
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6f33"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6f33"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iKObn", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lEFyc"));

});
parcelRegister("lEFyc", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $fc3d907a510ac5cd$export$ffb0004e005737fa, (v) => $fc3d907a510ac5cd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $fc3d907a510ac5cd$export$34b9dba7ce09269b, (v) => $fc3d907a510ac5cd$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $fc3d907a510ac5cd$export$25062201e9e25d76, (v) => $fc3d907a510ac5cd$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fc3d907a510ac5cd$export$ffb0004e005737fa;
var $fc3d907a510ac5cd$export$34b9dba7ce09269b;
var $fc3d907a510ac5cd$export$25062201e9e25d76;
"use strict";

var $81g6h = parcelRequire("81g6h");
var $fc3d907a510ac5cd$var$k = Symbol.for("react.element"), $fc3d907a510ac5cd$var$l = Symbol.for("react.fragment"), $fc3d907a510ac5cd$var$m = Object.prototype.hasOwnProperty, $fc3d907a510ac5cd$var$n = $81g6h.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $fc3d907a510ac5cd$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $fc3d907a510ac5cd$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$fc3d907a510ac5cd$var$m.call(a, b) && !$fc3d907a510ac5cd$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $fc3d907a510ac5cd$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $fc3d907a510ac5cd$var$n.current
    };
}
$fc3d907a510ac5cd$export$ffb0004e005737fa = $fc3d907a510ac5cd$var$l;
$fc3d907a510ac5cd$export$34b9dba7ce09269b = $fc3d907a510ac5cd$var$q;
$fc3d907a510ac5cd$export$25062201e9e25d76 = $fc3d907a510ac5cd$var$q;

});
parcelRegister("81g6h", function(module, exports) {
"use strict";

module.exports = (parcelRequire("azvNp"));

});
parcelRegister("azvNp", function(module, exports) {

$parcel$export(module.exports, "Children", () => $7b25d64766a1fc46$export$dca3b0875bd9a954, (v) => $7b25d64766a1fc46$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $7b25d64766a1fc46$export$16fa2f45be04daa8, (v) => $7b25d64766a1fc46$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $7b25d64766a1fc46$export$ffb0004e005737fa, (v) => $7b25d64766a1fc46$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $7b25d64766a1fc46$export$e2c29f18771995cb, (v) => $7b25d64766a1fc46$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $7b25d64766a1fc46$export$221d75b3f55bb0bd, (v) => $7b25d64766a1fc46$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $7b25d64766a1fc46$export$5f8d39834fd61797, (v) => $7b25d64766a1fc46$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $7b25d64766a1fc46$export$74bf444e3cd11ea5, (v) => $7b25d64766a1fc46$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $7b25d64766a1fc46$export$ae55be85d98224ed, (v) => $7b25d64766a1fc46$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $7b25d64766a1fc46$export$3ba232387fd5d6dd, (v) => $7b25d64766a1fc46$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $7b25d64766a1fc46$export$e530037191fcd5d7, (v) => $7b25d64766a1fc46$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $7b25d64766a1fc46$export$fd42f52fd3ae1109, (v) => $7b25d64766a1fc46$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $7b25d64766a1fc46$export$c8a8987d4410bf2d, (v) => $7b25d64766a1fc46$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $7b25d64766a1fc46$export$d38cd72104c1f0e9, (v) => $7b25d64766a1fc46$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $7b25d64766a1fc46$export$7d1e3a5e95ceca43, (v) => $7b25d64766a1fc46$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $7b25d64766a1fc46$export$257a8862b851cb5b, (v) => $7b25d64766a1fc46$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $7b25d64766a1fc46$export$a8257692ac88316c, (v) => $7b25d64766a1fc46$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $7b25d64766a1fc46$export$488013bae63b21da, (v) => $7b25d64766a1fc46$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $7b25d64766a1fc46$export$7c73462e0d25e514, (v) => $7b25d64766a1fc46$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $7b25d64766a1fc46$export$7568632d0d33d16d, (v) => $7b25d64766a1fc46$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $7b25d64766a1fc46$export$88948ce120ea2619, (v) => $7b25d64766a1fc46$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $7b25d64766a1fc46$export$35808ee640e87ca7, (v) => $7b25d64766a1fc46$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $7b25d64766a1fc46$export$fae74005e78b1a27, (v) => $7b25d64766a1fc46$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $7b25d64766a1fc46$export$dc8fbce3eb94dc1e, (v) => $7b25d64766a1fc46$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $7b25d64766a1fc46$export$6a7bc4e911dc01cf, (v) => $7b25d64766a1fc46$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $7b25d64766a1fc46$export$6d9c69b0de29b591, (v) => $7b25d64766a1fc46$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $7b25d64766a1fc46$export$f680877a34711e37, (v) => $7b25d64766a1fc46$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $7b25d64766a1fc46$export$d5a552a76deda3c2, (v) => $7b25d64766a1fc46$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $7b25d64766a1fc46$export$aaabe4eda9ed9969, (v) => $7b25d64766a1fc46$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $7b25d64766a1fc46$export$e5c5a5f917a5871c, (v) => $7b25d64766a1fc46$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $7b25d64766a1fc46$export$1538c33de8887b59, (v) => $7b25d64766a1fc46$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $7b25d64766a1fc46$export$13e3392192263954, (v) => $7b25d64766a1fc46$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $7b25d64766a1fc46$export$b8f5890fc79d6aca, (v) => $7b25d64766a1fc46$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $7b25d64766a1fc46$export$60241385465d0a34, (v) => $7b25d64766a1fc46$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $7b25d64766a1fc46$export$306c0aa65ff9ec16, (v) => $7b25d64766a1fc46$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $7b25d64766a1fc46$export$7b286972b8d8ccbf, (v) => $7b25d64766a1fc46$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $7b25d64766a1fc46$export$83d89fbfd8236492, (v) => $7b25d64766a1fc46$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7b25d64766a1fc46$export$dca3b0875bd9a954;
var $7b25d64766a1fc46$export$16fa2f45be04daa8;
var $7b25d64766a1fc46$export$ffb0004e005737fa;
var $7b25d64766a1fc46$export$e2c29f18771995cb;
var $7b25d64766a1fc46$export$221d75b3f55bb0bd;
var $7b25d64766a1fc46$export$5f8d39834fd61797;
var $7b25d64766a1fc46$export$74bf444e3cd11ea5;
var $7b25d64766a1fc46$export$ae55be85d98224ed;
var $7b25d64766a1fc46$export$3ba232387fd5d6dd;
var $7b25d64766a1fc46$export$e530037191fcd5d7;
var $7b25d64766a1fc46$export$fd42f52fd3ae1109;
var $7b25d64766a1fc46$export$c8a8987d4410bf2d;
var $7b25d64766a1fc46$export$d38cd72104c1f0e9;
var $7b25d64766a1fc46$export$7d1e3a5e95ceca43;
var $7b25d64766a1fc46$export$257a8862b851cb5b;
var $7b25d64766a1fc46$export$a8257692ac88316c;
var $7b25d64766a1fc46$export$488013bae63b21da;
var $7b25d64766a1fc46$export$7c73462e0d25e514;
var $7b25d64766a1fc46$export$7568632d0d33d16d;
var $7b25d64766a1fc46$export$88948ce120ea2619;
var $7b25d64766a1fc46$export$35808ee640e87ca7;
var $7b25d64766a1fc46$export$fae74005e78b1a27;
var $7b25d64766a1fc46$export$dc8fbce3eb94dc1e;
var $7b25d64766a1fc46$export$6a7bc4e911dc01cf;
var $7b25d64766a1fc46$export$6d9c69b0de29b591;
var $7b25d64766a1fc46$export$f680877a34711e37;
var $7b25d64766a1fc46$export$d5a552a76deda3c2;
var $7b25d64766a1fc46$export$aaabe4eda9ed9969;
var $7b25d64766a1fc46$export$e5c5a5f917a5871c;
var $7b25d64766a1fc46$export$1538c33de8887b59;
var $7b25d64766a1fc46$export$13e3392192263954;
var $7b25d64766a1fc46$export$b8f5890fc79d6aca;
var $7b25d64766a1fc46$export$60241385465d0a34;
var $7b25d64766a1fc46$export$306c0aa65ff9ec16;
var $7b25d64766a1fc46$export$7b286972b8d8ccbf;
var $7b25d64766a1fc46$export$83d89fbfd8236492;
"use strict";
var $7b25d64766a1fc46$var$l = Symbol.for("react.element"), $7b25d64766a1fc46$var$n = Symbol.for("react.portal"), $7b25d64766a1fc46$var$p = Symbol.for("react.fragment"), $7b25d64766a1fc46$var$q = Symbol.for("react.strict_mode"), $7b25d64766a1fc46$var$r = Symbol.for("react.profiler"), $7b25d64766a1fc46$var$t = Symbol.for("react.provider"), $7b25d64766a1fc46$var$u = Symbol.for("react.context"), $7b25d64766a1fc46$var$v = Symbol.for("react.forward_ref"), $7b25d64766a1fc46$var$w = Symbol.for("react.suspense"), $7b25d64766a1fc46$var$x = Symbol.for("react.memo"), $7b25d64766a1fc46$var$y = Symbol.for("react.lazy"), $7b25d64766a1fc46$var$z = Symbol.iterator;
function $7b25d64766a1fc46$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $7b25d64766a1fc46$var$z && a[$7b25d64766a1fc46$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $7b25d64766a1fc46$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $7b25d64766a1fc46$var$C = Object.assign, $7b25d64766a1fc46$var$D = {};
function $7b25d64766a1fc46$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $7b25d64766a1fc46$var$D;
    this.updater = e || $7b25d64766a1fc46$var$B;
}
$7b25d64766a1fc46$var$E.prototype.isReactComponent = {};
$7b25d64766a1fc46$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$7b25d64766a1fc46$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $7b25d64766a1fc46$var$F() {}
$7b25d64766a1fc46$var$F.prototype = $7b25d64766a1fc46$var$E.prototype;
function $7b25d64766a1fc46$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $7b25d64766a1fc46$var$D;
    this.updater = e || $7b25d64766a1fc46$var$B;
}
var $7b25d64766a1fc46$var$H = $7b25d64766a1fc46$var$G.prototype = new $7b25d64766a1fc46$var$F;
$7b25d64766a1fc46$var$H.constructor = $7b25d64766a1fc46$var$G;
$7b25d64766a1fc46$var$C($7b25d64766a1fc46$var$H, $7b25d64766a1fc46$var$E.prototype);
$7b25d64766a1fc46$var$H.isPureReactComponent = !0;
var $7b25d64766a1fc46$var$I = Array.isArray, $7b25d64766a1fc46$var$J = Object.prototype.hasOwnProperty, $7b25d64766a1fc46$var$K = {
    current: null
}, $7b25d64766a1fc46$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7b25d64766a1fc46$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$7b25d64766a1fc46$var$J.call(b, d) && !$7b25d64766a1fc46$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $7b25d64766a1fc46$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $7b25d64766a1fc46$var$K.current
    };
}
function $7b25d64766a1fc46$var$N(a, b) {
    return {
        $$typeof: $7b25d64766a1fc46$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $7b25d64766a1fc46$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7b25d64766a1fc46$var$l;
}
function $7b25d64766a1fc46$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $7b25d64766a1fc46$var$P = /\/+/g;
function $7b25d64766a1fc46$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $7b25d64766a1fc46$var$escape("" + a.key) : b.toString(36);
}
function $7b25d64766a1fc46$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $7b25d64766a1fc46$var$l:
                case $7b25d64766a1fc46$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $7b25d64766a1fc46$var$Q(h, 0) : d, $7b25d64766a1fc46$var$I(c) ? (e = "", null != a && (e = a.replace($7b25d64766a1fc46$var$P, "$&/") + "/"), $7b25d64766a1fc46$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($7b25d64766a1fc46$var$O(c) && (c = $7b25d64766a1fc46$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($7b25d64766a1fc46$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($7b25d64766a1fc46$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $7b25d64766a1fc46$var$Q(k, g);
        h += $7b25d64766a1fc46$var$R(k, b, e, f, c);
    }
    else if (f = $7b25d64766a1fc46$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $7b25d64766a1fc46$var$Q(k, g++), h += $7b25d64766a1fc46$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $7b25d64766a1fc46$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $7b25d64766a1fc46$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $7b25d64766a1fc46$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $7b25d64766a1fc46$var$U = {
    current: null
}, $7b25d64766a1fc46$var$V = {
    transition: null
}, $7b25d64766a1fc46$var$W = {
    ReactCurrentDispatcher: $7b25d64766a1fc46$var$U,
    ReactCurrentBatchConfig: $7b25d64766a1fc46$var$V,
    ReactCurrentOwner: $7b25d64766a1fc46$var$K
};
function $7b25d64766a1fc46$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$7b25d64766a1fc46$export$dca3b0875bd9a954 = {
    map: $7b25d64766a1fc46$var$S,
    forEach: function(a, b, e) {
        $7b25d64766a1fc46$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $7b25d64766a1fc46$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $7b25d64766a1fc46$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$7b25d64766a1fc46$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$7b25d64766a1fc46$export$16fa2f45be04daa8 = $7b25d64766a1fc46$var$E;
$7b25d64766a1fc46$export$ffb0004e005737fa = $7b25d64766a1fc46$var$p;
$7b25d64766a1fc46$export$e2c29f18771995cb = $7b25d64766a1fc46$var$r;
$7b25d64766a1fc46$export$221d75b3f55bb0bd = $7b25d64766a1fc46$var$G;
$7b25d64766a1fc46$export$5f8d39834fd61797 = $7b25d64766a1fc46$var$q;
$7b25d64766a1fc46$export$74bf444e3cd11ea5 = $7b25d64766a1fc46$var$w;
$7b25d64766a1fc46$export$ae55be85d98224ed = $7b25d64766a1fc46$var$W;
$7b25d64766a1fc46$export$3ba232387fd5d6dd = $7b25d64766a1fc46$var$X;
$7b25d64766a1fc46$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $7b25d64766a1fc46$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $7b25d64766a1fc46$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$7b25d64766a1fc46$var$J.call(b, f) && !$7b25d64766a1fc46$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $7b25d64766a1fc46$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$7b25d64766a1fc46$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $7b25d64766a1fc46$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $7b25d64766a1fc46$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$7b25d64766a1fc46$export$c8a8987d4410bf2d = $7b25d64766a1fc46$var$M;
$7b25d64766a1fc46$export$d38cd72104c1f0e9 = function(a) {
    var b = $7b25d64766a1fc46$var$M.bind(null, a);
    b.type = a;
    return b;
};
$7b25d64766a1fc46$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$7b25d64766a1fc46$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $7b25d64766a1fc46$var$v,
        render: a
    };
};
$7b25d64766a1fc46$export$a8257692ac88316c = $7b25d64766a1fc46$var$O;
$7b25d64766a1fc46$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $7b25d64766a1fc46$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $7b25d64766a1fc46$var$T
    };
};
$7b25d64766a1fc46$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $7b25d64766a1fc46$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$7b25d64766a1fc46$export$7568632d0d33d16d = function(a) {
    var b = $7b25d64766a1fc46$var$V.transition;
    $7b25d64766a1fc46$var$V.transition = {};
    try {
        a();
    } finally{
        $7b25d64766a1fc46$var$V.transition = b;
    }
};
$7b25d64766a1fc46$export$88948ce120ea2619 = $7b25d64766a1fc46$var$X;
$7b25d64766a1fc46$export$35808ee640e87ca7 = function(a, b) {
    return $7b25d64766a1fc46$var$U.current.useCallback(a, b);
};
$7b25d64766a1fc46$export$fae74005e78b1a27 = function(a) {
    return $7b25d64766a1fc46$var$U.current.useContext(a);
};
$7b25d64766a1fc46$export$dc8fbce3eb94dc1e = function() {};
$7b25d64766a1fc46$export$6a7bc4e911dc01cf = function(a) {
    return $7b25d64766a1fc46$var$U.current.useDeferredValue(a);
};
$7b25d64766a1fc46$export$6d9c69b0de29b591 = function(a, b) {
    return $7b25d64766a1fc46$var$U.current.useEffect(a, b);
};
$7b25d64766a1fc46$export$f680877a34711e37 = function() {
    return $7b25d64766a1fc46$var$U.current.useId();
};
$7b25d64766a1fc46$export$d5a552a76deda3c2 = function(a, b, e) {
    return $7b25d64766a1fc46$var$U.current.useImperativeHandle(a, b, e);
};
$7b25d64766a1fc46$export$aaabe4eda9ed9969 = function(a, b) {
    return $7b25d64766a1fc46$var$U.current.useInsertionEffect(a, b);
};
$7b25d64766a1fc46$export$e5c5a5f917a5871c = function(a, b) {
    return $7b25d64766a1fc46$var$U.current.useLayoutEffect(a, b);
};
$7b25d64766a1fc46$export$1538c33de8887b59 = function(a, b) {
    return $7b25d64766a1fc46$var$U.current.useMemo(a, b);
};
$7b25d64766a1fc46$export$13e3392192263954 = function(a, b, e) {
    return $7b25d64766a1fc46$var$U.current.useReducer(a, b, e);
};
$7b25d64766a1fc46$export$b8f5890fc79d6aca = function(a) {
    return $7b25d64766a1fc46$var$U.current.useRef(a);
};
$7b25d64766a1fc46$export$60241385465d0a34 = function(a) {
    return $7b25d64766a1fc46$var$U.current.useState(a);
};
$7b25d64766a1fc46$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $7b25d64766a1fc46$var$U.current.useSyncExternalStore(a, b, e);
};
$7b25d64766a1fc46$export$7b286972b8d8ccbf = function() {
    return $7b25d64766a1fc46$var$U.current.useTransition();
};
$7b25d64766a1fc46$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("Q1dTY", function(module, exports) {
"use strict";
function $09c5ce599eae13c1$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($09c5ce599eae13c1$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$09c5ce599eae13c1$var$checkDCE();

module.exports = (parcelRequire("gURGA"));

});
parcelRegister("gURGA", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $c50b85309f892411$export$ae55be85d98224ed, (v) => $c50b85309f892411$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $c50b85309f892411$export$d39a5bbd09211389, (v) => $c50b85309f892411$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $c50b85309f892411$export$882461b6382ed46c, (v) => $c50b85309f892411$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $c50b85309f892411$export$466bfc07425424d5, (v) => $c50b85309f892411$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $c50b85309f892411$export$cd75ccfd720a3cd4, (v) => $c50b85309f892411$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $c50b85309f892411$export$fa8d919ba61d84db, (v) => $c50b85309f892411$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $c50b85309f892411$export$757ceba2d55c277e, (v) => $c50b85309f892411$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $c50b85309f892411$export$b3890eb0ae9dca99, (v) => $c50b85309f892411$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $c50b85309f892411$export$502457920280e6be, (v) => $c50b85309f892411$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $c50b85309f892411$export$c78a37762a8d58e1, (v) => $c50b85309f892411$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $c50b85309f892411$export$dc54d992c10e8a18, (v) => $c50b85309f892411$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $c50b85309f892411$export$83d89fbfd8236492, (v) => $c50b85309f892411$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c50b85309f892411$export$ae55be85d98224ed;
var $c50b85309f892411$export$d39a5bbd09211389;
var $c50b85309f892411$export$882461b6382ed46c;
var $c50b85309f892411$export$466bfc07425424d5;
var $c50b85309f892411$export$cd75ccfd720a3cd4;
var $c50b85309f892411$export$fa8d919ba61d84db;
var $c50b85309f892411$export$757ceba2d55c277e;
var $c50b85309f892411$export$b3890eb0ae9dca99;
var $c50b85309f892411$export$502457920280e6be;
var $c50b85309f892411$export$c78a37762a8d58e1;
var $c50b85309f892411$export$dc54d992c10e8a18;
var $c50b85309f892411$export$83d89fbfd8236492;
"use strict";

var $81g6h = parcelRequire("81g6h");

var $5lIsG = parcelRequire("5lIsG");
function $c50b85309f892411$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c50b85309f892411$var$da = new Set, $c50b85309f892411$var$ea = {};
function $c50b85309f892411$var$fa(a, b) {
    $c50b85309f892411$var$ha(a, b);
    $c50b85309f892411$var$ha(a + "Capture", b);
}
function $c50b85309f892411$var$ha(a, b) {
    $c50b85309f892411$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c50b85309f892411$var$da.add(b[a]);
}
var $c50b85309f892411$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c50b85309f892411$var$ja = Object.prototype.hasOwnProperty, $c50b85309f892411$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c50b85309f892411$var$la = {}, $c50b85309f892411$var$ma = {};
function $c50b85309f892411$var$oa(a) {
    if ($c50b85309f892411$var$ja.call($c50b85309f892411$var$ma, a)) return !0;
    if ($c50b85309f892411$var$ja.call($c50b85309f892411$var$la, a)) return !1;
    if ($c50b85309f892411$var$ka.test(a)) return $c50b85309f892411$var$ma[a] = !0;
    $c50b85309f892411$var$la[a] = !0;
    return !1;
}
function $c50b85309f892411$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c50b85309f892411$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c50b85309f892411$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c50b85309f892411$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c50b85309f892411$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c50b85309f892411$var$z[a] = new $c50b85309f892411$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c50b85309f892411$var$z[b] = new $c50b85309f892411$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c50b85309f892411$var$z[a] = new $c50b85309f892411$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c50b85309f892411$var$z[a] = new $c50b85309f892411$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c50b85309f892411$var$z[a] = new $c50b85309f892411$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c50b85309f892411$var$z[a] = new $c50b85309f892411$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c50b85309f892411$var$z[a] = new $c50b85309f892411$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c50b85309f892411$var$z[a] = new $c50b85309f892411$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c50b85309f892411$var$z[a] = new $c50b85309f892411$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c50b85309f892411$var$ra = /[\-:]([a-z])/g;
function $c50b85309f892411$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c50b85309f892411$var$ra, $c50b85309f892411$var$sa);
    $c50b85309f892411$var$z[b] = new $c50b85309f892411$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c50b85309f892411$var$ra, $c50b85309f892411$var$sa);
    $c50b85309f892411$var$z[b] = new $c50b85309f892411$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c50b85309f892411$var$ra, $c50b85309f892411$var$sa);
    $c50b85309f892411$var$z[b] = new $c50b85309f892411$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c50b85309f892411$var$z[a] = new $c50b85309f892411$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c50b85309f892411$var$z.xlinkHref = new $c50b85309f892411$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c50b85309f892411$var$z[a] = new $c50b85309f892411$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c50b85309f892411$var$ta(a, b, c, d) {
    var e = $c50b85309f892411$var$z.hasOwnProperty(b) ? $c50b85309f892411$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c50b85309f892411$var$qa(b, c, e, d) && (c = null), d || null === e ? $c50b85309f892411$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c50b85309f892411$var$ua = $81g6h.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c50b85309f892411$var$va = Symbol.for("react.element"), $c50b85309f892411$var$wa = Symbol.for("react.portal"), $c50b85309f892411$var$ya = Symbol.for("react.fragment"), $c50b85309f892411$var$za = Symbol.for("react.strict_mode"), $c50b85309f892411$var$Aa = Symbol.for("react.profiler"), $c50b85309f892411$var$Ba = Symbol.for("react.provider"), $c50b85309f892411$var$Ca = Symbol.for("react.context"), $c50b85309f892411$var$Da = Symbol.for("react.forward_ref"), $c50b85309f892411$var$Ea = Symbol.for("react.suspense"), $c50b85309f892411$var$Fa = Symbol.for("react.suspense_list"), $c50b85309f892411$var$Ga = Symbol.for("react.memo"), $c50b85309f892411$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c50b85309f892411$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c50b85309f892411$var$Ja = Symbol.iterator;
function $c50b85309f892411$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c50b85309f892411$var$Ja && a[$c50b85309f892411$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c50b85309f892411$var$A = Object.assign, $c50b85309f892411$var$La;
function $c50b85309f892411$var$Ma(a) {
    if (void 0 === $c50b85309f892411$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c50b85309f892411$var$La = b && b[1] || "";
    }
    return "\n" + $c50b85309f892411$var$La + a;
}
var $c50b85309f892411$var$Na = !1;
function $c50b85309f892411$var$Oa(a, b) {
    if (!a || $c50b85309f892411$var$Na) return "";
    $c50b85309f892411$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c50b85309f892411$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c50b85309f892411$var$Ma(a) : "";
}
function $c50b85309f892411$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c50b85309f892411$var$Ma(a.type);
        case 16:
            return $c50b85309f892411$var$Ma("Lazy");
        case 13:
            return $c50b85309f892411$var$Ma("Suspense");
        case 19:
            return $c50b85309f892411$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c50b85309f892411$var$Oa(a.type, !1), a;
        case 11:
            return a = $c50b85309f892411$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c50b85309f892411$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c50b85309f892411$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c50b85309f892411$var$ya:
            return "Fragment";
        case $c50b85309f892411$var$wa:
            return "Portal";
        case $c50b85309f892411$var$Aa:
            return "Profiler";
        case $c50b85309f892411$var$za:
            return "StrictMode";
        case $c50b85309f892411$var$Ea:
            return "Suspense";
        case $c50b85309f892411$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c50b85309f892411$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c50b85309f892411$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c50b85309f892411$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c50b85309f892411$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c50b85309f892411$var$Qa(a.type) || "Memo";
        case $c50b85309f892411$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c50b85309f892411$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c50b85309f892411$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c50b85309f892411$var$Qa(b);
        case 8:
            return b === $c50b85309f892411$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c50b85309f892411$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c50b85309f892411$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c50b85309f892411$var$Ua(a) {
    var b = $c50b85309f892411$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c50b85309f892411$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c50b85309f892411$var$Ua(a));
}
function $c50b85309f892411$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c50b85309f892411$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c50b85309f892411$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c50b85309f892411$var$Ya(a, b) {
    var c = b.checked;
    return $c50b85309f892411$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c50b85309f892411$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c50b85309f892411$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c50b85309f892411$var$ab(a, b) {
    b = b.checked;
    null != b && $c50b85309f892411$var$ta(a, "checked", b, !1);
}
function $c50b85309f892411$var$bb(a, b) {
    $c50b85309f892411$var$ab(a, b);
    var c = $c50b85309f892411$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c50b85309f892411$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c50b85309f892411$var$cb(a, b.type, $c50b85309f892411$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c50b85309f892411$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c50b85309f892411$var$cb(a, b, c) {
    if ("number" !== b || $c50b85309f892411$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c50b85309f892411$var$eb = Array.isArray;
function $c50b85309f892411$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c50b85309f892411$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c50b85309f892411$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c50b85309f892411$var$p(91));
    return $c50b85309f892411$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c50b85309f892411$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c50b85309f892411$var$p(92));
            if ($c50b85309f892411$var$eb(c)) {
                if (1 < c.length) throw Error($c50b85309f892411$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c50b85309f892411$var$Sa(c)
    };
}
function $c50b85309f892411$var$ib(a, b) {
    var c = $c50b85309f892411$var$Sa(b.value), d = $c50b85309f892411$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c50b85309f892411$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c50b85309f892411$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c50b85309f892411$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c50b85309f892411$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c50b85309f892411$var$mb, $c50b85309f892411$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c50b85309f892411$var$mb = $c50b85309f892411$var$mb || document.createElement("div");
        $c50b85309f892411$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c50b85309f892411$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c50b85309f892411$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c50b85309f892411$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c50b85309f892411$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c50b85309f892411$var$pb).forEach(function(a) {
    $c50b85309f892411$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c50b85309f892411$var$pb[b] = $c50b85309f892411$var$pb[a];
    });
});
function $c50b85309f892411$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c50b85309f892411$var$pb.hasOwnProperty(a) && $c50b85309f892411$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c50b85309f892411$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c50b85309f892411$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c50b85309f892411$var$tb = $c50b85309f892411$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c50b85309f892411$var$ub(a, b) {
    if (b) {
        if ($c50b85309f892411$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c50b85309f892411$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c50b85309f892411$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c50b85309f892411$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c50b85309f892411$var$p(62));
    }
}
function $c50b85309f892411$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c50b85309f892411$var$wb = null;
function $c50b85309f892411$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c50b85309f892411$var$yb = null, $c50b85309f892411$var$zb = null, $c50b85309f892411$var$Ab = null;
function $c50b85309f892411$var$Bb(a) {
    if (a = $c50b85309f892411$var$Cb(a)) {
        if ("function" !== typeof $c50b85309f892411$var$yb) throw Error($c50b85309f892411$var$p(280));
        var b = a.stateNode;
        b && (b = $c50b85309f892411$var$Db(b), $c50b85309f892411$var$yb(a.stateNode, a.type, b));
    }
}
function $c50b85309f892411$var$Eb(a) {
    $c50b85309f892411$var$zb ? $c50b85309f892411$var$Ab ? $c50b85309f892411$var$Ab.push(a) : $c50b85309f892411$var$Ab = [
        a
    ] : $c50b85309f892411$var$zb = a;
}
function $c50b85309f892411$var$Fb() {
    if ($c50b85309f892411$var$zb) {
        var a = $c50b85309f892411$var$zb, b = $c50b85309f892411$var$Ab;
        $c50b85309f892411$var$Ab = $c50b85309f892411$var$zb = null;
        $c50b85309f892411$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c50b85309f892411$var$Bb(b[a]);
    }
}
function $c50b85309f892411$var$Gb(a, b) {
    return a(b);
}
function $c50b85309f892411$var$Hb() {}
var $c50b85309f892411$var$Ib = !1;
function $c50b85309f892411$var$Jb(a, b, c) {
    if ($c50b85309f892411$var$Ib) return a(b, c);
    $c50b85309f892411$var$Ib = !0;
    try {
        return $c50b85309f892411$var$Gb(a, b, c);
    } finally{
        if ($c50b85309f892411$var$Ib = !1, null !== $c50b85309f892411$var$zb || null !== $c50b85309f892411$var$Ab) $c50b85309f892411$var$Hb(), $c50b85309f892411$var$Fb();
    }
}
function $c50b85309f892411$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c50b85309f892411$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c50b85309f892411$var$p(231, b, typeof c));
    return c;
}
var $c50b85309f892411$var$Lb = !1;
if ($c50b85309f892411$var$ia) try {
    var $c50b85309f892411$var$Mb = {};
    Object.defineProperty($c50b85309f892411$var$Mb, "passive", {
        get: function() {
            $c50b85309f892411$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c50b85309f892411$var$Mb, $c50b85309f892411$var$Mb);
    window.removeEventListener("test", $c50b85309f892411$var$Mb, $c50b85309f892411$var$Mb);
} catch (a) {
    $c50b85309f892411$var$Lb = !1;
}
function $c50b85309f892411$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c50b85309f892411$var$Ob = !1, $c50b85309f892411$var$Pb = null, $c50b85309f892411$var$Qb = !1, $c50b85309f892411$var$Rb = null, $c50b85309f892411$var$Sb = {
    onError: function(a) {
        $c50b85309f892411$var$Ob = !0;
        $c50b85309f892411$var$Pb = a;
    }
};
function $c50b85309f892411$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c50b85309f892411$var$Ob = !1;
    $c50b85309f892411$var$Pb = null;
    $c50b85309f892411$var$Nb.apply($c50b85309f892411$var$Sb, arguments);
}
function $c50b85309f892411$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c50b85309f892411$var$Tb.apply(this, arguments);
    if ($c50b85309f892411$var$Ob) {
        if ($c50b85309f892411$var$Ob) {
            var l = $c50b85309f892411$var$Pb;
            $c50b85309f892411$var$Ob = !1;
            $c50b85309f892411$var$Pb = null;
        } else throw Error($c50b85309f892411$var$p(198));
        $c50b85309f892411$var$Qb || ($c50b85309f892411$var$Qb = !0, $c50b85309f892411$var$Rb = l);
    }
}
function $c50b85309f892411$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c50b85309f892411$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c50b85309f892411$var$Xb(a) {
    if ($c50b85309f892411$var$Vb(a) !== a) throw Error($c50b85309f892411$var$p(188));
}
function $c50b85309f892411$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c50b85309f892411$var$Vb(a);
        if (null === b) throw Error($c50b85309f892411$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c50b85309f892411$var$Xb(e), a;
                if (f === d) return $c50b85309f892411$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c50b85309f892411$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c50b85309f892411$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c50b85309f892411$var$p(190));
    }
    if (3 !== c.tag) throw Error($c50b85309f892411$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c50b85309f892411$var$Zb(a) {
    a = $c50b85309f892411$var$Yb(a);
    return null !== a ? $c50b85309f892411$var$$b(a) : null;
}
function $c50b85309f892411$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c50b85309f892411$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c50b85309f892411$var$ac = $5lIsG.unstable_scheduleCallback, $c50b85309f892411$var$bc = $5lIsG.unstable_cancelCallback, $c50b85309f892411$var$cc = $5lIsG.unstable_shouldYield, $c50b85309f892411$var$dc = $5lIsG.unstable_requestPaint, $c50b85309f892411$var$B = $5lIsG.unstable_now, $c50b85309f892411$var$ec = $5lIsG.unstable_getCurrentPriorityLevel, $c50b85309f892411$var$fc = $5lIsG.unstable_ImmediatePriority, $c50b85309f892411$var$gc = $5lIsG.unstable_UserBlockingPriority, $c50b85309f892411$var$hc = $5lIsG.unstable_NormalPriority, $c50b85309f892411$var$ic = $5lIsG.unstable_LowPriority, $c50b85309f892411$var$jc = $5lIsG.unstable_IdlePriority, $c50b85309f892411$var$kc = null, $c50b85309f892411$var$lc = null;
function $c50b85309f892411$var$mc(a) {
    if ($c50b85309f892411$var$lc && "function" === typeof $c50b85309f892411$var$lc.onCommitFiberRoot) try {
        $c50b85309f892411$var$lc.onCommitFiberRoot($c50b85309f892411$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c50b85309f892411$var$oc = Math.clz32 ? Math.clz32 : $c50b85309f892411$var$nc, $c50b85309f892411$var$pc = Math.log, $c50b85309f892411$var$qc = Math.LN2;
function $c50b85309f892411$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c50b85309f892411$var$pc(a) / $c50b85309f892411$var$qc | 0) | 0;
}
var $c50b85309f892411$var$rc = 64, $c50b85309f892411$var$sc = 4194304;
function $c50b85309f892411$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c50b85309f892411$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c50b85309f892411$var$tc(h) : (f &= g, 0 !== f && (d = $c50b85309f892411$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c50b85309f892411$var$tc(g) : 0 !== f && (d = $c50b85309f892411$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c50b85309f892411$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c50b85309f892411$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c50b85309f892411$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c50b85309f892411$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c50b85309f892411$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c50b85309f892411$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c50b85309f892411$var$yc() {
    var a = $c50b85309f892411$var$rc;
    $c50b85309f892411$var$rc <<= 1;
    0 === ($c50b85309f892411$var$rc & 4194240) && ($c50b85309f892411$var$rc = 64);
    return a;
}
function $c50b85309f892411$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c50b85309f892411$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c50b85309f892411$var$oc(b);
    a[b] = c;
}
function $c50b85309f892411$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c50b85309f892411$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c50b85309f892411$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c50b85309f892411$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c50b85309f892411$var$C = 0;
function $c50b85309f892411$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c50b85309f892411$var$Ec, $c50b85309f892411$var$Fc, $c50b85309f892411$var$Gc, $c50b85309f892411$var$Hc, $c50b85309f892411$var$Ic, $c50b85309f892411$var$Jc = !1, $c50b85309f892411$var$Kc = [], $c50b85309f892411$var$Lc = null, $c50b85309f892411$var$Mc = null, $c50b85309f892411$var$Nc = null, $c50b85309f892411$var$Oc = new Map, $c50b85309f892411$var$Pc = new Map, $c50b85309f892411$var$Qc = [], $c50b85309f892411$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c50b85309f892411$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c50b85309f892411$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c50b85309f892411$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c50b85309f892411$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c50b85309f892411$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c50b85309f892411$var$Pc.delete(b.pointerId);
    }
}
function $c50b85309f892411$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c50b85309f892411$var$Cb(b), null !== b && $c50b85309f892411$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c50b85309f892411$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c50b85309f892411$var$Lc = $c50b85309f892411$var$Tc($c50b85309f892411$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c50b85309f892411$var$Mc = $c50b85309f892411$var$Tc($c50b85309f892411$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c50b85309f892411$var$Nc = $c50b85309f892411$var$Tc($c50b85309f892411$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c50b85309f892411$var$Oc.set(f, $c50b85309f892411$var$Tc($c50b85309f892411$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c50b85309f892411$var$Pc.set(f, $c50b85309f892411$var$Tc($c50b85309f892411$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c50b85309f892411$var$Vc(a) {
    var b = $c50b85309f892411$var$Wc(a.target);
    if (null !== b) {
        var c = $c50b85309f892411$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c50b85309f892411$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c50b85309f892411$var$Ic(a.priority, function() {
                        $c50b85309f892411$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c50b85309f892411$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c50b85309f892411$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c50b85309f892411$var$wb = d;
            c.target.dispatchEvent(d);
            $c50b85309f892411$var$wb = null;
        } else return b = $c50b85309f892411$var$Cb(c), null !== b && $c50b85309f892411$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c50b85309f892411$var$Zc(a, b, c) {
    $c50b85309f892411$var$Xc(a) && c.delete(b);
}
function $c50b85309f892411$var$$c() {
    $c50b85309f892411$var$Jc = !1;
    null !== $c50b85309f892411$var$Lc && $c50b85309f892411$var$Xc($c50b85309f892411$var$Lc) && ($c50b85309f892411$var$Lc = null);
    null !== $c50b85309f892411$var$Mc && $c50b85309f892411$var$Xc($c50b85309f892411$var$Mc) && ($c50b85309f892411$var$Mc = null);
    null !== $c50b85309f892411$var$Nc && $c50b85309f892411$var$Xc($c50b85309f892411$var$Nc) && ($c50b85309f892411$var$Nc = null);
    $c50b85309f892411$var$Oc.forEach($c50b85309f892411$var$Zc);
    $c50b85309f892411$var$Pc.forEach($c50b85309f892411$var$Zc);
}
function $c50b85309f892411$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c50b85309f892411$var$Jc || ($c50b85309f892411$var$Jc = !0, $5lIsG.unstable_scheduleCallback($5lIsG.unstable_NormalPriority, $c50b85309f892411$var$$c)));
}
function $c50b85309f892411$var$bd(a) {
    function b(b) {
        return $c50b85309f892411$var$ad(b, a);
    }
    if (0 < $c50b85309f892411$var$Kc.length) {
        $c50b85309f892411$var$ad($c50b85309f892411$var$Kc[0], a);
        for(var c = 1; c < $c50b85309f892411$var$Kc.length; c++){
            var d = $c50b85309f892411$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c50b85309f892411$var$Lc && $c50b85309f892411$var$ad($c50b85309f892411$var$Lc, a);
    null !== $c50b85309f892411$var$Mc && $c50b85309f892411$var$ad($c50b85309f892411$var$Mc, a);
    null !== $c50b85309f892411$var$Nc && $c50b85309f892411$var$ad($c50b85309f892411$var$Nc, a);
    $c50b85309f892411$var$Oc.forEach(b);
    $c50b85309f892411$var$Pc.forEach(b);
    for(c = 0; c < $c50b85309f892411$var$Qc.length; c++)d = $c50b85309f892411$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c50b85309f892411$var$Qc.length && (c = $c50b85309f892411$var$Qc[0], null === c.blockedOn);)$c50b85309f892411$var$Vc(c), null === c.blockedOn && $c50b85309f892411$var$Qc.shift();
}
var $c50b85309f892411$var$cd = $c50b85309f892411$var$ua.ReactCurrentBatchConfig, $c50b85309f892411$var$dd = !0;
function $c50b85309f892411$var$ed(a, b, c, d) {
    var e = $c50b85309f892411$var$C, f = $c50b85309f892411$var$cd.transition;
    $c50b85309f892411$var$cd.transition = null;
    try {
        $c50b85309f892411$var$C = 1, $c50b85309f892411$var$fd(a, b, c, d);
    } finally{
        $c50b85309f892411$var$C = e, $c50b85309f892411$var$cd.transition = f;
    }
}
function $c50b85309f892411$var$gd(a, b, c, d) {
    var e = $c50b85309f892411$var$C, f = $c50b85309f892411$var$cd.transition;
    $c50b85309f892411$var$cd.transition = null;
    try {
        $c50b85309f892411$var$C = 4, $c50b85309f892411$var$fd(a, b, c, d);
    } finally{
        $c50b85309f892411$var$C = e, $c50b85309f892411$var$cd.transition = f;
    }
}
function $c50b85309f892411$var$fd(a, b, c, d) {
    if ($c50b85309f892411$var$dd) {
        var e = $c50b85309f892411$var$Yc(a, b, c, d);
        if (null === e) $c50b85309f892411$var$hd(a, b, d, $c50b85309f892411$var$id, c), $c50b85309f892411$var$Sc(a, d);
        else if ($c50b85309f892411$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c50b85309f892411$var$Sc(a, d), b & 4 && -1 < $c50b85309f892411$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c50b85309f892411$var$Cb(e);
                null !== f && $c50b85309f892411$var$Ec(f);
                f = $c50b85309f892411$var$Yc(a, b, c, d);
                null === f && $c50b85309f892411$var$hd(a, b, d, $c50b85309f892411$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c50b85309f892411$var$hd(a, b, d, null, c);
    }
}
var $c50b85309f892411$var$id = null;
function $c50b85309f892411$var$Yc(a, b, c, d) {
    $c50b85309f892411$var$id = null;
    a = $c50b85309f892411$var$xb(d);
    a = $c50b85309f892411$var$Wc(a);
    if (null !== a) {
        if (b = $c50b85309f892411$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c50b85309f892411$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c50b85309f892411$var$id = a;
    return null;
}
function $c50b85309f892411$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c50b85309f892411$var$ec()){
                case $c50b85309f892411$var$fc:
                    return 1;
                case $c50b85309f892411$var$gc:
                    return 4;
                case $c50b85309f892411$var$hc:
                case $c50b85309f892411$var$ic:
                    return 16;
                case $c50b85309f892411$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c50b85309f892411$var$kd = null, $c50b85309f892411$var$ld = null, $c50b85309f892411$var$md = null;
function $c50b85309f892411$var$nd() {
    if ($c50b85309f892411$var$md) return $c50b85309f892411$var$md;
    var a, b = $c50b85309f892411$var$ld, c = b.length, d, e = "value" in $c50b85309f892411$var$kd ? $c50b85309f892411$var$kd.value : $c50b85309f892411$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c50b85309f892411$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c50b85309f892411$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c50b85309f892411$var$pd() {
    return !0;
}
function $c50b85309f892411$var$qd() {
    return !1;
}
function $c50b85309f892411$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c50b85309f892411$var$pd : $c50b85309f892411$var$qd;
        this.isPropagationStopped = $c50b85309f892411$var$qd;
        return this;
    }
    $c50b85309f892411$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c50b85309f892411$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c50b85309f892411$var$pd);
        },
        persist: function() {},
        isPersistent: $c50b85309f892411$var$pd
    });
    return b;
}
var $c50b85309f892411$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c50b85309f892411$var$td = $c50b85309f892411$var$rd($c50b85309f892411$var$sd), $c50b85309f892411$var$ud = $c50b85309f892411$var$A({}, $c50b85309f892411$var$sd, {
    view: 0,
    detail: 0
}), $c50b85309f892411$var$vd = $c50b85309f892411$var$rd($c50b85309f892411$var$ud), $c50b85309f892411$var$wd, $c50b85309f892411$var$xd, $c50b85309f892411$var$yd, $c50b85309f892411$var$Ad = $c50b85309f892411$var$A({}, $c50b85309f892411$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c50b85309f892411$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c50b85309f892411$var$yd && ($c50b85309f892411$var$yd && "mousemove" === a.type ? ($c50b85309f892411$var$wd = a.screenX - $c50b85309f892411$var$yd.screenX, $c50b85309f892411$var$xd = a.screenY - $c50b85309f892411$var$yd.screenY) : $c50b85309f892411$var$xd = $c50b85309f892411$var$wd = 0, $c50b85309f892411$var$yd = a);
        return $c50b85309f892411$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c50b85309f892411$var$xd;
    }
}), $c50b85309f892411$var$Bd = $c50b85309f892411$var$rd($c50b85309f892411$var$Ad), $c50b85309f892411$var$Cd = $c50b85309f892411$var$A({}, $c50b85309f892411$var$Ad, {
    dataTransfer: 0
}), $c50b85309f892411$var$Dd = $c50b85309f892411$var$rd($c50b85309f892411$var$Cd), $c50b85309f892411$var$Ed = $c50b85309f892411$var$A({}, $c50b85309f892411$var$ud, {
    relatedTarget: 0
}), $c50b85309f892411$var$Fd = $c50b85309f892411$var$rd($c50b85309f892411$var$Ed), $c50b85309f892411$var$Gd = $c50b85309f892411$var$A({}, $c50b85309f892411$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c50b85309f892411$var$Hd = $c50b85309f892411$var$rd($c50b85309f892411$var$Gd), $c50b85309f892411$var$Id = $c50b85309f892411$var$A({}, $c50b85309f892411$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c50b85309f892411$var$Jd = $c50b85309f892411$var$rd($c50b85309f892411$var$Id), $c50b85309f892411$var$Kd = $c50b85309f892411$var$A({}, $c50b85309f892411$var$sd, {
    data: 0
}), $c50b85309f892411$var$Ld = $c50b85309f892411$var$rd($c50b85309f892411$var$Kd), $c50b85309f892411$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c50b85309f892411$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c50b85309f892411$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c50b85309f892411$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c50b85309f892411$var$Od[a]) ? !!b[a] : !1;
}
function $c50b85309f892411$var$zd() {
    return $c50b85309f892411$var$Pd;
}
var $c50b85309f892411$var$Qd = $c50b85309f892411$var$A({}, $c50b85309f892411$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $c50b85309f892411$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c50b85309f892411$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c50b85309f892411$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c50b85309f892411$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $c50b85309f892411$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c50b85309f892411$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c50b85309f892411$var$Rd = $c50b85309f892411$var$rd($c50b85309f892411$var$Qd), $c50b85309f892411$var$Sd = $c50b85309f892411$var$A({}, $c50b85309f892411$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c50b85309f892411$var$Td = $c50b85309f892411$var$rd($c50b85309f892411$var$Sd), $c50b85309f892411$var$Ud = $c50b85309f892411$var$A({}, $c50b85309f892411$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c50b85309f892411$var$zd
}), $c50b85309f892411$var$Vd = $c50b85309f892411$var$rd($c50b85309f892411$var$Ud), $c50b85309f892411$var$Wd = $c50b85309f892411$var$A({}, $c50b85309f892411$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c50b85309f892411$var$Xd = $c50b85309f892411$var$rd($c50b85309f892411$var$Wd), $c50b85309f892411$var$Yd = $c50b85309f892411$var$A({}, $c50b85309f892411$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c50b85309f892411$var$Zd = $c50b85309f892411$var$rd($c50b85309f892411$var$Yd), $c50b85309f892411$var$$d = [
    9,
    13,
    27,
    32
], $c50b85309f892411$var$ae = $c50b85309f892411$var$ia && "CompositionEvent" in window, $c50b85309f892411$var$be = null;
$c50b85309f892411$var$ia && "documentMode" in document && ($c50b85309f892411$var$be = document.documentMode);
var $c50b85309f892411$var$ce = $c50b85309f892411$var$ia && "TextEvent" in window && !$c50b85309f892411$var$be, $c50b85309f892411$var$de = $c50b85309f892411$var$ia && (!$c50b85309f892411$var$ae || $c50b85309f892411$var$be && 8 < $c50b85309f892411$var$be && 11 >= $c50b85309f892411$var$be), $c50b85309f892411$var$ee = String.fromCharCode(32), $c50b85309f892411$var$fe = !1;
function $c50b85309f892411$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c50b85309f892411$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c50b85309f892411$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c50b85309f892411$var$ie = !1;
function $c50b85309f892411$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c50b85309f892411$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c50b85309f892411$var$fe = !0;
            return $c50b85309f892411$var$ee;
        case "textInput":
            return a = b.data, a === $c50b85309f892411$var$ee && $c50b85309f892411$var$fe ? null : a;
        default:
            return null;
    }
}
function $c50b85309f892411$var$ke(a, b) {
    if ($c50b85309f892411$var$ie) return "compositionend" === a || !$c50b85309f892411$var$ae && $c50b85309f892411$var$ge(a, b) ? (a = $c50b85309f892411$var$nd(), $c50b85309f892411$var$md = $c50b85309f892411$var$ld = $c50b85309f892411$var$kd = null, $c50b85309f892411$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c50b85309f892411$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c50b85309f892411$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c50b85309f892411$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c50b85309f892411$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c50b85309f892411$var$ne(a, b, c, d) {
    $c50b85309f892411$var$Eb(d);
    b = $c50b85309f892411$var$oe(b, "onChange");
    0 < b.length && (c = new $c50b85309f892411$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c50b85309f892411$var$pe = null, $c50b85309f892411$var$qe = null;
function $c50b85309f892411$var$re(a) {
    $c50b85309f892411$var$se(a, 0);
}
function $c50b85309f892411$var$te(a) {
    var b = $c50b85309f892411$var$ue(a);
    if ($c50b85309f892411$var$Wa(b)) return a;
}
function $c50b85309f892411$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c50b85309f892411$var$we = !1;
if ($c50b85309f892411$var$ia) {
    var $c50b85309f892411$var$xe;
    if ($c50b85309f892411$var$ia) {
        var $c50b85309f892411$var$ye = "oninput" in document;
        if (!$c50b85309f892411$var$ye) {
            var $c50b85309f892411$var$ze = document.createElement("div");
            $c50b85309f892411$var$ze.setAttribute("oninput", "return;");
            $c50b85309f892411$var$ye = "function" === typeof $c50b85309f892411$var$ze.oninput;
        }
        $c50b85309f892411$var$xe = $c50b85309f892411$var$ye;
    } else $c50b85309f892411$var$xe = !1;
    $c50b85309f892411$var$we = $c50b85309f892411$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c50b85309f892411$var$Ae() {
    $c50b85309f892411$var$pe && ($c50b85309f892411$var$pe.detachEvent("onpropertychange", $c50b85309f892411$var$Be), $c50b85309f892411$var$qe = $c50b85309f892411$var$pe = null);
}
function $c50b85309f892411$var$Be(a) {
    if ("value" === a.propertyName && $c50b85309f892411$var$te($c50b85309f892411$var$qe)) {
        var b = [];
        $c50b85309f892411$var$ne(b, $c50b85309f892411$var$qe, a, $c50b85309f892411$var$xb(a));
        $c50b85309f892411$var$Jb($c50b85309f892411$var$re, b);
    }
}
function $c50b85309f892411$var$Ce(a, b, c) {
    "focusin" === a ? ($c50b85309f892411$var$Ae(), $c50b85309f892411$var$pe = b, $c50b85309f892411$var$qe = c, $c50b85309f892411$var$pe.attachEvent("onpropertychange", $c50b85309f892411$var$Be)) : "focusout" === a && $c50b85309f892411$var$Ae();
}
function $c50b85309f892411$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c50b85309f892411$var$te($c50b85309f892411$var$qe);
}
function $c50b85309f892411$var$Ee(a, b) {
    if ("click" === a) return $c50b85309f892411$var$te(b);
}
function $c50b85309f892411$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c50b85309f892411$var$te(b);
}
function $c50b85309f892411$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c50b85309f892411$var$He = "function" === typeof Object.is ? Object.is : $c50b85309f892411$var$Ge;
function $c50b85309f892411$var$Ie(a, b) {
    if ($c50b85309f892411$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c50b85309f892411$var$ja.call(b, e) || !$c50b85309f892411$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c50b85309f892411$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c50b85309f892411$var$Ke(a, b) {
    var c = $c50b85309f892411$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c50b85309f892411$var$Je(c);
    }
}
function $c50b85309f892411$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c50b85309f892411$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c50b85309f892411$var$Me() {
    for(var a = window, b = $c50b85309f892411$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c50b85309f892411$var$Xa(a.document);
    }
    return b;
}
function $c50b85309f892411$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c50b85309f892411$var$Oe(a) {
    var b = $c50b85309f892411$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c50b85309f892411$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c50b85309f892411$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c50b85309f892411$var$Ke(c, f);
                var g = $c50b85309f892411$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c50b85309f892411$var$Pe = $c50b85309f892411$var$ia && "documentMode" in document && 11 >= document.documentMode, $c50b85309f892411$var$Qe = null, $c50b85309f892411$var$Re = null, $c50b85309f892411$var$Se = null, $c50b85309f892411$var$Te = !1;
function $c50b85309f892411$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c50b85309f892411$var$Te || null == $c50b85309f892411$var$Qe || $c50b85309f892411$var$Qe !== $c50b85309f892411$var$Xa(d) || (d = $c50b85309f892411$var$Qe, "selectionStart" in d && $c50b85309f892411$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c50b85309f892411$var$Se && $c50b85309f892411$var$Ie($c50b85309f892411$var$Se, d) || ($c50b85309f892411$var$Se = d, d = $c50b85309f892411$var$oe($c50b85309f892411$var$Re, "onSelect"), 0 < d.length && (b = new $c50b85309f892411$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c50b85309f892411$var$Qe)));
}
function $c50b85309f892411$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c50b85309f892411$var$We = {
    animationend: $c50b85309f892411$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c50b85309f892411$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c50b85309f892411$var$Ve("Animation", "AnimationStart"),
    transitionend: $c50b85309f892411$var$Ve("Transition", "TransitionEnd")
}, $c50b85309f892411$var$Xe = {}, $c50b85309f892411$var$Ye = {};
$c50b85309f892411$var$ia && ($c50b85309f892411$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c50b85309f892411$var$We.animationend.animation, delete $c50b85309f892411$var$We.animationiteration.animation, delete $c50b85309f892411$var$We.animationstart.animation), "TransitionEvent" in window || delete $c50b85309f892411$var$We.transitionend.transition);
function $c50b85309f892411$var$Ze(a) {
    if ($c50b85309f892411$var$Xe[a]) return $c50b85309f892411$var$Xe[a];
    if (!$c50b85309f892411$var$We[a]) return a;
    var b = $c50b85309f892411$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c50b85309f892411$var$Ye) return $c50b85309f892411$var$Xe[a] = b[c];
    return a;
}
var $c50b85309f892411$var$$e = $c50b85309f892411$var$Ze("animationend"), $c50b85309f892411$var$af = $c50b85309f892411$var$Ze("animationiteration"), $c50b85309f892411$var$bf = $c50b85309f892411$var$Ze("animationstart"), $c50b85309f892411$var$cf = $c50b85309f892411$var$Ze("transitionend"), $c50b85309f892411$var$df = new Map, $c50b85309f892411$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c50b85309f892411$var$ff(a, b) {
    $c50b85309f892411$var$df.set(a, b);
    $c50b85309f892411$var$fa(b, [
        a
    ]);
}
for(var $c50b85309f892411$var$gf = 0; $c50b85309f892411$var$gf < $c50b85309f892411$var$ef.length; $c50b85309f892411$var$gf++){
    var $c50b85309f892411$var$hf = $c50b85309f892411$var$ef[$c50b85309f892411$var$gf], $c50b85309f892411$var$jf = $c50b85309f892411$var$hf.toLowerCase(), $c50b85309f892411$var$kf = $c50b85309f892411$var$hf[0].toUpperCase() + $c50b85309f892411$var$hf.slice(1);
    $c50b85309f892411$var$ff($c50b85309f892411$var$jf, "on" + $c50b85309f892411$var$kf);
}
$c50b85309f892411$var$ff($c50b85309f892411$var$$e, "onAnimationEnd");
$c50b85309f892411$var$ff($c50b85309f892411$var$af, "onAnimationIteration");
$c50b85309f892411$var$ff($c50b85309f892411$var$bf, "onAnimationStart");
$c50b85309f892411$var$ff("dblclick", "onDoubleClick");
$c50b85309f892411$var$ff("focusin", "onFocus");
$c50b85309f892411$var$ff("focusout", "onBlur");
$c50b85309f892411$var$ff($c50b85309f892411$var$cf, "onTransitionEnd");
$c50b85309f892411$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c50b85309f892411$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c50b85309f892411$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c50b85309f892411$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c50b85309f892411$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c50b85309f892411$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c50b85309f892411$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c50b85309f892411$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c50b85309f892411$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c50b85309f892411$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c50b85309f892411$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c50b85309f892411$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c50b85309f892411$var$lf));
function $c50b85309f892411$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c50b85309f892411$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c50b85309f892411$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c50b85309f892411$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c50b85309f892411$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c50b85309f892411$var$Qb) throw a = $c50b85309f892411$var$Rb, $c50b85309f892411$var$Qb = !1, $c50b85309f892411$var$Rb = null, a;
}
function $c50b85309f892411$var$D(a, b) {
    var c = b[$c50b85309f892411$var$of];
    void 0 === c && (c = b[$c50b85309f892411$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c50b85309f892411$var$pf(b, a, 2, !1), c.add(d));
}
function $c50b85309f892411$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c50b85309f892411$var$pf(c, a, d, b);
}
var $c50b85309f892411$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c50b85309f892411$var$sf(a) {
    if (!a[$c50b85309f892411$var$rf]) {
        a[$c50b85309f892411$var$rf] = !0;
        $c50b85309f892411$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c50b85309f892411$var$mf.has(b) || $c50b85309f892411$var$qf(b, !1, a), $c50b85309f892411$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c50b85309f892411$var$rf] || (b[$c50b85309f892411$var$rf] = !0, $c50b85309f892411$var$qf("selectionchange", !1, b));
    }
}
function $c50b85309f892411$var$pf(a, b, c, d) {
    switch($c50b85309f892411$var$jd(b)){
        case 1:
            var e = $c50b85309f892411$var$ed;
            break;
        case 4:
            e = $c50b85309f892411$var$gd;
            break;
        default:
            e = $c50b85309f892411$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c50b85309f892411$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c50b85309f892411$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c50b85309f892411$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c50b85309f892411$var$Jb(function() {
        var d = f, e = $c50b85309f892411$var$xb(c), g = [];
        a: {
            var h = $c50b85309f892411$var$df.get(a);
            if (void 0 !== h) {
                var k = $c50b85309f892411$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c50b85309f892411$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c50b85309f892411$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c50b85309f892411$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c50b85309f892411$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c50b85309f892411$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c50b85309f892411$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c50b85309f892411$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c50b85309f892411$var$Vd;
                        break;
                    case $c50b85309f892411$var$$e:
                    case $c50b85309f892411$var$af:
                    case $c50b85309f892411$var$bf:
                        k = $c50b85309f892411$var$Hd;
                        break;
                    case $c50b85309f892411$var$cf:
                        k = $c50b85309f892411$var$Xd;
                        break;
                    case "scroll":
                        k = $c50b85309f892411$var$vd;
                        break;
                    case "wheel":
                        k = $c50b85309f892411$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c50b85309f892411$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c50b85309f892411$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c50b85309f892411$var$Kb(w, x), null != F && t.push($c50b85309f892411$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c50b85309f892411$var$wb && (n = c.relatedTarget || c.fromElement) && ($c50b85309f892411$var$Wc(n) || n[$c50b85309f892411$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $c50b85309f892411$var$Wc(n) : null, null !== n && (J = $c50b85309f892411$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $c50b85309f892411$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c50b85309f892411$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c50b85309f892411$var$ue(k);
                        u = null == n ? h : $c50b85309f892411$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c50b85309f892411$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c50b85309f892411$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c50b85309f892411$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c50b85309f892411$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c50b85309f892411$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c50b85309f892411$var$vf(t);
                                x = $c50b85309f892411$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c50b85309f892411$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c50b85309f892411$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $c50b85309f892411$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c50b85309f892411$var$ve;
                else if ($c50b85309f892411$var$me(h)) {
                    if ($c50b85309f892411$var$we) na = $c50b85309f892411$var$Fe;
                    else {
                        na = $c50b85309f892411$var$De;
                        var xa = $c50b85309f892411$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c50b85309f892411$var$Ee);
                if (na && (na = na(a, d))) {
                    $c50b85309f892411$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c50b85309f892411$var$cb(h, "number", h.value);
            }
            xa = d ? $c50b85309f892411$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($c50b85309f892411$var$me(xa) || "true" === xa.contentEditable) $c50b85309f892411$var$Qe = xa, $c50b85309f892411$var$Re = d, $c50b85309f892411$var$Se = null;
                    break;
                case "focusout":
                    $c50b85309f892411$var$Se = $c50b85309f892411$var$Re = $c50b85309f892411$var$Qe = null;
                    break;
                case "mousedown":
                    $c50b85309f892411$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c50b85309f892411$var$Te = !1;
                    $c50b85309f892411$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($c50b85309f892411$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c50b85309f892411$var$Ue(g, c, e);
            }
            var $a;
            if ($c50b85309f892411$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c50b85309f892411$var$ie ? $c50b85309f892411$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c50b85309f892411$var$de && "ko" !== c.locale && ($c50b85309f892411$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c50b85309f892411$var$ie && ($a = $c50b85309f892411$var$nd()) : ($c50b85309f892411$var$kd = e, $c50b85309f892411$var$ld = "value" in $c50b85309f892411$var$kd ? $c50b85309f892411$var$kd.value : $c50b85309f892411$var$kd.textContent, $c50b85309f892411$var$ie = !0)), xa = $c50b85309f892411$var$oe(d, ba), 0 < xa.length && (ba = new $c50b85309f892411$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c50b85309f892411$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c50b85309f892411$var$ce ? $c50b85309f892411$var$je(a, c) : $c50b85309f892411$var$ke(a, c)) d = $c50b85309f892411$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $c50b85309f892411$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $c50b85309f892411$var$se(g, b);
    });
}
function $c50b85309f892411$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c50b85309f892411$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c50b85309f892411$var$Kb(a, c), null != f && d.unshift($c50b85309f892411$var$tf(a, f, e)), f = $c50b85309f892411$var$Kb(a, b), null != f && d.push($c50b85309f892411$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c50b85309f892411$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c50b85309f892411$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c50b85309f892411$var$Kb(c, f), null != k && g.unshift($c50b85309f892411$var$tf(c, k, h))) : e || (k = $c50b85309f892411$var$Kb(c, f), null != k && g.push($c50b85309f892411$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c50b85309f892411$var$xf = /\r\n?/g, $c50b85309f892411$var$yf = /\u0000|\uFFFD/g;
function $c50b85309f892411$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c50b85309f892411$var$xf, "\n").replace($c50b85309f892411$var$yf, "");
}
function $c50b85309f892411$var$Af(a, b, c) {
    b = $c50b85309f892411$var$zf(b);
    if ($c50b85309f892411$var$zf(a) !== b && c) throw Error($c50b85309f892411$var$p(425));
}
function $c50b85309f892411$var$Bf() {}
var $c50b85309f892411$var$Cf = null, $c50b85309f892411$var$Df = null;
function $c50b85309f892411$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c50b85309f892411$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c50b85309f892411$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c50b85309f892411$var$Hf = "function" === typeof Promise ? Promise : void 0, $c50b85309f892411$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c50b85309f892411$var$Hf ? function(a) {
    return $c50b85309f892411$var$Hf.resolve(null).then(a).catch($c50b85309f892411$var$If);
} : $c50b85309f892411$var$Ff;
function $c50b85309f892411$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c50b85309f892411$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c50b85309f892411$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c50b85309f892411$var$bd(b);
}
function $c50b85309f892411$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c50b85309f892411$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c50b85309f892411$var$Nf = Math.random().toString(36).slice(2), $c50b85309f892411$var$Of = "__reactFiber$" + $c50b85309f892411$var$Nf, $c50b85309f892411$var$Pf = "__reactProps$" + $c50b85309f892411$var$Nf, $c50b85309f892411$var$uf = "__reactContainer$" + $c50b85309f892411$var$Nf, $c50b85309f892411$var$of = "__reactEvents$" + $c50b85309f892411$var$Nf, $c50b85309f892411$var$Qf = "__reactListeners$" + $c50b85309f892411$var$Nf, $c50b85309f892411$var$Rf = "__reactHandles$" + $c50b85309f892411$var$Nf;
function $c50b85309f892411$var$Wc(a) {
    var b = a[$c50b85309f892411$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c50b85309f892411$var$uf] || c[$c50b85309f892411$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c50b85309f892411$var$Mf(a); null !== a;){
                if (c = a[$c50b85309f892411$var$Of]) return c;
                a = $c50b85309f892411$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c50b85309f892411$var$Cb(a) {
    a = a[$c50b85309f892411$var$Of] || a[$c50b85309f892411$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c50b85309f892411$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c50b85309f892411$var$p(33));
}
function $c50b85309f892411$var$Db(a) {
    return a[$c50b85309f892411$var$Pf] || null;
}
var $c50b85309f892411$var$Sf = [], $c50b85309f892411$var$Tf = -1;
function $c50b85309f892411$var$Uf(a) {
    return {
        current: a
    };
}
function $c50b85309f892411$var$E(a) {
    0 > $c50b85309f892411$var$Tf || (a.current = $c50b85309f892411$var$Sf[$c50b85309f892411$var$Tf], $c50b85309f892411$var$Sf[$c50b85309f892411$var$Tf] = null, $c50b85309f892411$var$Tf--);
}
function $c50b85309f892411$var$G(a, b) {
    $c50b85309f892411$var$Tf++;
    $c50b85309f892411$var$Sf[$c50b85309f892411$var$Tf] = a.current;
    a.current = b;
}
var $c50b85309f892411$var$Vf = {}, $c50b85309f892411$var$H = $c50b85309f892411$var$Uf($c50b85309f892411$var$Vf), $c50b85309f892411$var$Wf = $c50b85309f892411$var$Uf(!1), $c50b85309f892411$var$Xf = $c50b85309f892411$var$Vf;
function $c50b85309f892411$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c50b85309f892411$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c50b85309f892411$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c50b85309f892411$var$$f() {
    $c50b85309f892411$var$E($c50b85309f892411$var$Wf);
    $c50b85309f892411$var$E($c50b85309f892411$var$H);
}
function $c50b85309f892411$var$ag(a, b, c) {
    if ($c50b85309f892411$var$H.current !== $c50b85309f892411$var$Vf) throw Error($c50b85309f892411$var$p(168));
    $c50b85309f892411$var$G($c50b85309f892411$var$H, b);
    $c50b85309f892411$var$G($c50b85309f892411$var$Wf, c);
}
function $c50b85309f892411$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c50b85309f892411$var$p(108, $c50b85309f892411$var$Ra(a) || "Unknown", e));
    return $c50b85309f892411$var$A({}, c, d);
}
function $c50b85309f892411$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c50b85309f892411$var$Vf;
    $c50b85309f892411$var$Xf = $c50b85309f892411$var$H.current;
    $c50b85309f892411$var$G($c50b85309f892411$var$H, a);
    $c50b85309f892411$var$G($c50b85309f892411$var$Wf, $c50b85309f892411$var$Wf.current);
    return !0;
}
function $c50b85309f892411$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c50b85309f892411$var$p(169));
    c ? (a = $c50b85309f892411$var$bg(a, b, $c50b85309f892411$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c50b85309f892411$var$E($c50b85309f892411$var$Wf), $c50b85309f892411$var$E($c50b85309f892411$var$H), $c50b85309f892411$var$G($c50b85309f892411$var$H, a)) : $c50b85309f892411$var$E($c50b85309f892411$var$Wf);
    $c50b85309f892411$var$G($c50b85309f892411$var$Wf, c);
}
var $c50b85309f892411$var$eg = null, $c50b85309f892411$var$fg = !1, $c50b85309f892411$var$gg = !1;
function $c50b85309f892411$var$hg(a) {
    null === $c50b85309f892411$var$eg ? $c50b85309f892411$var$eg = [
        a
    ] : $c50b85309f892411$var$eg.push(a);
}
function $c50b85309f892411$var$ig(a) {
    $c50b85309f892411$var$fg = !0;
    $c50b85309f892411$var$hg(a);
}
function $c50b85309f892411$var$jg() {
    if (!$c50b85309f892411$var$gg && null !== $c50b85309f892411$var$eg) {
        $c50b85309f892411$var$gg = !0;
        var a = 0, b = $c50b85309f892411$var$C;
        try {
            var c = $c50b85309f892411$var$eg;
            for($c50b85309f892411$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c50b85309f892411$var$eg = null;
            $c50b85309f892411$var$fg = !1;
        } catch (e) {
            throw null !== $c50b85309f892411$var$eg && ($c50b85309f892411$var$eg = $c50b85309f892411$var$eg.slice(a + 1)), $c50b85309f892411$var$ac($c50b85309f892411$var$fc, $c50b85309f892411$var$jg), e;
        } finally{
            $c50b85309f892411$var$C = b, $c50b85309f892411$var$gg = !1;
        }
    }
    return null;
}
var $c50b85309f892411$var$kg = [], $c50b85309f892411$var$lg = 0, $c50b85309f892411$var$mg = null, $c50b85309f892411$var$ng = 0, $c50b85309f892411$var$og = [], $c50b85309f892411$var$pg = 0, $c50b85309f892411$var$qg = null, $c50b85309f892411$var$rg = 1, $c50b85309f892411$var$sg = "";
function $c50b85309f892411$var$tg(a, b) {
    $c50b85309f892411$var$kg[$c50b85309f892411$var$lg++] = $c50b85309f892411$var$ng;
    $c50b85309f892411$var$kg[$c50b85309f892411$var$lg++] = $c50b85309f892411$var$mg;
    $c50b85309f892411$var$mg = a;
    $c50b85309f892411$var$ng = b;
}
function $c50b85309f892411$var$ug(a, b, c) {
    $c50b85309f892411$var$og[$c50b85309f892411$var$pg++] = $c50b85309f892411$var$rg;
    $c50b85309f892411$var$og[$c50b85309f892411$var$pg++] = $c50b85309f892411$var$sg;
    $c50b85309f892411$var$og[$c50b85309f892411$var$pg++] = $c50b85309f892411$var$qg;
    $c50b85309f892411$var$qg = a;
    var d = $c50b85309f892411$var$rg;
    a = $c50b85309f892411$var$sg;
    var e = 32 - $c50b85309f892411$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c50b85309f892411$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c50b85309f892411$var$rg = 1 << 32 - $c50b85309f892411$var$oc(b) + e | c << e | d;
        $c50b85309f892411$var$sg = f + a;
    } else $c50b85309f892411$var$rg = 1 << f | c << e | d, $c50b85309f892411$var$sg = a;
}
function $c50b85309f892411$var$vg(a) {
    null !== a.return && ($c50b85309f892411$var$tg(a, 1), $c50b85309f892411$var$ug(a, 1, 0));
}
function $c50b85309f892411$var$wg(a) {
    for(; a === $c50b85309f892411$var$mg;)$c50b85309f892411$var$mg = $c50b85309f892411$var$kg[--$c50b85309f892411$var$lg], $c50b85309f892411$var$kg[$c50b85309f892411$var$lg] = null, $c50b85309f892411$var$ng = $c50b85309f892411$var$kg[--$c50b85309f892411$var$lg], $c50b85309f892411$var$kg[$c50b85309f892411$var$lg] = null;
    for(; a === $c50b85309f892411$var$qg;)$c50b85309f892411$var$qg = $c50b85309f892411$var$og[--$c50b85309f892411$var$pg], $c50b85309f892411$var$og[$c50b85309f892411$var$pg] = null, $c50b85309f892411$var$sg = $c50b85309f892411$var$og[--$c50b85309f892411$var$pg], $c50b85309f892411$var$og[$c50b85309f892411$var$pg] = null, $c50b85309f892411$var$rg = $c50b85309f892411$var$og[--$c50b85309f892411$var$pg], $c50b85309f892411$var$og[$c50b85309f892411$var$pg] = null;
}
var $c50b85309f892411$var$xg = null, $c50b85309f892411$var$yg = null, $c50b85309f892411$var$I = !1, $c50b85309f892411$var$zg = null;
function $c50b85309f892411$var$Ag(a, b) {
    var c = $c50b85309f892411$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c50b85309f892411$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c50b85309f892411$var$xg = a, $c50b85309f892411$var$yg = $c50b85309f892411$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c50b85309f892411$var$xg = a, $c50b85309f892411$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c50b85309f892411$var$qg ? {
                id: $c50b85309f892411$var$rg,
                overflow: $c50b85309f892411$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c50b85309f892411$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c50b85309f892411$var$xg = a, $c50b85309f892411$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c50b85309f892411$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c50b85309f892411$var$Eg(a) {
    if ($c50b85309f892411$var$I) {
        var b = $c50b85309f892411$var$yg;
        if (b) {
            var c = b;
            if (!$c50b85309f892411$var$Cg(a, b)) {
                if ($c50b85309f892411$var$Dg(a)) throw Error($c50b85309f892411$var$p(418));
                b = $c50b85309f892411$var$Lf(c.nextSibling);
                var d = $c50b85309f892411$var$xg;
                b && $c50b85309f892411$var$Cg(a, b) ? $c50b85309f892411$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c50b85309f892411$var$I = !1, $c50b85309f892411$var$xg = a);
            }
        } else {
            if ($c50b85309f892411$var$Dg(a)) throw Error($c50b85309f892411$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c50b85309f892411$var$I = !1;
            $c50b85309f892411$var$xg = a;
        }
    }
}
function $c50b85309f892411$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c50b85309f892411$var$xg = a;
}
function $c50b85309f892411$var$Gg(a) {
    if (a !== $c50b85309f892411$var$xg) return !1;
    if (!$c50b85309f892411$var$I) return $c50b85309f892411$var$Fg(a), $c50b85309f892411$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c50b85309f892411$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c50b85309f892411$var$yg)) {
        if ($c50b85309f892411$var$Dg(a)) throw $c50b85309f892411$var$Hg(), Error($c50b85309f892411$var$p(418));
        for(; b;)$c50b85309f892411$var$Ag(a, b), b = $c50b85309f892411$var$Lf(b.nextSibling);
    }
    $c50b85309f892411$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c50b85309f892411$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c50b85309f892411$var$yg = $c50b85309f892411$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c50b85309f892411$var$yg = null;
        }
    } else $c50b85309f892411$var$yg = $c50b85309f892411$var$xg ? $c50b85309f892411$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c50b85309f892411$var$Hg() {
    for(var a = $c50b85309f892411$var$yg; a;)a = $c50b85309f892411$var$Lf(a.nextSibling);
}
function $c50b85309f892411$var$Ig() {
    $c50b85309f892411$var$yg = $c50b85309f892411$var$xg = null;
    $c50b85309f892411$var$I = !1;
}
function $c50b85309f892411$var$Jg(a) {
    null === $c50b85309f892411$var$zg ? $c50b85309f892411$var$zg = [
        a
    ] : $c50b85309f892411$var$zg.push(a);
}
var $c50b85309f892411$var$Kg = $c50b85309f892411$var$ua.ReactCurrentBatchConfig;
function $c50b85309f892411$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c50b85309f892411$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c50b85309f892411$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c50b85309f892411$var$p(284));
        if (!c._owner) throw Error($c50b85309f892411$var$p(290, a));
    }
    return a;
}
function $c50b85309f892411$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c50b85309f892411$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c50b85309f892411$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $c50b85309f892411$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c50b85309f892411$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c50b85309f892411$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c50b85309f892411$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c50b85309f892411$var$Ha && $c50b85309f892411$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $c50b85309f892411$var$Lg(a, b, c), d.return = a, d;
        d = $c50b85309f892411$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c50b85309f892411$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c50b85309f892411$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c50b85309f892411$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c50b85309f892411$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c50b85309f892411$var$va:
                    return c = $c50b85309f892411$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $c50b85309f892411$var$Lg(a, null, b), c.return = a, c;
                case $c50b85309f892411$var$wa:
                    return b = $c50b85309f892411$var$Sg(b, a.mode, c), b.return = a, b;
                case $c50b85309f892411$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c50b85309f892411$var$eb(b) || $c50b85309f892411$var$Ka(b)) return b = $c50b85309f892411$var$Tg(b, a.mode, c, null), b.return = a, b;
            $c50b85309f892411$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c50b85309f892411$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c50b85309f892411$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c50b85309f892411$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c50b85309f892411$var$eb(c) || $c50b85309f892411$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c50b85309f892411$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c50b85309f892411$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c50b85309f892411$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c50b85309f892411$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c50b85309f892411$var$eb(d) || $c50b85309f892411$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c50b85309f892411$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c50b85309f892411$var$I && $c50b85309f892411$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c50b85309f892411$var$I && $c50b85309f892411$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c50b85309f892411$var$I && $c50b85309f892411$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c50b85309f892411$var$Ka(h);
        if ("function" !== typeof l) throw Error($c50b85309f892411$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c50b85309f892411$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c50b85309f892411$var$I && $c50b85309f892411$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c50b85309f892411$var$I && $c50b85309f892411$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c50b85309f892411$var$I && $c50b85309f892411$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c50b85309f892411$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c50b85309f892411$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c50b85309f892411$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c50b85309f892411$var$Ha && $c50b85309f892411$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c50b85309f892411$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c50b85309f892411$var$ya ? (d = $c50b85309f892411$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c50b85309f892411$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $c50b85309f892411$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c50b85309f892411$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c50b85309f892411$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c50b85309f892411$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c50b85309f892411$var$eb(f)) return n(a, d, f, h);
            if ($c50b85309f892411$var$Ka(f)) return t(a, d, f, h);
            $c50b85309f892411$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c50b85309f892411$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c50b85309f892411$var$Ug = $c50b85309f892411$var$Og(!0), $c50b85309f892411$var$Vg = $c50b85309f892411$var$Og(!1), $c50b85309f892411$var$Wg = $c50b85309f892411$var$Uf(null), $c50b85309f892411$var$Xg = null, $c50b85309f892411$var$Yg = null, $c50b85309f892411$var$Zg = null;
function $c50b85309f892411$var$$g() {
    $c50b85309f892411$var$Zg = $c50b85309f892411$var$Yg = $c50b85309f892411$var$Xg = null;
}
function $c50b85309f892411$var$ah(a) {
    var b = $c50b85309f892411$var$Wg.current;
    $c50b85309f892411$var$E($c50b85309f892411$var$Wg);
    a._currentValue = b;
}
function $c50b85309f892411$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c50b85309f892411$var$ch(a, b) {
    $c50b85309f892411$var$Xg = a;
    $c50b85309f892411$var$Zg = $c50b85309f892411$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c50b85309f892411$var$dh = !0), a.firstContext = null);
}
function $c50b85309f892411$var$eh(a) {
    var b = a._currentValue;
    if ($c50b85309f892411$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c50b85309f892411$var$Yg) {
            if (null === $c50b85309f892411$var$Xg) throw Error($c50b85309f892411$var$p(308));
            $c50b85309f892411$var$Yg = a;
            $c50b85309f892411$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c50b85309f892411$var$Yg = $c50b85309f892411$var$Yg.next = a;
    }
    return b;
}
var $c50b85309f892411$var$fh = null;
function $c50b85309f892411$var$gh(a) {
    null === $c50b85309f892411$var$fh ? $c50b85309f892411$var$fh = [
        a
    ] : $c50b85309f892411$var$fh.push(a);
}
function $c50b85309f892411$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c50b85309f892411$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c50b85309f892411$var$ih(a, d);
}
function $c50b85309f892411$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c50b85309f892411$var$jh = !1;
function $c50b85309f892411$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c50b85309f892411$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c50b85309f892411$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c50b85309f892411$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c50b85309f892411$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c50b85309f892411$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c50b85309f892411$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c50b85309f892411$var$ih(a, c);
}
function $c50b85309f892411$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c50b85309f892411$var$Cc(a, c);
    }
}
function $c50b85309f892411$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c50b85309f892411$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $c50b85309f892411$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c50b85309f892411$var$A({}, q, r);
                            break a;
                        case 2:
                            $c50b85309f892411$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c50b85309f892411$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c50b85309f892411$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c50b85309f892411$var$p(191, e));
            e.call(d);
        }
    }
}
var $c50b85309f892411$var$th = {}, $c50b85309f892411$var$uh = $c50b85309f892411$var$Uf($c50b85309f892411$var$th), $c50b85309f892411$var$vh = $c50b85309f892411$var$Uf($c50b85309f892411$var$th), $c50b85309f892411$var$wh = $c50b85309f892411$var$Uf($c50b85309f892411$var$th);
function $c50b85309f892411$var$xh(a) {
    if (a === $c50b85309f892411$var$th) throw Error($c50b85309f892411$var$p(174));
    return a;
}
function $c50b85309f892411$var$yh(a, b) {
    $c50b85309f892411$var$G($c50b85309f892411$var$wh, b);
    $c50b85309f892411$var$G($c50b85309f892411$var$vh, a);
    $c50b85309f892411$var$G($c50b85309f892411$var$uh, $c50b85309f892411$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c50b85309f892411$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c50b85309f892411$var$lb(b, a);
    }
    $c50b85309f892411$var$E($c50b85309f892411$var$uh);
    $c50b85309f892411$var$G($c50b85309f892411$var$uh, b);
}
function $c50b85309f892411$var$zh() {
    $c50b85309f892411$var$E($c50b85309f892411$var$uh);
    $c50b85309f892411$var$E($c50b85309f892411$var$vh);
    $c50b85309f892411$var$E($c50b85309f892411$var$wh);
}
function $c50b85309f892411$var$Ah(a) {
    $c50b85309f892411$var$xh($c50b85309f892411$var$wh.current);
    var b = $c50b85309f892411$var$xh($c50b85309f892411$var$uh.current);
    var c = $c50b85309f892411$var$lb(b, a.type);
    b !== c && ($c50b85309f892411$var$G($c50b85309f892411$var$vh, a), $c50b85309f892411$var$G($c50b85309f892411$var$uh, c));
}
function $c50b85309f892411$var$Bh(a) {
    $c50b85309f892411$var$vh.current === a && ($c50b85309f892411$var$E($c50b85309f892411$var$uh), $c50b85309f892411$var$E($c50b85309f892411$var$vh));
}
var $c50b85309f892411$var$L = $c50b85309f892411$var$Uf(0);
function $c50b85309f892411$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c50b85309f892411$var$Dh = [];
function $c50b85309f892411$var$Eh() {
    for(var a = 0; a < $c50b85309f892411$var$Dh.length; a++)$c50b85309f892411$var$Dh[a]._workInProgressVersionPrimary = null;
    $c50b85309f892411$var$Dh.length = 0;
}
var $c50b85309f892411$var$Fh = $c50b85309f892411$var$ua.ReactCurrentDispatcher, $c50b85309f892411$var$Gh = $c50b85309f892411$var$ua.ReactCurrentBatchConfig, $c50b85309f892411$var$Hh = 0, $c50b85309f892411$var$M = null, $c50b85309f892411$var$N = null, $c50b85309f892411$var$O = null, $c50b85309f892411$var$Ih = !1, $c50b85309f892411$var$Jh = !1, $c50b85309f892411$var$Kh = 0, $c50b85309f892411$var$Lh = 0;
function $c50b85309f892411$var$P() {
    throw Error($c50b85309f892411$var$p(321));
}
function $c50b85309f892411$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c50b85309f892411$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c50b85309f892411$var$Nh(a, b, c, d, e, f) {
    $c50b85309f892411$var$Hh = f;
    $c50b85309f892411$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c50b85309f892411$var$Fh.current = null === a || null === a.memoizedState ? $c50b85309f892411$var$Oh : $c50b85309f892411$var$Ph;
    a = c(d, e);
    if ($c50b85309f892411$var$Jh) {
        f = 0;
        do {
            $c50b85309f892411$var$Jh = !1;
            $c50b85309f892411$var$Kh = 0;
            if (25 <= f) throw Error($c50b85309f892411$var$p(301));
            f += 1;
            $c50b85309f892411$var$O = $c50b85309f892411$var$N = null;
            b.updateQueue = null;
            $c50b85309f892411$var$Fh.current = $c50b85309f892411$var$Qh;
            a = c(d, e);
        }while ($c50b85309f892411$var$Jh);
    }
    $c50b85309f892411$var$Fh.current = $c50b85309f892411$var$Rh;
    b = null !== $c50b85309f892411$var$N && null !== $c50b85309f892411$var$N.next;
    $c50b85309f892411$var$Hh = 0;
    $c50b85309f892411$var$O = $c50b85309f892411$var$N = $c50b85309f892411$var$M = null;
    $c50b85309f892411$var$Ih = !1;
    if (b) throw Error($c50b85309f892411$var$p(300));
    return a;
}
function $c50b85309f892411$var$Sh() {
    var a = 0 !== $c50b85309f892411$var$Kh;
    $c50b85309f892411$var$Kh = 0;
    return a;
}
function $c50b85309f892411$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c50b85309f892411$var$O ? $c50b85309f892411$var$M.memoizedState = $c50b85309f892411$var$O = a : $c50b85309f892411$var$O = $c50b85309f892411$var$O.next = a;
    return $c50b85309f892411$var$O;
}
function $c50b85309f892411$var$Uh() {
    if (null === $c50b85309f892411$var$N) {
        var a = $c50b85309f892411$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c50b85309f892411$var$N.next;
    var b = null === $c50b85309f892411$var$O ? $c50b85309f892411$var$M.memoizedState : $c50b85309f892411$var$O.next;
    if (null !== b) $c50b85309f892411$var$O = b, $c50b85309f892411$var$N = a;
    else {
        if (null === a) throw Error($c50b85309f892411$var$p(310));
        $c50b85309f892411$var$N = a;
        a = {
            memoizedState: $c50b85309f892411$var$N.memoizedState,
            baseState: $c50b85309f892411$var$N.baseState,
            baseQueue: $c50b85309f892411$var$N.baseQueue,
            queue: $c50b85309f892411$var$N.queue,
            next: null
        };
        null === $c50b85309f892411$var$O ? $c50b85309f892411$var$M.memoizedState = $c50b85309f892411$var$O = a : $c50b85309f892411$var$O = $c50b85309f892411$var$O.next = a;
    }
    return $c50b85309f892411$var$O;
}
function $c50b85309f892411$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c50b85309f892411$var$Wh(a) {
    var b = $c50b85309f892411$var$Uh(), c = b.queue;
    if (null === c) throw Error($c50b85309f892411$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c50b85309f892411$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c50b85309f892411$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c50b85309f892411$var$M.lanes |= m;
                $c50b85309f892411$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c50b85309f892411$var$He(d, b.memoizedState) || ($c50b85309f892411$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c50b85309f892411$var$M.lanes |= f, $c50b85309f892411$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c50b85309f892411$var$Xh(a) {
    var b = $c50b85309f892411$var$Uh(), c = b.queue;
    if (null === c) throw Error($c50b85309f892411$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c50b85309f892411$var$He(f, b.memoizedState) || ($c50b85309f892411$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c50b85309f892411$var$Yh() {}
function $c50b85309f892411$var$Zh(a, b) {
    var c = $c50b85309f892411$var$M, d = $c50b85309f892411$var$Uh(), e = b(), f = !$c50b85309f892411$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c50b85309f892411$var$dh = !0);
    d = d.queue;
    $c50b85309f892411$var$$h($c50b85309f892411$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c50b85309f892411$var$O && $c50b85309f892411$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c50b85309f892411$var$bi(9, $c50b85309f892411$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $c50b85309f892411$var$Q) throw Error($c50b85309f892411$var$p(349));
        0 !== ($c50b85309f892411$var$Hh & 30) || $c50b85309f892411$var$di(c, b, e);
    }
    return e;
}
function $c50b85309f892411$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c50b85309f892411$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c50b85309f892411$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c50b85309f892411$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c50b85309f892411$var$ei(b) && $c50b85309f892411$var$fi(a);
}
function $c50b85309f892411$var$ai(a, b, c) {
    return c(function() {
        $c50b85309f892411$var$ei(b) && $c50b85309f892411$var$fi(a);
    });
}
function $c50b85309f892411$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c50b85309f892411$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c50b85309f892411$var$fi(a) {
    var b = $c50b85309f892411$var$ih(a, 1);
    null !== b && $c50b85309f892411$var$gi(b, a, 1, -1);
}
function $c50b85309f892411$var$hi(a) {
    var b = $c50b85309f892411$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c50b85309f892411$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c50b85309f892411$var$ii.bind(null, $c50b85309f892411$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c50b85309f892411$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c50b85309f892411$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c50b85309f892411$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c50b85309f892411$var$ji() {
    return $c50b85309f892411$var$Uh().memoizedState;
}
function $c50b85309f892411$var$ki(a, b, c, d) {
    var e = $c50b85309f892411$var$Th();
    $c50b85309f892411$var$M.flags |= a;
    e.memoizedState = $c50b85309f892411$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c50b85309f892411$var$li(a, b, c, d) {
    var e = $c50b85309f892411$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c50b85309f892411$var$N) {
        var g = $c50b85309f892411$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $c50b85309f892411$var$Mh(d, g.deps)) {
            e.memoizedState = $c50b85309f892411$var$bi(b, c, f, d);
            return;
        }
    }
    $c50b85309f892411$var$M.flags |= a;
    e.memoizedState = $c50b85309f892411$var$bi(1 | b, c, f, d);
}
function $c50b85309f892411$var$mi(a, b) {
    return $c50b85309f892411$var$ki(8390656, 8, a, b);
}
function $c50b85309f892411$var$$h(a, b) {
    return $c50b85309f892411$var$li(2048, 8, a, b);
}
function $c50b85309f892411$var$ni(a, b) {
    return $c50b85309f892411$var$li(4, 2, a, b);
}
function $c50b85309f892411$var$oi(a, b) {
    return $c50b85309f892411$var$li(4, 4, a, b);
}
function $c50b85309f892411$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c50b85309f892411$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c50b85309f892411$var$li(4, 4, $c50b85309f892411$var$pi.bind(null, b, a), c);
}
function $c50b85309f892411$var$ri() {}
function $c50b85309f892411$var$si(a, b) {
    var c = $c50b85309f892411$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c50b85309f892411$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c50b85309f892411$var$ti(a, b) {
    var c = $c50b85309f892411$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c50b85309f892411$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c50b85309f892411$var$ui(a, b, c) {
    if (0 === ($c50b85309f892411$var$Hh & 21)) return a.baseState && (a.baseState = !1, $c50b85309f892411$var$dh = !0), a.memoizedState = c;
    $c50b85309f892411$var$He(c, b) || (c = $c50b85309f892411$var$yc(), $c50b85309f892411$var$M.lanes |= c, $c50b85309f892411$var$rh |= c, a.baseState = !0);
    return b;
}
function $c50b85309f892411$var$vi(a, b) {
    var c = $c50b85309f892411$var$C;
    $c50b85309f892411$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c50b85309f892411$var$Gh.transition;
    $c50b85309f892411$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c50b85309f892411$var$C = c, $c50b85309f892411$var$Gh.transition = d;
    }
}
function $c50b85309f892411$var$wi() {
    return $c50b85309f892411$var$Uh().memoizedState;
}
function $c50b85309f892411$var$xi(a, b, c) {
    var d = $c50b85309f892411$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c50b85309f892411$var$zi(a)) $c50b85309f892411$var$Ai(b, c);
    else if (c = $c50b85309f892411$var$hh(a, b, c, d), null !== c) {
        var e = $c50b85309f892411$var$R();
        $c50b85309f892411$var$gi(c, a, d, e);
        $c50b85309f892411$var$Bi(c, b, d);
    }
}
function $c50b85309f892411$var$ii(a, b, c) {
    var d = $c50b85309f892411$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c50b85309f892411$var$zi(a)) $c50b85309f892411$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c50b85309f892411$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c50b85309f892411$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c50b85309f892411$var$hh(a, b, e, d);
        null !== c && (e = $c50b85309f892411$var$R(), $c50b85309f892411$var$gi(c, a, d, e), $c50b85309f892411$var$Bi(c, b, d));
    }
}
function $c50b85309f892411$var$zi(a) {
    var b = a.alternate;
    return a === $c50b85309f892411$var$M || null !== b && b === $c50b85309f892411$var$M;
}
function $c50b85309f892411$var$Ai(a, b) {
    $c50b85309f892411$var$Jh = $c50b85309f892411$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c50b85309f892411$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c50b85309f892411$var$Cc(a, c);
    }
}
var $c50b85309f892411$var$Rh = {
    readContext: $c50b85309f892411$var$eh,
    useCallback: $c50b85309f892411$var$P,
    useContext: $c50b85309f892411$var$P,
    useEffect: $c50b85309f892411$var$P,
    useImperativeHandle: $c50b85309f892411$var$P,
    useInsertionEffect: $c50b85309f892411$var$P,
    useLayoutEffect: $c50b85309f892411$var$P,
    useMemo: $c50b85309f892411$var$P,
    useReducer: $c50b85309f892411$var$P,
    useRef: $c50b85309f892411$var$P,
    useState: $c50b85309f892411$var$P,
    useDebugValue: $c50b85309f892411$var$P,
    useDeferredValue: $c50b85309f892411$var$P,
    useTransition: $c50b85309f892411$var$P,
    useMutableSource: $c50b85309f892411$var$P,
    useSyncExternalStore: $c50b85309f892411$var$P,
    useId: $c50b85309f892411$var$P,
    unstable_isNewReconciler: !1
}, $c50b85309f892411$var$Oh = {
    readContext: $c50b85309f892411$var$eh,
    useCallback: function(a, b) {
        $c50b85309f892411$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c50b85309f892411$var$eh,
    useEffect: $c50b85309f892411$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c50b85309f892411$var$ki(4194308, 4, $c50b85309f892411$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c50b85309f892411$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c50b85309f892411$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c50b85309f892411$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c50b85309f892411$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c50b85309f892411$var$xi.bind(null, $c50b85309f892411$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c50b85309f892411$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c50b85309f892411$var$hi,
    useDebugValue: $c50b85309f892411$var$ri,
    useDeferredValue: function(a) {
        return $c50b85309f892411$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $c50b85309f892411$var$hi(!1), b = a[0];
        a = $c50b85309f892411$var$vi.bind(null, a[1]);
        $c50b85309f892411$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c50b85309f892411$var$M, e = $c50b85309f892411$var$Th();
        if ($c50b85309f892411$var$I) {
            if (void 0 === c) throw Error($c50b85309f892411$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c50b85309f892411$var$Q) throw Error($c50b85309f892411$var$p(349));
            0 !== ($c50b85309f892411$var$Hh & 30) || $c50b85309f892411$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c50b85309f892411$var$mi($c50b85309f892411$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c50b85309f892411$var$bi(9, $c50b85309f892411$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c50b85309f892411$var$Th(), b = $c50b85309f892411$var$Q.identifierPrefix;
        if ($c50b85309f892411$var$I) {
            var c = $c50b85309f892411$var$sg;
            var d = $c50b85309f892411$var$rg;
            c = (d & ~(1 << 32 - $c50b85309f892411$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c50b85309f892411$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c50b85309f892411$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c50b85309f892411$var$Ph = {
    readContext: $c50b85309f892411$var$eh,
    useCallback: $c50b85309f892411$var$si,
    useContext: $c50b85309f892411$var$eh,
    useEffect: $c50b85309f892411$var$$h,
    useImperativeHandle: $c50b85309f892411$var$qi,
    useInsertionEffect: $c50b85309f892411$var$ni,
    useLayoutEffect: $c50b85309f892411$var$oi,
    useMemo: $c50b85309f892411$var$ti,
    useReducer: $c50b85309f892411$var$Wh,
    useRef: $c50b85309f892411$var$ji,
    useState: function() {
        return $c50b85309f892411$var$Wh($c50b85309f892411$var$Vh);
    },
    useDebugValue: $c50b85309f892411$var$ri,
    useDeferredValue: function(a) {
        var b = $c50b85309f892411$var$Uh();
        return $c50b85309f892411$var$ui(b, $c50b85309f892411$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $c50b85309f892411$var$Wh($c50b85309f892411$var$Vh)[0], b = $c50b85309f892411$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c50b85309f892411$var$Yh,
    useSyncExternalStore: $c50b85309f892411$var$Zh,
    useId: $c50b85309f892411$var$wi,
    unstable_isNewReconciler: !1
}, $c50b85309f892411$var$Qh = {
    readContext: $c50b85309f892411$var$eh,
    useCallback: $c50b85309f892411$var$si,
    useContext: $c50b85309f892411$var$eh,
    useEffect: $c50b85309f892411$var$$h,
    useImperativeHandle: $c50b85309f892411$var$qi,
    useInsertionEffect: $c50b85309f892411$var$ni,
    useLayoutEffect: $c50b85309f892411$var$oi,
    useMemo: $c50b85309f892411$var$ti,
    useReducer: $c50b85309f892411$var$Xh,
    useRef: $c50b85309f892411$var$ji,
    useState: function() {
        return $c50b85309f892411$var$Xh($c50b85309f892411$var$Vh);
    },
    useDebugValue: $c50b85309f892411$var$ri,
    useDeferredValue: function(a) {
        var b = $c50b85309f892411$var$Uh();
        return null === $c50b85309f892411$var$N ? b.memoizedState = a : $c50b85309f892411$var$ui(b, $c50b85309f892411$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $c50b85309f892411$var$Xh($c50b85309f892411$var$Vh)[0], b = $c50b85309f892411$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c50b85309f892411$var$Yh,
    useSyncExternalStore: $c50b85309f892411$var$Zh,
    useId: $c50b85309f892411$var$wi,
    unstable_isNewReconciler: !1
};
function $c50b85309f892411$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $c50b85309f892411$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $c50b85309f892411$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c50b85309f892411$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c50b85309f892411$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c50b85309f892411$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c50b85309f892411$var$R(), e = $c50b85309f892411$var$yi(a), f = $c50b85309f892411$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c50b85309f892411$var$nh(a, f, e);
        null !== b && ($c50b85309f892411$var$gi(b, a, e, d), $c50b85309f892411$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c50b85309f892411$var$R(), e = $c50b85309f892411$var$yi(a), f = $c50b85309f892411$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c50b85309f892411$var$nh(a, f, e);
        null !== b && ($c50b85309f892411$var$gi(b, a, e, d), $c50b85309f892411$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c50b85309f892411$var$R(), d = $c50b85309f892411$var$yi(a), e = $c50b85309f892411$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c50b85309f892411$var$nh(a, e, d);
        null !== b && ($c50b85309f892411$var$gi(b, a, d, c), $c50b85309f892411$var$oh(b, a, d));
    }
};
function $c50b85309f892411$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c50b85309f892411$var$Ie(c, d) || !$c50b85309f892411$var$Ie(e, f) : !0;
}
function $c50b85309f892411$var$Gi(a, b, c) {
    var d = !1, e = $c50b85309f892411$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c50b85309f892411$var$eh(f) : (e = $c50b85309f892411$var$Zf(b) ? $c50b85309f892411$var$Xf : $c50b85309f892411$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c50b85309f892411$var$Yf(a, e) : $c50b85309f892411$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c50b85309f892411$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c50b85309f892411$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c50b85309f892411$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $c50b85309f892411$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $c50b85309f892411$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c50b85309f892411$var$eh(f) : (f = $c50b85309f892411$var$Zf(b) ? $c50b85309f892411$var$Xf : $c50b85309f892411$var$H.current, e.context = $c50b85309f892411$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c50b85309f892411$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c50b85309f892411$var$Ei.enqueueReplaceState(e, e.state, null), $c50b85309f892411$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c50b85309f892411$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $c50b85309f892411$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c50b85309f892411$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c50b85309f892411$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c50b85309f892411$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $c50b85309f892411$var$Ni(a, b, c) {
    c = $c50b85309f892411$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c50b85309f892411$var$Oi || ($c50b85309f892411$var$Oi = !0, $c50b85309f892411$var$Pi = d);
        $c50b85309f892411$var$Li(a, b);
    };
    return c;
}
function $c50b85309f892411$var$Qi(a, b, c) {
    c = $c50b85309f892411$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c50b85309f892411$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c50b85309f892411$var$Li(a, b);
        "function" !== typeof d && (null === $c50b85309f892411$var$Ri ? $c50b85309f892411$var$Ri = new Set([
            this
        ]) : $c50b85309f892411$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c50b85309f892411$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c50b85309f892411$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c50b85309f892411$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $c50b85309f892411$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c50b85309f892411$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c50b85309f892411$var$mh(-1, 1), b.tag = 2, $c50b85309f892411$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c50b85309f892411$var$Wi = $c50b85309f892411$var$ua.ReactCurrentOwner, $c50b85309f892411$var$dh = !1;
function $c50b85309f892411$var$Xi(a, b, c, d) {
    b.child = null === a ? $c50b85309f892411$var$Vg(b, null, c, d) : $c50b85309f892411$var$Ug(b, a.child, c, d);
}
function $c50b85309f892411$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c50b85309f892411$var$ch(b, e);
    d = $c50b85309f892411$var$Nh(a, b, c, d, f, e);
    c = $c50b85309f892411$var$Sh();
    if (null !== a && !$c50b85309f892411$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c50b85309f892411$var$Zi(a, b, e);
    $c50b85309f892411$var$I && c && $c50b85309f892411$var$vg(b);
    b.flags |= 1;
    $c50b85309f892411$var$Xi(a, b, d, e);
    return b.child;
}
function $c50b85309f892411$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c50b85309f892411$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c50b85309f892411$var$bj(a, b, f, d, e);
        a = $c50b85309f892411$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c50b85309f892411$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c50b85309f892411$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $c50b85309f892411$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c50b85309f892411$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c50b85309f892411$var$Ie(f, d) && a.ref === b.ref) {
            if ($c50b85309f892411$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c50b85309f892411$var$dh = !0);
            else return b.lanes = a.lanes, $c50b85309f892411$var$Zi(a, b, e);
        }
    }
    return $c50b85309f892411$var$cj(a, b, c, d, e);
}
function $c50b85309f892411$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c50b85309f892411$var$G($c50b85309f892411$var$ej, $c50b85309f892411$var$fj), $c50b85309f892411$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c50b85309f892411$var$G($c50b85309f892411$var$ej, $c50b85309f892411$var$fj), $c50b85309f892411$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c50b85309f892411$var$G($c50b85309f892411$var$ej, $c50b85309f892411$var$fj);
            $c50b85309f892411$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c50b85309f892411$var$G($c50b85309f892411$var$ej, $c50b85309f892411$var$fj), $c50b85309f892411$var$fj |= d;
    $c50b85309f892411$var$Xi(a, b, e, c);
    return b.child;
}
function $c50b85309f892411$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c50b85309f892411$var$cj(a, b, c, d, e) {
    var f = $c50b85309f892411$var$Zf(c) ? $c50b85309f892411$var$Xf : $c50b85309f892411$var$H.current;
    f = $c50b85309f892411$var$Yf(b, f);
    $c50b85309f892411$var$ch(b, e);
    c = $c50b85309f892411$var$Nh(a, b, c, d, f, e);
    d = $c50b85309f892411$var$Sh();
    if (null !== a && !$c50b85309f892411$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c50b85309f892411$var$Zi(a, b, e);
    $c50b85309f892411$var$I && d && $c50b85309f892411$var$vg(b);
    b.flags |= 1;
    $c50b85309f892411$var$Xi(a, b, c, e);
    return b.child;
}
function $c50b85309f892411$var$hj(a, b, c, d, e) {
    if ($c50b85309f892411$var$Zf(c)) {
        var f = !0;
        $c50b85309f892411$var$cg(b);
    } else f = !1;
    $c50b85309f892411$var$ch(b, e);
    if (null === b.stateNode) $c50b85309f892411$var$ij(a, b), $c50b85309f892411$var$Gi(b, c, d), $c50b85309f892411$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c50b85309f892411$var$eh(l) : (l = $c50b85309f892411$var$Zf(c) ? $c50b85309f892411$var$Xf : $c50b85309f892411$var$H.current, l = $c50b85309f892411$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c50b85309f892411$var$Hi(b, g, d, l);
        $c50b85309f892411$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $c50b85309f892411$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c50b85309f892411$var$Wf.current || $c50b85309f892411$var$jh ? ("function" === typeof m && ($c50b85309f892411$var$Di(b, c, m, d), k = b.memoizedState), (h = $c50b85309f892411$var$jh || $c50b85309f892411$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c50b85309f892411$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c50b85309f892411$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c50b85309f892411$var$eh(k) : (k = $c50b85309f892411$var$Zf(c) ? $c50b85309f892411$var$Xf : $c50b85309f892411$var$H.current, k = $c50b85309f892411$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c50b85309f892411$var$Hi(b, g, d, k);
        $c50b85309f892411$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $c50b85309f892411$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c50b85309f892411$var$Wf.current || $c50b85309f892411$var$jh ? ("function" === typeof y && ($c50b85309f892411$var$Di(b, c, y, d), n = b.memoizedState), (l = $c50b85309f892411$var$jh || $c50b85309f892411$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c50b85309f892411$var$jj(a, b, c, d, f, e);
}
function $c50b85309f892411$var$jj(a, b, c, d, e, f) {
    $c50b85309f892411$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c50b85309f892411$var$dg(b, c, !1), $c50b85309f892411$var$Zi(a, b, f);
    d = b.stateNode;
    $c50b85309f892411$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c50b85309f892411$var$Ug(b, a.child, null, f), b.child = $c50b85309f892411$var$Ug(b, null, h, f)) : $c50b85309f892411$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c50b85309f892411$var$dg(b, c, !0);
    return b.child;
}
function $c50b85309f892411$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c50b85309f892411$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c50b85309f892411$var$ag(a, b.context, !1);
    $c50b85309f892411$var$yh(a, b.containerInfo);
}
function $c50b85309f892411$var$lj(a, b, c, d, e) {
    $c50b85309f892411$var$Ig();
    $c50b85309f892411$var$Jg(e);
    b.flags |= 256;
    $c50b85309f892411$var$Xi(a, b, c, d);
    return b.child;
}
var $c50b85309f892411$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c50b85309f892411$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c50b85309f892411$var$oj(a, b, c) {
    var d = b.pendingProps, e = $c50b85309f892411$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c50b85309f892411$var$G($c50b85309f892411$var$L, e & 1);
    if (null === a) {
        $c50b85309f892411$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c50b85309f892411$var$pj(g, d, 0, null), a = $c50b85309f892411$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c50b85309f892411$var$nj(c), b.memoizedState = $c50b85309f892411$var$mj, a) : $c50b85309f892411$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c50b85309f892411$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c50b85309f892411$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c50b85309f892411$var$Pg(h, f) : (f = $c50b85309f892411$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c50b85309f892411$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c50b85309f892411$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c50b85309f892411$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c50b85309f892411$var$qj(a, b) {
    b = $c50b85309f892411$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c50b85309f892411$var$sj(a, b, c, d) {
    null !== d && $c50b85309f892411$var$Jg(d);
    $c50b85309f892411$var$Ug(b, a.child, null, c);
    a = $c50b85309f892411$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c50b85309f892411$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c50b85309f892411$var$Ki(Error($c50b85309f892411$var$p(422))), $c50b85309f892411$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c50b85309f892411$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c50b85309f892411$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c50b85309f892411$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $c50b85309f892411$var$nj(g);
        b.memoizedState = $c50b85309f892411$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c50b85309f892411$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c50b85309f892411$var$p(419));
        d = $c50b85309f892411$var$Ki(f, d, void 0);
        return $c50b85309f892411$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c50b85309f892411$var$dh || h) {
        d = $c50b85309f892411$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c50b85309f892411$var$ih(a, e), $c50b85309f892411$var$gi(d, a, e, -1));
        }
        $c50b85309f892411$var$tj();
        d = $c50b85309f892411$var$Ki(Error($c50b85309f892411$var$p(421)));
        return $c50b85309f892411$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c50b85309f892411$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c50b85309f892411$var$yg = $c50b85309f892411$var$Lf(e.nextSibling);
    $c50b85309f892411$var$xg = b;
    $c50b85309f892411$var$I = !0;
    $c50b85309f892411$var$zg = null;
    null !== a && ($c50b85309f892411$var$og[$c50b85309f892411$var$pg++] = $c50b85309f892411$var$rg, $c50b85309f892411$var$og[$c50b85309f892411$var$pg++] = $c50b85309f892411$var$sg, $c50b85309f892411$var$og[$c50b85309f892411$var$pg++] = $c50b85309f892411$var$qg, $c50b85309f892411$var$rg = a.id, $c50b85309f892411$var$sg = a.overflow, $c50b85309f892411$var$qg = b);
    b = $c50b85309f892411$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c50b85309f892411$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c50b85309f892411$var$bh(a.return, b, c);
}
function $c50b85309f892411$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c50b85309f892411$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c50b85309f892411$var$Xi(a, b, d.children, c);
    d = $c50b85309f892411$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c50b85309f892411$var$vj(a, c, b);
            else if (19 === a.tag) $c50b85309f892411$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c50b85309f892411$var$G($c50b85309f892411$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c50b85309f892411$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c50b85309f892411$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c50b85309f892411$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c50b85309f892411$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $c50b85309f892411$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c50b85309f892411$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c50b85309f892411$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c50b85309f892411$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c50b85309f892411$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c50b85309f892411$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c50b85309f892411$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c50b85309f892411$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $c50b85309f892411$var$kj(b);
            $c50b85309f892411$var$Ig();
            break;
        case 5:
            $c50b85309f892411$var$Ah(b);
            break;
        case 1:
            $c50b85309f892411$var$Zf(b.type) && $c50b85309f892411$var$cg(b);
            break;
        case 4:
            $c50b85309f892411$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c50b85309f892411$var$G($c50b85309f892411$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c50b85309f892411$var$G($c50b85309f892411$var$L, $c50b85309f892411$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c50b85309f892411$var$oj(a, b, c);
                $c50b85309f892411$var$G($c50b85309f892411$var$L, $c50b85309f892411$var$L.current & 1);
                a = $c50b85309f892411$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c50b85309f892411$var$G($c50b85309f892411$var$L, $c50b85309f892411$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c50b85309f892411$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c50b85309f892411$var$G($c50b85309f892411$var$L, $c50b85309f892411$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c50b85309f892411$var$dj(a, b, c);
    }
    return $c50b85309f892411$var$Zi(a, b, c);
}
var $c50b85309f892411$var$zj, $c50b85309f892411$var$Aj, $c50b85309f892411$var$Bj, $c50b85309f892411$var$Cj;
$c50b85309f892411$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c50b85309f892411$var$Aj = function() {};
$c50b85309f892411$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c50b85309f892411$var$xh($c50b85309f892411$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c50b85309f892411$var$Ya(a, e);
                d = $c50b85309f892411$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c50b85309f892411$var$A({}, e, {
                    value: void 0
                });
                d = $c50b85309f892411$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c50b85309f892411$var$gb(a, e);
                d = $c50b85309f892411$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c50b85309f892411$var$Bf);
        }
        $c50b85309f892411$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c50b85309f892411$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c50b85309f892411$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c50b85309f892411$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c50b85309f892411$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c50b85309f892411$var$Dj(a, b) {
    if (!$c50b85309f892411$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c50b85309f892411$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c50b85309f892411$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $c50b85309f892411$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c50b85309f892411$var$S(b), null;
        case 1:
            return $c50b85309f892411$var$Zf(b.type) && $c50b85309f892411$var$$f(), $c50b85309f892411$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c50b85309f892411$var$zh();
            $c50b85309f892411$var$E($c50b85309f892411$var$Wf);
            $c50b85309f892411$var$E($c50b85309f892411$var$H);
            $c50b85309f892411$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c50b85309f892411$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c50b85309f892411$var$zg && ($c50b85309f892411$var$Fj($c50b85309f892411$var$zg), $c50b85309f892411$var$zg = null));
            $c50b85309f892411$var$Aj(a, b);
            $c50b85309f892411$var$S(b);
            return null;
        case 5:
            $c50b85309f892411$var$Bh(b);
            var e = $c50b85309f892411$var$xh($c50b85309f892411$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c50b85309f892411$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c50b85309f892411$var$p(166));
                    $c50b85309f892411$var$S(b);
                    return null;
                }
                a = $c50b85309f892411$var$xh($c50b85309f892411$var$uh.current);
                if ($c50b85309f892411$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c50b85309f892411$var$Of] = b;
                    d[$c50b85309f892411$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c50b85309f892411$var$D("cancel", d);
                            $c50b85309f892411$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c50b85309f892411$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c50b85309f892411$var$lf.length; e++)$c50b85309f892411$var$D($c50b85309f892411$var$lf[e], d);
                            break;
                        case "source":
                            $c50b85309f892411$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c50b85309f892411$var$D("error", d);
                            $c50b85309f892411$var$D("load", d);
                            break;
                        case "details":
                            $c50b85309f892411$var$D("toggle", d);
                            break;
                        case "input":
                            $c50b85309f892411$var$Za(d, f);
                            $c50b85309f892411$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c50b85309f892411$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c50b85309f892411$var$hb(d, f), $c50b85309f892411$var$D("invalid", d);
                    }
                    $c50b85309f892411$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c50b85309f892411$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c50b85309f892411$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c50b85309f892411$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c50b85309f892411$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c50b85309f892411$var$Va(d);
                            $c50b85309f892411$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c50b85309f892411$var$Va(d);
                            $c50b85309f892411$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c50b85309f892411$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c50b85309f892411$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c50b85309f892411$var$Of] = b;
                    a[$c50b85309f892411$var$Pf] = d;
                    $c50b85309f892411$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c50b85309f892411$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c50b85309f892411$var$D("cancel", a);
                                $c50b85309f892411$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c50b85309f892411$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c50b85309f892411$var$lf.length; e++)$c50b85309f892411$var$D($c50b85309f892411$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c50b85309f892411$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c50b85309f892411$var$D("error", a);
                                $c50b85309f892411$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c50b85309f892411$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c50b85309f892411$var$Za(a, d);
                                e = $c50b85309f892411$var$Ya(a, d);
                                $c50b85309f892411$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c50b85309f892411$var$A({}, d, {
                                    value: void 0
                                });
                                $c50b85309f892411$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c50b85309f892411$var$hb(a, d);
                                e = $c50b85309f892411$var$gb(a, d);
                                $c50b85309f892411$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c50b85309f892411$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c50b85309f892411$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c50b85309f892411$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c50b85309f892411$var$ob(a, k) : "number" === typeof k && $c50b85309f892411$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c50b85309f892411$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c50b85309f892411$var$D("scroll", a) : null != k && $c50b85309f892411$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c50b85309f892411$var$Va(a);
                                $c50b85309f892411$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c50b85309f892411$var$Va(a);
                                $c50b85309f892411$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c50b85309f892411$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c50b85309f892411$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c50b85309f892411$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c50b85309f892411$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c50b85309f892411$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c50b85309f892411$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c50b85309f892411$var$p(166));
                c = $c50b85309f892411$var$xh($c50b85309f892411$var$wh.current);
                $c50b85309f892411$var$xh($c50b85309f892411$var$uh.current);
                if ($c50b85309f892411$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c50b85309f892411$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c50b85309f892411$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c50b85309f892411$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c50b85309f892411$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c50b85309f892411$var$Of] = b, b.stateNode = d;
            }
            $c50b85309f892411$var$S(b);
            return null;
        case 13:
            $c50b85309f892411$var$E($c50b85309f892411$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c50b85309f892411$var$I && null !== $c50b85309f892411$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c50b85309f892411$var$Hg(), $c50b85309f892411$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c50b85309f892411$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c50b85309f892411$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c50b85309f892411$var$p(317));
                        f[$c50b85309f892411$var$Of] = b;
                    } else $c50b85309f892411$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c50b85309f892411$var$S(b);
                    f = !1;
                } else null !== $c50b85309f892411$var$zg && ($c50b85309f892411$var$Fj($c50b85309f892411$var$zg), $c50b85309f892411$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c50b85309f892411$var$L.current & 1) ? 0 === $c50b85309f892411$var$T && ($c50b85309f892411$var$T = 3) : $c50b85309f892411$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c50b85309f892411$var$S(b);
            return null;
        case 4:
            return $c50b85309f892411$var$zh(), $c50b85309f892411$var$Aj(a, b), null === a && $c50b85309f892411$var$sf(b.stateNode.containerInfo), $c50b85309f892411$var$S(b), null;
        case 10:
            return $c50b85309f892411$var$ah(b.type._context), $c50b85309f892411$var$S(b), null;
        case 17:
            return $c50b85309f892411$var$Zf(b.type) && $c50b85309f892411$var$$f(), $c50b85309f892411$var$S(b), null;
        case 19:
            $c50b85309f892411$var$E($c50b85309f892411$var$L);
            f = b.memoizedState;
            if (null === f) return $c50b85309f892411$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c50b85309f892411$var$Dj(f, !1);
                else {
                    if (0 !== $c50b85309f892411$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c50b85309f892411$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c50b85309f892411$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c50b85309f892411$var$G($c50b85309f892411$var$L, $c50b85309f892411$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c50b85309f892411$var$B() > $c50b85309f892411$var$Gj && (b.flags |= 128, d = !0, $c50b85309f892411$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c50b85309f892411$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c50b85309f892411$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c50b85309f892411$var$I) return $c50b85309f892411$var$S(b), null;
                    } else 2 * $c50b85309f892411$var$B() - f.renderingStartTime > $c50b85309f892411$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $c50b85309f892411$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c50b85309f892411$var$B(), b.sibling = null, c = $c50b85309f892411$var$L.current, $c50b85309f892411$var$G($c50b85309f892411$var$L, d ? c & 1 | 2 : c & 1), b;
            $c50b85309f892411$var$S(b);
            return null;
        case 22:
        case 23:
            return $c50b85309f892411$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c50b85309f892411$var$fj & 1073741824) && ($c50b85309f892411$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c50b85309f892411$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c50b85309f892411$var$p(156, b.tag));
}
function $c50b85309f892411$var$Ij(a, b) {
    $c50b85309f892411$var$wg(b);
    switch(b.tag){
        case 1:
            return $c50b85309f892411$var$Zf(b.type) && $c50b85309f892411$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c50b85309f892411$var$zh(), $c50b85309f892411$var$E($c50b85309f892411$var$Wf), $c50b85309f892411$var$E($c50b85309f892411$var$H), $c50b85309f892411$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c50b85309f892411$var$Bh(b), null;
        case 13:
            $c50b85309f892411$var$E($c50b85309f892411$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c50b85309f892411$var$p(340));
                $c50b85309f892411$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c50b85309f892411$var$E($c50b85309f892411$var$L), null;
        case 4:
            return $c50b85309f892411$var$zh(), null;
        case 10:
            return $c50b85309f892411$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $c50b85309f892411$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c50b85309f892411$var$Jj = !1, $c50b85309f892411$var$U = !1, $c50b85309f892411$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $c50b85309f892411$var$V = null;
function $c50b85309f892411$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c50b85309f892411$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c50b85309f892411$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c50b85309f892411$var$W(a, b, d);
    }
}
var $c50b85309f892411$var$Nj = !1;
function $c50b85309f892411$var$Oj(a, b) {
    $c50b85309f892411$var$Cf = $c50b85309f892411$var$dd;
    a = $c50b85309f892411$var$Me();
    if ($c50b85309f892411$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c50b85309f892411$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c50b85309f892411$var$dd = !1;
    for($c50b85309f892411$var$V = b; null !== $c50b85309f892411$var$V;)if (b = $c50b85309f892411$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c50b85309f892411$var$V = a;
    else for(; null !== $c50b85309f892411$var$V;){
        b = $c50b85309f892411$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c50b85309f892411$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c50b85309f892411$var$p(163));
            }
        } catch (F) {
            $c50b85309f892411$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c50b85309f892411$var$V = a;
            break;
        }
        $c50b85309f892411$var$V = b.return;
    }
    n = $c50b85309f892411$var$Nj;
    $c50b85309f892411$var$Nj = !1;
    return n;
}
function $c50b85309f892411$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c50b85309f892411$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c50b85309f892411$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c50b85309f892411$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c50b85309f892411$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c50b85309f892411$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c50b85309f892411$var$Of], delete b[$c50b85309f892411$var$Pf], delete b[$c50b85309f892411$var$of], delete b[$c50b85309f892411$var$Qf], delete b[$c50b85309f892411$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c50b85309f892411$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c50b85309f892411$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c50b85309f892411$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c50b85309f892411$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c50b85309f892411$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c50b85309f892411$var$Vj(a, b, c), a = a.sibling; null !== a;)$c50b85309f892411$var$Vj(a, b, c), a = a.sibling;
}
function $c50b85309f892411$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c50b85309f892411$var$Wj(a, b, c), a = a.sibling; null !== a;)$c50b85309f892411$var$Wj(a, b, c), a = a.sibling;
}
var $c50b85309f892411$var$X = null, $c50b85309f892411$var$Xj = !1;
function $c50b85309f892411$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$c50b85309f892411$var$Zj(a, b, c), c = c.sibling;
}
function $c50b85309f892411$var$Zj(a, b, c) {
    if ($c50b85309f892411$var$lc && "function" === typeof $c50b85309f892411$var$lc.onCommitFiberUnmount) try {
        $c50b85309f892411$var$lc.onCommitFiberUnmount($c50b85309f892411$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c50b85309f892411$var$U || $c50b85309f892411$var$Lj(c, b);
        case 6:
            var d = $c50b85309f892411$var$X, e = $c50b85309f892411$var$Xj;
            $c50b85309f892411$var$X = null;
            $c50b85309f892411$var$Yj(a, b, c);
            $c50b85309f892411$var$X = d;
            $c50b85309f892411$var$Xj = e;
            null !== $c50b85309f892411$var$X && ($c50b85309f892411$var$Xj ? (a = $c50b85309f892411$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c50b85309f892411$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c50b85309f892411$var$X && ($c50b85309f892411$var$Xj ? (a = $c50b85309f892411$var$X, c = c.stateNode, 8 === a.nodeType ? $c50b85309f892411$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c50b85309f892411$var$Kf(a, c), $c50b85309f892411$var$bd(a)) : $c50b85309f892411$var$Kf($c50b85309f892411$var$X, c.stateNode));
            break;
        case 4:
            d = $c50b85309f892411$var$X;
            e = $c50b85309f892411$var$Xj;
            $c50b85309f892411$var$X = c.stateNode.containerInfo;
            $c50b85309f892411$var$Xj = !0;
            $c50b85309f892411$var$Yj(a, b, c);
            $c50b85309f892411$var$X = d;
            $c50b85309f892411$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c50b85309f892411$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c50b85309f892411$var$Mj(c, b, g) : 0 !== (f & 4) && $c50b85309f892411$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c50b85309f892411$var$Yj(a, b, c);
            break;
        case 1:
            if (!$c50b85309f892411$var$U && ($c50b85309f892411$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c50b85309f892411$var$W(c, b, h);
            }
            $c50b85309f892411$var$Yj(a, b, c);
            break;
        case 21:
            $c50b85309f892411$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c50b85309f892411$var$U = (d = $c50b85309f892411$var$U) || null !== c.memoizedState, $c50b85309f892411$var$Yj(a, b, c), $c50b85309f892411$var$U = d) : $c50b85309f892411$var$Yj(a, b, c);
            break;
        default:
            $c50b85309f892411$var$Yj(a, b, c);
    }
}
function $c50b85309f892411$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c50b85309f892411$var$Kj);
        b.forEach(function(b) {
            var d = $c50b85309f892411$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c50b85309f892411$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c50b85309f892411$var$X = h.stateNode;
                        $c50b85309f892411$var$Xj = !1;
                        break a;
                    case 3:
                        $c50b85309f892411$var$X = h.stateNode.containerInfo;
                        $c50b85309f892411$var$Xj = !0;
                        break a;
                    case 4:
                        $c50b85309f892411$var$X = h.stateNode.containerInfo;
                        $c50b85309f892411$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c50b85309f892411$var$X) throw Error($c50b85309f892411$var$p(160));
            $c50b85309f892411$var$Zj(f, g, e);
            $c50b85309f892411$var$X = null;
            $c50b85309f892411$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c50b85309f892411$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c50b85309f892411$var$dk(b, a), b = b.sibling;
}
function $c50b85309f892411$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c50b85309f892411$var$ck(b, a);
            $c50b85309f892411$var$ek(a);
            if (d & 4) {
                try {
                    $c50b85309f892411$var$Pj(3, a, a.return), $c50b85309f892411$var$Qj(3, a);
                } catch (t) {
                    $c50b85309f892411$var$W(a, a.return, t);
                }
                try {
                    $c50b85309f892411$var$Pj(5, a, a.return);
                } catch (t) {
                    $c50b85309f892411$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c50b85309f892411$var$ck(b, a);
            $c50b85309f892411$var$ek(a);
            d & 512 && null !== c && $c50b85309f892411$var$Lj(c, c.return);
            break;
        case 5:
            $c50b85309f892411$var$ck(b, a);
            $c50b85309f892411$var$ek(a);
            d & 512 && null !== c && $c50b85309f892411$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c50b85309f892411$var$ob(e, "");
                } catch (t) {
                    $c50b85309f892411$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c50b85309f892411$var$ab(e, f);
                    $c50b85309f892411$var$vb(h, g);
                    var l = $c50b85309f892411$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c50b85309f892411$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c50b85309f892411$var$nb(e, q) : "children" === m ? $c50b85309f892411$var$ob(e, q) : $c50b85309f892411$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c50b85309f892411$var$bb(e, f);
                            break;
                        case "textarea":
                            $c50b85309f892411$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c50b85309f892411$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c50b85309f892411$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c50b85309f892411$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c50b85309f892411$var$Pf] = f;
                } catch (t) {
                    $c50b85309f892411$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c50b85309f892411$var$ck(b, a);
            $c50b85309f892411$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c50b85309f892411$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c50b85309f892411$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c50b85309f892411$var$ck(b, a);
            $c50b85309f892411$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c50b85309f892411$var$bd(b.containerInfo);
            } catch (t) {
                $c50b85309f892411$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c50b85309f892411$var$ck(b, a);
            $c50b85309f892411$var$ek(a);
            break;
        case 13:
            $c50b85309f892411$var$ck(b, a);
            $c50b85309f892411$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c50b85309f892411$var$fk = $c50b85309f892411$var$B()));
            d & 4 && $c50b85309f892411$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c50b85309f892411$var$U = (l = $c50b85309f892411$var$U) || m, $c50b85309f892411$var$ck(b, a), $c50b85309f892411$var$U = l) : $c50b85309f892411$var$ck(b, a);
            $c50b85309f892411$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c50b85309f892411$var$V = a, m = a.child; null !== m;){
                    for(q = $c50b85309f892411$var$V = m; null !== $c50b85309f892411$var$V;){
                        r = $c50b85309f892411$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c50b85309f892411$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $c50b85309f892411$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c50b85309f892411$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c50b85309f892411$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c50b85309f892411$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c50b85309f892411$var$V = y) : $c50b85309f892411$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c50b85309f892411$var$rb("display", g));
                            } catch (t) {
                                $c50b85309f892411$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c50b85309f892411$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c50b85309f892411$var$ck(b, a);
            $c50b85309f892411$var$ek(a);
            d & 4 && $c50b85309f892411$var$ak(a);
            break;
        case 21:
            break;
        default:
            $c50b85309f892411$var$ck(b, a), $c50b85309f892411$var$ek(a);
    }
}
function $c50b85309f892411$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c50b85309f892411$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c50b85309f892411$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c50b85309f892411$var$ob(e, ""), d.flags &= -33);
                    var f = $c50b85309f892411$var$Uj(a);
                    $c50b85309f892411$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c50b85309f892411$var$Uj(a);
                    $c50b85309f892411$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($c50b85309f892411$var$p(161));
            }
        } catch (k) {
            $c50b85309f892411$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c50b85309f892411$var$hk(a, b, c) {
    $c50b85309f892411$var$V = a;
    $c50b85309f892411$var$ik(a, b, c);
}
function $c50b85309f892411$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c50b85309f892411$var$V;){
        var e = $c50b85309f892411$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c50b85309f892411$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c50b85309f892411$var$U;
                h = $c50b85309f892411$var$Jj;
                var l = $c50b85309f892411$var$U;
                $c50b85309f892411$var$Jj = g;
                if (($c50b85309f892411$var$U = k) && !l) for($c50b85309f892411$var$V = e; null !== $c50b85309f892411$var$V;)g = $c50b85309f892411$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c50b85309f892411$var$jk(e) : null !== k ? (k.return = g, $c50b85309f892411$var$V = k) : $c50b85309f892411$var$jk(e);
                for(; null !== f;)$c50b85309f892411$var$V = f, $c50b85309f892411$var$ik(f, b, c), f = f.sibling;
                $c50b85309f892411$var$V = e;
                $c50b85309f892411$var$Jj = h;
                $c50b85309f892411$var$U = l;
            }
            $c50b85309f892411$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c50b85309f892411$var$V = f) : $c50b85309f892411$var$kk(a, b, c);
    }
}
function $c50b85309f892411$var$kk(a) {
    for(; null !== $c50b85309f892411$var$V;){
        var b = $c50b85309f892411$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c50b85309f892411$var$U || $c50b85309f892411$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c50b85309f892411$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c50b85309f892411$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c50b85309f892411$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c50b85309f892411$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c50b85309f892411$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c50b85309f892411$var$p(163));
                }
                $c50b85309f892411$var$U || b.flags & 512 && $c50b85309f892411$var$Rj(b);
            } catch (r) {
                $c50b85309f892411$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c50b85309f892411$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c50b85309f892411$var$V = c;
            break;
        }
        $c50b85309f892411$var$V = b.return;
    }
}
function $c50b85309f892411$var$gk(a) {
    for(; null !== $c50b85309f892411$var$V;){
        var b = $c50b85309f892411$var$V;
        if (b === a) {
            $c50b85309f892411$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c50b85309f892411$var$V = c;
            break;
        }
        $c50b85309f892411$var$V = b.return;
    }
}
function $c50b85309f892411$var$jk(a) {
    for(; null !== $c50b85309f892411$var$V;){
        var b = $c50b85309f892411$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c50b85309f892411$var$Qj(4, b);
                    } catch (k) {
                        $c50b85309f892411$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c50b85309f892411$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c50b85309f892411$var$Rj(b);
                    } catch (k) {
                        $c50b85309f892411$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c50b85309f892411$var$Rj(b);
                    } catch (k) {
                        $c50b85309f892411$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c50b85309f892411$var$W(b, b.return, k);
        }
        if (b === a) {
            $c50b85309f892411$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c50b85309f892411$var$V = h;
            break;
        }
        $c50b85309f892411$var$V = b.return;
    }
}
var $c50b85309f892411$var$lk = Math.ceil, $c50b85309f892411$var$mk = $c50b85309f892411$var$ua.ReactCurrentDispatcher, $c50b85309f892411$var$nk = $c50b85309f892411$var$ua.ReactCurrentOwner, $c50b85309f892411$var$ok = $c50b85309f892411$var$ua.ReactCurrentBatchConfig, $c50b85309f892411$var$K = 0, $c50b85309f892411$var$Q = null, $c50b85309f892411$var$Y = null, $c50b85309f892411$var$Z = 0, $c50b85309f892411$var$fj = 0, $c50b85309f892411$var$ej = $c50b85309f892411$var$Uf(0), $c50b85309f892411$var$T = 0, $c50b85309f892411$var$pk = null, $c50b85309f892411$var$rh = 0, $c50b85309f892411$var$qk = 0, $c50b85309f892411$var$rk = 0, $c50b85309f892411$var$sk = null, $c50b85309f892411$var$tk = null, $c50b85309f892411$var$fk = 0, $c50b85309f892411$var$Gj = Infinity, $c50b85309f892411$var$uk = null, $c50b85309f892411$var$Oi = !1, $c50b85309f892411$var$Pi = null, $c50b85309f892411$var$Ri = null, $c50b85309f892411$var$vk = !1, $c50b85309f892411$var$wk = null, $c50b85309f892411$var$xk = 0, $c50b85309f892411$var$yk = 0, $c50b85309f892411$var$zk = null, $c50b85309f892411$var$Ak = -1, $c50b85309f892411$var$Bk = 0;
function $c50b85309f892411$var$R() {
    return 0 !== ($c50b85309f892411$var$K & 6) ? $c50b85309f892411$var$B() : -1 !== $c50b85309f892411$var$Ak ? $c50b85309f892411$var$Ak : $c50b85309f892411$var$Ak = $c50b85309f892411$var$B();
}
function $c50b85309f892411$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c50b85309f892411$var$K & 2) && 0 !== $c50b85309f892411$var$Z) return $c50b85309f892411$var$Z & -$c50b85309f892411$var$Z;
    if (null !== $c50b85309f892411$var$Kg.transition) return 0 === $c50b85309f892411$var$Bk && ($c50b85309f892411$var$Bk = $c50b85309f892411$var$yc()), $c50b85309f892411$var$Bk;
    a = $c50b85309f892411$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c50b85309f892411$var$jd(a.type);
    return a;
}
function $c50b85309f892411$var$gi(a, b, c, d) {
    if (50 < $c50b85309f892411$var$yk) throw $c50b85309f892411$var$yk = 0, $c50b85309f892411$var$zk = null, Error($c50b85309f892411$var$p(185));
    $c50b85309f892411$var$Ac(a, c, d);
    if (0 === ($c50b85309f892411$var$K & 2) || a !== $c50b85309f892411$var$Q) a === $c50b85309f892411$var$Q && (0 === ($c50b85309f892411$var$K & 2) && ($c50b85309f892411$var$qk |= c), 4 === $c50b85309f892411$var$T && $c50b85309f892411$var$Ck(a, $c50b85309f892411$var$Z)), $c50b85309f892411$var$Dk(a, d), 1 === c && 0 === $c50b85309f892411$var$K && 0 === (b.mode & 1) && ($c50b85309f892411$var$Gj = $c50b85309f892411$var$B() + 500, $c50b85309f892411$var$fg && $c50b85309f892411$var$jg());
}
function $c50b85309f892411$var$Dk(a, b) {
    var c = a.callbackNode;
    $c50b85309f892411$var$wc(a, b);
    var d = $c50b85309f892411$var$uc(a, a === $c50b85309f892411$var$Q ? $c50b85309f892411$var$Z : 0);
    if (0 === d) null !== c && $c50b85309f892411$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c50b85309f892411$var$bc(c);
        if (1 === b) 0 === a.tag ? $c50b85309f892411$var$ig($c50b85309f892411$var$Ek.bind(null, a)) : $c50b85309f892411$var$hg($c50b85309f892411$var$Ek.bind(null, a)), $c50b85309f892411$var$Jf(function() {
            0 === ($c50b85309f892411$var$K & 6) && $c50b85309f892411$var$jg();
        }), c = null;
        else {
            switch($c50b85309f892411$var$Dc(d)){
                case 1:
                    c = $c50b85309f892411$var$fc;
                    break;
                case 4:
                    c = $c50b85309f892411$var$gc;
                    break;
                case 16:
                    c = $c50b85309f892411$var$hc;
                    break;
                case 536870912:
                    c = $c50b85309f892411$var$jc;
                    break;
                default:
                    c = $c50b85309f892411$var$hc;
            }
            c = $c50b85309f892411$var$Fk(c, $c50b85309f892411$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c50b85309f892411$var$Gk(a, b) {
    $c50b85309f892411$var$Ak = -1;
    $c50b85309f892411$var$Bk = 0;
    if (0 !== ($c50b85309f892411$var$K & 6)) throw Error($c50b85309f892411$var$p(327));
    var c = a.callbackNode;
    if ($c50b85309f892411$var$Hk() && a.callbackNode !== c) return null;
    var d = $c50b85309f892411$var$uc(a, a === $c50b85309f892411$var$Q ? $c50b85309f892411$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c50b85309f892411$var$Ik(a, d);
    else {
        b = d;
        var e = $c50b85309f892411$var$K;
        $c50b85309f892411$var$K |= 2;
        var f = $c50b85309f892411$var$Jk();
        if ($c50b85309f892411$var$Q !== a || $c50b85309f892411$var$Z !== b) $c50b85309f892411$var$uk = null, $c50b85309f892411$var$Gj = $c50b85309f892411$var$B() + 500, $c50b85309f892411$var$Kk(a, b);
        for(;;)try {
            $c50b85309f892411$var$Lk();
            break;
        } catch (h) {
            $c50b85309f892411$var$Mk(a, h);
        }
        $c50b85309f892411$var$$g();
        $c50b85309f892411$var$mk.current = f;
        $c50b85309f892411$var$K = e;
        null !== $c50b85309f892411$var$Y ? b = 0 : ($c50b85309f892411$var$Q = null, $c50b85309f892411$var$Z = 0, b = $c50b85309f892411$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c50b85309f892411$var$xc(a), 0 !== e && (d = e, b = $c50b85309f892411$var$Nk(a, e)));
        if (1 === b) throw c = $c50b85309f892411$var$pk, $c50b85309f892411$var$Kk(a, 0), $c50b85309f892411$var$Ck(a, d), $c50b85309f892411$var$Dk(a, $c50b85309f892411$var$B()), c;
        if (6 === b) $c50b85309f892411$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c50b85309f892411$var$Ok(e) && (b = $c50b85309f892411$var$Ik(a, d), 2 === b && (f = $c50b85309f892411$var$xc(a), 0 !== f && (d = f, b = $c50b85309f892411$var$Nk(a, f))), 1 === b)) throw c = $c50b85309f892411$var$pk, $c50b85309f892411$var$Kk(a, 0), $c50b85309f892411$var$Ck(a, d), $c50b85309f892411$var$Dk(a, $c50b85309f892411$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c50b85309f892411$var$p(345));
                case 2:
                    $c50b85309f892411$var$Pk(a, $c50b85309f892411$var$tk, $c50b85309f892411$var$uk);
                    break;
                case 3:
                    $c50b85309f892411$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $c50b85309f892411$var$fk + 500 - $c50b85309f892411$var$B(), 10 < b)) {
                        if (0 !== $c50b85309f892411$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c50b85309f892411$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c50b85309f892411$var$Ff($c50b85309f892411$var$Pk.bind(null, a, $c50b85309f892411$var$tk, $c50b85309f892411$var$uk), b);
                        break;
                    }
                    $c50b85309f892411$var$Pk(a, $c50b85309f892411$var$tk, $c50b85309f892411$var$uk);
                    break;
                case 4:
                    $c50b85309f892411$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c50b85309f892411$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c50b85309f892411$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c50b85309f892411$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c50b85309f892411$var$Ff($c50b85309f892411$var$Pk.bind(null, a, $c50b85309f892411$var$tk, $c50b85309f892411$var$uk), d);
                        break;
                    }
                    $c50b85309f892411$var$Pk(a, $c50b85309f892411$var$tk, $c50b85309f892411$var$uk);
                    break;
                case 5:
                    $c50b85309f892411$var$Pk(a, $c50b85309f892411$var$tk, $c50b85309f892411$var$uk);
                    break;
                default:
                    throw Error($c50b85309f892411$var$p(329));
            }
        }
    }
    $c50b85309f892411$var$Dk(a, $c50b85309f892411$var$B());
    return a.callbackNode === c ? $c50b85309f892411$var$Gk.bind(null, a) : null;
}
function $c50b85309f892411$var$Nk(a, b) {
    var c = $c50b85309f892411$var$sk;
    a.current.memoizedState.isDehydrated && ($c50b85309f892411$var$Kk(a, b).flags |= 256);
    a = $c50b85309f892411$var$Ik(a, b);
    2 !== a && (b = $c50b85309f892411$var$tk, $c50b85309f892411$var$tk = c, null !== b && $c50b85309f892411$var$Fj(b));
    return a;
}
function $c50b85309f892411$var$Fj(a) {
    null === $c50b85309f892411$var$tk ? $c50b85309f892411$var$tk = a : $c50b85309f892411$var$tk.push.apply($c50b85309f892411$var$tk, a);
}
function $c50b85309f892411$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c50b85309f892411$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c50b85309f892411$var$Ck(a, b) {
    b &= ~$c50b85309f892411$var$rk;
    b &= ~$c50b85309f892411$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c50b85309f892411$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c50b85309f892411$var$Ek(a) {
    if (0 !== ($c50b85309f892411$var$K & 6)) throw Error($c50b85309f892411$var$p(327));
    $c50b85309f892411$var$Hk();
    var b = $c50b85309f892411$var$uc(a, 0);
    if (0 === (b & 1)) return $c50b85309f892411$var$Dk(a, $c50b85309f892411$var$B()), null;
    var c = $c50b85309f892411$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c50b85309f892411$var$xc(a);
        0 !== d && (b = d, c = $c50b85309f892411$var$Nk(a, d));
    }
    if (1 === c) throw c = $c50b85309f892411$var$pk, $c50b85309f892411$var$Kk(a, 0), $c50b85309f892411$var$Ck(a, b), $c50b85309f892411$var$Dk(a, $c50b85309f892411$var$B()), c;
    if (6 === c) throw Error($c50b85309f892411$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c50b85309f892411$var$Pk(a, $c50b85309f892411$var$tk, $c50b85309f892411$var$uk);
    $c50b85309f892411$var$Dk(a, $c50b85309f892411$var$B());
    return null;
}
function $c50b85309f892411$var$Qk(a, b) {
    var c = $c50b85309f892411$var$K;
    $c50b85309f892411$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c50b85309f892411$var$K = c, 0 === $c50b85309f892411$var$K && ($c50b85309f892411$var$Gj = $c50b85309f892411$var$B() + 500, $c50b85309f892411$var$fg && $c50b85309f892411$var$jg());
    }
}
function $c50b85309f892411$var$Rk(a) {
    null !== $c50b85309f892411$var$wk && 0 === $c50b85309f892411$var$wk.tag && 0 === ($c50b85309f892411$var$K & 6) && $c50b85309f892411$var$Hk();
    var b = $c50b85309f892411$var$K;
    $c50b85309f892411$var$K |= 1;
    var c = $c50b85309f892411$var$ok.transition, d = $c50b85309f892411$var$C;
    try {
        if ($c50b85309f892411$var$ok.transition = null, $c50b85309f892411$var$C = 1, a) return a();
    } finally{
        $c50b85309f892411$var$C = d, $c50b85309f892411$var$ok.transition = c, $c50b85309f892411$var$K = b, 0 === ($c50b85309f892411$var$K & 6) && $c50b85309f892411$var$jg();
    }
}
function $c50b85309f892411$var$Hj() {
    $c50b85309f892411$var$fj = $c50b85309f892411$var$ej.current;
    $c50b85309f892411$var$E($c50b85309f892411$var$ej);
}
function $c50b85309f892411$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c50b85309f892411$var$Gf(c));
    if (null !== $c50b85309f892411$var$Y) for(c = $c50b85309f892411$var$Y.return; null !== c;){
        var d = c;
        $c50b85309f892411$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c50b85309f892411$var$$f();
                break;
            case 3:
                $c50b85309f892411$var$zh();
                $c50b85309f892411$var$E($c50b85309f892411$var$Wf);
                $c50b85309f892411$var$E($c50b85309f892411$var$H);
                $c50b85309f892411$var$Eh();
                break;
            case 5:
                $c50b85309f892411$var$Bh(d);
                break;
            case 4:
                $c50b85309f892411$var$zh();
                break;
            case 13:
                $c50b85309f892411$var$E($c50b85309f892411$var$L);
                break;
            case 19:
                $c50b85309f892411$var$E($c50b85309f892411$var$L);
                break;
            case 10:
                $c50b85309f892411$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $c50b85309f892411$var$Hj();
        }
        c = c.return;
    }
    $c50b85309f892411$var$Q = a;
    $c50b85309f892411$var$Y = a = $c50b85309f892411$var$Pg(a.current, null);
    $c50b85309f892411$var$Z = $c50b85309f892411$var$fj = b;
    $c50b85309f892411$var$T = 0;
    $c50b85309f892411$var$pk = null;
    $c50b85309f892411$var$rk = $c50b85309f892411$var$qk = $c50b85309f892411$var$rh = 0;
    $c50b85309f892411$var$tk = $c50b85309f892411$var$sk = null;
    if (null !== $c50b85309f892411$var$fh) {
        for(b = 0; b < $c50b85309f892411$var$fh.length; b++)if (c = $c50b85309f892411$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c50b85309f892411$var$fh = null;
    }
    return a;
}
function $c50b85309f892411$var$Mk(a, b) {
    do {
        var c = $c50b85309f892411$var$Y;
        try {
            $c50b85309f892411$var$$g();
            $c50b85309f892411$var$Fh.current = $c50b85309f892411$var$Rh;
            if ($c50b85309f892411$var$Ih) {
                for(var d = $c50b85309f892411$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c50b85309f892411$var$Ih = !1;
            }
            $c50b85309f892411$var$Hh = 0;
            $c50b85309f892411$var$O = $c50b85309f892411$var$N = $c50b85309f892411$var$M = null;
            $c50b85309f892411$var$Jh = !1;
            $c50b85309f892411$var$Kh = 0;
            $c50b85309f892411$var$nk.current = null;
            if (null === c || null === c.return) {
                $c50b85309f892411$var$T = 1;
                $c50b85309f892411$var$pk = b;
                $c50b85309f892411$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c50b85309f892411$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c50b85309f892411$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c50b85309f892411$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $c50b85309f892411$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c50b85309f892411$var$Si(f, l, b);
                            $c50b85309f892411$var$tj();
                            break a;
                        }
                        k = Error($c50b85309f892411$var$p(426));
                    }
                } else if ($c50b85309f892411$var$I && h.mode & 1) {
                    var J = $c50b85309f892411$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c50b85309f892411$var$Vi(J, g, h, f, b);
                        $c50b85309f892411$var$Jg($c50b85309f892411$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $c50b85309f892411$var$Ji(k, h);
                4 !== $c50b85309f892411$var$T && ($c50b85309f892411$var$T = 2);
                null === $c50b85309f892411$var$sk ? $c50b85309f892411$var$sk = [
                    f
                ] : $c50b85309f892411$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c50b85309f892411$var$Ni(f, k, b);
                            $c50b85309f892411$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c50b85309f892411$var$Ri || !$c50b85309f892411$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c50b85309f892411$var$Qi(f, h, b);
                                $c50b85309f892411$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c50b85309f892411$var$Sk(c);
        } catch (na) {
            b = na;
            $c50b85309f892411$var$Y === c && null !== c && ($c50b85309f892411$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c50b85309f892411$var$Jk() {
    var a = $c50b85309f892411$var$mk.current;
    $c50b85309f892411$var$mk.current = $c50b85309f892411$var$Rh;
    return null === a ? $c50b85309f892411$var$Rh : a;
}
function $c50b85309f892411$var$tj() {
    if (0 === $c50b85309f892411$var$T || 3 === $c50b85309f892411$var$T || 2 === $c50b85309f892411$var$T) $c50b85309f892411$var$T = 4;
    null === $c50b85309f892411$var$Q || 0 === ($c50b85309f892411$var$rh & 268435455) && 0 === ($c50b85309f892411$var$qk & 268435455) || $c50b85309f892411$var$Ck($c50b85309f892411$var$Q, $c50b85309f892411$var$Z);
}
function $c50b85309f892411$var$Ik(a, b) {
    var c = $c50b85309f892411$var$K;
    $c50b85309f892411$var$K |= 2;
    var d = $c50b85309f892411$var$Jk();
    if ($c50b85309f892411$var$Q !== a || $c50b85309f892411$var$Z !== b) $c50b85309f892411$var$uk = null, $c50b85309f892411$var$Kk(a, b);
    for(;;)try {
        $c50b85309f892411$var$Tk();
        break;
    } catch (e) {
        $c50b85309f892411$var$Mk(a, e);
    }
    $c50b85309f892411$var$$g();
    $c50b85309f892411$var$K = c;
    $c50b85309f892411$var$mk.current = d;
    if (null !== $c50b85309f892411$var$Y) throw Error($c50b85309f892411$var$p(261));
    $c50b85309f892411$var$Q = null;
    $c50b85309f892411$var$Z = 0;
    return $c50b85309f892411$var$T;
}
function $c50b85309f892411$var$Tk() {
    for(; null !== $c50b85309f892411$var$Y;)$c50b85309f892411$var$Uk($c50b85309f892411$var$Y);
}
function $c50b85309f892411$var$Lk() {
    for(; null !== $c50b85309f892411$var$Y && !$c50b85309f892411$var$cc();)$c50b85309f892411$var$Uk($c50b85309f892411$var$Y);
}
function $c50b85309f892411$var$Uk(a) {
    var b = $c50b85309f892411$var$Vk(a.alternate, a, $c50b85309f892411$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c50b85309f892411$var$Sk(a) : $c50b85309f892411$var$Y = b;
    $c50b85309f892411$var$nk.current = null;
}
function $c50b85309f892411$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c50b85309f892411$var$Ej(c, b, $c50b85309f892411$var$fj), null !== c) {
                $c50b85309f892411$var$Y = c;
                return;
            }
        } else {
            c = $c50b85309f892411$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c50b85309f892411$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c50b85309f892411$var$T = 6;
                $c50b85309f892411$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c50b85309f892411$var$Y = b;
            return;
        }
        $c50b85309f892411$var$Y = b = a;
    }while (null !== b);
    0 === $c50b85309f892411$var$T && ($c50b85309f892411$var$T = 5);
}
function $c50b85309f892411$var$Pk(a, b, c) {
    var d = $c50b85309f892411$var$C, e = $c50b85309f892411$var$ok.transition;
    try {
        $c50b85309f892411$var$ok.transition = null, $c50b85309f892411$var$C = 1, $c50b85309f892411$var$Wk(a, b, c, d);
    } finally{
        $c50b85309f892411$var$ok.transition = e, $c50b85309f892411$var$C = d;
    }
    return null;
}
function $c50b85309f892411$var$Wk(a, b, c, d) {
    do $c50b85309f892411$var$Hk();
    while (null !== $c50b85309f892411$var$wk);
    if (0 !== ($c50b85309f892411$var$K & 6)) throw Error($c50b85309f892411$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c50b85309f892411$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c50b85309f892411$var$Bc(a, f);
    a === $c50b85309f892411$var$Q && ($c50b85309f892411$var$Y = $c50b85309f892411$var$Q = null, $c50b85309f892411$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c50b85309f892411$var$vk || ($c50b85309f892411$var$vk = !0, $c50b85309f892411$var$Fk($c50b85309f892411$var$hc, function() {
        $c50b85309f892411$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c50b85309f892411$var$ok.transition;
        $c50b85309f892411$var$ok.transition = null;
        var g = $c50b85309f892411$var$C;
        $c50b85309f892411$var$C = 1;
        var h = $c50b85309f892411$var$K;
        $c50b85309f892411$var$K |= 4;
        $c50b85309f892411$var$nk.current = null;
        $c50b85309f892411$var$Oj(a, c);
        $c50b85309f892411$var$dk(c, a);
        $c50b85309f892411$var$Oe($c50b85309f892411$var$Df);
        $c50b85309f892411$var$dd = !!$c50b85309f892411$var$Cf;
        $c50b85309f892411$var$Df = $c50b85309f892411$var$Cf = null;
        a.current = c;
        $c50b85309f892411$var$hk(c, a, e);
        $c50b85309f892411$var$dc();
        $c50b85309f892411$var$K = h;
        $c50b85309f892411$var$C = g;
        $c50b85309f892411$var$ok.transition = f;
    } else a.current = c;
    $c50b85309f892411$var$vk && ($c50b85309f892411$var$vk = !1, $c50b85309f892411$var$wk = a, $c50b85309f892411$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($c50b85309f892411$var$Ri = null);
    $c50b85309f892411$var$mc(c.stateNode, d);
    $c50b85309f892411$var$Dk(a, $c50b85309f892411$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c50b85309f892411$var$Oi) throw $c50b85309f892411$var$Oi = !1, a = $c50b85309f892411$var$Pi, $c50b85309f892411$var$Pi = null, a;
    0 !== ($c50b85309f892411$var$xk & 1) && 0 !== a.tag && $c50b85309f892411$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c50b85309f892411$var$zk ? $c50b85309f892411$var$yk++ : ($c50b85309f892411$var$yk = 0, $c50b85309f892411$var$zk = a) : $c50b85309f892411$var$yk = 0;
    $c50b85309f892411$var$jg();
    return null;
}
function $c50b85309f892411$var$Hk() {
    if (null !== $c50b85309f892411$var$wk) {
        var a = $c50b85309f892411$var$Dc($c50b85309f892411$var$xk), b = $c50b85309f892411$var$ok.transition, c = $c50b85309f892411$var$C;
        try {
            $c50b85309f892411$var$ok.transition = null;
            $c50b85309f892411$var$C = 16 > a ? 16 : a;
            if (null === $c50b85309f892411$var$wk) var d = !1;
            else {
                a = $c50b85309f892411$var$wk;
                $c50b85309f892411$var$wk = null;
                $c50b85309f892411$var$xk = 0;
                if (0 !== ($c50b85309f892411$var$K & 6)) throw Error($c50b85309f892411$var$p(331));
                var e = $c50b85309f892411$var$K;
                $c50b85309f892411$var$K |= 4;
                for($c50b85309f892411$var$V = a.current; null !== $c50b85309f892411$var$V;){
                    var f = $c50b85309f892411$var$V, g = f.child;
                    if (0 !== ($c50b85309f892411$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c50b85309f892411$var$V = l; null !== $c50b85309f892411$var$V;){
                                    var m = $c50b85309f892411$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c50b85309f892411$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c50b85309f892411$var$V = q;
                                    else for(; null !== $c50b85309f892411$var$V;){
                                        m = $c50b85309f892411$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c50b85309f892411$var$Sj(m);
                                        if (m === l) {
                                            $c50b85309f892411$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c50b85309f892411$var$V = r;
                                            break;
                                        }
                                        $c50b85309f892411$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c50b85309f892411$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c50b85309f892411$var$V = g;
                    else b: for(; null !== $c50b85309f892411$var$V;){
                        f = $c50b85309f892411$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c50b85309f892411$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c50b85309f892411$var$V = x;
                            break b;
                        }
                        $c50b85309f892411$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c50b85309f892411$var$V = w; null !== $c50b85309f892411$var$V;){
                    g = $c50b85309f892411$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c50b85309f892411$var$V = u;
                    else b: for(g = w; null !== $c50b85309f892411$var$V;){
                        h = $c50b85309f892411$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c50b85309f892411$var$Qj(9, h);
                            }
                        } catch (na) {
                            $c50b85309f892411$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c50b85309f892411$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c50b85309f892411$var$V = F;
                            break b;
                        }
                        $c50b85309f892411$var$V = h.return;
                    }
                }
                $c50b85309f892411$var$K = e;
                $c50b85309f892411$var$jg();
                if ($c50b85309f892411$var$lc && "function" === typeof $c50b85309f892411$var$lc.onPostCommitFiberRoot) try {
                    $c50b85309f892411$var$lc.onPostCommitFiberRoot($c50b85309f892411$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c50b85309f892411$var$C = c, $c50b85309f892411$var$ok.transition = b;
        }
    }
    return !1;
}
function $c50b85309f892411$var$Xk(a, b, c) {
    b = $c50b85309f892411$var$Ji(c, b);
    b = $c50b85309f892411$var$Ni(a, b, 1);
    a = $c50b85309f892411$var$nh(a, b, 1);
    b = $c50b85309f892411$var$R();
    null !== a && ($c50b85309f892411$var$Ac(a, 1, b), $c50b85309f892411$var$Dk(a, b));
}
function $c50b85309f892411$var$W(a, b, c) {
    if (3 === a.tag) $c50b85309f892411$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c50b85309f892411$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c50b85309f892411$var$Ri || !$c50b85309f892411$var$Ri.has(d))) {
                a = $c50b85309f892411$var$Ji(c, a);
                a = $c50b85309f892411$var$Qi(b, a, 1);
                b = $c50b85309f892411$var$nh(b, a, 1);
                a = $c50b85309f892411$var$R();
                null !== b && ($c50b85309f892411$var$Ac(b, 1, a), $c50b85309f892411$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c50b85309f892411$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c50b85309f892411$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $c50b85309f892411$var$Q === a && ($c50b85309f892411$var$Z & c) === c && (4 === $c50b85309f892411$var$T || 3 === $c50b85309f892411$var$T && ($c50b85309f892411$var$Z & 130023424) === $c50b85309f892411$var$Z && 500 > $c50b85309f892411$var$B() - $c50b85309f892411$var$fk ? $c50b85309f892411$var$Kk(a, 0) : $c50b85309f892411$var$rk |= c);
    $c50b85309f892411$var$Dk(a, b);
}
function $c50b85309f892411$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c50b85309f892411$var$sc, $c50b85309f892411$var$sc <<= 1, 0 === ($c50b85309f892411$var$sc & 130023424) && ($c50b85309f892411$var$sc = 4194304)));
    var c = $c50b85309f892411$var$R();
    a = $c50b85309f892411$var$ih(a, b);
    null !== a && ($c50b85309f892411$var$Ac(a, b, c), $c50b85309f892411$var$Dk(a, c));
}
function $c50b85309f892411$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c50b85309f892411$var$Yk(a, c);
}
function $c50b85309f892411$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c50b85309f892411$var$p(314));
    }
    null !== d && d.delete(b);
    $c50b85309f892411$var$Yk(a, c);
}
var $c50b85309f892411$var$Vk;
$c50b85309f892411$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c50b85309f892411$var$Wf.current) $c50b85309f892411$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c50b85309f892411$var$dh = !1, $c50b85309f892411$var$yj(a, b, c);
            $c50b85309f892411$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c50b85309f892411$var$dh = !1, $c50b85309f892411$var$I && 0 !== (b.flags & 1048576) && $c50b85309f892411$var$ug(b, $c50b85309f892411$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c50b85309f892411$var$ij(a, b);
            a = b.pendingProps;
            var e = $c50b85309f892411$var$Yf(b, $c50b85309f892411$var$H.current);
            $c50b85309f892411$var$ch(b, c);
            e = $c50b85309f892411$var$Nh(null, b, d, a, e, c);
            var f = $c50b85309f892411$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c50b85309f892411$var$Zf(d) ? (f = !0, $c50b85309f892411$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c50b85309f892411$var$kh(b), e.updater = $c50b85309f892411$var$Ei, b.stateNode = e, e._reactInternals = b, $c50b85309f892411$var$Ii(b, d, a, c), b = $c50b85309f892411$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $c50b85309f892411$var$I && f && $c50b85309f892411$var$vg(b), $c50b85309f892411$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c50b85309f892411$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c50b85309f892411$var$Zk(d);
                a = $c50b85309f892411$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $c50b85309f892411$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c50b85309f892411$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c50b85309f892411$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c50b85309f892411$var$$i(null, b, d, $c50b85309f892411$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($c50b85309f892411$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c50b85309f892411$var$Ci(d, e), $c50b85309f892411$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c50b85309f892411$var$Ci(d, e), $c50b85309f892411$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $c50b85309f892411$var$kj(b);
                if (null === a) throw Error($c50b85309f892411$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c50b85309f892411$var$lh(a, b);
                $c50b85309f892411$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c50b85309f892411$var$Ji(Error($c50b85309f892411$var$p(423)), b);
                        b = $c50b85309f892411$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c50b85309f892411$var$Ji(Error($c50b85309f892411$var$p(424)), b);
                        b = $c50b85309f892411$var$lj(a, b, d, c, e);
                        break a;
                    } else for($c50b85309f892411$var$yg = $c50b85309f892411$var$Lf(b.stateNode.containerInfo.firstChild), $c50b85309f892411$var$xg = b, $c50b85309f892411$var$I = !0, $c50b85309f892411$var$zg = null, c = $c50b85309f892411$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c50b85309f892411$var$Ig();
                    if (d === e) {
                        b = $c50b85309f892411$var$Zi(a, b, c);
                        break a;
                    }
                    $c50b85309f892411$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c50b85309f892411$var$Ah(b), null === a && $c50b85309f892411$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c50b85309f892411$var$Ef(d, e) ? g = null : null !== f && $c50b85309f892411$var$Ef(d, f) && (b.flags |= 32), $c50b85309f892411$var$gj(a, b), $c50b85309f892411$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $c50b85309f892411$var$Eg(b), null;
        case 13:
            return $c50b85309f892411$var$oj(a, b, c);
        case 4:
            return $c50b85309f892411$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c50b85309f892411$var$Ug(b, null, d, c) : $c50b85309f892411$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c50b85309f892411$var$Ci(d, e), $c50b85309f892411$var$Yi(a, b, d, e, c);
        case 7:
            return $c50b85309f892411$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c50b85309f892411$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c50b85309f892411$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c50b85309f892411$var$G($c50b85309f892411$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c50b85309f892411$var$He(f.value, g)) {
                        if (f.children === e.children && !$c50b85309f892411$var$Wf.current) {
                            b = $c50b85309f892411$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c50b85309f892411$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c50b85309f892411$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c50b85309f892411$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c50b85309f892411$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c50b85309f892411$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c50b85309f892411$var$ch(b, c), e = $c50b85309f892411$var$eh(e), d = d(e), b.flags |= 1, $c50b85309f892411$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c50b85309f892411$var$Ci(d, b.pendingProps), e = $c50b85309f892411$var$Ci(d.type, e), $c50b85309f892411$var$$i(a, b, d, e, c);
        case 15:
            return $c50b85309f892411$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c50b85309f892411$var$Ci(d, e), $c50b85309f892411$var$ij(a, b), b.tag = 1, $c50b85309f892411$var$Zf(d) ? (a = !0, $c50b85309f892411$var$cg(b)) : a = !1, $c50b85309f892411$var$ch(b, c), $c50b85309f892411$var$Gi(b, d, e), $c50b85309f892411$var$Ii(b, d, e, c), $c50b85309f892411$var$jj(null, b, d, !0, a, c);
        case 19:
            return $c50b85309f892411$var$xj(a, b, c);
        case 22:
            return $c50b85309f892411$var$dj(a, b, c);
    }
    throw Error($c50b85309f892411$var$p(156, b.tag));
};
function $c50b85309f892411$var$Fk(a, b) {
    return $c50b85309f892411$var$ac(a, b);
}
function $c50b85309f892411$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c50b85309f892411$var$Bg(a, b, c, d) {
    return new $c50b85309f892411$var$$k(a, b, c, d);
}
function $c50b85309f892411$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c50b85309f892411$var$Zk(a) {
    if ("function" === typeof a) return $c50b85309f892411$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c50b85309f892411$var$Da) return 11;
        if (a === $c50b85309f892411$var$Ga) return 14;
    }
    return 2;
}
function $c50b85309f892411$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $c50b85309f892411$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c50b85309f892411$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c50b85309f892411$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c50b85309f892411$var$ya:
            return $c50b85309f892411$var$Tg(c.children, e, f, b);
        case $c50b85309f892411$var$za:
            g = 8;
            e |= 8;
            break;
        case $c50b85309f892411$var$Aa:
            return a = $c50b85309f892411$var$Bg(12, c, b, e | 2), a.elementType = $c50b85309f892411$var$Aa, a.lanes = f, a;
        case $c50b85309f892411$var$Ea:
            return a = $c50b85309f892411$var$Bg(13, c, b, e), a.elementType = $c50b85309f892411$var$Ea, a.lanes = f, a;
        case $c50b85309f892411$var$Fa:
            return a = $c50b85309f892411$var$Bg(19, c, b, e), a.elementType = $c50b85309f892411$var$Fa, a.lanes = f, a;
        case $c50b85309f892411$var$Ia:
            return $c50b85309f892411$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c50b85309f892411$var$Ba:
                    g = 10;
                    break a;
                case $c50b85309f892411$var$Ca:
                    g = 9;
                    break a;
                case $c50b85309f892411$var$Da:
                    g = 11;
                    break a;
                case $c50b85309f892411$var$Ga:
                    g = 14;
                    break a;
                case $c50b85309f892411$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c50b85309f892411$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c50b85309f892411$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c50b85309f892411$var$Tg(a, b, c, d) {
    a = $c50b85309f892411$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c50b85309f892411$var$pj(a, b, c, d) {
    a = $c50b85309f892411$var$Bg(22, a, d, b);
    a.elementType = $c50b85309f892411$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c50b85309f892411$var$Qg(a, b, c) {
    a = $c50b85309f892411$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c50b85309f892411$var$Sg(a, b, c) {
    b = $c50b85309f892411$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c50b85309f892411$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c50b85309f892411$var$zc(0);
    this.expirationTimes = $c50b85309f892411$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c50b85309f892411$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c50b85309f892411$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $c50b85309f892411$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c50b85309f892411$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c50b85309f892411$var$kh(f);
    return a;
}
function $c50b85309f892411$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c50b85309f892411$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c50b85309f892411$var$dl(a) {
    if (!a) return $c50b85309f892411$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c50b85309f892411$var$Vb(a) !== a || 1 !== a.tag) throw Error($c50b85309f892411$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c50b85309f892411$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c50b85309f892411$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c50b85309f892411$var$Zf(c)) return $c50b85309f892411$var$bg(a, c, b);
    }
    return b;
}
function $c50b85309f892411$var$el(a, b, c, d, e, f, g, h, k) {
    a = $c50b85309f892411$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $c50b85309f892411$var$dl(null);
    c = a.current;
    d = $c50b85309f892411$var$R();
    e = $c50b85309f892411$var$yi(c);
    f = $c50b85309f892411$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c50b85309f892411$var$nh(c, f, e);
    a.current.lanes = e;
    $c50b85309f892411$var$Ac(a, e, d);
    $c50b85309f892411$var$Dk(a, d);
    return a;
}
function $c50b85309f892411$var$fl(a, b, c, d) {
    var e = b.current, f = $c50b85309f892411$var$R(), g = $c50b85309f892411$var$yi(e);
    c = $c50b85309f892411$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c50b85309f892411$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c50b85309f892411$var$nh(e, b, g);
    null !== a && ($c50b85309f892411$var$gi(a, e, g, f), $c50b85309f892411$var$oh(a, e, g));
    return g;
}
function $c50b85309f892411$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c50b85309f892411$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c50b85309f892411$var$il(a, b) {
    $c50b85309f892411$var$hl(a, b);
    (a = a.alternate) && $c50b85309f892411$var$hl(a, b);
}
function $c50b85309f892411$var$jl() {
    return null;
}
var $c50b85309f892411$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c50b85309f892411$var$ll(a) {
    this._internalRoot = a;
}
$c50b85309f892411$var$ml.prototype.render = $c50b85309f892411$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c50b85309f892411$var$p(409));
    $c50b85309f892411$var$fl(a, b, null, null);
};
$c50b85309f892411$var$ml.prototype.unmount = $c50b85309f892411$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c50b85309f892411$var$Rk(function() {
            $c50b85309f892411$var$fl(null, a, null, null);
        });
        b[$c50b85309f892411$var$uf] = null;
    }
};
function $c50b85309f892411$var$ml(a) {
    this._internalRoot = a;
}
$c50b85309f892411$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c50b85309f892411$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c50b85309f892411$var$Qc.length && 0 !== b && b < $c50b85309f892411$var$Qc[c].priority; c++);
        $c50b85309f892411$var$Qc.splice(c, 0, a);
        0 === c && $c50b85309f892411$var$Vc(a);
    }
};
function $c50b85309f892411$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c50b85309f892411$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c50b85309f892411$var$pl() {}
function $c50b85309f892411$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c50b85309f892411$var$gl(g);
                f.call(a);
            };
        }
        var g = $c50b85309f892411$var$el(b, d, a, 0, null, !1, !1, "", $c50b85309f892411$var$pl);
        a._reactRootContainer = g;
        a[$c50b85309f892411$var$uf] = g.current;
        $c50b85309f892411$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c50b85309f892411$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c50b85309f892411$var$gl(k);
            h.call(a);
        };
    }
    var k = $c50b85309f892411$var$bl(a, 0, !1, null, null, !1, !1, "", $c50b85309f892411$var$pl);
    a._reactRootContainer = k;
    a[$c50b85309f892411$var$uf] = k.current;
    $c50b85309f892411$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c50b85309f892411$var$Rk(function() {
        $c50b85309f892411$var$fl(b, k, c, d);
    });
    return k;
}
function $c50b85309f892411$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c50b85309f892411$var$gl(g);
                h.call(a);
            };
        }
        $c50b85309f892411$var$fl(b, g, a, e);
    } else g = $c50b85309f892411$var$ql(c, b, a, e, d);
    return $c50b85309f892411$var$gl(g);
}
$c50b85309f892411$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c50b85309f892411$var$tc(b.pendingLanes);
                0 !== c && ($c50b85309f892411$var$Cc(b, c | 1), $c50b85309f892411$var$Dk(b, $c50b85309f892411$var$B()), 0 === ($c50b85309f892411$var$K & 6) && ($c50b85309f892411$var$Gj = $c50b85309f892411$var$B() + 500, $c50b85309f892411$var$jg()));
            }
            break;
        case 13:
            $c50b85309f892411$var$Rk(function() {
                var b = $c50b85309f892411$var$ih(a, 1);
                if (null !== b) {
                    var c = $c50b85309f892411$var$R();
                    $c50b85309f892411$var$gi(b, a, 1, c);
                }
            }), $c50b85309f892411$var$il(a, 1);
    }
};
$c50b85309f892411$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $c50b85309f892411$var$ih(a, 134217728);
        if (null !== b) {
            var c = $c50b85309f892411$var$R();
            $c50b85309f892411$var$gi(b, a, 134217728, c);
        }
        $c50b85309f892411$var$il(a, 134217728);
    }
};
$c50b85309f892411$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $c50b85309f892411$var$yi(a), c = $c50b85309f892411$var$ih(a, b);
        if (null !== c) {
            var d = $c50b85309f892411$var$R();
            $c50b85309f892411$var$gi(c, a, b, d);
        }
        $c50b85309f892411$var$il(a, b);
    }
};
$c50b85309f892411$var$Hc = function() {
    return $c50b85309f892411$var$C;
};
$c50b85309f892411$var$Ic = function(a, b) {
    var c = $c50b85309f892411$var$C;
    try {
        return $c50b85309f892411$var$C = a, b();
    } finally{
        $c50b85309f892411$var$C = c;
    }
};
$c50b85309f892411$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c50b85309f892411$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c50b85309f892411$var$Db(d);
                        if (!e) throw Error($c50b85309f892411$var$p(90));
                        $c50b85309f892411$var$Wa(d);
                        $c50b85309f892411$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c50b85309f892411$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c50b85309f892411$var$fb(a, !!c.multiple, b, !1);
    }
};
$c50b85309f892411$var$Gb = $c50b85309f892411$var$Qk;
$c50b85309f892411$var$Hb = $c50b85309f892411$var$Rk;
var $c50b85309f892411$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $c50b85309f892411$var$Cb,
        $c50b85309f892411$var$ue,
        $c50b85309f892411$var$Db,
        $c50b85309f892411$var$Eb,
        $c50b85309f892411$var$Fb,
        $c50b85309f892411$var$Qk
    ]
}, $c50b85309f892411$var$tl = {
    findFiberByHostInstance: $c50b85309f892411$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $c50b85309f892411$var$ul = {
    bundleType: $c50b85309f892411$var$tl.bundleType,
    version: $c50b85309f892411$var$tl.version,
    rendererPackageName: $c50b85309f892411$var$tl.rendererPackageName,
    rendererConfig: $c50b85309f892411$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c50b85309f892411$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c50b85309f892411$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c50b85309f892411$var$tl.findFiberByHostInstance || $c50b85309f892411$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c50b85309f892411$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c50b85309f892411$var$vl.isDisabled && $c50b85309f892411$var$vl.supportsFiber) try {
        $c50b85309f892411$var$kc = $c50b85309f892411$var$vl.inject($c50b85309f892411$var$ul), $c50b85309f892411$var$lc = $c50b85309f892411$var$vl;
    } catch (a) {}
}
$c50b85309f892411$export$ae55be85d98224ed = $c50b85309f892411$var$sl;
$c50b85309f892411$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c50b85309f892411$var$nl(b)) throw Error($c50b85309f892411$var$p(200));
    return $c50b85309f892411$var$cl(a, b, null, c);
};
$c50b85309f892411$export$882461b6382ed46c = function(a, b) {
    if (!$c50b85309f892411$var$nl(a)) throw Error($c50b85309f892411$var$p(299));
    var c = !1, d = "", e = $c50b85309f892411$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c50b85309f892411$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$c50b85309f892411$var$uf] = b.current;
    $c50b85309f892411$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c50b85309f892411$var$ll(b);
};
$c50b85309f892411$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c50b85309f892411$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c50b85309f892411$var$p(268, a));
    }
    a = $c50b85309f892411$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c50b85309f892411$export$cd75ccfd720a3cd4 = function(a) {
    return $c50b85309f892411$var$Rk(a);
};
$c50b85309f892411$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c50b85309f892411$var$ol(b)) throw Error($c50b85309f892411$var$p(200));
    return $c50b85309f892411$var$rl(null, a, b, !0, c);
};
$c50b85309f892411$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c50b85309f892411$var$nl(a)) throw Error($c50b85309f892411$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c50b85309f892411$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c50b85309f892411$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c50b85309f892411$var$uf] = b.current;
    $c50b85309f892411$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c50b85309f892411$var$ml(b);
};
$c50b85309f892411$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c50b85309f892411$var$ol(b)) throw Error($c50b85309f892411$var$p(200));
    return $c50b85309f892411$var$rl(null, a, b, !1, c);
};
$c50b85309f892411$export$502457920280e6be = function(a) {
    if (!$c50b85309f892411$var$ol(a)) throw Error($c50b85309f892411$var$p(40));
    return a._reactRootContainer ? ($c50b85309f892411$var$Rk(function() {
        $c50b85309f892411$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c50b85309f892411$var$uf] = null;
        });
    }), !0) : !1;
};
$c50b85309f892411$export$c78a37762a8d58e1 = $c50b85309f892411$var$Qk;
$c50b85309f892411$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c50b85309f892411$var$ol(c)) throw Error($c50b85309f892411$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c50b85309f892411$var$p(38));
    return $c50b85309f892411$var$rl(a, b, c, !1, d);
};
$c50b85309f892411$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("5lIsG", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kycCK"));

});
parcelRegister("kycCK", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $ef60c67cb289f5a8$export$c4744153514ff05d, (v) => $ef60c67cb289f5a8$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $ef60c67cb289f5a8$export$3e506c1ccc9cc1a7, (v) => $ef60c67cb289f5a8$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $ef60c67cb289f5a8$export$e26fe2ed2fa76875, (v) => $ef60c67cb289f5a8$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $ef60c67cb289f5a8$export$502329bbf4b505b1, (v) => $ef60c67cb289f5a8$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $ef60c67cb289f5a8$export$6e3807111c4874c4, (v) => $ef60c67cb289f5a8$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $ef60c67cb289f5a8$export$c27134553091fb3a, (v) => $ef60c67cb289f5a8$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $ef60c67cb289f5a8$export$33ee1acdc04fd2a2, (v) => $ef60c67cb289f5a8$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $ef60c67cb289f5a8$export$b00a404bbd5edef2, (v) => $ef60c67cb289f5a8$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $ef60c67cb289f5a8$export$8352ce38b91d0c62, (v) => $ef60c67cb289f5a8$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $ef60c67cb289f5a8$export$d66a1c1c77bd778b, (v) => $ef60c67cb289f5a8$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $ef60c67cb289f5a8$export$d3dfb8e4810cb555, (v) => $ef60c67cb289f5a8$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $ef60c67cb289f5a8$export$839f9183b0465a69, (v) => $ef60c67cb289f5a8$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $ef60c67cb289f5a8$export$72fdf0e06517287b, (v) => $ef60c67cb289f5a8$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $ef60c67cb289f5a8$export$4b844e58a3e414b4, (v) => $ef60c67cb289f5a8$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $ef60c67cb289f5a8$export$816d2913ae6b83b1, (v) => $ef60c67cb289f5a8$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $ef60c67cb289f5a8$export$61bcfe829111a1d0, (v) => $ef60c67cb289f5a8$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $ef60c67cb289f5a8$export$7ee8c9beb337bc3f, (v) => $ef60c67cb289f5a8$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $ef60c67cb289f5a8$export$b5836b71941fa3ed, (v) => $ef60c67cb289f5a8$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $ef60c67cb289f5a8$export$cf845f2c119da08a, (v) => $ef60c67cb289f5a8$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ef60c67cb289f5a8$export$c4744153514ff05d;
var $ef60c67cb289f5a8$export$3e506c1ccc9cc1a7;
var $ef60c67cb289f5a8$export$e26fe2ed2fa76875;
var $ef60c67cb289f5a8$export$502329bbf4b505b1;
var $ef60c67cb289f5a8$export$6e3807111c4874c4;
var $ef60c67cb289f5a8$export$c27134553091fb3a;
var $ef60c67cb289f5a8$export$33ee1acdc04fd2a2;
var $ef60c67cb289f5a8$export$b00a404bbd5edef2;
var $ef60c67cb289f5a8$export$8352ce38b91d0c62;
var $ef60c67cb289f5a8$export$d66a1c1c77bd778b;
var $ef60c67cb289f5a8$export$d3dfb8e4810cb555;
var $ef60c67cb289f5a8$export$839f9183b0465a69;
var $ef60c67cb289f5a8$export$72fdf0e06517287b;
var $ef60c67cb289f5a8$export$4b844e58a3e414b4;
var $ef60c67cb289f5a8$export$816d2913ae6b83b1;
var $ef60c67cb289f5a8$export$61bcfe829111a1d0;
var $ef60c67cb289f5a8$export$7ee8c9beb337bc3f;
var $ef60c67cb289f5a8$export$b5836b71941fa3ed;
var $ef60c67cb289f5a8$export$cf845f2c119da08a;
"use strict";
function $ef60c67cb289f5a8$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $ef60c67cb289f5a8$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $ef60c67cb289f5a8$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $ef60c67cb289f5a8$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $ef60c67cb289f5a8$var$g(C, c)) n < e && 0 > $ef60c67cb289f5a8$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $ef60c67cb289f5a8$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $ef60c67cb289f5a8$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ef60c67cb289f5a8$var$l = performance;
    $ef60c67cb289f5a8$export$c4744153514ff05d = function() {
        return $ef60c67cb289f5a8$var$l.now();
    };
} else {
    var $ef60c67cb289f5a8$var$p = Date, $ef60c67cb289f5a8$var$q = $ef60c67cb289f5a8$var$p.now();
    $ef60c67cb289f5a8$export$c4744153514ff05d = function() {
        return $ef60c67cb289f5a8$var$p.now() - $ef60c67cb289f5a8$var$q;
    };
}
var $ef60c67cb289f5a8$var$r = [], $ef60c67cb289f5a8$var$t = [], $ef60c67cb289f5a8$var$u = 1, $ef60c67cb289f5a8$var$v = null, $ef60c67cb289f5a8$var$y = 3, $ef60c67cb289f5a8$var$z = !1, $ef60c67cb289f5a8$var$A = !1, $ef60c67cb289f5a8$var$B = !1, $ef60c67cb289f5a8$var$D = "function" === typeof setTimeout ? setTimeout : null, $ef60c67cb289f5a8$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $ef60c67cb289f5a8$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $ef60c67cb289f5a8$var$G(a) {
    for(var b = $ef60c67cb289f5a8$var$h($ef60c67cb289f5a8$var$t); null !== b;){
        if (null === b.callback) $ef60c67cb289f5a8$var$k($ef60c67cb289f5a8$var$t);
        else if (b.startTime <= a) $ef60c67cb289f5a8$var$k($ef60c67cb289f5a8$var$t), b.sortIndex = b.expirationTime, $ef60c67cb289f5a8$var$f($ef60c67cb289f5a8$var$r, b);
        else break;
        b = $ef60c67cb289f5a8$var$h($ef60c67cb289f5a8$var$t);
    }
}
function $ef60c67cb289f5a8$var$H(a) {
    $ef60c67cb289f5a8$var$B = !1;
    $ef60c67cb289f5a8$var$G(a);
    if (!$ef60c67cb289f5a8$var$A) {
        if (null !== $ef60c67cb289f5a8$var$h($ef60c67cb289f5a8$var$r)) $ef60c67cb289f5a8$var$A = !0, $ef60c67cb289f5a8$var$I($ef60c67cb289f5a8$var$J);
        else {
            var b = $ef60c67cb289f5a8$var$h($ef60c67cb289f5a8$var$t);
            null !== b && $ef60c67cb289f5a8$var$K($ef60c67cb289f5a8$var$H, b.startTime - a);
        }
    }
}
function $ef60c67cb289f5a8$var$J(a, b) {
    $ef60c67cb289f5a8$var$A = !1;
    $ef60c67cb289f5a8$var$B && ($ef60c67cb289f5a8$var$B = !1, $ef60c67cb289f5a8$var$E($ef60c67cb289f5a8$var$L), $ef60c67cb289f5a8$var$L = -1);
    $ef60c67cb289f5a8$var$z = !0;
    var c = $ef60c67cb289f5a8$var$y;
    try {
        $ef60c67cb289f5a8$var$G(b);
        for($ef60c67cb289f5a8$var$v = $ef60c67cb289f5a8$var$h($ef60c67cb289f5a8$var$r); null !== $ef60c67cb289f5a8$var$v && (!($ef60c67cb289f5a8$var$v.expirationTime > b) || a && !$ef60c67cb289f5a8$var$M());){
            var d = $ef60c67cb289f5a8$var$v.callback;
            if ("function" === typeof d) {
                $ef60c67cb289f5a8$var$v.callback = null;
                $ef60c67cb289f5a8$var$y = $ef60c67cb289f5a8$var$v.priorityLevel;
                var e = d($ef60c67cb289f5a8$var$v.expirationTime <= b);
                b = $ef60c67cb289f5a8$export$c4744153514ff05d();
                "function" === typeof e ? $ef60c67cb289f5a8$var$v.callback = e : $ef60c67cb289f5a8$var$v === $ef60c67cb289f5a8$var$h($ef60c67cb289f5a8$var$r) && $ef60c67cb289f5a8$var$k($ef60c67cb289f5a8$var$r);
                $ef60c67cb289f5a8$var$G(b);
            } else $ef60c67cb289f5a8$var$k($ef60c67cb289f5a8$var$r);
            $ef60c67cb289f5a8$var$v = $ef60c67cb289f5a8$var$h($ef60c67cb289f5a8$var$r);
        }
        if (null !== $ef60c67cb289f5a8$var$v) var w = !0;
        else {
            var m = $ef60c67cb289f5a8$var$h($ef60c67cb289f5a8$var$t);
            null !== m && $ef60c67cb289f5a8$var$K($ef60c67cb289f5a8$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $ef60c67cb289f5a8$var$v = null, $ef60c67cb289f5a8$var$y = c, $ef60c67cb289f5a8$var$z = !1;
    }
}
var $ef60c67cb289f5a8$var$N = !1, $ef60c67cb289f5a8$var$O = null, $ef60c67cb289f5a8$var$L = -1, $ef60c67cb289f5a8$var$P = 5, $ef60c67cb289f5a8$var$Q = -1;
function $ef60c67cb289f5a8$var$M() {
    return $ef60c67cb289f5a8$export$c4744153514ff05d() - $ef60c67cb289f5a8$var$Q < $ef60c67cb289f5a8$var$P ? !1 : !0;
}
function $ef60c67cb289f5a8$var$R() {
    if (null !== $ef60c67cb289f5a8$var$O) {
        var a = $ef60c67cb289f5a8$export$c4744153514ff05d();
        $ef60c67cb289f5a8$var$Q = a;
        var b = !0;
        try {
            b = $ef60c67cb289f5a8$var$O(!0, a);
        } finally{
            b ? $ef60c67cb289f5a8$var$S() : ($ef60c67cb289f5a8$var$N = !1, $ef60c67cb289f5a8$var$O = null);
        }
    } else $ef60c67cb289f5a8$var$N = !1;
}
var $ef60c67cb289f5a8$var$S;
if ("function" === typeof $ef60c67cb289f5a8$var$F) $ef60c67cb289f5a8$var$S = function() {
    $ef60c67cb289f5a8$var$F($ef60c67cb289f5a8$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ef60c67cb289f5a8$var$T = new MessageChannel, $ef60c67cb289f5a8$var$U = $ef60c67cb289f5a8$var$T.port2;
    $ef60c67cb289f5a8$var$T.port1.onmessage = $ef60c67cb289f5a8$var$R;
    $ef60c67cb289f5a8$var$S = function() {
        $ef60c67cb289f5a8$var$U.postMessage(null);
    };
} else $ef60c67cb289f5a8$var$S = function() {
    $ef60c67cb289f5a8$var$D($ef60c67cb289f5a8$var$R, 0);
};
function $ef60c67cb289f5a8$var$I(a) {
    $ef60c67cb289f5a8$var$O = a;
    $ef60c67cb289f5a8$var$N || ($ef60c67cb289f5a8$var$N = !0, $ef60c67cb289f5a8$var$S());
}
function $ef60c67cb289f5a8$var$K(a, b) {
    $ef60c67cb289f5a8$var$L = $ef60c67cb289f5a8$var$D(function() {
        a($ef60c67cb289f5a8$export$c4744153514ff05d());
    }, b);
}
$ef60c67cb289f5a8$export$3e506c1ccc9cc1a7 = 5;
$ef60c67cb289f5a8$export$e26fe2ed2fa76875 = 1;
$ef60c67cb289f5a8$export$502329bbf4b505b1 = 4;
$ef60c67cb289f5a8$export$6e3807111c4874c4 = 3;
$ef60c67cb289f5a8$export$c27134553091fb3a = null;
$ef60c67cb289f5a8$export$33ee1acdc04fd2a2 = 2;
$ef60c67cb289f5a8$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$ef60c67cb289f5a8$export$8352ce38b91d0c62 = function() {
    $ef60c67cb289f5a8$var$A || $ef60c67cb289f5a8$var$z || ($ef60c67cb289f5a8$var$A = !0, $ef60c67cb289f5a8$var$I($ef60c67cb289f5a8$var$J));
};
$ef60c67cb289f5a8$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ef60c67cb289f5a8$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$ef60c67cb289f5a8$export$d3dfb8e4810cb555 = function() {
    return $ef60c67cb289f5a8$var$y;
};
$ef60c67cb289f5a8$export$839f9183b0465a69 = function() {
    return $ef60c67cb289f5a8$var$h($ef60c67cb289f5a8$var$r);
};
$ef60c67cb289f5a8$export$72fdf0e06517287b = function(a) {
    switch($ef60c67cb289f5a8$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $ef60c67cb289f5a8$var$y;
    }
    var c = $ef60c67cb289f5a8$var$y;
    $ef60c67cb289f5a8$var$y = b;
    try {
        return a();
    } finally{
        $ef60c67cb289f5a8$var$y = c;
    }
};
$ef60c67cb289f5a8$export$4b844e58a3e414b4 = function() {};
$ef60c67cb289f5a8$export$816d2913ae6b83b1 = function() {};
$ef60c67cb289f5a8$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $ef60c67cb289f5a8$var$y;
    $ef60c67cb289f5a8$var$y = a;
    try {
        return b();
    } finally{
        $ef60c67cb289f5a8$var$y = c;
    }
};
$ef60c67cb289f5a8$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $ef60c67cb289f5a8$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $ef60c67cb289f5a8$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $ef60c67cb289f5a8$var$f($ef60c67cb289f5a8$var$t, a), null === $ef60c67cb289f5a8$var$h($ef60c67cb289f5a8$var$r) && a === $ef60c67cb289f5a8$var$h($ef60c67cb289f5a8$var$t) && ($ef60c67cb289f5a8$var$B ? ($ef60c67cb289f5a8$var$E($ef60c67cb289f5a8$var$L), $ef60c67cb289f5a8$var$L = -1) : $ef60c67cb289f5a8$var$B = !0, $ef60c67cb289f5a8$var$K($ef60c67cb289f5a8$var$H, c - d))) : (a.sortIndex = e, $ef60c67cb289f5a8$var$f($ef60c67cb289f5a8$var$r, a), $ef60c67cb289f5a8$var$A || $ef60c67cb289f5a8$var$z || ($ef60c67cb289f5a8$var$A = !0, $ef60c67cb289f5a8$var$I($ef60c67cb289f5a8$var$J)));
    return a;
};
$ef60c67cb289f5a8$export$b5836b71941fa3ed = $ef60c67cb289f5a8$var$M;
$ef60c67cb289f5a8$export$cf845f2c119da08a = function(a) {
    var b = $ef60c67cb289f5a8$var$y;
    return function() {
        var c = $ef60c67cb289f5a8$var$y;
        $ef60c67cb289f5a8$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $ef60c67cb289f5a8$var$y = c;
        }
    };
};

});




parcelRegister("ghfIB", function(module, exports) {

$parcel$export(module.exports, "serverConfigManager", () => $dc9b703e9f01506e$export$43e36fda3e49e841);
$parcel$export(module.exports, "infraManager", () => $dc9b703e9f01506e$export$e3b06a5f7674cf48);
$parcel$export(module.exports, "networkActionsErrorsManager", () => $dc9b703e9f01506e$export$934de068dca8feb);
$parcel$export(module.exports, "featureTogglesManager", () => $dc9b703e9f01506e$export$abceef408ce76075);
$parcel$export(module.exports, "analyticsService", () => $dc9b703e9f01506e$export$b5b101acdf4c4e2c);
$parcel$export(module.exports, "userStatusManager", () => $dc9b703e9f01506e$export$bb9e294842020c67);
$parcel$export(module.exports, "errorManager", () => $dc9b703e9f01506e$export$b52cdbd2befa8971);
$parcel$export(module.exports, "translationsManager", () => $dc9b703e9f01506e$export$bec0ac3d51f7baf5);
$parcel$export(module.exports, "announcementManager", () => $dc9b703e9f01506e$export$cc39ffb60aa62d20);
$parcel$export(module.exports, "userService", () => $dc9b703e9f01506e$export$59bd1d223db88f98);
$parcel$export(module.exports, "userManager", () => $dc9b703e9f01506e$export$cc5a9a3851cbd70d);
$parcel$export(module.exports, "learnManager", () => $dc9b703e9f01506e$export$24d56af93d43af7a);
$parcel$export(module.exports, "tutorialBannerManager", () => $dc9b703e9f01506e$export$bcc5fda2161eeeb6);
$parcel$export(module.exports, "userBannerManager", () => $dc9b703e9f01506e$export$7ec790d6fe6e4fb8);
$parcel$export(module.exports, "userSurveyManager", () => $dc9b703e9f01506e$export$e7675d32378a6c96);
$parcel$export(module.exports, "patientManager", () => $dc9b703e9f01506e$export$3621a991c65ec971);
$parcel$export(module.exports, "exerciseManager", () => $dc9b703e9f01506e$export$3542862c063acb6c);
$parcel$export(module.exports, "libraryFilterManager", () => $dc9b703e9f01506e$export$ebc9281c3556e242);
$parcel$export(module.exports, "exerciseFilterManager", () => $dc9b703e9f01506e$export$f5714856402131d3);
$parcel$export(module.exports, "programManager", () => $dc9b703e9f01506e$export$969d6974d56ddba4);
$parcel$export(module.exports, "patientProgramsManager", () => $dc9b703e9f01506e$export$4f2263bf2ae9c344);
$parcel$export(module.exports, "progressDataManager", () => $dc9b703e9f01506e$export$12c018bc16ac96dd);
$parcel$export(module.exports, "countryManager", () => $dc9b703e9f01506e$export$8d628b13d86001);
$parcel$export(module.exports, "localeManager", () => $dc9b703e9f01506e$export$68a8c8fe5d24991);
$parcel$export(module.exports, "legalContentManager", () => $dc9b703e9f01506e$export$41134b67808feaa3);
$parcel$export(module.exports, "analyticsDimensionsManager", () => $dc9b703e9f01506e$export$51c93cd2c3206b63);
$parcel$export(module.exports, "analyticsRoutesManager", () => $dc9b703e9f01506e$export$d792f5ea7be3f1ce);
$parcel$export(module.exports, "networkDebugManager", () => $dc9b703e9f01506e$export$7594d901985ce4ce);
$parcel$export(module.exports, "templateManager", () => $dc9b703e9f01506e$export$34332ea7c94b738b);
$parcel$export(module.exports, "templateOperationsManager", () => $dc9b703e9f01506e$export$274c00c5b8179702);
$parcel$export(module.exports, "programOperationsManager", () => $dc9b703e9f01506e$export$dc6d77b984301729);
$parcel$export(module.exports, "cookiebotManager", () => $dc9b703e9f01506e$export$9b7916c1ac1b2d30);
$parcel$export(module.exports, "healthcareTeamManager", () => $dc9b703e9f01506e$export$4cf489593e40dcbc);
$parcel$export(module.exports, "registerManager", () => $dc9b703e9f01506e$export$9bc197bca8e7d2f7);
$parcel$export(module.exports, "vipRegisterManager", () => $dc9b703e9f01506e$export$ff0f0254c32297d7);
$parcel$export(module.exports, "fastTrackRegisterManager", () => $dc9b703e9f01506e$export$11ed3437dc3f2cff);
$parcel$export(module.exports, "prospectRequestManager", () => $dc9b703e9f01506e$export$fc4d3cbecfcc0322);
$parcel$export(module.exports, "notificationManager", () => $dc9b703e9f01506e$export$82a33ce82c0bcfe8);
$parcel$export(module.exports, "notificationBadgeManager", () => $dc9b703e9f01506e$export$54a1159de42ca444);
$parcel$export(module.exports, "onboardingManager", () => $dc9b703e9f01506e$export$e4dca90213c30a5f);
$parcel$export(module.exports, "getStartedManager", () => $dc9b703e9f01506e$export$af9d1f697ad44f0c);
$parcel$export(module.exports, "onfidoService", () => $dc9b703e9f01506e$export$f02b0ea57844eb5b);
$parcel$export(module.exports, "initializeServicesAndManagers", () => $dc9b703e9f01506e$export$dbf4918af207660c);
$parcel$export(module.exports, "resetServicesAndManagers", () => $dc9b703e9f01506e$export$b6b29240c9f15a9b);

var $6lqel = parcelRequire("6lqel");

var $5ALBt = parcelRequire("5ALBt");

var $d5fcV = parcelRequire("d5fcV");

var $4ppMx = parcelRequire("4ppMx");

var $lWryN = parcelRequire("lWryN");

var $gi9KJ = parcelRequire("gi9KJ");

var $2w9VQ = parcelRequire("2w9VQ");

var $hvhSI = parcelRequire("hvhSI");

var $1RPKt = parcelRequire("1RPKt");

var $kpDEW = parcelRequire("kpDEW");

var $iqzJm = parcelRequire("iqzJm");

var $bQxqW = parcelRequire("bQxqW");

var $7SbDW = parcelRequire("7SbDW");

var $lAOzn = parcelRequire("lAOzn");

var $chRgh = parcelRequire("chRgh");

var $aj4st = parcelRequire("aj4st");

var $av31l = parcelRequire("av31l");

var $2y70O = parcelRequire("2y70O");

var $auPqo = parcelRequire("auPqo");

var $cM7bY = parcelRequire("cM7bY");

var $b3162 = parcelRequire("b3162");

var $5DLWq = parcelRequire("5DLWq");

var $gV9DR = parcelRequire("gV9DR");

var $8HMyT = parcelRequire("8HMyT");

var $1MEPE = parcelRequire("1MEPE");

var $hsZgT = parcelRequire("hsZgT");

var $8KSst = parcelRequire("8KSst");

var $gASCG = parcelRequire("gASCG");

var $hGOU3 = parcelRequire("hGOU3");

var $dmi3A = parcelRequire("dmi3A");

var $iDkBu = parcelRequire("iDkBu");

var $kZYvH = parcelRequire("kZYvH");

var $jl5Na = parcelRequire("jl5Na");

var $9Xe21 = parcelRequire("9Xe21");

var $8XtwW = parcelRequire("8XtwW");

var $daNIT = parcelRequire("daNIT");

var $dvhRi = parcelRequire("dvhRi");

var $kKtHN = parcelRequire("kKtHN");

var $jJH8x = parcelRequire("jJH8x");

var $bGHjr = parcelRequire("bGHjr");

var $kRxX7 = parcelRequire("kRxX7");

var $kEidV = parcelRequire("kEidV");

var $cdxFd = parcelRequire("cdxFd");

var $dT2AR = parcelRequire("dT2AR");

var $fBvlK = parcelRequire("fBvlK");

var $7V7cK = parcelRequire("7V7cK");

var $idwZU = parcelRequire("idwZU");

var $csqRG = parcelRequire("csqRG");

var $bOjgs = parcelRequire("bOjgs");

var $bnG5b = parcelRequire("bnG5b");

var $auZdZ = parcelRequire("auZdZ");

var $bGoxH = parcelRequire("bGoxH");

var $k6Nr9 = parcelRequire("k6Nr9");

var $aMqVr = parcelRequire("aMqVr");

var $7U4Mk = parcelRequire("7U4Mk");

var $kI4v8 = parcelRequire("kI4v8");

var $1ySyt = parcelRequire("1ySyt");

var $fnxXE = parcelRequire("fnxXE");

var $kP9hn = parcelRequire("kP9hn");

var $7ZHO1 = parcelRequire("7ZHO1");

var $8rwTs = parcelRequire("8rwTs");

var $8n64Q = parcelRequire("8n64Q");

var $5oZJu = parcelRequire("5oZJu");

var $frvHD = parcelRequire("frvHD");

var $94Hzw = parcelRequire("94Hzw");

var $4m2wf = parcelRequire("4m2wf");

var $kOuME = parcelRequire("kOuME");

var $6TlSs = parcelRequire("6TlSs");

var $7VkZx = parcelRequire("7VkZx");

var $jkS1f = parcelRequire("jkS1f");

var $2Bm53 = parcelRequire("2Bm53");

var $261bY = parcelRequire("261bY");

var $gIkq9 = parcelRequire("gIkq9");

var $gFp6z = parcelRequire("gFp6z");

var $gn5v7 = parcelRequire("gn5v7");

var $7gQVm = parcelRequire("7gQVm");

var $6ihZe = parcelRequire("6ihZe");

var $zj4Ke = parcelRequire("zj4Ke");

var $jOymS = parcelRequire("jOymS");

var $iJEAD = parcelRequire("iJEAD");

var $6cSBm = parcelRequire("6cSBm");

var $7JiF7 = parcelRequire("7JiF7");

var $hPUY2 = parcelRequire("hPUY2");

var $ivrAm = parcelRequire("ivrAm");
const $dc9b703e9f01506e$var$masterApiService = new (0, $2w9VQ.MasterApiService)((0, $gi9KJ.createAxiosInstance)());
const $dc9b703e9f01506e$var$serverConfigService = new (0, $kOuME.ServerConfigService)($dc9b703e9f01506e$var$masterApiService);
const $dc9b703e9f01506e$export$43e36fda3e49e841 = new (0, $4m2wf.ServerConfigManager)($dc9b703e9f01506e$var$serverConfigService, (0, $aj4st.storage).getStore((0, $chRgh.LocalStorageKeys).serverConfiguration, (sc)=>sc, (sc)=>sc));
const $dc9b703e9f01506e$export$e3b06a5f7674cf48 = new (0, $jl5Na.InfraManager)($dc9b703e9f01506e$export$43e36fda3e49e841, (0, $aj4st.storage).getStore((0, $chRgh.LocalStorageKeys).targetInfrastructureId, (i)=>i, (i)=>i));
const $dc9b703e9f01506e$export$934de068dca8feb = new (0, $jJH8x.NetworkActionsErrorsManager)();
const $dc9b703e9f01506e$var$cognitoServiceWrapper = new (0, $8KSst.CognitoServiceWrapper)($dc9b703e9f01506e$export$934de068dca8feb);
const $dc9b703e9f01506e$var$userPoolProvider = new (0, $gASCG.CognitoUserPoolProvider)($dc9b703e9f01506e$export$e3b06a5f7674cf48);
const $dc9b703e9f01506e$var$cognitoMultiInfra = new (0, $hsZgT.CognitoMultiInfra)($dc9b703e9f01506e$var$cognitoServiceWrapper, $dc9b703e9f01506e$var$userPoolProvider);
const $dc9b703e9f01506e$var$cognitoAuthService = new (0, $1MEPE.CognitoAuthService)($dc9b703e9f01506e$var$cognitoServiceWrapper, $dc9b703e9f01506e$var$userPoolProvider, $dc9b703e9f01506e$export$934de068dca8feb, $dc9b703e9f01506e$var$cognitoMultiInfra);
const $dc9b703e9f01506e$export$abceef408ce76075 = new (0, $dmi3A.FeatureTogglesManager)((0, $aj4st.storage).getStore((0, $chRgh.LocalStorageKeys).featureToggles, (i)=>i, (i)=>i));
const $dc9b703e9f01506e$export$c3a37448169bd6e8 = new (0, $5ALBt.GoogleAnalyticsTracker)();
const $dc9b703e9f01506e$export$b5b101acdf4c4e2c = new (0, $6lqel.AnalyticsService)([
    $dc9b703e9f01506e$export$c3a37448169bd6e8
], (0, $auPqo.AnalyticsCategories), (0, $cM7bY.CustomDimensions), (0, $auPqo.AnalyticsRoutes), $dc9b703e9f01506e$export$abceef408ce76075);
const $dc9b703e9f01506e$export$bb9e294842020c67 = new (0, $jOymS.UserStatusManager)();
const $dc9b703e9f01506e$var$announcementReceivedService = new (0, $gV9DR.AnnouncementReceivedService)();
const $dc9b703e9f01506e$var$networkAnalyticsManager = new (0, $b3162.NetworkAnalyticsManager)($dc9b703e9f01506e$export$b5b101acdf4c4e2c);
const $dc9b703e9f01506e$export$b52cdbd2befa8971 = new (0, $kpDEW.ErrorManager)();
const $dc9b703e9f01506e$var$innerAuthenticatedApiService = new (0, $d5fcV.AuthenticatedApiService)((0, $gi9KJ.createAxiosInstance), $dc9b703e9f01506e$var$cognitoAuthService, $dc9b703e9f01506e$export$e3b06a5f7674cf48, $dc9b703e9f01506e$export$bb9e294842020c67, $dc9b703e9f01506e$var$announcementReceivedService, $dc9b703e9f01506e$export$b52cdbd2befa8971);
const $dc9b703e9f01506e$var$authenticatedApiService = new (0, $4ppMx.ApiServiceWithErrorHandler)($dc9b703e9f01506e$var$innerAuthenticatedApiService, $dc9b703e9f01506e$export$934de068dca8feb, $dc9b703e9f01506e$var$networkAnalyticsManager);
const $dc9b703e9f01506e$var$unauthenticatedApiService = new (0, $4ppMx.ApiServiceWithErrorHandler)(new (0, $hvhSI.UnauthenticatedApiService)((0, $gi9KJ.createAxiosInstance), $dc9b703e9f01506e$export$e3b06a5f7674cf48), $dc9b703e9f01506e$export$934de068dca8feb, $dc9b703e9f01506e$var$networkAnalyticsManager);
const $dc9b703e9f01506e$export$78189938e49787be = new (0, $4ppMx.ApiServiceWithErrorHandler)(new (0, $lWryN.ExternalApiService)((0, $gi9KJ.createAxiosInstance)), $dc9b703e9f01506e$export$934de068dca8feb, $dc9b703e9f01506e$var$networkAnalyticsManager);
const $dc9b703e9f01506e$var$translationsService = new (0, $7SbDW.TranslationsService)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hPUY2))).create(), $dc9b703e9f01506e$export$43e36fda3e49e841, $dc9b703e9f01506e$var$masterApiService);
const $dc9b703e9f01506e$export$bec0ac3d51f7baf5 = new (0, $bQxqW.TranslationsManager)($dc9b703e9f01506e$var$translationsService, (0, $aj4st.storage).getStore((0, $chRgh.LocalStorageKeys).translations, (i)=>i, (i)=>i));
const $dc9b703e9f01506e$var$announcementService = new (0, $8HMyT.AnnouncementService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$export$cc39ffb60aa62d20 = new (0, $5DLWq.AnnouncementManager)($dc9b703e9f01506e$var$announcementService, $dc9b703e9f01506e$var$announcementReceivedService);
const $dc9b703e9f01506e$export$59bd1d223db88f98 = new (0, $zj4Ke.UserService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$export$cc5a9a3851cbd70d = new (0, $6ihZe.UserManager)($dc9b703e9f01506e$var$cognitoAuthService, $dc9b703e9f01506e$export$59bd1d223db88f98);
const $dc9b703e9f01506e$export$16ac2d2e76093748 = new (0, $6cSBm.LearnService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$export$24d56af93d43af7a = new (0, $7JiF7.LearnManager)($dc9b703e9f01506e$export$16ac2d2e76093748, $dc9b703e9f01506e$export$cc5a9a3851cbd70d);
const $dc9b703e9f01506e$export$782e7a704e0249dd = new (0, $261bY.TutorialBannerService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$export$bcc5fda2161eeeb6 = new (0, $2Bm53.TutorialBannerManager)($dc9b703e9f01506e$export$782e7a704e0249dd, $dc9b703e9f01506e$export$cc5a9a3851cbd70d);
const $dc9b703e9f01506e$export$7ec790d6fe6e4fb8 = new (0, $gFp6z.UserBannerManager)();
const $dc9b703e9f01506e$var$userSurveyService = new (0, $7gQVm.UserSurveyService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$export$e7675d32378a6c96 = new (0, $gn5v7.UserSurveyManager)($dc9b703e9f01506e$var$userSurveyService);
const $dc9b703e9f01506e$var$patientService = new (0, $csqRG.PatientService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$export$3621a991c65ec971 = new (0, $idwZU.PatientManager)($dc9b703e9f01506e$var$patientService);
const $dc9b703e9f01506e$var$exerciseService = new (0, $dvhRi.ExerciseService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$export$3542862c063acb6c = new (0, $ivrAm.ExerciseManager)($dc9b703e9f01506e$var$exerciseService);
const $dc9b703e9f01506e$export$ebc9281c3556e242 = new (0, $daNIT.LibraryFilterManager)($dc9b703e9f01506e$export$3542862c063acb6c);
const $dc9b703e9f01506e$export$f5714856402131d3 = new (0, $kKtHN.ExerciseFilterManager)();
const $dc9b703e9f01506e$var$programService = new (0, $k6Nr9.ProgramService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$export$969d6974d56ddba4 = new (0, $auZdZ.ProgramManager)($dc9b703e9f01506e$var$programService);
const $dc9b703e9f01506e$var$patientProgramsService = new (0, $bnG5b.PatientProgramsService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$export$4f2263bf2ae9c344 = new (0, $bOjgs.PatientProgramsManager)($dc9b703e9f01506e$var$patientProgramsService);
const $dc9b703e9f01506e$var$progressDataService = new (0, $7U4Mk.ProgressDataService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$export$12c018bc16ac96dd = new (0, $aMqVr.ProgressDataManager)($dc9b703e9f01506e$var$progressDataService);
const $dc9b703e9f01506e$var$countryService = new (0, $kP9hn.CountryService)($dc9b703e9f01506e$var$masterApiService, $dc9b703e9f01506e$var$unauthenticatedApiService);
const $dc9b703e9f01506e$export$8d628b13d86001 = new (0, $fnxXE.CountryManager)($dc9b703e9f01506e$var$countryService, $dc9b703e9f01506e$export$cc5a9a3851cbd70d);
const $dc9b703e9f01506e$export$68a8c8fe5d24991 = new (0, $gIkq9.LocaleManager)($dc9b703e9f01506e$export$cc5a9a3851cbd70d, $dc9b703e9f01506e$export$bec0ac3d51f7baf5, $dc9b703e9f01506e$var$countryService);
const $dc9b703e9f01506e$var$legalContentService = new (0, $8XtwW.LegalContentService)($dc9b703e9f01506e$var$authenticatedApiService, $dc9b703e9f01506e$var$unauthenticatedApiService);
const $dc9b703e9f01506e$export$41134b67808feaa3 = new (0, $9Xe21.LegalContentManager)($dc9b703e9f01506e$var$legalContentService, $dc9b703e9f01506e$export$e3b06a5f7674cf48, (0, $aj4st.storage).getStore((0, $chRgh.LocalStorageKeys).legalContent, (i)=>i, (i)=>i));
const $dc9b703e9f01506e$export$51c93cd2c3206b63 = new (0, $av31l.AnalyticsDimensionsManager)($dc9b703e9f01506e$export$b5b101acdf4c4e2c, $dc9b703e9f01506e$export$cc5a9a3851cbd70d, $dc9b703e9f01506e$export$68a8c8fe5d24991);
const $dc9b703e9f01506e$export$d792f5ea7be3f1ce = new (0, $2y70O.AnalyticsRoutesManager)($dc9b703e9f01506e$export$b5b101acdf4c4e2c);
const $dc9b703e9f01506e$export$7594d901985ce4ce = new (0, $1RPKt.NetworkDebugManager)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$var$templateService = new (0, $jkS1f.TemplateService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$export$34332ea7c94b738b = new (0, $6TlSs.TemplateManager)($dc9b703e9f01506e$var$templateService);
const $dc9b703e9f01506e$export$274c00c5b8179702 = new (0, $7VkZx.TemplateOperationsManager)($dc9b703e9f01506e$export$34332ea7c94b738b, $dc9b703e9f01506e$export$969d6974d56ddba4);
const $dc9b703e9f01506e$export$dc6d77b984301729 = new (0, $bGoxH.ProgramOperationsManager)($dc9b703e9f01506e$export$969d6974d56ddba4, $dc9b703e9f01506e$export$4f2263bf2ae9c344, $dc9b703e9f01506e$export$34332ea7c94b738b);
const $dc9b703e9f01506e$export$9b7916c1ac1b2d30 = new (0, $hGOU3.CookiebotManager)();
const $dc9b703e9f01506e$var$healthcareTeamService = new (0, $kZYvH.HealthcareTeamService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$export$4cf489593e40dcbc = new (0, $iDkBu.HealthcareTeamManager)($dc9b703e9f01506e$var$healthcareTeamService);
const $dc9b703e9f01506e$var$registerService = new (0, $94Hzw.RegisterService)($dc9b703e9f01506e$var$authenticatedApiService, $dc9b703e9f01506e$var$unauthenticatedApiService);
const $dc9b703e9f01506e$export$9bc197bca8e7d2f7 = new (0, $frvHD.RegisterManager)($dc9b703e9f01506e$var$registerService, $dc9b703e9f01506e$export$68a8c8fe5d24991, $dc9b703e9f01506e$var$cognitoAuthService, $dc9b703e9f01506e$export$e3b06a5f7674cf48);
const $dc9b703e9f01506e$var$veevaService = new (0, $iJEAD.VeevaService)($dc9b703e9f01506e$var$masterApiService);
const $dc9b703e9f01506e$var$vipRegisterService = new (0, $5oZJu.VipRegisterService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$export$ff0f0254c32297d7 = new (0, $8n64Q.VipRegisterManager)($dc9b703e9f01506e$var$vipRegisterService, $dc9b703e9f01506e$var$veevaService, $dc9b703e9f01506e$var$cognitoAuthService, $dc9b703e9f01506e$export$e3b06a5f7674cf48);
const $dc9b703e9f01506e$var$fastTrackRegisterService = new (0, $8rwTs.FastTrackRegisterService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$export$11ed3437dc3f2cff = new (0, $7ZHO1.FastTrackRegisterManager)($dc9b703e9f01506e$var$fastTrackRegisterService, $dc9b703e9f01506e$var$veevaService, $dc9b703e9f01506e$var$cognitoAuthService, $dc9b703e9f01506e$export$e3b06a5f7674cf48);
const $dc9b703e9f01506e$var$prospectRequestService = new (0, $1ySyt.ProspectRequestService)($dc9b703e9f01506e$var$unauthenticatedApiService);
const $dc9b703e9f01506e$export$fc4d3cbecfcc0322 = new (0, $kI4v8.ProspectRequestManager)($dc9b703e9f01506e$var$prospectRequestService, $dc9b703e9f01506e$var$countryService, $dc9b703e9f01506e$export$e3b06a5f7674cf48);
const $dc9b703e9f01506e$var$notificationService = new (0, $kEidV.NotificationService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$export$82a33ce82c0bcfe8 = new (0, $kRxX7.NotificationManager)($dc9b703e9f01506e$var$notificationService);
const $dc9b703e9f01506e$export$54a1159de42ca444 = new (0, $bGHjr.NotificationBadgeManager)($dc9b703e9f01506e$export$82a33ce82c0bcfe8, $dc9b703e9f01506e$export$cc5a9a3851cbd70d, (0, $aj4st.storage).getStore((0, $chRgh.LocalStorageKeys).notifications, (sc)=>sc, (sc)=>sc));
const $dc9b703e9f01506e$var$onboardingService = new (0, $dT2AR.OnboardingService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$export$e4dca90213c30a5f = new (0, $cdxFd.OnboardingManager)($dc9b703e9f01506e$var$onboardingService, $dc9b703e9f01506e$export$cc5a9a3851cbd70d);
const $dc9b703e9f01506e$export$af9d1f697ad44f0c = new (0, $fBvlK.GetStartedManager)($dc9b703e9f01506e$export$e4dca90213c30a5f, $dc9b703e9f01506e$export$cc5a9a3851cbd70d);
const $dc9b703e9f01506e$export$f02b0ea57844eb5b = new (0, $7V7cK.OnfidoService)($dc9b703e9f01506e$var$authenticatedApiService);
const $dc9b703e9f01506e$var$dayjsLibConfiguration = new (0, $iqzJm.DayjsLibConfiguration)($dc9b703e9f01506e$export$68a8c8fe5d24991, $dc9b703e9f01506e$export$bec0ac3d51f7baf5);
const $dc9b703e9f01506e$var$servicesManager = new (0, $lAOzn.ServicesManager)([
    [
        $dc9b703e9f01506e$export$43e36fda3e49e841,
        "serverConfigManager",
        (0, $lAOzn.ServiceInitPriority).Critical
    ],
    [
        $dc9b703e9f01506e$export$e3b06a5f7674cf48,
        "infraManager",
        (0, $lAOzn.ServiceInitPriority).Critical
    ],
    [
        $dc9b703e9f01506e$var$cognitoAuthService,
        "cognitoAuthService",
        (0, $lAOzn.ServiceInitPriority).High
    ],
    [
        $dc9b703e9f01506e$export$68a8c8fe5d24991,
        "localeManager",
        (0, $lAOzn.ServiceInitPriority).High
    ],
    [
        $dc9b703e9f01506e$export$bec0ac3d51f7baf5,
        "translationsManager"
    ],
    [
        $dc9b703e9f01506e$export$cc5a9a3851cbd70d,
        "userManager"
    ],
    [
        $dc9b703e9f01506e$var$dayjsLibConfiguration,
        "dayjsLibConfiguration"
    ],
    [
        $dc9b703e9f01506e$export$abceef408ce76075,
        "featureTogglesManager"
    ],
    [
        $dc9b703e9f01506e$export$e4dca90213c30a5f,
        "onboardingManager"
    ]
]);
const $dc9b703e9f01506e$export$dbf4918af207660c = async ()=>{
    await $dc9b703e9f01506e$var$servicesManager.initServices();
    await $dc9b703e9f01506e$export$8d628b13d86001.init();
};
const $dc9b703e9f01506e$export$b6b29240c9f15a9b = async ()=>{
    const servicesToReset = [
        $dc9b703e9f01506e$export$3621a991c65ec971,
        $dc9b703e9f01506e$export$ebc9281c3556e242,
        $dc9b703e9f01506e$export$969d6974d56ddba4,
        $dc9b703e9f01506e$export$4f2263bf2ae9c344,
        $dc9b703e9f01506e$export$dc6d77b984301729,
        $dc9b703e9f01506e$export$12c018bc16ac96dd,
        $dc9b703e9f01506e$export$34332ea7c94b738b,
        $dc9b703e9f01506e$export$274c00c5b8179702,
        $dc9b703e9f01506e$export$68a8c8fe5d24991,
        $dc9b703e9f01506e$export$82a33ce82c0bcfe8,
        $dc9b703e9f01506e$export$bb9e294842020c67
    ];
    const resetPromises = [];
    for (const service of servicesToReset){
        const reset = service.reset;
        if (typeof reset === "function") resetPromises.push(Promise.resolve(reset.call(service)));
    }
    await Promise.all(resetPromises);
};

});
parcelRegister("6lqel", function(module, exports) {

$parcel$export(module.exports, "AnalyticsService", () => $354fa0839fbe33ec$export$a63ba6b63d0ef2e0);

var $dmi3A = parcelRequire("dmi3A");

var $1IWnK = parcelRequire("1IWnK");
class $354fa0839fbe33ec$export$a63ba6b63d0ef2e0 {
    constructor(trackers, eventCategories, customDimensions, routeNames, featureTogglesManager){
        this.trackers = trackers;
        this.eventCategories = eventCategories;
        this.customDimensions = customDimensions;
        this.routeNames = routeNames;
        this.featureTogglesManager = featureTogglesManager;
        this.areAnalyticsDisabled = (0, $1IWnK.observable)(false);
        this.featureTogglesManager.hasFeature((0, $dmi3A.FeatureToggle).DeactivateAnalytics).subscribe((disabled)=>this.areAnalyticsDisabled.set(disabled));
    }
    trackEvent(event) {
        if (this.areAnalyticsDisabled.get()) return;
        this.trackers.forEach((tracker)=>{
            tracker.trackEvent({
                ...event,
                category: this.eventCategories[event.category]
            });
        });
    }
    setCustomDimension(dimensionName, dimensionValue) {
        if (this.areAnalyticsDisabled.get()) return;
        this.trackers.forEach((tracker)=>tracker.setCustomDimension(this.customDimensions[dimensionName], dimensionValue));
    }
    trackView(viewTitle, customUrl) {
        if (this.areAnalyticsDisabled.get()) return;
        this.trackers.forEach((tracker)=>tracker.trackView(this.routeNames[viewTitle], customUrl));
    }
    setUserId(userId) {
        if (this.areAnalyticsDisabled.get()) return;
        this.trackers.forEach((tracker)=>tracker.setUserId(userId));
    }
}

});
parcelRegister("dmi3A", function(module, exports) {

$parcel$export(module.exports, "FeatureToggle", () => $6fca919ec0d7c818$export$8e25d4633f989d7a);
$parcel$export(module.exports, "featureToggles", () => $6fca919ec0d7c818$export$b61d3e34f05ee642);
$parcel$export(module.exports, "FeatureTogglesManager", () => $6fca919ec0d7c818$export$700417517608fb03);

var $1IWnK = parcelRequire("1IWnK");
var $6fca919ec0d7c818$export$8e25d4633f989d7a;
(function(FeatureToggle) {
    FeatureToggle["DeactivateAnalytics"] = "DeactivateAnalytics";
})($6fca919ec0d7c818$export$8e25d4633f989d7a || ($6fca919ec0d7c818$export$8e25d4633f989d7a = {}));
const $6fca919ec0d7c818$export$b61d3e34f05ee642 = Object.keys($6fca919ec0d7c818$export$8e25d4633f989d7a);
const $6fca919ec0d7c818$var$DEFAULT_FEATURE_TOGGLES = {
    ["DeactivateAnalytics"]: false
};
class $6fca919ec0d7c818$export$700417517608fb03 {
    constructor(featureTogglesStore){
        this.featureTogglesStore = featureTogglesStore;
        this._featureToggles = (0, $1IWnK.observable)($6fca919ec0d7c818$var$DEFAULT_FEATURE_TOGGLES);
        this.featureToggles = this._featureToggles.readOnly();
    }
    async init() {
        const storedFeaturesToggle = this.featureTogglesStore.getItem();
        this._featureToggles.set({
            ...$6fca919ec0d7c818$var$DEFAULT_FEATURE_TOGGLES,
            ...storedFeaturesToggle
        });
    }
    setFeatureToggleValue(featureToggle, enabled) {
        const currentRecord = {
            ...this._featureToggles.get(),
            [featureToggle]: enabled
        };
        this._featureToggles.set(currentRecord);
        this.featureTogglesStore.setItem(currentRecord);
    }
    hasFeature(featureToggle) {
        return this.featureToggles.select((toggles)=>toggles[featureToggle]);
    }
    reset() {
        this.featureTogglesStore.setItem($6fca919ec0d7c818$var$DEFAULT_FEATURE_TOGGLES);
        this._featureToggles.set($6fca919ec0d7c818$var$DEFAULT_FEATURE_TOGGLES);
    }
}

});
parcelRegister("1IWnK", function(module, exports) {

$parcel$export(module.exports, "observable", () => $14172ff2c81b266c$export$5ab46cbf6120b33a);
$parcel$export(module.exports, "Observable", () => $14172ff2c81b266c$export$77cea355fa80b5f4);
$parcel$export(module.exports, "useObservable", () => $14172ff2c81b266c$export$262b072b280a540c);
$parcel$export(module.exports, "useMemoizedObservable", () => $14172ff2c81b266c$export$c632af3a8745bd4c);
$parcel$export(module.exports, "useComputedObservable", () => $14172ff2c81b266c$export$6407b4f871d636e5);

var $81g6h = parcelRequire("81g6h");

var $khy2w = parcelRequire("khy2w");
function $14172ff2c81b266c$var$_extends() {
    $14172ff2c81b266c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $14172ff2c81b266c$var$_extends.apply(this, arguments);
}
function $14172ff2c81b266c$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $14172ff2c81b266c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $14172ff2c81b266c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $14172ff2c81b266c$var$_arrayLikeToArray(o, minLen);
}
function $14172ff2c81b266c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $14172ff2c81b266c$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $14172ff2c81b266c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    it = o[Symbol.iterator]();
    return it.next.bind(it);
}
var $14172ff2c81b266c$export$e8304ac4680ccea;
function $14172ff2c81b266c$export$c53f1c6d6268982b(updater) {
    $14172ff2c81b266c$export$e8304ac4680ccea = updater;
}
var $14172ff2c81b266c$var$PluginManager = /*#__PURE__*/ function() {
    function PluginManager() {
        this._plugins = [];
    }
    var _proto = PluginManager.prototype;
    _proto.use = function use(plugin) {
        this._plugins.push(plugin);
    };
    _proto.onCreate = function onCreate(observable, val) {
        this._plugins.forEach(function(it) {
            return it.onCreate == null ? void 0 : it.onCreate(observable, val);
        });
    };
    _proto.onChange = function onChange(observable, val, prevVal) {
        this._plugins.forEach(function(it) {
            return it.onChange == null ? void 0 : it.onChange(observable, val, prevVal);
        });
    };
    _proto.onBecomeObserved = function onBecomeObserved(observable) {
        this._plugins.forEach(function(it) {
            return it.onBecomeObserved == null ? void 0 : it.onBecomeObserved(observable);
        });
    };
    _proto.onBecomeUnobserved = function onBecomeUnobserved(observable) {
        this._plugins.forEach(function(it) {
            return it.onBecomeUnobserved == null ? void 0 : it.onBecomeUnobserved(observable);
        });
    };
    _proto.onAttach = function onAttach(observable, input) {
        this._plugins.forEach(function(it) {
            return it.onAttach == null ? void 0 : it.onAttach(observable, input);
        });
    };
    _proto.onDetach = function onDetach(observable, input) {
        this._plugins.forEach(function(it) {
            return it.onDetach == null ? void 0 : it.onDetach(observable, input);
        });
    };
    return PluginManager;
}();
var $14172ff2c81b266c$var$UNSET = /*#__PURE__*/ Symbol();
var $14172ff2c81b266c$var$plugins = /*#__PURE__*/ new $14172ff2c81b266c$var$PluginManager();
var $14172ff2c81b266c$var$capturedInputFrames = [];
var $14172ff2c81b266c$var$shouldCaptureNextInput = false;
var $14172ff2c81b266c$var$batchedObservables = [];
var $14172ff2c81b266c$var$batchDepth = 0;
var $14172ff2c81b266c$export$e003c0433d448277 = /*#__PURE__*/ function() {
    function BaseObservable(val, options) {
        if (options === void 0) options = {};
        this._prevVal = $14172ff2c81b266c$var$UNSET;
        this._inputs = [];
        this._outputs = [];
        this._listeners = [];
        this._attachedToInputs = false;
        /**
     * @deprecated Use observable.subscribe() instead
     */ this.onChange = this.subscribe;
        this._val = val;
        this._options = options;
        $14172ff2c81b266c$var$plugins.onCreate(this, val);
    }
    var _proto = BaseObservable.prototype;
    _proto.get = function get() {
        var capturedInputs = $14172ff2c81b266c$var$capturedInputFrames[$14172ff2c81b266c$var$capturedInputFrames.length - 1];
        if (capturedInputs && $14172ff2c81b266c$var$shouldCaptureNextInput) try {
            $14172ff2c81b266c$var$shouldCaptureNextInput = false;
            capturedInputs.push(this);
            return this._get();
        } finally{
            $14172ff2c81b266c$var$shouldCaptureNextInput = true;
        }
        else return this._get();
    };
    _proto._get = function _get() {
        var shouldEvaluate = !this._attachedToInputs || this._prevVal !== $14172ff2c81b266c$var$UNSET;
        return shouldEvaluate ? this._evaluate() : this._val;
    };
    _proto._evaluate = function _evaluate() {
        return this._val;
    };
    _proto._set = function _set(val) {
        if (this._val !== val) {
            this._addToBatchRecursively();
            this._val = val;
        }
    };
    _proto.subscribe = function subscribe(listener) {
        var _this = this;
        this._listeners.push(listener);
        this._attachToInputs();
        var listenerRemoved = false;
        return function() {
            if (!listenerRemoved) {
                listenerRemoved = true;
                _this._listeners.splice(_this._listeners.indexOf(listener), 1);
                _this._detachFromInputs();
            }
        };
    };
    _proto.onBecomeObserved = function onBecomeObserved() {};
    _proto.onBecomeUnobserved = function onBecomeUnobserved() {};
    _proto.getInputs = function getInputs() {
        return this._inputs;
    };
    _proto.getOptions = function getOptions() {
        return this._options;
    };
    _proto.withOptions = function withOptions(options) {
        this._options = $14172ff2c81b266c$var$_extends({}, this._options, options);
        return this;
    };
    BaseObservable._captureInputs = function _captureInputs(block) {
        try {
            var capturedInputs = [];
            $14172ff2c81b266c$var$capturedInputFrames.push(capturedInputs);
            $14172ff2c81b266c$var$shouldCaptureNextInput = true;
            block();
            return capturedInputs;
        } finally{
            $14172ff2c81b266c$var$capturedInputFrames.pop();
            $14172ff2c81b266c$var$shouldCaptureNextInput = false;
        }
    };
    _proto._addInput = function _addInput(input) {
        this._inputs.push(input);
        if (this._attachedToInputs) this._attachToInput(input);
    };
    _proto._removeInput = function _removeInput(input) {
        this._inputs.splice(this._inputs.indexOf(input), 1);
        if (this._attachedToInputs) this._detachFromInput(input);
    };
    _proto._shouldAttachToInputs = function _shouldAttachToInputs() {
        // Only attach to inputs when at least one listener is subscribed to the observable or to one of its outputs.
        // This is done to avoid unused observables being references by their inputs, preventing garbage-collection.
        return this._listeners.length > 0 || this._outputs.length > 0;
    };
    _proto._attachToInputs = function _attachToInputs() {
        if (!this._attachedToInputs && this._shouldAttachToInputs()) {
            this._attachedToInputs = true; // Since the observable was not attached to its inputs, its value may be outdated.
            // Refresh it so that listeners will be called with the correct prevValue the next time an input changes.
            this._val = this._evaluate();
            this.onBecomeObserved();
            $14172ff2c81b266c$var$plugins.onBecomeObserved(this);
            for(var _iterator = $14172ff2c81b266c$var$_createForOfIteratorHelperLoose(this._inputs), _step; !(_step = _iterator()).done;){
                var input = _step.value;
                this._attachToInput(input);
                input._attachToInputs();
            }
        }
    };
    _proto._detachFromInputs = function _detachFromInputs() {
        if (this._attachedToInputs && !this._shouldAttachToInputs()) {
            this._attachedToInputs = false;
            for(var _iterator2 = $14172ff2c81b266c$var$_createForOfIteratorHelperLoose(this._inputs), _step2; !(_step2 = _iterator2()).done;){
                var input = _step2.value;
                this._detachFromInput(input);
                input._detachFromInputs();
            }
            this.onBecomeUnobserved();
            $14172ff2c81b266c$var$plugins.onBecomeUnobserved(this);
        }
    };
    _proto._attachToInput = function _attachToInput(input) {
        input._outputs.push(this);
        $14172ff2c81b266c$var$plugins.onAttach(this, input);
    };
    _proto._detachFromInput = function _detachFromInput(input) {
        input._outputs.splice(input._outputs.indexOf(this), 1);
        $14172ff2c81b266c$var$plugins.onDetach(this, input);
    };
    _proto._addToBatchRecursively = function _addToBatchRecursively() {
        if (this._prevVal === $14172ff2c81b266c$var$UNSET) {
            this._prevVal = this._val; // Add the observable and its outputs in reverse topological order
            for(var _iterator3 = $14172ff2c81b266c$var$_createForOfIteratorHelperLoose(this._outputs), _step3; !(_step3 = _iterator3()).done;){
                var output = _step3.value;
                output._addToBatchRecursively();
            }
            $14172ff2c81b266c$var$batchedObservables.push(this);
        }
    };
    BaseObservable._batch = function _batch(block) {
        try {
            $14172ff2c81b266c$var$batchDepth++;
            if ($14172ff2c81b266c$var$batchDepth === 1 && $14172ff2c81b266c$export$e8304ac4680ccea) $14172ff2c81b266c$export$e8304ac4680ccea(block);
            else block();
        } finally{
            $14172ff2c81b266c$var$batchDepth--;
            if ($14172ff2c81b266c$var$batchDepth === 0) {
                var observablesToUpdate = $14172ff2c81b266c$var$batchedObservables;
                $14172ff2c81b266c$var$batchedObservables = []; // Iterate in reverse order as _addToBatchRecursively() adds them in reverse topological order
                for(var i = observablesToUpdate.length - 1; i >= 0; i--){
                    var observable = observablesToUpdate[i];
                    var prevVal = observable._prevVal;
                    observable._prevVal = $14172ff2c81b266c$var$UNSET;
                    observable._val = observable._evaluate();
                    var val = observable._val;
                    if (val !== prevVal) {
                        for(var _iterator4 = $14172ff2c81b266c$var$_createForOfIteratorHelperLoose(observable._listeners.slice()), _step4; !(_step4 = _iterator4()).done;){
                            var listener = _step4.value;
                            listener(val, prevVal);
                        }
                        $14172ff2c81b266c$var$plugins.onChange(observable, val, prevVal);
                    }
                }
            }
        }
    };
    BaseObservable._use = function _use(plugin) {
        $14172ff2c81b266c$var$plugins.use(plugin);
    };
    return BaseObservable;
}();
function $14172ff2c81b266c$var$memoize(func) {
    var lastArgs;
    var lastResult;
    return function(args) {
        var argsHaveChanged = false;
        if (!lastArgs || args.length !== lastArgs.length) argsHaveChanged = true;
        else {
            for(var i = 0; i < args.length; i++)if (args[i] !== lastArgs[i]) {
                argsHaveChanged = true;
                break;
            }
        }
        if (argsHaveChanged) {
            lastArgs = args;
            lastResult = func(args);
        }
        return lastResult;
    };
}
function $14172ff2c81b266c$export$5ab46cbf6120b33a(val, options) {
    return new $14172ff2c81b266c$export$cc3e5f03c9f686c8(val, options);
}
function $14172ff2c81b266c$export$90b0b54dab0a340a(derive) {
    return $14172ff2c81b266c$export$77cea355fa80b5f4.compute(derive);
}
var $14172ff2c81b266c$export$77cea355fa80b5f4 = /*#__PURE__*/ function(_BaseObservable) {
    $14172ff2c81b266c$var$_inheritsLoose(Observable, _BaseObservable);
    function Observable(val, options) {
        var _this;
        _this = _BaseObservable.call(this, val instanceof Observable ? val.get() : val, options) || this;
        /**
     * @deprecated Use observable.select() instead
     */ _this.transform = _this.select;
        _this._updateValInput(val);
        return _this;
    }
    var _proto = Observable.prototype;
    _proto._evaluate = function _evaluate() {
        return this._valInput ? this._valInput.get() : _BaseObservable.prototype._evaluate.call(this);
    };
    _proto.select = function select(selector) {
        return new $14172ff2c81b266c$var$DerivedObservable([
            this
        ], function(_ref) {
            var val = _ref[0];
            return selector(val);
        });
    };
    _proto.onlyIf = function onlyIf(predicate) {
        var filteredVal = undefined;
        return this.select(function(val) {
            if (predicate(val)) filteredVal = val;
            return filteredVal;
        });
    };
    _proto["default"] = function _default(defaultVal) {
        return this.select(function(val) {
            return val != null ? val : defaultVal;
        });
    };
    _proto.as = function as() {
        return this;
    };
    Observable.select = function select(observables, selector) {
        return new $14172ff2c81b266c$var$DerivedObservable(observables, function(vals) {
            return selector.apply(void 0, vals);
        });
    } /**
   * @deprecated Use Observable.select() instead
   */ ;
    Observable.from = function from() {
        for(var _len = arguments.length, observables = new Array(_len), _key = 0; _key < _len; _key++)observables[_key] = arguments[_key];
        return new $14172ff2c81b266c$var$DerivedObservable(observables, function(values) {
            return values;
        });
    };
    Observable.merge = function merge(observables) {
        return new $14172ff2c81b266c$var$DerivedObservable(observables, function(values) {
            return values;
        });
    };
    Observable.latest = function latest() {
        var prevValues;
        for(var _len2 = arguments.length, observables = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)observables[_key2] = arguments[_key2];
        return new $14172ff2c81b266c$var$DerivedObservable(observables, function(values) {
            var val = !prevValues ? values[0] : values.find(function(it, index) {
                return it !== prevValues[index];
            });
            prevValues = values;
            return val;
        });
    };
    Observable.compute = function compute(_compute) {
        return new $14172ff2c81b266c$var$ComputedObservable(_compute);
    };
    Observable.fromPromise = function fromPromise(promise, onError) {
        var obs = $14172ff2c81b266c$export$5ab46cbf6120b33a(undefined);
        promise.then(function(val) {
            return obs.set(val);
        }, function(e) {
            return onError && obs.set(onError(e));
        });
        return obs;
    };
    _proto.toPromise = function toPromise() {
        var _this2 = this;
        return new Promise(function(resolve) {
            var unsubscribe = _this2.subscribe(function(val) {
                resolve(val);
                unsubscribe();
            });
        });
    };
    Observable.batch = function batch(block) {
        $14172ff2c81b266c$export$e003c0433d448277._batch(block);
    };
    Observable.use = function use(plugin) {
        $14172ff2c81b266c$export$e003c0433d448277._use(plugin);
    };
    _proto._updateValInput = function _updateValInput(val) {
        if (this._valInput !== val) {
            if (this._valInput) {
                this._removeInput(this._valInput);
                this._valInput = undefined;
            }
            if (val instanceof Observable) {
                this._addInput(val);
                this._valInput = val;
            }
        }
    };
    return Observable;
}($14172ff2c81b266c$export$e003c0433d448277);
var $14172ff2c81b266c$export$cc3e5f03c9f686c8 = /*#__PURE__*/ function(_Observable) {
    $14172ff2c81b266c$var$_inheritsLoose(WritableObservable, _Observable);
    function WritableObservable() {
        return _Observable.apply(this, arguments) || this;
    }
    var _proto2 = WritableObservable.prototype;
    _proto2.set = function set(val) {
        var _this3 = this;
        this._updateValInput(val);
        $14172ff2c81b266c$export$77cea355fa80b5f4.batch(function() {
            return _this3._set(val instanceof $14172ff2c81b266c$export$77cea355fa80b5f4 ? val.get() : val);
        });
    };
    _proto2.update = function update(updater) {
        this.set(updater(this.get()));
    };
    _proto2.readOnly = function readOnly() {
        return this;
    };
    return WritableObservable;
}($14172ff2c81b266c$export$77cea355fa80b5f4);
var $14172ff2c81b266c$var$DerivedObservable = /*#__PURE__*/ function(_Observable2) {
    $14172ff2c81b266c$var$_inheritsLoose(DerivedObservable, _Observable2);
    function DerivedObservable(computeInputs, compute) {
        var _this4;
        // No need to initialize it as it will be evaluated the first time get() or subscribe() is called
        _this4 = _Observable2.call(this, undefined) || this;
        _this4._compute = $14172ff2c81b266c$var$memoize(compute);
        _this4._computeInputs = computeInputs;
        for(var _iterator = $14172ff2c81b266c$var$_createForOfIteratorHelperLoose(computeInputs), _step; !(_step = _iterator()).done;){
            var input = _step.value;
            _this4._addInput(input);
        }
        return _this4;
    }
    var _proto3 = DerivedObservable.prototype;
    _proto3._evaluate = function _evaluate() {
        var computed = this._compute(this._computeInputs.map(function(input) {
            return input.get();
        }));
        this._updateValInput(computed);
        return computed instanceof $14172ff2c81b266c$export$77cea355fa80b5f4 ? computed.get() : computed;
    };
    return DerivedObservable;
}($14172ff2c81b266c$export$77cea355fa80b5f4);
var $14172ff2c81b266c$var$ComputedObservable = /*#__PURE__*/ function(_Observable3) {
    $14172ff2c81b266c$var$_inheritsLoose(ComputedObservable, _Observable3);
    function ComputedObservable(compute) {
        var _this5;
        // No need to initialize it as it will be evaluated the first time get() or subscribe() is called
        _this5 = _Observable3.call(this, undefined) || this;
        _this5._currentInputs = new Set();
        _this5._compute = compute;
        return _this5;
    }
    var _proto4 = ComputedObservable.prototype;
    _proto4._evaluate = function _evaluate() {
        var _this6 = this;
        var value;
        var inputs = new Set($14172ff2c81b266c$export$e003c0433d448277._captureInputs(function() {
            return value = _this6._compute();
        }));
        inputs.forEach(function(input) {
            if (!_this6._currentInputs.has(input)) _this6._addInput(input);
            else _this6._currentInputs["delete"](input);
        });
        this._currentInputs.forEach(function(input) {
            return _this6._removeInput(input);
        });
        this._currentInputs = inputs;
        return value;
    };
    return ComputedObservable;
}($14172ff2c81b266c$export$77cea355fa80b5f4);
function $14172ff2c81b266c$export$262b072b280a540c(observable) {
    var _useState = (0, $81g6h.useState)({}), forceRender = _useState[1];
    var val = observable.get();
    (0, $81g6h.useLayoutEffect)(function() {
        return observable.subscribe(function() {
            return forceRender({});
        });
    }, [
        observable
    ]);
    return val;
}
function $14172ff2c81b266c$export$c632af3a8745bd4c(factory, deps) {
    if (deps === void 0) deps = [];
    return $14172ff2c81b266c$export$262b072b280a540c((0, $81g6h.useMemo)(factory, deps));
}
function $14172ff2c81b266c$export$6407b4f871d636e5(compute, deps) {
    if (deps === void 0) deps = [];
    return $14172ff2c81b266c$export$c632af3a8745bd4c(function() {
        return $14172ff2c81b266c$export$77cea355fa80b5f4.compute(compute);
    }, deps);
}
// Code ported from React source-code
function $14172ff2c81b266c$var$is(x, y) {
    return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y;
}
function $14172ff2c81b266c$var$shallowEqual(objA, objB) {
    if ($14172ff2c81b266c$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!objB.hasOwnProperty(keysA[i]) || !$14172ff2c81b266c$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
var $14172ff2c81b266c$export$3cec01b67e6700d9 = function withObservables(Component, mapping) {
    var WithObservables = /*#__PURE__*/ function(_React$PureComponent) {
        $14172ff2c81b266c$var$_inheritsLoose(WithObservables, _React$PureComponent);
        function WithObservables() {
            var _this;
            _this = _React$PureComponent.apply(this, arguments) || this;
            _this._unsubscribers = [];
            return _this;
        }
        var _proto = WithObservables.prototype;
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._unsubscribers.forEach(function(it) {
                return it();
            });
            this._unsubscribers = [];
        };
        _proto.render = function render() {
            this.updateMapping();
            var injectedProps = {};
            for(var _i = 0, _Object$keys = Object.keys(this._mapping); _i < _Object$keys.length; _i++){
                var key = _Object$keys[_i];
                injectedProps[key] = this._mapping[key].get();
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement(Component, $14172ff2c81b266c$var$_extends({}, this.props, injectedProps));
        };
        _proto.updateMapping = function updateMapping() {
            var _this2 = this;
            if (!this._ownProps || !$14172ff2c81b266c$var$shallowEqual(this._ownProps, this.props)) {
                this._ownProps = this.props;
                this._mapping = typeof mapping === "function" ? mapping(this.props) : mapping;
                var unsubscribers = Object.values(this._mapping).map(function(observable) {
                    return observable.subscribe(function() {
                        return _this2.forceUpdate();
                    });
                });
                this._unsubscribers.forEach(function(it) {
                    return it();
                });
                this._unsubscribers = unsubscribers;
            }
        };
        return WithObservables;
    }((0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).PureComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($khy2w)))(WithObservables, Component);
};

});
parcelRegister("khy2w", function(module, exports) {
"use strict";

var $aQ75K = parcelRequire("aQ75K");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $ec3fccbb300b90d9$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $ec3fccbb300b90d9$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $ec3fccbb300b90d9$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $ec3fccbb300b90d9$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $ec3fccbb300b90d9$var$TYPE_STATICS = {};
$ec3fccbb300b90d9$var$TYPE_STATICS[$aQ75K.ForwardRef] = $ec3fccbb300b90d9$var$FORWARD_REF_STATICS;
$ec3fccbb300b90d9$var$TYPE_STATICS[$aQ75K.Memo] = $ec3fccbb300b90d9$var$MEMO_STATICS;
function $ec3fccbb300b90d9$var$getStatics(component) {
    // React v16.11 and below
    if ($aQ75K.isMemo(component)) return $ec3fccbb300b90d9$var$MEMO_STATICS;
     // React v16.12 and above
    return $ec3fccbb300b90d9$var$TYPE_STATICS[component["$$typeof"]] || $ec3fccbb300b90d9$var$REACT_STATICS;
}
var $ec3fccbb300b90d9$var$defineProperty = Object.defineProperty;
var $ec3fccbb300b90d9$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $ec3fccbb300b90d9$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $ec3fccbb300b90d9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $ec3fccbb300b90d9$var$getPrototypeOf = Object.getPrototypeOf;
var $ec3fccbb300b90d9$var$objectPrototype = Object.prototype;
function $ec3fccbb300b90d9$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($ec3fccbb300b90d9$var$objectPrototype) {
            var inheritedComponent = $ec3fccbb300b90d9$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $ec3fccbb300b90d9$var$objectPrototype) $ec3fccbb300b90d9$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $ec3fccbb300b90d9$var$getOwnPropertyNames(sourceComponent);
        if ($ec3fccbb300b90d9$var$getOwnPropertySymbols) keys = keys.concat($ec3fccbb300b90d9$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $ec3fccbb300b90d9$var$getStatics(targetComponent);
        var sourceStatics = $ec3fccbb300b90d9$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$ec3fccbb300b90d9$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $ec3fccbb300b90d9$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $ec3fccbb300b90d9$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $ec3fccbb300b90d9$var$hoistNonReactStatics;

});
parcelRegister("aQ75K", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7olBK"));

});
parcelRegister("7olBK", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $561b892c4e22bb7e$export$2b8d127b894957b9, (v) => $561b892c4e22bb7e$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $561b892c4e22bb7e$export$cea3a54a6425200c, (v) => $561b892c4e22bb7e$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $561b892c4e22bb7e$export$a7c73072b1a182ae, (v) => $561b892c4e22bb7e$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $561b892c4e22bb7e$export$9f27bc3417b4524d, (v) => $561b892c4e22bb7e$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $561b892c4e22bb7e$export$db77ccec0bb4ccac, (v) => $561b892c4e22bb7e$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $561b892c4e22bb7e$export$8392c0c9d3dcbd35, (v) => $561b892c4e22bb7e$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $561b892c4e22bb7e$export$ffb0004e005737fa, (v) => $561b892c4e22bb7e$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $561b892c4e22bb7e$export$b624eff549462981, (v) => $561b892c4e22bb7e$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $561b892c4e22bb7e$export$7897aa7841a5380c, (v) => $561b892c4e22bb7e$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $561b892c4e22bb7e$export$602eac185826482c, (v) => $561b892c4e22bb7e$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $561b892c4e22bb7e$export$e2c29f18771995cb, (v) => $561b892c4e22bb7e$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $561b892c4e22bb7e$export$5f8d39834fd61797, (v) => $561b892c4e22bb7e$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $561b892c4e22bb7e$export$74bf444e3cd11ea5, (v) => $561b892c4e22bb7e$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $561b892c4e22bb7e$export$92387174baf9b227, (v) => $561b892c4e22bb7e$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $561b892c4e22bb7e$export$ec112efeb987d9c6, (v) => $561b892c4e22bb7e$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $561b892c4e22bb7e$export$b706b080d889d2c9, (v) => $561b892c4e22bb7e$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $561b892c4e22bb7e$export$5be5a87408f70ddc, (v) => $561b892c4e22bb7e$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $561b892c4e22bb7e$export$45a5e7f76e0caa8d, (v) => $561b892c4e22bb7e$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $561b892c4e22bb7e$export$455c2e768291efa6, (v) => $561b892c4e22bb7e$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $561b892c4e22bb7e$export$9522e17588c12572, (v) => $561b892c4e22bb7e$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $561b892c4e22bb7e$export$2110ac352bb060b9, (v) => $561b892c4e22bb7e$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $561b892c4e22bb7e$export$56885ab8b9c456ab, (v) => $561b892c4e22bb7e$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $561b892c4e22bb7e$export$d927fcb6adf8f9de, (v) => $561b892c4e22bb7e$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $561b892c4e22bb7e$export$b82d16f27459e05a, (v) => $561b892c4e22bb7e$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $561b892c4e22bb7e$export$522c17b4f5e123e8, (v) => $561b892c4e22bb7e$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $561b892c4e22bb7e$export$1aabd8a0274ecfd6, (v) => $561b892c4e22bb7e$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $561b892c4e22bb7e$export$9b621391a187a31a, (v) => $561b892c4e22bb7e$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $561b892c4e22bb7e$export$f5bbd400c2f4426f, (v) => $561b892c4e22bb7e$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $561b892c4e22bb7e$export$2b8d127b894957b9;
var $561b892c4e22bb7e$export$cea3a54a6425200c;
var $561b892c4e22bb7e$export$a7c73072b1a182ae;
var $561b892c4e22bb7e$export$9f27bc3417b4524d;
var $561b892c4e22bb7e$export$db77ccec0bb4ccac;
var $561b892c4e22bb7e$export$8392c0c9d3dcbd35;
var $561b892c4e22bb7e$export$ffb0004e005737fa;
var $561b892c4e22bb7e$export$b624eff549462981;
var $561b892c4e22bb7e$export$7897aa7841a5380c;
var $561b892c4e22bb7e$export$602eac185826482c;
var $561b892c4e22bb7e$export$e2c29f18771995cb;
var $561b892c4e22bb7e$export$5f8d39834fd61797;
var $561b892c4e22bb7e$export$74bf444e3cd11ea5;
var $561b892c4e22bb7e$export$92387174baf9b227;
var $561b892c4e22bb7e$export$ec112efeb987d9c6;
var $561b892c4e22bb7e$export$b706b080d889d2c9;
var $561b892c4e22bb7e$export$5be5a87408f70ddc;
var $561b892c4e22bb7e$export$45a5e7f76e0caa8d;
var $561b892c4e22bb7e$export$455c2e768291efa6;
var $561b892c4e22bb7e$export$9522e17588c12572;
var $561b892c4e22bb7e$export$2110ac352bb060b9;
var $561b892c4e22bb7e$export$56885ab8b9c456ab;
var $561b892c4e22bb7e$export$d927fcb6adf8f9de;
var $561b892c4e22bb7e$export$b82d16f27459e05a;
var $561b892c4e22bb7e$export$522c17b4f5e123e8;
var $561b892c4e22bb7e$export$1aabd8a0274ecfd6;
var $561b892c4e22bb7e$export$9b621391a187a31a;
var $561b892c4e22bb7e$export$f5bbd400c2f4426f;
"use strict";
var $561b892c4e22bb7e$var$b = "function" === typeof Symbol && Symbol.for, $561b892c4e22bb7e$var$c = $561b892c4e22bb7e$var$b ? Symbol.for("react.element") : 60103, $561b892c4e22bb7e$var$d = $561b892c4e22bb7e$var$b ? Symbol.for("react.portal") : 60106, $561b892c4e22bb7e$var$e = $561b892c4e22bb7e$var$b ? Symbol.for("react.fragment") : 60107, $561b892c4e22bb7e$var$f = $561b892c4e22bb7e$var$b ? Symbol.for("react.strict_mode") : 60108, $561b892c4e22bb7e$var$g = $561b892c4e22bb7e$var$b ? Symbol.for("react.profiler") : 60114, $561b892c4e22bb7e$var$h = $561b892c4e22bb7e$var$b ? Symbol.for("react.provider") : 60109, $561b892c4e22bb7e$var$k = $561b892c4e22bb7e$var$b ? Symbol.for("react.context") : 60110, $561b892c4e22bb7e$var$l = $561b892c4e22bb7e$var$b ? Symbol.for("react.async_mode") : 60111, $561b892c4e22bb7e$var$m = $561b892c4e22bb7e$var$b ? Symbol.for("react.concurrent_mode") : 60111, $561b892c4e22bb7e$var$n = $561b892c4e22bb7e$var$b ? Symbol.for("react.forward_ref") : 60112, $561b892c4e22bb7e$var$p = $561b892c4e22bb7e$var$b ? Symbol.for("react.suspense") : 60113, $561b892c4e22bb7e$var$q = $561b892c4e22bb7e$var$b ? Symbol.for("react.suspense_list") : 60120, $561b892c4e22bb7e$var$r = $561b892c4e22bb7e$var$b ? Symbol.for("react.memo") : 60115, $561b892c4e22bb7e$var$t = $561b892c4e22bb7e$var$b ? Symbol.for("react.lazy") : 60116, $561b892c4e22bb7e$var$v = $561b892c4e22bb7e$var$b ? Symbol.for("react.block") : 60121, $561b892c4e22bb7e$var$w = $561b892c4e22bb7e$var$b ? Symbol.for("react.fundamental") : 60117, $561b892c4e22bb7e$var$x = $561b892c4e22bb7e$var$b ? Symbol.for("react.responder") : 60118, $561b892c4e22bb7e$var$y = $561b892c4e22bb7e$var$b ? Symbol.for("react.scope") : 60119;
function $561b892c4e22bb7e$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $561b892c4e22bb7e$var$c:
                switch(a = a.type, a){
                    case $561b892c4e22bb7e$var$l:
                    case $561b892c4e22bb7e$var$m:
                    case $561b892c4e22bb7e$var$e:
                    case $561b892c4e22bb7e$var$g:
                    case $561b892c4e22bb7e$var$f:
                    case $561b892c4e22bb7e$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $561b892c4e22bb7e$var$k:
                            case $561b892c4e22bb7e$var$n:
                            case $561b892c4e22bb7e$var$t:
                            case $561b892c4e22bb7e$var$r:
                            case $561b892c4e22bb7e$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $561b892c4e22bb7e$var$d:
                return u;
        }
    }
}
function $561b892c4e22bb7e$var$A(a) {
    return $561b892c4e22bb7e$var$z(a) === $561b892c4e22bb7e$var$m;
}
$561b892c4e22bb7e$export$2b8d127b894957b9 = $561b892c4e22bb7e$var$l;
$561b892c4e22bb7e$export$cea3a54a6425200c = $561b892c4e22bb7e$var$m;
$561b892c4e22bb7e$export$a7c73072b1a182ae = $561b892c4e22bb7e$var$k;
$561b892c4e22bb7e$export$9f27bc3417b4524d = $561b892c4e22bb7e$var$h;
$561b892c4e22bb7e$export$db77ccec0bb4ccac = $561b892c4e22bb7e$var$c;
$561b892c4e22bb7e$export$8392c0c9d3dcbd35 = $561b892c4e22bb7e$var$n;
$561b892c4e22bb7e$export$ffb0004e005737fa = $561b892c4e22bb7e$var$e;
$561b892c4e22bb7e$export$b624eff549462981 = $561b892c4e22bb7e$var$t;
$561b892c4e22bb7e$export$7897aa7841a5380c = $561b892c4e22bb7e$var$r;
$561b892c4e22bb7e$export$602eac185826482c = $561b892c4e22bb7e$var$d;
$561b892c4e22bb7e$export$e2c29f18771995cb = $561b892c4e22bb7e$var$g;
$561b892c4e22bb7e$export$5f8d39834fd61797 = $561b892c4e22bb7e$var$f;
$561b892c4e22bb7e$export$74bf444e3cd11ea5 = $561b892c4e22bb7e$var$p;
$561b892c4e22bb7e$export$92387174baf9b227 = function(a) {
    return $561b892c4e22bb7e$var$A(a) || $561b892c4e22bb7e$var$z(a) === $561b892c4e22bb7e$var$l;
};
$561b892c4e22bb7e$export$ec112efeb987d9c6 = $561b892c4e22bb7e$var$A;
$561b892c4e22bb7e$export$b706b080d889d2c9 = function(a) {
    return $561b892c4e22bb7e$var$z(a) === $561b892c4e22bb7e$var$k;
};
$561b892c4e22bb7e$export$5be5a87408f70ddc = function(a) {
    return $561b892c4e22bb7e$var$z(a) === $561b892c4e22bb7e$var$h;
};
$561b892c4e22bb7e$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $561b892c4e22bb7e$var$c;
};
$561b892c4e22bb7e$export$455c2e768291efa6 = function(a) {
    return $561b892c4e22bb7e$var$z(a) === $561b892c4e22bb7e$var$n;
};
$561b892c4e22bb7e$export$9522e17588c12572 = function(a) {
    return $561b892c4e22bb7e$var$z(a) === $561b892c4e22bb7e$var$e;
};
$561b892c4e22bb7e$export$2110ac352bb060b9 = function(a) {
    return $561b892c4e22bb7e$var$z(a) === $561b892c4e22bb7e$var$t;
};
$561b892c4e22bb7e$export$56885ab8b9c456ab = function(a) {
    return $561b892c4e22bb7e$var$z(a) === $561b892c4e22bb7e$var$r;
};
$561b892c4e22bb7e$export$d927fcb6adf8f9de = function(a) {
    return $561b892c4e22bb7e$var$z(a) === $561b892c4e22bb7e$var$d;
};
$561b892c4e22bb7e$export$b82d16f27459e05a = function(a) {
    return $561b892c4e22bb7e$var$z(a) === $561b892c4e22bb7e$var$g;
};
$561b892c4e22bb7e$export$522c17b4f5e123e8 = function(a) {
    return $561b892c4e22bb7e$var$z(a) === $561b892c4e22bb7e$var$f;
};
$561b892c4e22bb7e$export$1aabd8a0274ecfd6 = function(a) {
    return $561b892c4e22bb7e$var$z(a) === $561b892c4e22bb7e$var$p;
};
$561b892c4e22bb7e$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $561b892c4e22bb7e$var$e || a === $561b892c4e22bb7e$var$m || a === $561b892c4e22bb7e$var$g || a === $561b892c4e22bb7e$var$f || a === $561b892c4e22bb7e$var$p || a === $561b892c4e22bb7e$var$q || "object" === typeof a && null !== a && (a.$$typeof === $561b892c4e22bb7e$var$t || a.$$typeof === $561b892c4e22bb7e$var$r || a.$$typeof === $561b892c4e22bb7e$var$h || a.$$typeof === $561b892c4e22bb7e$var$k || a.$$typeof === $561b892c4e22bb7e$var$n || a.$$typeof === $561b892c4e22bb7e$var$w || a.$$typeof === $561b892c4e22bb7e$var$x || a.$$typeof === $561b892c4e22bb7e$var$y || a.$$typeof === $561b892c4e22bb7e$var$v);
};
$561b892c4e22bb7e$export$f5bbd400c2f4426f = $561b892c4e22bb7e$var$z;

});






parcelRegister("5ALBt", function(module, exports) {

$parcel$export(module.exports, "GoogleAnalyticsTracker", () => $2ce8daa41bc02513$export$789145a5b0b8ddb8);

var $3qtRD = parcelRequire("3qtRD");

var $eOSo1 = parcelRequire("eOSo1");
class $2ce8daa41bc02513$export$789145a5b0b8ddb8 extends (0, $3qtRD.AnalyticsTracker) {
    async trackEvent(e) {
        const gaEvent = this.googleAnalyticsEventFromAnalyticsEvent(e);
        const success = this.push(gaEvent);
    }
    async setCustomDimension(dimensionName, dimensionValue) {
        const success = this.push({
            [dimensionName]: dimensionValue
        });
    }
    async trackView(customTitle, customUrl) {
        if (customUrl) {
            const success = this.push({
                event: "pageView",
                pageVirtualURL: customUrl,
                pageVirtualTitle: customTitle ?? ""
            });
        }
    }
    push(e) {
        if (!window.dataLayer) return false;
        window.dataLayer.push(e);
        return true;
    }
    googleAnalyticsEventFromAnalyticsEvent(event) {
        return {
            event: "googleAnalyticsEvent",
            eventCategory: event.category,
            eventAction: event.action,
            eventLabel: this.buildParamsLabel(event.params)
        };
    }
    constructor(...args){
        super(...args);
        this.logger = (0, $eOSo1.getLogger)("\uD83D\uDCCA\uFE0F [GA Analytics]");
    }
}

});
parcelRegister("3qtRD", function(module, exports) {

$parcel$export(module.exports, "AnalyticsTracker", () => $fd4015cda00b5dd2$export$db78b92a799823ab);

var $lTdpc = parcelRequire("lTdpc");
const $fd4015cda00b5dd2$export$fa60bbc85e85c60d = "_";
class $fd4015cda00b5dd2$export$db78b92a799823ab {
    async setUserId(userId) {
        await this.setCustomDimension("PTID", userId);
    }
    buildParamsLabel(params) {
        if ((0, $lTdpc.isNotNil)(params)) return params.map((param)=>(0, $lTdpc.isNotNil)(param) ? param : $fd4015cda00b5dd2$export$fa60bbc85e85c60d).join(" | ");
        return "";
    }
}

});
parcelRegister("lTdpc", function(module, exports) {

$parcel$export(module.exports, "isNotNil", () => $19776effb8b29dad$export$7e515ab5fbd92bef);
$parcel$export(module.exports, "isNil", () => $19776effb8b29dad$export$984f70f9382f5d27);
$parcel$export(module.exports, "isNotEmpty", () => $19776effb8b29dad$export$a079a83b07f794bf);
const $19776effb8b29dad$export$7e515ab5fbd92bef = (data)=>!$19776effb8b29dad$export$984f70f9382f5d27(data);
const $19776effb8b29dad$export$984f70f9382f5d27 = (data)=>data === undefined || data === null;
function $19776effb8b29dad$export$a079a83b07f794bf(data) {
    return $19776effb8b29dad$export$7e515ab5fbd92bef(data) && data.trim().length > 0;
}

});


parcelRegister("eOSo1", function(module, exports) {

$parcel$export(module.exports, "getLogger", () => $24a490179141d395$export$2b1d391cd05230fd);
const $24a490179141d395$export$2b1d391cd05230fd = (prefix)=>({
        trace: (message, ...optionalParams)=>console.trace(prefix, message, ...optionalParams),
        debug: (message, ...optionalParams)=>console.debug(prefix, message, ...optionalParams),
        info: (message, ...optionalParams)=>console.info(prefix, message, ...optionalParams),
        warn: (message, ...optionalParams)=>console.warn(prefix, message, ...optionalParams),
        error: (message, ...optionalParams)=>console.error(prefix, message, ...optionalParams)
    });

});


parcelRegister("d5fcV", function(module, exports) {

$parcel$export(module.exports, "AuthenticatedApiService", () => $c9deb4e958c8571b$export$be16b81832b103d6);

var $4GOaR = parcelRequire("4GOaR");

var $9Y5ps = parcelRequire("9Y5ps");

var $2bI8n = parcelRequire("2bI8n");

var $dabJv = parcelRequire("dabJv");

var $jpxp5 = parcelRequire("jpxp5");

var $1EYnA = parcelRequire("1EYnA");

var $3c9p6 = parcelRequire("3c9p6");

var $aEup4 = parcelRequire("aEup4");

var $jVUCX = parcelRequire("jVUCX");
class $c9deb4e958c8571b$export$be16b81832b103d6 {
    constructor(axiosInstanceProvider, authService, infraManager, userStatusManager, announcementReceivedService, errorManager){
        this.axiosInstanceProvider = axiosInstanceProvider;
        this.authService = authService;
        this.infraManager = infraManager;
        this.userStatusManager = userStatusManager;
        this.announcementReceivedService = announcementReceivedService;
        this.errorManager = errorManager;
        this.axiosInstance = this.initiateAxiosInstance();
        infraManager.targetInfraChanged.add(this.refreshAxiosInstance.bind(this));
    }
    refreshAxiosInstance() {
        this.axiosInstance = this.initiateAxiosInstance();
    }
    initiateAxiosInstance() {
        const axiosInstance = this.axiosInstanceProvider();
        (0, $aEup4.addRequestInterceptor)(axiosInstance, (0, $9Y5ps.addBaseUrlInterceptor)(this.infraManager));
        (0, $aEup4.addRequestInterceptor)(axiosInstance, (0, $4GOaR.addAuthorizationInterceptor)(this.authService));
        (0, $aEup4.addResponseInterceptor)(axiosInstance, (0, $2bI8n.errorHandlingInterceptor)(this.errorManager));
        (0, $aEup4.addResponseInterceptor)(axiosInstance, (0, $jpxp5.getPTStatusInterceptor)(this.userStatusManager));
        (0, $aEup4.addResponseInterceptor)(axiosInstance, (0, $1EYnA.getHcpStatusInterceptor)(this.userStatusManager));
        (0, $aEup4.addResponseInterceptor)(axiosInstance, (0, $3c9p6.getIdentityStatusInterceptor)(this.userStatusManager));
        (0, $aEup4.addResponseInterceptor)(axiosInstance, (0, $jVUCX.notificationCountInterceptor)());
        (0, $aEup4.addResponseInterceptor)(axiosInstance, (0, $dabJv.getLatestAnnouncementId)(this.announcementReceivedService));
        return axiosInstance;
    }
    get(url, config) {
        return this.axiosInstance.get(url, config);
    }
    post(url, data, config) {
        return this.axiosInstance.post(url, data, config);
    }
    put(url, data, config) {
        return this.axiosInstance.put(url, data, config);
    }
    delete(url, config) {
        return this.axiosInstance.delete(url, config);
    }
}

});
parcelRegister("4GOaR", function(module, exports) {

$parcel$export(module.exports, "addAuthorizationInterceptor", () => $3cb118a8b575e9c2$export$d759b701deb95aa1);
const $3cb118a8b575e9c2$export$d759b701deb95aa1 = (authenticationService)=>({
        onFulfilled: async (config)=>{
            const token = await authenticationService.getToken();
            return {
                ...config,
                headers: token ? {
                    ...config.headers,
                    Authorization: `Bearer ${token}`
                } : config.headers
            };
        }
    });

});

parcelRegister("9Y5ps", function(module, exports) {

$parcel$export(module.exports, "addBaseUrlInterceptor", () => $52f29d402818c170$export$e3834c5ea0e5b9dd);

var $5xCsV = parcelRequire("5xCsV");

var $lTdpc = parcelRequire("lTdpc");
const $52f29d402818c170$export$e3834c5ea0e5b9dd = (infraManager)=>({
        onFulfilled: (config)=>{
            const targetBaseUrl = infraManager.targetInfra?.apiUrl;
            if ((0, $lTdpc.isNotNil)(targetBaseUrl)) return {
                ...config,
                url: `${targetBaseUrl}${config.url}`
            };
            return Promise.reject(new (0, $5xCsV.NoTargetInfraError)(`Api calls are forbidden until an infra is targeted. Url was ${config.url}`));
        }
    });

});
parcelRegister("5xCsV", function(module, exports) {

$parcel$export(module.exports, "NoTargetInfraError", () => $a6676ebb6d6d6e60$export$826256f091feca48);
class $a6676ebb6d6d6e60$export$826256f091feca48 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("2bI8n", function(module, exports) {

$parcel$export(module.exports, "errorHandlingInterceptor", () => $3d5341132a882d39$export$3aedfb1187bff05e);

var $04Qjn = parcelRequire("04Qjn");

var $2hJI5 = parcelRequire("2hJI5");
const $3d5341132a882d39$export$3aedfb1187bff05e = (errorManager)=>({
        onRejected: (error)=>{
            if ((0, $2hJI5.isAxiosError)(error) && error.response) {
                if (error.response.data && (0, $04Qjn.isApiError)(error.response.data)) {
                    errorManager?.handleCustomApiError(error.response.data);
                    const apiError = Object.assign(new Error("ApiError"), error.response.data);
                    return Promise.reject(apiError);
                }
                const data = {
                    path: "unknown",
                    status: error.response.status
                };
                const apiError = Object.assign(new Error("ApiError"), data);
                return Promise.reject(apiError);
            }
            return Promise.reject(error);
        }
    });

});
parcelRegister("04Qjn", function(module, exports) {

$parcel$export(module.exports, "isApiError", () => $7700b389e0d28287$export$89d83cc97c52a37);

var $gMt2l = parcelRequire("gMt2l");
function $7700b389e0d28287$export$89d83cc97c52a37(error) {
    if (error === null || error === undefined || typeof error !== "object") return false;
    if (!(0, $gMt2l.hasOwnProperty)(error, "path") || typeof error.path !== "string") return false;
    if (!(0, $gMt2l.hasOwnProperty)(error, "status") || typeof error.status !== "number") return false;
    return true;
}

});
parcelRegister("gMt2l", function(module, exports) {

$parcel$export(module.exports, "hasOwnProperty", () => $e1bd02a6a52c0bca$export$5a15a386532a5ea4);
// eslint-disable-next-line @typescript-eslint/ban-types
function $e1bd02a6a52c0bca$export$5a15a386532a5ea4(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});


parcelRegister("2hJI5", function(module, exports) {

$parcel$export(module.exports, "isAxiosError", () => $43e9e7fd30e7a149$export$fbafdbe06a5b5a9a);
function $43e9e7fd30e7a149$export$fbafdbe06a5b5a9a(error) {
    return error.isAxiosError;
}

});


parcelRegister("dabJv", function(module, exports) {

$parcel$export(module.exports, "getLatestAnnouncementId", () => $2fa35a012506f8be$export$38a6bddf6fec5413);

var $lTdpc = parcelRequire("lTdpc");
const $2fa35a012506f8be$export$38a6bddf6fec5413 = (announcementReceivedService)=>({
        onFulfilled: async (response)=>{
            const headerValue = response.headers["x-pt-latest-announcement-id"];
            if ((0, $lTdpc.isNotNil)(headerValue)) announcementReceivedService.onAnnouncementIdReceived.dispatch(headerValue);
            return response;
        }
    });

});

parcelRegister("jpxp5", function(module, exports) {

$parcel$export(module.exports, "getPTStatusInterceptor", () => $94f7310745a6c9a2$export$540cfc070b4f6032);

var $02mFA = parcelRequire("02mFA");

var $lTdpc = parcelRequire("lTdpc");
const $94f7310745a6c9a2$export$540cfc070b4f6032 = (userStatusManager)=>({
        onFulfilled: async (response)=>{
            const ptStatusHeaderValue = response.headers["x-pt-registration-status"];
            if ((0, $lTdpc.isNotNil)(ptStatusHeaderValue)) {
                const ptStatus = (0, $02mFA.RegistrationStatus)[ptStatusHeaderValue];
                if ((0, $lTdpc.isNotNil)(ptStatus)) userStatusManager.updatePtRegistrationStatus(ptStatus);
            }
            return response;
        }
    });

});
parcelRegister("02mFA", function(module, exports) {

$parcel$export(module.exports, "RegistrationStatus", () => $81728ae9f1eb893c$export$8c65819fe6ca1f5c);
$parcel$export(module.exports, "IdentityStatus", () => $81728ae9f1eb893c$export$a88ec8b3f218caff);
$parcel$export(module.exports, "PtNotificationPreferencesType", () => $81728ae9f1eb893c$export$8deef480235eb20d);
$parcel$export(module.exports, "PtNotificationPreferencesStatus", () => $81728ae9f1eb893c$export$e795dc0c9d3acdf7);
var $81728ae9f1eb893c$export$8c65819fe6ca1f5c;
(function(RegistrationStatus) {
    RegistrationStatus["PENDING"] = "PENDING";
    RegistrationStatus["VALIDATED"] = "VALIDATED";
    RegistrationStatus["REJECTED"] = "REJECTED";
    RegistrationStatus["INCOMPLETE"] = "INCOMPLETE";
    RegistrationStatus["ONFIDO_REJECTED"] = "ONFIDO_REJECTED";
    RegistrationStatus["NOT_NEEDED"] = "NOT_NEEDED";
})($81728ae9f1eb893c$export$8c65819fe6ca1f5c || ($81728ae9f1eb893c$export$8c65819fe6ca1f5c = {}));
var $81728ae9f1eb893c$export$a88ec8b3f218caff;
(function(IdentityStatus) {
    IdentityStatus["NOT_NEEDED"] = "NOT_NEEDED";
    IdentityStatus["PENDING"] = "PENDING";
    IdentityStatus["VALIDATED"] = "VALIDATED";
    IdentityStatus["INCOMPLETE"] = "INCOMPLETE";
})($81728ae9f1eb893c$export$a88ec8b3f218caff || ($81728ae9f1eb893c$export$a88ec8b3f218caff = {}));
var $81728ae9f1eb893c$export$8deef480235eb20d;
(function(PtNotificationPreferencesType) {
    PtNotificationPreferencesType["PHYSIO_ME"] = "PHYSIO_ME";
    PtNotificationPreferencesType["BIOGEN"] = "BIOGEN";
    PtNotificationPreferencesType["PATIENT_PROGRAM_STARTED"] = "PATIENT_PROGRAM_STARTED";
    PtNotificationPreferencesType["PATIENT_PROGRAM_ENDING_SOON"] = "PATIENT_PROGRAM_ENDING_SOON";
    PtNotificationPreferencesType["PATIENT_PROGRAM_ENDED"] = "PATIENT_PROGRAM_ENDED";
    PtNotificationPreferencesType["PATIENT_REGISTERED"] = "PATIENT_REGISTERED";
    PtNotificationPreferencesType["HCT_INVITATION_ACCEPTED"] = "HCT_INVITATION_ACCEPTED";
    PtNotificationPreferencesType["MONTHLY_RECAP"] = "MONTHLY_RECAP";
})($81728ae9f1eb893c$export$8deef480235eb20d || ($81728ae9f1eb893c$export$8deef480235eb20d = {}));
var $81728ae9f1eb893c$export$e795dc0c9d3acdf7;
(function(PtNotificationPreferencesStatus) {
    PtNotificationPreferencesStatus["ENABLED"] = "ENABLED";
    PtNotificationPreferencesStatus["DISABLED"] = "DISABLED";
    PtNotificationPreferencesStatus["NA"] = "NA";
})($81728ae9f1eb893c$export$e795dc0c9d3acdf7 || ($81728ae9f1eb893c$export$e795dc0c9d3acdf7 = {}));

});


parcelRegister("1EYnA", function(module, exports) {

$parcel$export(module.exports, "getHcpStatusInterceptor", () => $b7c105898ac8484b$export$b820c0e346975149);

var $02mFA = parcelRequire("02mFA");

var $lTdpc = parcelRequire("lTdpc");
const $b7c105898ac8484b$export$b820c0e346975149 = (userStatusManager)=>({
        onFulfilled: async (response)=>{
            const ptHcpStatusHeaderValue = response.headers["x-pt-hcp-status"];
            if ((0, $lTdpc.isNotNil)(ptHcpStatusHeaderValue)) {
                const hcpStatus = (0, $02mFA.RegistrationStatus)[ptHcpStatusHeaderValue];
                if ((0, $lTdpc.isNotNil)(hcpStatus)) userStatusManager.updateHcpStatus(hcpStatus);
            }
            return response;
        }
    });

});

parcelRegister("3c9p6", function(module, exports) {

$parcel$export(module.exports, "getIdentityStatusInterceptor", () => $edb2e01cf056fa80$export$edffee20ad5585d5);

var $02mFA = parcelRequire("02mFA");

var $lTdpc = parcelRequire("lTdpc");
const $edb2e01cf056fa80$export$edffee20ad5585d5 = (userStatusManager)=>({
        onFulfilled: async (response)=>{
            const identityStatusHeaderValue = response.headers["x-pt-identity-status"];
            if ((0, $lTdpc.isNotNil)(identityStatusHeaderValue)) {
                const identityStatus = (0, $02mFA.IdentityStatus)[identityStatusHeaderValue];
                if ((0, $lTdpc.isNotNil)(identityStatus)) userStatusManager.updateIdentityStatus(identityStatus);
            }
            return response;
        }
    });

});

parcelRegister("aEup4", function(module, exports) {

$parcel$export(module.exports, "addRequestInterceptor", () => $1b193941bfff9df7$export$3be7240099dfcd9f);
$parcel$export(module.exports, "addResponseInterceptor", () => $1b193941bfff9df7$export$3ceabb822ce04969);
$parcel$export(module.exports, "removeResponseInterceptor", () => $1b193941bfff9df7$export$3f30d03a6f01a6a3);
function $1b193941bfff9df7$export$3be7240099dfcd9f(axiosInstance, interceptor) {
    return axiosInstance.interceptors.request.use(interceptor.onFulfilled, interceptor.onRejected);
}
function $1b193941bfff9df7$export$3ceabb822ce04969(axiosInstance, interceptor) {
    return axiosInstance.interceptors.response.use(interceptor.onFulfilled, interceptor.onRejected);
}
function $1b193941bfff9df7$export$3f30d03a6f01a6a3(axiosInstance, interceptorId) {
    axiosInstance.interceptors.response.eject(interceptorId);
}

});

parcelRegister("jVUCX", function(module, exports) {

$parcel$export(module.exports, "notificationCountInterceptor", () => $c88f849c1862034a$export$ee3dff9464391381);

var $ghfIB = parcelRequire("ghfIB");
const $c88f849c1862034a$export$ee3dff9464391381 = ()=>({
        onFulfilled: async (response)=>{
            const unreadNotificationCount = parseInt(response.headers["x-unread-notification-count"]);
            const hasUnsentNotifications = response.headers["x-has-unsent-notifications"] === "true";
            if (unreadNotificationCount >= 0) try {
                (0, $ghfIB.notificationManager).updateUnreadCount(unreadNotificationCount);
            } catch (e) {
                console.error("[notificationCountInterceptor] Failed to update new unread notification count", e);
            }
            if (hasUnsentNotifications) try {
                await (0, $ghfIB.notificationManager).fetchUnsentNotifications();
            } catch (e) {
                console.error("[notificationCountInterceptor] Failed to fetch unsent notifications", e);
            }
            return response;
        },
        onRejected: (error)=>Promise.reject(error)
    });

});


parcelRegister("4ppMx", function(module, exports) {

$parcel$export(module.exports, "ApiServiceWithErrorHandler", () => $0a8372a256dc63fa$export$db294e90cbf533ed);
const $0a8372a256dc63fa$var$defaultGetErrorReporter = ()=>false;
const $0a8372a256dc63fa$var$defaultOtherErrorsReporter = ()=>true;
class $0a8372a256dc63fa$export$db294e90cbf533ed {
    constructor(innerApiService, errorHandler, analyticsHandler){
        this.innerApiService = innerApiService;
        this.errorHandler = errorHandler;
        this.analyticsHandler = analyticsHandler;
    }
    get axiosInstance() {
        return this.innerApiService.axiosInstance;
    }
    async get(url, config, reportError = $0a8372a256dc63fa$var$defaultGetErrorReporter) {
        try {
            this.errorHandler.clearError();
            return await this.innerApiService.get(url, config);
        } catch (error) {
            this.trackError(error, "GET", url);
            this.reportErrorOptional(error, reportError);
            throw error;
        }
    }
    async post(url, data, config, reportError = $0a8372a256dc63fa$var$defaultOtherErrorsReporter) {
        try {
            this.errorHandler.clearError();
            return await this.innerApiService.post(url, data, config);
        } catch (error) {
            this.trackError(error, "POST", url);
            this.reportErrorOptional(error, reportError);
            throw error;
        }
    }
    async put(url, data, config, reportError = $0a8372a256dc63fa$var$defaultOtherErrorsReporter) {
        try {
            this.errorHandler.clearError();
            return await this.innerApiService.put(url, data, config);
        } catch (error) {
            this.trackError(error, "PUT", url);
            this.reportErrorOptional(error, reportError);
            throw error;
        }
    }
    async delete(url, config, reportError = $0a8372a256dc63fa$var$defaultOtherErrorsReporter) {
        try {
            this.errorHandler.clearError();
            return await this.innerApiService.delete(url, config);
        } catch (error) {
            this.trackError(error, "DELETE", url);
            this.reportErrorOptional(error, reportError);
            throw error;
        }
    }
    reportErrorOptional(error, reportErrors) {
        if (reportErrors(error)) this.errorHandler.reportError(error);
    }
    trackError(error, method, url) {
        this.analyticsHandler.trackError(error, [
            method,
            url
        ]);
    }
}

});

parcelRegister("lWryN", function(module, exports) {

$parcel$export(module.exports, "ExternalApiService", () => $17c9122588a32959$export$492b418da17c30a5);

var $2bI8n = parcelRequire("2bI8n");

var $aEup4 = parcelRequire("aEup4");

var $hPUY2 = parcelRequire("hPUY2");
class $17c9122588a32959$export$492b418da17c30a5 {
    constructor(axiosInstanceProvider){
        this.axiosInstanceProvider = axiosInstanceProvider;
        this.axiosInstance = this.initiateAxiosInstance();
    }
    initiateAxiosInstance() {
        const axiosInstance = (0, (/*@__PURE__*/$parcel$interopDefault($hPUY2))).create();
        (0, $aEup4.addResponseInterceptor)(axiosInstance, (0, $2bI8n.errorHandlingInterceptor)());
        return axiosInstance;
    }
    get(url, config) {
        return this.axiosInstance.get(url, config);
    }
    post(url, data, config) {
        return this.axiosInstance.post(url, data, config);
    }
    put(url, data, config) {
        return this.axiosInstance.put(url, data, config);
    }
    delete(url, config) {
        return this.axiosInstance.delete(url, config);
    }
}

});
parcelRegister("hPUY2", function(module, exports) {

module.exports = (parcelRequire("9dXaz"));

});
parcelRegister("9dXaz", function(module, exports) {
"use strict";

var $lEpgQ = parcelRequire("lEpgQ");

var $gCuV7 = parcelRequire("gCuV7");

var $fw2Gr = parcelRequire("fw2Gr");

var $diMqi = parcelRequire("diMqi");

var $f6WE5 = parcelRequire("f6WE5");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $6b7339cb82ba6dc4$var$createInstance(defaultConfig) {
    var context = new $fw2Gr(defaultConfig);
    var instance = $gCuV7($fw2Gr.prototype.request, context);
    // Copy axios.prototype to instance
    $lEpgQ.extend(instance, $fw2Gr.prototype, context);
    // Copy context to instance
    $lEpgQ.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $6b7339cb82ba6dc4$var$createInstance($diMqi(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $6b7339cb82ba6dc4$var$axios = $6b7339cb82ba6dc4$var$createInstance($f6WE5);
// Expose Axios class to allow class inheritance
$6b7339cb82ba6dc4$var$axios.Axios = $fw2Gr;

// Expose Cancel & CancelToken
$6b7339cb82ba6dc4$var$axios.Cancel = (parcelRequire("9TLHS"));

$6b7339cb82ba6dc4$var$axios.CancelToken = (parcelRequire("aIMy1"));

$6b7339cb82ba6dc4$var$axios.isCancel = (parcelRequire("3h79Q"));

$6b7339cb82ba6dc4$var$axios.VERSION = (parcelRequire("1ZYLu")).version;
// Expose all/spread
$6b7339cb82ba6dc4$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$6b7339cb82ba6dc4$var$axios.spread = (parcelRequire("3gDLn"));

// Expose isAxiosError
$6b7339cb82ba6dc4$var$axios.isAxiosError = (parcelRequire("9c4f0"));
module.exports = $6b7339cb82ba6dc4$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $6b7339cb82ba6dc4$var$axios;

});
parcelRegister("lEpgQ", function(module, exports) {
"use strict";

var $gCuV7 = parcelRequire("gCuV7");
// utils is a library of generic helper functions non-specific to axios
var $fc30ef9f2dee6a2c$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $fc30ef9f2dee6a2c$var$isArray(val) {
    return $fc30ef9f2dee6a2c$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $fc30ef9f2dee6a2c$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $fc30ef9f2dee6a2c$var$isBuffer(val) {
    return val !== null && !$fc30ef9f2dee6a2c$var$isUndefined(val) && val.constructor !== null && !$fc30ef9f2dee6a2c$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $fc30ef9f2dee6a2c$var$isArrayBuffer(val) {
    return $fc30ef9f2dee6a2c$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $fc30ef9f2dee6a2c$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $fc30ef9f2dee6a2c$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $fc30ef9f2dee6a2c$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $fc30ef9f2dee6a2c$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $fc30ef9f2dee6a2c$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $fc30ef9f2dee6a2c$var$isPlainObject(val) {
    if ($fc30ef9f2dee6a2c$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $fc30ef9f2dee6a2c$var$isDate(val) {
    return $fc30ef9f2dee6a2c$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $fc30ef9f2dee6a2c$var$isFile(val) {
    return $fc30ef9f2dee6a2c$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $fc30ef9f2dee6a2c$var$isBlob(val) {
    return $fc30ef9f2dee6a2c$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $fc30ef9f2dee6a2c$var$isFunction(val) {
    return $fc30ef9f2dee6a2c$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $fc30ef9f2dee6a2c$var$isStream(val) {
    return $fc30ef9f2dee6a2c$var$isObject(val) && $fc30ef9f2dee6a2c$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $fc30ef9f2dee6a2c$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $fc30ef9f2dee6a2c$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $fc30ef9f2dee6a2c$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $fc30ef9f2dee6a2c$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($fc30ef9f2dee6a2c$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $fc30ef9f2dee6a2c$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($fc30ef9f2dee6a2c$var$isPlainObject(result[key]) && $fc30ef9f2dee6a2c$var$isPlainObject(val)) result[key] = $fc30ef9f2dee6a2c$var$merge(result[key], val);
        else if ($fc30ef9f2dee6a2c$var$isPlainObject(val)) result[key] = $fc30ef9f2dee6a2c$var$merge({}, val);
        else if ($fc30ef9f2dee6a2c$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$fc30ef9f2dee6a2c$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $fc30ef9f2dee6a2c$var$extend(a, b, thisArg) {
    $fc30ef9f2dee6a2c$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $gCuV7(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $fc30ef9f2dee6a2c$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $fc30ef9f2dee6a2c$var$isArray,
    isArrayBuffer: $fc30ef9f2dee6a2c$var$isArrayBuffer,
    isBuffer: $fc30ef9f2dee6a2c$var$isBuffer,
    isFormData: $fc30ef9f2dee6a2c$var$isFormData,
    isArrayBufferView: $fc30ef9f2dee6a2c$var$isArrayBufferView,
    isString: $fc30ef9f2dee6a2c$var$isString,
    isNumber: $fc30ef9f2dee6a2c$var$isNumber,
    isObject: $fc30ef9f2dee6a2c$var$isObject,
    isPlainObject: $fc30ef9f2dee6a2c$var$isPlainObject,
    isUndefined: $fc30ef9f2dee6a2c$var$isUndefined,
    isDate: $fc30ef9f2dee6a2c$var$isDate,
    isFile: $fc30ef9f2dee6a2c$var$isFile,
    isBlob: $fc30ef9f2dee6a2c$var$isBlob,
    isFunction: $fc30ef9f2dee6a2c$var$isFunction,
    isStream: $fc30ef9f2dee6a2c$var$isStream,
    isURLSearchParams: $fc30ef9f2dee6a2c$var$isURLSearchParams,
    isStandardBrowserEnv: $fc30ef9f2dee6a2c$var$isStandardBrowserEnv,
    forEach: $fc30ef9f2dee6a2c$var$forEach,
    merge: $fc30ef9f2dee6a2c$var$merge,
    extend: $fc30ef9f2dee6a2c$var$extend,
    trim: $fc30ef9f2dee6a2c$var$trim,
    stripBOM: $fc30ef9f2dee6a2c$var$stripBOM
};

});
parcelRegister("gCuV7", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("fw2Gr", function(module, exports) {
"use strict";

var $lEpgQ = parcelRequire("lEpgQ");

var $groFr = parcelRequire("groFr");

var $7PAjL = parcelRequire("7PAjL");

var $7jBez = parcelRequire("7jBez");

var $diMqi = parcelRequire("diMqi");

var $7qCPA = parcelRequire("7qCPA");
var $b4bbed1390953333$var$validators = $7qCPA.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $b4bbed1390953333$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $7PAjL(),
        response: new $7PAjL()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $b4bbed1390953333$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $diMqi(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $7qCPA.assertOptions(transitional, {
        silentJSONParsing: $b4bbed1390953333$var$validators.transitional($b4bbed1390953333$var$validators.boolean),
        forcedJSONParsing: $b4bbed1390953333$var$validators.transitional($b4bbed1390953333$var$validators.boolean),
        clarifyTimeoutError: $b4bbed1390953333$var$validators.transitional($b4bbed1390953333$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $7jBez,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $7jBez(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$b4bbed1390953333$var$Axios.prototype.getUri = function getUri(config) {
    config = $diMqi(this.defaults, config);
    return $groFr(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$lEpgQ.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $b4bbed1390953333$var$Axios.prototype[method] = function(url, config) {
        return this.request($diMqi(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$lEpgQ.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $b4bbed1390953333$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($diMqi(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $b4bbed1390953333$var$Axios;

});
parcelRegister("groFr", function(module, exports) {
"use strict";

var $lEpgQ = parcelRequire("lEpgQ");
function $bf824d6117960b94$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($lEpgQ.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $lEpgQ.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($lEpgQ.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $lEpgQ.forEach(val, function parseValue(v) {
                if ($lEpgQ.isDate(v)) v = v.toISOString();
                else if ($lEpgQ.isObject(v)) v = JSON.stringify(v);
                parts.push($bf824d6117960b94$var$encode(key) + "=" + $bf824d6117960b94$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("7PAjL", function(module, exports) {
"use strict";

var $lEpgQ = parcelRequire("lEpgQ");
function $5b3977ca249525ae$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $5b3977ca249525ae$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $5b3977ca249525ae$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $5b3977ca249525ae$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $lEpgQ.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $5b3977ca249525ae$var$InterceptorManager;

});

parcelRegister("7jBez", function(module, exports) {
"use strict";

var $lEpgQ = parcelRequire("lEpgQ");

var $dUZEY = parcelRequire("dUZEY");

var $3h79Q = parcelRequire("3h79Q");

var $f6WE5 = parcelRequire("f6WE5");

var $9TLHS = parcelRequire("9TLHS");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $553730a48cb1787d$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $9TLHS("canceled");
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $553730a48cb1787d$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $dUZEY.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $lEpgQ.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $lEpgQ.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $f6WE5.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $553730a48cb1787d$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $dUZEY.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$3h79Q(reason)) {
            $553730a48cb1787d$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $dUZEY.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("dUZEY", function(module, exports) {
"use strict";

var $lEpgQ = parcelRequire("lEpgQ");

var $f6WE5 = parcelRequire("f6WE5");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $f6WE5;
    /*eslint no-param-reassign:0*/ $lEpgQ.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("f6WE5", function(module, exports) {

var $lMUAO = parcelRequire("lMUAO");
"use strict";

var $lEpgQ = parcelRequire("lEpgQ");

var $1bJrb = parcelRequire("1bJrb");

var $67JeM = parcelRequire("67JeM");
var $b004e857a9cf871f$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $b004e857a9cf871f$var$setContentTypeIfUnset(headers, value) {
    if (!$lEpgQ.isUndefined(headers) && $lEpgQ.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $b004e857a9cf871f$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("bSZrE"));
    else if (typeof $lMUAO !== "undefined" && Object.prototype.toString.call($lMUAO) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("bSZrE"));
    return adapter;
}
function $b004e857a9cf871f$var$stringifySafely(rawValue, parser, encoder) {
    if ($lEpgQ.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $lEpgQ.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $b004e857a9cf871f$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $b004e857a9cf871f$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $1bJrb(headers, "Accept");
            $1bJrb(headers, "Content-Type");
            if ($lEpgQ.isFormData(data) || $lEpgQ.isArrayBuffer(data) || $lEpgQ.isBuffer(data) || $lEpgQ.isStream(data) || $lEpgQ.isFile(data) || $lEpgQ.isBlob(data)) return data;
            if ($lEpgQ.isArrayBufferView(data)) return data.buffer;
            if ($lEpgQ.isURLSearchParams(data)) {
                $b004e857a9cf871f$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($lEpgQ.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $b004e857a9cf871f$var$setContentTypeIfUnset(headers, "application/json");
                return $b004e857a9cf871f$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $b004e857a9cf871f$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $lEpgQ.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $67JeM(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$lEpgQ.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $b004e857a9cf871f$var$defaults.headers[method] = {};
});
$lEpgQ.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $b004e857a9cf871f$var$defaults.headers[method] = $lEpgQ.merge($b004e857a9cf871f$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $b004e857a9cf871f$var$defaults;

});
parcelRegister("lMUAO", function(module, exports) {
// shim for using process in browser
var $fdc9faceccf754e6$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $fdc9faceccf754e6$var$cachedSetTimeout;
var $fdc9faceccf754e6$var$cachedClearTimeout;
function $fdc9faceccf754e6$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $fdc9faceccf754e6$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $fdc9faceccf754e6$var$cachedSetTimeout = setTimeout;
        else $fdc9faceccf754e6$var$cachedSetTimeout = $fdc9faceccf754e6$var$defaultSetTimout;
    } catch (e) {
        $fdc9faceccf754e6$var$cachedSetTimeout = $fdc9faceccf754e6$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $fdc9faceccf754e6$var$cachedClearTimeout = clearTimeout;
        else $fdc9faceccf754e6$var$cachedClearTimeout = $fdc9faceccf754e6$var$defaultClearTimeout;
    } catch (e) {
        $fdc9faceccf754e6$var$cachedClearTimeout = $fdc9faceccf754e6$var$defaultClearTimeout;
    }
})();
function $fdc9faceccf754e6$var$runTimeout(fun) {
    if ($fdc9faceccf754e6$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($fdc9faceccf754e6$var$cachedSetTimeout === $fdc9faceccf754e6$var$defaultSetTimout || !$fdc9faceccf754e6$var$cachedSetTimeout) && setTimeout) {
        $fdc9faceccf754e6$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $fdc9faceccf754e6$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $fdc9faceccf754e6$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $fdc9faceccf754e6$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $fdc9faceccf754e6$var$runClearTimeout(marker) {
    if ($fdc9faceccf754e6$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($fdc9faceccf754e6$var$cachedClearTimeout === $fdc9faceccf754e6$var$defaultClearTimeout || !$fdc9faceccf754e6$var$cachedClearTimeout) && clearTimeout) {
        $fdc9faceccf754e6$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $fdc9faceccf754e6$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $fdc9faceccf754e6$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $fdc9faceccf754e6$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $fdc9faceccf754e6$var$queue = [];
var $fdc9faceccf754e6$var$draining = false;
var $fdc9faceccf754e6$var$currentQueue;
var $fdc9faceccf754e6$var$queueIndex = -1;
function $fdc9faceccf754e6$var$cleanUpNextTick() {
    if (!$fdc9faceccf754e6$var$draining || !$fdc9faceccf754e6$var$currentQueue) return;
    $fdc9faceccf754e6$var$draining = false;
    if ($fdc9faceccf754e6$var$currentQueue.length) $fdc9faceccf754e6$var$queue = $fdc9faceccf754e6$var$currentQueue.concat($fdc9faceccf754e6$var$queue);
    else $fdc9faceccf754e6$var$queueIndex = -1;
    if ($fdc9faceccf754e6$var$queue.length) $fdc9faceccf754e6$var$drainQueue();
}
function $fdc9faceccf754e6$var$drainQueue() {
    if ($fdc9faceccf754e6$var$draining) return;
    var timeout = $fdc9faceccf754e6$var$runTimeout($fdc9faceccf754e6$var$cleanUpNextTick);
    $fdc9faceccf754e6$var$draining = true;
    var len = $fdc9faceccf754e6$var$queue.length;
    while(len){
        $fdc9faceccf754e6$var$currentQueue = $fdc9faceccf754e6$var$queue;
        $fdc9faceccf754e6$var$queue = [];
        while(++$fdc9faceccf754e6$var$queueIndex < len)if ($fdc9faceccf754e6$var$currentQueue) $fdc9faceccf754e6$var$currentQueue[$fdc9faceccf754e6$var$queueIndex].run();
        $fdc9faceccf754e6$var$queueIndex = -1;
        len = $fdc9faceccf754e6$var$queue.length;
    }
    $fdc9faceccf754e6$var$currentQueue = null;
    $fdc9faceccf754e6$var$draining = false;
    $fdc9faceccf754e6$var$runClearTimeout(timeout);
}
$fdc9faceccf754e6$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $fdc9faceccf754e6$var$queue.push(new $fdc9faceccf754e6$var$Item(fun, args));
    if ($fdc9faceccf754e6$var$queue.length === 1 && !$fdc9faceccf754e6$var$draining) $fdc9faceccf754e6$var$runTimeout($fdc9faceccf754e6$var$drainQueue);
};
// v8 likes predictible objects
function $fdc9faceccf754e6$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$fdc9faceccf754e6$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$fdc9faceccf754e6$var$process.title = "browser";
$fdc9faceccf754e6$var$process.browser = true;
$fdc9faceccf754e6$var$process.env = {};
$fdc9faceccf754e6$var$process.argv = [];
$fdc9faceccf754e6$var$process.version = ""; // empty string to avoid regexp issues
$fdc9faceccf754e6$var$process.versions = {};
function $fdc9faceccf754e6$var$noop() {}
$fdc9faceccf754e6$var$process.on = $fdc9faceccf754e6$var$noop;
$fdc9faceccf754e6$var$process.addListener = $fdc9faceccf754e6$var$noop;
$fdc9faceccf754e6$var$process.once = $fdc9faceccf754e6$var$noop;
$fdc9faceccf754e6$var$process.off = $fdc9faceccf754e6$var$noop;
$fdc9faceccf754e6$var$process.removeListener = $fdc9faceccf754e6$var$noop;
$fdc9faceccf754e6$var$process.removeAllListeners = $fdc9faceccf754e6$var$noop;
$fdc9faceccf754e6$var$process.emit = $fdc9faceccf754e6$var$noop;
$fdc9faceccf754e6$var$process.prependListener = $fdc9faceccf754e6$var$noop;
$fdc9faceccf754e6$var$process.prependOnceListener = $fdc9faceccf754e6$var$noop;
$fdc9faceccf754e6$var$process.listeners = function(name) {
    return [];
};
$fdc9faceccf754e6$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$fdc9faceccf754e6$var$process.cwd = function() {
    return "/";
};
$fdc9faceccf754e6$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$fdc9faceccf754e6$var$process.umask = function() {
    return 0;
};

});

parcelRegister("1bJrb", function(module, exports) {
"use strict";

var $lEpgQ = parcelRequire("lEpgQ");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $lEpgQ.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("67JeM", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("bSZrE", function(module, exports) {
"use strict";

var $lEpgQ = parcelRequire("lEpgQ");

var $8ZfTs = parcelRequire("8ZfTs");

var $lBLV5 = parcelRequire("lBLV5");

var $groFr = parcelRequire("groFr");

var $fh4Qc = parcelRequire("fh4Qc");

var $hwTBR = parcelRequire("hwTBR");

var $jPxRv = parcelRequire("jPxRv");

var $2PT9r = parcelRequire("2PT9r");

var $f6WE5 = parcelRequire("f6WE5");

var $9TLHS = parcelRequire("9TLHS");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($lEpgQ.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $fh4Qc(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $groFr(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $hwTBR(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $8ZfTs(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($2PT9r("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($2PT9r("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $f6WE5.transitional;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($2PT9r(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($lEpgQ.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $jPxRv(fullPath)) && config.xsrfCookieName ? $lBLV5.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $lEpgQ.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$lEpgQ.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $9TLHS("canceled") : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("8ZfTs", function(module, exports) {
"use strict";

var $2PT9r = parcelRequire("2PT9r");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($2PT9r("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("2PT9r", function(module, exports) {
"use strict";

var $67JeM = parcelRequire("67JeM");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $67JeM(error, config, code, request, response);
};

});


parcelRegister("lBLV5", function(module, exports) {
"use strict";

var $lEpgQ = parcelRequire("lEpgQ");
module.exports = $lEpgQ.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($lEpgQ.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($lEpgQ.isString(path)) cookie.push("path=" + path);
            if ($lEpgQ.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("fh4Qc", function(module, exports) {
"use strict";

var $8CHYI = parcelRequire("8CHYI");

var $iZB8V = parcelRequire("iZB8V");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$8CHYI(requestedURL)) return $iZB8V(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("8CHYI", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("iZB8V", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("hwTBR", function(module, exports) {
"use strict";

var $lEpgQ = parcelRequire("lEpgQ");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $cc308fb981352bef$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $lEpgQ.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $lEpgQ.trim(line.substr(0, i)).toLowerCase();
        val = $lEpgQ.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $cc308fb981352bef$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("jPxRv", function(module, exports) {
"use strict";

var $lEpgQ = parcelRequire("lEpgQ");
module.exports = $lEpgQ.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $lEpgQ.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("9TLHS", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $734e41aa15a6349f$var$Cancel(message) {
    this.message = message;
}
$734e41aa15a6349f$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$734e41aa15a6349f$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $734e41aa15a6349f$var$Cancel;

});




parcelRegister("3h79Q", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("diMqi", function(module, exports) {
"use strict";

var $lEpgQ = parcelRequire("lEpgQ");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($lEpgQ.isPlainObject(target) && $lEpgQ.isPlainObject(source)) return $lEpgQ.merge(target, source);
        else if ($lEpgQ.isPlainObject(source)) return $lEpgQ.merge({}, source);
        else if ($lEpgQ.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$lEpgQ.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$lEpgQ.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$lEpgQ.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$lEpgQ.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$lEpgQ.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $lEpgQ.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $lEpgQ.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("7qCPA", function(module, exports) {
"use strict";

var $1ZYLu = parcelRequire("1ZYLu");
var $568915248b705d88$require$VERSION = $1ZYLu.version;
var $568915248b705d88$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $568915248b705d88$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $568915248b705d88$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $568915248b705d88$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $568915248b705d88$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        if (version && !$568915248b705d88$var$deprecatedWarnings[opt]) {
            $568915248b705d88$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $568915248b705d88$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    assertOptions: $568915248b705d88$var$assertOptions,
    validators: $568915248b705d88$var$validators
};

});
parcelRegister("1ZYLu", function(module, exports) {
module.exports = {
    "version": "0.24.0"
};

});



parcelRegister("aIMy1", function(module, exports) {
"use strict";

var $9TLHS = parcelRequire("9TLHS");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $7ce3ac011d3fbfc6$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $9TLHS(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $7ce3ac011d3fbfc6$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $7ce3ac011d3fbfc6$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $7ce3ac011d3fbfc6$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $7ce3ac011d3fbfc6$var$CancelToken.source = function source() {
    var cancel;
    var token = new $7ce3ac011d3fbfc6$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $7ce3ac011d3fbfc6$var$CancelToken;

});

parcelRegister("3gDLn", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("9c4f0", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});




parcelRegister("gi9KJ", function(module, exports) {

$parcel$export(module.exports, "createAxiosInstance", () => $ebbce51464a87731$export$456995facc43eda);

var $hPUY2 = parcelRequire("hPUY2");
function $ebbce51464a87731$export$456995facc43eda() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($hPUY2))).create({
        headers: {
            "x-api-version": "1.0",
            "x-time-zone": Intl.DateTimeFormat().resolvedOptions().timeZone
        }
    });
}

});

parcelRegister("2w9VQ", function(module, exports) {

$parcel$export(module.exports, "MasterApiService", () => $7d995705eee1ca3f$export$65b9a65b1524598c);

var $jVw0L = parcelRequire("jVw0L");

var $2bI8n = parcelRequire("2bI8n");

var $aEup4 = parcelRequire("aEup4");
class $7d995705eee1ca3f$export$65b9a65b1524598c {
    constructor(axiosInstance){
        this.axiosInstance = axiosInstance;
        (0, $aEup4.addRequestInterceptor)(this.axiosInstance, (0, $jVw0L.addMasterUrlInterceptor));
        (0, $aEup4.addResponseInterceptor)(this.axiosInstance, (0, $2bI8n.errorHandlingInterceptor)());
    }
    get(url, config) {
        return this.axiosInstance.get(url, config);
    }
    post(url, data, config) {
        return this.axiosInstance.post(url, data, config);
    }
    put(url, data, config) {
        return this.axiosInstance.put(url, data, config);
    }
    delete(url, config) {
        return this.axiosInstance.delete(url, config);
    }
}

});
parcelRegister("jVw0L", function(module, exports) {

$parcel$export(module.exports, "addMasterUrlInterceptor", () => $51de8627cd56c44d$export$e305de56981e049c);
const $51de8627cd56c44d$export$e305de56981e049c = {
    onFulfilled: (config)=>({
            ...config,
            url: `${"https://api.eu.physio.me/pt-api" ?? ""}${config.url}`
        })
};

});


parcelRegister("hvhSI", function(module, exports) {

$parcel$export(module.exports, "UnauthenticatedApiService", () => $4c8401fad5bafd15$export$98000e2c4e55e19c);

var $9Y5ps = parcelRequire("9Y5ps");

var $2bI8n = parcelRequire("2bI8n");

var $aEup4 = parcelRequire("aEup4");
class $4c8401fad5bafd15$export$98000e2c4e55e19c {
    constructor(axiosInstanceProvider, infraManager){
        this.axiosInstanceProvider = axiosInstanceProvider;
        this.infraManager = infraManager;
        this.axiosInstance = this.initiateAxiosInstance();
        infraManager.targetInfraChanged.add(this.refreshAxiosInstance.bind(this));
    }
    refreshAxiosInstance() {
        this.axiosInstance = this.initiateAxiosInstance();
    }
    initiateAxiosInstance() {
        const axiosInstance = this.axiosInstanceProvider();
        (0, $aEup4.addRequestInterceptor)(axiosInstance, (0, $9Y5ps.addBaseUrlInterceptor)(this.infraManager));
        (0, $aEup4.addResponseInterceptor)(axiosInstance, (0, $2bI8n.errorHandlingInterceptor)());
        return axiosInstance;
    }
    get(url, config) {
        return this.axiosInstance.get(url, config);
    }
    post(url, data, config) {
        return this.axiosInstance.post(url, data, config);
    }
    put(url, data, config) {
        return this.axiosInstance.put(url, data, config);
    }
    delete(url, config) {
        return this.axiosInstance.delete(url, config);
    }
}

});

parcelRegister("1RPKt", function(module, exports) {

$parcel$export(module.exports, "NetworkDebugManager", () => $c8a62ba99edacfb6$export$3eb00b7fc2c3553c);

var $aEup4 = parcelRequire("aEup4");

var $dAJa4 = parcelRequire("dAJa4");

var $aj4st = parcelRequire("aj4st");

var $lTdpc = parcelRequire("lTdpc");

var $1IWnK = parcelRequire("1IWnK");
const $c8a62ba99edacfb6$var$DEFAULT_DEBUG_SETTINGS = {
    enableRandomNetworkErrors: false
};
class $c8a62ba99edacfb6$export$3eb00b7fc2c3553c {
    constructor(apiService){
        this.apiService = apiService;
        this._randomErrorsInterceptor = null;
        this._debugSettings = (0, $1IWnK.observable)($c8a62ba99edacfb6$var$DEFAULT_DEBUG_SETTINGS);
        this.debugSettings = this._debugSettings.readOnly();
        this._settingsStore = (0, $aj4st.storage).getStore("debugSettings", (s)=>s, (s)=>s);
        const storedSettings = this._settingsStore.getItem($c8a62ba99edacfb6$var$DEFAULT_DEBUG_SETTINGS);
        this._debugSettings.set({
            ...storedSettings
        });
        if (this.debugSettings.get().enableRandomNetworkErrors) this.toggleRandomNetworkErrors(true);
    }
    toggleRandomNetworkErrors(enable) {
        if (enable) {
            this.enableRandomNetworkErrors();
            return;
        }
        this.disableRandomNetworkErrors();
    }
    enableRandomNetworkErrors() {
        if ((0, $lTdpc.isNil)(this._randomErrorsInterceptor)) this._randomErrorsInterceptor = (0, $aEup4.addResponseInterceptor)(this.apiService.axiosInstance, (0, $dAJa4.fakeBadNetworkInterceptor)());
        this.updateRandomNetworkErrorsSetting(true);
    }
    disableRandomNetworkErrors() {
        if ((0, $lTdpc.isNotNil)(this._randomErrorsInterceptor)) {
            (0, $aEup4.removeResponseInterceptor)(this.apiService.axiosInstance, this._randomErrorsInterceptor);
            this._randomErrorsInterceptor = null;
        }
        this.updateRandomNetworkErrorsSetting(false);
    }
    updateRandomNetworkErrorsSetting(enableRandomNetworkErrors) {
        this._debugSettings.update((previousSettings)=>({
                ...previousSettings,
                enableRandomNetworkErrors: enableRandomNetworkErrors
            }));
        this._settingsStore.setItem(this.debugSettings.get());
    }
}

});
parcelRegister("dAJa4", function(module, exports) {

$parcel$export(module.exports, "fakeBadNetworkInterceptor", () => $d9cc466c57c327dd$export$80bd4b1c3bf1f7db);
class $d9cc466c57c327dd$var$FakeNetworkError extends Error {
    constructor(message){
        super(message);
    }
}
const $d9cc466c57c327dd$var$ERROR_THRESOLD = 0.33;
const $d9cc466c57c327dd$export$80bd4b1c3bf1f7db = ()=>({
        onFulfilled: (response)=>{
            if (response.config.url?.includes("/pts/me")) return response;
            return Math.random() <= $d9cc466c57c327dd$var$ERROR_THRESOLD ? Promise.reject(new $d9cc466c57c327dd$var$FakeNetworkError("Random network error!!")) : response;
        },
        onRejected: (error)=>Promise.reject(error)
    });

});

parcelRegister("aj4st", function(module, exports) {

$parcel$export(module.exports, "storage", () => $4472d319c29cae77$export$ddcffe0146c8f882);
class $4472d319c29cae77$var$StorageStatic {
    getStore(key, serialize, deserialize, version) {
        const versionedKey = `${key}-${version ?? 0}`;
        return {
            setItem: (item)=>{
                try {
                    localStorage.setItem(versionedKey, JSON.stringify(serialize(item)));
                } catch (e) {
                    console.warn(e);
                }
            },
            getItem: (defaultValue)=>{
                try {
                    const item = localStorage.getItem(versionedKey);
                    if (item === null) return defaultValue;
                    return deserialize(JSON.parse(item));
                } catch (e) {
                    console.warn(e);
                    return defaultValue;
                }
            },
            clear: ()=>localStorage.removeItem(versionedKey)
        };
    }
}
const $4472d319c29cae77$export$ddcffe0146c8f882 = new $4472d319c29cae77$var$StorageStatic();

});


parcelRegister("kpDEW", function(module, exports) {

$parcel$export(module.exports, "ErrorManager", () => $a4616edb2ebd32a2$export$8117257dfd8bd5f2);

var $hjTZh = parcelRequire("hjTZh");

var $gbSxu = parcelRequire("gbSxu");
class $a4616edb2ebd32a2$export$8117257dfd8bd5f2 {
    handleCustomApiError(error) {
        if (error.code === (0, $hjTZh.HealthcareTeamErrorCodes).PtNotInHealthcareTeam) this.onPtNotInHealthcareTeam.dispatch();
    }
    constructor(){
        this.onPtNotInHealthcareTeam = new (0, $gbSxu.Signal)();
    }
}

});
parcelRegister("hjTZh", function(module, exports) {

$parcel$export(module.exports, "HealthcareTeamErrorCodes", () => $c712cb219a22d08c$export$bcd1509ece57f1b0);
$parcel$export(module.exports, "InvitationPtNotFoundError", () => $c712cb219a22d08c$export$838850263b8b1651);
$parcel$export(module.exports, "InvitationPtInDifferentCountryError", () => $c712cb219a22d08c$export$a47564078ae14f3d);
$parcel$export(module.exports, "InvitationAlreadyAcceptedError", () => $c712cb219a22d08c$export$21c89faf06abec6b);
$parcel$export(module.exports, "InvitationPtAlreadyInHctError", () => $c712cb219a22d08c$export$f0220056e05898ed);
$parcel$export(module.exports, "InvitationPtNotInvitedError", () => $c712cb219a22d08c$export$96b7a631228cbd7b);
$parcel$export(module.exports, "HealthcareTeamInvitationInWrongCountryError", () => $c712cb219a22d08c$export$7e17c7fd6339507b);
var $c712cb219a22d08c$export$bcd1509ece57f1b0;
(function(HealthcareTeamErrorCodes) {
    HealthcareTeamErrorCodes["PtInvitationAlreadyAccepted"] = "PT_INVITATION_ALREADY_ACCEPTED";
    HealthcareTeamErrorCodes["PtNotFoundByEmail"] = "PT_NOT_FOUND_BY_EMAIL";
    HealthcareTeamErrorCodes["PtInDifferentCountry"] = "PT_DIFFERENT_COUNTRY";
    HealthcareTeamErrorCodes["PtAlreadyInHealthcareTeam"] = "PT_ALREADY_IN_HEALTHCARE_TEAM";
    HealthcareTeamErrorCodes["HealthcareTeamInvitationInWrongCountry"] = "HEALTHCARE_TEAM_INVITATION_IN_WRONG_COUNTRY";
    HealthcareTeamErrorCodes["PtNotInvited"] = "PT_NOT_INVITED_IN_HEALTHCARE_TEAM";
    HealthcareTeamErrorCodes["PtNotInHealthcareTeam"] = "PT_NOT_IN_HEALTHCARE_TEAM";
})($c712cb219a22d08c$export$bcd1509ece57f1b0 || ($c712cb219a22d08c$export$bcd1509ece57f1b0 = {}));
class $c712cb219a22d08c$export$838850263b8b1651 extends Error {
    constructor(message){
        super(message);
    }
}
class $c712cb219a22d08c$export$a47564078ae14f3d extends Error {
    constructor(message){
        super(message);
    }
}
class $c712cb219a22d08c$export$21c89faf06abec6b extends Error {
    constructor(message){
        super(message);
    }
}
class $c712cb219a22d08c$export$f0220056e05898ed extends Error {
    constructor(message){
        super(message);
    }
}
class $c712cb219a22d08c$export$96b7a631228cbd7b extends Error {
    constructor(message){
        super(message);
    }
}
class $c712cb219a22d08c$export$7e17c7fd6339507b extends Error {
    constructor(message){
        super(message);
    }
}

});

parcelRegister("gbSxu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1Vgas = parcelRequire("1Vgas");
module.exports.Signal = $1Vgas.Signal;

var $e1Xg3 = parcelRequire("e1Xg3");
module.exports.ExtendedSignal = $e1Xg3.ExtendedSignal;

var $dXo1D = parcelRequire("dXo1D");
module.exports.ValueCache = $dXo1D.ValueCache;
module.exports.CollectionCache = $dXo1D.CollectionCache;

});
parcelRegister("1Vgas", function(module, exports) {
"use strict";
var $1667a7e72532f583$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e1Xg3 = parcelRequire("e1Xg3");
var $1667a7e72532f583$var$Signal = /** @class */ function(_super) {
    $1667a7e72532f583$var$__extends(Signal, _super);
    function Signal() {
        var _this = _super.call(this, {
            add: function(listener) {
                _this._listeners.add(listener);
            },
            remove: function(listener) {
                _this._listeners.delete(listener);
            }
        }) || this;
        _this._listeners = new Set();
        _this._instanceDefaultListener = function(payload) {
            return Signal._staticDefaultListener(payload);
        };
        return _this;
    }
    Signal.setDefaultListener = function(listener) {
        Signal._staticDefaultListener = listener;
    };
    Signal.prototype.dispatch = function(payload) {
        if (this._listeners.size === 0) {
            var instanceDefaultListener = this._instanceDefaultListener;
            instanceDefaultListener(payload);
            return;
        }
        this._listeners.forEach(function(callback) {
            return callback.call(undefined, payload);
        });
    };
    Signal.prototype.setDefaultListener = function(listener) {
        this._instanceDefaultListener = listener;
    };
    Signal._staticDefaultListener = function() {
    // default static listener is a noop
    };
    return Signal;
}($e1Xg3.ExtendedSignal);
module.exports.Signal = $1667a7e72532f583$var$Signal;

});
parcelRegister("e1Xg3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8mBIB = parcelRequire("8mBIB");
var $a36f2010ecc9b5a8$var$ExtendedSignal = /** @class */ function() {
    function ExtendedSignal(_baseSignal) {
        this._baseSignal = _baseSignal;
        this._tagMap = new $8mBIB.TagMap();
    }
    ExtendedSignal.merge = function() {
        var signals = [];
        for(var _i = 0; _i < arguments.length; _i++)signals[_i] = arguments[_i];
        var listeners = new Map();
        return new ExtendedSignal({
            add: function(listener) {
                var newListener = function(payload) {
                    return listener(payload);
                };
                listeners.set(listener, newListener);
                signals.forEach(function(signal) {
                    return signal.add(newListener);
                });
            },
            remove: function(listener) {
                var newListener = listeners.get(listener);
                listeners.delete(listener);
                signals.forEach(function(signal) {
                    return signal.remove(newListener);
                });
            }
        });
    };
    ExtendedSignal.promisify = function(resolveSignal, rejectSignal) {
        return new Promise(function(resolve, reject) {
            function clearListeners() {
                resolveSignal.remove(completeResolution);
                if (rejectSignal) rejectSignal.remove(completeRejection);
            }
            function completeRejection(payload) {
                clearListeners();
                reject(payload);
            }
            function completeResolution(payload) {
                clearListeners();
                resolve(payload);
            }
            resolveSignal.add(completeResolution);
            if (rejectSignal) rejectSignal.add(completeRejection);
        });
    };
    ExtendedSignal.prototype.add = function(listener) {
        var tags = [];
        for(var _i = 1; _i < arguments.length; _i++)tags[_i - 1] = arguments[_i];
        var _a;
        (_a = this._tagMap).setListeners.apply(_a, [
            listener
        ].concat(tags));
        this._baseSignal.add(listener);
    };
    ExtendedSignal.prototype.remove = function(listenerOrTag) {
        var _this = this;
        this._tagMap.getListeners(listenerOrTag).forEach(function(taggedListener) {
            _this._baseSignal.remove(taggedListener);
            _this._tagMap.clearListener(taggedListener);
        });
        this._baseSignal.remove(listenerOrTag);
        this._tagMap.clearListener(listenerOrTag);
    };
    ExtendedSignal.prototype.addOnce = function(listener) {
        var _this = this;
        var tags = [];
        for(var _i = 1; _i < arguments.length; _i++)tags[_i - 1] = arguments[_i];
        var _a;
        // to match the set behavior of add, only add the listener if the listener is not already
        // registered, don't add the same listener twice
        if (this._tagMap.getListeners(listener).size > 0) return;
        var oneTimeListener = function(payload) {
            _this._baseSignal.remove(oneTimeListener);
            listener(payload);
        };
        (_a = this._tagMap).setListeners.apply(_a, [
            oneTimeListener,
            listener
        ].concat(tags));
        this._baseSignal.add(oneTimeListener);
    };
    ExtendedSignal.prototype.filter = function(filter) {
        return $a36f2010ecc9b5a8$var$convertedListenerSignal(this._baseSignal, function(listener) {
            return function(payload) {
                if (filter(payload)) listener(payload);
            };
        });
    };
    ExtendedSignal.prototype.map = function(transform) {
        return $a36f2010ecc9b5a8$var$convertedListenerSignal(this._baseSignal, function(listener) {
            return function(payload) {
                return listener(transform(payload));
            };
        });
    };
    ExtendedSignal.prototype.merge = function() {
        var signals = [];
        for(var _i = 0; _i < arguments.length; _i++)signals[_i] = arguments[_i];
        return ExtendedSignal.merge.apply(ExtendedSignal, [
            this._baseSignal
        ].concat(signals));
    };
    ExtendedSignal.prototype.promisify = function(rejectSignal) {
        return ExtendedSignal.promisify(this._baseSignal, rejectSignal);
    };
    ExtendedSignal.prototype.readOnly = function() {
        return $a36f2010ecc9b5a8$var$convertedListenerSignal(this._baseSignal, function(listener) {
            return function(payload) {
                return listener(payload);
            };
        });
    };
    ExtendedSignal.prototype.reduce = function(accumulator, initialValue) {
        return $a36f2010ecc9b5a8$var$convertedListenerSignal(this._baseSignal, function(listener) {
            return function() {
                var accum = initialValue;
                return function(payload) {
                    accum = accumulator(accum, payload);
                    listener(accum);
                };
            }();
        });
    };
    ExtendedSignal.prototype.peek = function(peekaboo) {
        return $a36f2010ecc9b5a8$var$convertedListenerSignal(this._baseSignal, function(listener) {
            return function(payload) {
                peekaboo(payload);
                listener(payload);
            };
        });
    };
    ExtendedSignal.prototype.cache = function(cache) {
        this._baseSignal.add(function(payload) {
            return cache.add(payload);
        });
        return $a36f2010ecc9b5a8$var$convertedListenerSignal(this._baseSignal, function(listener) {
            return function(payload) {
                return listener(payload);
            };
        }, function(listener, listenerActive) {
            cache.forEach(function(payload) {
                if (listenerActive()) listener(payload);
            });
        });
    };
    return ExtendedSignal;
}();
module.exports.ExtendedSignal = $a36f2010ecc9b5a8$var$ExtendedSignal;
/**
 * Provides a new signal, with its own set of listeners, and the ability to transform listeners that
 * are added to the new signal.
 */ function $a36f2010ecc9b5a8$var$convertedListenerSignal(baseSignal, convertListener, postAddHook) {
    var listenerMap = new Map();
    return new $a36f2010ecc9b5a8$var$ExtendedSignal({
        add: function(listener) {
            var newListener = convertListener(listener);
            listenerMap.set(listener, newListener);
            baseSignal.add(newListener);
            if (postAddHook) postAddHook(listener, function() {
                return listenerMap.has(listener);
            });
        },
        remove: function(listener) {
            var newListener = listenerMap.get(listener);
            listenerMap.delete(listener);
            // TODO undefined ok in other case
            if (newListener !== undefined) baseSignal.remove(newListener);
        }
    });
}

});
parcelRegister("8mBIB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $616da2e15da45386$var$TagMap = /** @class */ function() {
    function TagMap() {
        this._tagToListeners = new WeakMap();
        this._listenerToTags = new WeakMap();
    }
    TagMap.prototype.setListeners = function(listener) {
        var _this = this;
        var tags = [];
        for(var _i = 1; _i < arguments.length; _i++)tags[_i - 1] = arguments[_i];
        var tagSet = this._listenerToTags.get(listener) || new Set();
        tags.forEach(function(tag) {
            var listenerSet = _this._tagToListeners.get(tag) || new Set();
            listenerSet.add(listener);
            tagSet.add(tag);
            _this._tagToListeners.set(tag, listenerSet);
        });
        this._listenerToTags.set(listener, tagSet);
    };
    TagMap.prototype.getListeners = function(tag) {
        return this._tagToListeners.get(tag) || new Set();
    };
    TagMap.prototype.getTags = function(listener) {
        return this._listenerToTags.get(listener) || new Set();
    };
    TagMap.prototype.clearListener = function(listener) {
        var _this = this;
        var tags = this.getTags(listener);
        this._listenerToTags.delete(listener);
        tags.forEach(function(tag) {
            var listenerSet = _this.getListeners(tag);
            listenerSet.delete(listener);
            if (listenerSet.size === 0) _this._tagToListeners.delete(tag);
        });
    };
    return TagMap;
}();
module.exports.TagMap = $616da2e15da45386$var$TagMap;

});



parcelRegister("dXo1D", function(module, exports) {
"use strict";
var $a2936c01a2bcb641$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a2936c01a2bcb641$var$ArrayCache = /** @class */ function() {
    function ArrayCache() {
        this._payloads = [];
    }
    ArrayCache.prototype.forEach = function(callback) {
        this._payloads.forEach(function(value) {
            return callback(value);
        });
    };
    return ArrayCache;
}();
module.exports.ArrayCache = $a2936c01a2bcb641$var$ArrayCache;
var $a2936c01a2bcb641$var$ValueCache = /** @class */ function(_super) {
    $a2936c01a2bcb641$var$__extends(ValueCache, _super);
    function ValueCache() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ValueCache.prototype.add = function(value) {
        this._payloads = [
            value
        ];
    };
    return ValueCache;
}($a2936c01a2bcb641$var$ArrayCache);
module.exports.ValueCache = $a2936c01a2bcb641$var$ValueCache;
var $a2936c01a2bcb641$var$CollectionCache = /** @class */ function(_super) {
    $a2936c01a2bcb641$var$__extends(CollectionCache, _super);
    function CollectionCache() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionCache.prototype.add = function(value) {
        this._payloads.push(value);
    };
    return CollectionCache;
}($a2936c01a2bcb641$var$ArrayCache);
module.exports.CollectionCache = $a2936c01a2bcb641$var$CollectionCache;

});



parcelRegister("iqzJm", function(module, exports) {

$parcel$export(module.exports, "DayjsLibConfiguration", () => $ad1ac9f2c570a4ca$export$24d53fbb739af46f);
parcelRequire("92qf1");

var $eOSo1 = parcelRequire("eOSo1");

var $cD3aa = parcelRequire("cD3aa");

var $bXTqq = parcelRequire("bXTqq");
const $ad1ac9f2c570a4ca$var$isLocale = (string)=>string in $ad1ac9f2c570a4ca$var$parentLocale;
const $ad1ac9f2c570a4ca$var$parentLocale = {
    "de-DE": "de",
    "en-CA": "en-ca",
    "en-US": "en",
    "es-AR": "es-mx",
    "es-CL": "es-mx",
    "es-ES": "es",
    "es-UY": "es-mx",
    "fr-CA": "fr-ca",
    "fr-FR": "fr",
    "it-IT": "it",
    "pl-PL": "pl",
    "hu-HU": "hu",
    "pt-BR": "pt-br",
    "de-CH": "de",
    "fr-CH": "fr",
    "it-CH": "it",
    en: "en"
};
class $ad1ac9f2c570a4ca$export$24d53fbb739af46f {
    constructor(localeManager, translationsManager){
        this.localeManager = localeManager;
        this.translationsManager = translationsManager;
        this.logger = (0, $eOSo1.getLogger)("\u23F2\uFE0F [Dayjs Lib Configuration]");
    }
    async init() {
        this.setDayjsLocale(this.localeManager.locale.get());
        this.localeManager.locale.subscribe((locale)=>{
            this.setDayjsLocale(locale);
        });
        this.translationsManager.weekdaysConfig.subscribe(()=>{
            this.setDayjsLocale(this.localeManager.locale.get());
        });
    }
    setDayjsLocale(locale) {
        if (!$ad1ac9f2c570a4ca$var$isLocale(locale)) return;
        const translations = this.translationsManager.getLocaleWordings(locale);
        const localeList = (0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).Ls;
        const parentLocal = $ad1ac9f2c570a4ca$var$parentLocale[locale];
        const localeConfiguration = {
            weekStart: this.getWeekStart(locale),
            weekdaysMin: this.getWeekdaysMin(locale),
            parentLocale: parentLocal,
            relativeTime: {
                ...localeList[parentLocal].relativeTime,
                m: translations["global.relativeTime.minute"],
                mm: translations["global.relativeTime.minutes"],
                h: translations["global.relativeTime.hour"],
                hh: translations["global.relativeTime.hours"],
                d: translations["global.relativeTime.day"],
                dd: translations["global.relativeTime.days"],
                w: translations["global.relativeTime.week"],
                ww: translations["global.relativeTime.weeks"],
                M: translations["global.relativeTime.month"],
                MM: translations["global.relativeTime.months"],
                y: translations["global.relativeTime.year"],
                yy: translations["global.relativeTime.years"]
            },
            formats: localeList[parentLocal].formats
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).updateLocale(parentLocal, localeConfiguration);
        (0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).locale(parentLocal);
        this.logger.info("Dayjs locale set to", (0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).locale());
    }
    getWeekdaysMin(currentLocale) {
        const weekdaysConfig = this.translationsManager.weekdaysConfig.get();
        return weekdaysConfig.initials[(0, $bXTqq.intlLocaleToLocale)(currentLocale)];
    }
    getWeekStart(currentLocale) {
        const weekdaysConfig = this.translationsManager.weekdaysConfig.get();
        return weekdaysConfig.firstDayOfWeek[(0, $bXTqq.intlLocaleToLocale)(currentLocale)];
    }
}

});
parcelRegister("92qf1", function(module, exports) {

var $cD3aa = parcelRequire("cD3aa");
parcelRequire("euOhx");
parcelRequire("bOX3q");
parcelRequire("au7l0");
parcelRequire("j3t4b");
parcelRequire("ccwfq");
parcelRequire("5PPlv");
parcelRequire("7jRRs");
parcelRequire("fcsd0");
parcelRequire("a6Hvg");
parcelRequire("cxAlB");
parcelRequire("lVhDL");
parcelRequire("h99g9");
parcelRequire("dcYIf");

var $g0ZPl = parcelRequire("g0ZPl");

var $c3R11 = parcelRequire("c3R11");

var $gEAE0 = parcelRequire("gEAE0");

var $dmkeZ = parcelRequire("dmkeZ");

var $7Lw6S = parcelRequire("7Lw6S");

var $fssOk = parcelRequire("fssOk");

var $lyK7W = parcelRequire("lyK7W");
(0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).extend((0, (/*@__PURE__*/$parcel$interopDefault($7Lw6S))));
(0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).extend((0, (/*@__PURE__*/$parcel$interopDefault($dmkeZ))));
(0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).extend((0, (/*@__PURE__*/$parcel$interopDefault($c3R11))));
(0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).extend((0, (/*@__PURE__*/$parcel$interopDefault($g0ZPl))));
(0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).extend((0, (/*@__PURE__*/$parcel$interopDefault($fssOk))));
(0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).extend((0, (/*@__PURE__*/$parcel$interopDefault($gEAE0))));
(0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).extend((0, (/*@__PURE__*/$parcel$interopDefault($lyK7W))));

});
parcelRegister("cD3aa", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("euOhx", function(module, exports) {

!function(e, n) {
    module.exports = n((parcelRequire("cD3aa")));
}(module.exports, function(e) {
    "use strict";
    function n(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var t = n(e), a = {
        s: "ein paar Sekunden",
        m: [
            "eine Minute",
            "einer Minute"
        ],
        mm: "%d Minuten",
        h: [
            "eine Stunde",
            "einer Stunde"
        ],
        hh: "%d Stunden",
        d: [
            "ein Tag",
            "einem Tag"
        ],
        dd: [
            "%d Tage",
            "%d Tagen"
        ],
        M: [
            "ein Monat",
            "einem Monat"
        ],
        MM: [
            "%d Monate",
            "%d Monaten"
        ],
        y: [
            "ein Jahr",
            "einem Jahr"
        ],
        yy: [
            "%d Jahre",
            "%d Jahren"
        ]
    };
    function i(e, n, t) {
        var i = a[t];
        return Array.isArray(i) && (i = i[n ? 0 : 1]), i.replace("%d", e);
    }
    var r = {
        name: "de",
        weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
        weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
        weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        months: "Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.".split("_"),
        ordinal: function(e) {
            return e + ".";
        },
        weekStart: 1,
        yearStart: 4,
        formats: {
            LTS: "HH:mm:ss",
            LT: "HH:mm",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd, D. MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "in %s",
            past: "vor %s",
            s: i,
            m: i,
            mm: i,
            h: i,
            hh: i,
            d: i,
            dd: i,
            M: i,
            MM: i,
            y: i,
            yy: i
        }
    };
    return t.default.locale(r, null, !0), r;
});

});

parcelRegister("bOX3q", function(module, exports) {

!function(e, a) {
    module.exports = a((parcelRequire("cD3aa")));
}(module.exports, function(e) {
    "use strict";
    function a(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var _ = a(e), t = {
        name: "en-ca",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        ordinal: function(e) {
            return e;
        },
        formats: {
            LT: "h:mm A",
            LTS: "h:mm:ss A",
            L: "YYYY-MM-DD",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY h:mm A",
            LLLL: "dddd, MMMM D, YYYY h:mm A"
        },
        relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        }
    };
    return _.default.locale(t, null, !0), t;
});

});

parcelRegister("au7l0", function(module, exports) {

!function(e, o) {
    module.exports = o((parcelRequire("cD3aa")));
}(module.exports, function(e) {
    "use strict";
    function o(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var s = o(e), d = {
        name: "es",
        monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        weekStart: 1,
        formats: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY H:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
        },
        relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        ordinal: function(e) {
            return e + "\xba";
        }
    };
    return s.default.locale(d, null, !0), d;
});

});

parcelRegister("j3t4b", function(module, exports) {

!function(e, o) {
    module.exports = o((parcelRequire("cD3aa")));
}(module.exports, function(e) {
    "use strict";
    function o(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var s = o(e), d = {
        name: "es-mx",
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
        relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        ordinal: function(e) {
            return e + "\xba";
        },
        formats: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY H:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
        }
    };
    return s.default.locale(d, null, !0), d;
});

});

parcelRegister("ccwfq", function(module, exports) {

!function(e, n) {
    module.exports = n((parcelRequire("cD3aa")));
}(module.exports, function(e) {
    "use strict";
    function n(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var t = n(e), i = {
        name: "fr",
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),
        monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
        weekStart: 1,
        yearStart: 4,
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans"
        },
        ordinal: function(e) {
            return "" + e + (1 === e ? "er" : "");
        }
    };
    return t.default.locale(i, null, !0), i;
});

});

parcelRegister("5PPlv", function(module, exports) {

!function(e, n) {
    module.exports = n((parcelRequire("cD3aa")));
}(module.exports, function(e) {
    "use strict";
    function n(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var i = n(e), _ = {
        name: "fr-ca",
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        ordinal: function(e) {
            return e;
        },
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans"
        }
    };
    return i.default.locale(_, null, !0), _;
});

});

parcelRegister("7jRRs", function(module, exports) {

!function(e, o) {
    module.exports = o((parcelRequire("cD3aa")));
}(module.exports, function(e) {
    "use strict";
    function o(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var t = o(e), n = {
        name: "it",
        weekdays: "domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),
        weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
        weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
        months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
        weekStart: 1,
        monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "tra %s",
            past: "%s fa",
            s: "qualche secondo",
            m: "un minuto",
            mm: "%d minuti",
            h: "un' ora",
            hh: "%d ore",
            d: "un giorno",
            dd: "%d giorni",
            M: "un mese",
            MM: "%d mesi",
            y: "un anno",
            yy: "%d anni"
        },
        ordinal: function(e) {
            return e + "\xba";
        }
    };
    return t.default.locale(n, null, !0), n;
});

});

parcelRegister("fcsd0", function(module, exports) {

!function(e, t) {
    module.exports = t((parcelRequire("cD3aa")));
}(module.exports, function(e) {
    "use strict";
    function t(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var i = t(e);
    function a(e) {
        return e % 10 < 5 && e % 10 > 1 && ~~(e / 10) % 10 != 1;
    }
    function n(e, t, i) {
        var n = e + " ";
        switch(i){
            case "m":
                return t ? "minuta" : "minut\u0119";
            case "mm":
                return n + (a(e) ? "minuty" : "minut");
            case "h":
                return t ? "godzina" : "godzin\u0119";
            case "hh":
                return n + (a(e) ? "godziny" : "godzin");
            case "MM":
                return n + (a(e) ? "miesi\u0105ce" : "miesi\u0119cy");
            case "yy":
                return n + (a(e) ? "lata" : "lat");
        }
    }
    var r = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_wrze\u015Bnia_pa\u017Adziernika_listopada_grudnia".split("_"), _ = "stycze\u0144_luty_marzec_kwiecie\u0144_maj_czerwiec_lipiec_sierpie\u0144_wrzesie\u0144_pa\u017Adziernik_listopad_grudzie\u0144".split("_"), s = /D MMMM/, d = function(e, t) {
        return s.test(t) ? r[e.month()] : _[e.month()];
    };
    d.s = _, d.f = r;
    var o = {
        name: "pl",
        weekdays: "niedziela_poniedzia\u0142ek_wtorek_\u015Broda_czwartek_pi\u0105tek_sobota".split("_"),
        weekdaysShort: "ndz_pon_wt_\u015Br_czw_pt_sob".split("_"),
        weekdaysMin: "Nd_Pn_Wt_\u015Ar_Cz_Pt_So".split("_"),
        months: d,
        monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_pa\u017A_lis_gru".split("_"),
        ordinal: function(e) {
            return e + ".";
        },
        weekStart: 1,
        yearStart: 4,
        relativeTime: {
            future: "za %s",
            past: "%s temu",
            s: "kilka sekund",
            m: n,
            mm: n,
            h: n,
            hh: n,
            d: "1 dzie\u0144",
            dd: "%d dni",
            M: "miesi\u0105c",
            MM: n,
            y: "rok",
            yy: n
        },
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        }
    };
    return i.default.locale(o, null, !0), o;
});

});

parcelRegister("a6Hvg", function(module, exports) {

!function(e, o) {
    module.exports = o((parcelRequire("cD3aa")));
}(module.exports, function(e) {
    "use strict";
    function o(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var a = o(e), s = {
        name: "pt-br",
        weekdays: "domingo_segunda-feira_ter\xe7a-feira_quarta-feira_quinta-feira_sexta-feira_s\xe1bado".split("_"),
        weekdaysShort: "dom_seg_ter_qua_qui_sex_s\xe1b".split("_"),
        weekdaysMin: "Do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_S\xe1".split("_"),
        months: "janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),
        monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
        ordinal: function(e) {
            return e + "\xba";
        },
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY [\xe0s] HH:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY [\xe0s] HH:mm"
        },
        relativeTime: {
            future: "em %s",
            past: "h\xe1 %s",
            s: "poucos segundos",
            m: "um minuto",
            mm: "%d minutos",
            h: "uma hora",
            hh: "%d horas",
            d: "um dia",
            dd: "%d dias",
            M: "um m\xeas",
            MM: "%d meses",
            y: "um ano",
            yy: "%d anos"
        }
    };
    return a.default.locale(s, null, !0), s;
});

});

parcelRegister("cxAlB", function(module, exports) {

!function(e, n) {
    module.exports = n((parcelRequire("cD3aa")));
}(module.exports, function(e) {
    "use strict";
    function n(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var t = n(e), r = {
        name: "hu",
        weekdays: "vas\xe1rnap_h\xe9tf\u0151_kedd_szerda_cs\xfct\xf6rt\xf6k_p\xe9ntek_szombat".split("_"),
        weekdaysShort: "vas_h\xe9t_kedd_sze_cs\xfct_p\xe9n_szo".split("_"),
        weekdaysMin: "v_h_k_sze_cs_p_szo".split("_"),
        months: "janu\xe1r_febru\xe1r_m\xe1rcius_\xe1prilis_m\xe1jus_j\xfanius_j\xfalius_augusztus_szeptember_okt\xf3ber_november_december".split("_"),
        monthsShort: "jan_feb_m\xe1rc_\xe1pr_m\xe1j_j\xfan_j\xfal_aug_szept_okt_nov_dec".split("_"),
        ordinal: function(e) {
            return e + ".";
        },
        weekStart: 1,
        relativeTime: {
            future: "%s m\xfalva",
            past: "%s",
            s: function(e, n, t, r) {
                return "n\xe9h\xe1ny m\xe1sodperc" + (r || n ? "" : "e");
            },
            m: function(e, n, t, r) {
                return "egy perc" + (r || n ? "" : "e");
            },
            mm: function(e, n, t, r) {
                return e + " perc" + (r || n ? "" : "e");
            },
            h: function(e, n, t, r) {
                return "egy " + (r || n ? "\xf3ra" : "\xf3r\xe1ja");
            },
            hh: function(e, n, t, r) {
                return e + " " + (r || n ? "\xf3ra" : "\xf3r\xe1ja");
            },
            d: function(e, n, t, r) {
                return "egy " + (r || n ? "nap" : "napja");
            },
            dd: function(e, n, t, r) {
                return e + " " + (r || n ? "nap" : "napja");
            },
            M: function(e, n, t, r) {
                return "egy " + (r || n ? "h\xf3nap" : "h\xf3napja");
            },
            MM: function(e, n, t, r) {
                return e + " " + (r || n ? "h\xf3nap" : "h\xf3napja");
            },
            y: function(e, n, t, r) {
                return "egy " + (r || n ? "\xe9v" : "\xe9ve");
            },
            yy: function(e, n, t, r) {
                return e + " " + (r || n ? "\xe9v" : "\xe9ve");
            }
        },
        formats: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "YYYY.MM.DD.",
            LL: "YYYY. MMMM D.",
            LLL: "YYYY. MMMM D. H:mm",
            LLLL: "YYYY. MMMM D., dddd H:mm"
        }
    };
    return t.default.locale(r, null, !0), r;
});

});

parcelRegister("lVhDL", function(module, exports) {

!function(e, n) {
    module.exports = n((parcelRequire("cD3aa")));
}(module.exports, function(e) {
    "use strict";
    function n(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var t = n(e), a = {
        s: "ein paar Sekunden",
        m: [
            "eine Minute",
            "einer Minute"
        ],
        mm: "%d Minuten",
        h: [
            "eine Stunde",
            "einer Stunde"
        ],
        hh: "%d Stunden",
        d: [
            "ein Tag",
            "einem Tag"
        ],
        dd: [
            "%d Tage",
            "%d Tagen"
        ],
        M: [
            "ein Monat",
            "einem Monat"
        ],
        MM: [
            "%d Monate",
            "%d Monaten"
        ],
        y: [
            "ein Jahr",
            "einem Jahr"
        ],
        yy: [
            "%d Jahre",
            "%d Jahren"
        ]
    };
    function i(e, n, t) {
        var i = a[t];
        return Array.isArray(i) && (i = i[n ? 0 : 1]), i.replace("%d", e);
    }
    var r = {
        name: "de-ch",
        weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
        weekdaysShort: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
        months: "Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
        monthsShort: "Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
        ordinal: function(e) {
            return e + ".";
        },
        weekStart: 1,
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY HH:mm",
            LLLL: "dddd, D. MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "in %s",
            past: "vor %s",
            s: i,
            m: i,
            mm: i,
            h: i,
            hh: i,
            d: i,
            dd: i,
            M: i,
            MM: i,
            y: i,
            yy: i
        }
    };
    return t.default.locale(r, null, !0), r;
});

});

parcelRegister("h99g9", function(module, exports) {

!function(e, n) {
    module.exports = n((parcelRequire("cD3aa")));
}(module.exports, function(e) {
    "use strict";
    function n(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var i = n(e), _ = {
        name: "fr-ch",
        weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),
        weekStart: 1,
        weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        monthsShort: "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),
        weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
        ordinal: function(e) {
            return e;
        },
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "dans %s",
            past: "il y a %s",
            s: "quelques secondes",
            m: "une minute",
            mm: "%d minutes",
            h: "une heure",
            hh: "%d heures",
            d: "un jour",
            dd: "%d jours",
            M: "un mois",
            MM: "%d mois",
            y: "un an",
            yy: "%d ans"
        }
    };
    return i.default.locale(_, null, !0), _;
});

});

parcelRegister("dcYIf", function(module, exports) {

!function(e, o) {
    module.exports = o((parcelRequire("cD3aa")));
}(module.exports, function(e) {
    "use strict";
    function o(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var n = o(e), t = {
        name: "it-ch",
        weekdays: "domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),
        months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
        weekStart: 1,
        weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
        monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
        weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
        ordinal: function(e) {
            return e;
        },
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "tra %s",
            past: "%s fa",
            s: "alcuni secondi",
            m: "un minuto",
            mm: "%d minuti",
            h: "un'ora",
            hh: "%d ore",
            d: "un giorno",
            dd: "%d giorni",
            M: "un mese",
            MM: "%d mesi",
            y: "un anno",
            yy: "%d anni"
        }
    };
    return n.default.locale(t, null, !0), t;
});

});

parcelRegister("g0ZPl", function(module, exports) {
!function(t, s) {
    module.exports = s();
}(module.exports, function() {
    "use strict";
    var t, s, n = 1e3, i = 6e4, e = 36e5, r = 864e5, o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = 31536e6, d = 2628e6, a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, h = {
        years: u,
        months: d,
        days: r,
        hours: e,
        minutes: i,
        seconds: n,
        milliseconds: 1,
        weeks: 6048e5
    }, c = function(t) {
        return t instanceof g;
    }, f = function(t, s, n) {
        return new g(t, n, s.$l);
    }, m = function(t) {
        return s.p(t) + "s";
    }, l = function(t) {
        return t < 0;
    }, $ = function(t) {
        return l(t) ? Math.ceil(t) : Math.floor(t);
    }, y = function(t) {
        return Math.abs(t);
    }, v = function(t, s) {
        return t ? l(t) ? {
            negative: !0,
            format: "" + y(t) + s
        } : {
            negative: !1,
            format: "" + t + s
        } : {
            negative: !1,
            format: ""
        };
    }, g = function() {
        function l(t, s, n) {
            var i = this;
            if (this.$d = {}, this.$l = n, void 0 === t && (this.$ms = 0, this.parseFromMilliseconds()), s) return f(t * h[m(s)], this);
            if ("number" == typeof t) return this.$ms = t, this.parseFromMilliseconds(), this;
            if ("object" == typeof t) return Object.keys(t).forEach(function(s) {
                i.$d[m(s)] = t[s];
            }), this.calMilliseconds(), this;
            if ("string" == typeof t) {
                var e = t.match(a);
                if (e) {
                    var r = e.slice(2).map(function(t) {
                        return null != t ? Number(t) : 0;
                    });
                    return this.$d.years = r[0], this.$d.months = r[1], this.$d.weeks = r[2], this.$d.days = r[3], this.$d.hours = r[4], this.$d.minutes = r[5], this.$d.seconds = r[6], this.calMilliseconds(), this;
                }
            }
            return this;
        }
        var y = l.prototype;
        return y.calMilliseconds = function() {
            var t = this;
            this.$ms = Object.keys(this.$d).reduce(function(s, n) {
                return s + (t.$d[n] || 0) * h[n];
            }, 0);
        }, y.parseFromMilliseconds = function() {
            var t = this.$ms;
            this.$d.years = $(t / u), t %= u, this.$d.months = $(t / d), t %= d, this.$d.days = $(t / r), t %= r, this.$d.hours = $(t / e), t %= e, this.$d.minutes = $(t / i), t %= i, this.$d.seconds = $(t / n), t %= n, this.$d.milliseconds = t;
        }, y.toISOString = function() {
            var t = v(this.$d.years, "Y"), s = v(this.$d.months, "M"), n = +this.$d.days || 0;
            this.$d.weeks && (n += 7 * this.$d.weeks);
            var i = v(n, "D"), e = v(this.$d.hours, "H"), r = v(this.$d.minutes, "M"), o = this.$d.seconds || 0;
            this.$d.milliseconds && (o += this.$d.milliseconds / 1e3, o = Math.round(1e3 * o) / 1e3);
            var u = v(o, "S"), d = t.negative || s.negative || i.negative || e.negative || r.negative || u.negative, a = e.format || r.format || u.format ? "T" : "", h = (d ? "-" : "") + "P" + t.format + s.format + i.format + a + e.format + r.format + u.format;
            return "P" === h || "-P" === h ? "P0D" : h;
        }, y.toJSON = function() {
            return this.toISOString();
        }, y.format = function(t) {
            var n = t || "YYYY-MM-DDTHH:mm:ss", i = {
                Y: this.$d.years,
                YY: s.s(this.$d.years, 2, "0"),
                YYYY: s.s(this.$d.years, 4, "0"),
                M: this.$d.months,
                MM: s.s(this.$d.months, 2, "0"),
                D: this.$d.days,
                DD: s.s(this.$d.days, 2, "0"),
                H: this.$d.hours,
                HH: s.s(this.$d.hours, 2, "0"),
                m: this.$d.minutes,
                mm: s.s(this.$d.minutes, 2, "0"),
                s: this.$d.seconds,
                ss: s.s(this.$d.seconds, 2, "0"),
                SSS: s.s(this.$d.milliseconds, 3, "0")
            };
            return n.replace(o, function(t, s) {
                return s || String(i[t]);
            });
        }, y.as = function(t) {
            return this.$ms / h[m(t)];
        }, y.get = function(t) {
            var s = this.$ms, n = m(t);
            return "milliseconds" === n ? s %= 1e3 : s = "weeks" === n ? $(s / h[n]) : this.$d[n], s || 0;
        }, y.add = function(t, s, n) {
            var i;
            return i = s ? t * h[m(s)] : c(t) ? t.$ms : f(t, this).$ms, f(this.$ms + i * (n ? -1 : 1), this);
        }, y.subtract = function(t, s) {
            return this.add(t, s, !0);
        }, y.locale = function(t) {
            var s = this.clone();
            return s.$l = t, s;
        }, y.clone = function() {
            return f(this.$ms, this);
        }, y.humanize = function(s) {
            return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s);
        }, y.valueOf = function() {
            return this.asMilliseconds();
        }, y.milliseconds = function() {
            return this.get("milliseconds");
        }, y.asMilliseconds = function() {
            return this.as("milliseconds");
        }, y.seconds = function() {
            return this.get("seconds");
        }, y.asSeconds = function() {
            return this.as("seconds");
        }, y.minutes = function() {
            return this.get("minutes");
        }, y.asMinutes = function() {
            return this.as("minutes");
        }, y.hours = function() {
            return this.get("hours");
        }, y.asHours = function() {
            return this.as("hours");
        }, y.days = function() {
            return this.get("days");
        }, y.asDays = function() {
            return this.as("days");
        }, y.weeks = function() {
            return this.get("weeks");
        }, y.asWeeks = function() {
            return this.as("weeks");
        }, y.months = function() {
            return this.get("months");
        }, y.asMonths = function() {
            return this.as("months");
        }, y.years = function() {
            return this.get("years");
        }, y.asYears = function() {
            return this.as("years");
        }, l;
    }(), p = function(t, s, n) {
        return t.add(s.years() * n, "y").add(s.months() * n, "M").add(s.days() * n, "d").add(s.hours() * n, "h").add(s.minutes() * n, "m").add(s.seconds() * n, "s").add(s.milliseconds() * n, "ms");
    };
    return function(n, i, e) {
        t = e, s = e().$utils(), e.duration = function(t, s) {
            var n = e.locale();
            return f(t, {
                $l: n
            }, s);
        }, e.isDuration = c;
        var r = i.prototype.add, o = i.prototype.subtract;
        i.prototype.add = function(t, s) {
            return c(t) ? p(this, t, 1) : r.bind(this)(t, s);
        }, i.prototype.subtract = function(t, s) {
            return c(t) ? p(this, t, -1) : o.bind(this)(t, s);
        };
    };
});

});

parcelRegister("c3R11", function(module, exports) {
!function(e, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});

});

parcelRegister("gEAE0", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = "day";
    return function(t, i, s) {
        var a = function(t) {
            return t.add(4 - t.isoWeekday(), e);
        }, d = i.prototype;
        d.isoWeekYear = function() {
            return a(this).year();
        }, d.isoWeek = function(t) {
            if (!this.$utils().u(t)) return this.add(7 * (t - this.isoWeek()), e);
            var i, d, n, o, r = a(this), u = (i = this.isoWeekYear(), d = this.$u, n = (d ? s.utc : s)().year(i).startOf("year"), o = 4 - n.isoWeekday(), n.isoWeekday() > 4 && (o += 7), n.add(o, e));
            return r.diff(u, "week") + 1;
        }, d.isoWeekday = function(e) {
            return this.$utils().u(e) ? this.day() || 7 : this.day(this.day() % 7 ? e : e - 7);
        };
        var n = d.startOf;
        d.startOf = function(e, t) {
            var i = this.$utils(), s = !!i.u(t) || t;
            return "isoweek" === i.p(e) ? s ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : n.bind(this)(e, t);
        };
    };
});

});

parcelRegister("dmkeZ", function(module, exports) {
!function(n, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    return function(n, e, t) {
        var r = e.prototype, o = function(n) {
            return n && (n.indexOf ? n : n.s);
        }, u = function(n, e, t, r, u) {
            var i = n.name ? n : n.$locale(), a = o(i[e]), s = o(i[t]), f = a || s.map(function(n) {
                return n.slice(0, r);
            });
            if (!u) return f;
            var d = i.weekStart;
            return f.map(function(n, e) {
                return f[(e + (d || 0)) % 7];
            });
        }, i = function() {
            return t.Ls[t.locale()];
        }, a = function(n, e) {
            return n.formats[e] || function(n) {
                return n.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(n, e, t) {
                    return e || t.slice(1);
                });
            }(n.formats[e.toUpperCase()]);
        }, s = function() {
            var n = this;
            return {
                months: function(e) {
                    return e ? e.format("MMMM") : u(n, "months");
                },
                monthsShort: function(e) {
                    return e ? e.format("MMM") : u(n, "monthsShort", "months", 3);
                },
                firstDayOfWeek: function() {
                    return n.$locale().weekStart || 0;
                },
                weekdays: function(e) {
                    return e ? e.format("dddd") : u(n, "weekdays");
                },
                weekdaysMin: function(e) {
                    return e ? e.format("dd") : u(n, "weekdaysMin", "weekdays", 2);
                },
                weekdaysShort: function(e) {
                    return e ? e.format("ddd") : u(n, "weekdaysShort", "weekdays", 3);
                },
                longDateFormat: function(e) {
                    return a(n.$locale(), e);
                },
                meridiem: this.$locale().meridiem,
                ordinal: this.$locale().ordinal
            };
        };
        r.localeData = function() {
            return s.bind(this)();
        }, t.localeData = function() {
            var n = i();
            return {
                firstDayOfWeek: function() {
                    return n.weekStart || 0;
                },
                weekdays: function() {
                    return t.weekdays();
                },
                weekdaysShort: function() {
                    return t.weekdaysShort();
                },
                weekdaysMin: function() {
                    return t.weekdaysMin();
                },
                months: function() {
                    return t.months();
                },
                monthsShort: function() {
                    return t.monthsShort();
                },
                longDateFormat: function(e) {
                    return a(n, e);
                },
                meridiem: n.meridiem,
                ordinal: n.ordinal
            };
        }, t.months = function() {
            return u(i(), "months");
        }, t.monthsShort = function() {
            return u(i(), "monthsShort", "months", 3);
        }, t.weekdays = function(n) {
            return u(i(), "weekdays", null, null, n);
        }, t.weekdaysShort = function(n) {
            return u(i(), "weekdaysShort", "weekdays", 3, n);
        }, t.weekdaysMin = function(n) {
            return u(i(), "weekdaysMin", "weekdays", 2, n);
        };
    };
});

});

parcelRegister("7Lw6S", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});

});

parcelRegister("fssOk", function(module, exports) {
!function(r, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});

});

parcelRegister("lyK7W", function(module, exports) {
!function(e, n) {
    module.exports = n();
}(module.exports, function() {
    "use strict";
    return function(e, n, t) {
        t.updateLocale = function(e, n) {
            var o = t.Ls[e];
            if (o) return (n ? Object.keys(n) : []).forEach(function(e) {
                o[e] = n[e];
            }), o;
        };
    };
});

});


parcelRegister("bXTqq", function(module, exports) {

$parcel$export(module.exports, "getLanguageFromIntlLocale", () => $e611c2f896cc8912$export$f284fc8e546f04ff);
$parcel$export(module.exports, "localeToIntlLocale", () => $e611c2f896cc8912$export$73f449e510a1c5a0);
$parcel$export(module.exports, "intlLocaleToLocale", () => $e611c2f896cc8912$export$d1b0f702d4c977a5);
$parcel$export(module.exports, "getLowercaseCountryCodeFromIntlLocale", () => $e611c2f896cc8912$export$93332f4b4c0b44d);
$parcel$export(module.exports, "getLowercaseLanguageCodeFromIntlLocale", () => $e611c2f896cc8912$export$aca5e1f58bc0d942);
$parcel$export(module.exports, "localeKeysToIntlLocale", () => $e611c2f896cc8912$export$22cba08617baefa);
$parcel$export(module.exports, "localeValuesToIntlLocale", () => $e611c2f896cc8912$export$1ed3bc9c3ac7643a);
$parcel$export(module.exports, "applyCountryCodeFromLang", () => $e611c2f896cc8912$export$ed9ca3af497048b8);
$parcel$export(module.exports, "applyLocaleFromLang", () => $e611c2f896cc8912$export$263c59c7154cd75c);
$parcel$export(module.exports, "getCountryLocalesFromLang", () => $e611c2f896cc8912$export$38c12d6c0bfe4ddf);
$parcel$export(module.exports, "getLanguageSelfNameFromIntlLocale", () => $e611c2f896cc8912$export$3dcb6a1e9f4e6a78);

var $gIkq9 = parcelRequire("gIkq9");
const $e611c2f896cc8912$var$INTL_LOCALE_SEPARATOR = "-";
const $e611c2f896cc8912$var$DAYJS_LOCALE_SEPARATOR = "_";
const $e611c2f896cc8912$export$f284fc8e546f04ff = (locale, lowercase)=>{
    const language = locale.split($e611c2f896cc8912$var$INTL_LOCALE_SEPARATOR)[0];
    return lowercase ? language.toLowerCase() : language;
};
function $e611c2f896cc8912$export$73f449e510a1c5a0(locale) {
    return locale.replace($e611c2f896cc8912$var$DAYJS_LOCALE_SEPARATOR, $e611c2f896cc8912$var$INTL_LOCALE_SEPARATOR);
}
function $e611c2f896cc8912$export$d1b0f702d4c977a5(locale) {
    return locale.replace($e611c2f896cc8912$var$INTL_LOCALE_SEPARATOR, $e611c2f896cc8912$var$DAYJS_LOCALE_SEPARATOR);
}
function $e611c2f896cc8912$export$93332f4b4c0b44d(locale) {
    const parts = locale.split($e611c2f896cc8912$var$INTL_LOCALE_SEPARATOR);
    return parts.length === 2 ? parts[1].toLowerCase() : $e611c2f896cc8912$export$93332f4b4c0b44d((0, $gIkq9.DEFAULT_LOCALE));
}
function $e611c2f896cc8912$export$aca5e1f58bc0d942(locale) {
    const parts = locale.split($e611c2f896cc8912$var$INTL_LOCALE_SEPARATOR);
    return parts.length === 2 ? parts[0].toLowerCase() : null;
}
function $e611c2f896cc8912$export$22cba08617baefa(map) {
    return Object.fromEntries(Object.entries(map).map(([key, value])=>[
            $e611c2f896cc8912$export$73f449e510a1c5a0(key),
            value
        ]));
}
function $e611c2f896cc8912$export$1ed3bc9c3ac7643a(map) {
    return Object.fromEntries(Object.entries(map).map(([key, value])=>[
            key,
            $e611c2f896cc8912$export$73f449e510a1c5a0(value)
        ]));
}
function $e611c2f896cc8912$export$ed9ca3af497048b8(registerManager, lang, supportedCountries) {
    if (!lang) return;
    const intlLocale = $e611c2f896cc8912$export$73f449e510a1c5a0(lang);
    const countryCode = $e611c2f896cc8912$export$93332f4b4c0b44d(intlLocale);
    if (supportedCountries.includes(countryCode)) registerManager.sendCountryCode(countryCode);
}
function $e611c2f896cc8912$export$263c59c7154cd75c(registerManager, lang, supportedLocales) {
    if (!lang) return;
    const localExists = Array.from(supportedLocales.values()).some((locales)=>locales.includes(lang));
    if (localExists) {
        const intlLocale = $e611c2f896cc8912$export$73f449e510a1c5a0(lang);
        registerManager.changeLocale(intlLocale);
    }
}
const $e611c2f896cc8912$export$38c12d6c0bfe4ddf = (lang, supportedLocales)=>{
    if (!lang) return new Map();
    const intlLocale = $e611c2f896cc8912$export$73f449e510a1c5a0(lang);
    const countryCode = $e611c2f896cc8912$export$93332f4b4c0b44d(intlLocale);
    const countryLocales = supportedLocales.get(countryCode);
    return countryLocales ? new Map([
        [
            countryCode,
            countryLocales
        ]
    ]) : new Map();
};
const $e611c2f896cc8912$export$3dcb6a1e9f4e6a78 = (locale)=>{
    const [lang] = locale.toLowerCase().split($e611c2f896cc8912$var$INTL_LOCALE_SEPARATOR);
    const displayNames = new Intl.DisplayNames([
        lang
    ], {
        type: "language"
    });
    return displayNames.of(lang) || lang;
};

});
parcelRegister("gIkq9", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $a4cc7f23b4c69b01$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "LocaleManager", () => $a4cc7f23b4c69b01$export$9a5c40674650b7fa);

var $bXTqq = parcelRequire("bXTqq");

var $eOSo1 = parcelRequire("eOSo1");

var $chRgh = parcelRequire("chRgh");

var $aj4st = parcelRequire("aj4st");

var $1IWnK = parcelRequire("1IWnK");

var $8Zwsm = parcelRequire("8Zwsm");
const $a4cc7f23b4c69b01$export$1af4c7e47ad72f44 = "en-US";
class $a4cc7f23b4c69b01$export$9a5c40674650b7fa {
    constructor(userManager, translationsManager, countryService){
        this.userManager = userManager;
        this.translationsManager = translationsManager;
        this.countryService = countryService;
        this.logger = (0, $eOSo1.getLogger)("\uD83C\uDF10 [LocaleManager]");
        this._localeStore = (0, $aj4st.storage).getStore((0, $chRgh.LocalStorageKeys).locale, (v)=>v, (v)=>v);
        this._locale = (0, $1IWnK.observable)($a4cc7f23b4c69b01$export$1af4c7e47ad72f44);
        this.locale = this._locale.readOnly();
        this._defaultLocalesMapping = {};
        this._supportedLocales = (0, $1IWnK.observable)(new Map());
        this.supportedLocales = this._supportedLocales.readOnly();
        this.countryCode = this.locale.select((newLocale)=>(0, $bXTqq.getLowercaseCountryCodeFromIntlLocale)(newLocale));
        translationsManager.availableLocales.subscribe((locales)=>{
            this.updatePrimeWording(locales);
            this.setUserLocaleOrDefault();
        });
        userManager.user.subscribe(()=>{
            this.setUserLocaleOrDefault();
        });
    }
    async init() {
        const defaultLocalesMapping = await this.countryService.getDefaultLocalesMapping();
        this._defaultLocalesMapping = (0, $bXTqq.localeValuesToIntlLocale)(defaultLocalesMapping);
        this.setUserLocaleOrDefault();
    }
    async fetchSupportedLocales() {
        const supportedLocales = await this.countryService.getSupportedLocales();
        this._supportedLocales.set(supportedLocales);
    }
    setUserLocaleOrDefault() {
        const userLocale = this.userManager.user.get()?.locale;
        const navigatorLocale = this.resolveLocaleFromNavigator();
        const userLocaleOrDefault = userLocale ?? this._localeStore.getItem(navigatorLocale);
        this.logger.debug("setUserLocaleOrDefault", {
            userLocale: userLocale,
            localStorageLocale: this._localeStore.getItem(),
            navigatorLocale: navigatorLocale
        });
        this.changeLocale(userLocaleOrDefault);
    }
    getNavigatorLocale() {
        return navigator.languages[0];
    }
    resolveLocale(locale) {
        const intlLocale = (0, $bXTqq.localeToIntlLocale)(locale);
        return this.getBestLocaleAvailable([
            intlLocale
        ]);
    }
    resolveLocaleFromNavigator() {
        return this.getBestLocaleAvailable(Array.from(navigator.languages));
    }
    resolveLocaleForCountry(countryCode) {
        const localesForCountry = this._supportedLocales.get().get(countryCode);
        if (localesForCountry?.length) {
            const resolved = this.getBestLocaleAvailable(localesForCountry);
            if (resolved !== $a4cc7f23b4c69b01$export$1af4c7e47ad72f44) return resolved;
        }
        const availableLocales = this.translationsManager.availableLocales.get();
        const countryLocales = availableLocales.filter((locale)=>(0, $bXTqq.getLowercaseCountryCodeFromIntlLocale)(locale) === countryCode);
        if (countryLocales.length) {
            const resolved = this.getBestLocaleAvailable(countryLocales);
            if (resolved !== $a4cc7f23b4c69b01$export$1af4c7e47ad72f44) return resolved;
        }
        return undefined;
    }
    changeLocale(locale) {
        const intlLocale = (0, $bXTqq.localeToIntlLocale)(locale);
        const handledLocale = this.getBestLocaleAvailable([
            intlLocale
        ]);
        if (intlLocale !== handledLocale) this.logger.warn("Trying to change locale to", intlLocale, "but the best-matching available locale is", handledLocale);
        this.logger.debug("Changing locale to", handledLocale);
        this._localeStore.setItem(handledLocale);
        this._locale.set(handledLocale);
        (0, $8Zwsm.locale)(handledLocale);
    }
    updatePrimeWording(locales) {
        // init primereact locales for calendar
        this.logger.debug("Updating prime wordings");
        locales.forEach((locale)=>{
            const translations = this.translationsManager.getLocaleWordings(locale);
            const localeOptions = {
                clear: translations["primereact.calendar.clear"],
                dateFormat: translations["primereact.calendar.dateFormat"],
                dayNames: translations["primereact.calendar.dayNames"].split("_"),
                dayNamesMin: translations["primereact.calendar.dayNamesMin"].split("_"),
                dayNamesShort: translations["primereact.calendar.dayNamesShort"].split("_"),
                firstDayOfWeek: this.getFixedFirstDayOfWeekIndex(translations["primereact.calendar.firstDayOfWeek"]),
                monthNames: translations["primereact.calendar.monthNames"].split("_"),
                monthNamesShort: translations["primereact.calendar.monthNamesShort"].split("_"),
                today: translations["primereact.calendar.today"]
            };
            (0, $8Zwsm.addLocale)(locale, localeOptions);
        });
    }
    getFixedFirstDayOfWeekIndex(firstDayOfWeekLocalizedValue) {
        // Fix for lokalize that gives us "" instead of "0" for localized index values of 0
        const index = parseInt(firstDayOfWeekLocalizedValue);
        if (!isNaN(index)) return index;
        return 0;
    }
    // eslint-disable-next-line sonarjs/cognitive-complexity
    getBestLocaleAvailable(givenLocales) {
        const availableLocales = this.translationsManager.availableLocales.get();
        const resolveFromAvailableOrMapped = (locale)=>availableLocales.includes(locale) ? locale : this._defaultLocalesMapping[locale];
        for (const locale of givenLocales){
            // 1. Exact match or mapped match
            const resolvedLocale = resolveFromAvailableOrMapped(locale);
            if (resolvedLocale) return resolvedLocale;
            // 2. Match by same language in givenLocales
            const language = (0, $bXTqq.getLanguageFromIntlLocale)(locale, true);
            for (const otherLocale of givenLocales)if (otherLocale !== locale && (0, $bXTqq.getLanguageFromIntlLocale)(otherLocale, true) === language) {
                const resolvedOther = resolveFromAvailableOrMapped(otherLocale);
                if (resolvedOther) return resolvedOther;
            }
            // 3. Match by same language in availableLocales
            const availableLocale = availableLocales.find((loc)=>(0, $bXTqq.getLanguageFromIntlLocale)(loc, true) === language);
            if (availableLocale) return availableLocale;
        }
        return $a4cc7f23b4c69b01$export$1af4c7e47ad72f44;
    }
}

});
parcelRegister("chRgh", function(module, exports) {

$parcel$export(module.exports, "LocalStorageKeys", () => $9eab6d0d89da4b91$export$ada36e8a1c3bc83a);
const $9eab6d0d89da4b91$export$ada36e8a1c3bc83a = {
    locale: "locale",
    notifications: "notifications",
    featureToggles: "featureToggles",
    serverConfiguration: "serverConfiguration",
    targetInfrastructureId: "targetInfrastructureId",
    translations: "translations",
    legalContent: "legalContent"
};

});

parcelRegister("8Zwsm", function(module, exports) {

$parcel$export(module.exports, "FilterMatchMode", () => $68bd326542f5b43b$export$b9fbdf9129f67822);
$parcel$export(module.exports, "FilterOperator", () => $68bd326542f5b43b$export$9cc7a9d8d8c733ca);
$parcel$export(module.exports, "FilterService", () => $68bd326542f5b43b$export$f4fb036b8adcc8c8);
$parcel$export(module.exports, "locale", () => $68bd326542f5b43b$export$162ce11d62a1ca51);
$parcel$export(module.exports, "addLocale", () => $68bd326542f5b43b$export$3ab428da39598a54);
$parcel$export(module.exports, "localeOptions", () => $68bd326542f5b43b$export$ef9c48731c26e22d);
$parcel$export(module.exports, "localeOption", () => $68bd326542f5b43b$export$aa1e8754cc4d1e7a);
$parcel$export(module.exports, "ariaLabel", () => $68bd326542f5b43b$export$eb839c9fd3d638b9);
$parcel$export(module.exports, "PrimeReactContext", () => $68bd326542f5b43b$export$43502877ff87a530);
$parcel$export(module.exports, "default", () => $68bd326542f5b43b$export$2e2bcd8739ae039);

var $cfkGk = parcelRequire("cfkGk");

var $81g6h = parcelRequire("81g6h");
"use client";
var $68bd326542f5b43b$export$b9fbdf9129f67822 = Object.freeze({
    STARTS_WITH: "startsWith",
    CONTAINS: "contains",
    NOT_CONTAINS: "notContains",
    ENDS_WITH: "endsWith",
    EQUALS: "equals",
    NOT_EQUALS: "notEquals",
    IN: "in",
    LESS_THAN: "lt",
    LESS_THAN_OR_EQUAL_TO: "lte",
    GREATER_THAN: "gt",
    GREATER_THAN_OR_EQUAL_TO: "gte",
    BETWEEN: "between",
    DATE_IS: "dateIs",
    DATE_IS_NOT: "dateIsNot",
    DATE_BEFORE: "dateBefore",
    DATE_AFTER: "dateAfter",
    CUSTOM: "custom"
});
var $68bd326542f5b43b$export$9cc7a9d8d8c733ca = Object.freeze({
    AND: "and",
    OR: "or"
});
function $68bd326542f5b43b$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $68bd326542f5b43b$var$_unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $68bd326542f5b43b$var$_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $68bd326542f5b43b$var$_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $68bd326542f5b43b$var$_arrayLikeToArray$1(o, minLen);
}
function $68bd326542f5b43b$var$_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $68bd326542f5b43b$export$f4fb036b8adcc8c8 = {
    filter: function filter(value, fields, filterValue, filterMatchMode, filterLocale) {
        var filteredItems = [];
        if (!value) return filteredItems;
        var _iterator = $68bd326542f5b43b$var$_createForOfIteratorHelper(value), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var item = _step.value;
                if (typeof item === "string") {
                    if (this.filters[filterMatchMode](item, filterValue, filterLocale)) {
                        filteredItems.push(item);
                        continue;
                    }
                } else {
                    var _iterator2 = $68bd326542f5b43b$var$_createForOfIteratorHelper(fields), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var field = _step2.value;
                            var fieldValue = (0, $cfkGk.ObjectUtils).resolveFieldData(item, field);
                            if (this.filters[filterMatchMode](fieldValue, filterValue, filterLocale)) {
                                filteredItems.push(item);
                                break;
                            }
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return filteredItems;
    },
    filters: {
        startsWith: function startsWith(value, filter, filterLocale) {
            if (filter === undefined || filter === null || filter.trim() === "") return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, $cfkGk.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, $cfkGk.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.slice(0, filterValue.length) === filterValue;
        },
        contains: function contains(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === "string" && filter.trim() === "") return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, $cfkGk.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, $cfkGk.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue) !== -1;
        },
        notContains: function notContains(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === "string" && filter.trim() === "") return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, $cfkGk.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, $cfkGk.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue) === -1;
        },
        endsWith: function endsWith(value, filter, filterLocale) {
            if (filter === undefined || filter === null || filter.trim() === "") return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, $cfkGk.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, $cfkGk.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue, stringValue.length - filterValue.length) !== -1;
        },
        equals: function equals(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === "string" && filter.trim() === "") return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() === filter.getTime();
            return (0, $cfkGk.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale) === (0, $cfkGk.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
        },
        notEquals: function notEquals(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === "string" && filter.trim() === "") return true;
            if (value === undefined || value === null) return true;
            if (value.getTime && filter.getTime) return value.getTime() !== filter.getTime();
            return (0, $cfkGk.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale) !== (0, $cfkGk.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
        },
        "in": function _in(value, filter) {
            if (filter === undefined || filter === null || filter.length === 0) return true;
            for(var i = 0; i < filter.length; i++){
                if ((0, $cfkGk.ObjectUtils).equals(value, filter[i])) return true;
            }
            return false;
        },
        notIn: function notIn(value, filter) {
            if (filter === undefined || filter === null || filter.length === 0) return true;
            for(var i = 0; i < filter.length; i++){
                if ((0, $cfkGk.ObjectUtils).equals(value, filter[i])) return false;
            }
            return true;
        },
        between: function between(value, filter) {
            if (filter == null || filter[0] == null || filter[1] == null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime) return filter[0].getTime() <= value.getTime() && value.getTime() <= filter[1].getTime();
            return filter[0] <= value && value <= filter[1];
        },
        lt: function lt(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() < filter.getTime();
            return value < filter;
        },
        lte: function lte(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() <= filter.getTime();
            return value <= filter;
        },
        gt: function gt(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() > filter.getTime();
            return value > filter;
        },
        gte: function gte(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() >= filter.getTime();
            return value >= filter;
        },
        dateIs: function dateIs(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.toDateString() === filter.toDateString();
        },
        dateIsNot: function dateIsNot(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.toDateString() !== filter.toDateString();
        },
        dateBefore: function dateBefore(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.getTime() < filter.getTime();
        },
        dateAfter: function dateAfter(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.getTime() > filter.getTime();
        }
    },
    register: function register(rule, fn) {
        this.filters[rule] = fn;
    }
};
function $68bd326542f5b43b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $68bd326542f5b43b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $68bd326542f5b43b$var$_typeof(o);
}
function $68bd326542f5b43b$var$_toPrimitive(input, hint) {
    if ($68bd326542f5b43b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($68bd326542f5b43b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $68bd326542f5b43b$var$_toPropertyKey(arg) {
    var key = $68bd326542f5b43b$var$_toPrimitive(arg, "string");
    return $68bd326542f5b43b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $68bd326542f5b43b$var$_defineProperty(obj, key, value) {
    key = $68bd326542f5b43b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $68bd326542f5b43b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $68bd326542f5b43b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $68bd326542f5b43b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $68bd326542f5b43b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $68bd326542f5b43b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $68bd326542f5b43b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/**
 * @deprecated please use PrimeReactContext
 */ var $68bd326542f5b43b$var$PrimeReact$1 = /*#__PURE__*/ $68bd326542f5b43b$var$_createClass(function PrimeReact() {
    $68bd326542f5b43b$var$_classCallCheck(this, PrimeReact);
});
$68bd326542f5b43b$var$_defineProperty($68bd326542f5b43b$var$PrimeReact$1, "ripple", false);
$68bd326542f5b43b$var$_defineProperty($68bd326542f5b43b$var$PrimeReact$1, "inputStyle", "outlined");
$68bd326542f5b43b$var$_defineProperty($68bd326542f5b43b$var$PrimeReact$1, "locale", "en");
$68bd326542f5b43b$var$_defineProperty($68bd326542f5b43b$var$PrimeReact$1, "appendTo", null);
$68bd326542f5b43b$var$_defineProperty($68bd326542f5b43b$var$PrimeReact$1, "cssTransition", true);
$68bd326542f5b43b$var$_defineProperty($68bd326542f5b43b$var$PrimeReact$1, "autoZIndex", true);
$68bd326542f5b43b$var$_defineProperty($68bd326542f5b43b$var$PrimeReact$1, "hideOverlaysOnDocumentScrolling", false);
$68bd326542f5b43b$var$_defineProperty($68bd326542f5b43b$var$PrimeReact$1, "nonce", null);
$68bd326542f5b43b$var$_defineProperty($68bd326542f5b43b$var$PrimeReact$1, "nullSortOrder", 1);
$68bd326542f5b43b$var$_defineProperty($68bd326542f5b43b$var$PrimeReact$1, "zIndex", {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
    toast: 1200
});
$68bd326542f5b43b$var$_defineProperty($68bd326542f5b43b$var$PrimeReact$1, "pt", undefined);
$68bd326542f5b43b$var$_defineProperty($68bd326542f5b43b$var$PrimeReact$1, "filterMatchModeOptions", {
    text: [
        $68bd326542f5b43b$export$b9fbdf9129f67822.STARTS_WITH,
        $68bd326542f5b43b$export$b9fbdf9129f67822.CONTAINS,
        $68bd326542f5b43b$export$b9fbdf9129f67822.NOT_CONTAINS,
        $68bd326542f5b43b$export$b9fbdf9129f67822.ENDS_WITH,
        $68bd326542f5b43b$export$b9fbdf9129f67822.EQUALS,
        $68bd326542f5b43b$export$b9fbdf9129f67822.NOT_EQUALS
    ],
    numeric: [
        $68bd326542f5b43b$export$b9fbdf9129f67822.EQUALS,
        $68bd326542f5b43b$export$b9fbdf9129f67822.NOT_EQUALS,
        $68bd326542f5b43b$export$b9fbdf9129f67822.LESS_THAN,
        $68bd326542f5b43b$export$b9fbdf9129f67822.LESS_THAN_OR_EQUAL_TO,
        $68bd326542f5b43b$export$b9fbdf9129f67822.GREATER_THAN,
        $68bd326542f5b43b$export$b9fbdf9129f67822.GREATER_THAN_OR_EQUAL_TO
    ],
    date: [
        $68bd326542f5b43b$export$b9fbdf9129f67822.DATE_IS,
        $68bd326542f5b43b$export$b9fbdf9129f67822.DATE_IS_NOT,
        $68bd326542f5b43b$export$b9fbdf9129f67822.DATE_BEFORE,
        $68bd326542f5b43b$export$b9fbdf9129f67822.DATE_AFTER
    ]
});
$68bd326542f5b43b$var$_defineProperty($68bd326542f5b43b$var$PrimeReact$1, "changeTheme", function(currentTheme, newTheme, linkElementId, callback) {
    var _linkElement$parentNo;
    var linkElement = document.getElementById(linkElementId);
    var cloneLinkElement = linkElement.cloneNode(true);
    var newThemeUrl = linkElement.getAttribute("href").replace(currentTheme, newTheme);
    cloneLinkElement.setAttribute("id", linkElementId + "-clone");
    cloneLinkElement.setAttribute("href", newThemeUrl);
    cloneLinkElement.addEventListener("load", function() {
        linkElement.remove();
        cloneLinkElement.setAttribute("id", linkElementId);
        if (callback) callback();
    });
    (_linkElement$parentNo = linkElement.parentNode) === null || _linkElement$parentNo === void 0 || _linkElement$parentNo.insertBefore(cloneLinkElement, linkElement.nextSibling);
});
function $68bd326542f5b43b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $68bd326542f5b43b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $68bd326542f5b43b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $68bd326542f5b43b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $68bd326542f5b43b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $68bd326542f5b43b$var$locales = {
    en: {
        accept: "Yes",
        addRule: "Add Rule",
        am: "AM",
        apply: "Apply",
        cancel: "Cancel",
        choose: "Choose",
        chooseDate: "Choose Date",
        chooseMonth: "Choose Month",
        chooseYear: "Choose Year",
        clear: "Clear",
        completed: "Completed",
        contains: "Contains",
        custom: "Custom",
        dateAfter: "Date is after",
        dateBefore: "Date is before",
        dateFormat: "mm/dd/yy",
        dateIs: "Date is",
        dateIsNot: "Date is not",
        dayNames: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        dayNamesMin: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
        ],
        dayNamesShort: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        emptyFilterMessage: "No results found",
        emptyMessage: "No available options",
        emptySearchMessage: "No results found",
        emptySelectionMessage: "No selected item",
        endsWith: "Ends with",
        equals: "Equals",
        fileSizeTypes: [
            "B",
            "KB",
            "MB",
            "GB",
            "TB",
            "PB",
            "EB",
            "ZB",
            "YB"
        ],
        filter: "Filter",
        firstDayOfWeek: 0,
        gt: "Greater than",
        gte: "Greater than or equal to",
        lt: "Less than",
        lte: "Less than or equal to",
        matchAll: "Match All",
        matchAny: "Match Any",
        medium: "Medium",
        monthNames: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthNamesShort: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        nextDecade: "Next Decade",
        nextHour: "Next Hour",
        nextMinute: "Next Minute",
        nextMonth: "Next Month",
        nextSecond: "Next Second",
        nextYear: "Next Year",
        noFilter: "No Filter",
        notContains: "Not contains",
        notEquals: "Not equals",
        now: "Now",
        passwordPrompt: "Enter a password",
        pending: "Pending",
        pm: "PM",
        prevDecade: "Previous Decade",
        prevHour: "Previous Hour",
        prevMinute: "Previous Minute",
        prevMonth: "Previous Month",
        prevSecond: "Previous Second",
        prevYear: "Previous Year",
        reject: "No",
        removeRule: "Remove Rule",
        searchMessage: "{0} results are available",
        selectionMessage: "{0} items selected",
        showMonthAfterYear: false,
        startsWith: "Starts with",
        strong: "Strong",
        today: "Today",
        upload: "Upload",
        weak: "Weak",
        weekHeader: "Wk",
        aria: {
            cancelEdit: "Cancel Edit",
            close: "Close",
            collapseRow: "Row Collapsed",
            editRow: "Edit Row",
            expandRow: "Row Expanded",
            falseLabel: "False",
            filterConstraint: "Filter Constraint",
            filterOperator: "Filter Operator",
            firstPageLabel: "First Page",
            gridView: "Grid View",
            hideFilterMenu: "Hide Filter Menu",
            jumpToPageDropdownLabel: "Jump to Page Dropdown",
            jumpToPageInputLabel: "Jump to Page Input",
            lastPageLabel: "Last Page",
            listView: "List View",
            moveAllToSource: "Move All to Source",
            moveAllToTarget: "Move All to Target",
            moveBottom: "Move Bottom",
            moveDown: "Move Down",
            moveToSource: "Move to Source",
            moveToTarget: "Move to Target",
            moveTop: "Move Top",
            moveUp: "Move Up",
            navigation: "Navigation",
            next: "Next",
            nextPageLabel: "Next Page",
            nullLabel: "Not Selected",
            pageLabel: "Page {page}",
            otpLabel: "Please enter one time password character {0}",
            passwordHide: "Hide Password",
            passwordShow: "Show Password",
            previous: "Previous",
            previousPageLabel: "Previous Page",
            rotateLeft: "Rotate Left",
            rotateRight: "Rotate Right",
            rowsPerPageLabel: "Rows per page",
            saveEdit: "Save Edit",
            scrollTop: "Scroll Top",
            selectAll: "All items selected",
            selectRow: "Row Selected",
            showFilterMenu: "Show Filter Menu",
            slide: "Slide",
            slideNumber: "{slideNumber}",
            star: "1 star",
            stars: "{star} stars",
            trueLabel: "True",
            unselectAll: "All items unselected",
            unselectRow: "Row Unselected",
            zoomImage: "Zoom Image",
            zoomIn: "Zoom In",
            zoomOut: "Zoom Out"
        }
    }
};
function $68bd326542f5b43b$export$162ce11d62a1ca51(locale) {
    locale && ($68bd326542f5b43b$var$PrimeReact$1.locale = locale);
    return {
        locale: $68bd326542f5b43b$var$PrimeReact$1.locale,
        options: $68bd326542f5b43b$var$locales[$68bd326542f5b43b$var$PrimeReact$1.locale]
    };
}
function $68bd326542f5b43b$export$3ab428da39598a54(locale, options) {
    if (locale.includes("__proto__") || locale.includes("prototype")) throw new Error("Unsafe locale detected");
    $68bd326542f5b43b$var$locales[locale] = $68bd326542f5b43b$var$_objectSpread($68bd326542f5b43b$var$_objectSpread({}, $68bd326542f5b43b$var$locales.en), options);
}
function $68bd326542f5b43b$export$7cd3e26e5d06a8a9(key, value, locale) {
    if (key.includes("__proto__") || key.includes("prototype")) throw new Error("Unsafe key detected");
    $68bd326542f5b43b$export$ef9c48731c26e22d(locale)[key] = value;
}
function $68bd326542f5b43b$export$8024ed7ed764e4fc(options, locale) {
    if (locale.includes("__proto__") || locale.includes("prototype")) throw new Error("Unsafe locale detected");
    var _locale = locale || $68bd326542f5b43b$var$PrimeReact$1.locale;
    $68bd326542f5b43b$var$locales[_locale] = $68bd326542f5b43b$var$_objectSpread($68bd326542f5b43b$var$_objectSpread({}, $68bd326542f5b43b$var$locales[_locale]), options);
}
function $68bd326542f5b43b$export$aa1e8754cc4d1e7a(key, locale) {
    if (key.includes("__proto__") || key.includes("prototype")) throw new Error("Unsafe key detected");
    var _locale = locale || $68bd326542f5b43b$var$PrimeReact$1.locale;
    try {
        return $68bd326542f5b43b$export$ef9c48731c26e22d(_locale)[key];
    } catch (error) {
        throw new Error("The ".concat(key, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
/**
 * Find an ARIA label in the locale by key.  If options are passed it will replace all options:
 * ```ts
 * const ariaValue = "Page {page}, User {user}, Role {role}";
 * const options = { page: 2, user: "John", role: "Admin" };
 * const result = ariaLabel('yourLabel', { page: 2, user: "John", role: "Admin" })
 * console.log(result); // Output: Page 2, User John, Role Admin
 * ```
 * @param {string} ariaKey key of the ARIA label to look up in locale.
 * @param {any} options JSON options like { page: 2, user: "John", role: "Admin" }
 * @returns the ARIA label with replaced values
 */ function $68bd326542f5b43b$export$eb839c9fd3d638b9(ariaKey, options) {
    if (ariaKey.includes("__proto__") || ariaKey.includes("prototype")) throw new Error("Unsafe ariaKey detected");
    var _locale = $68bd326542f5b43b$var$PrimeReact$1.locale;
    try {
        var _ariaLabel = $68bd326542f5b43b$export$ef9c48731c26e22d(_locale).aria[ariaKey];
        if (_ariaLabel) {
            for(var key in options)if (options.hasOwnProperty(key)) _ariaLabel = _ariaLabel.replace("{".concat(key, "}"), options[key]);
        }
        return _ariaLabel;
    } catch (error) {
        throw new Error("The ".concat(ariaKey, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
function $68bd326542f5b43b$export$ef9c48731c26e22d(locale) {
    var _locale = locale || $68bd326542f5b43b$var$PrimeReact$1.locale;
    if (_locale.includes("__proto__") || _locale.includes("prototype")) throw new Error("Unsafe locale detected");
    return $68bd326542f5b43b$var$locales[_locale];
}
var $68bd326542f5b43b$export$bb45678bd9ad9127 = Object.freeze({
    SUCCESS: "success",
    INFO: "info",
    WARN: "warn",
    ERROR: "error",
    SECONDARY: "secondary",
    CONTRAST: "contrast"
});
var $68bd326542f5b43b$export$9daa7f1467519fd8 = Object.freeze({
    ADDRESS_BOOK: "pi pi-address-book",
    ALIGN_CENTER: "pi pi-align-center",
    ALIGN_JUSTIFY: "pi pi-align-justify",
    ALIGN_LEFT: "pi pi-align-left",
    ALIGN_RIGHT: "pi pi-align-right",
    AMAZON: "pi pi-amazon",
    ANDROID: "pi pi-android",
    ANGLE_DOUBLE_DOWN: "pi pi-angle-double-down",
    ANGLE_DOUBLE_LEFT: "pi pi-angle-double-left",
    ANGLE_DOUBLE_RIGHT: "pi pi-angle-double-right",
    ANGLE_DOUBLE_UP: "pi pi-angle-double-up",
    ANGLE_DOWN: "pi pi-angle-down",
    ANGLE_LEFT: "pi pi-angle-left",
    ANGLE_RIGHT: "pi pi-angle-right",
    ANGLE_UP: "pi pi-angle-up",
    APPLE: "pi pi-apple",
    ARROW_CIRCLE_DOWN: "pi pi-arrow-circle-down",
    ARROW_CIRCLE_LEFT: "pi pi-arrow-circle-left",
    ARROW_CIRCLE_RIGHT: "pi pi-arrow-circle-right",
    ARROW_CIRCLE_UP: "pi pi-arrow-circle-up",
    ARROW_DOWN_LEFT_AND_ARROW_UP_RIGHT_TO_CENTER: "pi pi-arrow-down-left-and-arrow-up-right-to-center",
    ARROW_DOWN_LEFT: "pi pi-arrow-down-left",
    ARROW_DOWN_RIGHT: "pi pi-arrow-down-right",
    ARROW_DOWN: "pi pi-arrow-down",
    ARROW_LEFT: "pi pi-arrow-left",
    ARROW_RIGHT_ARROW_LEFT: "pi pi-arrow-right-arrow-left",
    ARROW_RIGHT: "pi pi-arrow-right",
    ARROW_UP_LEFT: "pi pi-arrow-up-left",
    ARROW_UP_RIGHT_AND_ARROW_DOWN_LEFT_FROM_CENTER: "pi pi-arrow-up-right-and-arrow-down-left-from-center",
    ARROW_UP_RIGHT: "pi pi-arrow-up-right",
    ARROW_UP: "pi pi-arrow-up",
    ARROWS_ALT: "pi pi-arrows-alt",
    ARROWS_H: "pi pi-arrows-h",
    ARROWS_V: "pi pi-arrows-v",
    ASTERISK: "pi pi-asterisk",
    AT: "pi pi-at",
    BACKWARD: "pi pi-backward",
    BAN: "pi pi-ban",
    BARCODE: "pi pi-barcode",
    BARS: "pi pi-bars",
    BELL_SLASH: "pi pi-bell-slash",
    BELL: "pi pi-bell",
    BITCOIN: "pi pi-bitcoin",
    BOLT: "pi pi-bolt",
    BOOK: "pi pi-book",
    BOOKMARK_FILL: "pi pi-bookmark-fill",
    BOOKMARK: "pi pi-bookmark",
    BOX: "pi pi-box",
    BRIEFCASE: "pi pi-briefcase",
    BUILDING_COLUMNS: "pi pi-building-columns",
    BUILDING: "pi pi-building",
    BULLSEYE: "pi pi-bullseye",
    CALCULATOR: "pi pi-calculator",
    CALENDAR_CLOCK: "pi pi-calendar-clock",
    CALENDAR_MINUS: "pi pi-calendar-minus",
    CALENDAR_PLUS: "pi pi-calendar-plus",
    CALENDAR_TIMES: "pi pi-calendar-times",
    CALENDAR: "pi pi-calendar",
    CAMERA: "pi pi-camera",
    CAR: "pi pi-car",
    CARET_DOWN: "pi pi-caret-down",
    CARET_LEFT: "pi pi-caret-left",
    CARET_RIGHT: "pi pi-caret-right",
    CARET_UP: "pi pi-caret-up",
    CART_ARROW_DOWN: "pi pi-cart-arrow-down",
    CART_MINUS: "pi pi-cart-minus",
    CART_PLUS: "pi pi-cart-plus",
    CHART_BAR: "pi pi-chart-bar",
    CHART_LINE: "pi pi-chart-line",
    CHART_PIE: "pi pi-chart-pie",
    CHART_SCATTER: "pi pi-chart-scatter",
    CHECK_CIRCLE: "pi pi-check-circle",
    CHECK_SQUARE: "pi pi-check-square",
    CHECK: "pi pi-check",
    CHEVRON_CIRCLE_DOWN: "pi pi-chevron-circle-down",
    CHEVRON_CIRCLE_LEFT: "pi pi-chevron-circle-left",
    CHEVRON_CIRCLE_RIGHT: "pi pi-chevron-circle-right",
    CHEVRON_CIRCLE_UP: "pi pi-chevron-circle-up",
    CHEVRON_DOWN: "pi pi-chevron-down",
    CHEVRON_LEFT: "pi pi-chevron-left",
    CHEVRON_RIGHT: "pi pi-chevron-right",
    CHEVRON_UP: "pi pi-chevron-up",
    CIRCLE_FILL: "pi pi-circle-fill",
    CIRCLE_OFF: "pi pi-circle-off",
    CIRCLE_ON: "pi pi-circle-on",
    CIRCLE: "pi pi-circle",
    CLIPBOARD: "pi pi-clipboard",
    CLOCK: "pi pi-clock",
    CLONE: "pi pi-clone",
    CLOUD_DOWNLOAD: "pi pi-cloud-download",
    CLOUD_UPLOAD: "pi pi-cloud-upload",
    CLOUD: "pi pi-cloud",
    CODE: "pi pi-code",
    COG: "pi pi-cog",
    COMMENT: "pi pi-comment",
    COMMENTS: "pi pi-comments",
    COMPASS: "pi pi-compass",
    COPY: "pi pi-copy",
    CREDIT_CARD: "pi pi-credit-card",
    CROWN: "pi pi-crown",
    DATABASE: "pi pi-database",
    DELETE_LEFT: "pi pi-delete-left",
    DESKTOP: "pi pi-desktop",
    DIRECTIONS_ALT: "pi pi-directions-alt",
    DIRECTIONS: "pi pi-directions",
    DISCORD: "pi pi-discord",
    DOLLAR: "pi pi-dollar",
    DOWNLOAD: "pi pi-download",
    EJECT: "pi pi-eject",
    ELLIPSIS_H: "pi pi-ellipsis-h",
    ELLIPSIS_V: "pi pi-ellipsis-v",
    ENVELOPE: "pi pi-envelope",
    EQUALS: "pi pi-equals",
    ERASER: "pi pi-eraser",
    ETHEREUM: "pi pi-ethereum",
    EURO: "pi pi-euro",
    EXCLAMATION_CIRCLE: "pi pi-exclamation-circle",
    EXCLAMATION_TRIANGLE: "pi pi-exclamation-triangle",
    EXPAND: "pi pi-expand",
    EXTERNAL_LINK: "pi pi-external-link",
    EYE_SLASH: "pi pi-eye-slash",
    EYE: "pi pi-eye",
    FACE_SMILE: "pi pi-face-smile",
    FACEBOOK: "pi pi-facebook",
    FAST_BACKWARD: "pi pi-fast-backward",
    FAST_FORWARD: "pi pi-fast-forward",
    FILE_ARROW_UP: "pi pi-file-arrow-up",
    FILE_CHECK: "pi pi-file-check",
    FILE_EDIT: "pi pi-file-edit",
    FILE_EXCEL: "pi pi-file-excel",
    FILE_EXPORT: "pi pi-file-export",
    FILE_IMPORT: "pi pi-file-import",
    FILE_O: "pi pi-file-o",
    FILE_PDF: "pi pi-file-pdf",
    FILE_PLUS: "pi pi-file-plus",
    FILE_WORD: "pi pi-file-word",
    FILE: "pi pi-file",
    FILTER_FILL: "pi pi-filter-fill",
    FILTER_SLASH: "pi pi-filter-slash",
    FILTER: "pi pi-filter",
    FLAG_FILL: "pi pi-flag-fill",
    FLAG: "pi pi-flag",
    FOLDER_OPEN: "pi pi-folder-open",
    FOLDER_PLUS: "pi pi-folder-plus",
    FOLDER: "pi pi-folder",
    FORWARD: "pi pi-forward",
    GAUGE: "pi pi-gauge",
    GIFT: "pi pi-gift",
    GITHUB: "pi pi-github",
    GLOBE: "pi pi-globe",
    GOOGLE: "pi pi-google",
    GRADUATION_CAP: "pi pi-graduation-cap",
    HAMMER: "pi pi-hammer",
    HASHTAG: "pi pi-hashtag",
    HEADPHONES: "pi pi-headphones",
    HEART_FILL: "pi pi-heart-fill",
    HEART: "pi pi-heart",
    HISTORY: "pi pi-history",
    HOME: "pi pi-home",
    HOURGLASS: "pi pi-hourglass",
    ID_CARD: "pi pi-id-card",
    IMAGE: "pi pi-image",
    IMAGES: "pi pi-images",
    INBOX: "pi pi-inbox",
    INDIAN_RUPEE: "pi pi-indian-rupee",
    INFO_CIRCLE: "pi pi-info-circle",
    INFO: "pi pi-info",
    INSTAGRAM: "pi pi-instagram",
    KEY: "pi pi-key",
    LANGUAGE: "pi pi-language",
    LIGHTBULB: "pi pi-lightbulb",
    LINK: "pi pi-link",
    LINKEDIN: "pi pi-linkedin",
    LIST_CHECK: "pi pi-list-check",
    LIST: "pi pi-list",
    LOCK_OPEN: "pi pi-lock-open",
    LOCK: "pi pi-lock",
    MAP_MARKER: "pi pi-map-marker",
    MAP: "pi pi-map",
    MARS: "pi pi-mars",
    MEGAPHONE: "pi pi-megaphone",
    MICROCHIP_AI: "pi pi-microchip-ai",
    MICROCHIP: "pi pi-microchip",
    MICROPHONE: "pi pi-microphone",
    MICROSOFT: "pi pi-microsoft",
    MINUS_CIRCLE: "pi pi-minus-circle",
    MINUS: "pi pi-minus",
    MOBILE: "pi pi-mobile",
    MONEY_BILL: "pi pi-money-bill",
    MOON: "pi pi-moon",
    OBJECTS_COLUMN: "pi pi-objects-column",
    PALETTE: "pi pi-palette",
    PAPERCLIP: "pi pi-paperclip",
    PAUSE_CIRCLE: "pi pi-pause-circle",
    PAUSE: "pi pi-pause",
    PAYPAL: "pi pi-paypal",
    PEN_TO_SQUARE: "pi pi-pen-to-square",
    PENCIL: "pi pi-pencil",
    PERCENTAGE: "pi pi-percentage",
    PHONE: "pi pi-phone",
    PINTEREST: "pi pi-pinterest",
    PLAY_CIRCLE: "pi pi-play-circle",
    PLAY: "pi pi-play",
    PLUS_CIRCLE: "pi pi-plus-circle",
    PLUS: "pi pi-plus",
    POUND: "pi pi-pound",
    POWER_OFF: "pi pi-power-off",
    PRIME: "pi pi-prime",
    PRINT: "pi pi-print",
    QRCODE: "pi pi-qrcode",
    QUESTION_CIRCLE: "pi pi-question-circle",
    QUESTION: "pi pi-question",
    RECEIPT: "pi pi-receipt",
    REDDIT: "pi pi-reddit",
    REFRESH: "pi pi-refresh",
    REPLAY: "pi pi-replay",
    REPLY: "pi pi-reply",
    SAVE: "pi pi-save",
    SEARCH_MINUS: "pi pi-search-minus",
    SEARCH_PLUS: "pi pi-search-plus",
    SEARCH: "pi pi-search",
    SEND: "pi pi-send",
    SERVER: "pi pi-server",
    SHARE_ALT: "pi pi-share-alt",
    SHIELD: "pi pi-shield",
    SHOP: "pi pi-shop",
    SHOPPING_BAG: "pi pi-shopping-bag",
    SHOPPING_CART: "pi pi-shopping-cart",
    SIGN_IN: "pi pi-sign-in",
    SIGN_OUT: "pi pi-sign-out",
    SITEMAP: "pi pi-sitemap",
    SLACK: "pi pi-slack",
    SLIDERS_H: "pi pi-sliders-h",
    SLIDERS_V: "pi pi-sliders-v",
    SORT_ALPHA_DOWN_ALT: "pi pi-sort-alpha-down-alt",
    SORT_ALPHA_DOWN: "pi pi-sort-alpha-down",
    SORT_ALPHA_UP_ALT: "pi pi-sort-alpha-up-alt",
    SORT_ALPHA_UP: "pi pi-sort-alpha-up",
    SORT_ALT_SLASH: "pi pi-sort-alt-slash",
    SORT_ALT: "pi pi-sort-alt",
    SORT_AMOUNT_DOWN_ALT: "pi pi-sort-amount-down-alt",
    SORT_AMOUNT_DOWN: "pi pi-sort-amount-down",
    SORT_AMOUNT_UP_ALT: "pi pi-sort-amount-up-alt",
    SORT_AMOUNT_UP: "pi pi-sort-amount-up",
    SORT_DOWN_FILL: "pi pi-sort-down-fill",
    SORT_DOWN: "pi pi-sort-down",
    SORT_NUMERIC_DOWN_ALT: "pi pi-sort-numeric-down-alt",
    SORT_NUMERIC_DOWN: "pi pi-sort-numeric-down",
    SORT_NUMERIC_UP_ALT: "pi pi-sort-numeric-up-alt",
    SORT_NUMERIC_UP: "pi pi-sort-numeric-up",
    SORT_UP_FILL: "pi pi-sort-up-fill",
    SORT_UP: "pi pi-sort-up",
    SORT: "pi pi-sort",
    SPARKLES: "pi pi-sparkles",
    SPINNER_DOTTED: "pi pi-spinner-dotted",
    SPINNER: "pi pi-spinner",
    STAR_FILL: "pi pi-star-fill",
    STAR_HALF_FILL: "pi pi-star-half-fill",
    STAR_HALF: "pi pi-star-half",
    STAR: "pi pi-star",
    STEP_BACKWARD_ALT: "pi pi-step-backward-alt",
    STEP_BACKWARD: "pi pi-step-backward",
    STEP_FORWARD_ALT: "pi pi-step-forward-alt",
    STEP_FORWARD: "pi pi-step-forward",
    STOP_CIRCLE: "pi pi-stop-circle",
    STOP: "pi pi-stop",
    STOPWATCH: "pi pi-stopwatch",
    SUN: "pi pi-sun",
    SYNC: "pi pi-sync",
    TABLE: "pi pi-table",
    TABLET: "pi pi-tablet",
    TAG: "pi pi-tag",
    TAGS: "pi pi-tags",
    TELEGRAM: "pi pi-telegram",
    TH_LARGE: "pi pi-th-large",
    THUMBS_DOWN_FILL: "pi pi-thumbs-down-fill",
    THUMBS_DOWN: "pi pi-thumbs-down",
    THUMBS_UP_FILL: "pi pi-thumbs-up-fill",
    THUMBS_UP: "pi pi-thumbs-up",
    THUMBTACK: "pi pi-thumbtack",
    TICKET: "pi pi-ticket",
    TIKTOK: "pi pi-tiktok",
    TIMES_CIRCLE: "pi pi-times-circle",
    TIMES: "pi pi-times",
    TRASH: "pi pi-trash",
    TROPHY: "pi pi-trophy",
    TRUCK: "pi pi-truck",
    TURKISH_LIRA: "pi pi-turkish-lira",
    TWITCH: "pi pi-twitch",
    TWITTER: "pi pi-twitter",
    UNDO: "pi pi-undo",
    UNLOCK: "pi pi-unlock",
    UPLOAD: "pi pi-upload",
    USER_EDIT: "pi pi-user-edit",
    USER_MINUS: "pi pi-user-minus",
    USER_PLUS: "pi pi-user-plus",
    USER: "pi pi-user",
    USERS: "pi pi-users",
    VENUS: "pi pi-venus",
    VERIFIED: "pi pi-verified",
    VIDEO: "pi pi-video",
    VIMEO: "pi pi-vimeo",
    VOLUME_DOWN: "pi pi-volume-down",
    VOLUME_OFF: "pi pi-volume-off",
    VOLUME_UP: "pi pi-volume-up",
    WALLET: "pi pi-wallet",
    WAREHOUSE: "pi pi-warehouse",
    WAVE_PULSE: "pi pi-wave-pulse",
    WHATSAPP: "pi pi-whatsapp",
    WIFI: "pi pi-wifi",
    WINDOW_MAXIMIZE: "pi pi-window-maximize",
    WINDOW_MINIMIZE: "pi pi-window-minimize",
    WRENCH: "pi pi-wrench",
    YOUTUBE: "pi pi-youtube"
});
var $68bd326542f5b43b$export$7ae723045d45777a = Object.freeze({
    DESC: -1,
    UNSORTED: 0,
    ASC: 1
});
function $68bd326542f5b43b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $68bd326542f5b43b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $68bd326542f5b43b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $68bd326542f5b43b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $68bd326542f5b43b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $68bd326542f5b43b$var$_arrayLikeToArray(o, minLen);
}
function $68bd326542f5b43b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $68bd326542f5b43b$var$_slicedToArray(arr, i) {
    return $68bd326542f5b43b$var$_arrayWithHoles(arr) || $68bd326542f5b43b$var$_iterableToArrayLimit(arr, i) || $68bd326542f5b43b$var$_unsupportedIterableToArray(arr, i) || $68bd326542f5b43b$var$_nonIterableRest();
}
var $68bd326542f5b43b$export$43502877ff87a530 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createContext();
var $68bd326542f5b43b$export$6a5b5c2279ff1e8d = function PrimeReactProvider(props) {
    var propsValue = props.value || {};
    var _useState = (0, $81g6h.useState)(propsValue.ripple || false), _useState2 = $68bd326542f5b43b$var$_slicedToArray(_useState, 2), ripple = _useState2[0], setRipple = _useState2[1];
    var _useState3 = (0, $81g6h.useState)(propsValue.inputStyle || "outlined"), _useState4 = $68bd326542f5b43b$var$_slicedToArray(_useState3, 2), inputStyle = _useState4[0], setInputStyle = _useState4[1];
    var _useState5 = (0, $81g6h.useState)(propsValue.locale || "en"), _useState6 = $68bd326542f5b43b$var$_slicedToArray(_useState5, 2), locale = _useState6[0], setLocale = _useState6[1];
    var _useState7 = (0, $81g6h.useState)(propsValue.appendTo || null), _useState8 = $68bd326542f5b43b$var$_slicedToArray(_useState7, 2), appendTo = _useState8[0], setAppendTo = _useState8[1];
    var _useState9 = (0, $81g6h.useState)(propsValue.styleContainer || null), _useState10 = $68bd326542f5b43b$var$_slicedToArray(_useState9, 2), styleContainer = _useState10[0], setStyleContainer = _useState10[1];
    var _useState11 = (0, $81g6h.useState)(propsValue.cssTransition || true), _useState12 = $68bd326542f5b43b$var$_slicedToArray(_useState11, 2), cssTransition = _useState12[0], setCssTransition = _useState12[1];
    var _useState13 = (0, $81g6h.useState)(propsValue.autoZIndex || true), _useState14 = $68bd326542f5b43b$var$_slicedToArray(_useState13, 2), autoZIndex = _useState14[0], setAutoZIndex = _useState14[1];
    var _useState15 = (0, $81g6h.useState)(propsValue.hideOverlaysOnDocumentScrolling || false), _useState16 = $68bd326542f5b43b$var$_slicedToArray(_useState15, 2), hideOverlaysOnDocumentScrolling = _useState16[0], setHideOverlaysOnDocumentScrolling = _useState16[1];
    var _useState17 = (0, $81g6h.useState)(propsValue.nonce || null), _useState18 = $68bd326542f5b43b$var$_slicedToArray(_useState17, 2), nonce = _useState18[0], setNonce = _useState18[1];
    var _useState19 = (0, $81g6h.useState)(propsValue.nullSortOrder || 1), _useState20 = $68bd326542f5b43b$var$_slicedToArray(_useState19, 2), nullSortOrder = _useState20[0], setNullSortOrder = _useState20[1];
    var _useState21 = (0, $81g6h.useState)(propsValue.zIndex || {
        modal: 1100,
        overlay: 1000,
        menu: 1000,
        tooltip: 1100,
        toast: 1200
    }), _useState22 = $68bd326542f5b43b$var$_slicedToArray(_useState21, 2), zIndex = _useState22[0], setZIndex = _useState22[1];
    var _useState23 = (0, $81g6h.useState)(propsValue.ptOptions || {
        mergeSections: true,
        mergeProps: true
    }), _useState24 = $68bd326542f5b43b$var$_slicedToArray(_useState23, 2), ptOptions = _useState24[0], setPtOptions = _useState24[1];
    var _useState25 = (0, $81g6h.useState)(propsValue.pt || undefined), _useState26 = $68bd326542f5b43b$var$_slicedToArray(_useState25, 2), pt = _useState26[0], setPt = _useState26[1];
    var _useState27 = (0, $81g6h.useState)(propsValue.unstyled || false), _useState28 = $68bd326542f5b43b$var$_slicedToArray(_useState27, 2), unstyled = _useState28[0], setUnstyled = _useState28[1];
    var _useState29 = (0, $81g6h.useState)(propsValue.filterMatchModeOptions || {
        text: [
            $68bd326542f5b43b$export$b9fbdf9129f67822.STARTS_WITH,
            $68bd326542f5b43b$export$b9fbdf9129f67822.CONTAINS,
            $68bd326542f5b43b$export$b9fbdf9129f67822.NOT_CONTAINS,
            $68bd326542f5b43b$export$b9fbdf9129f67822.ENDS_WITH,
            $68bd326542f5b43b$export$b9fbdf9129f67822.EQUALS,
            $68bd326542f5b43b$export$b9fbdf9129f67822.NOT_EQUALS
        ],
        numeric: [
            $68bd326542f5b43b$export$b9fbdf9129f67822.EQUALS,
            $68bd326542f5b43b$export$b9fbdf9129f67822.NOT_EQUALS,
            $68bd326542f5b43b$export$b9fbdf9129f67822.LESS_THAN,
            $68bd326542f5b43b$export$b9fbdf9129f67822.LESS_THAN_OR_EQUAL_TO,
            $68bd326542f5b43b$export$b9fbdf9129f67822.GREATER_THAN,
            $68bd326542f5b43b$export$b9fbdf9129f67822.GREATER_THAN_OR_EQUAL_TO
        ],
        date: [
            $68bd326542f5b43b$export$b9fbdf9129f67822.DATE_IS,
            $68bd326542f5b43b$export$b9fbdf9129f67822.DATE_IS_NOT,
            $68bd326542f5b43b$export$b9fbdf9129f67822.DATE_BEFORE,
            $68bd326542f5b43b$export$b9fbdf9129f67822.DATE_AFTER
        ]
    }), _useState30 = $68bd326542f5b43b$var$_slicedToArray(_useState29, 2), filterMatchModeOptions = _useState30[0], setFilterMatchModeOptions = _useState30[1];
    var changeTheme = function changeTheme(currentTheme, newTheme, linkElementId, callback) {
        var _linkElement$parentNo;
        var linkElement = document.getElementById(linkElementId);
        var cloneLinkElement = linkElement.cloneNode(true);
        var newThemeUrl = linkElement.getAttribute("href").replace(currentTheme, newTheme);
        cloneLinkElement.setAttribute("id", linkElementId + "-clone");
        cloneLinkElement.setAttribute("href", newThemeUrl);
        cloneLinkElement.addEventListener("load", function() {
            linkElement.remove();
            cloneLinkElement.setAttribute("id", linkElementId);
            if (callback) callback();
        });
        (_linkElement$parentNo = linkElement.parentNode) === null || _linkElement$parentNo === void 0 || _linkElement$parentNo.insertBefore(cloneLinkElement, linkElement.nextSibling);
    };
    /**
   * @deprecated
   */ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(function() {
        $68bd326542f5b43b$var$PrimeReact$1.ripple = ripple;
    }, [
        ripple
    ]);
    /**
   * @deprecated
   */ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(function() {
        $68bd326542f5b43b$var$PrimeReact$1.inputStyle = inputStyle;
    }, [
        inputStyle
    ]);
    /**
   * @deprecated
   */ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(function() {
        $68bd326542f5b43b$var$PrimeReact$1.locale = locale;
    }, [
        locale
    ]);
    var value = {
        changeTheme: changeTheme,
        ripple: ripple,
        setRipple: setRipple,
        inputStyle: inputStyle,
        setInputStyle: setInputStyle,
        locale: locale,
        setLocale: setLocale,
        appendTo: appendTo,
        setAppendTo: setAppendTo,
        styleContainer: styleContainer,
        setStyleContainer: setStyleContainer,
        cssTransition: cssTransition,
        setCssTransition: setCssTransition,
        autoZIndex: autoZIndex,
        setAutoZIndex: setAutoZIndex,
        hideOverlaysOnDocumentScrolling: hideOverlaysOnDocumentScrolling,
        setHideOverlaysOnDocumentScrolling: setHideOverlaysOnDocumentScrolling,
        nonce: nonce,
        setNonce: setNonce,
        nullSortOrder: nullSortOrder,
        setNullSortOrder: setNullSortOrder,
        zIndex: zIndex,
        setZIndex: setZIndex,
        ptOptions: ptOptions,
        setPtOptions: setPtOptions,
        pt: pt,
        setPt: setPt,
        filterMatchModeOptions: filterMatchModeOptions,
        setFilterMatchModeOptions: setFilterMatchModeOptions,
        unstyled: unstyled,
        setUnstyled: setUnstyled
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement($68bd326542f5b43b$export$43502877ff87a530.Provider, {
        value: value
    }, props.children);
};
var $68bd326542f5b43b$export$2e2bcd8739ae039 = $68bd326542f5b43b$var$PrimeReact$1;

});
parcelRegister("cfkGk", function(module, exports) {

$parcel$export(module.exports, "classNames", () => $8ea6edb353c20265$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "DomHandler", () => $8ea6edb353c20265$export$ff8ccbac9225de62);
$parcel$export(module.exports, "EventBus", () => $8ea6edb353c20265$export$5087227eb54526);
$parcel$export(module.exports, "ObjectUtils", () => $8ea6edb353c20265$export$4855211e6b8ad895);
$parcel$export(module.exports, "IconUtils", () => $8ea6edb353c20265$export$7114f767f3d3c711);
$parcel$export(module.exports, "mask", () => $8ea6edb353c20265$export$d99f0801a68bbcf1);
$parcel$export(module.exports, "mergeProps", () => $8ea6edb353c20265$export$9d1611c77c2fe928);
$parcel$export(module.exports, "UniqueComponentId", () => $8ea6edb353c20265$export$d5d9b89141473caf);
$parcel$export(module.exports, "ZIndexUtils", () => $8ea6edb353c20265$export$832931caede8e4b9);

var $81g6h = parcelRequire("81g6h");
"use client";
function $8ea6edb353c20265$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8ea6edb353c20265$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $8ea6edb353c20265$var$_arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8ea6edb353c20265$var$_unsupportedIterableToArray$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8ea6edb353c20265$var$_arrayLikeToArray$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8ea6edb353c20265$var$_arrayLikeToArray$2(o, minLen);
}
function $8ea6edb353c20265$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8ea6edb353c20265$var$_slicedToArray(arr, i) {
    return $8ea6edb353c20265$var$_arrayWithHoles(arr) || $8ea6edb353c20265$var$_iterableToArrayLimit(arr, i) || $8ea6edb353c20265$var$_unsupportedIterableToArray$2(arr, i) || $8ea6edb353c20265$var$_nonIterableRest();
}
function $8ea6edb353c20265$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8ea6edb353c20265$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8ea6edb353c20265$var$_typeof(o);
}
function $8ea6edb353c20265$export$ce4ab0c55987d1ff() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (args) {
        var classes = [];
        for(var i = 0; i < args.length; i++){
            var className = args[i];
            if (!className) continue;
            var type = $8ea6edb353c20265$var$_typeof(className);
            if (type === "string" || type === "number") classes.push(className);
            else if (type === "object") {
                var _classes = Array.isArray(className) ? className : Object.entries(className).map(function(_ref) {
                    var _ref2 = $8ea6edb353c20265$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    return value ? key : null;
                });
                classes = _classes.length ? classes.concat(_classes.filter(function(c) {
                    return !!c;
                })) : classes;
            }
        }
        return classes.join(" ").trim();
    }
    return undefined;
}
function $8ea6edb353c20265$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8ea6edb353c20265$var$_arrayLikeToArray$2(arr);
}
function $8ea6edb353c20265$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8ea6edb353c20265$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8ea6edb353c20265$var$_toConsumableArray(arr) {
    return $8ea6edb353c20265$var$_arrayWithoutHoles(arr) || $8ea6edb353c20265$var$_iterableToArray(arr) || $8ea6edb353c20265$var$_unsupportedIterableToArray$2(arr) || $8ea6edb353c20265$var$_nonIterableSpread();
}
function $8ea6edb353c20265$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8ea6edb353c20265$var$_toPrimitive(input, hint) {
    if ($8ea6edb353c20265$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8ea6edb353c20265$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8ea6edb353c20265$var$_toPropertyKey(arg) {
    var key = $8ea6edb353c20265$var$_toPrimitive(arg, "string");
    return $8ea6edb353c20265$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8ea6edb353c20265$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $8ea6edb353c20265$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $8ea6edb353c20265$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8ea6edb353c20265$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8ea6edb353c20265$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8ea6edb353c20265$var$_defineProperty(obj, key, value) {
    key = $8ea6edb353c20265$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8ea6edb353c20265$var$_createForOfIteratorHelper$1(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $8ea6edb353c20265$var$_unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $8ea6edb353c20265$var$_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8ea6edb353c20265$var$_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8ea6edb353c20265$var$_arrayLikeToArray$1(o, minLen);
}
function $8ea6edb353c20265$var$_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $8ea6edb353c20265$export$ff8ccbac9225de62 = /*#__PURE__*/ function() {
    function DomHandler() {
        $8ea6edb353c20265$var$_classCallCheck(this, DomHandler);
    }
    return $8ea6edb353c20265$var$_createClass(DomHandler, null, [
        {
            key: "innerWidth",
            value: function innerWidth(el) {
                if (el) {
                    var width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    width = width + (parseFloat(style.paddingLeft) + parseFloat(style.paddingRight));
                    return width;
                }
                return 0;
            }
        },
        {
            key: "width",
            value: function width(el) {
                if (el) {
                    var width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    width = width - (parseFloat(style.paddingLeft) + parseFloat(style.paddingRight));
                    return width;
                }
                return 0;
            }
        },
        {
            key: "getBrowserLanguage",
            value: function getBrowserLanguage() {
                return navigator.userLanguage || navigator.languages && navigator.languages.length && navigator.languages[0] || navigator.language || navigator.browserLanguage || navigator.systemLanguage || "en";
            }
        },
        {
            key: "getWindowScrollTop",
            value: function getWindowScrollTop() {
                var doc = document.documentElement;
                return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
            }
        },
        {
            key: "getWindowScrollLeft",
            value: function getWindowScrollLeft() {
                var doc = document.documentElement;
                return (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
            }
        },
        {
            key: "getOuterWidth",
            value: function getOuterWidth(el, margin) {
                if (el) {
                    var width = el.getBoundingClientRect().width || el.offsetWidth;
                    if (margin) {
                        var style = getComputedStyle(el);
                        width = width + (parseFloat(style.marginLeft) + parseFloat(style.marginRight));
                    }
                    return width;
                }
                return 0;
            }
        },
        {
            key: "getOuterHeight",
            value: function getOuterHeight(el, margin) {
                if (el) {
                    var height = el.getBoundingClientRect().height || el.offsetHeight;
                    if (margin) {
                        var style = getComputedStyle(el);
                        height = height + (parseFloat(style.marginTop) + parseFloat(style.marginBottom));
                    }
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getClientHeight",
            value: function getClientHeight(el, margin) {
                if (el) {
                    var height = el.clientHeight;
                    if (margin) {
                        var style = getComputedStyle(el);
                        height = height + (parseFloat(style.marginTop) + parseFloat(style.marginBottom));
                    }
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getClientWidth",
            value: function getClientWidth(el, margin) {
                if (el) {
                    var width = el.clientWidth;
                    if (margin) {
                        var style = getComputedStyle(el);
                        width = width + (parseFloat(style.marginLeft) + parseFloat(style.marginRight));
                    }
                    return width;
                }
                return 0;
            }
        },
        {
            key: "getViewport",
            value: function getViewport() {
                var win = window;
                var d = document;
                var e = d.documentElement;
                var g = d.getElementsByTagName("body")[0];
                var w = win.innerWidth || e.clientWidth || g.clientWidth;
                var h = win.innerHeight || e.clientHeight || g.clientHeight;
                return {
                    width: w,
                    height: h
                };
            }
        },
        {
            key: "getOffset",
            value: function getOffset(el) {
                if (el) {
                    var rect = el.getBoundingClientRect();
                    return {
                        top: rect.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
                        left: rect.left + (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0)
                    };
                }
                return {
                    top: "auto",
                    left: "auto"
                };
            }
        },
        {
            key: "index",
            value: function index(element) {
                if (element) {
                    var children = element.parentNode.childNodes;
                    var num = 0;
                    for(var i = 0; i < children.length; i++){
                        if (children[i] === element) return num;
                        if (children[i].nodeType === 1) num++;
                    }
                }
                return -1;
            }
        },
        {
            key: "addMultipleClasses",
            value: function addMultipleClasses(element, className) {
                if (element && className) {
                    if (element.classList) {
                        var styles = className.split(" ");
                        for(var i = 0; i < styles.length; i++)element.classList.add(styles[i]);
                    } else {
                        var _styles = className.split(" ");
                        for(var _i = 0; _i < _styles.length; _i++)element.className = element.className + (" " + _styles[_i]);
                    }
                }
            }
        },
        {
            key: "removeMultipleClasses",
            value: function removeMultipleClasses(element, className) {
                if (element && className) {
                    if (element.classList) {
                        var styles = className.split(" ");
                        for(var i = 0; i < styles.length; i++)element.classList.remove(styles[i]);
                    } else {
                        var _styles2 = className.split(" ");
                        for(var _i2 = 0; _i2 < _styles2.length; _i2++)element.className = element.className.replace(new RegExp("(^|\\b)" + _styles2[_i2].split(" ").join("|") + "(\\b|$)", "gi"), " ");
                    }
                }
            }
        },
        {
            key: "addClass",
            value: function addClass(element, className) {
                if (element && className) {
                    if (element.classList) element.classList.add(className);
                    else element.className = element.className + (" " + className);
                }
            }
        },
        {
            key: "removeClass",
            value: function removeClass(element, className) {
                if (element && className) {
                    if (element.classList) element.classList.remove(className);
                    else element.className = element.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
                }
            }
        },
        {
            key: "hasClass",
            value: function hasClass(element, className) {
                if (element) {
                    if (element.classList) return element.classList.contains(className);
                    return new RegExp("(^| )" + className + "( |$)", "gi").test(element.className);
                }
                return false;
            }
        },
        {
            key: "addStyles",
            value: function addStyles(element) {
                var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (element) Object.entries(styles).forEach(function(_ref) {
                    var _ref2 = $8ea6edb353c20265$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    return element.style[key] = value;
                });
            }
        },
        {
            key: "find",
            value: function find(element, selector) {
                return element ? Array.from(element.querySelectorAll(selector)) : [];
            }
        },
        {
            key: "findSingle",
            value: function findSingle(element, selector) {
                if (element) return element.querySelector(selector);
                return null;
            }
        },
        {
            key: "setAttributes",
            value: function setAttributes(element) {
                var _this = this;
                var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (element) {
                    var computedStyles = function computedStyles(rule, value) {
                        var _element$$attrs, _element$$attrs2;
                        var styles = element !== null && element !== void 0 && (_element$$attrs = element.$attrs) !== null && _element$$attrs !== void 0 && _element$$attrs[rule] ? [
                            element === null || element === void 0 || (_element$$attrs2 = element.$attrs) === null || _element$$attrs2 === void 0 ? void 0 : _element$$attrs2[rule]
                        ] : [];
                        return [
                            value
                        ].flat().reduce(function(cv, v) {
                            if (v !== null && v !== undefined) {
                                var type = $8ea6edb353c20265$var$_typeof(v);
                                if (type === "string" || type === "number") cv.push(v);
                                else if (type === "object") {
                                    var _cv = Array.isArray(v) ? computedStyles(rule, v) : Object.entries(v).map(function(_ref3) {
                                        var _ref4 = $8ea6edb353c20265$var$_slicedToArray(_ref3, 2), _k = _ref4[0], _v = _ref4[1];
                                        return rule === "style" && (!!_v || _v === 0) ? "".concat(_k.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), ":").concat(_v) : _v ? _k : undefined;
                                    });
                                    cv = _cv.length ? cv.concat(_cv.filter(function(c) {
                                        return !!c;
                                    })) : cv;
                                }
                            }
                            return cv;
                        }, styles);
                    };
                    Object.entries(attributes).forEach(function(_ref5) {
                        var _ref6 = $8ea6edb353c20265$var$_slicedToArray(_ref5, 2), key = _ref6[0], value = _ref6[1];
                        if (value !== undefined && value !== null) {
                            var matchedEvent = key.match(/^on(.+)/);
                            if (matchedEvent) element.addEventListener(matchedEvent[1].toLowerCase(), value);
                            else if (key === "p-bind") _this.setAttributes(element, value);
                            else {
                                value = key === "class" ? $8ea6edb353c20265$var$_toConsumableArray(new Set(computedStyles("class", value))).join(" ").trim() : key === "style" ? computedStyles("style", value).join(";").trim() : value;
                                element.$attrs = element.$attrs || {}, element.$attrs[key] = value;
                                element.setAttribute(key, value);
                            }
                        }
                    });
                }
            }
        },
        {
            key: "getAttribute",
            value: function getAttribute(element, name) {
                if (element) {
                    var value = element.getAttribute(name);
                    if (!isNaN(value)) return +value;
                    if (value === "true" || value === "false") return value === "true";
                    return value;
                }
                return undefined;
            }
        },
        {
            key: "isAttributeEquals",
            value: function isAttributeEquals(element, name, value) {
                return element ? this.getAttribute(element, name) === value : false;
            }
        },
        {
            key: "isAttributeNotEquals",
            value: function isAttributeNotEquals(element, name, value) {
                return !this.isAttributeEquals(element, name, value);
            }
        },
        {
            key: "getHeight",
            value: function getHeight(el) {
                if (el) {
                    var height = el.offsetHeight;
                    var style = getComputedStyle(el);
                    height = height - (parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth));
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getWidth",
            value: function getWidth(el) {
                if (el) {
                    var width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    width = width - (parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth));
                    return width;
                }
                return 0;
            }
        },
        {
            key: "alignOverlay",
            value: function alignOverlay(overlay, target, appendTo) {
                var calculateMinWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
                if (overlay && target) {
                    if (appendTo === "self") this.relativePosition(overlay, target);
                    else {
                        calculateMinWidth && (overlay.style.minWidth = DomHandler.getOuterWidth(target) + "px");
                        this.absolutePosition(overlay, target);
                    }
                }
            }
        },
        {
            key: "absolutePosition",
            value: function absolutePosition(element, target) {
                var align = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "left";
                if (element && target) {
                    var elementDimensions = element.offsetParent ? {
                        width: element.offsetWidth,
                        height: element.offsetHeight
                    } : this.getHiddenElementDimensions(element);
                    var elementOuterHeight = elementDimensions.height;
                    var elementOuterWidth = elementDimensions.width;
                    var targetOuterHeight = target.offsetHeight;
                    var targetOuterWidth = target.offsetWidth;
                    var targetOffset = target.getBoundingClientRect();
                    var windowScrollTop = this.getWindowScrollTop();
                    var windowScrollLeft = this.getWindowScrollLeft();
                    var viewport = this.getViewport();
                    var top;
                    var left;
                    if (targetOffset.top + targetOuterHeight + elementOuterHeight > viewport.height) {
                        top = targetOffset.top + windowScrollTop - elementOuterHeight;
                        if (top < 0) top = windowScrollTop;
                        element.style.transformOrigin = "bottom";
                    } else {
                        top = targetOuterHeight + targetOffset.top + windowScrollTop;
                        element.style.transformOrigin = "top";
                    }
                    var targetOffsetPx = targetOffset.left;
                    var alignOffset = align === "left" ? 0 : elementOuterWidth - targetOuterWidth;
                    if (targetOffsetPx + targetOuterWidth + elementOuterWidth > viewport.width) left = Math.max(0, targetOffsetPx + windowScrollLeft + targetOuterWidth - elementOuterWidth);
                    else left = targetOffsetPx - alignOffset + windowScrollLeft;
                    element.style.top = top + "px";
                    element.style.left = left + "px";
                }
            }
        },
        {
            key: "relativePosition",
            value: function relativePosition(element, target) {
                if (element && target) {
                    var elementDimensions = element.offsetParent ? {
                        width: element.offsetWidth,
                        height: element.offsetHeight
                    } : this.getHiddenElementDimensions(element);
                    var targetHeight = target.offsetHeight;
                    var targetOffset = target.getBoundingClientRect();
                    var viewport = this.getViewport();
                    var top;
                    var left;
                    if (targetOffset.top + targetHeight + elementDimensions.height > viewport.height) {
                        top = -1 * elementDimensions.height;
                        if (targetOffset.top + top < 0) top = -1 * targetOffset.top;
                        element.style.transformOrigin = "bottom";
                    } else {
                        top = targetHeight;
                        element.style.transformOrigin = "top";
                    }
                    if (elementDimensions.width > viewport.width) // element wider then viewport and cannot fit on screen (align at left side of viewport)
                    left = targetOffset.left * -1;
                    else if (targetOffset.left + elementDimensions.width > viewport.width) // element wider then viewport but can be fit on screen (align at right side of viewport)
                    left = (targetOffset.left + elementDimensions.width - viewport.width) * -1;
                    else // element fits on screen (align with target)
                    left = 0;
                    element.style.top = top + "px";
                    element.style.left = left + "px";
                }
            }
        },
        {
            key: "flipfitCollision",
            value: function flipfitCollision(element, target) {
                var _this2 = this;
                var my = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "left top";
                var at = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "left bottom";
                var callback = arguments.length > 4 ? arguments[4] : undefined;
                if (element && target) {
                    var targetOffset = target.getBoundingClientRect();
                    var viewport = this.getViewport();
                    var myArr = my.split(" ");
                    var atArr = at.split(" ");
                    var getPositionValue = function getPositionValue(arr, isOffset) {
                        return isOffset ? +arr.substring(arr.search(/(\+|-)/g)) || 0 : arr.substring(0, arr.search(/(\+|-)/g)) || arr;
                    };
                    var position = {
                        my: {
                            x: getPositionValue(myArr[0]),
                            y: getPositionValue(myArr[1] || myArr[0]),
                            offsetX: getPositionValue(myArr[0], true),
                            offsetY: getPositionValue(myArr[1] || myArr[0], true)
                        },
                        at: {
                            x: getPositionValue(atArr[0]),
                            y: getPositionValue(atArr[1] || atArr[0]),
                            offsetX: getPositionValue(atArr[0], true),
                            offsetY: getPositionValue(atArr[1] || atArr[0], true)
                        }
                    };
                    var myOffset = {
                        left: function left() {
                            var totalOffset = position.my.offsetX + position.at.offsetX;
                            return totalOffset + targetOffset.left + (position.my.x === "left" ? 0 : -1 * (position.my.x === "center" ? _this2.getOuterWidth(element) / 2 : _this2.getOuterWidth(element)));
                        },
                        top: function top() {
                            var totalOffset = position.my.offsetY + position.at.offsetY;
                            return totalOffset + targetOffset.top + (position.my.y === "top" ? 0 : -1 * (position.my.y === "center" ? _this2.getOuterHeight(element) / 2 : _this2.getOuterHeight(element)));
                        }
                    };
                    var alignWithAt = {
                        count: {
                            x: 0,
                            y: 0
                        },
                        left: function left() {
                            var left = myOffset.left();
                            var scrollLeft = DomHandler.getWindowScrollLeft();
                            element.style.left = left + scrollLeft + "px";
                            if (this.count.x === 2) {
                                element.style.left = scrollLeft + "px";
                                this.count.x = 0;
                            } else if (left < 0) {
                                this.count.x++;
                                position.my.x = "left";
                                position.at.x = "right";
                                position.my.offsetX *= -1;
                                position.at.offsetX *= -1;
                                this.right();
                            }
                        },
                        right: function right() {
                            var left = myOffset.left() + DomHandler.getOuterWidth(target);
                            var scrollLeft = DomHandler.getWindowScrollLeft();
                            element.style.left = left + scrollLeft + "px";
                            if (this.count.x === 2) {
                                element.style.left = viewport.width - DomHandler.getOuterWidth(element) + scrollLeft + "px";
                                this.count.x = 0;
                            } else if (left + DomHandler.getOuterWidth(element) > viewport.width) {
                                this.count.x++;
                                position.my.x = "right";
                                position.at.x = "left";
                                position.my.offsetX *= -1;
                                position.at.offsetX *= -1;
                                this.left();
                            }
                        },
                        top: function top() {
                            var top = myOffset.top();
                            var scrollTop = DomHandler.getWindowScrollTop();
                            element.style.top = top + scrollTop + "px";
                            if (this.count.y === 2) {
                                element.style.left = scrollTop + "px";
                                this.count.y = 0;
                            } else if (top < 0) {
                                this.count.y++;
                                position.my.y = "top";
                                position.at.y = "bottom";
                                position.my.offsetY *= -1;
                                position.at.offsetY *= -1;
                                this.bottom();
                            }
                        },
                        bottom: function bottom() {
                            var top = myOffset.top() + DomHandler.getOuterHeight(target);
                            var scrollTop = DomHandler.getWindowScrollTop();
                            element.style.top = top + scrollTop + "px";
                            if (this.count.y === 2) {
                                element.style.left = viewport.height - DomHandler.getOuterHeight(element) + scrollTop + "px";
                                this.count.y = 0;
                            } else if (top + DomHandler.getOuterHeight(target) > viewport.height) {
                                this.count.y++;
                                position.my.y = "bottom";
                                position.at.y = "top";
                                position.my.offsetY *= -1;
                                position.at.offsetY *= -1;
                                this.top();
                            }
                        },
                        center: function center(axis) {
                            if (axis === "y") {
                                var top = myOffset.top() + DomHandler.getOuterHeight(target) / 2;
                                element.style.top = top + DomHandler.getWindowScrollTop() + "px";
                                if (top < 0) this.bottom();
                                else if (top + DomHandler.getOuterHeight(target) > viewport.height) this.top();
                            } else {
                                var left = myOffset.left() + DomHandler.getOuterWidth(target) / 2;
                                element.style.left = left + DomHandler.getWindowScrollLeft() + "px";
                                if (left < 0) this.left();
                                else if (left + DomHandler.getOuterWidth(element) > viewport.width) this.right();
                            }
                        }
                    };
                    alignWithAt[position.at.x]("x");
                    alignWithAt[position.at.y]("y");
                    if (this.isFunction(callback)) callback(position);
                }
            }
        },
        {
            key: "findCollisionPosition",
            value: function findCollisionPosition(position) {
                if (position) {
                    var isAxisY = position === "top" || position === "bottom";
                    var myXPosition = position === "left" ? "right" : "left";
                    var myYPosition = position === "top" ? "bottom" : "top";
                    if (isAxisY) return {
                        axis: "y",
                        my: "center ".concat(myYPosition),
                        at: "center ".concat(position)
                    };
                    return {
                        axis: "x",
                        my: "".concat(myXPosition, " center"),
                        at: "".concat(position, " center")
                    };
                }
            }
        },
        {
            key: "getParents",
            value: function getParents(element) {
                var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return element.parentNode === null ? parents : this.getParents(element.parentNode, parents.concat([
                    element.parentNode
                ]));
            }
        },
        {
            key: "getScrollableParents",
            value: function getScrollableParents(element) {
                var hideOverlaysOnDocumentScrolling = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var scrollableParents = [];
                if (element) {
                    var parents = this.getParents(element);
                    var overflowRegex = /(auto|scroll)/;
                    var overflowCheck = function overflowCheck(node) {
                        var styleDeclaration = node ? getComputedStyle(node) : null;
                        return styleDeclaration && (overflowRegex.test(styleDeclaration.getPropertyValue("overflow")) || overflowRegex.test(styleDeclaration.getPropertyValue("overflow-x")) || overflowRegex.test(styleDeclaration.getPropertyValue("overflow-y")));
                    };
                    var addScrollableParent = function addScrollableParent(node) {
                        if (hideOverlaysOnDocumentScrolling) // nodeType 9 is for document element
                        scrollableParents.push(node.nodeName === "BODY" || node.nodeName === "HTML" || node.nodeType === 9 ? window : node);
                        else scrollableParents.push(node);
                    };
                    var _iterator = $8ea6edb353c20265$var$_createForOfIteratorHelper$1(parents), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var parent = _step.value;
                            var scrollSelectors = parent.nodeType === 1 && parent.dataset.scrollselectors;
                            if (scrollSelectors) {
                                var selectors = scrollSelectors.split(",");
                                var _iterator2 = $8ea6edb353c20265$var$_createForOfIteratorHelper$1(selectors), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var selector = _step2.value;
                                        var el = this.findSingle(parent, selector);
                                        if (el && overflowCheck(el)) addScrollableParent(el);
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                            }
                            // BODY
                            if (parent.nodeType === 1 && overflowCheck(parent)) addScrollableParent(parent);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                // we should always at least have the body or window
                if (!scrollableParents.some(function(node) {
                    return node === document.body || node === window;
                })) scrollableParents.push(window);
                return scrollableParents;
            }
        },
        {
            key: "getHiddenElementOuterHeight",
            value: function getHiddenElementOuterHeight(element) {
                if (element) {
                    element.style.visibility = "hidden";
                    element.style.display = "block";
                    var elementHeight = element.offsetHeight;
                    element.style.display = "none";
                    element.style.visibility = "visible";
                    return elementHeight;
                }
                return 0;
            }
        },
        {
            key: "getHiddenElementOuterWidth",
            value: function getHiddenElementOuterWidth(element) {
                if (element) {
                    element.style.visibility = "hidden";
                    element.style.display = "block";
                    var elementWidth = element.offsetWidth;
                    element.style.display = "none";
                    element.style.visibility = "visible";
                    return elementWidth;
                }
                return 0;
            }
        },
        {
            key: "getHiddenElementDimensions",
            value: function getHiddenElementDimensions(element) {
                var dimensions = {};
                if (element) {
                    element.style.visibility = "hidden";
                    element.style.display = "block";
                    dimensions.width = element.offsetWidth;
                    dimensions.height = element.offsetHeight;
                    element.style.display = "none";
                    element.style.visibility = "visible";
                }
                return dimensions;
            }
        },
        {
            key: "fadeIn",
            value: function fadeIn(element, duration) {
                if (element) {
                    element.style.opacity = 0;
                    var last = +new Date();
                    var opacity = 0;
                    var tick = function tick() {
                        opacity = +element.style.opacity + (new Date().getTime() - last) / duration;
                        element.style.opacity = opacity;
                        last = +new Date();
                        if (+opacity < 1) window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
                    };
                    tick();
                }
            }
        },
        {
            key: "fadeOut",
            value: function fadeOut(element, duration) {
                if (element) {
                    var opacity = 1;
                    var interval = 50;
                    var gap = interval / duration;
                    var fading = setInterval(function() {
                        opacity = opacity - gap;
                        if (opacity <= 0) {
                            opacity = 0;
                            clearInterval(fading);
                        }
                        element.style.opacity = opacity;
                    }, interval);
                }
            }
        },
        {
            key: "getUserAgent",
            value: function getUserAgent() {
                return navigator.userAgent;
            }
        },
        {
            key: "isIOS",
            value: function isIOS() {
                return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            }
        },
        {
            key: "isAndroid",
            value: function isAndroid() {
                return /(android)/i.test(navigator.userAgent);
            }
        },
        {
            key: "isChrome",
            value: function isChrome() {
                return /(chrome)/i.test(navigator.userAgent);
            }
        },
        {
            key: "isClient",
            value: function isClient() {
                return !!(typeof window !== "undefined" && window.document && window.document.createElement);
            }
        },
        {
            key: "isTouchDevice",
            value: function isTouchDevice() {
                return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
            }
        },
        {
            key: "isFunction",
            value: function isFunction(obj) {
                return !!(obj && obj.constructor && obj.call && obj.apply);
            }
        },
        {
            key: "appendChild",
            value: function appendChild(element, target) {
                if (this.isElement(target)) target.appendChild(element);
                else if (target.el && target.el.nativeElement) target.el.nativeElement.appendChild(element);
                else throw new Error("Cannot append " + target + " to " + element);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(element, target) {
                if (this.isElement(target)) target.removeChild(element);
                else if (target.el && target.el.nativeElement) target.el.nativeElement.removeChild(element);
                else throw new Error("Cannot remove " + element + " from " + target);
            }
        },
        {
            key: "isElement",
            value: function isElement(obj) {
                return (typeof HTMLElement === "undefined" ? "undefined" : $8ea6edb353c20265$var$_typeof(HTMLElement)) === "object" ? obj instanceof HTMLElement : obj && $8ea6edb353c20265$var$_typeof(obj) === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === "string";
            }
        },
        {
            key: "scrollInView",
            value: function scrollInView(container, item) {
                var borderTopValue = getComputedStyle(container).getPropertyValue("border-top-width");
                var borderTop = borderTopValue ? parseFloat(borderTopValue) : 0;
                var paddingTopValue = getComputedStyle(container).getPropertyValue("padding-top");
                var paddingTop = paddingTopValue ? parseFloat(paddingTopValue) : 0;
                var containerRect = container.getBoundingClientRect();
                var itemRect = item.getBoundingClientRect();
                var offset = itemRect.top + document.body.scrollTop - (containerRect.top + document.body.scrollTop) - borderTop - paddingTop;
                var scroll = container.scrollTop;
                var elementHeight = container.clientHeight;
                var itemHeight = this.getOuterHeight(item);
                if (offset < 0) container.scrollTop = scroll + offset;
                else if (offset + itemHeight > elementHeight) container.scrollTop = scroll + offset - elementHeight + itemHeight;
            }
        },
        {
            key: "clearSelection",
            value: function clearSelection() {
                if (window.getSelection) {
                    if (window.getSelection().empty) window.getSelection().empty();
                    else if (window.getSelection().removeAllRanges && window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects().length > 0) window.getSelection().removeAllRanges();
                } else if (document.selection && document.selection.empty) try {
                    document.selection.empty();
                } catch (error) {
                //ignore IE bug
                }
            }
        },
        {
            key: "calculateScrollbarWidth",
            value: function calculateScrollbarWidth(el) {
                if (el) {
                    var style = getComputedStyle(el);
                    return el.offsetWidth - el.clientWidth - parseFloat(style.borderLeftWidth) - parseFloat(style.borderRightWidth);
                }
                if (this.calculatedScrollbarWidth != null) return this.calculatedScrollbarWidth;
                var scrollDiv = document.createElement("div");
                scrollDiv.className = "p-scrollbar-measure";
                document.body.appendChild(scrollDiv);
                var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
                document.body.removeChild(scrollDiv);
                this.calculatedScrollbarWidth = scrollbarWidth;
                return scrollbarWidth;
            }
        },
        {
            key: "calculateBodyScrollbarWidth",
            value: function calculateBodyScrollbarWidth() {
                return window.innerWidth - document.documentElement.offsetWidth;
            }
        },
        {
            key: "getBrowser",
            value: function getBrowser() {
                if (!this.browser) {
                    var matched = this.resolveUserAgent();
                    this.browser = {};
                    if (matched.browser) {
                        this.browser[matched.browser] = true;
                        this.browser.version = matched.version;
                    }
                    if (this.browser.chrome) this.browser.webkit = true;
                    else if (this.browser.webkit) this.browser.safari = true;
                }
                return this.browser;
            }
        },
        {
            key: "resolveUserAgent",
            value: function resolveUserAgent() {
                var ua = navigator.userAgent.toLowerCase();
                var match = /(chrome)[ ]([\w.]+)/.exec(ua) || /(webkit)[ ]([\w.]+)/.exec(ua) || /(opera)(?:.*version|)[ ]([\w.]+)/.exec(ua) || /(msie) ([\w.]+)/.exec(ua) || ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];
                return {
                    browser: match[1] || "",
                    version: match[2] || "0"
                };
            }
        },
        {
            key: "blockBodyScroll",
            value: function blockBodyScroll() {
                var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "p-overflow-hidden";
                /* PR Ref: https://github.com/primefaces/primereact/pull/4976
       * @todo This method is called several times after this PR. Refactors will be made to prevent this in future releases.
       */ var hasScrollbarWidth = !!document.body.style.getPropertyValue("--scrollbar-width");
                !hasScrollbarWidth && document.body.style.setProperty("--scrollbar-width", this.calculateBodyScrollbarWidth() + "px");
                this.addClass(document.body, className);
            }
        },
        {
            key: "unblockBodyScroll",
            value: function unblockBodyScroll() {
                var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "p-overflow-hidden";
                document.body.style.removeProperty("--scrollbar-width");
                this.removeClass(document.body, className);
            }
        },
        {
            key: "isVisible",
            value: function isVisible(element) {
                // https://stackoverflow.com/a/59096915/502366 (in future use IntersectionObserver)
                return element && (element.clientHeight !== 0 || element.getClientRects().length !== 0 || getComputedStyle(element).display !== "none");
            }
        },
        {
            key: "isExist",
            value: function isExist(element) {
                return !!(element !== null && typeof element !== "undefined" && element.nodeName && element.parentNode);
            }
        },
        {
            key: "getFocusableElements",
            value: function getFocusableElements(element) {
                var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var focusableElements = DomHandler.find(element, 'button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])'.concat(selector, ',\n                [href][clientHeight][clientWidth]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(selector, ',\n                input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(selector, ',\n                select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(selector, ',\n                textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(selector, ',\n                [tabIndex]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(selector, ',\n                [contenteditable]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])').concat(selector));
                var visibleFocusableElements = [];
                var _iterator3 = $8ea6edb353c20265$var$_createForOfIteratorHelper$1(focusableElements), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var focusableElement = _step3.value;
                        if (getComputedStyle(focusableElement).display !== "none" && getComputedStyle(focusableElement).visibility !== "hidden") visibleFocusableElements.push(focusableElement);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                return visibleFocusableElements;
            }
        },
        {
            key: "getFirstFocusableElement",
            value: function getFirstFocusableElement(element, selector) {
                var focusableElements = DomHandler.getFocusableElements(element, selector);
                return focusableElements.length > 0 ? focusableElements[0] : null;
            }
        },
        {
            key: "getLastFocusableElement",
            value: function getLastFocusableElement(element, selector) {
                var focusableElements = DomHandler.getFocusableElements(element, selector);
                return focusableElements.length > 0 ? focusableElements[focusableElements.length - 1] : null;
            }
        },
        {
            key: "focus",
            value: function focus(el, scrollTo) {
                var preventScroll = scrollTo === undefined ? true : !scrollTo;
                el && document.activeElement !== el && el.focus({
                    preventScroll: preventScroll
                });
            }
        },
        {
            key: "focusFirstElement",
            value: function focusFirstElement(el, scrollTo) {
                if (!el) return;
                var firstFocusableElement = DomHandler.getFirstFocusableElement(el);
                firstFocusableElement && DomHandler.focus(firstFocusableElement, scrollTo);
                return firstFocusableElement;
            }
        },
        {
            key: "getCursorOffset",
            value: function getCursorOffset(el, prevText, nextText, currentText) {
                if (el) {
                    var style = getComputedStyle(el);
                    var ghostDiv = document.createElement("div");
                    ghostDiv.style.position = "absolute";
                    ghostDiv.style.top = "0px";
                    ghostDiv.style.left = "0px";
                    ghostDiv.style.visibility = "hidden";
                    ghostDiv.style.pointerEvents = "none";
                    ghostDiv.style.overflow = style.overflow;
                    ghostDiv.style.width = style.width;
                    ghostDiv.style.height = style.height;
                    ghostDiv.style.padding = style.padding;
                    ghostDiv.style.border = style.border;
                    ghostDiv.style.overflowWrap = style.overflowWrap;
                    ghostDiv.style.whiteSpace = style.whiteSpace;
                    ghostDiv.style.lineHeight = style.lineHeight;
                    ghostDiv.innerHTML = prevText.replace(/\r\n|\r|\n/g, "<br />");
                    var ghostSpan = document.createElement("span");
                    ghostSpan.textContent = currentText;
                    ghostDiv.appendChild(ghostSpan);
                    var text = document.createTextNode(nextText);
                    ghostDiv.appendChild(text);
                    document.body.appendChild(ghostDiv);
                    var offsetLeft = ghostSpan.offsetLeft, offsetTop = ghostSpan.offsetTop, clientHeight = ghostSpan.clientHeight;
                    document.body.removeChild(ghostDiv);
                    return {
                        left: Math.abs(offsetLeft - el.scrollLeft),
                        top: Math.abs(offsetTop - el.scrollTop) + clientHeight
                    };
                }
                return {
                    top: "auto",
                    left: "auto"
                };
            }
        },
        {
            key: "invokeElementMethod",
            value: function invokeElementMethod(element, methodName, args) {
                element[methodName].apply(element, args);
            }
        },
        {
            key: "isClickable",
            value: function isClickable(element) {
                var targetNode = element.nodeName;
                var parentNode = element.parentElement && element.parentElement.nodeName;
                return targetNode === "INPUT" || targetNode === "TEXTAREA" || targetNode === "BUTTON" || targetNode === "A" || parentNode === "INPUT" || parentNode === "TEXTAREA" || parentNode === "BUTTON" || parentNode === "A" || this.hasClass(element, "p-button") || this.hasClass(element.parentElement, "p-button") || this.hasClass(element.parentElement, "p-checkbox") || this.hasClass(element.parentElement, "p-radiobutton");
            }
        },
        {
            key: "applyStyle",
            value: function applyStyle(element, style) {
                if (typeof style === "string") element.style.cssText = this.style;
                else for(var prop in this.style)element.style[prop] = style[prop];
            }
        },
        {
            key: "exportCSV",
            value: function exportCSV(csv, filename) {
                var blob = new Blob([
                    csv
                ], {
                    type: "application/csv;charset=utf-8;"
                });
                if (window.navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(blob, filename + ".csv");
                else {
                    var isDownloaded = DomHandler.saveAs({
                        name: filename + ".csv",
                        src: URL.createObjectURL(blob)
                    });
                    if (!isDownloaded) {
                        csv = "data:text/csv;charset=utf-8," + csv;
                        window.open(encodeURI(csv));
                    }
                }
            }
        },
        {
            key: "saveAs",
            value: function saveAs(file) {
                if (file) {
                    var link = document.createElement("a");
                    if (link.download !== undefined) {
                        var name = file.name, src = file.src;
                        link.setAttribute("href", src);
                        link.setAttribute("download", name);
                        link.style.display = "none";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "createInlineStyle",
            value: function createInlineStyle(nonce, styleContainer) {
                var styleElement = document.createElement("style");
                DomHandler.addNonce(styleElement, nonce);
                if (!styleContainer) styleContainer = document.head;
                styleContainer.appendChild(styleElement);
                return styleElement;
            }
        },
        {
            key: "removeInlineStyle",
            value: function removeInlineStyle(styleElement) {
                if (this.isExist(styleElement)) {
                    try {
                        styleElement.parentNode.removeChild(styleElement);
                    } catch (error) {
                    // style element may have already been removed in a fast refresh
                    }
                    styleElement = null;
                }
                return styleElement;
            }
        },
        {
            key: "addNonce",
            value: function addNonce(styleElement, nonce) {
                try {
                    if (!nonce) nonce = undefined;
                } catch (error) {
                // NOOP
                }
                nonce && styleElement.setAttribute("nonce", nonce);
            }
        },
        {
            key: "getTargetElement",
            value: function getTargetElement(target) {
                if (!target) return null;
                if (target === "document") return document;
                else if (target === "window") return window;
                else if ($8ea6edb353c20265$var$_typeof(target) === "object" && target.hasOwnProperty("current")) return this.isExist(target.current) ? target.current : null;
                var isFunction = function isFunction(obj) {
                    return !!(obj && obj.constructor && obj.call && obj.apply);
                };
                var element = isFunction(target) ? target() : target;
                return element && element.nodeType === 9 || this.isExist(element) ? element : null;
            }
        },
        {
            key: "getAttributeNames",
            value: function getAttributeNames(node) {
                var index;
                var rv;
                var attrs;
                rv = [];
                attrs = node.attributes;
                for(index = 0; index < attrs.length; ++index)rv.push(attrs[index].nodeName);
                rv.sort();
                return rv;
            }
        },
        {
            key: "isEqualElement",
            value: function isEqualElement(elm1, elm2) {
                var attrs1;
                var attrs2;
                var name;
                var node1;
                var node2;
                // Compare attributes without order sensitivity
                attrs1 = DomHandler.getAttributeNames(elm1);
                attrs2 = DomHandler.getAttributeNames(elm2);
                if (attrs1.join(",") !== attrs2.join(",")) // console.log("Found nodes with different sets of attributes; not equiv");
                return false;
                // ...and values
                // unless you want to compare DOM0 event handlers
                // (onclick="...")
                for(var index = 0; index < attrs1.length; ++index){
                    name = attrs1[index];
                    if (name === "style") {
                        var astyle = elm1.style;
                        var bstyle = elm2.style;
                        var rexDigitsOnly = /^\d+$/;
                        for(var _i3 = 0, _Object$keys = Object.keys(astyle); _i3 < _Object$keys.length; _i3++){
                            var key = _Object$keys[_i3];
                            if (!rexDigitsOnly.test(key) && astyle[key] !== bstyle[key]) // Not equivalent, stop
                            //console.log("Found nodes with mis-matched values for attribute '" + name + "'; not equiv");
                            return false;
                        }
                    } else if (elm1.getAttribute(name) !== elm2.getAttribute(name)) // console.log("Found nodes with mis-matched values for attribute '" + name + "'; not equiv");
                    return false;
                }
                // Walk the children
                for(node1 = elm1.firstChild, node2 = elm2.firstChild; node1 && node2; node1 = node1.nextSibling, node2 = node2.nextSibling){
                    if (node1.nodeType !== node2.nodeType) // display("Found nodes of different types; not equiv");
                    return false;
                    if (node1.nodeType === 1) {
                        // Element
                        if (!DomHandler.isEqualElement(node1, node2)) return false;
                    } else if (node1.nodeValue !== node2.nodeValue) // console.log("Found nodes with mis-matched nodeValues; not equiv");
                    return false;
                }
                if (node1 || node2) // One of the elements had more nodes than the other
                // console.log("Found more children of one element than the other; not equivalent");
                return false;
                // Seem the same
                return true;
            }
        },
        {
            key: "hasCSSAnimation",
            value: function hasCSSAnimation(element) {
                if (element) {
                    var style = getComputedStyle(element);
                    var animationDuration = parseFloat(style.getPropertyValue("animation-duration") || "0");
                    return animationDuration > 0;
                }
                return false;
            }
        },
        {
            key: "hasCSSTransition",
            value: function hasCSSTransition(element) {
                if (element) {
                    var style = getComputedStyle(element);
                    var transitionDuration = parseFloat(style.getPropertyValue("transition-duration") || "0");
                    return transitionDuration > 0;
                }
                return false;
            }
        }
    ]);
}();
/**
 * All data- properties like data-test-id
 */ $8ea6edb353c20265$var$_defineProperty($8ea6edb353c20265$export$ff8ccbac9225de62, "DATA_PROPS", [
    "data-"
]);
/**
 * All ARIA properties like aria-label and focus-target for https://www.npmjs.com/package/@q42/floating-focus-a11y
 */ $8ea6edb353c20265$var$_defineProperty($8ea6edb353c20265$export$ff8ccbac9225de62, "ARIA_PROPS", [
    "aria",
    "focus-target"
]);
function $8ea6edb353c20265$export$5087227eb54526() {
    var allHandlers = new Map();
    return {
        on: function on(type, handler) {
            var handlers = allHandlers.get(type);
            if (!handlers) handlers = [
                handler
            ];
            else handlers.push(handler);
            allHandlers.set(type, handlers);
        },
        off: function off(type, handler) {
            var handlers = allHandlers.get(type);
            handlers && handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        },
        emit: function emit(type, evt) {
            var handlers = allHandlers.get(type);
            handlers && handlers.slice().forEach(function(handler) {
                return handler(evt);
            });
        }
    };
}
function $8ea6edb353c20265$var$_extends() {
    $8ea6edb353c20265$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8ea6edb353c20265$var$_extends.apply(this, arguments);
}
function $8ea6edb353c20265$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $8ea6edb353c20265$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $8ea6edb353c20265$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8ea6edb353c20265$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8ea6edb353c20265$var$_arrayLikeToArray(o, minLen);
}
function $8ea6edb353c20265$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $8ea6edb353c20265$export$4855211e6b8ad895 = /*#__PURE__*/ function() {
    function ObjectUtils() {
        $8ea6edb353c20265$var$_classCallCheck(this, ObjectUtils);
    }
    return $8ea6edb353c20265$var$_createClass(ObjectUtils, null, [
        {
            key: "equals",
            value: function equals(obj1, obj2, field) {
                if (field && obj1 && $8ea6edb353c20265$var$_typeof(obj1) === "object" && obj2 && $8ea6edb353c20265$var$_typeof(obj2) === "object") return this.deepEquals(this.resolveFieldData(obj1, field), this.resolveFieldData(obj2, field));
                return this.deepEquals(obj1, obj2);
            }
        },
        {
            key: "deepEquals",
            value: function deepEquals(a, b) {
                if (a === b) return true;
                if (a && b && $8ea6edb353c20265$var$_typeof(a) === "object" && $8ea6edb353c20265$var$_typeof(b) === "object") {
                    var arrA = Array.isArray(a);
                    var arrB = Array.isArray(b);
                    var i;
                    var length;
                    var key;
                    if (arrA && arrB) {
                        length = a.length;
                        if (length !== b.length) return false;
                        for(i = length; i-- !== 0;){
                            if (!this.deepEquals(a[i], b[i])) return false;
                        }
                        return true;
                    }
                    if (arrA !== arrB) return false;
                    var dateA = a instanceof Date;
                    var dateB = b instanceof Date;
                    if (dateA !== dateB) return false;
                    if (dateA && dateB) return a.getTime() === b.getTime();
                    var regexpA = a instanceof RegExp;
                    var regexpB = b instanceof RegExp;
                    if (regexpA !== regexpB) return false;
                    if (regexpA && regexpB) return a.toString() === b.toString();
                    var keys = Object.keys(a);
                    length = keys.length;
                    if (length !== Object.keys(b).length) return false;
                    for(i = length; i-- !== 0;){
                        if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
                    }
                    for(i = length; i-- !== 0;){
                        key = keys[i];
                        if (!this.deepEquals(a[key], b[key])) return false;
                    }
                    return true;
                }
                /*eslint no-self-compare: "off"*/ return a !== a && b !== b;
            }
        },
        {
            key: "resolveFieldData",
            value: function resolveFieldData(data, field) {
                if (!data || !field) // short circuit if there is nothing to resolve
                return null;
                try {
                    var value = data[field];
                    if (this.isNotEmpty(value)) return value;
                } catch (_unused) {
                // Performance optimization: https://github.com/primefaces/primereact/issues/4797
                // do nothing and continue to other methods to resolve field data
                }
                if (Object.keys(data).length) {
                    if (this.isFunction(field)) return field(data);
                    else if (this.isNotEmpty(data[field])) return data[field];
                    else if (field.indexOf(".") === -1) return data[field];
                    var fields = field.split(".");
                    var _value = data;
                    for(var i = 0, len = fields.length; i < len; ++i){
                        if (_value == null) return null;
                        _value = _value[fields[i]];
                    }
                    return _value;
                }
                return null;
            }
        },
        {
            key: "findDiffKeys",
            value: function findDiffKeys(obj1, obj2) {
                if (!obj1 || !obj2) return {};
                return Object.keys(obj1).filter(function(key) {
                    return !obj2.hasOwnProperty(key);
                }).reduce(function(result, current) {
                    result[current] = obj1[current];
                    return result;
                }, {});
            }
        },
        {
            key: "reduceKeys",
            value: function reduceKeys(obj, startsWiths) {
                var result = {};
                if (!obj || !startsWiths || startsWiths.length === 0) return result;
                Object.keys(obj).filter(function(key) {
                    return startsWiths.some(function(value) {
                        return key.startsWith(value);
                    });
                }).forEach(function(key) {
                    result[key] = obj[key];
                    delete obj[key];
                });
                return result;
            }
        },
        {
            key: "reorderArray",
            value: function reorderArray(value, from, to) {
                if (value && from !== to) {
                    if (to >= value.length) {
                        to = to % value.length;
                        from = from % value.length;
                    }
                    value.splice(to, 0, value.splice(from, 1)[0]);
                }
            }
        },
        {
            key: "findIndexInList",
            value: function findIndexInList(value, list, dataKey) {
                var _this = this;
                if (list) return dataKey ? list.findIndex(function(item) {
                    return _this.equals(item, value, dataKey);
                }) : list.findIndex(function(item) {
                    return item === value;
                });
                return -1;
            }
        },
        {
            key: "getJSXElement",
            value: function getJSXElement(obj) {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
                return this.isFunction(obj) ? obj.apply(void 0, params) : obj;
            }
        },
        {
            key: "getItemValue",
            value: function getItemValue(obj) {
                for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
                return this.isFunction(obj) ? obj.apply(void 0, params) : obj;
            }
        },
        {
            key: "getProp",
            value: function getProp(props) {
                var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var value = props ? props[prop] : undefined;
                return value === undefined ? defaultProps[prop] : value;
            }
        },
        {
            key: "getPropCaseInsensitive",
            value: function getPropCaseInsensitive(props, prop) {
                var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var fkey = this.toFlatCase(prop);
                for(var key in props){
                    if (props.hasOwnProperty(key) && this.toFlatCase(key) === fkey) return props[key];
                }
                for(var _key3 in defaultProps){
                    if (defaultProps.hasOwnProperty(_key3) && this.toFlatCase(_key3) === fkey) return defaultProps[_key3];
                }
                return undefined; // Property not found
            }
        },
        {
            key: "getMergedProps",
            value: function getMergedProps(props, defaultProps) {
                return Object.assign({}, defaultProps, props);
            }
        },
        {
            key: "getDiffProps",
            value: function getDiffProps(props, defaultProps) {
                return this.findDiffKeys(props, defaultProps);
            }
        },
        {
            key: "getPropValue",
            value: function getPropValue(obj) {
                for(var _len3 = arguments.length, params = new Array(_len3 > 1 ? _len3 - 1 : 0), _key4 = 1; _key4 < _len3; _key4++)params[_key4 - 1] = arguments[_key4];
                return this.isFunction(obj) ? obj.apply(void 0, params) : obj;
            }
        },
        {
            key: "getComponentProp",
            value: function getComponentProp(component) {
                var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.isNotEmpty(component) ? this.getProp(component.props, prop, defaultProps) : undefined;
            }
        },
        {
            key: "getComponentProps",
            value: function getComponentProps(component, defaultProps) {
                return this.isNotEmpty(component) ? this.getMergedProps(component.props, defaultProps) : undefined;
            }
        },
        {
            key: "getComponentDiffProps",
            value: function getComponentDiffProps(component, defaultProps) {
                return this.isNotEmpty(component) ? this.getDiffProps(component.props, defaultProps) : undefined;
            }
        },
        {
            key: "isValidChild",
            value: function isValidChild(child, type, validTypes) {
                /* eslint-disable */ if (child) {
                    var _child$type;
                    var childType = this.getComponentProp(child, "__TYPE") || (child.type ? child.type.displayName : undefined);
                    // for App Router in Next.js ^14,
                    if (!childType && child !== null && child !== void 0 && (_child$type = child.type) !== null && _child$type !== void 0 && (_child$type = _child$type._payload) !== null && _child$type !== void 0 && _child$type.value) childType = child.type._payload.value.find(function(v) {
                        return v === type;
                    });
                    var isValid = childType === type;
                    try {
                        var messageTypes;
                    } catch (error) {
                    // NOOP
                    }
                    return isValid;
                }
                return false;
            /* eslint-enable */ }
        },
        {
            key: "getRefElement",
            value: function getRefElement(ref) {
                if (ref) return $8ea6edb353c20265$var$_typeof(ref) === "object" && ref.hasOwnProperty("current") ? ref.current : ref;
                return null;
            }
        },
        {
            key: "combinedRefs",
            value: function combinedRefs(innerRef, forwardRef) {
                if (innerRef && forwardRef) {
                    if (typeof forwardRef === "function") forwardRef(innerRef.current);
                    else forwardRef.current = innerRef.current;
                }
            }
        },
        {
            key: "removeAccents",
            value: function removeAccents(str) {
                if (str && str.search(/[\xC0-\xFF]/g) > -1) str = str.replace(/[\xC0-\xC5]/g, "A").replace(/[\xC6]/g, "AE").replace(/[\xC7]/g, "C").replace(/[\xC8-\xCB]/g, "E").replace(/[\xCC-\xCF]/g, "I").replace(/[\xD0]/g, "D").replace(/[\xD1]/g, "N").replace(/[\xD2-\xD6\xD8]/g, "O").replace(/[\xD9-\xDC]/g, "U").replace(/[\xDD]/g, "Y").replace(/[\xDE]/g, "P").replace(/[\xE0-\xE5]/g, "a").replace(/[\xE6]/g, "ae").replace(/[\xE7]/g, "c").replace(/[\xE8-\xEB]/g, "e").replace(/[\xEC-\xEF]/g, "i").replace(/[\xF1]/g, "n").replace(/[\xF2-\xF6\xF8]/g, "o").replace(/[\xF9-\xFC]/g, "u").replace(/[\xFE]/g, "p").replace(/[\xFD\xFF]/g, "y");
                return str;
            }
        },
        {
            key: "toFlatCase",
            value: function toFlatCase(str) {
                // convert snake, kebab, camel and pascal cases to flat case
                return this.isNotEmpty(str) && this.isString(str) ? str.replace(/(-|_)/g, "").toLowerCase() : str;
            }
        },
        {
            key: "toCapitalCase",
            value: function toCapitalCase(str) {
                return this.isNotEmpty(str) && this.isString(str) ? str[0].toUpperCase() + str.slice(1) : str;
            }
        },
        {
            key: "trim",
            value: function trim(value) {
                // trim only if the value is actually a string
                return this.isNotEmpty(value) && this.isString(value) ? value.trim() : value;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty(value) {
                return value === null || value === undefined || value === "" || Array.isArray(value) && value.length === 0 || !(value instanceof Date) && $8ea6edb353c20265$var$_typeof(value) === "object" && Object.keys(value).length === 0;
            }
        },
        {
            key: "isNotEmpty",
            value: function isNotEmpty(value) {
                return !this.isEmpty(value);
            }
        },
        {
            key: "isFunction",
            value: function isFunction(value) {
                return !!(value && value.constructor && value.call && value.apply);
            }
        },
        {
            key: "isObject",
            value: function isObject(value) {
                return value !== null && value instanceof Object && value.constructor === Object;
            }
        },
        {
            key: "isDate",
            value: function isDate(value) {
                return value !== null && value instanceof Date && value.constructor === Date;
            }
        },
        {
            key: "isArray",
            value: function isArray(value) {
                return value !== null && Array.isArray(value);
            }
        },
        {
            key: "isString",
            value: function isString(value) {
                return value !== null && typeof value === "string";
            }
        },
        {
            key: "isPrintableCharacter",
            value: function isPrintableCharacter() {
                var _char = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                return this.isNotEmpty(_char) && _char.length === 1 && _char.match(/\S| /);
            }
        },
        {
            key: "isLetter",
            value: function isLetter(_char2) {
                return /^[a-zA-Z\u00C0-\u017F]$/.test(_char2);
            }
        },
        {
            key: "findLast",
            value: function findLast(arr, callback) {
                var item;
                if (this.isNotEmpty(arr)) try {
                    item = arr.findLast(callback);
                } catch (_unused2) {
                    item = $8ea6edb353c20265$var$_toConsumableArray(arr).reverse().find(callback);
                }
                return item;
            }
        },
        {
            key: "findLastIndex",
            value: function findLastIndex(arr, callback) {
                var index = -1;
                if (this.isNotEmpty(arr)) try {
                    index = arr.findLastIndex(callback);
                } catch (_unused3) {
                    index = arr.lastIndexOf($8ea6edb353c20265$var$_toConsumableArray(arr).reverse().find(callback));
                }
                return index;
            }
        },
        {
            key: "sort",
            value: function sort(value1, value2) {
                var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                var comparator = arguments.length > 3 ? arguments[3] : undefined;
                var nullSortOrder = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
                var result = this.compare(value1, value2, comparator, order);
                var finalSortOrder = order;
                // nullSortOrder == 1 means Excel like sort nulls at bottom
                if (this.isEmpty(value1) || this.isEmpty(value2)) finalSortOrder = nullSortOrder === 1 ? order : nullSortOrder;
                return finalSortOrder * result;
            }
        },
        {
            key: "compare",
            value: function compare(value1, value2, comparator) {
                var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
                var result = -1;
                var emptyValue1 = this.isEmpty(value1);
                var emptyValue2 = this.isEmpty(value2);
                if (emptyValue1 && emptyValue2) result = 0;
                else if (emptyValue1) result = order;
                else if (emptyValue2) result = -order;
                else if (typeof value1 === "string" && typeof value2 === "string") result = comparator(value1, value2);
                else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
                return result;
            }
        },
        {
            key: "localeComparator",
            value: function localeComparator(locale) {
                //performance gain using Int.Collator. It is not recommended to use localeCompare against large arrays.
                return new Intl.Collator(locale, {
                    numeric: true
                }).compare;
            }
        },
        {
            key: "findChildrenByKey",
            value: function findChildrenByKey(data, key) {
                var _iterator = $8ea6edb353c20265$var$_createForOfIteratorHelper(data), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var item = _step.value;
                        if (item.key === key) return item.children || [];
                        else if (item.children) {
                            var result = this.findChildrenByKey(item.children, key);
                            if (result.length > 0) return result;
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return [];
            }
        },
        {
            key: "mutateFieldData",
            value: function mutateFieldData(data, field, value) {
                if ($8ea6edb353c20265$var$_typeof(data) !== "object" || typeof field !== "string") // short circuit if there is nothing to resolve
                return;
                var fields = field.split(".");
                var obj = data;
                for(var i = 0, len = fields.length; i < len; ++i){
                    // Check if we are on the last field
                    if (i + 1 - len === 0) {
                        obj[fields[i]] = value;
                        break;
                    }
                    if (!obj[fields[i]]) obj[fields[i]] = {};
                    obj = obj[fields[i]];
                }
            }
        }
    ]);
}();
function $8ea6edb353c20265$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8ea6edb353c20265$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8ea6edb353c20265$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $8ea6edb353c20265$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8ea6edb353c20265$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8ea6edb353c20265$export$7114f767f3d3c711 = /*#__PURE__*/ function() {
    function IconUtils() {
        $8ea6edb353c20265$var$_classCallCheck(this, IconUtils);
    }
    return $8ea6edb353c20265$var$_createClass(IconUtils, null, [
        {
            key: "getJSXIcon",
            value: function getJSXIcon(icon) {
                var iconProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var content = null;
                if (icon !== null) {
                    var iconType = $8ea6edb353c20265$var$_typeof(icon);
                    var className = $8ea6edb353c20265$export$ce4ab0c55987d1ff(iconProps.className, iconType === "string" && icon);
                    content = /*#__PURE__*/ $81g6h.createElement("span", $8ea6edb353c20265$var$_extends({}, iconProps, {
                        className: className
                    }));
                    if (iconType !== "string") {
                        var defaultContentOptions = $8ea6edb353c20265$var$_objectSpread$2({
                            iconProps: iconProps,
                            element: content
                        }, options);
                        return $8ea6edb353c20265$export$4855211e6b8ad895.getJSXElement(icon, defaultContentOptions);
                    }
                }
                return content;
            }
        }
    ]);
}();
function $8ea6edb353c20265$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8ea6edb353c20265$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8ea6edb353c20265$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $8ea6edb353c20265$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8ea6edb353c20265$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8ea6edb353c20265$export$d99f0801a68bbcf1(el, options) {
    var defaultOptions = {
        mask: null,
        slotChar: "_",
        autoClear: true,
        unmask: false,
        readOnly: false,
        onComplete: null,
        onChange: null,
        onFocus: null,
        onBlur: null
    };
    options = $8ea6edb353c20265$var$_objectSpread$1($8ea6edb353c20265$var$_objectSpread$1({}, defaultOptions), options);
    var tests;
    var partialPosition;
    var len;
    var firstNonMaskPos;
    var defs;
    var androidChrome;
    var lastRequiredNonMaskPos;
    var oldVal;
    var focusText;
    var caretTimeoutId;
    var buffer;
    var defaultBuffer;
    var caret = function caret(first, last) {
        var range;
        var begin;
        var end;
        if (!el.offsetParent || el !== document.activeElement) return;
        if (typeof first === "number") {
            begin = first;
            end = typeof last === "number" ? last : begin;
            if (el.setSelectionRange) el.setSelectionRange(begin, end);
            else if (el.createTextRange) {
                range = el.createTextRange();
                range.collapse(true);
                range.moveEnd("character", end);
                range.moveStart("character", begin);
                range.select();
            }
        } else {
            if (el.setSelectionRange) {
                begin = el.selectionStart;
                end = el.selectionEnd;
            } else if (document.selection && document.selection.createRange) {
                range = document.selection.createRange();
                begin = 0 - range.duplicate().moveStart("character", -100000);
                end = begin + range.text.length;
            }
            return {
                begin: begin,
                end: end
            };
        }
    };
    var isCompleted = function isCompleted() {
        for(var i = firstNonMaskPos; i <= lastRequiredNonMaskPos; i++){
            if (tests[i] && buffer[i] === getPlaceholder(i)) return false;
        }
        return true;
    };
    var getPlaceholder = function getPlaceholder(i) {
        if (i < options.slotChar.length) return options.slotChar.charAt(i);
        return options.slotChar.charAt(0);
    };
    var getValue = function getValue() {
        return options.unmask ? getUnmaskedValue() : el && el.value;
    };
    var seekNext = function seekNext(pos) {
        while(++pos < len && !tests[pos]);
        return pos;
    };
    var seekPrev = function seekPrev(pos) {
        while(--pos >= 0 && !tests[pos]);
        return pos;
    };
    var shiftL = function shiftL(begin, end) {
        var i;
        var j;
        if (begin < 0) return;
        for(i = begin, j = seekNext(end); i < len; i++)if (tests[i]) {
            if (j < len && tests[i].test(buffer[j])) {
                buffer[i] = buffer[j];
                buffer[j] = getPlaceholder(j);
            } else break;
            j = seekNext(j);
        }
        writeBuffer();
        caret(Math.max(firstNonMaskPos, begin));
    };
    var shiftR = function shiftR(pos) {
        var i;
        var c;
        var j;
        var t;
        for(i = pos, c = getPlaceholder(pos); i < len; i++)if (tests[i]) {
            j = seekNext(i);
            t = buffer[i];
            buffer[i] = c;
            if (j < len && tests[j].test(t)) c = t;
            else break;
        }
    };
    var handleAndroidInput = function handleAndroidInput(e) {
        var curVal = el.value;
        var pos = caret();
        if (oldVal && oldVal.length && oldVal.length > curVal.length) {
            // a deletion or backspace happened
            checkVal(true);
            while(pos.begin > 0 && !tests[pos.begin - 1])pos.begin--;
            if (pos.begin === 0) while(pos.begin < firstNonMaskPos && !tests[pos.begin])pos.begin++;
            caret(pos.begin, pos.begin);
        } else {
            checkVal(true);
            while(pos.begin < len && !tests[pos.begin])pos.begin++;
            caret(pos.begin, pos.begin);
        }
        if (options.onComplete && isCompleted()) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var onBlur = function onBlur(e) {
        checkVal();
        options.onBlur && options.onBlur(e);
        updateModel(e);
        if (el.value !== focusText) {
            var event = document.createEvent("HTMLEvents");
            event.initEvent("change", true, false);
            el.dispatchEvent(event);
        }
    };
    var onKeyDown = function onKeyDown(e) {
        if (options.readOnly) return;
        var k = e.which || e.keyCode;
        var pos;
        var begin;
        var end;
        oldVal = el.value;
        //backspace, delete, and escape get special treatment
        if (k === 8 || k === 46 || $8ea6edb353c20265$export$ff8ccbac9225de62.isIOS() && k === 127) {
            pos = caret();
            begin = pos.begin;
            end = pos.end;
            if (end - begin === 0) {
                begin = k !== 46 ? seekPrev(begin) : end = seekNext(begin - 1);
                end = k === 46 ? seekNext(end) : end;
            }
            clearBuffer(begin, end);
            shiftL(begin, end - 1);
            updateModel(e);
            e.preventDefault();
        } else if (k === 13) {
            // enter
            onBlur(e);
            updateModel(e);
        } else if (k === 27) {
            // escape
            el.value = focusText;
            caret(0, checkVal());
            updateModel(e);
            e.preventDefault();
        }
    };
    var onKeyPress = function onKeyPress(e) {
        if (options.readOnly) return;
        var k = e.which || e.keyCode;
        var pos = caret();
        var p;
        var c;
        var next;
        var completed;
        if (e.ctrlKey || e.altKey || e.metaKey || k < 32) //Ignore
        return;
        else if (k && k !== 13) {
            if (pos.end - pos.begin !== 0) {
                clearBuffer(pos.begin, pos.end);
                shiftL(pos.begin, pos.end - 1);
            }
            p = seekNext(pos.begin - 1);
            if (p < len) {
                c = String.fromCharCode(k);
                if (tests[p].test(c)) {
                    shiftR(p);
                    buffer[p] = c;
                    writeBuffer();
                    next = seekNext(p);
                    if ($8ea6edb353c20265$export$ff8ccbac9225de62.isAndroid()) {
                        //Path for CSP Violation on FireFox OS 1.1
                        var proxy = function proxy() {
                            caret(next);
                        };
                        setTimeout(proxy, 0);
                    } else caret(next);
                    if (pos.begin <= lastRequiredNonMaskPos) completed = isCompleted();
                }
            }
            e.preventDefault();
        }
        updateModel(e);
        if (options.onComplete && completed) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var clearBuffer = function clearBuffer(start, end) {
        var i;
        for(i = start; i < end && i < len; i++)if (tests[i]) buffer[i] = getPlaceholder(i);
    };
    var writeBuffer = function writeBuffer() {
        el.value = buffer.join("");
    };
    var checkVal = function checkVal(allow) {
        //try to place characters where they belong
        var test = el.value;
        var lastMatch = -1;
        var i;
        var c;
        var pos;
        for(i = 0, pos = 0; i < len; i++)if (tests[i]) {
            buffer[i] = getPlaceholder(i);
            while(pos++ < test.length){
                c = test.charAt(pos - 1);
                if (tests[i].test(c)) {
                    buffer[i] = c;
                    lastMatch = i;
                    break;
                }
            }
            if (pos > test.length) {
                clearBuffer(i + 1, len);
                break;
            }
        } else {
            if (buffer[i] === test.charAt(pos)) pos++;
            if (i < partialPosition) lastMatch = i;
        }
        if (allow) writeBuffer();
        else if (lastMatch + 1 < partialPosition) {
            if (options.autoClear || buffer.join("") === defaultBuffer) {
                // Invalid value. Remove it and replace it with the
                // mask, which is the default behavior.
                if (el.value) el.value = "";
                clearBuffer(0, len);
            } else // Invalid value, but we opt to show the value to the
            // user and allow them to correct their mistake.
            writeBuffer();
        } else {
            writeBuffer();
            el.value = el.value.substring(0, lastMatch + 1);
        }
        return partialPosition ? i : firstNonMaskPos;
    };
    var onFocus = function onFocus(e) {
        if (options.readOnly) return;
        clearTimeout(caretTimeoutId);
        var pos;
        focusText = el.value;
        pos = checkVal();
        caretTimeoutId = setTimeout(function() {
            if (el !== document.activeElement) return;
            writeBuffer();
            if (pos === options.mask.replace("?", "").length) caret(0, pos);
            else caret(pos);
        }, 100);
        if (options.onFocus) options.onFocus(e);
    };
    var onInput = function onInput(event) {
        if (androidChrome) handleAndroidInput(event);
        else handleInputChange(event);
    };
    var handleInputChange = function handleInputChange(e) {
        if (options.readOnly) return;
        var pos = checkVal(true);
        caret(pos);
        updateModel(e);
        if (options.onComplete && isCompleted()) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var getUnmaskedValue = function getUnmaskedValue() {
        var unmaskedBuffer = [];
        for(var i = 0; i < buffer.length; i++){
            var c = buffer[i];
            if (tests[i] && c !== getPlaceholder(i)) unmaskedBuffer.push(c);
        }
        return unmaskedBuffer.join("");
    };
    var updateModel = function updateModel(e) {
        if (options.onChange) {
            var val = getValue();
            options.onChange({
                originalEvent: e,
                value: defaultBuffer !== val ? val : "",
                stopPropagation: function stopPropagation() {
                    e.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    e.preventDefault();
                },
                target: {
                    value: defaultBuffer !== val ? val : ""
                }
            });
        }
    };
    var bindEvents = function bindEvents() {
        el.addEventListener("focus", onFocus);
        el.addEventListener("blur", onBlur);
        el.addEventListener("keydown", onKeyDown);
        el.addEventListener("keypress", onKeyPress);
        el.addEventListener("input", onInput);
        el.addEventListener("paste", handleInputChange);
    };
    var unbindEvents = function unbindEvents() {
        el.removeEventListener("focus", onFocus);
        el.removeEventListener("blur", onBlur);
        el.removeEventListener("keydown", onKeyDown);
        el.removeEventListener("keypress", onKeyPress);
        el.removeEventListener("input", onInput);
        el.removeEventListener("paste", handleInputChange);
    };
    var init = function init() {
        tests = [];
        partialPosition = options.mask.length;
        len = options.mask.length;
        firstNonMaskPos = null;
        defs = {
            9: "[0-9]",
            a: "[A-Za-z]",
            "*": "[A-Za-z0-9]"
        };
        androidChrome = $8ea6edb353c20265$export$ff8ccbac9225de62.isChrome() && $8ea6edb353c20265$export$ff8ccbac9225de62.isAndroid();
        var maskTokens = options.mask.split("");
        for(var i = 0; i < maskTokens.length; i++){
            var c = maskTokens[i];
            if (c === "?") {
                len--;
                partialPosition = i;
            } else if (defs[c]) {
                tests.push(new RegExp(defs[c]));
                if (firstNonMaskPos === null) firstNonMaskPos = tests.length - 1;
                if (i < partialPosition) lastRequiredNonMaskPos = tests.length - 1;
            } else tests.push(null);
        }
        buffer = [];
        for(var _i = 0; _i < maskTokens.length; _i++){
            var _c = maskTokens[_i];
            if (_c !== "?") {
                if (defs[_c]) buffer.push(getPlaceholder(_i));
                else buffer.push(_c);
            }
        }
        defaultBuffer = buffer.join("");
    };
    if (el && options.mask) {
        init();
        bindEvents();
    }
    return {
        init: init,
        bindEvents: bindEvents,
        unbindEvents: unbindEvents,
        updateModel: updateModel,
        getValue: getValue
    };
}
function $8ea6edb353c20265$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8ea6edb353c20265$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8ea6edb353c20265$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8ea6edb353c20265$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8ea6edb353c20265$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Merges properties together taking an Array of props and merging into one single set of
 * properties. The options can contain a "classNameMergeFunction" which can be something
 * like Tailwind Merge for properly merging Tailwind classes.
 *
 * @param {object[]} props the array of object properties to merge
 * @param {*} options either empty or could contain a custom merge function like TailwindMerge
 * @returns the single properties value after merging
 */ function $8ea6edb353c20265$export$9d1611c77c2fe928(props) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!props) return undefined;
    var isFunction = function isFunction(obj) {
        return typeof obj === "function";
    };
    var classNameMergeFunction = options.classNameMergeFunction;
    var hasMergeFunction = isFunction(classNameMergeFunction);
    return props.reduce(function(merged, ps) {
        if (!ps) return merged;
        var _loop = function _loop() {
            var value = ps[key];
            if (key === "style") merged.style = $8ea6edb353c20265$var$_objectSpread($8ea6edb353c20265$var$_objectSpread({}, merged.style), ps.style);
            else if (key === "className") {
                var newClassName = "";
                if (hasMergeFunction) newClassName = classNameMergeFunction(merged.className, ps.className);
                else newClassName = [
                    merged.className,
                    ps.className
                ].join(" ").trim();
                merged.className = newClassName || undefined;
            } else if (isFunction(value)) {
                var existingFn = merged[key];
                merged[key] = existingFn ? function() {
                    existingFn.apply(void 0, arguments);
                    value.apply(void 0, arguments);
                } : value;
            } else merged[key] = value;
        };
        for(var key in ps)_loop();
        return merged;
    }, {});
}
var $8ea6edb353c20265$var$lastId = 0;
function $8ea6edb353c20265$export$d5d9b89141473caf() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "pr_id_";
    $8ea6edb353c20265$var$lastId++;
    return "".concat(prefix).concat($8ea6edb353c20265$var$lastId);
}
function $8ea6edb353c20265$var$handler() {
    var zIndexes = [];
    var generateZIndex = function generateZIndex(key, autoZIndex) {
        var baseZIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 999;
        var lastZIndex = getLastZIndex(key, autoZIndex, baseZIndex);
        var newZIndex = lastZIndex.value + (lastZIndex.key === key ? 0 : baseZIndex) + 1;
        zIndexes.push({
            key: key,
            value: newZIndex
        });
        return newZIndex;
    };
    var revertZIndex = function revertZIndex(zIndex) {
        zIndexes = zIndexes.filter(function(obj) {
            return obj.value !== zIndex;
        });
    };
    var getCurrentZIndex = function getCurrentZIndex(key, autoZIndex) {
        return getLastZIndex(key, autoZIndex).value;
    };
    var getLastZIndex = function getLastZIndex(key, autoZIndex) {
        var baseZIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        return $8ea6edb353c20265$var$_toConsumableArray(zIndexes).reverse().find(function(obj) {
            return autoZIndex ? true : obj.key === key;
        }) || {
            key: key,
            value: baseZIndex
        };
    };
    var getZIndex = function getZIndex(el) {
        return el ? parseInt(el.style.zIndex, 10) || 0 : 0;
    };
    return {
        get: getZIndex,
        set: function set(key, el, autoZIndex, baseZIndex) {
            if (el) el.style.zIndex = String(generateZIndex(key, autoZIndex, baseZIndex));
        },
        clear: function clear(el) {
            if (el) {
                revertZIndex($8ea6edb353c20265$export$832931caede8e4b9.get(el));
                el.style.zIndex = "";
            }
        },
        getCurrent: function getCurrent(key, autoZIndex) {
            return getCurrentZIndex(key, autoZIndex);
        }
    };
}
var $8ea6edb353c20265$export$832931caede8e4b9 = $8ea6edb353c20265$var$handler();

});





parcelRegister("bQxqW", function(module, exports) {

$parcel$export(module.exports, "TranslationsManager", () => $f2596f8b5eb24982$export$b409a7d64280348b);

var $cHzXx = parcelRequire("cHzXx");

var $eOSo1 = parcelRequire("eOSo1");

var $4Wcs0 = parcelRequire("4Wcs0");

var $hO7pz = parcelRequire("hO7pz");

var $jTpg0 = parcelRequire("jTpg0");

var $1IWnK = parcelRequire("1IWnK");
class $f2596f8b5eb24982$export$b409a7d64280348b {
    constructor(translationService, store){
        this.translationService = translationService;
        this.store = store;
        this.logger = (0, $eOSo1.getLogger)("\u270D\uFE0F [TranslationManager]");
        this._initialState = {
            translations: this.getBuiltInTranslations(),
            versionDate: ""
        };
        this._translations = (0, $1IWnK.observable)(this._initialState);
        this._translationsStatus = (0, $1IWnK.observable)({
            available: false,
            error: null
        });
        this.translationsStatus = this._translationsStatus.readOnly();
        this._weekdaysConfig = (0, $1IWnK.observable)({
            initials: {},
            firstDayOfWeek: {}
        });
        this.weekdaysConfig = this._weekdaysConfig.readOnly();
        this.availableLocales = this._translations.select((t)=>Object.keys(t.translations));
    }
    async init() {
        this._translations.set(this.store.getItem(this._initialState));
        await this.updateWordingsOnVersion();
        await this.fetchWeekdaysConfig();
    }
    getLocaleWordings(locale) {
        const { translations: translations } = this._translations.get();
        return locale in translations ? translations[locale] : translations.en;
    }
    resetWordingsVersionDate() {
        const newTranslations = {
            ...this._translations.get(),
            versionDate: ""
        };
        this._translations.set(newTranslations);
        this.store.setItem(newTranslations);
    }
    async updateWordingsOnVersion(forceUpdate) {
        let error;
        let newVersion = "";
        const currentLocaleWordingsVersion = this._translations.get().versionDate;
        try {
            const { translations: translations, versionDate: versionDate } = await this.translationService.fetchWordings(forceUpdate ? "" : currentLocaleWordingsVersion);
            this.logger.info("Fetching new wordings from date:", versionDate);
            newVersion = versionDate;
            this._translations.set({
                versionDate: versionDate,
                translations: translations
            });
            this.store.setItem({
                versionDate: versionDate,
                translations: translations
            });
        } catch (e) {
            if (e instanceof (0, $cHzXx.TranslationsAlreadyUpToDateError)) this.logger.info("Wordings up to date ! Last update date", currentLocaleWordingsVersion);
            else {
                this.logger.error("Getting translations error:", e);
                error = e;
            }
            // backup startup: enable translations if an old version is stored locally
            newVersion = currentLocaleWordingsVersion;
        }
        this._translationsStatus.set({
            available: !(0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).isEmpty(newVersion),
            error: error
        });
    }
    async fetchWeekdaysConfig() {
        const weekdaysConfig = await this.translationService.fetchWeekdaysConfig();
        this._weekdaysConfig.set(weekdaysConfig);
    }
    debugGetTranslationsVersionDate() {
        return this._translations.select((t)=>t.versionDate);
    }
    getBuiltInTranslations() {
        const base = (0, $hO7pz.wording).en;
        return Object.fromEntries(Object.entries((0, $4Wcs0.builtInWording)).map(([key, value])=>{
            const override = value;
            return [
                key,
                {
                    ...base,
                    ...override
                }
            ];
        }));
    }
}

});
parcelRegister("cHzXx", function(module, exports) {

$parcel$export(module.exports, "TranslationsAlreadyUpToDateError", () => $100c1bda8105e6be$export$60322c97a6b88b5f);
class $100c1bda8105e6be$export$60322c97a6b88b5f extends Error {
    constructor(message){
        super(message);
    }
}

});

parcelRegister("4Wcs0", function(module, exports) {

$parcel$export(module.exports, "builtInWording", () => $e1be045e041add60$export$43ec6963e38d8e71);

var $iYRwE = parcelRequire("iYRwE");

var $9vkpn = parcelRequire("9vkpn");

var $csAUC = parcelRequire("csAUC");

var $g3eHy = parcelRequire("g3eHy");

var $4BZEV = parcelRequire("4BZEV");

var $1umwG = parcelRequire("1umwG");

var $7fVMx = parcelRequire("7fVMx");

var $21PHS = parcelRequire("21PHS");

var $dcH32 = parcelRequire("dcH32");

var $fqdCa = parcelRequire("fqdCa");

var $ksUdp = parcelRequire("ksUdp");

var $kfWYd = parcelRequire("kfWYd");

var $dS6df = parcelRequire("dS6df");

var $93Yz4 = parcelRequire("93Yz4");

var $lhggY = parcelRequire("lhggY");

var $loOxb = parcelRequire("loOxb");

var $4YhDi = parcelRequire("4YhDi");
const $e1be045e041add60$export$43ec6963e38d8e71 = {
    "de-DE": (0, (/*@__PURE__*/$parcel$interopDefault($iYRwE))),
    "en-CA": (0, (/*@__PURE__*/$parcel$interopDefault($csAUC))),
    "en-US": (0, (/*@__PURE__*/$parcel$interopDefault($g3eHy))),
    en: (/*@__PURE__*/$parcel$interopDefault($9vkpn)),
    "es-AR": (0, (/*@__PURE__*/$parcel$interopDefault($4BZEV))),
    "es-CL": (0, (/*@__PURE__*/$parcel$interopDefault($1umwG))),
    "es-ES": (0, (/*@__PURE__*/$parcel$interopDefault($7fVMx))),
    "es-UY": (0, (/*@__PURE__*/$parcel$interopDefault($21PHS))),
    "fr-CA": (0, (/*@__PURE__*/$parcel$interopDefault($dcH32))),
    "fr-FR": (0, (/*@__PURE__*/$parcel$interopDefault($fqdCa))),
    "it-IT": (0, (/*@__PURE__*/$parcel$interopDefault($ksUdp))),
    "pl-PL": (0, (/*@__PURE__*/$parcel$interopDefault($kfWYd))),
    "hu-HU": (0, (/*@__PURE__*/$parcel$interopDefault($dS6df))),
    "pt-BR": (0, (/*@__PURE__*/$parcel$interopDefault($93Yz4))),
    "de-CH": (0, (/*@__PURE__*/$parcel$interopDefault($lhggY))),
    "fr-CH": (0, (/*@__PURE__*/$parcel$interopDefault($loOxb))),
    "it-CH": (0, (/*@__PURE__*/$parcel$interopDefault($4YhDi)))
};

});
parcelRegister("iYRwE", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Zur\xfcck zur Startseite","errorPage.404.code":"404\xa0Fehler","errorPage.404.description":"Die gesuchte Seite existiert leider nicht oder wurde verschoben.","errorPage.404.title":"Seite nicht gefunden...","errorPage.network.description":"Die Seite konnte nicht geladen werden.\\n\xdcberpr\xfcfe die Interneteinstellungen und versuch es noch einmal.","errorPage.network.title":"Es ist ein Fehler aufgetreten\u2026","global.refreshButton":"Aktualisieren","global.toast.error.message":"Es ist ein Fehler aufgetreten. Bitte versuch es noch einmal.","global.toast.error.title":"Fehler"}');

});

parcelRegister("9vkpn", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Back to Homepage","errorPage.404.code":"404 error","errorPage.404.description":"Sorry, the page you are looking for doesn\u2019t exist or has been moved.","errorPage.404.title":"Page not found...","errorPage.network.description":"We were unable to load the page.\\nPlease check your internet settings and try again.","errorPage.network.title":"An error occurred...","global.refreshButton":"Refresh","global.toast.error.message":"An error occurred, please try again.","global.toast.error.title":"Error"}');

});

parcelRegister("csAUC", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Back to Homepage","errorPage.404.code":"404 error","errorPage.404.description":"Sorry, the page you are looking for doesn\u2019t exist or has been moved.","errorPage.404.title":"Page not found...","errorPage.network.description":"We were unable to load the page.\\nPlease check your internet settings and try again.","errorPage.network.title":"An error occurred...","global.refreshButton":"Refresh","global.toast.error.message":"An error occurred, please try again.","global.toast.error.title":"Error"}');

});

parcelRegister("g3eHy", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Back to Homepage","errorPage.404.code":"404 error","errorPage.404.description":"Sorry, the page you are looking for doesn\u2019t exist or has been moved.","errorPage.404.title":"Page not found...","errorPage.network.description":"We were unable to load the page.\\nPlease check your internet settings and try again.","errorPage.network.title":"An error occurred...","global.refreshButton":"Refresh","global.toast.error.message":"An error occurred, please try again.","global.toast.error.title":"Error"}');

});

parcelRegister("4BZEV", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Volver a la p\xe1gina de inicio","errorPage.404.code":"Error 404","errorPage.404.description":"Lo sentimos, la p\xe1gina que buscas no existe o se ha trasladado.","errorPage.404.title":"P\xe1gina no encontrada...","errorPage.network.description":"No pudimos cargar la p\xe1gina.\\nComprueba tu configuraci\xf3n de Internet e int\xe9ntalo de nuevo.","errorPage.network.title":"Se ha producido un error\u2026","global.refreshButton":"Actualizar","global.toast.error.message":"Se ha producido un error, int\xe9ntelo de nuevo.","global.toast.error.title":"Error"}');

});

parcelRegister("1umwG", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Volver a la p\xe1gina de inicio","errorPage.404.code":"Error 404","errorPage.404.description":"Lo sentimos, la p\xe1gina que buscas no existe o se ha trasladado.","errorPage.404.title":"P\xe1gina no encontrada...","errorPage.network.description":"No pudimos cargar la p\xe1gina.\\nComprueba tu configuraci\xf3n de Internet e int\xe9ntalo de nuevo.","errorPage.network.title":"Se ha producido un error\u2026","global.refreshButton":"Actualizar","global.toast.error.message":"Se ha producido un error, int\xe9ntelo de nuevo.","global.toast.error.title":"Error"}');

});

parcelRegister("7fVMx", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Volver a la p\xe1gina de inicio","errorPage.404.code":"Error 404","errorPage.404.description":"Lo sentimos, la p\xe1gina que est\xe1 buscando no existe o se ha trasladado.","errorPage.404.title":"P\xe1gina no encontrada...","errorPage.network.description":"No hemos podido cargar la p\xe1gina.\\nCompruebe su configuraci\xf3n de Internet e int\xe9ntelo de nuevo.","errorPage.network.title":"Se ha producido un error\u2026","global.refreshButton":"Actualizar","global.toast.error.message":"Se ha producido un error, int\xe9ntelo de nuevo.","global.toast.error.title":"Error"}');

});

parcelRegister("21PHS", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Volver a la p\xe1gina de inicio","errorPage.404.code":"Error 404","errorPage.404.description":"Lo sentimos, la p\xe1gina que buscas no existe o se ha trasladado.","errorPage.404.title":"P\xe1gina no encontrada...","errorPage.network.description":"No pudimos cargar la p\xe1gina.\\nComprueba tu configuraci\xf3n de Internet e int\xe9ntalo de nuevo.","errorPage.network.title":"Se ha producido un error\u2026","global.refreshButton":"Actualizar","global.toast.error.message":"Se ha producido un error, int\xe9ntelo de nuevo.","global.toast.error.title":"Error"}');

});

parcelRegister("dcH32", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Retour \xe0 l\'accueil","errorPage.404.code":"Erreur 404","errorPage.404.description":"D\xe9sol\xe9, la page que vous recherchez n\'existe pas ou a \xe9t\xe9 supprim\xe9e","errorPage.404.title":"Page introuvable...","errorPage.network.description":"Impossible de charger la page.\\nV\xe9rifiez votre connexion internet et r\xe9essayez.","errorPage.network.title":"Une erreur est survenue...","global.refreshButton":"R\xe9essayer","global.toast.error.message":"Une erreur s\u2019est produite, veuillez r\xe9essayer.","global.toast.error.title":"Erreur"}');

});

parcelRegister("fqdCa", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Retour \xe0 l\'accueil","errorPage.404.code":"Erreur 404","errorPage.404.description":"D\xe9sol\xe9, la page que vous recherchez n\u2019existe pas ou a \xe9t\xe9 d\xe9plac\xe9e.","errorPage.404.title":"Page introuvable...","errorPage.network.description":"Impossible de charger la page.\\nV\xe9rifiez votre connexion internet et r\xe9essayez.","errorPage.network.title":"Une erreur s\u2019est produite\u2026","global.refreshButton":"R\xe9essayer","global.toast.error.message":"Une erreur s\u2019est produite, veuillez r\xe9essayer.","global.toast.error.title":"Erreur"}');

});

parcelRegister("ksUdp", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Torna alla pagina iniziale","errorPage.404.code":"Errore 404","errorPage.404.description":"Siamo spiacenti, la pagina che stai cercando non esiste o \xe8 stata spostata.","errorPage.404.title":"Pagina non trovata\u2026","errorPage.network.description":"Non \xe8 stato possibile caricare la pagina.\\nControlla le impostazioni Internet e riprova.","errorPage.network.title":"Si \xe8 verificato un errore\u2026","global.refreshButton":"Ricarica","global.toast.error.message":"Si \xe8 verificato un errore, riprova.","global.toast.error.title":"Errore"}');

});

parcelRegister("kfWYd", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Powr\xf3t do strony g\u0142\xf3wnej","errorPage.404.code":"B\u0142\u0105d 404","errorPage.404.description":"Przepraszamy, strona kt\xf3rej szukasz nie istnieje lub zosta\u0142a przeniesiona.","errorPage.404.title":"Nie znaleziono strony\u2026","errorPage.network.description":"Nie uda\u0142o si\u0119 za\u0142adowa\u0107 strony.\\nSprawd\u017A po\u0142\u0105czenie z Internetem i spr\xf3buj ponownie.","errorPage.network.title":"Wyst\u0105pi\u0142 b\u0142\u0105d\u2026","global.refreshButton":"Od\u015Bwie\u017C","global.toast.error.message":"Wyst\u0105pi\u0142 b\u0142\u0105d, spr\xf3buj ponownie.","global.toast.error.title":"B\u0142\u0105d"}');

});

parcelRegister("dS6df", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Vissza a Kezd\u0151lapra","errorPage.404.code":"404-es hiba","errorPage.404.description":"Sajn\xe1ljuk, de a keresett oldal nem tal\xe1lhat\xf3, vagy m\xe1shov\xe1 helyezt\xe9k.","errorPage.404.title":"Az oldal nem tal\xe1lhat\xf3...","errorPage.network.description":"Nem tudtuk bet\xf6lteni az oldalt. K\xe9rj\xfck, ellen\u0151rizze az internetbe\xe1ll\xedt\xe1sait, majd pr\xf3b\xe1lja meg \xfajra.","errorPage.network.title":"Hiba t\xf6rt\xe9nt...","global.refreshButton":"Friss\xedt\xe9s","global.toast.error.message":"Hiba t\xf6rt\xe9nt; k\xe9rj\xfck, pr\xf3b\xe1lja \xfajra.","global.toast.error.title":"Hiba"}');

});

parcelRegister("93Yz4", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Voltar \xe0 P\xe1gina inicial","errorPage.404.code":"Erro 404","errorPage.404.description":"A p\xe1gina que voc\xea est\xe1 procurando n\xe3o existe ou foi movida.","errorPage.404.title":"P\xe1gina n\xe3o encontrada...","errorPage.network.description":"N\xe3o foi poss\xedvel carregar a p\xe1gina.\\nVerifique a configura\xe7\xe3o da sua internet e tente novamente.","errorPage.network.title":"Ocorreu um erro\u2026","global.refreshButton":"Atualizar","global.toast.error.message":"Ocorreu um erro. Tente novamente.","global.toast.error.title":"Erro"}');

});

parcelRegister("lhggY", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Zur\xfcck zur Startseite","errorPage.404.code":"404\xa0Fehler","errorPage.404.description":"Die gesuchte Seite existiert leider nicht oder wurde verschoben.","errorPage.404.title":"Seite nicht gefunden...","errorPage.network.description":"Die Seite konnte nicht geladen werden.\\n\xdcberpr\xfcfe die Interneteinstellungen und versuch es noch einmal.","errorPage.network.title":"Es ist ein Fehler aufgetreten\u2026","global.refreshButton":"Aktualisieren","global.toast.error.message":"Es ist ein Fehler aufgetreten. Bitte versuch es noch einmal.","global.toast.error.title":"Fehler"}');

});

parcelRegister("loOxb", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Retour \xe0 l\'accueil","errorPage.404.code":"Erreur 404","errorPage.404.description":"D\xe9sol\xe9, la page que vous recherchez n\u2019existe pas ou a \xe9t\xe9 d\xe9plac\xe9e.","errorPage.404.title":"Page introuvable...","errorPage.network.description":"Impossible de charger la page.\\nV\xe9rifiez votre connexion internet et r\xe9essayez.","errorPage.network.title":"Une erreur s\u2019est produite\u2026","global.refreshButton":"R\xe9essayer","global.toast.error.message":"Une erreur s\u2019est produite, veuillez r\xe9essayer.","global.toast.error.title":"Erreur"}');

});

parcelRegister("4YhDi", function(module, exports) {
module.exports = JSON.parse('{"errorPage.404.button":"Torna alla pagina iniziale","errorPage.404.code":"Errore 404","errorPage.404.description":"Siamo spiacenti, la pagina che stai cercando non esiste o \xe8 stata spostata.","errorPage.404.title":"Pagina non trovata\u2026","errorPage.network.description":"Non \xe8 stato possibile caricare la pagina.\\nControlla le impostazioni Internet e riprova.","errorPage.network.title":"Si \xe8 verificato un errore\u2026","global.refreshButton":"Ricarica","global.toast.error.message":"Si \xe8 verificato un errore, riprova.","global.toast.error.title":"Errore"}');

});


parcelRegister("hO7pz", function(module, exports) {

$parcel$export(module.exports, "wording", () => $4a2e92ae0c1af93d$export$167630b2ea15996d);

var $78Mt5 = parcelRequire("78Mt5");
const $4a2e92ae0c1af93d$export$167630b2ea15996d = {
    en: (/*@__PURE__*/$parcel$interopDefault($78Mt5))
};

});
parcelRegister("78Mt5", function(module, exports) {
module.exports = JSON.parse('{"#Master_EN.Label":"Create Program (2 Exercises)","#Master_EN.Library":"Library","#Master_EN.Monday":"Sunday","#Master_EN.Monday.25":"Monday","#Master_EN.Monday.27":"Wednesday","#Master_EN.Monday.45":"Tuesday","#Master_EN.Monday.62":"Friday","#Master_EN.Monday.63":"Saturday","#Master_EN.Monday.71":"Thursday","#Master_EN.Program_title":"Program for Peter","#Master_EN.Selected_Exercises":"Selected Exercises","#Master_EN.Text":"To add an exercise, \u2028drag & drop from ","#Master_EN.Text.18":"Peter Randal","#Master_EN.Title":"Hip warm-up","#Master_EN.Title.18":"Arms warm-up","#Master_EN.Title.2":"Tabletop position","#Master_EN.Title.26":"Chest mobility on all fours","#Master_EN.Title.31":"Extended child\u2019s pose","#Master_EN.Title.34":"Abduction et adduction de la hanche en position assise","#Master_EN.Title.67":"Seated isometric push-ups","#Master_EN.Title.82":"Exercise title","Keyscreens/EN/IOS/End_of_Session.Desc":"WELL\\nDONE!","Keyscreens/EN/IOS/End_of_Session.Exercises_Completed":"Exercises Completed","Keyscreens/EN/IOS/End_of_Session.Status.Mon":"Wed","Keyscreens/EN/IOS/End_of_Session.Status.Mon.22":"Mon","Keyscreens/EN/IOS/End_of_Session.Status.Mon.94":"Fri","Keyscreens/EN/IOS/End_of_Session.Weekly_Objective":"Weekly Objective","Keyscreens/EN/IOS/End_of_Session.You\u2019re_on_a_roll!_Only_{x}_session{s}_left__you_got_this!":"You are doing great. Keep up the hard work!","Patient_page_-_programs.Date":"Jan. 12, 2022 by","Patient_page_-_programs.Strong_sitter":"Strong sitter","Patient_page_-_programs.person":"Drake Ramoray","Patient_page_-_programs.person.1":"Chandler Scott","Patient_page_-_programs.person.67":"Monica Halpert","Progress_-_Graphs_Exertion_+_Moods.Description":"Program adherence","Progress_-_Graphs_Exertion_+_Moods.Indicator":"(per weeks)","Progress_-_Graphs_Exertion_+_Moods.Indicator.49":"(per session)","Progress_-_Graphs_Exertion_+_Moods.Title":"Exercises per week","Progress_-_Graphs_Exertion_+_Moods.Title.5":"Global adherence","Session.Title":"Shoulder Abduction","accountDeleted.cta":"Got it!","accountDeleted.description":"Thank you for trying Physio.me. Your account and all your personal data will be completely deleted within 30 days.","accountDeleted.title":"Sorry to see you go","audioPlayer.description":"Vocal instruction","cancelPatientInvitationDialog.message":"Are you sure you want to cancel the invitation for <strong>{name}</strong>?\\n\\nThe patient won\u2019t be able to register or start their exercise program on Physio.me.","cancelPatientInvitationDialog.successToast.message":"{name, select, undefined {The patient} other {{name}}}\'s invitation has been cancelled.","cancelPatientInvitationDialog.successToast.title":"Patient invitation cancelled.","cancelPatientInvitationDialog.title":"Cancel Invitation","deleteTemplateDialog.message":"Are you sure you wish to delete this template? It will be permanently removed from the template list.","deleteTemplateDialog.title":"Delete Program Template","demoRequest.countryField.title":"Country","demoRequest.dataShareConsentField.errorMessage":"You must agree to share this data with the Biogen teams","demoRequest.dataShareConsentField.message":"By selecting this box, I agree that my data will be shared with Biogen teams in order to organize a demo session with me.","demoRequest.emailField.formatError":"This email address is invalid","demoRequest.emailField.placeholder":"Email","demoRequest.emailField.title":"E-mail","demoRequest.firstNameField.placeholder":"First name","demoRequest.firstNameField.title":"First name","demoRequest.header.message":"Fill in the contact form to book a comprehensive demo with our team. \\nAvailable only for healthcare professionals.","demoRequest.header.title":"<color>Join</color> the movement","demoRequest.lastNameField.placeholder":"Last name","demoRequest.lastNameField.title":"Last name","demoRequest.medicalProfessionField.title":"Medical Profession","demoRequest.phoneNumberField.title":"Phone Number","demoRequest.postalCodeField.errorInvalidCodeMessage":"Invalid postal/zip code","demoRequest.postalCodeField.title":"Postal Code","demoRequest.submitButton":"Submit","demoRequest.successDialog.Title":"Thanks for booking a demo!","demoRequest.successDialog.button":"Return to Home page","demoRequest.successDialog.message":"We will contact you soon.","disease.friedreichAtaxia":"Friedreich\u2019s Ataxia","disease.fshd":"Facioscapulohumeral Muscular Dystrophy (FSHD)","disease.idk":"Not known","disease.multipleSclerosis":"MS (Multiple Sclerosis)","disease.v1_9.als":"Amyotrophic Lateral Sclerosis (ALS)","disease.v1_9.bmd":"Duchenne or Becker Muscular Dystrophy (DMD/BMD)","disease.v1_9.cmt":"Charcot-Marie-Tooth (CMT)","disease.v1_9.lgmd":"Limb Girdle Muscular Dystrophy (LGMD)","disease.v1_9.metabolicDisorders":"Inherited Metabolic Disorders","disease.v1_9.myasthenia":"Myasthenia Gravis","disease.v1_9.myopathy":"Myopathy","disease.v1_9.neuropathy":"Neuropathy","disease.v1_9.other":"Other","disease.v1_9.otherMuscularDystrophy":"Other Muscular Dystrophy","disease.v1_9.preferNotToSay":"I prefer not to say","disease.v1_9.sma":"Spinal Muscular Atrophy (SMA)","errorPage.404.button":"Back to Homepage","errorPage.404.code":"404 error","errorPage.404.description":"Sorry, the page you are looking for doesn\u2019t exist or has been moved.","errorPage.404.title":"Page not found...","errorPage.network.description":"We were unable to load the page.\\nPlease check your internet settings and try again.","errorPage.network.title":"An error occurred...","exercise.bodyPart.title":"Body part","exercise.bodyPart.value.fullBody":"Full body","exercise.bodyPart.value.headAndTrunk":"Head & trunk","exercise.bodyPart.value.lowerLimbs":"Lower limbs","exercise.bodyPart.value.upperLimbs":"Upper limbs","exercise.caregiverAssistance.title":"Caregiver assistance","exercise.caregiverAssistance.value.no":"No","exercise.caregiverAssistance.value.yes":"Yes","exercise.category.title":"Category","exercise.category.value.coordinationBalance":"Coordination and Balance","exercise.category.value.strengthening":"Strengthening","exercise.category.value.stretching":"Stretching","exercise.category.value.warmUp":"Warm-up","exercise.difficulty.title":"Difficulty","exercise.difficulty.value.easy":"Easy","exercise.difficulty.value.hard":"Hard","exercise.difficulty.value.moderate":"Moderate","exercise.helpNeeded.title":"Caregiver assistance","exercise.helpNeeded.value.no":"Without caregiver","exercise.helpNeeded.value.yes":"With caregiver","exercise.startingPosition.title":"Starting Position","exercise.startingPosition.value.kneeling":"Kneeling","exercise.startingPosition.value.lyingDown":"Lying Down","exercise.startingPosition.value.sitting.chair":"Sitting (chair)","exercise.startingPosition.value.sitting.floor":"Sitting (floor)","exercise.startingPosition.value.standing":"Standing","exercise.withWheelchair.title":"Wheelchair Exercises","exercise.withWheelchair.value.no":"No wheelchair","exercise.withWheelchair.value.yes":"With wheelchair","exercise.equipment.title":"Equipment","exercise.equipment.none":"No Equipment","exerciseDetailsModal.comment.help":"You can specify additional information for your patient. Once written, save your program for the comment to be sent to your patient.","exerciseDetailsModal.comment.placeholder":"For this exercise, it is really important to...","exerciseDetailsModal.comment.title":"Comments","exerciseDetailsModal.comment.title.readonly":"Comment","exerciseDetailsModal.description.title":"Description","exerciseDetailsModal.displayType.keyframes":"View Keyframes","exerciseDetailsModal.displayType.video":"View Video","exerciseDetailsModal.emptySection":"None","exerciseDetailsModal.lastCommentUpdate":"Last update: {date}{name, select, undefined {} other { by <strong>{name}</strong>} }","exerciseDetailsModal.mandatoryEquipment.title":"Mandatory Equipment","exerciseDetailsModal.navigation.outOf":"of","exerciseDetailsModal.optionalEquipment.title":"Optional Equipment","exerciseDetailsModal.ataxiaWarning":"Unsuitable for people with balance difficulties.","exerciseFilterListingPanel.clear":"Clear filters","exerciseFilterListingPanel.title":"Filters","exerciseFilterPanel.clear":"Clear All","exerciseFilterPanel.completeLabel":"{filterCategory, select, undefined {} other {{filterCategory} : }}{filterValue}","exerciseFilterPanel.title":"Exercises Filters","exerciseLibrary.alreadyAdded":"Already Added","exerciseLibrary.alreadyInSelection":"Already in selection ({size})","exerciseLibrary.alreadyInSelectionToolTipMessage":"{exerciseSelectedCount, plural, =1 {Exercise} other {Exercises}} already on the list of alternatives.","exerciseLibrary.emptySearch":"Oops! No results found. Try adjusting your filters or search terms.","exerciseLibrary.errorMessage":"Impossible to update the exercise library data","exerciseLibrary.exerciseCount":"<boldSmall>{count}</boldSmall> {count, plural, =0 {exercise} one {exercise} other {exercises}}","exerciseLibrary.filteredExerciseCounts":"<boldSmall>{filteredCount} / {totalCount}</boldSmall> {totalCount, plural, =0 {exercise} one {exercise} other {exercises}}","exerciseLibrary.header":"Exercise Library","exerciseLibrary.librarySection":"Library","exerciseLibrary.searchInputPlaceholder":"Search for an exercise","exerciseLibrary.searchResult":"Search result ({size})","exerciseLibrary.selectedExercisesSection":"Selected Exercises","exerciseListing.createProgramButton":"Create Program","exerciseListing.createProgramButtonMobile":"Create Program ({count} {count, plural, =0 {Exercise} one {Exercise} other {Exercises}})","exerciseListing.emptySearch.description":"We couldn\u2019t find any exercises matching your search criteria or filters. \\nCheck spelling, use different keywords, or adjust filters.","exerciseListing.emptySearch.title":"No Exercises Found","exerciseListing.exerciseCount":"<boldSmall>{count}</boldSmall> {count, plural, =0 {exercise} one {exercise} other {exercises}}","exerciseListing.filteredExerciseCounts":"<boldSmall>{filteredCount} / {totalCount}</boldSmall> {totalCount, plural, =0 {exercise} one {exercise} other {exercises}}","exerciseListing.selectedExerciseCount":"<boldSmall>{selectedCount}</boldSmall> {selectedCount, plural, =0 {exercise} one {exercise} other {exercises}} selected","forgotPassword.enterCode.codeLabel":"Confirmation Code","forgotPassword.enterCode.formatError":"This code is invalid","forgotPassword.enterCode.placeholder":"000000","forgotPassword.enterCode.requireError":"Please enter the code received on {email}","forgotPassword.enterCode.resendCodeButton":"Didn\u2019t receive it? Resend the email","forgotPassword.enterCode.resetError":"This code is invalid. Please request a new one.","forgotPassword.enterCode.submitButton":"Next","forgotPassword.enterCode.temporaryPasswordError":"Sorry, you can\u2019t reset your password for now because you did not activate your account with your temporary password.","forgotPassword.enterCode.userNotFoundError":"We couldn\'t find a user with this email.","forgotPassword.enterEmail.description":"Please enter your email address that is linked to your account. We will send you a link to reset your password.","forgotPassword.enterEmail.emailLabel":"Email Address","forgotPassword.enterEmail.formatError":"Invalid email address. E.g. example@email.com","forgotPassword.enterEmail.placeholder":"user@email.com","forgotPassword.enterEmail.requiredError":"Please enter your email address","forgotPassword.enterEmail.sendButton":"Send Link","forgotPassword.resendEmail.successToast.message":"Please check your inbox for your new code.","forgotPassword.resendEmail.successToast.title":"Email successfully sent!","forgotPassword.sendLimitExceededError":"You\u2019ve reached the send limit. Please try again later.","forgotPassword.title":"Reset Your Password","functionalStatus.sitter":"Sitter","functionalStatus.walker":"Walker","getStarted.checkIcon.completed":"Completed","getStarted.description":"Welcome Onboard! Explore this temporary guide to learn how Physio.me works.","getStarted.dialog.autoHideNotice":"The Get Started page will automatically disappear in one hour.","getStarted.dialog.closeButton":"Ok, got it","getStarted.dialog.step.exercises":"Explore Exercises","getStarted.dialog.step.patients":"Create a Patient Profile","getStarted.dialog.step.programs":"Build a Program","getStarted.dialog.subTitle":"You\u2019re all set now!","getStarted.dialog.title":"You\u2019ve Completed the Onboarding!","getStarted.exercisesCard.ctaButton":"Explore Exercises","getStarted.exercisesCard.description":"Explore our comprehensive library to find the ideal exercises for your patients. Use the search or filter options to locate, view, and play exercises effortlessly.","getStarted.exercisesCard.mainHeadline":"Exercises","getStarted.exercisesCard.secondaryHeadline":"Discover our extensive library","getStarted.patientsCard.ctaButton":"Create a Patient Profile","getStarted.patientsCard.description":"Create patient profiles to share programs with them.","getStarted.patientsCard.mainHeadline":"Patients","getStarted.patientsCard.secondaryHeadline":"Track progress and engage","getStarted.programsCard.ctaButton":"Build a Program","getStarted.programsCard.description":"Create a customized and engaging program in minutes. \\nExplore the various exercise options available in the Program Builder.","getStarted.programsCard.mainHeadline":"Programs","getStarted.programsCard.secondaryHeadline":"Build effective therapy routines","getStarted.title":"Let\'s Explore Physio.me!","global.close":"Close","global.confirmDuplicationDialog.confirmButtonLabel":"Duplicate Anyway","global.confirmDuplicationDialog.message":"You are duplicating a program with changes not saved. These changes will not be duplicated.","global.confirmDuplicationDialog.title":"Some changes have not been saved","global.contactUs":"Contact support","global.deleteProgramOperation.errorToast.message":"We were unable to delete your program, please try again","global.deleteProgramOperation.errorToast.title":"An error has occurred","global.deleteProgramOperation.successToast.message":"\u201C{program}\u201D is deleted","global.deleteProgramOperation.successToast.title":"Program deleted","global.deleteTemplateOperation.errorToast.message":"We were unable to delete your template, please try again","global.deleteTemplateOperation.errorToast.title":"An error has occurred","global.deleteTemplateOperation.successToast.message":"\\"{name}\\" is deleted","global.deleteTemplateOperation.successToast.title":"Template Deleted","global.dialog.back":"Back","global.scrollToTop":"Top","global.dialog.cancel":"Cancel","global.dialog.continue":"Continue","global.dialog.next":"Next","global.dialog.save":"Save","global.dialog.textInput.maxLength":"Max {maxLength} characters","global.dialog.yes":"Yes","global.duplicateProgramOperation.errorToast.message":"We were unable to duplicate your program, please try again","global.duplicateProgramOperation.successToast.message":"A copy of \u201C{program}\u201D has been created.","global.duplicateProgramOperation.successToast.title":"Program duplicated","global.empty":"\u2014","global.errorToast.title":"An error has occurred","global.exertion.1.description":"I didn\u2019t feel any exertion efforts","global.exertion.1.title":"Little, If No Exertion","global.exertion.1.value":"1","global.exertion.2.description":"I felt light exertion efforts but I could still do it again","global.exertion.2.title":"Light Exertion","global.exertion.2.value":"2","global.exertion.3.description":"I felt moderate exertion efforts but it is still manageable","global.exertion.3.title":"Moderate Exertion","global.exertion.3.value":"3","global.exertion.4.description":"I felt intense exertion effort. It would be a challenge to do again.","global.exertion.4.title":"Intense Exertion","global.exertion.4.value":"4","global.exertion.5.description":"It would be difficult for me to keep going","global.exertion.5.title":"Very intense Exertion","global.exertion.5.value":"5","global.exertion.6.description":"I feel it\'s impossible to finish. My muscles are completely exhausted","global.exertion.6.title":"Maximum Exertion","global.exertion.6.value":"6","global.form.dropdown.placeholder":"Select...","global.form.dropdown.requiredError":"You must select a topic","global.form.field.requiredError":"You must fill in this field","global.form.phoneNumberInput.country.search.empty":"No country found","global.form.phoneNumberInput.country.search.placeholder":"Search for countries","global.form.phoneNumberInput.invalidError":"This phone number is invalid","global.gender.man":"Male","global.gender.other":"Other","global.gender.woman":"Female","global.medicalProfession.eapa":"EAPA","global.medicalProfession.employedPt":"Employed physical therapist","global.medicalProfession.independentPt":"Independent physical therapist","global.medicalProfession.neurologist":"Neurologist","global.medicalProfession.none":"Not a healthcare professional","global.medicalProfession.occupationalPt":"Occupational therapist","global.medicalProfession.other":"Other healthcare professional","global.medicalProfession.pmrPhysician":"Physical Medicine & Rehab","global.medicalProfession.psychomotorTherapist":"Psychomotor Therapist","global.mood.1.title":"Not Great","global.mood.2.title":"Uneasy","global.mood.3.title":"So So","global.mood.4.title":"Good","global.mood.5.title":"Great","global.mood.6.title":"Excellent","global.nativeBlockModal":"Are you sure you want to leave this page? Unsaved modifications will be lost","global.notifications.hct.invitation":"<strong>{ptName}</strong> invited you to join <strong><color>{patientName}</color></strong>\u2018s healthcare team.","global.notifications.hct.joined":"<strong>{ptName}</strong> joined <strong><color>{patientName}</color></strong>\u2018s healthcare team.","global.notifications.hct.ptleft":"<strong>{ptName}</strong> has left <strong>{patientName}\u2019s</strong> healthcare team.","global.notifications.patient.registered":"<strong>{patientName}</strong> completed their registration on Physio.me.","global.notifications.patientAccount.deletion":"<strong>{patientName}</strong> has left Physio.me","global.notifications.patientProgram.finishSoon":"<strong>{patientName}</strong>\u2019s program \u201C{programName}\u201D <strong><color>is ending in {dayCount, plural, =1 {# day} other {# days}}</color></strong> ({date}).","global.notifications.patientProgram.finished":"<strong>{patientName}</strong> finished their program \u201C<strong><color>{programName}</color></strong>\u201D.","global.notifications.patientProgram.started":"<strong>{patientName}</strong>\u2019s program \u201C{programName}\u201D <strong><color>starts today</color></strong>.","global.notifications.ptAccount.validated":"<strong>Welcome to Physio.me!</strong> You account has been verified. You are now using the full version of Physio.me.","global.notifications.ptAccount.validationPending":"Our support staff will <strong>examine your request shortly</strong>. This process can take up to 48 hours (working days).","global.notifications.toast.newNotificationsReceived":"You\u2019ve received <strong>{count}</strong> new {count, plural, =1 {notification} other {notifications}}","global.now":"Now","global.patientNotFound.description":"We were unable to load the page.\\nThe patient cannot be found or does not exist.","global.patientOperation.cancelInvitation":"Cancel Invitation","global.patientOperation.keepInvitation":"Keep Invitation","global.patientOperation.see":"See details","global.programName.maxLength":"Program name contains too many characters","global.programNotFound.description":"We were unable to load the page.\\nThe program cannot be found or does not exist.","global.programOperation.delete":"Delete Program","global.programOperation.duplicateAsDraft":"Duplicate as a draft","global.programOperation.duplicateAsTemplate":"Duplicate as a template","global.programOperation.edit":"Edit program","global.programOperation.see":"See Program","global.programOperation.stop":"Stop Program","global.programStatus.completed":"Completed","global.programStatus.labels.draft":"Draft","global.programStatus.labels.ended":"Ended","global.programStatus.labels.endedProgramDetailsMode_v2.4":"Ended on {endDate}","global.programStatus.labels.endedProgramWithNoUpcoming":"Ended {endDate}","global.programStatus.labels.noProgram":"No program scheduled","global.programStatus.labels.noProgram.v2_6":"Not scheduled","global.programStatus.labels.ongoing":"Ongoing","global.programStatus.labels.scheduled":"Scheduled","global.programStatus.labels.upcomingProgram":"Start in {formattedDays}","global.programStatus.ongoing":"Ongoing","global.programStatus.stopped":"Stopped","global.refreshButton":"Refresh","global.register.biogenEmails.v1_6":"I wish to receive emails from <strong>Biogen</strong>. I can opt-out at any time","global.register.licensedPt.confirmation":"I confirm that I am a legally authorized and licensed physical therapist.","global.register.consent.tou":"I agree with the <link>Terms of Use</link>","global.register.consent.tou.and.pn":"I agree with the <link>Terms of Use</link> & <link2>Privacy Notice</link2>","global.register.consent.tou.and.pn.required":"You must agree with the Terms of Use & Privacy Notice","global.register.consent.tou.required":"You must agree with the Terms of Use","global.register.physiomeEmails.v1_6":"I wish to receive emails from <strong>Physio.me</strong>. I can opt-out at any time","global.register.privacy_notice.description":"This <link>Privacy Notice</link> explains how we process your personal data when you create an account and use Physio.me.","global.relativeTime.day":"1 day","global.relativeTime.days":"%d days","global.relativeTime.hour":"1 hour","global.relativeTime.hours":"%d hours","global.relativeTime.minute":"1 min","global.relativeTime.minutes":"%d min","global.relativeTime.month":"1 month","global.relativeTime.months":"%d months","global.relativeTime.week":"1 week","global.relativeTime.weeks":"%d weeks","global.relativeTime.year":"1 year","global.relativeTime.years":"%d years","global.saveChangesDialog.confirmButtonLabel":"Discard Changes","global.saveChangesDialog.title":"Exit without saving","global.search.placeholder":"Search","global.stopProgramOperation.draft.successToast.message":"Find it in the draft programs section of your patient page","global.stopProgramOperation.errorToast.message":"We were unable to stop your program, please try again","global.stopProgramOperation.errorToast.title":"An error has occurred","global.stopProgramOperation.successToast.message":"Find it in the former programs section of your patient page","global.stopProgramOperation.successToast.title":"Program stopped","global.templateName.maxLength":"Template name contains too many characters","global.textArea.limitCharacters":"Max {limit} characters","global.timeLeft":"{formattedRemainingTime} {remainingTime, plural, =0 {left} other {left}}","global.timeLeft.none":"Ends today","global.time.minute":"1 minute","global.time.minutes":"%d minutes","global.toast.error.message":"An error occurred, please try again.","global.toast.error.title":"Error","global.transformProgramToTemplateOperation.successToast.message":"\\"{template}\\" has been created","global.transformProgramToTemplateOperation.successToast.title":"Program saved as a template","home.aboutPhysiomeDialog.content.buildVersion.intro":"Build version number:","home.aboutPhysiomeDialog.content.productVersion.intro":"Product version number:","home.aboutPhysiomeDialog.header":"About Physio.me","home.addPatientButton":"Add Patient","home.addPatientDialog.hctJoined.cta":"View Patient Profile","home.addPatientDialog.hctJoined.header":"Healthcare Team Joined","home.addPatientDialog.hctJoined.subtitle":"You can now view their progress and manage their programs.","home.addPatientDialog.hctJoined.title":"<color>{patientName}</color> has been added to your patient list.","home.addPatientDialog.invitationCodeForm.alreadyInHctError":"You are already a member of this patient\'s healthcare team.","home.addPatientDialog.invitationCodeForm.formatError":"This code\'s format is invalid","home.addPatientDialog.invitationCodeForm.header":"Join Healthcare Team","home.addPatientDialog.invitationCodeForm.invalidError":"This code is invalid. Please verify that you have entered it correctly request a new one from your patient.","home.addPatientDialog.invitationCodeForm.placeholder":"XXXXXX","home.addPatientDialog.invitationCodeForm.requireError":"You must fill in this field","home.addPatientDialog.invitationCodeForm.title":"Enter the invitation code the patient gave you to access their programs and view their progress.","home.addPatientDialog.invitationCodeForm.wrongCountryError":"You cannot join a patient\'s healthcare team in another country.","home.addPatientDialog.inviteOrCreate.createPatient":"Create New Patient Profile","home.addPatientDialog.inviteOrCreate.header":"Add Patient","home.addPatientDialog.inviteOrCreate.joinHct":"Join a Patient\u2019s Healthcare Team","home.healthcareTeam.acceptDialog.acceptButton":"Accept invitation","home.healthcareTeam.acceptDialog.description.v1_6":"Your colleague physical therapist <strong>{ptName}</strong> has invited you to join the healthcare team of {patientName, select, undefined {their patient} other {<strong>{patientName}</strong>}}.","home.healthcareTeam.acceptDialog.header":"Invitation to join a healthcare team","home.healthcareTeam.acceptDialog.patientDetails.functionalStatus":"Functional Status","home.healthcareTeam.acceptDialog.patientDetails.header":"Patient Details","home.healthcareTeam.acceptDialog.patientDetails.medicalCondition":"Medical Condition","home.healthcareTeam.acceptDialog.patientDetails.patientInformation":"Patient Information","home.healthcareTeam.acceptDialog.patientDetails.profileCreation":"Profile Creation","home.healthcareTeam.errorToast.ptNotInvited.subtitle":"It seems that this invitation does not apply to you","home.healthcareTeam.errorToast.ptNotInvited.title":"You can\'t join this healthcare team","home.noPatients.description":"Create a new patient profile to share a program with your patient. If your patient has provided an invitation code, join their healthcare team.","home.noPatients.title":"Add Your First Patient","home.noPendingPatients.title":"Your pending patients list is currently empty","home.noRegisteredPatients.description":"Create a new patient profile to share a program with your patient. If your patient has provided an invitation code, join their healthcare team.","home.noRegisteredPatients.title":"Your registered patients list is currently empty","home.patientComplianceListingError.toast":"Impossible to load the patient compliance. Please try again later.","home.patientListingError.description":"We were unable to load the data.\\nPlease try again.","home.patientListingError.toast":"Impossible to update the listing. Please try again later","home.patientsListing.globalComplianceRowMobile":"Compliance: ","home.patientsListing.lastSessionCompletedRowMobile":"Last Session Completed: ","home.pendingPatientDialog.codeSent.bottomCard.cta":"Create Program Template","home.pendingPatientDialog.codeSent.bottomCard.text":"Create a program template now and assign it once the patient completes registration.","home.pendingPatientDialog.codeSent.bottomCard.title":"Prepare Program in Advance","home.pendingPatientDialog.codeSent.newPatient.email.message":"An invitation code was send to {email}","home.pendingPatientDialog.codeSent.newPatient.header":"A new patient profile has been created","home.pendingPatientDialog.codeSent.notReceived":"Invitation code not received?","home.pendingPatientDialog.codeSent.print.message":"{patientName} has been added to your patient list","home.pendingPatientDialog.codeSent.resendCode.email.message":"An invitation code was resend to {email}","home.pendingPatientDialog.codeSent.resendCode.header":"The code has been resent to your patient","home.pendingPatientDialog.codeSent.retryButton":"Retry","home.pendingPatientDialog.details.code.title":"Invitation code","home.pendingPatientDialog.details.description":"Please share this invitation code with your patient and ask them to register on the app with it.","home.pendingPatientDialog.details.sharing.email":"Email","home.pendingPatientDialog.details.sharing.email.incorrectFormat":"The email format is invalid","home.pendingPatientDialog.details.sharing.email.label":"Email Address","home.pendingPatientDialog.details.sharing.email.placeholder":"Enter the patient\u2019s email address","home.pendingPatientDialog.details.sharing.email.patientNotPending.description":"This patient has already completed their registration. You can continue to the next step.","home.pendingPatientDialog.details.sharing.email.patientNotPending.title":"Account already exists","home.pendingPatientDialog.details.sharing.email.submitButton":"Send by Email","home.pendingPatientDialog.details.sharing.print":"Print","home.pendingPatientDialog.details.sharing.title":"Send the code","home.pendingPatientDialog.form.additionalFields":"Show Additional Fields","home.pendingPatientDialog.form.dataConsent.label":"I understand that Biogen is receiving data in order to send a link & code to your patient and they have agreed to this.","home.pendingPatientDialog.form.dataConsent.required":"You must accept this condition","home.pendingPatientDialog.form.firstName.label":"First Name","home.pendingPatientDialog.form.functionalStatus.label":"Functional Status (optional)","home.pendingPatientDialog.form.header":"Create a new patient profile","home.pendingPatientDialog.form.header.v2_6":"Create Patient Profile","home.pendingPatientDialog.form.lastName.label":"Last Name","home.pendingPatientDialog.form.submitButton":"Next","home.pendingPatientDialog.print.code.description_1":"In order to register, you will need your","home.pendingPatientDialog.print.code.description_2":"invitation code :","home.pendingPatientDialog.print.fisrtDescription":"We are pleased to have you on board!","home.pendingPatientDialog.print.footer":"See you later on <color>Physio.me</color>!","home.pendingPatientDialog.print.secondDescription":"To download Physio.me, look for the app on your phone store or simply scan this QR code","home.pendingPatientDialog.print.step_1":"Open the camera of your smartphone","home.pendingPatientDialog.print.step_2":"Point the camera at the QR code","home.pendingPatientDialog.print.step_3":"Make sure the QR code is in the center of your screen","home.pendingPatientDialog.print.step_4":"Wait for the scan to finish and open the content of the QR code by pressing \u201COpen\u201D (Android) or \u201CContinue\u201D (iOS)","home.pendingPatientDialog.print.subtitle":"your NMD training program","home.pendingPatientDialog.print.title":"Physio.me","home.pendingPatientDialog.printButton":"Print","home.pendingPatientDialog.registrationDetails.header":"Registration Pending","home.pendingPatientDialog.registrationDetails.text":"{patientFullName} needs to complete registration before a program can be created for them.","home.pendingPatientDialog.resendCode.header":"Resend code","home.pendingPatientsListing.codeColumn":"Invitation Code","home.pendingPatientsListing.codeRowMobile":"Invitation Code: ","home.pendingPatientsListing.creationDateColumn":"Creation Date","home.pendingPatientsListing.creationDateRowMobile":"Creation Date","home.pendingPatientsListing.emptyMessage":"No pending patients","home.pendingPatientsListing.expiresInColumn":"Expires in","home.pendingPatientsListing.expiresInColumn.item":"{remainingDays, plural, =0 {# day} one {# day} other {# days}}","home.pendingPatientsListing.expiresInColumn.tooltip":"How many days remaining before the invitation expires.","home.pendingPatientsListing.expiresInRowMobile":"Expire in: ","home.pendingPatientsListing.patientNameColumn":"Patient Name","home.pendingPatientsListing.resendCode.item":"Resend code","home.pendingPatientsListing.tabName":"Pending Patients ({count})","home.pendingPatientsListing.tabName.loading":"Pending Patients","home.registeredPatientsListing.activeFilter.extensionNeeded":"Extension Needed","home.registeredPatientsListing.alert.activeFilters.text":"Active Filters:","home.registeredPatientsListing.alert.programEnding.button":"See Patients","home.registeredPatientsListing.alert.programEnding.label":"Filtered patient list","home.registeredPatientsListing.alert.programEnding.message":"{patientNumber, plural, =1 {# patient} other {# patients}} {patientNumber, plural, =1 {has} other {have}} a program that is about to end or has already ended.\\nExtend their programs now so they can continue exercising until their next assessment.","home.registeredPatientsListing.alert.programEnding.title":"Don\u2019t Let Your Patients Stop Exercising!","home.registeredPatientsListing.emptyMessage":"No registered patients yet","home.registeredPatientsListing.emptyName":"Inscription in progress...","home.registeredPatientsListing.extendColumn.button":"Extend","home.registeredPatientsListing.globalComplianceColumn":"Global compliance","home.registeredPatientsListing.lastSessionColumn":"Last Session","home.registeredPatientsListing.lastSessionColumn.tooltip":"Last session completed by the patient","home.registeredPatientsListing.nameColumn":"Patient Name","home.registeredPatientsListing.programStatusColumn":"Program Status","home.registeredPatientsListing.tabName":"Registered Patients ({count})","home.registeredPatientsListing.tabName.loading":"Registered Patients","home.title":"Patients","home.validateAccountCard.cta":"Validate Account","home.validateAccountCard.message":"To ensure patient safety, we need to verify your profession and identity before you can invite them.","home.validateAccountCard.title":"Validate Your Account","home.validatePendingAccountCard.message":"Our customer support team is reviewing your information. We\'ll notify you when your account is validated.","home.validatePendingAccountCard.title":"Your Account is Pending Approval","iPhone_13_Pro_Max_-_5.Group_626.52_Days_Left":"52\\nDays Left","iPhone_13_Pro_Max_-_5.Group_627.Status":"(Ongoing)","iPhone_13_Pro_Max_-_5.Group_627.Text":"Barbara Davis","iPhone_13_Pro_Max_-_5.Group_627.Text.40":"35, Female","iPhone_13_Pro_Max_-_5.Group_627.Title":"Program for Barabara","iPhone_13_Pro_Max_-_5.H3":"Program Progress","iPhone_13_Pro_Max_-_5.Metric":"Jan 3, 2025","iPhone_13_Pro_Max_-_5.Metric.85":"Sept 3, 2025","iPhone_13_Pro_Max_-_5.Title":"Ending","iPhone_13_Pro_Max_-_5.Title.81":"Started ","inviteYourPt.confirmMessage.backButton":"Go Back to the Website","inviteYourPt.confirmMessage.description":"The information that you provided to us has been shared with Biogen.\\nThe Biogen team will contact your physical therapist and propose a Physio.me demo.","inviteYourPt.confirmMessage.title":"Thanks for providing your therapist\'s information.","inviteYourPt.form.description":"Physio.me is designed to help both you and your physical therapist through tailor-made programs and communication of your progress. Would you like to share Physio.me with your physical therapist?  Please provide their information below and we will be in contact.","inviteYourPt.form.patientSection.consentCheckbox.label":"By selecting this box, I agree to share my information and contact information of my physical therapist with Biogen, so that Biogen contacts my physical therapist on my behalf. My data will be deleted, once my physical therapist is contacted, regardless if they join Physio.me or not.","inviteYourPt.form.patientSection.consentCheckbox.requiredError":"You must agree to share this data with the Biogen teams","inviteYourPt.form.patientSection.firstName.placeholder":"First Name","inviteYourPt.form.patientSection.firstName.title":"First Name","inviteYourPt.form.patientSection.lastName.placeholder":"Last Name","inviteYourPt.form.patientSection.lastName.title":"Last Name","inviteYourPt.form.patientSection.title":"Your information","inviteYourPt.form.privacyFooter":"You can find more information about how Biogen processes personal data in our <link>Privacy Policy</link>.","inviteYourPt.form.ptSection.email.title":"Email (optional)","inviteYourPt.form.ptSection.medicalProfession.title":"Medical Profession (optional)","inviteYourPt.form.ptSection.title":"Your Physical Therapist Information","inviteYourPt.form.submitButton":"Submit","inviteYourPt.form.title":"Invite your <color>Physical Therapist</color>","leavingReason.difficult_use":"I find it difficult to use","leavingReason.missing_guidance":"I am missing guidance on how to create a program for people with neuromuscular diseases","leavingReason.no_benefit":"I don\u2019t see the benefit for my patients","leavingReason.no_patients":"I have too few patients with neuromuscular diseases","leavingReason.other":"Other","leavingReason.privacy_concerns":"I have privacy concerns","leavingReason.spam":"I receive too many emails","leavingReason.technical_issues":"I experience technical issues","leavingReason.time_consuming":"I find it too time-consuming","legalContent.privacyNotice.switchLabel":"See Terms of Use","legalContent.privacyNotice.title":"Privacy Notice","legalContent.registration.form.continueButton":"Continue","legalContent.registration.form.text":"Let\u2019s start using Physio.me by accepting our conditions first.","legalContent.registration.subtitle":"Finish my registration","legalContent.registration.title":"Welcome","legalContent.termsOfUse.switchLabel":"See Privacy Notice","legalContent.termsOfUse.title":"Terms of Use","login.completeYourRegistrationMessage":"Complete Your Registration","login.completeYourRegistrationMessage.note":"You are invited to Physio.me! Follow the steps below to finalise your registration.","login.description.v1_6.note1":"Gallery of 100+ video exercises co-created with specialized physical therapists.","login.description.v1_6.note2":"Patient progress tracking & program compliance monitoring.","login.description.v1_6.note3":"Interactive and intuitive program builder","login.description.v1_6.note4":"Virtual rewards program to motivate your patients","login.description.v1_6.subTitle":"Physio.me is a digital solution that enables physical therapists to assign tailor-made exercise programs for people living with NMD and monitor their progress.","login.description.v1_6.title":"Join the movement!","login.emailAddressField.formatError":"Invalid email address. E.g. example@email.com","login.emailAddressField.placeholder":"user@email.com","login.emailAddressField.requiredError":"Please enter your email address","login.emailAddressField.title":"Email Address","login.incorrectDataError":"Your email address and/or password is invalid","login.loginButton":"Log In","login.needNewPasswordMessage":"Define your own password before starting","login.newPassword.reusedTemporaryPasswordError":"You cannot use your temporary password as a permanent password.","login.newPassword.sessionExpiredToast.message":"Your session has expired. Please connect again.","login.newPassword.sessionExpiredToast.title":"Changes have not been saved","login.passwordField":"Password","login.passwordField.placeholder":"Password","login.passwordField.requiredError":"Please enter your password","login.passwordLostButton":"Forgot Password?","login.registerButton":"New to Physio.me ?<link> Register</link>","login.title.welcomeBack":"Welcome Back!","login.tooManyAttemptsError":"You\u2019ve reached the maximum of attempts. Please try again later.","login.vip.button":"Activate My Account","login.vip.newSubtitle":"You have been invited to register on Physio.me. This will only take a brief moment.","login.vip.newTitle":"Welcome {name}","login.vip.subtitle":"Let\'s get started on your Physio.me registration.\\nThis should only take a few minutes.","login.vip.title":"Welcome, {name}","login.welcomeBackMessage":"Welcome back","metadata.title":"Physio.me","newPasswordForm.confirmPassword.label":"Confirm password","newPasswordForm.confirmPassword.matchError":"The confirmation password doesn\'t match your password","newPasswordForm.confirmPassword.placeholder":"Confirm Password","newPasswordForm.confirmPassword.requiredError":"Please enter your confirmation password","newPasswordForm.submitButton":"Save & Continue","notificationCenter.emptyList.subtitle":"You have not received any messages yet","notificationCenter.emptyList.title":"Your notification center is currently empty","notificationCenter.list.row.markAsRead.tooltip":"Mark as read","notificationCenter.list.row.markAsUnread.tooltip":"Mark as unread","notificationCenter.markAllAsRead.button":"Mark all as read","notificationCenter.markAllAsRead.dialog.description":"Do you want to mark all your notifications as read?","notificationCenter.markAllAsRead.dialog.header":"Mark {count, plural, =1 {# notification} other {# notifications}} as read","notificationCenter.markAllAsRead.toastSuccess.detail":"{count, plural, =1 {# notification} other {# notifications}} marked as read","notificationCenter.sections.last30days":"Last 30 days","notificationCenter.sections.last7days":"Last 7 days","notificationCenter.sections.older":"Older","notificationCenter.sections.today":"Today","notificationCenter.title":"Notifications","programBuilder.quickstart.step.complementaryExercises.guide01":"Add complementary exercises to quickly build a well-rounded session with ease.","programBuilder.quickstart.step.complementaryExercises.guide03":"The library is now filtered to show exercises from other categories targeting the same body part. Add a few to enhance your session!","passwordField.countryLanguage.label":"Select your language","passwordField.create.your.new.password.label":"Create Your New Password","passwordField.create.your.password.label":"Create Your Password","passwordField.password.incorrectRuleError":"Your password doesn\'t meet the required characters needed","passwordField.password.label":"Password","passwordField.password.placeholder":"Password","passwordField.password.requiredError":"Please enter your new password","passwordField.rules.description":"Your passport must contain at least:","passwordField.rules.lowerCaseLetterIncluded":"1 lower case letter","passwordField.rules.minLength":"12 characters","passwordField.rules.numberIncluded":"1 number","passwordField.rules.specialCharacterIncluded":"1 special character","passwordField.rules.upperCaseLetterIncluded":"1 upper case letter","patientDetails.alert.programEnded.button":"Duplicate as Draft","patientDetails.alert.programEnded.message":"Create a new program to ensure your patient continues exercising until their next assessment.","patientDetails.alert.programEnded.title":"{patientName} Has Run Out of Programs","patientDetails.alert.programEndingSoon.button":"Extend Program","patientDetails.alert.programEndingSoon.message":"Extend this program or create a new one to ensure your patient continues exercising until their next assessment.","patientDetails.alert.programEndingSoon.title":"{patientName}\u2019s Program Is Ending Soon","patientDetails.breadCrumb.home":"Patient List","patientDetails.column.contactSection":"Contact","patientDetails.column.editInfoDialog.functionalStatus":"Functional status (optional)","patientDetails.column.editInfoDialog.header":"Edit patient info","patientDetails.column.editInfoDialog.medicalCondition":"Medical condition (optional)","patientDetails.column.editInfoDialog.successToast":"Patient info modified","patientDetails.column.functionalStatusSection":"Functional Status","patientDetails.column.legalAgeDisclaimer.description":"The minor user must perform any exercise under the supervision of a parent or any adult who has authority over them.","patientDetails.column.legalAgeDisclaimer.title":"Underage patient","patientDetails.column.medicalSection":"Medical Condition","patientDetails.column.patientAspiration":"Patient Aspiration","patientDetails.column.patientAspiration.tooltip":"This is a statement written by your patient aimed at helping them stay motivated.","patientDetails.column.pendingPatient.invitationCode":"Invitation Code","patientDetails.column.profileCreation":"Profile Creation Date","patientDetails.errorToast.notInHealthcareTeam":"You don\'t have access to this patient","patientDetails.healthcareTeam.actionButton.delete":"Remove","patientDetails.healthcareTeam.actionButton.delete.toastSuccess.message":"{invitedPtName} has been removed from {patientName}\'s healthcare team","patientDetails.healthcareTeam.actionButton.delete.toastSuccess.title":"Team Member has been removed","patientDetails.healthcareTeam.actionButton.leave":"Leave Healthcare Team","patientDetails.healthcareTeam.actionButton.resend":"Resend Invite","patientDetails.healthcareTeam.actionButton.resend.toastSuccess.message":"An invitation email has been resent to {email}","patientDetails.healthcareTeam.actionButton.resend.toastSuccess.title":"Invitation resent","patientDetails.healthcareTeam.inviteColleagueButton":"Invite a colleague","patientDetails.healthcareTeam.inviteDialog.form.customMessage.defaultValue":"Hello dear colleague,\\nI would like to take this opportunity to share with you {patientName, select, undefined {this patient} other {{patientName}}}\'s Physio.me account. {patientName, select, undefined {This patient} other {{patientName}}} is one of my patients and I\'d like to give you access to their account. You will be able to monitor their progress and modify their program as necessary.\\n\\n\u2013 {ptName}","patientDetails.healthcareTeam.inviteDialog.form.customMessage.label":"Custom Message","patientDetails.healthcareTeam.inviteDialog.form.email.alreadyJoinedError":"This physical therapist has already been invited or is already part of the patient\'s healthcare team.","patientDetails.healthcareTeam.inviteDialog.form.email.formatError":"The email format is invalid.","patientDetails.healthcareTeam.inviteDialog.form.email.label":"Email Address","patientDetails.healthcareTeam.inviteDialog.form.email.placeholder":"Email Address","patientDetails.healthcareTeam.inviteDialog.form.email.ptInDifferentCountryError":"You cannot invite a physical therapist practicing in another country.","patientDetails.healthcareTeam.inviteDialog.form.invitedColleague.label":"Invited colleague","patientDetails.healthcareTeam.inviteDialog.form.submitButton":"Invite","patientDetails.healthcareTeam.inviteDialog.header":"Invite a colleague to this healthcare team","patientDetails.healthcareTeam.inviteDialog.toastSuccess.subtitle":"Both your patient and your colleague have to accept the invitation.","patientDetails.healthcareTeam.inviteDialog.toastSuccess.title":"Colleague successfully invited.","patientDetails.healthcareTeam.inviteDialog.unregisteredPt.copyButton":"Copy","patientDetails.healthcareTeam.inviteDialog.unregisteredPt.copyButton.copied":"Message copied","patientDetails.healthcareTeam.inviteDialog.unregisteredPt.email.body":"Dear Colleague,\\n\\n{patientName} is my patient and I would like to grant you access to their physical therapy program. Click on this link to join Physio.me now:\\n\\n{inviteUrl}\\n\\n{patientName} will need to accept sharing their profile with you before you can access or see their account. Please check back in a couple of days after creating your account.\\n\\nSincerely,\\n{invitingPtName}","patientDetails.healthcareTeam.inviteDialog.unregisteredPt.email.subject":"Invite to Physio.me from {invitingPt}","patientDetails.healthcareTeam.inviteDialog.unregisteredPt.info":"<boldSmall>{email}</boldSmall> is not yet using Physio.me.","patientDetails.healthcareTeam.inviteDialog.unregisteredPt.instruction":"Share this invitation link with your colleague from your email, or via any other media.","patientDetails.healthcareTeam.inviteDialog.unregisteredPt.sendButton":"Send by Email","patientDetails.healthcareTeam.leaveHealthcareTeamModal.leavePatientName":"Are you sure that you want to leave <strong>{patientName}\u2019s</strong> healthcare team?","patientDetails.healthcareTeam.leaveHealthcareTeamModal.leaveTeamButton":"Leave Team","patientDetails.healthcareTeam.leaveHealthcareTeamModal.patientAndHCTNotified":"The patient and the team members will be notified.","patientDetails.healthcareTeam.leaveHealthcareTeamModal.stayInTeamButton":"Stay in Team","patientDetails.healthcareTeam.leaveHealthcareTeamModal.successDetail":"You are no longer in {patientName}\u2019s healthcare team.","patientDetails.healthcareTeam.leaveHealthcareTeamModal.successSummary":"Healthcare Team Successfully Left","patientDetails.healthcareTeam.leaveHealthcareTeamModal.title":"Leave Healthcare Team","patientDetails.healthcareTeam.leaveHealthcareTeamModal.wontBeAbleToAccess":"You won\'t be able to access this patient\'s programs and statistics. However, the patient\'s account won\'t be deleted and the other members of the healthcare team will still have access.","patientDetails.healthcareTeam.listItem.status.pendingPatientValidation":"Waiting for patient\u2019s approval","patientDetails.healthcareTeam.listItem.status.pendingPatientValidation.tooltip":"Your patient must accept your colleague\'s invitation to join their healthcare team. Once completed, your colleague can then accept your invitation.","patientDetails.healthcareTeam.listItem.status.pendingPtValidation":"Waiting for colleague\u2019s approval","patientDetails.healthcareTeam.listItem.status.pendingPtValidation.tooltip":"Your colleague must accept your invitation to join this healthcare team.","patientDetails.healthcareTeam.listItem.status.unregistered":"Registration pending","patientDetails.healthcareTeam.listItem.status.unregistered.tooltip":"Your colleague has not created a Physio.me account yet. Once they have, your patient and your colleague will need to accept the invitation.","patientDetails.healthcareTeam.teamMemberTooltip":"Team members have acces to this patient information","patientDetails.healthcareTeam.teamMembersTitle":"Team Members ({count})","patientDetails.healthcareTeam.toastAlreadyJoinedError.subtitle":"You can already consult and edit this patient\u2019s profile","patientDetails.healthcareTeam.toastAlreadyJoinedError.title":"You have already joined this healthcare team.","patientDetails.healthcareTeam.toastJoinSuccess.subtitle":"You can now consult and edit {patientName, select, undefined {this patient} other {{patientName}}}\u2019s profile","patientDetails.healthcareTeam.toastJoinSuccess.title":"You have joined a healthcare team.","patientDetails.healthcareTeam.you":"(You)","patientDetails.patientPrograms.createButton":"Create a New Program","patientDetails.patientPrograms.createButtonFromTemplate":"Start from a template","patientDetails.patientPrograms.createButtonStartFromTemplate":"Start from a Template","patientDetails.patientPrograms.createProgramButton":"Create Program","patientDetails.patientPrograms.draftPanel.title":"Draft {count, plural, =0 {Program} one {Program} other {Programs}} ({count})","patientDetails.patientPrograms.draftPanel.tooltip.v1_6":"<strong>These are the programs you are currently still working on.</strong> They are saved but not started.","patientDetails.patientPrograms.duplicateAsTemplateDialog.description":"It will create a copy of this program in your template section.","patientDetails.patientPrograms.duplicateAsTemplateDialog.duplicateButton":"Duplicate","patientDetails.patientPrograms.duplicateAsTemplateDialog.label":"New template name","patientDetails.patientPrograms.duplicateAsTemplateDialog.title":"Duplicate as template","patientDetails.patientPrograms.endedPanel.title":"Ended {count, plural, =0 {program} one {program} other {programs}} ({count})","patientDetails.patientPrograms.formerPanel.tooltip.v1_6":"<strong>These programs are no longer active.</strong> They have either reached their end date or have been manually stopped.","patientDetails.patientPrograms.futurePanel.tooltip.v1_6":"<strong>These programs are ready to go!</strong> They are now just patiently waiting for their start date.","patientDetails.patientPrograms.ongoingPanel.title":"Ongoing {count, plural, =0 {program} one {program} other {programs}} ({count})","patientDetails.patientPrograms.ongoingPanel.tooltip.v1_6":"<strong>Active Program.</strong> This refers to your patient\u2019s current program being done. ","patientDetails.patientPrograms.panel.hide":"Hide","patientDetails.patientPrograms.panel.show":"Show","patientDetails.patientPrograms.programCard.description.exercisesNumber":"{count, plural, =0 {no exercises} one {# exercise} other {# exercises}}","patientDetails.patientPrograms.programCard.description.intro":"Per Week:","patientDetails.patientPrograms.programCard.description.sessionsNumber":"{count, plural, =0 {no sessions} one {# session} other {# sessions}}","patientDetails.patientPrograms.programCard.lastEdited.v1_6":"{date} by <strong>{name}</strong>","patientDetails.patientPrograms.programCard.lastEdited.v2_6":"Edited {date} by <strong>{name}</strong>","patientDetails.patientPrograms.programCard.lastEdited.you":"You","patientDetails.patientPrograms.scheduledPanel.title":"Scheduled {count, plural, =0 {Program} one {Program} other {Programs}} ({count})","patientDetails.progress.compliance.title":"Compliance","patientDetails.progress.complianceGraphSection.graphXAxisDate.oneMonth":"{month} {day1}-{day2}","patientDetails.progress.complianceGraphSection.scaleCta":"Last 8 Weeks","patientDetails.progress.complianceGraphSection.title":"Compliance <grey>(per week)</grey>","patientDetails.progress.complianceGraphSection.tooltip.v1_6":"<strong>Week {x}</strong>","patientDetails.progress.complianceSection.title":"Program Compliance","patientDetails.progress.complianceSection.tooltip":"This is the patient\'s global compliance (completed sessions/past sessions)","patientDetails.progress.complianceSection.tooltip.v2_0":"This is the patient\'s program compliance (completed sessions/past sessions)","patientDetails.progress.dropdown.endedSection":"Ended {count, plural, =0 {Program} one {Program} other {Programs}} ({count})","patientDetails.progress.dropdown.ongoingSection":"Ongoing {count, plural, =0 {program} one {program} other {programs}} ({count})","patientDetails.progress.empty.description":"You will be able to track your patient\'s progress here once they have an ongoing program","patientDetails.progress.empty.title":"Your patient has no assigned program","patientDetails.progress.emptyProgram.title":"No Program Assigned Yet","patientDetails.progress.exercisesPerWeek.title":"Exercises Per Week","patientDetails.progress.exertionGraphSection.dots.tooltip":"<strong>Session Done {date}</strong> \\n<strong>{exertion} :</strong> {exertionText}","patientDetails.progress.exertionGraphSection.dots.tooltip.noData":"<strong>Session Done {date}</strong>\\nNo data","patientDetails.progress.exertionGraphSection.dots.tooltip.noData.v2_4":"No data","patientDetails.progress.exertionGraphSection.dots.tooltip.v2_4":"<strong>{exertion} :</strong> {exertionText}","patientDetails.progress.exertionGraphSection.scaleYTooltip.v1_6":"<strong>{title}.</strong> {description}","patientDetails.progress.exertionGraphSection.sectionTooltip":"This is the level of fatigue that your patient reports feeling after a session.\\n\\n<link>Learn more</link>","patientDetails.progress.exertionGraphSection.title":"Perceived Exertion","patientDetails.progress.exertionModal.button":"Got it","patientDetails.progress.exertionModal.description.v1_6":"<strong>How does the scale work?</strong>\\n\\nAfter each session, your patient is asked to indicate their <strong>Perceived Effort</strong> on a scale.\\n\\nThe scale that your patient will use as reference is represented on the x-axis of the graph:","patientDetails.progress.exertionModal.exertionListing.v1_6":"<strong>{value}</strong> : <strong>{title}</strong>. {description}","patientDetails.progress.exertionModal.title":"Perceived Exertion Scale","patientDetails.progress.lastSessionCompleted.emptyValue":"\u2014","patientDetails.progress.lastSessionCompleted.title":"Last Session Completed","patientDetails.progress.moodGraphSection.dots.tooltip.noData":"<strong>Session Done {date}</strong>\\nNo data","patientDetails.progress.moodGraphSection.scaleYTooltip.v1_6":"<strong>{mood}</strong>","patientDetails.progress.moodGraphSection.sectionTooltip":"This is the mood that your patient feels before their session.\\n\\n<link>Learn more</link>","patientDetails.progress.moodGraphSection.title":"Mood","patientDetails.progress.moodModal.button":"Got it","patientDetails.progress.moodModal.description.v1_6":"<strong>How does the scale work?</strong>\\n\\nBefore each session, your patient is asked to indicate their <strong>mood</strong> on a scale rating.\\n\\nThe scale that your patient will use as reference is represented on the x-axis of the graph:","patientDetails.progress.moodModal.moodListing.v2_1":"<element></element><strong> : {mood}</strong>","patientDetails.progress.moodModal.title":"Mood Scale","patientDetails.progress.noOngoing.title":"Your patient\u2019s program has not started yet","patientDetails.progress.openProgramButton":"Open Program","patientDetails.progress.programCompliance.emptyValue":"\u2014%","patientDetails.progress.programProgress.tooltip.v2_0":"This is the program\'s progress","patientDetails.progress.progressCircle.ended":"Ended on <element></element>","patientDetails.progress.progressSection.title":"Progress","patientDetails.progress.schedule.title":"Schedule","patientDetails.progress.sessionsCompleted.title":"Sessions Completed","patientDetails.progress.sessionsCompleted.value":"{count}/{total}","patientDetails.progress.sessionsPerWeek.title":"Sessions Per Week","patientDetails.progress.trackersGraphSection.scaleCta":"Last 15 Completed Sessions","patientDetails.progress.trackersGraphSection.sectionTooltip":"These are data indicated by your patient before and after a session","patientDetails.progress.trackersGraphSection.title":"Patient trackers <grey>(per completed session)</grey>","patientDetails.tabs.healthcareTeam":"Healthcare Team","patientDetails.tabs.programs":"Programs","patientDetails.tabs.progress":"Progress","primereact.calendar.clear":"Clear All","primereact.calendar.dateFormat":"mm/dd/yy","primereact.calendar.dayNames":"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday","primereact.calendar.dayNamesMin":"S_M_T_W_T_F_S","primereact.calendar.dayNamesShort":"Sun_Mon_Tue_Wed_Thu_Fri_Sat","primereact.calendar.firstDayOfWeek":"0","primereact.calendar.monthNames":"January_February_March_April_May_June_July_August_September_October_November_December","primereact.calendar.monthNamesShort":"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec","primereact.calendar.today":"Today","primereact.calendar.tomorrow":"Tomorrow","primereact.calendar.yesterday":"Yesterday","programBuilder.alternativeExerciseDialog.addAlternativesButton":"Alternative Exercises","programBuilder.alternativeExerciseDialog.header":"Alternative Exercises","programBuilder.alternativeExercisePanel.noAlternativeExercisePlaceholder.mobile_title":"Add alternative exercises from","programBuilder.alternativeExercisePanel.noAlternativeExercisePlaceholder.title":"To add alternative exercises, drag & drop from","programBuilder.alternativeExercises.errors.maximumReached":"Maximum of four alternatives exercise allowed.","programBuilder.alternativeExercises.errors.oneAlreadyExists":"Adding the same exercise as alternative is not possible.","programBuilder.alternativeExercises.errors.thisAlreadyExists":"This exercise is already in the alternative ones. Adding an exercise twice is not possible.","programBuilder.alternativeExercises.infoDialog.page1.description":"Switch up your patient\u2019s routine and diversify their programs by incorporating alternative exercises. Pre-select exercises so your patients can switch them out every 4 weeks.","programBuilder.alternativeExercises.infoDialog.page1.title":"Boost patient motivation with alternative exercises. ","programBuilder.alternativeExercises.infoDialog.page2.description":"Every four weeks, your patient can swap out existing exercises for alternative ones that you have selected.\\n\\nYour patient can also remove an unsuitable exercise for an alternative one at any moment.","programBuilder.alternativeExercises.infoDialog.page2.title":"Patients can choose from the available alternative exercises.","programBuilder.alternativeExercises.infoDialog.title":"Alternative Exercise Info","programBuilder.assignTemplateBanner.v1_6":"You are now editing a program assigned to <strong>{name}</strong>","programBuilder.cantOpenFormerExerciseLibraryTooltipMessage":"You cannot add exercises to former programs","programBuilder.cantSaveBecauseAlreadySavedTooltipMessage":"This program has already been saved","programBuilder.cantSaveProgramTooltipMessage":"You cannot save an empty program","programBuilder.cantStartProgramTooltipMessage":"You cannot start an empty program","programBuilder.dayTable.addExercisesButton":"Add Exercises","programBuilder.dayTable.columnMenu.clear":"Clear session","programBuilder.dayTable.columnMenu.duplicate":"Duplicate the session","programBuilder.dayTable.duplicateDayColumnDialog.confirmButton":"Duplicate","programBuilder.dayTable.duplicateDayColumnDialog.description":"Select the day(s) where you want to duplicate {name}\'s session","programBuilder.dayTable.duplicateDayColumnDialog.header":"Duplicate {name}\'s session","programBuilder.dayTable.duplicateDayColumnDialog.tooltip.unavailableDay":"You can\u2019t duplicate on a day already filled with exercises","programBuilder.dayTable.emptyColumn":"Rest Day","programBuilder.dayTable.noExercisePlaceholder.libraryTitle":"the library","programBuilder.dayTable.noExercisePlaceholder.title":"To add an exercise, drag & drop from","programBuilder.defaultTitle.v2_1":"Program for {patientName}","programBuilder.deleteDialog.header":"Delete Program","programBuilder.deleteDialog.message":"Are you sure you wish to delete this program? It will be permanently removed from the patient\'s profile.","programBuilder.editEndedProgramButton.v2_1":"Duplicate as Draft","programBuilder.editOngoingProgramButton.v2_1":"Update","programBuilder.editOngoingProgramDialog.confirmDialog.sessionDoneContentChanged.message":"Some session(s) that you have updated have already been completed by your patient.\\n\\nThis specific modifications will be effective starting next week within your patient\u2019s app.","programBuilder.editOngoingProgramDialog.confirmDialog.sessionOrderChanged.confirmButtonLabel":"Confirm Update","programBuilder.editOngoingProgramDialog.confirmDialog.sessionOrderChanged.message":"Any changes to the sessions will be effective starting next week within your patient\u2019s app.","programBuilder.editOngoingProgramDialog.confirmDialog.title.v2_0":"Confirm Your Changes","programBuilder.editScheduleProgramButton.v2_1":"Update","programBuilder.exerciseCard.addAlternative":"{alternativesCount, plural, =0 {Alternative exercise} one {1 Alternative exercise} other {# Alternative exercises}}","programBuilder.exerciseCard.complementaryExercises":"Complementary Exercises","programBuilder.exerciseCard.delete":"Delete","programBuilder.exerciseCard.details":"See details","programBuilder.exerciseCard.duplicate":"Duplicate exercise","programBuilder.mobileExerciseLibraryDialog.addButton":"Add{count, plural, =0 {} other { #}}","programBuilder.mobileExerciseLibraryDialog.addButton.alternativeExercises":"Add Alternative Exercises ({count})","programBuilder.mobileExerciseLibraryDialog.addButton.complementaryExercises":"Add Complementary Exercises ({count})","programBuilder.popupMenu.deleteProgram":"Delete Program","programBuilder.popupMenu.stopProgram":"Stop Program","programBuilder.programStatus.draft":"Draft","programBuilder.programStatus.ended.v2_1":"Ended","programBuilder.programStatus.ongoing.v2_1":"Ongoing","programBuilder.programStatus.scheduled.v2_1":"Scheduled","programBuilder.renameProgramDialog.newName.label":"New name","programBuilder.renameProgramDialog.newName.placeholder":"Program","programBuilder.renameProgramDialog.saveButton":"Ok","programBuilder.renameProgramDialog.title":"Rename Program","programBuilder.saveButton":"Save","programBuilder.saveButton.errorToast.message":"We were unable to save your changes. Please try again","programBuilder.saveButton.errorToast.title":"An error has occurred","programBuilder.saveButton.successToast.message":"You will find it in the \u201Cdraft\u201D section of your patient page","programBuilder.saveButton.successToast.title":"Program saved","programBuilder.scheduleDialog.addShortcut":"Add {month} months","programBuilder.scheduleDialog.calendarFooter":"Your program always end on {endDay} to let your Patient enough time to complete their weekly session.","programBuilder.scheduleDialog.endDate.label":"End date","programBuilder.scheduleDialog.endDate.required":"Select an end date to start the program","programBuilder.scheduleDialog.endDatePlaceholder":"Select end date","programBuilder.scheduleDialog.endDateTooltip":"You can only extend the program up to 24 months from now. Come back after your patient\u2019s next assessment to further extend the program.","programBuilder.scheduleDialog.endingSoonAlert.message":"Extend the program until the next assessment and keep {patientName} in motion!","programBuilder.scheduleDialog.endingSoonAlert.title":"The Program Will End {remainingDays, plural, =0 {today} one {in 1 day} other {in # days}}","programBuilder.scheduleDialog.header":"Schedule the Program","programBuilder.scheduleDialog.inShortcut":"In {month} months","programBuilder.scheduleDialog.okButton":"Ok","programBuilder.scheduleDialog.startButton":"Start program","programBuilder.scheduleDialog.updateProgramButton":"Update Program","programBuilder.startButton":"Start","programBuilder.startDialog.error":"Unable to start. Please try again","programBuilder.startDialog.errorToast.message":"We were unable to start your program, please try again","programBuilder.startDialog.errorToast.nameTooLongMessage":"Your patient\'s program name exceeds authorized max length","programBuilder.startDialog.errorToast.title":"An error has occurred","programBuilder.startDialog.overlapWarn.v1_6":"This range is unavailable. {name} already has a program planned <strong>between the {startDate} and the {endDate}.</strong>","programBuilder.startDialog.programName.label":"Program Name","programBuilder.startDialog.programName.placeholder":"Program","programBuilder.startDialog.startingDate.invalid":"Invalid date","programBuilder.startDialog.startingDate.label":"Starting Date","programBuilder.startDialog.startingDate.required":"Please enter a starting date","programBuilder.startDialog.successToast.message":"Your patient will be notified shortly","programBuilder.startDialog.successToast.title":"Program successfully started","programBuilder.startDialog.weeks.duration":"Duration: {duration}","programBuilder.stopDialog.header":"Stop Program","programBuilder.stopDialog.message":"Are you sure you wish to stop this program? Stopping will end program and your patient will no longer have any planned physical sessions.","programBuilder.quickstart.intro":"Learn how to build engaging exercise programs in 6 simple steps.","programBuilder.quickstart.title":"Quickstart","programBuilder.quickstart.step.addFirstExercise":"Add first exercise","programBuilder.quickstart.step.filterLibrary":"Filter the exercise library","programBuilder.quickstart.step.addComplementaryExercises":"Add complementary exercises","programBuilder.quickstart.step.addAlternativeExercises":"Add alternative exercises","programBuilder.quickstart.step.addAlternativeExercises.guide02":"Keep the routine exciting by adding up to 4 alternative exercises to keep your patient engaged and motivated!","programBuilder.quickstart.step.addAlternativeExercises.guide03":"The Library is now filtered to show exercises similar to the one you just selected. Choose up to 4 alternatives to add variety and keep sessions engaging.","programBuilder.quickstart.step.addAlternativeExercises.guide04":"Great choice to keep your patients motivated! Click the info icon to see how it works for them.","programBuilder.quickstart.step.duplicateSession":"Duplicate a session","programBuilder.quickstart.step.duplicateSession.guide02":"Duplicate a session if you want your patient to repeat it multiple times a week.","programBuilder.quickstart.step.startProgram":"Start the program","programBuilder.quickstart.pill":"Quickstart","programBuilder.quickstart.pillCount":"{completedCount}/{totalCount}","programBuilder.quickstart.guide.addFirstExercise":"Start by dragging an exercise from the library onto a day to create your session.","programBuilder.quickstart.guide.searchAndFilter":"Quickly find the perfect exercises for your patients by exploring our extensive library with the search and filter options.","programBuilder.quickstart.guide.applyFilters":"Apply filters to view only the exercises that match your criteria.","programBuilder.quickstart.step.startTemplate.guide01":"Once your program is ready, assign it to a patient and start it with a timeline to help them begin moving.","programBuilder.quickstart.step.startDraft.guide01":"Once your program is ready, assign it to a patient and start it with a timeline to help them begin moving.","programBuilder.quickstart.step.startGuide02":"Pro tip: Set an end date several months ahead. You can easily extend it anytime to continue tracking your patient\'s progress.","programBuilder.updateFutureProgramDialog.successToast.message":"\u201C{program}\u201D has been updated.","programBuilder.updateFutureProgramDialog.successToast.title":"Program updated","program_builder_-_Draft.Session.Title":"Side-lying push ups ","program_builder_-_Draft.Session.Title.34":"Elbow warm-up","register.accountCreation.email.formatError":"This email address is invalid","register.accountCreation.email.label":"Email Address","register.accountCreation.email.placeholder":"Email address...","register.accountCreation.email.userExistsError":"This email has already used. If this is you, try <link> logging in here </link>","register.accountCreation.header":"Create Your Account","register.accountCreation.header.subtitle":"Our online platform is dedicated to healthcare professionals.\\nPatients can utilize our services by <link>download the patient app</link>.","register.accountCreation.invitation.header":"Join {ptName} to help support common patients on Physio.me","register.accountCreation.invitation.multiple.header":"Join the healthcare team of your patients on Physio.me","register.accountCreation.invitation.physiome.description":"Support your patients suffering from a neuromuscular disease with an innovative physical training Mobile App. <link>Learn more</link>","register.accountCreation.invitation.physiome.description.withoutLink":"Support your patients living with neuromuscular disease with an innovative physical training Mobile App.","register.accountCreation.invitation.physiome.title":"What is Physio.me?","register.accountCreation.registerAsPT.header":"Register as a Physical Therapist","register.accountCreation.registerButton.pt":"Register","register.accountCreation.registerInvitedByPT.header":"Join {name} in supporting your shared patients on Physio.me","register.accountCreation.requestType.label":"Request Topic","register.accountCreation.requestType.patientMessage":"I have a neuromuscular disease and want to download the training app","register.accountCreation.requestType.ptMessage":"I am a healthcare professional and want to access the practitioner platform","register.accountCreation.submitButton.patient":"Discover The App","register.accountCreation.submitButton.patient.android":"Discover the Android app","register.accountCreation.submitButton.patient.ios":"Discover the iOS app","register.accountCreation.submitButton.pt":"Continue","register.alreadyHaveAccount":"Already have an account? <link>Log in</link>","register.completed.button":"Access the Limited Version","register.completed.card.description":"This process can take up to 48 hours (working days)","register.completed.description":"We will get back to you shortly with our decision.","register.completed.header":"Thanks For Registering!","register.completed.pending.approval.bullet1":"<strong>Manage your patient profiles</strong>, create new ones and invite new patients to join Physio.me.","register.completed.pending.approval.bullet2":"<strong>Assign programs to your patients</strong> and start your programs.","register.completed.pending.approval.header":"Pending Approval","register.completed.pending.approval.note1":"Thank you! Our admins will review your request within 48 working hours.","register.completed.pending.approval.note2":"Once validated, you will be able to:","register.countrySelection.countryDropdown.CountryAndLanguage":"{country} ({language})","register.countrySelection.countryDropdown.emptyMessage":"No country is available","register.countrySelection.countryDropdown.label":"Country of Practice","register.countrySelection.submitButton":"Sign Up","register.description.checkidentity.note1":"To follow <strong>efficient security policies</strong> regarding individuals who prescribe care to patients, <strong>we are required to validate your identity</strong> as it relates to your status as a healthcare professional.","register.description.checkidentity.note2":"Your information is confidential and used strictly to validate your professional status. <strong>Biogen does not use your personal data</strong> for any other purposes.","register.description.checkidentity.title":"Why Do We Need to Verify Your Identity?","register.description.professionalinformation.note1":"To follow <strong>efficient security policies</strong> regarding individuals who prescribe care to patients, we are <strong>required to validate your status</strong> as a healthcare professional.","register.description.professionalinformation.note2":"Your information is confidential and used strictly to validate your professional status. <strong>Biogen does not use your personal data</strong> for any other purposes.","register.description.professionalinformation.title":"Why Do We Need to Validate Your Profession?","register.description.subTitle":"Physio.me Is a Digital Solution Allowing Physical Therapists to Assign Personalised Exercise Programs for NMD Patients.","register.emailConfirmation.activationCode.label":"Activation code","register.emailConfirmation.confirmationCode.btnResendCode":"Resend Code","register.emailConfirmation.confirmationCode.invalidError":"This code is not valid","register.emailConfirmation.confirmationCode.label":"Confirmation code","register.emailConfirmation.confirmationCode.resendCode":"Didn\u2019t receive the confirmation email? <link>Resend email</link>","register.emailConfirmation.confirmationCode.resendCode.v2_5":"Didn\'t receive activation code, please check your <strong>spam folder.</strong>","register.emailConfirmation.description.v1_6":"We have sent you a confirmation code at <strong>{email}</strong>.\\nYou may reset your password by entering the code below.","register.emailConfirmation.description.v2_5":"We have just sent an email to","register.emailConfirmation.enterInvitationCode":"Please enter your invitation code to confirm your email","register.emailConfirmation.header":"Confirm Your Email","register.emailConfirmation.resendCode.errorToast.message":"Please try again","register.emailConfirmation.resendCode.errorToast.title":"We were unable to send email.","register.emailConfirmation.resendCode.successToast.title":"Email successfully sent","register.fastTrack.completed.fastTrack.button":"Go To Dashboard","register.fastTrack.completed.fastTrack.description":"Based on your information you have provided, we have successfully validated you as a healthcare professional. \\n\\nYou may now start using Physio.me to provide the appropriate exercises and follow-ups to your patients living with neuromuscular diseases.","register.fastTrack.completed.title":"Dear Physical Therapist","register.introduction.cta.back":"Do it Later","register.introduction.description":"<boldSmall>Physio.me</boldSmall> is a digital platform that contains patient health data. To ensure patient privacy, we must verify that your identity is real and you\'re a licensed healthcare professional.","register.introduction.requirements.id":"A <boldSmall>valid ID document</boldSmall> (e.g., passport, driver\'s license)","register.introduction.requirements.license":"Your <boldSmall>Professional License Number</boldSmall> (e.g: {licenses})","register.introduction.requirements.title":"Kindly provide:","register.introduction.title":"Validate Your Account","register.nameStep.cta":"Access Physio.me","register.Information.description":"Tell us more about yourself to personalize your experience.","register.Information.title":"Complete Your Information","register.professionalInfo.city.label":"City of Practice","register.professionalInfo.city.placeholder":"City of Practice...","register.professionalInfo.firstName.label":"First Name","register.professionalInfo.firstName.placeholder":"First Name...","register.professionalInfo.header":"Your Professional Information","register.professionalInfo.idType.label":"Type of Identification","register.professionalInfo.idValue.tooltip.contactSupport":"If you have an issue, you can contact our <link>customer support</link>","register.professionalInfo.lastName.label":"Last Name","register.professionalInfo.lastName.placeholder":"Last Name...","register.professionalInfo.medicalExpertise.label":"Medical Profession","register.professionalInfo.postalCode.errorText":"Invalid postal/zip code","register.professionalInfo.postalCode.label":"Postal Code","register.professionalInfo.postalCode.placeholder":"00000","register.professionalInfo.submitButton":"Next","register.progressionBar.accountCreation":"Account Creation","register.progressionBar.done":"Done","register.progressionBar.emailConfirmation":"Email Confirmation","register.progressionBar.identityVerification":"Identity Verification","register.progressionBar.introduction":"Introduction","register.progressionBar.professionalInfo":"Professional Information","register.rejected-pt.contact-button":"Contact Customer Service","register.rejected-pt.logout":"Log out","register.rejected-pt.subtitle":"We are unable to confirm your registration with the provided information. Please contact Customer Service for further assistance.","register.rejected-pt.title":"Your account could not be validated","restrictedDialog.incompleteStatus.addPatient.title":"Validate your Account to Add Patients","restrictedDialog.incompleteStatus.assignTemplate.title":"Validate your Account to Assign Programs to Your Patients","restrictedDialog.incompleteStatus.closeDialogButton":"Skip for Now","restrictedDialog.incompleteStatus.description":"We need to validate your professional status and identity to ensure patient safety before you can manage their programs on Physio.me.","restrictedDialog.incompleteStatus.validateAccountButton":"Validate my Account","restrictedDialog.pendingStatus.closeDialogButton":"Got It","restrictedDialog.pendingStatus.description":"You can add patients and manage their programs as soon as your account is validated. We\'re currently reviewing your information and will get back to you by email within 48 working hours.","restrictedDialog.pendingStatus.title":"Your Account is Pending Approval","searchFilter.searchInputPlaceholder":"Search by name, muscle, limb...","settings.AccountValidatedAccountCard.message":"You now have full access to manage and invite patients, assign programs, and start your sessions.","settings.AccountValidatedAccountCard.title":"Account Validated","settings.accountTab.credentialsSection.editButton":"Edit Your Password","settings.accountTab.credentialsSection.emailAddress":"Email Address","settings.accountTab.credentialsSection.password":"Password","settings.accountTab.credentialsSection.title":"Credentials","settings.accountTab.deleteSection.cta":"Delete your account","settings.accountTab.deleteSection.description":"Permanently delete your account and leave your patients\u2019 healthcare teams.","settings.accountTab.deleteSection.title":"Delete Account","settings.accountTab.editInfoDialog.header":"Edit Your Information","settings.accountTab.editInfoDialog.successToast.detail":"Information successfully changed.","settings.accountTab.editLanguageDialog.header":"Edit Your Language","settings.accountTab.editLanguageDialog.successToast.detail":"Language successfully changed.","settings.accountTab.editPasswordDialog.currentPassword.invalidError":"Your current password is incorrect","settings.accountTab.editPasswordDialog.currentPassword.label":"Current Password","settings.accountTab.editPasswordDialog.currentPassword.placeholder":"Enter your current password","settings.accountTab.editPasswordDialog.header":"Modify Your Password","settings.accountTab.editPasswordDialog.newPassword.label":"New Password","settings.accountTab.editPasswordDialog.newPassword.placeholder":"Enter a new password","settings.accountTab.editPasswordDialog.successToast.detail":"Password successfully changed.","settings.accountTab.header":"Account","settings.accountTab.languageSection.editButton":"Edit your language","settings.accountTab.languageSection.title":"Language","settings.accountTab.professionalInformationSection.cityOfPractice":"City of Practice","settings.accountTab.professionalInformationSection.editButton":"Edit Your Information","settings.accountTab.professionalInformationSection.firstName":"First Name","settings.accountTab.professionalInformationSection.lastName":"Last Name","settings.accountTab.professionalInformationSection.medicalProfession":"Medical Profession","settings.accountTab.professionalInformationSection.postalCode":"Postal Code","settings.accountTab.professionalInformationSection.postalCode.errorMessage":"Invalid postal/zip code","settings.accountTab.professionalInformationSection.professionalNumber":"Professional Number","settings.accountTab.professionalInformationSection.title":"Professional Information","settings.accountTab.professionalInformationSection.typeOfIdentification":"Type of Identification","settings.leavingReasons.consequences.one.description":"All your personal data and account details will be permanently deleted.","settings.leavingReasons.consequences.one.title":"Once done, it\'s final","settings.leavingReasons.consequences.three.description":"Ongoing programs can be pursued until their end date.","settings.leavingReasons.consequences.three.title":"Your patients can\u2019t continue their programs once they are over","settings.leavingReasons.consequences.title":"Make sure to keep this in mind before deleting your account:","settings.leavingReasons.consequences.two.description":"Be sure to save any important information before you delete.","settings.leavingReasons.consequences.two.title":"You will lose access to your patients\u2019 programs and their progress","settings.leavingReasons.consequencesAcknowledgement":"I want to delete my account and I understand the consequences","settings.leavingReasons.deleteCTA":"Delete Account","settings.leavingReasons.header.title":"Delete your account","settings.leavingReasons.helpSection.description":"Our help center and our friendly support team are here to help you get the most out of Physio.me.","settings.leavingReasons.helpSection.helpCenter":"Help Center","settings.leavingReasons.helpSection.title":"Need help with Physio.me?","settings.leavingReasons.instructions.subtitle":"Optional, select up to 3 reasons","settings.leavingReasons.instructions.title":"Before you go, please tell us why are you leaving Physio.me.","settings.manageCookiesButton":"Manage my cookies settings","settings.notificationPreferences":"Notification Preferences","settings.notificationPreferences.checkboxes.biogenEmails":"I agree to receive emails from <strong>Biogen</strong>","settings.notificationPreferences.checkboxes.hctInvitationAccepted":"A professional has joined a healthcare team of which you are a member","settings.notificationPreferences.checkboxes.monthlyRecap":"Patient Progress Monthly Recap","settings.notificationPreferences.checkboxes.patientProgramEnded":"A patient finished a program","settings.notificationPreferences.checkboxes.patientProgramEndingSoon":"A patient has almost finished a program (14 days before the end date)","settings.notificationPreferences.checkboxes.patientProgramStarted":"A patient started a new program","settings.notificationPreferences.checkboxes.patientRegistered":"A patient completed his/her registration","settings.notificationPreferences.checkboxes.physiomeEmails":"I agree to receive emails from <strong>Physio.me</strong>","settings.notificationPreferences.emailColumn":"Email","settings.notificationPreferences.save.errorToast.message":"We were unable to save your changes. Please try again.","settings.notificationPreferences.save.errorToast.title":"An error has occurred","settings.notificationPreferences.save.successToast.message":"Your changes have been updated.","settings.notificationPreferences.save.successToast.title":"Notification preferences saved","settings.notificationPreferences.saveButton":"Save","settings.notificationPreferences.title.hctRelated":"Healthcare Team Related","settings.notificationPreferences.title.patientRelated":"Patient Related","settings.notificationPreferences.title.physiomeUpdates":"Physio.me Updates","settings.notificationPreferences.webColumn":"Web","survey.popup.nps.body":"Share your impressions to help us improve your experience!","survey.popup.nps.cta.notNow":"Not Now","survey.popup.nps.cta.shareYourFeedback":"Share Your Feedback","survey.popup.nps.title":"Your Voice Matters","survey.popup.thankYou.body":"Your feedback is important to help create better experience for you and people living with neuromuscular disease in the future.","survey.popup.thankYou.title":"Thank you!","tabbar.about":"About","tabbar.exercises":"Exercises","tabbar.exercises.mobile":"Exercises","tabbar.learn":"Learn","tabbar.learn.mobile":"Learn","learn.hero.title":"Shape the Future:","learn.hero.subtitle":"Advance your skills in treating Neurodegenerative and rare disease patients.","learn.empty.title":"No Content Available Yet","learn.empty.subtitle":"Our Learn section is awaiting its first contents. Stay tuned for upcoming contents and insights.","learn.tab.all":"All","learn.tab.articles":"Articles","learn.tab.videos":"Videos","learn.tab.podcasts":"Podcasts","learn.Feedback.title":"Did You Enjoy This Content?","learn.References.title":"References","tabbar.faq":"FAQ","tabbar.getStarted":"Get Started ({completedCount}/{totalCount})","tabbar.getStarted.mobile":"Get Started","tabbar.logout":"Log Out","tabbar.patients":"Patients","tabbar.patients.demoMode.tooltip":"Invite your patients once your access has been granted.","tabbar.patients.mobile":"Patients","tabbar.privacyNotice":"Privacy Notice","tabbar.programTemplates":"Program Templates","tabbar.programTemplates.mobile":"Template","tabbar.programs":"Programs","tabbar.programs.mobile":"Programs","tabbar.settings":"Settings","tabbar.tab1":"Patients","tabbar.tab1.mobile":"Patients","tabbar.tab2":"Program Templates","tabbar.tab2.mobile":"Template","tabbar.termsOfUse":"Terms of Use","templateBuilder.assignButton":"Assign","templateBuilder.assignTemplateDialog.loading":"Creating a program for {name} from the template...","templateBuilder.assignTemplateDialog.loading.v2_6":"Assigning this program to {name}","templateBuilder.assignTemplateDialog.patientInput.emptyList":"There is no one with this name in this list.","templateBuilder.assignTemplateDialog.patientInput.footerMessage":"Patients must complete their registration before templates can be assigned to them.","templateBuilder.assignTemplateDialog.patientInput.incorrectPatient":"This name does not exist in your patient list","templateBuilder.assignTemplateDialog.patientInput.label":"Assign To...","templateBuilder.assignTemplateDialog.patientInput.placeholder":"Enter a patient name","templateBuilder.assignTemplateDialog.submitButton":"Assign","templateBuilder.assignTemplateDialog.title":"Assign to a Patient","templateBuilder.cantAssignNotSavedTemplateTooltipMessage":"You cannot assign an unsaved template","templateBuilder.cantAssignTemplateTooltipMessage":"You cannot assign an empty template","templateBuilder.cantSaveBecauseAlreadySavedTooltipMessage":"This template has already been saved","templateBuilder.cantSaveEmptyTemplateTooltipMessage":"This template is empty","templateBuilder.defaultTitle.v2_1":"Undefined","templateBuilder.demoMode.cantAssignTemplate.tooltip":"Assign a program to your patients once your access has been granted.","templateBuilder.popupMenu.deleteTemplate":"Delete Template","templateBuilder.renameProgramDialog.newName.label":"New name","templateBuilder.renameProgramDialog.newName.placeholder":"Template","templateBuilder.renameProgramDialog.saveButton":"Save","templateBuilder.renameProgramDialog.title":"Rename Template","templateBuilder.saveButton":"Save","templateBuilder.saveButton.asTemplate":"Save as Template","templateBuilder.saveButton.errorToast.message":"We were unable to save your modifications, please try again","templateBuilder.saveButton.errorToast.title":"An error has occurred","templateBuilder.saveButton.successToast.message":"You will find it in the \u201CProgram Templates\u201D section","templateBuilder.saveButton.successToast.message.v2_6":"Find your template on the \u201CPrograms\u201D page under the \u201CTemplates\u201D tab.","templateBuilder.saveButton.successToast.title":"Template saved","templateBuilder.statusMessage":"Template","templateBuilder.statusMessage.newProgram":"New Program","templateBuilder.templateNameDialog.description":"Save this program as a template to easily reuse it for your patients.","templateBuilder.templateNameDialog.nameInput.label":"Template Name","templateBuilder.templateNameDialog.nameInput.placeholder":"Template","templateBuilder.templateNameDialog.saveButton":"Save","templateBuilder.templateNameDialog.saveButton.v2_6":"Save Template","templateBuilder.templateNameDialog.title":"Save template","templateBuilder.templateNameDialog.title.v2_6":"Save as Template","templateBuilder.templateNotFoundError":"We were unable to load the page.\\nThe template cannot be found or does not exist.","templateListing.createProgramButton":"Create Program","templateListing.createTemplatebutton":"Create a New Template","templateListing.empty.description":"Your Program Templates list is\\ncurrently empty","templateListing.empty.description.v2_6":"Design tailored exercise programs\u2028for your patients in minutes.","templateListing.empty.title":"Create Your First Program","templateListing.error.description":"We were unable to load the data. Please try again.","templateListing.errorToast.description":"Impossible to update the listing. Please try again later","templateListing.mobileTitle":"Templates","templateListing.noPrograms.description":"You haven\'t assigned a program to your patients yet.\\nCreate a personalized program now or use one of your templates!","templateListing.noPrograms.title":"Ready to Assign Programs to\xa0Your\xa0Patients?","templateListing.noTemplates.description":"Templates let you create programs that can be easily referenced, duplicated, and assigned quickly. Just click \\"Save as Template\\" when creating or viewing a program.","templateListing.noTemplates.title":"Streamline Your Workflow With\xa0Program Templates","templateListing.programs.emptySearch.description":"We couldn\u2019t find any assigned program matching your search criteria. Check spelling or use different keywords.","templateListing.programs.emptySearch.title":"No Assigned Programs Found","templateListing.programs.searchInputPlaceholder":"Search assigned programs","templateListing.programs.sort.lastEdited":"Last edited","templateListing.programs.sort.patientName":"Patient name","templateListing.programs.sort.programName":"Program name","templateListing.programs.tabName":"Assigned Programs ({count})","templateListing.searchFilter.filters":"Filters:","templateListing.sortLabel":"Sort by","templateListing.templateCard.option.edit":"Edit Template","templateListing.templates.emptySearch.description":"We couldn\u2019t find any program template matching your search criteria. Check spelling or use different keywords.","templateListing.templates.emptySearch.title":"No Templates Found","templateListing.templates.searchInputPlaceholder":"Search program templates","templateListing.templates.sort.lastEdited":"Last edited","templateListing.templates.sort.templateName":"Template name","templateListing.templates.tabName":"Templates ({count})","templateListing.title":"My Program Templates ({count})","templateListing.title.tooltip":"Templates allow you to create programs that can easily be used as reference, be duplicated and assigned quickly.","templateListing.viewTemplatesButton":"View Templates","templateListingDialog.empty.description":"Create a template to assign it to a patient.","templateListingDialog.empty.title":"Your program template lists are currently empty","templateListingDialog.error":"We were unable to load the data.\\nPlease try again.","templateListingDialog.title":"Choose from Your Templates","tutorialBanner.cta":"Watch The Tutorial","tutorialBanner.hct":"Learn how to invite your patient\u2019s care team.","tutorialBanner.monitorProgram":"Learn how to monitor your patient\u2019s progress.","mediaContent.feedback.thanks":"Thank You for Your Feedback!","videoPlayer.error":"The video player stopped working due to a network error.\\nPlease check your internet settings and try again."}');

});


parcelRegister("jTpg0", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});


parcelRegister("7SbDW", function(module, exports) {

$parcel$export(module.exports, "TranslationsService", () => $b17ea8b101369173$export$a26951af1d69b8f1);

var $2bI8n = parcelRequire("2bI8n");

var $aEup4 = parcelRequire("aEup4");

var $bXTqq = parcelRequire("bXTqq");

var $04Qjn = parcelRequire("04Qjn");

var $cHzXx = parcelRequire("cHzXx");
class $b17ea8b101369173$export$a26951af1d69b8f1 {
    constructor(axiosInstanceProvider, serverConfigService, apiService){
        this.axiosInstanceProvider = axiosInstanceProvider;
        this.serverConfigService = serverConfigService;
        this.apiService = apiService;
        this.axiosInstance = this.initiateAxiosInstance();
    }
    initiateAxiosInstance() {
        const axiosInstance = this.axiosInstanceProvider();
        (0, $aEup4.addResponseInterceptor)(axiosInstance, (0, $2bI8n.errorHandlingInterceptor)());
        return axiosInstance;
    }
    async fetchWordings(lastUpdateDate) {
        try {
            const serverConfig = this.serverConfigService.serverConfig;
            const result = await this.axiosInstance.get(serverConfig.translations.url, {
                headers: {
                    "if-modified-since": lastUpdateDate
                }
            });
            return {
                translations: (0, $bXTqq.localeKeysToIntlLocale)(result.data),
                versionDate: result.headers["last-modified"]
            };
        } catch (e) {
            if ((0, $04Qjn.isApiError)(e) && e.status === 304) throw new (0, $cHzXx.TranslationsAlreadyUpToDateError)(e.message);
            throw e;
        }
    }
    async fetchWeekdaysConfig() {
        const result = await this.apiService.get("/localization/weekdays-config");
        return result.data;
    }
}

});

parcelRegister("lAOzn", function(module, exports) {

$parcel$export(module.exports, "ServiceInitPriority", () => $6357a1ed0fd2d46e$export$a952b91f29424803);
$parcel$export(module.exports, "ServicesManager", () => $6357a1ed0fd2d46e$export$ee6b90922de2dec9);

var $eOSo1 = parcelRequire("eOSo1");
var $6357a1ed0fd2d46e$export$a952b91f29424803;
(function(ServiceInitPriority) {
    ServiceInitPriority["Critical"] = "Critical";
    ServiceInitPriority["High"] = "High";
    ServiceInitPriority["Normal"] = "Normal";
})($6357a1ed0fd2d46e$export$a952b91f29424803 || ($6357a1ed0fd2d46e$export$a952b91f29424803 = {}));
class $6357a1ed0fd2d46e$export$ee6b90922de2dec9 {
    constructor(services){
        this.services = services;
        this.logger = (0, $eOSo1.getLogger)("\uD83D\uDDC2\uFE0F [ServicesManager]");
    }
    async initServices() {
        this.logger.debug("----------- Starting app services INIT --------------");
        const byPriority = (priority)=>(service)=>(service[2] ?? "Normal") === priority;
        const criticalServices = this.services.filter(byPriority("Critical"));
        for (const [service, serviceName] of criticalServices)await this.initService(service, serviceName);
        await Promise.all(this.services.filter(byPriority("High")).map(async ([service, serviceName])=>await this.initService(service, serviceName)));
        await Promise.all(this.services.filter(byPriority("Normal")).map(async ([service, serviceName])=>await this.initService(service, serviceName)));
        this.logger.debug("----------- App services INIT: DONE --------------");
    }
    async initService(service, serviceName) {
        this.logger.debug(`Initing service ${serviceName}`);
        try {
            await service.init();
            this.logger.debug(`Service ${serviceName} - Inited`);
        } catch (error) {
            this.logger.error(`Could not init service ${serviceName}:`, error);
        }
    }
}

});

parcelRegister("av31l", function(module, exports) {

$parcel$export(module.exports, "AnalyticsDimensionsManager", () => $aaf8d747d30056ba$export$9e211e97cef2c87d);

var $lTdpc = parcelRequire("lTdpc");

var $kXaMn = parcelRequire("kXaMn");

var $auPqo = parcelRequire("auPqo");

var $cM7bY = parcelRequire("cM7bY");
const $aaf8d747d30056ba$var$HARDCODED_USER_STATUS = "physio";
class $aaf8d747d30056ba$export$9e211e97cef2c87d {
    constructor(analyticsService, userManager, localeManager){
        this.analyticsService = analyticsService;
        this.userManager = userManager;
        this.localeManager = localeManager;
        userManager.user.subscribe((user)=>{
            this.updateAnalyticsId(user);
            this.computeCustomDimensions();
        });
        userManager.onUserFirstConnection.addOnce(()=>{
            this.analyticsService.trackEvent({
                category: (0, $auPqo.AnalyticsCategory).REGISTRATION,
                action: "physioOnboarding"
            });
        });
    }
    updateAnalyticsId(user) {
        if ((0, $lTdpc.isNotNil)(user)) {
            this.analyticsService.setUserId(user.analyticsId);
            return;
        }
        this.analyticsService.setUserId(null);
    }
    computeCustomDimensions() {
        const user = this.userManager.user.get();
        this.analyticsService.setCustomDimension((0, $cM7bY.CustomDimensions).registrationDate, user ? (0, $kXaMn.dateToDateDto)(user.creationDate) : null);
        this.analyticsService.setCustomDimension((0, $cM7bY.CustomDimensions).userCountry, user?.country.toLowerCase() ?? null);
        this.analyticsService.setCustomDimension((0, $cM7bY.CustomDimensions).envStatus, "prod" ?? null);
        this.analyticsService.setCustomDimension((0, $cM7bY.CustomDimensions).userEnv, $aaf8d747d30056ba$var$HARDCODED_USER_STATUS);
        this.analyticsService.setCustomDimension((0, $cM7bY.CustomDimensions).platformLanguage, this.localeManager.locale.get().toLowerCase());
        this.analyticsService.setCustomDimension((0, $cM7bY.CustomDimensions).deviceLanguage, this.localeManager.getNavigatorLocale().toLowerCase());
        this.analyticsService.setCustomDimension((0, $cM7bY.CustomDimensions).loginStatus, (0, $lTdpc.isNotNil)(user) ? "logged" : "anonymous");
        if ((0, $lTdpc.isNotNil)(user)) {
            this.analyticsService.setCustomDimension((0, $cM7bY.CustomDimensions).isTester, user.isTester.toString());
            this.analyticsService.setCustomDimension((0, $cM7bY.CustomDimensions).isReviewer, user.isReviewer.toString());
        }
    }
}

});
parcelRegister("kXaMn", function(module, exports) {

$parcel$export(module.exports, "WEEK_LENGTH", () => $604faeb459bdaf6e$export$642081d4c01a5386);
$parcel$export(module.exports, "TWO_WEEKS_IN_DAYS", () => $604faeb459bdaf6e$export$49e1422e085b8504);
$parcel$export(module.exports, "ONE_MONTH_IN_DAYS", () => $604faeb459bdaf6e$export$2487981a941b87c3);
$parcel$export(module.exports, "TWO_MONTH_IN_DAYS", () => $604faeb459bdaf6e$export$82425425a9ee0ff8);
$parcel$export(module.exports, "now", () => $604faeb459bdaf6e$export$461939dd4422153);
$parcel$export(module.exports, "nowAsStartOfDay", () => $604faeb459bdaf6e$export$cf9a172f632f0861);
$parcel$export(module.exports, "datesAreOnSameDay", () => $604faeb459bdaf6e$export$8d6f3e598a4b7ded);
$parcel$export(module.exports, "dateIsBeforeOrSameAs", () => $604faeb459bdaf6e$export$5f0df70d91bdafda);
$parcel$export(module.exports, "addDaysToDate", () => $604faeb459bdaf6e$export$13cf42d631545d33);
$parcel$export(module.exports, "dateToDateDto", () => $604faeb459bdaf6e$export$4a2609371b513462);
$parcel$export(module.exports, "dateFromDateDto", () => $604faeb459bdaf6e$export$869b91e18a098fa4);
$parcel$export(module.exports, "computeDiffInDays", () => $604faeb459bdaf6e$export$9a49e8192a6765c4);
$parcel$export(module.exports, "computeDiffBetween", () => $604faeb459bdaf6e$export$7e4828645d85b43b);
$parcel$export(module.exports, "dateRangesOverlap", () => $604faeb459bdaf6e$export$6129c42600c8bfaf);
$parcel$export(module.exports, "daysToMonth", () => $604faeb459bdaf6e$export$c082e797153cad7e);
parcelRequire("92qf1");

var $cD3aa = parcelRequire("cD3aa");
const $604faeb459bdaf6e$var$BACKEND_DATE_FORMAT = "YYYY-MM-DD";
const $604faeb459bdaf6e$export$642081d4c01a5386 = 7;
const $604faeb459bdaf6e$export$49e1422e085b8504 = 14;
const $604faeb459bdaf6e$export$2487981a941b87c3 = 30;
const $604faeb459bdaf6e$export$82425425a9ee0ff8 = 60;
const $604faeb459bdaf6e$export$461939dd4422153 = (0, (/*@__PURE__*/$parcel$interopDefault($cD3aa)));
const $604faeb459bdaf6e$export$cf9a172f632f0861 = ()=>$604faeb459bdaf6e$export$461939dd4422153().startOf("day");
function $604faeb459bdaf6e$export$8d6f3e598a4b7ded(date1, date2) {
    return date1.isSame(date2, "date");
}
const $604faeb459bdaf6e$export$5f0df70d91bdafda = (date1, date2)=>date1.isBefore(date2, "date") || date1.isSame(date2, "date");
function $604faeb459bdaf6e$export$13cf42d631545d33(date, days) {
    return date.add(days, "days");
}
function $604faeb459bdaf6e$export$4a2609371b513462(date) {
    return date.format($604faeb459bdaf6e$var$BACKEND_DATE_FORMAT);
}
function $604faeb459bdaf6e$export$869b91e18a098fa4(date) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cD3aa)))(date, $604faeb459bdaf6e$var$BACKEND_DATE_FORMAT);
}
function $604faeb459bdaf6e$export$36eae39abf349953(startDate, durationInWeek) {
    if (startDate.day() === (0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).localeData().firstDayOfWeek()) return startDate.add(-1, "day").add(durationInWeek, "weeks");
    return startDate.endOf("week").add(durationInWeek, "weeks");
}
function $604faeb459bdaf6e$export$f04058c039a21585(startDate, endDate) {
    return Math.max(0, endDate.diff(startDate, "weeks"));
}
const $604faeb459bdaf6e$export$9a49e8192a6765c4 = (startDate, endDate)=>endDate.startOf("day").diff(startDate.startOf("day"), "days");
const $604faeb459bdaf6e$export$7e4828645d85b43b = (startDate, endDate)=>{
    let month = 0;
    while($604faeb459bdaf6e$export$5f0df70d91bdafda(startDate.add(month + 1, "months"), endDate))month += 1;
    const diffInDays = $604faeb459bdaf6e$export$9a49e8192a6765c4(startDate.add(month, "months"), endDate) + 1; //include start date
    return {
        month: month,
        weeks: Math.floor(diffInDays / 7),
        days: diffInDays % 7
    };
};
const $604faeb459bdaf6e$export$6129c42600c8bfaf = (rangeA, rangeB)=>{
    const [startRangeA, endRangeA] = rangeA;
    const [startRangeB, endRangeB] = rangeB;
    return startRangeA.isBetween(startRangeB, endRangeB, "days", "[]") || endRangeA.isBetween(startRangeB, endRangeB, "days", "[]") || // This last condition is necessary in case range B is completely within range A
    startRangeB.isBetween(startRangeA, endRangeA, "days", "[]");
};
const $604faeb459bdaf6e$export$c082e797153cad7e = (days, calendarMode)=>{
    if (calendarMode) {
        const { month: month } = $604faeb459bdaf6e$export$7e4828645d85b43b($604faeb459bdaf6e$export$461939dd4422153(), $604faeb459bdaf6e$export$461939dd4422153().add(days, "days"));
        return month;
    }
    return Math.floor(days / $604faeb459bdaf6e$export$2487981a941b87c3);
};

});

parcelRegister("auPqo", function(module, exports) {

$parcel$export(module.exports, "AnalyticsCategory", () => $ce52c7f35963ca91$export$257af46c9923adf8);
$parcel$export(module.exports, "AnalyticsCategories", () => $ce52c7f35963ca91$export$99cb2c76c1f7b090);
$parcel$export(module.exports, "getTrackedRouteFromRoutesPath", () => $ce52c7f35963ca91$export$50bf1dfdf6f50efc);
$parcel$export(module.exports, "AnalyticsRoutes", () => $ce52c7f35963ca91$export$97cc371d0e9fef84);

var $lDZlX = parcelRequire("lDZlX");
var $ce52c7f35963ca91$export$257af46c9923adf8;
(function(AnalyticsCategory) {
    AnalyticsCategory["LOGIN"] = "LOGIN";
    AnalyticsCategory["VIP"] = "VIP";
    AnalyticsCategory["REGISTRATION"] = "REGISTRATION";
    AnalyticsCategory["PATIENT"] = "PATIENT";
    AnalyticsCategory["EXERCISE"] = "EXERCISE";
    AnalyticsCategory["PROGRAM"] = "PROGRAM";
    AnalyticsCategory["ERROR"] = "ERROR";
    AnalyticsCategory["TEMPLATE"] = "TEMPLATE";
    AnalyticsCategory["PERMISSIONS"] = "PERMISSIONS";
    AnalyticsCategory["HEALTHCARE"] = "HEALTHCARE";
    AnalyticsCategory["NOTIFICATIONS"] = "NOTIFICATIONS";
    AnalyticsCategory["PROSPECT"] = "PROSPECT";
    AnalyticsCategory["COMMUNICATION"] = "COMMUNICATION";
    AnalyticsCategory["SETTINGS"] = "SETTINGS";
    AnalyticsCategory["TUTORIAL"] = "TUTORIAL";
    AnalyticsCategory["ANNOUNCEMENT"] = "ANNOUNCEMENT";
    AnalyticsCategory["MODAL"] = "MODAL";
    AnalyticsCategory["SURVEY"] = "SURVEY";
    AnalyticsCategory["GETSTARTED"] = "GETSTARTED";
    AnalyticsCategory["LEARN"] = "LEARN";
    AnalyticsCategory["CONTENT"] = "CONTENT";
})($ce52c7f35963ca91$export$257af46c9923adf8 || ($ce52c7f35963ca91$export$257af46c9923adf8 = {}));
const $ce52c7f35963ca91$export$99cb2c76c1f7b090 = {
    LOGIN: "Login",
    VIP: "Vip",
    REGISTRATION: "Registration",
    PATIENT: "Patient",
    EXERCISE: "Exercise",
    PROGRAM: "Program",
    ERROR: "Error",
    TEMPLATE: "Template",
    PERMISSIONS: "Permissions",
    HEALTHCARE: "Healthcare",
    NOTIFICATIONS: "Notifications",
    PROSPECT: "Prospect",
    COMMUNICATION: "Communication",
    SETTINGS: "Settings",
    ANNOUNCEMENT: "Announcement",
    TUTORIAL: "Tutorial",
    MODAL: "Modal",
    SURVEY: "Survey",
    GETSTARTED: "GetStarted",
    LEARN: "Learn",
    CONTENT: "Content"
};
var $ce52c7f35963ca91$export$7c5ccd22ac7e3cf8;
(function(TrackedRoute) {
    TrackedRoute["Home"] = "/";
    TrackedRoute["Login"] = "/login";
    TrackedRoute["VipLogin"] = "/vip/:veevaId";
    TrackedRoute["ForgotPassword"] = "/forgot-password";
    TrackedRoute["PatientDetailsProgress"] = "/patient-details/:patientId?active=progress";
    TrackedRoute["PatientDetailsProgram"] = "/patient-details/:patientId?active=programs";
    TrackedRoute["ProgramBuilder"] = "/program-builder/:patientId";
    TrackedRoute["ProgramList"] = "/programs/";
    TrackedRoute["TemplateBuilder"] = "/template-builder/";
    TrackedRoute["ExerciseList"] = "/exercises";
    TrackedRoute["TermsOfUse"] = "/legal/terms-of-use";
    TrackedRoute["PrivacyNotice"] = "/legal/privacy-notice";
    TrackedRoute["Settings"] = "/settings";
    TrackedRoute["LeavingReasons"] = "/settings/leaving-reasons";
    TrackedRoute["AccountDeleted"] = "/account-deleted";
    TrackedRoute["Register"] = "/register";
    TrackedRoute["RegisterPrivacyNotice"] = "/register/privacy-notice";
    TrackedRoute["RegisterTermsOfUse"] = "/register/terms-of-use";
    TrackedRoute["Rejected"] = "/rejected";
    TrackedRoute["NotificationCenter"] = "/notifications";
    TrackedRoute["DemoRequest"] = "/demo-request";
    TrackedRoute["InviteYourPt"] = "/invite-your-physiotherapist";
    TrackedRoute["ProfessionalInformation"] = "/professional-information";
    TrackedRoute["ThankYouSurvey"] = "/survey-thankyou";
    TrackedRoute["GetStarted"] = "/get-started";
    TrackedRoute["Learn"] = "/learn";
})($ce52c7f35963ca91$export$7c5ccd22ac7e3cf8 || ($ce52c7f35963ca91$export$7c5ccd22ac7e3cf8 = {}));
function $ce52c7f35963ca91$export$50bf1dfdf6f50efc(path, search) {
    switch(path){
        case (0, $lDZlX.RoutesPath).Home:
            return "/";
        case (0, $lDZlX.RoutesPath).Login:
            return "/login";
        case (0, $lDZlX.RoutesPath).VipLogin:
            return "/vip/:veevaId";
        case (0, $lDZlX.RoutesPath).ForgotPassword:
            return "/forgot-password";
        case (0, $lDZlX.RoutesPath).PatientDetails:
            return new URLSearchParams(search).get("active") === "progress" ? "/patient-details/:patientId?active=progress" : "/patient-details/:patientId?active=programs";
        case (0, $lDZlX.RoutesPath).ProgramBuilder:
            return "/program-builder/:patientId";
        case (0, $lDZlX.RoutesPath).TemplateBuilder:
            return "/template-builder/";
        case (0, $lDZlX.RoutesPath).ProgramList:
            return "/programs/";
        case (0, $lDZlX.RoutesPath).ExerciseList:
            return "/exercises";
        case (0, $lDZlX.RoutesPath).TermsOfUse:
            return "/legal/terms-of-use";
        case (0, $lDZlX.RoutesPath).PrivacyNotice:
            return "/legal/privacy-notice";
        case (0, $lDZlX.RoutesPath).Settings:
            return "/settings";
        case (0, $lDZlX.RoutesPath).Register:
            return "/register";
        case (0, $lDZlX.RoutesPath).RegisterPrivacyNotice:
            return "/register/privacy-notice";
        case (0, $lDZlX.RoutesPath).RegisterTermsOfUse:
            return "/register/terms-of-use";
        case (0, $lDZlX.RoutesPath).NotificationCenter:
            return "/notifications";
        case (0, $lDZlX.RoutesPath).DemoRequest:
            return "/demo-request";
        case (0, $lDZlX.RoutesPath).InviteYourPt:
            return "/invite-your-physiotherapist";
        case (0, $lDZlX.RoutesPath).Rejected:
            return "/rejected";
        case (0, $lDZlX.RoutesPath).LeavingReasons:
            return "/settings/leaving-reasons";
        case (0, $lDZlX.RoutesPath).AccountDeleted:
            return "/account-deleted";
        case (0, $lDZlX.RoutesPath).ProfessionalInformation:
            return "/professional-information";
        case (0, $lDZlX.RoutesPath).ThankYouSurvey:
            return "/survey-thankyou";
        case (0, $lDZlX.RoutesPath).GetStarted:
            return "/get-started";
        case (0, $lDZlX.RoutesPath).Learn:
            return "/learn";
        case (0, $lDZlX.RoutesPath).LearnDocument:
            return "/learn";
        case (0, $lDZlX.RoutesPath).VipLoginRedirection:
        case (0, $lDZlX.RoutesPath).Debug:
            return null;
    }
}
const $ce52c7f35963ca91$export$97cc371d0e9fef84 = {
    ["/"]: "Home",
    ["/login"]: "Login",
    ["/vip/:veevaId"]: "Vip Login",
    ["/forgot-password"]: "ForgotPassword",
    ["/patient-details/:patientId?active=progress"]: "PatientDetails - Progress",
    ["/patient-details/:patientId?active=programs"]: "PatientDetails - Program",
    ["/program-builder/:patientId"]: "ProgramBuilder",
    ["/legal/terms-of-use"]: "TermsOfUse",
    ["/legal/privacy-notice"]: "PrivacyNotice",
    ["/programs/"]: "ProgramList",
    ["/template-builder/"]: "TemplateBuilder",
    ["/exercises"]: "ExerciseList",
    ["/settings"]: "Settings",
    ["/register"]: "Register",
    ["/register/privacy-notice"]: "RegisterPrivacyNotice",
    ["/register/terms-of-use"]: "RegisterTermsOfUse",
    ["/notifications"]: "NotificationCenter",
    ["/demo-request"]: "DemoRequest",
    ["/invite-your-physiotherapist"]: "InviteYourPt",
    ["/rejected"]: "Rejected",
    ["/settings/leaving-reasons"]: "DeleteReasons",
    ["/account-deleted"]: "AccountDeleted",
    ["/professional-information"]: "ProfessionalInformation",
    ["/survey-thankyou"]: "ThankYouSurvey",
    ["/get-started"]: "GetStarted",
    ["/learn"]: "Learn"
};

});
parcelRegister("lDZlX", function(module, exports) {

$parcel$export(module.exports, "RoutesPath", () => $61fb25879c091627$export$b63241d775b72b81);
$parcel$export(module.exports, "routesPaths", () => $61fb25879c091627$export$ac5e0cbd0753388a);
$parcel$export(module.exports, "TabPatientDetails", () => $61fb25879c091627$export$6be11ec721e3c677);

var $d90o3 = parcelRequire("d90o3");
var $61fb25879c091627$export$b63241d775b72b81;
(function(RoutesPath) {
    RoutesPath["Home"] = "/";
    RoutesPath["Settings"] = "/settings";
    RoutesPath["Register"] = "/register";
    RoutesPath["RegisterPrivacyNotice"] = "/register/privacy-notice";
    RoutesPath["RegisterTermsOfUse"] = "/register/terms-of-use";
    RoutesPath["Login"] = "/login";
    RoutesPath["Rejected"] = "/rejected";
    RoutesPath["VipLoginRedirection"] = "/vip";
    RoutesPath["VipLogin"] = "/vip/:veevaId";
    RoutesPath["ForgotPassword"] = "/forgot-password";
    RoutesPath["TermsOfUse"] = "/legal/terms-of-use";
    RoutesPath["PrivacyNotice"] = "/legal/privacy-notice";
    RoutesPath["PatientDetails"] = "/patient-details/:patientId";
    RoutesPath["ProgramBuilder"] = "/program-builder/:patientId";
    RoutesPath["ProgramList"] = "/programs";
    RoutesPath["TemplateBuilder"] = "/new-program";
    RoutesPath["ExerciseList"] = "/exercises";
    RoutesPath["Learn"] = "/learn";
    RoutesPath["LearnDocument"] = "/learn/:documentId";
    RoutesPath["NotificationCenter"] = "/notifications";
    RoutesPath["InviteYourPt"] = "/invite-your-physiotherapist";
    RoutesPath["Debug"] = "/debug";
    RoutesPath["DemoRequest"] = "/demo-request";
    RoutesPath["LeavingReasons"] = "/leaving-reasons";
    RoutesPath["AccountDeleted"] = "/account-deleted";
    RoutesPath["ProfessionalInformation"] = "/professional-information";
    RoutesPath["ThankYouSurvey"] = "/survey-thankyou";
    RoutesPath["GetStarted"] = "/get-started";
})($61fb25879c091627$export$b63241d775b72b81 || ($61fb25879c091627$export$b63241d775b72b81 = {}));
const $61fb25879c091627$export$ac5e0cbd0753388a = (0, $d90o3.getEnumValues)($61fb25879c091627$export$b63241d775b72b81);
var $61fb25879c091627$export$6be11ec721e3c677;
(function(TabPatientDetails) {
    TabPatientDetails["PROGRESS_TAB"] = "progress";
    TabPatientDetails["PROGRAMS_TAB"] = "programs";
    TabPatientDetails["HEALTHCARE_TAB"] = "healthcare";
})($61fb25879c091627$export$6be11ec721e3c677 || ($61fb25879c091627$export$6be11ec721e3c677 = {}));

});
parcelRegister("d90o3", function(module, exports) {

$parcel$export(module.exports, "getEnumValues", () => $55ca7de24d78c270$export$70a5d58ec00f3c11);
function $55ca7de24d78c270$export$70a5d58ec00f3c11(enumObject) {
    return Object.keys(enumObject).filter((key)=>Number.isNaN(Number(key))).map((key)=>enumObject[key]);
}

});



parcelRegister("cM7bY", function(module, exports) {

$parcel$export(module.exports, "CustomDimensions", () => $253ef3d5694f68b7$export$b25f21f3f4445352);
const $253ef3d5694f68b7$export$b25f21f3f4445352 = {
    // Visites / Sessions
    PTID: "PTID",
    registrationDate: "registrationDate",
    userCountry: "userCountry",
    envStatus: "envStatus",
    userEnv: "userEnv",
    platformLanguage: "platformLanguage",
    deviceLanguage: "deviceLanguage",
    isTester: "isTester",
    isReviewer: "isReviewer",
    // Actions / Hits
    loginStatus: "loginStatus"
};

});


parcelRegister("2y70O", function(module, exports) {

$parcel$export(module.exports, "AnalyticsRoutesManager", () => $fe5a539aa4af653b$export$6e6098b53272091a);

var $auPqo = parcelRequire("auPqo");

var $lDZlX = parcelRequire("lDZlX");
parcelRequire("hE6rp");
var $kEwLa = parcelRequire("kEwLa");
class $fe5a539aa4af653b$export$6e6098b53272091a {
    constructor(analyticsService){
        this.analyticsService = analyticsService;
        this._currentRoute = undefined;
    }
    setCurrentRoute(location) {
        const routeData = this.getRouteDataFromLocation(location);
        if (routeData?.trackedRoute) {
            const baseUrl = window.location.origin;
            const pathName = this.getPathName(routeData);
            const search = this.getSearch(location);
            const customUrl = baseUrl + pathName + (search === "?" ? "" : search);
            if (routeData.trackedRoute !== this._currentRoute?.title || customUrl !== this._currentRoute.url) {
                this._currentRoute = {
                    title: routeData.trackedRoute,
                    url: customUrl
                };
                this.analyticsService.trackView(routeData.trackedRoute, customUrl);
            }
        }
    }
    getPathName(routeData) {
        return routeData.params.patientId ? routeData.realPath.replace(`/${routeData.params.patientId}`, "") : routeData.realPath;
    }
    getSearch(location) {
        const programIdParam = new URLSearchParams(location.search).get("programId");
        return programIdParam ? location.search.replace(`&programId=${programIdParam}`, "").replace(`programId=${programIdParam}`, "") : location.search;
    }
    getRouteDataFromLocation(location) {
        const currentRoute = (0, $kEwLa.matchRoutes)((0, $lDZlX.routesPaths).map((route)=>({
                path: route
            })), location)?.[0];
        const routePath = currentRoute?.route.path;
        if (currentRoute && routePath) {
            const trackedRoute = (0, $auPqo.getTrackedRouteFromRoutesPath)(routePath, location.search);
            return {
                path: routePath,
                realPath: currentRoute.pathname,
                params: currentRoute.params,
                trackedRoute: trackedRoute
            };
        }
        return null;
    }
}

});
parcelRegister("hE6rp", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $cd8b2b26f5ec4df1$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $cd8b2b26f5ec4df1$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $cd8b2b26f5ec4df1$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $cd8b2b26f5ec4df1$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $cd8b2b26f5ec4df1$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $cd8b2b26f5ec4df1$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $cd8b2b26f5ec4df1$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $cd8b2b26f5ec4df1$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $cd8b2b26f5ec4df1$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $cd8b2b26f5ec4df1$export$5fcee62552a12fbf);
$parcel$export(module.exports, "useRouteError", () => $cd8b2b26f5ec4df1$export$ed527bf60f6e05f2);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $cd8b2b26f5ec4df1$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $cd8b2b26f5ec4df1$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $cd8b2b26f5ec4df1$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $cd8b2b26f5ec4df1$export$b273b3273281a049);
$parcel$export(module.exports, "Router", () => $cd8b2b26f5ec4df1$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Navigate", () => $cd8b2b26f5ec4df1$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Outlet", () => $cd8b2b26f5ec4df1$export$910ae8079b2c2852);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $cd8b2b26f5ec4df1$export$52b333d321859367);
$parcel$export(module.exports, "matchRoutes", () => (parcelRequire("kEwLa")).matchRoutes);
/**
 * React Router v6.24.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $81g6h = parcelRequire("81g6h");

var $kEwLa = parcelRequire("kEwLa");
function $cd8b2b26f5ec4df1$var$_extends() {
    $cd8b2b26f5ec4df1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cd8b2b26f5ec4df1$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $cd8b2b26f5ec4df1$export$3add0d5dce533e2e = /*#__PURE__*/ $81g6h.createContext(null);
const $cd8b2b26f5ec4df1$export$145dfa71566a64dc = /*#__PURE__*/ $81g6h.createContext(null);
const $cd8b2b26f5ec4df1$var$AwaitContext = /*#__PURE__*/ $81g6h.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $cd8b2b26f5ec4df1$export$26749e8557646306 = /*#__PURE__*/ $81g6h.createContext(null);
const $cd8b2b26f5ec4df1$export$c7914228fb69b0f5 = /*#__PURE__*/ $81g6h.createContext(null);
const $cd8b2b26f5ec4df1$export$9072aa6dd1f93057 = /*#__PURE__*/ $81g6h.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $cd8b2b26f5ec4df1$var$RouteErrorContext = /*#__PURE__*/ $81g6h.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $cd8b2b26f5ec4df1$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$cd8b2b26f5ec4df1$export$9c954a9d03d32f4a() && (0, $kEwLa.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $81g6h.useContext($cd8b2b26f5ec4df1$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $cd8b2b26f5ec4df1$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $kEwLa.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $cd8b2b26f5ec4df1$export$9c954a9d03d32f4a() {
    return $81g6h.useContext($cd8b2b26f5ec4df1$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $cd8b2b26f5ec4df1$export$45d76561a5302f2b() {
    !$cd8b2b26f5ec4df1$export$9c954a9d03d32f4a() && (0, $kEwLa.UNSAFE_invariant)(false);
    return $81g6h.useContext($cd8b2b26f5ec4df1$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $cd8b2b26f5ec4df1$export$1b3f31771c5d07c() {
    return $81g6h.useContext($cd8b2b26f5ec4df1$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $cd8b2b26f5ec4df1$export$6c330e8992e8a295(pattern) {
    !$cd8b2b26f5ec4df1$export$9c954a9d03d32f4a() && (0, $kEwLa.UNSAFE_invariant)(false);
    let { pathname: pathname } = $cd8b2b26f5ec4df1$export$45d76561a5302f2b();
    return $81g6h.useMemo(()=>(0, $kEwLa.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $cd8b2b26f5ec4df1$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $cd8b2b26f5ec4df1$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $81g6h.useContext($cd8b2b26f5ec4df1$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $81g6h.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $cd8b2b26f5ec4df1$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $81g6h.useContext($cd8b2b26f5ec4df1$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $cd8b2b26f5ec4df1$var$useNavigateStable() : $cd8b2b26f5ec4df1$var$useNavigateUnstable();
}
function $cd8b2b26f5ec4df1$var$useNavigateUnstable() {
    !$cd8b2b26f5ec4df1$export$9c954a9d03d32f4a() && (0, $kEwLa.UNSAFE_invariant)(false);
    let dataRouterContext = $81g6h.useContext($cd8b2b26f5ec4df1$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $81g6h.useContext($cd8b2b26f5ec4df1$export$26749e8557646306);
    let { matches: matches } = $81g6h.useContext($cd8b2b26f5ec4df1$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $cd8b2b26f5ec4df1$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $kEwLa.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $81g6h.useRef(false);
    $cd8b2b26f5ec4df1$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $81g6h.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $kEwLa.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $kEwLa.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $cd8b2b26f5ec4df1$var$OutletContext = /*#__PURE__*/ $81g6h.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $cd8b2b26f5ec4df1$export$4138103a3ae699cc() {
    return $81g6h.useContext($cd8b2b26f5ec4df1$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $cd8b2b26f5ec4df1$export$a3be3530d8e40d0b(context) {
    let outlet = $81g6h.useContext($cd8b2b26f5ec4df1$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $cd8b2b26f5ec4df1$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $81g6h.useContext($cd8b2b26f5ec4df1$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $cd8b2b26f5ec4df1$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $81g6h.useContext($cd8b2b26f5ec4df1$export$26749e8557646306);
    let { matches: matches } = $81g6h.useContext($cd8b2b26f5ec4df1$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $cd8b2b26f5ec4df1$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $kEwLa.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $81g6h.useMemo(()=>(0, $kEwLa.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $cd8b2b26f5ec4df1$export$5d3fca4a98652595(routes, locationArg) {
    return $cd8b2b26f5ec4df1$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $cd8b2b26f5ec4df1$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$cd8b2b26f5ec4df1$export$9c954a9d03d32f4a() && (0, $kEwLa.UNSAFE_invariant)(false);
    let { navigator: navigator } = $81g6h.useContext($cd8b2b26f5ec4df1$export$26749e8557646306);
    let { matches: parentMatches } = $81g6h.useContext($cd8b2b26f5ec4df1$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $cd8b2b26f5ec4df1$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $kEwLa.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $kEwLa.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $kEwLa.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $cd8b2b26f5ec4df1$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $kEwLa.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $kEwLa.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $cd8b2b26f5ec4df1$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $kEwLa.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $cd8b2b26f5ec4df1$var$DefaultErrorComponent() {
    let error = $cd8b2b26f5ec4df1$export$ed527bf60f6e05f2();
    let message = (0, $kEwLa.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $81g6h.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $81g6h.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $cd8b2b26f5ec4df1$var$defaultErrorElement = /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$var$DefaultErrorComponent, null);
class $cd8b2b26f5ec4df1$var$RenderErrorBoundary extends $81g6h.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $cd8b2b26f5ec4df1$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $81g6h.useContext($cd8b2b26f5ec4df1$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $cd8b2b26f5ec4df1$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $kEwLa.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $cd8b2b26f5ec4df1$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $cd8b2b26f5ec4df1$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $81g6h.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $cd8b2b26f5ec4df1$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($cd8b2b26f5ec4df1$var$DataRouterHook || {});
var $cd8b2b26f5ec4df1$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($cd8b2b26f5ec4df1$var$DataRouterStateHook || {});
function $cd8b2b26f5ec4df1$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $cd8b2b26f5ec4df1$var$useDataRouterContext(hookName) {
    let ctx = $81g6h.useContext($cd8b2b26f5ec4df1$export$3add0d5dce533e2e);
    !ctx && (0, $kEwLa.UNSAFE_invariant)(false);
    return ctx;
}
function $cd8b2b26f5ec4df1$var$useDataRouterState(hookName) {
    let state = $81g6h.useContext($cd8b2b26f5ec4df1$export$145dfa71566a64dc);
    !state && (0, $kEwLa.UNSAFE_invariant)(false);
    return state;
}
function $cd8b2b26f5ec4df1$var$useRouteContext(hookName) {
    let route = $81g6h.useContext($cd8b2b26f5ec4df1$export$9072aa6dd1f93057);
    !route && (0, $kEwLa.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $cd8b2b26f5ec4df1$var$useCurrentRouteId(hookName) {
    let route = $cd8b2b26f5ec4df1$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $kEwLa.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $cd8b2b26f5ec4df1$export$5fc8298006ad9e58() {
    return $cd8b2b26f5ec4df1$var$useCurrentRouteId($cd8b2b26f5ec4df1$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $cd8b2b26f5ec4df1$export$d0fd4b7106de2769() {
    let state = $cd8b2b26f5ec4df1$var$useDataRouterState($cd8b2b26f5ec4df1$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $cd8b2b26f5ec4df1$export$600dc272ed516c15() {
    let dataRouterContext = $cd8b2b26f5ec4df1$var$useDataRouterContext($cd8b2b26f5ec4df1$var$DataRouterHook.UseRevalidator);
    let state = $cd8b2b26f5ec4df1$var$useDataRouterState($cd8b2b26f5ec4df1$var$DataRouterStateHook.UseRevalidator);
    return $81g6h.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $cd8b2b26f5ec4df1$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $cd8b2b26f5ec4df1$var$useDataRouterState($cd8b2b26f5ec4df1$var$DataRouterStateHook.UseMatches);
    return $81g6h.useMemo(()=>matches.map((m)=>(0, $kEwLa.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $cd8b2b26f5ec4df1$export$1448a5050d252c4d() {
    let state = $cd8b2b26f5ec4df1$var$useDataRouterState($cd8b2b26f5ec4df1$var$DataRouterStateHook.UseLoaderData);
    let routeId = $cd8b2b26f5ec4df1$var$useCurrentRouteId($cd8b2b26f5ec4df1$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $cd8b2b26f5ec4df1$export$fd5d37484eab868d(routeId) {
    let state = $cd8b2b26f5ec4df1$var$useDataRouterState($cd8b2b26f5ec4df1$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $cd8b2b26f5ec4df1$export$fdc00f3f26066d5e() {
    let state = $cd8b2b26f5ec4df1$var$useDataRouterState($cd8b2b26f5ec4df1$var$DataRouterStateHook.UseActionData);
    let routeId = $cd8b2b26f5ec4df1$var$useCurrentRouteId($cd8b2b26f5ec4df1$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $cd8b2b26f5ec4df1$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $81g6h.useContext($cd8b2b26f5ec4df1$var$RouteErrorContext);
    let state = $cd8b2b26f5ec4df1$var$useDataRouterState($cd8b2b26f5ec4df1$var$DataRouterStateHook.UseRouteError);
    let routeId = $cd8b2b26f5ec4df1$var$useCurrentRouteId($cd8b2b26f5ec4df1$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $cd8b2b26f5ec4df1$export$78a72ddb39bdd145() {
    let value = $81g6h.useContext($cd8b2b26f5ec4df1$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $cd8b2b26f5ec4df1$export$17f53340677d5831() {
    let value = $81g6h.useContext($cd8b2b26f5ec4df1$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $cd8b2b26f5ec4df1$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $cd8b2b26f5ec4df1$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $cd8b2b26f5ec4df1$var$useDataRouterContext($cd8b2b26f5ec4df1$var$DataRouterHook.UseBlocker);
    let state = $cd8b2b26f5ec4df1$var$useDataRouterState($cd8b2b26f5ec4df1$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $81g6h.useState("");
    let blockerFunction = $81g6h.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $cd8b2b26f5ec4df1$var$_extends({}, currentLocation, {
                pathname: (0, $kEwLa.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $cd8b2b26f5ec4df1$var$_extends({}, nextLocation, {
                pathname: (0, $kEwLa.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $81g6h.useEffect(()=>{
        let key = String(++$cd8b2b26f5ec4df1$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $81g6h.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $kEwLa.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $cd8b2b26f5ec4df1$var$useNavigateStable() {
    let { router: router } = $cd8b2b26f5ec4df1$var$useDataRouterContext($cd8b2b26f5ec4df1$var$DataRouterHook.UseNavigateStable);
    let id = $cd8b2b26f5ec4df1$var$useCurrentRouteId($cd8b2b26f5ec4df1$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $81g6h.useRef(false);
    $cd8b2b26f5ec4df1$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $81g6h.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $cd8b2b26f5ec4df1$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $cd8b2b26f5ec4df1$var$alreadyWarned = {};
function $cd8b2b26f5ec4df1$var$warningOnce(key, cond, message) {
    if (!cond && !$cd8b2b26f5ec4df1$var$alreadyWarned[key]) $cd8b2b26f5ec4df1$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $cd8b2b26f5ec4df1$var$START_TRANSITION = "startTransition";
const $cd8b2b26f5ec4df1$var$startTransitionImpl = $81g6h[$cd8b2b26f5ec4df1$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $cd8b2b26f5ec4df1$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $81g6h.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $81g6h.useCallback((newState)=>{
        if (v7_startTransition && $cd8b2b26f5ec4df1$var$startTransitionImpl) $cd8b2b26f5ec4df1$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $81g6h.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $81g6h.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $81g6h.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $81g6h.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $cd8b2b26f5ec4df1$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $cd8b2b26f5ec4df1$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $cd8b2b26f5ec4df1$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $81g6h.useRef();
    if (historyRef.current == null) historyRef.current = (0, $kEwLa.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $81g6h.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $81g6h.useCallback((newState)=>{
        v7_startTransition && $cd8b2b26f5ec4df1$var$startTransitionImpl ? $cd8b2b26f5ec4df1$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $81g6h.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $cd8b2b26f5ec4df1$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$cd8b2b26f5ec4df1$export$9c954a9d03d32f4a() && (0, $kEwLa.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $81g6h.useContext($cd8b2b26f5ec4df1$export$26749e8557646306);
    let { matches: matches } = $81g6h.useContext($cd8b2b26f5ec4df1$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $cd8b2b26f5ec4df1$export$45d76561a5302f2b();
    let navigate = $cd8b2b26f5ec4df1$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $kEwLa.resolveTo)(to, (0, $kEwLa.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $81g6h.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $cd8b2b26f5ec4df1$export$910ae8079b2c2852(props) {
    return $cd8b2b26f5ec4df1$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $cd8b2b26f5ec4df1$export$e7b0ac011bb776c6(_props) {
    (0, $kEwLa.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $cd8b2b26f5ec4df1$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $kEwLa.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$cd8b2b26f5ec4df1$export$9c954a9d03d32f4a() && (0, $kEwLa.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $81g6h.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $cd8b2b26f5ec4df1$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $kEwLa.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $81g6h.useMemo(()=>{
        let trailingPathname = (0, $kEwLa.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $cd8b2b26f5ec4df1$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $cd8b2b26f5ec4df1$export$5d3fca4a98652595($cd8b2b26f5ec4df1$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $cd8b2b26f5ec4df1$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$var$ResolveAwait, null, children));
}
var $cd8b2b26f5ec4df1$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($cd8b2b26f5ec4df1$var$AwaitRenderStatus || {});
const $cd8b2b26f5ec4df1$var$neverSettledPromise = new Promise(()=>{});
class $cd8b2b26f5ec4df1$var$AwaitErrorBoundary extends $81g6h.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $cd8b2b26f5ec4df1$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $cd8b2b26f5ec4df1$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $cd8b2b26f5ec4df1$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $cd8b2b26f5ec4df1$var$AwaitRenderStatus.error : "_data" in promise ? $cd8b2b26f5ec4df1$var$AwaitRenderStatus.success : $cd8b2b26f5ec4df1$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $cd8b2b26f5ec4df1$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $cd8b2b26f5ec4df1$var$AwaitRenderStatus.error && promise._error instanceof (0, $kEwLa.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $cd8b2b26f5ec4df1$var$neverSettledPromise;
        if (status === $cd8b2b26f5ec4df1$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $cd8b2b26f5ec4df1$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $cd8b2b26f5ec4df1$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $81g6h.createElement($cd8b2b26f5ec4df1$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $cd8b2b26f5ec4df1$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $cd8b2b26f5ec4df1$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $cd8b2b26f5ec4df1$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $81g6h.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $81g6h.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $81g6h.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $cd8b2b26f5ec4df1$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $cd8b2b26f5ec4df1$export$e7b0ac011bb776c6) && (0, $kEwLa.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $kEwLa.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $cd8b2b26f5ec4df1$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $cd8b2b26f5ec4df1$export$daf73786167a7f72(matches) {
    return $cd8b2b26f5ec4df1$var$_renderMatches(matches);
}
function $cd8b2b26f5ec4df1$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $81g6h.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $81g6h.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $81g6h.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $cd8b2b26f5ec4df1$export$f30f7e456d254e83(routes, opts) {
    return (0, $kEwLa.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $cd8b2b26f5ec4df1$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $kEwLa.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $cd8b2b26f5ec4df1$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss
    }).initialize();
}

});
parcelRegister("kEwLa", function(module, exports) {

$parcel$export(module.exports, "Action", () => $f090f4785d1d4f7f$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $f090f4785d1d4f7f$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $f090f4785d1d4f7f$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $f090f4785d1d4f7f$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $f090f4785d1d4f7f$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $f090f4785d1d4f7f$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $f090f4785d1d4f7f$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $f090f4785d1d4f7f$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $f090f4785d1d4f7f$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $f090f4785d1d4f7f$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $f090f4785d1d4f7f$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $f090f4785d1d4f7f$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $f090f4785d1d4f7f$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $f090f4785d1d4f7f$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $f090f4785d1d4f7f$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $f090f4785d1d4f7f$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $f090f4785d1d4f7f$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $f090f4785d1d4f7f$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $f090f4785d1d4f7f$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $f090f4785d1d4f7f$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.17.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $f090f4785d1d4f7f$var$_extends() {
    $f090f4785d1d4f7f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f090f4785d1d4f7f$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $f090f4785d1d4f7f$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($f090f4785d1d4f7f$export$e19cd5f9376f8cee || ($f090f4785d1d4f7f$export$e19cd5f9376f8cee = {}));
const $f090f4785d1d4f7f$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $f090f4785d1d4f7f$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $f090f4785d1d4f7f$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $f090f4785d1d4f7f$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $f090f4785d1d4f7f$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $f090f4785d1d4f7f$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $f090f4785d1d4f7f$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $f090f4785d1d4f7f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $f090f4785d1d4f7f$export$fe53371bee54353d(to);
    }
    return $f090f4785d1d4f7f$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $f090f4785d1d4f7f$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $f090f4785d1d4f7f$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $f090f4785d1d4f7f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $f090f4785d1d4f7f$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $f090f4785d1d4f7f$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $f090f4785d1d4f7f$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $f090f4785d1d4f7f$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $f090f4785d1d4f7f$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $f090f4785d1d4f7f$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $f090f4785d1d4f7f$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $f090f4785d1d4f7f$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $f090f4785d1d4f7f$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $f090f4785d1d4f7f$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $f090f4785d1d4f7f$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $f090f4785d1d4f7f$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $f090f4785d1d4f7f$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $f090f4785d1d4f7f$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($f090f4785d1d4f7f$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Push;
        let location = $f090f4785d1d4f7f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $f090f4785d1d4f7f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Replace;
        let location = $f090f4785d1d4f7f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $f090f4785d1d4f7f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $f090f4785d1d4f7f$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $f090f4785d1d4f7f$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($f090f4785d1d4f7f$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($f090f4785d1d4f7f$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $f090f4785d1d4f7f$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($f090f4785d1d4f7f$var$ResultType || ($f090f4785d1d4f7f$var$ResultType = {}));
const $f090f4785d1d4f7f$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $f090f4785d1d4f7f$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $f090f4785d1d4f7f$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $f090f4785d1d4f7f$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $f090f4785d1d4f7f$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($f090f4785d1d4f7f$var$isIndexRoute(route)) {
            let indexRoute = $f090f4785d1d4f7f$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $f090f4785d1d4f7f$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $f090f4785d1d4f7f$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $f090f4785d1d4f7f$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $f090f4785d1d4f7f$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $f090f4785d1d4f7f$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $f090f4785d1d4f7f$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $f090f4785d1d4f7f$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $f090f4785d1d4f7f$var$flattenRoutes(routes);
    $f090f4785d1d4f7f$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $f090f4785d1d4f7f$var$decodePath(pathname);
        matches = $f090f4785d1d4f7f$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $f090f4785d1d4f7f$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $f090f4785d1d4f7f$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $f090f4785d1d4f7f$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $f090f4785d1d4f7f$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $f090f4785d1d4f7f$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $f090f4785d1d4f7f$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $f090f4785d1d4f7f$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $f090f4785d1d4f7f$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $f090f4785d1d4f7f$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $f090f4785d1d4f7f$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $f090f4785d1d4f7f$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $f090f4785d1d4f7f$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $f090f4785d1d4f7f$var$paramRe = /^:[\w-]+$/;
const $f090f4785d1d4f7f$var$dynamicSegmentValue = 3;
const $f090f4785d1d4f7f$var$indexRouteValue = 2;
const $f090f4785d1d4f7f$var$emptySegmentValue = 1;
const $f090f4785d1d4f7f$var$staticSegmentValue = 10;
const $f090f4785d1d4f7f$var$splatPenalty = -2;
const $f090f4785d1d4f7f$var$isSplat = (s)=>s === "*";
function $f090f4785d1d4f7f$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($f090f4785d1d4f7f$var$isSplat)) initialScore += $f090f4785d1d4f7f$var$splatPenalty;
    if (index) initialScore += $f090f4785d1d4f7f$var$indexRouteValue;
    return segments.filter((s)=>!$f090f4785d1d4f7f$var$isSplat(s)).reduce((score, segment)=>score + ($f090f4785d1d4f7f$var$paramRe.test(segment) ? $f090f4785d1d4f7f$var$dynamicSegmentValue : segment === "" ? $f090f4785d1d4f7f$var$emptySegmentValue : $f090f4785d1d4f7f$var$staticSegmentValue), initialScore);
}
function $f090f4785d1d4f7f$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $f090f4785d1d4f7f$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $f090f4785d1d4f7f$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $f090f4785d1d4f7f$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $f090f4785d1d4f7f$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $f090f4785d1d4f7f$export$a5c6d149b50c1d86($f090f4785d1d4f7f$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $f090f4785d1d4f7f$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $f090f4785d1d4f7f$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $f090f4785d1d4f7f$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $f090f4785d1d4f7f$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $f090f4785d1d4f7f$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $f090f4785d1d4f7f$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $f090f4785d1d4f7f$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $f090f4785d1d4f7f$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $f090f4785d1d4f7f$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $f090f4785d1d4f7f$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $f090f4785d1d4f7f$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $f090f4785d1d4f7f$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $f090f4785d1d4f7f$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $f090f4785d1d4f7f$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $f090f4785d1d4f7f$var$normalizeSearch(search),
        hash: $f090f4785d1d4f7f$var$normalizeHash(hash)
    };
}
function $f090f4785d1d4f7f$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $f090f4785d1d4f7f$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $f090f4785d1d4f7f$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $f090f4785d1d4f7f$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $f090f4785d1d4f7f$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $f090f4785d1d4f7f$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $f090f4785d1d4f7f$export$8ccf933b0513f8d0(toArg);
    else {
        to = $f090f4785d1d4f7f$var$_extends({}, toArg);
        $f090f4785d1d4f7f$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $f090f4785d1d4f7f$var$getInvalidPathError("?", "pathname", "search", to));
        $f090f4785d1d4f7f$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $f090f4785d1d4f7f$var$getInvalidPathError("#", "pathname", "hash", to));
        $f090f4785d1d4f7f$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $f090f4785d1d4f7f$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $f090f4785d1d4f7f$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $f090f4785d1d4f7f$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $f090f4785d1d4f7f$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $f090f4785d1d4f7f$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $f090f4785d1d4f7f$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $f090f4785d1d4f7f$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $f090f4785d1d4f7f$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $f090f4785d1d4f7f$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $f090f4785d1d4f7f$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $f090f4785d1d4f7f$export$42a99a7a4bc0e76a extends Error {
}
class $f090f4785d1d4f7f$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $f090f4785d1d4f7f$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $f090f4785d1d4f7f$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $f090f4785d1d4f7f$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $f090f4785d1d4f7f$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $f090f4785d1d4f7f$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $f090f4785d1d4f7f$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $f090f4785d1d4f7f$var$unwrapTrackedPromise(value) {
    if (!$f090f4785d1d4f7f$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $f090f4785d1d4f7f$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $f090f4785d1d4f7f$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f090f4785d1d4f7f$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $f090f4785d1d4f7f$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f090f4785d1d4f7f$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $f090f4785d1d4f7f$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $f090f4785d1d4f7f$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $f090f4785d1d4f7f$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $f090f4785d1d4f7f$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $f090f4785d1d4f7f$var$validMutationMethods = new Set($f090f4785d1d4f7f$var$validMutationMethodsArr);
const $f090f4785d1d4f7f$var$validRequestMethodsArr = [
    "get",
    ...$f090f4785d1d4f7f$var$validMutationMethodsArr
];
const $f090f4785d1d4f7f$var$validRequestMethods = new Set($f090f4785d1d4f7f$var$validRequestMethodsArr);
const $f090f4785d1d4f7f$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $f090f4785d1d4f7f$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $f090f4785d1d4f7f$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $f090f4785d1d4f7f$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $f090f4785d1d4f7f$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $f090f4785d1d4f7f$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $f090f4785d1d4f7f$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $f090f4785d1d4f7f$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $f090f4785d1d4f7f$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $f090f4785d1d4f7f$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f090f4785d1d4f7f$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $f090f4785d1d4f7f$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $f090f4785d1d4f7f$var$defaultDataStrategy;
    let patchRoutesOnMissImpl = init.unstable_patchRoutesOnMiss;
    // Config driven behavior flags
    let future = $f090f4785d1d4f7f$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $f090f4785d1d4f7f$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnMissImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $f090f4785d1d4f7f$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $f090f4785d1d4f7f$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // If the user provided a patchRoutesOnMiss implementation and our initial
    // match is a splat route, clear them out so we run through lazy discovery
    // on hydration in case there's a more accurate lazy route match
    if (initialMatches && patchRoutesOnMissImpl) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        // We need to run patchRoutesOnMiss in initialize()
        initialized = false;
        initialMatches = [];
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $f090f4785d1d4f7f$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnMiss() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $f090f4785d1d4f7f$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $f090f4785d1d4f7f$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $f090f4785d1d4f7f$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$f090f4785d1d4f7f$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($f090f4785d1d4f7f$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $f090f4785d1d4f7f$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $f090f4785d1d4f7f$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $f090f4785d1d4f7f$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $f090f4785d1d4f7f$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $f090f4785d1d4f7f$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($f090f4785d1d4f7f$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $f090f4785d1d4f7f$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $f090f4785d1d4f7f$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $f090f4785d1d4f7f$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $f090f4785d1d4f7f$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $f090f4785d1d4f7f$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $f090f4785d1d4f7f$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $f090f4785d1d4f7f$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $f090f4785d1d4f7f$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $f090f4785d1d4f7f$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $f090f4785d1d4f7f$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $f090f4785d1d4f7f$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $f090f4785d1d4f7f$var$findNearestBoundary(matches).route.id,
            {
                type: $f090f4785d1d4f7f$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $f090f4785d1d4f7f$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($f090f4785d1d4f7f$var$isErrorResult(result) && $f090f4785d1d4f7f$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $f090f4785d1d4f7f$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $f090f4785d1d4f7f$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $f090f4785d1d4f7f$var$_extends({
            matches: updatedMatches || matches
        }, $f090f4785d1d4f7f$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $f090f4785d1d4f7f$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $f090f4785d1d4f7f$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $f090f4785d1d4f7f$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $f090f4785d1d4f7f$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $f090f4785d1d4f7f$var$ResultType.error,
            error: $f090f4785d1d4f7f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($f090f4785d1d4f7f$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $f090f4785d1d4f7f$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($f090f4785d1d4f7f$var$isDeferredResult(result)) throw $f090f4785d1d4f7f$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($f090f4785d1d4f7f$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $f090f4785d1d4f7f$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $f090f4785d1d4f7f$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $f090f4785d1d4f7f$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($f090f4785d1d4f7f$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $f090f4785d1d4f7f$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $f090f4785d1d4f7f$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $f090f4785d1d4f7f$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $f090f4785d1d4f7f$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $f090f4785d1d4f7f$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f090f4785d1d4f7f$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $f090f4785d1d4f7f$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$f090f4785d1d4f7f$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $f090f4785d1d4f7f$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $f090f4785d1d4f7f$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $f090f4785d1d4f7f$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $f090f4785d1d4f7f$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $f090f4785d1d4f7f$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $f090f4785d1d4f7f$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $f090f4785d1d4f7f$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $f090f4785d1d4f7f$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f090f4785d1d4f7f$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $f090f4785d1d4f7f$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $f090f4785d1d4f7f$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $f090f4785d1d4f7f$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($f090f4785d1d4f7f$var$isRedirectResult(actionResult) || $f090f4785d1d4f7f$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $f090f4785d1d4f7f$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($f090f4785d1d4f7f$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $f090f4785d1d4f7f$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $f090f4785d1d4f7f$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($f090f4785d1d4f7f$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($f090f4785d1d4f7f$var$isDeferredResult(actionResult)) throw $f090f4785d1d4f7f$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $f090f4785d1d4f7f$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $f090f4785d1d4f7f$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $f090f4785d1d4f7f$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $f090f4785d1d4f7f$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $f090f4785d1d4f7f$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $f090f4785d1d4f7f$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $f090f4785d1d4f7f$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f090f4785d1d4f7f$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $f090f4785d1d4f7f$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $f090f4785d1d4f7f$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $f090f4785d1d4f7f$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f090f4785d1d4f7f$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $f090f4785d1d4f7f$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $f090f4785d1d4f7f$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $f090f4785d1d4f7f$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($f090f4785d1d4f7f$var$isDeferredResult(result)) result = await $f090f4785d1d4f7f$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $f090f4785d1d4f7f$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($f090f4785d1d4f7f$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $f090f4785d1d4f7f$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($f090f4785d1d4f7f$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $f090f4785d1d4f7f$export$3e9cee6b33872309(!$f090f4785d1d4f7f$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $f090f4785d1d4f7f$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $f090f4785d1d4f7f$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $f090f4785d1d4f7f$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $f090f4785d1d4f7f$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($f090f4785d1d4f7f$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $f090f4785d1d4f7f$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Replace : $f090f4785d1d4f7f$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $f090f4785d1d4f7f$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($f090f4785d1d4f7f$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $f090f4785d1d4f7f$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $f090f4785d1d4f7f$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $f090f4785d1d4f7f$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $f090f4785d1d4f7f$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($f090f4785d1d4f7f$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $f090f4785d1d4f7f$var$ResultType.redirect,
                        response: $f090f4785d1d4f7f$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $f090f4785d1d4f7f$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $f090f4785d1d4f7f$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $f090f4785d1d4f7f$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $f090f4785d1d4f7f$var$ResultType.error,
                    error: $f090f4785d1d4f7f$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $f090f4785d1d4f7f$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $f090f4785d1d4f7f$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $f090f4785d1d4f7f$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $f090f4785d1d4f7f$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $f090f4785d1d4f7f$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $f090f4785d1d4f7f$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $f090f4785d1d4f7f$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $f090f4785d1d4f7f$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $f090f4785d1d4f7f$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $f090f4785d1d4f7f$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $f090f4785d1d4f7f$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $f090f4785d1d4f7f$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $f090f4785d1d4f7f$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $f090f4785d1d4f7f$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        let matches = discoverResult.partialMatches;
        let route = matches[matches.length - 1].route;
        let error = $f090f4785d1d4f7f$var$getInternalRouterError(400, {
            type: "route-discovery",
            routeId: route.id,
            pathname: pathname,
            message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
        });
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $f090f4785d1d4f7f$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$f090f4785d1d4f7f$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnMissImpl) {
            if (!matches) {
                let fogMatches = $f090f4785d1d4f7f$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else {
                let leafRoute = matches[matches.length - 1].route;
                if (leafRoute.path && (leafRoute.path === "*" || leafRoute.path.endsWith("/*"))) {
                    // If we matched a splat, it might only be because we haven't yet fetched
                    // the children that would match with a higher score, so let's fetch
                    // around and find out
                    let partialMatches = $f090f4785d1d4f7f$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    return {
                        active: true,
                        matches: partialMatches
                    };
                }
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        let route = partialMatches.length > 0 ? partialMatches[partialMatches.length - 1].route : null;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await $f090f4785d1d4f7f$var$loadLazyRouteChildren(patchRoutesOnMissImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $f090f4785d1d4f7f$export$2708184779ceb39d(routesToUse, pathname, basename);
            let matchedSplat = false;
            if (newMatches) {
                let leafRoute = newMatches[newMatches.length - 1].route;
                if (leafRoute.index) // If we found an index route, we can stop
                return {
                    type: "success",
                    matches: newMatches
                };
                if (leafRoute.path && leafRoute.path.length > 0) {
                    if (leafRoute.path === "*") // If we found a splat route, we can't be sure there's not a
                    // higher-scoring route down some partial matches trail so we need
                    // to check that out
                    matchedSplat = true;
                    else // If we found a non-splat route, we can stop
                    return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            let newPartialMatches = $f090f4785d1d4f7f$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // If we are no longer partially matching anything, this was either a
            // legit splat match above, or it's a 404.  Also avoid loops if the
            // second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.map((m)=>m.route.id).join("-") === newPartialMatches.map((m)=>m.route.id).join("-")) return {
                type: "success",
                matches: matchedSplat ? newMatches : null
            };
            partialMatches = newPartialMatches;
            route = partialMatches[partialMatches.length - 1].route;
            if (route.path === "*") // The splat is still our most accurate partial, so run with it
            return {
                type: "success",
                matches: partialMatches
            };
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $f090f4785d1d4f7f$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $f090f4785d1d4f7f$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $f090f4785d1d4f7f$export$4d0306f8f6a4585b = Symbol("deferred");
function $f090f4785d1d4f7f$export$3336b097a6fbc59a(routes, opts) {
    $f090f4785d1d4f7f$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f090f4785d1d4f7f$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $f090f4785d1d4f7f$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $f090f4785d1d4f7f$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f090f4785d1d4f7f$var$createLocation("", $f090f4785d1d4f7f$export$fe53371bee54353d(url), null, "default");
        let matches = $f090f4785d1d4f7f$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$f090f4785d1d4f7f$var$isValidMethod(method) && method !== "HEAD") {
            let error = $f090f4785d1d4f7f$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $f090f4785d1d4f7f$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $f090f4785d1d4f7f$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $f090f4785d1d4f7f$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($f090f4785d1d4f7f$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $f090f4785d1d4f7f$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f090f4785d1d4f7f$var$createLocation("", $f090f4785d1d4f7f$export$fe53371bee54353d(url), null, "default");
        let matches = $f090f4785d1d4f7f$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$f090f4785d1d4f7f$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $f090f4785d1d4f7f$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $f090f4785d1d4f7f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $f090f4785d1d4f7f$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $f090f4785d1d4f7f$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $f090f4785d1d4f7f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($f090f4785d1d4f7f$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$f090f4785d1d4f7f$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $f090f4785d1d4f7f$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($f090f4785d1d4f7f$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $f090f4785d1d4f7f$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $f090f4785d1d4f7f$var$isResponse(result) ? result : $f090f4785d1d4f7f$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($f090f4785d1d4f7f$var$isHandlerResult(e) && $f090f4785d1d4f7f$var$isResponse(e.result)) {
                if (e.type === $f090f4785d1d4f7f$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($f090f4785d1d4f7f$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $f090f4785d1d4f7f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f090f4785d1d4f7f$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $f090f4785d1d4f7f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($f090f4785d1d4f7f$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($f090f4785d1d4f7f$var$isDeferredResult(result)) {
            let error = $f090f4785d1d4f7f$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f090f4785d1d4f7f$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($f090f4785d1d4f7f$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($f090f4785d1d4f7f$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $f090f4785d1d4f7f$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $f090f4785d1d4f7f$var$_extends({}, context, {
                statusCode: $f090f4785d1d4f7f$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $f090f4785d1d4f7f$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $f090f4785d1d4f7f$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $f090f4785d1d4f7f$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $f090f4785d1d4f7f$var$isErrorResult(pendingActionResult[1]) ? $f090f4785d1d4f7f$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $f090f4785d1d4f7f$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $f090f4785d1d4f7f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $f090f4785d1d4f7f$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $f090f4785d1d4f7f$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $f090f4785d1d4f7f$var$callDataStrategyImpl(unstable_dataStrategy || $f090f4785d1d4f7f$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($f090f4785d1d4f7f$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $f090f4785d1d4f7f$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($f090f4785d1d4f7f$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $f090f4785d1d4f7f$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $f090f4785d1d4f7f$export$fec11da027c70692(routes, context, error) {
    let newContext = $f090f4785d1d4f7f$var$_extends({}, context, {
        statusCode: $f090f4785d1d4f7f$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $f090f4785d1d4f7f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $f090f4785d1d4f7f$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $f090f4785d1d4f7f$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $f090f4785d1d4f7f$export$cae722b0cc860f13(to ? to : ".", $f090f4785d1d4f7f$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $f090f4785d1d4f7f$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$f090f4785d1d4f7f$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $f090f4785d1d4f7f$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $f090f4785d1d4f7f$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $f090f4785d1d4f7f$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$f090f4785d1d4f7f$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$f090f4785d1d4f7f$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $f090f4785d1d4f7f$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $f090f4785d1d4f7f$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $f090f4785d1d4f7f$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$f090f4785d1d4f7f$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$f090f4785d1d4f7f$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $f090f4785d1d4f7f$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $f090f4785d1d4f7f$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $f090f4785d1d4f7f$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $f090f4785d1d4f7f$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $f090f4785d1d4f7f$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($f090f4785d1d4f7f$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $f090f4785d1d4f7f$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $f090f4785d1d4f7f$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $f090f4785d1d4f7f$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $f090f4785d1d4f7f$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $f090f4785d1d4f7f$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $f090f4785d1d4f7f$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $f090f4785d1d4f7f$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $f090f4785d1d4f7f$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($f090f4785d1d4f7f$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $f090f4785d1d4f7f$var$shouldRevalidateLoader(match, $f090f4785d1d4f7f$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $f090f4785d1d4f7f$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $f090f4785d1d4f7f$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $f090f4785d1d4f7f$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $f090f4785d1d4f7f$var$shouldRevalidateLoader(fetcherMatch, $f090f4785d1d4f7f$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $f090f4785d1d4f7f$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $f090f4785d1d4f7f$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $f090f4785d1d4f7f$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnMiss() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function $f090f4785d1d4f7f$var$loadLazyRouteChildren(patchRoutesOnMissImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnMissImpl({
                path: path,
                matches: matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) $f090f4785d1d4f7f$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && $f090f4785d1d4f7f$var$isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function $f090f4785d1d4f7f$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        $f090f4785d1d4f7f$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = $f090f4785d1d4f7f$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = $f090f4785d1d4f7f$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $f090f4785d1d4f7f$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $f090f4785d1d4f7f$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $f090f4785d1d4f7f$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$f090f4785d1d4f7f$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $f090f4785d1d4f7f$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $f090f4785d1d4f7f$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $f090f4785d1d4f7f$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $f090f4785d1d4f7f$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $f090f4785d1d4f7f$var$ResultType.data,
                    result: undefined
                });
            };
            return $f090f4785d1d4f7f$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$f090f4785d1d4f7f$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $f090f4785d1d4f7f$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $f090f4785d1d4f7f$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $f090f4785d1d4f7f$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $f090f4785d1d4f7f$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $f090f4785d1d4f7f$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $f090f4785d1d4f7f$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $f090f4785d1d4f7f$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $f090f4785d1d4f7f$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $f090f4785d1d4f7f$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($f090f4785d1d4f7f$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $f090f4785d1d4f7f$var$ResultType.error,
                error: e
            };
        }
        if (type === $f090f4785d1d4f7f$var$ResultType.error) return {
            type: $f090f4785d1d4f7f$var$ResultType.error,
            error: new $f090f4785d1d4f7f$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $f090f4785d1d4f7f$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $f090f4785d1d4f7f$var$ResultType.error) return {
        type: $f090f4785d1d4f7f$var$ResultType.error,
        error: result,
        statusCode: $f090f4785d1d4f7f$export$972111febbeef05b(result) ? result.status : status
    };
    if ($f090f4785d1d4f7f$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $f090f4785d1d4f7f$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $f090f4785d1d4f7f$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $f090f4785d1d4f7f$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $f090f4785d1d4f7f$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$f090f4785d1d4f7f$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $f090f4785d1d4f7f$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $f090f4785d1d4f7f$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($f090f4785d1d4f7f$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $f090f4785d1d4f7f$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $f090f4785d1d4f7f$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($f090f4785d1d4f7f$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $f090f4785d1d4f7f$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $f090f4785d1d4f7f$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $f090f4785d1d4f7f$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $f090f4785d1d4f7f$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $f090f4785d1d4f7f$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $f090f4785d1d4f7f$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $f090f4785d1d4f7f$export$3e9cee6b33872309(!$f090f4785d1d4f7f$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($f090f4785d1d4f7f$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $f090f4785d1d4f7f$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $f090f4785d1d4f7f$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($f090f4785d1d4f7f$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $f090f4785d1d4f7f$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $f090f4785d1d4f7f$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $f090f4785d1d4f7f$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($f090f4785d1d4f7f$var$isErrorResult(result)) {
            let boundaryMatch = $f090f4785d1d4f7f$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $f090f4785d1d4f7f$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($f090f4785d1d4f7f$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $f090f4785d1d4f7f$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($f090f4785d1d4f7f$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $f090f4785d1d4f7f$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $f090f4785d1d4f7f$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $f090f4785d1d4f7f$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $f090f4785d1d4f7f$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $f090f4785d1d4f7f$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $f090f4785d1d4f7f$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $f090f4785d1d4f7f$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $f090f4785d1d4f7f$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $f090f4785d1d4f7f$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `children()` function for ' + ("route `" + routeId + "` threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $f090f4785d1d4f7f$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $f090f4785d1d4f7f$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($f090f4785d1d4f7f$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $f090f4785d1d4f7f$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $f090f4785d1d4f7f$export$8ccf933b0513f8d0(path) : path;
    return $f090f4785d1d4f7f$export$fe53371bee54353d($f090f4785d1d4f7f$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $f090f4785d1d4f7f$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $f090f4785d1d4f7f$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $f090f4785d1d4f7f$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $f090f4785d1d4f7f$var$ResultType.data || result.type === $f090f4785d1d4f7f$var$ResultType.error);
}
function $f090f4785d1d4f7f$var$isRedirectHandlerResult(result) {
    return $f090f4785d1d4f7f$var$isResponse(result.result) && $f090f4785d1d4f7f$var$redirectStatusCodes.has(result.result.status);
}
function $f090f4785d1d4f7f$var$isDeferredResult(result) {
    return result.type === $f090f4785d1d4f7f$var$ResultType.deferred;
}
function $f090f4785d1d4f7f$var$isErrorResult(result) {
    return result.type === $f090f4785d1d4f7f$var$ResultType.error;
}
function $f090f4785d1d4f7f$var$isRedirectResult(result) {
    return (result && result.type) === $f090f4785d1d4f7f$var$ResultType.redirect;
}
function $f090f4785d1d4f7f$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $f090f4785d1d4f7f$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $f090f4785d1d4f7f$var$isRedirectResponse(result) {
    if (!$f090f4785d1d4f7f$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $f090f4785d1d4f7f$var$isValidMethod(method) {
    return $f090f4785d1d4f7f$var$validRequestMethods.has(method.toLowerCase());
}
function $f090f4785d1d4f7f$var$isMutationMethod(method) {
    return $f090f4785d1d4f7f$var$validMutationMethods.has(method.toLowerCase());
}
async function $f090f4785d1d4f7f$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$f090f4785d1d4f7f$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($f090f4785d1d4f7f$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $f090f4785d1d4f7f$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $f090f4785d1d4f7f$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $f090f4785d1d4f7f$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $f090f4785d1d4f7f$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $f090f4785d1d4f7f$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $f090f4785d1d4f7f$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $f090f4785d1d4f7f$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $f090f4785d1d4f7f$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $f090f4785d1d4f7f$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $f090f4785d1d4f7f$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $f090f4785d1d4f7f$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $f090f4785d1d4f7f$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $f090f4785d1d4f7f$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $f090f4785d1d4f7f$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $f090f4785d1d4f7f$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $f090f4785d1d4f7f$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $f090f4785d1d4f7f$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $f090f4785d1d4f7f$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($f090f4785d1d4f7f$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $f090f4785d1d4f7f$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($f090f4785d1d4f7f$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $f090f4785d1d4f7f$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});



parcelRegister("b3162", function(module, exports) {

$parcel$export(module.exports, "NetworkAnalyticsManager", () => $747a5a451ce8a867$export$d3f83786459e6799);

var $04Qjn = parcelRequire("04Qjn");

var $auPqo = parcelRequire("auPqo");
class $747a5a451ce8a867$export$d3f83786459e6799 {
    constructor(analyticsService){
        this.analyticsService = analyticsService;
    }
    trackError(error, params) {
        this.analyticsService.trackEvent({
            category: (0, $auPqo.AnalyticsCategory).ERROR,
            action: (0, $04Qjn.isApiError)(error) ? "serverError" : "networkError",
            params: (0, $04Qjn.isApiError)(error) ? [
                error.status,
                ...params ?? []
            ] : params
        });
    }
}

});

parcelRegister("5DLWq", function(module, exports) {

$parcel$export(module.exports, "AnnouncementManager", () => $24749a6e2b0f52b1$export$6acbaf3b9ae621ef);

var $1IWnK = parcelRequire("1IWnK");
class $24749a6e2b0f52b1$export$6acbaf3b9ae621ef {
    constructor(announcementService, announcementReceivedService){
        this.announcementService = announcementService;
        this.announcementReceivedService = announcementReceivedService;
        this._announcement = (0, $1IWnK.observable)(undefined);
        this.announcement = this._announcement.readOnly();
        this.loadingAnnouncementId = undefined;
        announcementReceivedService.onAnnouncementIdReceived.add(this.getAnnouncement.bind(this));
    }
    async markAsViewed(id) {
        await this.announcementService.markAsViewed(id);
        this._announcement.set(undefined);
    }
    async getAnnouncement(id) {
        if (id === this.loadingAnnouncementId) return;
        this.loadingAnnouncementId = id;
        this._announcement.set(await this.announcementService.getAnnouncement(id));
    }
}

});

parcelRegister("gV9DR", function(module, exports) {

$parcel$export(module.exports, "AnnouncementReceivedService", () => $b3f5f9c7231e1d8b$export$b0a0e092f64777b7);

var $gbSxu = parcelRequire("gbSxu");
class $b3f5f9c7231e1d8b$export$b0a0e092f64777b7 {
    constructor(){
        this.onAnnouncementIdReceived = new (0, $gbSxu.Signal)();
    }
}

});

parcelRegister("8HMyT", function(module, exports) {

$parcel$export(module.exports, "AnnouncementService", () => $237aeabd9849f93a$export$ad6c18669f3332b2);
class $237aeabd9849f93a$export$ad6c18669f3332b2 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async getAnnouncement(id) {
        const result = await this.apiService.get(`/me/announcements/strapi/${id}`);
        return result.data;
    }
    async markAsViewed(id) {
        await this.apiService.post(`/me/announcements/strapi/${id}/view`);
    }
}

});

parcelRegister("1MEPE", function(module, exports) {

$parcel$export(module.exports, "CognitoAuthService", () => $dd3406ad322a1bbb$export$737c6e4fac708ab);

var $eOSo1 = parcelRequire("eOSo1");

var $12cV0 = parcelRequire("12cV0");

var $iGCNG = parcelRequire("iGCNG");

var $hkC80 = parcelRequire("hkC80");

var $azfbQ = parcelRequire("azfbQ");

var $lTdpc = parcelRequire("lTdpc");
parcelRequire("lJ9F2");
var $5Hj4s = parcelRequire("5Hj4s");

var $1IWnK = parcelRequire("1IWnK");

var $gbSxu = parcelRequire("gbSxu");
const $dd3406ad322a1bbb$var$SEC_TO_MILLISEC = 1000;
class $dd3406ad322a1bbb$export$737c6e4fac708ab {
    constructor(cognitoServiceWrapper, userPoolProvider, networkActionsErrorsManager, cognitoMultiInfra){
        this.cognitoServiceWrapper = cognitoServiceWrapper;
        this.userPoolProvider = userPoolProvider;
        this.networkActionsErrorsManager = networkActionsErrorsManager;
        this.cognitoMultiInfra = cognitoMultiInfra;
        this._idToken = (0, $1IWnK.observable)(null);
        this._cognitoUser = (0, $1IWnK.observable)(null);
        this._cognitoUserAttributes = (0, $1IWnK.observable)([]);
        this.logger = (0, $eOSo1.getLogger)("\uD83E\uDDE0 [CognitoAuthService]");
        this.onSessionExpired = new (0, $gbSxu.Signal)();
    }
    async init() {
        const userPool = this.userPoolProvider.getUnsafePool();
        if ((0, $lTdpc.isNil)(userPool)) {
            this.logger.info("No user pool defined yet, skip session restoration");
            return;
        }
        try {
            const currentUser = userPool.getCurrentUser();
            if ((0, $lTdpc.isNotNil)(currentUser)) {
                const session = await this.cognitoServiceWrapper.getSession(currentUser);
                this._idToken.set(session.getIdToken());
                await this.updateUser(currentUser);
            }
        } catch (error) {
            this.logger.error("Refresh user failed", error);
            if ((0, $iGCNG.isCognitoError)(error) && error.code === (0, $iGCNG.CognitoErrorCode).NotAuthorizedException) this.onSessionExpired.dispatch();
        }
    }
    async isEmailAvailable(email) {
        return await this.cognitoMultiInfra.multipleInfraIsEmailAvailable(email);
    }
    // eslint-disable-next-line sonarjs/cognitive-complexity
    async loginEmail(email, password, onNewDevice) {
        try {
            const { cognitoUser: cognitoUser, cognitoUserSession: cognitoUserSession } = await this.cognitoMultiInfra.multipleInfraLoginEmail(email, password, this.updateUser.bind(this));
            await this.updateUser(cognitoUser);
            this._idToken.set(cognitoUserSession.getIdToken());
            const newDeviceUsed = this.getUserAttribute("custom:new_device") === "1";
            if (newDeviceUsed) {
                const deviceKey = cognitoUserSession.getAccessToken().payload.device_key;
                onNewDevice(deviceKey);
            }
        } catch (error) {
            let managedError;
            if ((0, $iGCNG.isCognitoError)(error)) {
                // report Too many attempts as specific message
                if (error.code === (0, $iGCNG.CognitoErrorCode).NotAuthorizedException && error.message === (0, $iGCNG.CognitoErrorMessage).PasswordAttemptsExceeded) managedError = new (0, $12cV0.TooManyAttemptsError)(error.message);
                else if (error.code === (0, $iGCNG.CognitoErrorCode).NotAuthorizedException || error.code === (0, $iGCNG.CognitoErrorCode).UserNotFoundException) managedError = new (0, $12cV0.IncorrectCredentialsError)("Incorrect username or password.");
                else if (error.code === (0, $iGCNG.CognitoErrorCode).UserNotConfirmedException) managedError = new (0, $12cV0.UserNotConfirmedError)(error.message);
            } else if (error instanceof (0, $12cV0.NewPasswordNeededError)) managedError = error;
            if ((0, $lTdpc.isNil)(managedError)) this.reportCognitoError(error);
            throw managedError ?? error;
        }
    }
    // eslint-disable-next-line sonarjs/cognitive-complexity
    async forgotPassword(email) {
        try {
            await this.cognitoMultiInfra.multipleInfraForgotPassword(email);
        } catch (error) {
            this.logger.debug("Forgot password failed", error);
            if ((0, $iGCNG.isCognitoError)(error)) {
                if (error.code === (0, $iGCNG.CognitoErrorCode).UserNotFoundException) throw new (0, $12cV0.UserNotFoundError)();
                // report Too many attempts as specific message
                if (error.code === (0, $iGCNG.CognitoErrorCode).LimitExceededException) throw new (0, $12cV0.SendLimitExceededError)(error.message);
                if (error.code === (0, $iGCNG.CognitoErrorCode).NotAuthorizedException) throw new (0, $12cV0.TemporaryPasswordError)(error.message);
                if (error.code === (0, $iGCNG.CognitoErrorCode).InvalidParameterException && error.message.includes("verified email")) throw new (0, $12cV0.UserNotConfirmedError)(error.message);
            }
            this.networkActionsErrorsManager.reportError(error);
            throw error;
        }
    }
    async newPassword(email, resetToken, newPassword) {
        return new Promise((resolve, reject)=>{
            const userPool = this.userPoolProvider.getPool();
            const userData = {
                Username: email,
                Pool: userPool
            };
            const cognitoUser = new (0, $5Hj4s.default)(userData);
            cognitoUser.confirmPassword(resetToken, newPassword, {
                onSuccess: ()=>{
                    resolve();
                },
                onFailure: (err)=>{
                    this.logger.debug("New password failed : " + err.name + "\n" + err.message || JSON.stringify(err));
                    if (err.name === "CodeMismatchException") reject(new (0, $12cV0.ResetPasswordCodeError)(err.message));
                    else if (err.name === "ExpiredCodeException") reject(new (0, $12cV0.ExpiredCodeError)(err.message));
                    else {
                        this.networkActionsErrorsManager.reportError(err);
                        reject(err);
                    }
                }
            });
        });
    }
    isAuthenticated() {
        return !!this._cognitoUser.get();
    }
    async getToken() {
        const token = this._idToken.get();
        if (token && token.getExpiration() * $dd3406ad322a1bbb$var$SEC_TO_MILLISEC < Date.now()) await this.refreshToken();
        return this._idToken.get()?.getJwtToken();
    }
    async refreshToken() {
        return new Promise((resolve, reject)=>{
            const currentUser = this._cognitoUser.get();
            if (currentUser) currentUser.getSession((error, session)=>{
                if (error) {
                    this.logger.warn("Error getting user session : " + JSON.stringify(error));
                    reject(error);
                } else if (session) {
                    const refreshToken = session.getRefreshToken();
                    currentUser.refreshSession(refreshToken, (error2, newSession)=>{
                        if (error2) {
                            this.logger.warn("Error refreshing session : " + JSON.stringify(error2));
                            reject(error2);
                        } else {
                            this._idToken.set(newSession.getIdToken());
                            resolve();
                        }
                    });
                }
            });
            else reject(new (0, $12cV0.UserNotDefinedError)("user not defined when refreshing token"));
        });
    }
    updateUser(user) {
        return new Promise((resolve)=>{
            this._cognitoUser.set(user);
            if (user) user.getUserAttributes((error, result)=>{
                if (!error && result) this._cognitoUserAttributes.set(result);
                resolve();
            });
            else {
                this._cognitoUserAttributes.set([]);
                resolve();
            }
        });
    }
    getUserAttribute(name) {
        return this._cognitoUserAttributes.get().find((attribute)=>attribute.Name === name)?.Value;
    }
    async logout() {
        this._cognitoUser.get()?.signOut();
        await this.updateUser(null);
        this._idToken.set(null);
    }
    async authOnSuccess(user, result, resolve, onNewDevice) {
        await this.updateUser(user);
        this._idToken.set(result.getIdToken());
        const newDeviceUsed = this.getUserAttribute("custom:new_device") === "1";
        if (newDeviceUsed) {
            const deviceKey = result.getAccessToken().payload["device_key"];
            onNewDevice(deviceKey);
        }
        resolve();
    }
    async authOnFailure(error, reject) {
        this.logger.warn("Authentication failed : " + (error.message || JSON.stringify(error)));
        switch(error.code){
            case "UserNotConfirmedException":
                reject(new (0, $12cV0.UserNotConfirmedError)(error.message));
                break;
            case "NotAuthorizedException":
                if (error.message === (0, $iGCNG.CognitoErrorMessage).PasswordAttemptsExceeded) reject(new (0, $12cV0.TooManyAttemptsError)(error.message));
                else reject(new (0, $12cV0.IncorrectCredentialsError)(error.message));
                break;
            case "UserNotFoundException":
                reject(new (0, $12cV0.UserNotFoundError)("The user doesn't exist"));
                break;
            default:
                this.networkActionsErrorsManager.reportError(error);
                reject(error);
                break;
        }
    }
    completeNewPasswordChallenge(newPassword, onNewDevice) {
        return new Promise((resolve, reject)=>{
            const currentUser = this._cognitoUser.get();
            if ((0, $lTdpc.isNotNil)(currentUser)) currentUser.completeNewPasswordChallenge(newPassword, null, {
                onSuccess: (result)=>this.authOnSuccess(currentUser, result, resolve, onNewDevice),
                onFailure: (error)=>this.authOnFailure(error, reject)
            });
            else reject(new (0, $12cV0.UserNotDefinedError)("user not defined when completing NewPasswordChallenge"));
        });
    }
    async changePassword(currentPassword, newPassword) {
        const currentUser = this._cognitoUser.get();
        if (!currentUser) throw new (0, $12cV0.UserNotDefinedError)("user not defined when changing password");
        try {
            await this.cognitoServiceWrapper.changePassword(currentUser, currentPassword, newPassword);
        } catch (error) {
            if ((0, $iGCNG.isCognitoError)(error) && error.code === (0, $iGCNG.CognitoErrorCode).NotAuthorizedException) throw new (0, $12cV0.NotAuthorizedCodeError)(error.message);
            this.reportCognitoError(error);
            throw error;
        }
    }
    async validateSignUpConfirmationCode(code, email) {
        this.logger.debug("Cognito validation");
        return new Promise((resolve, reject)=>{
            const userPool = this.userPoolProvider.getPool();
            const currentUser = new (0, $5Hj4s.default)({
                Username: email,
                Pool: userPool
            });
            currentUser.confirmRegistration(code, true, async (error)=>{
                if ((0, $lTdpc.isNil)(error)) resolve();
                else this.handleCognitoErrorCases(reject, resolve, error);
            });
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleCognitoErrorCases(reject, resolve, error) {
        this.logger.error("Error confirm registration", error);
        if ((0, $iGCNG.isCognitoError)(error)) switch(error.code){
            case (0, $iGCNG.CognitoErrorCode).ExpiredCodeException:
                reject(new (0, $12cV0.ExpiredCodeError)(error.message));
                break;
            case (0, $iGCNG.CognitoErrorCode).NotAuthorizedException:
                // case user is already confirmed. skip confirmation step and continue signup process (access token & backend registration)
                if (error.message.includes((0, $iGCNG.CognitoErrorMessage).AlreadyConfirmed)) resolve();
                else reject(new (0, $12cV0.NotAuthorizedCodeError)(error.message));
                break;
            case (0, $iGCNG.CognitoErrorCode).CodeMismatchException:
                reject(new (0, $12cV0.CodeMismatchError)(error.message));
                break;
            default:
                this.reportCognitoError(error);
                reject(error);
        }
        else {
            this.reportCognitoError(error);
            reject(error);
        }
    }
    reportCognitoError(error) {
        this.logger.error("reporting a cognito error", error);
        this.networkActionsErrorsManager.reportError((0, $iGCNG.isCognitoError)(error) && error.code === (0, $iGCNG.CognitoErrorCode).NetworkErrorException ? new (0, $azfbQ.NoNetworkError)("Cognito no network") : error);
    }
    async signUpEmail(email, password, userAttributes) {
        const cognitoUserAttributes = (0, $hkC80.createCognitoUserAttributes)({
            ...userAttributes,
            email: email
        });
        return new Promise((resolve, reject)=>{
            const userPool = this.userPoolProvider.getPool();
            userPool.signUp(email, password, cognitoUserAttributes, [], async (error, result)=>{
                if (error) {
                    this.logger.error("Signup Error : ", error);
                    if ((0, $iGCNG.isCognitoError)(error) && error.code === (0, $iGCNG.CognitoErrorCode).LimitExceededException) reject(new (0, $12cV0.LimitExceededCodeError)(error.message));
                    else if ((0, $iGCNG.isCognitoError)(error) && error.code === (0, $iGCNG.CognitoErrorCode).UsernameExistsException) reject(new (0, $12cV0.UsernameExistsCodeError)(error.message));
                    else {
                        this.reportCognitoError(error);
                        reject(error);
                    }
                } else if (!result) {
                    this.logger.error("signUp error: no user");
                    const nullUserError = new Error("signUp error: no user");
                    this.reportCognitoError(nullUserError);
                    reject(nullUserError);
                } else {
                    await this.updateUser(result.user);
                    resolve();
                }
            });
        });
    }
    async resendSignUpValidationCode(email) {
        const userPool = this.userPoolProvider.getPool();
        const currentUser = new (0, $5Hj4s.default)({
            Username: email,
            Pool: userPool
        });
        try {
            await this.cognitoServiceWrapper.resendConfirmationCode(currentUser);
            await this.updateUser(currentUser);
        } catch (error) {
            this.logger.error("Error resending confirmation code", error);
            if ((0, $iGCNG.isCognitoError)(error) && error.code === (0, $iGCNG.CognitoErrorCode).LimitExceededException) throw new (0, $12cV0.LimitExceededCodeError)(error.message);
            else {
                this.reportCognitoError(error);
                throw error;
            }
        }
    }
    getRegistrationUserAttributes() {
        const userAttributes = this._cognitoUserAttributes.get();
        return (0, $hkC80.getRegistrationUserAttributes)(userAttributes);
    }
}
var $dd3406ad322a1bbb$var$CognitoAttributes;
(function(CognitoAttributes) {
    CognitoAttributes["Email"] = "email";
    CognitoAttributes["Locale"] = "locale";
    CognitoAttributes["NewDevice"] = "custom:new_device";
})($dd3406ad322a1bbb$var$CognitoAttributes || ($dd3406ad322a1bbb$var$CognitoAttributes = {}));

});
parcelRegister("12cV0", function(module, exports) {

$parcel$export(module.exports, "IncorrectCredentialsError", () => $cc455df4e3e9b01e$export$645908c55cd07d26);
$parcel$export(module.exports, "TooManyAttemptsError", () => $cc455df4e3e9b01e$export$f96087197eebedb4);
$parcel$export(module.exports, "NewPasswordNeededError", () => $cc455df4e3e9b01e$export$28abf795601818d5);
$parcel$export(module.exports, "UserNotConfirmedError", () => $cc455df4e3e9b01e$export$6d80209b4496db2c);
$parcel$export(module.exports, "ResetPasswordCodeError", () => $cc455df4e3e9b01e$export$69876bf69667ef5d);
$parcel$export(module.exports, "ExpiredCodeError", () => $cc455df4e3e9b01e$export$23121f32e7d918b4);
$parcel$export(module.exports, "UserNotDefinedError", () => $cc455df4e3e9b01e$export$b0af3dc0daeb9f00);
$parcel$export(module.exports, "UserNotFoundError", () => $cc455df4e3e9b01e$export$7333e7db5e5d49a);
$parcel$export(module.exports, "LimitExceededCodeError", () => $cc455df4e3e9b01e$export$6c7241276d3260b9);
$parcel$export(module.exports, "TemporaryPasswordError", () => $cc455df4e3e9b01e$export$480518c31292e9bb);
$parcel$export(module.exports, "SendLimitExceededError", () => $cc455df4e3e9b01e$export$695c8b2459a3d248);
$parcel$export(module.exports, "UsernameExistsCodeError", () => $cc455df4e3e9b01e$export$b148526c1d314cf5);
$parcel$export(module.exports, "NotAuthorizedCodeError", () => $cc455df4e3e9b01e$export$3c3a2904fd603540);
$parcel$export(module.exports, "CodeMismatchError", () => $cc455df4e3e9b01e$export$53759c54e787b12a);
$parcel$export(module.exports, "UserInMultipleInfractureError", () => $cc455df4e3e9b01e$export$741547fadc328e77);
class $cc455df4e3e9b01e$export$645908c55cd07d26 extends Error {
    constructor(message){
        super(message);
    }
}
class $cc455df4e3e9b01e$export$f96087197eebedb4 extends Error {
    constructor(message){
        super(message);
    }
}
class $cc455df4e3e9b01e$export$28abf795601818d5 extends Error {
    constructor(message){
        super(message);
    }
}
class $cc455df4e3e9b01e$export$6d80209b4496db2c extends Error {
    constructor(message){
        super(message);
    }
}
class $cc455df4e3e9b01e$export$69876bf69667ef5d extends Error {
    constructor(message){
        super(message);
    }
}
class $cc455df4e3e9b01e$export$23121f32e7d918b4 extends Error {
    constructor(message){
        super(message);
    }
}
class $cc455df4e3e9b01e$export$b0af3dc0daeb9f00 extends Error {
    constructor(message){
        super(message);
    }
}
class $cc455df4e3e9b01e$export$7333e7db5e5d49a extends Error {
    constructor(message){
        super(message);
    }
}
class $cc455df4e3e9b01e$export$6c7241276d3260b9 extends Error {
    constructor(message){
        super(message);
    }
}
class $cc455df4e3e9b01e$export$480518c31292e9bb extends Error {
    constructor(message){
        super(message);
    }
}
class $cc455df4e3e9b01e$export$695c8b2459a3d248 extends Error {
    constructor(message){
        super(message);
    }
}
class $cc455df4e3e9b01e$export$b148526c1d314cf5 extends Error {
    constructor(message){
        super(message);
    }
}
class $cc455df4e3e9b01e$export$3c3a2904fd603540 extends Error {
    constructor(message){
        super(message);
    }
}
class $cc455df4e3e9b01e$export$53759c54e787b12a extends Error {
    constructor(message){
        super(message);
    }
}
class $cc455df4e3e9b01e$export$741547fadc328e77 extends Error {
    constructor(message){
        super(message);
    }
}

});

parcelRegister("iGCNG", function(module, exports) {

$parcel$export(module.exports, "isCognitoError", () => $3ced3fce6eea01f6$export$ff274599b958bb6);
$parcel$export(module.exports, "CognitoErrorCode", () => $3ced3fce6eea01f6$export$48986d9f5cf996ee);
$parcel$export(module.exports, "CognitoErrorMessage", () => $3ced3fce6eea01f6$export$2b944f25384c33a6);

var $gMt2l = parcelRequire("gMt2l");
function $3ced3fce6eea01f6$export$ff274599b958bb6(error) {
    if (error === null || error === undefined || typeof error !== "object") return false;
    if (!(0, $gMt2l.hasOwnProperty)(error, "code") || typeof error.code !== "string") return false;
    if (!(0, $gMt2l.hasOwnProperty)(error, "message") || typeof error.message !== "string") return false;
    return true;
}
var $3ced3fce6eea01f6$export$48986d9f5cf996ee;
(function(CognitoErrorCode) {
    CognitoErrorCode["NotAuthorizedException"] = "NotAuthorizedException";
    CognitoErrorCode["UserNotFoundException"] = "UserNotFoundException";
    CognitoErrorCode["UserNotConfirmedException"] = "UserNotConfirmedException";
    CognitoErrorCode["InvalidParameterException"] = "InvalidParameterException";
    CognitoErrorCode["CodeMismatchException"] = "CodeMismatchException";
    CognitoErrorCode["ExpiredCodeException"] = "ExpiredCodeException";
    CognitoErrorCode["LimitExceededException"] = "LimitExceededException";
    CognitoErrorCode["UsernameExistsException"] = "UsernameExistsException";
    CognitoErrorCode["NetworkErrorException"] = "NetworkError";
})($3ced3fce6eea01f6$export$48986d9f5cf996ee || ($3ced3fce6eea01f6$export$48986d9f5cf996ee = {}));
var $3ced3fce6eea01f6$export$2b944f25384c33a6;
(function(CognitoErrorMessage) {
    CognitoErrorMessage["PasswordAttemptsExceeded"] = "Password attempts exceeded";
    CognitoErrorMessage["AlreadyConfirmed"] = "Current status is CONFIRMED";
})($3ced3fce6eea01f6$export$2b944f25384c33a6 || ($3ced3fce6eea01f6$export$2b944f25384c33a6 = {}));

});

parcelRegister("hkC80", function(module, exports) {

$parcel$export(module.exports, "getRegistrationUserAttributes", () => $90d6bd2c029df30f$export$39a0eae3619ff4da);
$parcel$export(module.exports, "createCognitoUserAttributes", () => $90d6bd2c029df30f$export$c48fa746080350a4);

var $lTdpc = parcelRequire("lTdpc");
parcelRequire("lJ9F2");
var $1UnWp = parcelRequire("1UnWp");
const $90d6bd2c029df30f$export$39a0eae3619ff4da = (userAttributes)=>{
    const getUserAttribute = (name)=>userAttributes.find((attribute)=>attribute.Name === name)?.Value;
    const locale = getUserAttribute("locale");
    const countryCode = getUserAttribute("custom:country_code");
    const agreeToPhysiomeEmails = getUserAttribute("custom:physiome_emails");
    const agreeToBiogenEmails = getUserAttribute("custom:biogen_emails");
    const touVersion = getUserAttribute("custom:tou_version");
    const pnVersion = getUserAttribute("custom:pn_version");
    const invitationId = getUserAttribute("custom:invitation_id");
    if ((0, $lTdpc.isNil)(locale)) return null;
    if ((0, $lTdpc.isNil)(countryCode)) return null;
    if ((0, $lTdpc.isNil)(agreeToPhysiomeEmails)) return null;
    if ((0, $lTdpc.isNil)(agreeToBiogenEmails)) return null;
    if ((0, $lTdpc.isNil)(touVersion)) return null;
    if ((0, $lTdpc.isNil)(pnVersion)) return null;
    return $90d6bd2c029df30f$var$deserializationRegistrationUserAttributes({
        locale: locale,
        countryCode: countryCode,
        agreeToBiogenEmails: agreeToBiogenEmails,
        agreeToPhysiomeEmails: agreeToPhysiomeEmails,
        touVersion: touVersion,
        pnVersion: pnVersion,
        invitationId: invitationId
    });
};
const $90d6bd2c029df30f$export$c48fa746080350a4 = (userAttributes)=>{
    const serializedUserAttributes = $90d6bd2c029df30f$var$serializeRegistrationUserAttributes(userAttributes);
    const attributesList = [
        new (0, $1UnWp.default)({
            Name: "email",
            Value: userAttributes.email
        }),
        new (0, $1UnWp.default)({
            Name: "locale",
            Value: serializedUserAttributes.locale
        }),
        new (0, $1UnWp.default)({
            Name: "custom:country_code",
            Value: serializedUserAttributes.countryCode
        }),
        new (0, $1UnWp.default)({
            Name: "custom:physiome_emails",
            Value: serializedUserAttributes.agreeToPhysiomeEmails
        }),
        new (0, $1UnWp.default)({
            Name: "custom:biogen_emails",
            Value: serializedUserAttributes.agreeToBiogenEmails
        }),
        new (0, $1UnWp.default)({
            Name: "custom:tou_version",
            Value: serializedUserAttributes.touVersion
        }),
        new (0, $1UnWp.default)({
            Name: "custom:pn_version",
            Value: serializedUserAttributes.pnVersion
        })
    ];
    if ((0, $lTdpc.isNotNil)(serializedUserAttributes.invitationId)) attributesList.push(new (0, $1UnWp.default)({
        Name: "custom:invitation_id",
        Value: serializedUserAttributes.invitationId
    }));
    return attributesList;
};
const $90d6bd2c029df30f$var$serializeRegistrationUserAttributes = (userAttributes)=>({
        locale: userAttributes.locale.replace("-", "_"),
        countryCode: userAttributes.countryCode,
        agreeToPhysiomeEmails: userAttributes.agreeToPhysiomeEmails ? "1" : "0",
        agreeToBiogenEmails: userAttributes.agreeToBiogenEmails ? "1" : "0",
        touVersion: userAttributes.touVersion.toString(),
        pnVersion: userAttributes.pnVersion.toString(),
        invitationId: userAttributes.invitationId
    });
const $90d6bd2c029df30f$var$deserializationRegistrationUserAttributes = (serializedUserAttributes)=>({
        locale: serializedUserAttributes.locale.replace("_", "-"),
        countryCode: serializedUserAttributes.countryCode,
        agreeToPhysiomeEmails: serializedUserAttributes.agreeToPhysiomeEmails === "1",
        agreeToBiogenEmails: serializedUserAttributes.agreeToBiogenEmails === "1",
        touVersion: parseInt(serializedUserAttributes.touVersion),
        pnVersion: parseInt(serializedUserAttributes.pnVersion.toString()),
        invitationId: serializedUserAttributes.invitationId
    });
var $90d6bd2c029df30f$var$RegistrationCognitoAttributes;
(function(RegistrationCognitoAttributes) {
    RegistrationCognitoAttributes["Email"] = "email";
    RegistrationCognitoAttributes["Locale"] = "locale";
    RegistrationCognitoAttributes["CountryCode"] = "custom:country_code";
    RegistrationCognitoAttributes["AgreeToPhysiomeEmails"] = "custom:physiome_emails";
    RegistrationCognitoAttributes["AgreeToBiogenEmails"] = "custom:biogen_emails";
    RegistrationCognitoAttributes["TouVersion"] = "custom:tou_version";
    RegistrationCognitoAttributes["PnVersion"] = "custom:pn_version";
    RegistrationCognitoAttributes["InvitationId"] = "custom:invitation_id";
    RegistrationCognitoAttributes["NewDevice"] = "custom:new_device";
})($90d6bd2c029df30f$var$RegistrationCognitoAttributes || ($90d6bd2c029df30f$var$RegistrationCognitoAttributes = {}));

});
parcelRegister("lJ9F2", function(module, exports) {

$parcel$export(module.exports, "AuthenticationDetails", () => (parcelRequire("3XzuU")).default);
$parcel$export(module.exports, "CognitoUser", () => (parcelRequire("5Hj4s")).default);
$parcel$export(module.exports, "CognitoUserAttribute", () => (parcelRequire("1UnWp")).default);
$parcel$export(module.exports, "CognitoUserPool", () => (parcelRequire("dNjJr")).default);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $3XzuU = parcelRequire("3XzuU");

var $l3UJv = parcelRequire("l3UJv");

var $3krSj = parcelRequire("3krSj");

var $d4tWG = parcelRequire("d4tWG");

var $iXW9s = parcelRequire("iXW9s");

var $5Hj4s = parcelRequire("5Hj4s");

var $1UnWp = parcelRequire("1UnWp");

var $dNjJr = parcelRequire("dNjJr");

var $2NjOD = parcelRequire("2NjOD");

var $02Di9 = parcelRequire("02Di9");

var $6qkqJ = parcelRequire("6qkqJ");

var $kerV5 = parcelRequire("kerV5");

var $1y40d = parcelRequire("1y40d");

});
parcelRegister("3XzuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e226adb295bb4be$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $2e226adb295bb4be$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {string} the record's password
   */ ;
    _proto.getPassword = function getPassword() {
        return this.password;
    } /**
   * @returns {Array} the record's validationData
   */ ;
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    } /**
   * @returns {Array} the record's authParameters
   */ ;
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    } /**
   * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
   */ ;
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();

});

parcelRegister("l3UJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f555e2c0338d21f5$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $vD8K9 = parcelRequire("vD8K9");

var $6H3gU = parcelRequire("6H3gU");
parcelRequire("ca2vu");

var $kBJeJ = parcelRequire("kBJeJ");

var $40qEb = parcelRequire("40qEb");

var $1y40d = parcelRequire("1y40d");

var $j9sBo = parcelRequire("j9sBo");
/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function $f555e2c0338d21f5$var$randomBytes(nBytes) {
    return (0, $vD8K9.Buffer).from(new (0, $1y40d.default)().random(nBytes).toString(), "hex");
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var $f555e2c0338d21f5$var$HEX_MSB_REGEX = /^[89a-f]/i;
var $f555e2c0338d21f5$var$initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var $f555e2c0338d21f5$var$newPasswordRequiredChallengeUserAttributePrefix = "userAttributes.";
/** @class */ var $f555e2c0338d21f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, $j9sBo.default)($f555e2c0338d21f5$var$initN, 16);
        this.g = new (0, $j9sBo.default)("2", 16);
        this.k = new (0, $j9sBo.default)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, $vD8K9.Buffer).from("Caldera Derived Key", "utf8");
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    } /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */ ;
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    } /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */ ;
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = $f555e2c0338d21f5$var$randomBytes(128).toString("hex");
        var randomBigInt = new (0, $j9sBo.default)(hexRandom, 16);
        // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    } /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */ ;
    _proto.generateRandomString = function generateRandomString() {
        return $f555e2c0338d21f5$var$randomBytes(40).toString("base64");
    } /**
   * @returns {string} Generated random value included in password hash.
   */ ;
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    } /**
   * @returns {string} Generated random value included in devices hash.
   */ ;
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    } /**
   * @returns {string} Value used to verify devices.
   */ ;
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    } /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */ ;
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = $f555e2c0338d21f5$var$randomBytes(16).toString("hex");
        // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, $j9sBo.default)(hexRandom, 16));
        this.g.modPow(new (0, $j9sBo.default)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    } /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */ ;
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, $j9sBo.default).ZERO)) callback(new Error("Illegal paramater. A mod N cannot be 0."), null);
            callback(null, A);
        });
    } /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */ ;
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, $j9sBo.default)(this.UHexHash, 16);
        return finalU;
    } /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hash = function hash(buf) {
        var str = buf instanceof (0, $vD8K9.Buffer) ? (0, (/*@__PURE__*/$parcel$interopDefault($6H3gU))).lib.WordArray.create(buf) : buf;
        var hashHex = (0, (/*@__PURE__*/$parcel$interopDefault($kBJeJ)))(str).toString();
        return new Array(64 - hashHex.length).join("0") + hashHex;
    } /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, $vD8K9.Buffer).from(hexStr, "hex"));
    } /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */ ;
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsWordArray = (0, (/*@__PURE__*/$parcel$interopDefault($6H3gU))).lib.WordArray.create((0, $vD8K9.Buffer).concat([
            this.infoBits,
            (0, $vD8K9.Buffer).from(String.fromCharCode(1), "utf8")
        ]));
        var ikmWordArray = ikm instanceof (0, $vD8K9.Buffer) ? (0, (/*@__PURE__*/$parcel$interopDefault($6H3gU))).lib.WordArray.create(ikm) : ikm;
        var saltWordArray = salt instanceof (0, $vD8K9.Buffer) ? (0, (/*@__PURE__*/$parcel$interopDefault($6H3gU))).lib.WordArray.create(salt) : salt;
        var prk = (0, (/*@__PURE__*/$parcel$interopDefault($40qEb)))(ikmWordArray, saltWordArray);
        var hmac = (0, (/*@__PURE__*/$parcel$interopDefault($40qEb)))(infoBitsWordArray, prk);
        return (0, $vD8K9.Buffer).from(hmac.toString(), "hex").slice(0, 16);
    } /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */ ;
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, $j9sBo.default).ZERO)) throw new Error("B cannot be zero.");
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, $j9sBo.default).ZERO)) throw new Error("U cannot be zero.");
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, $j9sBo.default)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, $vD8K9.Buffer).from(_this4.padHex(sValue), "hex"), (0, $vD8K9.Buffer).from(_this4.padHex(_this4.UValue), "hex"));
            callback(null, hkdf);
        });
    } /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    } /**
   * Return constant newPasswordRequiredChallengeUserAttributePrefix
   * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
   */ ;
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return $f555e2c0338d21f5$var$newPasswordRequiredChallengeUserAttributePrefix;
    } /**
   * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
   *
   * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
   * byte array containing the two's-complement representation of a BigInteger. The array contains
   * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
   *
   * Examples showing how ambiguity is avoided by left padding with:
   * 	"00" (for positive values where the most-significant-bit is set)
   *  "FF" (for negative values where the most-significant-bit is set)
   *
   * padHex(bigInteger.fromInt(-236))  === "FF14"
   * padHex(bigInteger.fromInt(20))    === "14"
   *
   * padHex(bigInteger.fromInt(-200))  === "FF38"
   * padHex(bigInteger.fromInt(56))    === "38"
   *
   * padHex(bigInteger.fromInt(-20))   === "EC"
   * padHex(bigInteger.fromInt(236))   === "00EC"
   *
   * padHex(bigInteger.fromInt(-56))   === "C8"
   * padHex(bigInteger.fromInt(200))   === "00C8"
   *
   * @param {BigInteger} bigInt Number to encode.
   * @returns {String} even-length hex string of the two's complement encoding.
   */ ;
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, $j9sBo.default))) throw new Error("Not a BigInteger");
        var isNegative = bigInt.compareTo((0, $j9sBo.default).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = $f555e2c0338d21f5$var$HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split("").map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return "0123456789ABCDEF".charAt(invertedNibble);
            }).join("");
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, $j9sBo.default)(invertedNibbles, 16).add((0, $j9sBo.default).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();

});
parcelRegister("vD8K9", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $05f141c20a408f73$export$a143d493d941bafc, (v) => $05f141c20a408f73$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $05f141c20a408f73$export$f99ded8fe4b79145, (v) => $05f141c20a408f73$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $05f141c20a408f73$export$a143d493d941bafc;
var $05f141c20a408f73$export$e4cf37d7f6fb9e0a;
var $05f141c20a408f73$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $05f141c20a408f73$export$599f31c3813fae4d;
"use strict";

var $4iGWZ = parcelRequire("4iGWZ");

var $dx5XB = parcelRequire("dx5XB");

var $jcRjg = parcelRequire("jcRjg");
$05f141c20a408f73$export$a143d493d941bafc = $05f141c20a408f73$var$Buffer;
$05f141c20a408f73$export$e4cf37d7f6fb9e0a = $05f141c20a408f73$var$SlowBuffer;
$05f141c20a408f73$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $05f141c20a408f73$var$typedArraySupport();
$05f141c20a408f73$export$599f31c3813fae4d = $05f141c20a408f73$var$kMaxLength();
function $05f141c20a408f73$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $05f141c20a408f73$var$kMaxLength() {
    return $05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $05f141c20a408f73$var$createBuffer(that, length) {
    if ($05f141c20a408f73$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $05f141c20a408f73$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $05f141c20a408f73$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $05f141c20a408f73$var$Buffer(arg, encodingOrOffset, length) {
    if (!$05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $05f141c20a408f73$var$Buffer)) return new $05f141c20a408f73$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $05f141c20a408f73$var$allocUnsafe(this, arg);
    }
    return $05f141c20a408f73$var$from(this, arg, encodingOrOffset, length);
}
$05f141c20a408f73$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$05f141c20a408f73$var$Buffer._augment = function(arr) {
    arr.__proto__ = $05f141c20a408f73$var$Buffer.prototype;
    return arr;
};
function $05f141c20a408f73$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $05f141c20a408f73$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $05f141c20a408f73$var$fromString(that, value, encodingOrOffset);
    return $05f141c20a408f73$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $05f141c20a408f73$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $05f141c20a408f73$var$from(null, value, encodingOrOffset, length);
};
if ($05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $05f141c20a408f73$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $05f141c20a408f73$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $05f141c20a408f73$var$Buffer[Symbol.species] === $05f141c20a408f73$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($05f141c20a408f73$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $05f141c20a408f73$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $05f141c20a408f73$var$alloc(that, size, fill, encoding) {
    $05f141c20a408f73$var$assertSize(size);
    if (size <= 0) return $05f141c20a408f73$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $05f141c20a408f73$var$createBuffer(that, size).fill(fill, encoding) : $05f141c20a408f73$var$createBuffer(that, size).fill(fill);
    return $05f141c20a408f73$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $05f141c20a408f73$var$Buffer.alloc = function(size, fill, encoding) {
    return $05f141c20a408f73$var$alloc(null, size, fill, encoding);
};
function $05f141c20a408f73$var$allocUnsafe(that, size) {
    $05f141c20a408f73$var$assertSize(size);
    that = $05f141c20a408f73$var$createBuffer(that, size < 0 ? 0 : $05f141c20a408f73$var$checked(size) | 0);
    if (!$05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $05f141c20a408f73$var$Buffer.allocUnsafe = function(size) {
    return $05f141c20a408f73$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $05f141c20a408f73$var$Buffer.allocUnsafeSlow = function(size) {
    return $05f141c20a408f73$var$allocUnsafe(null, size);
};
function $05f141c20a408f73$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$05f141c20a408f73$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $05f141c20a408f73$var$byteLength(string, encoding) | 0;
    that = $05f141c20a408f73$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $05f141c20a408f73$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $05f141c20a408f73$var$checked(array.length) | 0;
    that = $05f141c20a408f73$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $05f141c20a408f73$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $05f141c20a408f73$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $05f141c20a408f73$var$fromArrayLike(that, array);
    return that;
}
function $05f141c20a408f73$var$fromObject(that, obj) {
    if ($05f141c20a408f73$var$Buffer.isBuffer(obj)) {
        var len = $05f141c20a408f73$var$checked(obj.length) | 0;
        that = $05f141c20a408f73$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $05f141c20a408f73$var$isnan(obj.length)) return $05f141c20a408f73$var$createBuffer(that, 0);
            return $05f141c20a408f73$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $jcRjg(obj.data)) return $05f141c20a408f73$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $05f141c20a408f73$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $05f141c20a408f73$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $05f141c20a408f73$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $05f141c20a408f73$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $05f141c20a408f73$var$Buffer.alloc(+length);
}
$05f141c20a408f73$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$05f141c20a408f73$var$Buffer.compare = function compare(a, b) {
    if (!$05f141c20a408f73$var$Buffer.isBuffer(a) || !$05f141c20a408f73$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$05f141c20a408f73$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$05f141c20a408f73$var$Buffer.concat = function concat(list, length) {
    if (!$jcRjg(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $05f141c20a408f73$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $05f141c20a408f73$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$05f141c20a408f73$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $05f141c20a408f73$var$byteLength(string, encoding) {
    if ($05f141c20a408f73$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $05f141c20a408f73$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $05f141c20a408f73$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $05f141c20a408f73$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$05f141c20a408f73$var$Buffer.byteLength = $05f141c20a408f73$var$byteLength;
function $05f141c20a408f73$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $05f141c20a408f73$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $05f141c20a408f73$var$utf8Slice(this, start, end);
        case "ascii":
            return $05f141c20a408f73$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $05f141c20a408f73$var$latin1Slice(this, start, end);
        case "base64":
            return $05f141c20a408f73$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $05f141c20a408f73$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$05f141c20a408f73$var$Buffer.prototype._isBuffer = true;
function $05f141c20a408f73$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$05f141c20a408f73$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$05f141c20a408f73$var$swap(this, i, i + 1);
    return this;
};
$05f141c20a408f73$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $05f141c20a408f73$var$swap(this, i, i + 3);
        $05f141c20a408f73$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$05f141c20a408f73$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $05f141c20a408f73$var$swap(this, i, i + 7);
        $05f141c20a408f73$var$swap(this, i + 1, i + 6);
        $05f141c20a408f73$var$swap(this, i + 2, i + 5);
        $05f141c20a408f73$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$05f141c20a408f73$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $05f141c20a408f73$var$utf8Slice(this, 0, length);
    return $05f141c20a408f73$var$slowToString.apply(this, arguments);
};
$05f141c20a408f73$var$Buffer.prototype.equals = function equals(b) {
    if (!$05f141c20a408f73$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $05f141c20a408f73$var$Buffer.compare(this, b) === 0;
};
$05f141c20a408f73$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $05f141c20a408f73$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$05f141c20a408f73$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$05f141c20a408f73$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $05f141c20a408f73$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $05f141c20a408f73$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($05f141c20a408f73$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $05f141c20a408f73$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $05f141c20a408f73$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $05f141c20a408f73$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$05f141c20a408f73$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$05f141c20a408f73$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $05f141c20a408f73$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$05f141c20a408f73$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $05f141c20a408f73$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $05f141c20a408f73$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $05f141c20a408f73$var$utf8Write(buf, string, offset, length) {
    return $05f141c20a408f73$var$blitBuffer($05f141c20a408f73$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $05f141c20a408f73$var$asciiWrite(buf, string, offset, length) {
    return $05f141c20a408f73$var$blitBuffer($05f141c20a408f73$var$asciiToBytes(string), buf, offset, length);
}
function $05f141c20a408f73$var$latin1Write(buf, string, offset, length) {
    return $05f141c20a408f73$var$asciiWrite(buf, string, offset, length);
}
function $05f141c20a408f73$var$base64Write(buf, string, offset, length) {
    return $05f141c20a408f73$var$blitBuffer($05f141c20a408f73$var$base64ToBytes(string), buf, offset, length);
}
function $05f141c20a408f73$var$ucs2Write(buf, string, offset, length) {
    return $05f141c20a408f73$var$blitBuffer($05f141c20a408f73$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$05f141c20a408f73$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $05f141c20a408f73$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $05f141c20a408f73$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $05f141c20a408f73$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $05f141c20a408f73$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $05f141c20a408f73$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $05f141c20a408f73$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$05f141c20a408f73$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $05f141c20a408f73$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $4iGWZ.fromByteArray(buf);
    else return $4iGWZ.fromByteArray(buf.slice(start, end));
}
function $05f141c20a408f73$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $05f141c20a408f73$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $05f141c20a408f73$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $05f141c20a408f73$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $05f141c20a408f73$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $05f141c20a408f73$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $05f141c20a408f73$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $05f141c20a408f73$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $05f141c20a408f73$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $05f141c20a408f73$var$toHex(buf[i]);
    return out;
}
function $05f141c20a408f73$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$05f141c20a408f73$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $05f141c20a408f73$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $05f141c20a408f73$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $05f141c20a408f73$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$05f141c20a408f73$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$05f141c20a408f73$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$05f141c20a408f73$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$05f141c20a408f73$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$05f141c20a408f73$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$05f141c20a408f73$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$05f141c20a408f73$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$05f141c20a408f73$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$05f141c20a408f73$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$05f141c20a408f73$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$05f141c20a408f73$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$05f141c20a408f73$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$05f141c20a408f73$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$05f141c20a408f73$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$05f141c20a408f73$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, 4, this.length);
    return $dx5XB.read(this, offset, true, 23, 4);
};
$05f141c20a408f73$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, 4, this.length);
    return $dx5XB.read(this, offset, false, 23, 4);
};
$05f141c20a408f73$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, 8, this.length);
    return $dx5XB.read(this, offset, true, 52, 8);
};
$05f141c20a408f73$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $05f141c20a408f73$var$checkOffset(offset, 8, this.length);
    return $dx5XB.read(this, offset, false, 52, 8);
};
function $05f141c20a408f73$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$05f141c20a408f73$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$05f141c20a408f73$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $05f141c20a408f73$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$05f141c20a408f73$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $05f141c20a408f73$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$05f141c20a408f73$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $05f141c20a408f73$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $05f141c20a408f73$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$05f141c20a408f73$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $05f141c20a408f73$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $05f141c20a408f73$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$05f141c20a408f73$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $05f141c20a408f73$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $05f141c20a408f73$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $05f141c20a408f73$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$05f141c20a408f73$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $05f141c20a408f73$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $05f141c20a408f73$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$05f141c20a408f73$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $05f141c20a408f73$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $05f141c20a408f73$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$05f141c20a408f73$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $05f141c20a408f73$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$05f141c20a408f73$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $05f141c20a408f73$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$05f141c20a408f73$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $05f141c20a408f73$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$05f141c20a408f73$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $05f141c20a408f73$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $05f141c20a408f73$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$05f141c20a408f73$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $05f141c20a408f73$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $05f141c20a408f73$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$05f141c20a408f73$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $05f141c20a408f73$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $05f141c20a408f73$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$05f141c20a408f73$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $05f141c20a408f73$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $05f141c20a408f73$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $05f141c20a408f73$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $05f141c20a408f73$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $05f141c20a408f73$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dx5XB.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$05f141c20a408f73$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $05f141c20a408f73$var$writeFloat(this, value, offset, true, noAssert);
};
$05f141c20a408f73$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $05f141c20a408f73$var$writeFloat(this, value, offset, false, noAssert);
};
function $05f141c20a408f73$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $05f141c20a408f73$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dx5XB.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$05f141c20a408f73$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $05f141c20a408f73$var$writeDouble(this, value, offset, true, noAssert);
};
$05f141c20a408f73$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $05f141c20a408f73$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$05f141c20a408f73$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$05f141c20a408f73$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$05f141c20a408f73$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$05f141c20a408f73$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $05f141c20a408f73$var$Buffer.isBuffer(val) ? val : $05f141c20a408f73$var$utf8ToBytes(new $05f141c20a408f73$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $05f141c20a408f73$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $05f141c20a408f73$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $05f141c20a408f73$var$stringtrim(str).replace($05f141c20a408f73$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $05f141c20a408f73$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $05f141c20a408f73$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $05f141c20a408f73$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $05f141c20a408f73$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $05f141c20a408f73$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $05f141c20a408f73$var$base64ToBytes(str) {
    return $4iGWZ.toByteArray($05f141c20a408f73$var$base64clean(str));
}
function $05f141c20a408f73$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $05f141c20a408f73$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

});
parcelRegister("4iGWZ", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $321a28f3eed92d90$export$d622b2ad8d90c771, (v) => $321a28f3eed92d90$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $321a28f3eed92d90$export$6100ba28696e12de, (v) => $321a28f3eed92d90$export$6100ba28696e12de = v);
var $321a28f3eed92d90$export$a48f0734ac7c2329;
var $321a28f3eed92d90$export$d622b2ad8d90c771;
var $321a28f3eed92d90$export$6100ba28696e12de;
"use strict";
$321a28f3eed92d90$export$a48f0734ac7c2329 = $321a28f3eed92d90$var$byteLength;
$321a28f3eed92d90$export$d622b2ad8d90c771 = $321a28f3eed92d90$var$toByteArray;
$321a28f3eed92d90$export$6100ba28696e12de = $321a28f3eed92d90$var$fromByteArray;
var $321a28f3eed92d90$var$lookup = [];
var $321a28f3eed92d90$var$revLookup = [];
var $321a28f3eed92d90$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $321a28f3eed92d90$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $321a28f3eed92d90$var$i = 0, $321a28f3eed92d90$var$len = $321a28f3eed92d90$var$code.length; $321a28f3eed92d90$var$i < $321a28f3eed92d90$var$len; ++$321a28f3eed92d90$var$i){
    $321a28f3eed92d90$var$lookup[$321a28f3eed92d90$var$i] = $321a28f3eed92d90$var$code[$321a28f3eed92d90$var$i];
    $321a28f3eed92d90$var$revLookup[$321a28f3eed92d90$var$code.charCodeAt($321a28f3eed92d90$var$i)] = $321a28f3eed92d90$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$321a28f3eed92d90$var$revLookup["-".charCodeAt(0)] = 62;
$321a28f3eed92d90$var$revLookup["_".charCodeAt(0)] = 63;
function $321a28f3eed92d90$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $321a28f3eed92d90$var$byteLength(b64) {
    var lens = $321a28f3eed92d90$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $321a28f3eed92d90$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $321a28f3eed92d90$var$toByteArray(b64) {
    var tmp;
    var lens = $321a28f3eed92d90$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $321a28f3eed92d90$var$Arr($321a28f3eed92d90$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $321a28f3eed92d90$var$revLookup[b64.charCodeAt(i)] << 18 | $321a28f3eed92d90$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $321a28f3eed92d90$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $321a28f3eed92d90$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $321a28f3eed92d90$var$revLookup[b64.charCodeAt(i)] << 2 | $321a28f3eed92d90$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $321a28f3eed92d90$var$revLookup[b64.charCodeAt(i)] << 10 | $321a28f3eed92d90$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $321a28f3eed92d90$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $321a28f3eed92d90$var$tripletToBase64(num) {
    return $321a28f3eed92d90$var$lookup[num >> 18 & 0x3F] + $321a28f3eed92d90$var$lookup[num >> 12 & 0x3F] + $321a28f3eed92d90$var$lookup[num >> 6 & 0x3F] + $321a28f3eed92d90$var$lookup[num & 0x3F];
}
function $321a28f3eed92d90$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($321a28f3eed92d90$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $321a28f3eed92d90$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($321a28f3eed92d90$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($321a28f3eed92d90$var$lookup[tmp >> 2] + $321a28f3eed92d90$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($321a28f3eed92d90$var$lookup[tmp >> 10] + $321a28f3eed92d90$var$lookup[tmp >> 4 & 0x3F] + $321a28f3eed92d90$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("dx5XB", function(module, exports) {

$parcel$export(module.exports, "read", () => $9da2fb09b4343a75$export$aafa59e2e03f2942, (v) => $9da2fb09b4343a75$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $9da2fb09b4343a75$export$68d8715fc104d294, (v) => $9da2fb09b4343a75$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $9da2fb09b4343a75$export$aafa59e2e03f2942;
var $9da2fb09b4343a75$export$68d8715fc104d294;
$9da2fb09b4343a75$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$9da2fb09b4343a75$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});

parcelRegister("jcRjg", function(module, exports) {
var $dfb87d7f8b6b3d62$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $dfb87d7f8b6b3d62$var$toString.call(arr) == "[object Array]";
};

});


parcelRegister("6H3gU", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("rPOe1"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});
parcelRegister("rPOe1", function(module, exports) {
"use strict";

});


parcelRegister("ca2vu", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("6H3gU")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != "function") return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("kBJeJ", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("6H3gU")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("40qEb", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("6H3gU")), (parcelRequire("kBJeJ")), (parcelRequire("b7LlM")));
})(this, function(CryptoJS) {
    return CryptoJS.HmacSHA256;
});

});
parcelRegister("b7LlM", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("6H3gU")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});


parcelRegister("1y40d", function(module, exports) {

$parcel$export(module.exports, "default", () => $120c123c28b6eea2$export$2e2bcd8739ae039);

var $04rP0 = parcelRequire("04rP0");
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $120c123c28b6eea2$var$hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes;
    // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
var $120c123c28b6eea2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, $04rP0.default)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return $120c123c28b6eea2$var$hexStringify(this);
    };
    return WordArray;
}();

});
parcelRegister("04rP0", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d5f4a518b0e091$export$2e2bcd8739ae039);
var $00d5f4a518b0e091$var$crypto;
// Native crypto from window (Browser)
if (typeof window !== "undefined" && window.crypto) $00d5f4a518b0e091$var$crypto = window.crypto;
// Native (experimental IE 11) crypto from window (Browser)
if (!$00d5f4a518b0e091$var$crypto && typeof window !== "undefined" && window.msCrypto) $00d5f4a518b0e091$var$crypto = window.msCrypto;
// Native crypto from global (NodeJS)
if (!$00d5f4a518b0e091$var$crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) $00d5f4a518b0e091$var$crypto = $parcel$global.crypto;

// Native crypto import via require (NodeJS)
if (!$00d5f4a518b0e091$var$crypto && true) try {
    $00d5f4a518b0e091$var$crypto = (parcelRequire("rPOe1"));
} catch (err) {}
function $00d5f4a518b0e091$export$2e2bcd8739ae039() {
    if ($00d5f4a518b0e091$var$crypto) {
        // Use getRandomValues method (Browser)
        if (typeof $00d5f4a518b0e091$var$crypto.getRandomValues === "function") try {
            return $00d5f4a518b0e091$var$crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
        // Use randomBytes method (NodeJS)
        if (typeof $00d5f4a518b0e091$var$crypto.randomBytes === "function") try {
            return $00d5f4a518b0e091$var$crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error("Native crypto module could not be used to get secure random number.");
}

});


parcelRegister("j9sBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $df150b5963694486$export$2e2bcd8739ae039);
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var $df150b5963694486$export$2e2bcd8739ae039 = $df150b5963694486$var$BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $df150b5963694486$var$BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $df150b5963694486$var$nbi() {
    return new $df150b5963694486$var$BigInteger(null);
}
// Bits per digit
var $df150b5963694486$var$dbits;
// JavaScript engine analysis
var $df150b5963694486$var$canary = 0xdeadbeefcafe;
var $df150b5963694486$var$j_lm = ($df150b5963694486$var$canary & 0xffffff) == 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $df150b5963694486$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $df150b5963694486$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $df150b5963694486$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var $df150b5963694486$var$inBrowser = typeof navigator !== "undefined";
if ($df150b5963694486$var$inBrowser && $df150b5963694486$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    $df150b5963694486$var$BigInteger.prototype.am = $df150b5963694486$var$am2;
    $df150b5963694486$var$dbits = 30;
} else if ($df150b5963694486$var$inBrowser && $df150b5963694486$var$j_lm && navigator.appName != "Netscape") {
    $df150b5963694486$var$BigInteger.prototype.am = $df150b5963694486$var$am1;
    $df150b5963694486$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $df150b5963694486$var$BigInteger.prototype.am = $df150b5963694486$var$am3;
    $df150b5963694486$var$dbits = 28;
}
$df150b5963694486$var$BigInteger.prototype.DB = $df150b5963694486$var$dbits;
$df150b5963694486$var$BigInteger.prototype.DM = (1 << $df150b5963694486$var$dbits) - 1;
$df150b5963694486$var$BigInteger.prototype.DV = 1 << $df150b5963694486$var$dbits;
var $df150b5963694486$var$BI_FP = 52;
$df150b5963694486$var$BigInteger.prototype.FV = Math.pow(2, $df150b5963694486$var$BI_FP);
$df150b5963694486$var$BigInteger.prototype.F1 = $df150b5963694486$var$BI_FP - $df150b5963694486$var$dbits;
$df150b5963694486$var$BigInteger.prototype.F2 = 2 * $df150b5963694486$var$dbits - $df150b5963694486$var$BI_FP;
// Digit conversions
var $df150b5963694486$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $df150b5963694486$var$BI_RC = new Array();
var $df150b5963694486$var$rr, $df150b5963694486$var$vv;
$df150b5963694486$var$rr = "0".charCodeAt(0);
for($df150b5963694486$var$vv = 0; $df150b5963694486$var$vv <= 9; ++$df150b5963694486$var$vv)$df150b5963694486$var$BI_RC[$df150b5963694486$var$rr++] = $df150b5963694486$var$vv;
$df150b5963694486$var$rr = "a".charCodeAt(0);
for($df150b5963694486$var$vv = 10; $df150b5963694486$var$vv < 36; ++$df150b5963694486$var$vv)$df150b5963694486$var$BI_RC[$df150b5963694486$var$rr++] = $df150b5963694486$var$vv;
$df150b5963694486$var$rr = "A".charCodeAt(0);
for($df150b5963694486$var$vv = 10; $df150b5963694486$var$vv < 36; ++$df150b5963694486$var$vv)$df150b5963694486$var$BI_RC[$df150b5963694486$var$rr++] = $df150b5963694486$var$vv;
function $df150b5963694486$var$int2char(n) {
    return $df150b5963694486$var$BI_RM.charAt(n);
}
function $df150b5963694486$var$intAt(s, i) {
    var c = $df150b5963694486$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $df150b5963694486$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $df150b5963694486$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $df150b5963694486$var$nbv(i) {
    var r = $df150b5963694486$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $df150b5963694486$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = $df150b5963694486$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $df150b5963694486$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $df150b5963694486$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $df150b5963694486$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $df150b5963694486$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $df150b5963694486$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $df150b5963694486$var$bnNegate() {
    var r = $df150b5963694486$var$nbi();
    $df150b5963694486$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $df150b5963694486$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $df150b5963694486$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $df150b5963694486$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $df150b5963694486$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $df150b5963694486$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $df150b5963694486$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $df150b5963694486$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $df150b5963694486$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $df150b5963694486$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $df150b5963694486$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $df150b5963694486$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $df150b5963694486$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $df150b5963694486$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $df150b5963694486$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $df150b5963694486$var$nbi();
    var y = $df150b5963694486$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $df150b5963694486$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $df150b5963694486$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $df150b5963694486$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $df150b5963694486$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $df150b5963694486$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $df150b5963694486$var$bnMod(a) {
    var r = $df150b5963694486$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($df150b5963694486$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $df150b5963694486$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $df150b5963694486$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
// (protected) r = this + a
function $df150b5963694486$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $df150b5963694486$var$bnAdd(a) {
    var r = $df150b5963694486$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $df150b5963694486$var$bnSubtract(a) {
    var r = $df150b5963694486$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $df150b5963694486$var$bnMultiply(a) {
    var r = $df150b5963694486$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $df150b5963694486$var$bnDivide(a) {
    var r = $df150b5963694486$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $df150b5963694486$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $df150b5963694486$var$montConvert(x) {
    var r = $df150b5963694486$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($df150b5963694486$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $df150b5963694486$var$montRevert(x) {
    var r = $df150b5963694486$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $df150b5963694486$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $df150b5963694486$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $df150b5963694486$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$df150b5963694486$var$Montgomery.prototype.convert = $df150b5963694486$var$montConvert;
$df150b5963694486$var$Montgomery.prototype.revert = $df150b5963694486$var$montRevert;
$df150b5963694486$var$Montgomery.prototype.reduce = $df150b5963694486$var$montReduce;
$df150b5963694486$var$Montgomery.prototype.mulTo = $df150b5963694486$var$montMulTo;
$df150b5963694486$var$Montgomery.prototype.sqrTo = $df150b5963694486$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $df150b5963694486$var$bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = $df150b5963694486$var$nbv(1), z = new $df150b5963694486$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $df150b5963694486$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $df150b5963694486$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $df150b5963694486$var$nbi(), t;
    i = $df150b5963694486$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$df150b5963694486$var$BigInteger.prototype.copyTo = $df150b5963694486$var$bnpCopyTo;
$df150b5963694486$var$BigInteger.prototype.fromInt = $df150b5963694486$var$bnpFromInt;
$df150b5963694486$var$BigInteger.prototype.fromString = $df150b5963694486$var$bnpFromString;
$df150b5963694486$var$BigInteger.prototype.clamp = $df150b5963694486$var$bnpClamp;
$df150b5963694486$var$BigInteger.prototype.dlShiftTo = $df150b5963694486$var$bnpDLShiftTo;
$df150b5963694486$var$BigInteger.prototype.drShiftTo = $df150b5963694486$var$bnpDRShiftTo;
$df150b5963694486$var$BigInteger.prototype.lShiftTo = $df150b5963694486$var$bnpLShiftTo;
$df150b5963694486$var$BigInteger.prototype.rShiftTo = $df150b5963694486$var$bnpRShiftTo;
$df150b5963694486$var$BigInteger.prototype.subTo = $df150b5963694486$var$bnpSubTo;
$df150b5963694486$var$BigInteger.prototype.multiplyTo = $df150b5963694486$var$bnpMultiplyTo;
$df150b5963694486$var$BigInteger.prototype.squareTo = $df150b5963694486$var$bnpSquareTo;
$df150b5963694486$var$BigInteger.prototype.divRemTo = $df150b5963694486$var$bnpDivRemTo;
$df150b5963694486$var$BigInteger.prototype.invDigit = $df150b5963694486$var$bnpInvDigit;
$df150b5963694486$var$BigInteger.prototype.addTo = $df150b5963694486$var$bnpAddTo;
// public
$df150b5963694486$var$BigInteger.prototype.toString = $df150b5963694486$var$bnToString;
$df150b5963694486$var$BigInteger.prototype.negate = $df150b5963694486$var$bnNegate;
$df150b5963694486$var$BigInteger.prototype.abs = $df150b5963694486$var$bnAbs;
$df150b5963694486$var$BigInteger.prototype.compareTo = $df150b5963694486$var$bnCompareTo;
$df150b5963694486$var$BigInteger.prototype.bitLength = $df150b5963694486$var$bnBitLength;
$df150b5963694486$var$BigInteger.prototype.mod = $df150b5963694486$var$bnMod;
$df150b5963694486$var$BigInteger.prototype.equals = $df150b5963694486$var$bnEquals;
$df150b5963694486$var$BigInteger.prototype.add = $df150b5963694486$var$bnAdd;
$df150b5963694486$var$BigInteger.prototype.subtract = $df150b5963694486$var$bnSubtract;
$df150b5963694486$var$BigInteger.prototype.multiply = $df150b5963694486$var$bnMultiply;
$df150b5963694486$var$BigInteger.prototype.divide = $df150b5963694486$var$bnDivide;
$df150b5963694486$var$BigInteger.prototype.modPow = $df150b5963694486$var$bnModPow;
// "constants"
$df150b5963694486$var$BigInteger.ZERO = $df150b5963694486$var$nbv(0);
$df150b5963694486$var$BigInteger.ONE = $df150b5963694486$var$nbv(1);

});


parcelRegister("3krSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $26c8dcba0610e737$export$2e2bcd8739ae039);

var $307OC = parcelRequire("307OC");
function $26c8dcba0610e737$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $26c8dcba0610e737$var$_setPrototypeOf(subClass, superClass);
}
function $26c8dcba0610e737$var$_setPrototypeOf(o, p) {
    $26c8dcba0610e737$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $26c8dcba0610e737$var$_setPrototypeOf(o, p);
}
/** @class */ var $26c8dcba0610e737$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $26c8dcba0610e737$var$_inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || "") || this;
    }
    return CognitoAccessToken;
}((0, $307OC.default));

});
parcelRegister("307OC", function(module, exports) {

$parcel$export(module.exports, "default", () => $22f76f2bc297c625$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $vD8K9 = parcelRequire("vD8K9");
/** @class */ var $22f76f2bc297c625$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || "";
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    } /**
   * @returns {int} the token's expiration (exp member).
   */ ;
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    } /**
   * @returns {int} the token's "issued at" (iat member).
   */ ;
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    } /**
   * @returns {object} the token's payload.
   */ ;
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split(".")[1];
        try {
            return JSON.parse((0, $vD8K9.Buffer).from(payload, "base64").toString("utf8"));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();

});


parcelRegister("d4tWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9842e0a0f4c35862$export$2e2bcd8739ae039);

var $307OC = parcelRequire("307OC");
function $9842e0a0f4c35862$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $9842e0a0f4c35862$var$_setPrototypeOf(subClass, superClass);
}
function $9842e0a0f4c35862$var$_setPrototypeOf(o, p) {
    $9842e0a0f4c35862$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9842e0a0f4c35862$var$_setPrototypeOf(o, p);
}
/** @class */ var $9842e0a0f4c35862$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $9842e0a0f4c35862$var$_inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || "") || this;
    }
    return CognitoIdToken;
}((0, $307OC.default));

});

parcelRegister("iXW9s", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcead8595255cce9$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $dcead8595255cce9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || "";
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();

});

parcelRegister("5Hj4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $425fc2fb1dfcf511$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $vD8K9 = parcelRequire("vD8K9");

var $6H3gU = parcelRequire("6H3gU");
parcelRequire("ca2vu");

var $6EZmq = parcelRequire("6EZmq");

var $40qEb = parcelRequire("40qEb");

var $j9sBo = parcelRequire("j9sBo");

var $l3UJv = parcelRequire("l3UJv");

var $3krSj = parcelRequire("3krSj");

var $d4tWG = parcelRequire("d4tWG");

var $iXW9s = parcelRequire("iXW9s");

var $2NjOD = parcelRequire("2NjOD");

var $6qkqJ = parcelRequire("6qkqJ");

var $1UnWp = parcelRequire("1UnWp");

var $7Ow9L = parcelRequire("7Ow9L");
/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var $425fc2fb1dfcf511$var$isBrowser = typeof navigator !== "undefined";
var $425fc2fb1dfcf511$var$userAgent = $425fc2fb1dfcf511$var$isBrowser ? navigator.userAgent : "nodejs";
/** @class */ var $425fc2fb1dfcf511$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error("Username and Pool information are required.");
        this.username = data.Username || "";
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = "USER_SRP_AUTH";
        this.storage = data.Storage || new (0, $7Ow9L.default)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    } /**
   * @returns {CognitoUserSession} the current session for this user
   */ ;
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    } /**
   * @returns {string} the user's username
   */ ;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {String} the authentication flow type
   */ ;
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    } /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */ ;
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    } /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "CUSTOM_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === "CUSTOM_CHALLENGE") {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    } /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === "USER_PASSWORD_AUTH") return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH") return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error("Authentication flow type is invalid."));
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, $l3UJv.default)(this.pool.getUserPoolName());
        var dateHelper = new (0, $6qkqJ.default)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === "CUSTOM_AUTH") authParameters.CHALLENGE_NAME = "SRP_A";
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request("InitiateAuth", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, $j9sBo.default)(challengeParameters.SRP_B, 16);
                salt = new (0, $j9sBo.default)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($6H3gU))).lib.WordArray.create((0, $vD8K9.Buffer).concat([
                        (0, $vD8K9.Buffer).from(_this2.pool.getUserPoolName(), "utf8"),
                        (0, $vD8K9.Buffer).from(_this2.username, "utf8"),
                        (0, $vD8K9.Buffer).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $vD8K9.Buffer).from(dateNow, "utf8")
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($6H3gU))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($6EZmq))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($40qEb)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request("RespondToAuthChallenge", challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === "ResourceNotFoundException" && errChallenge.message.toLowerCase().indexOf("device") !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: "PASSWORD_VERIFIER",
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error("PASSWORD parameter is required"));
            return;
        }
        var authenticationHelper = new (0, $l3UJv.default)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "USER_PASSWORD_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
        // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} dataAuthenticate authentication data
   * @param {object} authenticationHelper helper created
   * @param {callback} callback passed on from caller
   * @returns {void}
   */ ;
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === "SMS_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === "SELECT_MFA_TYPE") {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === "MFA_SETUP") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === "SOFTWARE_TOKEN_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === "CUSTOM_CHALLENGE") {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === "NEW_PASSWORD_REQUIRED") {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === "DEVICE_SRP_AUTH") {
            this.Session = dataAuthenticate.Session;
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, $vD8K9.Buffer).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                PasswordVerifier: (0, $vD8K9.Buffer).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request("ConfirmDevice", {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: $425fc2fb1dfcf511$var$userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    } /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error("New password is required."));
        var authenticationHelper = new (0, $l3UJv.default)(this.pool.getUserPoolName());
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: "NEW_PASSWORD_REQUIRED",
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    } /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   * @private
   */ ;
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, $l3UJv.default)(this.deviceGroupKey);
        var dateHelper = new (0, $6qkqJ.default)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: "DEVICE_SRP_AUTH",
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata,
                Session: _this6.Session
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, $j9sBo.default)(challengeParameters.SRP_B, 16);
                var salt = new (0, $j9sBo.default)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($6H3gU))).lib.WordArray.create((0, $vD8K9.Buffer).concat([
                        (0, $vD8K9.Buffer).from(_this6.deviceGroupKey, "utf8"),
                        (0, $vD8K9.Buffer).from(_this6.deviceKey, "utf8"),
                        (0, $vD8K9.Buffer).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $vD8K9.Buffer).from(dateNow, "utf8")
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($6H3gU))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($6EZmq))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($40qEb)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request("RespondToAuthChallenge", jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmSignUp", jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
    } /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, $l3UJv.default)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: "CUSTOM_CHALLENGE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    } /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || "SMS_MFA";
        if (mfaTypeSelection === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === "DEVICE_SRP_AUTH") {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, $l3UJv.default)(_this8.pool.getUserPoolName());
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, $vD8K9.Buffer).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                    PasswordVerifier: (0, $vD8K9.Buffer).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request("ConfirmDevice", {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: $425fc2fb1dfcf511$var$userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    } /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("ChangePassword", {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: "SMS",
            AttributeName: "phone_number"
        };
        mfaOptions.push(mfaEnabled);
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("SetUserMFAPreference", {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("UpdateUserAttributes", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this10.getUserData(function() {
                return callback(null, "SUCCESS");
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, $1UnWp.default)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    } /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata);
            else resolve();
        });
    } /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @returns {void}
   */ ;
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error("User is not authenticated"), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    } /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        var _this14 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUserAttributes", {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this14.getUserData(function() {
                return callback(null, "SUCCESS");
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request("ResendConfirmationCode", jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    } /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @returns {void}
   */ ;
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error("Username is null. Cannot retrieve a new session"), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, $d4tWG.default)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, $3krSj.default)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, $iXW9s.default)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, $2NjOD.default)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error("Cannot retrieve a new session. Please authenticate."), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata);
        } else callback(new Error("Local storage is missing an ID Token, Please authenticate"), null);
        return undefined;
    } /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this15 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: "REFRESH_TOKEN_AUTH",
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === "NotAuthorizedException") _this15.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, "RefreshToken")) authenticationResult.RefreshToken = refreshToken.getToken();
                _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
                _this15.cacheTokens();
                return wrappedCallback(null, _this15.signInUserSession);
            }
            return undefined;
        });
    } /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */ ;
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    } /**
   * This is to cache user data
   */ ;
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    } /**
   * This is to remove cached user data
   */ ;
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    } /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */ ;
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    } /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */ ;
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    } /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    } /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    } /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */ ;
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, $d4tWG.default)(authResult);
        var accessToken = new (0, $3krSj.default)(authResult);
        var refreshToken = new (0, $iXW9s.default)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, $2NjOD.default)(sessionData);
    } /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ForgotPassword", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    } /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmForgotPassword", jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
    } /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetUserAttributeVerificationCode", {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("VerifyUserAttribute", {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */ ;
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("ForgetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this16 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this16.deviceKey = null;
                _this16.deviceGroupKey = null;
                _this16.randomPassword = null;
                _this16.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    } /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "not_remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */ ;
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request("ListDevices", requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this17 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GlobalSignOut", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this17.clearCachedUser();
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */ ;
    _proto.signOut = function signOut(revokeTokenCallback) {
        var _this18 = this;
        // If tokens won't be revoked, we just clean the client data.
        if (!revokeTokenCallback || typeof revokeTokenCallback !== "function") {
            this.cleanClientData();
            return;
        }
        this.getSession(function(error, _session) {
            if (error) return revokeTokenCallback(error);
            _this18.revokeTokens(function(err) {
                _this18.cleanClientData();
                revokeTokenCallback(err);
            });
        });
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        if (typeof revokeTokenCallback !== "function") throw new Error("Invalid revokeTokenCallback. It should be a function.");
        var tokensToBeRevoked = [];
        if (!this.signInUserSession) {
            var error = new Error("User is not authenticated");
            return revokeTokenCallback(error);
        }
        if (!this.signInUserSession.getAccessToken()) {
            var _error = new Error("No Access token available");
            return revokeTokenCallback(_error);
        }
        var refreshToken = this.signInUserSession.getRefreshToken().getToken();
        var accessToken = this.signInUserSession.getAccessToken();
        if (this.isSessionRevocable(accessToken)) {
            if (refreshToken) return this.revokeToken({
                token: refreshToken,
                callback: revokeTokenCallback
            });
        }
        revokeTokenCallback();
    };
    _proto.isSessionRevocable = function isSessionRevocable(token) {
        if (token && typeof token.decodePayload === "function") try {
            var _token$decodePayload2 = token.decodePayload(), origin_jti = _token$decodePayload2.origin_jti;
            return !!origin_jti;
        } catch (err) {
        // Nothing to do, token doesnt have origin_jti claim
        }
        return false;
    };
    _proto.cleanClientData = function cleanClientData() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.revokeToken = function revokeToken(_ref2) {
        var token = _ref2.token, callback = _ref2.callback;
        this.client.requestWithRetry("RevokeToken", {
            Token: token,
            ClientId: this.pool.getClientId()
        }, function(err) {
            if (err) return callback(err);
            callback();
        });
    } /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this19 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: "SELECT_MFA_TYPE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            if (answerChallenge === "SMS_MFA") return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === "SOFTWARE_TOKEN_MFA") return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    } /**
   * This returns the user context data for advanced security feature.
   * @returns {string} the user context data from CognitoUserPool
   */ ;
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    } /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this20 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("AssociateSoftwareToken", {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this20.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request("AssociateSoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    } /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this21 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("VerifySoftwareToken", {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this21.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this21.username;
            var jsonReq = {
                ChallengeName: "MFA_SETUP",
                ClientId: _this21.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this21.Session
            };
            if (_this21.getUserContextData()) jsonReq.UserContextData = _this21.getUserContextData();
            _this21.client.request("RespondToAuthChallenge", jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this21.cacheTokens();
                return callback.onSuccess(_this21.signInUserSession);
            });
            return undefined;
        });
        else this.client.request("VerifySoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();

});
parcelRegister("6EZmq", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("6H3gU")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("2NjOD", function(module, exports) {

$parcel$export(module.exports, "default", () => $208f8757f9c6672a$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $208f8757f9c6672a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error("Id token and Access Token must be present.");
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    } /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */ ;
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    } /**
   * @returns {CognitoAccessToken} the session's access token
   */ ;
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    } /**
   * @returns {int} the session's clock drift
   */ ;
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    } /**
   * @returns {int} the computer's clock drift
   */ ;
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    } /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */ ;
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();

});

parcelRegister("6qkqJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ad504c6cc093926$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $4ad504c6cc093926$var$monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $4ad504c6cc093926$var$weekNames = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
/** @class */ var $4ad504c6cc093926$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = $4ad504c6cc093926$var$weekNames[now.getUTCDay()];
        var month = $4ad504c6cc093926$var$monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear();
        // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();

});

parcelRegister("1UnWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $163d9796ad1b4619$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $163d9796ad1b4619$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || "";
        this.Value = Value || "";
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    } /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    } /**
   * @returns {string} the record's name.
   */ ;
    _proto.getName = function getName() {
        return this.Name;
    } /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    } /**
   * @returns {string} a string representation of the record.
   */ ;
    _proto.toString = function toString() {
        return JSON.stringify(this);
    } /**
   * @returns {object} a flat object representing the record.
   */ ;
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();

});

parcelRegister("7Ow9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b062589e0e5fd00$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $5b062589e0e5fd00$var$dataMemory = {};
var $5b062589e0e5fd00$export$d7392285c701ecf5 = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        $5b062589e0e5fd00$var$dataMemory[key] = value;
        return $5b062589e0e5fd00$var$dataMemory[key];
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call($5b062589e0e5fd00$var$dataMemory, key) ? $5b062589e0e5fd00$var$dataMemory[key] : undefined;
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */ ;
    MemoryStorage.removeItem = function removeItem(key) {
        return delete $5b062589e0e5fd00$var$dataMemory[key];
    } /**
   * This is used to clear the storage
   * @returns {string} nothing
   */ ;
    MemoryStorage.clear = function clear() {
        $5b062589e0e5fd00$var$dataMemory = {};
        return $5b062589e0e5fd00$var$dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var $5b062589e0e5fd00$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.cognito.test-ls", 1);
            this.storageWindow.removeItem("aws.cognito.test-ls");
        } catch (exception) {
            this.storageWindow = $5b062589e0e5fd00$export$d7392285c701ecf5;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();

});


parcelRegister("dNjJr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0297786461100c80$export$2e2bcd8739ae039);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $iXQBV = parcelRequire("iXQBV");

var $5Hj4s = parcelRequire("5Hj4s");

var $7Ow9L = parcelRequire("7Ow9L");
var $0297786461100c80$var$USER_POOL_ID_MAX_LENGTH = 55;
/** @class */ var $0297786461100c80$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error("Both UserPoolId and ClientId are required.");
        if (UserPoolId.length > $0297786461100c80$var$USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) throw new Error("Invalid UserPoolId format.");
        var region = UserPoolId.split("_")[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, $iXQBV.default)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, $7Ow9L.default)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    } /**
   * @returns {string} the user pool name
   */ ;
    _proto.getUserPoolName = function getUserPoolName() {
        return this.getUserPoolId().split("_")[1];
    } /**
   * @returns {string} the client id
   */ ;
    _proto.getClientId = function getClientId() {
        return this.clientId;
    } /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request("SignUp", jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, $5Hj4s.default)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    } /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */ ;
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, $5Hj4s.default)(cognitoUser);
        }
        return null;
    } /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/ ;
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === "undefined") return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();

});
parcelRegister("iXQBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $dce68c18d7f7256b$export$2e2bcd8739ae039);
parcelRequire("pLksJ");

var $kerV5 = parcelRequire("kerV5");
function $dce68c18d7f7256b$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $dce68c18d7f7256b$var$_setPrototypeOf(subClass, superClass);
}
function $dce68c18d7f7256b$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $dce68c18d7f7256b$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$dce68c18d7f7256b$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $dce68c18d7f7256b$var$_construct(Class, arguments, $dce68c18d7f7256b$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $dce68c18d7f7256b$var$_setPrototypeOf(Wrapper, Class);
    };
    return $dce68c18d7f7256b$var$_wrapNativeSuper(Class);
}
function $dce68c18d7f7256b$var$_construct(Parent, args, Class) {
    if ($dce68c18d7f7256b$var$_isNativeReflectConstruct()) $dce68c18d7f7256b$var$_construct = Reflect.construct.bind();
    else $dce68c18d7f7256b$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $dce68c18d7f7256b$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $dce68c18d7f7256b$var$_construct.apply(null, arguments);
}
function $dce68c18d7f7256b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $dce68c18d7f7256b$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $dce68c18d7f7256b$var$_setPrototypeOf(o, p) {
    $dce68c18d7f7256b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $dce68c18d7f7256b$var$_setPrototypeOf(o, p);
}
function $dce68c18d7f7256b$var$_getPrototypeOf(o) {
    $dce68c18d7f7256b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $dce68c18d7f7256b$var$_getPrototypeOf(o);
}
var $dce68c18d7f7256b$var$CognitoError = /*#__PURE__*/ function(_Error) {
    $dce68c18d7f7256b$var$_inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ $dce68c18d7f7256b$var$_wrapNativeSuper(Error));
/** @class */ var $dce68c18d7f7256b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new $dce68c18d7f7256b$var$CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
        var _this3 = this;
        var MAX_DELAY_IN_MILLIS = 5000;
        $dce68c18d7f7256b$var$jitteredExponentialRetry(function(p) {
            return new Promise(function(res, rej) {
                _this3.request(operation, p, function(error, result) {
                    if (error) rej(error);
                    else res(result);
                });
            });
        }, [
            params
        ], MAX_DELAY_IN_MILLIS).then(function(result) {
            return callback(null, result);
        })["catch"](function(error) {
            return callback(error);
        });
    } /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @returns {void}
   */ ;
    _proto.request = function request(operation, params, callback) {
        var headers = {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target": "AWSCognitoIdentityProviderService." + operation,
            "X-Amz-User-Agent": (0, $kerV5.default).prototype.userAgent,
            "Cache-Control": "no-store"
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: "POST",
            mode: "cors",
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error("Network error");
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data;
            // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split("#").pop();
            var error = new Error(data.message || data.Message || null);
            error.name = code;
            error.code = code;
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get("x-amzn-errortype")) try {
                var code = response.headers.get("x-amzn-errortype").split(":")[0];
                var error = new Error(response.status ? response.status.toString() : null);
                error.code = code;
                error.name = code;
                error.statusCode = response.status;
                return callback(error);
            } catch (ex) {
                return callback(err);
            }
            else if (err instanceof Error && err.message === "Network error") err.code = "NetworkError";
            return callback(err);
        });
    };
    return Client;
}();
var $dce68c18d7f7256b$var$logger = {
    debug: function debug() {
    // Intentionally blank. This package doesn't have logging
    }
};
/**
 * For now, all errors are retryable.
 */ var $dce68c18d7f7256b$var$NonRetryableError = /*#__PURE__*/ function(_Error2) {
    $dce68c18d7f7256b$var$_inheritsLoose(NonRetryableError, _Error2);
    function NonRetryableError(message) {
        var _this4;
        _this4 = _Error2.call(this, message) || this;
        _this4.nonRetryable = true;
        return _this4;
    }
    return NonRetryableError;
}(/*#__PURE__*/ $dce68c18d7f7256b$var$_wrapNativeSuper(Error));
var $dce68c18d7f7256b$var$isNonRetryableError = function isNonRetryableError(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function $dce68c18d7f7256b$var$retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
    $dce68c18d7f7256b$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
    return functionToRetry.apply(void 0, args)["catch"](function(err) {
        $dce68c18d7f7256b$var$logger.debug("error on " + functionToRetry.name, err);
        if ($dce68c18d7f7256b$var$isNonRetryableError(err)) {
            $dce68c18d7f7256b$var$logger.debug(functionToRetry.name + " non retryable error", err);
            throw err;
        }
        var retryIn = delayFn(attempt, args, err);
        $dce68c18d7f7256b$var$logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
        if (retryIn !== false) return new Promise(function(res) {
            return setTimeout(res, retryIn);
        }).then(function() {
            return $dce68c18d7f7256b$var$retry(functionToRetry, args, delayFn, attempt + 1);
        });
        else throw err;
    });
}
function $dce68c18d7f7256b$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $dce68c18d7f7256b$var$MAX_DELAY_MS = 300000;
function $dce68c18d7f7256b$var$jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $dce68c18d7f7256b$var$MAX_DELAY_MS;
    return $dce68c18d7f7256b$var$retry(functionToRetry, args, $dce68c18d7f7256b$var$jitteredBackoff(maxDelayMs));
}

});
parcelRegister("pLksJ", function(module, exports) {


module.exports = self.fetch || (self.fetch = (parcelRequire("aQjrS")).default || (parcelRequire("aQjrS")));

});
parcelRegister("aQjrS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7e4dd8cb1f61dfed$export$2e2bcd8739ae039);
function $7e4dd8cb1f61dfed$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});


parcelRegister("kerV5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebaac5b8158b8ffd$export$2e2bcd8739ae039);

var $9dGxj = parcelRequire("9dGxj");
// constructor
function $ebaac5b8158b8ffd$var$UserAgent() {}
// public
$ebaac5b8158b8ffd$var$UserAgent.prototype.userAgent = (0, $9dGxj.getUserAgent)();
var $ebaac5b8158b8ffd$export$ad34c5a3baecdb02 = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if ($ebaac5b8158b8ffd$var$UserAgent.prototype.userAgent && !$ebaac5b8158b8ffd$var$UserAgent.prototype.userAgent.includes(content)) $ebaac5b8158b8ffd$var$UserAgent.prototype.userAgent = $ebaac5b8158b8ffd$var$UserAgent.prototype.userAgent.concat(" ", content);
    if (!$ebaac5b8158b8ffd$var$UserAgent.prototype.userAgent || $ebaac5b8158b8ffd$var$UserAgent.prototype.userAgent === "") $ebaac5b8158b8ffd$var$UserAgent.prototype.userAgent = content;
};
var // class for defining the amzn user-agent
$ebaac5b8158b8ffd$export$2e2bcd8739ae039 = $ebaac5b8158b8ffd$var$UserAgent;

});
parcelRegister("9dGxj", function(module, exports) {

$parcel$export(module.exports, "getUserAgent", () => $6b6652c9f7f86a0f$export$7935961ef7719cb0);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $kd1IL = parcelRequire("kd1IL");
var $6b6652c9f7f86a0f$var$BASE_USER_AGENT = "aws-amplify/" + (0, $kd1IL.version);
var $6b6652c9f7f86a0f$export$2dffd0b5373a4389 = {
    userAgent: $6b6652c9f7f86a0f$var$BASE_USER_AGENT + " js",
    product: "",
    navigator: null,
    isReactNative: false
};
if (typeof navigator !== "undefined" && navigator.product) {
    $6b6652c9f7f86a0f$export$2dffd0b5373a4389.product = navigator.product || "";
    $6b6652c9f7f86a0f$export$2dffd0b5373a4389.navigator = navigator || null;
    switch(navigator.product){
        case "ReactNative":
            $6b6652c9f7f86a0f$export$2dffd0b5373a4389.userAgent = $6b6652c9f7f86a0f$var$BASE_USER_AGENT + " react-native";
            $6b6652c9f7f86a0f$export$2dffd0b5373a4389.isReactNative = true;
            break;
        default:
            $6b6652c9f7f86a0f$export$2dffd0b5373a4389.userAgent = $6b6652c9f7f86a0f$var$BASE_USER_AGENT + " js";
            $6b6652c9f7f86a0f$export$2dffd0b5373a4389.isReactNative = false;
            break;
    }
}
var $6b6652c9f7f86a0f$export$7935961ef7719cb0 = function getUserAgent() {
    return $6b6652c9f7f86a0f$export$2dffd0b5373a4389.userAgent;
};
var /**
 * @deprecated use named import
 */ $6b6652c9f7f86a0f$export$2e2bcd8739ae039 = $6b6652c9f7f86a0f$export$2dffd0b5373a4389;

});
parcelRegister("kd1IL", function(module, exports) {

$parcel$export(module.exports, "version", () => $eb665b4745ca7047$export$83d89fbfd8236492);
// generated by genversion
var $eb665b4745ca7047$export$83d89fbfd8236492 = "5.0.4";

});





parcelRegister("02Di9", function(module, exports) {

var $csFH9 = parcelRequire("csFH9");
/** @class */ var $007eaa8c3ad2d059$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (mandatory).
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behaviour (default: null)
   */ function CookieStorage(data) {
        if (data.domain) this.domain = data.domain;
        else throw new Error("The domain of cookieStorage can not be undefined.");
        if (data.path) this.path = data.path;
        else this.path = "/";
        if (Object.prototype.hasOwnProperty.call(data, "expires")) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, "secure")) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (![
                "strict",
                "lax",
                "none"
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        $csFH9.set(key, value, options);
        return $csFH9.get(key);
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    _proto.getItem = function getItem(key) {
        return $csFH9.get(key);
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */ ;
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return $csFH9.remove(key, options);
    } /**
   * This is used to clear the storage of optional
   * items that were previously set
   * @returns {} an empty object
   */ ;
    _proto.clear = function clear() {
        var cookies = $csFH9.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();

});
parcelRegister("csFH9", function(module, exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});




parcelRegister("azfbQ", function(module, exports) {

$parcel$export(module.exports, "NoNetworkError", () => $9c1599981ae3e47d$export$79f50640f30c1c0e);
class $9c1599981ae3e47d$export$79f50640f30c1c0e extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("hsZgT", function(module, exports) {

$parcel$export(module.exports, "CognitoMultiInfra", () => $8a1ed77e4ee7df11$export$ca85aafb265a19b2);

var $eOSo1 = parcelRequire("eOSo1");

var $12cV0 = parcelRequire("12cV0");

var $iGCNG = parcelRequire("iGCNG");

var $fN93O = parcelRequire("fN93O");

var $dp6hQ = parcelRequire("dp6hQ");
parcelRequire("lJ9F2");
var $3XzuU = parcelRequire("3XzuU");
class $8a1ed77e4ee7df11$export$ca85aafb265a19b2 {
    constructor(cognitoServiceWrapper, userPoolProvider){
        this.cognitoServiceWrapper = cognitoServiceWrapper;
        this.userPoolProvider = userPoolProvider;
        this.logger = (0, $eOSo1.getLogger)("\uD83E\uDDE0 [CognitoMultiInfra]");
    }
    async multipleInfraIsEmailAvailable(email) {
        const authenticationDetails = new (0, $3XzuU.default)({
            Username: email,
            Password: ""
        });
        const cognitoUsers = this.userPoolProvider.generateCognitoUsersForAllInfras(email);
        try {
            return await (0, $dp6hQ.cognitoMultiInfraPromise)(cognitoUsers.map(async (cognitoUser)=>{
                try {
                    await this.cognitoServiceWrapper.authenticateUser(cognitoUser.user, authenticationDetails);
                } catch (e) {
                    if (!(0, $iGCNG.isCognitoError)(e) || e.code !== (0, $iGCNG.CognitoErrorCode).NotAuthorizedException && e.code !== (0, $iGCNG.CognitoErrorCode).UserNotConfirmedException) throw e;
                }
            }), async ()=>false);
        } catch (e) {
            this.logger.debug("multipleInfraIsEmailAvailable => true.", e);
            return true;
        }
    }
    async multipleInfraForgotPassword(email) {
        const cognitoUsers = this.userPoolProvider.generateCognitoUsersForAllInfras(email);
        await (0, $dp6hQ.cognitoMultiInfraPromise)(cognitoUsers.map(async (cognitoUser)=>{
            await this.cognitoServiceWrapper.forgotPassword(cognitoUser.user);
            return {
                ...cognitoUser
            };
        }), async (result)=>await this.userPoolProvider.changeInfrastructure(result.infrastructureId), async (aggregateError)=>{
            const errors = aggregateError.errors.map((error, index)=>({
                    error: error,
                    ...cognitoUsers[index]
                }));
            const cognitoErrors = errors.filter((0, $fN93O.isMultiInfraCognitoError));
            if (cognitoErrors.every(({ error: error })=>error.code === (0, $iGCNG.CognitoErrorCode).UserNotFoundException)) return cognitoErrors[0].error;
            const limitExceededErrors = cognitoErrors.filter((cognitoError)=>cognitoError.error.code === (0, $iGCNG.CognitoErrorCode).LimitExceededException);
            if (limitExceededErrors.length >= 1) return limitExceededErrors[0].error;
            const notAuthorizedErrors = cognitoErrors.filter((cognitoError)=>cognitoError.error.code === (0, $iGCNG.CognitoErrorCode).NotAuthorizedException);
            if (notAuthorizedErrors.length > 0) return notAuthorizedErrors[0].error;
            const userNotVerifiedErrors = cognitoErrors.filter(({ error: error })=>error.code === (0, $iGCNG.CognitoErrorCode).InvalidParameterException && error.message.includes("verified email"));
            if (userNotVerifiedErrors.length > 1) return new (0, $12cV0.UserInMultipleInfractureError)("User cannot have sessions in multiple infras! (case 1)");
            if (userNotVerifiedErrors.length === 1) {
                await this.userPoolProvider.changeInfrastructure(userNotVerifiedErrors[0].infrastructureId);
                return userNotVerifiedErrors[0].error;
            }
            return new Error("Need to work on these cases");
        });
    }
    async multipleInfraLoginEmail(email, password, updateUser) {
        const authenticationDetails = new (0, $3XzuU.default)({
            Username: email,
            Password: password
        });
        const cognitoUsers = this.userPoolProvider.generateCognitoUsersForAllInfras(email);
        return await (0, $dp6hQ.cognitoMultiInfraPromise)(cognitoUsers.map(async (cognitoUser)=>{
            const userSession = await this.cognitoServiceWrapper.authenticateUser(cognitoUser.user, authenticationDetails);
            return {
                userSession: userSession,
                ...cognitoUser
            };
        }), async (result)=>{
            await this.userPoolProvider.changeInfrastructure(result.infrastructureId);
            return {
                cognitoUserSession: result.userSession,
                cognitoUser: result.user
            };
        }, async (aggregateError)=>{
            const errors = aggregateError.errors.map((error, index)=>({
                    error: error,
                    ...cognitoUsers[index]
                }));
            const newPasswordNeededErrors = errors.filter((error)=>error.error instanceof (0, $12cV0.NewPasswordNeededError));
            if (newPasswordNeededErrors.length > 1) return new (0, $12cV0.UserInMultipleInfractureError)("User cannot have sessions in multiple infras! (case 2)");
            if (newPasswordNeededErrors.length === 1) {
                await this.userPoolProvider.changeInfrastructure(newPasswordNeededErrors[0].infrastructureId);
                await updateUser(newPasswordNeededErrors[0].user);
                return newPasswordNeededErrors[0].error;
            }
            const cognitoErrors = [];
            errors.forEach(({ error: error, infrastructureId: infrastructureId })=>{
                if ((0, $iGCNG.isCognitoError)(error)) cognitoErrors.push({
                    error: error,
                    infrastructureId: infrastructureId
                });
            });
            const userNotConfirmedErrors = cognitoErrors.filter((cognitoError)=>cognitoError.error.code === (0, $iGCNG.CognitoErrorCode).UserNotConfirmedException);
            if (userNotConfirmedErrors.length > 1) return new (0, $12cV0.UserInMultipleInfractureError)("User cannot have sessions in multiple infras! (case 3)");
            if (userNotConfirmedErrors.length === 1) {
                await this.userPoolProvider.changeInfrastructure(userNotConfirmedErrors[0].infrastructureId);
                return userNotConfirmedErrors[0].error;
            }
            const tooManyAttemptsErrors = cognitoErrors.filter((cognitoError)=>cognitoError.error.code === (0, $iGCNG.CognitoErrorCode).NotAuthorizedException && cognitoError.error.message === (0, $iGCNG.CognitoErrorMessage).PasswordAttemptsExceeded);
            if (tooManyAttemptsErrors.length >= 1) return tooManyAttemptsErrors[0].error;
            const loginFailedErrors = cognitoErrors.filter((cognitoError)=>cognitoError.error.code === (0, $iGCNG.CognitoErrorCode).NotAuthorizedException);
            if (loginFailedErrors.length > 1) return new (0, $12cV0.UserInMultipleInfractureError)("User cannot have sessions in multiple infras! (case 4)");
            if (loginFailedErrors.length === 1) return loginFailedErrors[0].error;
            if (cognitoErrors.every((error)=>error.error.code === (0, $iGCNG.CognitoErrorCode).UserNotFoundException)) return cognitoErrors[0].error;
            return Error("Need to work on these cases");
        });
    }
}

});
parcelRegister("fN93O", function(module, exports) {

$parcel$export(module.exports, "isMultiInfraCognitoError", () => $d9824ff4fd01f2d1$export$4ae1ce6a2e9ac447);

var $iGCNG = parcelRequire("iGCNG");
function $d9824ff4fd01f2d1$export$4ae1ce6a2e9ac447(error) {
    return (0, $iGCNG.isCognitoError)(error.error);
}

});

parcelRegister("dp6hQ", function(module, exports) {

$parcel$export(module.exports, "cognitoMultiInfraPromise", () => $6d79e32c70fe1036$export$2aa125b862e40c5f);
async function $6d79e32c70fe1036$export$2aa125b862e40c5f(map, onFulfilled, onRejected) {
    try {
        const result = await Promise.any(map);
        return await onFulfilled(result);
    } catch (aggregateError) {
        if (!(aggregateError instanceof AggregateError)) throw aggregateError;
        throw await onRejected?.(aggregateError) ?? aggregateError;
    }
}

});


parcelRegister("8KSst", function(module, exports) {

$parcel$export(module.exports, "CognitoServiceWrapper", () => $5d015111b67b4c3a$export$d532bf826e5988c);
/* eslint-disable sonarjs/no-identical-functions */ 
var $12cV0 = parcelRequire("12cV0");

var $lTdpc = parcelRequire("lTdpc");
class $5d015111b67b4c3a$export$d532bf826e5988c {
    constructor(networkActionsErrorsManager){
        this.networkActionsErrorsManager = networkActionsErrorsManager;
    }
    getSession(user) {
        this.networkActionsErrorsManager.clearError();
        return new Promise((resolve, reject)=>{
            user.getSession((...[error, session])=>{
                if (session) resolve(session);
                else reject(error);
            });
        });
    }
    authenticateUser(user, authenticationDetails) {
        this.networkActionsErrorsManager.clearError();
        return new Promise((resolve, reject)=>{
            user.authenticateUser(authenticationDetails, {
                newPasswordRequired: async ()=>{
                    reject(new (0, $12cV0.NewPasswordNeededError)("The user needs to change their password"));
                },
                onSuccess: (result)=>{
                    resolve(result);
                },
                onFailure: (error)=>{
                    reject(error);
                }
            });
        });
    }
    forgotPassword(user) {
        this.networkActionsErrorsManager.clearError();
        return new Promise((resolve, reject)=>{
            user.forgotPassword({
                onSuccess: ()=>{
                    resolve();
                },
                onFailure: (error)=>{
                    reject(error);
                }
            });
        });
    }
    confirmPassword(user, resetToken, newPassword) {
        this.networkActionsErrorsManager.clearError();
        return new Promise((resolve, reject)=>{
            user.confirmPassword(resetToken, newPassword, {
                onSuccess: ()=>{
                    resolve();
                },
                onFailure: (error)=>{
                    reject(error);
                }
            });
        });
    }
    getUserAttributes(user) {
        // No clear error here, as there were none before refactor
        return new Promise((resolve, reject)=>{
            user.getUserAttributes((error, result)=>{
                if (!error && result) resolve(result);
                else reject(error);
            });
        });
    }
    updateAttributes(user, attributes) {
        this.networkActionsErrorsManager.clearError();
        return new Promise((resolve, reject)=>{
            user.updateAttributes(attributes, async (error)=>{
                if ((0, $lTdpc.isNotNil)(error)) reject(error);
                else resolve();
            });
        });
    }
    signUp(userPool, email, password, attributes = []) {
        this.networkActionsErrorsManager.clearError();
        return new Promise((resolve, reject)=>{
            userPool.signUp(email, password, attributes, [], async (error, result)=>{
                if (result && !error) resolve(result);
                else reject(error);
            });
        });
    }
    changePassword(user, currentPassword, newPassword) {
        return new Promise((resolve, reject)=>{
            user.changePassword(currentPassword, newPassword, (error)=>{
                if (error) return reject(error);
                resolve();
            });
        });
    }
    confirmRegistration(user, code) {
        this.networkActionsErrorsManager.clearError();
        return new Promise((resolve, reject)=>{
            user.confirmRegistration(code, true, async (error)=>{
                if ((0, $lTdpc.isNotNil)(error)) reject(error);
                else resolve();
            });
        });
    }
    resendConfirmationCode(user) {
        this.networkActionsErrorsManager.clearError();
        return new Promise((resolve, reject)=>{
            user.resendConfirmationCode((error)=>{
                if ((0, $lTdpc.isNotNil)(error)) reject(error);
                else resolve();
            });
        });
    }
}

});

parcelRegister("gASCG", function(module, exports) {

$parcel$export(module.exports, "CognitoUserPoolProvider", () => $eae8788f71633d99$export$aa541ba93854ec1b);

var $5xCsV = parcelRequire("5xCsV");

var $lTdpc = parcelRequire("lTdpc");
parcelRequire("lJ9F2");
var $5Hj4s = parcelRequire("5Hj4s");
var $dNjJr = parcelRequire("dNjJr");
class $eae8788f71633d99$export$aa541ba93854ec1b {
    constructor(infraManager){
        this.infraManager = infraManager;
        this.userPool = null;
        this.infraManager.targetInfraChanged.add(this.onTargetInfraChanged.bind(this));
    }
    async changeInfrastructure(infrastructureId) {
        await this.infraManager.changeInfrastructureUsingId(infrastructureId);
    }
    getPool() {
        if ((0, $lTdpc.isNotNil)(this.userPool)) return this.userPool;
        throw new (0, $5xCsV.NoTargetInfraError)("Cognito is not usable until a target infra is set");
    }
    generateCognitoUsersForAllInfras(email) {
        return [
            ...this.infraManager.allInfras
        ].map(([infrastructureId, infra])=>({
                user: new (0, $5Hj4s.default)({
                    Pool: new (0, $dNjJr.default)({
                        UserPoolId: infra.cognitoUserPool.id,
                        ClientId: infra.cognitoUserPool.clientId
                    }),
                    Username: email
                }),
                infrastructureId: infrastructureId
            }));
    }
    getUnsafePool() {
        return this.userPool;
    }
    onTargetInfraChanged(infra) {
        if ((0, $lTdpc.isNotNil)(infra)) this.userPool = (0, $lTdpc.isNotNil)(infra) ? new (0, $dNjJr.default)({
            UserPoolId: infra.cognitoUserPool.id,
            ClientId: infra.cognitoUserPool.clientId
        }) : null;
    }
}

});

parcelRegister("hGOU3", function(module, exports) {

$parcel$export(module.exports, "CookiebotManager", () => $f90a890f6dd26fef$export$c465154cd440f326);

var $eOSo1 = parcelRequire("eOSo1");

var $1IWnK = parcelRequire("1IWnK");
class $f90a890f6dd26fef$export$c465154cd440f326 {
    constructor(){
        this.logger = (0, $eOSo1.getLogger)("\uD83C\uDF6A [CookiebotManager]");
        this._consentStatistics = (0, $1IWnK.observable)(true);
        this.consentStatistics = this._consentStatistics.readOnly();
        window.addEventListener("CookiebotOnConsentReady", ()=>{
            this.updateConsents();
        });
        this.updateConsents();
    }
    updateConsents() {
        const consent = window.Cookiebot?.consent.statistics ?? false;
        this.logger.debug("Statistical consent found to be", consent);
        this._consentStatistics.set(consent);
    }
    openConsentDialog() {
        window.Cookiebot?.renew();
    }
}

});

parcelRegister("iDkBu", function(module, exports) {

$parcel$export(module.exports, "HealthcareTeamManager", () => $a762a60277896265$export$e265c3f36e33c323);

var $04Qjn = parcelRequire("04Qjn");

var $hjTZh = parcelRequire("hjTZh");

var $1IWnK = parcelRequire("1IWnK");
class $a762a60277896265$export$e265c3f36e33c323 {
    constructor(healthcareTeamService){
        this.healthcareTeamService = healthcareTeamService;
        this._healthcareTeam = (0, $1IWnK.observable)(null);
        this.healthcareTeam = this._healthcareTeam.readOnly();
    }
    async fetchHealthcareTeam(patientId) {
        if (this._healthcareTeam.get()?.patientId !== patientId) this._healthcareTeam.set(null);
        const healthcareTeamMembers = await this.healthcareTeamService.fetchHealthcareTeam(patientId);
        this._healthcareTeam.set({
            patientId: patientId,
            healthcareTeamMembers: healthcareTeamMembers
        });
    }
    async sendInvitation(patientId, email, message) {
        await this.healthcareTeamService.sendInvitation(patientId, email, message);
        await this.fetchHealthcareTeam(patientId);
    }
    async resendInvitation(patientId, hctMemberId) {
        await this.healthcareTeamService.resendInvitation(patientId, hctMemberId);
    }
    async sendUnregisteredInvitation(patientId, email) {
        const result = await this.healthcareTeamService.sendUnregisteredInvitation(patientId, email);
        await this.fetchHealthcareTeam(patientId);
        return result;
    }
    async getInvitationDetails(patientId) {
        try {
            return await this.healthcareTeamService.getInvitationDetails(patientId);
        } catch (e) {
            if ((0, $04Qjn.isApiError)(e) && e.code === (0, $hjTZh.HealthcareTeamErrorCodes).PtInvitationAlreadyAccepted) throw new (0, $hjTZh.InvitationAlreadyAcceptedError)();
            if ((0, $04Qjn.isApiError)(e) && e.code === (0, $hjTZh.HealthcareTeamErrorCodes).PtNotInvited) throw new (0, $hjTZh.InvitationPtNotInvitedError)();
            throw e;
        }
    }
    async deleteMember(patientId, hctMemberId) {
        await this.healthcareTeamService.deleteMember(patientId, hctMemberId);
        await this.fetchHealthcareTeam(patientId);
    }
    async leaveHealthcareTeam(patientId) {
        await this.healthcareTeamService.leaveHealthcareTeam(patientId);
    }
    async joinHealthcareTeam(code) {
        return await this.healthcareTeamService.joinHealthcareTeam(code);
    }
    async confirmInvitation(patientId) {
        await this.healthcareTeamService.confirmInvitation(patientId);
    }
    async checkEmailRegistered(patientId, email) {
        try {
            return await this.healthcareTeamService.checkEmailRegistered(patientId, email);
        } catch (e) {
            if ((0, $04Qjn.isApiError)(e) && e.code === (0, $hjTZh.HealthcareTeamErrorCodes).PtNotFoundByEmail) throw new (0, $hjTZh.InvitationPtNotFoundError)();
            if ((0, $04Qjn.isApiError)(e) && e.code === (0, $hjTZh.HealthcareTeamErrorCodes).PtInDifferentCountry) throw new (0, $hjTZh.InvitationPtInDifferentCountryError)();
            if ((0, $04Qjn.isApiError)(e) && e.code === (0, $hjTZh.HealthcareTeamErrorCodes).PtAlreadyInHealthcareTeam) throw new (0, $hjTZh.InvitationPtAlreadyInHctError)();
            throw e;
        }
    }
}

});

parcelRegister("kZYvH", function(module, exports) {

$parcel$export(module.exports, "HealthcareTeamService", () => $63350c3452815a70$export$173da4d909203c1c);

var $04Qjn = parcelRequire("04Qjn");

var $hjTZh = parcelRequire("hjTZh");

var $lTdpc = parcelRequire("lTdpc");

var $kXaMn = parcelRequire("kXaMn");
class $63350c3452815a70$export$173da4d909203c1c {
    constructor(apiService){
        this.apiService = apiService;
    }
    async checkEmailRegistered(patientId, email) {
        return (await this.apiService.get(`/patients/${patientId}/healthcare-team/${email}/check`)).data;
    }
    async sendInvitation(patientId, email, message) {
        await this.apiService.post(`/patients/${patientId}/healthcare-team/invite`, {
            email: email,
            message: message
        }, undefined, (error)=>!(0, $04Qjn.isApiError)(error) || (0, $lTdpc.isNil)(error.code));
    }
    async resendInvitation(patientId, hctMemberId) {
        await this.apiService.post(`/patients/${patientId}/healthcare-team/${hctMemberId}/resend-invitation`);
    }
    async sendUnregisteredInvitation(patientId, email) {
        return (await this.apiService.post(`/patients/${patientId}/healthcare-team/invite-unregistered`, {
            email: email
        })).data;
    }
    async fetchHealthcareTeam(patientId) {
        return (await this.apiService.get(`/patients/${patientId}/healthcare-team`)).data;
    }
    async getInvitationDetails(patientId) {
        const result = (await this.apiService.get(`/pts/me/healthcare-team/${patientId}/invitation`)).data;
        return this.healthcareTeamOutputFromDto(result);
    }
    async confirmInvitation(patientId) {
        await this.apiService.post(`/pts/me/healthcare-team/${patientId}/invitation/accept`);
    }
    async deleteMember(patientId, hctMemberId) {
        await this.apiService.delete(`/patients/${patientId}/healthcare-team/${hctMemberId}`);
    }
    async leaveHealthcareTeam(patientId) {
        await this.apiService.delete(`/patients/${patientId}/healthcare-team`);
    }
    async joinHealthcareTeam(code) {
        try {
            const res = await this.apiService.post("/pts/me/healthcare-team/join", {
                code: code
            }, undefined, ()=>false);
            return res.data;
        } catch (e) {
            if ((0, $04Qjn.isApiError)(e) && e.code === (0, $hjTZh.HealthcareTeamErrorCodes).PtAlreadyInHealthcareTeam) throw new (0, $hjTZh.InvitationPtAlreadyInHctError)();
            if ((0, $04Qjn.isApiError)(e) && e.code === (0, $hjTZh.HealthcareTeamErrorCodes).HealthcareTeamInvitationInWrongCountry) throw new (0, $hjTZh.HealthcareTeamInvitationInWrongCountryError)();
            throw e;
        }
    }
    healthcareTeamOutputFromDto(healthcareTeamOutputDto) {
        return {
            ...healthcareTeamOutputDto,
            patient: {
                ...healthcareTeamOutputDto.patient,
                creationDate: (0, $kXaMn.dateFromDateDto)(healthcareTeamOutputDto.patient.creationDate),
                birthDate: (0, $kXaMn.dateFromDateDto)(healthcareTeamOutputDto.patient.birthDate)
            }
        };
    }
}

});

parcelRegister("jl5Na", function(module, exports) {

$parcel$export(module.exports, "InfraManager", () => $c9d2f5bc89211e07$export$511f128a2ad8d0fa);

var $eOSo1 = parcelRequire("eOSo1");

var $5xCsV = parcelRequire("5xCsV");

var $lTdpc = parcelRequire("lTdpc");

var $gbSxu = parcelRequire("gbSxu");
class $c9d2f5bc89211e07$export$511f128a2ad8d0fa {
    constructor(serverConfigManager, store){
        this.serverConfigManager = serverConfigManager;
        this.store = store;
        this.logger = (0, $eOSo1.getLogger)("\uD83D\uDEE0 [InfraManager]");
        this._allInfras = new Map();
        this._targetInfra = null;
        this.serverConfigManager.configChanged.add(this.onServerConfigChanged.bind(this));
        this.targetInfraChanged = new (0, $gbSxu.Signal)();
    }
    get targetInfra() {
        return this._targetInfra;
    }
    get allInfras() {
        return this._allInfras;
    }
    async init() {
        const infrastructureId = this.store.getItem();
        try {
            await this.changeInfrastructureUsingId(infrastructureId);
        } catch (e) {
            this.logger.debug("Change infrastructure failed on init");
        }
    }
    async changeInfrastructureUsingCountryCode(countryCode) {
        const infrastructureId = this.findInfrastuctureByCountryCode(countryCode);
        if ((0, $lTdpc.isNil)(infrastructureId)) throw new Error(`Country code ${countryCode} is not supported by any infra`);
        await this.changeInfrastructureUsingId(infrastructureId);
    }
    async changeInfrastructureUsingId(infrastructureId) {
        if ((0, $lTdpc.isNotNil)(infrastructureId)) {
            const targetConfig = this._allInfras.get(infrastructureId);
            if ((0, $lTdpc.isNil)(targetConfig)) throw new (0, $5xCsV.NoTargetInfraError)(`Infra with code ${infrastructureId} does not exist`);
            if (targetConfig.id !== this._targetInfra?.id) {
                this._targetInfra = targetConfig;
                this.store.setItem(infrastructureId);
            } else this.logger.debug("Ignored infra change - same infra:", this.targetInfra?.name);
        } else {
            this._targetInfra = null;
            this.store.clear();
        }
        this.logger.debug("Changed infra to", this.targetInfra?.name);
        this.targetInfraChanged.dispatch(this.targetInfra);
    }
    findInfrastuctureByCountryCode(countryCode) {
        for (const [infraId, infraConfig] of this._allInfras){
            if (infraConfig.hostedCountries.includes(countryCode)) return infraId;
        }
    }
    onServerConfigChanged(config) {
        this._allInfras = new Map(config.infrastructures.map((infra)=>[
                infra.id,
                {
                    ...infra
                }
            ]));
        this.logger.debug("Infrastructures defined: ", config.infrastructures.map((i)=>i.name));
    }
    isInfrastructureCodeValid(infrastructureCode) {
        return (0, $lTdpc.isNotNil)(this._allInfras.get(infrastructureCode));
    }
    reset() {
        this.changeInfrastructureUsingId();
    }
}

});

parcelRegister("9Xe21", function(module, exports) {

$parcel$export(module.exports, "LegalContentManager", () => $fe51d3e0d5a53858$export$651f04ca2dfd8e18);

var $1IWnK = parcelRequire("1IWnK");

var $eOSo1 = parcelRequire("eOSo1");
class $fe51d3e0d5a53858$export$651f04ca2dfd8e18 {
    constructor(legalContentService, infraManager, store){
        this.legalContentService = legalContentService;
        this.infraManager = infraManager;
        this.store = store;
        this.logger = (0, $eOSo1.getLogger)("\uD83D\uDCDC [LegalContentManager]");
        this._termsOfUse = (0, $1IWnK.observable)(null);
        this.termsOfUse = this._termsOfUse.readOnly();
        this._privacyNotice = (0, $1IWnK.observable)(null);
        this.privacyNotice = this._privacyNotice.readOnly();
        this._legalDocumentsMetadata = (0, $1IWnK.observable)(null);
        this.legalDocumentsMetadata = this._legalDocumentsMetadata.readOnly();
        this.infraManager.targetInfraChanged.add(this.retrieveDocumentsMetadata.bind(this));
    }
    async retrieveLegalDocuments(locale) {
        await Promise.all([
            this.retrieveTermsOfUse(locale),
            this.retrievePrivacyNotice(locale)
        ]);
    }
    async retrieveTermsOfUse(locale) {
        this._termsOfUse.set(await this.legalContentService.getTermsOfUse(locale));
    }
    async retrievePrivacyNotice(locale) {
        this._privacyNotice.set(await this.legalContentService.getPrivacyNotice(locale));
    }
    async retrieveDocumentsMetadata() {
        let documents;
        try {
            documents = await this.legalContentService.getLegalDocumentsMetadata();
            this.store.setItem(documents);
        } catch (e) {
            documents = this.store.getItem();
        }
        this._legalDocumentsMetadata.set(documents);
    }
    async consentToLegalDocuments() {
        const termsOfUse = this._termsOfUse.get();
        const privacyNotice = this._privacyNotice.get();
        if (termsOfUse && privacyNotice) await this.legalContentService.consentToLegalDocuments(termsOfUse.version, privacyNotice.version);
        else throw new Error("Impossible to consent because either the privacy or terms of use are missing");
    }
}

});

parcelRegister("8XtwW", function(module, exports) {

$parcel$export(module.exports, "LegalContentService", () => $edb846284a00d489$export$66dcdc979f62cfde);
class $edb846284a00d489$export$66dcdc979f62cfde {
    constructor(apiService, unauthenticatedApiService){
        this.apiService = apiService;
        this.unauthenticatedApiService = unauthenticatedApiService;
    }
    async getTermsOfUse(locale) {
        const result = await this.apiService.get("/legal-content/terms-of-use", {
            params: {
                locale: locale
            }
        });
        return result.data;
    }
    async getPrivacyNotice(locale) {
        const result = await this.apiService.get("/legal-content/privacy-notice", {
            params: {
                locale: locale
            }
        });
        return result.data;
    }
    async getLegalDocumentsMetadata() {
        const result = await this.unauthenticatedApiService.get("/legal-content/documents-metadata");
        return result.data;
    }
    async consentToLegalDocuments(termsOfUseVersion, privacyNoticeVersion) {
        await this.apiService.post("/legal-content/consent", {
            touVersion: termsOfUseVersion,
            pnVersion: privacyNoticeVersion
        });
    }
}

});

parcelRegister("daNIT", function(module, exports) {

$parcel$export(module.exports, "LibraryFilteringState", () => $82e219a544b7cf6c$export$b7a14e3cf3144fc8);
$parcel$export(module.exports, "LibraryFilterManager", () => $82e219a544b7cf6c$export$73f341385d67d13e);

var $lTdpc = parcelRequire("lTdpc");

var $buI4E = parcelRequire("buI4E");

var $1IWnK = parcelRequire("1IWnK");

var $8gUdJ = parcelRequire("8gUdJ");
var $82e219a544b7cf6c$export$b7a14e3cf3144fc8;
(function(LibraryFilteringState) {
    LibraryFilteringState["UNDEFINED"] = "undefined";
    LibraryFilteringState["COMPLEMENTARY"] = "complementary";
    LibraryFilteringState["ALTERNATIVE"] = "alternative";
})($82e219a544b7cf6c$export$b7a14e3cf3144fc8 || ($82e219a544b7cf6c$export$b7a14e3cf3144fc8 = {}));
class $82e219a544b7cf6c$export$73f341385d67d13e extends (0, $8gUdJ.ExerciseSelectionManager) {
    constructor(exerciseManager){
        super();
        this.exerciseManager = exerciseManager;
        this._exercises = [];
        this._filteredExercises = (0, $1IWnK.observable)(this._exercises);
        this.filteredExercises = this._filteredExercises.readOnly();
        this._filteredSelectedExercises = (0, $1IWnK.observable)([]);
        this.filteredSelectedExercises = this._filteredSelectedExercises.readOnly();
        this._sidebarVisible = (0, $1IWnK.observable)(true);
        this.sidebarVisible = this._sidebarVisible.readOnly();
        this._filteringState = (0, $1IWnK.observable)("undefined");
        this.filteringState = this._filteringState.readOnly();
        this._lastAddedExerciseData = (0, $1IWnK.observable)(undefined);
        this.lastAddedExerciseMetadata = this._lastAddedExerciseData.readOnly();
        this.searchWord = (0, $1IWnK.observable)("");
        this.activeCategoryFilters = (0, $1IWnK.observable)([]);
        this.exerciseWithAlternativesEdited = (0, $1IWnK.observable)(null);
        this.searchWord.subscribe(()=>this.filterExercises());
        this.activeCategoryFilters.subscribe(()=>this.filterExercises());
        this.exerciseWithAlternativesEdited.subscribe(()=>this.filterExercises());
        this.selectedExercises.subscribe(()=>this.filterExercises());
        this.exerciseWithAlternativesEditedList = this.exerciseWithAlternativesEdited.select((editedExercise)=>{
            const collator = new Intl.Collator();
            if ((0, $lTdpc.isNotNil)(editedExercise)) return [
                editedExercise,
                ...editedExercise.alternativeExercises
            ].sort((exercise1, exercise2)=>collator.compare(exercise1.title, exercise2.title));
            return [];
        });
    }
    setSidebarVisible(visible) {
        this._sidebarVisible.set(visible);
    }
    async listAllExercises() {
        await this.exerciseManager.fetchExercises();
        this._exercises = this.exerciseManager.allExercises.get();
        this.filterExercises();
    }
    async clearLibraryFiltersAndSearch() {
        this._filteredExercises.set([]);
        this.activeCategoryFilters.set([]);
        this.searchWord.set("");
        this.exerciseWithAlternativesEdited.set(null);
        this._filteringState.set("undefined");
    }
    async reset() {
        this._exercises = [];
        this.clearLibraryFiltersAndSearch();
    }
    setIsComplementaryExerciseActive() {
        this._filteringState.set("complementary");
    }
    setIsAlternativeExerciseActive() {
        this._filteringState.set("alternative");
    }
    clearActiveFilteringState() {
        this._filteringState.set("undefined");
    }
    setLastAddedExerciseMetadata(newExerciseId, isAlternative = false) {
        this._lastAddedExerciseData.set({
            draggableId: newExerciseId,
            isComplementary: this.filteringState.get() === "complementary",
            isAlternative: isAlternative
        });
    }
    clearLastAddedExerciseMetadata() {
        this._lastAddedExerciseData.set(undefined);
    }
    setExerciseWithAlternativesEdited(newExercise) {
        this.exerciseWithAlternativesEdited.set(newExercise);
    }
    selectExercises(exercises) {
        this.updateSelectedExerciseList(exercises, true);
    }
    filterExercises() {
        this._filteredSelectedExercises.set(this.getMatchingExercises(this.selectedExercises.get()));
        const exercisesWithoutSelected = this._exercises.filter((exercise)=>!this.selectedExercises.get().some((e)=>exercise.id === e.id));
        const filteredExercises = this.getMatchingExercises(exercisesWithoutSelected);
        this._filteredExercises.set(filteredExercises);
    }
    getMatchingExercises(exercises) {
        const filteredByCategoryExercises = exercises.filter((exercise)=>{
            for (const category of this.activeCategoryFilters.get()){
                if (!this.exerciseMatchFilterCategory(exercise, category)) return false;
            }
            return true;
        });
        const search = this.searchWord.get();
        const filteredByNameExercises = filteredByCategoryExercises.filter((exercise)=>!search || (0, $buI4E.isWordMatchingSearch)(exercise.title, search));
        const filteredByTagsRemainingExercises = filteredByCategoryExercises.filter((exercise)=>(!search || exercise.tags.find((tag)=>(0, $buI4E.isWordMatchingSearch)(tag, search))) && !filteredByNameExercises.find((e)=>e.id === exercise.id));
        const filteredBtNameAndTagsExercises = [
            ...filteredByNameExercises,
            ...filteredByTagsRemainingExercises
        ];
        const alreadySelectedExercises = this.exerciseWithAlternativesEditedList.get();
        return filteredBtNameAndTagsExercises.filter((filteredExercise)=>!alreadySelectedExercises.some((e)=>filteredExercise.id === e.id));
    }
    exerciseMatchFilterCategory(exercise, filterCategory) {
        if (filterCategory.filters.length === 0) return true;
        for (const filter of filterCategory.filters){
            if (filter.predicate(exercise)) return true;
        }
        return false;
    }
}

});
parcelRegister("buI4E", function(module, exports) {

$parcel$export(module.exports, "capitalizeFirstLetter", () => $9aff7ee83a75dd50$export$d07f57595c356899);
$parcel$export(module.exports, "removeDiacriticsFromString", () => $9aff7ee83a75dd50$export$45a653fb2fa4b396);
$parcel$export(module.exports, "splitTextWithQueryString", () => $9aff7ee83a75dd50$export$64f01e8d00c64ea6);
$parcel$export(module.exports, "formatName", () => $9aff7ee83a75dd50$export$61b6a526e2f145be);
$parcel$export(module.exports, "stringToBoolean", () => $9aff7ee83a75dd50$export$70f24959ef00553b);
$parcel$export(module.exports, "isNumeric", () => $9aff7ee83a75dd50$export$e90fb89750dba83f);
$parcel$export(module.exports, "truncateString", () => $9aff7ee83a75dd50$export$88f68187db5ede92);
$parcel$export(module.exports, "isWordMatchingSearch", () => $9aff7ee83a75dd50$export$9886b7e80c4ab518);
$parcel$export(module.exports, "orderList", () => $9aff7ee83a75dd50$export$4f8a2277b624e8cc);
$parcel$export(module.exports, "getInitials", () => $9aff7ee83a75dd50$export$de9bdbce6502b027);
$parcel$export(module.exports, "formatTitle", () => $9aff7ee83a75dd50$export$d71cca6e19e59240);

var $lTdpc = parcelRequire("lTdpc");

var $4hOw0 = parcelRequire("4hOw0");
function $9aff7ee83a75dd50$export$d07f57595c356899(text) {
    const [first, ...rest] = text;
    return [
        first.toUpperCase(),
        ...rest
    ].join("");
}
function $9aff7ee83a75dd50$export$45a653fb2fa4b396(text) {
    return text.toLowerCase()// separate special caracters from their original character (ex: ñ => n~)
    .normalize("NFD")// remove special characters (ex: n~ => n)
    .replace(/[\u0300-\u036f]/g, "");
}
const $9aff7ee83a75dd50$export$f6dc560b211daea9 = (text, substring, options = {
    caseInsensitive: true,
    diacriticsInsensitive: true
})=>{
    let processedText = text;
    let processedSubstring = substring;
    if (options.caseInsensitive) {
        processedText = processedText.toLowerCase();
        processedSubstring = processedSubstring.toLowerCase();
    }
    if (options.diacriticsInsensitive) {
        processedText = $9aff7ee83a75dd50$export$45a653fb2fa4b396(processedText);
        processedSubstring = $9aff7ee83a75dd50$export$45a653fb2fa4b396(processedSubstring);
    }
    const result = [];
    for(let index = 0; index <= text.length - substring.length; index++)if (processedText.slice(index).startsWith(processedSubstring)) result.push(index);
    return result;
};
const $9aff7ee83a75dd50$export$64f01e8d00c64ea6 = (text, queryString)=>{
    let currentIndex = 0;
    const result = [];
    $9aff7ee83a75dd50$export$f6dc560b211daea9(text, queryString).forEach((occurrenceIndex)=>{
        if (currentIndex !== occurrenceIndex) {
            result.push({
                isQueryString: false,
                text: text.slice(currentIndex, occurrenceIndex)
            });
            currentIndex = occurrenceIndex;
        }
        result.push({
            isQueryString: true,
            text: text.slice(occurrenceIndex, occurrenceIndex + queryString.length)
        });
        currentIndex = occurrenceIndex + queryString.length;
    });
    if (currentIndex !== text.length) result.push({
        isQueryString: false,
        text: text.slice(currentIndex)
    });
    return result;
};
const $9aff7ee83a75dd50$export$61b6a526e2f145be = ({ firstName: firstName, lastName: lastName }, defaultName = "")=>{
    if ((0, $lTdpc.isNotNil)(firstName) || (0, $lTdpc.isNotNil)(lastName)) return [
        firstName,
        lastName
    ].join(" ");
    else return defaultName;
};
const $9aff7ee83a75dd50$export$70f24959ef00553b = (value)=>value.toLowerCase() === (0, $4hOw0.TRUE_STRING);
const $9aff7ee83a75dd50$export$e90fb89750dba83f = (value)=>!isNaN(+value);
const $9aff7ee83a75dd50$export$88f68187db5ede92 = (value, n)=>value.length > n ? value.slice(0, n - 1) + "..." : value;
const $9aff7ee83a75dd50$export$9886b7e80c4ab518 = (word, search)=>$9aff7ee83a75dd50$export$45a653fb2fa4b396(word).includes($9aff7ee83a75dd50$export$45a653fb2fa4b396(search));
const $9aff7ee83a75dd50$export$4f8a2277b624e8cc = (list, property)=>{
    const collator = new Intl.Collator();
    return (0, $lTdpc.isNil)(property) ? list.sort((a, b)=>collator.compare(a, b)) : list.sort((a, b)=>collator.compare(a[property], b[property]));
};
const $9aff7ee83a75dd50$export$de9bdbce6502b027 = (name)=>name.trim().split(/\s+/).map((word)=>word[0]).slice(0, 2).join("").toUpperCase();
const $9aff7ee83a75dd50$export$d71cca6e19e59240 = (title, maxLength = 63)=>{
    if (!title) return "";
    if (title.length <= maxLength) return title;
    return `${title.slice(0, maxLength - 3).trimEnd()}...`;
};

});
parcelRegister("4hOw0", function(module, exports) {

$parcel$export(module.exports, "TRUE_STRING", () => $1fe2aa761593c172$export$38ead5bcf5f643e);
$parcel$export(module.exports, "booleanToString", () => $1fe2aa761593c172$export$26ddfe171c2a4299);
const $1fe2aa761593c172$export$38ead5bcf5f643e = "true";
const $1fe2aa761593c172$var$FALSE_STRING = "false";
const $1fe2aa761593c172$export$26ddfe171c2a4299 = (value)=>value ? $1fe2aa761593c172$export$38ead5bcf5f643e : $1fe2aa761593c172$var$FALSE_STRING;

});


parcelRegister("8gUdJ", function(module, exports) {

$parcel$export(module.exports, "ExerciseSelectionManager", () => $4d93ac0e7bd9149a$export$c4e453203d6a81e7);

var $1IWnK = parcelRequire("1IWnK");

var $buI4E = parcelRequire("buI4E");
class $4d93ac0e7bd9149a$export$c4e453203d6a81e7 {
    clearAllSelectedExercises() {
        this._selectedExercises.set([]);
    }
    updateSelectedExerciseList(exercises, isSelected) {
        for (const exercise of exercises)this.updateSelectedExercise(exercise, isSelected);
    }
    updateSelectedExercise(exercise, isSelected) {
        const selectedExercises = [
            ...this._selectedExercises.get()
        ];
        if (isSelected) this._selectedExercises.set((0, $buI4E.orderList)([
            ...selectedExercises,
            exercise
        ], "title"));
        else {
            selectedExercises.splice(selectedExercises.indexOf(exercise), 1);
            this._selectedExercises.set(selectedExercises);
        }
    }
    constructor(){
        this._selectedExercises = (0, $1IWnK.observable)([]);
        this.selectedExercises = this._selectedExercises.readOnly();
    }
}

});


parcelRegister("dvhRi", function(module, exports) {

$parcel$export(module.exports, "ExerciseService", () => $ba24a9555336d8ee$export$ee3b8f811b98e69a);

var $aAhWR = parcelRequire("aAhWR");
class $ba24a9555336d8ee$export$ee3b8f811b98e69a {
    constructor(apiService){
        this.apiService = apiService;
    }
    async listExercises() {
        const result = await this.apiService.get("/library/exercises");
        return result.data.map((exercise)=>$ba24a9555336d8ee$export$ee3b8f811b98e69a.exerciseFromLibraryExerciseDto(exercise));
    }
    static exerciseFromLibraryExerciseDto(exerciseDto) {
        return {
            ...exerciseDto,
            units: 10,
            setCount: 1,
            draggableId: (0, $aAhWR.default)()
        };
    }
    static exerciseFromDto(exerciseDto) {
        return {
            ...exerciseDto,
            draggableId: (0, $aAhWR.default)(),
            alternativeExercises: exerciseDto.alternativeExercises.map($ba24a9555336d8ee$export$ee3b8f811b98e69a.alternativeExerciseFromDto)
        };
    }
    static dtoFromExercise(exercise) {
        return {
            id: exercise.id,
            revision: exercise.revision,
            units: exercise.units,
            setCount: exercise.setCount,
            comment: exercise.comment,
            alternativeExercises: exercise.alternativeExercises.map(this.dtoFromAlternativeExercise)
        };
    }
    static dtoFromAlternativeExercise(alternativeExercise) {
        return {
            id: alternativeExercise.id,
            revision: alternativeExercise.revision,
            units: alternativeExercise.units,
            setCount: alternativeExercise.setCount,
            comment: alternativeExercise.comment
        };
    }
    static alternativeExerciseFromDto(alternativeDto) {
        return {
            ...alternativeDto,
            draggableId: (0, $aAhWR.default)()
        };
    }
}

});
parcelRegister("aAhWR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b4b305d21566e4a$export$2e2bcd8739ae039);

var $iqnnF = parcelRequire("iqnnF");

var $4bkyD = parcelRequire("4bkyD");

var $cWrQs = parcelRequire("cWrQs");
function $7b4b305d21566e4a$var$v4(options, buf, offset) {
    if ((0, $iqnnF.default).randomUUID && !buf && !options) return (0, $iqnnF.default).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $4bkyD.default)();
    if (rnds.length < 16) throw new Error("Random bytes length must be >= 16");
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $cWrQs.unsafeStringify)(rnds);
}
var $7b4b305d21566e4a$export$2e2bcd8739ae039 = $7b4b305d21566e4a$var$v4;

});
parcelRegister("iqnnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d69ccaa4215bff73$export$2e2bcd8739ae039);
const $d69ccaa4215bff73$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $d69ccaa4215bff73$export$2e2bcd8739ae039 = {
    randomUUID: $d69ccaa4215bff73$var$randomUUID
};

});

parcelRegister("4bkyD", function(module, exports) {

$parcel$export(module.exports, "default", () => $30b822d08f5971cc$export$2e2bcd8739ae039);
let $30b822d08f5971cc$var$getRandomValues;
const $30b822d08f5971cc$var$rnds8 = new Uint8Array(16);
function $30b822d08f5971cc$export$2e2bcd8739ae039() {
    if (!$30b822d08f5971cc$var$getRandomValues) {
        if (typeof crypto === "undefined" || !crypto.getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
        $30b822d08f5971cc$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $30b822d08f5971cc$var$getRandomValues($30b822d08f5971cc$var$rnds8);
}

});

parcelRegister("cWrQs", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $96c08047943ca7b8$export$8fb373d660548968);

var $jTNur = parcelRequire("jTNur");
const $96c08047943ca7b8$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$96c08047943ca7b8$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $96c08047943ca7b8$export$8fb373d660548968(arr, offset = 0) {
    return ($96c08047943ca7b8$var$byteToHex[arr[offset + 0]] + $96c08047943ca7b8$var$byteToHex[arr[offset + 1]] + $96c08047943ca7b8$var$byteToHex[arr[offset + 2]] + $96c08047943ca7b8$var$byteToHex[arr[offset + 3]] + "-" + $96c08047943ca7b8$var$byteToHex[arr[offset + 4]] + $96c08047943ca7b8$var$byteToHex[arr[offset + 5]] + "-" + $96c08047943ca7b8$var$byteToHex[arr[offset + 6]] + $96c08047943ca7b8$var$byteToHex[arr[offset + 7]] + "-" + $96c08047943ca7b8$var$byteToHex[arr[offset + 8]] + $96c08047943ca7b8$var$byteToHex[arr[offset + 9]] + "-" + $96c08047943ca7b8$var$byteToHex[arr[offset + 10]] + $96c08047943ca7b8$var$byteToHex[arr[offset + 11]] + $96c08047943ca7b8$var$byteToHex[arr[offset + 12]] + $96c08047943ca7b8$var$byteToHex[arr[offset + 13]] + $96c08047943ca7b8$var$byteToHex[arr[offset + 14]] + $96c08047943ca7b8$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $96c08047943ca7b8$var$stringify(arr, offset = 0) {
    const uuid = $96c08047943ca7b8$export$8fb373d660548968(arr, offset);
    if (!(0, $jTNur.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $96c08047943ca7b8$export$2e2bcd8739ae039 = $96c08047943ca7b8$var$stringify;

});
parcelRegister("jTNur", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7c98b0eb3dcc196$export$2e2bcd8739ae039);

var $kcJ6M = parcelRequire("kcJ6M");
function $e7c98b0eb3dcc196$var$validate(uuid) {
    return typeof uuid === "string" && (0, $kcJ6M.default).test(uuid);
}
var $e7c98b0eb3dcc196$export$2e2bcd8739ae039 = $e7c98b0eb3dcc196$var$validate;

});
parcelRegister("kcJ6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb57eb394ca13493$export$2e2bcd8739ae039);
var $eb57eb394ca13493$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});





parcelRegister("kKtHN", function(module, exports) {

$parcel$export(module.exports, "ExerciseFilterManager", () => $bf7c847dec730cfe$export$47c2be1909ba8945);

var $1IWnK = parcelRequire("1IWnK");

var $buI4E = parcelRequire("buI4E");

var $8gUdJ = parcelRequire("8gUdJ");

var $ghfIB = parcelRequire("ghfIB");
class $bf7c847dec730cfe$export$47c2be1909ba8945 extends (0, $8gUdJ.ExerciseSelectionManager) {
    constructor(){
        super();
        this._filteredExercises = (0, $1IWnK.observable)([]);
        this.filteredExercises = this._filteredExercises.readOnly();
        this.searchWord = (0, $1IWnK.observable)("");
        this.activeFilters = (0, $1IWnK.observable)([]);
        this.searchWord.subscribe(()=>this.filterExercises());
        this.activeFilters.subscribe(()=>this.filterExercises());
    }
    async fetchExercises() {
        await (0, $ghfIB.exerciseManager).fetchExercises();
    }
    clearAllFiltersAndSearch() {
        this.searchWord.set("");
        this.activeFilters.set([]);
    }
    filterExercises() {
        let filteredExercises = (0, $ghfIB.exerciseManager).allExercises.get().filter((exercise)=>{
            for (const category of this.activeFilters.get()){
                if (!this.exerciseMatchFilterCategory(exercise, category)) return false;
            }
            return true;
        });
        const search = this.searchWord.get();
        if (search) filteredExercises = [
            ...new Set([
                filteredExercises.filter((exercise)=>(0, $buI4E.isWordMatchingSearch)(exercise.title, search)),
                filteredExercises.filter((exercise)=>(0, $buI4E.isWordMatchingSearch)(exercise.description || "", search)),
                filteredExercises.filter((exercise)=>exercise.tags.some((tag)=>(0, $buI4E.isWordMatchingSearch)(tag, search)))
            ].flat())
        ];
        this._filteredExercises.set((0, $buI4E.orderList)(filteredExercises, "title"));
    }
    exerciseMatchFilterCategory(exercise, filterCategory) {
        if (filterCategory.filters.length === 0) return true;
        for (const filter of filterCategory.filters){
            if (filter.predicate(exercise)) return true;
        }
        return false;
    }
}

});

parcelRegister("jJH8x", function(module, exports) {

$parcel$export(module.exports, "NetworkActionsErrorsManager", () => $ab18c646f4caf052$export$bacfeec6e30a808);

var $1IWnK = parcelRequire("1IWnK");
class $ab18c646f4caf052$export$bacfeec6e30a808 {
    clearError() {
        this._actionErrors.set(null);
    }
    reportError(error, message, title) {
        this._actionErrors.set({
            date: new Date(),
            error: error,
            title: title,
            message: message
        });
    }
    constructor(){
        this._actionErrors = (0, $1IWnK.observable)(null);
        this.actionErrors = this._actionErrors.readOnly();
    }
}

});

parcelRegister("bGHjr", function(module, exports) {

$parcel$export(module.exports, "NotificationBadgeManager", () => $80358e2c9df519df$export$921a6ccb82258e91);

var $lTdpc = parcelRequire("lTdpc");

var $1IWnK = parcelRequire("1IWnK");
class $80358e2c9df519df$export$921a6ccb82258e91 {
    constructor(notificationManager, userManager, store){
        this.notificationManager = notificationManager;
        this.userManager = userManager;
        this.store = store;
        this._lastUnreadCount = (0, $1IWnK.observable)(-1);
        this.shouldDisplayBadge = (0, $1IWnK.Observable).merge([
            this.notificationManager.unreadCount,
            this._lastUnreadCount
        ]).select(([unreadCount, lastUnreadCount])=>unreadCount > 0 && lastUnreadCount !== unreadCount);
        this.userManager.user.subscribe(async (user)=>{
            const ptId = user?.id;
            const storedUnreadCounts = this.store.getItem();
            let lastUnreadCount = -1;
            if ((0, $lTdpc.isNotNil)(ptId) && (0, $lTdpc.isNotNil)(storedUnreadCounts) && (0, $lTdpc.isNotNil)(storedUnreadCounts[ptId])) lastUnreadCount = storedUnreadCounts[ptId];
            this._lastUnreadCount.set(lastUnreadCount);
        });
    }
    saveLastUnreadCount() {
        const unreadCount = this.notificationManager.unreadCount.get();
        const ptId = this.userManager.user.get()?.id;
        if ((0, $lTdpc.isNil)(ptId)) return;
        const previousLastUnreadCounts = this.store.getItem();
        this.store.setItem({
            ...previousLastUnreadCounts,
            [ptId]: unreadCount
        });
        this._lastUnreadCount.set(unreadCount);
    }
}

});

parcelRegister("kRxX7", function(module, exports) {

$parcel$export(module.exports, "NotificationManager", () => $a2c768fc4bdd1093$export$dfa1f14b6290f8c5);

var $he9Ds = parcelRequire("he9Ds");

var $eOSo1 = parcelRequire("eOSo1");

var $lTdpc = parcelRequire("lTdpc");

var $1IWnK = parcelRequire("1IWnK");
class $a2c768fc4bdd1093$export$dfa1f14b6290f8c5 {
    constructor(notificationService){
        this.notificationService = notificationService;
        this.logger = (0, $eOSo1.getLogger)("\uD83D\uDCAC [NotificationManager]");
        this._notifications = (0, $1IWnK.observable)(new Map());
        this.notifications = this._notifications.readOnly();
        this._unreadCount = (0, $1IWnK.observable)(0);
        this._isFetchingUnsentNotifications = false;
        this.unreadCount = this._unreadCount.readOnly();
        this.listingOffset = 0;
        this._isNewUnsentNotificationsAvailable = (0, $1IWnK.observable)(false);
        this.isNewUnsentNotificationsAvailable = this._isNewUnsentNotificationsAvailable.readOnly();
        this._notifications.subscribe(()=>this.logger.info("notifications was modified"));
    }
    async loadNotifications() {
        this.listingOffset = 0;
        this._notifications.set(new Map());
        return this.fetchAndAppendNotifications();
    }
    async loadMoreNotifications() {
        this.listingOffset += (0, $he9Ds.APP_CONSTANTS).NOTIFICATION_CENTER_PAGINATION_SIZE;
        return this.fetchAndAppendNotifications();
    }
    async markAllAsRead() {
        await this.notificationService.markAllAsRead();
        this._notifications.update((notifications)=>{
            notifications.forEach((notification)=>notification.markAsRead());
            return new Map([
                ...notifications
            ]);
        });
        this.updateUnreadCount(0);
    }
    async markAsRead(notificationId, optimistically = true) {
        await this.notificationService.markAsRead(notificationId);
        this._notifications.update((notifications)=>{
            [
                ...notifications.values()
            ].find(({ id: id })=>id === notificationId)?.markAsRead();
            return new Map([
                ...notifications
            ]);
        });
        if (optimistically) this.updateUnreadCount(this.unreadCount.get() - 1);
    }
    async markAsUnread(notificationId, optimistically = true) {
        await this.notificationService.markAsUnread(notificationId);
        this._notifications.update((notifications)=>{
            [
                ...notifications.values()
            ].find(({ id: id })=>id === notificationId)?.markAsUnread();
            return new Map([
                ...notifications
            ]);
        });
        if (optimistically) this.updateUnreadCount(this.unreadCount.get() + 1);
    }
    async fetchUnsentNotifications(optimistically = false) {
        if (!this._isFetchingUnsentNotifications) {
            this._isFetchingUnsentNotifications = true;
            // Fetch and prepend the new notifications
            const newNotifications = await this.notificationService.getUnsentNotifications();
            const newUnsentCount = newNotifications.length;
            this._notifications.update((current)=>new Map([
                    ...newNotifications.map((notification)=>[
                            notification.id,
                            notification
                        ]),
                    ...current
                ]));
            this.listingOffset += newUnsentCount;
            if (newUnsentCount === 1) this._newUnsentNotificationData = {
                count: 1,
                notification: newNotifications[0]
            };
            else if (newUnsentCount > 1) this._newUnsentNotificationData = {
                count: newUnsentCount
            };
            this.logger.debug("isNewUnreadNotificationsAvailable set to", true);
            this._isNewUnsentNotificationsAvailable.set(true);
            this._isFetchingUnsentNotifications = false;
            if (optimistically) this.updateUnreadCount(this.unreadCount.get() + newUnsentCount);
        }
    }
    get newUnsentNotificationData() {
        if ((0, $lTdpc.isNil)(this._newUnsentNotificationData)) return undefined;
        const data = this._newUnsentNotificationData;
        this._isNewUnsentNotificationsAvailable.set(false);
        this.logger.debug("isNewUnreadNotificationsAvailable set to", false);
        this._newUnsentNotificationData = undefined;
        return data;
    }
    updateUnreadCount(unreadCount) {
        if (unreadCount !== this.unreadCount.get()) {
            this.logger.debug("Updating unreadCount from", this.unreadCount.get(), "to", unreadCount);
            this._unreadCount.set(unreadCount);
        }
    }
    debugMockNotificationData(notification) {
        this._newUnsentNotificationData = {
            count: 1,
            notification: notification
        };
        this._isNewUnsentNotificationsAvailable.set(true);
    }
    async fetchAndAppendNotifications() {
        const { notifications: notifications, reachedEnd: reachedEnd, unreadNotificationsCount: unreadNotificationsCount } = await this.notificationService.loadNotifications((0, $he9Ds.APP_CONSTANTS).NOTIFICATION_CENTER_PAGINATION_SIZE, this.listingOffset);
        this._notifications.update((current)=>new Map([
                ...current,
                ...notifications.map((notification)=>[
                        notification.id,
                        notification
                    ])
            ]));
        this.updateUnreadCount(unreadNotificationsCount);
        return {
            reachedEnd: reachedEnd
        };
    }
    async reset() {
        this.logger.debug("Resetting...");
        this._unreadCount.set(0);
        this._isNewUnsentNotificationsAvailable.set(false);
        this._notifications.set(new Map());
        this._newUnsentNotificationData = undefined;
        this.listingOffset = 0;
    }
}

});
parcelRegister("he9Ds", function(module, exports) {

$parcel$export(module.exports, "APP_CONSTANTS", () => $21082247f9948e12$export$c3e828ecf1ed776c);
const $21082247f9948e12$export$c3e828ecf1ed776c = {
    APP_VERSION: "2.9",
    PROGRAM_OR_TEMPLATE_MAX_TITLE_LENGTH: 100,
    EXERCISE_MAX_COMMENT_LENGTH: 700,
    HEALTH_CARE_INVITE_MAX_CUSTOM_MESSAGE_LENGTH: 700,
    TOAST_DURATION: 8000,
    // 8s
    MAX_INPUT_SIZE: "20.625rem",
    PATIENT_APP_ANDROID_STORE: "https://play.google.com/store/apps/details?id=com.biogen.physiome",
    PATIENT_APP_IOS_STORE: "https://apps.apple.com/app/physio-me/id1599700059",
    REGISTRATION_MAX_SIZE_ID_FILE: 5242880,
    // 5 MiB
    REGISTRATION_VALID_MIME_ID_FILE: [
        "image/jpeg",
        "image/png",
        "application/pdf"
    ],
    CUSTOMER_SUPPORT_DEFAULT_EMAIL_KEY: "fr",
    NOTIFICATION_CENTER_PAGINATION_SIZE: 20,
    LEGAL_AGE_DISCLAIMER_COUNTRIES: [
        "fr"
    ]
};

});


parcelRegister("kEidV", function(module, exports) {

$parcel$export(module.exports, "NotificationService", () => $e3ee4463ea12329b$export$cfe57eeafcf44ca0);

var $espDn = parcelRequire("espDn");

var $echCM = parcelRequire("echCM");

var $2cHWd = parcelRequire("2cHWd");

var $bTNYI = parcelRequire("bTNYI");

var $4bhIM = parcelRequire("4bhIM");

var $iXoR1 = parcelRequire("iXoR1");

var $kqhCK = parcelRequire("kqhCK");

var $h7ymg = parcelRequire("h7ymg");

var $1jqjN = parcelRequire("1jqjN");

var $kI9DF = parcelRequire("kI9DF");

var $kXaMn = parcelRequire("kXaMn");

var $epURn = parcelRequire("epURn");
class $e3ee4463ea12329b$export$cfe57eeafcf44ca0 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async loadNotifications(size, offset = 0) {
        const result = await this.apiService.get(`/pts/me/notifications?size=${size}&offset=${offset}`);
        return {
            notifications: result.data.notifications.content.map((notification)=>$e3ee4463ea12329b$export$cfe57eeafcf44ca0.notificationFromDto(notification)),
            reachedEnd: result.data.notifications.last,
            unreadNotificationsCount: result.data.unreadNotificationsCount
        };
    }
    async markAllAsRead() {
        await this.apiService.post("/pts/me/notifications/mark-as-read");
    }
    async markAsRead(notificationId) {
        await this.apiService.post(`/pts/me/notifications/${notificationId}/mark-as-read`);
    }
    async markAsUnread(notificationId) {
        await this.apiService.post(`/pts/me/notifications/${notificationId}/mark-as-unread`);
    }
    async getUnsentNotifications() {
        const result = await this.apiService.get("/pts/me/notifications/unsent");
        return result.data.map((notification)=>$e3ee4463ea12329b$export$cfe57eeafcf44ca0.notificationFromDto(notification));
    }
    static notificationFromDto(dto) {
        const notification = {
            ...dto,
            creationDate: (0, $kXaMn.dateFromDateDto)(dto.creationDate)
        };
        switch(notification.type){
            case (0, $espDn.NotificationType).PATIENT_PROGRAM_STARTED:
                return new (0, $kqhCK.PatientProgramStartedNotification)(notification);
            case (0, $espDn.NotificationType).PATIENT_PROGRAM_ENDING_SOON:
                return new (0, $iXoR1.PatientProgramEndingSoonNotification)(notification);
            case (0, $espDn.NotificationType).PATIENT_PROGRAM_ENDED:
                return new (0, $4bhIM.PatientProgramEndedNotification)(notification);
            case (0, $espDn.NotificationType).PATIENT_REGISTERED:
                return new (0, $h7ymg.PatientRegisteredNotification)(notification);
            case (0, $espDn.NotificationType).HCT_INVITATION_SENT:
                return new (0, $2cHWd.HctInvitationSentNotification)(notification);
            case (0, $espDn.NotificationType).HCT_INVITATION_ACCEPTED:
                return new (0, $echCM.HctInvitationAcceptedNotification)(notification);
            case (0, $espDn.NotificationType).PT_ACCOUNT_VALIDATED:
                return new (0, $1jqjN.PtAccountValidatedNotification)(notification);
            case (0, $espDn.NotificationType).PT_ACCOUNT_VALIDATION_PENDING:
                return new (0, $kI9DF.PtAccountValidationPendingNotification)(notification);
            case (0, $espDn.NotificationType).PATIENT_HAS_DELETED_HIS_ACCOUNT:
                return new (0, $bTNYI.PatientHasDeletedHisAccountNotification)(notification);
            case (0, $espDn.NotificationType).PT_LEFT_HCT:
                return new (0, $epURn.PtLeftHctNotification)(notification);
        }
    }
}

});
parcelRegister("espDn", function(module, exports) {

$parcel$export(module.exports, "NotificationType", () => $9bba44f085024c8f$export$9130146a86a85749);
$parcel$export(module.exports, "notificationTypes", () => $9bba44f085024c8f$export$1b7a4f1fd460c7bb);
$parcel$export(module.exports, "Notification", () => $9bba44f085024c8f$export$14834abbfce3b8cd);
/* eslint-disable sonarjs/no-identical-functions */ 
var $d90o3 = parcelRequire("d90o3");
var $9bba44f085024c8f$export$9130146a86a85749;
(function(NotificationType) {
    NotificationType["PATIENT_PROGRAM_STARTED"] = "PATIENT_PROGRAM_STARTED";
    NotificationType["PATIENT_PROGRAM_ENDING_SOON"] = "PATIENT_PROGRAM_ENDING_SOON";
    NotificationType["PATIENT_PROGRAM_ENDED"] = "PATIENT_PROGRAM_ENDED";
    NotificationType["PATIENT_HAS_DELETED_HIS_ACCOUNT"] = "PATIENT_HAS_DELETED_HIS_ACCOUNT";
    NotificationType["PATIENT_REGISTERED"] = "PATIENT_REGISTERED";
    NotificationType["HCT_INVITATION_SENT"] = "HCT_INVITATION_SENT";
    NotificationType["HCT_INVITATION_ACCEPTED"] = "HCT_INVITATION_ACCEPTED";
    NotificationType["PT_ACCOUNT_VALIDATION_PENDING"] = "PT_ACCOUNT_VALIDATION_PENDING";
    NotificationType["PT_ACCOUNT_VALIDATED"] = "PT_ACCOUNT_VALIDATED";
    NotificationType["PT_LEFT_HCT"] = "PT_LEFT_HCT";
})($9bba44f085024c8f$export$9130146a86a85749 || ($9bba44f085024c8f$export$9130146a86a85749 = {}));
const $9bba44f085024c8f$export$1b7a4f1fd460c7bb = (0, $d90o3.getEnumValues)($9bba44f085024c8f$export$9130146a86a85749);
class $9bba44f085024c8f$export$14834abbfce3b8cd {
    constructor(notification){
        this.notification = notification;
    }
    markAsRead() {
        this.notification.isRead = true;
    }
    markAsUnread() {
        this.notification.isRead = false;
    }
    get isRead() {
        return this.notification.isRead;
    }
    get id() {
        return this.notification.id;
    }
    get type() {
        return this.notification.type;
    }
    get creationDate() {
        return this.notification.creationDate;
    }
}

});

parcelRegister("echCM", function(module, exports) {

$parcel$export(module.exports, "HctInvitationAcceptedNotification", () => $9db26638ff5a00a9$export$9613e840f531fbb0);

var $espDn = parcelRequire("espDn");

var $lDZlX = parcelRequire("lDZlX");

var $buI4E = parcelRequire("buI4E");
class $9db26638ff5a00a9$export$9613e840f531fbb0 extends (0, $espDn.Notification) {
    get data() {
        return this.notification.data;
    }
    format({ format: format }) {
        return format("global.notifications.hct.joined", {
            ptName: (0, $buI4E.formatName)(this.data.invitedPt),
            patientName: (0, $buI4E.formatName)(this.data.patient)
        });
    }
    onClick(navigate) {
        navigate((0, $lDZlX.RoutesPath).PatientDetails, {
            route: {
                patientId: this.data.patient.id
            },
            query: {
                active: (0, $lDZlX.TabPatientDetails).HEALTHCARE_TAB
            }
        });
    }
}

});

parcelRegister("2cHWd", function(module, exports) {

$parcel$export(module.exports, "HctInvitationSentNotification", () => $fcd10a182cbb50b8$export$955756e07ef82b96);

var $espDn = parcelRequire("espDn");

var $lDZlX = parcelRequire("lDZlX");

var $buI4E = parcelRequire("buI4E");
class $fcd10a182cbb50b8$export$955756e07ef82b96 extends (0, $espDn.Notification) {
    get data() {
        return this.notification.data;
    }
    format({ format: format }) {
        return format("global.notifications.hct.invitation", {
            ptName: (0, $buI4E.formatName)(this.data.invitingPt),
            patientName: (0, $buI4E.formatName)(this.data.patient)
        });
    }
    onClick(navigate) {
        navigate((0, $lDZlX.RoutesPath).Home, {
            query: {
                patientId: this.data.patient.id,
                ptId: this.data.invitingPt.id
            }
        });
    }
}

});

parcelRegister("bTNYI", function(module, exports) {

$parcel$export(module.exports, "PatientHasDeletedHisAccountNotification", () => $ef2379b765bd5719$export$e7f9a414f868195f);

var $espDn = parcelRequire("espDn");

var $lDZlX = parcelRequire("lDZlX");

var $buI4E = parcelRequire("buI4E");
class $ef2379b765bd5719$export$e7f9a414f868195f extends (0, $espDn.Notification) {
    get data() {
        return this.notification.data;
    }
    format({ format: format }) {
        return format("global.notifications.patientAccount.deletion", {
            patientName: (0, $buI4E.formatName)(this.data.patient)
        });
    }
    onClick(navigate) {
        navigate((0, $lDZlX.RoutesPath).NotificationCenter);
    }
}

});

parcelRegister("4bhIM", function(module, exports) {

$parcel$export(module.exports, "PatientProgramEndedNotification", () => $652da69f32f5e8e1$export$8e6df38a90185c9c);

var $espDn = parcelRequire("espDn");

var $lDZlX = parcelRequire("lDZlX");

var $buI4E = parcelRequire("buI4E");
class $652da69f32f5e8e1$export$8e6df38a90185c9c extends (0, $espDn.Notification) {
    get data() {
        return this.notification.data;
    }
    format({ format: format }) {
        return format("global.notifications.patientProgram.finished", {
            patientName: (0, $buI4E.formatName)(this.data.patient),
            programName: this.data.program.name
        });
    }
    onClick(navigate) {
        navigate((0, $lDZlX.RoutesPath).PatientDetails, {
            route: {
                patientId: this.data.patient.id
            },
            query: {
                active: (0, $lDZlX.TabPatientDetails).PROGRESS_TAB
            }
        });
    }
}

});

parcelRegister("iXoR1", function(module, exports) {

$parcel$export(module.exports, "PatientProgramEndingSoonNotification", () => $f3a1530458f40d45$export$49f070f9e51d0b59);

var $espDn = parcelRequire("espDn");

var $lDZlX = parcelRequire("lDZlX");

var $kXaMn = parcelRequire("kXaMn");

var $buI4E = parcelRequire("buI4E");
class $f3a1530458f40d45$export$49f070f9e51d0b59 extends (0, $espDn.Notification) {
    get data() {
        return this.notification.data;
    }
    format({ format: format, formatDateMed: formatDateMed }) {
        const endDate = (0, $kXaMn.dateFromDateDto)(this.data.program.endDate);
        const diff = (0, $kXaMn.computeDiffInDays)(this.notification.creationDate, endDate);
        return format("global.notifications.patientProgram.finishSoon", {
            patientName: (0, $buI4E.formatName)(this.data.patient),
            programName: this.data.program.name,
            date: formatDateMed(endDate),
            dayCount: diff
        });
    }
    onClick(navigate) {
        navigate((0, $lDZlX.RoutesPath).PatientDetails, {
            route: {
                patientId: this.data.patient.id
            },
            query: {
                active: (0, $lDZlX.TabPatientDetails).PROGRESS_TAB
            }
        });
    }
}

});

parcelRegister("kqhCK", function(module, exports) {

$parcel$export(module.exports, "PatientProgramStartedNotification", () => $953141f1d4679116$export$5d3ac209ad06b3d7);

var $espDn = parcelRequire("espDn");

var $lDZlX = parcelRequire("lDZlX");

var $buI4E = parcelRequire("buI4E");
class $953141f1d4679116$export$5d3ac209ad06b3d7 extends (0, $espDn.Notification) {
    get data() {
        return this.notification.data;
    }
    format({ format: format }) {
        return format("global.notifications.patientProgram.started", {
            patientName: (0, $buI4E.formatName)(this.data.patient),
            programName: this.data.program.name
        });
    }
    onClick(navigate) {
        navigate((0, $lDZlX.RoutesPath).PatientDetails, {
            route: {
                patientId: this.data.patient.id
            },
            query: {
                active: (0, $lDZlX.TabPatientDetails).PROGRESS_TAB
            }
        });
    }
}

});

parcelRegister("h7ymg", function(module, exports) {

$parcel$export(module.exports, "PatientRegisteredNotification", () => $c8a7892d31b97b25$export$14b2ac6ee3e26bc8);

var $espDn = parcelRequire("espDn");

var $lDZlX = parcelRequire("lDZlX");

var $buI4E = parcelRequire("buI4E");
class $c8a7892d31b97b25$export$14b2ac6ee3e26bc8 extends (0, $espDn.Notification) {
    get data() {
        return this.notification.data;
    }
    format({ format: format }) {
        return format("global.notifications.patient.registered", {
            patientName: (0, $buI4E.formatName)(this.data.patient)
        });
    }
    onClick(navigate) {
        navigate((0, $lDZlX.RoutesPath).PatientDetails, {
            route: {
                patientId: this.data.patient.id
            },
            query: {
                active: (0, $lDZlX.TabPatientDetails).PROGRESS_TAB
            }
        });
    }
}

});

parcelRegister("1jqjN", function(module, exports) {

$parcel$export(module.exports, "PtAccountValidatedNotification", () => $0b855a2736e23de8$export$fc5c003b087f9d02);

var $espDn = parcelRequire("espDn");

var $lDZlX = parcelRequire("lDZlX");
class $0b855a2736e23de8$export$fc5c003b087f9d02 extends (0, $espDn.Notification) {
    get data() {
        return undefined;
    }
    format({ format: format }) {
        return format("global.notifications.ptAccount.validated");
    }
    onClick(navigate) {
        navigate((0, $lDZlX.RoutesPath).NotificationCenter);
    }
}

});

parcelRegister("kI9DF", function(module, exports) {

$parcel$export(module.exports, "PtAccountValidationPendingNotification", () => $4e32f46b3cd5a5cd$export$2f66f098750e2c88);

var $espDn = parcelRequire("espDn");

var $lDZlX = parcelRequire("lDZlX");
class $4e32f46b3cd5a5cd$export$2f66f098750e2c88 extends (0, $espDn.Notification) {
    get data() {
        return undefined;
    }
    format({ format: format }) {
        return format("global.notifications.ptAccount.validationPending");
    }
    onClick(navigate) {
        navigate((0, $lDZlX.RoutesPath).NotificationCenter);
    }
}

});

parcelRegister("epURn", function(module, exports) {

$parcel$export(module.exports, "PtLeftHctNotification", () => $09dc549d64e6858d$export$ad81bc2c6336ac54);

var $espDn = parcelRequire("espDn");

var $lDZlX = parcelRequire("lDZlX");

var $buI4E = parcelRequire("buI4E");
class $09dc549d64e6858d$export$ad81bc2c6336ac54 extends (0, $espDn.Notification) {
    get data() {
        return this.notification.data;
    }
    format({ format: format }) {
        return format("global.notifications.hct.ptleft", {
            patientName: (0, $buI4E.formatName)(this.data.patient),
            ptName: (0, $buI4E.formatName)(this.data.pt)
        });
    }
    onClick(navigate) {
        navigate((0, $lDZlX.RoutesPath).PatientDetails, {
            route: {
                patientId: this.data.patient.id
            },
            query: {
                active: (0, $lDZlX.TabPatientDetails).HEALTHCARE_TAB
            }
        });
    }
}

});


parcelRegister("cdxFd", function(module, exports) {

$parcel$export(module.exports, "OnboardingManager", () => $a7b1b2a363ff5d60$export$a2f244fe169736c5);

var $isRr9 = parcelRequire("isRr9");

var $bqXcD = parcelRequire("bqXcD");

var $lTdpc = parcelRequire("lTdpc");

var $kXaMn = parcelRequire("kXaMn");

var $1IWnK = parcelRequire("1IWnK");
class $a7b1b2a363ff5d60$export$a2f244fe169736c5 {
    constructor(onboardingService, userManager){
        this.onboardingService = onboardingService;
        this.userManager = userManager;
        this._onboardingStatus = (0, $1IWnK.observable)(undefined);
        this._onboardingStepsStatus = (0, $1IWnK.observable)(undefined);
        this.onboardingStepsStatus = this._onboardingStepsStatus.readOnly();
        userManager.user.subscribe(async ()=>{
            await this.init();
        });
        this._onboardingStatus.subscribe((status)=>{
            if ((0, $lTdpc.isNotNil)(status)) {
                const onboardingGetStartedSteps = (0, $bqXcD.initOnboardingGetStartedSteps)(status);
                const onboardingProgramQuickstartSteps = (0, $bqXcD.initOnboardingProgramQuickstartSteps)(status);
                const stepsStatus = {
                    ...onboardingGetStartedSteps,
                    ...onboardingProgramQuickstartSteps
                };
                this._onboardingStepsStatus.set(stepsStatus);
            }
        });
    }
    async init() {
        const status = await this.onboardingService.getOnboardingsStatus();
        this._onboardingStatus.set(status);
    }
    async passStepOnboarding(step, shouldDismissButStayDisplayed = false) {
        const onboardingType = (0, $isRr9.extractOnboardingTypeFromStep)(step);
        const markStepAsDismissed = ()=>this._onboardingStatus.update((status)=>status ? {
                    ...status,
                    [onboardingType]: [
                        ...status[onboardingType],
                        {
                            step: step,
                            date: (0, $kXaMn.now)()
                        }
                    ]
                } : undefined);
        const stepStatus = this.onboardingStepsStatus.get()?.[step];
        switch(stepStatus){
            case (0, $isRr9.OnboardingStepStatus).DISMISSED_BUT_DISPLAYED:
                markStepAsDismissed();
                break;
            case (0, $isRr9.OnboardingStepStatus).AVAILABLE:
                await this.onboardingService.sendOnboardingStepFinished(onboardingType, step);
                if (shouldDismissButStayDisplayed) this._onboardingStepsStatus.update((stepsStatus)=>stepsStatus ? {
                        ...stepsStatus,
                        [step]: (0, $isRr9.OnboardingStepStatus).DISMISSED_BUT_DISPLAYED
                    } : undefined);
                else markStepAsDismissed();
                break;
            case (0, $isRr9.OnboardingStepStatus).PENDING:
            case (0, $isRr9.OnboardingStepStatus).DISMISSED:
            default:
                return;
        }
    }
}

});
parcelRegister("isRr9", function(module, exports) {

$parcel$export(module.exports, "OnboardingGetStartedStep", () => $b97d733451395de8$export$ea118b82b67d1413);
$parcel$export(module.exports, "onboardingGetStartedSteps", () => $b97d733451395de8$export$f91484ac8498ef7b);
$parcel$export(module.exports, "OnboardingType", () => $b97d733451395de8$export$fa8825a82259aa64);
$parcel$export(module.exports, "OnboardingStepStatus", () => $b97d733451395de8$export$52f131411b995eb0);
$parcel$export(module.exports, "extractOnboardingTypeFromStep", () => $b97d733451395de8$export$35a609fd564d3e6a);
$parcel$export(module.exports, "onboardingProgramQuickstartSteps", () => $b97d733451395de8$export$27a21c30333ef1b2);
$parcel$export(module.exports, "OnboardingProgramQuickstartStep", () => $b97d733451395de8$export$ff0a3fe7124a1b4f);

var $d90o3 = parcelRequire("d90o3");

var $jTpg0 = parcelRequire("jTpg0");
var $b97d733451395de8$export$ea118b82b67d1413;
(function(OnboardingGetStartedStep) {
    OnboardingGetStartedStep["GET_STARTED_EXERCISES"] = "GET_STARTED_EXERCISES";
    OnboardingGetStartedStep["GET_STARTED_PROGRAMS"] = "GET_STARTED_PROGRAMS";
    OnboardingGetStartedStep["GET_STARTED_PATIENTS"] = "GET_STARTED_PATIENTS";
})($b97d733451395de8$export$ea118b82b67d1413 || ($b97d733451395de8$export$ea118b82b67d1413 = {}));
const $b97d733451395de8$export$f91484ac8498ef7b = (0, $d90o3.getEnumValues)($b97d733451395de8$export$ea118b82b67d1413);
var $b97d733451395de8$export$fa8825a82259aa64;
(function(OnboardingType) {
    OnboardingType["GET_STARTED"] = "GET_STARTED";
    OnboardingType["PROGRAM_QUICKSTART"] = "PROGRAM_QUICKSTART";
})($b97d733451395de8$export$fa8825a82259aa64 || ($b97d733451395de8$export$fa8825a82259aa64 = {}));
var $b97d733451395de8$export$52f131411b995eb0;
(function(OnboardingStepStatus) {
    OnboardingStepStatus["AVAILABLE"] = "Available";
    OnboardingStepStatus["PENDING"] = "Pending";
    OnboardingStepStatus["DISMISSED"] = "Dismissed";
    OnboardingStepStatus["DISMISSED_BUT_DISPLAYED"] = "DismissedButDisplayed";
})($b97d733451395de8$export$52f131411b995eb0 || ($b97d733451395de8$export$52f131411b995eb0 = {}));
const $b97d733451395de8$export$35a609fd564d3e6a = (step)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).indexOf($b97d733451395de8$export$27a21c30333ef1b2, step) !== -1) return "PROGRAM_QUICKSTART";
    return "GET_STARTED";
};
var $b97d733451395de8$export$ff0a3fe7124a1b4f;
(function(OnboardingProgramQuickstartStep) {
    OnboardingProgramQuickstartStep["ADD_EXERCISE_GUIDE_01"] = "PROGRAM_QUICKSTART_ADD_EXERCISE_GUIDE_01";
    OnboardingProgramQuickstartStep["FILTER_LIBRARY_GUIDE_01"] = "PROGRAM_QUICKSTART_FILTER_LIBRARY_GUIDE_01";
    OnboardingProgramQuickstartStep["FILTER_LIBRARY_GUIDE_02"] = "PROGRAM_QUICKSTART_FILTER_LIBRARY_GUIDE_02";
    OnboardingProgramQuickstartStep["COMPLEMENTARY_EXERCISES_GUIDE_01"] = "PROGRAM_QUICKSTART_COMPLEMENTARY_EXERCISES_GUIDE_01";
    OnboardingProgramQuickstartStep["COMPLEMENTARY_EXERCISES_GUIDE_02"] = "PROGRAM_QUICKSTART_COMPLEMENTARY_EXERCISES_GUIDE_02";
    OnboardingProgramQuickstartStep["COMPLEMENTARY_EXERCISES_GUIDE_03"] = "PROGRAM_QUICKSTART_COMPLEMENTARY_EXERCISES_GUIDE_03";
    OnboardingProgramQuickstartStep["ALTERNATIVE_EXERCISES_GUIDE_01"] = "PROGRAM_QUICKSTART_ALTERNATIVE_EXERCISES_GUIDE_01";
    OnboardingProgramQuickstartStep["ALTERNATIVE_EXERCISES_GUIDE_02"] = "PROGRAM_QUICKSTART_ALTERNATIVE_EXERCISES_GUIDE_02";
    OnboardingProgramQuickstartStep["ALTERNATIVE_EXERCISES_GUIDE_03"] = "PROGRAM_QUICKSTART_ALTERNATIVE_EXERCISES_GUIDE_03";
    OnboardingProgramQuickstartStep["DUPLICATE_SESSION_GUIDE_01"] = "PROGRAM_QUICKSTART_DUPLICATE_SESSION_GUIDE_01";
    OnboardingProgramQuickstartStep["DUPLICATE_SESSION_GUIDE_02"] = "PROGRAM_QUICKSTART_DUPLICATE_SESSION_GUIDE_02";
    OnboardingProgramQuickstartStep["START_TEMPLATE_GUIDE_01"] = "PROGRAM_QUICKSTART_START_TEMPLATE_GUIDE_01";
    OnboardingProgramQuickstartStep["START_DRAFT_GUIDE_01"] = "PROGRAM_QUICKSTART_START_DRAFT_GUIDE_01";
    OnboardingProgramQuickstartStep["START_GUIDE_02"] = "PROGRAM_QUICKSTART_START_GUIDE_02";
})($b97d733451395de8$export$ff0a3fe7124a1b4f || ($b97d733451395de8$export$ff0a3fe7124a1b4f = {}));
const $b97d733451395de8$export$27a21c30333ef1b2 = (0, $d90o3.getEnumValues)($b97d733451395de8$export$ff0a3fe7124a1b4f);

});

parcelRegister("bqXcD", function(module, exports) {

$parcel$export(module.exports, "initOnboardingGetStartedSteps", () => $5d819d7e14d42574$export$a2e62e2b240cd3df);
$parcel$export(module.exports, "initOnboardingProgramQuickstartSteps", () => $5d819d7e14d42574$export$d8182e809760041c);

var $isRr9 = parcelRequire("isRr9");

var $lTdpc = parcelRequire("lTdpc");
const $5d819d7e14d42574$export$47be5b59e5e1d67a = 4;
const $5d819d7e14d42574$export$a2e62e2b240cd3df = (status)=>{
    const record = Object.fromEntries((0, $isRr9.onboardingGetStartedSteps).map((key)=>[
            key,
            (0, $isRr9.OnboardingStepStatus).AVAILABLE
        ]));
    (0, $isRr9.onboardingGetStartedSteps).forEach((step)=>{
        const dismissedStatus = status[(0, $isRr9.OnboardingType).GET_STARTED].find((s)=>s.step === step);
        if ((0, $lTdpc.isNotNil)(dismissedStatus)) record[step] = (0, $isRr9.OnboardingStepStatus).DISMISSED;
    });
    return record;
};
const $5d819d7e14d42574$export$d8182e809760041c = (status)=>{
    const record = Object.fromEntries((0, $isRr9.onboardingProgramQuickstartSteps).map((key)=>[
            key,
            (0, $isRr9.OnboardingStepStatus).AVAILABLE
        ]));
    (0, $isRr9.onboardingProgramQuickstartSteps).forEach((step)=>{
        const dismissedStatus = status[(0, $isRr9.OnboardingType).PROGRAM_QUICKSTART].find((s)=>s.step === step);
        if ((0, $lTdpc.isNotNil)(dismissedStatus)) record[step] = (0, $isRr9.OnboardingStepStatus).DISMISSED;
    });
    return record;
};

});


parcelRegister("dT2AR", function(module, exports) {

$parcel$export(module.exports, "OnboardingService", () => $401024f419d95841$export$f25aa0aa32428d81);

var $isRr9 = parcelRequire("isRr9");

var $kXaMn = parcelRequire("kXaMn");
class $401024f419d95841$export$f25aa0aa32428d81 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async getOnboardingsStatus() {
        const result = await this.apiService.get("/pts/me/onboarding/status");
        return $401024f419d95841$export$f25aa0aa32428d81.onboardingStatusFromDto(result.data);
    }
    async sendOnboardingStepFinished(type, step) {
        await this.apiService.post(`/pts/me/onboarding/${type}/step`, {
            step: step
        });
    }
    static onboardingStatusFromDto(onboardingStatusDto) {
        return {
            [(0, $isRr9.OnboardingType).GET_STARTED]: $401024f419d95841$export$f25aa0aa32428d81.onboardingStepsFromDto(onboardingStatusDto.steps[(0, $isRr9.OnboardingType).GET_STARTED]),
            [(0, $isRr9.OnboardingType).PROGRAM_QUICKSTART]: $401024f419d95841$export$f25aa0aa32428d81.onboardingStepsFromDto(onboardingStatusDto.steps[(0, $isRr9.OnboardingType).PROGRAM_QUICKSTART])
        };
    }
    static onboardingStepsFromDto(dto) {
        return dto?.map((step)=>({
                ...step,
                date: (0, $kXaMn.dateFromDateDto)(step.date)
            })) ?? [];
    }
}

});

parcelRegister("fBvlK", function(module, exports) {

$parcel$export(module.exports, "GetStartedManager", () => $bed1fcdaf3000c4a$export$e1997332b62e140b);

var $1IWnK = parcelRequire("1IWnK");

var $isRr9 = parcelRequire("isRr9");

var $4nRkH = parcelRequire("4nRkH");

var $lTdpc = parcelRequire("lTdpc");

var $jTpg0 = parcelRequire("jTpg0");
const $bed1fcdaf3000c4a$var$TIMER_DELAY_MS = 3600000; // 1 hour
var $bed1fcdaf3000c4a$var$GetStartedVisibility;
(function(GetStartedVisibility) {
    GetStartedVisibility["Hidden"] = "Hidden";
    GetStartedVisibility["Visible"] = "Visible";
    GetStartedVisibility["Timed"] = "Timed";
})($bed1fcdaf3000c4a$var$GetStartedVisibility || ($bed1fcdaf3000c4a$var$GetStartedVisibility = {}));
class $bed1fcdaf3000c4a$export$e1997332b62e140b {
    constructor(onboardingManager, userManager){
        this.onboardingManager = onboardingManager;
        this._getStartedStepsStatus = undefined;
        this._timer = undefined;
        this._completedCount = (0, $1IWnK.observable)(0);
        this.completedCount = this._completedCount.readOnly();
        this._exercisesStepStatus = (0, $1IWnK.observable)((0, $4nRkH.GetStartedStepStatus).Default);
        this.exercisesStepStatus = this._exercisesStepStatus.readOnly();
        this._programsStepStatus = (0, $1IWnK.observable)((0, $4nRkH.GetStartedStepStatus).Default);
        this.programsStepStatus = this._programsStepStatus.readOnly();
        this._patientsStepStatus = (0, $1IWnK.observable)((0, $4nRkH.GetStartedStepStatus).Default);
        this.patientsStepStatus = this._patientsStepStatus.readOnly();
        this._shouldDisplayGetStartedTab = (0, $1IWnK.observable)(false);
        this.shouldDisplayGetStartedTab = this._shouldDisplayGetStartedTab.readOnly();
        this.shouldDisplayGetStartedCompletedDialog = (0, $1IWnK.observable)(false);
        this._currentUser = (0, $1IWnK.observable)(null);
        this.tryPassStepAsCompleted = async (step)=>{
            if ((0, $lTdpc.isNotNil)(this._getStartedStepsStatus) && this._getStartedStepsStatus[step] === (0, $4nRkH.GetStartedStepStatus).Default) try {
                await this.onboardingManager.passStepOnboarding(step);
            } catch (error) {
                console.error(`Failed to pass get-started step ${step}:`, error);
            }
        };
        this.reset = ()=>{
            this._getStartedStepsStatus = undefined;
            if ((0, $lTdpc.isNotNil)(this._timer)) {
                clearTimeout(this._timer);
                this._timer = undefined;
            }
        };
        onboardingManager.onboardingStepsStatus.subscribe((onboardingStepsStatus)=>{
            if (this._currentUser.get() === null) return;
            const stepsStatus = $bed1fcdaf3000c4a$var$getGetStartedStepsStatus(onboardingStepsStatus);
            if ((0, $jTpg0.isNil)(this._getStartedStepsStatus) || !$bed1fcdaf3000c4a$var$areGetStartedStepsStatusEqual(this._getStartedStepsStatus, stepsStatus)) {
                const newCompletedCount = $bed1fcdaf3000c4a$var$getCompletedStepsCount(stepsStatus);
                const oldCompletedCount = (0, $jTpg0.isNil)(this._getStartedStepsStatus) ? newCompletedCount : this._completedCount.get();
                const getStartedVisibility = $bed1fcdaf3000c4a$var$getGetStartedVisibility(oldCompletedCount, newCompletedCount);
                this._getStartedStepsStatus = stepsStatus;
                if (getStartedVisibility === "Timed") this._timer = setTimeout(()=>{
                    $bed1fcdaf3000c4a$var$updateObservable(this._shouldDisplayGetStartedTab, false);
                    this._timer = undefined;
                }, $bed1fcdaf3000c4a$var$TIMER_DELAY_MS);
                $bed1fcdaf3000c4a$var$updateObservable(this._shouldDisplayGetStartedTab, getStartedVisibility !== "Hidden");
                $bed1fcdaf3000c4a$var$updateObservable(this.shouldDisplayGetStartedCompletedDialog, getStartedVisibility === "Timed");
                $bed1fcdaf3000c4a$var$updateObservable(this._completedCount, newCompletedCount);
                $bed1fcdaf3000c4a$var$updateObservable(this._exercisesStepStatus, stepsStatus[(0, $isRr9.OnboardingGetStartedStep).GET_STARTED_EXERCISES]);
                $bed1fcdaf3000c4a$var$updateObservable(this._programsStepStatus, stepsStatus[(0, $isRr9.OnboardingGetStartedStep).GET_STARTED_PROGRAMS]);
                $bed1fcdaf3000c4a$var$updateObservable(this._patientsStepStatus, stepsStatus[(0, $isRr9.OnboardingGetStartedStep).GET_STARTED_PATIENTS]);
            }
        });
        userManager.user.subscribe(async (user)=>{
            const currentUser = this._currentUser.get();
            if ((0, $lTdpc.isNotNil)(currentUser) && currentUser.id !== user?.id) this.reset();
            $bed1fcdaf3000c4a$var$updateObservable(this._currentUser, user);
        });
    }
    async tryMarkExercisesStepAsCompleted() {
        await this.tryPassStepAsCompleted((0, $isRr9.OnboardingGetStartedStep).GET_STARTED_EXERCISES);
    }
    async tryMarkProgramsStepAsCompleted() {
        await this.tryPassStepAsCompleted((0, $isRr9.OnboardingGetStartedStep).GET_STARTED_PROGRAMS);
    }
    async tryMarkPatientsStepAsCompleted() {
        await this.tryPassStepAsCompleted((0, $isRr9.OnboardingGetStartedStep).GET_STARTED_PATIENTS);
    }
}
const $bed1fcdaf3000c4a$var$getGetStartedVisibility = (oldCompletedCount, newCompletedCount)=>{
    if (newCompletedCount < (0, $isRr9.onboardingGetStartedSteps).length) return "Visible";
    if (oldCompletedCount < (0, $isRr9.onboardingGetStartedSteps).length) return "Timed";
    return "Hidden";
};
const $bed1fcdaf3000c4a$var$areGetStartedStepsStatusEqual = (a, b)=>(0, $isRr9.onboardingGetStartedSteps).every((step)=>a[step] === b[step]);
const $bed1fcdaf3000c4a$var$updateObservable = (writableObservable, value)=>{
    if (writableObservable.get() !== value) writableObservable.set(value);
};
const $bed1fcdaf3000c4a$var$getCompletedStepsCount = (getStartedStepsStatus)=>(0, $isRr9.onboardingGetStartedSteps).reduce((count, step)=>getStartedStepsStatus[step] === (0, $4nRkH.GetStartedStepStatus).Completed ? count + 1 : count, 0);
const $bed1fcdaf3000c4a$var$getGetStartedStepsStatus = (onboardingStepsStatus)=>Object.fromEntries((0, $isRr9.onboardingGetStartedSteps).map((step)=>[
            step,
            onboardingStepsStatus?.[step] === (0, $isRr9.OnboardingStepStatus).DISMISSED ? (0, $4nRkH.GetStartedStepStatus).Completed : (0, $4nRkH.GetStartedStepStatus).Default
        ]));

});
parcelRegister("4nRkH", function(module, exports) {

$parcel$export(module.exports, "getStartedSteps", () => $f29dbe8b1f811915$export$b095a76903254c29);
$parcel$export(module.exports, "GetStartedStepStatus", () => $f29dbe8b1f811915$export$e55ced82eba1ca17);

var $isRr9 = parcelRequire("isRr9");
const $f29dbe8b1f811915$export$b095a76903254c29 = (0, $isRr9.onboardingGetStartedSteps);
var $f29dbe8b1f811915$export$e55ced82eba1ca17;
(function(GetStartedStepStatus) {
    GetStartedStepStatus["Default"] = "Default";
    GetStartedStepStatus["Completed"] = "Completed";
    GetStartedStepStatus["Disabled"] = "Disabled";
})($f29dbe8b1f811915$export$e55ced82eba1ca17 || ($f29dbe8b1f811915$export$e55ced82eba1ca17 = {}));

});


parcelRegister("7V7cK", function(module, exports) {

$parcel$export(module.exports, "OnfidoService", () => $6b4eb04430cafa54$export$a48d665e93956fb);
class $6b4eb04430cafa54$export$a48d665e93956fb {
    constructor(authenticatedApiService){
        this.authenticatedApiService = authenticatedApiService;
    }
    async getOnfidoInitConfig() {
        const result = await this.authenticatedApiService.get("/onfido");
        return result.data;
    }
}

});

parcelRegister("idwZU", function(module, exports) {

$parcel$export(module.exports, "PatientManager", () => $1f75bc44952b8a78$export$bcca835f9000de5f);

var $6Yxa2 = parcelRequire("6Yxa2");

var $lTdpc = parcelRequire("lTdpc");

var $kp7gC = parcelRequire("kp7gC");

var $1IWnK = parcelRequire("1IWnK");

var $04Qjn = parcelRequire("04Qjn");

var $l075W = parcelRequire("l075W");
class $1f75bc44952b8a78$export$bcca835f9000de5f {
    constructor(patientService){
        this.patientService = patientService;
        this._allPatients = (0, $1IWnK.observable)(null);
        this._registeredPatientCompliances = (0, $1IWnK.observable)([]);
        this._patientMap = (0, $1IWnK.observable)((0, $kp7gC.Map)());
        this.patientMap = this._patientMap.readOnly();
        this.allPatients = (0, $1IWnK.Observable).select([
            this._allPatients,
            this._registeredPatientCompliances
        ], (currentPatients, currentCompliances)=>({
                pendingPatients: currentPatients?.pendingPatients ?? [],
                registeredPatients: currentPatients?.registeredPatients.map((registeredPatient)=>({
                        ...registeredPatient,
                        compliance: currentCompliances.find((it)=>it.id === registeredPatient.id)?.globalCompliance
                    })) ?? []
            }));
    }
    async createPendingPatient(pendingPatientPutDto) {
        const newPendingPatient = await this.patientService.createPendingPatient(pendingPatientPutDto);
        this.addPendingPatient(newPendingPatient);
        return newPendingPatient;
    }
    async retrievePatient(patientId) {
        try {
            const newPatient = await this.patientService.retrievePatient(patientId);
            this._patientMap.update((patientMap)=>patientMap.set(newPatient.id, newPatient));
        } catch (e) {
            if ((0, $04Qjn.isApiError)(e) && e.code === (0, $l075W.PatientErrorCodes).PendingPatientForbiddenAccess) throw new (0, $l075W.PendingPatientForbiddenAccessError)();
            throw e;
        }
    }
    async deletePatient(patientId) {
        await this.patientService.deletePatient(patientId);
        this.removePatient(patientId);
    }
    async deletePendingPatient(patientId) {
        await this.patientService.deletePendingPatient(patientId);
        this.removePendingPatient(patientId);
    }
    async editPatientDetails(patientId, disease, functionalStatus) {
        await this.patientService.editPatientDetails(patientId, disease, functionalStatus);
        const patientToUpdate = this._patientMap.get().get(patientId);
        if ((0, $lTdpc.isNotNil)(patientToUpdate)) {
            patientToUpdate.functionalStatus = functionalStatus;
            if (!(0, $6Yxa2.isPendingPatient)(patientToUpdate)) patientToUpdate.disease = disease;
            this._patientMap.update((patientMap)=>patientMap.set(patientToUpdate.id, patientToUpdate));
        }
    }
    async fetchAllPatients() {
        const [pendingPatients, registeredPatients] = await Promise.all([
            this.patientService.listPendingPatients(),
            this.patientService.listRegisteredPatient()
        ]);
        this._allPatients.set({
            registeredPatients: registeredPatients,
            pendingPatients: pendingPatients
        });
    }
    async listRegisteredPatientNames() {
        return this.patientService.listRegisteredPatientNames();
    }
    async fetchRegisteredPatientGlobalCompliances() {
        const compliances = await this.patientService.listRegisteredPatientGlobalCompliances();
        this._registeredPatientCompliances.set(compliances);
    }
    async sendInvitationCodeEmail(patientId, email) {
        try {
            await this.patientService.sendInvitationCodeEmail(patientId, email);
        } catch (e) {
            if ((0, $04Qjn.isApiError)(e) && e.status === 400) throw new (0, $l075W.PatientNotPendingError)();
            throw e;
        }
        this._allPatients.update((currentPatients)=>({
                pendingPatients: currentPatients?.pendingPatients.map((pendingPatient)=>pendingPatient.id === patientId ? {
                        ...pendingPatient,
                        email: email
                    } : pendingPatient) ?? [],
                registeredPatients: currentPatients?.registeredPatients ?? []
            }));
    }
    async reset() {
        this._allPatients.set(null);
        this._patientMap.set((0, $kp7gC.Map)());
    }
    addPendingPatient(pendingPatient) {
        this._allPatients.update((previousPatients)=>({
                pendingPatients: [
                    pendingPatient,
                    ...previousPatients?.pendingPatients ?? []
                ],
                registeredPatients: previousPatients?.registeredPatients ?? []
            }));
    }
    removePendingPatient(patientId) {
        this._allPatients.update((previousPatients)=>({
                pendingPatients: [
                    ...previousPatients?.pendingPatients.filter((patient)=>patient.id !== patientId) ?? []
                ],
                registeredPatients: previousPatients?.registeredPatients ?? []
            }));
        this._patientMap.update((previousMap)=>previousMap.filter((patient)=>patient.id !== patientId));
    }
    removePatient(patientId) {
        this._allPatients.update((previousPatients)=>({
                pendingPatients: previousPatients?.pendingPatients ?? [],
                registeredPatients: [
                    ...previousPatients?.registeredPatients.filter((patient)=>patient.id !== patientId) ?? []
                ]
            }));
        this._patientMap.update((previousMap)=>previousMap.filter((patient)=>patient.id !== patientId));
    }
}

});
parcelRegister("6Yxa2", function(module, exports) {

$parcel$export(module.exports, "PatientStatus", () => $f14ec7e98b1cd2ec$export$bd6effbea74d616a);
$parcel$export(module.exports, "isPendingPatient", () => $f14ec7e98b1cd2ec$export$afd91e1a0aa9a85e);
var $f14ec7e98b1cd2ec$export$bd6effbea74d616a;
(function(PatientStatus) {
    PatientStatus["Pending"] = "INVITED";
    PatientStatus["Registered"] = "REGISTERED";
})($f14ec7e98b1cd2ec$export$bd6effbea74d616a || ($f14ec7e98b1cd2ec$export$bd6effbea74d616a = {}));
function $f14ec7e98b1cd2ec$export$afd91e1a0aa9a85e(patient) {
    return patient.status === "INVITED";
}

});

parcelRegister("kp7gC", function(module, exports) {

$parcel$export(module.exports, "Map", () => Map);
$parcel$export(module.exports, "OrderedMap", () => OrderedMap);
/**
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var DELETE = "delete";
// Constants describing the size of trie nodes.
var SHIFT = 5; // Resulted in best performance after ______?
var SIZE = 1 << SHIFT;
var MASK = SIZE - 1;
// A consistent shared value representing "not set" which equals nothing other
// than itself, and nothing that could be provided externally.
var NOT_SET = {};
// Boolean references, Rough equivalent of `bool &`.
function MakeRef() {
    return {
        value: false
    };
}
function SetRef(ref) {
    if (ref) ref.value = true;
}
// A function which returns a value representing an "owner" for transient writes
// to tries. The return value will only ever equal itself, and will not equal
// the return of any subsequent call of this function.
function OwnerID() {}
function ensureSize(iter) {
    if (iter.size === undefined) iter.size = iter.__iterate(returnTrue);
    return iter.size;
}
function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== "number") {
        var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
        if ("" + uint32Index !== index || uint32Index === 4294967295) return NaN;
        index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
}
function returnTrue() {
    return true;
}
function wholeSlice(begin, end, size) {
    return (begin === 0 && !isNeg(begin) || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
}
function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
}
function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
}
function resolveIndex(index, size, defaultIndex) {
    // Sanitize indices using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    return index === undefined ? defaultIndex : isNeg(index) ? size === Infinity ? size : Math.max(0, size + index) | 0 : size === undefined || size === index ? index : Math.min(size, index) | 0;
}
function isNeg(value) {
    // Account for -0 which is negative, but not less than 0.
    return value < 0 || value === 0 && 1 / value === -Infinity;
}
var IS_COLLECTION_SYMBOL = "@@__IMMUTABLE_ITERABLE__@@";
function isCollection(maybeCollection) {
    return Boolean(maybeCollection && maybeCollection[IS_COLLECTION_SYMBOL]);
}
var IS_KEYED_SYMBOL = "@@__IMMUTABLE_KEYED__@@";
function isKeyed(maybeKeyed) {
    return Boolean(maybeKeyed && maybeKeyed[IS_KEYED_SYMBOL]);
}
var IS_INDEXED_SYMBOL = "@@__IMMUTABLE_INDEXED__@@";
function isIndexed(maybeIndexed) {
    return Boolean(maybeIndexed && maybeIndexed[IS_INDEXED_SYMBOL]);
}
function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
}
var Collection = function Collection(value) {
    // eslint-disable-next-line no-constructor-return
    return isCollection(value) ? value : Seq(value);
};
var KeyedCollection = /*@__PURE__*/ function(Collection) {
    function KeyedCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isKeyed(value) ? value : KeyedSeq(value);
    }
    if (Collection) KeyedCollection.__proto__ = Collection;
    KeyedCollection.prototype = Object.create(Collection && Collection.prototype);
    KeyedCollection.prototype.constructor = KeyedCollection;
    return KeyedCollection;
}(Collection);
var IndexedCollection = /*@__PURE__*/ function(Collection) {
    function IndexedCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isIndexed(value) ? value : IndexedSeq(value);
    }
    if (Collection) IndexedCollection.__proto__ = Collection;
    IndexedCollection.prototype = Object.create(Collection && Collection.prototype);
    IndexedCollection.prototype.constructor = IndexedCollection;
    return IndexedCollection;
}(Collection);
var SetCollection = /*@__PURE__*/ function(Collection) {
    function SetCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isCollection(value) && !isAssociative(value) ? value : SetSeq(value);
    }
    if (Collection) SetCollection.__proto__ = Collection;
    SetCollection.prototype = Object.create(Collection && Collection.prototype);
    SetCollection.prototype.constructor = SetCollection;
    return SetCollection;
}(Collection);
Collection.Keyed = KeyedCollection;
Collection.Indexed = IndexedCollection;
Collection.Set = SetCollection;
var IS_SEQ_SYMBOL = "@@__IMMUTABLE_SEQ__@@";
function isSeq(maybeSeq) {
    return Boolean(maybeSeq && maybeSeq[IS_SEQ_SYMBOL]);
}
var IS_RECORD_SYMBOL = "@@__IMMUTABLE_RECORD__@@";
function isRecord(maybeRecord) {
    return Boolean(maybeRecord && maybeRecord[IS_RECORD_SYMBOL]);
}
function isImmutable(maybeImmutable) {
    return isCollection(maybeImmutable) || isRecord(maybeImmutable);
}
var IS_ORDERED_SYMBOL = "@@__IMMUTABLE_ORDERED__@@";
function isOrdered(maybeOrdered) {
    return Boolean(maybeOrdered && maybeOrdered[IS_ORDERED_SYMBOL]);
}
var ITERATE_KEYS = 0;
var ITERATE_VALUES = 1;
var ITERATE_ENTRIES = 2;
var REAL_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = "@@iterator";
var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
var Iterator = function Iterator(next) {
    this.next = next;
};
Iterator.prototype.toString = function toString() {
    return "[Iterator]";
};
Iterator.KEYS = ITERATE_KEYS;
Iterator.VALUES = ITERATE_VALUES;
Iterator.ENTRIES = ITERATE_ENTRIES;
Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
    return this.toString();
};
Iterator.prototype[ITERATOR_SYMBOL] = function() {
    return this;
};
function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [
        k,
        v
    ];
    iteratorResult ? iteratorResult.value = value : iteratorResult = {
        value: value,
        done: false
    };
    return iteratorResult;
}
function iteratorDone() {
    return {
        value: undefined,
        done: true
    };
}
function hasIterator(maybeIterable) {
    if (Array.isArray(maybeIterable)) // IE11 trick as it does not support `Symbol.iterator`
    return true;
    return !!getIteratorFn(maybeIterable);
}
function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === "function";
}
function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
}
function getIteratorFn(iterable) {
    var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === "function") return iteratorFn;
}
function isEntriesIterable(maybeIterable) {
    var iteratorFn = getIteratorFn(maybeIterable);
    return iteratorFn && iteratorFn === maybeIterable.entries;
}
function isKeysIterable(maybeIterable) {
    var iteratorFn = getIteratorFn(maybeIterable);
    return iteratorFn && iteratorFn === maybeIterable.keys;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isArrayLike(value) {
    if (Array.isArray(value) || typeof value === "string") return true;
    return value && typeof value === "object" && Number.isInteger(value.length) && value.length >= 0 && (value.length === 0 ? Object.keys(value).length === 1 : // in the array-like may be found (which could be undefined).
    value.hasOwnProperty(value.length - 1));
}
var Seq = /*@__PURE__*/ function(Collection) {
    function Seq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence() : isImmutable(value) ? value.toSeq() : seqFromValue(value);
    }
    if (Collection) Seq.__proto__ = Collection;
    Seq.prototype = Object.create(Collection && Collection.prototype);
    Seq.prototype.constructor = Seq;
    Seq.prototype.toSeq = function toSeq() {
        return this;
    };
    Seq.prototype.toString = function toString() {
        return this.__toString("Seq {", "}");
    };
    Seq.prototype.cacheResult = function cacheResult() {
        if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
        }
        return this;
    };
    // abstract __iterateUncached(fn, reverse)
    Seq.prototype.__iterate = function __iterate(fn, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            while(i !== size){
                var entry = cache[reverse ? size - ++i : i++];
                if (fn(entry[1], entry[0], this) === false) break;
            }
            return i;
        }
        return this.__iterateUncached(fn, reverse);
    };
    // abstract __iteratorUncached(type, reverse)
    Seq.prototype.__iterator = function __iterator(type, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            return new Iterator(function() {
                if (i === size) return iteratorDone();
                var entry = cache[reverse ? size - ++i : i++];
                return iteratorValue(type, entry[0], entry[1]);
            });
        }
        return this.__iteratorUncached(type, reverse);
    };
    return Seq;
}(Collection);
var KeyedSeq = /*@__PURE__*/ function(Seq) {
    function KeyedSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence().toKeyedSeq() : isCollection(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : isRecord(value) ? value.toSeq() : keyedSeqFromValue(value);
    }
    if (Seq) KeyedSeq.__proto__ = Seq;
    KeyedSeq.prototype = Object.create(Seq && Seq.prototype);
    KeyedSeq.prototype.constructor = KeyedSeq;
    KeyedSeq.prototype.toKeyedSeq = function toKeyedSeq() {
        return this;
    };
    return KeyedSeq;
}(Seq);
var IndexedSeq = /*@__PURE__*/ function(Seq) {
    function IndexedSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence() : isCollection(value) ? isKeyed(value) ? value.entrySeq() : value.toIndexedSeq() : isRecord(value) ? value.toSeq().entrySeq() : indexedSeqFromValue(value);
    }
    if (Seq) IndexedSeq.__proto__ = Seq;
    IndexedSeq.prototype = Object.create(Seq && Seq.prototype);
    IndexedSeq.prototype.constructor = IndexedSeq;
    IndexedSeq.of = function of() {
        return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function toIndexedSeq() {
        return this;
    };
    IndexedSeq.prototype.toString = function toString() {
        return this.__toString("Seq [", "]");
    };
    return IndexedSeq;
}(Seq);
var SetSeq = /*@__PURE__*/ function(Seq) {
    function SetSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return (isCollection(value) && !isAssociative(value) ? value : IndexedSeq(value)).toSetSeq();
    }
    if (Seq) SetSeq.__proto__ = Seq;
    SetSeq.prototype = Object.create(Seq && Seq.prototype);
    SetSeq.prototype.constructor = SetSeq;
    SetSeq.of = function of() {
        return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function toSetSeq() {
        return this;
    };
    return SetSeq;
}(Seq);
Seq.isSeq = isSeq;
Seq.Keyed = KeyedSeq;
Seq.Set = SetSeq;
Seq.Indexed = IndexedSeq;
Seq.prototype[IS_SEQ_SYMBOL] = true;
// #pragma Root Sequences
var ArraySeq = /*@__PURE__*/ function(IndexedSeq) {
    function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
    }
    if (IndexedSeq) ArraySeq.__proto__ = IndexedSeq;
    ArraySeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ArraySeq.prototype.constructor = ArraySeq;
    ArraySeq.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function __iterate(fn, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        while(i !== size){
            var ii = reverse ? size - ++i : i++;
            if (fn(array[ii], ii, this) === false) break;
        }
        return i;
    };
    ArraySeq.prototype.__iterator = function __iterator(type, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var ii = reverse ? size - ++i : i++;
            return iteratorValue(type, ii, array[ii]);
        });
    };
    return ArraySeq;
}(IndexedSeq);
var ObjectSeq = /*@__PURE__*/ function(KeyedSeq) {
    function ObjectSeq(object) {
        var keys = Object.keys(object).concat(Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(object) : []);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
    }
    if (KeyedSeq) ObjectSeq.__proto__ = KeyedSeq;
    ObjectSeq.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ObjectSeq.prototype.constructor = ObjectSeq;
    ObjectSeq.prototype.get = function get(key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) return notSetValue;
        return this._object[key];
    };
    ObjectSeq.prototype.has = function has(key) {
        return hasOwnProperty.call(this._object, key);
    };
    ObjectSeq.prototype.__iterate = function __iterate(fn, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        while(i !== size){
            var key = keys[reverse ? size - ++i : i++];
            if (fn(object[key], key, this) === false) break;
        }
        return i;
    };
    ObjectSeq.prototype.__iterator = function __iterator(type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var key = keys[reverse ? size - ++i : i++];
            return iteratorValue(type, key, object[key]);
        });
    };
    return ObjectSeq;
}(KeyedSeq);
ObjectSeq.prototype[IS_ORDERED_SYMBOL] = true;
var CollectionSeq = /*@__PURE__*/ function(IndexedSeq) {
    function CollectionSeq(collection) {
        this._collection = collection;
        this.size = collection.length || collection.size;
    }
    if (IndexedSeq) CollectionSeq.__proto__ = IndexedSeq;
    CollectionSeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    CollectionSeq.prototype.constructor = CollectionSeq;
    CollectionSeq.prototype.__iterateUncached = function __iterateUncached(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        var iterations = 0;
        if (isIterator(iterator)) {
            var step;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
        }
        return iterations;
    };
    CollectionSeq.prototype.__iteratorUncached = function __iteratorUncached(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        if (!isIterator(iterator)) return new Iterator(iteratorDone);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value);
        });
    };
    return CollectionSeq;
}(IndexedSeq);
// # pragma Helper functions
var EMPTY_SEQ;
function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
}
function keyedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq.fromEntrySeq();
    if (typeof value === "object") return new ObjectSeq(value);
    throw new TypeError("Expected Array or collection object of [k, v] entries, or keyed object: " + value);
}
function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq;
    throw new TypeError("Expected Array or collection object of values: " + value);
}
function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return isEntriesIterable(value) ? seq.fromEntrySeq() : isKeysIterable(value) ? seq.toSetSeq() : seq;
    if (typeof value === "object") return new ObjectSeq(value);
    throw new TypeError("Expected Array or collection object of values, or keyed object: " + value);
}
function maybeIndexedSeqFromValue(value) {
    return isArrayLike(value) ? new ArraySeq(value) : hasIterator(value) ? new CollectionSeq(value) : undefined;
}
var IS_MAP_SYMBOL = "@@__IMMUTABLE_MAP__@@";
function isMap(maybeMap) {
    return Boolean(maybeMap && maybeMap[IS_MAP_SYMBOL]);
}
function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
}
function isValueObject(maybeValue) {
    return Boolean(maybeValue && typeof maybeValue.equals === "function" && typeof maybeValue.hashCode === "function");
}
/**
 * An extension of the "same-value" algorithm as [described for use by ES6 Map
 * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
 *
 * NaN is considered the same as NaN, however -0 and 0 are considered the same
 * value, which is different from the algorithm described by
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
 *
 * This is extended further to allow Objects to describe the values they
 * represent, by way of `valueOf` or `equals` (and `hashCode`).
 *
 * Note: because of this extension, the key equality of Immutable.Map and the
 * value equality of Immutable.Set will differ from ES6 Map and Set.
 *
 * ### Defining custom values
 *
 * The easiest way to describe the value an object represents is by implementing
 * `valueOf`. For example, `Date` represents a value by returning a unix
 * timestamp for `valueOf`:
 *
 *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
 *     var date2 = new Date(1234567890000);
 *     date1.valueOf(); // 1234567890000
 *     assert( date1 !== date2 );
 *     assert( Immutable.is( date1, date2 ) );
 *
 * Note: overriding `valueOf` may have other implications if you use this object
 * where JavaScript expects a primitive, such as implicit string coercion.
 *
 * For more complex types, especially collections, implementing `valueOf` may
 * not be performant. An alternative is to implement `equals` and `hashCode`.
 *
 * `equals` takes another object, presumably of similar type, and returns true
 * if it is equal. Equality is symmetrical, so the same result should be
 * returned if this and the argument are flipped.
 *
 *     assert( a.equals(b) === b.equals(a) );
 *
 * `hashCode` returns a 32bit integer number representing the object which will
 * be used to determine how to store the value object in a Map or Set. You must
 * provide both or neither methods, one must not exist without the other.
 *
 * Also, an important relationship between these methods must be upheld: if two
 * values are equal, they *must* return the same hashCode. If the values are not
 * equal, they might have the same hashCode; this is called a hash collision,
 * and while undesirable for performance reasons, it is acceptable.
 *
 *     if (a.equals(b)) {
 *       assert( a.hashCode() === b.hashCode() );
 *     }
 *
 * All Immutable collections are Value Objects: they implement `equals()`
 * and `hashCode()`.
 */ function is(valueA, valueB) {
    if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
    if (!valueA || !valueB) return false;
    if (typeof valueA.valueOf === "function" && typeof valueB.valueOf === "function") {
        valueA = valueA.valueOf();
        valueB = valueB.valueOf();
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
        if (!valueA || !valueB) return false;
    }
    return !!(isValueObject(valueA) && isValueObject(valueB) && valueA.equals(valueB));
}
var imul = typeof Math.imul === "function" && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
    a |= 0; // int
    b |= 0; // int
    var c = a & 0xffff;
    var d = b & 0xffff;
    // Shift by 0 fixes the sign on the high part.
    return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
};
// v8 has an optimization for storing 31-bit signed numbers.
// Values which have either 00 or 11 as the high order bits qualify.
// This function drops the highest order bit in a signed number, maintaining
// the sign bit.
function smi(i32) {
    return i32 >>> 1 & 0x40000000 | i32 & 0xbfffffff;
}
var defaultValueOf = Object.prototype.valueOf;
function hash(o) {
    if (o == null) return hashNullish(o);
    if (typeof o.hashCode === "function") // Drop any high bits from accidentally long hash codes.
    return smi(o.hashCode(o));
    var v = valueOf(o);
    if (v == null) return hashNullish(v);
    switch(typeof v){
        case "boolean":
            // The hash values for built-in constants are a 1 value for each 5-byte
            // shift region expect for the first, which encodes the value. This
            // reduces the odds of a hash collision for these common values.
            return v ? 0x42108421 : 0x42108420;
        case "number":
            return hashNumber(v);
        case "string":
            return v.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(v) : hashString(v);
        case "object":
        case "function":
            return hashJSObj(v);
        case "symbol":
            return hashSymbol(v);
        default:
            if (typeof v.toString === "function") return hashString(v.toString());
            throw new Error("Value type " + typeof v + " cannot be hashed.");
    }
}
function hashNullish(nullish) {
    return nullish === null ? 0x42108422 : /* undefined */ 0x42108423;
}
// Compress arbitrarily large numbers into smi hashes.
function hashNumber(n) {
    if (n !== n || n === Infinity) return 0;
    var hash = n | 0;
    if (hash !== n) hash ^= n * 0xffffffff;
    while(n > 0xffffffff){
        n /= 0xffffffff;
        hash ^= n;
    }
    return smi(hash);
}
function cachedHashString(string) {
    var hashed = stringHashCache[string];
    if (hashed === undefined) {
        hashed = hashString(string);
        if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
            STRING_HASH_CACHE_SIZE = 0;
            stringHashCache = {};
        }
        STRING_HASH_CACHE_SIZE++;
        stringHashCache[string] = hashed;
    }
    return hashed;
}
// http://jsperf.com/hashing-strings
function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hashed = 0;
    for(var ii = 0; ii < string.length; ii++)hashed = 31 * hashed + string.charCodeAt(ii) | 0;
    return smi(hashed);
}
function hashSymbol(sym) {
    var hashed = symbolMap[sym];
    if (hashed !== undefined) return hashed;
    hashed = nextHash();
    symbolMap[sym] = hashed;
    return hashed;
}
function hashJSObj(obj) {
    var hashed;
    if (usingWeakMap) {
        hashed = weakMap.get(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = obj[UID_HASH_KEY];
    if (hashed !== undefined) return hashed;
    if (!canDefineProperty) {
        hashed = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
        if (hashed !== undefined) return hashed;
        hashed = getIENodeHash(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = nextHash();
    if (usingWeakMap) weakMap.set(obj, hashed);
    else if (isExtensible !== undefined && isExtensible(obj) === false) throw new Error("Non-extensible objects are not allowed as keys.");
    else if (canDefineProperty) Object.defineProperty(obj, UID_HASH_KEY, {
        enumerable: false,
        configurable: false,
        writable: false,
        value: hashed
    });
    else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
        // Since we can't define a non-enumerable property on the object
        // we'll hijack one of the less-used non-enumerable properties to
        // save our hash on it. Since this is a function it will not show up in
        // `JSON.stringify` which is what we want.
        obj.propertyIsEnumerable = function() {
            return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
        };
        obj.propertyIsEnumerable[UID_HASH_KEY] = hashed;
    } else if (obj.nodeType !== undefined) // At this point we couldn't get the IE `uniqueID` to use as a hash
    // and we couldn't use a non-enumerable property to exploit the
    // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
    // itself.
    obj[UID_HASH_KEY] = hashed;
    else throw new Error("Unable to set a non-enumerable property on object.");
    return hashed;
}
// Get references to ES5 object methods.
var isExtensible = Object.isExtensible;
// True if Object.defineProperty works as expected. IE8 fails this test.
var canDefineProperty = function() {
    try {
        Object.defineProperty({}, "@", {});
        return true;
    } catch (e) {
        return false;
    }
}();
// IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
// and avoid memory leaks from the IE cloneNode bug.
function getIENodeHash(node) {
    if (node && node.nodeType > 0) switch(node.nodeType){
        case 1:
            return node.uniqueID;
        case 9:
            return node.documentElement && node.documentElement.uniqueID;
    }
}
function valueOf(obj) {
    return obj.valueOf !== defaultValueOf && typeof obj.valueOf === "function" ? obj.valueOf(obj) : obj;
}
function nextHash() {
    var nextHash = ++_objHashUID;
    if (_objHashUID & 0x40000000) _objHashUID = 0;
    return nextHash;
}
// If possible, use a WeakMap.
var usingWeakMap = typeof WeakMap === "function";
var weakMap;
if (usingWeakMap) weakMap = new WeakMap();
var symbolMap = Object.create(null);
var _objHashUID = 0;
var UID_HASH_KEY = "__immutablehash__";
if (typeof Symbol === "function") UID_HASH_KEY = Symbol(UID_HASH_KEY);
var STRING_HASH_CACHE_MIN_STRLEN = 16;
var STRING_HASH_CACHE_MAX_SIZE = 255;
var STRING_HASH_CACHE_SIZE = 0;
var stringHashCache = {};
var ToKeyedSequence = /*@__PURE__*/ function(KeyedSeq) {
    function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
    }
    if (KeyedSeq) ToKeyedSequence.__proto__ = KeyedSeq;
    ToKeyedSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ToKeyedSequence.prototype.constructor = ToKeyedSequence;
    ToKeyedSequence.prototype.get = function get(key, notSetValue) {
        return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function has(key) {
        return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function valueSeq() {
        return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function reverse() {
        var this$1$1 = this;
        var reversedSequence = reverseFactory(this, true);
        if (!this._useKeys) reversedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().reverse();
        };
        return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        var mappedSequence = mapFactory(this, mapper, context);
        if (!this._useKeys) mappedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().map(mapper, context);
        };
        return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
    };
    ToKeyedSequence.prototype.__iterator = function __iterator(type, reverse) {
        return this._iter.__iterator(type, reverse);
    };
    return ToKeyedSequence;
}(KeyedSeq);
ToKeyedSequence.prototype[IS_ORDERED_SYMBOL] = true;
var ToIndexedSequence = /*@__PURE__*/ function(IndexedSeq) {
    function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (IndexedSeq) ToIndexedSequence.__proto__ = IndexedSeq;
    ToIndexedSequence.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ToIndexedSequence.prototype.constructor = ToIndexedSequence;
    ToIndexedSequence.prototype.includes = function includes(value) {
        return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        reverse && ensureSize(this);
        return this._iter.__iterate(function(v) {
            return fn(v, reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var i = 0;
        reverse && ensureSize(this);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, reverse ? this$1$1.size - ++i : i++, step.value, step);
        });
    };
    return ToIndexedSequence;
}(IndexedSeq);
var ToSetSequence = /*@__PURE__*/ function(SetSeq) {
    function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (SetSeq) ToSetSequence.__proto__ = SetSeq;
    ToSetSequence.prototype = Object.create(SetSeq && SetSeq.prototype);
    ToSetSequence.prototype.constructor = ToSetSequence;
    ToSetSequence.prototype.has = function has(key) {
        return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v) {
            return fn(v, v, this$1$1);
        }, reverse);
    };
    ToSetSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, step.value, step.value, step);
        });
    };
    return ToSetSequence;
}(SetSeq);
var FromEntriesSequence = /*@__PURE__*/ function(KeyedSeq) {
    function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
    }
    if (KeyedSeq) FromEntriesSequence.__proto__ = KeyedSeq;
    FromEntriesSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    FromEntriesSequence.prototype.constructor = FromEntriesSequence;
    FromEntriesSequence.prototype.entrySeq = function entrySeq() {
        return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
                validateEntry(entry);
                var indexedCollection = isCollection(entry);
                return fn(indexedCollection ? entry.get(1) : entry[1], indexedCollection ? entry.get(0) : entry[0], this$1$1);
            }
        }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    validateEntry(entry);
                    var indexedCollection = isCollection(entry);
                    return iteratorValue(type, indexedCollection ? entry.get(0) : entry[0], indexedCollection ? entry.get(1) : entry[1], step);
                }
            }
        });
    };
    return FromEntriesSequence;
}(KeyedSeq);
ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
function flipFactory(collection) {
    var flipSequence = makeSequence(collection);
    flipSequence._iter = collection;
    flipSequence.size = collection.size;
    flipSequence.flip = function() {
        return collection;
    };
    flipSequence.reverse = function() {
        var reversedSequence = collection.reverse.apply(this); // super.reverse()
        reversedSequence.flip = function() {
            return collection.reverse();
        };
        return reversedSequence;
    };
    flipSequence.has = function(key) {
        return collection.includes(key);
    };
    flipSequence.includes = function(key) {
        return collection.has(key);
    };
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k) {
            return fn(k, v, this$1$1) !== false;
        }, reverse);
    };
    flipSequence.__iteratorUncached = function(type, reverse) {
        if (type === ITERATE_ENTRIES) {
            var iterator = collection.__iterator(type, reverse);
            return new Iterator(function() {
                var step = iterator.next();
                if (!step.done) {
                    var k = step.value[0];
                    step.value[0] = step.value[1];
                    step.value[1] = k;
                }
                return step;
            });
        }
        return collection.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
    };
    return flipSequence;
}
function mapFactory(collection, mapper, context) {
    var mappedSequence = makeSequence(collection);
    mappedSequence.size = collection.size;
    mappedSequence.has = function(key) {
        return collection.has(key);
    };
    mappedSequence.get = function(key, notSetValue) {
        var v = collection.get(key, NOT_SET);
        return v === NOT_SET ? notSetValue : mapper.call(context, v, key, collection);
    };
    mappedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k, c) {
            return fn(mapper.call(context, v, k, c), k, this$1$1) !== false;
        }, reverse);
    };
    mappedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var key = entry[0];
            return iteratorValue(type, key, mapper.call(context, entry[1], key, collection), step);
        });
    };
    return mappedSequence;
}
function reverseFactory(collection, useKeys) {
    var this$1$1 = this;
    var reversedSequence = makeSequence(collection);
    reversedSequence._iter = collection;
    reversedSequence.size = collection.size;
    reversedSequence.reverse = function() {
        return collection;
    };
    if (collection.flip) reversedSequence.flip = function() {
        var flipSequence = flipFactory(collection);
        flipSequence.reverse = function() {
            return collection.flip();
        };
        return flipSequence;
    };
    reversedSequence.get = function(key, notSetValue) {
        return collection.get(useKeys ? key : -1 - key, notSetValue);
    };
    reversedSequence.has = function(key) {
        return collection.has(useKeys ? key : -1 - key);
    };
    reversedSequence.includes = function(value) {
        return collection.includes(value);
    };
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        reverse && ensureSize(collection);
        return collection.__iterate(function(v, k) {
            return fn(v, useKeys ? k : reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, !reverse);
    };
    reversedSequence.__iterator = function(type, reverse) {
        var i = 0;
        reverse && ensureSize(collection);
        var iterator = collection.__iterator(ITERATE_ENTRIES, !reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            return iteratorValue(type, useKeys ? entry[0] : reverse ? this$1$1.size - ++i : i++, entry[1], step);
        });
    };
    return reversedSequence;
}
function filterFactory(collection, predicate, context, useKeys) {
    var filterSequence = makeSequence(collection);
    if (useKeys) {
        filterSequence.has = function(key) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && !!predicate.call(context, v, key, collection);
        };
        filterSequence.get = function(key, notSetValue) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && predicate.call(context, v, key, collection) ? v : notSetValue;
        };
    }
    filterSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        }, reverse);
        return iterations;
    };
    filterSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterations = 0;
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var key = entry[0];
                var value = entry[1];
                if (predicate.call(context, value, key, collection)) return iteratorValue(type, useKeys ? key : iterations++, value, step);
            }
        });
    };
    return filterSequence;
}
function countByFactory(collection, grouper, context) {
    var groups = Map().asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), 0, function(a) {
            return a + 1;
        });
    });
    return groups.asImmutable();
}
function groupByFactory(collection, grouper, context) {
    var isKeyedIter = isKeyed(collection);
    var groups = (isOrdered(collection) ? OrderedMap() : Map()).asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), function(a) {
            return a = a || [], a.push(isKeyedIter ? [
                k,
                v
            ] : v), a;
        });
    });
    var coerce = collectionClass(collection);
    return groups.map(function(arr) {
        return reify(collection, coerce(arr));
    }).asImmutable();
}
function partitionFactory(collection, predicate, context) {
    var isKeyedIter = isKeyed(collection);
    var groups = [
        [],
        []
    ];
    collection.__iterate(function(v, k) {
        groups[predicate.call(context, v, k, collection) ? 1 : 0].push(isKeyedIter ? [
            k,
            v
        ] : v);
    });
    var coerce = collectionClass(collection);
    return groups.map(function(arr) {
        return reify(collection, coerce(arr));
    });
}
function sliceFactory(collection, begin, end, useKeys) {
    var originalSize = collection.size;
    if (wholeSlice(begin, end, originalSize)) return collection;
    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);
    // begin or end will be NaN if they were provided as negative numbers and
    // this collection's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) return sliceFactory(collection.toSeq().cacheResult(), begin, end, useKeys);
    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    var sliceSeq = makeSequence(collection);
    // If collection.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : collection.size && sliceSize || undefined;
    if (!useKeys && isSeq(collection) && sliceSize >= 0) sliceSeq.get = function(index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ? collection.get(index + resolvedBegin, notSetValue) : notSetValue;
    };
    sliceSeq.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (sliceSize === 0) return 0;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var skipped = 0;
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k) {
            if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1) !== false && iterations !== sliceSize;
            }
        });
        return iterations;
    };
    sliceSeq.__iteratorUncached = function(type, reverse) {
        if (sliceSize !== 0 && reverse) return this.cacheResult().__iterator(type, reverse);
        // Don't bother instantiating parent iterator if taking 0.
        if (sliceSize === 0) return new Iterator(iteratorDone);
        var iterator = collection.__iterator(type, reverse);
        var skipped = 0;
        var iterations = 0;
        return new Iterator(function() {
            while(skipped++ < resolvedBegin)iterator.next();
            if (++iterations > sliceSize) return iteratorDone();
            var step = iterator.next();
            if (useKeys || type === ITERATE_VALUES || step.done) return step;
            if (type === ITERATE_KEYS) return iteratorValue(type, iterations - 1, undefined, step);
            return iteratorValue(type, iterations - 1, step.value[1], step);
        });
    };
    return sliceSeq;
}
function takeWhileFactory(collection, predicate, context) {
    var takeSequence = makeSequence(collection);
    takeSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$1$1);
        });
        return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterating = true;
        return new Iterator(function() {
            if (!iterating) return iteratorDone();
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var k = entry[0];
            var v = entry[1];
            if (!predicate.call(context, v, k, this$1$1)) {
                iterating = false;
                return iteratorDone();
            }
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return takeSequence;
}
function skipWhileFactory(collection, predicate, context, useKeys) {
    var skipSequence = makeSequence(collection);
    skipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        });
        return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var skipping = true;
        var iterations = 0;
        return new Iterator(function() {
            var step;
            var k;
            var v;
            do {
                step = iterator.next();
                if (step.done) {
                    if (useKeys || type === ITERATE_VALUES) return step;
                    if (type === ITERATE_KEYS) return iteratorValue(type, iterations++, undefined, step);
                    return iteratorValue(type, iterations++, step.value[1], step);
                }
                var entry = step.value;
                k = entry[0];
                v = entry[1];
                skipping && (skipping = predicate.call(context, v, k, this$1$1));
            }while (skipping);
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return skipSequence;
}
function concatFactory(collection, values) {
    var isKeyedCollection = isKeyed(collection);
    var iters = [
        collection
    ].concat(values).map(function(v) {
        if (!isCollection(v)) v = isKeyedCollection ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [
            v
        ]);
        else if (isKeyedCollection) v = KeyedCollection(v);
        return v;
    }).filter(function(v) {
        return v.size !== 0;
    });
    if (iters.length === 0) return collection;
    if (iters.length === 1) {
        var singleton = iters[0];
        if (singleton === collection || isKeyedCollection && isKeyed(singleton) || isIndexed(collection) && isIndexed(singleton)) return singleton;
    }
    var concatSeq = new ArraySeq(iters);
    if (isKeyedCollection) concatSeq = concatSeq.toKeyedSeq();
    else if (!isIndexed(collection)) concatSeq = concatSeq.toSetSeq();
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(function(sum, seq) {
        if (sum !== undefined) {
            var size = seq.size;
            if (size !== undefined) return sum + size;
        }
    }, 0);
    return concatSeq;
}
function flattenFactory(collection, depth, useKeys) {
    var flatSequence = makeSequence(collection);
    flatSequence.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        var stopped = false;
        function flatDeep(iter, currentDepth) {
            iter.__iterate(function(v, k) {
                if ((!depth || currentDepth < depth) && isCollection(v)) flatDeep(v, currentDepth + 1);
                else {
                    iterations++;
                    if (fn(v, useKeys ? k : iterations - 1, flatSequence) === false) stopped = true;
                }
                return !stopped;
            }, reverse);
        }
        flatDeep(collection, 0);
        return iterations;
    };
    flatSequence.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(type, reverse);
        var stack = [];
        var iterations = 0;
        return new Iterator(function() {
            while(iterator){
                var step = iterator.next();
                if (step.done !== false) {
                    iterator = stack.pop();
                    continue;
                }
                var v = step.value;
                if (type === ITERATE_ENTRIES) v = v[1];
                if ((!depth || stack.length < depth) && isCollection(v)) {
                    stack.push(iterator);
                    iterator = v.__iterator(type, reverse);
                } else return useKeys ? step : iteratorValue(type, iterations++, v, step);
            }
            return iteratorDone();
        });
    };
    return flatSequence;
}
function flatMapFactory(collection, mapper, context) {
    var coerce = collectionClass(collection);
    return collection.toSeq().map(function(v, k) {
        return coerce(mapper.call(context, v, k, collection));
    }).flatten(true);
}
function interposeFactory(collection, separator) {
    var interposedSequence = makeSequence(collection);
    interposedSequence.size = collection.size && collection.size * 2 - 1;
    interposedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v) {
            return (!iterations || fn(separator, iterations++, this$1$1) !== false) && fn(v, iterations++, this$1$1) !== false;
        }, reverse);
        return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_VALUES, reverse);
        var iterations = 0;
        var step;
        return new Iterator(function() {
            if (!step || iterations % 2) {
                step = iterator.next();
                if (step.done) return step;
            }
            return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
        });
    };
    return interposedSequence;
}
function sortFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    var isKeyedCollection = isKeyed(collection);
    var index = 0;
    var entries = collection.toSeq().map(function(v, k) {
        return [
            k,
            v,
            index++,
            mapper ? mapper(v, k, collection) : v
        ];
    }).valueSeq().toArray();
    entries.sort(function(a, b) {
        return comparator(a[3], b[3]) || a[2] - b[2];
    }).forEach(isKeyedCollection ? function(v, i) {
        entries[i].length = 2;
    } : function(v, i) {
        entries[i] = v[1];
    });
    return isKeyedCollection ? KeyedSeq(entries) : isIndexed(collection) ? IndexedSeq(entries) : SetSeq(entries);
}
function maxFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    if (mapper) {
        var entry = collection.toSeq().map(function(v, k) {
            return [
                v,
                mapper(v, k, collection)
            ];
        }).reduce(function(a, b) {
            return maxCompare(comparator, a[1], b[1]) ? b : a;
        });
        return entry && entry[0];
    }
    return collection.reduce(function(a, b) {
        return maxCompare(comparator, a, b) ? b : a;
    });
}
function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
}
function zipWithFactory(keyIter, zipper, iters, zipAll) {
    var zipSequence = makeSequence(keyIter);
    var sizes = new ArraySeq(iters).map(function(i) {
        return i.size;
    });
    zipSequence.size = zipAll ? sizes.max() : sizes.min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
        /* generic:
    var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      iterations++;
      if (fn(step.value[1], step.value[0], this) === false) {
        break;
      }
    }
    return iterations;
    */ // indexed:
        var iterator = this.__iterator(ITERATE_VALUES, reverse);
        var step;
        var iterations = 0;
        while(!(step = iterator.next()).done){
            if (fn(step.value, iterations++, this) === false) break;
        }
        return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
        var iterators = iters.map(function(i) {
            return i = Collection(i), getIterator(reverse ? i.reverse() : i);
        });
        var iterations = 0;
        var isDone = false;
        return new Iterator(function() {
            var steps;
            if (!isDone) {
                steps = iterators.map(function(i) {
                    return i.next();
                });
                isDone = zipAll ? steps.every(function(s) {
                    return s.done;
                }) : steps.some(function(s) {
                    return s.done;
                });
            }
            if (isDone) return iteratorDone();
            return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                return s.value;
            })));
        });
    };
    return zipSequence;
}
// #pragma Helper Functions
function reify(iter, seq) {
    return iter === seq ? iter : isSeq(iter) ? seq : iter.constructor(seq);
}
function validateEntry(entry) {
    if (entry !== Object(entry)) throw new TypeError("Expected [K, V] tuple: " + entry);
}
function collectionClass(collection) {
    return isKeyed(collection) ? KeyedCollection : isIndexed(collection) ? IndexedCollection : SetCollection;
}
function makeSequence(collection) {
    return Object.create((isKeyed(collection) ? KeyedSeq : isIndexed(collection) ? IndexedSeq : SetSeq).prototype);
}
function cacheResultThrough() {
    if (this._iter.cacheResult) {
        this._iter.cacheResult();
        this.size = this._iter.size;
        return this;
    }
    return Seq.prototype.cacheResult.call(this);
}
function defaultComparator(a, b) {
    if (a === undefined && b === undefined) return 0;
    if (a === undefined) return 1;
    if (b === undefined) return -1;
    return a > b ? 1 : a < b ? -1 : 0;
}
function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for(var ii = 0; ii < len; ii++)newArr[ii] = arr[ii + offset];
    return newArr;
}
function invariant(condition, error) {
    if (!condition) throw new Error(error);
}
function assertNotInfinite(size) {
    invariant(size !== Infinity, "Cannot perform this action with an infinite size.");
}
function coerceKeyPath(keyPath) {
    if (isArrayLike(keyPath) && typeof keyPath !== "string") return keyPath;
    if (isOrdered(keyPath)) return keyPath.toArray();
    throw new TypeError("Invalid keyPath: expected Ordered Collection or Array: " + keyPath);
}
var toString = Object.prototype.toString;
function isPlainObject(value) {
    // The base prototype's toString deals with Argument objects and native namespaces like Math
    if (!value || typeof value !== "object" || toString.call(value) !== "[object Object]") return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    // Iteratively going up the prototype chain is needed for cross-realm environments (differing contexts, iframes, etc)
    var parentProto = proto;
    var nextProto = Object.getPrototypeOf(proto);
    while(nextProto !== null){
        parentProto = nextProto;
        nextProto = Object.getPrototypeOf(parentProto);
    }
    return parentProto === proto;
}
/**
 * Returns true if the value is a potentially-persistent data structure, either
 * provided by Immutable.js or a plain Array or Object.
 */ function isDataStructure(value) {
    return typeof value === "object" && (isImmutable(value) || Array.isArray(value) || isPlainObject(value));
}
function quoteString(value) {
    try {
        return typeof value === "string" ? JSON.stringify(value) : String(value);
    } catch (_ignoreError) {
        return JSON.stringify(value);
    }
}
function has(collection, key) {
    return isImmutable(collection) ? collection.has(key) : isDataStructure(collection) && hasOwnProperty.call(collection, key);
}
function get(collection, key, notSetValue) {
    return isImmutable(collection) ? collection.get(key, notSetValue) : !has(collection, key) ? notSetValue : typeof collection.get === "function" ? collection.get(key) : collection[key];
}
function shallowCopy(from) {
    if (Array.isArray(from)) return arrCopy(from);
    var to = {};
    for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
    return to;
}
function remove(collection, key) {
    if (!isDataStructure(collection)) throw new TypeError("Cannot update non-data-structure value: " + collection);
    if (isImmutable(collection)) {
        if (!collection.remove) throw new TypeError("Cannot update immutable value without .remove() method: " + collection);
        return collection.remove(key);
    }
    if (!hasOwnProperty.call(collection, key)) return collection;
    var collectionCopy = shallowCopy(collection);
    if (Array.isArray(collectionCopy)) collectionCopy.splice(key, 1);
    else delete collectionCopy[key];
    return collectionCopy;
}
function set(collection, key, value) {
    if (!isDataStructure(collection)) throw new TypeError("Cannot update non-data-structure value: " + collection);
    if (isImmutable(collection)) {
        if (!collection.set) throw new TypeError("Cannot update immutable value without .set() method: " + collection);
        return collection.set(key, value);
    }
    if (hasOwnProperty.call(collection, key) && value === collection[key]) return collection;
    var collectionCopy = shallowCopy(collection);
    collectionCopy[key] = value;
    return collectionCopy;
}
function updateIn$1(collection, keyPath, notSetValue, updater) {
    if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
    }
    var updatedValue = updateInDeeply(isImmutable(collection), collection, coerceKeyPath(keyPath), 0, notSetValue, updater);
    return updatedValue === NOT_SET ? notSetValue : updatedValue;
}
function updateInDeeply(inImmutable, existing, keyPath, i, notSetValue, updater) {
    var wasNotSet = existing === NOT_SET;
    if (i === keyPath.length) {
        var existingValue = wasNotSet ? notSetValue : existing;
        var newValue = updater(existingValue);
        return newValue === existingValue ? existing : newValue;
    }
    if (!wasNotSet && !isDataStructure(existing)) throw new TypeError("Cannot update within non-data-structure value in path [" + keyPath.slice(0, i).map(quoteString) + "]: " + existing);
    var key = keyPath[i];
    var nextExisting = wasNotSet ? NOT_SET : get(existing, key, NOT_SET);
    var nextUpdated = updateInDeeply(nextExisting === NOT_SET ? inImmutable : isImmutable(nextExisting), nextExisting, keyPath, i + 1, notSetValue, updater);
    return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? remove(existing, key) : set(wasNotSet ? inImmutable ? emptyMap() : {} : existing, key, nextUpdated);
}
function setIn$1(collection, keyPath, value) {
    return updateIn$1(collection, keyPath, NOT_SET, function() {
        return value;
    });
}
function setIn(keyPath, v) {
    return setIn$1(this, keyPath, v);
}
function removeIn(collection, keyPath) {
    return updateIn$1(collection, keyPath, function() {
        return NOT_SET;
    });
}
function deleteIn(keyPath) {
    return removeIn(this, keyPath);
}
function update$1(collection, key, notSetValue, updater) {
    return updateIn$1(collection, [
        key
    ], notSetValue, updater);
}
function update(key, notSetValue, updater) {
    return arguments.length === 1 ? key(this) : update$1(this, key, notSetValue, updater);
}
function updateIn(keyPath, notSetValue, updater) {
    return updateIn$1(this, keyPath, notSetValue, updater);
}
function merge$1() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeIntoKeyedWith(this, iters);
}
function mergeWith$1(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    if (typeof merger !== "function") throw new TypeError("Invalid merger function: " + merger);
    return mergeIntoKeyedWith(this, iters, merger);
}
function mergeIntoKeyedWith(collection, collections, merger) {
    var iters = [];
    for(var ii = 0; ii < collections.length; ii++){
        var collection$1 = KeyedCollection(collections[ii]);
        if (collection$1.size !== 0) iters.push(collection$1);
    }
    if (iters.length === 0) return collection;
    if (collection.toSeq().size === 0 && !collection.__ownerID && iters.length === 1) return collection.constructor(iters[0]);
    return collection.withMutations(function(collection) {
        var mergeIntoCollection = merger ? function(value, key) {
            update$1(collection, key, NOT_SET, function(oldVal) {
                return oldVal === NOT_SET ? value : merger(oldVal, value, key);
            });
        } : function(value, key) {
            collection.set(key, value);
        };
        for(var ii = 0; ii < iters.length; ii++)iters[ii].forEach(mergeIntoCollection);
    });
}
function merge(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeWithSources(collection, sources);
}
function mergeWith(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeWithSources(collection, sources, merger);
}
function mergeDeep$1(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeDeepWithSources(collection, sources);
}
function mergeDeepWith$1(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeDeepWithSources(collection, sources, merger);
}
function mergeDeepWithSources(collection, sources, merger) {
    return mergeWithSources(collection, sources, deepMergerWith(merger));
}
function mergeWithSources(collection, sources, merger) {
    if (!isDataStructure(collection)) throw new TypeError("Cannot merge into non-data-structure value: " + collection);
    if (isImmutable(collection)) return typeof merger === "function" && collection.mergeWith ? collection.mergeWith.apply(collection, [
        merger
    ].concat(sources)) : collection.merge ? collection.merge.apply(collection, sources) : collection.concat.apply(collection, sources);
    var isArray = Array.isArray(collection);
    var merged = collection;
    var Collection = isArray ? IndexedCollection : KeyedCollection;
    var mergeItem = isArray ? function(value) {
        // Copy on write
        if (merged === collection) merged = shallowCopy(merged);
        merged.push(value);
    } : function(value, key) {
        var hasVal = hasOwnProperty.call(merged, key);
        var nextVal = hasVal && merger ? merger(merged[key], value, key) : value;
        if (!hasVal || nextVal !== merged[key]) {
            // Copy on write
            if (merged === collection) merged = shallowCopy(merged);
            merged[key] = nextVal;
        }
    };
    for(var i = 0; i < sources.length; i++)Collection(sources[i]).forEach(mergeItem);
    return merged;
}
function deepMergerWith(merger) {
    function deepMerger(oldValue, newValue, key) {
        return isDataStructure(oldValue) && isDataStructure(newValue) && areMergeable(oldValue, newValue) ? mergeWithSources(oldValue, [
            newValue
        ], deepMerger) : merger ? merger(oldValue, newValue, key) : newValue;
    }
    return deepMerger;
}
/**
 * It's unclear what the desired behavior is for merging two collections that
 * fall into separate categories between keyed, indexed, or set-like, so we only
 * consider them mergeable if they fall into the same category.
 */ function areMergeable(oldDataStructure, newDataStructure) {
    var oldSeq = Seq(oldDataStructure);
    var newSeq = Seq(newDataStructure);
    // This logic assumes that a sequence can only fall into one of the three
    // categories mentioned above (since there's no `isSetLike()` method).
    return isIndexed(oldSeq) === isIndexed(newSeq) && isKeyed(oldSeq) === isKeyed(newSeq);
}
function mergeDeep() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeDeepWithSources(this, iters);
}
function mergeDeepWith(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return mergeDeepWithSources(this, iters, merger);
}
function mergeIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn$1(this, keyPath, emptyMap(), function(m) {
        return mergeWithSources(m, iters);
    });
}
function mergeDeepIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn$1(this, keyPath, emptyMap(), function(m) {
        return mergeDeepWithSources(m, iters);
    });
}
function withMutations(fn) {
    var mutable = this.asMutable();
    fn(mutable);
    return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
}
function asMutable() {
    return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
}
function asImmutable() {
    return this.__ensureOwner();
}
function wasAltered() {
    return this.__altered;
}
var Map = /*@__PURE__*/ function(KeyedCollection) {
    function Map(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (KeyedCollection) Map.__proto__ = KeyedCollection;
    Map.prototype = Object.create(KeyedCollection && KeyedCollection.prototype);
    Map.prototype.constructor = Map;
    Map.of = function of() {
        var keyValues = [], len = arguments.length;
        while(len--)keyValues[len] = arguments[len];
        return emptyMap().withMutations(function(map) {
            for(var i = 0; i < keyValues.length; i += 2){
                if (i + 1 >= keyValues.length) throw new Error("Missing value for key: " + keyValues[i]);
                map.set(keyValues[i], keyValues[i + 1]);
            }
        });
    };
    Map.prototype.toString = function toString() {
        return this.__toString("Map {", "}");
    };
    // @pragma Access
    Map.prototype.get = function get(k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    };
    // @pragma Modification
    Map.prototype.set = function set(k, v) {
        return updateMap(this, k, v);
    };
    Map.prototype.remove = function remove(k) {
        return updateMap(this, k, NOT_SET);
    };
    Map.prototype.deleteAll = function deleteAll(keys) {
        var collection = Collection(keys);
        if (collection.size === 0) return this;
        return this.withMutations(function(map) {
            collection.forEach(function(key) {
                return map.remove(key);
            });
        });
    };
    Map.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyMap();
    };
    // @pragma Composition
    Map.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator));
    };
    Map.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator, mapper));
    };
    Map.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(map) {
            map.forEach(function(value, key) {
                map.set(key, mapper.call(context, value, key, this$1$1));
            });
        });
    };
    // @pragma Mutability
    Map.prototype.__iterator = function __iterator(type, reverse) {
        return new MapIterator(this, type, reverse);
    };
    Map.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        this._root && this._root.iterate(function(entry) {
            iterations++;
            return fn(entry[1], entry[0], this$1$1);
        }, reverse);
        return iterations;
    };
    Map.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeMap(this.size, this._root, ownerID, this.__hash);
    };
    return Map;
}(KeyedCollection);
Map.isMap = isMap;
var MapPrototype = Map.prototype;
MapPrototype[IS_MAP_SYMBOL] = true;
MapPrototype[DELETE] = MapPrototype.remove;
MapPrototype.removeAll = MapPrototype.deleteAll;
MapPrototype.setIn = setIn;
MapPrototype.removeIn = MapPrototype.deleteIn = deleteIn;
MapPrototype.update = update;
MapPrototype.updateIn = updateIn;
MapPrototype.merge = MapPrototype.concat = merge$1;
MapPrototype.mergeWith = mergeWith$1;
MapPrototype.mergeDeep = mergeDeep;
MapPrototype.mergeDeepWith = mergeDeepWith;
MapPrototype.mergeIn = mergeIn;
MapPrototype.mergeDeepIn = mergeDeepIn;
MapPrototype.withMutations = withMutations;
MapPrototype.wasAltered = wasAltered;
MapPrototype.asImmutable = asImmutable;
MapPrototype["@@transducer/init"] = MapPrototype.asMutable = asMutable;
MapPrototype["@@transducer/step"] = function(result, arr) {
    return result.set(arr[0], arr[1]);
};
MapPrototype["@@transducer/result"] = function(obj) {
    return obj.asImmutable();
};
// #pragma Trie Nodes
var ArrayMapNode = function ArrayMapNode(ownerID, entries) {
    this.ownerID = ownerID;
    this.entries = entries;
};
ArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if (is(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
ArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if (is(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && entries.length === 1) return; // undefined
    if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) return createNodes(ownerID, entries, key, value);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new ArrayMapNode(ownerID, newEntries);
};
var BitmapIndexedNode = function BitmapIndexedNode(ownerID, bitmap, nodes) {
    this.ownerID = ownerID;
    this.bitmap = bitmap;
    this.nodes = nodes;
};
BitmapIndexedNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
    var bitmap = this.bitmap;
    return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
};
BitmapIndexedNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var bit = 1 << keyHashFrag;
    var bitmap = this.bitmap;
    var exists = (bitmap & bit) !== 0;
    if (!exists && value === NOT_SET) return this;
    var idx = popCount(bitmap & bit - 1);
    var nodes = this.nodes;
    var node = exists ? nodes[idx] : undefined;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
    if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) return nodes[idx ^ 1];
    if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) return newNode;
    var isEditable = ownerID && ownerID === this.ownerID;
    var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
    var newNodes = exists ? newNode ? setAt(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
    }
    return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
};
var HashArrayMapNode = function HashArrayMapNode(ownerID, count, nodes) {
    this.ownerID = ownerID;
    this.count = count;
    this.nodes = nodes;
};
HashArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var node = this.nodes[idx];
    return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
};
HashArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var removed = value === NOT_SET;
    var nodes = this.nodes;
    var node = nodes[idx];
    if (removed && !node) return this;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    var newCount = this.count;
    if (!node) newCount++;
    else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) return packNodes(ownerID, nodes, newCount, idx);
    }
    var isEditable = ownerID && ownerID === this.ownerID;
    var newNodes = setAt(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
    }
    return new HashArrayMapNode(ownerID, newCount, newNodes);
};
var HashCollisionNode = function HashCollisionNode(ownerID, keyHash, entries) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entries = entries;
};
HashCollisionNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if (is(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
HashCollisionNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var removed = value === NOT_SET;
    if (keyHash !== this.keyHash) {
        if (removed) return this;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [
            key,
            value
        ]);
    }
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if (is(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && len === 2) return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new HashCollisionNode(ownerID, this.keyHash, newEntries);
};
var ValueNode = function ValueNode(ownerID, keyHash, entry) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entry = entry;
};
ValueNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
};
ValueNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var keyMatch = is(key, this.entry[0]);
    if (keyMatch ? value === this.entry[1] : removed) return this;
    SetRef(didAlter);
    if (removed) {
        SetRef(didChangeSize);
        return; // undefined
    }
    if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
            this.entry[1] = value;
            return this;
        }
        return new ValueNode(ownerID, this.keyHash, [
            key,
            value
        ]);
    }
    SetRef(didChangeSize);
    return mergeIntoNode(this, ownerID, shift, hash(key), [
        key,
        value
    ]);
};
// #pragma Iterators
ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
    var entries = this.entries;
    for(var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++){
        if (fn(entries[reverse ? maxIndex - ii : ii]) === false) return false;
    }
};
BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
    var nodes = this.nodes;
    for(var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++){
        var node = nodes[reverse ? maxIndex - ii : ii];
        if (node && node.iterate(fn, reverse) === false) return false;
    }
};
// eslint-disable-next-line no-unused-vars
ValueNode.prototype.iterate = function(fn, reverse) {
    return fn(this.entry);
};
var MapIterator = /*@__PURE__*/ function(Iterator) {
    function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && mapIteratorFrame(map._root);
    }
    if (Iterator) MapIterator.__proto__ = Iterator;
    MapIterator.prototype = Object.create(Iterator && Iterator.prototype);
    MapIterator.prototype.constructor = MapIterator;
    MapIterator.prototype.next = function next() {
        var type = this._type;
        var stack = this._stack;
        while(stack){
            var node = stack.node;
            var index = stack.index++;
            var maxIndex = void 0;
            if (node.entry) {
                if (index === 0) return mapIteratorValue(type, node.entry);
            } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
            } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                    var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return mapIteratorValue(type, subNode.entry);
                        stack = this._stack = mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
            }
            stack = this._stack = this._stack.__prev;
        }
        return iteratorDone();
    };
    return MapIterator;
}(Iterator);
function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
}
function mapIteratorFrame(node, prev) {
    return {
        node: node,
        index: 0,
        __prev: prev
    };
}
function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var EMPTY_MAP;
function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
}
function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
        if (v === NOT_SET) return map;
        newSize = 1;
        newRoot = new ArrayMapNode(map.__ownerID, [
            [
                k,
                v
            ]
        ]);
    } else {
        var didChangeSize = MakeRef();
        var didAlter = MakeRef();
        newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
        if (!didAlter.value) return map;
        newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
        map.size = newSize;
        map._root = newRoot;
        map.__hash = undefined;
        map.__altered = true;
        return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
}
function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
        if (value === NOT_SET) return node;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return new ValueNode(ownerID, keyHash, [
            key,
            value
        ]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
}
function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
}
function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) return new HashCollisionNode(ownerID, keyHash, [
        node.entry,
        entry
    ]);
    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var newNode;
    var nodes = idx1 === idx2 ? [
        mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)
    ] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [
        node,
        newNode
    ] : [
        newNode,
        node
    ]);
    return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
}
function createNodes(ownerID, entries, key, value) {
    if (!ownerID) ownerID = new OwnerID();
    var node = new ValueNode(ownerID, hash(key), [
        key,
        value
    ]);
    for(var ii = 0; ii < entries.length; ii++){
        var entry = entries[ii];
        node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
}
function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for(var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1){
        var node = nodes[ii];
        if (node !== undefined && ii !== excluding) {
            bitmap |= bit;
            packedNodes[packedII++] = node;
        }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
}
function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for(var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1)expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
}
function popCount(x) {
    x -= x >> 1 & 0x55555555;
    x = (x & 0x33333333) + (x >> 2 & 0x33333333);
    x = x + (x >> 4) & 0x0f0f0f0f;
    x += x >> 8;
    x += x >> 16;
    return x & 0x7f;
}
function setAt(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
}
function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
        array[idx] = val;
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++)if (ii === idx) {
        newArray[ii] = val;
        after = -1;
    } else newArray[ii] = array[ii + after];
    return newArray;
}
function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
        array.pop();
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++){
        if (ii === idx) after = 1;
        newArray[ii] = array[ii + after];
    }
    return newArray;
}
var MAX_ARRAY_MAP_SIZE = SIZE / 4;
var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
var IS_LIST_SYMBOL = "@@__IMMUTABLE_LIST__@@";
function isList(maybeList) {
    return Boolean(maybeList && maybeList[IS_LIST_SYMBOL]);
}
var List = /*@__PURE__*/ function(IndexedCollection) {
    function List(value) {
        var empty = emptyList();
        if (value === undefined || value === null) // eslint-disable-next-line no-constructor-return
        return empty;
        if (isList(value)) // eslint-disable-next-line no-constructor-return
        return value;
        var iter = IndexedCollection(value);
        var size = iter.size;
        if (size === 0) // eslint-disable-next-line no-constructor-return
        return empty;
        assertNotInfinite(size);
        if (size > 0 && size < SIZE) // eslint-disable-next-line no-constructor-return
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
        // eslint-disable-next-line no-constructor-return
        return empty.withMutations(function(list) {
            list.setSize(size);
            iter.forEach(function(v, i) {
                return list.set(i, v);
            });
        });
    }
    if (IndexedCollection) List.__proto__ = IndexedCollection;
    List.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    List.prototype.constructor = List;
    List.of = function of() {
        return this(arguments);
    };
    List.prototype.toString = function toString() {
        return this.__toString("List [", "]");
    };
    // @pragma Access
    List.prototype.get = function get(index, notSetValue) {
        index = wrapIndex(this, index);
        if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = listNodeFor(this, index);
            return node && node.array[index & MASK];
        }
        return notSetValue;
    };
    // @pragma Modification
    List.prototype.set = function set(index, value) {
        return updateList(this, index, value);
    };
    List.prototype.remove = function remove(index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List.prototype.insert = function insert(index, value) {
        return this.splice(index, 0, value);
    };
    List.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = SHIFT;
            this._root = this._tail = this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyList();
    };
    List.prototype.push = function push() {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function(list) {
            setListBounds(list, 0, oldSize + values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(oldSize + ii, values[ii]);
        });
    };
    List.prototype.pop = function pop() {
        return setListBounds(this, 0, -1);
    };
    List.prototype.unshift = function unshift() {
        var values = arguments;
        return this.withMutations(function(list) {
            setListBounds(list, -values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(ii, values[ii]);
        });
    };
    List.prototype.shift = function shift() {
        return setListBounds(this, 1);
    };
    // @pragma Composition
    List.prototype.concat = function concat() {
        var arguments$1 = arguments;
        var seqs = [];
        for(var i = 0; i < arguments.length; i++){
            var argument = arguments$1[i];
            var seq = IndexedCollection(typeof argument !== "string" && hasIterator(argument) ? argument : [
                argument
            ]);
            if (seq.size !== 0) seqs.push(seq);
        }
        if (seqs.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && seqs.length === 1) return this.constructor(seqs[0]);
        return this.withMutations(function(list) {
            seqs.forEach(function(seq) {
                return seq.forEach(function(value) {
                    return list.push(value);
                });
            });
        });
    };
    List.prototype.setSize = function setSize(size) {
        return setListBounds(this, 0, size);
    };
    List.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(list) {
            for(var i = 0; i < this$1$1.size; i++)list.set(i, mapper.call(context, list.get(i), i, this$1$1));
        });
    };
    // @pragma Iteration
    List.prototype.slice = function slice(begin, end) {
        var size = this.size;
        if (wholeSlice(begin, end, size)) return this;
        return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
    };
    List.prototype.__iterator = function __iterator(type, reverse) {
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        return new Iterator(function() {
            var value = values();
            return value === DONE ? iteratorDone() : iteratorValue(type, reverse ? --index : index++, value);
        });
    };
    List.prototype.__iterate = function __iterate(fn, reverse) {
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        var value;
        while((value = values()) !== DONE){
            if (fn(value, reverse ? --index : index++, this) === false) break;
        }
        return index;
    };
    List.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyList();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    return List;
}(IndexedCollection);
List.isList = isList;
var ListPrototype = List.prototype;
ListPrototype[IS_LIST_SYMBOL] = true;
ListPrototype[DELETE] = ListPrototype.remove;
ListPrototype.merge = ListPrototype.concat;
ListPrototype.setIn = setIn;
ListPrototype.deleteIn = ListPrototype.removeIn = deleteIn;
ListPrototype.update = update;
ListPrototype.updateIn = updateIn;
ListPrototype.mergeIn = mergeIn;
ListPrototype.mergeDeepIn = mergeDeepIn;
ListPrototype.withMutations = withMutations;
ListPrototype.wasAltered = wasAltered;
ListPrototype.asImmutable = asImmutable;
ListPrototype["@@transducer/init"] = ListPrototype.asMutable = asMutable;
ListPrototype["@@transducer/step"] = function(result, arr) {
    return result.push(arr);
};
ListPrototype["@@transducer/result"] = function(obj) {
    return obj.asImmutable();
};
var VNode = function VNode(array, ownerID) {
    this.array = array;
    this.ownerID = ownerID;
};
// TODO: seems like these methods are very similar
VNode.prototype.removeBefore = function removeBefore(ownerID, level, index) {
    if (index === level ? 1 << level : this.array.length === 0) return this;
    var originIndex = index >>> level & MASK;
    if (originIndex >= this.array.length) return new VNode([], ownerID);
    var removingFirst = originIndex === 0;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) return this;
    }
    if (removingFirst && !newChild) return this;
    var editable = editableVNode(this, ownerID);
    if (!removingFirst) for(var ii = 0; ii < originIndex; ii++)editable.array[ii] = undefined;
    if (newChild) editable.array[originIndex] = newChild;
    return editable;
};
VNode.prototype.removeAfter = function removeAfter(ownerID, level, index) {
    if (index === (level ? 1 << level : 0) || this.array.length === 0) return this;
    var sizeIndex = index - 1 >>> level & MASK;
    if (sizeIndex >= this.array.length) return this;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) return this;
    }
    var editable = editableVNode(this, ownerID);
    editable.array.splice(sizeIndex + 1);
    if (newChild) editable.array[sizeIndex] = newChild;
    return editable;
};
var DONE = {};
function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;
    return iterateNodeOrLeaf(list._root, list._level, 0);
    function iterateNodeOrLeaf(node, level, offset) {
        return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
    }
    function iterateLeaf(node, offset) {
        var array = offset === tailPos ? tail && tail.array : node && node.array;
        var from = offset > left ? 0 : left - offset;
        var to = right - offset;
        if (to > SIZE) to = SIZE;
        return function() {
            if (from === to) return DONE;
            var idx = reverse ? --to : from++;
            return array && array[idx];
        };
    }
    function iterateNode(node, level, offset) {
        var values;
        var array = node && node.array;
        var from = offset > left ? 0 : left - offset >> level;
        var to = (right - offset >> level) + 1;
        if (to > SIZE) to = SIZE;
        return function() {
            while(true){
                if (values) {
                    var value = values();
                    if (value !== DONE) return value;
                    values = null;
                }
                if (from === to) return DONE;
                var idx = reverse ? --to : from++;
                values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
            }
        };
    }
}
function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
}
var EMPTY_LIST;
function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
}
function updateList(list, index, value) {
    index = wrapIndex(list, index);
    if (index !== index) return list;
    if (index >= list.size || index < 0) return list.withMutations(function(list) {
        index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
    });
    index += list._origin;
    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef();
    if (index >= getTailOffset(list._capacity)) newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    else newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    if (!didAlter.value) return list;
    if (list.__ownerID) {
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
}
function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = index >>> level & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) return node;
    var newNode;
    if (level > 0) {
        var lowerNode = node && node.array[idx];
        var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
        if (newLowerNode === lowerNode) return node;
        newNode = editableVNode(node, ownerID);
        newNode.array[idx] = newLowerNode;
        return newNode;
    }
    if (nodeHas && node.array[idx] === value) return node;
    if (didAlter) SetRef(didAlter);
    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) newNode.array.pop();
    else newNode.array[idx] = value;
    return newNode;
}
function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) return node;
    return new VNode(node ? node.array.slice() : [], ownerID);
}
function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) return list._tail;
    if (rawIndex < 1 << list._level + SHIFT) {
        var node = list._root;
        var level = list._level;
        while(node && level > 0){
            node = node.array[rawIndex >>> level & MASK];
            level -= SHIFT;
        }
        return node;
    }
}
function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) begin |= 0;
    if (end !== undefined) end |= 0;
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) return list.clear();
    var newLevel = list._level;
    var newRoot = list._root;
    // New origin might need creating a higher root.
    var offsetShift = 0;
    while(newOrigin + offsetShift < 0){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            undefined,
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
        offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
        newOrigin += offsetShift;
        oldOrigin += offsetShift;
        newCapacity += offsetShift;
        oldCapacity += offsetShift;
    }
    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);
    // New size might need creating a higher root.
    while(newTailOffset >= 1 << newLevel + SHIFT){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
    }
    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
        newRoot = editableVNode(newRoot, owner);
        var node = newRoot;
        for(var level = newLevel; level > SHIFT; level -= SHIFT){
            var idx = oldTailOffset >>> level & MASK;
            node = node.array[idx] = editableVNode(node.array[idx], owner);
        }
        node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
    }
    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
        newOrigin -= newTailOffset;
        newCapacity -= newTailOffset;
        newLevel = SHIFT;
        newRoot = null;
        newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
        offsetShift = 0;
        // Identify the new top root node of the subtree of the old root.
        while(newRoot){
            var beginIndex = newOrigin >>> newLevel & MASK;
            if (beginIndex !== newTailOffset >>> newLevel & MASK) break;
            if (beginIndex) offsetShift += (1 << newLevel) * beginIndex;
            newLevel -= SHIFT;
            newRoot = newRoot.array[beginIndex];
        }
        // Trim the new sides of the new root.
        if (newRoot && newOrigin > oldOrigin) newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
        if (newRoot && newTailOffset < oldTailOffset) newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
        if (offsetShift) {
            newOrigin -= offsetShift;
            newCapacity -= offsetShift;
        }
    }
    if (list.__ownerID) {
        list.size = newCapacity - newOrigin;
        list._origin = newOrigin;
        list._capacity = newCapacity;
        list._level = newLevel;
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
}
function getTailOffset(size) {
    return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
}
var OrderedMap = /*@__PURE__*/ function(Map) {
    function OrderedMap(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (Map) OrderedMap.__proto__ = Map;
    OrderedMap.prototype = Object.create(Map && Map.prototype);
    OrderedMap.prototype.constructor = OrderedMap;
    OrderedMap.of = function of() {
        return this(arguments);
    };
    OrderedMap.prototype.toString = function toString() {
        return this.__toString("OrderedMap {", "}");
    };
    // @pragma Access
    OrderedMap.prototype.get = function get(k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };
    // @pragma Modification
    OrderedMap.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._map.clear();
            this._list.clear();
            this.__altered = true;
            return this;
        }
        return emptyOrderedMap();
    };
    OrderedMap.prototype.set = function set(k, v) {
        return updateOrderedMap(this, k, v);
    };
    OrderedMap.prototype.remove = function remove(k) {
        return updateOrderedMap(this, k, NOT_SET);
    };
    OrderedMap.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._list.__iterate(function(entry) {
            return entry && fn(entry[1], entry[0], this$1$1);
        }, reverse);
    };
    OrderedMap.prototype.__iterator = function __iterator(type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
    };
    OrderedMap.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return emptyOrderedMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            this._map = newMap;
            this._list = newList;
            return this;
        }
        return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    return OrderedMap;
}(Map);
OrderedMap.isOrderedMap = isOrderedMap;
OrderedMap.prototype[IS_ORDERED_SYMBOL] = true;
OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    omap.__altered = false;
    return omap;
}
var EMPTY_ORDERED_MAP;
function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
}
function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) {
        // removed
        if (!has) return omap;
        if (list.size >= SIZE && list.size >= map.size * 2) {
            newList = list.filter(function(entry, idx) {
                return entry !== undefined && i !== idx;
            });
            newMap = newList.toKeyedSeq().map(function(entry) {
                return entry[0];
            }).flip().toMap();
            if (omap.__ownerID) newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        } else {
            newMap = map.remove(k);
            newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
        }
    } else if (has) {
        if (v === list.get(i)[1]) return omap;
        newMap = map;
        newList = list.set(i, [
            k,
            v
        ]);
    } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [
            k,
            v
        ]);
    }
    if (omap.__ownerID) {
        omap.size = newMap.size;
        omap._map = newMap;
        omap._list = newList;
        omap.__hash = undefined;
        omap.__altered = true;
        return omap;
    }
    return makeOrderedMap(newMap, newList);
}
var IS_STACK_SYMBOL = "@@__IMMUTABLE_STACK__@@";
function isStack(maybeStack) {
    return Boolean(maybeStack && maybeStack[IS_STACK_SYMBOL]);
}
var Stack = /*@__PURE__*/ function(IndexedCollection) {
    function Stack(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyStack() : isStack(value) ? value : emptyStack().pushAll(value);
    }
    if (IndexedCollection) Stack.__proto__ = IndexedCollection;
    Stack.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    Stack.prototype.constructor = Stack;
    Stack.of = function of() {
        return this(arguments);
    };
    Stack.prototype.toString = function toString() {
        return this.__toString("Stack [", "]");
    };
    // @pragma Access
    Stack.prototype.get = function get(index, notSetValue) {
        var head = this._head;
        index = wrapIndex(this, index);
        while(head && index--)head = head.next;
        return head ? head.value : notSetValue;
    };
    Stack.prototype.peek = function peek() {
        return this._head && this._head.value;
    };
    // @pragma Modification
    Stack.prototype.push = function push() {
        var arguments$1 = arguments;
        if (arguments.length === 0) return this;
        var newSize = this.size + arguments.length;
        var head = this._head;
        for(var ii = arguments.length - 1; ii >= 0; ii--)head = {
            value: arguments$1[ii],
            next: head
        };
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pushAll = function pushAll(iter) {
        iter = IndexedCollection(iter);
        if (iter.size === 0) return this;
        if (this.size === 0 && isStack(iter)) return iter;
        assertNotInfinite(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.__iterate(function(value) {
            newSize++;
            head = {
                value: value,
                next: head
            };
        }, /* reverse */ true);
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pop = function pop() {
        return this.slice(1);
    };
    Stack.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyStack();
    };
    Stack.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        var resolvedBegin = resolveBegin(begin, this.size);
        var resolvedEnd = resolveEnd(end, this.size);
        if (resolvedEnd !== this.size) // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while(resolvedBegin--)head = head.next;
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    // @pragma Mutability
    Stack.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyStack();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeStack(this.size, this._head, ownerID, this.__hash);
    };
    // @pragma Iteration
    Stack.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return new ArraySeq(this.toArray()).__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
        var iterations = 0;
        var node = this._head;
        while(node){
            if (fn(node.value, iterations++, this) === false) break;
            node = node.next;
        }
        return iterations;
    };
    Stack.prototype.__iterator = function __iterator(type, reverse) {
        if (reverse) return new ArraySeq(this.toArray()).__iterator(type, reverse);
        var iterations = 0;
        var node = this._head;
        return new Iterator(function() {
            if (node) {
                var value = node.value;
                node = node.next;
                return iteratorValue(type, iterations++, value);
            }
            return iteratorDone();
        });
    };
    return Stack;
}(IndexedCollection);
Stack.isStack = isStack;
var StackPrototype = Stack.prototype;
StackPrototype[IS_STACK_SYMBOL] = true;
StackPrototype.shift = StackPrototype.pop;
StackPrototype.unshift = StackPrototype.push;
StackPrototype.unshiftAll = StackPrototype.pushAll;
StackPrototype.withMutations = withMutations;
StackPrototype.wasAltered = wasAltered;
StackPrototype.asImmutable = asImmutable;
StackPrototype["@@transducer/init"] = StackPrototype.asMutable = asMutable;
StackPrototype["@@transducer/step"] = function(result, arr) {
    return result.unshift(arr);
};
StackPrototype["@@transducer/result"] = function(obj) {
    return obj.asImmutable();
};
function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var EMPTY_STACK;
function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
}
var IS_SET_SYMBOL = "@@__IMMUTABLE_SET__@@";
function isSet(maybeSet) {
    return Boolean(maybeSet && maybeSet[IS_SET_SYMBOL]);
}
function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
}
function deepEqual(a, b) {
    if (a === b) return true;
    if (!isCollection(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) return false;
    if (a.size === 0 && b.size === 0) return true;
    var notAssociative = !isAssociative(a);
    if (isOrdered(a)) {
        var entries = a.entries();
        return b.every(function(v, k) {
            var entry = entries.next().value;
            return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
        }) && entries.next().done;
    }
    var flipped = false;
    if (a.size === undefined) {
        if (b.size === undefined) {
            if (typeof a.cacheResult === "function") a.cacheResult();
        } else {
            flipped = true;
            var _ = a;
            a = b;
            b = _;
        }
    }
    var allEqual = true;
    var bSize = b.__iterate(function(v, k) {
        if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
            allEqual = false;
            return false;
        }
    });
    return allEqual && a.size === bSize;
}
function mixin(ctor, methods) {
    var keyCopier = function(key) {
        ctor.prototype[key] = methods[key];
    };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
}
function toJS(value) {
    if (!value || typeof value !== "object") return value;
    if (!isCollection(value)) {
        if (!isDataStructure(value)) return value;
        value = Seq(value);
    }
    if (isKeyed(value)) {
        var result$1 = {};
        value.__iterate(function(v, k) {
            result$1[k] = toJS(v);
        });
        return result$1;
    }
    var result = [];
    value.__iterate(function(v) {
        result.push(toJS(v));
    });
    return result;
}
var Set = /*@__PURE__*/ function(SetCollection) {
    function Set(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (SetCollection) Set.__proto__ = SetCollection;
    Set.prototype = Object.create(SetCollection && SetCollection.prototype);
    Set.prototype.constructor = Set;
    Set.of = function of() {
        return this(arguments);
    };
    Set.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    Set.intersect = function intersect(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.intersect.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.union = function union(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.union.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.prototype.toString = function toString() {
        return this.__toString("Set {", "}");
    };
    // @pragma Access
    Set.prototype.has = function has(value) {
        return this._map.has(value);
    };
    // @pragma Modification
    Set.prototype.add = function add(value) {
        return updateSet(this, this._map.set(value, value));
    };
    Set.prototype.remove = function remove(value) {
        return updateSet(this, this._map.remove(value));
    };
    Set.prototype.clear = function clear() {
        return updateSet(this, this._map.clear());
    };
    // @pragma Composition
    Set.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        // keep track if the set is altered by the map function
        var didChanges = false;
        var newMap = updateSet(this, this._map.mapEntries(function(ref) {
            var v = ref[1];
            var mapped = mapper.call(context, v, v, this$1$1);
            if (mapped !== v) didChanges = true;
            return [
                mapped,
                mapped
            ];
        }, context));
        return didChanges ? newMap : this;
    };
    Set.prototype.union = function union() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && iters.length === 1) return this.constructor(iters[0]);
        return this.withMutations(function(set) {
            for(var ii = 0; ii < iters.length; ii++)if (typeof iters[ii] === "string") set.add(iters[ii]);
            else SetCollection(iters[ii]).forEach(function(value) {
                return set.add(value);
            });
        });
    };
    Set.prototype.intersect = function intersect() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (!iters.every(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.subtract = function subtract() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (iters.some(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator));
    };
    Set.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator, mapper));
    };
    Set.prototype.wasAltered = function wasAltered() {
        return this._map.wasAltered();
    };
    Set.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._map.__iterate(function(k) {
            return fn(k, k, this$1$1);
        }, reverse);
    };
    Set.prototype.__iterator = function __iterator(type, reverse) {
        return this._map.__iterator(type, reverse);
    };
    Set.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return this.__empty();
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return this.__make(newMap, ownerID);
    };
    return Set;
}(SetCollection);
Set.isSet = isSet;
var SetPrototype = Set.prototype;
SetPrototype[IS_SET_SYMBOL] = true;
SetPrototype[DELETE] = SetPrototype.remove;
SetPrototype.merge = SetPrototype.concat = SetPrototype.union;
SetPrototype.withMutations = withMutations;
SetPrototype.asImmutable = asImmutable;
SetPrototype["@@transducer/init"] = SetPrototype.asMutable = asMutable;
SetPrototype["@@transducer/step"] = function(result, arr) {
    return result.add(arr);
};
SetPrototype["@@transducer/result"] = function(obj) {
    return obj.asImmutable();
};
SetPrototype.__empty = emptySet;
SetPrototype.__make = makeSet;
function updateSet(set, newMap) {
    if (set.__ownerID) {
        set.size = newMap.size;
        set._map = newMap;
        return set;
    }
    return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
}
function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var EMPTY_SET;
function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
}
/**
 * Returns a lazy seq of nums from start (inclusive) to end
 * (exclusive), by step, where start defaults to 0, step to 1, and end to
 * infinity. When start is equal to end, returns empty list.
 */ var Range = /*@__PURE__*/ function(IndexedSeq) {
    function Range(start, end, step) {
        if (!(this instanceof Range)) // eslint-disable-next-line no-constructor-return
        return new Range(start, end, step);
        invariant(step !== 0, "Cannot step a Range by 0");
        start = start || 0;
        if (end === undefined) end = Infinity;
        step = step === undefined ? 1 : Math.abs(step);
        if (end < start) step = -step;
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
            if (EMPTY_RANGE) // eslint-disable-next-line no-constructor-return
            return EMPTY_RANGE;
            EMPTY_RANGE = this;
        }
    }
    if (IndexedSeq) Range.__proto__ = IndexedSeq;
    Range.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Range.prototype.constructor = Range;
    Range.prototype.toString = function toString() {
        if (this.size === 0) return "Range []";
        return "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
    };
    Range.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function includes(searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        begin = resolveBegin(begin, this.size);
        end = resolveEnd(end, this.size);
        if (end <= begin) return new Range(0, 0);
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function indexOf(searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;
            if (index >= 0 && index < this.size) return index;
        }
        return -1;
    };
    Range.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        while(i !== size){
            if (fn(value, reverse ? size - ++i : i++, this) === false) break;
            value += reverse ? -step : step;
        }
        return i;
    };
    Range.prototype.__iterator = function __iterator(type, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var v = value;
            value += reverse ? -step : step;
            return iteratorValue(type, reverse ? size - ++i : i++, v);
        });
    };
    Range.prototype.equals = function equals(other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
    };
    return Range;
}(IndexedSeq);
var EMPTY_RANGE;
function getIn$1(collection, searchKeyPath, notSetValue) {
    var keyPath = coerceKeyPath(searchKeyPath);
    var i = 0;
    while(i !== keyPath.length){
        collection = get(collection, keyPath[i++], NOT_SET);
        if (collection === NOT_SET) return notSetValue;
    }
    return collection;
}
function getIn(searchKeyPath, notSetValue) {
    return getIn$1(this, searchKeyPath, notSetValue);
}
function hasIn$1(collection, keyPath) {
    return getIn$1(collection, keyPath, NOT_SET) !== NOT_SET;
}
function hasIn(searchKeyPath) {
    return hasIn$1(this, searchKeyPath);
}
function toObject() {
    assertNotInfinite(this.size);
    var object = {};
    this.__iterate(function(v, k) {
        object[k] = v;
    });
    return object;
}
// Note: all of these methods are deprecated.
Collection.isIterable = isCollection;
Collection.isKeyed = isKeyed;
Collection.isIndexed = isIndexed;
Collection.isAssociative = isAssociative;
Collection.isOrdered = isOrdered;
Collection.Iterator = Iterator;
mixin(Collection, {
    // ### Conversion to other types
    toArray: function toArray() {
        assertNotInfinite(this.size);
        var array = new Array(this.size || 0);
        var useTuples = isKeyed(this);
        var i = 0;
        this.__iterate(function(v, k) {
            // Keyed collections produce an array of tuples.
            array[i++] = useTuples ? [
                k,
                v
            ] : v;
        });
        return array;
    },
    toIndexedSeq: function toIndexedSeq() {
        return new ToIndexedSequence(this);
    },
    toJS: function toJS$1() {
        return toJS(this);
    },
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, true);
    },
    toMap: function toMap() {
        // Use Late Binding here to solve the circular dependency.
        return Map(this.toKeyedSeq());
    },
    toObject: toObject,
    toOrderedMap: function toOrderedMap() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedMap(this.toKeyedSeq());
    },
    toOrderedSet: function toOrderedSet() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },
    toSet: function toSet() {
        // Use Late Binding here to solve the circular dependency.
        return Set(isKeyed(this) ? this.valueSeq() : this);
    },
    toSetSeq: function toSetSeq() {
        return new ToSetSequence(this);
    },
    toSeq: function toSeq() {
        return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
    },
    toStack: function toStack() {
        // Use Late Binding here to solve the circular dependency.
        return Stack(isKeyed(this) ? this.valueSeq() : this);
    },
    toList: function toList() {
        // Use Late Binding here to solve the circular dependency.
        return List(isKeyed(this) ? this.valueSeq() : this);
    },
    // ### Common JavaScript methods and properties
    toString: function toString() {
        return "[Collection]";
    },
    __toString: function __toString(head, tail) {
        if (this.size === 0) return head + tail;
        return head + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + tail;
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    concat: function concat() {
        var values = [], len = arguments.length;
        while(len--)values[len] = arguments[len];
        return reify(this, concatFactory(this, values));
    },
    includes: function includes(searchValue) {
        return this.some(function(value) {
            return is(value, searchValue);
        });
    },
    entries: function entries() {
        return this.__iterator(ITERATE_ENTRIES);
    },
    every: function every(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = true;
        this.__iterate(function(v, k, c) {
            if (!predicate.call(context, v, k, c)) {
                returnValue = false;
                return false;
            }
        });
        return returnValue;
    },
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, true));
    },
    partition: function partition(predicate, context) {
        return partitionFactory(this, predicate, context);
    },
    find: function find(predicate, context, notSetValue) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[1] : notSetValue;
    },
    forEach: function forEach(sideEffect, context) {
        assertNotInfinite(this.size);
        return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },
    join: function join(separator) {
        assertNotInfinite(this.size);
        separator = separator !== undefined ? "" + separator : ",";
        var joined = "";
        var isFirst = true;
        this.__iterate(function(v) {
            isFirst ? isFirst = false : joined += separator;
            joined += v !== null && v !== undefined ? v.toString() : "";
        });
        return joined;
    },
    keys: function keys() {
        return this.__iterator(ITERATE_KEYS);
    },
    map: function map(mapper, context) {
        return reify(this, mapFactory(this, mapper, context));
    },
    reduce: function reduce$1(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, false);
    },
    reduceRight: function reduceRight(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, true);
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, true));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, true));
    },
    some: function some(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = false;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                returnValue = true;
                return false;
            }
        });
        return returnValue;
    },
    sort: function sort(comparator) {
        return reify(this, sortFactory(this, comparator));
    },
    values: function values() {
        return this.__iterator(ITERATE_VALUES);
    },
    // ### More sequential methods
    butLast: function butLast() {
        return this.slice(0, -1);
    },
    isEmpty: function isEmpty() {
        return this.size !== undefined ? this.size === 0 : !this.some(function() {
            return true;
        });
    },
    count: function count(predicate, context) {
        return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
    },
    countBy: function countBy(grouper, context) {
        return countByFactory(this, grouper, context);
    },
    equals: function equals(other) {
        return deepEqual(this, other);
    },
    entrySeq: function entrySeq() {
        var collection = this;
        if (collection._cache) // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(collection._cache);
        var entriesSequence = collection.toSeq().map(entryMapper).toIndexedSeq();
        entriesSequence.fromEntrySeq = function() {
            return collection.toSeq();
        };
        return entriesSequence;
    },
    filterNot: function filterNot(predicate, context) {
        return this.filter(not(predicate), context);
    },
    findEntry: function findEntry(predicate, context, notSetValue) {
        var found = notSetValue;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                found = [
                    k,
                    v
                ];
                return false;
            }
        });
        return found;
    },
    findKey: function findKey(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry && entry[0];
    },
    findLast: function findLast(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },
    findLastEntry: function findLastEntry(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },
    findLastKey: function findLastKey(predicate, context) {
        return this.toKeyedSeq().reverse().findKey(predicate, context);
    },
    first: function first(notSetValue) {
        return this.find(returnTrue, null, notSetValue);
    },
    flatMap: function flatMap(mapper, context) {
        return reify(this, flatMapFactory(this, mapper, context));
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, true));
    },
    fromEntrySeq: function fromEntrySeq() {
        return new FromEntriesSequence(this);
    },
    get: function get(searchKey, notSetValue) {
        return this.find(function(_, key) {
            return is(key, searchKey);
        }, undefined, notSetValue);
    },
    getIn: getIn,
    groupBy: function groupBy(grouper, context) {
        return groupByFactory(this, grouper, context);
    },
    has: function has(searchKey) {
        return this.get(searchKey, NOT_SET) !== NOT_SET;
    },
    hasIn: hasIn,
    isSubset: function isSubset(iter) {
        iter = typeof iter.includes === "function" ? iter : Collection(iter);
        return this.every(function(value) {
            return iter.includes(value);
        });
    },
    isSuperset: function isSuperset(iter) {
        iter = typeof iter.isSubset === "function" ? iter : Collection(iter);
        return iter.isSubset(this);
    },
    keyOf: function keyOf(searchValue) {
        return this.findKey(function(value) {
            return is(value, searchValue);
        });
    },
    keySeq: function keySeq() {
        return this.toSeq().map(keyMapper).toIndexedSeq();
    },
    last: function last(notSetValue) {
        return this.toSeq().reverse().first(notSetValue);
    },
    lastKeyOf: function lastKeyOf(searchValue) {
        return this.toKeyedSeq().reverse().keyOf(searchValue);
    },
    max: function max(comparator) {
        return maxFactory(this, comparator);
    },
    maxBy: function maxBy(mapper, comparator) {
        return maxFactory(this, comparator, mapper);
    },
    min: function min(comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },
    minBy: function minBy(mapper, comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },
    rest: function rest() {
        return this.slice(1);
    },
    skip: function skip(amount) {
        return amount === 0 ? this : this.slice(Math.max(0, amount));
    },
    skipLast: function skipLast(amount) {
        return amount === 0 ? this : this.slice(0, -Math.max(0, amount));
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, true));
    },
    skipUntil: function skipUntil(predicate, context) {
        return this.skipWhile(not(predicate), context);
    },
    sortBy: function sortBy(mapper, comparator) {
        return reify(this, sortFactory(this, comparator, mapper));
    },
    take: function take(amount) {
        return this.slice(0, Math.max(0, amount));
    },
    takeLast: function takeLast(amount) {
        return this.slice(-Math.max(0, amount));
    },
    takeWhile: function takeWhile(predicate, context) {
        return reify(this, takeWhileFactory(this, predicate, context));
    },
    takeUntil: function takeUntil(predicate, context) {
        return this.takeWhile(not(predicate), context);
    },
    update: function update(fn) {
        return fn(this);
    },
    valueSeq: function valueSeq() {
        return this.toIndexedSeq();
    },
    // ### Hashable Object
    hashCode: function hashCode() {
        return this.__hash || (this.__hash = hashCollection(this));
    }
});
var CollectionPrototype = Collection.prototype;
CollectionPrototype[IS_COLLECTION_SYMBOL] = true;
CollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.values;
CollectionPrototype.toJSON = CollectionPrototype.toArray;
CollectionPrototype.__toStringMapper = quoteString;
CollectionPrototype.inspect = CollectionPrototype.toSource = function() {
    return this.toString();
};
CollectionPrototype.chain = CollectionPrototype.flatMap;
CollectionPrototype.contains = CollectionPrototype.includes;
mixin(KeyedCollection, {
    // ### More sequential methods
    flip: function flip() {
        return reify(this, flipFactory(this));
    },
    mapEntries: function mapEntries(mapper, context) {
        var this$1$1 = this;
        var iterations = 0;
        return reify(this, this.toSeq().map(function(v, k) {
            return mapper.call(context, [
                k,
                v
            ], iterations++, this$1$1);
        }).fromEntrySeq());
    },
    mapKeys: function mapKeys(mapper, context) {
        var this$1$1 = this;
        return reify(this, this.toSeq().flip().map(function(k, v) {
            return mapper.call(context, k, v, this$1$1);
        }).flip());
    }
});
var KeyedCollectionPrototype = KeyedCollection.prototype;
KeyedCollectionPrototype[IS_KEYED_SYMBOL] = true;
KeyedCollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.entries;
KeyedCollectionPrototype.toJSON = toObject;
KeyedCollectionPrototype.__toStringMapper = function(v, k) {
    return quoteString(k) + ": " + quoteString(v);
};
mixin(IndexedCollection, {
    // ### Conversion to other types
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, false);
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, false));
    },
    findIndex: function findIndex(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    indexOf: function indexOf(searchValue) {
        var key = this.keyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    lastIndexOf: function lastIndexOf(searchValue) {
        var key = this.lastKeyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, false));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, false));
    },
    splice: function splice(index, removeNum /*, ...values*/ ) {
        var numArgs = arguments.length;
        removeNum = Math.max(removeNum || 0, 0);
        if (numArgs === 0 || numArgs === 2 && !removeNum) return this;
        // If index is negative, it should resolve relative to the size of the
        // collection. However size may be expensive to compute if not cached, so
        // only call count() if the number is in fact negative.
        index = resolveBegin(index, index < 0 ? this.count() : this.size);
        var spliced = this.slice(0, index);
        return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
    },
    // ### More collection methods
    findLastIndex: function findLastIndex(predicate, context) {
        var entry = this.findLastEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    first: function first(notSetValue) {
        return this.get(0, notSetValue);
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, false));
    },
    get: function get(index, notSetValue) {
        index = wrapIndex(this, index);
        return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function(_, key) {
            return key === index;
        }, undefined, notSetValue);
    },
    has: function has(index) {
        index = wrapIndex(this, index);
        return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
    },
    interpose: function interpose(separator) {
        return reify(this, interposeFactory(this, separator));
    },
    interleave: function interleave() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, collections);
        var interleaved = zipped.flatten(true);
        if (zipped.size) interleaved.size = zipped.size * collections.length;
        return reify(this, interleaved);
    },
    keySeq: function keySeq() {
        return Range(0, this.size);
    },
    last: function last(notSetValue) {
        return this.get(-1, notSetValue);
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, false));
    },
    zip: function zip() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections));
    },
    zipAll: function zipAll() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections, true));
    },
    zipWith: function zipWith(zipper /*, ...collections */ ) {
        var collections = arrCopy(arguments);
        collections[0] = this;
        return reify(this, zipWithFactory(this, zipper, collections));
    }
});
var IndexedCollectionPrototype = IndexedCollection.prototype;
IndexedCollectionPrototype[IS_INDEXED_SYMBOL] = true;
IndexedCollectionPrototype[IS_ORDERED_SYMBOL] = true;
mixin(SetCollection, {
    // ### ES6 Collection methods (ES6 Array and Map)
    get: function get(value, notSetValue) {
        return this.has(value) ? value : notSetValue;
    },
    includes: function includes(value) {
        return this.has(value);
    },
    // ### More sequential methods
    keySeq: function keySeq() {
        return this.valueSeq();
    }
});
var SetCollectionPrototype = SetCollection.prototype;
SetCollectionPrototype.has = CollectionPrototype.includes;
SetCollectionPrototype.contains = SetCollectionPrototype.includes;
SetCollectionPrototype.keys = SetCollectionPrototype.values;
// Mixin subclasses
mixin(KeyedSeq, KeyedCollectionPrototype);
mixin(IndexedSeq, IndexedCollectionPrototype);
mixin(SetSeq, SetCollectionPrototype);
// #pragma Helper functions
function reduce(collection, reducer, reduction, context, useFirst, reverse) {
    assertNotInfinite(collection.size);
    collection.__iterate(function(v, k, c) {
        if (useFirst) {
            useFirst = false;
            reduction = v;
        } else reduction = reducer.call(context, reduction, v, k, c);
    }, reverse);
    return reduction;
}
function keyMapper(v, k) {
    return k;
}
function entryMapper(v, k) {
    return [
        k,
        v
    ];
}
function not(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}
function neg(predicate) {
    return function() {
        return -predicate.apply(this, arguments);
    };
}
function defaultZipper() {
    return arrCopy(arguments);
}
function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function hashCollection(collection) {
    if (collection.size === Infinity) return 0;
    var ordered = isOrdered(collection);
    var keyed = isKeyed(collection);
    var h = ordered ? 1 : 0;
    var size = collection.__iterate(keyed ? ordered ? function(v, k) {
        h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
    } : function(v, k) {
        h = h + hashMerge(hash(v), hash(k)) | 0;
    } : ordered ? function(v) {
        h = 31 * h + hash(v) | 0;
    } : function(v) {
        h = h + hash(v) | 0;
    });
    return murmurHashOfSize(size, h);
}
function murmurHashOfSize(size, h) {
    h = imul(h, 0xcc9e2d51);
    h = imul(h << 15 | h >>> -15, 0x1b873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xe6546b64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85ebca6b);
    h = imul(h ^ h >>> 13, 0xc2b2ae35);
    h = smi(h ^ h >>> 16);
    return h;
}
function hashMerge(a, b) {
    return a ^ b + 0x9e3779b9 + (a << 6) + (a >> 2) | 0; // int
}
var OrderedSet = /*@__PURE__*/ function(Set) {
    function OrderedSet(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (Set) OrderedSet.__proto__ = Set;
    OrderedSet.prototype = Object.create(Set && Set.prototype);
    OrderedSet.prototype.constructor = OrderedSet;
    OrderedSet.of = function of() {
        return this(arguments);
    };
    OrderedSet.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    OrderedSet.prototype.toString = function toString() {
        return this.__toString("OrderedSet {", "}");
    };
    return OrderedSet;
}(Set);
OrderedSet.isOrderedSet = isOrderedSet;
var OrderedSetPrototype = OrderedSet.prototype;
OrderedSetPrototype[IS_ORDERED_SYMBOL] = true;
OrderedSetPrototype.zip = IndexedCollectionPrototype.zip;
OrderedSetPrototype.zipWith = IndexedCollectionPrototype.zipWith;
OrderedSetPrototype.zipAll = IndexedCollectionPrototype.zipAll;
OrderedSetPrototype.__empty = emptyOrderedSet;
OrderedSetPrototype.__make = makeOrderedSet;
function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var EMPTY_ORDERED_SET;
function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
}
var PairSorting = {
    LeftThenRight: -1,
    RightThenLeft: 1
};
function throwOnInvalidDefaultValues(defaultValues) {
    if (isRecord(defaultValues)) throw new Error("Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead.");
    if (isImmutable(defaultValues)) throw new Error("Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead.");
    if (defaultValues === null || typeof defaultValues !== "object") throw new Error("Can not call `Record` with a non-object as default values. Use a plain javascript object instead.");
}
var Record = function Record(defaultValues, name) {
    var hasInitialized;
    throwOnInvalidDefaultValues(defaultValues);
    var RecordType = function Record(values) {
        var this$1$1 = this;
        if (values instanceof RecordType) return values;
        if (!(this instanceof RecordType)) return new RecordType(values);
        if (!hasInitialized) {
            hasInitialized = true;
            var keys = Object.keys(defaultValues);
            var indices = RecordTypePrototype._indices = {};
            // Deprecated: left to attempt not to break any external code which
            // relies on a ._name property existing on record instances.
            // Use Record.getDescriptiveName() instead
            RecordTypePrototype._name = name;
            RecordTypePrototype._keys = keys;
            RecordTypePrototype._defaultValues = defaultValues;
            for(var i = 0; i < keys.length; i++){
                var propName = keys[i];
                indices[propName] = i;
                if (RecordTypePrototype[propName]) /* eslint-disable no-console */ typeof console === "object" && console.warn && console.warn("Cannot define " + recordName(this) + ' with property "' + propName + '" since that property name is part of the Record API.');
                else setProp(RecordTypePrototype, propName);
            }
        }
        this.__ownerID = undefined;
        this._values = List().withMutations(function(l) {
            l.setSize(this$1$1._keys.length);
            KeyedCollection(values).forEach(function(v, k) {
                l.set(this$1$1._indices[k], v === this$1$1._defaultValues[k] ? undefined : v);
            });
        });
        return this;
    };
    var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
    RecordTypePrototype.constructor = RecordType;
    if (name) RecordType.displayName = name;
    // eslint-disable-next-line no-constructor-return
    return RecordType;
};
Record.prototype.toString = function toString() {
    var str = recordName(this) + " { ";
    var keys = this._keys;
    var k;
    for(var i = 0, l = keys.length; i !== l; i++){
        k = keys[i];
        str += (i ? ", " : "") + k + ": " + quoteString(this.get(k));
    }
    return str + " }";
};
Record.prototype.equals = function equals(other) {
    return this === other || isRecord(other) && recordSeq(this).equals(recordSeq(other));
};
Record.prototype.hashCode = function hashCode() {
    return recordSeq(this).hashCode();
};
// @pragma Access
Record.prototype.has = function has(k) {
    return this._indices.hasOwnProperty(k);
};
Record.prototype.get = function get(k, notSetValue) {
    if (!this.has(k)) return notSetValue;
    var index = this._indices[k];
    var value = this._values.get(index);
    return value === undefined ? this._defaultValues[k] : value;
};
// @pragma Modification
Record.prototype.set = function set(k, v) {
    if (this.has(k)) {
        var newValues = this._values.set(this._indices[k], v === this._defaultValues[k] ? undefined : v);
        if (newValues !== this._values && !this.__ownerID) return makeRecord(this, newValues);
    }
    return this;
};
Record.prototype.remove = function remove(k) {
    return this.set(k);
};
Record.prototype.clear = function clear() {
    var newValues = this._values.clear().setSize(this._keys.length);
    return this.__ownerID ? this : makeRecord(this, newValues);
};
Record.prototype.wasAltered = function wasAltered() {
    return this._values.wasAltered();
};
Record.prototype.toSeq = function toSeq() {
    return recordSeq(this);
};
Record.prototype.toJS = function toJS$1() {
    return toJS(this);
};
Record.prototype.entries = function entries() {
    return this.__iterator(ITERATE_ENTRIES);
};
Record.prototype.__iterator = function __iterator(type, reverse) {
    return recordSeq(this).__iterator(type, reverse);
};
Record.prototype.__iterate = function __iterate(fn, reverse) {
    return recordSeq(this).__iterate(fn, reverse);
};
Record.prototype.__ensureOwner = function __ensureOwner(ownerID) {
    if (ownerID === this.__ownerID) return this;
    var newValues = this._values.__ensureOwner(ownerID);
    if (!ownerID) {
        this.__ownerID = ownerID;
        this._values = newValues;
        return this;
    }
    return makeRecord(this, newValues, ownerID);
};
Record.isRecord = isRecord;
Record.getDescriptiveName = recordName;
var RecordPrototype = Record.prototype;
RecordPrototype[IS_RECORD_SYMBOL] = true;
RecordPrototype[DELETE] = RecordPrototype.remove;
RecordPrototype.deleteIn = RecordPrototype.removeIn = deleteIn;
RecordPrototype.getIn = getIn;
RecordPrototype.hasIn = CollectionPrototype.hasIn;
RecordPrototype.merge = merge$1;
RecordPrototype.mergeWith = mergeWith$1;
RecordPrototype.mergeIn = mergeIn;
RecordPrototype.mergeDeep = mergeDeep;
RecordPrototype.mergeDeepWith = mergeDeepWith;
RecordPrototype.mergeDeepIn = mergeDeepIn;
RecordPrototype.setIn = setIn;
RecordPrototype.update = update;
RecordPrototype.updateIn = updateIn;
RecordPrototype.withMutations = withMutations;
RecordPrototype.asMutable = asMutable;
RecordPrototype.asImmutable = asImmutable;
RecordPrototype[ITERATOR_SYMBOL] = RecordPrototype.entries;
RecordPrototype.toJSON = RecordPrototype.toObject = CollectionPrototype.toObject;
RecordPrototype.inspect = RecordPrototype.toSource = function() {
    return this.toString();
};
function makeRecord(likeRecord, values, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._values = values;
    record.__ownerID = ownerID;
    return record;
}
function recordName(record) {
    return record.constructor.displayName || record.constructor.name || "Record";
}
function recordSeq(record) {
    return keyedSeqFromValue(record._keys.map(function(k) {
        return [
            k,
            record.get(k)
        ];
    }));
}
function setProp(prototype, name) {
    try {
        Object.defineProperty(prototype, name, {
            get: function() {
                return this.get(name);
            },
            set: function(value) {
                invariant(this.__ownerID, "Cannot set on an immutable record.");
                this.set(name, value);
            }
        });
    } catch (error) {
    // Object.defineProperty failed. Probably IE8.
    }
}
/**
 * Returns a lazy Seq of `value` repeated `times` times. When `times` is
 * undefined, returns an infinite sequence of `value`.
 */ var Repeat = /*@__PURE__*/ function(IndexedSeq) {
    function Repeat(value, times) {
        if (!(this instanceof Repeat)) // eslint-disable-next-line no-constructor-return
        return new Repeat(value, times);
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
            if (EMPTY_REPEAT) // eslint-disable-next-line no-constructor-return
            return EMPTY_REPEAT;
            EMPTY_REPEAT = this;
        }
    }
    if (IndexedSeq) Repeat.__proto__ = IndexedSeq;
    Repeat.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Repeat.prototype.constructor = Repeat;
    Repeat.prototype.toString = function toString() {
        if (this.size === 0) return "Repeat []";
        return "Repeat [ " + this._value + " " + this.size + " times ]";
    };
    Repeat.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
    };
    Repeat.prototype.includes = function includes(searchValue) {
        return is(this._value, searchValue);
    };
    Repeat.prototype.slice = function slice(begin, end) {
        var size = this.size;
        return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };
    Repeat.prototype.reverse = function reverse() {
        return this;
    };
    Repeat.prototype.indexOf = function indexOf(searchValue) {
        if (is(this._value, searchValue)) return 0;
        return -1;
    };
    Repeat.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        if (is(this._value, searchValue)) return this.size;
        return -1;
    };
    Repeat.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var i = 0;
        while(i !== size){
            if (fn(this._value, reverse ? size - ++i : i++, this) === false) break;
        }
        return i;
    };
    Repeat.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var size = this.size;
        var i = 0;
        return new Iterator(function() {
            return i === size ? iteratorDone() : iteratorValue(type, reverse ? size - ++i : i++, this$1$1._value);
        });
    };
    Repeat.prototype.equals = function equals(other) {
        return other instanceof Repeat ? is(this._value, other._value) : deepEqual(this, other);
    };
    return Repeat;
}(IndexedSeq);
var EMPTY_REPEAT;
function fromJS(value, converter) {
    return fromJSWith([], converter || defaultConverter, value, "", converter && converter.length > 2 ? [] : undefined, {
        "": value
    });
}
function fromJSWith(stack, converter, value, key, keyPath, parentValue) {
    if (typeof value !== "string" && !isImmutable(value) && (isArrayLike(value) || hasIterator(value) || isPlainObject(value))) {
        if (~stack.indexOf(value)) throw new TypeError("Cannot convert circular structure to Immutable");
        stack.push(value);
        keyPath && key !== "" && keyPath.push(key);
        var converted = converter.call(parentValue, key, Seq(value).map(function(v, k) {
            return fromJSWith(stack, converter, v, k, keyPath, value);
        }), keyPath && keyPath.slice());
        stack.pop();
        keyPath && keyPath.pop();
        return converted;
    }
    return value;
}
function defaultConverter(k, v) {
    // Effectively the opposite of "Collection.toSeq()"
    return isIndexed(v) ? v.toList() : isKeyed(v) ? v.toMap() : v.toSet();
}
var version = "4.3.6";
var Immutable = {
    version: version,
    Collection: Collection,
    // Note: Iterable is deprecated
    Iterable: Collection,
    Seq: Seq,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,
    PairSorting: PairSorting,
    Record: Record,
    Range: Range,
    Repeat: Repeat,
    is: is,
    fromJS: fromJS,
    hash: hash,
    isImmutable: isImmutable,
    isCollection: isCollection,
    isKeyed: isKeyed,
    isIndexed: isIndexed,
    isAssociative: isAssociative,
    isOrdered: isOrdered,
    isValueObject: isValueObject,
    isPlainObject: isPlainObject,
    isSeq: isSeq,
    isList: isList,
    isMap: isMap,
    isOrderedMap: isOrderedMap,
    isStack: isStack,
    isSet: isSet,
    isOrderedSet: isOrderedSet,
    isRecord: isRecord,
    get: get,
    getIn: getIn$1,
    has: has,
    hasIn: hasIn$1,
    merge: merge,
    mergeDeep: mergeDeep$1,
    mergeWith: mergeWith,
    mergeDeepWith: mergeDeepWith$1,
    remove: remove,
    removeIn: removeIn,
    set: set,
    setIn: setIn$1,
    update: update$1,
    updateIn: updateIn$1
};
// Note: Iterable is deprecated
var Iterable = Collection;
var $edabc78263019259$export$2e2bcd8739ae039 = Immutable;

});

parcelRegister("l075W", function(module, exports) {

$parcel$export(module.exports, "PatientErrorCodes", () => $475049ebd3d01e0b$export$2384ca1b44f547ed);
$parcel$export(module.exports, "PendingPatientForbiddenAccessError", () => $475049ebd3d01e0b$export$958ef1c6465f107f);
$parcel$export(module.exports, "PatientNotPendingError", () => $475049ebd3d01e0b$export$467c371318c96339);
var $475049ebd3d01e0b$export$2384ca1b44f547ed;
(function(PatientErrorCodes) {
    PatientErrorCodes["PendingPatientForbiddenAccess"] = "PENDING_PATIENT_FORBIDDEN_ACCESS";
})($475049ebd3d01e0b$export$2384ca1b44f547ed || ($475049ebd3d01e0b$export$2384ca1b44f547ed = {}));
class $475049ebd3d01e0b$export$958ef1c6465f107f extends Error {
    constructor(message){
        super(message);
    }
}
class $475049ebd3d01e0b$export$467c371318c96339 extends Error {
}

});


parcelRegister("csqRG", function(module, exports) {

$parcel$export(module.exports, "PatientService", () => $98a953baf65e06c0$export$dcc0086037b77986);

var $04Qjn = parcelRequire("04Qjn");

var $ccjD7 = parcelRequire("ccjD7");

var $6Yxa2 = parcelRequire("6Yxa2");

var $5stJo = parcelRequire("5stJo");

var $kXaMn = parcelRequire("kXaMn");
class $98a953baf65e06c0$export$dcc0086037b77986 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async createPendingPatient(pendingPatientCreateDto) {
        const result = await this.apiService.post("/pending-patients", pendingPatientCreateDto);
        return $98a953baf65e06c0$export$dcc0086037b77986.pendingPatientStatFromDto(result.data);
    }
    async retrievePatient(patientId) {
        const result = await this.apiService.get(`/patients/${patientId}`);
        return $98a953baf65e06c0$export$dcc0086037b77986.patientFromDto(result.data);
    }
    async deletePatient(patientId) {
        await this.apiService.delete(`/patients/${patientId}`);
    }
    async editPatientDetails(patientId, disease, functionalStatus) {
        await this.apiService.post(`/patients/${patientId}`, {
            disease: disease,
            functionalStatus: functionalStatus
        });
    }
    async deletePendingPatient(patientId) {
        await this.apiService.delete(`/pending-patients/${patientId}`);
    }
    async listPendingPatients() {
        const result = await this.apiService.get("/pending-patients");
        return result.data.map((patient)=>$98a953baf65e06c0$export$dcc0086037b77986.pendingPatientStatFromDto(patient));
    }
    async listRegisteredPatient() {
        const result = await this.apiService.get("/patients/registered");
        return result.data.map((patient)=>$98a953baf65e06c0$export$dcc0086037b77986.registeredPatientsFromDto(patient));
    }
    async listRegisteredPatientNames() {
        const result = await this.apiService.get("/patients/registered/names");
        return result.data;
    }
    async listRegisteredPatientGlobalCompliances() {
        const result = await this.apiService.get("/patients/registered/global-compliances");
        return result.data;
    }
    async sendInvitationCodeEmail(patientId, email) {
        await this.apiService.post(`/pending-patients/${patientId}/send-code/email`, {
            email: email
        }, undefined, (error)=>!((0, $04Qjn.isApiError)(error) && error.status === 400));
    }
    static pendingPatientStatFromDto(pendingPatientDto) {
        return {
            ...pendingPatientDto,
            status: (0, $6Yxa2.PatientStatus).Pending,
            creationDate: (0, $kXaMn.dateFromDateDto)(pendingPatientDto.creationDate)
        };
    }
    static registeredPatientsFromDto(registeredPatientsDto) {
        const ongoingProgram = $98a953baf65e06c0$export$dcc0086037b77986.PatientDatedProgramSummaryFromDto(registeredPatientsDto.ongoingProgram);
        const previousProgram = $98a953baf65e06c0$export$dcc0086037b77986.PatientDatedProgramSummaryFromDto(registeredPatientsDto.previousProgram);
        const nextProgram = $98a953baf65e06c0$export$dcc0086037b77986.PatientDatedProgramSummaryFromDto(registeredPatientsDto.nextProgram);
        return {
            ...registeredPatientsDto,
            disease: (0, $ccjD7.diseases).includes(registeredPatientsDto.disease) ? registeredPatientsDto.disease : (0, $ccjD7.Disease).OTHER,
            lastCompletedSessionDate: registeredPatientsDto.lastCompletedSessionDate ? (0, $kXaMn.dateFromDateDto)(registeredPatientsDto.lastCompletedSessionDate) : undefined,
            globalProgramStatus: (0, $5stJo.extractGlobalProgramStatusFromPatient)({
                previousProgram: previousProgram,
                ongoingProgram: ongoingProgram,
                nextProgram: nextProgram
            }),
            compliance: undefined
        };
    }
    static patientFromDto(patientDto) {
        return {
            ...patientDto,
            creationDate: (0, $kXaMn.dateFromDateDto)(patientDto.creationDate),
            birthDate: patientDto.birthDate ? (0, $kXaMn.dateFromDateDto)(patientDto.birthDate) : undefined,
            disease: (0, $ccjD7.diseases).includes(patientDto.disease) ? patientDto.disease : (0, $ccjD7.Disease).OTHER
        };
    }
    static PatientDatedProgramSummaryFromDto(dto) {
        return dto ? {
            id: dto.id,
            startDate: (0, $kXaMn.dateFromDateDto)(dto.startDate),
            endDate: (0, $kXaMn.dateFromDateDto)(dto.endDate)
        } : undefined;
    }
}

});
parcelRegister("ccjD7", function(module, exports) {

$parcel$export(module.exports, "Disease", () => $19a2b9fb432e5132$export$3a5ed23b021afd33);
$parcel$export(module.exports, "diseases", () => $19a2b9fb432e5132$export$9237cf79d3916b11);
$parcel$export(module.exports, "FunctionalStatus", () => $19a2b9fb432e5132$export$a10ecddf9d119b57);
$parcel$export(module.exports, "functionalStatuses", () => $19a2b9fb432e5132$export$bc1c20236bc83ad8);
$parcel$export(module.exports, "isUnspecifiedDisease", () => $19a2b9fb432e5132$export$7931d5f6b88be0c4);

var $lTdpc = parcelRequire("lTdpc");

var $d90o3 = parcelRequire("d90o3");
var $19a2b9fb432e5132$export$3a5ed23b021afd33;
(function(Disease) {
    Disease["IDK"] = "IDK";
    Disease["PREFER_NOT_TO_SAY"] = "PREFER_NOT_TO_SAY";
    Disease["OTHER"] = "OTHER";
    Disease["SMA"] = "SMA";
    Disease["ALS"] = "ALS";
    Disease["BMD"] = "BMD";
    Disease["FSHD"] = "FSHD";
    Disease["LGMD"] = "LGMD";
    Disease["CMT"] = "CMT";
    Disease["OTHER_MUSCULAR_DYSTROPHY"] = "OTHER_MUSCULAR_DYSTROPHY";
    Disease["MYASTHENIA"] = "MYASTHENIA";
    Disease["NEUROPATHY"] = "NEUROPATHY";
    Disease["MYOPATHY"] = "MYOPATHY";
    Disease["METABOLIC_DISORDERS"] = "METABOLIC_DISORDERS";
    Disease["FRIEDREICH_ATAXIA"] = "FRIEDREICH_ATAXIA";
    Disease["MULTIPLE_SCLEROSIS"] = "MULTIPLE_SCLEROSIS";
})($19a2b9fb432e5132$export$3a5ed23b021afd33 || ($19a2b9fb432e5132$export$3a5ed23b021afd33 = {}));
const $19a2b9fb432e5132$export$9237cf79d3916b11 = (0, $d90o3.getEnumValues)($19a2b9fb432e5132$export$3a5ed23b021afd33);
var $19a2b9fb432e5132$export$a10ecddf9d119b57;
(function(FunctionalStatus) {
    FunctionalStatus["Walker"] = "WALKER";
    FunctionalStatus["Sitter"] = "SITTER";
})($19a2b9fb432e5132$export$a10ecddf9d119b57 || ($19a2b9fb432e5132$export$a10ecddf9d119b57 = {}));
const $19a2b9fb432e5132$export$bc1c20236bc83ad8 = (0, $d90o3.getEnumValues)($19a2b9fb432e5132$export$a10ecddf9d119b57);
const $19a2b9fb432e5132$export$7931d5f6b88be0c4 = (disease)=>(0, $lTdpc.isNil)(disease) || [
        "IDK",
        "PREFER_NOT_TO_SAY"
    ].includes(disease);

});

parcelRegister("5stJo", function(module, exports) {

$parcel$export(module.exports, "extractGlobalProgramStatusFromPatient", () => $3d2f88d89e5353dc$export$da962234d714ef9b);
$parcel$export(module.exports, "extractPropsForProgramStatusComponentFromPatientProgram", () => $3d2f88d89e5353dc$export$fb58a79c23d9a09e);
$parcel$export(module.exports, "isGlobalProgramStatusExtendable", () => $3d2f88d89e5353dc$export$50e8ca708542c982);
$parcel$export(module.exports, "hasPatientExtendableProgram", () => $3d2f88d89e5353dc$export$f4c230cc518d99ee);
$parcel$export(module.exports, "sortGlobalProgramStatus", () => $3d2f88d89e5353dc$export$d6a25e07704dc1c1);

var $5SzTW = parcelRequire("5SzTW");

var $lTdpc = parcelRequire("lTdpc");

var $kXaMn = parcelRequire("kXaMn");
const $3d2f88d89e5353dc$export$da962234d714ef9b = ({ previousProgram: previousProgram, ongoingProgram: ongoingProgram, nextProgram: nextProgram })=>{
    if ((0, $lTdpc.isNotNil)(ongoingProgram)) return {
        type: (0, $lTdpc.isNil)(nextProgram) && (0, $kXaMn.computeDiffInDays)((0, $kXaMn.now)(), ongoingProgram.endDate) < (0, $kXaMn.TWO_MONTH_IN_DAYS) ? (0, $5SzTW.GlobalProgramStatusType).EndingSoonProgramWithNoNext : (0, $5SzTW.GlobalProgramStatusType).OngoingProgram,
        startDate: ongoingProgram.startDate,
        endDate: ongoingProgram.endDate,
        programId: ongoingProgram.id
    };
    if ((0, $lTdpc.isNotNil)(nextProgram)) return {
        type: (0, $5SzTW.GlobalProgramStatusType).ScheduledProgram,
        startDate: nextProgram.startDate
    };
    if ((0, $lTdpc.isNotNil)(previousProgram)) return {
        type: (0, $5SzTW.GlobalProgramStatusType).EndedLastProgram,
        endDate: previousProgram.endDate,
        programId: previousProgram.id
    };
    return {
        type: (0, $5SzTW.GlobalProgramStatusType).NoProgram
    };
};
const $3d2f88d89e5353dc$export$fb58a79c23d9a09e = (program, inDetail)=>{
    switch(program.status){
        case (0, $5SzTW.ProgramStatus).Ongoing:
            return {
                type: (0, $5SzTW.GlobalProgramStatusType).OngoingProgram,
                startDate: program.startDate,
                endDate: program.endDate,
                programId: program.id
            };
        case (0, $5SzTW.ProgramStatus).Scheduled:
            return {
                type: (0, $5SzTW.GlobalProgramStatusType).ScheduledProgram,
                startDate: program.startDate
            };
        case (0, $5SzTW.ProgramStatus).Ended:
            return {
                type: inDetail ? (0, $5SzTW.GlobalProgramStatusType).EndedLastProgramDetailsMode : (0, $5SzTW.GlobalProgramStatusType).EndedLastProgram,
                endDate: program.endDate,
                programId: program.id
            };
        default:
            return {
                type: (0, $5SzTW.GlobalProgramStatusType).NoProgram
            };
    }
};
const $3d2f88d89e5353dc$var$ExtendableProgramsStatus = [
    (0, $5SzTW.GlobalProgramStatusType).EndingSoonProgramWithNoNext,
    (0, $5SzTW.GlobalProgramStatusType).EndedLastProgram,
    (0, $5SzTW.GlobalProgramStatusType).EndedLastProgramDetailsMode
];
const $3d2f88d89e5353dc$export$50e8ca708542c982 = (props)=>$3d2f88d89e5353dc$var$ExtendableProgramsStatus.includes(props.type);
const $3d2f88d89e5353dc$export$f4c230cc518d99ee = (patient)=>$3d2f88d89e5353dc$export$50e8ca708542c982(patient.globalProgramStatus);
const $3d2f88d89e5353dc$var$extractUnixDateFromGlobalProgramStatus = (status)=>{
    switch(status.type){
        case (0, $5SzTW.GlobalProgramStatusType).ScheduledProgram:
            return status.startDate.unix();
        case (0, $5SzTW.GlobalProgramStatusType).EndedLastProgram:
            return status.endDate.unix();
        case (0, $5SzTW.GlobalProgramStatusType).OngoingProgram:
            return status.endDate.unix();
        case (0, $5SzTW.GlobalProgramStatusType).EndedLastProgramDetailsMode:
            return status.endDate.unix();
        case (0, $5SzTW.GlobalProgramStatusType).EndingSoonProgramWithNoNext:
            return status.endDate.unix();
        case (0, $5SzTW.GlobalProgramStatusType).NoProgram:
            return 0;
    }
};
const $3d2f88d89e5353dc$var$SortedGlobalStatus = [
    (0, $5SzTW.GlobalProgramStatusType).NoProgram,
    (0, $5SzTW.GlobalProgramStatusType).EndedLastProgram,
    (0, $5SzTW.GlobalProgramStatusType).EndedLastProgramDetailsMode,
    (0, $5SzTW.GlobalProgramStatusType).EndingSoonProgramWithNoNext,
    (0, $5SzTW.GlobalProgramStatusType).OngoingProgram,
    (0, $5SzTW.GlobalProgramStatusType).ScheduledProgram
];
const $3d2f88d89e5353dc$export$d6a25e07704dc1c1 = (a, b, order)=>{
    if (a.type === b.type) return order * ($3d2f88d89e5353dc$var$extractUnixDateFromGlobalProgramStatus(a) - $3d2f88d89e5353dc$var$extractUnixDateFromGlobalProgramStatus(b));
    else return $3d2f88d89e5353dc$var$SortedGlobalStatus.indexOf(a.type) > $3d2f88d89e5353dc$var$SortedGlobalStatus.indexOf(b.type) ? order : -order;
};

});
parcelRegister("5SzTW", function(module, exports) {

$parcel$export(module.exports, "ProgramStatus", () => $07a95e5406189005$export$cc3859b81a162fc2);
$parcel$export(module.exports, "GlobalProgramStatusType", () => $07a95e5406189005$export$1ca9cc9c3283c622);
// ProgramId import removed - now using string type instead
var $07a95e5406189005$export$cc3859b81a162fc2;
(function(ProgramStatus) {
    ProgramStatus["Ongoing"] = "ONGOING";
    ProgramStatus["Scheduled"] = "SCHEDULED";
    ProgramStatus["Draft"] = "DRAFT";
    ProgramStatus["Ended"] = "ENDED";
})($07a95e5406189005$export$cc3859b81a162fc2 || ($07a95e5406189005$export$cc3859b81a162fc2 = {}));
var $07a95e5406189005$export$1ca9cc9c3283c622;
(function(GlobalProgramStatusType) {
    GlobalProgramStatusType["NoProgram"] = "NoProgram";
    GlobalProgramStatusType["ScheduledProgram"] = "ScheduledProgram";
    GlobalProgramStatusType["OngoingProgram"] = "OngoingProgram";
    GlobalProgramStatusType["EndingSoonProgramWithNoNext"] = "EndingSoonProgramWithNoNext";
    GlobalProgramStatusType["EndedLastProgram"] = "EndedLastProgram";
    GlobalProgramStatusType["EndedLastProgramDetailsMode"] = "EndedLastProgramDetailsMode";
})($07a95e5406189005$export$1ca9cc9c3283c622 || ($07a95e5406189005$export$1ca9cc9c3283c622 = {}));

});



parcelRegister("bOjgs", function(module, exports) {

$parcel$export(module.exports, "PatientProgramsManager", () => $93d4e975ed25d8a9$export$a3160b1de9dae50b);

var $5SzTW = parcelRequire("5SzTW");

var $lTdpc = parcelRequire("lTdpc");

var $kXaMn = parcelRequire("kXaMn");

var $kp7gC = parcelRequire("kp7gC");

var $jTpg0 = parcelRequire("jTpg0");

var $1IWnK = parcelRequire("1IWnK");
class $93d4e975ed25d8a9$export$a3160b1de9dae50b {
    constructor(patientProgramsService){
        this.patientProgramsService = patientProgramsService;
        this._allPatientsPrograms = (0, $1IWnK.observable)((0, $kp7gC.Map)());
        this.allPatientsPrograms = this._allPatientsPrograms.select((item)=>Array.from(item.values()));
        this._allProgramsByPatient = (0, $1IWnK.observable)((0, $kp7gC.Map)());
        this.allProgramsByPatient = this._allProgramsByPatient.readOnly();
        this.getStoppedProgram = (patientId, programMetadata, editor)=>{
            const programToStop = this.allProgramsByPatient.get().get(patientId)?.ongoingProgram ?? this._allPatientsPrograms.get().get(programMetadata.id);
            if (programToStop?.status !== (0, $5SzTW.ProgramStatus).Ongoing) return;
            if (programMetadata.status === (0, $5SzTW.ProgramStatus).Ended && (0, $lTdpc.isNotNil)(programMetadata.endDate)) return {
                ...programToStop,
                endDate: programMetadata.endDate,
                stopped: true,
                status: programMetadata.status,
                lastEditionMetadata: {
                    date: (0, $kXaMn.now)(),
                    editor: editor
                }
            };
            else if (programMetadata.status === (0, $5SzTW.ProgramStatus).Draft) return {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).omit(programToStop, "startDate", "endDate"),
                status: (0, $5SzTW.ProgramStatus).Draft,
                lastEditionMetadata: {
                    date: (0, $kXaMn.now)(),
                    editor: editor
                }
            };
        };
        this.updatePatientsProgramsLocaly = (programId, program)=>{
            const allPatientsPrograms = this._allPatientsPrograms.get();
            const programToUpdate = allPatientsPrograms.get(programId);
            if (programToUpdate) this._allPatientsPrograms.set(allPatientsPrograms.set(program.id, {
                ...program,
                patient: programToUpdate.patient
            }));
        };
    }
    async fetchAllPatientsPrograms() {
        const patientsPrograms = await this.patientProgramsService.loadAllPatientsPrograms();
        this._allPatientsPrograms.set((0, $kp7gC.Map)(patientsPrograms.map((item)=>[
                item.id,
                item
            ])));
    }
    async fetchAllPatientPrograms(patientId) {
        const programs = await this.patientProgramsService.loadAllPatientPrograms(patientId);
        this._allProgramsByPatient.update((map)=>map.set(patientId, programs));
    }
    getOverlappingProgram(patientId, startDate, endDate, programId) {
        const newProgramRange = [
            startDate,
            endDate
        ];
        if (endDate.isBefore(startDate)) return null;
        const patientPrograms = this.allProgramsByPatient.get().get(patientId);
        if (patientPrograms) {
            const filteredPrograms = [
                ...patientPrograms.ongoingProgram ? [
                    patientPrograms.ongoingProgram
                ] : [],
                ...patientPrograms.scheduledPrograms,
                ...patientPrograms.endedPrograms
            ].filter((program)=>program.id !== programId);
            for (const program of filteredPrograms){
                const existingProgramRange = [
                    program.startDate,
                    program.endDate
                ];
                if ((0, $kXaMn.dateRangesOverlap)(newProgramRange, existingProgramRange)) return program;
            }
        }
        return null;
    }
    stopProgramLocally(patientId, programMetadata, editor) {
        const stoppedProgram = this.getStoppedProgram(patientId, programMetadata, editor);
        if (!stoppedProgram) return;
        const patientPrograms = this.allProgramsByPatient.get().get(patientId);
        if (patientPrograms?.ongoingProgram?.id === programMetadata.id) {
            if (stoppedProgram.status === (0, $5SzTW.ProgramStatus).Ended) {
                const modifiedPatientPrograms = {
                    scheduledPrograms: patientPrograms.scheduledPrograms,
                    draftPrograms: patientPrograms.draftPrograms,
                    endedPrograms: [
                        stoppedProgram,
                        ...patientPrograms.endedPrograms
                    ]
                };
                this._allProgramsByPatient.update((map)=>map.set(patientId, modifiedPatientPrograms));
            } else {
                const modifiedPatientPrograms = {
                    scheduledPrograms: patientPrograms.scheduledPrograms,
                    draftPrograms: [
                        stoppedProgram,
                        ...patientPrograms.draftPrograms
                    ],
                    endedPrograms: patientPrograms.endedPrograms
                };
                this._allProgramsByPatient.update((map)=>map.set(patientId, modifiedPatientPrograms));
            }
        }
        this.updatePatientsProgramsLocaly(stoppedProgram.id, stoppedProgram);
    }
    startProgramLocally(patientId, startedPatientProgram) {
        const today = (0, $kXaMn.now)();
        const isOngoingProgram = (0, $kXaMn.datesAreOnSameDay)(today, startedPatientProgram.startDate) || startedPatientProgram.startDate.isBefore(today);
        const patientPrograms = this.allProgramsByPatient.get().get(patientId);
        if (patientPrograms) {
            const filteredPrograms = this.getFilteredPrograms(patientPrograms, startedPatientProgram.id);
            const newAllpatientPrograms = isOngoingProgram ? {
                ...filteredPrograms,
                ongoingProgram: {
                    ...startedPatientProgram,
                    status: (0, $5SzTW.ProgramStatus).Ongoing
                }
            } : {
                ...filteredPrograms,
                scheduledPrograms: [
                    {
                        ...startedPatientProgram,
                        status: (0, $5SzTW.ProgramStatus).Scheduled
                    },
                    ...filteredPrograms.scheduledPrograms
                ].sort((p1, p2)=>p1.startDate.diff(p2.startDate))
            };
            this._allProgramsByPatient.update((map)=>map.set(patientId, newAllpatientPrograms));
        }
        this.updatePatientsProgramsLocaly(startedPatientProgram.id, isOngoingProgram ? {
            ...startedPatientProgram,
            status: (0, $5SzTW.ProgramStatus).Ongoing
        } : {
            ...startedPatientProgram,
            status: (0, $5SzTW.ProgramStatus).Scheduled
        });
    }
    deleteProgramLocally(patientId, deletedId) {
        const patientPrograms = this.allProgramsByPatient.get().get(patientId);
        if (patientPrograms) {
            const modifiedPatientPrograms = this.getFilteredPrograms(patientPrograms, deletedId);
            this._allProgramsByPatient.update((map)=>map.set(patientId, modifiedPatientPrograms));
        }
        const allPatientsPrograms = this._allPatientsPrograms.get();
        const programToDelete = allPatientsPrograms.get(deletedId);
        if (programToDelete) this._allPatientsPrograms.set(allPatientsPrograms.delete(deletedId));
    }
    async duplicateProgramAsDraft(patientId, programId) {
        const duplicatedProgram = await this.patientProgramsService.duplicateProgramAsDraft(patientId, programId);
        const patientPrograms = this.allProgramsByPatient.get().get(patientId);
        if (patientPrograms) {
            const modifiedPatientPrograms = {
                ...patientPrograms,
                draftPrograms: [
                    duplicatedProgram,
                    ...patientPrograms.draftPrograms
                ]
            };
            this._allProgramsByPatient.update((map)=>map.set(patientId, modifiedPatientPrograms));
        }
        this.updatePatientsProgramsLocaly(programId, duplicatedProgram);
        return duplicatedProgram.id;
    }
    async reset() {
        this._allProgramsByPatient.set((0, $kp7gC.Map)());
        this._allPatientsPrograms.set((0, $kp7gC.Map)());
    }
    getFilteredPrograms(patientPrograms, programIdToFilter) {
        return {
            ongoingProgram: patientPrograms.ongoingProgram?.id === programIdToFilter ? undefined : patientPrograms.ongoingProgram,
            scheduledPrograms: patientPrograms.scheduledPrograms.filter((program)=>program.id !== programIdToFilter),
            draftPrograms: patientPrograms.draftPrograms.filter((program)=>program.id !== programIdToFilter),
            endedPrograms: patientPrograms.endedPrograms.filter((program)=>program.id !== programIdToFilter)
        };
    }
}

});

parcelRegister("bnG5b", function(module, exports) {

$parcel$export(module.exports, "PatientProgramsService", () => $5c3da5d124fb5890$export$e37fe10b03c6f40d);

var $5SzTW = parcelRequire("5SzTW");

var $kXaMn = parcelRequire("kXaMn");
class $5c3da5d124fb5890$export$e37fe10b03c6f40d {
    constructor(apiService){
        this.apiService = apiService;
    }
    async loadAllPatientsPrograms() {
        const result = await this.apiService.get("/programs");
        return $5c3da5d124fb5890$export$e37fe10b03c6f40d.allExtendedPatientsProgramsFromDto(result.data);
    }
    async loadAllPatientPrograms(patientId) {
        const result = await this.apiService.get(`/patients/${patientId}/programs`);
        return $5c3da5d124fb5890$export$e37fe10b03c6f40d.allPatientProgramsFromDto(result.data);
    }
    async duplicateProgramAsDraft(patientId, programId) {
        const result = await this.apiService.post(`/patients/${patientId}/programs/${programId}/duplicate`);
        return $5c3da5d124fb5890$export$e37fe10b03c6f40d.draftPatientProgramFromDto(result.data);
    }
    // Dto Conversions
    static startedPatientProgramFromDto(programDto) {
        return {
            ...programDto,
            lastEditionMetadata: $5c3da5d124fb5890$export$e37fe10b03c6f40d.lastEditionMetadataFromDto(programDto.lastEditionMetadata),
            startDate: (0, $kXaMn.dateFromDateDto)(programDto.startDate),
            endDate: (0, $kXaMn.dateFromDateDto)(programDto.endDate)
        };
    }
    static ongoingPatientProgramFromDto(ongoingProgramDto) {
        return {
            ...$5c3da5d124fb5890$export$e37fe10b03c6f40d.startedPatientProgramFromDto(ongoingProgramDto),
            status: (0, $5SzTW.ProgramStatus).Ongoing
        };
    }
    static scheduledPatientProgramFromDto(scheduledProgramDto) {
        return {
            ...$5c3da5d124fb5890$export$e37fe10b03c6f40d.startedPatientProgramFromDto(scheduledProgramDto),
            status: (0, $5SzTW.ProgramStatus).Scheduled
        };
    }
    static endedPatientProgramFromDto(endedProgramDto) {
        return {
            ...$5c3da5d124fb5890$export$e37fe10b03c6f40d.startedPatientProgramFromDto(endedProgramDto),
            status: (0, $5SzTW.ProgramStatus).Ended,
            stopped: endedProgramDto.stopped
        };
    }
    static draftPatientProgramFromDto(draftProgramDto) {
        return {
            ...draftProgramDto,
            lastEditionMetadata: $5c3da5d124fb5890$export$e37fe10b03c6f40d.lastEditionMetadataFromDto(draftProgramDto.lastEditionMetadata)
        };
    }
    static lastEditionMetadataFromDto(lastEditionMetadata) {
        return {
            ...lastEditionMetadata,
            date: (0, $kXaMn.dateFromDateDto)(lastEditionMetadata.date)
        };
    }
    static allPatientProgramsFromDto(allPatientProgramsDto) {
        const programsByStatus = allPatientProgramsDto.reduce((acc, program)=>{
            switch(program.status){
                case (0, $5SzTW.ProgramStatus).Ongoing:
                    return {
                        ...acc,
                        ongoingProgram: $5c3da5d124fb5890$export$e37fe10b03c6f40d.ongoingPatientProgramFromDto(program)
                    };
                case (0, $5SzTW.ProgramStatus).Draft:
                    return {
                        ...acc,
                        draftPrograms: [
                            ...acc.draftPrograms,
                            $5c3da5d124fb5890$export$e37fe10b03c6f40d.draftPatientProgramFromDto(program)
                        ]
                    };
                case (0, $5SzTW.ProgramStatus).Scheduled:
                    return {
                        ...acc,
                        scheduledPrograms: [
                            ...acc.scheduledPrograms,
                            $5c3da5d124fb5890$export$e37fe10b03c6f40d.scheduledPatientProgramFromDto(program)
                        ]
                    };
                case (0, $5SzTW.ProgramStatus).Ended:
                    return {
                        ...acc,
                        endedPrograms: [
                            ...acc.endedPrograms,
                            $5c3da5d124fb5890$export$e37fe10b03c6f40d.endedPatientProgramFromDto(program)
                        ]
                    };
            }
        }, {
            scheduledPrograms: [],
            draftPrograms: [],
            endedPrograms: []
        });
        const sortedDraftPrograms = [
            ...programsByStatus.draftPrograms
        ].sort((a, b)=>b.lastEditionMetadata.date.diff(a.lastEditionMetadata.date));
        const sortedScheduledPrograms = [
            ...programsByStatus.scheduledPrograms
        ].sort((a, b)=>a.startDate.diff(b.startDate));
        const sortedEndedPrograms = [
            ...programsByStatus.endedPrograms
        ].sort((a, b)=>b.endDate.diff(a.endDate));
        return {
            ongoingProgram: programsByStatus.ongoingProgram,
            draftPrograms: sortedDraftPrograms,
            scheduledPrograms: sortedScheduledPrograms,
            endedPrograms: sortedEndedPrograms
        };
    }
    static{
        this.getPatientProgramFromDto = (dto)=>{
            switch(dto.status){
                case (0, $5SzTW.ProgramStatus).Ongoing:
                    return $5c3da5d124fb5890$export$e37fe10b03c6f40d.ongoingPatientProgramFromDto(dto);
                case (0, $5SzTW.ProgramStatus).Scheduled:
                    return $5c3da5d124fb5890$export$e37fe10b03c6f40d.scheduledPatientProgramFromDto(dto);
                case (0, $5SzTW.ProgramStatus).Draft:
                    return $5c3da5d124fb5890$export$e37fe10b03c6f40d.draftPatientProgramFromDto(dto);
                case (0, $5SzTW.ProgramStatus).Ended:
                    return $5c3da5d124fb5890$export$e37fe10b03c6f40d.endedPatientProgramFromDto(dto);
            }
        };
    }
    static{
        this.allExtendedPatientsProgramsFromDto = (allExtendedPatientProgramsDto)=>allExtendedPatientProgramsDto.map((dto)=>{
                const patientProgram = $5c3da5d124fb5890$export$e37fe10b03c6f40d.getPatientProgramFromDto(dto);
                return {
                    ...patientProgram,
                    patient: dto.patient
                };
            });
    }
}

});

parcelRegister("auZdZ", function(module, exports) {

$parcel$export(module.exports, "ProgramManager", () => $c3968caf689a2154$export$9e4159a9dc94e98a);

var $04Qjn = parcelRequire("04Qjn");

var $lbkrH = parcelRequire("lbkrH");

var $kp7gC = parcelRequire("kp7gC");

var $1IWnK = parcelRequire("1IWnK");
class $c3968caf689a2154$export$9e4159a9dc94e98a {
    constructor(programService){
        this.programService = programService;
        this._programsByPatient = (0, $1IWnK.observable)((0, $kp7gC.Map)());
        this.programsByPatient = this._programsByPatient.readOnly();
    }
    async fetchPatientProgram(patientId, programId) {
        const newProgram = await this.programService.loadPatientProgram(patientId, programId);
        this.updatePatientProgram(patientId, newProgram);
    }
    async startDraftProgram(patientId, programContent, programId) {
        const programMetadata = programId ? await this.programService.startDraftProgram(patientId, programId, programContent) : await this.programService.startNewDraftProgram(patientId, programContent);
        this.updatePatientProgram(patientId, {
            ...programContent,
            patientId: patientId,
            ...programMetadata
        });
        return programMetadata;
    }
    async createDraftProgram(patientId, draftProgam, reportError) {
        const programMetadata = await this.programService.createDraftProgram(patientId, draftProgam, reportError);
        this.updatePatientProgram(patientId, {
            ...draftProgam,
            patientId: patientId,
            ...programMetadata
        });
        return programMetadata;
    }
    async saveProgram(patientId, programId, programSaveData) {
        const programMetadata = await this.programService.updateProgram(patientId, programId, programSaveData);
        this.updatePatientProgram(patientId, {
            ...programSaveData,
            patientId: patientId,
            ...programMetadata
        });
    }
    async startFutureProgram(patientId, programId, programStartData) {
        const programMetadata = await this.programService.updateProgram(patientId, programId, programStartData);
        this.updatePatientProgram(patientId, {
            patientId: patientId,
            ...programStartData,
            ...programMetadata
        });
        return programMetadata;
    }
    async stopProgram(patientId, programId) {
        const metadata = await this.programService.stopProgram(patientId, programId);
        const stoppedProgram = this._programsByPatient.get().get(patientId)?.get(programId);
        if (stoppedProgram) this.updatePatientProgram(patientId, {
            ...stoppedProgram,
            ...metadata
        });
        return metadata;
    }
    async deleteProgram(patientId, programId) {
        await this.programService.deleteProgram(patientId, programId);
        this._programsByPatient.update((patientMap)=>{
            const patientProgramsMap = patientMap.get(patientId) ?? (0, $kp7gC.Map)();
            return patientMap.set(patientId, patientProgramsMap.remove(programId));
        });
    }
    async updateOngoingProgram(patientId, programId, programUpdateData, forceChanges) {
        try {
            const programMetadata = await this.programService.updateProgram(patientId, programId, programUpdateData, forceChanges);
            if (!programMetadata.startDate || !programMetadata.endDate) throw new Error("An ongoing program should have a startDate and an endDate");
            const typedMetadata = {
                ...programMetadata,
                startDate: programMetadata.startDate,
                endDate: programMetadata.endDate
            };
            this.updatePatientProgram(patientId, {
                patientId: patientId,
                ...programUpdateData,
                ...typedMetadata
            });
            return typedMetadata;
        } catch (e) {
            if ((0, $04Qjn.isApiError)(e) && e.code === (0, $lbkrH.ProgramUpdateErrors).SESSION_DONE_CONTENT_CHANGED) throw new (0, $lbkrH.SessionDoneContentChangedError)();
            if ((0, $04Qjn.isApiError)(e) && e.code === (0, $lbkrH.ProgramUpdateErrors).SESSION_ORDER_CHANGED) throw new (0, $lbkrH.SessionOrderChangedError)();
            throw e;
        }
    }
    async reset() {
        this._programsByPatient.set((0, $kp7gC.Map)());
    }
    updatePatientProgram(patientId, program) {
        this._programsByPatient.update((patientMap)=>{
            const patientProgramsMap = patientMap.get(patientId) ?? (0, $kp7gC.Map)();
            return patientMap.set(patientId, patientProgramsMap.set(program.id, program));
        });
    }
}

});
parcelRegister("lbkrH", function(module, exports) {

$parcel$export(module.exports, "ProgramUpdateErrors", () => $695adb556b4e4f6e$export$5a661055856835d7);
$parcel$export(module.exports, "SessionOrderChangedError", () => $695adb556b4e4f6e$export$5dd80c72ef5a83f4);
$parcel$export(module.exports, "SessionDoneContentChangedError", () => $695adb556b4e4f6e$export$e3902f2616f0751);
var $695adb556b4e4f6e$export$5a661055856835d7;
(function(ProgramUpdateErrors) {
    ProgramUpdateErrors["SESSION_ORDER_CHANGED"] = "SESSION_ORDER_CHANGED";
    ProgramUpdateErrors["SESSION_DONE_CONTENT_CHANGED"] = "SESSION_DONE_CONTENT_CHANGED";
})($695adb556b4e4f6e$export$5a661055856835d7 || ($695adb556b4e4f6e$export$5a661055856835d7 = {}));
class $695adb556b4e4f6e$export$5dd80c72ef5a83f4 extends Error {
    constructor(message){
        super(message);
    }
}
class $695adb556b4e4f6e$export$e3902f2616f0751 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("bGoxH", function(module, exports) {

$parcel$export(module.exports, "ProgramOperationsManager", () => $354f44f7f46dc5ab$export$5cca753cab5811b8);

var $5SzTW = parcelRequire("5SzTW");

var $lTdpc = parcelRequire("lTdpc");

var $kXaMn = parcelRequire("kXaMn");
class $354f44f7f46dc5ab$export$5cca753cab5811b8 {
    constructor(programManager, patientProgramsManager, templateManager){
        this.programManager = programManager;
        this.patientProgramsManager = patientProgramsManager;
        this.templateManager = templateManager;
    }
    async performStopProgramOperation(patientId, programId, editor) {
        const result = await this.programManager.stopProgram(patientId, programId);
        this.patientProgramsManager.stopProgramLocally(patientId, result, editor);
        return result;
    }
    async performDeleteOperation(patientId, programId) {
        await this.programManager.deleteProgram(patientId, programId);
        this.patientProgramsManager.deleteProgramLocally(patientId, programId);
    }
    async performStartOperation(patientId, programContent, status, editor, programId) {
        if ((0, $lTdpc.isNil)(programContent.startDate) || (0, $lTdpc.isNil)(programContent.endDate)) throw new Error("performStartOperation called with undefined programDates");
        const isDraft = status === (0, $5SzTW.ProgramStatus).Draft;
        const programMetadata = !programId ? await this.programManager.startDraftProgram(patientId, programContent) : isDraft ? await this.programManager.startDraftProgram(patientId, programContent, programId) : await this.programManager.startFutureProgram(patientId, programId, programContent);
        const startedPatientProgram = {
            id: programMetadata.id,
            name: programContent.name,
            exercisesPerWeek: programContent.days.exercisesPerWeek,
            sessionsPerWeek: programContent.days.sessionsPerWeek,
            startDate: programContent.startDate,
            lastEditionMetadata: {
                date: (0, $kXaMn.now)(),
                editor: editor
            },
            endDate: programContent.endDate
        };
        this.patientProgramsManager.startProgramLocally(patientId, startedPatientProgram);
        return startedPatientProgram;
    }
    async performUpdateOngoingOperation(patientId, programId, programUpdateData, editor, forceChanges) {
        const programMetadata = await this.programManager.updateOngoingProgram(patientId, programId, programUpdateData, forceChanges);
        const startedPatientProgram = {
            id: programMetadata.id,
            name: programUpdateData.name,
            exercisesPerWeek: programUpdateData.days.exercisesPerWeek,
            sessionsPerWeek: programUpdateData.days.sessionsPerWeek,
            startDate: programMetadata.startDate,
            lastEditionMetadata: {
                date: (0, $kXaMn.now)(),
                editor: editor
            },
            endDate: programMetadata.endDate
        };
        this.patientProgramsManager.startProgramLocally(patientId, startedPatientProgram);
        return startedPatientProgram;
    }
    async performDuplicateAsDraftOperation(patientId, programId) {
        return await this.patientProgramsManager.duplicateProgramAsDraft(patientId, programId);
    }
    async performTransformToTemplateOperation(patientId, programId, templateName) {
        return await this.templateManager.transformProgramToTemplate(patientId, programId, templateName);
    }
}

});

parcelRegister("k6Nr9", function(module, exports) {

$parcel$export(module.exports, "ProgramService", () => $9171b2a4520d9d79$export$84ac2881c878ff18);

var $04Qjn = parcelRequire("04Qjn");

var $97zxo = parcelRequire("97zxo");

var $fIuLY = parcelRequire("fIuLY");

var $lTdpc = parcelRequire("lTdpc");

var $kXaMn = parcelRequire("kXaMn");
class $9171b2a4520d9d79$export$84ac2881c878ff18 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async loadPatientProgram(patientId, programId) {
        const result = await this.apiService.get(`/patients/${patientId}/programs/${programId}`);
        return $9171b2a4520d9d79$export$84ac2881c878ff18.programFromDto(result.data, patientId);
    }
    async startNewDraftProgram(patientId, newProgram) {
        try {
            const newProgramDto = $9171b2a4520d9d79$export$84ac2881c878ff18.dtoFromProgramStartData(newProgram);
            const result = await this.apiService.post(`/patients/${patientId}/programs/start`, newProgramDto, undefined, ()=>false);
            return $9171b2a4520d9d79$export$84ac2881c878ff18.metadataFromDto(result.data);
        } catch (e) {
            if ((0, $04Qjn.isApiError)(e) && e.code === (0, $fIuLY.ProgramErrorCodes).ProgramNameTooLong) throw new (0, $fIuLY.ProgramNameTooLong)();
            throw e;
        }
    }
    async startDraftProgram(patientId, programId, newProgram) {
        const newProgramDto = $9171b2a4520d9d79$export$84ac2881c878ff18.dtoFromProgramStartData(newProgram);
        const result = await this.apiService.post(`/patients/${patientId}/programs/${programId}/start`, newProgramDto, undefined, ()=>false);
        return $9171b2a4520d9d79$export$84ac2881c878ff18.metadataFromDto(result.data);
    }
    async createDraftProgram(patientId, draftProgram, reportError) {
        const newProgramDto = (0, $97zxo.getProgramLightContentDtoFromProgramContent)(draftProgram);
        const result = await this.apiService.post(`/patients/${patientId}/programs`, newProgramDto, undefined, reportError);
        return $9171b2a4520d9d79$export$84ac2881c878ff18.metadataFromDto(result.data);
    }
    async updateProgram(patientId, programId, draftProgram, forceChanges = false) {
        const newProgramDto = $9171b2a4520d9d79$export$84ac2881c878ff18.dtoFromProgramUpdateData(draftProgram);
        const result = await this.apiService.post(`/patients/${patientId}/programs/${programId}`, newProgramDto, {
            params: {
                forceChanges: forceChanges
            }
        }, ()=>false);
        return $9171b2a4520d9d79$export$84ac2881c878ff18.metadataFromDto(result.data);
    }
    async stopProgram(patientId, programId) {
        const result = await this.apiService.post(`/patients/${patientId}/programs/${programId}/stop`);
        return $9171b2a4520d9d79$export$84ac2881c878ff18.metadataFromDto(result.data);
    }
    async deleteProgram(patientId, programId) {
        await this.apiService.delete(`/patients/${patientId}/programs/${programId}`);
    }
    // Dto Conversions
    static dtoFromProgramStartData(programStartData) {
        const { startDate: startDate, endDate: endDate, ...programContent } = programStartData;
        if ((0, $lTdpc.isNil)(startDate) || (0, $lTdpc.isNil)(endDate)) throw new Error("dtoFromProgramStartData called with undefined programDates");
        return {
            ...(0, $97zxo.getProgramLightContentDtoFromProgramContent)(programContent),
            startDate: (0, $kXaMn.dateToDateDto)(startDate),
            endDate: (0, $kXaMn.dateToDateDto)(endDate)
        };
    }
    static dtoFromProgramUpdateData(programUpdateData) {
        const { startDate: startDate, endDate: endDate, ...programContent } = programUpdateData;
        return {
            ...(0, $97zxo.getProgramLightContentDtoFromProgramContent)(programContent),
            startDate: startDate ? (0, $kXaMn.dateToDateDto)(startDate) : undefined,
            endDate: endDate ? (0, $kXaMn.dateToDateDto)(endDate) : undefined
        };
    }
    static programFromDto(programDto, patientId) {
        const { startDate: startDate, endDate: endDate, days: days, name: name, ...otherProps } = programDto;
        return {
            ...otherProps,
            patientId: patientId,
            ...(0, $97zxo.getProgramContentFromDto)({
                days: days,
                name: name
            }),
            startDate: startDate ? (0, $kXaMn.dateFromDateDto)(startDate) : undefined,
            endDate: endDate ? (0, $kXaMn.dateFromDateDto)(endDate) : undefined
        };
    }
    static metadataFromDto(metadataDto) {
        return {
            ...metadataDto,
            startDate: metadataDto.startDate ? (0, $kXaMn.dateFromDateDto)(metadataDto.startDate) : undefined,
            endDate: metadataDto.endDate ? (0, $kXaMn.dateFromDateDto)(metadataDto.endDate) : undefined
        };
    }
}

});
parcelRegister("97zxo", function(module, exports) {

$parcel$export(module.exports, "getProgramLightContentDtoFromProgramContent", () => $9f46b3c776247bc9$export$4052eb731468e3fd);
$parcel$export(module.exports, "getProgramContentFromDto", () => $9f46b3c776247bc9$export$ec452c117fb24e9d);

var $dvhRi = parcelRequire("dvhRi");

var $c9OC9 = parcelRequire("c9OC9");
function $9f46b3c776247bc9$export$4052eb731468e3fd(programContent) {
    return {
        name: programContent.name,
        days: Object.fromEntries(programContent.days.map(([dayIndex, session])=>[
                (0, $c9OC9.DayIndex)[dayIndex],
                {
                    exercises: session.exercises.map((exercise)=>(0, $dvhRi.ExerciseService).dtoFromExercise(exercise))
                }
            ]))
    };
}
function $9f46b3c776247bc9$export$ec452c117fb24e9d(programContentDto) {
    return {
        name: programContentDto.name,
        days: new (0, $c9OC9.ProgramDays)(Object.entries(programContentDto.days).map(([dayIndex, session])=>[
                (0, $c9OC9.DayIndex)[dayIndex],
                {
                    exercises: session.exercises.map((exercise)=>(0, $dvhRi.ExerciseService).exerciseFromDto(exercise))
                }
            ]))
    };
}

});
parcelRegister("c9OC9", function(module, exports) {

$parcel$export(module.exports, "DayIndex", () => $9e2c837390532304$export$90f46e9651d97553);
$parcel$export(module.exports, "dayIndexes", () => $9e2c837390532304$export$11b63ac857a2752f);
$parcel$export(module.exports, "ProgramDays", () => $9e2c837390532304$export$16c94a9005e1f3e4);

var $iXFhQ = parcelRequire("iXFhQ");

var $lTdpc = parcelRequire("lTdpc");

var $d90o3 = parcelRequire("d90o3");
var $9e2c837390532304$export$90f46e9651d97553;
(function(DayIndex) {
    DayIndex[DayIndex["MONDAY"] = 1] = "MONDAY";
    DayIndex[DayIndex["TUESDAY"] = 2] = "TUESDAY";
    DayIndex[DayIndex["WEDNESDAY"] = 3] = "WEDNESDAY";
    DayIndex[DayIndex["THURSDAY"] = 4] = "THURSDAY";
    DayIndex[DayIndex["FRIDAY"] = 5] = "FRIDAY";
    DayIndex[DayIndex["SATURDAY"] = 6] = "SATURDAY";
    DayIndex[DayIndex["SUNDAY"] = 7] = "SUNDAY";
})($9e2c837390532304$export$90f46e9651d97553 || ($9e2c837390532304$export$90f46e9651d97553 = {}));
const $9e2c837390532304$export$11b63ac857a2752f = (0, $d90o3.getEnumValues)($9e2c837390532304$export$90f46e9651d97553);
class $9e2c837390532304$export$16c94a9005e1f3e4 {
    constructor(days = []){
        this.days = new Map($9e2c837390532304$export$11b63ac857a2752f.map((dayIndex)=>[
                dayIndex,
                {
                    exercises: []
                }
            ]));
        days.forEach(([key, value])=>this.days.set(key, value));
    }
    get(dayIndex) {
        const result = this.days.get(dayIndex);
        if ((0, $lTdpc.isNil)(result)) throw new Error("Invalid dayIndex");
        return result;
    }
    set(dayIndex, value) {
        this.days.set(dayIndex, value);
    }
    forEach(callbackfn) {
        [
            ...this.days.entries()
        ].forEach((value, index)=>callbackfn(value, index));
    }
    map(callbackfn) {
        return [
            ...this.days.entries()
        ].map((value, index)=>callbackfn(value, index));
    }
    equals(other) {
        return [
            ...this.days.entries()
        ].every(([dayIndex, session])=>(0, $iXFhQ.sessionContentAreEquals)(session, other.get(dayIndex)));
    }
    copy() {
        return new $9e2c837390532304$export$16c94a9005e1f3e4(this.map(([dayIndex, session])=>[
                dayIndex,
                (0, $iXFhQ.sessionDeepCopy)(session)
            ]));
    }
    get exercisesPerWeek() {
        return [
            ...this.days.values()
        ].reduce((acc, session)=>acc + session.exercises.length, 0);
    }
    get sessionsPerWeek() {
        return [
            ...this.days.values()
        ].reduce((acc, session)=>acc + (session.exercises.length > 0 ? 1 : 0), 0);
    }
    get isEmpty() {
        return [
            ...this.days.values()
        ].every((session)=>session.exercises.length === 0);
    }
    get entries() {
        return [
            ...this.days.entries()
        ];
    }
}

});
parcelRegister("iXFhQ", function(module, exports) {

$parcel$export(module.exports, "sessionContentAreEquals", () => $215fcd11234d9b3e$export$a3dbb0f3999d989b);
$parcel$export(module.exports, "sessionDeepCopy", () => $215fcd11234d9b3e$export$5474be66f8d0b015);

var $hLaGu = parcelRequire("hLaGu");
function $215fcd11234d9b3e$export$a3dbb0f3999d989b(session1, session2) {
    if (session1.exercises.length !== session2.exercises.length) return false;
    return session1.exercises.every((exercise, i)=>{
        const { ex1: ex1, ex2: ex2 } = {
            ex1: exercise,
            ex2: session2.exercises[i]
        };
        return (0, $hLaGu.exerciseContentAreEquals)(ex1, ex2);
    });
}
function $215fcd11234d9b3e$export$5474be66f8d0b015(session) {
    return {
        exercises: Array.from(session.exercises, (exercise)=>({
                ...exercise
            }))
    };
}

});
parcelRegister("hLaGu", function(module, exports) {

$parcel$export(module.exports, "ExerciseCategory", () => $cfacb421ece7ea51$export$9b057765c2d39bd8);
$parcel$export(module.exports, "exerciseCategories", () => $cfacb421ece7ea51$export$c5218b860b48647a);
$parcel$export(module.exports, "ExerciseBodyPart", () => $cfacb421ece7ea51$export$113c6a96a5825a5d);
$parcel$export(module.exports, "exerciseBodyPartsValues", () => $cfacb421ece7ea51$export$2245ee4d10c5aefb);
$parcel$export(module.exports, "ExerciseStartingPosition", () => $cfacb421ece7ea51$export$978dda83a3afa6b6);
$parcel$export(module.exports, "exerciseStartingPositions", () => $cfacb421ece7ea51$export$966eaf3ccabfba9f);
$parcel$export(module.exports, "ExerciseDifficulty", () => $cfacb421ece7ea51$export$b271b2c8ff92c49a);
$parcel$export(module.exports, "exerciseDifficulties", () => $cfacb421ece7ea51$export$c67b424f1654021a);
$parcel$export(module.exports, "ExercisePatientWarning", () => $cfacb421ece7ea51$export$ce970b76f0f676a8);
$parcel$export(module.exports, "isExerciseCategory", () => $cfacb421ece7ea51$export$632e9325701a8064);
$parcel$export(module.exports, "isExerciseBodyPart", () => $cfacb421ece7ea51$export$bbcab35d4a18cbcc);
$parcel$export(module.exports, "isExerciseStartingPosition", () => $cfacb421ece7ea51$export$6e1b4c8622d7b390);
$parcel$export(module.exports, "isExerciseDifficulty", () => $cfacb421ece7ea51$export$24bf8d5f834ff5fc);
$parcel$export(module.exports, "isMainExercise", () => $cfacb421ece7ea51$export$39cfbe6ed90efe8f);
$parcel$export(module.exports, "exerciseBodyParts", () => $cfacb421ece7ea51$export$5ca219b61e6a702c);
$parcel$export(module.exports, "REPETITION_TIME_IN_SEC", () => $cfacb421ece7ea51$export$141bf1128c2039f6);
$parcel$export(module.exports, "exerciseContentAreEquals", () => $cfacb421ece7ea51$export$b137eefcabb24d6f);
$parcel$export(module.exports, "isDurationExercise", () => $cfacb421ece7ea51$export$d7c24f3e1c265d6d);

var $d90o3 = parcelRequire("d90o3");

var $jTpg0 = parcelRequire("jTpg0");
var $cfacb421ece7ea51$export$d2f4b923e36972d7;
(function(ExerciseType) {
    ExerciseType["Duration"] = "DURATION";
    ExerciseType["Repetition"] = "REPETITION";
})($cfacb421ece7ea51$export$d2f4b923e36972d7 || ($cfacb421ece7ea51$export$d2f4b923e36972d7 = {}));
var $cfacb421ece7ea51$export$9b057765c2d39bd8;
(function(ExerciseCategory) {
    ExerciseCategory["WarmUp"] = "Warm-up";
    ExerciseCategory["Stretching"] = "Stretching";
    ExerciseCategory["Strengthening"] = "Strengthening";
    ExerciseCategory["CoordinationAndBalance"] = "Coordination and balance";
})($cfacb421ece7ea51$export$9b057765c2d39bd8 || ($cfacb421ece7ea51$export$9b057765c2d39bd8 = {}));
const $cfacb421ece7ea51$export$c5218b860b48647a = (0, $d90o3.getEnumValues)($cfacb421ece7ea51$export$9b057765c2d39bd8);
var $cfacb421ece7ea51$export$113c6a96a5825a5d;
(function(ExerciseBodyPart) {
    ExerciseBodyPart["FullBody"] = "Full body";
    ExerciseBodyPart["HeadTrunk"] = "Head & trunk";
    ExerciseBodyPart["UpperLimbs"] = "Upper limbs";
    ExerciseBodyPart["LowerLimbs"] = "Lower limbs";
})($cfacb421ece7ea51$export$113c6a96a5825a5d || ($cfacb421ece7ea51$export$113c6a96a5825a5d = {}));
const $cfacb421ece7ea51$export$2245ee4d10c5aefb = (0, $d90o3.getEnumValues)($cfacb421ece7ea51$export$113c6a96a5825a5d);
var $cfacb421ece7ea51$export$978dda83a3afa6b6;
(function(ExerciseStartingPosition) {
    ExerciseStartingPosition["LyingDown"] = "Lying down";
    ExerciseStartingPosition["Kneeling"] = "Kneeling";
    ExerciseStartingPosition["SittingChair"] = "Sitting (chair)";
    ExerciseStartingPosition["SittingFloor"] = "Sitting (floor)";
    ExerciseStartingPosition["Standing"] = "Standing";
})($cfacb421ece7ea51$export$978dda83a3afa6b6 || ($cfacb421ece7ea51$export$978dda83a3afa6b6 = {}));
const $cfacb421ece7ea51$export$966eaf3ccabfba9f = (0, $d90o3.getEnumValues)($cfacb421ece7ea51$export$978dda83a3afa6b6);
var $cfacb421ece7ea51$export$b271b2c8ff92c49a;
(function(ExerciseDifficulty) {
    ExerciseDifficulty["Easy"] = "Easy";
    ExerciseDifficulty["Moderate"] = "Moderate";
    ExerciseDifficulty["Hard"] = "Hard";
})($cfacb421ece7ea51$export$b271b2c8ff92c49a || ($cfacb421ece7ea51$export$b271b2c8ff92c49a = {}));
const $cfacb421ece7ea51$export$c67b424f1654021a = (0, $d90o3.getEnumValues)($cfacb421ece7ea51$export$b271b2c8ff92c49a);
var $cfacb421ece7ea51$export$ce970b76f0f676a8;
(function(ExercisePatientWarning) {
    ExercisePatientWarning["No"] = "No";
    ExercisePatientWarning["AtaxiaWarning"] = "Ataxia Warning";
})($cfacb421ece7ea51$export$ce970b76f0f676a8 || ($cfacb421ece7ea51$export$ce970b76f0f676a8 = {}));
const $cfacb421ece7ea51$export$632e9325701a8064 = (value)=>$cfacb421ece7ea51$export$c5218b860b48647a.includes(value);
const $cfacb421ece7ea51$export$bbcab35d4a18cbcc = (value)=>$cfacb421ece7ea51$export$2245ee4d10c5aefb.includes(value);
const $cfacb421ece7ea51$export$6e1b4c8622d7b390 = (value)=>$cfacb421ece7ea51$export$966eaf3ccabfba9f.includes(value);
const $cfacb421ece7ea51$export$24bf8d5f834ff5fc = (value)=>$cfacb421ece7ea51$export$c67b424f1654021a.includes(value);
const $cfacb421ece7ea51$export$39cfbe6ed90efe8f = (exercise)=>"alternativeExercises" in exercise;
const $cfacb421ece7ea51$export$5ca219b61e6a702c = (exercise)=>[
        exercise.primaryBodyPart,
        ...exercise.secondaryBodyParts
    ];
const $cfacb421ece7ea51$export$141bf1128c2039f6 = 10;
function $cfacb421ece7ea51$export$b137eefcabb24d6f(ex1, ex2) {
    const ex1Props = (0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).omit(ex1, "draggableId");
    const ex2Props = (0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).omit(ex2, "draggableId");
    return JSON.stringify(ex1Props) === JSON.stringify(ex2Props);
}
function $cfacb421ece7ea51$export$d7c24f3e1c265d6d(exercise) {
    return exercise.unitType === "DURATION";
}

});




parcelRegister("fIuLY", function(module, exports) {

$parcel$export(module.exports, "ProgramErrorCodes", () => $fa1a4a6ccec7efab$export$c2a833ddd2155d91);
$parcel$export(module.exports, "ProgramNameTooLong", () => $fa1a4a6ccec7efab$export$5852a69435b1ae2b);
var $fa1a4a6ccec7efab$export$c2a833ddd2155d91;
(function(ProgramErrorCodes) {
    ProgramErrorCodes["ProgramNameTooLong"] = "PROGRAM_NAME_TOO_LONG";
})($fa1a4a6ccec7efab$export$c2a833ddd2155d91 || ($fa1a4a6ccec7efab$export$c2a833ddd2155d91 = {}));
class $fa1a4a6ccec7efab$export$5852a69435b1ae2b extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("aMqVr", function(module, exports) {

$parcel$export(module.exports, "ProgressDataManager", () => $1208afa3fffc1015$export$8733299577c26db0);
// ProgramId import removed - now using string type instead

var $lTdpc = parcelRequire("lTdpc");

var $kp7gC = parcelRequire("kp7gC");

var $1IWnK = parcelRequire("1IWnK");
class $1208afa3fffc1015$export$8733299577c26db0 {
    constructor(progressDataService){
        this.progressDataService = progressDataService;
        this._progressDataByPatient = (0, $1IWnK.observable)((0, $kp7gC.Map)());
        this._complianceGraphDataByPatient = (0, $1IWnK.observable)((0, $kp7gC.Map)());
        this._feedbackGraphDataByPatient = (0, $1IWnK.observable)((0, $kp7gC.Map)());
        this.progressDataByPatient = this._progressDataByPatient.readOnly();
        this.complianceGraphDataByPatient = this._complianceGraphDataByPatient.readOnly();
        this.feedbackGraphDataByPatient = this._feedbackGraphDataByPatient.readOnly();
    }
    async fetchProgressData(patientId, programId) {
        const newProgress = await this.progressDataService.loadProgressData(patientId, programId);
        this.updateMap(this._progressDataByPatient, patientId, programId, newProgress);
    }
    async fetchComplianceGraphData(patientId, programId) {
        const newComplianceGraphData = await this.progressDataService.loadComplianceGraphData(patientId, programId);
        this.updateMap(this._complianceGraphDataByPatient, patientId, programId, newComplianceGraphData);
    }
    async fetchFeedbackGraphData(patientId, programId) {
        const newFeedbackGraphData = await this.progressDataService.loadFeedbackGraphData(patientId, programId);
        this.updateMap(this._feedbackGraphDataByPatient, patientId, programId, newFeedbackGraphData);
    }
    async reset() {
        this._complianceGraphDataByPatient.set((0, $kp7gC.Map)());
        this._feedbackGraphDataByPatient.set((0, $kp7gC.Map)());
        this._progressDataByPatient.set((0, $kp7gC.Map)());
    }
    updateMap(map, patientId, programId, newData) {
        if ((0, $lTdpc.isNotNil)(newData) && map.get().get(patientId)?.get(programId) && JSON.stringify(map.get().get(patientId)?.get(programId)) === JSON.stringify(newData)) return;
        map.update((dataMap)=>{
            const patientDataMap = dataMap.get(patientId) ?? (0, $kp7gC.Map)();
            return dataMap.set(patientId, patientDataMap.set(programId, newData));
        });
    }
}

});

parcelRegister("7U4Mk", function(module, exports) {

$parcel$export(module.exports, "ProgressDataService", () => $f7351d83063a3ecf$export$51af816df09b4791);

var $c9OC9 = parcelRequire("c9OC9");

var $kXaMn = parcelRequire("kXaMn");
class $f7351d83063a3ecf$export$51af816df09b4791 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async loadProgressData(patientId, programId) {
        const result = await this.apiService.get(`/patients/${patientId}/programs/${programId}/kpis`);
        return $f7351d83063a3ecf$export$51af816df09b4791.progressDataFromDto(result.data);
    }
    async loadComplianceGraphData(patientId, programId) {
        const result = await this.apiService.get(`/patients/${patientId}/programs/${programId}/kpis/weekly-compliance`);
        return $f7351d83063a3ecf$export$51af816df09b4791.complianceGraphDataFromDto(result.data);
    }
    async loadFeedbackGraphData(patientId, programId) {
        const result = await this.apiService.get(`/patients/${patientId}/programs/${programId}/kpis/daily-feedback`);
        return $f7351d83063a3ecf$export$51af816df09b4791.feedbackGraphDataFromDto(result.data);
    }
    // Dto Conversions
    static progressDataFromDto(progressDataDto) {
        return {
            ...progressDataDto,
            startDate: (0, $kXaMn.dateFromDateDto)(progressDataDto.startDate),
            endDate: (0, $kXaMn.dateFromDateDto)(progressDataDto.endDate),
            lastCompletedSession: progressDataDto.lastCompletedSession ? (0, $kXaMn.dateFromDateDto)(progressDataDto.lastCompletedSession) : undefined,
            programProgressInPercent: progressDataDto.totalSessions ? progressDataDto.pastSessionsCount / progressDataDto.totalSessions * 100 : 0,
            programComplianceInPercent: progressDataDto.pastSessionsCount ? progressDataDto.completedSessionsCount / progressDataDto.pastSessionsCount * 100 : 0
        };
    }
    static complianceGraphDataFromDto(complianceGraphDataDto) {
        return complianceGraphDataDto.map(({ startDate: startDate, endDate: endDate, days: days, ...otherAttributes })=>({
                ...otherAttributes,
                days: days.map((dayDto)=>this.complianceDayFromDto(dayDto)),
                startDate: (0, $kXaMn.dateFromDateDto)(startDate),
                endDate: (0, $kXaMn.dateFromDateDto)(endDate)
            }));
    }
    static complianceDayFromDto(dayDto) {
        return {
            day: (0, $c9OC9.DayIndex)[dayDto.day],
            completed: dayDto.completed
        };
    }
    static feedbackGraphDataFromDto(feedbackGraphDataDto) {
        return {
            feedbacks: feedbackGraphDataDto.feedbacks.map((feedbackPerSessionDto, i)=>({
                    ...feedbackPerSessionDto,
                    index: i + 1,
                    completionDate: (0, $kXaMn.dateFromDateDto)(feedbackPerSessionDto.completionDate)
                }))
        };
    }
}

});

parcelRegister("kI4v8", function(module, exports) {

$parcel$export(module.exports, "ProspectRequestManager", () => $e84bb0b078be8695$export$83d2fa00ff0824ed);

var $bXTqq = parcelRequire("bXTqq");

var $lTdpc = parcelRequire("lTdpc");
class $e84bb0b078be8695$export$83d2fa00ff0824ed {
    constructor(prospectRequestService, countryService, infraManager){
        this.prospectRequestService = prospectRequestService;
        this.countryService = countryService;
        this.infraManager = infraManager;
    }
    async prepareProspectRequest(inputLocale) {
        const supportedCountries = await this.countryService.getSupportedCountries();
        const initialCountryCode = await this.getBestCountryFromSupportedCountries(supportedCountries, inputLocale);
        const referentialsMap = await this.fetchCountriesReferentials(supportedCountries);
        await this.selectCountry(initialCountryCode);
        return {
            supportedCountries: supportedCountries,
            initialCountryCode: initialCountryCode,
            referentialsMap: referentialsMap
        };
    }
    async selectCountry(countryCode) {
        await this.infraManager.changeInfrastructureUsingCountryCode(countryCode);
    }
    async sendDemoRequest(demoRequest) {
        await this.prospectRequestService.sendDemoRequest(demoRequest);
    }
    async sendInviteYourPTRequest(inviteYourPtRequest) {
        await this.prospectRequestService.sendInviteYourPTRequest(inviteYourPtRequest);
    }
    async getBestCountryFromSupportedCountries(supportedCountries, inputLocale) {
        let bestCountryCode;
        if ((0, $lTdpc.isNotNil)(inputLocale)) {
            const inputCountryCode = (0, $bXTqq.getLowercaseCountryCodeFromIntlLocale)((0, $bXTqq.localeToIntlLocale)(inputLocale));
            bestCountryCode = supportedCountries.find((countryCode)=>countryCode === inputCountryCode);
        }
        if ((0, $lTdpc.isNotNil)(bestCountryCode)) return bestCountryCode;
        return await this.countryService.getDefaultCountry();
    }
    async fetchCountriesReferentials(countryCodes) {
        const referentialsMap = new Map();
        for (const countryCode of countryCodes){
            const referential = await this.fetchCountryReferential(countryCode);
            referentialsMap.set(countryCode, referential);
        }
        return referentialsMap;
    }
    async fetchCountryReferential(countryCode) {
        if (!this.infraManager.targetInfra?.hostedCountries.includes(countryCode)) this.infraManager.changeInfrastructureUsingCountryCode(countryCode);
        return await this.countryService.getCountryUserConfig(countryCode);
    }
}

});

parcelRegister("1ySyt", function(module, exports) {

$parcel$export(module.exports, "ProspectRequestService", () => $f134d27ebe7d296a$export$12a3adcbd365c2a4);
class $f134d27ebe7d296a$export$12a3adcbd365c2a4 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async sendDemoRequest(demoRequest) {
        await this.apiService.post("/prospects/pt", demoRequest);
    }
    async sendInviteYourPTRequest(inviteYourPtRequest) {
        await this.apiService.post("/prospects/patient", $f134d27ebe7d296a$var$inviteYourPtRequestDtoFromFormData(inviteYourPtRequest));
    }
}
const $f134d27ebe7d296a$var$inviteYourPtRequestDtoFromFormData = ({ patientFirstName: patientFirstName, patientLastName: patientLastName, ...pt })=>({
        patient: {
            firstName: patientFirstName,
            lastName: patientLastName
        },
        pt: pt
    });

});

parcelRegister("fnxXE", function(module, exports) {

$parcel$export(module.exports, "CountryManager", () => $0be80c623a667e95$export$8d5dfc4e79526110);

var $lTdpc = parcelRequire("lTdpc");

var $1IWnK = parcelRequire("1IWnK");
class $0be80c623a667e95$export$8d5dfc4e79526110 {
    constructor(countryService, userManager){
        this.countryService = countryService;
        this.userManager = userManager;
        this._countryConfig = (0, $1IWnK.observable)(null);
        this.countryConfig = this._countryConfig.readOnly();
        this._supportedCountries = (0, $1IWnK.observable)([]);
        this.supportedCountries = this._supportedCountries.readOnly();
        this._countryUserConfig = (0, $1IWnK.observable)(null);
        this.countryUserConfig = this._countryUserConfig.readOnly();
        this._initialized = false;
        this._initializationPromise = null;
    }
    async init() {
        if (this._initialized) return;
        if (this._initializationPromise) {
            await this._initializationPromise;
            return;
        }
        this._initializationPromise = (async ()=>{
            await this.fetchSupportedCountries();
            this.userManager.user.subscribe(async (_user)=>{
                if ((0, $lTdpc.isNotNil)(_user?.country)) await this.fetchCountryUserConfig(_user.country);
            });
            this._initialized = true;
        })();
        try {
            await this._initializationPromise;
        } finally{
            this._initializationPromise = null;
        }
    }
    async fetchSupportedCountries() {
        const supportedCountries = await this.countryService.getSupportedCountries();
        this._supportedCountries.set(supportedCountries);
    }
    async getCountryUserConfig(countryCode) {
        this._countryUserConfig.set(await this.countryService.getCountryUserConfig(countryCode));
    }
    async fetchCountryUserConfig(countryCode) {
        this._countryConfig.set(await this.countryService.getCountryUserConfig(countryCode));
    }
    async getVerificationConfig(countryCode) {
        return await this.countryService.getVerificationConfig(countryCode);
    }
    async getLocale(email) {
        return await this.countryService.getLocale(email);
    }
}

});

parcelRegister("kP9hn", function(module, exports) {

$parcel$export(module.exports, "CountryService", () => $8513fb2231cd838e$export$25f8043512eddda0);
class $8513fb2231cd838e$export$25f8043512eddda0 {
    constructor(masterAxiosApiService, unauthenticatedApiService){
        this.masterAxiosApiService = masterAxiosApiService;
        this.unauthenticatedApiService = unauthenticatedApiService;
    }
    async getLocale(email) {
        return (await this.unauthenticatedApiService.get("/localization/locale", {
            params: {
                email: email
            }
        })).data.locale;
    }
    async getDefaultCountry() {
        return (await this.masterAxiosApiService.get("/localization/default-country")).data.code;
    }
    async getDefaultLocalesMapping() {
        return (await this.masterAxiosApiService.get("/localization/default-locales-mapping")).data;
    }
    async getSupportedCountries() {
        return (await this.masterAxiosApiService.get("/localization/supported-countries")).data.map(({ code: code })=>code);
    }
    async getSupportedLocales() {
        const result = (await this.masterAxiosApiService.get("/localization/supported-locales")).data;
        return new Map(result.map(({ country: country, locales: locales })=>[
                country,
                locales
            ]));
    }
    async getCountryUserConfig(countryCode) {
        const result = await this.unauthenticatedApiService.get("/localization/country-config", {
            params: {
                countryCode: countryCode
            }
        });
        return $8513fb2231cd838e$var$countryConfigFromDto(result.data);
    }
    async getVerificationConfig(countryCode) {
        const result = await this.unauthenticatedApiService.get(`/config/verification-config/${countryCode}`);
        return result.data;
    }
}
function $8513fb2231cd838e$var$countryConfigFromDto(dto) {
    return {
        ...dto,
        ptProfessionalIds: new Map(dto.ptProfessionalIds.map(({ name: name, ...rest })=>[
                name,
                rest
            ]))
    };
}

});

parcelRegister("7ZHO1", function(module, exports) {

$parcel$export(module.exports, "FastTrackRegisterManager", () => $4a98c7caef1e16f5$export$7eef27585a59d0c1);

var $eOSo1 = parcelRequire("eOSo1");

var $12cV0 = parcelRequire("12cV0");
class $4a98c7caef1e16f5$export$7eef27585a59d0c1 {
    constructor(fastTrackRegisterService, veevaService, authService, infraManager){
        this.fastTrackRegisterService = fastTrackRegisterService;
        this.veevaService = veevaService;
        this.authService = authService;
        this.infraManager = infraManager;
        this.logger = (0, $eOSo1.getLogger)("\uD83C\uDFC3 [FastTrackRegisterManager]");
    }
    async registerFastTrackUser(ptInput) {
        await this.infraManager.changeInfrastructureUsingCountryCode(ptInput.countryCode);
        this.logger.debug("Try to fast track with email", ptInput.email);
        const emailAlreadyExists = !await this.authService.isEmailAvailable(ptInput.email);
        if (emailAlreadyExists) {
            this.logger.error("Email already used");
            throw new (0, $12cV0.UsernameExistsCodeError)();
        }
        await this.fastTrackRegisterService.registerFastTrackUser(ptInput);
        this.logger.debug("User has been signed up with fast track");
    }
    async hasVeevaRecord(email, countryCode) {
        const hasRecord = await this.veevaService.hasVeevaRecord({
            email: email,
            countryCode: countryCode
        });
        this.logger.debug("Does User have a veeva record ? ", hasRecord);
        return hasRecord;
    }
}

});

parcelRegister("8rwTs", function(module, exports) {

$parcel$export(module.exports, "FastTrackRegisterService", () => $9190a6fcf0d5a6e5$export$5e4422716391c93f);

var $04Qjn = parcelRequire("04Qjn");

var $9luHD = parcelRequire("9luHD");
class $9190a6fcf0d5a6e5$export$5e4422716391c93f {
    constructor(authenticatedAxiosApiService){
        this.authenticatedAxiosApiService = authenticatedAxiosApiService;
    }
    async registerFastTrackUser(fastTrackPtInput) {
        try {
            await this.authenticatedAxiosApiService.post("/pts/fast-track/register", fastTrackPtInput, {}, ()=>false);
        } catch (e) {
            if ((0, $04Qjn.isApiError)(e) && e.status === 404) throw new (0, $9luHD.InvalidVeevaUser)(e.message);
            throw e;
        }
    }
}

});
parcelRegister("9luHD", function(module, exports) {

$parcel$export(module.exports, "VeevaErrorCodes", () => $84a5d68e3bcd7338$export$a0e2c00cf16b58f2);
$parcel$export(module.exports, "InvalidVeevaUser", () => $84a5d68e3bcd7338$export$d7ad7d6f0b2749db);
var $84a5d68e3bcd7338$export$a0e2c00cf16b58f2;
(function(VeevaErrorCodes) {
    VeevaErrorCodes["InvalidVeevaUser"] = "VEEVA_RECORD_ERROR";
    VeevaErrorCodes["PtEmailAlreadyExists"] = "PT_EMAIL_ALREADY_EXISTS";
})($84a5d68e3bcd7338$export$a0e2c00cf16b58f2 || ($84a5d68e3bcd7338$export$a0e2c00cf16b58f2 = {}));
class $84a5d68e3bcd7338$export$d7ad7d6f0b2749db extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("8n64Q", function(module, exports) {

$parcel$export(module.exports, "VipRegisterManager", () => $679ffbeb5bbad890$export$2a79c377c0b276e7);

var $04Qjn = parcelRequire("04Qjn");

var $eOSo1 = parcelRequire("eOSo1");

var $12cV0 = parcelRequire("12cV0");

var $9luHD = parcelRequire("9luHD");
class $679ffbeb5bbad890$export$2a79c377c0b276e7 {
    constructor(vipRegisterService, veevaService, authService, infraManager){
        this.vipRegisterService = vipRegisterService;
        this.veevaService = veevaService;
        this.authService = authService;
        this.infraManager = infraManager;
        this.vipUserLogger = (0, $eOSo1.getLogger)("\uD83C\uDF1F\uFE0F [VipRegisterManager]");
    }
    async getVeevaUserData(veevaId) {
        try {
            this.vipUserLogger.info(`Try to get Veeva user data with id : ${veevaId}`);
            const veevaUserRecordData = await this.veevaService.getVeevaUserData(veevaId);
            const email = veevaUserRecordData.email;
            let emailAlreadyExists = false;
            if (email) {
                emailAlreadyExists = !await this.authService.isEmailAvailable(email);
                if (emailAlreadyExists) this.vipUserLogger.info("Veeva Email already exists. Redirect to login...");
            }
            await this.infraManager.changeInfrastructureUsingCountryCode(veevaUserRecordData.countryCode);
            return {
                record: veevaUserRecordData,
                emailAlreadyExists: emailAlreadyExists
            };
        } catch (error) {
            if ((0, $04Qjn.isApiError)(error) && error.code === (0, $9luHD.VeevaErrorCodes).InvalidVeevaUser) {
                this.vipUserLogger.error("Invalid Veeva user (wrong id,  missing information, ...)");
                throw new (0, $9luHD.InvalidVeevaUser)();
            }
            this.vipUserLogger.error("An error occurred: ", error);
            throw error;
        }
    }
    async registerVipUser(veevaPtInput) {
        try {
            const emailAlreadyExists = !await this.authService.isEmailAvailable(veevaPtInput.email);
            if (emailAlreadyExists) throw new (0, $12cV0.UsernameExistsCodeError)();
            await this.vipRegisterService.registerVipUser(veevaPtInput);
        } catch (e) {
            if ((0, $04Qjn.isApiError)(e) && e.code === (0, $9luHD.VeevaErrorCodes).PtEmailAlreadyExists || e instanceof (0, $12cV0.UsernameExistsCodeError)) throw new (0, $12cV0.UsernameExistsCodeError)();
            throw e;
        }
    }
}

});

parcelRegister("5oZJu", function(module, exports) {

$parcel$export(module.exports, "VipRegisterService", () => $60a0f72e0fbc4c7c$export$88db4dfdedee3a62);
class $60a0f72e0fbc4c7c$export$88db4dfdedee3a62 {
    constructor(authenticatedApiService){
        this.authenticatedApiService = authenticatedApiService;
    }
    async registerVipUser(veevaPtInput) {
        await this.authenticatedApiService.post("/pts/vip/register", veevaPtInput);
    }
}

});

parcelRegister("frvHD", function(module, exports) {

$parcel$export(module.exports, "RegisterManager", () => $9d239e3f82d99707$export$4030fbcdb124970b);

var $bXTqq = parcelRequire("bXTqq");

var $eOSo1 = parcelRequire("eOSo1");

var $12cV0 = parcelRequire("12cV0");

var $lTdpc = parcelRequire("lTdpc");
class $9d239e3f82d99707$export$4030fbcdb124970b {
    constructor(registerService, localeManager, authService, infraManager){
        this.registerService = registerService;
        this.localeManager = localeManager;
        this.authService = authService;
        this.infraManager = infraManager;
        this.logger = (0, $eOSo1.getLogger)("\uD83D\uDD8A\uFE0F [RegisterManager]");
    }
    async fetchPtInvitation(invitationId) {
        return await this.registerService.fetchPtInvitation(invitationId);
    }
    async getBestLocaleForCountry(countryCode) {
        const { locale: locale } = await this.registerService.sendCountryCode(countryCode);
        return (0, $bXTqq.localeToIntlLocale)(locale);
    }
    async sendCountryCode(countryCode) {
        await this.infraManager.changeInfrastructureUsingCountryCode(countryCode);
        const intlLocale = await this.getBestLocaleForCountry(countryCode);
        this.localeManager.changeLocale(intlLocale);
    }
    async changeLocale(intlLocale) {
        const countryCode = (0, $bXTqq.getLowercaseCountryCodeFromIntlLocale)(intlLocale);
        await this.infraManager.changeInfrastructureUsingCountryCode(countryCode);
        this.localeManager.changeLocale(intlLocale);
    }
    async signUpWithEmail(email, password, userAttributes) {
        this.logger.debug("Try to sign up");
        const isEmailAvailable = await this.authService.isEmailAvailable(email);
        if (!isEmailAvailable) {
            this.logger.debug("Email already exists");
            throw new (0, $12cV0.UsernameExistsCodeError)(`Email ${email} already exists`);
        }
        await this.authService.signUpEmail(email, password, userAttributes);
    }
    async resendSignUpCode(email) {
        await this.authService.resendSignUpValidationCode(email);
    }
    async sendRegistrationData(data) {
        await this.registerService.sendRegistrationData(data);
    }
    async validateProfessionalInformation(data) {
        await this.registerService.validateProfessionalInfo(data);
    }
    async confirmEmailAddress(email, code) {
        await this.authService.validateSignUpConfirmationCode(code, email);
    }
    async login(email, password) {
        await this.authService.loginEmail(email, password, Promise.resolve);
    }
    async retrieveUserAttributes(email, password, onSuccess, onError) {
        if (!this.authService.isAuthenticated()) await this.authService.loginEmail(email, password, Promise.resolve);
        try {
            const userAttributes = this.authService.getRegistrationUserAttributes();
            if ((0, $lTdpc.isNil)(userAttributes)) {
                onError?.(new Error("UserAttributes are undefined. The registration cannot continue"));
                return;
            }
            onSuccess?.(userAttributes);
        } catch (error) {
            console.error("Failed to retrieve user attributes", error);
            onError?.(error);
        }
    }
}

});

parcelRegister("94Hzw", function(module, exports) {

$parcel$export(module.exports, "RegisterService", () => $4de32c64fc56016e$export$f081687a3defd6f3);
class $4de32c64fc56016e$export$f081687a3defd6f3 {
    constructor(authenticatedApiService, unauthenticatedApiService){
        this.authenticatedApiService = authenticatedApiService;
        this.unauthenticatedApiService = unauthenticatedApiService;
    }
    async fetchPtInvitation(invitationId) {
        const result = await this.unauthenticatedApiService.get(`/pts/invitations/${invitationId}`);
        return {
            ...result.data,
            id: invitationId
        };
    }
    async sendCountryCode(countryCode) {
        return (await this.unauthenticatedApiService.post("/localization/locale", {
            countryCode: countryCode
        })).data;
    }
    async sendRegistrationData(data) {
        await this.authenticatedApiService.post("/pts/register", data);
    }
    async validateProfessionalInfo(data) {
        await this.authenticatedApiService.post("/pts/professional-information", data);
    }
}

});

parcelRegister("4m2wf", function(module, exports) {

$parcel$export(module.exports, "ServerConfigManager", () => $2b3a2d74cc744adc$export$bac638ac9cd035e2);

var $eOSo1 = parcelRequire("eOSo1");

var $lTdpc = parcelRequire("lTdpc");

var $1IWnK = parcelRequire("1IWnK");

var $gbSxu = parcelRequire("gbSxu");
class $2b3a2d74cc744adc$export$bac638ac9cd035e2 {
    get serverConfig() {
        if ((0, $lTdpc.isNotNil)(this._serverConfig)) return this._serverConfig;
        throw new Error("Server config does not exist");
    }
    constructor(serverConfigService, store){
        this.serverConfigService = serverConfigService;
        this.store = store;
        this.logger = (0, $eOSo1.getLogger)("\uD83C\uDF9B [ServerConfigManager]");
        this._serverConfig = null;
        this._serverConfigStatus = (0, $1IWnK.observable)({
            available: false,
            error: null
        });
        this.serverConfigStatus = this._serverConfigStatus.readOnly();
        this.configChanged = new (0, $gbSxu.Signal)();
    }
    async init() {
        let config;
        let error = null;
        try {
            config = await this.serverConfigService.getConfig();
            this.store.setItem(config);
        } catch (e) {
            error = e;
            // Backup startup: retrieve older config from local storage
            config = this.store.getItem();
        }
        if ((0, $lTdpc.isNotNil)(config)) {
            this._serverConfig = config;
            this.configChanged.dispatch(config);
        }
        this._serverConfigStatus.set({
            available: (0, $lTdpc.isNotNil)(config),
            error: error
        });
    }
    debugShowNoConfigScreen(error) {
        this._serverConfigStatus.set({
            available: false,
            error: error
        });
    }
}

});

parcelRegister("kOuME", function(module, exports) {

$parcel$export(module.exports, "ServerConfigService", () => $c603aeb3738c4aed$export$57168961060452cd);
class $c603aeb3738c4aed$export$57168961060452cd {
    constructor(apiService){
        this.apiService = apiService;
    }
    async getConfig() {
        const result = await this.apiService.get("/config");
        return result.data;
    }
}

});

parcelRegister("6TlSs", function(module, exports) {

$parcel$export(module.exports, "TemplateManager", () => $c5a4d9c812094b4d$export$8cc24d54938ccaf6);

var $l2BWr = parcelRequire("l2BWr");

var $kp7gC = parcelRequire("kp7gC");

var $1IWnK = parcelRequire("1IWnK");
class $c5a4d9c812094b4d$export$8cc24d54938ccaf6 {
    constructor(templateService){
        this.templateService = templateService;
        this._templateById = (0, $1IWnK.observable)((0, $kp7gC.Map)());
        this._templateItems = (0, $1IWnK.observable)(undefined);
        this.templateById = this._templateById.readOnly();
        this.templateItems = this._templateItems.readOnly();
    }
    async fetchAllTemplates() {
        const allTemplates = await this.templateService.loadAllTemplates();
        this._templateItems.set(allTemplates);
    }
    async fetchTemplate(templateId) {
        const newTemplate = await this.templateService.loadTemplate(templateId);
        this._templateById.update((templateMap)=>templateMap.set(templateId, newTemplate));
        return newTemplate;
    }
    async createTemplate(newTemplate) {
        const templateMetadata = await this.templateService.createTemplate(newTemplate);
        const newRealTemplate = {
            id: templateMetadata.id,
            ...newTemplate
        };
        this._templateById.update((templateMap)=>templateMap.set(templateMetadata.id, newRealTemplate));
        this._templateItems.update((templateItems)=>[
                ...templateItems ?? [],
                (0, $l2BWr.getTemplateItemFromTemplate)(newRealTemplate, templateMetadata.lastEditionDate)
            ].sort((item1, item2)=>item2.lastEditionDate.diff(item1.lastEditionDate)));
        return templateMetadata;
    }
    async updateTemplate(templateId, templateUpdateData) {
        const templateMetadata = await this.templateService.updateTemplate(templateId, templateUpdateData);
        const newRealTemplate = {
            id: templateMetadata.id,
            ...templateUpdateData
        };
        this._templateById.update((templateMap)=>templateMap.set(templateMetadata.id, newRealTemplate));
        const updatedTemplateItem = (0, $l2BWr.getTemplateItemFromTemplate)(newRealTemplate, templateMetadata.lastEditionDate);
        this._templateItems.update((templateItems)=>templateItems?.map((templateItem)=>templateItem.id === updatedTemplateItem.id ? updatedTemplateItem : templateItem).sort((item1, item2)=>item2.lastEditionDate.diff(item1.lastEditionDate)));
    }
    async transformProgramToTemplate(patientId, programId, templateName) {
        const newTemplate = await this.templateService.transformProgramToTemplate(patientId, programId, templateName);
        this._templateItems.update((templateItems)=>[
                newTemplate,
                ...templateItems ?? []
            ]);
        return newTemplate.id;
    }
    async deleteTemplate(templateId) {
        await this.templateService.deleteTemplate(templateId);
        this._templateById.update((templateMap)=>templateMap.delete(templateId));
        this._templateItems.update((templateItems)=>templateItems?.filter((item)=>item.id !== templateId));
    }
    async reset() {
        this._templateById.set((0, $kp7gC.Map)());
        this._templateItems.set(undefined);
    }
}

});
parcelRegister("l2BWr", function(module, exports) {

$parcel$export(module.exports, "getTemplateItemFromTemplate", () => $7cc2f87a86554859$export$4b0a4abbeb7c4f53);
$parcel$export(module.exports, "isTemplate", () => $7cc2f87a86554859$export$6306e0d85c68df69);
$parcel$export(module.exports, "getEmptyNewTemplate", () => $7cc2f87a86554859$export$be29137edefe29ff);

var $c9OC9 = parcelRequire("c9OC9");

var $kXaMn = parcelRequire("kXaMn");
function $7cc2f87a86554859$export$4b0a4abbeb7c4f53(template, lastEditionDate) {
    const { id: id, name: name, days: days } = template;
    return {
        id: id,
        name: name,
        lastEditionDate: lastEditionDate ?? (0, $kXaMn.now)(),
        exercisesPerWeek: days.exercisesPerWeek,
        sessionsPerWeek: days.sessionsPerWeek
    };
}
function $7cc2f87a86554859$export$6306e0d85c68df69(template) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return template.id !== undefined;
}
function $7cc2f87a86554859$export$be29137edefe29ff() {
    return {
        days: new (0, $c9OC9.ProgramDays)()
    };
}

});


parcelRegister("7VkZx", function(module, exports) {

$parcel$export(module.exports, "TemplateOperationsManager", () => $e8a18b37d4af264d$export$93ce0a18ddec70fa);

var $1IWnK = parcelRequire("1IWnK");
class $e8a18b37d4af264d$export$93ce0a18ddec70fa {
    constructor(templateManager, programManager){
        this.templateManager = templateManager;
        this.programManager = programManager;
        this._lastTemplateOperation = (0, $1IWnK.observable)(null);
        this.lastTemplateOperation = this._lastTemplateOperation.readOnly();
    }
    async performDeleteOperation(templateId, templateName) {
        await this.templateManager.deleteTemplate(templateId);
        this._lastTemplateOperation.set({
            type: "delete",
            templateName: templateName
        });
    }
    async performAssignOperation(patientId, programContent) {
        const metadata = await this.programManager.createDraftProgram(patientId, programContent);
        this._lastTemplateOperation.set({
            type: "assign"
        });
        return metadata;
    }
    removeLastTemplateOperation() {
        this._lastTemplateOperation.set(null);
    }
    async reset() {
        this.removeLastTemplateOperation();
    }
}

});

parcelRegister("jkS1f", function(module, exports) {

$parcel$export(module.exports, "TemplateService", () => $bc07250ad478a49c$export$742dedceeaaabe78);

var $97zxo = parcelRequire("97zxo");

var $kXaMn = parcelRequire("kXaMn");
class $bc07250ad478a49c$export$742dedceeaaabe78 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async loadAllTemplates() {
        const result = await this.apiService.get("/templates");
        return result.data.map((template)=>$bc07250ad478a49c$export$742dedceeaaabe78.templateItemFromDto(template));
    }
    async loadTemplate(templateId) {
        const result = await this.apiService.get(`/templates/${templateId}`);
        return $bc07250ad478a49c$export$742dedceeaaabe78.templateFromDto(result.data);
    }
    async createTemplate(newTemplate) {
        const newTemplateDto = (0, $97zxo.getProgramLightContentDtoFromProgramContent)(newTemplate);
        const result = await this.apiService.post("/templates", newTemplateDto, undefined, ()=>false);
        return $bc07250ad478a49c$export$742dedceeaaabe78.metadataFromDto(result.data);
    }
    async updateTemplate(templateId, draftTemplate) {
        const newTemplateDto = (0, $97zxo.getProgramLightContentDtoFromProgramContent)(draftTemplate);
        const result = await this.apiService.post(`/templates/${templateId}`, newTemplateDto, undefined, ()=>false);
        return $bc07250ad478a49c$export$742dedceeaaabe78.metadataFromDto(result.data);
    }
    async deleteTemplate(templateId) {
        await this.apiService.delete(`/templates/${templateId}`);
    }
    async transformProgramToTemplate(patientId, programId, templateName) {
        const result = await this.apiService.post(`/patients/${patientId}/programs/${programId}/template`, {
            name: templateName
        });
        return $bc07250ad478a49c$export$742dedceeaaabe78.templateItemFromDto(result.data);
    }
    // Dto Conversions
    static templateFromDto(templateDto) {
        return {
            id: templateDto.id,
            ...(0, $97zxo.getProgramContentFromDto)(templateDto)
        };
    }
    static templateItemFromDto(templateLightDto) {
        return {
            ...templateLightDto,
            lastEditionDate: (0, $kXaMn.dateFromDateDto)(templateLightDto.lastEditionDate)
        };
    }
    static metadataFromDto(metadataDto) {
        return {
            ...metadataDto,
            lastEditionDate: (0, $kXaMn.now)()
        };
    }
}

});

parcelRegister("2Bm53", function(module, exports) {

$parcel$export(module.exports, "TutorialBannerType", () => $49263937552390d0$export$80f09614cab05f1a);
$parcel$export(module.exports, "tutorialBannerTypes", () => $49263937552390d0$export$117575db38afe12e);
$parcel$export(module.exports, "TutorialBannerManager", () => $49263937552390d0$export$d816d3f6af1a61df);

var $aj4st = parcelRequire("aj4st");

var $d90o3 = parcelRequire("d90o3");

var $jTpg0 = parcelRequire("jTpg0");

var $1IWnK = parcelRequire("1IWnK");
var $49263937552390d0$export$80f09614cab05f1a;
(function(TutorialBannerType) {
    TutorialBannerType["MONITOR_PATIENT_PROGRAM"] = "MONITOR_PATIENT_PROGRAM";
    TutorialBannerType["INVITE_TO_HCT"] = "INVITE_TO_HCT";
})($49263937552390d0$export$80f09614cab05f1a || ($49263937552390d0$export$80f09614cab05f1a = {}));
const $49263937552390d0$export$117575db38afe12e = (0, $d90o3.getEnumValues)($49263937552390d0$export$80f09614cab05f1a);
class $49263937552390d0$export$d816d3f6af1a61df {
    constructor(tutorialBannerService, userManager){
        this.tutorialBannerService = tutorialBannerService;
        this.userManager = userManager;
        this._disabledBannersStore = (0, $aj4st.storage).getStore("disabledBanners", (v)=>v, (v)=>v);
        this._disabledBanners = (0, $1IWnK.observable)([]);
        this._displayedBanners = (0, $1IWnK.observable)([]);
        this.displayedBanners = this._displayedBanners.readOnly();
        this._tutorialLinks = (0, $1IWnK.observable)(undefined);
        this._disabledBanners.subscribe((disabledBanners)=>this._displayedBanners.update((displayedBanners)=>displayedBanners.filter((bannerType)=>!disabledBanners.includes(bannerType))));
        userManager.user.subscribe(async ()=>{
            const links = await this.tutorialBannerService.getTutorialLinks();
            this._tutorialLinks.set(links);
            this._disabledBanners.set((0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).get(this._disabledBannersStore.getItem(), userManager.user.get()?.id ?? "") ?? []);
        });
    }
    displayBanner(type) {
        if (!this._disabledBanners.get().includes(type) && !this._displayedBanners.get().includes(type)) this._displayedBanners.update((banners)=>[
                ...banners,
                type
            ]);
    }
    hideBanners() {
        this._displayedBanners.set([]);
    }
    closeBanner(type) {
        this._displayedBanners.update((banners)=>banners.filter((banner)=>banner !== type));
        const newDisabledBanners = [
            ...this._disabledBanners.get(),
            type
        ];
        this.updateDisabledBannersAndCurrentUserStore(newDisabledBanners);
    }
    getTutorialLink(type) {
        return this._tutorialLinks.get()?.[type];
    }
    debugGetDisabledBanners() {
        return this._disabledBanners;
    }
    debugGetTutorials() {
        return this._tutorialLinks;
    }
    debugResetBanners() {
        this.updateDisabledBannersAndCurrentUserStore([]);
    }
    updateDisabledBannersAndCurrentUserStore(disabledBanners) {
        this._disabledBannersStore.setItem({
            ...this._disabledBannersStore.getItem(),
            [this.userManager.user.get()?.id ?? ""]: disabledBanners
        });
        this._disabledBanners.set(disabledBanners);
    }
}

});

parcelRegister("261bY", function(module, exports) {

$parcel$export(module.exports, "TutorialBannerService", () => $d12243f20159561b$export$8ea71455f65fe353);

var $2Bm53 = parcelRequire("2Bm53");
class $d12243f20159561b$export$8ea71455f65fe353 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async getTutorialLinks() {
        const tutorialsDto = await this.apiService.get("/pts/me/video-tutorials");
        return this.getTutorialsFromDto(tutorialsDto.data);
    }
    getTutorialsFromDto(dto) {
        const tutorials = {
            [(0, $2Bm53.TutorialBannerType).INVITE_TO_HCT]: undefined,
            [(0, $2Bm53.TutorialBannerType).MONITOR_PATIENT_PROGRAM]: undefined
        };
        dto.forEach((tutorial)=>{
            tutorials[tutorial.type] = {
                videoUrl: tutorial.videoUrl
            };
        });
        return tutorials;
    }
}

});

parcelRegister("gFp6z", function(module, exports) {

$parcel$export(module.exports, "UserBannerManager", () => $9afb64f620e9d5d9$export$e169199b8f378aef);

var $aj4st = parcelRequire("aj4st");

var $lTdpc = parcelRequire("lTdpc");
class $9afb64f620e9d5d9$export$e169199b8f378aef {
    updateValidatedAccountBanner(userId) {
        if ((0, $lTdpc.isNotNil)(userId)) this._hideValidatedAccountBannerStore.setItem({
            ...this._hideValidatedAccountBannerStore.getItem(),
            [userId]: true
        });
    }
    hasValidatedAccountBanner(userId) {
        const storeItems = this._hideValidatedAccountBannerStore.getItem();
        return (0, $lTdpc.isNotNil)(storeItems) && (0, $lTdpc.isNotNil)(userId) && Object.keys(storeItems).includes(userId);
    }
    constructor(){
        this._hideValidatedAccountBannerStore = (0, $aj4st.storage).getStore("hideValidateBanner", (v)=>v, (v)=>v);
    }
}

});

parcelRegister("gn5v7", function(module, exports) {

$parcel$export(module.exports, "UserSurveyManager", () => $a265f620b40a92c0$export$b7e452c7a109d6ac);

var $1IWnK = parcelRequire("1IWnK");

var $lTdpc = parcelRequire("lTdpc");
class $a265f620b40a92c0$export$b7e452c7a109d6ac {
    static{
        this.MIN_PAGES_VISITED = 6;
    }
    static{
        this.STOP_PERIOD_IN_DAYS = 1;
    }
    constructor(userSurveyService){
        this.userSurveyService = userSurveyService;
        this.surveyDialogDisplayContext = {
            visitedPage: undefined,
            pageVisitCount: 0,
            displayDate: undefined
        };
        this._isSurveyCompleted = (0, $1IWnK.observable)(false);
        this.isSurveyCompleted = this._isSurveyCompleted.readOnly();
    }
    async processPage(url, showDialogCallback) {
        // displayDate
        if ((0, $lTdpc.isNotNil)(this.surveyDialogDisplayContext.displayDate) && new Date() < this.surveyDialogDisplayContext.displayDate) return;
        // visitedPage
        if (url === this.surveyDialogDisplayContext.visitedPage) return;
        this.surveyDialogDisplayContext.visitedPage = url;
        // pageVisitCount
        if (++this.surveyDialogDisplayContext.pageVisitCount < $a265f620b40a92c0$export$b7e452c7a109d6ac.MIN_PAGES_VISITED) return;
        // reset context for next time
        this.surveyDialogDisplayContext = {
            visitedPage: undefined,
            pageVisitCount: 0,
            displayDate: $a265f620b40a92c0$export$b7e452c7a109d6ac.getSurveyDialogDisplayDate()
        };
        this._isSurveyCompleted.update(()=>false);
        const surveys = await this.listSurveys();
        if (surveys.length > 0) await showDialogCallback(surveys[0]);
    }
    async listSurveys() {
        return await this.userSurveyService.listSurveys();
    }
    async completeSurvey(id) {
        await this.userSurveyService.completeSurvey(id);
        this._isSurveyCompleted.update(()=>true);
    }
    async dismissSurvey(id) {
        await this.userSurveyService.dismissSurvey(id);
    }
    static getSurveyDialogDisplayDate() {
        const date = new Date();
        date.setDate(date.getDate() + $a265f620b40a92c0$export$b7e452c7a109d6ac.STOP_PERIOD_IN_DAYS);
        return date;
    }
}

});

parcelRegister("7gQVm", function(module, exports) {

$parcel$export(module.exports, "UserSurveyService", () => $9ef4a49eb862c512$export$415d4bb4b82d9639);
class $9ef4a49eb862c512$export$415d4bb4b82d9639 {
    constructor(apiService){
        this.apiService = apiService;
    }
    async listSurveys() {
        const result = await this.apiService.get("/surveys");
        return result.data;
    }
    async completeSurvey(surveyId) {
        await this.apiService.post(`/surveys/${surveyId}/complete`);
    }
    async dismissSurvey(surveyId) {
        await this.apiService.post(`/surveys/${surveyId}/dismiss`);
    }
}

});

parcelRegister("6ihZe", function(module, exports) {

$parcel$export(module.exports, "UserManager", () => $cc8ffebd62b55c4c$export$4c4d82ee86d9366d);

var $02mFA = parcelRequire("02mFA");

var $lTdpc = parcelRequire("lTdpc");

var $hPUY2 = parcelRequire("hPUY2");

var $1IWnK = parcelRequire("1IWnK");

var $gbSxu = parcelRequire("gbSxu");
class $cc8ffebd62b55c4c$export$4c4d82ee86d9366d {
    constructor(authService, userService){
        this.authService = authService;
        this.userService = userService;
        this._user = (0, $1IWnK.observable)(null);
        this.user = this._user.readOnly();
        this._userDeletingInfos = null;
        this.onUserLogout = new (0, $gbSxu.Signal)();
        this.onUserFirstConnection = new (0, $gbSxu.Signal)();
    }
    async init() {
        const isAuthenticated = this.authService.isAuthenticated();
        if (isAuthenticated) try {
            await this.retrieveUser();
        } catch (error) {
            console.warn("Authenticated but user does not exist on server");
        }
    }
    async loginWithEmail(email, password) {
        await this.authService.loginEmail(email, password, this.sendNewDeviceNotification.bind(this));
        await this.retrieveUser();
    }
    async resetPassword(email) {
        await this.authService.forgotPassword(email);
    }
    async resendResetToken(email) {
        await this.authService.forgotPassword(email);
    }
    async newPassword(email, resetToken, newPassword) {
        await this.authService.newPassword(email, resetToken, newPassword);
    }
    async newPasswordOnBoarding(newPassword) {
        await this.authService.completeNewPasswordChallenge(newPassword, this.sendNewDeviceNotification.bind(this));
    }
    async changePassword(currentPassword, newPassword) {
        await this.authService.changePassword(currentPassword, newPassword);
    }
    async updateUser(data) {
        const updatedUser = await this.userService.updateUser(data);
        this._user.set(updatedUser);
    }
    async deleteUser(leavingReasons) {
        this._userDeletingInfos = {
            leavingReasons: leavingReasons
        };
        await this.userService.deleteUser();
        await this.logout();
    }
    get userDeletingInfos() {
        const infos = this._userDeletingInfos;
        this._userDeletingInfos = null;
        return infos;
    }
    async logout() {
        this._user.set(null);
        this.onUserLogout.dispatch();
        await this.authService.logout();
    }
    async setConsentEmails(choices) {
        const notificationPreferences = (this.user.get()?.notificationPreferences ?? []).map((pref)=>{
            const isBiogen = pref.type === (0, $02mFA.PtNotificationPreferencesType).BIOGEN;
            const isPhysioMe = pref.type === (0, $02mFA.PtNotificationPreferencesType).PHYSIO_ME;
            let email = pref.email;
            if (isPhysioMe) email = choices.physioMeEmails;
            else if (isBiogen) email = choices.biogenEmails;
            return {
                ...pref,
                email: email
            };
        });
        await this.userService.updateNotificationPreferences(notificationPreferences);
    }
    async updateNotificationPreferences(notificationPreferences) {
        await this.userService.updateNotificationPreferences(notificationPreferences);
        this._user.update((user)=>(0, $lTdpc.isNotNil)(user) ? {
                ...user,
                notificationPreferences: notificationPreferences
            } : null);
    }
    async sendNewDeviceNotification(deviceKey) {
        console.debug("[UserManager] sendNewDeviceNotification");
        try {
            await this.userService.sendNewDeviceNotification(deviceKey);
        } catch (error) {
            console.warn("[UserManager] could not send new device notification", error);
        }
    }
    async retrieveUser() {
        try {
            const user = await this.userService.getUser();
            this._user.set(user);
            if (!user.lastConnectionDate) this.onUserFirstConnection.dispatch();
        } catch (error) {
            // Network errors (no internet) should not trigger logout — only server/auth errors should
            const isNetworkError = (0, (/*@__PURE__*/$parcel$interopDefault($hPUY2))).isAxiosError(error) && !error.response;
            if (!isNetworkError) await this.logout();
            throw error;
        }
    }
    async retrieveUserEmail(userId) {
        return await this.userService.getEmailFromUserId(userId);
    }
    updateUserHasIdentityFiles(hasIdentityFiles) {
        const user = this.user.get();
        if ((0, $lTdpc.isNotNil)(user)) this._user.set({
            ...user,
            hasIdentityFiles: hasIdentityFiles
        });
    }
    async foo() {
        console.debug("[UserManager] foo method called");
        return true;
    }
}

});

parcelRegister("zj4Ke", function(module, exports) {

$parcel$export(module.exports, "UserService", () => $551a82f7e8f0d024$export$a81c579a392aa9d2);

var $04Qjn = parcelRequire("04Qjn");

var $bXTqq = parcelRequire("bXTqq");

var $gIkq9 = parcelRequire("gIkq9");

var $9FLhs = parcelRequire("9FLhs");

var $kXaMn = parcelRequire("kXaMn");
class $551a82f7e8f0d024$export$a81c579a392aa9d2 {
    constructor(apiService){
        this.apiService = apiService;
        this.rootPath = "/pts/me";
    }
    async getUser() {
        try {
            const result = await this.apiService.get(this.rootPath, undefined);
            return $551a82f7e8f0d024$export$a81c579a392aa9d2.userFromDto(result.data);
        } catch (error) {
            if ((0, $04Qjn.isApiError)(error) && error.code === "USER_NOT_ACTIVATED") throw new (0, $9FLhs.NonExistentUserError)("user does not exist");
            else throw error;
        }
    }
    async getEmailFromUserId(ptId) {
        try {
            const result = await this.apiService.get(`${this.rootPath}/email`, {
                params: {
                    ptId: ptId
                }
            });
            return result.data.email;
        } catch (error) {
            console.error("Failed to fetch email by userId:", error);
            return null;
        }
    }
    async updateNotificationPreferences(notificationPreferences) {
        await this.apiService.post(`${this.rootPath}/notification-preferences`, {
            notificationPreferences: notificationPreferences
        });
    }
    async updateUser(data) {
        const result = await this.apiService.post(this.rootPath, data);
        return $551a82f7e8f0d024$export$a81c579a392aa9d2.userFromDto(result.data);
    }
    async sendNewDeviceNotification(deviceKey) {
        await this.apiService.post(`${this.rootPath}/notification/new-device`, {
            deviceKey: deviceKey
        });
    }
    async completeIdentityVerification() {
        await this.apiService.post(`${this.rootPath}/identity-verification/complete`);
    }
    async deleteUser() {
        await this.apiService.delete(this.rootPath);
    }
    static userFromDto(userDto) {
        return {
            ...userDto,
            lastConnectionDate: userDto.lastConnectionDate ? (0, $kXaMn.dateFromDateDto)(userDto.lastConnectionDate) : null,
            locale: userDto.locale ? (0, $bXTqq.localeToIntlLocale)(userDto.locale) : (0, $gIkq9.DEFAULT_LOCALE),
            creationDate: (0, $kXaMn.dateFromDateDto)(userDto.creationDate),
            hcpValidationDate: userDto.hcpValidationDate ? (0, $kXaMn.dateFromDateDto)(userDto.hcpValidationDate) : null,
            identityValidationDate: userDto.identityValidationDate ? (0, $kXaMn.dateFromDateDto)(userDto.identityValidationDate) : null
        };
    }
}

});
parcelRegister("9FLhs", function(module, exports) {

$parcel$export(module.exports, "NonExistentUserError", () => $e8e12489adc2a8a0$export$80ded96eb3640e1f);
class $e8e12489adc2a8a0$export$80ded96eb3640e1f extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("jOymS", function(module, exports) {

$parcel$export(module.exports, "UserStatusManager", () => $db4af7e21c9da460$export$620694379c7f9fd7);

var $aj4st = parcelRequire("aj4st");

var $lTdpc = parcelRequire("lTdpc");

var $1IWnK = parcelRequire("1IWnK");
class $db4af7e21c9da460$export$620694379c7f9fd7 {
    updatePtRegistrationStatus(newPtStatus) {
        this._ptRegistrationStatus.set(newPtStatus);
    }
    updateHcpStatus(newHcpStatus) {
        this._hcpStatus.set(newHcpStatus);
    }
    updateIdentityStatus(newIdentityStatus) {
        this._identityStatus.set(newIdentityStatus);
    }
    reset() {
        this._ptRegistrationStatus.set(null);
        this._hcpStatus.set(null);
        this._identityStatus.set(null);
    }
    updatePtViewedIntroduction(userId) {
        if ((0, $lTdpc.isNotNil)(userId)) this._registrationStepStore.setItem({
            ...this._registrationStepStore.getItem(),
            [userId]: true
        });
    }
    hasPtViewedIntroduction(userId) {
        const storeItems = this._registrationStepStore.getItem();
        return (0, $lTdpc.isNotNil)(storeItems) && (0, $lTdpc.isNotNil)(userId) && Object.keys(storeItems).includes(userId);
    }
    constructor(){
        this._ptRegistrationStatus = (0, $1IWnK.observable)(null);
        this.ptRegistrationStatus = this._ptRegistrationStatus.readOnly();
        this._hcpStatus = (0, $1IWnK.observable)(null);
        this.hcpStatus = this._hcpStatus.readOnly();
        this._identityStatus = (0, $1IWnK.observable)(null);
        this.identityStatus = this._identityStatus.readOnly();
        this._registrationStepStore = (0, $aj4st.storage).getStore("registrationIntroductionStep", (v)=>v, (v)=>v);
    }
}

});

parcelRegister("iJEAD", function(module, exports) {

$parcel$export(module.exports, "VeevaService", () => $451a98a95b1c49bd$export$b66319704eab80d4);
class $451a98a95b1c49bd$export$b66319704eab80d4 {
    constructor(masterAxiosApiService){
        this.masterAxiosApiService = masterAxiosApiService;
    }
    async getVeevaUserData(veevaId) {
        const result = await this.masterAxiosApiService.get(`/veeva/search/${veevaId}`);
        return result.data;
    }
    async hasVeevaRecord(params) {
        const result = await this.masterAxiosApiService.get("/veeva/exists", {
            params: params
        });
        return result.data.hasVeevaRecord;
    }
}

});

parcelRegister("6cSBm", function(module, exports) {

$parcel$export(module.exports, "MediaType", () => $fb71641da2f52876$export$483c11740a902fcd);
$parcel$export(module.exports, "LearnService", () => $fb71641da2f52876$export$945b4729b8ceb112);
var $fb71641da2f52876$export$483c11740a902fcd;
(function(MediaType) {
    MediaType["ARTICLE"] = "ARTICLE";
    MediaType["VIDEO"] = "VIDEO";
})($fb71641da2f52876$export$483c11740a902fcd || ($fb71641da2f52876$export$483c11740a902fcd = {}));
class $fb71641da2f52876$export$945b4729b8ceb112 {
    constructor(apiService){
        this.apiService = apiService;
        this.rootPath = "/learn";
    }
    async ping() {
        await this.apiService.get(this.rootPath);
    }
    async getItems(page = 0, pageSize = 20, mediaType) {
        const params = {
            page: page,
            pageSize: pageSize
        };
        if (mediaType) params.mediaType = mediaType;
        const result = await this.apiService.get(this.rootPath, {
            params: params
        });
        return result.data;
    }
    async getItem(documentId) {
        const result = await this.apiService.get(`${this.rootPath}/${documentId}`);
        return result.data;
    }
}

});

parcelRegister("7JiF7", function(module, exports) {

$parcel$export(module.exports, "LearnManager", () => $e731655a5a90b284$export$636e3b12827f22d0);

var $1IWnK = parcelRequire("1IWnK");
const $e731655a5a90b284$var$updateObservable = (writableObservable, value)=>{
    if (writableObservable.get() !== value) writableObservable.set(value);
};
class $e731655a5a90b284$export$636e3b12827f22d0 {
    constructor(learnService, userManager){
        this.learnService = learnService;
        this.userManager = userManager;
        this.called = false;
        this._hasItems = (0, $1IWnK.observable)(false);
        this.hasItems = this._hasItems.readOnly();
        this.userManager.user.subscribe((user)=>{
            if (user && !this.called) {
                this.called = true;
                this.callLearn();
            }
            if (!user) this.called = false;
        });
    }
    async callLearn() {
        try {
            // call getItems(0,1) to determine if the Learn endpoint has any items
            const resp = await this.learnService.getItems(0, 1);
            $e731655a5a90b284$var$updateObservable(this._hasItems, resp.totalItems > 0 || resp.items.length > 0);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn("[LearnManager] failed to call learn endpoint", e);
        }
    }
    async getItems(page = 0, pageSize = 20, mediaType) {
        const resp = await this.learnService.getItems(page, pageSize, mediaType);
        if (page === 0 && pageSize === 1 && mediaType === undefined) $e731655a5a90b284$var$updateObservable(this._hasItems, resp.totalItems > 0 || resp.items.length > 0);
        return resp;
    }
    async getItem(documentId) {
        return this.learnService.getItem(documentId);
    }
}

});

parcelRegister("ivrAm", function(module, exports) {

$parcel$export(module.exports, "ExerciseFetchState", () => $7bee9a1a1752456e$export$46b3b165570108c9);
$parcel$export(module.exports, "ExerciseManager", () => $7bee9a1a1752456e$export$c91b8ec7bd28303d);

var $1IWnK = parcelRequire("1IWnK");

var $buI4E = parcelRequire("buI4E");
var $7bee9a1a1752456e$export$46b3b165570108c9;
(function(ExerciseFetchState) {
    ExerciseFetchState[ExerciseFetchState["Undefined"] = 0] = "Undefined";
    ExerciseFetchState[ExerciseFetchState["Available"] = 1] = "Available";
    ExerciseFetchState[ExerciseFetchState["Loading"] = 2] = "Loading";
    ExerciseFetchState[ExerciseFetchState["Error"] = 3] = "Error";
})($7bee9a1a1752456e$export$46b3b165570108c9 || ($7bee9a1a1752456e$export$46b3b165570108c9 = {}));
class $7bee9a1a1752456e$export$c91b8ec7bd28303d {
    constructor(exerciseService){
        this.exerciseService = exerciseService;
        this._exercisesStatus = (0, $1IWnK.observable)(0);
        this.exercisesStatus = this._exercisesStatus.readOnly();
        this._exercises = (0, $1IWnK.observable)([]);
        this.allExercises = this._exercises.readOnly();
        this._exerciseTotalCount = (0, $1IWnK.observable)(0);
        this.exerciseTotalCount = this._exerciseTotalCount.readOnly();
        this.exerciseTotalCount = this._exercises.select((exercises)=>exercises.length);
    }
    async fetchExercises() {
        this._exercisesStatus.set(2);
        try {
            const exercises = await this.exerciseService.listExercises();
            this._exercisesStatus.set(1);
            this._exercises.set((0, $buI4E.orderList)(exercises, "title"));
            this._exerciseTotalCount.set(this._exercises.get().length);
        } catch (e) {
            this._exercisesStatus.set(3);
            throw e;
        }
    }
}

});


parcelRegister("kkH7g", function(module, exports) {

$parcel$export(module.exports, "Global", () => $ecd71edc61375765$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $ecd71edc61375765$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $ecd71edc61375765$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("kh6VF")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("kh6VF")).w);

var $kh6VF = parcelRequire("kh6VF");

var $81g6h = parcelRequire("81g6h");

var $e1iyw = parcelRequire("e1iyw");

var $h4egm = parcelRequire("h4egm");

var $hjFMi = parcelRequire("hjFMi");
parcelRequire("ixOoA");
parcelRequire("gXYXT");
parcelRequire("9py1l");

parcelRequire("khy2w");
var $ecd71edc61375765$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $ecd71edc61375765$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $kh6VF.h).call(props, "css")) // $FlowFixMe
    return $81g6h.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $kh6VF.E);
    createElementArgArray[1] = (0, $kh6VF.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $81g6h.createElement.apply(null, createElementArgArray);
};
var $ecd71edc61375765$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $ecd71edc61375765$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $kh6VF.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $hjFMi.serializeStyles)([
        styles
    ], undefined, $81g6h.useContext((0, $kh6VF.T)));
    if (!(0, $kh6VF.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $81g6h.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $81g6h.useRef();
    (0, $h4egm.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $h4egm.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $e1iyw.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $ecd71edc61375765$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $hjFMi.serializeStyles)(args);
}
var $ecd71edc61375765$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $ecd71edc61375765$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $ecd71edc61375765$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $ecd71edc61375765$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $e1iyw.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $ecd71edc61375765$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $h4egm.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $e1iyw.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $ecd71edc61375765$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $kh6VF.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $hjFMi.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $e1iyw.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $ecd71edc61375765$var$merge(cache.registered, css, $ecd71edc61375765$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $81g6h.useContext((0, $kh6VF.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement($ecd71edc61375765$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $ecd71edc61375765$var$isBrowser, $ecd71edc61375765$var$isTestEnv, $ecd71edc61375765$var$globalContext, $ecd71edc61375765$var$globalKey;

});
parcelRegister("kh6VF", function(module, exports) {

$parcel$export(module.exports, "i", () => $ec2ac5234f177dbf$export$23f2a1d2818174ef);
$parcel$export(module.exports, "h", () => $ec2ac5234f177dbf$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "w", () => $ec2ac5234f177dbf$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $ec2ac5234f177dbf$export$971d5caa766a69d7);
$parcel$export(module.exports, "c", () => $ec2ac5234f177dbf$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $ec2ac5234f177dbf$export$a9c23c6ac3fc3eca);

var $81g6h = parcelRequire("81g6h");

var $ixOoA = parcelRequire("ixOoA");

var $6JG9D = parcelRequire("6JG9D");

var $9py1l = parcelRequire("9py1l");

var $dUOw5 = parcelRequire("dUOw5");

var $e1iyw = parcelRequire("e1iyw");

var $hjFMi = parcelRequire("hjFMi");

var $h4egm = parcelRequire("h4egm");
var $ec2ac5234f177dbf$export$23f2a1d2818174ef = true;
var $ec2ac5234f177dbf$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $ec2ac5234f177dbf$var$EmotionCacheContext = /* #__PURE__ */ $81g6h.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $ixOoA.default)({
    key: "css"
}) : null);
var $ec2ac5234f177dbf$export$e7094788287c5e9b = $ec2ac5234f177dbf$var$EmotionCacheContext.Provider;
var $ec2ac5234f177dbf$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $81g6h.useContext)($ec2ac5234f177dbf$var$EmotionCacheContext);
};
var $ec2ac5234f177dbf$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $81g6h.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $81g6h.useContext)($ec2ac5234f177dbf$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$ec2ac5234f177dbf$export$23f2a1d2818174ef) $ec2ac5234f177dbf$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $81g6h.useContext)($ec2ac5234f177dbf$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $ixOoA.default)({
                key: "css"
            });
            return /*#__PURE__*/ $81g6h.createElement($ec2ac5234f177dbf$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $ec2ac5234f177dbf$export$971d5caa766a69d7 = /* #__PURE__ */ $81g6h.createContext({});
var $ec2ac5234f177dbf$export$3b14a55fb2447963 = function useTheme() {
    return $81g6h.useContext($ec2ac5234f177dbf$export$971d5caa766a69d7);
};
var $ec2ac5234f177dbf$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $6JG9D.default)({}, outerTheme, theme);
};
var $ec2ac5234f177dbf$var$createCacheWithTheme = /* #__PURE__ */ (0, $9py1l.default)(function(outerTheme) {
    return (0, $9py1l.default)(function(theme) {
        return $ec2ac5234f177dbf$var$getTheme(outerTheme, theme);
    });
});
var $ec2ac5234f177dbf$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $81g6h.useContext($ec2ac5234f177dbf$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $ec2ac5234f177dbf$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $81g6h.createElement($ec2ac5234f177dbf$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $ec2ac5234f177dbf$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $81g6h.useContext($ec2ac5234f177dbf$export$971d5caa766a69d7);
        return /*#__PURE__*/ $81g6h.createElement(Component, (0, $6JG9D.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $81g6h.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $dUOw5.default)(WithTheme, Component);
}
var $ec2ac5234f177dbf$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $ec2ac5234f177dbf$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $ec2ac5234f177dbf$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $ec2ac5234f177dbf$var$getLastPart(match[1]);
    return undefined;
};
var $ec2ac5234f177dbf$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $ec2ac5234f177dbf$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $ec2ac5234f177dbf$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $ec2ac5234f177dbf$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($ec2ac5234f177dbf$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $ec2ac5234f177dbf$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $ec2ac5234f177dbf$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $ec2ac5234f177dbf$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $ec2ac5234f177dbf$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($ec2ac5234f177dbf$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$ec2ac5234f177dbf$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $ec2ac5234f177dbf$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $e1iyw.registerStyles)(cache, serialized, isStringTag);
    (0, $h4egm.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $e1iyw.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $ec2ac5234f177dbf$var$Emotion = /* #__PURE__ */ $ec2ac5234f177dbf$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$ec2ac5234f177dbf$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $e1iyw.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $hjFMi.serializeStyles)(registeredStyles, undefined, $81g6h.useContext($ec2ac5234f177dbf$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($ec2ac5234f177dbf$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $ec2ac5234f177dbf$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement($ec2ac5234f177dbf$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $81g6h.createElement(WrappedComponent, newProps));
});
var $ec2ac5234f177dbf$export$a9c23c6ac3fc3eca = $ec2ac5234f177dbf$var$Emotion;

});
parcelRegister("ixOoA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8026696c9059f6e$export$2e2bcd8739ae039);

var $3m574 = parcelRequire("3m574");

var $flbYS = parcelRequire("flbYS");
parcelRequire("9py1l");
parcelRequire("5JzA5");
var $d8026696c9059f6e$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $flbYS.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $flbYS.token)(character)) break;
        (0, $flbYS.next)();
    }
    return (0, $flbYS.slice)(begin, (0, $flbYS.position));
};
var $d8026696c9059f6e$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $flbYS.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $flbYS.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $d8026696c9059f6e$var$identifierWithPointTracking((0, $flbYS.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $flbYS.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $flbYS.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $flbYS.from)(character);
    }
    while (character = (0, $flbYS.next)());
    return parsed;
};
var $d8026696c9059f6e$var$getRules = function getRules(value, points) {
    return (0, $flbYS.dealloc)($d8026696c9059f6e$var$toRules((0, $flbYS.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $d8026696c9059f6e$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $d8026696c9059f6e$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$d8026696c9059f6e$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $d8026696c9059f6e$var$fixedElements.set(element, true);
    var points = [];
    var rules = $d8026696c9059f6e$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $d8026696c9059f6e$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $d8026696c9059f6e$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $d8026696c9059f6e$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($d8026696c9059f6e$var$ignoreFlag) > -1;
};
var $d8026696c9059f6e$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($d8026696c9059f6e$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $d8026696c9059f6e$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $d8026696c9059f6e$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$d8026696c9059f6e$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $d8026696c9059f6e$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $d8026696c9059f6e$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$d8026696c9059f6e$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $d8026696c9059f6e$var$nullifyElement(element);
    } else if ($d8026696c9059f6e$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $d8026696c9059f6e$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $d8026696c9059f6e$var$prefix(value, length) {
    switch((0, $flbYS.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $flbYS.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $flbYS.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $flbYS.WEBKIT) + value + (0, $flbYS.MOZ) + value + (0, $flbYS.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $flbYS.WEBKIT) + value + (0, $flbYS.MS) + value + value;
        // order
        case 6165:
            return (0, $flbYS.WEBKIT) + value + (0, $flbYS.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $flbYS.WEBKIT) + value + (0, $flbYS.replace)(value, /(\w+).+(:[^]+)/, (0, $flbYS.WEBKIT) + "box-$1$2" + (0, $flbYS.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $flbYS.WEBKIT) + value + (0, $flbYS.MS) + "flex-item-" + (0, $flbYS.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $flbYS.WEBKIT) + value + (0, $flbYS.MS) + "flex-line-pack" + (0, $flbYS.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $flbYS.WEBKIT) + value + (0, $flbYS.MS) + (0, $flbYS.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $flbYS.WEBKIT) + value + (0, $flbYS.MS) + (0, $flbYS.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $flbYS.WEBKIT) + "box-" + (0, $flbYS.replace)(value, "-grow", "") + (0, $flbYS.WEBKIT) + value + (0, $flbYS.MS) + (0, $flbYS.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $flbYS.WEBKIT) + (0, $flbYS.replace)(value, /([^-])(transform)/g, "$1" + (0, $flbYS.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $flbYS.replace)((0, $flbYS.replace)((0, $flbYS.replace)(value, /(zoom-|grab)/, (0, $flbYS.WEBKIT) + "$1"), /(image-set)/, (0, $flbYS.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $flbYS.replace)(value, /(image-set\([^]*)/, (0, $flbYS.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $flbYS.replace)((0, $flbYS.replace)(value, /(.+:)(flex-)?(.*)/, (0, $flbYS.WEBKIT) + "box-pack:$3" + (0, $flbYS.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $flbYS.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $flbYS.replace)(value, /(.+)-inline(.+)/, (0, $flbYS.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $flbYS.strlen)(value) - 1 - length > 6) switch((0, $flbYS.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $flbYS.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $flbYS.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $flbYS.WEBKIT) + "$2-$3" + "$1" + (0, $flbYS.MOZ) + ((0, $flbYS.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $flbYS.indexof)(value, "stretch") ? $d8026696c9059f6e$var$prefix((0, $flbYS.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $flbYS.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $flbYS.charat)(value, (0, $flbYS.strlen)(value) - 3 - (~(0, $flbYS.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $flbYS.replace)(value, ":", ":" + (0, $flbYS.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $flbYS.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $flbYS.WEBKIT) + ((0, $flbYS.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $flbYS.WEBKIT) + "$2$3" + "$1" + (0, $flbYS.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $flbYS.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $flbYS.WEBKIT) + value + (0, $flbYS.MS) + (0, $flbYS.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $flbYS.WEBKIT) + value + (0, $flbYS.MS) + (0, $flbYS.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $flbYS.WEBKIT) + value + (0, $flbYS.MS) + (0, $flbYS.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $flbYS.WEBKIT) + value + (0, $flbYS.MS) + value + value;
    }
    return value;
}
var $d8026696c9059f6e$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $flbYS.DECLARATION:
                element["return"] = $d8026696c9059f6e$var$prefix(element.value, element.length);
                break;
            case 0, $flbYS.KEYFRAMES:
                return (0, $flbYS.serialize)([
                    (0, $flbYS.copy)(element, {
                        value: (0, $flbYS.replace)(element.value, "@", "@" + (0, $flbYS.WEBKIT))
                    })
                ], callback);
            case 0, $flbYS.RULESET:
                if (element.length) return (0, $flbYS.combine)(element.props, function(value) {
                    switch((0, $flbYS.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $flbYS.serialize)([
                                (0, $flbYS.copy)(element, {
                                    props: [
                                        (0, $flbYS.replace)(value, /:(read-\w+)/, ":" + (0, $flbYS.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $flbYS.serialize)([
                                (0, $flbYS.copy)(element, {
                                    props: [
                                        (0, $flbYS.replace)(value, /:(plac\w+)/, ":" + (0, $flbYS.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $flbYS.copy)(element, {
                                    props: [
                                        (0, $flbYS.replace)(value, /:(plac\w+)/, ":" + (0, $flbYS.MOZ) + "$1")
                                    ]
                                }),
                                (0, $flbYS.copy)(element, {
                                    props: [
                                        (0, $flbYS.replace)(value, /:(plac\w+)/, (0, $flbYS.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $d8026696c9059f6e$var$defaultStylisPlugins = [
    $d8026696c9059f6e$var$prefixer
];
var $d8026696c9059f6e$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $d8026696c9059f6e$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $d8026696c9059f6e$var$compat,
        $d8026696c9059f6e$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $flbYS.stringify),
        (0, $flbYS.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $flbYS.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $flbYS.serialize)((0, $flbYS.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $3m574.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("3m574", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $2717648080cc3e82$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $2717648080cc3e82$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $2717648080cc3e82$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $2717648080cc3e82$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($2717648080cc3e82$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $2717648080cc3e82$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("flbYS", function(module, exports) {

$parcel$export(module.exports, "MS", () => $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $f4f84acc3cd3d7bc$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $f4f84acc3cd3d7bc$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $f4f84acc3cd3d7bc$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $f4f84acc3cd3d7bc$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $f4f84acc3cd3d7bc$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $f4f84acc3cd3d7bc$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $f4f84acc3cd3d7bc$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $f4f84acc3cd3d7bc$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $f4f84acc3cd3d7bc$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $f4f84acc3cd3d7bc$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $f4f84acc3cd3d7bc$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $f4f84acc3cd3d7bc$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $f4f84acc3cd3d7bc$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $f4f84acc3cd3d7bc$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $f4f84acc3cd3d7bc$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $f4f84acc3cd3d7bc$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $f4f84acc3cd3d7bc$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $f4f84acc3cd3d7bc$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $f4f84acc3cd3d7bc$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $f4f84acc3cd3d7bc$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $f4f84acc3cd3d7bc$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $f4f84acc3cd3d7bc$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $f4f84acc3cd3d7bc$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $f4f84acc3cd3d7bc$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $f4f84acc3cd3d7bc$export$38bcb760f1d4871c);
var $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 = "-ms-";
var $f4f84acc3cd3d7bc$export$2c0f367103c8d01c = "-moz-";
var $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 = "-webkit-";
var $f4f84acc3cd3d7bc$export$a29989082612d0d9 = "comm";
var $f4f84acc3cd3d7bc$export$aa3a2e812ca8570d = "rule";
var $f4f84acc3cd3d7bc$export$527d108ccf083c2b = "decl";
var $f4f84acc3cd3d7bc$export$d3d35020fa5b54f0 = "@page";
var $f4f84acc3cd3d7bc$export$500415a86c544f73 = "@media";
var $f4f84acc3cd3d7bc$export$a763edbf796b780a = "@import";
var $f4f84acc3cd3d7bc$export$2790aeb8b4e5c826 = "@charset";
var $f4f84acc3cd3d7bc$export$1cc683e23b84b133 = "@viewport";
var $f4f84acc3cd3d7bc$export$9447a5efea57e862 = "@supports";
var $f4f84acc3cd3d7bc$export$ef011b4e114b1fba = "@document";
var $f4f84acc3cd3d7bc$export$6aad947bda0f3f46 = "@namespace";
var $f4f84acc3cd3d7bc$export$b44a8529a35fcb60 = "@keyframes";
var $f4f84acc3cd3d7bc$export$2c16de31893252e6 = "@font-face";
var $f4f84acc3cd3d7bc$export$3d846dd52e150c6f = "@counter-style";
var $f4f84acc3cd3d7bc$export$22314bfbb57653fe = "@font-feature-values";
var $f4f84acc3cd3d7bc$export$d773506282b3cfe6 = "@layer";
var $f4f84acc3cd3d7bc$export$2335f513bbd82c6d = Math.abs;
var $f4f84acc3cd3d7bc$export$6788812c4e6611e6 = String.fromCharCode;
var $f4f84acc3cd3d7bc$export$e6e34fd1f2686227 = Object.assign;
function $f4f84acc3cd3d7bc$export$d6af199866bfb566(e, r) {
    return $f4f84acc3cd3d7bc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $f4f84acc3cd3d7bc$export$a9db5e087081082d(e, 0)) << 2 ^ $f4f84acc3cd3d7bc$export$a9db5e087081082d(e, 1)) << 2 ^ $f4f84acc3cd3d7bc$export$a9db5e087081082d(e, 2)) << 2 ^ $f4f84acc3cd3d7bc$export$a9db5e087081082d(e, 3) : 0;
}
function $f4f84acc3cd3d7bc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $f4f84acc3cd3d7bc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $f4f84acc3cd3d7bc$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $f4f84acc3cd3d7bc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $f4f84acc3cd3d7bc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $f4f84acc3cd3d7bc$export$36776f635604f274(e) {
    return e.length;
}
function $f4f84acc3cd3d7bc$export$f9084667e487ed46(e) {
    return e.length;
}
function $f4f84acc3cd3d7bc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $f4f84acc3cd3d7bc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $f4f84acc3cd3d7bc$export$53f1d5ea8de3d7c = 1;
var $f4f84acc3cd3d7bc$export$4e0c71f277ca26b3 = 1;
var $f4f84acc3cd3d7bc$export$f24224f1c91d8156 = 0;
var $f4f84acc3cd3d7bc$export$5880b8b5730aff45 = 0;
var $f4f84acc3cd3d7bc$export$c0306caf338ac095 = 0;
var $f4f84acc3cd3d7bc$export$30a86d91af8ff6e6 = "";
function $f4f84acc3cd3d7bc$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $f4f84acc3cd3d7bc$export$53f1d5ea8de3d7c,
        column: $f4f84acc3cd3d7bc$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $f4f84acc3cd3d7bc$export$784d13d8ee351f07(e, r) {
    return $f4f84acc3cd3d7bc$export$e6e34fd1f2686227($f4f84acc3cd3d7bc$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $f4f84acc3cd3d7bc$export$eba6f6f03b0a92e7() {
    return $f4f84acc3cd3d7bc$export$c0306caf338ac095;
}
function $f4f84acc3cd3d7bc$export$232faf9add678146() {
    $f4f84acc3cd3d7bc$export$c0306caf338ac095 = $f4f84acc3cd3d7bc$export$5880b8b5730aff45 > 0 ? $f4f84acc3cd3d7bc$export$a9db5e087081082d($f4f84acc3cd3d7bc$export$30a86d91af8ff6e6, --$f4f84acc3cd3d7bc$export$5880b8b5730aff45) : 0;
    if ($f4f84acc3cd3d7bc$export$4e0c71f277ca26b3--, $f4f84acc3cd3d7bc$export$c0306caf338ac095 === 10) $f4f84acc3cd3d7bc$export$4e0c71f277ca26b3 = 1, $f4f84acc3cd3d7bc$export$53f1d5ea8de3d7c--;
    return $f4f84acc3cd3d7bc$export$c0306caf338ac095;
}
function $f4f84acc3cd3d7bc$export$48cfd1e771a65c4f() {
    $f4f84acc3cd3d7bc$export$c0306caf338ac095 = $f4f84acc3cd3d7bc$export$5880b8b5730aff45 < $f4f84acc3cd3d7bc$export$f24224f1c91d8156 ? $f4f84acc3cd3d7bc$export$a9db5e087081082d($f4f84acc3cd3d7bc$export$30a86d91af8ff6e6, $f4f84acc3cd3d7bc$export$5880b8b5730aff45++) : 0;
    if ($f4f84acc3cd3d7bc$export$4e0c71f277ca26b3++, $f4f84acc3cd3d7bc$export$c0306caf338ac095 === 10) $f4f84acc3cd3d7bc$export$4e0c71f277ca26b3 = 1, $f4f84acc3cd3d7bc$export$53f1d5ea8de3d7c++;
    return $f4f84acc3cd3d7bc$export$c0306caf338ac095;
}
function $f4f84acc3cd3d7bc$export$4d3fb11e950abb9e() {
    return $f4f84acc3cd3d7bc$export$a9db5e087081082d($f4f84acc3cd3d7bc$export$30a86d91af8ff6e6, $f4f84acc3cd3d7bc$export$5880b8b5730aff45);
}
function $f4f84acc3cd3d7bc$export$e88cb2efb12ae807() {
    return $f4f84acc3cd3d7bc$export$5880b8b5730aff45;
}
function $f4f84acc3cd3d7bc$export$58adb3bec8346d0f(e, r) {
    return $f4f84acc3cd3d7bc$export$2f35ab04d2335697($f4f84acc3cd3d7bc$export$30a86d91af8ff6e6, e, r);
}
function $f4f84acc3cd3d7bc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f4f84acc3cd3d7bc$export$2de70f21292aac9e(e) {
    return $f4f84acc3cd3d7bc$export$53f1d5ea8de3d7c = $f4f84acc3cd3d7bc$export$4e0c71f277ca26b3 = 1, $f4f84acc3cd3d7bc$export$f24224f1c91d8156 = $f4f84acc3cd3d7bc$export$36776f635604f274($f4f84acc3cd3d7bc$export$30a86d91af8ff6e6 = e), $f4f84acc3cd3d7bc$export$5880b8b5730aff45 = 0, [];
}
function $f4f84acc3cd3d7bc$export$45918ac1574455b1(e) {
    return $f4f84acc3cd3d7bc$export$30a86d91af8ff6e6 = "", e;
}
function $f4f84acc3cd3d7bc$export$410ac95b9ec204b8(e) {
    return $f4f84acc3cd3d7bc$export$87c2784dc9fc4ab($f4f84acc3cd3d7bc$export$58adb3bec8346d0f($f4f84acc3cd3d7bc$export$5880b8b5730aff45 - 1, $f4f84acc3cd3d7bc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $f4f84acc3cd3d7bc$export$660b2ee2d4fb4eff(e) {
    return $f4f84acc3cd3d7bc$export$45918ac1574455b1($f4f84acc3cd3d7bc$export$5f8c09e3ae6f64e1($f4f84acc3cd3d7bc$export$2de70f21292aac9e(e)));
}
function $f4f84acc3cd3d7bc$export$7af1228ff777d175(e) {
    while($f4f84acc3cd3d7bc$export$c0306caf338ac095 = $f4f84acc3cd3d7bc$export$4d3fb11e950abb9e())if ($f4f84acc3cd3d7bc$export$c0306caf338ac095 < 33) $f4f84acc3cd3d7bc$export$48cfd1e771a65c4f();
    else break;
    return $f4f84acc3cd3d7bc$export$9e1725a4cfeada27(e) > 2 || $f4f84acc3cd3d7bc$export$9e1725a4cfeada27($f4f84acc3cd3d7bc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $f4f84acc3cd3d7bc$export$5f8c09e3ae6f64e1(e) {
    while($f4f84acc3cd3d7bc$export$48cfd1e771a65c4f())switch($f4f84acc3cd3d7bc$export$9e1725a4cfeada27($f4f84acc3cd3d7bc$export$c0306caf338ac095)){
        case 0:
            $f4f84acc3cd3d7bc$export$10d8903dec122b9d($f4f84acc3cd3d7bc$export$c2ab62c7bf24634($f4f84acc3cd3d7bc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $f4f84acc3cd3d7bc$export$10d8903dec122b9d($f4f84acc3cd3d7bc$export$410ac95b9ec204b8($f4f84acc3cd3d7bc$export$c0306caf338ac095), e);
            break;
        default:
            $f4f84acc3cd3d7bc$export$10d8903dec122b9d($f4f84acc3cd3d7bc$export$6788812c4e6611e6($f4f84acc3cd3d7bc$export$c0306caf338ac095), e);
    }
    return e;
}
function $f4f84acc3cd3d7bc$export$955ba06d119e085e(e, r) {
    while(--r && $f4f84acc3cd3d7bc$export$48cfd1e771a65c4f())if ($f4f84acc3cd3d7bc$export$c0306caf338ac095 < 48 || $f4f84acc3cd3d7bc$export$c0306caf338ac095 > 102 || $f4f84acc3cd3d7bc$export$c0306caf338ac095 > 57 && $f4f84acc3cd3d7bc$export$c0306caf338ac095 < 65 || $f4f84acc3cd3d7bc$export$c0306caf338ac095 > 70 && $f4f84acc3cd3d7bc$export$c0306caf338ac095 < 97) break;
    return $f4f84acc3cd3d7bc$export$58adb3bec8346d0f(e, $f4f84acc3cd3d7bc$export$e88cb2efb12ae807() + (r < 6 && $f4f84acc3cd3d7bc$export$4d3fb11e950abb9e() == 32 && $f4f84acc3cd3d7bc$export$48cfd1e771a65c4f() == 32));
}
function $f4f84acc3cd3d7bc$export$c889f2fcc19dbf12(e) {
    while($f4f84acc3cd3d7bc$export$48cfd1e771a65c4f())switch($f4f84acc3cd3d7bc$export$c0306caf338ac095){
        case e:
            return $f4f84acc3cd3d7bc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $f4f84acc3cd3d7bc$export$c889f2fcc19dbf12($f4f84acc3cd3d7bc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $f4f84acc3cd3d7bc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $f4f84acc3cd3d7bc$export$48cfd1e771a65c4f();
            break;
    }
    return $f4f84acc3cd3d7bc$export$5880b8b5730aff45;
}
function $f4f84acc3cd3d7bc$export$4254d4e2b3745c4c(e, r) {
    while($f4f84acc3cd3d7bc$export$48cfd1e771a65c4f())if (e + $f4f84acc3cd3d7bc$export$c0306caf338ac095 === 57) break;
    else if (e + $f4f84acc3cd3d7bc$export$c0306caf338ac095 === 84 && $f4f84acc3cd3d7bc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $f4f84acc3cd3d7bc$export$58adb3bec8346d0f(r, $f4f84acc3cd3d7bc$export$5880b8b5730aff45 - 1) + "*" + $f4f84acc3cd3d7bc$export$6788812c4e6611e6(e === 47 ? e : $f4f84acc3cd3d7bc$export$48cfd1e771a65c4f());
}
function $f4f84acc3cd3d7bc$export$c2ab62c7bf24634(e) {
    while(!$f4f84acc3cd3d7bc$export$9e1725a4cfeada27($f4f84acc3cd3d7bc$export$4d3fb11e950abb9e()))$f4f84acc3cd3d7bc$export$48cfd1e771a65c4f();
    return $f4f84acc3cd3d7bc$export$58adb3bec8346d0f(e, $f4f84acc3cd3d7bc$export$5880b8b5730aff45);
}
function $f4f84acc3cd3d7bc$export$ef7acd7185315e22(e) {
    return $f4f84acc3cd3d7bc$export$45918ac1574455b1($f4f84acc3cd3d7bc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $f4f84acc3cd3d7bc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $f4f84acc3cd3d7bc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $f4f84acc3cd3d7bc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $f4f84acc3cd3d7bc$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($f4f84acc3cd3d7bc$export$f8e21b1e77979a08(j += $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed($f4f84acc3cd3d7bc$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $f4f84acc3cd3d7bc$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $f4f84acc3cd3d7bc$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $f4f84acc3cd3d7bc$export$955ba06d119e085e($f4f84acc3cd3d7bc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($f4f84acc3cd3d7bc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $f4f84acc3cd3d7bc$export$10d8903dec122b9d($f4f84acc3cd3d7bc$export$4a34f930e789283c($f4f84acc3cd3d7bc$export$4254d4e2b3745c4c($f4f84acc3cd3d7bc$export$48cfd1e771a65c4f(), $f4f84acc3cd3d7bc$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $f4f84acc3cd3d7bc$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $f4f84acc3cd3d7bc$export$36776f635604f274(j) - l) $f4f84acc3cd3d7bc$export$10d8903dec122b9d(p > 32 ? $f4f84acc3cd3d7bc$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $f4f84acc3cd3d7bc$export$f8483753829ec8f3($f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $f4f84acc3cd3d7bc$export$10d8903dec122b9d(y = $f4f84acc3cd3d7bc$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $f4f84acc3cd3d7bc$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $f4f84acc3cd3d7bc$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $f4f84acc3cd3d7bc$export$98e6a39c04603d36(e, y, y, n && $f4f84acc3cd3d7bc$export$10d8903dec122b9d($f4f84acc3cd3d7bc$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $f4f84acc3cd3d7bc$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $f4f84acc3cd3d7bc$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $f4f84acc3cd3d7bc$export$232faf9add678146() == 125) continue;
            }
            switch(j += $f4f84acc3cd3d7bc$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($f4f84acc3cd3d7bc$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($f4f84acc3cd3d7bc$export$4d3fb11e950abb9e() === 45) j += $f4f84acc3cd3d7bc$export$410ac95b9ec204b8($f4f84acc3cd3d7bc$export$48cfd1e771a65c4f());
                    v = $f4f84acc3cd3d7bc$export$4d3fb11e950abb9e(), o = l = $f4f84acc3cd3d7bc$export$36776f635604f274(g = j += $f4f84acc3cd3d7bc$export$c2ab62c7bf24634($f4f84acc3cd3d7bc$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $f4f84acc3cd3d7bc$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $f4f84acc3cd3d7bc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $f4f84acc3cd3d7bc$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $f4f84acc3cd3d7bc$export$2f35ab04d2335697(e, v + 1, v = $f4f84acc3cd3d7bc$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $f4f84acc3cd3d7bc$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $f4f84acc3cd3d7bc$export$35059013cd4a06db(e, r, a, s === 0 ? $f4f84acc3cd3d7bc$export$aa3a2e812ca8570d : i, f, o, l);
}
function $f4f84acc3cd3d7bc$export$4a34f930e789283c(e, r, a) {
    return $f4f84acc3cd3d7bc$export$35059013cd4a06db(e, r, a, $f4f84acc3cd3d7bc$export$a29989082612d0d9, $f4f84acc3cd3d7bc$export$6788812c4e6611e6($f4f84acc3cd3d7bc$export$eba6f6f03b0a92e7()), $f4f84acc3cd3d7bc$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $f4f84acc3cd3d7bc$export$f8483753829ec8f3(e, r, a, n) {
    return $f4f84acc3cd3d7bc$export$35059013cd4a06db(e, r, a, $f4f84acc3cd3d7bc$export$527d108ccf083c2b, $f4f84acc3cd3d7bc$export$2f35ab04d2335697(e, 0, n), $f4f84acc3cd3d7bc$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $f4f84acc3cd3d7bc$export$82e9f45cca5ba907(n, c, s) {
    switch($f4f84acc3cd3d7bc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $f4f84acc3cd3d7bc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + n + $f4f84acc3cd3d7bc$export$2c0f367103c8d01c + n + $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($f4f84acc3cd3d7bc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + n + $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + n + $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + n + $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + n + $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + n + $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + n + $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + "box-$1$2" + $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + n + $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + "flex-item-" + $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$f4f84acc3cd3d7bc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + "grid-row-" + $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + n + $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + "flex-line-pack" + $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + n + $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + n + $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + "box-" + $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + n + $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed($f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed($f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed($f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + "box-pack:$3" + $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$f4f84acc3cd3d7bc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + "grid-column-align" + $f4f84acc3cd3d7bc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $f4f84acc3cd3d7bc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$f4f84acc3cd3d7bc$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$f4f84acc3cd3d7bc$export$f8e21b1e77979a08(s, "span") ? $f4f84acc3cd3d7bc$export$4659b591c19bdf3d(s, /\d+/) : +$f4f84acc3cd3d7bc$export$4659b591c19bdf3d(s, /\d+/) - +$f4f84acc3cd3d7bc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $f4f84acc3cd3d7bc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed($f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($f4f84acc3cd3d7bc$export$36776f635604f274(n) - 1 - c > 6) switch($f4f84acc3cd3d7bc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($f4f84acc3cd3d7bc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $f4f84acc3cd3d7bc$export$2c0f367103c8d01c + ($f4f84acc3cd3d7bc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$f4f84acc3cd3d7bc$export$f8e21b1e77979a08(n, "stretch") ? $f4f84acc3cd3d7bc$export$82e9f45cca5ba907($f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($f4f84acc3cd3d7bc$export$a9db5e087081082d(n, c + 6) === 121) return $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, ":", ":" + $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($f4f84acc3cd3d7bc$export$a9db5e087081082d(n, $f4f84acc3cd3d7bc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + ($f4f84acc3cd3d7bc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, ":", ":" + $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $f4f84acc3cd3d7bc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $f4f84acc3cd3d7bc$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $f4f84acc3cd3d7bc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $f4f84acc3cd3d7bc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $f4f84acc3cd3d7bc$export$a763edbf796b780a:
        case $f4f84acc3cd3d7bc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $f4f84acc3cd3d7bc$export$a29989082612d0d9:
            return "";
        case $f4f84acc3cd3d7bc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $f4f84acc3cd3d7bc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $f4f84acc3cd3d7bc$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $f4f84acc3cd3d7bc$export$36776f635604f274(a = $f4f84acc3cd3d7bc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $f4f84acc3cd3d7bc$export$5a7767152ae0305f(e) {
    var r = $f4f84acc3cd3d7bc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $f4f84acc3cd3d7bc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $f4f84acc3cd3d7bc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $f4f84acc3cd3d7bc$export$527d108ccf083c2b:
                n.return = $f4f84acc3cd3d7bc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $f4f84acc3cd3d7bc$export$b44a8529a35fcb60:
                return $f4f84acc3cd3d7bc$export$dfdc1655ccc5b9cb([
                    $f4f84acc3cd3d7bc$export$784d13d8ee351f07(n, {
                        value: $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $f4f84acc3cd3d7bc$export$aa3a2e812ca8570d:
                if (n.length) return $f4f84acc3cd3d7bc$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($f4f84acc3cd3d7bc$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $f4f84acc3cd3d7bc$export$dfdc1655ccc5b9cb([
                                $f4f84acc3cd3d7bc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $f4f84acc3cd3d7bc$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $f4f84acc3cd3d7bc$export$dfdc1655ccc5b9cb([
                                $f4f84acc3cd3d7bc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $f4f84acc3cd3d7bc$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $f4f84acc3cd3d7bc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $f4f84acc3cd3d7bc$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $f4f84acc3cd3d7bc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f4f84acc3cd3d7bc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $f4f84acc3cd3d7bc$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $f4f84acc3cd3d7bc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $f4f84acc3cd3d7bc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $f4f84acc3cd3d7bc$export$1be1fc439b849fdf($f4f84acc3cd3d7bc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($f4f84acc3cd3d7bc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $f4f84acc3cd3d7bc$export$2f35ab04d2335697(r, 1, $f4f84acc3cd3d7bc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $f4f84acc3cd3d7bc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $f4f84acc3cd3d7bc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $f4f84acc3cd3d7bc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("9py1l", function(module, exports) {

$parcel$export(module.exports, "default", () => $6da0d6ae598a74b7$export$2e2bcd8739ae039);
var $6da0d6ae598a74b7$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("5JzA5", function(module, exports) {

$parcel$export(module.exports, "default", () => $42ccc165b847f427$export$2e2bcd8739ae039);
function $42ccc165b847f427$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("6JG9D", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e77a506dfc0fa98$export$2e2bcd8739ae039);
function $4e77a506dfc0fa98$export$2e2bcd8739ae039() {
    return $4e77a506dfc0fa98$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4e77a506dfc0fa98$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("dUOw5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a217b0d499f9b480$export$2e2bcd8739ae039);

var $khy2w = parcelRequire("khy2w");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $a217b0d499f9b480$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($khy2w)))(targetComponent, sourceComponent);
};

});

parcelRegister("e1iyw", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $a34f8d7da9bd746d$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $a34f8d7da9bd746d$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $a34f8d7da9bd746d$export$6f077d94b33a01aa);
var $a34f8d7da9bd746d$var$isBrowser = true;
function $a34f8d7da9bd746d$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $a34f8d7da9bd746d$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $a34f8d7da9bd746d$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $a34f8d7da9bd746d$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $a34f8d7da9bd746d$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("hjFMi", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $c9b49e3ae5ac5033$export$6321afa313b251b5);

var $eHg7y = parcelRequire("eHg7y");

var $cmsno = parcelRequire("cmsno");

var $5JzA5 = parcelRequire("5JzA5");
var $c9b49e3ae5ac5033$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $c9b49e3ae5ac5033$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $c9b49e3ae5ac5033$var$hyphenateRegex = /[A-Z]|^ms/g;
var $c9b49e3ae5ac5033$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $c9b49e3ae5ac5033$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $c9b49e3ae5ac5033$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $c9b49e3ae5ac5033$var$processStyleName = /* #__PURE__ */ (0, $5JzA5.default)(function(styleName) {
    return $c9b49e3ae5ac5033$var$isCustomProperty(styleName) ? styleName : styleName.replace($c9b49e3ae5ac5033$var$hyphenateRegex, "-$&").toLowerCase();
});
var $c9b49e3ae5ac5033$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($c9b49e3ae5ac5033$var$animationRegex, function(match, p1, p2) {
                $c9b49e3ae5ac5033$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $c9b49e3ae5ac5033$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cmsno.default)[key] !== 1 && !$c9b49e3ae5ac5033$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $c9b49e3ae5ac5033$var$contentValuePattern, $c9b49e3ae5ac5033$var$contentValues, $c9b49e3ae5ac5033$var$oldProcessStyleValue, $c9b49e3ae5ac5033$var$msPattern, $c9b49e3ae5ac5033$var$hyphenPattern, $c9b49e3ae5ac5033$var$hyphenatedCache;
var $c9b49e3ae5ac5033$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $c9b49e3ae5ac5033$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $c9b49e3ae5ac5033$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $c9b49e3ae5ac5033$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $c9b49e3ae5ac5033$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $c9b49e3ae5ac5033$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $c9b49e3ae5ac5033$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $c9b49e3ae5ac5033$var$cursor;
                var result = interpolation(mergedProps);
                $c9b49e3ae5ac5033$var$cursor = previousCursor;
                return $c9b49e3ae5ac5033$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $c9b49e3ae5ac5033$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $c9b49e3ae5ac5033$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($c9b49e3ae5ac5033$var$isProcessableValue(value)) string += $c9b49e3ae5ac5033$var$processStyleName(_key) + ":" + $c9b49e3ae5ac5033$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($c9b49e3ae5ac5033$var$isProcessableValue(value[_i])) string += $c9b49e3ae5ac5033$var$processStyleName(_key) + ":" + $c9b49e3ae5ac5033$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $c9b49e3ae5ac5033$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $c9b49e3ae5ac5033$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $c9b49e3ae5ac5033$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $c9b49e3ae5ac5033$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $c9b49e3ae5ac5033$var$cursor;
var $c9b49e3ae5ac5033$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $c9b49e3ae5ac5033$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $c9b49e3ae5ac5033$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $c9b49e3ae5ac5033$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $c9b49e3ae5ac5033$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $c9b49e3ae5ac5033$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $eHg7y.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $c9b49e3ae5ac5033$var$cursor
    };
};

});
parcelRegister("eHg7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab31961cff9056a8$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $ab31961cff9056a8$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cmsno", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ffd8d108be20424$export$2e2bcd8739ae039);
var $8ffd8d108be20424$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("h4egm", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $c6cddfb065c50656$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $c6cddfb065c50656$export$811a713a7276cb9d);

var $81g6h = parcelRequire("81g6h");
var $c6cddfb065c50656$var$syncFallback = function syncFallback(create) {
    return create();
};
var $c6cddfb065c50656$var$useInsertionEffect = $81g6h.useInsertionEffect ? $81g6h.useInsertionEffect : false;
var $c6cddfb065c50656$export$db21c7ffa21794e7 = $c6cddfb065c50656$var$useInsertionEffect || $c6cddfb065c50656$var$syncFallback;
var $c6cddfb065c50656$export$811a713a7276cb9d = $c6cddfb065c50656$var$useInsertionEffect || $81g6h.useLayoutEffect;

});


parcelRegister("gXYXT", function(module, exports) {
function $c5a172650876712c$var$_extends() {
    return module.exports = $c5a172650876712c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $c5a172650876712c$var$_extends.apply(null, arguments);
}
module.exports = $c5a172650876712c$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9pHcQ", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);

var $j1fad = parcelRequire("j1fad");

var $lMUAO = parcelRequire("lMUAO");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $j1fad.isBrowserBundle)() && Object.prototype.toString.call(typeof $lMUAO !== "undefined" ? $lMUAO : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("j1fad", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $dd89df87edc080bf$export$2928c40372e623c0);
$parcel$export(module.exports, "getSDKSource", () => $dd89df87edc080bf$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $dd89df87edc080bf$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $dd89df87edc080bf$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});


parcelRegister("5UMQ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44e810ee7bc6f48a$export$2e2bcd8739ae039);

var $lzJFw = parcelRequire("lzJFw");
parcelRequire("gXYXT");
parcelRequire("81g6h");
parcelRequire("l4JUy");

parcelRequire("e1iyw");
parcelRequire("hjFMi");
parcelRequire("h4egm");
var $44e810ee7bc6f48a$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $44e810ee7bc6f48a$export$2e2bcd8739ae039 = (0, $lzJFw.default).bind();
$44e810ee7bc6f48a$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $44e810ee7bc6f48a$export$2e2bcd8739ae039[tagName] = $44e810ee7bc6f48a$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("lzJFw", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb504ab1564328a2$export$2e2bcd8739ae039);

var $6JG9D = parcelRequire("6JG9D");

var $81g6h = parcelRequire("81g6h");

var $l4JUy = parcelRequire("l4JUy");
parcelRequire("kkH7g");
var $kh6VF = parcelRequire("kh6VF");

var $e1iyw = parcelRequire("e1iyw");

var $hjFMi = parcelRequire("hjFMi");

var $h4egm = parcelRequire("h4egm");
var $fb504ab1564328a2$var$testOmitPropsOnStringTag = (0, $l4JUy.default);
var $fb504ab1564328a2$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $fb504ab1564328a2$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $fb504ab1564328a2$var$testOmitPropsOnStringTag : $fb504ab1564328a2$var$testOmitPropsOnComponent;
};
var $fb504ab1564328a2$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $fb504ab1564328a2$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $fb504ab1564328a2$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $e1iyw.registerStyles)(cache, serialized, isStringTag);
    (0, $h4egm.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $e1iyw.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $fb504ab1564328a2$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $fb504ab1564328a2$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $fb504ab1564328a2$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $kh6VF.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $81g6h.useContext((0, $kh6VF.T));
            }
            if (typeof props.className === "string") className = (0, $e1iyw.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $hjFMi.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $fb504ab1564328a2$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement($fb504ab1564328a2$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $81g6h.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $6JG9D.default)({}, options, nextOptions, {
                shouldForwardProp: $fb504ab1564328a2$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("l4JUy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f57d95b1b260935c$export$2e2bcd8739ae039);

var $5JzA5 = parcelRequire("5JzA5");
var $f57d95b1b260935c$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $f57d95b1b260935c$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $5JzA5.default)(function(prop) {
    return $f57d95b1b260935c$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("GDBjl", function(module, exports) {

$parcel$export(module.exports, "AppLogo", () => $3ab21868e19617a7$export$113a612889e1565d);

var $iKObn = parcelRequire("iKObn");

var $ghfIB = parcelRequire("ghfIB");

var $1IWnK = parcelRequire("1IWnK");
parcelRequire("81g6h");
var $3ab21868e19617a7$var$DefaultFullWhiteLogo = function DefaultFullWhiteLogo(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("g", {
                clipPath: "url(#clip0_460_11962)",
                fill: "currentColor",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M99.658 51.4c-3.42-2.044-7.68-3.065-12.775-3.065-3.69 0-7.076.721-10.159 2.16a22.366 22.366 0 0 0-3.921 2.331V26.831H58.518v72.651h14.285V75.265c0-2.614.484-4.939 1.458-6.985.972-2.043 2.364-3.632 4.175-4.773 1.81-1.14 3.888-1.71 6.237-1.71 2.348 0 4.441.619 6.086 1.86 1.642 1.24 2.884 2.863 3.723 4.873.84 2.01 1.257 4.188 1.257 6.53v24.42h14.282V73.654c0-5.29-.872-9.812-2.613-13.567-1.745-3.753-4.325-6.649-7.744-8.692l-.006.003ZM151.476 74.965c0 2.346-.487 4.473-1.459 6.38-.971 1.908-2.312 3.401-4.023 4.47-1.711 1.073-3.639 1.608-5.783 1.608-3.555 0-6.27-1.12-8.147-3.368-1.879-2.244-2.818-5.176-2.818-8.793V49.738h-14.083v26.026c0 4.89.821 9.229 2.466 13.014 1.642 3.785 4.174 6.75 7.597 8.893 3.419 2.145 7.809 3.214 13.177 3.214 3.083 0 5.735-.538 7.946-1.607a13.571 13.571 0 0 0 5.331-4.555v1.827c0 3.05-.538 4.975-1.608 7.285-1.074 2.311-2.599 4.119-4.577 5.426-1.979 1.307-4.412 1.959-7.293 1.959-3.218 0-5.918-.739-8.099-2.211-2.18-1.476-3.84-3.284-4.977-5.426l-11.767 5.942c2.279 4.624 5.548 8.157 9.807 10.602 4.258 2.446 9.337 3.668 15.24 3.668 5.498 0 10.309-1.189 14.435-3.566 4.123-2.379 7.344-5.726 9.657-10.049 2.312-4.32 3.47-9.361 3.47-15.123V49.74h-14.486v25.224h-.006ZM206.205 72.546a28.709 28.709 0 0 0-6.589-2.367 202.62 202.62 0 0 0-6.637-1.41c-2.081-.402-3.774-.955-5.079-1.66-1.308-.706-1.961-1.728-1.961-3.07 0-.872.268-1.626.803-2.266.535-.637 1.272-1.142 2.214-1.511.938-.37 1.975-.553 3.118-.553 2.012 0 3.873.439 5.582 1.31 1.708.874 2.932 2.214 3.671 4.029l10.562-5.94c-1.007-1.947-2.4-3.725-4.174-5.335-1.777-1.61-3.973-2.92-6.589-3.927-2.613-1.006-5.732-1.51-9.356-1.51-4.09 0-7.644.705-10.66 2.114-3.02 1.409-5.35 3.323-6.992 5.738-1.645 2.416-2.463 5.134-2.463 8.154 0 3.22.652 5.789 1.96 7.703a12.834 12.834 0 0 0 5.08 4.38 31.126 31.126 0 0 0 6.637 2.316c2.345.538 4.541 1.006 6.589 1.409 2.045.402 3.738.922 5.079 1.56 1.341.639 2.012 1.627 2.012 2.97 0 1.007-.319 1.863-.956 2.569-.638.706-1.51 1.244-2.617 1.61-1.106.37-2.43.553-3.972.553-2.481 0-4.559-.454-6.237-1.358-1.679-.907-3.086-2.367-4.226-4.38l-10.561 5.94c2.078 3.691 4.911 6.494 8.498 8.405 3.588 1.914 7.997 2.869 13.229 2.869 3.756 0 7.242-.688 10.46-2.064 3.217-1.376 5.798-3.286 7.746-5.738 1.943-2.448 2.917-5.35 2.917-8.71 0-3.085-.67-5.569-2.012-7.45a13.932 13.932 0 0 0-5.079-4.38h.003ZM232.332 49.741h-14.284v49.741h14.284v-49.74ZM417.499 51.85c-3.588-2.343-8.099-3.518-13.53-3.518-3.957 0-7.479.787-10.561 2.361-3.086 1.575-5.534 3.753-7.344 6.532a16.946 16.946 0 0 0-1.164 2.106c-.319-.73-.686-1.43-1.101-2.106-1.708-2.78-4.123-4.957-7.241-6.532-3.119-1.574-6.824-2.36-11.115-2.36-5.365 0-9.843 1.17-13.427 3.517-3.588 2.346-6.289 5.444-8.099 9.295-1.81 3.855-2.716 8.09-2.716 12.711V99.48h14.285V76.166c0-2.544.367-4.873 1.107-6.984.736-2.11 1.909-3.8 3.521-5.075 1.609-1.27 3.756-1.907 6.439-1.907 2.682 0 4.661.619 6.336 1.86 1.675 1.24 2.884 2.913 3.621 5.022.736 2.11 1.106 4.47 1.106 7.084V99.48h14.285V76.064c0-2.544.385-4.873 1.158-6.985.77-2.109 1.96-3.782 3.569-5.023 1.609-1.237 3.723-1.86 6.337-1.86 2.613 0 4.742.638 6.387 1.908 1.642 1.274 2.851 2.966 3.621 5.075.77 2.108 1.158 4.47 1.158 7.084v23.213h14.284V73.853c0-4.69-.923-8.944-2.767-12.762-1.846-3.818-4.562-6.898-8.146-9.244l-.003.003ZM483 73.411c0-4.53-.983-8.69-2.944-12.488-1.964-3.797-4.776-6.844-8.435-9.142-3.66-2.298-8.12-3.446-13.377-3.446-5.256 0-9.518 1.184-13.376 3.548-3.861 2.364-6.872 5.53-9.034 9.493-2.162 3.963-3.245 8.31-3.245 13.039 0 5.263 1.164 9.875 3.495 13.837 2.327 3.963 5.539 7.06 9.632 9.292 4.093 2.233 8.7 3.347 13.824 3.347 5.125 0 9.864-1.217 13.825-3.647 3.96-2.43 7.004-5.876 9.133-10.34l-10.88-5.495c-1.134 2.265-2.779 4.031-4.941 5.296-2.163 1.265-4.577 1.899-7.239 1.899-2.794 0-5.208-.616-7.238-1.848-2.03-1.231-3.594-2.947-4.692-5.146a13.722 13.722 0 0 1-1.26-3.996h36.749v-4.197l.003-.006Zm-36.135-3.698a13.1 13.1 0 0 1 2.048-4.545c.962-1.364 2.228-2.449 3.792-3.248 1.564-.799 3.377-1.199 5.44-1.199 2.063 0 3.759.385 5.29 1.148a9.993 9.993 0 0 1 3.744 3.197c.965 1.367 1.549 2.914 1.747 4.644h-22.061v.003ZM40.79 51.901c-4.06-2.376-8.666-3.566-13.83-3.566-5.163 0-9.774 1.139-13.83 3.416-4.06 2.277-7.26 5.378-9.605 9.295C1.173 64.966 0 69.314 0 75.578v46.817h14.284V96.211a23.43 23.43 0 0 0 3.42 2.217c3.082 1.64 6.438 2.46 10.06 2.46 5.163 0 9.707-1.123 13.628-3.365 3.924-2.244 6.992-5.36 9.202-9.346 2.214-3.983 3.32-8.556 3.32-13.717 0-4.756-1.173-9.109-3.521-13.062-2.349-3.954-5.549-7.117-9.605-9.497h.003ZM26.96 87.612c-7.148 0-12.94-5.822-12.94-13.002 0-7.18 5.795-13.002 12.94-13.002S39.9 67.43 39.9 74.61c0 7.18-5.795 13.002-12.94 13.002ZM264.405 48.335c-14.916 0-27.008 11.765-27.008 26.278 0 14.514 12.092 26.278 27.008 26.278 14.916 0 27.008-11.764 27.008-26.278 0-14.513-12.092-26.278-27.008-26.278Zm0 39.283c-7.133 0-12.916-5.822-12.916-13.005 0-7.183 5.783-13.005 12.916-13.005s12.916 5.822 12.916 13.005c0 7.183-5.783 13.005-12.916 13.005ZM316.145 37.264c10.301 0 18.651-8.341 18.651-18.632 0-10.29-8.35-18.632-18.651-18.632s-18.651 8.342-18.651 18.632c0 10.29 8.35 18.632 18.651 18.632ZM316.145 101.014c4.791 0 8.676-3.88 8.676-8.667s-3.885-8.667-8.676-8.667c-4.792 0-8.676 3.88-8.676 8.667s3.884 8.667 8.676 8.667ZM316.145 73.216c7.045 0 12.757-5.706 12.757-12.744 0-7.038-5.712-12.744-12.757-12.744-7.046 0-12.757 5.706-12.757 12.744 0 7.038 5.711 12.744 12.757 12.744Z"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M352.419 131.32c-1.152 0-2.197-.235-3.136-.704a5.922 5.922 0 0 1-2.208-2.016c-.554-.853-.864-1.824-.928-2.912v-4.576c.064-1.109.374-2.08.928-2.912a5.908 5.908 0 0 1 2.24-1.984c.939-.491 1.974-.736 3.104-.736 1.387 0 2.635.352 3.744 1.056a7.414 7.414 0 0 1 2.656 2.848c.64 1.195.96 2.539.96 4.032 0 1.493-.32 2.837-.96 4.032a7.414 7.414 0 0 1-2.656 2.848c-1.109.683-2.357 1.024-3.744 1.024Zm-.48-2.72c.96 0 1.803-.224 2.528-.672a4.888 4.888 0 0 0 1.728-1.824c.427-.789.64-1.696.64-2.72 0-1.003-.213-1.899-.64-2.688-.426-.789-1.002-1.397-1.728-1.824-.725-.448-1.557-.672-2.496-.672-.96 0-1.802.224-2.528.672-.725.427-1.29 1.035-1.696 1.824-.405.789-.608 1.696-.608 2.72 0 1.003.192 1.899.576 2.688a4.664 4.664 0 0 0 1.696 1.824c.747.448 1.59.672 2.528.672Zm-7.52 2.4v-22.848h2.88v11.36l-.544 3.68.544 3.712V131h-2.88Zm23.248.128-6.592-15.328h3.2l4.896 12h-1.024l5.152-12h3.2l-7.104 15.328h-1.728Zm-4.352 6.24 4.48-9.184 1.6 2.944-2.88 6.24h-3.2ZM387.004 131v-3.552h5.856c1.045 0 1.856-.32 2.432-.96a3.22 3.22 0 0 0 .896-2.272c0-.597-.128-1.141-.384-1.632a2.724 2.724 0 0 0-1.152-1.152c-.491-.299-1.088-.448-1.792-.448h-5.856v-3.52h5.376c.896 0 1.61-.224 2.144-.672.554-.448.832-1.12.832-2.016 0-.917-.278-1.6-.832-2.048-.534-.448-1.248-.672-2.144-.672h-5.376v-3.552h5.888c1.493 0 2.741.277 3.744.832 1.024.533 1.792 1.248 2.304 2.144a5.6 5.6 0 0 1 .768 2.88c0 1.28-.395 2.389-1.184 3.328-.768.917-1.899 1.6-3.392 2.048l.192-1.408c1.664.469 2.944 1.248 3.84 2.336.917 1.067 1.376 2.357 1.376 3.872 0 1.195-.299 2.283-.896 3.264-.576.96-1.43 1.739-2.56 2.336-1.11.576-2.464.864-4.064.864h-6.016Zm-3.2 0v-22.496h4.32V131h-4.32Zm19.963 0v-15.456h4.224V131h-4.224Zm2.112-17.952c-.682 0-1.248-.224-1.696-.672-.448-.469-.672-1.045-.672-1.728 0-.661.224-1.227.672-1.696.448-.469 1.014-.704 1.696-.704.704 0 1.27.235 1.696.704.448.469.672 1.035.672 1.696 0 .683-.224 1.259-.672 1.728-.426.448-.992.672-1.696.672Zm13.314 18.272c-1.558 0-2.966-.352-4.224-1.056a8.445 8.445 0 0 1-2.976-2.912c-.726-1.237-1.088-2.613-1.088-4.128 0-1.515.362-2.869 1.088-4.064a7.872 7.872 0 0 1 2.976-2.88c1.258-.725 2.656-1.088 4.192-1.088 1.578 0 2.986.363 4.224 1.088a7.886 7.886 0 0 1 2.976 2.88c.725 1.195 1.088 2.549 1.088 4.064 0 1.515-.363 2.891-1.088 4.128a8.128 8.128 0 0 1-2.976 2.912c-1.238.704-2.635 1.056-4.192 1.056Zm-.032-3.904c.789 0 1.482-.171 2.08-.512a3.599 3.599 0 0 0 1.408-1.472c.341-.64.512-1.365.512-2.176 0-.811-.171-1.525-.512-2.144a3.66 3.66 0 0 0-1.408-1.44c-.598-.363-1.291-.544-2.08-.544-.768 0-1.451.181-2.048.544a3.646 3.646 0 0 0-1.408 1.44c-.342.619-.512 1.333-.512 2.144 0 .811.17 1.536.512 2.176.341.619.81 1.109 1.408 1.472.597.341 1.28.512 2.048.512Zm17.674 10.432c-1.642 0-3.093-.299-4.352-.896-1.258-.576-2.261-1.397-3.008-2.464l2.656-2.656c.598.704 1.259 1.237 1.984 1.6.747.384 1.643.576 2.688.576 1.302 0 2.326-.331 3.072-.992.769-.661 1.153-1.579 1.153-2.752v-3.872l.703-3.392-.672-3.392v-4.064h4.16V130.2c0 1.536-.362 2.869-1.087 4-.705 1.152-1.686 2.048-2.944 2.688-1.259.64-2.71.96-4.353.96Zm-.192-7.264c-1.386 0-2.634-.331-3.744-.992a7.329 7.329 0 0 1-2.624-2.784c-.618-1.173-.928-2.485-.928-3.936s.31-2.752.928-3.904a7.145 7.145 0 0 1 2.624-2.72c1.11-.683 2.358-1.024 3.744-1.024 1.152 0 2.166.224 3.04.672.896.448 1.601 1.067 2.112 1.856.512.768.79 1.675.832 2.72v4.864c-.042 1.024-.33 1.941-.863 2.752-.513.789-1.217 1.408-2.113 1.856-.874.427-1.877.64-3.008.64Zm.832-3.808c.768 0 1.43-.16 1.984-.48a3.616 3.616 0 0 0 1.344-1.376c.32-.597.48-1.269.48-2.016 0-.768-.16-1.44-.48-2.016a3.394 3.394 0 0 0-1.344-1.344c-.554-.341-1.216-.512-1.984-.512s-1.44.171-2.016.512a3.344 3.344 0 0 0-1.344 1.376c-.32.576-.48 1.237-.48 1.984 0 .725.16 1.387.48 1.984.32.576.768 1.035 1.344 1.376.576.341 1.248.512 2.016.512Zm19.044 4.544c-1.622 0-3.062-.341-4.32-1.024a8.114 8.114 0 0 1-3.008-2.88c-.726-1.216-1.088-2.603-1.088-4.16 0-1.536.352-2.901 1.056-4.096a7.937 7.937 0 0 1 2.944-2.88c1.237-.725 2.613-1.088 4.128-1.088 1.493 0 2.805.341 3.936 1.024a6.949 6.949 0 0 1 2.688 2.752c.661 1.152.992 2.464.992 3.936 0 .277-.022.565-.064.864a6.55 6.55 0 0 1-.16.96l-12.992.032v-3.136l11.04-.032-1.696 1.312c-.043-.917-.214-1.685-.512-2.304-.278-.619-.694-1.088-1.248-1.408-.534-.341-1.195-.512-1.984-.512-.832 0-1.558.192-2.176.576-.619.363-1.099.885-1.44 1.568-.32.661-.48 1.451-.48 2.368 0 .939.17 1.76.512 2.464a3.951 3.951 0 0 0 1.536 1.6c.661.363 1.429.544 2.304.544.789 0 1.504-.128 2.144-.384a4.67 4.67 0 0 0 1.664-1.216l2.464 2.464a7.132 7.132 0 0 1-2.752 1.984c-1.067.448-2.23.672-3.488.672Zm20.544-.32v-8.864c0-.917-.288-1.664-.864-2.24-.576-.576-1.322-.864-2.24-.864-.597 0-1.13.128-1.6.384a2.897 2.897 0 0 0-1.12 1.088c-.256.469-.384 1.013-.384 1.632l-1.632-.832c0-1.216.256-2.272.768-3.168a5.686 5.686 0 0 1 2.176-2.144c.939-.512 1.995-.768 3.168-.768 1.131 0 2.144.288 3.04.864a5.996 5.996 0 0 1 2.112 2.208c.512.896.768 1.867.768 2.912V131h-4.192Zm-10.4 0v-15.456h4.192V131h-4.192Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_460_11962",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h483v123.801H0z"
                    })
                })
            })
        ]
    });
};
$3ab21868e19617a7$var$DefaultFullWhiteLogo.defaultProps = {
    viewBox: "0 0 483 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $3ab21868e19617a7$var$DefaultDefaultLogo = function DefaultDefaultLogo(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_460_11956)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M99.039 51.067c-3.398-2.03-7.633-3.045-12.696-3.045-3.667 0-7.032.717-10.095 2.146a22.228 22.228 0 0 0-3.897 2.316V26.657H58.155v72.181H72.35v-24.06c0-2.597.48-4.907 1.45-6.94.965-2.03 2.348-3.608 4.147-4.743 1.8-1.13 3.865-1.698 6.199-1.698 2.334 0 4.414.615 6.049 1.848 1.631 1.232 2.866 2.844 3.7 4.84.833 1.998 1.249 4.162 1.249 6.49v24.26h14.192V73.178c0-5.256-.866-9.748-2.597-13.48-1.733-3.727-4.297-6.605-7.695-8.634l-.006.003ZM150.535 74.48c0 2.33-.484 4.444-1.449 6.34-.966 1.894-2.299 3.378-3.999 4.44-1.701 1.066-3.616 1.597-5.747 1.597-3.533 0-6.231-1.113-8.096-3.346-1.868-2.23-2.801-5.142-2.801-8.736V49.416h-13.995v25.857c0 4.86.816 9.17 2.451 12.93 1.631 3.761 4.148 6.707 7.549 8.835 3.398 2.132 7.761 3.194 13.096 3.194 3.063 0 5.699-.534 7.896-1.597a13.485 13.485 0 0 0 5.298-4.525v1.815c0 3.03-.535 4.943-1.599 7.238-1.066 2.295-2.582 4.092-4.548 5.391-1.967 1.298-4.384 1.946-7.247 1.946-3.198 0-5.882-.735-8.049-2.197-2.166-1.466-3.816-3.262-4.946-5.391l-11.694 5.904c2.265 4.594 5.514 8.104 9.746 10.534 4.231 2.429 9.279 3.644 15.146 3.644 5.463 0 10.245-1.182 14.345-3.543 4.097-2.364 7.298-5.689 9.596-9.984 2.299-4.292 3.449-9.301 3.449-15.025V49.419h-14.396v25.06h-.006ZM204.924 72.077a28.528 28.528 0 0 0-6.548-2.352c-2.334-.535-4.533-1-6.595-1.4-2.068-.4-3.751-.95-5.048-1.65-1.3-.702-1.949-1.717-1.949-3.051 0-.866.266-1.615.798-2.25.532-.634 1.264-1.135 2.2-1.502.932-.367 1.963-.55 3.099-.55 1.999 0 3.849.436 5.547 1.302 1.697.869 2.914 2.2 3.649 4.003l10.496-5.901c-1.001-1.934-2.385-3.701-4.148-5.301-1.767-1.6-3.948-2.901-6.548-3.901-2.597-1-5.697-1.502-9.298-1.502-4.064 0-7.597.702-10.594 2.102-3.001 1.4-5.317 3.3-6.949 5.7-1.635 2.4-2.447 5.101-2.447 8.101 0 3.2.648 5.752 1.948 7.653a12.746 12.746 0 0 0 5.048 4.352c2.065 1 4.265 1.767 6.596 2.301 2.331.535 4.512 1 6.548 1.4 2.032.4 3.714.916 5.047 1.55 1.333.635 2 1.617 2 2.951 0 1-.317 1.85-.951 2.552-.633.702-1.5 1.236-2.6 1.6-1.1.367-2.414.55-3.948.55-2.465 0-4.53-.452-6.198-1.35-1.668-.901-3.066-2.352-4.199-4.352l-10.496 5.901c2.065 3.668 4.881 6.453 8.446 8.352 3.565 1.9 7.947 2.85 13.147 2.85 3.732 0 7.196-.683 10.394-2.05 3.198-1.368 5.762-3.266 7.699-5.701 1.93-2.433 2.899-5.316 2.899-8.653 0-3.066-.667-5.534-2-7.403a13.843 13.843 0 0 0-5.048-4.351h.003ZM230.889 49.42h-14.195v49.418h14.195V49.42ZM414.906 51.514c-3.566-2.328-8.049-3.495-13.446-3.495-3.933 0-7.433.782-10.496 2.346-3.066 1.564-5.499 3.728-7.298 6.49a16.89 16.89 0 0 0-1.157 2.092 16.786 16.786 0 0 0-1.094-2.093c-1.697-2.76-4.097-4.925-7.196-6.489-3.099-1.564-6.781-2.346-11.046-2.346-5.332 0-9.781 1.164-13.344 3.495-3.565 2.331-6.249 5.409-8.048 9.235-1.799 3.83-2.699 8.038-2.699 12.629v25.457h14.196V75.673c0-2.528.365-4.841 1.1-6.94.732-2.095 1.897-3.775 3.499-5.04 1.599-1.263 3.733-1.896 6.399-1.896s4.632.615 6.297 1.848c1.665 1.232 2.866 2.895 3.598 4.99.732 2.095 1.1 4.441 1.1 7.038v23.162h14.196V75.572c0-2.528.382-4.842 1.15-6.94.765-2.095 1.949-3.758 3.548-4.99 1.599-1.23 3.7-1.848 6.297-1.848 2.597 0 4.713.633 6.347 1.895 1.632 1.266 2.834 2.946 3.599 5.042.765 2.095 1.15 4.44 1.15 7.038v23.063h14.196V73.375c0-4.66-.917-8.886-2.749-12.68-1.835-3.793-4.534-6.852-8.096-9.184l-.003.003ZM480 72.936c0-4.5-.977-8.635-2.926-12.408-1.951-3.772-4.746-6.799-8.383-9.082-3.637-2.284-8.069-3.424-13.293-3.424-5.224 0-9.459 1.176-13.293 3.525-3.838 2.35-6.829 5.495-8.978 9.432-2.149 3.937-3.225 8.256-3.225 12.954 0 5.23 1.157 9.811 3.473 13.748 2.313 3.937 5.505 7.014 9.572 9.232 4.068 2.218 8.646 3.325 13.739 3.325s9.803-1.209 13.739-3.623c3.936-2.415 6.96-5.839 9.076-10.274l-10.813-5.46c-1.126 2.251-2.761 4.006-4.91 5.263-2.149 1.256-4.549 1.886-7.194 1.886-2.776 0-5.176-.612-7.193-1.835-2.017-1.224-3.571-2.928-4.662-5.113a13.62 13.62 0 0 1-1.253-3.97h36.521v-4.17l.003-.006Zm-35.911-3.674a13.04 13.04 0 0 1 2.035-4.516c.957-1.355 2.215-2.433 3.769-3.227 1.554-.794 3.356-1.19 5.406-1.19s3.736.382 5.257 1.14a9.92 9.92 0 0 1 3.721 3.175c.959 1.359 1.539 2.896 1.736 4.615h-21.924v.003ZM40.537 51.565c-4.034-2.36-8.613-3.543-13.744-3.543-5.132 0-9.713 1.131-13.745 3.394-4.034 2.262-7.214 5.343-9.545 9.235C1.166 64.546 0 68.865 0 75.088v46.515h14.196V95.588c1.04.812 2.17 1.549 3.398 2.203 3.063 1.63 6.398 2.444 9.997 2.444 5.131 0 9.647-1.116 13.544-3.343 3.9-2.23 6.948-5.325 9.145-9.286 2.2-3.957 3.3-8.5 3.3-13.628 0-4.725-1.166-9.05-3.5-12.978-2.334-3.928-5.514-7.07-9.546-9.435h.003Zm-13.744 35.48c-7.104 0-12.86-5.784-12.86-12.918 0-7.133 5.759-12.918 12.86-12.918 7.1 0 12.86 5.784 12.86 12.918 0 7.134-5.76 12.918-12.86 12.918ZM262.763 48.022c-14.824 0-26.841 11.689-26.841 26.108 0 14.42 12.017 26.108 26.841 26.108 14.823 0 26.84-11.688 26.84-26.108s-12.017-26.108-26.84-26.108Zm0 39.03c-7.089 0-12.836-5.785-12.836-12.922 0-7.136 5.747-12.921 12.836-12.921 7.088 0 12.835 5.784 12.835 12.921s-5.747 12.921-12.835 12.921Z",
                        fill: "#190032"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M314.181 37.023c10.237 0 18.535-8.288 18.535-18.511C332.716 8.288 324.418 0 314.181 0c-10.236 0-18.535 8.288-18.535 18.512 0 10.223 8.299 18.511 18.535 18.511Z",
                        fill: "url(#paint0_linear_460_11956)"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M314.181 100.36c4.762 0 8.622-3.855 8.622-8.61 0-4.757-3.86-8.612-8.622-8.612-4.762 0-8.622 3.855-8.622 8.611s3.86 8.611 8.622 8.611Z",
                        fill: "url(#paint1_linear_460_11956)"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M314.181 72.742c7.002 0 12.678-5.669 12.678-12.661 0-6.993-5.676-12.662-12.678-12.662-7.001 0-12.677 5.669-12.677 12.662 0 6.992 5.676 12.661 12.677 12.661Z",
                        fill: "url(#paint2_linear_460_11956)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M349.419 130.32c-1.152 0-2.197-.235-3.136-.704a5.922 5.922 0 0 1-2.208-2.016c-.554-.853-.864-1.824-.928-2.912v-4.576c.064-1.109.374-2.08.928-2.912a5.908 5.908 0 0 1 2.24-1.984c.939-.491 1.974-.736 3.104-.736 1.387 0 2.635.352 3.744 1.056a7.414 7.414 0 0 1 2.656 2.848c.64 1.195.96 2.539.96 4.032 0 1.493-.32 2.837-.96 4.032a7.414 7.414 0 0 1-2.656 2.848c-1.109.683-2.357 1.024-3.744 1.024Zm-.48-2.72c.96 0 1.803-.224 2.528-.672a4.888 4.888 0 0 0 1.728-1.824c.427-.789.64-1.696.64-2.72 0-1.003-.213-1.899-.64-2.688-.426-.789-1.002-1.397-1.728-1.824-.725-.448-1.557-.672-2.496-.672-.96 0-1.802.224-2.528.672-.725.427-1.29 1.035-1.696 1.824-.405.789-.608 1.696-.608 2.72 0 1.003.192 1.899.576 2.688a4.664 4.664 0 0 0 1.696 1.824c.747.448 1.59.672 2.528.672Zm-7.52 2.4v-22.848h2.88v11.36l-.544 3.68.544 3.712V130h-2.88Zm23.248.128-6.592-15.328h3.2l4.896 12h-1.024l5.152-12h3.2l-7.104 15.328h-1.728Zm-4.352 6.24 4.48-9.184 1.6 2.944-2.88 6.24h-3.2ZM384.004 130v-3.552h5.856c1.045 0 1.856-.32 2.432-.96a3.22 3.22 0 0 0 .896-2.272c0-.597-.128-1.141-.384-1.632a2.724 2.724 0 0 0-1.152-1.152c-.491-.299-1.088-.448-1.792-.448h-5.856v-3.52h5.376c.896 0 1.61-.224 2.144-.672.554-.448.832-1.12.832-2.016 0-.917-.278-1.6-.832-2.048-.534-.448-1.248-.672-2.144-.672h-5.376v-3.552h5.888c1.493 0 2.741.277 3.744.832 1.024.533 1.792 1.248 2.304 2.144a5.6 5.6 0 0 1 .768 2.88c0 1.28-.395 2.389-1.184 3.328-.768.917-1.899 1.6-3.392 2.048l.192-1.408c1.664.469 2.944 1.248 3.84 2.336.917 1.067 1.376 2.357 1.376 3.872 0 1.195-.299 2.283-.896 3.264-.576.96-1.43 1.739-2.56 2.336-1.11.576-2.464.864-4.064.864h-6.016Zm-3.2 0v-22.496h4.32V130h-4.32Zm19.963 0v-15.456h4.224V130h-4.224Zm2.112-17.952c-.682 0-1.248-.224-1.696-.672-.448-.469-.672-1.045-.672-1.728 0-.661.224-1.227.672-1.696.448-.469 1.014-.704 1.696-.704.704 0 1.27.235 1.696.704.448.469.672 1.035.672 1.696 0 .683-.224 1.259-.672 1.728-.426.448-.992.672-1.696.672Zm13.314 18.272c-1.558 0-2.966-.352-4.224-1.056a8.445 8.445 0 0 1-2.976-2.912c-.726-1.237-1.088-2.613-1.088-4.128 0-1.515.362-2.869 1.088-4.064a7.872 7.872 0 0 1 2.976-2.88c1.258-.725 2.656-1.088 4.192-1.088 1.578 0 2.986.363 4.224 1.088a7.886 7.886 0 0 1 2.976 2.88c.725 1.195 1.088 2.549 1.088 4.064 0 1.515-.363 2.891-1.088 4.128a8.128 8.128 0 0 1-2.976 2.912c-1.238.704-2.635 1.056-4.192 1.056Zm-.032-3.904c.789 0 1.482-.171 2.08-.512a3.599 3.599 0 0 0 1.408-1.472c.341-.64.512-1.365.512-2.176 0-.811-.171-1.525-.512-2.144a3.66 3.66 0 0 0-1.408-1.44c-.598-.363-1.291-.544-2.08-.544-.768 0-1.451.181-2.048.544a3.646 3.646 0 0 0-1.408 1.44c-.342.619-.512 1.333-.512 2.144 0 .811.17 1.536.512 2.176.341.619.81 1.109 1.408 1.472.597.341 1.28.512 2.048.512Zm17.674 10.432c-1.642 0-3.093-.299-4.352-.896-1.258-.576-2.261-1.397-3.008-2.464l2.656-2.656c.598.704 1.259 1.237 1.984 1.6.747.384 1.643.576 2.688.576 1.302 0 2.326-.331 3.072-.992.769-.661 1.153-1.579 1.153-2.752v-3.872l.703-3.392-.672-3.392v-4.064h4.16V129.2c0 1.536-.362 2.869-1.087 4-.705 1.152-1.686 2.048-2.944 2.688-1.259.64-2.71.96-4.353.96Zm-.192-7.264c-1.386 0-2.634-.331-3.744-.992a7.329 7.329 0 0 1-2.624-2.784c-.618-1.173-.928-2.485-.928-3.936s.31-2.752.928-3.904a7.145 7.145 0 0 1 2.624-2.72c1.11-.683 2.358-1.024 3.744-1.024 1.152 0 2.166.224 3.04.672.896.448 1.601 1.067 2.112 1.856.512.768.79 1.675.832 2.72v4.864c-.042 1.024-.33 1.941-.863 2.752-.513.789-1.217 1.408-2.113 1.856-.874.427-1.877.64-3.008.64Zm.832-3.808c.768 0 1.43-.16 1.984-.48a3.616 3.616 0 0 0 1.344-1.376c.32-.597.48-1.269.48-2.016 0-.768-.16-1.44-.48-2.016a3.394 3.394 0 0 0-1.344-1.344c-.554-.341-1.216-.512-1.984-.512s-1.44.171-2.016.512a3.344 3.344 0 0 0-1.344 1.376c-.32.576-.48 1.237-.48 1.984 0 .725.16 1.387.48 1.984.32.576.768 1.035 1.344 1.376.576.341 1.248.512 2.016.512Zm19.044 4.544c-1.622 0-3.062-.341-4.32-1.024a8.114 8.114 0 0 1-3.008-2.88c-.726-1.216-1.088-2.603-1.088-4.16 0-1.536.352-2.901 1.056-4.096a7.937 7.937 0 0 1 2.944-2.88c1.237-.725 2.613-1.088 4.128-1.088 1.493 0 2.805.341 3.936 1.024a6.949 6.949 0 0 1 2.688 2.752c.661 1.152.992 2.464.992 3.936 0 .277-.022.565-.064.864a6.55 6.55 0 0 1-.16.96l-12.992.032v-3.136l11.04-.032-1.696 1.312c-.043-.917-.214-1.685-.512-2.304-.278-.619-.694-1.088-1.248-1.408-.534-.341-1.195-.512-1.984-.512-.832 0-1.558.192-2.176.576-.619.363-1.099.885-1.44 1.568-.32.661-.48 1.451-.48 2.368 0 .939.17 1.76.512 2.464a3.951 3.951 0 0 0 1.536 1.6c.661.363 1.429.544 2.304.544.789 0 1.504-.128 2.144-.384a4.67 4.67 0 0 0 1.664-1.216l2.464 2.464a7.132 7.132 0 0 1-2.752 1.984c-1.067.448-2.23.672-3.488.672Zm20.544-.32v-8.864c0-.917-.288-1.664-.864-2.24-.576-.576-1.322-.864-2.24-.864-.597 0-1.13.128-1.6.384a2.897 2.897 0 0 0-1.12 1.088c-.256.469-.384 1.013-.384 1.632l-1.632-.832c0-1.216.256-2.272.768-3.168a5.686 5.686 0 0 1 2.176-2.144c.939-.512 1.995-.768 3.168-.768 1.131 0 2.144.288 3.04.864a5.996 5.996 0 0 1 2.112 2.208c.512.896.768 1.867.768 2.912V130h-4.192Zm-10.4 0v-15.456h4.192V130h-4.192Z",
                fill: "#190032"
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)("linearGradient", {
                        id: "paint0_linear_460_11956",
                        x1: "314.181",
                        y1: "99.916",
                        x2: "314.181",
                        y2: "1.519",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                stopColor: "#50F"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                offset: ".5",
                                stopColor: "#7828F7"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                offset: "1",
                                stopColor: "#A055F0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("linearGradient", {
                        id: "paint1_linear_460_11956",
                        x1: "314.181",
                        y1: "99.916",
                        x2: "314.181",
                        y2: "1.519",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                stopColor: "#50F"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                offset: ".5",
                                stopColor: "#7828F7"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                offset: "1",
                                stopColor: "#A055F0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("linearGradient", {
                        id: "paint2_linear_460_11956",
                        x1: "314.181",
                        y1: "99.916",
                        x2: "314.181",
                        y2: "1.519",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                stopColor: "#50F"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                offset: ".5",
                                stopColor: "#7828F7"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                offset: "1",
                                stopColor: "#A055F0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                        id: "clip0_460_11956",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h480v123H0z"
                        })
                    })
                ]
            })
        ]
    });
};
$3ab21868e19617a7$var$DefaultDefaultLogo.defaultProps = {
    width: "480",
    height: "137",
    viewBox: "0 0 480 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $3ab21868e19617a7$var$BrFullWhiteLogo = function BrFullWhiteLogo(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("g", {
                clipPath: "url(#clip0_1362_9941)",
                fill: "currentColor",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M99.658 51.4c-3.42-2.044-7.68-3.065-12.775-3.065-3.69 0-7.076.721-10.159 2.16a22.37 22.37 0 0 0-3.921 2.331V26.831H58.518v72.651h14.285V75.265c0-2.614.484-4.939 1.458-6.985.972-2.043 2.364-3.632 4.174-4.773 1.81-1.14 3.889-1.71 6.237-1.71 2.35 0 4.442.619 6.087 1.86 1.642 1.24 2.884 2.863 3.723 4.873.84 2.01 1.257 4.188 1.257 6.53v24.42h14.282V73.654c0-5.29-.872-9.812-2.614-13.567-1.744-3.753-4.324-6.649-7.743-8.692l-.006.003ZM151.476 74.965c0 2.346-.487 4.473-1.459 6.38-.971 1.908-2.312 3.401-4.023 4.47-1.711 1.073-3.639 1.608-5.783 1.608-3.555 0-6.27-1.12-8.147-3.368-1.879-2.244-2.818-5.176-2.818-8.793V49.738h-14.083v26.026c0 4.89.821 9.229 2.466 13.014 1.642 3.785 4.174 6.75 7.597 8.893 3.419 2.145 7.809 3.214 13.177 3.214 3.083 0 5.735-.538 7.946-1.607a13.571 13.571 0 0 0 5.331-4.555v1.827c0 3.05-.538 4.975-1.608 7.285-1.074 2.311-2.599 4.119-4.577 5.426-1.979 1.307-4.412 1.959-7.293 1.959-3.218 0-5.918-.739-8.099-2.211-2.18-1.476-3.84-3.284-4.977-5.426l-11.767 5.942c2.279 4.624 5.548 8.157 9.807 10.602 4.258 2.446 9.337 3.668 15.24 3.668 5.498 0 10.309-1.189 14.435-3.566 4.123-2.379 7.344-5.726 9.657-10.049 2.312-4.32 3.47-9.361 3.47-15.123V49.74h-14.486v25.224h-.006ZM206.205 72.546a28.709 28.709 0 0 0-6.589-2.367 202.62 202.62 0 0 0-6.637-1.41c-2.081-.402-3.774-.955-5.079-1.66-1.308-.706-1.961-1.728-1.961-3.07 0-.872.268-1.626.803-2.266.536-.637 1.272-1.142 2.214-1.511.938-.37 1.975-.553 3.118-.553 2.012 0 3.873.439 5.582 1.31 1.708.874 2.932 2.214 3.671 4.029l10.562-5.94c-1.007-1.947-2.4-3.725-4.174-5.335-1.777-1.61-3.973-2.92-6.589-3.927-2.613-1.006-5.732-1.51-9.356-1.51-4.089 0-7.644.705-10.66 2.114-3.02 1.409-5.35 3.323-6.992 5.738-1.645 2.416-2.463 5.134-2.463 8.154 0 3.22.652 5.789 1.961 7.703a12.824 12.824 0 0 0 5.079 4.38 31.126 31.126 0 0 0 6.637 2.316c2.346.538 4.541 1.006 6.589 1.409 2.045.402 3.738.922 5.079 1.56 1.341.639 2.012 1.627 2.012 2.97 0 1.007-.319 1.863-.956 2.569-.638.706-1.51 1.244-2.617 1.61-1.106.37-2.43.553-3.972.553-2.481 0-4.559-.454-6.237-1.358-1.678-.907-3.086-2.367-4.226-4.38l-10.561 5.94c2.078 3.691 4.911 6.494 8.498 8.405 3.588 1.914 7.997 2.869 13.229 2.869 3.756 0 7.242-.688 10.46-2.064 3.217-1.376 5.798-3.286 7.746-5.738 1.943-2.448 2.917-5.35 2.917-8.71 0-3.085-.67-5.569-2.011-7.45a13.944 13.944 0 0 0-5.08-4.38h.003ZM232.332 49.741h-14.284v49.741h14.284v-49.74ZM417.499 51.85c-3.588-2.343-8.099-3.518-13.53-3.518-3.957 0-7.479.787-10.561 2.361-3.086 1.575-5.534 3.753-7.344 6.532a16.946 16.946 0 0 0-1.164 2.106c-.319-.73-.686-1.43-1.101-2.106-1.708-2.78-4.123-4.957-7.241-6.532-3.119-1.574-6.824-2.36-11.115-2.36-5.365 0-9.843 1.17-13.427 3.517-3.588 2.346-6.289 5.444-8.099 9.295-1.81 3.855-2.716 8.09-2.716 12.711V99.48h14.285V76.166c0-2.544.367-4.873 1.107-6.984.736-2.11 1.909-3.8 3.521-5.075 1.609-1.27 3.756-1.907 6.439-1.907 2.682 0 4.661.619 6.336 1.86 1.675 1.24 2.884 2.913 3.621 5.022.737 2.11 1.106 4.47 1.106 7.084V99.48h14.285V76.064c0-2.544.385-4.873 1.158-6.985.77-2.109 1.96-3.782 3.569-5.023 1.609-1.237 3.723-1.86 6.337-1.86 2.613 0 4.742.638 6.387 1.908 1.642 1.274 2.851 2.966 3.621 5.075.77 2.108 1.158 4.47 1.158 7.084v23.213h14.284V73.853c0-4.69-.923-8.944-2.767-12.762-1.846-3.818-4.562-6.898-8.146-9.244l-.003.003ZM483 73.411c0-4.53-.983-8.69-2.944-12.488-1.964-3.797-4.776-6.844-8.436-9.142-3.659-2.298-8.119-3.446-13.376-3.446s-9.518 1.184-13.376 3.548c-3.862 2.364-6.872 5.53-9.034 9.493-2.162 3.963-3.245 8.31-3.245 13.039 0 5.263 1.164 9.875 3.495 13.837 2.327 3.963 5.539 7.06 9.632 9.292 4.093 2.233 8.7 3.347 13.824 3.347 5.125 0 9.864-1.217 13.825-3.647 3.96-2.43 7.004-5.876 9.133-10.34l-10.881-5.495c-1.133 2.265-2.778 4.031-4.941 5.296-2.162 1.265-4.577 1.899-7.238 1.899-2.794 0-5.209-.616-7.239-1.848-2.029-1.231-3.593-2.947-4.691-5.146a13.722 13.722 0 0 1-1.26-3.996h36.749v-4.197l.003-.006Zm-36.135-3.698a13.1 13.1 0 0 1 2.048-4.545c.962-1.364 2.228-2.449 3.792-3.248 1.563-.799 3.377-1.199 5.44-1.199 2.063 0 3.759.385 5.29 1.148a9.993 9.993 0 0 1 3.744 3.197c.965 1.367 1.548 2.914 1.747 4.644h-22.061v.003ZM40.79 51.901c-4.06-2.376-8.666-3.566-13.83-3.566-5.163 0-9.774 1.139-13.83 3.416-4.06 2.277-7.26 5.378-9.605 9.295C1.173 64.966 0 69.314 0 75.578v46.817h14.284V96.211a23.43 23.43 0 0 0 3.42 2.217c3.082 1.64 6.438 2.46 10.06 2.46 5.163 0 9.707-1.123 13.628-3.365 3.924-2.244 6.992-5.36 9.202-9.346 2.214-3.983 3.32-8.556 3.32-13.717 0-4.756-1.173-9.109-3.521-13.062-2.349-3.954-5.549-7.117-9.605-9.497h.003ZM26.96 87.612c-7.148 0-12.94-5.822-12.94-13.002 0-7.18 5.795-13.002 12.94-13.002S39.9 67.43 39.9 74.61c0 7.18-5.795 13.002-12.94 13.002ZM264.405 48.335c-14.916 0-27.009 11.765-27.009 26.278 0 14.514 12.093 26.278 27.009 26.278s27.008-11.764 27.008-26.278c0-14.513-12.092-26.278-27.008-26.278Zm0 39.283c-7.134 0-12.916-5.822-12.916-13.005 0-7.183 5.782-13.005 12.916-13.005 7.133 0 12.916 5.822 12.916 13.005 0 7.183-5.783 13.005-12.916 13.005ZM316.145 37.264c10.301 0 18.651-8.341 18.651-18.632 0-10.29-8.35-18.632-18.651-18.632s-18.651 8.342-18.651 18.632c0 10.29 8.35 18.632 18.651 18.632ZM316.145 101.014c4.792 0 8.676-3.88 8.676-8.667s-3.884-8.667-8.676-8.667-8.676 3.88-8.676 8.667 3.884 8.667 8.676 8.667ZM316.145 73.216c7.045 0 12.757-5.706 12.757-12.744 0-7.038-5.712-12.744-12.757-12.744s-12.757 5.706-12.757 12.744c0 7.038 5.712 12.744 12.757 12.744Z"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M232.334 131.32c-1.259 0-2.39-.277-3.392-.832a6.132 6.132 0 0 1-2.304-2.368c-.555-1.003-.832-2.165-.832-3.488V115.8h2.88v8.704c0 .832.138 1.557.416 2.176a3.194 3.194 0 0 0 1.28 1.376c.554.32 1.205.48 1.952.48 1.13 0 2.016-.352 2.656-1.056.64-.725.96-1.717.96-2.976V115.8h2.88v8.832c0 1.323-.278 2.485-.832 3.488a6.146 6.146 0 0 1-2.304 2.368c-.96.555-2.08.832-3.36.832Zm10.58-.32v-15.2h2.88V131h-2.88Zm10.272 0v-9.184c0-1.131-.352-2.016-1.056-2.656-.683-.661-1.547-.992-2.592-.992-.704 0-1.334.149-1.888.448a3.596 3.596 0 0 0-1.344 1.248c-.342.533-.512 1.173-.512 1.92l-1.184-.576c0-1.152.245-2.155.736-3.008a5.311 5.311 0 0 1 2.08-1.984c.874-.491 1.856-.736 2.944-.736 1.066 0 2.026.235 2.88.704a5.1 5.1 0 0 1 2.048 1.984c.512.853.768 1.867.768 3.04V131h-2.88Zm10.272 0v-9.184c0-1.131-.352-2.016-1.056-2.656-.683-.661-1.536-.992-2.56-.992-.704 0-1.344.149-1.92.448a3.596 3.596 0 0 0-1.344 1.248c-.342.533-.512 1.173-.512 1.92l-1.632-.576c.064-1.173.373-2.176.928-3.008a5.974 5.974 0 0 1 2.208-1.984 6.024 6.024 0 0 1 2.944-.736c1.109 0 2.101.235 2.976.704a5.318 5.318 0 0 1 2.08 1.984c.533.853.8 1.877.8 3.072V131h-2.912Zm18.767.32a9.063 9.063 0 0 1-2.432-.32 8.819 8.819 0 0 1-2.08-.96 7.488 7.488 0 0 1-1.664-1.504l1.856-1.856c.555.683 1.195 1.195 1.92 1.536.725.32 1.536.48 2.432.48.896 0 1.589-.149 2.08-.448.491-.32.736-.757.736-1.312s-.203-.981-.608-1.28c-.384-.32-.885-.576-1.504-.768a31.892 31.892 0 0 0-1.984-.608 12.056 12.056 0 0 1-1.952-.8 4.341 4.341 0 0 1-1.536-1.312c-.384-.555-.576-1.291-.576-2.208 0-.917.224-1.707.672-2.368.448-.683 1.067-1.205 1.856-1.568.811-.363 1.781-.544 2.912-.544 1.195 0 2.251.213 3.168.64a5.436 5.436 0 0 1 2.304 1.856l-1.856 1.856a4.265 4.265 0 0 0-1.6-1.28c-.619-.299-1.323-.448-2.112-.448-.832 0-1.472.149-1.92.448-.427.277-.64.672-.64 1.184 0 .512.192.907.576 1.184.384.277.885.512 1.504.704.64.192 1.301.395 1.984.608a9.18 9.18 0 0 1 1.952.8c.619.341 1.12.8 1.504 1.376.405.576.608 1.333.608 2.272 0 1.429-.512 2.56-1.536 3.392-1.003.832-2.357 1.248-4.064 1.248Zm16.088 0c-1.514 0-2.88-.341-4.096-1.024a7.844 7.844 0 0 1-2.88-2.848c-.704-1.195-1.056-2.549-1.056-4.064 0-1.493.342-2.837 1.024-4.032a7.751 7.751 0 0 1 2.816-2.816c1.195-.704 2.528-1.056 4-1.056 1.408 0 2.646.32 3.712.96a6.586 6.586 0 0 1 2.528 2.656c.619 1.131.928 2.411.928 3.84 0 .213-.01.448-.032.704a7.94 7.94 0 0 1-.128.832h-12.832v-2.4h11.296l-1.056.928c0-1.024-.181-1.888-.544-2.592-.362-.725-.874-1.28-1.536-1.664-.661-.405-1.461-.608-2.4-.608-.981 0-1.845.213-2.592.64a4.38 4.38 0 0 0-1.728 1.792c-.405.768-.608 1.675-.608 2.72 0 1.067.214 2.005.64 2.816a4.633 4.633 0 0 0 1.824 1.856c.79.427 1.696.64 2.72.64.854 0 1.632-.149 2.336-.448a4.84 4.84 0 0 0 1.856-1.344l1.856 1.888a7.057 7.057 0 0 1-2.688 1.952 8.436 8.436 0 0 1-3.36.672Zm10.34-.32v-15.2h2.88V131h-2.88Zm2.88-8.672-1.088-.48c0-1.941.448-3.488 1.344-4.64.896-1.152 2.187-1.728 3.872-1.728.768 0 1.462.139 2.08.416.619.256 1.195.693 1.728 1.312l-1.888 1.952a2.878 2.878 0 0 0-1.056-.736c-.384-.149-.832-.224-1.344-.224-1.066 0-1.941.341-2.624 1.024-.682.683-1.024 1.717-1.024 3.104ZM326.656 131l-6.976-15.2h3.2l5.6 12.832h-1.856l5.632-12.832h3.072l-6.976 15.2h-1.696Zm11.384 0v-15.2h2.88V131h-2.88Zm1.44-18.24c-.534 0-.971-.171-1.312-.512-.342-.363-.512-.811-.512-1.344 0-.512.17-.939.512-1.28.341-.363.778-.544 1.312-.544.533 0 .97.181 1.312.544.341.341.512.768.512 1.28 0 .533-.171.981-.512 1.344-.342.341-.779.512-1.312.512Zm12.852 18.56c-1.493 0-2.848-.352-4.064-1.056a7.918 7.918 0 0 1-2.848-2.848c-.683-1.216-1.024-2.56-1.024-4.032 0-1.493.341-2.837 1.024-4.032a7.671 7.671 0 0 1 2.848-2.816c1.216-.704 2.571-1.056 4.064-1.056 1.173 0 2.261.224 3.264.672a7.072 7.072 0 0 1 2.592 1.888l-1.92 1.92a4.385 4.385 0 0 0-1.728-1.248c-.661-.299-1.397-.448-2.208-.448-.96 0-1.813.224-2.56.672a4.588 4.588 0 0 0-1.76 1.792c-.427.768-.64 1.653-.64 2.656 0 1.003.213 1.888.64 2.656a4.818 4.818 0 0 0 1.76 1.824c.747.448 1.6.672 2.56.672.811 0 1.547-.139 2.208-.416a4.994 4.994 0 0 0 1.76-1.28l1.888 1.92a7.204 7.204 0 0 1-2.592 1.888c-1.003.448-2.091.672-3.264.672Zm-1.024 6.368c-.747 0-1.419-.107-2.016-.32a7.147 7.147 0 0 1-1.728-.832l1.312-1.568c.256.256.565.459.928.608.384.149.821.224 1.312.224.64 0 1.109-.096 1.408-.288.299-.192.448-.437.448-.736s-.149-.555-.448-.768c-.299-.213-.747-.32-1.344-.32h-1.408l.992-3.104h2.176l-.736 2.304-1.056-.864c1.301-.043 2.336.203 3.104.736.789.555 1.184 1.248 1.184 2.08 0 .832-.373 1.515-1.12 2.048-.747.533-1.749.8-3.008.8Zm16.623-6.368c-1.493 0-2.837-.352-4.032-1.056a7.918 7.918 0 0 1-2.848-2.848c-.704-1.216-1.056-2.571-1.056-4.064 0-1.472.352-2.795 1.056-3.968a7.918 7.918 0 0 1 2.848-2.848c1.195-.704 2.539-1.056 4.032-1.056 1.472 0 2.805.352 4 1.056a7.605 7.605 0 0 1 2.88 2.816c.704 1.195 1.056 2.528 1.056 4 0 1.493-.352 2.848-1.056 4.064a7.844 7.844 0 0 1-2.88 2.848c-1.195.704-2.528 1.056-4 1.056Zm0-2.784c.96 0 1.813-.224 2.56-.672a4.818 4.818 0 0 0 1.76-1.824c.427-.789.64-1.685.64-2.688 0-.981-.224-1.856-.672-2.624a4.588 4.588 0 0 0-1.76-1.792c-.725-.448-1.568-.672-2.528-.672s-1.813.224-2.56.672a4.588 4.588 0 0 0-1.76 1.792c-.427.768-.64 1.643-.64 2.624 0 1.003.213 1.899.64 2.688a4.818 4.818 0 0 0 1.76 1.824c.747.448 1.6.672 2.56.672ZM387.004 131v-3.552h5.856c1.045 0 1.856-.32 2.432-.96a3.22 3.22 0 0 0 .896-2.272c0-.597-.128-1.141-.384-1.632a2.724 2.724 0 0 0-1.152-1.152c-.491-.299-1.088-.448-1.792-.448h-5.856v-3.52h5.376c.896 0 1.61-.224 2.144-.672.554-.448.832-1.12.832-2.016 0-.917-.278-1.6-.832-2.048-.534-.448-1.248-.672-2.144-.672h-5.376v-3.552h5.888c1.493 0 2.741.277 3.744.832 1.024.533 1.792 1.248 2.304 2.144a5.6 5.6 0 0 1 .768 2.88c0 1.28-.395 2.389-1.184 3.328-.768.917-1.899 1.6-3.392 2.048l.192-1.408c1.664.469 2.944 1.248 3.84 2.336.917 1.067 1.376 2.357 1.376 3.872 0 1.195-.299 2.283-.896 3.264-.576.96-1.43 1.739-2.56 2.336-1.11.576-2.464.864-4.064.864h-6.016Zm-3.2 0v-22.496h4.32V131h-4.32Zm19.963 0v-15.456h4.224V131h-4.224Zm2.112-17.952c-.682 0-1.248-.224-1.696-.672-.448-.469-.672-1.045-.672-1.728 0-.661.224-1.227.672-1.696.448-.469 1.014-.704 1.696-.704.704 0 1.27.235 1.696.704.448.469.672 1.035.672 1.696 0 .683-.224 1.259-.672 1.728-.426.448-.992.672-1.696.672Zm13.314 18.272c-1.558 0-2.966-.352-4.224-1.056a8.445 8.445 0 0 1-2.976-2.912c-.726-1.237-1.088-2.613-1.088-4.128 0-1.515.362-2.869 1.088-4.064a7.872 7.872 0 0 1 2.976-2.88c1.258-.725 2.656-1.088 4.192-1.088 1.578 0 2.986.363 4.224 1.088a7.886 7.886 0 0 1 2.976 2.88c.725 1.195 1.088 2.549 1.088 4.064 0 1.515-.363 2.891-1.088 4.128a8.128 8.128 0 0 1-2.976 2.912c-1.238.704-2.635 1.056-4.192 1.056Zm-.032-3.904c.789 0 1.482-.171 2.08-.512a3.599 3.599 0 0 0 1.408-1.472c.341-.64.512-1.365.512-2.176 0-.811-.171-1.525-.512-2.144a3.66 3.66 0 0 0-1.408-1.44c-.598-.363-1.291-.544-2.08-.544-.768 0-1.451.181-2.048.544a3.646 3.646 0 0 0-1.408 1.44c-.342.619-.512 1.333-.512 2.144 0 .811.17 1.536.512 2.176.341.619.81 1.109 1.408 1.472.597.341 1.28.512 2.048.512Zm17.674 10.432c-1.642 0-3.093-.299-4.352-.896-1.258-.576-2.261-1.397-3.008-2.464l2.656-2.656c.598.704 1.259 1.237 1.984 1.6.747.384 1.643.576 2.688.576 1.302 0 2.326-.331 3.072-.992.769-.661 1.153-1.579 1.153-2.752v-3.872l.703-3.392-.672-3.392v-4.064h4.16V130.2c0 1.536-.362 2.869-1.087 4-.705 1.152-1.686 2.048-2.944 2.688-1.259.64-2.71.96-4.353.96Zm-.192-7.264c-1.386 0-2.634-.331-3.744-.992a7.329 7.329 0 0 1-2.624-2.784c-.618-1.173-.928-2.485-.928-3.936s.31-2.752.928-3.904a7.145 7.145 0 0 1 2.624-2.72c1.11-.683 2.358-1.024 3.744-1.024 1.152 0 2.166.224 3.04.672.896.448 1.601 1.067 2.112 1.856.512.768.79 1.675.832 2.72v4.864c-.042 1.024-.33 1.941-.863 2.752-.513.789-1.217 1.408-2.113 1.856-.874.427-1.877.64-3.008.64Zm.832-3.808c.768 0 1.43-.16 1.984-.48a3.616 3.616 0 0 0 1.344-1.376c.32-.597.48-1.269.48-2.016 0-.768-.16-1.44-.48-2.016a3.394 3.394 0 0 0-1.344-1.344c-.554-.341-1.216-.512-1.984-.512s-1.44.171-2.016.512a3.344 3.344 0 0 0-1.344 1.376c-.32.576-.48 1.237-.48 1.984 0 .725.16 1.387.48 1.984.32.576.768 1.035 1.344 1.376.576.341 1.248.512 2.016.512Zm19.044 4.544c-1.622 0-3.062-.341-4.32-1.024a8.114 8.114 0 0 1-3.008-2.88c-.726-1.216-1.088-2.603-1.088-4.16 0-1.536.352-2.901 1.056-4.096a7.937 7.937 0 0 1 2.944-2.88c1.237-.725 2.613-1.088 4.128-1.088 1.493 0 2.805.341 3.936 1.024a6.949 6.949 0 0 1 2.688 2.752c.661 1.152.992 2.464.992 3.936 0 .277-.022.565-.064.864a6.55 6.55 0 0 1-.16.96l-12.992.032v-3.136l11.04-.032-1.696 1.312c-.043-.917-.214-1.685-.512-2.304-.278-.619-.694-1.088-1.248-1.408-.534-.341-1.195-.512-1.984-.512-.832 0-1.558.192-2.176.576-.619.363-1.099.885-1.44 1.568-.32.661-.48 1.451-.48 2.368 0 .939.17 1.76.512 2.464a3.951 3.951 0 0 0 1.536 1.6c.661.363 1.429.544 2.304.544.789 0 1.504-.128 2.144-.384a4.67 4.67 0 0 0 1.664-1.216l2.464 2.464a7.132 7.132 0 0 1-2.752 1.984c-1.067.448-2.23.672-3.488.672Zm20.544-.32v-8.864c0-.917-.288-1.664-.864-2.24-.576-.576-1.322-.864-2.24-.864-.597 0-1.13.128-1.6.384a2.897 2.897 0 0 0-1.12 1.088c-.256.469-.384 1.013-.384 1.632l-1.632-.832c0-1.216.256-2.272.768-3.168a5.686 5.686 0 0 1 2.176-2.144c.939-.512 1.995-.768 3.168-.768 1.131 0 2.144.288 3.04.864a5.996 5.996 0 0 1 2.112 2.208c.512.896.768 1.867.768 2.912V131h-4.192Zm-10.4 0v-15.456h4.192V131h-4.192Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_1362_9941",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h483v123.801H0z"
                    })
                })
            })
        ]
    });
};
$3ab21868e19617a7$var$BrFullWhiteLogo.defaultProps = {
    viewBox: "0 0 483 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $3ab21868e19617a7$var$BrDefaultLogo = function BrDefaultLogo(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_1442_10030)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M99.039 51.067c-3.398-2.03-7.633-3.045-12.696-3.045-3.667 0-7.032.717-10.095 2.146a22.232 22.232 0 0 0-3.897 2.316V26.657H58.155v72.181h14.196v-24.06c0-2.597.481-4.907 1.45-6.94.965-2.03 2.348-3.608 4.147-4.743 1.8-1.13 3.865-1.698 6.199-1.698 2.334 0 4.414.615 6.049 1.848 1.631 1.232 2.866 2.844 3.7 4.84.833 1.998 1.249 4.162 1.249 6.49v24.26h14.193V73.178c0-5.256-.867-9.748-2.597-13.48-1.734-3.727-4.298-6.605-7.696-8.634l-.006.003ZM150.535 74.48c0 2.33-.484 4.444-1.449 6.34-.966 1.894-2.299 3.378-3.999 4.44-1.701 1.066-3.616 1.597-5.747 1.597-3.533 0-6.231-1.113-8.096-3.346-1.868-2.23-2.801-5.142-2.801-8.736V49.416h-13.995v25.857c0 4.86.816 9.17 2.451 12.93 1.631 3.761 4.148 6.707 7.549 8.835 3.398 2.132 7.761 3.194 13.096 3.194 3.063 0 5.699-.534 7.896-1.597a13.485 13.485 0 0 0 5.298-4.525v1.815c0 3.03-.535 4.943-1.599 7.238-1.066 2.295-2.582 4.092-4.548 5.391-1.967 1.298-4.384 1.946-7.247 1.946-3.198 0-5.882-.735-8.049-2.197-2.166-1.466-3.816-3.262-4.946-5.391l-11.694 5.904c2.265 4.594 5.514 8.104 9.746 10.534 4.231 2.429 9.279 3.644 15.146 3.644 5.463 0 10.245-1.182 14.345-3.543 4.097-2.364 7.298-5.689 9.596-9.984 2.299-4.292 3.449-9.301 3.449-15.025V49.419h-14.396v25.06h-.006ZM204.925 72.077a28.562 28.562 0 0 0-6.548-2.352c-2.335-.535-4.534-1-6.596-1.4-2.068-.4-3.751-.95-5.048-1.65-1.3-.702-1.949-1.717-1.949-3.051 0-.866.266-1.615.798-2.25.532-.634 1.265-1.135 2.2-1.502.932-.367 1.964-.55 3.099-.55 2 0 3.849.436 5.547 1.302 1.698.869 2.914 2.2 3.649 4.003l10.496-5.901c-1.001-1.934-2.385-3.701-4.148-5.301-1.766-1.6-3.948-2.901-6.548-3.901-2.597-1-5.696-1.502-9.298-1.502-4.064 0-7.597.702-10.594 2.102-3.001 1.4-5.317 3.3-6.949 5.7-1.634 2.4-2.447 5.101-2.447 8.101 0 3.2.648 5.752 1.948 7.653a12.746 12.746 0 0 0 5.048 4.352c2.065 1 4.265 1.767 6.596 2.301 2.331.535 4.513 1 6.548 1.4 2.032.4 3.715.916 5.047 1.55 1.333.635 2 1.617 2 2.951 0 1-.317 1.85-.951 2.552-.633.702-1.5 1.236-2.6 1.6-1.099.367-2.414.55-3.948.55-2.465 0-4.53-.452-6.198-1.35-1.667-.901-3.066-2.352-4.199-4.352l-10.496 5.901c2.065 3.668 4.881 6.453 8.446 8.352 3.565 1.9 7.947 2.85 13.147 2.85 3.733 0 7.196-.683 10.394-2.05 3.198-1.368 5.762-3.266 7.699-5.701 1.93-2.433 2.899-5.316 2.899-8.653 0-3.066-.667-5.534-2-7.403a13.848 13.848 0 0 0-5.047-4.351h.003ZM230.889 49.42h-14.195v49.418h14.195V49.42ZM414.906 51.514c-3.566-2.328-8.049-3.495-13.446-3.495-3.933 0-7.433.782-10.496 2.346-3.066 1.564-5.499 3.728-7.298 6.49a16.76 16.76 0 0 0-1.157 2.092 16.921 16.921 0 0 0-1.094-2.093c-1.697-2.76-4.097-4.925-7.196-6.489-3.099-1.564-6.781-2.346-11.046-2.346-5.332 0-9.782 1.164-13.344 3.495-3.565 2.331-6.249 5.409-8.048 9.235-1.799 3.83-2.699 8.038-2.699 12.629v25.457h14.196V75.673c0-2.528.364-4.841 1.1-6.94.732-2.095 1.897-3.775 3.499-5.04 1.599-1.263 3.733-1.896 6.399-1.896s4.632.615 6.297 1.848c1.664 1.232 2.866 2.895 3.598 4.99.732 2.095 1.1 4.441 1.1 7.038v23.162h14.196V75.572c0-2.528.382-4.842 1.15-6.94.765-2.095 1.949-3.758 3.548-4.99 1.599-1.23 3.7-1.848 6.297-1.848 2.597 0 4.713.633 6.347 1.895 1.632 1.266 2.834 2.946 3.599 5.042.765 2.095 1.15 4.44 1.15 7.038v23.063h14.196V73.375c0-4.66-.917-8.886-2.749-12.68-1.835-3.793-4.534-6.852-8.097-9.184l-.002.003ZM480 72.936c0-4.5-.977-8.635-2.926-12.408-1.951-3.772-4.746-6.799-8.383-9.082-3.637-2.284-8.069-3.424-13.293-3.424-5.224 0-9.459 1.176-13.293 3.525-3.838 2.35-6.829 5.495-8.978 9.432-2.149 3.937-3.225 8.256-3.225 12.954 0 5.23 1.157 9.811 3.473 13.748 2.313 3.937 5.505 7.014 9.573 9.232 4.067 2.218 8.646 3.325 13.738 3.325 5.093 0 9.803-1.209 13.739-3.623 3.936-2.415 6.96-5.839 9.076-10.274l-10.813-5.46c-1.126 2.251-2.761 4.006-4.91 5.263-2.149 1.256-4.549 1.886-7.194 1.886-2.776 0-5.176-.612-7.193-1.835-2.017-1.224-3.571-2.928-4.662-5.113a13.588 13.588 0 0 1-1.252-3.97h36.52v-4.17l.003-.006Zm-35.911-3.674a13.04 13.04 0 0 1 2.035-4.516c.957-1.355 2.215-2.433 3.769-3.227 1.554-.794 3.356-1.19 5.406-1.19 2.051 0 3.736.382 5.257 1.14a9.913 9.913 0 0 1 3.721 3.175c.959 1.359 1.539 2.896 1.736 4.615h-21.924v.003ZM40.537 51.565c-4.034-2.36-8.613-3.543-13.744-3.543-5.132 0-9.713 1.131-13.745 3.394-4.034 2.262-7.214 5.343-9.545 9.235C1.166 64.546 0 68.865 0 75.088v46.515h14.196V95.588c1.04.812 2.17 1.549 3.398 2.203 3.063 1.63 6.398 2.444 9.997 2.444 5.131 0 9.647-1.116 13.544-3.343 3.9-2.23 6.948-5.325 9.145-9.286 2.2-3.957 3.3-8.5 3.3-13.628 0-4.725-1.166-9.05-3.5-12.978-2.334-3.928-5.514-7.07-9.546-9.435h.003Zm-13.744 35.48c-7.104 0-12.86-5.784-12.86-12.918 0-7.133 5.759-12.918 12.86-12.918 7.1 0 12.86 5.784 12.86 12.918 0 7.134-5.76 12.918-12.86 12.918ZM262.763 48.022c-14.824 0-26.841 11.689-26.841 26.108 0 14.42 12.017 26.108 26.841 26.108 14.823 0 26.84-11.688 26.84-26.108s-12.017-26.108-26.84-26.108Zm0 39.03c-7.089 0-12.836-5.785-12.836-12.922 0-7.136 5.747-12.921 12.836-12.921s12.836 5.784 12.836 12.921-5.747 12.921-12.836 12.921Z",
                        fill: "#190032"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M314.181 37.023c10.237 0 18.535-8.288 18.535-18.511C332.716 8.288 324.418 0 314.181 0c-10.236 0-18.535 8.288-18.535 18.512 0 10.223 8.299 18.511 18.535 18.511Z",
                        fill: "url(#paint0_linear_1442_10030)"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M314.181 100.36c4.762 0 8.622-3.855 8.622-8.61 0-4.757-3.86-8.612-8.622-8.612-4.762 0-8.622 3.855-8.622 8.611s3.86 8.611 8.622 8.611Z",
                        fill: "url(#paint1_linear_1442_10030)"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M314.181 72.742c7.002 0 12.678-5.669 12.678-12.661 0-6.993-5.676-12.662-12.678-12.662-7.001 0-12.677 5.669-12.677 12.662 0 6.992 5.676 12.661 12.677 12.661Z",
                        fill: "url(#paint2_linear_1442_10030)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M229.334 130.32c-1.259 0-2.39-.277-3.392-.832a6.132 6.132 0 0 1-2.304-2.368c-.555-1.003-.832-2.165-.832-3.488V114.8h2.88v8.704c0 .832.138 1.557.416 2.176a3.194 3.194 0 0 0 1.28 1.376c.554.32 1.205.48 1.952.48 1.13 0 2.016-.352 2.656-1.056.64-.725.96-1.717.96-2.976V114.8h2.88v8.832c0 1.323-.278 2.485-.832 3.488a6.146 6.146 0 0 1-2.304 2.368c-.96.555-2.08.832-3.36.832Zm10.58-.32v-15.2h2.88V130h-2.88Zm10.272 0v-9.184c0-1.131-.352-2.016-1.056-2.656-.683-.661-1.547-.992-2.592-.992-.704 0-1.334.149-1.888.448a3.596 3.596 0 0 0-1.344 1.248c-.342.533-.512 1.173-.512 1.92l-1.184-.576c0-1.152.245-2.155.736-3.008a5.311 5.311 0 0 1 2.08-1.984c.874-.491 1.856-.736 2.944-.736 1.066 0 2.026.235 2.88.704a5.1 5.1 0 0 1 2.048 1.984c.512.853.768 1.867.768 3.04V130h-2.88Zm10.272 0v-9.184c0-1.131-.352-2.016-1.056-2.656-.683-.661-1.536-.992-2.56-.992-.704 0-1.344.149-1.92.448a3.596 3.596 0 0 0-1.344 1.248c-.342.533-.512 1.173-.512 1.92l-1.632-.576c.064-1.173.373-2.176.928-3.008a5.974 5.974 0 0 1 2.208-1.984 6.024 6.024 0 0 1 2.944-.736c1.109 0 2.101.235 2.976.704a5.318 5.318 0 0 1 2.08 1.984c.533.853.8 1.877.8 3.072V130h-2.912Zm18.767.32a9.063 9.063 0 0 1-2.432-.32 8.819 8.819 0 0 1-2.08-.96 7.488 7.488 0 0 1-1.664-1.504l1.856-1.856c.555.683 1.195 1.195 1.92 1.536.725.32 1.536.48 2.432.48.896 0 1.589-.149 2.08-.448.491-.32.736-.757.736-1.312s-.203-.981-.608-1.28c-.384-.32-.885-.576-1.504-.768a31.892 31.892 0 0 0-1.984-.608 12.056 12.056 0 0 1-1.952-.8 4.341 4.341 0 0 1-1.536-1.312c-.384-.555-.576-1.291-.576-2.208 0-.917.224-1.707.672-2.368.448-.683 1.067-1.205 1.856-1.568.811-.363 1.781-.544 2.912-.544 1.195 0 2.251.213 3.168.64a5.436 5.436 0 0 1 2.304 1.856l-1.856 1.856a4.265 4.265 0 0 0-1.6-1.28c-.619-.299-1.323-.448-2.112-.448-.832 0-1.472.149-1.92.448-.427.277-.64.672-.64 1.184 0 .512.192.907.576 1.184.384.277.885.512 1.504.704.64.192 1.301.395 1.984.608a9.18 9.18 0 0 1 1.952.8c.619.341 1.12.8 1.504 1.376.405.576.608 1.333.608 2.272 0 1.429-.512 2.56-1.536 3.392-1.003.832-2.357 1.248-4.064 1.248Zm16.088 0c-1.514 0-2.88-.341-4.096-1.024a7.844 7.844 0 0 1-2.88-2.848c-.704-1.195-1.056-2.549-1.056-4.064 0-1.493.342-2.837 1.024-4.032a7.751 7.751 0 0 1 2.816-2.816c1.195-.704 2.528-1.056 4-1.056 1.408 0 2.646.32 3.712.96a6.586 6.586 0 0 1 2.528 2.656c.619 1.131.928 2.411.928 3.84 0 .213-.01.448-.032.704a7.94 7.94 0 0 1-.128.832h-12.832v-2.4h11.296l-1.056.928c0-1.024-.181-1.888-.544-2.592-.362-.725-.874-1.28-1.536-1.664-.661-.405-1.461-.608-2.4-.608-.981 0-1.845.213-2.592.64a4.38 4.38 0 0 0-1.728 1.792c-.405.768-.608 1.675-.608 2.72 0 1.067.214 2.005.64 2.816a4.633 4.633 0 0 0 1.824 1.856c.79.427 1.696.64 2.72.64.854 0 1.632-.149 2.336-.448a4.84 4.84 0 0 0 1.856-1.344l1.856 1.888a7.057 7.057 0 0 1-2.688 1.952 8.436 8.436 0 0 1-3.36.672Zm10.34-.32v-15.2h2.88V130h-2.88Zm2.88-8.672-1.088-.48c0-1.941.448-3.488 1.344-4.64.896-1.152 2.187-1.728 3.872-1.728.768 0 1.462.139 2.08.416.619.256 1.195.693 1.728 1.312l-1.888 1.952a2.878 2.878 0 0 0-1.056-.736c-.384-.149-.832-.224-1.344-.224-1.066 0-1.941.341-2.624 1.024-.682.683-1.024 1.717-1.024 3.104ZM323.656 130l-6.976-15.2h3.2l5.6 12.832h-1.856l5.632-12.832h3.072l-6.976 15.2h-1.696Zm11.384 0v-15.2h2.88V130h-2.88Zm1.44-18.24c-.534 0-.971-.171-1.312-.512-.342-.363-.512-.811-.512-1.344 0-.512.17-.939.512-1.28.341-.363.778-.544 1.312-.544.533 0 .97.181 1.312.544.341.341.512.768.512 1.28 0 .533-.171.981-.512 1.344-.342.341-.779.512-1.312.512Zm12.852 18.56c-1.493 0-2.848-.352-4.064-1.056a7.918 7.918 0 0 1-2.848-2.848c-.683-1.216-1.024-2.56-1.024-4.032 0-1.493.341-2.837 1.024-4.032a7.671 7.671 0 0 1 2.848-2.816c1.216-.704 2.571-1.056 4.064-1.056 1.173 0 2.261.224 3.264.672a7.072 7.072 0 0 1 2.592 1.888l-1.92 1.92a4.385 4.385 0 0 0-1.728-1.248c-.661-.299-1.397-.448-2.208-.448-.96 0-1.813.224-2.56.672a4.588 4.588 0 0 0-1.76 1.792c-.427.768-.64 1.653-.64 2.656 0 1.003.213 1.888.64 2.656a4.818 4.818 0 0 0 1.76 1.824c.747.448 1.6.672 2.56.672.811 0 1.547-.139 2.208-.416a4.994 4.994 0 0 0 1.76-1.28l1.888 1.92a7.204 7.204 0 0 1-2.592 1.888c-1.003.448-2.091.672-3.264.672Zm-1.024 6.368c-.747 0-1.419-.107-2.016-.32a7.147 7.147 0 0 1-1.728-.832l1.312-1.568c.256.256.565.459.928.608.384.149.821.224 1.312.224.64 0 1.109-.096 1.408-.288.299-.192.448-.437.448-.736s-.149-.555-.448-.768c-.299-.213-.747-.32-1.344-.32h-1.408l.992-3.104h2.176l-.736 2.304-1.056-.864c1.301-.043 2.336.203 3.104.736.789.555 1.184 1.248 1.184 2.08 0 .832-.373 1.515-1.12 2.048-.747.533-1.749.8-3.008.8Zm16.623-6.368c-1.493 0-2.837-.352-4.032-1.056a7.918 7.918 0 0 1-2.848-2.848c-.704-1.216-1.056-2.571-1.056-4.064 0-1.472.352-2.795 1.056-3.968a7.918 7.918 0 0 1 2.848-2.848c1.195-.704 2.539-1.056 4.032-1.056 1.472 0 2.805.352 4 1.056a7.605 7.605 0 0 1 2.88 2.816c.704 1.195 1.056 2.528 1.056 4 0 1.493-.352 2.848-1.056 4.064a7.844 7.844 0 0 1-2.88 2.848c-1.195.704-2.528 1.056-4 1.056Zm0-2.784c.96 0 1.813-.224 2.56-.672a4.818 4.818 0 0 0 1.76-1.824c.427-.789.64-1.685.64-2.688 0-.981-.224-1.856-.672-2.624a4.588 4.588 0 0 0-1.76-1.792c-.725-.448-1.568-.672-2.528-.672s-1.813.224-2.56.672a4.588 4.588 0 0 0-1.76 1.792c-.427.768-.64 1.643-.64 2.624 0 1.003.213 1.899.64 2.688a4.818 4.818 0 0 0 1.76 1.824c.747.448 1.6.672 2.56.672ZM384.228 130v-3.552h5.856c1.045 0 1.856-.32 2.432-.96a3.22 3.22 0 0 0 .896-2.272c0-.597-.128-1.141-.384-1.632a2.724 2.724 0 0 0-1.152-1.152c-.491-.299-1.088-.448-1.792-.448h-5.856v-3.52h5.376c.896 0 1.61-.224 2.144-.672.554-.448.832-1.12.832-2.016 0-.917-.278-1.6-.832-2.048-.534-.448-1.248-.672-2.144-.672h-5.376v-3.552h5.888c1.493 0 2.741.277 3.744.832 1.024.533 1.792 1.248 2.304 2.144a5.6 5.6 0 0 1 .768 2.88c0 1.28-.395 2.389-1.184 3.328-.768.917-1.899 1.6-3.392 2.048l.192-1.408c1.664.469 2.944 1.248 3.84 2.336.917 1.067 1.376 2.357 1.376 3.872 0 1.195-.299 2.283-.896 3.264-.576.96-1.43 1.739-2.56 2.336-1.11.576-2.464.864-4.064.864h-6.016Zm-3.2 0v-22.496h4.32V130h-4.32Zm19.963 0v-15.456h4.224V130h-4.224Zm2.112-17.952c-.682 0-1.248-.224-1.696-.672-.448-.469-.672-1.045-.672-1.728 0-.661.224-1.227.672-1.696.448-.469 1.014-.704 1.696-.704.704 0 1.27.235 1.696.704.448.469.672 1.035.672 1.696 0 .683-.224 1.259-.672 1.728-.426.448-.992.672-1.696.672Zm13.314 18.272c-1.558 0-2.966-.352-4.224-1.056a8.445 8.445 0 0 1-2.976-2.912c-.726-1.237-1.088-2.613-1.088-4.128 0-1.515.362-2.869 1.088-4.064a7.872 7.872 0 0 1 2.976-2.88c1.258-.725 2.656-1.088 4.192-1.088 1.578 0 2.986.363 4.224 1.088a7.886 7.886 0 0 1 2.976 2.88c.725 1.195 1.088 2.549 1.088 4.064 0 1.515-.363 2.891-1.088 4.128a8.128 8.128 0 0 1-2.976 2.912c-1.238.704-2.635 1.056-4.192 1.056Zm-.032-3.904c.789 0 1.482-.171 2.08-.512a3.599 3.599 0 0 0 1.408-1.472c.341-.64.512-1.365.512-2.176 0-.811-.171-1.525-.512-2.144a3.66 3.66 0 0 0-1.408-1.44c-.598-.363-1.291-.544-2.08-.544-.768 0-1.451.181-2.048.544a3.646 3.646 0 0 0-1.408 1.44c-.342.619-.512 1.333-.512 2.144 0 .811.17 1.536.512 2.176.341.619.81 1.109 1.408 1.472.597.341 1.28.512 2.048.512Zm17.674 10.432c-1.642 0-3.093-.299-4.352-.896-1.258-.576-2.261-1.397-3.008-2.464l2.656-2.656c.598.704 1.259 1.237 1.984 1.6.747.384 1.643.576 2.688.576 1.302 0 2.326-.331 3.072-.992.768-.661 1.152-1.579 1.152-2.752v-3.872l.704-3.392-.672-3.392v-4.064h4.16V129.2c0 1.536-.362 2.869-1.088 4-.704 1.152-1.685 2.048-2.944 2.688-1.258.64-2.709.96-4.352.96Zm-.192-7.264c-1.386 0-2.634-.331-3.744-.992a7.329 7.329 0 0 1-2.624-2.784c-.618-1.173-.928-2.485-.928-3.936s.31-2.752.928-3.904a7.145 7.145 0 0 1 2.624-2.72c1.11-.683 2.358-1.024 3.744-1.024 1.152 0 2.166.224 3.04.672.896.448 1.6 1.067 2.112 1.856.512.768.79 1.675.832 2.72v4.864c-.042 1.024-.33 1.941-.864 2.752-.512.789-1.216 1.408-2.112 1.856-.874.427-1.877.64-3.008.64Zm.832-3.808c.768 0 1.43-.16 1.984-.48a3.616 3.616 0 0 0 1.344-1.376c.32-.597.48-1.269.48-2.016 0-.768-.16-1.44-.48-2.016a3.394 3.394 0 0 0-1.344-1.344c-.554-.341-1.216-.512-1.984-.512s-1.44.171-2.016.512a3.344 3.344 0 0 0-1.344 1.376c-.32.576-.48 1.237-.48 1.984 0 .725.16 1.387.48 1.984.32.576.768 1.035 1.344 1.376.576.341 1.248.512 2.016.512Zm19.044 4.544c-1.622 0-3.062-.341-4.32-1.024a8.114 8.114 0 0 1-3.008-2.88c-.726-1.216-1.088-2.603-1.088-4.16 0-1.536.352-2.901 1.056-4.096a7.937 7.937 0 0 1 2.944-2.88c1.237-.725 2.613-1.088 4.128-1.088 1.493 0 2.805.341 3.936 1.024a6.949 6.949 0 0 1 2.688 2.752c.661 1.152.992 2.464.992 3.936 0 .277-.022.565-.064.864a6.55 6.55 0 0 1-.16.96l-12.992.032v-3.136l11.04-.032-1.696 1.312c-.043-.917-.214-1.685-.512-2.304-.278-.619-.694-1.088-1.248-1.408-.534-.341-1.195-.512-1.984-.512-.832 0-1.558.192-2.176.576-.619.363-1.099.885-1.44 1.568-.32.661-.48 1.451-.48 2.368 0 .939.17 1.76.512 2.464a3.951 3.951 0 0 0 1.536 1.6c.661.363 1.429.544 2.304.544.789 0 1.504-.128 2.144-.384a4.67 4.67 0 0 0 1.664-1.216l2.464 2.464a7.132 7.132 0 0 1-2.752 1.984c-1.067.448-2.23.672-3.488.672Zm20.544-.32v-8.864c0-.917-.288-1.664-.864-2.24-.576-.576-1.322-.864-2.24-.864-.597 0-1.13.128-1.6.384a2.897 2.897 0 0 0-1.12 1.088c-.256.469-.384 1.013-.384 1.632l-1.632-.832c0-1.216.256-2.272.768-3.168a5.686 5.686 0 0 1 2.176-2.144c.939-.512 1.995-.768 3.168-.768 1.131 0 2.144.288 3.04.864a5.996 5.996 0 0 1 2.112 2.208c.512.896.768 1.867.768 2.912V130h-4.192Zm-10.4 0v-15.456h4.192V130h-4.192Z",
                fill: "#190032"
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)("linearGradient", {
                        id: "paint0_linear_1442_10030",
                        x1: "314.181",
                        y1: "99.916",
                        x2: "314.181",
                        y2: "1.519",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                stopColor: "#50F"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                offset: ".5",
                                stopColor: "#7828F7"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                offset: "1",
                                stopColor: "#A055F0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("linearGradient", {
                        id: "paint1_linear_1442_10030",
                        x1: "314.181",
                        y1: "99.916",
                        x2: "314.181",
                        y2: "1.519",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                stopColor: "#50F"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                offset: ".5",
                                stopColor: "#7828F7"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                offset: "1",
                                stopColor: "#A055F0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("linearGradient", {
                        id: "paint2_linear_1442_10030",
                        x1: "314.181",
                        y1: "99.916",
                        x2: "314.181",
                        y2: "1.519",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                stopColor: "#50F"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                offset: ".5",
                                stopColor: "#7828F7"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("stop", {
                                offset: "1",
                                stopColor: "#A055F0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                        id: "clip0_1442_10030",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h480v123H0z"
                        })
                    })
                ]
            })
        ]
    });
};
$3ab21868e19617a7$var$BrDefaultLogo.defaultProps = {
    width: "480",
    height: "137",
    viewBox: "0 0 480 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $3ab21868e19617a7$var$allLogos = {
    "pt-BR": {
        default: $3ab21868e19617a7$var$BrDefaultLogo,
        monochrome: $3ab21868e19617a7$var$BrFullWhiteLogo
    },
    default: {
        default: $3ab21868e19617a7$var$DefaultDefaultLogo,
        monochrome: $3ab21868e19617a7$var$DefaultFullWhiteLogo
    }
};
const $3ab21868e19617a7$export$113a612889e1565d = ({ type: type = "default", ...otherProps })=>{
    const locale = (0, $1IWnK.useObservable)((0, $ghfIB.localeManager).locale);
    const Icon = $3ab21868e19617a7$var$allLogos[locale in $3ab21868e19617a7$var$allLogos ? locale : "default"][type];
    return /*#__PURE__*/ (0, $iKObn.jsx)(Icon, {
        ...otherProps
    });
};

});

parcelRegister("8miOT", function(module, exports) {

$parcel$export(module.exports, "ContactSupport", () => $ccbfe707e05737f2$export$d65ea6ee8960e96a);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $5UMQ1 = parcelRequire("5UMQ1");

var $1acTy = parcelRequire("1acTy");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
var $ccbfe707e05737f2$var$Mail = function Mail(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M20 21H4c-1.65 0-3-1.35-3-3V6c0-1.65 1.35-3 3-3h16c1.65 0 3 1.35 3 3v12c0 1.65-1.35 3-3 3ZM4 5c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H4Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.134 7.919a1 1 0 0 1 1.378-.315l4.956 3.113a1 1 0 0 0 1.064 0l4.956-3.113a1 1 0 1 1 1.063 1.694l-4.955 3.112a3 3 0 0 1-3.192 0L5.45 9.298a1 1 0 0 1-.315-1.38Z",
                fill: "currentColor"
            })
        ]
    });
};
$ccbfe707e05737f2$var$Mail.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $ccbfe707e05737f2$export$d65ea6ee8960e96a = ({ uiStyle: uiStyle = "primary" })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { countryConfig: countryConfig } = (0, $1acTy.useCountryConfig)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($ccbfe707e05737f2$var$ContactUsContainer, {
        uiStyle: uiStyle,
        onClick: ()=>{
            (0, $ghfIB.analyticsService).trackEvent({
                category: (0, $auPqo.AnalyticsCategory).COMMUNICATION,
                action: "contactCustomerSupport"
            });
            window.open(`mailto:${countryConfig?.customerSupportEmail}`);
        },
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($ccbfe707e05737f2$var$ContactUsTitle, {
                children: format("global.contactUs")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($ccbfe707e05737f2$var$Mail, {
                height: 20,
                width: 20
            })
        ]
    });
};
const $ccbfe707e05737f2$var$ContactUsContainer = (0, $5UMQ1.default).div`
	display: flex;
	place-items: center;
	cursor: pointer;
	color: ${({ uiStyle: uiStyle })=>uiStyle === "primary" ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).grey};
`;
const $ccbfe707e05737f2$var$ContactUsTitle = (0, $5UMQ1.default).div`
	font-weight: 600;
	margin-right: 8px;
`;

});
parcelRegister("1eHG3", function(module, exports) {

$parcel$export(module.exports, "useI18n", () => $ec9b92fd9fbd729c$export$3f3caade1c12f8c9);

var $iKObn = parcelRequire("iKObn");

var $bXTqq = parcelRequire("bXTqq");

var $dkAKF = parcelRequire("dkAKF");

var $1acTy = parcelRequire("1acTy");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $kXaMn = parcelRequire("kXaMn");

var $hEQyt = parcelRequire("hEQyt");

var $cD3aa = parcelRequire("cD3aa");

var $cfkGk = parcelRequire("cfkGk");

var $81g6h = parcelRequire("81g6h");

var $4zkdA = parcelRequire("4zkdA");
var $ec9b92fd9fbd729c$var$DateFormats;
(function(DateFormats) {
    DateFormats["FULL"] = "FULL";
    DateFormats["FULL_WITHOUT_YEAR"] = "FULL_WITHOUT_YEAR";
    DateFormats["FULL_WITH_WEEKDAY"] = "FULL_WITH_WEEKDAY";
    DateFormats["FULL_WITHOUT_YEAR_WITH_WEEKDAY"] = "FULL_WITHOUT_YEAR_WITH_WEEKDAY";
    DateFormats["MED"] = "MED";
    DateFormats["MED_WITHOUT_YEAR"] = "MED_WITHOUT_YEAR";
    DateFormats["MED_WITH_WEEKDAY"] = "MED_WITH_WEEKDAY";
    DateFormats["MED_WITHOUT_YEAR_WITH_WEEKDAY"] = "MED_WITHOUT_YEAR_WITH_WEEKDAY";
    DateFormats["SHORT"] = "SHORT";
})($ec9b92fd9fbd729c$var$DateFormats || ($ec9b92fd9fbd729c$var$DateFormats = {}));
const $ec9b92fd9fbd729c$var$getTagFormatters = (values)=>({
        color: (parts)=>/*#__PURE__*/ (0, $iKObn.jsx)("span", {
                style: {
                    color: values?.color ?? (0, $kKnoQ.colors).primary
                },
                children: parts
            }),
        grey: (parts)=>/*#__PURE__*/ (0, $iKObn.jsx)("span", {
                style: {
                    color: (0, $kKnoQ.colors).grey
                },
                children: parts
            }),
        boldSmall: (parts)=>/*#__PURE__*/ (0, $iKObn.jsx)("span", {
                className: "p-size-s-bold",
                children: parts
            }),
        strong: (parts)=>/*#__PURE__*/ (0, $iKObn.jsx)("span", {
                style: {
                    fontWeight: "bold"
                },
                children: parts
            }),
        link: (parts)=>/*#__PURE__*/ (0, $iKObn.jsx)("span", {
                "data-test": (values?.link).dataTest,
                onClick: (values?.link).onClick,
                style: {
                    cursor: "pointer"
                },
                className: (values?.link).className,
                children: parts
            }),
        link2: (parts)=>/*#__PURE__*/ (0, $iKObn.jsx)("span", {
                "data-test": (values?.link2).dataTest,
                onClick: (values?.link2).onClick,
                style: {
                    cursor: "pointer"
                },
                className: (0, $cfkGk.classNames)((values?.link2).className),
                children: parts
            }),
        element: ()=>values?.element
    });
function $ec9b92fd9fbd729c$export$3f3caade1c12f8c9() {
    const intl = (0, $4zkdA.default)();
    const { countryConfig: countryConfig } = (0, $1acTy.useCountryConfig)();
    const format = (0, $81g6h.useCallback)((key, values)=>intl.formatMessage({
            id: key
        }, {
            ...values,
            ...$ec9b92fd9fbd729c$var$getTagFormatters(values)
        }), [
        intl
    ]);
    const formatDuration = (0, $81g6h.useCallback)((timeInSecond)=>{
        const { hour: hour, minutes: minutes, seconds: seconds } = {
            hour: (0, $hEQyt.getTwoDigitStringFromNumber)(Math.floor(timeInSecond / 3600)),
            minutes: (0, $hEQyt.getTwoDigitStringFromNumber)(Math.floor(timeInSecond % 3600 / 60)),
            seconds: (0, $hEQyt.getTwoDigitStringFromNumber)(Math.floor(timeInSecond % 60))
        };
        return timeInSecond >= 3600 ? `${hour}:${minutes}:${seconds}` : `${minutes}:${seconds}`;
    }, []);
    const formatAge = (0, $81g6h.useCallback)((birthDate)=>(0, $kXaMn.now)().diff(birthDate, "years").toString(), []);
    const formatPercent = (0, $81g6h.useCallback)((numberInPercent)=>{
        const ratio = (0, $dkAKF.getPercentRatio)(numberInPercent);
        return intl.formatNumber(ratio, {
            style: "percent"
        });
    }, [
        intl
    ]);
    const formatRelativeDateTime = (0, $81g6h.useCallback)((date)=>{
        const duration = date.diff((0, $kXaMn.now)(), "minute");
        if (duration === 0) return format("global.now").toLowerCase();
        return date.fromNow();
    }, [
        format
    ]);
    const formatDateRelative = (0, $81g6h.useCallback)((date)=>{
        const daysFromNow = (0, $kXaMn.computeDiffInDays)((0, $kXaMn.now)(), date);
        switch(daysFromNow){
            case -1:
                return format("primereact.calendar.yesterday");
            case 0:
                return format("primereact.calendar.today");
            case 1:
                return format("primereact.calendar.tomorrow");
            default:
                return date.fromNow();
        }
    }, [
        format
    ]);
    const formatUnit = (0, $81g6h.useCallback)((givenUnit, unit)=>{
        switch(givenUnit){
            case 0:
                return "";
            case 1:
                return format($ec9b92fd9fbd729c$var$RELATIVE_TIME_WORDING_RECORD[unit].singular);
            default:
                return format($ec9b92fd9fbd729c$var$RELATIVE_TIME_WORDING_RECORD[unit].plural).replace("%d", givenUnit.toString());
        }
    }, [
        format
    ]);
    const formatProgramDuration = (0, $81g6h.useCallback)((date1, date2)=>{
        const { days: days, weeks: weeks, month: month } = (0, $kXaMn.computeDiffBetween)(date1, date2);
        if (days === 0 && month === 0 && weeks === 0) return format("global.empty");
        if (month === 0) {
            if (weeks === 0) return formatUnit(days, "day");
            if (days === 0) return formatUnit(weeks, "week");
            return [
                formatUnit(weeks, "week"),
                formatUnit(days, "day")
            ].join(", ");
        }
        return [
            formatUnit(month, "month"),
            formatUnit(days + weeks * 7, "day")
        ].join(", ");
    }, [
        format,
        formatUnit
    ]);
    const formatDurationLeft = (0, $81g6h.useCallback)((durationInDays, monthPrecisionThreshold, calendarMode)=>{
        const isMonthPrecision = (0, $lTdpc.isNotNil)(monthPrecisionThreshold) && durationInDays > monthPrecisionThreshold;
        const durationInMonth = (0, $kXaMn.daysToMonth)(durationInDays, calendarMode);
        const finalDuration = isMonthPrecision ? durationInMonth : durationInDays;
        const formattedTimeLeft = formatUnit(finalDuration, isMonthPrecision ? "month" : "day");
        return durationInDays === 0 ? format("global.timeLeft.none") : format("global.timeLeft", {
            remainingTime: finalDuration,
            formattedRemainingTime: formattedTimeLeft
        });
    }, [
        format,
        formatUnit
    ]);
    const getEndWeekDay = (0, $81g6h.useCallback)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).weekdays()[(0, $hEQyt.positiveModulo)((0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).localeData().firstDayOfWeek() - 1, 7)], []);
    const formatDate = (0, $81g6h.useCallback)((date, dateFormat)=>{
        if ((0, $lTdpc.isNil)(countryConfig) || (0, $lTdpc.isNil)(date)) return "-";
        return date.format(countryConfig.dateFormats[dateFormat]);
    }, [
        countryConfig
    ]);
    const formatDateFull = (date)=>formatDate(date, "FULL");
    const formatDateFullWithoutYear = (date)=>formatDate(date, "FULL_WITHOUT_YEAR");
    const formatDateFullWithWeekday = (date)=>formatDate(date, "FULL_WITH_WEEKDAY");
    const formatDateFullWithoutYearWithWeekday = (date)=>formatDate(date, "FULL_WITHOUT_YEAR_WITH_WEEKDAY");
    const formatDateMed = (date)=>formatDate(date, "MED");
    const formatDateMedWithoutYear = (date)=>formatDate(date, "MED_WITHOUT_YEAR");
    const formatDateMedWithWeekday = (date)=>formatDate(date, "MED_WITH_WEEKDAY");
    const formatDateMedWithoutYearWithWeekday = (date)=>formatDate(date, "MED_WITHOUT_YEAR_WITH_WEEKDAY");
    const formatDateShort = (date)=>formatDate(date, "SHORT");
    return {
        ...intl,
        language: (0, $bXTqq.getLanguageFromIntlLocale)(intl.locale),
        format: format,
        formatAge: formatAge,
        formatDuration: formatDuration,
        formatPercent: formatPercent,
        formatRelativeDateTime: formatRelativeDateTime,
        formatDateRelative: formatDateRelative,
        formatProgramDuration: formatProgramDuration,
        getEndWeekDay: getEndWeekDay,
        formatDurationLeft: formatDurationLeft,
        formatDateFull: formatDateFull,
        formatDateFullWithoutYear: formatDateFullWithoutYear,
        formatDateFullWithoutYearWithWeekday: formatDateFullWithoutYearWithWeekday,
        formatDateFullWithWeekday: formatDateFullWithWeekday,
        formatDateMedWithoutYear: formatDateMedWithoutYear,
        formatDateMedWithoutYearWithWeekday: formatDateMedWithoutYearWithWeekday,
        formatDateShort: formatDateShort,
        formatDateMedWithWeekday: formatDateMedWithWeekday,
        formatDateMed: formatDateMed
    };
}
const $ec9b92fd9fbd729c$var$RELATIVE_TIME_WORDING_RECORD = {
    day: {
        singular: "global.relativeTime.day",
        plural: "global.relativeTime.days"
    },
    week: {
        singular: "global.relativeTime.week",
        plural: "global.relativeTime.weeks"
    },
    month: {
        singular: "global.relativeTime.month",
        plural: "global.relativeTime.months"
    }
};

});
parcelRegister("dkAKF", function(module, exports) {

$parcel$export(module.exports, "getPercentRatio", () => $5ffa04d2b874f7a8$export$6f7af00acaa1463c);

var $hEQyt = parcelRequire("hEQyt");
const $5ffa04d2b874f7a8$export$6f7af00acaa1463c = (numberInPercent)=>{
    const roundNumber = Math.round(numberInPercent);
    let ratio = 0;
    if (numberInPercent === 100) ratio = 1;
    else if (numberInPercent !== 0) ratio = (0, $hEQyt.clamp)(roundNumber / 100, 0.01, 0.99);
    return ratio;
};

});
parcelRegister("hEQyt", function(module, exports) {

$parcel$export(module.exports, "clamp", () => $9c6319ce2610460b$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "getTwoDigitStringFromNumber", () => $9c6319ce2610460b$export$cf5cea85a5b82711);
$parcel$export(module.exports, "positiveModulo", () => $9c6319ce2610460b$export$ad34c56f55029159);
$parcel$export(module.exports, "calculateMediaDurationMinutes", () => $9c6319ce2610460b$export$c79d9d347f25ed12);
function $9c6319ce2610460b$export$7d15b64cf5a3a4c4(number, min, max) {
    return Math.max(min, Math.min(number, max));
}
function $9c6319ce2610460b$export$cf5cea85a5b82711(val) {
    return val.toString().padStart(2, "0");
}
function $9c6319ce2610460b$export$ad34c56f55029159(number, modulo) {
    return (number % modulo + modulo) % modulo;
}
const $9c6319ce2610460b$export$c79d9d347f25ed12 = (durationInSeconds)=>Math.max(1, Math.round(durationInSeconds / 60));

});


parcelRegister("1acTy", function(module, exports) {

$parcel$export(module.exports, "useCountryConfig", () => $a04d9c0e026b608a$export$a0afd794016de4d3);

var $bXTqq = parcelRequire("bXTqq");

var $ghfIB = parcelRequire("ghfIB");

var $6Yxa2 = parcelRequire("6Yxa2");

var $lTdpc = parcelRequire("lTdpc");

var $880Ip = parcelRequire("880Ip");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
function $a04d9c0e026b608a$export$a0afd794016de4d3() {
    const locale = (0, $1IWnK.useObservable)((0, $ghfIB.localeManager).locale);
    const countryCode = (0, $1IWnK.useObservable)((0, $ghfIB.localeManager).countryCode);
    const serverConfigStatus = (0, $1IWnK.useObservable)((0, $ghfIB.serverConfigManager).serverConfigStatus);
    const legalDocumentsMetadata = (0, $1IWnK.useObservable)((0, $ghfIB.legalContentManager).legalDocumentsMetadata);
    const countryConfig = (0, $81g6h.useMemo)(()=>{
        if (!serverConfigStatus.available || !legalDocumentsMetadata) return null;
        const serverConfig = (0, $ghfIB.serverConfigManager).serverConfig;
        const _locale = (0, $bXTqq.intlLocaleToLocale)(locale);
        const language = (0, $bXTqq.getLanguageFromIntlLocale)(locale);
        return {
            customerSupportEmail: serverConfig.customerSupportEmails[countryCode],
            ptBiogenPrivacyNoticeUrl: legalDocumentsMetadata.ptBiogenPrivacyNoticeUrls[countryCode],
            patientBiogenPrivacyNoticeUrl: legalDocumentsMetadata.patientBiogenPrivacyNoticeUrls[countryCode],
            faqUrl: serverConfig.faqUrls[countryCode][language],
            landingPages: serverConfig.landingPages[countryCode][language],
            dateFormats: serverConfig.dateFormats[countryCode][_locale],
            patientLegalAge: serverConfig.patientLegalAges[countryCode],
            ptPhysiomePrivacyNoticeVersion: legalDocumentsMetadata.ptPhysiomePrivacyNoticeVersions[countryCode][_locale],
            ptPhysiomeTermsOfUseVersion: legalDocumentsMetadata.ptPhysiomeTermsOfUseVersions[countryCode][_locale]
        };
    }, [
        countryCode,
        locale,
        serverConfigStatus.available,
        legalDocumentsMetadata
    ]);
    const shouldDisplayLegalAgeDisclaimer = (0, $81g6h.useCallback)((patient)=>!(0, $6Yxa2.isPendingPatient)(patient) && (0, $lTdpc.isNotNil)(patient.birthDate) && (0, $lTdpc.isNotNil)(countryConfig) && !(0, $880Ip.isOldEnough)(patient.birthDate, countryConfig.patientLegalAge), [
        countryConfig
    ]);
    return {
        shouldDisplayLegalAgeDisclaimer: shouldDisplayLegalAgeDisclaimer,
        countryConfig: countryConfig
    };
}

});
parcelRegister("880Ip", function(module, exports) {

$parcel$export(module.exports, "isOldEnough", () => $6795a390874a68dd$export$b07cf7395e2ac800);

var $kXaMn = parcelRequire("kXaMn");
function $6795a390874a68dd$export$b07cf7395e2ac800(birthDate, minimalAge) {
    const years = (0, $kXaMn.now)().diff(birthDate, "years");
    return years >= minimalAge;
}

});


parcelRegister("kKnoQ", function(module, exports) {

$parcel$export(module.exports, "colors", () => $06b1193da32781ba$export$8f45430ccf837300);
const $06b1193da32781ba$var$getCSSValue = (variableName)=>window.getComputedStyle(document.body).getPropertyValue(variableName);
const $06b1193da32781ba$export$8f45430ccf837300 = {
    // Primary
    primary: $06b1193da32781ba$var$getCSSValue("--primary-color"),
    primaryDark: $06b1193da32781ba$var$getCSSValue("--primary-dark"),
    primaryDark50: $06b1193da32781ba$var$getCSSValue("--primary-dark-50"),
    primary25: $06b1193da32781ba$var$getCSSValue("--primary-25"),
    primary10: $06b1193da32781ba$var$getCSSValue("--primary-10"),
    primaryBackground: $06b1193da32781ba$var$getCSSValue("--primary-background"),
    // Secondary
    validation: $06b1193da32781ba$var$getCSSValue("--validation"),
    validationDark: $06b1193da32781ba$var$getCSSValue("--validation-dark"),
    validation25: $06b1193da32781ba$var$getCSSValue("--validation-25"),
    validation10: $06b1193da32781ba$var$getCSSValue("--validation-10"),
    rejection: $06b1193da32781ba$var$getCSSValue("--rejection"),
    rejectionDark: $06b1193da32781ba$var$getCSSValue("--rejection-dark"),
    rejection25: $06b1193da32781ba$var$getCSSValue("--rejection-25"),
    rejection10: $06b1193da32781ba$var$getCSSValue("--rejection-10"),
    warn: $06b1193da32781ba$var$getCSSValue("--warn"),
    warnDark: $06b1193da32781ba$var$getCSSValue("--warn-dark"),
    // Greyscale
    black: $06b1193da32781ba$var$getCSSValue("--black"),
    grey: $06b1193da32781ba$var$getCSSValue("--grey"),
    grey80: $06b1193da32781ba$var$getCSSValue("--grey-80"),
    grey50: $06b1193da32781ba$var$getCSSValue("--grey-50"),
    grey25: $06b1193da32781ba$var$getCSSValue("--grey-25"),
    grey10: $06b1193da32781ba$var$getCSSValue("--grey-10"),
    grey5: $06b1193da32781ba$var$getCSSValue("--grey-5"),
    grey3: $06b1193da32781ba$var$getCSSValue("--grey-3"),
    white: $06b1193da32781ba$var$getCSSValue("--white"),
    neutral10: $06b1193da32781ba$var$getCSSValue("--neutral-10"),
    // Colors outside of Design System
    orange: "#ff8214",
    yellow: "#FFAF00",
    transparent: "transparent",
    videoBackground: "#eae8fA",
    mobilePrimaryBlue: "#5500ff",
    mobilePrimaryBlue50: "#AA80FF",
    mobilePrimaryBlue15: "#E1D2FF",
    mobileDarkPrimaryBlue: "#330099",
    demoRequestBlue: "#00C3E6",
    onboardingPrimary: "#A055F0",
    onboardingPrimaryDark: "#603390",
    primary75: "#7279EB" // TODO: Add to Prime React Designer
};

});

parcelRegister("4zkdA", function(module, exports) {

$parcel$export(module.exports, "default", () => $353a1d3898cb3d69$export$2e2bcd8739ae039);

var $81g6h = parcelRequire("81g6h");

var $hkEGL = parcelRequire("hkEGL");

var $yGWuH = parcelRequire("yGWuH");
function $353a1d3898cb3d69$export$2e2bcd8739ae039() {
    var intl = $81g6h.useContext((0, $hkEGL.Context));
    (0, $yGWuH.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("hkEGL", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $c9e3dddd8ef11581$export$2881499e37b75b9a);
$parcel$export(module.exports, "Context", () => $c9e3dddd8ef11581$export$841858b892ce1f4c);

var $6NkbF = parcelRequire("6NkbF");

var $81g6h = parcelRequire("81g6h");

var $khy2w = parcelRequire("khy2w");

var $yGWuH = parcelRequire("yGWuH");
function $c9e3dddd8ef11581$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $c9e3dddd8ef11581$var$IntlContext = typeof window !== "undefined" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $81g6h.createContext(null)) : $81g6h.createContext(null);
var $c9e3dddd8ef11581$var$IntlConsumer = $c9e3dddd8ef11581$var$IntlContext.Consumer, $c9e3dddd8ef11581$var$IntlProvider = $c9e3dddd8ef11581$var$IntlContext.Provider;
var $c9e3dddd8ef11581$export$2881499e37b75b9a = $c9e3dddd8ef11581$var$IntlProvider;
var $c9e3dddd8ef11581$export$841858b892ce1f4c = $c9e3dddd8ef11581$var$IntlContext;
function $c9e3dddd8ef11581$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $81g6h.createElement($c9e3dddd8ef11581$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $yGWuH.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $81g6h.createElement(WrappedComponent, (0, $6NkbF.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($c9e3dddd8ef11581$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($khy2w)))($81g6h.forwardRef(function(props, ref) {
        return $81g6h.createElement(WithIntl, (0, $6NkbF.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($khy2w)))(WithIntl, WrappedComponent);
}

});
parcelRegister("6NkbF", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $4f26fa6d6ad7689b$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $4f26fa6d6ad7689b$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $4f26fa6d6ad7689b$export$3c9a16f847548506);
$parcel$export(module.exports, "__spreadArray", () => $4f26fa6d6ad7689b$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $4f26fa6d6ad7689b$var$extendStatics = function(d, b) {
    $4f26fa6d6ad7689b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $4f26fa6d6ad7689b$var$extendStatics(d, b);
};
function $4f26fa6d6ad7689b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $4f26fa6d6ad7689b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4f26fa6d6ad7689b$export$18ce0697a983be9b = function() {
    $4f26fa6d6ad7689b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4f26fa6d6ad7689b$export$18ce0697a983be9b.apply(this, arguments);
};
function $4f26fa6d6ad7689b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4f26fa6d6ad7689b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4f26fa6d6ad7689b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4f26fa6d6ad7689b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $4f26fa6d6ad7689b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $4f26fa6d6ad7689b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $4f26fa6d6ad7689b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $4f26fa6d6ad7689b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4f26fa6d6ad7689b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4f26fa6d6ad7689b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $4f26fa6d6ad7689b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $4f26fa6d6ad7689b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $4f26fa6d6ad7689b$export$45d3717a4c69092e(o, m, p);
}
function $4f26fa6d6ad7689b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4f26fa6d6ad7689b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4f26fa6d6ad7689b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4f26fa6d6ad7689b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4f26fa6d6ad7689b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4f26fa6d6ad7689b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $4f26fa6d6ad7689b$export$10c90e4f7922046c(v) {
    return this instanceof $4f26fa6d6ad7689b$export$10c90e4f7922046c ? (this.v = v, this) : new $4f26fa6d6ad7689b$export$10c90e4f7922046c(v);
}
function $4f26fa6d6ad7689b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4f26fa6d6ad7689b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4f26fa6d6ad7689b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4f26fa6d6ad7689b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $4f26fa6d6ad7689b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4f26fa6d6ad7689b$export$19a8beecd37a4c45 === "function" ? $4f26fa6d6ad7689b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4f26fa6d6ad7689b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $4f26fa6d6ad7689b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $4f26fa6d6ad7689b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4f26fa6d6ad7689b$export$45d3717a4c69092e(result, mod, k);
    }
    $4f26fa6d6ad7689b$var$__setModuleDefault(result, mod);
    return result;
}
function $4f26fa6d6ad7689b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4f26fa6d6ad7689b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $4f26fa6d6ad7689b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $4f26fa6d6ad7689b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $4f26fa6d6ad7689b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $4f26fa6d6ad7689b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $4f26fa6d6ad7689b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $4f26fa6d6ad7689b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $4f26fa6d6ad7689b$export$2e2bcd8739ae039 = {
    __extends: $4f26fa6d6ad7689b$export$a8ba968b8961cb8a,
    __assign: $4f26fa6d6ad7689b$export$18ce0697a983be9b,
    __rest: $4f26fa6d6ad7689b$export$3c9a16f847548506,
    __decorate: $4f26fa6d6ad7689b$export$29e00dfd3077644b,
    __param: $4f26fa6d6ad7689b$export$d5ad3fd78186038f,
    __metadata: $4f26fa6d6ad7689b$export$f1db080c865becb9,
    __awaiter: $4f26fa6d6ad7689b$export$1050f835b63b671e,
    __generator: $4f26fa6d6ad7689b$export$67ebef60e6f28a6,
    __createBinding: $4f26fa6d6ad7689b$export$45d3717a4c69092e,
    __exportStar: $4f26fa6d6ad7689b$export$f33643c0debef087,
    __values: $4f26fa6d6ad7689b$export$19a8beecd37a4c45,
    __read: $4f26fa6d6ad7689b$export$8d051b38c9118094,
    __spread: $4f26fa6d6ad7689b$export$afc72e2116322959,
    __spreadArrays: $4f26fa6d6ad7689b$export$6388937ca91ccae8,
    __spreadArray: $4f26fa6d6ad7689b$export$1216008129fb82ed,
    __await: $4f26fa6d6ad7689b$export$10c90e4f7922046c,
    __asyncGenerator: $4f26fa6d6ad7689b$export$e427f37a30a4de9b,
    __asyncDelegator: $4f26fa6d6ad7689b$export$bbd80228419bb833,
    __asyncValues: $4f26fa6d6ad7689b$export$e3b29a3d6162315f,
    __makeTemplateObject: $4f26fa6d6ad7689b$export$4fb47efe1390b86f,
    __importStar: $4f26fa6d6ad7689b$export$c21735bcef00d192,
    __importDefault: $4f26fa6d6ad7689b$export$da59b14a69baef04,
    __classPrivateFieldGet: $4f26fa6d6ad7689b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $4f26fa6d6ad7689b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $4f26fa6d6ad7689b$export$81fdc39f203e4e04,
    __addDisposableResource: $4f26fa6d6ad7689b$export$88ac25d8e944e405,
    __disposeResources: $4f26fa6d6ad7689b$export$8f076105dc360e92
};

});

parcelRegister("yGWuH", function(module, exports) {

$parcel$export(module.exports, "invariantIntlContext", () => $06847c913a98c6c5$export$45c4bbf6e55bba1f);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $06847c913a98c6c5$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "assignUniqueKeysToParts", () => $06847c913a98c6c5$export$cfec03d26465fa63);
$parcel$export(module.exports, "shallowEqual", () => $06847c913a98c6c5$export$d36bdfa510afb180);

var $6NkbF = parcelRequire("6NkbF");

var $81g6h = parcelRequire("81g6h");

var $5JgwF = parcelRequire("5JgwF");

var $iWpxp = parcelRequire("iWpxp");
function $06847c913a98c6c5$export$45c4bbf6e55bba1f(intl) {
    (0, $5JgwF.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $06847c913a98c6c5$export$b52f8d6fc0d47415 = (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, (0, $iWpxp.DEFAULT_INTL_CONFIG)), {
    textComponent: $81g6h.Fragment
});
function $06847c913a98c6c5$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($81g6h.Children.toArray(parts));
    };
}
function $06847c913a98c6c5$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("5JgwF", function(module, exports) {

$parcel$export(module.exports, "invariant", () => $42bdf96fb8529b7c$export$f5708dca728d7177);
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $42bdf96fb8529b7c$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $42bdf96fb8529b7c$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
function $42bdf96fb8529b7c$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $42bdf96fb8529b7c$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $42bdf96fb8529b7c$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $42bdf96fb8529b7c$export$3fae2929ed23c202(map, pl, field) {
    return $42bdf96fb8529b7c$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $42bdf96fb8529b7c$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $42bdf96fb8529b7c$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === "literal";
}
function $42bdf96fb8529b7c$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
function $42bdf96fb8529b7c$export$e4e12d57dd938668(target, name, value) {
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
}
var $42bdf96fb8529b7c$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $42bdf96fb8529b7c$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("iWpxp", function(module, exports) {

$parcel$export(module.exports, "filterProps", () => $dca1740f6d6f2a11$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $dca1740f6d6f2a11$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $dca1740f6d6f2a11$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $dca1740f6d6f2a11$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $dca1740f6d6f2a11$export$4ee1db8ce44a209b);

var $6NkbF = parcelRequire("6NkbF");
parcelRequire("q7Vsy");
var $4hlvu = parcelRequire("4hlvu");

var $dXi6A = parcelRequire("dXi6A");

var $ktjzr = parcelRequire("ktjzr");
function $dca1740f6d6f2a11$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $dca1740f6d6f2a11$var$defaultErrorHandler = function(error) {};
var $dca1740f6d6f2a11$var$defaultWarnHandler = function(warning) {};
var $dca1740f6d6f2a11$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $dca1740f6d6f2a11$var$defaultErrorHandler,
    onWarn: $dca1740f6d6f2a11$var$defaultWarnHandler
};
function $dca1740f6d6f2a11$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $dca1740f6d6f2a11$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $dca1740f6d6f2a11$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $dca1740f6d6f2a11$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $dXi6A.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $6NkbF.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $dca1740f6d6f2a11$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $dXi6A.strategies).variadic
    });
    var getNumberFormat = (0, $dXi6A.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $6NkbF.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $dca1740f6d6f2a11$var$createFastMemoizeCache(cache.number),
        strategy: (0, $dXi6A.strategies).variadic
    });
    var getPluralRules = (0, $dXi6A.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $6NkbF.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $dca1740f6d6f2a11$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $dXi6A.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $dXi6A.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $4hlvu.IntlMessageFormat)(message, locales, overrideFormats, (0, $6NkbF.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $dca1740f6d6f2a11$var$createFastMemoizeCache(cache.message),
            strategy: (0, $dXi6A.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $dXi6A.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $6NkbF.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $dca1740f6d6f2a11$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $dXi6A.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $dXi6A.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $6NkbF.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $dca1740f6d6f2a11$var$createFastMemoizeCache(cache.list),
            strategy: (0, $dXi6A.strategies).variadic
        }),
        getDisplayNames: (0, $dXi6A.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $6NkbF.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $dca1740f6d6f2a11$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $dXi6A.strategies).variadic
        })
    };
}
function $dca1740f6d6f2a11$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $ktjzr.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("q7Vsy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", () => (parcelRequire("fHOge")).ErrorCode);
$parcel$export(module.exports, "FormatError", () => (parcelRequire("fHOge")).FormatError);
$parcel$export(module.exports, "isFormatXMLElementFn", () => (parcelRequire("eSQuK")).isFormatXMLElementFn);

$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("4hlvu")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $4hlvu = parcelRequire("4hlvu");
parcelRequire("fHOge");
parcelRequire("eSQuK");
var $04e893b70723a0b9$export$2e2bcd8739ae039 = (0, $4hlvu.IntlMessageFormat);

});
parcelRegister("4hlvu", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", () => $31d96ecc68c7ccac$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $6NkbF = parcelRequire("6NkbF");

var $23pH2 = parcelRequire("23pH2");

var $dXi6A = parcelRequire("dXi6A");

var $eSQuK = parcelRequire("eSQuK");
// -- MessageFormat --------------------------------------------------------
function $31d96ecc68c7ccac$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $6NkbF.__assign)((0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $31d96ecc68c7ccac$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $31d96ecc68c7ccac$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $6NkbF.__assign)({}, defaultConfig));
}
function $31d96ecc68c7ccac$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $31d96ecc68c7ccac$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $dXi6A.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $6NkbF.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $31d96ecc68c7ccac$var$createFastMemoizeCache(cache.number),
            strategy: (0, $dXi6A.strategies).variadic
        }),
        getDateTimeFormat: (0, $dXi6A.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $6NkbF.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $31d96ecc68c7ccac$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $dXi6A.strategies).variadic
        }),
        getPluralRules: (0, $dXi6A.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $6NkbF.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $31d96ecc68c7ccac$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $dXi6A.strategies).variadic
        })
    };
}
var $31d96ecc68c7ccac$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $eSQuK.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $eSQuK.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $6NkbF.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $31d96ecc68c7ccac$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $31d96ecc68c7ccac$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $23pH2.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("23pH2", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("au5gb")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("au5gb")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("au5gb")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("au5gb")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("au5gb")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("au5gb")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("au5gb")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("au5gb")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("au5gb")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("au5gb")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("au5gb")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("au5gb")).TYPE);

$parcel$export(module.exports, "parse", () => $17efcab47bdbb686$export$98e6a39c04603d36);

var $6NkbF = parcelRequire("6NkbF");

var $2bhzL = parcelRequire("2bhzL");

var $28pol = parcelRequire("28pol");

var $au5gb = parcelRequire("au5gb");
function $17efcab47bdbb686$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $au5gb.isSelectElement)(el) || (0, $au5gb.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $17efcab47bdbb686$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $au5gb.isNumberElement)(el) && (0, $au5gb.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $au5gb.isDateElement)(el) || (0, $au5gb.isTimeElement)(el)) && (0, $au5gb.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $au5gb.isTagElement)(el)) $17efcab47bdbb686$var$pruneLocation(el.children);
    });
}
function $17efcab47bdbb686$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $6NkbF.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $28pol.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $2bhzL.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $17efcab47bdbb686$var$pruneLocation(result.val);
    return result.val;
}
var $17efcab47bdbb686$export$d3c1bfa0f7d806e9 = (0, $28pol.Parser);

});
parcelRegister("2bhzL", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", () => $196a3e06a24e8c2b$export$896afd8541959ee5);
var $196a3e06a24e8c2b$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($196a3e06a24e8c2b$export$896afd8541959ee5 || ($196a3e06a24e8c2b$export$896afd8541959ee5 = {}));

});

parcelRegister("28pol", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $18e0065be529a496$export$7acfa6ed01010e37);

var $6NkbF = parcelRequire("6NkbF");

var $2bhzL = parcelRequire("2bhzL");

var $au5gb = parcelRequire("au5gb");

var $cQqxK = parcelRequire("cQqxK");
parcelRequire("73EtB");
var $iyyB9 = parcelRequire("iyyB9");
var $a3flk = parcelRequire("a3flk");

var $akiHc = parcelRequire("akiHc");
var $18e0065be529a496$var$_a;
var $18e0065be529a496$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $cQqxK.SPACE_SEPARATOR_REGEX).source, "*"));
var $18e0065be529a496$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $cQqxK.SPACE_SEPARATOR_REGEX).source, "*$"));
function $18e0065be529a496$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $18e0065be529a496$var$hasNativeStartsWith = !!String.prototype.startsWith && "_a".startsWith("a", 1);
var $18e0065be529a496$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $18e0065be529a496$var$hasNativeFromEntries = !!Object.fromEntries;
var $18e0065be529a496$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $18e0065be529a496$var$hasTrimStart = !!String.prototype.trimStart;
var $18e0065be529a496$var$hasTrimEnd = !!String.prototype.trimEnd;
var $18e0065be529a496$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $18e0065be529a496$var$isSafeInteger = $18e0065be529a496$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $18e0065be529a496$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $18e0065be529a496$var$re = $18e0065be529a496$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $18e0065be529a496$var$REGEX_SUPPORTS_U_AND_Y = (($18e0065be529a496$var$_a = $18e0065be529a496$var$re.exec("a")) === null || $18e0065be529a496$var$_a === void 0 ? void 0 : $18e0065be529a496$var$_a[0]) === "a";
} catch (_) {
    $18e0065be529a496$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $18e0065be529a496$var$startsWith = $18e0065be529a496$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $18e0065be529a496$var$fromCodePoint = $18e0065be529a496$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $18e0065be529a496$var$fromEntries = // native
$18e0065be529a496$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $18e0065be529a496$var$codePointAt = $18e0065be529a496$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $18e0065be529a496$var$trimStart = $18e0065be529a496$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($18e0065be529a496$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $18e0065be529a496$var$trimEnd = $18e0065be529a496$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($18e0065be529a496$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $18e0065be529a496$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $18e0065be529a496$var$matchIdentifierAtIndex;
if ($18e0065be529a496$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $18e0065be529a496$var$IDENTIFIER_PREFIX_RE_1 = $18e0065be529a496$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $18e0065be529a496$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $18e0065be529a496$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $18e0065be529a496$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$18e0065be529a496$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $18e0065be529a496$var$codePointAt(s, index);
        if (c === undefined || $18e0065be529a496$var$_isWhiteSpace(c) || $18e0065be529a496$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $18e0065be529a496$var$fromCodePoint.apply(void 0, match);
};
var $18e0065be529a496$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $au5gb.TYPE).pound,
                    location: $18e0065be529a496$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $2bhzL.ErrorKind).UNMATCHED_CLOSING_TAG, $18e0065be529a496$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $18e0065be529a496$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $au5gb.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $18e0065be529a496$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$18e0065be529a496$var$_isAlpha(this.char())) return this.error((0, $2bhzL.ErrorKind).INVALID_TAG, $18e0065be529a496$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $2bhzL.ErrorKind).UNMATCHED_CLOSING_TAG, $18e0065be529a496$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $2bhzL.ErrorKind).INVALID_TAG, $18e0065be529a496$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $au5gb.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $18e0065be529a496$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $2bhzL.ErrorKind).UNCLOSED_TAG, $18e0065be529a496$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $2bhzL.ErrorKind).INVALID_TAG, $18e0065be529a496$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $18e0065be529a496$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $18e0065be529a496$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $au5gb.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$18e0065be529a496$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $18e0065be529a496$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $18e0065be529a496$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $2bhzL.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $18e0065be529a496$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $2bhzL.ErrorKind).EMPTY_ARGUMENT, $18e0065be529a496$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $2bhzL.ErrorKind).MALFORMED_ARGUMENT, $18e0065be529a496$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $2bhzL.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $18e0065be529a496$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $au5gb.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $18e0065be529a496$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $2bhzL.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $18e0065be529a496$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $2bhzL.ErrorKind).MALFORMED_ARGUMENT, $18e0065be529a496$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $18e0065be529a496$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $18e0065be529a496$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $2bhzL.ErrorKind).EXPECT_ARGUMENT_TYPE, $18e0065be529a496$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $18e0065be529a496$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $2bhzL.ErrorKind).EXPECT_ARGUMENT_STYLE, $18e0065be529a496$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $18e0065be529a496$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $18e0065be529a496$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $18e0065be529a496$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $18e0065be529a496$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $au5gb.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $2bhzL.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $akiHc.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $au5gb.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $iyyB9.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $au5gb.TYPE).date : (0, $au5gb.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $au5gb.TYPE).number : argType === "date" ? (0, $au5gb.TYPE).date : (0, $au5gb.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $2bhzL.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $18e0065be529a496$var$createLocation(typeEndPosition_1, (0, $6NkbF.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $2bhzL.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $18e0065be529a496$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $2bhzL.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $2bhzL.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $18e0065be529a496$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $au5gb.TYPE).select,
                        value: value,
                        options: $18e0065be529a496$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $au5gb.TYPE).plural,
                        value: value,
                        options: $18e0065be529a496$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $2bhzL.ErrorKind).INVALID_ARGUMENT_TYPE, $18e0065be529a496$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $2bhzL.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $18e0065be529a496$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $2bhzL.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $18e0065be529a496$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $a3flk.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $2bhzL.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $au5gb.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $a3flk.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $2bhzL.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $2bhzL.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $18e0065be529a496$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $2bhzL.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $2bhzL.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $2bhzL.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $2bhzL.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $18e0065be529a496$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $18e0065be529a496$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $2bhzL.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $2bhzL.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $18e0065be529a496$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $2bhzL.ErrorKind).MISSING_OTHER_CLAUSE, $18e0065be529a496$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $18e0065be529a496$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$18e0065be529a496$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $18e0065be529a496$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($18e0065be529a496$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $18e0065be529a496$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $18e0065be529a496$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $18e0065be529a496$var$_isAlphaOrSlash(codepoint) {
    return $18e0065be529a496$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $18e0065be529a496$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $18e0065be529a496$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $18e0065be529a496$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("au5gb", function(module, exports) {

$parcel$export(module.exports, "TYPE", () => $7a20c947b62acb2b$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $7a20c947b62acb2b$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $7a20c947b62acb2b$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $7a20c947b62acb2b$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $7a20c947b62acb2b$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $7a20c947b62acb2b$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $7a20c947b62acb2b$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $7a20c947b62acb2b$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $7a20c947b62acb2b$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $7a20c947b62acb2b$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $7a20c947b62acb2b$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $7a20c947b62acb2b$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $7a20c947b62acb2b$export$7680c41f1a55f4cf);
var $7a20c947b62acb2b$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($7a20c947b62acb2b$export$b87f371cbc396fcf || ($7a20c947b62acb2b$export$b87f371cbc396fcf = {}));
var $7a20c947b62acb2b$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($7a20c947b62acb2b$export$906452485466fa53 || ($7a20c947b62acb2b$export$906452485466fa53 = {}));
function $7a20c947b62acb2b$export$cfa10c5697238752(el) {
    return el.type === $7a20c947b62acb2b$export$b87f371cbc396fcf.literal;
}
function $7a20c947b62acb2b$export$4f55724281bdfaf9(el) {
    return el.type === $7a20c947b62acb2b$export$b87f371cbc396fcf.argument;
}
function $7a20c947b62acb2b$export$e11187b219e191e1(el) {
    return el.type === $7a20c947b62acb2b$export$b87f371cbc396fcf.number;
}
function $7a20c947b62acb2b$export$32d811605da75f40(el) {
    return el.type === $7a20c947b62acb2b$export$b87f371cbc396fcf.date;
}
function $7a20c947b62acb2b$export$34ec46f596b1702f(el) {
    return el.type === $7a20c947b62acb2b$export$b87f371cbc396fcf.time;
}
function $7a20c947b62acb2b$export$dcfe1c11d168b5a1(el) {
    return el.type === $7a20c947b62acb2b$export$b87f371cbc396fcf.select;
}
function $7a20c947b62acb2b$export$6c796d116f0a4fbc(el) {
    return el.type === $7a20c947b62acb2b$export$b87f371cbc396fcf.plural;
}
function $7a20c947b62acb2b$export$c0ece297bdd0c082(el) {
    return el.type === $7a20c947b62acb2b$export$b87f371cbc396fcf.pound;
}
function $7a20c947b62acb2b$export$5c83de34745812b(el) {
    return el.type === $7a20c947b62acb2b$export$b87f371cbc396fcf.tag;
}
function $7a20c947b62acb2b$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $7a20c947b62acb2b$export$906452485466fa53.number);
}
function $7a20c947b62acb2b$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $7a20c947b62acb2b$export$906452485466fa53.dateTime);
}
function $7a20c947b62acb2b$export$f0ac572c1121c662(value) {
    return {
        type: $7a20c947b62acb2b$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $7a20c947b62acb2b$export$425e864b0ba114f1(value, style) {
    return {
        type: $7a20c947b62acb2b$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("cQqxK", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $959eee50aad747cf$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $959eee50aad747cf$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $959eee50aad747cf$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("73EtB", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("iyyB9")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("a3flk")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("a3flk")).parseNumberSkeletonFromString);
parcelRequire("iyyB9");
parcelRequire("a3flk");

});
parcelRegister("iyyB9", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", () => $d8263d75608b99cd$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $d8263d75608b99cd$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $d8263d75608b99cd$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($d8263d75608b99cd$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

});

parcelRegister("a3flk", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $751615f9eddc9c79$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $751615f9eddc9c79$export$47c6f8480bda3e11);

var $6NkbF = parcelRequire("6NkbF");

var $8rO6Z = parcelRequire("8rO6Z");
function $751615f9eddc9c79$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $8rO6Z.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $751615f9eddc9c79$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $751615f9eddc9c79$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $751615f9eddc9c79$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $751615f9eddc9c79$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $751615f9eddc9c79$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $751615f9eddc9c79$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($751615f9eddc9c79$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $751615f9eddc9c79$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $751615f9eddc9c79$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$751615f9eddc9c79$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $751615f9eddc9c79$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $751615f9eddc9c79$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $751615f9eddc9c79$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $751615f9eddc9c79$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $6NkbF.__assign)((0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, all), $751615f9eddc9c79$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $6NkbF.__assign)((0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, all), $751615f9eddc9c79$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            case "rounding-mode-floor":
                result.roundingMode = "floor";
                continue;
            case "rounding-mode-ceiling":
                result.roundingMode = "ceil";
                continue;
            case "rounding-mode-down":
                result.roundingMode = "trunc";
                continue;
            case "rounding-mode-up":
                result.roundingMode = "expand";
                continue;
            case "rounding-mode-half-even":
                result.roundingMode = "halfEven";
                continue;
            case "rounding-mode-half-down":
                result.roundingMode = "halfTrunc";
                continue;
            case "rounding-mode-half-up":
                result.roundingMode = "halfExpand";
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($751615f9eddc9c79$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($751615f9eddc9c79$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($751615f9eddc9c79$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($751615f9eddc9c79$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, result), $751615f9eddc9c79$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($751615f9eddc9c79$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, result), $751615f9eddc9c79$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $751615f9eddc9c79$var$parseSign(token.stem);
        if (signOpts) result = (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $751615f9eddc9c79$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("8rO6Z", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $6267b77e26db8c83$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $6267b77e26db8c83$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("akiHc", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", () => $784a463a4db6d9df$export$29c5368be8904d27);

var $bzg7r = parcelRequire("bzg7r");
function $784a463a4db6d9df$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $784a463a4db6d9df$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $784a463a4db6d9df$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $bzg7r.timeData)[regionTag || ""] || (0, $bzg7r.timeData)[languageTag || ""] || (0, $bzg7r.timeData)["".concat(languageTag, "-001")] || (0, $bzg7r.timeData)["001"];
    return hourCycles[0];
}

});
parcelRegister("bzg7r", function(module, exports) {

$parcel$export(module.exports, "timeData", () => $86bf77842999ef46$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $86bf77842999ef46$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("dXi6A", function(module, exports) {

$parcel$export(module.exports, "memoize", () => $a28ed464f9761aa0$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $a28ed464f9761aa0$export$c5491a8691a23b9e);
//
// Main
//
function $a28ed464f9761aa0$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $a28ed464f9761aa0$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $a28ed464f9761aa0$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $a28ed464f9761aa0$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $a28ed464f9761aa0$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $a28ed464f9761aa0$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $a28ed464f9761aa0$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $a28ed464f9761aa0$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $a28ed464f9761aa0$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $a28ed464f9761aa0$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $a28ed464f9761aa0$var$monadic : $a28ed464f9761aa0$var$variadic;
    return $a28ed464f9761aa0$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $a28ed464f9761aa0$var$strategyVariadic(fn, options) {
    return $a28ed464f9761aa0$var$assemble(fn, this, $a28ed464f9761aa0$var$variadic, options.cache.create(), options.serializer);
}
function $a28ed464f9761aa0$var$strategyMonadic(fn, options) {
    return $a28ed464f9761aa0$var$assemble(fn, this, $a28ed464f9761aa0$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $a28ed464f9761aa0$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $a28ed464f9761aa0$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$a28ed464f9761aa0$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$a28ed464f9761aa0$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $a28ed464f9761aa0$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $a28ed464f9761aa0$var$ObjectWithoutPrototypeCache();
    }
};
var $a28ed464f9761aa0$export$c5491a8691a23b9e = {
    variadic: $a28ed464f9761aa0$var$strategyVariadic,
    monadic: $a28ed464f9761aa0$var$strategyMonadic
};

});

parcelRegister("eSQuK", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", () => $ad5ed4383f203eb3$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $ad5ed4383f203eb3$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $ad5ed4383f203eb3$export$275d4a3bb5f66fda);
parcelRequire("23pH2");
var $au5gb = parcelRequire("au5gb");

var $fHOge = parcelRequire("fHOge");
var $ad5ed4383f203eb3$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($ad5ed4383f203eb3$export$49694c2877b44c57 || ($ad5ed4383f203eb3$export$49694c2877b44c57 = {}));
function $ad5ed4383f203eb3$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $ad5ed4383f203eb3$export$49694c2877b44c57.literal || part.type !== $ad5ed4383f203eb3$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $ad5ed4383f203eb3$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $ad5ed4383f203eb3$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $au5gb.isLiteralElement)(els[0])) return [
        {
            type: $ad5ed4383f203eb3$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $au5gb.isLiteralElement)(el)) {
            result.push({
                type: $ad5ed4383f203eb3$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $au5gb.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $ad5ed4383f203eb3$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $fHOge.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $au5gb.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $ad5ed4383f203eb3$export$49694c2877b44c57.literal : $ad5ed4383f203eb3$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $au5gb.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $au5gb.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $ad5ed4383f203eb3$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $au5gb.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $au5gb.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $ad5ed4383f203eb3$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $au5gb.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $au5gb.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $ad5ed4383f203eb3$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $au5gb.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$ad5ed4383f203eb3$export$df0c12a2d414a163(formatFn)) throw new (0, $fHOge.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $ad5ed4383f203eb3$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $ad5ed4383f203eb3$export$49694c2877b44c57.literal : $ad5ed4383f203eb3$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $au5gb.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $fHOge.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $ad5ed4383f203eb3$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $au5gb.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $fHOge.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $fHOge.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $fHOge.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $ad5ed4383f203eb3$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $ad5ed4383f203eb3$var$mergeLiteral(result);
}

});
parcelRegister("fHOge", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", () => $b6f1dbe821365ac1$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $b6f1dbe821365ac1$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $b6f1dbe821365ac1$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $b6f1dbe821365ac1$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $b6f1dbe821365ac1$export$8bfc137e4d23fdf0);

var $6NkbF = parcelRequire("6NkbF");
var $b6f1dbe821365ac1$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($b6f1dbe821365ac1$export$d4e71bc0b80dc0fb || ($b6f1dbe821365ac1$export$d4e71bc0b80dc0fb = {}));
var $b6f1dbe821365ac1$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $6NkbF.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $b6f1dbe821365ac1$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $6NkbF.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $b6f1dbe821365ac1$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($b6f1dbe821365ac1$export$7369836851cc1329);
var $b6f1dbe821365ac1$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $6NkbF.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $b6f1dbe821365ac1$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($b6f1dbe821365ac1$export$7369836851cc1329);
var $b6f1dbe821365ac1$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $6NkbF.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $b6f1dbe821365ac1$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($b6f1dbe821365ac1$export$7369836851cc1329);

});




parcelRegister("ktjzr", function(module, exports) {

$parcel$export(module.exports, "UnsupportedFormatterError", () => $ee75b2629cafb731$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $ee75b2629cafb731$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $ee75b2629cafb731$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $ee75b2629cafb731$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $ee75b2629cafb731$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $ee75b2629cafb731$export$2ddcb436d0aa3688);

var $6NkbF = parcelRequire("6NkbF");
var $ee75b2629cafb731$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($ee75b2629cafb731$export$557d6acb76e8a244 || ($ee75b2629cafb731$export$557d6acb76e8a244 = {}));
var $ee75b2629cafb731$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $6NkbF.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $ee75b2629cafb731$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $6NkbF.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $ee75b2629cafb731$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($ee75b2629cafb731$export$c016d36112f6ddf8);
var $ee75b2629cafb731$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $6NkbF.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $ee75b2629cafb731$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($ee75b2629cafb731$export$c016d36112f6ddf8);
var $ee75b2629cafb731$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $6NkbF.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $ee75b2629cafb731$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($ee75b2629cafb731$export$c016d36112f6ddf8);
var $ee75b2629cafb731$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $6NkbF.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $ee75b2629cafb731$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($ee75b2629cafb731$export$c016d36112f6ddf8);
var $ee75b2629cafb731$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $6NkbF.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($ee75b2629cafb731$export$e3b7eee1dbc44895);
var $ee75b2629cafb731$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $6NkbF.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $ee75b2629cafb731$export$557d6acb76e8a244.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($ee75b2629cafb731$export$c016d36112f6ddf8);

});







parcelRegister("28f8Y", function(module, exports) {

$parcel$export(module.exports, "Error404", () => $a156f6c6c8cffb10$export$a7ebee81a8f27f15);
$parcel$export(module.exports, "NetworkError", () => $a156f6c6c8cffb10$export$bae979e68e4dc802);

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $5UMQ1 = parcelRequire("5UMQ1");

var $9Q47x = parcelRequire("9Q47x");

var $dhb7H = parcelRequire("dhb7H");

var $lDZlX = parcelRequire("lDZlX");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");
var $a156f6c6c8cffb10$var$ErrorIcon = function ErrorIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_222_14150)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M42.635 49.056c-.557 1.478-6.632 1.96-8.017 3.193-1.386 1.234.549 4.402-1.538 5.314-2.087.912-6.438-1.174-8.913-.743-2.475.43-5.01 3.734-7.519 3.607-2.517-.135-2.585-3.599-4.579-4.25-2.061-.675-7.772.88-9.107-.21-1.335-1.09 2.872-3.887 2.433-5.264C4.955 49.326-.51 48.278.039 46.8c.549-1.478 6.632-1.96 8.017-3.194 1.386-1.233 7.967-4.14 10.442-4.57 2.476-.43 5.01-3.734 7.52-3.607 2.517.135 2.584 3.599 4.578 4.25 2.062.675 7.773-.88 9.108.21 1.334 1.09-2.873 3.886-2.434 5.264.423 1.334 5.906 2.424 5.357 3.903h.008Z",
                        fill: "#FF0B4B"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask0_222_14150",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "6",
                        y: "27",
                        width: "33",
                        height: "23",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M35.015 31.56c-5.086-5.087-13.323-5.087-18.41 0a12.937 12.937 0 0 0-3.286 5.575c-8.33 4.36-7.045 11.963-7.045 11.963l29.442.093c4.359-5.111 4.123-12.8-.71-17.632h.009Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask0_222_14150)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M62.877 43.353a4.838 4.838 0 0 0-5.12 2.805 4.836 4.836 0 0 0-4.401-2.915A4.822 4.822 0 0 0 48.92 46.1a4.836 4.836 0 0 0-4.402-2.915 4.822 4.822 0 0 0-4.435 2.856 4.836 4.836 0 0 0-4.402-2.915 4.823 4.823 0 0 0-4.435 2.855 4.837 4.837 0 0 0-4.402-2.914 4.823 4.823 0 0 0-4.435 2.855 4.836 4.836 0 0 0-4.402-2.914 4.822 4.822 0 0 0-4.435 2.855 4.836 4.836 0 0 0-5.086-2.872c-2.146.279-3.886 2.036-4.148 4.19a4.831 4.831 0 0 0 4.765 5.432 4.817 4.817 0 0 0 3.295-1.275 1.64 1.64 0 0 1 2.264.017 4.795 4.795 0 0 0 3.278 1.318 4.777 4.777 0 0 0 3.294-1.276c.651-.6 1.623-.592 2.265.017a4.816 4.816 0 0 0 6.573.042 1.64 1.64 0 0 1 2.264.017 4.816 4.816 0 0 0 6.573.042c.65-.6 1.622-.591 2.264.017a4.794 4.794 0 0 0 3.277 1.318 4.778 4.778 0 0 0 3.295-1.276 1.64 1.64 0 0 1 2.264.017 4.795 4.795 0 0 0 3.278 1.318 4.778 4.778 0 0 0 3.295-1.276c.65-.6 1.622-.591 2.264.017a4.794 4.794 0 0 0 3.278 1.318 4.834 4.834 0 0 0 4.833-5.373c-.237-2.154-1.943-3.937-4.09-4.24h.01Z",
                                fill: "#FF0B4B"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M62.911 38.529a4.837 4.837 0 0 0-5.12 2.805 4.837 4.837 0 0 0-4.401-2.915 4.822 4.822 0 0 0-4.436 2.856 4.836 4.836 0 0 0-4.401-2.915 4.836 4.836 0 0 0-4.435 2.855 4.837 4.837 0 0 0-4.402-2.914 4.823 4.823 0 0 0-4.436 2.855 4.836 4.836 0 0 0-4.401-2.914 4.822 4.822 0 0 0-4.435 2.855 4.836 4.836 0 0 0-4.402-2.915 4.822 4.822 0 0 0-4.435 2.856 4.836 4.836 0 0 0-5.086-2.872c-2.264.295-3.886 2.036-4.148 4.19a4.831 4.831 0 0 0 4.765 5.432 4.817 4.817 0 0 0 3.294-1.275c.651-.6 1.623-.592 2.265.016a4.794 4.794 0 0 0 3.277 1.318 4.778 4.778 0 0 0 3.295-1.275 1.64 1.64 0 0 1 2.264.017 4.795 4.795 0 0 0 3.278 1.318 4.777 4.777 0 0 0 3.295-1.276c.65-.6 1.622-.592 2.264.017a4.795 4.795 0 0 0 3.278 1.318 4.777 4.777 0 0 0 3.295-1.276c.65-.6 1.622-.591 2.264.017a4.795 4.795 0 0 0 3.278 1.318 4.777 4.777 0 0 0 3.295-1.276c.65-.6 1.622-.591 2.264.017a4.795 4.795 0 0 0 3.278 1.318 4.778 4.778 0 0 0 3.295-1.276c.65-.6 1.622-.591 2.264.017a4.795 4.795 0 0 0 3.278 1.318 4.833 4.833 0 0 0 4.832-5.373c-.236-2.154-1.943-3.937-4.088-4.241h.008Z",
                                fill: "#FE6C93"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M62.936 34.094a4.837 4.837 0 0 0-5.12 2.804 4.836 4.836 0 0 0-4.4-2.914 4.822 4.822 0 0 0-4.436 2.855 4.836 4.836 0 0 0-4.402-2.914 4.823 4.823 0 0 0-4.435 2.855 4.837 4.837 0 0 0-4.402-2.915 4.823 4.823 0 0 0-4.435 2.856 4.836 4.836 0 0 0-4.402-2.915 4.822 4.822 0 0 0-4.435 2.856 4.836 4.836 0 0 0-4.402-2.915 4.822 4.822 0 0 0-4.435 2.856 4.836 4.836 0 0 0-5.086-2.873c-2.146.28-3.886 2.036-4.148 4.19a4.831 4.831 0 0 0 4.765 5.433 4.817 4.817 0 0 0 3.295-1.276 1.64 1.64 0 0 1 2.264.017A4.795 4.795 0 0 0 18 43.412a4.778 4.778 0 0 0 3.295-1.276 1.64 1.64 0 0 1 2.264.017 4.796 4.796 0 0 0 3.278 1.318 4.777 4.777 0 0 0 3.295-1.275c.65-.6 1.622-.592 2.264.016a4.816 4.816 0 0 0 6.573.042c.65-.6 1.621-.59 2.264.018a4.795 4.795 0 0 0 3.278 1.317 4.777 4.777 0 0 0 3.294-1.275c.65-.6 1.623-.592 2.265.017a4.795 4.795 0 0 0 3.277 1.318 4.777 4.777 0 0 0 3.295-1.276c.65-.6 1.622-.591 2.264.017a4.795 4.795 0 0 0 3.278 1.318 4.833 4.833 0 0 0 4.833-5.373c-.237-2.155-1.943-3.937-4.09-4.241h.01Z",
                                fill: "#FF0B4B"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M62.97 29.27a4.837 4.837 0 0 0-5.12 2.804 4.837 4.837 0 0 0-4.401-2.914 4.822 4.822 0 0 0-4.435 2.855 4.837 4.837 0 0 0-4.402-2.914 4.823 4.823 0 0 0-4.436 2.855 4.836 4.836 0 0 0-4.401-2.915 4.823 4.823 0 0 0-4.435 2.856 4.836 4.836 0 0 0-4.402-2.915 4.822 4.822 0 0 0-4.435 2.856 4.837 4.837 0 0 0-4.402-2.915 4.822 4.822 0 0 0-4.435 2.856 4.836 4.836 0 0 0-5.086-2.873c-2.146.28-3.886 2.036-4.148 4.19a4.831 4.831 0 0 0 4.765 5.433 4.816 4.816 0 0 0 3.295-1.276c.65-.6 1.622-.591 2.264.017a4.794 4.794 0 0 0 3.278 1.318 4.778 4.778 0 0 0 3.294-1.276c.651-.6 1.623-.591 2.265.017a4.816 4.816 0 0 0 6.573.042c.65-.6 1.621-.59 2.263.017a4.795 4.795 0 0 0 3.279 1.318 4.777 4.777 0 0 0 3.294-1.275 1.64 1.64 0 0 1 2.264.017 4.795 4.795 0 0 0 3.278 1.318 4.777 4.777 0 0 0 3.295-1.276 1.64 1.64 0 0 1 2.264.017 4.795 4.795 0 0 0 3.278 1.318 4.778 4.778 0 0 0 3.295-1.276c.65-.6 1.622-.591 2.264.017a4.794 4.794 0 0 0 3.278 1.318 4.833 4.833 0 0 0 4.832-5.373c-.236-2.155-1.943-3.937-4.088-4.241h.008Z",
                                fill: "#D90841"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M63.004 23.905c-2.256-.338-4.275.972-5.12 2.965-.735-1.8-2.425-3.058-4.401-3.075-1.977-.017-3.675 1.234-4.444 3.016-.735-1.8-2.425-3.058-4.402-3.075-1.977-.017-3.675 1.233-4.444 3.016-.734-1.8-2.424-3.058-4.401-3.075-1.977-.017-3.675 1.233-4.444 3.016-.735-1.8-2.424-3.058-4.401-3.075-1.977-.009-3.675 1.233-4.444 3.016-.735-1.8-2.425-3.058-4.402-3.075-1.977-.017-3.675 1.233-4.443 3.016-.82-2.002-2.822-3.337-5.086-3.025-2.265.313-3.887 2.154-4.148 4.427-.355 3.084 1.909 5.72 4.764 5.737a4.722 4.722 0 0 0 3.295-1.344c.65-.633 1.622-.625 2.264.017a4.67 4.67 0 0 0 3.278 1.386 4.686 4.686 0 0 0 3.295-1.344c.65-.633 1.622-.625 2.264.017a4.67 4.67 0 0 0 3.278 1.386 4.723 4.723 0 0 0 3.295-1.343c.65-.634 1.622-.626 2.264.016a4.67 4.67 0 0 0 3.278 1.386 4.686 4.686 0 0 0 3.295-1.343c.65-.634 1.622-.626 2.264.017a4.67 4.67 0 0 0 3.278 1.385 4.686 4.686 0 0 0 3.295-1.343c.65-.634 1.622-.625 2.264.017a4.67 4.67 0 0 0 3.278 1.385 4.686 4.686 0 0 0 3.295-1.343c.65-.634 1.622-.625 2.264.017a4.67 4.67 0 0 0 3.278 1.385c2.855.017 5.153-2.585 4.832-5.677-.228-2.272-1.943-4.156-4.089-4.477l.05-.009Z",
                                fill: "#98062D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask1_222_14150",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "26",
                        y: "3",
                        width: "38",
                        height: "38",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M63.536 7.296 42.322 40.59 26.01 24.277 59.734 3.435c2.518-1.554 5.399 1.369 3.81 3.86h-.008Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask1_222_14150)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M45.66 40.802c10.96 0 19.844-8.885 19.844-19.845 0-10.96-8.884-19.845-19.845-19.845-10.96 0-19.845 8.884-19.845 19.845 0 10.96 8.885 19.845 19.846 19.845Z",
                                fill: "#4427FA"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M49.774 35.707c9.686 0 17.538-7.852 17.538-17.538C67.313 8.482 59.46.63 49.775.63S32.235 8.482 32.235 18.17c0 9.686 7.853 17.538 17.539 17.538Z",
                                fill: "#334EF5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M52.25 27.74c7.227 0 13.086-5.858 13.086-13.086 0-7.227-5.86-13.086-13.087-13.086-7.227 0-13.086 5.859-13.086 13.086 0 7.228 5.859 13.087 13.086 13.087Z",
                                fill: "#2275F0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M56.11 22.74c5.487 0 9.935-4.449 9.935-9.936s-4.448-9.935-9.935-9.935-9.935 4.448-9.935 9.935 4.448 9.935 9.935 9.935Z",
                                fill: "#119CEB"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M60.47 15.271a6.818 6.818 0 1 0 0-13.636 6.818 6.818 0 0 0 0 13.636Z",
                                fill: "#00C3E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "m37.591 48.833-19.91-19.911 3.984-3.985a4.222 4.222 0 0 1 5.962 0l13.949 13.95a4.222 4.222 0 0 1 0 5.961l-3.985 3.985Z",
                        fill: "#33009A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_222_14150",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h64v64H0z"
                    })
                })
            })
        ]
    });
};
$a156f6c6c8cffb10$var$ErrorIcon.defaultProps = {
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $a156f6c6c8cffb10$export$a7ebee81a8f27f15 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($a156f6c6c8cffb10$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $9Q47x.BackgroundIcon), {
                iconSvg: $a156f6c6c8cffb10$var$ErrorIcon
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($a156f6c6c8cffb10$var$Code, {
                children: format("errorPage.404.code")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($a156f6c6c8cffb10$var$Title, {
                children: format("errorPage.404.title")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($a156f6c6c8cffb10$var$Description, {
                className: "p-size-m",
                children: format("errorPage.404.description")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                style: {
                    marginTop: 16
                },
                label: format("errorPage.404.button"),
                onClick: ()=>navigate((0, $lDZlX.RoutesPath).Home)
            })
        ]
    });
};
const $a156f6c6c8cffb10$export$bae979e68e4dc802 = ({ title: title, titleStyle: titleStyle, description: description, icon: icon, withoutIcon: withoutIcon, onRefresh: onRefresh, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const reload = (0, $81g6h.useCallback)(async ()=>{
        if (onRefresh) await onRefresh();
        else location.reload();
    }, [
        onRefresh
    ]);
    const [operation, loading] = (0, $grmoS.useAsyncOperation)(reload, {});
    return /*#__PURE__*/ (0, $iKObn.jsxs)($a156f6c6c8cffb10$var$Container, {
        ...otherProps,
        children: [
            withoutIcon ? null : icon ?? /*#__PURE__*/ (0, $iKObn.jsx)((0, $9Q47x.BackgroundIcon), {
                iconSvg: $a156f6c6c8cffb10$var$ErrorIcon
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($a156f6c6c8cffb10$var$Title, {
                style: titleStyle,
                children: title ?? format("errorPage.network.title")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($a156f6c6c8cffb10$var$Description, {
                className: "p-size-m",
                children: description ?? format("errorPage.network.description")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.RefreshButton), {
                style: {
                    marginTop: 16
                },
                loading: loading,
                onClick: operation
            })
        ]
    });
};
const $a156f6c6c8cffb10$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(16, "center", "center")}
`;
const $a156f6c6c8cffb10$var$Title = (0, $5UMQ1.default).h1`
	text-align: center;
	color: ${(0, $kKnoQ.colors).grey};
	margin-top: 16px;
`;
const $a156f6c6c8cffb10$var$Code = (0, $5UMQ1.default).div`
	text-align: center;
	margin-top: 16px;
	color: ${(0, $kKnoQ.colors).grey};
`;
const $a156f6c6c8cffb10$var$Description = (0, $5UMQ1.default).div`
	text-align: center;
	max-width: 448px;
	color: ${(0, $kKnoQ.colors).grey};
`;

});
parcelRegister("grmoS", function(module, exports) {

$parcel$export(module.exports, "useAsyncOperation", () => $b7b31f3624501b65$export$7d619ed4f883db21);

var $TSc86 = parcelRequire("TSc86");

var $81g6h = parcelRequire("81g6h");
function $b7b31f3624501b65$export$7d619ed4f883db21(operation, options) {
    const [loading, setLoading] = (0, $81g6h.useState)(options.initialLoadingState ?? false);
    const [error, setError] = (0, $81g6h.useState)(false);
    const isCancelled = (0, $81g6h.useRef)(false);
    const minimumDuration = (0, $81g6h.useMemo)(()=>options.minimumDuration ?? false, [
        options.minimumDuration
    ]);
    const deps = (0, $81g6h.useMemo)(()=>options.deps ?? [], [
        options.deps
    ]);
    const doRethrow = (0, $81g6h.useMemo)(()=>options.rethrow ?? false, [
        options.rethrow
    ]);
    (0, $81g6h.useEffect)(()=>()=>{
            // Cancel operation on hook dismount
            isCancelled.current = true;
        }, []);
    const operationWrapper = (0, $81g6h.useCallback)(async (...parameters)=>{
        try {
            setError(false);
            setLoading(true);
            const result = minimumDuration ? await (0, $TSc86.resolveWithDelay)(operation(...parameters), minimumDuration) : await operation(...parameters);
            if (!isCancelled.current) {
                options.completionCallback?.();
                setError(false);
            }
            return result;
        } catch (e) {
            if (!isCancelled.current) setError(true);
            if (doRethrow) throw e;
        } finally{
            if (!isCancelled.current) setLoading(false);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        deps,
        operation,
        minimumDuration,
        doRethrow
    ]);
    return [
        operationWrapper,
        loading,
        error
    ];
}

});
parcelRegister("TSc86", function(module, exports) {

$parcel$export(module.exports, "delay", () => $4c1215d37d09d99e$export$1391212d75b2ee65);
$parcel$export(module.exports, "resolveWithDelay", () => $4c1215d37d09d99e$export$3108ce3b0883056);
function $4c1215d37d09d99e$export$1391212d75b2ee65(duration) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve();
        }, duration);
    });
}
async function $4c1215d37d09d99e$export$3108ce3b0883056(promise, timeout) {
    return new Promise((resolve, reject)=>{
        const delayPromise = $4c1215d37d09d99e$export$1391212d75b2ee65(timeout);
        promise.then((result)=>delayPromise.then(()=>resolve(result)), (reason)=>delayPromise.then(()=>reject(reason)));
    });
}
async function $4c1215d37d09d99e$export$d3e5a80dcb87fc02(promise) {
    return $4c1215d37d09d99e$export$3108ce3b0883056(promise, 500);
}

});


parcelRegister("htiSH", function(module, exports) {

$parcel$export(module.exports, "useNavigate", () => $ee348659337e9a39$export$9770f232ac06a008);
$parcel$export(module.exports, "useGoBack", () => $ee348659337e9a39$export$2d918281c8e50d49);

var $lTdpc = parcelRequire("lTdpc");

var $hE6rp = parcelRequire("hE6rp");

var $81g6h = parcelRequire("81g6h");
const $ee348659337e9a39$export$9770f232ac06a008 = ()=>{
    const navigate = (0, $hE6rp.useNavigate)();
    return (0, $81g6h.useCallback)((path, params, options)=>{
        let pathWithParam = path;
        if ((0, $lTdpc.isNotNil)(params)) {
            // Route params
            if ((0, $lTdpc.isNotNil)(params.route)) {
                const routeParams = params.route;
                Object.entries(routeParams).forEach(([key, value])=>{
                    if (typeof value === "string") pathWithParam = pathWithParam.replace(`:${key}`, value);
                });
            }
            // Query params
            if ((0, $lTdpc.isNotNil)(params.query)) {
                const queryParams = params.query;
                const queryParamsKeyValues = [];
                Object.entries(queryParams).forEach(([key, value])=>$ee348659337e9a39$var$isURIEncodable(value) && queryParamsKeyValues.push([
                        key,
                        value
                    ]));
                pathWithParam += `?${queryParamsKeyValues.map(([key, value])=>`${key}=${encodeURIComponent(value)}`).join("&")}`;
            }
        }
        if (options?.target === "_blank") window.open(pathWithParam, options.target);
        else navigate(pathWithParam, {
            ...options,
            state: params?.state
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
const $ee348659337e9a39$export$2d918281c8e50d49 = ()=>{
    const navigate = (0, $hE6rp.useNavigate)();
    return ()=>navigate(-1);
};
const $ee348659337e9a39$var$isURIEncodable = (item)=>typeof item === "string" || typeof item === "boolean" || typeof item === "number";

});

parcelRegister("9Q47x", function(module, exports) {

$parcel$export(module.exports, "BackgroundIcon", () => $ac9556871835bed0$export$707671a32875dd3e);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
const $ac9556871835bed0$var$ICON_CONTAINER_WIDTH = 128 / Math.SQRT2;
const $ac9556871835bed0$export$707671a32875dd3e = ({ iconSvg: IconSvg })=>/*#__PURE__*/ (0, $iKObn.jsx)($ac9556871835bed0$var$MainContainer, {
        children: /*#__PURE__*/ (0, $iKObn.jsx)($ac9556871835bed0$var$IconContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)(IconSvg, {
                width: 64,
                height: 64
            })
        })
    });
const $ac9556871835bed0$var$MainContainer = (0, $5UMQ1.default).div`
	width: ${$ac9556871835bed0$var$ICON_CONTAINER_WIDTH}px;
	height: ${$ac9556871835bed0$var$ICON_CONTAINER_WIDTH}px;
	background-color: ${(0, $kKnoQ.colors).primary10};
	border-radius: 16px;
	transform: rotate(45deg);
	${(0, $5WGN2.stack)(undefined, "center", "center")};
	margin: 8px 0;
`;
const $ac9556871835bed0$var$IconContainer = (0, $5UMQ1.default).div`
	transform: rotate(-45deg);
`;

});
parcelRegister("42FK8", function(module, exports) {
$parcel$export(module.exports, "absoluteFillObject", () => (parcelRequire("5WGN2")).absoluteFillObject);
$parcel$export(module.exports, "row", () => (parcelRequire("5WGN2")).row);
$parcel$export(module.exports, "sizes", () => (parcelRequire("5WGN2")).sizes);
$parcel$export(module.exports, "stack", () => (parcelRequire("5WGN2")).stack);
$parcel$export(module.exports, "MOBILE_BREAKING_POINT", () => (parcelRequire("eaiXJ")).MOBILE_BREAKING_POINT);
$parcel$export(module.exports, "physioMeDesktopLargeBreakpoint", () => (parcelRequire("eaiXJ")).physioMeDesktopLargeBreakpoint);
$parcel$export(module.exports, "physioMeMobileBreakpoint", () => (parcelRequire("eaiXJ")).physioMeMobileBreakpoint);
$parcel$export(module.exports, "physioMeTabletBreakpoint", () => (parcelRequire("eaiXJ")).physioMeTabletBreakpoint);
$parcel$export(module.exports, "TABLET_BREAKING_POINT", () => (parcelRequire("eaiXJ")).TABLET_BREAKING_POINT);
$parcel$export(module.exports, "spacings", () => (parcelRequire("kwJi4")).spacings);
parcelRequire("5WGN2");
parcelRequire("eaiXJ");
parcelRequire("kwJi4");

});
parcelRegister("5WGN2", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $07a86a826e1ac0f7$export$c647cb0ee6e282fe);
$parcel$export(module.exports, "stack", () => $07a86a826e1ac0f7$export$a57ab32f40f83ea9);
$parcel$export(module.exports, "row", () => $07a86a826e1ac0f7$export$120ff0929b202a6d);
$parcel$export(module.exports, "absoluteFillObject", () => $07a86a826e1ac0f7$export$ddba11810ae65756);

var $kkH7g = parcelRequire("kkH7g");
const $07a86a826e1ac0f7$export$c647cb0ee6e282fe = {
    XSS: "0.25rem",
    XS: "0.5rem",
    S: "0.625rem",
    SM: "1rem",
    M: "1.25rem",
    L: "1.875rem",
    XL: "2.5rem"
};
const $07a86a826e1ac0f7$export$a57ab32f40f83ea9 = (gap, justify = "flexstart", align = "flexstart", reverse)=>(0, $kkH7g.css)`
	display: flex;
	flex-direction: ${reverse ? "column-reverse" : "column"};
	justify-content: ${$07a86a826e1ac0f7$var$cssText[justify]};
	align-items: ${$07a86a826e1ac0f7$var$cssText[align]};

	${gap !== undefined && (0, $kkH7g.css)`
		gap: ${typeof gap === "number" ? `${gap / 16}rem` : $07a86a826e1ac0f7$export$c647cb0ee6e282fe[gap]};
	`}
`;
const $07a86a826e1ac0f7$export$120ff0929b202a6d = (gap, justify = "flexstart", align = "flexstart", reverse)=>(0, $kkH7g.css)`
	display: flex;
	flex-direction: ${reverse ? "row-reverse" : "row"};
	justify-content: ${$07a86a826e1ac0f7$var$cssText[justify]};
	align-items: ${$07a86a826e1ac0f7$var$cssText[align]};

	${gap !== undefined && (0, $kkH7g.css)`
		gap: ${typeof gap === "number" ? `${gap / 16}rem` : $07a86a826e1ac0f7$export$c647cb0ee6e282fe[gap]};
	`}
`;
const $07a86a826e1ac0f7$export$ddba11810ae65756 = (0, $kkH7g.css)`
	position: absolute;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
`;
const $07a86a826e1ac0f7$var$cssText = {
    ["flexstart"]: "flex-start",
    ["flexend"]: "flex-end",
    ["center"]: "center",
    ["spacearound"]: "space-around",
    ["spacebetween"]: "space-between",
    ["spaceevenly"]: "space-evenly",
    ["stretch"]: "stretch",
    ["baseline"]: "baseline"
};

});

parcelRegister("eaiXJ", function(module, exports) {

$parcel$export(module.exports, "MOBILE_BREAKING_POINT", () => $aadd2a543be7f721$export$4616b0acedf6f27b);
$parcel$export(module.exports, "TABLET_BREAKING_POINT", () => $aadd2a543be7f721$export$4dc8f6a4caba84a);
$parcel$export(module.exports, "physioMeMobileBreakpoint", () => $aadd2a543be7f721$export$b141e7cdd3729206);
$parcel$export(module.exports, "physioMeTabletBreakpoint", () => $aadd2a543be7f721$export$a313349d744ff31b);
$parcel$export(module.exports, "physioMeDesktopLargeBreakpoint", () => $aadd2a543be7f721$export$2dfa8bb6b990a251);
const $aadd2a543be7f721$export$4616b0acedf6f27b = 500;
const $aadd2a543be7f721$export$4dc8f6a4caba84a = 1200;
const $aadd2a543be7f721$export$911f1d03a6532ca6 = 1280;
const $aadd2a543be7f721$export$b141e7cdd3729206 = `(max-width: ${$aadd2a543be7f721$export$4616b0acedf6f27b}px)`;
const $aadd2a543be7f721$export$a313349d744ff31b = `(max-width: ${$aadd2a543be7f721$export$4dc8f6a4caba84a}px)`;
const $aadd2a543be7f721$export$2dfa8bb6b990a251 = `(min-width: ${$aadd2a543be7f721$export$4dc8f6a4caba84a}px) and (max-width: ${$aadd2a543be7f721$export$911f1d03a6532ca6}px)`;

});

parcelRegister("kwJi4", function(module, exports) {

$parcel$export(module.exports, "spacings", () => $8cc13b543241a80e$export$4baaf6dabb0fdd38);
const $8cc13b543241a80e$export$4baaf6dabb0fdd38 = {
    XXL: "64px",
    XL: "48px",
    L: "32px",
    M: "24px",
    S: "16px",
    XS: "8px"
};

});



parcelRegister("dhb7H", function(module, exports) {

$parcel$export(module.exports, "Button", () => $b0c4b0653379210a$export$353f5b6fc5456de1);
$parcel$export(module.exports, "RefreshButton", () => $b0c4b0653379210a$export$b6a16082cbe3a673);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $kKnoQ = parcelRequire("kKnoQ");

var $9AWgp = parcelRequire("9AWgp");

var $cfkGk = parcelRequire("cfkGk");

var $81g6h = parcelRequire("81g6h");
const $b0c4b0653379210a$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ uiStyle: uiStyle = "primary", children: children, className: className, ...props }, ref)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $9AWgp.Button), {
        ref: ref,
        className: (0, $cfkGk.classNames)({
            "p-button-secondary": uiStyle.startsWith("secondary")
        }, {
            "p-button-danger": uiStyle === "danger"
        }, className),
        label: children,
        ...props,
        style: {
            ...props.style,
            ...uiStyle === "secondary_B" && !props.disabled ? {
                backgroundColor: (0, $kKnoQ.colors).white
            } : {}
        }
    }));
$b0c4b0653379210a$export$353f5b6fc5456de1.displayName = "Button";
const $b0c4b0653379210a$export$b6a16082cbe3a673 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef((props, ref)=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)($b0c4b0653379210a$export$353f5b6fc5456de1, {
        ref: ref,
        label: format("global.refreshButton"),
        icon: "pi pi-refresh",
        iconPos: "right",
        ...props
    });
});
$b0c4b0653379210a$export$b6a16082cbe3a673.displayName = "RefreshButton";

});
parcelRegister("9AWgp", function(module, exports) {

$parcel$export(module.exports, "Button", () => $6fc4abd1edf2dcf5$export$353f5b6fc5456de1);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $cfkGk = parcelRequire("cfkGk");

var $dPQhb = parcelRequire("dPQhb");

var $9rbaG = parcelRequire("9rbaG");

var $7hMfd = parcelRequire("7hMfd");
"use client";
function $6fc4abd1edf2dcf5$var$_extends() {
    $6fc4abd1edf2dcf5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6fc4abd1edf2dcf5$var$_extends.apply(this, arguments);
}
function $6fc4abd1edf2dcf5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6fc4abd1edf2dcf5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6fc4abd1edf2dcf5$var$_typeof(o);
}
function $6fc4abd1edf2dcf5$var$_toPrimitive(input, hint) {
    if ($6fc4abd1edf2dcf5$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6fc4abd1edf2dcf5$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6fc4abd1edf2dcf5$var$_toPropertyKey(arg) {
    var key = $6fc4abd1edf2dcf5$var$_toPrimitive(arg, "string");
    return $6fc4abd1edf2dcf5$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6fc4abd1edf2dcf5$var$_defineProperty(obj, key, value) {
    key = $6fc4abd1edf2dcf5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6fc4abd1edf2dcf5$var$classes$1 = {
    root: function root(_ref) {
        var props = _ref.props;
        return (0, $cfkGk.classNames)("p-badge p-component", $6fc4abd1edf2dcf5$var$_defineProperty({
            "p-badge-no-gutter": (0, $cfkGk.ObjectUtils).isNotEmpty(props.value) && String(props.value).length === 1,
            "p-badge-dot": (0, $cfkGk.ObjectUtils).isEmpty(props.value),
            "p-badge-lg": props.size === "large",
            "p-badge-xl": props.size === "xlarge"
        }, "p-badge-".concat(props.severity), props.severity !== null));
    }
};
var $6fc4abd1edf2dcf5$var$styles = "\n@layer primereact {\n    .p-badge {\n        display: inline-block;\n        border-radius: 10px;\n        text-align: center;\n        padding: 0 .5rem;\n    }\n    \n    .p-overlay-badge {\n        position: relative;\n    }\n    \n    .p-overlay-badge .p-badge {\n        position: absolute;\n        top: 0;\n        right: 0;\n        transform: translate(50%,-50%);\n        transform-origin: 100% 0;\n        margin: 0;\n    }\n    \n    .p-badge-dot {\n        width: .5rem;\n        min-width: .5rem;\n        height: .5rem;\n        border-radius: 50%;\n        padding: 0;\n    }\n    \n    .p-badge-no-gutter {\n        padding: 0;\n        border-radius: 50%;\n    }\n}\n";
var $6fc4abd1edf2dcf5$var$BadgeBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Badge",
        __parentMetadata: null,
        value: null,
        severity: null,
        size: null,
        style: null,
        className: null,
        children: undefined
    },
    css: {
        classes: $6fc4abd1edf2dcf5$var$classes$1,
        styles: $6fc4abd1edf2dcf5$var$styles
    }
});
function $6fc4abd1edf2dcf5$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6fc4abd1edf2dcf5$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6fc4abd1edf2dcf5$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $6fc4abd1edf2dcf5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6fc4abd1edf2dcf5$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6fc4abd1edf2dcf5$var$Badge = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $6fc4abd1edf2dcf5$var$BadgeBase.getProps(inProps, context);
    var _BadgeBase$setMetaDat = $6fc4abd1edf2dcf5$var$BadgeBase.setMetaData($6fc4abd1edf2dcf5$var$_objectSpread$1({
        props: props
    }, props.__parentMetadata)), ptm = _BadgeBase$setMetaDat.ptm, cx = _BadgeBase$setMetaDat.cx, isUnstyled = _BadgeBase$setMetaDat.isUnstyled;
    (0, $4gQLd.useHandleStyle)($6fc4abd1edf2dcf5$var$BadgeBase.css.styles, isUnstyled, {
        name: "badge"
    });
    var elementRef = $81g6h.useRef(null);
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var rootProps = mergeProps({
        ref: elementRef,
        style: props.style,
        className: (0, $cfkGk.classNames)(props.className, cx("root"))
    }, $6fc4abd1edf2dcf5$var$BadgeBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $81g6h.createElement("span", rootProps, props.value);
}));
$6fc4abd1edf2dcf5$var$Badge.displayName = "Badge";
var $6fc4abd1edf2dcf5$var$classes = {
    icon: function icon(_ref) {
        var props = _ref.props;
        return (0, $cfkGk.classNames)("p-button-icon p-c", $6fc4abd1edf2dcf5$var$_defineProperty({}, "p-button-icon-".concat(props.iconPos), props.label));
    },
    loadingIcon: function loadingIcon(_ref2) {
        var props = _ref2.props, className = _ref2.className;
        return (0, $cfkGk.classNames)(className, {
            "p-button-loading-icon": props.loading
        });
    },
    label: "p-button-label p-c",
    root: function root(_ref3) {
        var props = _ref3.props, size = _ref3.size, disabled = _ref3.disabled;
        return (0, $cfkGk.classNames)("p-button p-component", $6fc4abd1edf2dcf5$var$_defineProperty($6fc4abd1edf2dcf5$var$_defineProperty($6fc4abd1edf2dcf5$var$_defineProperty($6fc4abd1edf2dcf5$var$_defineProperty({
            "p-button-icon-only": (props.icon || props.loading) && !props.label && !props.children,
            "p-button-vertical": (props.iconPos === "top" || props.iconPos === "bottom") && props.label,
            "p-disabled": disabled,
            "p-button-loading": props.loading,
            "p-button-outlined": props.outlined,
            "p-button-raised": props.raised,
            "p-button-link": props.link,
            "p-button-text": props.text,
            "p-button-rounded": props.rounded,
            "p-button-loading-label-only": props.loading && !props.icon && props.label
        }, "p-button-loading-".concat(props.iconPos), props.loading && props.label), "p-button-".concat(size), size), "p-button-".concat(props.severity), props.severity), "p-button-plain", props.plain));
    }
};
var $6fc4abd1edf2dcf5$var$ButtonBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Button",
        __parentMetadata: null,
        badge: null,
        badgeClassName: null,
        className: null,
        children: undefined,
        disabled: false,
        icon: null,
        iconPos: "left",
        label: null,
        link: false,
        loading: false,
        loadingIcon: null,
        outlined: false,
        plain: false,
        raised: false,
        rounded: false,
        severity: null,
        size: null,
        text: false,
        tooltip: null,
        tooltipOptions: null,
        visible: true
    },
    css: {
        classes: $6fc4abd1edf2dcf5$var$classes
    }
});
function $6fc4abd1edf2dcf5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6fc4abd1edf2dcf5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6fc4abd1edf2dcf5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6fc4abd1edf2dcf5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6fc4abd1edf2dcf5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6fc4abd1edf2dcf5$export$353f5b6fc5456de1 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $6fc4abd1edf2dcf5$var$ButtonBase.getProps(inProps, context);
    var disabled = props.disabled || props.loading;
    var metaData = $6fc4abd1edf2dcf5$var$_objectSpread($6fc4abd1edf2dcf5$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        context: {
            disabled: disabled
        }
    });
    var _ButtonBase$setMetaDa = $6fc4abd1edf2dcf5$var$ButtonBase.setMetaData(metaData), ptm = _ButtonBase$setMetaDa.ptm, cx = _ButtonBase$setMetaDa.cx, isUnstyled = _ButtonBase$setMetaDa.isUnstyled;
    (0, $4gQLd.useHandleStyle)($6fc4abd1edf2dcf5$var$ButtonBase.css.styles, isUnstyled, {
        name: "button",
        styled: true
    });
    var elementRef = $81g6h.useRef(ref);
    $81g6h.useEffect(function() {
        (0, $cfkGk.ObjectUtils).combinedRefs(elementRef, ref);
    }, [
        elementRef,
        ref
    ]);
    if (props.visible === false) return null;
    var createIcon = function createIcon() {
        var className = (0, $cfkGk.classNames)("p-button-icon p-c", $6fc4abd1edf2dcf5$var$_defineProperty({}, "p-button-icon-".concat(props.iconPos), props.label));
        var iconsProps = mergeProps({
            className: cx("icon")
        }, ptm("icon"));
        className = (0, $cfkGk.classNames)(className, {
            "p-button-loading-icon": props.loading
        });
        var loadingIconProps = mergeProps({
            className: cx("loadingIcon", {
                className: className
            })
        }, ptm("loadingIcon"));
        var icon = props.loading ? props.loadingIcon || /*#__PURE__*/ $81g6h.createElement((0, $dPQhb.SpinnerIcon), $6fc4abd1edf2dcf5$var$_extends({}, loadingIconProps, {
            spin: true
        })) : props.icon;
        return (0, $cfkGk.IconUtils).getJSXIcon(icon, $6fc4abd1edf2dcf5$var$_objectSpread({}, iconsProps), {
            props: props
        });
    };
    var createLabel = function createLabel() {
        var labelProps = mergeProps({
            className: cx("label")
        }, ptm("label"));
        if (props.label) return /*#__PURE__*/ $81g6h.createElement("span", labelProps, props.label);
        return !props.children && !props.label && /*#__PURE__*/ $81g6h.createElement("span", $6fc4abd1edf2dcf5$var$_extends({}, labelProps, {
            dangerouslySetInnerHTML: {
                __html: "&nbsp;"
            }
        }));
    };
    var createBadge = function createBadge() {
        if (props.badge) {
            var badgeProps = mergeProps({
                className: (0, $cfkGk.classNames)(props.badgeClassName),
                value: props.badge,
                unstyled: props.unstyled,
                __parentMetadata: {
                    parent: metaData
                }
            }, ptm("badge"));
            return /*#__PURE__*/ $81g6h.createElement($6fc4abd1edf2dcf5$var$Badge, badgeProps, props.badge);
        }
        return null;
    };
    var showTooltip = !disabled || props.tooltipOptions && props.tooltipOptions.showOnDisabled;
    var hasTooltip = (0, $cfkGk.ObjectUtils).isNotEmpty(props.tooltip) && showTooltip;
    var sizeMapping = {
        large: "lg",
        small: "sm"
    };
    var size = sizeMapping[props.size];
    var icon = createIcon();
    var label = createLabel();
    var badge = createBadge();
    var defaultAriaLabel = props.label ? props.label + (props.badge ? " " + props.badge : "") : props["aria-label"];
    var rootProps = mergeProps({
        ref: elementRef,
        "aria-label": defaultAriaLabel,
        "data-pc-autofocus": props.autoFocus,
        className: (0, $cfkGk.classNames)(props.className, cx("root", {
            size: size,
            disabled: disabled
        })),
        disabled: disabled
    }, $6fc4abd1edf2dcf5$var$ButtonBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("button", rootProps, icon, label, props.children, badge, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null)), hasTooltip && /*#__PURE__*/ $81g6h.createElement((0, $7hMfd.Tooltip), $6fc4abd1edf2dcf5$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$6fc4abd1edf2dcf5$export$353f5b6fc5456de1.displayName = "Button";

});
parcelRegister("4gQLd", function(module, exports) {

$parcel$export(module.exports, "ComponentBase", () => $31c195372834831e$export$425c3e0a21b857e8);
$parcel$export(module.exports, "useHandleStyle", () => $31c195372834831e$export$142583cb150b394);

var $8Zwsm = parcelRequire("8Zwsm");

var $l2NC0 = parcelRequire("l2NC0");

var $cfkGk = parcelRequire("cfkGk");
"use client";
function $31c195372834831e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $31c195372834831e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $31c195372834831e$var$_arrayLikeToArray(arr);
}
function $31c195372834831e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $31c195372834831e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $31c195372834831e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $31c195372834831e$var$_arrayLikeToArray(o, minLen);
}
function $31c195372834831e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $31c195372834831e$var$_toConsumableArray(arr) {
    return $31c195372834831e$var$_arrayWithoutHoles(arr) || $31c195372834831e$var$_iterableToArray(arr) || $31c195372834831e$var$_unsupportedIterableToArray(arr) || $31c195372834831e$var$_nonIterableSpread();
}
function $31c195372834831e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $31c195372834831e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $31c195372834831e$var$_typeof(o);
}
function $31c195372834831e$var$_toPrimitive(input, hint) {
    if ($31c195372834831e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($31c195372834831e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $31c195372834831e$var$_toPropertyKey(arg) {
    var key = $31c195372834831e$var$_toPrimitive(arg, "string");
    return $31c195372834831e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $31c195372834831e$var$_defineProperty(obj, key, value) {
    key = $31c195372834831e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $31c195372834831e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $31c195372834831e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $31c195372834831e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $31c195372834831e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $31c195372834831e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $31c195372834831e$var$baseStyle = "\n.p-hidden-accessible {\n    border: 0;\n    padding: 0;\n    margin: -1px;\n    position: absolute;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    clip-path: inset(50%);\n    white-space: nowrap;\n}\n\n.p-hidden-accessible input,\n.p-hidden-accessible select {\n    transform: scale(0);\n}\n\n.p-overflow-hidden {\n    overflow: hidden;\n    padding-right: var(--scrollbar-width);\n}\n";
var $31c195372834831e$var$buttonStyles = "\n.p-button {\n    margin: 0;\n    display: inline-flex;\n    cursor: pointer;\n    user-select: none;\n    align-items: center;\n    vertical-align: bottom;\n    text-align: center;\n    overflow: hidden;\n    position: relative;\n}\n\n.p-button-label {\n    flex: 1 1 auto;\n}\n\n.p-button-icon-right {\n    order: 1;\n}\n\n.p-button:disabled {\n    cursor: default;\n}\n\n.p-button-icon-only {\n    justify-content: center;\n}\n\n.p-button-icon-only .p-button-label {\n    visibility: hidden;\n    width: 0;\n    flex: 0 0 auto;\n}\n\n.p-button-vertical {\n    flex-direction: column;\n}\n\n.p-button-icon-bottom {\n    order: 2;\n}\n\n.p-button-group .p-button {\n    margin: 0;\n}\n\n.p-button-group .p-button:not(:last-child) {\n    border-right: 0 none;\n}\n\n.p-button-group .p-button:not(:first-of-type):not(:last-of-type) {\n    border-radius: 0;\n}\n\n.p-button-group .p-button:first-of-type {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.p-button-group .p-button:last-of-type {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.p-button-group .p-button:focus {\n    position: relative;\n    z-index: 1;\n}\n";
var $31c195372834831e$var$inputTextStyles = "\n.p-inputtext {\n    margin: 0;\n}\n\n.p-fluid .p-inputtext {\n    width: 100%;\n}\n\n/* InputGroup */\n.p-inputgroup {\n    display: flex;\n    align-items: stretch;\n    width: 100%;\n}\n\n.p-inputgroup-addon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.p-inputgroup .p-float-label {\n    display: flex;\n    align-items: stretch;\n    width: 100%;\n}\n\n.p-inputgroup .p-inputtext,\n.p-fluid .p-inputgroup .p-inputtext,\n.p-inputgroup .p-inputwrapper,\n.p-fluid .p-inputgroup .p-input {\n    flex: 1 1 auto;\n    width: 1%;\n}\n\n/* Floating Label */\n.p-float-label {\n    display: block;\n    position: relative;\n}\n\n.p-float-label label {\n    position: absolute;\n    pointer-events: none;\n    top: 50%;\n    margin-top: -0.5rem;\n    transition-property: all;\n    transition-timing-function: ease;\n    line-height: 1;\n}\n\n.p-float-label textarea ~ label,\n.p-float-label .p-mention ~ label {\n    top: 1rem;\n}\n\n.p-float-label input:focus ~ label,\n.p-float-label input:-webkit-autofill ~ label,\n.p-float-label input.p-filled ~ label,\n.p-float-label textarea:focus ~ label,\n.p-float-label textarea.p-filled ~ label,\n.p-float-label .p-inputwrapper-focus ~ label,\n.p-float-label .p-inputwrapper-filled ~ label,\n.p-float-label .p-tooltip-target-wrapper ~ label {\n    top: -0.75rem;\n    font-size: 12px;\n}\n\n.p-float-label .p-placeholder,\n.p-float-label input::placeholder,\n.p-float-label .p-inputtext::placeholder {\n    opacity: 0;\n    transition-property: all;\n    transition-timing-function: ease;\n}\n\n.p-float-label .p-focus .p-placeholder,\n.p-float-label input:focus::placeholder,\n.p-float-label .p-inputtext:focus::placeholder {\n    opacity: 1;\n    transition-property: all;\n    transition-timing-function: ease;\n}\n\n.p-input-icon-left,\n.p-input-icon-right {\n    position: relative;\n    display: inline-block;\n}\n\n.p-input-icon-left > i,\n.p-input-icon-right > i,\n.p-input-icon-left > svg,\n.p-input-icon-right > svg,\n.p-input-icon-left > .p-input-prefix,\n.p-input-icon-right > .p-input-suffix {\n    position: absolute;\n    top: 50%;\n    margin-top: -0.5rem;\n}\n\n.p-fluid .p-input-icon-left,\n.p-fluid .p-input-icon-right {\n    display: block;\n    width: 100%;\n}\n";
var $31c195372834831e$var$iconStyles = "\n.p-icon {\n    display: inline-block;\n}\n\n.p-icon-spin {\n    -webkit-animation: p-icon-spin 2s infinite linear;\n    animation: p-icon-spin 2s infinite linear;\n}\n\nsvg.p-icon {\n    pointer-events: auto;\n}\n\nsvg.p-icon g,\n.p-disabled svg.p-icon {\n    pointer-events: none;\n}\n\n@-webkit-keyframes p-icon-spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(359deg);\n        transform: rotate(359deg);\n    }\n}\n\n@keyframes p-icon-spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(359deg);\n        transform: rotate(359deg);\n    }\n}\n";
var $31c195372834831e$var$commonStyle = "\n@layer primereact {\n    .p-component, .p-component * {\n        box-sizing: border-box;\n    }\n\n    .p-hidden {\n        display: none;\n    }\n\n    .p-hidden-space {\n        visibility: hidden;\n    }\n\n    .p-reset {\n        margin: 0;\n        padding: 0;\n        border: 0;\n        outline: 0;\n        text-decoration: none;\n        font-size: 100%;\n        list-style: none;\n    }\n\n    .p-disabled, .p-disabled * {\n        cursor: default;\n        pointer-events: none;\n        user-select: none;\n    }\n\n    .p-component-overlay {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n    }\n\n    .p-unselectable-text {\n        user-select: none;\n    }\n\n    .p-scrollbar-measure {\n        width: 100px;\n        height: 100px;\n        overflow: scroll;\n        position: absolute;\n        top: -9999px;\n    }\n\n    @-webkit-keyframes p-fadein {\n      0%   { opacity: 0; }\n      100% { opacity: 1; }\n    }\n    @keyframes p-fadein {\n      0%   { opacity: 0; }\n      100% { opacity: 1; }\n    }\n\n    .p-link {\n        text-align: left;\n        background-color: transparent;\n        margin: 0;\n        padding: 0;\n        border: none;\n        cursor: pointer;\n        user-select: none;\n    }\n\n    .p-link:disabled {\n        cursor: default;\n    }\n\n    /* Non react overlay animations */\n    .p-connected-overlay {\n        opacity: 0;\n        transform: scaleY(0.8);\n        transition: transform .12s cubic-bezier(0, 0, 0.2, 1), opacity .12s cubic-bezier(0, 0, 0.2, 1);\n    }\n\n    .p-connected-overlay-visible {\n        opacity: 1;\n        transform: scaleY(1);\n    }\n\n    .p-connected-overlay-hidden {\n        opacity: 0;\n        transform: scaleY(1);\n        transition: opacity .1s linear;\n    }\n\n    /* React based overlay animations */\n    .p-connected-overlay-enter {\n        opacity: 0;\n        transform: scaleY(0.8);\n    }\n\n    .p-connected-overlay-enter-active {\n        opacity: 1;\n        transform: scaleY(1);\n        transition: transform .12s cubic-bezier(0, 0, 0.2, 1), opacity .12s cubic-bezier(0, 0, 0.2, 1);\n    }\n\n    .p-connected-overlay-enter-done {\n        transform: none;\n    }\n\n    .p-connected-overlay-exit {\n        opacity: 1;\n    }\n\n    .p-connected-overlay-exit-active {\n        opacity: 0;\n        transition: opacity .1s linear;\n    }\n\n    /* Toggleable Content */\n    .p-toggleable-content-enter {\n        max-height: 0;\n    }\n\n    .p-toggleable-content-enter-active {\n        overflow: hidden;\n        max-height: 1000px;\n        transition: max-height 1s ease-in-out;\n    }\n\n    .p-toggleable-content-enter-done {\n        transform: none;\n    }\n\n    .p-toggleable-content-exit {\n        max-height: 1000px;\n    }\n\n    .p-toggleable-content-exit-active {\n        overflow: hidden;\n        max-height: 0;\n        transition: max-height 0.45s cubic-bezier(0, 1, 0, 1);\n    }\n\n    .p-sr-only {\n        border: 0;\n        clip: rect(1px, 1px, 1px, 1px);\n        clip-path: inset(50%);\n        height: 1px;\n        margin: -1px;\n        overflow: hidden;\n        padding: 0;\n        position: absolute;\n        width: 1px;\n        word-wrap: normal;\n    }\n\n    /* @todo Refactor */\n    .p-menu .p-menuitem-link {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        text-decoration: none;\n        overflow: hidden;\n        position: relative;\n    }\n\n    ".concat($31c195372834831e$var$buttonStyles, "\n    ").concat($31c195372834831e$var$inputTextStyles, "\n    ").concat($31c195372834831e$var$iconStyles, "\n}\n");
var $31c195372834831e$export$425c3e0a21b857e8 = {
    cProps: undefined,
    cParams: undefined,
    cName: undefined,
    defaultProps: {
        pt: undefined,
        ptOptions: undefined,
        unstyled: false
    },
    context: {},
    globalCSS: undefined,
    classes: {},
    styles: "",
    extend: function extend() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var css = props.css;
        var defaultProps = $31c195372834831e$var$_objectSpread($31c195372834831e$var$_objectSpread({}, props.defaultProps), $31c195372834831e$export$425c3e0a21b857e8.defaultProps);
        var inlineStyles = {};
        var getProps = function getProps(props) {
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            $31c195372834831e$export$425c3e0a21b857e8.context = context;
            $31c195372834831e$export$425c3e0a21b857e8.cProps = props;
            return (0, $cfkGk.ObjectUtils).getMergedProps(props, defaultProps);
        };
        var getOtherProps = function getOtherProps(props) {
            return (0, $cfkGk.ObjectUtils).getDiffProps(props, defaultProps);
        };
        var getPTValue = function getPTValue() {
            var _ComponentBase$contex;
            var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var searchInDefaultPT = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
            // obj either is the passthrough options or has a .pt property.
            if (obj.hasOwnProperty("pt") && obj.pt !== undefined) obj = obj.pt;
            var originalkey = key;
            var isNestedParam = /./g.test(originalkey) && !!params[originalkey.split(".")[0]];
            var fkey = isNestedParam ? (0, $cfkGk.ObjectUtils).toFlatCase(originalkey.split(".")[1]) : (0, $cfkGk.ObjectUtils).toFlatCase(originalkey);
            var hostName = params.hostName && (0, $cfkGk.ObjectUtils).toFlatCase(params.hostName);
            var componentName = hostName || params.props && params.props.__TYPE && (0, $cfkGk.ObjectUtils).toFlatCase(params.props.__TYPE) || "";
            var isTransition = fkey === "transition";
            var datasetPrefix = "data-pc-";
            var getHostInstance = function getHostInstance(params) {
                return params !== null && params !== void 0 && params.props ? params.hostName ? params.props.__TYPE === params.hostName ? params.props : getHostInstance(params.parent) : params.parent : undefined;
            };
            var getPropValue = function getPropValue(name) {
                var _params$props, _getHostInstance;
                return ((_params$props = params.props) === null || _params$props === void 0 ? void 0 : _params$props[name]) || ((_getHostInstance = getHostInstance(params)) === null || _getHostInstance === void 0 ? void 0 : _getHostInstance[name]);
            };
            $31c195372834831e$export$425c3e0a21b857e8.cParams = params;
            $31c195372834831e$export$425c3e0a21b857e8.cName = componentName;
            var _ref = getPropValue("ptOptions") || $31c195372834831e$export$425c3e0a21b857e8.context.ptOptions || {}, _ref$mergeSections = _ref.mergeSections, mergeSections = _ref$mergeSections === void 0 ? true : _ref$mergeSections, _ref$mergeProps = _ref.mergeProps, useMergeProps = _ref$mergeProps === void 0 ? false : _ref$mergeProps;
            var getPTClassValue = function getPTClassValue() {
                var value = $31c195372834831e$var$getOptionValue.apply(void 0, arguments);
                if (Array.isArray(value)) return {
                    className: (0, $cfkGk.classNames).apply(void 0, $31c195372834831e$var$_toConsumableArray(value))
                };
                if ((0, $cfkGk.ObjectUtils).isString(value)) return {
                    className: value
                };
                if (value !== null && value !== void 0 && value.hasOwnProperty("className") && Array.isArray(value.className)) return {
                    className: (0, $cfkGk.classNames).apply(void 0, $31c195372834831e$var$_toConsumableArray(value.className))
                };
                return value;
            };
            var globalPT = searchInDefaultPT ? isNestedParam ? $31c195372834831e$var$_useGlobalPT(getPTClassValue, originalkey, params) : $31c195372834831e$var$_useDefaultPT(getPTClassValue, originalkey, params) : undefined;
            var self = isNestedParam ? undefined : $31c195372834831e$var$_usePT($31c195372834831e$var$_getPT(obj, componentName), getPTClassValue, originalkey, params);
            var datasetProps = !isTransition && $31c195372834831e$var$_objectSpread($31c195372834831e$var$_objectSpread({}, fkey === "root" && $31c195372834831e$var$_defineProperty({}, "".concat(datasetPrefix, "name"), params.props && params.props.__parentMetadata ? (0, $cfkGk.ObjectUtils).toFlatCase(params.props.__TYPE) : componentName)), {}, $31c195372834831e$var$_defineProperty({}, "".concat(datasetPrefix, "section"), fkey));
            return mergeSections || !mergeSections && self ? useMergeProps ? (0, $cfkGk.mergeProps)([
                globalPT,
                self,
                Object.keys(datasetProps).length ? datasetProps : {}
            ], {
                classNameMergeFunction: (_ComponentBase$contex = $31c195372834831e$export$425c3e0a21b857e8.context.ptOptions) === null || _ComponentBase$contex === void 0 ? void 0 : _ComponentBase$contex.classNameMergeFunction
            }) : $31c195372834831e$var$_objectSpread($31c195372834831e$var$_objectSpread($31c195372834831e$var$_objectSpread({}, globalPT), self), Object.keys(datasetProps).length ? datasetProps : {}) : $31c195372834831e$var$_objectSpread($31c195372834831e$var$_objectSpread({}, self), Object.keys(datasetProps).length ? datasetProps : {});
        };
        var setMetaData = function setMetaData() {
            var metadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var props = metadata.props, state = metadata.state;
            var ptm = function ptm() {
                var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return getPTValue((props || {}).pt, key, $31c195372834831e$var$_objectSpread($31c195372834831e$var$_objectSpread({}, metadata), params));
            };
            var ptmo = function ptmo() {
                var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return getPTValue(obj, key, params, false);
            };
            var isUnstyled = function isUnstyled() {
                return $31c195372834831e$export$425c3e0a21b857e8.context.unstyled || (0, $8Zwsm.default).unstyled || props.unstyled;
            };
            var cx = function cx() {
                var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return !isUnstyled() ? $31c195372834831e$var$getOptionValue(css && css.classes, key, $31c195372834831e$var$_objectSpread({
                    props: props,
                    state: state
                }, params)) : undefined;
            };
            var sx = function sx() {
                var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                if (when) {
                    var _ComponentBase$contex2;
                    var self = $31c195372834831e$var$getOptionValue(css && css.inlineStyles, key, $31c195372834831e$var$_objectSpread({
                        props: props,
                        state: state
                    }, params));
                    var base = $31c195372834831e$var$getOptionValue(inlineStyles, key, $31c195372834831e$var$_objectSpread({
                        props: props,
                        state: state
                    }, params));
                    return (0, $cfkGk.mergeProps)([
                        base,
                        self
                    ], {
                        classNameMergeFunction: (_ComponentBase$contex2 = $31c195372834831e$export$425c3e0a21b857e8.context.ptOptions) === null || _ComponentBase$contex2 === void 0 ? void 0 : _ComponentBase$contex2.classNameMergeFunction
                    });
                }
                return undefined;
            };
            return {
                ptm: ptm,
                ptmo: ptmo,
                sx: sx,
                cx: cx,
                isUnstyled: isUnstyled
            };
        };
        return $31c195372834831e$var$_objectSpread($31c195372834831e$var$_objectSpread({
            getProps: getProps,
            getOtherProps: getOtherProps,
            setMetaData: setMetaData
        }, props), {}, {
            defaultProps: defaultProps
        });
    }
};
var $31c195372834831e$var$getOptionValue = function getOptionValue(obj) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var fKeys = String((0, $cfkGk.ObjectUtils).toFlatCase(key)).split(".");
    var fKey = fKeys.shift();
    var matchedPTOption = (0, $cfkGk.ObjectUtils).isNotEmpty(obj) ? Object.keys(obj).find(function(k) {
        return (0, $cfkGk.ObjectUtils).toFlatCase(k) === fKey;
    }) : "";
    return fKey ? (0, $cfkGk.ObjectUtils).isObject(obj) ? getOptionValue((0, $cfkGk.ObjectUtils).getItemValue(obj[matchedPTOption], params), fKeys.join("."), params) : undefined : (0, $cfkGk.ObjectUtils).getItemValue(obj, params);
};
var $31c195372834831e$var$_getPT = function _getPT(pt) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var callback = arguments.length > 2 ? arguments[2] : undefined;
    var _usept = pt === null || pt === void 0 ? void 0 : pt._usept;
    var getValue = function getValue(value) {
        var _ref3;
        var checkSameKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var _value = callback ? callback(value) : value;
        var _key = (0, $cfkGk.ObjectUtils).toFlatCase(key);
        return (_ref3 = checkSameKey ? _key !== $31c195372834831e$export$425c3e0a21b857e8.cName ? _value === null || _value === void 0 ? void 0 : _value[_key] : undefined : _value === null || _value === void 0 ? void 0 : _value[_key]) !== null && _ref3 !== void 0 ? _ref3 : _value;
    };
    return (0, $cfkGk.ObjectUtils).isNotEmpty(_usept) ? {
        _usept: _usept,
        originalValue: getValue(pt.originalValue),
        value: getValue(pt.value)
    } : getValue(pt, true);
};
var $31c195372834831e$var$_usePT = function _usePT(pt, callback, key, params) {
    var fn = function fn(value) {
        return callback(value, key, params);
    };
    if (pt !== null && pt !== void 0 && pt.hasOwnProperty("_usept")) {
        var _ref4 = pt._usept || $31c195372834831e$export$425c3e0a21b857e8.context.ptOptions || {}, _ref4$mergeSections = _ref4.mergeSections, mergeSections = _ref4$mergeSections === void 0 ? true : _ref4$mergeSections, _ref4$mergeProps = _ref4.mergeProps, useMergeProps = _ref4$mergeProps === void 0 ? false : _ref4$mergeProps, classNameMergeFunction = _ref4.classNameMergeFunction;
        var originalValue = fn(pt.originalValue);
        var value = fn(pt.value);
        if (originalValue === undefined && value === undefined) return undefined;
        else if ((0, $cfkGk.ObjectUtils).isString(value)) return value;
        else if ((0, $cfkGk.ObjectUtils).isString(originalValue)) return originalValue;
        return mergeSections || !mergeSections && value ? useMergeProps ? (0, $cfkGk.mergeProps)([
            originalValue,
            value
        ], {
            classNameMergeFunction: classNameMergeFunction
        }) : $31c195372834831e$var$_objectSpread($31c195372834831e$var$_objectSpread({}, originalValue), value) : value;
    }
    return fn(pt);
};
var $31c195372834831e$var$getGlobalPT = function getGlobalPT() {
    return $31c195372834831e$var$_getPT($31c195372834831e$export$425c3e0a21b857e8.context.pt || (0, $8Zwsm.default).pt, undefined, function(value) {
        return (0, $cfkGk.ObjectUtils).getItemValue(value, $31c195372834831e$export$425c3e0a21b857e8.cParams);
    });
};
var $31c195372834831e$var$getDefaultPT = function getDefaultPT() {
    return $31c195372834831e$var$_getPT($31c195372834831e$export$425c3e0a21b857e8.context.pt || (0, $8Zwsm.default).pt, undefined, function(value) {
        return $31c195372834831e$var$getOptionValue(value, $31c195372834831e$export$425c3e0a21b857e8.cName, $31c195372834831e$export$425c3e0a21b857e8.cParams) || (0, $cfkGk.ObjectUtils).getItemValue(value, $31c195372834831e$export$425c3e0a21b857e8.cParams);
    });
};
var $31c195372834831e$var$_useGlobalPT = function _useGlobalPT(callback, key, params) {
    return $31c195372834831e$var$_usePT($31c195372834831e$var$getGlobalPT(), callback, key, params);
};
var $31c195372834831e$var$_useDefaultPT = function _useDefaultPT(callback, key, params) {
    return $31c195372834831e$var$_usePT($31c195372834831e$var$getDefaultPT(), callback, key, params);
};
var $31c195372834831e$export$142583cb150b394 = function useHandleStyle(styles) {
    var config = arguments.length > 2 ? arguments[2] : undefined;
    var name = config.name, _config$styled = config.styled, styled = _config$styled === void 0 ? false : _config$styled, _config$hostName = config.hostName, hostName = _config$hostName === void 0 ? "" : _config$hostName;
    var globalCSS = $31c195372834831e$var$_useGlobalPT($31c195372834831e$var$getOptionValue, "global.css", $31c195372834831e$export$425c3e0a21b857e8.cParams);
    var componentName = (0, $cfkGk.ObjectUtils).toFlatCase(name);
    var _useStyle = (0, $l2NC0.useStyle)($31c195372834831e$var$baseStyle, {
        name: "base",
        manual: true
    }), loadBaseStyle = _useStyle.load;
    var _useStyle2 = (0, $l2NC0.useStyle)($31c195372834831e$var$commonStyle, {
        name: "common",
        manual: true
    }), loadCommonStyle = _useStyle2.load;
    var _useStyle3 = (0, $l2NC0.useStyle)(globalCSS, {
        name: "global",
        manual: true
    }), loadGlobalStyle = _useStyle3.load;
    var _useStyle4 = (0, $l2NC0.useStyle)(styles, {
        name: name,
        manual: true
    }), load = _useStyle4.load;
    var hook = function hook(hookName) {
        if (!hostName) {
            var selfHook = $31c195372834831e$var$_usePT($31c195372834831e$var$_getPT(($31c195372834831e$export$425c3e0a21b857e8.cProps || {}).pt, componentName), $31c195372834831e$var$getOptionValue, "hooks.".concat(hookName));
            var defaultHook = $31c195372834831e$var$_useDefaultPT($31c195372834831e$var$getOptionValue, "hooks.".concat(hookName));
            selfHook === null || selfHook === void 0 || selfHook();
            defaultHook === null || defaultHook === void 0 || defaultHook();
        }
    };
    hook("useMountEffect");
    (0, $l2NC0.useMountEffect)(function() {
        loadBaseStyle();
        loadGlobalStyle();
        loadCommonStyle();
        if (!styled) load();
    });
    (0, $l2NC0.useUpdateEffect)(function() {
        hook("useUpdateEffect");
    });
    (0, $l2NC0.useUnmountEffect)(function() {
        hook("useUnmountEffect");
    });
};

});
parcelRegister("l2NC0", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $f52044c30799e016$export$5cae361ad82dce8b);
$parcel$export(module.exports, "useUnmountEffect", () => $f52044c30799e016$export$f3a192d0cbd30b96);
$parcel$export(module.exports, "useEventListener", () => $f52044c30799e016$export$7080b3e976bc91ab);
$parcel$export(module.exports, "useMountEffect", () => $f52044c30799e016$export$51c44cea289ac0f6);
$parcel$export(module.exports, "useDisplayOrder", () => $f52044c30799e016$export$6353a33119af9098);
$parcel$export(module.exports, "ESC_KEY_HANDLING_PRIORITIES", () => $f52044c30799e016$export$5153c70e1a2d4b71);
$parcel$export(module.exports, "useGlobalOnEscapeKey", () => $f52044c30799e016$export$dee4359f392495ae);
$parcel$export(module.exports, "useMatchMedia", () => $f52044c30799e016$export$dd42f485803cd57d);
$parcel$export(module.exports, "useMergeProps", () => $f52044c30799e016$export$9596428d77cc41ba);
$parcel$export(module.exports, "useOverlayScrollListener", () => $f52044c30799e016$export$d04245b74d6bdcb8);
$parcel$export(module.exports, "useResizeListener", () => $f52044c30799e016$export$158eb97be50d41ef);
$parcel$export(module.exports, "useOverlayListener", () => $f52044c30799e016$export$2fef17345d27a5b4);
$parcel$export(module.exports, "useStyle", () => $f52044c30799e016$export$72c85e333541e7f);
$parcel$export(module.exports, "useTimeout", () => $f52044c30799e016$export$d8e6abf214c9ec0f);
$parcel$export(module.exports, "useUpdateEffect", () => $f52044c30799e016$export$496315a1608d9602);

var $81g6h = parcelRequire("81g6h");

var $cfkGk = parcelRequire("cfkGk");

var $8Zwsm = parcelRequire("8Zwsm");
"use client";
function $f52044c30799e016$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f52044c30799e016$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $f52044c30799e016$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f52044c30799e016$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f52044c30799e016$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f52044c30799e016$var$_arrayLikeToArray(o, minLen);
}
function $f52044c30799e016$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f52044c30799e016$var$_slicedToArray(arr, i) {
    return $f52044c30799e016$var$_arrayWithHoles(arr) || $f52044c30799e016$var$_iterableToArrayLimit(arr, i) || $f52044c30799e016$var$_unsupportedIterableToArray(arr, i) || $f52044c30799e016$var$_nonIterableRest();
}
var $f52044c30799e016$export$5cae361ad82dce8b = function usePrevious(newValue) {
    var ref = $81g6h.useRef(null);
    $81g6h.useEffect(function() {
        ref.current = newValue;
        return function() {
            ref.current = null;
        };
    }, [
        newValue
    ]);
    return ref.current;
};
/* eslint-disable */ var $f52044c30799e016$export$f3a192d0cbd30b96 = function useUnmountEffect(fn) {
    return $81g6h.useEffect(function() {
        return fn;
    }, []);
};
/* eslint-enable */ var $f52044c30799e016$export$7080b3e976bc91ab = function useEventListener(_ref) {
    var _ref$target = _ref.target, target = _ref$target === void 0 ? "document" : _ref$target, type = _ref.type, listener = _ref.listener, options = _ref.options, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    var targetRef = $81g6h.useRef(null);
    var listenerRef = $81g6h.useRef(null);
    var prevListener = $f52044c30799e016$export$5cae361ad82dce8b(listener);
    var prevOptions = $f52044c30799e016$export$5cae361ad82dce8b(options);
    var bind = function bind() {
        var bindOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var bindTarget = bindOptions.target;
        if ((0, $cfkGk.ObjectUtils).isNotEmpty(bindTarget)) {
            unbind();
            (bindOptions.when || when) && (targetRef.current = (0, $cfkGk.DomHandler).getTargetElement(bindTarget));
        }
        if (!listenerRef.current && targetRef.current) {
            listenerRef.current = function(event) {
                return listener && listener(event);
            };
            targetRef.current.addEventListener(type, listenerRef.current, options);
        }
    };
    var unbind = function unbind() {
        if (listenerRef.current) {
            targetRef.current.removeEventListener(type, listenerRef.current, options);
            listenerRef.current = null;
        }
    };
    var dispose = function dispose() {
        unbind();
        // Prevent memory leak by releasing
        prevListener = null;
        prevOptions = null;
    };
    var updateTarget = $81g6h.useCallback(function() {
        if (when) targetRef.current = (0, $cfkGk.DomHandler).getTargetElement(target);
        else {
            unbind();
            targetRef.current = null;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        target,
        when
    ]);
    $81g6h.useEffect(function() {
        updateTarget();
    }, [
        updateTarget
    ]);
    $81g6h.useEffect(function() {
        var listenerChanged = "".concat(prevListener) !== "".concat(listener);
        var optionsChanged = prevOptions !== options;
        var listenerExists = listenerRef.current;
        if (listenerExists && (listenerChanged || optionsChanged)) {
            unbind();
            when && bind();
        } else if (!listenerExists) dispose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        listener,
        options,
        when
    ]);
    $f52044c30799e016$export$f3a192d0cbd30b96(function() {
        dispose();
    });
    return [
        bind,
        unbind
    ];
};
var $f52044c30799e016$export$1896bab46732d207 = function useClickOutside(ref, callback) {
    var isOutsideClicked = function isOutsideClicked(event) {
        if (!ref.current || ref.current.contains(event.target)) return;
        callback(event);
    };
    var _useEventListener = $f52044c30799e016$export$7080b3e976bc91ab({
        type: "mousedown",
        listener: isOutsideClicked
    }), _useEventListener2 = $f52044c30799e016$var$_slicedToArray(_useEventListener, 2), bindMouseDownListener = _useEventListener2[0], unbindMouseDownListener = _useEventListener2[1];
    var _useEventListener3 = $f52044c30799e016$export$7080b3e976bc91ab({
        type: "touchstart",
        listener: isOutsideClicked
    }), _useEventListener4 = $f52044c30799e016$var$_slicedToArray(_useEventListener3, 2), bindTouchStartListener = _useEventListener4[0], unbindTouchStartListener = _useEventListener4[1];
    $81g6h.useEffect(function() {
        if (!ref.current) return;
        bindMouseDownListener();
        bindTouchStartListener();
        return function() {
            unbindMouseDownListener();
            unbindTouchStartListener();
        };
    });
    return [
        ref,
        callback
    ];
};
var $f52044c30799e016$export$70c4067197c60e2d = function useCounter() {
    var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        step: 1
    };
    var _React$useState = $81g6h.useState(initialValue), _React$useState2 = $f52044c30799e016$var$_slicedToArray(_React$useState, 2), count = _React$useState2[0], setCount = _React$useState2[1];
    var increment = function increment() {
        if (options.max && count >= options.max) return;
        setCount(count + options.step);
    };
    var decrement = function decrement() {
        if (options.min || options.min === 0 && count <= options.min) return null;
        setCount(count - options.step);
    };
    var reset = function reset() {
        setCount(0);
    };
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset
    };
};
var $f52044c30799e016$export$21805fee57372823 = function useDebounce(initialValue, delay) {
    var _React$useState = $81g6h.useState(initialValue), _React$useState2 = $f52044c30799e016$var$_slicedToArray(_React$useState, 2), inputValue = _React$useState2[0], setInputValue = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(initialValue), _React$useState4 = $f52044c30799e016$var$_slicedToArray(_React$useState3, 2), debouncedValue = _React$useState4[0], setDebouncedValue = _React$useState4[1];
    var mountedRef = $81g6h.useRef(false);
    var timeoutRef = $81g6h.useRef(null);
    var cancelTimer = function cancelTimer() {
        return window.clearTimeout(timeoutRef.current);
    };
    $f52044c30799e016$export$51c44cea289ac0f6(function() {
        mountedRef.current = true;
    });
    $f52044c30799e016$export$f3a192d0cbd30b96(function() {
        cancelTimer();
    });
    $81g6h.useEffect(function() {
        if (!mountedRef.current) return;
        cancelTimer();
        timeoutRef.current = window.setTimeout(function() {
            setDebouncedValue(inputValue);
        }, delay);
    }, [
        inputValue,
        delay
    ]);
    return [
        inputValue,
        debouncedValue,
        setInputValue
    ];
};
var $f52044c30799e016$var$groupToDisplayedElements = {};
var $f52044c30799e016$export$6353a33119af9098 = function useDisplayOrder(group) {
    var isVisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var _React$useState = $81g6h.useState(function() {
        return (0, $cfkGk.UniqueComponentId)();
    }), _React$useState2 = $f52044c30799e016$var$_slicedToArray(_React$useState, 1), uid = _React$useState2[0];
    var _React$useState3 = $81g6h.useState(0), _React$useState4 = $f52044c30799e016$var$_slicedToArray(_React$useState3, 2), displayOrder = _React$useState4[0], setDisplayOrder = _React$useState4[1];
    $81g6h.useEffect(function() {
        if (isVisible) {
            if (!$f52044c30799e016$var$groupToDisplayedElements[group]) $f52044c30799e016$var$groupToDisplayedElements[group] = [];
            var newDisplayOrder = $f52044c30799e016$var$groupToDisplayedElements[group].push(uid);
            setDisplayOrder(newDisplayOrder);
            return function() {
                delete $f52044c30799e016$var$groupToDisplayedElements[group][newDisplayOrder - 1];
                // Reduce array length, by removing undefined elements at the end of array:
                var lastIndex = $f52044c30799e016$var$groupToDisplayedElements[group].length - 1;
                var lastOrder = (0, $cfkGk.ObjectUtils).findLastIndex($f52044c30799e016$var$groupToDisplayedElements[group], function(el) {
                    return el !== undefined;
                });
                if (lastOrder !== lastIndex) $f52044c30799e016$var$groupToDisplayedElements[group].splice(lastOrder + 1);
                setDisplayOrder(undefined);
            };
        }
    }, [
        group,
        uid,
        isVisible
    ]);
    return displayOrder;
};
var $f52044c30799e016$var$TYPE_MAP = {
    ico: "image/x-icon",
    png: "image/png",
    svg: "image/svg+xml",
    gif: "image/gif"
};
var $f52044c30799e016$export$1252d0179ae6292b = function useFavicon() {
    var newIcon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var rel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "shortcut icon";
    $81g6h.useLayoutEffect(function() {
        if (newIcon) {
            var linkElements = document.querySelectorAll("link[rel*='icon']");
            linkElements.forEach(function(linkEl) {
                document.head.removeChild(linkEl);
            });
            var link = document.createElement("link");
            link.setAttribute("type", $f52044c30799e016$var$TYPE_MAP[newIcon.split(".").pop()]);
            link.setAttribute("rel", rel);
            link.setAttribute("href", newIcon);
            document.head.appendChild(link);
        }
    }, [
        newIcon,
        rel
    ]);
};
function $f52044c30799e016$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f52044c30799e016$var$_arrayLikeToArray(arr);
}
function $f52044c30799e016$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f52044c30799e016$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f52044c30799e016$var$_toConsumableArray(arr) {
    return $f52044c30799e016$var$_arrayWithoutHoles(arr) || $f52044c30799e016$var$_iterableToArray(arr) || $f52044c30799e016$var$_unsupportedIterableToArray(arr) || $f52044c30799e016$var$_nonIterableSpread();
}
/**
 * Priorities of different components (bigger number handled first)
 */ var $f52044c30799e016$export$5153c70e1a2d4b71 = {
    SIDEBAR: 100,
    SLIDE_MENU: 200,
    DIALOG: 300,
    IMAGE: 400,
    MENU: 500,
    OVERLAY_PANEL: 600,
    PASSWORD: 700,
    CASCADE_SELECT: 800,
    SPLIT_BUTTON: 900,
    SPEED_DIAL: 1000,
    TOOLTIP: 1200
};
/**
 * Object, that manages global escape key handling logic
 */ var $f52044c30799e016$var$globalEscKeyHandlingLogic = {
    /**
   * Mapping from ESC_KEY_HANDLING_PRIORITY to array of related listeners, grouped by priority
   * @example
   * Map<{
   *     [ESC_KEY_HANDLING_PRIORITIES.SIDEBAR]: Map<{
   *         1: () => {...},
   *         2: () => {...}
   *     }>,
   *     [ESC_KEY_HANDLING_PRIORITIES.DIALOG]: Map<{
   *         1: () => {...},
   *         2: () => {...}
   *     }>
   * }>;
   */ escKeyListeners: new Map(),
    /**
   * Keydown handler (attached to any keydown)
   */ onGlobalKeyDown: function onGlobalKeyDown(event) {
        // Do nothing if not an "esc" key is pressed:
        if (event.code !== "Escape") return;
        var escKeyListeners = $f52044c30799e016$var$globalEscKeyHandlingLogic.escKeyListeners;
        var maxPrimaryPriority = Math.max.apply(Math, $f52044c30799e016$var$_toConsumableArray(escKeyListeners.keys()));
        var theMostImportantEscHandlersSet = escKeyListeners.get(maxPrimaryPriority);
        var maxSecondaryPriority = Math.max.apply(Math, $f52044c30799e016$var$_toConsumableArray(theMostImportantEscHandlersSet.keys()));
        var theMostImportantEscHandler = theMostImportantEscHandlersSet.get(maxSecondaryPriority);
        theMostImportantEscHandler(event);
    },
    /**
   * Attach global keydown listener if there are any "esc" key handlers assigned,
   * otherwise detach.
   */ refreshGlobalKeyDownListener: function refreshGlobalKeyDownListener() {
        var document1 = (0, $cfkGk.DomHandler).getTargetElement("document");
        if (this.escKeyListeners.size > 0) document1.addEventListener("keydown", this.onGlobalKeyDown);
        else document1.removeEventListener("keydown", this.onGlobalKeyDown);
    },
    /**
   * Add "Esc" key handler
   */ addListener: function addListener(callback, _ref) {
        var _this = this;
        var _ref2 = $f52044c30799e016$var$_slicedToArray(_ref, 2), primaryPriority = _ref2[0], secondaryPriority = _ref2[1];
        var escKeyListeners = this.escKeyListeners;
        if (!escKeyListeners.has(primaryPriority)) escKeyListeners.set(primaryPriority, new Map());
        var primaryPriorityListeners = escKeyListeners.get(primaryPriority);
        // To prevent unexpected override of callback:
        if (primaryPriorityListeners.has(secondaryPriority)) throw new Error("Unexpected: global esc key listener with priority [".concat(primaryPriority, ", ").concat(secondaryPriority, "] already exists."));
        primaryPriorityListeners.set(secondaryPriority, callback);
        this.refreshGlobalKeyDownListener();
        return function() {
            primaryPriorityListeners["delete"](secondaryPriority);
            if (primaryPriorityListeners.size === 0) escKeyListeners["delete"](primaryPriority);
            _this.refreshGlobalKeyDownListener();
        };
    }
};
var $f52044c30799e016$export$dee4359f392495ae = function useGlobalOnEscapeKey(_ref3) {
    var callback = _ref3.callback, when = _ref3.when, priority = _ref3.priority;
    (0, $81g6h.useEffect)(function() {
        if (!when) return;
        return $f52044c30799e016$var$globalEscKeyHandlingLogic.addListener(callback, priority);
    }, [
        callback,
        when,
        priority
    ]);
};
var $f52044c30799e016$export$a7395f9832c00176 = function useIntersectionObserver(ref) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _React$useState = $81g6h.useState(false), _React$useState2 = $f52044c30799e016$var$_slicedToArray(_React$useState, 2), isElementVisible = _React$useState2[0], setIsElementVisible = _React$useState2[1];
    $81g6h.useEffect(function() {
        if (!ref.current) return;
        var observer = new IntersectionObserver(function(_ref) {
            var _ref2 = $f52044c30799e016$var$_slicedToArray(_ref, 1), entry = _ref2[0];
            setIsElementVisible(entry.isIntersecting);
        }, options);
        observer.observe(ref.current);
        return function() {
            observer.disconnect();
        };
    }, [
        options,
        ref
    ]);
    return isElementVisible;
};
/* eslint-disable */ var $f52044c30799e016$export$f4b266cd2aae9cb1 = function useInterval(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var timeout = $81g6h.useRef(null);
    var savedCallback = $81g6h.useRef(null);
    var clear = $81g6h.useCallback(function() {
        return clearInterval(timeout.current);
    }, [
        timeout.current
    ]);
    $81g6h.useEffect(function() {
        savedCallback.current = fn;
    });
    $81g6h.useEffect(function() {
        function callback() {
            savedCallback.current();
        }
        if (when) {
            timeout.current = setInterval(callback, delay);
            return clear;
        } else clear();
    }, [
        delay,
        when
    ]);
    $f52044c30799e016$export$f3a192d0cbd30b96(function() {
        clear();
    });
    return [
        clear
    ];
};
/* eslint-enable */ var $f52044c30799e016$export$dd42f485803cd57d = function useMatchMedia(query) {
    var when = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var _React$useState = $81g6h.useState(false), _React$useState2 = $f52044c30799e016$var$_slicedToArray(_React$useState, 2), matches = _React$useState2[0], setMatches = _React$useState2[1];
    var matchMedia = $81g6h.useRef(null);
    var handleChange = function handleChange(e) {
        return setMatches(e.matches);
    };
    var bind = function bind() {
        return matchMedia.current && matchMedia.current.addEventListener("change", handleChange);
    };
    var unbind = function unbind() {
        return matchMedia.current && matchMedia.current.removeEventListener("change", handleChange) && (matchMedia.current = null);
    };
    $81g6h.useEffect(function() {
        if (when) {
            matchMedia.current = window.matchMedia(query);
            setMatches(matchMedia.current.matches);
            bind();
        }
        return unbind;
    }, [
        query,
        when
    ]);
    return matches;
};
/* eslint-enable */ /**
 * Hook to merge properties including custom merge function for things like Tailwind merge.
 */ var $f52044c30799e016$export$9596428d77cc41ba = function useMergeProps() {
    var context = (0, $81g6h.useContext)((0, $8Zwsm.PrimeReactContext));
    return function() {
        for(var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++)props[_key] = arguments[_key];
        return (0, $cfkGk.mergeProps)(props, context === null || context === void 0 ? void 0 : context.ptOptions);
    };
};
/* eslint-disable */ /**
 * Custom hook to run a mount effect only once.
 * @param {*} fn the callback function
 * @returns the hook
 */ var $f52044c30799e016$export$51c44cea289ac0f6 = function useMountEffect(fn) {
    var mounted = $81g6h.useRef(false);
    return $81g6h.useEffect(function() {
        if (!mounted.current) {
            mounted.current = true;
            return fn && fn();
        }
    }, []);
};
/* eslint-enable */ function $f52044c30799e016$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f52044c30799e016$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f52044c30799e016$var$_typeof(o);
}
function $f52044c30799e016$var$_toPrimitive(input, hint) {
    if ($f52044c30799e016$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f52044c30799e016$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f52044c30799e016$var$_toPropertyKey(arg) {
    var key = $f52044c30799e016$var$_toPrimitive(arg, "string");
    return $f52044c30799e016$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f52044c30799e016$var$_defineProperty(obj, key, value) {
    key = $f52044c30799e016$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f52044c30799e016$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f52044c30799e016$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f52044c30799e016$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $f52044c30799e016$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f52044c30799e016$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f52044c30799e016$export$70811b4970b0f258 = function useMouse() {
    var _React$useState = $81g6h.useState({
        x: 0,
        y: 0
    }), _React$useState2 = $f52044c30799e016$var$_slicedToArray(_React$useState, 2), position = _React$useState2[0], setPosition = _React$useState2[1];
    var ref = $81g6h.useRef(null);
    var handleMouseMove = $81g6h.useCallback(function(event) {
        var x;
        var y;
        if (ref.current) {
            var rect = event.currentTarget.getBoundingClientRect();
            x = event.pageX - rect.left - (window.pageXOffset || window.scrollX);
            y = event.pageY - rect.top - (window.pageYOffset || window.scrollY);
        } else {
            x = event.clientX;
            y = event.clientY;
        }
        setPosition({
            x: Math.max(0, Math.round(x)),
            y: Math.max(0, Math.round(y))
        });
    }, []);
    var _useEventListener = $f52044c30799e016$export$7080b3e976bc91ab({
        target: ref,
        type: "mousemove",
        listener: handleMouseMove
    }), _useEventListener2 = $f52044c30799e016$var$_slicedToArray(_useEventListener, 2), bindMouseMoveEventListener = _useEventListener2[0], unbindMouseMoveEventListener = _useEventListener2[1];
    var _useEventListener3 = $f52044c30799e016$export$7080b3e976bc91ab({
        type: "mousemove",
        listener: handleMouseMove
    }), _useEventListener4 = $f52044c30799e016$var$_slicedToArray(_useEventListener3, 2), bindDocumentMoveEventListener = _useEventListener4[0], unbindDocumentMoveEventListener = _useEventListener4[1];
    var reset = function reset() {
        return setPosition({
            x: 0,
            y: 0
        });
    };
    $81g6h.useEffect(function() {
        bindMouseMoveEventListener();
        if (!ref.current) bindDocumentMoveEventListener();
        return function() {
            unbindMouseMoveEventListener();
            // eslint-disable-next-line react-hooks/exhaustive-deps
            if (!ref.current) unbindDocumentMoveEventListener();
        };
    }, [
        bindDocumentMoveEventListener,
        bindMouseMoveEventListener,
        unbindDocumentMoveEventListener,
        unbindMouseMoveEventListener
    ]);
    return $f52044c30799e016$var$_objectSpread$1($f52044c30799e016$var$_objectSpread$1({
        ref: ref
    }, position), {}, {
        reset: reset
    });
};
function $f52044c30799e016$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f52044c30799e016$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f52044c30799e016$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f52044c30799e016$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f52044c30799e016$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f52044c30799e016$export$36da96379f79f245(_ref) {
    var _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "both" : _ref$mode, _ref$initialValue = _ref.initialValue, initialValue = _ref$initialValue === void 0 ? {
        x: 0,
        y: 0
    } : _ref$initialValue;
    var _React$useState = $81g6h.useState(initialValue), _React$useState2 = $f52044c30799e016$var$_slicedToArray(_React$useState, 2), positions = _React$useState2[0], setPositions = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(false), _React$useState4 = $f52044c30799e016$var$_slicedToArray(_React$useState3, 2), active = _React$useState4[0], setActive = _React$useState4[1];
    var isMounted = $81g6h.useRef(false);
    var isSliding = $81g6h.useRef(false);
    var ref = $81g6h.useRef(null);
    var onMouseMove = function onMouseMove(event) {
        return updateMousePosition({
            x: event.clientX,
            y: event.clientY
        });
    };
    var handlePositionChange = function handlePositionChange(_ref2) {
        var clampedX = _ref2.clampedX, clampedY = _ref2.clampedY;
        if (mode === "vertical") setPositions({
            y: 1 - clampedY
        });
        else if (mode === "horizontal") setPositions({
            x: clampedX
        });
        else if (mode === "both") setPositions({
            x: clampedX,
            y: clampedY
        });
    };
    var onMouseDown = function onMouseDown(event) {
        startScrubbing();
        event.preventDefault();
        onMouseMove(event);
    };
    var stopScrubbing = function stopScrubbing() {
        if (isSliding.current && isMounted.current) {
            isSliding.current = false;
            setActive(false);
            unbindListeners();
        }
    };
    var onTouchMove = function onTouchMove(event) {
        if (event.cancelable) event.preventDefault();
        updateMousePosition({
            x: event.changedTouches[0].clientX,
            y: event.changedTouches[0].clientY
        });
    };
    var onTouchStart = function onTouchStart(event) {
        if (event.cancelable) event.preventDefault();
        startScrubbing();
        onTouchMove(event);
    };
    var _useEventListener = $f52044c30799e016$export$7080b3e976bc91ab({
        type: "mousemove",
        listener: onMouseMove
    }), _useEventListener2 = $f52044c30799e016$var$_slicedToArray(_useEventListener, 2), bindDocumentMouseMoveListener = _useEventListener2[0], unbindDocumentMouseMoveListener = _useEventListener2[1];
    var _useEventListener3 = $f52044c30799e016$export$7080b3e976bc91ab({
        type: "mouseup",
        listener: stopScrubbing
    }), _useEventListener4 = $f52044c30799e016$var$_slicedToArray(_useEventListener3, 2), bindDocumentMouseUpListener = _useEventListener4[0], unbindDocumentMouseUpListener = _useEventListener4[1];
    var _useEventListener5 = $f52044c30799e016$export$7080b3e976bc91ab({
        type: "touchmove",
        listener: onTouchMove
    }), _useEventListener6 = $f52044c30799e016$var$_slicedToArray(_useEventListener5, 2), bindDocumentTouchMoveListener = _useEventListener6[0], unbindDocumentTouchMoveListener = _useEventListener6[1];
    var _useEventListener7 = $f52044c30799e016$export$7080b3e976bc91ab({
        type: "touchend",
        listener: stopScrubbing
    }), _useEventListener8 = $f52044c30799e016$var$_slicedToArray(_useEventListener7, 2), bindDocumentTouchEndListener = _useEventListener8[0], unbindDocumentTouchEndListener = _useEventListener8[1];
    var _useEventListener9 = $f52044c30799e016$export$7080b3e976bc91ab({
        target: ref,
        type: "mousedown",
        listener: onMouseDown
    }), _useEventListener10 = $f52044c30799e016$var$_slicedToArray(_useEventListener9, 2), bindMouseDownListener = _useEventListener10[0], unbindMouseDownListener = _useEventListener10[1];
    var _useEventListener11 = $f52044c30799e016$export$7080b3e976bc91ab({
        target: ref,
        type: "touchstart",
        listener: onTouchStart,
        options: {
            passive: false
        }
    }), _useEventListener12 = $f52044c30799e016$var$_slicedToArray(_useEventListener11, 2), bindTouchStartListener = _useEventListener12[0], unbindTouchStartListener = _useEventListener12[1];
    var clamp = function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
    };
    var clampPositions = function clampPositions(_ref3) {
        var x = _ref3.x, y = _ref3.y;
        return {
            clampedX: clamp(x, 0, 1),
            clampedY: clamp(y, 0, 1)
        };
    };
    var bindListeners = function bindListeners() {
        bindDocumentMouseMoveListener();
        bindDocumentMouseUpListener();
        bindDocumentTouchMoveListener();
        bindDocumentTouchEndListener();
    };
    var unbindListeners = function unbindListeners() {
        unbindDocumentMouseMoveListener();
        unbindDocumentMouseUpListener();
        unbindDocumentTouchMoveListener();
        unbindDocumentTouchEndListener();
    };
    var reset = function reset() {
        setPositions(initialValue);
    };
    $81g6h.useEffect(function() {
        isMounted.current = true;
    }, []);
    var startScrubbing = function startScrubbing() {
        if (!isSliding.current && isMounted.current) {
            isSliding.current = true;
            setActive(true);
            bindListeners();
        }
    };
    var updateMousePosition = function updateMousePosition(_ref4) {
        var x = _ref4.x, y = _ref4.y;
        if (isSliding.current) {
            var rect = ref.current.getBoundingClientRect();
            var _clampPositions = clampPositions({
                x: (x - rect.left) / rect.width,
                y: (y - rect.top) / rect.height
            }), clampedX = _clampPositions.clampedX, clampedY = _clampPositions.clampedY;
            handlePositionChange({
                clampedX: clampedX,
                clampedY: clampedY
            });
        }
    };
    $81g6h.useEffect(function() {
        if (ref.current) {
            bindMouseDownListener();
            bindTouchStartListener();
        }
        return function() {
            if (ref.current) {
                unbindMouseDownListener();
                unbindTouchStartListener();
            }
        };
    }, [
        bindMouseDownListener,
        bindTouchStartListener,
        positions,
        unbindMouseDownListener,
        unbindTouchStartListener
    ]);
    return $f52044c30799e016$var$_objectSpread($f52044c30799e016$var$_objectSpread({
        ref: ref
    }, positions), {}, {
        active: active,
        reset: reset
    });
}
var $f52044c30799e016$export$d04245b74d6bdcb8 = function useOverlayScrollListener(_ref) {
    var target = _ref.target, listener = _ref.listener, options = _ref.options, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var targetRef = $81g6h.useRef(null);
    var listenerRef = $81g6h.useRef(null);
    var scrollableParentsRef = $81g6h.useRef([]);
    var prevListener = $f52044c30799e016$export$5cae361ad82dce8b(listener);
    var prevOptions = $f52044c30799e016$export$5cae361ad82dce8b(options);
    var bind = function bind() {
        var bindOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ((0, $cfkGk.ObjectUtils).isNotEmpty(bindOptions.target)) {
            unbind();
            (bindOptions.when || when) && (targetRef.current = (0, $cfkGk.DomHandler).getTargetElement(bindOptions.target));
        }
        if (!listenerRef.current && targetRef.current) {
            var hideOnScroll = context ? context.hideOverlaysOnDocumentScrolling : (0, $8Zwsm.default).hideOverlaysOnDocumentScrolling;
            var nodes = scrollableParentsRef.current = (0, $cfkGk.DomHandler).getScrollableParents(targetRef.current, hideOnScroll);
            listenerRef.current = function(event) {
                return listener && listener(event);
            };
            nodes.forEach(function(node) {
                return node.addEventListener("scroll", listenerRef.current, options);
            });
        }
    };
    var unbind = function unbind() {
        if (listenerRef.current) {
            var nodes = scrollableParentsRef.current;
            nodes.forEach(function(node) {
                return node.removeEventListener("scroll", listenerRef.current, options);
            });
            listenerRef.current = null;
        }
    };
    var dispose = function dispose() {
        unbind();
        // #5927 prevent memory leak by releasing
        scrollableParentsRef.current = null;
        prevListener = null;
        prevOptions = null;
    };
    var updateTarget = $81g6h.useCallback(function() {
        if (when) targetRef.current = (0, $cfkGk.DomHandler).getTargetElement(target);
        else {
            unbind();
            targetRef.current = null;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        target,
        when
    ]);
    $81g6h.useEffect(function() {
        updateTarget();
    }, [
        updateTarget
    ]);
    $81g6h.useEffect(function() {
        var listenerChanged = "".concat(prevListener) !== "".concat(listener);
        var optionsChanged = prevOptions !== options;
        var listenerExists = listenerRef.current;
        if (listenerExists && (listenerChanged || optionsChanged)) {
            unbind();
            when && bind();
        } else if (!listenerExists) dispose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        listener,
        options,
        when
    ]);
    $f52044c30799e016$export$f3a192d0cbd30b96(function() {
        dispose();
    });
    return [
        bind,
        unbind
    ];
};
var $f52044c30799e016$export$158eb97be50d41ef = function useResizeListener(_ref) {
    var listener = _ref.listener, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return $f52044c30799e016$export$7080b3e976bc91ab({
        target: "window",
        type: "resize",
        listener: listener,
        when: when
    });
};
var $f52044c30799e016$export$2fef17345d27a5b4 = function useOverlayListener(_ref) {
    var target = _ref.target, overlay = _ref.overlay, _listener = _ref.listener, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when, _ref$type = _ref.type, type = _ref$type === void 0 ? "click" : _ref$type;
    var targetRef = $81g6h.useRef(null);
    var overlayRef = $81g6h.useRef(null);
    /**
   * The parameters of the 'listener' method in the following event handlers;
   * @param {Event} event A click event of the document.
   * @param {string} options.type The custom type to detect event.
   * @param {boolean} options.valid It is controlled by PrimeReact. It is determined whether it is valid or not according to some custom validation.
   */ var _useEventListener = $f52044c30799e016$export$7080b3e976bc91ab({
        target: "window",
        type: type,
        listener: function listener(event) {
            _listener && _listener(event, {
                type: "outside",
                valid: event.which !== 3 && isOutsideClicked(event)
            });
        }
    }), _useEventListener2 = $f52044c30799e016$var$_slicedToArray(_useEventListener, 2), bindDocumentClickListener = _useEventListener2[0], unbindDocumentClickListener = _useEventListener2[1];
    var _useResizeListener = $f52044c30799e016$export$158eb97be50d41ef({
        target: "window",
        listener: function listener(event) {
            _listener && _listener(event, {
                type: "resize",
                valid: !(0, $cfkGk.DomHandler).isTouchDevice()
            });
        }
    }), _useResizeListener2 = $f52044c30799e016$var$_slicedToArray(_useResizeListener, 2), bindWindowResizeListener = _useResizeListener2[0], unbindWindowResizeListener = _useResizeListener2[1];
    var _useEventListener3 = $f52044c30799e016$export$7080b3e976bc91ab({
        target: "window",
        type: "orientationchange",
        listener: function listener(event) {
            _listener && _listener(event, {
                type: "orientationchange",
                valid: true
            });
        }
    }), _useEventListener4 = $f52044c30799e016$var$_slicedToArray(_useEventListener3, 2), bindWindowOrientationChangeListener = _useEventListener4[0], unbindWindowOrientationChangeListener = _useEventListener4[1];
    var _useOverlayScrollList = $f52044c30799e016$export$d04245b74d6bdcb8({
        target: target,
        listener: function listener(event) {
            _listener && _listener(event, {
                type: "scroll",
                valid: true
            });
        }
    }), _useOverlayScrollList2 = $f52044c30799e016$var$_slicedToArray(_useOverlayScrollList, 2), bindOverlayScrollListener = _useOverlayScrollList2[0], unbindOverlayScrollListener = _useOverlayScrollList2[1];
    var isOutsideClicked = function isOutsideClicked(event) {
        return targetRef.current && !(targetRef.current.isSameNode(event.target) || targetRef.current.contains(event.target) || overlayRef.current && overlayRef.current.contains(event.target));
    };
    var bind = function bind() {
        bindDocumentClickListener();
        bindWindowResizeListener();
        bindWindowOrientationChangeListener();
        bindOverlayScrollListener();
    };
    var unbind = function unbind() {
        unbindDocumentClickListener();
        unbindWindowResizeListener();
        unbindWindowOrientationChangeListener();
        unbindOverlayScrollListener();
    };
    $81g6h.useEffect(function() {
        if (when) {
            targetRef.current = (0, $cfkGk.DomHandler).getTargetElement(target);
            overlayRef.current = (0, $cfkGk.DomHandler).getTargetElement(overlay);
        } else {
            unbind();
            targetRef.current = overlayRef.current = null;
        }
    }, [
        target,
        overlay,
        when
    ]);
    $81g6h.useEffect(function() {
        unbind();
    }, [
        when
    ]);
    $f52044c30799e016$export$f3a192d0cbd30b96(function() {
        unbind();
    });
    return [
        bind,
        unbind
    ];
};
/* eslint-enable */ /**
 * Hook to wrap around useState that stores the value in the browser local/session storage.
 *
 * @param {any} initialValue the initial value to store
 * @param {string} key the key to store the value in local/session storage
 * @param {string} storage either 'local' or 'session' for what type of storage
 * @returns a stateful value, and a function to update it.
 */ var $f52044c30799e016$export$95809329f49ea9f9 = function useStorage(initialValue, key) {
    var storage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "local";
    // Since the local storage API isn't available in server-rendering environments,
    // we check that typeof window !== 'undefined' to make SSR and SSG work properly.
    var storageAvailable = typeof window !== "undefined";
    // subscribe to window storage event so changes in one tab to a stored value
    // are properly reflected in all tabs
    var _useEventListener = $f52044c30799e016$export$7080b3e976bc91ab({
        target: "window",
        type: "storage",
        listener: function listener(event) {
            var area = storage === "local" ? window.localStorage : window.sessionStorage;
            if (event.storageArea === area && event.key === key) {
                var newValue = event.newValue ? JSON.parse(event.newValue) : undefined;
                setStoredValue(newValue);
            }
        }
    }), _useEventListener2 = $f52044c30799e016$var$_slicedToArray(_useEventListener, 2), bindWindowStorageListener = _useEventListener2[0], unbindWindowStorageListener = _useEventListener2[1];
    var _React$useState = $81g6h.useState(initialValue), _React$useState2 = $f52044c30799e016$var$_slicedToArray(_React$useState, 2), storedValue = _React$useState2[0], setStoredValue = _React$useState2[1];
    var setValue = function setValue(value) {
        try {
            // Allow value to be a function so we have same API as useState
            var valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (storageAvailable) {
                var serializedValue = JSON.stringify(valueToStore);
                storage === "local" ? window.localStorage.setItem(key, serializedValue) : window.sessionStorage.setItem(key, serializedValue);
            }
        } catch (error) {
            throw new Error("PrimeReact useStorage: Failed to serialize the value at key: ".concat(key));
        }
    };
    $81g6h.useEffect(function() {
        if (!storageAvailable) setStoredValue(initialValue);
        try {
            var item = storage === "local" ? window.localStorage.getItem(key) : window.sessionStorage.getItem(key);
            setStoredValue(item ? JSON.parse(item) : initialValue);
        } catch (error) {
            // If error also return initialValue
            setStoredValue(initialValue);
        }
        bindWindowStorageListener();
        return function() {
            return unbindWindowStorageListener();
        };
    }, []);
    return [
        storedValue,
        setValue
    ];
};
/**
 * Hook to wrap around useState that stores the value in the browser local storage.
 *
 * @param {any} initialValue the initial value to store
 * @param {string} key the key to store the value in local storage
 * @returns a stateful value, and a function to update it.
 */ var $f52044c30799e016$export$86e2cef2561044ac = function useLocalStorage(initialValue, key) {
    return $f52044c30799e016$export$95809329f49ea9f9(initialValue, key, "local");
};
/**
 * Hook to wrap around useState that stores the value in the browser session storage.
 *
 * @param {any} initialValue the initial value to store
 * @param {string} key the key to store the value in session storage
 * @returns a stateful value, and a function to update it.
 */ var $f52044c30799e016$export$864b6828bd07eda6 = function useSessionStorage(initialValue, key) {
    return $f52044c30799e016$export$95809329f49ea9f9(initialValue, key, "session");
};
/* eslint-enable */ var $f52044c30799e016$var$_id = 0;
var $f52044c30799e016$export$72c85e333541e7f = function useStyle(css) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _useState = (0, $81g6h.useState)(false), _useState2 = $f52044c30799e016$var$_slicedToArray(_useState, 2), isLoaded = _useState2[0], setIsLoaded = _useState2[1];
    var styleRef = (0, $81g6h.useRef)(null);
    var context = (0, $81g6h.useContext)((0, $8Zwsm.PrimeReactContext));
    var defaultDocument = (0, $cfkGk.DomHandler).isClient() ? window.document : undefined;
    var _options$document = options.document, document1 = _options$document === void 0 ? defaultDocument : _options$document, _options$manual = options.manual, manual = _options$manual === void 0 ? false : _options$manual, _options$name = options.name, name = _options$name === void 0 ? "style_".concat(++$f52044c30799e016$var$_id) : _options$name, _options$id = options.id, id = _options$id === void 0 ? undefined : _options$id, _options$media = options.media, media = _options$media === void 0 ? undefined : _options$media;
    var getCurrentStyleRef = function getCurrentStyleRef(styleContainer) {
        var existingStyle = styleContainer.querySelector('style[data-primereact-style-id="'.concat(name, '"]'));
        if (existingStyle) return existingStyle;
        if (id !== undefined) {
            var existingElement = document1.getElementById(id);
            if (existingElement) return existingElement;
        }
        // finally if not found create the new style
        return document1.createElement("style");
    };
    var update = function update(newCSS) {
        isLoaded && css !== newCSS && (styleRef.current.textContent = newCSS);
    };
    var load = function load() {
        if (!document1 || isLoaded) return;
        var styleContainer = (context === null || context === void 0 ? void 0 : context.styleContainer) || document1.head;
        styleRef.current = getCurrentStyleRef(styleContainer);
        if (!styleRef.current.isConnected) {
            styleRef.current.type = "text/css";
            if (id) styleRef.current.id = id;
            if (media) styleRef.current.media = media;
            (0, $cfkGk.DomHandler).addNonce(styleRef.current, context && context.nonce || (0, $8Zwsm.default).nonce);
            styleContainer.appendChild(styleRef.current);
            if (name) styleRef.current.setAttribute("data-primereact-style-id", name);
        }
        styleRef.current.textContent = css;
        setIsLoaded(true);
    };
    var unload = function unload() {
        if (!document1 || !styleRef.current) return;
        (0, $cfkGk.DomHandler).removeInlineStyle(styleRef.current);
        setIsLoaded(false);
    };
    (0, $81g6h.useEffect)(function() {
        if (!manual) load();
    // return () => {if (!manual) unload()}; /* @todo */
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        manual
    ]);
    return {
        id: id,
        name: name,
        update: update,
        unload: unload,
        load: load,
        isLoaded: isLoaded
    };
};
/* eslint-disable */ var $f52044c30799e016$export$d8e6abf214c9ec0f = function useTimeout(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var timeout = $81g6h.useRef(null);
    var savedCallback = $81g6h.useRef(null);
    var clear = $81g6h.useCallback(function() {
        return clearTimeout(timeout.current);
    }, [
        timeout.current
    ]);
    $81g6h.useEffect(function() {
        savedCallback.current = fn;
    });
    $81g6h.useEffect(function() {
        function callback() {
            savedCallback.current();
        }
        if (when) {
            timeout.current = setTimeout(callback, delay);
            return clear;
        } else clear();
    }, [
        delay,
        when
    ]);
    $f52044c30799e016$export$f3a192d0cbd30b96(function() {
        clear();
    });
    return [
        clear
    ];
};
/* eslint-enable */ /* eslint-disable */ var $f52044c30799e016$export$496315a1608d9602 = function useUpdateEffect(fn, deps) {
    var mounted = $81g6h.useRef(false);
    return $81g6h.useEffect(function() {
        if (!mounted.current) {
            mounted.current = true;
            return;
        }
        return fn && fn();
    }, deps);
};

});


parcelRegister("dPQhb", function(module, exports) {

$parcel$export(module.exports, "SpinnerIcon", () => $a12896c2bbf50b4d$export$fe708d541030d854);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $a12896c2bbf50b4d$var$_extends() {
    $a12896c2bbf50b4d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a12896c2bbf50b4d$var$_extends.apply(this, arguments);
}
var $a12896c2bbf50b4d$export$fe708d541030d854 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $a12896c2bbf50b4d$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M6.99701 14C5.85441 13.999 4.72939 13.7186 3.72012 13.1832C2.71084 12.6478 1.84795 11.8737 1.20673 10.9284C0.565504 9.98305 0.165424 8.89526 0.041387 7.75989C-0.0826496 6.62453 0.073125 5.47607 0.495122 4.4147C0.917119 3.35333 1.59252 2.4113 2.46241 1.67077C3.33229 0.930247 4.37024 0.413729 5.4857 0.166275C6.60117 -0.0811796 7.76026 -0.0520535 8.86188 0.251112C9.9635 0.554278 10.9742 1.12227 11.8057 1.90555C11.915 2.01493 11.9764 2.16319 11.9764 2.31778C11.9764 2.47236 11.915 2.62062 11.8057 2.73C11.7521 2.78503 11.688 2.82877 11.6171 2.85864C11.5463 2.8885 11.4702 2.90389 11.3933 2.90389C11.3165 2.90389 11.2404 2.8885 11.1695 2.85864C11.0987 2.82877 11.0346 2.78503 10.9809 2.73C9.9998 1.81273 8.73246 1.26138 7.39226 1.16876C6.05206 1.07615 4.72086 1.44794 3.62279 2.22152C2.52471 2.99511 1.72683 4.12325 1.36345 5.41602C1.00008 6.70879 1.09342 8.08723 1.62775 9.31926C2.16209 10.5513 3.10478 11.5617 4.29713 12.1803C5.48947 12.7989 6.85865 12.988 8.17414 12.7157C9.48963 12.4435 10.6711 11.7264 11.5196 10.6854C12.3681 9.64432 12.8319 8.34282 12.8328 7C12.8328 6.84529 12.8943 6.69692 13.0038 6.58752C13.1132 6.47812 13.2616 6.41667 13.4164 6.41667C13.5712 6.41667 13.7196 6.47812 13.8291 6.58752C13.9385 6.69692 14 6.84529 14 7C14 8.85651 13.2622 10.637 11.9489 11.9497C10.6356 13.2625 8.85432 14 6.99701 14Z",
        fill: "currentColor"
    }));
}));
$a12896c2bbf50b4d$export$fe708d541030d854.displayName = "SpinnerIcon";

});
parcelRegister("2u9US", function(module, exports) {

$parcel$export(module.exports, "IconBase", () => $1cf613477c056b88$export$a188ecdd443fe91a);

var $cfkGk = parcelRequire("cfkGk");
"use client";
var $1cf613477c056b88$export$a188ecdd443fe91a = {
    defaultProps: {
        __TYPE: "IconBase",
        className: null,
        label: null,
        spin: false
    },
    getProps: function getProps(props) {
        return (0, $cfkGk.ObjectUtils).getMergedProps(props, $1cf613477c056b88$export$a188ecdd443fe91a.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $cfkGk.ObjectUtils).getDiffProps(props, $1cf613477c056b88$export$a188ecdd443fe91a.defaultProps);
    },
    getPTI: function getPTI(props) {
        var isLabelEmpty = (0, $cfkGk.ObjectUtils).isEmpty(props.label);
        var otherProps = $1cf613477c056b88$export$a188ecdd443fe91a.getOtherProps(props);
        var ptiProps = {
            className: (0, $cfkGk.classNames)("p-icon", {
                "p-icon-spin": props.spin
            }, props.className),
            role: !isLabelEmpty ? "img" : undefined,
            "aria-label": !isLabelEmpty ? props.label : undefined,
            "aria-hidden": isLabelEmpty
        };
        return (0, $cfkGk.ObjectUtils).getMergedProps(otherProps, ptiProps);
    }
};

});


parcelRegister("9rbaG", function(module, exports) {

$parcel$export(module.exports, "Ripple", () => $6def4d0ea32b3ff6$export$9e9146f7e027fdaa);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $l2NC0 = parcelRequire("l2NC0");

var $cfkGk = parcelRequire("cfkGk");

var $4gQLd = parcelRequire("4gQLd");
"use client";
function $6def4d0ea32b3ff6$var$_extends() {
    $6def4d0ea32b3ff6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6def4d0ea32b3ff6$var$_extends.apply(this, arguments);
}
function $6def4d0ea32b3ff6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6def4d0ea32b3ff6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6def4d0ea32b3ff6$var$_typeof(o);
}
function $6def4d0ea32b3ff6$var$_toPrimitive(input, hint) {
    if ($6def4d0ea32b3ff6$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6def4d0ea32b3ff6$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6def4d0ea32b3ff6$var$_toPropertyKey(arg) {
    var key = $6def4d0ea32b3ff6$var$_toPrimitive(arg, "string");
    return $6def4d0ea32b3ff6$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6def4d0ea32b3ff6$var$_defineProperty(obj, key, value) {
    key = $6def4d0ea32b3ff6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6def4d0ea32b3ff6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6def4d0ea32b3ff6$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $6def4d0ea32b3ff6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6def4d0ea32b3ff6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6def4d0ea32b3ff6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6def4d0ea32b3ff6$var$_arrayLikeToArray(o, minLen);
}
function $6def4d0ea32b3ff6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6def4d0ea32b3ff6$var$_slicedToArray(arr, i) {
    return $6def4d0ea32b3ff6$var$_arrayWithHoles(arr) || $6def4d0ea32b3ff6$var$_iterableToArrayLimit(arr, i) || $6def4d0ea32b3ff6$var$_unsupportedIterableToArray(arr, i) || $6def4d0ea32b3ff6$var$_nonIterableRest();
}
var $6def4d0ea32b3ff6$var$styles = "\n@layer primereact {\n    .p-ripple {\n        overflow: hidden;\n        position: relative;\n    }\n    \n    .p-ink {\n        display: block;\n        position: absolute;\n        background: rgba(255, 255, 255, 0.5);\n        border-radius: 100%;\n        transform: scale(0);\n    }\n    \n    .p-ink-active {\n        animation: ripple 0.4s linear;\n    }\n    \n    .p-ripple-disabled .p-ink {\n        display: none;\n    }\n}\n\n@keyframes ripple {\n    100% {\n        opacity: 0;\n        transform: scale(2.5);\n    }\n}\n\n";
var $6def4d0ea32b3ff6$var$classes = {
    root: "p-ink"
};
var $6def4d0ea32b3ff6$var$RippleBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Ripple",
        children: undefined
    },
    css: {
        styles: $6def4d0ea32b3ff6$var$styles,
        classes: $6def4d0ea32b3ff6$var$classes
    },
    getProps: function getProps(props) {
        return (0, $cfkGk.ObjectUtils).getMergedProps(props, $6def4d0ea32b3ff6$var$RippleBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $cfkGk.ObjectUtils).getDiffProps(props, $6def4d0ea32b3ff6$var$RippleBase.defaultProps);
    }
});
function $6def4d0ea32b3ff6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6def4d0ea32b3ff6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6def4d0ea32b3ff6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6def4d0ea32b3ff6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6def4d0ea32b3ff6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6def4d0ea32b3ff6$export$9e9146f7e027fdaa = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var _React$useState = $81g6h.useState(false), _React$useState2 = $6def4d0ea32b3ff6$var$_slicedToArray(_React$useState, 2), isMounted = _React$useState2[0], setMounted = _React$useState2[1];
    var inkRef = $81g6h.useRef(null);
    var targetRef = $81g6h.useRef(null);
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $6def4d0ea32b3ff6$var$RippleBase.getProps(inProps, context);
    var isRippleActive = context && context.ripple || (0, $8Zwsm.default).ripple;
    var metaData = {
        props: props
    };
    (0, $l2NC0.useStyle)($6def4d0ea32b3ff6$var$RippleBase.css.styles, {
        name: "ripple",
        manual: !isRippleActive
    });
    var _RippleBase$setMetaDa = $6def4d0ea32b3ff6$var$RippleBase.setMetaData($6def4d0ea32b3ff6$var$_objectSpread({}, metaData)), ptm = _RippleBase$setMetaDa.ptm, cx = _RippleBase$setMetaDa.cx;
    var getTarget = function getTarget() {
        return inkRef.current && inkRef.current.parentElement;
    };
    var bindEvents = function bindEvents() {
        if (targetRef.current) targetRef.current.addEventListener("pointerdown", onPointerDown);
    };
    var unbindEvents = function unbindEvents() {
        if (targetRef.current) targetRef.current.removeEventListener("pointerdown", onPointerDown);
    };
    var onPointerDown = function onPointerDown(event) {
        var offset = (0, $cfkGk.DomHandler).getOffset(targetRef.current);
        var offsetX = event.pageX - offset.left + document.body.scrollTop - (0, $cfkGk.DomHandler).getWidth(inkRef.current) / 2;
        var offsetY = event.pageY - offset.top + document.body.scrollLeft - (0, $cfkGk.DomHandler).getHeight(inkRef.current) / 2;
        activateRipple(offsetX, offsetY);
    };
    var activateRipple = function activateRipple(offsetX, offsetY) {
        if (!inkRef.current || getComputedStyle(inkRef.current, null).display === "none") return;
        (0, $cfkGk.DomHandler).removeClass(inkRef.current, "p-ink-active");
        setDimensions();
        inkRef.current.style.top = offsetY + "px";
        inkRef.current.style.left = offsetX + "px";
        (0, $cfkGk.DomHandler).addClass(inkRef.current, "p-ink-active");
    };
    var onAnimationEnd = function onAnimationEnd(event) {
        (0, $cfkGk.DomHandler).removeClass(event.currentTarget, "p-ink-active");
    };
    var setDimensions = function setDimensions() {
        if (inkRef.current && !(0, $cfkGk.DomHandler).getHeight(inkRef.current) && !(0, $cfkGk.DomHandler).getWidth(inkRef.current)) {
            var d = Math.max((0, $cfkGk.DomHandler).getOuterWidth(targetRef.current), (0, $cfkGk.DomHandler).getOuterHeight(targetRef.current));
            inkRef.current.style.height = d + "px";
            inkRef.current.style.width = d + "px";
        }
    };
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            getInk: function getInk() {
                return inkRef.current;
            },
            getTarget: function getTarget() {
                return targetRef.current;
            }
        };
    });
    (0, $l2NC0.useMountEffect)(function() {
        // for App Router in Next.js ^14
        setMounted(true);
    });
    (0, $l2NC0.useUpdateEffect)(function() {
        if (isMounted && inkRef.current) {
            targetRef.current = getTarget();
            setDimensions();
            bindEvents();
        }
    }, [
        isMounted
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (inkRef.current && !targetRef.current) {
            targetRef.current = getTarget();
            setDimensions();
            bindEvents();
        }
    });
    (0, $l2NC0.useUnmountEffect)(function() {
        if (inkRef.current) {
            targetRef.current = null;
            unbindEvents();
        }
    });
    if (!isRippleActive) return null;
    var rootProps = mergeProps({
        "aria-hidden": true,
        className: (0, $cfkGk.classNames)(cx("root"))
    }, $6def4d0ea32b3ff6$var$RippleBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $81g6h.createElement("span", $6def4d0ea32b3ff6$var$_extends({
        role: "presentation",
        ref: inkRef
    }, rootProps, {
        onAnimationEnd: onAnimationEnd
    }));
}));
$6def4d0ea32b3ff6$export$9e9146f7e027fdaa.displayName = "Ripple";

});

parcelRegister("7hMfd", function(module, exports) {

$parcel$export(module.exports, "Tooltip", () => $54df8b48da2298b3$export$28c660c63b792dea);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $6b4aU = parcelRequire("6b4aU");

var $cfkGk = parcelRequire("cfkGk");
"use client";
function $54df8b48da2298b3$var$_extends() {
    $54df8b48da2298b3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $54df8b48da2298b3$var$_extends.apply(this, arguments);
}
function $54df8b48da2298b3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $54df8b48da2298b3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $54df8b48da2298b3$var$_typeof(o);
}
function $54df8b48da2298b3$var$_toPrimitive(input, hint) {
    if ($54df8b48da2298b3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($54df8b48da2298b3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $54df8b48da2298b3$var$_toPropertyKey(arg) {
    var key = $54df8b48da2298b3$var$_toPrimitive(arg, "string");
    return $54df8b48da2298b3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $54df8b48da2298b3$var$_defineProperty(obj, key, value) {
    key = $54df8b48da2298b3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $54df8b48da2298b3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $54df8b48da2298b3$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $54df8b48da2298b3$var$_arrayLikeToArray(arr);
}
function $54df8b48da2298b3$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $54df8b48da2298b3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $54df8b48da2298b3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $54df8b48da2298b3$var$_arrayLikeToArray(o, minLen);
}
function $54df8b48da2298b3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $54df8b48da2298b3$var$_toConsumableArray(arr) {
    return $54df8b48da2298b3$var$_arrayWithoutHoles(arr) || $54df8b48da2298b3$var$_iterableToArray(arr) || $54df8b48da2298b3$var$_unsupportedIterableToArray(arr) || $54df8b48da2298b3$var$_nonIterableSpread();
}
function $54df8b48da2298b3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $54df8b48da2298b3$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $54df8b48da2298b3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $54df8b48da2298b3$var$_slicedToArray(arr, i) {
    return $54df8b48da2298b3$var$_arrayWithHoles(arr) || $54df8b48da2298b3$var$_iterableToArrayLimit(arr, i) || $54df8b48da2298b3$var$_unsupportedIterableToArray(arr, i) || $54df8b48da2298b3$var$_nonIterableRest();
}
var $54df8b48da2298b3$var$classes = {
    root: function root(_ref) {
        var positionState = _ref.positionState, classNameState = _ref.classNameState;
        return (0, $cfkGk.classNames)("p-tooltip p-component", $54df8b48da2298b3$var$_defineProperty({}, "p-tooltip-".concat(positionState), true), classNameState);
    },
    arrow: "p-tooltip-arrow",
    text: "p-tooltip-text"
};
var $54df8b48da2298b3$var$inlineStyles = {
    arrow: function arrow(_ref2) {
        var context = _ref2.context;
        return {
            top: context.bottom ? "0" : context.right || context.left || !context.right && !context.left && !context.top && !context.bottom ? "50%" : null,
            bottom: context.top ? "0" : null,
            left: context.right || !context.right && !context.left && !context.top && !context.bottom ? "0" : context.top || context.bottom ? "50%" : null,
            right: context.left ? "0" : null
        };
    }
};
var $54df8b48da2298b3$var$styles = "\n@layer primereact {\n    .p-tooltip {\n        position: absolute;\n        padding: .25em .5rem;\n        /* #3687: Tooltip prevent scrollbar flickering */\n        top: -9999px;\n        left: -9999px;\n    }\n    \n    .p-tooltip.p-tooltip-right,\n    .p-tooltip.p-tooltip-left {\n        padding: 0 .25rem;\n    }\n    \n    .p-tooltip.p-tooltip-top,\n    .p-tooltip.p-tooltip-bottom {\n        padding:.25em 0;\n    }\n    \n    .p-tooltip .p-tooltip-text {\n       white-space: pre-line;\n       word-break: break-word;\n    }\n    \n    .p-tooltip-arrow {\n        position: absolute;\n        width: 0;\n        height: 0;\n        border-color: transparent;\n        border-style: solid;\n    }\n    \n    .p-tooltip-right .p-tooltip-arrow {\n        top: 50%;\n        left: 0;\n        margin-top: -.25rem;\n        border-width: .25em .25em .25em 0;\n    }\n    \n    .p-tooltip-left .p-tooltip-arrow {\n        top: 50%;\n        right: 0;\n        margin-top: -.25rem;\n        border-width: .25em 0 .25em .25rem;\n    }\n    \n    .p-tooltip.p-tooltip-top {\n        padding: .25em 0;\n    }\n    \n    .p-tooltip-top .p-tooltip-arrow {\n        bottom: 0;\n        left: 50%;\n        margin-left: -.25rem;\n        border-width: .25em .25em 0;\n    }\n    \n    .p-tooltip-bottom .p-tooltip-arrow {\n        top: 0;\n        left: 50%;\n        margin-left: -.25rem;\n        border-width: 0 .25em .25rem;\n    }\n\n    .p-tooltip-target-wrapper {\n        display: inline-flex;\n    }\n}\n";
var $54df8b48da2298b3$var$TooltipBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Tooltip",
        appendTo: null,
        at: null,
        autoHide: true,
        autoZIndex: true,
        baseZIndex: 0,
        className: null,
        closeOnEscape: false,
        content: null,
        disabled: false,
        event: null,
        hideDelay: 0,
        hideEvent: "mouseleave",
        id: null,
        mouseTrack: false,
        mouseTrackLeft: 5,
        mouseTrackTop: 5,
        my: null,
        onBeforeHide: null,
        onBeforeShow: null,
        onHide: null,
        onShow: null,
        position: "right",
        showDelay: 0,
        showEvent: "mouseenter",
        showOnDisabled: false,
        style: null,
        target: null,
        updateDelay: 0,
        children: undefined
    },
    css: {
        classes: $54df8b48da2298b3$var$classes,
        styles: $54df8b48da2298b3$var$styles,
        inlineStyles: $54df8b48da2298b3$var$inlineStyles
    }
});
function $54df8b48da2298b3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $54df8b48da2298b3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $54df8b48da2298b3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $54df8b48da2298b3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $54df8b48da2298b3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $54df8b48da2298b3$export$28c660c63b792dea = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $54df8b48da2298b3$var$TooltipBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState(false), _React$useState2 = $54df8b48da2298b3$var$_slicedToArray(_React$useState, 2), visibleState = _React$useState2[0], setVisibleState = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(props.position || "right"), _React$useState4 = $54df8b48da2298b3$var$_slicedToArray(_React$useState3, 2), positionState = _React$useState4[0], setPositionState = _React$useState4[1];
    var _React$useState5 = $81g6h.useState(""), _React$useState6 = $54df8b48da2298b3$var$_slicedToArray(_React$useState5, 2), classNameState = _React$useState6[0], setClassNameState = _React$useState6[1];
    var metaData = {
        props: props,
        state: {
            visible: visibleState,
            position: positionState,
            className: classNameState
        },
        context: {
            right: positionState === "right",
            left: positionState === "left",
            top: positionState === "top",
            bottom: positionState === "bottom"
        }
    };
    var _TooltipBase$setMetaD = $54df8b48da2298b3$var$TooltipBase.setMetaData(metaData), ptm = _TooltipBase$setMetaD.ptm, cx = _TooltipBase$setMetaD.cx, sx = _TooltipBase$setMetaD.sx, isUnstyled = _TooltipBase$setMetaD.isUnstyled;
    (0, $4gQLd.useHandleStyle)($54df8b48da2298b3$var$TooltipBase.css.styles, isUnstyled, {
        name: "tooltip"
    });
    (0, $l2NC0.useGlobalOnEscapeKey)({
        callback: function callback() {
            hide();
        },
        when: props.closeOnEscape,
        priority: [
            (0, $l2NC0.ESC_KEY_HANDLING_PRIORITIES).TOOLTIP,
            0
        ]
    });
    var elementRef = $81g6h.useRef(null);
    var textRef = $81g6h.useRef(null);
    var currentTargetRef = $81g6h.useRef(null);
    var containerSize = $81g6h.useRef(null);
    var allowHide = $81g6h.useRef(true);
    var timeouts = $81g6h.useRef({});
    var currentMouseEvent = $81g6h.useRef(null);
    var _useResizeListener = (0, $l2NC0.useResizeListener)({
        listener: function listener(event) {
            !(0, $cfkGk.DomHandler).isTouchDevice() && hide(event);
        }
    }), _useResizeListener2 = $54df8b48da2298b3$var$_slicedToArray(_useResizeListener, 2), bindWindowResizeListener = _useResizeListener2[0], unbindWindowResizeListener = _useResizeListener2[1];
    var _useOverlayScrollList = (0, $l2NC0.useOverlayScrollListener)({
        target: currentTargetRef.current,
        listener: function listener(event) {
            hide(event);
        },
        when: visibleState
    }), _useOverlayScrollList2 = $54df8b48da2298b3$var$_slicedToArray(_useOverlayScrollList, 2), bindOverlayScrollListener = _useOverlayScrollList2[0], unbindOverlayScrollListener = _useOverlayScrollList2[1];
    var isTargetContentEmpty = function isTargetContentEmpty(target) {
        return !(props.content || getTargetOption(target, "tooltip"));
    };
    var isContentEmpty = function isContentEmpty(target) {
        return !(props.content || getTargetOption(target, "tooltip") || props.children);
    };
    var isMouseTrack = function isMouseTrack(target) {
        return getTargetOption(target, "mousetrack") || props.mouseTrack;
    };
    var isDisabled = function isDisabled(target) {
        return getTargetOption(target, "disabled") === "true" || hasTargetOption(target, "disabled") || props.disabled;
    };
    var isShowOnDisabled = function isShowOnDisabled(target) {
        return getTargetOption(target, "showondisabled") || props.showOnDisabled;
    };
    var isAutoHide = function isAutoHide() {
        return getTargetOption(currentTargetRef.current, "autohide") || props.autoHide;
    };
    var getTargetOption = function getTargetOption(target, option) {
        return hasTargetOption(target, "data-pr-".concat(option)) ? target.getAttribute("data-pr-".concat(option)) : null;
    };
    var hasTargetOption = function hasTargetOption(target, option) {
        return target && target.hasAttribute(option);
    };
    var getEvents = function getEvents(target) {
        var showEvents = [
            getTargetOption(target, "showevent") || props.showEvent
        ];
        var hideEvents = [
            getTargetOption(target, "hideevent") || props.hideEvent
        ];
        if (isMouseTrack(target)) {
            showEvents = [
                "mousemove"
            ];
            hideEvents = [
                "mouseleave"
            ];
        } else {
            var event = getTargetOption(target, "event") || props.event;
            if (event === "focus") {
                showEvents = [
                    "focus"
                ];
                hideEvents = [
                    "blur"
                ];
            }
            if (event === "both") {
                showEvents = [
                    "focus",
                    "mouseenter"
                ];
                hideEvents = [
                    "blur",
                    "mouseleave"
                ];
            }
        }
        return {
            showEvents: showEvents,
            hideEvents: hideEvents
        };
    };
    var getPosition = function getPosition(target) {
        return getTargetOption(target, "position") || positionState;
    };
    var getMouseTrackPosition = function getMouseTrackPosition(target) {
        var top = getTargetOption(target, "mousetracktop") || props.mouseTrackTop;
        var left = getTargetOption(target, "mousetrackleft") || props.mouseTrackLeft;
        return {
            top: top,
            left: left
        };
    };
    var updateText = function updateText(target, callback) {
        if (textRef.current) {
            var content = getTargetOption(target, "tooltip") || props.content;
            if (content) {
                textRef.current.innerHTML = ""; // remove children
                textRef.current.appendChild(document.createTextNode(content));
                callback();
            } else if (props.children) callback();
        }
    };
    var updateTooltipState = function updateTooltipState(position) {
        updateText(currentTargetRef.current, function() {
            var _currentMouseEvent$cu = currentMouseEvent.current, x = _currentMouseEvent$cu.pageX, y = _currentMouseEvent$cu.pageY;
            if (props.autoZIndex && !(0, $cfkGk.ZIndexUtils).get(elementRef.current)) (0, $cfkGk.ZIndexUtils).set("tooltip", elementRef.current, context && context.autoZIndex || (0, $8Zwsm.default).autoZIndex, props.baseZIndex || context && context.zIndex.tooltip || (0, $8Zwsm.default).zIndex.tooltip);
            elementRef.current.style.left = "";
            elementRef.current.style.top = "";
            // GitHub #2695 disable pointer events when autohiding
            if (isAutoHide()) elementRef.current.style.pointerEvents = "none";
            var mouseTrackCheck = isMouseTrack(currentTargetRef.current) || position === "mouse";
            if (mouseTrackCheck && !containerSize.current || mouseTrackCheck) containerSize.current = {
                width: (0, $cfkGk.DomHandler).getOuterWidth(elementRef.current),
                height: (0, $cfkGk.DomHandler).getOuterHeight(elementRef.current)
            };
            align(currentTargetRef.current, {
                x: x,
                y: y
            }, position);
        });
    };
    var show = function show(e) {
        currentTargetRef.current = e.currentTarget;
        var disabled = isDisabled(currentTargetRef.current);
        var empty = isContentEmpty(isShowOnDisabled(currentTargetRef.current) && disabled ? currentTargetRef.current.firstChild : currentTargetRef.current);
        if (empty || disabled) return;
        currentMouseEvent.current = e;
        if (visibleState) applyDelay("updateDelay", updateTooltipState);
        else {
            // #2653 give the callback a chance to return false and not continue with display
            var success = sendCallback(props.onBeforeShow, {
                originalEvent: e,
                target: currentTargetRef.current
            });
            if (success) applyDelay("showDelay", function() {
                setVisibleState(true);
                sendCallback(props.onShow, {
                    originalEvent: e,
                    target: currentTargetRef.current
                });
            });
        }
    };
    var hide = function hide(e) {
        clearTimeouts();
        if (visibleState) {
            var success = sendCallback(props.onBeforeHide, {
                originalEvent: e,
                target: currentTargetRef.current
            });
            if (success) applyDelay("hideDelay", function() {
                if (!isAutoHide() && allowHide.current === false) return;
                (0, $cfkGk.ZIndexUtils).clear(elementRef.current);
                (0, $cfkGk.DomHandler).removeClass(elementRef.current, "p-tooltip-active");
                setVisibleState(false);
                sendCallback(props.onHide, {
                    originalEvent: e,
                    target: currentTargetRef.current
                });
            });
        }
    };
    var align = function align(target, coordinate, position) {
        var left = 0;
        var top = 0;
        var currentPosition = position || positionState;
        if ((isMouseTrack(target) || currentPosition == "mouse") && coordinate) {
            var _containerSize = {
                width: (0, $cfkGk.DomHandler).getOuterWidth(elementRef.current),
                height: (0, $cfkGk.DomHandler).getOuterHeight(elementRef.current)
            };
            left = coordinate.x;
            top = coordinate.y;
            var _getMouseTrackPositio = getMouseTrackPosition(target), mouseTrackTop = _getMouseTrackPositio.top, mouseTrackLeft = _getMouseTrackPositio.left;
            switch(currentPosition){
                case "left":
                    left = left - (_containerSize.width + mouseTrackLeft);
                    top = top - (_containerSize.height / 2 - mouseTrackTop);
                    break;
                case "right":
                case "mouse":
                    left = left + mouseTrackLeft;
                    top = top - (_containerSize.height / 2 - mouseTrackTop);
                    break;
                case "top":
                    left = left - (_containerSize.width / 2 - mouseTrackLeft);
                    top = top - (_containerSize.height + mouseTrackTop);
                    break;
                case "bottom":
                    left = left - (_containerSize.width / 2 - mouseTrackLeft);
                    top = top + mouseTrackTop;
                    break;
            }
            if (left <= 0 || containerSize.current.width > _containerSize.width) {
                elementRef.current.style.left = "0px";
                elementRef.current.style.right = window.innerWidth - _containerSize.width - left + "px";
            } else {
                elementRef.current.style.right = "";
                elementRef.current.style.left = left + "px";
            }
            elementRef.current.style.top = top + "px";
            (0, $cfkGk.DomHandler).addClass(elementRef.current, "p-tooltip-active");
        } else {
            var pos = (0, $cfkGk.DomHandler).findCollisionPosition(currentPosition);
            var my = getTargetOption(target, "my") || props.my || pos.my;
            var at = getTargetOption(target, "at") || props.at || pos.at;
            elementRef.current.style.padding = "0px";
            (0, $cfkGk.DomHandler).flipfitCollision(elementRef.current, target, my, at, function(calculatedPosition) {
                var _calculatedPosition$a = calculatedPosition.at, atX = _calculatedPosition$a.x, atY = _calculatedPosition$a.y;
                var myX = calculatedPosition.my.x;
                var newPosition = props.at ? atX !== "center" && atX !== myX ? atX : atY : calculatedPosition.at["".concat(pos.axis)];
                elementRef.current.style.padding = "";
                setPositionState(newPosition);
                updateContainerPosition(newPosition);
                (0, $cfkGk.DomHandler).addClass(elementRef.current, "p-tooltip-active");
            });
        }
    };
    var updateContainerPosition = function updateContainerPosition(position) {
        if (elementRef.current) {
            var style = getComputedStyle(elementRef.current);
            if (position === "left") elementRef.current.style.left = parseFloat(style.left) - parseFloat(style.paddingLeft) * 2 + "px";
            else if (position === "top") elementRef.current.style.top = parseFloat(style.top) - parseFloat(style.paddingTop) * 2 + "px";
        }
    };
    var _onMouseEnter = function onMouseEnter() {
        if (!isAutoHide()) allowHide.current = false;
    };
    var _onMouseLeave = function onMouseLeave(e) {
        if (!isAutoHide()) {
            allowHide.current = true;
            hide(e);
        }
    };
    var bindTargetEvent = function bindTargetEvent(target) {
        if (target) {
            var _getEvents = getEvents(target), showEvents = _getEvents.showEvents, hideEvents = _getEvents.hideEvents;
            var currentTarget = getTarget(target);
            showEvents.forEach(function(event) {
                return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.addEventListener(event, show);
            });
            hideEvents.forEach(function(event) {
                return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.addEventListener(event, hide);
            });
        }
    };
    var unbindTargetEvent = function unbindTargetEvent(target) {
        if (target) {
            var _getEvents2 = getEvents(target), showEvents = _getEvents2.showEvents, hideEvents = _getEvents2.hideEvents;
            var currentTarget = getTarget(target);
            showEvents.forEach(function(event) {
                return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.removeEventListener(event, show);
            });
            hideEvents.forEach(function(event) {
                return currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.removeEventListener(event, hide);
            });
        }
    };
    var applyDelay = function applyDelay(delayProp, callback) {
        clearTimeouts();
        var delay = getTargetOption(currentTargetRef.current, delayProp.toLowerCase()) || props[delayProp];
        delay ? timeouts.current["".concat(delayProp)] = setTimeout(function() {
            return callback();
        }, delay) : callback();
    };
    var sendCallback = function sendCallback(callback) {
        if (callback) {
            for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
            var result = callback.apply(void 0, params);
            if (result === undefined) result = true;
            return result;
        }
        return true;
    };
    var clearTimeouts = function clearTimeouts() {
        Object.values(timeouts.current).forEach(function(t) {
            return clearTimeout(t);
        });
    };
    var getTarget = function getTarget(target) {
        if (target) {
            if (isShowOnDisabled(target)) {
                if (!target.hasWrapper) {
                    var wrapper = document.createElement("div");
                    var isInputElement = target.nodeName === "INPUT";
                    if (isInputElement) (0, $cfkGk.DomHandler).addMultipleClasses(wrapper, "p-tooltip-target-wrapper p-inputwrapper");
                    else (0, $cfkGk.DomHandler).addClass(wrapper, "p-tooltip-target-wrapper");
                    target.parentNode.insertBefore(wrapper, target);
                    wrapper.appendChild(target);
                    target.hasWrapper = true;
                    return wrapper;
                }
                return target.parentElement;
            } else if (target.hasWrapper) {
                var _target$parentElement;
                (_target$parentElement = target.parentElement).replaceWith.apply(_target$parentElement, $54df8b48da2298b3$var$_toConsumableArray(target.parentElement.childNodes));
                delete target.hasWrapper;
            }
            return target;
        }
        return null;
    };
    var updateTargetEvents = function updateTargetEvents(target) {
        unloadTargetEvents(target);
        loadTargetEvents(target);
    };
    var loadTargetEvents = function loadTargetEvents(target) {
        setTargetEventOperations(target || props.target, bindTargetEvent);
    };
    var unloadTargetEvents = function unloadTargetEvents(target) {
        setTargetEventOperations(target || props.target, unbindTargetEvent);
    };
    var setTargetEventOperations = function setTargetEventOperations(target, operation) {
        target = (0, $cfkGk.ObjectUtils).getRefElement(target);
        if (target) {
            if ((0, $cfkGk.DomHandler).isElement(target)) operation(target);
            else {
                var setEvent = function setEvent(target) {
                    var element = (0, $cfkGk.DomHandler).find(document, target);
                    element.forEach(function(el) {
                        operation(el);
                    });
                };
                if (target instanceof Array) target.forEach(function(t) {
                    setEvent(t);
                });
                else setEvent(target);
            }
        }
    };
    (0, $l2NC0.useMountEffect)(function() {
        if (visibleState && currentTargetRef.current && isDisabled(currentTargetRef.current)) hide();
    });
    (0, $l2NC0.useUpdateEffect)(function() {
        loadTargetEvents();
        return function() {
            unloadTargetEvents();
        };
    }, [
        show,
        hide,
        props.target
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (visibleState) {
            var position = getPosition(currentTargetRef.current);
            var classname = getTargetOption(currentTargetRef.current, "classname");
            setPositionState(position);
            setClassNameState(classname);
            updateTooltipState(position);
            bindWindowResizeListener();
            bindOverlayScrollListener();
        } else {
            setPositionState(props.position || "right");
            setClassNameState("");
            currentTargetRef.current = null;
            containerSize.current = null;
            allowHide.current = true;
        }
        return function() {
            unbindWindowResizeListener();
            unbindOverlayScrollListener();
        };
    }, [
        visibleState
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        var position = getPosition(currentTargetRef.current);
        if (visibleState && position !== "mouse") applyDelay("updateDelay", function() {
            updateText(currentTargetRef.current, function() {
                align(currentTargetRef.current);
            });
        });
    }, [
        props.content
    ]);
    (0, $l2NC0.useUnmountEffect)(function() {
        hide();
        (0, $cfkGk.ZIndexUtils).clear(elementRef.current);
    });
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            updateTargetEvents: updateTargetEvents,
            loadTargetEvents: loadTargetEvents,
            unloadTargetEvents: unloadTargetEvents,
            show: show,
            hide: hide,
            getElement: function getElement() {
                return elementRef.current;
            },
            getTarget: function getTarget() {
                return currentTargetRef.current;
            }
        };
    });
    var createElement = function createElement() {
        var empty = isTargetContentEmpty(currentTargetRef.current);
        var rootProps = mergeProps({
            id: props.id,
            className: (0, $cfkGk.classNames)(props.className, cx("root", {
                positionState: positionState,
                classNameState: classNameState
            })),
            style: props.style,
            role: "tooltip",
            "aria-hidden": visibleState,
            onMouseEnter: function onMouseEnter(e) {
                return _onMouseEnter();
            },
            onMouseLeave: function onMouseLeave(e) {
                return _onMouseLeave(e);
            }
        }, $54df8b48da2298b3$var$TooltipBase.getOtherProps(props), ptm("root"));
        var arrowProps = mergeProps({
            className: cx("arrow"),
            style: sx("arrow", $54df8b48da2298b3$var$_objectSpread({}, metaData))
        }, ptm("arrow"));
        var textProps = mergeProps({
            className: cx("text")
        }, ptm("text"));
        return /*#__PURE__*/ $81g6h.createElement("div", $54df8b48da2298b3$var$_extends({
            ref: elementRef
        }, rootProps), /*#__PURE__*/ $81g6h.createElement("div", arrowProps), /*#__PURE__*/ $81g6h.createElement("div", $54df8b48da2298b3$var$_extends({
            ref: textRef
        }, textProps), empty && props.children));
    };
    if (visibleState) {
        var element = createElement();
        return /*#__PURE__*/ $81g6h.createElement((0, $6b4aU.Portal), {
            element: element,
            appendTo: props.appendTo,
            visible: true
        });
    }
    return null;
}));
$54df8b48da2298b3$export$28c660c63b792dea.displayName = "Tooltip";

});
parcelRegister("6b4aU", function(module, exports) {

$parcel$export(module.exports, "Portal", () => $47f70231822256d4$export$602eac185826482c);

var $81g6h = parcelRequire("81g6h");

var $Q1dTY = parcelRequire("Q1dTY");

var $8Zwsm = parcelRequire("8Zwsm");

var $l2NC0 = parcelRequire("l2NC0");

var $cfkGk = parcelRequire("cfkGk");
"use client";
function $47f70231822256d4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $47f70231822256d4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $47f70231822256d4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $47f70231822256d4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $47f70231822256d4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $47f70231822256d4$var$_arrayLikeToArray(o, minLen);
}
function $47f70231822256d4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $47f70231822256d4$var$_slicedToArray(arr, i) {
    return $47f70231822256d4$var$_arrayWithHoles(arr) || $47f70231822256d4$var$_iterableToArrayLimit(arr, i) || $47f70231822256d4$var$_unsupportedIterableToArray(arr, i) || $47f70231822256d4$var$_nonIterableRest();
}
var $47f70231822256d4$var$PortalBase = {
    defaultProps: {
        __TYPE: "Portal",
        element: null,
        appendTo: null,
        visible: false,
        onMounted: null,
        onUnmounted: null,
        children: undefined
    },
    getProps: function getProps(props) {
        return (0, $cfkGk.ObjectUtils).getMergedProps(props, $47f70231822256d4$var$PortalBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $cfkGk.ObjectUtils).getDiffProps(props, $47f70231822256d4$var$PortalBase.defaultProps);
    }
};
var $47f70231822256d4$export$602eac185826482c = /*#__PURE__*/ $81g6h.memo(function(inProps) {
    var props = $47f70231822256d4$var$PortalBase.getProps(inProps);
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var _React$useState = $81g6h.useState(props.visible && (0, $cfkGk.DomHandler).isClient()), _React$useState2 = $47f70231822256d4$var$_slicedToArray(_React$useState, 2), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    (0, $l2NC0.useMountEffect)(function() {
        if ((0, $cfkGk.DomHandler).isClient() && !mountedState) {
            setMountedState(true);
            props.onMounted && props.onMounted();
        }
    });
    (0, $l2NC0.useUpdateEffect)(function() {
        props.onMounted && props.onMounted();
    }, [
        mountedState
    ]);
    (0, $l2NC0.useUnmountEffect)(function() {
        props.onUnmounted && props.onUnmounted();
    });
    var element = props.element || props.children;
    if (element && mountedState) {
        var appendTo = props.appendTo || context && context.appendTo || (0, $8Zwsm.default).appendTo;
        if ((0, $cfkGk.ObjectUtils).isFunction(appendTo)) appendTo = appendTo();
        if (!appendTo) appendTo = document.body;
        return appendTo === "self" ? element : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Q1dTY))).createPortal(element, appendTo);
    }
    return null;
});
$47f70231822256d4$export$602eac185826482c.displayName = "Portal";

});





parcelRegister("9XVwj", function(module, exports) {

$parcel$export(module.exports, "ToastContext", () => $2d7e3ce5b08f14cf$export$29d4e2ed4674ecfc);
$parcel$export(module.exports, "ToastProvider", () => $2d7e3ce5b08f14cf$export$f5d03d415824e0e);

var $iKObn = parcelRequire("iKObn");

var $he9Ds = parcelRequire("he9Ds");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5kXMA = parcelRequire("5kXMA");

var $kGSAf = parcelRequire("kGSAf");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $hPWzh = parcelRequire("hPWzh");

var $81g6h = parcelRequire("81g6h");
const $2d7e3ce5b08f14cf$export$29d4e2ed4674ecfc = /*#__PURE__*/ (0, $81g6h.createContext)({
    showToast: ()=>undefined,
    showNotification: ()=>undefined,
    clearToasts: ()=>undefined
});
const $2d7e3ce5b08f14cf$export$f5d03d415824e0e = ({ children: children })=>{
    const toastRef = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(null);
    const showToast = (0, $81g6h.useCallback)((summary, detail, severity = "error")=>toastRef.current?.show({
            severity: severity,
            summary: summary,
            detail: detail,
            life: (0, $he9Ds.APP_CONSTANTS).TOAST_DURATION
        }), [
        toastRef
    ]);
    const showNotification = (0, $81g6h.useCallback)((message, onClick)=>toastRef.current?.show({
            severity: "info",
            life: (0, $he9Ds.APP_CONSTANTS).TOAST_DURATION,
            content: /*#__PURE__*/ (0, $iKObn.jsx)((0, $kGSAf.NotificationToastContent), {
                message: message,
                onClick: onClick
            })
        }), [
        toastRef
    ]);
    const clearToasts = (0, $81g6h.useCallback)(()=>toastRef.current?.clear(), [
        toastRef
    ]);
    const { responsiveDeviceType: responsiveDeviceType } = (0, $5kXMA.useDimensions)();
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useMemo(()=>({
            showToast: showToast,
            showNotification: showNotification,
            clearToasts: clearToasts
        }), [
        showToast,
        showNotification,
        clearToasts
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($2d7e3ce5b08f14cf$export$29d4e2ed4674ecfc.Provider, {
        value: contextValue,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($2d7e3ce5b08f14cf$var$StyledToast, {
                ref: toastRef,
                position: responsiveDeviceType === (0, $5kXMA.ResponsiveDeviceType).Mobile ? "bottom-center" : "top-right"
            }),
            children
        ]
    });
};
const $2d7e3ce5b08f14cf$var$StyledToast = (0, $5UMQ1.default)((0, $hPWzh.Toast))`
	.p-toast-icon-close {
		overflow: unset;
		margin-left: 1rem;
	}

	width: auto;
	max-width: 500px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		bottom: 80px;
		width: 90%;
	}
`;

});
parcelRegister("5kXMA", function(module, exports) {

$parcel$export(module.exports, "ResponsiveDeviceType", () => $b68fde2ebfafb4f9$export$6f0d280023947840);
$parcel$export(module.exports, "useDimensions", () => $b68fde2ebfafb4f9$export$d04af0e501fb729f);
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $81g6h = parcelRequire("81g6h");
var $b68fde2ebfafb4f9$export$6f0d280023947840;
(function(ResponsiveDeviceType) {
    ResponsiveDeviceType["Mobile"] = "Mobile";
    ResponsiveDeviceType["Tablet"] = "Tablet";
    ResponsiveDeviceType["Desktop"] = "Desktop";
})($b68fde2ebfafb4f9$export$6f0d280023947840 || ($b68fde2ebfafb4f9$export$6f0d280023947840 = {}));
const $b68fde2ebfafb4f9$export$d04af0e501fb729f = ()=>{
    const [windowWidth, setWindowWidth] = (0, $81g6h.useState)(NaN);
    (0, $81g6h.useEffect)(()=>{
        function handleResize() {
            setWindowWidth(window.innerWidth);
        }
        window.addEventListener("resize", handleResize);
        handleResize();
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    const responsiveDeviceType = (0, $81g6h.useMemo)(()=>{
        if (windowWidth <= (0, $eaiXJ.MOBILE_BREAKING_POINT)) return "Mobile";
        else if (windowWidth <= (0, $eaiXJ.TABLET_BREAKING_POINT)) return "Tablet";
        else return "Desktop";
    }, [
        windowWidth
    ]);
    const isMobile = (0, $81g6h.useMemo)(()=>responsiveDeviceType === "Mobile", [
        responsiveDeviceType
    ]);
    const isTablet = (0, $81g6h.useMemo)(()=>responsiveDeviceType === "Tablet", [
        responsiveDeviceType
    ]);
    const isDesktop = (0, $81g6h.useMemo)(()=>responsiveDeviceType === "Desktop", [
        responsiveDeviceType
    ]);
    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    return {
        responsiveDeviceType: responsiveDeviceType,
        isMobile: isMobile,
        isTablet: isTablet,
        isDesktop: isDesktop,
        isTouchDevice: isTouchDevice
    };
};

});

parcelRegister("kGSAf", function(module, exports) {

$parcel$export(module.exports, "NotificationToastContent", () => $9c00b21ae0840178$export$b8b6be46b861fe7e);

var $iKObn = parcelRequire("iKObn");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");
parcelRequire("81g6h");
var $9c00b21ae0840178$var$NotificationIcon = function NotificationIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M3.98 19.7c-.326 0-.598-.105-.817-.316-.22-.211-.33-.472-.33-.784 0-.312.11-.573.33-.784.22-.21.491-.316.816-.316h1.146V9.8c0-1.522.477-2.874 1.432-4.056.955-1.183 2.196-1.957 3.724-2.324v-.77c0-.458.167-.848.502-1.169.334-.32.74-.481 1.217-.481.477 0 .883.16 1.217.481.335.321.502.71.502 1.169v.77c1.527.367 2.769 1.141 3.724 2.324A6.277 6.277 0 0 1 18.875 9.8v7.7h1.146c.324 0 .596.105.816.316.22.211.33.472.33.784 0 .312-.11.573-.33.784-.22.21-.492.316-.816.316H3.979Zm3.437-2.2h9.166V9.8c0-1.21-.448-2.246-1.346-3.108C14.339 5.832 13.26 5.4 12 5.4s-2.34.43-3.237 1.292C7.865 7.554 7.417 8.59 7.417 9.8v7.7ZM10.473 22.554c.449.43.988.646 1.619.646.63 0 1.17-.215 1.618-.646.449-.431.673-.949.673-1.554H9.8c0 .605.224 1.123.673 1.554Z",
            fill: "currentColor"
        })
    });
};
$9c00b21ae0840178$var$NotificationIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $9c00b21ae0840178$export$b8b6be46b861fe7e = ({ message: message, onClick: onClick })=>/*#__PURE__*/ (0, $iKObn.jsxs)($9c00b21ae0840178$var$Container, {
        onClick: ()=>{
            (0, $ghfIB.notificationBadgeManager).saveLastUnreadCount();
            if ((0, $lTdpc.isNotNil)(onClick)) onClick();
        },
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)($9c00b21ae0840178$var$NotificationIcon, {
                    color: (0, $kKnoQ.colors).primary,
                    width: 24,
                    height: 24
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: message
            })
        ]
    });
const $9c00b21ae0840178$var$Container = (0, $5UMQ1.default).div`
	display: flex;
	flex: 1;
	cursor: pointer;
	gap: 8px;
	color: ${(0, $kKnoQ.colors).black};
`;

});

parcelRegister("hPWzh", function(module, exports) {

$parcel$export(module.exports, "Toast", () => $cfc4a17651d2ea2c$export$8d8dc7d5f743331b);

var $81g6h = parcelRequire("81g6h");

var $bNx1F = parcelRequire("bNx1F");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $lbdsH = parcelRequire("lbdsH");

var $l2NC0 = parcelRequire("l2NC0");

var $6b4aU = parcelRequire("6b4aU");

var $cfkGk = parcelRequire("cfkGk");

var $h7Chj = parcelRequire("h7Chj");

var $3HHq3 = parcelRequire("3HHq3");

var $6zYvp = parcelRequire("6zYvp");

var $4vsYR = parcelRequire("4vsYR");

var $6BqT9 = parcelRequire("6BqT9");

var $9rbaG = parcelRequire("9rbaG");
"use client";
function $cfc4a17651d2ea2c$var$_extends() {
    $cfc4a17651d2ea2c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cfc4a17651d2ea2c$var$_extends.apply(this, arguments);
}
function $cfc4a17651d2ea2c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cfc4a17651d2ea2c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cfc4a17651d2ea2c$var$_arrayLikeToArray(arr);
}
function $cfc4a17651d2ea2c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $cfc4a17651d2ea2c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cfc4a17651d2ea2c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cfc4a17651d2ea2c$var$_arrayLikeToArray(o, minLen);
}
function $cfc4a17651d2ea2c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cfc4a17651d2ea2c$var$_toConsumableArray(arr) {
    return $cfc4a17651d2ea2c$var$_arrayWithoutHoles(arr) || $cfc4a17651d2ea2c$var$_iterableToArray(arr) || $cfc4a17651d2ea2c$var$_unsupportedIterableToArray(arr) || $cfc4a17651d2ea2c$var$_nonIterableSpread();
}
function $cfc4a17651d2ea2c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $cfc4a17651d2ea2c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $cfc4a17651d2ea2c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cfc4a17651d2ea2c$var$_slicedToArray(arr, i) {
    return $cfc4a17651d2ea2c$var$_arrayWithHoles(arr) || $cfc4a17651d2ea2c$var$_iterableToArrayLimit(arr, i) || $cfc4a17651d2ea2c$var$_unsupportedIterableToArray(arr, i) || $cfc4a17651d2ea2c$var$_nonIterableRest();
}
function $cfc4a17651d2ea2c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cfc4a17651d2ea2c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cfc4a17651d2ea2c$var$_typeof(o);
}
function $cfc4a17651d2ea2c$var$_toPrimitive(input, hint) {
    if ($cfc4a17651d2ea2c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($cfc4a17651d2ea2c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $cfc4a17651d2ea2c$var$_toPropertyKey(arg) {
    var key = $cfc4a17651d2ea2c$var$_toPrimitive(arg, "string");
    return $cfc4a17651d2ea2c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $cfc4a17651d2ea2c$var$_defineProperty(obj, key, value) {
    key = $cfc4a17651d2ea2c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $cfc4a17651d2ea2c$var$styles = "\n@layer primereact {\n    .p-toast {\n        width: calc(100% - var(--toast-indent, 0px));\n        max-width: 25rem;\n    }\n    \n    .p-toast-message-icon {\n        flex-shrink: 0;\n    }\n    \n    .p-toast-message-content {\n        display: flex;\n        align-items: flex-start;\n    }\n    \n    .p-toast-message-text {\n        flex: 1 1 auto;\n    }\n    \n    .p-toast-summary {\n        overflow-wrap: anywhere;\n    }\n    \n    .p-toast-detail {\n        overflow-wrap: anywhere;\n    }\n    \n    .p-toast-top-center {\n        transform: translateX(-50%);\n    }\n    \n    .p-toast-bottom-center {\n        transform: translateX(-50%);\n    }\n    \n    .p-toast-center {\n        min-width: 20vw;\n        transform: translate(-50%, -50%);\n    }\n    \n    .p-toast-icon-close {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        overflow: hidden;\n        position: relative;\n    }\n    \n    .p-toast-icon-close.p-link {\n        cursor: pointer;\n    }\n    \n    /* Animations */\n    .p-toast-message-enter {\n        opacity: 0;\n        transform: translateY(50%);\n    }\n    \n    .p-toast-message-enter-active {\n        opacity: 1;\n        transform: translateY(0);\n        transition: transform 0.3s, opacity 0.3s;\n    }\n    \n    .p-toast-message-enter-done {\n        transform: none;\n    }\n    \n    .p-toast-message-exit {\n        opacity: 1;\n        max-height: 1000px;\n    }\n    \n    .p-toast .p-toast-message.p-toast-message-exit-active {\n        opacity: 0;\n        max-height: 0;\n        margin-bottom: 0;\n        overflow: hidden;\n        transition: max-height 0.45s cubic-bezier(0, 1, 0, 1), opacity 0.3s, margin-bottom 0.3s;\n    }\n}\n";
var $cfc4a17651d2ea2c$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, context = _ref.context;
        return (0, $cfkGk.classNames)("p-toast p-component p-toast-" + props.position, props.className, {
            "p-input-filled": context && context.inputStyle === "filled" || (0, $8Zwsm.default).inputStyle === "filled",
            "p-ripple-disabled": context && context.ripple === false || (0, $8Zwsm.default).ripple === false
        });
    },
    message: {
        message: function message(_ref2) {
            var severity = _ref2.severity;
            return (0, $cfkGk.classNames)("p-toast-message", $cfc4a17651d2ea2c$var$_defineProperty({}, "p-toast-message-".concat(severity), severity));
        },
        content: "p-toast-message-content",
        buttonicon: "p-toast-icon-close-icon",
        closeButton: "p-toast-icon-close p-link",
        icon: "p-toast-message-icon",
        text: "p-toast-message-text",
        summary: "p-toast-summary",
        detail: "p-toast-detail"
    },
    transition: "p-toast-message"
};
var $cfc4a17651d2ea2c$var$inlineStyles = {
    root: function root(_ref3) {
        var props = _ref3.props;
        return {
            position: "fixed",
            top: props.position === "top-right" || props.position === "top-left" || props.position === "top-center" ? "20px" : props.position === "center" ? "50%" : null,
            right: (props.position === "top-right" || props.position === "bottom-right") && "20px",
            bottom: (props.position === "bottom-left" || props.position === "bottom-right" || props.position === "bottom-center") && "20px",
            left: props.position === "top-left" || props.position === "bottom-left" ? "20px" : props.position === "center" || props.position === "top-center" || props.position === "bottom-center" ? "50%" : null
        };
    }
};
var $cfc4a17651d2ea2c$var$ToastBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Toast",
        id: null,
        className: null,
        content: null,
        style: null,
        baseZIndex: 0,
        position: "top-right",
        transitionOptions: null,
        appendTo: "self",
        onClick: null,
        onRemove: null,
        onShow: null,
        onHide: null,
        onMouseEnter: null,
        onMouseLeave: null,
        children: undefined
    },
    css: {
        classes: $cfc4a17651d2ea2c$var$classes,
        styles: $cfc4a17651d2ea2c$var$styles,
        inlineStyles: $cfc4a17651d2ea2c$var$inlineStyles
    }
});
function $cfc4a17651d2ea2c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $cfc4a17651d2ea2c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $cfc4a17651d2ea2c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cfc4a17651d2ea2c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cfc4a17651d2ea2c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $cfc4a17651d2ea2c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $cfc4a17651d2ea2c$var$FilterMatchMode = Object.freeze({
    STARTS_WITH: "startsWith",
    CONTAINS: "contains",
    NOT_CONTAINS: "notContains",
    ENDS_WITH: "endsWith",
    EQUALS: "equals",
    NOT_EQUALS: "notEquals",
    IN: "in",
    LESS_THAN: "lt",
    LESS_THAN_OR_EQUAL_TO: "lte",
    GREATER_THAN: "gt",
    GREATER_THAN_OR_EQUAL_TO: "gte",
    BETWEEN: "between",
    DATE_IS: "dateIs",
    DATE_IS_NOT: "dateIsNot",
    DATE_BEFORE: "dateBefore",
    DATE_AFTER: "dateAfter",
    CUSTOM: "custom"
});
/**
 * @deprecated please use PrimeReactContext
 */ var $cfc4a17651d2ea2c$var$PrimeReact = /*#__PURE__*/ $cfc4a17651d2ea2c$var$_createClass(function PrimeReact() {
    $cfc4a17651d2ea2c$var$_classCallCheck(this, PrimeReact);
});
$cfc4a17651d2ea2c$var$_defineProperty($cfc4a17651d2ea2c$var$PrimeReact, "ripple", false);
$cfc4a17651d2ea2c$var$_defineProperty($cfc4a17651d2ea2c$var$PrimeReact, "inputStyle", "outlined");
$cfc4a17651d2ea2c$var$_defineProperty($cfc4a17651d2ea2c$var$PrimeReact, "locale", "en");
$cfc4a17651d2ea2c$var$_defineProperty($cfc4a17651d2ea2c$var$PrimeReact, "appendTo", null);
$cfc4a17651d2ea2c$var$_defineProperty($cfc4a17651d2ea2c$var$PrimeReact, "cssTransition", true);
$cfc4a17651d2ea2c$var$_defineProperty($cfc4a17651d2ea2c$var$PrimeReact, "autoZIndex", true);
$cfc4a17651d2ea2c$var$_defineProperty($cfc4a17651d2ea2c$var$PrimeReact, "hideOverlaysOnDocumentScrolling", false);
$cfc4a17651d2ea2c$var$_defineProperty($cfc4a17651d2ea2c$var$PrimeReact, "nonce", null);
$cfc4a17651d2ea2c$var$_defineProperty($cfc4a17651d2ea2c$var$PrimeReact, "nullSortOrder", 1);
$cfc4a17651d2ea2c$var$_defineProperty($cfc4a17651d2ea2c$var$PrimeReact, "zIndex", {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
    toast: 1200
});
$cfc4a17651d2ea2c$var$_defineProperty($cfc4a17651d2ea2c$var$PrimeReact, "pt", undefined);
$cfc4a17651d2ea2c$var$_defineProperty($cfc4a17651d2ea2c$var$PrimeReact, "filterMatchModeOptions", {
    text: [
        $cfc4a17651d2ea2c$var$FilterMatchMode.STARTS_WITH,
        $cfc4a17651d2ea2c$var$FilterMatchMode.CONTAINS,
        $cfc4a17651d2ea2c$var$FilterMatchMode.NOT_CONTAINS,
        $cfc4a17651d2ea2c$var$FilterMatchMode.ENDS_WITH,
        $cfc4a17651d2ea2c$var$FilterMatchMode.EQUALS,
        $cfc4a17651d2ea2c$var$FilterMatchMode.NOT_EQUALS
    ],
    numeric: [
        $cfc4a17651d2ea2c$var$FilterMatchMode.EQUALS,
        $cfc4a17651d2ea2c$var$FilterMatchMode.NOT_EQUALS,
        $cfc4a17651d2ea2c$var$FilterMatchMode.LESS_THAN,
        $cfc4a17651d2ea2c$var$FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        $cfc4a17651d2ea2c$var$FilterMatchMode.GREATER_THAN,
        $cfc4a17651d2ea2c$var$FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
    ],
    date: [
        $cfc4a17651d2ea2c$var$FilterMatchMode.DATE_IS,
        $cfc4a17651d2ea2c$var$FilterMatchMode.DATE_IS_NOT,
        $cfc4a17651d2ea2c$var$FilterMatchMode.DATE_BEFORE,
        $cfc4a17651d2ea2c$var$FilterMatchMode.DATE_AFTER
    ]
});
$cfc4a17651d2ea2c$var$_defineProperty($cfc4a17651d2ea2c$var$PrimeReact, "changeTheme", function(currentTheme, newTheme, linkElementId, callback) {
    var _linkElement$parentNo;
    var linkElement = document.getElementById(linkElementId);
    var cloneLinkElement = linkElement.cloneNode(true);
    var newThemeUrl = linkElement.getAttribute("href").replace(currentTheme, newTheme);
    cloneLinkElement.setAttribute("id", linkElementId + "-clone");
    cloneLinkElement.setAttribute("href", newThemeUrl);
    cloneLinkElement.addEventListener("load", function() {
        linkElement.remove();
        cloneLinkElement.setAttribute("id", linkElementId);
        if (callback) callback();
    });
    (_linkElement$parentNo = linkElement.parentNode) === null || _linkElement$parentNo === void 0 || _linkElement$parentNo.insertBefore(cloneLinkElement, linkElement.nextSibling);
});
var $cfc4a17651d2ea2c$var$locales = {
    en: {
        accept: "Yes",
        addRule: "Add Rule",
        am: "AM",
        apply: "Apply",
        cancel: "Cancel",
        choose: "Choose",
        chooseDate: "Choose Date",
        chooseMonth: "Choose Month",
        chooseYear: "Choose Year",
        clear: "Clear",
        completed: "Completed",
        contains: "Contains",
        custom: "Custom",
        dateAfter: "Date is after",
        dateBefore: "Date is before",
        dateFormat: "mm/dd/yy",
        dateIs: "Date is",
        dateIsNot: "Date is not",
        dayNames: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        dayNamesMin: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
        ],
        dayNamesShort: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        emptyFilterMessage: "No results found",
        emptyMessage: "No available options",
        emptySearchMessage: "No results found",
        emptySelectionMessage: "No selected item",
        endsWith: "Ends with",
        equals: "Equals",
        fileSizeTypes: [
            "B",
            "KB",
            "MB",
            "GB",
            "TB",
            "PB",
            "EB",
            "ZB",
            "YB"
        ],
        filter: "Filter",
        firstDayOfWeek: 0,
        gt: "Greater than",
        gte: "Greater than or equal to",
        lt: "Less than",
        lte: "Less than or equal to",
        matchAll: "Match All",
        matchAny: "Match Any",
        medium: "Medium",
        monthNames: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthNamesShort: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        nextDecade: "Next Decade",
        nextHour: "Next Hour",
        nextMinute: "Next Minute",
        nextMonth: "Next Month",
        nextSecond: "Next Second",
        nextYear: "Next Year",
        noFilter: "No Filter",
        notContains: "Not contains",
        notEquals: "Not equals",
        now: "Now",
        passwordPrompt: "Enter a password",
        pending: "Pending",
        pm: "PM",
        prevDecade: "Previous Decade",
        prevHour: "Previous Hour",
        prevMinute: "Previous Minute",
        prevMonth: "Previous Month",
        prevSecond: "Previous Second",
        prevYear: "Previous Year",
        reject: "No",
        removeRule: "Remove Rule",
        searchMessage: "{0} results are available",
        selectionMessage: "{0} items selected",
        showMonthAfterYear: false,
        startsWith: "Starts with",
        strong: "Strong",
        today: "Today",
        upload: "Upload",
        weak: "Weak",
        weekHeader: "Wk",
        aria: {
            cancelEdit: "Cancel Edit",
            close: "Close",
            collapseRow: "Row Collapsed",
            editRow: "Edit Row",
            expandRow: "Row Expanded",
            falseLabel: "False",
            filterConstraint: "Filter Constraint",
            filterOperator: "Filter Operator",
            firstPageLabel: "First Page",
            gridView: "Grid View",
            hideFilterMenu: "Hide Filter Menu",
            jumpToPageDropdownLabel: "Jump to Page Dropdown",
            jumpToPageInputLabel: "Jump to Page Input",
            lastPageLabel: "Last Page",
            listView: "List View",
            moveAllToSource: "Move All to Source",
            moveAllToTarget: "Move All to Target",
            moveBottom: "Move Bottom",
            moveDown: "Move Down",
            moveToSource: "Move to Source",
            moveToTarget: "Move to Target",
            moveTop: "Move Top",
            moveUp: "Move Up",
            navigation: "Navigation",
            next: "Next",
            nextPageLabel: "Next Page",
            nullLabel: "Not Selected",
            pageLabel: "Page {page}",
            otpLabel: "Please enter one time password character {0}",
            passwordHide: "Hide Password",
            passwordShow: "Show Password",
            previous: "Previous",
            previousPageLabel: "Previous Page",
            rotateLeft: "Rotate Left",
            rotateRight: "Rotate Right",
            rowsPerPageLabel: "Rows per page",
            saveEdit: "Save Edit",
            scrollTop: "Scroll Top",
            selectAll: "All items selected",
            selectRow: "Row Selected",
            showFilterMenu: "Show Filter Menu",
            slide: "Slide",
            slideNumber: "{slideNumber}",
            star: "1 star",
            stars: "{star} stars",
            trueLabel: "True",
            unselectAll: "All items unselected",
            unselectRow: "Row Unselected",
            zoomImage: "Zoom Image",
            zoomIn: "Zoom In",
            zoomOut: "Zoom Out"
        }
    }
};
function $cfc4a17651d2ea2c$var$localeOption(key, locale) {
    if (key.includes("__proto__") || key.includes("prototype")) throw new Error("Unsafe key detected");
    var _locale = locale || $cfc4a17651d2ea2c$var$PrimeReact.locale;
    try {
        return $cfc4a17651d2ea2c$var$localeOptions(_locale)[key];
    } catch (error) {
        throw new Error("The ".concat(key, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
function $cfc4a17651d2ea2c$var$localeOptions(locale) {
    var _locale = locale || $cfc4a17651d2ea2c$var$PrimeReact.locale;
    if (_locale.includes("__proto__") || _locale.includes("prototype")) throw new Error("Unsafe locale detected");
    return $cfc4a17651d2ea2c$var$locales[_locale];
}
function $cfc4a17651d2ea2c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cfc4a17651d2ea2c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cfc4a17651d2ea2c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cfc4a17651d2ea2c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cfc4a17651d2ea2c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cfc4a17651d2ea2c$var$ToastMessage = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(props, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var messageInfo = props.messageInfo, parentMetaData = props.metaData, _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx, index = props.index;
    var _messageInfo$message = messageInfo.message, severity = _messageInfo$message.severity, content = _messageInfo$message.content, summary = _messageInfo$message.summary, detail = _messageInfo$message.detail, closable = _messageInfo$message.closable, life = _messageInfo$message.life, sticky = _messageInfo$message.sticky, _className = _messageInfo$message.className, style = _messageInfo$message.style, _contentClassName = _messageInfo$message.contentClassName, contentStyle = _messageInfo$message.contentStyle, _icon = _messageInfo$message.icon, _closeIcon = _messageInfo$message.closeIcon, pt = _messageInfo$message.pt;
    var params = {
        index: index
    };
    var parentParams = $cfc4a17651d2ea2c$var$_objectSpread($cfc4a17651d2ea2c$var$_objectSpread({}, parentMetaData), params);
    var _React$useState = $81g6h.useState(false), _React$useState2 = $cfc4a17651d2ea2c$var$_slicedToArray(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
    var _useTimeout = (0, $l2NC0.useTimeout)(function() {
        onClose();
    }, life || 3000, !sticky && !focused), _useTimeout2 = $cfc4a17651d2ea2c$var$_slicedToArray(_useTimeout, 1), clearTimer = _useTimeout2[0];
    var getPTOptions = function getPTOptions(key, options) {
        return ptm(key, $cfc4a17651d2ea2c$var$_objectSpread({
            hostName: props.hostName
        }, options));
    };
    var onClose = function onClose() {
        clearTimer();
        props.onClose && props.onClose(messageInfo);
    };
    var onClick = function onClick(event) {
        if (props.onClick && !((0, $cfkGk.DomHandler).hasClass(event.target, "p-toast-icon-close") || (0, $cfkGk.DomHandler).hasClass(event.target, "p-toast-icon-close-icon"))) props.onClick(messageInfo.message);
    };
    var onMouseEnter = function onMouseEnter(event) {
        props.onMouseEnter && props.onMouseEnter(event);
        // do not continue if the user has canceled the event
        if (event.defaultPrevented) return;
        // stop timer while user has focused message
        if (!sticky) {
            clearTimer();
            setFocused(true);
        }
    };
    var onMouseLeave = function onMouseLeave(event) {
        props.onMouseLeave && props.onMouseLeave(event);
        // do not continue if the user has canceled the event
        if (event.defaultPrevented) return;
        // restart timer when user has left message
        if (!sticky) setFocused(false);
    };
    var createCloseIcon = function createCloseIcon() {
        var buttonIconProps = mergeProps({
            className: cx("message.buttonicon")
        }, getPTOptions("buttonicon", parentParams), ptmo(pt, "buttonicon", $cfc4a17651d2ea2c$var$_objectSpread($cfc4a17651d2ea2c$var$_objectSpread({}, params), {}, {
            hostName: props.hostName
        })));
        var icon = _closeIcon || /*#__PURE__*/ $81g6h.createElement((0, $4vsYR.TimesIcon), buttonIconProps);
        var closeIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $cfc4a17651d2ea2c$var$_objectSpread({}, buttonIconProps), {
            props: props
        });
        var ariaLabel = props.ariaCloseLabel || $cfc4a17651d2ea2c$var$localeOption("close");
        var closeButtonProps = mergeProps({
            type: "button",
            className: cx("message.closeButton"),
            onClick: onClose,
            "aria-label": ariaLabel
        }, getPTOptions("closeButton", parentParams), ptmo(pt, "closeButton", $cfc4a17651d2ea2c$var$_objectSpread($cfc4a17651d2ea2c$var$_objectSpread({}, params), {}, {
            hostName: props.hostName
        })));
        if (closable !== false) return /*#__PURE__*/ $81g6h.createElement("div", null, /*#__PURE__*/ $81g6h.createElement("button", closeButtonProps, closeIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null)));
        return null;
    };
    var createMessage = function createMessage() {
        if (messageInfo) {
            var contentEl = (0, $cfkGk.ObjectUtils).getJSXElement(content, {
                message: messageInfo.message,
                onClick: onClick,
                onClose: onClose
            });
            var iconProps = mergeProps({
                className: cx("message.icon")
            }, getPTOptions("icon", parentParams), ptmo(pt, "icon", $cfc4a17651d2ea2c$var$_objectSpread($cfc4a17651d2ea2c$var$_objectSpread({}, params), {}, {
                hostName: props.hostName
            })));
            var icon = _icon;
            if (!_icon) switch(severity){
                case "info":
                    icon = /*#__PURE__*/ $81g6h.createElement((0, $6zYvp.InfoCircleIcon), iconProps);
                    break;
                case "warn":
                    icon = /*#__PURE__*/ $81g6h.createElement((0, $3HHq3.ExclamationTriangleIcon), iconProps);
                    break;
                case "error":
                    icon = /*#__PURE__*/ $81g6h.createElement((0, $6BqT9.TimesCircleIcon), iconProps);
                    break;
                case "success":
                    icon = /*#__PURE__*/ $81g6h.createElement((0, $h7Chj.CheckIcon), iconProps);
                    break;
            }
            var messageIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $cfc4a17651d2ea2c$var$_objectSpread({}, iconProps), {
                props: props
            });
            var textProps = mergeProps({
                className: cx("message.text")
            }, getPTOptions("text", parentParams), ptmo(pt, "text", $cfc4a17651d2ea2c$var$_objectSpread($cfc4a17651d2ea2c$var$_objectSpread({}, params), {}, {
                hostName: props.hostName
            })));
            var summaryProps = mergeProps({
                className: cx("message.summary")
            }, getPTOptions("summary", parentParams), ptmo(pt, "summary", $cfc4a17651d2ea2c$var$_objectSpread($cfc4a17651d2ea2c$var$_objectSpread({}, params), {}, {
                hostName: props.hostName
            })));
            var detailProps = mergeProps({
                className: cx("message.detail")
            }, getPTOptions("detail", parentParams), ptmo(pt, "detail", $cfc4a17651d2ea2c$var$_objectSpread($cfc4a17651d2ea2c$var$_objectSpread({}, params), {}, {
                hostName: props.hostName
            })));
            return contentEl || /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, messageIcon, /*#__PURE__*/ $81g6h.createElement("div", textProps, /*#__PURE__*/ $81g6h.createElement("span", summaryProps, summary), detail && /*#__PURE__*/ $81g6h.createElement("div", detailProps, detail)));
        }
        return null;
    };
    var message = createMessage();
    var closeIcon = createCloseIcon();
    var messageProps = mergeProps({
        ref: ref,
        className: (0, $cfkGk.classNames)(_className, cx("message.message", {
            severity: severity
        })),
        style: style,
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, getPTOptions("message", parentParams), ptmo(pt, "root", $cfc4a17651d2ea2c$var$_objectSpread($cfc4a17651d2ea2c$var$_objectSpread({}, params), {}, {
        hostName: props.hostName
    })));
    var contentProps = mergeProps({
        className: (0, $cfkGk.classNames)(_contentClassName, cx("message.content")),
        style: contentStyle
    }, getPTOptions("content", parentParams), ptmo(pt, "content", $cfc4a17651d2ea2c$var$_objectSpread($cfc4a17651d2ea2c$var$_objectSpread({}, params), {}, {
        hostName: props.hostName
    })));
    return /*#__PURE__*/ $81g6h.createElement("div", messageProps, /*#__PURE__*/ $81g6h.createElement("div", contentProps, message, closeIcon));
}));
$cfc4a17651d2ea2c$var$ToastMessage.displayName = "ToastMessage";
var $cfc4a17651d2ea2c$var$messageIdx = 0;
var $cfc4a17651d2ea2c$export$8d8dc7d5f743331b = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $cfc4a17651d2ea2c$var$ToastBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState([]), _React$useState2 = $cfc4a17651d2ea2c$var$_slicedToArray(_React$useState, 2), messagesState = _React$useState2[0], setMessagesState = _React$useState2[1];
    var containerRef = $81g6h.useRef(null);
    var metaData = {
        props: props,
        state: {
            messages: messagesState
        }
    };
    var ptCallbacks = $cfc4a17651d2ea2c$var$ToastBase.setMetaData(metaData);
    (0, $4gQLd.useHandleStyle)($cfc4a17651d2ea2c$var$ToastBase.css.styles, ptCallbacks.isUnstyled, {
        name: "toast"
    });
    var show = function show(messageInfo) {
        if (messageInfo) setMessagesState(function(prev) {
            return assignIdentifiers(prev, messageInfo, true);
        });
    };
    var assignIdentifiers = function assignIdentifiers(currentState, messageInfo, copy) {
        var messages;
        if (Array.isArray(messageInfo)) {
            var multipleMessages = messageInfo.reduce(function(acc, message) {
                acc.push({
                    _pId: $cfc4a17651d2ea2c$var$messageIdx++,
                    message: message
                });
                return acc;
            }, []);
            if (copy) messages = currentState ? [].concat($cfc4a17651d2ea2c$var$_toConsumableArray(currentState), $cfc4a17651d2ea2c$var$_toConsumableArray(multipleMessages)) : multipleMessages;
            else messages = multipleMessages;
        } else {
            var message = {
                _pId: $cfc4a17651d2ea2c$var$messageIdx++,
                message: messageInfo
            };
            if (copy) messages = currentState ? [].concat($cfc4a17651d2ea2c$var$_toConsumableArray(currentState), [
                message
            ]) : [
                message
            ];
            else messages = [
                message
            ];
        }
        return messages;
    };
    var clear = function clear() {
        (0, $cfkGk.ZIndexUtils).clear(containerRef.current);
        setMessagesState([]);
    };
    var replace = function replace(messageInfo) {
        setMessagesState(function(previousMessagesState) {
            return assignIdentifiers(previousMessagesState, messageInfo, false);
        });
    };
    var remove = function remove(messageInfo) {
        // allow removal by ID or by message equality
        var removeMessage = messageInfo._pId ? messageInfo._pId : messageInfo.message || messageInfo;
        setMessagesState(function(prev) {
            return prev.filter(function(msg) {
                return msg._pId !== messageInfo._pId && !(0, $cfkGk.ObjectUtils).deepEquals(msg.message, removeMessage);
            });
        });
        props.onRemove && props.onRemove(removeMessage.message || removeMessage);
    };
    var onClose = function onClose(messageInfo) {
        remove(messageInfo);
    };
    var onEntered = function onEntered() {
        props.onShow && props.onShow();
    };
    var onExited = function onExited() {
        messagesState.length === 1 && (0, $cfkGk.ZIndexUtils).clear(containerRef.current);
        props.onHide && props.onHide();
    };
    (0, $l2NC0.useUpdateEffect)(function() {
        (0, $cfkGk.ZIndexUtils).set("toast", containerRef.current, context && context.autoZIndex || (0, $8Zwsm.default).autoZIndex, props.baseZIndex || context && context.zIndex.toast || (0, $8Zwsm.default).zIndex.toast);
    }, [
        messagesState,
        props.baseZIndex
    ]);
    (0, $l2NC0.useUnmountEffect)(function() {
        (0, $cfkGk.ZIndexUtils).clear(containerRef.current);
    });
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            replace: replace,
            remove: remove,
            clear: clear,
            getElement: function getElement() {
                return containerRef.current;
            }
        };
    });
    var createElement = function createElement() {
        var rootProps = mergeProps({
            ref: containerRef,
            id: props.id,
            className: ptCallbacks.cx("root", {
                context: context
            }),
            style: ptCallbacks.sx("root")
        }, $cfc4a17651d2ea2c$var$ToastBase.getOtherProps(props), ptCallbacks.ptm("root"));
        var transitionProps = mergeProps({
            classNames: ptCallbacks.cx("transition"),
            timeout: {
                enter: 300,
                exit: 300
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEntered: onEntered,
            onExited: onExited
        }, ptCallbacks.ptm("transition"));
        return /*#__PURE__*/ $81g6h.createElement("div", rootProps, /*#__PURE__*/ $81g6h.createElement((0, $bNx1F.default), null, messagesState && messagesState.map(function(messageInfo, index) {
            var messageRef = /*#__PURE__*/ $81g6h.createRef();
            return /*#__PURE__*/ $81g6h.createElement((0, $lbdsH.CSSTransition), $cfc4a17651d2ea2c$var$_extends({
                nodeRef: messageRef,
                key: messageInfo._pId
            }, transitionProps), inProps.content ? (0, $cfkGk.ObjectUtils).getJSXElement(inProps.content, {
                message: messageInfo.message
            }) : /*#__PURE__*/ $81g6h.createElement($cfc4a17651d2ea2c$var$ToastMessage, {
                hostName: "Toast",
                ref: messageRef,
                messageInfo: messageInfo,
                index: index,
                onClick: props.onClick,
                onClose: onClose,
                onMouseEnter: props.onMouseEnter,
                onMouseLeave: props.onMouseLeave,
                closeIcon: props.closeIcon,
                ptCallbacks: ptCallbacks,
                metaData: metaData
            }));
        })));
    };
    var element = createElement();
    return /*#__PURE__*/ $81g6h.createElement((0, $6b4aU.Portal), {
        element: element,
        appendTo: props.appendTo
    });
}));
$cfc4a17651d2ea2c$export$8d8dc7d5f743331b.displayName = "Toast";

});
parcelRegister("bNx1F", function(module, exports) {

$parcel$export(module.exports, "default", () => $896de396d8b3e144$export$2e2bcd8739ae039);

var $cnuf2 = parcelRequire("cnuf2");

var $6JG9D = parcelRequire("6JG9D");

var $iOo63 = parcelRequire("iOo63");

var $6UE7L = parcelRequire("6UE7L");


var $81g6h = parcelRequire("81g6h");

var $6iCDW = parcelRequire("6iCDW");

var $71gEj = parcelRequire("71gEj");
var $896de396d8b3e144$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $896de396d8b3e144$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $896de396d8b3e144$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $6UE7L.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $iOo63.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $71gEj.getInitialChildMapping)(nextProps, handleExited) : (0, $71gEj.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $71gEj.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $6JG9D.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $cnuf2.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $896de396d8b3e144$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement((0, $6iCDW.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement((0, $6iCDW.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).Component);
$896de396d8b3e144$var$TransitionGroup.propTypes = {};
$896de396d8b3e144$var$TransitionGroup.defaultProps = $896de396d8b3e144$var$defaultProps;
var $896de396d8b3e144$export$2e2bcd8739ae039 = $896de396d8b3e144$var$TransitionGroup;

});
parcelRegister("cnuf2", function(module, exports) {

$parcel$export(module.exports, "default", () => $902f175d35f950e0$export$2e2bcd8739ae039);
function $902f175d35f950e0$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("iOo63", function(module, exports) {

$parcel$export(module.exports, "default", () => $0388c47e6d7bb57b$export$2e2bcd8739ae039);
function $0388c47e6d7bb57b$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("6UE7L", function(module, exports) {

$parcel$export(module.exports, "default", () => $508718dcb24eb4bd$export$2e2bcd8739ae039);

var $gDLFW = parcelRequire("gDLFW");
function $508718dcb24eb4bd$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $gDLFW.default)(t, o);
}

});
parcelRegister("gDLFW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1d54538cc60fa9f$export$2e2bcd8739ae039);
function $c1d54538cc60fa9f$export$2e2bcd8739ae039(t, e) {
    return $c1d54538cc60fa9f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $c1d54538cc60fa9f$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("6iCDW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4962663d603ef3f5$export$2e2bcd8739ae039);

var $81g6h = parcelRequire("81g6h");
var $4962663d603ef3f5$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createContext(null);

});

parcelRegister("71gEj", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", () => $51c58a9164147be0$export$bbc8a025727ea824);
$parcel$export(module.exports, "getInitialChildMapping", () => $51c58a9164147be0$export$fa71e2345c31d7a2);
$parcel$export(module.exports, "getNextChildMapping", () => $51c58a9164147be0$export$36fd1af28d383ec0);

var $81g6h = parcelRequire("81g6h");
function $51c58a9164147be0$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $81g6h.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $81g6h.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $51c58a9164147be0$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $51c58a9164147be0$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $51c58a9164147be0$export$fa71e2345c31d7a2(props, onExited) {
    return $51c58a9164147be0$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $81g6h.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $51c58a9164147be0$var$getProp(child, "appear", props),
            enter: $51c58a9164147be0$var$getProp(child, "enter", props),
            exit: $51c58a9164147be0$var$getProp(child, "exit", props)
        });
    });
}
function $51c58a9164147be0$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $51c58a9164147be0$export$bbc8a025727ea824(nextProps.children);
    var children = $51c58a9164147be0$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $81g6h.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $81g6h.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $81g6h.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $51c58a9164147be0$var$getProp(child, "exit", nextProps),
            enter: $51c58a9164147be0$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $81g6h.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $81g6h.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $81g6h.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $51c58a9164147be0$var$getProp(child, "exit", nextProps),
            enter: $51c58a9164147be0$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRegister("lbdsH", function(module, exports) {

$parcel$export(module.exports, "CSSTransition", () => $f6b5115101e28130$export$a7a5590ad6d7af0);

var $81g6h = parcelRequire("81g6h");

var $7QQq2 = parcelRequire("7QQq2");

var $l2NC0 = parcelRequire("l2NC0");

var $cfkGk = parcelRequire("cfkGk");

var $8Zwsm = parcelRequire("8Zwsm");
"use client";
function $f6b5115101e28130$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f6b5115101e28130$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f6b5115101e28130$var$_typeof(o);
}
function $f6b5115101e28130$var$_toPrimitive(input, hint) {
    if ($f6b5115101e28130$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f6b5115101e28130$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f6b5115101e28130$var$_toPropertyKey(arg) {
    var key = $f6b5115101e28130$var$_toPrimitive(arg, "string");
    return $f6b5115101e28130$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f6b5115101e28130$var$_defineProperty(obj, key, value) {
    key = $f6b5115101e28130$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $f6b5115101e28130$var$CSSTransitionBase = {
    defaultProps: {
        __TYPE: "CSSTransition",
        children: undefined
    },
    getProps: function getProps(props) {
        return (0, $cfkGk.ObjectUtils).getMergedProps(props, $f6b5115101e28130$var$CSSTransitionBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $cfkGk.ObjectUtils).getDiffProps(props, $f6b5115101e28130$var$CSSTransitionBase.defaultProps);
    }
};
function $f6b5115101e28130$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f6b5115101e28130$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f6b5115101e28130$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f6b5115101e28130$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f6b5115101e28130$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f6b5115101e28130$export$a7a5590ad6d7af0 = /*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var props = $f6b5115101e28130$var$CSSTransitionBase.getProps(inProps);
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var disabled = props.disabled || props.options && props.options.disabled || context && !context.cssTransition || !(0, $8Zwsm.default).cssTransition;
    var onEnter = function onEnter(node, isAppearing) {
        props.onEnter && props.onEnter(node, isAppearing); // component
        props.options && props.options.onEnter && props.options.onEnter(node, isAppearing); // user option
    };
    var onEntering = function onEntering(node, isAppearing) {
        props.onEntering && props.onEntering(node, isAppearing); // component
        props.options && props.options.onEntering && props.options.onEntering(node, isAppearing); // user option
    };
    var onEntered = function onEntered(node, isAppearing) {
        props.onEntered && props.onEntered(node, isAppearing); // component
        props.options && props.options.onEntered && props.options.onEntered(node, isAppearing); // user option
    };
    var onExit = function onExit(node) {
        props.onExit && props.onExit(node); // component
        props.options && props.options.onExit && props.options.onExit(node); // user option
    };
    var onExiting = function onExiting(node) {
        props.onExiting && props.onExiting(node); // component
        props.options && props.options.onExiting && props.options.onExiting(node); // user option
    };
    var onExited = function onExited(node) {
        props.onExited && props.onExited(node); // component
        props.options && props.options.onExited && props.options.onExited(node); // user option
    };
    (0, $l2NC0.useUpdateEffect)(function() {
        if (disabled) {
            // no animation
            var node = (0, $cfkGk.ObjectUtils).getRefElement(props.nodeRef);
            if (props["in"]) {
                onEnter(node, true);
                onEntering(node, true);
                onEntered(node, true);
            } else {
                onExit(node);
                onExiting(node);
                onExited(node);
            }
        }
    }, [
        props["in"]
    ]);
    if (disabled) return props["in"] ? props.children : null;
    var immutableProps = {
        nodeRef: props.nodeRef,
        "in": props["in"],
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited
    };
    var mutableProps = {
        classNames: props.classNames,
        timeout: props.timeout,
        unmountOnExit: props.unmountOnExit
    };
    var mergedProps = $f6b5115101e28130$var$_objectSpread($f6b5115101e28130$var$_objectSpread($f6b5115101e28130$var$_objectSpread({}, mutableProps), props.options || {}), immutableProps);
    return /*#__PURE__*/ $81g6h.createElement((0, $7QQq2.default), mergedProps, props.children);
});
$f6b5115101e28130$export$a7a5590ad6d7af0.displayName = "CSSTransition";

});
parcelRegister("7QQq2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b760d0619dac2fc$export$2e2bcd8739ae039);

var $6JG9D = parcelRequire("6JG9D");

var $cnuf2 = parcelRequire("cnuf2");

var $6UE7L = parcelRequire("6UE7L");


var $bizvI = parcelRequire("bizvI");

var $lWRvo = parcelRequire("lWRvo");

var $81g6h = parcelRequire("81g6h");

var $5c04a = parcelRequire("5c04a");


var $gB85v = parcelRequire("gB85v");
var $5b760d0619dac2fc$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $bizvI.default)(node, c);
    });
};
var $5b760d0619dac2fc$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $lWRvo.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $5b760d0619dac2fc$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $6UE7L.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $gB85v.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $5b760d0619dac2fc$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $5b760d0619dac2fc$var$removeClass(node, baseClassName);
        if (activeClassName) $5b760d0619dac2fc$var$removeClass(node, activeClassName);
        if (doneClassName) $5b760d0619dac2fc$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $cnuf2.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement((0, $5c04a.default), (0, $6JG9D.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).Component);
$5b760d0619dac2fc$var$CSSTransition.defaultProps = {
    classNames: ""
};
$5b760d0619dac2fc$var$CSSTransition.propTypes = {};
var $5b760d0619dac2fc$export$2e2bcd8739ae039 = $5b760d0619dac2fc$var$CSSTransition;

});
parcelRegister("bizvI", function(module, exports) {

$parcel$export(module.exports, "default", () => $839cebccb03858df$export$2e2bcd8739ae039);

var $iLqVT = parcelRequire("iLqVT");
function $839cebccb03858df$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $iLqVT.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

});
parcelRegister("iLqVT", function(module, exports) {

$parcel$export(module.exports, "default", () => $da91821682a721ae$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $da91821682a721ae$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("lWRvo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffa884c8a149c40c$export$2e2bcd8739ae039);
function $ffa884c8a149c40c$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $ffa884c8a149c40c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $ffa884c8a149c40c$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $ffa884c8a149c40c$var$replaceClassName(element.className && element.className.baseVal || "", className));
}

});

parcelRegister("5c04a", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c7e1fe159c2b616$export$2e2bcd8739ae039);

var $cnuf2 = parcelRequire("cnuf2");

var $6UE7L = parcelRequire("6UE7L");


var $81g6h = parcelRequire("81g6h");

var $Q1dTY = parcelRequire("Q1dTY");

var $dsNHX = parcelRequire("dsNHX");


var $6iCDW = parcelRequire("6iCDW");

var $gB85v = parcelRequire("gB85v");
var $3c7e1fe159c2b616$export$bb38bb9a1161268 = "unmounted";
var $3c7e1fe159c2b616$export$84cbff306f539230 = "exited";
var $3c7e1fe159c2b616$export$df38205c966be359 = "entering";
var $3c7e1fe159c2b616$export$78e9e6e3e014d60a = "entered";
var $3c7e1fe159c2b616$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $3c7e1fe159c2b616$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $6UE7L.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $3c7e1fe159c2b616$export$84cbff306f539230;
                _this.appearStatus = $3c7e1fe159c2b616$export$df38205c966be359;
            } else initialStatus = $3c7e1fe159c2b616$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $3c7e1fe159c2b616$export$bb38bb9a1161268;
        else initialStatus = $3c7e1fe159c2b616$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $3c7e1fe159c2b616$export$bb38bb9a1161268) return {
            status: $3c7e1fe159c2b616$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $3c7e1fe159c2b616$export$df38205c966be359 && status !== $3c7e1fe159c2b616$export$78e9e6e3e014d60a) nextStatus = $3c7e1fe159c2b616$export$df38205c966be359;
            } else if (status === $3c7e1fe159c2b616$export$df38205c966be359 || status === $3c7e1fe159c2b616$export$78e9e6e3e014d60a) nextStatus = $3c7e1fe159c2b616$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $3c7e1fe159c2b616$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($Q1dTY))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $gB85v.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $3c7e1fe159c2b616$export$84cbff306f539230) this.setState({
            status: $3c7e1fe159c2b616$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($Q1dTY))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $dsNHX.default).disabled) {
            this.safeSetState({
                status: $3c7e1fe159c2b616$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $3c7e1fe159c2b616$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $3c7e1fe159c2b616$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($Q1dTY))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $dsNHX.default).disabled) {
            this.safeSetState({
                status: $3c7e1fe159c2b616$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $3c7e1fe159c2b616$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $3c7e1fe159c2b616$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($Q1dTY))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $3c7e1fe159c2b616$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $cnuf2.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement((0, $6iCDW.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).Component);
$3c7e1fe159c2b616$var$Transition.contextType = (0, $6iCDW.default);
$3c7e1fe159c2b616$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $3c7e1fe159c2b616$var$noop() {}
$3c7e1fe159c2b616$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $3c7e1fe159c2b616$var$noop,
    onEntering: $3c7e1fe159c2b616$var$noop,
    onEntered: $3c7e1fe159c2b616$var$noop,
    onExit: $3c7e1fe159c2b616$var$noop,
    onExiting: $3c7e1fe159c2b616$var$noop,
    onExited: $3c7e1fe159c2b616$var$noop
};
$3c7e1fe159c2b616$var$Transition.UNMOUNTED = $3c7e1fe159c2b616$export$bb38bb9a1161268;
$3c7e1fe159c2b616$var$Transition.EXITED = $3c7e1fe159c2b616$export$84cbff306f539230;
$3c7e1fe159c2b616$var$Transition.ENTERING = $3c7e1fe159c2b616$export$df38205c966be359;
$3c7e1fe159c2b616$var$Transition.ENTERED = $3c7e1fe159c2b616$export$78e9e6e3e014d60a;
$3c7e1fe159c2b616$var$Transition.EXITING = $3c7e1fe159c2b616$export$4aacc83d4d59139f;
var $3c7e1fe159c2b616$export$2e2bcd8739ae039 = $3c7e1fe159c2b616$var$Transition;

});
parcelRegister("dsNHX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cd472d97885c9c8$export$2e2bcd8739ae039);
var $9cd472d97885c9c8$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("gB85v", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $c156601e727dcc2e$export$7d26bbb1236dafd6);
var $c156601e727dcc2e$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});




parcelRegister("h7Chj", function(module, exports) {

$parcel$export(module.exports, "CheckIcon", () => $c770c865f44eb891$export$7dd004358974b05d);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $c770c865f44eb891$var$_extends() {
    $c770c865f44eb891$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c770c865f44eb891$var$_extends.apply(this, arguments);
}
var $c770c865f44eb891$export$7dd004358974b05d = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $c770c865f44eb891$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M4.86199 11.5948C4.78717 11.5923 4.71366 11.5745 4.64596 11.5426C4.57826 11.5107 4.51779 11.4652 4.46827 11.4091L0.753985 7.69483C0.683167 7.64891 0.623706 7.58751 0.580092 7.51525C0.536478 7.44299 0.509851 7.36177 0.502221 7.27771C0.49459 7.19366 0.506156 7.10897 0.536046 7.03004C0.565935 6.95111 0.613367 6.88 0.674759 6.82208C0.736151 6.76416 0.8099 6.72095 0.890436 6.69571C0.970973 6.67046 1.05619 6.66385 1.13966 6.67635C1.22313 6.68886 1.30266 6.72017 1.37226 6.76792C1.44186 6.81567 1.4997 6.8786 1.54141 6.95197L4.86199 10.2503L12.6397 2.49483C12.7444 2.42694 12.8689 2.39617 12.9932 2.40745C13.1174 2.41873 13.2343 2.47141 13.3251 2.55705C13.4159 2.64268 13.4753 2.75632 13.4938 2.87973C13.5123 3.00315 13.4888 3.1292 13.4271 3.23768L5.2557 11.4091C5.20618 11.4652 5.14571 11.5107 5.07801 11.5426C5.01031 11.5745 4.9368 11.5923 4.86199 11.5948Z",
        fill: "currentColor"
    }));
}));
$c770c865f44eb891$export$7dd004358974b05d.displayName = "CheckIcon";

});

parcelRegister("3HHq3", function(module, exports) {

$parcel$export(module.exports, "ExclamationTriangleIcon", () => $2b27116843bee35f$export$b409b230b61d4724);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $2b27116843bee35f$var$_extends() {
    $2b27116843bee35f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2b27116843bee35f$var$_extends.apply(this, arguments);
}
var $2b27116843bee35f$export$b409b230b61d4724 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $2b27116843bee35f$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M13.4018 13.1893H0.598161C0.49329 13.189 0.390283 13.1615 0.299143 13.1097C0.208003 13.0578 0.131826 12.9832 0.0780112 12.8932C0.0268539 12.8015 0 12.6982 0 12.5931C0 12.4881 0.0268539 12.3848 0.0780112 12.293L6.47985 1.08982C6.53679 1.00399 6.61408 0.933574 6.70484 0.884867C6.7956 0.836159 6.897 0.810669 7 0.810669C7.103 0.810669 7.2044 0.836159 7.29516 0.884867C7.38592 0.933574 7.46321 1.00399 7.52015 1.08982L13.922 12.293C13.9731 12.3848 14 12.4881 14 12.5931C14 12.6982 13.9731 12.8015 13.922 12.8932C13.8682 12.9832 13.792 13.0578 13.7009 13.1097C13.6097 13.1615 13.5067 13.189 13.4018 13.1893ZM1.63046 11.989H12.3695L7 2.59425L1.63046 11.989Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M6.99996 8.78801C6.84143 8.78594 6.68997 8.72204 6.57787 8.60993C6.46576 8.49782 6.40186 8.34637 6.39979 8.18784V5.38703C6.39979 5.22786 6.46302 5.0752 6.57557 4.96265C6.68813 4.85009 6.84078 4.78686 6.99996 4.78686C7.15914 4.78686 7.31179 4.85009 7.42435 4.96265C7.5369 5.0752 7.60013 5.22786 7.60013 5.38703V8.18784C7.59806 8.34637 7.53416 8.49782 7.42205 8.60993C7.30995 8.72204 7.15849 8.78594 6.99996 8.78801Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M6.99996 11.1887C6.84143 11.1866 6.68997 11.1227 6.57787 11.0106C6.46576 10.8985 6.40186 10.7471 6.39979 10.5885V10.1884C6.39979 10.0292 6.46302 9.87658 6.57557 9.76403C6.68813 9.65147 6.84078 9.58824 6.99996 9.58824C7.15914 9.58824 7.31179 9.65147 7.42435 9.76403C7.5369 9.87658 7.60013 10.0292 7.60013 10.1884V10.5885C7.59806 10.7471 7.53416 10.8985 7.42205 11.0106C7.30995 11.1227 7.15849 11.1866 6.99996 11.1887Z",
        fill: "currentColor"
    }));
}));
$2b27116843bee35f$export$b409b230b61d4724.displayName = "ExclamationTriangleIcon";

});

parcelRegister("6zYvp", function(module, exports) {

$parcel$export(module.exports, "InfoCircleIcon", () => $4ca4f21d72163ff5$export$235e99e4cce237dc);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $4ca4f21d72163ff5$var$_extends() {
    $4ca4f21d72163ff5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4ca4f21d72163ff5$var$_extends.apply(this, arguments);
}
var $4ca4f21d72163ff5$export$235e99e4cce237dc = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $4ca4f21d72163ff5$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.11101 12.8203C4.26215 13.5895 5.61553 14 7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.61553 13.5895 4.26215 12.8203 3.11101C12.0511 1.95987 10.9579 1.06266 9.67879 0.532846C8.3997 0.00303296 6.99224 -0.13559 5.63437 0.134506C4.2765 0.404603 3.02922 1.07129 2.05026 2.05026C1.07129 3.02922 0.404603 4.2765 0.134506 5.63437C-0.13559 6.99224 0.00303296 8.3997 0.532846 9.67879C1.06266 10.9579 1.95987 12.0511 3.11101 12.8203ZM3.75918 2.14976C4.71846 1.50879 5.84628 1.16667 7 1.16667C8.5471 1.16667 10.0308 1.78125 11.1248 2.87521C12.2188 3.96918 12.8333 5.45291 12.8333 7C12.8333 8.15373 12.4912 9.28154 11.8502 10.2408C11.2093 11.2001 10.2982 11.9478 9.23232 12.3893C8.16642 12.8308 6.99353 12.9463 5.86198 12.7212C4.73042 12.4962 3.69102 11.9406 2.87521 11.1248C2.05941 10.309 1.50384 9.26958 1.27876 8.13803C1.05367 7.00647 1.16919 5.83358 1.61071 4.76768C2.05222 3.70178 2.79989 2.79074 3.75918 2.14976ZM7.00002 4.8611C6.84594 4.85908 6.69873 4.79698 6.58977 4.68801C6.48081 4.57905 6.4187 4.43185 6.41669 4.27776V3.88888C6.41669 3.73417 6.47815 3.58579 6.58754 3.4764C6.69694 3.367 6.84531 3.30554 7.00002 3.30554C7.15473 3.30554 7.3031 3.367 7.4125 3.4764C7.52189 3.58579 7.58335 3.73417 7.58335 3.88888V4.27776C7.58134 4.43185 7.51923 4.57905 7.41027 4.68801C7.30131 4.79698 7.1541 4.85908 7.00002 4.8611ZM7.00002 10.6945C6.84594 10.6925 6.69873 10.6304 6.58977 10.5214C6.48081 10.4124 6.4187 10.2652 6.41669 10.1111V6.22225C6.41669 6.06754 6.47815 5.91917 6.58754 5.80977C6.69694 5.70037 6.84531 5.63892 7.00002 5.63892C7.15473 5.63892 7.3031 5.70037 7.4125 5.80977C7.52189 5.91917 7.58335 6.06754 7.58335 6.22225V10.1111C7.58134 10.2652 7.51923 10.4124 7.41027 10.5214C7.30131 10.6304 7.1541 10.6925 7.00002 10.6945Z",
        fill: "currentColor"
    }));
}));
$4ca4f21d72163ff5$export$235e99e4cce237dc.displayName = "InfoCircleIcon";

});

parcelRegister("4vsYR", function(module, exports) {

$parcel$export(module.exports, "TimesIcon", () => $348089a05d5dcdb6$export$32edebbf2d9136cc);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $348089a05d5dcdb6$var$_extends() {
    $348089a05d5dcdb6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $348089a05d5dcdb6$var$_extends.apply(this, arguments);
}
var $348089a05d5dcdb6$export$32edebbf2d9136cc = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $348089a05d5dcdb6$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z",
        fill: "currentColor"
    }));
}));
$348089a05d5dcdb6$export$32edebbf2d9136cc.displayName = "TimesIcon";

});

parcelRegister("6BqT9", function(module, exports) {

$parcel$export(module.exports, "TimesCircleIcon", () => $4ceb0e46dad21776$export$4236c899190094ee);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $4ceb0e46dad21776$var$_extends() {
    $4ceb0e46dad21776$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4ceb0e46dad21776$var$_extends.apply(this, arguments);
}
var $4ceb0e46dad21776$export$4236c899190094ee = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $4ceb0e46dad21776$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C5.61553 14 4.26215 13.5895 3.11101 12.8203C1.95987 12.0511 1.06266 10.9579 0.532846 9.67879C0.00303296 8.3997 -0.13559 6.99224 0.134506 5.63437C0.404603 4.2765 1.07129 3.02922 2.05026 2.05026C3.02922 1.07129 4.2765 0.404603 5.63437 0.134506C6.99224 -0.13559 8.3997 0.00303296 9.67879 0.532846C10.9579 1.06266 12.0511 1.95987 12.8203 3.11101C13.5895 4.26215 14 5.61553 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14ZM7 1.16667C5.84628 1.16667 4.71846 1.50879 3.75918 2.14976C2.79989 2.79074 2.05222 3.70178 1.61071 4.76768C1.16919 5.83358 1.05367 7.00647 1.27876 8.13803C1.50384 9.26958 2.05941 10.309 2.87521 11.1248C3.69102 11.9406 4.73042 12.4962 5.86198 12.7212C6.99353 12.9463 8.16642 12.8308 9.23232 12.3893C10.2982 11.9478 11.2093 11.2001 11.8502 10.2408C12.4912 9.28154 12.8333 8.15373 12.8333 7C12.8333 5.45291 12.2188 3.96918 11.1248 2.87521C10.0308 1.78125 8.5471 1.16667 7 1.16667ZM4.66662 9.91668C4.58998 9.91704 4.51404 9.90209 4.44325 9.87271C4.37246 9.84333 4.30826 9.8001 4.2544 9.74557C4.14516 9.6362 4.0838 9.48793 4.0838 9.33335C4.0838 9.17876 4.14516 9.0305 4.2544 8.92113L6.17553 7L4.25443 5.07891C4.15139 4.96832 4.09529 4.82207 4.09796 4.67094C4.10063 4.51982 4.16185 4.37563 4.26872 4.26876C4.3756 4.16188 4.51979 4.10066 4.67091 4.09799C4.82204 4.09532 4.96829 4.15142 5.07887 4.25446L6.99997 6.17556L8.92106 4.25446C9.03164 4.15142 9.1779 4.09532 9.32903 4.09799C9.48015 4.10066 9.62434 4.16188 9.73121 4.26876C9.83809 4.37563 9.89931 4.51982 9.90198 4.67094C9.90464 4.82207 9.84855 4.96832 9.74551 5.07891L7.82441 7L9.74554 8.92113C9.85478 9.0305 9.91614 9.17876 9.91614 9.33335C9.91614 9.48793 9.85478 9.6362 9.74554 9.74557C9.69168 9.8001 9.62748 9.84333 9.55669 9.87271C9.4859 9.90209 9.40996 9.91704 9.33332 9.91668C9.25668 9.91704 9.18073 9.90209 9.10995 9.87271C9.03916 9.84333 8.97495 9.8001 8.9211 9.74557L6.99997 7.82444L5.07884 9.74557C5.02499 9.8001 4.96078 9.84333 4.88999 9.87271C4.81921 9.90209 4.74326 9.91704 4.66662 9.91668Z",
        fill: "currentColor"
    }));
}));
$4ceb0e46dad21776$export$4236c899190094ee.displayName = "TimesCircleIcon";

});



parcelRegister("ddMj4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $96cc6 = parcelRequire("96cc6");
function $9a01f5ee62a65214$var$emptyFunction() {}
function $9a01f5ee62a65214$var$emptyFunctionWithReset() {}
$9a01f5ee62a65214$var$emptyFunctionWithReset.resetWarningCache = $9a01f5ee62a65214$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $96cc6) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $9a01f5ee62a65214$var$emptyFunctionWithReset,
        resetWarningCache: $9a01f5ee62a65214$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("96cc6", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $69fe221a775a59ba$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $69fe221a775a59ba$var$ReactPropTypesSecret;

});


parcelRegister("4UKJF", function(module, exports) {

$parcel$export(module.exports, "useUser", () => $48980d154bfe896f$export$23bbbc4533528f03);

var $ghfIB = parcelRequire("ghfIB");

var $1IWnK = parcelRequire("1IWnK");
const $48980d154bfe896f$export$23bbbc4533528f03 = ()=>(0, $1IWnK.useObservable)((0, $ghfIB.userManager).user);

});

parcelRegister("243Cr", function(module, exports) {

$parcel$export(module.exports, "ModalId", () => $684cfc9ccf3ece4f$export$91d18c1203db8cb5);
$parcel$export(module.exports, "DialogContext", () => $684cfc9ccf3ece4f$export$8b93a07348a7730c);
$parcel$export(module.exports, "DialogProvider", () => $684cfc9ccf3ece4f$export$7ab5cfe96fae86d3);

var $iKObn = parcelRequire("iKObn");

var $jJxkW = parcelRequire("jJxkW");

var $IR0l7 = parcelRequire("IR0l7");

var $l7dWZ = parcelRequire("l7dWZ");

var $i7mGO = parcelRequire("i7mGO");

var $cg4YL = parcelRequire("cg4YL");

var $hcxj3 = parcelRequire("hcxj3");

var $9rH2X = parcelRequire("9rH2X");

var $eiBvZ = parcelRequire("eiBvZ");

var $g6npC = parcelRequire("g6npC");

var $9ijS8 = parcelRequire("9ijS8");

var $8dSEo = parcelRequire("8dSEo");

var $loq6i = parcelRequire("loq6i");

var $cf3Fx = parcelRequire("cf3Fx");

var $dHcUB = parcelRequire("dHcUB");

var $4BN49 = parcelRequire("4BN49");

var $ajWZo = parcelRequire("ajWZo");

var $5jB8I = parcelRequire("5jB8I");

var $2rZVV = parcelRequire("2rZVV");

var $74GM7 = parcelRequire("74GM7");

var $5e5pP = parcelRequire("5e5pP");

var $2zGye = parcelRequire("2zGye");

var $cxZ7L = parcelRequire("cxZ7L");

var $5XbDN = parcelRequire("5XbDN");

var $8H969 = parcelRequire("8H969");

var $9eehA = parcelRequire("9eehA");

var $6AeQE = parcelRequire("6AeQE");

var $4iUgP = parcelRequire("4iUgP");

var $2xBCC = parcelRequire("2xBCC");

var $jD5Wy = parcelRequire("jD5Wy");

var $iOLvt = parcelRequire("iOLvt");

var $1prVa = parcelRequire("1prVa");

var $aw1du = parcelRequire("aw1du");

var $eXK3g = parcelRequire("eXK3g");

var $cWD63 = parcelRequire("cWD63");

var $jxWDh = parcelRequire("jxWDh");

var $397Q6 = parcelRequire("397Q6");

var $81g6h = parcelRequire("81g6h");

var $iIujE = parcelRequire("iIujE");
var $684cfc9ccf3ece4f$export$91d18c1203db8cb5;
(function(ModalId) {
    ModalId["AddPatient"] = "pendingPatient";
    ModalId["AddSurvey"] = "addSurvey";
    ModalId["ExerciseDetails"] = "exerciseDetails";
    ModalId["MobileAlternativeExercise"] = "mobileAlternativeExercise";
    ModalId["StartProgram"] = "startProgram";
    ModalId["StopProgram"] = "stopProgram";
    ModalId["DeleteProgram"] = "deleteProgram";
    ModalId["RenameProgram"] = "renameProgram";
    ModalId["ScheduleProgram"] = "scheduleProgram";
    ModalId["ProgramBuilderActions"] = "programBuilderActions";
    ModalId["DuplicateAsTemplateProgram"] = "duplicateAsTemplateProgram";
    ModalId["ExertionDetails"] = "exertionDetails";
    ModalId["MoodDetails"] = "moodDetails";
    ModalId["TemplateName"] = "templateName";
    ModalId["DeleteTemplate"] = "deleteTemplate";
    ModalId["TemplateListing"] = "templateListing";
    ModalId["AssignTemplate"] = "assignTemplate";
    ModalId["CancelPatientInvitation"] = "deletePatient";
    ModalId["EditPatientInfo"] = "editPatientInfo";
    ModalId["AboutPhysiome"] = "aboutPhysiome";
    ModalId["HealthcareTeamAccept"] = "healthcareTeamAccept";
    ModalId["DuplicateDayColumn"] = "duplicateDayColumn";
    ModalId["MarkAllNotificationsAsRead"] = "markAllNotificationsAsRead";
    ModalId["EditProfessionalInformation"] = "editProfessionalInformation";
    ModalId["EditPassword"] = "editPassword";
    ModalId["EditUserLocale"] = "editSupportedLocale";
    ModalId["VideoTutorial"] = "videoTutorial";
    ModalId["Announcement"] = "announcement";
    ModalId["MobileExerciseLibrary"] = "mobileExerciseLibrary";
    ModalId["HealthcareTeamInvite"] = "healthcareTeamInvite";
    ModalId["HealthcareTeamUnregisteredInvite"] = "healthcareTeamUnregisteredInvite";
    ModalId["HealthcareTeamLeave"] = "healthcareTeamLeave";
    ModalId["SaveChanges"] = "saveChanges";
    ModalId["ConfirmDuplication"] = "confirmDuplication";
    ModalId["GetStartedCompleted"] = "getStartedCompleted";
    ModalId["ExerciseFilters"] = "exerciseFilters";
})($684cfc9ccf3ece4f$export$91d18c1203db8cb5 || ($684cfc9ccf3ece4f$export$91d18c1203db8cb5 = {}));
const $684cfc9ccf3ece4f$var$ModalIdComponents = {
    ["pendingPatient"]: (0, $eiBvZ.AddPatientDialog),
    ["exerciseDetails"]: (0, $2zGye.ExerciseDetailsDialog),
    ["mobileAlternativeExercise"]: (0, $2rZVV.MobileAlternativeExerciseDialog),
    ["startProgram"]: (0, $9eehA.StartProgramDialog),
    ["stopProgram"]: (0, $6AeQE.StopProgramDialog),
    ["deleteProgram"]: (0, $74GM7.DeleteProgramDialog),
    ["renameProgram"]: (0, $cxZ7L.RenameProgramDialog),
    ["scheduleProgram"]: (0, $8H969.ScheduleProgramDialog),
    ["programBuilderActions"]: (0, $2xBCC.ProgramBuilderActionsDialog),
    ["duplicateAsTemplateProgram"]: (0, $dHcUB.DuplicateAsTemplateDialog),
    ["exertionDetails"]: (0, $ajWZo.ExertionDetailsDialog),
    ["moodDetails"]: (0, $5jB8I.MoodDetailsDialog),
    ["templateName"]: (0, $cWD63.TemplateNameDialog),
    ["deleteTemplate"]: (0, $eXK3g.DeleteTemplateDialog),
    ["templateListing"]: (0, $4BN49.TemplateListingDialog),
    ["assignTemplate"]: (0, $aw1du.AssignTemplateDialog),
    ["deletePatient"]: (0, $cg4YL.CancelPatientInvitationDialog),
    ["editPatientInfo"]: (0, $9ijS8.EditPatientInfoDialog),
    ["aboutPhysiome"]: (0, $i7mGO.AboutPhysiomeDialog),
    ["healthcareTeamAccept"]: (0, $9rH2X.HealthcareTeamAcceptDialog),
    ["duplicateDayColumn"]: (0, $5e5pP.DuplicateDayColumnDialog),
    ["markAllNotificationsAsRead"]: (0, $g6npC.MarkAllNotificationsAsReadDialog),
    ["editProfessionalInformation"]: (0, $1prVa.EditProfessionalInformationDialog),
    ["editPassword"]: (0, $iOLvt.EditPasswordDialog),
    ["editSupportedLocale"]: (0, $iIujE.EditUserLocaleDialog),
    ["announcement"]: (0, $l7dWZ.AnnouncementDialog),
    ["videoTutorial"]: (0, $IR0l7.TutorialDialog),
    ["mobileExerciseLibrary"]: (0, $jD5Wy.MobileExerciseLibraryDialog),
    ["healthcareTeamInvite"]: (0, $8dSEo.HealthcareTeamInviteDialog),
    ["healthcareTeamUnregisteredInvite"]: (0, $cf3Fx.InviteUnregisteredPtDialog),
    ["healthcareTeamLeave"]: (0, $loq6i.HealthcareTeamLeaveDialog),
    ["saveChanges"]: (0, $5XbDN.SaveChangesDialog),
    ["confirmDuplication"]: (0, $4iUgP.ConfirmDuplicationDialog),
    ["addSurvey"]: (0, $hcxj3.AddSurveyDialog),
    ["getStartedCompleted"]: (0, $jxWDh.GetStartedCompletedDialog),
    ["exerciseFilters"]: (0, $397Q6.ExerciseFiltersDialog)
};
const $684cfc9ccf3ece4f$export$8b93a07348a7730c = /*#__PURE__*/ (0, $81g6h.createContext)(null);
const $684cfc9ccf3ece4f$var$filterVisibleDialogs = (currentStack)=>currentStack.filter((state)=>state.visible);
const $684cfc9ccf3ece4f$export$7ab5cfe96fae86d3 = ({ children: children })=>{
    const [dialogStack, setDialogStack] = (0, $81g6h.useState)([]);
    const scheduleDialogCleanup = (0, $81g6h.useCallback)(()=>{
        setTimeout(()=>{
            setDialogStack($684cfc9ccf3ece4f$var$filterVisibleDialogs);
        }, 100);
    }, []);
    const closeDialogStackUpdater = (0, $81g6h.useCallback)((id)=>(currentStack)=>{
            const index = currentStack.findIndex((state)=>state.id === id);
            if (index === -1) return currentStack;
            const newStack = [
                ...currentStack
            ];
            newStack[index].visible = false;
            (0, $jJxkW.sendAnalyticsEventCloseModal)(id);
            return newStack;
        }, []);
    const openModal = (0, $81g6h.useCallback)((id, ...props)=>{
        setDialogStack((currentStack)=>{
            const index = currentStack.findIndex((state)=>state.id === id);
            if (index !== -1) {
                const existing = currentStack[index];
                if (existing.visible) return currentStack;
                const newStack = [
                    ...currentStack
                ];
                newStack[index] = {
                    ...existing,
                    visible: true,
                    props: props[0] ?? existing.props
                };
                (0, $jJxkW.sendAnalyticsEventOpenModal)(id);
                return newStack;
            }
            (0, $jJxkW.sendAnalyticsEventOpenModal)(id);
            return [
                ...currentStack,
                {
                    id: id,
                    visible: true,
                    props: props[0] ?? {}
                }
            ];
        });
    }, []);
    const closeModal = (0, $81g6h.useCallback)((id)=>{
        if (dialogStack.length === 0) return;
        setDialogStack(closeDialogStackUpdater(id));
        scheduleDialogCleanup();
    }, [
        closeDialogStackUpdater,
        dialogStack.length,
        scheduleDialogCleanup
    ]);
    const closeAll = (0, $81g6h.useCallback)(()=>{
        dialogStack.forEach((state)=>closeModal(state.id));
        setDialogStack([]);
    }, [
        closeModal,
        dialogStack
    ]);
    const renderModal = (0, $81g6h.useCallback)((state)=>{
        const { id: id, props: props, visible: visible } = state;
        const commonProps = {
            onHide: ()=>closeModal(state.id),
            ...props,
            visible: visible
        };
        const ModalIdComponent = $684cfc9ccf3ece4f$var$ModalIdComponents[id];
        return /*#__PURE__*/ (0, $iKObn.jsx)(ModalIdComponent, {
            ...commonProps
        }, state.id);
    }, [
        closeModal
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useMemo(()=>({
            openModal: openModal,
            closeAll: closeAll
        }), [
        openModal,
        closeAll
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($684cfc9ccf3ece4f$export$8b93a07348a7730c.Provider, {
        value: contextValue,
        children: [
            children,
            dialogStack.map(renderModal)
        ]
    });
};

});
parcelRegister("jJxkW", function(module, exports) {

$parcel$export(module.exports, "sendAnalyticsEventOpenModal", () => $513f47dc52c8aed2$export$b5bc91987b90defc);
$parcel$export(module.exports, "sendAnalyticsEventCloseModal", () => $513f47dc52c8aed2$export$2d134d151c6dddec);

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");
const $513f47dc52c8aed2$export$b5bc91987b90defc = (modalId)=>{
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).MODAL,
        action: "openModal",
        params: [
            modalId
        ]
    });
};
const $513f47dc52c8aed2$export$2d134d151c6dddec = (modalId)=>{
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).MODAL,
        action: "closeModal",
        params: [
            modalId
        ]
    });
};

});

parcelRegister("IR0l7", function(module, exports) {

$parcel$export(module.exports, "TutorialDialog", () => $6eec41b104f077d4$export$9080f8affd01f933);

var $iKObn = parcelRequire("iKObn");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5lYAo = parcelRequire("5lYAo");

var $5kXMA = parcelRequire("5kXMA");

var $b7G8f = parcelRequire("b7G8f");

var $kKnoQ = parcelRequire("kKnoQ");

var $9AWgp = parcelRequire("9AWgp");

var $j19eN = parcelRequire("j19eN");

var $81g6h = parcelRequire("81g6h");
const $6eec41b104f077d4$export$9080f8affd01f933 = (props)=>{
    const { tutorial: tutorial, tutorialType: tutorialType, onHide: onHide, ...otherProps } = props;
    const videoRef = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(null);
    const { openFullScreen: openFullScreen } = (0, $b7G8f.useVideo)();
    const { isMobile: isMobile } = (0, $5kXMA.useDimensions)();
    (0, $81g6h.useEffect)(()=>{
        if (isMobile) openFullScreen();
    }, [
        isMobile,
        openFullScreen
    ]);
    const onClose = ()=>{
        const percentage = videoRef.current ? Math.round(videoRef.current.currentTime * 100 / videoRef.current.duration) : -1;
        (0, $ghfIB.analyticsService).trackEvent({
            category: (0, $auPqo.AnalyticsCategory).TUTORIAL,
            action: "videoread",
            params: [
                tutorialType,
                percentage
            ]
        });
        onHide();
    };
    return /*#__PURE__*/ (0, $iKObn.jsxs)($6eec41b104f077d4$var$StyledDialog, {
        draggable: false,
        resizable: false,
        onHide: onHide,
        dismissableMask: true,
        ...otherProps,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($6eec41b104f077d4$var$CloseButton, {
                className: "p-button-text p-button-rounded ui-button-flat",
                icon: "pi pi-times",
                color: (0, $kKnoQ.colors).white,
                onClick: onClose
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $5lYAo.VideoPlayer), {
                ref: videoRef,
                url: tutorial.videoUrl,
                autoPlay: true,
                controls: true,
                style: {
                    borderRadius: 0
                }
            })
        ]
    });
};
const $6eec41b104f077d4$var$StyledDialog = (0, $5UMQ1.default)((0, $j19eN.Dialog))`
	width: 684px;
	border-radius: 0;

	.p-dialog-header {
		padding: 0;
		overflow: hidden;

		.p-dialog-header-icons {
			position: absolute;
		}
	}

	.p-dialog-content {
		padding: 0;
		border-radius: 1rem;
	}
`;
const $6eec41b104f077d4$var$CloseButton = (0, $5UMQ1.default)((0, $9AWgp.Button))`
	position: absolute;
	z-index: 10;
	top: 0;
	right: 0;
	margin: 12px 8px;

	.p-button-icon {
		color: ${(0, $kKnoQ.colors).black};
	}
`;

});
parcelRegister("5lYAo", function(module, exports) {

$parcel$export(module.exports, "VideoPlayer", () => $cae9fea72027084d$export$f503bc85d719e8b0);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $1IlhR = parcelRequire("1IlhR");

var $b7G8f = parcelRequire("b7G8f");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");
const $cae9fea72027084d$export$f503bc85d719e8b0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ title: title, url: url, displayVideoGradient: displayVideoGradient = true, ...videoProps }, ref)=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const [error, setError] = (0, $81g6h.useState)(false);
    const [isLoading, setIsLoading] = (0, $81g6h.useState)(true);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($cae9fea72027084d$var$VideoWrapper, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($cae9fea72027084d$var$Title, {
                className: "p-size-l-bold",
                children: title
            }),
            error ? /*#__PURE__*/ (0, $iKObn.jsxs)($cae9fea72027084d$var$EmptyContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($cae9fea72027084d$var$ErrorText, {
                        className: "p-size-m",
                        children: format("videoPlayer.error")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.RefreshButton), {
                        onClick: ()=>setError(false)
                    })
                ]
            }) : /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    displayVideoGradient && /*#__PURE__*/ (0, $iKObn.jsx)($cae9fea72027084d$var$Gradient, {}),
                    /*#__PURE__*/ (0, $iKObn.jsx)($cae9fea72027084d$var$StyledVideo, {
                        isLoading: isLoading,
                        id: (0, $b7G8f.VIDEO_PLAYER_ID),
                        ref: ref,
                        ...videoProps,
                        onErrorCapture: (e)=>{
                            console.error(e);
                            setError(true);
                        },
                        muted: true,
                        controlsList: "nodownload",
                        onLoadedData: ()=>setIsLoading(false),
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("source", {
                            src: url
                        })
                    }),
                    isLoading && /*#__PURE__*/ (0, $iKObn.jsx)($cae9fea72027084d$var$CenteredContainer, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {})
                    })
                ]
            })
        ]
    });
});
$cae9fea72027084d$export$f503bc85d719e8b0.displayName = "VideoPlayer";
const $cae9fea72027084d$var$VideoWrapper = (0, $5UMQ1.default).div`
	width: 100%;
	position: relative;
	padding-bottom: 56.25%;
`;
const $cae9fea72027084d$var$StyledVideo = (0, $5UMQ1.default).video`
	position: absolute;
	width: 100%;
	height: 100%;
	visibility: ${({ isLoading: isLoading })=>isLoading ? "hidden" : "visible"};
`;
const $cae9fea72027084d$var$CenteredContainer = (0, $5UMQ1.default).div`
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
`;
const $cae9fea72027084d$var$EmptyContainer = (0, $5UMQ1.default).div`
	position: absolute;
	width: 100%;
	height: 100%;
	padding: 32px;
	background-color: ${(0, $kKnoQ.colors).black};

	${(0, $5WGN2.stack)(32, "center", "center")}
`;
const $cae9fea72027084d$var$ErrorText = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).white};
	text-align: center;
`;
const $cae9fea72027084d$var$Title = (0, $5UMQ1.default).div`
	position: absolute;
	top: 32px;
	left: 16px;
	right: 70px;
	color: ${(0, $kKnoQ.colors).black};
	z-index: 20;
	pointer-events: none;
`;
const $cae9fea72027084d$var$Gradient = (0, $5UMQ1.default).div`
	pointer-events: none;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	z-index: 5;
	height: 95px;
	background: linear-gradient(180deg, ${(0, $kKnoQ.colors).videoBackground} 0%, ${(0, $kKnoQ.colors).transparent} 100%);
`;

});
parcelRegister("1IlhR", function(module, exports) {

$parcel$export(module.exports, "LoadingContainer", () => $a07a7c8e9d6c38d8$export$5e3f251c730829);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
const $a07a7c8e9d6c38d8$export$5e3f251c730829 = (props)=>/*#__PURE__*/ (0, $iKObn.jsx)($a07a7c8e9d6c38d8$var$LoadingContent, {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("i", {
            className: "pi pi-spin pi-spinner"
        })
    });
const $a07a7c8e9d6c38d8$var$LoadingContent = (0, $5UMQ1.default).div`
	height: 100px;
	${(0, $5WGN2.stack)(undefined, "center", "center")};

	i {
		font-size: 2rem;
		color: ${(0, $kKnoQ.colors).primary};
	}
`;

});

parcelRegister("b7G8f", function(module, exports) {

$parcel$export(module.exports, "VIDEO_PLAYER_ID", () => $c1e1bcd8c4e3436a$export$57003bf8a219362f);
$parcel$export(module.exports, "useVideo", () => $c1e1bcd8c4e3436a$export$5269023cd97c8c79);

var $81g6h = parcelRequire("81g6h");
const $c1e1bcd8c4e3436a$export$57003bf8a219362f = "videoPlayerId";
const $c1e1bcd8c4e3436a$export$5269023cd97c8c79 = ()=>{
    const openFullScreen = (0, $81g6h.useCallback)(()=>{
        const videoElement = document.getElementById($c1e1bcd8c4e3436a$export$57003bf8a219362f);
        if (videoElement?.requestFullscreen) videoElement.requestFullscreen();
        else if (videoElement?.webkitRequestFullscreen) /* Safari */ videoElement.webkitRequestFullscreen();
        else if (videoElement?.msRequestFullscreen) /* IE11 */ videoElement.msRequestFullscreen();
    }, []);
    return {
        openFullScreen: openFullScreen
    };
};

});


parcelRegister("j19eN", function(module, exports) {

$parcel$export(module.exports, "Dialog", () => $dd8546bf06353be3$export$3ddf2d174ce01153);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $lbdsH = parcelRequire("lbdsH");

var $l2NC0 = parcelRequire("l2NC0");

var $cfkGk = parcelRequire("cfkGk");

var $4vsYR = parcelRequire("4vsYR");

var $8VSKI = parcelRequire("8VSKI");

var $7hQM2 = parcelRequire("7hQM2");

var $6b4aU = parcelRequire("6b4aU");

var $9rbaG = parcelRequire("9rbaG");
"use client";
function $dd8546bf06353be3$var$_extends() {
    $dd8546bf06353be3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dd8546bf06353be3$var$_extends.apply(this, arguments);
}
function $dd8546bf06353be3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dd8546bf06353be3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dd8546bf06353be3$var$_typeof(o);
}
function $dd8546bf06353be3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dd8546bf06353be3$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $dd8546bf06353be3$var$_arrayLikeToArray(arr);
}
function $dd8546bf06353be3$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $dd8546bf06353be3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dd8546bf06353be3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dd8546bf06353be3$var$_arrayLikeToArray(o, minLen);
}
function $dd8546bf06353be3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dd8546bf06353be3$var$_toConsumableArray(arr) {
    return $dd8546bf06353be3$var$_arrayWithoutHoles(arr) || $dd8546bf06353be3$var$_iterableToArray(arr) || $dd8546bf06353be3$var$_unsupportedIterableToArray(arr) || $dd8546bf06353be3$var$_nonIterableSpread();
}
function $dd8546bf06353be3$var$_toPrimitive(input, hint) {
    if ($dd8546bf06353be3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($dd8546bf06353be3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $dd8546bf06353be3$var$_toPropertyKey(arg) {
    var key = $dd8546bf06353be3$var$_toPrimitive(arg, "string");
    return $dd8546bf06353be3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $dd8546bf06353be3$var$_defineProperty(obj, key, value) {
    key = $dd8546bf06353be3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dd8546bf06353be3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $dd8546bf06353be3$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $dd8546bf06353be3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dd8546bf06353be3$var$_slicedToArray(arr, i) {
    return $dd8546bf06353be3$var$_arrayWithHoles(arr) || $dd8546bf06353be3$var$_iterableToArrayLimit(arr, i) || $dd8546bf06353be3$var$_unsupportedIterableToArray(arr, i) || $dd8546bf06353be3$var$_nonIterableRest();
}
var $dd8546bf06353be3$var$styles$1 = "";
var $dd8546bf06353be3$var$FocusTrapBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "FocusTrap",
        children: undefined
    },
    css: {
        styles: $dd8546bf06353be3$var$styles$1
    },
    getProps: function getProps(props) {
        return (0, $cfkGk.ObjectUtils).getMergedProps(props, $dd8546bf06353be3$var$FocusTrapBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $cfkGk.ObjectUtils).getDiffProps(props, $dd8546bf06353be3$var$FocusTrapBase.defaultProps);
    }
});
function $dd8546bf06353be3$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dd8546bf06353be3$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dd8546bf06353be3$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $dd8546bf06353be3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dd8546bf06353be3$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dd8546bf06353be3$var$FocusTrap = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(function(inProps, ref) {
    var targetRef = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(null);
    var firstFocusableElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(null);
    var lastFocusableElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(null);
    var context = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useContext((0, $8Zwsm.PrimeReactContext));
    var props = $dd8546bf06353be3$var$FocusTrapBase.getProps(inProps, context);
    var metaData = {
        props: props
    };
    (0, $l2NC0.useStyle)($dd8546bf06353be3$var$FocusTrapBase.css.styles, {
        name: "focustrap"
    });
    var _FocusTrapBase$setMet = $dd8546bf06353be3$var$FocusTrapBase.setMetaData($dd8546bf06353be3$var$_objectSpread$2({}, metaData));
    _FocusTrapBase$setMet.ptm;
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useImperativeHandle(ref, function() {
        return {
            props: props,
            getInk: function getInk() {
                return firstFocusableElementRef.current;
            },
            getTarget: function getTarget() {
                return targetRef.current;
            }
        };
    });
    (0, $l2NC0.useMountEffect)(function() {
        if (!props.disabled) {
            targetRef.current = getTarget();
            setAutoFocus(targetRef.current);
        }
    });
    var getTarget = function getTarget() {
        return firstFocusableElementRef.current && firstFocusableElementRef.current.parentElement;
    };
    /**
   * This method sets the auto focus on the first focusable element within the target element.
   * It first tries to find a focusable element using the autoFocusSelector. If no such element is found,
   * it then tries to find a focusable element using the firstFocusableSelector.
   * If the autoFocus prop is set to true and a focusable element is found, it sets the focus on that element.
   *
   * @param {HTMLElement} target - The target element within which to find a focusable element.
   */ var setAutoFocus = function setAutoFocus(target) {
        var _ref = props || {}, _ref$autoFocusSelecto = _ref.autoFocusSelector, autoFocusSelector = _ref$autoFocusSelecto === void 0 ? "" : _ref$autoFocusSelecto, _ref$firstFocusableSe = _ref.firstFocusableSelector, firstFocusableSelector = _ref$firstFocusableSe === void 0 ? "" : _ref$firstFocusableSe, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus;
        var defaultAutoFocusSelector = "".concat(getComputedSelector(autoFocusSelector));
        var computedAutoFocusSelector = "[autofocus]".concat(defaultAutoFocusSelector, ", [data-pc-autofocus='true']").concat(defaultAutoFocusSelector);
        var focusableElement = (0, $cfkGk.DomHandler).getFirstFocusableElement(target, computedAutoFocusSelector);
        autoFocus && !focusableElement && (focusableElement = (0, $cfkGk.DomHandler).getFirstFocusableElement(target, getComputedSelector(firstFocusableSelector)));
        (0, $cfkGk.DomHandler).focus(focusableElement);
    };
    var getComputedSelector = function getComputedSelector(selector) {
        return ':not(.p-hidden-focusable):not([data-p-hidden-focusable="true"])'.concat(selector !== null && selector !== void 0 ? selector : "");
    };
    var onFirstHiddenElementFocus = function onFirstHiddenElementFocus(event) {
        var _targetRef$current;
        var currentTarget = event.currentTarget, relatedTarget = event.relatedTarget;
        var focusableElement = relatedTarget === currentTarget.$_pfocustrap_lasthiddenfocusableelement || !((_targetRef$current = targetRef.current) !== null && _targetRef$current !== void 0 && _targetRef$current.contains(relatedTarget)) ? (0, $cfkGk.DomHandler).getFirstFocusableElement(currentTarget.parentElement, getComputedSelector(currentTarget.$_pfocustrap_focusableselector)) : currentTarget.$_pfocustrap_lasthiddenfocusableelement;
        (0, $cfkGk.DomHandler).focus(focusableElement);
    };
    var onLastHiddenElementFocus = function onLastHiddenElementFocus(event) {
        var _targetRef$current2;
        var currentTarget = event.currentTarget, relatedTarget = event.relatedTarget;
        var focusableElement = relatedTarget === currentTarget.$_pfocustrap_firsthiddenfocusableelement || !((_targetRef$current2 = targetRef.current) !== null && _targetRef$current2 !== void 0 && _targetRef$current2.contains(relatedTarget)) ? (0, $cfkGk.DomHandler).getLastFocusableElement(currentTarget.parentElement, getComputedSelector(currentTarget.$_pfocustrap_focusableselector)) : currentTarget.$_pfocustrap_firsthiddenfocusableelement;
        (0, $cfkGk.DomHandler).focus(focusableElement);
    };
    var createHiddenFocusableElements = function createHiddenFocusableElements() {
        var _ref2 = props || {}, _ref2$tabIndex = _ref2.tabIndex, tabIndex = _ref2$tabIndex === void 0 ? 0 : _ref2$tabIndex;
        var createFocusableElement = function createFocusableElement(onFocus, section) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("span", {
                ref: section === "firstfocusableelement" ? firstFocusableElementRef : lastFocusableElementRef,
                className: "p-hidden-accessible p-hidden-focusable",
                tabIndex: tabIndex,
                role: "presentation",
                "aria-hidden": true,
                "data-p-hidden-accessible": true,
                "data-p-hidden-focusable": true,
                onFocus: onFocus,
                "data-pc-section": section
            });
        };
        var firstFocusableElement = createFocusableElement(onFirstHiddenElementFocus, "firstfocusableelement");
        var lastFocusableElement = createFocusableElement(onLastHiddenElementFocus, "lastfocusableelement");
        if (firstFocusableElement.ref.current && lastFocusableElement.ref.current) {
            firstFocusableElement.ref.current.$_pfocustrap_lasthiddenfocusableelement = lastFocusableElement.ref.current;
            lastFocusableElement.ref.current.$_pfocustrap_firsthiddenfocusableelement = firstFocusableElement.ref.current;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).Fragment, null, firstFocusableElement, props.children, lastFocusableElement);
    };
    return createHiddenFocusableElements();
}));
var $dd8546bf06353be3$var$FocusTrap$1 = $dd8546bf06353be3$var$FocusTrap;
function $dd8546bf06353be3$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dd8546bf06353be3$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dd8546bf06353be3$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $dd8546bf06353be3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dd8546bf06353be3$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dd8546bf06353be3$var$classes = {
    closeButtonIcon: "p-dialog-header-close-icon",
    closeButton: "p-dialog-header-icon p-dialog-header-close p-link",
    maximizableIcon: "p-dialog-header-maximize-icon",
    maximizableButton: "p-dialog-header-icon p-dialog-header-maximize p-link",
    header: function header(_ref) {
        var props = _ref.props;
        return (0, $cfkGk.classNames)("p-dialog-header", props.headerClassName);
    },
    headerTitle: "p-dialog-title",
    headerIcons: "p-dialog-header-icons",
    content: function content(_ref2) {
        var props = _ref2.props;
        return (0, $cfkGk.classNames)("p-dialog-content", props.contentClassName);
    },
    footer: function footer(_ref3) {
        var props = _ref3.props;
        return (0, $cfkGk.classNames)("p-dialog-footer", props.footerClassName);
    },
    mask: function mask(_ref4) {
        var props = _ref4.props, maskVisibleState = _ref4.maskVisibleState;
        var positions = [
            "center",
            "left",
            "right",
            "top",
            "top-left",
            "top-right",
            "bottom",
            "bottom-left",
            "bottom-right"
        ];
        var pos = positions.find(function(item) {
            return item === props.position || item.replace("-", "") === props.position;
        });
        return (0, $cfkGk.classNames)("p-dialog-mask", pos ? "p-dialog-".concat(pos) : "", {
            "p-component-overlay p-component-overlay-enter": props.modal,
            "p-dialog-visible": maskVisibleState,
            "p-dialog-draggable": props.draggable,
            "p-dialog-resizable": props.resizable
        }, props.maskClassName);
    },
    root: function root(_ref5) {
        var props = _ref5.props, maximized = _ref5.maximized, context = _ref5.context;
        return (0, $cfkGk.classNames)("p-dialog p-component", {
            "p-dialog-rtl": props.rtl,
            "p-dialog-maximized": maximized,
            "p-dialog-default": !maximized,
            "p-input-filled": context && context.inputStyle === "filled" || (0, $8Zwsm.default).inputStyle === "filled",
            "p-ripple-disabled": context && context.ripple === false || (0, $8Zwsm.default).ripple === false
        });
    },
    transition: "p-dialog"
};
var $dd8546bf06353be3$var$styles = "\n@layer primereact {\n    .p-dialog-mask {\n        background-color: transparent;\n        transition-property: background-color;\n    }\n\n    .p-dialog-visible {\n        display: flex;\n    }\n\n    .p-dialog-mask.p-component-overlay {\n        pointer-events: auto;\n    }\n\n    .p-dialog {\n        display: flex;\n        flex-direction: column;\n        pointer-events: auto;\n        max-height: 90%;\n        transform: scale(1);\n        position: relative;\n    }\n\n    .p-dialog-content {\n        overflow-y: auto;\n        flex-grow: 1;\n    }\n\n    .p-dialog-header {\n        display: flex;\n        align-items: center;\n        flex-shrink: 0;\n    }\n\n    .p-dialog-footer {\n        flex-shrink: 0;\n    }\n\n    .p-dialog .p-dialog-header-icons {\n        display: flex;\n        align-items: center;\n        align-self: flex-start;\n        flex-shrink: 0;\n    }\n\n    .p-dialog .p-dialog-header-icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .p-dialog .p-dialog-title {\n        flex-grow: 1;\n    }\n\n    /* Fluid */\n    .p-fluid .p-dialog-footer .p-button {\n        width: auto;\n    }\n\n    /* Animation */\n    /* Center */\n    .p-dialog-enter {\n        opacity: 0;\n        transform: scale(0.7);\n    }\n\n    .p-dialog-enter-active {\n        opacity: 1;\n        transform: scale(1);\n        transition: all 150ms cubic-bezier(0, 0, 0.2, 1);\n    }\n\n    .p-dialog-enter-done {\n        transform: none;\n    }\n\n    .p-dialog-exit-active {\n        opacity: 0;\n        transform: scale(0.7);\n        transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);\n    }\n\n    /* Top, Bottom, Left, Right, Top* and Bottom* */\n    .p-dialog-top .p-dialog,\n    .p-dialog-bottom .p-dialog,\n    .p-dialog-left .p-dialog,\n    .p-dialog-right .p-dialog,\n    .p-dialog-top-left .p-dialog,\n    .p-dialog-top-right .p-dialog,\n    .p-dialog-bottom-left .p-dialog,\n    .p-dialog-bottom-right .p-dialog {\n        margin: 0.75em;\n    }\n\n    .p-dialog-top .p-dialog-enter,\n    .p-dialog-top .p-dialog-exit-active {\n        transform: translate3d(0px, -100%, 0px);\n    }\n\n    .p-dialog-bottom .p-dialog-enter,\n    .p-dialog-bottom .p-dialog-exit-active {\n        transform: translate3d(0px, 100%, 0px);\n    }\n\n    .p-dialog-left .p-dialog-enter,\n    .p-dialog-left .p-dialog-exit-active,\n    .p-dialog-top-left .p-dialog-enter,\n    .p-dialog-top-left .p-dialog-exit-active,\n    .p-dialog-bottom-left .p-dialog-enter,\n    .p-dialog-bottom-left .p-dialog-exit-active {\n        transform: translate3d(-100%, 0px, 0px);\n    }\n\n    .p-dialog-right .p-dialog-enter,\n    .p-dialog-right .p-dialog-exit-active,\n    .p-dialog-top-right .p-dialog-enter,\n    .p-dialog-top-right .p-dialog-exit-active,\n    .p-dialog-bottom-right .p-dialog-enter,\n    .p-dialog-bottom-right .p-dialog-exit-active {\n        transform: translate3d(100%, 0px, 0px);\n    }\n\n    .p-dialog-top .p-dialog-enter-active,\n    .p-dialog-bottom .p-dialog-enter-active,\n    .p-dialog-left .p-dialog-enter-active,\n    .p-dialog-top-left .p-dialog-enter-active,\n    .p-dialog-bottom-left .p-dialog-enter-active,\n    .p-dialog-right .p-dialog-enter-active,\n    .p-dialog-top-right .p-dialog-enter-active,\n    .p-dialog-bottom-right .p-dialog-enter-active {\n        transform: translate3d(0px, 0px, 0px);\n        transition: all 0.3s ease-out;\n    }\n\n    .p-dialog-top .p-dialog-exit-active,\n    .p-dialog-bottom .p-dialog-exit-active,\n    .p-dialog-left .p-dialog-exit-active,\n    .p-dialog-top-left .p-dialog-exit-active,\n    .p-dialog-bottom-left .p-dialog-exit-active,\n    .p-dialog-right .p-dialog-exit-active,\n    .p-dialog-top-right .p-dialog-exit-active,\n    .p-dialog-bottom-right .p-dialog-exit-active {\n        transition: all 0.3s ease-out;\n    }\n\n    /* Maximize */\n    .p-dialog-maximized {\n        transition: none;\n        transform: none;\n        margin: 0;\n        width: 100vw !important;\n        height: 100vh !important;\n        max-height: 100%;\n        top: 0px !important;\n        left: 0px !important;\n    }\n\n    .p-dialog-maximized .p-dialog-content {\n        flex-grow: 1;\n    }\n\n    .p-confirm-dialog .p-dialog-content {\n        display: flex;\n        align-items: center;\n    }\n\n    /* Resizable */\n    .p-dialog .p-resizable-handle {\n        position: absolute;\n        font-size: 0.1px;\n        display: block;\n        cursor: se-resize;\n        width: 12px;\n        height: 12px;\n        right: 1px;\n        bottom: 1px;\n    }\n\n    .p-dialog-draggable .p-dialog-header {\n        cursor: move;\n    }\n}\n";
var $dd8546bf06353be3$var$inlineStyles = {
    mask: function mask(_ref6) {
        var props = _ref6.props;
        return $dd8546bf06353be3$var$_objectSpread$1({
            position: "fixed",
            height: "100%",
            width: "100%",
            left: 0,
            top: 0,
            display: "flex",
            justifyContent: props.position === "left" || props.position === "top-left" || props.position === "bottom-left" ? "flex-start" : props.position === "right" || props.position === "top-right" || props.position === "bottom-right" ? "flex-end" : "center",
            alignItems: props.position === "top" || props.position === "top-left" || props.position === "top-right" ? "flex-start" : props.position === "bottom" || props.position === "bottom-left" || props.position === "bottom-right" ? "flex-end" : "center",
            pointerEvents: !props.modal && "none"
        }, props.maskStyle);
    }
};
var $dd8546bf06353be3$var$DialogBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Dialog",
        __parentMetadata: null,
        appendTo: null,
        ariaCloseIconLabel: null,
        baseZIndex: 0,
        blockScroll: false,
        breakpoints: null,
        className: null,
        closable: true,
        closeIcon: null,
        closeOnEscape: true,
        content: null,
        contentClassName: null,
        contentStyle: null,
        dismissableMask: false,
        draggable: true,
        focusOnShow: true,
        footer: null,
        footerClassName: null,
        header: null,
        headerClassName: null,
        headerStyle: null,
        icons: null,
        id: null,
        keepInViewport: true,
        maskClassName: null,
        maskStyle: null,
        maximizable: false,
        maximizeIcon: null,
        maximized: false,
        minX: 0,
        minY: 0,
        minimizeIcon: null,
        modal: true,
        onClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragStart: null,
        onHide: null,
        onMaskClick: null,
        onMaximize: null,
        onResize: null,
        onResizeEnd: null,
        onResizeStart: null,
        onShow: null,
        position: "center",
        resizable: true,
        rtl: false,
        showHeader: true,
        style: null,
        transitionOptions: null,
        visible: false,
        children: undefined
    },
    css: {
        classes: $dd8546bf06353be3$var$classes,
        styles: $dd8546bf06353be3$var$styles,
        inlineStyles: $dd8546bf06353be3$var$inlineStyles
    }
});
function $dd8546bf06353be3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dd8546bf06353be3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dd8546bf06353be3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dd8546bf06353be3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dd8546bf06353be3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dd8546bf06353be3$export$3ddf2d174ce01153 = /*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $dd8546bf06353be3$var$DialogBase.getProps(inProps, context);
    var uniqueId = props.id ? props.id : (0, $cfkGk.UniqueComponentId)();
    var _React$useState = $81g6h.useState(uniqueId), _React$useState2 = $dd8546bf06353be3$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0];
    _React$useState2[1];
    var _React$useState3 = $81g6h.useState(false), _React$useState4 = $dd8546bf06353be3$var$_slicedToArray(_React$useState3, 2), maskVisibleState = _React$useState4[0], setMaskVisibleState = _React$useState4[1];
    var _React$useState5 = $81g6h.useState(false), _React$useState6 = $dd8546bf06353be3$var$_slicedToArray(_React$useState5, 2), visibleState = _React$useState6[0], setVisibleState = _React$useState6[1];
    var _React$useState7 = $81g6h.useState(props.maximized), _React$useState8 = $dd8546bf06353be3$var$_slicedToArray(_React$useState7, 2), maximizedState = _React$useState8[0], setMaximizedState = _React$useState8[1];
    var dialogRef = $81g6h.useRef(null);
    var maskRef = $81g6h.useRef(null);
    var pointerRef = $81g6h.useRef(null);
    var contentRef = $81g6h.useRef(null);
    var headerRef = $81g6h.useRef(null);
    var footerRef = $81g6h.useRef(null);
    var closeRef = $81g6h.useRef(null);
    var dragging = $81g6h.useRef(false);
    var resizing = $81g6h.useRef(false);
    var lastPageX = $81g6h.useRef(null);
    var lastPageY = $81g6h.useRef(null);
    var styleElement = $81g6h.useRef(null);
    var attributeSelector = $81g6h.useRef(uniqueId);
    var focusElementOnHide = $81g6h.useRef(null);
    var maximized = props.onMaximize ? props.maximized : maximizedState;
    var shouldBlockScroll = visibleState && (props.blockScroll || props.maximizable && maximized);
    var isCloseOnEscape = props.closable && props.closeOnEscape && visibleState;
    var displayOrder = (0, $l2NC0.useDisplayOrder)("dialog", isCloseOnEscape);
    var _DialogBase$setMetaDa = $dd8546bf06353be3$var$DialogBase.setMetaData($dd8546bf06353be3$var$_objectSpread($dd8546bf06353be3$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        state: {
            id: idState,
            maximized: maximized,
            containerVisible: maskVisibleState
        }
    })), ptm = _DialogBase$setMetaDa.ptm, cx = _DialogBase$setMetaDa.cx, sx = _DialogBase$setMetaDa.sx, isUnstyled = _DialogBase$setMetaDa.isUnstyled;
    (0, $4gQLd.useHandleStyle)($dd8546bf06353be3$var$DialogBase.css.styles, isUnstyled, {
        name: "dialog"
    });
    (0, $l2NC0.useGlobalOnEscapeKey)({
        callback: function callback(event) {
            onClose(event);
        },
        when: isCloseOnEscape && displayOrder,
        priority: [
            (0, $l2NC0.ESC_KEY_HANDLING_PRIORITIES).DIALOG,
            displayOrder
        ]
    });
    var _useEventListener = (0, $l2NC0.useEventListener)({
        type: "mousemove",
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onResize(event);
        }
    }), _useEventListener2 = $dd8546bf06353be3$var$_slicedToArray(_useEventListener, 2), bindDocumentResizeListener = _useEventListener2[0], unbindDocumentResizeListener = _useEventListener2[1];
    var _useEventListener3 = (0, $l2NC0.useEventListener)({
        type: "mouseup",
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onResizeEnd(event);
        }
    }), _useEventListener4 = $dd8546bf06353be3$var$_slicedToArray(_useEventListener3, 2), bindDocumentResizeEndListener = _useEventListener4[0], unbindDocumentResizEndListener = _useEventListener4[1];
    var _useEventListener5 = (0, $l2NC0.useEventListener)({
        type: "mousemove",
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onDrag(event);
        }
    }), _useEventListener6 = $dd8546bf06353be3$var$_slicedToArray(_useEventListener5, 2), bindDocumentDragListener = _useEventListener6[0], unbindDocumentDragListener = _useEventListener6[1];
    var _useEventListener7 = (0, $l2NC0.useEventListener)({
        type: "mouseup",
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onDragEnd(event);
        }
    }), _useEventListener8 = $dd8546bf06353be3$var$_slicedToArray(_useEventListener7, 2), bindDocumentDragEndListener = _useEventListener8[0], unbindDocumentDragEndListener = _useEventListener8[1];
    var onClose = function onClose(event) {
        props.onHide();
        event.preventDefault();
    };
    var focus = function focus() {
        var activeElement = document.activeElement;
        var isActiveElementInDialog = activeElement && dialogRef.current && dialogRef.current.contains(activeElement);
        if (!isActiveElementInDialog && props.closable && props.showHeader && closeRef.current) closeRef.current.focus();
    };
    var onDialogPointerDown = function onDialogPointerDown(event) {
        pointerRef.current = event.target;
        props.onPointerDown && props.onPointerDown(event);
    };
    var onMaskPointerUp = function onMaskPointerUp(event) {
        if (props.dismissableMask && props.modal && maskRef.current === event.target && !pointerRef.current) onClose(event);
        props.onMaskClick && props.onMaskClick(event);
        pointerRef.current = null;
    };
    var toggleMaximize = function toggleMaximize(event) {
        if (props.onMaximize) props.onMaximize({
            originalEvent: event,
            maximized: !maximized
        });
        else setMaximizedState(function(prevMaximized) {
            return !prevMaximized;
        });
        event.preventDefault();
    };
    var onDragStart = function onDragStart(event) {
        if ((0, $cfkGk.DomHandler).hasClass(event.target, "p-dialog-header-icon") || (0, $cfkGk.DomHandler).hasClass(event.target.parentElement, "p-dialog-header-icon")) return;
        if (props.draggable) {
            dragging.current = true;
            lastPageX.current = event.pageX;
            lastPageY.current = event.pageY;
            dialogRef.current.style.margin = "0";
            (0, $cfkGk.DomHandler).addClass(document.body, "p-unselectable-text");
            props.onDragStart && props.onDragStart(event);
        }
    };
    var onDrag = function onDrag(event) {
        if (dragging.current) {
            var width = (0, $cfkGk.DomHandler).getOuterWidth(dialogRef.current);
            var height = (0, $cfkGk.DomHandler).getOuterHeight(dialogRef.current);
            var deltaX = event.pageX - lastPageX.current;
            var deltaY = event.pageY - lastPageY.current;
            var offset = dialogRef.current.getBoundingClientRect();
            var leftPos = offset.left + deltaX;
            var topPos = offset.top + deltaY;
            var viewport = (0, $cfkGk.DomHandler).getViewport();
            var computedStyle = getComputedStyle(dialogRef.current);
            var leftMargin = parseFloat(computedStyle.marginLeft);
            var topMargin = parseFloat(computedStyle.marginTop);
            dialogRef.current.style.position = "fixed";
            if (props.keepInViewport) {
                if (leftPos >= props.minX && leftPos + width < viewport.width) {
                    lastPageX.current = event.pageX;
                    dialogRef.current.style.left = leftPos - leftMargin + "px";
                }
                if (topPos >= props.minY && topPos + height < viewport.height) {
                    lastPageY.current = event.pageY;
                    dialogRef.current.style.top = topPos - topMargin + "px";
                }
            } else {
                lastPageX.current = event.pageX;
                dialogRef.current.style.left = leftPos - leftMargin + "px";
                lastPageY.current = event.pageY;
                dialogRef.current.style.top = topPos - topMargin + "px";
            }
            props.onDrag && props.onDrag(event);
        }
    };
    var onDragEnd = function onDragEnd(event) {
        if (dragging.current) {
            dragging.current = false;
            (0, $cfkGk.DomHandler).removeClass(document.body, "p-unselectable-text");
            props.onDragEnd && props.onDragEnd(event);
        }
    };
    var onResizeStart = function onResizeStart(event) {
        if (props.resizable) {
            resizing.current = true;
            lastPageX.current = event.pageX;
            lastPageY.current = event.pageY;
            (0, $cfkGk.DomHandler).addClass(document.body, "p-unselectable-text");
            props.onResizeStart && props.onResizeStart(event);
        }
    };
    var convertToPx = function convertToPx(value, property, viewport) {
        !viewport && (viewport = (0, $cfkGk.DomHandler).getViewport());
        var val = parseInt(value);
        if (/^(\d+|(\.\d+))(\.\d+)?%$/.test(value)) return val * (viewport[property] / 100);
        return val;
    };
    var onResize = function onResize(event) {
        if (resizing.current) {
            var deltaX = event.pageX - lastPageX.current;
            var deltaY = event.pageY - lastPageY.current;
            var width = (0, $cfkGk.DomHandler).getOuterWidth(dialogRef.current);
            var height = (0, $cfkGk.DomHandler).getOuterHeight(dialogRef.current);
            var offset = dialogRef.current.getBoundingClientRect();
            var viewport = (0, $cfkGk.DomHandler).getViewport();
            var hasBeenDragged = !parseInt(dialogRef.current.style.top) || !parseInt(dialogRef.current.style.left);
            var minWidth = convertToPx(dialogRef.current.style.minWidth, "width", viewport);
            var minHeight = convertToPx(dialogRef.current.style.minHeight, "height", viewport);
            var newWidth = width + deltaX;
            var newHeight = height + deltaY;
            if (hasBeenDragged) {
                newWidth = newWidth + deltaX;
                newHeight = newHeight + deltaY;
            }
            if ((!minWidth || newWidth > minWidth) && offset.left + newWidth < viewport.width) dialogRef.current.style.width = newWidth + "px";
            if ((!minHeight || newHeight > minHeight) && offset.top + newHeight < viewport.height) dialogRef.current.style.height = newHeight + "px";
            lastPageX.current = event.pageX;
            lastPageY.current = event.pageY;
            props.onResize && props.onResize(event);
        }
    };
    var onResizeEnd = function onResizeEnd(event) {
        if (resizing.current) {
            resizing.current = false;
            (0, $cfkGk.DomHandler).removeClass(document.body, "p-unselectable-text");
            props.onResizeEnd && props.onResizeEnd(event);
        }
    };
    var resetPosition = function resetPosition() {
        dialogRef.current.style.position = "";
        dialogRef.current.style.left = "";
        dialogRef.current.style.top = "";
        dialogRef.current.style.margin = "";
    };
    var onEnter = function onEnter() {
        dialogRef.current.setAttribute(attributeSelector.current, "");
    };
    var onEntered = function onEntered() {
        props.onShow && props.onShow();
        if (props.focusOnShow) focus();
        enableDocumentSettings();
    };
    var onExiting = function onExiting() {
        if (props.modal) !isUnstyled() && (0, $cfkGk.DomHandler).addClass(maskRef.current, "p-component-overlay-leave");
    };
    var onExited = function onExited() {
        dragging.current = false;
        (0, $cfkGk.ZIndexUtils).clear(maskRef.current);
        setMaskVisibleState(false);
        disableDocumentSettings();
        // return focus to element before dialog was open
        (0, $cfkGk.DomHandler).focus(focusElementOnHide.current);
        focusElementOnHide.current = null;
    };
    var enableDocumentSettings = function enableDocumentSettings() {
        bindGlobalListeners();
    };
    var disableDocumentSettings = function disableDocumentSettings() {
        unbindGlobalListeners();
    };
    var updateScrollBlocker = function updateScrollBlocker() {
        // Scroll should be unblocked if there is at least one dialog that blocks scrolling:
        var isThereAnyDialogThatBlocksScrolling = document.primeDialogParams && document.primeDialogParams.some(function(i) {
            return i.hasBlockScroll;
        });
        if (isThereAnyDialogThatBlocksScrolling) (0, $cfkGk.DomHandler).blockBodyScroll();
        else (0, $cfkGk.DomHandler).unblockBodyScroll();
    };
    var updateGlobalDialogsRegistry = function updateGlobalDialogsRegistry(isMounted) {
        // Update current dialog info in global registry if it is mounted and visible:
        if (isMounted && visibleState) {
            var newParam = {
                id: idState,
                hasBlockScroll: shouldBlockScroll
            };
            // Create registry if not yet created:
            if (!document.primeDialogParams) document.primeDialogParams = [];
            var currentDialogIndexInRegistry = document.primeDialogParams.findIndex(function(dialogInRegistry) {
                return dialogInRegistry.id === idState;
            });
            if (currentDialogIndexInRegistry === -1) document.primeDialogParams = [].concat($dd8546bf06353be3$var$_toConsumableArray(document.primeDialogParams), [
                newParam
            ]);
            else document.primeDialogParams = document.primeDialogParams.toSpliced(currentDialogIndexInRegistry, 1, newParam);
        } else document.primeDialogParams = document.primeDialogParams && document.primeDialogParams.filter(function(param) {
            return param.id !== idState;
        });
        // Always update scroll blocker after dialog registry - this way we ensure that
        // p-overflow-hidden class is properly added/removed:
        updateScrollBlocker();
    };
    var bindGlobalListeners = function bindGlobalListeners() {
        if (props.draggable) {
            bindDocumentDragListener();
            bindDocumentDragEndListener();
        }
        if (props.resizable) {
            bindDocumentResizeListener();
            bindDocumentResizeEndListener();
        }
    };
    var unbindGlobalListeners = function unbindGlobalListeners() {
        unbindDocumentDragListener();
        unbindDocumentDragEndListener();
        unbindDocumentResizeListener();
        unbindDocumentResizEndListener();
    };
    var createStyle = function createStyle() {
        styleElement.current = (0, $cfkGk.DomHandler).createInlineStyle(context && context.nonce || (0, $8Zwsm.default).nonce, context && context.styleContainer);
        var innerHTML = "";
        for(var breakpoint in props.breakpoints)innerHTML = innerHTML + "\n                @media screen and (max-width: ".concat(breakpoint, ') {\n                     [data-pc-name="dialog"][').concat(attributeSelector.current, "] {\n                        width: ").concat(props.breakpoints[breakpoint], " !important;\n                    }\n                }\n            ");
        styleElement.current.innerHTML = innerHTML;
    };
    var destroyStyle = function destroyStyle() {
        styleElement.current = (0, $cfkGk.DomHandler).removeInlineStyle(styleElement.current);
    };
    (0, $l2NC0.useMountEffect)(function() {
        updateGlobalDialogsRegistry(true);
        if (props.visible) setMaskVisibleState(true);
    });
    $81g6h.useEffect(function() {
        if (props.breakpoints) createStyle();
        return function() {
            destroyStyle();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.breakpoints
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (props.visible && !maskVisibleState) setMaskVisibleState(true);
        if (props.visible !== visibleState && maskVisibleState) setVisibleState(props.visible);
        if (props.visible) // Remember the focused element before we opened the dialog
        // so we can return focus to it once we close the dialog.
        focusElementOnHide.current = document.activeElement;
    }, [
        props.visible,
        maskVisibleState
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (maskVisibleState) {
            (0, $cfkGk.ZIndexUtils).set("modal", maskRef.current, context && context.autoZIndex || (0, $8Zwsm.default).autoZIndex, props.baseZIndex || context && context.zIndex.modal || (0, $8Zwsm.default).zIndex.modal);
            setVisibleState(true);
        }
    }, [
        maskVisibleState
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        updateGlobalDialogsRegistry(true);
    }, [
        shouldBlockScroll,
        visibleState
    ]);
    (0, $l2NC0.useUnmountEffect)(function() {
        disableDocumentSettings();
        updateGlobalDialogsRegistry(false);
        (0, $cfkGk.DomHandler).removeInlineStyle(styleElement.current);
        (0, $cfkGk.ZIndexUtils).clear(maskRef.current);
    });
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            resetPosition: resetPosition,
            getElement: function getElement() {
                return dialogRef.current;
            },
            getMask: function getMask() {
                return maskRef.current;
            },
            getContent: function getContent() {
                return contentRef.current;
            },
            getHeader: function getHeader() {
                return headerRef.current;
            },
            getFooter: function getFooter() {
                return footerRef.current;
            },
            getCloseButton: function getCloseButton() {
                return closeRef.current;
            }
        };
    });
    var createCloseIcon = function createCloseIcon() {
        if (props.closable) {
            var ariaLabel = props.ariaCloseIconLabel || (0, $8Zwsm.localeOption)("close");
            var closeButtonIconProps = mergeProps({
                className: cx("closeButtonIcon"),
                "aria-hidden": true
            }, ptm("closeButtonIcon"));
            var icon = props.closeIcon || /*#__PURE__*/ $81g6h.createElement((0, $4vsYR.TimesIcon), closeButtonIconProps);
            var headerCloseIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $dd8546bf06353be3$var$_objectSpread({}, closeButtonIconProps), {
                props: props
            });
            var closeButtonProps = mergeProps({
                ref: closeRef,
                type: "button",
                className: cx("closeButton"),
                "aria-label": ariaLabel,
                onClick: onClose,
                onKeyDown: function onKeyDown(ev) {
                    if (ev.key !== "Escape") ev.stopPropagation();
                }
            }, ptm("closeButton"));
            return /*#__PURE__*/ $81g6h.createElement("button", closeButtonProps, headerCloseIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
        }
        return null;
    };
    var createMaximizeIcon = function createMaximizeIcon() {
        var icon;
        var maximizableIconProps = mergeProps({
            className: cx("maximizableIcon")
        }, ptm("maximizableIcon"));
        if (!maximized) icon = props.maximizeIcon || /*#__PURE__*/ $81g6h.createElement((0, $8VSKI.WindowMaximizeIcon), maximizableIconProps);
        else icon = props.minimizeIcon || /*#__PURE__*/ $81g6h.createElement((0, $7hQM2.WindowMinimizeIcon), maximizableIconProps);
        var toggleIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, maximizableIconProps, {
            props: props
        });
        if (props.maximizable) {
            var maximizableButtonProps = mergeProps({
                type: "button",
                className: cx("maximizableButton"),
                onClick: toggleMaximize
            }, ptm("maximizableButton"));
            return /*#__PURE__*/ $81g6h.createElement("button", maximizableButtonProps, toggleIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
        }
        return null;
    };
    var createHeader = function createHeader() {
        if (props.showHeader) {
            var closeIcon = createCloseIcon();
            var maximizeIcon = createMaximizeIcon();
            var icons = (0, $cfkGk.ObjectUtils).getJSXElement(props.icons, props);
            var header = (0, $cfkGk.ObjectUtils).getJSXElement(props.header, props);
            var headerId = idState + "_header";
            var headerProps = mergeProps({
                ref: headerRef,
                style: props.headerStyle,
                className: cx("header"),
                onMouseDown: onDragStart
            }, ptm("header"));
            var headerTitleProps = mergeProps({
                id: headerId,
                className: cx("headerTitle")
            }, ptm("headerTitle"));
            var headerIconsProps = mergeProps({
                className: cx("headerIcons")
            }, ptm("headerIcons"));
            return /*#__PURE__*/ $81g6h.createElement("div", headerProps, /*#__PURE__*/ $81g6h.createElement("div", headerTitleProps, header), /*#__PURE__*/ $81g6h.createElement("div", headerIconsProps, icons, maximizeIcon, closeIcon));
        }
        return null;
    };
    var createContent = function createContent() {
        var contentId = idState + "_content";
        var contentProps = mergeProps({
            id: contentId,
            ref: contentRef,
            style: props.contentStyle,
            className: cx("content")
        }, ptm("content"));
        return /*#__PURE__*/ $81g6h.createElement("div", contentProps, props.children);
    };
    var createFooter = function createFooter() {
        var footer = (0, $cfkGk.ObjectUtils).getJSXElement(props.footer, props);
        var footerProps = mergeProps({
            ref: footerRef,
            className: cx("footer")
        }, ptm("footer"));
        return footer && /*#__PURE__*/ $81g6h.createElement("div", footerProps, footer);
    };
    var createResizer = function createResizer() {
        if (props.resizable) return /*#__PURE__*/ $81g6h.createElement("span", {
            className: "p-resizable-handle",
            style: {
                zIndex: 90
            },
            onMouseDown: onResizeStart
        });
        return null;
    };
    var createTemplateElement = function createTemplateElement() {
        var _props$children;
        var messageProps = {
            header: props.header,
            content: props.message,
            message: props === null || props === void 0 || (_props$children = props.children) === null || _props$children === void 0 || (_props$children = _props$children[1]) === null || _props$children === void 0 || (_props$children = _props$children.props) === null || _props$children === void 0 ? void 0 : _props$children.children
        };
        var templateElementProps = {
            headerRef: headerRef,
            contentRef: contentRef,
            footerRef: footerRef,
            closeRef: closeRef,
            hide: onClose,
            message: messageProps
        };
        return (0, $cfkGk.ObjectUtils).getJSXElement(inProps.content, templateElementProps);
    };
    var createElement = function createElement() {
        var header = createHeader();
        var content = createContent();
        var footer = createFooter();
        var resizer = createResizer();
        return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, header, content, footer, resizer);
    };
    var createDialog = function createDialog() {
        var headerId = idState + "_header";
        var contentId = idState + "_content";
        var transitionTimeout = {
            enter: props.position === "center" ? 150 : 300,
            exit: props.position === "center" ? 150 : 300
        };
        var maskProps = mergeProps({
            ref: maskRef,
            style: sx("mask"),
            className: cx("mask"),
            onPointerUp: onMaskPointerUp
        }, ptm("mask"));
        var rootProps = mergeProps({
            ref: dialogRef,
            id: idState,
            className: (0, $cfkGk.classNames)(props.className, cx("root", {
                props: props,
                maximized: maximized,
                context: context
            })),
            style: props.style,
            onClick: props.onClick,
            role: "dialog",
            "aria-labelledby": headerId,
            "aria-describedby": contentId,
            "aria-modal": props.modal,
            onPointerDown: onDialogPointerDown
        }, $dd8546bf06353be3$var$DialogBase.getOtherProps(props), ptm("root"));
        var transitionProps = mergeProps({
            classNames: cx("transition"),
            timeout: transitionTimeout,
            "in": visibleState,
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: onEnter,
            onEntered: onEntered,
            onExiting: onExiting,
            onExited: onExited
        }, ptm("transition"));
        var contentElement = null;
        if (inProps !== null && inProps !== void 0 && inProps.content) contentElement = createTemplateElement();
        else contentElement = createElement();
        var rootElement = /*#__PURE__*/ $81g6h.createElement("div", maskProps, /*#__PURE__*/ $81g6h.createElement((0, $lbdsH.CSSTransition), $dd8546bf06353be3$var$_extends({
            nodeRef: dialogRef
        }, transitionProps), /*#__PURE__*/ $81g6h.createElement("div", rootProps, /*#__PURE__*/ $81g6h.createElement($dd8546bf06353be3$var$FocusTrap$1, {
            autoFocus: true
        }, contentElement))));
        return /*#__PURE__*/ $81g6h.createElement((0, $6b4aU.Portal), {
            element: rootElement,
            appendTo: props.appendTo,
            visible: true
        });
    };
    return maskVisibleState && createDialog();
});
$dd8546bf06353be3$export$3ddf2d174ce01153.displayName = "Dialog";

});
parcelRegister("8VSKI", function(module, exports) {

$parcel$export(module.exports, "WindowMaximizeIcon", () => $680e1e4a64821ce6$export$e9bf06badb7c79be);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $680e1e4a64821ce6$var$_extends() {
    $680e1e4a64821ce6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $680e1e4a64821ce6$var$_extends.apply(this, arguments);
}
var $680e1e4a64821ce6$export$e9bf06badb7c79be = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $680e1e4a64821ce6$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14H11.8C12.3835 14 12.9431 13.7682 13.3556 13.3556C13.7682 12.9431 14 12.3835 14 11.8V2.2C14 1.61652 13.7682 1.05694 13.3556 0.644365C12.9431 0.231785 12.3835 0 11.8 0H2.2C1.61652 0 1.05694 0.231785 0.644365 0.644365C0.231785 1.05694 0 1.61652 0 2.2V7C0 7.15913 0.063214 7.31174 0.175736 7.42426C0.288258 7.53679 0.44087 7.6 0.6 7.6C0.75913 7.6 0.911742 7.53679 1.02426 7.42426C1.13679 7.31174 1.2 7.15913 1.2 7V2.2C1.2 1.93478 1.30536 1.68043 1.49289 1.49289C1.68043 1.30536 1.93478 1.2 2.2 1.2H11.8C12.0652 1.2 12.3196 1.30536 12.5071 1.49289C12.6946 1.68043 12.8 1.93478 12.8 2.2V11.8C12.8 12.0652 12.6946 12.3196 12.5071 12.5071C12.3196 12.6946 12.0652 12.8 11.8 12.8H7C6.84087 12.8 6.68826 12.8632 6.57574 12.9757C6.46321 13.0883 6.4 13.2409 6.4 13.4C6.4 13.5591 6.46321 13.7117 6.57574 13.8243C6.68826 13.9368 6.84087 14 7 14ZM9.77805 7.42192C9.89013 7.534 10.0415 7.59788 10.2 7.59995C10.3585 7.59788 10.5099 7.534 10.622 7.42192C10.7341 7.30985 10.798 7.15844 10.8 6.99995V3.94242C10.8066 3.90505 10.8096 3.86689 10.8089 3.82843C10.8079 3.77159 10.7988 3.7157 10.7824 3.6623C10.756 3.55552 10.701 3.45698 10.622 3.37798C10.5099 3.2659 10.3585 3.20202 10.2 3.19995H7.00002C6.84089 3.19995 6.68828 3.26317 6.57576 3.37569C6.46324 3.48821 6.40002 3.64082 6.40002 3.79995C6.40002 3.95908 6.46324 4.11169 6.57576 4.22422C6.68828 4.33674 6.84089 4.39995 7.00002 4.39995H8.80006L6.19997 7.00005C6.10158 7.11005 6.04718 7.25246 6.04718 7.40005C6.04718 7.54763 6.10158 7.69004 6.19997 7.80005C6.30202 7.91645 6.44561 7.98824 6.59997 8.00005C6.75432 7.98824 6.89791 7.91645 6.99997 7.80005L9.60002 5.26841V6.99995C9.6021 7.15844 9.66598 7.30985 9.77805 7.42192ZM1.4 14H3.8C4.17066 13.9979 4.52553 13.8498 4.78763 13.5877C5.04973 13.3256 5.1979 12.9707 5.2 12.6V10.2C5.1979 9.82939 5.04973 9.47452 4.78763 9.21242C4.52553 8.95032 4.17066 8.80215 3.8 8.80005H1.4C1.02934 8.80215 0.674468 8.95032 0.412371 9.21242C0.150274 9.47452 0.00210008 9.82939 0 10.2V12.6C0.00210008 12.9707 0.150274 13.3256 0.412371 13.5877C0.674468 13.8498 1.02934 13.9979 1.4 14ZM1.25858 10.0586C1.29609 10.0211 1.34696 10 1.4 10H3.8C3.85304 10 3.90391 10.0211 3.94142 10.0586C3.97893 10.0961 4 10.147 4 10.2V12.6C4 12.6531 3.97893 12.704 3.94142 12.7415C3.90391 12.779 3.85304 12.8 3.8 12.8H1.4C1.34696 12.8 1.29609 12.779 1.25858 12.7415C1.22107 12.704 1.2 12.6531 1.2 12.6V10.2C1.2 10.147 1.22107 10.0961 1.25858 10.0586Z",
        fill: "currentColor"
    }));
}));
$680e1e4a64821ce6$export$e9bf06badb7c79be.displayName = "WindowMaximizeIcon";

});

parcelRegister("7hQM2", function(module, exports) {

$parcel$export(module.exports, "WindowMinimizeIcon", () => $54e30eb534f18a79$export$e1e96001ddb7b5e7);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $54e30eb534f18a79$var$_extends() {
    $54e30eb534f18a79$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $54e30eb534f18a79$var$_extends.apply(this, arguments);
}
var $54e30eb534f18a79$export$e1e96001ddb7b5e7 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $54e30eb534f18a79$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.8 0H2.2C1.61652 0 1.05694 0.231785 0.644365 0.644365C0.231785 1.05694 0 1.61652 0 2.2V7C0 7.15913 0.063214 7.31174 0.175736 7.42426C0.288258 7.53679 0.44087 7.6 0.6 7.6C0.75913 7.6 0.911742 7.53679 1.02426 7.42426C1.13679 7.31174 1.2 7.15913 1.2 7V2.2C1.2 1.93478 1.30536 1.68043 1.49289 1.49289C1.68043 1.30536 1.93478 1.2 2.2 1.2H11.8C12.0652 1.2 12.3196 1.30536 12.5071 1.49289C12.6946 1.68043 12.8 1.93478 12.8 2.2V11.8C12.8 12.0652 12.6946 12.3196 12.5071 12.5071C12.3196 12.6946 12.0652 12.8 11.8 12.8H7C6.84087 12.8 6.68826 12.8632 6.57574 12.9757C6.46321 13.0883 6.4 13.2409 6.4 13.4C6.4 13.5591 6.46321 13.7117 6.57574 13.8243C6.68826 13.9368 6.84087 14 7 14H11.8C12.3835 14 12.9431 13.7682 13.3556 13.3556C13.7682 12.9431 14 12.3835 14 11.8V2.2C14 1.61652 13.7682 1.05694 13.3556 0.644365C12.9431 0.231785 12.3835 0 11.8 0ZM6.368 7.952C6.44137 7.98326 6.52025 7.99958 6.6 8H9.8C9.95913 8 10.1117 7.93678 10.2243 7.82426C10.3368 7.71174 10.4 7.55913 10.4 7.4C10.4 7.24087 10.3368 7.08826 10.2243 6.97574C10.1117 6.86321 9.95913 6.8 9.8 6.8H8.048L10.624 4.224C10.73 4.11026 10.7877 3.95982 10.7849 3.80438C10.7822 3.64894 10.7192 3.50063 10.6093 3.3907C10.4994 3.28077 10.3511 3.2178 10.1956 3.21506C10.0402 3.21232 9.88974 3.27002 9.776 3.376L7.2 5.952V4.2C7.2 4.04087 7.13679 3.88826 7.02426 3.77574C6.91174 3.66321 6.75913 3.6 6.6 3.6C6.44087 3.6 6.28826 3.66321 6.17574 3.77574C6.06321 3.88826 6 4.04087 6 4.2V7.4C6.00042 7.47975 6.01674 7.55862 6.048 7.632C6.07656 7.70442 6.11971 7.7702 6.17475 7.82524C6.2298 7.88029 6.29558 7.92344 6.368 7.952ZM1.4 8.80005H3.8C4.17066 8.80215 4.52553 8.95032 4.78763 9.21242C5.04973 9.47452 5.1979 9.82939 5.2 10.2V12.6C5.1979 12.9707 5.04973 13.3256 4.78763 13.5877C4.52553 13.8498 4.17066 13.9979 3.8 14H1.4C1.02934 13.9979 0.674468 13.8498 0.412371 13.5877C0.150274 13.3256 0.00210008 12.9707 0 12.6V10.2C0.00210008 9.82939 0.150274 9.47452 0.412371 9.21242C0.674468 8.95032 1.02934 8.80215 1.4 8.80005ZM3.94142 12.7415C3.97893 12.704 4 12.6531 4 12.6V10.2C4 10.147 3.97893 10.0961 3.94142 10.0586C3.90391 10.0211 3.85304 10 3.8 10H1.4C1.34696 10 1.29609 10.0211 1.25858 10.0586C1.22107 10.0961 1.2 10.147 1.2 10.2V12.6C1.2 12.6531 1.22107 12.704 1.25858 12.7415C1.29609 12.779 1.34696 12.8 1.4 12.8H3.8C3.85304 12.8 3.90391 12.779 3.94142 12.7415Z",
        fill: "currentColor"
    }));
}));
$54e30eb534f18a79$export$e1e96001ddb7b5e7.displayName = "WindowMinimizeIcon";

});



parcelRegister("l7dWZ", function(module, exports) {

$parcel$export(module.exports, "AnnouncementDialog", () => $7762cdaeed15cb71$export$7e4c4ea3c9a171aa);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $jim7G = parcelRequire("jim7G");

var $49q7U = parcelRequire("49q7U");

var $d8lNf = parcelRequire("d8lNf");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");

var $cFUyi = parcelRequire("cFUyi");

var $5kXMA = parcelRequire("5kXMA");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $bl9tw = parcelRequire("bl9tw");

var $lTdpc = parcelRequire("lTdpc");

var $dDMmD = parcelRequire("dDMmD");
var $dU78w = parcelRequire("dU78w");

var $81g6h = parcelRequire("81g6h");
var $7762cdaeed15cb71$var$CrossIcon = function CrossIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M6.14 5.302a.836.836 0 0 0-.583 1.435l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26a.834.834 0 0 0 1.377-.263.836.836 0 0 0-.195-.919L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 0 0-.6-.254Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.14 5.015a1.123 1.123 0 0 1 .803.338L12 10.41l5.057-5.057a1.123 1.123 0 1 1 1.588 1.589l-5.057 5.056 5.056 5.056c.107.103.192.226.251.363l-.263.114a.836.836 0 0 0-.189-.272L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 1 0-1.182 1.181l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26c.077.08.17.145.271.189l-.114.263a1.124 1.124 0 0 1-.362-.25L12 13.585l-5.056 5.056a1.123 1.123 0 1 1-1.588-1.588l5.056-5.056-5.057-5.056a1.123 1.123 0 0 1 .785-1.927ZM17.532 18.63a.834.834 0 0 0 1.168-.776.836.836 0 0 0-.068-.323l.263-.114a1.125 1.125 0 0 1-1.477 1.476l.114-.263Z",
                fill: "currentColor"
            })
        ]
    });
};
$7762cdaeed15cb71$var$CrossIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $7762cdaeed15cb71$var$Megaphone = function Megaphone(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                width: "22.165",
                height: "45.523",
                rx: "6",
                transform: "matrix(.90884 -.41658 .4197 .90792 65.09 121.45)",
                fill: "#119CEB"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_1_2287",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "68",
                y: "115",
                width: "33",
                height: "45",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                    width: "22.165",
                    height: "45.523",
                    rx: "11.082",
                    transform: "matrix(.90884 -.41658 .4197 .90792 65.09 121.45)",
                    fill: "#119CEB"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("g", {
                mask: "url(#mask0_1_2287)",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M93.862 139.231c7.37 2.405 14.737 7.509 17.499 9.76 4.391-11.06 13.086-33.336 12.742-33.955-.432-.774-19.11-37.002-20.952-37.603-1.843-.6-48.398 10.55-49.551 11.187-.922.51 2.185 35.49 3.855 52.917 9.064-1.77 29.037-4.71 36.407-2.306Z",
                    fill: "#2275F0"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M72.15 83.282c-5.178 2.473-12.95 4.688-19.429 6.39-3.968 1.042-7 4.374-7.028 8.477-.08 11.831 3.53 23.077 10.713 32.382 2.335 3.024 6.399 3.938 10.022 2.734l17.784-5.913c14.907-4.956 32.995-1.612 55.41 7.682 7.813 3.24 16.187-3.512 13.744-11.608-7.846-25.995-18.957-54.255-26.47-72.433-3.214-7.776-14.049-8.143-18.665-1.113-15.462 23.553-28.77 29.91-36.082 33.402Z",
                fill: "#334EF5"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask1_1_2287",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "46",
                y: "31",
                width: "111",
                height: "113",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M72.15 83.282c-2.364 1.129-5.267 2.204-8.342 3.2-10.525 3.414-19.24 12.29-16.995 23.128a51.995 51.995 0 0 0 1.09 4.329c4.371 14.655 21.803 18.236 36.31 13.413 18.963-6.305 40.548.182 72.168 15.906-10.662-45.737-38.352-111.44-38.352-111.44-19.788 38.783-36.962 47.204-45.88 51.464Z",
                    fill: "#334EF5"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask1_1_2287)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M76.509 69.48c15.12-12.909-18.543-27.085-23.825-32.936L32.805-4.28l85.2-37.816c15.217 54.967 44.64 186.141 42.982 186.426-2.072.356 17.751 28.55 10.471 23.481-19.413-13.517-19.118-6.675-42.376-30.065-26.19-26.337-47.997-4.484-63.266-18.713-17.016-15.856-7.033-34.419 10.693-49.552Z",
                        fill: "#2275F0"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M87.987 54c5.493-13.752-10.551-23.643-15.331-29.907L56.219-18.222l88.036-30.705c10.622 56.028 29.102 189.17 27.426 189.318-2.094.185 15.332 29.907 8.495 24.259-18.23-15.063-20.227-1.54-41.473-26.757-28.593-33.936-44.45-13.586-58.492-29.018-13.314-14.634-.854-33.27 7.776-54.875Z",
                        fill: "#119CEB"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M100.67 67.072c3.268-7.656-6.134-13.105-8.925-16.571l-9.54-23.461 51.836-17.311c6.082 31.096 16.558 105.01 15.573 105.098-1.232.108 8.925 16.571 4.923 13.452-10.672-8.315-10.16-2.574-22.576-16.522-13.98-15.706-27.812-5.643-36.02-14.177-7.784-8.091-.406-18.481 4.729-30.508Z",
                        fill: "#00C3E6"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                cx: "19.675",
                cy: "60.899",
                rx: "19.675",
                ry: "60.899",
                transform: "matrix(.94612 -.32328 .32586 .9456 103.523 34.684)",
                fill: "#33009A"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask2_1_2287",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "114",
                y: "27",
                width: "56",
                height: "117",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                    cx: "19.675",
                    cy: "60.899",
                    rx: "19.675",
                    ry: "60.899",
                    transform: "matrix(.94612 -.32328 .32586 .9456 103.523 34.684)",
                    fill: "#33009A"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M92.064 124.94a2.303 2.303 0 0 1-1.43 2.933l-18.041 6.223a2.317 2.317 0 0 1-2.946-1.423 2.304 2.304 0 0 1 1.43-2.934l18.04-6.223a2.317 2.317 0 0 1 2.947 1.424Z",
                fill: "#33009A"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "m221.022 73.261-37.907 5.605c-3.492.51-4.901-4.383-1.695-5.806l35.01-15.478c11.616-4.403 16.794 13.19 4.598 15.66l-.006.02ZM204.795 110.18l-20.747-14.698c-2.913-2.071-.429-6.588 2.884-5.32l23.731 9.2c8.442 3.781 1.974 15.761-5.862 10.799l-.006.019ZM193.083 37.072 177.825 57.27c-2.196 2.859-6.718.156-5.227-3.093l10.569-22.974c3.866-7.488 14.663-1.11 9.897 5.863l.019.006ZM236.93 95.684a2.911 2.911 0 0 0 2.847-2.973 2.913 2.913 0 0 0-2.986-2.835 2.91 2.91 0 0 0-2.847 2.973 2.912 2.912 0 0 0 2.986 2.835ZM164.476 16.955a2.908 2.908 0 0 0 2.648-3.15 2.914 2.914 0 0 0-3.164-2.638 2.91 2.91 0 0 0-2.648 3.15 2.914 2.914 0 0 0 3.164 2.638Z",
                fill: "#D5BFFF"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M230.417 15.943a1.742 1.742 0 0 1 1.912.45c1.881 2.062 3.151 3.075 4.543 3.611 1.412.545 3.162.682 6.196.5.754-.045 1.451.4 1.724 1.103a1.727 1.727 0 0 1-.531 1.97c-2.372 1.902-3.577 3.177-4.255 4.526-.669 1.329-.924 2.925-.923 5.704a1.729 1.729 0 0 1-1.11 1.614 1.742 1.742 0 0 1-1.912-.45c-1.881-2.061-3.15-3.074-4.543-3.611-1.412-.544-3.162-.681-6.195-.5a1.736 1.736 0 0 1-1.724-1.102 1.725 1.725 0 0 1 .53-1.97c2.373-1.902 3.577-3.178 4.256-4.526.668-1.33.924-2.926.922-5.705a1.73 1.73 0 0 1 1.11-1.614Zm2.123 5.47c-.19 1.225-.516 2.337-1.05 3.398-.468.93-1.075 1.779-1.826 2.612 1.116.115 2.136.337 3.108.712 1.113.429 2.107 1.035 3.078 1.817.191-1.225.517-2.337 1.051-3.399.467-.929 1.074-1.779 1.825-2.612-1.115-.114-2.136-.337-3.107-.711-1.113-.43-2.107-1.036-3.079-1.818ZM270.445 62.888a1.733 1.733 0 0 1 1.346 1.424c.57 3.666 1.246 5.813 2.469 7.526 1.234 1.73 3.156 3.202 6.652 5.212a1.727 1.727 0 0 1-.706 3.219c-4.026.378-6.393.919-8.241 1.978-1.828 1.05-3.339 2.717-5.386 5.806a1.739 1.739 0 0 1-3.165-.687c-.571-3.666-1.247-5.813-2.469-7.526-1.234-1.73-3.156-3.202-6.652-5.212a1.727 1.727 0 0 1 .706-3.22c4.026-.377 6.393-.918 8.241-1.978 1.828-1.048 3.339-2.716 5.386-5.805a1.739 1.739 0 0 1 1.819-.737Zm-1.291 5.891c-1.282 1.544-2.602 2.743-4.181 3.648-1.447.83-3.048 1.377-4.924 1.766 1.538 1.13 2.761 2.29 3.727 3.644 1.056 1.48 1.755 3.121 2.275 5.061 1.281-1.543 2.602-2.742 4.181-3.647 1.447-.83 3.048-1.377 4.923-1.766-1.537-1.13-2.76-2.29-3.726-3.644-1.057-1.48-1.755-3.121-2.275-5.062Z",
                fill: "#D5BFFF"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask3_1_2287",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "133",
                y: "61",
                width: "33",
                height: "47",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                    cx: "13.767",
                    cy: "24.374",
                    rx: "13.767",
                    ry: "24.374",
                    transform: "matrix(.9194 -.39281 .3956 .91864 126.879 67.686)",
                    fill: "#33009A"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask3_1_2287)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                        cx: "14.815",
                        cy: "17.541",
                        rx: "14.815",
                        ry: "17.541",
                        transform: "matrix(.91947 -.39284 .39453 .91902 117.022 79.331)",
                        fill: "#FFAF00"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask4_1_2287",
                        style: {
                            maskType: "alpha"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "122",
                        y: "72",
                        width: "31",
                        height: "35",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                            cx: "14.815",
                            cy: "17.541",
                            rx: "14.815",
                            ry: "17.541",
                            transform: "matrix(.91947 -.39284 .39453 .91902 117.022 79.33)",
                            fill: "#119CEB"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("g", {
                        mask: "url(#mask4_1_2287)",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M165.857 77.226c2.433 5.649 2.877 11.386 1.763 16.043-1.114 4.656-3.712 8.038-7.255 9.552-3.544 1.514-7.794 1.058-11.949-1.347-4.155-2.406-8.023-6.68-10.456-12.329-2.432-5.648-2.876-11.386-1.762-16.043 1.114-4.656 3.712-8.038 7.255-9.552 3.544-1.513 7.794-1.058 11.949 1.347 4.155 2.406 8.023 6.68 10.455 12.33Z",
                            stroke: "#FF8214",
                            strokeWidth: "6"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.04 50.254a1.736 1.736 0 0 1 1.362 1.411c.462 2.75.98 4.287 1.86 5.49.89 1.22 2.287 2.281 4.936 3.767a1.73 1.73 0 0 1-.665 3.228c-3.026.317-4.731.739-6.033 1.506-1.284.756-2.365 1.96-3.873 4.298a1.736 1.736 0 0 1-3.172-.654c-.462-2.75-.98-4.287-1.86-5.49-.89-1.221-2.287-2.282-4.936-3.768a1.731 1.731 0 0 1-.851-1.858 1.73 1.73 0 0 1 1.516-1.37c3.026-.317 4.731-.739 6.034-1.506 1.283-.756 2.364-1.96 3.872-4.297a1.735 1.735 0 0 1 1.81-.757Zm-1.185 5.745c-.825.927-1.703 1.685-2.728 2.29-.898.528-1.869.914-2.953 1.21.876.698 1.613 1.436 2.226 2.276.703.962 1.21 2.009 1.602 3.19.825-.927 1.703-1.685 2.728-2.289.897-.529 1.869-.915 2.953-1.21-.876-.698-1.613-1.437-2.227-2.277-.702-.962-1.209-2.008-1.6-3.19Z",
                fill: "#D5BFFF"
            })
        ]
    });
};
$7762cdaeed15cb71$var$Megaphone.defaultProps = {
    width: "290",
    height: "168",
    viewBox: "0 0 290 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $7762cdaeed15cb71$export$7e4c4ea3c9a171aa = ({ dialogContent: dialogContent, onClose: onClose, ...otherProps })=>{
    const [currentPageIndex, setCurrentPageIndex] = (0, $81g6h.useState)(0);
    const { format: format } = (0, $1eHG3.useI18n)();
    const closeDialog = (0, $81g6h.useCallback)(()=>{
        (0, $jim7G.isAnnouncement)(dialogContent) && (0, $d8lNf.sendAnnouncementCloseEvent)(dialogContent);
        onClose?.(otherProps.onHide) ?? otherProps.onHide();
    }, [
        dialogContent,
        onClose,
        otherProps
    ]);
    const onNextPressed = (0, $81g6h.useCallback)(()=>{
        if (currentPageIndex < dialogContent.pages.length - 1) {
            (0, $jim7G.isAnnouncement)(dialogContent) && (0, $d8lNf.sendAnnouncementNextSlideEvent)(dialogContent, currentPageIndex);
            setCurrentPageIndex(currentPageIndex + 1);
        } else closeDialog();
    }, [
        dialogContent,
        currentPageIndex,
        closeDialog
    ]);
    const onBackPressed = (0, $81g6h.useCallback)(()=>{
        (0, $jim7G.isAnnouncement)(dialogContent) && (0, $d8lNf.sendAnnouncementPreviousSlideEvent)(dialogContent, currentPageIndex);
        setCurrentPageIndex(currentPageIndex - 1);
    }, [
        dialogContent,
        currentPageIndex
    ]);
    const { isMobile: isMobile } = (0, $5kXMA.useDimensions)();
    if (dialogContent.pages.length === 0) return null;
    return /*#__PURE__*/ (0, $iKObn.jsx)($7762cdaeed15cb71$var$StyledBaseDialog, {
        blockScroll: true,
        resizable: false,
        draggable: false,
        dismissableMask: !(0, $jim7G.isAnnouncement)(dialogContent),
        header: /*#__PURE__*/ (0, $iKObn.jsxs)($7762cdaeed15cb71$var$Header, {
            children: [
                !(0, $jim7G.isAnnouncement)(dialogContent) && /*#__PURE__*/ (0, $iKObn.jsx)($7762cdaeed15cb71$var$CrossIconContainer, {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($7762cdaeed15cb71$var$StyledCrossIcon, {
                        width: 24,
                        height: 24,
                        color: (0, $kKnoQ.colors).grey,
                        onClick: closeDialog
                    })
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)($7762cdaeed15cb71$var$Title, {
                    children: dialogContent.title
                })
            ]
        }),
        footer: /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
            children: [
                dialogContent.pages.length > 1 && /*#__PURE__*/ (0, $iKObn.jsx)($7762cdaeed15cb71$var$StepCirclesContainer, {
                    children: dialogContent.pages.map((page, index)=>/*#__PURE__*/ (0, $iKObn.jsx)($7762cdaeed15cb71$var$StepCircle, {
                            active: currentPageIndex === index
                        }, page.id))
                }),
                /*#__PURE__*/ (0, $iKObn.jsxs)($7762cdaeed15cb71$var$ButtonsContainer, {
                    children: [
                        dialogContent.pages.length > 1 && /*#__PURE__*/ (0, $iKObn.jsx)((0, $dDMmD.AnimatePresence), {
                            mode: "popLayout",
                            presenceAffectsLayout: true,
                            children: currentPageIndex > 0 && /*#__PURE__*/ (0, $iKObn.jsx)((0, $dU78w.motion).div, {
                                layout: true,
                                initial: {
                                    opacity: 0,
                                    x: -10
                                },
                                animate: {
                                    opacity: 1,
                                    x: 0
                                },
                                exit: {
                                    opacity: 0,
                                    scale: 0,
                                    x: -30
                                },
                                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                                    onClick: onBackPressed,
                                    uiStyle: "secondary",
                                    children: format("global.dialog.back")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                            onClick: onNextPressed,
                            children: isMobile ? dialogContent.pages[currentPageIndex].shortCtaLabel : dialogContent.pages[currentPageIndex].ctaLabel
                        })
                    ]
                })
            ]
        }),
        closable: false,
        ...otherProps,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($7762cdaeed15cb71$var$PagesContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)($7762cdaeed15cb71$var$Pages, {
                currentPageIndex: currentPageIndex,
                children: dialogContent.pages.map(({ id: id, title: title, description: description, imageUrl: imageUrl, backgroundColor: backgroundColor })=>/*#__PURE__*/ (0, $iKObn.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($7762cdaeed15cb71$var$ImageContainer, {
                                style: {
                                    backgroundColor: backgroundColor
                                },
                                children: (0, $lTdpc.isNotNil)(imageUrl) ? /*#__PURE__*/ (0, $iKObn.jsx)($7762cdaeed15cb71$var$AnnouncementImage, {
                                    src: imageUrl
                                }) : /*#__PURE__*/ (0, $iKObn.jsx)($7762cdaeed15cb71$var$StyledMegaphone, {})
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)($7762cdaeed15cb71$var$PageTextContent, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)("h3", {
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $49q7U.AnnouncementRenderer), {
                                            content: description
                                        })
                                    })
                                ]
                            })
                        ]
                    }, id))
            })
        })
    });
};
const $7762cdaeed15cb71$var$Header = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(0, "flexstart", "center")};
`;
const $7762cdaeed15cb71$var$Title = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(0, "spacebetween", "center")};
`;
const $7762cdaeed15cb71$var$CrossIconContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(0, "flexend", "center")};
	width: 100%;
`;
const $7762cdaeed15cb71$var$StyledCrossIcon = (0, $5UMQ1.default)($7762cdaeed15cb71$var$CrossIcon)`
	justify-self: end;
	cursor: pointer;
`;
const $7762cdaeed15cb71$var$PagesContainer = (0, $5UMQ1.default).div`
	overflow-x: hidden;
	flex: 1;
`;
const $7762cdaeed15cb71$var$Pages = (0, $5UMQ1.default).div`
	display: grid;
	grid-auto-flow: column;
	grid-auto-columns: 100%;
	transition: 0.5s transform;
	transform: translateX(${({ currentPageIndex: currentPageIndex })=>-currentPageIndex * 100}%);
`;
const $7762cdaeed15cb71$var$StepCirclesContainer = (0, $5UMQ1.default).div`
	display: flex;
	gap: 8px;
	place-content: center;
	padding: 8px;
`;
const $7762cdaeed15cb71$var$StepCircle = (0, $5UMQ1.default).div`
	width: 10px;
	height: 10px;
	border: 1px solid ${(0, $kKnoQ.colors).grey80};
	border-radius: 5px;
	background-color: ${({ active: active })=>active ? (0, $kKnoQ.colors).grey80 : "unset"};
`;
const $7762cdaeed15cb71$var$PageTextContent = (0, $5UMQ1.default).div`
	display: grid;
	grid-template-columns: 1fr 2fr;
	padding: 40px;
	padding-bottom: 16px;
	gap: 40px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		grid-template-columns: 1fr;
		gap: 8px;
		padding: 24px;
	}
`;
const $7762cdaeed15cb71$var$ButtonsContainer = (0, $5UMQ1.default).div`
	margin-top: 16px;
	display: flex;
	place-content: center;
	place-items: center;
	gap: 10px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		& > button {
			width: 100% !important;
		}
	}
`;
const $7762cdaeed15cb71$var$StyledBaseDialog = (0, $5UMQ1.default)((0, $gk3fY.BaseDialog))`
	.p-dialog-title {
		font-family: ${(0, $bl9tw.fonts).body};
		font-weight: 700 !important;
		font-size: 18px !important;
		text-align: center !important;
	}

	.p-dialog-header {
		padding: 16px !important;
	}

	.p-dialog-header::after {
		display: none;
	}

	.p-dialog-content {
		padding: 0;
		scrollbar-color: rgba(1, 1, 1, 0.08) transparent;
		&::-webkit-scrollbar {
			width: 10px;
		}
		&::-webkit-scrollbar-track {
			background: rgba(1, 1, 1, 0.08);
		}
		&::-webkit-scrollbar-thumb {
			background: rgba(1, 1, 1, 0.08);
		}
	}
`;
const $7762cdaeed15cb71$var$AnnouncementImage = (0, $5UMQ1.default)((0, $cFUyi.ImageWithLoading))`
	object-fit: cover;
	height: 332px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		height: 282px;
	}
`;
const $7762cdaeed15cb71$var$ImageContainer = (0, $5UMQ1.default).div`
	height: 332px;
	width: 100%;
	display: grid;
	justify-content: center;
	align-items: center;
	position: relative;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		height: 282px;
		max-width: 90vw !important;
		margin-left: auto !important;
		margin-right: auto !important;
		border-radius: 18px !important;
		overflow: hidden !important;
	}
`;
const $7762cdaeed15cb71$var$StyledMegaphone = (0, $5UMQ1.default)($7762cdaeed15cb71$var$Megaphone)`
	height: 142px;
	transform: rotateZ(5deg);
`;

});
parcelRegister("jim7G", function(module, exports) {

$parcel$export(module.exports, "isAnnouncement", () => $b9db420bfe7c6615$export$3688876db6a20312);
$parcel$export(module.exports, "createParagraphBlock", () => $b9db420bfe7c6615$export$8628a0251491ce2b);
const $b9db420bfe7c6615$export$3688876db6a20312 = (content)=>"documentId" in content;
const $b9db420bfe7c6615$export$8628a0251491ce2b = (text)=>[
        {
            type: "paragraph",
            children: [
                {
                    type: "text",
                    text: text
                }
            ]
        }
    ];

});

parcelRegister("49q7U", function(module, exports) {

$parcel$export(module.exports, "AnnouncementRenderer", () => $80285ad8a6f16ef8$export$16e69afc28fbe4eb);

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $3hnF2 = parcelRequire("3hnF2");

var $5nnsS = parcelRequire("5nnsS");
const $80285ad8a6f16ef8$export$16e69afc28fbe4eb = ({ content: content })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $3hnF2.BaseBlocksRenderer), {
        content: content,
        blocks: (0, $5nnsS.announcementBlocksOverrides)
    });

});
parcelRegister("3hnF2", function(module, exports) {

$parcel$export(module.exports, "BaseBlocksRenderer", () => $1be7b958d5c4283e$export$80cae5db87478bb7);

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");
parcelRequire("iCpev");
var $hnWaE = parcelRequire("hnWaE");

var $5nnsS = parcelRequire("5nnsS");
const $1be7b958d5c4283e$export$80cae5db87478bb7 = ({ content: content, blocks: blocks = (0, $5nnsS.commonBlocksOverrides), modifiers: modifiers = (0, $5nnsS.commonModifiersOverrides) })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $hnWaE.BlocksRenderer), {
        content: content,
        blocks: blocks,
        modifiers: modifiers
    });

});
parcelRegister("iCpev", function(module, exports) {

$parcel$export(module.exports, "BlocksRenderer", () => (parcelRequire("hnWaE")).BlocksRenderer);

var $hnWaE = parcelRequire("hnWaE");

});
parcelRegister("hnWaE", function(module, exports) {

$parcel$export(module.exports, "useComponentsContext", () => $ca81b52ee008597a$export$65518c2c4245fa67);
$parcel$export(module.exports, "BlocksRenderer", () => $ca81b52ee008597a$export$cc6164b6561d868);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $2N1gk = parcelRequire("2N1gk");
"use client";
const $ca81b52ee008597a$var$defaultComponents = {
    blocks: {
        paragraph: (props)=>/* @__PURE__ */ (0, $iKObn.jsx)("p", {
                children: props.children
            }),
        quote: (props)=>/* @__PURE__ */ (0, $iKObn.jsx)("blockquote", {
                children: props.children
            }),
        code: (props)=>/* @__PURE__ */ (0, $iKObn.jsx)("pre", {
                children: /* @__PURE__ */ (0, $iKObn.jsx)("code", {
                    children: props.plainText
                })
            }),
        heading: ({ level: level, children: children })=>{
            switch(level){
                case 1:
                    return /* @__PURE__ */ (0, $iKObn.jsx)("h1", {
                        children: children
                    });
                case 2:
                    return /* @__PURE__ */ (0, $iKObn.jsx)("h2", {
                        children: children
                    });
                case 3:
                    return /* @__PURE__ */ (0, $iKObn.jsx)("h3", {
                        children: children
                    });
                case 4:
                    return /* @__PURE__ */ (0, $iKObn.jsx)("h4", {
                        children: children
                    });
                case 5:
                    return /* @__PURE__ */ (0, $iKObn.jsx)("h5", {
                        children: children
                    });
                case 6:
                    return /* @__PURE__ */ (0, $iKObn.jsx)("h6", {
                        children: children
                    });
            }
        },
        link: (props)=>/* @__PURE__ */ (0, $iKObn.jsx)("a", {
                href: props.url,
                children: props.children
            }),
        list: (props)=>{
            if (props.format === "ordered") return /* @__PURE__ */ (0, $iKObn.jsx)("ol", {
                children: props.children
            });
            return /* @__PURE__ */ (0, $iKObn.jsx)("ul", {
                children: props.children
            });
        },
        "list-item": (props)=>/* @__PURE__ */ (0, $iKObn.jsx)("li", {
                children: props.children
            }),
        image: (props)=>/* @__PURE__ */ (0, $iKObn.jsx)("img", {
                src: props.image.url,
                alt: props.image.alternativeText || void 0
            })
    },
    modifiers: {
        bold: (props)=>/* @__PURE__ */ (0, $iKObn.jsx)("strong", {
                children: props.children
            }),
        italic: (props)=>/* @__PURE__ */ (0, $iKObn.jsx)("em", {
                children: props.children
            }),
        underline: (props)=>/* @__PURE__ */ (0, $iKObn.jsx)("u", {
                children: props.children
            }),
        strikethrough: (props)=>/* @__PURE__ */ (0, $iKObn.jsx)("del", {
                children: props.children
            }),
        code: (props)=>/* @__PURE__ */ (0, $iKObn.jsx)("code", {
                children: props.children
            })
    },
    missingBlockTypes: [],
    missingModifierTypes: []
};
const $ca81b52ee008597a$var$ComponentsContext = $81g6h.createContext($ca81b52ee008597a$var$defaultComponents);
const $ca81b52ee008597a$export$4bb6aa6e948cd565 = ({ children: children, value: value = $ca81b52ee008597a$var$defaultComponents })=>{
    const memoizedValue = $81g6h.useMemo(()=>value, [
        value
    ]);
    return /* @__PURE__ */ (0, $iKObn.jsx)($ca81b52ee008597a$var$ComponentsContext.Provider, {
        value: memoizedValue,
        children: children
    });
};
function $ca81b52ee008597a$export$65518c2c4245fa67() {
    return $81g6h.useContext($ca81b52ee008597a$var$ComponentsContext);
}
const $ca81b52ee008597a$export$cc6164b6561d868 = (props)=>{
    const blocks = {
        ...$ca81b52ee008597a$var$defaultComponents.blocks,
        ...props.blocks
    };
    const modifiers = {
        ...$ca81b52ee008597a$var$defaultComponents.modifiers,
        ...props.modifiers
    };
    const missingBlockTypes = $81g6h.useRef([]);
    const missingModifierTypes = $81g6h.useRef([]);
    return /* @__PURE__ */ (0, $iKObn.jsx)($ca81b52ee008597a$export$4bb6aa6e948cd565, {
        value: {
            blocks: blocks,
            modifiers: modifiers,
            missingBlockTypes: missingBlockTypes.current,
            missingModifierTypes: missingModifierTypes.current
        },
        children: props.content.map((content, index)=>/* @__PURE__ */ (0, $iKObn.jsx)((0, $2N1gk.Block), {
                content: content
            }, index))
    });
};

});
parcelRegister("2N1gk", function(module, exports) {

$parcel$export(module.exports, "Block", () => $2081230e05caf471$export$d96a8827a60d6b69);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $hnWaE = parcelRequire("hnWaE");

var $jSZbC = parcelRequire("jSZbC");
const $2081230e05caf471$var$voidTypes = [
    "image"
];
const $2081230e05caf471$var$augmentProps = (content)=>{
    const { children: childrenNodes, type: type, ...props } = content;
    if (type === "code") {
        const getPlainText = (children)=>{
            return children.reduce((currentPlainText, node)=>{
                if (node.type === "text") return currentPlainText.concat(node.text);
                if (node.type === "link") return currentPlainText.concat(getPlainText(node.children));
                return currentPlainText;
            }, "");
        };
        return {
            ...props,
            plainText: getPlainText(content.children)
        };
    }
    return props;
};
const $2081230e05caf471$export$d96a8827a60d6b69 = ({ content: content })=>{
    const { children: childrenNodes, type: type, ...props } = content;
    const { blocks: blocks, missingBlockTypes: missingBlockTypes } = (0, $hnWaE.useComponentsContext)();
    const BlockComponent = blocks[type];
    if (!BlockComponent) {
        if (!missingBlockTypes.includes(type)) {
            console.warn(`[@strapi/block-react-renderer] No component found for block type "${type}"`);
            missingBlockTypes.push(type);
        }
        return null;
    }
    if ($2081230e05caf471$var$voidTypes.includes(type)) return /* @__PURE__ */ (0, $iKObn.jsx)(BlockComponent, {
        ...props
    });
    if (type === "paragraph" && childrenNodes.length === 1 && childrenNodes[0].type === "text" && childrenNodes[0].text === "") return /* @__PURE__ */ (0, $iKObn.jsx)("br", {});
    const augmentedProps = $2081230e05caf471$var$augmentProps(content);
    return /* @__PURE__ */ (0, $iKObn.jsx)(BlockComponent, {
        ...augmentedProps,
        children: childrenNodes.map((childNode, index)=>{
            if (childNode.type === "text") {
                const { type: _type, ...childNodeProps } = childNode;
                return /* @__PURE__ */ (0, $81g6h.createElement)((0, $jSZbC.Text), {
                    ...childNodeProps,
                    key: index
                });
            }
            return /* @__PURE__ */ (0, $iKObn.jsx)($2081230e05caf471$export$d96a8827a60d6b69, {
                content: childNode
            }, index);
        })
    });
};

});
parcelRegister("jSZbC", function(module, exports) {

$parcel$export(module.exports, "Text", () => $e7a285cbd91d06c0$export$5f1af8db9871e1d6);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $hnWaE = parcelRequire("hnWaE");
const $e7a285cbd91d06c0$var$replaceLineBreaks = (text)=>{
    const split = text.split(/\r?\n|\r/g);
    return /* @__PURE__ */ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
        children: split.map((part, idx)=>/* @__PURE__ */ (0, $iKObn.jsxs)($81g6h.Fragment, {
                children: [
                    idx > 0 && /* @__PURE__ */ (0, $iKObn.jsx)("br", {}),
                    part
                ]
            }, idx))
    });
};
const $e7a285cbd91d06c0$export$5f1af8db9871e1d6 = ({ text: text, ...modifiers })=>{
    const { modifiers: modifierComponents, missingModifierTypes: missingModifierTypes } = (0, $hnWaE.useComponentsContext)();
    const modifierNames = Object.keys(modifiers);
    return modifierNames.reduce((children, modifierName)=>{
        if (!modifiers[modifierName]) return children;
        const ModifierComponent = modifierComponents[modifierName];
        if (!ModifierComponent) {
            if (!missingModifierTypes.includes(modifierName)) {
                console.warn(`[@strapi/block-react-renderer] No component found for modifier "${modifierName}"`);
                missingModifierTypes.push(modifierName);
            }
            return children;
        }
        return /* @__PURE__ */ (0, $iKObn.jsx)(ModifierComponent, {
            children: children
        });
    }, // By default, return the text without any wrapper to avoid useless nesting
    $e7a285cbd91d06c0$var$replaceLineBreaks(text));
};

});




parcelRegister("5nnsS", function(module, exports) {

$parcel$export(module.exports, "commonBlocksOverrides", () => $59ded07b3fcfdae0$export$39fb48436154b319);
$parcel$export(module.exports, "commonModifiersOverrides", () => $59ded07b3fcfdae0$export$35717c5236fd3754);
$parcel$export(module.exports, "announcementBlocksOverrides", () => $59ded07b3fcfdae0$export$9222b8030dae2895);

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");

var $bl9tw = parcelRequire("bl9tw");
// Styled Components
const $59ded07b3fcfdae0$var$Paragraph = (0, $5UMQ1.default).p`
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 18px;
	font-weight: 400;
	line-height: 1;
	color: ${(0, $kKnoQ.colors).black};
	margin: 16px 0 0 0 !important;
`;
const $59ded07b3fcfdae0$var$BlocksParagraphRenderer = ({ children: children })=>/*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$Paragraph, {
        children: children
    });
const $59ded07b3fcfdae0$var$HeadingBase = (0, $5UMQ1.default).h1`
	font-family: ${(0, $bl9tw.fonts).header};
	color: ${(0, $kKnoQ.colors).black};
	font-weight: 700;
	line-height: 1;
	margin-bottom: 24px;
	margin-top: 16px;
`;
const $59ded07b3fcfdae0$var$Heading1 = (0, $5UMQ1.default)($59ded07b3fcfdae0$var$HeadingBase)`
	font-size: 24px;
	line-height: 1.3;
`;
const $59ded07b3fcfdae0$var$Heading2 = (0, $5UMQ1.default)($59ded07b3fcfdae0$var$HeadingBase)`
	font-size: 24px;
	line-height: 1.3;
`;
const $59ded07b3fcfdae0$var$Heading3 = (0, $5UMQ1.default)($59ded07b3fcfdae0$var$HeadingBase)`
	font-size: 24px;
	line-height: 1.3;
`;
const $59ded07b3fcfdae0$var$Heading4 = (0, $5UMQ1.default)($59ded07b3fcfdae0$var$HeadingBase)`
	font-size: 24px;
	line-height: 1.3;
`;
const $59ded07b3fcfdae0$var$Heading5 = (0, $5UMQ1.default)($59ded07b3fcfdae0$var$HeadingBase)`
	font-size: 24px;
	line-height: 1.3;
`;
const $59ded07b3fcfdae0$var$Heading6 = (0, $5UMQ1.default)($59ded07b3fcfdae0$var$HeadingBase)`
	font-size: 24px;
	line-height: 1.3;
`;
const $59ded07b3fcfdae0$var$HeadingDefault = (0, $5UMQ1.default)($59ded07b3fcfdae0$var$Paragraph)`
	font-weight: 700;
`;
const $59ded07b3fcfdae0$var$OrderedList = (0, $5UMQ1.default).ol`
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 18px;
	line-height: 1.7;
	color: ${(0, $kKnoQ.colors).black};
	padding-left: 24px;
	margin: 0 0 24px 0;

	&:first-of-type {
		margin-top: 0;
	}
`;
const $59ded07b3fcfdae0$var$UnorderedList = (0, $5UMQ1.default).ul`
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 16px;
	line-height: 8px;
	color: ${(0, $kKnoQ.colors).grey};
	padding-left: 12px;
	margin: 0;
	margin-top: 24px;
`;
const $59ded07b3fcfdae0$var$ListItem = (0, $5UMQ1.default).li`
	font-family: ${(0, $bl9tw.fonts).body};
	color: ${(0, $kKnoQ.colors).primaryDark};
`;
const $59ded07b3fcfdae0$var$StyledImage = (0, $5UMQ1.default).img`
	max-width: 100%;
	height: auto;
	border-radius: 8px;
`;
const $59ded07b3fcfdae0$var$Quote = (0, $5UMQ1.default).blockquote`
	border-left: 4px solid ${(0, $kKnoQ.colors).primary};
	margin: 0;
	padding: 8px 16px;
	color: ${(0, $kKnoQ.colors).grey80};
	font-style: italic;
`;
const $59ded07b3fcfdae0$var$CodeBlock = (0, $5UMQ1.default).pre`
	margin: 0;
	padding: 12px;
	border-radius: 8px;
	background-color: ${(0, $kKnoQ.colors).grey10};
	font-family: "Source Code Pro", monospace;
	overflow-x: auto;
`;
const $59ded07b3fcfdae0$var$InlineCode = (0, $5UMQ1.default).code`
	font-family: "Source Code Pro", monospace;
	background-color: ${(0, $kKnoQ.colors).grey10};
	padding: 0 4px;
	border-radius: 4px;
`;
const $59ded07b3fcfdae0$var$HyperlinkContainer = (0, $5UMQ1.default).a`
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-bottom: 10px;
	text-decoration: none;
	gap: 10px;

	&:hover {
		opacity: 0.8;
	}
`;
const $59ded07b3fcfdae0$var$HyperlinkImage = (0, $5UMQ1.default).img`
	width: 45px;
	height: 45px;
	border-radius: 24px;
	object-fit: contain;
`;
const $59ded07b3fcfdae0$var$HyperlinkTitle = (0, $5UMQ1.default).span`
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 18px;
	font-weight: 700;
	color: ${(0, $kKnoQ.colors).primaryDark50};
	line-height: 1.5;
`;
const $59ded07b3fcfdae0$var$BoldText = (0, $5UMQ1.default).strong`
	font-weight: 700;
`;
const $59ded07b3fcfdae0$var$ItalicText = (0, $5UMQ1.default).em`
	font-style: italic;
`;
const $59ded07b3fcfdae0$var$UnderlineText = (0, $5UMQ1.default).span`
	text-decoration: underline;
`;
const $59ded07b3fcfdae0$export$39fb48436154b319 = {
    paragraph: $59ded07b3fcfdae0$var$BlocksParagraphRenderer,
    heading: ({ children: children, level: level })=>{
        switch(level){
            case 1:
                return /*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$Heading1, {
                    children: children
                });
            case 2:
                return /*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$Heading2, {
                    children: children
                });
            case 3:
                return /*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$Heading3, {
                    children: children
                });
            case 4:
                return /*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$Heading4, {
                    children: children
                });
            case 5:
                return /*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$Heading5, {
                    children: children
                });
            case 6:
                return /*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$Heading6, {
                    children: children
                });
            default:
                return /*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$HeadingDefault, {
                    children: children
                });
        }
    },
    list: ({ children: children, format: format })=>format === "ordered" ? /*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$OrderedList, {
            children: children
        }) : /*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$UnorderedList, {
            id: "listUnOrdered",
            children: children
        }),
    "list-item": ({ children: children })=>/*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$ListItem, {
            id: "listItem",
            children: children
        }),
    image: ({ image: image })=>{
        if (!image?.url) return null;
        return /*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$StyledImage, {
            src: image.url,
            alt: image.alternativeText ?? "",
            width: image.width,
            height: image.height
        });
    },
    quote: ({ children: children })=>/*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$Quote, {
            children: children
        }),
    code: ({ plainText: plainText })=>/*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$CodeBlock, {
            children: plainText
        }),
    link: ({ children: children, url: url })=>/*#__PURE__*/ (0, $iKObn.jsxs)($59ded07b3fcfdae0$var$HyperlinkContainer, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$HyperlinkImage, {
                    src: url
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$HyperlinkTitle, {
                    children: children
                })
            ]
        })
};
const $59ded07b3fcfdae0$export$35717c5236fd3754 = {
    bold: ({ children: children })=>/*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$BoldText, {
            children: children
        }),
    italic: ({ children: children })=>/*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$ItalicText, {
            children: children
        }),
    underline: ({ children: children })=>/*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$UnderlineText, {
            children: children
        }),
    code: ({ children: children })=>/*#__PURE__*/ (0, $iKObn.jsx)($59ded07b3fcfdae0$var$InlineCode, {
            children: children
        })
};
const $59ded07b3fcfdae0$export$9222b8030dae2895 = {
    ...$59ded07b3fcfdae0$export$39fb48436154b319,
    link: ({ children: children, url: url })=>/*#__PURE__*/ (0, $iKObn.jsx)("a", {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            children: children
        })
};

});
parcelRegister("bl9tw", function(module, exports) {

$parcel$export(module.exports, "fonts", () => $3690cbd9d523e89b$export$f45fbea8fe20ca8a);
const $3690cbd9d523e89b$var$getCSSValue = (variableName)=>window.getComputedStyle(document.body).getPropertyValue(variableName);
const $3690cbd9d523e89b$export$f45fbea8fe20ca8a = {
    body: $3690cbd9d523e89b$var$getCSSValue("--font-family"),
    header: $3690cbd9d523e89b$var$getCSSValue("--font-family-header")
};

});




parcelRegister("d8lNf", function(module, exports) {

$parcel$export(module.exports, "sendAnnouncementDisplayEvent", () => $0ab892b6268575da$export$710ba678d672fb11);
$parcel$export(module.exports, "sendAnnouncementNextSlideEvent", () => $0ab892b6268575da$export$f65fbea8f6a929de);
$parcel$export(module.exports, "sendAnnouncementPreviousSlideEvent", () => $0ab892b6268575da$export$f36be044b7d36c77);
$parcel$export(module.exports, "sendAnnouncementCloseEvent", () => $0ab892b6268575da$export$2bfdd7d20634ffda);

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");
const $0ab892b6268575da$export$710ba678d672fb11 = (announcement)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).ANNOUNCEMENT,
        action: "display",
        params: [
            announcement.title,
            1,
            announcement.pages.length
        ]
    });
const $0ab892b6268575da$export$f65fbea8f6a929de = (announcement, currentIndex)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).ANNOUNCEMENT,
        action: "nextSlide",
        params: [
            announcement.title,
            currentIndex + 2,
            announcement.pages.length
        ]
    });
const $0ab892b6268575da$export$f36be044b7d36c77 = (announcement, currentIndex)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).ANNOUNCEMENT,
        action: "previousSlide",
        params: [
            announcement.title,
            currentIndex,
            announcement.pages.length
        ]
    });
const $0ab892b6268575da$export$2bfdd7d20634ffda = (announcement)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).ANNOUNCEMENT,
        action: "closeWindow",
        params: [
            announcement.title
        ]
    });

});

parcelRegister("gk3fY", function(module, exports) {

$parcel$export(module.exports, "DIALOG_SIZE", () => $ffb4ff963f809549$export$abdfa4ea997bbb3);
$parcel$export(module.exports, "BaseDialog", () => $ffb4ff963f809549$export$a0609e4d602995aa);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kkH7g = parcelRequire("kkH7g");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $j19eN = parcelRequire("j19eN");

var $81g6h = parcelRequire("81g6h");
var $ffb4ff963f809549$export$abdfa4ea997bbb3;
(function(DIALOG_SIZE) {
    DIALOG_SIZE[DIALOG_SIZE["S"] = 0] = "S";
    DIALOG_SIZE[DIALOG_SIZE["M"] = 1] = "M";
    DIALOG_SIZE[DIALOG_SIZE["L"] = 2] = "L";
    DIALOG_SIZE[DIALOG_SIZE["XL"] = 3] = "XL";
})($ffb4ff963f809549$export$abdfa4ea997bbb3 || ($ffb4ff963f809549$export$abdfa4ea997bbb3 = {}));
const $ffb4ff963f809549$var$getWidth = (width)=>{
    switch(width){
        case 0:
            return "480px";
        case 1:
            return "684px";
        case 2:
            return "732px";
        case 3:
            return `${window.innerWidth - 300}px`;
        default:
            return "100%";
    }
};
const $ffb4ff963f809549$export$a0609e4d602995aa = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ children: children, resizable: resizable = false, draggable: draggable = false, blockScroll: blockScroll = true, footer: footer = /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {}), width: width, height: height, tabletSameAsMobile: tabletSameAsMobile = false, hideScrollbar: hideScrollbar = false, dismissableMask: dismissableMask = true, ...otherProps }, ref)=>/*#__PURE__*/ (0, $iKObn.jsx)($ffb4ff963f809549$var$StyledDialog, {
        ...otherProps,
        ref: ref,
        resizable: resizable,
        draggable: draggable,
        blockScroll: blockScroll,
        footer: footer,
        width: width,
        height: height,
        tabletSameAsMobile: tabletSameAsMobile,
        hideScrollbar: hideScrollbar,
        dismissableMask: dismissableMask,
        children: children
    }));
$ffb4ff963f809549$export$a0609e4d602995aa.displayName = "BaseDialog";
const $ffb4ff963f809549$var$mobileStyles = (0, $kkH7g.css)`
	max-height: 100%;
	width: 100%;
	height: 100%;
	max-width: initial;

	.p-dialog-header {
		flex-direction: row-reverse;
		gap: 16px;

		::after {
			left: 16px;
			right: 16px;
		}
	}

	.p-dialog-header,
	.p-dialog-footer,
	.p-dialog-content {
		border-radius: 0;
		padding: 16px;
	}

	.p-dialog-content {
		display: flex;
		flex-direction: column;
		height: 100%;
	}
`;
const $ffb4ff963f809549$var$StyledDialog = (0, $5UMQ1.default)((0, $j19eN.Dialog))`
	max-width: ${()=>$ffb4ff963f809549$var$getWidth(3)};
	${({ height: height })=>height && `min-height: ${height};`}
	width: ${({ width: width })=>$ffb4ff963f809549$var$getWidth(width)};

	.p-dialog-content {
		overflow: ${({ hideScrollbar: hideScrollbar })=>hideScrollbar ? "hidden" : "auto"};
	}

	.p-dialog-footer:empty {
		padding-top: 0;
		padding-bottom: 1rem;
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		${$ffb4ff963f809549$var$mobileStyles}
	}

	${({ tabletSameAsMobile: tabletSameAsMobile })=>tabletSameAsMobile && (0, $kkH7g.css)`
			@media ${0, $eaiXJ.physioMeTabletBreakpoint} {
				${$ffb4ff963f809549$var$mobileStyles}
			}
		`}
`;

});

parcelRegister("cFUyi", function(module, exports) {

$parcel$export(module.exports, "ImageWithLoading", () => $fd6b77fddeac2d47$export$c992611b4861bc9a);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $1IlhR = parcelRequire("1IlhR");

var $81g6h = parcelRequire("81g6h");
const $fd6b77fddeac2d47$export$c992611b4861bc9a = ({ src: src, ...props })=>{
    const [isLoading, setIsLoading] = (0, $81g6h.useState)(true);
    const imgRef = (0, $81g6h.useRef)(null);
    (0, $81g6h.useEffect)(()=>{
        let cancelled = false;
        setIsLoading(true);
        if (!src) {
            setIsLoading(false);
            return ()=>{
                cancelled = true;
            };
        }
        const currentImg = imgRef.current;
        if (currentImg?.complete && currentImg.naturalWidth > 0) {
            setIsLoading(false);
            return ()=>{
                cancelled = true;
            };
        }
        const pre = document.createElement("img");
        pre.onload = ()=>{
            if (cancelled) return;
            setIsLoading(false);
        };
        pre.onerror = ()=>{
            if (cancelled) return;
            setIsLoading(false);
        };
        pre.src = src;
        return ()=>{
            cancelled = true;
            pre.onload = null;
            pre.onerror = null;
        };
    }, [
        src
    ]);
    const handleLoad = ()=>setIsLoading(false);
    const handleError = ()=>setIsLoading(false);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($fd6b77fddeac2d47$var$ImageContainer, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($fd6b77fddeac2d47$var$Image, {
                ref: imgRef,
                src: src,
                isLoading: isLoading,
                onLoad: handleLoad,
                onError: handleError,
                ...props
            }),
            isLoading && /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {})
        ]
    });
};
const $fd6b77fddeac2d47$var$ImageContainer = (0, $5UMQ1.default).div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
`;
const $fd6b77fddeac2d47$var$Image = (0, $5UMQ1.default).img`
	width: 100%;
	display: ${({ isLoading: isLoading })=>isLoading ? "none" : "block"};
`;

});

parcelRegister("dDMmD", function(module, exports) {

$parcel$export(module.exports, "AnimatePresence", () => $45b71b225396a1df$export$3ae376d12526dd6f);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $d4vhU = parcelRequire("d4vhU");

var $lVc1g = parcelRequire("lVc1g");

var $7DwGf = parcelRequire("7DwGf");

var $l8veq = parcelRequire("l8veq");

var $1FCO4 = parcelRequire("1FCO4");

var $eeD2g = parcelRequire("eeD2g");

var $jc7Ow = parcelRequire("jc7Ow");
const $45b71b225396a1df$var$getChildKey = (child)=>child.key || "";
function $45b71b225396a1df$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $45b71b225396a1df$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $45b71b225396a1df$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $81g6h.Children).forEach(children, (child)=>{
        if ((0, $81g6h.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $45b71b225396a1df$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $jc7Ow.invariant)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $81g6h.useContext)((0, $l8veq.LayoutGroupContext)).forceRender || (0, $d4vhU.useForceUpdate)()[0];
    const isMounted = (0, $lVc1g.useIsMounted)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $45b71b225396a1df$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $81g6h.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $81g6h.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $81g6h.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $81g6h.useRef)(true);
    (0, $1FCO4.useIsomorphicLayoutEffect)(()=>{
        isInitialRender.current = false;
        $45b71b225396a1df$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $eeD2g.useUnmountEffect)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return (0, $iKObn.jsx)((0, $iKObn.Fragment), {
        children: childrenToRender.map((child)=>(0, $iKObn.jsx)((0, $7DwGf.PresenceChild), {
                isPresent: true,
                initial: initial ? undefined : false,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                children: child
            }, $45b71b225396a1df$var$getChildKey(child)))
    });
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($45b71b225396a1df$var$getChildKey);
    const targetKeys = filteredChildren.map($45b71b225396a1df$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                // clean up the exiting children map
                exitingChildren.delete(key);
                // compute the keys of children that were rendered once but are no longer present
                // this could happen in case of too many fast consequent renderings
                // @link https://github.com/framer/motion/issues/2023
                const leftOverKeys = Array.from(allChildren.keys()).filter((childKey)=>!targetKeys.includes(childKey));
                // clean up the all children map
                leftOverKeys.forEach((leftOverKey)=>allChildren.delete(leftOverKey));
                // make sure to render only the children that are actually visible
                presentChildren.current = filteredChildren.filter((presentChild)=>{
                    const presentChildKey = $45b71b225396a1df$var$getChildKey(presentChild);
                    return(// filter out the node exiting
                    presentChildKey === key || // filter out the leftover children
                    leftOverKeys.includes(presentChildKey));
                });
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = (0, $iKObn.jsx)((0, $7DwGf.PresenceChild), {
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                children: child
            }, $45b71b225396a1df$var$getChildKey(child));
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : (0, $iKObn.jsx)((0, $7DwGf.PresenceChild), {
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode,
            children: child
        }, $45b71b225396a1df$var$getChildKey(child));
    });
    return (0, $iKObn.jsx)((0, $iKObn.Fragment), {
        children: exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $81g6h.cloneElement)(child))
    });
};

});
parcelRegister("d4vhU", function(module, exports) {

$parcel$export(module.exports, "useForceUpdate", () => $f43651189ed9becd$export$91db9bc4f8ac944a);

var $81g6h = parcelRequire("81g6h");

var $lVc1g = parcelRequire("lVc1g");

var $gjKjc = parcelRequire("gjKjc");
function $f43651189ed9becd$export$91db9bc4f8ac944a() {
    const isMounted = (0, $lVc1g.useIsMounted)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $81g6h.useState)(0);
    const forceRender = (0, $81g6h.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $81g6h.useCallback)(()=>(0, $gjKjc.frame).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}

});
parcelRegister("lVc1g", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $7364e118362962de$export$80c2a3957bcb42ea);

var $81g6h = parcelRequire("81g6h");

var $1FCO4 = parcelRequire("1FCO4");
function $7364e118362962de$export$80c2a3957bcb42ea() {
    const isMounted = (0, $81g6h.useRef)(false);
    (0, $1FCO4.useIsomorphicLayoutEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}

});
parcelRegister("1FCO4", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $13a847680e6b7dbc$export$700979bc83e7db82);

var $81g6h = parcelRequire("81g6h");

var $eJJN2 = parcelRequire("eJJN2");
const $13a847680e6b7dbc$export$700979bc83e7db82 = (0, $eJJN2.isBrowser) ? (0, $81g6h.useLayoutEffect) : (0, $81g6h.useEffect);

});
parcelRegister("eJJN2", function(module, exports) {

$parcel$export(module.exports, "isBrowser", () => $29b319fa95d35fb1$export$4e09c449d6c407f7);
const $29b319fa95d35fb1$export$4e09c449d6c407f7 = typeof document !== "undefined";

});



parcelRegister("gjKjc", function(module, exports) {

$parcel$export(module.exports, "frame", () => $95621cb86fb45f3c$export$2cef06c20297c17d);
$parcel$export(module.exports, "cancelFrame", () => $95621cb86fb45f3c$export$ec99c0ef4978dccb);
$parcel$export(module.exports, "frameData", () => $95621cb86fb45f3c$export$fff89137e9e818ce);
$parcel$export(module.exports, "steps", () => $95621cb86fb45f3c$export$be3f796aed065412);

var $vssLq = parcelRequire("vssLq");

var $eWGZi = parcelRequire("eWGZi");
const { schedule: $95621cb86fb45f3c$export$2cef06c20297c17d, cancel: $95621cb86fb45f3c$export$ec99c0ef4978dccb, state: $95621cb86fb45f3c$export$fff89137e9e818ce, steps: $95621cb86fb45f3c$export$be3f796aed065412 } = (0, $eWGZi.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $vssLq.noop), true);

});
parcelRegister("vssLq", function(module, exports) {

$parcel$export(module.exports, "noop", () => $925f217cdb6ddcfb$export$8793edee2d425525);
const $925f217cdb6ddcfb$export$8793edee2d425525 = (any)=>any;

});

parcelRegister("eWGZi", function(module, exports) {

$parcel$export(module.exports, "createRenderBatcher", () => $b4cd6922761b5300$export$510b0596a933801a);

var $5YT1K = parcelRequire("5YT1K");

var $eYCiQ = parcelRequire("eYCiQ");
const $b4cd6922761b5300$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $b4cd6922761b5300$var$maxElapsed = 40;
function $b4cd6922761b5300$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $b4cd6922761b5300$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $eYCiQ.createRenderStep)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $5YT1K.MotionGlobalConfig).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $b4cd6922761b5300$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $b4cd6922761b5300$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $b4cd6922761b5300$export$71ecace0a033b35a.length; i++)steps[$b4cd6922761b5300$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}

});
parcelRegister("5YT1K", function(module, exports) {

$parcel$export(module.exports, "MotionGlobalConfig", () => $2336e3be6cfc3e69$export$dd826089e3c5e502);
const $2336e3be6cfc3e69$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};

});

parcelRegister("eYCiQ", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", () => $182221e737fe1a04$export$b995e5e85f5c8289);
class $182221e737fe1a04$var$Queue {
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function $182221e737fe1a04$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $182221e737fe1a04$var$Queue();
    let nextFrame = new $182221e737fe1a04$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
                callback(frameData);
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

});




parcelRegister("7DwGf", function(module, exports) {

$parcel$export(module.exports, "PresenceChild", () => $bce31aaeb1af86ed$export$979daf65881a382a);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $iU7u9 = parcelRequire("iU7u9");

var $eaulW = parcelRequire("eaulW");

var $7voCy = parcelRequire("7voCy");
const $bce31aaeb1af86ed$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $eaulW.useConstant)($bce31aaeb1af86ed$var$newChildrenMap);
    const id = (0, $81g6h.useId)();
    const context = (0, $81g6h.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random()
    ] : [
        isPresent
    ]);
    (0, $81g6h.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $81g6h.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $iKObn.jsx)((0, $7voCy.PopChild), {
        isPresent: isPresent,
        children: children
    });
    return (0, $iKObn.jsx)((0, $iU7u9.PresenceContext).Provider, {
        value: context,
        children: children
    });
};
function $bce31aaeb1af86ed$var$newChildrenMap() {
    return new Map();
}

});
parcelRegister("iU7u9", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", () => $f6588963ad198127$export$f224e4635b6f8ce2);

var $81g6h = parcelRequire("81g6h");
/**
 * @public
 */ const $f6588963ad198127$export$f224e4635b6f8ce2 = (0, $81g6h.createContext)(null);

});

parcelRegister("eaulW", function(module, exports) {

$parcel$export(module.exports, "useConstant", () => $549bce0c12b05b8f$export$fe4300aa8eebea86);

var $81g6h = parcelRequire("81g6h");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $549bce0c12b05b8f$export$fe4300aa8eebea86(init) {
    const ref = (0, $81g6h.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});

parcelRegister("7voCy", function(module, exports) {

$parcel$export(module.exports, "PopChild", () => $826f51795a6ceda1$export$1d6cdde0c6816c6d);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $3LSjD = parcelRequire("3LSjD");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $826f51795a6ceda1$var$PopChildMeasure extends $81g6h.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $826f51795a6ceda1$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $81g6h.useId)();
    const ref = (0, $81g6h.useRef)(null);
    const size = (0, $81g6h.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const { nonce: nonce } = (0, $81g6h.useContext)((0, $3LSjD.MotionConfigContext));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $81g6h.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $iKObn.jsx)($826f51795a6ceda1$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $81g6h.cloneElement(children, {
            ref: ref
        })
    });
}

});
parcelRegister("3LSjD", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", () => $0db0fecf67d1b545$export$22a697fb29aac98d);

var $81g6h = parcelRequire("81g6h");
/**
 * @public
 */ const $0db0fecf67d1b545$export$22a697fb29aac98d = (0, $81g6h.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});

});



parcelRegister("l8veq", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", () => $cd196c1c94b5cb45$export$a3579ca508007a95);

var $81g6h = parcelRequire("81g6h");
const $cd196c1c94b5cb45$export$a3579ca508007a95 = (0, $81g6h.createContext)({});

});

parcelRegister("eeD2g", function(module, exports) {

$parcel$export(module.exports, "useUnmountEffect", () => $a5a90e4a3f34b0c9$export$f3a192d0cbd30b96);

var $81g6h = parcelRequire("81g6h");
function $a5a90e4a3f34b0c9$export$f3a192d0cbd30b96(callback) {
    return (0, $81g6h.useEffect)(()=>()=>callback(), []);
}

});

parcelRegister("jc7Ow", function(module, exports) {

$parcel$export(module.exports, "warning", () => $9ab0ca34e3b2c553$export$491112666e282270);
$parcel$export(module.exports, "invariant", () => $9ab0ca34e3b2c553$export$f5708dca728d7177);

var $vssLq = parcelRequire("vssLq");
let $9ab0ca34e3b2c553$export$491112666e282270 = (0, $vssLq.noop);
let $9ab0ca34e3b2c553$export$f5708dca728d7177 = (0, $vssLq.noop);
var $9ab0ca34e3b2c553$var$check, $9ab0ca34e3b2c553$var$message, $9ab0ca34e3b2c553$var$check1, $9ab0ca34e3b2c553$var$message1;

});


parcelRegister("dU78w", function(module, exports) {

$parcel$export(module.exports, "motion", () => $ee1a8a5c7c620731$export$e25e478948902b8b);

var $eGE3X = parcelRequire("eGE3X");

var $b2sxE = parcelRequire("b2sxE");

var $cbkZO = parcelRequire("cbkZO");

var $3l8G9 = parcelRequire("3l8G9");

var $1zMcU = parcelRequire("1zMcU");

var $7h5Dc = parcelRequire("7h5Dc");

var $ko4c1 = parcelRequire("ko4c1");

var $lrPdG = parcelRequire("lrPdG");
const $ee1a8a5c7c620731$var$preloadedFeatures = {
    ...(0, $1zMcU.animations),
    ...(0, $3l8G9.gestureAnimations),
    ...(0, $7h5Dc.drag),
    ...(0, $lrPdG.layout)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $ee1a8a5c7c620731$export$e25e478948902b8b = /*@__PURE__*/ (0, $b2sxE.createMotionProxy)((Component, config)=>(0, $cbkZO.createDomMotionConfig)(Component, config, $ee1a8a5c7c620731$var$preloadedFeatures, (0, $ko4c1.createDomVisualElement)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $ee1a8a5c7c620731$export$546614c4a05701f9(key) {
    return (0, $eGE3X.createMotionComponent)((0, $cbkZO.createDomMotionConfig)(key, {
        forwardMotionProps: false
    }, $ee1a8a5c7c620731$var$preloadedFeatures, (0, $ko4c1.createDomVisualElement)));
}

});
parcelRegister("eGE3X", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", () => $190457e6a6579c9f$export$46b7e4b9dc6110c3);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $3LSjD = parcelRequire("3LSjD");

var $cJsHg = parcelRequire("cJsHg");

var $i2lgi = parcelRequire("i2lgi");

var $bKf40 = parcelRequire("bKf40");

var $iBNKW = parcelRequire("iBNKW");

var $jiqVB = parcelRequire("jiqVB");

var $eJJN2 = parcelRequire("eJJN2");

var $l8veq = parcelRequire("l8veq");

var $1F0Z8 = parcelRequire("1F0Z8");

var $4NKQD = parcelRequire("4NKQD");


var $b0hpJ = parcelRequire("b0hpJ");
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $190457e6a6579c9f$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $jiqVB.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $81g6h.useContext)((0, $3LSjD.MotionConfigContext)),
            ...props,
            layoutId: $190457e6a6579c9f$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $iBNKW.useCreateMotionContext)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $eJJN2.isBrowser)) {
            $190457e6a6579c9f$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $190457e6a6579c9f$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $i2lgi.useVisualElement)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $iKObn.jsxs)((0, $cJsHg.MotionContext).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $iKObn.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $bKf40.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefComponent = (0, $81g6h.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $4NKQD.motionComponentSymbol] = Component;
    return ForwardRefComponent;
}
function $190457e6a6579c9f$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $81g6h.useContext)((0, $l8veq.LayoutGroupContext)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $190457e6a6579c9f$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $81g6h.useContext)((0, $1F0Z8.LazyContext)).strict;
}
function $190457e6a6579c9f$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $b0hpJ.featureDefinitions);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}

});
parcelRegister("cJsHg", function(module, exports) {

$parcel$export(module.exports, "MotionContext", () => $e7e3ee5268113f60$export$2285bbca2c666415);

var $81g6h = parcelRequire("81g6h");
const $e7e3ee5268113f60$export$2285bbca2c666415 = (0, $81g6h.createContext)({});

});

parcelRegister("i2lgi", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", () => $1d3f1ba387dec7d3$export$dc0335d73ab0b115);

var $81g6h = parcelRequire("81g6h");

var $iU7u9 = parcelRequire("iU7u9");

var $cJsHg = parcelRequire("cJsHg");

var $1FCO4 = parcelRequire("1FCO4");

var $1F0Z8 = parcelRequire("1F0Z8");

var $3LSjD = parcelRequire("3LSjD");

var $lMutI = parcelRequire("lMutI");

var $lvKul = parcelRequire("lvKul");

var $2S2Xa = parcelRequire("2S2Xa");

var $dtZWn = parcelRequire("dtZWn");
let $1d3f1ba387dec7d3$var$scheduleHandoffComplete = false;
function $1d3f1ba387dec7d3$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    const { visualElement: parent } = (0, $81g6h.useContext)((0, $cJsHg.MotionContext));
    const lazyContext = (0, $81g6h.useContext)((0, $1F0Z8.LazyContext));
    const presenceContext = (0, $81g6h.useContext)((0, $iU7u9.PresenceContext));
    const reducedMotionConfig = (0, $81g6h.useContext)((0, $3LSjD.MotionConfigContext)).reducedMotion;
    const visualElementRef = (0, $81g6h.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $81g6h.useContext)((0, $dtZWn.SwitchLayoutGroupContext));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $1d3f1ba387dec7d3$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    (0, $81g6h.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const wantsHandoff = (0, $81g6h.useRef)(Boolean(props[0, $lMutI.optimizedAppearDataAttribute] && !window.HandoffComplete));
    (0, $1FCO4.useIsomorphicLayoutEffect)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        (0, $lvKul.microtask).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $81g6h.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            wantsHandoff.current = false;
            // This ensures all future calls to animateChanges() will run in useEffect
            if (!$1d3f1ba387dec7d3$var$scheduleHandoffComplete) {
                $1d3f1ba387dec7d3$var$scheduleHandoffComplete = true;
                queueMicrotask($1d3f1ba387dec7d3$var$completeHandoff);
            }
        }
    });
    return visualElement;
}
function $1d3f1ba387dec7d3$var$completeHandoff() {
    window.HandoffComplete = true;
}
function $1d3f1ba387dec7d3$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $1d3f1ba387dec7d3$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $2S2Xa.isRefObject)(dragConstraints),
        visualElement: visualElement,
        scheduleRender: ()=>visualElement.scheduleRender(),
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $1d3f1ba387dec7d3$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $1d3f1ba387dec7d3$var$getClosestProjectingNode(visualElement.parent);
}

});
parcelRegister("1F0Z8", function(module, exports) {

$parcel$export(module.exports, "LazyContext", () => $b8d8a4c3a9bbdd6b$export$40f10139ecf1f171);

var $81g6h = parcelRequire("81g6h");
const $b8d8a4c3a9bbdd6b$export$40f10139ecf1f171 = (0, $81g6h.createContext)({
    strict: false
});

});

parcelRegister("lMutI", function(module, exports) {

$parcel$export(module.exports, "optimizedAppearDataAttribute", () => $a77dfd19ce188011$export$8592e1c077c890a6);

var $7HryJ = parcelRequire("7HryJ");
const $a77dfd19ce188011$export$ed7b8fa9dbf0105d = "framerAppearId";
const $a77dfd19ce188011$export$8592e1c077c890a6 = "data-" + (0, $7HryJ.camelToDash)($a77dfd19ce188011$export$ed7b8fa9dbf0105d);

});
parcelRegister("7HryJ", function(module, exports) {

$parcel$export(module.exports, "camelToDash", () => $e512b228bdd4e649$export$9fd24a634729c672);
/**
 * Convert camelCase to dash-case properties.
 */ const $e512b228bdd4e649$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();

});


parcelRegister("lvKul", function(module, exports) {

$parcel$export(module.exports, "microtask", () => $1e559f1c0723c88e$export$bb76eed83315504c);

var $eWGZi = parcelRequire("eWGZi");
const { schedule: $1e559f1c0723c88e$export$bb76eed83315504c, cancel: $1e559f1c0723c88e$export$3252729004b8456e } = (0, $eWGZi.createRenderBatcher)(queueMicrotask, false);

});

parcelRegister("2S2Xa", function(module, exports) {

$parcel$export(module.exports, "isRefObject", () => $b6a6676fd6de369f$export$dedd81df7bc1307);
function $b6a6676fd6de369f$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});

parcelRegister("dtZWn", function(module, exports) {

$parcel$export(module.exports, "SwitchLayoutGroupContext", () => $065eb72cd9c5b604$export$da5f7b802957459a);

var $81g6h = parcelRequire("81g6h");
/**
 * Internal, exported only for usage in Framer
 */ const $065eb72cd9c5b604$export$da5f7b802957459a = (0, $81g6h.createContext)({});

});


parcelRegister("bKf40", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", () => $1e2e7b1549658bb1$export$c684914703d321fd);

var $81g6h = parcelRequire("81g6h");

var $2S2Xa = parcelRequire("2S2Xa");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $1e2e7b1549658bb1$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $81g6h.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $2S2Xa.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

});

parcelRegister("iBNKW", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", () => $a27bdbf66ce975ac$export$c5638d843b37a176);

var $81g6h = parcelRequire("81g6h");

var $cJsHg = parcelRequire("cJsHg");

var $hOnYD = parcelRequire("hOnYD");
function $a27bdbf66ce975ac$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $hOnYD.getCurrentTreeVariants)(props, (0, $81g6h.useContext)((0, $cJsHg.MotionContext)));
    return (0, $81g6h.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $a27bdbf66ce975ac$var$variantLabelsAsDependency(initial),
        $a27bdbf66ce975ac$var$variantLabelsAsDependency(animate)
    ]);
}
function $a27bdbf66ce975ac$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("hOnYD", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", () => $04bf1ddbc5a9c72a$export$12fc32fc096a04a3);

var $hrE0h = parcelRequire("hrE0h");

var $kCXZm = parcelRequire("kCXZm");
function $04bf1ddbc5a9c72a$export$12fc32fc096a04a3(props, context) {
    if ((0, $kCXZm.isControllingVariants)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $hrE0h.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $hrE0h.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});
parcelRegister("hrE0h", function(module, exports) {

$parcel$export(module.exports, "isVariantLabel", () => $febcfc11de34eee5$export$720b90e312cea233);
/**
 * Decides if the supplied variable is variant label
 */ function $febcfc11de34eee5$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}

});

parcelRegister("kCXZm", function(module, exports) {

$parcel$export(module.exports, "isControllingVariants", () => $adb852b9d66d1539$export$4b3c3bd8d910d78d);
$parcel$export(module.exports, "isVariantNode", () => $adb852b9d66d1539$export$ce46fa4165cdec40);

var $fQwBC = parcelRequire("fQwBC");

var $hrE0h = parcelRequire("hrE0h");

var $iOEAQ = parcelRequire("iOEAQ");
function $adb852b9d66d1539$export$4b3c3bd8d910d78d(props) {
    return (0, $fQwBC.isAnimationControls)(props.animate) || (0, $iOEAQ.variantProps).some((name)=>(0, $hrE0h.isVariantLabel)(props[name]));
}
function $adb852b9d66d1539$export$ce46fa4165cdec40(props) {
    return Boolean($adb852b9d66d1539$export$4b3c3bd8d910d78d(props) || props.variants);
}

});
parcelRegister("fQwBC", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", () => $fc334e4bec6815f5$export$aa71198ceeaf53ce);
function $fc334e4bec6815f5$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}

});

parcelRegister("iOEAQ", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", () => $8b7cba9d638b872b$export$16e45afcc206d3a8);
$parcel$export(module.exports, "variantProps", () => $8b7cba9d638b872b$export$1405a65085f40b9);
const $8b7cba9d638b872b$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $8b7cba9d638b872b$export$1405a65085f40b9 = [
    "initial",
    ...$8b7cba9d638b872b$export$16e45afcc206d3a8
];

});




parcelRegister("jiqVB", function(module, exports) {

$parcel$export(module.exports, "loadFeatures", () => $569bf7699d1c3de0$export$449561ec5703cdc8);

var $b0hpJ = parcelRequire("b0hpJ");
function $569bf7699d1c3de0$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $b0hpJ.featureDefinitions)[key] = {
        ...(0, $b0hpJ.featureDefinitions)[key],
        ...features[key]
    };
}

});
parcelRegister("b0hpJ", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", () => $b0c60cc5c50424a6$export$65570e08d843624d);
const $b0c60cc5c50424a6$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $b0c60cc5c50424a6$export$65570e08d843624d = {};
for(const key in $b0c60cc5c50424a6$var$featureProps)$b0c60cc5c50424a6$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$b0c60cc5c50424a6$var$featureProps[key].some((name)=>!!props[name])
};

});


parcelRegister("4NKQD", function(module, exports) {

$parcel$export(module.exports, "motionComponentSymbol", () => $24328d21abe4488a$export$28e2e4cce424ae23);
const $24328d21abe4488a$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");

});


parcelRegister("b2sxE", function(module, exports) {

$parcel$export(module.exports, "createMotionProxy", () => $b604755e755c8600$export$a28d6df673050e18);

var $eGE3X = parcelRequire("eGE3X");
/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $b604755e755c8600$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $eGE3X.createMotionComponent)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}

});

parcelRegister("cbkZO", function(module, exports) {

$parcel$export(module.exports, "createDomMotionConfig", () => $ffb88a49b2dd4220$export$732916c0e88175fb);

var $5oF6F = parcelRequire("5oF6F");

var $dn8m8 = parcelRequire("dn8m8");

var $jYooZ = parcelRequire("jYooZ");

var $cIra8 = parcelRequire("cIra8");
function $ffb88a49b2dd4220$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $5oF6F.isSVGComponent)(Component) ? (0, $jYooZ.svgMotionConfig) : (0, $cIra8.htmlMotionConfig);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $dn8m8.createUseRender)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}

});
parcelRegister("5oF6F", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", () => $bc55aad835ab2195$export$88f3fc2fd3766989);

var $2S6vY = parcelRequire("2S6vY");
function $bc55aad835ab2195$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $2S6vY.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}

});
parcelRegister("2S6vY", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", () => $4990f0d275aa79ac$export$40209c4c512158e6);
/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $4990f0d275aa79ac$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];

});


parcelRegister("dn8m8", function(module, exports) {

$parcel$export(module.exports, "createUseRender", () => $25a366e974912d3c$export$5d29104eefd89cc8);

var $81g6h = parcelRequire("81g6h");

var $3Llns = parcelRequire("3Llns");

var $57i5X = parcelRequire("57i5X");

var $5oF6F = parcelRequire("5oF6F");

var $hp1fk = parcelRequire("hp1fk");

var $6ym6A = parcelRequire("6ym6A");
function $25a366e974912d3c$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $5oF6F.isSVGComponent)(Component) ? (0, $hp1fk.useSVGProps) : (0, $3Llns.useHTMLProps);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $57i5X.filterProps)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $81g6h.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $81g6h.useMemo)(()=>(0, $6ym6A.isMotionValue)(children) ? children.get() : children, [
            children
        ]);
        return (0, $81g6h.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}

});
parcelRegister("3Llns", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", () => $3bfe231650d6e5e1$export$40dafdb8630c956b);
$parcel$export(module.exports, "useHTMLProps", () => $3bfe231650d6e5e1$export$57be0a314572d87d);

var $81g6h = parcelRequire("81g6h");

var $6iNSN = parcelRequire("6iNSN");

var $6ym6A = parcelRequire("6ym6A");

var $1P4h9 = parcelRequire("1P4h9");

var $bWibi = parcelRequire("bWibi");
function $3bfe231650d6e5e1$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $6ym6A.isMotionValue)(source[key]) && !(0, $6iNSN.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $3bfe231650d6e5e1$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $81g6h.useMemo)(()=>{
        const state = (0, $bWibi.createHtmlRenderState)();
        (0, $1P4h9.buildHTMLStyles)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $3bfe231650d6e5e1$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $3bfe231650d6e5e1$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $3bfe231650d6e5e1$var$useInitialMotionValues(props, visualState));
    return style;
}
function $3bfe231650d6e5e1$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $3bfe231650d6e5e1$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}

});
parcelRegister("6iNSN", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", () => $c01dbf496272109d$export$6d27ce8e3de1c3cf);

var $jb3dc = parcelRequire("jb3dc");

var $313j6 = parcelRequire("313j6");
function $c01dbf496272109d$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $313j6.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $jb3dc.scaleCorrectors)[key] || key === "opacity");
}

});
parcelRegister("jb3dc", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", () => $d822fb4d0600084b$export$91ddd985b97788d1);
$parcel$export(module.exports, "addScaleCorrector", () => $d822fb4d0600084b$export$de9e7791c71225fd);
const $d822fb4d0600084b$export$91ddd985b97788d1 = {};
function $d822fb4d0600084b$export$de9e7791c71225fd(correctors) {
    Object.assign($d822fb4d0600084b$export$91ddd985b97788d1, correctors);
}

});

parcelRegister("313j6", function(module, exports) {

$parcel$export(module.exports, "transformPropOrder", () => $f090abb439be88c2$export$280dc01950909d86);
$parcel$export(module.exports, "transformProps", () => $f090abb439be88c2$export$7b42a0094fb00b6e);
/**
 * Generate a list of every possible transform key.
 */ const $f090abb439be88c2$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $f090abb439be88c2$export$7b42a0094fb00b6e = new Set($f090abb439be88c2$export$280dc01950909d86);

});


parcelRegister("6ym6A", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", () => $83798517deadff35$export$605d60a2578142d3);
const $83798517deadff35$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);

});

parcelRegister("1P4h9", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", () => $463c854c1ae1d16c$export$bb517f8b40f8e99d);

var $8DRgE = parcelRequire("8DRgE");

var $9zsdr = parcelRequire("9zsdr");

var $313j6 = parcelRequire("313j6");

var $6DXs7 = parcelRequire("6DXs7");

var $1QVwa = parcelRequire("1QVwa");
function $463c854c1ae1d16c$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $9zsdr.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $1QVwa.numberValueTypes)[key];
        const valueAsType = (0, $6DXs7.getValueAsType)(value, valueType);
        if ((0, $313j6.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $8DRgE.buildTransform)(state.transform, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

});
parcelRegister("8DRgE", function(module, exports) {

$parcel$export(module.exports, "buildTransform", () => $c66d58ea95716142$export$bdc96e0d5c8f914);

var $313j6 = parcelRequire("313j6");
const $c66d58ea95716142$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $c66d58ea95716142$var$numTransforms = (0, $313j6.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $c66d58ea95716142$export$bdc96e0d5c8f914(transform, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $c66d58ea95716142$var$numTransforms; i++){
        const key = (0, $313j6.transformPropOrder)[i];
        if (transform[key] !== undefined) {
            const transformName = $c66d58ea95716142$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}

});

parcelRegister("9zsdr", function(module, exports) {

$parcel$export(module.exports, "isCSSVariableName", () => $6e661502a8d5ebd6$export$9de1236619d9e756);
$parcel$export(module.exports, "isCSSVariableToken", () => $6e661502a8d5ebd6$export$31f9caa2600b5723);
const $6e661502a8d5ebd6$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $6e661502a8d5ebd6$export$9de1236619d9e756 = $6e661502a8d5ebd6$var$checkStringStartsWith("--");
const $6e661502a8d5ebd6$var$startsAsVariableToken = $6e661502a8d5ebd6$var$checkStringStartsWith("var(--");
const $6e661502a8d5ebd6$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $6e661502a8d5ebd6$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $6e661502a8d5ebd6$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $6e661502a8d5ebd6$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

});

parcelRegister("6DXs7", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", () => $4760a2007f8de48c$export$453ef540a9a1bd6b);
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $4760a2007f8de48c$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};

});

parcelRegister("1QVwa", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", () => $4567717cc092d023$export$eec14432cd1cb67b);

var $huvJ8 = parcelRequire("huvJ8");

var $ffEe3 = parcelRequire("ffEe3");

var $cS88E = parcelRequire("cS88E");
const $4567717cc092d023$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $ffEe3.px),
    borderTopWidth: (0, $ffEe3.px),
    borderRightWidth: (0, $ffEe3.px),
    borderBottomWidth: (0, $ffEe3.px),
    borderLeftWidth: (0, $ffEe3.px),
    borderRadius: (0, $ffEe3.px),
    radius: (0, $ffEe3.px),
    borderTopLeftRadius: (0, $ffEe3.px),
    borderTopRightRadius: (0, $ffEe3.px),
    borderBottomRightRadius: (0, $ffEe3.px),
    borderBottomLeftRadius: (0, $ffEe3.px),
    // Positioning props
    width: (0, $ffEe3.px),
    maxWidth: (0, $ffEe3.px),
    height: (0, $ffEe3.px),
    maxHeight: (0, $ffEe3.px),
    size: (0, $ffEe3.px),
    top: (0, $ffEe3.px),
    right: (0, $ffEe3.px),
    bottom: (0, $ffEe3.px),
    left: (0, $ffEe3.px),
    // Spacing props
    padding: (0, $ffEe3.px),
    paddingTop: (0, $ffEe3.px),
    paddingRight: (0, $ffEe3.px),
    paddingBottom: (0, $ffEe3.px),
    paddingLeft: (0, $ffEe3.px),
    margin: (0, $ffEe3.px),
    marginTop: (0, $ffEe3.px),
    marginRight: (0, $ffEe3.px),
    marginBottom: (0, $ffEe3.px),
    marginLeft: (0, $ffEe3.px),
    // Transform props
    rotate: (0, $ffEe3.degrees),
    rotateX: (0, $ffEe3.degrees),
    rotateY: (0, $ffEe3.degrees),
    rotateZ: (0, $ffEe3.degrees),
    scale: $huvJ8.scale,
    scaleX: (0, $huvJ8.scale),
    scaleY: (0, $huvJ8.scale),
    scaleZ: (0, $huvJ8.scale),
    skew: (0, $ffEe3.degrees),
    skewX: (0, $ffEe3.degrees),
    skewY: (0, $ffEe3.degrees),
    distance: (0, $ffEe3.px),
    translateX: (0, $ffEe3.px),
    translateY: (0, $ffEe3.px),
    translateZ: (0, $ffEe3.px),
    x: (0, $ffEe3.px),
    y: (0, $ffEe3.px),
    z: (0, $ffEe3.px),
    perspective: (0, $ffEe3.px),
    transformPerspective: (0, $ffEe3.px),
    opacity: (0, $huvJ8.alpha),
    originX: (0, $ffEe3.progressPercentage),
    originY: (0, $ffEe3.progressPercentage),
    originZ: (0, $ffEe3.px),
    // Misc
    zIndex: (0, $cS88E.int),
    backgroundPositionX: (0, $ffEe3.px),
    backgroundPositionY: (0, $ffEe3.px),
    // SVG
    fillOpacity: (0, $huvJ8.alpha),
    strokeOpacity: (0, $huvJ8.alpha),
    numOctaves: (0, $cS88E.int)
};

});
parcelRegister("huvJ8", function(module, exports) {

$parcel$export(module.exports, "number", () => $b52053ad08840c9c$export$98e628dec113755e);
$parcel$export(module.exports, "alpha", () => $b52053ad08840c9c$export$58f0f39f63f3cf42);
$parcel$export(module.exports, "scale", () => $b52053ad08840c9c$export$dcdf75081b88279d);

var $cMkBT = parcelRequire("cMkBT");
const $b52053ad08840c9c$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $b52053ad08840c9c$export$58f0f39f63f3cf42 = {
    ...$b52053ad08840c9c$export$98e628dec113755e,
    transform: (v)=>(0, $cMkBT.clamp)(0, 1, v)
};
const $b52053ad08840c9c$export$dcdf75081b88279d = {
    ...$b52053ad08840c9c$export$98e628dec113755e,
    default: 1
};

});
parcelRegister("cMkBT", function(module, exports) {

$parcel$export(module.exports, "clamp", () => $97888043dcf3c8c7$export$7d15b64cf5a3a4c4);
const $97888043dcf3c8c7$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

});


parcelRegister("ffEe3", function(module, exports) {

$parcel$export(module.exports, "degrees", () => $cb1d876d8907915e$export$41fc368e1a942b97);
$parcel$export(module.exports, "percent", () => $cb1d876d8907915e$export$626336c2cd4b14de);
$parcel$export(module.exports, "px", () => $cb1d876d8907915e$export$91c0eda1d06bf008);
$parcel$export(module.exports, "vh", () => $cb1d876d8907915e$export$f91e8c45a95a32f2);
$parcel$export(module.exports, "vw", () => $cb1d876d8907915e$export$aed3d7b7d206c196);
$parcel$export(module.exports, "progressPercentage", () => $cb1d876d8907915e$export$44e2e1705876d7ed);

var $cg7o1 = parcelRequire("cg7o1");
const $cb1d876d8907915e$var$createUnitType = (unit)=>({
        test: (v)=>(0, $cg7o1.isString)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $cb1d876d8907915e$export$41fc368e1a942b97 = $cb1d876d8907915e$var$createUnitType("deg");
const $cb1d876d8907915e$export$626336c2cd4b14de = $cb1d876d8907915e$var$createUnitType("%");
const $cb1d876d8907915e$export$91c0eda1d06bf008 = $cb1d876d8907915e$var$createUnitType("px");
const $cb1d876d8907915e$export$f91e8c45a95a32f2 = $cb1d876d8907915e$var$createUnitType("vh");
const $cb1d876d8907915e$export$aed3d7b7d206c196 = $cb1d876d8907915e$var$createUnitType("vw");
const $cb1d876d8907915e$export$44e2e1705876d7ed = {
    ...$cb1d876d8907915e$export$626336c2cd4b14de,
    parse: (v)=>$cb1d876d8907915e$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$cb1d876d8907915e$export$626336c2cd4b14de.transform(v * 100)
};

});
parcelRegister("cg7o1", function(module, exports) {

$parcel$export(module.exports, "sanitize", () => $a1a25e09eb1e8f91$export$83d2e9e3e4ee39ed);
$parcel$export(module.exports, "floatRegex", () => $a1a25e09eb1e8f91$export$2444ca58c08448e4);
$parcel$export(module.exports, "colorRegex", () => $a1a25e09eb1e8f91$export$740b69c5fad25dba);
$parcel$export(module.exports, "singleColorRegex", () => $a1a25e09eb1e8f91$export$ed808ff6ecd39e8d);
$parcel$export(module.exports, "isString", () => $a1a25e09eb1e8f91$export$844ec244b1367d54);
$parcel$export(module.exports, "isNullish", () => $a1a25e09eb1e8f91$export$b931b78cbb3caf86);
/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $a1a25e09eb1e8f91$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $a1a25e09eb1e8f91$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
const $a1a25e09eb1e8f91$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
const $a1a25e09eb1e8f91$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function $a1a25e09eb1e8f91$export$844ec244b1367d54(v) {
    return typeof v === "string";
}
function $a1a25e09eb1e8f91$export$b931b78cbb3caf86(v) {
    return v == null;
}

});


parcelRegister("cS88E", function(module, exports) {

$parcel$export(module.exports, "int", () => $21b5912a5383261b$export$7d260a2a5f8bc19e);

var $huvJ8 = parcelRequire("huvJ8");
const $21b5912a5383261b$export$7d260a2a5f8bc19e = {
    ...(0, $huvJ8.number),
    transform: Math.round
};

});



parcelRegister("bWibi", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", () => $1c618a9bfd2c2ad7$export$8940b483cf52eeda);
const $1c618a9bfd2c2ad7$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });

});


parcelRegister("57i5X", function(module, exports) {

$parcel$export(module.exports, "filterProps", () => $7a74072be902b581$export$d697c39a2985a4c);

var $fmlCM = parcelRequire("fmlCM");
let $7a74072be902b581$var$shouldForward = (key)=>!(0, $fmlCM.isValidMotionProp)(key);
function $7a74072be902b581$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $7a74072be902b581$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $fmlCM.isValidMotionProp)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $7a74072be902b581$export$59d6962c470509a5((parcelRequire("l4JUy")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $7a74072be902b581$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($7a74072be902b581$var$shouldForward(key) || forwardMotionProps === true && (0, $fmlCM.isValidMotionProp)(key) || !isDom && !(0, $fmlCM.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}

});
parcelRegister("fmlCM", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", () => $693ca7005e78bf25$export$2f9c46555243bf04);
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $693ca7005e78bf25$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $693ca7005e78bf25$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $693ca7005e78bf25$var$validMotionProps.has(key);
}

});


parcelRegister("hp1fk", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", () => $583d06f59f255632$export$84309c4f53cb1bd5);

var $81g6h = parcelRequire("81g6h");

var $3Llns = parcelRequire("3Llns");

var $jr6qb = parcelRequire("jr6qb");

var $koVBl = parcelRequire("koVBl");

var $4dpiX = parcelRequire("4dpiX");
function $583d06f59f255632$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $81g6h.useMemo)(()=>{
        const state = (0, $koVBl.createSvgRenderState)();
        (0, $jr6qb.buildSVGAttrs)(state, visualState, (0, $4dpiX.isSVGTag)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $3Llns.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}

});
parcelRegister("jr6qb", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", () => $58dd5775a643444d$export$5475d24f125d7053);

var $1P4h9 = parcelRequire("1P4h9");

var $iKhIm = parcelRequire("iKhIm");

var $f7cYv = parcelRequire("f7cYv");
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $58dd5775a643444d$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $1P4h9.buildHTMLStyles)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $iKhIm.calcSVGTransformOrigin)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $f7cYv.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("iKhIm", function(module, exports) {

$parcel$export(module.exports, "calcSVGTransformOrigin", () => $b63c872b0383b999$export$d4fbcfc8e5472155);

var $ffEe3 = parcelRequire("ffEe3");
function $b63c872b0383b999$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $ffEe3.px).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $b63c872b0383b999$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $b63c872b0383b999$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $b63c872b0383b999$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}

});

parcelRegister("f7cYv", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", () => $1d88b8baff9e3c0a$export$311b43f666da1d82);

var $ffEe3 = parcelRequire("ffEe3");
const $1d88b8baff9e3c0a$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $1d88b8baff9e3c0a$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $1d88b8baff9e3c0a$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $1d88b8baff9e3c0a$var$dashKeys : $1d88b8baff9e3c0a$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $ffEe3.px).transform(-offset);
    // Build the dash array
    const pathLength = (0, $ffEe3.px).transform(length);
    const pathSpacing = (0, $ffEe3.px).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

});


parcelRegister("koVBl", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", () => $f2614c9ea0709fd9$export$41be8b43e1c4d4f9);

var $bWibi = parcelRequire("bWibi");
const $f2614c9ea0709fd9$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $bWibi.createHtmlRenderState)(),
        attrs: {}
    });

});

parcelRegister("4dpiX", function(module, exports) {

$parcel$export(module.exports, "isSVGTag", () => $508058c492eb933a$export$6328ce7565ea1049);
const $508058c492eb933a$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";

});



parcelRegister("jYooZ", function(module, exports) {

$parcel$export(module.exports, "svgMotionConfig", () => $5914a5b1cf21f2a7$export$44dabd3fae512e85);

var $eb9bJ = parcelRequire("eb9bJ");

var $aSdXp = parcelRequire("aSdXp");

var $a1yKX = parcelRequire("a1yKX");

var $koVBl = parcelRequire("koVBl");

var $jr6qb = parcelRequire("jr6qb");

var $4dpiX = parcelRequire("4dpiX");

var $gjKjc = parcelRequire("gjKjc");
const $5914a5b1cf21f2a7$export$44dabd3fae512e85 = {
    useVisualState: (0, $a1yKX.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $aSdXp.scrapeMotionValuesFromProps),
        createRenderState: (0, $koVBl.createSvgRenderState),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $gjKjc.frame).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $gjKjc.frame).render(()=>{
                (0, $jr6qb.buildSVGAttrs)(renderState, latestValues, (0, $4dpiX.isSVGTag)(instance.tagName), props.transformTemplate);
                (0, $eb9bJ.renderSVG)(instance, renderState);
            });
        }
    })
};

});
parcelRegister("eb9bJ", function(module, exports) {

$parcel$export(module.exports, "renderSVG", () => $fd3e4b9964b7565b$export$c5f8399d19a7394b);

var $7HryJ = parcelRequire("7HryJ");

var $lo33Q = parcelRequire("lo33Q");

var $5owg4 = parcelRequire("5owg4");
function $fd3e4b9964b7565b$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $lo33Q.renderHTML)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $5owg4.camelCaseAttributes).has(key) ? (0, $7HryJ.camelToDash)(key) : key, renderState.attrs[key]);
}

});
parcelRegister("lo33Q", function(module, exports) {

$parcel$export(module.exports, "renderHTML", () => $a348183a91adee61$export$1a32bf6229c258c0);
function $a348183a91adee61$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}

});

parcelRegister("5owg4", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", () => $02457c4c6278e4fa$export$28931db5d57958e5);
/**
 * A set of attribute names that are always read/written as camel case.
 */ const $02457c4c6278e4fa$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

});


parcelRegister("aSdXp", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", () => $fa1ff92c7515be03$export$16da615486abaa45);

var $6ym6A = parcelRequire("6ym6A");

var $29VaU = parcelRequire("29VaU");

var $313j6 = parcelRequire("313j6");
function $fa1ff92c7515be03$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $29VaU.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    for(const key in props)if ((0, $6ym6A.isMotionValue)(props[key]) || (0, $6ym6A.isMotionValue)(prevProps[key])) {
        const targetKey = (0, $313j6.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});
parcelRegister("29VaU", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", () => $99638d1447cf75ed$export$16da615486abaa45);

var $6iNSN = parcelRequire("6iNSN");

var $6ym6A = parcelRequire("6ym6A");
function $99638d1447cf75ed$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $6ym6A.isMotionValue)(style[key]) || prevProps.style && (0, $6ym6A.isMotionValue)(prevProps.style[key]) || (0, $6iNSN.isForcedMotionValue)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    /**
     * If the willChange style has been manually set as a string, set
     * applyWillChange to false to prevent it from automatically being applied.
     */ if (visualElement && style && typeof style.willChange === "string") visualElement.applyWillChange = false;
    return newValues;
}

});


parcelRegister("a1yKX", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", () => $f6b826e0a8bbb6c5$export$e91e107bc6d03a8e);

var $81g6h = parcelRequire("81g6h");

var $fQwBC = parcelRequire("fQwBC");

var $iU7u9 = parcelRequire("iU7u9");

var $1DKCf = parcelRequire("1DKCf");

var $eaulW = parcelRequire("eaulW");

var $5KSww = parcelRequire("5KSww");

var $cJsHg = parcelRequire("cJsHg");

var $kCXZm = parcelRequire("kCXZm");

var $ejOow = parcelRequire("ejOow");

var $fXcrA = parcelRequire("fXcrA");
function $f6b826e0a8bbb6c5$var$makeState({ applyWillChange: applyWillChange = false, scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext, isStatic) {
    const state = {
        latestValues: $f6b826e0a8bbb6c5$var$makeLatestValues(props, context, presenceContext, isStatic ? false : applyWillChange, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $f6b826e0a8bbb6c5$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $81g6h.useContext)((0, $cJsHg.MotionContext));
        const presenceContext = (0, $81g6h.useContext)((0, $iU7u9.PresenceContext));
        const make = ()=>$f6b826e0a8bbb6c5$var$makeState(config, props, context, presenceContext, isStatic);
        return isStatic ? make() : (0, $eaulW.useConstant)(make);
    };
function $f6b826e0a8bbb6c5$var$addWillChange(willChange, name) {
    const memberName = (0, $ejOow.getWillChangeName)(name);
    if (memberName) (0, $fXcrA.addUniqueItem)(willChange, memberName);
}
function $f6b826e0a8bbb6c5$var$forEachDefinition(props, definition, callback) {
    const list = Array.isArray(definition) ? definition : [
        definition
    ];
    for(let i = 0; i < list.length; i++){
        const resolved = (0, $1DKCf.resolveVariantFromProps)(props, list[i]);
        if (resolved) {
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            callback(target, transitionEnd);
        }
    }
}
function $f6b826e0a8bbb6c5$var$makeLatestValues(props, context, presenceContext, shouldApplyWillChange, scrapeMotionValues) {
    var _a;
    const values = {};
    const willChange = [];
    const applyWillChange = shouldApplyWillChange && ((_a = props.style) === null || _a === void 0 ? void 0 : _a.willChange) === undefined;
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $5KSww.resolveMotionValue)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $kCXZm.isControllingVariants)(props);
    const isVariantNode$1 = (0, $kCXZm.isVariantNode)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $fQwBC.isAnimationControls)(variantToSet)) $f6b826e0a8bbb6c5$var$forEachDefinition(props, variantToSet, (target, transitionEnd)=>{
        for(const key in target){
            let valueTarget = target[key];
            if (Array.isArray(valueTarget)) {
                /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                valueTarget = valueTarget[index];
            }
            if (valueTarget !== null) values[key] = valueTarget;
        }
        for(const key in transitionEnd)values[key] = transitionEnd[key];
    });
    // Add animating values to will-change
    if (applyWillChange) {
        if (animate && initial !== false && !(0, $fQwBC.isAnimationControls)(animate)) $f6b826e0a8bbb6c5$var$forEachDefinition(props, animate, (target)=>{
            for(const key in target)$f6b826e0a8bbb6c5$var$addWillChange(willChange, key);
        });
        if (willChange.length) values.willChange = willChange.join(",");
    }
    return values;
}

});
parcelRegister("1DKCf", function(module, exports) {

$parcel$export(module.exports, "resolveVariantFromProps", () => $a99601b18946e1ba$export$d68f140c4d9b48bc);
function $a99601b18946e1ba$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $a99601b18946e1ba$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $a99601b18946e1ba$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $a99601b18946e1ba$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}

});

parcelRegister("5KSww", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", () => $ea441214c70b8b10$export$fcc2206ecb6d74b);

var $ylCkB = parcelRequire("ylCkB");

var $6ym6A = parcelRequire("6ym6A");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $ea441214c70b8b10$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $6ym6A.isMotionValue)(value) ? value.get() : value;
    return (0, $ylCkB.isCustomValue)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

});
parcelRegister("ylCkB", function(module, exports) {

$parcel$export(module.exports, "isCustomValue", () => $063e0a8e893b3f2d$export$2f308ad9864b3ac9);
$parcel$export(module.exports, "resolveFinalValueInKeyframes", () => $063e0a8e893b3f2d$export$5485128c47bd48bb);

var $lMXkF = parcelRequire("lMXkF");
const $063e0a8e893b3f2d$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $063e0a8e893b3f2d$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $lMXkF.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
};

});
parcelRegister("lMXkF", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", () => $0175336fdf3f0113$export$9153ad4c4999f4a0);
const $0175336fdf3f0113$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};

});



parcelRegister("ejOow", function(module, exports) {

$parcel$export(module.exports, "getWillChangeName", () => $d0a5390b586a5b9d$export$b3f9dd865b560c6);

var $7qPMm = parcelRequire("7qPMm");

var $7HryJ = parcelRequire("7HryJ");

var $313j6 = parcelRequire("313j6");
function $d0a5390b586a5b9d$export$b3f9dd865b560c6(name) {
    if ((0, $313j6.transformProps).has(name)) return "transform";
    else if ((0, $7qPMm.acceleratedValues).has(name)) return (0, $7HryJ.camelToDash)(name);
}

});
parcelRegister("7qPMm", function(module, exports) {

$parcel$export(module.exports, "acceleratedValues", () => $49f045e6adba5030$export$a27eefbd8fb5e404);
/**
 * A list of values that can be hardware-accelerated.
 */ const $49f045e6adba5030$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);

});


parcelRegister("fXcrA", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", () => $9d0a1f0f746ed470$export$20e507e47fae79fd);
$parcel$export(module.exports, "removeItem", () => $9d0a1f0f746ed470$export$fe2d9b4e03920b4c);
function $9d0a1f0f746ed470$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $9d0a1f0f746ed470$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $9d0a1f0f746ed470$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});



parcelRegister("cIra8", function(module, exports) {

$parcel$export(module.exports, "htmlMotionConfig", () => $d5590b5b6bb38dfb$export$e13ea21d87ea57c8);

var $a1yKX = parcelRequire("a1yKX");

var $29VaU = parcelRequire("29VaU");

var $bWibi = parcelRequire("bWibi");
const $d5590b5b6bb38dfb$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $a1yKX.makeUseVisualState)({
        applyWillChange: true,
        scrapeMotionValuesFromProps: $29VaU.scrapeMotionValuesFromProps,
        createRenderState: (0, $bWibi.createHtmlRenderState)
    })
};

});


parcelRegister("3l8G9", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", () => $92a4fa010535c959$export$e5b72898e5a201f1);

var $6c3YM = parcelRequire("6c3YM");

var $9D6VL = parcelRequire("9D6VL");

var $5CinC = parcelRequire("5CinC");

var $bQUBC = parcelRequire("bQUBC");
const $92a4fa010535c959$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $bQUBC.InViewFeature)
    },
    tap: {
        Feature: (0, $5CinC.PressGesture)
    },
    focus: {
        Feature: (0, $9D6VL.FocusGesture)
    },
    hover: {
        Feature: (0, $6c3YM.HoverGesture)
    }
};

});
parcelRegister("6c3YM", function(module, exports) {

$parcel$export(module.exports, "HoverGesture", () => $731db8c65e72890b$export$93a81ea037eac456);

var $7Y6Zq = parcelRequire("7Y6Zq");

var $aAuWK = parcelRequire("aAuWK");

var $41uBy = parcelRequire("41uBy");

var $4A0s3 = parcelRequire("4A0s3");

var $gjKjc = parcelRequire("gjKjc");
function $731db8c65e72890b$var$addHoverEvent(node, isActive) {
    const eventName = isActive ? "pointerenter" : "pointerleave";
    const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $41uBy.isDragActive)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        const callback = props[callbackName];
        if (callback) (0, $gjKjc.frame).postRender(()=>callback(event, info));
    };
    return (0, $7Y6Zq.addPointerEvent)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $731db8c65e72890b$export$93a81ea037eac456 extends (0, $4A0s3.Feature) {
    mount() {
        this.unmount = (0, $aAuWK.pipe)($731db8c65e72890b$var$addHoverEvent(this.node, true), $731db8c65e72890b$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}

});
parcelRegister("7Y6Zq", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", () => $92230d2bfce9ac0c$export$fcff2e64e6676b81);

var $3M4VH = parcelRequire("3M4VH");

var $g81Jb = parcelRequire("g81Jb");
function $92230d2bfce9ac0c$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $3M4VH.addDomEvent)(target, eventName, (0, $g81Jb.addPointerInfo)(handler), options);
}

});
parcelRegister("3M4VH", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", () => $efd3e9efb708fc79$export$b1d829ddf82884aa);
function $efd3e9efb708fc79$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}

});

parcelRegister("g81Jb", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", () => $ed7dca4ebe0e1d0f$export$12f84bb882d06e1a);
$parcel$export(module.exports, "addPointerInfo", () => $ed7dca4ebe0e1d0f$export$c404e80f92c98d29);

var $k4kCH = parcelRequire("k4kCH");
function $ed7dca4ebe0e1d0f$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[`${pointType}X`],
            y: event[`${pointType}Y`]
        }
    };
}
const $ed7dca4ebe0e1d0f$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $k4kCH.isPrimaryPointer)(event) && handler(event, $ed7dca4ebe0e1d0f$export$12f84bb882d06e1a(event));
};

});
parcelRegister("k4kCH", function(module, exports) {

$parcel$export(module.exports, "isPrimaryPointer", () => $a4b73602223a9356$export$a4cf9c8a4b063a6e);
const $a4b73602223a9356$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};

});



parcelRegister("aAuWK", function(module, exports) {

$parcel$export(module.exports, "pipe", () => $6d86340dc6e0bb49$export$a4627e546088548d);
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $6d86340dc6e0bb49$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $6d86340dc6e0bb49$export$a4627e546088548d = (...transformers)=>transformers.reduce($6d86340dc6e0bb49$var$combineFunctions);

});

parcelRegister("41uBy", function(module, exports) {

$parcel$export(module.exports, "getGlobalLock", () => $143609e059ecceb2$export$2b7959ed03c1a3fe);
$parcel$export(module.exports, "isDragActive", () => $143609e059ecceb2$export$1b3dd616664938e4);
function $143609e059ecceb2$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $143609e059ecceb2$var$globalHorizontalLock = $143609e059ecceb2$export$518c5fc2dcb7974b("dragHorizontal");
const $143609e059ecceb2$var$globalVerticalLock = $143609e059ecceb2$export$518c5fc2dcb7974b("dragVertical");
function $143609e059ecceb2$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $143609e059ecceb2$var$globalVerticalLock();
    else if (drag === "x") lock = $143609e059ecceb2$var$globalHorizontalLock();
    else {
        const openHorizontal = $143609e059ecceb2$var$globalHorizontalLock();
        const openVertical = $143609e059ecceb2$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $143609e059ecceb2$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $143609e059ecceb2$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}

});

parcelRegister("4A0s3", function(module, exports) {

$parcel$export(module.exports, "Feature", () => $fabfac0147918ed8$export$6e91cf7616333d5);
class $fabfac0147918ed8$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}

});


parcelRegister("9D6VL", function(module, exports) {

$parcel$export(module.exports, "FocusGesture", () => $5621c3c4a6d5a47b$export$d4826db40d47595b);

var $3M4VH = parcelRequire("3M4VH");

var $4A0s3 = parcelRequire("4A0s3");

var $aAuWK = parcelRequire("aAuWK");
class $5621c3c4a6d5a47b$export$d4826db40d47595b extends (0, $4A0s3.Feature) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $aAuWK.pipe)((0, $3M4VH.addDomEvent)(this.node.current, "focus", ()=>this.onFocus()), (0, $3M4VH.addDomEvent)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}

});

parcelRegister("5CinC", function(module, exports) {

$parcel$export(module.exports, "PressGesture", () => $f373f72f6df59f97$export$f026abdbba7f0c9e);

var $g81Jb = parcelRequire("g81Jb");

var $3M4VH = parcelRequire("3M4VH");

var $7Y6Zq = parcelRequire("7Y6Zq");

var $4A0s3 = parcelRequire("4A0s3");

var $aAuWK = parcelRequire("aAuWK");

var $41uBy = parcelRequire("41uBy");

var $5yW7O = parcelRequire("5yW7O");

var $vssLq = parcelRequire("vssLq");

var $gjKjc = parcelRequire("gjKjc");
function $f373f72f6df59f97$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $g81Jb.extractEventInfo)(syntheticPointerEvent));
}
class $f373f72f6df59f97$export$f026abdbba7f0c9e extends (0, $4A0s3.Feature) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $vssLq.noop);
        this.removeEndListeners = (0, $vssLq.noop);
        this.removeAccessibleListeners = (0, $vssLq.noop);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ const handler = !globalTapTarget && !(0, $5yW7O.isNodeOrChild)(this.node.current, endEvent.target) ? onTapCancel : onTap;
                if (handler) (0, $gjKjc.frame).update(()=>handler(endEvent, endInfo));
            };
            const removePointerUpListener = (0, $7Y6Zq.addPointerEvent)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $7Y6Zq.addPointerEvent)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $aAuWK.pipe)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $f373f72f6df59f97$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $gjKjc.frame).postRender(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $3M4VH.addDomEvent)(this.node.current, "keyup", handleKeyup);
                $f373f72f6df59f97$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $3M4VH.addDomEvent)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $f373f72f6df59f97$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $3M4VH.addDomEvent)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $aAuWK.pipe)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $gjKjc.frame).postRender(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $41uBy.isDragActive)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $gjKjc.frame).postRender(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $7Y6Zq.addPointerEvent)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $3M4VH.addDomEvent)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $aAuWK.pipe)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}

});
parcelRegister("5yW7O", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", () => $76b4063037244792$export$e841ada32ff745b);
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $76b4063037244792$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $76b4063037244792$export$e841ada32ff745b(parent, child.parentElement);
};

});


parcelRegister("bQUBC", function(module, exports) {

$parcel$export(module.exports, "InViewFeature", () => $8ca647a43aa18d43$export$150851c8cc2f0c72);

var $4A0s3 = parcelRequire("4A0s3");

var $cbf3E = parcelRequire("cbf3E");
const $8ca647a43aa18d43$var$thresholdNames = {
    some: 0,
    all: 1
};
class $8ca647a43aa18d43$export$150851c8cc2f0c72 extends (0, $4A0s3.Feature) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $8ca647a43aa18d43$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $cbf3E.observeIntersection)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($8ca647a43aa18d43$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $8ca647a43aa18d43$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}

});
parcelRegister("cbf3E", function(module, exports) {

$parcel$export(module.exports, "observeIntersection", () => $f381546fc3fb9b25$export$b2bcd62fb7925aa5);
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $f381546fc3fb9b25$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $f381546fc3fb9b25$var$observers = new WeakMap();
const $f381546fc3fb9b25$var$fireObserverCallback = (entry)=>{
    const callback = $f381546fc3fb9b25$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $f381546fc3fb9b25$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($f381546fc3fb9b25$var$fireObserverCallback);
};
function $f381546fc3fb9b25$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$f381546fc3fb9b25$var$observers.has(lookupRoot)) $f381546fc3fb9b25$var$observers.set(lookupRoot, {});
    const rootObservers = $f381546fc3fb9b25$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($f381546fc3fb9b25$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $f381546fc3fb9b25$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $f381546fc3fb9b25$var$initIntersectionObserver(options);
    $f381546fc3fb9b25$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $f381546fc3fb9b25$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

});



parcelRegister("1zMcU", function(module, exports) {

$parcel$export(module.exports, "animations", () => $c2b66687833da579$export$7f9953c70dacfd7f);

var $bXPyn = parcelRequire("bXPyn");

var $hzbY1 = parcelRequire("hzbY1");
const $c2b66687833da579$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $bXPyn.AnimationFeature)
    },
    exit: {
        Feature: (0, $hzbY1.ExitAnimationFeature)
    }
};

});
parcelRegister("bXPyn", function(module, exports) {

$parcel$export(module.exports, "AnimationFeature", () => $3d432afd85af7cc9$export$b45b3fe5caabdca);

var $fQwBC = parcelRequire("fQwBC");

var $T2n4q = parcelRequire("T2n4q");

var $4A0s3 = parcelRequire("4A0s3");
class $3d432afd85af7cc9$export$b45b3fe5caabdca extends (0, $4A0s3.Feature) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $T2n4q.createAnimationState)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $fQwBC.isAnimationControls)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}

});
parcelRegister("T2n4q", function(module, exports) {

$parcel$export(module.exports, "createAnimationState", () => $ce5c399beb680daa$export$bb53502b7a672aa8);

var $fQwBC = parcelRequire("fQwBC");

var $lMXkF = parcelRequire("lMXkF");

var $akFoY = parcelRequire("akFoY");

var $hrE0h = parcelRequire("hrE0h");

var $kz7B1 = parcelRequire("kz7B1");

var $iOEAQ = parcelRequire("iOEAQ");

var $fPWPM = parcelRequire("fPWPM");
const $ce5c399beb680daa$var$reversePriorityOrder = [
    ...(0, $iOEAQ.variantPriorityOrder)
].reverse();
const $ce5c399beb680daa$var$numAnimationTypes = (0, $iOEAQ.variantPriorityOrder).length;
function $ce5c399beb680daa$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $fPWPM.animateVisualElement)(visualElement, animation, options)));
}
function $ce5c399beb680daa$export$bb53502b7a672aa8(visualElement) {
    let animate = $ce5c399beb680daa$var$animateList(visualElement);
    let state = $ce5c399beb680daa$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $kz7B1.resolveVariant)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $ce5c399beb680daa$var$numAnimationTypes; i++){
            const type = $ce5c399beb680daa$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $hrE0h.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $fQwBC.isAnimationControls)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $ce5c399beb680daa$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $lMXkF.isKeyframesTarget)(next) && (0, $lMXkF.isKeyframesTarget)(prev)) valueHasChanged = !(0, $akFoY.shallowCompare)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $ce5c399beb680daa$var$createState();
            isInitialRender = true;
        }
    };
}
function $ce5c399beb680daa$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $akFoY.shallowCompare)(next, prev);
    return false;
}
function $ce5c399beb680daa$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $ce5c399beb680daa$var$createState() {
    return {
        animate: $ce5c399beb680daa$var$createTypeState(true),
        whileInView: $ce5c399beb680daa$var$createTypeState(),
        whileHover: $ce5c399beb680daa$var$createTypeState(),
        whileTap: $ce5c399beb680daa$var$createTypeState(),
        whileDrag: $ce5c399beb680daa$var$createTypeState(),
        whileFocus: $ce5c399beb680daa$var$createTypeState(),
        exit: $ce5c399beb680daa$var$createTypeState()
    };
}

});
parcelRegister("akFoY", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", () => $8396ae391a947958$export$90e866afbd6b9f1a);
function $8396ae391a947958$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRegister("kz7B1", function(module, exports) {

$parcel$export(module.exports, "resolveVariant", () => $b982419525786c48$export$7b1b1c981f4f0558);

var $1DKCf = parcelRequire("1DKCf");
function $b982419525786c48$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $1DKCf.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

});

parcelRegister("fPWPM", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", () => $99a03facb9e68293$export$ff62cf473653f109);

var $kz7B1 = parcelRequire("kz7B1");

var $6VfLK = parcelRequire("6VfLK");

var $b3tnl = parcelRequire("b3tnl");

var $gjKjc = parcelRequire("gjKjc");
function $99a03facb9e68293$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $b3tnl.animateVariant)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $b3tnl.animateVariant)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $kz7B1.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $6VfLK.animateTarget)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        (0, $gjKjc.frame).postRender(()=>{
            visualElement.notify("AnimationComplete", definition);
        });
    });
}

});
parcelRegister("6VfLK", function(module, exports) {

$parcel$export(module.exports, "animateTarget", () => $a15b442534684861$export$68cacfeee78d98d2);

var $313j6 = parcelRequire("313j6");

var $5xu5L = parcelRequire("5xu5L");

var $4Tom3 = parcelRequire("4Tom3");

var $2GyY3 = parcelRequire("2GyY3");

var $7EL1Y = parcelRequire("7EL1Y");

var $3COqC = parcelRequire("3COqC");

var $gjKjc = parcelRequire("gjKjc");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $a15b442534684861$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $a15b442534684861$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $a15b442534684861$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...(0, $2GyY3.getValueTransition)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.HandoffAppearAnimations) {
            const appearId = (0, $7EL1Y.getOptimisedAppearId)(visualElement);
            if (appearId) {
                const elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $gjKjc.frame));
                if (elapsed !== null) {
                    valueTransition.elapsed = elapsed;
                    isHandoff = true;
                }
            }
        }
        value.start((0, $5xu5L.animateMotionValue)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $313j6.transformProps).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff, (0, $3COqC.addValueToWillChange)(visualElement, key)));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $gjKjc.frame).update(()=>{
            transitionEnd && (0, $4Tom3.setTarget)(visualElement, transitionEnd);
        });
    });
    return animations;
}

});
parcelRegister("5xu5L", function(module, exports) {

$parcel$export(module.exports, "animateMotionValue", () => $04472c2a8137883f$export$90b3dfc33ff3548);

var $lhAHd = parcelRequire("lhAHd");

var $5n65N = parcelRequire("5n65N");

var $2GyY3 = parcelRequire("2GyY3");

var $5YT1K = parcelRequire("5YT1K");

var $1HZFh = parcelRequire("1HZFh");

var $6OtMl = parcelRequire("6OtMl");

var $gjKjc = parcelRequire("gjKjc");

var $4tDMd = parcelRequire("4tDMd");

var $jKH9j = parcelRequire("jKH9j");

var $2WyfF = parcelRequire("2WyfF");
const $04472c2a8137883f$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff, /**
 * Currently used to remove values from will-change when an animation ends.
 * Preferably this would be handled by event listeners on the MotionValue
 * but these aren't consistent enough yet when considering the different ways
 * an animation can be cancelled.
 */ onEnd)=>(onComplete)=>{
        const valueTransition = (0, $2GyY3.getValueTransition)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $lhAHd.secondsToMilliseconds)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
                onEnd && onEnd();
            },
            onStop: onEnd,
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $2GyY3.isTransitionDefined)(valueTransition)) options = {
            ...options,
            ...(0, $5n65N.getDefaultTransition)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $lhAHd.secondsToMilliseconds)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $lhAHd.secondsToMilliseconds)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $1HZFh.instantAnimationState).current || (0, $5YT1K.MotionGlobalConfig).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $6OtMl.getFinalKeyframe)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $gjKjc.frame).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $2WyfF.GroupPlaybackControls)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $4tDMd.AcceleratedAnimation).supports(options)) return new (0, $4tDMd.AcceleratedAnimation)(options);
        else return new (0, $jKH9j.MainThreadAnimation)(options);
    };

});
parcelRegister("lhAHd", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", () => $6b2f3aa4bdb1c024$export$fc3e7e8557f8c8c7);
$parcel$export(module.exports, "millisecondsToSeconds", () => $6b2f3aa4bdb1c024$export$f64c3bfbc58eec0f);
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $6b2f3aa4bdb1c024$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $6b2f3aa4bdb1c024$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

});

parcelRegister("5n65N", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", () => $6f473d8165f564b8$export$262124b154b9f1c0);

var $313j6 = parcelRequire("313j6");
const $6f473d8165f564b8$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $6f473d8165f564b8$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $6f473d8165f564b8$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $6f473d8165f564b8$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $6f473d8165f564b8$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $6f473d8165f564b8$var$keyframesTransition;
    else if ((0, $313j6.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? $6f473d8165f564b8$var$criticallyDampedSpring(keyframes[1]) : $6f473d8165f564b8$var$underDampedSpring;
    return $6f473d8165f564b8$var$ease;
};

});

parcelRegister("2GyY3", function(module, exports) {

$parcel$export(module.exports, "isTransitionDefined", () => $00ff9390ab753383$export$ca8e47dc8ed5a9d7);
$parcel$export(module.exports, "getValueTransition", () => $00ff9390ab753383$export$7c1391340308742e);
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $00ff9390ab753383$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $00ff9390ab753383$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}

});

parcelRegister("1HZFh", function(module, exports) {

$parcel$export(module.exports, "instantAnimationState", () => $988ab42866799394$export$888a3d84909f9e3d);
const $988ab42866799394$export$888a3d84909f9e3d = {
    current: false
};

});

parcelRegister("6OtMl", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", () => $de13af8c90a1cdf3$export$14de59408fad90b);
const $de13af8c90a1cdf3$var$isNotNull = (value)=>value !== null;
function $de13af8c90a1cdf3$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($de13af8c90a1cdf3$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

});

parcelRegister("4tDMd", function(module, exports) {

$parcel$export(module.exports, "AcceleratedAnimation", () => $1a0ffc0d940cfe35$export$2a45abb4e6513325);

var $9KDBY = parcelRequire("9KDBY");

var $jUU7y = parcelRequire("jUU7y");

var $1Il6E = parcelRequire("1Il6E");

var $vssLq = parcelRequire("vssLq");

var $lhAHd = parcelRequire("lhAHd");

var $6G0lw = parcelRequire("6G0lw");

var $jKH9j = parcelRequire("jKH9j");

var $7qPMm = parcelRequire("7qPMm");

var $6DCo5 = parcelRequire("6DCo5");

var $aVyud = parcelRequire("aVyud");

var $6OtMl = parcelRequire("6OtMl");
const $1a0ffc0d940cfe35$var$supportsWaapi = (0, $1Il6E.memo)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $1a0ffc0d940cfe35$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $1a0ffc0d940cfe35$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $1a0ffc0d940cfe35$var$requiresPregeneratedKeyframes(options) {
    return options.type === "spring" || !(0, $aVyud.isWaapiSupportedEasing)(options.ease);
}
function $1a0ffc0d940cfe35$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $jKH9j.MainThreadAnimation)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $1a0ffc0d940cfe35$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $1a0ffc0d940cfe35$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $1a0ffc0d940cfe35$var$sampleDelta,
        ease: "linear"
    };
}
class $1a0ffc0d940cfe35$export$2a45abb4e6513325 extends (0, $6G0lw.BaseAnimation) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, keyframes: keyframes } = this.options;
        this.resolver = new (0, $jUU7y.DOMKeyframesResolver)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($1a0ffc0d940cfe35$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, ...options } = this.options;
            const pregeneratedAnimation = $1a0ffc0d940cfe35$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $6DCo5.animateStyle)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = (0, $9KDBY.time).now();
        if (this.pendingTimeline) {
            animation.timeline = this.pendingTimeline;
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $6OtMl.getFinalKeyframe)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $lhAHd.millisecondsToSeconds)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $lhAHd.millisecondsToSeconds)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $lhAHd.secondsToMilliseconds)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $vssLq.noop;
            const { animation: animation } = resolved;
            animation.timeline = timeline;
            animation.onfinish = null;
        }
        return 0, $vssLq.noop;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, ...options } = this.options;
            const sampleAnimation = new (0, $jKH9j.MainThreadAnimation)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $lhAHd.secondsToMilliseconds)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $1a0ffc0d940cfe35$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $1a0ffc0d940cfe35$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        return $1a0ffc0d940cfe35$var$supportsWaapi() && name && (0, $7qPMm.acceleratedValues).has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}

});
parcelRegister("9KDBY", function(module, exports) {

$parcel$export(module.exports, "time", () => $8f5dba2940a09ea1$export$2da9be4cfdb689b1);

var $5YT1K = parcelRequire("5YT1K");

var $gjKjc = parcelRequire("gjKjc");
let $8f5dba2940a09ea1$var$now;
function $8f5dba2940a09ea1$var$clearTime() {
    $8f5dba2940a09ea1$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $8f5dba2940a09ea1$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($8f5dba2940a09ea1$var$now === undefined) $8f5dba2940a09ea1$export$2da9be4cfdb689b1.set((0, $gjKjc.frameData).isProcessing || (0, $5YT1K.MotionGlobalConfig).useManualTiming ? (0, $gjKjc.frameData).timestamp : performance.now());
        return $8f5dba2940a09ea1$var$now;
    },
    set: (newTime)=>{
        $8f5dba2940a09ea1$var$now = newTime;
        queueMicrotask($8f5dba2940a09ea1$var$clearTime);
    }
};

});

parcelRegister("jUU7y", function(module, exports) {

$parcel$export(module.exports, "DOMKeyframesResolver", () => $ac57a384ac603893$export$4983792d11b61017);

var $hkfPV = parcelRequire("hkfPV");

var $egwtT = parcelRequire("egwtT");

var $9zsdr = parcelRequire("9zsdr");

var $lrBU8 = parcelRequire("lrBU8");

var $blfVU = parcelRequire("blfVU");

var $1FIdb = parcelRequire("1FIdb");

var $dnd6v = parcelRequire("dnd6v");
class $ac57a384ac603893$export$4983792d11b61017 extends (0, $1FIdb.KeyframeResolver) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue){
        super(unresolvedKeyframes, onComplete, name, motionValue, motionValue === null || motionValue === void 0 ? void 0 : motionValue.owner, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $9zsdr.isCSSVariableToken)(keyframe)) {
                    const resolved = (0, $egwtT.getVariableValue)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $lrBU8.positionalKeys).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $blfVU.findDimensionValueType)(origin);
        const targetType = (0, $blfVU.findDimensionValueType)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $lrBU8.isNumOrPxType)(originType) && (0, $lrBU8.isNumOrPxType)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $hkfPV.isNone)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $dnd6v.makeNoneKeyframesAnimatable)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $lrBU8.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $lrBU8.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}

});
parcelRegister("hkfPV", function(module, exports) {

$parcel$export(module.exports, "isNone", () => $7157532918cefcf8$export$e56af863d5645d5f);

var $elq0T = parcelRequire("elq0T");
function $7157532918cefcf8$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $elq0T.isZeroValueString)(value);
    else return true;
}

});
parcelRegister("elq0T", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", () => $8b73145114672774$export$ade84c85e44a6cb1);
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $8b73145114672774$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);

});


parcelRegister("egwtT", function(module, exports) {

$parcel$export(module.exports, "getVariableValue", () => $713590f2c3df5cbc$export$289398774300c991);

var $jc7Ow = parcelRequire("jc7Ow");

var $fcZiz = parcelRequire("fcZiz");

var $9zsdr = parcelRequire("9zsdr");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $713590f2c3df5cbc$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $713590f2c3df5cbc$export$b9f0c1f373aee2b0(current) {
    const match = $713590f2c3df5cbc$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $713590f2c3df5cbc$var$maxDepth = 4;
function $713590f2c3df5cbc$export$289398774300c991(current, element, depth = 1) {
    (0, $jc7Ow.invariant)(depth <= $713590f2c3df5cbc$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $713590f2c3df5cbc$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $fcZiz.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $9zsdr.isCSSVariableToken)(fallback) ? $713590f2c3df5cbc$export$289398774300c991(fallback, element, depth + 1) : fallback;
}

});
parcelRegister("fcZiz", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", () => $9f4bcab8d55df353$export$65583ed5a868f2d9);
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $9f4bcab8d55df353$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

});


parcelRegister("lrBU8", function(module, exports) {

$parcel$export(module.exports, "positionalKeys", () => $376d70a358d1c1e3$export$c66c0d5db2a205d);
$parcel$export(module.exports, "isNumOrPxType", () => $376d70a358d1c1e3$export$8e5250d1aa9bf370);
$parcel$export(module.exports, "removeNonTranslationalTransform", () => $376d70a358d1c1e3$export$39d4bc9655f3f632);
$parcel$export(module.exports, "positionalValues", () => $376d70a358d1c1e3$export$781d46a8aa670d52);

var $313j6 = parcelRequire("313j6");

var $huvJ8 = parcelRequire("huvJ8");

var $ffEe3 = parcelRequire("ffEe3");
const $376d70a358d1c1e3$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $376d70a358d1c1e3$export$8e5250d1aa9bf370 = (v)=>v === (0, $huvJ8.number) || v === (0, $ffEe3.px);
const $376d70a358d1c1e3$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $376d70a358d1c1e3$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $376d70a358d1c1e3$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $376d70a358d1c1e3$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $376d70a358d1c1e3$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $376d70a358d1c1e3$var$nonTranslationalTransformKeys = (0, $313j6.transformPropOrder).filter((key)=>!$376d70a358d1c1e3$var$transformKeys.has(key));
function $376d70a358d1c1e3$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $376d70a358d1c1e3$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $376d70a358d1c1e3$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $376d70a358d1c1e3$var$getTranslateFromMatrix(4, 13),
    y: $376d70a358d1c1e3$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$376d70a358d1c1e3$export$781d46a8aa670d52.translateX = $376d70a358d1c1e3$export$781d46a8aa670d52.x;
$376d70a358d1c1e3$export$781d46a8aa670d52.translateY = $376d70a358d1c1e3$export$781d46a8aa670d52.y;

});

parcelRegister("blfVU", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", () => $bbf26605e571c391$export$d176691c1998a1f5);
$parcel$export(module.exports, "findDimensionValueType", () => $bbf26605e571c391$export$eefdd52e3ccae428);

var $huvJ8 = parcelRequire("huvJ8");

var $ffEe3 = parcelRequire("ffEe3");

var $b9Sq8 = parcelRequire("b9Sq8");

var $a5azb = parcelRequire("a5azb");
/**
 * A list of value types commonly used for dimensions
 */ const $bbf26605e571c391$export$d176691c1998a1f5 = [
    (0, $huvJ8.number),
    (0, $ffEe3.px),
    (0, $ffEe3.percent),
    (0, $ffEe3.degrees),
    (0, $ffEe3.vw),
    (0, $ffEe3.vh),
    (0, $a5azb.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $bbf26605e571c391$export$eefdd52e3ccae428 = (v)=>$bbf26605e571c391$export$d176691c1998a1f5.find((0, $b9Sq8.testValueType)(v));

});
parcelRegister("b9Sq8", function(module, exports) {

$parcel$export(module.exports, "testValueType", () => $302238e36a30e9b1$export$6eae4d0a6a7ca7cd);
/**
 * Tests a provided value against a ValueType
 */ const $302238e36a30e9b1$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);

});

parcelRegister("a5azb", function(module, exports) {

$parcel$export(module.exports, "auto", () => $efebbb049a655dff$export$dfb5619354ba860);
/**
 * ValueType for "auto"
 */ const $efebbb049a655dff$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};

});


parcelRegister("1FIdb", function(module, exports) {

$parcel$export(module.exports, "flushKeyframeResolvers", () => $fafeb3bbf3f39bf1$export$78b96d2a12593b05);
$parcel$export(module.exports, "KeyframeResolver", () => $fafeb3bbf3f39bf1$export$74d34ca3182f1750);

var $lrBU8 = parcelRequire("lrBU8");

var $gjKjc = parcelRequire("gjKjc");
const $fafeb3bbf3f39bf1$var$toResolve = new Set();
let $fafeb3bbf3f39bf1$var$isScheduled = false;
let $fafeb3bbf3f39bf1$var$anyNeedsMeasurement = false;
function $fafeb3bbf3f39bf1$var$measureAllKeyframes() {
    if ($fafeb3bbf3f39bf1$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($fafeb3bbf3f39bf1$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $lrBU8.removeNonTranslationalTransform)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $fafeb3bbf3f39bf1$var$anyNeedsMeasurement = false;
    $fafeb3bbf3f39bf1$var$isScheduled = false;
    $fafeb3bbf3f39bf1$var$toResolve.forEach((resolver)=>resolver.complete());
    $fafeb3bbf3f39bf1$var$toResolve.clear();
}
function $fafeb3bbf3f39bf1$var$readAllKeyframes() {
    $fafeb3bbf3f39bf1$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $fafeb3bbf3f39bf1$var$anyNeedsMeasurement = true;
    });
}
function $fafeb3bbf3f39bf1$export$78b96d2a12593b05() {
    $fafeb3bbf3f39bf1$var$readAllKeyframes();
    $fafeb3bbf3f39bf1$var$measureAllKeyframes();
}
class $fafeb3bbf3f39bf1$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $fafeb3bbf3f39bf1$var$toResolve.add(this);
            if (!$fafeb3bbf3f39bf1$var$isScheduled) {
                $fafeb3bbf3f39bf1$var$isScheduled = true;
                (0, $gjKjc.frame).read($fafeb3bbf3f39bf1$var$readAllKeyframes);
                (0, $gjKjc.frame).resolveKeyframes($fafeb3bbf3f39bf1$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $fafeb3bbf3f39bf1$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $fafeb3bbf3f39bf1$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}

});

parcelRegister("dnd6v", function(module, exports) {

$parcel$export(module.exports, "makeNoneKeyframesAnimatable", () => $9080f794c5ebb69a$export$8cc4958f8e540f37);

var $5U4ao = parcelRequire("5U4ao");

var $5hjmD = parcelRequire("5hjmD");
/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $9080f794c5ebb69a$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $9080f794c5ebb69a$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$9080f794c5ebb69a$var$invalidTemplates.has(keyframe) && (0, $5U4ao.analyseComplexValue)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $5hjmD.getAnimatableNone)(name, animatableTemplate);
}

});
parcelRegister("5U4ao", function(module, exports) {

$parcel$export(module.exports, "analyseComplexValue", () => $e7a742f3fad51654$export$b61fc7c44bf646d5);
$parcel$export(module.exports, "complex", () => $e7a742f3fad51654$export$83a0e34f1302825b);

var $83rBL = parcelRequire("83rBL");

var $cg7o1 = parcelRequire("cg7o1");
function $e7a742f3fad51654$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $cg7o1.isString)(v) && (((_a = v.match((0, $cg7o1.floatRegex))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $cg7o1.colorRegex))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $e7a742f3fad51654$var$NUMBER_TOKEN = "number";
const $e7a742f3fad51654$var$COLOR_TOKEN = "color";
const $e7a742f3fad51654$var$VAR_TOKEN = "var";
const $e7a742f3fad51654$var$VAR_FUNCTION_TOKEN = "var(";
const $e7a742f3fad51654$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $e7a742f3fad51654$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $e7a742f3fad51654$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($e7a742f3fad51654$var$complexRegex, (parsedValue)=>{
        if ((0, $83rBL.color).test(parsedValue)) {
            indexes.color.push(i);
            types.push($e7a742f3fad51654$var$COLOR_TOKEN);
            values.push((0, $83rBL.color).parse(parsedValue));
        } else if (parsedValue.startsWith($e7a742f3fad51654$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($e7a742f3fad51654$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($e7a742f3fad51654$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $e7a742f3fad51654$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($e7a742f3fad51654$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $e7a742f3fad51654$var$parseComplexValue(v) {
    return $e7a742f3fad51654$export$b61fc7c44bf646d5(v).values;
}
function $e7a742f3fad51654$var$createTransformer(source) {
    const { split: split, types: types } = $e7a742f3fad51654$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $e7a742f3fad51654$var$NUMBER_TOKEN) output += (0, $cg7o1.sanitize)(v[i]);
                else if (type === $e7a742f3fad51654$var$COLOR_TOKEN) output += (0, $83rBL.color).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $e7a742f3fad51654$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $e7a742f3fad51654$var$getAnimatableNone(v) {
    const parsed = $e7a742f3fad51654$var$parseComplexValue(v);
    const transformer = $e7a742f3fad51654$var$createTransformer(v);
    return transformer(parsed.map($e7a742f3fad51654$var$convertNumbersToZero));
}
const $e7a742f3fad51654$export$83a0e34f1302825b = {
    test: $e7a742f3fad51654$var$test,
    parse: $e7a742f3fad51654$var$parseComplexValue,
    createTransformer: $e7a742f3fad51654$var$createTransformer,
    getAnimatableNone: $e7a742f3fad51654$var$getAnimatableNone
};

});
parcelRegister("83rBL", function(module, exports) {

$parcel$export(module.exports, "color", () => $8fab0c6f38a4dc71$export$35e9368ef982300f);

var $cg7o1 = parcelRequire("cg7o1");

var $1UGDE = parcelRequire("1UGDE");

var $8AmTf = parcelRequire("8AmTf");

var $BNw1G = parcelRequire("BNw1G");
const $8fab0c6f38a4dc71$export$35e9368ef982300f = {
    test: (v)=>(0, $BNw1G.rgba).test(v) || (0, $1UGDE.hex).test(v) || (0, $8AmTf.hsla).test(v),
    parse: (v)=>{
        if ((0, $BNw1G.rgba).test(v)) return (0, $BNw1G.rgba).parse(v);
        else if ((0, $8AmTf.hsla).test(v)) return (0, $8AmTf.hsla).parse(v);
        else return (0, $1UGDE.hex).parse(v);
    },
    transform: (v)=>{
        return (0, $cg7o1.isString)(v) ? v : v.hasOwnProperty("red") ? (0, $BNw1G.rgba).transform(v) : (0, $8AmTf.hsla).transform(v);
    }
};

});
parcelRegister("1UGDE", function(module, exports) {

$parcel$export(module.exports, "hex", () => $8d734b63a2738875$export$834dfc94dde4b3d8);

var $BNw1G = parcelRequire("BNw1G");

var $6NJZI = parcelRequire("6NJZI");
function $8d734b63a2738875$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $8d734b63a2738875$export$834dfc94dde4b3d8 = {
    test: (0, $6NJZI.isColorString)("#"),
    parse: $8d734b63a2738875$var$parseHex,
    transform: (0, $BNw1G.rgba).transform
};

});
parcelRegister("BNw1G", function(module, exports) {

$parcel$export(module.exports, "rgba", () => $4bb5d6912a4f6a41$export$4e46ac54fc82cf3b);

var $cMkBT = parcelRequire("cMkBT");

var $huvJ8 = parcelRequire("huvJ8");

var $cg7o1 = parcelRequire("cg7o1");

var $6NJZI = parcelRequire("6NJZI");
const $4bb5d6912a4f6a41$var$clampRgbUnit = (v)=>(0, $cMkBT.clamp)(0, 255, v);
const $4bb5d6912a4f6a41$export$7a99c86b5b1f4c9e = {
    ...(0, $huvJ8.number),
    transform: (v)=>Math.round($4bb5d6912a4f6a41$var$clampRgbUnit(v))
};
const $4bb5d6912a4f6a41$export$4e46ac54fc82cf3b = {
    test: (0, $6NJZI.isColorString)("rgb", "red"),
    parse: (0, $6NJZI.splitColor)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $4bb5d6912a4f6a41$export$7a99c86b5b1f4c9e.transform(red) + ", " + $4bb5d6912a4f6a41$export$7a99c86b5b1f4c9e.transform(green) + ", " + $4bb5d6912a4f6a41$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $cg7o1.sanitize)((0, $huvJ8.alpha).transform(alpha$1)) + ")"
};

});
parcelRegister("6NJZI", function(module, exports) {

$parcel$export(module.exports, "isColorString", () => $a0b8b17451eb947e$export$2c8400d58aca05e);
$parcel$export(module.exports, "splitColor", () => $a0b8b17451eb947e$export$73d6f35be992df24);

var $cg7o1 = parcelRequire("cg7o1");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $a0b8b17451eb947e$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $cg7o1.isString)(v) && (0, $cg7o1.singleColorRegex).test(v) && v.startsWith(type) || testProp && !(0, $cg7o1.isNullish)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $a0b8b17451eb947e$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $cg7o1.isString)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $cg7o1.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

});



parcelRegister("8AmTf", function(module, exports) {

$parcel$export(module.exports, "hsla", () => $b9e2a2ebd4ec28e4$export$810b04175080204c);

var $huvJ8 = parcelRequire("huvJ8");

var $ffEe3 = parcelRequire("ffEe3");

var $cg7o1 = parcelRequire("cg7o1");

var $6NJZI = parcelRequire("6NJZI");
const $b9e2a2ebd4ec28e4$export$810b04175080204c = {
    test: (0, $6NJZI.isColorString)("hsl", "hue"),
    parse: (0, $6NJZI.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $ffEe3.percent).transform((0, $cg7o1.sanitize)(saturation)) + ", " + (0, $ffEe3.percent).transform((0, $cg7o1.sanitize)(lightness)) + ", " + (0, $cg7o1.sanitize)((0, $huvJ8.alpha).transform(alpha$1)) + ")";
    }
};

});



parcelRegister("5hjmD", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", () => $11177ab3773e8f83$export$cea0cedcb94873b5);

var $5U4ao = parcelRequire("5U4ao");

var $eIgSo = parcelRequire("eIgSo");

var $lnR8r = parcelRequire("lnR8r");
function $11177ab3773e8f83$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $lnR8r.getDefaultValueType)(key);
    if (defaultValueType !== (0, $eIgSo.filter)) defaultValueType = (0, $5U4ao.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

});
parcelRegister("eIgSo", function(module, exports) {

$parcel$export(module.exports, "filter", () => $3acf618bf899815d$export$3dea766d36a8935f);

var $5U4ao = parcelRequire("5U4ao");

var $cg7o1 = parcelRequire("cg7o1");
/**
 * Properties that should default to 1 or 100%
 */ const $3acf618bf899815d$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $3acf618bf899815d$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $cg7o1.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $3acf618bf899815d$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $3acf618bf899815d$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $3acf618bf899815d$export$3dea766d36a8935f = {
    ...(0, $5U4ao.complex),
    getAnimatableNone: (v)=>{
        const functions = v.match($3acf618bf899815d$var$functionRegex);
        return functions ? functions.map($3acf618bf899815d$var$applyDefaultFilter).join(" ") : v;
    }
};

});

parcelRegister("lnR8r", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", () => $afce7c30e730735c$export$67d1babe0338d23b);

var $83rBL = parcelRequire("83rBL");

var $eIgSo = parcelRequire("eIgSo");

var $1QVwa = parcelRequire("1QVwa");
/**
 * A map of default value types for common values
 */ const $afce7c30e730735c$export$98cd7c72c5a731fb = {
    ...(0, $1QVwa.numberValueTypes),
    color: // Color props
    $83rBL.color,
    backgroundColor: (0, $83rBL.color),
    outlineColor: (0, $83rBL.color),
    fill: (0, $83rBL.color),
    stroke: (0, $83rBL.color),
    // Border props
    borderColor: (0, $83rBL.color),
    borderTopColor: (0, $83rBL.color),
    borderRightColor: (0, $83rBL.color),
    borderBottomColor: (0, $83rBL.color),
    borderLeftColor: (0, $83rBL.color),
    filter: $eIgSo.filter,
    WebkitFilter: (0, $eIgSo.filter)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $afce7c30e730735c$export$67d1babe0338d23b = (key)=>$afce7c30e730735c$export$98cd7c72c5a731fb[key];

});




parcelRegister("1Il6E", function(module, exports) {

$parcel$export(module.exports, "memo", () => $7b3ef5950d3d67ea$export$7c73462e0d25e514);
function $7b3ef5950d3d67ea$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}

});

parcelRegister("6G0lw", function(module, exports) {

$parcel$export(module.exports, "BaseAnimation", () => $c321dd42a838e5c9$export$d1e4f34b9c2550c1);

var $1FIdb = parcelRequire("1FIdb");

var $1HZFh = parcelRequire("1HZFh");

var $h53Av = parcelRequire("h53Av");

var $6OtMl = parcelRequire("6OtMl");
class $c321dd42a838e5c9$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $1FIdb.flushKeyframeResolvers)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $h53Av.canAnimate)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $1HZFh.instantAnimationState).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $6OtMl.getFinalKeyframe)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}

});
parcelRegister("h53Av", function(module, exports) {

$parcel$export(module.exports, "canAnimate", () => $ecce2e9caeb51c59$export$1b109e6c9968df4f);

var $jc7Ow = parcelRequire("jc7Ow");

var $lKo3j = parcelRequire("lKo3j");
function $ecce2e9caeb51c59$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $ecce2e9caeb51c59$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $lKo3j.isAnimatable)(originKeyframe, name);
    const isTargetAnimatable = (0, $lKo3j.isAnimatable)(targetKeyframe, name);
    (0, $jc7Ow.warning)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $ecce2e9caeb51c59$var$hasKeyframesChanged(keyframes) || type === "spring" && velocity;
}

});
parcelRegister("lKo3j", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", () => $a60b6fb088e57e2f$export$65676b58b122bc38);

var $5U4ao = parcelRequire("5U4ao");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $a60b6fb088e57e2f$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $5U4ao.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});



parcelRegister("jKH9j", function(module, exports) {

$parcel$export(module.exports, "MainThreadAnimation", () => $9926540e1dd5ea1a$export$fd98d9cca67a58bc);

var $1FIdb = parcelRequire("1FIdb");

var $8Ybf5 = parcelRequire("8Ybf5");

var $a1gNu = parcelRequire("a1gNu");

var $42Rqk = parcelRequire("42Rqk");

var $6G0lw = parcelRequire("6G0lw");

var $aAuWK = parcelRequire("aAuWK");

var $fMko1 = parcelRequire("fMko1");

var $4z4dP = parcelRequire("4z4dP");

var $lhAHd = parcelRequire("lhAHd");

var $cMkBT = parcelRequire("cMkBT");


var $cB0Bo = parcelRequire("cB0Bo");

var $6OtMl = parcelRequire("6OtMl");
const $9926540e1dd5ea1a$var$generators = {
    decay: (0, $a1gNu.inertia),
    inertia: $a1gNu.inertia,
    tween: (0, $42Rqk.keyframes),
    keyframes: (0, $42Rqk.keyframes),
    spring: $8Ybf5.spring
};
const $9926540e1dd5ea1a$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $9926540e1dd5ea1a$export$fd98d9cca67a58bc extends (0, $6G0lw.BaseAnimation) {
    constructor({ KeyframeResolver: KeyframeResolver$1 = (0, $1FIdb.KeyframeResolver), ...options }){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, keyframes: keyframes } = this.options;
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        if (name && motionValue && motionValue.owner) this.resolver = motionValue.owner.resolveKeyframes(keyframes, onResolved, name, motionValue);
        else this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = $9926540e1dd5ea1a$var$generators[type] || (0, $42Rqk.keyframes);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $42Rqk.keyframes) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $aAuWK.pipe)($9926540e1dd5ea1a$var$percentToProgress, (0, $fMko1.mix)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $4z4dP.calcGeneratorDuration)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $cMkBT.clamp)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $6OtMl.getFinalKeyframe)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $lhAHd.millisecondsToSeconds)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $lhAHd.millisecondsToSeconds)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $lhAHd.secondsToMilliseconds)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $lhAHd.millisecondsToSeconds)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $cB0Bo.frameloopDriver), onPlay: onPlay } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime || this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $9926540e1dd5ea1a$export$ee9b76de7353d815(options) {
    return new $9926540e1dd5ea1a$export$fd98d9cca67a58bc(options);
}

});
parcelRegister("8Ybf5", function(module, exports) {

$parcel$export(module.exports, "spring", () => $15410289e38b98f0$export$b36281d89752ae66);

var $lhAHd = parcelRequire("lhAHd");

var $dQMyd = parcelRequire("dQMyd");

var $dTMve = parcelRequire("dTMve");
const $15410289e38b98f0$var$durationKeys = [
    "duration",
    "bounce"
];
const $15410289e38b98f0$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $15410289e38b98f0$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $15410289e38b98f0$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$15410289e38b98f0$var$isSpringType(options, $15410289e38b98f0$var$physicsKeys) && $15410289e38b98f0$var$isSpringType(options, $15410289e38b98f0$var$durationKeys)) {
        const derived = (0, $dTMve.findSpring)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $15410289e38b98f0$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $15410289e38b98f0$var$getSpringOptions({
        ...options,
        velocity: -(0, $lhAHd.millisecondsToSeconds)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $lhAHd.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $dTMve.calcAngularFreq)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $dQMyd.calcGeneratorVelocity)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}

});
parcelRegister("dQMyd", function(module, exports) {

$parcel$export(module.exports, "calcGeneratorVelocity", () => $b51b930a57d0cb5b$export$854187271d233eb5);

var $iqeM4 = parcelRequire("iqeM4");
const $b51b930a57d0cb5b$var$velocitySampleDuration = 5; // ms
function $b51b930a57d0cb5b$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $b51b930a57d0cb5b$var$velocitySampleDuration, 0);
    return (0, $iqeM4.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

});
parcelRegister("iqeM4", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", () => $7aebbe6d56fa9a90$export$eab0632f7ad4f9d7);
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $7aebbe6d56fa9a90$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});


parcelRegister("dTMve", function(module, exports) {

$parcel$export(module.exports, "findSpring", () => $88ebda9ab67d9bdc$export$b15f158dc6d6f458);
$parcel$export(module.exports, "calcAngularFreq", () => $88ebda9ab67d9bdc$export$5f679887c3a78b15);

var $jc7Ow = parcelRequire("jc7Ow");

var $cMkBT = parcelRequire("cMkBT");

var $lhAHd = parcelRequire("lhAHd");
const $88ebda9ab67d9bdc$var$safeMin = 0.001;
const $88ebda9ab67d9bdc$export$a3cdb76e84ee608e = 0.01;
const $88ebda9ab67d9bdc$export$1824b851fad8862b = 10.0;
const $88ebda9ab67d9bdc$export$ff08f2d53484465 = 0.05;
const $88ebda9ab67d9bdc$export$201ca48e54038115 = 1;
function $88ebda9ab67d9bdc$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $jc7Ow.warning)(duration <= (0, $lhAHd.secondsToMilliseconds)($88ebda9ab67d9bdc$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $cMkBT.clamp)($88ebda9ab67d9bdc$export$ff08f2d53484465, $88ebda9ab67d9bdc$export$201ca48e54038115, dampingRatio);
    duration = (0, $cMkBT.clamp)($88ebda9ab67d9bdc$export$a3cdb76e84ee608e, $88ebda9ab67d9bdc$export$1824b851fad8862b, (0, $lhAHd.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $88ebda9ab67d9bdc$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $88ebda9ab67d9bdc$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $88ebda9ab67d9bdc$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $88ebda9ab67d9bdc$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$88ebda9ab67d9bdc$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $88ebda9ab67d9bdc$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $lhAHd.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $88ebda9ab67d9bdc$var$rootIterations = 12;
function $88ebda9ab67d9bdc$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $88ebda9ab67d9bdc$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $88ebda9ab67d9bdc$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});


parcelRegister("a1gNu", function(module, exports) {

$parcel$export(module.exports, "inertia", () => $03335216e20ea791$export$ee3ff3a17106998);

var $8Ybf5 = parcelRequire("8Ybf5");

var $dQMyd = parcelRequire("dQMyd");
function $03335216e20ea791$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $8Ybf5.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $dQMyd.calcGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

});

parcelRegister("42Rqk", function(module, exports) {

$parcel$export(module.exports, "keyframes", () => $c0d23ab022f1d630$export$d25ddfdf17c3ad3e);

var $2j7GS = parcelRequire("2j7GS");

var $aHZLd = parcelRequire("aHZLd");

var $bTnfL = parcelRequire("bTnfL");

var $bVo2Y = parcelRequire("bVo2Y");

var $aEnkp = parcelRequire("aEnkp");

var $aKiKB = parcelRequire("aKiKB");
function $c0d23ab022f1d630$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $2j7GS.easeInOut)).splice(0, values.length - 1);
}
function $c0d23ab022f1d630$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $aHZLd.isEasingArray)(ease) ? ease.map((0, $bTnfL.easingDefinitionToFunction)) : (0, $bTnfL.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $aKiKB.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $aEnkp.defaultOffset)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $bVo2Y.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $c0d23ab022f1d630$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

});
parcelRegister("2j7GS", function(module, exports) {

$parcel$export(module.exports, "easeIn", () => $5ef32e74d6b80fde$export$929e5a82286172a6);
$parcel$export(module.exports, "easeOut", () => $5ef32e74d6b80fde$export$57636bb43b1ccbb0);
$parcel$export(module.exports, "easeInOut", () => $5ef32e74d6b80fde$export$c07234257a03d5e9);

var $jsv6D = parcelRequire("jsv6D");
const $5ef32e74d6b80fde$export$929e5a82286172a6 = (0, $jsv6D.cubicBezier)(0.42, 0, 1, 1);
const $5ef32e74d6b80fde$export$57636bb43b1ccbb0 = (0, $jsv6D.cubicBezier)(0, 0, 0.58, 1);
const $5ef32e74d6b80fde$export$c07234257a03d5e9 = (0, $jsv6D.cubicBezier)(0.42, 0, 0.58, 1);

});
parcelRegister("jsv6D", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", () => $401a6b3dfff5d158$export$2c575fa1d20488bd);

var $vssLq = parcelRequire("vssLq");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $401a6b3dfff5d158$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $401a6b3dfff5d158$var$subdivisionPrecision = 0.0000001;
const $401a6b3dfff5d158$var$subdivisionMaxIterations = 12;
function $401a6b3dfff5d158$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $401a6b3dfff5d158$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $401a6b3dfff5d158$var$subdivisionPrecision && ++i < $401a6b3dfff5d158$var$subdivisionMaxIterations);
    return currentT;
}
function $401a6b3dfff5d158$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $vssLq.noop;
    const getTForX = (aX)=>$401a6b3dfff5d158$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $401a6b3dfff5d158$var$calcBezier(getTForX(t), mY1, mY2);
}

});


parcelRegister("aHZLd", function(module, exports) {

$parcel$export(module.exports, "isEasingArray", () => $b66f7ebbcecad9d2$export$216948827bbdc797);
const $b66f7ebbcecad9d2$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});

parcelRegister("bTnfL", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", () => $fc776660f79936b3$export$ef97fe084f156ca4);

var $jc7Ow = parcelRequire("jc7Ow");

var $jsv6D = parcelRequire("jsv6D");

var $vssLq = parcelRequire("vssLq");

var $2j7GS = parcelRequire("2j7GS");

var $jrijA = parcelRequire("jrijA");

var $nbWww = parcelRequire("nbWww");

var $5OX2u = parcelRequire("5OX2u");
const $fc776660f79936b3$var$easingLookup = {
    linear: (0, $vssLq.noop),
    easeIn: $2j7GS.easeIn,
    easeInOut: $2j7GS.easeInOut,
    easeOut: $2j7GS.easeOut,
    circIn: $jrijA.circIn,
    circInOut: $jrijA.circInOut,
    circOut: $jrijA.circOut,
    backIn: $nbWww.backIn,
    backInOut: $nbWww.backInOut,
    backOut: $nbWww.backOut,
    anticipate: $5OX2u.anticipate
};
const $fc776660f79936b3$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $jc7Ow.invariant)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $jsv6D.cubicBezier)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $jc7Ow.invariant)($fc776660f79936b3$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $fc776660f79936b3$var$easingLookup[definition];
    }
    return definition;
};

});
parcelRegister("jrijA", function(module, exports) {

$parcel$export(module.exports, "circIn", () => $7188782cac8f103b$export$e444123e42d03385);
$parcel$export(module.exports, "circOut", () => $7188782cac8f103b$export$c8d67a19199d1a50);
$parcel$export(module.exports, "circInOut", () => $7188782cac8f103b$export$30d3455eee55bed5);

var $50Ivk = parcelRequire("50Ivk");

var $hlbiV = parcelRequire("hlbiV");
const $7188782cac8f103b$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $7188782cac8f103b$export$c8d67a19199d1a50 = (0, $hlbiV.reverseEasing)($7188782cac8f103b$export$e444123e42d03385);
const $7188782cac8f103b$export$30d3455eee55bed5 = (0, $50Ivk.mirrorEasing)($7188782cac8f103b$export$e444123e42d03385);

});
parcelRegister("50Ivk", function(module, exports) {

$parcel$export(module.exports, "mirrorEasing", () => $115035b0b1ee0b4f$export$f946554fb8aeaf0d);
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $115035b0b1ee0b4f$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

});

parcelRegister("hlbiV", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", () => $7d8870e55c34c2d5$export$2c07eeff45156d4d);
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $7d8870e55c34c2d5$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);

});


parcelRegister("nbWww", function(module, exports) {

$parcel$export(module.exports, "backOut", () => $5ed1d54ded492049$export$77edfce482316a60);
$parcel$export(module.exports, "backIn", () => $5ed1d54ded492049$export$b01116c84cdfe1a2);
$parcel$export(module.exports, "backInOut", () => $5ed1d54ded492049$export$ddc5fd596f6c71b2);

var $jsv6D = parcelRequire("jsv6D");

var $50Ivk = parcelRequire("50Ivk");

var $hlbiV = parcelRequire("hlbiV");
const $5ed1d54ded492049$export$77edfce482316a60 = (0, $jsv6D.cubicBezier)(0.33, 1.53, 0.69, 0.99);
const $5ed1d54ded492049$export$b01116c84cdfe1a2 = (0, $hlbiV.reverseEasing)($5ed1d54ded492049$export$77edfce482316a60);
const $5ed1d54ded492049$export$ddc5fd596f6c71b2 = (0, $50Ivk.mirrorEasing)($5ed1d54ded492049$export$b01116c84cdfe1a2);

});

parcelRegister("5OX2u", function(module, exports) {

$parcel$export(module.exports, "anticipate", () => $85d6e307dce3d2f9$export$6b0af63b873d419e);

var $nbWww = parcelRequire("nbWww");
const $85d6e307dce3d2f9$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $nbWww.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

});


parcelRegister("bVo2Y", function(module, exports) {

$parcel$export(module.exports, "interpolate", () => $1331b2e7b9d040b2$export$89e29e4ab65e70a9);

var $jc7Ow = parcelRequire("jc7Ow");

var $cMkBT = parcelRequire("cMkBT");

var $aAuWK = parcelRequire("aAuWK");

var $cw1Iu = parcelRequire("cw1Iu");

var $vssLq = parcelRequire("vssLq");

var $fMko1 = parcelRequire("fMko1");
function $1331b2e7b9d040b2$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $fMko1.mix);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $vssLq.noop) : ease;
            mixer = (0, $aAuWK.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $1331b2e7b9d040b2$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $jc7Ow.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $1331b2e7b9d040b2$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $cw1Iu.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $cMkBT.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

});
parcelRegister("cw1Iu", function(module, exports) {

$parcel$export(module.exports, "progress", () => $ab333620f3cf5834$export$504d7abb21fa8c9);
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $ab333620f3cf5834$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});

parcelRegister("fMko1", function(module, exports) {

$parcel$export(module.exports, "mix", () => $d9f147e40c0d4e41$export$2c9e8a9632a706b2);

var $a1S6Z = parcelRequire("a1S6Z");

var $evA7j = parcelRequire("evA7j");
function $d9f147e40c0d4e41$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $evA7j.mixNumber)(from, to, p);
    const mixer = (0, $a1S6Z.getMixer)(from);
    return mixer(from, to);
}

});
parcelRegister("a1S6Z", function(module, exports) {

$parcel$export(module.exports, "getMixer", () => $c7bcdddbedf3f01c$export$36ec24672cd098e0);

var $evA7j = parcelRequire("evA7j");

var $7P78Q = parcelRequire("7P78Q");

var $aAuWK = parcelRequire("aAuWK");

var $jc7Ow = parcelRequire("jc7Ow");

var $83rBL = parcelRequire("83rBL");

var $5U4ao = parcelRequire("5U4ao");

var $9zsdr = parcelRequire("9zsdr");

var $4lf8M = parcelRequire("4lf8M");

var $f30eI = parcelRequire("f30eI");
function $c7bcdddbedf3f01c$var$mixNumber(a, b) {
    return (p)=>(0, $evA7j.mixNumber)(a, b, p);
}
function $c7bcdddbedf3f01c$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $c7bcdddbedf3f01c$var$mixNumber;
    else if (typeof a === "string") return (0, $9zsdr.isCSSVariableToken)(a) ? (0, $f30eI.mixImmediate) : (0, $83rBL.color).test(a) ? (0, $7P78Q.mixColor) : $c7bcdddbedf3f01c$export$65516310a87d8205;
    else if (Array.isArray(a)) return $c7bcdddbedf3f01c$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $83rBL.color).test(a) ? (0, $7P78Q.mixColor) : $c7bcdddbedf3f01c$export$ebc23b6840c51ba1;
    return 0, $f30eI.mixImmediate;
}
function $c7bcdddbedf3f01c$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$c7bcdddbedf3f01c$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $c7bcdddbedf3f01c$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $c7bcdddbedf3f01c$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $c7bcdddbedf3f01c$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $c7bcdddbedf3f01c$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $5U4ao.complex).createTransformer(target);
    const originStats = (0, $5U4ao.analyseComplexValue)(origin);
    const targetStats = (0, $5U4ao.analyseComplexValue)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $4lf8M.invisibleValues).has(origin) && !targetStats.values.length || (0, $4lf8M.invisibleValues).has(target) && !originStats.values.length) return (0, $4lf8M.mixVisibility)(origin, target);
        return (0, $aAuWK.pipe)($c7bcdddbedf3f01c$export$3bbefa2f402845c4($c7bcdddbedf3f01c$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $jc7Ow.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $f30eI.mixImmediate)(origin, target);
    }
};

});
parcelRegister("evA7j", function(module, exports) {

$parcel$export(module.exports, "mixNumber", () => $021a8d1fd997c20c$export$3bb0b4ff1037b8dd);
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $021a8d1fd997c20c$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};

});

parcelRegister("7P78Q", function(module, exports) {

$parcel$export(module.exports, "mixColor", () => $7d606ecad39625c6$export$51e568cf5c039bac);

var $evA7j = parcelRequire("evA7j");

var $jc7Ow = parcelRequire("jc7Ow");

var $3DRpj = parcelRequire("3DRpj");

var $1UGDE = parcelRequire("1UGDE");

var $BNw1G = parcelRequire("BNw1G");

var $8AmTf = parcelRequire("8AmTf");

var $f30eI = parcelRequire("f30eI");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $7d606ecad39625c6$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $7d606ecad39625c6$var$colorTypes = [
    (0, $1UGDE.hex),
    (0, $BNw1G.rgba),
    (0, $8AmTf.hsla)
];
const $7d606ecad39625c6$var$getColorType = (v)=>$7d606ecad39625c6$var$colorTypes.find((type)=>type.test(v));
function $7d606ecad39625c6$var$asRGBA(color) {
    const type = $7d606ecad39625c6$var$getColorType(color);
    (0, $jc7Ow.warning)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $8AmTf.hsla)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $3DRpj.hslaToRgba)(model);
    return model;
}
const $7d606ecad39625c6$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $7d606ecad39625c6$var$asRGBA(from);
    const toRGBA = $7d606ecad39625c6$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $f30eI.mixImmediate)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $7d606ecad39625c6$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $7d606ecad39625c6$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $7d606ecad39625c6$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $evA7j.mixNumber)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $BNw1G.rgba).transform(blended);
    };
};

});
parcelRegister("3DRpj", function(module, exports) {

$parcel$export(module.exports, "hslaToRgba", () => $ff07b3f18e098217$export$6ae64dbcd6bfc33e);
// Adapted from https://gist.github.com/mjackson/5311256
function $ff07b3f18e098217$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $ff07b3f18e098217$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $ff07b3f18e098217$var$hueToRgb(p, q, hue + 1 / 3);
        green = $ff07b3f18e098217$var$hueToRgb(p, q, hue);
        blue = $ff07b3f18e098217$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

});

parcelRegister("f30eI", function(module, exports) {

$parcel$export(module.exports, "mixImmediate", () => $b44269d881bc5f59$export$a6f92d4bae65c0f1);
function $b44269d881bc5f59$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}

});


parcelRegister("4lf8M", function(module, exports) {

$parcel$export(module.exports, "invisibleValues", () => $2734bd6d1d020812$export$e5a55ae567dd4ac7);
$parcel$export(module.exports, "mixVisibility", () => $2734bd6d1d020812$export$fed62ccc3fb1a568);
const $2734bd6d1d020812$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $2734bd6d1d020812$export$fed62ccc3fb1a568(origin, target) {
    if ($2734bd6d1d020812$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}

});




parcelRegister("aEnkp", function(module, exports) {

$parcel$export(module.exports, "defaultOffset", () => $b4f9ddd1f4bf5d9f$export$24dbcec0b26e6d9d);

var $1vJ3I = parcelRequire("1vJ3I");
function $b4f9ddd1f4bf5d9f$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $1vJ3I.fillOffset)(offset, arr.length - 1);
    return offset;
}

});
parcelRegister("1vJ3I", function(module, exports) {

$parcel$export(module.exports, "fillOffset", () => $7782113bf600e4fe$export$dafee61230cf05c6);

var $evA7j = parcelRequire("evA7j");

var $cw1Iu = parcelRequire("cw1Iu");
function $7782113bf600e4fe$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $cw1Iu.progress)(0, remaining, i);
        offset.push((0, $evA7j.mixNumber)(min, 1, offsetProgress));
    }
}

});


parcelRegister("aKiKB", function(module, exports) {

$parcel$export(module.exports, "convertOffsetToTimes", () => $e5233976d54b5f6e$export$2a91b4e3a4539316);
function $e5233976d54b5f6e$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}

});


parcelRegister("4z4dP", function(module, exports) {

$parcel$export(module.exports, "maxGeneratorDuration", () => $7b16f93ee4f2a6f3$export$f4ff70a5b4808fd8);
$parcel$export(module.exports, "calcGeneratorDuration", () => $7b16f93ee4f2a6f3$export$cbdd6b3d40ea54e2);
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $7b16f93ee4f2a6f3$export$f4ff70a5b4808fd8 = 20000;
function $7b16f93ee4f2a6f3$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $7b16f93ee4f2a6f3$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $7b16f93ee4f2a6f3$export$f4ff70a5b4808fd8 ? Infinity : duration;
}

});

parcelRegister("cB0Bo", function(module, exports) {

$parcel$export(module.exports, "frameloopDriver", () => $c844bfda18ce9c2c$export$c1033964b5ad7fef);

var $9KDBY = parcelRequire("9KDBY");

var $gjKjc = parcelRequire("gjKjc");
const $c844bfda18ce9c2c$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $gjKjc.frame).update(passTimestamp, true),
        stop: ()=>(0, $gjKjc.cancelFrame)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $gjKjc.frameData).isProcessing ? (0, $gjKjc.frameData).timestamp : (0, $9KDBY.time).now()
    };
};

});


parcelRegister("6DCo5", function(module, exports) {

$parcel$export(module.exports, "animateStyle", () => $b4777107b62422c4$export$c76cd972d26986f9);

var $aVyud = parcelRequire("aVyud");
function $b4777107b62422c4$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $aVyud.mapEasingToNativeEasing)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}

});
parcelRegister("aVyud", function(module, exports) {

$parcel$export(module.exports, "isWaapiSupportedEasing", () => $4ded4d86393fc684$export$fcdd8f3f2160beda);
$parcel$export(module.exports, "mapEasingToNativeEasing", () => $4ded4d86393fc684$export$916ea73bcd3a6030);

var $kXpmb = parcelRequire("kXpmb");
function $4ded4d86393fc684$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && easing in $4ded4d86393fc684$export$2cf569f5e2221176 || (0, $kXpmb.isBezierDefinition)(easing) || Array.isArray(easing) && easing.every($4ded4d86393fc684$export$fcdd8f3f2160beda));
}
const $4ded4d86393fc684$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $4ded4d86393fc684$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $4ded4d86393fc684$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $4ded4d86393fc684$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $4ded4d86393fc684$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $4ded4d86393fc684$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $4ded4d86393fc684$var$mapEasingToNativeEasingWithDefault(easing) {
    return $4ded4d86393fc684$export$916ea73bcd3a6030(easing) || $4ded4d86393fc684$export$2cf569f5e2221176.easeOut;
}
function $4ded4d86393fc684$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    else if ((0, $kXpmb.isBezierDefinition)(easing)) return $4ded4d86393fc684$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map($4ded4d86393fc684$var$mapEasingToNativeEasingWithDefault);
    else return $4ded4d86393fc684$export$2cf569f5e2221176[easing];
}

});
parcelRegister("kXpmb", function(module, exports) {

$parcel$export(module.exports, "isBezierDefinition", () => $0137eab8a2c8ef68$export$ff43f99925d7366b);
const $0137eab8a2c8ef68$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";

});




parcelRegister("2WyfF", function(module, exports) {

$parcel$export(module.exports, "GroupPlaybackControls", () => $71c2b15e38fc3a48$export$c1e41718f71efe41);

var $aCFyS = parcelRequire("aCFyS");

var $exI0c = parcelRequire("exI0c");
class $71c2b15e38fc3a48$export$c1e41718f71efe41 {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const cancelAll = this.animations.map((animation)=>{
            if ((0, $exI0c.supportsScrollTimeline)() && animation.attachTimeline) animation.attachTimeline(timeline);
            else {
                animation.pause();
                return (0, $aCFyS.observeTimeline)((progress)=>{
                    animation.time = animation.duration * progress;
                }, timeline);
            }
        });
        return ()=>{
            cancelAll.forEach((cancelTimeline, i)=>{
                if (cancelTimeline) cancelTimeline();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}

});
parcelRegister("aCFyS", function(module, exports) {

$parcel$export(module.exports, "observeTimeline", () => $afda186429e01b6e$export$b4f1bbab0c442a76);

var $gjKjc = parcelRequire("gjKjc");
function $afda186429e01b6e$export$b4f1bbab0c442a76(update, timeline) {
    let prevProgress;
    const onFrame = ()=>{
        const { currentTime: currentTime } = timeline;
        const percentage = currentTime === null ? 0 : currentTime.value;
        const progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, $gjKjc.frame).update(onFrame, true);
    return ()=>(0, $gjKjc.cancelFrame)(onFrame);
}

});

parcelRegister("exI0c", function(module, exports) {

$parcel$export(module.exports, "supportsScrollTimeline", () => $361606629ff2f7f5$export$20d68f04f30763a5);

var $1Il6E = parcelRequire("1Il6E");
const $361606629ff2f7f5$export$20d68f04f30763a5 = (0, $1Il6E.memo)(()=>window.ScrollTimeline !== undefined);

});



parcelRegister("4Tom3", function(module, exports) {

$parcel$export(module.exports, "setTarget", () => $1fca9daef8f51b09$export$1f61c53461aff4a5);

var $ylCkB = parcelRequire("ylCkB");

var $dW73m = parcelRequire("dW73m");

var $kz7B1 = parcelRequire("kz7B1");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $1fca9daef8f51b09$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $dW73m.motionValue)(value));
}
function $1fca9daef8f51b09$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $kz7B1.resolveVariant)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $ylCkB.resolveFinalValueInKeyframes)(target[key]);
        $1fca9daef8f51b09$var$setMotionValue(visualElement, key, value);
    }
}

});
parcelRegister("dW73m", function(module, exports) {

$parcel$export(module.exports, "collectMotionValues", () => $08c1d503e6db95ea$export$67fcd818a264039d);
$parcel$export(module.exports, "MotionValue", () => $08c1d503e6db95ea$export$8cea36d14ee64562);
$parcel$export(module.exports, "motionValue", () => $08c1d503e6db95ea$export$ce8bdc721e76545f);

var $eRjGx = parcelRequire("eRjGx");

var $iqeM4 = parcelRequire("iqeM4");


var $9KDBY = parcelRequire("9KDBY");

var $gjKjc = parcelRequire("gjKjc");
/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $08c1d503e6db95ea$var$MAX_VELOCITY_DELTA = 30;
const $08c1d503e6db95ea$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $08c1d503e6db95ea$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $08c1d503e6db95ea$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.3.2";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $9KDBY.time).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $9KDBY.time).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $08c1d503e6db95ea$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $eRjGx.SubscriptionManager)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $gjKjc.frame).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($08c1d503e6db95ea$export$67fcd818a264039d.current) $08c1d503e6db95ea$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $9KDBY.time).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $08c1d503e6db95ea$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $08c1d503e6db95ea$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $iqeM4.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $08c1d503e6db95ea$export$ce8bdc721e76545f(init, options) {
    return new $08c1d503e6db95ea$export$8cea36d14ee64562(init, options);
}

});
parcelRegister("eRjGx", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", () => $3a3115ba31dcf260$export$e7dff9482a5fd23c);

var $fXcrA = parcelRequire("fXcrA");
class $3a3115ba31dcf260$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $fXcrA.addUniqueItem)(this.subscriptions, handler);
        return ()=>(0, $fXcrA.removeItem)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

});



parcelRegister("7EL1Y", function(module, exports) {

$parcel$export(module.exports, "getOptimisedAppearId", () => $b9ed7a09551e04da$export$5f8d21e84d1d84fc);

var $lMutI = parcelRequire("lMutI");
function $b9ed7a09551e04da$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.getProps()[0, $lMutI.optimizedAppearDataAttribute];
}

});

parcelRegister("3COqC", function(module, exports) {

$parcel$export(module.exports, "addValueToWillChange", () => $81ee8ee15a5b8600$export$3ac5aed310be0bee);

var $jifPj = parcelRequire("jifPj");

var $4bPth = parcelRequire("4bPth");
function $81ee8ee15a5b8600$export$3ac5aed310be0bee(visualElement, key) {
    var _a;
    if (!visualElement.applyWillChange) return;
    let willChange = visualElement.getValue("willChange");
    /**
     * If we haven't created a willChange MotionValue, and the we haven't been
     * manually provided one, create one.
     */ if (!willChange && !((_a = visualElement.props.style) === null || _a === void 0 ? void 0 : _a.willChange)) {
        willChange = new (0, $jifPj.WillChangeMotionValue)("auto");
        visualElement.addValue("willChange", willChange);
    }
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $4bPth.isWillChangeMotionValue)(willChange)) return willChange.add(key);
}

});
parcelRegister("jifPj", function(module, exports) {

$parcel$export(module.exports, "WillChangeMotionValue", () => $26cbeb92e1f1fcb1$export$3fe5fa490af65f85);

var $eaulW = parcelRequire("eaulW");

var $dW73m = parcelRequire("dW73m");

var $ejOow = parcelRequire("ejOow");

var $fXcrA = parcelRequire("fXcrA");
class $26cbeb92e1f1fcb1$export$3fe5fa490af65f85 extends (0, $dW73m.MotionValue) {
    constructor(){
        super(...arguments);
        this.output = [];
        this.counts = new Map();
    }
    add(name) {
        const styleName = (0, $ejOow.getWillChangeName)(name);
        if (!styleName) return;
        /**
         * Update counter. Each value has an indepdent counter
         * as multiple sources could be requesting the same value
         * gets added to will-change.
         */ const prevCount = this.counts.get(styleName) || 0;
        this.counts.set(styleName, prevCount + 1);
        if (prevCount === 0) {
            this.output.push(styleName);
            this.update();
        }
        /**
         * Prevents the remove function from being called multiple times.
         */ let hasRemoved = false;
        return ()=>{
            if (hasRemoved) return;
            hasRemoved = true;
            const newCount = this.counts.get(styleName) - 1;
            this.counts.set(styleName, newCount);
            if (newCount === 0) {
                (0, $fXcrA.removeItem)(this.output, styleName);
                this.update();
            }
        };
    }
    update() {
        this.set(this.output.length ? this.output.join(", ") : "auto");
    }
}
function $26cbeb92e1f1fcb1$export$384afe146fc0c056() {
    return (0, $eaulW.useConstant)(()=>new $26cbeb92e1f1fcb1$export$3fe5fa490af65f85("auto"));
}

});

parcelRegister("4bPth", function(module, exports) {

$parcel$export(module.exports, "isWillChangeMotionValue", () => $160667ddaf7dcc4c$export$98397f3adbf6259f);

var $6ym6A = parcelRequire("6ym6A");
function $160667ddaf7dcc4c$export$98397f3adbf6259f(value) {
    return Boolean((0, $6ym6A.isMotionValue)(value) && value.add);
}

});



parcelRegister("b3tnl", function(module, exports) {

$parcel$export(module.exports, "animateVariant", () => $5d5adf2261ed9097$export$4709dc300705b2af);

var $kz7B1 = parcelRequire("kz7B1");

var $6VfLK = parcelRequire("6VfLK");
function $5d5adf2261ed9097$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $kz7B1.resolveVariant)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $6VfLK.animateTarget)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $5d5adf2261ed9097$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $5d5adf2261ed9097$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($5d5adf2261ed9097$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($5d5adf2261ed9097$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $5d5adf2261ed9097$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}

});




parcelRegister("hzbY1", function(module, exports) {

$parcel$export(module.exports, "ExitAnimationFeature", () => $7c73422ccd03970f$export$4989d1eb6104cc6c);

var $4A0s3 = parcelRequire("4A0s3");
let $7c73422ccd03970f$var$id = 0;
class $7c73422ccd03970f$export$4989d1eb6104cc6c extends (0, $4A0s3.Feature) {
    constructor(){
        super(...arguments);
        this.id = $7c73422ccd03970f$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}

});


parcelRegister("7h5Dc", function(module, exports) {

$parcel$export(module.exports, "drag", () => $3f005cc90a7b4137$export$d7d5d435647ed5a0);

var $839GZ = parcelRequire("839GZ");

var $4k2Ss = parcelRequire("4k2Ss");

var $1iab6 = parcelRequire("1iab6");

var $bVwFV = parcelRequire("bVwFV");
const $3f005cc90a7b4137$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $4k2Ss.PanGesture)
    },
    drag: {
        Feature: (0, $839GZ.DragGesture),
        ProjectionNode: (0, $bVwFV.HTMLProjectionNode),
        MeasureLayout: $1iab6.MeasureLayout
    }
};

});
parcelRegister("839GZ", function(module, exports) {

$parcel$export(module.exports, "DragGesture", () => $0c5e4ca4fdfedd18$export$5d97dc2872682820);

var $4A0s3 = parcelRequire("4A0s3");

var $vssLq = parcelRequire("vssLq");

var $iuhe8 = parcelRequire("iuhe8");
class $0c5e4ca4fdfedd18$export$5d97dc2872682820 extends (0, $4A0s3.Feature) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $vssLq.noop);
        this.removeListeners = (0, $vssLq.noop);
        this.controls = new (0, $iuhe8.VisualElementDragControls)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $vssLq.noop);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}

});
parcelRegister("iuhe8", function(module, exports) {

$parcel$export(module.exports, "VisualElementDragControls", () => $92d2231cd634a15e$export$86bff71f18910307);

var $jc7Ow = parcelRequire("jc7Ow");

var $eLE5U = parcelRequire("eLE5U");

var $41uBy = parcelRequire("41uBy");

var $2S2Xa = parcelRequire("2S2Xa");

var $7Y6Zq = parcelRequire("7Y6Zq");

var $ddCvt = parcelRequire("ddCvt");

var $cjTwS = parcelRequire("cjTwS");

var $g9u8e = parcelRequire("g9u8e");

var $dQjRp = parcelRequire("dQjRp");

var $g81Jb = parcelRequire("g81Jb");

var $l6VHE = parcelRequire("l6VHE");

var $3M4VH = parcelRequire("3M4VH");

var $5SWta = parcelRequire("5SWta");

var $evA7j = parcelRequire("evA7j");

var $ffEe3 = parcelRequire("ffEe3");

var $5xu5L = parcelRequire("5xu5L");

var $dXwvF = parcelRequire("dXwvF");

var $3COqC = parcelRequire("3COqC");

var $gjKjc = parcelRequire("gjKjc");
const $92d2231cd634a15e$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $92d2231cd634a15e$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $cjTwS.createBox)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $g81Jb.extractEventInfo)(event, "page").point);
        };
        const onStart = (event, info)=>{
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $41uBy.getGlobalLock)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $g9u8e.eachAxis)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $ffEe3.percent).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $5SWta.calcLength)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $gjKjc.frame).postRender(()=>onDragStart(event, info));
            (_a = this.removeWillChange) === null || _a === void 0 || _a.call(this);
            this.removeWillChange = (0, $3COqC.addValueToWillChange)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $92d2231cd634a15e$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $g9u8e.eachAxis)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $eLE5U.PanSession)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $dXwvF.getContextWindow)(this.visualElement)
        });
    }
    stop(event, info) {
        var _a;
        (_a = this.removeWillChange) === null || _a === void 0 || _a.call(this);
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $gjKjc.frame).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$92d2231cd634a15e$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $ddCvt.applyConstraints)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $2S2Xa.isRefObject)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $ddCvt.calcRelativeConstraints)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $ddCvt.resolveDragElastic)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $g9u8e.eachAxis)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $ddCvt.rebaseAxisConstraints)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $2S2Xa.isRefObject)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $jc7Ow.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $dQjRp.measurePageBox)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $ddCvt.calcViewportConstraints)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $l6VHE.convertBoxToBoundingBox)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $l6VHE.convertBoundingBoxToBox)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $g9u8e.eachAxis)((axis)=>{
            if (!$92d2231cd634a15e$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $5xu5L.animateMotionValue)(axis, axisValue, 0, transition, this.visualElement, false, (0, $3COqC.addValueToWillChange)(this.visualElement, axis)));
    }
    stopAnimation() {
        (0, $g9u8e.eachAxis)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $g9u8e.eachAxis)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $g9u8e.eachAxis)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$92d2231cd634a15e$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $evA7j.mixNumber)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $2S2Xa.isRefObject)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $g9u8e.eachAxis)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $ddCvt.calcOrigin)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $g9u8e.eachAxis)((axis)=>{
            if (!$92d2231cd634a15e$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $evA7j.mixNumber)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $92d2231cd634a15e$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $7Y6Zq.addPointerEvent)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $2S2Xa.isRefObject)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $gjKjc.frame).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $3M4VH.addDomEvent)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $g9u8e.eachAxis)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $ddCvt.defaultElastic), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $92d2231cd634a15e$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $92d2231cd634a15e$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

});
parcelRegister("eLE5U", function(module, exports) {

$parcel$export(module.exports, "PanSession", () => $13ec6b4d04b58085$export$d9c66232c9c4689c);

var $g81Jb = parcelRequire("g81Jb");

var $lhAHd = parcelRequire("lhAHd");

var $7Y6Zq = parcelRequire("7Y6Zq");

var $aAuWK = parcelRequire("aAuWK");

var $jAwjS = parcelRequire("jAwjS");

var $k4kCH = parcelRequire("k4kCH");

var $gjKjc = parcelRequire("gjKjc");
/**
 * @internal
 */ class $13ec6b4d04b58085$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $13ec6b4d04b58085$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $jAwjS.distance2D)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $gjKjc.frameData);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $13ec6b4d04b58085$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $gjKjc.frame).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $13ec6b4d04b58085$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $13ec6b4d04b58085$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $k4kCH.isPrimaryPointer)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $g81Jb.extractEventInfo)(event);
        const initialInfo = $13ec6b4d04b58085$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $gjKjc.frameData);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $13ec6b4d04b58085$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $aAuWK.pipe)((0, $7Y6Zq.addPointerEvent)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $7Y6Zq.addPointerEvent)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $7Y6Zq.addPointerEvent)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $gjKjc.cancelFrame)(this.updatePoint);
    }
}
function $13ec6b4d04b58085$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $13ec6b4d04b58085$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $13ec6b4d04b58085$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $13ec6b4d04b58085$var$subtractPoint(point, $13ec6b4d04b58085$var$lastDevicePoint(history)),
        offset: $13ec6b4d04b58085$var$subtractPoint(point, $13ec6b4d04b58085$var$startDevicePoint(history)),
        velocity: $13ec6b4d04b58085$var$getVelocity(history, 0.1)
    };
}
function $13ec6b4d04b58085$var$startDevicePoint(history) {
    return history[0];
}
function $13ec6b4d04b58085$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $13ec6b4d04b58085$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $13ec6b4d04b58085$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $lhAHd.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $lhAHd.millisecondsToSeconds)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

});
parcelRegister("jAwjS", function(module, exports) {

$parcel$export(module.exports, "distance2D", () => $81c0f0542a54a2a4$export$503a1d513f12e38b);
const $81c0f0542a54a2a4$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $81c0f0542a54a2a4$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $81c0f0542a54a2a4$export$9f17032d917177de(a.x, b.x);
    const yDelta = $81c0f0542a54a2a4$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

});


parcelRegister("ddCvt", function(module, exports) {

$parcel$export(module.exports, "applyConstraints", () => $3be9608f7aab59b2$export$b3c764d3fca3ffe3);
$parcel$export(module.exports, "calcRelativeConstraints", () => $3be9608f7aab59b2$export$4e9195bf7793bc78);
$parcel$export(module.exports, "calcViewportConstraints", () => $3be9608f7aab59b2$export$4228500f19d4cdf7);
$parcel$export(module.exports, "calcOrigin", () => $3be9608f7aab59b2$export$13abbfca044ca46d);
$parcel$export(module.exports, "rebaseAxisConstraints", () => $3be9608f7aab59b2$export$e9672cc4c36a8b87);
$parcel$export(module.exports, "defaultElastic", () => $3be9608f7aab59b2$export$a3366d3bac43a742);
$parcel$export(module.exports, "resolveDragElastic", () => $3be9608f7aab59b2$export$7c5eaef8f4723d22);

var $cw1Iu = parcelRequire("cw1Iu");

var $5SWta = parcelRequire("5SWta");

var $cMkBT = parcelRequire("cMkBT");

var $evA7j = parcelRequire("evA7j");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $3be9608f7aab59b2$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $evA7j.mixNumber)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $evA7j.mixNumber)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $3be9608f7aab59b2$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $3be9608f7aab59b2$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $3be9608f7aab59b2$export$690c180aa5775042(layoutBox.x, left, right),
        y: $3be9608f7aab59b2$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $3be9608f7aab59b2$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $3be9608f7aab59b2$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $3be9608f7aab59b2$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $3be9608f7aab59b2$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $3be9608f7aab59b2$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $5SWta.calcLength)(source);
    const targetLength = (0, $5SWta.calcLength)(target);
    if (targetLength > sourceLength) origin = (0, $cw1Iu.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $cw1Iu.progress)(source.min, source.max - targetLength, target.min);
    return (0, $cMkBT.clamp)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $3be9608f7aab59b2$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $3be9608f7aab59b2$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $3be9608f7aab59b2$export$7c5eaef8f4723d22(dragElastic = $3be9608f7aab59b2$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $3be9608f7aab59b2$export$a3366d3bac43a742;
    return {
        x: $3be9608f7aab59b2$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $3be9608f7aab59b2$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $3be9608f7aab59b2$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $3be9608f7aab59b2$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $3be9608f7aab59b2$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $3be9608f7aab59b2$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

});
parcelRegister("5SWta", function(module, exports) {

$parcel$export(module.exports, "calcLength", () => $6bbc55ec01c2a1db$export$c1c127004b72a37);
$parcel$export(module.exports, "isNear", () => $6bbc55ec01c2a1db$export$28d0384c4b79bde2);
$parcel$export(module.exports, "calcBoxDelta", () => $6bbc55ec01c2a1db$export$c0d25e96fc67d310);
$parcel$export(module.exports, "calcRelativeBox", () => $6bbc55ec01c2a1db$export$426154f9d100f99);
$parcel$export(module.exports, "calcRelativePosition", () => $6bbc55ec01c2a1db$export$2785bfcc929c5650);

var $evA7j = parcelRequire("evA7j");
function $6bbc55ec01c2a1db$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $6bbc55ec01c2a1db$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $6bbc55ec01c2a1db$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $evA7j.mixNumber)(source.min, source.max, delta.origin);
    delta.scale = $6bbc55ec01c2a1db$export$c1c127004b72a37(target) / $6bbc55ec01c2a1db$export$c1c127004b72a37(source);
    if ($6bbc55ec01c2a1db$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $evA7j.mixNumber)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($6bbc55ec01c2a1db$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $6bbc55ec01c2a1db$export$c0d25e96fc67d310(delta, source, target, origin) {
    $6bbc55ec01c2a1db$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $6bbc55ec01c2a1db$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $6bbc55ec01c2a1db$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $6bbc55ec01c2a1db$export$c1c127004b72a37(relative);
}
function $6bbc55ec01c2a1db$export$426154f9d100f99(target, relative, parent) {
    $6bbc55ec01c2a1db$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $6bbc55ec01c2a1db$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $6bbc55ec01c2a1db$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $6bbc55ec01c2a1db$export$c1c127004b72a37(layout);
}
function $6bbc55ec01c2a1db$export$2785bfcc929c5650(target, layout, parent) {
    $6bbc55ec01c2a1db$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $6bbc55ec01c2a1db$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}

});


parcelRegister("cjTwS", function(module, exports) {

$parcel$export(module.exports, "createDelta", () => $e0a33d931f61adc7$export$3d227df54007d73a);
$parcel$export(module.exports, "createBox", () => $e0a33d931f61adc7$export$6459fc9e86be362e);
const $e0a33d931f61adc7$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $e0a33d931f61adc7$export$3d227df54007d73a = ()=>({
        x: $e0a33d931f61adc7$export$ff25708b37f72782(),
        y: $e0a33d931f61adc7$export$ff25708b37f72782()
    });
const $e0a33d931f61adc7$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $e0a33d931f61adc7$export$6459fc9e86be362e = ()=>({
        x: $e0a33d931f61adc7$export$6db76765312617ac(),
        y: $e0a33d931f61adc7$export$6db76765312617ac()
    });

});

parcelRegister("g9u8e", function(module, exports) {

$parcel$export(module.exports, "eachAxis", () => $ae09f23cea39e723$export$b789de563eb43b1);
function $ae09f23cea39e723$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

});

parcelRegister("dQjRp", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", () => $6687426c1ecb7751$export$d8718b6a7e5c624e);
$parcel$export(module.exports, "measurePageBox", () => $6687426c1ecb7751$export$6a597be7a7940a96);

var $l6VHE = parcelRequire("l6VHE");

var $kYtoI = parcelRequire("kYtoI");
function $6687426c1ecb7751$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $l6VHE.convertBoundingBoxToBox)((0, $l6VHE.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $6687426c1ecb7751$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $6687426c1ecb7751$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $kYtoI.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, $kYtoI.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

});
parcelRegister("l6VHE", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", () => $97a28ec3aec8cbdc$export$d3955c6a8f65a36b);
$parcel$export(module.exports, "convertBoxToBoundingBox", () => $97a28ec3aec8cbdc$export$b6b9cd4198191a47);
$parcel$export(module.exports, "transformBoxPoints", () => $97a28ec3aec8cbdc$export$21543fb75483a50);
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $97a28ec3aec8cbdc$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $97a28ec3aec8cbdc$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $97a28ec3aec8cbdc$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});

parcelRegister("kYtoI", function(module, exports) {

$parcel$export(module.exports, "scalePoint", () => $27c01630b40cfd19$export$2290ec7febe36dd6);
$parcel$export(module.exports, "applyBoxDelta", () => $27c01630b40cfd19$export$d80074982803af5c);
$parcel$export(module.exports, "applyTreeDeltas", () => $27c01630b40cfd19$export$e2a980535c55eabb);
$parcel$export(module.exports, "transformBox", () => $27c01630b40cfd19$export$58b16271041fbfb);
$parcel$export(module.exports, "translateAxis", () => $27c01630b40cfd19$export$a807a5ce5ebb3895);

var $evA7j = parcelRequire("evA7j");

var $48MuY = parcelRequire("48MuY");
/**
 * Scales a point based on a factor and an originPoint
 */ function $27c01630b40cfd19$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $27c01630b40cfd19$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $27c01630b40cfd19$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $27c01630b40cfd19$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $27c01630b40cfd19$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $27c01630b40cfd19$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $27c01630b40cfd19$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $27c01630b40cfd19$export$d80074982803af5c(box, { x: x, y: y }) {
    $27c01630b40cfd19$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $27c01630b40cfd19$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $27c01630b40cfd19$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $27c01630b40cfd19$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $27c01630b40cfd19$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $48MuY.hasTransform)(node.latestValues)) $27c01630b40cfd19$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $27c01630b40cfd19$var$snapToDefault(treeScale.x);
    treeScale.y = $27c01630b40cfd19$var$snapToDefault(treeScale.y);
}
function $27c01630b40cfd19$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $27c01630b40cfd19$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $27c01630b40cfd19$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $evA7j.mixNumber)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $27c01630b40cfd19$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $27c01630b40cfd19$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $27c01630b40cfd19$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $27c01630b40cfd19$export$58b16271041fbfb(box, transform) {
    $27c01630b40cfd19$export$625f1dd140a2f5e7(box.x, transform, $27c01630b40cfd19$var$xKeys);
    $27c01630b40cfd19$export$625f1dd140a2f5e7(box.y, transform, $27c01630b40cfd19$var$yKeys);
}

});
parcelRegister("48MuY", function(module, exports) {

$parcel$export(module.exports, "hasScale", () => $c51ebbcf9242c4e2$export$bdf30dca883ea463);
$parcel$export(module.exports, "hasTransform", () => $c51ebbcf9242c4e2$export$a545127cf1fbb600);
$parcel$export(module.exports, "has2DTranslate", () => $c51ebbcf9242c4e2$export$bf80f5f8f4dc327f);
function $c51ebbcf9242c4e2$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $c51ebbcf9242c4e2$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$c51ebbcf9242c4e2$var$isIdentityScale(scale) || !$c51ebbcf9242c4e2$var$isIdentityScale(scaleX) || !$c51ebbcf9242c4e2$var$isIdentityScale(scaleY);
}
function $c51ebbcf9242c4e2$export$a545127cf1fbb600(values) {
    return $c51ebbcf9242c4e2$export$bdf30dca883ea463(values) || $c51ebbcf9242c4e2$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $c51ebbcf9242c4e2$export$bf80f5f8f4dc327f(values) {
    return $c51ebbcf9242c4e2$var$is2DTranslate(values.x) || $c51ebbcf9242c4e2$var$is2DTranslate(values.y);
}
function $c51ebbcf9242c4e2$var$is2DTranslate(value) {
    return value && value !== "0%";
}

});



parcelRegister("dXwvF", function(module, exports) {

$parcel$export(module.exports, "getContextWindow", () => $a8ba3b6067865902$export$d533d84f9871c879);
// Fixes https://github.com/framer/motion/issues/2270
const $a8ba3b6067865902$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};

});



parcelRegister("4k2Ss", function(module, exports) {

$parcel$export(module.exports, "PanGesture", () => $465e7ed8853b1abc$export$b4f8f1ee75ce5859);

var $eLE5U = parcelRequire("eLE5U");

var $7Y6Zq = parcelRequire("7Y6Zq");

var $4A0s3 = parcelRequire("4A0s3");

var $vssLq = parcelRequire("vssLq");

var $dXwvF = parcelRequire("dXwvF");

var $gjKjc = parcelRequire("gjKjc");
const $465e7ed8853b1abc$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $gjKjc.frame).postRender(()=>handler(event, info));
    };
class $465e7ed8853b1abc$export$b4f8f1ee75ce5859 extends (0, $4A0s3.Feature) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $vssLq.noop);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $eLE5U.PanSession)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $dXwvF.getContextWindow)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $465e7ed8853b1abc$var$asyncHandler(onPanSessionStart),
            onStart: $465e7ed8853b1abc$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $gjKjc.frame).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $7Y6Zq.addPointerEvent)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}

});

parcelRegister("1iab6", function(module, exports) {

$parcel$export(module.exports, "MeasureLayout", () => $a6f1e07772ef211b$export$779f5fb01ad751cd);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $luPGt = parcelRequire("luPGt");

var $l8veq = parcelRequire("l8veq");

var $dtZWn = parcelRequire("dtZWn");

var $hY3yK = parcelRequire("hY3yK");

var $01Aty = parcelRequire("01Aty");

var $cyRTq = parcelRequire("cyRTq");

var $jb3dc = parcelRequire("jb3dc");

var $lvKul = parcelRequire("lvKul");

var $gjKjc = parcelRequire("gjKjc");
class $a6f1e07772ef211b$var$MeasureLayoutWithContext extends (0, $81g6h.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $jb3dc.addScaleCorrector)($a6f1e07772ef211b$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $hY3yK.globalProjectionState).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $gjKjc.frame).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $lvKul.microtask).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $a6f1e07772ef211b$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $luPGt.usePresence)();
    const layoutGroup = (0, $81g6h.useContext)((0, $l8veq.LayoutGroupContext));
    return (0, $iKObn.jsx)($a6f1e07772ef211b$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $81g6h.useContext)((0, $dtZWn.SwitchLayoutGroupContext)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $a6f1e07772ef211b$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $01Aty.correctBorderRadius),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $01Aty.correctBorderRadius),
    borderTopRightRadius: (0, $01Aty.correctBorderRadius),
    borderBottomLeftRadius: (0, $01Aty.correctBorderRadius),
    borderBottomRightRadius: (0, $01Aty.correctBorderRadius),
    boxShadow: (0, $cyRTq.correctBoxShadow)
};

});
parcelRegister("luPGt", function(module, exports) {

$parcel$export(module.exports, "usePresence", () => $2301ed0b14d18ab1$export$2a8c16d82a0a0e26);

var $81g6h = parcelRequire("81g6h");

var $iU7u9 = parcelRequire("iU7u9");
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $2301ed0b14d18ab1$export$2a8c16d82a0a0e26() {
    const context = (0, $81g6h.useContext)((0, $iU7u9.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $81g6h.useId)();
    (0, $81g6h.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $2301ed0b14d18ab1$export$8249053f690ea39a() {
    return $2301ed0b14d18ab1$export$ee27c052bca048fb((0, $81g6h.useContext)((0, $iU7u9.PresenceContext)));
}
function $2301ed0b14d18ab1$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}

});

parcelRegister("hY3yK", function(module, exports) {

$parcel$export(module.exports, "globalProjectionState", () => $fc01a224bd1a13eb$export$97db156a3ed1593b);
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $fc01a224bd1a13eb$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};

});

parcelRegister("01Aty", function(module, exports) {

$parcel$export(module.exports, "correctBorderRadius", () => $7d339c330dbefb4a$export$5eafb6257a5844c);

var $ffEe3 = parcelRequire("ffEe3");
function $7d339c330dbefb4a$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $7d339c330dbefb4a$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $ffEe3.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $7d339c330dbefb4a$export$fafff692be55225d(latest, node.target.x);
        const y = $7d339c330dbefb4a$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};

});

parcelRegister("cyRTq", function(module, exports) {

$parcel$export(module.exports, "correctBoxShadow", () => $0377dfd99bde52e1$export$eb0bc629e74dcf8);

var $evA7j = parcelRequire("evA7j");

var $5U4ao = parcelRequire("5U4ao");
const $0377dfd99bde52e1$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $5U4ao.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $5U4ao.complex).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $evA7j.mixNumber)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};

});


parcelRegister("bVwFV", function(module, exports) {

$parcel$export(module.exports, "HTMLProjectionNode", () => $1fdd56dd034aeb8f$export$b61a9eb3dbde8858);

var $7j4zl = parcelRequire("7j4zl");

var $8iTjS = parcelRequire("8iTjS");
const $1fdd56dd034aeb8f$export$b91509fcf893b648 = {
    current: undefined
};
const $1fdd56dd034aeb8f$export$b61a9eb3dbde8858 = (0, $7j4zl.createProjectionNode)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$1fdd56dd034aeb8f$export$b91509fcf893b648.current) {
            const documentNode = new (0, $8iTjS.DocumentProjectionNode)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $1fdd56dd034aeb8f$export$b91509fcf893b648.current = documentNode;
        }
        return $1fdd56dd034aeb8f$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});

});
parcelRegister("7j4zl", function(module, exports) {

$parcel$export(module.exports, "createProjectionNode", () => $5215f3f95c6e47c6$export$a84b61f69daa9da0);

var $eRjGx = parcelRequire("eRjGx");

var $ab6go = parcelRequire("ab6go");

var $eCOas = parcelRequire("eCOas");

var $kYtoI = parcelRequire("kYtoI");

var $5SWta = parcelRequire("5SWta");

var $cF678 = parcelRequire("cF678");

var $cjTwS = parcelRequire("cjTwS");

var $2GyY3 = parcelRequire("2GyY3");

var $lYce6 = parcelRequire("lYce6");

var $6nuKc = parcelRequire("6nuKc");

var $jb3dc = parcelRequire("jb3dc");

var $cpZpM = parcelRequire("cpZpM");

var $g9u8e = parcelRequire("g9u8e");

var $48MuY = parcelRequire("48MuY");

var $dnJld = parcelRequire("dnJld");

var $5KSww = parcelRequire("5KSww");

var $hY3yK = parcelRequire("hY3yK");

var $2UAy6 = parcelRequire("2UAy6");

var $evA7j = parcelRequire("evA7j");

var $k1WBq = parcelRequire("k1WBq");

var $c3rG3 = parcelRequire("c3rG3");

var $eRt7D = parcelRequire("eRt7D");

var $cMkBT = parcelRequire("cMkBT");

var $gjKjc = parcelRequire("gjKjc");

var $vssLq = parcelRequire("vssLq");

var $9KDBY = parcelRequire("9KDBY");

var $lvKul = parcelRequire("lvKul");

var $7EL1Y = parcelRequire("7EL1Y");
const $5215f3f95c6e47c6$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $5215f3f95c6e47c6$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $5215f3f95c6e47c6$var$animationTarget = 1000;
let $5215f3f95c6e47c6$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $5215f3f95c6e47c6$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $5215f3f95c6e47c6$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $5215f3f95c6e47c6$var$isOptimisedAppearTree(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return false;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return false;
    else if ((0, $7EL1Y.getOptimisedAppearId)(visualElement)) return true;
    else if (projectionNode.parent && !projectionNode.parent.hasCheckedOptimisedAppear) return $5215f3f95c6e47c6$var$isOptimisedAppearTree(projectionNode.parent);
    else return false;
}
function $5215f3f95c6e47c6$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $5215f3f95c6e47c6$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $5215f3f95c6e47c6$var$projectionFrameData.totalNodes = $5215f3f95c6e47c6$var$projectionFrameData.resolvedTargetDeltas = $5215f3f95c6e47c6$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($5215f3f95c6e47c6$export$131f2f0cc5fe9609);
                this.nodes.forEach($5215f3f95c6e47c6$var$resolveTargetDelta);
                this.nodes.forEach($5215f3f95c6e47c6$var$calcProjection);
                this.nodes.forEach($5215f3f95c6e47c6$export$c2664f37bc951031);
                (0, $k1WBq.record)($5215f3f95c6e47c6$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $dnJld.FlatTree)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $eRjGx.SubscriptionManager)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $c3rG3.isSVGElement)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $2UAy6.delay)(resizeUnblockUpdate, 250);
                    if ((0, $hY3yK.globalProjectionState).hasAnimatedSinceResize) {
                        (0, $hY3yK.globalProjectionState).hasAnimatedSinceResize = false;
                        this.nodes.forEach($5215f3f95c6e47c6$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $5215f3f95c6e47c6$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $lYce6.boxEqualsRounded)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $2GyY3.getValueTransition)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $5215f3f95c6e47c6$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $gjKjc.cancelFrame)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($5215f3f95c6e47c6$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.HandoffCancelAllAnimations && $5215f3f95c6e47c6$var$isOptimisedAppearTree(this)) window.HandoffCancelAllAnimations();
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($5215f3f95c6e47c6$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($5215f3f95c6e47c6$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($5215f3f95c6e47c6$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($5215f3f95c6e47c6$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($5215f3f95c6e47c6$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $9KDBY.time).now();
            (0, $gjKjc.frameData).delta = (0, $cMkBT.clamp)(0, 1000 / 60, now - (0, $gjKjc.frameData).timestamp);
            (0, $gjKjc.frameData).timestamp = now;
            (0, $gjKjc.frameData).isProcessing = true;
            (0, $gjKjc.steps).update.process((0, $gjKjc.frameData));
            (0, $gjKjc.steps).preRender.process((0, $gjKjc.frameData));
            (0, $gjKjc.steps).render.process((0, $gjKjc.frameData));
            (0, $gjKjc.frameData).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $lvKul.microtask).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($5215f3f95c6e47c6$var$clearSnapshot);
            this.sharedNodes.forEach($5215f3f95c6e47c6$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $gjKjc.frame).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $gjKjc.frame).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $cjTwS.createBox)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $lYce6.isDeltaZero)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $48MuY.hasTransform)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $5215f3f95c6e47c6$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $cjTwS.createBox)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $kYtoI.translateAxis)(box.x, scroll.offset.x);
                (0, $kYtoI.translateAxis)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $cjTwS.createBox)();
            (0, $eCOas.copyBoxInto)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $eCOas.copyBoxInto)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $kYtoI.translateAxis)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $kYtoI.translateAxis)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $kYtoI.translateAxis)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $kYtoI.translateAxis)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $cjTwS.createBox)();
            (0, $eCOas.copyBoxInto)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $kYtoI.transformBox)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $48MuY.hasTransform)(node.latestValues)) continue;
                (0, $kYtoI.transformBox)(withTransforms, node.latestValues);
            }
            if ((0, $48MuY.hasTransform)(this.latestValues)) (0, $kYtoI.transformBox)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $cjTwS.createBox)();
            (0, $eCOas.copyBoxInto)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $48MuY.hasTransform)(node.latestValues)) continue;
                (0, $48MuY.hasScale)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $cjTwS.createBox)();
                const nodeBox = node.measurePageBox();
                (0, $eCOas.copyBoxInto)(sourceBox, nodeBox);
                (0, $cF678.removeBoxTransforms)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $48MuY.hasTransform)(this.latestValues)) (0, $cF678.removeBoxTransforms)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $gjKjc.frameData).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $gjKjc.frameData).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $cjTwS.createBox)();
                    this.relativeTargetOrigin = (0, $cjTwS.createBox)();
                    (0, $5SWta.calcRelativePosition)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $eCOas.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $cjTwS.createBox)();
                this.targetWithTransforms = (0, $cjTwS.createBox)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $5SWta.calcRelativeBox)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $eCOas.copyBoxInto)(this.target, this.layout.layoutBox);
                (0, $kYtoI.applyBoxDelta)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $eCOas.copyBoxInto)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $cjTwS.createBox)();
                    this.relativeTargetOrigin = (0, $cjTwS.createBox)();
                    (0, $5SWta.calcRelativePosition)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $eCOas.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $5215f3f95c6e47c6$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $48MuY.hasScale)(this.parent.latestValues) || (0, $48MuY.has2DTranslate)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $gjKjc.frameData).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $eCOas.copyBoxInto)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $kYtoI.applyTreeDeltas)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $cjTwS.createBox)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionDelta = (0, $cjTwS.createDelta)();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $cjTwS.createDelta)();
                this.projectionDeltaWithTransform = (0, $cjTwS.createDelta)();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $5SWta.calcBoxDelta)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $cpZpM.buildProjectionTransform)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $5215f3f95c6e47c6$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $cjTwS.createDelta)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $cjTwS.createBox)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($5215f3f95c6e47c6$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $5215f3f95c6e47c6$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $5215f3f95c6e47c6$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $5SWta.calcRelativePosition)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $5215f3f95c6e47c6$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $lYce6.boxEquals)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $cjTwS.createBox)();
                    (0, $eCOas.copyBoxInto)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $ab6go.mixValues)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $gjKjc.cancelFrame)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $gjKjc.frame).update(()=>{
                (0, $hY3yK.globalProjectionState).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $eRt7D.animateSingleValue)(0, $5215f3f95c6e47c6$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($5215f3f95c6e47c6$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $5215f3f95c6e47c6$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $cjTwS.createBox)();
                const xLength = (0, $5SWta.calcLength)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $5SWta.calcLength)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $eCOas.copyBoxInto)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $kYtoI.transformBox)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $5SWta.calcBoxDelta)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $6nuKc.NodeStack)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $5215f3f95c6e47c6$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $5215f3f95c6e47c6$var$transformAxes.length; i++){
                $5215f3f95c6e47c6$var$resetDistortingTransform(`rotate${$5215f3f95c6e47c6$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $5215f3f95c6e47c6$var$resetDistortingTransform(`skew${$5215f3f95c6e47c6$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $5215f3f95c6e47c6$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $5KSww.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $5KSww.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $48MuY.hasTransform)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $cpZpM.buildProjectionTransform)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $jb3dc.scaleCorrectors){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $jb3dc.scaleCorrectors)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $5KSww.resolveMotionValue)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($5215f3f95c6e47c6$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $5215f3f95c6e47c6$var$updateLayout(node) {
    node.updateLayout();
}
function $5215f3f95c6e47c6$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $g9u8e.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $5SWta.calcLength)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($5215f3f95c6e47c6$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $g9u8e.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $5SWta.calcLength)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $cjTwS.createDelta)();
        (0, $5SWta.calcBoxDelta)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $cjTwS.createDelta)();
        if (isShared) (0, $5SWta.calcBoxDelta)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $5SWta.calcBoxDelta)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $lYce6.isDeltaZero)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $cjTwS.createBox)();
                    (0, $5SWta.calcRelativePosition)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $cjTwS.createBox)();
                    (0, $5SWta.calcRelativePosition)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $lYce6.boxEqualsRounded)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $5215f3f95c6e47c6$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $5215f3f95c6e47c6$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $5215f3f95c6e47c6$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $5215f3f95c6e47c6$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $5215f3f95c6e47c6$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $5215f3f95c6e47c6$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $5215f3f95c6e47c6$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $5215f3f95c6e47c6$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $5215f3f95c6e47c6$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $5215f3f95c6e47c6$var$calcProjection(node) {
    node.calcProjection();
}
function $5215f3f95c6e47c6$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $5215f3f95c6e47c6$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $5215f3f95c6e47c6$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $evA7j.mixNumber)(delta.translate, 0, p);
    output.scale = (0, $evA7j.mixNumber)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $5215f3f95c6e47c6$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $evA7j.mixNumber)(from.min, to.min, p);
    output.max = (0, $evA7j.mixNumber)(from.max, to.max, p);
}
function $5215f3f95c6e47c6$export$6ffd3e6ae339a132(output, from, to, p) {
    $5215f3f95c6e47c6$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $5215f3f95c6e47c6$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $5215f3f95c6e47c6$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $5215f3f95c6e47c6$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $5215f3f95c6e47c6$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $5215f3f95c6e47c6$var$roundPoint = $5215f3f95c6e47c6$var$userAgentContains("applewebkit/") && !$5215f3f95c6e47c6$var$userAgentContains("chrome/") ? Math.round : (0, $vssLq.noop);
function $5215f3f95c6e47c6$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $5215f3f95c6e47c6$var$roundPoint(axis.min);
    axis.max = $5215f3f95c6e47c6$var$roundPoint(axis.max);
}
function $5215f3f95c6e47c6$var$roundBox(box) {
    $5215f3f95c6e47c6$var$roundAxis(box.x);
    $5215f3f95c6e47c6$var$roundAxis(box.y);
}
function $5215f3f95c6e47c6$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $5SWta.isNear)((0, $lYce6.aspectRatio)(snapshot), (0, $lYce6.aspectRatio)(layout), 0.2);
}

});
parcelRegister("ab6go", function(module, exports) {

$parcel$export(module.exports, "mixValues", () => $51b2e755d48a92a5$export$739e279c17d51c3d);

var $jrijA = parcelRequire("jrijA");

var $cw1Iu = parcelRequire("cw1Iu");

var $evA7j = parcelRequire("evA7j");

var $vssLq = parcelRequire("vssLq");

var $ffEe3 = parcelRequire("ffEe3");
const $51b2e755d48a92a5$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $51b2e755d48a92a5$var$numBorders = $51b2e755d48a92a5$var$borders.length;
const $51b2e755d48a92a5$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $51b2e755d48a92a5$var$isPx = (value)=>typeof value === "number" || (0, $ffEe3.px).test(value);
function $51b2e755d48a92a5$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $evA7j.mixNumber)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $51b2e755d48a92a5$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $evA7j.mixNumber)(follow.opacity !== undefined ? follow.opacity : 1, 0, $51b2e755d48a92a5$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $evA7j.mixNumber)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $51b2e755d48a92a5$var$numBorders; i++){
        const borderLabel = `border${$51b2e755d48a92a5$var$borders[i]}Radius`;
        let followRadius = $51b2e755d48a92a5$var$getRadius(follow, borderLabel);
        let leadRadius = $51b2e755d48a92a5$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $51b2e755d48a92a5$var$isPx(followRadius) === $51b2e755d48a92a5$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $evA7j.mixNumber)($51b2e755d48a92a5$var$asNumber(followRadius), $51b2e755d48a92a5$var$asNumber(leadRadius), progress), 0);
            if ((0, $ffEe3.percent).test(leadRadius) || (0, $ffEe3.percent).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $evA7j.mixNumber)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $51b2e755d48a92a5$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $51b2e755d48a92a5$var$easeCrossfadeIn = $51b2e755d48a92a5$var$compress(0, 0.5, (0, $jrijA.circOut));
const $51b2e755d48a92a5$var$easeCrossfadeOut = $51b2e755d48a92a5$var$compress(0.5, 0.95, (0, $vssLq.noop));
function $51b2e755d48a92a5$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $cw1Iu.progress)(min, max, p));
    };
}

});

parcelRegister("eCOas", function(module, exports) {

$parcel$export(module.exports, "copyBoxInto", () => $7c76c2e66200c28c$export$c53fd88f45d77e4b);
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $7c76c2e66200c28c$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $7c76c2e66200c28c$export$c53fd88f45d77e4b(box, originBox) {
    $7c76c2e66200c28c$export$a0230ae482601ae8(box.x, originBox.x);
    $7c76c2e66200c28c$export$a0230ae482601ae8(box.y, originBox.y);
}

});

parcelRegister("cF678", function(module, exports) {

$parcel$export(module.exports, "removeBoxTransforms", () => $f64b171d31e19d88$export$73e1ad0a9694e25c);

var $evA7j = parcelRequire("evA7j");

var $ffEe3 = parcelRequire("ffEe3");

var $kYtoI = parcelRequire("kYtoI");
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $f64b171d31e19d88$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $kYtoI.scalePoint)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $kYtoI.scalePoint)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $f64b171d31e19d88$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $ffEe3.percent).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $evA7j.mixNumber)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $evA7j.mixNumber)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $f64b171d31e19d88$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $f64b171d31e19d88$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $f64b171d31e19d88$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $f64b171d31e19d88$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $f64b171d31e19d88$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $f64b171d31e19d88$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $f64b171d31e19d88$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $f64b171d31e19d88$export$42b76f1d0d16d5b(box.x, transforms, $f64b171d31e19d88$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $f64b171d31e19d88$export$42b76f1d0d16d5b(box.y, transforms, $f64b171d31e19d88$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

});

parcelRegister("lYce6", function(module, exports) {

$parcel$export(module.exports, "isDeltaZero", () => $a10b267ceaa13c7f$export$a7ec7642fe550fb6);
$parcel$export(module.exports, "boxEquals", () => $a10b267ceaa13c7f$export$8d5cf76bb7daff09);
$parcel$export(module.exports, "boxEqualsRounded", () => $a10b267ceaa13c7f$export$ef641b782d85522);
$parcel$export(module.exports, "aspectRatio", () => $a10b267ceaa13c7f$export$c5706146bc63213);

var $5SWta = parcelRequire("5SWta");
function $a10b267ceaa13c7f$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $a10b267ceaa13c7f$export$a7ec7642fe550fb6(delta) {
    return $a10b267ceaa13c7f$var$isAxisDeltaZero(delta.x) && $a10b267ceaa13c7f$var$isAxisDeltaZero(delta.y);
}
function $a10b267ceaa13c7f$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $a10b267ceaa13c7f$export$ef641b782d85522(a, b) {
    return Math.round(a.x.min) === Math.round(b.x.min) && Math.round(a.x.max) === Math.round(b.x.max) && Math.round(a.y.min) === Math.round(b.y.min) && Math.round(a.y.max) === Math.round(b.y.max);
}
function $a10b267ceaa13c7f$export$c5706146bc63213(box) {
    return (0, $5SWta.calcLength)(box.x) / (0, $5SWta.calcLength)(box.y);
}

});

parcelRegister("6nuKc", function(module, exports) {

$parcel$export(module.exports, "NodeStack", () => $c3b9c072a056e554$export$39be5b2d82fc9dc7);

var $fXcrA = parcelRequire("fXcrA");
class $c3b9c072a056e554$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $fXcrA.addUniqueItem)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $fXcrA.removeItem)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}

});

parcelRegister("cpZpM", function(module, exports) {

$parcel$export(module.exports, "buildProjectionTransform", () => $8dd0b3b1cf51c8f2$export$d33653b270fe725c);
function $8dd0b3b1cf51c8f2$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}

});

parcelRegister("dnJld", function(module, exports) {

$parcel$export(module.exports, "FlatTree", () => $b1d064adb0936fd8$export$1465d17e3de78a96);

var $fXcrA = parcelRequire("fXcrA");

var $k2tdR = parcelRequire("k2tdR");
class $b1d064adb0936fd8$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $fXcrA.addUniqueItem)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $fXcrA.removeItem)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $k2tdR.compareByDepth));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}

});
parcelRegister("k2tdR", function(module, exports) {

$parcel$export(module.exports, "compareByDepth", () => $d242c45d65722744$export$d689d9dec5ad338);
const $d242c45d65722744$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;

});


parcelRegister("2UAy6", function(module, exports) {

$parcel$export(module.exports, "delay", () => $d6be6a8bfe0e5015$export$1391212d75b2ee65);

var $9KDBY = parcelRequire("9KDBY");

var $gjKjc = parcelRequire("gjKjc");
/**
 * Timeout defined in ms
 */ function $d6be6a8bfe0e5015$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $9KDBY.time).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $gjKjc.cancelFrame)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $gjKjc.frame).read(checkElapsed, true);
    return ()=>(0, $gjKjc.cancelFrame)(checkElapsed);
}

});

parcelRegister("k1WBq", function(module, exports) {

$parcel$export(module.exports, "record", () => $e6edeaac7d074791$export$e5185e241753e543);
function $e6edeaac7d074791$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}

});

parcelRegister("c3rG3", function(module, exports) {

$parcel$export(module.exports, "isSVGElement", () => $b60ef293ecd6396b$export$17eda790a720ec57);
function $b60ef293ecd6396b$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}

});

parcelRegister("eRt7D", function(module, exports) {

$parcel$export(module.exports, "animateSingleValue", () => $ad7d1049cf474a9f$export$335a17c977067b99);

var $5xu5L = parcelRequire("5xu5L");

var $dW73m = parcelRequire("dW73m");

var $6ym6A = parcelRequire("6ym6A");
function $ad7d1049cf474a9f$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $6ym6A.isMotionValue)(value) ? value : (0, $dW73m.motionValue)(value);
    motionValue$1.start((0, $5xu5L.animateMotionValue)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

});


parcelRegister("8iTjS", function(module, exports) {

$parcel$export(module.exports, "DocumentProjectionNode", () => $eb111cf554b8c916$export$2d029a49a09b6177);

var $7j4zl = parcelRequire("7j4zl");

var $3M4VH = parcelRequire("3M4VH");
const $eb111cf554b8c916$export$2d029a49a09b6177 = (0, $7j4zl.createProjectionNode)({
    attachResizeListener: (ref, notify)=>(0, $3M4VH.addDomEvent)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});

});



parcelRegister("ko4c1", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", () => $ab1cdffb5766747b$export$56ba0183203348f5);

var $81g6h = parcelRequire("81g6h");

var $4bs0h = parcelRequire("4bs0h");

var $jauEW = parcelRequire("jauEW");

var $5oF6F = parcelRequire("5oF6F");
const $ab1cdffb5766747b$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $5oF6F.isSVGComponent)(Component) ? new (0, $jauEW.SVGVisualElement)(options) : new (0, $4bs0h.HTMLVisualElement)(options, {
        allowProjection: Component !== (0, $81g6h.Fragment)
    });
};

});
parcelRegister("4bs0h", function(module, exports) {

$parcel$export(module.exports, "HTMLVisualElement", () => $e941ea3872883bc6$export$23fea75b03ac16b3);

var $1P4h9 = parcelRequire("1P4h9");

var $9zsdr = parcelRequire("9zsdr");

var $313j6 = parcelRequire("313j6");

var $29VaU = parcelRequire("29VaU");

var $lo33Q = parcelRequire("lo33Q");

var $lnR8r = parcelRequire("lnR8r");

var $dQjRp = parcelRequire("dQjRp");

var $6mPPi = parcelRequire("6mPPi");

var $6ym6A = parcelRequire("6ym6A");
function $e941ea3872883bc6$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $e941ea3872883bc6$export$23fea75b03ac16b3 extends (0, $6mPPi.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.applyWillChange = true;
    }
    readValueFromInstance(instance, key) {
        if ((0, $313j6.transformProps).has(key)) {
            const defaultType = (0, $lnR8r.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $e941ea3872883bc6$export$3735103072e4a80(instance);
            const value = ((0, $9zsdr.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $dQjRp.measureViewportBox)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $1P4h9.buildHTMLStyles)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $29VaU.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $6ym6A.isMotionValue)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $lo33Q.renderHTML)(instance, renderState, styleProp, projection);
    }
}

});
parcelRegister("6mPPi", function(module, exports) {

$parcel$export(module.exports, "DOMVisualElement", () => $2d3ac5c96fc37a89$export$e49735c2a366bdc7);

var $7FP6E = parcelRequire("7FP6E");

var $jUU7y = parcelRequire("jUU7y");
class $2d3ac5c96fc37a89$export$e49735c2a366bdc7 extends (0, $7FP6E.VisualElement) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $jUU7y.DOMKeyframesResolver);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
}

});
parcelRegister("7FP6E", function(module, exports) {

$parcel$export(module.exports, "VisualElement", () => $8e96c7a85d288825$export$fa8b653c0f3714e5);

var $cjTwS = parcelRequire("cjTwS");

var $1LGye = parcelRequire("1LGye");

var $34F69 = parcelRequire("34F69");

var $eRjGx = parcelRequire("eRjGx");

var $dW73m = parcelRequire("dW73m");

var $6ym6A = parcelRequire("6ym6A");

var $313j6 = parcelRequire("313j6");

var $kCXZm = parcelRequire("kCXZm");

var $hrE0h = parcelRequire("hrE0h");

var $2qbDF = parcelRequire("2qbDF");

var $1DKCf = parcelRequire("1DKCf");


var $b0hpJ = parcelRequire("b0hpJ");

var $iOEAQ = parcelRequire("iOEAQ");

var $2tXqa = parcelRequire("2tXqa");

var $1FIdb = parcelRequire("1FIdb");

var $fcZiz = parcelRequire("fcZiz");

var $elq0T = parcelRequire("elq0T");

var $fcGZ1 = parcelRequire("fcGZ1");

var $5U4ao = parcelRequire("5U4ao");

var $5hjmD = parcelRequire("5hjmD");

var $gjKjc = parcelRequire("gjKjc");
const $8e96c7a85d288825$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $8e96c7a85d288825$var$numVariantProps = (0, $iOEAQ.variantProps).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $8e96c7a85d288825$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * If true, will-change will be applied to the element. Only HTMLVisualElements
         * currently support this.
         */ this.applyWillChange = false;
        this.resolveKeyframes = (keyframes, // We use an onComplete callback here rather than a Promise as a Promise
        // resolution is a microtask and we want to retain the ability to force
        // the resolution of keyframes synchronously.
        onComplete, name, value)=>{
            return new this.KeyframeResolver(keyframes, onComplete, name, value, this);
        };
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $1FIdb.KeyframeResolver);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $gjKjc.frame).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $kCXZm.isControllingVariants)(props);
        this.isVariantNode = (0, $kCXZm.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $6ym6A.isMotionValue)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $2tXqa.visualElementStore).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $34F69.hasReducedMotionListener).current) (0, $1LGye.initPrefersReducedMotion)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $34F69.prefersReducedMotion).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $2tXqa.visualElementStore).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $gjKjc.cancelFrame)(this.notifyUpdate);
        (0, $gjKjc.cancelFrame)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $313j6.transformProps).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $gjKjc.frame).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $b0hpJ.featureDefinitions){
            const featureDefinition = (0, $b0hpJ.featureDefinitions)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $cjTwS.createBox)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $8e96c7a85d288825$var$propEventHandlers.length; i++){
            const key = $8e96c7a85d288825$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $2qbDF.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $8e96c7a85d288825$var$numVariantProps; i++){
            const name = (0, $iOEAQ.variantProps)[i];
            const prop = this.props[name];
            if ((0, $hrE0h.isVariantLabel)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $dW73m.motionValue)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $fcZiz.isNumericalString)(value) || (0, $elq0T.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $fcGZ1.findValueType)(value) && (0, $5U4ao.complex).test(target)) value = (0, $5hjmD.getAnimatableNone)(key, target);
            this.setBaseTarget(key, (0, $6ym6A.isMotionValue)(value) ? value.get() : value);
        }
        return (0, $6ym6A.isMotionValue)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $1DKCf.resolveVariantFromProps)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $6ym6A.isMotionValue)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $eRjGx.SubscriptionManager)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}

});
parcelRegister("1LGye", function(module, exports) {

$parcel$export(module.exports, "initPrefersReducedMotion", () => $1cb6928cf64f5ec1$export$ca9f41fb23dded3d);

var $eJJN2 = parcelRequire("eJJN2");

var $34F69 = parcelRequire("34F69");
function $1cb6928cf64f5ec1$export$ca9f41fb23dded3d() {
    (0, $34F69.hasReducedMotionListener).current = true;
    if (!(0, $eJJN2.isBrowser)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $34F69.prefersReducedMotion).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $34F69.prefersReducedMotion).current = false;
}

});
parcelRegister("34F69", function(module, exports) {

$parcel$export(module.exports, "prefersReducedMotion", () => $1f7adb2f249f5156$export$ff7706047246b98b);
$parcel$export(module.exports, "hasReducedMotionListener", () => $1f7adb2f249f5156$export$6476d16e2fd2d0db);
// Does this device prefer reduced motion? Returns `null` server-side.
const $1f7adb2f249f5156$export$ff7706047246b98b = {
    current: null
};
const $1f7adb2f249f5156$export$6476d16e2fd2d0db = {
    current: false
};

});


parcelRegister("2qbDF", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", () => $bb368c05967cf4bf$export$9a552858d5197f6e);


var $dW73m = parcelRequire("dW73m");

var $6ym6A = parcelRequire("6ym6A");
function $bb368c05967cf4bf$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $6ym6A.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $6ym6A.isMotionValue)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $dW73m.motionValue)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $dW73m.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});

parcelRegister("2tXqa", function(module, exports) {

$parcel$export(module.exports, "visualElementStore", () => $4db5c59728cc470e$export$bc2a978a17abfdde);
const $4db5c59728cc470e$export$bc2a978a17abfdde = new WeakMap();

});

parcelRegister("fcGZ1", function(module, exports) {

$parcel$export(module.exports, "findValueType", () => $97bed8b763b773a4$export$950e7e59ea1ffed7);

var $83rBL = parcelRequire("83rBL");

var $5U4ao = parcelRequire("5U4ao");

var $blfVU = parcelRequire("blfVU");

var $b9Sq8 = parcelRequire("b9Sq8");
/**
 * A list of all ValueTypes
 */ const $97bed8b763b773a4$var$valueTypes = [
    ...(0, $blfVU.dimensionValueTypes),
    (0, $83rBL.color),
    (0, $5U4ao.complex)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $97bed8b763b773a4$export$950e7e59ea1ffed7 = (v)=>$97bed8b763b773a4$var$valueTypes.find((0, $b9Sq8.testValueType)(v));

});




parcelRegister("jauEW", function(module, exports) {

$parcel$export(module.exports, "SVGVisualElement", () => $1498532716070274$export$86bcdffbaf733d84);

var $aSdXp = parcelRequire("aSdXp");

var $6mPPi = parcelRequire("6mPPi");

var $jr6qb = parcelRequire("jr6qb");

var $7HryJ = parcelRequire("7HryJ");

var $5owg4 = parcelRequire("5owg4");

var $313j6 = parcelRequire("313j6");

var $eb9bJ = parcelRequire("eb9bJ");

var $lnR8r = parcelRequire("lnR8r");

var $cjTwS = parcelRequire("cjTwS");

var $4dpiX = parcelRequire("4dpiX");
class $1498532716070274$export$86bcdffbaf733d84 extends (0, $6mPPi.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $313j6.transformProps).has(key)) {
            const defaultType = (0, $lnR8r.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $5owg4.camelCaseAttributes).has(key) ? (0, $7HryJ.camelToDash)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $cjTwS.createBox)();
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $aSdXp.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $jr6qb.buildSVGAttrs)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $eb9bJ.renderSVG)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $4dpiX.isSVGTag)(instance.tagName);
        super.mount(instance);
    }
}

});


parcelRegister("lrPdG", function(module, exports) {

$parcel$export(module.exports, "layout", () => $31cf1190dcc13aae$export$b3219800bda33a1f);

var $bVwFV = parcelRequire("bVwFV");

var $1iab6 = parcelRequire("1iab6");
const $31cf1190dcc13aae$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $bVwFV.HTMLProjectionNode),
        MeasureLayout: $1iab6.MeasureLayout
    }
};

});



parcelRegister("i7mGO", function(module, exports) {

$parcel$export(module.exports, "AboutPhysiomeDialog", () => $67d9b1184e116a48$export$3b57cdcff1274483);

var $iKObn = parcelRequire("iKObn");

var $he9Ds = parcelRequire("he9Ds");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $gk3fY = parcelRequire("gk3fY");
parcelRequire("81g6h");
const $67d9b1184e116a48$var$SPACE_SEPARATOR = " ";
const $67d9b1184e116a48$export$3b57cdcff1274483 = (props)=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $gk3fY.BaseDialog), {
        header: format("home.aboutPhysiomeDialog.header"),
        width: (0, $gk3fY.DIALOG_SIZE).S,
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($67d9b1184e116a48$var$Version, {
                children: [
                    format("home.aboutPhysiomeDialog.content.productVersion.intro") + $67d9b1184e116a48$var$SPACE_SEPARATOR,
                    /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                        className: "p-size-s-bold",
                        children: (0, $he9Ds.APP_CONSTANTS).APP_VERSION
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($67d9b1184e116a48$var$Version, {
                children: [
                    format("home.aboutPhysiomeDialog.content.buildVersion.intro") + $67d9b1184e116a48$var$SPACE_SEPARATOR,
                    /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                        className: "p-size-s-bold",
                        children: "26.09.01-b003b204" ?? `build-${"prod"}`
                    })
                ]
            })
        ]
    });
};
const $67d9b1184e116a48$var$Version = (0, $5UMQ1.default).p`
	margin: 16px 0;
`;

});

parcelRegister("cg4YL", function(module, exports) {

$parcel$export(module.exports, "CancelPatientInvitationDialog", () => $608b8c9cc2109512$export$1c9dd4880aac0b32);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $aEP4N = parcelRequire("aEP4N");

var $fUhFD = parcelRequire("fUhFD");

var $9XVwj = parcelRequire("9XVwj");

var $9oyj9 = parcelRequire("9oyj9");

var $81g6h = parcelRequire("81g6h");
const $608b8c9cc2109512$export$1c9dd4880aac0b32 = ({ patient: { id: id, status: status, firstName: firstName, lastName: lastName }, ...otherProps })=>{
    const [awaitingDelete, setAwaitingDelete] = (0, $81g6h.useState)(false);
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const { format: format } = (0, $1eHG3.useI18n)();
    const { formatPatientName: formatPatientName } = (0, $aEP4N.useFormatPatients)();
    const deletePatient = (0, $81g6h.useCallback)(async ()=>{
        setAwaitingDelete(true);
        try {
            await (0, $ghfIB.patientManager).deletePendingPatient(id);
            setAwaitingDelete(false);
            (0, $fUhFD.sendAnalyticsEventPatientDeleted)(status);
            showToast(format("cancelPatientInvitationDialog.successToast.title"), format("cancelPatientInvitationDialog.successToast.message", {
                name: formatPatientName({
                    firstName: firstName,
                    lastName: lastName
                }, false, false)
            }), "success");
            otherProps.onHide();
        } catch (error) {
            console.error("Failed to cancel patient invitation", error);
            setAwaitingDelete(false);
        }
    }, [
        status,
        showToast,
        format,
        formatPatientName,
        firstName,
        lastName,
        otherProps,
        id
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $9oyj9.ConfirmActionDialog), {
        title: format("cancelPatientInvitationDialog.title"),
        message: format("cancelPatientInvitationDialog.message", {
            name: formatPatientName({
                firstName: firstName,
                lastName: lastName
            }, false, false)
        }),
        cancelButtonLabel: format("global.patientOperation.keepInvitation"),
        onCancel: otherProps.onHide,
        confirmButtonLabel: format("global.patientOperation.cancelInvitation"),
        onConfirm: deletePatient,
        confirmLoading: awaitingDelete,
        ...otherProps
    });
};

});
parcelRegister("aEP4N", function(module, exports) {

$parcel$export(module.exports, "useFormatPatients", () => $a30838cb6cc15f09$export$e5ddf354f3562042);
$parcel$export(module.exports, "usePatient", () => $a30838cb6cc15f09$export$9b570c45914f833c);
$parcel$export(module.exports, "usePatientNames", () => $a30838cb6cc15f09$export$acc175fcb98de56b);

var $grmoS = parcelRequire("grmoS");

var $giAv5 = parcelRequire("giAv5");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $l075W = parcelRequire("l075W");

var $lDZlX = parcelRequire("lDZlX");

var $8Njzk = parcelRequire("8Njzk");

var $lTdpc = parcelRequire("lTdpc");

var $buI4E = parcelRequire("buI4E");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
const $a30838cb6cc15f09$export$e5ddf354f3562042 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const formatPatientName = (0, $81g6h.useCallback)(({ firstName: firstName, lastName: lastName, activationCode: activationCode }, fallbackToActivationCode = true, fallbackToNamePlaceholder = true)=>{
        if ((0, $lTdpc.isNotEmpty)(firstName) && (0, $lTdpc.isNotEmpty)(lastName)) return (0, $buI4E.formatName)({
            firstName: firstName,
            lastName: lastName
        });
        if (fallbackToActivationCode && (0, $lTdpc.isNotNil)(activationCode)) return activationCode;
        if (fallbackToNamePlaceholder) return format("home.registeredPatientsListing.emptyName");
        return "";
    }, [
        format
    ]);
    return {
        formatPatientName: formatPatientName
    };
};
function $a30838cb6cc15f09$export$9b570c45914f833c(patientId, withFetch = true) {
    const [loading, setLoading] = (0, $81g6h.useState)(withFetch);
    const [error, setError] = (0, $81g6h.useState)(undefined);
    const navigate = (0, $htiSH.useNavigate)();
    const patient = (0, $1IWnK.useComputedObservable)(()=>patientId ? (0, $ghfIB.patientManager).patientMap.get().get(patientId) : undefined, [
        patientId
    ]);
    const refreshPatient = (0, $81g6h.useCallback)(async (patientIdToBeRefreshed)=>{
        try {
            await (0, $ghfIB.patientManager).retrievePatient(patientIdToBeRefreshed);
            setError(null);
        } catch (e) {
            if (e instanceof (0, $l075W.PendingPatientForbiddenAccessError)) navigate((0, $lDZlX.RoutesPath).Home, {
                query: {
                    active: (0, $8Njzk.HomeTabNames).Pending
                }
            });
            else {
                setError(e);
                console.error("Failed to retrieve the patient", e);
            }
        } finally{
            setLoading(false);
        }
    }, [
        navigate
    ]);
    (0, $81g6h.useEffect)(()=>{
        withFetch && patientId && refreshPatient(patientId);
    }, [
        patientId,
        refreshPatient,
        withFetch
    ]);
    return {
        loading: loading,
        patient: patient,
        error: error,
        refreshPatient: refreshPatient
    };
}
function $a30838cb6cc15f09$export$acc175fcb98de56b() {
    const [patientNames, setPatientNames] = (0, $81g6h.useState)([]);
    const [fetchRegisteredPatientNames, loading] = (0, $grmoS.useAsyncOperation)(async ()=>{
        const result = await (0, $ghfIB.patientManager).listRegisteredPatientNames();
        setPatientNames(result);
    }, {});
    (0, $giAv5.useOnceEffect)(async ()=>await fetchRegisteredPatientNames());
    return {
        loading: loading,
        patientNames: patientNames
    };
}

});
parcelRegister("giAv5", function(module, exports) {

$parcel$export(module.exports, "useOnceEffect", () => $53f7f9c4519cacf9$export$45251f7754f55ae9);

var $81g6h = parcelRequire("81g6h");
const $53f7f9c4519cacf9$export$45251f7754f55ae9 = (effect, condition = true, deps = [])=>{
    const done = (0, $81g6h.useRef)(false);
    (0, $81g6h.useEffect)(()=>{
        if (condition && !done.current) {
            effect();
            done.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        deps
    ]);
};

});

parcelRegister("8Njzk", function(module, exports) {

$parcel$export(module.exports, "HomeTabNames", () => $e48ea7879649cb4c$export$c657c2863388e6c1);
$parcel$export(module.exports, "PatientTabs", () => $e48ea7879649cb4c$export$4920f3b42ff39b47);

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $iV9Zw = parcelRequire("iV9Zw");

var $8zvzh = parcelRequire("8zvzh");

var $ghfIB = parcelRequire("ghfIB");

var $fUhFD = parcelRequire("fUhFD");

var $5stJo = parcelRequire("5stJo");

var $5UMQ1 = parcelRequire("5UMQ1");

var $imaOW = parcelRequire("imaOW");

var $28f8Y = parcelRequire("28f8Y");

var $dkVlr = parcelRequire("dkVlr");

var $1IlhR = parcelRequire("1IlhR");

var $5kXMA = parcelRequire("5kXMA");

var $9HyYO = parcelRequire("9HyYO");

var $8nx58 = parcelRequire("8nx58");

var $2tsa2 = parcelRequire("2tsa2");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $kLgU7 = parcelRequire("kLgU7");

var $lTdpc = parcelRequire("lTdpc");

var $jTpg0 = parcelRequire("jTpg0");

var $1IWnK = parcelRequire("1IWnK");

var $bY9wC = parcelRequire("bY9wC");

var $81g6h = parcelRequire("81g6h");
var $e48ea7879649cb4c$export$c657c2863388e6c1;
(function(HomeTabNames) {
    HomeTabNames["Registered"] = "registered";
    HomeTabNames["Pending"] = "pending";
})($e48ea7879649cb4c$export$c657c2863388e6c1 || ($e48ea7879649cb4c$export$c657c2863388e6c1 = {}));
const $e48ea7879649cb4c$var$tabIndices = [
    "registered",
    "pending"
];
const $e48ea7879649cb4c$export$4920f3b42ff39b47 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isMobile: isMobile } = (0, $5kXMA.useDimensions)();
    const { updateHistory: updateHistory } = (0, $iV9Zw.useHistory)();
    const { active: active } = (0, $8zvzh.useQueryParams)();
    const { registeredPatients: registeredPatients, pendingPatients: pendingPatients } = (0, $1IWnK.useObservable)((0, $ghfIB.patientManager).allPatients);
    const [activePatientTab, setActivePatientTab] = (0, $81g6h.useState)((0, $kLgU7.indexOfOrDefault)($e48ea7879649cb4c$var$tabIndices, active, "registered"));
    const [isFilteringPatientsWithExtensionNeeded, setIsFilteringPatientsWithExtensionNeeded] = (0, $81g6h.useState)(false);
    const eventSent = (0, $81g6h.useRef)(false);
    const listAllPatients = (0, $81g6h.useCallback)(()=>(0, $ghfIB.patientManager).fetchAllPatients(), []);
    const [fetchPatientData, loadingPatients, errorLoadingPatients] = (0, $grmoS.useAsyncOperation)(listAllPatients, {
        initialLoadingState: true
    });
    const listAllRegisteredPatientCompliance = (0, $81g6h.useCallback)(()=>(0, $ghfIB.patientManager).fetchRegisteredPatientGlobalCompliances(), []);
    const [fetchPatientCompliances, loadingCompliances, errorLoadingCompliances] = (0, $grmoS.useAsyncOperation)(listAllRegisteredPatientCompliance, {});
    const skeletonProps = (0, $81g6h.useMemo)(()=>({
            active: loadingPatients,
            loading: loadingPatients
        }), [
        loadingPatients
    ]);
    (0, $81g6h.useEffect)(()=>{
        fetchPatientData();
        fetchPatientCompliances();
    }, [
        fetchPatientCompliances,
        fetchPatientData
    ]);
    const selectTab = (tabIndex)=>{
        setActivePatientTab(tabIndex);
    };
    (0, $81g6h.useEffect)(()=>{
        if (errorLoadingPatients) (0, $ghfIB.networkActionsErrorsManager).reportError(errorLoadingPatients, format("home.patientListingError.toast"));
        if (errorLoadingCompliances) (0, $ghfIB.networkActionsErrorsManager).reportError(errorLoadingCompliances, format("home.patientComplianceListingError.toast"));
    }, [
        errorLoadingCompliances,
        errorLoadingPatients,
        format
    ]);
    (0, $81g6h.useEffect)(()=>{
        if ((0, $lTdpc.isNotNil)(registeredPatients) && !eventSent.current) {
            (0, $fUhFD.sendAnalyticsEventPatientListViewed)((0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).isEmpty(registeredPatients) ? "pending" : "registered");
            eventSent.current = true;
        }
    }, [
        registeredPatients
    ]);
    const headerStyle = (0, $81g6h.useMemo)(()=>({
            width: isMobile ? "100%" : "unset"
        }), [
        isMobile
    ]);
    const patientsWithExtendableProgram = (0, $81g6h.useMemo)(()=>registeredPatients.filter((0, $5stJo.hasPatientExtendableProgram)), [
        registeredPatients
    ]);
    const registeredPatientsData = (0, $81g6h.useMemo)(()=>isFilteringPatientsWithExtensionNeeded ? patientsWithExtendableProgram : registeredPatients, [
        isFilteringPatientsWithExtensionNeeded,
        patientsWithExtendableProgram,
        registeredPatients
    ]);
    if (loadingPatients) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {});
    if (errorLoadingPatients) return /*#__PURE__*/ (0, $iKObn.jsx)($e48ea7879649cb4c$var$ErrorContainer, {
        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
            style: {
                width: "100%",
                padding: "72px 32px"
            },
            titleStyle: {
                fontSize: "1.5rem"
            },
            description: format("home.patientListingError.description"),
            onRefresh: async ()=>{
                await fetchPatientData();
            }
        })
    });
    if (registeredPatientsData.length === 0 && pendingPatients.length === 0) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $2tsa2.EmptyPatientMessage), {
        variant: (0, $2tsa2.EmptyPatientMessageVariant).NoPatients
    });
    return /*#__PURE__*/ (0, $iKObn.jsxs)($e48ea7879649cb4c$var$StyledTabView, {
        activeIndex: activePatientTab,
        onTabChange: (e)=>{
            (0, $fUhFD.sendAnalyticsEventPatientListViewed)($e48ea7879649cb4c$var$tabIndices[e.index]);
            updateHistory({
                active: $e48ea7879649cb4c$var$tabIndices[e.index]
            });
            selectTab(e.index);
        },
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)((0, $bY9wC.TabPanel), {
                headerStyle: headerStyle,
                header: format("home.registeredPatientsListing.tabName", {
                    count: registeredPatients.length
                }),
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($e48ea7879649cb4c$var$Head, {
                        children: [
                            (0, $lTdpc.isNotNil)(patientsWithExtendableProgram) && patientsWithExtendableProgram.length > 0 && !skeletonProps.active && /*#__PURE__*/ (0, $iKObn.jsx)($e48ea7879649cb4c$var$StyledAlertCard, {
                                title: format("home.registeredPatientsListing.alert.programEnding.title"),
                                message: format("home.registeredPatientsListing.alert.programEnding.message", {
                                    patientNumber: patientsWithExtendableProgram.length
                                }),
                                cardType: (0, $imaOW.CardType).Warn,
                                textButton: isFilteringPatientsWithExtensionNeeded ? {
                                    text: format("home.registeredPatientsListing.alert.programEnding.label")
                                } : {
                                    text: format("home.registeredPatientsListing.alert.programEnding.button"),
                                    onPressed: ()=>setIsFilteringPatientsWithExtensionNeeded(true)
                                }
                            }),
                            isFilteringPatientsWithExtensionNeeded && /*#__PURE__*/ (0, $iKObn.jsxs)($e48ea7879649cb4c$var$FiltersContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                        className: "p-size-s",
                                        color: (0, $kKnoQ.colors).grey,
                                        children: format("home.registeredPatientsListing.alert.activeFilters.text")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $dkVlr.FilterTag), {
                                        label: format("home.registeredPatientsListing.activeFilter.extensionNeeded"),
                                        onCrossClicked: ()=>setIsFilteringPatientsWithExtensionNeeded(false)
                                    })
                                ]
                            })
                        ]
                    }),
                    registeredPatientsData.length === 0 ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $2tsa2.EmptyPatientMessage), {
                        variant: (0, $2tsa2.EmptyPatientMessageVariant).NoRegisteredPatients
                    }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $8nx58.RegisteredPatientListing), {
                        registeredPatients: registeredPatientsData,
                        isLoadingCompliances: loadingCompliances
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $bY9wC.TabPanel), {
                headerStyle: headerStyle,
                header: format("home.pendingPatientsListing.tabName", {
                    count: pendingPatients.length
                }),
                children: pendingPatients.length === 0 ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $2tsa2.EmptyPatientMessage), {
                    variant: (0, $2tsa2.EmptyPatientMessageVariant).NoPendingPatients
                }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $9HyYO.PendingPatientListing), {
                    pendingPatients: pendingPatients
                })
            })
        ]
    });
};
const $e48ea7879649cb4c$var$ErrorContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "stretch")};
	flex-grow: 1;
`;
const $e48ea7879649cb4c$var$StyledTabView = (0, $5UMQ1.default)((0, $bY9wC.TabView))`
	.p-tabview-nav {
		@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
			background-color: ${(0, $kKnoQ.colors).primaryBackground} !important;
		}
	}

	.p-tabview-nav-link {
		@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
			background-color: ${(0, $kKnoQ.colors).primaryBackground} !important;
			justify-content: center !important;
		}
	}

	.p-tabview-panels {
		@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
			padding: 0 !important;
		}
	}
`;
const $e48ea7879649cb4c$var$StyledAlertCard = (0, $5UMQ1.default)((0, $imaOW.AlertCard))`
	margin-bottom: 32px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		margin-bottom: 16px;
	}
`;
const $e48ea7879649cb4c$var$FiltersContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8, "flexstart", "center")};
	margin-bottom: 16px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		margin-bottom: 8px;
	}
`;
const $e48ea7879649cb4c$var$Head = (0, $5UMQ1.default).div`
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		margin: 16px 24px;
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		margin: 16px 16px;
	}
`;

});
parcelRegister("iV9Zw", function(module, exports) {

$parcel$export(module.exports, "useHistory", () => $daf4de89672729d2$export$3420e1dc2c4a518c);

var $81g6h = parcelRequire("81g6h");

var $hE6rp = parcelRequire("hE6rp");
const $daf4de89672729d2$var$INITIAL_LOCATION = "default";
function $daf4de89672729d2$export$3420e1dc2c4a518c() {
    const location = (0, $hE6rp.useLocation)();
    const updateHistory = (0, $81g6h.useCallback)((queryParam)=>{
        const currentParams = {};
        new URLSearchParams(location.search).forEach((value, key)=>Object.assign(currentParams, {
                [key]: value
            }));
        const newQueryParams = new URLSearchParams({
            ...currentParams,
            ...queryParam
        }).toString();
        window.history.replaceState({}, "", "?" + newQueryParams);
    }, [
        location.search
    ]);
    const cleanHistory = (0, $81g6h.useCallback)(()=>{
        window.history.replaceState({}, "", "?");
    }, []);
    const isInitialLocation = (0, $81g6h.useMemo)(()=>location.key === $daf4de89672729d2$var$INITIAL_LOCATION, [
        location.key
    ]);
    return {
        updateHistory: updateHistory,
        cleanHistory: cleanHistory,
        isInitialLocation: isInitialLocation
    };
}

});

parcelRegister("8zvzh", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $8ca9e5f4a119d2b2$export$b37ee0d76c6d2fbc);

var $81g6h = parcelRequire("81g6h");
parcelRequire("aanF2");
var $hE6rp = parcelRequire("hE6rp");
function $8ca9e5f4a119d2b2$export$b37ee0d76c6d2fbc() {
    const location = (0, $hE6rp.useLocation)();
    return (0, $81g6h.useMemo)(()=>{
        const result = {};
        new URLSearchParams(location.search).forEach((value, key)=>Object.assign(result, {
                [key]: value
            }));
        return result;
    }, [
        location
    ]);
}

});
parcelRegister("aanF2", function(module, exports) {

$parcel$export(module.exports, "createBrowserRouter", () => $766d311b9f538b57$export$1f3f55432a00e06d);
$parcel$export(module.exports, "RouterProvider", () => $766d311b9f538b57$export$323e4fc2fa4753fb);
$parcel$export(module.exports, "ScrollRestoration", () => $766d311b9f538b57$export$11aac1aab828f1fa);
$parcel$export(module.exports, "useSearchParams", () => $766d311b9f538b57$export$f1a78c17382fe22a);
$parcel$export(module.exports, "useBeforeUnload", () => $766d311b9f538b57$export$c0a586b329cae57d);
$parcel$export(module.exports, "useBlocker", () => (parcelRequire("hE6rp")).useBlocker);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("hE6rp")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("hE6rp")).useNavigate);
/**
 * React Router DOM v6.24.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $81g6h = parcelRequire("81g6h");

var $Q1dTY = parcelRequire("Q1dTY");

var $kEwLa = parcelRequire("kEwLa");
var $hE6rp = parcelRequire("hE6rp");

var $kEwLa = parcelRequire("kEwLa");
function $766d311b9f538b57$var$_extends() {
    $766d311b9f538b57$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $766d311b9f538b57$var$_extends.apply(this, arguments);
}
function $766d311b9f538b57$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $766d311b9f538b57$var$defaultMethod = "get";
const $766d311b9f538b57$var$defaultEncType = "application/x-www-form-urlencoded";
function $766d311b9f538b57$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $766d311b9f538b57$var$isButtonElement(object) {
    return $766d311b9f538b57$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $766d311b9f538b57$var$isFormElement(object) {
    return $766d311b9f538b57$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $766d311b9f538b57$var$isInputElement(object) {
    return $766d311b9f538b57$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $766d311b9f538b57$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $766d311b9f538b57$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$766d311b9f538b57$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $766d311b9f538b57$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $766d311b9f538b57$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $766d311b9f538b57$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $766d311b9f538b57$var$_formDataSupportsSubmitter = null;
function $766d311b9f538b57$var$isFormDataSubmitterSupported() {
    if ($766d311b9f538b57$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $766d311b9f538b57$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $766d311b9f538b57$var$_formDataSupportsSubmitter = true;
    }
    return $766d311b9f538b57$var$_formDataSupportsSubmitter;
}
const $766d311b9f538b57$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $766d311b9f538b57$var$getFormEncType(encType) {
    if (encType != null && !$766d311b9f538b57$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $766d311b9f538b57$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($766d311b9f538b57$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $kEwLa.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $766d311b9f538b57$var$defaultMethod;
        encType = $766d311b9f538b57$var$getFormEncType(target.getAttribute("enctype")) || $766d311b9f538b57$var$defaultEncType;
        formData = new FormData(target);
    } else if ($766d311b9f538b57$var$isButtonElement(target) || $766d311b9f538b57$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $kEwLa.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $766d311b9f538b57$var$defaultMethod;
        encType = $766d311b9f538b57$var$getFormEncType(target.getAttribute("formenctype")) || $766d311b9f538b57$var$getFormEncType(form.getAttribute("enctype")) || $766d311b9f538b57$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$766d311b9f538b57$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($766d311b9f538b57$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $766d311b9f538b57$var$defaultMethod;
        action = null;
        encType = $766d311b9f538b57$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $766d311b9f538b57$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $766d311b9f538b57$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $766d311b9f538b57$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $766d311b9f538b57$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $766d311b9f538b57$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $766d311b9f538b57$export$1f3f55432a00e06d(routes, opts) {
    return (0, $kEwLa.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $766d311b9f538b57$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $kEwLa.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $766d311b9f538b57$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $hE6rp.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $766d311b9f538b57$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $kEwLa.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $766d311b9f538b57$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $kEwLa.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $766d311b9f538b57$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $hE6rp.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $766d311b9f538b57$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $766d311b9f538b57$var$_extends({}, state, {
        errors: $766d311b9f538b57$var$deserializeErrors(state.errors)
    });
    return state;
}
function $766d311b9f538b57$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $kEwLa.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $766d311b9f538b57$export$7ad602f0e94e62d1 = /*#__PURE__*/ $81g6h.createContext({
    isTransitioning: false
});
const $766d311b9f538b57$export$148fd98d095596d4 = /*#__PURE__*/ $81g6h.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $766d311b9f538b57$var$START_TRANSITION = "startTransition";
const $766d311b9f538b57$var$startTransitionImpl = $81g6h[$766d311b9f538b57$var$START_TRANSITION];
const $766d311b9f538b57$var$FLUSH_SYNC = "flushSync";
const $766d311b9f538b57$var$flushSyncImpl = $Q1dTY[$766d311b9f538b57$var$FLUSH_SYNC];
const $766d311b9f538b57$var$USE_ID = "useId";
const $766d311b9f538b57$var$useIdImpl = $81g6h[$766d311b9f538b57$var$USE_ID];
function $766d311b9f538b57$var$startTransitionSafe(cb) {
    if ($766d311b9f538b57$var$startTransitionImpl) $766d311b9f538b57$var$startTransitionImpl(cb);
    else cb();
}
function $766d311b9f538b57$var$flushSyncSafe(cb) {
    if ($766d311b9f538b57$var$flushSyncImpl) $766d311b9f538b57$var$flushSyncImpl(cb);
    else cb();
}
class $766d311b9f538b57$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $766d311b9f538b57$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $81g6h.useState(router.state);
    let [pendingState, setPendingState] = $81g6h.useState();
    let [vtContext, setVtContext] = $81g6h.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $81g6h.useState();
    let [transition, setTransition] = $81g6h.useState();
    let [interruption, setInterruption] = $81g6h.useState();
    let fetcherData = $81g6h.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $81g6h.useCallback((cb)=>{
        if (v7_startTransition) $766d311b9f538b57$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $81g6h.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $766d311b9f538b57$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $766d311b9f538b57$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $766d311b9f538b57$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $766d311b9f538b57$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $766d311b9f538b57$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $81g6h.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $81g6h.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $766d311b9f538b57$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $81g6h.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $81g6h.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $81g6h.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $81g6h.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $81g6h.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $81g6h.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement((0, $hE6rp.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $81g6h.createElement((0, $hE6rp.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $81g6h.createElement($766d311b9f538b57$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $81g6h.createElement($766d311b9f538b57$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $81g6h.createElement((0, $hE6rp.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $81g6h.createElement($766d311b9f538b57$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $766d311b9f538b57$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $hE6rp.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $766d311b9f538b57$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $81g6h.useRef();
    if (historyRef.current == null) historyRef.current = (0, $kEwLa.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $81g6h.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $81g6h.useCallback((newState)=>{
        v7_startTransition && $766d311b9f538b57$var$startTransitionImpl ? $766d311b9f538b57$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $81g6h.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $81g6h.createElement((0, $hE6rp.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $766d311b9f538b57$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $81g6h.useRef();
    if (historyRef.current == null) historyRef.current = (0, $kEwLa.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $81g6h.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $81g6h.useCallback((newState)=>{
        v7_startTransition && $766d311b9f538b57$var$startTransitionImpl ? $766d311b9f538b57$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $81g6h.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $81g6h.createElement((0, $hE6rp.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $766d311b9f538b57$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $81g6h.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $81g6h.useCallback((newState)=>{
        v7_startTransition && $766d311b9f538b57$var$startTransitionImpl ? $766d311b9f538b57$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $81g6h.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $81g6h.createElement((0, $hE6rp.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $766d311b9f538b57$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $766d311b9f538b57$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $766d311b9f538b57$export$a6c7ac8248d6e38a = /*#__PURE__*/ $81g6h.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $766d311b9f538b57$var$_objectWithoutPropertiesLoose(_ref7, $766d311b9f538b57$var$_excluded);
    let { basename: basename } = $81g6h.useContext((0, $hE6rp.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $766d311b9f538b57$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($766d311b9f538b57$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $kEwLa.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $hE6rp.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $766d311b9f538b57$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $81g6h.createElement("a", $766d311b9f538b57$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $766d311b9f538b57$export$b0d92dbee9b5b60d = /*#__PURE__*/ $81g6h.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $766d311b9f538b57$var$_objectWithoutPropertiesLoose(_ref8, $766d311b9f538b57$var$_excluded2);
    let path = (0, $hE6rp.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $hE6rp.useLocation)();
    let routerState = $81g6h.useContext((0, $hE6rp.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $81g6h.useContext((0, $hE6rp.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $766d311b9f538b57$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $kEwLa.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $81g6h.createElement($766d311b9f538b57$export$a6c7ac8248d6e38a, $766d311b9f538b57$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $766d311b9f538b57$export$a7fed597f4b8afd8 = /*#__PURE__*/ $81g6h.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $766d311b9f538b57$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $766d311b9f538b57$var$_objectWithoutPropertiesLoose(_ref9, $766d311b9f538b57$var$_excluded3);
    let submit = $766d311b9f538b57$export$47c85c6e3a081d3();
    let formAction = $766d311b9f538b57$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $81g6h.createElement("form", $766d311b9f538b57$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $766d311b9f538b57$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $766d311b9f538b57$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $766d311b9f538b57$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($766d311b9f538b57$var$DataRouterHook || ($766d311b9f538b57$var$DataRouterHook = {}));
var $766d311b9f538b57$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($766d311b9f538b57$var$DataRouterStateHook || ($766d311b9f538b57$var$DataRouterStateHook = {}));
// Internal hooks
function $766d311b9f538b57$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $766d311b9f538b57$var$useDataRouterContext(hookName) {
    let ctx = $81g6h.useContext((0, $hE6rp.UNSAFE_DataRouterContext));
    !ctx && (0, $kEwLa.UNSAFE_invariant)(false);
    return ctx;
}
function $766d311b9f538b57$var$useDataRouterState(hookName) {
    let state = $81g6h.useContext((0, $hE6rp.UNSAFE_DataRouterStateContext));
    !state && (0, $kEwLa.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $766d311b9f538b57$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $hE6rp.useNavigate)();
    let location = (0, $hE6rp.useLocation)();
    let path = (0, $hE6rp.useResolvedPath)(to, {
        relative: relative
    });
    return $81g6h.useCallback((event)=>{
        if ($766d311b9f538b57$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $kEwLa.createPath)(location) === (0, $kEwLa.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $766d311b9f538b57$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $81g6h.useRef($766d311b9f538b57$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $81g6h.useRef(false);
    let location = (0, $hE6rp.useLocation)();
    let searchParams = $81g6h.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $766d311b9f538b57$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $hE6rp.useNavigate)();
    let setSearchParams = $81g6h.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $766d311b9f538b57$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $766d311b9f538b57$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $766d311b9f538b57$var$fetcherId = 0;
let $766d311b9f538b57$var$getUniqueFetcherId = ()=>"__" + String(++$766d311b9f538b57$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $766d311b9f538b57$export$47c85c6e3a081d3() {
    let { router: router } = $766d311b9f538b57$var$useDataRouterContext($766d311b9f538b57$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $81g6h.useContext((0, $hE6rp.UNSAFE_NavigationContext));
    let currentRouteId = (0, $hE6rp.UNSAFE_useRouteId)();
    return $81g6h.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $766d311b9f538b57$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $766d311b9f538b57$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $766d311b9f538b57$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $766d311b9f538b57$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $81g6h.useContext((0, $hE6rp.UNSAFE_NavigationContext));
    let routeContext = $81g6h.useContext((0, $hE6rp.UNSAFE_RouteContext));
    !routeContext && (0, $kEwLa.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $766d311b9f538b57$var$_extends({}, (0, $hE6rp.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $hE6rp.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $kEwLa.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $kEwLa.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $766d311b9f538b57$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $766d311b9f538b57$var$useDataRouterContext($766d311b9f538b57$var$DataRouterHook.UseFetcher);
    let state = $766d311b9f538b57$var$useDataRouterState($766d311b9f538b57$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $81g6h.useContext($766d311b9f538b57$export$148fd98d095596d4);
    let route = $81g6h.useContext((0, $hE6rp.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $kEwLa.UNSAFE_invariant)(false);
    !route && (0, $kEwLa.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $kEwLa.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $766d311b9f538b57$var$useIdImpl ? $766d311b9f538b57$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $81g6h.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($766d311b9f538b57$var$getUniqueFetcherId());
    // Registration/cleanup
    $81g6h.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $81g6h.useCallback((href, opts)=>{
        !routeId && (0, $kEwLa.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $766d311b9f538b57$export$47c85c6e3a081d3();
    let submit = $81g6h.useCallback((target, opts)=>{
        submitImpl(target, $766d311b9f538b57$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $81g6h.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $81g6h.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $81g6h.createElement($766d311b9f538b57$export$a7fed597f4b8afd8, $766d311b9f538b57$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $kEwLa.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $81g6h.useMemo(()=>$766d311b9f538b57$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $766d311b9f538b57$export$fa996778a3a31087() {
    let state = $766d311b9f538b57$var$useDataRouterState($766d311b9f538b57$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $766d311b9f538b57$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $766d311b9f538b57$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $766d311b9f538b57$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $766d311b9f538b57$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $766d311b9f538b57$var$useDataRouterContext($766d311b9f538b57$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $766d311b9f538b57$var$useDataRouterState($766d311b9f538b57$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $81g6h.useContext((0, $hE6rp.UNSAFE_NavigationContext));
    let location = (0, $hE6rp.useLocation)();
    let matches = (0, $hE6rp.useMatches)();
    let navigation = (0, $hE6rp.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $81g6h.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $766d311b9f538b57$var$usePageHide($81g6h.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $766d311b9f538b57$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $766d311b9f538b57$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($766d311b9f538b57$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $81g6h.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $766d311b9f538b57$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $766d311b9f538b57$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $81g6h.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($766d311b9f538b57$var$_extends({}, location, {
                    pathname: (0, $kEwLa.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($766d311b9f538b57$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $81g6h.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $766d311b9f538b57$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $81g6h.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $766d311b9f538b57$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $81g6h.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $766d311b9f538b57$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $hE6rp.useBlocker)(when);
    $81g6h.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $81g6h.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $766d311b9f538b57$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $81g6h.useContext($766d311b9f538b57$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $kEwLa.UNSAFE_invariant)(false);
    let { basename: basename } = $766d311b9f538b57$var$useDataRouterContext($766d311b9f538b57$var$DataRouterHook.useViewTransitionState);
    let path = (0, $hE6rp.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $kEwLa.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $kEwLa.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $kEwLa.matchPath)(path.pathname, nextPath) != null || (0, $kEwLa.matchPath)(path.pathname, currentPath) != null;
}

});


parcelRegister("fUhFD", function(module, exports) {

$parcel$export(module.exports, "sendAnalyticsEventPatientDeleted", () => $eeda4a12e6390dc3$export$2c80c2b01c09e2a9);
$parcel$export(module.exports, "sendAnalyticsEventReinvitePatient", () => $eeda4a12e6390dc3$export$cf8e0dd538dbbb88);
$parcel$export(module.exports, "sendAnalyticsEventPatientListViewed", () => $eeda4a12e6390dc3$export$8ee79f3030eff1ed);
$parcel$export(module.exports, "sendAnalyticsEventSharePatientCode", () => $eeda4a12e6390dc3$export$18e44064e313eac5);
$parcel$export(module.exports, "sendAnalyticsEventEditPatientDetails", () => $eeda4a12e6390dc3$export$e0fb29aaf55df80e);
$parcel$export(module.exports, "sendAnalyticsEventPatientCreated", () => $eeda4a12e6390dc3$export$72c92421ec86aaaf);
$parcel$export(module.exports, "sendAnalyticsEventCreateNewPatient", () => $eeda4a12e6390dc3$export$2437ab211e073409);
$parcel$export(module.exports, "sendAnalyticsEventJoinExistingPatient", () => $eeda4a12e6390dc3$export$dad7ba69dbfd6b61);
$parcel$export(module.exports, "sendAnalyticsEventJoinPatientHealthcareTeam", () => $eeda4a12e6390dc3$export$4d22f16f69df3b02);

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $6Yxa2 = parcelRequire("6Yxa2");
const $eeda4a12e6390dc3$var$SHARING_METHOD_ANALYTICS_ACTION = {
    print: "patientCreatedPrintCode",
    email: "patientCreatedSendEmail"
};
const $eeda4a12e6390dc3$export$2c80c2b01c09e2a9 = (status)=>{
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PATIENT,
        action: "patientDeleted",
        params: [
            status === (0, $6Yxa2.PatientStatus).Pending ? "pending" : "registered"
        ]
    });
};
const $eeda4a12e6390dc3$export$cf8e0dd538dbbb88 = ()=>{
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PATIENT,
        action: "openReinviteWindow"
    });
};
const $eeda4a12e6390dc3$export$8ee79f3030eff1ed = (homeTab)=>{
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PATIENT,
        action: "viewPatientList",
        params: [
            homeTab
        ]
    });
};
const $eeda4a12e6390dc3$export$18e44064e313eac5 = (sharingMethod, newlyInvited, withDetail)=>{
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PATIENT,
        action: $eeda4a12e6390dc3$var$SHARING_METHOD_ANALYTICS_ACTION[sharingMethod],
        params: [
            withDetail ? "withDetail" : "withoutDetail",
            newlyInvited ? "invite" : "reinvite"
        ]
    });
};
const $eeda4a12e6390dc3$export$e0fb29aaf55df80e = (oldPatient, updatedFields)=>{
    (0, $ghfIB.analyticsService).trackEvent({
        action: "editPatientDetail",
        category: (0, $auPqo.AnalyticsCategory).PATIENT,
        params: [
            oldPatient.functionalStatus !== updatedFields.functionalStatus ? "functionalStatus" : "",
            !(0, $6Yxa2.isPendingPatient)(oldPatient) && oldPatient.disease !== updatedFields.disease ? "medicalCondition" : "",
            oldPatient.analyticsId
        ]
    });
};
const $eeda4a12e6390dc3$export$72c92421ec86aaaf = (analyticsId, withDetail)=>{
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PATIENT,
        action: "patientCreated",
        params: [
            withDetail ? "withDetail" : "withoutDetail",
            analyticsId
        ]
    });
};
const $eeda4a12e6390dc3$export$2437ab211e073409 = ()=>{
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PATIENT,
        action: "createNewPatient"
    });
};
const $eeda4a12e6390dc3$export$dad7ba69dbfd6b61 = ()=>{
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PATIENT,
        action: "joinExistingPatient"
    });
};
const $eeda4a12e6390dc3$export$4d22f16f69df3b02 = (patientId)=>{
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PATIENT,
        action: "existingPatientAdded",
        params: [
            patientId
        ]
    });
};

});

parcelRegister("imaOW", function(module, exports) {

$parcel$export(module.exports, "CardType", () => $4f6621dd01bc37d2$export$f1a79bffad3377cd);
$parcel$export(module.exports, "AlertCard", () => $4f6621dd01bc37d2$export$15f660e0f0f2d11f);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $c22GE = parcelRequire("c22GE");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");
var $4f6621dd01bc37d2$var$VerifyIcon = function VerifyIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.892 3.038C10.042 4.652 7.322 6 5 6v7c0 2.236.77 3.861 1.987 5.106 1.243 1.274 2.997 2.194 5.01 2.889l.022.008c2.005-.7 3.754-1.622 4.995-2.895C18.229 16.861 19 15.236 19 13V6c-2.32 0-5.032-1.338-6.892-2.962a.17.17 0 0 0-.216 0ZM10.59 1.52a2.17 2.17 0 0 1 2.82 0l.008.007C15.058 2.961 17.323 4 19 4a2 2 0 0 1 2 2v7c0 2.764-.98 4.889-2.554 6.504-1.547 1.588-3.625 2.64-5.777 3.39l-.008.003a2 2 0 0 1-1.327-.015c-2.154-.745-4.231-1.794-5.778-3.378C3.979 17.889 3 15.764 3 13V6a2 2 0 0 1 2-2c1.676 0 3.952-1.049 5.582-2.473l.008-.007Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.707 9.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 12.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
                fill: "currentColor"
            })
        ]
    });
};
$4f6621dd01bc37d2$var$VerifyIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $4f6621dd01bc37d2$var$InfoIcon = function InfoIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Zm0-20c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12.01 17.17c-.55 0-1-.45-1-1v-5.44c0-.55.45-1 1-1s1 .45 1 1v5.44c0 .55-.45 1-1 1ZM12 8.11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                fill: "currentColor"
            })
        ]
    });
};
$4f6621dd01bc37d2$var$InfoIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $4f6621dd01bc37d2$var$ProgressIcon = function ProgressIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M9.67 1.125a1.1 1.1 0 0 0-.258.026c-1.25.283-2.416.78-3.468 1.445-.597.378-.675 1.223-.176 1.723l.003.002c.358.358.92.443 1.347.172a8.845 8.845 0 0 1 2.82-1.171c.492-.11.825-.572.825-1.076a1.12 1.12 0 0 0-1.092-1.121Zm4.413 0c-.59.009-1.095.5-1.095 1.121v.002c0 .51.344.963.841 1.076 3.97.892 6.946 4.44 6.946 8.675s-2.976 7.784-6.946 8.676c-.497.112-.84.566-.84 1.075v.003c0 .71.659 1.253 1.35 1.095C19.292 21.724 23 17.287 23 11.999c0-5.287-3.709-9.723-8.66-10.848a1.084 1.084 0 0 0-.257-.026ZM3.287 5.568a1.08 1.08 0 0 0-.815.5 11.06 11.06 0 0 0-1.444 3.468c-.157.691.385 1.35 1.095 1.35.503 0 .965-.333 1.075-.825a8.809 8.809 0 0 1 1.171-2.82c.272-.427.187-.989-.172-1.347l-.002-.002a1.126 1.126 0 0 0-.908-.324Zm13.017 3.083c-.29.009-.564.13-.765.337l-4.776 4.776-1.438-1.439a1.113 1.113 0 1 0-1.573 1.573l2.225 2.225a1.112 1.112 0 0 0 1.573 0l5.562-5.562a1.113 1.113 0 0 0-.808-1.91Zm-14.181 4.46c-.71 0-1.253.66-1.095 1.352.283 1.25.778 2.417 1.444 3.468.377.597 1.224.675 1.723.176.36-.36.446-.922.174-1.35a8.844 8.844 0 0 1-1.171-2.82c-.11-.492-.572-.825-1.075-.825Zm4.297 6.245c-.239.032-.47.143-.65.322l-.002.002c-.5.5-.421 1.345.176 1.723a11.06 11.06 0 0 0 3.468 1.445c.692.157 1.351-.386 1.351-1.095 0-.504-.334-.966-.825-1.076a8.821 8.821 0 0 1-2.818-1.171 1.04 1.04 0 0 0-.7-.15Z",
            fill: "currentColor"
        })
    });
};
$4f6621dd01bc37d2$var$ProgressIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $4f6621dd01bc37d2$var$CheckIcon = function CheckIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.064 5.318c.449.449.449 1.177 0 1.626L9.325 18.683a1.15 1.15 0 0 1-1.626 0L2.936 13.92a1.15 1.15 0 0 1 1.627-1.627l3.95 3.95L19.437 5.318a1.15 1.15 0 0 1 1.626 0Z",
            fill: "currentColor"
        })
    });
};
$4f6621dd01bc37d2$var$CheckIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $4f6621dd01bc37d2$var$WarnIcon = function WarnIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M11.99 6.83c.55 0 1 .45 1 1v5.44c0 .55-.45 1-1 1s-1-.45-1-1V7.83c0-.55.45-1 1-1ZM12 15.89a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M19.288 22.087H4.711a3.695 3.695 0 0 1-3.165-1.753 3.62 3.62 0 0 1-.167-3.54L8.68 3.941a3.73 3.73 0 0 1 6.651.024l7.265 12.784a3.637 3.637 0 0 1-.143 3.585 3.696 3.696 0 0 1-3.165 1.753ZM12 3.747a1.846 1.846 0 0 0-1.69 1.035l-.023.045-7.289 12.828a1.76 1.76 0 0 0 .107 1.712 1.875 1.875 0 0 0 1.606.886h14.581a1.875 1.875 0 0 0 1.607-.886 1.776 1.776 0 0 0 .082-1.757L13.713 4.827A1.87 1.87 0 0 0 12 3.747Z",
                fill: "currentColor"
            })
        ]
    });
};
$4f6621dd01bc37d2$var$WarnIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $4f6621dd01bc37d2$export$f1a79bffad3377cd;
(function(CardType) {
    CardType["Info"] = "Info";
    CardType["Warn"] = "Warn";
    CardType["Pending"] = "Pending";
    CardType["Validated"] = "Validated";
    CardType["Warning"] = "Warning";
})($4f6621dd01bc37d2$export$f1a79bffad3377cd || ($4f6621dd01bc37d2$export$f1a79bffad3377cd = {}));
const $4f6621dd01bc37d2$var$CardStyle = {
    ["Info"]: {
        assetColor: (0, $kKnoQ.colors).primaryDark,
        backgroundColor: (0, $kKnoQ.colors).primary10,
        icon: /*#__PURE__*/ (0, $iKObn.jsx)($4f6621dd01bc37d2$var$VerifyIcon, {
            width: 20,
            height: 20,
            color: (0, $kKnoQ.colors).primaryDark
        }),
        padding: "16px",
        width: "auto"
    },
    ["Warn"]: {
        assetColor: (0, $kKnoQ.colors).warnDark,
        backgroundColor: (0, $kKnoQ.colors).warn,
        icon: /*#__PURE__*/ (0, $iKObn.jsx)($4f6621dd01bc37d2$var$InfoIcon, {
            width: 20,
            height: 20,
            color: (0, $kKnoQ.colors).warnDark
        }),
        padding: "16px",
        width: "auto"
    },
    ["Warning"]: {
        assetColor: (0, $kKnoQ.colors).grey,
        backgroundColor: (0, $kKnoQ.colors).primary10,
        icon: /*#__PURE__*/ (0, $iKObn.jsx)($4f6621dd01bc37d2$var$WarnIcon, {
            width: 20,
            height: 20,
            color: (0, $kKnoQ.colors).grey
        }),
        padding: "8px 16px",
        width: "100%"
    },
    ["Pending"]: {
        assetColor: (0, $kKnoQ.colors).primaryDark,
        backgroundColor: (0, $kKnoQ.colors).primary10,
        icon: /*#__PURE__*/ (0, $iKObn.jsx)($4f6621dd01bc37d2$var$ProgressIcon, {
            width: 20,
            height: 20,
            color: (0, $kKnoQ.colors).primaryDark
        }),
        padding: "16px",
        width: "auto"
    },
    ["Validated"]: {
        assetColor: (0, $kKnoQ.colors).validationDark,
        backgroundColor: (0, $kKnoQ.colors).validation10,
        icon: /*#__PURE__*/ (0, $iKObn.jsx)($4f6621dd01bc37d2$var$CheckIcon, {
            width: 20,
            height: 20,
            color: (0, $kKnoQ.colors).validationDark
        }),
        padding: "16px",
        width: "auto"
    }
};
const $4f6621dd01bc37d2$export$15f660e0f0f2d11f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ title: title, message: message, cardType: cardType, secondaryButtons: secondaryButtons, textButton: textButton, onCrossClicked: onCrossClicked, ...otherProps }, ref)=>/*#__PURE__*/ (0, $iKObn.jsxs)($4f6621dd01bc37d2$var$AlertCardContainer, {
        cardType: cardType,
        ref: ref,
        ...otherProps,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: $4f6621dd01bc37d2$var$CardStyle[cardType].icon
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($4f6621dd01bc37d2$var$Container, {
                className: "alertContainer",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($4f6621dd01bc37d2$var$Column, {
                        children: [
                            title && /*#__PURE__*/ (0, $iKObn.jsx)($4f6621dd01bc37d2$var$CardTitle, {
                                className: "p-size-s-bold",
                                textColor: $4f6621dd01bc37d2$var$CardStyle[cardType].assetColor,
                                children: title
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($4f6621dd01bc37d2$var$CardDescription, {
                                className: "p-size-s",
                                textColor: $4f6621dd01bc37d2$var$CardStyle[cardType].assetColor,
                                children: message
                            })
                        ]
                    }),
                    cardType === "Validated" && /*#__PURE__*/ (0, $iKObn.jsx)($4f6621dd01bc37d2$var$DeleteIcon, {
                        className: "pi pi-times",
                        onClick: onCrossClicked
                    }),
                    secondaryButtons && secondaryButtons.length > 0 && secondaryButtons.map((action, index)=>/*#__PURE__*/ (0, $iKObn.jsx)($4f6621dd01bc37d2$var$OneLineButton, {
                            uiStyle: "secondary_B",
                            onClick: action.onPressed,
                            loading: action.loading,
                            children: action.title
                        }, `${action.title}-${index}`)),
                    /*#__PURE__*/ (0, $iKObn.jsx)($4f6621dd01bc37d2$var$LabelContainer, {
                        children: textButton && (textButton.onPressed ? /*#__PURE__*/ (0, $iKObn.jsx)($4f6621dd01bc37d2$var$StyledTextButton, {
                            onClick: textButton.onPressed,
                            label: textButton.text
                        }) : /*#__PURE__*/ (0, $iKObn.jsx)($4f6621dd01bc37d2$var$Label, {
                            children: textButton.text
                        }))
                    })
                ]
            })
        ]
    }));
$4f6621dd01bc37d2$export$15f660e0f0f2d11f.displayName = "AlertCard";
const $4f6621dd01bc37d2$var$AlertCardContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("XS")}
	padding: ${({ cardType: cardType })=>$4f6621dd01bc37d2$var$CardStyle[cardType].padding};
	border-radius: 8px;
	background-color: ${({ cardType: cardType })=>$4f6621dd01bc37d2$var$CardStyle[cardType].backgroundColor};
	width: ${({ cardType: cardType })=>$4f6621dd01bc37d2$var$CardStyle[cardType].width};
`;
const $4f6621dd01bc37d2$var$CardTitle = (0, $5UMQ1.default).p`
	color: ${({ textColor: textColor })=>textColor};
`;
const $4f6621dd01bc37d2$var$CardDescription = (0, $5UMQ1.default).p`
	color: ${({ textColor: textColor })=>textColor};
	white-space: pre-wrap;
`;
const $4f6621dd01bc37d2$var$Column = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)()}
	flex: 1;
`;
const $4f6621dd01bc37d2$var$LabelContainer = (0, $5UMQ1.default).div`
	margin-right: 8px;
	white-space: nowrap;
`;
const $4f6621dd01bc37d2$var$Label = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).grey};
`;
const $4f6621dd01bc37d2$var$StyledTextButton = (0, $5UMQ1.default)((0, $c22GE.TertiaryButton))`
	white-space: nowrap;
`;
const $4f6621dd01bc37d2$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("XS", "spacebetween")}
	flex-grow: 1;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		${(0, $5WGN2.stack)("XS")}
	}
`;
const $4f6621dd01bc37d2$var$OneLineButton = (0, $5UMQ1.default)((0, $dhb7H.Button))`
	white-space: nowrap;
	min-width: max-content;
`;
const $4f6621dd01bc37d2$var$DeleteIcon = (0, $5UMQ1.default).i`
	cursor: pointer;
	white-space: nowrap;
	min-width: max-content;
`;

});
parcelRegister("c22GE", function(module, exports) {

$parcel$export(module.exports, "TertiaryButton", () => $4a459d3aa4eb477a$export$3a30621a8b0c1490);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $jTpg0 = parcelRequire("jTpg0");
parcelRequire("81g6h");
var $4a459d3aa4eb477a$var$ButtonState;
(function(ButtonState) {
    ButtonState["PRESSED"] = "pressed";
    ButtonState["HOVER"] = "hover";
    ButtonState["DISABLED"] = "disabled";
    ButtonState["DEFAULT"] = "default";
})($4a459d3aa4eb477a$var$ButtonState || ($4a459d3aa4eb477a$var$ButtonState = {}));
const $4a459d3aa4eb477a$var$TERTIARY_BUTTON_COLORS = {
    primary: {
        ["disabled"]: (0, $kKnoQ.colors).grey80,
        ["pressed"]: (0, $kKnoQ.colors).primaryDark,
        ["hover"]: (0, $kKnoQ.colors).primaryDark50,
        ["default"]: (0, $kKnoQ.colors).primary
    },
    danger: {
        ["disabled"]: (0, $kKnoQ.colors).grey80,
        ["pressed"]: (0, $kKnoQ.colors).rejectionDark,
        ["hover"]: (0, $kKnoQ.colors).rejectionDark,
        ["default"]: (0, $kKnoQ.colors).rejection
    }
};
const $4a459d3aa4eb477a$export$3a30621a8b0c1490 = ({ uiStyle: uiStyle = "primary", label: label, onClick: onClick, disabled: disabled, loading: loading, style: style, size: size = "M", icon: icon, className: className })=>/*#__PURE__*/ (0, $iKObn.jsxs)($4a459d3aa4eb477a$var$ButtonContainer, {
        onClick: onClick,
        uiStyle: uiStyle,
        style: {
            pointerEvents: disabled ? "none" : "auto",
            cursor: disabled ? "none" : "pointer",
            color: disabled ? $4a459d3aa4eb477a$var$TERTIARY_BUTTON_COLORS[uiStyle].disabled : undefined,
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($4a459d3aa4eb477a$var$ButtonContent, {
                loading: loading,
                style: {
                    gap: size === "S" ? 4 : undefined
                },
                className: className,
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($4a459d3aa4eb477a$var$ButtonLabel, {
                        className: size === "S" ? "p-size-xs-semi-bold" : "p-size-s-bold",
                        children: label
                    }),
                    (0, $lTdpc.isNotNil)(icon) && (0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).isString(icon) ? /*#__PURE__*/ (0, $iKObn.jsx)("i", {
                        className: icon,
                        style: {
                            fontSize: size === "S" ? 9 : 13
                        }
                    }) : icon
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($4a459d3aa4eb477a$var$LoadingContainer, {
                loading: loading,
                children: /*#__PURE__*/ (0, $iKObn.jsx)("i", {
                    className: "pi pi-spin pi-spinner",
                    style: {
                        fontSize: 15
                    }
                })
            })
        ]
    });
const $4a459d3aa4eb477a$var$ButtonContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, undefined, "center")};

	:hover {
		color: ${({ uiStyle: uiStyle })=>$4a459d3aa4eb477a$var$TERTIARY_BUTTON_COLORS[uiStyle].hover};
	}

	:active {
		color: ${({ uiStyle: uiStyle })=>$4a459d3aa4eb477a$var$TERTIARY_BUTTON_COLORS[uiStyle].pressed};
	}

	color: ${({ uiStyle: uiStyle })=>$4a459d3aa4eb477a$var$TERTIARY_BUTTON_COLORS[uiStyle].default};

	position: relative;
	width: fit-content;
`;
const $4a459d3aa4eb477a$var$ButtonLabel = (0, $5UMQ1.default).p``;
const $4a459d3aa4eb477a$var$ButtonContent = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8, undefined, "center")};
	visibility: ${({ loading: loading })=>loading ? "hidden" : "visible"};
`;
const $4a459d3aa4eb477a$var$LoadingContainer = (0, $5UMQ1.default).div`
	visibility: ${({ loading: loading })=>loading ? "visible" : "hidden"};
	position: absolute;
	right: 0;
	left: 0;
	display: flex;
	justify-content: center;
`;

});


parcelRegister("dkVlr", function(module, exports) {

$parcel$export(module.exports, "FilterTag", () => $933ee889627cf561$export$358a8964f40dc99a);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
var $933ee889627cf561$var$CrossIcon = function CrossIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M6.14 5.302a.836.836 0 0 0-.583 1.435l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26a.834.834 0 0 0 1.377-.263.836.836 0 0 0-.195-.919L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 0 0-.6-.254Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.14 5.015a1.123 1.123 0 0 1 .803.338L12 10.41l5.057-5.057a1.123 1.123 0 1 1 1.588 1.589l-5.057 5.056 5.056 5.056c.107.103.192.226.251.363l-.263.114a.836.836 0 0 0-.189-.272L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 1 0-1.182 1.181l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26c.077.08.17.145.271.189l-.114.263a1.124 1.124 0 0 1-.362-.25L12 13.585l-5.056 5.056a1.123 1.123 0 1 1-1.588-1.588l5.056-5.056-5.057-5.056a1.123 1.123 0 0 1 .785-1.927ZM17.532 18.63a.834.834 0 0 0 1.168-.776.836.836 0 0 0-.068-.323l.263-.114a1.125 1.125 0 0 1-1.477 1.476l.114-.263Z",
                fill: "currentColor"
            })
        ]
    });
};
$933ee889627cf561$var$CrossIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $933ee889627cf561$export$358a8964f40dc99a = ({ label: label, onCrossClicked: onCrossClicked })=>/*#__PURE__*/ (0, $iKObn.jsxs)($933ee889627cf561$var$TagContainer, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                className: "p-size-s-bold",
                children: label
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($933ee889627cf561$var$StyledCrossIcon, {
                height: 16,
                width: 16,
                onClick: onCrossClicked
            })
        ]
    });
const $933ee889627cf561$var$TagContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8, "center", "center")}
	padding:8px 16px;
	border-radius: 32px;
	border: 1px solid ${(0, $kKnoQ.colors).primary25};
	width: fit-content;
`;
const $933ee889627cf561$var$StyledCrossIcon = (0, $5UMQ1.default)($933ee889627cf561$var$CrossIcon)`
	cursor: pointer;
`;

});

parcelRegister("9HyYO", function(module, exports) {

$parcel$export(module.exports, "PendingPatientListing", () => $c6e15827fd5474e6$export$9f94b85a5f79a302);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $aEP4N = parcelRequire("aEP4N");

var $fUhFD = parcelRequire("fUhFD");

var $bC9c0 = parcelRequire("bC9c0");

var $243Cr = parcelRequire("243Cr");

var $02Kb9 = parcelRequire("02Kb9");

var $5kXMA = parcelRequire("5kXMA");

var $6Curj = parcelRequire("6Curj");

var $2LUd1 = parcelRequire("2LUd1");

var $iPFid = parcelRequire("iPFid");

var $970DV = parcelRequire("970DV");

var $eiBvZ = parcelRequire("eiBvZ");

var $2tsa2 = parcelRequire("2tsa2");

var $izIaa = parcelRequire("izIaa");

var $1LHh3 = parcelRequire("1LHh3");

var $81g6h = parcelRequire("81g6h");
const $c6e15827fd5474e6$var$expirationBody = (data)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $6Curj.ExpirationRemainingDays), {
        patient: data
    });
const $c6e15827fd5474e6$var$patientActionBody = (data)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $2LUd1.PatientActionButton), {
        patient: data
    });
const $c6e15827fd5474e6$var$ResendCodeCell = ({ patient: patient })=>{
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $970DV.ResendCodeButton), {
        onClick: ()=>{
            (0, $fUhFD.sendAnalyticsEventReinvitePatient)();
            dialogContext?.openModal((0, $243Cr.ModalId).AddPatient, {
                pendingPatient: patient
            });
        }
    });
};
const $c6e15827fd5474e6$var$resendCodeBody = (data)=>/*#__PURE__*/ (0, $iKObn.jsx)($c6e15827fd5474e6$var$ResendCodeCell, {
        patient: data
    });
const $c6e15827fd5474e6$export$9f94b85a5f79a302 = ({ pendingPatients: pendingPatients })=>{
    const { format: format, formatDateMed: formatDateMed } = (0, $1eHG3.useI18n)();
    const { formatPatientName: formatPatientName } = (0, $aEP4N.useFormatPatients)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const columnProps = {
        sortable: true
    };
    const pendingPatientStatsRows = pendingPatients.map((patient)=>({
            ...patient,
            name: formatPatientName(patient)
        }));
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    if (!isDesktop) return pendingPatientStatsRows.length === 0 ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $2tsa2.EmptyPatientMessage), {
        variant: (0, $2tsa2.EmptyPatientMessageVariant).NoPendingPatients
    }) : pendingPatientStatsRows.map((patient)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $iPFid.PendingPatientListingRowMobile), {
            patient: patient
        }, patient.id));
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $1LHh3.DataTable), {
        className: "p-round-corner",
        dataKey: "activationCode",
        tableStyle: {
            width: "100%"
        },
        value: pendingPatientStatsRows,
        rowHover: true,
        onRowClick: (e)=>{
            const data = e.data;
            (0, $bC9c0.sendAnalyticsEventViewPatientDetail)(data.analyticsId, (0, $bC9c0.AnalyticsProgramClickType).LIST_CLICK);
            dialogContext?.openModal((0, $243Cr.ModalId).AddPatient, {
                pendingPatient: data,
                step: (0, $eiBvZ.DialogStep).RegistrationDetails
            });
        },
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $izIaa.Column), {
                ...columnProps,
                field: "name",
                bodyStyle: {
                    maxWidth: 300,
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                },
                bodyClassName: "p-size-s-bold",
                header: format("home.pendingPatientsListing.patientNameColumn"),
                body: ({ name: name })=>name
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $izIaa.Column), {
                ...columnProps,
                field: "activationCode",
                header: format("home.pendingPatientsListing.codeColumn"),
                body: ({ activationCode: activationCode })=>activationCode
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $izIaa.Column), {
                ...columnProps,
                field: "creationDate",
                header: format("home.pendingPatientsListing.creationDateColumn"),
                body: (data)=>formatDateMed(data.creationDate)
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $izIaa.Column), {
                ...columnProps,
                field: "expiration",
                header: /*#__PURE__*/ (0, $iKObn.jsx)((0, $02Kb9.Tooltip), {
                    content: format("home.pendingPatientsListing.expiresInColumn.tooltip"),
                    maxWidth: 400,
                    placement: "top",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                        className: "p-column-title last-completed-session",
                        children: format("home.pendingPatientsListing.expiresInColumn")
                    })
                }),
                body: $c6e15827fd5474e6$var$expirationBody
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $izIaa.Column), {
                field: "resendCode",
                body: $c6e15827fd5474e6$var$resendCodeBody
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $izIaa.Column), {
                field: "additionalOptions",
                style: {
                    width: 72
                },
                body: $c6e15827fd5474e6$var$patientActionBody
            })
        ]
    });
};

});
parcelRegister("bC9c0", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProgramLocation", () => $5fb05effebd8e096$export$fc1371b4784f7793);
$parcel$export(module.exports, "AnalyticsProgramClickType", () => $5fb05effebd8e096$export$22b357ec6512c533);
$parcel$export(module.exports, "sendAnalyticsEventSaveProgram", () => $5fb05effebd8e096$export$ab1173c23497c1ea);
$parcel$export(module.exports, "sendAnalyticsEventCreateProgram", () => $5fb05effebd8e096$export$6462b4be5e45be2e);
$parcel$export(module.exports, "sendAnalyticsEventExtendProgram", () => $5fb05effebd8e096$export$dc7973df9e190322);
$parcel$export(module.exports, "sendAnalyticsEventEditProgram", () => $5fb05effebd8e096$export$da2076d8282747b);
$parcel$export(module.exports, "sendAnalyticsEventDeleteProgram", () => $5fb05effebd8e096$export$fcc9bf73ab200f75);
$parcel$export(module.exports, "sendAnalyticsEventStopProgram", () => $5fb05effebd8e096$export$82759146be3ef7e9);
$parcel$export(module.exports, "sendAnalyticsEventViewPatientDetail", () => $5fb05effebd8e096$export$dfdc91f8764f6252);
$parcel$export(module.exports, "sendAnalyticsEventSwitchPatientDetail", () => $5fb05effebd8e096$export$ac53b8d7665762ba);
$parcel$export(module.exports, "sendAnalyticsEventDateModification", () => $5fb05effebd8e096$export$c61ad586955a2cb2);
$parcel$export(module.exports, "sendAnalyticsEventUseTemplateForProgram", () => $5fb05effebd8e096$export$77db745a64bfd7c7);
$parcel$export(module.exports, "sendAnalyticsEventStartProgram", () => $5fb05effebd8e096$export$e05698c52c363e8c);
$parcel$export(module.exports, "sendAnalyticsEventViewProgram", () => $5fb05effebd8e096$export$b333618d08ca77d3);
$parcel$export(module.exports, "sendAnalyticsEventOpenMoodTooltip", () => $5fb05effebd8e096$export$9cb78434141771ab);
$parcel$export(module.exports, "sendAnalyticsEventOpenExertionTooltip", () => $5fb05effebd8e096$export$1bf5d571f8ed59b3);
$parcel$export(module.exports, "sendAnalyticsEventDuplicateProgramAsDraft", () => $5fb05effebd8e096$export$b3ae20aaba5edbb9);
$parcel$export(module.exports, "sendAnalyticsEventDuplicateProgramAsTemplate", () => $5fb05effebd8e096$export$210dbd60dde2aaa6);
$parcel$export(module.exports, "sendAnalyticsEventProgramDurationExtendedShortcut", () => $5fb05effebd8e096$export$47eb78b39a8ac99d);
$parcel$export(module.exports, "sendAnalyticsEventSetProgramDurationShortcut", () => $5fb05effebd8e096$export$129a2af3068f09f);
$parcel$export(module.exports, "sendAnalyticsEventViewGuide", () => $5fb05effebd8e096$export$b516f0fc55a1fea9);

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $isRr9 = parcelRequire("isRr9");

var $6Yxa2 = parcelRequire("6Yxa2");

var $lDZlX = parcelRequire("lDZlX");

var $lTdpc = parcelRequire("lTdpc");

var $kXaMn = parcelRequire("kXaMn");

var $jTpg0 = parcelRequire("jTpg0");
var $5fb05effebd8e096$export$fc1371b4784f7793;
(function(AnalyticsProgramLocation) {
    AnalyticsProgramLocation["PROGRAM_BUILDER"] = "programBuilder";
    AnalyticsProgramLocation["PATIENT_DETAIL"] = "patientDetail";
    AnalyticsProgramLocation["HOME"] = "home";
    AnalyticsProgramLocation["PROGRESS_TAB"] = "progressTab";
    AnalyticsProgramLocation["PROGRAM_TAB"] = "programTab";
    AnalyticsProgramLocation["PROGRAM_TAB_TOP"] = "programTabTop";
    AnalyticsProgramLocation["PROGRAM_TAB_BOTTOM"] = "programTabBottom";
    AnalyticsProgramLocation["PROGRAM_PAGE"] = "programPage";
})($5fb05effebd8e096$export$fc1371b4784f7793 || ($5fb05effebd8e096$export$fc1371b4784f7793 = {}));
var $5fb05effebd8e096$export$22b357ec6512c533;
(function(AnalyticsProgramClickType) {
    AnalyticsProgramClickType["LIST_CLICK"] = "listClick";
    AnalyticsProgramClickType["OPTION_CLICK"] = "optionClick";
    AnalyticsProgramClickType["PROGRAM_LIST_DETAIL"] = "programListDetail";
    AnalyticsProgramClickType["PROGRAM_LIST_CLICK"] = "programListClick";
})($5fb05effebd8e096$export$22b357ec6512c533 || ($5fb05effebd8e096$export$22b357ec6512c533 = {}));
const $5fb05effebd8e096$export$ab1173c23497c1ea = (patient, programId)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "saveProgram",
        params: [
            patient.analyticsId,
            programId
        ]
    });
const $5fb05effebd8e096$export$6462b4be5e45be2e = (location, analyticsId, fromTemplate)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "createProgram",
        params: [
            location,
            analyticsId ?? "",
            fromTemplate ? "template" : "blank"
        ]
    });
const $5fb05effebd8e096$export$dc7973df9e190322 = (location, analyticsId, programId)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "extendCTA",
        params: [
            analyticsId,
            programId,
            location
        ]
    });
const $5fb05effebd8e096$export$da2076d8282747b = (params)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "editProgram",
        params: params
    });
const $5fb05effebd8e096$export$fcc9bf73ab200f75 = (patient, programId, location)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "deleteProgram",
        params: [
            location,
            patient.analyticsId,
            programId
        ]
    });
const $5fb05effebd8e096$export$82759146be3ef7e9 = (patient, programId, location)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "stopProgram",
        params: [
            location,
            patient.analyticsId,
            programId
        ]
    });
const $5fb05effebd8e096$export$dfdc91f8764f6252 = (analyticsId, clickType)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "viewPatientDetail",
        params: [
            (0, $lDZlX.TabPatientDetails).PROGRESS_TAB,
            analyticsId,
            clickType
        ]
    });
const $5fb05effebd8e096$export$ac53b8d7665762ba = (analyticsId, tab)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "switchPatientDetail",
        params: [
            tab,
            analyticsId
        ]
    });
const $5fb05effebd8e096$export$c61ad586955a2cb2 = (patientId, program, dates)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "dateModification",
        params: (0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).compact([
            patientId,
            (0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).get(program, "id"),
            (0, $lTdpc.isNotNil)(dates.startDate) && (0, $kXaMn.dateToDateDto)(dates.startDate),
            dates.endDate && (0, $kXaMn.dateToDateDto)(dates.endDate)
        ])
    });
const $5fb05effebd8e096$export$77db745a64bfd7c7 = (analyticsId, template, exerciseDetails, patientStatus)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "useTemplateForProgram",
        params: [
            analyticsId,
            template.id,
            template.sessionsPerWeek,
            template.exercisesPerWeek,
            exerciseDetails.exerciseTitles.join(";"),
            exerciseDetails.exerciseUnits.join(";"),
            exerciseDetails.exerciseSets.join(";"),
            patientStatus ?? "",
            exerciseDetails.exerciseIds.join(";"),
            exerciseDetails.exerciseRevisions.join(";"),
            exerciseDetails.exerciseCategories.join(";"),
            exerciseDetails.exerciseBodyParts.join(";"),
            exerciseDetails.exerciseDifficulties.join(";"),
            exerciseDetails.exerciseStartingPosition.join(";")
        ]
    });
const $5fb05effebd8e096$export$e05698c52c363e8c = (analyticsId, startedProgram, exerciseDetails, patientStatus)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "startProgram",
        params: [
            analyticsId,
            startedProgram.id,
            startedProgram.sessionsPerWeek,
            startedProgram.exercisesPerWeek,
            (0, $kXaMn.computeDiffInDays)(startedProgram.startDate, startedProgram.endDate),
            (0, $kXaMn.dateToDateDto)(startedProgram.startDate),
            exerciseDetails.exerciseUnits.join(";"),
            exerciseDetails.exerciseSets.join(";"),
            patientStatus === (0, $6Yxa2.PatientStatus).Pending ? "pending" : "registered",
            exerciseDetails.exerciseIds.join(";"),
            exerciseDetails.exerciseRevisions.join(";"),
            exerciseDetails.exerciseCategories.join(";"),
            exerciseDetails.exerciseBodyParts.join(";"),
            exerciseDetails.exerciseDifficulties.join(";"),
            exerciseDetails.exerciseStartingPosition.join(";")
        ]
    });
const $5fb05effebd8e096$export$b333618d08ca77d3 = (analyticsId, program, action)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "viewProgram",
        params: [
            analyticsId,
            program.id,
            program.status.toLowerCase(),
            action
        ]
    });
const $5fb05effebd8e096$export$9cb78434141771ab = ()=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "openMoodTooltip"
    });
const $5fb05effebd8e096$export$1bf5d571f8ed59b3 = ()=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "openExertionTooltip"
    });
const $5fb05effebd8e096$export$b3ae20aaba5edbb9 = (programId)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "duplicateProgramAsDraft",
        params: [
            programId
        ]
    });
const $5fb05effebd8e096$export$210dbd60dde2aaa6 = (programId)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "duplicateProgramAsTemplate",
        params: [
            programId
        ]
    });
const $5fb05effebd8e096$export$f0f7b887102269bd = ()=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "clearAll",
        params: []
    });
const $5fb05effebd8e096$export$47eb78b39a8ac99d = (value)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "endDateExtendedShortcut",
        params: [
            value
        ]
    });
const $5fb05effebd8e096$export$129a2af3068f09f = (value)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "endDateShortcut",
        params: [
            value
        ]
    });
const $5fb05effebd8e096$export$b516f0fc55a1fea9 = (guideStep)=>{
    const onboardingType = (0, $isRr9.extractOnboardingTypeFromStep)(guideStep);
    const stepsOrder = onboardingType === (0, $isRr9.OnboardingType).PROGRAM_QUICKSTART ? (0, $isRr9.onboardingProgramQuickstartSteps) : [];
    const currentStepIndex = stepsOrder.indexOf(guideStep);
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "viewGuide",
        params: [
            $5fb05effebd8e096$var$getAnalyticsLabel(onboardingType),
            currentStepIndex + 1
        ]
    });
};
const $5fb05effebd8e096$var$onboardingTypeLabels = {
    [(0, $isRr9.OnboardingType).GET_STARTED]: "getStarted",
    [(0, $isRr9.OnboardingType).PROGRAM_QUICKSTART]: "programQuickstart"
};
const $5fb05effebd8e096$var$getAnalyticsLabel = (guideType)=>$5fb05effebd8e096$var$onboardingTypeLabels[guideType];

});

parcelRegister("02Kb9", function(module, exports) {

$parcel$export(module.exports, "Tooltip", () => $cf62bd58b75beb3e$export$28c660c63b792dea);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $2cfUo = parcelRequire("2cfUo");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");

const $cf62bd58b75beb3e$export$28c660c63b792dea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $iKObn.jsx)($cf62bd58b75beb3e$var$StyledTippy, {
        ref: ref,
        ...props
    }));
$cf62bd58b75beb3e$export$28c660c63b792dea.displayName = "Tooltip";
const $cf62bd58b75beb3e$var$StyledTippy = (0, $5UMQ1.default)((0, $2cfUo.default))`
	padding: 8px;
	border-radius: 8px;
	background-color: ${(0, $kKnoQ.colors).black};

	.tippy-arrow {
		color: ${(0, $kKnoQ.colors).black};
	}
`;

});
parcelRegister("2cfUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $19990ae00005dcb5$export$2e2bcd8739ae039);

var $fNfkL = parcelRequire("fNfkL");

var $81g6h = parcelRequire("81g6h");

var $Q1dTY = parcelRequire("Q1dTY");
function $19990ae00005dcb5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $19990ae00005dcb5$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
function $19990ae00005dcb5$var$preserveRef(ref, node) {
    if (ref) {
        if (typeof ref === "function") ref(node);
        if (({}).hasOwnProperty.call(ref, "current")) ref.current = node;
    }
}
function $19990ae00005dcb5$var$ssrSafeCreateDiv() {
    return $19990ae00005dcb5$var$isBrowser && document.createElement("div");
}
function $19990ae00005dcb5$var$toDataAttributes(attrs) {
    var dataAttrs = {
        "data-placement": attrs.placement
    };
    if (attrs.referenceHidden) dataAttrs["data-reference-hidden"] = "";
    if (attrs.escaped) dataAttrs["data-escaped"] = "";
    return dataAttrs;
}
function $19990ae00005dcb5$var$deepEqual(x, y) {
    if (x === y) return true;
    else if (typeof x === "object" && x != null && typeof y === "object" && y != null) {
        if (Object.keys(x).length !== Object.keys(y).length) return false;
        for(var prop in x){
            if (y.hasOwnProperty(prop)) {
                if (!$19990ae00005dcb5$var$deepEqual(x[prop], y[prop])) return false;
            } else return false;
        }
        return true;
    } else return false;
}
function $19990ae00005dcb5$var$uniqueByShape(arr) {
    var output = [];
    arr.forEach(function(item) {
        if (!output.find(function(outputItem) {
            return $19990ae00005dcb5$var$deepEqual(item, outputItem);
        })) output.push(item);
    });
    return output;
}
function $19990ae00005dcb5$var$deepPreserveProps(instanceProps, componentProps) {
    var _instanceProps$popper, _componentProps$poppe;
    return Object.assign({}, componentProps, {
        popperOptions: Object.assign({}, instanceProps.popperOptions, componentProps.popperOptions, {
            modifiers: $19990ae00005dcb5$var$uniqueByShape([].concat(((_instanceProps$popper = instanceProps.popperOptions) == null ? void 0 : _instanceProps$popper.modifiers) || [], ((_componentProps$poppe = componentProps.popperOptions) == null ? void 0 : _componentProps$poppe.modifiers) || []))
        })
    });
}
var $19990ae00005dcb5$var$useIsomorphicLayoutEffect = $19990ae00005dcb5$var$isBrowser ? (0, $81g6h.useLayoutEffect) : (0, $81g6h.useEffect);
function $19990ae00005dcb5$var$useMutableBox(initialValue) {
    // Using refs instead of state as it's recommended to not store imperative
    // values in state due to memory problems in React(?)
    var ref = (0, $81g6h.useRef)();
    if (!ref.current) ref.current = typeof initialValue === "function" ? initialValue() : initialValue;
    return ref.current;
}
function $19990ae00005dcb5$var$updateClassName(box, action, classNames) {
    classNames.split(/\s+/).forEach(function(name) {
        if (name) box.classList[action](name);
    });
}
var $19990ae00005dcb5$var$classNamePlugin = {
    name: "className",
    defaultValue: "",
    fn: function fn(instance) {
        var box = instance.popper.firstElementChild;
        var isDefaultRenderFn = function isDefaultRenderFn() {
            var _instance$props$rende;
            return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
        };
        function add() {
            if (instance.props.className && !isDefaultRenderFn()) return;
            $19990ae00005dcb5$var$updateClassName(box, "add", instance.props.className);
        }
        function remove() {
            if (isDefaultRenderFn()) $19990ae00005dcb5$var$updateClassName(box, "remove", instance.props.className);
        }
        return {
            onCreate: add,
            onBeforeUpdate: remove,
            onAfterUpdate: add
        };
    }
};
function $19990ae00005dcb5$var$TippyGenerator(tippy) {
    function Tippy(_ref) {
        var children = _ref.children, content = _ref.content, visible = _ref.visible, singleton = _ref.singleton, render = _ref.render, reference = _ref.reference, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$ignoreAttributes = _ref.ignoreAttributes, ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes, __source = _ref.__source, __self = _ref.__self, restOfNativeProps = $19990ae00005dcb5$var$_objectWithoutPropertiesLoose(_ref, [
            "children",
            "content",
            "visible",
            "singleton",
            "render",
            "reference",
            "disabled",
            "ignoreAttributes",
            "__source",
            "__self"
        ]);
        var isControlledMode = visible !== undefined;
        var isSingletonMode = singleton !== undefined;
        var _useState = (0, $81g6h.useState)(false), mounted = _useState[0], setMounted = _useState[1];
        var _useState2 = (0, $81g6h.useState)({}), attrs = _useState2[0], setAttrs = _useState2[1];
        var _useState3 = (0, $81g6h.useState)(), singletonContent = _useState3[0], setSingletonContent = _useState3[1];
        var mutableBox = $19990ae00005dcb5$var$useMutableBox(function() {
            return {
                container: $19990ae00005dcb5$var$ssrSafeCreateDiv(),
                renders: 1
            };
        });
        var props = Object.assign({
            ignoreAttributes: ignoreAttributes
        }, restOfNativeProps, {
            content: mutableBox.container
        });
        if (isControlledMode) {
            props.trigger = "manual";
            props.hideOnClick = false;
        }
        if (isSingletonMode) disabled = true;
        var computedProps = props;
        var plugins = props.plugins || [];
        if (render) computedProps = Object.assign({}, props, {
            plugins: isSingletonMode && singleton.data != null ? [].concat(plugins, [
                {
                    fn: function fn() {
                        return {
                            onTrigger: function onTrigger(instance, event) {
                                var node = singleton.data.children.find(function(_ref2) {
                                    var instance = _ref2.instance;
                                    return instance.reference === event.currentTarget;
                                });
                                instance.state.$$activeSingletonInstance = node.instance;
                                setSingletonContent(node.content);
                            }
                        };
                    }
                }
            ]) : plugins,
            render: function render() {
                return {
                    popper: mutableBox.container
                };
            }
        });
        var deps = [
            reference
        ].concat(children ? [
            children.type
        ] : []); // CREATE
        $19990ae00005dcb5$var$useIsomorphicLayoutEffect(function() {
            var element = reference;
            if (reference && reference.hasOwnProperty("current")) element = reference.current;
            var instance = tippy(element || mutableBox.ref || $19990ae00005dcb5$var$ssrSafeCreateDiv(), Object.assign({}, computedProps, {
                plugins: [
                    $19990ae00005dcb5$var$classNamePlugin
                ].concat(props.plugins || [])
            }));
            mutableBox.instance = instance;
            if (disabled) instance.disable();
            if (visible) instance.show();
            if (isSingletonMode) singleton.hook({
                instance: instance,
                content: content,
                props: computedProps,
                setSingletonContent: setSingletonContent
            });
            setMounted(true);
            return function() {
                instance.destroy();
                singleton == null || singleton.cleanup(instance);
            };
        }, deps); // UPDATE
        $19990ae00005dcb5$var$useIsomorphicLayoutEffect(function() {
            var _instance$popperInsta;
            // Prevent this effect from running on 1st render
            if (mutableBox.renders === 1) {
                mutableBox.renders++;
                return;
            }
            var instance = mutableBox.instance;
            instance.setProps($19990ae00005dcb5$var$deepPreserveProps(instance.props, computedProps)); // Fixes #264
            (_instance$popperInsta = instance.popperInstance) == null || _instance$popperInsta.forceUpdate();
            if (disabled) instance.disable();
            else instance.enable();
            if (isControlledMode) {
                if (visible) instance.show();
                else instance.hide();
            }
            if (isSingletonMode) singleton.hook({
                instance: instance,
                content: content,
                props: computedProps,
                setSingletonContent: setSingletonContent
            });
        });
        $19990ae00005dcb5$var$useIsomorphicLayoutEffect(function() {
            var _instance$props$poppe;
            if (!render) return;
            var instance = mutableBox.instance;
            instance.setProps({
                popperOptions: Object.assign({}, instance.props.popperOptions, {
                    modifiers: [].concat((((_instance$props$poppe = instance.props.popperOptions) == null ? void 0 : _instance$props$poppe.modifiers) || []).filter(function(_ref3) {
                        var name = _ref3.name;
                        return name !== "$$tippyReact";
                    }), [
                        {
                            name: "$$tippyReact",
                            enabled: true,
                            phase: "beforeWrite",
                            requires: [
                                "computeStyles"
                            ],
                            fn: function fn(_ref4) {
                                var _state$modifiersData;
                                var state = _ref4.state;
                                var hideData = (_state$modifiersData = state.modifiersData) == null ? void 0 : _state$modifiersData.hide; // WARNING: this is a high-risk path that can cause an infinite
                                // loop. This expression _must_ evaluate to false when required
                                if (attrs.placement !== state.placement || attrs.referenceHidden !== (hideData == null ? void 0 : hideData.isReferenceHidden) || attrs.escaped !== (hideData == null ? void 0 : hideData.hasPopperEscaped)) setAttrs({
                                    placement: state.placement,
                                    referenceHidden: hideData == null ? void 0 : hideData.isReferenceHidden,
                                    escaped: hideData == null ? void 0 : hideData.hasPopperEscaped
                                });
                                state.attributes.popper = {};
                            }
                        }
                    ])
                })
            });
        }, [
            attrs.placement,
            attrs.referenceHidden,
            attrs.escaped
        ].concat(deps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).Fragment, null, children ? /*#__PURE__*/ (0, $81g6h.cloneElement)(children, {
            ref: function ref(node) {
                mutableBox.ref = node;
                $19990ae00005dcb5$var$preserveRef(children.ref, node);
            }
        }) : null, mounted && /*#__PURE__*/ (0, $Q1dTY.createPortal)(render ? render($19990ae00005dcb5$var$toDataAttributes(attrs), singletonContent, mutableBox.instance) : content, mutableBox.container));
    }
    return Tippy;
}
function $19990ae00005dcb5$var$useSingletonGenerator(createSingleton) {
    return function useSingleton(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$overrides = _ref.overrides, overrides = _ref$overrides === void 0 ? [] : _ref$overrides;
        var _useState = (0, $81g6h.useState)(false), mounted = _useState[0], setMounted = _useState[1];
        var mutableBox = $19990ae00005dcb5$var$useMutableBox({
            children: [],
            renders: 1
        });
        $19990ae00005dcb5$var$useIsomorphicLayoutEffect(function() {
            if (!mounted) {
                setMounted(true);
                return;
            }
            var children = mutableBox.children, sourceData = mutableBox.sourceData;
            if (!sourceData) return;
            var instance = createSingleton(children.map(function(child) {
                return child.instance;
            }), Object.assign({}, sourceData.props, {
                popperOptions: sourceData.instance.props.popperOptions,
                overrides: overrides,
                plugins: [
                    $19990ae00005dcb5$var$classNamePlugin
                ].concat(sourceData.props.plugins || [])
            }));
            mutableBox.instance = instance;
            if (disabled) instance.disable();
            return function() {
                instance.destroy();
                mutableBox.children = children.filter(function(_ref2) {
                    var instance = _ref2.instance;
                    return !instance.state.isDestroyed;
                });
            };
        }, [
            mounted
        ]);
        $19990ae00005dcb5$var$useIsomorphicLayoutEffect(function() {
            if (!mounted) return;
            if (mutableBox.renders === 1) {
                mutableBox.renders++;
                return;
            }
            var children = mutableBox.children, instance = mutableBox.instance, sourceData = mutableBox.sourceData;
            if (!(instance && sourceData)) return;
            var _sourceData$props = sourceData.props, content = _sourceData$props.content, props = $19990ae00005dcb5$var$_objectWithoutPropertiesLoose(_sourceData$props, [
                "content"
            ]);
            instance.setProps($19990ae00005dcb5$var$deepPreserveProps(instance.props, Object.assign({}, props, {
                overrides: overrides
            })));
            instance.setInstances(children.map(function(child) {
                return child.instance;
            }));
            if (disabled) instance.disable();
            else instance.enable();
        });
        return (0, $81g6h.useMemo)(function() {
            var source = {
                data: mutableBox,
                hook: function hook(data) {
                    mutableBox.sourceData = data;
                    mutableBox.setSingletonContent = data.setSingletonContent;
                },
                cleanup: function cleanup() {
                    mutableBox.sourceData = null;
                }
            };
            var target = {
                hook: function hook(data) {
                    var _mutableBox$instance, _mutableBox$instance2;
                    mutableBox.children = mutableBox.children.filter(function(_ref3) {
                        var instance = _ref3.instance;
                        return data.instance !== instance;
                    });
                    mutableBox.children.push(data);
                    if (((_mutableBox$instance = mutableBox.instance) == null ? void 0 : _mutableBox$instance.state.isMounted) && ((_mutableBox$instance2 = mutableBox.instance) == null ? void 0 : _mutableBox$instance2.state.$$activeSingletonInstance) === data.instance) mutableBox.setSingletonContent == null || mutableBox.setSingletonContent(data.content);
                    if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) mutableBox.instance.setInstances(mutableBox.children.map(function(child) {
                        return child.instance;
                    }));
                },
                cleanup: function cleanup(instance) {
                    mutableBox.children = mutableBox.children.filter(function(data) {
                        return data.instance !== instance;
                    });
                    if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) mutableBox.instance.setInstances(mutableBox.children.map(function(child) {
                        return child.instance;
                    }));
                }
            };
            return [
                source,
                target
            ];
        }, []);
    };
}
var $19990ae00005dcb5$var$forwardRef = function(Tippy, defaultProps) {
    return /*#__PURE__*/ (0, $81g6h.forwardRef)(function TippyWrapper(_ref, _ref2) {
        var children = _ref.children, props = $19990ae00005dcb5$var$_objectWithoutPropertiesLoose(_ref, [
            "children"
        ]);
        return(/*#__PURE__*/ // If I spread them separately here, Babel adds the _extends ponyfill for
        // some reason
        (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement(Tippy, Object.assign({}, defaultProps, props), children ? /*#__PURE__*/ (0, $81g6h.cloneElement)(children, {
            ref: function ref(node) {
                $19990ae00005dcb5$var$preserveRef(_ref2, node);
                $19990ae00005dcb5$var$preserveRef(children.ref, node);
            }
        }) : null));
    });
};
var $19990ae00005dcb5$export$abf4268d2dd55708 = /*#__PURE__*/ $19990ae00005dcb5$var$useSingletonGenerator((0, $fNfkL.createSingleton));
var $19990ae00005dcb5$var$index = /*#__PURE__*/ $19990ae00005dcb5$var$forwardRef(/*#__PURE__*/ $19990ae00005dcb5$var$TippyGenerator((0, $fNfkL.default)));
var $19990ae00005dcb5$export$2e2bcd8739ae039 = $19990ae00005dcb5$var$index;

});
parcelRegister("fNfkL", function(module, exports) {

$parcel$export(module.exports, "createSingleton", () => $b7f7539736fbdcdd$export$374c483667c1ea9b);
$parcel$export(module.exports, "default", () => $b7f7539736fbdcdd$export$2e2bcd8739ae039);
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ 
var $aAfJ1 = parcelRequire("aAfJ1");
var $ls7YH = parcelRequire("ls7YH");
var $b7f7539736fbdcdd$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $b7f7539736fbdcdd$var$BOX_CLASS = "tippy-box";
var $b7f7539736fbdcdd$var$CONTENT_CLASS = "tippy-content";
var $b7f7539736fbdcdd$var$BACKDROP_CLASS = "tippy-backdrop";
var $b7f7539736fbdcdd$var$ARROW_CLASS = "tippy-arrow";
var $b7f7539736fbdcdd$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $b7f7539736fbdcdd$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $b7f7539736fbdcdd$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $b7f7539736fbdcdd$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $b7f7539736fbdcdd$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $b7f7539736fbdcdd$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf("[object") === 0 && str.indexOf(type + "]") > -1;
}
function $b7f7539736fbdcdd$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === "function" ? value.apply(void 0, args) : value;
}
function $b7f7539736fbdcdd$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $b7f7539736fbdcdd$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $b7f7539736fbdcdd$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $b7f7539736fbdcdd$var$normalizeToArray(value) {
    return [].concat(value);
}
function $b7f7539736fbdcdd$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $b7f7539736fbdcdd$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $b7f7539736fbdcdd$var$getBasePlacement(placement) {
    return placement.split("-")[0];
}
function $b7f7539736fbdcdd$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $b7f7539736fbdcdd$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $b7f7539736fbdcdd$var$div() {
    return document.createElement("div");
}
function $b7f7539736fbdcdd$var$isElement(value) {
    return [
        "Element",
        "Fragment"
    ].some(function(type) {
        return $b7f7539736fbdcdd$var$isType(value, type);
    });
}
function $b7f7539736fbdcdd$var$isNodeList(value) {
    return $b7f7539736fbdcdd$var$isType(value, "NodeList");
}
function $b7f7539736fbdcdd$var$isMouseEvent(value) {
    return $b7f7539736fbdcdd$var$isType(value, "MouseEvent");
}
function $b7f7539736fbdcdd$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $b7f7539736fbdcdd$var$getArrayOfElements(value) {
    if ($b7f7539736fbdcdd$var$isElement(value)) return [
        value
    ];
    if ($b7f7539736fbdcdd$var$isNodeList(value)) return $b7f7539736fbdcdd$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $b7f7539736fbdcdd$var$arrayFrom(document.querySelectorAll(value));
}
function $b7f7539736fbdcdd$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $b7f7539736fbdcdd$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute("data-state", state);
    });
}
function $b7f7539736fbdcdd$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $b7f7539736fbdcdd$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $b7f7539736fbdcdd$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $b7f7539736fbdcdd$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === "top" ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === "right" ? offsetData.left.x : 0;
        var rightDistance = basePlacement === "left" ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $b7f7539736fbdcdd$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        "transitionend",
        "webkitTransitionEnd"
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $b7f7539736fbdcdd$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $b7f7539736fbdcdd$var$currentInput = {
    isTouch: false
};
var $b7f7539736fbdcdd$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $b7f7539736fbdcdd$var$onDocumentTouchStart() {
    if ($b7f7539736fbdcdd$var$currentInput.isTouch) return;
    $b7f7539736fbdcdd$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener("mousemove", $b7f7539736fbdcdd$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $b7f7539736fbdcdd$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $b7f7539736fbdcdd$var$lastMouseMoveTime < 20) {
        $b7f7539736fbdcdd$var$currentInput.isTouch = false;
        document.removeEventListener("mousemove", $b7f7539736fbdcdd$var$onDocumentMouseMove);
    }
    $b7f7539736fbdcdd$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $b7f7539736fbdcdd$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($b7f7539736fbdcdd$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $b7f7539736fbdcdd$var$bindGlobalEventListeners() {
    document.addEventListener("touchstart", $b7f7539736fbdcdd$var$onDocumentTouchStart, $b7f7539736fbdcdd$var$TOUCH_OPTIONS);
    window.addEventListener("blur", $b7f7539736fbdcdd$var$onWindowBlur);
}
var $b7f7539736fbdcdd$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var $b7f7539736fbdcdd$var$isIE11 = $b7f7539736fbdcdd$var$isBrowser ? !!window.msCrypto : false;
function $b7f7539736fbdcdd$var$createMemoryLeakWarning(method) {
    var txt = method === "destroy" ? "n already-" : " ";
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        "indicates a potential memory leak."
    ].join(" ");
}
function $b7f7539736fbdcdd$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, " ").replace(lineStartWithSpaces, "").trim();
}
function $b7f7539736fbdcdd$var$getDevMessage(message) {
    return $b7f7539736fbdcdd$var$clean("\n  %ctippy.js\n\n  %c" + $b7f7539736fbdcdd$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $b7f7539736fbdcdd$var$getFormattedMessage(message) {
    return [
        $b7f7539736fbdcdd$var$getDevMessage(message),
        "color: #00C584; font-size: 1.3em; font-weight: bold;",
        "line-height: 1.5",
        "color: #a6a095;"
    ];
} // Assume warnings and errors never have the same message
var $b7f7539736fbdcdd$var$visitedMessages;
function $b7f7539736fbdcdd$var$resetVisitedMessages() {
    $b7f7539736fbdcdd$var$visitedMessages = new Set();
}
function $b7f7539736fbdcdd$var$warnWhen(condition, message) {
    if (condition && !$b7f7539736fbdcdd$var$visitedMessages.has(message)) {
        var _console;
        $b7f7539736fbdcdd$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $b7f7539736fbdcdd$var$getFormattedMessage(message));
    }
}
function $b7f7539736fbdcdd$var$errorWhen(condition, message) {
    if (condition && !$b7f7539736fbdcdd$var$visitedMessages.has(message)) {
        var _console2;
        $b7f7539736fbdcdd$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $b7f7539736fbdcdd$var$getFormattedMessage(message));
    }
}
function $b7f7539736fbdcdd$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === "[object Object]" && !targets.addEventListener;
    $b7f7539736fbdcdd$var$errorWhen(didPassFalsyValue, [
        "tippy() was passed",
        "`" + String(targets) + "`",
        "as its targets (first) argument. Valid types are: String, Element,",
        "Element[], or NodeList."
    ].join(" "));
    $b7f7539736fbdcdd$var$errorWhen(didPassPlainObject, [
        "tippy() was passed a plain object which is not supported as an argument",
        "for virtual positioning. Use props.getReferenceClientRect instead."
    ].join(" "));
}
var $b7f7539736fbdcdd$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $b7f7539736fbdcdd$var$renderProps = {
    allowHTML: false,
    animation: "fade",
    arrow: true,
    content: "",
    inertia: false,
    maxWidth: 350,
    role: "tooltip",
    theme: "",
    zIndex: 9999
};
var $b7f7539736fbdcdd$var$defaultProps = Object.assign({
    appendTo: $b7f7539736fbdcdd$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: "auto",
        expanded: "auto"
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: "",
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: "top",
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: "mouseenter focus",
    triggerTarget: null
}, $b7f7539736fbdcdd$var$pluginProps, $b7f7539736fbdcdd$var$renderProps);
var $b7f7539736fbdcdd$var$defaultKeys = Object.keys($b7f7539736fbdcdd$var$defaultProps);
var $b7f7539736fbdcdd$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $b7f7539736fbdcdd$var$defaultProps[key] = partialProps[key];
    });
};
function $b7f7539736fbdcdd$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $b7f7539736fbdcdd$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $b7f7539736fbdcdd$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($b7f7539736fbdcdd$var$getExtendedPassedProps(Object.assign({}, $b7f7539736fbdcdd$var$defaultProps, {
        plugins: plugins
    }))) : $b7f7539736fbdcdd$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || "").trim();
        if (!valueAsString) return acc;
        if (key === "content") acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $b7f7539736fbdcdd$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $b7f7539736fbdcdd$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $b7f7539736fbdcdd$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $b7f7539736fbdcdd$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === "auto" ? props.interactive : out.aria.expanded,
        content: out.aria.content === "auto" ? props.interactive ? null : "describedby" : out.aria.content
    };
    return out;
}
function $b7f7539736fbdcdd$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $b7f7539736fbdcdd$var$removeProperties($b7f7539736fbdcdd$var$defaultProps, Object.keys($b7f7539736fbdcdd$var$pluginProps));
        var didPassUnknownProp = !$b7f7539736fbdcdd$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $b7f7539736fbdcdd$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            "a plugin, forgot to pass it in an array as props.plugins.",
            "\n\n",
            "All props: https://atomiks.github.io/tippyjs/v6/all-props/\n",
            "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"
        ].join(" "));
    });
}
var $b7f7539736fbdcdd$var$innerHTML = function innerHTML() {
    return "innerHTML";
};
function $b7f7539736fbdcdd$var$dangerouslySetInnerHTML(element, html) {
    element[$b7f7539736fbdcdd$var$innerHTML()] = html;
}
function $b7f7539736fbdcdd$var$createArrowElement(value) {
    var arrow = $b7f7539736fbdcdd$var$div();
    if (value === true) arrow.className = $b7f7539736fbdcdd$var$ARROW_CLASS;
    else {
        arrow.className = $b7f7539736fbdcdd$var$SVG_ARROW_CLASS;
        if ($b7f7539736fbdcdd$var$isElement(value)) arrow.appendChild(value);
        else $b7f7539736fbdcdd$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $b7f7539736fbdcdd$var$setContent(content, props) {
    if ($b7f7539736fbdcdd$var$isElement(props.content)) {
        $b7f7539736fbdcdd$var$dangerouslySetInnerHTML(content, "");
        content.appendChild(props.content);
    } else if (typeof props.content !== "function") {
        if (props.allowHTML) $b7f7539736fbdcdd$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $b7f7539736fbdcdd$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $b7f7539736fbdcdd$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($b7f7539736fbdcdd$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($b7f7539736fbdcdd$var$ARROW_CLASS) || node.classList.contains($b7f7539736fbdcdd$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($b7f7539736fbdcdd$var$BACKDROP_CLASS);
        })
    };
}
function $b7f7539736fbdcdd$var$render(instance) {
    var popper = $b7f7539736fbdcdd$var$div();
    var box = $b7f7539736fbdcdd$var$div();
    box.className = $b7f7539736fbdcdd$var$BOX_CLASS;
    box.setAttribute("data-state", "hidden");
    box.setAttribute("tabindex", "-1");
    var content = $b7f7539736fbdcdd$var$div();
    content.className = $b7f7539736fbdcdd$var$CONTENT_CLASS;
    content.setAttribute("data-state", "hidden");
    $b7f7539736fbdcdd$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $b7f7539736fbdcdd$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute("data-theme", nextProps.theme);
        else box.removeAttribute("data-theme");
        if (typeof nextProps.animation === "string") box.setAttribute("data-animation", nextProps.animation);
        else box.removeAttribute("data-animation");
        if (nextProps.inertia) box.setAttribute("data-inertia", "");
        else box.removeAttribute("data-inertia");
        box.style.maxWidth = typeof nextProps.maxWidth === "number" ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute("role", nextProps.role);
        else box.removeAttribute("role");
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $b7f7539736fbdcdd$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($b7f7539736fbdcdd$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($b7f7539736fbdcdd$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$b7f7539736fbdcdd$var$render.$$tippy = true;
var $b7f7539736fbdcdd$var$idCounter = 1;
var $b7f7539736fbdcdd$var$mouseMoveListeners = []; // Used by `hideAll()`
var $b7f7539736fbdcdd$var$mountedInstances = [];
function $b7f7539736fbdcdd$var$createTippy(reference, passedProps) {
    var props = $b7f7539736fbdcdd$var$evaluateProps(reference, Object.assign({}, $b7f7539736fbdcdd$var$defaultProps, $b7f7539736fbdcdd$var$getExtendedPassedProps($b7f7539736fbdcdd$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $b7f7539736fbdcdd$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $b7f7539736fbdcdd$var$idCounter++;
    var popperInstance = null;
    var plugins = $b7f7539736fbdcdd$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $b7f7539736fbdcdd$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute("data-tippy-root", "");
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute("aria-expanded");
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook("onCreate", [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener("mouseenter", function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener("mouseleave", function() {
        if (instance.props.interactive && instance.props.trigger.indexOf("mouseenter") >= 0) getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === "hold";
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $b7f7539736fbdcdd$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $b7f7539736fbdcdd$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $b7f7539736fbdcdd$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === "focus") return 0;
        return $b7f7539736fbdcdd$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $b7f7539736fbdcdd$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? "" : "none";
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $b7f7539736fbdcdd$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, "").trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $b7f7539736fbdcdd$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute("aria-expanded", instance.state.isVisible && node === getCurrentTarget() ? "true" : "false");
            else node.removeAttribute("aria-expanded");
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener("mousemove", debouncedOnMouseMove);
        $b7f7539736fbdcdd$var$mouseMoveListeners = $b7f7539736fbdcdd$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($b7f7539736fbdcdd$var$currentInput.isTouch) {
            if (didTouchMove || event.type === "mousedown") return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $b7f7539736fbdcdd$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($b7f7539736fbdcdd$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $b7f7539736fbdcdd$var$actualContains(el, actualTarget);
        })) {
            if ($b7f7539736fbdcdd$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf("click") >= 0) return;
        } else invokeHook("onClickOutside", [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener("mousedown", onDocumentPress, true);
        doc.addEventListener("touchend", onDocumentPress, $b7f7539736fbdcdd$var$TOUCH_OPTIONS);
        doc.addEventListener("touchstart", onTouchStart, $b7f7539736fbdcdd$var$TOUCH_OPTIONS);
        doc.addEventListener("touchmove", onTouchMove, $b7f7539736fbdcdd$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener("mousedown", onDocumentPress, true);
        doc.removeEventListener("touchend", onDocumentPress, $b7f7539736fbdcdd$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchstart", onTouchStart, $b7f7539736fbdcdd$var$TOUCH_OPTIONS);
        doc.removeEventListener("touchmove", onTouchMove, $b7f7539736fbdcdd$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $b7f7539736fbdcdd$var$updateTransitionEndListener(box, "remove", listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $b7f7539736fbdcdd$var$updateTransitionEndListener(box, "remove", currentTransitionEndListener);
        $b7f7539736fbdcdd$var$updateTransitionEndListener(box, "add", listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $b7f7539736fbdcdd$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on("touchstart", onTrigger, {
                passive: true
            });
            on("touchend", onMouseLeave, {
                passive: true
            });
        }
        $b7f7539736fbdcdd$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === "manual") return;
            on(eventType, onTrigger);
            switch(eventType){
                case "mouseenter":
                    on("mouseleave", onMouseLeave);
                    break;
                case "focus":
                    on($b7f7539736fbdcdd$var$isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
                    break;
                case "focusin":
                    on("focusout", onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === "focus";
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $b7f7539736fbdcdd$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $b7f7539736fbdcdd$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === "click" && (instance.props.trigger.indexOf("mouseenter") < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === "click") isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === "mousemove" && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($b7f7539736fbdcdd$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf("click") >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf("focusin") < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $b7f7539736fbdcdd$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $b7f7539736fbdcdd$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: "$$tippy",
            enabled: true,
            phase: "beforeWrite",
            requires: [
                "computeStyles"
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        "placement",
                        "reference-hidden",
                        "escaped"
                    ].forEach(function(attr) {
                        if (attr === "placement") box.setAttribute("data-placement", state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, "");
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: "flip",
                options: {
                    padding: 5
                }
            },
            {
                name: "computeStyles",
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: "arrow",
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $ls7YH.createPopper)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $b7f7539736fbdcdd$var$TIPPY_DEFAULT_APPEND_TO || appendTo === "parent") parentNode = node.parentNode;
        else parentNode = $b7f7539736fbdcdd$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $b7f7539736fbdcdd$var$arrayFrom(popper.querySelectorAll("[data-tippy-root]"));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook("onTrigger", [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($b7f7539736fbdcdd$var$currentInput.isTouch && touchValue === "hold" && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook("onUntrigger", [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf("mouseenter") >= 0 && instance.props.trigger.indexOf("click") >= 0 && [
            "mouseleave",
            "mousemove"
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook("onBeforeUpdate", [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $b7f7539736fbdcdd$var$evaluateProps(reference, Object.assign({}, prevProps, $b7f7539736fbdcdd$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $b7f7539736fbdcdd$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $b7f7539736fbdcdd$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute("aria-expanded");
        });
        else if (nextProps.triggerTarget) reference.removeAttribute("aria-expanded");
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook("onAfterUpdate", [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $b7f7539736fbdcdd$var$currentInput.isTouch && !instance.props.touch;
        var duration = $b7f7539736fbdcdd$var$getValueAtIndexOrReturn(instance.props.duration, 0, $b7f7539736fbdcdd$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute("disabled")) return;
        invokeHook("onShow", [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = "visible";
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = "none";
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $b7f7539736fbdcdd$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $b7f7539736fbdcdd$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $b7f7539736fbdcdd$var$setVisibilityState([
                    _box,
                    _content
                ], "visible");
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $b7f7539736fbdcdd$var$pushIfUnique($b7f7539736fbdcdd$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook("onMount", [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook("onShown", [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $b7f7539736fbdcdd$var$getValueAtIndexOrReturn(instance.props.duration, 1, $b7f7539736fbdcdd$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook("onHide", [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = "hidden";
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $b7f7539736fbdcdd$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $b7f7539736fbdcdd$var$setVisibilityState([
                    box,
                    content
                ], "hidden");
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener("mousemove", debouncedOnMouseMove);
        $b7f7539736fbdcdd$var$pushIfUnique($b7f7539736fbdcdd$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $b7f7539736fbdcdd$var$mountedInstances = $b7f7539736fbdcdd$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook("onHidden", [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook("onDestroy", [
            instance
        ]);
    }
}
function $b7f7539736fbdcdd$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $b7f7539736fbdcdd$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $b7f7539736fbdcdd$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $b7f7539736fbdcdd$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $b7f7539736fbdcdd$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $b7f7539736fbdcdd$var$isElement(targets) ? instances[0] : instances;
}
$b7f7539736fbdcdd$var$tippy.defaultProps = $b7f7539736fbdcdd$var$defaultProps;
$b7f7539736fbdcdd$var$tippy.setDefaultProps = $b7f7539736fbdcdd$var$setDefaultProps;
$b7f7539736fbdcdd$var$tippy.currentInput = $b7f7539736fbdcdd$var$currentInput;
var $b7f7539736fbdcdd$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $b7f7539736fbdcdd$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $b7f7539736fbdcdd$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $b7f7539736fbdcdd$var$applyStylesModifier = Object.assign({}, (0, $aAfJ1.default), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: "0",
                top: "0",
                margin: "0"
            },
            arrow: {
                position: "absolute"
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $b7f7539736fbdcdd$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $b7f7539736fbdcdd$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat("content").reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === "function" ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $b7f7539736fbdcdd$var$tippy($b7f7539736fbdcdd$var$div(), Object.assign({}, $b7f7539736fbdcdd$var$removeProperties(optionalProps, [
        "overrides"
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $b7f7539736fbdcdd$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === "number") return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $b7f7539736fbdcdd$var$BUBBLING_EVENTS_MAP = {
    mouseover: "mouseenter",
    focusin: "focus",
    click: "click"
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $b7f7539736fbdcdd$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $b7f7539736fbdcdd$var$removeProperties(props, [
        "target"
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: "manual",
        touch: false
    });
    var childProps = Object.assign({
        touch: $b7f7539736fbdcdd$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $b7f7539736fbdcdd$var$tippy(targets, parentProps);
    var normalizedReturnValue = $b7f7539736fbdcdd$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute("data-tippy-trigger") || props.trigger || $b7f7539736fbdcdd$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === "touchstart" && typeof childProps.touch === "boolean") return;
        if (event.type !== "touchstart" && trigger.indexOf($b7f7539736fbdcdd$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $b7f7539736fbdcdd$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, "touchstart", onTrigger, $b7f7539736fbdcdd$var$TOUCH_OPTIONS);
        on(reference, "mouseover", onTrigger);
        on(reference, "focusin", onTrigger);
        on(reference, "click", onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $b7f7539736fbdcdd$export$dd8ded329c01db79 = {
    name: "animateFill",
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $b7f7539736fbdcdd$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $b7f7539736fbdcdd$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute("data-animatefill", "");
                    box.style.overflow = "hidden";
                    instance.setProps({
                        arrow: false,
                        animation: "shift-away"
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace("ms", "")); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $b7f7539736fbdcdd$var$setVisibilityState([
                        backdrop
                    ], "visible");
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = "0ms";
            },
            onHide: function onHide() {
                if (backdrop) $b7f7539736fbdcdd$var$setVisibilityState([
                    backdrop
                ], "hidden");
            }
        };
    }
};
function $b7f7539736fbdcdd$var$createBackdropElement() {
    var backdrop = $b7f7539736fbdcdd$var$div();
    backdrop.className = $b7f7539736fbdcdd$var$BACKDROP_CLASS;
    $b7f7539736fbdcdd$var$setVisibilityState([
        backdrop
    ], "hidden");
    return backdrop;
}
var $b7f7539736fbdcdd$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $b7f7539736fbdcdd$var$activeInstances = [];
function $b7f7539736fbdcdd$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $b7f7539736fbdcdd$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $b7f7539736fbdcdd$var$addMouseCoordsListener(doc) {
    doc.addEventListener("mousemove", $b7f7539736fbdcdd$var$storeMouseCoords);
}
function $b7f7539736fbdcdd$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener("mousemove", $b7f7539736fbdcdd$var$storeMouseCoords);
}
var $b7f7539736fbdcdd$export$ac81526b64504ab6 = {
    name: "followCursor",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $b7f7539736fbdcdd$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === "initial" && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener("mousemove", onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener("mousemove", onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === "initial") {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === "horizontal" ? rect.top : y;
                    var right = followCursor === "vertical" ? rect.right : x;
                    var bottom = followCursor === "horizontal" ? rect.bottom : y;
                    var left = followCursor === "vertical" ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $b7f7539736fbdcdd$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $b7f7539736fbdcdd$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $b7f7539736fbdcdd$var$activeInstances = $b7f7539736fbdcdd$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($b7f7539736fbdcdd$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $b7f7539736fbdcdd$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($b7f7539736fbdcdd$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($b7f7539736fbdcdd$var$isMouseEvent(event)) $b7f7539736fbdcdd$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === "focus";
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $b7f7539736fbdcdd$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $b7f7539736fbdcdd$export$e2b668424a9c728 = {
    name: "inlinePositioning",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: "tippyInlinePositioning",
            enabled: true,
            phase: "afterWrite",
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $b7f7539736fbdcdd$var$getInlineBoundingClientRect($b7f7539736fbdcdd$var$getBasePlacement(placement), reference.getBoundingClientRect(), $b7f7539736fbdcdd$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($b7f7539736fbdcdd$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($b7f7539736fbdcdd$var$isMouseEvent(event)) {
                    var rects = $b7f7539736fbdcdd$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $b7f7539736fbdcdd$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case "top":
        case "bottom":
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === "top";
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case "left":
        case "right":
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === "left" ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $b7f7539736fbdcdd$export$4bd4b47501432316 = {
    name: "sticky",
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck("reference") ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck("popper") ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $b7f7539736fbdcdd$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $b7f7539736fbdcdd$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $b7f7539736fbdcdd$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$b7f7539736fbdcdd$var$tippy.setDefaultProps({
    render: $b7f7539736fbdcdd$var$render
});
var $b7f7539736fbdcdd$export$2e2bcd8739ae039 = $b7f7539736fbdcdd$var$tippy;

});
parcelRegister("aAfJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b4976da59b83042$export$2e2bcd8739ae039);

var $jwJki = parcelRequire("jwJki");

var $ivibo = parcelRequire("ivibo");
// and applies them to the HTMLElements such as popper and arrow
function $7b4976da59b83042$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $ivibo.isHTMLElement)(element) || !(0, $jwJki.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7b4976da59b83042$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $ivibo.isHTMLElement)(element) || !(0, $jwJki.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7b4976da59b83042$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7b4976da59b83042$var$applyStyles,
    effect: $7b4976da59b83042$var$effect,
    requires: [
        "computeStyles"
    ]
};

});
parcelRegister("jwJki", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3742a5cc7b39134$export$2e2bcd8739ae039);
function $e3742a5cc7b39134$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("ivibo", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $d78939f3a8cbed56$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $d78939f3a8cbed56$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $d78939f3a8cbed56$export$af51f0f06c0f328a);

var $eo0rj = parcelRequire("eo0rj");
function $d78939f3a8cbed56$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $eo0rj.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d78939f3a8cbed56$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $eo0rj.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d78939f3a8cbed56$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $eo0rj.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("eo0rj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a793a5da78d1684d$export$2e2bcd8739ae039);
function $a793a5da78d1684d$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("ls7YH", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $f9e266c62f82b781$export$8f7491d57c8f97a9);

var $bSr4D = parcelRequire("bSr4D");

var $6CCNt = parcelRequire("6CCNt");

var $eH1bw = parcelRequire("eH1bw");

var $8ThEi = parcelRequire("8ThEi");

var $aAfJ1 = parcelRequire("aAfJ1");

var $eQrYL = parcelRequire("eQrYL");

var $1RcMs = parcelRequire("1RcMs");

var $6q4rp = parcelRequire("6q4rp");

var $8FXxC = parcelRequire("8FXxC");

var $l1HpG = parcelRequire("l1HpG");


var $f9e266c62f82b781$export$d34966752335dd47 = [
    (0, $6CCNt.default),
    (0, $eH1bw.default),
    (0, $8ThEi.default),
    (0, $aAfJ1.default),
    (0, $eQrYL.default),
    (0, $1RcMs.default),
    (0, $6q4rp.default),
    (0, $8FXxC.default),
    (0, $l1HpG.default)
];
var $f9e266c62f82b781$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $bSr4D.popperGenerator)({
    defaultModifiers: $f9e266c62f82b781$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("bSr4D", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $8a59bd20c87d1ac9$export$ed5e13716264f202);

var $du0VC = parcelRequire("du0VC");

var $eKM07 = parcelRequire("eKM07");

var $2j92Y = parcelRequire("2j92Y");

var $6uo2j = parcelRequire("6uo2j");

var $9O8kg = parcelRequire("9O8kg");

var $auZgh = parcelRequire("auZgh");

var $e8ggD = parcelRequire("e8ggD");


var $ivibo = parcelRequire("ivibo");
var $8a59bd20c87d1ac9$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $8a59bd20c87d1ac9$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $8a59bd20c87d1ac9$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $8a59bd20c87d1ac9$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $8a59bd20c87d1ac9$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $ivibo.isElement)(reference) ? (0, $2j92Y.default)(reference) : reference.contextElement ? (0, $2j92Y.default)(reference.contextElement) : [],
                    popper: (0, $2j92Y.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $9O8kg.default)((0, $e8ggD.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$8a59bd20c87d1ac9$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $du0VC.default)(reference, (0, $6uo2j.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $eKM07.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $auZgh.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$8a59bd20c87d1ac9$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $8a59bd20c87d1ac9$export$8f7491d57c8f97a9 = /*#__PURE__*/ $8a59bd20c87d1ac9$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("du0VC", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d0ecc0ce6582db9$export$2e2bcd8739ae039);

var $cqNBE = parcelRequire("cqNBE");

var $hBNBF = parcelRequire("hBNBF");

var $jwJki = parcelRequire("jwJki");

var $ivibo = parcelRequire("ivibo");

var $8yKMq = parcelRequire("8yKMq");

var $quZ7I = parcelRequire("quZ7I");

var $8lMHT = parcelRequire("8lMHT");

var $7KMOf = parcelRequire("7KMOf");
function $9d0ecc0ce6582db9$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $7KMOf.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $7KMOf.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $9d0ecc0ce6582db9$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $ivibo.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $ivibo.isHTMLElement)(offsetParent) && $9d0ecc0ce6582db9$var$isElementScaled(offsetParent);
    var documentElement = (0, $quZ7I.default)(offsetParent);
    var rect = (0, $cqNBE.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $jwJki.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $8lMHT.default)(documentElement)) scroll = (0, $hBNBF.default)(offsetParent);
        if ((0, $ivibo.isHTMLElement)(offsetParent)) {
            offsets = (0, $cqNBE.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8yKMq.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("cqNBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $90ce647eb5a80d1e$export$2e2bcd8739ae039);

var $ivibo = parcelRequire("ivibo");

var $7KMOf = parcelRequire("7KMOf");

var $eo0rj = parcelRequire("eo0rj");

var $1r5Cg = parcelRequire("1r5Cg");
function $90ce647eb5a80d1e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $ivibo.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $7KMOf.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $7KMOf.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $ivibo.isElement)(element) ? (0, $eo0rj.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $1r5Cg.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("7KMOf", function(module, exports) {

$parcel$export(module.exports, "max", () => $5a52b0ccb31d3232$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $5a52b0ccb31d3232$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $5a52b0ccb31d3232$export$2077e0241d6afd3c);
var $5a52b0ccb31d3232$export$8960430cfd85939f = Math.max;
var $5a52b0ccb31d3232$export$96ec731ed4dcb222 = Math.min;
var $5a52b0ccb31d3232$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("1r5Cg", function(module, exports) {

$parcel$export(module.exports, "default", () => $10bcab4c14aebcff$export$2e2bcd8739ae039);

var $43BlU = parcelRequire("43BlU");
function $10bcab4c14aebcff$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $43BlU.default)());
}

});
parcelRegister("43BlU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f446aa4b3ec30e7$export$2e2bcd8739ae039);
function $2f446aa4b3ec30e7$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("hBNBF", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd1c5f324ae7d8e5$export$2e2bcd8739ae039);

var $5mKfz = parcelRequire("5mKfz");

var $eo0rj = parcelRequire("eo0rj");

var $ivibo = parcelRequire("ivibo");

var $aISWs = parcelRequire("aISWs");
function $cd1c5f324ae7d8e5$export$2e2bcd8739ae039(node) {
    if (node === (0, $eo0rj.default)(node) || !(0, $ivibo.isHTMLElement)(node)) return (0, $5mKfz.default)(node);
    else return (0, $aISWs.default)(node);
}

});
parcelRegister("5mKfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e82e21de353c52e$export$2e2bcd8739ae039);

var $eo0rj = parcelRequire("eo0rj");
function $3e82e21de353c52e$export$2e2bcd8739ae039(node) {
    var win = (0, $eo0rj.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("aISWs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ce8a1c674b7f90a$export$2e2bcd8739ae039);
function $7ce8a1c674b7f90a$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("8yKMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $63b5c93bb8018b74$export$2e2bcd8739ae039);

var $cqNBE = parcelRequire("cqNBE");

var $quZ7I = parcelRequire("quZ7I");

var $5mKfz = parcelRequire("5mKfz");
function $63b5c93bb8018b74$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $cqNBE.default)((0, $quZ7I.default)(element)).left + (0, $5mKfz.default)(element).scrollLeft;
}

});
parcelRegister("quZ7I", function(module, exports) {

$parcel$export(module.exports, "default", () => $04fa76c56bbd2641$export$2e2bcd8739ae039);

var $ivibo = parcelRequire("ivibo");
function $04fa76c56bbd2641$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $ivibo.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("8lMHT", function(module, exports) {

$parcel$export(module.exports, "default", () => $61461110e75afa0a$export$2e2bcd8739ae039);

var $cYS6I = parcelRequire("cYS6I");
function $61461110e75afa0a$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cYS6I.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("cYS6I", function(module, exports) {

$parcel$export(module.exports, "default", () => $97350f3d043254ad$export$2e2bcd8739ae039);

var $eo0rj = parcelRequire("eo0rj");
function $97350f3d043254ad$export$2e2bcd8739ae039(element) {
    return (0, $eo0rj.default)(element).getComputedStyle(element);
}

});



parcelRegister("eKM07", function(module, exports) {

$parcel$export(module.exports, "default", () => $abda98867bd542b0$export$2e2bcd8739ae039);

var $cqNBE = parcelRequire("cqNBE");
function $abda98867bd542b0$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $cqNBE.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("2j92Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ae45fab0e700231$export$2e2bcd8739ae039);

var $kc7mO = parcelRequire("kc7mO");

var $gFTVa = parcelRequire("gFTVa");

var $eo0rj = parcelRequire("eo0rj");

var $8lMHT = parcelRequire("8lMHT");
function $1ae45fab0e700231$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $kc7mO.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $eo0rj.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $8lMHT.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($1ae45fab0e700231$export$2e2bcd8739ae039((0, $gFTVa.default)(target)));
}

});
parcelRegister("kc7mO", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb3aa494251e0038$export$2e2bcd8739ae039);

var $gFTVa = parcelRequire("gFTVa");

var $8lMHT = parcelRequire("8lMHT");

var $jwJki = parcelRequire("jwJki");

var $ivibo = parcelRequire("ivibo");
function $eb3aa494251e0038$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $jwJki.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $ivibo.isHTMLElement)(node) && (0, $8lMHT.default)(node)) return node;
    return $eb3aa494251e0038$export$2e2bcd8739ae039((0, $gFTVa.default)(node));
}

});
parcelRegister("gFTVa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c23bda729c7fe4d8$export$2e2bcd8739ae039);

var $jwJki = parcelRequire("jwJki");

var $quZ7I = parcelRequire("quZ7I");

var $ivibo = parcelRequire("ivibo");
function $c23bda729c7fe4d8$export$2e2bcd8739ae039(element) {
    if ((0, $jwJki.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $ivibo.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $quZ7I.default)(element) // fallback
    );
}

});



parcelRegister("6uo2j", function(module, exports) {

$parcel$export(module.exports, "default", () => $013821d0ad6e92ea$export$2e2bcd8739ae039);

var $eo0rj = parcelRequire("eo0rj");

var $jwJki = parcelRequire("jwJki");

var $cYS6I = parcelRequire("cYS6I");

var $ivibo = parcelRequire("ivibo");

var $2997F = parcelRequire("2997F");

var $gFTVa = parcelRequire("gFTVa");

var $43BlU = parcelRequire("43BlU");
function $013821d0ad6e92ea$var$getTrueOffsetParent(element) {
    if (!(0, $ivibo.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cYS6I.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $013821d0ad6e92ea$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $43BlU.default)());
    var isIE = /Trident/i.test((0, $43BlU.default)());
    if (isIE && (0, $ivibo.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cYS6I.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $gFTVa.default)(element);
    if ((0, $ivibo.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $ivibo.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $jwJki.default)(currentNode)) < 0){
        var css = (0, $cYS6I.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $013821d0ad6e92ea$export$2e2bcd8739ae039(element) {
    var window = (0, $eo0rj.default)(element);
    var offsetParent = $013821d0ad6e92ea$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $2997F.default)(offsetParent) && (0, $cYS6I.default)(offsetParent).position === "static")offsetParent = $013821d0ad6e92ea$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $jwJki.default)(offsetParent) === "html" || (0, $jwJki.default)(offsetParent) === "body" && (0, $cYS6I.default)(offsetParent).position === "static")) return window;
    return offsetParent || $013821d0ad6e92ea$var$getContainingBlock(element) || window;
}

});
parcelRegister("2997F", function(module, exports) {

$parcel$export(module.exports, "default", () => $19037f95143aa5bf$export$2e2bcd8739ae039);

var $jwJki = parcelRequire("jwJki");
function $19037f95143aa5bf$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $jwJki.default)(element)) >= 0;
}

});


parcelRegister("9O8kg", function(module, exports) {

$parcel$export(module.exports, "default", () => $723f3de2f10a5097$export$2e2bcd8739ae039);

var $aybkz = parcelRequire("aybkz");
function $723f3de2f10a5097$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $723f3de2f10a5097$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $723f3de2f10a5097$var$order(modifiers); // order based on phase
    return (0, $aybkz.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("aybkz", function(module, exports) {

$parcel$export(module.exports, "top", () => $7ae5de662d321f58$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $7ae5de662d321f58$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $7ae5de662d321f58$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $7ae5de662d321f58$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $7ae5de662d321f58$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $7ae5de662d321f58$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $7ae5de662d321f58$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $7ae5de662d321f58$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $7ae5de662d321f58$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $7ae5de662d321f58$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $7ae5de662d321f58$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $7ae5de662d321f58$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $7ae5de662d321f58$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $7ae5de662d321f58$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $7ae5de662d321f58$export$d087d3878fdf71d5);
var $7ae5de662d321f58$export$1e95b668f3b82d = "top";
var $7ae5de662d321f58$export$40e543e69a8b3fbb = "bottom";
var $7ae5de662d321f58$export$79ffe56a765070d2 = "right";
var $7ae5de662d321f58$export$eabcd2c8791e7bf4 = "left";
var $7ae5de662d321f58$export$dfb5619354ba860 = "auto";
var $7ae5de662d321f58$export$aec2ce47c367b8c3 = [
    $7ae5de662d321f58$export$1e95b668f3b82d,
    $7ae5de662d321f58$export$40e543e69a8b3fbb,
    $7ae5de662d321f58$export$79ffe56a765070d2,
    $7ae5de662d321f58$export$eabcd2c8791e7bf4
];
var $7ae5de662d321f58$export$b3571188c770cc5a = "start";
var $7ae5de662d321f58$export$bd5df0f255a350f8 = "end";
var $7ae5de662d321f58$export$390fd549c5303b4d = "clippingParents";
var $7ae5de662d321f58$export$d7b7311ec04a3e8f = "viewport";
var $7ae5de662d321f58$export$ae5ab1c730825774 = "popper";
var $7ae5de662d321f58$export$ca50aac9f3ba507f = "reference";
var $7ae5de662d321f58$export$368f9a87e87fa4e1 = /*#__PURE__*/ $7ae5de662d321f58$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $7ae5de662d321f58$export$b3571188c770cc5a,
        placement + "-" + $7ae5de662d321f58$export$bd5df0f255a350f8
    ]);
}, []);
var $7ae5de662d321f58$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($7ae5de662d321f58$export$aec2ce47c367b8c3, [
    $7ae5de662d321f58$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $7ae5de662d321f58$export$b3571188c770cc5a,
        placement + "-" + $7ae5de662d321f58$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $7ae5de662d321f58$export$421679a7c3d56e = "beforeRead";
var $7ae5de662d321f58$export$aafa59e2e03f2942 = "read";
var $7ae5de662d321f58$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $7ae5de662d321f58$export$c65e99957a05207c = "beforeMain";
var $7ae5de662d321f58$export$f22da7240b7add18 = "main";
var $7ae5de662d321f58$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $7ae5de662d321f58$export$8d4d2d70e7d46032 = "beforeWrite";
var $7ae5de662d321f58$export$68d8715fc104d294 = "write";
var $7ae5de662d321f58$export$70a6e5159acce2e6 = "afterWrite";
var $7ae5de662d321f58$export$d087d3878fdf71d5 = [
    $7ae5de662d321f58$export$421679a7c3d56e,
    $7ae5de662d321f58$export$aafa59e2e03f2942,
    $7ae5de662d321f58$export$6964f6c886723980,
    $7ae5de662d321f58$export$c65e99957a05207c,
    $7ae5de662d321f58$export$f22da7240b7add18,
    $7ae5de662d321f58$export$bab79516f2d662fe,
    $7ae5de662d321f58$export$8d4d2d70e7d46032,
    $7ae5de662d321f58$export$68d8715fc104d294,
    $7ae5de662d321f58$export$70a6e5159acce2e6
];

});


parcelRegister("auZgh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a4c39fa51782c2d$export$2e2bcd8739ae039);
function $7a4c39fa51782c2d$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("e8ggD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a49e6e64000099d6$export$2e2bcd8739ae039);
function $a49e6e64000099d6$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("6CCNt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d2462efa5a48f21$export$2e2bcd8739ae039);

var $eo0rj = parcelRequire("eo0rj");
var $4d2462efa5a48f21$var$passive = {
    passive: true
};
function $4d2462efa5a48f21$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $eo0rj.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $4d2462efa5a48f21$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $4d2462efa5a48f21$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $4d2462efa5a48f21$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $4d2462efa5a48f21$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $4d2462efa5a48f21$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $4d2462efa5a48f21$var$effect,
    data: {}
};

});

parcelRegister("eH1bw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab26001de36d5c4f$export$2e2bcd8739ae039);

var $4nOge = parcelRequire("4nOge");
function $ab26001de36d5c4f$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4nOge.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ab26001de36d5c4f$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $ab26001de36d5c4f$var$popperOffsets,
    data: {}
};

});
parcelRegister("4nOge", function(module, exports) {

$parcel$export(module.exports, "default", () => $33104c26dad1a969$export$2e2bcd8739ae039);

var $2xMQb = parcelRequire("2xMQb");

var $bG8YS = parcelRequire("bG8YS");

var $kkXKw = parcelRequire("kkXKw");

var $aybkz = parcelRequire("aybkz");
function $33104c26dad1a969$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $2xMQb.default)(placement) : null;
    var variation = placement ? (0, $bG8YS.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $aybkz.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $aybkz.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $aybkz.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $aybkz.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $kkXKw.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $aybkz.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $aybkz.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("2xMQb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1da48c9a1d9e61ab$export$2e2bcd8739ae039);

function $1da48c9a1d9e61ab$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("bG8YS", function(module, exports) {

$parcel$export(module.exports, "default", () => $880a955e2137b9bf$export$2e2bcd8739ae039);
function $880a955e2137b9bf$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("kkXKw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ece405dba733980e$export$2e2bcd8739ae039);
function $ece405dba733980e$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("8ThEi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6791267df2a4fddd$export$2e2bcd8739ae039);

var $aybkz = parcelRequire("aybkz");

var $6uo2j = parcelRequire("6uo2j");

var $eo0rj = parcelRequire("eo0rj");

var $quZ7I = parcelRequire("quZ7I");

var $cYS6I = parcelRequire("cYS6I");

var $2xMQb = parcelRequire("2xMQb");

var $bG8YS = parcelRequire("bG8YS");

var $7KMOf = parcelRequire("7KMOf");
var $6791267df2a4fddd$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $6791267df2a4fddd$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $7KMOf.round)(x * dpr) / dpr || 0,
        y: (0, $7KMOf.round)(y * dpr) / dpr || 0
    };
}
function $6791267df2a4fddd$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $aybkz.left);
    var sideY = (0, $aybkz.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $6uo2j.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $eo0rj.default)(popper)) {
            offsetParent = (0, $quZ7I.default)(popper);
            if ((0, $cYS6I.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $aybkz.top) || (placement === (0, $aybkz.left) || placement === (0, $aybkz.right)) && variation === (0, $aybkz.end)) {
            sideY = (0, $aybkz.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $aybkz.left) || (placement === (0, $aybkz.top) || placement === (0, $aybkz.bottom)) && variation === (0, $aybkz.end)) {
            sideX = (0, $aybkz.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $6791267df2a4fddd$var$unsetSides);
    var _ref4 = roundOffsets === true ? $6791267df2a4fddd$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $eo0rj.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $6791267df2a4fddd$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $2xMQb.default)(state.placement),
        variation: (0, $bG8YS.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $6791267df2a4fddd$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $6791267df2a4fddd$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $6791267df2a4fddd$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $6791267df2a4fddd$var$computeStyles,
    data: {}
};

});

parcelRegister("eQrYL", function(module, exports) {

$parcel$export(module.exports, "default", () => $aceba0172c9e108f$export$2e2bcd8739ae039);

var $2xMQb = parcelRequire("2xMQb");

var $aybkz = parcelRequire("aybkz");
function $aceba0172c9e108f$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $2xMQb.default)(placement);
    var invertDistance = [
        (0, $aybkz.left),
        (0, $aybkz.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $aybkz.left),
        (0, $aybkz.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $aceba0172c9e108f$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $aybkz.placements).reduce(function(acc, placement) {
        acc[placement] = $aceba0172c9e108f$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $aceba0172c9e108f$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $aceba0172c9e108f$var$offset
};

});

parcelRegister("1RcMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $15a4a7a58dc1f940$export$2e2bcd8739ae039);

var $iisCC = parcelRequire("iisCC");

var $2xMQb = parcelRequire("2xMQb");

var $bwVyG = parcelRequire("bwVyG");

var $6YUKb = parcelRequire("6YUKb");

var $99Fjk = parcelRequire("99Fjk");

var $aybkz = parcelRequire("aybkz");

var $bG8YS = parcelRequire("bG8YS");
function $15a4a7a58dc1f940$var$getExpandedFallbackPlacements(placement) {
    if ((0, $2xMQb.default)(placement) === (0, $aybkz.auto)) return [];
    var oppositePlacement = (0, $iisCC.default)(placement);
    return [
        (0, $bwVyG.default)(placement),
        oppositePlacement,
        (0, $bwVyG.default)(oppositePlacement)
    ];
}
function $15a4a7a58dc1f940$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $2xMQb.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $iisCC.default)(preferredPlacement)
    ] : $15a4a7a58dc1f940$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $2xMQb.default)(placement) === (0, $aybkz.auto) ? (0, $99Fjk.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $2xMQb.default)(placement);
        var isStartVariation = (0, $bG8YS.default)(placement) === (0, $aybkz.start);
        var isVertical = [
            (0, $aybkz.top),
            (0, $aybkz.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $6YUKb.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $aybkz.right) : (0, $aybkz.left) : isStartVariation ? (0, $aybkz.bottom) : (0, $aybkz.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $iisCC.default)(mainVariationSide);
        var altVariationSide = (0, $iisCC.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $15a4a7a58dc1f940$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $15a4a7a58dc1f940$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("iisCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5201c1f6c75cdfe$export$2e2bcd8739ae039);
var $d5201c1f6c75cdfe$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $d5201c1f6c75cdfe$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d5201c1f6c75cdfe$var$hash[matched];
    });
}

});

parcelRegister("bwVyG", function(module, exports) {

$parcel$export(module.exports, "default", () => $864f54c20e9cff1f$export$2e2bcd8739ae039);
var $864f54c20e9cff1f$var$hash = {
    start: "end",
    end: "start"
};
function $864f54c20e9cff1f$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $864f54c20e9cff1f$var$hash[matched];
    });
}

});

parcelRegister("6YUKb", function(module, exports) {

$parcel$export(module.exports, "default", () => $51545cd169cd74c0$export$2e2bcd8739ae039);

var $lLkDB = parcelRequire("lLkDB");

var $quZ7I = parcelRequire("quZ7I");

var $cqNBE = parcelRequire("cqNBE");

var $4nOge = parcelRequire("4nOge");

var $i4BwR = parcelRequire("i4BwR");

var $aybkz = parcelRequire("aybkz");

var $ivibo = parcelRequire("ivibo");

var $0iVRh = parcelRequire("0iVRh");

var $4QLK7 = parcelRequire("4QLK7");
function $51545cd169cd74c0$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $aybkz.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $aybkz.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $aybkz.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $0iVRh.default)(typeof padding !== "number" ? padding : (0, $4QLK7.default)(padding, (0, $aybkz.basePlacements)));
    var altContext = elementContext === (0, $aybkz.popper) ? (0, $aybkz.reference) : (0, $aybkz.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $lLkDB.default)((0, $ivibo.isElement)(element) ? element : element.contextElement || (0, $quZ7I.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $cqNBE.default)(state.elements.reference);
    var popperOffsets = (0, $4nOge.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $i4BwR.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $aybkz.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $aybkz.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $aybkz.right),
                (0, $aybkz.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $aybkz.top),
                (0, $aybkz.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("lLkDB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd7dfefb756c2ece$export$2e2bcd8739ae039);

var $aybkz = parcelRequire("aybkz");

var $igiMq = parcelRequire("igiMq");

var $357G3 = parcelRequire("357G3");

var $2j92Y = parcelRequire("2j92Y");

var $6uo2j = parcelRequire("6uo2j");

var $quZ7I = parcelRequire("quZ7I");

var $cYS6I = parcelRequire("cYS6I");

var $ivibo = parcelRequire("ivibo");

var $cqNBE = parcelRequire("cqNBE");

var $gFTVa = parcelRequire("gFTVa");

var $4MdF7 = parcelRequire("4MdF7");

var $jwJki = parcelRequire("jwJki");

var $i4BwR = parcelRequire("i4BwR");

var $7KMOf = parcelRequire("7KMOf");
function $fd7dfefb756c2ece$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $cqNBE.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $fd7dfefb756c2ece$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $aybkz.viewport) ? (0, $i4BwR.default)((0, $igiMq.default)(element, strategy)) : (0, $ivibo.isElement)(clippingParent) ? $fd7dfefb756c2ece$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $i4BwR.default)((0, $357G3.default)((0, $quZ7I.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $fd7dfefb756c2ece$var$getClippingParents(element) {
    var clippingParents = (0, $2j92Y.default)((0, $gFTVa.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $cYS6I.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $ivibo.isHTMLElement)(element) ? (0, $6uo2j.default)(element) : element;
    if (!(0, $ivibo.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $ivibo.isElement)(clippingParent) && (0, $4MdF7.default)(clippingParent, clipperElement) && (0, $jwJki.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $fd7dfefb756c2ece$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $fd7dfefb756c2ece$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $fd7dfefb756c2ece$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $7KMOf.max)(rect.top, accRect.top);
        accRect.right = (0, $7KMOf.min)(rect.right, accRect.right);
        accRect.bottom = (0, $7KMOf.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $7KMOf.max)(rect.left, accRect.left);
        return accRect;
    }, $fd7dfefb756c2ece$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("igiMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4b849f14ba4f436$export$2e2bcd8739ae039);

var $eo0rj = parcelRequire("eo0rj");

var $quZ7I = parcelRequire("quZ7I");

var $8yKMq = parcelRequire("8yKMq");

var $1r5Cg = parcelRequire("1r5Cg");
function $d4b849f14ba4f436$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $eo0rj.default)(element);
    var html = (0, $quZ7I.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $1r5Cg.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8yKMq.default)(element),
        y: y
    };
}

});

parcelRegister("357G3", function(module, exports) {

$parcel$export(module.exports, "default", () => $23e7cb485e6148ae$export$2e2bcd8739ae039);

var $quZ7I = parcelRequire("quZ7I");

var $cYS6I = parcelRequire("cYS6I");

var $8yKMq = parcelRequire("8yKMq");

var $5mKfz = parcelRequire("5mKfz");

var $7KMOf = parcelRequire("7KMOf");
function $23e7cb485e6148ae$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $quZ7I.default)(element);
    var winScroll = (0, $5mKfz.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $7KMOf.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $7KMOf.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8yKMq.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cYS6I.default)(body || html).direction === "rtl") x += (0, $7KMOf.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("4MdF7", function(module, exports) {

$parcel$export(module.exports, "default", () => $37a63e221e7e0e8a$export$2e2bcd8739ae039);

var $ivibo = parcelRequire("ivibo");
function $37a63e221e7e0e8a$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $ivibo.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("i4BwR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d285b62e790b9511$export$2e2bcd8739ae039);
function $d285b62e790b9511$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("0iVRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $000eafbe1cd3e859$export$2e2bcd8739ae039);

var $7hTxG = parcelRequire("7hTxG");
function $000eafbe1cd3e859$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $7hTxG.default)(), paddingObject);
}

});
parcelRegister("7hTxG", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e5347503c80281$export$2e2bcd8739ae039);
function $54e5347503c80281$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("4QLK7", function(module, exports) {

$parcel$export(module.exports, "default", () => $38810d7c0e620ac6$export$2e2bcd8739ae039);
function $38810d7c0e620ac6$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("99Fjk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6aa4ffc34db4a465$export$2e2bcd8739ae039);

var $bG8YS = parcelRequire("bG8YS");

var $aybkz = parcelRequire("aybkz");

var $6YUKb = parcelRequire("6YUKb");

var $2xMQb = parcelRequire("2xMQb");
function $6aa4ffc34db4a465$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $aybkz.placements) : _options$allowedAutoP;
    var variation = (0, $bG8YS.default)(placement);
    var placements = variation ? flipVariations ? (0, $aybkz.variationPlacements) : (0, $aybkz.variationPlacements).filter(function(placement) {
        return (0, $bG8YS.default)(placement) === variation;
    }) : (0, $aybkz.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $6YUKb.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $2xMQb.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("6q4rp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ac89dac647d39b4$export$2e2bcd8739ae039);

var $aybkz = parcelRequire("aybkz");

var $2xMQb = parcelRequire("2xMQb");

var $kkXKw = parcelRequire("kkXKw");

var $5qnQK = parcelRequire("5qnQK");

var $f4lHE = parcelRequire("f4lHE");

var $eKM07 = parcelRequire("eKM07");

var $6uo2j = parcelRequire("6uo2j");

var $6YUKb = parcelRequire("6YUKb");

var $bG8YS = parcelRequire("bG8YS");

var $7hTxG = parcelRequire("7hTxG");

var $7KMOf = parcelRequire("7KMOf");
function $4ac89dac647d39b4$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $6YUKb.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $2xMQb.default)(state.placement);
    var variation = (0, $bG8YS.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $kkXKw.default)(basePlacement);
    var altAxis = (0, $5qnQK.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $aybkz.top) : (0, $aybkz.left);
        var altSide = mainAxis === "y" ? (0, $aybkz.bottom) : (0, $aybkz.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $aybkz.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $aybkz.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $eKM07.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $7hTxG.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $f4lHE.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $6uo2j.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $f4lHE.within)(tether ? (0, $7KMOf.min)(min, tetherMin) : min, offset, tether ? (0, $7KMOf.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $aybkz.top) : (0, $aybkz.left);
        var _altSide = mainAxis === "x" ? (0, $aybkz.bottom) : (0, $aybkz.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $aybkz.top),
            (0, $aybkz.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $f4lHE.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $f4lHE.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4ac89dac647d39b4$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $4ac89dac647d39b4$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("5qnQK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f31e18164f7c015$export$2e2bcd8739ae039);
function $3f31e18164f7c015$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("f4lHE", function(module, exports) {

$parcel$export(module.exports, "within", () => $af88108347c8b046$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $af88108347c8b046$export$86c8af6d3ef0b4a);

var $7KMOf = parcelRequire("7KMOf");
function $af88108347c8b046$export$f28d906d67a997f3(min, value, max) {
    return (0, $7KMOf.max)(min, (0, $7KMOf.min)(value, max));
}
function $af88108347c8b046$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $af88108347c8b046$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("8FXxC", function(module, exports) {

$parcel$export(module.exports, "default", () => $651056bc64e13a1b$export$2e2bcd8739ae039);

var $2xMQb = parcelRequire("2xMQb");

var $eKM07 = parcelRequire("eKM07");

var $4MdF7 = parcelRequire("4MdF7");

var $6uo2j = parcelRequire("6uo2j");

var $kkXKw = parcelRequire("kkXKw");

var $f4lHE = parcelRequire("f4lHE");

var $0iVRh = parcelRequire("0iVRh");

var $4QLK7 = parcelRequire("4QLK7");

var $aybkz = parcelRequire("aybkz");
var $651056bc64e13a1b$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $0iVRh.default)(typeof padding !== "number" ? padding : (0, $4QLK7.default)(padding, (0, $aybkz.basePlacements)));
};
function $651056bc64e13a1b$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $2xMQb.default)(state.placement);
    var axis = (0, $kkXKw.default)(basePlacement);
    var isVertical = [
        (0, $aybkz.left),
        (0, $aybkz.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $651056bc64e13a1b$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $eKM07.default)(arrowElement);
    var minProp = axis === "y" ? (0, $aybkz.top) : (0, $aybkz.left);
    var maxProp = axis === "y" ? (0, $aybkz.bottom) : (0, $aybkz.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $6uo2j.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $f4lHE.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $651056bc64e13a1b$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4MdF7.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $651056bc64e13a1b$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $651056bc64e13a1b$var$arrow,
    effect: $651056bc64e13a1b$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("l1HpG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4eb5df016b46648$export$2e2bcd8739ae039);

var $aybkz = parcelRequire("aybkz");

var $6YUKb = parcelRequire("6YUKb");
function $f4eb5df016b46648$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $f4eb5df016b46648$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $aybkz.top),
        (0, $aybkz.right),
        (0, $aybkz.bottom),
        (0, $aybkz.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $f4eb5df016b46648$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $6YUKb.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $6YUKb.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $f4eb5df016b46648$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $f4eb5df016b46648$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $f4eb5df016b46648$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $f4eb5df016b46648$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $f4eb5df016b46648$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $f4eb5df016b46648$var$hide
};

});





parcelRegister("6Curj", function(module, exports) {

$parcel$export(module.exports, "ExpirationRemainingDays", () => $4550a66ca0ff69e5$export$a21360df4ae4fe9e);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");
const $4550a66ca0ff69e5$var$RED_THRESHOLD = 5;
const $4550a66ca0ff69e5$var$ORANGE_THRESHOLD = 10;
const $4550a66ca0ff69e5$export$a21360df4ae4fe9e = ({ patient: patient })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const labelColor = (0, $81g6h.useMemo)(()=>{
        if (patient.expirationDays < $4550a66ca0ff69e5$var$RED_THRESHOLD) return (0, $kKnoQ.colors).rejection;
        if (patient.expirationDays < $4550a66ca0ff69e5$var$ORANGE_THRESHOLD) return (0, $kKnoQ.colors).orange;
        return (0, $kKnoQ.colors).black;
    }, [
        patient.expirationDays
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)("span", {
        style: {
            color: labelColor
        },
        children: format("home.pendingPatientsListing.expiresInColumn.item", {
            remainingDays: patient.expirationDays
        })
    });
};

});

parcelRegister("2LUd1", function(module, exports) {

$parcel$export(module.exports, "PatientActionButton", () => $797111d7101d1d66$export$10db6bcc5d52eb1a);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $6Yxa2 = parcelRequire("6Yxa2");

var $bC9c0 = parcelRequire("bC9c0");

var $5UMQ1 = parcelRequire("5UMQ1");

var $243Cr = parcelRequire("243Cr");

var $amllh = parcelRequire("amllh");

var $lDZlX = parcelRequire("lDZlX");

var $kKnoQ = parcelRequire("kKnoQ");

var $jTpg0 = parcelRequire("jTpg0");

var $81g6h = parcelRequire("81g6h");
var $797111d7101d1d66$var$DeleteIcon = function DeleteIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M10.82 2c-.52 0-1.01.2-1.38.57L9.01 3h-5c-.13 0-.26.02-.39.07a1.004 1.004 0 0 0-.55.55c-.05.12-.07.25-.07.39s.02.26.07.39c.05.12.13.23.22.33.1.09.21.17.33.22.13.05.26.07.39.07h16c.13 0 .26-.02.39-.07a1.004 1.004 0 0 0 .55-.55c.05-.12.07-.25.07-.39s-.02-.26-.07-.39a1.19 1.19 0 0 0-.22-.33c-.1-.09-.21-.17-.33-.22-.13-.05-.26-.07-.39-.07h-5l-.43-.43A1.92 1.92 0 0 0 13.2 2h-2.38ZM16.13 22H7.88c-1.5 0-2.78-1.05-2.97-2.447L3.409 8.136a1 1 0 0 1 .991-1.13h15.22a1 1 0 0 1 .991 1.13L19.11 19.534C18.9 20.95 17.62 22 16.13 22ZM5.5 8.88l1.39 10.448c.06.44.5.797.99.797h8.25c.5 0 .93-.356 1-.825l1.39-10.42H5.5Z",
            fill: "currentColor"
        })
    });
};
$797111d7101d1d66$var$DeleteIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $797111d7101d1d66$var$EyeVisibleIcon = function EyeVisibleIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_177_172)",
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M.208 11.128C1.016 9.392 4.511 3 12.01 3c7.473 0 10.978 6.378 11.803 8.11l.005.01.005.01c.246.551.246 1.189 0 1.74l-.005.01-.005.01c-.824 1.73-4.3 8.11-11.803 8.11-7.492 0-10.987-6.399-11.8-8.125a1.974 1.974 0 0 1-.002-1.747ZM12.01 5c-6.225 0-9.23 5.34-9.993 6.981l-.006.013-.003.006.002.004.005.01C2.79 13.662 5.795 19 12.01 19c6.196 0 9.182-5.266 9.99-6.954a.138.138 0 0 0 0-.092C21.193 10.268 18.177 5 12.01 5Z"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M12.01 16.22a4.22 4.22 0 1 0 0-8.44 4.22 4.22 0 0 0 0 8.44Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_177_172",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
};
$797111d7101d1d66$var$EyeVisibleIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $797111d7101d1d66$export$10db6bcc5d52eb1a = ({ patient: patient })=>{
    const { id: id, analyticsId: analyticsId, status: status } = patient;
    const navigate = (0, $htiSH.useNavigate)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const { format: format } = (0, $1eHG3.useI18n)();
    const items = (0, $81g6h.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).compact([
            status === (0, $6Yxa2.PatientStatus).Registered ? {
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($797111d7101d1d66$var$EyeVisibleIcon, {}),
                text: format("global.patientOperation.see"),
                onClick: ()=>{
                    navigate((0, $lDZlX.RoutesPath).PatientDetails, {
                        route: {
                            patientId: id
                        },
                        query: {
                            active: (0, $lDZlX.TabPatientDetails).PROGRAMS_TAB
                        }
                    });
                    (0, $bC9c0.sendAnalyticsEventViewPatientDetail)(analyticsId, (0, $bC9c0.AnalyticsProgramClickType).OPTION_CLICK);
                }
            } : {
                destructive: true,
                text: format("global.patientOperation.cancelInvitation"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($797111d7101d1d66$var$DeleteIcon, {}),
                onClick: ()=>{
                    dialogContext?.openModal((0, $243Cr.ModalId).CancelPatientInvitation, {
                        patient: patient
                    });
                }
            }
        ]), [
        analyticsId,
        dialogContext,
        format,
        id,
        navigate,
        patient,
        status
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($797111d7101d1d66$var$ActionButton, {
        menuId: id,
        menuItems: items
    });
};
const $797111d7101d1d66$var$ActionButton = (0, $5UMQ1.default)((0, $amllh.MenuButton))`
	.menu-button {
		background-color: ${(0, $kKnoQ.colors).transparent};

		&.hover {
			background-color: ${(0, $kKnoQ.colors).grey10};
		}
	}
`;

});
parcelRegister("amllh", function(module, exports) {

$parcel$export(module.exports, "MenuPosition", () => $6aa79c298549c904$export$871e3904bb103503);
$parcel$export(module.exports, "IconPosition", () => $6aa79c298549c904$export$73641af126067017);
$parcel$export(module.exports, "MenuButton", () => $6aa79c298549c904$export$266a769812832828);

var $iKObn = parcelRequire("iKObn");

var $a6fIt = parcelRequire("a6fIt");

var $5UMQ1 = parcelRequire("5UMQ1");

var $9f2ha = parcelRequire("9f2ha");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $1pD6E = parcelRequire("1pD6E");

var $cfkGk = parcelRequire("cfkGk");

var $81g6h = parcelRequire("81g6h");
var $6aa79c298549c904$var$MenuIcon = function MenuIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M12 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 7a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 7a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z",
            fill: "currentColor"
        })
    });
};
$6aa79c298549c904$var$MenuIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $6aa79c298549c904$export$871e3904bb103503;
(function(MenuPosition) {
    MenuPosition["DefaultPosition"] = "DefaultPosition";
    MenuPosition["CenteredPosition"] = "CenteredPosition";
})($6aa79c298549c904$export$871e3904bb103503 || ($6aa79c298549c904$export$871e3904bb103503 = {}));
var $6aa79c298549c904$export$73641af126067017;
(function(IconPosition) {
    IconPosition["Left"] = "Left";
    IconPosition["Right"] = "Right";
})($6aa79c298549c904$export$73641af126067017 || ($6aa79c298549c904$export$73641af126067017 = {}));
const $6aa79c298549c904$export$266a769812832828 = ({ className: className, menuItems: menuItems, menuId: menuId, menuPosition: menuPosition = "DefaultPosition", iconPosition: iconPosition = "Left", menuIconSize: menuIconSize = 16, menuIconColor: menuIconColor = (0, $kKnoQ.colors).grey, itemIconColor: itemIconColor, shouldDisplayHalo: shouldDisplayHalo = false, onMenuClick: onMenuClick })=>{
    const menuRef = (0, $81g6h.useRef)(null);
    const [isOpened, setIsOpened] = (0, $81g6h.useState)(false);
    const [isHovering, setIsHovering] = (0, $81g6h.useState)(false);
    const buttonRef = (0, $81g6h.useRef)(null);
    const popupId = (0, $81g6h.useMemo)(()=>menuId ?? "menu_button_popup_menu", [
        menuId
    ]);
    const [overriddenMenuPosition, setOverriddenMenuPosition] = (0, $81g6h.useState)("right");
    const items = (0, $81g6h.useMemo)(()=>menuItems.map(({ itemClassName: itemClassName, disabled: disabled, destructive: destructive, text: text, icon: icon, shouldDisplayHaloItem: shouldDisplayHaloItem = false, testId: testId, onClick: onClick })=>{
            let labelColor;
            if (disabled) labelColor = (0, $kKnoQ.colors).grey50;
            else if (destructive) labelColor = (0, $kKnoQ.colors).rejection;
            else labelColor = undefined;
            let overriddenItemIconColor;
            if (disabled) overriddenItemIconColor = (0, $kKnoQ.colors).grey50;
            else if (destructive) overriddenItemIconColor = (0, $kKnoQ.colors).rejection;
            else overriddenItemIconColor = itemIconColor;
            return {
                template: /*#__PURE__*/ (0, $iKObn.jsx)((0, $9f2ha.AnimatedHalo), {
                    shouldDisplayHalo: shouldDisplayHaloItem,
                    children: /*#__PURE__*/ (0, $iKObn.jsxs)($6aa79c298549c904$var$Option, {
                        "data-test": testId,
                        color: labelColor,
                        disabled: disabled,
                        onClick: (event)=>{
                            if (!disabled) {
                                event.stopPropagation();
                                onClick();
                                menuRef.current?.hide(event);
                            }
                        },
                        className: itemClassName,
                        isAnimatedBackground: shouldDisplayHaloItem,
                        children: [
                            icon && iconPosition === "Left" && /*#__PURE__*/ (0, $iKObn.jsx)($6aa79c298549c904$var$IconContainer, {
                                color: overriddenItemIconColor,
                                children: icon
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                                children: text
                            }),
                            icon && iconPosition === "Right" && /*#__PURE__*/ (0, $iKObn.jsx)($6aa79c298549c904$var$IconContainer, {
                                color: overriddenItemIconColor,
                                children: icon
                            })
                        ]
                    })
                })
            };
        }), [
        menuItems,
        itemIconColor,
        iconPosition
    ]);
    const centeredTransform = (0, $81g6h.useMemo)(()=>{
        switch(overriddenMenuPosition){
            case "right":
                return "translate(32px, calc(-20px - 50%))";
            case "topRight":
                return "translate(8px, 8px)";
            case "left":
                return "translate(-32px, calc(-20px - 50%))";
            case "topLeft":
                return "translate(-8px, 8px)";
        }
    }, [
        overriddenMenuPosition
    ]);
    const defaultTransform = (0, $81g6h.useMemo)(()=>{
        let transform;
        if (overriddenMenuPosition === "right") transform = "translate(8px, -8px)";
        else if (overriddenMenuPosition === "topRight") transform = "translate(8px, 8px)";
        else if (overriddenMenuPosition === "left") transform = "translate(-8px, -8px)";
        else transform = "translate(-8px, 8px)";
        return transform;
    }, [
        overriddenMenuPosition
    ]);
    (0, $81g6h.useEffect)(()=>{
        if (!isOpened) return;
        const buttonBox = buttonRef.current?.getBoundingClientRect();
        const popupBox = document.getElementById(popupId)?.getBoundingClientRect();
        if (popupBox && buttonBox) {
            if (popupBox.bottom <= buttonBox.bottom) setOverriddenMenuPosition(popupBox.left <= buttonBox.left ? "topLeft" : "topRight");
            else setOverriddenMenuPosition(popupBox.left <= buttonBox.left ? "left" : "right");
        }
    }, [
        isOpened,
        popupId
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($6aa79c298549c904$var$ToggleOptionButton, {
                "data-test": (0, $a6fIt.e2eTestId).createTemplatePage.toggleOptionButton,
                ref: buttonRef,
                onMouseEnter: ()=>{
                    setIsHovering(true);
                },
                onMouseOver: ()=>{
                    setIsHovering(true);
                },
                onMouseLeave: ()=>{
                    !isOpened && setIsHovering(false);
                },
                onClick: (event)=>{
                    menuRef.current?.toggle(event);
                    onMenuClick?.();
                    event.stopPropagation();
                },
                "aria-controls": "popup_menu",
                "aria-haspopup": true,
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $9f2ha.AnimatedHalo), {
                    shouldDisplayHalo: shouldDisplayHalo,
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($6aa79c298549c904$var$MenuIconContainer, {
                        className: (0, $cfkGk.classNames)("menu-button", {
                            hover: isHovering
                        }),
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($6aa79c298549c904$var$MenuIcon, {
                            width: menuIconSize,
                            height: menuIconSize,
                            color: menuIconColor
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $1pD6E.Menu), {
                style: {
                    backgroundColor: (0, $kKnoQ.colors).white,
                    padding: "8px 0px",
                    transform: menuPosition === "CenteredPosition" ? centeredTransform : defaultTransform,
                    width: "auto"
                },
                model: items,
                popup: true,
                onShow: ()=>setIsOpened(true),
                onHide: ()=>{
                    setIsHovering(false);
                    setIsOpened(false);
                },
                ref: menuRef,
                id: popupId
            })
        ]
    });
};
const $6aa79c298549c904$var$IconContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "center", "center")};

	> svg {
		width: 16px;
		height: 16px;
		color: ${({ color: color })=>color ?? (0, $kKnoQ.colors).grey};
	}
`;
const $6aa79c298549c904$var$ToggleOptionButton = (0, $5UMQ1.default).button`
	cursor: pointer;
	position: relative;
	appearance: none;
	border: none;
	padding: 8px;
	background-color: ${(0, $kKnoQ.colors).transparent};
	${(0, $5WGN2.row)(undefined, "center", "center")};
`;
const $6aa79c298549c904$var$MenuIconContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "center", "center")};
	width: 24px;
	height: 24px;
	border-radius: 50%;
`;
const $6aa79c298549c904$var$Option = (0, $5UMQ1.default).div`
	padding: 4px 24px 4px 8px;
	width: 100%;
	${(0, $5WGN2.row)(8, "flexstart", "center")};
	cursor: ${({ disabled: disabled })=>disabled ? "default" : "pointer"};

	span {
		color: ${(props)=>props.color ?? (0, $kKnoQ.colors).grey};
	}

	:hover {
		background-color: ${({ disabled: disabled })=>disabled ? "unset" : `${(0, $kKnoQ.colors).grey10}`};
		border-radius: ${({ isAnimatedBackground: isAnimatedBackground })=>isAnimatedBackground ? 40 : 0}px;
	}
`;

});
parcelRegister("a6fIt", function(module, exports) {

$parcel$export(module.exports, "e2eTestId", () => $eb16d3d859ec7e6d$export$8a3ed1cac0626ea);
const $eb16d3d859ec7e6d$var$P_DROPDOWN_ITEM = "p-dropdown-item";
const $eb16d3d859ec7e6d$export$8a3ed1cac0626ea = {
    loginPage: {
        cookiesDialogButton: "#CybotCookiebotDialogBodyButtonDecline",
        titleText: "loginScreen-titleText",
        emailTextInput: "loginScreen-emailTextInput",
        passwordTextInput: "loginScreen-passwordTextInput",
        loginLink: "registerScreen-linkTologinPage",
        submitButton: "loginScreen-submitButton",
        redirectToSignUpButton: "loginScreen-redirectToSignUpButton",
        registerButton: "loginScreen-register"
    },
    homePage: {
        tabGetStarted: "homePage-tab-get-started",
        tabExercise: "homePage-tab-exercise",
        tabProgram: "homePage-tab-program",
        tabPatient: "homePage-tab-patient",
        tabNotifications: "homePage-tab-notifications",
        createTemplateButton: "homePage-create-template-button",
        createProgramButton: "homePage-create-program-button",
        createPatientButton: "homePage-create-patient-button",
        profileMenu: "homePage-profile-menu",
        profileMenuItem: "homePage-profile-menu-item"
    },
    createTemplatePage: {
        exerciseContainer: "exercise-container",
        headerButtonContainer: "header-button-container",
        headerBackButton: "header-back-button",
        confirmButton: "confirm-button",
        templateNameInput: "template-name-input",
        templateGrid: "template-grid",
        programGrid: "program-grid",
        arrowUp: "arrow-up",
        arrowDown: "arrow-down",
        detailField: "detail-field",
        toggleOptionButton: "ToggleOptionButton",
        builderSecondaryButton: "builder-secondary-button",
        builderPrimaryButton: "builder-primary-button",
        templateMenu: {
            goToBuilderButton: "createTemplatePage-templateMenu-goToBuilder-Button",
            deleteTemplateButton: "createTemplatePage-templateMenu-deleteTemplateButton"
        }
    },
    dialog: {
        closeButton: "p-dialog-header-close-icon"
    },
    exerciseDetailsDialog: {
        closeButton: "exerciseDetailsDialog-closeButton"
    },
    createPatientDialog: {
        consentCheckbox: "createPatientDialog-consentCheckbox",
        closeButton: "p-dialog-header-icon",
        firstNameTextInput: "createPatientDialog-firstNameTextInput",
        lastNameTextInput: "createPatientDialog-lastNameTextInput",
        dropdownFunctionalStatus: "createPatientDialog-dropdown-functional-status",
        dropdownFunctionalStatusItem: $eb16d3d859ec7e6d$var$P_DROPDOWN_ITEM,
        submitButton: "createPatientDialog-submitButton",
        invitationCode: "createPatientDialog-invitation-code",
        createPatientCTA: "createPatientDialog-create-patient-cta"
    },
    patientPage: {
        ProgramTab: "patientPage-programTab",
        progressTab: "patientPage-progressTab",
        healthcareTeamTab: "patientPage-healthcareTeamTab",
        createProgramButton: "patientPage-createProgramButton",
        titreTextInput: "patientPage-titreTextInput",
        programCard: "patientPage-programCard"
    },
    scheduleProgramDialog: {
        shortcut: (index)=>`scheduleProgramDialog-shortcut-${index}`,
        submitButton: "scheduleProgramDialog-submitButton"
    },
    confirmActionDialog: {
        cancelButton: "confirmActionDialog-cancelButton",
        yesButton: "confirmActionDialog-yesButton"
    },
    registerPt: {
        dropdownObject: "register-pt-dropdown-object",
        dropdownObjectItem: $eb16d3d859ec7e6d$var$P_DROPDOWN_ITEM,
        dropdownCountry: "register-pt-dropdown-country",
        dropdownCountryItem: $eb16d3d859ec7e6d$var$P_DROPDOWN_ITEM,
        registerButton: "register-pt-register",
        nextButton: "register-pt-nex",
        emailTextInput: "register-pt-emailTextInput",
        passwordTextInput: "register-pt-passwordTextInput",
        consentCheckbox: "register-pt-consentCheckbox"
    },
    programTab: {
        programMenu: {
            goToBuilderButton: "programTab-programMenu-goToBuilder-Button",
            duplicateAsDraftButton: "programTab-programMenu-duplicateAsDraftButton",
            duplicateAsTemplateButton: "programTab-programMenu-duplicateAsTemplateButton",
            stopProgramButton: "programTab-programMenuStopProgramButton",
            deleteProgramButton: "programTab-programMenu-deleteProgramButton"
        }
    }
};

});

parcelRegister("9f2ha", function(module, exports) {

$parcel$export(module.exports, "AnimatedHalo", () => $c87007f857249124$export$1040443caa49682b);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
const $c87007f857249124$export$1040443caa49682b = ({ shouldDisplayHalo: shouldDisplayHalo = true, children: children })=>/*#__PURE__*/ (0, $iKObn.jsx)($c87007f857249124$var$MainContainer, {
        shouldDisplayHalo: shouldDisplayHalo,
        children: children
    });
const $c87007f857249124$var$MainContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(0)}
	border: ${({ shouldDisplayHalo: shouldDisplayHalo })=>shouldDisplayHalo ? "3px solid transparent" : "none"};
	border-radius: 40px;

	animation: ${({ shouldDisplayHalo: shouldDisplayHalo })=>shouldDisplayHalo ? "haloAnimation 2s infinite running" : "none"};
	animation-delay: 0.5s;
	animation-timing-function: cubic-bezier(0, 0.5, 0.5, 1);
	@keyframes haloAnimation {
		0% {
			outline: 1px solid ${(0, $kKnoQ.colors).onboardingPrimary};
			border: 3px solid ${(0, $kKnoQ.colors).onboardingPrimary};
		}
		100% {
			outline: 30px solid rgba(160, 85, 240, 0.0001);
			border: 3px solid ${(0, $kKnoQ.colors).onboardingPrimary};
		}
	}
`;

});

parcelRegister("1pD6E", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $107675f5eb9ac48f$export$d9b273488cd8ce6f);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $lbdsH = parcelRequire("lbdsH");

var $l2NC0 = parcelRequire("l2NC0");

var $k7ffa = parcelRequire("k7ffa");

var $6b4aU = parcelRequire("6b4aU");

var $9rbaG = parcelRequire("9rbaG");

var $cfkGk = parcelRequire("cfkGk");
"use client";
function $107675f5eb9ac48f$var$_extends() {
    $107675f5eb9ac48f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $107675f5eb9ac48f$var$_extends.apply(this, arguments);
}
function $107675f5eb9ac48f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $107675f5eb9ac48f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $107675f5eb9ac48f$var$_typeof(o);
}
function $107675f5eb9ac48f$var$_toPrimitive(input, hint) {
    if ($107675f5eb9ac48f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($107675f5eb9ac48f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $107675f5eb9ac48f$var$_toPropertyKey(arg) {
    var key = $107675f5eb9ac48f$var$_toPrimitive(arg, "string");
    return $107675f5eb9ac48f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $107675f5eb9ac48f$var$_defineProperty(obj, key, value) {
    key = $107675f5eb9ac48f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $107675f5eb9ac48f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $107675f5eb9ac48f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $107675f5eb9ac48f$var$_arrayLikeToArray(arr);
}
function $107675f5eb9ac48f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $107675f5eb9ac48f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $107675f5eb9ac48f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $107675f5eb9ac48f$var$_arrayLikeToArray(o, minLen);
}
function $107675f5eb9ac48f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $107675f5eb9ac48f$var$_toConsumableArray(arr) {
    return $107675f5eb9ac48f$var$_arrayWithoutHoles(arr) || $107675f5eb9ac48f$var$_iterableToArray(arr) || $107675f5eb9ac48f$var$_unsupportedIterableToArray(arr) || $107675f5eb9ac48f$var$_nonIterableSpread();
}
function $107675f5eb9ac48f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $107675f5eb9ac48f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $107675f5eb9ac48f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $107675f5eb9ac48f$var$_slicedToArray(arr, i) {
    return $107675f5eb9ac48f$var$_arrayWithHoles(arr) || $107675f5eb9ac48f$var$_iterableToArrayLimit(arr, i) || $107675f5eb9ac48f$var$_unsupportedIterableToArray(arr, i) || $107675f5eb9ac48f$var$_nonIterableRest();
}
var $107675f5eb9ac48f$var$styles = "\n@layer primereact {\n    .p-menu-overlay {\n        position: absolute;\n        /* Github #3122: Prevent animation flickering  */\n        top: -9999px;\n        left: -9999px;\n    }\n\n    .p-menu ul {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n    }\n\n    .p-menu .p-menuitem-link {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        text-decoration: none;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .p-menu .p-menuitem-text {\n        line-height: 1;\n    }\n}\n";
var $107675f5eb9ac48f$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, context = _ref.context;
        return (0, $cfkGk.classNames)("p-menu p-component", {
            "p-menu-overlay": props.popup,
            "p-input-filled": context && context.inputStyle === "filled" || (0, $8Zwsm.default).inputStyle === "filled",
            "p-ripple-disabled": context && context.ripple === false || (0, $8Zwsm.default).ripple === false
        });
    },
    menu: "p-menu-list p-reset",
    content: "p-menuitem-content",
    action: function action(_ref2) {
        var item = _ref2.item;
        return (0, $cfkGk.classNames)("p-menuitem-link", {
            "p-disabled": item.disabled
        });
    },
    menuitem: function menuitem(_ref3) {
        var focused = _ref3.focused;
        return (0, $cfkGk.classNames)("p-menuitem", {
            "p-focus": focused
        });
    },
    submenuHeader: function submenuHeader(_ref4) {
        var submenu = _ref4.submenu;
        return (0, $cfkGk.classNames)("p-submenu-header", {
            "p-disabled": submenu.disabled
        });
    },
    separator: "p-menu-separator",
    label: "p-menuitem-text",
    icon: "p-menuitem-icon",
    transition: "p-connected-overlay"
};
var $107675f5eb9ac48f$var$inlineStyles = {
    submenuHeader: function submenuHeader(_ref5) {
        var submenu = _ref5.submenu;
        return submenu.style;
    },
    menuitem: function menuitem(_ref6) {
        var item = _ref6.item;
        return item.style;
    }
};
var $107675f5eb9ac48f$var$MenuBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Menu",
        id: null,
        ariaLabel: null,
        ariaLabelledBy: null,
        tabIndex: 0,
        model: null,
        popup: false,
        popupAlignment: "left",
        style: null,
        className: null,
        autoZIndex: true,
        baseZIndex: 0,
        appendTo: null,
        onFocus: null,
        onBlur: null,
        transitionOptions: null,
        onShow: null,
        onHide: null,
        children: undefined,
        closeOnEscape: true
    },
    css: {
        classes: $107675f5eb9ac48f$var$classes,
        styles: $107675f5eb9ac48f$var$styles,
        inlineStyles: $107675f5eb9ac48f$var$inlineStyles
    }
});
function $107675f5eb9ac48f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $107675f5eb9ac48f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $107675f5eb9ac48f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $107675f5eb9ac48f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $107675f5eb9ac48f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $107675f5eb9ac48f$export$d9b273488cd8ce6f = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $107675f5eb9ac48f$var$MenuBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState(props.id), _React$useState2 = $107675f5eb9ac48f$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0], setIdState = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(!props.popup), _React$useState4 = $107675f5eb9ac48f$var$_slicedToArray(_React$useState3, 2), visibleState = _React$useState4[0], setVisibleState = _React$useState4[1];
    var _React$useState5 = $81g6h.useState(-1), _React$useState6 = $107675f5eb9ac48f$var$_slicedToArray(_React$useState5, 2), focusedOptionIndex = _React$useState6[0], setFocusedOptionIndex = _React$useState6[1];
    var _React$useState7 = $81g6h.useState(-1), _React$useState8 = $107675f5eb9ac48f$var$_slicedToArray(_React$useState7, 2), selectedOptionIndex = _React$useState8[0], setSelectedOptionIndex = _React$useState8[1];
    var _React$useState9 = $81g6h.useState(false), _React$useState10 = $107675f5eb9ac48f$var$_slicedToArray(_React$useState9, 2), focused = _React$useState10[0], setFocused = _React$useState10[1];
    var _MenuBase$setMetaData = $107675f5eb9ac48f$var$MenuBase.setMetaData({
        props: props,
        state: {
            id: idState,
            visible: visibleState,
            focused: focused
        }
    }), ptm = _MenuBase$setMetaData.ptm, cx = _MenuBase$setMetaData.cx, sx = _MenuBase$setMetaData.sx, isUnstyled = _MenuBase$setMetaData.isUnstyled;
    var getMenuItemPTOptions = function getMenuItemPTOptions(key, menuContext) {
        return ptm(key, {
            context: menuContext
        });
    };
    (0, $4gQLd.useHandleStyle)($107675f5eb9ac48f$var$MenuBase.css.styles, isUnstyled, {
        name: "menu"
    });
    var menuRef = $81g6h.useRef(null);
    var listRef = $81g6h.useRef(null);
    var targetRef = $81g6h.useRef(null);
    var isCloseOnEscape = !!(visibleState && props.popup && props.closeOnEscape);
    var popupMenuDisplayOrder = (0, $l2NC0.useDisplayOrder)("menu", isCloseOnEscape);
    (0, $l2NC0.useGlobalOnEscapeKey)({
        callback: function callback(event) {
            hide(event);
        },
        when: isCloseOnEscape && popupMenuDisplayOrder,
        priority: [
            (0, $l2NC0.ESC_KEY_HANDLING_PRIORITIES).MENU,
            popupMenuDisplayOrder
        ]
    });
    var _useOverlayListener = (0, $l2NC0.useOverlayListener)({
        target: targetRef,
        overlay: menuRef,
        listener: function listener(event, _ref) {
            var valid = _ref.valid;
            if (valid) {
                hide(event);
                setFocusedOptionIndex(-1);
            }
        },
        when: visibleState
    }), _useOverlayListener2 = $107675f5eb9ac48f$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var onPanelClick = function onPanelClick(event) {
        if (props.popup) (0, $k7ffa.OverlayService).emit("overlay-click", {
            originalEvent: event,
            target: targetRef.current
        });
    };
    var onItemClick = function onItemClick(event, item, key) {
        if (item.disabled) {
            event.preventDefault();
            return;
        }
        if (item.command) item.command({
            originalEvent: event,
            item: item
        });
        if (props.popup) hide(event);
        if (!props.popup && focusedOptionIndex !== key) setFocusedOptionIndex(key);
        if (!item.url) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    var onItemMouseMove = function onItemMouseMove(event, key) {
        if (event && props.popup && focusedOptionIndex !== key) setFocusedOptionIndex(key);
    };
    var onListFocus = function onListFocus(event) {
        setFocused(true);
        if (!props.popup) {
            if (selectedOptionIndex !== -1) {
                changeFocusedOptionIndex(selectedOptionIndex);
                setSelectedOptionIndex(-1);
            } else changeFocusedOptionIndex(0);
        }
        props.onFocus && props.onFocus(event);
    };
    var onListBlur = function onListBlur(event) {
        setFocused(false);
        setFocusedOptionIndex(-1);
        props.onBlur && props.onBlur(event);
    };
    var onListKeyDown = function onListKeyDown(event) {
        switch(event.code){
            case "ArrowDown":
                onArrowDownKey(event);
                break;
            case "ArrowUp":
                onArrowUpKey(event);
                break;
            case "Home":
                onHomeKey(event);
                break;
            case "End":
                onEndKey(event);
                break;
            case "Enter":
            case "NumpadEnter":
                onEnterKey(event);
                break;
            case "Space":
                onSpaceKey(event);
                break;
            case "Escape":
                if (props.popup) {
                    (0, $cfkGk.DomHandler).focus(targetRef.current);
                    hide(event);
                }
            case "Tab":
                props.popup && visibleState && hide(event);
                break;
        }
    };
    var onArrowDownKey = function onArrowDownKey(event) {
        var optionIndex = findNextOptionIndex(focusedOptionIndex);
        changeFocusedOptionIndex(optionIndex);
        event.preventDefault();
    };
    var onArrowUpKey = function onArrowUpKey(event) {
        if (event.altKey && props.popup) {
            (0, $cfkGk.DomHandler).focus(targetRef.current);
            hide(event);
            event.preventDefault();
        } else {
            var optionIndex = findPrevOptionIndex(focusedOptionIndex);
            changeFocusedOptionIndex(optionIndex);
            event.preventDefault();
        }
    };
    var onHomeKey = function onHomeKey(event) {
        changeFocusedOptionIndex(0);
        event.preventDefault();
    };
    var onEndKey = function onEndKey(event) {
        changeFocusedOptionIndex((0, $cfkGk.DomHandler).find(menuRef.current, 'li[data-pc-section="menuitem"][data-p-disabled="false"]').length - 1);
        event.preventDefault();
    };
    var onEnterKey = function onEnterKey(event) {
        var element = (0, $cfkGk.DomHandler).findSingle(menuRef.current, 'li[id="'.concat("".concat(focusedOptionIndex), '"]'));
        var anchorElement = element && (0, $cfkGk.DomHandler).findSingle(element, 'a[data-pc-section="action"]');
        props.popup && (0, $cfkGk.DomHandler).focus(targetRef.current);
        anchorElement ? anchorElement.click() : element && element.click();
        event.preventDefault();
    };
    var onSpaceKey = function onSpaceKey(event) {
        onEnterKey(event);
    };
    var findNextOptionIndex = function findNextOptionIndex(index) {
        var links = (0, $cfkGk.DomHandler).find(menuRef.current, 'li[data-pc-section="menuitem"][data-p-disabled="false"]');
        var matchedOptionIndex = $107675f5eb9ac48f$var$_toConsumableArray(links).findIndex(function(link) {
            return link.id === index;
        });
        return matchedOptionIndex > -1 ? matchedOptionIndex + 1 : 0;
    };
    var findPrevOptionIndex = function findPrevOptionIndex(index) {
        var links = (0, $cfkGk.DomHandler).find(menuRef.current, 'li[data-pc-section="menuitem"][data-p-disabled="false"]');
        var matchedOptionIndex = $107675f5eb9ac48f$var$_toConsumableArray(links).findIndex(function(link) {
            return link.id === index;
        });
        return matchedOptionIndex > -1 ? matchedOptionIndex - 1 : 0;
    };
    var changeFocusedOptionIndex = function changeFocusedOptionIndex(index) {
        var links = (0, $cfkGk.DomHandler).find(menuRef.current, 'li[data-pc-section="menuitem"][data-p-disabled="false"]');
        var order = index >= links.length ? links.length - 1 : index < 0 ? 0 : index;
        order > -1 && setFocusedOptionIndex(links[order].getAttribute("id"));
    };
    var focusedOptionId = function focusedOptionId() {
        return focusedOptionIndex !== -1 ? focusedOptionIndex : null;
    };
    var toggle = function toggle(event) {
        if (props.popup) visibleState ? hide(event) : show(event);
    };
    var show = function show(event) {
        targetRef.current = event.currentTarget;
        setVisibleState(true);
        props.onShow && props.onShow(event);
    };
    var hide = function hide(event) {
        targetRef.current = event.currentTarget;
        setVisibleState(false);
        props.onHide && props.onHide(event);
    };
    var onEnter = function onEnter() {
        (0, $cfkGk.DomHandler).addStyles(menuRef.current, {
            position: "absolute",
            top: "0",
            left: "0"
        });
        (0, $cfkGk.ZIndexUtils).set("menu", menuRef.current, context && context.autoZIndex || (0, $8Zwsm.default).autoZIndex, props.baseZIndex || context && context.zIndex.menu || (0, $8Zwsm.default).zIndex.menu);
        (0, $cfkGk.DomHandler).absolutePosition(menuRef.current, targetRef.current, props.popupAlignment);
        if (props.popup) {
            (0, $cfkGk.DomHandler).focus(listRef.current);
            changeFocusedOptionIndex(0);
        }
    };
    var onEntered = function onEntered() {
        bindOverlayListener();
    };
    var onExit = function onExit() {
        targetRef.current = null;
        unbindOverlayListener();
    };
    var onExited = function onExited() {
        (0, $cfkGk.ZIndexUtils).clear(menuRef.current);
    };
    (0, $l2NC0.useMountEffect)(function() {
        if (!idState) setIdState((0, $cfkGk.UniqueComponentId)());
    });
    (0, $l2NC0.useUnmountEffect)(function() {
        (0, $cfkGk.ZIndexUtils).clear(menuRef.current);
    });
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            toggle: toggle,
            show: show,
            hide: hide,
            getElement: function getElement() {
                return menuRef.current;
            },
            getTarget: function getTarget() {
                return targetRef.current;
            }
        };
    });
    var createSubmenu = function createSubmenu(submenu, index) {
        var key = idState + "_sub_" + index;
        var items = submenu.items.map(function(item, index) {
            return createMenuItem(item, index, key);
        });
        var submenuHeaderProps = mergeProps({
            id: key,
            key: key,
            role: "none",
            className: (0, $cfkGk.classNames)(submenu.className, cx("submenuHeader", {
                submenu: submenu
            })),
            style: sx("submenuHeader", {
                submenu: submenu
            }),
            "data-p-disabled": submenu.disabled
        }, ptm("submenuHeader"));
        return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, {
            key: key
        }, /*#__PURE__*/ $81g6h.createElement("li", submenuHeaderProps, submenu.label), items);
    };
    var createSeparator = function createSeparator(index) {
        var key = idState + "_separator_" + index;
        var separatorProps = mergeProps({
            id: key,
            key: key,
            className: cx("separator"),
            role: "separator"
        }, ptm("separator"));
        return /*#__PURE__*/ $81g6h.createElement("li", separatorProps);
    };
    var createMenuItem = function createMenuItem(item, index) {
        var parentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (item.visible === false) return null;
        var menuContext = {
            item: item,
            index: index,
            parentId: parentId
        };
        var linkClassName = (0, $cfkGk.classNames)("p-menuitem-link", {
            "p-disabled": item.disabled
        });
        var iconClassName = (0, $cfkGk.classNames)("p-menuitem-icon", item.icon);
        var iconProps = mergeProps({
            className: cx("icon")
        }, getMenuItemPTOptions("icon", menuContext));
        var icon = (0, $cfkGk.IconUtils).getJSXIcon(item.icon, $107675f5eb9ac48f$var$_objectSpread({}, iconProps), {
            props: props
        });
        var labelProps = mergeProps({
            className: cx("label")
        }, getMenuItemPTOptions("label", menuContext));
        var label = item.label && /*#__PURE__*/ $81g6h.createElement("span", labelProps, item.label);
        var key = item.id || (parentId || idState) + "_" + index;
        var contentProps = mergeProps({
            onClick: function onClick(event) {
                return onItemClick(event, item, key);
            },
            onMouseMove: function onMouseMove(event) {
                return onItemMouseMove(event, key);
            },
            className: cx("content")
        }, getMenuItemPTOptions("content", menuContext));
        var actionProps = mergeProps({
            href: item.url || "#",
            className: cx("action", {
                item: item
            }),
            onFocus: function onFocus(event) {
                return event.stopPropagation();
            },
            target: item.target,
            tabIndex: "-1",
            "aria-label": item.label,
            "aria-hidden": true,
            "aria-disabled": item.disabled,
            "data-p-disabled": item.disabled
        }, getMenuItemPTOptions("action", menuContext));
        var content = /*#__PURE__*/ $81g6h.createElement("div", contentProps, /*#__PURE__*/ $81g6h.createElement("a", actionProps, icon, label, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null)));
        if (item.template) {
            var defaultContentOptions = {
                onClick: function onClick(event) {
                    return onItemClick(event, item, key);
                },
                className: linkClassName,
                tabIndex: "-1",
                labelClassName: "p-menuitem-text",
                iconClassName: iconClassName,
                element: content,
                props: props
            };
            content = (0, $cfkGk.ObjectUtils).getJSXElement(item.template, item, defaultContentOptions);
        }
        var menuitemProps = mergeProps({
            id: key,
            key: key,
            className: (0, $cfkGk.classNames)(item.className, cx("menuitem", {
                focused: focusedOptionIndex === key
            })),
            style: sx("menuitem", {
                item: item
            }),
            role: "menuitem",
            "aria-label": item.label,
            "aria-disabled": item.disabled,
            "data-p-focused": focusedOptionId() === key,
            "data-p-disabled": item.disabled || false
        }, getMenuItemPTOptions("menuitem", menuContext));
        return /*#__PURE__*/ $81g6h.createElement("li", menuitemProps, content);
    };
    var createItem = function createItem(item, index) {
        return item.separator ? createSeparator(index) : item.items ? createSubmenu(item, index) : createMenuItem(item, index);
    };
    var createMenu = function createMenu() {
        return props.model.map(createItem);
    };
    var createElement = function createElement() {
        if (props.model) {
            var menuitems = createMenu();
            var rootProps = mergeProps({
                className: (0, $cfkGk.classNames)(props.className, cx("root", {
                    context: context
                })),
                style: props.style,
                onClick: function onClick(e) {
                    return onPanelClick(e);
                }
            }, $107675f5eb9ac48f$var$MenuBase.getOtherProps(props), ptm("root"));
            var menuProps = mergeProps({
                ref: listRef,
                className: cx("menu"),
                id: idState + "_list",
                tabIndex: props.tabIndex || "0",
                role: "menu",
                "aria-label": props.ariaLabel,
                "aria-labelledby": props.ariaLabelledBy,
                "aria-activedescendant": focused ? focusedOptionId() : undefined,
                onFocus: onListFocus,
                onKeyDown: onListKeyDown,
                onBlur: onListBlur
            }, ptm("menu"));
            var transitionProps = mergeProps({
                classNames: cx("transition"),
                "in": visibleState,
                timeout: {
                    enter: 120,
                    exit: 100
                },
                options: props.transitionOptions,
                unmountOnExit: true,
                onEnter: onEnter,
                onEntered: onEntered,
                onExit: onExit,
                onExited: onExited
            }, ptm("transition"));
            return /*#__PURE__*/ $81g6h.createElement((0, $lbdsH.CSSTransition), $107675f5eb9ac48f$var$_extends({
                nodeRef: menuRef
            }, transitionProps), /*#__PURE__*/ $81g6h.createElement("div", $107675f5eb9ac48f$var$_extends({
                id: props.id,
                ref: menuRef
            }, rootProps), /*#__PURE__*/ $81g6h.createElement("ul", menuProps, menuitems)));
        }
        return null;
    };
    var element = createElement();
    return props.popup ? /*#__PURE__*/ $81g6h.createElement((0, $6b4aU.Portal), {
        element: element,
        appendTo: props.appendTo
    }) : element;
}));
$107675f5eb9ac48f$export$d9b273488cd8ce6f.displayName = "Menu";

});
parcelRegister("k7ffa", function(module, exports) {

$parcel$export(module.exports, "OverlayService", () => $ea504926a234253a$export$dbec172f58a34ef1);

var $cfkGk = parcelRequire("cfkGk");
"use client";
var $ea504926a234253a$export$dbec172f58a34ef1 = (0, $cfkGk.EventBus)();

});




parcelRegister("iPFid", function(module, exports) {

$parcel$export(module.exports, "PendingPatientListingRowMobile", () => $2f21061f67d8fb37$export$43da0a8ff2c67637);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $6Yxa2 = parcelRequire("6Yxa2");

var $fUhFD = parcelRequire("fUhFD");

var $bC9c0 = parcelRequire("bC9c0");

var $5UMQ1 = parcelRequire("5UMQ1");

var $243Cr = parcelRequire("243Cr");

var $6Curj = parcelRequire("6Curj");

var $2LUd1 = parcelRequire("2LUd1");

var $970DV = parcelRequire("970DV");

var $eiBvZ = parcelRequire("eiBvZ");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");
const $2f21061f67d8fb37$export$43da0a8ff2c67637 = ({ patient: patient })=>{
    const { format: format, formatDateMed: formatDateMed } = (0, $1eHG3.useI18n)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    return /*#__PURE__*/ (0, $iKObn.jsx)($2f21061f67d8fb37$var$FlexContainer, {
        onClick: ()=>{
            (0, $bC9c0.sendAnalyticsEventViewPatientDetail)(patient.analyticsId, (0, $bC9c0.AnalyticsProgramClickType).LIST_CLICK);
            dialogContext?.openModal((0, $243Cr.ModalId).AddPatient, {
                pendingPatient: patient,
                step: (0, $eiBvZ.DialogStep).RegistrationDetails
            });
        },
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($2f21061f67d8fb37$var$Content, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)($2f21061f67d8fb37$var$KebabContainer, {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $2LUd1.PatientActionButton), {
                        patient: {
                            ...patient,
                            status: (0, $6Yxa2.PatientStatus).Pending
                        }
                    })
                }),
                /*#__PURE__*/ (0, $iKObn.jsxs)($2f21061f67d8fb37$var$PatientInformation, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)($2f21061f67d8fb37$var$PatientName, {
                            className: "p-size-s-bold",
                            children: patient.name
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsxs)($2f21061f67d8fb37$var$Row, {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                    children: format("home.pendingPatientsListing.codeRowMobile")
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                    className: "p-size-s-bold",
                                    children: patient.activationCode
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsxs)($2f21061f67d8fb37$var$Row, {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                    children: format("home.pendingPatientsListing.creationDateRowMobile")
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                    className: "p-size-s-bold",
                                    children: formatDateMed(patient.creationDate)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsxs)($2f21061f67d8fb37$var$Row, {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                    children: format("home.pendingPatientsListing.expiresInRowMobile")
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                    className: "p-size-s-bold",
                                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $6Curj.ExpirationRemainingDays), {
                                        patient: patient
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $970DV.ResendCodeButton), {
                            onClick: ()=>{
                                (0, $fUhFD.sendAnalyticsEventReinvitePatient)();
                                dialogContext?.openModal((0, $243Cr.ModalId).AddPatient, {
                                    pendingPatient: patient
                                });
                            }
                        })
                    ]
                })
            ]
        })
    });
};
const $2f21061f67d8fb37$var$FlexContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")};
	padding: 24px 32px 24px 24px;
	border-bottom: 1px solid ${(0, $kKnoQ.colors).grey25};
	cursor: pointer;
	position: relative;
`;
const $2f21061f67d8fb37$var$Content = (0, $5UMQ1.default).div`
	width: 100%;
`;
const $2f21061f67d8fb37$var$PatientInformation = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(8, "center", "flexstart")};
	overflow: hidden;
`;
const $2f21061f67d8fb37$var$PatientName = (0, $5UMQ1.default).p`
	align-self: stretch;
	overflow: hidden;
	text-overflow: ellipsis;
	margin-bottom: 10px;
`;
const $2f21061f67d8fb37$var$Row = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8)}
`;
const $2f21061f67d8fb37$var$KebabContainer = (0, $5UMQ1.default).div`
	position: absolute;
	top: 8px;
	right: 8px;
`;

});
parcelRegister("970DV", function(module, exports) {

$parcel$export(module.exports, "ResendCodeButton", () => $9bd6d46c25fa2d0d$export$5f210100dbc30a45);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
var $9bd6d46c25fa2d0d$var$RetryIcon = function RetryIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M11.842 2.002c-.537.008-1.084.058-1.637.154-4.029.707-7.285 3.925-8.03 7.947C1.004 16.448 5.866 22 12 22c5.135 0 9.378-3.89 9.938-8.879a1.009 1.009 0 0 0-1-1.121c-.5 0-.93.368-.985.865C19.52 16.87 16.118 20 12 20c-4.941 0-8.85-4.502-7.84-9.62.608-3.08 3.073-5.57 6.149-6.204a7.98 7.98 0 0 1 7.336 2.181l-1.43 1.43A.71.71 0 0 0 16.717 9H21a1 1 0 0 0 1-1V3.717a.71.71 0 0 0-1.213-.504l-1.73 1.73a9.942 9.942 0 0 0-7.215-2.941Z",
            fill: "currentColor"
        })
    });
};
$9bd6d46c25fa2d0d$var$RetryIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $9bd6d46c25fa2d0d$export$5f210100dbc30a45 = ({ onClick: onClick })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($9bd6d46c25fa2d0d$var$RetryContainer, {
        className: "p-size-s-bold",
        onClick: (event)=>{
            event.stopPropagation();
            onClick();
        },
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: format("home.pendingPatientsListing.resendCode.item")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($9bd6d46c25fa2d0d$var$RetryIcon, {
                width: "16",
                height: "16"
            })
        ]
    });
};
const $9bd6d46c25fa2d0d$var$RetryContainer = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).primary};
	display: flex;
	place-items: center;
	place-content: center;
	gap: 8px;
	padding-top: 0.5em;
	padding-bottom: 0.5em;
	cursor: pointer;
`;

});

parcelRegister("eiBvZ", function(module, exports) {

$parcel$export(module.exports, "DialogStep", () => $43dcc5a2451e5100$export$95c4f4b80f2213ca);
$parcel$export(module.exports, "AddPatientDialog", () => $43dcc5a2451e5100$export$6faa882f2b0559b8);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $fUhFD = parcelRequire("fUhFD");

var $iBbjf = parcelRequire("iBbjf");

var $5UMQ1 = parcelRequire("5UMQ1");

var $lDZlX = parcelRequire("lDZlX");

var $2Afhz = parcelRequire("2Afhz");

var $9WskH = parcelRequire("9WskH");

var $gHYu8 = parcelRequire("gHYu8");

var $7BZ59 = parcelRequire("7BZ59");

var $8AUvF = parcelRequire("8AUvF");

var $dLxEV = parcelRequire("dLxEV");

var $hbH4N = parcelRequire("hbH4N");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");

var $8Yj45 = parcelRequire("8Yj45");

var $gk3fY = parcelRequire("gk3fY");
var $43dcc5a2451e5100$export$95c4f4b80f2213ca;
(function(DialogStep) {
    DialogStep["InviteOrCreateChoice"] = "InviteOrCreateChoice";
    DialogStep["CreatePatientForm"] = "CreatePatientForm";
    DialogStep["RegistrationDetails"] = "RegistrationDetails";
    DialogStep["SendInvitationForm"] = "SendInvitationForm";
    DialogStep["InvitationConfirmed"] = "InvitationConfirmed";
    DialogStep["HealthcareTeamJoined"] = "HealthcareTeamJoined";
    DialogStep["InvitationCodeForm"] = "InvitationCodeForm";
})($43dcc5a2451e5100$export$95c4f4b80f2213ca || ($43dcc5a2451e5100$export$95c4f4b80f2213ca = {}));
const $43dcc5a2451e5100$export$6faa882f2b0559b8 = ({ ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    const [pendingPatient, setPendingPatient] = (0, $81g6h.useState)(otherProps.pendingPatient);
    const [invitationSentData, setInvitationSentData] = (0, $81g6h.useState)();
    const [healthcareTeamJoinedData, setHealthcareTeamJoinedData] = (0, $81g6h.useState)(undefined);
    const isNewlyCreatedPatient = (0, $81g6h.useMemo)(()=>(0, $lTdpc.isNil)(otherProps.pendingPatient), [
        otherProps.pendingPatient
    ]);
    const [step, setStep] = (0, $81g6h.useState)(()=>otherProps.step ?? ((0, $lTdpc.isNotNil)(pendingPatient) ? "SendInvitationForm" : "InviteOrCreateChoice"));
    const onPendingPatientCreated = (0, $81g6h.useCallback)((newPendingPatient)=>{
        setPendingPatient(newPendingPatient);
        setStep("SendInvitationForm");
    }, []);
    const onInvitationCodeSent = (0, $81g6h.useCallback)((data)=>{
        (0, $fUhFD.sendAnalyticsEventSharePatientCode)(data.sharingMethod, isNewlyCreatedPatient, (0, $lTdpc.isNotNil)(pendingPatient?.functionalStatus));
        if (data.sharingMethod === (0, $dLxEV.InvitationCodeSharingMethod).PRINT && !isNewlyCreatedPatient) otherProps.onHide();
        else {
            setInvitationSentData(data);
            setStep("InvitationConfirmed");
        }
    }, [
        isNewlyCreatedPatient,
        otherProps,
        pendingPatient?.functionalStatus
    ]);
    const dialogHeader = (0, $81g6h.useMemo)(()=>{
        switch(step){
            case "InviteOrCreateChoice":
                return format("home.addPatientDialog.inviteOrCreate.header");
            case "InvitationCodeForm":
                return format("home.addPatientDialog.invitationCodeForm.header");
            case "CreatePatientForm":
                return format("home.pendingPatientDialog.form.header.v2_6");
            case "SendInvitationForm":
                return isNewlyCreatedPatient ? format("home.pendingPatientDialog.form.header.v2_6") : format("home.pendingPatientDialog.resendCode.header");
            case "InvitationConfirmed":
                return isNewlyCreatedPatient ? format("home.pendingPatientDialog.codeSent.newPatient.header") : format("home.pendingPatientDialog.codeSent.resendCode.header");
            case "RegistrationDetails":
                return format("home.pendingPatientDialog.registrationDetails.header");
            case "HealthcareTeamJoined":
                return format("home.addPatientDialog.hctJoined.header");
        }
    }, [
        format,
        isNewlyCreatedPatient,
        step
    ]);
    const onCreateNewTemplateRequest = (0, $81g6h.useCallback)(()=>{
        (0, $iBbjf.sendAnalyticsEventCreateTemplate)((0, $iBbjf.AnalyticsTemplateLocation).PATIENT_CREATION);
        otherProps.onHide();
        navigate((0, $lDZlX.RoutesPath).TemplateBuilder);
    }, [
        navigate,
        otherProps
    ]);
    const renderStep = (0, $81g6h.useCallback)(()=>{
        switch(step){
            case "InviteOrCreateChoice":
                return /*#__PURE__*/ (0, $iKObn.jsx)((0, $8AUvF.InviteOrCreatePatient), {
                    createPatient: ()=>{
                        (0, $fUhFD.sendAnalyticsEventCreateNewPatient)();
                        setStep("CreatePatientForm");
                    },
                    joinHct: ()=>{
                        (0, $fUhFD.sendAnalyticsEventJoinExistingPatient)();
                        setStep("InvitationCodeForm");
                    }
                });
            case "CreatePatientForm":
                return /*#__PURE__*/ (0, $iKObn.jsx)((0, $2Afhz.CreatePendingPatientForm), {
                    onPendingPatientCreated: onPendingPatientCreated,
                    onBack: ()=>setStep("InviteOrCreateChoice")
                });
            case "SendInvitationForm":
                return (0, $lTdpc.isNotNil)(pendingPatient) ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $dLxEV.PendingPatientCreated), {
                    pendingPatient: pendingPatient,
                    onInvitationCodeSent: onInvitationCodeSent,
                    previousInvitationSentData: invitationSentData
                }) : null;
            case "InvitationConfirmed":
                return (0, $lTdpc.isNotNil)(pendingPatient) && (0, $lTdpc.isNotNil)(invitationSentData) ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $7BZ59.InvitationCodeSent), {
                    invitationSentData: invitationSentData,
                    pendingPatient: pendingPatient,
                    isNewlyCreatedPatient: isNewlyCreatedPatient,
                    onPressRetry: ()=>setStep("SendInvitationForm"),
                    onCreateNewTemplateRequest: onCreateNewTemplateRequest
                }) : null;
            case "RegistrationDetails":
                return (0, $lTdpc.isNotNil)(pendingPatient) ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $hbH4N.RegistrationDetailsStep), {
                    pendingPatient: pendingPatient,
                    onResend: ()=>setStep("SendInvitationForm"),
                    onCreateNewTemplateRequest: onCreateNewTemplateRequest
                }) : null;
            case "InvitationCodeForm":
                return /*#__PURE__*/ (0, $iKObn.jsx)((0, $9WskH.HctInvitationCodeForm), {
                    onConfirm: async (patientData)=>{
                        setStep("HealthcareTeamJoined");
                        setHealthcareTeamJoinedData(patientData);
                        await (0, $ghfIB.patientManager).fetchAllPatients();
                    },
                    onBack: ()=>setStep("InviteOrCreateChoice")
                });
            case "HealthcareTeamJoined":
                return (0, $lTdpc.isNotNil)(healthcareTeamJoinedData) ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $gHYu8.HealthcareTeamJoinedStep), {
                    ...healthcareTeamJoinedData
                }) : null;
        }
    }, [
        healthcareTeamJoinedData,
        invitationSentData,
        isNewlyCreatedPatient,
        onCreateNewTemplateRequest,
        onInvitationCodeSent,
        onPendingPatientCreated,
        pendingPatient,
        step
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $8Yj45.RestrictedDialog), {
        context: "AddPatient",
        width: (0, $gk3fY.DIALOG_SIZE).S,
        header: dialogHeader,
        ...otherProps,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($43dcc5a2451e5100$var$DialogContainer, {
            children: renderStep()
        })
    });
};
const $43dcc5a2451e5100$var$DialogContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("M", "flexstart", "stretch")};
	height: 100%;
`;

});
parcelRegister("iBbjf", function(module, exports) {

$parcel$export(module.exports, "AnalyticsTemplateLocation", () => $a27e6055b541eb69$export$cb0d4e45d3de7f7);
$parcel$export(module.exports, "sendAnalyticsEventViewTemplateList", () => $a27e6055b541eb69$export$82f28725494ed62);
$parcel$export(module.exports, "sendAnalyticsEventViewTemplate", () => $a27e6055b541eb69$export$475d1006859a4469);
$parcel$export(module.exports, "sendAnalyticsEventCreateTemplate", () => $a27e6055b541eb69$export$4572bba3798fcb98);
$parcel$export(module.exports, "sendAnalyticsEventSaveTemplate", () => $a27e6055b541eb69$export$dd5710da9c4f8af);
$parcel$export(module.exports, "sendAnalyticsEventEditTemplate", () => $a27e6055b541eb69$export$6e2406dd1d8ac7c3);
$parcel$export(module.exports, "sendAnalyticsEventDeleteTemplate", () => $a27e6055b541eb69$export$9656e6beb2ac883e);
$parcel$export(module.exports, "sendAnalyticsEventAssignProgram", () => $a27e6055b541eb69$export$5a23d00e35df70b7);

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");
var $a27e6055b541eb69$export$cb0d4e45d3de7f7;
(function(AnalyticsTemplateLocation) {
    AnalyticsTemplateLocation["TEMPLATE_TOP"] = "templateTop";
    AnalyticsTemplateLocation["TEMPLATE_BOTTOM"] = "templateBottom";
    AnalyticsTemplateLocation["PATIENT_CREATION"] = "patientCreation";
})($a27e6055b541eb69$export$cb0d4e45d3de7f7 || ($a27e6055b541eb69$export$cb0d4e45d3de7f7 = {}));
var $a27e6055b541eb69$var$AnalyticsTemplateClickType;
(function(AnalyticsTemplateClickType) {
    AnalyticsTemplateClickType["TEMPLATE_LIST_DETAIL"] = "templateListDetail";
    AnalyticsTemplateClickType["TEMPLATE_LIST_CLICK"] = "templateListClick";
})($a27e6055b541eb69$var$AnalyticsTemplateClickType || ($a27e6055b541eb69$var$AnalyticsTemplateClickType = {}));
const $a27e6055b541eb69$export$82f28725494ed62 = ()=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).TEMPLATE,
        action: "viewTemplateList"
    });
const $a27e6055b541eb69$export$475d1006859a4469 = (templateId, fromCardActions)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).TEMPLATE,
        action: "viewTemplate",
        params: [
            templateId,
            fromCardActions ? "templateListDetail" : "templateListClick"
        ]
    });
const $a27e6055b541eb69$export$4572bba3798fcb98 = (location)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).TEMPLATE,
        action: "createTemplate",
        params: [
            location
        ]
    });
const $a27e6055b541eb69$export$dd5710da9c4f8af = (templateId)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).TEMPLATE,
        action: "saveTemplate",
        params: [
            templateId
        ]
    });
const $a27e6055b541eb69$export$6e2406dd1d8ac7c3 = (templateId)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).TEMPLATE,
        action: "editTemplate",
        params: [
            templateId
        ]
    });
const $a27e6055b541eb69$export$9656e6beb2ac883e = (templateId)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).TEMPLATE,
        action: "deleteTemplate",
        params: [
            "templateList",
            templateId
        ]
    });
const $a27e6055b541eb69$export$5a23d00e35df70b7 = (analyticsId, programId, days, exerciseDetails)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).TEMPLATE,
        action: "assignProgram",
        params: [
            analyticsId,
            programId,
            days.sessionsPerWeek,
            days.exercisesPerWeek,
            exerciseDetails.exerciseTitles.join(";"),
            exerciseDetails.exerciseUnits.join(";"),
            exerciseDetails.exerciseSets.join(";"),
            exerciseDetails.exerciseIds.join(";"),
            exerciseDetails.exerciseRevisions.join(";"),
            exerciseDetails.exerciseCategories.join(";"),
            exerciseDetails.exerciseBodyParts.join(";"),
            exerciseDetails.exerciseDifficulties.join(";"),
            exerciseDetails.exerciseStartingPosition.join(";")
        ]
    });

});

parcelRegister("2Afhz", function(module, exports) {

$parcel$export(module.exports, "CreatePendingPatientForm", () => $675b60d899181a7b$export$ef35fb4cfde86633);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $ccjD7 = parcelRequire("ccjD7");

var $lG6Cp = parcelRequire("lG6Cp");

var $fUhFD = parcelRequire("fUhFD");

var $a6fIt = parcelRequire("a6fIt");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $8FlUV = parcelRequire("8FlUV");

var $hIci4 = parcelRequire("hIci4");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $lTdpc = parcelRequire("lTdpc");

var $68IWj = parcelRequire("68IWj");

var $eT9rN = parcelRequire("eT9rN");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");

var $i6nFl = parcelRequire("i6nFl");
const $675b60d899181a7b$export$ef35fb4cfde86633 = ({ onPendingPatientCreated: onPendingPatientCreated, onBack: onBack })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { formatFunctionalStatus: formatFunctionalStatus } = (0, $lG6Cp.useFormatMedicalCondition)();
    const [error, setError] = (0, $81g6h.useState)("");
    const [loadingSubmit, setLoadingSubmit] = (0, $81g6h.useState)(false);
    const { control: control, handleSubmit: handleSubmit } = (0, $eKUeg.useForm)({
        defaultValues: {
            functionalStatus: undefined
        },
        shouldFocusError: false
    });
    const createPendingPatient = async (formData)=>{
        try {
            setError("");
            const pendingPatient = await (0, $ghfIB.patientManager).createPendingPatient(formData);
            await (0, $ghfIB.getStartedManager).tryMarkPatientsStepAsCompleted();
            (0, $fUhFD.sendAnalyticsEventPatientCreated)(pendingPatient.analyticsId, (0, $lTdpc.isNotNil)(formData.functionalStatus));
            onPendingPatientCreated?.(pendingPatient);
        } catch (e) {
            console.error(e);
            setError(e instanceof Error ? e.message : "");
            setLoadingSubmit(false);
        }
    };
    return /*#__PURE__*/ (0, $iKObn.jsxs)($675b60d899181a7b$var$Form, {
        onSubmit: handleSubmit((data)=>{
            setLoadingSubmit(true);
            createPendingPatient(data);
        }),
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($675b60d899181a7b$var$FormContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($675b60d899181a7b$var$FormField, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                className: "p-size-m",
                                children: format("home.pendingPatientDialog.form.firstName.label")
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                                name: "firstName",
                                control: control,
                                rules: {
                                    required: format("global.form.field.requiredError")
                                },
                                render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                                ...field,
                                                "data-test": (0, $a6fIt.e2eTestId).createPatientDialog.firstNameTextInput,
                                                error: (0, $lTdpc.isNotNil)(fieldState.error),
                                                placeholder: format("home.pendingPatientDialog.form.firstName.label"),
                                                autoCapitalize: "words"
                                            }),
                                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $8FlUV.ErrorMessage), {
                                                children: error || fieldState.error?.message
                                            })
                                        ]
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($675b60d899181a7b$var$FormField, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                className: "p-size-m",
                                children: format("home.pendingPatientDialog.form.lastName.label")
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                                name: "lastName",
                                control: control,
                                rules: {
                                    required: format("global.form.field.requiredError")
                                },
                                render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                                ...field,
                                                "data-test": (0, $a6fIt.e2eTestId).createPatientDialog.lastNameTextInput,
                                                error: (0, $lTdpc.isNotNil)(fieldState.error),
                                                placeholder: format("home.pendingPatientDialog.form.lastName.label"),
                                                autoCapitalize: "words"
                                            }),
                                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $8FlUV.ErrorMessage), {
                                                children: error || fieldState.error?.message
                                            })
                                        ]
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $i6nFl.Panel), {
                        variant: "compact",
                        headerText: format("home.pendingPatientDialog.form.additionalFields"),
                        collapsed: true,
                        children: /*#__PURE__*/ (0, $iKObn.jsxs)($675b60d899181a7b$var$FormField, {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                    className: "p-size-m",
                                    children: format("home.pendingPatientDialog.form.functionalStatus.label")
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                                    name: "functionalStatus",
                                    control: control,
                                    render: ({ field: field })=>/*#__PURE__*/ (0, $iKObn.jsx)($675b60d899181a7b$var$StyledDropdown, {
                                            id: (0, $a6fIt.e2eTestId).createPatientDialog.dropdownFunctionalStatus,
                                            options: (0, $ccjD7.functionalStatuses).map((type, index)=>({
                                                    id: index,
                                                    value: type,
                                                    label: formatFunctionalStatus(type)
                                                })),
                                            placeholder: format("global.form.dropdown.placeholder"),
                                            ...field,
                                            optionLabel: "label",
                                            optionValue: "value",
                                            appendTo: "self"
                                        })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($675b60d899181a7b$var$FormField, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                            name: "dataConsent",
                            control: control,
                            rules: {
                                required: format("home.pendingPatientDialog.form.dataConsent.required")
                            },
                            render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $iKObn.jsxs)($675b60d899181a7b$var$CheckboxContainer, {
                                            "data-test": (0, $a6fIt.e2eTestId).createPatientDialog.consentCheckbox,
                                            children: [
                                                /*#__PURE__*/ (0, $iKObn.jsx)((0, $68IWj.Checkbox), {
                                                    style: {
                                                        zIndex: 0
                                                    },
                                                    id: "data-consent-checkbox",
                                                    inputId: "dataConsentCheckbox",
                                                    ...field,
                                                    checked: field.value
                                                }),
                                                /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                                    htmlFor: "dataConsentCheckbox",
                                                    children: format("home.pendingPatientDialog.form.dataConsent.label")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $8FlUV.ErrorMessage), {
                                            children: error || fieldState.error?.message
                                        })
                                    ]
                                })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($675b60d899181a7b$var$ButtonContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                        uiStyle: "secondary",
                        label: format("global.dialog.back"),
                        onClick: onBack
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                        "data-test": (0, $a6fIt.e2eTestId).createPatientDialog.submitButton,
                        loading: loadingSubmit,
                        label: format("home.pendingPatientDialog.form.submitButton"),
                        type: "submit"
                    })
                ]
            })
        ]
    });
};
const $675b60d899181a7b$var$ButtonContainer = (0, $5UMQ1.default).div`
	padding-top: 16px;
	${(0, $5WGN2.row)("S", "spacebetween")};
`;
const $675b60d899181a7b$var$FormField = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("S", "flexstart", "stretch")};
`;
const $675b60d899181a7b$var$Form = (0, $5UMQ1.default).form`
	${(0, $5WGN2.stack)("M", "spacebetween", "stretch")};
	height: 100%;
`;
const $675b60d899181a7b$var$FormContainer = (0, $5UMQ1.default).form`
	${(0, $5WGN2.stack)("M", "flexstart", "stretch")}
`;
const $675b60d899181a7b$var$StyledDropdown = (0, $5UMQ1.default)((0, $eT9rN.Dropdown))`
	max-width: 330px;
`;
const $675b60d899181a7b$var$CheckboxContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("S", "flexstart")}
`;

});
parcelRegister("lG6Cp", function(module, exports) {

$parcel$export(module.exports, "useFormatMedicalCondition", () => $6240450ca12c39ed$export$34ac3542497d9a58);
$parcel$export(module.exports, "useSortedDiseaseList", () => $6240450ca12c39ed$export$f794ec9cfadeecb);

var $1eHG3 = parcelRequire("1eHG3");

var $ccjD7 = parcelRequire("ccjD7");

var $81g6h = parcelRequire("81g6h");
const $6240450ca12c39ed$var$diseaseWordingKey = {
    [(0, $ccjD7.Disease).IDK]: "disease.idk",
    [(0, $ccjD7.Disease).PREFER_NOT_TO_SAY]: "disease.v1_9.preferNotToSay",
    [(0, $ccjD7.Disease).OTHER]: "disease.v1_9.other",
    [(0, $ccjD7.Disease).SMA]: "disease.v1_9.sma",
    [(0, $ccjD7.Disease).ALS]: "disease.v1_9.als",
    [(0, $ccjD7.Disease).BMD]: "disease.v1_9.bmd",
    [(0, $ccjD7.Disease).FSHD]: "disease.fshd",
    [(0, $ccjD7.Disease).LGMD]: "disease.v1_9.lgmd",
    [(0, $ccjD7.Disease).CMT]: "disease.v1_9.cmt",
    [(0, $ccjD7.Disease).OTHER_MUSCULAR_DYSTROPHY]: "disease.v1_9.otherMuscularDystrophy",
    [(0, $ccjD7.Disease).MYASTHENIA]: "disease.v1_9.myasthenia",
    [(0, $ccjD7.Disease).NEUROPATHY]: "disease.v1_9.neuropathy",
    [(0, $ccjD7.Disease).MYOPATHY]: "disease.v1_9.myopathy",
    [(0, $ccjD7.Disease).METABOLIC_DISORDERS]: "disease.v1_9.metabolicDisorders",
    [(0, $ccjD7.Disease).FRIEDREICH_ATAXIA]: "disease.friedreichAtaxia",
    [(0, $ccjD7.Disease).MULTIPLE_SCLEROSIS]: "disease.multipleSclerosis"
};
const $6240450ca12c39ed$var$functionalStatusWordingKey = {
    [(0, $ccjD7.FunctionalStatus).Walker]: "functionalStatus.walker",
    [(0, $ccjD7.FunctionalStatus).Sitter]: "functionalStatus.sitter"
};
const $6240450ca12c39ed$export$34ac3542497d9a58 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const formatDisease = (0, $81g6h.useCallback)((disease)=>{
        if (disease && disease !== (0, $ccjD7.Disease).IDK) return format($6240450ca12c39ed$var$diseaseWordingKey[disease]);
        else return format("global.empty");
    }, [
        format
    ]);
    const formatFunctionalStatus = (0, $81g6h.useCallback)((functionalStatus)=>{
        if (functionalStatus) return format($6240450ca12c39ed$var$functionalStatusWordingKey[functionalStatus]);
        else return format("global.empty");
    }, [
        format
    ]);
    return {
        formatDisease: formatDisease,
        formatFunctionalStatus: formatFunctionalStatus
    };
};
const $6240450ca12c39ed$export$f794ec9cfadeecb = ()=>{
    const { formatDisease: formatDisease } = $6240450ca12c39ed$export$34ac3542497d9a58();
    const collator = new Intl.Collator();
    const [idkChoice, preferNotToSayChoice, otherChoice, ...choicesToSort] = (0, $ccjD7.diseases).map((value)=>({
            value: value,
            label: formatDisease(value)
        }));
    return [
        ...choicesToSort.sort((d1, d2)=>collator.compare(d1.label, d2.label)),
        preferNotToSayChoice,
        otherChoice,
        idkChoice
    ];
};

});

parcelRegister("8FlUV", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", () => $e8fbe53ac5543580$export$915e9e7bd4f0f96d);

var $iKObn = parcelRequire("iKObn");

var $dDMmD = parcelRequire("dDMmD");
var $dU78w = parcelRequire("dU78w");

var $cfkGk = parcelRequire("cfkGk");
parcelRequire("81g6h");
const $e8fbe53ac5543580$export$915e9e7bd4f0f96d = ({ children: children, className: className, ...props })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $dDMmD.AnimatePresence), {
        children: !!children && /*#__PURE__*/ (0, $iKObn.jsx)((0, $dU78w.motion).div, {
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            exit: {
                opacity: 0
            },
            className: (0, $cfkGk.classNames)("p-error", className),
            ...props,
            children: children
        })
    });

});

parcelRegister("hIci4", function(module, exports) {

$parcel$export(module.exports, "TextInput", () => $beaaa2ff4425f06f$export$c86715117507e8e5);
$parcel$export(module.exports, "TextArea", () => $beaaa2ff4425f06f$export$f5c9f3c2c4054eec);
$parcel$export(module.exports, "PasswordInput", () => $beaaa2ff4425f06f$export$b28585a458fee016);
$parcel$export(module.exports, "FormEmailInput", () => $beaaa2ff4425f06f$export$2ecc569fd2842c6c);
$parcel$export(module.exports, "SmallTextInput", () => $beaaa2ff4425f06f$export$238b417891ec5154);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");

var $kI5xQ = parcelRequire("kI5xQ");

var $6ccvc = parcelRequire("6ccvc");

var $1sbGw = parcelRequire("1sbGw");

var $3pC8l = parcelRequire("3pC8l");

var $cfkGk = parcelRequire("cfkGk");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
const $beaaa2ff4425f06f$export$c86715117507e8e5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ error: error, className: className, ...props }, ref)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $6ccvc.InputText), {
        ref: ref,
        className: (0, $cfkGk.classNames)({
            "p-invalid": !!error
        }, className),
        ...props
    }));
$beaaa2ff4425f06f$export$c86715117507e8e5.displayName = "TextInput";
const $beaaa2ff4425f06f$export$f5c9f3c2c4054eec = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ error: error, className: className, ...props }, ref)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $1sbGw.InputTextarea), {
        ref: ref,
        className: (0, $cfkGk.classNames)({
            "p-invalid": !!error
        }, className),
        ...props
    }));
$beaaa2ff4425f06f$export$f5c9f3c2c4054eec.displayName = "TextArea";
const $beaaa2ff4425f06f$export$b28585a458fee016 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ error: error, className: className, inputRef: inputRef, ...props })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $3pC8l.Password), {
        inputRef: inputRef,
        toggleMask: true,
        feedback: false,
        className: (0, $cfkGk.classNames)({
            "p-invalid": !!error
        }, className),
        ...props
    }));
$beaaa2ff4425f06f$export$b28585a458fee016.displayName = "PasswordInput";
const $beaaa2ff4425f06f$export$2ecc569fd2842c6c = ({ control: control, error: error, wording: wording })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
        name: "email",
        control: control,
        rules: {
            required: wording.requiredError,
            pattern: {
                value: (0, $kI5xQ.REGEX_EMAIL),
                message: wording.formatError
            }
        },
        render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)($beaaa2ff4425f06f$export$c86715117507e8e5, {
                ...field,
                placeholder: wording.placeholder,
                error: fieldState.invalid || !!error,
                inputMode: "email",
                autoCorrect: "off",
                autoCapitalize: "none"
            })
    });
const $beaaa2ff4425f06f$export$238b417891ec5154 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, $iKObn.jsx)($beaaa2ff4425f06f$var$Input, {
        ref: ref,
        className: (0, $cfkGk.classNames)("p-size-s-bold", className),
        ...props
    }));
$beaaa2ff4425f06f$export$238b417891ec5154.displayName = "SmallTextInput";
const $beaaa2ff4425f06f$var$Input = (0, $5UMQ1.default).input`
	appearance: none;
	border-radius: 7px;
	padding: 0;
	max-width: 1.2rem;
	height: 1.375rem;

	border: none;

	background-color: ${(0, $kKnoQ.colors).primaryBackground};
	color: ${(0, $kKnoQ.colors).grey};

	&:focus {
		outline: 0;
	}
`;

});
parcelRegister("kI5xQ", function(module, exports) {

$parcel$export(module.exports, "REGEX_EMAIL", () => $3e93f61751daf27c$export$13868b9442c40eb1);
$parcel$export(module.exports, "REGEX_CONFIRMATION_CODE_DIGIT", () => $3e93f61751daf27c$export$c2e3fe2828817e1f);
$parcel$export(module.exports, "REGEX_CONFIRMATION_CODE", () => $3e93f61751daf27c$export$1ced4907ae37042d);
const $3e93f61751daf27c$export$13868b9442c40eb1 = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/;
const $3e93f61751daf27c$export$c2e3fe2828817e1f = /\d/;
const $3e93f61751daf27c$export$1ced4907ae37042d = /\d{6}/;

});

parcelRegister("6ccvc", function(module, exports) {

$parcel$export(module.exports, "InputText", () => $482d8fc3f077ba39$export$7034fcb7d6351061);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $hyFEk = parcelRequire("hyFEk");

var $7hMfd = parcelRequire("7hMfd");

var $cfkGk = parcelRequire("cfkGk");
"use client";
function $482d8fc3f077ba39$var$_extends() {
    $482d8fc3f077ba39$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $482d8fc3f077ba39$var$_extends.apply(this, arguments);
}
function $482d8fc3f077ba39$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $482d8fc3f077ba39$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $482d8fc3f077ba39$var$_typeof(o);
}
function $482d8fc3f077ba39$var$_toPrimitive(input, hint) {
    if ($482d8fc3f077ba39$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($482d8fc3f077ba39$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $482d8fc3f077ba39$var$_toPropertyKey(arg) {
    var key = $482d8fc3f077ba39$var$_toPrimitive(arg, "string");
    return $482d8fc3f077ba39$var$_typeof(key) === "symbol" ? key : String(key);
}
function $482d8fc3f077ba39$var$_defineProperty(obj, key, value) {
    key = $482d8fc3f077ba39$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $482d8fc3f077ba39$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, isFilled = _ref.isFilled, context = _ref.context;
        return (0, $cfkGk.classNames)("p-inputtext p-component", {
            "p-disabled": props.disabled,
            "p-filled": isFilled,
            "p-invalid": props.invalid,
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled"
        });
    }
};
var $482d8fc3f077ba39$var$InputTextBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "InputText",
        __parentMetadata: null,
        children: undefined,
        className: null,
        invalid: false,
        variant: null,
        keyfilter: null,
        onBeforeInput: null,
        onInput: null,
        onKeyDown: null,
        onPaste: null,
        tooltip: null,
        tooltipOptions: null,
        validateOnly: false
    },
    css: {
        classes: $482d8fc3f077ba39$var$classes
    }
});
function $482d8fc3f077ba39$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $482d8fc3f077ba39$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $482d8fc3f077ba39$var$ownKeys(Object(t), !0).forEach(function(r) {
            $482d8fc3f077ba39$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $482d8fc3f077ba39$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $482d8fc3f077ba39$export$7034fcb7d6351061 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $482d8fc3f077ba39$var$InputTextBase.getProps(inProps, context);
    var _InputTextBase$setMet = $482d8fc3f077ba39$var$InputTextBase.setMetaData($482d8fc3f077ba39$var$_objectSpread($482d8fc3f077ba39$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        context: {
            disabled: props.disabled
        }
    })), ptm = _InputTextBase$setMet.ptm, cx = _InputTextBase$setMet.cx, isUnstyled = _InputTextBase$setMet.isUnstyled;
    (0, $4gQLd.useHandleStyle)($482d8fc3f077ba39$var$InputTextBase.css.styles, isUnstyled, {
        name: "inputtext",
        styled: true
    });
    var elementRef = $81g6h.useRef(ref);
    var onKeyDown = function onKeyDown(event) {
        props.onKeyDown && props.onKeyDown(event);
        if (props.keyfilter) (0, $hyFEk.KeyFilter).onKeyPress(event, props.keyfilter, props.validateOnly);
    };
    var onBeforeInput = function onBeforeInput(event) {
        props.onBeforeInput && props.onBeforeInput(event);
        if (props.keyfilter) (0, $hyFEk.KeyFilter).onBeforeInput(event, props.keyfilter, props.validateOnly);
    };
    var onInput = function onInput(event) {
        var target = event.target;
        var validatePattern = true;
        if (props.keyfilter && props.validateOnly) validatePattern = (0, $hyFEk.KeyFilter).validate(event, props.keyfilter);
        props.onInput && props.onInput(event, validatePattern);
        // for uncontrolled changes
        (0, $cfkGk.ObjectUtils).isNotEmpty(target.value) ? (0, $cfkGk.DomHandler).addClass(target, "p-filled") : (0, $cfkGk.DomHandler).removeClass(target, "p-filled");
    };
    var onPaste = function onPaste(event) {
        props.onPaste && props.onPaste(event);
        if (props.keyfilter) (0, $hyFEk.KeyFilter).onPaste(event, props.keyfilter, props.validateOnly);
    };
    $81g6h.useEffect(function() {
        (0, $cfkGk.ObjectUtils).combinedRefs(elementRef, ref);
    }, [
        elementRef,
        ref
    ]);
    var isFilled = $81g6h.useMemo(function() {
        return (0, $cfkGk.ObjectUtils).isNotEmpty(props.value) || (0, $cfkGk.ObjectUtils).isNotEmpty(props.defaultValue);
    }, [
        props.value,
        props.defaultValue
    ]);
    var hasTooltip = (0, $cfkGk.ObjectUtils).isNotEmpty(props.tooltip);
    var rootProps = mergeProps({
        className: (0, $cfkGk.classNames)(props.className, cx("root", {
            context: context,
            isFilled: isFilled
        })),
        onBeforeInput: onBeforeInput,
        onInput: onInput,
        onKeyDown: onKeyDown,
        onPaste: onPaste
    }, $482d8fc3f077ba39$var$InputTextBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("input", $482d8fc3f077ba39$var$_extends({
        ref: elementRef
    }, rootProps)), hasTooltip && /*#__PURE__*/ $81g6h.createElement((0, $7hMfd.Tooltip), $482d8fc3f077ba39$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$482d8fc3f077ba39$export$7034fcb7d6351061.displayName = "InputText";

});
parcelRegister("hyFEk", function(module, exports) {

$parcel$export(module.exports, "KeyFilter", () => $cc85eb5d7e824d5d$export$9dbdc44a13de1b0d);

var $cfkGk = parcelRequire("cfkGk");
"use client";
function $cc85eb5d7e824d5d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cc85eb5d7e824d5d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cc85eb5d7e824d5d$var$_arrayLikeToArray(arr);
}
function $cc85eb5d7e824d5d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $cc85eb5d7e824d5d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cc85eb5d7e824d5d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cc85eb5d7e824d5d$var$_arrayLikeToArray(o, minLen);
}
function $cc85eb5d7e824d5d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cc85eb5d7e824d5d$var$_toConsumableArray(arr) {
    return $cc85eb5d7e824d5d$var$_arrayWithoutHoles(arr) || $cc85eb5d7e824d5d$var$_iterableToArray(arr) || $cc85eb5d7e824d5d$var$_unsupportedIterableToArray(arr) || $cc85eb5d7e824d5d$var$_nonIterableSpread();
}
var $cc85eb5d7e824d5d$export$9dbdc44a13de1b0d = {
    /* eslint-disable */ DEFAULT_MASKS: {
        pint: /[\d]/,
        "int": /[\d\-]/,
        pnum: /[\d\.]/,
        money: /[\d\.\s,]/,
        num: /[\d\-\.]/,
        hex: /[0-9a-f]/i,
        email: /[a-z0-9_\.\-@]/i,
        alpha: /[a-z_]/i,
        alphanum: /[a-z0-9_]/i
    },
    /* eslint-enable */ getRegex: function getRegex(keyfilter) {
        return $cc85eb5d7e824d5d$export$9dbdc44a13de1b0d.DEFAULT_MASKS[keyfilter] ? $cc85eb5d7e824d5d$export$9dbdc44a13de1b0d.DEFAULT_MASKS[keyfilter] : keyfilter;
    },
    onBeforeInput: function onBeforeInput(e, keyfilter, validateOnly) {
        // android devices must use beforeinput https://stackoverflow.com/questions/36753548/keycode-on-android-is-always-229
        if (validateOnly || !(0, $cfkGk.DomHandler).isAndroid()) return;
        this.validateKey(e, e.data, keyfilter);
    },
    onKeyPress: function onKeyPress(e, keyfilter, validateOnly) {
        // non android devices use keydown
        if (validateOnly || (0, $cfkGk.DomHandler).isAndroid()) return;
        if (e.ctrlKey || e.altKey || e.metaKey) return;
        this.validateKey(e, e.key, keyfilter);
    },
    onPaste: function onPaste(e, keyfilter, validateOnly) {
        if (validateOnly) return;
        var regex = this.getRegex(keyfilter);
        var clipboard = e.clipboardData.getData("text");
        // loop over each letter pasted and if any fail prevent the paste
        $cc85eb5d7e824d5d$var$_toConsumableArray(clipboard).forEach(function(c) {
            if (!regex.test(c)) {
                e.preventDefault();
                return false;
            }
        });
    },
    validateKey: function validateKey(e, key, keyfilter) {
        if (key === null || key === undefined) return;
        // some AZERTY keys come in with 2 chars like ´ç if Dead key is pressed first
        var isPrintableKey = key.length <= 2;
        if (!isPrintableKey) return;
        var regex = this.getRegex(keyfilter);
        if (!regex.test(key)) e.preventDefault();
    },
    validate: function validate(e, keyfilter) {
        var value = e.target.value;
        var validatePattern = true;
        var regex = this.getRegex(keyfilter);
        if (value && !regex.test(value)) validatePattern = false;
        return validatePattern;
    }
};

});


parcelRegister("1sbGw", function(module, exports) {

$parcel$export(module.exports, "InputTextarea", () => $10f1785437f83b8e$export$3d88bd58d836b21e);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $hyFEk = parcelRequire("hyFEk");

var $7hMfd = parcelRequire("7hMfd");

var $cfkGk = parcelRequire("cfkGk");
"use client";
function $10f1785437f83b8e$var$_extends() {
    $10f1785437f83b8e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $10f1785437f83b8e$var$_extends.apply(this, arguments);
}
function $10f1785437f83b8e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $10f1785437f83b8e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $10f1785437f83b8e$var$_typeof(o);
}
function $10f1785437f83b8e$var$_toPrimitive(input, hint) {
    if ($10f1785437f83b8e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($10f1785437f83b8e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $10f1785437f83b8e$var$_toPropertyKey(arg) {
    var key = $10f1785437f83b8e$var$_toPrimitive(arg, "string");
    return $10f1785437f83b8e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $10f1785437f83b8e$var$_defineProperty(obj, key, value) {
    key = $10f1785437f83b8e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $10f1785437f83b8e$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, context = _ref.context, isFilled = _ref.isFilled;
        return (0, $cfkGk.classNames)("p-inputtextarea p-inputtext p-component", {
            "p-disabled": props.disabled,
            "p-filled": isFilled,
            "p-inputtextarea-resizable": props.autoResize,
            "p-invalid": props.invalid,
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled"
        });
    }
};
var $10f1785437f83b8e$var$styles = "\n@layer primereact {\n    .p-inputtextarea-resizable {\n        overflow: hidden;\n        resize: none;\n    }\n    \n    .p-fluid .p-inputtextarea {\n        width: 100%;\n    }\n}\n";
var $10f1785437f83b8e$var$InputTextareaBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "InputTextarea",
        __parentMetadata: null,
        autoResize: false,
        invalid: false,
        variant: null,
        keyfilter: null,
        onBlur: null,
        onFocus: null,
        onBeforeInput: null,
        onInput: null,
        onKeyDown: null,
        onKeyUp: null,
        onPaste: null,
        tooltip: null,
        tooltipOptions: null,
        validateOnly: false,
        children: undefined
    },
    css: {
        classes: $10f1785437f83b8e$var$classes,
        styles: $10f1785437f83b8e$var$styles
    }
});
function $10f1785437f83b8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $10f1785437f83b8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $10f1785437f83b8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $10f1785437f83b8e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $10f1785437f83b8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $10f1785437f83b8e$export$3d88bd58d836b21e = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $10f1785437f83b8e$var$InputTextareaBase.getProps(inProps, context);
    var elementRef = $81g6h.useRef(ref);
    var cachedScrollHeight = $81g6h.useRef(0);
    var _InputTextareaBase$se = $10f1785437f83b8e$var$InputTextareaBase.setMetaData($10f1785437f83b8e$var$_objectSpread($10f1785437f83b8e$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        context: {
            disabled: props.disabled
        }
    })), ptm = _InputTextareaBase$se.ptm, cx = _InputTextareaBase$se.cx, isUnstyled = _InputTextareaBase$se.isUnstyled;
    (0, $4gQLd.useHandleStyle)($10f1785437f83b8e$var$InputTextareaBase.css.styles, isUnstyled, {
        name: "inputtextarea"
    });
    var onFocus = function onFocus(event) {
        if (props.autoResize) resize();
        props.onFocus && props.onFocus(event);
    };
    var onBlur = function onBlur(event) {
        if (props.autoResize) resize();
        props.onBlur && props.onBlur(event);
    };
    var onKeyUp = function onKeyUp(event) {
        if (props.autoResize) resize();
        props.onKeyUp && props.onKeyUp(event);
    };
    var onKeyDown = function onKeyDown(event) {
        props.onKeyDown && props.onKeyDown(event);
        if (props.keyfilter) (0, $hyFEk.KeyFilter).onKeyPress(event, props.keyfilter, props.validateOnly);
    };
    var onBeforeInput = function onBeforeInput(event) {
        props.onBeforeInput && props.onBeforeInput(event);
        if (props.keyfilter) (0, $hyFEk.KeyFilter).onBeforeInput(event, props.keyfilter, props.validateOnly);
    };
    var onPaste = function onPaste(event) {
        props.onPaste && props.onPaste(event);
        if (props.keyfilter) (0, $hyFEk.KeyFilter).onPaste(event, props.keyfilter, props.validateOnly);
    };
    var onInput = function onInput(event) {
        var target = event.target;
        if (props.autoResize) resize((0, $cfkGk.ObjectUtils).isEmpty(target.value));
        props.onInput && props.onInput(event);
        (0, $cfkGk.ObjectUtils).isNotEmpty(target.value) ? (0, $cfkGk.DomHandler).addClass(target, "p-filled") : (0, $cfkGk.DomHandler).removeClass(target, "p-filled");
    };
    var resize = function resize(initial) {
        var inputEl = elementRef.current;
        if (inputEl && (0, $cfkGk.DomHandler).isVisible(inputEl)) {
            if (!cachedScrollHeight.current) {
                cachedScrollHeight.current = inputEl.scrollHeight;
                inputEl.style.overflow = "hidden";
            }
            if (cachedScrollHeight.current !== inputEl.scrollHeight || initial) {
                inputEl.style.height = "";
                inputEl.style.height = inputEl.scrollHeight + "px";
                if (parseFloat(inputEl.style.height) >= parseFloat(inputEl.style.maxHeight)) {
                    inputEl.style.overflowY = "scroll";
                    inputEl.style.height = inputEl.style.maxHeight;
                } else inputEl.style.overflow = "hidden";
                cachedScrollHeight.current = inputEl.scrollHeight;
            }
        }
    };
    $81g6h.useEffect(function() {
        (0, $cfkGk.ObjectUtils).combinedRefs(elementRef, ref);
    }, [
        elementRef,
        ref
    ]);
    $81g6h.useEffect(function() {
        if (props.autoResize) resize(true);
    }, [
        props.autoResize
    ]);
    var isFilled = $81g6h.useMemo(function() {
        return (0, $cfkGk.ObjectUtils).isNotEmpty(props.value) || (0, $cfkGk.ObjectUtils).isNotEmpty(props.defaultValue);
    }, [
        props.value,
        props.defaultValue
    ]);
    var hasTooltip = (0, $cfkGk.ObjectUtils).isNotEmpty(props.tooltip);
    var rootProps = mergeProps({
        ref: elementRef,
        className: (0, $cfkGk.classNames)(props.className, cx("root", {
            context: context,
            isFilled: isFilled
        })),
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onBeforeInput: onBeforeInput,
        onInput: onInput,
        onPaste: onPaste
    }, $10f1785437f83b8e$var$InputTextareaBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("textarea", rootProps), hasTooltip && /*#__PURE__*/ $81g6h.createElement((0, $7hMfd.Tooltip), $10f1785437f83b8e$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$10f1785437f83b8e$export$3d88bd58d836b21e.displayName = "InputTextarea";

});

parcelRegister("3pC8l", function(module, exports) {

$parcel$export(module.exports, "Password", () => $27c1496b97a87888$export$5e47cc20a502b05f);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $lbdsH = parcelRequire("lbdsH");

var $l2NC0 = parcelRequire("l2NC0");

var $cfkGk = parcelRequire("cfkGk");

var $5GLnM = parcelRequire("5GLnM");

var $1TaAN = parcelRequire("1TaAN");

var $6ccvc = parcelRequire("6ccvc");

var $k7ffa = parcelRequire("k7ffa");

var $6b4aU = parcelRequire("6b4aU");
"use client";
function $27c1496b97a87888$var$_extends() {
    $27c1496b97a87888$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $27c1496b97a87888$var$_extends.apply(this, arguments);
}
function $27c1496b97a87888$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $27c1496b97a87888$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $27c1496b97a87888$var$_typeof(o);
}
function $27c1496b97a87888$var$_toPrimitive(input, hint) {
    if ($27c1496b97a87888$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($27c1496b97a87888$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $27c1496b97a87888$var$_toPropertyKey(arg) {
    var key = $27c1496b97a87888$var$_toPrimitive(arg, "string");
    return $27c1496b97a87888$var$_typeof(key) === "symbol" ? key : String(key);
}
function $27c1496b97a87888$var$_defineProperty(obj, key, value) {
    key = $27c1496b97a87888$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $27c1496b97a87888$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $27c1496b97a87888$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $27c1496b97a87888$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $27c1496b97a87888$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $27c1496b97a87888$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $27c1496b97a87888$var$_arrayLikeToArray(o, minLen);
}
function $27c1496b97a87888$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $27c1496b97a87888$var$_slicedToArray(arr, i) {
    return $27c1496b97a87888$var$_arrayWithHoles(arr) || $27c1496b97a87888$var$_iterableToArrayLimit(arr, i) || $27c1496b97a87888$var$_unsupportedIterableToArray(arr, i) || $27c1496b97a87888$var$_nonIterableRest();
}
var $27c1496b97a87888$var$classes$2 = {
    root: function root(_ref) {
        var props = _ref.props;
        return (0, $cfkGk.classNames)("p-icon-field", {
            "p-icon-field-right": props.iconPosition === "right",
            "p-icon-field-left": props.iconPosition === "left"
        });
    }
};
var $27c1496b97a87888$var$IconFieldBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "IconField",
        __parentMetadata: null,
        children: undefined,
        className: null,
        iconPosition: "right"
    },
    css: {
        classes: $27c1496b97a87888$var$classes$2
    }
});
function $27c1496b97a87888$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $27c1496b97a87888$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $27c1496b97a87888$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $27c1496b97a87888$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $27c1496b97a87888$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $27c1496b97a87888$var$IconField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(function(inProps, ref) {
    var elementRef = (0, $81g6h.useRef)(ref);
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = (0, $81g6h.useContext)((0, $8Zwsm.PrimeReactContext));
    var props = $27c1496b97a87888$var$IconFieldBase.getProps(inProps, context);
    var _IconFieldBase$setMet = $27c1496b97a87888$var$IconFieldBase.setMetaData($27c1496b97a87888$var$_objectSpread$2($27c1496b97a87888$var$_objectSpread$2({
        props: props
    }, props.__parentMetadata), {}, {
        context: {
            iconPosition: props.iconPosition
        }
    })), ptm = _IconFieldBase$setMet.ptm, cx = _IconFieldBase$setMet.cx;
    var rootProps = mergeProps({
        className: (0, $cfkGk.classNames)(props.className, cx("root", {
            iconPosition: props.iconPosition
        }))
    }, $27c1496b97a87888$var$IconFieldBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("div", $27c1496b97a87888$var$_extends({}, rootProps, {
        ref: elementRef
    }), props.children);
}));
$27c1496b97a87888$var$IconField.displayName = "IconField";
var $27c1496b97a87888$var$classes$1 = {
    root: "p-input-icon"
};
var $27c1496b97a87888$var$InputIconBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "InputIcon",
        __parentMetadata: null,
        className: null
    },
    css: {
        classes: $27c1496b97a87888$var$classes$1
    }
});
function $27c1496b97a87888$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $27c1496b97a87888$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $27c1496b97a87888$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $27c1496b97a87888$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $27c1496b97a87888$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $27c1496b97a87888$var$InputIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(function(inProps, ref) {
    var elementRef = (0, $81g6h.useRef)(ref);
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = (0, $81g6h.useContext)((0, $8Zwsm.PrimeReactContext));
    var props = $27c1496b97a87888$var$InputIconBase.getProps(inProps, context);
    var _InputIconBase$setMet = $27c1496b97a87888$var$InputIconBase.setMetaData($27c1496b97a87888$var$_objectSpread$1({
        props: props
    }, props.__parentMetadata)), ptm = _InputIconBase$setMet.ptm, cx = _InputIconBase$setMet.cx;
    var rootProps = mergeProps({
        className: (0, $cfkGk.classNames)(props.className, cx("root"))
    }, $27c1496b97a87888$var$InputIconBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("span", $27c1496b97a87888$var$_extends({}, rootProps, {
        ref: elementRef
    }), props.children));
}));
$27c1496b97a87888$var$InputIcon.displayName = "InputIcon";
var $27c1496b97a87888$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, isFilled = _ref.isFilled, focusedState = _ref.focusedState;
        return (0, $cfkGk.classNames)("p-password p-component p-inputwrapper", {
            "p-inputwrapper-filled": isFilled,
            "p-inputwrapper-focus": focusedState,
            "p-input-icon-right": props.toggleMask
        });
    },
    input: function input(_ref2) {
        var props = _ref2.props;
        return (0, $cfkGk.classNames)("p-password-input", props.inputClassName);
    },
    panel: function panel(_ref3) {
        var props = _ref3.props, context = _ref3.context;
        return (0, $cfkGk.classNames)("p-password-panel p-component", props.panelClassName, {
            "p-input-filled": context && context.inputStyle === "filled" || (0, $8Zwsm.default).inputStyle === "filled",
            "p-ripple-disabled": context && context.ripple === false || (0, $8Zwsm.default).ripple === false
        });
    },
    meter: "p-password-meter",
    meterLabel: function meterLabel(_ref4) {
        var strength = _ref4.strength;
        return (0, $cfkGk.classNames)("p-password-strength", strength);
    },
    info: function info(_ref5) {
        var strength = _ref5.strength;
        return (0, $cfkGk.classNames)("p-password-info", strength);
    },
    showIcon: "p-password-show-icon",
    hideIcon: "p-password-hide-icon",
    transition: "p-connected-overlay"
};
var $27c1496b97a87888$var$styles = "\n@layer primereact {\n    .p-password {\n        position: relative;\n        display: inline-flex;\n    }\n    \n    .p-password-panel {\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n    \n    .p-password .p-password-panel {\n        min-width: 100%;\n    }\n    \n    .p-password-meter {\n        height: 10px;\n    }\n    \n    .p-password-strength {\n        height: 100%;\n        width: 0%;\n        transition: width 1s ease-in-out;\n    }\n    \n    .p-fluid .p-password {\n        display: flex;\n    }\n    \n    .p-password-input::-ms-reveal,\n    .p-password-input::-ms-clear {\n        display: none;\n    }\n\n    .p-password .p-password-show-icon,\n    .p-password .p-password-hide-icon {\n        line-height: 1.5;\n        cursor: pointer;\n    }\n}\n";
var $27c1496b97a87888$var$PasswordBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Password",
        id: null,
        inputId: null,
        inputRef: null,
        promptLabel: null,
        weakLabel: null,
        mediumLabel: null,
        strongLabel: null,
        mediumRegex: "^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})",
        strongRegex: "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})",
        feedback: true,
        toggleMask: false,
        appendTo: null,
        header: null,
        content: null,
        footer: null,
        showIcon: null,
        hideIcon: null,
        icon: null,
        tooltip: null,
        tooltipOptions: null,
        style: null,
        className: null,
        inputStyle: null,
        inputClassName: null,
        invalid: false,
        variant: null,
        panelStyle: null,
        panelClassName: null,
        transitionOptions: null,
        tabIndex: null,
        value: undefined,
        onInput: null,
        onShow: null,
        onHide: null,
        children: undefined
    },
    css: {
        classes: $27c1496b97a87888$var$classes,
        styles: $27c1496b97a87888$var$styles
    }
});
function $27c1496b97a87888$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $27c1496b97a87888$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $27c1496b97a87888$var$ownKeys(Object(t), !0).forEach(function(r) {
            $27c1496b97a87888$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $27c1496b97a87888$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $27c1496b97a87888$export$5e47cc20a502b05f = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $27c1496b97a87888$var$PasswordBase.getProps(inProps, context);
    var promptLabel = props.promptLabel || (0, $8Zwsm.localeOption)("passwordPrompt");
    var weakLabel = props.weakLabel || (0, $8Zwsm.localeOption)("weak");
    var mediumLabel = props.mediumLabel || (0, $8Zwsm.localeOption)("medium");
    var strongLabel = props.strongLabel || (0, $8Zwsm.localeOption)("strong");
    var _React$useState = $81g6h.useState(false), _React$useState2 = $27c1496b97a87888$var$_slicedToArray(_React$useState, 2), overlayVisibleState = _React$useState2[0], setOverlayVisibleState = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(null), _React$useState4 = $27c1496b97a87888$var$_slicedToArray(_React$useState3, 2), meterState = _React$useState4[0], setMeterState = _React$useState4[1];
    var _React$useState5 = $81g6h.useState(promptLabel), _React$useState6 = $27c1496b97a87888$var$_slicedToArray(_React$useState5, 2), infoTextState = _React$useState6[0], setInfoTextState = _React$useState6[1];
    var _React$useState7 = $81g6h.useState(false), _React$useState8 = $27c1496b97a87888$var$_slicedToArray(_React$useState7, 2), focusedState = _React$useState8[0], setFocusedState = _React$useState8[1];
    var _React$useState9 = $81g6h.useState(false), _React$useState10 = $27c1496b97a87888$var$_slicedToArray(_React$useState9, 2), unmaskedState = _React$useState10[0], setUnmaskedState = _React$useState10[1];
    var elementRef = $81g6h.useRef(null);
    var overlayRef = $81g6h.useRef(null);
    var inputRef = $81g6h.useRef(props.inputRef);
    var mediumCheckRegExp = $81g6h.useRef(new RegExp(props.mediumRegex));
    var strongCheckRegExp = $81g6h.useRef(new RegExp(props.strongRegex));
    var type = unmaskedState ? "text" : "password";
    var metaData = {
        props: props,
        state: {
            overlayVisible: overlayVisibleState,
            meter: meterState,
            infoText: infoTextState,
            focused: focusedState,
            unmasked: unmaskedState
        }
    };
    var _PasswordBase$setMeta = $27c1496b97a87888$var$PasswordBase.setMetaData(metaData), ptm = _PasswordBase$setMeta.ptm, cx = _PasswordBase$setMeta.cx, isUnstyled = _PasswordBase$setMeta.isUnstyled;
    (0, $4gQLd.useHandleStyle)($27c1496b97a87888$var$PasswordBase.css.styles, isUnstyled, {
        name: "password"
    });
    var passwordDisplayOrder = (0, $l2NC0.useDisplayOrder)("password", overlayVisibleState);
    (0, $l2NC0.useGlobalOnEscapeKey)({
        callback: function callback() {
            hide();
        },
        when: overlayVisibleState && props.feedback && passwordDisplayOrder,
        priority: [
            (0, $l2NC0.ESC_KEY_HANDLING_PRIORITIES).PASSWORD,
            passwordDisplayOrder
        ]
    });
    var _useOverlayListener = (0, $l2NC0.useOverlayListener)({
        target: elementRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var valid = _ref.valid;
            valid && hide();
        },
        when: overlayVisibleState
    }), _useOverlayListener2 = $27c1496b97a87888$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var currentValue = inputRef.current && inputRef.current.value;
    var isFilled = $81g6h.useMemo(function() {
        return (0, $cfkGk.ObjectUtils).isNotEmpty(props.value) || (0, $cfkGk.ObjectUtils).isNotEmpty(props.defaultValue) || (0, $cfkGk.ObjectUtils).isNotEmpty(currentValue);
    }, [
        props.value,
        props.defaultValue,
        currentValue
    ]);
    var updateLabels = function updateLabels() {
        if (meterState) {
            var label = null;
            switch(meterState.strength){
                case "weak":
                    label = weakLabel;
                    break;
                case "medium":
                    label = mediumLabel;
                    break;
                case "strong":
                    label = strongLabel;
                    break;
            }
            if (label && infoTextState !== label) setInfoTextState(label);
        } else if (infoTextState !== promptLabel) setInfoTextState(promptLabel);
    };
    var updateFeedback = function updateFeedback(value) {
        if (!props.feedback) return false;
        var label = null;
        var meter = null;
        switch(testStrength(value)){
            case 1:
                label = weakLabel;
                meter = {
                    strength: "weak",
                    width: "33.33%"
                };
                break;
            case 2:
                label = mediumLabel;
                meter = {
                    strength: "medium",
                    width: "66.66%"
                };
                break;
            case 3:
                label = strongLabel;
                meter = {
                    strength: "strong",
                    width: "100%"
                };
                break;
            default:
                label = promptLabel;
                meter = null;
                break;
        }
        setMeterState(meter);
        setInfoTextState(label);
        return true;
    };
    var onPanelClick = function onPanelClick(event) {
        if (props.feedback) (0, $k7ffa.OverlayService).emit("overlay-click", {
            originalEvent: event,
            target: elementRef.current
        });
    };
    var toggleMask = function toggleMask() {
        setUnmaskedState(function(prevUnmasked) {
            return !prevUnmasked;
        });
    };
    var show = function show() {
        updateLabels();
        setOverlayVisibleState(true);
    };
    var hide = function hide() {
        setOverlayVisibleState(false);
    };
    var alignOverlay = function alignOverlay() {
        if (inputRef.current) (0, $cfkGk.DomHandler).alignOverlay(overlayRef.current, inputRef.current.parentElement, props.appendTo || context && context.appendTo || (0, $8Zwsm.default).appendTo);
    };
    var onOverlayEnter = function onOverlayEnter() {
        (0, $cfkGk.ZIndexUtils).set("overlay", overlayRef.current, context && context.autoZIndex || (0, $8Zwsm.default).autoZIndex, context && context.zIndex.overlay || (0, $8Zwsm.default).zIndex.overlay);
        (0, $cfkGk.DomHandler).addStyles(overlayRef.current, {
            position: "absolute",
            top: "0",
            left: "0"
        });
        alignOverlay();
    };
    var onOverlayEntered = function onOverlayEntered() {
        bindOverlayListener();
        props.onShow && props.onShow();
    };
    var onOverlayExit = function onOverlayExit() {
        unbindOverlayListener();
    };
    var onOverlayExited = function onOverlayExited() {
        (0, $cfkGk.ZIndexUtils).clear(overlayRef.current);
        props.onHide && props.onHide();
    };
    var onFocus = function onFocus(event) {
        setFocusedState(true);
        if (props.feedback) show();
        props.onFocus && props.onFocus(event);
    };
    var onBlur = function onBlur(event) {
        setFocusedState(false);
        if (props.feedback) hide();
        props.onBlur && props.onBlur(event);
    };
    var onKeyup = function onKeyup(e) {
        var keyCode = e.code;
        if (props.feedback) {
            if (!!keyCode && keyCode !== "Escape" && !overlayVisibleState) show();
        }
        props.onKeyUp && props.onKeyUp(e);
    };
    var onInput = function onInput(event, validatePattern) {
        if (props.onInput) props.onInput(event, validatePattern);
        if (!props.onChange) (0, $cfkGk.ObjectUtils).isNotEmpty(event.target.value) ? (0, $cfkGk.DomHandler).addClass(elementRef.current, "p-inputwrapper-filled") : (0, $cfkGk.DomHandler).removeClass(elementRef.current, "p-inputwrapper-filled");
    };
    var testStrength = function testStrength(str) {
        if (!str || str.length === 0) return 0;
        if (strongCheckRegExp.current.test(str)) return 3;
        else if (mediumCheckRegExp.current.test(str)) return 2;
        else if (str.length > 0) return 1;
        return 0;
    };
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            toggleMask: toggleMask,
            focus: function focus() {
                return (0, $cfkGk.DomHandler).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getOverlay: function getOverlay() {
                return overlayRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    $81g6h.useEffect(function() {
        (0, $cfkGk.ObjectUtils).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    $81g6h.useEffect(function() {
        mediumCheckRegExp.current = new RegExp(props.mediumRegex);
    }, [
        props.mediumRegex
    ]);
    $81g6h.useEffect(function() {
        strongCheckRegExp.current = new RegExp(props.strongRegex);
    }, [
        props.strongRegex
    ]);
    $81g6h.useEffect(function() {
        if (!isFilled && (0, $cfkGk.DomHandler).hasClass(elementRef.current, "p-inputwrapper-filled")) (0, $cfkGk.DomHandler).removeClass(elementRef.current, "p-inputwrapper-filled");
    }, [
        isFilled
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        updateFeedback(props.value);
    }, [
        props.value
    ]);
    (0, $l2NC0.useMountEffect)(function() {
        alignOverlay();
    });
    (0, $l2NC0.useUnmountEffect)(function() {
        (0, $cfkGk.ZIndexUtils).clear(overlayRef.current);
    });
    var onToggleMaskKeyDown = function onToggleMaskKeyDown(event) {
        if (event.key === "Enter" || event.code === "Space") {
            toggleMask();
            event.preventDefault();
        }
    };
    var createIcon = function createIcon() {
        if (!props.toggleMask) return null;
        var icon;
        var hideIconProps = mergeProps({
            key: "hideIcon",
            role: "switch",
            tabIndex: props.tabIndex || "0",
            className: cx("hideIcon"),
            onClick: toggleMask,
            onKeyDown: onToggleMaskKeyDown,
            "aria-label": (0, $8Zwsm.ariaLabel)("passwordHide") || "Hide Password",
            "aria-checked": "false"
        }, ptm("hideIcon"));
        var showIconProps = mergeProps({
            key: "showIcon",
            role: "switch",
            tabIndex: props.tabIndex || "0",
            className: cx("showIcon"),
            onClick: toggleMask,
            onKeyDown: onToggleMaskKeyDown,
            "aria-label": (0, $8Zwsm.ariaLabel)("passwordShow") || "Show Password",
            "aria-checked": "true"
        }, ptm("showIcon"));
        if (unmaskedState) icon = props.hideIcon || /*#__PURE__*/ $81g6h.createElement((0, $1TaAN.EyeSlashIcon), hideIconProps);
        else icon = props.showIcon || /*#__PURE__*/ $81g6h.createElement((0, $5GLnM.EyeIcon), showIconProps);
        var eyeIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, unmaskedState ? $27c1496b97a87888$var$_objectSpread({}, hideIconProps) : $27c1496b97a87888$var$_objectSpread({}, showIconProps), {
            props: props
        });
        var content = eyeIcon;
        if (props.icon) {
            var defaultIconOptions = {
                onClick: toggleMask,
                className: className,
                element: content,
                props: props
            };
            content = (0, $cfkGk.ObjectUtils).getJSXElement(props.icon, defaultIconOptions);
        }
        return content;
    };
    var createPanel = function createPanel() {
        var _ref2 = meterState || {
            strength: "",
            width: "0%"
        }, strength = _ref2.strength, width = _ref2.width;
        var header = (0, $cfkGk.ObjectUtils).getJSXElement(props.header, props);
        var footer = (0, $cfkGk.ObjectUtils).getJSXElement(props.footer, props);
        var panelProps = mergeProps({
            className: cx("panel", {
                context: context
            }),
            style: props.panelStyle,
            onClick: onPanelClick
        }, ptm("panel"));
        var meterProps = mergeProps({
            className: cx("meter")
        }, ptm("meter"));
        var meterLabelProps = mergeProps({
            className: cx("meterLabel", {
                strength: strength
            }),
            style: {
                width: width
            }
        }, ptm("meterLabel"));
        var infoProps = mergeProps({
            className: cx("info", {
                strength: strength
            })
        }, ptm("info"));
        var content = props.content ? (0, $cfkGk.ObjectUtils).getJSXElement(props.content, props) : /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("div", meterProps, /*#__PURE__*/ $81g6h.createElement("div", meterLabelProps)), /*#__PURE__*/ $81g6h.createElement("div", infoProps, infoTextState));
        var transitionProps = mergeProps({
            classNames: cx("transition"),
            "in": overlayVisibleState,
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: onOverlayEnter,
            onEntered: onOverlayEntered,
            onExit: onOverlayExit,
            onExited: onOverlayExited
        }, ptm("transition"));
        var panel = /*#__PURE__*/ $81g6h.createElement((0, $lbdsH.CSSTransition), $27c1496b97a87888$var$_extends({
            nodeRef: overlayRef
        }, transitionProps), /*#__PURE__*/ $81g6h.createElement("div", $27c1496b97a87888$var$_extends({
            ref: overlayRef
        }, panelProps), header, content, footer));
        return /*#__PURE__*/ $81g6h.createElement((0, $6b4aU.Portal), {
            element: panel,
            appendTo: props.appendTo
        });
    };
    var className = (0, $cfkGk.classNames)("p-password p-component p-inputwrapper", {
        "p-inputwrapper-filled": isFilled,
        "p-inputwrapper-focus": focusedState,
        "p-input-icon-right": props.toggleMask
    }, props.className);
    var inputProps = $27c1496b97a87888$var$PasswordBase.getOtherProps(props);
    var icon = createIcon();
    var panel = createPanel();
    var rootProps = mergeProps({
        ref: elementRef,
        id: props.id,
        className: (0, $cfkGk.classNames)(props.className, cx("root", {
            isFilled: isFilled,
            focusedState: focusedState
        })),
        style: props.style
    }, ptm("root"));
    var inputTextProps = mergeProps($27c1496b97a87888$var$_objectSpread($27c1496b97a87888$var$_objectSpread({
        ref: inputRef,
        id: props.inputId
    }, inputProps), {}, {
        className: (0, $cfkGk.classNames)(props.inputClassName, cx("input")),
        onBlur: onBlur,
        onFocus: onFocus,
        onInput: onInput,
        onKeyUp: onKeyup,
        invalid: props.invalid,
        variant: props.variant,
        style: props.inputStyle,
        tabIndex: props.tabIndex || "0",
        tooltip: props.tooltip,
        tooltipOptions: props.tooltipOptions,
        type: type,
        value: props.value,
        __parentMetadata: {
            parent: metaData
        }
    }), ptm("input"));
    var input = /*#__PURE__*/ $81g6h.createElement((0, $6ccvc.InputText), inputTextProps);
    if (icon) input = /*#__PURE__*/ $81g6h.createElement($27c1496b97a87888$var$IconField, {
        className: cx("iconField"),
        pt: ptm("iconField"),
        __parentMetadata: {
            parent: metaData
        }
    }, input, /*#__PURE__*/ $81g6h.createElement($27c1496b97a87888$var$InputIcon, null, icon));
    return /*#__PURE__*/ $81g6h.createElement("div", rootProps, input, panel);
}));
$27c1496b97a87888$export$5e47cc20a502b05f.displayName = "Password";

});
parcelRegister("5GLnM", function(module, exports) {

$parcel$export(module.exports, "EyeIcon", () => $4245a1334a829520$export$4b2c798a70974642);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $4245a1334a829520$var$_extends() {
    $4245a1334a829520$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4245a1334a829520$var$_extends.apply(this, arguments);
}
var $4245a1334a829520$export$4b2c798a70974642 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $4245a1334a829520$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.0535499 7.25213C0.208567 7.59162 2.40413 12.4 7 12.4C11.5959 12.4 13.7914 7.59162 13.9465 7.25213C13.9487 7.2471 13.9506 7.24304 13.952 7.24001C13.9837 7.16396 14 7.08239 14 7.00001C14 6.91762 13.9837 6.83605 13.952 6.76001C13.9506 6.75697 13.9487 6.75292 13.9465 6.74788C13.7914 6.4084 11.5959 1.60001 7 1.60001C2.40413 1.60001 0.208567 6.40839 0.0535499 6.74788C0.0512519 6.75292 0.0494023 6.75697 0.048 6.76001C0.0163137 6.83605 0 6.91762 0 7.00001C0 7.08239 0.0163137 7.16396 0.048 7.24001C0.0494023 7.24304 0.0512519 7.2471 0.0535499 7.25213ZM7 11.2C3.664 11.2 1.736 7.92001 1.264 7.00001C1.736 6.08001 3.664 2.80001 7 2.80001C10.336 2.80001 12.264 6.08001 12.736 7.00001C12.264 7.92001 10.336 11.2 7 11.2ZM5.55551 9.16182C5.98308 9.44751 6.48576 9.6 7 9.6C7.68891 9.59789 8.349 9.32328 8.83614 8.83614C9.32328 8.349 9.59789 7.68891 9.59999 7C9.59999 6.48576 9.44751 5.98308 9.16182 5.55551C8.87612 5.12794 8.47006 4.7947 7.99497 4.59791C7.51988 4.40112 6.99711 4.34963 6.49276 4.44995C5.98841 4.55027 5.52513 4.7979 5.16152 5.16152C4.7979 5.52513 4.55027 5.98841 4.44995 6.49276C4.34963 6.99711 4.40112 7.51988 4.59791 7.99497C4.7947 8.47006 5.12794 8.87612 5.55551 9.16182ZM6.2222 5.83594C6.45243 5.6821 6.7231 5.6 7 5.6C7.37065 5.6021 7.72553 5.75027 7.98762 6.01237C8.24972 6.27446 8.39789 6.62934 8.4 7C8.4 7.27689 8.31789 7.54756 8.16405 7.77779C8.01022 8.00802 7.79157 8.18746 7.53575 8.29343C7.27994 8.39939 6.99844 8.42711 6.72687 8.37309C6.4553 8.31908 6.20584 8.18574 6.01005 7.98994C5.81425 7.79415 5.68091 7.54469 5.6269 7.27312C5.57288 7.00155 5.6006 6.72006 5.70656 6.46424C5.81253 6.20842 5.99197 5.98977 6.2222 5.83594Z",
        fill: "currentColor"
    }));
}));
$4245a1334a829520$export$4b2c798a70974642.displayName = "EyeIcon";

});

parcelRegister("1TaAN", function(module, exports) {

$parcel$export(module.exports, "EyeSlashIcon", () => $160324f2c74b9fe9$export$a3d42ccaf02d165b);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $160324f2c74b9fe9$var$_extends() {
    $160324f2c74b9fe9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $160324f2c74b9fe9$var$_extends.apply(this, arguments);
}
var $160324f2c74b9fe9$export$a3d42ccaf02d165b = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $160324f2c74b9fe9$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.9414 6.74792C13.9437 6.75295 13.9455 6.757 13.9469 6.76003C13.982 6.8394 14.0001 6.9252 14.0001 7.01195C14.0001 7.0987 13.982 7.1845 13.9469 7.26386C13.6004 8.00059 13.1711 8.69549 12.6674 9.33515C12.6115 9.4071 12.54 9.46538 12.4582 9.50556C12.3765 9.54574 12.2866 9.56678 12.1955 9.56707C12.0834 9.56671 11.9737 9.53496 11.8788 9.47541C11.7838 9.41586 11.7074 9.3309 11.6583 9.23015C11.6092 9.12941 11.5893 9.01691 11.6008 8.90543C11.6124 8.79394 11.6549 8.68793 11.7237 8.5994C12.1065 8.09726 12.4437 7.56199 12.7313 6.99995C12.2595 6.08027 10.3402 2.8014 6.99732 2.8014C6.63723 2.80218 6.27816 2.83969 5.92569 2.91336C5.77666 2.93304 5.62568 2.89606 5.50263 2.80972C5.37958 2.72337 5.29344 2.59398 5.26125 2.44714C5.22907 2.30031 5.2532 2.14674 5.32885 2.01685C5.40451 1.88696 5.52618 1.79021 5.66978 1.74576C6.10574 1.64961 6.55089 1.60134 6.99732 1.60181C11.5916 1.60181 13.7864 6.40856 13.9414 6.74792ZM2.20333 1.61685C2.35871 1.61411 2.5091 1.67179 2.6228 1.77774L12.2195 11.3744C12.3318 11.4869 12.3949 11.6393 12.3949 11.7983C12.3949 11.9572 12.3318 12.1097 12.2195 12.2221C12.107 12.3345 11.9546 12.3976 11.7956 12.3976C11.6367 12.3976 11.4842 12.3345 11.3718 12.2221L10.5081 11.3584C9.46549 12.0426 8.24432 12.4042 6.99729 12.3981C2.403 12.3981 0.208197 7.59135 0.0532336 7.25198C0.0509364 7.24694 0.0490875 7.2429 0.0476856 7.23986C0.0162332 7.16518 3.05176e-05 7.08497 3.05176e-05 7.00394C3.05176e-05 6.92291 0.0162332 6.8427 0.0476856 6.76802C0.631261 5.47831 1.46902 4.31959 2.51084 3.36119L1.77509 2.62545C1.66914 2.51175 1.61146 2.36136 1.61421 2.20597C1.61695 2.05059 1.6799 1.90233 1.78979 1.79244C1.89968 1.68254 2.04794 1.6196 2.20333 1.61685ZM7.45314 8.35147L5.68574 6.57609V6.5361C5.5872 6.78938 5.56498 7.06597 5.62183 7.33173C5.67868 7.59749 5.8121 7.84078 6.00563 8.03158C6.19567 8.21043 6.43052 8.33458 6.68533 8.39089C6.94014 8.44721 7.20543 8.43359 7.45314 8.35147ZM1.26327 6.99994C1.7351 7.91163 3.64645 11.1985 6.99729 11.1985C7.9267 11.2048 8.8408 10.9618 9.64438 10.4947L8.35682 9.20718C7.86027 9.51441 7.27449 9.64491 6.69448 9.57752C6.11446 9.51014 5.57421 9.24881 5.16131 8.83592C4.74842 8.42303 4.4871 7.88277 4.41971 7.30276C4.35232 6.72274 4.48282 6.13697 4.79005 5.64041L3.35855 4.2089C2.4954 5.00336 1.78523 5.94935 1.26327 6.99994Z",
        fill: "currentColor"
    }));
}));
$160324f2c74b9fe9$export$a3d42ccaf02d165b.displayName = "EyeSlashIcon";

});


parcelRegister("eKUeg", function(module, exports) {

$parcel$export(module.exports, "useWatch", () => $4c5d5da4c93ac56f$export$3c773aa2b84f29e0);
$parcel$export(module.exports, "Controller", () => $4c5d5da4c93ac56f$export$bd0bf19f25da8474);
$parcel$export(module.exports, "useForm", () => $4c5d5da4c93ac56f$export$87c0cf8eb5a167e0);

var $81g6h = parcelRequire("81g6h");
var $4c5d5da4c93ac56f$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $4c5d5da4c93ac56f$var$isDateObject = (value1)=>value1 instanceof Date;
var $4c5d5da4c93ac56f$var$isNullOrUndefined = (value1)=>value1 == null;
const $4c5d5da4c93ac56f$var$isObjectType = (value1)=>typeof value1 === "object";
var $4c5d5da4c93ac56f$var$isObject = (value1)=>!$4c5d5da4c93ac56f$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $4c5d5da4c93ac56f$var$isObjectType(value1) && !$4c5d5da4c93ac56f$var$isDateObject(value1);
var $4c5d5da4c93ac56f$var$getEventValue = (event)=>$4c5d5da4c93ac56f$var$isObject(event) && event.target ? $4c5d5da4c93ac56f$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $4c5d5da4c93ac56f$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $4c5d5da4c93ac56f$var$isNameInFieldArray = (names, name)=>names.has($4c5d5da4c93ac56f$var$getNodeParentName(name));
var $4c5d5da4c93ac56f$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $4c5d5da4c93ac56f$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $4c5d5da4c93ac56f$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $4c5d5da4c93ac56f$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($4c5d5da4c93ac56f$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $4c5d5da4c93ac56f$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$4c5d5da4c93ac56f$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $4c5d5da4c93ac56f$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $4c5d5da4c93ac56f$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $4c5d5da4c93ac56f$var$isUndefined = (val)=>val === undefined;
var $4c5d5da4c93ac56f$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$4c5d5da4c93ac56f$var$isObject(object)) return defaultValue;
    const result = $4c5d5da4c93ac56f$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$4c5d5da4c93ac56f$var$isNullOrUndefined(result) ? result : result[key], object);
    return $4c5d5da4c93ac56f$var$isUndefined(result) || result === object ? $4c5d5da4c93ac56f$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $4c5d5da4c93ac56f$var$isBoolean = (value1)=>typeof value1 === "boolean";
var $4c5d5da4c93ac56f$var$isKey = (value1)=>/^\w*$/.test(value1);
var $4c5d5da4c93ac56f$var$stringToPath = (input)=>$4c5d5da4c93ac56f$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $4c5d5da4c93ac56f$var$isKey(path) ? [
        path
    ] : $4c5d5da4c93ac56f$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $4c5d5da4c93ac56f$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === "__proto__") return;
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
const $4c5d5da4c93ac56f$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $4c5d5da4c93ac56f$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $4c5d5da4c93ac56f$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $4c5d5da4c93ac56f$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $4c5d5da4c93ac56f$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useContext($4c5d5da4c93ac56f$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $4c5d5da4c93ac56f$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement($4c5d5da4c93ac56f$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $4c5d5da4c93ac56f$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $4c5d5da4c93ac56f$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $4c5d5da4c93ac56f$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $4c5d5da4c93ac56f$var$isEmptyObject = (value1)=>$4c5d5da4c93ac56f$var$isObject(value1) && !Object.keys(value1).length;
var $4c5d5da4c93ac56f$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $4c5d5da4c93ac56f$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $4c5d5da4c93ac56f$var$VALIDATION_MODE.all));
};
var $4c5d5da4c93ac56f$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $4c5d5da4c93ac56f$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $4c5d5da4c93ac56f$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $4c5d5da4c93ac56f$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $4c5d5da4c93ac56f$export$606f11b2eb45ecc6(props) {
    const methods = $4c5d5da4c93ac56f$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(name);
    _name.current = name;
    $4c5d5da4c93ac56f$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $4c5d5da4c93ac56f$var$shouldSubscribeByName(_name.current, value1.name, exact) && $4c5d5da4c93ac56f$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $4c5d5da4c93ac56f$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $4c5d5da4c93ac56f$var$isString = (value1)=>typeof value1 === "string";
var $4c5d5da4c93ac56f$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($4c5d5da4c93ac56f$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $4c5d5da4c93ac56f$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $4c5d5da4c93ac56f$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $4c5d5da4c93ac56f$export$3c773aa2b84f29e0(props) {
    const methods = $4c5d5da4c93ac56f$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(name);
    _name.current = name;
    $4c5d5da4c93ac56f$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($4c5d5da4c93ac56f$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($4c5d5da4c93ac56f$var$cloneObject($4c5d5da4c93ac56f$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $4c5d5da4c93ac56f$export$e8c786024a2b0a79(props) {
    const methods = $4c5d5da4c93ac56f$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $4c5d5da4c93ac56f$var$isNameInFieldArray(control._names.array, name);
    const value1 = $4c5d5da4c93ac56f$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $4c5d5da4c93ac56f$export$3988ae62b71be9a3(control._formValues, name, $4c5d5da4c93ac56f$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $4c5d5da4c93ac56f$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$4c5d5da4c93ac56f$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $4c5d5da4c93ac56f$var$cloneObject($4c5d5da4c93ac56f$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($4c5d5da4c93ac56f$var$isUndefined($4c5d5da4c93ac56f$export$3988ae62b71be9a3(control._formValues, name))) $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(()=>{
        if ($4c5d5da4c93ac56f$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name,
            value: $4c5d5da4c93ac56f$export$3988ae62b71be9a3(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$4c5d5da4c93ac56f$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $4c5d5da4c93ac56f$var$getEventValue(event),
                        name: name
                    },
                    type: $4c5d5da4c93ac56f$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $4c5d5da4c93ac56f$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $4c5d5da4c93ac56f$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$4c5d5da4c93ac56f$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$4c5d5da4c93ac56f$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$4c5d5da4c93ac56f$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$4c5d5da4c93ac56f$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$4c5d5da4c93ac56f$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $4c5d5da4c93ac56f$export$bd0bf19f25da8474 = (props)=>props.render($4c5d5da4c93ac56f$export$e8c786024a2b0a79(props));
const $4c5d5da4c93ac56f$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $4c5d5da4c93ac56f$export$a7fed597f4b8afd8(props) {
    const methods = $4c5d5da4c93ac56f$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $4c5d5da4c93ac56f$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            for (const name of control._names.mount)formData.append(name, $4c5d5da4c93ac56f$export$3988ae62b71be9a3(data, name));
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $4c5d5da4c93ac56f$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $4c5d5da4c93ac56f$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $4c5d5da4c93ac56f$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $4c5d5da4c93ac56f$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$4c5d5da4c93ac56f$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $4c5d5da4c93ac56f$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $4c5d5da4c93ac56f$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $4c5d5da4c93ac56f$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $4c5d5da4c93ac56f$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $4c5d5da4c93ac56f$var$VALIDATION_MODE.all,
        isOnTouch: mode === $4c5d5da4c93ac56f$var$VALIDATION_MODE.onTouched
    });
var $4c5d5da4c93ac56f$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $4c5d5da4c93ac56f$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) break;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) break;
                else $4c5d5da4c93ac56f$var$iterateFieldsByAction(currentField, action);
            } else if ($4c5d5da4c93ac56f$var$isObject(currentField)) $4c5d5da4c93ac56f$var$iterateFieldsByAction(currentField, action);
        }
    }
};
var $4c5d5da4c93ac56f$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $4c5d5da4c93ac56f$var$convertToArrayPayload($4c5d5da4c93ac56f$export$3988ae62b71be9a3(errors, name));
    $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $4c5d5da4c93ac56f$var$isFileInput = (element)=>element.type === "file";
var $4c5d5da4c93ac56f$var$isFunction = (value1)=>typeof value1 === "function";
var $4c5d5da4c93ac56f$var$isHTMLElement = (value1)=>{
    if (!$4c5d5da4c93ac56f$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $4c5d5da4c93ac56f$var$isMessage = (value1)=>$4c5d5da4c93ac56f$var$isString(value1);
var $4c5d5da4c93ac56f$var$isRadioInput = (element)=>element.type === "radio";
var $4c5d5da4c93ac56f$var$isRegex = (value1)=>value1 instanceof RegExp;
const $4c5d5da4c93ac56f$var$defaultResult = {
    value: false,
    isValid: false
};
const $4c5d5da4c93ac56f$var$validResult = {
    value: true,
    isValid: true
};
var $4c5d5da4c93ac56f$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$4c5d5da4c93ac56f$var$isUndefined(options[0].attributes.value) ? $4c5d5da4c93ac56f$var$isUndefined(options[0].value) || options[0].value === "" ? $4c5d5da4c93ac56f$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $4c5d5da4c93ac56f$var$validResult : $4c5d5da4c93ac56f$var$defaultResult;
    }
    return $4c5d5da4c93ac56f$var$defaultResult;
};
const $4c5d5da4c93ac56f$var$defaultReturn = {
    isValid: false,
    value: null
};
var $4c5d5da4c93ac56f$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $4c5d5da4c93ac56f$var$defaultReturn) : $4c5d5da4c93ac56f$var$defaultReturn;
function $4c5d5da4c93ac56f$var$getValidateError(result, ref, type = "validate") {
    if ($4c5d5da4c93ac56f$var$isMessage(result) || Array.isArray(result) && result.every($4c5d5da4c93ac56f$var$isMessage) || $4c5d5da4c93ac56f$var$isBoolean(result) && !result) return {
        type: type,
        message: $4c5d5da4c93ac56f$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $4c5d5da4c93ac56f$var$getValueAndMessage = (validationData)=>$4c5d5da4c93ac56f$var$isObject(validationData) && !$4c5d5da4c93ac56f$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $4c5d5da4c93ac56f$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($4c5d5da4c93ac56f$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $4c5d5da4c93ac56f$var$isRadioInput(ref);
    const isCheckBox = $4c5d5da4c93ac56f$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $4c5d5da4c93ac56f$var$isFileInput(ref)) && $4c5d5da4c93ac56f$var$isUndefined(ref.value) && $4c5d5da4c93ac56f$var$isUndefined(inputValue) || $4c5d5da4c93ac56f$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $4c5d5da4c93ac56f$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $4c5d5da4c93ac56f$var$INPUT_VALIDATION_RULES.maxLength, minType = $4c5d5da4c93ac56f$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $4c5d5da4c93ac56f$var$isNullOrUndefined(inputValue)) || $4c5d5da4c93ac56f$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$4c5d5da4c93ac56f$var$getCheckboxValue(refs).isValid || isRadio && !$4c5d5da4c93ac56f$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $4c5d5da4c93ac56f$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $4c5d5da4c93ac56f$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $4c5d5da4c93ac56f$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($4c5d5da4c93ac56f$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$4c5d5da4c93ac56f$var$isNullOrUndefined(min) || !$4c5d5da4c93ac56f$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $4c5d5da4c93ac56f$var$getValueAndMessage(max);
        const minOutput = $4c5d5da4c93ac56f$var$getValueAndMessage(min);
        if (!$4c5d5da4c93ac56f$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$4c5d5da4c93ac56f$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$4c5d5da4c93ac56f$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($4c5d5da4c93ac56f$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($4c5d5da4c93ac56f$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $4c5d5da4c93ac56f$var$INPUT_VALIDATION_RULES.max, $4c5d5da4c93ac56f$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($4c5d5da4c93ac56f$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $4c5d5da4c93ac56f$var$getValueAndMessage(maxLength);
        const minLengthOutput = $4c5d5da4c93ac56f$var$getValueAndMessage(minLength);
        const exceedMax = !$4c5d5da4c93ac56f$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$4c5d5da4c93ac56f$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $4c5d5da4c93ac56f$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $4c5d5da4c93ac56f$var$getValueAndMessage(pattern);
        if ($4c5d5da4c93ac56f$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $4c5d5da4c93ac56f$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($4c5d5da4c93ac56f$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($4c5d5da4c93ac56f$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $4c5d5da4c93ac56f$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($4c5d5da4c93ac56f$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($4c5d5da4c93ac56f$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$4c5d5da4c93ac56f$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $4c5d5da4c93ac56f$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$4c5d5da4c93ac56f$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var $4c5d5da4c93ac56f$var$appendAt = (data, value1)=>[
        ...data,
        ...$4c5d5da4c93ac56f$var$convertToArrayPayload(value1)
    ];
var $4c5d5da4c93ac56f$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $4c5d5da4c93ac56f$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$4c5d5da4c93ac56f$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $4c5d5da4c93ac56f$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($4c5d5da4c93ac56f$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $4c5d5da4c93ac56f$var$prependAt = (data, value1)=>[
        ...$4c5d5da4c93ac56f$var$convertToArrayPayload(value1),
        ...$4c5d5da4c93ac56f$var$convertToArrayPayload(data)
    ];
function $4c5d5da4c93ac56f$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $4c5d5da4c93ac56f$var$compact(temp).length ? temp : [];
}
var $4c5d5da4c93ac56f$var$removeArrayAt = (data, index)=>$4c5d5da4c93ac56f$var$isUndefined(index) ? [] : $4c5d5da4c93ac56f$var$removeAtIndexes(data, $4c5d5da4c93ac56f$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $4c5d5da4c93ac56f$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function $4c5d5da4c93ac56f$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $4c5d5da4c93ac56f$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $4c5d5da4c93ac56f$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$4c5d5da4c93ac56f$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $4c5d5da4c93ac56f$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $4c5d5da4c93ac56f$var$isKey(path) ? [
        path
    ] : $4c5d5da4c93ac56f$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $4c5d5da4c93ac56f$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($4c5d5da4c93ac56f$var$isObject(childObject) && $4c5d5da4c93ac56f$var$isEmptyObject(childObject) || Array.isArray(childObject) && $4c5d5da4c93ac56f$var$isEmptyArray(childObject))) $4c5d5da4c93ac56f$var$unset(object, paths.slice(0, -1));
    return object;
}
var $4c5d5da4c93ac56f$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $4c5d5da4c93ac56f$export$310131896651d559(props) {
    const methods = $4c5d5da4c93ac56f$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(control._getFieldArray(name).map($4c5d5da4c93ac56f$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $4c5d5da4c93ac56f$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($4c5d5da4c93ac56f$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $4c5d5da4c93ac56f$var$convertToArrayPayload($4c5d5da4c93ac56f$var$cloneObject(value1));
        const updatedFieldArrayValues = $4c5d5da4c93ac56f$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $4c5d5da4c93ac56f$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $4c5d5da4c93ac56f$var$appendAt(ids.current, appendValue.map($4c5d5da4c93ac56f$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $4c5d5da4c93ac56f$var$appendAt, {
            argA: $4c5d5da4c93ac56f$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $4c5d5da4c93ac56f$var$convertToArrayPayload($4c5d5da4c93ac56f$var$cloneObject(value1));
        const updatedFieldArrayValues = $4c5d5da4c93ac56f$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $4c5d5da4c93ac56f$var$getFocusFieldName(name, 0, options);
        ids.current = $4c5d5da4c93ac56f$var$prependAt(ids.current, prependValue.map($4c5d5da4c93ac56f$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $4c5d5da4c93ac56f$var$prependAt, {
            argA: $4c5d5da4c93ac56f$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $4c5d5da4c93ac56f$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $4c5d5da4c93ac56f$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $4c5d5da4c93ac56f$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $4c5d5da4c93ac56f$var$convertToArrayPayload($4c5d5da4c93ac56f$var$cloneObject(value1));
        const updatedFieldArrayValues = $4c5d5da4c93ac56f$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $4c5d5da4c93ac56f$var$getFocusFieldName(name, index, options);
        ids.current = $4c5d5da4c93ac56f$var$insert(ids.current, index, insertValue.map($4c5d5da4c93ac56f$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $4c5d5da4c93ac56f$var$insert, {
            argA: index,
            argB: $4c5d5da4c93ac56f$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $4c5d5da4c93ac56f$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $4c5d5da4c93ac56f$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $4c5d5da4c93ac56f$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $4c5d5da4c93ac56f$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $4c5d5da4c93ac56f$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $4c5d5da4c93ac56f$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $4c5d5da4c93ac56f$var$cloneObject(value1);
        const updatedFieldArrayValues = $4c5d5da4c93ac56f$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $4c5d5da4c93ac56f$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $4c5d5da4c93ac56f$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $4c5d5da4c93ac56f$var$convertToArrayPayload($4c5d5da4c93ac56f$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($4c5d5da4c93ac56f$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(()=>{
        control._state.action = false;
        $4c5d5da4c93ac56f$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$4c5d5da4c93ac56f$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $4c5d5da4c93ac56f$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($4c5d5da4c93ac56f$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $4c5d5da4c93ac56f$var$getValidationModes(control._options.mode).isOnSubmit)) $4c5d5da4c93ac56f$var$validateField(field, control._formValues, control._options.criteriaMode === $4c5d5da4c93ac56f$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$4c5d5da4c93ac56f$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $4c5d5da4c93ac56f$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $4c5d5da4c93ac56f$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(()=>{
        !$4c5d5da4c93ac56f$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $4c5d5da4c93ac56f$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var $4c5d5da4c93ac56f$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $4c5d5da4c93ac56f$var$isPrimitive = (value1)=>$4c5d5da4c93ac56f$var$isNullOrUndefined(value1) || !$4c5d5da4c93ac56f$var$isObjectType(value1);
function $4c5d5da4c93ac56f$var$deepEqual(object1, object2) {
    if ($4c5d5da4c93ac56f$var$isPrimitive(object1) || $4c5d5da4c93ac56f$var$isPrimitive(object2)) return object1 === object2;
    if ($4c5d5da4c93ac56f$var$isDateObject(object1) && $4c5d5da4c93ac56f$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($4c5d5da4c93ac56f$var$isDateObject(val1) && $4c5d5da4c93ac56f$var$isDateObject(val2) || $4c5d5da4c93ac56f$var$isObject(val1) && $4c5d5da4c93ac56f$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$4c5d5da4c93ac56f$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $4c5d5da4c93ac56f$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $4c5d5da4c93ac56f$var$isRadioOrCheckbox = (ref)=>$4c5d5da4c93ac56f$var$isRadioInput(ref) || $4c5d5da4c93ac56f$var$isCheckBoxInput(ref);
var $4c5d5da4c93ac56f$var$live = (ref)=>$4c5d5da4c93ac56f$var$isHTMLElement(ref) && ref.isConnected;
var $4c5d5da4c93ac56f$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($4c5d5da4c93ac56f$var$isFunction(data[key])) return true;
    }
    return false;
};
function $4c5d5da4c93ac56f$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($4c5d5da4c93ac56f$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $4c5d5da4c93ac56f$var$isObject(data[key]) && !$4c5d5da4c93ac56f$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $4c5d5da4c93ac56f$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$4c5d5da4c93ac56f$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $4c5d5da4c93ac56f$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($4c5d5da4c93ac56f$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $4c5d5da4c93ac56f$var$isObject(data[key]) && !$4c5d5da4c93ac56f$var$objectHasFunction(data[key])) {
            if ($4c5d5da4c93ac56f$var$isUndefined(formValues) || $4c5d5da4c93ac56f$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $4c5d5da4c93ac56f$var$markFieldsDirty(data[key], []) : {
                ...$4c5d5da4c93ac56f$var$markFieldsDirty(data[key])
            };
            else $4c5d5da4c93ac56f$var$getDirtyFieldsFromDefaultValues(data[key], $4c5d5da4c93ac56f$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$4c5d5da4c93ac56f$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $4c5d5da4c93ac56f$var$getDirtyFields = (defaultValues, formValues)=>$4c5d5da4c93ac56f$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $4c5d5da4c93ac56f$var$markFieldsDirty(formValues));
var $4c5d5da4c93ac56f$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$4c5d5da4c93ac56f$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $4c5d5da4c93ac56f$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $4c5d5da4c93ac56f$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($4c5d5da4c93ac56f$var$isFileInput(ref)) return ref.files;
    if ($4c5d5da4c93ac56f$var$isRadioInput(ref)) return $4c5d5da4c93ac56f$var$getRadioValue(_f.refs).value;
    if ($4c5d5da4c93ac56f$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($4c5d5da4c93ac56f$var$isCheckBoxInput(ref)) return $4c5d5da4c93ac56f$var$getCheckboxValue(_f.refs).value;
    return $4c5d5da4c93ac56f$var$getFieldValueAs($4c5d5da4c93ac56f$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $4c5d5da4c93ac56f$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name);
        field && $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $4c5d5da4c93ac56f$var$getRuleValue = (rule)=>$4c5d5da4c93ac56f$var$isUndefined(rule) ? rule : $4c5d5da4c93ac56f$var$isRegex(rule) ? rule.source : $4c5d5da4c93ac56f$var$isObject(rule) ? $4c5d5da4c93ac56f$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $4c5d5da4c93ac56f$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $4c5d5da4c93ac56f$var$schemaErrorLookup(errors, _fields, name) {
    const error = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(errors, name);
    if (error || $4c5d5da4c93ac56f$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $4c5d5da4c93ac56f$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $4c5d5da4c93ac56f$var$unsetEmptyArray = (ref, name)=>!$4c5d5da4c93ac56f$var$compact($4c5d5da4c93ac56f$export$3988ae62b71be9a3(ref, name)).length && $4c5d5da4c93ac56f$var$unset(ref, name);
const $4c5d5da4c93ac56f$var$defaultOptions = {
    mode: $4c5d5da4c93ac56f$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $4c5d5da4c93ac56f$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $4c5d5da4c93ac56f$var$createFormControl(props = {}) {
    let _options = {
        ...$4c5d5da4c93ac56f$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $4c5d5da4c93ac56f$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $4c5d5da4c93ac56f$var$isObject(_options.defaultValues) || $4c5d5da4c93ac56f$var$isObject(_options.values) ? $4c5d5da4c93ac56f$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $4c5d5da4c93ac56f$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $4c5d5da4c93ac56f$var$createSubject(),
        array: $4c5d5da4c93ac56f$var$createSubject(),
        state: $4c5d5da4c93ac56f$var$createSubject()
    };
    const validationModeBeforeSubmit = $4c5d5da4c93ac56f$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $4c5d5da4c93ac56f$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $4c5d5da4c93ac56f$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $4c5d5da4c93ac56f$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (_proxyFormState.isValidating || _proxyFormState.validatingFields) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $4c5d5da4c93ac56f$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$4c5d5da4c93ac56f$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($4c5d5da4c93ac56f$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($4c5d5da4c93ac56f$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $4c5d5da4c93ac56f$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($4c5d5da4c93ac56f$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($4c5d5da4c93ac56f$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $4c5d5da4c93ac56f$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_formValues, name, $4c5d5da4c93ac56f$var$isUndefined(value1) ? $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $4c5d5da4c93ac56f$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $4c5d5da4c93ac56f$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        const disabledField = !!($4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name) && $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name)._f && $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name)._f.disabled);
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = disabledField || $4c5d5da4c93ac56f$var$deepEqual($4c5d5da4c93ac56f$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = !!(!disabledField && $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_formState.dirtyFields, name));
            isCurrentFieldPristine || disabledField ? $4c5d5da4c93ac56f$var$unset(_formState.dirtyFields, name) : $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $4c5d5da4c93ac56f$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $4c5d5da4c93ac56f$var$unset(_formState.errors, name);
        }
        if ((error ? !$4c5d5da4c93ac56f$var$deepEqual(previousFieldError, error) : previousFieldError) || !$4c5d5da4c93ac56f$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $4c5d5da4c93ac56f$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _executeSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $4c5d5da4c93ac56f$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(errors, name);
            error ? $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $4c5d5da4c93ac56f$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await $4c5d5da4c93ac56f$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($4c5d5da4c93ac56f$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $4c5d5da4c93ac56f$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $4c5d5da4c93ac56f$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$4c5d5da4c93ac56f$var$live(ref)) : !$4c5d5da4c93ac56f$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formValues, name, data), !$4c5d5da4c93ac56f$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$4c5d5da4c93ac56f$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $4c5d5da4c93ac56f$var$isUndefined(defaultValue) ? _defaultValues : $4c5d5da4c93ac56f$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$4c5d5da4c93ac56f$var$compact($4c5d5da4c93ac56f$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formValues, name, $4c5d5da4c93ac56f$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $4c5d5da4c93ac56f$var$isHTMLElement(fieldReference.ref) && $4c5d5da4c93ac56f$var$isNullOrUndefined(value1) ? "" : value1;
                if ($4c5d5da4c93ac56f$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($4c5d5da4c93ac56f$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($4c5d5da4c93ac56f$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$4c5d5da4c93ac56f$var$isPrimitive(fieldValue) || field && !field._f) && !$4c5d5da4c93ac56f$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $4c5d5da4c93ac56f$var$cloneObject(value1);
        $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $4c5d5da4c93ac56f$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$4c5d5da4c93ac56f$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $4c5d5da4c93ac56f$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: _state.mount ? name : undefined,
            values: {
                ..._formValues
            }
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $4c5d5da4c93ac56f$var$getFieldValue(field._f) : $4c5d5da4c93ac56f$var$getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_formValues, name, fieldValue);
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $4c5d5da4c93ac56f$var$EVENTS.BLUR || event.type === $4c5d5da4c93ac56f$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$4c5d5da4c93ac56f$var$hasValidation(field._f) && !_options.resolver && !$4c5d5da4c93ac56f$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $4c5d5da4c93ac56f$var$skipValidation(isBlurEvent, $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $4c5d5da4c93ac56f$var$isWatched(name, _names, isBlurEvent);
            $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$4c5d5da4c93ac56f$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $4c5d5da4c93ac56f$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $4c5d5da4c93ac56f$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $4c5d5da4c93ac56f$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $4c5d5da4c93ac56f$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($4c5d5da4c93ac56f$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $4c5d5da4c93ac56f$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($4c5d5da4c93ac56f$var$isUndefined(name) ? name : fieldNames);
            isValid = $4c5d5da4c93ac56f$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$4c5d5da4c93ac56f$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$4c5d5da4c93ac56f$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $4c5d5da4c93ac56f$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        return $4c5d5da4c93ac56f$var$isUndefined(fieldNames) ? values : $4c5d5da4c93ac56f$var$isString(fieldNames) ? $4c5d5da4c93ac56f$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$4c5d5da4c93ac56f$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$4c5d5da4c93ac56f$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$4c5d5da4c93ac56f$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $4c5d5da4c93ac56f$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$4c5d5da4c93ac56f$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$4c5d5da4c93ac56f$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $4c5d5da4c93ac56f$var$convertToArrayPayload(name).forEach((inputName)=>$4c5d5da4c93ac56f$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type, ...restOfErrorTree } = currentError;
        $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$4c5d5da4c93ac56f$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $4c5d5da4c93ac56f$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $4c5d5da4c93ac56f$var$unset(_fields, fieldName);
                $4c5d5da4c93ac56f$var$unset(_formValues, fieldName);
            }
            !options.keepError && $4c5d5da4c93ac56f$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $4c5d5da4c93ac56f$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $4c5d5da4c93ac56f$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $4c5d5da4c93ac56f$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $4c5d5da4c93ac56f$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields, value: value1 })=>{
        if ($4c5d5da4c93ac56f$var$isBoolean(disabled) && _state.mount || !!disabled) {
            const inputValue = disabled ? undefined : $4c5d5da4c93ac56f$var$isUndefined(value1) ? $4c5d5da4c93ac56f$var$getFieldValue(field ? field._f : $4c5d5da4c93ac56f$export$3988ae62b71be9a3(fields, name)._f) : value1;
            $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $4c5d5da4c93ac56f$var$isBoolean(options.disabled);
        $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: options.disabled,
            name: name,
            value: options.value
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $4c5d5da4c93ac56f$var$getRuleValue(options.min),
                max: $4c5d5da4c93ac56f$var$getRuleValue(options.max),
                minLength: $4c5d5da4c93ac56f$var$getRuleValue(options.minLength),
                maxLength: $4c5d5da4c93ac56f$var$getRuleValue(options.maxLength),
                pattern: $4c5d5da4c93ac56f$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $4c5d5da4c93ac56f$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $4c5d5da4c93ac56f$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($4c5d5da4c93ac56f$var$live),
                                    fieldRef,
                                    ...Array.isArray($4c5d5da4c93ac56f$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($4c5d5da4c93ac56f$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $4c5d5da4c93ac56f$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($4c5d5da4c93ac56f$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $4c5d5da4c93ac56f$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $4c5d5da4c93ac56f$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $4c5d5da4c93ac56f$var$unset(_formState.errors, "root");
            if ($4c5d5da4c93ac56f$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $4c5d5da4c93ac56f$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name)) {
            if ($4c5d5da4c93ac56f$var$isUndefined(options.defaultValue)) setValue(name, $4c5d5da4c93ac56f$var$cloneObject($4c5d5da4c93ac56f$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(_defaultValues, name, $4c5d5da4c93ac56f$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $4c5d5da4c93ac56f$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $4c5d5da4c93ac56f$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $4c5d5da4c93ac56f$var$cloneObject($4c5d5da4c93ac56f$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $4c5d5da4c93ac56f$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $4c5d5da4c93ac56f$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $4c5d5da4c93ac56f$var$cloneObject(updatedValues);
        const isEmptyResetValues = $4c5d5da4c93ac56f$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) for (const fieldName of _names.mount)$4c5d5da4c93ac56f$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $4c5d5da4c93ac56f$export$adaa4cf7ef1b65be(values, fieldName, $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $4c5d5da4c93ac56f$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($4c5d5da4c93ac56f$var$isWeb && $4c5d5da4c93ac56f$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($4c5d5da4c93ac56f$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $4c5d5da4c93ac56f$var$cloneObject(_defaultValues) : {} : $4c5d5da4c93ac56f$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$4c5d5da4c93ac56f$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $4c5d5da4c93ac56f$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $4c5d5da4c93ac56f$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($4c5d5da4c93ac56f$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $4c5d5da4c93ac56f$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$4c5d5da4c93ac56f$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            _setErrors: _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $4c5d5da4c93ac56f$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $4c5d5da4c93ac56f$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: $4c5d5da4c93ac56f$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$4c5d5da4c93ac56f$var$createFormControl(props),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $4c5d5da4c93ac56f$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($4c5d5da4c93ac56f$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(()=>{
        if (props.values && !$4c5d5da4c93ac56f$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(()=>{
        props.shouldUnregister && control._subjects.values.next({
            values: control._getWatch()
        });
    }, [
        props.shouldUnregister,
        control
    ]);
    _formControl.current.formState = $4c5d5da4c93ac56f$var$getProxyFormState(formState, control);
    return _formControl.current;
}

});


parcelRegister("68IWj", function(module, exports) {

$parcel$export(module.exports, "Checkbox", () => $47865977d5cb9f70$export$48513f6b9f8ce62d);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $h7Chj = parcelRequire("h7Chj");

var $7hMfd = parcelRequire("7hMfd");

var $cfkGk = parcelRequire("cfkGk");
"use client";
function $47865977d5cb9f70$var$_extends() {
    $47865977d5cb9f70$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $47865977d5cb9f70$var$_extends.apply(this, arguments);
}
function $47865977d5cb9f70$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $47865977d5cb9f70$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $47865977d5cb9f70$var$_typeof(o);
}
function $47865977d5cb9f70$var$_toPrimitive(input, hint) {
    if ($47865977d5cb9f70$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($47865977d5cb9f70$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $47865977d5cb9f70$var$_toPropertyKey(arg) {
    var key = $47865977d5cb9f70$var$_toPrimitive(arg, "string");
    return $47865977d5cb9f70$var$_typeof(key) === "symbol" ? key : String(key);
}
function $47865977d5cb9f70$var$_defineProperty(obj, key, value) {
    key = $47865977d5cb9f70$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $47865977d5cb9f70$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $47865977d5cb9f70$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $47865977d5cb9f70$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $47865977d5cb9f70$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $47865977d5cb9f70$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $47865977d5cb9f70$var$_arrayLikeToArray(o, minLen);
}
function $47865977d5cb9f70$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $47865977d5cb9f70$var$_slicedToArray(arr, i) {
    return $47865977d5cb9f70$var$_arrayWithHoles(arr) || $47865977d5cb9f70$var$_iterableToArrayLimit(arr, i) || $47865977d5cb9f70$var$_unsupportedIterableToArray(arr, i) || $47865977d5cb9f70$var$_nonIterableRest();
}
var $47865977d5cb9f70$var$classes = {
    box: "p-checkbox-box",
    input: "p-checkbox-input",
    icon: "p-checkbox-icon",
    root: function root(_ref) {
        var props = _ref.props, checked = _ref.checked, context = _ref.context;
        return (0, $cfkGk.classNames)("p-checkbox p-component", {
            "p-highlight": checked,
            "p-disabled": props.disabled,
            "p-invalid": props.invalid,
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled"
        });
    }
};
var $47865977d5cb9f70$var$CheckboxBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Checkbox",
        autoFocus: false,
        checked: false,
        className: null,
        disabled: false,
        falseValue: false,
        icon: null,
        id: null,
        inputId: null,
        inputRef: null,
        invalid: false,
        variant: null,
        name: null,
        onChange: null,
        onContextMenu: null,
        onMouseDown: null,
        readOnly: false,
        required: false,
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        trueValue: true,
        value: null,
        children: undefined
    },
    css: {
        classes: $47865977d5cb9f70$var$classes
    }
});
function $47865977d5cb9f70$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $47865977d5cb9f70$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $47865977d5cb9f70$var$ownKeys(Object(t), !0).forEach(function(r) {
            $47865977d5cb9f70$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $47865977d5cb9f70$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $47865977d5cb9f70$export$48513f6b9f8ce62d = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $47865977d5cb9f70$var$CheckboxBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState(false), _React$useState2 = $47865977d5cb9f70$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var _CheckboxBase$setMeta = $47865977d5cb9f70$var$CheckboxBase.setMetaData({
        props: props,
        state: {
            focused: focusedState
        },
        context: {
            checked: props.checked === props.trueValue,
            disabled: props.disabled
        }
    }), ptm = _CheckboxBase$setMeta.ptm, cx = _CheckboxBase$setMeta.cx, isUnstyled = _CheckboxBase$setMeta.isUnstyled;
    (0, $4gQLd.useHandleStyle)($47865977d5cb9f70$var$CheckboxBase.css.styles, isUnstyled, {
        name: "checkbox"
    });
    var elementRef = $81g6h.useRef(null);
    var inputRef = $81g6h.useRef(props.inputRef);
    var isChecked = function isChecked() {
        return props.checked === props.trueValue;
    };
    var _onChange = function onChange(event) {
        if (props.disabled || props.readonly) return;
        if (props.onChange) {
            var _props$onChange;
            var _checked = isChecked();
            var value = _checked ? props.falseValue : props.trueValue;
            var eventData = {
                originalEvent: event,
                value: props.value,
                checked: value,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    type: "checkbox",
                    name: props.name,
                    id: props.id,
                    value: props.value,
                    checked: value
                }
            };
            props === null || props === void 0 || (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, eventData);
            // do not continue if the user defined click wants to prevent
            if (event.defaultPrevented) return;
            (0, $cfkGk.DomHandler).focus(inputRef.current);
        }
    };
    var _onFocus = function onFocus() {
        var _props$onFocus;
        setFocusedState(true);
        props === null || props === void 0 || (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props);
    };
    var _onBlur = function onBlur() {
        var _props$onBlur;
        setFocusedState(false);
        props === null || props === void 0 || (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props);
    };
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            focus: function focus() {
                return (0, $cfkGk.DomHandler).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    $81g6h.useEffect(function() {
        (0, $cfkGk.ObjectUtils).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        inputRef.current.checked = isChecked();
    }, [
        props.checked,
        props.trueValue
    ]);
    (0, $l2NC0.useMountEffect)(function() {
        if (props.autoFocus) (0, $cfkGk.DomHandler).focus(inputRef.current, props.autoFocus);
    });
    var checked = isChecked();
    var hasTooltip = (0, $cfkGk.ObjectUtils).isNotEmpty(props.tooltip);
    var otherProps = $47865977d5cb9f70$var$CheckboxBase.getOtherProps(props);
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $cfkGk.classNames)(props.className, cx("root", {
            checked: checked,
            context: context
        })),
        style: props.style,
        "data-p-highlight": checked,
        "data-p-disabled": props.disabled,
        onContextMenu: props.onContextMenu,
        onMouseDown: props.onMouseDown
    }, otherProps, ptm("root"));
    var createInputElement = function createInputElement() {
        var ariaProps = (0, $cfkGk.ObjectUtils).reduceKeys(otherProps, (0, $cfkGk.DomHandler).ARIA_PROPS);
        var inputProps = mergeProps($47865977d5cb9f70$var$_objectSpread({
            id: props.inputId,
            type: "checkbox",
            className: cx("input"),
            name: props.name,
            tabIndex: props.tabIndex,
            onFocus: function onFocus(e) {
                return _onFocus();
            },
            onBlur: function onBlur(e) {
                return _onBlur();
            },
            onChange: function onChange(e) {
                return _onChange(e);
            },
            disabled: props.disabled,
            readOnly: props.readOnly,
            required: props.required,
            "aria-invalid": props.invalid,
            checked: checked
        }, ariaProps), ptm("input"));
        return /*#__PURE__*/ $81g6h.createElement("input", $47865977d5cb9f70$var$_extends({
            ref: inputRef
        }, inputProps));
    };
    var createBoxElement = function createBoxElement() {
        var iconProps = mergeProps({
            className: cx("icon")
        }, ptm("icon"));
        var boxProps = mergeProps({
            className: cx("box", {
                checked: checked
            }),
            "data-p-highlight": checked,
            "data-p-disabled": props.disabled
        }, ptm("box"));
        var icon = checked ? props.icon || /*#__PURE__*/ $81g6h.createElement((0, $h7Chj.CheckIcon), iconProps) : null;
        var checkboxIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $47865977d5cb9f70$var$_objectSpread({}, iconProps), {
            props: props,
            checked: checked
        });
        return /*#__PURE__*/ $81g6h.createElement("div", boxProps, checkboxIcon);
    };
    return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("div", $47865977d5cb9f70$var$_extends({
        ref: elementRef
    }, rootProps), createInputElement(), createBoxElement()), hasTooltip && /*#__PURE__*/ $81g6h.createElement((0, $7hMfd.Tooltip), $47865977d5cb9f70$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$47865977d5cb9f70$export$48513f6b9f8ce62d.displayName = "Checkbox";

});

parcelRegister("eT9rN", function(module, exports) {

$parcel$export(module.exports, "Dropdown", () => $ad6d87c8b3f19aa5$export$931cbfb6bfb85fc);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $jhJol = parcelRequire("jhJol");

var $dPQhb = parcelRequire("dPQhb");

var $4vsYR = parcelRequire("4vsYR");

var $k7ffa = parcelRequire("k7ffa");

var $7hMfd = parcelRequire("7hMfd");

var $cfkGk = parcelRequire("cfkGk");

var $lbdsH = parcelRequire("lbdsH");

var $bFyNR = parcelRequire("bFyNR");

var $6b4aU = parcelRequire("6b4aU");

var $2Sldw = parcelRequire("2Sldw");

var $9rbaG = parcelRequire("9rbaG");

var $h7Chj = parcelRequire("h7Chj");

var $2u9US = parcelRequire("2u9US");
"use client";
function $ad6d87c8b3f19aa5$var$_extends() {
    $ad6d87c8b3f19aa5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ad6d87c8b3f19aa5$var$_extends.apply(this, arguments);
}
function $ad6d87c8b3f19aa5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ad6d87c8b3f19aa5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ad6d87c8b3f19aa5$var$_typeof(o);
}
function $ad6d87c8b3f19aa5$var$_toPrimitive(input, hint) {
    if ($ad6d87c8b3f19aa5$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ad6d87c8b3f19aa5$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ad6d87c8b3f19aa5$var$_toPropertyKey(arg) {
    var key = $ad6d87c8b3f19aa5$var$_toPrimitive(arg, "string");
    return $ad6d87c8b3f19aa5$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ad6d87c8b3f19aa5$var$_defineProperty(obj, key, value) {
    key = $ad6d87c8b3f19aa5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ad6d87c8b3f19aa5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ad6d87c8b3f19aa5$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ad6d87c8b3f19aa5$var$_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ad6d87c8b3f19aa5$var$_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ad6d87c8b3f19aa5$var$_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ad6d87c8b3f19aa5$var$_arrayLikeToArray$1(o, minLen);
}
function $ad6d87c8b3f19aa5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ad6d87c8b3f19aa5$var$_slicedToArray(arr, i) {
    return $ad6d87c8b3f19aa5$var$_arrayWithHoles(arr) || $ad6d87c8b3f19aa5$var$_iterableToArrayLimit(arr, i) || $ad6d87c8b3f19aa5$var$_unsupportedIterableToArray$1(arr, i) || $ad6d87c8b3f19aa5$var$_nonIterableRest();
}
var $ad6d87c8b3f19aa5$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, focusedState = _ref.focusedState, overlayVisibleState = _ref.overlayVisibleState, context = _ref.context;
        return (0, $cfkGk.classNames)("p-dropdown p-component p-inputwrapper", {
            "p-disabled": props.disabled,
            "p-invalid": props.invalid,
            "p-focus": focusedState,
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled",
            "p-dropdown-clearable": props.showClear && !props.disabled,
            "p-inputwrapper-filled": (0, $cfkGk.ObjectUtils).isNotEmpty(props.value),
            "p-inputwrapper-focus": focusedState || overlayVisibleState
        });
    },
    input: function input(_ref2) {
        var props = _ref2.props, label = _ref2.label;
        return props.editable ? "p-dropdown-label p-inputtext" : (0, $cfkGk.classNames)("p-dropdown-label p-inputtext", {
            "p-placeholder": label === null && props.placeholder,
            "p-dropdown-label-empty": label === null && !props.placeholder
        });
    },
    trigger: "p-dropdown-trigger",
    emptyMessage: "p-dropdown-empty-message",
    itemGroup: function itemGroup(_ref3) {
        var optionGroupLabel = _ref3.optionGroupLabel;
        return (0, $cfkGk.classNames)("p-dropdown-item-group", {
            "p-dropdown-item-empty": !optionGroupLabel || optionGroupLabel.length === 0
        });
    },
    itemGroupLabel: "p-dropdown-item-group-label",
    dropdownIcon: "p-dropdown-trigger-icon p-clickable",
    loadingIcon: "p-dropdown-trigger-icon p-clickable",
    clearIcon: "p-dropdown-clear-icon p-clickable",
    filterIcon: "p-dropdown-filter-icon",
    filterClearIcon: "p-dropdown-filter-clear-icon",
    filterContainer: function filterContainer(_ref4) {
        var clearIcon = _ref4.clearIcon;
        return (0, $cfkGk.classNames)("p-dropdown-filter-container", {
            "p-dropdown-clearable-filter": !!clearIcon
        });
    },
    filterInput: function filterInput(_ref5) {
        var props = _ref5.props, context = _ref5.context;
        return (0, $cfkGk.classNames)("p-dropdown-filter p-inputtext p-component", {
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled"
        });
    },
    list: function list(_ref6) {
        var virtualScrollerOptions = _ref6.virtualScrollerOptions;
        return virtualScrollerOptions ? "p-dropdown-items" : "p-dropdown-items";
    },
    panel: function panel(_ref7) {
        var context = _ref7.context;
        return (0, $cfkGk.classNames)("p-dropdown-panel p-component", {
            "p-input-filled": context && context.inputStyle === "filled" || (0, $8Zwsm.default).inputStyle === "filled",
            "p-ripple-disabled": context && context.ripple === false || (0, $8Zwsm.default).ripple === false
        });
    },
    item: function item(_ref8) {
        var selected = _ref8.selected, disabled = _ref8.disabled, label = _ref8.label, index = _ref8.index, focusedOptionIndex = _ref8.focusedOptionIndex, highlightOnSelect = _ref8.highlightOnSelect;
        return (0, $cfkGk.classNames)("p-dropdown-item", {
            "p-highlight": selected && highlightOnSelect,
            "p-disabled": disabled,
            "p-focus": index === focusedOptionIndex,
            "p-dropdown-item-empty": !label || label.length === 0
        });
    },
    itemLabel: "p-dropdown-item-label",
    checkIcon: "p-dropdown-check-icon",
    blankIcon: "p-dropdown-blank-icon",
    wrapper: "p-dropdown-items-wrapper",
    header: "p-dropdown-header",
    footer: "p-dropdown-footer",
    transition: "p-connected-overlay"
};
var $ad6d87c8b3f19aa5$var$styles = "\n@layer primereact {\n    .p-dropdown {\n        display: inline-flex;\n        cursor: pointer;\n        position: relative;\n        user-select: none;\n    }\n    \n    .p-dropdown-trigger {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n    }\n    \n    .p-dropdown-label {\n        display: block;\n        white-space: nowrap;\n        overflow: hidden;\n        flex: 1 1 auto;\n        width: 1%;\n        text-overflow: ellipsis;\n        cursor: pointer;\n    }\n    \n    .p-dropdown-label-empty {\n        overflow: hidden;\n        visibility: hidden;\n    }\n    \n    input.p-dropdown-label  {\n        cursor: default;\n    }\n    \n    .p-dropdown .p-dropdown-panel {\n        min-width: 100%;\n    }\n    \n    .p-dropdown-panel {\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n    \n    .p-dropdown-items-wrapper {\n        overflow: auto;\n    }\n    \n    .p-dropdown-item {\n        cursor: pointer;\n        font-weight: normal;\n        white-space: nowrap;\n        position: relative;\n        overflow: hidden;\n    }\n    \n    .p-dropdown-items {\n        margin: 0;\n        padding: 0;\n        list-style-type: none;\n    }\n    \n    .p-dropdown-filter {\n        width: 100%;\n    }\n    \n    .p-dropdown-filter-container {\n        position: relative;\n    }\n    \n    .p-dropdown-clear-icon,\n    .p-dropdown-filter-icon,\n    .p-dropdown-filter-clear-icon {\n        position: absolute;\n        top: 50%;\n        margin-top: -.5rem;\n    }\n    \n    .p-fluid .p-dropdown {\n        display: flex;\n    }\n    \n    .p-fluid .p-dropdown .p-dropdown-label {\n        width: 1%;\n    }\n}\n";
var $ad6d87c8b3f19aa5$var$inlineStyles = {
    wrapper: function wrapper(_ref9) {
        var props = _ref9.props;
        return {
            maxHeight: props.scrollHeight || "auto"
        };
    },
    panel: function panel(_ref10) {
        var props = _ref10.props;
        props.panelStyle;
    }
};
var $ad6d87c8b3f19aa5$var$DropdownBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Dropdown",
        __parentMetadata: null,
        appendTo: null,
        ariaLabel: null,
        ariaLabelledBy: null,
        autoFocus: false,
        children: undefined,
        className: null,
        clearIcon: null,
        dataKey: null,
        disabled: false,
        dropdownIcon: null,
        editable: false,
        emptyFilterMessage: null,
        highlightOnSelect: true,
        checkmark: false,
        emptyMessage: null,
        filter: false,
        filterBy: null,
        filterClearIcon: null,
        filterIcon: null,
        filterInputAutoFocus: false,
        filterLocale: undefined,
        filterMatchMode: "contains",
        filterPlaceholder: null,
        filterTemplate: null,
        focusInputRef: null,
        id: null,
        inputId: null,
        inputRef: null,
        invalid: false,
        variant: null,
        itemTemplate: null,
        loading: false,
        loadingIcon: null,
        maxLength: null,
        name: null,
        onBlur: null,
        onChange: null,
        onContextMenu: null,
        onFilter: null,
        onFocus: null,
        onHide: null,
        onMouseDown: null,
        onShow: null,
        optionDisabled: null,
        optionGroupChildren: "items",
        selectOnFocus: false,
        focusOnHover: true,
        autoOptionFocus: false,
        optionGroupLabel: null,
        optionGroupTemplate: null,
        optionLabel: null,
        optionValue: null,
        options: null,
        panelClassName: null,
        panelFooterTemplate: null,
        panelStyle: null,
        placeholder: null,
        required: false,
        resetFilterOnHide: false,
        scrollHeight: "200px",
        showClear: false,
        showFilterClear: false,
        showOnFocus: false,
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        transitionOptions: null,
        value: null,
        valueTemplate: null,
        virtualScrollerOptions: null
    },
    css: {
        classes: $ad6d87c8b3f19aa5$var$classes,
        styles: $ad6d87c8b3f19aa5$var$styles,
        inlineStyles: $ad6d87c8b3f19aa5$var$inlineStyles
    }
});
var $ad6d87c8b3f19aa5$var$BlankIcon = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $ad6d87c8b3f19aa5$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("rect", {
        width: "1",
        height: "1",
        fill: "currentColor",
        fillOpacity: "0"
    }));
}));
$ad6d87c8b3f19aa5$var$BlankIcon.displayName = "BlankIcon";
var $ad6d87c8b3f19aa5$var$DropdownItem = /*#__PURE__*/ $81g6h.memo(function(props) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var ptm = props.ptm, cx = props.cx, selected = props.selected, disabled = props.disabled, option = props.option, label = props.label, index = props.index, focusedOptionIndex = props.focusedOptionIndex, checkmark = props.checkmark, highlightOnSelect = props.highlightOnSelect;
    var getPTOptions = function getPTOptions(key) {
        return ptm(key, {
            context: {
                selected: selected,
                disabled: disabled
            }
        });
    };
    var _onClick = function onClick(event, i) {
        if (props.onClick) props.onClick({
            originalEvent: event,
            option: option
        });
    };
    var content = props.template ? (0, $cfkGk.ObjectUtils).getJSXElement(props.template, props.option) : props.label;
    var itemProps = mergeProps({
        role: "option",
        key: props.label,
        className: (0, $cfkGk.classNames)(option.className, cx("item", {
            selected: selected,
            disabled: disabled,
            label: label,
            index: index,
            focusedOptionIndex: focusedOptionIndex,
            highlightOnSelect: highlightOnSelect
        })),
        style: props.style,
        onClick: function onClick(e) {
            return _onClick(e);
        },
        onMouseMove: function onMouseMove(e) {
            return props === null || props === void 0 ? void 0 : props.onMouseMove(e, index);
        },
        "aria-label": label,
        "aria-selected": selected,
        "data-p-highlight": selected,
        "data-p-focused": focusedOptionIndex === index,
        "data-p-disabled": disabled
    }, getPTOptions("item"));
    var itemGroupLabelProps = mergeProps({
        className: cx("itemLabel")
    }, getPTOptions("itemLabel"));
    var iconRenderer = function iconRenderer() {
        if (selected) {
            var checkIconProps = mergeProps({
                className: cx("checkIcon")
            }, getPTOptions("checkIcon"));
            return /*#__PURE__*/ $81g6h.createElement((0, $h7Chj.CheckIcon), checkIconProps);
        }
        var blankIconProps = mergeProps({
            className: cx("blankIcon")
        }, getPTOptions("blankIcon"));
        return /*#__PURE__*/ $81g6h.createElement($ad6d87c8b3f19aa5$var$BlankIcon, blankIconProps);
    };
    return /*#__PURE__*/ $81g6h.createElement("li", itemProps, checkmark && iconRenderer(), /*#__PURE__*/ $81g6h.createElement("span", itemGroupLabelProps, content), /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
});
$ad6d87c8b3f19aa5$var$DropdownItem.displayName = "DropdownItem";
function $ad6d87c8b3f19aa5$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad6d87c8b3f19aa5$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad6d87c8b3f19aa5$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $ad6d87c8b3f19aa5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad6d87c8b3f19aa5$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ad6d87c8b3f19aa5$var$DropdownPanel = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(props, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var ptm = props.ptm, cx = props.cx, sx = props.sx;
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var filterInputRef = $81g6h.useRef(null);
    var isEmptyFilter = !(props.visibleOptions && props.visibleOptions.length) && props.hasFilter;
    var filterOptions = {
        filter: function filter(e) {
            return onFilterInputChange(e);
        },
        reset: function reset() {
            return props.resetFilter();
        }
    };
    var getPTOptions = function getPTOptions(key, options) {
        return ptm(key, $ad6d87c8b3f19aa5$var$_objectSpread$1({
            hostName: props.hostName
        }, options));
    };
    var onEnter = function onEnter() {
        props.onEnter(function() {
            if (props.virtualScrollerRef.current) {
                var selectedIndex = props.getSelectedOptionIndex();
                if (selectedIndex !== -1) setTimeout(function() {
                    return props.virtualScrollerRef.current.scrollToIndex(selectedIndex);
                }, 0);
            }
        });
    };
    var onEntered = function onEntered() {
        props.onEntered(function() {
            if (props.filter && props.filterInputAutoFocus) (0, $cfkGk.DomHandler).focus(filterInputRef.current, false);
        });
    };
    var onFilterInputChange = function onFilterInputChange(event) {
        props.virtualScrollerRef.current && props.virtualScrollerRef.current.scrollToIndex(0);
        props.onFilterInputChange && props.onFilterInputChange(event);
    };
    var createFooter = function createFooter() {
        if (props.panelFooterTemplate) {
            var content = (0, $cfkGk.ObjectUtils).getJSXElement(props.panelFooterTemplate, props, props.onOverlayHide);
            var footerProps = mergeProps({
                className: cx("footer")
            }, getPTOptions("footer"));
            return /*#__PURE__*/ $81g6h.createElement("div", footerProps, content);
        }
        return null;
    };
    var changeFocusedItemOnHover = function changeFocusedItemOnHover(event, index) {
        if (props.focusOnHover) {
            var _props$changeFocusedO;
            props === null || props === void 0 || (_props$changeFocusedO = props.changeFocusedOptionIndex) === null || _props$changeFocusedO === void 0 || _props$changeFocusedO.call(props, event, index);
        }
    };
    var createEmptyMessage = function createEmptyMessage(emptyMessage, isFilter) {
        var message = (0, $cfkGk.ObjectUtils).getJSXElement(emptyMessage, props) || (0, $8Zwsm.localeOption)(isFilter ? "emptyFilterMessage" : "emptyMessage");
        var emptyMessageProps = mergeProps({
            className: cx("emptyMessage")
        }, getPTOptions("emptyMessage"));
        return /*#__PURE__*/ $81g6h.createElement("li", emptyMessageProps, message);
    };
    var createItem = function createItem(option, index) {
        var scrollerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var style = {
            height: scrollerOptions.props ? scrollerOptions.props.itemSize : undefined
        };
        style = $ad6d87c8b3f19aa5$var$_objectSpread$1($ad6d87c8b3f19aa5$var$_objectSpread$1({}, style), option.style);
        if (option.group && option.optionGroup && props.optionGroupLabel) {
            var optionGroupLabel = props.optionGroupLabel;
            var groupContent = props.optionGroupTemplate ? (0, $cfkGk.ObjectUtils).getJSXElement(props.optionGroupTemplate, option, index) : props.getOptionGroupLabel(option);
            var key = index + "_" + props.getOptionGroupRenderKey(option);
            var itemGroupProps = mergeProps({
                className: cx("itemGroup", {
                    optionGroupLabel: optionGroupLabel
                }),
                style: style,
                "data-p-highlight": props.selected
            }, getPTOptions("itemGroup"));
            var itemGroupLabelProps = mergeProps({
                className: cx("itemGroupLabel")
            }, getPTOptions("itemGroupLabel"));
            return /*#__PURE__*/ $81g6h.createElement("li", $ad6d87c8b3f19aa5$var$_extends({
                key: key
            }, itemGroupProps), /*#__PURE__*/ $81g6h.createElement("span", itemGroupLabelProps, groupContent));
        }
        var optionKey = props.getOptionRenderKey(option) + "_" + index;
        var optionLabel = props.getOptionLabel(option);
        var disabled = props.isOptionDisabled(option);
        return /*#__PURE__*/ $81g6h.createElement($ad6d87c8b3f19aa5$var$DropdownItem, {
            key: optionKey,
            label: optionLabel,
            index: index,
            focusedOptionIndex: props.focusedOptionIndex,
            option: option,
            style: style,
            template: props.itemTemplate,
            selected: props.isSelected(option),
            highlightOnSelect: props.highlightOnSelect,
            disabled: disabled,
            onClick: props.onOptionClick,
            onMouseMove: changeFocusedItemOnHover,
            ptm: ptm,
            cx: cx,
            checkmark: props.checkmark
        });
    };
    var createItems = function createItems() {
        if ((0, $cfkGk.ObjectUtils).isNotEmpty(props.visibleOptions)) return props.visibleOptions.map(createItem);
        else if (props.hasFilter) return createEmptyMessage(props.emptyFilterMessage, true);
        return createEmptyMessage(props.emptyMessage);
    };
    var createFilterClearIcon = function createFilterClearIcon() {
        if (props.showFilterClear && props.filterValue) {
            var ariaLabel = (0, $8Zwsm.localeOption)("clear");
            var clearIconProps = mergeProps({
                className: cx("filterClearIcon"),
                "aria-label": ariaLabel,
                onClick: function onClick() {
                    return props.onFilterClearIconClick(function() {
                        return (0, $cfkGk.DomHandler).focus(filterInputRef.current);
                    });
                }
            }, getPTOptions("filterClearIcon"));
            var icon = props.filterClearIcon || /*#__PURE__*/ $81g6h.createElement((0, $4vsYR.TimesIcon), clearIconProps);
            var filterClearIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $ad6d87c8b3f19aa5$var$_objectSpread$1({}, clearIconProps), {
                props: props
            });
            return filterClearIcon;
        }
        return null;
    };
    var createFilter = function createFilter() {
        if (props.filter) {
            var clearIcon = createFilterClearIcon();
            var filterIconProps = mergeProps({
                className: cx("filterIcon")
            }, getPTOptions("filterIcon"));
            var icon = props.filterIcon || /*#__PURE__*/ $81g6h.createElement((0, $bFyNR.SearchIcon), filterIconProps);
            var filterIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $ad6d87c8b3f19aa5$var$_objectSpread$1({}, filterIconProps), {
                props: props
            });
            var filterContainerProps = mergeProps({
                className: cx("filterContainer", {
                    clearIcon: clearIcon
                })
            }, getPTOptions("filterContainer"));
            var filterInputProps = mergeProps({
                ref: filterInputRef,
                type: "text",
                autoComplete: "off",
                className: cx("filterInput", {
                    context: context
                }),
                placeholder: props.filterPlaceholder,
                onKeyDown: props.onFilterInputKeyDown,
                onChange: function onChange(e) {
                    return onFilterInputChange(e);
                },
                value: props.filterValue
            }, getPTOptions("filterInput"));
            var content = /*#__PURE__*/ $81g6h.createElement("div", filterContainerProps, /*#__PURE__*/ $81g6h.createElement("input", filterInputProps), clearIcon, filterIcon);
            if (props.filterTemplate) {
                var defaultContentOptions = {
                    className: (0, $cfkGk.classNames)("p-dropdown-filter-container", {
                        "p-dropdown-clearable-filter": !!clearIcon
                    }),
                    element: content,
                    filterOptions: filterOptions,
                    filterInputKeyDown: props.onFilterInputKeyDown,
                    filterInputChange: onFilterInputChange,
                    filterIconClassName: "p-dropdown-filter-icon",
                    clearIcon: clearIcon,
                    props: props
                };
                content = (0, $cfkGk.ObjectUtils).getJSXElement(props.filterTemplate, defaultContentOptions);
            }
            var headerProps = mergeProps({
                className: cx("header")
            }, getPTOptions("header"));
            return /*#__PURE__*/ $81g6h.createElement("div", headerProps, content);
        }
        return null;
    };
    var createContent = function createContent() {
        if (props.virtualScrollerOptions) {
            var virtualScrollerProps = $ad6d87c8b3f19aa5$var$_objectSpread$1($ad6d87c8b3f19aa5$var$_objectSpread$1({}, props.virtualScrollerOptions), {
                style: $ad6d87c8b3f19aa5$var$_objectSpread$1($ad6d87c8b3f19aa5$var$_objectSpread$1({}, props.virtualScrollerOptions.style), {
                    height: props.scrollHeight
                }),
                className: (0, $cfkGk.classNames)("p-dropdown-items-wrapper", props.virtualScrollerOptions.className),
                items: props.visibleOptions,
                autoSize: true,
                onLazyLoad: function onLazyLoad(event) {
                    return props.virtualScrollerOptions.onLazyLoad($ad6d87c8b3f19aa5$var$_objectSpread$1($ad6d87c8b3f19aa5$var$_objectSpread$1({}, event), {
                        filter: props.filterValue
                    }));
                },
                itemTemplate: function itemTemplate(item, options) {
                    return item && createItem(item, options.index, options);
                },
                contentTemplate: function contentTemplate(options) {
                    var emptyMessage = props.hasFilter ? props.emptyFilterMessage : props.emptyMessage;
                    var content = isEmptyFilter ? createEmptyMessage(emptyMessage) : options.children;
                    var listProps = mergeProps({
                        ref: options.contentRef,
                        style: options.style,
                        className: (0, $cfkGk.classNames)(options.className, cx("list", {
                            virtualScrollerProps: props.virtualScrollerOptions
                        })),
                        role: "listbox"
                    }, getPTOptions("list"));
                    return /*#__PURE__*/ $81g6h.createElement("ul", listProps, content);
                }
            });
            return /*#__PURE__*/ $81g6h.createElement((0, $2Sldw.VirtualScroller), $ad6d87c8b3f19aa5$var$_extends({
                ref: props.virtualScrollerRef
            }, virtualScrollerProps, {
                pt: ptm("virtualScroller")
            }));
        }
        var items = createItems();
        var wrapperProps = mergeProps({
            className: cx("wrapper"),
            style: sx("wrapper")
        }, getPTOptions("wrapper"));
        var listProps = mergeProps({
            className: cx("list"),
            role: "listbox"
        }, getPTOptions("list"));
        return /*#__PURE__*/ $81g6h.createElement("div", wrapperProps, /*#__PURE__*/ $81g6h.createElement("ul", listProps, items));
    };
    var createElement = function createElement() {
        var filter = createFilter();
        var content = createContent();
        var footer = createFooter();
        var panelProps = mergeProps({
            className: (0, $cfkGk.classNames)(props.panelClassName, cx("panel", {
                context: context
            })),
            style: sx("panel"),
            onClick: props.onClick
        }, getPTOptions("panel"));
        var transitionProps = mergeProps({
            classNames: cx("transition"),
            "in": props["in"],
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: onEnter,
            onEntered: onEntered,
            onExit: props.onExit,
            onExited: props.onExited
        }, getPTOptions("transition"));
        return /*#__PURE__*/ $81g6h.createElement((0, $lbdsH.CSSTransition), $ad6d87c8b3f19aa5$var$_extends({
            nodeRef: ref
        }, transitionProps), /*#__PURE__*/ $81g6h.createElement("div", $ad6d87c8b3f19aa5$var$_extends({
            ref: ref
        }, panelProps), props.firstFocusableElement, filter, content, footer, props.lastFocusableElement));
    };
    var element = createElement();
    return /*#__PURE__*/ $81g6h.createElement((0, $6b4aU.Portal), {
        element: element,
        appendTo: props.appendTo
    });
}));
$ad6d87c8b3f19aa5$var$DropdownPanel.displayName = "DropdownPanel";
function $ad6d87c8b3f19aa5$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $ad6d87c8b3f19aa5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $ad6d87c8b3f19aa5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ad6d87c8b3f19aa5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ad6d87c8b3f19aa5$var$_arrayLikeToArray(o, minLen);
}
function $ad6d87c8b3f19aa5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ad6d87c8b3f19aa5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad6d87c8b3f19aa5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad6d87c8b3f19aa5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ad6d87c8b3f19aa5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad6d87c8b3f19aa5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ad6d87c8b3f19aa5$export$931cbfb6bfb85fc = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $ad6d87c8b3f19aa5$var$DropdownBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState(""), _React$useState2 = $ad6d87c8b3f19aa5$var$_slicedToArray(_React$useState, 2), filterState = _React$useState2[0], setFilterState = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(false), _React$useState4 = $ad6d87c8b3f19aa5$var$_slicedToArray(_React$useState3, 2), focusedState = _React$useState4[0], setFocusedState = _React$useState4[1];
    var _React$useState5 = $81g6h.useState(-1), _React$useState6 = $ad6d87c8b3f19aa5$var$_slicedToArray(_React$useState5, 2), focusedOptionIndex = _React$useState6[0], setFocusedOptionIndex = _React$useState6[1];
    var _React$useState7 = $81g6h.useState(false), _React$useState8 = $ad6d87c8b3f19aa5$var$_slicedToArray(_React$useState7, 2), overlayVisibleState = _React$useState8[0], setOverlayVisibleState = _React$useState8[1];
    var clickedRef = $81g6h.useRef(false);
    var elementRef = $81g6h.useRef(null);
    var overlayRef = $81g6h.useRef(null);
    var firstHiddenFocusableElementOnOverlay = $81g6h.useRef(null);
    var lastHiddenFocusableElementOnOverlay = $81g6h.useRef(null);
    var inputRef = $81g6h.useRef(props.inputRef);
    var focusInputRef = $81g6h.useRef(props.focusInputRef);
    var virtualScrollerRef = $81g6h.useRef(null);
    var searchTimeout = $81g6h.useRef(null);
    var searchValue = $81g6h.useRef(null);
    $81g6h.useRef(null);
    var isLazy = props.virtualScrollerOptions && props.virtualScrollerOptions.lazy;
    var hasFilter = (0, $cfkGk.ObjectUtils).isNotEmpty(filterState);
    var appendTo = props.appendTo || context && context.appendTo || (0, $8Zwsm.default).appendTo;
    var _DropdownBase$setMeta = $ad6d87c8b3f19aa5$var$DropdownBase.setMetaData($ad6d87c8b3f19aa5$var$_objectSpread($ad6d87c8b3f19aa5$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        state: {
            filter: filterState,
            focused: focusedState,
            overlayVisible: overlayVisibleState
        }
    })), ptm = _DropdownBase$setMeta.ptm, cx = _DropdownBase$setMeta.cx, sx = _DropdownBase$setMeta.sx, isUnstyled = _DropdownBase$setMeta.isUnstyled;
    (0, $4gQLd.useHandleStyle)($ad6d87c8b3f19aa5$var$DropdownBase.css.styles, isUnstyled, {
        name: "dropdown"
    });
    var _useOverlayListener = (0, $l2NC0.useOverlayListener)({
        target: elementRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var type = _ref.type, valid = _ref.valid;
            if (valid) type === "outside" ? !isClearClicked(event) && hide() : hide();
        },
        when: overlayVisibleState
    }), _useOverlayListener2 = $ad6d87c8b3f19aa5$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var flatOptions = function flatOptions(options) {
        return (options || []).reduce(function(result, option, index) {
            result.push({
                optionGroup: option,
                group: true,
                index: index,
                code: option.code,
                label: option.label
            });
            var optionGroupChildren = getOptionGroupChildren(option);
            optionGroupChildren && optionGroupChildren.forEach(function(o) {
                return result.push(o);
            });
            return result;
        }, []);
    };
    var getVisibleOptions = function getVisibleOptions() {
        var options = props.optionGroupLabel ? flatOptions(props.options) : props.options;
        if (hasFilter && !isLazy) {
            var filterValue = filterState.trim().toLocaleLowerCase(props.filterLocale);
            var searchFields = props.filterBy ? props.filterBy.split(",") : [
                props.optionLabel || "label"
            ];
            if (props.optionGroupLabel) {
                var filteredGroups = [];
                var _iterator = $ad6d87c8b3f19aa5$var$_createForOfIteratorHelper(props.options), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var optgroup = _step.value;
                        var filteredSubOptions = (0, $8Zwsm.FilterService).filter(getOptionGroupChildren(optgroup), searchFields, filterValue, props.filterMatchMode, props.filterLocale);
                        if (filteredSubOptions && filteredSubOptions.length) filteredGroups.push($ad6d87c8b3f19aa5$var$_objectSpread($ad6d87c8b3f19aa5$var$_objectSpread({}, optgroup), $ad6d87c8b3f19aa5$var$_defineProperty({}, "".concat(props.optionGroupChildren), filteredSubOptions)));
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return flatOptions(filteredGroups);
            }
            return (0, $8Zwsm.FilterService).filter(options, searchFields, filterValue, props.filterMatchMode, props.filterLocale);
        }
        return options;
    };
    var onFirstHiddenFocus = function onFirstHiddenFocus(event) {
        var focusableEl = event.relatedTarget === focusInputRef.current ? (0, $cfkGk.DomHandler).getFirstFocusableElement(overlayRef.current, ':not([data-p-hidden-focusable="true"])') : focusInputRef.current;
        (0, $cfkGk.DomHandler).focus(focusableEl);
    };
    var onLastHiddenFocus = function onLastHiddenFocus(event) {
        var focusableEl = event.relatedTarget === focusInputRef.current ? (0, $cfkGk.DomHandler).getLastFocusableElement(overlayRef.current, ':not([data-p-hidden-focusable="true"])') : focusInputRef.current;
        (0, $cfkGk.DomHandler).focus(focusableEl);
    };
    var isClearClicked = function isClearClicked(event) {
        return (0, $cfkGk.DomHandler).isAttributeEquals(event.target, "data-pc-section", "clearicon") || (0, $cfkGk.DomHandler).isAttributeEquals(event.target.parentElement || event.target, "data-pc-section", "filterclearicon");
    };
    var _onClick = function onClick(event) {
        if (props.disabled || props.loading) return;
        props.onClick && props.onClick(event);
        // do not continue if the user defined click wants to prevent it
        if (event.defaultPrevented) return;
        if (isClearClicked(event) || event.target.tagName === "INPUT") return;
        else if (!overlayRef.current || !(overlayRef.current && overlayRef.current.contains(event.target))) {
            (0, $cfkGk.DomHandler).focus(focusInputRef.current);
            overlayVisibleState ? hide() : show();
        }
        clickedRef.current = true;
    };
    var onInputFocus = function onInputFocus(event) {
        if (props.showOnFocus && !overlayVisibleState) show();
        setFocusedState(true);
        props.onFocus && props.onFocus(event);
    };
    var onInputBlur = function onInputBlur(event) {
        setFocusedState(false);
        if (props.onBlur) setTimeout(function() {
            var currentValue = inputRef.current ? inputRef.current.value : undefined;
            props.onBlur({
                originalEvent: event.originalEvent,
                value: currentValue,
                stopPropagation: function stopPropagation() {
                    event.originalEvent.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event.originalEvent.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: currentValue
                }
            });
        }, 200);
    };
    var onOptionSelect = function onOptionSelect(event, option) {
        var isHide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        selectItem({
            originalEvent: event,
            option: option
        });
        isHide && hide();
    };
    var onPanelClick = function onPanelClick(event) {
        (0, $k7ffa.OverlayService).emit("overlay-click", {
            originalEvent: event,
            target: elementRef.current
        });
    };
    var onInputKeyDown = function onInputKeyDown(event) {
        if (props.disabled || (0, $cfkGk.DomHandler).isAndroid()) {
            event.preventDefault();
            return;
        }
        var metaKey = event.metaKey || event.ctrlKey;
        switch(event.code){
            case "ArrowDown":
                onArrowDownKey(event);
                break;
            case "ArrowUp":
                onArrowUpKey(event);
                break;
            case "ArrowLeft":
            case "ArrowRight":
                onArrowLeftKey(event, props.editable);
                break;
            case "Home":
                onHomeKey(event);
                break;
            case "End":
                onEndKey(event);
                break;
            case "PageDown":
                onPageDownKey(event);
                break;
            case "PageUp":
                onPageUpKey(event);
                break;
            case "Space":
                onSpaceKey(event, props.editable);
                break;
            case "NumpadEnter":
            case "Enter":
                onEnterKey(event);
                break;
            case "Escape":
                onEscapeKey(event);
                break;
            case "Tab":
                onTabKey(event);
                break;
            case "Backspace":
                onBackspaceKey(event, props.editable);
                break;
            case "ShiftLeft":
            case "ShiftRight":
                break;
            default:
                if (!metaKey && (0, $cfkGk.ObjectUtils).isPrintableCharacter(event.key)) {
                    !overlayVisibleState && !props.editable && show();
                    !props.editable && searchOptions(event, event.key);
                }
                break;
        }
        clickedRef.current = false;
    };
    var onFilterInputKeyDown = function onFilterInputKeyDown(event) {
        switch(event.code){
            case "ArrowDown":
                onArrowDownKey(event);
                break;
            case "ArrowUp":
                onArrowUpKey(event);
                break;
            case "ArrowLeft":
            case "ArrowRight":
                onArrowLeftKey(event, true);
                break;
            case "Escape":
            case "Enter":
            case "NumpadEnter":
                onEnterKey(event);
                event.preventDefault();
                break;
        }
    };
    var hasFocusableElements = function hasFocusableElements() {
        return (0, $cfkGk.DomHandler).getFocusableElements(overlayRef.current, ':not([data-p-hidden-focusable="true"])').length > 0;
    };
    var isOptionMatched = function isOptionMatched(option) {
        var _getOptionLabel;
        return isValidOption(option) && ((_getOptionLabel = getOptionLabel(option)) === null || _getOptionLabel === void 0 ? void 0 : _getOptionLabel.toLocaleLowerCase(props.filterLocale).startsWith(searchValue.current.toLocaleLowerCase(props.filterLocale)));
    };
    var isValidOption = function isValidOption(option) {
        return (0, $cfkGk.ObjectUtils).isNotEmpty(option) && !(isOptionDisabled(option) || isOptionGroup(option));
    };
    var hasSelectedOption = function hasSelectedOption() {
        return (0, $cfkGk.ObjectUtils).isNotEmpty(props.value);
    };
    var isValidSelectedOption = function isValidSelectedOption(option) {
        return isValidOption(option) && isSelected(option);
    };
    var findSelectedOptionIndex = function findSelectedOptionIndex() {
        return hasSelectedOption ? visibleOptions.findIndex(function(option) {
            return isValidSelectedOption(option);
        }) : -1;
    };
    var findFirstFocusedOptionIndex = function findFirstFocusedOptionIndex() {
        var selectedIndex = findSelectedOptionIndex();
        return selectedIndex < 0 ? findFirstOptionIndex() : selectedIndex;
    };
    var searchOptions = function searchOptions(event, _char) {
        searchValue.current = (searchValue.current || "") + _char;
        var optionIndex = -1;
        var matched = false;
        if ((0, $cfkGk.ObjectUtils).isNotEmpty(searchValue.current)) {
            if (focusedOptionIndex !== -1) {
                optionIndex = visibleOptions.slice(focusedOptionIndex).findIndex(function(option) {
                    return isOptionMatched(option);
                });
                optionIndex = optionIndex === -1 ? visibleOptions.slice(0, focusedOptionIndex).findIndex(function(option) {
                    return isOptionMatched(option);
                }) : optionIndex + focusedOptionIndex;
            } else optionIndex = visibleOptions.findIndex(function(option) {
                return isOptionMatched(option);
            });
            if (optionIndex !== -1) matched = true;
            if (optionIndex === -1 && focusedOptionIndex === -1) optionIndex = findFirstFocusedOptionIndex();
            if (optionIndex !== -1) changeFocusedOptionIndex(event, optionIndex);
        }
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(function() {
            searchValue.current = "";
            searchTimeout.current = null;
        }, 500);
        return matched;
    };
    var findLastFocusedOptionIndex = function findLastFocusedOptionIndex() {
        var selectedIndex = findSelectedOptionIndex();
        return selectedIndex < 0 ? findLastOptionIndex() : selectedIndex;
    };
    var findFirstOptionIndex = function findFirstOptionIndex() {
        return visibleOptions.findIndex(function(option) {
            return isValidOption(option);
        });
    };
    var findLastOptionIndex = function findLastOptionIndex() {
        return (0, $cfkGk.ObjectUtils).findLastIndex(visibleOptions, function(option) {
            return isValidOption(option);
        });
    };
    var findNextOptionIndex = function findNextOptionIndex(index) {
        var matchedOptionIndex = index < visibleOptions.length - 1 ? visibleOptions.slice(index + 1).findIndex(function(option) {
            return isValidOption(option);
        }) : -1;
        return matchedOptionIndex > -1 ? matchedOptionIndex + index + 1 : index;
    };
    var findPrevOptionIndex = function findPrevOptionIndex(index) {
        var matchedOptionIndex = index > 0 ? (0, $cfkGk.ObjectUtils).findLastIndex(visibleOptions.slice(0, index), function(option) {
            return isValidOption(option);
        }) : -1;
        return matchedOptionIndex > -1 ? matchedOptionIndex : index;
    };
    var changeFocusedOptionIndex = function changeFocusedOptionIndex(event, index) {
        if (focusedOptionIndex !== index) {
            setFocusedOptionIndex(index);
            if (props.selectOnFocus) onOptionSelect(event, visibleOptions[index], false);
        }
    };
    var onArrowDownKey = function onArrowDownKey(event) {
        if (!overlayVisibleState) {
            show();
            props.editable && changeFocusedOptionIndex(event, findSelectedOptionIndex());
        } else {
            var optionIndex = focusedOptionIndex !== -1 ? findNextOptionIndex(focusedOptionIndex) : clickedRef.current ? findFirstOptionIndex() : findFirstFocusedOptionIndex();
            changeFocusedOptionIndex(event, optionIndex);
        }
        event.preventDefault();
    };
    var onArrowUpKey = function onArrowUpKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (event.altKey && !pressedInInputText) {
            if (focusedOptionIndex !== -1) onOptionSelect(event, visibleOptions[focusedOptionIndex]);
            state.overlayVisible && hide();
            event.preventDefault();
        } else {
            var optionIndex = focusedOptionIndex !== -1 ? findPrevOptionIndex(focusedOptionIndex) : clickedRef.current ? findLastOptionIndex() : findLastFocusedOptionIndex();
            changeFocusedOptionIndex(event, optionIndex);
            !overlayVisibleState && show();
            event.preventDefault();
        }
    };
    var onArrowLeftKey = function onArrowLeftKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        pressedInInputText && setFocusedOptionIndex(-1);
    };
    var onHomeKey = function onHomeKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (pressedInInputText) {
            event.currentTarget.setSelectionRange(0, 0);
            setFocusedOptionIndex(-1);
        } else {
            changeFocusedOptionIndex(event, findFirstOptionIndex());
            !overlayVisibleState && show();
        }
        event.preventDefault();
    };
    var onEndKey = function onEndKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (pressedInInputText) {
            var target = event.currentTarget;
            var len = target.value.length;
            target.setSelectionRange(len, len);
            setFocusedOptionIndex(-1);
        } else {
            changeFocusedOptionIndex(event, findLastOptionIndex());
            !overlayVisibleState && show();
        }
        event.preventDefault();
    };
    var onPageUpKey = function onPageUpKey(event) {
        event.preventDefault();
    };
    var onPageDownKey = function onPageDownKey(event) {
        event.preventDefault();
    };
    var onSpaceKey = function onSpaceKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        !pressedInInputText && onEnterKey(event);
    };
    var onEnterKey = function onEnterKey(event) {
        if (!overlayVisibleState) {
            setFocusedOptionIndex(-1);
            onArrowDownKey(event);
        } else {
            if (focusedOptionIndex !== -1) onOptionSelect(event, visibleOptions[focusedOptionIndex]);
            hide();
        }
        event.preventDefault();
    };
    var onEscapeKey = function onEscapeKey(event) {
        overlayVisibleState && hide();
        event.preventDefault();
    };
    var onTabKey = function onTabKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (!pressedInInputText) {
            if (overlayVisibleState && !hasFocusableElements()) {
                (0, $cfkGk.DomHandler).focus(firstHiddenFocusableElementOnOverlay.current);
                event.preventDefault();
            } else {
                if (focusedOptionIndex !== -1) onOptionSelect(event, visibleOptions[focusedOptionIndex]);
                overlayVisibleState && hide();
            }
        }
    };
    var onBackspaceKey = function onBackspaceKey(event) {
        var pressedInInputText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (pressedInInputText) !overlayVisibleState && show();
    };
    var onEditableInputChange = function onEditableInputChange(event) {
        !overlayVisibleState && show();
        var searchIndex = null;
        if (event.target.value && visibleOptions) searchIndex = visibleOptions.findIndex(function(item) {
            return getOptionLabel(item).toLocaleLowerCase().startsWith(event.target.value.toLocaleLowerCase());
        });
        setFocusedOptionIndex(searchIndex);
        if (props.onChange) props.onChange({
            originalEvent: event.originalEvent,
            value: event.target.value,
            stopPropagation: function stopPropagation() {
                event.originalEvent.stopPropagation();
            },
            preventDefault: function preventDefault() {
                event.originalEvent.preventDefault();
            },
            target: {
                name: props.name,
                id: props.id,
                value: event.target.value
            }
        });
    };
    var onEditableInputFocus = function onEditableInputFocus(event) {
        setFocusedState(true);
        hide();
        props.onFocus && props.onFocus(event);
    };
    var onOptionClick = function onOptionClick(event) {
        var option = event.option;
        if (!option.disabled) {
            selectItem(event);
            (0, $cfkGk.DomHandler).focus(focusInputRef.current);
        }
        hide();
    };
    var onFilterInputChange = function onFilterInputChange(event) {
        var filter = event.target.value;
        setFilterState(filter);
        if (props.onFilter) props.onFilter({
            originalEvent: event,
            filter: filter
        });
    };
    var onFilterClearIconClick = function onFilterClearIconClick(callback) {
        resetFilter(callback);
    };
    var resetFilter = function resetFilter(callback) {
        setFilterState("");
        props.onFilter && props.onFilter({
            filter: ""
        });
        callback && callback();
    };
    var clear = function clear(event) {
        if (props.onChange) props.onChange({
            originalEvent: event,
            value: undefined,
            stopPropagation: function stopPropagation() {
                event === null || event === void 0 || event.stopPropagation();
            },
            preventDefault: function preventDefault() {
                event === null || event === void 0 || event.preventDefault();
            },
            target: {
                name: props.name,
                id: props.id,
                value: undefined
            }
        });
        if (props.filter) resetFilter();
        updateEditableLabel();
    };
    var selectItem = function selectItem(event) {
        if (selectedOption !== event.option) {
            updateEditableLabel(event.option);
            setFocusedOptionIndex(-1);
            var optionValue = getOptionValue(event.option);
            var selectedOptionIndex = findOptionIndexInList(event.option, visibleOptions);
            if (props.onChange) props.onChange({
                originalEvent: event.originalEvent,
                value: optionValue,
                stopPropagation: function stopPropagation() {
                    event.originalEvent.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event.originalEvent.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: optionValue
                }
            });
            changeFocusedOptionIndex(event.originalEvent, selectedOptionIndex);
        }
    };
    var getSelectedOptionIndex = function getSelectedOptionIndex(options) {
        options = options || visibleOptions;
        if (props.value != null && options) {
            if (props.optionGroupLabel) for(var i = 0; i < options.length; i++){
                var selectedOptionIndex = findOptionIndexInList(props.value, getOptionGroupChildren(options[i]));
                if (selectedOptionIndex !== -1) return {
                    group: i,
                    option: selectedOptionIndex
                };
            }
            else return findOptionIndexInList(props.value, options);
        }
        return -1;
    };
    var equalityKey = function equalityKey() {
        return props.optionValue ? null : props.dataKey;
    };
    var findOptionIndexInList = function findOptionIndexInList(value, list) {
        var key = equalityKey();
        return list.findIndex(function(item) {
            return (0, $cfkGk.ObjectUtils).equals(value, getOptionValue(item), key);
        });
    };
    var isSelected = function isSelected(option) {
        return (0, $cfkGk.ObjectUtils).equals(props.value, getOptionValue(option), equalityKey());
    };
    var show = function show() {
        setFocusedOptionIndex(focusedOptionIndex !== -1 ? focusedOptionIndex : props.autoOptionFocus ? findFirstFocusedOptionIndex() : props.editable ? -1 : findSelectedOptionIndex());
        setOverlayVisibleState(true);
    };
    var hide = function hide() {
        setOverlayVisibleState(false);
        clickedRef.current = false;
    };
    var onFocus = function onFocus() {
        if (props.editable && !overlayVisibleState && clickedRef.current === false) (0, $cfkGk.DomHandler).focus(inputRef.current);
    };
    var onOverlayEnter = function onOverlayEnter(callback) {
        (0, $cfkGk.ZIndexUtils).set("overlay", overlayRef.current, context && context.autoZIndex || (0, $8Zwsm.default).autoZIndex, context && context.zIndex.overlay || (0, $8Zwsm.default).zIndex.overlay);
        (0, $cfkGk.DomHandler).addStyles(overlayRef.current, {
            position: "absolute",
            top: "0",
            left: "0"
        });
        alignOverlay();
        callback && callback();
    };
    var onOverlayEntered = function onOverlayEntered(callback) {
        callback && callback();
        bindOverlayListener();
        props.onShow && props.onShow();
    };
    var onOverlayExit = function onOverlayExit() {
        unbindOverlayListener();
    };
    var onOverlayExited = function onOverlayExited() {
        if (props.filter && props.resetFilterOnHide) resetFilter();
        (0, $cfkGk.ZIndexUtils).clear(overlayRef.current);
        props.onHide && props.onHide();
    };
    var alignOverlay = function alignOverlay() {
        (0, $cfkGk.DomHandler).alignOverlay(overlayRef.current, inputRef.current.parentElement, props.appendTo || context && context.appendTo || (0, $8Zwsm.default).appendTo);
    };
    var scrollInView = function scrollInView() {
        var focusedItem = (0, $cfkGk.DomHandler).findSingle(overlayRef.current, 'li[data-p-focused="true"]');
        if (focusedItem && focusedItem.scrollIntoView) focusedItem.scrollIntoView({
            block: "nearest",
            inline: "nearest"
        });
        else {
            var highlightItem = (0, $cfkGk.DomHandler).findSingle(overlayRef.current, 'li[data-p-highlight="true"]');
            if (highlightItem && highlightItem.scrollIntoView) highlightItem.scrollIntoView({
                block: "nearest",
                inline: "nearest"
            });
        }
    };
    var updateEditableLabel = function updateEditableLabel(option) {
        if (inputRef.current) {
            inputRef.current.value = option ? getOptionLabel(option) : props.value || "";
            // #1413 NVDA screenreader
            if (focusInputRef.current) focusInputRef.current.value = inputRef.current.value;
        }
    };
    var getOptionLabel = function getOptionLabel(option) {
        var optionLabel = props.optionLabel ? (0, $cfkGk.ObjectUtils).resolveFieldData(option, props.optionLabel) : (0, $cfkGk.ObjectUtils).resolveFieldData(option, "label");
        return (0, $cfkGk.ObjectUtils).isNotEmpty(optionLabel) ? optionLabel : option;
    };
    var getOptionValue = function getOptionValue(option) {
        var optionValue = props.OptionValue ? (0, $cfkGk.ObjectUtils).resolveFieldData(option, props.optionValue) : (0, $cfkGk.ObjectUtils).resolveFieldData(option, "value");
        return (0, $cfkGk.ObjectUtils).isNotEmpty(optionValue) ? optionValue : option;
    };
    var getOptionRenderKey = function getOptionRenderKey(option) {
        return props.dataKey ? (0, $cfkGk.ObjectUtils).resolveFieldData(option, props.dataKey) : getOptionLabel(option);
    };
    var isOptionGroup = function isOptionGroup(option) {
        return props.optionGroupLabel && option.optionGroup && option.group;
    };
    var isOptionDisabled = function isOptionDisabled(option) {
        if (props.optionDisabled) return (0, $cfkGk.ObjectUtils).isFunction(props.optionDisabled) ? props.optionDisabled(option) : (0, $cfkGk.ObjectUtils).resolveFieldData(option, props.optionDisabled);
        return option && option.disabled !== undefined ? option.disabled : false;
    };
    var getOptionGroupRenderKey = function getOptionGroupRenderKey(optionGroup) {
        return (0, $cfkGk.ObjectUtils).resolveFieldData(optionGroup, props.optionGroupLabel);
    };
    var getOptionGroupLabel = function getOptionGroupLabel(optionGroup) {
        return (0, $cfkGk.ObjectUtils).resolveFieldData(optionGroup, props.optionGroupLabel);
    };
    var getOptionGroupChildren = function getOptionGroupChildren(optionGroup) {
        return (0, $cfkGk.ObjectUtils).resolveFieldData(optionGroup, props.optionGroupChildren);
    };
    var updateInputField = function updateInputField() {
        if (props.editable && inputRef.current) {
            var label = selectedOption ? getOptionLabel(selectedOption) : null;
            var value = label || props.value || "";
            inputRef.current.value = value;
            // #1413 NVDA screenreader
            if (focusInputRef.current) focusInputRef.current.value = value;
        }
    };
    var getSelectedOption = function getSelectedOption() {
        var index = getSelectedOptionIndex(props.options);
        return index !== -1 ? props.optionGroupLabel ? getOptionGroupChildren(props.options[index.group])[index.option] : props.options[index] : null;
    };
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            hide: hide,
            clear: clear,
            focus: function focus() {
                return (0, $cfkGk.DomHandler).focus(focusInputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getOverlay: function getOverlay() {
                return overlayRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            },
            getFocusInput: function getFocusInput() {
                return focusInputRef.current;
            },
            getVirtualScroller: function getVirtualScroller() {
                return virtualScrollerRef.current;
            }
        };
    });
    $81g6h.useEffect(function() {
        (0, $cfkGk.ObjectUtils).combinedRefs(inputRef, props.inputRef);
        (0, $cfkGk.ObjectUtils).combinedRefs(focusInputRef, props.focusInputRef);
    }, [
        inputRef,
        props.inputRef,
        focusInputRef,
        props.focusInputRef
    ]);
    (0, $l2NC0.useMountEffect)(function() {
        if (props.autoFocus) (0, $cfkGk.DomHandler).focus(focusInputRef.current, props.autoFocus);
        alignOverlay();
    });
    (0, $l2NC0.useUpdateEffect)(function() {
        if (overlayVisibleState && (props.value || focusedOptionIndex >= 0)) scrollInView();
    }, [
        overlayVisibleState,
        props.value,
        focusedOptionIndex
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (overlayVisibleState && filterState && props.filter) alignOverlay();
    }, [
        overlayVisibleState,
        filterState,
        props.filter
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (filterState && (!props.options || props.options.length === 0)) setFilterState("");
        updateInputField();
        if (inputRef.current) inputRef.current.selectedIndex = 1;
    });
    (0, $l2NC0.useUnmountEffect)(function() {
        (0, $cfkGk.ZIndexUtils).clear(overlayRef.current);
    });
    var createHiddenSelect = function createHiddenSelect() {
        var option = {
            value: "",
            label: props.placeholder
        };
        if (selectedOption) {
            var optionValue = getOptionValue(selectedOption);
            option = {
                value: $ad6d87c8b3f19aa5$var$_typeof(optionValue) === "object" ? props.options.findIndex(function(o) {
                    return o === optionValue;
                }) : optionValue,
                label: getOptionLabel(selectedOption)
            };
        }
        var hiddenSelectedMessageProps = mergeProps({
            className: "p-hidden-accessible p-dropdown-hidden-select"
        }, ptm("hiddenSelectedMessage"));
        var selectProps = mergeProps({
            ref: inputRef,
            required: props.required,
            defaultValue: option.value,
            name: props.name,
            tabIndex: -1,
            "aria-hidden": "true"
        }, ptm("select"));
        var optionProps = mergeProps({
            value: option.value
        }, ptm("option"));
        return /*#__PURE__*/ $81g6h.createElement("div", hiddenSelectedMessageProps, /*#__PURE__*/ $81g6h.createElement("select", selectProps, /*#__PURE__*/ $81g6h.createElement("option", optionProps, option.label)));
    };
    var createKeyboardHelper = function createKeyboardHelper() {
        var value = (0, $cfkGk.ObjectUtils).isNotEmpty(selectedOption) ? getOptionLabel(selectedOption) : null;
        if (props.editable) value = value || props.value || "";
        var hiddenSelectedMessageProps = mergeProps({
            className: "p-hidden-accessible"
        }, ptm("hiddenSelectedMessage"));
        var inputProps = mergeProps($ad6d87c8b3f19aa5$var$_objectSpread({
            ref: focusInputRef,
            id: props.inputId,
            defaultValue: value,
            type: "text",
            readOnly: true,
            "aria-haspopup": "listbox",
            onFocus: onInputFocus,
            onBlur: onInputBlur,
            onKeyDown: onInputKeyDown,
            disabled: props.disabled,
            tabIndex: !props.disabled ? props.tabIndex || 0 : -1
        }, ariaProps), ptm("input"));
        return /*#__PURE__*/ $81g6h.createElement("div", hiddenSelectedMessageProps, /*#__PURE__*/ $81g6h.createElement("input", inputProps));
    };
    var createLabel = function createLabel() {
        var label = (0, $cfkGk.ObjectUtils).isNotEmpty(selectedOption) ? getOptionLabel(selectedOption) : null;
        if (props.editable) {
            var value = label || props.value || "";
            var _inputProps = mergeProps($ad6d87c8b3f19aa5$var$_objectSpread({
                ref: inputRef,
                type: "text",
                defaultValue: value,
                className: cx("input", {
                    label: label
                }),
                disabled: props.disabled,
                placeholder: props.placeholder,
                maxLength: props.maxLength,
                onInput: onEditableInputChange,
                onFocus: onEditableInputFocus,
                onKeyDown: onInputKeyDown,
                onBlur: onInputBlur,
                tabIndex: !props.disabled ? props.tabIndex || 0 : -1,
                "aria-haspopup": "listbox"
            }, ariaProps), ptm("input"));
            return /*#__PURE__*/ $81g6h.createElement("input", _inputProps);
        }
        var content = props.valueTemplate ? (0, $cfkGk.ObjectUtils).getJSXElement(props.valueTemplate, selectedOption, props) : label || props.placeholder || props.emptyMessage || /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, "\xa0");
        var inputProps = mergeProps({
            ref: inputRef,
            className: cx("input", {
                label: label
            }),
            tabIndex: "-1"
        }, ptm("input"));
        return /*#__PURE__*/ $81g6h.createElement("span", inputProps, content);
    };
    var onClearIconKeyDown = function onClearIconKeyDown(event) {
        if (event.key === "Enter" || event.code === "Space") {
            clear(event);
            event.preventDefault();
        }
    };
    var createClearIcon = function createClearIcon() {
        if (props.value != null && props.showClear && !props.disabled) {
            var clearIconProps = mergeProps({
                className: cx("clearIcon"),
                onPointerUp: clear,
                tabIndex: props.tabIndex || "0",
                onKeyDown: onClearIconKeyDown,
                "aria-label": (0, $8Zwsm.localeOption)("clear")
            }, ptm("clearIcon"));
            var icon = props.clearIcon || /*#__PURE__*/ $81g6h.createElement((0, $4vsYR.TimesIcon), clearIconProps);
            return (0, $cfkGk.IconUtils).getJSXIcon(icon, $ad6d87c8b3f19aa5$var$_objectSpread({}, clearIconProps), {
                props: props
            });
        }
        return null;
    };
    var createLoadingIcon = function createLoadingIcon() {
        var loadingIconProps = mergeProps({
            className: cx("loadingIcon"),
            "data-pr-overlay-visible": overlayVisibleState
        }, ptm("loadingIcon"));
        var icon = props.loadingIcon || /*#__PURE__*/ $81g6h.createElement((0, $dPQhb.SpinnerIcon), {
            spin: true
        });
        var loadingIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $ad6d87c8b3f19aa5$var$_objectSpread({}, loadingIconProps), {
            props: props
        });
        var ariaLabel = props.placeholder || props.ariaLabel;
        var loadingButtonProps = mergeProps({
            className: cx("trigger"),
            role: "button",
            "aria-haspopup": "listbox",
            "aria-expanded": overlayVisibleState,
            "aria-label": ariaLabel
        }, ptm("trigger"));
        return /*#__PURE__*/ $81g6h.createElement("div", loadingButtonProps, loadingIcon);
    };
    var createDropdownIcon = function createDropdownIcon() {
        var dropdownIconProps = mergeProps({
            className: cx("dropdownIcon"),
            "data-pr-overlay-visible": overlayVisibleState
        }, ptm("dropdownIcon"));
        var icon = props.dropdownIcon || /*#__PURE__*/ $81g6h.createElement((0, $jhJol.ChevronDownIcon), dropdownIconProps);
        var dropdownIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $ad6d87c8b3f19aa5$var$_objectSpread({}, dropdownIconProps), {
            props: props
        });
        var ariaLabel = props.placeholder || props.ariaLabel;
        var triggerProps = mergeProps({
            className: cx("trigger"),
            role: "button",
            "aria-haspopup": "listbox",
            "aria-expanded": overlayVisibleState,
            "aria-label": ariaLabel
        }, ptm("trigger"));
        return /*#__PURE__*/ $81g6h.createElement("div", triggerProps, dropdownIcon);
    };
    var visibleOptions = getVisibleOptions();
    var selectedOption = getSelectedOption();
    var hasTooltip = (0, $cfkGk.ObjectUtils).isNotEmpty(props.tooltip);
    var otherProps = $ad6d87c8b3f19aa5$var$DropdownBase.getOtherProps(props);
    var ariaProps = (0, $cfkGk.ObjectUtils).reduceKeys(otherProps, (0, $cfkGk.DomHandler).ARIA_PROPS);
    var hiddenSelect = createHiddenSelect();
    var keyboardHelper = createKeyboardHelper();
    var labelElement = createLabel();
    var dropdownIcon = props.loading ? createLoadingIcon() : createDropdownIcon();
    var clearIcon = createClearIcon();
    var rootProps = mergeProps({
        id: props.id,
        ref: elementRef,
        className: (0, $cfkGk.classNames)(props.className, cx("root", {
            context: context,
            focusedState: focusedState,
            overlayVisibleState: overlayVisibleState
        })),
        style: props.style,
        onClick: function onClick(e) {
            return _onClick(e);
        },
        onMouseDown: props.onMouseDown,
        onContextMenu: props.onContextMenu,
        onFocus: onFocus,
        "data-p-disabled": props.disabled,
        "data-p-focus": focusedState
    }, otherProps, ptm("root"));
    var firstHiddenFocusableElementProps = mergeProps({
        ref: firstHiddenFocusableElementOnOverlay,
        role: "presentation",
        "aria-hidden": "true",
        className: "p-hidden-accessible p-hidden-focusable",
        tabIndex: "0",
        onFocus: onFirstHiddenFocus,
        "data-p-hidden-accessible": true,
        "data-p-hidden-focusable": true
    }, ptm("hiddenFirstFocusableEl"));
    var lastHiddenFocusableElementProps = mergeProps({
        ref: lastHiddenFocusableElementOnOverlay,
        role: "presentation",
        "aria-hidden": "true",
        className: "p-hidden-accessible p-hidden-focusable",
        tabIndex: "0",
        onFocus: onLastHiddenFocus,
        "data-p-hidden-accessible": true,
        "data-p-hidden-focusable": true
    }, ptm("hiddenLastFocusableEl"));
    return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("div", rootProps, keyboardHelper, hiddenSelect, labelElement, clearIcon, dropdownIcon, /*#__PURE__*/ $81g6h.createElement($ad6d87c8b3f19aa5$var$DropdownPanel, $ad6d87c8b3f19aa5$var$_extends({
        hostName: "Dropdown",
        ref: overlayRef,
        visibleOptions: visibleOptions,
        virtualScrollerRef: virtualScrollerRef
    }, props, {
        appendTo: appendTo,
        cx: cx,
        filterValue: filterState,
        focusedOptionIndex: focusedOptionIndex,
        getOptionGroupChildren: getOptionGroupChildren,
        getOptionGroupLabel: getOptionGroupLabel,
        getOptionGroupRenderKey: getOptionGroupRenderKey,
        getOptionLabel: getOptionLabel,
        getOptionRenderKey: getOptionRenderKey,
        getSelectedOptionIndex: getSelectedOptionIndex,
        hasFilter: hasFilter,
        "in": overlayVisibleState,
        isOptionDisabled: isOptionDisabled,
        isSelected: isSelected,
        onClick: onPanelClick,
        onEnter: onOverlayEnter,
        onEntered: onOverlayEntered,
        onExit: onOverlayExit,
        onExited: onOverlayExited,
        onFilterClearIconClick: onFilterClearIconClick,
        onFilterInputChange: onFilterInputChange,
        onFilterInputKeyDown: onFilterInputKeyDown,
        onOptionClick: onOptionClick,
        ptm: ptm,
        resetFilter: resetFilter,
        changeFocusedOptionIndex: changeFocusedOptionIndex,
        firstFocusableElement: /*#__PURE__*/ $81g6h.createElement("span", firstHiddenFocusableElementProps),
        lastFocusableElement: /*#__PURE__*/ $81g6h.createElement("span", lastHiddenFocusableElementProps),
        sx: sx
    }))), hasTooltip && /*#__PURE__*/ $81g6h.createElement((0, $7hMfd.Tooltip), $ad6d87c8b3f19aa5$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$ad6d87c8b3f19aa5$export$931cbfb6bfb85fc.displayName = "Dropdown";

});
parcelRegister("jhJol", function(module, exports) {

$parcel$export(module.exports, "ChevronDownIcon", () => $e0a2d0b0cd9d986c$export$4857d3f3f5f8319b);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $e0a2d0b0cd9d986c$var$_extends() {
    $e0a2d0b0cd9d986c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e0a2d0b0cd9d986c$var$_extends.apply(this, arguments);
}
var $e0a2d0b0cd9d986c$export$4857d3f3f5f8319b = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $e0a2d0b0cd9d986c$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z",
        fill: "currentColor"
    }));
}));
$e0a2d0b0cd9d986c$export$4857d3f3f5f8319b.displayName = "ChevronDownIcon";

});

parcelRegister("bFyNR", function(module, exports) {

$parcel$export(module.exports, "SearchIcon", () => $87ee853e0bc8073f$export$82eafebb825fc23f);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $87ee853e0bc8073f$var$_extends() {
    $87ee853e0bc8073f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $87ee853e0bc8073f$var$_extends.apply(this, arguments);
}
var $87ee853e0bc8073f$export$82eafebb825fc23f = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $87ee853e0bc8073f$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.67602 11.0265C3.6661 11.688 4.83011 12.0411 6.02086 12.0411C6.81149 12.0411 7.59438 11.8854 8.32483 11.5828C8.87005 11.357 9.37808 11.0526 9.83317 10.6803L12.9769 13.8241C13.0323 13.8801 13.0983 13.9245 13.171 13.9548C13.2438 13.985 13.3219 14.0003 13.4007 14C13.4795 14.0003 13.5575 13.985 13.6303 13.9548C13.7031 13.9245 13.7691 13.8801 13.8244 13.8241C13.9367 13.7116 13.9998 13.5592 13.9998 13.4003C13.9998 13.2414 13.9367 13.089 13.8244 12.9765L10.6807 9.8328C11.053 9.37773 11.3573 8.86972 11.5831 8.32452C11.8857 7.59408 12.0414 6.81119 12.0414 6.02056C12.0414 4.8298 11.6883 3.66579 11.0268 2.67572C10.3652 1.68564 9.42494 0.913972 8.32483 0.45829C7.22472 0.00260857 6.01418 -0.116618 4.84631 0.115686C3.67844 0.34799 2.60568 0.921393 1.76369 1.76338C0.921698 2.60537 0.348296 3.67813 0.115991 4.84601C-0.116313 6.01388 0.00291375 7.22441 0.458595 8.32452C0.914277 9.42464 1.68595 10.3649 2.67602 11.0265ZM3.35565 2.0158C4.14456 1.48867 5.07206 1.20731 6.02086 1.20731C7.29317 1.20731 8.51338 1.71274 9.41304 2.6124C10.3127 3.51206 10.8181 4.73226 10.8181 6.00457C10.8181 6.95337 10.5368 7.88088 10.0096 8.66978C9.48251 9.45868 8.73328 10.0736 7.85669 10.4367C6.98011 10.7997 6.01554 10.8947 5.08496 10.7096C4.15439 10.5245 3.2996 10.0676 2.62869 9.39674C1.95778 8.72583 1.50089 7.87104 1.31579 6.94046C1.13068 6.00989 1.22568 5.04532 1.58878 4.16874C1.95187 3.29215 2.56675 2.54292 3.35565 2.0158Z",
        fill: "currentColor"
    }));
}));
$87ee853e0bc8073f$export$82eafebb825fc23f.displayName = "SearchIcon";

});

parcelRegister("2Sldw", function(module, exports) {

$parcel$export(module.exports, "VirtualScroller", () => $21811533dfe67969$export$fbd4ea7fe0fb889);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $l2NC0 = parcelRequire("l2NC0");

var $dPQhb = parcelRequire("dPQhb");

var $cfkGk = parcelRequire("cfkGk");

var $4gQLd = parcelRequire("4gQLd");
"use client";
function $21811533dfe67969$var$_extends() {
    $21811533dfe67969$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $21811533dfe67969$var$_extends.apply(this, arguments);
}
function $21811533dfe67969$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $21811533dfe67969$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $21811533dfe67969$var$_typeof(o);
}
function $21811533dfe67969$var$_toPrimitive(input, hint) {
    if ($21811533dfe67969$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($21811533dfe67969$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $21811533dfe67969$var$_toPropertyKey(arg) {
    var key = $21811533dfe67969$var$_toPrimitive(arg, "string");
    return $21811533dfe67969$var$_typeof(key) === "symbol" ? key : String(key);
}
function $21811533dfe67969$var$_defineProperty(obj, key, value) {
    key = $21811533dfe67969$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21811533dfe67969$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $21811533dfe67969$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $21811533dfe67969$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $21811533dfe67969$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $21811533dfe67969$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $21811533dfe67969$var$_arrayLikeToArray(o, minLen);
}
function $21811533dfe67969$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $21811533dfe67969$var$_slicedToArray(arr, i) {
    return $21811533dfe67969$var$_arrayWithHoles(arr) || $21811533dfe67969$var$_iterableToArrayLimit(arr, i) || $21811533dfe67969$var$_unsupportedIterableToArray(arr, i) || $21811533dfe67969$var$_nonIterableRest();
}
var $21811533dfe67969$var$styles = "\n.p-virtualscroller {\n    position: relative;\n    overflow: auto;\n    contain: strict;\n    transform: translateZ(0);\n    will-change: scroll-position;\n    outline: 0 none;\n}\n\n.p-virtualscroller-content {\n    position: absolute;\n    top: 0;\n    left: 0;\n    /*contain: content;*/\n    min-height: 100%;\n    min-width: 100%;\n    will-change: transform;\n}\n\n.p-virtualscroller-spacer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 1px;\n    width: 1px;\n    transform-origin: 0 0;\n    pointer-events: none;\n}\n\n.p-virtualscroller-loader {\n    position: sticky;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.p-virtualscroller-loader.p-component-overlay {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.p-virtualscroller-loading-icon {\n    font-size: 2rem;\n}\n\n.p-virtualscroller-horizontal > .p-virtualscroller-content {\n    display: flex;\n}\n\n/* Inline */\n.p-virtualscroller-inline .p-virtualscroller-content {\n    position: static;\n}\n";
var $21811533dfe67969$var$VirtualScrollerBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "VirtualScroller",
        __parentMetadata: null,
        id: null,
        style: null,
        className: null,
        tabIndex: 0,
        items: null,
        itemSize: 0,
        scrollHeight: null,
        scrollWidth: null,
        orientation: "vertical",
        step: 0,
        numToleratedItems: null,
        delay: 0,
        resizeDelay: 10,
        appendOnly: false,
        inline: false,
        lazy: false,
        disabled: false,
        loaderDisabled: false,
        loadingIcon: null,
        columns: null,
        loading: undefined,
        autoSize: false,
        showSpacer: true,
        showLoader: false,
        loadingTemplate: null,
        loaderIconTemplate: null,
        itemTemplate: null,
        contentTemplate: null,
        onScroll: null,
        onScrollIndexChange: null,
        onLazyLoad: null,
        children: undefined
    },
    css: {
        styles: $21811533dfe67969$var$styles
    }
});
function $21811533dfe67969$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $21811533dfe67969$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $21811533dfe67969$var$ownKeys(Object(t), !0).forEach(function(r) {
            $21811533dfe67969$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $21811533dfe67969$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $21811533dfe67969$export$fbd4ea7fe0fb889 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $21811533dfe67969$var$VirtualScrollerBase.getProps(inProps, context);
    var prevProps = (0, $l2NC0.usePrevious)(inProps) || {};
    var vertical = props.orientation === "vertical";
    var horizontal = props.orientation === "horizontal";
    var both = props.orientation === "both";
    var _React$useState = $81g6h.useState(both ? {
        rows: 0,
        cols: 0
    } : 0), _React$useState2 = $21811533dfe67969$var$_slicedToArray(_React$useState, 2), firstState = _React$useState2[0], setFirstState = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(both ? {
        rows: 0,
        cols: 0
    } : 0), _React$useState4 = $21811533dfe67969$var$_slicedToArray(_React$useState3, 2), lastState = _React$useState4[0], setLastState = _React$useState4[1];
    var _React$useState5 = $81g6h.useState(0), _React$useState6 = $21811533dfe67969$var$_slicedToArray(_React$useState5, 2), pageState = _React$useState6[0], setPageState = _React$useState6[1];
    var _React$useState7 = $81g6h.useState(both ? {
        rows: 0,
        cols: 0
    } : 0), _React$useState8 = $21811533dfe67969$var$_slicedToArray(_React$useState7, 2), numItemsInViewportState = _React$useState8[0], setNumItemsInViewportState = _React$useState8[1];
    var _React$useState9 = $81g6h.useState(props.numToleratedItems), _React$useState10 = $21811533dfe67969$var$_slicedToArray(_React$useState9, 2), numToleratedItemsState = _React$useState10[0], setNumToleratedItemsState = _React$useState10[1];
    var _React$useState11 = $81g6h.useState(props.loading || false), _React$useState12 = $21811533dfe67969$var$_slicedToArray(_React$useState11, 2), loadingState = _React$useState12[0], setLoadingState = _React$useState12[1];
    var _React$useState13 = $81g6h.useState([]), _React$useState14 = $21811533dfe67969$var$_slicedToArray(_React$useState13, 2), loaderArrState = _React$useState14[0], setLoaderArrState = _React$useState14[1];
    var _VirtualScrollerBase$ = $21811533dfe67969$var$VirtualScrollerBase.setMetaData({
        props: props,
        state: {
            first: firstState,
            last: lastState,
            page: pageState,
            numItemsInViewport: numItemsInViewportState,
            numToleratedItems: numToleratedItemsState,
            loading: loadingState,
            loaderArr: loaderArrState
        }
    }), ptm = _VirtualScrollerBase$.ptm;
    (0, $l2NC0.useStyle)($21811533dfe67969$var$VirtualScrollerBase.css.styles, {
        name: "virtualscroller"
    });
    var elementRef = $81g6h.useRef(null);
    var _contentRef = $81g6h.useRef(null);
    var _spacerRef = $81g6h.useRef(null);
    var _stickyRef = $81g6h.useRef(null);
    var lastScrollPos = $81g6h.useRef(both ? {
        top: 0,
        left: 0
    } : 0);
    var scrollTimeout = $81g6h.useRef(null);
    var resizeTimeout = $81g6h.useRef(null);
    var contentStyle = $81g6h.useRef({});
    var spacerStyle = $81g6h.useRef({});
    var defaultWidth = $81g6h.useRef(null);
    var defaultHeight = $81g6h.useRef(null);
    var defaultContentWidth = $81g6h.useRef(null);
    var defaultContentHeight = $81g6h.useRef(null);
    var isItemRangeChanged = $81g6h.useRef(false);
    var lazyLoadState = $81g6h.useRef(null);
    var _useResizeListener = (0, $l2NC0.useResizeListener)({
        listener: function listener(event) {
            return onResize();
        },
        when: !props.disabled
    }), _useResizeListener2 = $21811533dfe67969$var$_slicedToArray(_useResizeListener, 1), bindWindowResizeListener = _useResizeListener2[0];
    var _useEventListener = (0, $l2NC0.useEventListener)({
        target: "window",
        type: "orientationchange",
        listener: function listener(event) {
            return onResize();
        },
        when: !props.disabled
    }), _useEventListener2 = $21811533dfe67969$var$_slicedToArray(_useEventListener, 1), bindOrientationChangeListener = _useEventListener2[0];
    var getElementRef = function getElementRef() {
        return elementRef;
    };
    var getPageByFirst = function getPageByFirst(first) {
        return Math.floor((first + numToleratedItemsState * 4) / (props.step || 1));
    };
    var setContentElement = function setContentElement(element) {
        _contentRef.current = element || _contentRef.current || (0, $cfkGk.DomHandler).findSingle(elementRef.current, ".p-virtualscroller-content");
    };
    var isPageChanged = function isPageChanged(first) {
        return props.step ? pageState !== getPageByFirst(first) : true;
    };
    var scrollTo = function scrollTo(options) {
        lastScrollPos.current = both ? {
            top: 0,
            left: 0
        } : 0;
        elementRef.current && elementRef.current.scrollTo(options);
    };
    var scrollToIndex = function scrollToIndex(index) {
        var behavior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "auto";
        var _calculateNumItems = calculateNumItems(), numToleratedItems = _calculateNumItems.numToleratedItems;
        var contentPos = getContentPosition();
        var calculateFirst = function calculateFirst() {
            var _index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var _numT = arguments.length > 1 ? arguments[1] : undefined;
            return _index <= _numT ? 0 : _index;
        };
        var calculateCoord = function calculateCoord(_first, _size, _cpos) {
            return _first * _size + _cpos;
        };
        var scrollToItem = function scrollToItem() {
            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            return scrollTo({
                left: left,
                top: top,
                behavior: behavior
            });
        };
        var newFirst = both ? {
            rows: 0,
            cols: 0
        } : 0;
        var isRangeChanged = false;
        if (both) {
            newFirst = {
                rows: calculateFirst(index[0], numToleratedItems[0]),
                cols: calculateFirst(index[1], numToleratedItems[1])
            };
            scrollToItem(calculateCoord(newFirst.cols, props.itemSize[1], contentPos.left), calculateCoord(newFirst.rows, props.itemSize[0], contentPos.top));
            isRangeChanged = firstState.rows !== newFirst.rows || firstState.cols !== newFirst.cols;
        } else {
            newFirst = calculateFirst(index, numToleratedItems);
            horizontal ? scrollToItem(calculateCoord(newFirst, props.itemSize, contentPos.left), 0) : scrollToItem(0, calculateCoord(newFirst, props.itemSize, contentPos.top));
            isRangeChanged = firstState !== newFirst;
        }
        isItemRangeChanged.current = isRangeChanged;
        setFirstState(newFirst);
    };
    var scrollInView = function scrollInView(index, to) {
        var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "auto";
        if (to) {
            var _getRenderedRange = getRenderedRange(), first = _getRenderedRange.first, viewport = _getRenderedRange.viewport;
            var scrollToItem = function scrollToItem() {
                var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                return scrollTo({
                    left: left,
                    top: top,
                    behavior: behavior
                });
            };
            var isToStart = to === "to-start";
            var isToEnd = to === "to-end";
            if (isToStart) {
                if (both) {
                    if (viewport.first.rows - first.rows > index[0]) scrollToItem(viewport.first.cols * props.itemSize[1], (viewport.first.rows - 1) * props.itemSize[0]);
                    else if (viewport.first.cols - first.cols > index[1]) scrollToItem((viewport.first.cols - 1) * props.itemSize[1], viewport.first.rows * props.itemSize[0]);
                } else if (viewport.first - first > index) {
                    var pos = (viewport.first - 1) * props.itemSize;
                    horizontal ? scrollToItem(pos, 0) : scrollToItem(0, pos);
                }
            } else if (isToEnd) {
                if (both) {
                    if (viewport.last.rows - first.rows <= index[0] + 1) scrollToItem(viewport.first.cols * props.itemSize[1], (viewport.first.rows + 1) * props.itemSize[0]);
                    else if (viewport.last.cols - first.cols <= index[1] + 1) scrollToItem((viewport.first.cols + 1) * props.itemSize[1], viewport.first.rows * props.itemSize[0]);
                } else if (viewport.last - first <= index + 1) {
                    var _pos2 = (viewport.first + 1) * props.itemSize;
                    horizontal ? scrollToItem(_pos2, 0) : scrollToItem(0, _pos2);
                }
            }
        } else scrollToIndex(index, behavior);
    };
    var getRows = function getRows() {
        return loadingState ? props.loaderDisabled ? loaderArrState : [] : loadedItems();
    };
    var getColumns = function getColumns() {
        if (props.columns && both || horizontal) return loadingState && props.loaderDisabled ? both ? loaderArrState[0] : loaderArrState : props.columns.slice(both ? firstState.cols : firstState, both ? lastState.cols : lastState);
        return props.columns;
    };
    var getRenderedRange = function getRenderedRange() {
        var calculateFirstInViewport = function calculateFirstInViewport(_pos, _size) {
            return Math.floor(_pos / (_size || _pos));
        };
        var firstInViewport = firstState;
        var lastInViewport = 0;
        if (elementRef.current) {
            var _elementRef$current = elementRef.current, scrollTop = _elementRef$current.scrollTop, scrollLeft = _elementRef$current.scrollLeft;
            if (both) {
                firstInViewport = {
                    rows: calculateFirstInViewport(scrollTop, props.itemSize[0]),
                    cols: calculateFirstInViewport(scrollLeft, props.itemSize[1])
                };
                lastInViewport = {
                    rows: firstInViewport.rows + numItemsInViewportState.rows,
                    cols: firstInViewport.cols + numItemsInViewportState.cols
                };
            } else {
                var scrollPos = horizontal ? scrollLeft : scrollTop;
                firstInViewport = calculateFirstInViewport(scrollPos, props.itemSize);
                lastInViewport = firstInViewport + numItemsInViewportState;
            }
        }
        return {
            first: firstState,
            last: lastState,
            viewport: {
                first: firstInViewport,
                last: lastInViewport
            }
        };
    };
    var calculateNumItems = function calculateNumItems() {
        var contentPos = getContentPosition();
        var contentWidth = elementRef.current ? elementRef.current.offsetWidth - contentPos.left : 0;
        var contentHeight = elementRef.current ? elementRef.current.offsetHeight - contentPos.top : 0;
        var calculateNumItemsInViewport = function calculateNumItemsInViewport(_contentSize, _itemSize) {
            return Math.ceil(_contentSize / (_itemSize || _contentSize));
        };
        var calculateNumToleratedItems = function calculateNumToleratedItems(_numItems) {
            return Math.ceil(_numItems / 2);
        };
        var numItemsInViewport = both ? {
            rows: calculateNumItemsInViewport(contentHeight, props.itemSize[0]),
            cols: calculateNumItemsInViewport(contentWidth, props.itemSize[1])
        } : calculateNumItemsInViewport(horizontal ? contentWidth : contentHeight, props.itemSize);
        var numToleratedItems = numToleratedItemsState || (both ? [
            calculateNumToleratedItems(numItemsInViewport.rows),
            calculateNumToleratedItems(numItemsInViewport.cols)
        ] : calculateNumToleratedItems(numItemsInViewport));
        return {
            numItemsInViewport: numItemsInViewport,
            numToleratedItems: numToleratedItems
        };
    };
    var calculateOptions = function calculateOptions() {
        var _calculateNumItems2 = calculateNumItems(), numItemsInViewport = _calculateNumItems2.numItemsInViewport, numToleratedItems = _calculateNumItems2.numToleratedItems;
        var calculateLast = function calculateLast(_first, _num, _numT) {
            var _isCols = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            return getLast(_first + _num + (_first < _numT ? 2 : 3) * _numT, _isCols);
        };
        var last = both ? {
            rows: calculateLast(firstState.rows, numItemsInViewport.rows, numToleratedItems[0]),
            cols: calculateLast(firstState.cols, numItemsInViewport.cols, numToleratedItems[1], true)
        } : calculateLast(firstState, numItemsInViewport, numToleratedItems);
        setNumItemsInViewportState(numItemsInViewport);
        setNumToleratedItemsState(numToleratedItems);
        setLastState(last);
        if (props.showLoader) setLoaderArrState(both ? Array.from({
            length: numItemsInViewport.rows
        }).map(function() {
            return Array.from({
                length: numItemsInViewport.cols
            });
        }) : Array.from({
            length: numItemsInViewport
        }));
        if (props.lazy) Promise.resolve().then(function() {
            lazyLoadState.current = {
                first: props.step ? both ? {
                    rows: 0,
                    cols: firstState.cols
                } : 0 : firstState,
                last: Math.min(props.step ? props.step : last, (props.items || []).length)
            };
            props.onLazyLoad && props.onLazyLoad(lazyLoadState.current);
        });
    };
    var calculateAutoSize = function calculateAutoSize(loading) {
        if (props.autoSize && !loading) Promise.resolve().then(function() {
            if (_contentRef.current) {
                _contentRef.current.style.minHeight = _contentRef.current.style.minWidth = "auto";
                _contentRef.current.style.position = "relative";
                elementRef.current.style.contain = "none";
                /*const [contentWidth, contentHeight] = [DomHandler.getWidth(contentRef.current), DomHandler.getHeight(contentRef.current)];
           contentWidth !== defaultContentWidth.current && (elementRef.current.style.width = '');
          contentHeight !== defaultContentHeight.current && (elementRef.current.style.height = '');*/ var _ref = [
                    (0, $cfkGk.DomHandler).getWidth(elementRef.current),
                    (0, $cfkGk.DomHandler).getHeight(elementRef.current)
                ], width = _ref[0], height = _ref[1];
                (both || horizontal) && (elementRef.current.style.width = (width < defaultWidth.current ? width : props.scrollWidth || defaultWidth.current) + "px");
                (both || vertical) && (elementRef.current.style.height = (height < defaultHeight.current ? height : props.scrollHeight || defaultHeight.current) + "px");
                _contentRef.current.style.minHeight = _contentRef.current.style.minWidth = "";
                _contentRef.current.style.position = "";
                elementRef.current.style.contain = "";
            }
        });
    };
    var getLast = function getLast() {
        var _ref2;
        var last = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var isCols = arguments.length > 1 ? arguments[1] : undefined;
        return props.items ? Math.min(isCols ? ((_ref2 = props.columns || props.items[0]) === null || _ref2 === void 0 ? void 0 : _ref2.length) || 0 : (props.items || []).length, last) : 0;
    };
    var getContentPosition = function getContentPosition() {
        if (_contentRef.current) {
            var style = getComputedStyle(_contentRef.current);
            var left = parseFloat(style.paddingLeft) + Math.max(parseFloat(style.left) || 0, 0);
            var right = parseFloat(style.paddingRight) + Math.max(parseFloat(style.right) || 0, 0);
            var top = parseFloat(style.paddingTop) + Math.max(parseFloat(style.top) || 0, 0);
            var bottom = parseFloat(style.paddingBottom) + Math.max(parseFloat(style.bottom) || 0, 0);
            return {
                left: left,
                right: right,
                top: top,
                bottom: bottom,
                x: left + right,
                y: top + bottom
            };
        }
        return {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            x: 0,
            y: 0
        };
    };
    var setSize = function setSize() {
        if (elementRef.current) {
            var parentElement = elementRef.current.parentElement;
            var width = props.scrollWidth || "".concat(elementRef.current.offsetWidth || parentElement.offsetWidth, "px");
            var height = props.scrollHeight || "".concat(elementRef.current.offsetHeight || parentElement.offsetHeight, "px");
            var setProp = function setProp(_name, _value) {
                return elementRef.current.style[_name] = _value;
            };
            if (both || horizontal) {
                setProp("height", height);
                setProp("width", width);
            } else setProp("height", height);
        }
    };
    var setSpacerSize = function setSpacerSize() {
        var items = props.items;
        if (items) {
            var contentPos = getContentPosition();
            var setProp = function setProp(_name, _value, _size) {
                var _cpos = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                return spacerStyle.current = $21811533dfe67969$var$_objectSpread($21811533dfe67969$var$_objectSpread({}, spacerStyle.current), $21811533dfe67969$var$_defineProperty({}, "".concat(_name), (_value || []).length * _size + _cpos + "px"));
            };
            if (both) {
                setProp("height", items, props.itemSize[0], contentPos.y);
                setProp("width", props.columns || items[1], props.itemSize[1], contentPos.x);
            } else horizontal ? setProp("width", props.columns || items, props.itemSize, contentPos.x) : setProp("height", items, props.itemSize, contentPos.y);
        }
    };
    var setContentPosition = function setContentPosition(pos) {
        if (_contentRef.current && !props.appendOnly) {
            var first = pos ? pos.first : firstState;
            var calculateTranslateVal = function calculateTranslateVal(_first, _size) {
                return _first * _size;
            };
            var setTransform = function setTransform() {
                var _x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                var _y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                _stickyRef.current && (_stickyRef.current.style.top = "-".concat(_y, "px"));
                contentStyle.current = $21811533dfe67969$var$_objectSpread($21811533dfe67969$var$_objectSpread({}, contentStyle.current), {
                    transform: "translate3d(".concat(_x, "px, ").concat(_y, "px, 0)")
                });
            };
            if (both) setTransform(calculateTranslateVal(first.cols, props.itemSize[1]), calculateTranslateVal(first.rows, props.itemSize[0]));
            else {
                var translateVal = calculateTranslateVal(first, props.itemSize);
                horizontal ? setTransform(translateVal, 0) : setTransform(0, translateVal);
            }
        }
    };
    var onScrollPositionChange = function onScrollPositionChange(event) {
        var target = event.target;
        var contentPos = getContentPosition();
        var calculateScrollPos = function calculateScrollPos(_pos, _cpos) {
            return _pos ? _pos > _cpos ? _pos - _cpos : _pos : 0;
        };
        var calculateCurrentIndex = function calculateCurrentIndex(_pos, _size) {
            return Math.floor(_pos / (_size || _pos));
        };
        var calculateTriggerIndex = function calculateTriggerIndex(_currentIndex, _first, _last, _num, _numT, _isScrollDownOrRight) {
            return _currentIndex <= _numT ? _numT : _isScrollDownOrRight ? _last - _num - _numT : _first + _numT - 1;
        };
        var calculateFirst = function calculateFirst(_currentIndex, _triggerIndex, _first, _last, _num, _numT, _isScrollDownOrRight) {
            if (_currentIndex <= _numT) return 0;
            return Math.max(0, _isScrollDownOrRight ? _currentIndex < _triggerIndex ? _first : _currentIndex - _numT : _currentIndex > _triggerIndex ? _first : _currentIndex - 2 * _numT);
        };
        var calculateLast = function calculateLast(_currentIndex, _first, _last, _num, _numT, _isCols) {
            var lastValue = _first + _num + 2 * _numT;
            if (_currentIndex >= _numT) lastValue = lastValue + (_numT + 1);
            return getLast(lastValue, _isCols);
        };
        var scrollTop = calculateScrollPos(target.scrollTop, contentPos.top);
        var scrollLeft = calculateScrollPos(target.scrollLeft, contentPos.left);
        var newFirst = both ? {
            rows: 0,
            cols: 0
        } : 0;
        var newLast = lastState;
        var isRangeChanged = false;
        var newScrollPos = lastScrollPos.current;
        if (both) {
            var isScrollDown = lastScrollPos.current.top <= scrollTop;
            var isScrollRight = lastScrollPos.current.left <= scrollLeft;
            if (!props.appendOnly || props.appendOnly && (isScrollDown || isScrollRight)) {
                var currentIndex = {
                    rows: calculateCurrentIndex(scrollTop, props.itemSize[0]),
                    cols: calculateCurrentIndex(scrollLeft, props.itemSize[1])
                };
                var triggerIndex = {
                    rows: calculateTriggerIndex(currentIndex.rows, firstState.rows, lastState.rows, numItemsInViewportState.rows, numToleratedItemsState[0], isScrollDown),
                    cols: calculateTriggerIndex(currentIndex.cols, firstState.cols, lastState.cols, numItemsInViewportState.cols, numToleratedItemsState[1], isScrollRight)
                };
                newFirst = {
                    rows: calculateFirst(currentIndex.rows, triggerIndex.rows, firstState.rows, lastState.rows, numItemsInViewportState.rows, numToleratedItemsState[0], isScrollDown),
                    cols: calculateFirst(currentIndex.cols, triggerIndex.cols, firstState.cols, lastState.cols, numItemsInViewportState.cols, numToleratedItemsState[1], isScrollRight)
                };
                newLast = {
                    rows: calculateLast(currentIndex.rows, newFirst.rows, lastState.rows, numItemsInViewportState.rows, numToleratedItemsState[0]),
                    cols: calculateLast(currentIndex.cols, newFirst.cols, lastState.cols, numItemsInViewportState.cols, numToleratedItemsState[1], true)
                };
                isRangeChanged = newFirst.rows !== firstState.rows || newLast.rows !== lastState.rows || newFirst.cols !== firstState.cols || newLast.cols !== lastState.cols || isItemRangeChanged.current;
                newScrollPos = {
                    top: scrollTop,
                    left: scrollLeft
                };
            }
        } else {
            var scrollPos = horizontal ? scrollLeft : scrollTop;
            var isScrollDownOrRight = lastScrollPos.current <= scrollPos;
            if (!props.appendOnly || props.appendOnly && isScrollDownOrRight) {
                var _currentIndex2 = calculateCurrentIndex(scrollPos, props.itemSize);
                var _triggerIndex2 = calculateTriggerIndex(_currentIndex2, firstState, lastState, numItemsInViewportState, numToleratedItemsState, isScrollDownOrRight);
                newFirst = calculateFirst(_currentIndex2, _triggerIndex2, firstState, lastState, numItemsInViewportState, numToleratedItemsState, isScrollDownOrRight);
                newLast = calculateLast(_currentIndex2, newFirst, lastState, numItemsInViewportState, numToleratedItemsState);
                isRangeChanged = newFirst !== firstState || newLast !== lastState || isItemRangeChanged.current;
                newScrollPos = scrollPos;
            }
        }
        return {
            first: newFirst,
            last: newLast,
            isRangeChanged: isRangeChanged,
            scrollPos: newScrollPos
        };
    };
    var onScrollChange = function onScrollChange(event) {
        var _onScrollPositionChan = onScrollPositionChange(event), first = _onScrollPositionChan.first, last = _onScrollPositionChan.last, isRangeChanged = _onScrollPositionChan.isRangeChanged, scrollPos = _onScrollPositionChan.scrollPos;
        if (isRangeChanged) {
            var newState = {
                first: first,
                last: last
            };
            setContentPosition(newState);
            setFirstState(first);
            setLastState(last);
            lastScrollPos.current = scrollPos;
            props.onScrollIndexChange && props.onScrollIndexChange(newState);
            if (props.lazy && isPageChanged(first)) {
                var newLazyLoadState = {
                    first: props.step ? Math.min(getPageByFirst(first) * props.step, (props.items || []).length - props.step) : first,
                    last: Math.min(props.step ? (getPageByFirst(first) + 1) * props.step : last, (props.items || []).length)
                };
                var isLazyStateChanged = !lazyLoadState.current || lazyLoadState.current.first !== newLazyLoadState.first || lazyLoadState.current.last !== newLazyLoadState.last;
                isLazyStateChanged && props.onLazyLoad && props.onLazyLoad(newLazyLoadState);
                lazyLoadState.current = newLazyLoadState;
            }
        }
    };
    var _onScroll = function onScroll(event) {
        props.onScroll && props.onScroll(event);
        if (props.delay) {
            if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
            if (isPageChanged(firstState)) {
                if (!loadingState && props.showLoader) {
                    var _onScrollPositionChan2 = onScrollPositionChange(event), isRangeChanged = _onScrollPositionChan2.isRangeChanged;
                    var changed = isRangeChanged || (props.step ? isPageChanged(firstState) : false);
                    changed && setLoadingState(true);
                }
                scrollTimeout.current = setTimeout(function() {
                    onScrollChange(event);
                    if (loadingState && props.showLoader && (!props.lazy || props.loading === undefined)) {
                        setLoadingState(false);
                        setPageState(getPageByFirst(firstState));
                    }
                }, props.delay);
            }
        } else onScrollChange(event);
    };
    var onResize = function onResize() {
        if (resizeTimeout.current) clearTimeout(resizeTimeout.current);
        resizeTimeout.current = setTimeout(function() {
            if (elementRef.current) {
                var _ref3 = [
                    (0, $cfkGk.DomHandler).getWidth(elementRef.current),
                    (0, $cfkGk.DomHandler).getHeight(elementRef.current)
                ], width = _ref3[0], height = _ref3[1];
                var isDiffWidth = width !== defaultWidth.current, isDiffHeight = height !== defaultHeight.current;
                var reinit = both ? isDiffWidth || isDiffHeight : horizontal ? isDiffWidth : vertical ? isDiffHeight : false;
                if (reinit) {
                    setNumToleratedItemsState(props.numToleratedItems);
                    defaultWidth.current = width;
                    defaultHeight.current = height;
                    defaultContentWidth.current = (0, $cfkGk.DomHandler).getWidth(_contentRef.current);
                    defaultContentHeight.current = (0, $cfkGk.DomHandler).getHeight(_contentRef.current);
                }
            }
        }, props.resizeDelay);
    };
    var getOptions = function getOptions(renderedIndex) {
        var count = (props.items || []).length;
        var index = both ? firstState.rows + renderedIndex : firstState + renderedIndex;
        return {
            index: index,
            count: count,
            first: index === 0,
            last: index === count - 1,
            even: index % 2 === 0,
            odd: index % 2 !== 0,
            props: props
        };
    };
    var loaderOptions = function loaderOptions(index, extOptions) {
        var count = loaderArrState.length || 0;
        return $21811533dfe67969$var$_objectSpread({
            index: index,
            count: count,
            first: index === 0,
            last: index === count - 1,
            even: index % 2 === 0,
            odd: index % 2 !== 0,
            props: props
        }, extOptions);
    };
    var loadedItems = function loadedItems() {
        var items = props.items;
        if (items && !loadingState) {
            if (both) return items.slice(props.appendOnly ? 0 : firstState.rows, lastState.rows).map(function(item) {
                return props.columns ? item : item.slice(props.appendOnly ? 0 : firstState.cols, lastState.cols);
            });
            else if (horizontal && props.columns) return items;
            return items.slice(props.appendOnly ? 0 : firstState, lastState);
        }
        return [];
    };
    var viewInit = function viewInit() {
        if (elementRef.current && (0, $cfkGk.DomHandler).isVisible(elementRef.current)) {
            setContentElement(_contentRef.current);
            init();
            bindWindowResizeListener();
            bindOrientationChangeListener();
            defaultWidth.current = (0, $cfkGk.DomHandler).getWidth(elementRef.current);
            defaultHeight.current = (0, $cfkGk.DomHandler).getHeight(elementRef.current);
            defaultContentWidth.current = (0, $cfkGk.DomHandler).getWidth(_contentRef.current);
            defaultContentHeight.current = (0, $cfkGk.DomHandler).getHeight(_contentRef.current);
        }
    };
    var init = function init() {
        if (!props.disabled) {
            setSize();
            calculateOptions();
            setSpacerSize();
        }
    };
    (0, $l2NC0.useMountEffect)(function() {
        viewInit();
    });
    (0, $l2NC0.useUpdateEffect)(function() {
        init();
    }, [
        props.itemSize,
        props.scrollHeight,
        props.scrollWidth
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (props.numToleratedItems !== numToleratedItemsState) setNumToleratedItemsState(props.numToleratedItems);
    }, [
        props.numToleratedItems
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (props.numToleratedItems === numToleratedItemsState) init(); // reinit after resizing
    }, [
        numToleratedItemsState
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        // Check if the previous/current rows array exists
        var prevRowsExist = prevProps.items !== undefined && prevProps.items !== null;
        var currentRowsExist = props.items !== undefined && props.items !== null;
        // Get the length of the previous/current rows array, or 0 if it doesn't exist
        var prevRowsLength = prevRowsExist ? prevProps.items.length : 0;
        var currentRowsLength = currentRowsExist ? props.items.length : 0;
        // Check if the length of the rows arrays has changed
        var valuesChanged = prevRowsLength !== currentRowsLength;
        // If both is true, we also need to check the lengths of the first element (assuming it's a matrix)
        if (both && !valuesChanged) {
            // Get the length of the columns or 0
            var prevColumnsLength = prevRowsExist && prevProps.items.length > 0 ? prevProps.items[0].length : 0;
            var currentColumnsLength = currentRowsExist && props.items.length > 0 ? props.items[0].length : 0;
            // Check if the length of the columns has changed
            valuesChanged = prevColumnsLength !== currentColumnsLength;
        }
        // If the previous items array doesn't exist or if any values have changed, call the init function
        if (!prevRowsExist || valuesChanged) init();
        var loading = loadingState;
        if (props.lazy && prevProps.loading !== props.loading && props.loading !== loadingState) {
            setLoadingState(props.loading);
            loading = props.loading;
        }
        calculateAutoSize(loading);
    });
    (0, $l2NC0.useUpdateEffect)(function() {
        lastScrollPos.current = both ? {
            top: 0,
            left: 0
        } : 0;
    }, [
        props.orientation
    ]);
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElementRef: getElementRef,
            scrollTo: scrollTo,
            scrollToIndex: scrollToIndex,
            scrollInView: scrollInView,
            getRenderedRange: getRenderedRange
        };
    });
    var createLoaderItem = function createLoaderItem(index) {
        var extOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var options = loaderOptions(index, extOptions);
        var content = (0, $cfkGk.ObjectUtils).getJSXElement(props.loadingTemplate, options);
        return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, {
            key: index
        }, content);
    };
    var createLoader = function createLoader() {
        var iconClassName = "p-virtualscroller-loading-icon";
        var loadingIconProps = mergeProps({
            className: iconClassName
        }, ptm("loadingIcon"));
        var icon = props.loadingIcon || /*#__PURE__*/ $81g6h.createElement((0, $dPQhb.SpinnerIcon), $21811533dfe67969$var$_extends({}, loadingIconProps, {
            spin: true
        }));
        var loadingIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $21811533dfe67969$var$_objectSpread({}, loadingIconProps), {
            props: props
        });
        if (!props.loaderDisabled && props.showLoader && loadingState) {
            var _className = (0, $cfkGk.classNames)("p-virtualscroller-loader", {
                "p-component-overlay": !props.loadingTemplate
            });
            var _content = loadingIcon;
            if (props.loadingTemplate) _content = loaderArrState.map(function(_, index) {
                return createLoaderItem(index, both && {
                    numCols: numItemsInViewportState.cols
                });
            });
            else if (props.loaderIconTemplate) {
                var defaultContentOptions = {
                    iconClassName: iconClassName,
                    element: _content,
                    props: props
                };
                _content = (0, $cfkGk.ObjectUtils).getJSXElement(props.loaderIconTemplate, defaultContentOptions);
            }
            var loaderProps = mergeProps({
                className: _className
            }, ptm("loader"));
            return /*#__PURE__*/ $81g6h.createElement("div", loaderProps, _content);
        }
        return null;
    };
    var createSpacer = function createSpacer() {
        if (props.showSpacer) {
            var spacerProps = mergeProps({
                ref: _spacerRef,
                style: spacerStyle.current,
                className: "p-virtualscroller-spacer"
            }, ptm("spacer"));
            return /*#__PURE__*/ $81g6h.createElement("div", spacerProps);
        }
        return null;
    };
    var createItem = function createItem(item, index) {
        var options = getOptions(index);
        var content = (0, $cfkGk.ObjectUtils).getJSXElement(props.itemTemplate, item, options);
        return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, {
            key: options.index
        }, content);
    };
    var createItems = function createItems() {
        var items = loadedItems();
        return items.map(createItem);
    };
    var createContent = function createContent() {
        var items = createItems();
        var className = (0, $cfkGk.classNames)("p-virtualscroller-content", {
            "p-virtualscroller-loading": loadingState
        });
        var contentProps = mergeProps({
            ref: _contentRef,
            style: contentStyle.current,
            className: className
        }, ptm("content"));
        var content = /*#__PURE__*/ $81g6h.createElement("div", contentProps, items);
        if (props.contentTemplate) {
            var defaultOptions = {
                style: contentStyle.current,
                className: className,
                spacerStyle: spacerStyle.current,
                contentRef: function contentRef(el) {
                    return _contentRef.current = (0, $cfkGk.ObjectUtils).getRefElement(el);
                },
                spacerRef: function spacerRef(el) {
                    return _spacerRef.current = (0, $cfkGk.ObjectUtils).getRefElement(el);
                },
                stickyRef: function stickyRef(el) {
                    return _stickyRef.current = (0, $cfkGk.ObjectUtils).getRefElement(el);
                },
                items: loadedItems(),
                getItemOptions: function getItemOptions(index) {
                    return getOptions(index);
                },
                children: items,
                element: content,
                props: props,
                loading: loadingState,
                getLoaderOptions: function getLoaderOptions(index, ext) {
                    return loaderOptions(index, ext);
                },
                loadingTemplate: props.loadingTemplate,
                itemSize: props.itemSize,
                rows: getRows(),
                columns: getColumns(),
                vertical: vertical,
                horizontal: horizontal,
                both: both
            };
            return (0, $cfkGk.ObjectUtils).getJSXElement(props.contentTemplate, defaultOptions);
        }
        return content;
    };
    if (props.disabled) {
        var _content2 = (0, $cfkGk.ObjectUtils).getJSXElement(props.contentTemplate, {
            items: props.items,
            rows: props.items,
            columns: props.columns
        });
        return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, props.children, _content2);
    }
    var className = (0, $cfkGk.classNames)("p-virtualscroller", {
        "p-virtualscroller-inline": props.inline,
        "p-virtualscroller-both p-both-scroll": both,
        "p-virtualscroller-horizontal p-horizontal-scroll": horizontal
    }, props.className);
    var loader = createLoader();
    var content = createContent();
    var spacer = createSpacer();
    var rootProps = mergeProps({
        ref: elementRef,
        className: className,
        tabIndex: props.tabIndex,
        style: props.style,
        onScroll: function onScroll(e) {
            return _onScroll(e);
        }
    }, $21811533dfe67969$var$VirtualScrollerBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $81g6h.createElement("div", rootProps, content, spacer, loader);
}));
$21811533dfe67969$export$fbd4ea7fe0fb889.displayName = "VirtualScroller";

});


parcelRegister("i6nFl", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $c0f656b8d5bcfc0d$export$2ddb90ad54e5f587);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $jrnUx = parcelRequire("jrnUx");

var $kKnoQ = parcelRequire("kKnoQ");

var $2dbMB = parcelRequire("2dbMB");

var $81g6h = parcelRequire("81g6h");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");
var $c0f656b8d5bcfc0d$var$ChevronDown = function ChevronDown(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.645 8.85a1 1 0 0 0-1.414-.009L12 14.005 6.769 8.84a1 1 0 0 0-1.405 1.423l5.933 5.857a1 1 0 0 0 1.405 0l5.934-5.857a1 1 0 0 0 .01-1.414Z",
            fill: "currentColor"
        })
    });
};
$c0f656b8d5bcfc0d$var$ChevronDown.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $c0f656b8d5bcfc0d$var$ChevronUp = function ChevronUp(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.355 15.102a1 1 0 0 0 1.414.009L12 9.947l5.231 5.164a1 1 0 1 0 1.405-1.424l-5.933-5.856a1 1 0 0 0-1.405 0l-5.934 5.856a1 1 0 0 0-.01 1.415Z",
            fill: "currentColor"
        })
    });
};
$c0f656b8d5bcfc0d$var$ChevronUp.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $c0f656b8d5bcfc0d$var$VARIANT_DEFAULT = "default";
const $c0f656b8d5bcfc0d$var$VARIANT_COMPACT = "compact";
const $c0f656b8d5bcfc0d$export$2ddb90ad54e5f587 = ({ variant: variant = $c0f656b8d5bcfc0d$var$VARIANT_DEFAULT, showToggleButton: showToggleButton = true, toggleable: toggleable = true, children: children, ...otherProps })=>(0, $81g6h.useMemo)(()=>{
        const PanelComponent = variant === $c0f656b8d5bcfc0d$var$VARIANT_COMPACT ? $c0f656b8d5bcfc0d$var$CompactPanel : $c0f656b8d5bcfc0d$var$DefaultPanel;
        return /*#__PURE__*/ (0, $iKObn.jsx)(PanelComponent, {
            showToggleButton: showToggleButton,
            toggleable: toggleable,
            ...otherProps,
            children: children
        });
    }, [
        children,
        otherProps,
        showToggleButton,
        toggleable,
        variant
    ]);
const $c0f656b8d5bcfc0d$var$CompactPanel = ({ headerText: headerText, tooltip: tooltip, showToggleButton: showToggleButton = false, children: children, ...otherProps })=>{
    const header = (0, $81g6h.useMemo)(()=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $jrnUx.ContentWithTooltip), {
            tooltip: tooltip,
            children: headerText
        }), [
        headerText,
        tooltip
    ]);
    const showIcon = (0, $81g6h.useMemo)(()=>Boolean(children && showToggleButton), [
        children,
        showToggleButton
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($c0f656b8d5bcfc0d$var$CompactStyledPanel, {
        showToggleButton: showToggleButton && showIcon,
        expandIcon: /*#__PURE__*/ (0, $iKObn.jsxs)($c0f656b8d5bcfc0d$var$CompactToggleText, {
            className: "p-size-s-bold",
            children: [
                header,
                showIcon ? /*#__PURE__*/ (0, $iKObn.jsx)($c0f656b8d5bcfc0d$var$ChevronDown, {
                    className: "compact-panel-header-icon",
                    width: 24,
                    height: 24
                }) : null
            ]
        }),
        collapseIcon: /*#__PURE__*/ (0, $iKObn.jsxs)($c0f656b8d5bcfc0d$var$CompactToggleText, {
            className: "p-size-s-bold",
            children: [
                header,
                showIcon ? /*#__PURE__*/ (0, $iKObn.jsx)($c0f656b8d5bcfc0d$var$ChevronUp, {
                    className: "compact-panel-header-icon",
                    width: 24,
                    height: 24
                }) : null
            ]
        }),
        ...otherProps,
        children: children
    });
};
const $c0f656b8d5bcfc0d$var$DefaultPanel = ({ headerText: headerText, tooltip: tooltip, showToggleButton: showToggleButton = false, children: children, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const showIcon = (0, $81g6h.useMemo)(()=>Boolean(children && showToggleButton), [
        children,
        showToggleButton
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($c0f656b8d5bcfc0d$var$StyledPanel, {
        showToggleButton: showToggleButton && showIcon,
        header: /*#__PURE__*/ (0, $iKObn.jsx)((0, $jrnUx.ContentWithTooltip), {
            text: typeof headerText === "string" ? headerText : undefined,
            tooltip: tooltip,
            children: typeof headerText !== "string" ? headerText : undefined
        }),
        expandIcon: showIcon ? /*#__PURE__*/ (0, $iKObn.jsx)($c0f656b8d5bcfc0d$var$ToggleText, {
            className: "p-size-s-bold",
            children: format("patientDetails.patientPrograms.panel.show")
        }) : null,
        collapseIcon: showIcon ? /*#__PURE__*/ (0, $iKObn.jsx)($c0f656b8d5bcfc0d$var$ToggleText, {
            className: "p-size-s-bold",
            children: format("patientDetails.patientPrograms.panel.hide")
        }) : null,
        ...otherProps,
        children: children
    });
};
const $c0f656b8d5bcfc0d$var$StyledPanel = (0, $5UMQ1.default)((0, $2dbMB.Panel))`
	.p-panel-header-icon {
		display: ${({ showToggleButton: showToggleButton })=>showToggleButton ? "default" : "none"};
	}
`;
const $c0f656b8d5bcfc0d$var$ToggleText = (0, $5UMQ1.default).span`
	color: ${(0, $kKnoQ.colors).grey};

	:hover {
		color: inherit;
	}
`;
const $c0f656b8d5bcfc0d$var$CompactStyledPanel = (0, $5UMQ1.default)($c0f656b8d5bcfc0d$var$StyledPanel)`
	& .p-panel-header {
		border-bottom: none !important;
		justify-content: flex-start;
	}
`;
const $c0f656b8d5bcfc0d$var$CompactToggleText = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("XS", "flexstart", "center")};

	&,
	& .compact-panel-header-icon {
		color: ${(0, $kKnoQ.colors).primary};
	}

	&:hover,
	&:hover .compact-panel-header-icon {
		color: ${(0, $kKnoQ.colors).primaryDark50};
	}

	&:active,
	&:active .compact-panel-header-icon {
		color: ${(0, $kKnoQ.colors).primaryDark};
	}
`;

});
parcelRegister("jrnUx", function(module, exports) {

$parcel$export(module.exports, "ContentWithTooltip", () => $aafe2ca5fc242142$export$fc3a9d4aab5a8b1d);
$parcel$export(module.exports, "TooltipButton", () => $aafe2ca5fc242142$export$ba01b635860bcb3e);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $9gtEr = parcelRequire("9gtEr");

var $02Kb9 = parcelRequire("02Kb9");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");
var $aafe2ca5fc242142$var$InfoIcon = function InfoIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Zm0-20c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12.01 17.17c-.55 0-1-.45-1-1v-5.44c0-.55.45-1 1-1s1 .45 1 1v5.44c0 .55-.45 1-1 1ZM12 8.11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                fill: "currentColor"
            })
        ]
    });
};
$aafe2ca5fc242142$var$InfoIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $aafe2ca5fc242142$var$IconContainer = /*#__PURE__*/ (0, $81g6h.forwardRef)(({ color: color = (0, $kKnoQ.colors).grey, size: size = 20, ...restProps }, ref)=>/*#__PURE__*/ (0, $iKObn.jsx)($aafe2ca5fc242142$var$StyledIconContainer, {
        ref: ref,
        ...restProps,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($aafe2ca5fc242142$var$InfoIcon, {
            style: {
                cursor: "help",
                padding: 2
            },
            width: size,
            height: size,
            color: color
        })
    }));
$aafe2ca5fc242142$var$IconContainer.displayName = "IconContainer";
const $aafe2ca5fc242142$export$fc3a9d4aab5a8b1d = ({ text: text, children: children, tooltip: tooltip, skeleton: skeleton, tooltipOptions: tooltipOptions, iconSize: iconSize, iconColor: iconColor })=>{
    const showSkeleton = skeleton?.active ?? false;
    return /*#__PURE__*/ (0, $iKObn.jsxs)($aafe2ca5fc242142$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $9gtEr.ConditionalSkeleton), {
                ...skeleton,
                active: showSkeleton,
                children: children ?? /*#__PURE__*/ (0, $iKObn.jsx)("h3", {
                    className: "p-size-l",
                    children: text
                })
            }),
            !!tooltip && !showSkeleton && /*#__PURE__*/ (0, $iKObn.jsx)($aafe2ca5fc242142$var$StyledConditionalSkeleton, {
                ...skeleton,
                active: showSkeleton,
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $02Kb9.Tooltip), {
                    content: tooltip,
                    placement: "auto",
                    ...tooltipOptions,
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($aafe2ca5fc242142$var$IconContainer, {
                        color: iconColor,
                        size: iconSize
                    })
                })
            })
        ]
    });
};
const $aafe2ca5fc242142$export$ba01b635860bcb3e = ({ tooltipContent: tooltipContent, tooltipPosition: tooltipPosition = "auto", ...otherProps })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $02Kb9.Tooltip), {
        content: otherProps.disabled ? tooltipContent : undefined,
        disabled: !otherProps.disabled,
        placement: tooltipPosition,
        maxWidth: 400,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("div", {
            children: /*#__PURE__*/ (0, $iKObn.jsx)($aafe2ca5fc242142$var$StyledButton, {
                ...otherProps
            })
        })
    });
const $aafe2ca5fc242142$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8, "flexstart", "center")};
`;
const $aafe2ca5fc242142$var$StyledConditionalSkeleton = (0, $5UMQ1.default)((0, $9gtEr.ConditionalSkeleton))`
	padding: 0;
`;
const $aafe2ca5fc242142$var$StyledIconContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "flexstart", "center")};
`;
const $aafe2ca5fc242142$var$StyledButton = (0, $5UMQ1.default)((0, $dhb7H.Button))`
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		width: 100%;
		display: flex;
		justify-content: center;

		> span {
			flex: unset;
		}
	}
`;

});
parcelRegister("9gtEr", function(module, exports) {

$parcel$export(module.exports, "ConditionalSkeleton", () => $16ad8a2278b95bf8$export$8aef17ee1c7c57f);

var $iKObn = parcelRequire("iKObn");

var $kkH7g = parcelRequire("kkH7g");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");
const $16ad8a2278b95bf8$export$8aef17ee1c7c57f = ({ active: active, loading: loading = false, className: className, skeletonStyle: skeletonStyle, children: children, contentDriven: contentDriven = false })=>{
    const skeleton = (0, $81g6h.useMemo)(()=>/*#__PURE__*/ (0, $iKObn.jsxs)($16ad8a2278b95bf8$var$SkeletonWrapper, {
            className: className,
            children: [
                children,
                /*#__PURE__*/ (0, $iKObn.jsx)($16ad8a2278b95bf8$var$Skeleton, {
                    style: skeletonStyle,
                    isLoading: loading
                })
            ]
        }), [
        children,
        className,
        loading,
        skeletonStyle
    ]);
    let content;
    if (active) {
        if (contentDriven) content = /*#__PURE__*/ (0, $iKObn.jsx)("div", {
            style: {
                width: "fit-content"
            },
            children: skeleton
        });
        else content = skeleton;
    } else content = /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
        children: children
    });
    return content;
};
const $16ad8a2278b95bf8$var$SkeletonWrapper = (0, $5UMQ1.default).div`
	display: flex;
	position: relative;
	padding: 0 2px;
`;
const $16ad8a2278b95bf8$var$loadingAnimation = (0, $kkH7g.keyframes)`
    0% {
        background-position: 0% 0%
    }
    100% {
        background-position: 89% 89%
    }
`;
const $16ad8a2278b95bf8$var$Skeleton = (0, $5UMQ1.default).div`
	position: absolute;
	inset: 0;
	background: ${(0, $kKnoQ.colors).grey10};
	border-radius: ${({ style: style })=>{
    let radius = "20px";
    if (style?.borderRadius) {
        if (typeof style.borderRadius === "number") radius = `${style.borderRadius}px`;
        else radius = style.borderRadius;
    }
    return radius;
}};
	z-index: 20;

	${({ isLoading: isLoading, style: style })=>{
    const backgroundColor = style?.backgroundColor ?? (0, $kKnoQ.colors).grey10;
    return isLoading && (0, $kkH7g.css)`
				background: linear-gradient(313deg, ${backgroundColor}, ${(0, $kKnoQ.colors).white}, ${backgroundColor}, ${(0, $kKnoQ.colors).white});
				background-position: 100% 100%;
				background-size: 400% 400%;
				animation: ${$16ad8a2278b95bf8$var$loadingAnimation} ease-in-out infinite 1s;
			`;
}}
`;

});


parcelRegister("2dbMB", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $19c5ef85ffc96b55$export$2ddb90ad54e5f587);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $lbdsH = parcelRequire("lbdsH");

var $l2NC0 = parcelRequire("l2NC0");

var $4tpUf = parcelRequire("4tpUf");

var $ddETg = parcelRequire("ddETg");

var $9rbaG = parcelRequire("9rbaG");

var $cfkGk = parcelRequire("cfkGk");
"use client";
function $19c5ef85ffc96b55$var$_extends() {
    $19c5ef85ffc96b55$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $19c5ef85ffc96b55$var$_extends.apply(this, arguments);
}
function $19c5ef85ffc96b55$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $19c5ef85ffc96b55$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $19c5ef85ffc96b55$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $19c5ef85ffc96b55$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $19c5ef85ffc96b55$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $19c5ef85ffc96b55$var$_arrayLikeToArray(o, minLen);
}
function $19c5ef85ffc96b55$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $19c5ef85ffc96b55$var$_slicedToArray(arr, i) {
    return $19c5ef85ffc96b55$var$_arrayWithHoles(arr) || $19c5ef85ffc96b55$var$_iterableToArrayLimit(arr, i) || $19c5ef85ffc96b55$var$_unsupportedIterableToArray(arr, i) || $19c5ef85ffc96b55$var$_nonIterableRest();
}
var $19c5ef85ffc96b55$var$PanelBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Panel",
        id: null,
        header: null,
        headerTemplate: null,
        footer: null,
        footerTemplate: null,
        toggleable: null,
        style: null,
        className: null,
        collapsed: null,
        expandIcon: null,
        collapseIcon: null,
        icons: null,
        transitionOptions: null,
        onExpand: null,
        onCollapse: null,
        onToggle: null,
        children: undefined
    },
    css: {
        classes: {
            root: function root(_ref) {
                var props = _ref.props;
                return (0, $cfkGk.classNames)("p-panel p-component", {
                    "p-panel-toggleable": props.toggleable
                });
            },
            header: "p-panel-header",
            title: "p-panel-title",
            icons: "p-panel-icons",
            toggler: "p-panel-header-icon p-panel-toggler p-link",
            togglerIcon: "p-panel-header-icon p-panel-toggler p-link",
            toggleableContent: "p-toggleable-content",
            content: "p-panel-content",
            footer: "p-panel-footer",
            transition: "p-toggleable-content"
        },
        styles: "\n        @layer primereact {\n            .p-panel-header {\n              display: flex;\n              justify-content: space-between;\n              align-items: center;\n            }\n            \n            .p-panel-title {\n              line-height: 1;\n            }\n            \n            .p-panel-header-icon {\n              display: inline-flex;\n              justify-content: center;\n              align-items: center;\n              cursor: pointer;\n              text-decoration: none;\n              overflow: hidden;\n              position: relative;\n            }\n        }\n        "
    }
});
var $19c5ef85ffc96b55$export$2ddb90ad54e5f587 = /*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $19c5ef85ffc96b55$var$PanelBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState(props.id), _React$useState2 = $19c5ef85ffc96b55$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0], setIdState = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(props.collapsed), _React$useState4 = $19c5ef85ffc96b55$var$_slicedToArray(_React$useState3, 2), collapsedState = _React$useState4[0], setCollapsedState = _React$useState4[1];
    var elementRef = $81g6h.useRef(null);
    var contentRef = $81g6h.useRef(null);
    var collapsed = props.toggleable ? props.onToggle ? props.collapsed : collapsedState : false;
    var headerId = idState + "_header";
    var contentId = idState + "_content";
    var _PanelBase$setMetaDat = $19c5ef85ffc96b55$var$PanelBase.setMetaData({
        props: props,
        state: {
            id: idState,
            collapsed: collapsed
        }
    }), ptm = _PanelBase$setMetaDat.ptm, cx = _PanelBase$setMetaDat.cx, isUnstyled = _PanelBase$setMetaDat.isUnstyled;
    (0, $4gQLd.useHandleStyle)($19c5ef85ffc96b55$var$PanelBase.css.styles, isUnstyled, {
        name: "panel"
    });
    var toggle = function toggle(event) {
        if (!props.toggleable) return;
        collapsed ? expand(event) : collapse(event);
        if (event) {
            if (props.onToggle) props.onToggle({
                originalEvent: event,
                value: !collapsed
            });
            event.preventDefault();
        }
    };
    var expand = function expand(event) {
        if (!props.onToggle) setCollapsedState(false);
        props.onExpand && event && props.onExpand(event);
    };
    var collapse = function collapse(event) {
        if (!props.onToggle) setCollapsedState(true);
        props.onCollapse && event && props.onCollapse(event);
    };
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            toggle: toggle,
            expand: expand,
            collapse: collapse,
            getElement: function getElement() {
                return elementRef.current;
            },
            getContent: function getContent() {
                return contentRef.current;
            }
        };
    });
    (0, $l2NC0.useMountEffect)(function() {
        if (!idState) setIdState((0, $cfkGk.UniqueComponentId)());
    });
    var createToggleIcon = function createToggleIcon() {
        if (props.toggleable) {
            var buttonId = idState + "_label";
            var togglerProps = mergeProps({
                className: cx("toggler"),
                onClick: toggle,
                id: buttonId,
                "aria-controls": contentId,
                "aria-expanded": !collapsed,
                type: "button",
                role: "button",
                "aria-label": props.header
            }, ptm("toggler"));
            var togglerIconProps = mergeProps(ptm("togglericon"));
            var icon = collapsed ? props.expandIcon || /*#__PURE__*/ $81g6h.createElement((0, $ddETg.PlusIcon), togglerIconProps) : props.collapseIcon || /*#__PURE__*/ $81g6h.createElement((0, $4tpUf.MinusIcon), togglerIconProps);
            var toggleIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, togglerIconProps, {
                props: props,
                collapsed: collapsed
            });
            return /*#__PURE__*/ $81g6h.createElement("button", togglerProps, toggleIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
        }
        return null;
    };
    var createHeader = function createHeader() {
        var header = (0, $cfkGk.ObjectUtils).getJSXElement(props.header, props);
        var icons = (0, $cfkGk.ObjectUtils).getJSXElement(props.icons, props);
        var togglerElement = createToggleIcon();
        var titleProps = mergeProps({
            id: headerId,
            className: cx("title")
        }, ptm("title"));
        var titleElement = /*#__PURE__*/ $81g6h.createElement("span", titleProps, header);
        var iconsProps = mergeProps({
            className: cx("icons")
        }, ptm("icons"));
        var iconsElement = /*#__PURE__*/ $81g6h.createElement("div", iconsProps, icons, togglerElement);
        var headerProps = mergeProps({
            className: cx("header")
        }, ptm("header"));
        var content = /*#__PURE__*/ $81g6h.createElement("div", headerProps, titleElement, iconsElement);
        if (props.headerTemplate) {
            var defaultContentOptions = {
                className: "p-panel-header",
                titleClassName: "p-panel-title",
                iconsClassName: "p-panel-icons",
                togglerClassName: "p-panel-header-icon p-panel-toggler p-link",
                onTogglerClick: toggle,
                titleElement: titleElement,
                iconsElement: iconsElement,
                togglerElement: togglerElement,
                element: content,
                id: idState + "_header",
                props: props,
                collapsed: collapsed
            };
            return (0, $cfkGk.ObjectUtils).getJSXElement(props.headerTemplate, defaultContentOptions);
        } else if (props.header || props.toggleable) return content;
        return null;
    };
    var createFooter = function createFooter() {
        var footer = (0, $cfkGk.ObjectUtils).getJSXElement(props.footer, props);
        var footerProps = mergeProps({
            className: cx("footer")
        }, ptm("footer"));
        var content = /*#__PURE__*/ $81g6h.createElement("div", footerProps, footer);
        if (props.footerTemplate) {
            var defaultContentOptions = {
                className: cx("footer"),
                element: content,
                props: props
            };
            return (0, $cfkGk.ObjectUtils).getJSXElement(props.footerTemplate, defaultContentOptions);
        } else if (props.footer) return content;
        return null;
    };
    var createContent = function createContent() {
        var toggleableContentProps = mergeProps({
            ref: contentRef,
            className: cx("toggleableContent"),
            "aria-hidden": collapsed,
            role: "region",
            id: contentId,
            "aria-labelledby": headerId
        }, ptm("toggleablecontent"));
        var contentProps = mergeProps({
            className: cx("content")
        }, ptm("content"));
        var transitionProps = mergeProps({
            classNames: cx("transition"),
            timeout: {
                enter: 1000,
                exit: 450
            },
            "in": !collapsed,
            unmountOnExit: true,
            options: props.transitionOptions
        }, ptm("transition"));
        return /*#__PURE__*/ $81g6h.createElement((0, $lbdsH.CSSTransition), $19c5ef85ffc96b55$var$_extends({
            nodeRef: contentRef
        }, transitionProps), /*#__PURE__*/ $81g6h.createElement("div", toggleableContentProps, /*#__PURE__*/ $81g6h.createElement("div", contentProps, props.children)));
    };
    var rootProps = mergeProps({
        id: idState,
        ref: elementRef,
        style: props.style,
        className: (0, $cfkGk.classNames)(props.className, cx("root"))
    }, $19c5ef85ffc96b55$var$PanelBase.getOtherProps(props), ptm("root"));
    var header = createHeader();
    var content = createContent();
    var footer = createFooter();
    return /*#__PURE__*/ $81g6h.createElement("div", rootProps, header, content, footer);
});
$19c5ef85ffc96b55$export$2ddb90ad54e5f587.displayName = "Panel";

});
parcelRegister("4tpUf", function(module, exports) {

$parcel$export(module.exports, "MinusIcon", () => $341df744bb3b2aaf$export$cb808a3c41736d8e);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $341df744bb3b2aaf$var$_extends() {
    $341df744bb3b2aaf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $341df744bb3b2aaf$var$_extends.apply(this, arguments);
}
var $341df744bb3b2aaf$export$cb808a3c41736d8e = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $341df744bb3b2aaf$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M13.2222 7.77778H0.777778C0.571498 7.77778 0.373667 7.69584 0.227806 7.54998C0.0819442 7.40412 0 7.20629 0 7.00001C0 6.79373 0.0819442 6.5959 0.227806 6.45003C0.373667 6.30417 0.571498 6.22223 0.777778 6.22223H13.2222C13.4285 6.22223 13.6263 6.30417 13.7722 6.45003C13.9181 6.5959 14 6.79373 14 7.00001C14 7.20629 13.9181 7.40412 13.7722 7.54998C13.6263 7.69584 13.4285 7.77778 13.2222 7.77778Z",
        fill: "currentColor"
    }));
}));
$341df744bb3b2aaf$export$cb808a3c41736d8e.displayName = "MinusIcon";

});

parcelRegister("ddETg", function(module, exports) {

$parcel$export(module.exports, "PlusIcon", () => $99fc35376906d7d7$export$f21ab0717a89c77f);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $99fc35376906d7d7$var$_extends() {
    $99fc35376906d7d7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $99fc35376906d7d7$var$_extends.apply(this, arguments);
}
var $99fc35376906d7d7$export$f21ab0717a89c77f = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $99fc35376906d7d7$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M7.67742 6.32258V0.677419C7.67742 0.497757 7.60605 0.325452 7.47901 0.198411C7.35197 0.0713707 7.17966 0 7 0C6.82034 0 6.64803 0.0713707 6.52099 0.198411C6.39395 0.325452 6.32258 0.497757 6.32258 0.677419V6.32258H0.677419C0.497757 6.32258 0.325452 6.39395 0.198411 6.52099C0.0713707 6.64803 0 6.82034 0 7C0 7.17966 0.0713707 7.35197 0.198411 7.47901C0.325452 7.60605 0.497757 7.67742 0.677419 7.67742H6.32258V13.3226C6.32492 13.5015 6.39704 13.6725 6.52358 13.799C6.65012 13.9255 6.82106 13.9977 7 14C7.17966 14 7.35197 13.9286 7.47901 13.8016C7.60605 13.6745 7.67742 13.5022 7.67742 13.3226V7.67742H13.3226C13.5022 7.67742 13.6745 7.60605 13.8016 7.47901C13.9286 7.35197 14 7.17966 14 7C13.9977 6.82106 13.9255 6.65012 13.799 6.52358C13.6725 6.39704 13.5015 6.32492 13.3226 6.32258H7.67742Z",
        fill: "currentColor"
    }));
}));
$99fc35376906d7d7$export$f21ab0717a89c77f.displayName = "PlusIcon";

});




parcelRegister("9WskH", function(module, exports) {

$parcel$export(module.exports, "HctInvitationCodeForm", () => $e43879c11f2ad292$export$e662ec76e92d4dc9);

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $2jrEq = parcelRequire("2jrEq");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $hjTZh = parcelRequire("hjTZh");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $8FlUV = parcelRequire("8FlUV");

var $hIci4 = parcelRequire("hIci4");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $dU78w = parcelRequire("dU78w");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
const $e43879c11f2ad292$var$CODE_PREFIX = "P-";
const $e43879c11f2ad292$export$e662ec76e92d4dc9 = ({ onConfirm: onConfirm, onBack: onBack })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const [isHover, setIsHover] = (0, $81g6h.useState)(false);
    const [isFocus, setIsFocus] = (0, $81g6h.useState)(false);
    const { control: control, handleSubmit: handleSubmit, setError: setError } = (0, $eKUeg.useForm)({
        defaultValues: {
            code: ""
        }
    });
    const [onSubmit, loading] = (0, $grmoS.useAsyncOperation)(async (data)=>{
        try {
            const patientData = await (0, $ghfIB.healthcareTeamManager).joinHealthcareTeam($e43879c11f2ad292$var$CODE_PREFIX + data.code);
            await (0, $ghfIB.getStartedManager).tryMarkPatientsStepAsCompleted();
            onConfirm(patientData);
        } catch (e) {
            let errorMessage = format("home.addPatientDialog.invitationCodeForm.invalidError");
            if (e instanceof (0, $hjTZh.HealthcareTeamInvitationInWrongCountryError)) errorMessage = format("home.addPatientDialog.invitationCodeForm.wrongCountryError");
            if (e instanceof (0, $hjTZh.InvitationPtAlreadyInHctError)) errorMessage = format("home.addPatientDialog.invitationCodeForm.alreadyInHctError");
            setError("code", {
                type: "manual",
                message: errorMessage
            });
        }
    }, {
        deps: [
            format,
            onConfirm,
            setError
        ]
    });
    (0, $2jrEq.useKeyboardKeyPressed)({
        [(0, $2jrEq.KeyboardKeys).Enter]: handleSubmit(onSubmit)
    });
    return /*#__PURE__*/ (0, $iKObn.jsxs)($e43879c11f2ad292$var$Container, {
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($e43879c11f2ad292$var$FormContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                        children: format("home.addPatientDialog.invitationCodeForm.title")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                        name: "code",
                        control: control,
                        rules: {
                            required: format("home.addPatientDialog.invitationCodeForm.requireError"),
                            pattern: {
                                value: /^[A-Z0-9]{6}$/,
                                message: format("home.addPatientDialog.invitationCodeForm.formatError")
                            }
                        },
                        render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)($e43879c11f2ad292$var$WideContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($e43879c11f2ad292$var$InputContainer, {
                                        isHighlighted: isHover || isFocus,
                                        isError: (0, $lTdpc.isNotNil)(fieldState.error?.message),
                                        children: /*#__PURE__*/ (0, $iKObn.jsxs)("span", {
                                            className: "p-inputgroup",
                                            children: [
                                                /*#__PURE__*/ (0, $iKObn.jsx)($e43879c11f2ad292$var$Prefix, {
                                                    className: "p-inputgroup-addon",
                                                    isError: (0, $lTdpc.isNotNil)(fieldState.error?.message),
                                                    children: $e43879c11f2ad292$var$CODE_PREFIX
                                                }),
                                                /*#__PURE__*/ (0, $iKObn.jsx)($e43879c11f2ad292$var$CodeInput, {
                                                    ...field,
                                                    error: fieldState.invalid,
                                                    placeholder: format("home.addPatientDialog.invitationCodeForm.placeholder"),
                                                    style: {
                                                        alignSelf: "stretch",
                                                        width: "100%"
                                                    },
                                                    onMouseEnter: ()=>setIsHover(true),
                                                    onMouseLeave: ()=>setIsHover(false),
                                                    maxLength: 6,
                                                    onFocus: ()=>setIsFocus(true),
                                                    onBlur: ()=>setIsFocus(false)
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $8FlUV.ErrorMessage), {
                                        children: fieldState.error?.message
                                    })
                                ]
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($e43879c11f2ad292$var$Footer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                        uiStyle: "secondary",
                        label: format("global.dialog.back"),
                        onClick: onBack
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                        label: format("global.dialog.next"),
                        type: "submit",
                        loading: loading
                    })
                ]
            })
        ]
    });
};
const $e43879c11f2ad292$var$Container = (0, $5UMQ1.default)((0, $dU78w.motion).form)`
	${(0, $5WGN2.stack)(16, "spacebetween")};
	flex: 1;
`;
const $e43879c11f2ad292$var$FormContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(24)};
`;
const $e43879c11f2ad292$var$Prefix = (0, $5UMQ1.default).span`
	padding-right: 0;
	color: ${({ isError: isError })=>isError ? (0, $kKnoQ.colors).rejection : (0, $kKnoQ.colors).black};
	background-color: ${(0, $kKnoQ.colors).primaryBackground};
`;
const $e43879c11f2ad292$var$CodeInput = (0, $5UMQ1.default)((0, $hIci4.TextInput))`
	padding-left: 0;
	border: 0;
`;
const $e43879c11f2ad292$var$WideContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(8)}
	align-self: stretch;
	display: flex;
`;
const $e43879c11f2ad292$var$getInputBorderColor = ({ isError: isError, isHighlighted: isHighlighted })=>{
    if (isError) return (0, $kKnoQ.colors).rejection;
    if (isHighlighted) return (0, $kKnoQ.colors).primary75;
    return (0, $kKnoQ.colors).white;
};
const $e43879c11f2ad292$var$InputContainer = (0, $5UMQ1.default).div`
	align-self: stretch;
	display: flex;
	border: 1px solid ${({ isHighlighted: isHighlighted, isError: isError })=>$e43879c11f2ad292$var$getInputBorderColor({
        isHighlighted: isHighlighted,
        isError: isError
    })};
	border-radius: 8px;
`;
const $e43879c11f2ad292$var$Footer = (0, $5UMQ1.default).div`
	display: flex;
	justify-content: space-between;
	align-self: stretch;
`;

});
parcelRegister("2jrEq", function(module, exports) {

$parcel$export(module.exports, "KeyboardKeys", () => $b10d31550ee43385$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "useKeyboardKeyPressed", () => $b10d31550ee43385$export$ac5ef14fddc7c936);

var $81g6h = parcelRequire("81g6h");
var $b10d31550ee43385$export$70f9e5bc10d7eac;
(function(KeyboardKeys) {
    KeyboardKeys["Escape"] = "Escape";
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["Enter"] = "Enter";
})($b10d31550ee43385$export$70f9e5bc10d7eac || ($b10d31550ee43385$export$70f9e5bc10d7eac = {}));
const $b10d31550ee43385$export$ac5ef14fddc7c936 = (instructions)=>{
    const handleKeyPressed = (0, $81g6h.useCallback)((event)=>{
        if (event.key in instructions) {
            instructions[event.key]();
            event.preventDefault();
        }
    }, [
        instructions
    ]);
    (0, $81g6h.useEffect)(()=>{
        document.addEventListener("keydown", handleKeyPressed, false);
        return ()=>{
            document.removeEventListener("keydown", handleKeyPressed, false);
        };
    }, [
        handleKeyPressed
    ]);
};

});


parcelRegister("gHYu8", function(module, exports) {

$parcel$export(module.exports, "HealthcareTeamJoinedStep", () => $447ee51ed6ab49c0$export$66927d206a24dd92);

var $iKObn = parcelRequire("iKObn");

var $giAv5 = parcelRequire("giAv5");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $fUhFD = parcelRequire("fUhFD");

var $5UMQ1 = parcelRequire("5UMQ1");

var $9Q47x = parcelRequire("9Q47x");

var $dhb7H = parcelRequire("dhb7H");

var $lDZlX = parcelRequire("lDZlX");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
var $447ee51ed6ab49c0$var$CheckMarkIcon = function CheckMarkIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M51.18 9.6H12.82c-3.546 0-6.42 2.996-6.42 6.69v31.42c0 3.695 2.874 6.69 6.42 6.69h38.36c3.545 0 6.42-2.995 6.42-6.69V16.29c0-3.694-2.875-6.69-6.42-6.69Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_124_11989",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "10",
                y: "0",
                width: "54",
                height: "43",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M27.428 42.164a5.151 5.151 0 0 1-3.64-1.507L11.904 28.773a5.157 5.157 0 0 1 0-7.28 5.157 5.157 0 0 1 7.28 0l8.244 8.25 27.44-27.44a5.157 5.157 0 0 1 7.28 0 5.157 5.157 0 0 1 0 7.28L31.073 40.658a5.151 5.151 0 0 1-3.64 1.507h-.006Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_124_11989)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M29.937 45.926c13.836 0 25.052-11.216 25.052-25.052S43.773-4.178 29.937-4.178c-13.835 0-25.052 11.216-25.052 25.052s11.217 25.052 25.052 25.052Z",
                        fill: "#29D37A"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M59.05 14.794c1.207 10.307-7.3 22.46-19.816 24.299-12.516 1.839-24.298-7.325-25.505-17.632-1.207-10.306 7.3-22.459 19.816-24.298C46.06-4.676 57.843 4.488 59.05 14.794Z",
                        fill: "#3ADE88"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M63.284 11.627c.804 6.871-6.373 18.73-17.657 20.799-11.29 2.069-22.408-6.43-23.213-13.302-.804-6.87 6.373-18.73 17.657-20.798 11.284-2.07 22.408 6.43 23.213 13.301Z",
                        fill: "#4CE997"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M67.524 8.46c.402 3.435-5.447 15-15.505 17.3-10.058 2.298-20.524-5.531-20.926-8.967-.403-3.435 5.447-15 15.504-17.299 10.058-2.299 20.525 5.53 20.927 8.966Z",
                        fill: "#5DF4A5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M71.758 5.293s-4.521 11.264-13.353 13.8c-8.832 2.528-18.634-4.637-18.634-4.637S44.292 3.192 53.124.656c8.831-2.535 18.634 4.637 18.634 4.637Z",
                        fill: "#6EFFB3"
                    })
                ]
            })
        ]
    });
};
$447ee51ed6ab49c0$var$CheckMarkIcon.defaultProps = {
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $447ee51ed6ab49c0$export$66927d206a24dd92 = ({ fullname: fullname, id: id })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    (0, $giAv5.useOnceEffect)(()=>{
        (0, $fUhFD.sendAnalyticsEventJoinPatientHealthcareTeam)(id);
    });
    return /*#__PURE__*/ (0, $iKObn.jsxs)($447ee51ed6ab49c0$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $9Q47x.BackgroundIcon), {
                iconSvg: $447ee51ed6ab49c0$var$CheckMarkIcon
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                className: "p-size-m-bold",
                children: format("home.addPatientDialog.hctJoined.title", {
                    patientName: fullname
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                className: "p-size-m",
                style: {
                    color: (0, $kKnoQ.colors).grey
                },
                children: format("home.addPatientDialog.hctJoined.subtitle")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                label: format("home.addPatientDialog.hctJoined.cta"),
                onClick: ()=>navigate((0, $lDZlX.RoutesPath).PatientDetails, {
                        route: {
                            patientId: id
                        }
                    })
            })
        ]
    });
};
const $447ee51ed6ab49c0$var$Container = (0, $5UMQ1.default).div`
	margin-top: 8px;
	${(0, $5WGN2.stack)("L", "center", "center")}
	text-align: center;
`;

});

parcelRegister("7BZ59", function(module, exports) {

$parcel$export(module.exports, "InvitationCodeSent", () => $31fa3990090428c1$export$eac419147e6c76bb);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $aEP4N = parcelRequire("aEP4N");

var $5UMQ1 = parcelRequire("5UMQ1");

var $9Q47x = parcelRequire("9Q47x");

var $dLxEV = parcelRequire("dLxEV");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");

var $89Qlc = parcelRequire("89Qlc");
var $31fa3990090428c1$var$CheckMarkIcon = function CheckMarkIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M51.18 9.6H12.82c-3.546 0-6.42 2.996-6.42 6.69v31.42c0 3.695 2.874 6.69 6.42 6.69h38.36c3.545 0 6.42-2.995 6.42-6.69V16.29c0-3.694-2.875-6.69-6.42-6.69Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_124_11989",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "10",
                y: "0",
                width: "54",
                height: "43",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M27.428 42.164a5.151 5.151 0 0 1-3.64-1.507L11.904 28.773a5.157 5.157 0 0 1 0-7.28 5.157 5.157 0 0 1 7.28 0l8.244 8.25 27.44-27.44a5.157 5.157 0 0 1 7.28 0 5.157 5.157 0 0 1 0 7.28L31.073 40.658a5.151 5.151 0 0 1-3.64 1.507h-.006Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_124_11989)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M29.937 45.926c13.836 0 25.052-11.216 25.052-25.052S43.773-4.178 29.937-4.178c-13.835 0-25.052 11.216-25.052 25.052s11.217 25.052 25.052 25.052Z",
                        fill: "#29D37A"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M59.05 14.794c1.207 10.307-7.3 22.46-19.816 24.299-12.516 1.839-24.298-7.325-25.505-17.632-1.207-10.306 7.3-22.459 19.816-24.298C46.06-4.676 57.843 4.488 59.05 14.794Z",
                        fill: "#3ADE88"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M63.284 11.627c.804 6.871-6.373 18.73-17.657 20.799-11.29 2.069-22.408-6.43-23.213-13.302-.804-6.87 6.373-18.73 17.657-20.798 11.284-2.07 22.408 6.43 23.213 13.301Z",
                        fill: "#4CE997"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M67.524 8.46c.402 3.435-5.447 15-15.505 17.3-10.058 2.298-20.524-5.531-20.926-8.967-.403-3.435 5.447-15 15.504-17.299 10.058-2.299 20.525 5.53 20.927 8.966Z",
                        fill: "#5DF4A5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M71.758 5.293s-4.521 11.264-13.353 13.8c-8.832 2.528-18.634-4.637-18.634-4.637S44.292 3.192 53.124.656c8.831-2.535 18.634 4.637 18.634 4.637Z",
                        fill: "#6EFFB3"
                    })
                ]
            })
        ]
    });
};
$31fa3990090428c1$var$CheckMarkIcon.defaultProps = {
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $31fa3990090428c1$export$eac419147e6c76bb = ({ pendingPatient: { firstName: firstName, lastName: lastName }, invitationSentData: invitationSentData, isNewlyCreatedPatient: isNewlyCreatedPatient, onPressRetry: onPressRetry, onCreateNewTemplateRequest: onCreateNewTemplateRequest })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { formatPatientName: formatPatientName } = (0, $aEP4N.useFormatPatients)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($31fa3990090428c1$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $9Q47x.BackgroundIcon), {
                iconSvg: $31fa3990090428c1$var$CheckMarkIcon
            }),
            invitationSentData.sharingMethod === (0, $dLxEV.InvitationCodeSharingMethod).PRINT ? /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: format("home.pendingPatientDialog.codeSent.print.message", {
                    patientName: formatPatientName({
                        firstName: firstName,
                        lastName: lastName
                    })
                })
            }) : /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        children: isNewlyCreatedPatient ? format("home.pendingPatientDialog.codeSent.newPatient.email.message", {
                            email: invitationSentData.email
                        }) : format("home.pendingPatientDialog.codeSent.resendCode.email.message", {
                            email: invitationSentData.email
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($31fa3990090428c1$var$NotReceivedMessage, {
                        children: [
                            format("home.pendingPatientDialog.codeSent.notReceived"),
                            /*#__PURE__*/ (0, $iKObn.jsx)($31fa3990090428c1$var$RetrySpan, {
                                onClick: onPressRetry,
                                children: format("home.pendingPatientDialog.codeSent.retryButton")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $89Qlc.CreateTemplateCard), {
                onCreateNewTemplateRequest: onCreateNewTemplateRequest
            })
        ]
    });
};
const $31fa3990090428c1$var$NotReceivedMessage = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).grey80};
`;
const $31fa3990090428c1$var$RetrySpan = (0, $5UMQ1.default).span`
	margin-left: 0.5em;
	text-decoration: underline;
	cursor: pointer;
`;
const $31fa3990090428c1$var$Container = (0, $5UMQ1.default).div`
	margin-top: 8px;
	${(0, $5WGN2.stack)("L", "center", "center")}
	text-align: center;
`;

});
parcelRegister("dLxEV", function(module, exports) {

$parcel$export(module.exports, "InvitationCodeSharingMethod", () => $73d678cdc6b99064$export$5f1a51a567ea6223);
$parcel$export(module.exports, "PendingPatientCreated", () => $73d678cdc6b99064$export$f40a25dd274d8bd9);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $l075W = parcelRequire("l075W");

var $a6fIt = parcelRequire("a6fIt");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dLyEN = parcelRequire("dLyEN");

var $9XVwj = parcelRequire("9XVwj");

var $4SHRu = parcelRequire("4SHRu");

var $7ms76 = parcelRequire("7ms76");

var $bS6dF = parcelRequire("bS6dF");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");

var $9WnvU = parcelRequire("9WnvU");
var $73d678cdc6b99064$var$CopyIcon = function CopyIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M4 2a2 2 0 0 0-2 2v13a1 1 0 0 0 2 0V4h13a1 1 0 0 0 0-2H4Zm4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H8Zm0 2h12v12H8V8Z",
            fill: "currentColor"
        })
    });
};
$73d678cdc6b99064$var$CopyIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $73d678cdc6b99064$export$5f1a51a567ea6223;
(function(InvitationCodeSharingMethod) {
    InvitationCodeSharingMethod["EMAIL"] = "email";
    InvitationCodeSharingMethod["PRINT"] = "print";
})($73d678cdc6b99064$export$5f1a51a567ea6223 || ($73d678cdc6b99064$export$5f1a51a567ea6223 = {}));
const $73d678cdc6b99064$export$f40a25dd274d8bd9 = ({ pendingPatient: pendingPatient, previousInvitationSentData: previousInvitationSentData, onInvitationCodeSent: onInvitationCodeSent })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const [selectedSharingMethod, setSelectedSharingMethod] = (0, $81g6h.useState)(previousInvitationSentData?.sharingMethod ?? "email");
    const [hasCopiedCode, setHasCopiedCode] = (0, $81g6h.useState)(false);
    const componentRef = (0, $81g6h.useRef)(null);
    const handlePrint = (0, $9WnvU.useReactToPrint)({
        content: ()=>componentRef.current,
        onAfterPrint: ()=>onInvitationCodeSent?.({
                sharingMethod: "print"
            })
    });
    const handleEmail = (0, $81g6h.useCallback)(async (email)=>{
        try {
            await (0, $ghfIB.patientManager).sendInvitationCodeEmail(pendingPatient.id, email);
        } catch (e) {
            if (e instanceof (0, $l075W.PatientNotPendingError)) {
                showToast(format("home.pendingPatientDialog.details.sharing.email.patientNotPending.title"), format("home.pendingPatientDialog.details.sharing.email.patientNotPending.description"));
                return;
            }
            throw e;
        }
        onInvitationCodeSent?.({
            sharingMethod: "email",
            email: email
        });
    }, [
        onInvitationCodeSent,
        pendingPatient.id,
        showToast,
        format
    ]);
    const copyInvitationCodeToClipboard = (0, $81g6h.useCallback)(()=>{
        navigator.clipboard.writeText(pendingPatient.activationCode);
        setHasCopiedCode(true);
    }, [
        pendingPatient.activationCode
    ]);
    const sharingOptions = (0, $81g6h.useMemo)(()=>[
            {
                title: format("home.pendingPatientDialog.details.sharing.email"),
                data: "email"
            },
            {
                title: format("home.pendingPatientDialog.details.sharing.print"),
                data: "print"
            }
        ], [
        format
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: format("home.pendingPatientDialog.details.description")
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($73d678cdc6b99064$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        className: "p-size-l-bold",
                        children: format("home.pendingPatientDialog.details.code.title")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($73d678cdc6b99064$var$InvitationCodeContainer, {
                        "data-test": (0, $a6fIt.e2eTestId).createPatientDialog.invitationCode,
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($73d678cdc6b99064$var$InvitationCode, {
                                className: "p-size-l-bold",
                                highlighted: hasCopiedCode,
                                children: pendingPatient.activationCode
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($73d678cdc6b99064$var$DuplicateIconContainer, {
                                onClick: copyInvitationCodeToClipboard,
                                children: /*#__PURE__*/ (0, $iKObn.jsx)($73d678cdc6b99064$var$CopyIcon, {
                                    width: "20",
                                    height: "20"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($73d678cdc6b99064$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        className: "p-size-l-bold",
                        children: format("home.pendingPatientDialog.details.sharing.title")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $dLyEN.ButtonGroup), {
                        style: {
                            display: "grid",
                            gridAutoFlow: "column"
                        },
                        options: sharingOptions,
                        value: selectedSharingMethod,
                        onChange: (newSharingMethod)=>setSelectedSharingMethod(newSharingMethod)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                style: {
                    display: "none"
                },
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $4SHRu.ComponentToPrint), {
                    code: pendingPatient.activationCode,
                    url: pendingPatient.link,
                    ref: componentRef
                })
            }),
            selectedSharingMethod === "print" ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $7ms76.ShareUsingPrintForm), {
                onSuccess: handlePrint
            }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $bS6dF.SharingUsingEmailForm), {
                defaultEmail: previousInvitationSentData?.sharingMethod === "email" ? previousInvitationSentData.email : pendingPatient.email,
                onSuccess: handleEmail
            })
        ]
    });
};
const $73d678cdc6b99064$var$Section = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("S", undefined, "stretch")}
`;
const $73d678cdc6b99064$var$DuplicateIconContainer = (0, $5UMQ1.default).div`
	cursor: pointer;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	display: grid;
	place-content: center;
	color: ${(0, $kKnoQ.colors).grey};
	transition:
		color 0.2s,
		background-color 0.2s;

	:hover {
		background-color: ${(0, $kKnoQ.colors).primary10};

		:active {
			background-color: ${(0, $kKnoQ.colors).primary25};
			color: ${(0, $kKnoQ.colors).primary};
		}
	}
`;
const $73d678cdc6b99064$var$InvitationCode = (0, $5UMQ1.default).div`
	transition: background-color 0.2s;
	background-color: ${({ highlighted: highlighted })=>highlighted ? (0, $kKnoQ.colors).primary25 : "unset"};
	padding: 4px 8px;
`;
const $73d678cdc6b99064$var$InvitationCodeContainer = (0, $5UMQ1.default).div`
	background: ${(0, $kKnoQ.colors).primaryBackground};
	border-radius: var(--border-radius);
	color: ${(0, $kKnoQ.colors).primary};
	padding: 16px 8px;
	display: grid;
	grid-template-columns: 1fr auto;
	place-items: center;
`;

});
parcelRegister("dLyEN", function(module, exports) {

$parcel$export(module.exports, "ButtonGroup", () => $e31ba4ba9b5c38b6$export$69b1032f2ecdf404);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");

var $9AWgp = parcelRequire("9AWgp");
parcelRequire("81g6h");
const $e31ba4ba9b5c38b6$export$69b1032f2ecdf404 = ({ style: style, options: options, value: value, onChange: onChange })=>/*#__PURE__*/ (0, $iKObn.jsx)("div", {
        style: style,
        children: options.map((option, index)=>{
            const isFirst = index === 0;
            const isLast = index === options.length - 1;
            let position = "center";
            if (isFirst) position = "left";
            else if (isLast) position = "right";
            return /*#__PURE__*/ (0, $iKObn.jsx)($e31ba4ba9b5c38b6$var$ButtonGroupItem, {
                onClick: ()=>onChange?.(option.data),
                position: position,
                active: option.data === value,
                label: option.title
            }, option.title);
        })
    });
const $e31ba4ba9b5c38b6$var$ButtonGroupItem = (0, $5UMQ1.default)((0, $9AWgp.Button))`
	border-top-left-radius: ${({ position: position })=>position === "left" ? "8px" : "0"};
	border-bottom-left-radius: ${({ position: position })=>position === "left" ? "8px" : "0"};
	border-top-right-radius: ${({ position: position })=>position === "right" ? "8px" : "0"};
	border-bottom-right-radius: ${({ position: position })=>position === "right" ? "8px" : "0"};
	background-color: ${({ active: active })=>active ? (0, $kKnoQ.colors).primary10 : (0, $kKnoQ.colors).transparent};
	color: ${({ active: active })=>active ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).black};
	border-color: ${({ active: active })=>active ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).primary10};
	:hover {
		color: ${(0, $kKnoQ.colors).primary} !important;
		background-color: ${(0, $kKnoQ.colors).primary10} !important;
	}
`;

});

parcelRegister("4SHRu", function(module, exports) {

$parcel$export(module.exports, "ComponentToPrint", () => $d179f9e44a5a90ec$export$e131a7d84ca65b80);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");

var $arO47 = parcelRequire("arO47");
const $d179f9e44a5a90ec$export$e131a7d84ca65b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ code: code, url: url }, ref)=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const steps = [
        {
            id: "step_1",
            label: format("home.pendingPatientDialog.print.step_1")
        },
        {
            id: "step_2",
            label: format("home.pendingPatientDialog.print.step_2")
        },
        {
            id: "step_3",
            label: format("home.pendingPatientDialog.print.step_3")
        },
        {
            id: "step_4",
            label: format("home.pendingPatientDialog.print.step_4")
        }
    ];
    return /*#__PURE__*/ (0, $iKObn.jsxs)($d179f9e44a5a90ec$var$Container, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($d179f9e44a5a90ec$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($d179f9e44a5a90ec$var$H3, {
                        children: format("home.pendingPatientDialog.print.title")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        className: "p-size-s-rubik-regular",
                        children: format("home.pendingPatientDialog.print.subtitle")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($d179f9e44a5a90ec$var$Description, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        children: format("home.pendingPatientDialog.print.fisrtDescription")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        children: format("home.pendingPatientDialog.print.secondDescription")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($d179f9e44a5a90ec$var$Content, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        style: {
                            width: 170,
                            height: 170
                        },
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($d179f9e44a5a90ec$var$StyledQRCode, {
                            value: url,
                            size: 170
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($d179f9e44a5a90ec$var$Steps, {
                        children: steps.map((step, index)=>/*#__PURE__*/ (0, $iKObn.jsxs)($d179f9e44a5a90ec$var$Step, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsxs)($d179f9e44a5a90ec$var$StepIndex, {
                                        className: "p-size-s-bold",
                                        children: [
                                            index + 1,
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                                        className: "p-size-xs-semi-bold",
                                        children: step.label
                                    })
                                ]
                            }, step.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($d179f9e44a5a90ec$var$CodeContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        className: "p-size-s-bold",
                        children: format("home.pendingPatientDialog.print.code.description_1")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($d179f9e44a5a90ec$var$ColoredText, {
                        className: "p-size-s-bold",
                        children: format("home.pendingPatientDialog.print.code.description_2")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($d179f9e44a5a90ec$var$H3, {
                        style: {
                            paddingTop: "16px"
                        },
                        children: code
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                style: {
                    textAlign: "center"
                },
                children: format("home.pendingPatientDialog.print.footer", {
                    color: (0, $kKnoQ.colors).primary
                })
            })
        ]
    });
});
$d179f9e44a5a90ec$export$e131a7d84ca65b80.displayName = "ComponentToPrint";
const $d179f9e44a5a90ec$var$Container = (0, $5UMQ1.default).div`
	padding: 80px;
	${(0, $5WGN2.stack)("L", "flexstart", "stretch")};
	flex: 1;
	background-color: ${(0, $kKnoQ.colors).white};
	position: relative;

	@media print {
		background-color: ${(0, $kKnoQ.colors).white} !important;
		-webkit-print-color-adjust: exact;
	}

	:after {
		position: absolute;
		content: "";
		bottom: 80px;
		width: calc(100% - 160px);
		height: 1px;
		border-bottom: 1px solid ${(0, $kKnoQ.colors).primary25};
	}
`;
const $d179f9e44a5a90ec$var$Header = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "center")};
	padding-bottom: 16px;

	border-bottom: 1px solid ${(0, $kKnoQ.colors).primary25};
`;
const $d179f9e44a5a90ec$var$H3 = (0, $5UMQ1.default).h3`
	color: ${(0, $kKnoQ.colors).primary};
`;
const $d179f9e44a5a90ec$var$Description = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)()};
`;
const $d179f9e44a5a90ec$var$Content = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(18)}
`;
const $d179f9e44a5a90ec$var$Steps = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(16)};
`;
const $d179f9e44a5a90ec$var$Step = (0, $5UMQ1.default).div`
	padding-left: 1.5rem;
	position: relative;

	span {
		color: ${(0, $kKnoQ.colors).black};
	}
`;
const $d179f9e44a5a90ec$var$StepIndex = (0, $5UMQ1.default).div`
	position: absolute;
	top: 0;
	left: 0;
`;
const $d179f9e44a5a90ec$var$CodeContainer = (0, $5UMQ1.default).div`
	position: relative;
	padding: 24px;
	${(0, $5WGN2.stack)(undefined, "center", "center")};
	border-radius: 8px;
	border: 2px solid ${(0, $kKnoQ.colors).primaryBackground};
	background-color: ${(0, $kKnoQ.colors).primaryBackground};

	@media print {
		background-color: ${(0, $kKnoQ.colors).primaryBackground} !important;
		-webkit-print-color-adjust: exact;
	}
`;
const $d179f9e44a5a90ec$var$ColoredText = (0, $5UMQ1.default).span`
	color: ${(0, $kKnoQ.colors).primary};
`;
const $d179f9e44a5a90ec$var$StyledQRCode = (0, $5UMQ1.default)((0, (/*@__PURE__*/$parcel$interopDefault($arO47))))`
	print-color-adjust: exact;
`;

});
parcelRegister("arO47", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QRCode = undefined;
var $79b342edc43381de$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $gc7GP = parcelRequire("gc7GP");
var $79b342edc43381de$var$_propTypes2 = $79b342edc43381de$var$_interopRequireDefault($gc7GP);

var $d5EaJ = parcelRequire("d5EaJ");
var $79b342edc43381de$var$_ErrorCorrectLevel2 = $79b342edc43381de$var$_interopRequireDefault($d5EaJ);

var $lTnbc = parcelRequire("lTnbc");
var $79b342edc43381de$var$_QRCode2 = $79b342edc43381de$var$_interopRequireDefault($lTnbc);

var $81g6h = parcelRequire("81g6h");
var $79b342edc43381de$var$_react2 = $79b342edc43381de$var$_interopRequireDefault($81g6h);

var $ibZvH = parcelRequire("ibZvH");
var $79b342edc43381de$var$_QRCodeSvg2 = $79b342edc43381de$var$_interopRequireDefault($ibZvH);
function $79b342edc43381de$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $79b342edc43381de$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
// A `qr.js` doesn't handle error level of zero (M) so we need to do it right, thus the deep require.
var $79b342edc43381de$var$propTypes = {
    bgColor: $79b342edc43381de$var$_propTypes2.default.oneOfType([
        $79b342edc43381de$var$_propTypes2.default.object,
        $79b342edc43381de$var$_propTypes2.default.string
    ]),
    fgColor: $79b342edc43381de$var$_propTypes2.default.oneOfType([
        $79b342edc43381de$var$_propTypes2.default.object,
        $79b342edc43381de$var$_propTypes2.default.string
    ]),
    level: $79b342edc43381de$var$_propTypes2.default.string,
    size: $79b342edc43381de$var$_propTypes2.default.number,
    value: $79b342edc43381de$var$_propTypes2.default.string.isRequired
};
var $79b342edc43381de$var$QRCode = (0, $81g6h.forwardRef)(function(_ref, ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === undefined ? "#FFFFFF" : _ref$bgColor, _ref$fgColor = _ref.fgColor, fgColor = _ref$fgColor === undefined ? "#000000" : _ref$fgColor, _ref$level = _ref.level, level = _ref$level === undefined ? "L" : _ref$level, _ref$size = _ref.size, size = _ref$size === undefined ? 256 : _ref$size, value = _ref.value, props = $79b342edc43381de$var$_objectWithoutProperties(_ref, [
        "bgColor",
        "fgColor",
        "level",
        "size",
        "value"
    ]);
    // Use type === -1 to automatically pick the best type.
    var qrcode = new $79b342edc43381de$var$_QRCode2.default(-1, $79b342edc43381de$var$_ErrorCorrectLevel2.default[level]);
    qrcode.addData(value);
    qrcode.make();
    var cells = qrcode.modules;
    return $79b342edc43381de$var$_react2.default.createElement($79b342edc43381de$var$_QRCodeSvg2.default, $79b342edc43381de$var$_extends({}, props, {
        bgColor: bgColor,
        bgD: cells.map(function(row, rowIndex) {
            return row.map(function(cell, cellIndex) {
                return !cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
            }).join(" ");
        }).join(" "),
        fgColor: fgColor,
        fgD: cells.map(function(row, rowIndex) {
            return row.map(function(cell, cellIndex) {
                return cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
            }).join(" ");
        }).join(" "),
        ref: ref,
        size: size,
        viewBoxSize: cells.length
    }));
});
module.exports.QRCode = $79b342edc43381de$var$QRCode;
$79b342edc43381de$var$QRCode.displayName = "QRCode";
$79b342edc43381de$var$QRCode.propTypes = $79b342edc43381de$var$propTypes;
module.exports.default = $79b342edc43381de$var$QRCode;

});
parcelRegister("gc7GP", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bca3bb5fee8a4e2e$var$ReactIs, $bca3bb5fee8a4e2e$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("ddMj4"))();

});

parcelRegister("d5EaJ", function(module, exports) {
module.exports = {
    L: 1,
    M: 0,
    Q: 3,
    H: 2
};

});

parcelRegister("lTnbc", function(module, exports) {

var $2zVpG = parcelRequire("2zVpG");

var $dtSgL = parcelRequire("dtSgL");

var $iO4Jm = parcelRequire("iO4Jm");

var $cZ0hg = parcelRequire("cZ0hg");

var $ATWdu = parcelRequire("ATWdu");
function $ff00b7084dd8e00f$var$QRCode(typeNumber, errorCorrectLevel) {
    this.typeNumber = typeNumber;
    this.errorCorrectLevel = errorCorrectLevel;
    this.modules = null;
    this.moduleCount = 0;
    this.dataCache = null;
    this.dataList = [];
}
// for client side minification
var $ff00b7084dd8e00f$var$proto = $ff00b7084dd8e00f$var$QRCode.prototype;
$ff00b7084dd8e00f$var$proto.addData = function(data) {
    var newData = new $2zVpG(data);
    this.dataList.push(newData);
    this.dataCache = null;
};
$ff00b7084dd8e00f$var$proto.isDark = function(row, col) {
    if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) throw new Error(row + "," + col);
    return this.modules[row][col];
};
$ff00b7084dd8e00f$var$proto.getModuleCount = function() {
    return this.moduleCount;
};
$ff00b7084dd8e00f$var$proto.make = function() {
    // Calculate automatically typeNumber if provided is < 1
    if (this.typeNumber < 1) {
        var typeNumber = 1;
        for(typeNumber = 1; typeNumber < 40; typeNumber++){
            var rsBlocks = $dtSgL.getRSBlocks(typeNumber, this.errorCorrectLevel);
            var buffer = new $iO4Jm();
            var totalDataCount = 0;
            for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
            for(var i = 0; i < this.dataList.length; i++){
                var data = this.dataList[i];
                buffer.put(data.mode, 4);
                buffer.put(data.getLength(), $cZ0hg.getLengthInBits(data.mode, typeNumber));
                data.write(buffer);
            }
            if (buffer.getLengthInBits() <= totalDataCount * 8) break;
        }
        this.typeNumber = typeNumber;
    }
    this.makeImpl(false, this.getBestMaskPattern());
};
$ff00b7084dd8e00f$var$proto.makeImpl = function(test, maskPattern) {
    this.moduleCount = this.typeNumber * 4 + 17;
    this.modules = new Array(this.moduleCount);
    for(var row = 0; row < this.moduleCount; row++){
        this.modules[row] = new Array(this.moduleCount);
        for(var col = 0; col < this.moduleCount; col++)this.modules[row][col] = null; //(col + row) % 3;
    }
    this.setupPositionProbePattern(0, 0);
    this.setupPositionProbePattern(this.moduleCount - 7, 0);
    this.setupPositionProbePattern(0, this.moduleCount - 7);
    this.setupPositionAdjustPattern();
    this.setupTimingPattern();
    this.setupTypeInfo(test, maskPattern);
    if (this.typeNumber >= 7) this.setupTypeNumber(test);
    if (this.dataCache == null) this.dataCache = $ff00b7084dd8e00f$var$QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
    this.mapData(this.dataCache, maskPattern);
};
$ff00b7084dd8e00f$var$proto.setupPositionProbePattern = function(row, col) {
    for(var r = -1; r <= 7; r++){
        if (row + r <= -1 || this.moduleCount <= row + r) continue;
        for(var c = -1; c <= 7; c++){
            if (col + c <= -1 || this.moduleCount <= col + c) continue;
            if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) this.modules[row + r][col + c] = true;
            else this.modules[row + r][col + c] = false;
        }
    }
};
$ff00b7084dd8e00f$var$proto.getBestMaskPattern = function() {
    var minLostPoint = 0;
    var pattern = 0;
    for(var i = 0; i < 8; i++){
        this.makeImpl(true, i);
        var lostPoint = $cZ0hg.getLostPoint(this);
        if (i == 0 || minLostPoint > lostPoint) {
            minLostPoint = lostPoint;
            pattern = i;
        }
    }
    return pattern;
};
$ff00b7084dd8e00f$var$proto.createMovieClip = function(target_mc, instance_name, depth) {
    var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
    var cs = 1;
    this.make();
    for(var row = 0; row < this.modules.length; row++){
        var y = row * cs;
        for(var col = 0; col < this.modules[row].length; col++){
            var x = col * cs;
            var dark = this.modules[row][col];
            if (dark) {
                qr_mc.beginFill(0, 100);
                qr_mc.moveTo(x, y);
                qr_mc.lineTo(x + cs, y);
                qr_mc.lineTo(x + cs, y + cs);
                qr_mc.lineTo(x, y + cs);
                qr_mc.endFill();
            }
        }
    }
    return qr_mc;
};
$ff00b7084dd8e00f$var$proto.setupTimingPattern = function() {
    for(var r = 8; r < this.moduleCount - 8; r++){
        if (this.modules[r][6] != null) continue;
        this.modules[r][6] = r % 2 == 0;
    }
    for(var c = 8; c < this.moduleCount - 8; c++){
        if (this.modules[6][c] != null) continue;
        this.modules[6][c] = c % 2 == 0;
    }
};
$ff00b7084dd8e00f$var$proto.setupPositionAdjustPattern = function() {
    var pos = $cZ0hg.getPatternPosition(this.typeNumber);
    for(var i = 0; i < pos.length; i++)for(var j = 0; j < pos.length; j++){
        var row = pos[i];
        var col = pos[j];
        if (this.modules[row][col] != null) continue;
        for(var r = -2; r <= 2; r++){
            for(var c = -2; c <= 2; c++)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) this.modules[row + r][col + c] = true;
            else this.modules[row + r][col + c] = false;
        }
    }
};
$ff00b7084dd8e00f$var$proto.setupTypeNumber = function(test) {
    var bits = $cZ0hg.getBCHTypeNumber(this.typeNumber);
    for(var i = 0; i < 18; i++){
        var mod = !test && (bits >> i & 1) == 1;
        this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
    }
    for(var i = 0; i < 18; i++){
        var mod = !test && (bits >> i & 1) == 1;
        this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
    }
};
$ff00b7084dd8e00f$var$proto.setupTypeInfo = function(test, maskPattern) {
    var data = this.errorCorrectLevel << 3 | maskPattern;
    var bits = $cZ0hg.getBCHTypeInfo(data);
    // vertical		
    for(var i = 0; i < 15; i++){
        var mod = !test && (bits >> i & 1) == 1;
        if (i < 6) this.modules[i][8] = mod;
        else if (i < 8) this.modules[i + 1][8] = mod;
        else this.modules[this.moduleCount - 15 + i][8] = mod;
    }
    // horizontal
    for(var i = 0; i < 15; i++){
        var mod = !test && (bits >> i & 1) == 1;
        if (i < 8) this.modules[8][this.moduleCount - i - 1] = mod;
        else if (i < 9) this.modules[8][15 - i - 1 + 1] = mod;
        else this.modules[8][15 - i - 1] = mod;
    }
    // fixed module
    this.modules[this.moduleCount - 8][8] = !test;
};
$ff00b7084dd8e00f$var$proto.mapData = function(data, maskPattern) {
    var inc = -1;
    var row = this.moduleCount - 1;
    var bitIndex = 7;
    var byteIndex = 0;
    for(var col = this.moduleCount - 1; col > 0; col -= 2){
        if (col == 6) col--;
        while(true){
            for(var c = 0; c < 2; c++)if (this.modules[row][col - c] == null) {
                var dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                var mask = $cZ0hg.getMask(maskPattern, row, col - c);
                if (mask) dark = !dark;
                this.modules[row][col - c] = dark;
                bitIndex--;
                if (bitIndex == -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || this.moduleCount <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
};
$ff00b7084dd8e00f$var$QRCode.PAD0 = 0xEC;
$ff00b7084dd8e00f$var$QRCode.PAD1 = 0x11;
$ff00b7084dd8e00f$var$QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
    var rsBlocks = $dtSgL.getRSBlocks(typeNumber, errorCorrectLevel);
    var buffer = new $iO4Jm();
    for(var i = 0; i < dataList.length; i++){
        var data = dataList[i];
        buffer.put(data.mode, 4);
        buffer.put(data.getLength(), $cZ0hg.getLengthInBits(data.mode, typeNumber));
        data.write(buffer);
    }
    // calc num max data.
    var totalDataCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
    if (buffer.getLengthInBits() > totalDataCount * 8) throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
    // end code
    if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
    // padding
    while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
    // padding
    while(true){
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put($ff00b7084dd8e00f$var$QRCode.PAD0, 8);
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put($ff00b7084dd8e00f$var$QRCode.PAD1, 8);
    }
    return $ff00b7084dd8e00f$var$QRCode.createBytes(buffer, rsBlocks);
};
$ff00b7084dd8e00f$var$QRCode.createBytes = function(buffer, rsBlocks) {
    var offset = 0;
    var maxDcCount = 0;
    var maxEcCount = 0;
    var dcdata = new Array(rsBlocks.length);
    var ecdata = new Array(rsBlocks.length);
    for(var r = 0; r < rsBlocks.length; r++){
        var dcCount = rsBlocks[r].dataCount;
        var ecCount = rsBlocks[r].totalCount - dcCount;
        maxDcCount = Math.max(maxDcCount, dcCount);
        maxEcCount = Math.max(maxEcCount, ecCount);
        dcdata[r] = new Array(dcCount);
        for(var i = 0; i < dcdata[r].length; i++)dcdata[r][i] = 0xff & buffer.buffer[i + offset];
        offset += dcCount;
        var rsPoly = $cZ0hg.getErrorCorrectPolynomial(ecCount);
        var rawPoly = new $ATWdu(dcdata[r], rsPoly.getLength() - 1);
        var modPoly = rawPoly.mod(rsPoly);
        ecdata[r] = new Array(rsPoly.getLength() - 1);
        for(var i = 0; i < ecdata[r].length; i++){
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
            ecdata[r][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
        }
    }
    var totalCodeCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalCodeCount += rsBlocks[i].totalCount;
    var data = new Array(totalCodeCount);
    var index = 0;
    for(var i = 0; i < maxDcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < dcdata[r].length) data[index++] = dcdata[r][i];
    }
    for(var i = 0; i < maxEcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < ecdata[r].length) data[index++] = ecdata[r][i];
    }
    return data;
};
module.exports = $ff00b7084dd8e00f$var$QRCode;

});
parcelRegister("2zVpG", function(module, exports) {

var $82zhH = parcelRequire("82zhH");
function $1e0b62b67e9e74aa$var$QR8bitByte(data) {
    this.mode = $82zhH.MODE_8BIT_BYTE;
    this.data = data;
}
$1e0b62b67e9e74aa$var$QR8bitByte.prototype = {
    getLength: function(buffer) {
        return this.data.length;
    },
    write: function(buffer) {
        for(var i = 0; i < this.data.length; i++)// not JIS ...
        buffer.put(this.data.charCodeAt(i), 8);
    }
};
module.exports = $1e0b62b67e9e74aa$var$QR8bitByte;

});
parcelRegister("82zhH", function(module, exports) {
module.exports = {
    MODE_NUMBER: 1,
    MODE_ALPHA_NUM: 2,
    MODE_8BIT_BYTE: 4,
    MODE_KANJI: 8
};

});


parcelRegister("dtSgL", function(module, exports) {
// ErrorCorrectLevel

var $d5EaJ = parcelRequire("d5EaJ");
function $9d08148d9a5f27cd$var$QRRSBlock(totalCount, dataCount) {
    this.totalCount = totalCount;
    this.dataCount = dataCount;
}
$9d08148d9a5f27cd$var$QRRSBlock.RS_BLOCK_TABLE = [
    // L
    // M
    // Q
    // H
    // 1
    [
        1,
        26,
        19
    ],
    [
        1,
        26,
        16
    ],
    [
        1,
        26,
        13
    ],
    [
        1,
        26,
        9
    ],
    // 2
    [
        1,
        44,
        34
    ],
    [
        1,
        44,
        28
    ],
    [
        1,
        44,
        22
    ],
    [
        1,
        44,
        16
    ],
    // 3
    [
        1,
        70,
        55
    ],
    [
        1,
        70,
        44
    ],
    [
        2,
        35,
        17
    ],
    [
        2,
        35,
        13
    ],
    // 4		
    [
        1,
        100,
        80
    ],
    [
        2,
        50,
        32
    ],
    [
        2,
        50,
        24
    ],
    [
        4,
        25,
        9
    ],
    // 5
    [
        1,
        134,
        108
    ],
    [
        2,
        67,
        43
    ],
    [
        2,
        33,
        15,
        2,
        34,
        16
    ],
    [
        2,
        33,
        11,
        2,
        34,
        12
    ],
    // 6
    [
        2,
        86,
        68
    ],
    [
        4,
        43,
        27
    ],
    [
        4,
        43,
        19
    ],
    [
        4,
        43,
        15
    ],
    // 7		
    [
        2,
        98,
        78
    ],
    [
        4,
        49,
        31
    ],
    [
        2,
        32,
        14,
        4,
        33,
        15
    ],
    [
        4,
        39,
        13,
        1,
        40,
        14
    ],
    // 8
    [
        2,
        121,
        97
    ],
    [
        2,
        60,
        38,
        2,
        61,
        39
    ],
    [
        4,
        40,
        18,
        2,
        41,
        19
    ],
    [
        4,
        40,
        14,
        2,
        41,
        15
    ],
    // 9
    [
        2,
        146,
        116
    ],
    [
        3,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        36,
        16,
        4,
        37,
        17
    ],
    [
        4,
        36,
        12,
        4,
        37,
        13
    ],
    // 10		
    [
        2,
        86,
        68,
        2,
        87,
        69
    ],
    [
        4,
        69,
        43,
        1,
        70,
        44
    ],
    [
        6,
        43,
        19,
        2,
        44,
        20
    ],
    [
        6,
        43,
        15,
        2,
        44,
        16
    ],
    // 11
    [
        4,
        101,
        81
    ],
    [
        1,
        80,
        50,
        4,
        81,
        51
    ],
    [
        4,
        50,
        22,
        4,
        51,
        23
    ],
    [
        3,
        36,
        12,
        8,
        37,
        13
    ],
    // 12
    [
        2,
        116,
        92,
        2,
        117,
        93
    ],
    [
        6,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        46,
        20,
        6,
        47,
        21
    ],
    [
        7,
        42,
        14,
        4,
        43,
        15
    ],
    // 13
    [
        4,
        133,
        107
    ],
    [
        8,
        59,
        37,
        1,
        60,
        38
    ],
    [
        8,
        44,
        20,
        4,
        45,
        21
    ],
    [
        12,
        33,
        11,
        4,
        34,
        12
    ],
    // 14
    [
        3,
        145,
        115,
        1,
        146,
        116
    ],
    [
        4,
        64,
        40,
        5,
        65,
        41
    ],
    [
        11,
        36,
        16,
        5,
        37,
        17
    ],
    [
        11,
        36,
        12,
        5,
        37,
        13
    ],
    // 15
    [
        5,
        109,
        87,
        1,
        110,
        88
    ],
    [
        5,
        65,
        41,
        5,
        66,
        42
    ],
    [
        5,
        54,
        24,
        7,
        55,
        25
    ],
    [
        11,
        36,
        12
    ],
    // 16
    [
        5,
        122,
        98,
        1,
        123,
        99
    ],
    [
        7,
        73,
        45,
        3,
        74,
        46
    ],
    [
        15,
        43,
        19,
        2,
        44,
        20
    ],
    [
        3,
        45,
        15,
        13,
        46,
        16
    ],
    // 17
    [
        1,
        135,
        107,
        5,
        136,
        108
    ],
    [
        10,
        74,
        46,
        1,
        75,
        47
    ],
    [
        1,
        50,
        22,
        15,
        51,
        23
    ],
    [
        2,
        42,
        14,
        17,
        43,
        15
    ],
    // 18
    [
        5,
        150,
        120,
        1,
        151,
        121
    ],
    [
        9,
        69,
        43,
        4,
        70,
        44
    ],
    [
        17,
        50,
        22,
        1,
        51,
        23
    ],
    [
        2,
        42,
        14,
        19,
        43,
        15
    ],
    // 19
    [
        3,
        141,
        113,
        4,
        142,
        114
    ],
    [
        3,
        70,
        44,
        11,
        71,
        45
    ],
    [
        17,
        47,
        21,
        4,
        48,
        22
    ],
    [
        9,
        39,
        13,
        16,
        40,
        14
    ],
    // 20
    [
        3,
        135,
        107,
        5,
        136,
        108
    ],
    [
        3,
        67,
        41,
        13,
        68,
        42
    ],
    [
        15,
        54,
        24,
        5,
        55,
        25
    ],
    [
        15,
        43,
        15,
        10,
        44,
        16
    ],
    // 21
    [
        4,
        144,
        116,
        4,
        145,
        117
    ],
    [
        17,
        68,
        42
    ],
    [
        17,
        50,
        22,
        6,
        51,
        23
    ],
    [
        19,
        46,
        16,
        6,
        47,
        17
    ],
    // 22
    [
        2,
        139,
        111,
        7,
        140,
        112
    ],
    [
        17,
        74,
        46
    ],
    [
        7,
        54,
        24,
        16,
        55,
        25
    ],
    [
        34,
        37,
        13
    ],
    // 23
    [
        4,
        151,
        121,
        5,
        152,
        122
    ],
    [
        4,
        75,
        47,
        14,
        76,
        48
    ],
    [
        11,
        54,
        24,
        14,
        55,
        25
    ],
    [
        16,
        45,
        15,
        14,
        46,
        16
    ],
    // 24
    [
        6,
        147,
        117,
        4,
        148,
        118
    ],
    [
        6,
        73,
        45,
        14,
        74,
        46
    ],
    [
        11,
        54,
        24,
        16,
        55,
        25
    ],
    [
        30,
        46,
        16,
        2,
        47,
        17
    ],
    // 25
    [
        8,
        132,
        106,
        4,
        133,
        107
    ],
    [
        8,
        75,
        47,
        13,
        76,
        48
    ],
    [
        7,
        54,
        24,
        22,
        55,
        25
    ],
    [
        22,
        45,
        15,
        13,
        46,
        16
    ],
    // 26
    [
        10,
        142,
        114,
        2,
        143,
        115
    ],
    [
        19,
        74,
        46,
        4,
        75,
        47
    ],
    [
        28,
        50,
        22,
        6,
        51,
        23
    ],
    [
        33,
        46,
        16,
        4,
        47,
        17
    ],
    // 27
    [
        8,
        152,
        122,
        4,
        153,
        123
    ],
    [
        22,
        73,
        45,
        3,
        74,
        46
    ],
    [
        8,
        53,
        23,
        26,
        54,
        24
    ],
    [
        12,
        45,
        15,
        28,
        46,
        16
    ],
    // 28
    [
        3,
        147,
        117,
        10,
        148,
        118
    ],
    [
        3,
        73,
        45,
        23,
        74,
        46
    ],
    [
        4,
        54,
        24,
        31,
        55,
        25
    ],
    [
        11,
        45,
        15,
        31,
        46,
        16
    ],
    // 29
    [
        7,
        146,
        116,
        7,
        147,
        117
    ],
    [
        21,
        73,
        45,
        7,
        74,
        46
    ],
    [
        1,
        53,
        23,
        37,
        54,
        24
    ],
    [
        19,
        45,
        15,
        26,
        46,
        16
    ],
    // 30
    [
        5,
        145,
        115,
        10,
        146,
        116
    ],
    [
        19,
        75,
        47,
        10,
        76,
        48
    ],
    [
        15,
        54,
        24,
        25,
        55,
        25
    ],
    [
        23,
        45,
        15,
        25,
        46,
        16
    ],
    // 31
    [
        13,
        145,
        115,
        3,
        146,
        116
    ],
    [
        2,
        74,
        46,
        29,
        75,
        47
    ],
    [
        42,
        54,
        24,
        1,
        55,
        25
    ],
    [
        23,
        45,
        15,
        28,
        46,
        16
    ],
    // 32
    [
        17,
        145,
        115
    ],
    [
        10,
        74,
        46,
        23,
        75,
        47
    ],
    [
        10,
        54,
        24,
        35,
        55,
        25
    ],
    [
        19,
        45,
        15,
        35,
        46,
        16
    ],
    // 33
    [
        17,
        145,
        115,
        1,
        146,
        116
    ],
    [
        14,
        74,
        46,
        21,
        75,
        47
    ],
    [
        29,
        54,
        24,
        19,
        55,
        25
    ],
    [
        11,
        45,
        15,
        46,
        46,
        16
    ],
    // 34
    [
        13,
        145,
        115,
        6,
        146,
        116
    ],
    [
        14,
        74,
        46,
        23,
        75,
        47
    ],
    [
        44,
        54,
        24,
        7,
        55,
        25
    ],
    [
        59,
        46,
        16,
        1,
        47,
        17
    ],
    // 35
    [
        12,
        151,
        121,
        7,
        152,
        122
    ],
    [
        12,
        75,
        47,
        26,
        76,
        48
    ],
    [
        39,
        54,
        24,
        14,
        55,
        25
    ],
    [
        22,
        45,
        15,
        41,
        46,
        16
    ],
    // 36
    [
        6,
        151,
        121,
        14,
        152,
        122
    ],
    [
        6,
        75,
        47,
        34,
        76,
        48
    ],
    [
        46,
        54,
        24,
        10,
        55,
        25
    ],
    [
        2,
        45,
        15,
        64,
        46,
        16
    ],
    // 37
    [
        17,
        152,
        122,
        4,
        153,
        123
    ],
    [
        29,
        74,
        46,
        14,
        75,
        47
    ],
    [
        49,
        54,
        24,
        10,
        55,
        25
    ],
    [
        24,
        45,
        15,
        46,
        46,
        16
    ],
    // 38
    [
        4,
        152,
        122,
        18,
        153,
        123
    ],
    [
        13,
        74,
        46,
        32,
        75,
        47
    ],
    [
        48,
        54,
        24,
        14,
        55,
        25
    ],
    [
        42,
        45,
        15,
        32,
        46,
        16
    ],
    // 39
    [
        20,
        147,
        117,
        4,
        148,
        118
    ],
    [
        40,
        75,
        47,
        7,
        76,
        48
    ],
    [
        43,
        54,
        24,
        22,
        55,
        25
    ],
    [
        10,
        45,
        15,
        67,
        46,
        16
    ],
    // 40
    [
        19,
        148,
        118,
        6,
        149,
        119
    ],
    [
        18,
        75,
        47,
        31,
        76,
        48
    ],
    [
        34,
        54,
        24,
        34,
        55,
        25
    ],
    [
        20,
        45,
        15,
        61,
        46,
        16
    ]
];
$9d08148d9a5f27cd$var$QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
    var rsBlock = $9d08148d9a5f27cd$var$QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
    if (rsBlock == undefined) throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
    var length = rsBlock.length / 3;
    var list = new Array();
    for(var i = 0; i < length; i++){
        var count = rsBlock[i * 3 + 0];
        var totalCount = rsBlock[i * 3 + 1];
        var dataCount = rsBlock[i * 3 + 2];
        for(var j = 0; j < count; j++)list.push(new $9d08148d9a5f27cd$var$QRRSBlock(totalCount, dataCount));
    }
    return list;
};
$9d08148d9a5f27cd$var$QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
    switch(errorCorrectLevel){
        case $d5EaJ.L:
            return $9d08148d9a5f27cd$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
        case $d5EaJ.M:
            return $9d08148d9a5f27cd$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
        case $d5EaJ.Q:
            return $9d08148d9a5f27cd$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
        case $d5EaJ.H:
            return $9d08148d9a5f27cd$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
        default:
            return undefined;
    }
};
module.exports = $9d08148d9a5f27cd$var$QRRSBlock;

});

parcelRegister("iO4Jm", function(module, exports) {
function $db1090ed7309553e$var$QRBitBuffer() {
    this.buffer = new Array();
    this.length = 0;
}
$db1090ed7309553e$var$QRBitBuffer.prototype = {
    get: function(index) {
        var bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
    },
    put: function(num, length) {
        for(var i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) == 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        var bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
module.exports = $db1090ed7309553e$var$QRBitBuffer;

});

parcelRegister("cZ0hg", function(module, exports) {

var $82zhH = parcelRequire("82zhH");

var $ATWdu = parcelRequire("ATWdu");

var $8ys5E = parcelRequire("8ys5E");
var $973b659cf71ec3d6$var$QRMaskPattern = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
var $973b659cf71ec3d6$var$QRUtil = {
    PATTERN_POSITION_TABLE: [
        [],
        [
            6,
            18
        ],
        [
            6,
            22
        ],
        [
            6,
            26
        ],
        [
            6,
            30
        ],
        [
            6,
            34
        ],
        [
            6,
            22,
            38
        ],
        [
            6,
            24,
            42
        ],
        [
            6,
            26,
            46
        ],
        [
            6,
            28,
            50
        ],
        [
            6,
            30,
            54
        ],
        [
            6,
            32,
            58
        ],
        [
            6,
            34,
            62
        ],
        [
            6,
            26,
            46,
            66
        ],
        [
            6,
            26,
            48,
            70
        ],
        [
            6,
            26,
            50,
            74
        ],
        [
            6,
            30,
            54,
            78
        ],
        [
            6,
            30,
            56,
            82
        ],
        [
            6,
            30,
            58,
            86
        ],
        [
            6,
            34,
            62,
            90
        ],
        [
            6,
            28,
            50,
            72,
            94
        ],
        [
            6,
            26,
            50,
            74,
            98
        ],
        [
            6,
            30,
            54,
            78,
            102
        ],
        [
            6,
            28,
            54,
            80,
            106
        ],
        [
            6,
            32,
            58,
            84,
            110
        ],
        [
            6,
            30,
            58,
            86,
            114
        ],
        [
            6,
            34,
            62,
            90,
            118
        ],
        [
            6,
            26,
            50,
            74,
            98,
            122
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126
        ],
        [
            6,
            26,
            52,
            78,
            104,
            130
        ],
        [
            6,
            30,
            56,
            82,
            108,
            134
        ],
        [
            6,
            34,
            60,
            86,
            112,
            138
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142
        ],
        [
            6,
            34,
            62,
            90,
            118,
            146
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ],
        [
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ],
        [
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ],
        [
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ],
        [
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]
    ],
    G15: 1335,
    G18: 7973,
    G15_MASK: 21522,
    getBCHTypeInfo: function(data) {
        var d = data << 10;
        while($973b659cf71ec3d6$var$QRUtil.getBCHDigit(d) - $973b659cf71ec3d6$var$QRUtil.getBCHDigit($973b659cf71ec3d6$var$QRUtil.G15) >= 0)d ^= $973b659cf71ec3d6$var$QRUtil.G15 << $973b659cf71ec3d6$var$QRUtil.getBCHDigit(d) - $973b659cf71ec3d6$var$QRUtil.getBCHDigit($973b659cf71ec3d6$var$QRUtil.G15);
        return (data << 10 | d) ^ $973b659cf71ec3d6$var$QRUtil.G15_MASK;
    },
    getBCHTypeNumber: function(data) {
        var d = data << 12;
        while($973b659cf71ec3d6$var$QRUtil.getBCHDigit(d) - $973b659cf71ec3d6$var$QRUtil.getBCHDigit($973b659cf71ec3d6$var$QRUtil.G18) >= 0)d ^= $973b659cf71ec3d6$var$QRUtil.G18 << $973b659cf71ec3d6$var$QRUtil.getBCHDigit(d) - $973b659cf71ec3d6$var$QRUtil.getBCHDigit($973b659cf71ec3d6$var$QRUtil.G18);
        return data << 12 | d;
    },
    getBCHDigit: function(data) {
        var digit = 0;
        while(data != 0){
            digit++;
            data >>>= 1;
        }
        return digit;
    },
    getPatternPosition: function(typeNumber) {
        return $973b659cf71ec3d6$var$QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },
    getMask: function(maskPattern, i, j) {
        switch(maskPattern){
            case $973b659cf71ec3d6$var$QRMaskPattern.PATTERN000:
                return (i + j) % 2 == 0;
            case $973b659cf71ec3d6$var$QRMaskPattern.PATTERN001:
                return i % 2 == 0;
            case $973b659cf71ec3d6$var$QRMaskPattern.PATTERN010:
                return j % 3 == 0;
            case $973b659cf71ec3d6$var$QRMaskPattern.PATTERN011:
                return (i + j) % 3 == 0;
            case $973b659cf71ec3d6$var$QRMaskPattern.PATTERN100:
                return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
            case $973b659cf71ec3d6$var$QRMaskPattern.PATTERN101:
                return i * j % 2 + i * j % 3 == 0;
            case $973b659cf71ec3d6$var$QRMaskPattern.PATTERN110:
                return (i * j % 2 + i * j % 3) % 2 == 0;
            case $973b659cf71ec3d6$var$QRMaskPattern.PATTERN111:
                return (i * j % 3 + (i + j) % 2) % 2 == 0;
            default:
                throw new Error("bad maskPattern:" + maskPattern);
        }
    },
    getErrorCorrectPolynomial: function(errorCorrectLength) {
        var a = new $ATWdu([
            1
        ], 0);
        for(var i = 0; i < errorCorrectLength; i++)a = a.multiply(new $ATWdu([
            1,
            $8ys5E.gexp(i)
        ], 0));
        return a;
    },
    getLengthInBits: function(mode, type) {
        if (1 <= type && type < 10) // 1 - 9
        switch(mode){
            case $82zhH.MODE_NUMBER:
                return 10;
            case $82zhH.MODE_ALPHA_NUM:
                return 9;
            case $82zhH.MODE_8BIT_BYTE:
                return 8;
            case $82zhH.MODE_KANJI:
                return 8;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 27) // 10 - 26
        switch(mode){
            case $82zhH.MODE_NUMBER:
                return 12;
            case $82zhH.MODE_ALPHA_NUM:
                return 11;
            case $82zhH.MODE_8BIT_BYTE:
                return 16;
            case $82zhH.MODE_KANJI:
                return 10;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 41) // 27 - 40
        switch(mode){
            case $82zhH.MODE_NUMBER:
                return 14;
            case $82zhH.MODE_ALPHA_NUM:
                return 13;
            case $82zhH.MODE_8BIT_BYTE:
                return 16;
            case $82zhH.MODE_KANJI:
                return 12;
            default:
                throw new Error("mode:" + mode);
        }
        else throw new Error("type:" + type);
    },
    getLostPoint: function(qrCode) {
        var moduleCount = qrCode.getModuleCount();
        var lostPoint = 0;
        // LEVEL1
        for(var row = 0; row < moduleCount; row++)for(var col = 0; col < moduleCount; col++){
            var sameCount = 0;
            var dark = qrCode.isDark(row, col);
            for(var r = -1; r <= 1; r++){
                if (row + r < 0 || moduleCount <= row + r) continue;
                for(var c = -1; c <= 1; c++){
                    if (col + c < 0 || moduleCount <= col + c) continue;
                    if (r == 0 && c == 0) continue;
                    if (dark == qrCode.isDark(row + r, col + c)) sameCount++;
                }
            }
            if (sameCount > 5) lostPoint += 3 + sameCount - 5;
        }
        // LEVEL2
        for(var row = 0; row < moduleCount - 1; row++)for(var col = 0; col < moduleCount - 1; col++){
            var count = 0;
            if (qrCode.isDark(row, col)) count++;
            if (qrCode.isDark(row + 1, col)) count++;
            if (qrCode.isDark(row, col + 1)) count++;
            if (qrCode.isDark(row + 1, col + 1)) count++;
            if (count == 0 || count == 4) lostPoint += 3;
        }
        // LEVEL3
        for(var row = 0; row < moduleCount; row++){
            for(var col = 0; col < moduleCount - 6; col++)if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) lostPoint += 40;
        }
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount - 6; row++)if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) lostPoint += 40;
        }
        // LEVEL4
        var darkCount = 0;
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount; row++)if (qrCode.isDark(row, col)) darkCount++;
        }
        var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;
        return lostPoint;
    }
};
module.exports = $973b659cf71ec3d6$var$QRUtil;

});
parcelRegister("ATWdu", function(module, exports) {

var $8ys5E = parcelRequire("8ys5E");
function $06eec10644df985a$var$QRPolynomial(num, shift) {
    if (num.length == undefined) throw new Error(num.length + "/" + shift);
    var offset = 0;
    while(offset < num.length && num[offset] == 0)offset++;
    this.num = new Array(num.length - offset + shift);
    for(var i = 0; i < num.length - offset; i++)this.num[i] = num[i + offset];
}
$06eec10644df985a$var$QRPolynomial.prototype = {
    get: function(index) {
        return this.num[index];
    },
    getLength: function() {
        return this.num.length;
    },
    multiply: function(e) {
        var num = new Array(this.getLength() + e.getLength() - 1);
        for(var i = 0; i < this.getLength(); i++)for(var j = 0; j < e.getLength(); j++)num[i + j] ^= $8ys5E.gexp($8ys5E.glog(this.get(i)) + $8ys5E.glog(e.get(j)));
        return new $06eec10644df985a$var$QRPolynomial(num, 0);
    },
    mod: function(e) {
        if (this.getLength() - e.getLength() < 0) return this;
        var ratio = $8ys5E.glog(this.get(0)) - $8ys5E.glog(e.get(0));
        var num = new Array(this.getLength());
        for(var i = 0; i < this.getLength(); i++)num[i] = this.get(i);
        for(var i = 0; i < e.getLength(); i++)num[i] ^= $8ys5E.gexp($8ys5E.glog(e.get(i)) + ratio);
        // recursive call
        return new $06eec10644df985a$var$QRPolynomial(num, 0).mod(e);
    }
};
module.exports = $06eec10644df985a$var$QRPolynomial;

});
parcelRegister("8ys5E", function(module, exports) {
var $63a749d093b6a55f$var$QRMath = {
    glog: function(n) {
        if (n < 1) throw new Error("glog(" + n + ")");
        return $63a749d093b6a55f$var$QRMath.LOG_TABLE[n];
    },
    gexp: function(n) {
        while(n < 0)n += 255;
        while(n >= 256)n -= 255;
        return $63a749d093b6a55f$var$QRMath.EXP_TABLE[n];
    },
    EXP_TABLE: new Array(256),
    LOG_TABLE: new Array(256)
};
for(var $63a749d093b6a55f$var$i = 0; $63a749d093b6a55f$var$i < 8; $63a749d093b6a55f$var$i++)$63a749d093b6a55f$var$QRMath.EXP_TABLE[$63a749d093b6a55f$var$i] = 1 << $63a749d093b6a55f$var$i;
for(var $63a749d093b6a55f$var$i = 8; $63a749d093b6a55f$var$i < 256; $63a749d093b6a55f$var$i++)$63a749d093b6a55f$var$QRMath.EXP_TABLE[$63a749d093b6a55f$var$i] = $63a749d093b6a55f$var$QRMath.EXP_TABLE[$63a749d093b6a55f$var$i - 4] ^ $63a749d093b6a55f$var$QRMath.EXP_TABLE[$63a749d093b6a55f$var$i - 5] ^ $63a749d093b6a55f$var$QRMath.EXP_TABLE[$63a749d093b6a55f$var$i - 6] ^ $63a749d093b6a55f$var$QRMath.EXP_TABLE[$63a749d093b6a55f$var$i - 8];
for(var $63a749d093b6a55f$var$i = 0; $63a749d093b6a55f$var$i < 255; $63a749d093b6a55f$var$i++)$63a749d093b6a55f$var$QRMath.LOG_TABLE[$63a749d093b6a55f$var$QRMath.EXP_TABLE[$63a749d093b6a55f$var$i]] = $63a749d093b6a55f$var$i;
module.exports = $63a749d093b6a55f$var$QRMath;

});




parcelRegister("ibZvH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d3e8f7bd26a7a94c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $gc7GP = parcelRequire("gc7GP");
var $d3e8f7bd26a7a94c$var$_propTypes2 = $d3e8f7bd26a7a94c$var$_interopRequireDefault($gc7GP);

var $81g6h = parcelRequire("81g6h");
var $d3e8f7bd26a7a94c$var$_react2 = $d3e8f7bd26a7a94c$var$_interopRequireDefault($81g6h);
function $d3e8f7bd26a7a94c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d3e8f7bd26a7a94c$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $d3e8f7bd26a7a94c$var$propTypes = {
    bgColor: $d3e8f7bd26a7a94c$var$_propTypes2.default.oneOfType([
        $d3e8f7bd26a7a94c$var$_propTypes2.default.object,
        $d3e8f7bd26a7a94c$var$_propTypes2.default.string
    ]).isRequired,
    bgD: $d3e8f7bd26a7a94c$var$_propTypes2.default.string.isRequired,
    fgColor: $d3e8f7bd26a7a94c$var$_propTypes2.default.oneOfType([
        $d3e8f7bd26a7a94c$var$_propTypes2.default.object,
        $d3e8f7bd26a7a94c$var$_propTypes2.default.string
    ]).isRequired,
    fgD: $d3e8f7bd26a7a94c$var$_propTypes2.default.string.isRequired,
    size: $d3e8f7bd26a7a94c$var$_propTypes2.default.number.isRequired,
    title: $d3e8f7bd26a7a94c$var$_propTypes2.default.string,
    viewBoxSize: $d3e8f7bd26a7a94c$var$_propTypes2.default.number.isRequired,
    xmlns: $d3e8f7bd26a7a94c$var$_propTypes2.default.string
};
var $d3e8f7bd26a7a94c$var$QRCodeSvg = (0, $81g6h.forwardRef)(function(_ref, ref) {
    var bgColor = _ref.bgColor, bgD = _ref.bgD, fgD = _ref.fgD, fgColor = _ref.fgColor, size = _ref.size, title = _ref.title, viewBoxSize = _ref.viewBoxSize, _ref$xmlns = _ref.xmlns, xmlns = _ref$xmlns === undefined ? "http://www.w3.org/2000/svg" : _ref$xmlns, props = $d3e8f7bd26a7a94c$var$_objectWithoutProperties(_ref, [
        "bgColor",
        "bgD",
        "fgD",
        "fgColor",
        "size",
        "title",
        "viewBoxSize",
        "xmlns"
    ]);
    return $d3e8f7bd26a7a94c$var$_react2.default.createElement("svg", $d3e8f7bd26a7a94c$var$_extends({}, props, {
        height: size,
        ref: ref,
        viewBox: "0 0 " + viewBoxSize + " " + viewBoxSize,
        width: size,
        xmlns: xmlns
    }), title ? $d3e8f7bd26a7a94c$var$_react2.default.createElement("title", null, title) : null, $d3e8f7bd26a7a94c$var$_react2.default.createElement("path", {
        d: bgD,
        fill: bgColor
    }), $d3e8f7bd26a7a94c$var$_react2.default.createElement("path", {
        d: fgD,
        fill: fgColor
    }));
});
$d3e8f7bd26a7a94c$var$QRCodeSvg.displayName = "QRCodeSvg";
$d3e8f7bd26a7a94c$var$QRCodeSvg.propTypes = $d3e8f7bd26a7a94c$var$propTypes;
module.exports.default = $d3e8f7bd26a7a94c$var$QRCodeSvg;

});



parcelRegister("7ms76", function(module, exports) {

$parcel$export(module.exports, "ShareUsingPrintForm", () => $60a294159a18e9d9$export$27b2a2933f9f4a7d);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");
parcelRequire("81g6h");
const $60a294159a18e9d9$export$27b2a2933f9f4a7d = ({ onSuccess: onSuccess })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)($60a294159a18e9d9$var$ButtonContainer, {
        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
            label: format("home.pendingPatientDialog.printButton"),
            onClick: ()=>{
                onSuccess?.();
            }
        })
    });
};
const $60a294159a18e9d9$var$ButtonContainer = (0, $5UMQ1.default).div`
	padding-top: 0.75rem;
	${(0, $5WGN2.row)(undefined, "flexend")};
	flex-grow: 1;
	height: 100%;
`;

});

parcelRegister("bS6dF", function(module, exports) {

$parcel$export(module.exports, "SharingUsingEmailForm", () => $382e15cd3054f4b3$export$a50bcf7b802174bb);

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $8FlUV = parcelRequire("8FlUV");

var $hIci4 = parcelRequire("hIci4");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $lTdpc = parcelRequire("lTdpc");

var $kI5xQ = parcelRequire("kI5xQ");

var $9AWgp = parcelRequire("9AWgp");
parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
const $382e15cd3054f4b3$export$a50bcf7b802174bb = ({ defaultEmail: defaultEmail, onSuccess: onSuccess })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { control: controlEmail, handleSubmit: handleEmailSubmit } = (0, $eKUeg.useForm)({
        defaultValues: {
            email: defaultEmail
        }
    });
    const [submitEmail, isLoading, isError] = (0, $grmoS.useAsyncOperation)(async (data)=>{
        await onSuccess?.(data.email);
    }, {
        minimumDuration: 500
    });
    return /*#__PURE__*/ (0, $iKObn.jsxs)($382e15cd3054f4b3$var$Form, {
        onSubmit: handleEmailSubmit(submitEmail),
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($382e15cd3054f4b3$var$FormField, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                        className: "p-size-m",
                        children: format("home.pendingPatientDialog.details.sharing.email.label")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                        name: "email",
                        control: controlEmail,
                        rules: {
                            required: format("global.form.field.requiredError"),
                            pattern: {
                                value: (0, $kI5xQ.REGEX_EMAIL),
                                message: format("home.pendingPatientDialog.details.sharing.email.incorrectFormat")
                            }
                        },
                        render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                        ...field,
                                        error: (0, $lTdpc.isNotNil)(fieldState.error),
                                        placeholder: format("home.pendingPatientDialog.details.sharing.email.placeholder"),
                                        autoCapitalize: "words"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $8FlUV.ErrorMessage), {
                                        children: isError || fieldState.error?.message
                                    })
                                ]
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($382e15cd3054f4b3$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $9AWgp.Button), {
                    loading: isLoading,
                    label: format("home.pendingPatientDialog.details.sharing.email.submitButton"),
                    type: "submit"
                })
            })
        ]
    });
};
const $382e15cd3054f4b3$var$ButtonContainer = (0, $5UMQ1.default).div`
	padding-top: 0.75rem;
	${(0, $5WGN2.row)(undefined, "flexend")}
`;
const $382e15cd3054f4b3$var$Form = (0, $5UMQ1.default).form`
	${(0, $5WGN2.stack)("M", "flexstart", "stretch")}
`;
const $382e15cd3054f4b3$var$FormField = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("S", "flexstart", "stretch")};
`;

});

parcelRegister("9WnvU", function(module, exports) {


!function(e, t) {
    module.exports = t((parcelRequire("81g6h")), (parcelRequire("Q1dTY")));
}("undefined" != typeof self ? self : module.exports, function(e, t) {
    return function() {
        "use strict";
        var r = {
            328: function(e, t, r) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PrintContextConsumer = t.PrintContext = void 0;
                var n = r(496), o = Object.prototype.hasOwnProperty.call(n, "createContext");
                t.PrintContext = o ? n.createContext({}) : null, t.PrintContextConsumer = t.PrintContext ? t.PrintContext.Consumer : function() {
                    return null;
                };
            },
            428: function(e, t, r) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ReactToPrint = void 0;
                var n = r(316), o = r(496), i = r(190), a = r(328), c = r(940), s = function(e) {
                    function t() {
                        var t = e.apply(this, n.__spreadArray([], n.__read(arguments), !1)) || this;
                        return t.startPrint = function(e) {
                            var r = t.props, n = r.onAfterPrint, o = r.onPrintError, i = r.print, a = r.documentTitle;
                            setTimeout(function() {
                                var r, c;
                                if (e.contentWindow) {
                                    if (e.contentWindow.focus(), i) i(e).then(function() {
                                        return null == n ? void 0 : n();
                                    }).then(function() {
                                        return t.handleRemoveIframe();
                                    }).catch(function(e) {
                                        o ? o("print", e) : t.logMessages([
                                            "An error was thrown by the specified `print` function"
                                        ]);
                                    });
                                    else {
                                        if (e.contentWindow.print) {
                                            var s = null !== (c = null === (r = e.contentDocument) || void 0 === r ? void 0 : r.title) && void 0 !== c ? c : "", u = e.ownerDocument.title;
                                            a && (e.ownerDocument.title = a, e.contentDocument && (e.contentDocument.title = a)), e.contentWindow.print(), a && (e.ownerDocument.title = u, e.contentDocument && (e.contentDocument.title = s));
                                        } else t.logMessages([
                                            "Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes."
                                        ]);
                                        null == n || n(), t.handleRemoveIframe();
                                    }
                                } else t.logMessages([
                                    "Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `react-to-print`. Please file an issue: https://github.com/gregnb/react-to-print/issues/"
                                ]);
                            }, 500);
                        }, t.triggerPrint = function(e) {
                            var r = t.props, n = r.onBeforePrint, o = r.onPrintError;
                            if (n) {
                                var i = n();
                                i && "function" == typeof i.then ? i.then(function() {
                                    t.startPrint(e);
                                }).catch(function(e) {
                                    o && o("onBeforePrint", e);
                                }) : t.startPrint(e);
                            } else t.startPrint(e);
                        }, t.handlePrint = function(e) {
                            var r = t.props, o = r.bodyClass, a = r.content, c = r.copyStyles, s = r.fonts, u = r.pageStyle, l = r.nonce, f = "function" == typeof e ? e() : null;
                            if (f && "function" == typeof a && t.logMessages([
                                '"react-to-print" received a `content` prop and a content param passed the callback return by `useReactToPrint. The `content` prop will be ignored.'
                            ], "warning"), f || "function" != typeof a || (f = a()), void 0 !== f) {
                                if (null !== f) {
                                    var d = document.createElement("iframe");
                                    d.width = "".concat(document.documentElement.clientWidth, "px"), d.height = "".concat(document.documentElement.clientHeight, "px"), d.style.position = "absolute", d.style.top = "-".concat(document.documentElement.clientHeight + 100, "px"), d.style.left = "-".concat(document.documentElement.clientWidth + 100, "px"), d.id = "printWindow", d.srcdoc = "<!DOCTYPE html>";
                                    var p = (0, i.findDOMNode)(f);
                                    if (p) {
                                        var h = p.cloneNode(!0), y = h instanceof Text, b = document.querySelectorAll("link[rel~='stylesheet'], link[as='style']"), v = y ? [] : h.querySelectorAll("img"), g = y ? [] : h.querySelectorAll("video"), m = s ? s.length : 0;
                                        t.numResourcesToLoad = b.length + v.length + g.length + m, t.resourcesLoaded = [], t.resourcesErrored = [];
                                        var _ = function(e, r) {
                                            t.resourcesLoaded.includes(e) ? t.logMessages([
                                                "Tried to mark a resource that has already been handled",
                                                e
                                            ], "debug") : (r ? (t.logMessages(n.__spreadArray([
                                                '"react-to-print" was unable to load a resource but will continue attempting to print the page'
                                            ], n.__read(r), !1)), t.resourcesErrored.push(e)) : t.resourcesLoaded.push(e), t.resourcesLoaded.length + t.resourcesErrored.length === t.numResourcesToLoad && t.triggerPrint(d));
                                        };
                                        d.onload = function() {
                                            var e, r, i, a;
                                            d.onload = null;
                                            var f = d.contentDocument || (null === (r = d.contentWindow) || void 0 === r ? void 0 : r.document);
                                            if (f) {
                                                f.body.appendChild(h), s && ((null === (i = d.contentDocument) || void 0 === i ? void 0 : i.fonts) && (null === (a = d.contentWindow) || void 0 === a ? void 0 : a.FontFace) ? s.forEach(function(e) {
                                                    var t = new FontFace(e.family, e.source, {
                                                        weight: e.weight,
                                                        style: e.style
                                                    });
                                                    d.contentDocument.fonts.add(t), t.loaded.then(function() {
                                                        _(t);
                                                    }).catch(function(e) {
                                                        _(t, [
                                                            "Failed loading the font:",
                                                            t,
                                                            "Load error:",
                                                            e
                                                        ]);
                                                    });
                                                }) : (s.forEach(function(e) {
                                                    return _(e);
                                                }), t.logMessages([
                                                    '"react-to-print" is not able to load custom fonts because the browser does not support the FontFace API but will continue attempting to print the page'
                                                ])));
                                                var b = "function" == typeof u ? u() : u;
                                                if ("string" != typeof b) t.logMessages([
                                                    '"react-to-print" expected a "string" from `pageStyle` but received "'.concat(typeof b, '". Styles from `pageStyle` will not be applied.')
                                                ]);
                                                else {
                                                    var m = f.createElement("style");
                                                    l && (m.setAttribute("nonce", l), f.head.setAttribute("nonce", l)), m.appendChild(f.createTextNode(b)), f.head.appendChild(m);
                                                }
                                                if (o && (e = f.body.classList).add.apply(e, n.__spreadArray([], n.__read(o.split(" ")), !1)), !y) {
                                                    for(var w = y ? [] : p.querySelectorAll("canvas"), P = f.querySelectorAll("canvas"), O = 0; O < w.length; ++O){
                                                        var x = w[O], S = P[O].getContext("2d");
                                                        S && S.drawImage(x, 0, 0);
                                                    }
                                                    var E = function(e) {
                                                        var t = v[e], r = t.getAttribute("src");
                                                        if (r) {
                                                            var n = new Image;
                                                            n.onload = function() {
                                                                return _(t);
                                                            }, n.onerror = function(e, r, n, o, i) {
                                                                return _(t, [
                                                                    "Error loading <img>",
                                                                    t,
                                                                    "Error",
                                                                    i
                                                                ]);
                                                            }, n.src = r;
                                                        } else _(t, [
                                                            'Found an <img> tag with an empty "src" attribute. This prevents pre-loading it. The <img> is:',
                                                            t
                                                        ]);
                                                    };
                                                    for(O = 0; O < v.length; O++)E(O);
                                                    var T = function(e) {
                                                        var t = g[e];
                                                        t.preload = "auto";
                                                        var r = t.getAttribute("poster");
                                                        if (r) {
                                                            var n = new Image;
                                                            n.onload = function() {
                                                                return _(t);
                                                            }, n.onerror = function(e, n, o, i, a) {
                                                                return _(t, [
                                                                    "Error loading video poster",
                                                                    r,
                                                                    "for video",
                                                                    t,
                                                                    "Error:",
                                                                    a
                                                                ]);
                                                            }, n.src = r;
                                                        } else t.readyState >= 2 ? _(t) : (t.onloadeddata = function() {
                                                            return _(t);
                                                        }, t.onerror = function(e, r, n, o, i) {
                                                            return _(t, [
                                                                "Error loading video",
                                                                t,
                                                                "Error",
                                                                i
                                                            ]);
                                                        }, t.onstalled = function() {
                                                            return _(t, [
                                                                "Loading video stalled, skipping",
                                                                t
                                                            ]);
                                                        });
                                                    };
                                                    for(O = 0; O < g.length; O++)T(O);
                                                    var j = "input", C = p.querySelectorAll(j), A = f.querySelectorAll(j);
                                                    for(O = 0; O < C.length; O++)A[O].value = C[O].value;
                                                    var k = "input[type=checkbox],input[type=radio]", R = p.querySelectorAll(k), M = f.querySelectorAll(k);
                                                    for(O = 0; O < R.length; O++)M[O].checked = R[O].checked;
                                                    var D = "select", I = p.querySelectorAll(D), q = f.querySelectorAll(D);
                                                    for(O = 0; O < I.length; O++)q[O].value = I[O].value;
                                                }
                                                if (c) for(var F = document.querySelectorAll("style, link[rel~='stylesheet'], link[as='style']"), W = function(e, r) {
                                                    var n = F[e];
                                                    if ("style" === n.tagName.toLowerCase()) {
                                                        var o = f.createElement(n.tagName), i = n.sheet;
                                                        if (i) {
                                                            var a = "";
                                                            try {
                                                                for(var c = i.cssRules.length, s = 0; s < c; ++s)"string" == typeof i.cssRules[s].cssText && (a += "".concat(i.cssRules[s].cssText, "\r\n"));
                                                            } catch (e) {
                                                                t.logMessages([
                                                                    "A stylesheet could not be accessed. This is likely due to the stylesheet having cross-origin imports, and many browsers block script access to cross-origin stylesheets. See https://github.com/gregnb/react-to-print/issues/429 for details. You may be able to load the sheet by both marking the stylesheet with the cross `crossorigin` attribute, and setting the `Access-Control-Allow-Origin` header on the server serving the stylesheet. Alternatively, host the stylesheet on your domain to avoid this issue entirely.",
                                                                    n
                                                                ], "warning");
                                                            }
                                                            o.setAttribute("id", "react-to-print-".concat(e)), l && o.setAttribute("nonce", l), o.appendChild(f.createTextNode(a)), f.head.appendChild(o);
                                                        }
                                                    } else if (n.getAttribute("href")) {
                                                        if (n.hasAttribute("disabled")) t.logMessages([
                                                            "`react-to-print` encountered a <link> tag with a `disabled` attribute and will ignore it. Note that the `disabled` attribute is deprecated, and some browsers ignore it. You should stop using it. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#attr-disabled. The <link> is:",
                                                            n
                                                        ], "warning"), _(n);
                                                        else {
                                                            for(var u = f.createElement(n.tagName), d = (s = 0, n.attributes.length); s < d; ++s){
                                                                var p = n.attributes[s];
                                                                p && u.setAttribute(p.nodeName, p.nodeValue || "");
                                                            }
                                                            u.onload = function() {
                                                                return _(u);
                                                            }, u.onerror = function(e, t, r, n, o) {
                                                                return _(u, [
                                                                    "Failed to load",
                                                                    u,
                                                                    "Error:",
                                                                    o
                                                                ]);
                                                            }, l && u.setAttribute("nonce", l), f.head.appendChild(u);
                                                        }
                                                    } else t.logMessages([
                                                        "`react-to-print` encountered a <link> tag with an empty `href` attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:",
                                                        n
                                                    ], "warning"), _(n);
                                                }, L = (O = 0, F.length); O < L; ++O)W(O);
                                            }
                                            0 !== t.numResourcesToLoad && c || t.triggerPrint(d);
                                        }, t.handleRemoveIframe(!0), document.body.appendChild(d);
                                    } else t.logMessages([
                                        '"react-to-print" could not locate the DOM node corresponding with the `content` prop'
                                    ]);
                                } else t.logMessages([
                                    'There is nothing to print because the "content" prop returned "null". Please ensure "content" is renderable before allowing "react-to-print" to be called.'
                                ]);
                            } else t.logMessages([
                                "To print a functional component ensure it is wrapped with `React.forwardRef`, and ensure the forwarded ref is used. See the README for an example: https://github.com/gregnb/react-to-print#examples"
                            ]);
                        }, t.handleRemoveIframe = function(e) {
                            var r = t.props.removeAfterPrint;
                            if (e || r) {
                                var n = document.getElementById("printWindow");
                                n && document.body.removeChild(n);
                            }
                        }, t.logMessages = function(e, r) {
                            void 0 === r && (r = "error"), t.props.suppressErrors || ("error" === r ? console.error(e) : "warning" === r ? console.warn(e) : "debug" === r && console.debug(e));
                        }, t;
                    }
                    return n.__extends(t, e), t.prototype.handleClick = function(e, t) {
                        var r = this, n = this.props, o = n.onBeforeGetContent, i = n.onPrintError;
                        if (o) {
                            var a = o();
                            a && "function" == typeof a.then ? a.then(function() {
                                return r.handlePrint(t);
                            }).catch(function(e) {
                                i && i("onBeforeGetContent", e);
                            }) : this.handlePrint(t);
                        } else this.handlePrint(t);
                    }, t.prototype.render = function() {
                        var e = this.props, t = e.children, r = e.trigger;
                        if (r) return o.cloneElement(r(), {
                            onClick: this.handleClick.bind(this)
                        });
                        if (!a.PrintContext) return this.logMessages([
                            '"react-to-print" requires React ^16.3.0 to be able to use "PrintContext"'
                        ]), null;
                        var n = {
                            handlePrint: this.handleClick.bind(this)
                        };
                        return o.createElement(a.PrintContext.Provider, {
                            value: n
                        }, t);
                    }, t.defaultProps = c.defaultProps, t;
                }(o.Component);
                t.ReactToPrint = s;
            },
            940: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.defaultProps = void 0, t.defaultProps = {
                    copyStyles: !0,
                    pageStyle: "\n        @page {\n            /* Remove browser default header (title) and footer (url) */\n            margin: 0;\n        }\n        @media print {\n            body {\n                /* Tell browsers to print background colors */\n                -webkit-print-color-adjust: exact; /* Chrome/Safari/Edge/Opera */\n                color-adjust: exact; /* Firefox */\n            }\n        }\n    ",
                    removeAfterPrint: !1,
                    suppressErrors: !1
                };
            },
            892: function(e, t, r) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.useReactToPrint = void 0;
                var n = r(316), o = r(496), i = r(428), a = r(940), c = r(860), s = Object.prototype.hasOwnProperty.call(o, "useMemo") && Object.prototype.hasOwnProperty.call(o, "useCallback");
                t.useReactToPrint = function(e) {
                    if (!s) return e.suppressErrors || console.error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"'), function() {
                        throw new Error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"');
                    };
                    var t = o.useMemo(function() {
                        return new i.ReactToPrint(n.__assign(n.__assign({}, a.defaultProps), e));
                    }, [
                        e
                    ]);
                    return o.useCallback(function(e, r) {
                        return (0, c.wrapCallbackWithArgs)(t, t.handleClick, r)(e);
                    }, [
                        t
                    ]);
                };
            },
            860: function(e, t, r) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.wrapCallbackWithArgs = void 0;
                var n = r(316);
                t.wrapCallbackWithArgs = function(e, t) {
                    for(var r = [], o = 2; o < arguments.length; o++)r[o - 2] = arguments[o];
                    return function() {
                        for(var o = [], i = 0; i < arguments.length; i++)o[i] = arguments[i];
                        return t.apply(e, n.__spreadArray(n.__spreadArray([], n.__read(o), !1), n.__read(r), !1));
                    };
                };
            },
            496: function(t) {
                t.exports = e;
            },
            190: function(e) {
                e.exports = t;
            },
            316: function(e, t, r) {
                r.r(t), r.d(t, {
                    __addDisposableResource: function() {
                        return D;
                    },
                    __assign: function() {
                        return i;
                    },
                    __asyncDelegator: function() {
                        return S;
                    },
                    __asyncGenerator: function() {
                        return x;
                    },
                    __asyncValues: function() {
                        return E;
                    },
                    __await: function() {
                        return O;
                    },
                    __awaiter: function() {
                        return h;
                    },
                    __classPrivateFieldGet: function() {
                        return k;
                    },
                    __classPrivateFieldIn: function() {
                        return M;
                    },
                    __classPrivateFieldSet: function() {
                        return R;
                    },
                    __createBinding: function() {
                        return b;
                    },
                    __decorate: function() {
                        return c;
                    },
                    __disposeResources: function() {
                        return q;
                    },
                    __esDecorate: function() {
                        return u;
                    },
                    __exportStar: function() {
                        return v;
                    },
                    __extends: function() {
                        return o;
                    },
                    __generator: function() {
                        return y;
                    },
                    __importDefault: function() {
                        return A;
                    },
                    __importStar: function() {
                        return C;
                    },
                    __makeTemplateObject: function() {
                        return T;
                    },
                    __metadata: function() {
                        return p;
                    },
                    __param: function() {
                        return s;
                    },
                    __propKey: function() {
                        return f;
                    },
                    __read: function() {
                        return m;
                    },
                    __rest: function() {
                        return a;
                    },
                    __runInitializers: function() {
                        return l;
                    },
                    __setFunctionName: function() {
                        return d;
                    },
                    __spread: function() {
                        return _;
                    },
                    __spreadArray: function() {
                        return P;
                    },
                    __spreadArrays: function() {
                        return w;
                    },
                    __values: function() {
                        return g;
                    }
                });
                var n = function(e, t) {
                    return n = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, t) {
                        e.__proto__ = t;
                    } || function(e, t) {
                        for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                    }, n(e, t);
                };
                function o(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function r() {
                        this.constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
                }
                var i = function() {
                    return i = Object.assign || function(e) {
                        for(var t, r = 1, n = arguments.length; r < n; r++)for(var o in t = arguments[r])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                        return e;
                    }, i.apply(this, arguments);
                };
                function a(e, t) {
                    var r = {};
                    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var o = 0;
                        for(n = Object.getOwnPropertySymbols(e); o < n.length; o++)t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
                    }
                    return r;
                }
                function c(e, t, r, n) {
                    var o, i = arguments.length, a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, r, n);
                    else for(var c = e.length - 1; c >= 0; c--)(o = e[c]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, r, a) : o(t, r)) || a);
                    return i > 3 && a && Object.defineProperty(t, r, a), a;
                }
                function s(e, t) {
                    return function(r, n) {
                        t(r, n, e);
                    };
                }
                function u(e, t, r, n, o, i) {
                    function a(e) {
                        if (void 0 !== e && "function" != typeof e) throw new TypeError("Function expected");
                        return e;
                    }
                    for(var c, s = n.kind, u = "getter" === s ? "get" : "setter" === s ? "set" : "value", l = !t && e ? n.static ? e : e.prototype : null, f = t || (l ? Object.getOwnPropertyDescriptor(l, n.name) : {}), d = !1, p = r.length - 1; p >= 0; p--){
                        var h = {};
                        for(var y in n)h[y] = "access" === y ? {} : n[y];
                        for(var y in n.access)h.access[y] = n.access[y];
                        h.addInitializer = function(e) {
                            if (d) throw new TypeError("Cannot add initializers after decoration has completed");
                            i.push(a(e || null));
                        };
                        var b = (0, r[p])("accessor" === s ? {
                            get: f.get,
                            set: f.set
                        } : f[u], h);
                        if ("accessor" === s) {
                            if (void 0 === b) continue;
                            if (null === b || "object" != typeof b) throw new TypeError("Object expected");
                            (c = a(b.get)) && (f.get = c), (c = a(b.set)) && (f.set = c), (c = a(b.init)) && o.unshift(c);
                        } else (c = a(b)) && ("field" === s ? o.unshift(c) : f[u] = c);
                    }
                    l && Object.defineProperty(l, n.name, f), d = !0;
                }
                function l(e, t, r) {
                    for(var n = arguments.length > 2, o = 0; o < t.length; o++)r = n ? t[o].call(e, r) : t[o].call(e);
                    return n ? r : void 0;
                }
                function f(e) {
                    return "symbol" == typeof e ? e : "".concat(e);
                }
                function d(e, t, r) {
                    return "symbol" == typeof t && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
                        configurable: !0,
                        value: r ? "".concat(r, " ", t) : t
                    });
                }
                function p(e, t) {
                    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
                }
                function h(e, t, r, n) {
                    return new (r || (r = Promise))(function(o, i) {
                        function a(e) {
                            try {
                                s(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function c(e) {
                            try {
                                s(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function s(e) {
                            var t;
                            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                                e(t);
                            })).then(a, c);
                        }
                        s((n = n.apply(e, t || [])).next());
                    });
                }
                function y(e, t) {
                    var r, n, o, i, a = {
                        label: 0,
                        sent: function() {
                            if (1 & o[0]) throw o[1];
                            return o[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return i = {
                        next: c(0),
                        throw: c(1),
                        return: c(2)
                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                        return this;
                    }), i;
                    function c(c) {
                        return function(s) {
                            return function(c) {
                                if (r) throw new TypeError("Generator is already executing.");
                                for(; i && (i = 0, c[0] && (a = 0)), a;)try {
                                    if (r = 1, n && (o = 2 & c[0] ? n.return : c[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, c[1])).done) return o;
                                    switch(n = 0, o && (c = [
                                        2 & c[0],
                                        o.value
                                    ]), c[0]){
                                        case 0:
                                        case 1:
                                            o = c;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: c[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, n = c[1], c = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            c = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((o = (o = a.trys).length > 0 && o[o.length - 1]) || 6 !== c[0] && 2 !== c[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === c[0] && (!o || c[1] > o[0] && c[1] < o[3])) {
                                                a.label = c[1];
                                                break;
                                            }
                                            if (6 === c[0] && a.label < o[1]) {
                                                a.label = o[1], o = c;
                                                break;
                                            }
                                            if (o && a.label < o[2]) {
                                                a.label = o[2], a.ops.push(c);
                                                break;
                                            }
                                            o[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    c = t.call(e, a);
                                } catch (e) {
                                    c = [
                                        6,
                                        e
                                    ], n = 0;
                                } finally{
                                    r = o = 0;
                                }
                                if (5 & c[0]) throw c[1];
                                return {
                                    value: c[0] ? c[1] : void 0,
                                    done: !0
                                };
                            }([
                                c,
                                s
                            ]);
                        };
                    }
                }
                var b = Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r);
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    }), Object.defineProperty(e, n, o);
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                };
                function v(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || b(t, e, r);
                }
                function g(e) {
                    var t = "function" == typeof Symbol && Symbol.iterator, r = t && e[t], n = 0;
                    if (r) return r.call(e);
                    if (e && "number" == typeof e.length) return {
                        next: function() {
                            return e && n >= e.length && (e = void 0), {
                                value: e && e[n++],
                                done: !e
                            };
                        }
                    };
                    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                }
                function m(e, t) {
                    var r = "function" == typeof Symbol && e[Symbol.iterator];
                    if (!r) return e;
                    var n, o, i = r.call(e), a = [];
                    try {
                        for(; (void 0 === t || t-- > 0) && !(n = i.next()).done;)a.push(n.value);
                    } catch (e) {
                        o = {
                            error: e
                        };
                    } finally{
                        try {
                            n && !n.done && (r = i.return) && r.call(i);
                        } finally{
                            if (o) throw o.error;
                        }
                    }
                    return a;
                }
                function _() {
                    for(var e = [], t = 0; t < arguments.length; t++)e = e.concat(m(arguments[t]));
                    return e;
                }
                function w() {
                    for(var e = 0, t = 0, r = arguments.length; t < r; t++)e += arguments[t].length;
                    var n = Array(e), o = 0;
                    for(t = 0; t < r; t++)for(var i = arguments[t], a = 0, c = i.length; a < c; a++, o++)n[o] = i[a];
                    return n;
                }
                function P(e, t, r) {
                    if (r || 2 === arguments.length) for(var n, o = 0, i = t.length; o < i; o++)!n && o in t || (n || (n = Array.prototype.slice.call(t, 0, o)), n[o] = t[o]);
                    return e.concat(n || Array.prototype.slice.call(t));
                }
                function O(e) {
                    return this instanceof O ? (this.v = e, this) : new O(e);
                }
                function x(e, t, r) {
                    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                    var n, o = r.apply(e, t || []), i = [];
                    return n = {}, a("next"), a("throw"), a("return"), n[Symbol.asyncIterator] = function() {
                        return this;
                    }, n;
                    function a(e) {
                        o[e] && (n[e] = function(t) {
                            return new Promise(function(r, n) {
                                i.push([
                                    e,
                                    t,
                                    r,
                                    n
                                ]) > 1 || c(e, t);
                            });
                        });
                    }
                    function c(e, t) {
                        try {
                            (r = o[e](t)).value instanceof O ? Promise.resolve(r.value.v).then(s, u) : l(i[0][2], r);
                        } catch (e) {
                            l(i[0][3], e);
                        }
                        var r;
                    }
                    function s(e) {
                        c("next", e);
                    }
                    function u(e) {
                        c("throw", e);
                    }
                    function l(e, t) {
                        e(t), i.shift(), i.length && c(i[0][0], i[0][1]);
                    }
                }
                function S(e) {
                    var t, r;
                    return t = {}, n("next"), n("throw", function(e) {
                        throw e;
                    }), n("return"), t[Symbol.iterator] = function() {
                        return this;
                    }, t;
                    function n(n, o) {
                        t[n] = e[n] ? function(t) {
                            return (r = !r) ? {
                                value: O(e[n](t)),
                                done: !1
                            } : o ? o(t) : t;
                        } : o;
                    }
                }
                function E(e) {
                    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                    var t, r = e[Symbol.asyncIterator];
                    return r ? r.call(e) : (e = g(e), t = {}, n("next"), n("throw"), n("return"), t[Symbol.asyncIterator] = function() {
                        return this;
                    }, t);
                    function n(r) {
                        t[r] = e[r] && function(t) {
                            return new Promise(function(n, o) {
                                !function(e, t, r, n) {
                                    Promise.resolve(n).then(function(t) {
                                        e({
                                            value: t,
                                            done: r
                                        });
                                    }, t);
                                }(n, o, (t = e[r](t)).done, t.value);
                            });
                        };
                    }
                }
                function T(e, t) {
                    return Object.defineProperty ? Object.defineProperty(e, "raw", {
                        value: t
                    }) : e.raw = t, e;
                }
                var j = Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                };
                function C(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && b(t, e, r);
                    return j(t, e), t;
                }
                function A(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function k(e, t, r, n) {
                    if ("a" === r && !n) throw new TypeError("Private accessor was defined without a getter");
                    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
                    return "m" === r ? n : "a" === r ? n.call(e) : n ? n.value : t.get(e);
                }
                function R(e, t, r, n, o) {
                    if ("m" === n) throw new TypeError("Private method is not writable");
                    if ("a" === n && !o) throw new TypeError("Private accessor was defined without a setter");
                    if ("function" == typeof t ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
                    return "a" === n ? o.call(e, r) : o ? o.value = r : t.set(e, r), r;
                }
                function M(e, t) {
                    if (null === t || "object" != typeof t && "function" != typeof t) throw new TypeError("Cannot use 'in' operator on non-object");
                    return "function" == typeof e ? t === e : e.has(t);
                }
                function D(e, t, r) {
                    if (null != t) {
                        if ("object" != typeof t && "function" != typeof t) throw new TypeError("Object expected.");
                        var n;
                        if (r) {
                            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
                            n = t[Symbol.asyncDispose];
                        }
                        if (void 0 === n) {
                            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
                            n = t[Symbol.dispose];
                        }
                        if ("function" != typeof n) throw new TypeError("Object not disposable.");
                        e.stack.push({
                            value: t,
                            dispose: n,
                            async: r
                        });
                    } else r && e.stack.push({
                        async: !0
                    });
                    return t;
                }
                var I = "function" == typeof SuppressedError ? SuppressedError : function(e, t, r) {
                    var n = new Error(r);
                    return n.name = "SuppressedError", n.error = e, n.suppressed = t, n;
                };
                function q(e) {
                    function t(t) {
                        e.error = e.hasError ? new I(t, e.error, "An error was suppressed during disposal.") : t, e.hasError = !0;
                    }
                    return function r() {
                        for(; e.stack.length;){
                            var n = e.stack.pop();
                            try {
                                var o = n.dispose && n.dispose.call(n.value);
                                if (n.async) return Promise.resolve(o).then(r, function(e) {
                                    return t(e), r();
                                });
                            } catch (e) {
                                t(e);
                            }
                        }
                        if (e.hasError) throw e.error;
                    }();
                }
                t.default = {
                    __extends: o,
                    __assign: i,
                    __rest: a,
                    __decorate: c,
                    __param: s,
                    __metadata: p,
                    __awaiter: h,
                    __generator: y,
                    __createBinding: b,
                    __exportStar: v,
                    __values: g,
                    __read: m,
                    __spread: _,
                    __spreadArrays: w,
                    __spreadArray: P,
                    __await: O,
                    __asyncGenerator: x,
                    __asyncDelegator: S,
                    __asyncValues: E,
                    __makeTemplateObject: T,
                    __importStar: C,
                    __importDefault: A,
                    __classPrivateFieldGet: k,
                    __classPrivateFieldSet: R,
                    __classPrivateFieldIn: M,
                    __addDisposableResource: D,
                    __disposeResources: q
                };
            }
        }, n = {};
        function o(e) {
            var t = n[e];
            if (void 0 !== t) return t.exports;
            var i = n[e] = {
                exports: {}
            };
            return r[e](i, i.exports, o), i.exports;
        }
        o.d = function(e, t) {
            for(var r in t)o.o(t, r) && !o.o(e, r) && Object.defineProperty(e, r, {
                enumerable: !0,
                get: t[r]
            });
        }, o.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, o.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var i = {};
        return function() {
            var e = i;
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.useReactToPrint = e.ReactToPrint = e.PrintContextConsumer = void 0;
            var t = o(328);
            Object.defineProperty(e, "PrintContextConsumer", {
                enumerable: !0,
                get: function() {
                    return t.PrintContextConsumer;
                }
            });
            var r = o(428);
            Object.defineProperty(e, "ReactToPrint", {
                enumerable: !0,
                get: function() {
                    return r.ReactToPrint;
                }
            });
            var n = o(892);
            Object.defineProperty(e, "useReactToPrint", {
                enumerable: !0,
                get: function() {
                    return n.useReactToPrint;
                }
            });
            var a = o(428);
            e.default = a.ReactToPrint;
        }(), i;
    }();
});

});


parcelRegister("89Qlc", function(module, exports) {

$parcel$export(module.exports, "CreateTemplateCard", () => $9530920fabefd196$export$dc3bdd752680efdb);

var $iKObn = parcelRequire("iKObn");

var $9AWgp = parcelRequire("9AWgp");
parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");
const $9530920fabefd196$export$dc3bdd752680efdb = ({ onCreateNewTemplateRequest: onCreateNewTemplateRequest })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($9530920fabefd196$var$ButtonCard, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($9530920fabefd196$var$CardTitle, {
                className: "p-size-m-bold",
                children: format("home.pendingPatientDialog.codeSent.bottomCard.title")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($9530920fabefd196$var$CardText, {
                className: "p-size-s",
                children: format("home.pendingPatientDialog.codeSent.bottomCard.text")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $9AWgp.Button), {
                label: format("home.pendingPatientDialog.codeSent.bottomCard.cta"),
                onClick: onCreateNewTemplateRequest
            })
        ]
    });
};
const $9530920fabefd196$var$ButtonCard = (0, $5UMQ1.default).div`
	background-color: ${(0, $kKnoQ.colors).primaryBackground};
	border-radius: 8px;
	padding: 24px;
	align-items: center;
	${(0, $5WGN2.stack)(undefined, "center", "center")}
`;
const $9530920fabefd196$var$CardTitle = (0, $5UMQ1.default).p`
	text-align: center;
	margin-bottom: 4px;
`;
const $9530920fabefd196$var$CardText = (0, $5UMQ1.default).p`
	text-align: center;
	margin-bottom: 16px;
`;

});


parcelRegister("8AUvF", function(module, exports) {

$parcel$export(module.exports, "InviteOrCreatePatient", () => $9e985a4f10b464fd$export$74e2b0354eff8e3f);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $a6fIt = parcelRequire("a6fIt");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");
parcelRequire("81g6h");

var $j2wRB = parcelRequire("j2wRB");
var $9e985a4f10b464fd$var$AddIcon = function AddIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M11 13H6a.967.967 0 0 1-.713-.287A.968.968 0 0 1 5 12c0-.283.096-.52.287-.713A.967.967 0 0 1 6 11h5V6c0-.283.096-.52.287-.713A.968.968 0 0 1 12 5c.283 0 .52.096.713.287.191.192.287.43.287.713v5h5c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 18 13h-5v5c0 .283-.096.52-.287.712A.968.968 0 0 1 12 19a.968.968 0 0 1-.713-.288A.968.968 0 0 1 11 18v-5Z",
            fill: "currentColor"
        })
    });
};
$9e985a4f10b464fd$var$AddIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $9e985a4f10b464fd$var$HctIcon = function HctIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M4.5 7c-.66 0-1.3.26-1.77.73S2 8.83 2 9.5c0 .33.07.65.19.96A2.488 2.488 0 0 0 4.5 12c.33 0 .65-.06.96-.19.3-.13.58-.31.81-.54.23-.23.42-.51.54-.81.12-.3.19-.63.19-.96 0-.33-.07-.65-.19-.96-.13-.3-.31-.58-.54-.81-.23-.23-.51-.42-.81-.54-.3-.13-.63-.19-.96-.19Zm15 0c-.66 0-1.3.26-1.77.73S17 8.83 17 9.5c0 .33.07.65.19.96A2.488 2.488 0 0 0 19.5 12c.33 0 .65-.06.96-.19.3-.13.58-.31.81-.54.23-.23.42-.51.54-.81a2.505 2.505 0 0 0-.54-2.73C20.8 7.26 20.17 7 19.5 7ZM3.9 14.05C2.32 14.29 0 15.39 0 16.7v2.29c0 .55.45 1 1 1h2v-3.5c0-.96.34-1.77.9-2.45v.01Zm16.2 0c.55.68.9 1.49.9 2.45V20h2c.55 0 1-.45 1-1v-2.29c0-1.32-2.32-2.41-3.9-2.65v-.01ZM12 6a1.499 1.499 0 0 1 1.06 2.56 1.499 1.499 0 1 1-2.12-2.12C11.22 6.16 11.6 6 12 6Zm0-2c-.93 0-1.82.37-2.48 1.03A3.49 3.49 0 0 0 8.5 7.5c0 .92.37 1.82 1.02 2.48.66.66 1.55 1.02 2.48 1.02a3.496 3.496 0 0 0 3.5-3.5c0-.93-.37-1.82-1.03-2.47A3.499 3.499 0 0 0 12 4ZM12 15c2.13 0 4.62.96 5 1.57V18H7v-1.43c.38-.61 2.87-1.57 5-1.57Zm0-2c-2.34 0-7 1.17-7 3.5V19c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-2.5c0-2.33-4.66-3.5-7-3.5Z",
            fill: "currentColor"
        })
    });
};
$9e985a4f10b464fd$var$HctIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $9e985a4f10b464fd$export$74e2b0354eff8e3f = ({ createPatient: createPatient, joinHct: joinHct, disabled: disabled, className: className })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($9e985a4f10b464fd$var$Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($9e985a4f10b464fd$var$StyledIconCardButton, {
                onClick: createPatient,
                icon: $9e985a4f10b464fd$var$AddIcon,
                label: format("home.addPatientDialog.inviteOrCreate.createPatient"),
                disabled: disabled,
                "data-test": (0, $a6fIt.e2eTestId).createPatientDialog.createPatientCTA
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($9e985a4f10b464fd$var$StyledIconCardButton, {
                onClick: joinHct,
                icon: $9e985a4f10b464fd$var$HctIcon,
                label: format("home.addPatientDialog.inviteOrCreate.joinHct"),
                disabled: disabled
            })
        ]
    });
};
const $9e985a4f10b464fd$var$StyledIconCardButton = (0, $5UMQ1.default)((0, $j2wRB.IconCardButton))`
	flex: 1;
	align-self: stretch;
	padding: 24px 16px;
`;
const $9e985a4f10b464fd$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("SM")}
`;

});
parcelRegister("j2wRB", function(module, exports) {

$parcel$export(module.exports, "IconCardButton", () => $02f737e30c4641d9$export$fe9cd93de3f300f0);

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
const $02f737e30c4641d9$export$fe9cd93de3f300f0 = ({ icon: Icon, onClick: onClick, label: label, disabled: disabled, className: className })=>/*#__PURE__*/ (0, $iKObn.jsxs)($02f737e30c4641d9$var$Container, {
        onClick: onClick,
        disabled: disabled,
        className: className,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($02f737e30c4641d9$var$Circle, {
                disabled: disabled,
                children: /*#__PURE__*/ (0, $iKObn.jsx)(Icon, {
                    width: 24,
                    height: 24,
                    color: disabled ? (0, $kKnoQ.colors).grey50 : (0, $kKnoQ.colors).primary
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($02f737e30c4641d9$var$LabelContainer, {
                disabled: disabled,
                className: "p-size-s-bold icon-card-button-label",
                children: label
            })
        ]
    });
const $02f737e30c4641d9$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(16, "flexstart", "center")};
	width: 100%;
	border-radius: 8px;

	${({ disabled: disabled })=>disabled ? `
				border: 1px solid ${(0, $kKnoQ.colors).grey5};
				background-color: ${(0, $kKnoQ.colors).grey5};
				pointer-events: none;` : `
				border: 1px solid ${(0, $kKnoQ.colors).primaryBackground};
				background-color: ${(0, $kKnoQ.colors).primaryBackground};

				cursor: pointer;            
				&:hover,
				&:active {
					border: 1px solid ${(0, $kKnoQ.colors).primary75};
				}

				&:active {
					background-color: ${(0, $kKnoQ.colors).primary10};
				}

				&:hover > .icon-card-button-label,
				&:active > .icon-card-button-label {
					color: ${(0, $kKnoQ.colors).black};
				}`}
`;
const $02f737e30c4641d9$var$Circle = (0, $5UMQ1.default).div`
	display: grid;
	place-items: center;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	background-color: ${({ disabled: disabled })=>disabled ? (0, $kKnoQ.colors).grey10 : (0, $kKnoQ.colors).primary10};
`;
const $02f737e30c4641d9$var$LabelContainer = (0, $5UMQ1.default).div`
	text-align: center;
	color: ${({ disabled: disabled })=>disabled ? (0, $kKnoQ.colors).grey50 : (0, $kKnoQ.colors).grey};
`;

});


parcelRegister("hbH4N", function(module, exports) {

$parcel$export(module.exports, "RegistrationDetailsStep", () => $1bbb2f23cb5a4541$export$4730599a2f97382c);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $aEP4N = parcelRequire("aEP4N");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");
parcelRequire("81g6h");

var $89Qlc = parcelRequire("89Qlc");

var $970DV = parcelRequire("970DV");
const $1bbb2f23cb5a4541$export$4730599a2f97382c = ({ pendingPatient: pendingPatient, onResend: onResend, onCreateNewTemplateRequest: onCreateNewTemplateRequest })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { formatPatientName: formatPatientName } = (0, $aEP4N.useFormatPatients)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($1bbb2f23cb5a4541$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                className: "p-size-m",
                children: format("home.pendingPatientDialog.registrationDetails.text", {
                    patientFullName: formatPatientName(pendingPatient)
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $970DV.ResendCodeButton), {
                onClick: onResend
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $89Qlc.CreateTemplateCard), {
                onCreateNewTemplateRequest: onCreateNewTemplateRequest
            })
        ]
    });
};
const $1bbb2f23cb5a4541$var$Container = (0, $5UMQ1.default).div`
	margin-top: 8px;
	${(0, $5WGN2.stack)("XS")}
`;

});

parcelRegister("8Yj45", function(module, exports) {

$parcel$export(module.exports, "RestrictedDialog", () => $2a01373585bb7cdb$export$3f5be051acaeb61a);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $02mFA = parcelRequire("02mFA");

var $5UMQ1 = parcelRequire("5UMQ1");

var $gk3fY = parcelRequire("gk3fY");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");

var $hE6rp = parcelRequire("hE6rp");

var $lDZlX = parcelRequire("lDZlX");

var $auPqo = parcelRequire("auPqo");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $dhb7H = parcelRequire("dhb7H");

var $c22GE = parcelRequire("c22GE");
var $2a01373585bb7cdb$var$ValidateAccountIcon = function ValidateAccountIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_6328_44413)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M53.729 5.115 4.836 54.007c-5.785 5.786-5.785 15.167 0 20.952l48.893 48.893c5.786 5.786 15.166 5.786 20.952 0l48.892-48.893c5.786-5.785 5.786-15.166 0-20.952L74.681 5.115c-5.786-5.786-15.166-5.786-20.952 0Z",
                        fill: "#F5EEFD"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask0_6328_44413",
                        style: {
                            maskType: "alpha"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "128",
                        height: "129",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M53.729 5.115 4.836 54.007c-5.785 5.786-5.785 15.167 0 20.952l48.893 48.893c5.786 5.786 15.166 5.786 20.952 0l48.892-48.893c5.786-5.785 5.786-15.166 0-20.952L74.681 5.115c-5.786-5.786-15.166-5.786-20.952 0Z",
                            fill: "#F5EEFD"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask0_6328_44413)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "m22.35 131.623 9.711-34.31c2.9-10.25 11.8-17.789 22.281-18.27.38-.017.753-.025 1.133-.025l39.212.558c8.063.111 14.851 6.173 15.992 14.278l8.224 38.163-24.216 22.591-72.346-22.994.008.009Z",
                                fill: "#309"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "m93.427 131.458-4.244-43.272-12.518 1.657 13.752 41.271",
                                fill: "#1C0060"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                                id: "mask1_6328_44413",
                                style: {
                                    maskType: "luminance"
                                },
                                maskUnits: "userSpaceOnUse",
                                x: "57",
                                y: "33",
                                width: "42",
                                height: "63",
                                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                    d: "M57.724 79.077c3.186-.043 5.747-2.679 5.747-5.916V34.268l20.836-.49c7.404-.171 12.983 6.86 11.174 14.158-.034.146 1.69 2.73 3.136 4.86.854 1.253.05 2.98-1.445 3.117l-.626.06 1.817 10.062c.626 3.486-2.011 6.697-5.502 6.697h-3.584v16.133c0 4.954-5.477 7.864-9.484 5.048L57.706 79.085l.017-.008Z",
                                    fill: "#fff"
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                                mask: "url(#mask1_6328_44413)",
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M101.731 97.659c15.7-12.079 18.795-34.79 6.912-50.726-11.883-15.936-34.244-19.064-49.944-6.985-15.7 12.079-18.795 34.79-6.912 50.726 11.883 15.936 34.243 19.063 49.944 6.985Z",
                                        fill: "#50F"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M61.29 88.058c12.662 11.075 31.74 10.535 43.599-1.477 5.418-5.486 8.317-12.518 8.706-19.687.448-8.174-2.587-16.416-8.605-22.778-2.392-2.524-5.055-4.654-7.912-6.276-11.461-6.465-26.279-5.092-36.43 4.447-4.015 3.795-7.32 8.517-8.74 13.686-1.437 5.211-.676 10.44.482 15.6.887 3.967 1.977 7.89 4.268 11.368 1.268 1.914 2.89 3.58 4.65 5.117h-.018Z",
                                        fill: "#4427F9"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M61.443 87.492c14.555 11.161 35.28 10.423 48.72-2.181 5.934-5.572 9.307-12.784 10.059-20.314.854-8.586-2.223-17.309-8.14-24.383-2.553-3.057-5.401-5.796-8.52-7.96-12.468-8.568-29.71-8.542-42.195 1.4-4.911 3.915-9.83 9.178-11.656 15.24-1.902 6.336.22 12.355 1.58 18.52 1.057 4.79 1.606 9.65 4.32 13.848 1.504 2.327 3.643 4.147 5.832 5.83Z",
                                        fill: "#334EF4"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M73.994 77.223c12.214 7.762 28.485 6.886 39.693-2.412 4.674-3.881 7.607-8.981 8.588-14.545 1.116-6.336-.972-12.956-4.886-18.588-1.944-2.799-4.108-5.443-6.559-7.615-9.72-8.612-24.58-10.312-36.126-3.1-4.497 2.808-9.974 7.083-11.724 12.355-1.91 5.77 1.327 10.887 2.527 16.373.939 4.327.6 8.852 2.984 12.647 1.336 2.12 3.432 3.563 5.503 4.877v.008Z",
                                        fill: "#2275EF"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M80.29 63.984c9.73 4.55 21.623 3.288 30.667-2.645 3.389-2.223 5.9-5.185 7.108-8.774 1.378-4.096.406-8.715-1.622-12.801-1.285-2.593-2.815-5.075-4.599-7.264-6.998-8.611-19.432-12.063-30.057-7.59-4.066 1.717-10.126 4.971-11.8 9.462-1.927 5.203 2.434 9.41 3.466 14.235.828 3.864-.415 8.053 1.648 11.445 1.158 1.914 3.212 3.005 5.181 3.923l.009.009Z",
                                        fill: "#119BEA"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M84.646 46.022c.532 2.558-1.074 5.477.236 7.735.744 1.288 2.232 1.915 3.669 2.25 5.418 1.27 11.03-.464 16.339-2.172 1.546-.498 3.169-1.048 4.26-2.267 1.234-1.39 1.538-3.443 1.234-5.289-.313-1.846-1.158-3.554-1.995-5.22-3.246-6.49-10.785-10.397-18.105-9.118-2.748.48-7.768 2.164-8.96 4.963-1.48 3.485 2.68 5.992 3.33 9.126l-.008-.008Z",
                                        fill: "#00C2E5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M94.44 35.573v-.198c-.168-5.014-4.716-8.68-9.56-7.675l-15.197 3.133c-9.5-.249-16.069 9.556-12.358 18.443l5.95 14.235.204.48v-13.96c0-1.974 1.53-3.597 3.465-3.683 1.978-.086 3.669 1.45 3.787 3.468.06.988.88 1.743 1.851 1.7l.651-.025a2.419 2.419 0 0 0 2.02-1.254l2.232-3.984a6.393 6.393 0 0 0 .152-5.94c-.905-1.83.406-3.985 2.426-3.985h5.942l4.395 2.01c1.944.884 4.117-.61 4.04-2.765Z",
                                fill: "#309"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "m56.362 79.068-.896 8.56c-.465 4.44 2.156 8.612 6.306 10.063l13.144 4.585-3.204 9.564c-1.107 3.314-.034 6.98 2.68 9.135l14.2 11.274M90.67 79.772l7.16 7.194a5.462 5.462 0 0 1 .964 5.564l-3.271 8.431 4.682 4.387a7.584 7.584 0 0 1 2.232 7.041l-3.914 19.318",
                                stroke: "#334EF4",
                                strokeMiterlimit: "10"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "m44.917 131.054 2.908-9.23",
                                stroke: "#1C0060",
                                strokeWidth: "3",
                                strokeMiterlimit: "10",
                                strokeLinecap: "round"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M20.494 50.499c.033-1.1.958-1.929 2.058-1.948 2.12-.036 5.416-.219 7.05-.962 1.618-.736 3.806-2.084 5.17-2.958a2.23 2.23 0 0 1 2.488.073c1.557 1.107 4.315 2.898 6.506 3.42 1.815.432 4.018.513 5.606.5 1.164-.008 2.164.878 2.168 2.041.014 3.91-.336 12.352-3.337 17.696-4.01 7.141-10.672 9.64-12.161 9.64-1.49 0-7.77-2.432-12.161-9.64-3.33-5.468-3.5-14.04-3.387-17.862Z",
                                fill: "#FFAF00"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M33.258 66.928c-.376 0-.766-.15-1.055-.44l-3.453-3.454a1.516 1.516 0 0 1 0-2.122 1.516 1.516 0 0 1 2.122 0l2.4 2.399 7.974-7.975a1.516 1.516 0 0 1 2.123 0c.578.59.578 1.532 0 2.122l-9.043 9.043c-.289.289-.678.44-1.055.44l-.013-.013Z",
                                fill: "#fff"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_6328_44413",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(.497 .775)",
                        d: "M0 0h128v128H0z"
                    })
                })
            })
        ]
    });
};
$2a01373585bb7cdb$var$ValidateAccountIcon.defaultProps = {
    width: "129",
    height: "129",
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $2a01373585bb7cdb$var$PendingAccountIcon = function PendingAccountIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_6328_44422)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M53.232 5.115 4.339 54.007c-5.785 5.786-5.785 15.167 0 20.952l48.893 48.893c5.785 5.786 15.166 5.786 20.952 0l48.892-48.893c5.786-5.785 5.786-15.166 0-20.952L74.184 5.115c-5.786-5.786-15.166-5.786-20.952 0Z",
                        fill: "#F5EEFD"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask0_6328_44422",
                        style: {
                            maskType: "alpha"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "128",
                        height: "129",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M53.232 5.115 4.339 54.007c-5.785 5.786-5.785 15.167 0 20.952l48.893 48.893c5.785 5.786 15.166 5.786 20.952 0l48.892-48.893c5.786-5.785 5.786-15.166 0-20.952L74.184 5.115c-5.786-5.786-15.166-5.786-20.952 0Z",
                            fill: "#F5EEFD"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask0_6328_44422)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "m21.852 131.623 9.712-34.31c2.9-10.25 11.8-17.789 22.281-18.27.38-.017.752-.025 1.133-.025l39.211.558c8.064.111 14.852 6.173 15.993 14.278l8.224 38.163-24.217 22.591-72.345-22.994.008.009Z",
                                fill: "#309"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "m92.93 131.458-4.244-43.272-12.518 1.657 13.752 41.271",
                                fill: "#1C0060"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                                id: "mask1_6328_44422",
                                style: {
                                    maskType: "luminance"
                                },
                                maskUnits: "userSpaceOnUse",
                                x: "57",
                                y: "33",
                                width: "42",
                                height: "63",
                                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                    d: "M57.226 79.077c3.187-.043 5.748-2.679 5.748-5.916V34.268l20.836-.49c7.404-.171 12.983 6.86 11.174 14.158-.034.146 1.69 2.73 3.136 4.86.854 1.253.05 2.98-1.445 3.117l-.626.06 1.817 10.062c.626 3.486-2.011 6.697-5.502 6.697H88.78v16.133c0 4.954-5.477 7.864-9.484 5.048L57.21 79.085l.017-.008Z",
                                    fill: "#fff"
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                                mask: "url(#mask1_6328_44422)",
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M101.234 97.659c15.7-12.079 18.795-34.79 6.912-50.726-11.883-15.936-34.244-19.064-49.944-6.985-15.7 12.079-18.795 34.79-6.912 50.726 11.883 15.936 34.243 19.063 49.944 6.985Z",
                                        fill: "#50F"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M60.793 88.058c12.662 11.075 31.74 10.535 43.599-1.477 5.418-5.486 8.317-12.518 8.706-19.687.448-8.174-2.587-16.416-8.605-22.778-2.392-2.524-5.055-4.654-7.912-6.276-11.461-6.465-26.279-5.092-36.43 4.447-4.015 3.795-7.32 8.517-8.74 13.686-1.437 5.211-.677 10.44.481 15.6.888 3.967 1.978 7.89 4.27 11.368 1.267 1.914 2.89 3.58 4.648 5.117h-.017Z",
                                        fill: "#4427F9"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M60.946 87.492c14.555 11.161 35.28 10.423 48.72-2.181 5.934-5.572 9.307-12.784 10.059-20.314.854-8.586-2.223-17.309-8.14-24.383-2.553-3.057-5.401-5.796-8.52-7.96-12.468-8.568-29.711-8.542-42.195 1.4-4.911 3.915-9.83 9.178-11.657 15.24-1.901 6.336.22 12.355 1.581 18.52 1.057 4.79 1.606 9.65 4.32 13.848 1.504 2.327 3.642 4.147 5.832 5.83Z",
                                        fill: "#334EF4"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M73.497 77.223c12.214 7.762 28.485 6.886 39.693-2.412 4.674-3.881 7.607-8.981 8.588-14.545 1.116-6.336-.972-12.956-4.886-18.588-1.944-2.799-4.108-5.443-6.559-7.615-9.72-8.612-24.58-10.312-36.126-3.1-4.497 2.808-9.974 7.083-11.724 12.355-1.91 5.77 1.327 10.887 2.527 16.373.938 4.327.6 8.852 2.984 12.647 1.335 2.12 3.432 3.563 5.503 4.877v.008Z",
                                        fill: "#2275EF"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M79.794 63.984c9.729 4.55 21.621 3.288 30.666-2.645 3.389-2.223 5.9-5.185 7.108-8.774 1.378-4.096.406-8.715-1.623-12.801-1.284-2.593-2.814-5.075-4.598-7.264-6.999-8.611-19.432-12.063-30.057-7.59-4.066 1.717-10.126 4.971-11.8 9.462-1.927 5.203 2.434 9.41 3.466 14.235.828 3.864-.415 8.053 1.648 11.445 1.158 1.914 3.212 3.005 5.181 3.923l.009.009Z",
                                        fill: "#119BEA"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M84.149 46.022c.532 2.558-1.074 5.477.236 7.735.744 1.288 2.232 1.915 3.669 2.25 5.418 1.27 11.03-.464 16.339-2.172 1.546-.498 3.169-1.048 4.26-2.267 1.234-1.39 1.538-3.443 1.234-5.289-.313-1.846-1.158-3.554-1.995-5.22-3.246-6.49-10.786-10.397-18.105-9.118-2.748.48-7.769 2.164-8.96 4.963-1.48 3.485 2.68 5.992 3.33 9.126l-.008-.008Z",
                                        fill: "#00C2E5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M93.944 35.573v-.198c-.17-5.014-4.717-8.68-9.56-7.675l-15.198 3.133c-9.5-.249-16.069 9.556-12.358 18.443l5.95 14.235.204.48v-13.96c0-1.974 1.53-3.597 3.465-3.683 1.978-.086 3.669 1.45 3.787 3.468.06.988.879 1.743 1.851 1.7l.65-.025a2.419 2.419 0 0 0 2.021-1.254l2.232-3.984a6.394 6.394 0 0 0 .152-5.94c-.905-1.83.405-3.985 2.426-3.985h5.942l4.395 2.01c1.944.884 4.116-.61 4.04-2.765Z",
                                fill: "#309"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "m55.865 79.068-.896 8.56c-.465 4.44 2.156 8.612 6.306 10.063l13.144 4.585-3.204 9.564c-1.107 3.314-.034 6.98 2.68 9.135l14.2 11.274M90.174 79.772l7.16 7.194a5.462 5.462 0 0 1 .963 5.564l-3.271 8.431 4.682 4.387a7.585 7.585 0 0 1 2.232 7.041l-3.914 19.318",
                                stroke: "#334EF4",
                                strokeMiterlimit: "10"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "m44.42 131.054 2.908-9.23",
                                stroke: "#1C0060",
                                strokeWidth: "3",
                                strokeMiterlimit: "10",
                                strokeLinecap: "round"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M31.312 43.057a1.75 1.75 0 0 0-.41.041 17.472 17.472 0 0 0-5.49 2.288c-.946.599-1.07 1.937-.279 2.728l.004.003c.567.567 1.456.702 2.133.272a14.004 14.004 0 0 1 4.465-1.854c.78-.175 1.307-.905 1.307-1.703 0-.983-.797-1.763-1.73-1.775Zm6.987 0a1.777 1.777 0 0 0-1.734 1.775v.003c0 .807.544 1.525 1.331 1.703 6.286 1.413 10.998 7.031 10.998 13.737 0 6.705-4.712 12.323-10.998 13.736-.787.178-1.331.896-1.331 1.703v.003c0 1.124 1.044 1.984 2.14 1.734 7.84-1.779 13.712-8.805 13.712-17.176 0-8.372-5.873-15.396-13.712-17.177a1.72 1.72 0 0 0-.406-.041Zm-17.094 7.035c-.509.05-.99.318-1.29.791a17.513 17.513 0 0 0-2.288 5.49c-.248 1.096.61 2.14 1.734 2.14.798 0 1.528-.529 1.703-1.307a13.95 13.95 0 0 1 1.854-4.465c.43-.677.295-1.566-.272-2.133l-.003-.004a1.783 1.783 0 0 0-1.438-.512Zm20.61 4.881a1.761 1.761 0 0 0-1.212.534l-7.56 7.56-2.278-2.276a1.761 1.761 0 1 0-2.49 2.49l3.522 3.523a1.762 1.762 0 0 0 2.49 0l8.807-8.807a1.761 1.761 0 0 0-1.28-3.024ZM19.36 62.036c-1.124 0-1.984 1.044-1.734 2.14a17.475 17.475 0 0 0 2.288 5.49c.597.946 1.937 1.07 2.728.279.569-.57.705-1.46.275-2.137a14.005 14.005 0 0 1-1.854-4.465c-.175-.78-.905-1.307-1.703-1.307Zm6.804 9.887c-.378.05-.745.225-1.028.509l-.004.003c-.79.791-.667 2.13.279 2.728a17.512 17.512 0 0 0 5.49 2.288c1.096.248 2.14-.61 2.14-1.734 0-.798-.529-1.528-1.307-1.703a13.967 13.967 0 0 1-4.462-1.854 1.646 1.646 0 0 0-1.108-.237Z",
                fill: "#14B511"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_6328_44422",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(0 .775)",
                        d: "M0 0h128v128H0z"
                    })
                })
            })
        ]
    });
};
$2a01373585bb7cdb$var$PendingAccountIcon.defaultProps = {
    width: "128",
    height: "129",
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $2a01373585bb7cdb$export$3f5be051acaeb61a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ context: context, onHide: onHide, children: children, ...otherProps }, ref)=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $hE6rp.useNavigate)();
    const ptStatus = (0, $1IWnK.useObservable)((0, $ghfIB.userStatusManager).ptRegistrationStatus);
    const header = otherProps.header?.toString() ?? "";
    const handleRegistrationClick = (0, $81g6h.useCallback)(()=>{
        (0, $ghfIB.analyticsService).trackEvent({
            category: (0, $auPqo.AnalyticsCategory).REGISTRATION,
            action: "startVerificationFlowCTA",
            params: [
                header
            ]
        });
        navigate((0, $lDZlX.RoutesPath).ProfessionalInformation);
    }, [
        header,
        navigate
    ]);
    const restrictedBaseDialogProps = (0, $81g6h.useMemo)(()=>({
            ...otherProps,
            ref: ref,
            onHide: onHide,
            width: (0, $gk3fY.DIALOG_SIZE).S,
            header: /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {}),
            footer: /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {})
        }), [
        onHide,
        otherProps,
        ref
    ]);
    return (0, $81g6h.useMemo)(()=>{
        switch(ptStatus){
            case (0, $02mFA.RegistrationStatus).INCOMPLETE:
                return /*#__PURE__*/ (0, $iKObn.jsx)($2a01373585bb7cdb$var$RestrictedBaseDialog, {
                    ...restrictedBaseDialogProps,
                    children: /*#__PURE__*/ (0, $iKObn.jsxs)($2a01373585bb7cdb$var$Container, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($2a01373585bb7cdb$var$ValidateAccountIcon, {
                                width: 128,
                                height: 128
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                className: "p-size-m-bold",
                                children: context === "AddPatient" ? format("restrictedDialog.incompleteStatus.addPatient.title") : format("restrictedDialog.incompleteStatus.assignTemplate.title")
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                className: "p-size-s",
                                children: format("restrictedDialog.incompleteStatus.description")
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                                onClick: handleRegistrationClick,
                                children: format("restrictedDialog.incompleteStatus.validateAccountButton")
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $c22GE.TertiaryButton), {
                                onClick: onHide,
                                label: format("restrictedDialog.incompleteStatus.closeDialogButton")
                            })
                        ]
                    })
                });
            case (0, $02mFA.RegistrationStatus).PENDING:
                return /*#__PURE__*/ (0, $iKObn.jsx)($2a01373585bb7cdb$var$RestrictedBaseDialog, {
                    ...restrictedBaseDialogProps,
                    children: /*#__PURE__*/ (0, $iKObn.jsxs)($2a01373585bb7cdb$var$Container, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($2a01373585bb7cdb$var$PendingAccountIcon, {
                                width: 128,
                                height: 128
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                className: "p-size-m-bold",
                                children: format("restrictedDialog.pendingStatus.title")
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                className: "p-size-s",
                                children: format("restrictedDialog.pendingStatus.description")
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                                uiStyle: "secondary_B",
                                onClick: onHide,
                                children: format("restrictedDialog.pendingStatus.closeDialogButton")
                            })
                        ]
                    })
                });
            default:
                return /*#__PURE__*/ (0, $iKObn.jsx)((0, $gk3fY.BaseDialog), {
                    ...otherProps,
                    ref: ref,
                    onHide: onHide,
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        id: "dialogContent",
                        children: children
                    })
                });
        }
    }, [
        children,
        context,
        format,
        handleRegistrationClick,
        onHide,
        otherProps,
        ptStatus,
        ref,
        restrictedBaseDialogProps
    ]);
});
$2a01373585bb7cdb$export$3f5be051acaeb61a.displayName = "RestrictedDialog";
const $2a01373585bb7cdb$var$RestrictedBaseDialog = (0, $5UMQ1.default)((0, $gk3fY.BaseDialog))`
	& .p-dialog-header {
		padding-bottom: 0;
	}

	& .p-dialog-header:after {
		display: none;
	}

	& .p-dialog-content {
		padding-top: 0;
	}
`;
const $2a01373585bb7cdb$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(24, "flexstart", "center")}
	text-align: center;
`;

});



parcelRegister("2tsa2", function(module, exports) {

$parcel$export(module.exports, "EmptyPatientMessageVariant", () => $1de285cdb4f6b295$export$58917d9e8f3320d);
$parcel$export(module.exports, "EmptyPatientMessage", () => $1de285cdb4f6b295$export$b898471ea3372a77);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $djk4t = parcelRequire("djk4t");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");

var $8AUvF = parcelRequire("8AUvF");

var $243Cr = parcelRequire("243Cr");

var $eiBvZ = parcelRequire("eiBvZ");
var $1de285cdb4f6b295$var$PatientAddIcon = function PatientAddIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M53.47 4.362 4.362 53.47c-5.816 5.816-5.816 15.244 0 21.06l49.108 49.108c5.816 5.816 15.244 5.816 21.06 0l49.108-49.108c5.816-5.816 5.816-15.244 0-21.06L74.53 4.362c-5.816-5.816-15.244-5.816-21.06 0Z",
                fill: "#F5EEFD"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_301_16603",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "128",
                height: "129",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M53.476 4.36 4.359 53.475c-5.812 5.812-5.812 15.236 0 21.048l49.117 49.117c5.812 5.812 15.236 5.812 21.048 0l49.117-49.117c5.812-5.812 5.812-15.236 0-21.048L74.524 4.359c-5.812-5.812-15.236-5.812-21.048 0Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_301_16603)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M36.402 85.25a21.961 21.961 0 0 1 19.162-11.244l34.252.483c7.046.1 12.972 5.31 13.968 12.279l.716 6.732L75 123 36.402 85.25Z",
                        fill: "#33009A"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask1_301_16603",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "57",
                        y: "35",
                        width: "37",
                        height: "53",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M57.526 74.06a5.09 5.09 0 0 0 5.022-5.092V35.525l18.205-.42c6.47-.148 11.337 5.902 9.756 12.178-.031.124 1.48 2.351 2.74 4.181.748 1.082.047 2.562-1.26 2.679l-.546.046 1.589 8.65c.552 2.999-1.76 5.763-4.804 5.763h-3.13v13.875c0 4.259-4.781 6.766-8.285 4.337L57.526 74.06Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask1_301_16603)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M95.973 90.033c13.716-10.388 16.42-29.92 6.039-43.624-10.38-13.706-29.913-16.395-43.629-6.007-13.715 10.388-16.419 29.92-6.039 43.625 10.38 13.705 29.914 16.394 43.63 6.006Z",
                                fill: "#50F"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M60.64 81.792c11.065 9.53 27.728 9.055 38.084-1.27 4.726-4.718 7.264-10.76 7.599-16.927.389-7.03-2.258-14.116-7.514-19.59-2.086-2.172-4.415-4.002-6.914-5.396-10.013-5.56-22.954-4.376-31.822 3.823-3.504 3.262-6.393 7.327-7.639 11.773-1.253 4.485-.584 8.977.42 13.416.771 3.41 1.73 6.782 3.73 9.772 1.106 1.65 2.523 3.075 4.057 4.399Z",
                                fill: "#4427FA"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M60.773 81.301c12.715 9.6 30.818 8.962 42.56-1.876 5.186-4.789 8.129-10.995 8.783-17.465.747-7.381-1.947-14.887-7.109-20.968-2.235-2.632-4.718-4.984-7.444-6.845-10.885-7.373-25.951-7.35-36.86 1.2-4.29 3.363-8.588 7.895-10.177 13.112-1.658 5.45.187 10.628 1.379 15.922.926 4.12 1.401 8.3 3.776 11.914 1.316 2 3.177 3.566 5.092 5.014v-.008Z",
                                fill: "#334EF5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M71.744 72.464c10.675 6.673 24.885 5.918 34.672-2.079 4.088-3.34 6.642-7.724 7.499-12.505.973-5.45-.849-11.142-4.267-15.985-1.698-2.406-3.59-4.68-5.731-6.548-8.495-7.405-21.467-8.869-31.558-2.663-3.924 2.413-8.713 6.089-10.239 10.62-1.674 4.96 1.16 9.36 2.204 14.086.825 3.721.521 7.615 2.608 10.877 1.16 1.822 2.998 3.06 4.812 4.197Z",
                                fill: "#2275F0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M76.82 64.468c8.503 3.916 18.89 2.826 26.786-2.274 2.958-1.908 5.154-4.462 6.213-7.545 1.199-3.52.35-7.498-1.417-11.01-1.129-2.227-2.46-4.36-4.018-6.252-6.112-7.405-16.974-10.371-26.255-6.525-3.55 1.472-8.845 4.275-10.301 8.137-1.69 4.469 2.125 8.09 3.028 12.24.725 3.317-.358 6.922 1.441 9.842 1.012 1.642 2.803 2.585 4.524 3.379v.008Z",
                                fill: "#119CEB"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M82.63 50.717c.467 2.204-.935 4.71.21 6.65.654 1.105 1.954 1.642 3.2 1.93 4.734 1.09 9.64-.397 14.272-1.868 1.347-.428 2.772-.903 3.722-1.955 1.082-1.199 1.347-2.958 1.074-4.547-.272-1.588-1.012-3.052-1.736-4.492-2.834-5.583-9.421-8.94-15.822-7.841-2.398.412-6.79 1.86-7.825 4.267-1.292 2.997 2.336 5.154 2.912 7.848l-.008.008Z",
                                fill: "#00C3E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M89.598 36.647v-.171c-.148-4.314-4.119-7.46-8.347-6.603l-13.276 2.694c-8.292-.218-14.038 8.222-10.791 15.86l5.193 12.24.18.414v-12a3.17 3.17 0 0 1 3.028-3.168 3.17 3.17 0 0 1 3.301 2.982c.047.849.771 1.503 1.62 1.464l.568-.023a2.144 2.144 0 0 0 1.768-1.075l1.946-3.426a5.444 5.444 0 0 0 .14-5.108c-.786-1.573.359-3.426 2.118-3.426h5.194l3.839 1.729c1.697.763 3.597-.522 3.527-2.383h-.008Z",
                        fill: "#33009A"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M80.044 120.829c-7.417-.712-60.679-33.734-60.679-33.734l3.146-.716a14.172 14.172 0 0 0 5.069-2.266l2.632-1.775c.132-.094.35-.234.6-.39l.264-.179c.148-.101.296-.226.444-.381.054-.063.1-.133.148-.203l.015-1.417a12.82 12.82 0 0 0-1.129-5.435l-2.071-4.617a168.66 168.66 0 0 1-.958-2.141c-1.214-3.084-1.915-5.357-2.164-7.024a22.368 22.368 0 0 1-.296-1.62c-1.472-1.626-1.145-5.979-.086-9.25 1.518-4.687 4.524-7.762 8.495-8.68 4.127-2.095 9.64-2.936 16.398-2.508 1.316.085 2.608.335 3.854.74 6.066.88 10.948 5.466 12.17 11.484.716 3.528.07 7.218-1.76 10.31l1.799 2.475c.568.78.677 1.815.273 2.702a2.707 2.707 0 0 1-2.212 1.573l-.786.07-1.394 7.203a4.48 4.48 0 0 1-4.742 3.612l-4.087-.311-.289 5.264.701.498c.405.288.88.576 1.433.88a13.997 13.997 0 0 0 3.636 1.386l1.876.358a15.577 15.577 0 0 1 11.734 10.145l7.973 23.947h-.007ZM74.5 116.5l-6.034-18.364a11.735 11.735 0 0 0-8.853-7.654l-1.94-.374a18.126 18.126 0 0 1-4.671-1.767 17.967 17.967 0 0 1-1.814-1.121l-2.414-1.721.615-11.244 7.966.608a.676.676 0 0 0 .708-.545l1.939-10.021 1.69-.148-.78-1.067a6.489 6.489 0 0 1-.77-1.425l-.39-.973.608-.849c1.752-2.453 2.39-5.427 1.799-8.362a10.708 10.708 0 0 0-9.118-8.487l-.366-.086a12.064 12.064 0 0 0-3.052-.607c-6.175-.398-11.096.35-14.615 2.203l-.241.125-.265.054c-2.141.436-3.839 1.83-5.046 4.127-1.308 2.484-1.62 5.279-1.565 6.79l.639-.148.218 2.149c.078.81.194 1.518.342 2.164l.032.164c.132.926.576 2.756 1.93 6.182.265.607.577 1.293.896 2.009l2.079 4.648a16.856 16.856 0 0 1 1.3 4.555l.755-.21-.085 2.718a6.232 6.232 0 0 1-1.09 3.317c-.195.295-.39.568-.615.817-.35.374-.724.693-1.114.95l-.32.21c-.225.14-.373.242-.49.327l-2.631 1.776C18.474 95.218 62.76 110.435 74.5 116.5Z",
                        fill: "#F5EEFD"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M41.223 81.625c2.472-5.819-.038-12.454-5.607-14.82-5.569-2.366-12.087.433-14.56 6.252-2.472 5.819.038 12.454 5.607 14.82 5.569 2.366 12.088-.433 14.56-6.252ZM51.655 66.236c6.975 0 12.63-5.655 12.63-12.63 0-6.975-5.655-12.63-12.63-12.63-6.975 0-12.63 5.655-12.63 12.63 0 6.975 5.655 12.63 12.63 12.63Z",
                        fill: "#33009A"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "m78.5 120.5-8.236-22.995a13.616 13.616 0 0 0-10.293-8.9l-1.939-.373a16.142 16.142 0 0 1-5.746-2.57l-1.744-1.238a6.53 6.53 0 0 0-3.769-1.199l-9.6-1.993c-1.347 0-4.805 1.9-5.902 2.686l-2.593 1.752a16.004 16.004 0 0 1-5.747 2.57L18.5 89c1.715 1.715 27.631 27.712 39.5 39h11.5",
                        fill: "#00C3E6"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask2_301_16603",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "27",
                        y: "40",
                        width: "38",
                        height: "56",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M27.798 60.116v-.07a17.252 17.252 0 0 1-.452-3.068c-.63-11.438 7.545-16.982 22.448-16.009 5.887.382 11.321 5.614 11.929 11.477.21 2.048.171 4.041-.117 5.918a4.844 4.844 0 0 0 .856 3.597l1.931 2.655a.794.794 0 0 1-.568 1.254l-2.22.194-1.72 7.857a3.525 3.525 0 0 1-3.605 2.64l-5.092-.273-.864 15.837c-.133 2.476-2.975 3.8-4.96 2.32L31.263 83.911l.864-.577a4.413 4.413 0 0 0 1.97-3.558l.093-3.41s-5.7-11.376-6.392-16.258v.008Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask2_301_16603)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M65.872 98.208C80.962 86.78 83.936 65.29 72.515 50.21 61.094 35.13 39.602 32.17 24.512 43.6 9.422 55.029 6.448 76.518 17.87 91.598c11.422 15.08 32.913 18.039 48.003 6.61Z",
                                fill: "#50F"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M26.996 89.135c12.17 10.48 30.507 9.966 41.898-1.394 5.201-5.194 7.989-11.843 8.363-18.625.428-7.74-2.484-15.534-8.27-21.552-2.296-2.39-4.85-4.4-7.607-5.934-11.017-6.112-25.25-4.82-35.014 4.205-3.855 3.59-7.04 8.059-8.402 12.956-1.378 4.937-.646 9.881.46 14.755.848 3.753 1.9 7.468 4.103 10.753 1.214 1.815 2.78 3.387 4.47 4.843v-.007Z",
                                fill: "#4427FA"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M27.144 88.605c13.992 10.566 33.91 9.866 46.827-2.063 5.7-5.271 8.946-12.092 9.662-19.216.818-8.122-2.14-16.375-7.825-23.071-2.46-2.897-5.193-5.49-8.19-7.538-11.984-8.113-28.553-8.082-40.552 1.324-4.718 3.699-9.453 8.69-11.197 14.42-1.83 5.996.21 11.695 1.519 17.52 1.02 4.531 1.541 9.133 4.158 13.104 1.448 2.203 3.496 3.924 5.606 5.513l-.008.007Z",
                                fill: "#334EF5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M39.213 78.88c11.742 7.343 27.377 6.51 38.145-2.281 4.493-3.667 7.311-8.503 8.253-13.759 1.075-5.995-.934-12.255-4.695-17.589-1.868-2.647-3.947-5.146-6.307-7.202-9.343-8.145-23.623-9.756-34.719-2.928-4.321 2.655-9.592 6.697-11.267 11.688-1.837 5.458 1.277 10.3 2.43 15.494.903 4.096.576 8.378 2.873 11.968 1.277 2.009 3.301 3.371 5.295 4.617l-.008-.008Z",
                                fill: "#2275F0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M44.842 69.95c9.352 4.305 20.782 3.106 29.472-2.5 3.254-2.103 5.676-4.906 6.836-8.3 1.323-3.87.39-8.246-1.565-12.108-1.238-2.453-2.71-4.804-4.423-6.875-6.727-8.145-18.68-11.415-28.887-7.18-3.909 1.62-9.733 4.704-11.337 8.955-1.853 4.92 2.344 8.9 3.333 13.47.794 3.652-.397 7.623 1.588 10.831 1.114 1.806 3.084 2.842 4.983 3.714v-.008Z",
                                fill: "#119CEB"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M51.188 54.945c.514 2.422-1.028 5.178.226 7.32.716 1.214 2.149 1.806 3.527 2.125 5.21 1.2 10.605-.436 15.697-2.056 1.487-.475 3.045-.988 4.088-2.149 1.191-1.315 1.48-3.254 1.183-5.006-.295-1.752-1.113-3.364-1.915-4.944-3.122-6.144-10.364-9.834-17.402-8.628-2.64.452-7.467 2.048-8.612 4.696-1.425 3.3 2.57 5.668 3.2 8.635l.008.007Z",
                                fill: "#00C3E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M61.684 52.127c-.709-6.105-5.84-10.769-11.975-11.166-14.857-.95-23.001 4.602-22.37 16.008.062 1.052.218 2.08.451 3.068v.07c.234 1.643 1.036 4.034 2.001 6.47.88 2.025 1.947 4.221 3.06 7.024.779 1.666 1.332 2.764 1.332 2.764l-.032 2.663 1.363-.374a10.691 10.691 0 0 0 7.39-7.996l.412-1.908a2.14 2.14 0 0 1-1.059-.942l-2.562-4.625a2.566 2.566 0 0 1 1.176-3.574c.265-.125.592-.179.942-.202 1.986-.102 2.71-2.788 1.005-3.816a.163.163 0 0 1-.047-.03c-.77-.452-1.55-.974-2.056-1.465 6.86 1.838 8.659-.381 12.599-2.11 3.169-1.393 6.197-.685 8.432.943-.023-.265-.047-.538-.078-.803h.016Z",
                        fill: "#33009A"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M33.583 79.784a14.833 14.833 0 0 0-1.292-6.237 903.28 903.28 0 0 0-2.071-4.617c-.335-.74-.647-1.433-.943-2.118-1.144-2.897-1.83-5.116-2.04-6.619a18.245 18.245 0 0 1-.46-3.192c-.272-4.929 1.037-8.86 3.894-11.703 3.854-3.823 10.278-5.474 19.077-4.913 6.509.413 11.765 5.318 12.504 11.664.031.272.063.553.086.825l.101 1.238-1.004-.732c-1.386-1.012-4.26-2.468-7.872-.88-.748.328-1.417.678-2.064 1.013-2.289 1.183-4.321 2.234-8.206 1.697.88.646 1.245 1.682.98 2.74-.295 1.169-1.237 1.963-2.413 2.017a2.21 2.21 0 0 0-.74.148 1.97 1.97 0 0 0-1.066 1.192 1.954 1.954 0 0 0 .148 1.588l2.561 4.625.18.312c1.432 2.46.934 5.606-1.231 7.467-1.947 1.666-4.228 3.356-6.027 3.893l-2.11.576.008.016ZM46.61 41.436c-6.829 0-12.03 1.596-15.145 4.688-2.616 2.6-3.815 6.236-3.558 10.83.054.981.202 1.986.436 2.975l.016.14c.194 1.386.856 3.52 1.962 6.322.288.662.6 1.355.926 2.087.646 1.433 1.386 3.06 2.134 4.937.763 1.619 1.308 2.717 1.316 2.717l.062.124-.023 2.04.638-.17a10.091 10.091 0 0 0 6.976-7.57l.32-1.486a2.644 2.644 0 0 1-.911-.966l-2.562-4.625a3.15 3.15 0 0 1-.233-2.5c.272-.825.88-1.51 1.674-1.868.311-.14.7-.226 1.152-.25.81-.038 1.238-.653 1.37-1.16.133-.513.031-1.198-.63-1.603-.997-.592-1.729-1.106-2.204-1.565l-1.596-1.534 2.141.576C46.197 55 48.3 53.91 50.97 52.532c.662-.343 1.355-.701 2.126-1.044 2.647-1.168 5.489-1.028 7.965.343-.833-5.614-5.567-9.912-11.391-10.278a45.948 45.948 0 0 0-3.06-.101v-.016Z",
                        fill: "#33009A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M110 76c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z",
                fill: "#20BB71"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M111.202 72.385c.312-.311.495-.733.495-1.201V56.808c0-.945-.761-1.707-1.706-1.707s-1.707.762-1.707 1.707v14.376a1.707 1.707 0 0 0 2.909 1.211l.009-.01Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M118.385 65.201c.312-.311.496-.734.496-1.201 0-.945-.762-1.707-1.707-1.707h-14.376c-.945 0-1.706.762-1.706 1.707 0 .945.761 1.706 1.706 1.706h14.376c.468 0 .899-.193 1.202-.496l.009-.009Z",
                fill: "#fff"
            })
        ]
    });
};
$1de285cdb4f6b295$var$PatientAddIcon.defaultProps = {
    width: "128",
    height: "128",
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $1de285cdb4f6b295$export$58917d9e8f3320d;
(function(EmptyPatientMessageVariant) {
    EmptyPatientMessageVariant["NoPatients"] = "NoPatients";
    EmptyPatientMessageVariant["NoRegisteredPatients"] = "NoRegisteredPatients";
    EmptyPatientMessageVariant["NoPendingPatients"] = "NoPendingPatients";
})($1de285cdb4f6b295$export$58917d9e8f3320d || ($1de285cdb4f6b295$export$58917d9e8f3320d = {}));
function $1de285cdb4f6b295$export$b898471ea3372a77({ variant: variant }) {
    const { format: format } = (0, $1eHG3.useI18n)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const onCreatePatientClicked = (0, $81g6h.useCallback)(()=>dialogContext?.openModal((0, $243Cr.ModalId).AddPatient, {
            contentStyle: {
                overflowY: "visible"
            },
            step: (0, $eiBvZ.DialogStep).CreatePatientForm
        }), [
        dialogContext
    ]);
    const onJoinHctClicked = (0, $81g6h.useCallback)(()=>dialogContext?.openModal((0, $243Cr.ModalId).AddPatient, {
            contentStyle: {
                overflowY: "visible"
            },
            step: (0, $eiBvZ.DialogStep).InvitationCodeForm
        }), [
        dialogContext
    ]);
    const { title: title, description: description, content: content } = (0, $81g6h.useMemo)(()=>{
        switch(variant){
            case "NoPatients":
                return {
                    title: format("home.noPatients.title"),
                    description: format("home.noPatients.description"),
                    content: /*#__PURE__*/ (0, $iKObn.jsx)($1de285cdb4f6b295$var$StyledInviteOrCreatePatient, {
                        createPatient: onCreatePatientClicked,
                        joinHct: onJoinHctClicked
                    })
                };
            case "NoRegisteredPatients":
                return {
                    title: format("home.noRegisteredPatients.title"),
                    description: format("home.noRegisteredPatients.description"),
                    content: /*#__PURE__*/ (0, $iKObn.jsx)($1de285cdb4f6b295$var$StyledInviteOrCreatePatient, {
                        createPatient: onCreatePatientClicked,
                        joinHct: onJoinHctClicked
                    })
                };
            case "NoPendingPatients":
                return {
                    title: format("home.noPendingPatients.title"),
                    content: /*#__PURE__*/ (0, $iKObn.jsx)((0, $djk4t.AddPatientButton), {})
                };
        }
    }, [
        format,
        onCreatePatientClicked,
        onJoinHctClicked,
        variant
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($1de285cdb4f6b295$var$MainContainer, {
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($1de285cdb4f6b295$var$Container, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)($1de285cdb4f6b295$var$PatientAddIcon, {
                    width: 128,
                    height: 128
                }),
                /*#__PURE__*/ (0, $iKObn.jsxs)($1de285cdb4f6b295$var$TextContainer, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)($1de285cdb4f6b295$var$Title, {
                            children: title
                        }),
                        description && /*#__PURE__*/ (0, $iKObn.jsx)($1de285cdb4f6b295$var$Description, {
                            className: "p-size-s",
                            children: description
                        })
                    ]
                }),
                content
            ]
        })
    });
}
const $1de285cdb4f6b295$var$MainContainer = (0, $5UMQ1.default).div`
	display: grid;
	place-items: center;
`;
const $1de285cdb4f6b295$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(24, "center", "center")};
	padding: 65px 16px;
	max-width: 400px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding-top: 30px;
		padding-bottom: 20px;
	}
`;
const $1de285cdb4f6b295$var$TextContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("XS", "center", "center")};
`;
const $1de285cdb4f6b295$var$Title = (0, $5UMQ1.default).h3`
	text-align: center;
	color: ${(0, $kKnoQ.colors).grey};
`;
const $1de285cdb4f6b295$var$Description = (0, $5UMQ1.default).div`
	text-align: center;
	color: ${(0, $kKnoQ.colors).grey};
`;
const $1de285cdb4f6b295$var$StyledInviteOrCreatePatient = (0, $5UMQ1.default)((0, $8AUvF.InviteOrCreatePatient))`
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		${(0, $5WGN2.stack)()};
	}
`;

});
parcelRegister("djk4t", function(module, exports) {

$parcel$export(module.exports, "AddPatientButton", () => $ba229bf76aca0649$export$371e482688077371);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $a6fIt = parcelRequire("a6fIt");

var $jrnUx = parcelRequire("jrnUx");

var $243Cr = parcelRequire("243Cr");

var $81g6h = parcelRequire("81g6h");
const $ba229bf76aca0649$export$371e482688077371 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const onCreatePatientClicked = (0, $81g6h.useCallback)(()=>dialogContext?.openModal((0, $243Cr.ModalId).AddPatient, {
            contentStyle: {
                overflowY: "visible"
            }
        }), [
        dialogContext
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $jrnUx.TooltipButton), {
        tooltipContent: format("tabbar.patients.demoMode.tooltip"),
        tooltipPosition: "bottom",
        id: "create-patient",
        "data-test": (0, $a6fIt.e2eTestId).homePage.createPatientButton,
        label: format("home.addPatientButton"),
        onClick: onCreatePatientClicked
    });
};

});


parcelRegister("izIaa", function(module, exports) {

$parcel$export(module.exports, "Column", () => $d85dc0bc44da0f0a$export$816b5d811295e6bc);
"use client";
var $d85dc0bc44da0f0a$export$816b5d811295e6bc = function Column() {};
//@todo Pass Parent MetaData
$d85dc0bc44da0f0a$export$816b5d811295e6bc.displayName = "Column";

});

parcelRegister("1LHh3", function(module, exports) {

$parcel$export(module.exports, "DataTable", () => $149bbf8d591193be$export$df30df7ec97b32b5);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $cfkGk = parcelRequire("cfkGk");

var $l2NC0 = parcelRequire("l2NC0");

var $fOwK6 = parcelRequire("fOwK6");

var $3E86S = parcelRequire("3E86S");

var $dPQhb = parcelRequire("dPQhb");

var $e6Cmx = parcelRequire("e6Cmx");

var $2Sldw = parcelRequire("2Sldw");

var $6NeNe = parcelRequire("6NeNe");

var $h7Chj = parcelRequire("h7Chj");

var $jhJol = parcelRequire("jhJol");

var $gbrlA = parcelRequire("gbrlA");

var $icj7p = parcelRequire("icj7p");

var $4vsYR = parcelRequire("4vsYR");

var $k7ffa = parcelRequire("k7ffa");

var $9rbaG = parcelRequire("9rbaG");

var $7hMfd = parcelRequire("7hMfd");

var $9AWgp = parcelRequire("9AWgp");

var $lbdsH = parcelRequire("lbdsH");

var $eT9rN = parcelRequire("eT9rN");

var $42wHR = parcelRequire("42wHR");

var $deOWu = parcelRequire("deOWu");

var $ddETg = parcelRequire("ddETg");

var $2NGYW = parcelRequire("2NGYW");

var $6ccvc = parcelRequire("6ccvc");

var $6b4aU = parcelRequire("6b4aU");

var $65uA4 = parcelRequire("65uA4");

var $gft09 = parcelRequire("gft09");

var $7nQgj = parcelRequire("7nQgj");
"use client";
function $149bbf8d591193be$var$_extends() {
    $149bbf8d591193be$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $149bbf8d591193be$var$_extends.apply(this, arguments);
}
function $149bbf8d591193be$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $149bbf8d591193be$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $149bbf8d591193be$var$_typeof(o);
}
function $149bbf8d591193be$var$_toPrimitive(input, hint) {
    if ($149bbf8d591193be$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($149bbf8d591193be$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $149bbf8d591193be$var$_toPropertyKey(arg) {
    var key = $149bbf8d591193be$var$_toPrimitive(arg, "string");
    return $149bbf8d591193be$var$_typeof(key) === "symbol" ? key : String(key);
}
function $149bbf8d591193be$var$_defineProperty(obj, key, value) {
    key = $149bbf8d591193be$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $149bbf8d591193be$var$_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $149bbf8d591193be$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $149bbf8d591193be$var$_arrayLikeToArray$1(arr);
}
function $149bbf8d591193be$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $149bbf8d591193be$var$_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $149bbf8d591193be$var$_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $149bbf8d591193be$var$_arrayLikeToArray$1(o, minLen);
}
function $149bbf8d591193be$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $149bbf8d591193be$var$_toConsumableArray(arr) {
    return $149bbf8d591193be$var$_arrayWithoutHoles(arr) || $149bbf8d591193be$var$_iterableToArray(arr) || $149bbf8d591193be$var$_unsupportedIterableToArray$1(arr) || $149bbf8d591193be$var$_nonIterableSpread();
}
function $149bbf8d591193be$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $149bbf8d591193be$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $149bbf8d591193be$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $149bbf8d591193be$var$_slicedToArray(arr, i) {
    return $149bbf8d591193be$var$_arrayWithHoles(arr) || $149bbf8d591193be$var$_iterableToArrayLimit(arr, i) || $149bbf8d591193be$var$_unsupportedIterableToArray$1(arr, i) || $149bbf8d591193be$var$_nonIterableRest();
}
var $149bbf8d591193be$var$getStorage = function getStorage(stateStorageProp) {
    switch(stateStorageProp){
        case "local":
            return window.localStorage;
        case "session":
            return window.sessionStorage;
        case "custom":
            return null;
        default:
            throw new Error(stateStorageProp + ' is not a valid value for the state storage, supported values are "local", "session" and "custom".');
    }
};
var $149bbf8d591193be$var$ColumnBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Column",
        align: null,
        alignFrozen: "left",
        alignHeader: null,
        body: null,
        bodyClassName: null,
        bodyStyle: null,
        cellEditValidateOnClose: false,
        cellEditValidator: null,
        cellEditValidatorEvent: "click",
        className: null,
        colSpan: null,
        columnKey: null,
        dataType: "text",
        editor: null,
        excludeGlobalFilter: false,
        expander: false,
        exportField: null,
        exportable: true,
        field: null,
        filter: false,
        filterApply: null,
        filterClear: null,
        filterElement: null,
        filterField: null,
        filterFooter: null,
        filterFunction: null,
        filterHeader: null,
        filterHeaderClassName: null,
        filterHeaderStyle: null,
        filterMatchMode: null,
        filterMatchModeOptions: null,
        filterMaxLength: null,
        filterMenuClassName: null,
        filterMenuStyle: null,
        filterPlaceholder: null,
        filterType: "text",
        footer: null,
        footerClassName: null,
        footerStyle: null,
        frozen: false,
        header: null,
        headerClassName: null,
        headerStyle: null,
        headerTooltip: null,
        headerTooltipOptions: null,
        hidden: false,
        maxConstraints: 2,
        onBeforeCellEditHide: null,
        onBeforeCellEditShow: null,
        onCellEditCancel: null,
        onCellEditComplete: null,
        onCellEditInit: null,
        onFilterApplyClick: null,
        onFilterClear: null,
        onFilterConstraintAdd: null,
        onFilterConstraintRemove: null,
        onFilterMatchModeChange: null,
        onFilterOperatorChange: null,
        reorderable: true,
        resizeable: true,
        rowEditor: false,
        rowReorder: false,
        rowReorderIcon: null,
        rowSpan: null,
        selectionMode: null,
        showAddButton: true,
        showApplyButton: true,
        showClearButton: true,
        showFilterMatchModes: true,
        showFilterMenu: true,
        showFilterMenuOptions: true,
        showFilterOperator: true,
        sortField: null,
        sortFunction: null,
        sortable: false,
        sortableDisabled: false,
        style: null,
        children: undefined
    },
    getCProp: function getCProp(column, name) {
        return (0, $cfkGk.ObjectUtils).getComponentProp(column, name, $149bbf8d591193be$var$ColumnBase.defaultProps);
    },
    getCProps: function getCProps(column) {
        return (0, $cfkGk.ObjectUtils).getComponentProps(column, $149bbf8d591193be$var$ColumnBase.defaultProps);
    },
    getCOtherProps: function getCOtherProps(column) {
        return (0, $cfkGk.ObjectUtils).getComponentDiffProps(column, $149bbf8d591193be$var$ColumnBase.defaultProps);
    }
});
function $149bbf8d591193be$var$ownKeys$e(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149bbf8d591193be$var$_objectSpread$e(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149bbf8d591193be$var$ownKeys$e(Object(t), !0).forEach(function(r) {
            $149bbf8d591193be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149bbf8d591193be$var$ownKeys$e(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149bbf8d591193be$var$styles$1 = "\n@layer primereact {\n    .p-datatable {\n        position: relative;\n    }\n\n    .p-datatable > .p-datatable-wrapper {\n        overflow: auto;\n    }\n\n    .p-datatable-table {\n        border-spacing: 0px;\n        width: 100%;\n    }\n\n    .p-datatable .p-sortable-disabled {\n        cursor: auto;\n    }\n\n    .p-datatable .p-sortable-column {\n        cursor: pointer;\n        user-select: none;\n    }\n\n    .p-datatable .p-sortable-column .p-column-title,\n    .p-datatable .p-sortable-column .p-sortable-column-icon,\n    .p-datatable .p-sortable-column .p-sortable-column-badge {\n        vertical-align: middle;\n    }\n\n    .p-datatable .p-sortable-column .p-sortable-column-badge {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .p-datatable-selectable .p-selectable-row,\n    .p-datatable-selectable-cell .p-selectable-cell {\n        cursor: pointer;\n    }\n\n    .p-datatable-drag-selection-helper {\n        position: absolute;\n        z-index: 99999999;\n    }\n\n    /* Scrollable */\n    .p-datatable-scrollable > .p-datatable-wrapper {\n        position: relative;\n    }\n\n    .p-datatable-scrollable-table > .p-datatable-thead {\n        position: sticky;\n        top: 0;\n        z-index: 1;\n    }\n\n    .p-datatable-scrollable-table > .p-datatable-frozen-tbody {\n        position: sticky;\n        z-index: 1;\n    }\n\n    .p-datatable-scrollable-table > .p-datatable-tfoot {\n        position: sticky;\n        bottom: 0;\n        z-index: 1;\n    }\n\n    .p-datatable-scrollable .p-frozen-column {\n        position: sticky;\n        background: inherit;\n    }\n\n    .p-datatable-scrollable th.p-frozen-column {\n        z-index: 1;\n    }\n\n    .p-datatable-flex-scrollable {\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n    }\n\n    .p-datatable-flex-scrollable > .p-datatable-wrapper {\n        display: flex;\n        flex-direction: column;\n        flex: 1;\n        height: 100%;\n    }\n\n    .p-datatable-scrollable-table > .p-datatable-tbody > .p-rowgroup-header {\n        position: sticky;\n        z-index: 1;\n    }\n\n    /* Resizable */\n    .p-datatable-resizable-table > .p-datatable-thead > tr > th,\n    .p-datatable-resizable-table > .p-datatable-tfoot > tr > td,\n    .p-datatable-resizable-table > .p-datatable-tbody > tr > td {\n        overflow: hidden;\n        white-space: nowrap;\n    }\n\n    .p-datatable-resizable-table > .p-datatable-thead > tr > th.p-resizable-column:not(.p-frozen-column) {\n        background-clip: padding-box;\n        position: relative;\n    }\n\n    .p-datatable-resizable-table-fit > .p-datatable-thead > tr > th.p-resizable-column:last-child .p-column-resizer {\n        display: none;\n    }\n\n    .p-datatable .p-column-resizer {\n        display: block;\n        position: absolute;\n        top: 0;\n        right: 0;\n        margin: 0;\n        width: 0.5rem;\n        height: 100%;\n        padding: 0px;\n        cursor: col-resize;\n        border: 1px solid transparent;\n    }\n\n    .p-datatable .p-column-header-content {\n        display: flex;\n        align-items: center;\n    }\n\n    .p-datatable .p-column-resizer-helper {\n        width: 1px;\n        position: absolute;\n        z-index: 10;\n        display: none;\n    }\n\n    .p-datatable .p-row-editor-init,\n    .p-datatable .p-row-editor-save,\n    .p-datatable .p-row-editor-cancel {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        overflow: hidden;\n        position: relative;\n    }\n\n    /* Expand */\n    .p-datatable .p-row-toggler {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        overflow: hidden;\n        position: relative;\n    }\n\n    /* Reorder */\n    .p-datatable-reorder-indicator-up,\n    .p-datatable-reorder-indicator-down {\n        position: absolute;\n        display: none;\n    }\n\n    .p-reorderable-column,\n    .p-datatable-reorderablerow-handle {\n        cursor: move;\n    }\n\n    /* Loader */\n    .p-datatable .p-datatable-loading-overlay {\n        position: absolute;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        z-index: 2;\n    }\n\n    /* Filter */\n    .p-column-filter-row {\n        display: flex;\n        align-items: center;\n        width: 100%;\n    }\n\n    .p-column-filter-menu {\n        display: inline-flex;\n        margin-left: auto;\n    }\n\n    .p-column-filter-row .p-column-filter-element {\n        flex: 1 1 auto;\n        width: 1%;\n    }\n\n    .p-column-filter-menu-button,\n    .p-column-filter-clear-button {\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        text-decoration: none;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .p-column-filter-overlay {\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n\n    .p-column-filter-row-items {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n    }\n\n    .p-column-filter-row-item {\n        cursor: pointer;\n    }\n\n    .p-column-filter-add-button,\n    .p-column-filter-remove-button {\n        justify-content: center;\n    }\n\n    .p-column-filter-add-button .p-button-label,\n    .p-column-filter-remove-button .p-button-label {\n        flex-grow: 0;\n    }\n\n    .p-column-filter-buttonbar {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .p-column-filter-buttonbar .p-button:not(.p-button-icon-only) {\n        width: auto;\n    }\n\n    /* Responsive */\n    .p-datatable .p-datatable-tbody > tr > td > .p-column-title {\n        display: none;\n    }\n\n    /* VirtualScroller */\n    .p-datatable-virtualscroller-spacer {\n        display: flex;\n    }\n\n    .p-datatable .p-virtualscroller .p-virtualscroller-loading {\n        transform: none;\n        min-height: 0;\n        position: sticky;\n        top: 0;\n        left: 0;\n    }\n\n    /* Alignment */\n    .p-datatable .p-datatable-thead > tr > th.p-align-left > .p-column-header-content,\n    .p-datatable .p-datatable-tbody > tr > td.p-align-left,\n    .p-datatable .p-datatable-tfoot > tr > td.p-align-left {\n        text-align: left;\n        justify-content: flex-start;\n    }\n\n    .p-datatable .p-datatable-thead > tr > th.p-align-right > .p-column-header-content,\n    .p-datatable .p-datatable-tbody > tr > td.p-align-right,\n    .p-datatable .p-datatable-tfoot > tr > td.p-align-right {\n        text-align: right;\n        justify-content: flex-end;\n    }\n\n    .p-datatable .p-datatable-thead > tr > th.p-align-center > .p-column-header-content,\n    .p-datatable .p-datatable-tbody > tr > td.p-align-center,\n    .p-datatable .p-datatable-tfoot > tr > td.p-align-center {\n        text-align: center;\n        justify-content: center;\n    }\n}\n";
var $149bbf8d591193be$var$classes$2 = {
    root: function root(_ref) {
        var props = _ref.props, selectable = _ref.selectable;
        return (0, $cfkGk.classNames)("p-datatable p-component", {
            "p-datatable-hoverable-rows": props.rowHover,
            "p-datatable-selectable": selectable && !props.cellSelection,
            "p-datatable-selectable-cell": selectable && props.cellSelection,
            "p-datatable-resizable": props.resizableColumns,
            "p-datatable-resizable-fit": props.resizableColumns && props.columnResizeMode === "fit",
            "p-datatable-scrollable": props.scrollable,
            "p-datatable-flex-scrollable": props.scrollable && props.scrollHeight === "flex",
            "p-datatable-responsive-stack": props.responsiveLayout === "stack",
            "p-datatable-responsive-scroll": props.responsiveLayout === "scroll",
            "p-datatable-striped": props.stripedRows,
            "p-datatable-gridlines": props.showGridlines,
            "p-datatable-grouped-header": props.headerColumnGroup != null,
            "p-datatable-grouped-footer": props.footerColumnGroup != null,
            "p-datatable-sm": props.size === "small",
            "p-datatable-lg": props.size === "large"
        });
    },
    loadingIcon: "p-datatable-loading-icon",
    loadingOverlay: "p-datatable-loading-overlay p-component-overlay",
    header: "p-datatable-header",
    wrapper: "p-datatable-wrapper",
    table: function table(_ref2) {
        var props = _ref2.props;
        return (0, $cfkGk.classNames)("p-datatable-table", {
            "p-datatable-scrollable-table": props.scrollable,
            "p-datatable-resizable-table": props.resizableColumns,
            "p-datatable-resizable-table-fit": props.resizableColumns && props.columnResizeMode === "fit"
        });
    },
    thead: "p-datatable-thead",
    tfoot: "p-datatable-tfoot",
    footer: "p-datatable-footer",
    checkIcon: "p-checkbox-icon",
    resizeHelper: "p-column-resizer-helper",
    reorderIndicatorUp: "p-datatable-reorder-indicator-up",
    reorderIndicatorDown: "p-datatable-reorder-indicator-down",
    paginator: function paginator(_ref3) {
        var position = _ref3.position;
        return (0, $cfkGk.classNames)("p-paginator-" + position);
    },
    bodyCell: function bodyCell(_ref4) {
        var selectionMode = _ref4.selectionMode, editor = _ref4.editor, editingState = _ref4.editingState, frozen = _ref4.frozen, cellSelected = _ref4.cellSelected, align = _ref4.align, props = _ref4.bodyProps, getCellParams = _ref4.getCellParams;
        return (0, $cfkGk.classNames)($149bbf8d591193be$var$_defineProperty({
            "p-selection-column": selectionMode !== null,
            "p-editable-column": editor,
            "p-cell-editing": editor && editingState,
            "p-frozen-column": frozen,
            "p-selectable-cell": props.allowCellSelection && props.isSelectable({
                data: getCellParams(),
                index: props.rowIndex
            }),
            "p-highlight": cellSelected
        }, "p-align-".concat(align), !!align));
    },
    columnTitle: "p-column-title",
    bodyRow: function bodyRow(_ref5) {
        var props = _ref5.rowProps;
        return (0, $cfkGk.classNames)({
            "p-highlight": !props.allowCellSelection && props.selected || props.contextMenuSelected,
            "p-highlight-contextmenu": props.contextMenuSelected,
            "p-selectable-row": props.allowRowSelection && props.isSelectable({
                data: props.rowData,
                index: props.rowIndex
            }),
            "p-row-odd": props.rowIndex % 2 !== 0
        });
    },
    rowGroupTogglerIcon: "p-row-toggler-icon",
    rowGroupToggler: "p-row-toggler p-link",
    rowGroupHeader: "p-rowgroup-header",
    rowGroupHeaderName: "p-rowgroup-header-name",
    rowGroupFooter: "p-rowgroup-footer",
    rowReorderIcon: "p-datatable-reorderablerow-handle",
    rowTogglerIcon: "p-row-toggler-icon",
    rowToggler: "p-row-toggler p-link",
    rowEditorSaveIcon: "p-row-editor-save-icon",
    rowEditorSaveButton: "p-row-editor-save p-link",
    rowEditorCancelIcon: "p-row-editor-cancel-icon",
    rowEditorCancelButton: "p-row-editor-cancel p-link",
    rowEditorInitIcon: "p-row-editor-init-icon",
    rowEditorInitButton: "p-row-editor-init p-link",
    rowExpansion: "p-datatable-row-expansion",
    virtualScrollerSpacer: function virtualScrollerSpacer(_ref6) {
        var className = _ref6.className;
        return className;
    },
    tbody: function tbody(_ref7) {
        var className = _ref7.className;
        return className;
    },
    filterInput: "p-fluid p-column-filter-element",
    filterMenuButton: function filterMenuButton(_ref8) {
        var overlayVisibleState = _ref8.overlayVisibleState, hasFilter = _ref8.hasFilter;
        return (0, $cfkGk.classNames)("p-column-filter-menu-button p-link", {
            "p-column-filter-menu-button-open": overlayVisibleState,
            "p-column-filter-menu-button-active": hasFilter()
        });
    },
    headerFilterClearButton: function headerFilterClearButton(_ref9) {
        var hasRowFilter = _ref9.hasRowFilter;
        return (0, $cfkGk.classNames)("p-column-filter-clear-button p-link", {
            "p-hidden-space": !hasRowFilter()
        });
    },
    filterSeparator: "p-column-filter-separator",
    filterRowItem: function filterRowItem(_ref10) {
        var isRowMatchModeSelected = _ref10.isRowMatchModeSelected, isShowMatchModes = _ref10.isShowMatchModes, value = _ref10.value;
        return isShowMatchModes() ? (0, $cfkGk.classNames)("p-column-filter-row-item", {
            "p-highlight": value && isRowMatchModeSelected(value)
        }) : undefined;
    },
    filterRowItems: "p-column-filter-row-items",
    filterOperator: "p-column-filter-operator",
    filterConstraints: "p-column-filter-constraints",
    filterConstraint: "p-column-filter-constraint",
    filterAddRule: "p-column-filter-add-rule",
    filterButtonBar: "p-column-filter-buttonbar",
    filterOverlay: function filterOverlay(_ref11) {
        var props = _ref11.columnFilterProps, context = _ref11.context, getColumnProp = _ref11.getColumnProp;
        return (0, $cfkGk.classNames)("p-column-filter-overlay p-component p-fluid", getColumnProp("filterMenuClassName"), {
            "p-column-filter-overlay-menu": props.display === "menu",
            "p-input-filled": context && context.inputStyle === "filled" || (0, $8Zwsm.default).inputStyle === "filled",
            "p-ripple-disabled": context && context.ripple === false || (0, $8Zwsm.default).ripple === false
        });
    },
    columnFilter: function columnFilter(_ref12) {
        var props = _ref12.columnFilterProps;
        return (0, $cfkGk.classNames)("p-column-filter p-fluid", {
            "p-column-filter-row": props.display === "row",
            "p-column-filter-menu": props.display === "menu"
        });
    },
    columnResizer: "p-column-resizer",
    emptyMessage: "p-datatable-emptymessage",
    sortBadge: "p-sortable-column-badge",
    sortIcon: "p-sortable-column-icon",
    headerTitle: "p-column-title",
    headerContent: "p-column-header-content",
    headerCell: function headerCell(_ref13) {
        var props = _ref13.headerProps, frozen = _ref13.frozen, sortMeta = _ref13.sortMeta, align = _ref13.align, _isSortableDisabled = _ref13._isSortableDisabled, getColumnProp = _ref13.getColumnProp;
        return (0, $cfkGk.ObjectUtils).isEmpty(props) ? (0, $cfkGk.classNames)("p-filter-column", {
            "p-frozen-column": frozen
        }) : (0, $cfkGk.classNames)($149bbf8d591193be$var$_defineProperty({
            "p-filter-column": !props.headerColumnGroup && props.filterDisplay === "row",
            "p-sortable-column": getColumnProp("sortable"),
            "p-resizable-column": props.resizableColumns && getColumnProp("resizeable"),
            "p-highlight": sortMeta.sorted,
            "p-frozen-column": frozen,
            "p-selection-column": getColumnProp("selectionMode"),
            "p-sortable-disabled": getColumnProp("sortable") && _isSortableDisabled,
            "p-reorderable-column": props.reorderableColumns && getColumnProp("reorderable") && !frozen
        }, "p-align-".concat(align), !!align));
    },
    footerCell: function footerCell(_ref14) {
        var getColumnProp = _ref14.getColumnProp, align = _ref14.align;
        return (0, $cfkGk.classNames)($149bbf8d591193be$var$_defineProperty({
            "p-frozen-column": getColumnProp("frozen")
        }, "p-align-".concat(align), !!align));
    },
    transition: "p-connected-overlay"
};
var $149bbf8d591193be$var$inlineStyles = {
    wrapper: {
        overflow: "auto"
    },
    resizeHelper: {
        display: "none"
    },
    reorderIndicatorUp: function reorderIndicatorUp(_ref15) {
        var style = _ref15.style;
        return $149bbf8d591193be$var$_objectSpread$e({}, style);
    },
    reorderIndicatorDown: function reorderIndicatorDown(_ref16) {
        var style = _ref16.style;
        return $149bbf8d591193be$var$_objectSpread$e({}, style);
    }
};
var $149bbf8d591193be$var$DataTableBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "DataTable",
        alwaysShowPaginator: true,
        breakpoint: "960px",
        cellClassName: null,
        cellSelection: false,
        checkIcon: null,
        className: null,
        collapsedRowIcon: null,
        columnResizeMode: "fit",
        compareSelectionBy: "deepEquals",
        contextMenuSelection: null,
        csvSeparator: ",",
        currentPageReportTemplate: "({currentPage} of {totalPages})",
        customRestoreState: null,
        customSaveState: null,
        dataKey: null,
        defaultSortOrder: 1,
        dragSelection: false,
        editMode: null,
        editingRows: null,
        emptyMessage: null,
        expandableRowGroups: false,
        expandedRowIcon: null,
        expandedRows: null,
        exportFilename: "download",
        exportFunction: null,
        filterClearIcon: null,
        filterDelay: 300,
        filterDisplay: "menu",
        filterIcon: null,
        filterLocale: undefined,
        filters: null,
        first: 0,
        footer: null,
        footerColumnGroup: null,
        frozenRow: false,
        frozenValue: null,
        frozenWidth: null,
        globalFilter: null,
        globalFilterFields: null,
        globalFilterMatchMode: (0, $8Zwsm.FilterMatchMode).CONTAINS,
        groupRowsBy: null,
        header: null,
        headerColumnGroup: null,
        id: null,
        isDataSelectable: null,
        lazy: false,
        loading: false,
        loadingIcon: null,
        metaKeySelection: false,
        multiSortMeta: null,
        onAllRowsSelect: null,
        onAllRowsUnselect: null,
        onCellClick: null,
        onCellSelect: null,
        onCellUnselect: null,
        onColReorder: null,
        onColumnResizeEnd: null,
        onColumnResizerClick: null,
        onColumnResizerDoubleClick: null,
        onContextMenu: null,
        onContextMenuSelectionChange: null,
        onFilter: null,
        onPage: null,
        onRowClick: null,
        onRowCollapse: null,
        onRowDoubleClick: null,
        onRowEditCancel: null,
        onRowEditChange: null,
        onRowEditComplete: null,
        onRowEditInit: null,
        onRowEditSave: null,
        onRowExpand: null,
        onRowMouseEnter: null,
        onRowMouseLeave: null,
        onRowPointerDown: null,
        onRowPointerUp: null,
        onRowReorder: null,
        onRowSelect: null,
        onRowToggle: null,
        onRowUnselect: null,
        onSelectAllChange: null,
        onSelectionChange: null,
        onSort: null,
        onStateRestore: null,
        onStateSave: null,
        onValueChange: null,
        pageLinkSize: 5,
        paginator: false,
        paginatorClassName: null,
        paginatorDropdownAppendTo: null,
        paginatorLeft: null,
        paginatorPosition: "bottom",
        paginatorRight: null,
        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
        removableSort: false,
        reorderIndicatorDownIcon: null,
        reorderIndicatorUpIcon: null,
        reorderableColumns: false,
        reorderableRows: false,
        resizableColumns: false,
        responsiveLayout: "scroll",
        rowClassName: null,
        rowEditValidator: null,
        rowEditorCancelIcon: null,
        rowEditorInitIcon: null,
        rowEditorSaveIcon: null,
        rowExpansionTemplate: null,
        rowGroupFooterTemplate: null,
        rowGroupHeaderTemplate: null,
        rowGroupMode: null,
        rowHover: false,
        rows: null,
        rowsPerPageOptions: null,
        scrollHeight: null,
        scrollable: false,
        selectAll: false,
        selectOnEdit: true,
        selection: null,
        selectionAriaLabel: null,
        selectionAutoFocus: true,
        selectionMode: null,
        selectionPageOnly: false,
        showGridlines: false,
        showHeaders: true,
        showRowReorderElement: null,
        showSelectAll: true,
        showSelectionElement: null,
        size: "normal",
        sortField: null,
        sortIcon: null,
        sortMode: "single",
        sortOrder: null,
        stateKey: null,
        stateStorage: "session",
        stripedRows: false,
        style: null,
        tabIndex: 0,
        tableClassName: null,
        tableStyle: null,
        totalRecords: null,
        value: null,
        virtualScrollerOptions: null,
        children: undefined
    },
    css: {
        styles: $149bbf8d591193be$var$styles$1,
        classes: $149bbf8d591193be$var$classes$2,
        inlineStyles: $149bbf8d591193be$var$inlineStyles
    }
});
function $149bbf8d591193be$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $149bbf8d591193be$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $149bbf8d591193be$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $149bbf8d591193be$var$classes$1 = {
    box: "p-checkbox-box",
    input: "p-checkbox-input",
    icon: "p-checkbox-icon",
    root: function root(_ref) {
        var props = _ref.props, checked = _ref.checked, context = _ref.context;
        return (0, $cfkGk.classNames)("p-checkbox p-component", {
            "p-highlight": checked,
            "p-disabled": props.disabled,
            "p-invalid": props.invalid,
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled"
        });
    }
};
var $149bbf8d591193be$var$CheckboxBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Checkbox",
        autoFocus: false,
        checked: false,
        className: null,
        disabled: false,
        falseValue: false,
        icon: null,
        id: null,
        inputId: null,
        inputRef: null,
        invalid: false,
        variant: null,
        name: null,
        onChange: null,
        onContextMenu: null,
        onMouseDown: null,
        readOnly: false,
        required: false,
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        trueValue: true,
        value: null,
        children: undefined
    },
    css: {
        classes: $149bbf8d591193be$var$classes$1
    }
});
function $149bbf8d591193be$var$ownKeys$d(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149bbf8d591193be$var$_objectSpread$d(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149bbf8d591193be$var$ownKeys$d(Object(t), !0).forEach(function(r) {
            $149bbf8d591193be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149bbf8d591193be$var$ownKeys$d(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149bbf8d591193be$var$Checkbox = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $149bbf8d591193be$var$CheckboxBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState(false), _React$useState2 = $149bbf8d591193be$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var _CheckboxBase$setMeta = $149bbf8d591193be$var$CheckboxBase.setMetaData({
        props: props,
        state: {
            focused: focusedState
        },
        context: {
            checked: props.checked === props.trueValue,
            disabled: props.disabled
        }
    }), ptm = _CheckboxBase$setMeta.ptm, cx = _CheckboxBase$setMeta.cx, isUnstyled = _CheckboxBase$setMeta.isUnstyled;
    (0, $4gQLd.useHandleStyle)($149bbf8d591193be$var$CheckboxBase.css.styles, isUnstyled, {
        name: "checkbox"
    });
    var elementRef = $81g6h.useRef(null);
    var inputRef = $81g6h.useRef(props.inputRef);
    var isChecked = function isChecked() {
        return props.checked === props.trueValue;
    };
    var _onChange = function onChange(event) {
        if (props.disabled || props.readonly) return;
        if (props.onChange) {
            var _props$onChange;
            var _checked = isChecked();
            var value = _checked ? props.falseValue : props.trueValue;
            var eventData = {
                originalEvent: event,
                value: props.value,
                checked: value,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    type: "checkbox",
                    name: props.name,
                    id: props.id,
                    value: props.value,
                    checked: value
                }
            };
            props === null || props === void 0 || (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, eventData);
            // do not continue if the user defined click wants to prevent
            if (event.defaultPrevented) return;
            (0, $cfkGk.DomHandler).focus(inputRef.current);
        }
    };
    var _onFocus = function onFocus() {
        var _props$onFocus;
        setFocusedState(true);
        props === null || props === void 0 || (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props);
    };
    var _onBlur = function onBlur() {
        var _props$onBlur;
        setFocusedState(false);
        props === null || props === void 0 || (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props);
    };
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            focus: function focus() {
                return (0, $cfkGk.DomHandler).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    $81g6h.useEffect(function() {
        (0, $cfkGk.ObjectUtils).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        inputRef.current.checked = isChecked();
    }, [
        props.checked,
        props.trueValue
    ]);
    (0, $l2NC0.useMountEffect)(function() {
        if (props.autoFocus) (0, $cfkGk.DomHandler).focus(inputRef.current, props.autoFocus);
    });
    var checked = isChecked();
    var hasTooltip = (0, $cfkGk.ObjectUtils).isNotEmpty(props.tooltip);
    var otherProps = $149bbf8d591193be$var$CheckboxBase.getOtherProps(props);
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $cfkGk.classNames)(props.className, cx("root", {
            checked: checked,
            context: context
        })),
        style: props.style,
        "data-p-highlight": checked,
        "data-p-disabled": props.disabled,
        onContextMenu: props.onContextMenu,
        onMouseDown: props.onMouseDown
    }, otherProps, ptm("root"));
    var createInputElement = function createInputElement() {
        var ariaProps = (0, $cfkGk.ObjectUtils).reduceKeys(otherProps, (0, $cfkGk.DomHandler).ARIA_PROPS);
        var inputProps = mergeProps($149bbf8d591193be$var$_objectSpread$d({
            id: props.inputId,
            type: "checkbox",
            className: cx("input"),
            name: props.name,
            tabIndex: props.tabIndex,
            onFocus: function onFocus(e) {
                return _onFocus();
            },
            onBlur: function onBlur(e) {
                return _onBlur();
            },
            onChange: function onChange(e) {
                return _onChange(e);
            },
            disabled: props.disabled,
            readOnly: props.readOnly,
            required: props.required,
            "aria-invalid": props.invalid,
            checked: checked
        }, ariaProps), ptm("input"));
        return /*#__PURE__*/ $81g6h.createElement("input", $149bbf8d591193be$var$_extends({
            ref: inputRef
        }, inputProps));
    };
    var createBoxElement = function createBoxElement() {
        var iconProps = mergeProps({
            className: cx("icon")
        }, ptm("icon"));
        var boxProps = mergeProps({
            className: cx("box", {
                checked: checked
            }),
            "data-p-highlight": checked,
            "data-p-disabled": props.disabled
        }, ptm("box"));
        var icon = checked ? props.icon || /*#__PURE__*/ $81g6h.createElement((0, $h7Chj.CheckIcon), iconProps) : null;
        var checkboxIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $149bbf8d591193be$var$_objectSpread$d({}, iconProps), {
            props: props,
            checked: checked
        });
        return /*#__PURE__*/ $81g6h.createElement("div", boxProps, checkboxIcon);
    };
    return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("div", $149bbf8d591193be$var$_extends({
        ref: elementRef
    }, rootProps), createInputElement(), createBoxElement()), hasTooltip && /*#__PURE__*/ $81g6h.createElement((0, $7hMfd.Tooltip), $149bbf8d591193be$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$149bbf8d591193be$var$Checkbox.displayName = "Checkbox";
function $149bbf8d591193be$var$ownKeys$c(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149bbf8d591193be$var$_objectSpread$c(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149bbf8d591193be$var$ownKeys$c(Object(t), !0).forEach(function(r) {
            $149bbf8d591193be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149bbf8d591193be$var$ownKeys$c(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149bbf8d591193be$var$RowCheckbox = /*#__PURE__*/ $81g6h.memo(function(props) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var getColumnProps = function getColumnProps() {
        return $149bbf8d591193be$var$ColumnBase.getCProps(props.column);
    };
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var getColumnPTOptions = function getColumnPTOptions(key) {
        var columnMetaData = {
            props: getColumnProps(),
            parent: props.metaData,
            hostName: props.hostName,
            state: {},
            context: {
                index: props.tabIndex,
                checked: props.checked,
                disabled: props.disabled
            }
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(getColumnProps(), key, columnMetaData));
    };
    var onChange = function onChange(event) {
        if (!props.disabled) props.onChange(event);
    };
    var checkboxIconProps = mergeProps({
        className: cx("checkIcon")
    }, getColumnPTOptions("rowCheckbox.icon"));
    var icon = props.checked ? props.checkIcon || /*#__PURE__*/ $81g6h.createElement((0, $h7Chj.CheckIcon), checkboxIconProps) : null;
    var checkIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $149bbf8d591193be$var$_objectSpread$c({}, checkboxIconProps), {
        props: props
    });
    var tabIndex = props.disabled ? null : "0";
    var checkboxProps = mergeProps({
        role: "checkbox",
        "aria-checked": props.checked,
        tabIndex: tabIndex,
        onChange: onChange,
        "aria-label": props.ariaLabel,
        checked: props.checked,
        icon: checkIcon,
        disabled: props.disabled
    }, getColumnPTOptions("rowCheckbox"));
    return /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$Checkbox, checkboxProps);
});
$149bbf8d591193be$var$RowCheckbox.displayName = "RowCheckbox";
var $149bbf8d591193be$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, context = _ref.context;
        return (0, $cfkGk.classNames)("p-radiobutton p-component", {
            "p-highlight": props.checked,
            "p-disabled": props.disabled,
            "p-invalid": props.invalid,
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled"
        });
    },
    radiobuttonbox: "p-radiobutton-box",
    radiobuttoninput: "p-radiobutton-input",
    radiobuttonicon: "p-radiobutton-icon"
};
var $149bbf8d591193be$var$RadioButtonBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "RadioButton",
        autoFocus: false,
        checked: false,
        className: null,
        disabled: false,
        id: null,
        inputId: null,
        inputRef: null,
        invalid: false,
        variant: null,
        name: null,
        onChange: null,
        onClick: null,
        required: false,
        style: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        value: null,
        children: undefined
    },
    css: {
        classes: $149bbf8d591193be$var$classes
    }
});
function $149bbf8d591193be$var$ownKeys$b(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149bbf8d591193be$var$_objectSpread$b(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149bbf8d591193be$var$ownKeys$b(Object(t), !0).forEach(function(r) {
            $149bbf8d591193be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149bbf8d591193be$var$ownKeys$b(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149bbf8d591193be$var$RadioButton = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $149bbf8d591193be$var$RadioButtonBase.getProps(inProps, context);
    var elementRef = $81g6h.useRef(null);
    var inputRef = $81g6h.useRef(props.inputRef);
    var _RadioButtonBase$setM = $149bbf8d591193be$var$RadioButtonBase.setMetaData({
        props: props
    }), ptm = _RadioButtonBase$setM.ptm, cx = _RadioButtonBase$setM.cx, isUnstyled = _RadioButtonBase$setM.isUnstyled;
    (0, $4gQLd.useHandleStyle)($149bbf8d591193be$var$RadioButtonBase.css.styles, isUnstyled, {
        name: "radiobutton"
    });
    var select = function select(event) {
        onChange(event);
    };
    var onChange = function onChange(event) {
        if (props.disabled || props.readonly) return;
        if (props.onChange) {
            var checked = props.checked;
            var radioClicked = event.target instanceof HTMLDivElement;
            var inputClicked = event.target === inputRef.current;
            var isInputToggled = inputClicked && event.target.checked !== checked;
            var isRadioToggled = radioClicked && ((0, $cfkGk.DomHandler).hasClass(elementRef.current, "p-radiobutton-checked") === checked ? !checked : false);
            var value = !checked;
            var eventData = {
                originalEvent: event,
                value: props.value,
                checked: value,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    type: "radio",
                    name: props.name,
                    id: props.id,
                    value: props.value,
                    checked: value
                }
            };
            if (isInputToggled || isRadioToggled) {
                var _props$onChange;
                props === null || props === void 0 || (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, eventData);
                // do not continue if the user defined click wants to prevent
                if (event.defaultPrevented) return;
                if (isRadioToggled) inputRef.current.checked = value;
            }
            (0, $cfkGk.DomHandler).focus(inputRef.current);
        }
    };
    var onFocus = function onFocus(event) {
        var _props$onFocus;
        props === null || props === void 0 || (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, event);
    };
    var onBlur = function onBlur(event) {
        var _props$onBlur;
        props === null || props === void 0 || (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props, event);
    };
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            select: select,
            focus: function focus() {
                return (0, $cfkGk.DomHandler).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    $81g6h.useEffect(function() {
        if (inputRef.current) inputRef.current.checked = props.checked;
    }, [
        props.checked
    ]);
    $81g6h.useEffect(function() {
        (0, $cfkGk.ObjectUtils).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $l2NC0.useMountEffect)(function() {
        if (props.autoFocus) (0, $cfkGk.DomHandler).focus(inputRef.current, props.autoFocus);
    });
    var hasTooltip = (0, $cfkGk.ObjectUtils).isNotEmpty(props.tooltip);
    var otherProps = $149bbf8d591193be$var$RadioButtonBase.getOtherProps(props);
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $cfkGk.classNames)(props.className, cx("root", {
            context: context
        })),
        style: props.style,
        "data-p-checked": props.checked
    }, otherProps, ptm("root"));
    delete rootProps.input;
    delete rootProps.box;
    delete rootProps.icon;
    var createInputElement = function createInputElement() {
        var ariaProps = (0, $cfkGk.ObjectUtils).reduceKeys(otherProps, (0, $cfkGk.DomHandler).ARIA_PROPS);
        var inputProps = mergeProps($149bbf8d591193be$var$_objectSpread$b({
            id: props.inputId,
            type: "radio",
            name: props.name,
            defaultChecked: props.checked,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: onChange,
            disabled: props.disabled,
            readOnly: props.readonly,
            required: props.required,
            tabIndex: props.tabIndex,
            className: cx("radiobuttoninput")
        }, ariaProps), inProps.input, ptm("radiobuttoninput"));
        return /*#__PURE__*/ $81g6h.createElement("input", $149bbf8d591193be$var$_extends({
            ref: inputRef
        }, inputProps));
    };
    var createBoxElement = function createBoxElement() {
        var boxProps = mergeProps({
            className: cx("radiobuttonbox")
        }, inProps.box, ptm("radiobuttonbox"));
        var iconProps = mergeProps({
            className: cx("radiobuttonicon")
        }, inProps.icon, ptm("radiobuttonicon"));
        return /*#__PURE__*/ $81g6h.createElement("div", boxProps, /*#__PURE__*/ $81g6h.createElement("div", iconProps));
    };
    return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("div", $149bbf8d591193be$var$_extends({
        ref: elementRef
    }, rootProps), createInputElement(), createBoxElement()), hasTooltip && /*#__PURE__*/ $81g6h.createElement((0, $7hMfd.Tooltip), $149bbf8d591193be$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$149bbf8d591193be$var$RadioButton.displayName = "RadioButton";
var $149bbf8d591193be$var$RowRadioButton = /*#__PURE__*/ $81g6h.memo(function(props) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var getColumnProps = function getColumnProps() {
        return $149bbf8d591193be$var$ColumnBase.getCProps(props.column);
    };
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo;
    var getColumnPTOptions = function getColumnPTOptions(key) {
        var columnMetaData = {
            props: getColumnProps(),
            parent: props.metaData,
            hostName: props.hostName,
            state: {},
            context: {
                index: props.tabIndex,
                checked: props.checked,
                disabled: props.disabled
            }
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(getColumnProps(), key, columnMetaData));
    };
    var onChange = function onChange(event) {
        if (!props.disabled) props.onChange(event);
    };
    var radioButtonProps = mergeProps({
        role: "radio",
        "aria-checked": props.checked,
        checked: props.checked,
        disabled: props.disabled,
        name: "".concat(props.tableSelector, "_dt_radio"),
        onChange: onChange,
        input: getColumnPTOptions("radiobuttoninput"),
        box: getColumnPTOptions("radiobuttonbox"),
        icon: getColumnPTOptions("radiobuttonicon"),
        unstyled: props.unstyled
    }, getColumnPTOptions("radiobutton"));
    return /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$RadioButton, radioButtonProps);
});
$149bbf8d591193be$var$RowRadioButton.displayName = "RowRadioButton";
function $149bbf8d591193be$var$ownKeys$a(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149bbf8d591193be$var$_objectSpread$a(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149bbf8d591193be$var$ownKeys$a(Object(t), !0).forEach(function(r) {
            $149bbf8d591193be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149bbf8d591193be$var$ownKeys$a(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149bbf8d591193be$var$BodyCell = /*#__PURE__*/ $81g6h.memo(function(props) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var _React$useState = $81g6h.useState(props.editing), _React$useState2 = $149bbf8d591193be$var$_slicedToArray(_React$useState, 2), editingState = _React$useState2[0], setEditingState = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(props.rowData), _React$useState4 = $149bbf8d591193be$var$_slicedToArray(_React$useState3, 2), editingRowDataState = _React$useState4[0], setEditingRowDataState = _React$useState4[1];
    var _React$useState5 = $81g6h.useState({}), _React$useState6 = $149bbf8d591193be$var$_slicedToArray(_React$useState5, 2), styleObjectState = _React$useState6[0], setStyleObjectState = _React$useState6[1];
    var elementRef = $81g6h.useRef(null);
    var keyHelperRef = $81g6h.useRef(null);
    var overlayEventListener = $81g6h.useRef(null);
    var selfClick = $81g6h.useRef(false);
    var initFocusTimeout = $81g6h.useRef(null);
    var editingRowDataStateRef = $81g6h.useRef(null);
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var getColumnProp = function getColumnProp(name) {
        return $149bbf8d591193be$var$ColumnBase.getCProp(props.column, name);
    };
    var getColumnProps = function getColumnProps() {
        return $149bbf8d591193be$var$ColumnBase.getCProps(props.column);
    };
    var getColumnPTOptions = function getColumnPTOptions(key) {
        var cProps = getColumnProps();
        var columnMetaData = {
            props: cProps,
            parent: props.metaData,
            hostName: props.hostName,
            state: {
                styleObject: styleObjectState,
                editing: editingState,
                editingRowData: editingRowDataState
            },
            context: {
                index: props.index,
                size: props.metaData.props.size,
                showGridlines: props.metaData.props.showGridlines
            }
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(cProps, key, columnMetaData));
    };
    var field = getColumnProp("field") || "field_".concat(props.index);
    var editingKey = props.dataKey ? props.rowData && props.rowData[props.dataKey] || props.rowIndex : props.rowIndex;
    var isEditable = function isEditable() {
        return (0, $cfkGk.ObjectUtils).isNotEmpty(props.editMode) && getColumnProp("editor");
    };
    var cellEditValidateOnClose = function cellEditValidateOnClose() {
        return getColumnProp("cellEditValidateOnClose");
    };
    var _useEventListener = (0, $l2NC0.useEventListener)({
        type: "click",
        listener: function listener(e) {
            if (!selfClick.current && isOutsideClicked(e.target)) // #2666 for overlay components and outside is clicked
            setTimeout(function() {
                switchCellToViewMode(e, true);
            }, 0);
            selfClick.current = false;
        },
        options: true,
        when: isEditable()
    }), _useEventListener2 = $149bbf8d591193be$var$_slicedToArray(_useEventListener, 2), bindDocumentClickListener = _useEventListener2[0], unbindDocumentClickListener = _useEventListener2[1];
    var isSelected = function isSelected() {
        return props.selection ? props.selection instanceof Array ? findIndex(props.selection) > -1 : equals(props.selection) : false;
    };
    var equalsData = function equalsData(data) {
        return props.compareSelectionBy === "equals" ? data === props.rowData : (0, $cfkGk.ObjectUtils).equals(data, props.rowData, props.dataKey);
    };
    var equals = function equals(selectedCell) {
        return selectedCell && (selectedCell.rowIndex === props.rowIndex || equalsData(selectedCell.rowData)) && (selectedCell.field === field || selectedCell.cellIndex === props.index);
    };
    var isOutsideClicked = function isOutsideClicked(target) {
        return elementRef.current && !(elementRef.current.isSameNode(target) || elementRef.current.contains(target));
    };
    var getVirtualScrollerOption = function getVirtualScrollerOption(option) {
        return props.virtualScrollerOptions ? props.virtualScrollerOptions[option] : null;
    };
    var getStyle = function getStyle() {
        var bodyStyle = getColumnProp("bodyStyle");
        var columnStyle = getColumnProp("style");
        return getColumnProp("frozen") ? Object.assign({}, columnStyle, bodyStyle, styleObjectState) : Object.assign({}, columnStyle, bodyStyle);
    };
    var getCellParams = function getCellParams() {
        return {
            value: resolveFieldData(),
            field: field,
            rowData: props.rowData,
            rowIndex: props.rowIndex,
            cellIndex: props.index,
            selected: isSelected(),
            column: props.column,
            props: props
        };
    };
    var getCellCallbackParams = function getCellCallbackParams(event) {
        var params = getCellParams();
        return $149bbf8d591193be$var$_objectSpread$a({
            originalEvent: event
        }, params);
    };
    var resolveFieldData = function resolveFieldData(data) {
        return (0, $cfkGk.ObjectUtils).resolveFieldData(data || props.rowData, field);
    };
    var getEditingRowData = function getEditingRowData() {
        return props.editingMeta && props.editingMeta[editingKey] ? props.editingMeta[editingKey].data : props.rowData;
    };
    var getTabIndex = function getTabIndex(cellSelected) {
        return props.allowCellSelection ? cellSelected ? 0 : props.rowIndex === 0 && props.index === 0 ? props.tabIndex : -1 : null;
    };
    var findIndex = function findIndex(collection) {
        return (collection || []).findIndex(function(data) {
            return equals(data);
        });
    };
    var closeCell = function closeCell(event) {
        var params = getCellCallbackParams(event);
        var onBeforeCellEditHide = getColumnProp("onBeforeCellEditHide");
        if (onBeforeCellEditHide) onBeforeCellEditHide(params);
        /* When using the 'tab' key, the focus event of the next cell is not called in IE. */ setTimeout(function() {
            setEditingState(false);
            unbindDocumentClickListener();
            (0, $k7ffa.OverlayService).off("overlay-click", overlayEventListener.current);
            overlayEventListener.current = null;
            editingRowDataStateRef.current = null;
            selfClick.current = false;
        }, 1);
    };
    var switchCellToViewMode = function switchCellToViewMode(event, submit) {
        var callbackParams = getCellCallbackParams(event);
        var newRowData = $149bbf8d591193be$var$_objectSpread$a({}, editingRowDataStateRef.current);
        var newValue = resolveFieldData(newRowData);
        var params = $149bbf8d591193be$var$_objectSpread$a($149bbf8d591193be$var$_objectSpread$a({}, callbackParams), {}, {
            newRowData: newRowData,
            newValue: newValue
        });
        var onCellEditCancel = getColumnProp("onCellEditCancel");
        var cellEditValidator = getColumnProp("cellEditValidator");
        var onCellEditComplete = getColumnProp("onCellEditComplete");
        if (!submit && onCellEditCancel) onCellEditCancel(params);
        var valid = true;
        if ((!submit || cellEditValidateOnClose()) && cellEditValidator) valid = cellEditValidator(params);
        if (valid) {
            if (submit && onCellEditComplete) onCellEditComplete(params);
            closeCell(event);
        } else event.preventDefault();
        setEditingRowDataState(newRowData);
    };
    var findNextSelectableCell = function findNextSelectableCell(cell) {
        var nextCell = cell.nextElementSibling;
        return nextCell ? (0, $cfkGk.DomHandler).getAttribute(nextCell, "data-p-selectable-cell") ? nextCell : findNextSelectableCell(nextCell) : null;
    };
    var findPrevSelectableCell = function findPrevSelectableCell(cell) {
        var prevCell = cell.previousElementSibling;
        return prevCell ? (0, $cfkGk.DomHandler).getAttribute(prevCell, "data-p-selectable-cell") ? prevCell : findPrevSelectableCell(prevCell) : null;
    };
    var findDownSelectableCell = function findDownSelectableCell(cell) {
        var downRow = cell.parentElement.nextElementSibling;
        var downCell = downRow ? downRow.children[props.index] : null;
        return downRow && downCell ? (0, $cfkGk.DomHandler).getAttribute(downRow, "data-p-selectable-row") && (0, $cfkGk.DomHandler).getAttribute(downCell, "data-p-selectable-cell") ? downCell : findDownSelectableCell(downCell) : null;
    };
    var findUpSelectableCell = function findUpSelectableCell(cell) {
        var upRow = cell.parentElement.previousElementSibling;
        var upCell = upRow ? upRow.children[props.index] : null;
        return upRow && upCell ? (0, $cfkGk.DomHandler).getAttribute(upRow, "data-p-selectable-row") && (0, $cfkGk.DomHandler).getAttribute(upCell, "data-p-selectable-cell") ? upCell : findUpSelectableCell(upCell) : null;
    };
    var changeTabIndex = function changeTabIndex(currentCell, nextCell) {
        if (currentCell && nextCell) {
            currentCell.tabIndex = -1;
            nextCell.tabIndex = props.tabIndex;
        }
    };
    var focusOnElement = function focusOnElement() {
        if (editingState) {
            var focusableEl = props.editMode === "cell" ? (0, $cfkGk.DomHandler).getFirstFocusableElement(elementRef.current, ':not([data-pc-section="editorkeyhelperlabel"])') : (0, $cfkGk.DomHandler).findSingle(elementRef.current, '[data-p-row-editor-save="true"]');
            focusableEl && focusableEl.focus();
        }
        keyHelperRef.current && (keyHelperRef.current.tabIndex = editingState ? -1 : 0);
    };
    var focusOnInit = function focusOnInit() {
        clearTimeout(initFocusTimeout.current);
        initFocusTimeout.current = setTimeout(function() {
            var focusableEl = props.editMode === "row" ? (0, $cfkGk.DomHandler).findSingle(elementRef.current, '[data-p-row-editor-init="true"]') : null;
            focusableEl && focusableEl.focus();
        }, 1);
    };
    var updateStickyPosition = function updateStickyPosition() {
        if (getColumnProp("frozen")) {
            var styleObject = $149bbf8d591193be$var$_objectSpread$a({}, styleObjectState);
            var align = getColumnProp("alignFrozen");
            if (align === "right") {
                var right = 0;
                var next = elementRef.current && elementRef.current.nextElementSibling;
                if (next) right = (0, $cfkGk.DomHandler).getOuterWidth(next) + parseFloat(next.style.right || 0);
                styleObject.right = right + "px";
            } else {
                var left = 0;
                var prev = elementRef.current && elementRef.current.previousElementSibling;
                if (prev) left = (0, $cfkGk.DomHandler).getOuterWidth(prev) + parseFloat(prev.style.left || 0);
                styleObject.left = left + "px";
            }
            var isSameStyle = styleObjectState.left === styleObject.left && styleObjectState.right === styleObject.right;
            !isSameStyle && setStyleObjectState(styleObject);
        }
    };
    var editorCallback = function editorCallback(val) {
        var editingRowData = $149bbf8d591193be$var$_objectSpread$a({}, editingRowDataState);
        (0, $cfkGk.ObjectUtils).mutateFieldData(editingRowData, field, val);
        setEditingRowDataState(editingRowData);
        // update editing meta for complete methods on row mode
        var currentData = getEditingRowData();
        if (currentData) (0, $cfkGk.ObjectUtils).mutateFieldData(currentData, field, val);
        editingRowDataStateRef.current = editingRowData;
    };
    var _onClick = function onClick(event) {
        var params = getCellCallbackParams(event);
        if (props.editMode !== "row" && isEditable() && !editingState && (props.selectOnEdit || !props.selectOnEdit && props.selected)) {
            selfClick.current = true;
            var onBeforeCellEditShow = getColumnProp("onBeforeCellEditShow");
            var onCellEditInit = getColumnProp("onCellEditInit");
            var cellEditValidatorEvent = getColumnProp("cellEditValidatorEvent");
            if (onBeforeCellEditShow) {
                // if user returns false do not show the editor
                if (onBeforeCellEditShow(params) === false) return;
                // if user prevents default stop the editor
                if (event && event.defaultPrevented) return;
            }
            // If the data is sorted using sort icon, it has been added to wait for the sort operation when any cell is wanted to be opened.
            setTimeout(function() {
                setEditingState(true);
                if (onCellEditInit) {
                    if (onCellEditInit(params) === false) return;
                    // if user prevents default stop the editor
                    if (event && event.defaultPrevented) return;
                }
                if (cellEditValidatorEvent === "click") {
                    bindDocumentClickListener();
                    overlayEventListener.current = function(e) {
                        if (!isOutsideClicked(e.target)) selfClick.current = true;
                    };
                    (0, $k7ffa.OverlayService).on("overlay-click", overlayEventListener.current);
                }
            }, 1);
        }
        if (props.allowCellSelection && props.onClick) props.onClick(params);
    };
    var _onMouseDown = function onMouseDown(event) {
        var params = getCellCallbackParams(event);
        props.onMouseDown && props.onMouseDown(params);
    };
    var _onMouseUp = function onMouseUp(event) {
        var params = getCellCallbackParams(event);
        props.onMouseUp && props.onMouseUp(params);
    };
    var _onKeyDown = function onKeyDown(event) {
        if (props.editMode !== "row") {
            if (event.code === "Enter" || event.code === "NumpadEnter" || event.code === "Tab") switchCellToViewMode(event, true);
            if (event.code === "Escape") switchCellToViewMode(event, false);
        }
        if (props.allowCellSelection) {
            var target = event.target, cell = event.currentTarget;
            switch(event.code){
                case "ArrowLeft":
                    var prevCell = findPrevSelectableCell(cell);
                    if (prevCell) {
                        changeTabIndex(cell, prevCell);
                        prevCell.focus();
                    }
                    event.preventDefault();
                    break;
                case "ArrowRight":
                    var nextCell = findNextSelectableCell(cell);
                    if (nextCell) {
                        changeTabIndex(cell, nextCell);
                        nextCell.focus();
                    }
                    event.preventDefault();
                    break;
                case "ArrowUp":
                    var upCell = findUpSelectableCell(cell);
                    if (upCell) {
                        changeTabIndex(cell, upCell);
                        upCell.focus();
                    }
                    event.preventDefault();
                    break;
                case "ArrowDown":
                    var downCell = findDownSelectableCell(cell);
                    if (downCell) {
                        changeTabIndex(cell, downCell);
                        downCell.focus();
                    }
                    event.preventDefault();
                    break;
                case "Enter":
                case "NumpadEnter":
                    if (event.shiftKey || event.ctrlKey) ;
                    else if (!(0, $cfkGk.DomHandler).isClickable(target)) {
                        _onClick(event);
                        event.preventDefault();
                    }
                    break;
                case "Space":
                    if (!(0, $cfkGk.DomHandler).isClickable(target) && !target.readOnly) {
                        _onClick(event);
                        event.preventDefault();
                    }
                    break;
            }
        }
    };
    var _onBlur = function onBlur(event) {
        selfClick.current = false;
        if (props.editMode !== "row" && editingState && getColumnProp("cellEditValidatorEvent") === "blur") switchCellToViewMode(event, true);
    };
    var onEditorFocus = function onEditorFocus(event) {
        _onClick(event);
    };
    var onRadioChange = function onRadioChange(event) {
        props.onRadioChange({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var onCheckboxChange = function onCheckboxChange(event) {
        props.onCheckboxChange({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var onRowToggle = function onRowToggle(event) {
        props.onRowToggle({
            originalEvent: event,
            data: props.rowData
        });
        event.preventDefault();
        event.stopPropagation();
    };
    var onRowEditInit = function onRowEditInit(event) {
        props.onRowEditInit({
            originalEvent: event,
            data: props.rowData,
            newData: getEditingRowData(),
            field: field,
            index: props.rowIndex
        });
    };
    var onRowEditSave = function onRowEditSave(event) {
        props.onRowEditSave({
            originalEvent: event,
            data: props.rowData,
            newData: getEditingRowData(),
            field: field,
            index: props.rowIndex
        });
        focusOnInit();
    };
    var onRowEditCancel = function onRowEditCancel(event) {
        props.onRowEditCancel({
            originalEvent: event,
            data: props.rowData,
            newData: getEditingRowData(),
            field: field,
            index: props.rowIndex
        });
        focusOnInit();
    };
    $81g6h.useEffect(function() {
        if (getColumnProp("frozen")) updateStickyPosition();
        if (props.editMode === "cell" || props.editMode === "row") focusOnElement();
    });
    $81g6h.useEffect(function() {
        if (props.editMode === "row" && props.editing !== editingState) setEditingState(props.editing);
    }, [
        props.editMode,
        props.editing,
        editingState
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (props.editMode === "cell" || props.editMode === "row") {
            var editingRowData = getEditingRowData();
            setEditingRowDataState(editingRowData);
            editingRowDataStateRef.current = editingRowData;
        }
    }, [
        props.editingMeta
    ]);
    $81g6h.useEffect(function() {
        if (props.editMode === "cell" || props.editMode === "row") {
            var callbackParams = getCellCallbackParams();
            var params = $149bbf8d591193be$var$_objectSpread$a($149bbf8d591193be$var$_objectSpread$a({}, callbackParams), {}, {
                editing: editingState,
                editingKey: editingKey
            });
            props.onEditingMetaChange(params);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editingState
    ]);
    (0, $l2NC0.useUnmountEffect)(function() {
        if (overlayEventListener.current) {
            (0, $k7ffa.OverlayService).off("overlay-click", overlayEventListener.current);
            overlayEventListener.current = null;
        }
    });
    var createLoading = function createLoading() {
        var options = getVirtualScrollerOption("getLoaderOptions")(props.rowIndex, {
            cellIndex: props.index,
            cellFirst: props.index === 0,
            cellLast: props.index === getVirtualScrollerOption("columns").length - 1,
            cellEven: props.index % 2 === 0,
            cellOdd: props.index % 2 !== 0,
            column: props.column,
            field: field
        });
        var content = (0, $cfkGk.ObjectUtils).getJSXElement(getVirtualScrollerOption("loadingTemplate"), options);
        var bodyCellProps = mergeProps(getColumnPTOptions("bodyCell"), {
            role: "cell"
        });
        return /*#__PURE__*/ $81g6h.createElement("td", bodyCellProps, content);
    };
    var createElement = function createElement() {
        var content;
        var editorKeyHelper;
        var cellSelected = props.allowCellSelection && isSelected();
        var isRowEditor = props.editMode === "row";
        var tabIndex = getTabIndex(cellSelected);
        var selectionMode = getColumnProp("selectionMode");
        var rowReorder = getColumnProp("rowReorder");
        var header = getColumnProp("header");
        var body = getColumnProp("body");
        var editor = getColumnProp("editor");
        var frozen = getColumnProp("frozen");
        var align = getColumnProp("align");
        var value = resolveFieldData();
        var columnBodyOptions = {
            column: props.column,
            field: field,
            rowIndex: props.rowIndex,
            frozenRow: props.frozenRow,
            props: props.tableProps
        };
        var rowEditor = (0, $cfkGk.ObjectUtils).getPropValue(getColumnProp("rowEditor"), props.rowData, columnBodyOptions);
        var expander = (0, $cfkGk.ObjectUtils).getPropValue(getColumnProp("expander"), props.rowData, columnBodyOptions);
        var cellClassName = (0, $cfkGk.ObjectUtils).getPropValue(props.cellClassName, value, columnBodyOptions);
        var bodyClassName = (0, $cfkGk.ObjectUtils).getPropValue(getColumnProp("bodyClassName"), props.rowData, columnBodyOptions);
        var style = getStyle();
        var columnTitleProps = mergeProps({
            className: cx("columnTitle")
        }, getColumnPTOptions("columnTitle"));
        var title = props.responsiveLayout === "stack" && /*#__PURE__*/ $81g6h.createElement("span", columnTitleProps, (0, $cfkGk.ObjectUtils).getJSXElement(header, {
            props: props.tableProps
        }));
        if (selectionMode) {
            var showSelection = props.showSelectionElement ? props.showSelectionElement(props.rowData, {
                rowIndex: props.rowIndex,
                props: props.tableProps
            }) : true;
            var label;
            if (showSelection) {
                var ariaLabelField = props.selectionAriaLabel || props.tableProps.dataKey;
                var ariaLabelText = (0, $cfkGk.ObjectUtils).resolveFieldData(props.rowData, ariaLabelField);
                label = "".concat(props.selected ? (0, $8Zwsm.ariaLabel)("unselectRow") : (0, $8Zwsm.ariaLabel)("selectRow"), " ").concat(ariaLabelText);
            }
            content = showSelection && /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, selectionMode === "single" && /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$RowRadioButton, {
                hostName: props.hostName,
                column: props.column,
                checked: props.selected,
                disabled: !props.isSelectable({
                    data: props.rowData,
                    index: props.rowIndex
                }),
                onChange: onRadioChange,
                tabIndex: props.tabIndex,
                tableSelector: props.tableSelector,
                ariaLabel: label,
                ptCallbacks: props.ptCallbacks,
                metaData: props.metaData,
                unstyled: props.unstyled
            }), selectionMode === "multiple" && /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$RowCheckbox, {
                hostName: props.hostName,
                column: props.column,
                checked: props.selected,
                disabled: !props.isSelectable({
                    data: props.rowData,
                    index: props.rowIndex
                }),
                onChange: onCheckboxChange,
                tabIndex: props.tabIndex,
                ariaLabel: label,
                checkIcon: props.checkIcon,
                ptCallbacks: props.ptCallbacks,
                metaData: props.metaData,
                unstyled: props.unstyled
            }));
        } else if (rowReorder) {
            var showReorder = props.showRowReorderElement ? props.showRowReorderElement(props.rowData, {
                rowIndex: props.rowIndex,
                props: props.tableProps
            }) : true;
            var customIcon = getColumnProp("rowReorderIcon");
            var rowReorderIconProps = mergeProps({
                className: cx("rowReorderIcon")
            }, customIcon ? null : getColumnPTOptions("rowReorderIcon"));
            var rowReorderIcon = customIcon || /*#__PURE__*/ $81g6h.createElement((0, $6NeNe.BarsIcon), rowReorderIconProps);
            content = showReorder ? (0, $cfkGk.IconUtils).getJSXIcon(rowReorderIcon, $149bbf8d591193be$var$_objectSpread$a({}, rowReorderIconProps), {
                props: props
            }) : null;
        } else if (expander) {
            var rowTogglerIconProps = mergeProps({
                className: cx("rowTogglerIcon"),
                "aria-hidden": true
            }, getColumnPTOptions("rowTogglerIcon"));
            var icon = props.expanded ? props.expandedRowIcon || /*#__PURE__*/ $81g6h.createElement((0, $jhJol.ChevronDownIcon), rowTogglerIconProps) : props.collapsedRowIcon || /*#__PURE__*/ $81g6h.createElement((0, $gbrlA.ChevronRightIcon), rowTogglerIconProps);
            var togglerIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $149bbf8d591193be$var$_objectSpread$a({}, rowTogglerIconProps), {
                props: props
            });
            var ariaControls = "".concat(props.tableSelector, "_content_").concat(props.rowIndex, "_expanded");
            var _ariaLabelField = props.selectionAriaLabel || props.tableProps.dataKey;
            var _ariaLabelText = (0, $cfkGk.ObjectUtils).resolveFieldData(props.rowData, _ariaLabelField);
            var _label = "".concat(props.expanded ? (0, $8Zwsm.ariaLabel)("collapseLabel") : (0, $8Zwsm.ariaLabel)("expandLabel"), " ").concat(_ariaLabelText);
            var expanderProps = {
                onClick: onRowToggle,
                className: cx("rowToggler")
            };
            var rowTogglerProps = mergeProps($149bbf8d591193be$var$_objectSpread$a($149bbf8d591193be$var$_objectSpread$a({}, expanderProps), {}, {
                type: "button",
                "aria-expanded": props.expanded,
                "aria-controls": ariaControls,
                tabIndex: props.tabIndex,
                "aria-label": _label
            }), getColumnPTOptions("rowToggler"));
            content = /*#__PURE__*/ $81g6h.createElement("button", rowTogglerProps, togglerIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
            if (body) {
                expanderProps.element = content;
                content = (0, $cfkGk.ObjectUtils).getJSXElement(body, props.rowData, {
                    column: props.column,
                    field: field,
                    rowIndex: props.rowIndex,
                    frozenRow: props.frozenRow,
                    props: props.tableProps,
                    expander: expanderProps
                });
            }
        } else if (isRowEditor && rowEditor) {
            var rowEditorProps = {};
            var rowEditorSaveIconProps = mergeProps({
                className: cx("rowEditorSaveIcon")
            }, getColumnPTOptions("rowEditorSaveIcon"));
            var rowEditorCancelIconProps = mergeProps({
                className: cx("rowEditorCancelIcon")
            }, getColumnPTOptions("rowEditorCancelIcon"));
            var rowEditorInitIconProps = mergeProps({
                className: cx("rowEditorInitIcon")
            }, getColumnPTOptions("rowEditorInitIcon"));
            var rowEditorSaveIcon = (0, $cfkGk.IconUtils).getJSXIcon(props.rowEditorSaveIcon || /*#__PURE__*/ $81g6h.createElement((0, $h7Chj.CheckIcon), rowEditorSaveIconProps), $149bbf8d591193be$var$_objectSpread$a({}, rowEditorSaveIconProps), {
                props: props
            });
            var rowEditorCancelIcon = (0, $cfkGk.IconUtils).getJSXIcon(props.rowEditorCancelIcon || /*#__PURE__*/ $81g6h.createElement((0, $4vsYR.TimesIcon), rowEditorCancelIconProps), $149bbf8d591193be$var$_objectSpread$a({}, rowEditorCancelIconProps), {
                props: props
            });
            var rowEditorInitIcon = (0, $cfkGk.IconUtils).getJSXIcon(props.rowEditorInitIcon || /*#__PURE__*/ $81g6h.createElement((0, $icj7p.PencilIcon), rowEditorInitIconProps), $149bbf8d591193be$var$_objectSpread$a({}, rowEditorInitIconProps), {
                props: props
            });
            if (editingState) {
                rowEditorProps = {
                    editing: true,
                    onSaveClick: onRowEditSave,
                    saveClassName: cx("rowEditorSaveButton"),
                    onCancelClick: onRowEditCancel,
                    cancelClassName: cx("rowEditorCancelButton")
                };
                var rowEditorSaveButtonProps = mergeProps({
                    type: "button",
                    name: "row-save",
                    "aria-label": (0, $8Zwsm.ariaLabel)("saveEdit"),
                    onClick: rowEditorProps.onSaveClick,
                    className: rowEditorProps.saveClassName,
                    tabIndex: props.tabIndex,
                    "data-p-row-editor-save": true
                }, getColumnPTOptions("rowEditorSaveButton"));
                var rowEditorCancelButtonProps = mergeProps({
                    type: "button",
                    name: "row-cancel",
                    "aria-label": (0, $8Zwsm.ariaLabel)("cancelEdit"),
                    onClick: rowEditorProps.onCancelClick,
                    className: rowEditorProps.cancelClassName,
                    tabIndex: props.tabIndex
                }, getColumnPTOptions("rowEditorCancelButton"));
                content = /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("button", rowEditorSaveButtonProps, rowEditorSaveIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null)), /*#__PURE__*/ $81g6h.createElement("button", rowEditorCancelButtonProps, rowEditorCancelIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null)));
            } else {
                rowEditorProps = {
                    editing: false,
                    onInitClick: onRowEditInit,
                    initClassName: cx("rowEditorInitButton")
                };
                var rowEditorInitButtonProps = mergeProps({
                    type: "button",
                    name: "row-edit",
                    "aria-label": (0, $8Zwsm.ariaLabel)("editRow"),
                    onClick: rowEditorProps.onInitClick,
                    className: rowEditorProps.initClassName,
                    tabIndex: props.tabIndex,
                    "data-p-row-editor-init": true
                }, getColumnPTOptions("rowEditorInitButton"));
                content = /*#__PURE__*/ $81g6h.createElement("button", rowEditorInitButtonProps, rowEditorInitIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
            }
            if (body) {
                rowEditorProps.element = content;
                content = (0, $cfkGk.ObjectUtils).getJSXElement(body, props.rowData, {
                    column: props.column,
                    field: field,
                    rowIndex: props.rowIndex,
                    frozenRow: props.frozenRow,
                    props: props.tableProps,
                    rowEditor: rowEditorProps
                });
            }
        } else if (body && (!editingState || !editor)) content = body ? (0, $cfkGk.ObjectUtils).getJSXElement(body, props.rowData, {
            column: props.column,
            field: field,
            rowIndex: props.rowIndex,
            frozenRow: props.frozenRow,
            props: props.tableProps
        }) : value;
        else if (editor && editingState) content = (0, $cfkGk.ObjectUtils).getJSXElement(editor, {
            rowData: editingRowDataState,
            value: resolveFieldData(editingRowDataState),
            column: props.column,
            field: field,
            rowIndex: props.rowIndex,
            frozenRow: props.frozenRow,
            props: props.tableProps,
            editorCallback: editorCallback
        });
        else content = value;
        content = typeof content === "boolean" ? content.toString() : content;
        if (!isRowEditor && editor) {
            var editorKeyHelperProps = mergeProps({
                tabIndex: "0",
                className: "p-cell-editor-key-helper p-hidden-accessible",
                onFocus: function onFocus(e) {
                    return onEditorFocus(e);
                }
            }, getColumnPTOptions("editorKeyHelperLabel"));
            var editorKeyHelperLabelProps = mergeProps(getColumnPTOptions("editorKeyHelper"));
            /* eslint-disable */ editorKeyHelper = /*#__PURE__*/ $81g6h.createElement("a", $149bbf8d591193be$var$_extends({
                ref: keyHelperRef
            }, editorKeyHelperProps), /*#__PURE__*/ $81g6h.createElement("span", editorKeyHelperLabelProps));
        /* eslint-enable */ }
        var bodyCellProps = mergeProps({
            style: style,
            className: (0, $cfkGk.classNames)(bodyClassName, getColumnProp("className"), cellClassName, cx("bodyCell", {
                selectionMode: selectionMode,
                editor: editor,
                editingState: editingState,
                frozen: frozen,
                cellSelected: cellSelected,
                align: align,
                bodyProps: props,
                getCellParams: getCellParams
            })),
            rowSpan: props.rowSpan,
            tabIndex: tabIndex,
            role: "cell",
            onClick: function onClick(e) {
                return _onClick(e);
            },
            onKeyDown: function onKeyDown(e) {
                return _onKeyDown(e);
            },
            onBlur: function onBlur(e) {
                return _onBlur(e);
            },
            onMouseDown: function onMouseDown(e) {
                return _onMouseDown(e);
            },
            onMouseUp: function onMouseUp(e) {
                return _onMouseUp(e);
            },
            "data-p-selectable-cell": props.allowCellSelection && props.isSelectable({
                data: getCellParams(),
                index: props.rowIndex
            }),
            "data-p-selection-column": getColumnProp("selectionMode") != null,
            "data-p-editable-column": isEditable() != null,
            "data-p-cell-editing": editingState,
            "data-p-frozen-column": frozen
        }, getColumnPTOptions("root"), getColumnPTOptions("bodyCell"));
        return /*#__PURE__*/ $81g6h.createElement("td", $149bbf8d591193be$var$_extends({
            ref: elementRef
        }, bodyCellProps), editorKeyHelper, title, content);
    };
    return getVirtualScrollerOption("loading") ? createLoading() : createElement();
});
$149bbf8d591193be$var$BodyCell.displayName = "BodyCell";
function $149bbf8d591193be$var$ownKeys$9(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149bbf8d591193be$var$_objectSpread$9(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149bbf8d591193be$var$ownKeys$9(Object(t), !0).forEach(function(r) {
            $149bbf8d591193be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149bbf8d591193be$var$ownKeys$9(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149bbf8d591193be$var$BodyRow = /*#__PURE__*/ $81g6h.memo(function(props) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var _React$useState = $81g6h.useState(false), _React$useState2 = $149bbf8d591193be$var$_slicedToArray(_React$useState, 2), editingState = _React$useState2[0], setEditingState = _React$useState2[1];
    var editing = props.onRowEditChange ? props.editing : editingState;
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, cx = _props$ptCallbacks.cx;
    var getBodyRowPTOptions = function getBodyRowPTOptions(key) {
        return ptm(key, {
            parent: props.metaData,
            hostName: props.hostName,
            state: {
                editing: editing
            },
            context: {
                index: props.index,
                selectable: props.allowRowSelection && props.isSelectable({
                    data: props.rowData,
                    index: props.rowIndex
                }),
                selected: !props.allowCellSelection && props.selected || props.contextMenuSelected,
                stripedRows: props.metaData.props.stripedRows
            }
        });
    };
    var getColumnProp = function getColumnProp(column, name) {
        return $149bbf8d591193be$var$ColumnBase.getCProp(column, name);
    };
    var isFocusable = function isFocusable() {
        return props.selectionMode && props.selectionModeInColumn !== "single" && props.selectionModeInColumn !== "multiple";
    };
    var isGrouped = function isGrouped(column) {
        var columnField = getColumnProp(column, "field");
        if (props.groupRowsBy && columnField) return Array.isArray(props.groupRowsBy) ? props.groupRowsBy.indexOf(columnField) > -1 : props.groupRowsBy === columnField;
        return false;
    };
    var equals = function equals(data1, data2) {
        return props.compareSelectionBy === "equals" ? data1 === data2 : (0, $cfkGk.ObjectUtils).equals(data1, data2, props.dataKey);
    };
    var getTabIndex = function getTabIndex() {
        return isFocusable() && !props.allowCellSelection ? props.rowIndex === 0 ? props.tabIndex : -1 : null;
    };
    var findIndex = function findIndex(collection, rowData) {
        return (collection || []).findIndex(function(data) {
            return equals(rowData, data);
        });
    };
    var changeTabIndex = function changeTabIndex(currentRow, nextRow) {
        if (currentRow && nextRow) {
            currentRow.tabIndex = -1;
            nextRow.tabIndex = props.tabIndex;
        }
    };
    var findFirstSelectableRow = function findFirstSelectableRow(row) {
        var firstRow = (0, $cfkGk.DomHandler).findSingle(row.parentNode, "tr[data-p-selectable-row]");
        return firstRow ? firstRow : null;
    };
    var findNextSelectableRow = function findNextSelectableRow(row) {
        var nextRow = row.nextElementSibling;
        return nextRow ? (0, $cfkGk.DomHandler).getAttribute(nextRow, "data-p-selectable-row") === true ? nextRow : findNextSelectableRow(nextRow) : null;
    };
    var findPrevSelectableRow = function findPrevSelectableRow(row) {
        var prevRow = row.previousElementSibling;
        return prevRow ? (0, $cfkGk.DomHandler).getAttribute(prevRow, "data-p-selectable-row") === true ? prevRow : findPrevSelectableRow(prevRow) : null;
    };
    var findLastSelectableRow = function findLastSelectableRow(row) {
        var lastRow = (0, $cfkGk.DomHandler).findSingle(row.parentNode, "tr[data-p-selectable-row]:last-child");
        return lastRow ? lastRow : null;
    };
    var shouldRenderBodyCell = function shouldRenderBodyCell(value, column, i) {
        if (getColumnProp(column, "hidden")) return false;
        else if (props.rowGroupMode && props.rowGroupMode === "rowspan" && isGrouped(column)) {
            var prevRowData = value[i - 1];
            if (prevRowData) {
                var currentRowFieldData = (0, $cfkGk.ObjectUtils).resolveFieldData(value[i], getColumnProp(column, "field"));
                var previousRowFieldData = (0, $cfkGk.ObjectUtils).resolveFieldData(prevRowData, getColumnProp(column, "field"));
                return currentRowFieldData !== previousRowFieldData;
            }
        }
        return true;
    };
    var calculateRowGroupSize = function calculateRowGroupSize(value, column, index) {
        if (isGrouped(column)) {
            var currentRowFieldData = (0, $cfkGk.ObjectUtils).resolveFieldData(value[index], getColumnProp(column, "field"));
            var nextRowFieldData = currentRowFieldData;
            var groupRowSpan = 0;
            while(currentRowFieldData === nextRowFieldData){
                groupRowSpan++;
                var nextRowData = value[++index];
                if (nextRowData) nextRowFieldData = (0, $cfkGk.ObjectUtils).resolveFieldData(nextRowData, getColumnProp(column, "field"));
                else break;
            }
            return groupRowSpan === 1 ? null : groupRowSpan;
        }
        return null;
    };
    var _onClick = function onClick(event) {
        props.onRowClick({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onDoubleClick = function onDoubleClick(event) {
        props.onRowDoubleClick({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onPointerDown = function onPointerDown(event) {
        props.onRowPointerDown({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onPointerUp = function onPointerUp(event) {
        props.onRowPointerUp({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var onRightClick = function onRightClick(event) {
        props.onRowRightClick({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onMouseEnter = function onMouseEnter(event) {
        props.onRowMouseEnter({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onMouseLeave = function onMouseLeave(event) {
        props.onRowMouseLeave({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onTouchEnd = function onTouchEnd(event) {
        props.onRowTouchEnd(event);
    };
    var _onKeyDown = function onKeyDown(event) {
        if (isFocusable() && !props.allowCellSelection) {
            var target = event.target, row = event.currentTarget;
            switch(event.code){
                case "ArrowDown":
                    onArrowDownKey(row, event);
                    break;
                case "ArrowUp":
                    onArrowUpKey(row, event);
                    break;
                case "Home":
                    onHomeKey(row, event);
                    break;
                case "End":
                    onEndKey(row, event);
                    break;
                case "Enter":
                case "NumpadEnter":
                    onEnterKey(row, event, target);
                    break;
                case "Space":
                    onSpaceKey(row, event, target);
                    break;
                case "Tab":
                    onTabKey(row, event);
                    break;
            }
        }
    };
    var onArrowDownKey = function onArrowDownKey(row, event) {
        var nextRow = findNextSelectableRow(row);
        if (nextRow) {
            changeTabIndex(row, nextRow);
            nextRow.focus();
        }
        event.preventDefault();
    };
    var onArrowUpKey = function onArrowUpKey(row, event) {
        var prevRow = findPrevSelectableRow(row);
        if (prevRow) {
            changeTabIndex(row, prevRow);
            prevRow.focus();
        }
        event.preventDefault();
    };
    var onHomeKey = function onHomeKey(row, event) {
        var firstRow = findFirstSelectableRow(row);
        if (firstRow) {
            changeTabIndex(row, firstRow);
            firstRow.focus();
        }
        event.preventDefault();
    };
    var onEndKey = function onEndKey(row, event) {
        var lastRow = findLastSelectableRow(row);
        if (lastRow) {
            changeTabIndex(row, lastRow);
            lastRow.focus();
        }
        event.preventDefault();
    };
    var onEnterKey = function onEnterKey(row, event, target) {
        if (!(0, $cfkGk.DomHandler).isClickable(target)) {
            _onClick(event);
            event.preventDefault();
        }
    };
    var onSpaceKey = function onSpaceKey(row, event, target) {
        if (!(0, $cfkGk.DomHandler).isClickable(target) && !target.readOnly) {
            _onClick(event);
            event.preventDefault();
        }
    };
    var onTabKey = function onTabKey(row, event) {
        var parent = row.parentNode;
        var rows = (0, $cfkGk.DomHandler).find(parent, 'tr[data-p-selectable-row="true"]');
        if (event.code === "Tab" && rows && rows.length > 0) {
            var firstSelectedRow = (0, $cfkGk.DomHandler).findSingle(parent, 'tr[data-p-highlight="true"]');
            var focusedItem = (0, $cfkGk.DomHandler).findSingle(parent, 'tr[data-p-selectable-row="true"][tabindex="0"]');
            if (firstSelectedRow) {
                firstSelectedRow.tabIndex = "0";
                focusedItem && focusedItem !== firstSelectedRow && (focusedItem.tabIndex = "-1");
            } else {
                rows[0].tabIndex = "0";
                focusedItem !== rows[0] && (rows[props.rowIndex].tabIndex = "-1");
            }
        }
    };
    var _onMouseDown = function onMouseDown(event) {
        props.onRowMouseDown({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onMouseUp = function onMouseUp(event) {
        props.onRowMouseUp({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onDragStart = function onDragStart(event) {
        props.onRowDragStart({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onDragOver = function onDragOver(event) {
        props.onRowDragOver({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onDragLeave = function onDragLeave(event) {
        props.onRowDragLeave({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onDragEnd = function onDragEnd(event) {
        props.onRowDragEnd({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var _onDrop = function onDrop(event) {
        props.onRowDrop({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
    };
    var onEditChange = function onEditChange(e, isEditing) {
        if (props.onRowEditChange) {
            var editingRows;
            var dataKey = props.dataKey;
            var originalEvent = e.originalEvent, data = e.data, index = e.index, newData = e.newData;
            if (dataKey) {
                var dataKeyValue = String((0, $cfkGk.ObjectUtils).resolveFieldData(data, dataKey));
                editingRows = props.editingRows ? $149bbf8d591193be$var$_objectSpread$9({}, props.editingRows) : {};
                if (!isEditing) {
                    delete editingRows[dataKeyValue];
                    // if the key value was changed, stop editing for the new key value too
                    var newDataKeyValue = String((0, $cfkGk.ObjectUtils).resolveFieldData(newData, dataKey));
                    delete editingRows[newDataKeyValue];
                } else editingRows[dataKeyValue] = true;
            } else {
                var editingRowIndex = findIndex(props.editingRows, data);
                editingRows = props.editingRows ? $149bbf8d591193be$var$_toConsumableArray(props.editingRows) : [];
                if (editingRowIndex !== -1) editingRows = editingRows.filter(function(val, i) {
                    return i !== editingRowIndex;
                });
                else editingRows.push(data);
            }
            props.onRowEditChange({
                originalEvent: originalEvent,
                data: editingRows,
                index: index
            });
        } else setEditingState(isEditing);
    };
    var onEditInit = function onEditInit(e) {
        var event = e.originalEvent;
        if (props.onRowEditInit) props.onRowEditInit({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
        onEditChange(e, true);
        event.preventDefault();
    };
    var onEditSave = function onEditSave(e) {
        var event = e.originalEvent, newData = e.newData;
        var valid = props.rowEditValidator ? props.rowEditValidator(newData, {
            props: props.tableProps,
            rowIndex: props.rowIndex
        }) : true;
        if (props.onRowEditSave) props.onRowEditSave({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex,
            newData: newData,
            valid: valid
        });
        if (valid) {
            if (props.onRowEditComplete) props.onRowEditComplete(e);
            onEditChange(e, false);
        }
        event.preventDefault();
    };
    var onEditCancel = function onEditCancel(e) {
        var event = e.originalEvent;
        if (props.onRowEditCancel) props.onRowEditCancel({
            originalEvent: event,
            data: props.rowData,
            index: props.rowIndex
        });
        onEditChange(e, false);
        event.preventDefault();
    };
    var createContent = function createContent() {
        return props.columns.map(function(col, i) {
            if (shouldRenderBodyCell(props.value, col, props.index)) {
                var key = "".concat(props.rowIndex, "_").concat(getColumnProp(col, "columnKey") || getColumnProp(col, "field"), "_").concat(i);
                var rowSpan = props.rowGroupMode === "rowspan" ? calculateRowGroupSize(props.value, col, props.index) : null;
                return /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$BodyCell, {
                    hostName: props.hostName,
                    key: key,
                    allowCellSelection: props.allowCellSelection,
                    cellClassName: props.cellClassName,
                    checkIcon: props.checkIcon,
                    collapsedRowIcon: props.collapsedRowIcon,
                    column: col,
                    compareSelectionBy: props.compareSelectionBy,
                    dataKey: props.dataKey,
                    editMode: props.editMode,
                    editing: editing,
                    editingMeta: props.editingMeta,
                    expanded: props.expanded,
                    expandedRowIcon: props.expandedRowIcon,
                    frozenRow: props.frozenRow,
                    index: i,
                    isSelectable: props.isSelectable,
                    onCheckboxChange: props.onCheckboxChange,
                    onClick: props.onCellClick,
                    onEditingMetaChange: props.onEditingMetaChange,
                    onMouseDown: props.onCellMouseDown,
                    onMouseUp: props.onCellMouseUp,
                    onRadioChange: props.onRadioChange,
                    onRowEditCancel: onEditCancel,
                    onRowEditInit: onEditInit,
                    onRowEditSave: onEditSave,
                    onRowToggle: props.onRowToggle,
                    responsiveLayout: props.responsiveLayout,
                    rowData: props.rowData,
                    rowEditorCancelIcon: props.rowEditorCancelIcon,
                    rowEditorInitIcon: props.rowEditorInitIcon,
                    rowEditorSaveIcon: props.rowEditorSaveIcon,
                    rowIndex: props.rowIndex,
                    rowSpan: rowSpan,
                    selectOnEdit: props.selectOnEdit,
                    selected: props.selected,
                    selection: props.selection,
                    selectionAriaLabel: props.tableProps.selectionAriaLabel,
                    showRowReorderElement: props.showRowReorderElement,
                    showSelectionElement: props.showSelectionElement,
                    tabIndex: props.tabIndex,
                    tableProps: props.tableProps,
                    tableSelector: props.tableSelector,
                    value: props.value,
                    virtualScrollerOptions: props.virtualScrollerOptions,
                    ptCallbacks: props.ptCallbacks,
                    metaData: props.metaData,
                    unstyled: props.unstyled
                });
            }
            return null;
        });
    };
    var rowClassName = (0, $cfkGk.ObjectUtils).getPropValue(props.rowClassName, props.rowData, {
        props: props.tableProps
    });
    var style = {
        height: props.virtualScrollerOptions ? props.virtualScrollerOptions.itemSize : undefined
    };
    var content = createContent();
    var tabIndex = getTabIndex();
    var rowProps = mergeProps({
        role: "row",
        tabIndex: tabIndex,
        className: (0, $cfkGk.classNames)(cx("bodyRow", {
            rowProps: props
        })),
        style: style,
        onMouseDown: function onMouseDown(e) {
            return _onMouseDown(e);
        },
        onMouseUp: function onMouseUp(e) {
            return _onMouseUp(e);
        },
        onMouseEnter: function onMouseEnter(e) {
            return _onMouseEnter(e);
        },
        onMouseLeave: function onMouseLeave(e) {
            return _onMouseLeave(e);
        },
        onClick: function onClick(e) {
            return _onClick(e);
        },
        onDoubleClick: function onDoubleClick(e) {
            return _onDoubleClick(e);
        },
        onPointerDown: function onPointerDown(e) {
            return _onPointerDown(e);
        },
        onPointerUp: function onPointerUp(e) {
            return _onPointerUp(e);
        },
        onContextMenu: function onContextMenu(e) {
            return onRightClick(e);
        },
        onTouchEnd: function onTouchEnd(e) {
            return _onTouchEnd(e);
        },
        onKeyDown: function onKeyDown(e) {
            return _onKeyDown(e);
        },
        onDragStart: function onDragStart(e) {
            return _onDragStart(e);
        },
        onDragOver: function onDragOver(e) {
            return _onDragOver(e);
        },
        onDragLeave: function onDragLeave(e) {
            return _onDragLeave(e);
        },
        onDragEnd: function onDragEnd(e) {
            return _onDragEnd(e);
        },
        onDrop: function onDrop(e) {
            return _onDrop(e);
        },
        "aria-selected": props !== null && props !== void 0 && props.selectionMode ? props.selected : null,
        "data-p-selectable-row": props.allowRowSelection && props.isSelectable({
            data: props.rowData,
            index: props.rowIndex
        }),
        "data-p-highlight": props.selected,
        "data-p-highlight-contextmenu": props.contextMenuSelected
    }, getBodyRowPTOptions("bodyRow"), {
        className: (0, $cfkGk.classNames)(rowClassName) // #5983 must be last so all unstyled merging takes place first
    });
    return /*#__PURE__*/ $81g6h.createElement("tr", rowProps, content);
});
$149bbf8d591193be$var$BodyRow.displayName = "BodyRow";
function $149bbf8d591193be$var$ownKeys$8(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149bbf8d591193be$var$_objectSpread$8(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149bbf8d591193be$var$ownKeys$8(Object(t), !0).forEach(function(r) {
            $149bbf8d591193be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149bbf8d591193be$var$ownKeys$8(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149bbf8d591193be$var$RowTogglerButton = /*#__PURE__*/ $81g6h.memo(function(props) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var _onClick = function onClick(event) {
        props.onClick({
            originalEvent: event,
            data: props.rowData
        });
    };
    var getColumnProps = function getColumnProps() {
        return $149bbf8d591193be$var$ColumnBase.getCProps(props.column);
    };
    var getColumnPTOptions = function getColumnPTOptions(key) {
        var cProps = getColumnProps();
        var columnMetaData = {
            props: getColumnProps(),
            parent: props.metaData,
            hostName: props.hostName
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(cProps, key, columnMetaData));
    };
    var rowGroupTogglerIconProps = mergeProps({
        className: cx("rowGroupTogglerIcon"),
        "aria-hidden": true
    }, getColumnPTOptions("rowGroupTogglerIcon"));
    var icon = props.expanded ? props.expandedRowIcon || /*#__PURE__*/ $81g6h.createElement((0, $jhJol.ChevronDownIcon), rowGroupTogglerIconProps) : props.collapsedRowIcon || /*#__PURE__*/ $81g6h.createElement((0, $gbrlA.ChevronRightIcon), rowGroupTogglerIconProps);
    var togglerIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $149bbf8d591193be$var$_objectSpread$8({}, rowGroupTogglerIconProps), {
        props: props
    });
    var label = props.expanded ? (0, $8Zwsm.ariaLabel)("collapseLabel") : (0, $8Zwsm.ariaLabel)("expandLabel");
    var rowGroupTogglerProps = mergeProps({
        type: "button",
        onClick: function onClick(e) {
            return _onClick(e);
        },
        className: cx("rowGroupToggler"),
        tabIndex: props.tabIndex,
        "aria-label": label
    }, getColumnPTOptions("rowGroupToggler"));
    return /*#__PURE__*/ $81g6h.createElement("button", rowGroupTogglerProps, togglerIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
});
$149bbf8d591193be$var$RowTogglerButton.displayName = "RowTogglerButton";
var $149bbf8d591193be$var$_excluded = [
    "originalEvent"
];
function $149bbf8d591193be$var$ownKeys$7(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149bbf8d591193be$var$_objectSpread$7(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149bbf8d591193be$var$ownKeys$7(Object(t), !0).forEach(function(r) {
            $149bbf8d591193be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149bbf8d591193be$var$ownKeys$7(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149bbf8d591193be$var$TableBody = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(props, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx, isUnsyled = _props$ptCallbacks.isUnsyled;
    var _React$useState = $81g6h.useState({}), _React$useState2 = $149bbf8d591193be$var$_slicedToArray(_React$useState, 2), rowGroupHeaderStyleObjectState = _React$useState2[0], setRowGroupHeaderStyleObjectState = _React$useState2[1];
    var getColumnProps = function getColumnProps(column) {
        return $149bbf8d591193be$var$ColumnBase.getCProps(column);
    };
    var getColumnPTOptions = function getColumnPTOptions(key) {
        var cProps = getColumnProps(props.column);
        var columnMetaData = {
            props: cProps,
            parent: props.metaData,
            hostName: props.hostName,
            state: {
                rowGroupHeaderStyleObject: rowGroupHeaderStyleObjectState
            }
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(cProps, key, columnMetaData));
    };
    var elementRef = $81g6h.useRef(null);
    var refCallback = $81g6h.useCallback(function(el) {
        elementRef.current = el;
        props.virtualScrollerContentRef && props.virtualScrollerContentRef(el);
    }, [
        props
    ]);
    var dragSelectionHelper = $81g6h.useRef(null);
    var initialDragPosition = $81g6h.useRef(null);
    var anchorRowIndex = $81g6h.useRef(null);
    var anchorCellIndex = $81g6h.useRef(null);
    var rangeRowIndex = $81g6h.useRef(null);
    var anchorRowFirst = $81g6h.useRef(null);
    var rowTouched = $81g6h.useRef(false);
    var rowDragging = $81g6h.useRef(false);
    var draggedRowIndex = $81g6h.useRef(null);
    var droppedRowIndex = $81g6h.useRef(null);
    var isSubheaderGrouping = props.rowGroupMode && props.rowGroupMode === "subheader";
    var isRadioSelectionMode = props.selectionMode === "radiobutton";
    var isCheckboxSelectionMode = props.selectionMode === "checkbox";
    var isRadioSelectionModeInColumn = props.selectionModeInColumn === "single";
    var isCheckboxSelectionModeInColumn = props.selectionModeInColumn === "multiple";
    var equals = function equals(data1, data2) {
        if (allowCellSelection()) return (data1.rowIndex === data2.rowIndex || data1.rowData === data2.rowData) && (data1.field === data2.field || data1.cellIndex === data2.cellIndex);
        return props.compareSelectionBy === "equals" ? data1 === data2 : (0, $cfkGk.ObjectUtils).equals(data1, data2, props.dataKey);
    };
    var isSelectionEnabled = function isSelectionEnabled() {
        return props.selectionMode || props.selectionModeInColumn !== null || props.columns && props.columns.some(function(col) {
            return col && !!getColumnProp(col, "selectionMode");
        });
    };
    var isSingleSelection = function isSingleSelection() {
        return props.selectionMode === "single" && !isCheckboxSelectionModeInColumn || !isRadioSelectionMode && isRadioSelectionModeInColumn;
    };
    var isMultipleSelection = function isMultipleSelection() {
        return props.selectionMode === "multiple" && !isRadioSelectionModeInColumn || isCheckboxSelectionModeInColumn;
    };
    var isRadioOnlySelection = function isRadioOnlySelection() {
        return isRadioSelectionMode && isRadioSelectionModeInColumn;
    };
    var isCheckboxOnlySelection = function isCheckboxOnlySelection() {
        return isCheckboxSelectionMode && isCheckboxSelectionModeInColumn;
    };
    var isSelected = function isSelected(rowData) {
        if (rowData && props.selection) return props.selection instanceof Array ? findIndex(props.selection, rowData) > -1 : equals(rowData, props.selection);
        return false;
    };
    var isContextMenuSelected = function isContextMenuSelected(rowData) {
        if (rowData && props.contextMenuSelection) return equals(rowData, props.contextMenuSelection);
        return false;
    };
    var isSelectable = function isSelectable(options) {
        return props.isDataSelectable ? props.isDataSelectable(options) : true;
    };
    var isRowExpanded = function isRowExpanded(rowData) {
        if (rowData && props.expandedRows) {
            if (isSubheaderGrouping && props.expandableRowGroups) return isRowGroupExpanded(rowData);
            if (props.dataKey) {
                var rowId = (0, $cfkGk.ObjectUtils).resolveFieldData(rowData, props.dataKey);
                var expanded = false;
                if (props.expandedRows) {
                    if (Array.isArray(props.expandedRows)) expanded = props.expandedRows.some(function(row) {
                        return (0, $cfkGk.ObjectUtils).resolveFieldData(row, props.dataKey) === rowId;
                    });
                    else expanded = props.expandedRows[rowId] !== undefined;
                }
                return expanded;
            }
            return findIndex(props.expandedRows, rowData) !== -1;
        }
        return false;
    };
    var isRowGroupExpanded = function isRowGroupExpanded(rowData) {
        if (props.dataKey === props.groupRowsBy) return Object.keys(props.expandedRows).some(function(data) {
            return (0, $cfkGk.ObjectUtils).equals(data, (0, $cfkGk.ObjectUtils).resolveFieldData(rowData, props.dataKey));
        });
        return props.expandedRows.some(function(data) {
            return (0, $cfkGk.ObjectUtils).equals(data, rowData, props.groupRowsBy);
        });
    };
    var isRowEditing = function isRowEditing(rowData) {
        if (props.editMode === "row" && rowData && props.editingRows) {
            if (props.dataKey) return props.editingRows ? props.editingRows[(0, $cfkGk.ObjectUtils).resolveFieldData(rowData, props.dataKey)] !== undefined : false;
            return findIndex(props.editingRows, rowData) !== -1;
        }
        return false;
    };
    var allowDrag = function allowDrag(event) {
        return props.dragSelection && isMultipleSelection() && !event.originalEvent.shiftKey;
    };
    var allowRowDrag = function allowRowDrag(event) {
        return !allowCellSelection() && allowDrag(event) || props.reorderableRows;
    };
    var allowCellDrag = function allowCellDrag(event) {
        return allowCellSelection() && allowDrag(event);
    };
    var allowSelection = function allowSelection(event) {
        return !(0, $cfkGk.DomHandler).isClickable(event.originalEvent.target);
    };
    var allowMetaKeySelection = function allowMetaKeySelection(event) {
        return !rowTouched.current && (!props.metaKeySelection || props.metaKeySelection && (event.originalEvent.metaKey || event.originalEvent.ctrlKey));
    };
    var allowRangeSelection = function allowRangeSelection(event) {
        return isMultipleSelection() && event.originalEvent.shiftKey && anchorRowIndex.current !== null;
    };
    var allowRowSelection = function allowRowSelection() {
        return (props.selectionMode || props.selectionModeInColumn) && !isRadioOnlySelection() && !isCheckboxOnlySelection();
    };
    var allowCellSelection = function allowCellSelection() {
        return props.cellSelection && !isRadioSelectionModeInColumn && !isCheckboxSelectionModeInColumn;
    };
    var getColumnsLength = function getColumnsLength() {
        return props.columns ? props.columns.length : 0;
    };
    var getColumnProp = function getColumnProp(column, name) {
        return $149bbf8d591193be$var$ColumnBase.getCProp(column, name);
    };
    var getVirtualScrollerOption = function getVirtualScrollerOption(option, options) {
        options = options || props.virtualScrollerOptions;
        return options ? options[option] : null;
    };
    var findIndex = function findIndex(collection, rowData) {
        return (collection || []).findIndex(function(data) {
            return equals(rowData, data);
        });
    };
    var rowGroupHeaderStyle = function rowGroupHeaderStyle() {
        if (props.scrollable) return {
            top: rowGroupHeaderStyleObjectState.top
        };
        return null;
    };
    var getRowKey = function getRowKey(rowData, index) {
        return props.dataKey ? (0, $cfkGk.ObjectUtils).resolveFieldData(rowData, props.dataKey) : index;
    };
    var shouldRenderRowGroupHeader = function shouldRenderRowGroupHeader(value, rowData, i) {
        var currentRowFieldData = (0, $cfkGk.ObjectUtils).resolveFieldData(rowData, props.groupRowsBy);
        var prevRowData = value[i - 1];
        if (prevRowData) {
            var previousRowFieldData = (0, $cfkGk.ObjectUtils).resolveFieldData(prevRowData, props.groupRowsBy);
            return !(0, $cfkGk.ObjectUtils).deepEquals(currentRowFieldData, previousRowFieldData);
        }
        return true;
    };
    var shouldRenderRowGroupFooter = function shouldRenderRowGroupFooter(value, rowData, i, expanded) {
        if (props.expandableRowGroups && !expanded) return false;
        var currentRowFieldData = (0, $cfkGk.ObjectUtils).resolveFieldData(rowData, props.groupRowsBy);
        var nextRowData = value[i + 1];
        if (nextRowData) {
            var nextRowFieldData = (0, $cfkGk.ObjectUtils).resolveFieldData(nextRowData, props.groupRowsBy);
            return !(0, $cfkGk.ObjectUtils).deepEquals(currentRowFieldData, nextRowFieldData);
        }
        return true;
    };
    var updateFrozenRowStickyPosition = function updateFrozenRowStickyPosition() {
        elementRef.current.style.top = (0, $cfkGk.DomHandler).getOuterHeight(elementRef.current.previousElementSibling) + "px";
    };
    var updateFrozenRowGroupHeaderStickyPosition = function updateFrozenRowGroupHeaderStickyPosition() {
        var tableHeaderHeight = (0, $cfkGk.DomHandler).getOuterHeight(elementRef.current.previousElementSibling);
        var top = tableHeaderHeight + "px";
        if (rowGroupHeaderStyleObjectState.top !== top) setRowGroupHeaderStyleObjectState({
            top: top
        });
    };
    var onSingleSelection = function onSingleSelection(_ref) {
        var originalEvent = _ref.originalEvent, data = _ref.data, index = _ref.index, toggleable = _ref.toggleable, type = _ref.type;
        if (!isSelectable({
            data: data,
            index: index
        })) return;
        var selected = isSelected(data);
        var selection = props.selection;
        if (selected) {
            if (toggleable) {
                selection = null;
                onUnselect({
                    originalEvent: originalEvent,
                    data: data,
                    type: type
                });
            }
        } else {
            selection = data;
            onSelect({
                originalEvent: originalEvent,
                data: data,
                type: type
            });
        }
        focusOnElement(originalEvent, true);
        if (props.onSelectionChange && selection !== props.selection) props.onSelectionChange({
            originalEvent: originalEvent,
            value: selection,
            type: type
        });
    };
    var onMultipleSelection = function onMultipleSelection(_ref2) {
        var originalEvent = _ref2.originalEvent, data = _ref2.data, index = _ref2.index, toggleable = _ref2.toggleable, type = _ref2.type;
        if (!isSelectable({
            data: data,
            index: index
        })) return;
        var selected = isSelected(data);
        var selection = props.selection || [];
        if (selected) {
            if (toggleable) {
                var selectionIndex = findIndex(selection, data);
                selection = props.selection.filter(function(val, i) {
                    return i !== selectionIndex;
                });
                onUnselect({
                    originalEvent: originalEvent,
                    data: data,
                    type: type
                });
            } else if (selection.length) {
                props.selection.forEach(function(d) {
                    return onUnselect({
                        originalEvent: originalEvent,
                        data: d,
                        type: type
                    });
                });
                selection = [
                    data
                ];
                onSelect({
                    originalEvent: originalEvent,
                    data: data,
                    type: type
                });
            }
        } else {
            selection = (0, $cfkGk.ObjectUtils).isObject(selection) ? [
                selection
            ] : selection;
            selection = toggleable && isMultipleSelection() ? [].concat($149bbf8d591193be$var$_toConsumableArray(selection), [
                data
            ]) : [
                data
            ];
            onSelect({
                originalEvent: originalEvent,
                data: data,
                type: type
            });
        }
        if (props.onSelectionChange && selection !== props.selection) props.onSelectionChange({
            originalEvent: originalEvent,
            value: selection,
            type: type
        });
    };
    var onRangeSelection = function onRangeSelection(event, type) {
        (0, $cfkGk.DomHandler).clearSelection();
        rangeRowIndex.current = allowCellSelection() ? event.rowIndex : event.index;
        var selection = selectRange(event);
        if (props.onSelectionChange && selection !== props.selection) props.onSelectionChange({
            originalEvent: event.originalEvent,
            value: selection,
            type: type
        });
        anchorRowIndex.current = rangeRowIndex.current;
        anchorCellIndex.current = event.cellIndex;
    };
    var selectRange = function selectRange(event) {
        var rangeStart;
        var rangeEnd;
        var selectedSize;
        var isAllowCellSelection = allowCellSelection();
        var index = (0, $cfkGk.ObjectUtils).findIndexInList(event.data, props.value, props.dataKey);
        if (rangeRowIndex.current > anchorRowIndex.current) {
            rangeStart = anchorRowIndex.current;
            rangeEnd = rangeRowIndex.current;
            if (!isAllowCellSelection) {
                selectedSize = rangeEnd - rangeStart;
                rangeEnd = index;
                rangeStart = index - selectedSize;
            }
        } else if (rangeRowIndex.current < anchorRowIndex.current) {
            rangeStart = rangeRowIndex.current;
            rangeEnd = anchorRowIndex.current;
            if (!isAllowCellSelection) {
                selectedSize = rangeEnd - rangeStart;
                rangeStart = index;
                rangeEnd = index + selectedSize;
            }
        } else rangeStart = rangeEnd = rangeRowIndex.current;
        return isAllowCellSelection ? selectRangeOnCell(event, rangeStart, rangeEnd) : selectRangeOnRow(event, rangeStart, rangeEnd);
    };
    var selectRangeOnRow = function selectRangeOnRow(event, rowRangeStart, rowRangeEnd) {
        var value = props.value;
        var selection = [];
        for(var i = rowRangeStart; i <= rowRangeEnd; i++){
            var rangeRowData = value[i];
            if (!isSelectable({
                data: rangeRowData,
                index: i
            })) continue;
            selection.push(rangeRowData);
            onSelect({
                originalEvent: event.originalEvent,
                data: rangeRowData,
                type: "row"
            });
        }
        return selection;
    };
    var selectRangeOnCell = function selectRangeOnCell(event, rowRangeStart, rowRangeEnd) {
        var cellRangeStart;
        var cellRangeEnd;
        var cellIndex = event.cellIndex;
        if (cellIndex > anchorCellIndex.current) {
            cellRangeStart = anchorCellIndex.current;
            cellRangeEnd = cellIndex;
        } else if (cellIndex < anchorCellIndex.current) {
            cellRangeStart = cellIndex;
            cellRangeEnd = anchorCellIndex.current;
        } else cellRangeStart = cellRangeEnd = cellIndex;
        var value = props.value;
        var selection = [];
        for(var i = rowRangeStart; i <= rowRangeEnd; i++){
            var rowData = value[i];
            var columns = props.columns;
            var rowIndex = props.paginator ? i + props.first : i;
            for(var j = cellRangeStart; j <= cellRangeEnd; j++){
                var field = getColumnProp(columns[j], "field");
                var _value = (0, $cfkGk.ObjectUtils).resolveFieldData(rowData, field);
                var rangeRowData = {
                    value: _value,
                    field: field,
                    rowData: rowData,
                    rowIndex: rowIndex,
                    cellIndex: j,
                    selected: true
                };
                if (!isSelectable({
                    data: rangeRowData,
                    index: i
                })) continue;
                selection.push(rangeRowData);
                onSelect({
                    originalEvent: event.originalEvent,
                    data: rangeRowData,
                    type: "cell"
                });
            }
        }
        return selection;
    };
    var onSelect = function onSelect(event) {
        if (allowCellSelection()) props.onCellSelect && props.onCellSelect($149bbf8d591193be$var$_objectSpread$7($149bbf8d591193be$var$_objectSpread$7({
            originalEvent: event.originalEvent
        }, event.data), {}, {
            type: event.type
        }));
        else props.onRowSelect && props.onRowSelect(event);
    };
    var onUnselect = function onUnselect(event) {
        if (allowCellSelection()) props.onCellUnselect && props.onCellUnselect($149bbf8d591193be$var$_objectSpread$7($149bbf8d591193be$var$_objectSpread$7({
            originalEvent: event.originalEvent
        }, event.data), {}, {
            type: event.type
        }));
        else props.onRowUnselect && props.onRowUnselect(event);
    };
    var enableDragSelection = function enableDragSelection(event) {
        if (props.dragSelection && !dragSelectionHelper.current) {
            dragSelectionHelper.current = document.createElement("div");
            dragSelectionHelper.current.setAttribute("p-datatable-drag-selection-helper", "true");
            !isUnsyled && (0, $cfkGk.DomHandler).addClass(dragSelectionHelper.current, "p-datatable-drag-selection-helper");
            initialDragPosition.current = {
                x: event.clientX,
                y: event.clientY
            };
            dragSelectionHelper.current.style.top = "".concat(event.pageY, "px");
            dragSelectionHelper.current.style.left = "".concat(event.pageX, "px");
            bindDragSelectionEvents();
        }
    };
    var focusOnElement = function focusOnElement(event, isFocused) {
        var target = event.currentTarget;
        if (!allowCellSelection() && props.selectionAutoFocus) {
            if (isCheckboxSelectionModeInColumn) {
                var checkbox = (0, $cfkGk.DomHandler).findSingle(target, 'td[data-p-selection-column="true"] [data-pc-section="checkbox"]');
                checkbox && checkbox.focus();
            } else if (isRadioSelectionModeInColumn) {
                var radio = (0, $cfkGk.DomHandler).findSingle(target, 'td[data-p-selection-column="true"] input[type="radio"]');
                radio && radio.focus();
            }
        }
        !isFocused && target && target.focus();
    };
    var changeTabIndex = function changeTabIndex(event, type) {
        var target = event.currentTarget;
        var isSelectable = (0, $cfkGk.DomHandler).getAttribute(target, type === "cell" ? "data-p-selectable-cell" : "data-p-selectable-row") === true;
        if (isSelectable) {
            var selector = type === "cell" ? "tr > td" : "tr";
            var tabbableEl = (0, $cfkGk.DomHandler).findSingle(elementRef.current, "".concat(selector, '[tabindex="').concat(props.tabIndex, '"]'));
            if (tabbableEl && target) {
                tabbableEl.tabIndex = -1;
                target.tabIndex = props.tabIndex;
            }
        }
    };
    var onRowClick = function onRowClick(event) {
        if (event.defaultPrevented || event.originalEvent && event.originalEvent.defaultPrevented || allowCellSelection() || !allowSelection(event)) return;
        props.onRowClick && props.onRowClick(event);
        if (allowRowSelection()) {
            if (allowRangeSelection(event)) onRangeSelection(event, "row");
            else {
                var toggleable = isRadioSelectionModeInColumn || isCheckboxSelectionModeInColumn || allowMetaKeySelection(event);
                anchorRowIndex.current = event.index;
                rangeRowIndex.current = event.index;
                anchorRowFirst.current = props.first;
                if (isSingleSelection()) onSingleSelection($149bbf8d591193be$var$_objectSpread$7($149bbf8d591193be$var$_objectSpread$7({}, event), {}, {
                    toggleable: toggleable,
                    type: "row"
                }));
                else onMultipleSelection($149bbf8d591193be$var$_objectSpread$7($149bbf8d591193be$var$_objectSpread$7({}, event), {}, {
                    toggleable: toggleable,
                    type: "row"
                }));
            }
            changeTabIndex(event.originalEvent, "row");
        } else focusOnElement(event.originalEvent);
        rowTouched.current = false;
    };
    var onRowDoubleClick = function onRowDoubleClick(e) {
        var event = e.originalEvent;
        if ((0, $cfkGk.DomHandler).isClickable(event.target)) return;
        if (props.onRowDoubleClick) props.onRowDoubleClick(e);
    };
    var onRowPointerDown = function onRowPointerDown(e) {
        var event = e.originalEvent;
        if ((0, $cfkGk.DomHandler).isClickable(event.target)) return;
        if (props.onRowPointerDown) props.onRowPointerDown(e);
    };
    var onRowPointerUp = function onRowPointerUp(e) {
        var event = e.originalEvent;
        if ((0, $cfkGk.DomHandler).isClickable(event.target)) return;
        if (props.onRowPointerUp) props.onRowPointerUp(e);
    };
    var onRowRightClick = function onRowRightClick(event) {
        if (props.onContextMenu || props.onContextMenuSelectionChange) {
            var hasSelection = (0, $cfkGk.ObjectUtils).isNotEmpty(props.selection);
            var data = event.data;
            if (hasSelection) (0, $cfkGk.DomHandler).clearSelection();
            if (props.onContextMenuSelectionChange) props.onContextMenuSelectionChange({
                originalEvent: event.originalEvent,
                value: data,
                index: event.index
            });
            if (props.onContextMenu) props.onContextMenu({
                originalEvent: event.originalEvent,
                data: data,
                index: event.index
            });
            event.originalEvent.preventDefault();
        }
    };
    var onRowMouseEnter = function onRowMouseEnter(event) {
        props.onRowMouseEnter && props.onRowMouseEnter(event);
    };
    var onRowMouseLeave = function onRowMouseLeave(event) {
        props.onRowMouseLeave && props.onRowMouseLeave(event);
    };
    var onRowTouchEnd = function onRowTouchEnd() {
        rowTouched.current = true;
    };
    var onRowMouseDown = function onRowMouseDown(e) {
        var event = e.originalEvent;
        if (!isUnsyled && (0, $cfkGk.DomHandler).hasClass(event.target, "p-datatable-reorderablerow-handle")) {
            event.currentTarget.draggable = true;
            event.target.draggable = false;
        } else event.currentTarget.draggable = false;
        if (allowRowDrag(e)) {
            enableDragSelection(event);
            anchorRowIndex.current = e.index;
            rangeRowIndex.current = e.index;
            anchorRowFirst.current = props.first;
        }
    };
    var onRowMouseUp = function onRowMouseUp(event) {
        var isSameRow = event.index === anchorRowIndex.current;
        if (allowRowDrag(event) && !isSameRow) onRangeSelection(event, "row");
    };
    var onRowToggle = function onRowToggle(event) {
        var expandedRows;
        var dataKey = props.dataKey;
        var hasDataKey = props.groupRowsBy ? dataKey === props.groupRowsBy : !!dataKey;
        if (hasDataKey) {
            var dataKeyValue = String((0, $cfkGk.ObjectUtils).resolveFieldData(event.data, dataKey));
            expandedRows = props.expandedRows ? $149bbf8d591193be$var$_objectSpread$7({}, props.expandedRows) : {};
            if (expandedRows[dataKeyValue] != null) {
                delete expandedRows[dataKeyValue];
                if (props.onRowCollapse) props.onRowCollapse({
                    originalEvent: event,
                    data: event.data
                });
            } else {
                expandedRows[dataKeyValue] = true;
                if (props.onRowExpand) props.onRowExpand({
                    originalEvent: event,
                    data: event.data
                });
            }
        } else {
            var expandedRowIndex = findIndex(props.expandedRows, event.data);
            expandedRows = props.expandedRows ? $149bbf8d591193be$var$_toConsumableArray(props.expandedRows) : [];
            if (expandedRowIndex !== -1) {
                expandedRows = expandedRows.filter(function(_, i) {
                    return i !== expandedRowIndex;
                });
                if (props.onRowCollapse) props.onRowCollapse({
                    originalEvent: event,
                    data: event.data
                });
            } else {
                expandedRows.push(event.data);
                if (props.onRowExpand) props.onRowExpand({
                    originalEvent: event,
                    data: event.data
                });
            }
        }
        if (props.onRowToggle) props.onRowToggle({
            data: expandedRows
        });
    };
    var onRowDragStart = function onRowDragStart(e) {
        var event = e.originalEvent, index = e.index;
        if (allowRowDrag(event)) {
            rowDragging.current = true;
            draggedRowIndex.current = index;
            event.dataTransfer.setData("text", "b"); // For firefox
        }
    };
    var onRowDragOver = function onRowDragOver(e) {
        var event = e.originalEvent, index = e.index;
        if (rowDragging.current && draggedRowIndex.current !== index) {
            var rowElement = event.currentTarget;
            var rowY = (0, $cfkGk.DomHandler).getOffset(rowElement).top + (0, $cfkGk.DomHandler).getWindowScrollTop();
            var pageY = event.pageY + window.scrollY;
            var rowMidY = rowY + (0, $cfkGk.DomHandler).getOuterHeight(rowElement) / 2;
            var prevRowElement = rowElement.previousElementSibling;
            if (pageY < rowMidY) {
                rowElement.setAttribute("data-p-datatable-dragpoint-bottom", "false");
                !isUnsyled && (0, $cfkGk.DomHandler).removeClass(rowElement, "p-datatable-dragpoint-bottom");
                droppedRowIndex.current = index;
                if (prevRowElement) {
                    prevRowElement.setAttribute("data-p-datatable-dragpoint-bottom", "true");
                    !isUnsyled && (0, $cfkGk.DomHandler).addClass(prevRowElement, "p-datatable-dragpoint-bottom");
                } else {
                    rowElement.setAttribute("data-p-datatable-dragpoint-top", "true");
                    !isUnsyled && (0, $cfkGk.DomHandler).addClass(rowElement, "p-datatable-dragpoint-top");
                }
            } else {
                if (prevRowElement) {
                    prevRowElement.setAttribute("data-p-datatable-dragpoint-bottom", "false");
                    !isUnsyled && (0, $cfkGk.DomHandler).removeClass(prevRowElement, "p-datatable-dragpoint-bottom");
                } else {
                    rowElement.setAttribute("data-p-datatable-dragpoint-top", "true");
                    !isUnsyled && (0, $cfkGk.DomHandler).addClass(rowElement, "p-datatable-dragpoint-top");
                }
                droppedRowIndex.current = index + 1;
                rowElement.setAttribute("data-p-datatable-dragpoint-bottom", "true");
                !isUnsyled && (0, $cfkGk.DomHandler).addClass(rowElement, "p-datatable-dragpoint-bottom");
            }
        }
        event.preventDefault();
    };
    var onRowDragLeave = function onRowDragLeave(e) {
        var event = e.originalEvent;
        var rowElement = event.currentTarget;
        var prevRowElement = rowElement.previousElementSibling;
        if (prevRowElement) {
            prevRowElement.setAttribute("data-p-datatable-dragpoint-bottom", "false");
            !isUnsyled && (0, $cfkGk.DomHandler).removeClass(prevRowElement, "p-datatable-dragpoint-bottom");
        }
        rowElement.setAttribute("data-p-datatable-dragpoint-bottom", "false");
        !isUnsyled && (0, $cfkGk.DomHandler).removeClass(rowElement, "p-datatable-dragpoint-bottom");
        rowElement.setAttribute("data-p-datatable-dragpoint-top", "false");
        !isUnsyled && (0, $cfkGk.DomHandler).removeClass(rowElement, "p-datatable-dragpoint-top");
    };
    var onRowDragEnd = function onRowDragEnd(e) {
        var event = e.originalEvent;
        rowDragging.current = false;
        draggedRowIndex.current = null;
        droppedRowIndex.current = null;
        event.currentTarget.draggable = false;
    };
    var onRowDrop = function onRowDrop(e) {
        var event = e.originalEvent;
        if (droppedRowIndex.current != null) {
            var dropIndex = draggedRowIndex.current > droppedRowIndex.current ? droppedRowIndex.current : droppedRowIndex.current === 0 ? 0 : droppedRowIndex.current - 1;
            var val = $149bbf8d591193be$var$_toConsumableArray(props.tableProps.value);
            (0, $cfkGk.ObjectUtils).reorderArray(val, draggedRowIndex.current, dropIndex);
            if (props.onRowReorder) props.onRowReorder({
                originalEvent: event,
                value: val,
                dragIndex: draggedRowIndex.current,
                dropIndex: dropIndex
            });
        }
        //cleanup
        onRowDragLeave(e);
        onRowDragEnd(e);
        event.preventDefault();
    };
    var onRadioChange = function onRadioChange(event) {
        onSingleSelection($149bbf8d591193be$var$_objectSpread$7($149bbf8d591193be$var$_objectSpread$7({}, event), {}, {
            toggleable: true,
            type: "radio"
        }));
    };
    var onCheckboxChange = function onCheckboxChange(event) {
        onMultipleSelection($149bbf8d591193be$var$_objectSpread$7($149bbf8d591193be$var$_objectSpread$7({}, event), {}, {
            toggleable: true,
            type: "checkbox"
        }));
    };
    var onDragSelectionMouseMove = function onDragSelectionMouseMove(event) {
        var _initialDragPosition$ = initialDragPosition.current, x = _initialDragPosition$.x, y = _initialDragPosition$.y;
        var dx = event.clientX - x;
        var dy = event.clientY - y;
        if (dy < 0) dragSelectionHelper.current.style.top = "".concat(event.pageY + 5, "px");
        if (dx < 0) dragSelectionHelper.current.style.left = "".concat(event.pageX + 5, "px");
        dragSelectionHelper.current.style.height = "".concat(Math.abs(dy), "px");
        dragSelectionHelper.current.style.width = "".concat(Math.abs(dx), "px");
        event.preventDefault();
    };
    var onDragSelectionMouseUp = function onDragSelectionMouseUp() {
        if (dragSelectionHelper.current) {
            dragSelectionHelper.current.remove();
            dragSelectionHelper.current = null;
        }
        document.removeEventListener("mousemove", onDragSelectionMouseMove);
        document.removeEventListener("mouseup", onDragSelectionMouseUp);
    };
    var onCellClick = function onCellClick(event) {
        if (!allowSelection(event)) return;
        props.onCellClick && props.onCellClick(event);
        if (allowCellSelection()) {
            if (allowRangeSelection(event)) onRangeSelection(event, "cell");
            else {
                var toggleable = allowMetaKeySelection(event);
                var originalEvent = event.originalEvent, data = $149bbf8d591193be$var$_objectWithoutProperties(event, $149bbf8d591193be$var$_excluded);
                anchorRowIndex.current = event.rowIndex;
                rangeRowIndex.current = event.rowIndex;
                anchorRowFirst.current = props.first;
                anchorCellIndex.current = event.cellIndex;
                if (isSingleSelection()) onSingleSelection({
                    originalEvent: originalEvent,
                    data: data,
                    index: event.rowIndex,
                    toggleable: toggleable,
                    type: "cell"
                });
                else onMultipleSelection({
                    originalEvent: originalEvent,
                    data: data,
                    index: event.rowIndex,
                    toggleable: toggleable,
                    type: "cell"
                });
            }
            changeTabIndex(event.originalEvent, "cell");
        }
        rowTouched.current = false;
    };
    var onCellMouseDown = function onCellMouseDown(event) {
        if (allowCellDrag(event)) {
            enableDragSelection(event.originalEvent);
            anchorRowIndex.current = event.rowIndex;
            rangeRowIndex.current = event.rowIndex;
            anchorRowFirst.current = props.first;
            anchorCellIndex.current = event.cellIndex;
        }
    };
    var onCellMouseUp = function onCellMouseUp(event) {
        var isSameCell = event.rowIndex === anchorRowIndex.current && event.cellIndex === anchorCellIndex.current;
        if (allowCellDrag(event) && !isSameCell) onRangeSelection(event, "cell");
    };
    var bindDragSelectionEvents = function bindDragSelectionEvents() {
        document.addEventListener("mousemove", onDragSelectionMouseMove);
        document.addEventListener("mouseup", onDragSelectionMouseUp);
        document.body.appendChild(dragSelectionHelper.current);
    };
    var unbindDragSelectionEvents = function unbindDragSelectionEvents() {
        onDragSelectionMouseUp();
    };
    $81g6h.useEffect(function() {
        if (props.frozenRow) updateFrozenRowStickyPosition();
        if (props.scrollable && props.rowGroupMode === "subheader") updateFrozenRowGroupHeaderStickyPosition();
    });
    (0, $l2NC0.useUpdateEffect)(function() {
        if (props.paginator && isMultipleSelection()) anchorRowIndex.current = null;
    }, [
        props.first
    ]);
    (0, $l2NC0.useUnmountEffect)(function() {
        if (props.dragSelection) unbindDragSelectionEvents();
    });
    var createEmptyContent = function createEmptyContent() {
        if (!props.loading) {
            var colSpan = getColumnsLength();
            var _content = (0, $cfkGk.ObjectUtils).getJSXElement(props.emptyMessage, {
                props: props.tableProps,
                frozen: props.frozenRow
            }) || (0, $8Zwsm.localeOption)("emptyMessage");
            var emptyMessageProps = mergeProps({
                className: cx("emptyMessage"),
                role: "row"
            }, getColumnPTOptions("emptyMessage"));
            var bodyCellProps = mergeProps({
                colSpan: colSpan,
                role: "cell"
            }, getColumnPTOptions("root"), getColumnPTOptions("bodyCell"));
            return /*#__PURE__*/ $81g6h.createElement("tr", emptyMessageProps, /*#__PURE__*/ $81g6h.createElement("td", bodyCellProps, _content));
        }
        return null;
    };
    var createGroupHeader = function createGroupHeader(rowData, rowIndex, expanded, colSpan) {
        if (isSubheaderGrouping && shouldRenderRowGroupHeader(props.value, rowData, rowIndex - props.first)) {
            var style = rowGroupHeaderStyle();
            var toggler = props.expandableRowGroups && /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$RowTogglerButton, {
                hostName: props.hostName,
                onClick: onRowToggle,
                rowData: rowData,
                expanded: expanded,
                expandedRowIcon: props.expandedRowIcon,
                collapsedRowIcon: props.collapsedRowIcon,
                ptCallbacks: props.ptCallbacks,
                metaData: props.metaData,
                unstyled: props.unstyled
            });
            var options = {
                index: rowIndex,
                props: props.tableProps,
                customRendering: false
            };
            var _content2 = (0, $cfkGk.ObjectUtils).getJSXElement(props.rowGroupHeaderTemplate, rowData, options);
            // check if the user wants complete control of the rendering
            if (!options.customRendering) {
                var bodyCellProps = mergeProps({
                    colSpan: colSpan
                }, getColumnPTOptions("root"), getColumnPTOptions("bodyCell"));
                var rowGroupHeaderNameProps = mergeProps({
                    className: cx("rowGroupHeaderName")
                }, getColumnPTOptions("rowGroupHeaderName"));
                _content2 = /*#__PURE__*/ $81g6h.createElement("td", bodyCellProps, toggler, /*#__PURE__*/ $81g6h.createElement("span", rowGroupHeaderNameProps, _content2));
            }
            var rowGroupHeaderProps = mergeProps({
                className: cx("rowGroupHeader"),
                style: style,
                role: "row"
            }, getColumnPTOptions("rowGroupHeader"));
            return /*#__PURE__*/ $81g6h.createElement("tr", rowGroupHeaderProps, _content2);
        }
        return null;
    };
    var createRow = function createRow(rowData, rowIndex, index, expanded) {
        if (!props.expandableRowGroups || expanded) {
            var selected = isSelectionEnabled() ? isSelected(rowData) : false;
            var contextMenuSelected = isContextMenuSelected(rowData);
            var _allowRowSelection = allowRowSelection();
            var _allowCellSelection = allowCellSelection();
            var editing = isRowEditing(rowData);
            return /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$BodyRow, {
                hostName: props.hostName,
                allowCellSelection: _allowCellSelection,
                allowRowSelection: _allowRowSelection,
                cellClassName: props.cellClassName,
                checkIcon: props.checkIcon,
                collapsedRowIcon: props.collapsedRowIcon,
                columns: props.columns,
                compareSelectionBy: props.compareSelectionBy,
                contextMenuSelected: contextMenuSelected,
                dataKey: props.dataKey,
                editMode: props.editMode,
                editing: editing,
                editingMeta: props.editingMeta,
                editingRows: props.editingRows,
                expanded: expanded,
                expandedRowIcon: props.expandedRowIcon,
                frozenRow: props.frozenRow,
                groupRowsBy: props.groupRowsBy,
                index: index,
                isSelectable: isSelectable,
                onCellClick: onCellClick,
                onCellMouseDown: onCellMouseDown,
                onCellMouseUp: onCellMouseUp,
                onCheckboxChange: onCheckboxChange,
                onEditingMetaChange: props.onEditingMetaChange,
                onRadioChange: onRadioChange,
                onRowClick: onRowClick,
                onRowDoubleClick: onRowDoubleClick,
                onRowPointerDown: onRowPointerDown,
                onRowPointerUp: onRowPointerUp,
                onRowDragEnd: onRowDragEnd,
                onRowDragLeave: onRowDragLeave,
                onRowDragOver: onRowDragOver,
                onRowDragStart: onRowDragStart,
                onRowDrop: onRowDrop,
                onRowEditCancel: props.onRowEditCancel,
                onRowEditChange: props.onRowEditChange,
                onRowEditComplete: props.onRowEditComplete,
                onRowEditInit: props.onRowEditInit,
                onRowEditSave: props.onRowEditSave,
                onRowMouseDown: onRowMouseDown,
                onRowMouseEnter: onRowMouseEnter,
                onRowMouseLeave: onRowMouseLeave,
                onRowMouseUp: onRowMouseUp,
                onRowRightClick: onRowRightClick,
                onRowToggle: onRowToggle,
                onRowTouchEnd: onRowTouchEnd,
                responsiveLayout: props.responsiveLayout,
                rowClassName: props.rowClassName,
                rowData: rowData,
                rowEditValidator: props.rowEditValidator,
                rowEditorCancelIcon: props.rowEditorCancelIcon,
                rowEditorInitIcon: props.rowEditorInitIcon,
                rowEditorSaveIcon: props.rowEditorSaveIcon,
                rowGroupMode: props.rowGroupMode,
                rowIndex: rowIndex,
                selectOnEdit: props.selectOnEdit,
                selected: selected,
                selection: props.selection,
                selectionMode: props.selectionMode,
                selectionModeInColumn: props.selectionModeInColumn,
                showRowReorderElement: props.showRowReorderElement,
                showSelectionElement: props.showSelectionElement,
                tabIndex: props.tabIndex,
                tableProps: props.tableProps,
                tableSelector: props.tableSelector,
                value: props.value,
                virtualScrollerOptions: props.virtualScrollerOptions,
                ptCallbacks: props.ptCallbacks,
                metaData: props.metaData,
                unstyled: props.unstyled
            });
        }
    };
    var createExpansion = function createExpansion(rowData, rowIndex, expanded, colSpan) {
        if (expanded && !(isSubheaderGrouping && props.expandableRowGroups)) {
            var id = "".concat(props.tableSelector, "_content_").concat(rowIndex, "_expanded");
            var options = {
                index: rowIndex,
                customRendering: false
            };
            var _content3 = (0, $cfkGk.ObjectUtils).getJSXElement(props.rowExpansionTemplate, rowData, options);
            // check if the user wants complete control of the rendering
            if (!options.customRendering) {
                var bodyCellProps = mergeProps({
                    colSpan: colSpan,
                    role: "cell"
                }, getColumnPTOptions("root"), getColumnPTOptions("bodyCell"));
                _content3 = /*#__PURE__*/ $81g6h.createElement("td", bodyCellProps, _content3);
            }
            var rowExpansionProps = mergeProps({
                id: id,
                className: cx("rowExpansion"),
                role: "row"
            }, getColumnPTOptions("rowExpansion"));
            return /*#__PURE__*/ $81g6h.createElement("tr", rowExpansionProps, _content3);
        }
        return null;
    };
    var createGroupFooter = function createGroupFooter(rowData, rowIndex, expanded, colSpan) {
        if (isSubheaderGrouping && shouldRenderRowGroupFooter(props.value, rowData, rowIndex - props.first, expanded)) {
            var _content4 = (0, $cfkGk.ObjectUtils).getJSXElement(props.rowGroupFooterTemplate, rowData, {
                index: rowIndex,
                colSpan: colSpan,
                props: props.tableProps
            });
            var rowGroupFooterProps = mergeProps({
                className: cx("rowGroupFooter"),
                role: "row"
            }, getColumnPTOptions("rowGroupFooter"));
            return /*#__PURE__*/ $81g6h.createElement("tr", rowGroupFooterProps, _content4);
        }
        return null;
    };
    var createContent = function createContent() {
        return props.value && props.value.map(function(rowData, index) {
            var rowIndex = getVirtualScrollerOption("getItemOptions") ? getVirtualScrollerOption("getItemOptions")(index).index : props.first + index;
            var key = getRowKey(rowData, rowIndex);
            var expanded = isRowExpanded(rowData);
            var colSpan = getColumnsLength();
            var groupHeader = createGroupHeader(rowData, rowIndex, expanded, colSpan);
            var row = createRow(rowData, rowIndex, index, expanded);
            var expansion = createExpansion(rowData, rowIndex, expanded, colSpan);
            var groupFooter = createGroupFooter(rowData, rowIndex, expanded, colSpan);
            return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, {
                key: key
            }, groupHeader, row, expansion, groupFooter);
        });
    };
    var content = props.empty ? createEmptyContent() : createContent();
    var ptKey = props.className === "p-datatable-virtualscroller-spacer" ? "virtualScrollerSpacer" : "tbody";
    var tbodyProps = mergeProps({
        style: props.style,
        className: cx(ptKey, {
            className: props.className
        }),
        role: " rowgroup"
    }, ptm(ptKey, {
        hostName: props.hostName
    }));
    return /*#__PURE__*/ $81g6h.createElement("tbody", $149bbf8d591193be$var$_extends({
        ref: refCallback
    }, tbodyProps), content);
}));
$149bbf8d591193be$var$TableBody.displayName = "TableBody";
var $149bbf8d591193be$var$ColumnGroupBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "ColumnGroup",
        children: undefined
    },
    getCProp: function getCProp(group, name) {
        return (0, $cfkGk.ObjectUtils).getComponentProp(group, name, $149bbf8d591193be$var$ColumnGroupBase.defaultProps);
    },
    getCProps: function getCProps(group) {
        return (0, $cfkGk.ObjectUtils).getComponentProps(group, $149bbf8d591193be$var$ColumnGroupBase.defaultProps);
    }
});
var $149bbf8d591193be$var$RowBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Row",
        style: null,
        className: null,
        children: undefined
    },
    getCProp: function getCProp(row, name) {
        return (0, $cfkGk.ObjectUtils).getComponentProp(row, name, $149bbf8d591193be$var$RowBase.defaultProps);
    }
});
function $149bbf8d591193be$var$ownKeys$6(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149bbf8d591193be$var$_objectSpread$6(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149bbf8d591193be$var$ownKeys$6(Object(t), !0).forEach(function(r) {
            $149bbf8d591193be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149bbf8d591193be$var$ownKeys$6(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149bbf8d591193be$var$FooterCell = /*#__PURE__*/ $81g6h.memo(function(props) {
    var _React$useState = $81g6h.useState({}), _React$useState2 = $149bbf8d591193be$var$_slicedToArray(_React$useState, 2), styleObjectState = _React$useState2[0], setStyleObjectState = _React$useState2[1];
    var elementRef = $81g6h.useRef(null);
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var getColumnProps = function getColumnProps() {
        return $149bbf8d591193be$var$ColumnBase.getCProps(props.column);
    };
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var getColumnPTOptions = function getColumnPTOptions(key) {
        var cProps = getColumnProps();
        var columnMetaData = {
            props: cProps,
            parent: props.metaData,
            hostName: props.hostName,
            state: {
                styleObject: styleObjectState
            },
            context: {
                index: props.index,
                size: props.metaData.props.size,
                showGridlines: props.metaData.props.showGridlines
            }
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(cProps, key, columnMetaData));
    };
    var getColumnProp = function getColumnProp(name) {
        return $149bbf8d591193be$var$ColumnBase.getCProp(props.column, name);
    };
    var getStyle = function getStyle() {
        var footerStyle = getColumnProp("footerStyle");
        var columnStyle = getColumnProp("style");
        return getColumnProp("frozen") ? Object.assign({}, columnStyle, footerStyle, styleObjectState) : Object.assign({}, columnStyle, footerStyle);
    };
    var updateStickyPosition = function updateStickyPosition() {
        if (getColumnProp("frozen")) {
            var styleObject = $149bbf8d591193be$var$_objectSpread$6({}, styleObjectState);
            var _align = getColumnProp("alignFrozen");
            if (_align === "right") {
                var right = 0;
                var next = elementRef.current.nextElementSibling;
                if (next) right = (0, $cfkGk.DomHandler).getOuterWidth(next) + parseFloat(next.style.right || 0);
                styleObject.right = right + "px";
            } else {
                var left = 0;
                var prev = elementRef.current.previousElementSibling;
                if (prev) left = (0, $cfkGk.DomHandler).getOuterWidth(prev) + parseFloat(prev.style.left || 0);
                styleObject.left = left + "px";
            }
            var isSameStyle = styleObjectState.left === styleObject.left && styleObjectState.right === styleObject.right;
            !isSameStyle && setStyleObjectState(styleObject);
        }
    };
    $81g6h.useEffect(function() {
        if (getColumnProp("frozen")) updateStickyPosition();
    });
    var style = getStyle();
    var align = getColumnProp("align");
    var colSpan = getColumnProp("colSpan");
    var rowSpan = getColumnProp("rowSpan");
    var content = (0, $cfkGk.ObjectUtils).getJSXElement(getColumnProp("footer"), {
        props: props.tableProps
    });
    var footerCellProps = mergeProps({
        style: style,
        className: (0, $cfkGk.classNames)(getColumnProp("footerClassName"), getColumnProp("className"), cx("footerCell", {
            getColumnProp: getColumnProp,
            align: align
        })),
        role: "cell",
        colSpan: colSpan,
        rowSpan: rowSpan
    }, getColumnPTOptions("root"), getColumnPTOptions("footerCell"));
    return /*#__PURE__*/ $81g6h.createElement("td", $149bbf8d591193be$var$_extends({
        ref: elementRef
    }, footerCellProps), content);
});
$149bbf8d591193be$var$FooterCell.displayName = "FooterCell";
var $149bbf8d591193be$var$TableFooter = /*#__PURE__*/ $81g6h.memo(function(props) {
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var getRowProps = function getRowProps(row) {
        return $149bbf8d591193be$var$ColumnGroupBase.getCProps(row);
    };
    var getColumnGroupProps = function getColumnGroupProps() {
        return props.footerColumnGroup ? $149bbf8d591193be$var$ColumnGroupBase.getCProps(props.footerColumnGroup) : undefined;
    };
    var getRowPTOptions = function getRowPTOptions(row, key) {
        var rProps = getRowProps(row);
        var rowMetaData = {
            props: rProps,
            parent: props.metaData,
            hostName: props.hostName
        };
        return mergeProps(ptm("row.".concat(key), {
            row: rowMetaData
        }), ptm("row.".concat(key), rowMetaData), ptmo(rProps, key, rowMetaData));
    };
    var getColumnGroupPTOptions = function getColumnGroupPTOptions(key) {
        var cGProps = getColumnGroupProps();
        var columnGroupMetaData = {
            props: getColumnGroupProps(),
            parent: props.metaData,
            hostName: props.hostName
        };
        return mergeProps(ptm("columnGroup.".concat(key), {
            columnGroup: columnGroupMetaData
        }), ptm("columnGroup.".concat(key), columnGroupMetaData), ptmo(cGProps, key, columnGroupMetaData));
    };
    var hasFooter = function hasFooter() {
        return props.footerColumnGroup ? true : props.columns ? props.columns.some(function(col) {
            return col && getColumnProp(col, "footer");
        }) : false;
    };
    var getColumnProp = function getColumnProp(column, name) {
        return $149bbf8d591193be$var$ColumnBase.getCProp(column, name);
    };
    var createGroupFooterCells = function createGroupFooterCells(row) {
        var columns = $81g6h.Children.toArray($149bbf8d591193be$var$RowBase.getCProp(row, "children"));
        return createFooterCells(columns);
    };
    var createFooterCells = function createFooterCells(columns) {
        return $81g6h.Children.map(columns, function(col, i) {
            var isVisible = col ? !getColumnProp(col, "hidden") : true;
            var key = col ? getColumnProp(col, "columnKey") || getColumnProp(col, "field") || i : i;
            return isVisible && /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$FooterCell, {
                hostName: props.hostName,
                key: key,
                tableProps: props.tableProps,
                column: col,
                ptCallbacks: props.ptCallbacks,
                metaData: props.metaData
            });
        });
    };
    var createContent = function createContent() {
        if (props.footerColumnGroup) {
            var rows = $81g6h.Children.toArray($149bbf8d591193be$var$ColumnGroupBase.getCProp(props.footerColumnGroup, "children"));
            return rows.map(function(row, i) {
                var rootProps = mergeProps({
                    role: "row"
                }, getRowPTOptions(row, "root"));
                return /*#__PURE__*/ $81g6h.createElement("tr", $149bbf8d591193be$var$_extends({}, rootProps, {
                    key: i
                }), createGroupFooterCells(row));
            });
        }
        var footerRowProps = mergeProps({
            role: "row"
        }, ptm("footerRow", {
            hostName: props.hostName
        }));
        return /*#__PURE__*/ $81g6h.createElement("tr", footerRowProps, createFooterCells(props.columns));
    };
    if (hasFooter()) {
        var content = createContent();
        var tfootProps = mergeProps({
            className: cx("tfoot"),
            role: "rowgroup"
        }, getColumnGroupPTOptions("root"), ptm("tfoot", {
            hostName: props.hostName
        }));
        return /*#__PURE__*/ $81g6h.createElement("tfoot", tfootProps, content);
    }
    return null;
});
$149bbf8d591193be$var$TableFooter.displayName = "TableFooter";
function $149bbf8d591193be$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $149bbf8d591193be$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $149bbf8d591193be$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $149bbf8d591193be$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $149bbf8d591193be$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $149bbf8d591193be$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $149bbf8d591193be$var$FilterMatchMode = Object.freeze({
    STARTS_WITH: "startsWith",
    CONTAINS: "contains",
    NOT_CONTAINS: "notContains",
    ENDS_WITH: "endsWith",
    EQUALS: "equals",
    NOT_EQUALS: "notEquals",
    IN: "in",
    LESS_THAN: "lt",
    LESS_THAN_OR_EQUAL_TO: "lte",
    GREATER_THAN: "gt",
    GREATER_THAN_OR_EQUAL_TO: "gte",
    BETWEEN: "between",
    DATE_IS: "dateIs",
    DATE_IS_NOT: "dateIsNot",
    DATE_BEFORE: "dateBefore",
    DATE_AFTER: "dateAfter",
    CUSTOM: "custom"
});
/**
 * @deprecated please use PrimeReactContext
 */ var $149bbf8d591193be$var$PrimeReact = /*#__PURE__*/ $149bbf8d591193be$var$_createClass(function PrimeReact() {
    $149bbf8d591193be$var$_classCallCheck(this, PrimeReact);
});
$149bbf8d591193be$var$_defineProperty($149bbf8d591193be$var$PrimeReact, "ripple", false);
$149bbf8d591193be$var$_defineProperty($149bbf8d591193be$var$PrimeReact, "inputStyle", "outlined");
$149bbf8d591193be$var$_defineProperty($149bbf8d591193be$var$PrimeReact, "locale", "en");
$149bbf8d591193be$var$_defineProperty($149bbf8d591193be$var$PrimeReact, "appendTo", null);
$149bbf8d591193be$var$_defineProperty($149bbf8d591193be$var$PrimeReact, "cssTransition", true);
$149bbf8d591193be$var$_defineProperty($149bbf8d591193be$var$PrimeReact, "autoZIndex", true);
$149bbf8d591193be$var$_defineProperty($149bbf8d591193be$var$PrimeReact, "hideOverlaysOnDocumentScrolling", false);
$149bbf8d591193be$var$_defineProperty($149bbf8d591193be$var$PrimeReact, "nonce", null);
$149bbf8d591193be$var$_defineProperty($149bbf8d591193be$var$PrimeReact, "nullSortOrder", 1);
$149bbf8d591193be$var$_defineProperty($149bbf8d591193be$var$PrimeReact, "zIndex", {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
    toast: 1200
});
$149bbf8d591193be$var$_defineProperty($149bbf8d591193be$var$PrimeReact, "pt", undefined);
$149bbf8d591193be$var$_defineProperty($149bbf8d591193be$var$PrimeReact, "filterMatchModeOptions", {
    text: [
        $149bbf8d591193be$var$FilterMatchMode.STARTS_WITH,
        $149bbf8d591193be$var$FilterMatchMode.CONTAINS,
        $149bbf8d591193be$var$FilterMatchMode.NOT_CONTAINS,
        $149bbf8d591193be$var$FilterMatchMode.ENDS_WITH,
        $149bbf8d591193be$var$FilterMatchMode.EQUALS,
        $149bbf8d591193be$var$FilterMatchMode.NOT_EQUALS
    ],
    numeric: [
        $149bbf8d591193be$var$FilterMatchMode.EQUALS,
        $149bbf8d591193be$var$FilterMatchMode.NOT_EQUALS,
        $149bbf8d591193be$var$FilterMatchMode.LESS_THAN,
        $149bbf8d591193be$var$FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        $149bbf8d591193be$var$FilterMatchMode.GREATER_THAN,
        $149bbf8d591193be$var$FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
    ],
    date: [
        $149bbf8d591193be$var$FilterMatchMode.DATE_IS,
        $149bbf8d591193be$var$FilterMatchMode.DATE_IS_NOT,
        $149bbf8d591193be$var$FilterMatchMode.DATE_BEFORE,
        $149bbf8d591193be$var$FilterMatchMode.DATE_AFTER
    ]
});
$149bbf8d591193be$var$_defineProperty($149bbf8d591193be$var$PrimeReact, "changeTheme", function(currentTheme, newTheme, linkElementId, callback) {
    var _linkElement$parentNo;
    var linkElement = document.getElementById(linkElementId);
    var cloneLinkElement = linkElement.cloneNode(true);
    var newThemeUrl = linkElement.getAttribute("href").replace(currentTheme, newTheme);
    cloneLinkElement.setAttribute("id", linkElementId + "-clone");
    cloneLinkElement.setAttribute("href", newThemeUrl);
    cloneLinkElement.addEventListener("load", function() {
        linkElement.remove();
        cloneLinkElement.setAttribute("id", linkElementId);
        if (callback) callback();
    });
    (_linkElement$parentNo = linkElement.parentNode) === null || _linkElement$parentNo === void 0 || _linkElement$parentNo.insertBefore(cloneLinkElement, linkElement.nextSibling);
});
var $149bbf8d591193be$var$locales = {
    en: {
        accept: "Yes",
        addRule: "Add Rule",
        am: "AM",
        apply: "Apply",
        cancel: "Cancel",
        choose: "Choose",
        chooseDate: "Choose Date",
        chooseMonth: "Choose Month",
        chooseYear: "Choose Year",
        clear: "Clear",
        completed: "Completed",
        contains: "Contains",
        custom: "Custom",
        dateAfter: "Date is after",
        dateBefore: "Date is before",
        dateFormat: "mm/dd/yy",
        dateIs: "Date is",
        dateIsNot: "Date is not",
        dayNames: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        dayNamesMin: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
        ],
        dayNamesShort: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        emptyFilterMessage: "No results found",
        emptyMessage: "No available options",
        emptySearchMessage: "No results found",
        emptySelectionMessage: "No selected item",
        endsWith: "Ends with",
        equals: "Equals",
        fileSizeTypes: [
            "B",
            "KB",
            "MB",
            "GB",
            "TB",
            "PB",
            "EB",
            "ZB",
            "YB"
        ],
        filter: "Filter",
        firstDayOfWeek: 0,
        gt: "Greater than",
        gte: "Greater than or equal to",
        lt: "Less than",
        lte: "Less than or equal to",
        matchAll: "Match All",
        matchAny: "Match Any",
        medium: "Medium",
        monthNames: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthNamesShort: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        nextDecade: "Next Decade",
        nextHour: "Next Hour",
        nextMinute: "Next Minute",
        nextMonth: "Next Month",
        nextSecond: "Next Second",
        nextYear: "Next Year",
        noFilter: "No Filter",
        notContains: "Not contains",
        notEquals: "Not equals",
        now: "Now",
        passwordPrompt: "Enter a password",
        pending: "Pending",
        pm: "PM",
        prevDecade: "Previous Decade",
        prevHour: "Previous Hour",
        prevMinute: "Previous Minute",
        prevMonth: "Previous Month",
        prevSecond: "Previous Second",
        prevYear: "Previous Year",
        reject: "No",
        removeRule: "Remove Rule",
        searchMessage: "{0} results are available",
        selectionMessage: "{0} items selected",
        showMonthAfterYear: false,
        startsWith: "Starts with",
        strong: "Strong",
        today: "Today",
        upload: "Upload",
        weak: "Weak",
        weekHeader: "Wk",
        aria: {
            cancelEdit: "Cancel Edit",
            close: "Close",
            collapseRow: "Row Collapsed",
            editRow: "Edit Row",
            expandRow: "Row Expanded",
            falseLabel: "False",
            filterConstraint: "Filter Constraint",
            filterOperator: "Filter Operator",
            firstPageLabel: "First Page",
            gridView: "Grid View",
            hideFilterMenu: "Hide Filter Menu",
            jumpToPageDropdownLabel: "Jump to Page Dropdown",
            jumpToPageInputLabel: "Jump to Page Input",
            lastPageLabel: "Last Page",
            listView: "List View",
            moveAllToSource: "Move All to Source",
            moveAllToTarget: "Move All to Target",
            moveBottom: "Move Bottom",
            moveDown: "Move Down",
            moveToSource: "Move to Source",
            moveToTarget: "Move to Target",
            moveTop: "Move Top",
            moveUp: "Move Up",
            navigation: "Navigation",
            next: "Next",
            nextPageLabel: "Next Page",
            nullLabel: "Not Selected",
            pageLabel: "Page {page}",
            otpLabel: "Please enter one time password character {0}",
            passwordHide: "Hide Password",
            passwordShow: "Show Password",
            previous: "Previous",
            previousPageLabel: "Previous Page",
            rotateLeft: "Rotate Left",
            rotateRight: "Rotate Right",
            rowsPerPageLabel: "Rows per page",
            saveEdit: "Save Edit",
            scrollTop: "Scroll Top",
            selectAll: "All items selected",
            selectRow: "Row Selected",
            showFilterMenu: "Show Filter Menu",
            slide: "Slide",
            slideNumber: "{slideNumber}",
            star: "1 star",
            stars: "{star} stars",
            trueLabel: "True",
            unselectAll: "All items unselected",
            unselectRow: "Row Unselected",
            zoomImage: "Zoom Image",
            zoomIn: "Zoom In",
            zoomOut: "Zoom Out"
        }
    }
};
/**
 * Find an ARIA label in the locale by key.  If options are passed it will replace all options:
 * ```ts
 * const ariaValue = "Page {page}, User {user}, Role {role}";
 * const options = { page: 2, user: "John", role: "Admin" };
 * const result = ariaLabel('yourLabel', { page: 2, user: "John", role: "Admin" })
 * console.log(result); // Output: Page 2, User John, Role Admin
 * ```
 * @param {string} ariaKey key of the ARIA label to look up in locale.
 * @param {any} options JSON options like { page: 2, user: "John", role: "Admin" }
 * @returns the ARIA label with replaced values
 */ function $149bbf8d591193be$var$ariaLabel(ariaKey, options) {
    if (ariaKey.includes("__proto__") || ariaKey.includes("prototype")) throw new Error("Unsafe ariaKey detected");
    var _locale = $149bbf8d591193be$var$PrimeReact.locale;
    try {
        var _ariaLabel = $149bbf8d591193be$var$localeOptions(_locale).aria[ariaKey];
        if (_ariaLabel) {
            for(var key in options)if (options.hasOwnProperty(key)) _ariaLabel = _ariaLabel.replace("{".concat(key, "}"), options[key]);
        }
        return _ariaLabel;
    } catch (error) {
        throw new Error("The ".concat(ariaKey, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
function $149bbf8d591193be$var$localeOptions(locale) {
    var _locale = locale || $149bbf8d591193be$var$PrimeReact.locale;
    if (_locale.includes("__proto__") || _locale.includes("prototype")) throw new Error("Unsafe locale detected");
    return $149bbf8d591193be$var$locales[_locale];
}
var $149bbf8d591193be$var$styles = "";
var $149bbf8d591193be$var$FocusTrapBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "FocusTrap",
        children: undefined
    },
    css: {
        styles: $149bbf8d591193be$var$styles
    },
    getProps: function getProps(props) {
        return (0, $cfkGk.ObjectUtils).getMergedProps(props, $149bbf8d591193be$var$FocusTrapBase.defaultProps);
    },
    getOtherProps: function getOtherProps(props) {
        return (0, $cfkGk.ObjectUtils).getDiffProps(props, $149bbf8d591193be$var$FocusTrapBase.defaultProps);
    }
});
function $149bbf8d591193be$var$ownKeys$5(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149bbf8d591193be$var$_objectSpread$5(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149bbf8d591193be$var$ownKeys$5(Object(t), !0).forEach(function(r) {
            $149bbf8d591193be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149bbf8d591193be$var$ownKeys$5(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149bbf8d591193be$var$FocusTrap = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(function(inProps, ref) {
    var targetRef = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(null);
    var firstFocusableElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(null);
    var lastFocusableElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(null);
    var context = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useContext((0, $8Zwsm.PrimeReactContext));
    var props = $149bbf8d591193be$var$FocusTrapBase.getProps(inProps, context);
    var metaData = {
        props: props
    };
    (0, $l2NC0.useStyle)($149bbf8d591193be$var$FocusTrapBase.css.styles, {
        name: "focustrap"
    });
    var _FocusTrapBase$setMet = $149bbf8d591193be$var$FocusTrapBase.setMetaData($149bbf8d591193be$var$_objectSpread$5({}, metaData));
    _FocusTrapBase$setMet.ptm;
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useImperativeHandle(ref, function() {
        return {
            props: props,
            getInk: function getInk() {
                return firstFocusableElementRef.current;
            },
            getTarget: function getTarget() {
                return targetRef.current;
            }
        };
    });
    (0, $l2NC0.useMountEffect)(function() {
        if (!props.disabled) {
            targetRef.current = getTarget();
            setAutoFocus(targetRef.current);
        }
    });
    var getTarget = function getTarget() {
        return firstFocusableElementRef.current && firstFocusableElementRef.current.parentElement;
    };
    /**
   * This method sets the auto focus on the first focusable element within the target element.
   * It first tries to find a focusable element using the autoFocusSelector. If no such element is found,
   * it then tries to find a focusable element using the firstFocusableSelector.
   * If the autoFocus prop is set to true and a focusable element is found, it sets the focus on that element.
   *
   * @param {HTMLElement} target - The target element within which to find a focusable element.
   */ var setAutoFocus = function setAutoFocus(target) {
        var _ref = props || {}, _ref$autoFocusSelecto = _ref.autoFocusSelector, autoFocusSelector = _ref$autoFocusSelecto === void 0 ? "" : _ref$autoFocusSelecto, _ref$firstFocusableSe = _ref.firstFocusableSelector, firstFocusableSelector = _ref$firstFocusableSe === void 0 ? "" : _ref$firstFocusableSe, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus;
        var defaultAutoFocusSelector = "".concat(getComputedSelector(autoFocusSelector));
        var computedAutoFocusSelector = "[autofocus]".concat(defaultAutoFocusSelector, ", [data-pc-autofocus='true']").concat(defaultAutoFocusSelector);
        var focusableElement = (0, $cfkGk.DomHandler).getFirstFocusableElement(target, computedAutoFocusSelector);
        autoFocus && !focusableElement && (focusableElement = (0, $cfkGk.DomHandler).getFirstFocusableElement(target, getComputedSelector(firstFocusableSelector)));
        (0, $cfkGk.DomHandler).focus(focusableElement);
    };
    var getComputedSelector = function getComputedSelector(selector) {
        return ':not(.p-hidden-focusable):not([data-p-hidden-focusable="true"])'.concat(selector !== null && selector !== void 0 ? selector : "");
    };
    var onFirstHiddenElementFocus = function onFirstHiddenElementFocus(event) {
        var _targetRef$current;
        var currentTarget = event.currentTarget, relatedTarget = event.relatedTarget;
        var focusableElement = relatedTarget === currentTarget.$_pfocustrap_lasthiddenfocusableelement || !((_targetRef$current = targetRef.current) !== null && _targetRef$current !== void 0 && _targetRef$current.contains(relatedTarget)) ? (0, $cfkGk.DomHandler).getFirstFocusableElement(currentTarget.parentElement, getComputedSelector(currentTarget.$_pfocustrap_focusableselector)) : currentTarget.$_pfocustrap_lasthiddenfocusableelement;
        (0, $cfkGk.DomHandler).focus(focusableElement);
    };
    var onLastHiddenElementFocus = function onLastHiddenElementFocus(event) {
        var _targetRef$current2;
        var currentTarget = event.currentTarget, relatedTarget = event.relatedTarget;
        var focusableElement = relatedTarget === currentTarget.$_pfocustrap_firsthiddenfocusableelement || !((_targetRef$current2 = targetRef.current) !== null && _targetRef$current2 !== void 0 && _targetRef$current2.contains(relatedTarget)) ? (0, $cfkGk.DomHandler).getLastFocusableElement(currentTarget.parentElement, getComputedSelector(currentTarget.$_pfocustrap_focusableselector)) : currentTarget.$_pfocustrap_firsthiddenfocusableelement;
        (0, $cfkGk.DomHandler).focus(focusableElement);
    };
    var createHiddenFocusableElements = function createHiddenFocusableElements() {
        var _ref2 = props || {}, _ref2$tabIndex = _ref2.tabIndex, tabIndex = _ref2$tabIndex === void 0 ? 0 : _ref2$tabIndex;
        var createFocusableElement = function createFocusableElement(onFocus, section) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("span", {
                ref: section === "firstfocusableelement" ? firstFocusableElementRef : lastFocusableElementRef,
                className: "p-hidden-accessible p-hidden-focusable",
                tabIndex: tabIndex,
                role: "presentation",
                "aria-hidden": true,
                "data-p-hidden-accessible": true,
                "data-p-hidden-focusable": true,
                onFocus: onFocus,
                "data-pc-section": section
            });
        };
        var firstFocusableElement = createFocusableElement(onFirstHiddenElementFocus, "firstfocusableelement");
        var lastFocusableElement = createFocusableElement(onLastHiddenElementFocus, "lastfocusableelement");
        if (firstFocusableElement.ref.current && lastFocusableElement.ref.current) {
            firstFocusableElement.ref.current.$_pfocustrap_lasthiddenfocusableelement = lastFocusableElement.ref.current;
            lastFocusableElement.ref.current.$_pfocustrap_firsthiddenfocusableelement = firstFocusableElement.ref.current;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).Fragment, null, firstFocusableElement, props.children, lastFocusableElement);
    };
    return createHiddenFocusableElements();
}));
var $149bbf8d591193be$var$FocusTrap$1 = $149bbf8d591193be$var$FocusTrap;
function $149bbf8d591193be$var$ownKeys$4(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149bbf8d591193be$var$_objectSpread$4(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149bbf8d591193be$var$ownKeys$4(Object(t), !0).forEach(function(r) {
            $149bbf8d591193be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149bbf8d591193be$var$ownKeys$4(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149bbf8d591193be$var$ColumnFilter = /*#__PURE__*/ $81g6h.memo(function(props) {
    var _React$useState = $81g6h.useState(false), _React$useState2 = $149bbf8d591193be$var$_slicedToArray(_React$useState, 2), overlayVisibleState = _React$useState2[0], setOverlayVisibleState = _React$useState2[1];
    var overlayRef = $81g6h.useRef(null);
    var overlayId = $81g6h.useRef(null);
    var iconRef = $81g6h.useRef(null);
    var selfClick = $81g6h.useRef(false);
    var overlayEventListener = $81g6h.useRef(null);
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var getColumnProp = function getColumnProp(name) {
        return $149bbf8d591193be$var$ColumnBase.getCProp(props.column, name);
    };
    var getColumnProps = function getColumnProps() {
        return $149bbf8d591193be$var$ColumnBase.getCProps(props.column);
    };
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var getColumnPTOptions = function getColumnPTOptions(key, params) {
        var cProps = getColumnProps();
        var columnMetadata = $149bbf8d591193be$var$_objectSpread$4({
            props: cProps,
            parent: props.metaData,
            hostName: props.hostName,
            state: {
                overlayVisible: overlayVisibleState
            }
        }, params);
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetadata
        }), ptm("column.".concat(key), columnMetadata), ptmo(cProps, key, columnMetadata));
    };
    var field = getColumnProp("filterField") || getColumnProp("field");
    var filterModel = props.filters[field];
    var filterStoreModel = props.filtersStore && props.filtersStore[field];
    var _useOverlayListener = (0, $l2NC0.useOverlayListener)({
        target: iconRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var type = _ref.type, valid = _ref.valid;
            if (valid) type === "outside" ? !selfClick.current && !isTargetClicked(event.target) && hide() : hide();
            selfClick.current = false;
        },
        when: overlayVisibleState
    }), _useOverlayListener2 = $149bbf8d591193be$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var hasFilter = function hasFilter() {
        if (!filterStoreModel || !filterModel) return false;
        return filterStoreModel.operator ? !isFilterBlank(filterModel.constraints[0].value) : !isFilterBlank(filterModel.value);
    };
    var hasRowFilter = function hasRowFilter() {
        return filterModel && !isFilterBlank(filterModel.value);
    };
    var isFilterBlank = function isFilterBlank(filter) {
        return (0, $cfkGk.ObjectUtils).isEmpty(filter);
    };
    var isRowMatchModeSelected = function isRowMatchModeSelected(matchMode) {
        return filterModel && filterModel.matchMode === matchMode;
    };
    var matchModes = function matchModes() {
        return getColumnProp("filterMatchModeOptions") || context && context.filterMatchModeOptions[findDataType()].map(function(key) {
            return {
                label: (0, $8Zwsm.localeOption)(key),
                value: key
            };
        }) || (0, $8Zwsm.default).filterMatchModeOptions[findDataType()].map(function(key) {
            return {
                label: (0, $8Zwsm.localeOption)(key),
                value: key
            };
        });
    };
    var isShowMenuButton = function isShowMenuButton() {
        return getColumnProp("showFilterMenu") && (props.display === "row" ? getColumnProp("dataType") !== "boolean" : true);
    };
    var isShowClearButton = function isShowClearButton() {
        return getColumnProp("showClearButton") && props.display === "row";
    };
    var isShowMatchModes = function isShowMatchModes() {
        return getColumnProp("dataType") !== "boolean" && getColumnProp("showFilterMatchModes") && matchModes() && getColumnProp("showFilterMenuOptions");
    };
    var isShowOperator = function isShowOperator() {
        return getColumnProp("showFilterOperator") && filterModel && filterModel.operator && getColumnProp("showFilterMenuOptions");
    };
    var showRemoveIcon = function showRemoveIcon() {
        return fieldConstraints().length > 1;
    };
    var isShowAddConstraint = function isShowAddConstraint() {
        return getColumnProp("showAddButton") && filterModel && filterModel.operator && fieldConstraints() && fieldConstraints().length < getColumnProp("maxConstraints") && getColumnProp("showFilterMenuOptions");
    };
    var isOutsideClicked = function isOutsideClicked(target) {
        return !isTargetClicked(target) && overlayRef.current && !(overlayRef.current.isSameNode(target) || overlayRef.current.contains(target));
    };
    var isTargetClicked = function isTargetClicked(target) {
        return iconRef.current && (iconRef.current.isSameNode(target) || iconRef.current.contains(target));
    };
    var getDefaultConstraint = function getDefaultConstraint() {
        if (filterStoreModel) {
            if (filterStoreModel.operator) return {
                matchMode: filterStoreModel.constraints[0].matchMode,
                operator: filterStoreModel.operator
            };
            return {
                matchMode: filterStoreModel.matchMode
            };
        }
    };
    var findDataType = function findDataType() {
        var dataType = getColumnProp("dataType");
        var matchMode = getColumnProp("filterMatchMode");
        var hasMatchMode = function hasMatchMode(key) {
            return context && context.filterMatchModeOptions[key].some(function(mode) {
                return mode === matchMode;
            }) || (0, $8Zwsm.default).filterMatchModeOptions[key].some(function(mode) {
                return mode === matchMode;
            });
        };
        if (matchMode === "custom" && !hasMatchMode(dataType)) {
            context && context.filterMatchModeOptions[dataType].push((0, $8Zwsm.FilterMatchMode).CUSTOM) || (0, $8Zwsm.default).filterMatchModeOptions[dataType].push((0, $8Zwsm.FilterMatchMode).CUSTOM);
            return dataType;
        } else if (matchMode) return Object.keys(context && context.filterMatchModeOptions || (0, $8Zwsm.default).filterMatchModeOptions).find(function(key) {
            return hasMatchMode(key);
        }) || dataType;
        return dataType;
    };
    var clearFilter = function clearFilter() {
        var filterClearCallback = getColumnProp("onFilterClear");
        var defaultConstraint = getDefaultConstraint();
        var filters = $149bbf8d591193be$var$_objectSpread$4({}, props.filters);
        if (filters[field].operator) {
            filters[field].constraints.splice(1);
            filters[field].operator = defaultConstraint.operator;
            filters[field].constraints[0] = {
                value: null,
                matchMode: defaultConstraint.matchMode
            };
        } else {
            filters[field].value = null;
            filters[field].matchMode = defaultConstraint.matchMode;
        }
        filterClearCallback && filterClearCallback();
        props.onFilterChange(filters);
        props.onFilterApply();
        hide();
    };
    var applyFilter = function applyFilter() {
        var filterApplyClickCallback = getColumnProp("onFilterApplyClick");
        filterApplyClickCallback && filterApplyClickCallback({
            field: field,
            constraints: filterModel
        });
        props.onFilterApply();
        hide();
    };
    var toggleMenu = function toggleMenu() {
        setOverlayVisibleState(function(prevVisible) {
            return !prevVisible;
        });
    };
    var onToggleButtonKeyDown = function onToggleButtonKeyDown(event) {
        switch(event.key){
            case "Escape":
            case "Tab":
                hide();
                break;
            case "ArrowDown":
                if (overlayVisibleState) {
                    var focusable = (0, $cfkGk.DomHandler).getFirstFocusableElement(overlayRef.current);
                    focusable && focusable.focus();
                    event.preventDefault();
                } else if (event.altKey) {
                    setOverlayVisibleState(true);
                    event.preventDefault();
                }
                break;
        }
    };
    var onContentKeyDown = function onContentKeyDown(event) {
        if (event.key === "Escape") {
            hide();
            iconRef.current && iconRef.current.focus();
        }
    };
    var onInputChange = function onInputChange(event, index) {
        var filters = $149bbf8d591193be$var$_objectSpread$4({}, props.filters);
        var value = event.target.value;
        var filterField = filters[field];
        if (props.display === "menu" && (0, $cfkGk.ObjectUtils).isNotEmpty(filterField.constraints)) filterField.constraints[index].value = value;
        else filterField.value = value;
        props.onFilterChange(filters);
        if (!getColumnProp("showApplyButton") || props.display === "row") props.onFilterApply();
    };
    var onInputKeydown = function onInputKeydown(event, _index) {
        if (event.key === "Enter") {
            if (!getColumnProp("showApplyButton") || props.display === "menu") applyFilter();
        }
    };
    var onRowMatchModeChange = function onRowMatchModeChange(matchMode) {
        var filterMatchModeChangeCallback = getColumnProp("onFilterMatchModeChange");
        var filters = $149bbf8d591193be$var$_objectSpread$4({}, props.filters);
        filters[field].matchMode = matchMode;
        filterMatchModeChangeCallback && filterMatchModeChangeCallback({
            field: field,
            matchMode: matchMode
        });
        props.onFilterChange(filters);
        props.onFilterApply();
        hide();
    };
    var onRowMatchModeKeyDown = function onRowMatchModeKeyDown(event, matchMode, clear) {
        var item = event.target;
        switch(event.key){
            case "ArrowDown":
                var nextItem = findNextItem(item);
                if (nextItem) {
                    item.removeAttribute("tabindex");
                    nextItem.tabIndex = 0;
                    nextItem.focus();
                }
                event.preventDefault();
                break;
            case "ArrowUp":
                var prevItem = findPrevItem(item);
                if (prevItem) {
                    item.removeAttribute("tabindex");
                    prevItem.tabIndex = 0;
                    prevItem.focus();
                }
                event.preventDefault();
                break;
            case "Enter":
                clear ? clearFilter() : onRowMatchModeChange(matchMode.value);
                event.preventDefault();
                break;
        }
    };
    var onOperatorChange = function onOperatorChange(e) {
        var filterOperationChangeCallback = getColumnProp("onFilterOperatorChange");
        var value = e.value;
        var filters = $149bbf8d591193be$var$_objectSpread$4({}, props.filters);
        filters[field].operator = value;
        props.onFilterChange(filters);
        filterOperationChangeCallback && filterOperationChangeCallback({
            field: field,
            operator: value
        });
        if (!getColumnProp("showApplyButton")) props.onFilterApply();
    };
    var onMenuMatchModeChange = function onMenuMatchModeChange(value, index) {
        var filterMatchModeChangeCallback = getColumnProp("onFilterMatchModeChange");
        var filters = $149bbf8d591193be$var$_objectSpread$4({}, props.filters);
        var filterField = filters[field];
        if (props.display === "menu" && (0, $cfkGk.ObjectUtils).isNotEmpty(filterField.constraints)) filterField.constraints[index].matchMode = value;
        else filterField.matchMode = value;
        props.onFilterChange(filters);
        filterMatchModeChangeCallback && filterMatchModeChangeCallback({
            field: field,
            matchMode: value,
            index: index
        });
        if (!getColumnProp("showApplyButton")) props.onFilterApply();
    };
    var addConstraint = function addConstraint() {
        var filterConstraintAddCallback = getColumnProp("onFilterConstraintAdd");
        var defaultConstraint = getDefaultConstraint();
        var filters = $149bbf8d591193be$var$_objectSpread$4({}, props.filters);
        var newConstraint = {
            value: null,
            matchMode: defaultConstraint.matchMode
        };
        filters[field].constraints.push(newConstraint);
        filterConstraintAddCallback && filterConstraintAddCallback({
            field: field,
            constraint: newConstraint
        });
        props.onFilterChange(filters);
        if (!getColumnProp("showApplyButton")) props.onFilterApply();
    };
    var removeConstraint = function removeConstraint(index) {
        var filterConstraintRemoveCallback = getColumnProp("onFilterConstraintRemove");
        var filters = $149bbf8d591193be$var$_objectSpread$4({}, props.filters);
        var removedConstraint = filters[field].constraints.splice(index, 1);
        filterConstraintRemoveCallback && filterConstraintRemoveCallback({
            field: field,
            constraint: removedConstraint
        });
        props.onFilterChange(filters);
        if (!getColumnProp("showApplyButton")) props.onFilterApply();
    };
    var findNextItem = function findNextItem(item) {
        var nextItem = item.nextElementSibling;
        return nextItem ? (0, $cfkGk.DomHandler).getAttribute(nextItem, "data-p-column-filter-separator") === true ? findNextItem(nextItem) : nextItem : item.parentElement.firstElementChild;
    };
    var findPrevItem = function findPrevItem(item) {
        var prevItem = item.previousElementSibling;
        return prevItem ? (0, $cfkGk.DomHandler).getAttribute(prevItem, "data-p-column-filter-separator") === true ? findPrevItem(prevItem) : prevItem : item.parentElement.lastElementChild;
    };
    var hide = function hide() {
        setOverlayVisibleState(false);
    };
    var onContentClick = function onContentClick(event) {
        selfClick.current = true;
        (0, $k7ffa.OverlayService).emit("overlay-click", {
            originalEvent: event,
            target: overlayRef.current
        });
    };
    var onContentMouseDown = function onContentMouseDown() {
        selfClick.current = true;
    };
    var onOverlayEnter = function onOverlayEnter() {
        (0, $cfkGk.ZIndexUtils).set("overlay", overlayRef.current, context && context.autoZIndex || (0, $8Zwsm.default).autoZIndex, context && context.zIndex.overlay || (0, $8Zwsm.default).zIndex.overlay);
        (0, $cfkGk.DomHandler).addStyles(overlayRef.current, {
            position: "absolute",
            top: "0",
            left: "0"
        });
        (0, $cfkGk.DomHandler).alignOverlay(overlayRef.current, iconRef.current, context && context.appendTo || (0, $8Zwsm.default).appendTo, false);
        overlayEventListener.current = function(e) {
            if (!isOutsideClicked(e.target)) selfClick.current = true;
        };
        (0, $k7ffa.OverlayService).on("overlay-click", overlayEventListener.current);
    };
    var onOverlayEntered = function onOverlayEntered() {
        bindOverlayListener();
    };
    var onOverlayExit = function onOverlayExit() {
        onOverlayHide();
    };
    var onOverlayExited = function onOverlayExited() {
        (0, $cfkGk.ZIndexUtils).clear(overlayRef.current);
    };
    var onOverlayHide = function onOverlayHide() {
        unbindOverlayListener();
        (0, $k7ffa.OverlayService).off("overlay-click", overlayEventListener.current);
        overlayEventListener.current = null;
        selfClick.current = false;
    };
    var fieldConstraints = function fieldConstraints() {
        return filterModel ? filterModel.constraints || [
            filterModel
        ] : [];
    };
    var operator = function operator() {
        return filterModel.operator;
    };
    var operatorOptions = function operatorOptions() {
        return [
            {
                label: (0, $8Zwsm.localeOption)("matchAll"),
                value: (0, $8Zwsm.FilterOperator).AND
            },
            {
                label: (0, $8Zwsm.localeOption)("matchAny"),
                value: (0, $8Zwsm.FilterOperator).OR
            }
        ];
    };
    var noFilterLabel = function noFilterLabel() {
        return (0, $8Zwsm.localeOption)("noFilter");
    };
    var removeRuleButtonLabel = function removeRuleButtonLabel() {
        return (0, $8Zwsm.localeOption)("removeRule");
    };
    var addRuleButtonLabel = function addRuleButtonLabel() {
        return (0, $8Zwsm.localeOption)("addRule");
    };
    var clearButtonLabel = function clearButtonLabel() {
        return (0, $8Zwsm.localeOption)("clear");
    };
    var applyButtonLabel = function applyButtonLabel() {
        return (0, $8Zwsm.localeOption)("apply");
    };
    var filterCallback = function filterCallback(value) {
        var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var filters = $149bbf8d591193be$var$_objectSpread$4({}, props.filters);
        var meta = filters[field];
        props.display === "menu" && meta && meta.operator ? filters[field].constraints[index].value = value : filters[field].value = value;
        props.onFilterChange(filters);
    };
    var filterApplyCallback = function filterApplyCallback() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        args && filterCallback(args[0], args[1]);
        props.onFilterApply();
    };
    (0, $l2NC0.useUpdateEffect)(function() {
        if (props.display === "menu" && overlayVisibleState) (0, $cfkGk.DomHandler).alignOverlay(overlayRef.current, iconRef.current, context && context.appendTo || (0, $8Zwsm.default).appendTo, false);
    });
    (0, $l2NC0.useMountEffect)(function() {
        if (!overlayId.current) overlayId.current = (0, $cfkGk.UniqueComponentId)();
    });
    (0, $l2NC0.useUnmountEffect)(function() {
        if (overlayEventListener.current) {
            (0, $k7ffa.OverlayService).off("overlay-click", overlayEventListener.current);
            overlayEventListener.current = null;
        }
        if (overlayRef.current) {
            (0, $cfkGk.ZIndexUtils).clear(overlayRef.current);
            onOverlayHide();
        }
    });
    var createFilterElement = function createFilterElement(model, index) {
        var value = model ? model.value : null;
        return getColumnProp("filterElement") ? (0, $cfkGk.ObjectUtils).getJSXElement(getColumnProp("filterElement"), {
            field: field,
            index: index,
            filterModel: model,
            value: value,
            filterApplyCallback: filterApplyCallback,
            filterCallback: filterCallback
        }) : /*#__PURE__*/ $81g6h.createElement((0, $6ccvc.InputText), {
            type: getColumnProp("filterType"),
            value: value || "",
            onChange: function onChange(e) {
                return onInputChange(e, index);
            },
            onKeyDown: function onKeyDown(e) {
                return onInputKeydown(e);
            },
            className: "p-column-filter",
            placeholder: getColumnProp("filterPlaceholder"),
            maxLength: getColumnProp("filterMaxLength"),
            "aria-label": getColumnProp("filterPlaceholder"),
            unstyled: props.unstyled,
            __parentMetadata: {
                parent: props.metaData
            }
        });
    };
    var createRowFilterElement = function createRowFilterElement() {
        if (props.display === "row") {
            var content = createFilterElement(filterModel, 0);
            var filterInputProps = mergeProps({
                className: cx("filterInput")
            }, getColumnPTOptions("filterInput"));
            return /*#__PURE__*/ $81g6h.createElement("div", filterInputProps, content);
        }
        return null;
    };
    var createMenuFilterElement = function createMenuFilterElement(fieldConstraint, index) {
        return props.display === "menu" ? createFilterElement(fieldConstraint, index) : null;
    };
    var createMenuButton = function createMenuButton() {
        if (!isShowMenuButton()) return null;
        var filterIconProps = mergeProps({
            "aria-hidden": true
        }, getColumnPTOptions("filterIcon"));
        var icon = props.filterIcon || /*#__PURE__*/ $81g6h.createElement((0, $42wHR.FilterIcon), filterIconProps);
        var columnFilterIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $149bbf8d591193be$var$_objectSpread$4({}, filterIconProps), {
            props: props
        });
        var label = overlayVisibleState ? $149bbf8d591193be$var$ariaLabel("hideFilterMenu") : $149bbf8d591193be$var$ariaLabel("showFilterMenu");
        var filterMenuButtonProps = mergeProps({
            type: "button",
            className: cx("filterMenuButton", {
                overlayVisibleState: overlayVisibleState,
                hasFilter: hasFilter
            }),
            "aria-haspopup": true,
            "aria-expanded": overlayVisibleState,
            "aria-label": label,
            "aria-controls": overlayId.current,
            onClick: function onClick(e) {
                return toggleMenu();
            },
            onKeyDown: function onKeyDown(e) {
                return onToggleButtonKeyDown(e);
            }
        }, getColumnPTOptions("filterMenuButton", {
            context: {
                active: hasFilter()
            }
        }));
        return /*#__PURE__*/ $81g6h.createElement("button", $149bbf8d591193be$var$_extends({
            ref: iconRef
        }, filterMenuButtonProps), columnFilterIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
    };
    var createClearButton = function createClearButton() {
        if (!isShowClearButton()) return null;
        var filterClearIconProps = mergeProps({
            "aria-hidden": true
        }, getColumnPTOptions("filterClearIcon"));
        var icon = props.filterClearIcon || /*#__PURE__*/ $81g6h.createElement((0, $deOWu.FilterSlashIcon), filterClearIconProps);
        var filterClearIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $149bbf8d591193be$var$_objectSpread$4({}, filterClearIconProps), {
            props: props
        });
        var clearLabel = clearButtonLabel();
        var headerFilterClearButtonProps = mergeProps({
            className: cx("headerFilterClearButton", {
                hasRowFilter: hasRowFilter
            }),
            type: "button",
            onClick: function onClick(e) {
                return clearFilter();
            },
            "aria-label": clearLabel
        }, getColumnPTOptions("headerFilterClearButton", {
            context: {
                hidden: hasRowFilter()
            }
        }));
        return /*#__PURE__*/ $81g6h.createElement("button", headerFilterClearButtonProps, filterClearIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
    };
    var createRowItems = function createRowItems() {
        if (isShowMatchModes()) {
            var _matchModes = matchModes();
            var _noFilterLabel = noFilterLabel();
            var filterSeparatorProps = mergeProps({
                className: cx("filterSeparator"),
                "data-p-column-filter-separator": true
            }, getColumnPTOptions("filterSeparator"));
            var filterRowItemProps = mergeProps({
                className: cx("filterRowItem", {
                    isRowMatchModeSelected: isRowMatchModeSelected,
                    isShowMatchModes: isShowMatchModes
                }),
                onClick: function onClick(e) {
                    return clearFilter();
                },
                onKeyDown: function onKeyDown(e) {
                    return onRowMatchModeKeyDown(e, null, true);
                }
            }, getColumnPTOptions("filterRowItem"));
            var filterRowItemsProps = mergeProps({
                className: cx("filterRowItems")
            }, getColumnPTOptions("filterRowItems"));
            return /*#__PURE__*/ $81g6h.createElement("ul", filterRowItemsProps, _matchModes.map(function(matchMode, i) {
                var value = matchMode.value, label = matchMode.label;
                var tabIndex = i === 0 ? 0 : null;
                var filterRowItemProps = mergeProps({
                    className: cx("filterRowItem", {
                        isRowMatchModeSelected: isRowMatchModeSelected,
                        isShowMatchModes: isShowMatchModes,
                        value: value
                    }),
                    onClick: function onClick() {
                        return onRowMatchModeChange(value);
                    },
                    onKeyDown: function onKeyDown(e) {
                        return onRowMatchModeKeyDown(e, matchMode);
                    },
                    tabIndex: tabIndex
                }, getColumnPTOptions("filterRowItem", {
                    context: {
                        highlighted: matchMode && isRowMatchModeSelected(value)
                    }
                }));
                return /*#__PURE__*/ $81g6h.createElement("li", $149bbf8d591193be$var$_extends({}, filterRowItemProps, {
                    key: label
                }), label);
            }), /*#__PURE__*/ $81g6h.createElement("li", filterSeparatorProps), /*#__PURE__*/ $81g6h.createElement("li", filterRowItemProps, _noFilterLabel));
        }
        return null;
    };
    var createOperator = function createOperator() {
        if (isShowOperator()) {
            var options = operatorOptions();
            var value = operator();
            var filterOperatorProps = mergeProps({
                className: cx("filterOperator")
            }, getColumnPTOptions("filterOperator"));
            return /*#__PURE__*/ $81g6h.createElement("div", filterOperatorProps, /*#__PURE__*/ $81g6h.createElement((0, $eT9rN.Dropdown), {
                options: options,
                value: value,
                onChange: onOperatorChange,
                className: "p-column-filter-operator-dropdown",
                pt: getColumnPTOptions("filterOperatorDropdown"),
                unstyled: props.unstyled,
                __parentMetadata: {
                    parent: props.metaData
                },
                "aria-label": $149bbf8d591193be$var$ariaLabel("filterOperator")
            }));
        }
        return null;
    };
    var createMatchModeDropdown = function createMatchModeDropdown(constraint, index) {
        if (isShowMatchModes()) {
            var options = matchModes();
            return /*#__PURE__*/ $81g6h.createElement((0, $eT9rN.Dropdown), {
                options: options,
                value: constraint.matchMode,
                onChange: function onChange(e) {
                    return onMenuMatchModeChange(e.value, index);
                },
                className: "p-column-filter-matchmode-dropdown",
                pt: getColumnPTOptions("filterMatchModeDropdown"),
                unstyled: props.unstyled,
                __parentMetadata: {
                    parent: props.metaData
                },
                "aria-label": $149bbf8d591193be$var$ariaLabel("filterConstraint")
            });
        }
        return null;
    };
    var createRemoveButton = function createRemoveButton(index) {
        if (showRemoveIcon()) {
            var removeRuleLabel = removeRuleButtonLabel();
            return /*#__PURE__*/ $81g6h.createElement((0, $9AWgp.Button), {
                type: "button",
                icon: props.filterRemoveIcon || /*#__PURE__*/ $81g6h.createElement((0, $2NGYW.TrashIcon), null),
                className: "p-column-filter-remove-button p-button-text p-button-danger p-button-sm",
                onClick: function onClick() {
                    return removeConstraint(index);
                },
                label: removeRuleLabel,
                pt: getColumnPTOptions("filterRemoveButton"),
                unstyled: props.unstyled,
                __parentMetadata: {
                    parent: props.metaData
                }
            });
        }
        return null;
    };
    var createConstraints = function createConstraints() {
        var _fieldConstraints = fieldConstraints();
        var filterConstraintsProps = mergeProps({
            className: cx("filterConstraints")
        }, getColumnPTOptions("filterConstraints"));
        var filterConstraintProps = mergeProps({
            className: cx("filterConstraint")
        }, getColumnPTOptions("filterConstraint"));
        return /*#__PURE__*/ $81g6h.createElement("div", filterConstraintsProps, _fieldConstraints.map(function(fieldConstraint, i) {
            var matchModeDropdown = createMatchModeDropdown(fieldConstraint, i);
            var menuFilterElement = createMenuFilterElement(fieldConstraint, i);
            var removeButton = createRemoveButton(i);
            var filterRemoveProps = mergeProps(getColumnPTOptions("filterRemove"));
            return /*#__PURE__*/ $81g6h.createElement("div", $149bbf8d591193be$var$_extends({}, filterConstraintProps, {
                key: i
            }), matchModeDropdown, menuFilterElement, /*#__PURE__*/ $81g6h.createElement("div", filterRemoveProps, removeButton));
        }));
    };
    var createAddRule = function createAddRule() {
        if (isShowAddConstraint()) {
            var addRuleLabel = addRuleButtonLabel();
            var filterAddRuleProps = mergeProps({
                className: cx("filterAddRule")
            }, getColumnPTOptions("filterAddRule"));
            return /*#__PURE__*/ $81g6h.createElement("div", filterAddRuleProps, /*#__PURE__*/ $81g6h.createElement((0, $9AWgp.Button), {
                type: "button",
                label: addRuleLabel,
                icon: props.filterAddIcon || /*#__PURE__*/ $81g6h.createElement((0, $ddETg.PlusIcon), null),
                className: "p-column-filter-add-button p-button-text p-button-sm",
                onClick: addConstraint,
                pt: getColumnPTOptions("filterAddRuleButton"),
                unstyled: props.unstyled,
                __parentMetadata: {
                    parent: props.metaData
                }
            }));
        }
        return null;
    };
    var createFilterClearButton = function createFilterClearButton() {
        if (getColumnProp("showClearButton")) {
            if (!getColumnProp("filterClear")) {
                var clearLabel = clearButtonLabel();
                return /*#__PURE__*/ $81g6h.createElement((0, $9AWgp.Button), {
                    type: "button",
                    outlined: true,
                    size: "small",
                    onClick: clearFilter,
                    label: clearLabel,
                    pt: getColumnPTOptions("filterClearButton"),
                    unstyled: props.unstyled,
                    __parentMetadata: {
                        parent: props.metaData
                    }
                });
            }
            return (0, $cfkGk.ObjectUtils).getJSXElement(getColumnProp("filterClear"), {
                field: field,
                filterModel: filterModel,
                filterClearCallback: clearFilter
            });
        }
        return null;
    };
    var createFilterApplyButton = function createFilterApplyButton() {
        if (getColumnProp("showApplyButton")) {
            if (!getColumnProp("filterApply")) {
                var applyLabel = applyButtonLabel();
                return /*#__PURE__*/ $81g6h.createElement((0, $9AWgp.Button), {
                    type: "button",
                    size: "small",
                    onClick: applyFilter,
                    label: applyLabel,
                    pt: getColumnPTOptions("filterApplyButton"),
                    unstyled: props.unstyled,
                    __parentMetadata: {
                        parent: props.metaData
                    }
                });
            }
            return (0, $cfkGk.ObjectUtils).getJSXElement(getColumnProp("filterApply"), {
                field: field,
                filterModel: filterModel,
                filterApplyCallback: applyFilter
            });
        }
        return null;
    };
    var createButtonBar = function createButtonBar() {
        var clearButton = createFilterClearButton();
        var applyButton = createFilterApplyButton();
        var filterButtonbarProps = mergeProps({
            className: cx("filterButtonBar")
        }, getColumnPTOptions("filterButtonBar"));
        return /*#__PURE__*/ $81g6h.createElement("div", filterButtonbarProps, clearButton, applyButton);
    };
    var createItems = function createItems() {
        var operator = createOperator();
        var constraints = createConstraints();
        var addRule = createAddRule();
        var buttonBar = createButtonBar();
        return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, operator, constraints, addRule, buttonBar);
    };
    var createOverlay = function createOverlay() {
        var style = getColumnProp("filterMenuStyle");
        var filterHeader = (0, $cfkGk.ObjectUtils).getJSXElement(getColumnProp("filterHeader"), {
            field: field,
            filterModel: filterModel,
            filterApplyCallback: filterApplyCallback
        });
        var filterFooter = (0, $cfkGk.ObjectUtils).getJSXElement(getColumnProp("filterFooter"), {
            field: field,
            filterModel: filterModel,
            filterApplyCallback: filterApplyCallback
        });
        var items = props.display === "row" ? createRowItems() : createItems();
        var filterOverlayProps = mergeProps({
            style: style,
            className: cx("filterOverlay", {
                columnFilterProps: props,
                context: context,
                getColumnProp: getColumnProp
            }),
            onKeyDown: function onKeyDown(e) {
                return onContentKeyDown(e);
            },
            onClick: function onClick(e) {
                return onContentClick(e);
            },
            onMouseDown: function onMouseDown(e) {
                return onContentMouseDown();
            },
            id: overlayId.current,
            "aria-modal": overlayVisibleState,
            role: "dialog"
        }, getColumnPTOptions("filterOverlay"));
        var transitionProps = mergeProps({
            classNames: cx("transition"),
            "in": overlayVisibleState,
            timeout: {
                enter: 120,
                exit: 100
            },
            unmountOnExit: true,
            onEnter: onOverlayEnter,
            onEntered: onOverlayEntered,
            onExit: onOverlayExit,
            onExited: onOverlayExited
        }, getColumnPTOptions("transition"));
        return /*#__PURE__*/ $81g6h.createElement((0, $6b4aU.Portal), null, /*#__PURE__*/ $81g6h.createElement((0, $lbdsH.CSSTransition), $149bbf8d591193be$var$_extends({
            nodeRef: overlayRef
        }, transitionProps), /*#__PURE__*/ $81g6h.createElement("div", $149bbf8d591193be$var$_extends({
            ref: overlayRef
        }, filterOverlayProps), /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$FocusTrap$1, {
            autoFocus: true
        }, filterHeader, items, filterFooter))));
    };
    var rowFilterElement = createRowFilterElement();
    var menuButton = createMenuButton();
    var clearButton = createClearButton();
    var overlay = createOverlay();
    var columnFilter = mergeProps({
        className: cx("columnFilter", {
            columnFilterProps: props
        })
    }, getColumnPTOptions("columnFilter"));
    return /*#__PURE__*/ $81g6h.createElement("div", columnFilter, rowFilterElement, menuButton, clearButton, overlay);
});
$149bbf8d591193be$var$ColumnFilter.displayName = "ColumnFilter";
function $149bbf8d591193be$var$ownKeys$3(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149bbf8d591193be$var$_objectSpread$3(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149bbf8d591193be$var$ownKeys$3(Object(t), !0).forEach(function(r) {
            $149bbf8d591193be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149bbf8d591193be$var$ownKeys$3(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149bbf8d591193be$var$HeaderCheckbox = /*#__PURE__*/ $81g6h.memo(function(props) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var getColumnProps = function getColumnProps() {
        return $149bbf8d591193be$var$ColumnBase.getCProps(props.column);
    };
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var getColumnPTOptions = function getColumnPTOptions(key) {
        var cProps = getColumnProps();
        var columnMetaData = {
            props: cProps,
            parent: props.metaData,
            hostName: props.hostName,
            state: {},
            context: {
                checked: props.checked,
                disabled: props.disabled
            }
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(cProps, key, columnMetaData));
    };
    var onChange = function onChange(event) {
        if (!props.disabled) props.onChange({
            originalEvent: event,
            checked: !props.checked
        });
    };
    var headerCheckboxIconProps = mergeProps({
        className: cx("checkIcon")
    }, getColumnPTOptions("headerCheckbox.icon"));
    var icon = props.checked ? props.checkIcon || /*#__PURE__*/ $81g6h.createElement((0, $h7Chj.CheckIcon), headerCheckboxIconProps) : null;
    var checkIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $149bbf8d591193be$var$_objectSpread$3({}, headerCheckboxIconProps), {
        props: props
    });
    var tabIndex = props.disabled ? null : 0;
    var headerCheckboxProps = mergeProps({
        role: "checkbox",
        "aria-checked": props.checked,
        "aria-label": props.checked ? $149bbf8d591193be$var$ariaLabel("selectAll") : $149bbf8d591193be$var$ariaLabel("unselectAll"),
        tabIndex: tabIndex,
        onChange: onChange,
        icon: checkIcon,
        checked: props.checked,
        disabled: props.disabled
    }, getColumnPTOptions("headerCheckbox"));
    return /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$Checkbox, headerCheckboxProps);
});
$149bbf8d591193be$var$HeaderCheckbox.displayName = "HeaderCheckbox";
function $149bbf8d591193be$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149bbf8d591193be$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149bbf8d591193be$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $149bbf8d591193be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149bbf8d591193be$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149bbf8d591193be$var$HeaderCell = /*#__PURE__*/ $81g6h.memo(function(props) {
    var _React$useState = $81g6h.useState({}), _React$useState2 = $149bbf8d591193be$var$_slicedToArray(_React$useState, 2), styleObjectState = _React$useState2[0], setStyleObjectState = _React$useState2[1];
    var elementRef = $81g6h.useRef(null);
    var prevColumn = (0, $l2NC0.usePrevious)(props.column);
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var parentMetaData = props.metaData, ptCallbacks = props.ptCallbacks, index = props.index;
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var params = {
        index: index
    };
    var parentParams = $149bbf8d591193be$var$_objectSpread$2($149bbf8d591193be$var$_objectSpread$2({}, parentMetaData), params);
    var getColumnProps = function getColumnProps() {
        return $149bbf8d591193be$var$ColumnBase.getCProps(props.column);
    };
    var getColumnPTOptions = function getColumnPTOptions(key) {
        var cProps = getColumnProps();
        var columnMetaData = {
            props: cProps,
            parent: parentParams,
            hostName: props.hostName,
            state: {
                styleObject: styleObjectState
            },
            context: {
                index: props.index,
                sorted: getSortMeta().sorted,
                resizable: props.resizableColumns,
                size: props.metaData.props.size,
                showGridlines: props.metaData.props.showGridlines
            }
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(cProps, key, columnMetaData));
    };
    var isBadgeVisible = function isBadgeVisible() {
        return props.multiSortMeta && props.multiSortMeta.length > 1;
    };
    var isSortableDisabled = function isSortableDisabled() {
        return !getColumnProp("sortable") || getColumnProp("sortable") && (props.allSortableDisabled || getColumnProp("sortableDisabled"));
    };
    var getColumnProp = function getColumnProp() {
        return props.column ? typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string" ? $149bbf8d591193be$var$ColumnBase.getCProp(props.column, arguments.length <= 0 ? undefined : arguments[0]) : $149bbf8d591193be$var$ColumnBase.getCProp((arguments.length <= 0 ? undefined : arguments[0]) || props.column, arguments.length <= 1 ? undefined : arguments[1]) : null;
    };
    var getStyle = function getStyle() {
        var headerStyle = getColumnProp("headerStyle");
        var columnStyle = getColumnProp("style");
        return getColumnProp("frozen") ? Object.assign({}, columnStyle, headerStyle, styleObjectState) : Object.assign({}, columnStyle, headerStyle);
    };
    var getMultiSortMetaIndex = function getMultiSortMetaIndex() {
        return props.multiSortMeta.findIndex(function(meta) {
            return meta.field === getColumnProp("field") || meta.field === getColumnProp("sortField");
        });
    };
    var getSortMeta = function getSortMeta() {
        var sorted = false;
        var sortOrder = 0;
        var metaIndex = -1;
        if (props.sortMode === "single") {
            sorted = props.sortField && (props.sortField === getColumnProp("field") || props.sortField === getColumnProp("sortField"));
            sortOrder = sorted ? props.sortOrder : 0;
        } else if (props.sortMode === "multiple") {
            metaIndex = getMultiSortMetaIndex();
            if (metaIndex > -1) {
                sorted = true;
                sortOrder = props.multiSortMeta[metaIndex].order;
            }
        }
        return {
            sorted: sorted,
            sortOrder: sortOrder,
            metaIndex: metaIndex
        };
    };
    var getAriaSort = function getAriaSort(_ref) {
        var sorted = _ref.sorted, sortOrder = _ref.sortOrder;
        if (getColumnProp("sortable")) {
            if (sorted && sortOrder < 0) return "descending";
            else if (sorted && sortOrder > 0) return "ascending";
            return "none";
        }
        return null;
    };
    var updateStickyPosition = function updateStickyPosition() {
        if (getColumnProp("frozen")) {
            var styleObject = $149bbf8d591193be$var$_objectSpread$2({}, styleObjectState);
            var align = getColumnProp("alignFrozen");
            if (align === "right") {
                var right = 0;
                var next = elementRef.current.nextElementSibling;
                if (next) right = (0, $cfkGk.DomHandler).getOuterWidth(next) + parseFloat(next.style.right || 0);
                styleObject.right = right + "px";
            } else {
                var left = 0;
                var prev = elementRef.current.previousElementSibling;
                if (prev) left = (0, $cfkGk.DomHandler).getOuterWidth(prev) + parseFloat(prev.style.left || 0);
                styleObject.left = left + "px";
            }
            var filterRow = elementRef.current.parentElement.nextElementSibling;
            if (filterRow) {
                var _index = (0, $cfkGk.DomHandler).index(elementRef.current);
                filterRow.children[_index].style.left = styleObject.left;
                filterRow.children[_index].style.right = styleObject.right;
            }
            var isSameStyle = styleObjectState.left === styleObject.left && styleObjectState.right === styleObject.right;
            !isSameStyle && setStyleObjectState(styleObject);
        }
    };
    var updateSortableDisabled = function updateSortableDisabled(prevColumn) {
        if (getColumnProp(prevColumn, "sortableDisabled") !== getColumnProp("sortableDisabled") || getColumnProp(prevColumn, "sortable") !== getColumnProp("sortable")) props.onSortableChange();
    };
    var _onClick = function onClick(event) {
        if (!isSortableDisabled()) {
            var targetNode = event.target;
            if ((0, $cfkGk.DomHandler).getAttribute(targetNode, "data-p-sortable-column") === true || (0, $cfkGk.DomHandler).getAttribute(targetNode, "data-pc-section") === "headertitle" || (0, $cfkGk.DomHandler).getAttribute(targetNode, "data-pc-section") === "headercontent" || (0, $cfkGk.DomHandler).getAttribute(targetNode, "data-pc-section") === "sortIcon" || (0, $cfkGk.DomHandler).getAttribute(targetNode.parentElement, "data-pc-section") === "sortIcon" || targetNode.closest('[data-p-sortable-column="true"]') && !targetNode.closest('[data-pc-section="filtermenubutton"]')) {
                (0, $cfkGk.DomHandler).clearSelection();
                props.onSortChange({
                    originalEvent: event,
                    column: props.column,
                    sortableDisabledFields: props.sortableDisabledFields
                });
            }
        }
    };
    var _onMouseDown = function onMouseDown(event) {
        props.onColumnMouseDown({
            originalEvent: event,
            column: props.column
        });
    };
    var _onKeyDown = function onKeyDown(event) {
        if ((event.code == "Enter" || event.code === "NumpadEnter" || event.code == "Space") && event.currentTarget === elementRef.current && (0, $cfkGk.DomHandler).getAttribute(event.currentTarget, "data-p-sortable-column") === "true") {
            _onClick(event);
            event.preventDefault();
        }
    };
    var _onDragStart = function onDragStart(event) {
        props.onColumnDragStart({
            originalEvent: event,
            column: props.column
        });
    };
    var _onDragOver = function onDragOver(event) {
        props.onColumnDragOver({
            originalEvent: event,
            column: props.column
        });
    };
    var _onDragLeave = function onDragLeave(event) {
        props.onColumnDragLeave({
            originalEvent: event,
            column: props.column
        });
    };
    var _onDrop = function onDrop(event) {
        props.onColumnDrop({
            originalEvent: event,
            column: props.column
        });
    };
    var onResizeStart = function onResizeStart(event) {
        props.onColumnResizeStart({
            originalEvent: event,
            column: props.column
        });
    };
    var onResizerClick = function onResizerClick(event) {
        if (props.onColumnResizerClick) {
            props.onColumnResizerClick({
                originalEvent: event,
                element: event.currentTarget.parentElement,
                column: props.column
            });
            event.preventDefault();
        }
    };
    var onResizerDoubleClick = function onResizerDoubleClick(event) {
        if (props.onColumnResizerDoubleClick) {
            props.onColumnResizerDoubleClick({
                originalEvent: event,
                element: event.currentTarget.parentElement,
                column: props.column
            });
            event.preventDefault();
        }
    };
    $81g6h.useEffect(function() {
        if (getColumnProp("frozen")) updateStickyPosition();
        updateSortableDisabled(prevColumn);
    });
    var createResizer = function createResizer() {
        if (props.resizableColumns && !getColumnProp("frozen")) {
            var columnResizerProps = mergeProps({
                className: cx("columnResizer"),
                onMouseDown: function onMouseDown(e) {
                    return onResizeStart(e);
                },
                onTouchStart: function onTouchStart(e) {
                    return onResizeStart(e);
                },
                onClick: function onClick(e) {
                    return onResizerClick(e);
                },
                onDoubleClick: function onDoubleClick(e) {
                    return onResizerDoubleClick(e);
                }
            }, getColumnPTOptions("columnResizer"));
            return /*#__PURE__*/ $81g6h.createElement("span", columnResizerProps);
        }
        return null;
    };
    var createTitle = function createTitle() {
        var title = (0, $cfkGk.ObjectUtils).getJSXElement(getColumnProp("header"), {
            props: props.tableProps
        });
        var headerTitleProps = mergeProps({
            className: cx("headerTitle")
        }, getColumnPTOptions("headerTitle"));
        return /*#__PURE__*/ $81g6h.createElement("span", headerTitleProps, title);
    };
    var createSortIcon = function createSortIcon(_ref2) {
        var sorted = _ref2.sorted, sortOrder = _ref2.sortOrder;
        if (getColumnProp("sortable")) {
            var sortIconProps = mergeProps({
                className: cx("sortIcon")
            }, getColumnPTOptions("sortIcon"));
            var sortProps = mergeProps(getColumnPTOptions("sort"));
            var icon = sorted ? sortOrder < 0 ? /*#__PURE__*/ $81g6h.createElement((0, $gft09.SortAmountDownIcon), sortIconProps) : /*#__PURE__*/ $81g6h.createElement((0, $7nQgj.SortAmountUpAltIcon), sortIconProps) : /*#__PURE__*/ $81g6h.createElement((0, $65uA4.SortAltIcon), sortIconProps);
            var sortIcon = (0, $cfkGk.IconUtils).getJSXIcon(props.sortIcon || icon, $149bbf8d591193be$var$_objectSpread$2({}, sortIconProps), {
                props: props,
                sorted: sorted,
                sortOrder: sortOrder
            });
            return /*#__PURE__*/ $81g6h.createElement("span", sortProps, sortIcon);
        }
        return null;
    };
    var createBadge = function createBadge(_ref3) {
        var metaIndex = _ref3.metaIndex;
        if (metaIndex !== -1 && isBadgeVisible()) {
            var value = props.groupRowsBy && props.groupRowsBy === props.groupRowSortField ? metaIndex : metaIndex + 1;
            var sortBadgeProps = mergeProps({
                className: cx("sortBadge")
            }, getColumnPTOptions("root"), getColumnPTOptions("sortBadge"));
            return /*#__PURE__*/ $81g6h.createElement("span", sortBadgeProps, value);
        }
        return null;
    };
    var createCheckbox = function createCheckbox() {
        if (props.showSelectAll && getColumnProp("selectionMode") === "multiple" && props.filterDisplay !== "row") {
            var allRowsSelected = props.allRowsSelected(props.value);
            return /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$HeaderCheckbox, {
                hostName: props.hostName,
                checked: allRowsSelected,
                onChange: props.onColumnCheckboxChange,
                disabled: props.empty,
                ptCallbacks: ptCallbacks,
                metaData: parentMetaData,
                unstyled: props.unstyled
            });
        }
        return null;
    };
    var createFilter = function createFilter() {
        if (props.filterDisplay === "menu" && getColumnProp("filter")) return /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$ColumnFilter, {
            hostName: props.hostName,
            display: "menu",
            column: props.column,
            filters: props.filters,
            onFilterChange: props.onFilterChange,
            onFilterApply: props.onFilterApply,
            filtersStore: props.filtersStore,
            filterIcon: props.filterIcon,
            filterClearIcon: props.filterClearIcon,
            ptCallbacks: ptCallbacks,
            metaData: parentMetaData,
            unstyled: props.unstyled
        });
        return null;
    };
    var createHeader = function createHeader(sortMeta) {
        var title = createTitle();
        var sortIcon = createSortIcon(sortMeta);
        var badge = createBadge(sortMeta);
        var checkbox = createCheckbox();
        var filter = createFilter();
        var headerContentProps = mergeProps({
            className: cx("headerContent")
        }, getColumnPTOptions("headerContent"));
        return /*#__PURE__*/ $81g6h.createElement("div", headerContentProps, title, sortIcon, badge, checkbox, filter);
    };
    var createElement = function createElement() {
        var _isSortableDisabled = isSortableDisabled();
        var sortMeta = getSortMeta();
        var style = getStyle();
        var align = getColumnProp("alignHeader") || getColumnProp("align");
        var frozen = getColumnProp("frozen");
        var tabIndex = getColumnProp("sortable") && !_isSortableDisabled ? props.tabIndex : null;
        var colSpan = getColumnProp("colSpan");
        var rowSpan = getColumnProp("rowSpan");
        var ariaSort = getAriaSort(sortMeta);
        var headerTooltip = getColumnProp("headerTooltip");
        var headerClassName = getColumnProp("headerClassName");
        var hasTooltip = (0, $cfkGk.ObjectUtils).isNotEmpty(headerTooltip);
        var headerTooltipOptions = getColumnProp("headerTooltipOptions");
        var resizer = createResizer();
        var header = createHeader(sortMeta);
        var headerCellProps = mergeProps({
            className: (0, $cfkGk.classNames)(headerClassName, cx("headerCell", {
                headerProps: props,
                frozen: frozen,
                sortMeta: sortMeta,
                align: align,
                _isSortableDisabled: _isSortableDisabled,
                getColumnProp: getColumnProp
            })),
            style: style,
            role: "columnheader",
            onClick: function onClick(e) {
                return _onClick(e);
            },
            onKeyDown: function onKeyDown(e) {
                return _onKeyDown(e);
            },
            onMouseDown: function onMouseDown(e) {
                return _onMouseDown(e);
            },
            onDragStart: function onDragStart(e) {
                return _onDragStart(e);
            },
            onDragOver: function onDragOver(e) {
                return _onDragOver(e);
            },
            onDragLeave: function onDragLeave(e) {
                return _onDragLeave(e);
            },
            onDrop: function onDrop(e) {
                return _onDrop(e);
            },
            tabIndex: tabIndex,
            colSpan: colSpan,
            rowSpan: rowSpan,
            "aria-sort": ariaSort,
            "data-p-sortable-column": getColumnProp("sortable"),
            "data-p-resizable-column": props.resizableColumns,
            "data-p-highlight": sortMeta.sorted,
            "data-p-filter-column": !props.metaData.props.headerColumnGroup && props.filterDisplay === "row",
            "data-p-frozen-column": getColumnProp("frozen"),
            "data-p-reorderable-column": props.reorderableColumns
        }, getColumnPTOptions("root"), getColumnPTOptions("headerCell"));
        return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("th", $149bbf8d591193be$var$_extends({
            ref: elementRef
        }, headerCellProps), resizer, header), hasTooltip && /*#__PURE__*/ $81g6h.createElement((0, $7hMfd.Tooltip), $149bbf8d591193be$var$_extends({
            target: elementRef,
            content: headerTooltip,
            pt: getColumnPTOptions("tooltip"),
            unstyled: props.unstyled
        }, headerTooltipOptions)));
    };
    var element = createElement();
    return element;
});
$149bbf8d591193be$var$HeaderCell.displayName = "HeaderCell";
function $149bbf8d591193be$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149bbf8d591193be$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149bbf8d591193be$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $149bbf8d591193be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149bbf8d591193be$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149bbf8d591193be$var$TableHeader = /*#__PURE__*/ $81g6h.memo(function(props) {
    var _React$useState = $81g6h.useState([]), _React$useState2 = $149bbf8d591193be$var$_slicedToArray(_React$useState, 2), sortableDisabledFieldsState = _React$useState2[0], setSortableDisabledFieldsState = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(false), _React$useState4 = $149bbf8d591193be$var$_slicedToArray(_React$useState3, 2), allSortableDisabledState = _React$useState4[0], setAllSortableDisabledState = _React$useState4[1];
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var isSingleSort = props.sortMode === "single";
    var isMultipleSort = props.sortMode === "multiple";
    var isAllSortableDisabled = isSingleSort && allSortableDisabledState;
    var _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx;
    var getColumnProp = function getColumnProp(column, name) {
        return $149bbf8d591193be$var$ColumnBase.getCProp(column, name);
    };
    var getColumnProps = function getColumnProps(column) {
        return $149bbf8d591193be$var$ColumnBase.getCProps(column);
    };
    var getRowProps = function getRowProps(row) {
        return $149bbf8d591193be$var$ColumnGroupBase.getCProps(row);
    };
    var getColumnGroupProps = function getColumnGroupProps() {
        return props.headerColumnGroup ? ptmo($149bbf8d591193be$var$ColumnGroupBase.getCProps(props.headerColumnGroup)) : undefined;
    };
    var getColumnGroupPTOptions = function getColumnGroupPTOptions(key) {
        var cGProps = getColumnGroupProps();
        var columnGroupMetaData = {
            props: cGProps,
            parent: props.metaData,
            hostName: props.hostName,
            state: {
                sortableDisabledFields: sortableDisabledFieldsState,
                allSortableDisabled: allSortableDisabledState
            }
        };
        return mergeProps(ptm("columnGroup.".concat(key), {
            columnGroup: columnGroupMetaData
        }), ptm("columnGroup.".concat(key), columnGroupMetaData), ptmo(cGProps, key, columnGroupMetaData));
    };
    var getColumnPTOptions = function getColumnPTOptions(column, key) {
        var cProps = getColumnProps(column);
        var columnMetaData = {
            props: cProps,
            parent: props.metaData,
            hostName: props.hostName,
            state: {
                sortableDisabledFields: sortableDisabledFieldsState,
                allSortableDisabled: allSortableDisabledState
            }
        };
        return mergeProps(ptm("column.".concat(key), {
            column: columnMetaData
        }), ptm("column.".concat(key), columnMetaData), ptmo(cProps, key, columnMetaData));
    };
    var getRowPTOptions = function getRowPTOptions(row, key) {
        var rProps = getRowProps(row);
        var rowMetaData = {
            props: rProps,
            parent: props.metaData,
            hostName: props.hostName
        };
        return mergeProps(ptm("row.".concat(key), {
            row: rowMetaData
        }), ptm("row.".concat(key), rowMetaData), ptmo(rProps, key, rowMetaData));
    };
    var isColumnSorted = function isColumnSorted(column) {
        return props.sortField !== null ? getColumnProp(column, "field") === props.sortField || getColumnProp(column, "sortField") === props.sortField : false;
    };
    var updateSortableDisabled = function updateSortableDisabled() {
        if (isSingleSort || isMultipleSort && props.onSortChange) {
            var sortableDisabledFields = [];
            var allSortableDisabled = false;
            props.columns.forEach(function(column) {
                if (getColumnProp(column, "sortableDisabled")) {
                    sortableDisabledFields.push(getColumnProp(column, "sortField") || getColumnProp(column, "field"));
                    if (!allSortableDisabled && isColumnSorted(column)) allSortableDisabled = true;
                }
            });
            setSortableDisabledFieldsState(sortableDisabledFields);
            setAllSortableDisabledState(allSortableDisabled);
        }
    };
    var onSortableChange = function onSortableChange() {
        updateSortableDisabled();
    };
    var onCheckboxChange = function onCheckboxChange(e) {
        props.onColumnCheckboxChange(e, props.value);
    };
    (0, $l2NC0.useMountEffect)(function() {
        updateSortableDisabled();
    });
    var createGroupHeaderCells = function createGroupHeaderCells(row) {
        var columns = $81g6h.Children.toArray($149bbf8d591193be$var$RowBase.getCProp(row, "children"));
        return createHeaderCells(columns);
    };
    var createHeaderCells = function createHeaderCells(columns) {
        return $81g6h.Children.map(columns, function(col, i) {
            var isVisible = col ? !getColumnProp(col, "hidden") : true;
            var key = col ? getColumnProp(col, "columnKey") || getColumnProp(col, "field") || i : i;
            return isVisible && /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$HeaderCell, {
                hostName: props.hostName,
                allRowsSelected: props.allRowsSelected,
                allSortableDisabled: isAllSortableDisabled,
                column: col,
                index: i,
                empty: props.empty,
                filterClearIcon: props.filterClearIcon,
                filterDisplay: props.filterDisplay,
                filterIcon: props.filterIcon,
                filters: props.filters,
                filtersStore: props.filtersStore,
                groupRowSortField: props.groupRowSortField,
                groupRowsBy: props.groupRowsBy,
                key: key,
                multiSortMeta: props.multiSortMeta,
                onColumnCheckboxChange: onCheckboxChange,
                onColumnDragLeave: props.onColumnDragLeave,
                onColumnDragOver: props.onColumnDragOver,
                onColumnDragStart: props.onColumnDragStart,
                onColumnDrop: props.onColumnDrop,
                onColumnMouseDown: props.onColumnMouseDown,
                onColumnResizeStart: props.onColumnResizeStart,
                onColumnResizerClick: props.onColumnResizerClick,
                onColumnResizerDoubleClick: props.onColumnResizerDoubleClick,
                onFilterApply: props.onFilterApply,
                onFilterChange: props.onFilterChange,
                onSortChange: props.onSortChange,
                onSortableChange: onSortableChange,
                reorderableColumns: props.reorderableColumns,
                resizableColumns: props.resizableColumns,
                showSelectAll: props.showSelectAll,
                sortField: props.sortField,
                sortIcon: props.sortIcon,
                sortMode: props.sortMode,
                sortOrder: props.sortOrder,
                sortableDisabledFields: sortableDisabledFieldsState,
                tabIndex: props.tabIndex,
                tableProps: props.tableProps,
                value: props.value,
                ptCallbacks: props.ptCallbacks,
                metaData: props.metaData,
                unstyled: props.unstyled
            });
        });
    };
    var createCheckbox = function createCheckbox(selectionMode) {
        if (props.showSelectAll && selectionMode === "multiple") {
            var allRowsSelected = props.allRowsSelected(props.value);
            return /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$HeaderCheckbox, {
                hostName: props.hostName,
                checked: allRowsSelected,
                onChange: onCheckboxChange,
                disabled: props.empty,
                ptCallbacks: props.ptCallbacks,
                metaData: props.metaData
            });
        }
        return null;
    };
    var createFilter = function createFilter(column, filter) {
        if (filter) return /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$ColumnFilter, {
            hostName: props.hostName,
            display: "row",
            column: column,
            filterClearIcon: props.filterClearIcon,
            filterIcon: props.filterIcon,
            filters: props.filters,
            filtersStore: props.filtersStore,
            metaData: props.metaData,
            onFilterApply: props.onFilterApply,
            onFilterChange: props.onFilterChange,
            ptCallbacks: props.ptCallbacks,
            unstyled: props.unstyled
        });
        return null;
    };
    var createFilterCells = function createFilterCells() {
        return $81g6h.Children.map(props.columns, function(col, i) {
            var isVisible = !getColumnProp(col, "hidden");
            if (isVisible) {
                var _ColumnBase$getCProps = $149bbf8d591193be$var$ColumnBase.getCProps(col), filterHeaderStyle = _ColumnBase$getCProps.filterHeaderStyle, style = _ColumnBase$getCProps.style, filterHeaderClassName = _ColumnBase$getCProps.filterHeaderClassName, className = _ColumnBase$getCProps.className, frozen = _ColumnBase$getCProps.frozen, columnKey = _ColumnBase$getCProps.columnKey, field = _ColumnBase$getCProps.field, selectionMode = _ColumnBase$getCProps.selectionMode, filter = _ColumnBase$getCProps.filter;
                var colStyle = $149bbf8d591193be$var$_objectSpread$1($149bbf8d591193be$var$_objectSpread$1({}, filterHeaderStyle || {}), style || {});
                var colKey = columnKey || field || i;
                var checkbox = createCheckbox(selectionMode);
                var filterRow = createFilter(col, filter);
                var headerCellProps = mergeProps({
                    style: colStyle,
                    className: (0, $cfkGk.classNames)(filterHeaderClassName, className, cx("headerCell", {
                        frozen: frozen,
                        column: col
                    })),
                    key: colKey
                }, getColumnPTOptions(col, "root"), getColumnPTOptions(col, "headerCell"));
                return /*#__PURE__*/ $81g6h.createElement("th", headerCellProps, checkbox, filterRow);
            }
            return null;
        });
    };
    var createContent = function createContent() {
        if (props.headerColumnGroup) {
            var rows = $81g6h.Children.toArray($149bbf8d591193be$var$ColumnGroupBase.getCProp(props.headerColumnGroup, "children"));
            return rows.map(function(row, i) {
                var headerRowProps = mergeProps({
                    role: "row"
                }, getRowPTOptions(row, "root"));
                return /*#__PURE__*/ $81g6h.createElement("tr", $149bbf8d591193be$var$_extends({}, headerRowProps, {
                    key: i
                }), createGroupHeaderCells(row));
            });
        }
        var headerRowProps = mergeProps({
            role: "row"
        }, ptm("headerRow", {
            hostName: props.hostName
        }));
        var headerRow = /*#__PURE__*/ $81g6h.createElement("tr", headerRowProps, createHeaderCells(props.columns));
        var filterRow = props.filterDisplay === "row" && /*#__PURE__*/ $81g6h.createElement("tr", headerRowProps, createFilterCells());
        return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, headerRow, filterRow);
    };
    var content = createContent();
    var theadProps = mergeProps({
        className: cx("thead"),
        role: "rowgroup"
    }, getColumnGroupPTOptions("root"), ptm("thead", {
        hostName: props.hostName
    }));
    return /*#__PURE__*/ $81g6h.createElement("thead", theadProps, content);
});
$149bbf8d591193be$var$TableHeader.displayName = "TableHeader";
function $149bbf8d591193be$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $149bbf8d591193be$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $149bbf8d591193be$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $149bbf8d591193be$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $149bbf8d591193be$var$_arrayLikeToArray(o, minLen);
}
function $149bbf8d591193be$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $149bbf8d591193be$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149bbf8d591193be$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149bbf8d591193be$var$ownKeys(Object(t), !0).forEach(function(r) {
            $149bbf8d591193be$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149bbf8d591193be$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149bbf8d591193be$export$df30df7ec97b32b5 = /*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var props = $149bbf8d591193be$var$DataTableBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState(props.first), _React$useState2 = $149bbf8d591193be$var$_slicedToArray(_React$useState, 2), firstState = _React$useState2[0], setFirstState = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(props.rows), _React$useState4 = $149bbf8d591193be$var$_slicedToArray(_React$useState3, 2), rowsState = _React$useState4[0], setRowsState = _React$useState4[1];
    var _React$useState5 = $81g6h.useState(props.sortField), _React$useState6 = $149bbf8d591193be$var$_slicedToArray(_React$useState5, 2), sortFieldState = _React$useState6[0], setSortFieldState = _React$useState6[1];
    var _React$useState7 = $81g6h.useState(props.sortOrder), _React$useState8 = $149bbf8d591193be$var$_slicedToArray(_React$useState7, 2), sortOrderState = _React$useState8[0], setSortOrderState = _React$useState8[1];
    var _React$useState9 = $81g6h.useState(props.multiSortMeta), _React$useState10 = $149bbf8d591193be$var$_slicedToArray(_React$useState9, 2), multiSortMetaState = _React$useState10[0], setMultiSortMetaState = _React$useState10[1];
    var _React$useState11 = $81g6h.useState(props.filters), _React$useState12 = $149bbf8d591193be$var$_slicedToArray(_React$useState11, 2), filtersState = _React$useState12[0], setFiltersState = _React$useState12[1];
    var _React$useState13 = $81g6h.useState([]), _React$useState14 = $149bbf8d591193be$var$_slicedToArray(_React$useState13, 2), columnOrderState = _React$useState14[0], setColumnOrderState = _React$useState14[1];
    var _React$useState15 = $81g6h.useState(null), _React$useState16 = $149bbf8d591193be$var$_slicedToArray(_React$useState15, 2), groupRowsSortMetaState = _React$useState16[0], setGroupRowsSortMetaState = _React$useState16[1];
    var _React$useState17 = $81g6h.useState({}), _React$useState18 = $149bbf8d591193be$var$_slicedToArray(_React$useState17, 2), editingMetaState = _React$useState18[0], setEditingMetaState = _React$useState18[1];
    var _React$useState19 = $81g6h.useState(props.rows), _React$useState20 = $149bbf8d591193be$var$_slicedToArray(_React$useState19, 2), d_rowsState = _React$useState20[0], setD_rowsState = _React$useState20[1];
    var _React$useState21 = $81g6h.useState({}), _React$useState22 = $149bbf8d591193be$var$_slicedToArray(_React$useState21, 2), d_filtersState = _React$useState22[0], setD_filtersState = _React$useState22[1];
    var metaData = {
        props: props,
        state: {
            first: firstState,
            rows: rowsState,
            sortField: sortFieldState,
            sortOrder: sortOrderState,
            multiSortMeta: multiSortMetaState,
            filters: filtersState,
            columnOrder: columnOrderState,
            groupRowsSortMeta: groupRowsSortMetaState,
            editingMeta: editingMetaState,
            d_rows: d_rowsState,
            d_filters: d_filtersState
        },
        context: {
            scrollable: props.scrollable
        }
    };
    var ptCallbacks = $149bbf8d591193be$var$DataTableBase.setMetaData(metaData);
    (0, $4gQLd.useHandleStyle)($149bbf8d591193be$var$DataTableBase.css.styles, ptCallbacks.isUnstyled, {
        name: "datatable"
    });
    var attributeSelector = $81g6h.useRef("");
    var elementRef = $81g6h.useRef(null);
    var tableRef = $81g6h.useRef(null);
    var wrapperRef = $81g6h.useRef(null);
    var bodyRef = $81g6h.useRef(null);
    var frozenBodyRef = $81g6h.useRef(null);
    var virtualScrollerRef = $81g6h.useRef(null);
    var reorderIndicatorUpRef = $81g6h.useRef(null);
    var reorderIndicatorDownRef = $81g6h.useRef(null);
    var colReorderIconWidth = $81g6h.useRef(null);
    var colReorderIconHeight = $81g6h.useRef(null);
    var resizeHelperRef = $81g6h.useRef(null);
    var draggedColumnElement = $81g6h.useRef(null);
    var draggedColumn = $81g6h.useRef(null);
    var dropPosition = $81g6h.useRef(null);
    var styleElement = $81g6h.useRef(null);
    var responsiveStyleElement = $81g6h.useRef(null);
    var beforeResizeStyleElement = $81g6h.useRef(null);
    var columnWidthsState = $81g6h.useRef(null);
    var tableWidthState = $81g6h.useRef(null);
    var resizeColumn = $81g6h.useRef(null);
    var resizeColumnElement = $81g6h.useRef(null);
    var columnResizing = $81g6h.useRef(false);
    var lastResizeHelperX = $81g6h.useRef(null);
    var columnSortable = $81g6h.useRef(false);
    var columnSortFunction = $81g6h.useRef(null);
    var columnField = $81g6h.useRef(null);
    var filterTimeout = $81g6h.useRef(null);
    if (props.rows !== d_rowsState && !props.onPage) {
        setRowsState(props.rows);
        setD_rowsState(props.rows);
    }
    var columnResizeStartListener = function columnResizeStartListener(event) {
        return columnResizing.current && onColumnResize(event);
    };
    var columnResizeEndListener = function columnResizeEndListener() {
        return columnResizing.current && (columnResizing.current = false, onColumnResizeEnd());
    };
    var _useEventListener = (0, $l2NC0.useEventListener)({
        type: "mousemove",
        listener: columnResizeStartListener
    }), _useEventListener2 = $149bbf8d591193be$var$_slicedToArray(_useEventListener, 2), bindDocumentMouseMoveListener = _useEventListener2[0], unbindDocumentMouseMoveListener = _useEventListener2[1];
    var _useEventListener3 = (0, $l2NC0.useEventListener)({
        type: "mouseup",
        listener: columnResizeEndListener
    }), _useEventListener4 = $149bbf8d591193be$var$_slicedToArray(_useEventListener3, 2), bindDocumentMouseUpListener = _useEventListener4[0], unbindDocumentMouseUpListener = _useEventListener4[1];
    var _useEventListener5 = (0, $l2NC0.useEventListener)({
        type: "touchmove",
        listener: columnResizeStartListener
    }), _useEventListener6 = $149bbf8d591193be$var$_slicedToArray(_useEventListener5, 2), bindDocumentTouchMoveListener = _useEventListener6[0], unbindDocumentTouchMoveListener = _useEventListener6[1];
    var _useEventListener7 = (0, $l2NC0.useEventListener)({
        type: "touchend",
        listener: columnResizeEndListener
    }), _useEventListener8 = $149bbf8d591193be$var$_slicedToArray(_useEventListener7, 2), bindDocumentTouchEndListener = _useEventListener8[0], unbindDocumentTouchEndListener = _useEventListener8[1];
    var isCustomStateStorage = function isCustomStateStorage() {
        return props.stateStorage === "custom";
    };
    var isStateful = function isStateful() {
        return props.stateKey != null || isCustomStateStorage();
    };
    var isVirtualScrollerDisabled = function isVirtualScrollerDisabled() {
        return (0, $cfkGk.ObjectUtils).isEmpty(props.virtualScrollerOptions) || !props.scrollable;
    };
    var isEquals = function isEquals(data1, data2) {
        return props.compareSelectionBy === "equals" ? data1 === data2 : (0, $cfkGk.ObjectUtils).equals(data1, data2, props.dataKey);
    };
    var hasFilter = function hasFilter() {
        return (0, $cfkGk.ObjectUtils).isNotEmpty(getFilters()) || props.globalFilter;
    };
    var getFirst = function getFirst() {
        return props.onPage ? props.first : firstState;
    };
    var getRows = function getRows() {
        return props.onPage ? props.rows : rowsState;
    };
    var getSortField = function getSortField() {
        return props.onSort ? props.sortField : sortFieldState;
    };
    var getSortOrder = function getSortOrder() {
        return props.onSort ? props.sortOrder : sortOrderState;
    };
    var getMultiSortMeta = function getMultiSortMeta() {
        return (props.onSort ? props.multiSortMeta : multiSortMetaState) || [];
    };
    var getFilters = function getFilters() {
        return props.onFilter ? props.filters : filtersState;
    };
    var getColumnProp = function getColumnProp(column, name) {
        return $149bbf8d591193be$var$ColumnBase.getCProp(column, name);
    };
    var getColumns = function getColumns(ignoreReorderable) {
        var columns = $81g6h.Children.toArray(props.children);
        if (!columns) return null;
        if (!ignoreReorderable && props.reorderableColumns && columnOrderState) {
            var orderedColumns = columnOrderState.reduce(function(arr, columnKey) {
                var column = findColumnByKey(columns, columnKey);
                column && arr.push(column);
                return arr;
            }, []);
            return [].concat($149bbf8d591193be$var$_toConsumableArray(orderedColumns), $149bbf8d591193be$var$_toConsumableArray(columns.filter(function(col) {
                return orderedColumns.indexOf(col) < 0;
            })));
        }
        return columns;
    };
    var saveState = function saveState() {
        var state = {};
        if (props.paginator) {
            state.first = getFirst();
            state.rows = getRows();
        }
        var sortField = getSortField();
        if (sortField) {
            state.sortField = sortField;
            state.sortOrder = getSortOrder();
        }
        var multiSortMeta = getMultiSortMeta();
        if (multiSortMeta) state.multiSortMeta = multiSortMeta;
        if (hasFilter()) state.filters = getFilters();
        if (props.resizableColumns) saveColumnWidths(state);
        if (props.reorderableColumns) state.columnOrder = columnOrderState;
        if (props.expandedRows) state.expandedRows = props.expandedRows;
        if (props.selection && props.onSelectionChange) state.selection = props.selection;
        if (isCustomStateStorage()) {
            if (props.customSaveState) props.customSaveState(state);
        } else {
            var storage = $149bbf8d591193be$var$getStorage(props.stateStorage);
            if ((0, $cfkGk.ObjectUtils).isNotEmpty(state)) storage.setItem(props.stateKey, JSON.stringify(state));
        }
        if (props.onStateSave) props.onStateSave(state);
    };
    var clearState = function clearState() {
        var storage = $149bbf8d591193be$var$getStorage(props.stateStorage);
        if (storage && props.stateKey) storage.removeItem(props.stateKey);
    };
    var restoreState = function restoreState() {
        var restoredState = {};
        if (isCustomStateStorage()) {
            if (props.customRestoreState) restoredState = props.customRestoreState();
        } else {
            var storage = $149bbf8d591193be$var$getStorage(props.stateStorage);
            var stateString = storage.getItem(props.stateKey);
            var dateFormat = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/;
            var reviver = function reviver(key, value) {
                return typeof value === "string" && dateFormat.test(value) ? new Date(value) : value;
            };
            if (stateString) restoredState = JSON.parse(stateString, reviver);
        }
        _restoreState(restoredState);
    };
    var restoreTableState = function restoreTableState(restoredState) {
        _restoreState(restoredState);
    };
    var _restoreState = function _restoreState() {
        var restoredState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ((0, $cfkGk.ObjectUtils).isNotEmpty(restoredState)) {
            if (props.paginator) {
                if (props.onPage) {
                    var getOnPageParams = function getOnPageParams(first, rows) {
                        var totalRecords = getTotalRecords(processedData());
                        var pageCount = Math.ceil(totalRecords / rows) || 1;
                        var page = Math.floor(first / rows);
                        return {
                            first: first,
                            rows: rows,
                            page: page,
                            pageCount: pageCount
                        };
                    };
                    props.onPage(createEvent(getOnPageParams(restoredState.first, restoredState.rows)));
                } else {
                    setFirstState(restoredState.first);
                    setRowsState(restoredState.rows);
                }
            }
            if (restoredState.sortField) {
                if (props.onSort) props.onSort(createEvent({
                    sortField: restoredState.sortField,
                    sortOrder: restoredState.sortOrder
                }));
                else {
                    setSortFieldState(restoredState.sortField);
                    setSortOrderState(restoredState.sortOrder);
                }
            }
            if (restoredState.multiSortMeta) {
                if (props.onSort) props.onSort(createEvent({
                    multiSortMeta: restoredState.multiSortMeta
                }));
                else setMultiSortMetaState(restoredState.multiSortMeta);
            }
            if (restoredState.filters) {
                setD_filtersState(cloneFilters(restoredState.filters));
                if (props.onFilter) props.onFilter(createEvent({
                    filters: restoredState.filters
                }));
                else setFiltersState(cloneFilters(restoredState.filters));
            }
            if (props.resizableColumns) {
                columnWidthsState.current = restoredState.columnWidths;
                tableWidthState.current = restoredState.tableWidth;
                restoreColumnWidths();
            }
            if (props.reorderableColumns) setColumnOrderState(restoredState.columnOrder);
            if (restoredState.expandedRows && props.onRowToggle) props.onRowToggle({
                data: restoredState.expandedRows
            });
            if (restoredState.selection && props.onSelectionChange) props.onSelectionChange({
                value: restoredState.selection
            });
            if (props.onStateRestore) props.onStateRestore(restoredState);
        }
    };
    var saveColumnWidths = function saveColumnWidths(state) {
        var widths = [];
        var headers = (0, $cfkGk.DomHandler).find(elementRef.current, '[data-pc-section="thead"] > tr > th');
        headers.forEach(function(header) {
            return widths.push((0, $cfkGk.DomHandler).getOuterWidth(header));
        });
        state.columnWidths = widths.join(",");
        if (props.columnResizeMode === "expand") state.tableWidth = (0, $cfkGk.DomHandler).getOuterWidth(tableRef.current) + "px";
    };
    var addColumnWidthStyles = function addColumnWidthStyles(widths) {
        createStyleElement();
        var innerHTML = "";
        var selector = '[data-pc-name="datatable"]['.concat(attributeSelector.current, '] > [data-pc-section="wrapper"] ').concat(isVirtualScrollerDisabled() ? "" : '> [data-pc-name="virtualscroller"]', ' > [data-pc-section="table"]');
        widths.forEach(function(width, index) {
            var style = "width: ".concat(width, "px !important; max-width: ").concat(width, "px !important");
            innerHTML = innerHTML + "\n                ".concat(selector, ' > [data-pc-section="thead"] > tr > th:nth-child(').concat(index + 1, "),\n                ").concat(selector, ' > [data-pc-section="tbody"] > tr > td:nth-child(').concat(index + 1, "),\n                ").concat(selector, ' > [data-pc-section="tfoot"] > tr > td:nth-child(').concat(index + 1, ") {\n                    ").concat(style, "\n                }\n            ");
        });
        styleElement.current.innerHTML = innerHTML;
    };
    var restoreColumnWidths = function restoreColumnWidths() {
        if (columnWidthsState.current) {
            var widths = columnWidthsState.current.split(",");
            if (props.columnResizeMode === "expand" && tableWidthState.current) {
                tableRef.current.style.width = tableWidthState.current;
                tableRef.current.style.minWidth = tableWidthState.current;
            }
            if ((0, $cfkGk.ObjectUtils).isNotEmpty(widths)) addColumnWidthStyles(widths);
        }
    };
    var findParentHeader = function findParentHeader(element) {
        if (element.nodeName === "TH") return element;
        var parent = element.parentElement;
        while(parent.nodeName !== "TH"){
            parent = parent.parentElement;
            if (!parent) break;
        }
        return parent;
    };
    var getGroupRowSortField = function getGroupRowSortField() {
        return props.sortMode === "single" ? props.sortField : groupRowsSortMetaState ? groupRowsSortMetaState.field : null;
    };
    var getSelectableData = function getSelectableData(val) {
        if (props.showSelectionElement || props.isDataSelectable) return val.filter(function(data, index) {
            var isSelectable = true;
            if (props.showSelectionElement) isSelectable = props.showSelectionElement({
                rowIndex: index,
                props: props
            });
            if (props.isDataSelectable && isSelectable) isSelectable = props.isDataSelectable({
                data: data,
                index: index
            });
            return isSelectable;
        });
        return val;
    };
    var allRowsSelected = function allRowsSelected(processedData) {
        if (props.onSelectAllChange) return props.selectAll;
        var data = props.selectionPageOnly ? dataToRender(processedData) : processedData;
        var val = (0, $cfkGk.ObjectUtils).isNotEmpty(props.frozenValue) ? [].concat($149bbf8d591193be$var$_toConsumableArray(props.frozenValue), $149bbf8d591193be$var$_toConsumableArray(data)) : data;
        var selectableVal = getSelectableData(val);
        return (0, $cfkGk.ObjectUtils).isNotEmpty(selectableVal) && props.selection && selectableVal.every(function(sv) {
            return (0, $cfkGk.ObjectUtils).isArray(props.selection) && props.selection.some(function(s) {
                return isEquals(s, sv);
            });
        });
    };
    var getSelectionModeInColumn = function getSelectionModeInColumn(columns) {
        if (columns) {
            var col = columns.find(function(c) {
                return !!getColumnProp(c, "selectionMode");
            });
            return col ? getColumnProp(col, "selectionMode") : null;
        }
        return null;
    };
    var findColumnByKey = function findColumnByKey(columns, key) {
        return (0, $cfkGk.ObjectUtils).isNotEmpty(columns) ? columns.find(function(col) {
            return getColumnProp(col, "columnKey") === key || getColumnProp(col, "field") === key;
        }) : null;
    };
    var getTotalRecords = function getTotalRecords(data) {
        return props.lazy ? props.totalRecords : data ? data.length : 0;
    };
    var onEditingMetaChange = function onEditingMetaChange(e) {
        var rowData = e.rowData, field = e.field, editingKey = e.editingKey;
        e.rowIndex;
        var editing = e.editing;
        var editingMeta = $149bbf8d591193be$var$_objectSpread({}, editingMetaState);
        var meta = editingMeta[editingKey];
        if (editing) {
            !meta && (meta = editingMeta[editingKey] = {
                data: $149bbf8d591193be$var$_objectSpread({}, rowData),
                fields: []
            });
            meta.fields.push(field);
        } else if (meta) {
            var fields = meta.fields.filter(function(f) {
                return f !== field;
            });
            !fields.length ? delete editingMeta[editingKey] : meta.fields = fields;
        }
        setEditingMetaState(editingMeta);
    };
    var clearEditingMetaData = function clearEditingMetaData() {
        if (props.editMode && (0, $cfkGk.ObjectUtils).isNotEmpty(editingMetaState)) setEditingMetaState({});
    };
    var onColumnResizeStart = function onColumnResizeStart(e) {
        createBeforeResizeStyleElement();
        var event = e.originalEvent, column = e.column;
        var containerLeft = (0, $cfkGk.DomHandler).getOffset(elementRef.current).left;
        resizeColumn.current = column;
        resizeColumnElement.current = event.currentTarget.parentElement;
        columnResizing.current = true;
        lastResizeHelperX.current = (event.type === "touchstart" ? event.changedTouches[0].clientX : event.pageX) - containerLeft + elementRef.current.scrollLeft;
        bindColumnResizeEvents();
    };
    var onColumnResize = function onColumnResize(event) {
        var containerLeft = (0, $cfkGk.DomHandler).getOffset(elementRef.current).left;
        elementRef.current.setAttribute("data-p-unselectable-text", true);
        resizeHelperRef.current.style.height = elementRef.current.offsetHeight + "px";
        resizeHelperRef.current.style.top = "0px";
        resizeHelperRef.current.style.left = (event.type === "touchmove" ? event.changedTouches[0].clientX : event.pageX) - containerLeft + elementRef.current.scrollLeft + "px";
        resizeHelperRef.current.style.display = "block";
    };
    var onColumnResizeEnd = function onColumnResizeEnd() {
        var delta = resizeHelperRef.current.offsetLeft - lastResizeHelperX.current;
        var columnWidth = resizeColumnElement.current.offsetWidth;
        var newColumnWidth = columnWidth + delta;
        var minWidth = resizeColumnElement.current.style.minWidth || 15;
        if (columnWidth + delta > parseInt(minWidth, 10)) {
            if (props.columnResizeMode === "fit") {
                var nextColumn = resizeColumnElement.current.nextElementSibling;
                var nextColumnWidth = nextColumn.offsetWidth - delta;
                if (newColumnWidth > 15 && nextColumnWidth > 15) resizeTableCells(newColumnWidth, nextColumnWidth);
            } else if (props.columnResizeMode === "expand") {
                var tableWidth = tableRef.current.offsetWidth + delta + "px";
                var updateTableWidth = function updateTableWidth(el) {
                    !!el && (el.style.width = el.style.minWidth = tableWidth);
                };
                // https://github.com/primefaces/primereact/issues/3970 Reasoning: resize table cells before updating the table width so that it can use existing computed cell widths and adjust only the one column.
                resizeTableCells(newColumnWidth);
                updateTableWidth(tableRef.current);
                if (!isVirtualScrollerDisabled()) {
                    updateTableWidth(bodyRef.current);
                    updateTableWidth(frozenBodyRef.current);
                    if (wrapperRef.current) updateTableWidth((0, $cfkGk.DomHandler).findSingle(wrapperRef.current, '[data-pc-name="virtualscroller"] > table > tbody'));
                }
            }
            if (props.onColumnResizeEnd) props.onColumnResizeEnd({
                element: resizeColumnElement.current,
                column: resizeColumn.current,
                delta: delta
            });
            if (isStateful()) saveState();
        }
        resizeHelperRef.current.style.display = "none";
        resizeColumn.current = null;
        resizeColumnElement.current = null;
        elementRef.current.setAttribute("data-p-unselectable-text", "true");
        destroyBeforeResizeStyleElement();
        unbindColumnResizeEvents();
    };
    var resizeTableCells = function resizeTableCells(newColumnWidth, nextColumnWidth) {
        var widths = [];
        var colIndex = (0, $cfkGk.DomHandler).index(resizeColumnElement.current);
        var headers = (0, $cfkGk.DomHandler).find(tableRef.current, '[data-pc-section="thead"] > tr > th');
        headers.forEach(function(header) {
            return widths.push((0, $cfkGk.DomHandler).getOuterWidth(header));
        });
        destroyStyleElement();
        createStyleElement();
        var innerHTML = "";
        var selector = '[data-pc-name="datatable"]['.concat(attributeSelector.current, '] > [data-pc-section="wrapper"] ').concat(isVirtualScrollerDisabled() ? "" : '> [data-pc-name="virtualscroller"]', ' > [data-pc-section="table"]');
        widths.forEach(function(width, index) {
            var colWidth = index === colIndex ? newColumnWidth : nextColumnWidth && index === colIndex + 1 ? nextColumnWidth : width;
            var style = "width: ".concat(colWidth, "px !important; max-width: ").concat(colWidth, "px !important");
            innerHTML = innerHTML + "\n                 ".concat(selector, ' > [data-pc-section="thead"] > tr > th:nth-child(').concat(index + 1, "),\n                ").concat(selector, ' > [data-pc-section="tbody"] > tr > td:nth-child(').concat(index + 1, "),\n                ").concat(selector, ' > [data-pc-section="tfoot"] > tr > td:nth-child(').concat(index + 1, ") {\n                    ").concat(style, "\n                }\n            ");
        });
        styleElement.current.innerHTML = innerHTML;
    };
    var bindColumnResizeEvents = function bindColumnResizeEvents() {
        bindDocumentMouseMoveListener();
        bindDocumentMouseUpListener();
        bindDocumentTouchMoveListener();
        bindDocumentTouchEndListener();
    };
    var unbindColumnResizeEvents = function unbindColumnResizeEvents() {
        unbindDocumentMouseMoveListener();
        unbindDocumentMouseUpListener();
        unbindDocumentTouchMoveListener();
        unbindDocumentTouchEndListener();
    };
    var onColumnHeaderMouseDown = function onColumnHeaderMouseDown(e) {
        (0, $cfkGk.DomHandler).clearSelection();
        var event = e.originalEvent, column = e.column;
        if (props.reorderableColumns && getColumnProp(column, "reorderable") !== false && !getColumnProp(column, "frozen")) {
            if (event.target.nodeName === "INPUT" || event.target.nodeName === "TEXTAREA" || (0, $cfkGk.DomHandler).getAttribute(event.target, '[data-pc-section="columnresizer"]')) event.currentTarget.draggable = false;
            else event.currentTarget.draggable = true;
        }
    };
    var onColumnHeaderCheckboxChange = function onColumnHeaderCheckboxChange(e, processedData) {
        if (props.onSelectAllChange) props.onSelectAllChange(e);
        else {
            var originalEvent = e.originalEvent, checked = e.checked;
            var _data = props.selectionPageOnly ? dataToRender(processedData) : processedData;
            var selection = props.selectionPageOnly && props.selection ? props.selection.filter(function(s) {
                return !_data.some(function(d) {
                    return isEquals(s, d);
                });
            }) : [];
            if (checked) {
                selection = (0, $cfkGk.ObjectUtils).isNotEmpty(props.frozenValue) ? [].concat($149bbf8d591193be$var$_toConsumableArray(selection), $149bbf8d591193be$var$_toConsumableArray(props.frozenValue), $149bbf8d591193be$var$_toConsumableArray(_data)) : [].concat($149bbf8d591193be$var$_toConsumableArray(selection), $149bbf8d591193be$var$_toConsumableArray(_data));
                selection = getSelectableData(selection);
                props.onAllRowsSelect && props.onAllRowsSelect({
                    originalEvent: originalEvent,
                    data: selection,
                    type: "all"
                });
            } else props.onAllRowsUnselect && props.onAllRowsUnselect({
                originalEvent: originalEvent,
                data: selection,
                type: "all"
            });
            if (props.onSelectionChange) props.onSelectionChange({
                originalEvent: originalEvent,
                value: selection,
                type: "all"
            });
        }
    };
    var onColumnHeaderDragStart = function onColumnHeaderDragStart(e) {
        var event = e.originalEvent, column = e.column;
        if (columnResizing.current) {
            event.preventDefault();
            return;
        }
        if (!props.reorderableColumns) return;
        colReorderIconWidth.current = (0, $cfkGk.DomHandler).getHiddenElementOuterWidth(reorderIndicatorUpRef.current);
        colReorderIconHeight.current = (0, $cfkGk.DomHandler).getHiddenElementOuterHeight(reorderIndicatorUpRef.current);
        draggedColumn.current = column;
        draggedColumnElement.current = findParentHeader(event.currentTarget);
        event.dataTransfer.setData("text", "b"); // Firefox requires this to make dragging possible
    };
    var onColumnHeaderDragOver = function onColumnHeaderDragOver(e) {
        var event = e.originalEvent, column = e.column;
        var dropHeader = findParentHeader(event.currentTarget);
        if (props.reorderableColumns && draggedColumnElement.current && dropHeader && !getColumnProp(column, "frozen")) {
            event.preventDefault();
            if (draggedColumnElement.current !== dropHeader) {
                var containerOffset = (0, $cfkGk.DomHandler).getOffset(elementRef.current);
                var dropHeaderOffset = (0, $cfkGk.DomHandler).getOffset(dropHeader);
                var targetLeft = dropHeaderOffset.left - containerOffset.left;
                var columnCenter = dropHeaderOffset.left + dropHeader.offsetWidth / 2;
                var dragIndex = (0, $cfkGk.DomHandler).index(draggedColumnElement.current);
                var dropIndex = (0, $cfkGk.DomHandler).index(findParentHeader(event.currentTarget));
                reorderIndicatorUpRef.current.style.top = dropHeaderOffset.top - containerOffset.top - (colReorderIconHeight.current - 1) + "px";
                reorderIndicatorDownRef.current.style.top = dropHeaderOffset.top - containerOffset.top + dropHeader.offsetHeight + "px";
                if (event.pageX > columnCenter && dragIndex < dropIndex) {
                    reorderIndicatorUpRef.current.style.left = targetLeft + dropHeader.offsetWidth - Math.ceil(colReorderIconWidth.current / 2) + "px";
                    reorderIndicatorDownRef.current.style.left = targetLeft + dropHeader.offsetWidth - Math.ceil(colReorderIconWidth.current / 2) + "px";
                    dropPosition.current = 1;
                } else if (dragIndex > dropIndex) {
                    reorderIndicatorUpRef.current.style.left = targetLeft - Math.ceil(colReorderIconWidth.current / 2) + "px";
                    reorderIndicatorDownRef.current.style.left = targetLeft - Math.ceil(colReorderIconWidth.current / 2) + "px";
                    dropPosition.current = -1;
                }
                reorderIndicatorUpRef.current.style.display = "block";
                reorderIndicatorDownRef.current.style.display = "block";
            }
        }
    };
    var onColumnHeaderDragLeave = function onColumnHeaderDragLeave(e) {
        var event = e.originalEvent;
        if (props.reorderableColumns && draggedColumnElement.current) {
            event.preventDefault();
            reorderIndicatorUpRef.current.style.display = "none";
            reorderIndicatorDownRef.current.style.display = "none";
        }
    };
    var onColumnHeaderDrop = function onColumnHeaderDrop(e) {
        var event = e.originalEvent, column = e.column;
        event.preventDefault();
        if (draggedColumnElement.current) {
            var dragIndex = (0, $cfkGk.DomHandler).index(draggedColumnElement.current);
            var dropIndex = (0, $cfkGk.DomHandler).index(findParentHeader(event.currentTarget));
            var allowDrop = dragIndex !== dropIndex;
            if (allowDrop && (dropIndex - dragIndex === 1 && dropPosition.current === -1 || dragIndex - dropIndex === 1 && dropPosition.current === 1)) allowDrop = false;
            if (allowDrop) {
                var _columns = getColumns();
                var isSameColumn = function isSameColumn(col1, col2) {
                    return getColumnProp(col1, "columnKey") || getColumnProp(col2, "columnKey") ? (0, $cfkGk.ObjectUtils).equals(col1.props, col2.props, "columnKey") : (0, $cfkGk.ObjectUtils).equals(col1.props, col2.props, "field");
                };
                var dragColIndex = _columns.findIndex(function(child) {
                    return isSameColumn(child, draggedColumn.current);
                });
                var dropColIndex = _columns.findIndex(function(child) {
                    return isSameColumn(child, column);
                });
                var widths = [];
                var headers = (0, $cfkGk.DomHandler).find(tableRef.current, '[data-pc-section="thead"] > tr > th');
                headers.forEach(function(header) {
                    return widths.push((0, $cfkGk.DomHandler).getOuterWidth(header));
                });
                var movedItem = widths.find(function(items, index) {
                    return index === dragColIndex;
                });
                var remainingItems = widths.filter(function(items, index) {
                    return index !== dragColIndex;
                });
                var reorderedWidths = [].concat($149bbf8d591193be$var$_toConsumableArray(remainingItems.slice(0, dropColIndex)), [
                    movedItem
                ], $149bbf8d591193be$var$_toConsumableArray(remainingItems.slice(dropColIndex)));
                addColumnWidthStyles(reorderedWidths);
                if (dropColIndex < dragColIndex && dropPosition.current === 1) dropColIndex++;
                if (dropColIndex > dragColIndex && dropPosition.current === -1) dropColIndex--;
                (0, $cfkGk.ObjectUtils).reorderArray(_columns, dragColIndex, dropColIndex);
                var columnOrder = _columns.reduce(function(orders, col) {
                    orders.push(getColumnProp(col, "columnKey") || getColumnProp(col, "field"));
                    return orders;
                }, []);
                setColumnOrderState(columnOrder);
                if (props.onColReorder) props.onColReorder({
                    originalEvent: event,
                    dragIndex: dragColIndex,
                    dropIndex: dropColIndex,
                    columns: _columns
                });
            }
            reorderIndicatorUpRef.current.style.display = "none";
            reorderIndicatorDownRef.current.style.display = "none";
            draggedColumnElement.current.draggable = false;
            draggedColumnElement.current = null;
            draggedColumn.current = null;
            dropPosition.current = null;
        }
    };
    var createBeforeResizeStyleElement = function createBeforeResizeStyleElement() {
        beforeResizeStyleElement.current = (0, $cfkGk.DomHandler).createInlineStyle(context && context.nonce || (0, $8Zwsm.default).nonce, context && context.styleContainer);
        var innerHTML = '\n[data-pc-name="datatable"]['.concat(attributeSelector.current, "] {\n    user-select:none;\n}\n        ");
        beforeResizeStyleElement.current.innerHTML = innerHTML;
    };
    var createStyleElement = function createStyleElement() {
        styleElement.current = (0, $cfkGk.DomHandler).createInlineStyle(context && context.nonce || (0, $8Zwsm.default).nonce, context && context.styleContainer);
    };
    var createResponsiveStyle = function createResponsiveStyle() {
        if (!responsiveStyleElement.current) {
            responsiveStyleElement.current = (0, $cfkGk.DomHandler).createInlineStyle(context && context.nonce || (0, $8Zwsm.default).nonce, context && context.styleContainer);
            var tableSelector = ".p-datatable-wrapper ".concat(isVirtualScrollerDisabled() ? "" : "> .p-virtualscroller", " > .p-datatable-table");
            var selector = ".p-datatable[".concat(attributeSelector.current, "] > ").concat(tableSelector);
            var gridLinesSelector = ".p-datatable[".concat(attributeSelector.current, "].p-datatable-gridlines > ").concat(tableSelector);
            var innerHTML = "\n@media screen and (max-width: ".concat(props.breakpoint, ") {\n    ").concat(selector, " > .p-datatable-thead > tr > th,\n    ").concat(selector, " > .p-datatable-tfoot > tr > td {\n        display: none;\n    }\n\n    ").concat(selector, " > .p-datatable-tbody > tr > td {\n        display: flex;\n        width: 100%;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    ").concat(selector, " > .p-datatable-tbody > tr > td:not(:last-child) {\n        border: 0 none;\n    }\n\n    ").concat(gridLinesSelector, " > .p-datatable-tbody > tr > td:last-child {\n        border-top: 0;\n        border-right: 0;\n        border-left: 0;\n    }\n\n    ").concat(selector, " > .p-datatable-tbody > tr > td > .p-column-title {\n        display: block;\n    }\n}\n");
            responsiveStyleElement.current.innerHTML = innerHTML;
        }
    };
    var destroyResponsiveStyle = function destroyResponsiveStyle() {
        responsiveStyleElement.current = (0, $cfkGk.DomHandler).removeInlineStyle(responsiveStyleElement.current);
    };
    var destroyStyleElement = function destroyStyleElement() {
        styleElement.current = (0, $cfkGk.DomHandler).removeInlineStyle(styleElement.current);
    };
    var destroyBeforeResizeStyleElement = function destroyBeforeResizeStyleElement() {
        beforeResizeStyleElement.current = (0, $cfkGk.DomHandler).removeInlineStyle(beforeResizeStyleElement.current);
    };
    var onPageChange = function onPageChange(e) {
        clearEditingMetaData();
        if (props.onPage) props.onPage(createEvent(e));
        else {
            setFirstState(e.first);
            setRowsState(e.rows);
        }
        if (props.onValueChange) props.onValueChange(processedData());
    };
    var onSortChange = function onSortChange(e) {
        clearEditingMetaData();
        var event = e.originalEvent, column = e.column, sortableDisabledFields = e.sortableDisabledFields;
        var sortField = getColumnProp(column, "sortField") || getColumnProp(column, "field");
        var sortOrder = props.defaultSortOrder;
        var multiSortMeta;
        var eventMeta;
        columnSortable.current = getColumnProp(column, "sortable");
        columnSortFunction.current = getColumnProp(column, "sortFunction");
        columnField.current = sortField;
        if (props.sortMode === "multiple") {
            var metaKey = event.metaKey || event.ctrlKey;
            multiSortMeta = $149bbf8d591193be$var$_toConsumableArray(getMultiSortMeta());
            var sortMeta = multiSortMeta.find(function(sortMeta) {
                return sortMeta.field === sortField;
            });
            sortOrder = sortMeta ? getCalculatedSortOrder(sortMeta.order) : sortOrder;
            var newMetaData = {
                field: sortField,
                order: sortOrder
            };
            if (sortOrder) {
                multiSortMeta = metaKey ? multiSortMeta : multiSortMeta.filter(function(meta) {
                    return sortableDisabledFields.some(function(field) {
                        return field === meta.field;
                    });
                });
                addSortMeta(newMetaData, multiSortMeta);
            } else if (props.removableSort) removeSortMeta(newMetaData, multiSortMeta);
            eventMeta = {
                multiSortMeta: multiSortMeta
            };
        } else {
            sortOrder = getSortField() === sortField ? getCalculatedSortOrder(getSortOrder()) : sortOrder;
            if (props.removableSort) sortField = sortOrder ? sortField : null;
            eventMeta = {
                sortField: sortField,
                sortOrder: sortOrder
            };
        }
        if (props.onSort) props.onSort(createEvent(eventMeta));
        else {
            setFirstState(0);
            setSortFieldState(eventMeta.sortField);
            setSortOrderState(eventMeta.sortOrder);
            setMultiSortMetaState(eventMeta.multiSortMeta);
        }
        if (props.onValueChange) props.onValueChange(processedData({
            sortField: sortField,
            sortOrder: sortOrder,
            multiSortMeta: multiSortMeta
        }));
    };
    var getCalculatedSortOrder = function getCalculatedSortOrder(currentOrder) {
        return props.removableSort ? props.defaultSortOrder === currentOrder ? currentOrder * -1 : 0 : currentOrder * -1;
    };
    var compareValuesOnSort = function compareValuesOnSort(value1, value2, comparator, order) {
        return (0, $cfkGk.ObjectUtils).sort(value1, value2, order, comparator, context && context.nullSortOrder || (0, $8Zwsm.default).nullSortOrder);
    };
    var addSortMeta = function addSortMeta(meta, multiSortMeta) {
        var index = multiSortMeta.findIndex(function(sortMeta) {
            return sortMeta.field === meta.field;
        });
        if (index >= 0) multiSortMeta[index] = meta;
        else multiSortMeta.push(meta);
    };
    var removeSortMeta = function removeSortMeta(meta, multiSortMeta) {
        var index = multiSortMeta.findIndex(function(sortMeta) {
            return sortMeta.field === meta.field;
        });
        if (index >= 0) multiSortMeta.splice(index, 1);
        multiSortMeta = multiSortMeta.length > 0 ? multiSortMeta : null;
    };
    var sortSingle = function sortSingle(data, field, order) {
        if (props.groupRowsBy && props.groupRowsBy === props.sortField) {
            var multiSortMeta = [
                {
                    field: props.sortField,
                    order: props.sortOrder || props.defaultSortOrder
                }
            ];
            props.sortField !== field && multiSortMeta.push({
                field: field,
                order: order
            });
            return sortMultiple(data, multiSortMeta);
        }
        var value = $149bbf8d591193be$var$_toConsumableArray(data);
        if (columnSortable.current && columnSortFunction.current) value = columnSortFunction.current({
            data: data,
            field: field,
            order: order
        });
        else {
            // performance optimization to prevent resolving field data in each loop
            var lookupMap = new Map();
            var comparator = (0, $cfkGk.ObjectUtils).localeComparator(context && context.locale || (0, $8Zwsm.default).locale);
            var _iterator = $149bbf8d591193be$var$_createForOfIteratorHelper(data), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var item = _step.value;
                    lookupMap.set(item, (0, $cfkGk.ObjectUtils).resolveFieldData(item, field));
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            value.sort(function(data1, data2) {
                var value1 = lookupMap.get(data1);
                var value2 = lookupMap.get(data2);
                return compareValuesOnSort(value1, value2, comparator, order);
            });
        }
        return value;
    };
    var sortMultiple = function sortMultiple(data) {
        var multiSortMeta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        if (props.groupRowsBy && (groupRowsSortMetaState || multiSortMeta.length && props.groupRowsBy === multiSortMeta[0].field)) {
            var groupRowsSortMeta = groupRowsSortMetaState;
            var firstSortMeta = multiSortMeta[0];
            if (!groupRowsSortMeta) {
                groupRowsSortMeta = firstSortMeta;
                setGroupRowsSortMetaState(groupRowsSortMeta);
            }
            if (firstSortMeta.field !== groupRowsSortMeta.field) multiSortMeta = [
                groupRowsSortMeta
            ].concat($149bbf8d591193be$var$_toConsumableArray(multiSortMeta));
        }
        var value = $149bbf8d591193be$var$_toConsumableArray(data);
        if (columnSortable.current && columnSortFunction.current) {
            var meta = multiSortMeta.find(function(meta) {
                return meta.field === columnField.current;
            });
            var field = columnField.current;
            var order = meta ? meta.order : props.defaultSortOrder;
            value = columnSortFunction.current({
                data: data,
                field: field,
                order: order,
                multiSortMeta: multiSortMeta
            });
        } else {
            var comparator = (0, $cfkGk.ObjectUtils).localeComparator(context && context.locale || (0, $8Zwsm.default).locale);
            value.sort(function(data1, data2) {
                return multisortField(data1, data2, multiSortMeta, 0, comparator);
            });
        }
        return value;
    };
    var multisortField = function multisortField(data1, data2, multiSortMeta, index, comparator) {
        if (!multiSortMeta || !multiSortMeta[index]) return;
        var value1 = (0, $cfkGk.ObjectUtils).resolveFieldData(data1, multiSortMeta[index].field);
        var value2 = (0, $cfkGk.ObjectUtils).resolveFieldData(data2, multiSortMeta[index].field);
        // check if they are equal handling dates and locales
        if ((0, $cfkGk.ObjectUtils).compare(value1, value2, comparator) === 0) return multiSortMeta.length - 1 > index ? multisortField(data1, data2, multiSortMeta, index + 1, comparator) : 0;
        return compareValuesOnSort(value1, value2, comparator, multiSortMeta[index].order);
    };
    var onFilterChange = function onFilterChange(filters) {
        clearEditingMetaData();
        setD_filtersState(filters);
    };
    var onFilterApply = function onFilterApply(filtersToApply) {
        clearTimeout(filterTimeout.current);
        filterTimeout.current = setTimeout(function() {
            var filters = cloneFilters(filtersToApply || d_filtersState);
            if (props.onFilter) props.onFilter(createEvent({
                filters: filters
            }));
            else {
                setFirstState(0);
                setFiltersState(filters);
            }
            if (props.onValueChange) props.onValueChange(processedData({
                filters: filters
            }));
        }, props.filterDelay);
    };
    var getActiveFilters = function getActiveFilters(filters) {
        var removeEmptyFilters = function removeEmptyFilters(_ref) {
            var _ref2 = $149bbf8d591193be$var$_slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
            if (value.constraints) {
                var filteredConstraints = value.constraints.filter(function(constraint) {
                    return constraint.value !== null;
                });
                if (filteredConstraints.length > 0) return [
                    key,
                    $149bbf8d591193be$var$_objectSpread($149bbf8d591193be$var$_objectSpread({}, value), {}, {
                        constraints: filteredConstraints
                    })
                ];
            } else if (value.value !== null) return [
                key,
                value
            ];
            return undefined;
        };
        var filterValidEntries = function filterValidEntries(entry) {
            return entry !== undefined;
        };
        var entries = Object.entries(filters).map(removeEmptyFilters).filter(filterValidEntries);
        return Object.fromEntries(entries);
    };
    var filterLocal = function filterLocal(data, filters) {
        if (!data) return;
        var activeFilters = filters ? getActiveFilters(filters) : {};
        var columns = getColumns();
        var filteredValue = [];
        var isGlobalFilter = activeFilters.global || props.globalFilter;
        var globalFilterFieldsArray;
        if (isGlobalFilter) globalFilterFieldsArray = props.globalFilterFields || columns.filter(function(col) {
            return !getColumnProp(col, "excludeGlobalFilter");
        }).map(function(col) {
            return getColumnProp(col, "filterField") || getColumnProp(col, "field");
        });
        for(var i = 0; i < data.length; i++){
            var localMatch = true;
            var globalMatch = false;
            var localFiltered = false;
            for(var prop in activeFilters){
                if (prop === "null") continue;
                if (Object.prototype.hasOwnProperty.call(activeFilters, prop) && prop !== "global") {
                    localFiltered = true;
                    var filterField = prop;
                    var filterMeta = activeFilters[filterField];
                    if (filterMeta.operator) for(var j = 0; j < filterMeta.constraints.length; j++){
                        var filterConstraint = filterMeta.constraints[j];
                        localMatch = executeLocalFilter(filterField, data[i], filterConstraint, j);
                        if (filterMeta.operator === (0, $8Zwsm.FilterOperator).OR && localMatch || filterMeta.operator === (0, $8Zwsm.FilterOperator).AND && !localMatch) break;
                    }
                    else localMatch = executeLocalFilter(filterField, data[i], filterMeta, 0);
                    if (!localMatch) break;
                }
            }
            if (localMatch && isGlobalFilter && !globalMatch && globalFilterFieldsArray) for(var _j = 0; _j < globalFilterFieldsArray.length; _j++){
                var globalFilterField = globalFilterFieldsArray[_j];
                var matchMode = activeFilters.global ? activeFilters.global.matchMode : props.globalFilterMatchMode;
                var value = activeFilters.global ? activeFilters.global.value : props.globalFilter;
                globalMatch = (0, $8Zwsm.FilterService).filters[matchMode]((0, $cfkGk.ObjectUtils).resolveFieldData(data[i], globalFilterField), value, props.filterLocale);
                if (globalMatch) break;
            }
            var matches = void 0;
            if (isGlobalFilter) matches = localFiltered ? localFiltered && localMatch && globalMatch : globalMatch;
            else matches = localFiltered && localMatch;
            if (matches) filteredValue.push(data[i]);
        }
        if (filteredValue.length === props.value.length || Object.keys(activeFilters).length === 0) filteredValue = data;
        return filteredValue;
    };
    var executeLocalFilter = function executeLocalFilter(field, rowData, filterMeta, index) {
        var filterValue = filterMeta.value;
        var filterMatchMode = filterMeta.matchMode === "custom" ? "custom_".concat(field) : filterMeta.matchMode || (0, $8Zwsm.FilterMatchMode).STARTS_WITH;
        var dataFieldValue = (0, $cfkGk.ObjectUtils).resolveFieldData(rowData, field);
        var filterConstraint = (0, $8Zwsm.FilterService).filters[filterMatchMode];
        return (0, $cfkGk.ObjectUtils).isFunction(filterConstraint) && filterConstraint(dataFieldValue, filterValue, props.filterLocale, index);
    };
    var cloneFilters = function cloneFilters(filters) {
        filters = filters || props.filters;
        var cloned = {};
        if (filters) Object.entries(filters).forEach(function(_ref3) {
            var _ref4 = $149bbf8d591193be$var$_slicedToArray(_ref3, 2), prop = _ref4[0], value = _ref4[1];
            cloned[prop] = value.operator ? {
                operator: value.operator,
                constraints: value.constraints.map(function(constraint) {
                    return $149bbf8d591193be$var$_objectSpread({}, constraint);
                })
            } : $149bbf8d591193be$var$_objectSpread({}, value);
        });
        else {
            var _columns2 = getColumns();
            cloned = _columns2.reduce(function(filters, col) {
                var field = getColumnProp(col, "filterField") || getColumnProp(col, "field");
                var filterFunction = getColumnProp(col, "filterFunction");
                var dataType = getColumnProp(col, "dataType");
                var matchMode = getColumnProp(col, "filterMatchMode") || (context && context.filterMatchModeOptions[dataType] || (0, $8Zwsm.default).filterMatchModeOptions[dataType] ? context && context.filterMatchModeOptions[dataType][0] || (0, $8Zwsm.default).filterMatchModeOptions[dataType][0] : (0, $8Zwsm.FilterMatchMode).STARTS_WITH);
                var constraint = {
                    value: null,
                    matchMode: matchMode
                };
                if (filterFunction) (0, $8Zwsm.FilterService).register("custom_".concat(field), function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return filterFunction.apply(void 0, args.concat([
                        {
                            column: col
                        }
                    ]));
                });
                filters[field] = props.filterDisplay === "menu" ? {
                    operator: (0, $8Zwsm.FilterOperator).AND,
                    constraints: [
                        constraint
                    ]
                } : constraint;
                return filters;
            }, {});
        }
        return cloned;
    };
    var filter = function filter(value, field, matchMode) {
        var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var filters = $149bbf8d591193be$var$_objectSpread({}, d_filtersState);
        var meta = filters[field];
        var constraint = meta && meta.operator ? meta.constraints[index] : meta;
        constraint = meta ? {
            value: value,
            matchMode: matchMode || constraint.matchMode
        } : {
            value: value,
            matchMode: matchMode
        };
        props.filterDisplay === "menu" && meta && meta.operator ? filters[field].constraints[index] = constraint : filters[field] = constraint;
        setD_filtersState(filters);
        onFilterApply(filters);
    };
    var reset = function reset() {
        setD_rowsState(props.rows);
        setD_filtersState(cloneFilters(props.filters));
        setGroupRowsSortMetaState(null);
        setEditingMetaState({});
        if (!props.onPage) {
            setFirstState(props.first);
            setRowsState(props.rows);
        }
        if (!props.onSort) {
            setSortFieldState(props.sortField);
            setSortOrderState(props.sortOrder);
            setMultiSortMetaState(props.multiSortMeta);
        }
        if (!props.onFilter) setFiltersState(props.filters);
        resetColumnOrder();
    };
    var resetScroll = function resetScroll() {
        if (wrapperRef.current) {
            var scrollableContainer = !isVirtualScrollerDisabled() ? (0, $cfkGk.DomHandler).findSingle(wrapperRef.current, '[data-pc-name="virtualscroller"]') : wrapperRef.current;
            scrollableContainer.scrollTo(0, 0);
        }
    };
    var resetResizeColumnsWidth = function resetResizeColumnsWidth() {
        destroyStyleElement();
    };
    var resetColumnOrder = function resetColumnOrder() {
        var columns = getColumns(true);
        var columnOrder = [];
        if (columns) columnOrder = columns.reduce(function(orders, col) {
            orders.push(getColumnProp(col, "columnKey") || getColumnProp(col, "field"));
            return orders;
        }, []);
        setColumnOrderState(columnOrder);
    };
    var exportCSV = function exportCSV(options) {
        var data;
        var csv = "\uFEFF";
        var columns = getColumns();
        if (options && options.selectionOnly) data = props.selection || [];
        else data = [].concat($149bbf8d591193be$var$_toConsumableArray(props.frozenValue || []), $149bbf8d591193be$var$_toConsumableArray(processedData() || []));
        //headers
        columns.forEach(function(column, i) {
            var _ref5 = [
                getColumnProp(column, "field"),
                getColumnProp(column, "header"),
                getColumnProp(column, "exportHeader"),
                getColumnProp(column, "exportable")
            ], field = _ref5[0], header = _ref5[1], exportHeader = _ref5[2], exportable = _ref5[3];
            if (exportable && field) {
                var columnHeader = String(exportHeader || header || field).replace(/"/g, '""').replace(/\n/g, "\u2028");
                csv = csv + ('"' + columnHeader + '"');
                if (i < columns.length - 1) csv = csv + props.csvSeparator;
            }
        });
        //body
        data.forEach(function(record) {
            csv = csv + "\n";
            columns.forEach(function(column, i) {
                var _ref6 = [
                    getColumnProp(column, "field"),
                    getColumnProp(column, "exportField"),
                    getColumnProp(column, "exportable")
                ], colField = _ref6[0], exportField = _ref6[1], exportable = _ref6[2];
                var field = exportField || colField;
                if (exportable && field) {
                    var cellData = (0, $cfkGk.ObjectUtils).resolveFieldData(record, field);
                    if (cellData != null) {
                        if (props.exportFunction) cellData = props.exportFunction({
                            data: cellData,
                            field: field,
                            rowData: record,
                            column: column
                        });
                        else cellData = String(cellData).replace(/"/g, '""').replace(/\n/g, "\u2028");
                    } else cellData = "";
                    csv = csv + ('"' + cellData + '"');
                    if (i < columns.length - 1) csv = csv + props.csvSeparator;
                }
            });
        });
        (0, $cfkGk.DomHandler).exportCSV(csv, props.exportFilename);
    };
    var closeEditingCell = function closeEditingCell() {
        if (props.editMode !== "row") document.body.click();
    };
    var closeEditingRows = function closeEditingRows() {
        (0, $cfkGk.DomHandler).find(document.body, '[data-pc-section="roweditorcancelbuttonprops"]').forEach(function(button, index) {
            setTimeout(function() {
                button.click();
            }, index * 5);
        });
    };
    var createEvent = function createEvent(event) {
        return $149bbf8d591193be$var$_objectSpread({
            first: getFirst(),
            rows: getRows(),
            sortField: getSortField(),
            sortOrder: getSortOrder(),
            multiSortMeta: getMultiSortMeta(),
            filters: getFilters()
        }, event);
    };
    var processedData = function processedData(localState) {
        var data = props.value || [];
        if (!props.lazy) {
            if (data && data.length) {
                var filters = localState && localState.filters || getFilters();
                var sortField = localState && localState.sortField || getSortField();
                var sortOrder = localState && localState.sortOrder || getSortOrder();
                var multiSortMeta = localState && localState.multiSortMeta || getMultiSortMeta();
                var _columns3 = getColumns();
                var sortColumn = _columns3.find(function(col) {
                    return getColumnProp(col, "field") === sortField;
                });
                if (sortColumn) {
                    columnSortable.current = getColumnProp(sortColumn, "sortable");
                    columnSortFunction.current = getColumnProp(sortColumn, "sortFunction");
                }
                if ((0, $cfkGk.ObjectUtils).isNotEmpty(filters) || props.globalFilter) data = filterLocal(data, filters);
                if (sortField || (0, $cfkGk.ObjectUtils).isNotEmpty(multiSortMeta)) {
                    if (props.sortMode === "single") data = sortSingle(data, sortField, sortOrder);
                    else if (props.sortMode === "multiple") data = sortMultiple(data, multiSortMeta);
                }
            }
        }
        return data;
    };
    var dataToRender = function dataToRender(data) {
        if (data && props.paginator) {
            var first = props.lazy ? 0 : getFirst();
            return data.slice(first, first + getRows());
        }
        return data;
    };
    (0, $l2NC0.useMountEffect)(function() {
        if (elementRef.current) {
            attributeSelector.current = (0, $cfkGk.UniqueComponentId)();
            elementRef.current.setAttribute(attributeSelector.current, "");
        }
        //setFiltersState(cloneFilters(props.filters)); // Github #4248
        setD_filtersState(cloneFilters(props.filters));
        if (isStateful()) {
            restoreState();
            if (props.resizableColumns) restoreColumnWidths();
        }
    });
    (0, $l2NC0.useUpdateEffect)(function() {
        if (props.responsiveLayout === "stack" && !props.scrollable) createResponsiveStyle();
        return function() {
            destroyResponsiveStyle();
        };
    }, [
        props.breakpoint
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        var filters = cloneFilters(props.filters);
        setFiltersState(filters);
        setD_filtersState(cloneFilters(props.filters));
        if (props.onValueChange) props.onValueChange(processedData({
            filters: filters
        }));
    }, [
        props.filters
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (isStateful()) saveState();
    });
    (0, $l2NC0.useUpdateEffect)(function() {
        destroyResponsiveStyle();
        if (props.responsiveLayout === "stack" && !props.scrollable) createResponsiveStyle();
    }, [
        props.responsiveLayout,
        props.scrollable
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (props.globalFilter) filter(props.globalFilter, "global", props.globalFilterMatchMode);
        else // #3819 was filtering but now reset filter state
        setFiltersState(props.filters);
    }, [
        props.globalFilter,
        props.globalFilterMatchMode
    ]);
    (0, $l2NC0.useUnmountEffect)(function() {
        unbindColumnResizeEvents();
        destroyStyleElement();
        destroyResponsiveStyle();
        destroyBeforeResizeStyleElement();
    });
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            clearState: clearState,
            closeEditingCell: closeEditingCell,
            closeEditingRows: closeEditingRows,
            exportCSV: exportCSV,
            filter: filter,
            reset: reset,
            resetColumnOrder: resetColumnOrder,
            resetScroll: resetScroll,
            resetResizeColumnsWidth: resetResizeColumnsWidth,
            restoreColumnWidths: restoreColumnWidths,
            restoreState: restoreState,
            restoreTableState: restoreTableState,
            saveState: saveState,
            getFilterMeta: function getFilterMeta() {
                return filtersState;
            },
            setFilterMeta: function setFilterMeta(filters) {
                return setFiltersState(filters);
            },
            getSortMeta: function getSortMeta() {
                return multiSortMetaState;
            },
            setSortMeta: function setSortMeta(sorts) {
                return setMultiSortMetaState(sorts);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getTable: function getTable() {
                return tableRef.current;
            },
            getVirtualScroller: function getVirtualScroller() {
                return virtualScrollerRef.current;
            }
        };
    });
    var createLoader = function createLoader() {
        if (props.loading) {
            var loadingIconProps = mergeProps({
                className: ptCallbacks.cx("loadingIcon")
            }, ptCallbacks.ptm("loadingIcon"));
            var icon = props.loadingIcon || /*#__PURE__*/ $81g6h.createElement((0, $dPQhb.SpinnerIcon), $149bbf8d591193be$var$_extends({}, loadingIconProps, {
                spin: true,
                unstyled: props.unstyled
            }));
            var loadingIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $149bbf8d591193be$var$_objectSpread({}, loadingIconProps), {
                props: props
            });
            var loadingOverlayProps = mergeProps({
                className: ptCallbacks.cx("loadingOverlay")
            }, ptCallbacks.ptm("loadingOverlay"));
            return /*#__PURE__*/ $81g6h.createElement("div", loadingOverlayProps, loadingIcon);
        }
        return null;
    };
    var createHeader = function createHeader() {
        if (props.header) {
            var _content = (0, $cfkGk.ObjectUtils).getJSXElement(props.header, {
                props: props
            });
            var headerProps = mergeProps({
                className: ptCallbacks.cx("header")
            }, ptCallbacks.ptm("header"));
            return /*#__PURE__*/ $81g6h.createElement("div", headerProps, _content);
        }
        return null;
    };
    var createTableHeader = function createTableHeader(options, empty, _isVirtualScrollerDisabled) {
        if (props.showHeaders === false) return null;
        var sortField = getSortField();
        var sortOrder = getSortOrder();
        var multiSortMeta = $149bbf8d591193be$var$_toConsumableArray(getMultiSortMeta());
        var groupRowSortField = getGroupRowSortField();
        var filters = d_filtersState;
        var filtersStore = !props.onFilter && props.filters || getFilters();
        var processedData = options.items, virtualScrollerProps = options.props, columns = options.columns;
        var data = _isVirtualScrollerDisabled || virtualScrollerProps.lazy ? processedData : virtualScrollerProps.items;
        return /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$TableHeader, {
            hostName: "DataTable",
            value: data,
            tableProps: props,
            columns: columns,
            tabIndex: props.tabIndex,
            empty: empty,
            headerColumnGroup: props.headerColumnGroup,
            resizableColumns: props.resizableColumns,
            onColumnResizeStart: onColumnResizeStart,
            onColumnResizerClick: props.onColumnResizerClick,
            onColumnResizerDoubleClick: props.onColumnResizerDoubleClick,
            sortMode: props.sortMode,
            sortField: sortField,
            sortIcon: props.sortIcon,
            sortOrder: sortOrder,
            multiSortMeta: multiSortMeta,
            groupRowsBy: props.groupRowsBy,
            groupRowSortField: groupRowSortField,
            onSortChange: onSortChange,
            filterDisplay: props.filterDisplay,
            filters: filters,
            filtersStore: filtersStore,
            filterIcon: props.filterIcon,
            filterClearIcon: props.filterClearIcon,
            onFilterChange: onFilterChange,
            onFilterApply: onFilterApply,
            showSelectAll: props.showSelectAll,
            allRowsSelected: allRowsSelected,
            onColumnCheckboxChange: onColumnHeaderCheckboxChange,
            onColumnMouseDown: onColumnHeaderMouseDown,
            onColumnDragStart: onColumnHeaderDragStart,
            onColumnDragOver: onColumnHeaderDragOver,
            onColumnDragLeave: onColumnHeaderDragLeave,
            onColumnDrop: onColumnHeaderDrop,
            rowGroupMode: props.rowGroupMode,
            reorderableColumns: props.reorderableColumns,
            ptCallbacks: ptCallbacks,
            metaData: metaData,
            unstyled: props.unstyled
        });
    };
    var createTableBody = function createTableBody(options, selectionModeInColumn, empty, isVirtualScrollerDisabled) {
        var first = getFirst();
        var rows = options.rows, columns = options.columns, contentRef = options.contentRef, style = options.style, className = options.className, spacerStyle = options.spacerStyle, itemSize = options.itemSize;
        var frozenBody = (0, $cfkGk.ObjectUtils).isNotEmpty(props.frozenValue) && /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$TableBody, {
            hostName: "DataTable",
            ref: frozenBodyRef,
            cellClassName: props.cellClassName,
            cellSelection: props.cellSelection,
            checkIcon: props.checkIcon,
            className: "p-datatable-tbody p-datatable-frozen-tbody",
            collapsedRowIcon: props.collapsedRowIcon,
            columns: columns,
            compareSelectionBy: props.compareSelectionBy,
            contextMenuSelection: props.contextMenuSelection,
            dataKey: props.dataKey,
            dragSelection: props.dragSelection,
            editMode: props.editMode,
            editingMeta: editingMetaState,
            editingRows: props.editingRows,
            emptyMessage: props.emptyMessage,
            expandableRowGroups: props.expandableRowGroups,
            expandedRowIcon: props.expandedRowIcon,
            expandedRows: props.expandedRows,
            first: first,
            frozenRow: true,
            groupRowsBy: props.groupRowsBy,
            isDataSelectable: props.isDataSelectable,
            isVirtualScrollerDisabled: true,
            lazy: props.lazy,
            loading: props.loading,
            metaKeySelection: props.metaKeySelection,
            onCellClick: props.onCellClick,
            onCellSelect: props.onCellSelect,
            onCellUnselect: props.onCellUnselect,
            onContextMenu: props.onContextMenu,
            onContextMenuSelectionChange: props.onContextMenuSelectionChange,
            onEditingMetaChange: onEditingMetaChange,
            onRowClick: props.onRowClick,
            onRowCollapse: props.onRowCollapse,
            onRowDoubleClick: props.onRowDoubleClick,
            onRowPointerDown: props.onRowPointerDown,
            onRowPointerUp: props.onRowPointerUp,
            onRowEditCancel: props.onRowEditCancel,
            onRowEditChange: props.onRowEditChange,
            onRowEditComplete: props.onRowEditComplete,
            onRowEditInit: props.onRowEditInit,
            onRowEditSave: props.onRowEditSave,
            onRowExpand: props.onRowExpand,
            onRowMouseEnter: props.onRowMouseEnter,
            onRowMouseLeave: props.onRowMouseLeave,
            onRowReorder: props.onRowReorder,
            onRowSelect: props.onRowSelect,
            onRowToggle: props.onRowToggle,
            onRowUnselect: props.onRowUnselect,
            onSelectionChange: props.onSelectionChange,
            paginator: props.paginator,
            reorderableRows: props.reorderableRows,
            responsiveLayout: props.responsiveLayout,
            rowClassName: props.rowClassName,
            rowEditValidator: props.rowEditValidator,
            rowEditorCancelIcon: props.rowEditorCancelIcon,
            rowEditorInitIcon: props.rowEditorInitIcon,
            rowEditorSaveIcon: props.rowEditorSaveIcon,
            rowExpansionTemplate: props.rowExpansionTemplate,
            rowGroupFooterTemplate: props.rowGroupFooterTemplate,
            rowGroupHeaderTemplate: props.rowGroupHeaderTemplate,
            rowGroupMode: props.rowGroupMode,
            scrollable: props.scrollable,
            selectOnEdit: props.selectOnEdit,
            selection: props.selection,
            selectionAutoFocus: props.selectionAutoFocus,
            selectionMode: props.selectionMode,
            selectionModeInColumn: selectionModeInColumn,
            showRowReorderElement: props.showRowReorderElement,
            showSelectionElement: props.showSelectionElement,
            tabIndex: props.tabIndex,
            tableProps: props,
            tableSelector: attributeSelector.current,
            value: props.frozenValue,
            virtualScrollerOptions: options,
            ptCallbacks: ptCallbacks,
            metaData: metaData,
            unstyled: props.unstyled
        });
        var body = /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$TableBody, {
            hostName: "DataTable",
            ref: bodyRef,
            cellClassName: props.cellClassName,
            cellSelection: props.cellSelection,
            checkIcon: props.checkIcon,
            className: (0, $cfkGk.classNames)("p-datatable-tbody", className),
            collapsedRowIcon: props.collapsedRowIcon,
            columns: columns,
            compareSelectionBy: props.compareSelectionBy,
            contextMenuSelection: props.contextMenuSelection,
            dataKey: props.dataKey,
            dragSelection: props.dragSelection,
            editMode: props.editMode,
            editingMeta: editingMetaState,
            editingRows: props.editingRows,
            empty: empty,
            emptyMessage: props.emptyMessage,
            expandableRowGroups: props.expandableRowGroups,
            expandedRowIcon: props.expandedRowIcon,
            expandedRows: props.expandedRows,
            first: first,
            frozenRow: false,
            groupRowsBy: props.groupRowsBy,
            isDataSelectable: props.isDataSelectable,
            isVirtualScrollerDisabled: isVirtualScrollerDisabled,
            lazy: props.lazy,
            loading: props.loading,
            metaKeySelection: props.metaKeySelection,
            onCellClick: props.onCellClick,
            onCellSelect: props.onCellSelect,
            onCellUnselect: props.onCellUnselect,
            onContextMenu: props.onContextMenu,
            onContextMenuSelectionChange: props.onContextMenuSelectionChange,
            onEditingMetaChange: onEditingMetaChange,
            onRowClick: props.onRowClick,
            onRowCollapse: props.onRowCollapse,
            onRowDoubleClick: props.onRowDoubleClick,
            onRowEditCancel: props.onRowEditCancel,
            onRowEditChange: props.onRowEditChange,
            onRowEditComplete: props.onRowEditComplete,
            onRowEditInit: props.onRowEditInit,
            onRowEditSave: props.onRowEditSave,
            onRowExpand: props.onRowExpand,
            onRowMouseEnter: props.onRowMouseEnter,
            onRowMouseLeave: props.onRowMouseLeave,
            onRowPointerDown: props.onRowPointerDown,
            onRowPointerUp: props.onRowPointerUp,
            onRowReorder: props.onRowReorder,
            onRowSelect: props.onRowSelect,
            onRowToggle: props.onRowToggle,
            onRowUnselect: props.onRowUnselect,
            onSelectionChange: props.onSelectionChange,
            paginator: props.paginator,
            reorderableRows: props.reorderableRows,
            responsiveLayout: props.responsiveLayout,
            rowClassName: props.rowClassName,
            rowEditValidator: props.rowEditValidator,
            rowEditorCancelIcon: props.rowEditorCancelIcon,
            rowEditorInitIcon: props.rowEditorInitIcon,
            rowEditorSaveIcon: props.rowEditorSaveIcon,
            rowExpansionTemplate: props.rowExpansionTemplate,
            rowGroupFooterTemplate: props.rowGroupFooterTemplate,
            rowGroupHeaderTemplate: props.rowGroupHeaderTemplate,
            rowGroupMode: props.rowGroupMode,
            scrollable: props.scrollable,
            selectOnEdit: props.selectOnEdit,
            selection: props.selection,
            selectionAutoFocus: props.selectionAutoFocus,
            selectionMode: props.selectionMode,
            selectionModeInColumn: selectionModeInColumn,
            showRowReorderElement: props.showRowReorderElement,
            showSelectionElement: props.showSelectionElement,
            style: style,
            tabIndex: props.tabIndex,
            tableProps: props,
            tableSelector: attributeSelector.current,
            value: dataToRender(rows),
            virtualScrollerContentRef: contentRef,
            virtualScrollerOptions: options,
            ptCallbacks: ptCallbacks,
            metaData: metaData,
            unstyled: props.unstyled
        });
        var spacerBody = (0, $cfkGk.ObjectUtils).isNotEmpty(spacerStyle) ? /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$TableBody, {
            hostName: "DataTable",
            style: {
                height: "calc(".concat(spacerStyle.height, " - ").concat(rows.length * itemSize, "px)")
            },
            className: "p-datatable-virtualscroller-spacer",
            ptCallbacks: ptCallbacks,
            metaData: metaData,
            unstyled: props.unstyled
        }) : null;
        return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, frozenBody, body, spacerBody);
    };
    var createTableFooter = function createTableFooter(options) {
        var columns = options.columns;
        return /*#__PURE__*/ $81g6h.createElement($149bbf8d591193be$var$TableFooter, {
            hostName: "DataTable",
            tableProps: props,
            columns: columns,
            footerColumnGroup: props.footerColumnGroup,
            ptCallbacks: ptCallbacks,
            metaData: metaData,
            unstyled: props.unstyled
        });
    };
    var createContent = function createContent(processedData, columns, selectionModeInColumn, empty) {
        if (!columns) return;
        var _isVirtualScrollerDisabled = isVirtualScrollerDisabled();
        var virtualScrollerOptions = props.virtualScrollerOptions || {};
        var wrapperProps = mergeProps({
            className: ptCallbacks.cx("wrapper"),
            style: $149bbf8d591193be$var$_objectSpread($149bbf8d591193be$var$_objectSpread({}, ptCallbacks.sx("wrapper")), {}, {
                maxHeight: _isVirtualScrollerDisabled ? props.scrollHeight : null
            })
        }, ptCallbacks.ptm("wrapper"));
        return /*#__PURE__*/ $81g6h.createElement("div", $149bbf8d591193be$var$_extends({
            ref: wrapperRef
        }, wrapperProps), /*#__PURE__*/ $81g6h.createElement((0, $2Sldw.VirtualScroller), $149bbf8d591193be$var$_extends({
            ref: virtualScrollerRef
        }, virtualScrollerOptions, {
            items: processedData,
            columns: columns,
            style: $149bbf8d591193be$var$_objectSpread($149bbf8d591193be$var$_objectSpread({}, virtualScrollerOptions.style), {
                height: props.scrollHeight !== "flex" ? props.scrollHeight : undefined
            }),
            scrollHeight: props.scrollHeight !== "flex" ? undefined : "100%",
            disabled: _isVirtualScrollerDisabled,
            loaderDisabled: true,
            inline: true,
            autoSize: true,
            pt: ptCallbacks.ptm("virtualScroller"),
            __parentMetadata: {
                parent: metaData
            },
            showSpacer: false,
            unstyled: props.unstyled,
            contentTemplate: function contentTemplate(options) {
                var ref = function ref(el) {
                    tableRef.current = el;
                    options.spacerRef && options.spacerRef(el);
                };
                var tableHeader = createTableHeader(options, empty, _isVirtualScrollerDisabled);
                var tableBody = createTableBody(options, selectionModeInColumn, empty, _isVirtualScrollerDisabled);
                var tableFooter = createTableFooter(options);
                var tableProps = mergeProps({
                    className: (0, $cfkGk.classNames)(props.tableClassName, ptCallbacks.cx("table")),
                    style: props.tableStyle,
                    role: "table"
                }, ptCallbacks.ptm("table"));
                return /*#__PURE__*/ $81g6h.createElement("table", $149bbf8d591193be$var$_extends({
                    ref: ref
                }, tableProps), tableHeader, tableBody, tableFooter);
            }
        })));
    };
    var createFooter = function createFooter() {
        if (props.footer) {
            var _content2 = (0, $cfkGk.ObjectUtils).getJSXElement(props.footer, {
                props: props
            });
            var footerProps = mergeProps({
                className: ptCallbacks.cx("footer")
            }, ptCallbacks.ptm("footer"));
            return /*#__PURE__*/ $81g6h.createElement("div", footerProps, _content2);
        }
        return null;
    };
    var createPaginator = function createPaginator(position, totalRecords) {
        return /*#__PURE__*/ $81g6h.createElement((0, $e6Cmx.Paginator), {
            first: getFirst(),
            rows: getRows(),
            pageLinkSize: props.pageLinkSize,
            className: (0, $cfkGk.classNames)(props.paginatorClassName, ptCallbacks.cx("paginator", {
                position: position
            })),
            onPageChange: onPageChange,
            template: props.paginatorTemplate,
            totalRecords: totalRecords,
            rowsPerPageOptions: props.rowsPerPageOptions,
            currentPageReportTemplate: props.currentPageReportTemplate,
            leftContent: props.paginatorLeft,
            rightContent: props.paginatorRight,
            alwaysShow: props.alwaysShowPaginator,
            dropdownAppendTo: props.paginatorDropdownAppendTo,
            pt: ptCallbacks.ptm("paginator"),
            unstyled: props.unstyled,
            __parentMetadata: {
                parent: metaData
            }
        });
    };
    var createPaginatorTop = function createPaginatorTop(totalRecords) {
        if (props.paginator && props.paginatorPosition !== "bottom") return createPaginator("top", totalRecords);
        return null;
    };
    var createPaginatorBottom = function createPaginatorBottom(totalRecords) {
        if (props.paginator && props.paginatorPosition !== "top") return createPaginator("bottom", totalRecords);
        return null;
    };
    var createResizeHelper = function createResizeHelper() {
        if (props.resizableColumns) {
            var resizeHelperProps = mergeProps({
                className: ptCallbacks.cx("resizeHelper"),
                style: ptCallbacks.sx("resizeHelper")
            }, ptCallbacks.ptm("resizeHelper"));
            return /*#__PURE__*/ $81g6h.createElement("div", $149bbf8d591193be$var$_extends({
                ref: resizeHelperRef
            }, resizeHelperProps));
        }
        return null;
    };
    var createReorderIndicators = function createReorderIndicators() {
        if (props.reorderableColumns) {
            var style = {
                position: "absolute",
                display: "none"
            };
            var reorderIndicatorUpProps = mergeProps({
                className: ptCallbacks.cx("reorderIndicatorUp"),
                style: ptCallbacks.sx("reorderIndicatorUp", {
                    style: style
                })
            }, ptCallbacks.ptm("reorderIndicatorUp"));
            var reorderIndicatorUpIconProps = mergeProps(ptCallbacks.ptm("reorderIndicatorUpIcon"));
            var reorderIndicatorUpIcon = (0, $cfkGk.IconUtils).getJSXIcon(props.reorderIndicatorUpIcon || /*#__PURE__*/ $81g6h.createElement((0, $fOwK6.ArrowDownIcon), reorderIndicatorUpIconProps), $149bbf8d591193be$var$_objectSpread({}, reorderIndicatorUpIconProps), {
                props: props
            });
            var reorderIndicatorDownProps = mergeProps({
                className: ptCallbacks.cx("reorderIndicatorDown"),
                style: ptCallbacks.sx("reorderIndicatorDown", {
                    style: style
                })
            }, ptCallbacks.ptm("reorderIndicatorDown"));
            var reorderIndicatorDownIconProps = mergeProps(ptCallbacks.ptm("reorderIndicatorDownIcon"));
            var reorderIndicatorDownIcon = (0, $cfkGk.IconUtils).getJSXIcon(props.reorderIndicatorDownIcon || /*#__PURE__*/ $81g6h.createElement((0, $3E86S.ArrowUpIcon), reorderIndicatorDownIconProps), $149bbf8d591193be$var$_objectSpread({}, reorderIndicatorDownIconProps), {
                props: props
            });
            return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("span", $149bbf8d591193be$var$_extends({
                ref: reorderIndicatorUpRef
            }, reorderIndicatorUpProps), reorderIndicatorUpIcon), /*#__PURE__*/ $81g6h.createElement("span", $149bbf8d591193be$var$_extends({
                ref: reorderIndicatorDownRef
            }, reorderIndicatorDownProps), reorderIndicatorDownIcon));
        }
        return null;
    };
    var data = processedData();
    var columns = getColumns();
    var totalRecords = getTotalRecords(data);
    var empty = (0, $cfkGk.ObjectUtils).isEmpty(data);
    var selectionModeInColumn = getSelectionModeInColumn(columns);
    var selectable = props.selectionMode || selectionModeInColumn;
    var loader = createLoader();
    var header = createHeader();
    var paginatorTop = createPaginatorTop(totalRecords);
    var content = createContent(data, columns, selectionModeInColumn, empty);
    var paginatorBottom = createPaginatorBottom(totalRecords);
    var footer = createFooter();
    var resizeHelper = createResizeHelper();
    var reorderIndicators = createReorderIndicators();
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $cfkGk.classNames)(props.className, ptCallbacks.cx("root", {
            selectable: selectable
        })),
        style: props.style,
        "data-scrollselectors": ".p-datatable-wrapper",
        "data-showgridlines": props.showGridlines
    }, $149bbf8d591193be$var$DataTableBase.getOtherProps(props), ptCallbacks.ptm("root"));
    return /*#__PURE__*/ $81g6h.createElement("div", $149bbf8d591193be$var$_extends({
        ref: elementRef
    }, rootProps), loader, header, paginatorTop, content, paginatorBottom, footer, resizeHelper, reorderIndicators);
});
$149bbf8d591193be$export$df30df7ec97b32b5.displayName = "DataTable";

});
parcelRegister("fOwK6", function(module, exports) {

$parcel$export(module.exports, "ArrowDownIcon", () => $b834ec84c9d225f4$export$1c939d3c9b6931b);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $b834ec84c9d225f4$var$_extends() {
    $b834ec84c9d225f4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b834ec84c9d225f4$var$_extends.apply(this, arguments);
}
var $b834ec84c9d225f4$export$1c939d3c9b6931b = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $b834ec84c9d225f4$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.99994 14C6.91097 14.0004 6.82281 13.983 6.74064 13.9489C6.65843 13.9148 6.58387 13.8646 6.52133 13.8013L1.10198 8.38193C0.982318 8.25351 0.917175 8.08367 0.920272 7.90817C0.923368 7.73267 0.994462 7.56523 1.11858 7.44111C1.24269 7.317 1.41014 7.2459 1.58563 7.2428C1.76113 7.23971 1.93098 7.30485 2.0594 7.42451L6.32263 11.6877V0.677419C6.32263 0.497756 6.394 0.325452 6.52104 0.198411C6.64808 0.0713706 6.82039 0 7.00005 0C7.17971 0 7.35202 0.0713706 7.47906 0.198411C7.6061 0.325452 7.67747 0.497756 7.67747 0.677419V11.6877L11.9407 7.42451C12.0691 7.30485 12.2389 7.23971 12.4144 7.2428C12.5899 7.2459 12.7574 7.317 12.8815 7.44111C13.0056 7.56523 13.0767 7.73267 13.0798 7.90817C13.0829 8.08367 13.0178 8.25351 12.8981 8.38193L7.47875 13.8013C7.41621 13.8646 7.34164 13.9148 7.25944 13.9489C7.17727 13.983 7.08912 14.0004 7.00015 14C7.00012 14 7.00009 14 7.00005 14C7.00001 14 6.99998 14 6.99994 14Z",
        fill: "currentColor"
    }));
}));
$b834ec84c9d225f4$export$1c939d3c9b6931b.displayName = "ArrowDownIcon";

});

parcelRegister("3E86S", function(module, exports) {

$parcel$export(module.exports, "ArrowUpIcon", () => $2a7b65f9e3ab4bd1$export$f1a507b991affc46);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $2a7b65f9e3ab4bd1$var$_extends() {
    $2a7b65f9e3ab4bd1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2a7b65f9e3ab4bd1$var$_extends.apply(this, arguments);
}
var $2a7b65f9e3ab4bd1$export$f1a507b991affc46 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $2a7b65f9e3ab4bd1$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.51551 13.799C6.64205 13.9255 6.813 13.9977 6.99193 14C7.17087 13.9977 7.34182 13.9255 7.46835 13.799C7.59489 13.6725 7.66701 13.5015 7.66935 13.3226V2.31233L11.9326 6.57554C11.9951 6.63887 12.0697 6.68907 12.1519 6.72319C12.2341 6.75731 12.3223 6.77467 12.4113 6.77425C12.5003 6.77467 12.5885 6.75731 12.6707 6.72319C12.7529 6.68907 12.8274 6.63887 12.89 6.57554C13.0168 6.44853 13.0881 6.27635 13.0881 6.09683C13.0881 5.91732 13.0168 5.74514 12.89 5.61812L7.48846 0.216594C7.48274 0.210436 7.4769 0.204374 7.47094 0.198411C7.3439 0.0713707 7.1716 0 6.99193 0C6.81227 0 6.63997 0.0713707 6.51293 0.198411C6.50704 0.204296 6.50128 0.210278 6.49563 0.216354L1.09386 5.61812C0.974201 5.74654 0.909057 5.91639 0.912154 6.09189C0.91525 6.26738 0.986345 6.43483 1.11046 6.55894C1.23457 6.68306 1.40202 6.75415 1.57752 6.75725C1.75302 6.76035 1.92286 6.6952 2.05128 6.57554L6.31451 2.31231V13.3226C6.31685 13.5015 6.38898 13.6725 6.51551 13.799Z",
        fill: "currentColor"
    }));
}));
$2a7b65f9e3ab4bd1$export$f1a507b991affc46.displayName = "ArrowUpIcon";

});

parcelRegister("e6Cmx", function(module, exports) {

$parcel$export(module.exports, "Paginator", () => $a44f623ece12d8fa$export$98986e0ddad1af5a);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $cfkGk = parcelRequire("cfkGk");

var $5z9b3 = parcelRequire("5z9b3");

var $9rbaG = parcelRequire("9rbaG");

var $xyzRL = parcelRequire("xyzRL");

var $1PSYX = parcelRequire("1PSYX");

var $1gPAC = parcelRequire("1gPAC");

var $geU5g = parcelRequire("geU5g");

var $eT9rN = parcelRequire("eT9rN");
"use client";
function $a44f623ece12d8fa$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a44f623ece12d8fa$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $a44f623ece12d8fa$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a44f623ece12d8fa$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a44f623ece12d8fa$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a44f623ece12d8fa$var$_arrayLikeToArray(o, minLen);
}
function $a44f623ece12d8fa$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a44f623ece12d8fa$var$_slicedToArray(arr, i) {
    return $a44f623ece12d8fa$var$_arrayWithHoles(arr) || $a44f623ece12d8fa$var$_iterableToArrayLimit(arr, i) || $a44f623ece12d8fa$var$_unsupportedIterableToArray(arr, i) || $a44f623ece12d8fa$var$_nonIterableRest();
}
function $a44f623ece12d8fa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a44f623ece12d8fa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a44f623ece12d8fa$var$_typeof(o);
}
function $a44f623ece12d8fa$var$_toPrimitive(input, hint) {
    if ($a44f623ece12d8fa$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a44f623ece12d8fa$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $a44f623ece12d8fa$var$_toPropertyKey(arg) {
    var key = $a44f623ece12d8fa$var$_toPrimitive(arg, "string");
    return $a44f623ece12d8fa$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a44f623ece12d8fa$var$_defineProperty(obj, key, value) {
    key = $a44f623ece12d8fa$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a44f623ece12d8fa$var$classes = {
    root: "p-paginator p-component",
    left: "p-paginator-left-content",
    end: "p-paginator-right-content",
    firstPageIcon: "p-paginator-icon",
    firstPageButton: function firstPageButton(_ref) {
        var disabled = _ref.disabled;
        return (0, $cfkGk.classNames)("p-paginator-first p-paginator-element p-link", {
            "p-disabled": disabled
        });
    },
    prevPageIcon: "p-paginator-icon",
    prevPageButton: function prevPageButton(_ref2) {
        var disabled = _ref2.disabled;
        return (0, $cfkGk.classNames)("p-paginator-prev p-paginator-element p-link", {
            "p-disabled": disabled
        });
    },
    nextPageIcon: "p-paginator-icon",
    nextPageButton: function nextPageButton(_ref3) {
        var disabled = _ref3.disabled;
        return (0, $cfkGk.classNames)("p-paginator-next p-paginator-element p-link", {
            "p-disabled": disabled
        });
    },
    lastPageIcon: "p-paginator-icon",
    lastPageButton: function lastPageButton(_ref4) {
        var disabled = _ref4.disabled;
        return (0, $cfkGk.classNames)("p-paginator-last p-paginator-element p-link", {
            "p-disabled": disabled
        });
    },
    pageButton: function pageButton(_ref5) {
        var pageLink = _ref5.pageLink, startPageInView = _ref5.startPageInView, endPageInView = _ref5.endPageInView, page = _ref5.page;
        return (0, $cfkGk.classNames)("p-paginator-page p-paginator-element p-link", {
            "p-paginator-page-start": pageLink === startPageInView,
            "p-paginator-page-end": pageLink === endPageInView,
            "p-highlight": pageLink - 1 === page
        });
    },
    pages: "p-paginator-pages"
};
var $a44f623ece12d8fa$var$styles = "\n@layer primereact {\n    .p-paginator {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-wrap: wrap;\n    }\n    \n    .p-paginator-left-content {\n        margin-right: auto;\n    }\n    \n    .p-paginator-right-content {\n        margin-left: auto;\n    }\n    \n    .p-paginator-page,\n    .p-paginator-next,\n    .p-paginator-last,\n    .p-paginator-first,\n    .p-paginator-prev,\n    .p-paginator-current {\n        cursor: pointer;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        line-height: 1;\n        user-select: none;\n        overflow: hidden;\n        position: relative;\n    }\n    \n    .p-paginator-element:focus {\n        z-index: 1;\n        position: relative;\n    }\n}\n";
var $a44f623ece12d8fa$var$PaginatorBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Paginator",
        __parentMetadata: null,
        totalRecords: 0,
        rows: 0,
        first: 0,
        pageLinkSize: 5,
        rowsPerPageOptions: null,
        alwaysShow: true,
        style: null,
        className: null,
        template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
        onPageChange: null,
        leftContent: null,
        rightContent: null,
        dropdownAppendTo: null,
        currentPageReportTemplate: "({currentPage} of {totalPages})",
        children: undefined
    },
    css: {
        classes: $a44f623ece12d8fa$var$classes,
        styles: $a44f623ece12d8fa$var$styles
    }
});
var $a44f623ece12d8fa$var$CurrentPageReportBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "CurrentPageReport",
        pageCount: null,
        page: null,
        first: null,
        rows: null,
        totalRecords: null,
        reportTemplate: "({currentPage} of {totalPages})",
        template: null,
        children: undefined
    }
});
var $a44f623ece12d8fa$var$FirstPageLinkBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "FirstPageLink",
        disabled: false,
        onClick: null,
        template: null,
        firstPageLinkIcon: null,
        children: undefined
    }
});
var $a44f623ece12d8fa$var$JumpToPageInputBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "JumpToPageInput",
        page: null,
        rows: null,
        pageCount: null,
        disabled: false,
        template: null,
        onChange: null,
        children: undefined,
        metaData: null,
        ptm: null
    }
});
var $a44f623ece12d8fa$var$LastPageLinkBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "LastPageLink",
        disabled: false,
        onClick: null,
        template: null,
        lastPageLinkIcon: null,
        children: undefined
    }
});
var $a44f623ece12d8fa$var$NextPageLinkBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "NextPageLink",
        disabled: false,
        onClick: null,
        template: null,
        nextPageLinkIcon: null,
        children: undefined
    }
});
var $a44f623ece12d8fa$var$PageLinksBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "PageLinks",
        value: null,
        page: null,
        rows: null,
        pageCount: null,
        links: null,
        template: null,
        children: undefined
    }
});
var $a44f623ece12d8fa$var$PrevPageLinkBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "PrevPageLink",
        disabled: false,
        onClick: null,
        template: null,
        prevPageLinkIcon: null,
        children: undefined
    }
});
var $a44f623ece12d8fa$var$RowsPerPageDropdownBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "RowsPerPageDropdown",
        options: null,
        value: null,
        page: null,
        pageCount: null,
        totalRecords: 0,
        appendTo: null,
        onChange: null,
        template: null,
        disabled: false,
        children: undefined
    }
});
function $a44f623ece12d8fa$var$ownKeys$5(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a44f623ece12d8fa$var$_objectSpread$5(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a44f623ece12d8fa$var$ownKeys$5(Object(t), !0).forEach(function(r) {
            $a44f623ece12d8fa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a44f623ece12d8fa$var$ownKeys$5(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a44f623ece12d8fa$var$CurrentPageReport = /*#__PURE__*/ $81g6h.memo(function(inProps) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $a44f623ece12d8fa$var$CurrentPageReportBase.getProps(inProps, context);
    var report = {
        currentPage: props.page + 1,
        totalPages: props.totalPages,
        first: Math.min(props.first + 1, props.totalRecords),
        last: Math.min(props.first + props.rows, props.totalRecords),
        rows: props.rows,
        totalRecords: props.totalRecords
    };
    var text = props.reportTemplate.replace("{currentPage}", report.currentPage).replace("{totalPages}", report.totalPages).replace("{first}", report.first).replace("{last}", report.last).replace("{rows}", report.rows).replace("{totalRecords}", report.totalRecords);
    var currentProps = mergeProps({
        "aria-live": "polite",
        className: "p-paginator-current"
    }, props.ptm("current", {
        hostName: props.hostName
    }));
    var element = /*#__PURE__*/ $81g6h.createElement("span", currentProps, text);
    if (props.template) {
        var defaultOptions = $a44f623ece12d8fa$var$_objectSpread$5($a44f623ece12d8fa$var$_objectSpread$5({}, report), {
            ariaLive: "polite",
            className: "p-paginator-current",
            element: element,
            props: props
        });
        return (0, $cfkGk.ObjectUtils).getJSXElement(props.template, defaultOptions);
    }
    return element;
});
$a44f623ece12d8fa$var$CurrentPageReport.displayName = "CurrentPageReport";
function $a44f623ece12d8fa$var$ownKeys$4(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a44f623ece12d8fa$var$_objectSpread$4(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a44f623ece12d8fa$var$ownKeys$4(Object(t), !0).forEach(function(r) {
            $a44f623ece12d8fa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a44f623ece12d8fa$var$ownKeys$4(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a44f623ece12d8fa$var$FirstPageLink = /*#__PURE__*/ $81g6h.memo(function(inProps) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $a44f623ece12d8fa$var$FirstPageLinkBase.getProps(inProps, context);
    var ptm = props.ptm, cx = props.cx;
    var getPTOptions = function getPTOptions(key) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                disabled: props.disabled
            }
        });
    };
    var className = (0, $cfkGk.classNames)("p-paginator-first p-paginator-element p-link", {
        "p-disabled": props.disabled
    });
    var iconClassName = "p-paginator-icon";
    var firstPageIconProps = mergeProps({
        className: cx("firstPageIcon")
    }, getPTOptions("firstPageIcon"));
    var icon = props.firstPageLinkIcon || /*#__PURE__*/ $81g6h.createElement((0, $5z9b3.AngleDoubleLeftIcon), firstPageIconProps);
    var firstPageLinkIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $a44f623ece12d8fa$var$_objectSpread$4({}, firstPageIconProps), {
        props: props
    });
    var firstPageButtonProps = mergeProps({
        type: "button",
        className: cx("firstPageButton", {
            disabled: props.disabled
        }),
        onClick: props.onClick,
        disabled: props.disabled,
        "aria-label": (0, $8Zwsm.ariaLabel)("firstPageLabel")
    }, getPTOptions("firstPageButton"));
    var element = /*#__PURE__*/ $81g6h.createElement("button", firstPageButtonProps, firstPageLinkIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
    if (props.template) {
        var defaultOptions = {
            onClick: props.onClick,
            className: className,
            iconClassName: iconClassName,
            disabled: props.disabled,
            element: element,
            props: props
        };
        return (0, $cfkGk.ObjectUtils).getJSXElement(props.template, defaultOptions);
    }
    return element;
});
$a44f623ece12d8fa$var$FirstPageLink.displayName = "FirstPageLink";
function $a44f623ece12d8fa$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a44f623ece12d8fa$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a44f623ece12d8fa$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a44f623ece12d8fa$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a44f623ece12d8fa$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a44f623ece12d8fa$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $a44f623ece12d8fa$var$FilterMatchMode = Object.freeze({
    STARTS_WITH: "startsWith",
    CONTAINS: "contains",
    NOT_CONTAINS: "notContains",
    ENDS_WITH: "endsWith",
    EQUALS: "equals",
    NOT_EQUALS: "notEquals",
    IN: "in",
    LESS_THAN: "lt",
    LESS_THAN_OR_EQUAL_TO: "lte",
    GREATER_THAN: "gt",
    GREATER_THAN_OR_EQUAL_TO: "gte",
    BETWEEN: "between",
    DATE_IS: "dateIs",
    DATE_IS_NOT: "dateIsNot",
    DATE_BEFORE: "dateBefore",
    DATE_AFTER: "dateAfter",
    CUSTOM: "custom"
});
/**
 * @deprecated please use PrimeReactContext
 */ var $a44f623ece12d8fa$var$PrimeReact = /*#__PURE__*/ $a44f623ece12d8fa$var$_createClass(function PrimeReact() {
    $a44f623ece12d8fa$var$_classCallCheck(this, PrimeReact);
});
$a44f623ece12d8fa$var$_defineProperty($a44f623ece12d8fa$var$PrimeReact, "ripple", false);
$a44f623ece12d8fa$var$_defineProperty($a44f623ece12d8fa$var$PrimeReact, "inputStyle", "outlined");
$a44f623ece12d8fa$var$_defineProperty($a44f623ece12d8fa$var$PrimeReact, "locale", "en");
$a44f623ece12d8fa$var$_defineProperty($a44f623ece12d8fa$var$PrimeReact, "appendTo", null);
$a44f623ece12d8fa$var$_defineProperty($a44f623ece12d8fa$var$PrimeReact, "cssTransition", true);
$a44f623ece12d8fa$var$_defineProperty($a44f623ece12d8fa$var$PrimeReact, "autoZIndex", true);
$a44f623ece12d8fa$var$_defineProperty($a44f623ece12d8fa$var$PrimeReact, "hideOverlaysOnDocumentScrolling", false);
$a44f623ece12d8fa$var$_defineProperty($a44f623ece12d8fa$var$PrimeReact, "nonce", null);
$a44f623ece12d8fa$var$_defineProperty($a44f623ece12d8fa$var$PrimeReact, "nullSortOrder", 1);
$a44f623ece12d8fa$var$_defineProperty($a44f623ece12d8fa$var$PrimeReact, "zIndex", {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
    toast: 1200
});
$a44f623ece12d8fa$var$_defineProperty($a44f623ece12d8fa$var$PrimeReact, "pt", undefined);
$a44f623ece12d8fa$var$_defineProperty($a44f623ece12d8fa$var$PrimeReact, "filterMatchModeOptions", {
    text: [
        $a44f623ece12d8fa$var$FilterMatchMode.STARTS_WITH,
        $a44f623ece12d8fa$var$FilterMatchMode.CONTAINS,
        $a44f623ece12d8fa$var$FilterMatchMode.NOT_CONTAINS,
        $a44f623ece12d8fa$var$FilterMatchMode.ENDS_WITH,
        $a44f623ece12d8fa$var$FilterMatchMode.EQUALS,
        $a44f623ece12d8fa$var$FilterMatchMode.NOT_EQUALS
    ],
    numeric: [
        $a44f623ece12d8fa$var$FilterMatchMode.EQUALS,
        $a44f623ece12d8fa$var$FilterMatchMode.NOT_EQUALS,
        $a44f623ece12d8fa$var$FilterMatchMode.LESS_THAN,
        $a44f623ece12d8fa$var$FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        $a44f623ece12d8fa$var$FilterMatchMode.GREATER_THAN,
        $a44f623ece12d8fa$var$FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
    ],
    date: [
        $a44f623ece12d8fa$var$FilterMatchMode.DATE_IS,
        $a44f623ece12d8fa$var$FilterMatchMode.DATE_IS_NOT,
        $a44f623ece12d8fa$var$FilterMatchMode.DATE_BEFORE,
        $a44f623ece12d8fa$var$FilterMatchMode.DATE_AFTER
    ]
});
$a44f623ece12d8fa$var$_defineProperty($a44f623ece12d8fa$var$PrimeReact, "changeTheme", function(currentTheme, newTheme, linkElementId, callback) {
    var _linkElement$parentNo;
    var linkElement = document.getElementById(linkElementId);
    var cloneLinkElement = linkElement.cloneNode(true);
    var newThemeUrl = linkElement.getAttribute("href").replace(currentTheme, newTheme);
    cloneLinkElement.setAttribute("id", linkElementId + "-clone");
    cloneLinkElement.setAttribute("href", newThemeUrl);
    cloneLinkElement.addEventListener("load", function() {
        linkElement.remove();
        cloneLinkElement.setAttribute("id", linkElementId);
        if (callback) callback();
    });
    (_linkElement$parentNo = linkElement.parentNode) === null || _linkElement$parentNo === void 0 || _linkElement$parentNo.insertBefore(cloneLinkElement, linkElement.nextSibling);
});
var $a44f623ece12d8fa$var$locales = {
    en: {
        accept: "Yes",
        addRule: "Add Rule",
        am: "AM",
        apply: "Apply",
        cancel: "Cancel",
        choose: "Choose",
        chooseDate: "Choose Date",
        chooseMonth: "Choose Month",
        chooseYear: "Choose Year",
        clear: "Clear",
        completed: "Completed",
        contains: "Contains",
        custom: "Custom",
        dateAfter: "Date is after",
        dateBefore: "Date is before",
        dateFormat: "mm/dd/yy",
        dateIs: "Date is",
        dateIsNot: "Date is not",
        dayNames: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        dayNamesMin: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
        ],
        dayNamesShort: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        emptyFilterMessage: "No results found",
        emptyMessage: "No available options",
        emptySearchMessage: "No results found",
        emptySelectionMessage: "No selected item",
        endsWith: "Ends with",
        equals: "Equals",
        fileSizeTypes: [
            "B",
            "KB",
            "MB",
            "GB",
            "TB",
            "PB",
            "EB",
            "ZB",
            "YB"
        ],
        filter: "Filter",
        firstDayOfWeek: 0,
        gt: "Greater than",
        gte: "Greater than or equal to",
        lt: "Less than",
        lte: "Less than or equal to",
        matchAll: "Match All",
        matchAny: "Match Any",
        medium: "Medium",
        monthNames: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthNamesShort: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        nextDecade: "Next Decade",
        nextHour: "Next Hour",
        nextMinute: "Next Minute",
        nextMonth: "Next Month",
        nextSecond: "Next Second",
        nextYear: "Next Year",
        noFilter: "No Filter",
        notContains: "Not contains",
        notEquals: "Not equals",
        now: "Now",
        passwordPrompt: "Enter a password",
        pending: "Pending",
        pm: "PM",
        prevDecade: "Previous Decade",
        prevHour: "Previous Hour",
        prevMinute: "Previous Minute",
        prevMonth: "Previous Month",
        prevSecond: "Previous Second",
        prevYear: "Previous Year",
        reject: "No",
        removeRule: "Remove Rule",
        searchMessage: "{0} results are available",
        selectionMessage: "{0} items selected",
        showMonthAfterYear: false,
        startsWith: "Starts with",
        strong: "Strong",
        today: "Today",
        upload: "Upload",
        weak: "Weak",
        weekHeader: "Wk",
        aria: {
            cancelEdit: "Cancel Edit",
            close: "Close",
            collapseRow: "Row Collapsed",
            editRow: "Edit Row",
            expandRow: "Row Expanded",
            falseLabel: "False",
            filterConstraint: "Filter Constraint",
            filterOperator: "Filter Operator",
            firstPageLabel: "First Page",
            gridView: "Grid View",
            hideFilterMenu: "Hide Filter Menu",
            jumpToPageDropdownLabel: "Jump to Page Dropdown",
            jumpToPageInputLabel: "Jump to Page Input",
            lastPageLabel: "Last Page",
            listView: "List View",
            moveAllToSource: "Move All to Source",
            moveAllToTarget: "Move All to Target",
            moveBottom: "Move Bottom",
            moveDown: "Move Down",
            moveToSource: "Move to Source",
            moveToTarget: "Move to Target",
            moveTop: "Move Top",
            moveUp: "Move Up",
            navigation: "Navigation",
            next: "Next",
            nextPageLabel: "Next Page",
            nullLabel: "Not Selected",
            pageLabel: "Page {page}",
            otpLabel: "Please enter one time password character {0}",
            passwordHide: "Hide Password",
            passwordShow: "Show Password",
            previous: "Previous",
            previousPageLabel: "Previous Page",
            rotateLeft: "Rotate Left",
            rotateRight: "Rotate Right",
            rowsPerPageLabel: "Rows per page",
            saveEdit: "Save Edit",
            scrollTop: "Scroll Top",
            selectAll: "All items selected",
            selectRow: "Row Selected",
            showFilterMenu: "Show Filter Menu",
            slide: "Slide",
            slideNumber: "{slideNumber}",
            star: "1 star",
            stars: "{star} stars",
            trueLabel: "True",
            unselectAll: "All items unselected",
            unselectRow: "Row Unselected",
            zoomImage: "Zoom Image",
            zoomIn: "Zoom In",
            zoomOut: "Zoom Out"
        }
    }
};
/**
 * Find an ARIA label in the locale by key.  If options are passed it will replace all options:
 * ```ts
 * const ariaValue = "Page {page}, User {user}, Role {role}";
 * const options = { page: 2, user: "John", role: "Admin" };
 * const result = ariaLabel('yourLabel', { page: 2, user: "John", role: "Admin" })
 * console.log(result); // Output: Page 2, User John, Role Admin
 * ```
 * @param {string} ariaKey key of the ARIA label to look up in locale.
 * @param {any} options JSON options like { page: 2, user: "John", role: "Admin" }
 * @returns the ARIA label with replaced values
 */ function $a44f623ece12d8fa$var$ariaLabel(ariaKey, options) {
    if (ariaKey.includes("__proto__") || ariaKey.includes("prototype")) throw new Error("Unsafe ariaKey detected");
    var _locale = $a44f623ece12d8fa$var$PrimeReact.locale;
    try {
        var _ariaLabel = $a44f623ece12d8fa$var$localeOptions(_locale).aria[ariaKey];
        if (_ariaLabel) {
            for(var key in options)if (options.hasOwnProperty(key)) _ariaLabel = _ariaLabel.replace("{".concat(key, "}"), options[key]);
        }
        return _ariaLabel;
    } catch (error) {
        throw new Error("The ".concat(ariaKey, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
function $a44f623ece12d8fa$var$localeOptions(locale) {
    var _locale = locale || $a44f623ece12d8fa$var$PrimeReact.locale;
    if (_locale.includes("__proto__") || _locale.includes("prototype")) throw new Error("Unsafe locale detected");
    return $a44f623ece12d8fa$var$locales[_locale];
}
var $a44f623ece12d8fa$var$JumpToPageInput = /*#__PURE__*/ $81g6h.memo(function(inProps) {
    (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $a44f623ece12d8fa$var$JumpToPageInputBase.getProps(inProps, context);
    var ariaLabelValue = $a44f623ece12d8fa$var$ariaLabel("jumpToPageInputLabel");
    var onChange = function onChange(event) {
        if (props.onChange) props.onChange(props.rows * (event.value - 1), props.rows);
    };
    var value = props.totalPages > 0 ? props.page + 1 : 0;
    var element = /*#__PURE__*/ $81g6h.createElement((0, $xyzRL.InputNumber), {
        value: value,
        onChange: onChange,
        className: "p-paginator-page-input",
        disabled: props.disabled,
        pt: props.ptm("JTPInput"),
        unstyled: props.unstyled,
        __parentMetadata: {
            parent: props.metaData
        },
        "aria-label": ariaLabelValue
    });
    if (props.template) {
        var defaultOptions = {
            value: value,
            onChange: onChange,
            disabled: props.disabled,
            className: "p-paginator-page-input",
            "aria-label": ariaLabelValue,
            element: element,
            props: props
        };
        return (0, $cfkGk.ObjectUtils).getJSXElement(props.template, defaultOptions);
    }
    return element;
});
$a44f623ece12d8fa$var$JumpToPageInput.displayName = "JumpToPageInput";
function $a44f623ece12d8fa$var$ownKeys$3(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a44f623ece12d8fa$var$_objectSpread$3(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a44f623ece12d8fa$var$ownKeys$3(Object(t), !0).forEach(function(r) {
            $a44f623ece12d8fa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a44f623ece12d8fa$var$ownKeys$3(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a44f623ece12d8fa$var$LastPageLink = /*#__PURE__*/ $81g6h.memo(function(inProps) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $a44f623ece12d8fa$var$LastPageLinkBase.getProps(inProps, context);
    var ptm = props.ptm, cx = props.cx;
    var getPTOptions = function getPTOptions(key) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                disabled: props.disabled
            }
        });
    };
    var className = (0, $cfkGk.classNames)("p-paginator-last p-paginator-element p-link", {
        "p-disabled": props.disabled
    });
    var iconClassName = "p-paginator-icon";
    var lastPageIconProps = mergeProps({
        className: cx("lastPageIcon")
    }, getPTOptions("lastPageIcon"));
    var icon = props.lastPageLinkIcon || /*#__PURE__*/ $81g6h.createElement((0, $1PSYX.AngleDoubleRightIcon), lastPageIconProps);
    var lastPageLinkIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $a44f623ece12d8fa$var$_objectSpread$3({}, lastPageIconProps), {
        props: props
    });
    var lastPageButtonProps = mergeProps({
        type: "button",
        className: cx("lastPageButton", {
            disabled: props.disabled
        }),
        onClick: props.onClick,
        disabled: props.disabled,
        "aria-label": (0, $8Zwsm.ariaLabel)("lastPageLabel")
    }, getPTOptions("lastPageButton"));
    var element = /*#__PURE__*/ $81g6h.createElement("button", lastPageButtonProps, lastPageLinkIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
    if (props.template) {
        var defaultOptions = {
            onClick: props.onClick,
            className: className,
            iconClassName: iconClassName,
            disabled: props.disabled,
            element: element,
            props: props
        };
        return (0, $cfkGk.ObjectUtils).getJSXElement(props.template, defaultOptions);
    }
    return element;
});
$a44f623ece12d8fa$var$LastPageLink.displayName = "LastPageLink";
function $a44f623ece12d8fa$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a44f623ece12d8fa$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a44f623ece12d8fa$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $a44f623ece12d8fa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a44f623ece12d8fa$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a44f623ece12d8fa$var$NextPageLink = /*#__PURE__*/ $81g6h.memo(function(inProps) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $a44f623ece12d8fa$var$NextPageLinkBase.getProps(inProps, context);
    var ptm = props.ptm, cx = props.cx;
    var getPTOptions = function getPTOptions(key) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                disabled: props.disabled
            }
        });
    };
    var className = (0, $cfkGk.classNames)("p-paginator-next p-paginator-element p-link", {
        "p-disabled": props.disabled
    });
    var iconClassName = "p-paginator-icon";
    var nextPageIconProps = mergeProps({
        className: cx("nextPageIcon")
    }, getPTOptions("nextPageIcon"));
    var icon = props.nextPageLinkIcon || /*#__PURE__*/ $81g6h.createElement((0, $1gPAC.AngleRightIcon), nextPageIconProps);
    var nextPageLinkIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $a44f623ece12d8fa$var$_objectSpread$2({}, nextPageIconProps), {
        props: props
    });
    var nextPageButtonProps = mergeProps({
        type: "button",
        className: cx("nextPageButton", {
            disabled: props.disabled
        }),
        onClick: props.onClick,
        disabled: props.disabled,
        "aria-label": (0, $8Zwsm.ariaLabel)("nextPageLabel")
    }, getPTOptions("nextPageButton"));
    var element = /*#__PURE__*/ $81g6h.createElement("button", nextPageButtonProps, nextPageLinkIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
    if (props.template) {
        var defaultOptions = {
            onClick: props.onClick,
            className: className,
            iconClassName: iconClassName,
            disabled: props.disabled,
            element: element,
            nextPageLinkIcon: nextPageLinkIcon,
            props: props
        };
        return (0, $cfkGk.ObjectUtils).getJSXElement(props.template, defaultOptions);
    }
    return element;
});
$a44f623ece12d8fa$var$NextPageLink.displayName = "NextPageLink";
var $a44f623ece12d8fa$var$PageLinks = /*#__PURE__*/ $81g6h.memo(function(inProps) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $a44f623ece12d8fa$var$PageLinksBase.getProps(inProps, context);
    var ptm = props.ptm, cx = props.cx;
    var getPTOptions = function getPTOptions(pageLink, key) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                active: pageLink - 1 === props.page
            }
        });
    };
    var onPageLinkClick = function onPageLinkClick(event, pageLink) {
        if (props.onClick) props.onClick({
            originalEvent: event,
            value: pageLink
        });
        event.preventDefault();
    };
    var elements;
    if (props.value) {
        var startPageInView = props.value[0];
        var endPageInView = props.value[props.value.length - 1];
        elements = props.value.map(function(pageLink) {
            var className = (0, $cfkGk.classNames)("p-paginator-page p-paginator-element p-link", {
                "p-paginator-page-start": pageLink === startPageInView,
                "p-paginator-page-end": pageLink === endPageInView,
                "p-highlight": pageLink - 1 === props.page
            });
            var pageButtonProps = mergeProps({
                type: "button",
                onClick: function onClick(e) {
                    return onPageLinkClick(e, pageLink);
                },
                className: cx("pageButton", {
                    pageLink: pageLink,
                    startPageInView: startPageInView,
                    endPageInView: endPageInView,
                    page: props.page
                }),
                disabled: props.disabled,
                "aria-label": (0, $8Zwsm.ariaLabel)("pageLabel", {
                    page: pageLink
                }),
                "aria-current": pageLink - 1 === props.page ? "true" : undefined
            }, getPTOptions(pageLink, "pageButton"));
            var element = /*#__PURE__*/ $81g6h.createElement("button", pageButtonProps, pageLink, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
            if (props.template) {
                var defaultOptions = {
                    onClick: function onClick(e) {
                        return onPageLinkClick(e, pageLink);
                    },
                    className: className,
                    view: {
                        startPage: startPageInView - 1,
                        endPage: endPageInView - 1
                    },
                    page: pageLink - 1,
                    currentPage: props.page,
                    totalPages: props.totalPages,
                    ariaLabel: (0, $8Zwsm.ariaLabel)("pageLabel", {
                        page: pageLink
                    }),
                    ariaCurrent: pageLink - 1 === props.page ? "true" : undefined,
                    element: element,
                    props: props
                };
                element = (0, $cfkGk.ObjectUtils).getJSXElement(props.template, defaultOptions);
            }
            return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, {
                key: pageLink
            }, element);
        });
    }
    var pagesProps = mergeProps({
        className: cx("pages")
    }, ptm("pages", {
        hostName: props.hostName
    }));
    return /*#__PURE__*/ $81g6h.createElement("span", pagesProps, elements);
});
$a44f623ece12d8fa$var$PageLinks.displayName = "PageLinks";
function $a44f623ece12d8fa$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a44f623ece12d8fa$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a44f623ece12d8fa$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $a44f623ece12d8fa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a44f623ece12d8fa$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a44f623ece12d8fa$var$PrevPageLink = /*#__PURE__*/ $81g6h.memo(function(inProps) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $a44f623ece12d8fa$var$PrevPageLinkBase.getProps(inProps, context);
    var ptm = props.ptm, cx = props.cx;
    var getPTOptions = function getPTOptions(key) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                disabled: props.disabled
            }
        });
    };
    var className = (0, $cfkGk.classNames)("p-paginator-prev p-paginator-element p-link", {
        "p-disabled": props.disabled
    });
    var iconClassName = "p-paginator-icon";
    var prevPageIconProps = mergeProps({
        className: cx("prevPageIcon")
    }, getPTOptions("prevPageIcon"));
    var icon = props.prevPageLinkIcon || /*#__PURE__*/ $81g6h.createElement((0, $geU5g.AngleLeftIcon), prevPageIconProps);
    var prevPageLinkIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $a44f623ece12d8fa$var$_objectSpread$1({}, prevPageIconProps), {
        props: props
    });
    var prevPageButtonProps = mergeProps({
        type: "button",
        className: cx("prevPageButton", {
            disabled: props.disabled
        }),
        onClick: props.onClick,
        disabled: props.disabled,
        "aria-label": (0, $8Zwsm.ariaLabel)("previousPageLabel")
    }, getPTOptions("prevPageButton"));
    var element = /*#__PURE__*/ $81g6h.createElement("button", prevPageButtonProps, prevPageLinkIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
    if (props.template) {
        var defaultOptions = {
            onClick: props.onClick,
            className: className,
            iconClassName: iconClassName,
            disabled: props.disabled,
            element: element,
            props: props
        };
        return (0, $cfkGk.ObjectUtils).getJSXElement(props.template, defaultOptions);
    }
    return element;
});
$a44f623ece12d8fa$var$PrevPageLink.displayName = "PrevPageLink";
var $a44f623ece12d8fa$var$RowsPerPageDropdown = /*#__PURE__*/ $81g6h.memo(function(inProps) {
    (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $a44f623ece12d8fa$var$RowsPerPageDropdownBase.getProps(inProps, context);
    var hasOptions = props.options && props.options.length > 0;
    var options = hasOptions ? props.options.map(function(opt) {
        return {
            label: String(opt),
            value: opt
        };
    }) : [];
    var placeholderValue = (0, $8Zwsm.localeOption)("choose");
    var ariaLabelValue = $a44f623ece12d8fa$var$ariaLabel("jumpToPageDropdownLabel");
    var element = hasOptions ? /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement((0, $eT9rN.Dropdown), {
        value: props.value,
        options: options,
        onChange: props.onChange,
        appendTo: props.appendTo,
        disabled: props.disabled,
        placeholder: placeholderValue,
        "aria-label": ariaLabelValue,
        pt: props.ptm("RPPDropdown"),
        unstyled: props.unstyled,
        __parentMetadata: {
            parent: props.metaData
        }
    })) : null;
    if (props.template) {
        var defaultOptions = {
            value: props.value,
            options: options,
            onChange: props.onChange,
            appendTo: props.appendTo,
            currentPage: props.page,
            totalPages: props.pageCount,
            totalRecords: props.totalRecords,
            disabled: props.disabled,
            ariaLabel: ariaLabelValue,
            element: element,
            props: props
        };
        return (0, $cfkGk.ObjectUtils).getJSXElement(props.template, defaultOptions);
    }
    return element;
});
$a44f623ece12d8fa$var$RowsPerPageDropdown.displayName = "RowsPerPageDropdown";
function $a44f623ece12d8fa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a44f623ece12d8fa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a44f623ece12d8fa$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a44f623ece12d8fa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a44f623ece12d8fa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a44f623ece12d8fa$export$98986e0ddad1af5a = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $a44f623ece12d8fa$var$PaginatorBase.getProps(inProps, context);
    var metaData = $a44f623ece12d8fa$var$_objectSpread({
        props: props
    }, props.__parentMetadata);
    var _PaginatorBase$setMet = $a44f623ece12d8fa$var$PaginatorBase.setMetaData(metaData), ptm = _PaginatorBase$setMet.ptm, cx = _PaginatorBase$setMet.cx, isUnstyled = _PaginatorBase$setMet.isUnstyled;
    (0, $4gQLd.useHandleStyle)($a44f623ece12d8fa$var$PaginatorBase.css.styles, isUnstyled, {
        name: "paginator"
    });
    var elementRef = $81g6h.useRef(null);
    var page = Math.floor(props.first / props.rows);
    var totalPages = Math.ceil(props.totalRecords / props.rows);
    var isFirstPage = page === 0;
    var isLastPage = page === totalPages - 1;
    var isEmpty = totalPages === 0;
    var calculatePageLinkBoundaries = function calculatePageLinkBoundaries() {
        var numberOfPages = totalPages;
        var visiblePages = Math.min(props.pageLinkSize, numberOfPages);
        //calculate range, keep current in middle if necessary
        var start = Math.max(0, Math.ceil(page - visiblePages / 2));
        var end = Math.min(numberOfPages - 1, start + visiblePages - 1);
        //check when approaching to last page
        var delta = props.pageLinkSize - (end - start + 1);
        start = Math.max(0, start - delta);
        return [
            start,
            end
        ];
    };
    var updatePageLinks = function updatePageLinks() {
        var pageLinks = [];
        var boundaries = calculatePageLinkBoundaries();
        var start = boundaries[0];
        var end = boundaries[1];
        for(var i = start; i <= end; i++)pageLinks.push(i + 1);
        return pageLinks;
    };
    var changePage = function changePage(first, rows) {
        var pc = totalPages;
        var p = Math.floor(first / rows);
        if (p >= 0 && p < pc) {
            var newPageState = {
                first: first,
                rows: rows,
                page: p,
                totalPages: pc
            };
            if (props.onPageChange) props.onPageChange(newPageState);
        }
    };
    var changePageToFirst = function changePageToFirst(event) {
        changePage(0, props.rows);
        event.preventDefault();
    };
    var changePageToPrev = function changePageToPrev(event) {
        changePage(props.first - props.rows, props.rows);
        event.preventDefault();
    };
    var onPageLinkClick = function onPageLinkClick(event) {
        changePage((event.value - 1) * props.rows, props.rows);
    };
    var changePageToNext = function changePageToNext(event) {
        changePage(props.first + props.rows, props.rows);
        event.preventDefault();
    };
    var changePageToLast = function changePageToLast(event) {
        changePage((totalPages - 1) * props.rows, props.rows);
        event.preventDefault();
    };
    var onRowsChange = function onRowsChange(event) {
        var rows = event.value;
        changePage(0, rows);
    };
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    (0, $l2NC0.useUpdateEffect)(function() {
        if (page > 0 && props.first >= props.totalRecords) changePage((totalPages - 1) * props.rows, props.rows);
    }, [
        props.totalRecords
    ]);
    var createElement = function createElement(key, template) {
        var element;
        switch(key){
            case "FirstPageLink":
                element = /*#__PURE__*/ $81g6h.createElement($a44f623ece12d8fa$var$FirstPageLink, {
                    hostName: "Paginator",
                    key: key,
                    page: page,
                    totalPages: totalPages,
                    totalRecords: props.totalRecords,
                    rows: props.rows,
                    onClick: changePageToFirst,
                    disabled: isFirstPage || isEmpty,
                    template: template,
                    firstPageLinkIcon: props.firstPageLinkIcon,
                    ptm: ptm,
                    cx: cx
                });
                break;
            case "PrevPageLink":
                element = /*#__PURE__*/ $81g6h.createElement($a44f623ece12d8fa$var$PrevPageLink, {
                    hostName: "Paginator",
                    key: key,
                    page: page,
                    totalPages: totalPages,
                    totalRecords: props.totalRecords,
                    rows: props.rows,
                    onClick: changePageToPrev,
                    disabled: isFirstPage || isEmpty,
                    template: template,
                    prevPageLinkIcon: props.prevPageLinkIcon,
                    ptm: ptm,
                    cx: cx
                });
                break;
            case "NextPageLink":
                element = /*#__PURE__*/ $81g6h.createElement($a44f623ece12d8fa$var$NextPageLink, {
                    hostName: "Paginator",
                    key: key,
                    page: page,
                    totalPages: totalPages,
                    totalRecords: props.totalRecords,
                    rows: props.rows,
                    onClick: changePageToNext,
                    disabled: isLastPage || isEmpty,
                    template: template,
                    nextPageLinkIcon: props.nextPageLinkIcon,
                    ptm: ptm,
                    cx: cx
                });
                break;
            case "LastPageLink":
                element = /*#__PURE__*/ $81g6h.createElement($a44f623ece12d8fa$var$LastPageLink, {
                    hostName: "Paginator",
                    key: key,
                    page: page,
                    totalPages: totalPages,
                    totalRecords: props.totalRecords,
                    rows: props.rows,
                    onClick: changePageToLast,
                    disabled: isLastPage || isEmpty,
                    template: template,
                    lastPageLinkIcon: props.lastPageLinkIcon,
                    ptm: ptm,
                    cx: cx
                });
                break;
            case "PageLinks":
                element = /*#__PURE__*/ $81g6h.createElement($a44f623ece12d8fa$var$PageLinks, {
                    hostName: "Paginator",
                    key: key,
                    page: page,
                    totalPages: totalPages,
                    totalRecords: props.totalRecords,
                    rows: props.rows,
                    value: updatePageLinks(),
                    onClick: onPageLinkClick,
                    template: template,
                    ptm: ptm,
                    cx: cx
                });
                break;
            case "RowsPerPageDropdown":
                element = /*#__PURE__*/ $81g6h.createElement($a44f623ece12d8fa$var$RowsPerPageDropdown, {
                    hostName: "Paginator",
                    key: key,
                    value: props.rows,
                    page: page,
                    totalPages: totalPages,
                    totalRecords: props.totalRecords,
                    options: props.rowsPerPageOptions,
                    onChange: onRowsChange,
                    appendTo: props.dropdownAppendTo,
                    template: template,
                    disabled: isEmpty,
                    unstyled: props.unstyled,
                    ptm: ptm,
                    cx: cx,
                    metaData: metaData
                });
                break;
            case "CurrentPageReport":
                element = /*#__PURE__*/ $81g6h.createElement($a44f623ece12d8fa$var$CurrentPageReport, {
                    hostName: "Paginator",
                    reportTemplate: props.currentPageReportTemplate,
                    key: key,
                    page: page,
                    totalPages: totalPages,
                    totalRecords: props.totalRecords,
                    rows: props.rows,
                    first: props.first,
                    template: template,
                    ptm: ptm
                });
                break;
            case "JumpToPageInput":
                element = /*#__PURE__*/ $81g6h.createElement($a44f623ece12d8fa$var$JumpToPageInput, {
                    hostName: "Paginator",
                    key: key,
                    rows: props.rows,
                    page: page,
                    totalPages: totalPages,
                    onChange: changePage,
                    disabled: isEmpty,
                    template: template,
                    ptm: ptm,
                    unstyled: props.unstyled,
                    metaData: metaData
                });
                break;
            default:
                element = null;
                break;
        }
        return element;
    };
    var createElements = function createElements() {
        var template = props.template;
        if (template) {
            if ($a44f623ece12d8fa$var$_typeof(template) === "object") return template.layout ? template.layout.split(" ").map(function(value) {
                var key = value.trim();
                return createElement(key, template[key]);
            }) : Object.entries(template).map(function(_ref) {
                var _ref2 = $a44f623ece12d8fa$var$_slicedToArray(_ref, 2), key = _ref2[0], _template = _ref2[1];
                return createElement(key, _template);
            });
            return template.split(" ").map(function(value) {
                return createElement(value.trim());
            });
        }
        return null;
    };
    if (!props.alwaysShow && totalPages <= 1) return null;
    var leftContent = (0, $cfkGk.ObjectUtils).getJSXElement(props.leftContent, props);
    var rightContent = (0, $cfkGk.ObjectUtils).getJSXElement(props.rightContent, props);
    var elements = createElements();
    var leftProps = mergeProps({
        className: cx("left")
    }, ptm("left"));
    var leftElement = leftContent && /*#__PURE__*/ $81g6h.createElement("div", leftProps, leftContent);
    var endProps = mergeProps({
        className: cx("end")
    }, ptm("end"));
    var rightElement = rightContent && /*#__PURE__*/ $81g6h.createElement("div", endProps, rightContent);
    var rootProps = mergeProps({
        ref: elementRef,
        className: (0, $cfkGk.classNames)(props.className, cx("root")),
        style: props.style
    }, $a44f623ece12d8fa$var$PaginatorBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $81g6h.createElement("div", rootProps, leftElement, elements, rightElement);
}));
$a44f623ece12d8fa$export$98986e0ddad1af5a.displayName = "Paginator";

});
parcelRegister("5z9b3", function(module, exports) {

$parcel$export(module.exports, "AngleDoubleLeftIcon", () => $40d7570ce5a0997e$export$2f7bdd6eb480d530);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $40d7570ce5a0997e$var$_extends() {
    $40d7570ce5a0997e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $40d7570ce5a0997e$var$_extends.apply(this, arguments);
}
var $40d7570ce5a0997e$export$2f7bdd6eb480d530 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $40d7570ce5a0997e$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.71602 11.164C5.80782 11.2021 5.9063 11.2215 6.00569 11.221C6.20216 11.2301 6.39427 11.1612 6.54025 11.0294C6.68191 10.8875 6.76148 10.6953 6.76148 10.4948C6.76148 10.2943 6.68191 10.1021 6.54025 9.96024L3.51441 6.9344L6.54025 3.90855C6.624 3.76126 6.65587 3.59011 6.63076 3.42254C6.60564 3.25498 6.525 3.10069 6.40175 2.98442C6.2785 2.86815 6.11978 2.79662 5.95104 2.7813C5.78229 2.76598 5.61329 2.80776 5.47112 2.89994L1.97123 6.39983C1.82957 6.54167 1.75 6.73393 1.75 6.9344C1.75 7.13486 1.82957 7.32712 1.97123 7.46896L5.47112 10.9991C5.54096 11.0698 5.62422 11.1259 5.71602 11.164ZM11.0488 10.9689C11.1775 11.1156 11.3585 11.2061 11.5531 11.221C11.7477 11.2061 11.9288 11.1156 12.0574 10.9689C12.1815 10.8302 12.25 10.6506 12.25 10.4645C12.25 10.2785 12.1815 10.0989 12.0574 9.96024L9.03158 6.93439L12.0574 3.90855C12.1248 3.76739 12.1468 3.60881 12.1204 3.45463C12.0939 3.30045 12.0203 3.15826 11.9097 3.04765C11.7991 2.93703 11.6569 2.86343 11.5027 2.83698C11.3486 2.81053 11.19 2.83252 11.0488 2.89994L7.51865 6.36957C7.37699 6.51141 7.29742 6.70367 7.29742 6.90414C7.29742 7.1046 7.37699 7.29686 7.51865 7.4387L11.0488 10.9689Z",
        fill: "currentColor"
    }));
}));
$40d7570ce5a0997e$export$2f7bdd6eb480d530.displayName = "AngleDoubleLeftIcon";

});

parcelRegister("xyzRL", function(module, exports) {

$parcel$export(module.exports, "InputNumber", () => $064de78d0e99ff5a$export$cf9581d419a141cf);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $5sgNc = parcelRequire("5sgNc");

var $et0wC = parcelRequire("et0wC");

var $6ccvc = parcelRequire("6ccvc");

var $9rbaG = parcelRequire("9rbaG");

var $7hMfd = parcelRequire("7hMfd");

var $cfkGk = parcelRequire("cfkGk");
"use client";
function $064de78d0e99ff5a$var$_extends() {
    $064de78d0e99ff5a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $064de78d0e99ff5a$var$_extends.apply(this, arguments);
}
function $064de78d0e99ff5a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $064de78d0e99ff5a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $064de78d0e99ff5a$var$_arrayLikeToArray(arr);
}
function $064de78d0e99ff5a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $064de78d0e99ff5a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $064de78d0e99ff5a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $064de78d0e99ff5a$var$_arrayLikeToArray(o, minLen);
}
function $064de78d0e99ff5a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $064de78d0e99ff5a$var$_toConsumableArray(arr) {
    return $064de78d0e99ff5a$var$_arrayWithoutHoles(arr) || $064de78d0e99ff5a$var$_iterableToArray(arr) || $064de78d0e99ff5a$var$_unsupportedIterableToArray(arr) || $064de78d0e99ff5a$var$_nonIterableSpread();
}
function $064de78d0e99ff5a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $064de78d0e99ff5a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $064de78d0e99ff5a$var$_typeof(o);
}
function $064de78d0e99ff5a$var$_toPrimitive(input, hint) {
    if ($064de78d0e99ff5a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($064de78d0e99ff5a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $064de78d0e99ff5a$var$_toPropertyKey(arg) {
    var key = $064de78d0e99ff5a$var$_toPrimitive(arg, "string");
    return $064de78d0e99ff5a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $064de78d0e99ff5a$var$_defineProperty(obj, key, value) {
    key = $064de78d0e99ff5a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $064de78d0e99ff5a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $064de78d0e99ff5a$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $064de78d0e99ff5a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $064de78d0e99ff5a$var$_slicedToArray(arr, i) {
    return $064de78d0e99ff5a$var$_arrayWithHoles(arr) || $064de78d0e99ff5a$var$_iterableToArrayLimit(arr, i) || $064de78d0e99ff5a$var$_unsupportedIterableToArray(arr, i) || $064de78d0e99ff5a$var$_nonIterableRest();
}
var $064de78d0e99ff5a$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, focusedState = _ref.focusedState, stacked = _ref.stacked, horizontal = _ref.horizontal, vertical = _ref.vertical;
        return (0, $cfkGk.classNames)("p-inputnumber p-component p-inputwrapper", {
            "p-inputwrapper-filled": props.value != null && props.value.toString().length > 0,
            "p-inputwrapper-focus": focusedState,
            "p-inputnumber-buttons-stacked": stacked,
            "p-inputnumber-buttons-horizontal": horizontal,
            "p-inputnumber-buttons-vertical": vertical,
            "p-invalid": props.invalid
        });
    },
    input: function input(_ref2) {
        var props = _ref2.props, context = _ref2.context;
        return (0, $cfkGk.classNames)("p-inputnumber-input", {
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled"
        });
    },
    buttonGroup: "p-inputnumber-button-group",
    incrementButton: function incrementButton(_ref3) {
        var props = _ref3.props;
        return (0, $cfkGk.classNames)("p-inputnumber-button p-inputnumber-button-up p-button p-button-icon-only p-component", {
            "p-disabled": props.disabled
        });
    },
    incrementIcon: "p-button-icon",
    decrementButton: function decrementButton(_ref4) {
        var props = _ref4.props;
        return (0, $cfkGk.classNames)("p-inputnumber-button p-inputnumber-button-down p-button p-button-icon-only p-component", {
            "p-disabled": props.disabled
        });
    },
    decrementIcon: "p-button-icon"
};
var $064de78d0e99ff5a$var$styles = "\n@layer primereact {\n    .p-inputnumber {\n        display: inline-flex;\n    }\n    \n    .p-inputnumber-button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex: 0 0 auto;\n    }\n    \n    .p-inputnumber-buttons-stacked .p-button.p-inputnumber-button .p-button-label,\n    .p-inputnumber-buttons-horizontal .p-button.p-inputnumber-button .p-button-label {\n        display: none;\n    }\n    \n    .p-inputnumber-buttons-stacked .p-button.p-inputnumber-button-up {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n        padding: 0;\n    }\n    \n    .p-inputnumber-buttons-stacked .p-inputnumber-input {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n    \n    .p-inputnumber-buttons-stacked .p-button.p-inputnumber-button-down {\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n        border-bottom-left-radius: 0;\n        padding: 0;\n    }\n    \n    .p-inputnumber-buttons-stacked .p-inputnumber-button-group {\n        display: flex;\n        flex-direction: column;\n    }\n    \n    .p-inputnumber-buttons-stacked .p-inputnumber-button-group .p-button.p-inputnumber-button {\n        flex: 1 1 auto;\n    }\n    \n    .p-inputnumber-buttons-horizontal .p-button.p-inputnumber-button-up {\n        order: 3;\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n    \n    .p-inputnumber-buttons-horizontal .p-inputnumber-input {\n        order: 2;\n        border-radius: 0;\n    }\n    \n    .p-inputnumber-buttons-horizontal .p-button.p-inputnumber-button-down {\n        order: 1;\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n    \n    .p-inputnumber-buttons-vertical {\n        flex-direction: column;\n    }\n    \n    .p-inputnumber-buttons-vertical .p-button.p-inputnumber-button-up {\n        order: 1;\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n        width: 100%;\n    }\n    \n    .p-inputnumber-buttons-vertical .p-inputnumber-input {\n        order: 2;\n        border-radius: 0;\n        text-align: center;\n    }\n    \n    .p-inputnumber-buttons-vertical .p-button.p-inputnumber-button-down {\n        order: 3;\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n        width: 100%;\n    }\n    \n    .p-inputnumber-input {\n        flex: 1 1 auto;\n    }\n    \n    .p-fluid .p-inputnumber {\n        width: 100%;\n    }\n    \n    .p-fluid .p-inputnumber .p-inputnumber-input {\n        width: 1%;\n    }\n    \n    .p-fluid .p-inputnumber-buttons-vertical .p-inputnumber-input {\n        width: 100%;\n    }\n}\n";
var $064de78d0e99ff5a$var$InputNumberBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "InputNumber",
        __parentMetadata: null,
        allowEmpty: true,
        ariaLabelledBy: null,
        autoFocus: false,
        buttonLayout: "stacked",
        className: null,
        currency: undefined,
        currencyDisplay: undefined,
        decrementButtonClassName: null,
        decrementButtonIcon: null,
        disabled: false,
        format: true,
        id: null,
        incrementButtonClassName: null,
        incrementButtonIcon: null,
        inputClassName: null,
        inputId: null,
        inputMode: null,
        inputRef: null,
        inputStyle: null,
        invalid: false,
        variant: null,
        locale: undefined,
        localeMatcher: undefined,
        max: null,
        maxFractionDigits: undefined,
        maxLength: null,
        min: null,
        minFractionDigits: undefined,
        mode: "decimal",
        name: null,
        onBlur: null,
        onChange: null,
        onFocus: null,
        onKeyDown: null,
        onKeyUp: null,
        onValueChange: null,
        pattern: null,
        placeholder: null,
        prefix: null,
        readOnly: false,
        required: false,
        roundingMode: undefined,
        showButtons: false,
        size: null,
        step: 1,
        style: null,
        suffix: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        type: "text",
        useGrouping: true,
        value: null,
        children: undefined
    },
    css: {
        classes: $064de78d0e99ff5a$var$classes,
        styles: $064de78d0e99ff5a$var$styles
    }
});
function $064de78d0e99ff5a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $064de78d0e99ff5a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $064de78d0e99ff5a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $064de78d0e99ff5a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $064de78d0e99ff5a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $064de78d0e99ff5a$export$cf9581d419a141cf = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $064de78d0e99ff5a$var$InputNumberBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState(false), _React$useState2 = $064de78d0e99ff5a$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var metaData = $064de78d0e99ff5a$var$_objectSpread($064de78d0e99ff5a$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        state: {
            focused: focusedState
        }
    });
    var _InputNumberBase$setM = $064de78d0e99ff5a$var$InputNumberBase.setMetaData(metaData), ptm = _InputNumberBase$setM.ptm, cx = _InputNumberBase$setM.cx, isUnstyled = _InputNumberBase$setM.isUnstyled;
    (0, $4gQLd.useHandleStyle)($064de78d0e99ff5a$var$InputNumberBase.css.styles, isUnstyled, {
        name: "inputnumber"
    });
    var elementRef = $81g6h.useRef(null);
    var inputRef = $81g6h.useRef(null);
    var timer = $81g6h.useRef(null);
    var lastValue = $81g6h.useRef(null);
    var numberFormat = $81g6h.useRef(null);
    var groupChar = $81g6h.useRef(null);
    var prefixChar = $81g6h.useRef(null);
    var suffixChar = $81g6h.useRef(null);
    var isSpecialChar = $81g6h.useRef(null);
    var _numeral = $81g6h.useRef(null);
    var _group = $81g6h.useRef(null);
    var _minusSign = $81g6h.useRef(null);
    var _currency = $81g6h.useRef(null);
    var _decimal = $81g6h.useRef(null);
    var _decimalSeparator = $81g6h.useRef(null);
    var _suffix = $81g6h.useRef(null);
    var _prefix = $81g6h.useRef(null);
    var _index = $81g6h.useRef(null);
    var isFocusedByClick = $81g6h.useRef(false);
    var _locale = props.locale || context && context.locale || (0, $8Zwsm.default).locale;
    var stacked = props.showButtons && props.buttonLayout === "stacked";
    var horizontal = props.showButtons && props.buttonLayout === "horizontal";
    var vertical = props.showButtons && props.buttonLayout === "vertical";
    var inputMode = props.inputMode || (props.mode === "decimal" && !props.minFractionDigits ? "numeric" : "decimal");
    var getOptions = function getOptions() {
        var _props$minFractionDig, _props$maxFractionDig;
        return {
            localeMatcher: props.localeMatcher,
            style: props.mode,
            currency: props.currency,
            currencyDisplay: props.currencyDisplay,
            useGrouping: props.useGrouping,
            minimumFractionDigits: (_props$minFractionDig = props.minFractionDigits) !== null && _props$minFractionDig !== void 0 ? _props$minFractionDig : undefined,
            maximumFractionDigits: (_props$maxFractionDig = props.maxFractionDigits) !== null && _props$maxFractionDig !== void 0 ? _props$maxFractionDig : undefined,
            roundingMode: props.roundingMode
        };
    };
    var constructParser = function constructParser() {
        numberFormat.current = new Intl.NumberFormat(_locale, getOptions());
        var numerals = $064de78d0e99ff5a$var$_toConsumableArray(new Intl.NumberFormat(_locale, {
            useGrouping: false
        }).format(9876543210)).reverse();
        var index = new Map(numerals.map(function(d, i) {
            return [
                d,
                i
            ];
        }));
        _numeral.current = new RegExp("[".concat(numerals.join(""), "]"), "g");
        _group.current = getGroupingExpression(); // regular expression /[,]/g, /[.]/g
        _minusSign.current = getMinusSignExpression(); // regular expression /[-]/g
        _currency.current = getCurrencyExpression(); // regular expression for currency (e.g. /[$]/g, /[€]/g, /[]/g and more)
        _decimal.current = getDecimalExpression(); // regular expression /[,]/g, /[.]/g, /[]/g
        _decimalSeparator.current = getDecimalSeparator(); // current decimal separator  '.', ','
        _suffix.current = getSuffixExpression(); // regular expression for suffix (e.g. /℃/g)
        _prefix.current = getPrefixExpression(); // regular expression for prefix (e.g. /\ days/g)
        _index.current = function(d) {
            return index.get(d);
        };
    };
    var escapeRegExp = function escapeRegExp(text) {
        return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    };
    /**
   * get decimal separator in current locale
   */ var getDecimalSeparator = function getDecimalSeparator() {
        return new Intl.NumberFormat(_locale, {
            useGrouping: false
        }).format(1.1).trim().replace(_numeral.current, "");
    };
    var getDecimalExpression = function getDecimalExpression() {
        var formatter = new Intl.NumberFormat(_locale, $064de78d0e99ff5a$var$_objectSpread($064de78d0e99ff5a$var$_objectSpread({}, getOptions()), {}, {
            useGrouping: false
        }));
        return new RegExp("[".concat(formatter.format(1.1).replace(_currency.current, "").trim().replace(_numeral.current, ""), "]"), "g");
    };
    var getGroupingExpression = function getGroupingExpression() {
        var formatter = new Intl.NumberFormat(_locale, {
            useGrouping: true
        });
        groupChar.current = formatter.format(1000000).trim().replace(_numeral.current, "").charAt(0);
        return new RegExp("[".concat(groupChar.current, "]"), "g");
    };
    var getMinusSignExpression = function getMinusSignExpression() {
        var formatter = new Intl.NumberFormat(_locale, {
            useGrouping: false
        });
        return new RegExp("[".concat(formatter.format(-1).trim().replace(_numeral.current, ""), "]"), "g");
    };
    var getCurrencyExpression = function getCurrencyExpression() {
        if (props.currency) {
            var formatter = new Intl.NumberFormat(_locale, {
                style: "currency",
                currency: props.currency,
                currencyDisplay: props.currencyDisplay,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                roundingMode: props.roundingMode
            });
            return new RegExp("[".concat(formatter.format(1).replace(/\s/g, "").replace(_numeral.current, "").replace(_group.current, ""), "]"), "g");
        }
        return new RegExp("[]", "g");
    };
    var getPrefixExpression = function getPrefixExpression() {
        if (props.prefix) prefixChar.current = props.prefix;
        else {
            var formatter = new Intl.NumberFormat(_locale, {
                style: props.mode,
                currency: props.currency,
                currencyDisplay: props.currencyDisplay
            });
            prefixChar.current = formatter.format(1).split("1")[0];
        }
        return new RegExp("".concat(escapeRegExp(prefixChar.current || "")), "g");
    };
    var getSuffixExpression = function getSuffixExpression() {
        if (props.suffix) suffixChar.current = props.suffix;
        else {
            var formatter = new Intl.NumberFormat(_locale, {
                style: props.mode,
                currency: props.currency,
                currencyDisplay: props.currencyDisplay,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                roundingMode: props.roundingMode
            });
            suffixChar.current = formatter.format(1).split("1")[1];
        }
        return new RegExp("".concat(escapeRegExp(suffixChar.current || "")), "g");
    };
    var formatValue = function formatValue(value) {
        if (value != null) {
            if (value === "-") // Minus sign
            return value;
            if (props.format) {
                var formatter = new Intl.NumberFormat(_locale, getOptions());
                var _formattedValue = formatter.format(value);
                if (props.prefix) _formattedValue = props.prefix + _formattedValue;
                if (props.suffix) _formattedValue = _formattedValue + props.suffix;
                return _formattedValue;
            }
            return value.toString();
        }
        return "";
    };
    var parseValue = function parseValue(text) {
        var filteredText = text.replace(_suffix.current, "").replace(_prefix.current, "").trim().replace(/\s/g, "").replace(_currency.current, "").replace(_group.current, "").replace(_minusSign.current, "-").replace(_decimal.current, ".").replace(_numeral.current, _index.current);
        if (filteredText) {
            if (filteredText === "-") // Minus sign
            return filteredText;
            var parsedValue = +filteredText;
            return isNaN(parsedValue) ? null : parsedValue;
        }
        return null;
    };
    var repeat = function repeat(event, interval, dir) {
        var i = interval || 500;
        clearTimer();
        timer.current = setTimeout(function() {
            repeat(event, 40, dir);
        }, i);
        spin(event, dir);
    };
    var spin = function spin(event, dir) {
        if (inputRef.current) {
            var step = props.step * dir;
            var currentValue = parseValue(inputRef.current.value) || 0;
            var newValue = validateValue(currentValue + step);
            if (props.maxLength && props.maxLength < formatValue(newValue).length) return;
            // #3913 onChange should be called before onValueChange
            handleOnChange(event, currentValue, newValue);
            // touch devices trigger the keyboard to display because of setSelectionRange
            !(0, $cfkGk.DomHandler).isTouchDevice() && updateInput(newValue, null, "spin");
            updateModel(event, newValue);
        }
    };
    var onUpButtonMouseDown = function onUpButtonMouseDown(event) {
        if (!props.disabled && !props.readOnly) {
            (0, $cfkGk.DomHandler).focus(inputRef.current, props.autoFocus);
            repeat(event, null, 1);
            event.preventDefault();
        }
    };
    var onUpButtonMouseUp = function onUpButtonMouseUp() {
        if (!props.disabled && !props.readOnly) clearTimer();
    };
    var onUpButtonMouseLeave = function onUpButtonMouseLeave() {
        if (!props.disabled && !props.readOnly) clearTimer();
    };
    var onUpButtonKeyUp = function onUpButtonKeyUp() {
        if (!props.disabled && !props.readOnly) clearTimer();
    };
    var onUpButtonKeyDown = function onUpButtonKeyDown(event) {
        if (!props.disabled && !props.readOnly && (event.keyCode === 32 || event.keyCode === 13)) repeat(event, null, 1);
    };
    var onDownButtonMouseDown = function onDownButtonMouseDown(event) {
        if (!props.disabled && !props.readOnly) {
            (0, $cfkGk.DomHandler).focus(inputRef.current, props.autoFocus);
            repeat(event, null, -1);
            event.preventDefault();
        }
    };
    var onDownButtonMouseUp = function onDownButtonMouseUp() {
        if (!props.disabled && !props.readOnly) clearTimer();
    };
    var onDownButtonMouseLeave = function onDownButtonMouseLeave() {
        if (!props.disabled && !props.readOnly) clearTimer();
    };
    var onDownButtonKeyUp = function onDownButtonKeyUp() {
        if (!props.disabled && !props.readOnly) clearTimer();
    };
    var onDownButtonKeyDown = function onDownButtonKeyDown(event) {
        if (!props.disabled && !props.readOnly && (event.keyCode === 32 || event.keyCode === 13)) repeat(event, null, -1);
    };
    var onInput = function onInput(event) {
        if (props.disabled || props.readOnly) return;
        if (isSpecialChar.current) {
            event.target.value = lastValue.current;
            isSpecialChar.current = false;
        }
        if ((0, $cfkGk.DomHandler).isAndroid()) return;
        // #6324 Chrome is allowing accent-dead characters through...
        var inputType = event.nativeEvent.inputType;
        var data = event.nativeEvent.data;
        if (inputType === "insertText" && /\D/.test(data)) event.target.value = lastValue.current;
    };
    var onInputAndroidKey = function onInputAndroidKey(event) {
        if (!(0, $cfkGk.DomHandler).isAndroid() || props.disabled || props.readOnly) return;
        if (props.onKeyUp) {
            props.onKeyUp(event);
            // do not continue if the user defined event wants to prevent
            if (event.defaultPrevented) return;
        }
        var code = event.which || event.keyCode;
        if (code !== 13) // to submit a form
        event.preventDefault();
        var _char = String.fromCharCode(code);
        var _isDecimalSign = isDecimalSign(_char);
        var _isMinusSign = isMinusSign(_char);
        if (48 <= code && code <= 57 || _isMinusSign || _isDecimalSign) insert(event, _char, {
            isDecimalSign: _isDecimalSign,
            isMinusSign: _isMinusSign
        });
        else updateValue(event, event.target.value, null, "delete-single");
    };
    var onInputKeyDown = function onInputKeyDown(event) {
        if (props.disabled || props.readOnly) return;
        if (event.altKey || event.ctrlKey || event.metaKey) {
            isSpecialChar.current = true;
            return;
        }
        if (props.onKeyDown) {
            props.onKeyDown(event);
            // Do not continue if the user-defined event wants to prevent
            if (event.defaultPrevented) return;
        }
        lastValue.current = event.target.value;
        // Android is handled specially in onInputAndroidKey
        if ((0, $cfkGk.DomHandler).isAndroid()) return;
        var selectionStart = event.target.selectionStart;
        var selectionEnd = event.target.selectionEnd;
        var inputValue = event.target.value;
        var newValueStr = null;
        switch(event.code){
            //up
            case "ArrowUp":
                spin(event, 1);
                event.preventDefault();
                break;
            //down
            case "ArrowDown":
                spin(event, -1);
                event.preventDefault();
                break;
            //left
            case "ArrowLeft":
                if (!isNumeralChar(inputValue.charAt(selectionStart - 1))) event.preventDefault();
                break;
            //right
            case "ArrowRight":
                if (!isNumeralChar(inputValue.charAt(selectionStart))) event.preventDefault();
                break;
            //enter and tab
            case "Tab":
            case "Enter":
            case "NumpadEnter":
                newValueStr = validateValue(parseValue(inputValue));
                inputRef.current.value = formatValue(newValueStr);
                inputRef.current.setAttribute("aria-valuenow", newValueStr);
                updateModel(event, newValueStr);
                break;
            //backspace
            case "Backspace":
                event.preventDefault();
                if (selectionStart === selectionEnd) {
                    var deleteChar = inputValue.charAt(selectionStart - 1);
                    if (isNumeralChar(deleteChar)) {
                        var _getDecimalCharIndexe = getDecimalCharIndexes(inputValue), decimalCharIndex = _getDecimalCharIndexe.decimalCharIndex, decimalCharIndexWithoutPrefix = _getDecimalCharIndexe.decimalCharIndexWithoutPrefix;
                        var decimalLength = getDecimalLength(inputValue);
                        if (_group.current.test(deleteChar)) {
                            _group.current.lastIndex = 0;
                            newValueStr = inputValue.slice(0, selectionStart - 2) + inputValue.slice(selectionStart - 1);
                        } else if (_decimal.current.test(deleteChar)) {
                            _decimal.current.lastIndex = 0;
                            if (decimalLength) inputRef.current.setSelectionRange(selectionStart - 1, selectionStart - 1);
                            else newValueStr = inputValue.slice(0, selectionStart - 1) + inputValue.slice(selectionStart);
                        } else if (decimalCharIndex > 0 && selectionStart > decimalCharIndex) {
                            var insertedText = isDecimalMode() && (props.minFractionDigits || 0) < decimalLength ? "" : "0";
                            newValueStr = inputValue.slice(0, selectionStart - 1) + insertedText + inputValue.slice(selectionStart);
                        } else if (decimalCharIndexWithoutPrefix === 1) {
                            newValueStr = inputValue.slice(0, selectionStart - 1) + "0" + inputValue.slice(selectionStart);
                            newValueStr = parseValue(newValueStr) > 0 ? newValueStr : "";
                        } else newValueStr = inputValue.slice(0, selectionStart - 1) + inputValue.slice(selectionStart);
                    } else if (_currency.current.test(deleteChar)) {
                        var _getCharIndexes = getCharIndexes(inputValue), minusCharIndex = _getCharIndexes.minusCharIndex, currencyCharIndex = _getCharIndexes.currencyCharIndex;
                        if (minusCharIndex === currencyCharIndex - 1) newValueStr = inputValue.slice(0, minusCharIndex) + inputValue.slice(selectionStart);
                    }
                    updateValue(event, newValueStr, null, "delete-single");
                } else {
                    newValueStr = deleteRange(inputValue, selectionStart, selectionEnd);
                    updateValue(event, newValueStr, null, "delete-range");
                }
                break;
            // del
            case "Delete":
                event.preventDefault();
                if (selectionStart === selectionEnd) {
                    var _deleteChar = inputValue.charAt(selectionStart);
                    var _getDecimalCharIndexe2 = getDecimalCharIndexes(inputValue), _decimalCharIndex = _getDecimalCharIndexe2.decimalCharIndex, _decimalCharIndexWithoutPrefix = _getDecimalCharIndexe2.decimalCharIndexWithoutPrefix;
                    if (isNumeralChar(_deleteChar)) {
                        var _decimalLength = getDecimalLength(inputValue);
                        if (_group.current.test(_deleteChar)) {
                            _group.current.lastIndex = 0;
                            newValueStr = inputValue.slice(0, selectionStart) + inputValue.slice(selectionStart + 2);
                        } else if (_decimal.current.test(_deleteChar)) {
                            _decimal.current.lastIndex = 0;
                            if (_decimalLength) inputRef.current.setSelectionRange(selectionStart + 1, selectionStart + 1);
                            else newValueStr = inputValue.slice(0, selectionStart) + inputValue.slice(selectionStart + 1);
                        } else if (_decimalCharIndex > 0 && selectionStart > _decimalCharIndex) {
                            var _insertedText = isDecimalMode() && (props.minFractionDigits || 0) < _decimalLength ? "" : "0";
                            newValueStr = inputValue.slice(0, selectionStart) + _insertedText + inputValue.slice(selectionStart + 1);
                        } else if (_decimalCharIndexWithoutPrefix === 1) {
                            newValueStr = inputValue.slice(0, selectionStart) + "0" + inputValue.slice(selectionStart + 1);
                            newValueStr = parseValue(newValueStr) > 0 ? newValueStr : "";
                        } else newValueStr = inputValue.slice(0, selectionStart) + inputValue.slice(selectionStart + 1);
                    }
                    updateValue(event, newValueStr, null, "delete-back-single");
                } else {
                    newValueStr = deleteRange(inputValue, selectionStart, selectionEnd);
                    updateValue(event, newValueStr, null, "delete-range");
                }
                break;
            case "End":
                event.preventDefault();
                if (!(0, $cfkGk.ObjectUtils).isEmpty(props.max)) updateModel(event, props.max);
                break;
            case "Home":
                event.preventDefault();
                if (!(0, $cfkGk.ObjectUtils).isEmpty(props.min)) updateModel(event, props.min);
                break;
            default:
                event.preventDefault();
                var _char2 = event.key;
                if (_char2) {
                    var _isDecimalSign = isDecimalSign(_char2);
                    var _isMinusSign = isMinusSign(_char2);
                    if (Number(_char2) >= 0 && Number(_char2) <= 9 || _isMinusSign || _isDecimalSign) insert(event, _char2, {
                        isDecimalSign: _isDecimalSign,
                        isMinusSign: _isMinusSign
                    });
                }
                break;
        }
    };
    var onPaste = function onPaste(event) {
        event.preventDefault();
        if (props.disabled || props.readOnly) return;
        var data = (event.clipboardData || window.clipboardData).getData("Text");
        if (data) {
            var filteredData = parseValue(data);
            if (filteredData != null) insert(event, filteredData.toString());
        }
    };
    var allowMinusSign = function allowMinusSign() {
        return (0, $cfkGk.ObjectUtils).isEmpty(props.min) || props.min < 0;
    };
    var isMinusSign = function isMinusSign(_char3) {
        if (_minusSign.current.test(_char3) || _char3 === "-") {
            _minusSign.current.lastIndex = 0;
            return true;
        }
        return false;
    };
    var replaceDecimalSeparator = function replaceDecimalSeparator(val) {
        if (isFloat(val)) return val.toString().replace(/\.(?=[^.]*$)/, _decimalSeparator.current);
        return val;
    };
    var isDecimalSign = function isDecimalSign(_char4) {
        if (_decimal.current.test(_char4) || isFloat(_char4)) {
            _decimal.current.lastIndex = 0;
            return true;
        }
        return false;
    };
    var isDecimalMode = function isDecimalMode() {
        return props.mode === "decimal";
    };
    var isFloat = function isFloat(val) {
        var formatter = new Intl.NumberFormat(_locale, getOptions());
        var parseVal = parseValue(formatter.format(val));
        if (parseVal === null) return false;
        return parseVal % 1 !== 0;
    };
    var getDecimalCharIndexes = function getDecimalCharIndexes(val) {
        var decimalCharIndex = val.search(_decimal.current);
        _decimal.current.lastIndex = 0;
        var filteredVal = val.replace(_prefix.current, "").trim().replace(/\s/g, "").replace(_currency.current, "");
        var decimalCharIndexWithoutPrefix = filteredVal.search(_decimal.current);
        _decimal.current.lastIndex = 0;
        return {
            decimalCharIndex: decimalCharIndex,
            decimalCharIndexWithoutPrefix: decimalCharIndexWithoutPrefix
        };
    };
    var getCharIndexes = function getCharIndexes(val) {
        var decimalCharIndex = val.search(_decimal.current);
        _decimal.current.lastIndex = 0;
        var minusCharIndex = val.search(_minusSign.current);
        _minusSign.current.lastIndex = 0;
        var suffixCharIndex = val.search(_suffix.current);
        _suffix.current.lastIndex = 0;
        var currencyCharIndex = val.search(_currency.current);
        if (currencyCharIndex === 0 && prefixChar.current && prefixChar.current.length > 1) currencyCharIndex = prefixChar.current.trim().length;
        _currency.current.lastIndex = 0;
        return {
            decimalCharIndex: decimalCharIndex,
            minusCharIndex: minusCharIndex,
            suffixCharIndex: suffixCharIndex,
            currencyCharIndex: currencyCharIndex
        };
    };
    var insert = function insert(event, text) {
        var sign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            isDecimalSign: false,
            isMinusSign: false
        };
        var minusCharIndexOnText = text.search(_minusSign.current);
        _minusSign.current.lastIndex = 0;
        if (!allowMinusSign() && minusCharIndexOnText !== -1) return;
        var selectionStart = inputRef.current.selectionStart;
        var selectionEnd = inputRef.current.selectionEnd;
        var inputValue = inputRef.current.value.trim();
        var _getCharIndexes2 = getCharIndexes(inputValue), decimalCharIndex = _getCharIndexes2.decimalCharIndex, minusCharIndex = _getCharIndexes2.minusCharIndex, suffixCharIndex = _getCharIndexes2.suffixCharIndex, currencyCharIndex = _getCharIndexes2.currencyCharIndex;
        var newValueStr;
        if (sign.isMinusSign) {
            var isNewMinusSign = minusCharIndex === -1;
            // #6522 - Selected negative value can't be overwritten with a minus ('-') symbol
            if (selectionStart === 0 || selectionStart === currencyCharIndex + 1) {
                newValueStr = inputValue;
                if (isNewMinusSign || selectionEnd !== 0) newValueStr = insertText(inputValue, text, 0, selectionEnd);
                updateValue(event, newValueStr, text, "insert");
            }
        } else if (sign.isDecimalSign) {
            if (decimalCharIndex > 0 && selectionStart === decimalCharIndex) updateValue(event, inputValue, text, "insert");
            else if (decimalCharIndex > selectionStart && decimalCharIndex < selectionEnd) {
                newValueStr = insertText(inputValue, text, selectionStart, selectionEnd);
                updateValue(event, newValueStr, text, "insert");
            } else if (decimalCharIndex === -1 && props.maxFractionDigits) {
                newValueStr = insertText(inputValue, text, selectionStart, selectionEnd);
                updateValue(event, newValueStr, text, "insert");
            }
        } else {
            var maxFractionDigits = numberFormat.current.resolvedOptions().maximumFractionDigits;
            var operation = selectionStart !== selectionEnd ? "range-insert" : "insert";
            if (decimalCharIndex > 0 && selectionStart > decimalCharIndex) {
                if (selectionStart + text.length - (decimalCharIndex + 1) <= maxFractionDigits) {
                    var charIndex = currencyCharIndex >= selectionStart ? currencyCharIndex - 1 : suffixCharIndex >= selectionStart ? suffixCharIndex : inputValue.length;
                    newValueStr = inputValue.slice(0, selectionStart) + text + inputValue.slice(selectionStart + text.length, charIndex) + inputValue.slice(charIndex);
                    updateValue(event, newValueStr, text, operation);
                }
            } else {
                newValueStr = insertText(inputValue, text, selectionStart, selectionEnd);
                updateValue(event, newValueStr, text, operation);
            }
        }
    };
    var replaceSuffix = function replaceSuffix(value) {
        return value ? value.replace(_suffix.current, "").trim().replace(/\s/g, "").replace(_currency.current, "") : value;
    };
    var insertText = function insertText(value, text, start, end) {
        var textSplit = text === "." ? text : text.split(".");
        if (textSplit.length === 2) {
            var decimalCharIndex = value.slice(start, end).search(_decimal.current);
            _decimal.current.lastIndex = 0;
            return decimalCharIndex > 0 ? value.slice(0, start) + formatValue(text) + replaceSuffix(value).slice(end) : value || formatValue(text);
        } else if (end - start === value.length) return formatValue(text);
        else if (start === 0) {
            var suffix = (0, $cfkGk.ObjectUtils).isLetter(value[end]) ? end - 1 : end;
            return text + value.slice(suffix);
        } else if (end === value.length) return value.slice(0, start) + text;
        var selectionValue = value.slice(start, end);
        // Fix: if the suffix starts with a space, the input will be cleared after pasting
        var space = /\s$/.test(selectionValue) ? " " : "";
        return value.slice(0, start) + text + space + value.slice(end);
    };
    var deleteRange = function deleteRange(value, start, end) {
        var newValueStr;
        if (end - start === value.length) newValueStr = "";
        else if (start === 0) newValueStr = value.slice(end);
        else if (end === value.length) newValueStr = value.slice(0, start);
        else newValueStr = value.slice(0, start) + value.slice(end);
        return newValueStr;
    };
    var initCursor = function initCursor() {
        var selectionStart = inputRef.current.selectionStart;
        var inputValue = inputRef.current.value;
        var valueLength = inputValue.length;
        var index = null;
        // remove prefix
        var prefixLength = (prefixChar.current || "").length;
        inputValue = inputValue.replace(_prefix.current, "");
        selectionStart = selectionStart - prefixLength;
        var _char5 = inputValue.charAt(selectionStart);
        if (isNumeralChar(_char5)) return selectionStart + prefixLength;
        //left
        var i = selectionStart - 1;
        while(i >= 0){
            _char5 = inputValue.charAt(i);
            if (isNumeralChar(_char5)) {
                index = i + prefixLength;
                break;
            } else i--;
        }
        if (index !== null) inputRef.current.setSelectionRange(index + 1, index + 1);
        else {
            i = selectionStart;
            while(i < valueLength){
                _char5 = inputValue.charAt(i);
                if (isNumeralChar(_char5)) {
                    index = i + prefixLength;
                    break;
                } else i++;
            }
            if (index !== null) inputRef.current.setSelectionRange(index, index);
        }
        return index || 0;
    };
    var onInputPointerDown = function onInputPointerDown() {
        isFocusedByClick.current = true;
    };
    var onInputClick = function onInputClick() {
        initCursor();
    };
    var isNumeralChar = function isNumeralChar(_char6) {
        if (_char6.length === 1 && (_numeral.current.test(_char6) || _decimal.current.test(_char6) || _group.current.test(_char6) || _minusSign.current.test(_char6))) {
            resetRegex();
            return true;
        }
        return false;
    };
    var resetRegex = function resetRegex() {
        _numeral.current.lastIndex = 0;
        _decimal.current.lastIndex = 0;
        _group.current.lastIndex = 0;
        _minusSign.current.lastIndex = 0;
    };
    var updateValue = function updateValue(event, valueStr, insertedValueStr, operation) {
        var currentValue = inputRef.current.value;
        var newValue = null;
        if (valueStr != null) {
            newValue = evaluateEmpty(parseValue(valueStr));
            updateInput(newValue, insertedValueStr, operation, valueStr);
            handleOnChange(event, currentValue, newValue);
        }
    };
    var evaluateEmpty = function evaluateEmpty(newValue) {
        return !newValue && !props.allowEmpty ? props.min || 0 : newValue;
    };
    var handleOnChange = function handleOnChange(event, currentValue, newValue) {
        if (props.onChange && isValueChanged(currentValue, newValue)) props.onChange({
            originalEvent: event,
            value: newValue
        });
    };
    var isValueChanged = function isValueChanged(currentValue, newValue) {
        if (newValue === null && currentValue !== null) return true;
        if (newValue != null) {
            var parsedCurrentValue = typeof currentValue === "string" ? parseValue(currentValue) : currentValue;
            return newValue !== parsedCurrentValue;
        }
        return false;
    };
    var validateValue = function validateValue(value) {
        if (value === "-") return null;
        return validateValueByLimit(value);
    };
    var validateValueByLimit = function validateValueByLimit(value) {
        if ((0, $cfkGk.ObjectUtils).isEmpty(value)) return null;
        if (props.min !== null && value < props.min) return props.min;
        if (props.max !== null && value > props.max) return props.max;
        return value;
    };
    var updateInput = function updateInput(value, insertedValueStr, operation, valueStr) {
        insertedValueStr = insertedValueStr || "";
        var inputEl = inputRef.current;
        var inputValue = inputEl.value;
        var newValue = formatValue(value);
        var currentLength = inputValue.length;
        if (newValue !== valueStr) newValue = concatValues(newValue, valueStr);
        if (currentLength === 0) {
            inputEl.value = newValue;
            inputEl.setSelectionRange(0, 0);
            var index = initCursor();
            var selectionEnd = index + insertedValueStr.length;
            inputEl.setSelectionRange(selectionEnd, selectionEnd);
        } else {
            var selectionStart = inputEl.selectionStart;
            var _selectionEnd = inputEl.selectionEnd;
            if (props.maxLength && props.maxLength < newValue.length) return;
            inputEl.value = newValue;
            var newLength = newValue.length;
            if (operation === "range-insert") {
                var startValue = parseValue((inputValue || "").slice(0, selectionStart));
                var startValueStr = startValue !== null ? startValue.toString() : "";
                var startExpr = startValueStr.split("").join("(".concat(groupChar.current, ")?"));
                var sRegex = new RegExp(startExpr, "g");
                sRegex.test(newValue);
                var tExpr = insertedValueStr.split("").join("(".concat(groupChar.current, ")?"));
                var tRegex = new RegExp(tExpr, "g");
                tRegex.test(newValue.slice(sRegex.lastIndex));
                _selectionEnd = sRegex.lastIndex + tRegex.lastIndex;
                inputEl.setSelectionRange(_selectionEnd, _selectionEnd);
            } else if (newLength === currentLength) {
                if (operation === "insert" || operation === "delete-back-single") {
                    var newSelectionEnd = _selectionEnd;
                    if (insertedValueStr === "0") newSelectionEnd = _selectionEnd + 1;
                    else newSelectionEnd = newSelectionEnd + Number(isDecimalSign(value) || isDecimalSign(insertedValueStr));
                    inputEl.setSelectionRange(newSelectionEnd, newSelectionEnd);
                } else if (operation === "delete-single") inputEl.setSelectionRange(_selectionEnd - 1, _selectionEnd - 1);
                else if (operation === "delete-range" || operation === "spin") inputEl.setSelectionRange(_selectionEnd, _selectionEnd);
            } else if (operation === "delete-back-single") {
                var prevChar = inputValue.charAt(_selectionEnd - 1);
                var nextChar = inputValue.charAt(_selectionEnd);
                var diff = currentLength - newLength;
                var isGroupChar = _group.current.test(nextChar);
                if (isGroupChar && diff === 1) _selectionEnd = _selectionEnd + 1;
                else if (!isGroupChar && isNumeralChar(prevChar)) _selectionEnd = _selectionEnd + (-1 * diff + 1);
                _group.current.lastIndex = 0;
                inputEl.setSelectionRange(_selectionEnd, _selectionEnd);
            } else if (inputValue === "-" && operation === "insert") {
                inputEl.setSelectionRange(0, 0);
                var _index2 = initCursor();
                var _selectionEnd2 = _index2 + insertedValueStr.length + 1;
                inputEl.setSelectionRange(_selectionEnd2, _selectionEnd2);
            } else {
                _selectionEnd = _selectionEnd + (newLength - currentLength);
                inputEl.setSelectionRange(_selectionEnd, _selectionEnd);
            }
        }
        inputEl.setAttribute("aria-valuenow", value);
    };
    var updateInputValue = function updateInputValue(newValue) {
        newValue = evaluateEmpty(newValue);
        var inputEl = inputRef.current;
        var value = inputEl.value;
        var _formattedValue = formattedValue(newValue);
        if (value !== _formattedValue) {
            inputEl.value = _formattedValue;
            inputEl.setAttribute("aria-valuenow", newValue);
        }
    };
    var formattedValue = function formattedValue(val) {
        return formatValue(evaluateEmpty(val));
    };
    var concatValues = function concatValues(val1, val2) {
        if (val1 && val2) {
            var decimalCharIndex = val2.search(_decimal.current);
            _decimal.current.lastIndex = 0;
            var newVal1 = replaceDecimalSeparator(val1).split(_decimal.current)[0].replace(_suffix.current, "").trim();
            return decimalCharIndex !== -1 ? newVal1 + val2.slice(decimalCharIndex) : val1;
        }
        return val1;
    };
    var getDecimalLength = function getDecimalLength(value) {
        if (value) {
            var valueSplit = value.split(_decimal.current);
            if (valueSplit.length === 2) return replaceSuffix(valueSplit[1]).length;
        }
        return 0;
    };
    var updateModel = function updateModel(event, value) {
        if (props.onValueChange) props.onValueChange({
            originalEvent: event,
            value: value,
            stopPropagation: function stopPropagation() {
                event === null || event === void 0 || event.stopPropagation();
            },
            preventDefault: function preventDefault() {
                event === null || event === void 0 || event.preventDefault();
            },
            target: {
                name: props.name,
                id: props.id,
                value: value
            }
        });
    };
    var onInputFocus = function onInputFocus(event) {
        setFocusedState(true);
        props.onFocus && props.onFocus(event);
        if ((props.suffix || props.currency || props.prefix) && inputRef.current && !isFocusedByClick.current) {
            // GitHub #1866,#5537
            var inputValue = inputRef.current.value;
            var prefixLength = (prefixChar.current || "").length;
            var suffixLength = (suffixChar.current || "").length;
            var end = inputValue.length === 0 ? 0 : inputValue.length - suffixLength;
            inputRef.current.setSelectionRange(prefixLength, end);
        }
    };
    var onInputBlur = function onInputBlur(event) {
        setFocusedState(false);
        isFocusedByClick.current = false;
        if (inputRef.current) {
            var currentValue = inputRef.current.value;
            if (isValueChanged(currentValue, props.value)) {
                var newValue = validateValue(parseValue(currentValue));
                updateInputValue(newValue);
                updateModel(event, newValue);
            }
        }
        props.onBlur && props.onBlur(event);
    };
    var clearTimer = function clearTimer() {
        if (timer.current) clearInterval(timer.current);
    };
    var changeValue = function changeValue() {
        var val = validateValueByLimit(props.value);
        updateInputValue(props.format ? val : replaceDecimalSeparator(val));
        var newValue = validateValue(props.value);
        if (props.value !== null && props.value !== newValue) updateModel(null, newValue);
    };
    var getFormatter = function getFormatter() {
        return numberFormat.current;
    };
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            focus: function focus() {
                return (0, $cfkGk.DomHandler).focus(inputRef.current);
            },
            getFormatter: getFormatter,
            getElement: function getElement() {
                return elementRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    $81g6h.useEffect(function() {
        (0, $cfkGk.ObjectUtils).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $l2NC0.useMountEffect)(function() {
        constructParser();
        var newValue = validateValue(props.value);
        if (props.value !== null && props.value !== newValue) updateModel(null, newValue);
    });
    (0, $l2NC0.useUpdateEffect)(function() {
        constructParser();
        changeValue();
    }, [
        _locale,
        props.locale,
        props.localeMatcher,
        props.mode,
        props.currency,
        props.currencyDisplay,
        props.useGrouping,
        props.minFractionDigits,
        props.maxFractionDigits,
        props.suffix,
        props.prefix
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        changeValue();
    }, [
        props.value
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        // #5245 prevent infinite loop
        if (props.disabled) clearTimer();
    }, [
        props.disabled
    ]);
    var createInputElement = function createInputElement() {
        var className = (0, $cfkGk.classNames)(props.inputClassName, cx("input", {
            context: context
        }));
        var valueToRender = formattedValue(props.value);
        return /*#__PURE__*/ $81g6h.createElement((0, $6ccvc.InputText), $064de78d0e99ff5a$var$_extends({
            ref: inputRef,
            id: props.inputId,
            style: props.inputStyle,
            role: "spinbutton",
            className: className,
            defaultValue: valueToRender,
            type: props.type,
            size: props.size,
            tabIndex: props.tabIndex,
            inputMode: inputMode,
            maxLength: props.maxLength,
            disabled: props.disabled,
            required: props.required,
            pattern: props.pattern,
            placeholder: props.placeholder,
            readOnly: props.readOnly,
            name: props.name,
            autoFocus: props.autoFocus,
            onKeyDown: onInputKeyDown,
            onKeyPress: onInputAndroidKey,
            onInput: onInput,
            onClick: onInputClick,
            onPointerDown: onInputPointerDown,
            onBlur: onInputBlur,
            onFocus: onInputFocus,
            onPaste: onPaste,
            min: props.min,
            max: props.max,
            "aria-valuemin": props.min,
            "aria-valuemax": props.max,
            "aria-valuenow": props.value
        }, ariaProps, dataProps, {
            pt: ptm("input"),
            __parentMetadata: {
                parent: metaData
            }
        }));
    };
    var createUpButton = function createUpButton() {
        var incrementIconProps = mergeProps({
            className: cx("incrementIcon")
        }, ptm("incrementIcon"));
        var icon = props.incrementButtonIcon || /*#__PURE__*/ $81g6h.createElement((0, $et0wC.AngleUpIcon), incrementIconProps);
        var upButton = (0, $cfkGk.IconUtils).getJSXIcon(icon, $064de78d0e99ff5a$var$_objectSpread({}, incrementIconProps), {
            props: props
        });
        var incrementButtonProps = mergeProps({
            type: "button",
            className: (0, $cfkGk.classNames)(props.incrementButtonClassName, cx("incrementButton")),
            onPointerLeave: onUpButtonMouseLeave,
            onPointerDown: function onPointerDown(e) {
                return onUpButtonMouseDown(e);
            },
            onPointerUp: onUpButtonMouseUp,
            onKeyDown: function onKeyDown(e) {
                return onUpButtonKeyDown(e);
            },
            onKeyUp: onUpButtonKeyUp,
            disabled: props.disabled,
            tabIndex: -1,
            "aria-hidden": true
        }, ptm("incrementButton"));
        return /*#__PURE__*/ $81g6h.createElement("button", incrementButtonProps, upButton, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
    };
    var createDownButton = function createDownButton() {
        var decrementIconProps = mergeProps({
            className: cx("decrementIcon")
        }, ptm("decrementIcon"));
        var icon = props.decrementButtonIcon || /*#__PURE__*/ $81g6h.createElement((0, $5sgNc.AngleDownIcon), decrementIconProps);
        var downButton = (0, $cfkGk.IconUtils).getJSXIcon(icon, $064de78d0e99ff5a$var$_objectSpread({}, decrementIconProps), {
            props: props
        });
        var decrementButtonProps = mergeProps({
            type: "button",
            className: (0, $cfkGk.classNames)(props.decrementButtonClassName, cx("decrementButton")),
            onPointerLeave: onDownButtonMouseLeave,
            onPointerDown: function onPointerDown(e) {
                return onDownButtonMouseDown(e);
            },
            onPointerUp: onDownButtonMouseUp,
            onKeyDown: function onKeyDown(e) {
                return onDownButtonKeyDown(e);
            },
            onKeyUp: onDownButtonKeyUp,
            disabled: props.disabled,
            tabIndex: -1,
            "aria-hidden": true
        }, ptm("decrementButton"));
        return /*#__PURE__*/ $81g6h.createElement("button", decrementButtonProps, downButton, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
    };
    var createButtonGroup = function createButtonGroup() {
        var upButton = props.showButtons && createUpButton();
        var downButton = props.showButtons && createDownButton();
        var buttonGroupProps = mergeProps({
            className: cx("buttonGroup")
        }, ptm("buttonGroup"));
        if (stacked) return /*#__PURE__*/ $81g6h.createElement("span", buttonGroupProps, upButton, downButton);
        return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, upButton, downButton);
    };
    var hasTooltip = (0, $cfkGk.ObjectUtils).isNotEmpty(props.tooltip);
    var otherProps = $064de78d0e99ff5a$var$InputNumberBase.getOtherProps(props);
    var dataProps = (0, $cfkGk.ObjectUtils).reduceKeys(otherProps, (0, $cfkGk.DomHandler).DATA_PROPS);
    var ariaProps = (0, $cfkGk.ObjectUtils).reduceKeys(otherProps, (0, $cfkGk.DomHandler).ARIA_PROPS);
    var inputElement = createInputElement();
    var buttonGroup = createButtonGroup();
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $cfkGk.classNames)(props.className, cx("root", {
            focusedState: focusedState,
            stacked: stacked,
            horizontal: horizontal,
            vertical: vertical
        })),
        style: props.style
    }, otherProps, ptm("root"));
    return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("span", $064de78d0e99ff5a$var$_extends({
        ref: elementRef
    }, rootProps), inputElement, buttonGroup), hasTooltip && /*#__PURE__*/ $81g6h.createElement((0, $7hMfd.Tooltip), $064de78d0e99ff5a$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$064de78d0e99ff5a$export$cf9581d419a141cf.displayName = "InputNumber";

});
parcelRegister("5sgNc", function(module, exports) {

$parcel$export(module.exports, "AngleDownIcon", () => $3f8c97eb1cd7662e$export$e45f9104ca1b1c90);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $3f8c97eb1cd7662e$var$_extends() {
    $3f8c97eb1cd7662e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3f8c97eb1cd7662e$var$_extends.apply(this, arguments);
}
var $3f8c97eb1cd7662e$export$e45f9104ca1b1c90 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $3f8c97eb1cd7662e$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M3.58659 4.5007C3.68513 4.50023 3.78277 4.51945 3.87379 4.55723C3.9648 4.59501 4.04735 4.65058 4.11659 4.7207L7.11659 7.7207L10.1166 4.7207C10.2619 4.65055 10.4259 4.62911 10.5843 4.65956C10.7427 4.69002 10.8871 4.77074 10.996 4.88976C11.1049 5.00877 11.1726 5.15973 11.1889 5.32022C11.2052 5.48072 11.1693 5.6422 11.0866 5.7807L7.58659 9.2807C7.44597 9.42115 7.25534 9.50004 7.05659 9.50004C6.85784 9.50004 6.66722 9.42115 6.52659 9.2807L3.02659 5.7807C2.88614 5.64007 2.80725 5.44945 2.80725 5.2507C2.80725 5.05195 2.88614 4.86132 3.02659 4.7207C3.09932 4.64685 3.18675 4.58911 3.28322 4.55121C3.37969 4.51331 3.48305 4.4961 3.58659 4.5007Z",
        fill: "currentColor"
    }));
}));
$3f8c97eb1cd7662e$export$e45f9104ca1b1c90.displayName = "AngleDownIcon";

});

parcelRegister("et0wC", function(module, exports) {

$parcel$export(module.exports, "AngleUpIcon", () => $a8842e697e86e021$export$60014705184d48db);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $a8842e697e86e021$var$_extends() {
    $a8842e697e86e021$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a8842e697e86e021$var$_extends.apply(this, arguments);
}
var $a8842e697e86e021$export$60014705184d48db = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $a8842e697e86e021$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M10.4134 9.49931C10.3148 9.49977 10.2172 9.48055 10.1262 9.44278C10.0352 9.405 9.95263 9.34942 9.88338 9.27931L6.88338 6.27931L3.88338 9.27931C3.73811 9.34946 3.57409 9.3709 3.41567 9.34044C3.25724 9.30999 3.11286 9.22926 3.00395 9.11025C2.89504 8.99124 2.82741 8.84028 2.8111 8.67978C2.79478 8.51928 2.83065 8.35781 2.91338 8.21931L6.41338 4.71931C6.55401 4.57886 6.74463 4.49997 6.94338 4.49997C7.14213 4.49997 7.33276 4.57886 7.47338 4.71931L10.9734 8.21931C11.1138 8.35994 11.1927 8.55056 11.1927 8.74931C11.1927 8.94806 11.1138 9.13868 10.9734 9.27931C10.9007 9.35315 10.8132 9.41089 10.7168 9.44879C10.6203 9.48669 10.5169 9.5039 10.4134 9.49931Z",
        fill: "currentColor"
    }));
}));
$a8842e697e86e021$export$60014705184d48db.displayName = "AngleUpIcon";

});


parcelRegister("1PSYX", function(module, exports) {

$parcel$export(module.exports, "AngleDoubleRightIcon", () => $15653427f0fe6e60$export$3741352f2ad35b27);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $15653427f0fe6e60$var$_extends() {
    $15653427f0fe6e60$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $15653427f0fe6e60$var$_extends.apply(this, arguments);
}
var $15653427f0fe6e60$export$3741352f2ad35b27 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $15653427f0fe6e60$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.68757 11.1451C7.7791 11.1831 7.8773 11.2024 7.9764 11.2019C8.07769 11.1985 8.17721 11.1745 8.26886 11.1312C8.36052 11.088 8.44238 11.0265 8.50943 10.9505L12.0294 7.49085C12.1707 7.34942 12.25 7.15771 12.25 6.95782C12.25 6.75794 12.1707 6.56622 12.0294 6.42479L8.50943 2.90479C8.37014 2.82159 8.20774 2.78551 8.04633 2.80192C7.88491 2.81833 7.73309 2.88635 7.6134 2.99588C7.4937 3.10541 7.41252 3.25061 7.38189 3.40994C7.35126 3.56927 7.37282 3.73423 7.44337 3.88033L10.4605 6.89748L7.44337 9.91463C7.30212 10.0561 7.22278 10.2478 7.22278 10.4477C7.22278 10.6475 7.30212 10.8393 7.44337 10.9807C7.51301 11.0512 7.59603 11.1071 7.68757 11.1451ZM1.94207 10.9505C2.07037 11.0968 2.25089 11.1871 2.44493 11.2019C2.63898 11.1871 2.81949 11.0968 2.94779 10.9505L6.46779 7.49085C6.60905 7.34942 6.68839 7.15771 6.68839 6.95782C6.68839 6.75793 6.60905 6.56622 6.46779 6.42479L2.94779 2.90479C2.80704 2.83757 2.6489 2.81563 2.49517 2.84201C2.34143 2.86839 2.19965 2.94178 2.08936 3.05207C1.97906 3.16237 1.90567 3.30415 1.8793 3.45788C1.85292 3.61162 1.87485 3.76975 1.94207 3.9105L4.95922 6.92765L1.94207 9.9448C1.81838 10.0831 1.75 10.2621 1.75 10.4477C1.75 10.6332 1.81838 10.8122 1.94207 10.9505Z",
        fill: "currentColor"
    }));
}));
$15653427f0fe6e60$export$3741352f2ad35b27.displayName = "AngleDoubleRightIcon";

});

parcelRegister("1gPAC", function(module, exports) {

$parcel$export(module.exports, "AngleRightIcon", () => $0ecf4dafc2d8ce0c$export$f5db305c33b6241b);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $0ecf4dafc2d8ce0c$var$_extends() {
    $0ecf4dafc2d8ce0c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0ecf4dafc2d8ce0c$var$_extends.apply(this, arguments);
}
var $0ecf4dafc2d8ce0c$export$f5db305c33b6241b = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $0ecf4dafc2d8ce0c$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M5.25 11.1728C5.14929 11.1694 5.05033 11.1455 4.9592 11.1025C4.86806 11.0595 4.78666 10.9984 4.72 10.9228C4.57955 10.7822 4.50066 10.5916 4.50066 10.3928C4.50066 10.1941 4.57955 10.0035 4.72 9.86283L7.72 6.86283L4.72 3.86283C4.66067 3.71882 4.64765 3.55991 4.68275 3.40816C4.71785 3.25642 4.79932 3.11936 4.91585 3.01602C5.03238 2.91268 5.17819 2.84819 5.33305 2.83149C5.4879 2.81479 5.64411 2.84671 5.78 2.92283L9.28 6.42283C9.42045 6.56346 9.49934 6.75408 9.49934 6.95283C9.49934 7.15158 9.42045 7.34221 9.28 7.48283L5.78 10.9228C5.71333 10.9984 5.63193 11.0595 5.5408 11.1025C5.44966 11.1455 5.35071 11.1694 5.25 11.1728Z",
        fill: "currentColor"
    }));
}));
$0ecf4dafc2d8ce0c$export$f5db305c33b6241b.displayName = "AngleRightIcon";

});

parcelRegister("geU5g", function(module, exports) {

$parcel$export(module.exports, "AngleLeftIcon", () => $bd29753d67f1135a$export$3df4a161b319f37a);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $bd29753d67f1135a$var$_extends() {
    $bd29753d67f1135a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bd29753d67f1135a$var$_extends.apply(this, arguments);
}
var $bd29753d67f1135a$export$3df4a161b319f37a = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $bd29753d67f1135a$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M8.75 11.185C8.65146 11.1854 8.55381 11.1662 8.4628 11.1284C8.37179 11.0906 8.28924 11.0351 8.22 10.965L4.72 7.46496C4.57955 7.32433 4.50066 7.13371 4.50066 6.93496C4.50066 6.73621 4.57955 6.54558 4.72 6.40496L8.22 2.93496C8.36095 2.84357 8.52851 2.80215 8.69582 2.81733C8.86312 2.83252 9.02048 2.90344 9.14268 3.01872C9.26487 3.134 9.34483 3.28696 9.36973 3.4531C9.39463 3.61924 9.36303 3.78892 9.28 3.93496L6.28 6.93496L9.28 9.93496C9.42045 10.0756 9.49934 10.2662 9.49934 10.465C9.49934 10.6637 9.42045 10.8543 9.28 10.995C9.13526 11.1257 8.9448 11.1939 8.75 11.185Z",
        fill: "currentColor"
    }));
}));
$bd29753d67f1135a$export$3df4a161b319f37a.displayName = "AngleLeftIcon";

});


parcelRegister("6NeNe", function(module, exports) {

$parcel$export(module.exports, "BarsIcon", () => $4f22cb46fb44c653$export$5e8ad5a7e6c181f);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $4f22cb46fb44c653$var$_extends() {
    $4f22cb46fb44c653$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4f22cb46fb44c653$var$_extends.apply(this, arguments);
}
var $4f22cb46fb44c653$export$5e8ad5a7e6c181f = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $4f22cb46fb44c653$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.3226 3.6129H0.677419C0.497757 3.6129 0.325452 3.54152 0.198411 3.41448C0.0713707 3.28744 0 3.11514 0 2.93548C0 2.75581 0.0713707 2.58351 0.198411 2.45647C0.325452 2.32943 0.497757 2.25806 0.677419 2.25806H13.3226C13.5022 2.25806 13.6745 2.32943 13.8016 2.45647C13.9286 2.58351 14 2.75581 14 2.93548C14 3.11514 13.9286 3.28744 13.8016 3.41448C13.6745 3.54152 13.5022 3.6129 13.3226 3.6129ZM13.3226 7.67741H0.677419C0.497757 7.67741 0.325452 7.60604 0.198411 7.479C0.0713707 7.35196 0 7.17965 0 6.99999C0 6.82033 0.0713707 6.64802 0.198411 6.52098C0.325452 6.39394 0.497757 6.32257 0.677419 6.32257H13.3226C13.5022 6.32257 13.6745 6.39394 13.8016 6.52098C13.9286 6.64802 14 6.82033 14 6.99999C14 7.17965 13.9286 7.35196 13.8016 7.479C13.6745 7.60604 13.5022 7.67741 13.3226 7.67741ZM0.677419 11.7419H13.3226C13.5022 11.7419 13.6745 11.6706 13.8016 11.5435C13.9286 11.4165 14 11.2442 14 11.0645C14 10.8848 13.9286 10.7125 13.8016 10.5855C13.6745 10.4585 13.5022 10.3871 13.3226 10.3871H0.677419C0.497757 10.3871 0.325452 10.4585 0.198411 10.5855C0.0713707 10.7125 0 10.8848 0 11.0645C0 11.2442 0.0713707 11.4165 0.198411 11.5435C0.325452 11.6706 0.497757 11.7419 0.677419 11.7419Z",
        fill: "currentColor"
    }));
}));
$4f22cb46fb44c653$export$5e8ad5a7e6c181f.displayName = "BarsIcon";

});

parcelRegister("gbrlA", function(module, exports) {

$parcel$export(module.exports, "ChevronRightIcon", () => $bc82e30301559354$export$b837bd7eac09a33e);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $bc82e30301559354$var$_extends() {
    $bc82e30301559354$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bc82e30301559354$var$_extends.apply(this, arguments);
}
var $bc82e30301559354$export$b837bd7eac09a33e = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $bc82e30301559354$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M4.38708 13C4.28408 13.0005 4.18203 12.9804 4.08691 12.9409C3.99178 12.9014 3.9055 12.8433 3.83313 12.7701C3.68634 12.6231 3.60388 12.4238 3.60388 12.2161C3.60388 12.0084 3.68634 11.8091 3.83313 11.6622L8.50507 6.99022L3.83313 2.31827C3.69467 2.16968 3.61928 1.97313 3.62287 1.77005C3.62645 1.56698 3.70872 1.37322 3.85234 1.22959C3.99596 1.08597 4.18972 1.00371 4.3928 1.00012C4.59588 0.996539 4.79242 1.07192 4.94102 1.21039L10.1669 6.43628C10.3137 6.58325 10.3962 6.78249 10.3962 6.99022C10.3962 7.19795 10.3137 7.39718 10.1669 7.54416L4.94102 12.7701C4.86865 12.8433 4.78237 12.9014 4.68724 12.9409C4.59212 12.9804 4.49007 13.0005 4.38708 13Z",
        fill: "currentColor"
    }));
}));
$bc82e30301559354$export$b837bd7eac09a33e.displayName = "ChevronRightIcon";

});

parcelRegister("icj7p", function(module, exports) {

$parcel$export(module.exports, "PencilIcon", () => $d3f82d84babb0259$export$d2c72b688139a728);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $d3f82d84babb0259$var$_extends() {
    $d3f82d84babb0259$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d3f82d84babb0259$var$_extends.apply(this, arguments);
}
var $d3f82d84babb0259$export$d2c72b688139a728 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $d3f82d84babb0259$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M0.609628 13.959C0.530658 13.9599 0.452305 13.9451 0.379077 13.9156C0.305849 13.8861 0.239191 13.8424 0.18294 13.787C0.118447 13.7234 0.0688234 13.6464 0.0376166 13.5614C0.00640987 13.4765 -0.00560954 13.3857 0.00241768 13.2956L0.25679 10.1501C0.267698 10.0041 0.331934 9.86709 0.437312 9.76516L9.51265 0.705715C10.0183 0.233014 10.6911 -0.0203041 11.3835 0.00127367C12.0714 0.00660201 12.7315 0.27311 13.2298 0.746671C13.7076 1.23651 13.9824 1.88848 13.9992 2.57201C14.0159 3.25554 13.7733 3.92015 13.32 4.4327L4.23648 13.5331C4.13482 13.6342 4.0017 13.6978 3.85903 13.7133L0.667067 14L0.609628 13.959ZM1.43018 10.4696L1.25787 12.714L3.50619 12.5092L12.4502 3.56444C12.6246 3.35841 12.7361 3.10674 12.7714 2.83933C12.8067 2.57193 12.7644 2.30002 12.6495 2.05591C12.5346 1.8118 12.3519 1.60575 12.1231 1.46224C11.8943 1.31873 11.6291 1.2438 11.3589 1.24633C11.1813 1.23508 11.0033 1.25975 10.8355 1.31887C10.6677 1.37798 10.5136 1.47033 10.3824 1.59036L1.43018 10.4696Z",
        fill: "currentColor"
    }));
}));
$d3f82d84babb0259$export$d2c72b688139a728.displayName = "PencilIcon";

});

parcelRegister("42wHR", function(module, exports) {

$parcel$export(module.exports, "FilterIcon", () => $2f10b8269136928f$export$28f6150e232898de);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $2f10b8269136928f$var$_extends() {
    $2f10b8269136928f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2f10b8269136928f$var$_extends.apply(this, arguments);
}
var $2f10b8269136928f$export$28f6150e232898de = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $2f10b8269136928f$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M8.64708 14H5.35296C5.18981 13.9979 5.03395 13.9321 4.91858 13.8167C4.8032 13.7014 4.73745 13.5455 4.73531 13.3824V7L0.329431 0.98C0.259794 0.889466 0.217389 0.780968 0.20718 0.667208C0.19697 0.553448 0.219379 0.439133 0.271783 0.337647C0.324282 0.236453 0.403423 0.151519 0.500663 0.0920138C0.597903 0.0325088 0.709548 0.000692754 0.823548 0H13.1765C13.2905 0.000692754 13.4021 0.0325088 13.4994 0.0920138C13.5966 0.151519 13.6758 0.236453 13.7283 0.337647C13.7807 0.439133 13.8031 0.553448 13.7929 0.667208C13.7826 0.780968 13.7402 0.889466 13.6706 0.98L9.26472 7V13.3824C9.26259 13.5455 9.19683 13.7014 9.08146 13.8167C8.96609 13.9321 8.81022 13.9979 8.64708 14ZM5.97061 12.7647H8.02943V6.79412C8.02878 6.66289 8.07229 6.53527 8.15296 6.43177L11.9412 1.23529H2.05884L5.86355 6.43177C5.94422 6.53527 5.98773 6.66289 5.98708 6.79412L5.97061 12.7647Z",
        fill: "currentColor"
    }));
}));
$2f10b8269136928f$export$28f6150e232898de.displayName = "FilterIcon";

});

parcelRegister("deOWu", function(module, exports) {

$parcel$export(module.exports, "FilterSlashIcon", () => $9a3419457970c7bd$export$8bb975439d7d7e7c);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $9a3419457970c7bd$var$_extends() {
    $9a3419457970c7bd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9a3419457970c7bd$var$_extends.apply(this, arguments);
}
var $9a3419457970c7bd$export$8bb975439d7d7e7c = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $9a3419457970c7bd$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.4994 0.0920138C13.5967 0.151519 13.6758 0.236453 13.7283 0.337647C13.7807 0.439133 13.8031 0.553448 13.7929 0.667208C13.7827 0.780968 13.7403 0.889466 13.6707 0.98L11.406 4.06823C11.3099 4.19928 11.1656 4.28679 11.005 4.3115C10.8444 4.33621 10.6805 4.2961 10.5495 4.2C10.4184 4.1039 10.3309 3.95967 10.3062 3.79905C10.2815 3.63843 10.3216 3.47458 10.4177 3.34353L11.9412 1.23529H7.41184C7.24803 1.23529 7.09093 1.17022 6.97509 1.05439C6.85926 0.938558 6.79419 0.781457 6.79419 0.617647C6.79419 0.453837 6.85926 0.296736 6.97509 0.180905C7.09093 0.0650733 7.24803 0 7.41184 0H13.1765C13.2905 0.000692754 13.4022 0.0325088 13.4994 0.0920138ZM4.20008 0.181168H4.24126L13.2013 9.03411C13.3169 9.14992 13.3819 9.3069 13.3819 9.47058C13.3819 9.63426 13.3169 9.79124 13.2013 9.90705C13.1445 9.96517 13.0766 10.0112 13.0016 10.0423C12.9266 10.0735 12.846 10.0891 12.7648 10.0882C12.6836 10.0886 12.6032 10.0728 12.5283 10.0417C12.4533 10.0106 12.3853 9.96479 12.3283 9.90705L9.3142 6.92587L9.26479 6.99999V13.3823C9.26265 13.5455 9.19689 13.7014 9.08152 13.8167C8.96615 13.9321 8.81029 13.9979 8.64714 14H5.35302C5.18987 13.9979 5.03401 13.9321 4.91864 13.8167C4.80327 13.7014 4.73751 13.5455 4.73537 13.3823V6.99999L0.329492 1.02117C0.259855 0.930634 0.21745 0.822137 0.207241 0.708376C0.197031 0.594616 0.21944 0.480301 0.271844 0.378815C0.324343 0.277621 0.403484 0.192687 0.500724 0.133182C0.597964 0.073677 0.709609 0.041861 0.823609 0.0411682H3.86243C3.92448 0.0461551 3.9855 0.060022 4.04361 0.0823446C4.10037 0.10735 4.15311 0.140655 4.20008 0.181168ZM8.02949 6.79411C8.02884 6.66289 8.07235 6.53526 8.15302 6.43176L8.42478 6.05293L3.55773 1.23529H2.0589L5.84714 6.43176C5.92781 6.53526 5.97132 6.66289 5.97067 6.79411V12.7647H8.02949V6.79411Z",
        fill: "currentColor"
    }));
}));
$9a3419457970c7bd$export$8bb975439d7d7e7c.displayName = "FilterSlashIcon";

});

parcelRegister("2NGYW", function(module, exports) {

$parcel$export(module.exports, "TrashIcon", () => $20a17facf6ba1e10$export$d23329de703dffc4);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $20a17facf6ba1e10$var$_extends() {
    $20a17facf6ba1e10$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $20a17facf6ba1e10$var$_extends.apply(this, arguments);
}
var $20a17facf6ba1e10$export$d23329de703dffc4 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $20a17facf6ba1e10$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.44802 13.9955H10.552C10.8056 14.0129 11.06 13.9797 11.3006 13.898C11.5412 13.8163 11.7632 13.6877 11.9537 13.5196C12.1442 13.3515 12.2995 13.1473 12.4104 12.9188C12.5213 12.6903 12.5858 12.442 12.6 12.1884V4.36041H13.4C13.5591 4.36041 13.7117 4.29722 13.8243 4.18476C13.9368 4.07229 14 3.91976 14 3.76071C14 3.60166 13.9368 3.44912 13.8243 3.33666C13.7117 3.22419 13.5591 3.16101 13.4 3.16101H12.0537C12.0203 3.1557 11.9863 3.15299 11.952 3.15299C11.9178 3.15299 11.8838 3.1557 11.8503 3.16101H11.2285C11.2421 3.10893 11.2487 3.05513 11.248 3.00106V1.80966C11.2171 1.30262 10.9871 0.828306 10.608 0.48989C10.229 0.151475 9.73159 -0.0236625 9.22402 0.00257442H4.77602C4.27251 -0.0171866 3.78126 0.160868 3.40746 0.498617C3.03365 0.836366 2.807 1.30697 2.77602 1.80966V3.00106C2.77602 3.0556 2.78346 3.10936 2.79776 3.16101H0.6C0.521207 3.16101 0.443185 3.17652 0.37039 3.20666C0.297595 3.2368 0.231451 3.28097 0.175736 3.33666C0.120021 3.39235 0.0758251 3.45846 0.0456722 3.53121C0.0155194 3.60397 0 3.68196 0 3.76071C0 3.83946 0.0155194 3.91744 0.0456722 3.9902C0.0758251 4.06296 0.120021 4.12907 0.175736 4.18476C0.231451 4.24045 0.297595 4.28462 0.37039 4.31476C0.443185 4.3449 0.521207 4.36041 0.6 4.36041H1.40002V12.1884C1.41426 12.442 1.47871 12.6903 1.58965 12.9188C1.7006 13.1473 1.85582 13.3515 2.04633 13.5196C2.23683 13.6877 2.45882 13.8163 2.69944 13.898C2.94005 13.9797 3.1945 14.0129 3.44802 13.9955ZM2.60002 4.36041H11.304V12.1884C11.304 12.5163 10.952 12.7961 10.504 12.7961H3.40002C2.97602 12.7961 2.60002 12.5163 2.60002 12.1884V4.36041ZM3.95429 3.16101C3.96859 3.10936 3.97602 3.0556 3.97602 3.00106V1.80966C3.97602 1.48183 4.33602 1.20197 4.77602 1.20197H9.24802C9.66403 1.20197 10.048 1.48183 10.048 1.80966V3.00106C10.0473 3.05515 10.054 3.10896 10.0678 3.16101H3.95429ZM5.57571 10.997C5.41731 10.995 5.26597 10.9311 5.15395 10.8191C5.04193 10.7071 4.97808 10.5558 4.97601 10.3973V6.77517C4.97601 6.61612 5.0392 6.46359 5.15166 6.35112C5.26413 6.23866 5.41666 6.17548 5.57571 6.17548C5.73476 6.17548 5.8873 6.23866 5.99976 6.35112C6.11223 6.46359 6.17541 6.61612 6.17541 6.77517V10.3894C6.17647 10.4688 6.16174 10.5476 6.13208 10.6213C6.10241 10.695 6.05841 10.762 6.00261 10.8186C5.94682 10.8751 5.88035 10.92 5.80707 10.9506C5.73378 10.9813 5.65514 10.9971 5.57571 10.997ZM7.99968 10.8214C8.11215 10.9339 8.26468 10.997 8.42373 10.997C8.58351 10.9949 8.73604 10.93 8.84828 10.8163C8.96052 10.7025 9.02345 10.5491 9.02343 10.3894V6.77517C9.02343 6.61612 8.96025 6.46359 8.84778 6.35112C8.73532 6.23866 8.58278 6.17548 8.42373 6.17548C8.26468 6.17548 8.11215 6.23866 7.99968 6.35112C7.88722 6.46359 7.82404 6.61612 7.82404 6.77517V10.3973C7.82404 10.5564 7.88722 10.7089 7.99968 10.8214Z",
        fill: "currentColor"
    }));
}));
$20a17facf6ba1e10$export$d23329de703dffc4.displayName = "TrashIcon";

});

parcelRegister("65uA4", function(module, exports) {

$parcel$export(module.exports, "SortAltIcon", () => $46eaee7025657f94$export$d79696f0483bfbd9);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $46eaee7025657f94$var$_extends() {
    $46eaee7025657f94$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $46eaee7025657f94$var$_extends.apply(this, arguments);
}
var $46eaee7025657f94$export$d79696f0483bfbd9 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $46eaee7025657f94$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M5.64515 3.61291C5.47353 3.61291 5.30192 3.54968 5.16644 3.4142L3.38708 1.63484L1.60773 3.4142C1.34579 3.67613 0.912244 3.67613 0.650309 3.4142C0.388374 3.15226 0.388374 2.71871 0.650309 2.45678L2.90837 0.198712C3.17031 -0.0632236 3.60386 -0.0632236 3.86579 0.198712L6.12386 2.45678C6.38579 2.71871 6.38579 3.15226 6.12386 3.4142C5.98837 3.54968 5.81676 3.61291 5.64515 3.61291Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M3.38714 14C3.01681 14 2.70972 13.6929 2.70972 13.3226V0.677419C2.70972 0.307097 3.01681 0 3.38714 0C3.75746 0 4.06456 0.307097 4.06456 0.677419V13.3226C4.06456 13.6929 3.75746 14 3.38714 14Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M10.6129 14C10.4413 14 10.2697 13.9368 10.1342 13.8013L7.87611 11.5432C7.61418 11.2813 7.61418 10.8477 7.87611 10.5858C8.13805 10.3239 8.5716 10.3239 8.83353 10.5858L10.6129 12.3652L12.3922 10.5858C12.6542 10.3239 13.0877 10.3239 13.3497 10.5858C13.6116 10.8477 13.6116 11.2813 13.3497 11.5432L11.0916 13.8013C10.9561 13.9368 10.7845 14 10.6129 14Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M10.6129 14C10.2426 14 9.93552 13.6929 9.93552 13.3226V0.677419C9.93552 0.307097 10.2426 0 10.6129 0C10.9833 0 11.2904 0.307097 11.2904 0.677419V13.3226C11.2904 13.6929 10.9832 14 10.6129 14Z",
        fill: "currentColor"
    }));
}));
$46eaee7025657f94$export$d79696f0483bfbd9.displayName = "SortAltIcon";

});

parcelRegister("gft09", function(module, exports) {

$parcel$export(module.exports, "SortAmountDownIcon", () => $bd448b29c24c0c10$export$81e628514f0bafd8);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $bd448b29c24c0c10$var$_extends() {
    $bd448b29c24c0c10$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bd448b29c24c0c10$var$_extends.apply(this, arguments);
}
var $bd448b29c24c0c10$export$81e628514f0bafd8 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $bd448b29c24c0c10$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M2.59836 13.2009C2.44634 13.2009 2.29432 13.1449 2.1743 13.0248L0.174024 11.0246C-0.0580081 10.7925 -0.0580081 10.4085 0.174024 10.1764C0.406057 9.94441 0.79011 9.94441 1.02214 10.1764L2.59836 11.7527L4.17458 10.1764C4.40662 9.94441 4.79067 9.94441 5.0227 10.1764C5.25473 10.4085 5.25473 10.7925 5.0227 11.0246L3.02242 13.0248C2.90241 13.1449 2.75038 13.2009 2.59836 13.2009Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M2.59836 13.2009C2.27032 13.2009 1.99833 12.9288 1.99833 12.6008V1.39922C1.99833 1.07117 2.27036 0.799133 2.59841 0.799133C2.92646 0.799133 3.19849 1.07117 3.19849 1.39922V12.6008C3.19849 12.9288 2.92641 13.2009 2.59836 13.2009Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M13.3999 11.2006H6.99902C6.67098 11.2006 6.39894 10.9285 6.39894 10.6005C6.39894 10.2725 6.67098 10.0004 6.99902 10.0004H13.3999C13.728 10.0004 14 10.2725 14 10.6005C14 10.9285 13.728 11.2006 13.3999 11.2006Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M10.1995 6.39991H6.99902C6.67098 6.39991 6.39894 6.12788 6.39894 5.79983C6.39894 5.47179 6.67098 5.19975 6.99902 5.19975H10.1995C10.5275 5.19975 10.7996 5.47179 10.7996 5.79983C10.7996 6.12788 10.5275 6.39991 10.1995 6.39991Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M8.59925 3.99958H6.99902C6.67098 3.99958 6.39894 3.72754 6.39894 3.3995C6.39894 3.07145 6.67098 2.79941 6.99902 2.79941H8.59925C8.92729 2.79941 9.19933 3.07145 9.19933 3.3995C9.19933 3.72754 8.92729 3.99958 8.59925 3.99958Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M11.7997 8.80025H6.99902C6.67098 8.80025 6.39894 8.52821 6.39894 8.20017C6.39894 7.87212 6.67098 7.60008 6.99902 7.60008H11.7997C12.1277 7.60008 12.3998 7.87212 12.3998 8.20017C12.3998 8.52821 12.1277 8.80025 11.7997 8.80025Z",
        fill: "currentColor"
    }));
}));
$bd448b29c24c0c10$export$81e628514f0bafd8.displayName = "SortAmountDownIcon";

});

parcelRegister("7nQgj", function(module, exports) {

$parcel$export(module.exports, "SortAmountUpAltIcon", () => $01632612c95bb927$export$7a06440e4457d3e9);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $01632612c95bb927$var$_extends() {
    $01632612c95bb927$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $01632612c95bb927$var$_extends.apply(this, arguments);
}
var $01632612c95bb927$export$7a06440e4457d3e9 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $01632612c95bb927$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M4.59864 3.99958C4.44662 3.99958 4.2946 3.94357 4.17458 3.82356L2.59836 2.24734L1.02214 3.82356C0.79011 4.05559 0.406057 4.05559 0.174024 3.82356C-0.0580081 3.59152 -0.0580081 3.20747 0.174024 2.97544L2.1743 0.97516C2.40634 0.743127 2.79039 0.743127 3.02242 0.97516L5.0227 2.97544C5.25473 3.20747 5.25473 3.59152 5.0227 3.82356C4.90268 3.94357 4.75066 3.99958 4.59864 3.99958Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M2.59841 13.2009C2.27036 13.2009 1.99833 12.9288 1.99833 12.6008V1.39922C1.99833 1.07117 2.27036 0.799133 2.59841 0.799133C2.92646 0.799133 3.19849 1.07117 3.19849 1.39922V12.6008C3.19849 12.9288 2.92646 13.2009 2.59841 13.2009Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M13.3999 11.2006H6.99902C6.67098 11.2006 6.39894 10.9285 6.39894 10.6005C6.39894 10.2725 6.67098 10.0004 6.99902 10.0004H13.3999C13.728 10.0004 14 10.2725 14 10.6005C14 10.9285 13.728 11.2006 13.3999 11.2006Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M10.1995 6.39991H6.99902C6.67098 6.39991 6.39894 6.12788 6.39894 5.79983C6.39894 5.47179 6.67098 5.19975 6.99902 5.19975H10.1995C10.5275 5.19975 10.7996 5.47179 10.7996 5.79983C10.7996 6.12788 10.5275 6.39991 10.1995 6.39991Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M8.59925 3.99958H6.99902C6.67098 3.99958 6.39894 3.72754 6.39894 3.3995C6.39894 3.07145 6.67098 2.79941 6.99902 2.79941H8.59925C8.92729 2.79941 9.19933 3.07145 9.19933 3.3995C9.19933 3.72754 8.92729 3.99958 8.59925 3.99958Z",
        fill: "currentColor"
    }), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M11.7997 8.80025H6.99902C6.67098 8.80025 6.39894 8.52821 6.39894 8.20017C6.39894 7.87212 6.67098 7.60008 6.99902 7.60008H11.7997C12.1277 7.60008 12.3998 7.87212 12.3998 8.20017C12.3998 8.52821 12.1277 8.80025 11.7997 8.80025Z",
        fill: "currentColor"
    }));
}));
$01632612c95bb927$export$7a06440e4457d3e9.displayName = "SortAmountUpAltIcon";

});



parcelRegister("8nx58", function(module, exports) {

$parcel$export(module.exports, "RegisteredPatientListing", () => $38b761103a025890$export$e1b9b1bc869049ac);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ccjD7 = parcelRequire("ccjD7");

var $lG6Cp = parcelRequire("lG6Cp");

var $aEP4N = parcelRequire("aEP4N");

var $6Yxa2 = parcelRequire("6Yxa2");

var $bC9c0 = parcelRequire("bC9c0");

var $5stJo = parcelRequire("5stJo");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $9gtEr = parcelRequire("9gtEr");

var $1lhQS = parcelRequire("1lhQS");

var $02Kb9 = parcelRequire("02Kb9");

var $5kXMA = parcelRequire("5kXMA");

var $lDZlX = parcelRequire("lDZlX");

var $2LUd1 = parcelRequire("2LUd1");

var $egSoS = parcelRequire("egSoS");

var $1MPs5 = parcelRequire("1MPs5");

var $2tsa2 = parcelRequire("2tsa2");

var $2hf1V = parcelRequire("2hf1V");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $izIaa = parcelRequire("izIaa");

var $1LHh3 = parcelRequire("1LHh3");

var $81g6h = parcelRequire("81g6h");
// cell components moved outside the main component to avoid inline definitions
const $38b761103a025890$var$NameDiseaseCell = (patient)=>{
    if (!patient) return null;
    return /*#__PURE__*/ (0, $iKObn.jsxs)($38b761103a025890$var$PatientNameContainer, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($38b761103a025890$var$PatientName, {
                className: "p-size-s-bold",
                children: patient.name
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($38b761103a025890$var$Disease, {
                className: "p-size-xs-semi-bold",
                children: patient.disease
            })
        ]
    });
};
const $38b761103a025890$var$ProgramStatusCell = (patient)=>{
    if (!patient) return null;
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $1lhQS.ProgramStatusComponent), {
        programStatus: patient.globalProgramStatus
    });
};
const $38b761103a025890$var$ComplianceCell = ({ patient: patient, isLoadingCompliances: isLoadingCompliances })=>{
    const { format: format, formatPercent: formatPercent } = (0, $1eHG3.useI18n)();
    const emptyWording = format("global.empty");
    const complianceSkeletonProps = (0, $81g6h.useMemo)(()=>$38b761103a025890$var$skeletonPropsFromLoadingState(isLoadingCompliances), [
        isLoadingCompliances
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $9gtEr.ConditionalSkeleton), {
        ...complianceSkeletonProps,
        children: !patient || (0, $lTdpc.isNil)(patient.compliance) ? emptyWording : /*#__PURE__*/ (0, $iKObn.jsx)("span", {
            className: "p-size-s-bold",
            children: formatPercent(patient.compliance)
        })
    });
};
const $38b761103a025890$var$LastSessionCell = ({ patient: patient, emptyWording: emptyWording, getFormattedLastSessionDate: getFormattedLastSessionDate })=>{
    if (!patient) return emptyWording;
    return patient.lastCompletedSessionDate ? getFormattedLastSessionDate(patient.lastCompletedSessionDate) : emptyWording;
};
const $38b761103a025890$var$ExtendProgramCell = ({ patient: patient, label: label, extendProgram: extendProgram })=>{
    if (!patient) return null;
    const { globalProgramStatus: globalProgramStatus } = patient;
    if (!(0, $5stJo.isGlobalProgramStatusExtendable)(globalProgramStatus)) return null;
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
        label: label,
        onClick: ()=>extendProgram((0, $bC9c0.AnalyticsProgramLocation).HOME, patient.id, patient.analyticsId, globalProgramStatus.programId, globalProgramStatus.type),
        uiStyle: "secondary"
    });
};
const $38b761103a025890$var$PatientActionCell = (data)=>{
    if (!data) return null;
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $2LUd1.PatientActionButton), {
        patient: {
            ...data,
            status: (0, $6Yxa2.PatientStatus).Registered
        }
    });
};
const $38b761103a025890$var$skeletonPropsFromLoadingState = (loadingState)=>({
        active: loadingState,
        loading: loadingState
    });
const $38b761103a025890$export$e1b9b1bc869049ac = ({ registeredPatients: registeredPatients, isLoadingCompliances: isLoadingCompliances })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { getFormattedLastSessionDate: getFormattedLastSessionDate } = (0, $1MPs5.usePatientListingItem)();
    const { formatDisease: formatDisease } = (0, $lG6Cp.useFormatMedicalCondition)();
    const { formatPatientName: formatPatientName } = (0, $aEP4N.useFormatPatients)();
    const { extendProgram: extendProgram } = (0, $2hf1V.useProgramActions)();
    const navigate = (0, $htiSH.useNavigate)();
    const columnProps = {
        sortable: true
    };
    const registeredPatientsRows = registeredPatients.map((patient)=>({
            ...patient,
            name: formatPatientName(patient),
            disease: (0, $ccjD7.isUnspecifiedDisease)(patient.disease) ? undefined : formatDisease(patient.disease)
        }));
    const { responsiveDeviceType: responsiveDeviceType } = (0, $5kXMA.useDimensions)();
    const complianceSkeletonProps = (0, $81g6h.useMemo)(()=>$38b761103a025890$var$skeletonPropsFromLoadingState(isLoadingCompliances), [
        isLoadingCompliances
    ]);
    const complianceBody = (0, $81g6h.useCallback)((data)=>/*#__PURE__*/ (0, $iKObn.jsx)($38b761103a025890$var$ComplianceCell, {
            patient: data,
            isLoadingCompliances: isLoadingCompliances
        }), [
        isLoadingCompliances
    ]);
    const emptyWording = format("global.empty");
    const extendProgramLabel = format("home.registeredPatientsListing.extendColumn.button");
    const lastSessionBody = (0, $81g6h.useCallback)((data)=>/*#__PURE__*/ (0, $iKObn.jsx)($38b761103a025890$var$LastSessionCell, {
            patient: data,
            emptyWording: emptyWording,
            getFormattedLastSessionDate: getFormattedLastSessionDate
        }), [
        emptyWording,
        getFormattedLastSessionDate
    ]);
    const extendProgramBody = (0, $81g6h.useCallback)((data)=>/*#__PURE__*/ (0, $iKObn.jsx)($38b761103a025890$var$ExtendProgramCell, {
            patient: data,
            label: extendProgramLabel,
            extendProgram: extendProgram
        }), [
        extendProgram,
        extendProgramLabel
    ]);
    if (responsiveDeviceType !== (0, $5kXMA.ResponsiveDeviceType).Desktop) return registeredPatientsRows.length === 0 ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $2tsa2.EmptyPatientMessage), {
        variant: (0, $2tsa2.EmptyPatientMessageVariant).NoRegisteredPatients
    }) : registeredPatientsRows.map((patient)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $egSoS.RegisteredPatientListingRowMobile), {
            patient: patient,
            complianceSkeletonProps: complianceSkeletonProps
        }, patient.id));
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $1LHh3.DataTable), {
        className: "p-round-corner",
        tableStyle: {
            width: "100%"
        },
        value: registeredPatientsRows,
        rowHover: true,
        onRowClick: (e)=>{
            const data = e.data;
            navigate((0, $lDZlX.RoutesPath).PatientDetails, {
                route: {
                    patientId: data.id
                },
                query: {
                    active: (0, $lDZlX.TabPatientDetails).PROGRESS_TAB
                }
            });
            (0, $bC9c0.sendAnalyticsEventViewPatientDetail)(e.data.analyticsId, (0, $bC9c0.AnalyticsProgramClickType).LIST_CLICK);
        },
        dataKey: "id",
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $izIaa.Column), {
                ...columnProps,
                field: "name",
                bodyStyle: {
                    maxWidth: 300,
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                },
                bodyClassName: "p-size-s-bold",
                header: format("home.registeredPatientsListing.nameColumn"),
                body: $38b761103a025890$var$NameDiseaseCell
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $izIaa.Column), {
                ...columnProps,
                field: "programStatusColumn",
                header: format("home.registeredPatientsListing.programStatusColumn"),
                body: $38b761103a025890$var$ProgramStatusCell,
                sortFunction: (e)=>e.data.sort((a, b)=>(0, $5stJo.sortGlobalProgramStatus)(a.globalProgramStatus, b.globalProgramStatus, e.order ?? 1))
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $izIaa.Column), {
                ...columnProps,
                field: "compliance",
                body: complianceBody,
                header: /*#__PURE__*/ (0, $iKObn.jsx)((0, $02Kb9.Tooltip), {
                    content: format("patientDetails.progress.complianceSection.tooltip"),
                    maxWidth: 400,
                    placement: "top",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                        className: "p-column-title last-completed-session",
                        children: format("home.registeredPatientsListing.globalComplianceColumn")
                    })
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $izIaa.Column), {
                ...columnProps,
                field: "lastCompletedSession",
                header: /*#__PURE__*/ (0, $iKObn.jsx)((0, $02Kb9.Tooltip), {
                    content: format("home.registeredPatientsListing.lastSessionColumn.tooltip"),
                    placement: "top",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                        className: "p-column-title last-completed-session",
                        children: format("home.registeredPatientsListing.lastSessionColumn")
                    })
                }),
                body: lastSessionBody,
                sortFunction: (e)=>e.data.sort((a, b)=>(e.order ?? 1) * ((a.lastCompletedSessionDate?.unix() ?? 0) - (b.lastCompletedSessionDate?.unix() ?? 0)))
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $izIaa.Column), {
                field: "extendButton",
                style: {
                    width: 100
                },
                body: extendProgramBody
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $izIaa.Column), {
                field: "additionalOptions",
                style: {
                    width: 72
                },
                body: $38b761103a025890$var$PatientActionCell
            })
        ]
    });
};
const $38b761103a025890$var$Disease = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).grey} !important;
	margin-top: 4px 0 0 0;
`;
const $38b761103a025890$var$PatientNameContainer = (0, $5UMQ1.default).div`
	max-width: 300px;
	overflow: hidden;
	text-overflow: ellipsis;
	${(0, $5WGN2.stack)(4)}
`;
const $38b761103a025890$var$PatientName = (0, $5UMQ1.default).p`
	overflow: hidden;
	text-overflow: ellipsis;
`;

});
parcelRegister("1lhQS", function(module, exports) {

$parcel$export(module.exports, "ProgramStatusComponent", () => $764659706a7fb870$export$5b1d02d86f2a5d9f);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5SzTW = parcelRequire("5SzTW");

var $5UMQ1 = parcelRequire("5UMQ1");

var $j8eKB = parcelRequire("j8eKB");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $kXaMn = parcelRequire("kXaMn");

var $81g6h = parcelRequire("81g6h");

var $aTGFU = parcelRequire("aTGFU");
const $764659706a7fb870$export$5b1d02d86f2a5d9f = ({ programStatus: programStatus, statusLabelVisible: statusLabelVisible = false })=>{
    const { formatDurationLeft: formatDurationLeft, format: format, formatDateRelative: formatDateRelative, formatDateMed: formatDateMed } = (0, $1eHG3.useI18n)();
    const renderProps = (0, $81g6h.useMemo)(()=>{
        const { type: type } = programStatus;
        switch(type){
            case (0, $5SzTW.GlobalProgramStatusType).OngoingProgram:
            case (0, $5SzTW.GlobalProgramStatusType).EndingSoonProgramWithNoNext:
                {
                    const durationLeft = (0, $kXaMn.computeDiffInDays)((0, $kXaMn.nowAsStartOfDay)(), programStatus.endDate);
                    const total = (0, $kXaMn.computeDiffInDays)(programStatus.startDate, programStatus.endDate);
                    let pieChartColor;
                    if (durationLeft > (0, $kXaMn.TWO_MONTH_IN_DAYS)) pieChartColor = (0, $kKnoQ.colors).primary;
                    else if (durationLeft > (0, $kXaMn.TWO_WEEKS_IN_DAYS)) pieChartColor = (0, $kKnoQ.colors).yellow;
                    else pieChartColor = (0, $kKnoQ.colors).rejection;
                    return {
                        type: type,
                        pieChartColor: pieChartColor,
                        pieChartProgressPercentage: durationLeft / total,
                        label: formatDurationLeft(durationLeft, (0, $kXaMn.TWO_MONTH_IN_DAYS))
                    };
                }
            case (0, $5SzTW.GlobalProgramStatusType).ScheduledProgram:
                return {
                    type: type,
                    label: format("global.programStatus.labels.upcomingProgram", {
                        formattedDays: programStatus.startDate.startOf("day").to((0, $kXaMn.now)().startOf("day"), true)
                    })
                };
            case (0, $5SzTW.GlobalProgramStatusType).EndedLastProgram:
                return {
                    type: type,
                    label: format("global.programStatus.labels.endedProgramWithNoUpcoming", {
                        endDate: formatDateRelative(programStatus.endDate)
                    }),
                    labelColor: (0, $kKnoQ.colors).rejection
                };
            case (0, $5SzTW.GlobalProgramStatusType).EndedLastProgramDetailsMode:
                return {
                    type: type,
                    label: format("global.programStatus.labels.endedProgramDetailsMode_v2.4", {
                        endDate: formatDateMed(programStatus.endDate)
                    })
                };
            case (0, $5SzTW.GlobalProgramStatusType).NoProgram:
                return {
                    type: type,
                    label: format("global.programStatus.labels.noProgram.v2_6")
                };
        }
    }, [
        format,
        formatDateMed,
        formatDurationLeft,
        formatDateRelative,
        programStatus
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($764659706a7fb870$var$StatusContainer, {
        children: [
            statusLabelVisible && /*#__PURE__*/ (0, $iKObn.jsx)((0, $aTGFU.ProgramStatusLabel), {
                type: renderProps.type
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $j8eKB.ProgramStatusIcon), {
                props: renderProps
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($764659706a7fb870$var$ProgramLabel, {
                style: {
                    color: renderProps.type === (0, $5SzTW.GlobalProgramStatusType).EndedLastProgram ? renderProps.labelColor : undefined
                },
                children: renderProps.label
            })
        ]
    });
};
const $764659706a7fb870$var$StatusContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8, undefined, "center")}
`;
const $764659706a7fb870$var$ProgramLabel = (0, $5UMQ1.default).div``;

});
parcelRegister("j8eKB", function(module, exports) {

$parcel$export(module.exports, "ProgramStatusIcon", () => $db4b72741f834309$export$a5c413df3344b725);

var $iKObn = parcelRequire("iKObn");

var $5SzTW = parcelRequire("5SzTW");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
var $db4b72741f834309$var$CheckWithCircle = function CheckWithCircle(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Zm0-20c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "m17.71 9.71-7 7c-.2.19-.45.29-.71.29-.26 0-.51-.1-.71-.29l-3-3a.996.996 0 0 1 0-1.41c.39-.39 1.03-.39 1.42 0L10 14.59l6.29-6.29c.39-.39 1.03-.39 1.42 0 .39.39.39 1.02 0 1.41Z",
                fill: "currentColor"
            })
        ]
    });
};
$db4b72741f834309$var$CheckWithCircle.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $db4b72741f834309$var$Dashed = function Dashed(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("circle", {
            cx: "10",
            cy: "10",
            r: "9",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeDasharray: "4 4"
        })
    });
};
$db4b72741f834309$var$Dashed.defaultProps = {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $db4b72741f834309$var$PlayWithCircle = function PlayWithCircle(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 7c0-1.597 1.753-2.514 3.071-1.687l.006.003 8.135 5.174c1.222.788 1.242 2.587-.007 3.375L9.08 19.042h-.002C7.741 19.9 6 18.938 6 17.36V7Zm2 .003v10.355l.003-.001 8.132-5.182h-.002c0-.001 0-.002-.002-.002l-.002-.002-8.121-5.164a.055.055 0 0 0-.006-.004H8Z",
            fill: "currentColor"
        })
    });
};
$db4b72741f834309$var$PlayWithCircle.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $db4b72741f834309$var$Warn = function Warn(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0Zm.5 15h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5Zm-.5-4a1 1 0 0 1-1-1V6a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1Z",
            fill: "currentColor"
        })
    });
};
$db4b72741f834309$var$Warn.defaultProps = {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $db4b72741f834309$export$a5c413df3344b725 = ({ props: props })=>{
    switch(props.type){
        case (0, $5SzTW.GlobalProgramStatusType).ScheduledProgram:
            return /*#__PURE__*/ (0, $iKObn.jsx)($db4b72741f834309$var$PlayWithCircleIcon, {});
        case (0, $5SzTW.GlobalProgramStatusType).EndedLastProgram:
            return /*#__PURE__*/ (0, $iKObn.jsx)($db4b72741f834309$var$DangerIcon, {});
        case (0, $5SzTW.GlobalProgramStatusType).EndedLastProgramDetailsMode:
            return /*#__PURE__*/ (0, $iKObn.jsx)($db4b72741f834309$var$CheckWithCircleIcon, {});
        case (0, $5SzTW.GlobalProgramStatusType).NoProgram:
            return /*#__PURE__*/ (0, $iKObn.jsx)($db4b72741f834309$var$DashedCircle, {});
        case (0, $5SzTW.GlobalProgramStatusType).OngoingProgram:
        case (0, $5SzTW.GlobalProgramStatusType).EndingSoonProgramWithNoNext:
            return /*#__PURE__*/ (0, $iKObn.jsx)($db4b72741f834309$var$CircleContainer, {
                color: props.pieChartColor,
                children: /*#__PURE__*/ (0, $iKObn.jsx)($db4b72741f834309$var$PieChart, {
                    progress: 360 - Math.round(360 * props.pieChartProgressPercentage),
                    color: props.pieChartColor
                })
            });
    }
};
const $db4b72741f834309$var$PlayWithCircleIcon = (0, $5UMQ1.default)($db4b72741f834309$var$PlayWithCircle)`
	width: 16px;
	height: 16px;
	color: ${(0, $kKnoQ.colors).grey80};
`;
const $db4b72741f834309$var$CheckWithCircleIcon = (0, $5UMQ1.default)($db4b72741f834309$var$CheckWithCircle)`
	width: 16px;
	height: 16px;
	color: ${(0, $kKnoQ.colors).grey80};
`;
const $db4b72741f834309$var$DangerIcon = (0, $5UMQ1.default)($db4b72741f834309$var$Warn)`
	width: 16px;
	height: 16px;
	color: ${(0, $kKnoQ.colors).rejection};
`;
const $db4b72741f834309$var$DashedCircle = (0, $5UMQ1.default)($db4b72741f834309$var$Dashed)`
	width: 16px;
	height: 16px;
	color: ${(0, $kKnoQ.colors).grey80};
`;
const $db4b72741f834309$var$CircleContainer = (0, $5UMQ1.default).div`
	width: 16px;
	height: 16px;
	border-radius: 8px;
	border: 2px solid ${({ color: color })=>color};
	display: flex;
	justify-content: center;
	align-items: center;
`;
const $db4b72741f834309$var$PieChart = (0, $5UMQ1.default).div`
	width: 8px;
	height: 8px;
	border-radius: 6px;
	background: conic-gradient(
		${({ progress: progress, color: color })=>`${(0, $kKnoQ.colors).white} 0deg ${progress}deg, ${color}  ${progress}deg 360deg`}
	);
`;

});

parcelRegister("aTGFU", function(module, exports) {

$parcel$export(module.exports, "ProgramStatusLabel", () => $e72cf7f33878221a$export$9b880aae6af81af2);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");

var $5SzTW = parcelRequire("5SzTW");
const $e72cf7f33878221a$export$9b880aae6af81af2 = ({ type: type })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const label = (0, $81g6h.useMemo)(()=>{
        switch(type){
            case (0, $5SzTW.GlobalProgramStatusType).NoProgram:
                return format("global.programStatus.labels.draft");
            case (0, $5SzTW.GlobalProgramStatusType).OngoingProgram:
                return format("global.programStatus.ongoing");
            case (0, $5SzTW.GlobalProgramStatusType).EndedLastProgramDetailsMode:
            case (0, $5SzTW.GlobalProgramStatusType).EndedLastProgram:
                return format("global.programStatus.labels.ended");
            case (0, $5SzTW.GlobalProgramStatusType).ScheduledProgram:
                return format("global.programStatus.labels.scheduled");
        }
    }, [
        format,
        type
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($e72cf7f33878221a$var$Container, {
        className: "p-size-s",
        children: label
    });
};
const $e72cf7f33878221a$var$Container = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).black};
	background-color: ${(0, $kKnoQ.colors).primaryBackground};
	border-radius: 8px;
	padding: 6px 12px;
`;

});


parcelRegister("egSoS", function(module, exports) {

$parcel$export(module.exports, "RegisteredPatientListingRowMobile", () => $95b5693500051ee8$export$9277d8f0e9272940);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $6Yxa2 = parcelRequire("6Yxa2");

var $bC9c0 = parcelRequire("bC9c0");

var $5stJo = parcelRequire("5stJo");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $9gtEr = parcelRequire("9gtEr");

var $1lhQS = parcelRequire("1lhQS");

var $lDZlX = parcelRequire("lDZlX");

var $2LUd1 = parcelRequire("2LUd1");

var $1MPs5 = parcelRequire("1MPs5");

var $2hf1V = parcelRequire("2hf1V");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");
parcelRequire("81g6h");
const $95b5693500051ee8$export$9277d8f0e9272940 = ({ patient: patient, complianceSkeletonProps: complianceSkeletonProps })=>{
    const { id: id, disease: disease, name: name, analyticsId: analyticsId, compliance: compliance, lastCompletedSessionDate: lastCompletedSessionDate, globalProgramStatus: globalProgramStatus } = patient;
    const { format: format, formatPercent: formatPercent } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    const { getFormattedLastSessionDate: getFormattedLastSessionDate } = (0, $1MPs5.usePatientListingItem)();
    const { extendProgram: extendProgram } = (0, $2hf1V.useProgramActions)();
    const emptyWording = format("global.empty");
    return /*#__PURE__*/ (0, $iKObn.jsx)($95b5693500051ee8$var$FlexContainer, {
        onClick: ()=>{
            navigate((0, $lDZlX.RoutesPath).PatientDetails, {
                route: {
                    patientId: id
                },
                query: {
                    active: (0, $lDZlX.TabPatientDetails).PROGRESS_TAB
                }
            });
            (0, $bC9c0.sendAnalyticsEventViewPatientDetail)(analyticsId, (0, $bC9c0.AnalyticsProgramClickType).LIST_CLICK);
        },
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($95b5693500051ee8$var$Content, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)($95b5693500051ee8$var$KebabContainer, {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $2LUd1.PatientActionButton), {
                        patient: {
                            ...patient,
                            status: (0, $6Yxa2.PatientStatus).Registered
                        }
                    })
                }),
                /*#__PURE__*/ (0, $iKObn.jsxs)($95b5693500051ee8$var$PatientInformation, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsxs)($95b5693500051ee8$var$PatientNameContainer, {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)($95b5693500051ee8$var$PatientName, {
                                    className: "p-size-s-bold",
                                    children: name
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)($95b5693500051ee8$var$Disease, {
                                    className: "p-size-xs-semi-bold",
                                    children: disease
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $1lhQS.ProgramStatusComponent), {
                            programStatus: patient.globalProgramStatus
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)($95b5693500051ee8$var$Row, {
                            children: /*#__PURE__*/ (0, $iKObn.jsxs)((0, $9gtEr.ConditionalSkeleton), {
                                ...complianceSkeletonProps,
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                        children: format("home.patientsListing.globalComplianceRowMobile")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                        className: "p-size-s-bold",
                                        children: (0, $lTdpc.isNotNil)(compliance) ? formatPercent(compliance) : emptyWording
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsxs)($95b5693500051ee8$var$Row, {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                    children: format("home.patientsListing.lastSessionCompletedRowMobile")
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                    className: "p-size-s-bold",
                                    children: (0, $lTdpc.isNotNil)(lastCompletedSessionDate) ? getFormattedLastSessionDate(lastCompletedSessionDate) : emptyWording
                                })
                            ]
                        }),
                        (0, $5stJo.isGlobalProgramStatusExtendable)(globalProgramStatus) && /*#__PURE__*/ (0, $iKObn.jsx)($95b5693500051ee8$var$ExtendButton, {
                            label: format("home.registeredPatientsListing.extendColumn.button"),
                            onClick: (event)=>{
                                event.stopPropagation();
                                extendProgram((0, $bC9c0.AnalyticsProgramLocation).HOME, patient.id, patient.analyticsId, globalProgramStatus.programId, globalProgramStatus.type);
                            },
                            uiStyle: "secondary"
                        })
                    ]
                })
            ]
        })
    });
};
const $95b5693500051ee8$var$FlexContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")};
	padding: 24px 32px 24px 24px;
	border-bottom: 1px solid ${(0, $kKnoQ.colors).grey25};
	cursor: pointer;
	position: relative;
`;
const $95b5693500051ee8$var$Content = (0, $5UMQ1.default).div`
	overflow: hidden;
	width: 100%;
`;
const $95b5693500051ee8$var$PatientInformation = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(8)}
`;
const $95b5693500051ee8$var$PatientNameContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)()}
	overflow: hidden;
	align-self: stretch;
	text-overflow: ellipsis;
	margin-bottom: 10px;
`;
const $95b5693500051ee8$var$PatientName = (0, $5UMQ1.default).p`
	overflow: hidden;
	align-self: stretch;
	text-overflow: ellipsis;
`;
const $95b5693500051ee8$var$KebabContainer = (0, $5UMQ1.default).div`
	position: absolute;
	right: 8px;
	top: 8px;
`;
const $95b5693500051ee8$var$Row = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8)}
`;
const $95b5693500051ee8$var$Disease = (0, $5UMQ1.default).span`
	color: ${(0, $kKnoQ.colors).grey} !important;
	margin-top: 4px;
`;
const $95b5693500051ee8$var$ExtendButton = (0, $5UMQ1.default)((0, $dhb7H.Button))`
	margin-top: 8px;
`;

});
parcelRegister("1MPs5", function(module, exports) {

$parcel$export(module.exports, "usePatientListingItem", () => $dfb1b8b3cef375f6$export$9df735fbf5af831);

var $1eHG3 = parcelRequire("1eHG3");

var $kXaMn = parcelRequire("kXaMn");

var $81g6h = parcelRequire("81g6h");
const $dfb1b8b3cef375f6$export$9df735fbf5af831 = ()=>{
    const { formatDateRelative: formatDateRelative, formatDateMed: formatDateMed } = (0, $1eHG3.useI18n)();
    const getFormattedLastSessionDate = (0, $81g6h.useCallback)((date)=>{
        if ((0, $kXaMn.computeDiffInDays)(date, (0, $kXaMn.now)()) < (0, $kXaMn.ONE_MONTH_IN_DAYS)) return formatDateRelative(date);
        else return formatDateMed(date);
    }, [
        formatDateRelative,
        formatDateMed
    ]);
    return {
        getFormattedLastSessionDate: getFormattedLastSessionDate
    };
};

});

parcelRegister("2hf1V", function(module, exports) {

$parcel$export(module.exports, "useProgramActions", () => $150066a99f7ce1f3$export$93129f88228ab522);

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $bC9c0 = parcelRequire("bC9c0");

var $5SzTW = parcelRequire("5SzTW");

var $9XVwj = parcelRequire("9XVwj");

var $lDZlX = parcelRequire("lDZlX");

var $ghvAC = parcelRequire("ghvAC");

var $lTdpc = parcelRequire("lTdpc");

var $4hOw0 = parcelRequire("4hOw0");

var $81g6h = parcelRequire("81g6h");
function $150066a99f7ce1f3$export$93129f88228ab522() {
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    const [duplicateAsDraftProgram, duplicateAsDraftLoading] = (0, $grmoS.useAsyncOperation)(async ({ patientId: patientId, programId: programId, programName: programName, onSuccess: onSuccess })=>{
        try {
            const newProgramId = await (0, $ghfIB.programOperationsManager).performDuplicateAsDraftOperation(patientId, programId);
            showToast(format("global.duplicateProgramOperation.successToast.title"), format("global.duplicateProgramOperation.successToast.message", {
                program: programName
            }), "success");
            (0, $bC9c0.sendAnalyticsEventDuplicateProgramAsDraft)(programId);
            onSuccess?.(newProgramId);
        } catch (e) {
            console.error(e);
            showToast(format("global.errorToast.title"), format("global.duplicateProgramOperation.errorToast.message"));
        }
    }, {
        deps: [
            format,
            showToast
        ],
        minimumDuration: 3000
    });
    const [duplicateAsTemplateProgram, duplicateAsTemplateLoading] = (0, $grmoS.useAsyncOperation)(async ({ patientId: patientId, programId: programId, templateName: templateName })=>{
        const newProgramId = await (0, $ghfIB.programOperationsManager).performTransformToTemplateOperation(patientId, programId, templateName);
        (0, $bC9c0.sendAnalyticsEventDuplicateProgramAsTemplate)(programId);
        navigate((0, $lDZlX.RoutesPath).ProgramList, {
            state: {
                newProgramId: newProgramId
            },
            query: {
                active: (0, $ghvAC.ProgramListTabNames).Templates
            }
        });
        showToast(format("global.transformProgramToTemplateOperation.successToast.title"), format("global.transformProgramToTemplateOperation.successToast.message", {
            template: templateName
        }), "success");
    }, {
        deps: [
            format,
            showToast
        ],
        minimumDuration: 3000
    });
    const extendProgram = (0, $81g6h.useCallback)((location, patientId, patientAnalyticsId, programId, globalProgramStatus)=>{
        if ((0, $lTdpc.isNil)(programId)) throw new Error("programId undefined");
        (0, $bC9c0.sendAnalyticsEventExtendProgram)(location, patientAnalyticsId, programId);
        navigate((0, $lDZlX.RoutesPath).ProgramBuilder, {
            route: {
                patientId: patientId
            },
            query: {
                programId: programId,
                openScheduleModal: (0, $4hOw0.booleanToString)(globalProgramStatus === (0, $5SzTW.GlobalProgramStatusType).EndingSoonProgramWithNoNext)
            }
        });
    }, [
        navigate
    ]);
    const loading = duplicateAsDraftLoading || duplicateAsTemplateLoading;
    return {
        duplicateAsDraftProgram: duplicateAsDraftProgram,
        duplicateAsTemplateProgram: duplicateAsTemplateProgram,
        loading: loading,
        extendProgram: extendProgram
    };
}

});
parcelRegister("ghvAC", function(module, exports) {

$parcel$export(module.exports, "ProgramListTabNames", () => $b2f21d74c48e2d89$export$ad72473528b5059b);
$parcel$export(module.exports, "Tabs", () => $b2f21d74c48e2d89$export$b2539bed5023c21c);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $1IWnK = parcelRequire("1IWnK");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");

var $bY9wC = parcelRequire("bY9wC");

var $iV9Zw = parcelRequire("iV9Zw");

var $grmoS = parcelRequire("grmoS");

var $5kXMA = parcelRequire("5kXMA");

var $ghfIB = parcelRequire("ghfIB");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $1IlhR = parcelRequire("1IlhR");

var $28f8Y = parcelRequire("28f8Y");

var $kLgU7 = parcelRequire("kLgU7");

var $8zvzh = parcelRequire("8zvzh");

var $5lSKR = parcelRequire("5lSKR");

var $4tuK0 = parcelRequire("4tuK0");

var $3f6gX = parcelRequire("3f6gX");

var $2yeOW = parcelRequire("2yeOW");

var $6kyF0 = parcelRequire("6kyF0");

var $29TYN = parcelRequire("29TYN");
var $b2f21d74c48e2d89$export$ad72473528b5059b;
(function(ProgramListTabNames) {
    ProgramListTabNames["Programs"] = "programs";
    ProgramListTabNames["Templates"] = "templates";
})($b2f21d74c48e2d89$export$ad72473528b5059b || ($b2f21d74c48e2d89$export$ad72473528b5059b = {}));
const $b2f21d74c48e2d89$var$tabIndices = [
    "programs",
    "templates"
];
const $b2f21d74c48e2d89$export$b2539bed5023c21c = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { updateHistory: updateHistory } = (0, $iV9Zw.useHistory)();
    const { isMobile: isMobile } = (0, $5kXMA.useDimensions)();
    const { active: active } = (0, $8zvzh.useQueryParams)();
    const [activeTab, setActiveTab] = (0, $81g6h.useState)((0, $kLgU7.indexOfOrDefault)($b2f21d74c48e2d89$var$tabIndices, active, "programs"));
    const programs = (0, $1IWnK.useObservable)((0, $ghfIB.patientProgramsManager).allPatientsPrograms);
    const { programTotalCount: programTotalCount } = (0, $4tuK0.useProgramFilters)(programs);
    const templates = (0, $1IWnK.useObservable)((0, $ghfIB.templateManager).templateItems) ?? [];
    const { templateTotalCount: templateTotalCount } = (0, $3f6gX.useTemplateFilters)(templates);
    const listProgramsTemplates = (0, $81g6h.useCallback)(async ()=>await Promise.all([
            (0, $ghfIB.patientProgramsManager).fetchAllPatientsPrograms(),
            (0, $ghfIB.templateManager).fetchAllTemplates()
        ]), []);
    const [fetchData, loading, errorLoading] = (0, $grmoS.useAsyncOperation)(listProgramsTemplates, {
        initialLoadingState: true
    });
    (0, $81g6h.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    const selectTab = (tabIndex)=>{
        setActiveTab(tabIndex);
    };
    const headerStyle = {
        width: isMobile ? "100%" : "unset"
    };
    if (loading) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {});
    if (errorLoading) return /*#__PURE__*/ (0, $iKObn.jsx)($b2f21d74c48e2d89$var$ErrorContainer, {
        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
            style: {
                width: "100%",
                padding: "72px 32px"
            },
            titleStyle: {
                fontSize: "1.5rem"
            },
            description: format("templateListing.error.description"),
            onRefresh: async ()=>{
                await fetchData();
            }
        })
    });
    if (programTotalCount === 0 && templateTotalCount === 0) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $29TYN.EmptyContainer), {
        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $5lSKR.EmptyTabs), {})
    });
    return /*#__PURE__*/ (0, $iKObn.jsxs)($b2f21d74c48e2d89$var$StyledTabView, {
        activeIndex: activeTab,
        onTabChange: (e)=>{
            updateHistory({
                active: $b2f21d74c48e2d89$var$tabIndices[e.index]
            });
            selectTab(e.index);
        },
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $bY9wC.TabPanel), {
                headerStyle: headerStyle,
                header: format("templateListing.programs.tabName", {
                    count: programTotalCount
                }),
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $2yeOW.ProgramsTab), {
                    selectTab: (tabName)=>selectTab($b2f21d74c48e2d89$var$tabIndices.indexOf(tabName))
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $bY9wC.TabPanel), {
                headerStyle: headerStyle,
                header: format("templateListing.templates.tabName", {
                    count: templateTotalCount
                }),
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $6kyF0.TemplatesTab), {})
            })
        ]
    });
};
const $b2f21d74c48e2d89$var$ErrorContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "stretch")};
	flex-grow: 1;
`;
const $b2f21d74c48e2d89$var$StyledTabView = (0, $5UMQ1.default)((0, $bY9wC.TabView))`
	.p-tabview-panels {
		padding: 0;
	}

	.p-tabview-nav {
		@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
			background-color: ${(0, $kKnoQ.colors).primaryBackground} !important;
		}
	}

	.p-tabview-nav-link {
		@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
			background-color: ${(0, $kKnoQ.colors).primaryBackground} !important;
			justify-content: center !important;
		}
	}
`;

});
parcelRegister("bY9wC", function(module, exports) {

$parcel$export(module.exports, "TabPanel", () => $8b6cafd1edd6833d$export$3d96ec278d3efce4);
$parcel$export(module.exports, "TabView", () => $8b6cafd1edd6833d$export$44c45b2b7f09d2a6);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $6mIkN = parcelRequire("6mIkN");

var $gbrlA = parcelRequire("gbrlA");

var $4vsYR = parcelRequire("4vsYR");

var $9rbaG = parcelRequire("9rbaG");

var $cfkGk = parcelRequire("cfkGk");
"use client";
function $8b6cafd1edd6833d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8b6cafd1edd6833d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8b6cafd1edd6833d$var$_arrayLikeToArray(arr);
}
function $8b6cafd1edd6833d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8b6cafd1edd6833d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8b6cafd1edd6833d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8b6cafd1edd6833d$var$_arrayLikeToArray(o, minLen);
}
function $8b6cafd1edd6833d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8b6cafd1edd6833d$var$_toConsumableArray(arr) {
    return $8b6cafd1edd6833d$var$_arrayWithoutHoles(arr) || $8b6cafd1edd6833d$var$_iterableToArray(arr) || $8b6cafd1edd6833d$var$_unsupportedIterableToArray(arr) || $8b6cafd1edd6833d$var$_nonIterableSpread();
}
function $8b6cafd1edd6833d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8b6cafd1edd6833d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8b6cafd1edd6833d$var$_typeof(o);
}
function $8b6cafd1edd6833d$var$_toPrimitive(input, hint) {
    if ($8b6cafd1edd6833d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8b6cafd1edd6833d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8b6cafd1edd6833d$var$_toPropertyKey(arg) {
    var key = $8b6cafd1edd6833d$var$_toPrimitive(arg, "string");
    return $8b6cafd1edd6833d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8b6cafd1edd6833d$var$_defineProperty(obj, key, value) {
    key = $8b6cafd1edd6833d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8b6cafd1edd6833d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8b6cafd1edd6833d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $8b6cafd1edd6833d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8b6cafd1edd6833d$var$_slicedToArray(arr, i) {
    return $8b6cafd1edd6833d$var$_arrayWithHoles(arr) || $8b6cafd1edd6833d$var$_iterableToArrayLimit(arr, i) || $8b6cafd1edd6833d$var$_unsupportedIterableToArray(arr, i) || $8b6cafd1edd6833d$var$_nonIterableRest();
}
function $8b6cafd1edd6833d$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8b6cafd1edd6833d$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8b6cafd1edd6833d$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $8b6cafd1edd6833d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8b6cafd1edd6833d$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8b6cafd1edd6833d$var$classes = {
    navcontent: "p-tabview-nav-content",
    nav: "p-tabview-nav",
    inkbar: "p-tabview-ink-bar",
    panelcontainer: function panelcontainer(_ref) {
        var props = _ref.props;
        return (0, $cfkGk.classNames)("p-tabview-panels", props.panelContainerClassName);
    },
    prevbutton: "p-tabview-nav-prev p-tabview-nav-btn p-link",
    nextbutton: "p-tabview-nav-next p-tabview-nav-btn p-link",
    root: function root(_ref2) {
        var props = _ref2.props;
        return (0, $cfkGk.classNames)("p-tabview p-component", {
            "p-tabview-scrollable": props.scrollable
        });
    },
    navcontainer: "p-tabview-nav-container",
    tab: {
        header: function header(_ref3) {
            var selected = _ref3.selected, disabled = _ref3.disabled, headerClassName = _ref3.headerClassName, _className = _ref3._className;
            return (0, $cfkGk.classNames)("p-unselectable-text", {
                "p-tabview-selected p-highlight": selected,
                "p-disabled": disabled
            }, headerClassName, _className);
        },
        headertitle: "p-tabview-title",
        headeraction: "p-tabview-nav-link",
        closeIcon: "p-tabview-close",
        content: function content(_ref4) {
            var props = _ref4.props, selected = _ref4.selected, getTabProp = _ref4.getTabProp, tab = _ref4.tab, isSelected = _ref4.isSelected, shouldUseTab = _ref4.shouldUseTab, index = _ref4.index;
            return shouldUseTab(tab, index) && (!props.renderActiveOnly || isSelected(index)) ? (0, $cfkGk.classNames)(getTabProp(tab, "contentClassName"), getTabProp(tab, "className"), "p-tabview-panel", {
                "p-hidden": !selected
            }) : undefined;
        }
    }
};
var $8b6cafd1edd6833d$var$inlineStyles = {
    tab: {
        header: function header(_ref5) {
            var headerStyle = _ref5.headerStyle, _style = _ref5._style;
            return $8b6cafd1edd6833d$var$_objectSpread$1($8b6cafd1edd6833d$var$_objectSpread$1({}, headerStyle || {}), _style || {});
        },
        content: function content(_ref6) {
            var props = _ref6.props, getTabProp = _ref6.getTabProp, tab = _ref6.tab, isSelected = _ref6.isSelected, shouldUseTab = _ref6.shouldUseTab, index = _ref6.index;
            return shouldUseTab(tab, index) && (!props.renderActiveOnly || isSelected(index)) ? $8b6cafd1edd6833d$var$_objectSpread$1($8b6cafd1edd6833d$var$_objectSpread$1({}, getTabProp(tab, "contentStyle") || {}), getTabProp(tab, "style") || {}) : undefined;
        }
    }
};
var $8b6cafd1edd6833d$var$TabViewBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "TabView",
        id: null,
        activeIndex: 0,
        className: null,
        onBeforeTabChange: null,
        onBeforeTabClose: null,
        onTabChange: null,
        onTabClose: null,
        panelContainerClassName: null,
        panelContainerStyle: null,
        renderActiveOnly: true,
        scrollable: false,
        style: null,
        children: undefined
    },
    css: {
        classes: $8b6cafd1edd6833d$var$classes,
        inlineStyles: $8b6cafd1edd6833d$var$inlineStyles
    }
});
var $8b6cafd1edd6833d$var$TabPanelBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "TabPanel",
        children: undefined,
        className: null,
        closable: false,
        closeIcon: null,
        contentClassName: null,
        contentStyle: null,
        disabled: false,
        header: null,
        headerClassName: null,
        headerStyle: null,
        headerTemplate: null,
        leftIcon: null,
        nextButton: null,
        prevButton: null,
        rightIcon: null,
        style: null,
        visible: true
    },
    getCProp: function getCProp(tab, name) {
        return (0, $cfkGk.ObjectUtils).getComponentProp(tab, name, $8b6cafd1edd6833d$var$TabPanelBase.defaultProps);
    },
    getCProps: function getCProps(tab) {
        return (0, $cfkGk.ObjectUtils).getComponentProps(tab, $8b6cafd1edd6833d$var$TabPanelBase.defaultProps);
    },
    getCOtherProps: function getCOtherProps(tab) {
        return (0, $cfkGk.ObjectUtils).getComponentDiffProps(tab, $8b6cafd1edd6833d$var$TabPanelBase.defaultProps);
    }
});
function $8b6cafd1edd6833d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8b6cafd1edd6833d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8b6cafd1edd6833d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8b6cafd1edd6833d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8b6cafd1edd6833d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8b6cafd1edd6833d$export$3d96ec278d3efce4 = function TabPanel() {};
var $8b6cafd1edd6833d$export$44c45b2b7f09d2a6 = /*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $8b6cafd1edd6833d$var$TabViewBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState(props.id), _React$useState2 = $8b6cafd1edd6833d$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0], setIdState = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(true), _React$useState4 = $8b6cafd1edd6833d$var$_slicedToArray(_React$useState3, 2), backwardIsDisabledState = _React$useState4[0], setBackwardIsDisabledState = _React$useState4[1];
    var _React$useState5 = $81g6h.useState(false), _React$useState6 = $8b6cafd1edd6833d$var$_slicedToArray(_React$useState5, 2), forwardIsDisabledState = _React$useState6[0], setForwardIsDisabledState = _React$useState6[1];
    var _React$useState7 = $81g6h.useState([]), _React$useState8 = $8b6cafd1edd6833d$var$_slicedToArray(_React$useState7, 2), hiddenTabsState = _React$useState8[0], setHiddenTabsState = _React$useState8[1];
    var _React$useState9 = $81g6h.useState(props.activeIndex), _React$useState10 = $8b6cafd1edd6833d$var$_slicedToArray(_React$useState9, 2), activeIndexState = _React$useState10[0], setActiveIndexState = _React$useState10[1];
    var elementRef = $81g6h.useRef(null);
    var contentRef = $81g6h.useRef(null);
    var navRef = $81g6h.useRef(null);
    var inkbarRef = $81g6h.useRef(null);
    var prevBtnRef = $81g6h.useRef(null);
    var nextBtnRef = $81g6h.useRef(null);
    var tabsRef = $81g6h.useRef({});
    var activeIndex = props.onTabChange ? props.activeIndex : activeIndexState;
    var count = $81g6h.Children.count(props.children);
    var metaData = {
        props: props,
        state: {
            id: idState,
            isPrevButtonDisabled: backwardIsDisabledState,
            isNextButtonDisabled: forwardIsDisabledState,
            hiddenTabsState: hiddenTabsState,
            activeIndex: activeIndexState
        }
    };
    var _TabViewBase$setMetaD = $8b6cafd1edd6833d$var$TabViewBase.setMetaData($8b6cafd1edd6833d$var$_objectSpread({}, metaData)), ptm = _TabViewBase$setMetaD.ptm, ptmo = _TabViewBase$setMetaD.ptmo, cx = _TabViewBase$setMetaD.cx, sx = _TabViewBase$setMetaD.sx, isUnstyled = _TabViewBase$setMetaD.isUnstyled;
    (0, $4gQLd.useHandleStyle)($8b6cafd1edd6833d$var$TabViewBase.css.styles, isUnstyled, {
        name: "tabview"
    });
    var getTabPT = function getTabPT(tab, key, index) {
        var tabMetaData = {
            props: tab.props,
            parent: metaData,
            context: {
                index: index,
                count: count,
                first: index === 0,
                last: index === count - 1,
                active: index == activeIndexState,
                disabled: getTabProp(tab, "disabled")
            }
        };
        return mergeProps(ptm("tab.".concat(key), {
            tab: tabMetaData
        }), ptm("tabpanel.".concat(key), {
            tabpanel: tabMetaData
        }), ptm("tabpanel.".concat(key), tabMetaData), ptmo(getTabProp(tab, "pt"), key, tabMetaData));
    };
    var isSelected = function isSelected(index) {
        return index === activeIndex;
    };
    var getTabProp = function getTabProp(tab, name) {
        return $8b6cafd1edd6833d$var$TabPanelBase.getCProp(tab, name);
    };
    var shouldUseTab = function shouldUseTab(tab) {
        return tab && getTabProp(tab, "visible") && (0, $cfkGk.ObjectUtils).isValidChild(tab, "TabPanel") && hiddenTabsState.every(function(_i) {
            return _i !== tab.key;
        });
    };
    var findVisibleActiveTab = function findVisibleActiveTab(i) {
        var tabsInfo = $81g6h.Children.map(props.children, function(tab, index) {
            if (shouldUseTab(tab)) return {
                tab: tab,
                index: index
            };
        });
        return tabsInfo.find(function(_ref) {
            var tab = _ref.tab, index = _ref.index;
            return !getTabProp(tab, "disabled") && index >= i;
        }) || tabsInfo.reverse().find(function(_ref2) {
            var tab = _ref2.tab, index = _ref2.index;
            return !getTabProp(tab, "disabled") && i > index;
        });
    };
    var onTabHeaderClose = function onTabHeaderClose(event, index) {
        event.preventDefault();
        var onBeforeTabClose = props.onBeforeTabClose, onTabClose = props.onTabClose, children = props.children;
        var key = children[index].key;
        // give caller a chance to stop the selection
        if (onBeforeTabClose && onBeforeTabClose({
            originalEvent: event,
            index: index
        }) === false) return;
        setHiddenTabsState([].concat($8b6cafd1edd6833d$var$_toConsumableArray(hiddenTabsState), [
            key
        ]));
        if (onTabClose) onTabClose({
            originalEvent: event,
            index: index
        });
    };
    var onTabHeaderClick = function onTabHeaderClick(event, tab, index) {
        changeActiveIndex(event, tab, index);
    };
    var changeActiveIndex = function changeActiveIndex(event, tab, index) {
        if (event) event.preventDefault();
        if (!getTabProp(tab, "disabled")) {
            // give caller a chance to stop the selection
            if (props.onBeforeTabChange && props.onBeforeTabChange({
                originalEvent: event,
                index: index
            }) === false) return;
            if (props.onTabChange) props.onTabChange({
                originalEvent: event,
                index: index
            });
            else setActiveIndexState(index);
        }
        updateScrollBar({
            index: index
        });
    };
    var _onKeyDown = function onKeyDown(event, tab, index) {
        switch(event.code){
            case "ArrowLeft":
                onTabArrowLeftKey(event);
                break;
            case "ArrowRight":
                onTabArrowRightKey(event);
                break;
            case "Home":
                onTabHomeKey(event);
                break;
            case "End":
                onTabEndKey(event);
                break;
            case "PageDown":
                onPageDownKey(event);
                break;
            case "PageUp":
                onPageUpKey(event);
                break;
            case "Enter":
            case "NumpadEnter":
            case "Space":
                onTabEnterKey(event, tab, index);
                break;
        }
    };
    var onTabArrowRightKey = function onTabArrowRightKey(event) {
        var nextHeaderAction = findNextHeaderAction(event.target.parentElement);
        nextHeaderAction ? changeFocusedTab(nextHeaderAction) : onTabHomeKey(event);
        event.preventDefault();
    };
    var onTabArrowLeftKey = function onTabArrowLeftKey(event) {
        var prevHeaderAction = findPrevHeaderAction(event.target.parentElement);
        prevHeaderAction ? changeFocusedTab(prevHeaderAction) : onTabEndKey(event);
        event.preventDefault();
    };
    var onTabHomeKey = function onTabHomeKey(event) {
        var firstHeaderAction = findFirstHeaderAction();
        changeFocusedTab(firstHeaderAction);
        event.preventDefault();
    };
    var onTabEndKey = function onTabEndKey(event) {
        var lastHeaderAction = findLastHeaderAction();
        changeFocusedTab(lastHeaderAction);
        event.preventDefault();
    };
    var onPageDownKey = function onPageDownKey(event) {
        updateScrollBar({
            index: $81g6h.Children.count(props.children) - 1
        });
        event.preventDefault();
    };
    var onPageUpKey = function onPageUpKey(event) {
        updateScrollBar({
            index: 0
        });
        event.preventDefault();
    };
    var onTabEnterKey = function onTabEnterKey(event, tab, index) {
        changeActiveIndex(event, tab, index);
        event.preventDefault();
    };
    var findNextHeaderAction = function findNextHeaderAction(tabElement) {
        var selfCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var headerElement = selfCheck ? tabElement : tabElement.nextElementSibling;
        return headerElement ? (0, $cfkGk.DomHandler).getAttribute(headerElement, "data-p-disabled") || (0, $cfkGk.DomHandler).getAttribute(headerElement, "data-pc-section") === "inkbar" ? findNextHeaderAction(headerElement) : (0, $cfkGk.DomHandler).findSingle(headerElement, '[data-pc-section="headeraction"]') : null;
    };
    var findPrevHeaderAction = function findPrevHeaderAction(tabElement) {
        var selfCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var headerElement = selfCheck ? tabElement : tabElement.previousElementSibling;
        return headerElement ? (0, $cfkGk.DomHandler).getAttribute(headerElement, "data-p-disabled") || (0, $cfkGk.DomHandler).getAttribute(headerElement, "data-pc-section") === "inkbar" ? findPrevHeaderAction(headerElement) : (0, $cfkGk.DomHandler).findSingle(headerElement, '[data-pc-section="headeraction"]') : null;
    };
    var findFirstHeaderAction = function findFirstHeaderAction() {
        return findNextHeaderAction(navRef.current.firstElementChild, true);
    };
    var findLastHeaderAction = function findLastHeaderAction() {
        return findPrevHeaderAction(navRef.current.lastElementChild, true);
    };
    var changeFocusedTab = function changeFocusedTab(element) {
        if (element) {
            (0, $cfkGk.DomHandler).focus(element);
            updateScrollBar({
                element: element
            });
        }
    };
    var updateInkBar = function updateInkBar() {
        var tabHeader = tabsRef.current["tab_".concat(activeIndex)];
        inkbarRef.current.style.width = (0, $cfkGk.DomHandler).getWidth(tabHeader) + "px";
        inkbarRef.current.style.left = (0, $cfkGk.DomHandler).getOffset(tabHeader).left - (0, $cfkGk.DomHandler).getOffset(navRef.current).left + "px";
    };
    var updateScrollBar = function updateScrollBar(_ref3) {
        var index = _ref3.index, element = _ref3.element;
        var tabHeader = element || tabsRef.current["tab_".concat(index)];
        if (tabHeader && tabHeader.scrollIntoView) tabHeader.scrollIntoView({
            block: "nearest"
        });
    };
    var updateButtonState = function updateButtonState() {
        var _contentRef$current = contentRef.current, scrollLeft = _contentRef$current.scrollLeft, scrollWidth = _contentRef$current.scrollWidth;
        var width = (0, $cfkGk.DomHandler).getWidth(contentRef.current);
        setBackwardIsDisabledState(scrollLeft === 0);
        setForwardIsDisabledState(parseInt(scrollLeft) === scrollWidth - width);
    };
    var onScroll = function onScroll(event) {
        props.scrollable && updateButtonState();
        event.preventDefault();
    };
    var getVisibleButtonWidths = function getVisibleButtonWidths() {
        return [
            prevBtnRef.current,
            nextBtnRef.current
        ].reduce(function(acc, el) {
            return el ? acc + (0, $cfkGk.DomHandler).getWidth(el) : acc;
        }, 0);
    };
    var navBackward = function navBackward() {
        var width = (0, $cfkGk.DomHandler).getWidth(contentRef.current) - getVisibleButtonWidths();
        var pos = contentRef.current.scrollLeft - width;
        contentRef.current.scrollLeft = pos <= 0 ? 0 : pos;
    };
    var navForward = function navForward() {
        var width = (0, $cfkGk.DomHandler).getWidth(contentRef.current) - getVisibleButtonWidths();
        var pos = contentRef.current.scrollLeft + width;
        var lastPos = contentRef.current.scrollWidth - width;
        contentRef.current.scrollLeft = pos >= lastPos ? lastPos : pos;
    };
    var reset = function reset() {
        setBackwardIsDisabledState(true);
        setForwardIsDisabledState(false);
        setHiddenTabsState([]);
        if (props.onTabChange) props.onTabChange({
            index: activeIndex
        });
        else setActiveIndexState(props.activeIndex);
    };
    $81g6h.useEffect(function() {
        updateInkBar();
        updateButtonState();
    });
    (0, $l2NC0.useMountEffect)(function() {
        if (!idState) setIdState((0, $cfkGk.UniqueComponentId)());
    });
    (0, $l2NC0.useUpdateEffect)(function() {
        if ((0, $cfkGk.ObjectUtils).isNotEmpty(hiddenTabsState)) {
            var tabInfo = findVisibleActiveTab(hiddenTabsState[hiddenTabsState.length - 1]);
            tabInfo && onTabHeaderClick(null, tabInfo.tab, tabInfo.index);
        }
    }, [
        hiddenTabsState
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (props.activeIndex !== activeIndexState) updateScrollBar({
            index: props.activeIndex
        });
    }, [
        props.activeIndex
    ]);
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            reset: reset,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var createTabHeader = function createTabHeader(tab, index) {
        var selected = isSelected(index);
        var _TabPanelBase$getCPro = $8b6cafd1edd6833d$var$TabPanelBase.getCProps(tab), headerStyle = _TabPanelBase$getCPro.headerStyle, headerClassName = _TabPanelBase$getCPro.headerClassName, _style = _TabPanelBase$getCPro.style, _className = _TabPanelBase$getCPro.className, disabled = _TabPanelBase$getCPro.disabled, leftIcon = _TabPanelBase$getCPro.leftIcon, rightIcon = _TabPanelBase$getCPro.rightIcon, header = _TabPanelBase$getCPro.header, headerTemplate = _TabPanelBase$getCPro.headerTemplate, closable = _TabPanelBase$getCPro.closable, closeIcon = _TabPanelBase$getCPro.closeIcon;
        var headerId = idState + "_header_" + index;
        var ariaControls = idState + index + "_content";
        var tabIndex = disabled || !selected ? -1 : 0;
        var leftIconElement = leftIcon && (0, $cfkGk.IconUtils).getJSXIcon(leftIcon, undefined, {
            props: props
        });
        var headerTitleProps = mergeProps({
            className: cx("tab.headertitle")
        }, getTabPT(tab, "headertitle", index));
        var titleElement = /*#__PURE__*/ $81g6h.createElement("span", headerTitleProps, header);
        var rightIconElement = rightIcon && (0, $cfkGk.IconUtils).getJSXIcon(rightIcon, undefined, {
            props: props
        });
        var closeIconProps = mergeProps({
            className: cx("tab.closeIcon"),
            onClick: function onClick(e) {
                return onTabHeaderClose(e, index);
            }
        }, getTabPT(tab, "closeIcon", index));
        var icon = closeIcon || /*#__PURE__*/ $81g6h.createElement((0, $4vsYR.TimesIcon), closeIconProps);
        var closableIconElement = closable ? (0, $cfkGk.IconUtils).getJSXIcon(icon, $8b6cafd1edd6833d$var$_objectSpread({}, closeIconProps), {
            props: props
        }) : null;
        var headerActionProps = mergeProps({
            id: headerId,
            role: "tab",
            className: cx("tab.headeraction"),
            tabIndex: tabIndex,
            "aria-controls": ariaControls,
            "aria-selected": selected,
            "aria-disabled": disabled,
            onClick: function onClick(e) {
                return onTabHeaderClick(e, tab, index);
            },
            onKeyDown: function onKeyDown(e) {
                return _onKeyDown(e, tab, index);
            }
        }, getTabPT(tab, "headeraction", index));
        var content = /*#__PURE__*/ // eslint-disable /
        $81g6h.createElement("a", headerActionProps, leftIconElement, titleElement, rightIconElement, closableIconElement, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
        if (headerTemplate) {
            var defaultContentOptions = {
                className: "p-tabview-nav-link",
                titleClassName: "p-tabview-title",
                onClick: function onClick(e) {
                    return onTabHeaderClick(e, tab, index);
                },
                onKeyDown: function onKeyDown(e) {
                    return _onKeyDown(e, tab, index);
                },
                leftIconElement: leftIconElement,
                titleElement: titleElement,
                rightIconElement: rightIconElement,
                element: content,
                props: props,
                index: index,
                selected: selected,
                ariaControls: ariaControls
            };
            content = (0, $cfkGk.ObjectUtils).getJSXElement(headerTemplate, defaultContentOptions);
        }
        var headerProps = mergeProps({
            ref: function ref(el) {
                return tabsRef.current["tab_".concat(index)] = el;
            },
            className: cx("tab.header", {
                selected: selected,
                disabled: disabled,
                headerClassName: headerClassName,
                _className: _className
            }),
            style: sx("tab.header", {
                headerStyle: headerStyle,
                _style: _style
            }),
            role: "presentation"
        }, getTabPT(tab, "root", index), getTabPT(tab, "header", index));
        return /*#__PURE__*/ $81g6h.createElement("li", headerProps, content);
    };
    var createTabHeaders = function createTabHeaders() {
        return $81g6h.Children.map(props.children, function(tab, index) {
            if (shouldUseTab(tab)) return createTabHeader(tab, index);
        });
    };
    var createNavigator = function createNavigator() {
        var headers = createTabHeaders();
        var navContentProps = mergeProps({
            id: idState + "_navcontent",
            ref: contentRef,
            className: cx("navcontent"),
            style: props.style,
            onScroll: onScroll
        }, ptm("navcontent"));
        var navProps = mergeProps({
            ref: navRef,
            className: cx("nav"),
            role: "tablist"
        }, ptm("nav"));
        var inkbarProps = mergeProps({
            ref: inkbarRef,
            "aria-hidden": "true",
            role: "presentation",
            className: cx("inkbar")
        }, ptm("inkbar"));
        return /*#__PURE__*/ $81g6h.createElement("div", navContentProps, /*#__PURE__*/ $81g6h.createElement("ul", navProps, headers, /*#__PURE__*/ $81g6h.createElement("li", inkbarProps)));
    };
    var createContent = function createContent() {
        var panelContainerProps = mergeProps({
            className: cx("panelcontainer"),
            style: props.panelContainerStyle
        }, ptm("panelcontainer"));
        var contents = $81g6h.Children.map(props.children, function(tab, index) {
            if (shouldUseTab(tab) && (!props.renderActiveOnly || isSelected(index))) {
                var selected = isSelected(index);
                var contentId = idState + index + "_content";
                var ariaLabelledBy = idState + "_header_" + index;
                var contentProps = mergeProps({
                    id: contentId,
                    className: cx("tab.content", {
                        props: props,
                        selected: selected,
                        getTabProp: getTabProp,
                        tab: tab,
                        isSelected: isSelected,
                        shouldUseTab: shouldUseTab,
                        index: index
                    }),
                    style: sx("tab.content", {
                        props: props,
                        getTabProp: getTabProp,
                        tab: tab,
                        isSelected: isSelected,
                        shouldUseTab: shouldUseTab,
                        index: index
                    }),
                    role: "tabpanel",
                    "aria-labelledby": ariaLabelledBy
                }, $8b6cafd1edd6833d$var$TabPanelBase.getCOtherProps(tab), getTabPT(tab, "root", index), getTabPT(tab, "content", index));
                return /*#__PURE__*/ $81g6h.createElement("div", contentProps, !props.renderActiveOnly ? getTabProp(tab, "children") : selected && getTabProp(tab, "children"));
            }
        });
        return /*#__PURE__*/ $81g6h.createElement("div", panelContainerProps, contents);
    };
    var createPrevButton = function createPrevButton() {
        var prevIconProps = mergeProps({
            "aria-hidden": "true"
        }, ptm("previcon"));
        var icon = props.prevButton || /*#__PURE__*/ $81g6h.createElement((0, $6mIkN.ChevronLeftIcon), prevIconProps);
        var leftIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $8b6cafd1edd6833d$var$_objectSpread({}, prevIconProps), {
            props: props
        });
        var prevButtonProps = mergeProps({
            ref: prevBtnRef,
            type: "button",
            className: cx("prevbutton"),
            "aria-label": (0, $8Zwsm.ariaLabel)("previousPageLabel"),
            onClick: function onClick(e) {
                return navBackward();
            }
        }, ptm("prevbutton"));
        if (props.scrollable && !backwardIsDisabledState) return /*#__PURE__*/ $81g6h.createElement("button", prevButtonProps, leftIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
        return null;
    };
    var createNextButton = function createNextButton() {
        var nextIconProps = mergeProps({
            "aria-hidden": "true"
        }, ptm("nexticon"));
        var icon = props.nextButton || /*#__PURE__*/ $81g6h.createElement((0, $gbrlA.ChevronRightIcon), nextIconProps);
        var rightIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $8b6cafd1edd6833d$var$_objectSpread({}, nextIconProps), {
            props: props
        });
        var nextButtonProps = mergeProps({
            ref: nextBtnRef,
            type: "button",
            className: cx("nextbutton"),
            "aria-label": (0, $8Zwsm.ariaLabel)("nextPageLabel"),
            onClick: function onClick(e) {
                return navForward();
            }
        }, ptm("nextbutton"));
        if (props.scrollable && !forwardIsDisabledState) return /*#__PURE__*/ $81g6h.createElement("button", nextButtonProps, rightIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
    };
    var rootProps = mergeProps({
        id: idState,
        ref: elementRef,
        style: props.style,
        className: (0, $cfkGk.classNames)(props.className, cx("root"))
    }, $8b6cafd1edd6833d$var$TabViewBase.getOtherProps(props), ptm("root"));
    var navContainerProps = mergeProps({
        className: cx("navcontainer")
    }, ptm("navcontainer"));
    var navigator = createNavigator();
    var content = createContent();
    var prevButton = createPrevButton();
    var nextButton = createNextButton();
    return /*#__PURE__*/ $81g6h.createElement("div", rootProps, /*#__PURE__*/ $81g6h.createElement("div", navContainerProps, prevButton, navigator, nextButton), content);
});
$8b6cafd1edd6833d$export$3d96ec278d3efce4.displayName = "TabPanel";
$8b6cafd1edd6833d$export$44c45b2b7f09d2a6.displayName = "TabView";

});
parcelRegister("6mIkN", function(module, exports) {

$parcel$export(module.exports, "ChevronLeftIcon", () => $4a27300cff0218df$export$20bc5960c3c9eebb);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $4a27300cff0218df$var$_extends() {
    $4a27300cff0218df$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4a27300cff0218df$var$_extends.apply(this, arguments);
}
var $4a27300cff0218df$export$20bc5960c3c9eebb = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $4a27300cff0218df$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M9.61296 13C9.50997 13.0005 9.40792 12.9804 9.3128 12.9409C9.21767 12.9014 9.13139 12.8433 9.05902 12.7701L3.83313 7.54416C3.68634 7.39718 3.60388 7.19795 3.60388 6.99022C3.60388 6.78249 3.68634 6.58325 3.83313 6.43628L9.05902 1.21039C9.20762 1.07192 9.40416 0.996539 9.60724 1.00012C9.81032 1.00371 10.0041 1.08597 10.1477 1.22959C10.2913 1.37322 10.3736 1.56698 10.3772 1.77005C10.3808 1.97313 10.3054 2.16968 10.1669 2.31827L5.49496 6.99022L10.1669 11.6622C10.3137 11.8091 10.3962 12.0084 10.3962 12.2161C10.3962 12.4238 10.3137 12.6231 10.1669 12.7701C10.0945 12.8433 10.0083 12.9014 9.91313 12.9409C9.81801 12.9804 9.71596 13.0005 9.61296 13Z",
        fill: "currentColor"
    }));
}));
$4a27300cff0218df$export$20bc5960c3c9eebb.displayName = "ChevronLeftIcon";

});


parcelRegister("kLgU7", function(module, exports) {

$parcel$export(module.exports, "reorder", () => $8d3a745ae1fe06ba$export$fc77a6137e3f91c);
$parcel$export(module.exports, "immutableInsert", () => $8d3a745ae1fe06ba$export$25e92f6caef09279);
$parcel$export(module.exports, "move", () => $8d3a745ae1fe06ba$export$d947e5f4f4c48d48);
$parcel$export(module.exports, "offsetArray", () => $8d3a745ae1fe06ba$export$14923ec976cb57f1);
$parcel$export(module.exports, "indexOfOrDefault", () => $8d3a745ae1fe06ba$export$6164bd39adc00dff);
function $8d3a745ae1fe06ba$export$fc77a6137e3f91c(list, sourceIndex, destinationIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(sourceIndex, 1);
    result.splice(destinationIndex, 0, removed);
    return result;
}
function $8d3a745ae1fe06ba$export$25e92f6caef09279(itemToCopy, destination, destinationIndex, copyFactory) {
    const destClone = Array.from(destination);
    destClone.splice(destinationIndex, 0, copyFactory?.(itemToCopy) ?? itemToCopy);
    return destClone;
}
function $8d3a745ae1fe06ba$export$d947e5f4f4c48d48(source, destination, sourceIndex, destinationIndex) {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(sourceIndex, 1);
    destClone.splice(destinationIndex, 0, removed);
    return {
        newSource: sourceClone,
        newDestination: destClone
    };
}
const $8d3a745ae1fe06ba$export$14923ec976cb57f1 = (days, offset)=>[
        ...days.slice(offset),
        ...days.slice(0, offset)
    ];
const $8d3a745ae1fe06ba$export$6164bd39adc00dff = (array, value, defaultValue)=>{
    const index = array.indexOf(value);
    return index === -1 ? array.indexOf(defaultValue) : index;
};

});

parcelRegister("5lSKR", function(module, exports) {

$parcel$export(module.exports, "EmptyTabs", () => $dc856dbd8c96a896$export$2268c1f1d3300400);

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $5CjOe = parcelRequire("5CjOe");

var $lDZlX = parcelRequire("lDZlX");
var $dc856dbd8c96a896$var$NoProgramsIcon = function NoProgramsIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_6561_182627)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask0_6561_182627",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "10",
                        y: "4",
                        width: "45",
                        height: "58",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M47.067 61.45H18.765a7.817 7.817 0 0 1-7.818-7.818v-41.05c0-4.319 3.5-7.818 7.818-7.818h25.191A4.1 4.1 0 0 1 46.87 5.98l6.841 6.924a4.107 4.107 0 0 1 1.183 2.871v37.857c0 4.319-3.5 7.818-7.818 7.818h-.008Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask0_6561_182627)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M34.484 71.436c27.707 0 50.167-22.461 50.167-50.168s-22.46-50.167-50.167-50.167-50.168 22.46-50.168 50.167S6.777 71.436 34.484 71.436Z",
                                fill: "#1B5EC0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M68.817 2.017C75.742 15.55 70.273 36.58 54.033 45.5c-16.24 8.918-37.104 2.358-44.029-11.177C3.08 20.788 8.549-.242 24.788-9.16c16.24-8.918 37.105-2.358 44.03 11.177Z",
                                fill: "#2275F0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M74.616-1.433c4.616 9.025.819 28.972-13.617 37.576-14.437 8.612-34.052 2.622-38.668-6.395-4.617-9.026-.82-28.973 13.617-37.576C50.384-16.441 70-10.451 74.616-1.433Z",
                                fill: "#119CEB"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M76.981-10.352c2.309 4.51.183 23.372-12.45 31.67-12.633 8.297-31 2.887-33.307-1.622-2.309-4.509-.182-23.371 12.45-31.67 12.633-8.297 31-2.886 33.307 1.622Z",
                                fill: "#00C3E5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M53.71 12.896 46.87 5.97a4.1 4.1 0 0 0-2.913-1.216v8.165a3.287 3.287 0 0 0 3.284 3.285h7.645v-.439c0-1.075-.422-2.11-1.183-2.87h.008Z",
                                fill: "#99E8F5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "m21.156 38.576 7.81-7.802 7.024 7.024L46.71 27.076",
                        stroke: "#fff",
                        strokeWidth: "5.394",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M52.947 64.54c6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12-6.627 0-12 5.372-12 12 0 6.627 5.373 12 12 12Z",
                        fill: "#20BB71"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M46.947 54.014h4.75v4.75c0 .346.12.648.361.889.24.24.543.36.89.36.346 0 .648-.12.889-.36.24-.24.36-.543.36-.89v-4.75h4.75c.347 0 .649-.12.89-.36.24-.24.36-.543.36-.89 0-.346-.12-.648-.36-.889-.241-.24-.543-.36-.89-.36h-4.75v-4.75c0-.347-.12-.649-.36-.89-.241-.24-.543-.36-.89-.36-.346 0-.648.12-.889.36-.24.241-.36.543-.36.89v4.75h-4.75c-.347 0-.65.12-.89.36-.24.241-.36.543-.36.89 0 .346.12.648.36.889.24.24.543.36.89.36Z",
                        fill: "#fff",
                        stroke: "#fff",
                        strokeWidth: ".5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_6561_182627",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(.947 .764)",
                        d: "M0 0h64v64H0z"
                    })
                })
            })
        ]
    });
};
$dc856dbd8c96a896$var$NoProgramsIcon.defaultProps = {
    width: "65",
    height: "65",
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $dc856dbd8c96a896$export$2268c1f1d3300400 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $5CjOe.MessageContainer), {
        style: {
            flexGrow: 1,
            padding: "72px 32px"
        },
        iconSvg: $dc856dbd8c96a896$var$NoProgramsIcon,
        title: format("templateListing.empty.title"),
        description: format("templateListing.empty.description.v2_6"),
        cta: {
            label: format("templateListing.createProgramButton"),
            onClick: ()=>{
                navigate((0, $lDZlX.RoutesPath).TemplateBuilder);
            }
        }
    });
};

});
parcelRegister("5CjOe", function(module, exports) {

$parcel$export(module.exports, "MessageContainer", () => $b8926948a0b7fab1$export$616d763e306cba45);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $9Q47x = parcelRequire("9Q47x");

var $dhb7H = parcelRequire("dhb7H");

var $c22GE = parcelRequire("c22GE");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
const $b8926948a0b7fab1$export$616d763e306cba45 = ({ iconSvg: IconSvg, title: title, description: description, cta: cta, secondaryCta: secondaryCta, style: style })=>/*#__PURE__*/ (0, $iKObn.jsxs)($b8926948a0b7fab1$var$Container, {
        style: style,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $9Q47x.BackgroundIcon), {
                iconSvg: IconSvg
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($b8926948a0b7fab1$var$Title, {
                children: title
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($b8926948a0b7fab1$var$Description, {
                className: "p-size-s",
                children: description
            }),
            cta && /*#__PURE__*/ (0, $iKObn.jsx)($b8926948a0b7fab1$var$StyledButton, {
                label: cta.label,
                onClick: cta.onClick
            }),
            secondaryCta && /*#__PURE__*/ (0, $iKObn.jsx)($b8926948a0b7fab1$var$StyledTertiaryButton, {
                label: secondaryCta.label,
                onClick: secondaryCta.onClick
            })
        ]
    });
const $b8926948a0b7fab1$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "center")};
	max-width: 500px;
`;
const $b8926948a0b7fab1$var$Title = (0, $5UMQ1.default).h3`
	text-align: center;
	margin: 24px 0 8px;
	color: ${(0, $kKnoQ.colors).grey};
`;
const $b8926948a0b7fab1$var$Description = (0, $5UMQ1.default).h3`
	text-align: center;
	color: ${(0, $kKnoQ.colors).grey};
`;
const $b8926948a0b7fab1$var$StyledButton = (0, $5UMQ1.default)((0, $dhb7H.Button))`
	margin-top: 24px;
`;
const $b8926948a0b7fab1$var$StyledTertiaryButton = (0, $5UMQ1.default)((0, $c22GE.TertiaryButton))`
	margin-top: 24px;
`;

});


parcelRegister("4tuK0", function(module, exports) {

$parcel$export(module.exports, "useProgramFilters", () => $b8f4d246d024c060$export$8a719535085fca21);

var $1eHG3 = parcelRequire("1eHG3");

var $5SzTW = parcelRequire("5SzTW");

var $81g6h = parcelRequire("81g6h");

var $buI4E = parcelRequire("buI4E");

var $aEP4N = parcelRequire("aEP4N");
function $b8f4d246d024c060$export$8a719535085fca21(programs) {
    const { format: format } = (0, $1eHG3.useI18n)();
    const { formatPatientName: formatPatientName } = (0, $aEP4N.useFormatPatients)();
    const [searchFilter, setSearchFilter] = (0, $81g6h.useState)({
        search: "",
        filters: [
            (0, $5SzTW.ProgramStatus).Ongoing
        ]
    });
    const programTotalCount = (0, $81g6h.useMemo)(()=>programs.length, [
        programs
    ]);
    const matchesSearch = (0, $81g6h.useCallback)((program, textToSearch)=>(0, $buI4E.isWordMatchingSearch)(program.name, textToSearch) || (0, $buI4E.isWordMatchingSearch)(program.patient.firstName, textToSearch) || (0, $buI4E.isWordMatchingSearch)(program.patient.lastName, textToSearch) || (0, $buI4E.isWordMatchingSearch)(formatPatientName(program.patient), textToSearch), [
        formatPatientName
    ]);
    const filteredPrograms = (0, $81g6h.useMemo)(()=>{
        const hasFilters = searchFilter.filters.length > 0;
        const hasSearch = Boolean(searchFilter.search);
        return hasFilters || hasSearch ? programs.filter((program)=>{
            if (hasFilters && !searchFilter.filters.includes(program.status)) return false;
            if (hasSearch && !matchesSearch(program, searchFilter.search)) return false;
            return true;
        }) : programs;
    }, [
        matchesSearch,
        programs,
        searchFilter.filters,
        searchFilter.search
    ]);
    const allFilters = (0, $81g6h.useMemo)(()=>[
            {
                label: format("global.programStatus.labels.draft"),
                value: (0, $5SzTW.ProgramStatus).Draft
            },
            {
                label: format("global.programStatus.labels.scheduled"),
                value: (0, $5SzTW.ProgramStatus).Scheduled
            },
            {
                label: format("global.programStatus.labels.ongoing"),
                value: (0, $5SzTW.ProgramStatus).Ongoing
            },
            {
                label: format("global.programStatus.labels.ended"),
                value: (0, $5SzTW.ProgramStatus).Ended
            }
        ], [
        format
    ]);
    return {
        allFilters: allFilters,
        setSearchFilter: setSearchFilter,
        programTotalCount: programTotalCount,
        filteredPrograms: filteredPrograms
    };
}

});

parcelRegister("3f6gX", function(module, exports) {

$parcel$export(module.exports, "useTemplateFilters", () => $c3faa5d117f05e8f$export$4a1493f8763d294f);

var $81g6h = parcelRequire("81g6h");

var $buI4E = parcelRequire("buI4E");
function $c3faa5d117f05e8f$export$4a1493f8763d294f(templates) {
    const [search, setSearch] = (0, $81g6h.useState)("");
    const templateTotalCount = (0, $81g6h.useMemo)(()=>templates.length, [
        templates
    ]);
    const filteredTemplates = (0, $81g6h.useMemo)(()=>search ? templates.filter((template)=>(0, $buI4E.isWordMatchingSearch)(template.name, search)) : templates, [
        search,
        templates
    ]);
    return {
        setSearch: setSearch,
        templateTotalCount: templateTotalCount,
        filteredTemplates: filteredTemplates
    };
}

});

parcelRegister("2yeOW", function(module, exports) {

$parcel$export(module.exports, "ProgramsTab", () => $0669d653d6bb5189$export$c3be80dc465177c4);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $1IWnK = parcelRequire("1IWnK");

var $dDMmD = parcelRequire("dDMmD");

var $4UKJF = parcelRequire("4UKJF");

var $a6fIt = parcelRequire("a6fIt");

var $lTdpc = parcelRequire("lTdpc");

var $5kXMA = parcelRequire("5kXMA");

var $ghfIB = parcelRequire("ghfIB");

var $fuvmS = parcelRequire("fuvmS");

var $5SzTW = parcelRequire("5SzTW");

var $fqWoV = parcelRequire("fqWoV");

var $lgqEt = parcelRequire("lgqEt");

var $4tuK0 = parcelRequire("4tuK0");

var $18dwJ = parcelRequire("18dwJ");

var $dafz7 = parcelRequire("dafz7");

var $ijyoE = parcelRequire("ijyoE");

var $lLAgw = parcelRequire("lLAgw");

var $29TYN = parcelRequire("29TYN");

var $ghvAC = parcelRequire("ghvAC");
const $0669d653d6bb5189$export$c3be80dc465177c4 = ({ selectTab: selectTab })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const user = (0, $4UKJF.useUser)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const programs = (0, $1IWnK.useObservable)((0, $ghfIB.patientProgramsManager).allPatientsPrograms);
    const { lastProgramAdded: lastProgramAdded, navigateToProgram: navigateToProgram, getProgramCardActions: getProgramCardActions } = (0, $lLAgw.useProgramCard)();
    const { allFilters: allFilters, setSearchFilter: setSearchFilter, filteredPrograms: filteredPrograms, programTotalCount: programTotalCount } = (0, $4tuK0.useProgramFilters)(programs);
    const { allSortOptions: allSortOptions, setSortKey: setSortKey, sortedPrograms: sortedFilteredPrograms } = (0, $18dwJ.useProgramSort)(filteredPrograms);
    const filterPrograms = (0, $81g6h.useCallback)((search, activeFilters)=>{
        setSearchFilter({
            search: search,
            filters: activeFilters
        });
    }, [
        setSearchFilter
    ]);
    const sortPrograms = (0, $81g6h.useCallback)((key)=>setSortKey(key), [
        setSortKey
    ]);
    return programTotalCount === 0 ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $29TYN.EmptyContainer), {
        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $fqWoV.EmptyPrograms), {
            onSecondaryClick: ()=>selectTab((0, $ghvAC.ProgramListTabNames).Templates)
        })
    }) : /*#__PURE__*/ (0, $iKObn.jsxs)((0, $29TYN.TabContainer), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)((0, $29TYN.TabHeader), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $dafz7.SearchFilter), {
                        placeholder: format("templateListing.programs.searchInputPlaceholder"),
                        filters: allFilters,
                        onChange: filterPrograms,
                        defaultActiveFilters: [
                            (0, $5SzTW.ProgramStatus).Ongoing
                        ]
                    }),
                    isDesktop && /*#__PURE__*/ (0, $iKObn.jsx)((0, $ijyoE.SortDropdown), {
                        sortOptions: allSortOptions,
                        onChange: sortPrograms
                    })
                ]
            }),
            sortedFilteredPrograms.length === 0 ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $29TYN.EmptyContainer), {
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $lgqEt.EmptyProgramsSearch), {})
            }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $29TYN.Layout), {
                "data-test": (0, $a6fIt.e2eTestId).createTemplatePage.programGrid,
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dDMmD.AnimatePresence), {
                    presenceAffectsLayout: true,
                    children: (0, $lTdpc.isNotNil)(user) && sortedFilteredPrograms.map((program)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $29TYN.CardWrapper), {
                            layoutId: program.id,
                            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $fuvmS.PatientProgramCard), {
                                patient: program.patient,
                                program: program,
                                cardActions: getProgramCardActions(program.patient, program, ()=>selectTab((0, $ghvAC.ProgramListTabNames).Templates)),
                                onClick: ()=>navigateToProgram(program.patient, program),
                                isNew: program.id === lastProgramAdded
                            })
                        }, program.id))
                })
            })
        ]
    });
};

});
parcelRegister("fuvmS", function(module, exports) {

$parcel$export(module.exports, "PatientProgramCard", () => $1f2d30e5fea268b6$export$af3bb7b13667b223);
$parcel$export(module.exports, "TemplateCard", () => $1f2d30e5fea268b6$export$ba340e850b866867);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5stJo = parcelRequire("5stJo");

var $4UKJF = parcelRequire("4UKJF");

var $a6fIt = parcelRequire("a6fIt");

var $kkH7g = parcelRequire("kkH7g");

var $5UMQ1 = parcelRequire("5UMQ1");

var $amllh = parcelRequire("amllh");

var $1lhQS = parcelRequire("1lhQS");

var $5kXMA = parcelRequire("5kXMA");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $1JaRC = parcelRequire("1JaRC");

var $buI4E = parcelRequire("buI4E");

var $81g6h = parcelRequire("81g6h");

var $71Rdg = parcelRequire("71Rdg");
const $1f2d30e5fea268b6$var$SPACE_SEPARATOR = " ";
const $1f2d30e5fea268b6$export$af3bb7b13667b223 = ({ program: program, patient: patient, isNew: isNew, ...props })=>/*#__PURE__*/ (0, $iKObn.jsx)($1f2d30e5fea268b6$var$ProgramCard, {
        id: program.id,
        title: program.name,
        sessionsPerWeek: program.sessionsPerWeek,
        exercisesPerWeek: program.exercisesPerWeek,
        status: /*#__PURE__*/ (0, $iKObn.jsx)((0, $1lhQS.ProgramStatusComponent), {
            programStatus: (0, $5stJo.extractPropsForProgramStatusComponentFromPatientProgram)(program, true),
            statusLabelVisible: true
        }),
        lastEditionMetadata: program.lastEditionMetadata,
        isNew: isNew,
        patient: patient,
        ...props
    });
const $1f2d30e5fea268b6$export$ba340e850b866867 = ({ editor: editor, template: template, ...props })=>/*#__PURE__*/ (0, $iKObn.jsx)($1f2d30e5fea268b6$var$ProgramCard, {
        id: template.id,
        title: template.name,
        sessionsPerWeek: template.sessionsPerWeek,
        exercisesPerWeek: template.exercisesPerWeek,
        lastEditionMetadata: {
            date: template.lastEditionDate,
            editor: editor
        },
        ...props
    });
const $1f2d30e5fea268b6$var$ProgramCard = ({ title: title, sessionsPerWeek: sessionsPerWeek, exercisesPerWeek: exercisesPerWeek, status: status, lastEditionMetadata: lastEditionMetadata, cardActions: cardActions, onClick: onClick, isNew: isNew = false, patient: patient, ...props })=>{
    const { format: format, formatRelativeDateTime: formatRelativeDateTime } = (0, $1eHG3.useI18n)();
    const user = (0, $4UKJF.useUser)();
    const { isTouchDevice: isTouchDevice } = (0, $5kXMA.useDimensions)();
    const [isHovering, setIsHovering] = (0, $81g6h.useState)(false);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($1f2d30e5fea268b6$var$Container, {
        "data-test": (0, $a6fIt.e2eTestId).patientPage.programCard,
        onClick: onClick,
        isNew: isNew,
        onMouseEnter: (e)=>{
            setIsHovering(true);
            props.onMouseEnter?.(e);
        },
        onMouseOver: (e)=>{
            setIsHovering(true);
            props.onMouseOver?.(e);
        },
        onMouseLeave: (e)=>{
            setIsHovering(false);
            props.onMouseLeave?.(e);
        },
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($1f2d30e5fea268b6$var$CardTop, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($1f2d30e5fea268b6$var$CardTopText, {
                        children: [
                            (0, $lTdpc.isNotNil)(patient) && /*#__PURE__*/ (0, $iKObn.jsx)((0, $71Rdg.PatientButton), {
                                patient: patient
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($1f2d30e5fea268b6$var$Title, {
                                className: "p-size-l-bold",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)($1f2d30e5fea268b6$var$Description, {
                                children: [
                                    format("patientDetails.patientPrograms.programCard.description.intro") + $1f2d30e5fea268b6$var$SPACE_SEPARATOR,
                                    /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                                        className: "p-size-s-bold",
                                        children: format("patientDetails.patientPrograms.programCard.description.sessionsNumber", {
                                            count: sessionsPerWeek
                                        }) + $1f2d30e5fea268b6$var$SPACE_SEPARATOR
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($1f2d30e5fea268b6$var$Separator, {}),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                                        className: "p-size-s-bold",
                                        children: $1f2d30e5fea268b6$var$SPACE_SEPARATOR + format("patientDetails.patientPrograms.programCard.description.exercisesNumber", {
                                            count: exercisesPerWeek
                                        })
                                    })
                                ]
                            }),
                            (0, $lTdpc.isNotNil)(lastEditionMetadata) && /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                children: format("patientDetails.patientPrograms.programCard.lastEdited.v2_6", {
                                    date: formatRelativeDateTime(lastEditionMetadata.date),
                                    name: lastEditionMetadata.editor.id === user?.id ? format("patientDetails.patientPrograms.programCard.lastEdited.you") : (0, $buI4E.formatName)(lastEditionMetadata.editor)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($1f2d30e5fea268b6$var$ActionButtonContainer, {
                        children: (isHovering || isTouchDevice) && cardActions && cardActions.length > 0 && /*#__PURE__*/ (0, $iKObn.jsx)($1f2d30e5fea268b6$var$ActionButton, {
                            menuId: props.id,
                            menuItems: cardActions
                        })
                    })
                ]
            }),
            (0, $lTdpc.isNotNil)(status) && /*#__PURE__*/ (0, $iKObn.jsx)($1f2d30e5fea268b6$var$CardBottom, {
                children: status
            })
        ]
    });
};
const $1f2d30e5fea268b6$var$Container = (0, $5UMQ1.default).div`
	height: 100%;
	padding: 16px 16px 16px 32px;
	background-color: ${(0, $kKnoQ.colors).white};
	border-radius: 8px;
	${(0, $5WGN2.stack)("SM", "spacebetween", "stretch")};

	animation: 1s linear 2s fadeOut;
	animation-fill-mode: forwards;

	border: 1px solid ${({ isNew: isNew })=>isNew ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).primary25};
	box-shadow: 0 0 5px ${({ isNew: isNew })=>isNew ? (0, $1JaRC.colorWithAlpha)((0, $kKnoQ.colors).primary25, 0.5) : (0, $kKnoQ.colors).white};

	@keyframes fadeOut {
		100% {
			border-color: ${(0, $kKnoQ.colors).primary25};
			box-shadow: 0 0 5px ${(0, $kKnoQ.colors).white};
		}
	}

	${(props)=>props.onClick && (0, $kkH7g.css)`
			cursor: pointer;

			:hover {
				border: 1px solid ${(0, $kKnoQ.colors).primary} !important;
			}
		`};
`;
const $1f2d30e5fea268b6$var$CardTop = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")};
	min-height: 40px;
`;
const $1f2d30e5fea268b6$var$CardTopText = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("XSS", "flexstart")};
`;
const $1f2d30e5fea268b6$var$CardBottom = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	align-items: start;
`;
const $1f2d30e5fea268b6$var$ActionButtonContainer = (0, $5UMQ1.default).div`
	width: 40px;
	height: 100%;
	flex-shrink: 0;
`;
const $1f2d30e5fea268b6$var$ActionButton = (0, $5UMQ1.default)((0, $amllh.MenuButton))`
	.menu-button {
		background-color: ${(0, $kKnoQ.colors).transparent};

		&.hover {
			background-color: ${(0, $kKnoQ.colors).grey10};
		}
	}
`;
const $1f2d30e5fea268b6$var$Title = (0, $5UMQ1.default).h4`
	margin-right: 8px;
	overflow-wrap: anywhere;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
`;
const $1f2d30e5fea268b6$var$Description = (0, $5UMQ1.default).span`
	color: ${(0, $kKnoQ.colors).grey};
	padding-top: 4px;
`;
const $1f2d30e5fea268b6$var$Separator = (0, $5UMQ1.default).span`
	display: inline-block;
	height: 1rem;
	width: 0.0625rem;
	background-color: ${(0, $kKnoQ.colors).primary25};
	margin-bottom: -0.1875rem;
`;

});
parcelRegister("1JaRC", function(module, exports) {

$parcel$export(module.exports, "colorWithAlpha", () => $ab1e3ad68c913385$export$f222759bf4e05c51);

var $hEQyt = parcelRequire("hEQyt");
const $ab1e3ad68c913385$var$HEX_REGEX = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
const $ab1e3ad68c913385$var$HEX_3_REGEX = /^#[A-Fa-f0-9]{3}$/;
const $ab1e3ad68c913385$export$f222759bf4e05c51 = (color, alpha)=>{
    if (!$ab1e3ad68c913385$var$HEX_REGEX.test(color)) return color;
    const hexColor = $ab1e3ad68c913385$var$HEX_3_REGEX.test(color) ? $ab1e3ad68c913385$var$convertHex3toHex6(color) : color;
    const transparencyBase256 = Math.floor((0, $hEQyt.clamp)(alpha, 0, 1) * 255);
    const transparencyHexCode = transparencyBase256.toString(16).padStart(2, "0");
    return `${hexColor}${transparencyHexCode}`;
};
const $ab1e3ad68c913385$var$convertHex3toHex6 = (hex)=>`#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`;

});

parcelRegister("71Rdg", function(module, exports) {

$parcel$export(module.exports, "PatientButton", () => $6ab0c3efb90b3058$export$5455e7e474815a71);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $htiSH = parcelRequire("htiSH");

var $aEP4N = parcelRequire("aEP4N");

var $g3eyb = parcelRequire("g3eyb");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lDZlX = parcelRequire("lDZlX");
const $6ab0c3efb90b3058$export$5455e7e474815a71 = ({ patient: patient })=>{
    const navigate = (0, $htiSH.useNavigate)();
    const { getGenderIcon: getGenderIcon } = (0, $g3eyb.useGenderIcon)();
    const { formatPatientName: formatPatientName } = (0, $aEP4N.useFormatPatients)();
    const [isHovering, setIsHovering] = (0, $81g6h.useState)(false);
    const GenderIcon = (0, $81g6h.useMemo)(()=>getGenderIcon(patient, isHovering), [
        getGenderIcon,
        patient,
        isHovering
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($6ab0c3efb90b3058$var$Container, {
        onClick: (e)=>{
            e.stopPropagation();
            navigate((0, $lDZlX.RoutesPath).PatientDetails, {
                route: {
                    patientId: patient.id
                },
                query: {
                    active: (0, $lDZlX.TabPatientDetails).PROGRESS_TAB
                }
            });
        },
        onMouseEnter: ()=>{
            setIsHovering(true);
        },
        onMouseLeave: ()=>{
            setIsHovering(false);
        },
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)(GenderIcon, {
                width: 20,
                height: 20
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                className: "p-size-xs-semi-bold",
                children: formatPatientName(patient)
            })
        ]
    });
};
const $6ab0c3efb90b3058$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("XS", "flexstart", "center")};
	padding: 4px 8px 4px 4px;
	border-radius: 4px;
	color: ${(0, $kKnoQ.colors).black};

	&:hover {
		background-color: ${(0, $kKnoQ.colors).primaryBackground};
		color: ${(0, $kKnoQ.colors).primary};
	}
`;

});
parcelRegister("g3eyb", function(module, exports) {

$parcel$export(module.exports, "useGenderIcon", () => $ee0caa7d832c7dc7$export$52f647a30c85e5f3);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $6Yxa2 = parcelRequire("6Yxa2");

var $4QZSk = parcelRequire("4QZSk");
var $ee0caa7d832c7dc7$var$ManIcon = function ManIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_1423_16864",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "40",
                height: "40",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("circle", {
                    cx: "20",
                    cy: "20",
                    r: "20",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_1423_16864)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("circle", {
                        cx: "20",
                        cy: "20",
                        r: "20",
                        fill: "#ECEDFC"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.542 39.239C33.409 39.952 29.82 41.5 20 41.5c-9.819 0-13.408-1.548-14.54-2.261a.98.98 0 0 1-.458-.896c.072-1.054.58-3.364 3.56-4.414 2.51-.885 5.374-1.278 7.234-2.287a1.61 1.61 0 0 0 .247-2.676c-1.539-1.256-2.387-3.25-2.842-5.275-.795-.58-2.564-4.064-.979-4.717-.352-1.21-1.181-5.295 2.53-8.25 4.17-3.32 10.5 1.02 12.144-2.095.085-.16.313-.175.412-.022.502.78 1.477 2.785.196 5.158.257 1.084.631 3.217.205 5.172 2.077.553-.052 4.192-.912 4.761-.456 2.024-1.303 4.014-2.84 5.268a1.61 1.61 0 0 0 .247 2.676c1.86 1.01 4.724 1.402 7.235 2.287 2.978 1.05 3.487 3.36 3.559 4.414a.979.979 0 0 1-.457.896",
                        fill: "#74748B"
                    })
                ]
            })
        ]
    });
};
$ee0caa7d832c7dc7$var$ManIcon.defaultProps = {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $ee0caa7d832c7dc7$var$ManIconHover = function ManIconHover(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_6115_26564",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "40",
                height: "40",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z",
                    fill: "#ECEDFC"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_6115_26564)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z",
                        fill: "#ECEDFC"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.542 39.239C33.409 39.952 29.82 41.5 20 41.5c-9.819 0-13.408-1.548-14.54-2.261a.98.98 0 0 1-.458-.896c.072-1.054.58-3.364 3.56-4.414 2.51-.885 5.374-1.278 7.234-2.287a1.61 1.61 0 0 0 .247-2.676c-1.539-1.256-2.387-3.25-2.842-5.275-.795-.58-2.564-4.064-.979-4.717-.352-1.21-1.181-5.295 2.53-8.25 4.17-3.32 10.5 1.02 12.144-2.095.085-.16.313-.175.412-.022.502.78 1.477 2.785.196 5.158.257 1.084.631 3.217.205 5.172 2.077.553-.052 4.192-.912 4.761-.456 2.024-1.303 4.014-2.84 5.268a1.61 1.61 0 0 0 .247 2.676c1.86 1.01 4.724 1.402 7.235 2.287 2.978 1.05 3.487 3.36 3.559 4.414a.978.978 0 0 1-.456.896Z",
                        fill: "#434CE5"
                    })
                ]
            })
        ]
    });
};
$ee0caa7d832c7dc7$var$ManIconHover.defaultProps = {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $ee0caa7d832c7dc7$var$WomanIcon = function WomanIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_1423_16868",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "40",
                height: "40",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("circle", {
                    cx: "20",
                    cy: "20",
                    r: "20",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_1423_16868)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("circle", {
                        cx: "20",
                        cy: "20",
                        r: "20",
                        fill: "#ECEDFC"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.998 37.818a.99.99 0 0 1-.457.903c-1.133.719-4.721 2.278-14.54 2.279-9.82 0-13.409-1.559-14.542-2.277a.99.99 0 0 1-.457-.903c.072-1.062.58-3.389 3.56-4.447 2.51-.892 5.374-1.288 7.234-2.305a1.67 1.67 0 0 0 .328-.236 9.412 9.412 0 0 1-6.565-1.078.957.957 0 0 1-.228-1.48c.951-1.038 2.26-3.481 1.816-8.896-.678-8.245 3.728-10.169 6.101-10.36 1.733-.14 2.591.567 2.93.96.337-.393 1.196-1.1 2.928-.96 2.373.191 6.78 2.115 6.102 10.36-.445 5.415.865 7.858 1.816 8.897a.957.957 0 0 1-.228 1.48 9.418 9.418 0 0 1-7.017.978c.119.128.258.243.424.334 1.86 1.017 4.724 1.412 7.235 2.304 2.979 1.058 3.487 3.385 3.56 4.447",
                        fill: "#74748B"
                    })
                ]
            })
        ]
    });
};
$ee0caa7d832c7dc7$var$WomanIcon.defaultProps = {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $ee0caa7d832c7dc7$var$WomanIconHover = function WomanIconHover(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_6115_26554",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "40",
                height: "40",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z",
                    fill: "#ECEDFC"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_6115_26554)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z",
                        fill: "#ECEDFC"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.998 37.818a.99.99 0 0 1-.457.903c-1.133.719-4.721 2.278-14.54 2.279-9.82 0-13.409-1.559-14.542-2.277a.99.99 0 0 1-.457-.903c.072-1.062.58-3.389 3.56-4.447 2.51-.892 5.374-1.288 7.234-2.305a1.67 1.67 0 0 0 .328-.236 9.412 9.412 0 0 1-6.565-1.078.957.957 0 0 1-.228-1.48c.951-1.038 2.26-3.481 1.816-8.896-.678-8.245 3.728-10.169 6.101-10.36 1.733-.14 2.591.567 2.93.96.337-.393 1.196-1.1 2.928-.96 2.373.191 6.78 2.115 6.102 10.36-.445 5.415.865 7.858 1.816 8.897a.957.957 0 0 1-.228 1.48 9.418 9.418 0 0 1-7.017.978c.119.128.258.243.424.334 1.86 1.017 4.724 1.412 7.235 2.304 2.979 1.058 3.488 3.385 3.56 4.447Z",
                        fill: "#434CE5"
                    })
                ]
            })
        ]
    });
};
$ee0caa7d832c7dc7$var$WomanIconHover.defaultProps = {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $ee0caa7d832c7dc7$var$OtherGenderIcon = function OtherGenderIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_1423_16872",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "40",
                height: "40",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("circle", {
                    cx: "20",
                    cy: "20",
                    r: "20",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_1423_16872)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("circle", {
                        cx: "20",
                        cy: "20",
                        r: "20",
                        fill: "#ECEDFC"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.54 38.468c-1.132.72-4.721 2.281-14.54 2.282-9.82 0-13.408-1.56-14.54-2.28a.99.99 0 0 1-.458-.904c.072-1.062.58-3.392 3.56-4.452 2.51-.893 5.374-1.29 7.234-2.307a1.631 1.631 0 0 0 .247-2.699c-1.525-1.255-2.372-3.24-2.83-5.263-.766-.345-2.92-4.484-.83-4.892.11-.022.22-.026.327-.016.003-4.658 3.265-7.937 7.288-7.937s7.286 3.195 7.289 7.937c.051.002.104.006.156.015 2.287.378.308 3.972-.63 4.763-.451 2.069-1.3 4.11-2.857 5.392-.897.74-.775 2.14.247 2.699 1.86 1.018 4.724 1.414 7.235 2.307 2.979 1.06 3.488 3.389 3.56 4.452a.99.99 0 0 1-.457.903",
                        fill: "#74748B"
                    })
                ]
            })
        ]
    });
};
$ee0caa7d832c7dc7$var$OtherGenderIcon.defaultProps = {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $ee0caa7d832c7dc7$var$OtherGenderIconHover = function OtherGenderIconHover(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_6115_26544",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "40",
                height: "40",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z",
                    fill: "#ECEDFC"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_6115_26544)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z",
                        fill: "#ECEDFC"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.54 38.468c-1.132.72-4.721 2.281-14.54 2.282-9.82 0-13.408-1.56-14.54-2.28a.99.99 0 0 1-.458-.904c.072-1.062.58-3.392 3.56-4.452 2.51-.893 5.374-1.29 7.234-2.307a1.631 1.631 0 0 0 .247-2.699c-1.525-1.255-2.372-3.24-2.83-5.263-.766-.345-2.92-4.484-.83-4.892.11-.022.22-.026.327-.016.003-4.658 3.265-7.937 7.288-7.937s7.286 3.195 7.289 7.937c.051.002.104.006.156.015 2.287.378.308 3.972-.63 4.763-.451 2.069-1.3 4.11-2.857 5.392-.897.74-.775 2.14.247 2.699 1.86 1.018 4.724 1.414 7.235 2.307 2.979 1.06 3.488 3.389 3.56 4.452a.991.991 0 0 1-.457.903Z",
                        fill: "#434CE5"
                    })
                ]
            })
        ]
    });
};
$ee0caa7d832c7dc7$var$OtherGenderIconHover.defaultProps = {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $ee0caa7d832c7dc7$export$52f647a30c85e5f3 = ()=>{
    const getGenderIcon = (0, $81g6h.useCallback)(({ gender: gender, status: status }, isHovering = false)=>{
        if (status === (0, $6Yxa2.PatientStatus).Pending) return isHovering ? $ee0caa7d832c7dc7$var$OtherGenderIconHover : $ee0caa7d832c7dc7$var$OtherGenderIcon;
        if (gender === (0, $4QZSk.Gender).Man) return isHovering ? $ee0caa7d832c7dc7$var$ManIconHover : $ee0caa7d832c7dc7$var$ManIcon;
        if (gender === (0, $4QZSk.Gender).Woman) return isHovering ? $ee0caa7d832c7dc7$var$WomanIconHover : $ee0caa7d832c7dc7$var$WomanIcon;
        return $ee0caa7d832c7dc7$var$OtherGenderIcon;
    }, []);
    return {
        getGenderIcon: getGenderIcon
    };
};

});
parcelRegister("4QZSk", function(module, exports) {

$parcel$export(module.exports, "Gender", () => $096c9d2f361317e6$export$d549c77c8a078892);
var $096c9d2f361317e6$export$d549c77c8a078892;
(function(Gender) {
    Gender["Man"] = "MALE";
    Gender["Woman"] = "FEMALE";
    Gender["Other"] = "UNDEFINED";
})($096c9d2f361317e6$export$d549c77c8a078892 || ($096c9d2f361317e6$export$d549c77c8a078892 = {}));
function $096c9d2f361317e6$export$12bfa515bd66dbcb(text) {
    if (text === "MALE") return "MALE";
    if (text === "FEMALE") return "FEMALE";
    return "UNDEFINED";
}

});




parcelRegister("fqWoV", function(module, exports) {

$parcel$export(module.exports, "EmptyPrograms", () => $5ffec755804c06c7$export$368ea4300bc554da);

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $5CjOe = parcelRequire("5CjOe");

var $lDZlX = parcelRequire("lDZlX");

var $bC9c0 = parcelRequire("bC9c0");
var $5ffec755804c06c7$var$NoProgramsIcon = function NoProgramsIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_6561_182627)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask0_6561_182627",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "10",
                        y: "4",
                        width: "45",
                        height: "58",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M47.067 61.45H18.765a7.817 7.817 0 0 1-7.818-7.818v-41.05c0-4.319 3.5-7.818 7.818-7.818h25.191A4.1 4.1 0 0 1 46.87 5.98l6.841 6.924a4.107 4.107 0 0 1 1.183 2.871v37.857c0 4.319-3.5 7.818-7.818 7.818h-.008Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask0_6561_182627)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M34.484 71.436c27.707 0 50.167-22.461 50.167-50.168s-22.46-50.167-50.167-50.167-50.168 22.46-50.168 50.167S6.777 71.436 34.484 71.436Z",
                                fill: "#1B5EC0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M68.817 2.017C75.742 15.55 70.273 36.58 54.033 45.5c-16.24 8.918-37.104 2.358-44.029-11.177C3.08 20.788 8.549-.242 24.788-9.16c16.24-8.918 37.105-2.358 44.03 11.177Z",
                                fill: "#2275F0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M74.616-1.433c4.616 9.025.819 28.972-13.617 37.576-14.437 8.612-34.052 2.622-38.668-6.395-4.617-9.026-.82-28.973 13.617-37.576C50.384-16.441 70-10.451 74.616-1.433Z",
                                fill: "#119CEB"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M76.981-10.352c2.309 4.51.183 23.372-12.45 31.67-12.633 8.297-31 2.887-33.307-1.622-2.309-4.509-.182-23.371 12.45-31.67 12.633-8.297 31-2.886 33.307 1.622Z",
                                fill: "#00C3E5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M53.71 12.896 46.87 5.97a4.1 4.1 0 0 0-2.913-1.216v8.165a3.287 3.287 0 0 0 3.284 3.285h7.645v-.439c0-1.075-.422-2.11-1.183-2.87h.008Z",
                                fill: "#99E8F5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "m21.156 38.576 7.81-7.802 7.024 7.024L46.71 27.076",
                        stroke: "#fff",
                        strokeWidth: "5.394",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M52.947 64.54c6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12-6.627 0-12 5.372-12 12 0 6.627 5.373 12 12 12Z",
                        fill: "#20BB71"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M46.947 54.014h4.75v4.75c0 .346.12.648.361.889.24.24.543.36.89.36.346 0 .648-.12.889-.36.24-.24.36-.543.36-.89v-4.75h4.75c.347 0 .649-.12.89-.36.24-.24.36-.543.36-.89 0-.346-.12-.648-.36-.889-.241-.24-.543-.36-.89-.36h-4.75v-4.75c0-.347-.12-.649-.36-.89-.241-.24-.543-.36-.89-.36-.346 0-.648.12-.889.36-.24.241-.36.543-.36.89v4.75h-4.75c-.347 0-.65.12-.89.36-.24.241-.36.543-.36.89 0 .346.12.648.36.889.24.24.543.36.89.36Z",
                        fill: "#fff",
                        stroke: "#fff",
                        strokeWidth: ".5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_6561_182627",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(.947 .764)",
                        d: "M0 0h64v64H0z"
                    })
                })
            })
        ]
    });
};
$5ffec755804c06c7$var$NoProgramsIcon.defaultProps = {
    width: "65",
    height: "65",
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $5ffec755804c06c7$export$368ea4300bc554da = ({ onSecondaryClick: onSecondaryClick })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    const sendAnalytics = ()=>(0, $bC9c0.sendAnalyticsEventCreateProgram)((0, $bC9c0.AnalyticsProgramLocation).PROGRAM_PAGE);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $5CjOe.MessageContainer), {
        style: {
            flexGrow: 1,
            padding: "72px 32px"
        },
        iconSvg: $5ffec755804c06c7$var$NoProgramsIcon,
        title: format("templateListing.noPrograms.title"),
        description: format("templateListing.noPrograms.description"),
        cta: {
            label: format("templateListing.createProgramButton"),
            onClick: ()=>{
                sendAnalytics();
                navigate((0, $lDZlX.RoutesPath).TemplateBuilder);
            }
        },
        secondaryCta: {
            label: format("templateListing.viewTemplatesButton"),
            onClick: onSecondaryClick
        }
    });
};

});

parcelRegister("lgqEt", function(module, exports) {

$parcel$export(module.exports, "EmptyProgramsSearch", () => $eb9f98db3da1fb7f$export$5e8354c81379cfb7);

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $5CjOe = parcelRequire("5CjOe");
var $eb9f98db3da1fb7f$var$EmptyBoxLargeIcon = function EmptyBoxLargeIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_9595_47349)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask0_9595_47349",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "20",
                        width: "65",
                        height: "43",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "m.6 41.56 11.655-17.345a7.536 7.536 0 0 1 6.256-3.334h28.163a7.536 7.536 0 0 1 6.257 3.334L64.585 41.56v21.172H.6S.813 41.347.6 41.56Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("g", {
                        mask: "url(#mask0_9595_47349)",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M-2.36 26.492C-7.572 5.262 9.355-12.297 30.666-7.854c21.23-5.214 38.79 11.713 34.346 33.024 5.214 21.23-11.713 38.79-33.024 34.346C10.757 64.73-6.803 47.803-2.36 26.492Z",
                            fill: "#33009A"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask1_9595_47349",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "42",
                        width: "65",
                        height: "21",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M45.763 45.608a3.545 3.545 0 0 1-3.546 3.547H22.984a3.545 3.545 0 0 1-3.548-3.547 3.545 3.545 0 0 0-3.546-3.547H.614v14.687A5.986 5.986 0 0 0 6.6 62.733h52.015a5.986 5.986 0 0 0 5.985-5.985V42.06H49.325a3.545 3.545 0 0 0-3.547 3.547h-.015Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask1_9595_47349)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M35.703 92.835c19.013 0 34.427-15.4 34.427-34.398 0-18.997-15.414-34.397-34.427-34.397-19.014 0-34.427 15.4-34.427 34.397s15.413 34.398 34.427 34.398Z",
                                fill: "#50F"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M61.302 61.984c-3.393 15.774-18.381 26.473-34.39 24.285-7.314-.999-13.578-4.634-17.992-9.84-5.03-5.934-7.432-13.939-6.448-22.266.39-3.305 1.22-6.47 2.49-9.363 5.11-11.574 17.294-19.167 30.586-17.86 5.265.536 10.516 2.188 14.584 5.273 4.098 3.113 6.507 7.52 8.578 12.095 1.593 3.525 3.003 7.13 3.231 11.096.125 2.188-.169 4.399-.639 6.58Z",
                                fill: "#4427FA"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M60.862 61.646C56.066 78.588 39.69 90.103 22.124 88.384c-7.762-.764-14.496-4.26-19.387-9.525-5.581-6.007-8.218-14.408-7.726-23.213.213-3.804.83-7.542 1.99-11C1.68 30.89 14.957 20.86 30.268 21.116c6.022.104 12.837 1.227 17.713 4.76 5.104 3.693 6.925 9.487 9.407 14.95 1.939 4.245 4.303 8.248 4.62 13.014.175 2.643-.42 5.265-1.146 7.813v-.007Z",
                                fill: "#334EF5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M49.773 58.98c-4.95 12.998-17.97 21.81-31.93 21.304-5.823-.213-11.008-2.372-14.952-6.015-4.494-4.149-6.682-10.376-6.91-16.927-.11-3.253.037-6.514.683-9.59 2.54-12.184 12.998-22.134 26.019-23.397 5.067-.492 11.735-.448 16.111 2.526 4.781 3.26 5.222 9.018 7.454 13.872 1.755 3.826 4.62 7.057 4.957 11.324.191 2.38-.602 4.7-1.44 6.903h.008Z",
                                fill: "#2275F0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M36.987 56.88C32.111 66 22.234 71.971 11.872 72.75c-3.877.293-7.512-.485-10.509-2.505-3.407-2.298-5.31-6.367-6.088-10.64-.492-2.718-.741-5.486-.631-8.189.448-10.604 8.034-20.459 18.778-23.264 4.112-1.072 10.648-2.137 14.503.294 4.465 2.812 3.525 8.547 5.5 12.8 1.58 3.407 4.936 5.86 5.295 9.634.206 2.123-.749 4.15-1.733 5.993v.007Z",
                                fill: "#119CEB"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M24.1 44.623c1.057 2.255 3.965 3.525 4.251 5.992.162 1.41-.624 2.754-1.534 3.841-3.445 4.12-8.754 6.08-13.814 7.873-1.476.521-3.04 1.057-4.575.763-1.748-.33-3.158-1.71-3.98-3.29-.823-1.578-1.146-3.363-1.461-5.118-1.227-6.808 2.335-14.159 8.702-17.463 2.386-1.241 7.218-2.894 9.737-1.462 3.144 1.778 1.381 6.096 2.674 8.857v.007Z",
                                fill: "#00C3E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M33.309 2.88c.874 0 1.589.715 1.589 1.589v8.768c0 .874-.715 1.59-1.59 1.59a1.594 1.594 0 0 1-1.588-1.59V4.47c0-.874.715-1.59 1.589-1.59ZM41.236 8.269c.62-.62 1.628-.62 2.248 0 .62.62.62 1.628 0 2.248l-3.65 3.65c-.309.309-.714.468-1.12.468h-.008a1.592 1.592 0 0 1-1.12-2.717l3.65-3.649ZM22.51 8.269c.62-.62 1.628-.62 2.248 0l3.65 3.65a1.592 1.592 0 0 1-1.12 2.716h-.008c-.406 0-.812-.16-1.12-.469l-3.65-3.649a1.592 1.592 0 0 1 0-2.248Z",
                        fill: "#FF0A4B",
                        stroke: "#FF0A4B",
                        strokeWidth: ".24"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_9595_47349",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(.6 .6)",
                        d: "M0 0h64v64H0z"
                    })
                })
            })
        ]
    });
};
$eb9f98db3da1fb7f$var$EmptyBoxLargeIcon.defaultProps = {
    width: "65",
    height: "65",
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $eb9f98db3da1fb7f$export$5e8354c81379cfb7 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $5CjOe.MessageContainer), {
        style: {
            flexGrow: 1,
            padding: "72px 32px"
        },
        iconSvg: $eb9f98db3da1fb7f$var$EmptyBoxLargeIcon,
        title: format("templateListing.programs.emptySearch.title"),
        description: format("templateListing.programs.emptySearch.description")
    });
};

});

parcelRegister("18dwJ", function(module, exports) {

$parcel$export(module.exports, "useProgramSort", () => $80c6199e78a2cf4f$export$2860b087097b4e5c);

var $81g6h = parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $5kXMA = parcelRequire("5kXMA");

var $aEP4N = parcelRequire("aEP4N");
var $80c6199e78a2cf4f$export$f9f2a6af291ba0ff;
(function(ProgramSortKey) {
    ProgramSortKey["LastEdited"] = "LastEdited";
    ProgramSortKey["ProgramName"] = "ProgramName";
    ProgramSortKey["PatientName"] = "PatientName";
})($80c6199e78a2cf4f$export$f9f2a6af291ba0ff || ($80c6199e78a2cf4f$export$f9f2a6af291ba0ff = {}));
function $80c6199e78a2cf4f$export$2860b087097b4e5c(programs) {
    const { format: format } = (0, $1eHG3.useI18n)();
    const collator = (0, $81g6h.useMemo)(()=>new Intl.Collator(), []);
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const [sortKey, setSortKey] = (0, $81g6h.useState)("LastEdited");
    const { formatPatientName: formatPatientName } = (0, $aEP4N.useFormatPatients)();
    const compareByLastEdited = (0, $81g6h.useCallback)((a, b)=>b.lastEditionMetadata.date.diff(a.lastEditionMetadata.date), []);
    const compareByProgramName = (0, $81g6h.useCallback)((a, b)=>{
        const result = collator.compare(a.name, b.name);
        if (result !== 0) return result;
        return compareByLastEdited(a, b);
    }, [
        collator,
        compareByLastEdited
    ]);
    const compareByPatientName = (0, $81g6h.useCallback)((a, b)=>{
        const result = collator.compare(formatPatientName(a.patient), formatPatientName(b.patient));
        if (result !== 0) return result;
        return compareByLastEdited(a, b);
    }, [
        collator,
        compareByLastEdited,
        formatPatientName
    ]);
    const sortedPrograms = (0, $81g6h.useMemo)(()=>{
        switch(sortKey){
            case "LastEdited":
                return [
                    ...programs
                ].sort((a, b)=>compareByLastEdited(a, b));
            case "ProgramName":
                return [
                    ...programs
                ].sort((a, b)=>compareByProgramName(a, b));
            case "PatientName":
                return [
                    ...programs
                ].sort((a, b)=>compareByPatientName(a, b));
        }
    }, [
        sortKey,
        programs,
        compareByLastEdited,
        compareByProgramName,
        compareByPatientName
    ]);
    const allSortOptions = (0, $81g6h.useMemo)(()=>isDesktop ? Object.values({
            ["LastEdited"]: {
                label: format("templateListing.programs.sort.lastEdited"),
                key: "LastEdited"
            },
            ["ProgramName"]: {
                label: format("templateListing.programs.sort.programName"),
                key: "ProgramName"
            },
            ["PatientName"]: {
                label: format("templateListing.programs.sort.patientName"),
                key: "PatientName"
            }
        }) : [], [
        format,
        isDesktop
    ]);
    return {
        allSortOptions: allSortOptions,
        setSortKey: setSortKey,
        sortedPrograms: sortedPrograms
    };
}

});

parcelRegister("dafz7", function(module, exports) {

$parcel$export(module.exports, "SearchFilter", () => $218d5b64312ef184$export$820e4d34d59f5d7f);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $hIci4 = parcelRequire("hIci4");
const $218d5b64312ef184$export$820e4d34d59f5d7f = ({ placeholder: placeholder, filters: filters, onChange: onChange, defaultActiveFilters: defaultActiveFilters })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const [search, setSearch] = (0, $81g6h.useState)("");
    const [activeFilters, setActiveFilters] = (0, $81g6h.useState)(defaultActiveFilters ?? []);
    const toggleFilter = (0, $81g6h.useCallback)((value)=>setActiveFilters((prevFilters)=>prevFilters.includes(value) ? prevFilters.filter((filter)=>filter !== value) : [
                ...activeFilters,
                value
            ]), [
        activeFilters
    ]);
    (0, $81g6h.useEffect)(()=>onChange(search, activeFilters), [
        search,
        activeFilters,
        onChange
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($218d5b64312ef184$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($218d5b64312ef184$var$SearchContainer, {
                children: /*#__PURE__*/ (0, $iKObn.jsxs)($218d5b64312ef184$var$Row, {
                    className: "p-input-icon-left p-input-icon-right",
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)("i", {
                            className: "pi pi-search"
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)($218d5b64312ef184$var$StyledTextInput, {
                            placeholder: placeholder,
                            value: search,
                            onChange: (e)=>setSearch(e.target.value)
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)($218d5b64312ef184$var$ClearSearchButton, {
                            className: "pi pi-times",
                            displayed: !!search,
                            onClick: ()=>setSearch("")
                        })
                    ]
                })
            }),
            filters && /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
                children: /*#__PURE__*/ (0, $iKObn.jsxs)($218d5b64312ef184$var$FiltersContainer, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)($218d5b64312ef184$var$FilterTitle, {
                            children: format("templateListing.searchFilter.filters")
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)($218d5b64312ef184$var$FilterItemContainer, {
                            children: filters.map((filter)=>/*#__PURE__*/ (0, $iKObn.jsx)($218d5b64312ef184$var$FilterItem, {
                                    isActive: activeFilters.includes(filter.value),
                                    onClick: ()=>toggleFilter(filter.value),
                                    children: filter.label
                                }, `${filter.label}-${String(filter.value)}`))
                        })
                    ]
                })
            })
        ]
    });
};
const $218d5b64312ef184$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("SM", "flexstart", "center")}

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		${(0, $5WGN2.stack)("XS")}
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		width: 100%;
		${(0, $5WGN2.stack)("XS")}
	}
`;
const $218d5b64312ef184$var$FiltersContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("XS", "flexstart", "flexstart")}
	
	// I want that each raws have 10px padding top
	margin-top: 10px;
`;
const $218d5b64312ef184$var$FilterTitle = (0, $5UMQ1.default).div`
  ${(0, $5WGN2.row)(2, undefined, "center")}

  min-height: 36px;
  white-space: nowrap;
  width: fit-content;
  border-radius: 8px;
  color: ${(0, $kKnoQ.colors).grey};
`;
const $218d5b64312ef184$var$FilterItemContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("XS", "flexstart", "center")}
	flex-wrap: wrap;

`;
const $218d5b64312ef184$var$FilterItem = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(2, undefined, "center")}

	min-height: 36px;
	padding: 0 12px 0 12px;
	cursor: pointer;
	white-space: nowrap;
	width: fit-content;
	border-radius: 8px;
	background-color: ${({ isActive: isActive })=>isActive ? (0, $kKnoQ.colors).primary10 : "transparent"};
	border: 1px solid ${({ isActive: isActive })=>isActive ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).primary25};
	color: ${({ isActive: isActive })=>isActive ? (0, $kKnoQ.colors).black : (0, $kKnoQ.colors).grey};

	:hover {
		background-color: ${({ isActive: isActive })=>isActive ? (0, $kKnoQ.colors).primary25 : (0, $kKnoQ.colors).primaryBackground};
	}
`;
const $218d5b64312ef184$var$SearchContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("XS", "flexstart", "center")}
	min-width: 345px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		min-width: unset;
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		width: 100%;
	}
`;
const $218d5b64312ef184$var$Row = (0, $5UMQ1.default).div`
	flex: 1;
`;
const $218d5b64312ef184$var$StyledTextInput = (0, $5UMQ1.default)((0, $hIci4.TextInput))`
	width: 100%;
`;
const $218d5b64312ef184$var$ClearSearchButton = (0, $5UMQ1.default).i`
	cursor: pointer;
	display: ${({ displayed: displayed })=>displayed ? undefined : "none"};

	:hover {
		color: ${(0, $kKnoQ.colors).primary} !important;
	}
`;

});

parcelRegister("ijyoE", function(module, exports) {

$parcel$export(module.exports, "SortDropdown", () => $884e1135721ea30d$export$a1dacc7d85bcff8f);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $eT9rN = parcelRequire("eT9rN");

var $5WGN2 = parcelRequire("5WGN2");
const $884e1135721ea30d$export$a1dacc7d85bcff8f = ({ sortOptions: sortOptions, onChange: onChange })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const [selectedOption, setSelectedOption] = (0, $81g6h.useState)();
    const onSortChange = (0, $81g6h.useCallback)((e)=>setSelectedOption(e.value), []);
    (0, $81g6h.useEffect)(()=>{
        setSelectedOption(sortOptions.length > 0 ? sortOptions[0] : undefined);
    }, [
        sortOptions
    ]);
    (0, $81g6h.useEffect)(()=>selectedOption && onChange(selectedOption.key), [
        onChange,
        selectedOption
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($884e1135721ea30d$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: format("templateListing.sortLabel")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $eT9rN.Dropdown), {
                value: selectedOption,
                options: sortOptions,
                onChange: onSortChange
            })
        ]
    });
};
const $884e1135721ea30d$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("XS", "flexstart", "center")}
`;

});

parcelRegister("lLAgw", function(module, exports) {

$parcel$export(module.exports, "useProgramCard", () => $57d5cc6b8d97a35b$export$6ee1e4f462775e96);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $a6fIt = parcelRequire("a6fIt");

var $htiSH = parcelRequire("htiSH");

var $8fBuh = parcelRequire("8fBuh");

var $lTdpc = parcelRequire("lTdpc");

var $2hf1V = parcelRequire("2hf1V");

var $4UKJF = parcelRequire("4UKJF");

var $243Cr = parcelRequire("243Cr");

var $lDZlX = parcelRequire("lDZlX");

var $iBbjf = parcelRequire("iBbjf");

var $bC9c0 = parcelRequire("bC9c0");

var $5SzTW = parcelRequire("5SzTW");
var $57d5cc6b8d97a35b$var$DeleteIcon = function DeleteIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M10.82 2c-.52 0-1.01.2-1.38.57L9.01 3h-5c-.13 0-.26.02-.39.07a1.004 1.004 0 0 0-.55.55c-.05.12-.07.25-.07.39s.02.26.07.39c.05.12.13.23.22.33.1.09.21.17.33.22.13.05.26.07.39.07h16c.13 0 .26-.02.39-.07a1.004 1.004 0 0 0 .55-.55c.05-.12.07-.25.07-.39s-.02-.26-.07-.39a1.19 1.19 0 0 0-.22-.33c-.1-.09-.21-.17-.33-.22-.13-.05-.26-.07-.39-.07h-5l-.43-.43A1.92 1.92 0 0 0 13.2 2h-2.38ZM16.13 22H7.88c-1.5 0-2.78-1.05-2.97-2.447L3.409 8.136a1 1 0 0 1 .991-1.13h15.22a1 1 0 0 1 .991 1.13L19.11 19.534C18.9 20.95 17.62 22 16.13 22ZM5.5 8.88l1.39 10.448c.06.44.5.797.99.797h8.25c.5 0 .93-.356 1-.825l1.39-10.42H5.5Z",
            fill: "currentColor"
        })
    });
};
$57d5cc6b8d97a35b$var$DeleteIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $57d5cc6b8d97a35b$var$DuplicateIcon = function DuplicateIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M4 2a2 2 0 0 0-2 2v13a1 1 0 0 0 2 0V4h13a1 1 0 0 0 0-2H4Zm4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H8Zm0 2h12v12H8V8Z",
            fill: "currentColor"
        })
    });
};
$57d5cc6b8d97a35b$var$DuplicateIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $57d5cc6b8d97a35b$var$EditIcon = function EditIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M5 18.01a.99.99 0 0 0 1.69.7l8.335-8.335-1.4-1.4L5.29 17.31a.99.99 0 0 0-.29.7Zm15.003-9.788a1 1 0 0 1-1.41.004l-2.828-2.794a1 1 0 0 1-.004-1.418l.689-.689a1.92 1.92 0 0 1 1.413-.575 1.92 1.92 0 0 1 1.412.575l1.4 1.4c.383.383.583.846.6 1.388a1.806 1.806 0 0 1-.55 1.387l-.722.722Zm-2.86 1.47a1 1 0 0 1 0 1.415l-9.6 9.6a1 1 0 0 1-.707.293H4a1 1 0 0 1-1-1v-2.836a1 1 0 0 1 .293-.707l9.6-9.6a1 1 0 0 1 1.414 0l2.836 2.836Zm-2.818-.017-.7-.7 1.4 1.4-.7-.7Z",
            fill: "currentColor"
        })
    });
};
$57d5cc6b8d97a35b$var$EditIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $57d5cc6b8d97a35b$var$EyeVisibleIcon = function EyeVisibleIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_177_172)",
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M.208 11.128C1.016 9.392 4.511 3 12.01 3c7.473 0 10.978 6.378 11.803 8.11l.005.01.005.01c.246.551.246 1.189 0 1.74l-.005.01-.005.01c-.824 1.73-4.3 8.11-11.803 8.11-7.492 0-10.987-6.399-11.8-8.125a1.974 1.974 0 0 1-.002-1.747ZM12.01 5c-6.225 0-9.23 5.34-9.993 6.981l-.006.013-.003.006.002.004.005.01C2.79 13.662 5.795 19 12.01 19c6.196 0 9.182-5.266 9.99-6.954a.138.138 0 0 0 0-.092C21.193 10.268 18.177 5 12.01 5Z"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M12.01 16.22a4.22 4.22 0 1 0 0-8.44 4.22 4.22 0 0 0 0 8.44Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_177_172",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
};
$57d5cc6b8d97a35b$var$EyeVisibleIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $57d5cc6b8d97a35b$var$StopIcon = function StopIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M19.736 5.7a.885.885 0 0 0-.645-.264.885.885 0 0 0-.646.264.885.885 0 0 0-.263.645v12.01c0 .5-.182.927-.537 1.281a1.751 1.751 0 0 1-1.281.537h-6.319a.94.94 0 0 1-.436-.11.823.823 0 0 1-.318-.29l-3.573-5.21 1.864 1.31a.95.95 0 0 0 1.5-.782V4.727a.885.885 0 0 0-.264-.645.885.885 0 0 0-.645-.264.885.885 0 0 0-.646.264.885.885 0 0 0-.263.645v8.71L4.627 11.6a1.488 1.488 0 0 0-1.072-.273c-.391.046-.737.21-1.019.5a.883.883 0 0 0-.12 1.14l5.375 7.86c.254.382.582.673.982.873.39.21.818.31 1.272.31h6.319c1.109 0 2.045-.437 2.8-1.32A3.544 3.544 0 0 0 20 18.374V6.355a.885.885 0 0 0-.264-.646V5.7Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M8.83 13.172c.964-.345 3.615-.672 4.634-.69a9.166 9.166 0 0 1 3.309.545c.1.037 1.308.477 1.417.477a.907.907 0 0 0 .855-.6.907.907 0 0 0-.546-1.164c-.336-.118-1.79-.64-2.135-.73V3.817a.885.885 0 0 0-.264-.645.885.885 0 0 0-.646-.264.885.885 0 0 0-.645.264.885.885 0 0 0-.264.645v6.891a14.856 14.856 0 0 0-1.109-.045c-.236 0-.472.018-.709.045v-7.8a.885.885 0 0 0-.263-.645.885.885 0 0 0-.646-.264.885.885 0 0 0-.645.264.885.885 0 0 0-.264.645V11c-.354.09-2.342.336-2.688.454a.907.907 0 0 0-.545 1.163.907.907 0 0 0 1.164.546l-.01.01Z",
                fill: "currentColor"
            })
        ]
    });
};
$57d5cc6b8d97a35b$var$StopIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
function $57d5cc6b8d97a35b$export$6ee1e4f462775e96() {
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const user = (0, $4UKJF.useUser)();
    const { duplicateAsDraftProgram: duplicateAsDraftProgram, duplicateAsTemplateProgram: duplicateAsTemplateProgram } = (0, $2hf1V.useProgramActions)();
    const [lastProgramAdded, setLastProgramAdded] = (0, $81g6h.useState)();
    const { newProgramId: lastTemplateAdded } = (0, $8fBuh.useStateParams)();
    const navigateToProgram = (0, $81g6h.useCallback)((patient, program, fromCardActions)=>{
        (0, $bC9c0.sendAnalyticsEventViewProgram)(patient.analyticsId, program, fromCardActions ? (0, $bC9c0.AnalyticsProgramClickType).PROGRAM_LIST_DETAIL : (0, $bC9c0.AnalyticsProgramClickType).PROGRAM_LIST_CLICK);
        navigate((0, $lDZlX.RoutesPath).ProgramBuilder, {
            route: {
                patientId: patient.id
            },
            query: {
                programId: program.id
            }
        });
    }, [
        navigate
    ]);
    const navigateToTemplate = (0, $81g6h.useCallback)((template, fromCardActions)=>{
        (0, $iBbjf.sendAnalyticsEventViewTemplate)(template.id, fromCardActions);
        navigate((0, $lDZlX.RoutesPath).TemplateBuilder, {
            query: {
                templateId: template.id
            }
        });
    }, [
        navigate
    ]);
    const getProgramCardActions = (0, $81g6h.useCallback)((patient, program, onDuplicateAsTemplate)=>{
        const canEdit = program.status === (0, $5SzTW.ProgramStatus).Draft || program.status === (0, $5SzTW.ProgramStatus).Scheduled;
        const canStop = program.status === (0, $5SzTW.ProgramStatus).Ongoing;
        return [
            {
                text: canEdit ? format("global.programOperation.edit") : format("global.programOperation.see"),
                icon: canEdit ? /*#__PURE__*/ (0, $iKObn.jsx)($57d5cc6b8d97a35b$var$EditIcon, {}) : /*#__PURE__*/ (0, $iKObn.jsx)($57d5cc6b8d97a35b$var$EyeVisibleIcon, {}),
                onClick: ()=>navigateToProgram(patient, program, true),
                testId: (0, $a6fIt.e2eTestId).programTab.programMenu.goToBuilderButton
            },
            {
                text: format("global.programOperation.duplicateAsDraft"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($57d5cc6b8d97a35b$var$DuplicateIcon, {}),
                onClick: ()=>{
                    duplicateAsDraftProgram({
                        patientId: patient.id,
                        programName: program.name,
                        programId: program.id,
                        onSuccess: setLastProgramAdded
                    });
                },
                testId: (0, $a6fIt.e2eTestId).programTab.programMenu.duplicateAsDraftButton
            },
            {
                text: format("global.programOperation.duplicateAsTemplate"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($57d5cc6b8d97a35b$var$DuplicateIcon, {}),
                onClick: ()=>{
                    dialogContext?.openModal((0, $243Cr.ModalId).DuplicateAsTemplateProgram, {
                        programName: program.name,
                        onSubmit: async (templateName)=>{
                            duplicateAsTemplateProgram({
                                patientId: patient.id,
                                programId: program.id,
                                templateName: templateName
                            });
                            dialogContext.closeAll();
                            onDuplicateAsTemplate?.();
                        }
                    });
                },
                testId: (0, $a6fIt.e2eTestId).programTab.programMenu.duplicateAsTemplateButton
            },
            canStop && (0, $lTdpc.isNotNil)(user) ? {
                destructive: true,
                text: format("global.programOperation.stop"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($57d5cc6b8d97a35b$var$StopIcon, {}),
                onClick: ()=>{
                    dialogContext?.openModal((0, $243Cr.ModalId).StopProgram, {
                        onSuccess: ()=>(0, $bC9c0.sendAnalyticsEventStopProgram)(patient, program.id, (0, $bC9c0.AnalyticsProgramLocation).PATIENT_DETAIL),
                        program: program,
                        patient: patient,
                        editor: user
                    });
                },
                testId: (0, $a6fIt.e2eTestId).programTab.programMenu.stopProgramButton
            } : {
                destructive: true,
                text: format("global.programOperation.delete"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($57d5cc6b8d97a35b$var$DeleteIcon, {}),
                onClick: ()=>{
                    dialogContext?.openModal((0, $243Cr.ModalId).DeleteProgram, {
                        patient: patient,
                        program: program,
                        onSuccess: ()=>(0, $bC9c0.sendAnalyticsEventDeleteProgram)(patient, program.id, (0, $bC9c0.AnalyticsProgramLocation).PATIENT_DETAIL)
                    });
                },
                testId: (0, $a6fIt.e2eTestId).programTab.programMenu.deleteProgramButton
            }
        ];
    }, [
        dialogContext,
        duplicateAsDraftProgram,
        duplicateAsTemplateProgram,
        format,
        navigateToProgram,
        user
    ]);
    const getTemplateCardActions = (0, $81g6h.useCallback)((template)=>[
            {
                text: format("templateListing.templateCard.option.edit"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($57d5cc6b8d97a35b$var$EditIcon, {}),
                testId: (0, $a6fIt.e2eTestId).createTemplatePage.templateMenu.goToBuilderButton,
                onClick: ()=>navigateToTemplate(template, true)
            },
            {
                destructive: true,
                text: format("templateBuilder.popupMenu.deleteTemplate"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($57d5cc6b8d97a35b$var$DeleteIcon, {}),
                testId: (0, $a6fIt.e2eTestId).createTemplatePage.templateMenu.deleteTemplateButton,
                onClick: ()=>{
                    dialogContext?.openModal((0, $243Cr.ModalId).DeleteTemplate, {
                        templateId: template.id,
                        templateName: template.name
                    });
                }
            }
        ], [
        format,
        navigateToTemplate,
        dialogContext
    ]);
    return {
        lastProgramAdded: lastProgramAdded,
        lastTemplateAdded: lastTemplateAdded,
        navigateToProgram: navigateToProgram,
        navigateToTemplate: navigateToTemplate,
        getProgramCardActions: getProgramCardActions,
        getTemplateCardActions: getTemplateCardActions
    };
}

});
parcelRegister("8fBuh", function(module, exports) {

$parcel$export(module.exports, "useStateParams", () => $bd357a32dd6fbe33$export$8f953891cb0b6f04);

var $81g6h = parcelRequire("81g6h");
parcelRequire("aanF2");
var $hE6rp = parcelRequire("hE6rp");

var $lTdpc = parcelRequire("lTdpc");
function $bd357a32dd6fbe33$export$8f953891cb0b6f04() {
    const location = (0, $hE6rp.useLocation)();
    return (0, $81g6h.useMemo)(()=>{
        if ((0, $lTdpc.isNotNil)(location.state)) return location.state;
        return {};
    }, [
        location
    ]);
}

});


parcelRegister("29TYN", function(module, exports) {

$parcel$export(module.exports, "EmptyContainer", () => $102559b9667d64cf$export$a431988949589239);
$parcel$export(module.exports, "TabContainer", () => $102559b9667d64cf$export$eed545bf41e40386);
$parcel$export(module.exports, "TabHeader", () => $102559b9667d64cf$export$7fe377eaca5775a);
$parcel$export(module.exports, "Layout", () => $102559b9667d64cf$export$c84671f46d6a1ca);
$parcel$export(module.exports, "CardWrapper", () => $102559b9667d64cf$export$6aa22a823032b784);

var $5UMQ1 = parcelRequire("5UMQ1");

var $dU78w = parcelRequire("dU78w");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");
const $102559b9667d64cf$export$a431988949589239 = (0, $5UMQ1.default).div`
	display: grid;
	place-items: center;
`;
const $102559b9667d64cf$export$eed545bf41e40386 = (0, $5UMQ1.default).div`
	padding-top: 24px;
`;
const $102559b9667d64cf$export$7fe377eaca5775a = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "flexstart")};

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 0 16px;
	}
`;
const $102559b9667d64cf$export$c84671f46d6a1ca = (0, $5UMQ1.default)((0, $dU78w.motion).div)`
	padding-top: 24px;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
	grid-template-rows: min-content;
	grid-gap: 24px 32px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 16px;
		grid-gap: 16px 24px;
	}
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		grid-template-columns: 1fr;
	}
`;
const $102559b9667d64cf$export$6aa22a823032b784 = (0, $5UMQ1.default)((0, $dU78w.motion).div)`
	${(0, $5WGN2.stack)(undefined, "flexstart", "stretch")}
`;

});


parcelRegister("6kyF0", function(module, exports) {

$parcel$export(module.exports, "TemplatesTab", () => $3e31ddaede3cc1ef$export$32e9e432784ad02d);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $1IWnK = parcelRequire("1IWnK");

var $dDMmD = parcelRequire("dDMmD");

var $4UKJF = parcelRequire("4UKJF");

var $a6fIt = parcelRequire("a6fIt");

var $lTdpc = parcelRequire("lTdpc");

var $5kXMA = parcelRequire("5kXMA");

var $ghfIB = parcelRequire("ghfIB");

var $fuvmS = parcelRequire("fuvmS");

var $duy6w = parcelRequire("duy6w");

var $6W52T = parcelRequire("6W52T");

var $3f6gX = parcelRequire("3f6gX");

var $2gV4e = parcelRequire("2gV4e");

var $dafz7 = parcelRequire("dafz7");

var $ijyoE = parcelRequire("ijyoE");

var $lLAgw = parcelRequire("lLAgw");

var $29TYN = parcelRequire("29TYN");
const $3e31ddaede3cc1ef$export$32e9e432784ad02d = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const user = (0, $4UKJF.useUser)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const templates = (0, $1IWnK.useObservable)((0, $ghfIB.templateManager).templateItems) ?? [];
    const { lastTemplateAdded: lastTemplateAdded, navigateToTemplate: navigateToTemplate, getTemplateCardActions: getTemplateCardActions } = (0, $lLAgw.useProgramCard)();
    const { setSearch: setSearch, filteredTemplates: filteredTemplates, templateTotalCount: templateTotalCount } = (0, $3f6gX.useTemplateFilters)(templates);
    const { allSortOptions: allSortOptions, setSortKey: setSortKey, sortedTemplates: sortedFilteredTemplates } = (0, $2gV4e.useTemplateSort)(filteredTemplates);
    const filterTemplates = (0, $81g6h.useCallback)((search)=>setSearch(search), [
        setSearch
    ]);
    const sortTemplates = (0, $81g6h.useCallback)((key)=>setSortKey(key), [
        setSortKey
    ]);
    return templateTotalCount === 0 ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $29TYN.EmptyContainer), {
        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $duy6w.EmptyTemplates), {})
    }) : /*#__PURE__*/ (0, $iKObn.jsxs)((0, $29TYN.TabContainer), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)((0, $29TYN.TabHeader), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $dafz7.SearchFilter), {
                        placeholder: format("templateListing.templates.searchInputPlaceholder"),
                        onChange: filterTemplates
                    }),
                    isDesktop && /*#__PURE__*/ (0, $iKObn.jsx)((0, $ijyoE.SortDropdown), {
                        sortOptions: allSortOptions,
                        onChange: sortTemplates
                    })
                ]
            }),
            sortedFilteredTemplates.length === 0 ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $29TYN.EmptyContainer), {
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $6W52T.EmptyTemplatesSearch), {})
            }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $29TYN.Layout), {
                "data-test": (0, $a6fIt.e2eTestId).createTemplatePage.templateGrid,
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dDMmD.AnimatePresence), {
                    presenceAffectsLayout: true,
                    children: (0, $lTdpc.isNotNil)(user) && sortedFilteredTemplates.map((template)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $29TYN.CardWrapper), {
                            layoutId: template.id,
                            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $fuvmS.TemplateCard), {
                                template: template,
                                cardActions: getTemplateCardActions(template),
                                onClick: ()=>navigateToTemplate(template),
                                editor: user,
                                isNew: lastTemplateAdded === template.id
                            })
                        }, template.id))
                })
            })
        ]
    });
};

});
parcelRegister("duy6w", function(module, exports) {

$parcel$export(module.exports, "EmptyTemplates", () => $7a1ffc2ebf210c5d$export$42182e5ce4d3f843);

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $5CjOe = parcelRequire("5CjOe");

var $lDZlX = parcelRequire("lDZlX");

var $bC9c0 = parcelRequire("bC9c0");
var $7a1ffc2ebf210c5d$var$NoTemplatesIcon = function NoTemplatesIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M46.12 60.687H17.818A7.817 7.817 0 0 1 10 52.869V11.818C10 7.499 13.5 4 17.818 4h25.191c1.092 0 2.143.438 2.912 1.216l6.842 6.925a4.107 4.107 0 0 1 1.183 2.87V52.87c0 4.318-3.5 7.818-7.818 7.818h-.008Z",
                fill: "#ECEDFC",
                stroke: "#2275F0",
                strokeWidth: "3",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeDasharray: "5 8"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "m20.209 37.812 7.81-7.802 7.023 7.024 10.722-10.722",
                stroke: "#2275F0",
                strokeWidth: "5.394",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M52 63.776c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12s-12 5.372-12 12c0 6.627 5.373 12 12 12Z",
                fill: "#20BB71"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M52 44.75c.346 0 .649.12.89.36.24.241.36.544.36.89v4.75H58c.346 0 .649.12.89.36.24.241.36.544.36.89s-.12.649-.36.89c-.241.24-.544.36-.89.36h-4.75V58c0 .346-.12.649-.36.89-.241.24-.544.36-.89.36s-.649-.12-.89-.36c-.24-.241-.36-.544-.36-.89v-4.75H46c-.346 0-.649-.12-.89-.36-.24-.241-.36-.544-.36-.89s.12-.649.36-.89c.241-.24.544-.36.89-.36h4.75V46c0-.346.12-.649.36-.89.241-.24.544-.36.89-.36Z",
                fill: "#fff",
                stroke: "#fff",
                strokeWidth: ".5"
            })
        ]
    });
};
$7a1ffc2ebf210c5d$var$NoTemplatesIcon.defaultProps = {
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $7a1ffc2ebf210c5d$export$42182e5ce4d3f843 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    const sendAnalytics = ()=>(0, $bC9c0.sendAnalyticsEventCreateProgram)((0, $bC9c0.AnalyticsProgramLocation).PROGRAM_PAGE);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $5CjOe.MessageContainer), {
        style: {
            flexGrow: 1,
            padding: "72px 32px"
        },
        iconSvg: $7a1ffc2ebf210c5d$var$NoTemplatesIcon,
        title: format("templateListing.noTemplates.title"),
        description: format("templateListing.noTemplates.description"),
        cta: {
            label: format("templateListing.createProgramButton"),
            onClick: ()=>{
                sendAnalytics();
                navigate((0, $lDZlX.RoutesPath).TemplateBuilder);
            }
        }
    });
};

});

parcelRegister("6W52T", function(module, exports) {

$parcel$export(module.exports, "EmptyTemplatesSearch", () => $2b1d44c9c136d5d1$export$4af476fc6cc1e353);

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $5CjOe = parcelRequire("5CjOe");
var $2b1d44c9c136d5d1$var$EmptyBoxIcon = function EmptyBoxIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_9595_47349)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask0_9595_47349",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "20",
                        width: "65",
                        height: "43",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "m.6 41.56 11.655-17.345a7.536 7.536 0 0 1 6.256-3.334h28.163a7.536 7.536 0 0 1 6.257 3.334L64.585 41.56v21.172H.6S.813 41.347.6 41.56Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("g", {
                        mask: "url(#mask0_9595_47349)",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M-2.36 26.492C-7.572 5.262 9.355-12.297 30.666-7.854c21.23-5.214 38.79 11.713 34.346 33.024 5.214 21.23-11.713 38.79-33.024 34.346C10.757 64.73-6.803 47.803-2.36 26.492Z",
                            fill: "#33009A"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask1_9595_47349",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "42",
                        width: "65",
                        height: "21",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M45.763 45.608a3.545 3.545 0 0 1-3.546 3.547H22.984a3.545 3.545 0 0 1-3.548-3.547 3.545 3.545 0 0 0-3.546-3.547H.614v14.687A5.986 5.986 0 0 0 6.6 62.733h52.015a5.986 5.986 0 0 0 5.985-5.985V42.06H49.325a3.545 3.545 0 0 0-3.547 3.547h-.015Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask1_9595_47349)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M35.703 92.835c19.013 0 34.427-15.4 34.427-34.398 0-18.997-15.414-34.397-34.427-34.397-19.014 0-34.427 15.4-34.427 34.397s15.413 34.398 34.427 34.398Z",
                                fill: "#50F"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M61.302 61.984c-3.393 15.774-18.381 26.473-34.39 24.285-7.314-.999-13.578-4.634-17.992-9.84-5.03-5.934-7.432-13.939-6.448-22.266.39-3.305 1.22-6.47 2.49-9.363 5.11-11.574 17.294-19.167 30.586-17.86 5.265.536 10.516 2.188 14.584 5.273 4.098 3.113 6.507 7.52 8.578 12.095 1.593 3.525 3.003 7.13 3.231 11.096.125 2.188-.169 4.399-.639 6.58Z",
                                fill: "#4427FA"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M60.862 61.646C56.066 78.588 39.69 90.103 22.124 88.384c-7.762-.764-14.496-4.26-19.387-9.525-5.581-6.007-8.218-14.408-7.726-23.213.213-3.804.83-7.542 1.99-11C1.68 30.89 14.957 20.86 30.268 21.116c6.022.104 12.837 1.227 17.713 4.76 5.104 3.693 6.925 9.487 9.407 14.95 1.939 4.245 4.303 8.248 4.62 13.014.175 2.643-.42 5.265-1.146 7.813v-.007Z",
                                fill: "#334EF5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M49.773 58.98c-4.95 12.998-17.97 21.81-31.93 21.304-5.823-.213-11.008-2.372-14.952-6.015-4.494-4.149-6.682-10.376-6.91-16.927-.11-3.253.037-6.514.683-9.59 2.54-12.184 12.998-22.134 26.019-23.397 5.067-.492 11.735-.448 16.111 2.526 4.781 3.26 5.222 9.018 7.454 13.872 1.755 3.826 4.62 7.057 4.957 11.324.191 2.38-.602 4.7-1.44 6.903h.008Z",
                                fill: "#2275F0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M36.987 56.88C32.111 66 22.234 71.971 11.872 72.75c-3.877.293-7.512-.485-10.509-2.505-3.407-2.298-5.31-6.367-6.088-10.64-.492-2.718-.741-5.486-.631-8.189.448-10.604 8.034-20.459 18.778-23.264 4.112-1.072 10.648-2.137 14.503.294 4.465 2.812 3.525 8.547 5.5 12.8 1.58 3.407 4.936 5.86 5.295 9.634.206 2.123-.749 4.15-1.733 5.993v.007Z",
                                fill: "#119CEB"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M24.1 44.623c1.057 2.255 3.965 3.525 4.251 5.992.162 1.41-.624 2.754-1.534 3.841-3.445 4.12-8.754 6.08-13.814 7.873-1.476.521-3.04 1.057-4.575.763-1.748-.33-3.158-1.71-3.98-3.29-.823-1.578-1.146-3.363-1.461-5.118-1.227-6.808 2.335-14.159 8.702-17.463 2.386-1.241 7.218-2.894 9.737-1.462 3.144 1.778 1.381 6.096 2.674 8.857v.007Z",
                                fill: "#00C3E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M33.309 2.88c.874 0 1.589.715 1.589 1.589v8.768c0 .874-.715 1.59-1.59 1.59a1.594 1.594 0 0 1-1.588-1.59V4.47c0-.874.715-1.59 1.589-1.59ZM41.236 8.269c.62-.62 1.628-.62 2.248 0 .62.62.62 1.628 0 2.248l-3.65 3.65c-.309.309-.714.468-1.12.468h-.008a1.592 1.592 0 0 1-1.12-2.717l3.65-3.649ZM22.51 8.269c.62-.62 1.628-.62 2.248 0l3.65 3.65a1.592 1.592 0 0 1-1.12 2.716h-.008c-.406 0-.812-.16-1.12-.469l-3.65-3.649a1.592 1.592 0 0 1 0-2.248Z",
                        fill: "#FF0A4B",
                        stroke: "#FF0A4B",
                        strokeWidth: ".24"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_9595_47349",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(.6 .6)",
                        d: "M0 0h64v64H0z"
                    })
                })
            })
        ]
    });
};
$2b1d44c9c136d5d1$var$EmptyBoxIcon.defaultProps = {
    width: "65",
    height: "65",
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $2b1d44c9c136d5d1$export$4af476fc6cc1e353 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $5CjOe.MessageContainer), {
        style: {
            flexGrow: 1,
            padding: "72px 32px"
        },
        iconSvg: $2b1d44c9c136d5d1$var$EmptyBoxIcon,
        title: format("templateListing.templates.emptySearch.title"),
        description: format("templateListing.templates.emptySearch.description")
    });
};

});

parcelRegister("2gV4e", function(module, exports) {

$parcel$export(module.exports, "useTemplateSort", () => $39c8adfe117558f3$export$fbd0027d4bb9052a);

var $81g6h = parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $5kXMA = parcelRequire("5kXMA");
var $39c8adfe117558f3$export$eff6ca186a9b7906;
(function(TemplateSortKey) {
    TemplateSortKey["LastEdited"] = "LastEdited";
    TemplateSortKey["TemplateName"] = "TemplateName";
})($39c8adfe117558f3$export$eff6ca186a9b7906 || ($39c8adfe117558f3$export$eff6ca186a9b7906 = {}));
function $39c8adfe117558f3$export$fbd0027d4bb9052a(programs) {
    const { format: format } = (0, $1eHG3.useI18n)();
    const collator = (0, $81g6h.useMemo)(()=>new Intl.Collator(), []);
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const [sortKey, setSortKey] = (0, $81g6h.useState)("LastEdited");
    const compareByLastEdited = (0, $81g6h.useCallback)((a, b)=>b.lastEditionDate.diff(a.lastEditionDate), []);
    const compareByTemplateName = (0, $81g6h.useCallback)((a, b)=>{
        const result = collator.compare(a.name, b.name);
        if (result !== 0) return result;
        return compareByLastEdited(a, b);
    }, [
        collator,
        compareByLastEdited
    ]);
    const sortedTemplates = (0, $81g6h.useMemo)(()=>{
        switch(sortKey){
            case "LastEdited":
                return [
                    ...programs
                ].sort((a, b)=>compareByLastEdited(a, b));
            case "TemplateName":
                return [
                    ...programs
                ].sort((a, b)=>compareByTemplateName(a, b));
        }
    }, [
        sortKey,
        programs,
        compareByLastEdited,
        compareByTemplateName
    ]);
    const allSortOptions = (0, $81g6h.useMemo)(()=>isDesktop ? Object.values({
            ["LastEdited"]: {
                label: format("templateListing.templates.sort.lastEdited"),
                key: "LastEdited"
            },
            ["TemplateName"]: {
                label: format("templateListing.templates.sort.templateName"),
                key: "TemplateName"
            }
        }) : [], [
        format,
        isDesktop
    ]);
    return {
        allSortOptions: allSortOptions,
        setSortKey: setSortKey,
        sortedTemplates: sortedTemplates
    };
}

});








parcelRegister("9oyj9", function(module, exports) {

$parcel$export(module.exports, "ConfirmActionDialog", () => $066f64354d485e05$export$a7933bebbd8e283c);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $a6fIt = parcelRequire("a6fIt");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");
parcelRequire("81g6h");
const $066f64354d485e05$export$a7933bebbd8e283c = ({ title: title, message: message, cancelButtonLabel: cancelButtonLabel, confirmButtonLabel: confirmButtonLabel, onCancel: onCancel, onConfirm: onConfirm, confirmButtonStyle: confirmButtonStyle = "danger", confirmLoading: confirmLoading, width: width = (0, $gk3fY.DIALOG_SIZE).S, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $gk3fY.BaseDialog), {
        header: title,
        footer: /*#__PURE__*/ (0, $iKObn.jsxs)($066f64354d485e05$var$ButtonContainer, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                    "data-test": (0, $a6fIt.e2eTestId).confirmActionDialog.cancelButton,
                    uiStyle: "secondary",
                    onClick: onCancel,
                    label: cancelButtonLabel ?? format("global.dialog.cancel")
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                    "data-test": (0, $a6fIt.e2eTestId).confirmActionDialog.yesButton,
                    uiStyle: confirmButtonStyle,
                    onClick: onConfirm,
                    loading: confirmLoading,
                    label: confirmButtonLabel ?? format("global.dialog.yes")
                })
            ]
        }),
        width: width,
        ...otherProps,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("p", {
            style: {
                whiteSpace: "pre-line"
            },
            children: message
        })
    });
};
const $066f64354d485e05$var$ButtonContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(24, "flexend")}
`;

});


parcelRegister("hcxj3", function(module, exports) {

$parcel$export(module.exports, "AddSurveyDialog", () => $0e3742a496272280$export$4fd83372999502e4);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $81g6h = parcelRequire("81g6h");

var $gk3fY = parcelRequire("gk3fY");

var $lPWHT = parcelRequire("lPWHT");

var $dHsvm = parcelRequire("dHsvm");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $1IWnK = parcelRequire("1IWnK");
var $0e3742a496272280$export$237842b8dd0157ff;
(function(SurveyDialogStep) {
    SurveyDialogStep["SurveyInvitation"] = "SurveyInvitation";
    SurveyDialogStep["SurveyForm"] = "SurveyForm";
})($0e3742a496272280$export$237842b8dd0157ff || ($0e3742a496272280$export$237842b8dd0157ff = {}));
const $0e3742a496272280$export$4fd83372999502e4 = ({ survey: survey, onHide: onHide, ...otherProps })=>{
    const { format: format, locale: locale } = (0, $1eHG3.useI18n)();
    const translations = (0, $ghfIB.translationsManager).getLocaleWordings(locale);
    const [step, setStep] = (0, $81g6h.useState)(()=>"SurveyInvitation");
    const [widthSize, setWidthSize] = (0, $81g6h.useState)((0, $gk3fY.DIALOG_SIZE).S);
    const [heightSize, setHeightSize] = (0, $81g6h.useState)("");
    const isSurveyCompleted = (0, $1IWnK.useObservable)((0, $ghfIB.userSurveyManager).isSurveyCompleted);
    const popupTitle = (0, $81g6h.useMemo)(()=>survey.popupTitleKey in translations ? translations[survey.popupTitleKey] : format("survey.popup.nps.title"), [
        format,
        survey.popupTitleKey,
        translations
    ]);
    const onClose = (0, $81g6h.useCallback)(async ()=>{
        if (!isSurveyCompleted) {
            await (0, $ghfIB.userSurveyManager).dismissSurvey(survey.id);
            (0, $ghfIB.analyticsService).trackEvent({
                category: (0, $auPqo.AnalyticsCategory).SURVEY,
                action: "modaleSecondaryCta",
                params: [
                    survey.title
                ]
            });
        }
        onHide();
    }, [
        isSurveyCompleted,
        onHide,
        survey
    ]);
    const renderStep = (0, $81g6h.useCallback)(()=>{
        switch(step){
            case "SurveyInvitation":
                return /*#__PURE__*/ (0, $iKObn.jsx)((0, $lPWHT.InviteSurvey), {
                    onClose: onClose,
                    nextStepSurvey: ()=>{
                        setStep("SurveyForm");
                    },
                    surveyWordingKeys: {
                        popupBodyKey: survey.popupBodyKey,
                        popupPrimaryCtaKey: survey.popupPrimaryCtaKey,
                        popupSecondaryCtaKey: survey.popupSecondaryCtaKey
                    }
                });
            case "SurveyForm":
                return /*#__PURE__*/ (0, $iKObn.jsx)((0, $dHsvm.CreateSurveyForm), {
                    survey: survey,
                    setWidth: setWidthSize,
                    setHeight: setHeightSize
                });
        }
    }, [
        survey,
        onClose,
        step
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $gk3fY.BaseDialog), {
        dismissableMask: isSurveyCompleted,
        closeOnEscape: false,
        visible: true,
        onHide: onClose,
        width: widthSize,
        height: heightSize,
        header: step === "SurveyInvitation" ? popupTitle : "",
        hideScrollbar: true,
        ...otherProps,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($0e3742a496272280$var$DialogContainer, {
            children: renderStep()
        })
    });
};
const $0e3742a496272280$var$DialogContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("M", "flexstart", "stretch")};
`;

});
parcelRegister("lPWHT", function(module, exports) {

$parcel$export(module.exports, "InviteSurvey", () => $233102631ff77dc0$export$ddb3606e4baf1b7b);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $81g6h = parcelRequire("81g6h");

var $dhb7H = parcelRequire("dhb7H");

var $ghfIB = parcelRequire("ghfIB");
const $233102631ff77dc0$export$ddb3606e4baf1b7b = ({ nextStepSurvey: nextStepSurvey, onClose: onClose, surveyWordingKeys: surveyWordingKeys })=>{
    const { format: format, locale: locale } = (0, $1eHG3.useI18n)();
    const { popupBody: popupBody, popupPrimaryCta: popupPrimaryCta, popupSecondaryCta: popupSecondaryCta } = (0, $81g6h.useMemo)(()=>{
        const translations = (0, $ghfIB.translationsManager).getLocaleWordings(locale);
        return {
            popupBody: surveyWordingKeys.popupBodyKey in translations ? translations[surveyWordingKeys.popupBodyKey] : format("survey.popup.nps.body"),
            popupPrimaryCta: surveyWordingKeys.popupPrimaryCtaKey in translations ? translations[surveyWordingKeys.popupPrimaryCtaKey] : format("survey.popup.nps.cta.shareYourFeedback"),
            popupSecondaryCta: surveyWordingKeys.popupSecondaryCtaKey in translations ? translations[surveyWordingKeys.popupSecondaryCtaKey] : format("survey.popup.nps.cta.notNow")
        };
    }, [
        format,
        locale,
        surveyWordingKeys
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                children: popupBody
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($233102631ff77dc0$var$ButtonContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                        uiStyle: "secondary",
                        label: popupSecondaryCta,
                        id: "closeMe",
                        onClick: onClose
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                        label: popupPrimaryCta,
                        onClick: nextStepSurvey
                    })
                ]
            })
        ]
    });
};
const $233102631ff77dc0$var$ButtonContainer = (0, $5UMQ1.default).div`
	padding-top: 16px;
	${(0, $5WGN2.row)("S", "spacebetween")};
`;

});

parcelRegister("dHsvm", function(module, exports) {

$parcel$export(module.exports, "CreateSurveyForm", () => $a98ed70db0a71ced$export$875653c4475ed90f);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $81g6h = parcelRequire("81g6h");

var $gk3fY = parcelRequire("gk3fY");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $3TO5x = parcelRequire("3TO5x");

var $5kXMA = parcelRequire("5kXMA");
const $a98ed70db0a71ced$var$completeSurvey = async (survey)=>{
    (async ()=>await (0, $ghfIB.userSurveyManager).completeSurvey(survey.id))();
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).SURVEY,
        action: "completedSurvey",
        params: [
            survey.title
        ]
    });
};
const $a98ed70db0a71ced$export$875653c4475ed90f = ({ survey: survey, setWidth: setWidth, setHeight: setHeight })=>{
    const [iframeHeight, setIframeHeight] = (0, $81g6h.useState)(450);
    const { isMobile: isMobile } = (0, $5kXMA.useDimensions)();
    (0, $81g6h.useEffect)(()=>{
        const handleIFrameMessage = async (event)=>{
            // Message from thank-you-survey page
            if (event.origin === window.location.origin && event.data === (0, $3TO5x.SURVEY_COMPLETION_POSTMESSAGE)) await $a98ed70db0a71ced$var$completeSurvey(survey);
        };
        window.addEventListener("message", handleIFrameMessage);
        (0, $ghfIB.analyticsService).trackEvent({
            category: (0, $auPqo.AnalyticsCategory).SURVEY,
            action: "modaleMainCta",
            params: [
                survey.title
            ]
        });
        if (isMobile) setIframeHeight(window.innerHeight - 120);
        else setIframeHeight(window.innerHeight - 220);
        return ()=>{
            window.removeEventListener("message", handleIFrameMessage);
        };
    }, [
        isMobile,
        survey
    ]);
    (0, $81g6h.useEffect)(()=>{
        setWidth((0, $gk3fY.DIALOG_SIZE).XL);
        setHeight(window.innerHeight - 110 + "px");
    }, [
        setWidth,
        setHeight
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($a98ed70db0a71ced$var$Container, {
        children: /*#__PURE__*/ (0, $iKObn.jsx)($a98ed70db0a71ced$var$StyledIframe, {
            src: survey.link,
            height: iframeHeight,
            scrolling: "auto"
        })
    });
};
const $a98ed70db0a71ced$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("L", "flexstart", "center")}
	text-align: center;
	padding-top: 0px;
`;
const $a98ed70db0a71ced$var$StyledIframe = (0, $5UMQ1.default).iframe`
	border: none;
	width: 100%;
	min-width: 650px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		min-width: unset;
	}
`;

});
parcelRegister("3TO5x", function(module, exports) {

$parcel$export(module.exports, "SURVEY_COMPLETION_POSTMESSAGE", () => $ce2ee96786abd0e6$export$6976f8dd1950a5e);
const $ce2ee96786abd0e6$export$6976f8dd1950a5e = "request-survey-completion";

});



parcelRegister("9rH2X", function(module, exports) {

$parcel$export(module.exports, "HealthcareTeamAcceptDialog", () => $9aeb6d50d1521bf5$export$4fd3f0467caed01e);

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $Ukx0s = parcelRequire("Ukx0s");

var $lG6Cp = parcelRequire("lG6Cp");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");

var $9XVwj = parcelRequire("9XVwj");

var $lDZlX = parcelRequire("lDZlX");

var $01XZm = parcelRequire("01XZm");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $buI4E = parcelRequire("buI4E");

var $81g6h = parcelRequire("81g6h");
var $9aeb6d50d1521bf5$var$ProfileCreationIcon = function ProfileCreationIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.677 5.773a.807.807 0 0 0-.807.807v12.647c0 .445.361.806.807.806h12.646a.807.807 0 0 0 .807-.806V6.58a.807.807 0 0 0-.807-.807H5.677ZM2.87 6.58a2.807 2.807 0 0 1 2.807-2.807h12.646A2.807 2.807 0 0 1 21.13 6.58v12.647a2.807 2.807 0 0 1-2.807 2.806H5.677a2.807 2.807 0 0 1-2.807-2.806V6.58Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.613 1.967a1 1 0 0 1 1 1V6.58a1 1 0 1 1-2 0V2.967a1 1 0 0 1 1-1ZM8.387 1.967a1 1 0 0 1 1 1V6.58a1 1 0 0 1-2 0V2.967a1 1 0 0 1 1-1ZM2.87 10.193a1 1 0 0 1 1-1h16.26a1 1 0 1 1 0 2H3.87a1 1 0 0 1-1-1Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M14.178 13.375a.99.99 0 1 1 1.4 1.4l-3.293 3.293a1 1 0 0 1-1.414 0l-1.793-1.793a.99.99 0 1 1 1.4-1.4l1.1 1.1 2.6-2.6Z",
                fill: "currentColor"
            })
        ]
    });
};
$9aeb6d50d1521bf5$var$ProfileCreationIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $9aeb6d50d1521bf5$var$MedicalConditionIcon = function MedicalConditionIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.264 3.99v1.598h5.195V3.99H9.264Zm-2-.1a1.9 1.9 0 0 1 1.9-1.9h5.396a1.9 1.9 0 0 1 1.9 1.9v1.798a1.9 1.9 0 0 1-1.9 1.9H9.164a1.9 1.9 0 0 1-1.9-1.9V3.89Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.466 5.789a.799.799 0 0 0-.8.799v12.591a.799.799 0 0 0 .8.799h10.792a.799.799 0 0 0 .799-.799V6.588a.799.799 0 0 0-.799-.8H15.46a1 1 0 0 1 0-2h1.8a2.799 2.799 0 0 1 2.798 2.8v12.591a2.799 2.799 0 0 1-2.799 2.799H6.466a2.799 2.799 0 0 1-2.8-2.799V6.588a2.799 2.799 0 0 1 2.8-2.8h1.798a1 1 0 1 1 0 2H6.466Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.163 13.783a1 1 0 0 1 1-1h5.397a1 1 0 1 1 0 2H9.163a1 1 0 0 1-1-1Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.862 10.085a1 1 0 0 1 1 1v5.396a1 1 0 1 1-2 0v-5.397a1 1 0 0 1 1-1Z",
                fill: "currentColor"
            })
        ]
    });
};
$9aeb6d50d1521bf5$var$MedicalConditionIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $9aeb6d50d1521bf5$var$PatientInformationIcon = function PatientInformationIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.464 3.464a5 5 0 1 1 7.071 7.071 5 5 0 0 1-7.07-7.07ZM12 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM6.002 14.2C7.997 13.4 10.373 13 12 13c1.627 0 4.003.4 5.998 1.2.999.4 1.964.924 2.696 1.6.74.682 1.306 1.585 1.306 2.7V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1.5c0-1.115.567-2.018 1.306-2.7.732-.676 1.697-1.2 2.696-1.6Zm-1.34 3.07c-.48.442-.662.85-.662 1.23V20h16v-1.5c0-.38-.183-.788-.662-1.23-.486-.45-1.207-.863-2.083-1.214C15.5 15.353 13.377 15 12 15c-1.377 0-3.5.354-5.255 1.056-.876.351-1.597.765-2.083 1.213Z",
            fill: "currentColor"
        })
    });
};
$9aeb6d50d1521bf5$var$PatientInformationIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $9aeb6d50d1521bf5$var$FunctionalStatusIcon = function FunctionalStatusIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M7.5 8.713c1.778-.9 4.062-1.474 5.84.07l.996.957c.626.631 1.21 1.219 1.947 1.654.73.43 1.618.716 2.854.716a.964.964 0 0 1 0 1.928c-3.258 0-4.896-1.654-6.167-2.938l-.004-.004a33.771 33.771 0 0 0-.45-.448l-.975 2.244 3.156 2.255a.964.964 0 0 1 .404.784v5a.964.964 0 1 1-1.928 0v-4.503L10.755 14.7l-2.876 6.616a.964.964 0 0 1-1.77-.77l4.694-10.792c-.701-.03-1.57.215-2.615.774a14.392 14.392 0 0 0-2.682 1.91.964.964 0 0 1-1.32-1.405l.005-.004c.116-.11 1.514-1.407 3.309-2.316ZM15.47 6.497a2.398 2.398 0 1 1-2.665-3.987 2.398 2.398 0 0 1 2.664 3.987Z",
            fill: "currentColor"
        })
    });
};
$9aeb6d50d1521bf5$var$FunctionalStatusIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $9aeb6d50d1521bf5$export$4fd3f0467caed01e = ({ healthcareTeamOutput: { invitation: invitation, patient: patient }, ...otherProps })=>{
    const { format: format, formatAge: formatAge, formatDateMed: formatDateMed } = (0, $1eHG3.useI18n)();
    const { formatFunctionalStatus: formatFunctionalStatus, formatDisease: formatDisease } = (0, $lG6Cp.useFormatMedicalCondition)();
    const navigate = (0, $htiSH.useNavigate)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const patientNameAndAge = (0, $81g6h.useMemo)(()=>{
        const name = (0, $buI4E.formatName)(patient);
        if ((0, $lTdpc.isNotEmpty)(name)) {
            const age = (0, $lTdpc.isNotNil)(patient.birthDate) ? formatAge(patient.birthDate) : undefined;
            if ((0, $lTdpc.isNotNil)(age)) return [
                name,
                age
            ].join(", ");
            return name;
        }
        return format("global.empty");
    }, [
        format,
        formatAge,
        patient
    ]);
    const [acceptInvitation, isLoading] = (0, $grmoS.useAsyncOperation)(async ()=>{
        try {
            await (0, $ghfIB.healthcareTeamManager).confirmInvitation(patient.id);
            (0, $Ukx0s.sendAnalyticsEventAcceptInvitation)(patient);
            otherProps.onHide();
            showToast(format("patientDetails.healthcareTeam.toastJoinSuccess.title"), format("patientDetails.healthcareTeam.toastJoinSuccess.subtitle", {
                patientName: (0, $buI4E.formatName)(patient)
            }), "success");
            navigate((0, $lDZlX.RoutesPath).PatientDetails, {
                route: {
                    patientId: patient.id
                },
                query: {
                    active: (0, $lDZlX.TabPatientDetails).PROGRAMS_TAB
                }
            });
        } catch (e) {
            console.error("Failed to accept healthcare team invite", e);
        }
    }, {});
    const cancelInvitation = (0, $81g6h.useCallback)(()=>{
        (0, $Ukx0s.sendAnalyticsEventCancelInvitation)(patient);
        otherProps.onHide();
    }, [
        otherProps,
        patient
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $gk3fY.BaseDialog), {
        header: format("home.healthcareTeam.acceptDialog.header"),
        footer: /*#__PURE__*/ (0, $iKObn.jsxs)($9aeb6d50d1521bf5$var$ButtonContainer, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                    uiStyle: "secondary",
                    onClick: cancelInvitation,
                    label: format("global.dialog.cancel")
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                    uiStyle: "primary",
                    onClick: acceptInvitation,
                    loading: isLoading,
                    label: format("home.healthcareTeam.acceptDialog.acceptButton")
                })
            ]
        }),
        width: (0, $gk3fY.DIALOG_SIZE).L,
        ...otherProps,
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($9aeb6d50d1521bf5$var$ContentContainer, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                    children: format("home.healthcareTeam.acceptDialog.description.v1_6", {
                        ptName: (0, $buI4E.formatName)(invitation.invitingPt),
                        patientName: (0, $buI4E.formatName)(patient)
                    })
                }),
                invitation.message && /*#__PURE__*/ (0, $iKObn.jsx)($9aeb6d50d1521bf5$var$Container, {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($9aeb6d50d1521bf5$var$Message, {
                        children: `\u{201C}${invitation.message}\u{201D}`
                    })
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                    className: "p-size-l-bold",
                    children: format("home.healthcareTeam.acceptDialog.patientDetails.header")
                }),
                /*#__PURE__*/ (0, $iKObn.jsxs)($9aeb6d50d1521bf5$var$PatientDetailsContainer, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $01XZm.PatientDetailItem), {
                            icon: $9aeb6d50d1521bf5$var$PatientInformationIcon,
                            title: format("home.healthcareTeam.acceptDialog.patientDetails.patientInformation"),
                            subtitle: patientNameAndAge
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $01XZm.PatientDetailItem), {
                            icon: $9aeb6d50d1521bf5$var$MedicalConditionIcon,
                            title: format("home.healthcareTeam.acceptDialog.patientDetails.medicalCondition"),
                            subtitle: formatDisease(patient.disease)
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $01XZm.PatientDetailItem), {
                            icon: $9aeb6d50d1521bf5$var$ProfileCreationIcon,
                            title: format("home.healthcareTeam.acceptDialog.patientDetails.profileCreation"),
                            subtitle: formatDateMed(patient.creationDate)
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $01XZm.PatientDetailItem), {
                            icon: $9aeb6d50d1521bf5$var$FunctionalStatusIcon,
                            title: format("home.healthcareTeam.acceptDialog.patientDetails.functionalStatus"),
                            subtitle: formatFunctionalStatus(patient.functionalStatus)
                        })
                    ]
                })
            ]
        })
    });
};
const $9aeb6d50d1521bf5$var$ContentContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(24, "center")};
`;
const $9aeb6d50d1521bf5$var$Message = (0, $5UMQ1.default).div`
	white-space: pre-line;
`;
const $9aeb6d50d1521bf5$var$Container = (0, $5UMQ1.default).div`
	background-color: ${(0, $kKnoQ.colors).primaryBackground};
	padding: 16px;
	border-radius: 8px;
`;
const $9aeb6d50d1521bf5$var$PatientDetailsContainer = (0, $5UMQ1.default)($9aeb6d50d1521bf5$var$Container)`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 16px;
`;
const $9aeb6d50d1521bf5$var$ButtonContainer = (0, $5UMQ1.default).div`
	display: flex;
	gap: 24px;
	align-self: end;
`;

});
parcelRegister("Ukx0s", function(module, exports) {

$parcel$export(module.exports, "sendAnalyticsEventOpenInvitation", () => $7afb420fc1c8b7cd$export$afc82fd7c001d4ff);
$parcel$export(module.exports, "sendAnalyticsEventAcceptInvitation", () => $7afb420fc1c8b7cd$export$dba0a4219582627);
$parcel$export(module.exports, "sendAnalyticsEventCancelInvitation", () => $7afb420fc1c8b7cd$export$d4ccac35c1f54a34);
$parcel$export(module.exports, "sendAnalyticsEventStartInvite", () => $7afb420fc1c8b7cd$export$444f8540273de2f);
$parcel$export(module.exports, "sendAnalyticsEventResendInvitation", () => $7afb420fc1c8b7cd$export$d023d1163883a7a5);
$parcel$export(module.exports, "sendAnalyticsEventDeleteColleague", () => $7afb420fc1c8b7cd$export$483a53e511cc178e);
$parcel$export(module.exports, "sendAnalyticsEventInviteRegisteredColleague", () => $7afb420fc1c8b7cd$export$26bb3df23eba2c10);
$parcel$export(module.exports, "sendAnalyticsEventInviteColleagueError", () => $7afb420fc1c8b7cd$export$dd0ffa402630fac6);
$parcel$export(module.exports, "sendAnalyticsEventInviteUnregisteredColleague", () => $7afb420fc1c8b7cd$export$ea6997a8e104a1e7);
$parcel$export(module.exports, "sendAnalyticsEventClickCtaLeaveHct", () => $7afb420fc1c8b7cd$export$bd473765460e5a8b);
$parcel$export(module.exports, "sendAnalyticsEventHctLeft", () => $7afb420fc1c8b7cd$export$b7957af510a81832);

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $2aAG8 = parcelRequire("2aAG8");
const $7afb420fc1c8b7cd$export$afc82fd7c001d4ff = (patient)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).HEALTHCARE,
        action: "openInvitation",
        params: [
            patient.analyticsId
        ]
    });
const $7afb420fc1c8b7cd$export$dba0a4219582627 = (patient)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).HEALTHCARE,
        action: "acceptInvitation",
        params: [
            patient.analyticsId
        ]
    });
const $7afb420fc1c8b7cd$export$d4ccac35c1f54a34 = (patient)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).HEALTHCARE,
        action: "cancelInvitation",
        params: [
            patient.analyticsId
        ]
    });
const $7afb420fc1c8b7cd$export$444f8540273de2f = (patient)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).HEALTHCARE,
        action: "startInvite",
        params: [
            patient.analyticsId
        ]
    });
const $7afb420fc1c8b7cd$export$d023d1163883a7a5 = (patient, invitedPt)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).HEALTHCARE,
        action: "resendInvitation",
        params: [
            patient.analyticsId,
            (0, $2aAG8.isRegisteredHealthcareTeamMember)(invitedPt) ? invitedPt.ptAnalyticsId : "",
            (0, $2aAG8.isRegisteredHealthcareTeamMember)(invitedPt) ? "registered" : "unregistered"
        ]
    });
const $7afb420fc1c8b7cd$export$483a53e511cc178e = (patient, invitedPt)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).HEALTHCARE,
        action: "deleteColleague",
        params: [
            patient.analyticsId,
            (0, $2aAG8.isRegisteredHealthcareTeamMember)(invitedPt) ? invitedPt.ptAnalyticsId : ""
        ]
    });
const $7afb420fc1c8b7cd$export$26bb3df23eba2c10 = (patient, invitedPt, withMessage)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).HEALTHCARE,
        action: "inviteRegisteredColleague",
        params: [
            patient.analyticsId,
            invitedPt.analyticsId,
            withMessage ? "withMessage" : "withoutMessage"
        ]
    });
const $7afb420fc1c8b7cd$export$dd0ffa402630fac6 = (patient)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).HEALTHCARE,
        action: "inviteColleagueError",
        params: [
            patient.analyticsId
        ]
    });
const $7afb420fc1c8b7cd$export$ea6997a8e104a1e7 = (patient, method)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).HEALTHCARE,
        action: "inviteUnregisteredColleague",
        params: [
            patient.analyticsId,
            method
        ]
    });
const $7afb420fc1c8b7cd$export$bd473765460e5a8b = ()=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).HEALTHCARE,
        action: "clickCtaLeaveHct"
    });
const $7afb420fc1c8b7cd$export$b7957af510a81832 = ()=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).HEALTHCARE,
        action: "hctLeft"
    });

});
parcelRegister("2aAG8", function(module, exports) {

$parcel$export(module.exports, "HealthcareTeamMemberStatus", () => $c30babfc39a3d1a8$export$97d387f009c5e5b3);
$parcel$export(module.exports, "isUnregisteredHealthcareTeamMember", () => $c30babfc39a3d1a8$export$d3959047b5d1e16b);
$parcel$export(module.exports, "isRegisteredHealthcareTeamMember", () => $c30babfc39a3d1a8$export$3c9618a78d2b5afe);
var $c30babfc39a3d1a8$export$97d387f009c5e5b3;
(function(HealthcareTeamMemberStatus) {
    HealthcareTeamMemberStatus["PendingPTRegistration"] = "PENDING_PT_REGISTRATION";
    HealthcareTeamMemberStatus["PendingPatientValidation"] = "PENDING_PATIENT_VALIDATION";
    HealthcareTeamMemberStatus["PendingPtValidation"] = "PENDING_PT_VALIDATION";
    HealthcareTeamMemberStatus["Confirmed"] = "CONFIRMED";
})($c30babfc39a3d1a8$export$97d387f009c5e5b3 || ($c30babfc39a3d1a8$export$97d387f009c5e5b3 = {}));
function $c30babfc39a3d1a8$export$d3959047b5d1e16b(member) {
    return member.status === "PENDING_PT_REGISTRATION";
}
function $c30babfc39a3d1a8$export$3c9618a78d2b5afe(member) {
    return !$c30babfc39a3d1a8$export$d3959047b5d1e16b(member);
}

});


parcelRegister("01XZm", function(module, exports) {

$parcel$export(module.exports, "PatientDetailItem", () => $a1114aed982cc2ce$export$6488676ae6ebe3d);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("81g6h");

var $kKnoQ = parcelRequire("kKnoQ");
const $a1114aed982cc2ce$export$6488676ae6ebe3d = ({ icon: Icon, title: title, subtitle: subtitle })=>/*#__PURE__*/ (0, $iKObn.jsxs)($a1114aed982cc2ce$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)(Icon, {
                width: 24,
                height: 24,
                color: (0, $kKnoQ.colors).grey
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($a1114aed982cc2ce$var$Title, {
                        className: "p-size-s-bold",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        className: "p-size-s",
                        children: subtitle
                    })
                ]
            })
        ]
    });
const $a1114aed982cc2ce$var$Container = (0, $5UMQ1.default).div`
	display: flex;
	gap: 8px;
`;
const $a1114aed982cc2ce$var$Title = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).grey};
`;

});


parcelRegister("g6npC", function(module, exports) {

$parcel$export(module.exports, "MarkAllNotificationsAsReadDialog", () => $e44501e4c04fdb7d$export$c3766bf39c684d03);

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $9XVwj = parcelRequire("9XVwj");

var $9oyj9 = parcelRequire("9oyj9");

var $81g6h = parcelRequire("81g6h");
const $e44501e4c04fdb7d$export$c3766bf39c684d03 = ({ unreadNotificationCount: unreadNotificationCount, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const [markAllAsRead, isLoading] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(async ()=>{
        await (0, $ghfIB.notificationManager).markAllAsRead();
        (0, $ghfIB.analyticsService).trackEvent({
            category: (0, $auPqo.AnalyticsCategory).NOTIFICATIONS,
            action: "notificationAllRead"
        });
        showToast("", format("notificationCenter.markAllAsRead.toastSuccess.detail", {
            count: unreadNotificationCount
        }), "success");
        otherProps.onHide();
    }, [
        format,
        otherProps,
        showToast,
        unreadNotificationCount
    ]), {});
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $9oyj9.ConfirmActionDialog), {
        ...otherProps,
        onCancel: otherProps.onHide,
        onConfirm: markAllAsRead,
        confirmLoading: isLoading,
        confirmButtonStyle: "primary",
        message: format("notificationCenter.markAllAsRead.dialog.description"),
        title: format("notificationCenter.markAllAsRead.dialog.header", {
            count: unreadNotificationCount
        })
    });
};

});

parcelRegister("9ijS8", function(module, exports) {

$parcel$export(module.exports, "EditPatientInfoDialog", () => $e1db8131ea2540e6$export$8edfbac9110eb497);

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $ccjD7 = parcelRequire("ccjD7");

var $lG6Cp = parcelRequire("lG6Cp");

var $6Yxa2 = parcelRequire("6Yxa2");

var $fUhFD = parcelRequire("fUhFD");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");

var $8FlUV = parcelRequire("8FlUV");

var $9XVwj = parcelRequire("9XVwj");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $eT9rN = parcelRequire("eT9rN");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
const $e1db8131ea2540e6$export$8edfbac9110eb497 = ({ patient: patient, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { formatFunctionalStatus: formatFunctionalStatus } = (0, $lG6Cp.useFormatMedicalCondition)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const { formState: formState, control: control, handleSubmit: handleSubmit } = (0, $eKUeg.useForm)({
        defaultValues: {
            functionalStatus: patient.functionalStatus,
            disease: !(0, $6Yxa2.isPendingPatient)(patient) ? patient.disease : undefined
        }
    });
    const [submitPatientInfo, isLoading, isError] = (0, $grmoS.useAsyncOperation)(async (data)=>{
        (0, $fUhFD.sendAnalyticsEventEditPatientDetails)(patient, data);
        await (0, $ghfIB.patientManager).editPatientDetails(patient.id, data.disease, data.functionalStatus);
        showToast(format("patientDetails.column.editInfoDialog.successToast"), "", "success");
        otherProps.onHide();
    }, {});
    const diseases = (0, $lG6Cp.useSortedDiseaseList)();
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $gk3fY.BaseDialog), {
        header: format("patientDetails.column.editInfoDialog.header"),
        footer: /*#__PURE__*/ (0, $iKObn.jsx)($e1db8131ea2540e6$var$ButtonContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                loading: isLoading,
                type: "submit",
                disabled: !formState.isDirty,
                onClick: handleSubmit(submitPatientInfo),
                children: format("global.dialog.save")
            })
        }),
        width: (0, $gk3fY.DIALOG_SIZE).M,
        ...otherProps,
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($e1db8131ea2540e6$var$Form, {
            onSubmit: handleSubmit(submitPatientInfo),
            children: [
                /*#__PURE__*/ (0, $iKObn.jsxs)($e1db8131ea2540e6$var$FormField, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                            className: "p-size-m",
                            children: format("patientDetails.column.editInfoDialog.medicalCondition")
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                            name: "disease",
                            control: control,
                            render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $iKObn.jsx)($e1db8131ea2540e6$var$StyledDropdown, {
                                            disabled: (0, $6Yxa2.isPendingPatient)(patient),
                                            options: diseases,
                                            placeholder: format("global.form.dropdown.placeholder"),
                                            ...field,
                                            optionLabel: "label",
                                            optionValue: "value",
                                            appendTo: "self"
                                        }),
                                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $8FlUV.ErrorMessage), {
                                            children: isError || fieldState.error?.message
                                        })
                                    ]
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $iKObn.jsxs)($e1db8131ea2540e6$var$FormField, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                            className: "p-size-m",
                            children: format("patientDetails.column.editInfoDialog.functionalStatus")
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                            name: "functionalStatus",
                            control: control,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $iKObn.jsx)($e1db8131ea2540e6$var$StyledDropdown, {
                                    options: (0, $ccjD7.functionalStatuses).map((type)=>({
                                            value: type,
                                            label: formatFunctionalStatus(type)
                                        })),
                                    placeholder: format("global.form.dropdown.placeholder"),
                                    ...field,
                                    optionLabel: "label",
                                    optionValue: "value",
                                    appendTo: "self"
                                })
                        })
                    ]
                })
            ]
        })
    });
};
const $e1db8131ea2540e6$var$ButtonContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(24, "flexend")}
`;
const $e1db8131ea2540e6$var$Form = (0, $5UMQ1.default).form`
	${(0, $5WGN2.stack)("M", "flexstart", "stretch")}
	padding-bottom: 100px;
`;
const $e1db8131ea2540e6$var$FormField = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("S", "flexstart", "stretch")};
`;
const $e1db8131ea2540e6$var$StyledDropdown = (0, $5UMQ1.default)((0, $eT9rN.Dropdown))`
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		.p-dropdown-item {
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			width: calc(100vw - 48px);
		}
	}
`;

});

parcelRegister("8dSEo", function(module, exports) {

$parcel$export(module.exports, "HealthcareTeamInviteDialog", () => $f2f99e823b3744c0$export$4267b943a4fe09ec);

var $iKObn = parcelRequire("iKObn");

var $9r0qA = parcelRequire("9r0qA");

var $j7bBW = parcelRequire("j7bBW");

var $cf3Fx = parcelRequire("cf3Fx");

var $81g6h = parcelRequire("81g6h");
var $f2f99e823b3744c0$var$InvitationStep;
(function(InvitationStep) {
    InvitationStep["EmailForm"] = "email-form";
    InvitationStep["InviteRegistered"] = "invite-registered";
    InvitationStep["InviteUnregistered"] = "invite-unregistered";
})($f2f99e823b3744c0$var$InvitationStep || ($f2f99e823b3744c0$var$InvitationStep = {}));
const $f2f99e823b3744c0$export$4267b943a4fe09ec = ({ invitingPt: invitingPt, ...otherProps })=>{
    const [dialogStep, setDialogStep] = (0, $81g6h.useState)({
        step: "email-form"
    });
    const onInviteFormGoBack = (0, $81g6h.useCallback)((email)=>setDialogStep({
            step: "email-form",
            defaultValues: {
                email: email
            }
        }), []);
    if (dialogStep.step === "email-form") return /*#__PURE__*/ (0, $iKObn.jsx)((0, $9r0qA.EmailFormDialog), {
        ...otherProps,
        onRegisteredPt: (ptData)=>setDialogStep({
                step: "invite-registered",
                ptData: ptData
            }),
        onUnregisteredPt: (ptData)=>setDialogStep({
                step: "invite-unregistered",
                ptData: ptData
            }),
        defaultValues: dialogStep.defaultValues
    });
    if (dialogStep.step === "invite-registered") return /*#__PURE__*/ (0, $iKObn.jsx)((0, $j7bBW.InviteRegisteredPtDialog), {
        ...otherProps,
        invitedPt: dialogStep.ptData,
        invitingPt: invitingPt,
        onInvitationSent: otherProps.onHide,
        onGoBack: ()=>onInviteFormGoBack(dialogStep.ptData.email)
    });
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $cf3Fx.InviteUnregisteredPtDialog), {
        ...otherProps,
        invitedPt: dialogStep.ptData,
        invitingPt: invitingPt
    });
};

});
parcelRegister("9r0qA", function(module, exports) {

$parcel$export(module.exports, "EmailFormDialog", () => $8ecc3a9d23ab7cb9$export$3debd77f894fe1cc);

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $hjTZh = parcelRequire("hjTZh");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");

var $8FlUV = parcelRequire("8FlUV");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $lTdpc = parcelRequire("lTdpc");

var $kI5xQ = parcelRequire("kI5xQ");

var $6ccvc = parcelRequire("6ccvc");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
const $8ecc3a9d23ab7cb9$export$3debd77f894fe1cc = ({ patient: patient, defaultValues: defaultValues = {
    email: ""
}, onRegisteredPt: onRegisteredPt, onUnregisteredPt: onUnregisteredPt, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const [emailError, setEmailError] = (0, $81g6h.useState)();
    const { control: control, handleSubmit: handleSubmit } = (0, $eKUeg.useForm)({
        defaultValues: defaultValues
    });
    const [submit, isLoading] = (0, $grmoS.useAsyncOperation)(async (data)=>{
        try {
            const invitedPt = await (0, $ghfIB.healthcareTeamManager).checkEmailRegistered(patient.id, data.email);
            onRegisteredPt(invitedPt);
        } catch (e) {
            if (e instanceof (0, $hjTZh.InvitationPtNotFoundError)) try {
                const invitedPt = await (0, $ghfIB.healthcareTeamManager).sendUnregisteredInvitation(patient.id, data.email);
                onUnregisteredPt(invitedPt);
                return;
            } catch (e2) {
                (0, $ghfIB.networkActionsErrorsManager).reportError(e2);
            }
            if (e instanceof (0, $hjTZh.InvitationPtInDifferentCountryError)) setEmailError(format("patientDetails.healthcareTeam.inviteDialog.form.email.ptInDifferentCountryError"));
            else if (e instanceof (0, $hjTZh.InvitationPtAlreadyInHctError)) setEmailError(format("patientDetails.healthcareTeam.inviteDialog.form.email.alreadyJoinedError"));
            else {
                console.error("Failed to get PT data required for invitation", e);
                (0, $ghfIB.networkActionsErrorsManager).reportError(e);
            }
        }
    }, {});
    return /*#__PURE__*/ (0, $iKObn.jsx)($8ecc3a9d23ab7cb9$var$StyledDialog, {
        header: format("patientDetails.healthcareTeam.inviteDialog.header"),
        footer: /*#__PURE__*/ (0, $iKObn.jsx)($8ecc3a9d23ab7cb9$var$ButtonContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                loading: isLoading,
                type: "submit",
                onClick: handleSubmit(submit),
                label: format("global.dialog.next")
            })
        }),
        ...otherProps,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($8ecc3a9d23ab7cb9$var$Form, {
            onSubmit: handleSubmit(submit),
            children: /*#__PURE__*/ (0, $iKObn.jsxs)($8ecc3a9d23ab7cb9$var$FormField, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                        className: "p-size-m",
                        children: format("patientDetails.healthcareTeam.inviteDialog.form.email.label")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                        name: "email",
                        control: control,
                        rules: {
                            onChange: ()=>setEmailError(undefined),
                            required: format("global.form.field.requiredError"),
                            pattern: {
                                value: (0, $kI5xQ.REGEX_EMAIL),
                                message: format("patientDetails.healthcareTeam.inviteDialog.form.email.formatError")
                            }
                        },
                        render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($8ecc3a9d23ab7cb9$var$EmailInputText, {
                                        onChange: field.onChange,
                                        value: field.value,
                                        className: (0, $lTdpc.isNotNil)(fieldState.error) || (0, $lTdpc.isNotNil)(emailError) ? "p-invalid" : undefined,
                                        placeholder: format("patientDetails.healthcareTeam.inviteDialog.form.email.placeholder")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $8FlUV.ErrorMessage), {
                                        children: fieldState.error?.message ?? emailError
                                    })
                                ]
                            })
                    })
                ]
            })
        })
    });
};
const $8ecc3a9d23ab7cb9$var$StyledDialog = (0, $5UMQ1.default)((0, $gk3fY.BaseDialog))`
	width: 732px;
`;
const $8ecc3a9d23ab7cb9$var$ButtonContainer = (0, $5UMQ1.default).div`
	place-self: end;
`;
const $8ecc3a9d23ab7cb9$var$EmailInputText = (0, $5UMQ1.default)((0, $6ccvc.InputText))``;
const $8ecc3a9d23ab7cb9$var$Form = (0, $5UMQ1.default).form`
	${(0, $5WGN2.stack)("M", "spacebetween", "stretch")};
	height: 100%;
`;
const $8ecc3a9d23ab7cb9$var$FormField = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("S", "flexstart", "stretch")};
`;

});

parcelRegister("j7bBW", function(module, exports) {

$parcel$export(module.exports, "InviteRegisteredPtDialog", () => $7047e59dc473c78d$export$ce5f5a2e062fd9ae);

var $iKObn = parcelRequire("iKObn");

var $he9Ds = parcelRequire("he9Ds");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $Ukx0s = parcelRequire("Ukx0s");

var $aEP4N = parcelRequire("aEP4N");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");

var $9XVwj = parcelRequire("9XVwj");

var $eWrm7 = parcelRequire("eWrm7");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $lTdpc = parcelRequire("lTdpc");

var $buI4E = parcelRequire("buI4E");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
const $7047e59dc473c78d$export$ce5f5a2e062fd9ae = ({ patient: patient, invitingPt: invitingPt, invitedPt: invitedPt, onGoBack: onGoBack, onInvitationSent: onInvitationSent, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { formatPatientName: formatPatientName } = (0, $aEP4N.useFormatPatients)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const { control: control, handleSubmit: handleSubmit } = (0, $eKUeg.useForm)({
        defaultValues: {
            message: format("patientDetails.healthcareTeam.inviteDialog.form.customMessage.defaultValue", {
                patientName: formatPatientName(patient, false, false),
                ptName: (0, $buI4E.formatName)(invitingPt)
            })
        }
    });
    const [submitInvitation, isLoading] = (0, $grmoS.useAsyncOperation)(async (data)=>{
        try {
            if (data.message === "") data.message = undefined;
            await (0, $ghfIB.healthcareTeamManager).sendInvitation(patient.id, invitedPt.email, data.message);
            (0, $Ukx0s.sendAnalyticsEventInviteRegisteredColleague)(patient, invitedPt, (0, $lTdpc.isNotEmpty)(data.message));
            showToast(format("patientDetails.healthcareTeam.inviteDialog.toastSuccess.title"), format("patientDetails.healthcareTeam.inviteDialog.toastSuccess.subtitle"), "success");
            onInvitationSent();
        } catch (e) {
            (0, $Ukx0s.sendAnalyticsEventInviteColleagueError)(patient);
            console.error("Failed to send invitation", e);
        }
    }, {});
    return /*#__PURE__*/ (0, $iKObn.jsx)($7047e59dc473c78d$var$Dialog, {
        header: format("patientDetails.healthcareTeam.inviteDialog.header"),
        ...otherProps,
        footer: /*#__PURE__*/ (0, $iKObn.jsxs)($7047e59dc473c78d$var$ButtonContainer, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                    label: format("global.dialog.back"),
                    onClick: onGoBack,
                    uiStyle: "secondary_B"
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                    loading: isLoading,
                    type: "submit",
                    onClick: handleSubmit(submitInvitation),
                    label: format("patientDetails.healthcareTeam.inviteDialog.form.submitButton")
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($7047e59dc473c78d$var$Form, {
            onSubmit: handleSubmit(submitInvitation),
            children: [
                /*#__PURE__*/ (0, $iKObn.jsxs)($7047e59dc473c78d$var$FormField, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                            className: "p-size-m",
                            children: format("patientDetails.healthcareTeam.inviteDialog.form.invitedColleague.label")
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsxs)($7047e59dc473c78d$var$FilledInvitedPt, {
                            className: "p-inputtext p-component p-filled",
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                    className: "p-size-s-bold",
                                    children: (0, $buI4E.formatName)(invitedPt)
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                    children: invitedPt.email
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $iKObn.jsxs)($7047e59dc473c78d$var$FormField, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                            className: "p-size-m",
                            children: format("patientDetails.healthcareTeam.inviteDialog.form.customMessage.label")
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                            name: "message",
                            control: control,
                            rules: {
                                maxLength: (0, $he9Ds.APP_CONSTANTS).HEALTH_CARE_INVITE_MAX_CUSTOM_MESSAGE_LENGTH
                            },
                            render: ({ field: field })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $eWrm7.CustomMessageTextarea), {
                                    value: field.value ?? "",
                                    onChange: field.onChange,
                                    maxLength: (0, $he9Ds.APP_CONSTANTS).HEALTH_CARE_INVITE_MAX_CUSTOM_MESSAGE_LENGTH
                                })
                        })
                    ]
                })
            ]
        })
    });
};
const $7047e59dc473c78d$var$FilledInvitedPt = (0, $5UMQ1.default).div`
	max-width: 382px;
`;
const $7047e59dc473c78d$var$Form = (0, $5UMQ1.default).form`
	${(0, $5WGN2.stack)("M", "flexstart", "stretch")}
`;
const $7047e59dc473c78d$var$Dialog = (0, $5UMQ1.default)((0, $gk3fY.BaseDialog))`
	width: 732px;
`;
const $7047e59dc473c78d$var$ButtonContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(24, "spacebetween")};
`;
const $7047e59dc473c78d$var$FormField = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("S", "flexstart", "stretch")};
`;

});
parcelRegister("eWrm7", function(module, exports) {

$parcel$export(module.exports, "CustomMessageTextarea", () => $c889bf3f500c47ea$export$d0c56f3cd758ccaf);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $1sbGw = parcelRequire("1sbGw");
parcelRequire("81g6h");

var $he9Ds = parcelRequire("he9Ds");

var $1eHG3 = parcelRequire("1eHG3");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $bl9tw = parcelRequire("bl9tw");
const $c889bf3f500c47ea$export$d0c56f3cd758ccaf = ({ value: value, maxLength: maxLength, onChange: onChange })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($c889bf3f500c47ea$var$Content, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $1sbGw.InputTextarea), {
                rows: 5,
                value: value,
                onChange: onChange,
                maxLength: maxLength,
                autoResize: true
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($c889bf3f500c47ea$var$InfoContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($c889bf3f500c47ea$var$InfoText, {
                        children: format("global.dialog.textInput.maxLength", {
                            maxLength: (0, $he9Ds.APP_CONSTANTS).HEALTH_CARE_INVITE_MAX_CUSTOM_MESSAGE_LENGTH
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($c889bf3f500c47ea$var$InfoText, {
                        style: {
                            color: value.length === maxLength ? (0, $kKnoQ.colors).rejection : (0, $kKnoQ.colors).black
                        },
                        children: maxLength - value.length
                    })
                ]
            })
        ]
    });
};
const $c889bf3f500c47ea$var$Content = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(8, "flexstart", "stretch")};
`;
const $c889bf3f500c47ea$var$InfoContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "flexend")}
	flex-wrap: wrap;
`;
const $c889bf3f500c47ea$var$InfoText = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).black};
	margin: 8px;
	font-size: 12px;
	font-weight: 600;
	font-family: ${(0, $bl9tw.fonts).body};
`;

});


parcelRegister("cf3Fx", function(module, exports) {

$parcel$export(module.exports, "InviteUnregisteredPtDialog", () => $00ac6ba9d024ae46$export$e004aff3384a30d);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $Ukx0s = parcelRequire("Ukx0s");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");

var $lDZlX = parcelRequire("lDZlX");
parcelRequire("42FK8");
var $kwJi4 = parcelRequire("kwJi4");

var $kKnoQ = parcelRequire("kKnoQ");

var $buI4E = parcelRequire("buI4E");

var $81g6h = parcelRequire("81g6h");
var $00ac6ba9d024ae46$var$CheckIcon = function CheckIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.064 5.318c.449.449.449 1.177 0 1.626L9.325 18.683a1.15 1.15 0 0 1-1.626 0L2.936 13.92a1.15 1.15 0 0 1 1.627-1.627l3.95 3.95L19.437 5.318a1.15 1.15 0 0 1 1.626 0Z",
            fill: "currentColor"
        })
    });
};
$00ac6ba9d024ae46$var$CheckIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $00ac6ba9d024ae46$var$CopyIcon = function CopyIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M4 2a2 2 0 0 0-2 2v13a1 1 0 0 0 2 0V4h13a1 1 0 0 0 0-2H4Zm4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H8Zm0 2h12v12H8V8Z",
            fill: "currentColor"
        })
    });
};
$00ac6ba9d024ae46$var$CopyIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $00ac6ba9d024ae46$var$InfoIcon = function InfoIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Zm0-20c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12.01 17.17c-.55 0-1-.45-1-1v-5.44c0-.55.45-1 1-1s1 .45 1 1v5.44c0 .55-.45 1-1 1ZM12 8.11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                fill: "currentColor"
            })
        ]
    });
};
$00ac6ba9d024ae46$var$InfoIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $00ac6ba9d024ae46$export$e004aff3384a30d = ({ patient: patient, invitedPt: invitedPt, invitingPt: invitingPt, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const [hasCopied, setHasCopied] = (0, $81g6h.useState)(false);
    const emailBody = (0, $81g6h.useMemo)(()=>format("patientDetails.healthcareTeam.inviteDialog.unregisteredPt.email.body", {
            patientName: (0, $buI4E.formatName)(patient),
            inviteUrl: `${location.protocol}//${location.host}${(0, $lDZlX.RoutesPath).Register}?invitationId=${invitedPt.invitationId}&countryCode=${invitingPt.country}`,
            invitingPtName: (0, $buI4E.formatName)(invitingPt)
        }), [
        format,
        invitedPt.invitationId,
        invitingPt,
        patient
    ]);
    const emailSubject = (0, $81g6h.useMemo)(()=>format("patientDetails.healthcareTeam.inviteDialog.unregisteredPt.email.subject", {
            invitingPt: (0, $buI4E.formatName)(invitingPt)
        }), [
        format,
        invitingPt
    ]);
    const mailToLink = (0, $81g6h.useMemo)(()=>`mailto:${invitedPt.email}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`, [
        emailBody,
        emailSubject,
        invitedPt.email
    ]);
    const copyInvite = (0, $81g6h.useCallback)(()=>{
        setHasCopied(true);
        navigator.clipboard.writeText(emailBody);
        (0, $Ukx0s.sendAnalyticsEventInviteUnregisteredColleague)(patient, "copyCTA");
        setTimeout(()=>setHasCopied(false), 3000);
    }, [
        emailBody,
        patient
    ]);
    const sendByEmailClicked = (0, $81g6h.useCallback)(()=>(0, $Ukx0s.sendAnalyticsEventInviteUnregisteredColleague)(patient, "sendByEmailCTA"), [
        patient
    ]);
    // TODO: I had to give the button a children instead of using label and icon props because the iconPos props doesn't seem to work
    // We should check why this prop doesn't work (maybe update prime react)
    const copyButtonContent = /*#__PURE__*/ (0, $iKObn.jsx)($00ac6ba9d024ae46$var$CopyButtonContent, {
        children: hasCopied ? /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
            children: [
                format("patientDetails.healthcareTeam.inviteDialog.unregisteredPt.copyButton.copied"),
                /*#__PURE__*/ (0, $iKObn.jsx)($00ac6ba9d024ae46$var$CheckIcon, {
                    width: 24,
                    height: 24
                })
            ]
        }) : /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
            children: [
                format("patientDetails.healthcareTeam.inviteDialog.unregisteredPt.copyButton"),
                /*#__PURE__*/ (0, $iKObn.jsx)($00ac6ba9d024ae46$var$CopyIcon, {
                    width: 24,
                    height: 24
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $iKObn.jsxs)($00ac6ba9d024ae46$var$Dialog, {
        header: format("patientDetails.healthcareTeam.inviteDialog.header"),
        ...otherProps,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($00ac6ba9d024ae46$var$InfoBox, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($00ac6ba9d024ae46$var$StyledInfoIcon, {
                        height: 24,
                        width: 24
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($00ac6ba9d024ae46$var$InfoText, {
                        children: format("patientDetails.healthcareTeam.inviteDialog.unregisteredPt.info", {
                            email: invitedPt.email
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($00ac6ba9d024ae46$var$InstructionContainer, {
                className: "p-size-m-bold",
                children: format("patientDetails.healthcareTeam.inviteDialog.unregisteredPt.instruction")
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($00ac6ba9d024ae46$var$Invitation, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($00ac6ba9d024ae46$var$MessageContainer, {
                        children: emailBody
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($00ac6ba9d024ae46$var$ShareButtonContainer, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("a", {
                                href: mailToLink,
                                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                                    label: format("patientDetails.healthcareTeam.inviteDialog.unregisteredPt.sendButton"),
                                    uiStyle: "primary",
                                    onClick: sendByEmailClicked
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                                uiStyle: "secondary_B",
                                onClick: copyInvite,
                                children: copyButtonContent
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $00ac6ba9d024ae46$var$StyledInfoIcon = (0, $5UMQ1.default)($00ac6ba9d024ae46$var$InfoIcon)`
	flex-shrink: 0;
`;
const $00ac6ba9d024ae46$var$CopyButtonContent = (0, $5UMQ1.default).div`
	display: flex;
	gap: ${(0, $kwJi4.spacings).XS};
`;
const $00ac6ba9d024ae46$var$Invitation = (0, $5UMQ1.default).div`
	padding: ${(0, $kwJi4.spacings).M};
	padding-bottom: ${(0, $kwJi4.spacings).S};
	border: 1px solid ${(0, $kKnoQ.colors).primary25};
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	gap: ${(0, $kwJi4.spacings).M};
`;
const $00ac6ba9d024ae46$var$InfoText = (0, $5UMQ1.default).div`
	> span {
		overflow-wrap: anywhere;
	}
`;
const $00ac6ba9d024ae46$var$MessageContainer = (0, $5UMQ1.default).div`
	padding-right: ${(0, $kwJi4.spacings).XL};
	white-space: pre-line;
	color: ${(0, $kKnoQ.colors).grey};
	overflow-wrap: break-word;
`;
const $00ac6ba9d024ae46$var$InfoBox = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).primaryDark50};
	background-color: ${(0, $kKnoQ.colors).primary10};
	border: 1px solid ${(0, $kKnoQ.colors).primary75};
	border-radius: 8px;
	display: flex;
	padding: ${(0, $kwJi4.spacings).S};
	gap: 8px;
`;
const $00ac6ba9d024ae46$var$ShareButtonContainer = (0, $5UMQ1.default).div`
	display: flex;
	gap: ${(0, $kwJi4.spacings).S};
`;
const $00ac6ba9d024ae46$var$InstructionContainer = (0, $5UMQ1.default).div`
	margin-top: ${(0, $kwJi4.spacings).M};
	margin-bottom: ${(0, $kwJi4.spacings).S};
`;
const $00ac6ba9d024ae46$var$Dialog = (0, $5UMQ1.default)((0, $gk3fY.BaseDialog))`
	width: 732px;
`;

});


parcelRegister("loq6i", function(module, exports) {

$parcel$export(module.exports, "HealthcareTeamLeaveDialog", () => $560473969cf58202$export$dc86beacc12df532);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $Ukx0s = parcelRequire("Ukx0s");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");

var $9XVwj = parcelRequire("9XVwj");

var $5kXMA = parcelRequire("5kXMA");

var $lDZlX = parcelRequire("lDZlX");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $buI4E = parcelRequire("buI4E");

var $81g6h = parcelRequire("81g6h");

var $hE6rp = parcelRequire("hE6rp");
var $560473969cf58202$var$CrossIcon = function CrossIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M6.14 5.302a.836.836 0 0 0-.583 1.435l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26a.834.834 0 0 0 1.377-.263.836.836 0 0 0-.195-.919L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 0 0-.6-.254Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.14 5.015a1.123 1.123 0 0 1 .803.338L12 10.41l5.057-5.057a1.123 1.123 0 1 1 1.588 1.589l-5.057 5.056 5.056 5.056c.107.103.192.226.251.363l-.263.114a.836.836 0 0 0-.189-.272L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 1 0-1.182 1.181l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26c.077.08.17.145.271.189l-.114.263a1.124 1.124 0 0 1-.362-.25L12 13.585l-5.056 5.056a1.123 1.123 0 1 1-1.588-1.588l5.056-5.056-5.057-5.056a1.123 1.123 0 0 1 .785-1.927ZM17.532 18.63a.834.834 0 0 0 1.168-.776.836.836 0 0 0-.068-.323l.263-.114a1.125 1.125 0 0 1-1.477 1.476l.114-.263Z",
                fill: "currentColor"
            })
        ]
    });
};
$560473969cf58202$var$CrossIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $560473969cf58202$var$SpinnerIcon = function SpinnerIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M10.984.986A1 1 0 0 0 10 2v2a1 1 0 1 0 2 0V2A1.001 1.001 0 0 0 10.984.986Zm4.532 1.207a1 1 0 0 0-.881.512l-1 1.732a1 1 0 1 0 1.73 1l1-1.732a1 1 0 0 0-.85-1.512Zm-9.06.002a1 1 0 0 0-.821 1.51l1 1.732a1 1 0 1 0 1.73-1l-1-1.732a1 1 0 0 0-.91-.51ZM3.23 5.492a1 1 0 0 0-.525 1.873l1.732 1a1 1 0 1 0 1-1.73l-1.732-1a1 1 0 0 0-.475-.143Zm15.608.002a1 1 0 0 0-.543.14l-1.733 1a.999.999 0 0 0 .227 1.857 1 1 0 0 0 .773-.126l1.733-1a1 1 0 0 0-.457-1.87ZM2 10a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H2Zm16 0a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm-.912 3.492c-.033 0-.067 0-.1.002a1 1 0 0 0-.425 1.871l1.732 1a1 1 0 1 0 1-1.73l-1.733-1a1 1 0 0 0-.474-.143Zm-12.106.002a1 1 0 0 0-.545.14l-1.732 1a1 1 0 1 0 1 1.731l1.732-1a1 1 0 0 0-.455-1.87Zm2.534 2.555a1 1 0 0 0-.881.514l-1 1.732a1 1 0 1 0 1.73 1l1-1.733a1 1 0 0 0-.85-1.513Zm6.94.002a1 1 0 0 0-.821 1.512l1 1.732a1 1 0 1 0 1.73-1l-1-1.733a1 1 0 0 0-.91-.511Zm-3.472.935A1 1 0 0 0 10 18v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1.016-1.014Z",
            fill: "currentColor",
            children: /*#__PURE__*/ (0, $iKObn.jsx)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                from: "0 11 11",
                to: "360 11 11",
                dur: "1.5s",
                repeatCount: "indefinite"
            })
        })
    });
};
$560473969cf58202$var$SpinnerIcon.defaultProps = {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $560473969cf58202$var$LEAVE_BUTTON_WIDTH = 160;
const $560473969cf58202$export$dc86beacc12df532 = ({ patient: patient, onHide: onHide, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const [isLoading, setIsLoading] = (0, $81g6h.useState)(false);
    const navigate = (0, $hE6rp.useNavigate)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const patientFullName = (0, $81g6h.useMemo)(()=>(0, $buI4E.formatName)(patient), [
        patient
    ]);
    const leaveTeam = (0, $81g6h.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            await (0, $ghfIB.healthcareTeamManager).leaveHealthcareTeam(patient.id).then(()=>setIsLoading(false));
            onHide();
            (0, $Ukx0s.sendAnalyticsEventHctLeft)();
            navigate((0, $lDZlX.RoutesPath).Home);
            showToast(format("patientDetails.healthcareTeam.leaveHealthcareTeamModal.successSummary"), format("patientDetails.healthcareTeam.leaveHealthcareTeamModal.successDetail", {
                patientName: patientFullName
            }), "success");
        } catch (error) {
            setIsLoading(false);
        }
    }, [
        format,
        navigate,
        onHide,
        patient.id,
        patientFullName,
        showToast
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($560473969cf58202$var$StyledDialog, {
        width: (0, $gk3fY.DIALOG_SIZE).S,
        header: format("patientDetails.healthcareTeam.leaveHealthcareTeamModal.title"),
        onHide: onHide,
        closeIcon: /*#__PURE__*/ (0, $iKObn.jsx)($560473969cf58202$var$CrossIcon, {
            width: 24,
            height: 24,
            color: (0, $kKnoQ.colors).black
        }),
        ...otherProps,
        footer: /*#__PURE__*/ (0, $iKObn.jsxs)($560473969cf58202$var$FooterContainer, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                    label: format("patientDetails.healthcareTeam.leaveHealthcareTeamModal.stayInTeamButton"),
                    uiStyle: "secondary_B",
                    onClick: onHide,
                    style: {
                        width: isDesktop ? "" : "100%"
                    }
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                    label: isLoading ? "" : format("patientDetails.healthcareTeam.leaveHealthcareTeamModal.leaveTeamButton"),
                    uiStyle: "danger",
                    icon: isLoading ? /*#__PURE__*/ (0, $iKObn.jsx)($560473969cf58202$var$SpinnerIcon, {}) : undefined,
                    onClick: leaveTeam,
                    style: {
                        width: isDesktop ? $560473969cf58202$var$LEAVE_BUTTON_WIDTH : "100%"
                    }
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($560473969cf58202$var$ContentContainer, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                    children: format("patientDetails.healthcareTeam.leaveHealthcareTeamModal.leavePatientName", {
                        patientName: patientFullName
                    })
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                    children: format("patientDetails.healthcareTeam.leaveHealthcareTeamModal.wontBeAbleToAccess")
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                    children: format("patientDetails.healthcareTeam.leaveHealthcareTeamModal.patientAndHCTNotified")
                })
            ]
        })
    });
};
const $560473969cf58202$var$StyledDialog = (0, $5UMQ1.default)((0, $gk3fY.BaseDialog))`
	.p-dialog-footer {
		padding: 8px 32px 32px;
	}
`;
const $560473969cf58202$var$ContentContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(24)}
`;
const $560473969cf58202$var$FooterContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(16, "flexend")}
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		${(0, $5WGN2.stack)(8, "center", "center")}
		flex-direction: column-reverse;
	}
`;

});

parcelRegister("dHcUB", function(module, exports) {

$parcel$export(module.exports, "DuplicateAsTemplateDialog", () => $a56f499674fbb6f4$export$8e5432abfee35d2d);

var $iKObn = parcelRequire("iKObn");

var $he9Ds = parcelRequire("he9Ds");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");

var $lQZUP = parcelRequire("lQZUP");

var $9XVwj = parcelRequire("9XVwj");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $dU78w = parcelRequire("dU78w");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
const $a56f499674fbb6f4$export$8e5432abfee35d2d = ({ programName: programName, onSubmit: onSubmit, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const { control: control, handleSubmit: handleSubmit } = (0, $eKUeg.useForm)({
        defaultValues: {
            name: programName
        }
    });
    const [saveTemplate, isLoading] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(async (name)=>{
        try {
            onSubmit(name);
        } catch (e) {
            showToast(format("global.errorToast.title"), format("global.duplicateProgramOperation.errorToast.message"));
        }
    }, [
        format,
        onSubmit,
        showToast
    ]), {});
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $gk3fY.BaseDialog), {
        header: format("patientDetails.patientPrograms.duplicateAsTemplateDialog.title"),
        footer: /*#__PURE__*/ (0, $iKObn.jsx)($a56f499674fbb6f4$var$ButtonContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                label: format("patientDetails.patientPrograms.duplicateAsTemplateDialog.duplicateButton"),
                loading: isLoading,
                type: "submit",
                onClick: handleSubmit(({ name: name })=>saveTemplate(name))
            })
        }),
        width: (0, $gk3fY.DIALOG_SIZE).S,
        ...otherProps,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($a56f499674fbb6f4$var$DialogContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)($a56f499674fbb6f4$var$Form, {
                onSubmit: handleSubmit(({ name: name })=>saveTemplate(name)),
                children: /*#__PURE__*/ (0, $iKObn.jsxs)($a56f499674fbb6f4$var$FormField, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                            className: "p-size-m",
                            children: format("patientDetails.patientPrograms.duplicateAsTemplateDialog.description")
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                            className: "p-size-m",
                            children: format("patientDetails.patientPrograms.duplicateAsTemplateDialog.label")
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                            name: "name",
                            control: control,
                            rules: {
                                required: format("global.form.field.requiredError"),
                                maxLength: {
                                    value: (0, $he9Ds.APP_CONSTANTS).PROGRAM_OR_TEMPLATE_MAX_TITLE_LENGTH,
                                    message: format("global.templateName.maxLength")
                                }
                            },
                            render: ({ field: { onChange: onChange, value: value, ...otherFields }, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $lQZUP.TextAreaWithCharLimit), {
                                    ...otherFields,
                                    autoComplete: "off",
                                    autoFocus: !value,
                                    text: value,
                                    onTextChange: onChange,
                                    errorMessage: fieldState.error?.message,
                                    charLimit: (0, $he9Ds.APP_CONSTANTS).PROGRAM_OR_TEMPLATE_MAX_TITLE_LENGTH,
                                    placeholder: format("templateBuilder.templateNameDialog.nameInput.placeholder")
                                })
                        })
                    ]
                })
            })
        })
    });
};
const $a56f499674fbb6f4$var$DialogContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("M", "flexstart", "stretch")}
	height: 100%;
`;
const $a56f499674fbb6f4$var$ButtonContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("S", "flexend")}
`;
const $a56f499674fbb6f4$var$Form = (0, $5UMQ1.default)((0, $dU78w.motion).form)`
	${(0, $5WGN2.stack)("M", "spacebetween", "stretch")}
	height: 100%;
`;
const $a56f499674fbb6f4$var$FormField = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("S", "flexstart", "stretch")};
`;

});
parcelRegister("lQZUP", function(module, exports) {

$parcel$export(module.exports, "TextAreaWithCharLimit", () => $93f9920eadbed483$export$e56bc53471e2004e);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $8FlUV = parcelRequire("8FlUV");

var $hIci4 = parcelRequire("hIci4");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");
const $93f9920eadbed483$export$e56bc53471e2004e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ errorMessage: errorMessage, charLimit: charLimit, text: text, onTextChange: onTextChange, className: className, ...inputProps }, ref)=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const characterLeft = charLimit - text.length;
    return /*#__PURE__*/ (0, $iKObn.jsxs)($93f9920eadbed483$var$Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($93f9920eadbed483$var$StyledTextArea, {
                ref: ref,
                ...inputProps,
                onKeyPress: (e)=>{
                    if (e.key === "Enter") e.preventDefault();
                },
                value: text,
                onChange: (e)=>onTextChange(e.target.value),
                autoResize: true,
                rows: 1,
                error: !!errorMessage || characterLeft < 0
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($93f9920eadbed483$var$LimitWrapper, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                        className: "p-size-xs-semi-bold",
                        children: format("global.textArea.limitCharacters", {
                            limit: charLimit
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($93f9920eadbed483$var$CharactersLeft, {
                        className: "p-size-xs-semi-bold",
                        error: characterLeft < 0,
                        children: characterLeft
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $8FlUV.ErrorMessage), {
                children: errorMessage
            })
        ]
    });
});
$93f9920eadbed483$export$e56bc53471e2004e.displayName = "TextInput";
const $93f9920eadbed483$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(0, "spacebetween", "stretch")};
`;
const $93f9920eadbed483$var$StyledTextArea = (0, $5UMQ1.default)((0, $hIci4.TextArea))`
	margin-bottom: 4px !important;
`;
const $93f9920eadbed483$var$LimitWrapper = (0, $5UMQ1.default).div`
	padding: 0px 8px;
	${(0, $5WGN2.row)(16, "spacebetween", "center")};
`;
const $93f9920eadbed483$var$CharactersLeft = (0, $5UMQ1.default).span`
	color: ${(props)=>props.error ? (0, $kKnoQ.colors).rejection : (0, $kKnoQ.colors).black};
`;

});


parcelRegister("4BN49", function(module, exports) {

$parcel$export(module.exports, "TemplateListingDialog", () => $302d556a06fdd64c$export$360441928d4406bb);

var $iKObn = parcelRequire("iKObn");

var $04Qjn = parcelRequire("04Qjn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $gk3fY = parcelRequire("gk3fY");

var $28f8Y = parcelRequire("28f8Y");

var $1IlhR = parcelRequire("1IlhR");

var $fuvmS = parcelRequire("fuvmS");

var $4x2M3 = parcelRequire("4x2M3");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");
const $302d556a06fdd64c$export$360441928d4406bb = ({ onTemplateClicked: onTemplateClicked, editor: editor, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const handleTemplateClicked = async (template)=>{
        await onTemplateClicked(template);
        otherProps.onHide();
    };
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $gk3fY.BaseDialog), {
        header: format("templateListingDialog.title"),
        width: (0, $gk3fY.DIALOG_SIZE).S,
        ...otherProps,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($302d556a06fdd64c$var$DialogContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)($302d556a06fdd64c$var$DialogContent, {
                onTemplateClicked: handleTemplateClicked,
                editor: editor
            })
        })
    });
};
const $302d556a06fdd64c$var$DialogContent = ({ onTemplateClicked: onTemplateClicked, editor: editor })=>{
    const { templates: templates, loading: loading, error: error, refreshTemplates: refreshTemplates } = (0, $4x2M3.useTemplates)();
    const { format: format } = (0, $1eHG3.useI18n)();
    const [clickError, setClickError] = (0, $81g6h.useState)(false);
    const [onTemplateClickedWithLoading, clickLoading] = (0, $grmoS.useAsyncOperation)(onTemplateClicked, {
        rethrow: true
    });
    if (!templates || clickLoading || clickError) {
        if (loading || clickLoading) return /*#__PURE__*/ (0, $iKObn.jsx)($302d556a06fdd64c$var$CenteredContent, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {
                style: {
                    justifyContent: "center"
                }
            })
        });
        return /*#__PURE__*/ (0, $iKObn.jsx)($302d556a06fdd64c$var$CenteredContent, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
                titleStyle: {
                    fontSize: 24
                },
                description: (0, $04Qjn.isApiError)(error) || clickError ? format("templateListingDialog.error") : undefined,
                onRefresh: clickError ? ()=>setClickError(false) : refreshTemplates
            })
        });
    }
    if (templates.length == 0) return /*#__PURE__*/ (0, $iKObn.jsxs)($302d556a06fdd64c$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($302d556a06fdd64c$var$Title, {
                children: format("templateListingDialog.empty.title")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($302d556a06fdd64c$var$Description, {
                children: format("templateListingDialog.empty.description")
            })
        ]
    });
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
        children: templates.map((template)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $fuvmS.TemplateCard), {
                editor: editor,
                template: template,
                onClick: async ()=>{
                    try {
                        setClickError(false);
                        await onTemplateClickedWithLoading(template);
                    } catch (e) {
                        console.error(e);
                        setClickError(true);
                    }
                }
            }, template.id))
    });
};
const $302d556a06fdd64c$var$DialogContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(24, "flexstart", "stretch")};
	min-height: 500px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		min-height: unset;
	}
`;
const $302d556a06fdd64c$var$Container = (0, $5UMQ1.default).div`
	flex: 1;
	${(0, $5WGN2.stack)(16, "center", "center")}
`;
const $302d556a06fdd64c$var$Title = (0, $5UMQ1.default).h3`
	text-align: center;
	color: ${(0, $kKnoQ.colors).grey};
`;
const $302d556a06fdd64c$var$Description = (0, $5UMQ1.default).div`
	text-align: center;
	max-width: 448px;
	color: ${(0, $kKnoQ.colors).grey};
`;
const $302d556a06fdd64c$var$CenteredContent = (0, $5UMQ1.default).div`
	flex: 1;
	${(0, $5WGN2.stack)(undefined, "center", "center")};
`;

});
parcelRegister("4x2M3", function(module, exports) {

$parcel$export(module.exports, "useTemplates", () => $eb39aa6fd9a51d42$export$b0a9bce6cbec665b);
$parcel$export(module.exports, "useTemplate", () => $eb39aa6fd9a51d42$export$5c3a5f48c762cb34);

var $ghfIB = parcelRequire("ghfIB");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
function $eb39aa6fd9a51d42$export$b0a9bce6cbec665b(withFetch = true) {
    const [loading, setLoading] = (0, $81g6h.useState)(withFetch);
    const [error, setError] = (0, $81g6h.useState)(undefined);
    const templates = (0, $1IWnK.useObservable)((0, $ghfIB.templateManager).templateItems);
    const refreshTemplates = (0, $81g6h.useCallback)(async ()=>{
        try {
            await (0, $ghfIB.templateManager).fetchAllTemplates();
            setError(null);
        } catch (e) {
            setError(e);
            console.error(e);
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $81g6h.useEffect)(()=>{
        withFetch && refreshTemplates();
    }, [
        refreshTemplates,
        withFetch
    ]);
    return {
        loading: loading,
        templates: templates,
        error: error,
        refreshTemplates: refreshTemplates
    };
}
function $eb39aa6fd9a51d42$export$5c3a5f48c762cb34(templateId, withFetch = true) {
    const [loading, setLoading] = (0, $81g6h.useState)(withFetch && !!templateId);
    const [error, setError] = (0, $81g6h.useState)();
    const template = (0, $1IWnK.useComputedObservable)(()=>templateId ? (0, $ghfIB.templateManager).templateById.get().get(templateId) : undefined, [
        templateId
    ]);
    const refreshTemplate = (0, $81g6h.useCallback)(async (templateIdToRefresh)=>{
        try {
            setLoading(true);
            await (0, $ghfIB.templateManager).fetchTemplate(templateIdToRefresh);
            setError(undefined);
        } catch (e) {
            setError(e);
            console.error(e);
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $81g6h.useEffect)(()=>{
        withFetch && templateId && refreshTemplate(templateId);
    }, [
        templateId,
        refreshTemplate,
        withFetch
    ]);
    return {
        loading: loading,
        template: template,
        error: error,
        refreshTemplate: refreshTemplate
    };
}

});


parcelRegister("ajWZo", function(module, exports) {

$parcel$export(module.exports, "ExertionDetailsDialog", () => $8619f55259441f15$export$c6899e38099ccdd2);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $8jRcl = parcelRequire("8jRcl");

var $61E18 = parcelRequire("61E18");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");
parcelRequire("81g6h");
const $8619f55259441f15$export$c6899e38099ccdd2 = (props)=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { formatExertion: formatExertion } = (0, $8jRcl.useFormatFeedback)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $gk3fY.BaseDialog), {
        dismissableMask: true,
        ...props,
        header: format("patientDetails.progress.exertionModal.title"),
        footer: /*#__PURE__*/ (0, $iKObn.jsx)($8619f55259441f15$var$ButtonContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                onClick: props.onHide,
                label: format("patientDetails.progress.exertionModal.button")
            })
        }),
        width: (0, $gk3fY.DIALOG_SIZE).M,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($8619f55259441f15$var$DialogMessage, {
                style: {
                    whiteSpace: "pre-line"
                },
                children: format("patientDetails.progress.exertionModal.description.v1_6")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($8619f55259441f15$var$DialogMessage, {
                style: {
                    whiteSpace: "pre-line"
                },
                children: (0, $61E18.exertionValues).map((v)=>{
                    const exertionWording = formatExertion(v);
                    return /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        children: format("patientDetails.progress.exertionModal.exertionListing.v1_6", exertionWording)
                    }, v);
                })
            })
        ]
    });
};
const $8619f55259441f15$var$DialogMessage = (0, $5UMQ1.default).div`
	margin: 0;
`;
const $8619f55259441f15$var$ButtonContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(24, "flexend")}
`;

});
parcelRegister("8jRcl", function(module, exports) {

$parcel$export(module.exports, "useFormatFeedback", () => $5a2247e75f68fb0a$export$347512fb0c508fe9);

var $iKObn = parcelRequire("iKObn");

var $9S4zP = parcelRequire("9S4zP");

var $eHEmN = parcelRequire("eHEmN");

var $2DfmL = parcelRequire("2DfmL");

var $6Im9F = parcelRequire("6Im9F");

var $e6I5w = parcelRequire("e6I5w");

var $XBq9Z = parcelRequire("XBq9Z");

var $1eHG3 = parcelRequire("1eHG3");

var $61E18 = parcelRequire("61E18");

var $5UMQ1 = parcelRequire("5UMQ1");

var $81g6h = parcelRequire("81g6h");
const $5a2247e75f68fb0a$export$347512fb0c508fe9 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const formatExertion = (0, $81g6h.useCallback)((exertion)=>{
        switch(exertion){
            case 1:
                return {
                    value: format("global.exertion.1.value"),
                    title: format("global.exertion.1.title"),
                    description: format("global.exertion.1.description")
                };
            case 2:
                return {
                    value: format("global.exertion.2.value"),
                    title: format("global.exertion.2.title"),
                    description: format("global.exertion.2.description")
                };
            case 3:
                return {
                    value: format("global.exertion.3.value"),
                    title: format("global.exertion.3.title"),
                    description: format("global.exertion.3.description")
                };
            case 4:
                return {
                    value: format("global.exertion.4.value"),
                    title: format("global.exertion.4.title"),
                    description: format("global.exertion.4.description")
                };
            case 5:
                return {
                    value: format("global.exertion.5.value"),
                    title: format("global.exertion.5.title"),
                    description: format("global.exertion.5.description")
                };
            default:
                return {
                    value: format("global.exertion.6.value"),
                    title: format("global.exertion.6.title"),
                    description: format("global.exertion.6.description")
                };
        }
    }, [
        format
    ]);
    const formatMood = (0, $81g6h.useCallback)((mood)=>{
        switch(mood){
            case (0, $61E18.Mood).VERY_BAD:
                return {
                    title: format("global.mood.1.title"),
                    icon: /*#__PURE__*/ (0, $iKObn.jsx)($5a2247e75f68fb0a$var$MoodImage, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($XBq9Z)))
                    })
                };
            case (0, $61E18.Mood).BAD:
                return {
                    title: format("global.mood.2.title"),
                    icon: /*#__PURE__*/ (0, $iKObn.jsx)($5a2247e75f68fb0a$var$MoodImage, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2DfmL)))
                    })
                };
            case (0, $61E18.Mood).OK:
                return {
                    title: format("global.mood.3.title"),
                    icon: /*#__PURE__*/ (0, $iKObn.jsx)($5a2247e75f68fb0a$var$MoodImage, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($eHEmN)))
                    })
                };
            case (0, $61E18.Mood).GOOD:
                return {
                    title: format("global.mood.4.title"),
                    icon: /*#__PURE__*/ (0, $iKObn.jsx)($5a2247e75f68fb0a$var$MoodImage, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e6I5w)))
                    })
                };
            case (0, $61E18.Mood).VERY_GOOD:
                return {
                    title: format("global.mood.5.title"),
                    icon: /*#__PURE__*/ (0, $iKObn.jsx)($5a2247e75f68fb0a$var$MoodImage, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($9S4zP)))
                    })
                };
            default:
                return {
                    title: format("global.mood.6.title"),
                    icon: /*#__PURE__*/ (0, $iKObn.jsx)($5a2247e75f68fb0a$var$MoodImage, {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6Im9F)))
                    })
                };
        }
    }, [
        format
    ]);
    return {
        formatExertion: formatExertion,
        formatMood: formatMood
    };
};
const $5a2247e75f68fb0a$var$MoodImage = (0, $5UMQ1.default).img`
	width: 16px;
	height: 16px;
`;

});
parcelRegister("9S4zP", function(module, exports) {
module.exports = new URL("grinning-face-with-smiling-eyes.cf7a4a72.png", import.meta.url).toString();

});

parcelRegister("eHEmN", function(module, exports) {
module.exports = new URL("neutral-face.a2812f19.png", import.meta.url).toString();

});

parcelRegister("2DfmL", function(module, exports) {
module.exports = new URL("sad-but-relieved-face.7ac00b63.png", import.meta.url).toString();

});

parcelRegister("6Im9F", function(module, exports) {
module.exports = new URL("smiling-face-with-sunglasses.f2b13c5a.png", import.meta.url).toString();

});

parcelRegister("e6I5w", function(module, exports) {
module.exports = new URL("smiling-face.8b032437.png", import.meta.url).toString();

});

parcelRegister("XBq9Z", function(module, exports) {
module.exports = new URL("tired-face.6eca21f1.png", import.meta.url).toString();

});

parcelRegister("61E18", function(module, exports) {

$parcel$export(module.exports, "exertionValues", () => $f8186e8d42f506fd$export$d4db88c03f6a8a3);
$parcel$export(module.exports, "Mood", () => $f8186e8d42f506fd$export$845df097aff32871);
$parcel$export(module.exports, "moodValues", () => $f8186e8d42f506fd$export$7c0dbb7ad7bdafa1);
const $f8186e8d42f506fd$export$d4db88c03f6a8a3 = [
    1,
    2,
    3,
    4,
    5,
    6
];
var $f8186e8d42f506fd$export$845df097aff32871;
(function(Mood) {
    Mood[Mood["VERY_BAD"] = 1] = "VERY_BAD";
    Mood[Mood["BAD"] = 2] = "BAD";
    Mood[Mood["OK"] = 3] = "OK";
    Mood[Mood["GOOD"] = 4] = "GOOD";
    Mood[Mood["VERY_GOOD"] = 5] = "VERY_GOOD";
    Mood[Mood["EXCELLENT"] = 6] = "EXCELLENT";
})($f8186e8d42f506fd$export$845df097aff32871 || ($f8186e8d42f506fd$export$845df097aff32871 = {}));
const $f8186e8d42f506fd$export$7c0dbb7ad7bdafa1 = [
    1,
    2,
    3,
    4,
    5,
    6
];

});



parcelRegister("5jB8I", function(module, exports) {

$parcel$export(module.exports, "MoodDetailsDialog", () => $1cbf51ae022ff091$export$92aaee0098273510);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $8jRcl = parcelRequire("8jRcl");

var $61E18 = parcelRequire("61E18");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");
parcelRequire("81g6h");
const $1cbf51ae022ff091$export$92aaee0098273510 = (props)=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { formatMood: formatMood } = (0, $8jRcl.useFormatFeedback)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $gk3fY.BaseDialog), {
        dismissableMask: true,
        ...props,
        header: format("patientDetails.progress.moodModal.title"),
        width: (0, $gk3fY.DIALOG_SIZE).M,
        footer: /*#__PURE__*/ (0, $iKObn.jsx)($1cbf51ae022ff091$var$ButtonContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                onClick: props.onHide,
                label: format("patientDetails.progress.moodModal.button")
            })
        }),
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($1cbf51ae022ff091$var$DialogMessage, {
                children: format("patientDetails.progress.moodModal.description.v1_6")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($1cbf51ae022ff091$var$SpacedDialogMessage, {
                children: (0, $61E18.moodValues).map((v)=>{
                    const moodWording = formatMood(v);
                    return /*#__PURE__*/ (0, $iKObn.jsx)($1cbf51ae022ff091$var$AlignCenteredItems, {
                        children: format("patientDetails.progress.moodModal.moodListing.v2_1", {
                            element: moodWording.icon,
                            mood: moodWording.title
                        })
                    }, v);
                })
            })
        ]
    });
};
const $1cbf51ae022ff091$var$DialogMessage = (0, $5UMQ1.default).div`
	white-space: pre-line;
`;
const $1cbf51ae022ff091$var$SpacedDialogMessage = (0, $5UMQ1.default)($1cbf51ae022ff091$var$DialogMessage)`
	${(0, $5WGN2.stack)(8)}
`;
const $1cbf51ae022ff091$var$ButtonContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(24, "flexend")}
`;
const $1cbf51ae022ff091$var$AlignCenteredItems = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, undefined, "center")};

	img {
		margin-right: 4px;
		width: 24px;
		height: 24px;
	}
`;

});

parcelRegister("2rZVV", function(module, exports) {

$parcel$export(module.exports, "MobileAlternativeExerciseDialog", () => $7ebd804d26208068$export$54cde0fa6b33b0f1);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $bFakw = parcelRequire("bFakw");

var $kVPyX = parcelRequire("kVPyX");

var $5UMQ1 = parcelRequire("5UMQ1");

var $243Cr = parcelRequire("243Cr");

var $02Kb9 = parcelRequire("02Kb9");

var $5kXMA = parcelRequire("5kXMA");

var $dVArM = parcelRequire("dVArM");

var $cYBw6 = parcelRequire("cYBw6");

var $5r5yY = parcelRequire("5r5yY");

var $3EwEG = parcelRequire("3EwEG");

var $41K57 = parcelRequire("41K57");

var $kBALX = parcelRequire("kBALX");

var $ffhEE = parcelRequire("ffhEE");

var $jD5Wy = parcelRequire("jD5Wy");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $kLgU7 = parcelRequire("kLgU7");

var $lTdpc = parcelRequire("lTdpc");

var $j19eN = parcelRequire("j19eN");

var $81g6h = parcelRequire("81g6h");

var $6Sita = parcelRequire("6Sita");
var $7ebd804d26208068$var$PlusIcon = function PlusIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M11 13H6a.967.967 0 0 1-.713-.287A.968.968 0 0 1 5 12c0-.283.096-.52.287-.713A.967.967 0 0 1 6 11h5V6c0-.283.096-.52.287-.713A.968.968 0 0 1 12 5c.283 0 .52.096.713.287.191.192.287.43.287.713v5h5c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 18 13h-5v5c0 .283-.096.52-.287.712A.968.968 0 0 1 12 19a.968.968 0 0 1-.713-.288A.968.968 0 0 1 11 18v-5Z",
            fill: "currentColor"
        })
    });
};
$7ebd804d26208068$var$PlusIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $7ebd804d26208068$export$54cde0fa6b33b0f1 = (props)=>{
    const { exercise: exercise, onSave: onSave, onHide: onHide, ...otherProps } = props;
    const { formatExerciseBodyPart: formatExerciseBodyPart, formatExerciseCategory: formatExerciseCategory } = (0, $kVPyX.useExerciseFormatter)();
    const { format: format } = (0, $1eHG3.useI18n)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const [error, setError] = (0, $81g6h.useState)(null);
    const [alternatives, setAlternatives] = (0, $81g6h.useState)(exercise.alternativeExercises);
    const mainAndAlternativeExercises = [
        exercise,
        ...alternatives
    ];
    const addAlternatives = (0, $81g6h.useCallback)((exercises)=>{
        const newAlternatives = exercises.reduce((list, newAlternative)=>{
            if (list.length === (0, $cYBw6.MAX_ALTERNATIVE_EXERCISES)) {
                setError((0, $cYBw6.AlternativeErrorType).MaxExercisesReached);
                return list;
            }
            if (list.some((ex)=>ex.id === newAlternative.id) || exercise.id === newAlternative.id) {
                setError((0, $cYBw6.AlternativeErrorType).OneAlreadyExists);
                return list;
            }
            (0, $bFakw.sendAnalyticsEventAddAlternativeExercises)(exercise, newAlternative);
            return [
                ...list,
                {
                    ...newAlternative,
                    alternatives: null
                }
            ];
        }, alternatives);
        if (exercises.length > 0) (0, $ghfIB.libraryFilterManager).setLastAddedExerciseMetadata(exercises[0].draggableId, true);
        setAlternatives(newAlternatives);
    }, [
        alternatives,
        exercise
    ]);
    const reorderAlternatives = (0, $81g6h.useCallback)((sourceIndex, destinationIndex)=>{
        setAlternatives((0, $kLgU7.reorder)(alternatives, sourceIndex, destinationIndex));
    }, [
        alternatives
    ]);
    const deleteAlternative = (0, $81g6h.useCallback)((deletedAlternative)=>{
        (0, $bFakw.sendAnalyticsEventDeleteAlternativeExercises)(exercise, deletedAlternative);
        setAlternatives(alternatives.filter((alternative)=>alternative.draggableId !== deletedAlternative.draggableId));
    }, [
        alternatives,
        exercise
    ]);
    const onCrossClicked = (0, $81g6h.useCallback)(async ()=>{
        onSave?.({
            ...exercise,
            alternativeExercises: alternatives
        });
        onHide();
        (0, $ghfIB.libraryFilterManager).clearActiveFilteringState();
    }, [
        alternatives,
        exercise,
        onHide,
        onSave
    ]);
    const openLibrary = (0, $81g6h.useCallback)(async ()=>{
        const filteredBodyParts = [
            exercise.primaryBodyPart,
            ...exercise.secondaryBodyParts
        ];
        (0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited.set({
            ...exercise,
            alternativeExercises: alternatives
        });
        (0, $ghfIB.libraryFilterManager).activeCategoryFilters.set([
            (0, $6Sita.createBodyPartsFilter)(filteredBodyParts, format("exercise.bodyPart.title"), formatExerciseBodyPart),
            (0, $6Sita.createCategoriesFilter)([
                exercise.category
            ], format("exercise.category.title"), formatExerciseCategory)
        ]);
        (0, $ghfIB.libraryFilterManager).setIsAlternativeExerciseActive();
        dialogContext?.openModal((0, $243Cr.ModalId).MobileExerciseLibrary, {
            exerciseLibraryAddingFlow: (0, $jD5Wy.ExerciseLibraryFlow).AlternativeExercises,
            onClose: (exercises)=>{
                (async ()=>{
                    addAlternatives(exercises);
                })();
            }
        });
    }, [
        addAlternatives,
        alternatives,
        dialogContext,
        exercise,
        format,
        formatExerciseBodyPart,
        formatExerciseCategory
    ]);
    const updateAlternative = (0, $81g6h.useCallback)((updatedAlternative)=>{
        setAlternatives(alternatives.map((alternative)=>alternative.draggableId === updatedAlternative.draggableId ? {
                ...updatedAlternative,
                alternatives: null
            } : alternative));
    }, [
        alternatives
    ]);
    const { openExerciseDetailsModal: openExerciseDetailsModal } = (0, $kBALX.useEditorExerciseCardActions)();
    const maxAlternativesNotReached = (0, $81g6h.useMemo)(()=>(0, $lTdpc.isNotNil)(alternatives) && alternatives.length < (0, $cYBw6.MAX_ALTERNATIVE_EXERCISES), [
        alternatives
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($7ebd804d26208068$var$StyledDialog, {
        draggable: false,
        resizable: false,
        onHide: onHide,
        blockScroll: true,
        ...otherProps,
        header: /*#__PURE__*/ (0, $iKObn.jsx)((0, $3EwEG.AlternativeExerciseHeader), {
            onCrossClicked: onCrossClicked
        }),
        footer: /*#__PURE__*/ (0, $iKObn.jsxs)($7ebd804d26208068$var$Footer, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $02Kb9.Tooltip), {
                    content: format("programBuilder.alternativeExercises.errors.maximumReached"),
                    disabled: maxAlternativesNotReached,
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($7ebd804d26208068$var$PlusContainer, {
                        onClick: maxAlternativesNotReached ? openLibrary : undefined,
                        clickable: maxAlternativesNotReached,
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($7ebd804d26208068$var$PlusIcon, {
                            width: 24,
                            height: 24,
                            color: (0, $kKnoQ.colors).black
                        })
                    })
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                    className: "p-size-s-bold",
                    children: format("programBuilder.alternativeExerciseDialog.addAlternativesButton")
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($7ebd804d26208068$var$Body, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $5r5yY.AlternativeError), {
                    errorType: error,
                    cleanError: ()=>setError(null)
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $ffhEE.ExerciseCard), {
                    exercise: exercise,
                    deviceType: (0, $5kXMA.ResponsiveDeviceType).Mobile,
                    showAlternatives: false,
                    onlyAllowPreview: true,
                    hideContent: true,
                    onClick: ()=>openExerciseDetailsModal(exercise, mainAndAlternativeExercises, (0, $bFakw.AnalyticsViewExerciseDetailOrigin).CANVAS)
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)($7ebd804d26208068$var$Separator, {}),
                /*#__PURE__*/ (0, $iKObn.jsxs)($7ebd804d26208068$var$AlternativeContainer, {
                    children: [
                        (0, $lTdpc.isNotNil)(alternatives) && alternatives.map((alternative, alternativeIndex)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $dVArM.AlternativeExerciseCard), {
                                alternatives: alternatives,
                                alternativeExercise: alternative,
                                alternativeExerciseIndex: alternativeIndex,
                                relatedExercises: mainAndAlternativeExercises,
                                onReorder: reorderAlternatives,
                                onDelete: deleteAlternative,
                                deviceType: (0, $5kXMA.ResponsiveDeviceType).Mobile,
                                updateExercise: updateAlternative
                            }, alternative.draggableId)),
                        maxAlternativesNotReached && /*#__PURE__*/ (0, $iKObn.jsx)((0, $41K57.NoAlternativeExercisePlaceholder), {
                            onClick: openLibrary
                        })
                    ]
                })
            ]
        })
    });
};
const $7ebd804d26208068$var$StyledDialog = (0, $5UMQ1.default)((0, $j19eN.Dialog))`
	max-width: 450px;
	max-height: 1000px;
	width: 100%;
	height: 95%;
	margin: 16px;

	.p-dialog-content {
		background-color: ${(0, $kKnoQ.colors).primary10};
		border-radius: 0;
		padding: 0;
	}

	.p-dialog-header {
		background-color: ${(0, $kKnoQ.colors).primary10};
		overflow: hidden;
		padding: 16px;

		.p-dialog-header-icons {
			display: none;
		}
	}

	.p-dialog-footer {
		background-color: ${(0, $kKnoQ.colors).primary10};
		overflow: hidden;
		padding: 0;
	}
`;
const $7ebd804d26208068$var$Body = (0, $5UMQ1.default).div`
	padding: 0 12px;
`;
const $7ebd804d26208068$var$AlternativeContainer = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	flex: 1;
	margin-bottom: 8px;
`;
const $7ebd804d26208068$var$Footer = (0, $5UMQ1.default).div`
	padding: 16px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 8px;
	background-color: ${(0, $kKnoQ.colors).primaryBackground};
	border-top: 1px solid ${(0, $kKnoQ.colors).primary25};
`;
const $7ebd804d26208068$var$PlusContainer = (0, $5UMQ1.default).div`
	height: 32px;
	width: 32px;
	${(0, $5WGN2.row)(0, "center", "center")}
	border-radius: 100%;
	background-color: ${({ clickable: clickable })=>clickable ? (0, $kKnoQ.colors).primary25 : (0, $kKnoQ.colors).grey25};
	cursor: ${({ clickable: clickable })=>clickable ? "pointer" : "not-allowed"};
`;
const $7ebd804d26208068$var$Separator = (0, $5UMQ1.default).div`
	margin: 12px 0;
	height: 2px;
	background-color: ${(0, $kKnoQ.colors).primary25};
`;

});
parcelRegister("bFakw", function(module, exports) {

$parcel$export(module.exports, "AnalyticsViewExerciseDetailOrigin", () => $6c080f034b2fbccf$export$2ae0d15f6d6c7d16);
$parcel$export(module.exports, "sendAnalyticsEventViewExerciseDetail", () => $6c080f034b2fbccf$export$1856808fdef22b6d);
$parcel$export(module.exports, "sendAnalyticsEventAddExercise", () => $6c080f034b2fbccf$export$6747817e7bd566e);
$parcel$export(module.exports, "sendAnalyticsEventRemoveExercise", () => $6c080f034b2fbccf$export$558f553470d82a86);
$parcel$export(module.exports, "sendAnalyticsEventDuplicateExercise", () => $6c080f034b2fbccf$export$6aec53b994359f70);
$parcel$export(module.exports, "sendAnalyticsEventOpenComplementaryExercises", () => $6c080f034b2fbccf$export$ffb8a5930774d2ef);
$parcel$export(module.exports, "sendAnalyticsEventOpenAlternativeExercises", () => $6c080f034b2fbccf$export$fbfad6c6953e7b90);
$parcel$export(module.exports, "sendAnalyticsEventAddAlternativeExercises", () => $6c080f034b2fbccf$export$6b42083285bb9a63);
$parcel$export(module.exports, "sendAnalyticsEventDeleteAlternativeExercises", () => $6c080f034b2fbccf$export$a330a3b946cc079c);
$parcel$export(module.exports, "sendAnalyticsEventPlayVoiceOver", () => $6c080f034b2fbccf$export$e881f2b9ae694274);
$parcel$export(module.exports, "sendAnalyticsOpenAlternativeExercisesInfoTooltip", () => $6c080f034b2fbccf$export$3aecc0d47156294a);
$parcel$export(module.exports, "sendAnalyticsEventExerciseDetailsViewVideoOrKeyframe", () => $6c080f034b2fbccf$export$fac82bb0902b0418);
$parcel$export(module.exports, "sendAnalyticsEventExerciseDetailsComment", () => $6c080f034b2fbccf$export$fd31f7d5faccda95);
$parcel$export(module.exports, "sendAnalyticsEventNavigationClick", () => $6c080f034b2fbccf$export$19dab363549c6031);

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $hLaGu = parcelRequire("hLaGu");
var $6c080f034b2fbccf$export$2ae0d15f6d6c7d16;
(function(AnalyticsViewExerciseDetailOrigin) {
    AnalyticsViewExerciseDetailOrigin["CANVAS"] = "ProgramBuilder-canvas";
    AnalyticsViewExerciseDetailOrigin["LIBRARY"] = "ProgramBuilder-library";
    AnalyticsViewExerciseDetailOrigin["CANVAS_EXERCISE_DETAIL"] = "ProgramBuilder-canvasExerciseDetail";
    AnalyticsViewExerciseDetailOrigin["EXERCISE"] = "Exercise";
})($6c080f034b2fbccf$export$2ae0d15f6d6c7d16 || ($6c080f034b2fbccf$export$2ae0d15f6d6c7d16 = {}));
const $6c080f034b2fbccf$export$1856808fdef22b6d = (exercise, origin)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).EXERCISE,
        action: "viewExerciseDetail",
        params: [
            origin,
            exercise.category,
            $6c080f034b2fbccf$var$exerciseAnalyticsBodyPartsString(exercise),
            exercise.difficulty,
            exercise.startingPosition,
            exercise.title,
            exercise.id,
            exercise.revision
        ]
    });
const $6c080f034b2fbccf$export$6747817e7bd566e = (exercise, category)=>(0, $ghfIB.analyticsService).trackEvent({
        category: category,
        action: "addExercise",
        params: [
            exercise.category,
            $6c080f034b2fbccf$var$exerciseAnalyticsBodyPartsString(exercise),
            exercise.difficulty,
            exercise.startingPosition,
            exercise.title,
            exercise.id,
            exercise.revision
        ]
    });
const $6c080f034b2fbccf$export$558f553470d82a86 = (exercise, category)=>(0, $ghfIB.analyticsService).trackEvent({
        category: category,
        action: "removeExercise",
        params: [
            exercise.category,
            $6c080f034b2fbccf$var$exerciseAnalyticsBodyPartsString(exercise),
            exercise.difficulty,
            exercise.startingPosition,
            exercise.title,
            exercise.id,
            exercise.revision
        ]
    });
const $6c080f034b2fbccf$export$6aec53b994359f70 = (exercise, category)=>(0, $ghfIB.analyticsService).trackEvent({
        category: category,
        action: "duplicateExercise",
        params: [
            exercise.category,
            $6c080f034b2fbccf$var$exerciseAnalyticsBodyPartsString(exercise),
            exercise.difficulty,
            exercise.startingPosition,
            exercise.title,
            exercise.id,
            exercise.revision
        ]
    });
const $6c080f034b2fbccf$export$ffb8a5930774d2ef = (exercise)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "openComplementaryExercises",
        params: [
            exercise.title,
            exercise.id
        ]
    });
const $6c080f034b2fbccf$export$fbfad6c6953e7b90 = (exercise)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "openAlternativeExercises",
        params: [
            exercise.title,
            exercise.id
        ]
    });
const $6c080f034b2fbccf$export$6b42083285bb9a63 = (exercise, alternativeExercise)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "addAlternativeExercises",
        params: [
            exercise.title,
            exercise.id,
            alternativeExercise.title,
            alternativeExercise.id
        ]
    });
const $6c080f034b2fbccf$export$a330a3b946cc079c = (exercise, alternativeExercise)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "deleteAlternativeExercises",
        params: [
            exercise.title,
            exercise.id,
            alternativeExercise.title,
            alternativeExercise.id
        ]
    });
const $6c080f034b2fbccf$var$exerciseAnalyticsBodyPartsString = (exercise)=>(0, $hLaGu.exerciseBodyParts)(exercise).join(";");
const $6c080f034b2fbccf$export$e881f2b9ae694274 = (exercise)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).EXERCISE,
        action: "playVoiceOver",
        params: [
            exercise.title,
            exercise.id
        ]
    });
const $6c080f034b2fbccf$export$3aecc0d47156294a = ()=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).EXERCISE,
        action: "openAlternativeExercisesInfoTooltip"
    });
const $6c080f034b2fbccf$export$fac82bb0902b0418 = (exerciseId, isKeyframeDisplayed)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).EXERCISE,
        action: isKeyframeDisplayed ? "viewVideo" : "viewKeyframe",
        params: [
            exerciseId
        ]
    });
const $6c080f034b2fbccf$export$fd31f7d5faccda95 = (programId, contextAnalyticsCategory, currentExercise, initComment)=>{
    if (initComment !== currentExercise.comment) {
        let action = "editComment";
        if (initComment === undefined) action = "addComment";
        else if (currentExercise.comment === undefined) action = "removeComment";
        (0, $ghfIB.analyticsService).trackEvent({
            category: (0, $auPqo.AnalyticsCategory).EXERCISE,
            action: action,
            params: [
                currentExercise.id,
                currentExercise.title,
                programId !== "" ? programId : "unsaved",
                contextAnalyticsCategory
            ]
        });
    }
};
const $6c080f034b2fbccf$export$19dab363549c6031 = (clickCount)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).EXERCISE,
        action: "navigationClick",
        params: [
            clickCount
        ]
    });

});

parcelRegister("kVPyX", function(module, exports) {

$parcel$export(module.exports, "useExerciseFormatter", () => $30d6138584f13cec$export$eb58e5b4ac53502b);

var $ibHMF = parcelRequire("ibHMF");

var $1eHG3 = parcelRequire("1eHG3");

var $81g6h = parcelRequire("81g6h");
const $30d6138584f13cec$export$eb58e5b4ac53502b = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return (0, $81g6h.useMemo)(()=>new (0, $ibHMF.ExerciseFormatter)(format), [
        format
    ]);
};

});
parcelRegister("ibHMF", function(module, exports) {

$parcel$export(module.exports, "ExerciseFormatter", () => $617805a8c1e949cf$export$f0c443e5db5c3236);

var $hLaGu = parcelRequire("hLaGu");
const $617805a8c1e949cf$var$exerciseCategoryWordings = {
    [(0, $hLaGu.ExerciseCategory).WarmUp]: "exercise.category.value.warmUp",
    [(0, $hLaGu.ExerciseCategory).Stretching]: "exercise.category.value.stretching",
    [(0, $hLaGu.ExerciseCategory).Strengthening]: "exercise.category.value.strengthening",
    [(0, $hLaGu.ExerciseCategory).CoordinationAndBalance]: "exercise.category.value.coordinationBalance"
};
const $617805a8c1e949cf$var$exerciseBodyPartWordings = {
    [(0, $hLaGu.ExerciseBodyPart).UpperLimbs]: "exercise.bodyPart.value.upperLimbs",
    [(0, $hLaGu.ExerciseBodyPart).LowerLimbs]: "exercise.bodyPart.value.lowerLimbs",
    [(0, $hLaGu.ExerciseBodyPart).HeadTrunk]: "exercise.bodyPart.value.headAndTrunk",
    [(0, $hLaGu.ExerciseBodyPart).FullBody]: "exercise.bodyPart.value.fullBody"
};
const $617805a8c1e949cf$var$exerciseStartingPositionWordings = {
    [(0, $hLaGu.ExerciseStartingPosition).LyingDown]: "exercise.startingPosition.value.lyingDown",
    [(0, $hLaGu.ExerciseStartingPosition).Kneeling]: "exercise.startingPosition.value.kneeling",
    [(0, $hLaGu.ExerciseStartingPosition).SittingChair]: "exercise.startingPosition.value.sitting.chair",
    [(0, $hLaGu.ExerciseStartingPosition).SittingFloor]: "exercise.startingPosition.value.sitting.floor",
    [(0, $hLaGu.ExerciseStartingPosition).Standing]: "exercise.startingPosition.value.standing"
};
const $617805a8c1e949cf$var$exerciseDifficultyWordings = {
    [(0, $hLaGu.ExerciseDifficulty).Easy]: "exercise.difficulty.value.easy",
    [(0, $hLaGu.ExerciseDifficulty).Moderate]: "exercise.difficulty.value.moderate",
    [(0, $hLaGu.ExerciseDifficulty).Hard]: "exercise.difficulty.value.hard"
};
const $617805a8c1e949cf$var$exerciseWithWheelchairWordings = {
    true: "exercise.withWheelchair.value.yes",
    false: "exercise.withWheelchair.value.no"
};
// HelpNeeded = CaregiverAssistance
const $617805a8c1e949cf$var$exerciseHelpNeededWordings = {
    true: "exercise.helpNeeded.value.yes",
    false: "exercise.helpNeeded.value.no"
};
const $617805a8c1e949cf$var$exerciseCaregiverAssistanceWordings = {
    true: "exercise.caregiverAssistance.value.yes",
    false: "exercise.caregiverAssistance.value.no"
};
const $617805a8c1e949cf$var$LABEL_KEY_EMPTY_SECTION = "exerciseDetailsModal.emptySection";
class $617805a8c1e949cf$export$f0c443e5db5c3236 {
    constructor(format){
        this.format = format;
        this.formatExerciseBodyPart = this.formatExerciseBodyPart.bind(this);
        this.formatExerciseBodyParts = this.formatExerciseBodyParts.bind(this);
        this.formatExerciseCategory = this.formatExerciseCategory.bind(this);
        this.formatExerciseStartingPosition = this.formatExerciseStartingPosition.bind(this);
        this.formatEquipements = this.formatEquipements.bind(this);
        this.formatExerciseDifficulty = this.formatExerciseDifficulty.bind(this);
        this.formatExerciseWithWheelchair = this.formatExerciseWithWheelchair.bind(this);
        this.formatExerciseHelpNeeded = this.formatExerciseHelpNeeded.bind(this);
        this.formatExerciseCaregiverAssistance = this.formatExerciseCaregiverAssistance.bind(this);
    }
    formatExerciseBodyPart(bodyPart) {
        return (0, $hLaGu.isExerciseBodyPart)(bodyPart) ? this.format($617805a8c1e949cf$var$exerciseBodyPartWordings[bodyPart]) : bodyPart;
    }
    formatExerciseBodyParts(bodyParts) {
        return bodyParts.length > 0 ? bodyParts.map((bodyPart)=>this.formatExerciseBodyPart(bodyPart)).join(", ") : this.format($617805a8c1e949cf$var$LABEL_KEY_EMPTY_SECTION);
    }
    formatExerciseCategory(category) {
        return (0, $hLaGu.isExerciseCategory)(category) ? this.format($617805a8c1e949cf$var$exerciseCategoryWordings[category]) : category;
    }
    formatExerciseStartingPosition(startingPosition) {
        return (0, $hLaGu.isExerciseStartingPosition)(startingPosition) ? this.format($617805a8c1e949cf$var$exerciseStartingPositionWordings[startingPosition]) : startingPosition;
    }
    formatEquipements(equipments) {
        return equipments.length > 0 ? equipments.map((e)=>e.name).join(", ") : this.format("exerciseDetailsModal.emptySection");
    }
    formatExerciseDifficulty(difficulty) {
        return (0, $hLaGu.isExerciseDifficulty)(difficulty) ? this.format($617805a8c1e949cf$var$exerciseDifficultyWordings[difficulty]) : difficulty;
    }
    formatExerciseWithWheelchair(withWheelchair) {
        return this.format($617805a8c1e949cf$var$exerciseWithWheelchairWordings[withWheelchair ? "true" : "false"]);
    }
    formatExerciseHelpNeeded(helpNeeded) {
        return this.format($617805a8c1e949cf$var$exerciseHelpNeededWordings[helpNeeded ? "true" : "false"]);
    }
    formatExerciseCaregiverAssistance(caregiverAssistance) {
        return this.format($617805a8c1e949cf$var$exerciseCaregiverAssistanceWordings[caregiverAssistance ? "true" : "false"]);
    }
}

});


parcelRegister("dVArM", function(module, exports) {

$parcel$export(module.exports, "DraggableAlternativeExerciseCard", () => $5a891d1b87521912$export$5f1ebafbb5468e7b);
$parcel$export(module.exports, "AlternativeExerciseCard", () => $5a891d1b87521912$export$2bfd8d79022b55f);

var $iKObn = parcelRequire("iKObn");

var $bFakw = parcelRequire("bFakw");

var $5kXMA = parcelRequire("5kXMA");

var $8tJeT = parcelRequire("8tJeT");

var $2Z0Ms = parcelRequire("2Z0Ms");

var $2zGye = parcelRequire("2zGye");

var $kBALX = parcelRequire("kBALX");

var $a59kI = parcelRequire("a59kI");

var $ffhEE = parcelRequire("ffhEE");

var $81g6h = parcelRequire("81g6h");
const $5a891d1b87521912$export$5f1ebafbb5468e7b = ({ alternatives: alternatives, alternativeExercise: alternativeExercise, alternativeExerciseIndex: alternativeExerciseIndex, relatedExercises: relatedExercises, uiStyle: uiStyle, shouldAnimate: shouldAnimate, className: className, onReorder: onReorder, updateExercise: updateExercise, onDelete: onDelete, index: index })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $a59kI.DraggableCard), {
        exercise: alternativeExercise,
        index: index,
        renderCard: ({ cardStyle: cardStyle, overriddenUiStyle: overriddenUiStyle, provided: provided, snapshot: snapshot })=>/*#__PURE__*/ (0, $iKObn.jsx)($5a891d1b87521912$export$2bfd8d79022b55f, {
                ref: provided.innerRef,
                ...provided.draggableProps,
                ...provided.dragHandleProps,
                className: className,
                style: cardStyle,
                shouldAnimate: shouldAnimate,
                alternativeExercise: alternativeExercise,
                relatedExercises: relatedExercises,
                uiStyle: overriddenUiStyle ?? uiStyle,
                id: alternativeExercise.draggableId,
                draggable: true,
                isDragging: snapshot.isDragging,
                onDelete: onDelete,
                updateExercise: updateExercise,
                onReorder: onReorder,
                alternatives: alternatives,
                alternativeExerciseIndex: alternativeExerciseIndex,
                deviceType: (0, $5kXMA.ResponsiveDeviceType).Desktop
            })
    });
const $5a891d1b87521912$export$2bfd8d79022b55f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ uiStyle: uiStyle = "card", deviceType: deviceType = (0, $5kXMA.ResponsiveDeviceType).Mobile, alternatives: alternatives, alternativeExercise: alternativeExercise, alternativeExerciseIndex: alternativeExerciseIndex, relatedExercises: relatedExercises, shouldAnimate: shouldAnimate, draggable: draggable = false, isDragging: isDragging = false, onReorder: onReorder, onDelete: onDelete, updateExercise: updateExercise, ...props }, ref)=>{
    const { openExerciseDetailsModal: openExerciseDetailsModal } = (0, $kBALX.useEditorExerciseCardActions)();
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $ffhEE.ExerciseCard), {
        ...props,
        ref: ref,
        uiStyle: uiStyle,
        deviceType: deviceType,
        exercise: alternativeExercise,
        shouldAnimate: shouldAnimate,
        draggable: draggable,
        isDragging: isDragging,
        onClick: ()=>openExerciseDetailsModal(alternativeExercise, relatedExercises, (0, $bFakw.AnalyticsViewExerciseDetailOrigin).CANVAS),
        onCommentIconClick: ()=>openExerciseDetailsModal(alternativeExercise, relatedExercises, (0, $bFakw.AnalyticsViewExerciseDetailOrigin).CANVAS, (0, $2zGye.ExerciseDetailsDialogTabs).COMMENT),
        Options: /*#__PURE__*/ (0, $iKObn.jsx)((0, $2Z0Ms.AlternativeExerciseOptions), {
            alternativeExercise: alternativeExercise,
            onDelete: onDelete,
            relatedExercises: relatedExercises
        }),
        Footer: /*#__PURE__*/ (0, $iKObn.jsx)((0, $8tJeT.AlternativeExerciseFooterOptions), {
            alternatives: alternatives,
            alternativeExercise: alternativeExercise,
            alternativeExerciseIndex: alternativeExerciseIndex,
            relatedExercises: relatedExercises,
            onDelete: onDelete,
            onReorder: onReorder
        }),
        updateExercise: updateExercise
    });
});
$5a891d1b87521912$export$2bfd8d79022b55f.displayName = "AlternativeExerciseCard";

});
parcelRegister("8tJeT", function(module, exports) {

$parcel$export(module.exports, "AlternativeExerciseFooterOptions", () => $118b2dd3fb212cb7$export$870418f88f720089);

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $jG76e = parcelRequire("jG76e");

var $2Z0Ms = parcelRequire("2Z0Ms");
const $118b2dd3fb212cb7$export$870418f88f720089 = ({ alternatives: alternatives, alternativeExercise: alternativeExercise, alternativeExerciseIndex: alternativeExerciseIndex, relatedExercises: relatedExercises, onDelete: onDelete, onReorder: onReorder })=>{
    const handleMoveUp = ()=>{
        onReorder?.(alternativeExerciseIndex, alternativeExerciseIndex - 1);
    };
    const handleMoveDown = ()=>{
        onReorder?.(alternativeExerciseIndex, alternativeExerciseIndex + 1);
    };
    return /*#__PURE__*/ (0, $iKObn.jsxs)($118b2dd3fb212cb7$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $jG76e.Stepper), {
                onMoveUp: handleMoveUp,
                onMoveDown: handleMoveDown,
                min: 0,
                max: alternatives.length - 1,
                value: alternativeExerciseIndex
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $2Z0Ms.AlternativeExerciseOptions), {
                alternativeExercise: alternativeExercise,
                onDelete: onDelete,
                relatedExercises: relatedExercises
            })
        ]
    });
};
const $118b2dd3fb212cb7$var$Container = (0, $5UMQ1.default).div`
	display: flex;
	justify-content: space-between;
	margin: -4px -4px -8px 16px;

	> svg {
		cursor: pointer;
	}
`;

});
parcelRegister("jG76e", function(module, exports) {

$parcel$export(module.exports, "Stepper", () => $924a5e0aec9e34e1$export$ed8ca599049e8881);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("81g6h");

var $kKnoQ = parcelRequire("kKnoQ");

var $9AWgp = parcelRequire("9AWgp");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $lTdpc = parcelRequire("lTdpc");
var $924a5e0aec9e34e1$var$ArrowDownIcon = function ArrowDownIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M17.712 12.71a1.001 1.001 0 0 0-1.42 0L13.003 16V6a1 1 0 0 0-2 0v10l-3.29-3.29a1 1 0 1 0-1.42 1.41l4.3 4.29a2 2 0 0 0 1.41.59 2 2 0 0 0 1.4-.59l4.3-4.29a1 1 0 0 0 .01-1.41Z",
            fill: "currentColor"
        })
    });
};
$924a5e0aec9e34e1$var$ArrowDownIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $924a5e0aec9e34e1$var$ArrowUpIcon = function ArrowUpIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "m17.71 9.376-4.3-4.29a2 2 0 0 0-2.82 0l-4.3 4.29a1 1 0 1 0 1.42 1.41L11 7.496v11a1 1 0 0 0 2 0v-11l3.29 3.29a1 1 0 0 0 1.42-1.41Z",
            fill: "currentColor"
        })
    });
};
$924a5e0aec9e34e1$var$ArrowUpIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $924a5e0aec9e34e1$export$ed8ca599049e8881 = ({ iconUp: IconUp = $924a5e0aec9e34e1$var$ArrowUpIcon, iconDown: IconDown = $924a5e0aec9e34e1$var$ArrowDownIcon, onMoveUp: onMoveUp, onMoveDown: onMoveDown, min: min, max: max, value: value, className: className })=>{
    const isFirst = (0, $lTdpc.isNotNil)(min) && (0, $lTdpc.isNotNil)(value) && value <= min;
    const isLast = (0, $lTdpc.isNotNil)(max) && (0, $lTdpc.isNotNil)(value) && value >= max;
    return /*#__PURE__*/ (0, $iKObn.jsxs)($924a5e0aec9e34e1$var$Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $9AWgp.Button), {
                onClick: onMoveUp,
                disabled: isFirst,
                children: /*#__PURE__*/ (0, $iKObn.jsx)(IconUp, {
                    width: 24,
                    height: 24,
                    color: isFirst ? (0, $kKnoQ.colors).grey50 : (0, $kKnoQ.colors).grey
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($924a5e0aec9e34e1$var$Separator, {}),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $9AWgp.Button), {
                onClick: onMoveDown,
                disabled: isLast,
                children: /*#__PURE__*/ (0, $iKObn.jsx)(IconDown, {
                    width: 24,
                    height: 24,
                    color: isLast ? (0, $kKnoQ.colors).grey50 : (0, $kKnoQ.colors).grey
                })
            })
        ]
    });
};
const $924a5e0aec9e34e1$var$Separator = (0, $5UMQ1.default).div`
	width: 1px;
	height: 100%;
	background-color: ${(0, $kKnoQ.colors).neutral10};
`;
const $924a5e0aec9e34e1$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "center", "center")};
	width: 88px;
	height: 40px;
	border-radius: 30px;
	border: 1px solid ${(0, $kKnoQ.colors).neutral10};
	overflow: hidden;

	> button {
		${(0, $5WGN2.row)(undefined, "center", "center")};
		flex: 1;
		height: 100%;
		margin: 0;
		padding: 0;
		border: none;
		border-radius: 0;
		background-color: transparent;

		&:not(:disabled):hover {
			background-color: ${(0, $kKnoQ.colors).grey10};
			cursor: pointer;
		}
	}
	.p-button:disabled {
		background-color: unset;
	}
`;

});

parcelRegister("2Z0Ms", function(module, exports) {

$parcel$export(module.exports, "AlternativeExerciseOptions", () => $437273c957b1cc2f$export$68357d87c6418487);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $bFakw = parcelRequire("bFakw");

var $4UKJF = parcelRequire("4UKJF");

var $5UMQ1 = parcelRequire("5UMQ1");

var $amllh = parcelRequire("amllh");

var $kBALX = parcelRequire("kBALX");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");
var $437273c957b1cc2f$var$DeleteIcon = function DeleteIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M10.82 2c-.52 0-1.01.2-1.38.57L9.01 3h-5c-.13 0-.26.02-.39.07a1.004 1.004 0 0 0-.55.55c-.05.12-.07.25-.07.39s.02.26.07.39c.05.12.13.23.22.33.1.09.21.17.33.22.13.05.26.07.39.07h16c.13 0 .26-.02.39-.07a1.004 1.004 0 0 0 .55-.55c.05-.12.07-.25.07-.39s-.02-.26-.07-.39a1.19 1.19 0 0 0-.22-.33c-.1-.09-.21-.17-.33-.22-.13-.05-.26-.07-.39-.07h-5l-.43-.43A1.92 1.92 0 0 0 13.2 2h-2.38ZM16.13 22H7.88c-1.5 0-2.78-1.05-2.97-2.447L3.409 8.136a1 1 0 0 1 .991-1.13h15.22a1 1 0 0 1 .991 1.13L19.11 19.534C18.9 20.95 17.62 22 16.13 22ZM5.5 8.88l1.39 10.448c.06.44.5.797.99.797h8.25c.5 0 .93-.356 1-.825l1.39-10.42H5.5Z",
            fill: "currentColor"
        })
    });
};
$437273c957b1cc2f$var$DeleteIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $437273c957b1cc2f$var$EyeVisibleIcon = function EyeVisibleIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_177_172)",
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M.208 11.128C1.016 9.392 4.511 3 12.01 3c7.473 0 10.978 6.378 11.803 8.11l.005.01.005.01c.246.551.246 1.189 0 1.74l-.005.01-.005.01c-.824 1.73-4.3 8.11-11.803 8.11-7.492 0-10.987-6.399-11.8-8.125a1.974 1.974 0 0 1-.002-1.747ZM12.01 5c-6.225 0-9.23 5.34-9.993 6.981l-.006.013-.003.006.002.004.005.01C2.79 13.662 5.795 19 12.01 19c6.196 0 9.182-5.266 9.99-6.954a.138.138 0 0 0 0-.092C21.193 10.268 18.177 5 12.01 5Z"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M12.01 16.22a4.22 4.22 0 1 0 0-8.44 4.22 4.22 0 0 0 0 8.44Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_177_172",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
};
$437273c957b1cc2f$var$EyeVisibleIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $437273c957b1cc2f$export$68357d87c6418487 = ({ alternativeExercise: alternativeExercise, relatedExercises: relatedExercises, onDelete: onDelete })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const user = (0, $4UKJF.useUser)();
    const { openExerciseDetailsModal: openExerciseDetailsModal } = (0, $kBALX.useEditorExerciseCardActions)();
    const viewDetails = (0, $81g6h.useCallback)(()=>{
        (0, $lTdpc.isNotNil)(user) && openExerciseDetailsModal(alternativeExercise, relatedExercises, (0, $bFakw.AnalyticsViewExerciseDetailOrigin).CANVAS_EXERCISE_DETAIL);
    }, [
        alternativeExercise,
        openExerciseDetailsModal,
        relatedExercises,
        user
    ]);
    const items = (0, $81g6h.useMemo)(()=>[
            {
                text: format("programBuilder.exerciseCard.details"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($437273c957b1cc2f$var$EyeVisibleIcon, {}),
                onClick: viewDetails
            },
            {
                text: format("programBuilder.exerciseCard.delete"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($437273c957b1cc2f$var$DeleteIcon, {}),
                onClick: ()=>onDelete?.(alternativeExercise),
                destructive: true
            }
        ], [
        alternativeExercise,
        format,
        onDelete,
        viewDetails
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($437273c957b1cc2f$var$StyledMenuButton, {
        menuItems: items,
        menuId: `popup_menu_${alternativeExercise.draggableId}`,
        menuPosition: (0, $amllh.MenuPosition).CenteredPosition,
        menuIconSize: 24
    });
};
const $437273c957b1cc2f$var$StyledMenuButton = (0, $5UMQ1.default)((0, $amllh.MenuButton))`
	> button {
		padding: 0 2px;

		> div {
			background-color: unset;
			width: auto;
			height: auto;
			padding: 6px;

			:hover {
				background-color: ${(0, $kKnoQ.colors).primaryBackground};
			}
		}
	}
`;

});
parcelRegister("kBALX", function(module, exports) {

$parcel$export(module.exports, "useEditorExerciseCardActions", () => $87bd27a68798066c$export$a0b832dcaec2ccd8);

var $bFakw = parcelRequire("bFakw");

var $4UKJF = parcelRequire("4UKJF");

var $243Cr = parcelRequire("243Cr");

var $lKGAO = parcelRequire("lKGAO");

var $lTdpc = parcelRequire("lTdpc");

var $buI4E = parcelRequire("buI4E");

var $81g6h = parcelRequire("81g6h");
const $87bd27a68798066c$export$a0b832dcaec2ccd8 = ()=>{
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const trackingContext = (0, $81g6h.useContext)((0, $lKGAO.TrackingContext));
    const user = (0, $4UKJF.useUser)();
    const openExerciseDetailsModal = (0, $81g6h.useCallback)((exercise, relatedExercises, origin, selectedTab)=>{
        (0, $lTdpc.isNotNil)(user) && dialogContext?.openModal((0, $243Cr.ModalId).ExerciseDetails, {
            relatedExercises: relatedExercises,
            exerciseIndex: relatedExercises.findIndex((ex)=>ex.draggableId === exercise.draggableId),
            selectedTab: selectedTab,
            editable: true,
            trackingContext: trackingContext,
            editorName: (0, $buI4E.formatName)(user)
        });
        (0, $bFakw.sendAnalyticsEventViewExerciseDetail)(exercise, origin);
    }, [
        dialogContext,
        trackingContext,
        user
    ]);
    return {
        openExerciseDetailsModal: openExerciseDetailsModal
    };
};

});
parcelRegister("lKGAO", function(module, exports) {

$parcel$export(module.exports, "TrackingContext", () => $413edccf40b13f2f$export$2c6a8933d8f02b5c);
$parcel$export(module.exports, "TrackingContextProvider", () => $413edccf40b13f2f$export$8f1d653ee6383fc);

var $iKObn = parcelRequire("iKObn");

var $auPqo = parcelRequire("auPqo");

var $81g6h = parcelRequire("81g6h");
const $413edccf40b13f2f$export$2c6a8933d8f02b5c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createContext({
    category: (0, $auPqo.AnalyticsCategory).PROGRAM,
    programId: ""
});
const $413edccf40b13f2f$export$8f1d653ee6383fc = ({ category: category, programId: programId, children: children })=>{
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useMemo(()=>({
            category: category,
            programId: programId
        }), [
        category,
        programId
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($413edccf40b13f2f$export$2c6a8933d8f02b5c.Provider, {
        value: value,
        children: children
    });
};

});




parcelRegister("2zGye", function(module, exports) {

$parcel$export(module.exports, "ExerciseDetailsDialogTabs", () => $09fc2164ef268eb2$export$43e9cfb736863a7e);
$parcel$export(module.exports, "ExerciseDetailsDialog", () => $09fc2164ef268eb2$export$33c315563bc08b32);

var $iKObn = parcelRequire("iKObn");

var $aQb3l = parcelRequire("aQb3l");

var $2jrEq = parcelRequire("2jrEq");

var $1eHG3 = parcelRequire("1eHG3");

var $auPqo = parcelRequire("auPqo");

var $hLaGu = parcelRequire("hLaGu");

var $bFakw = parcelRequire("bFakw");

var $kVPyX = parcelRequire("kVPyX");

var $a6fIt = parcelRequire("a6fIt");

var $kkH7g = parcelRequire("kkH7g");

var $5UMQ1 = parcelRequire("5UMQ1");

var $7NE9I = parcelRequire("7NE9I");

var $dhb7H = parcelRequire("dhb7H");

var $a5hkt = parcelRequire("a5hkt");

var $gk3fY = parcelRequire("gk3fY");

var $cFUyi = parcelRequire("cFUyi");

var $02Kb9 = parcelRequire("02Kb9");

var $5lYAo = parcelRequire("5lYAo");

var $fLclJ = parcelRequire("fLclJ");

var $f35Zw = parcelRequire("f35Zw");

var $9P6Oe = parcelRequire("9P6Oe");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $jKTFw = parcelRequire("jKTFw");

var $lTdpc = parcelRequire("lTdpc");

var $jTpg0 = parcelRequire("jTpg0");

var $bY9wC = parcelRequire("bY9wC");

var $81g6h = parcelRequire("81g6h");
var $09fc2164ef268eb2$var$ArrowLeft = function ArrowLeft(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M11.29 17.712a1.002 1.002 0 0 0 0-1.42L8 13.003h10a1 1 0 0 0 0-2H8l3.29-3.29a1.001 1.001 0 1 0-1.41-1.42l-4.29 4.3a2 2 0 0 0-.59 1.41 2 2 0 0 0 .59 1.4l4.29 4.3a1 1 0 0 0 1.41.01Z",
            fill: "currentColor"
        })
    });
};
$09fc2164ef268eb2$var$ArrowLeft.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $09fc2164ef268eb2$var$ArrowRight = function ArrowRight(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M12.71 17.712a1.002 1.002 0 0 1 0-1.42l3.29-3.29H6a1 1 0 0 1 0-2h10l-3.29-3.29a1.001 1.001 0 1 1 1.41-1.42l4.29 4.3a2 2 0 0 1 .59 1.41 2 2 0 0 1-.59 1.4l-4.29 4.3a1 1 0 0 1-1.41.01Z",
            fill: "currentColor"
        })
    });
};
$09fc2164ef268eb2$var$ArrowRight.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $09fc2164ef268eb2$var$CrossIcon = function CrossIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M6.14 5.302a.836.836 0 0 0-.583 1.435l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26a.834.834 0 0 0 1.377-.263.836.836 0 0 0-.195-.919L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 0 0-.6-.254Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.14 5.015a1.123 1.123 0 0 1 .803.338L12 10.41l5.057-5.057a1.123 1.123 0 1 1 1.588 1.589l-5.057 5.056 5.056 5.056c.107.103.192.226.251.363l-.263.114a.836.836 0 0 0-.189-.272L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 1 0-1.182 1.181l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26c.077.08.17.145.271.189l-.114.263a1.124 1.124 0 0 1-.362-.25L12 13.585l-5.056 5.056a1.123 1.123 0 1 1-1.588-1.588l5.056-5.056-5.057-5.056a1.123 1.123 0 0 1 .785-1.927ZM17.532 18.63a.834.834 0 0 0 1.168-.776.836.836 0 0 0-.068-.323l.263-.114a1.125 1.125 0 0 1-1.477 1.476l.114-.263Z",
                fill: "currentColor"
            })
        ]
    });
};
$09fc2164ef268eb2$var$CrossIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $09fc2164ef268eb2$var$InfoIcon = function InfoIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Zm0-20c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12.01 17.17c-.55 0-1-.45-1-1v-5.44c0-.55.45-1 1-1s1 .45 1 1v5.44c0 .55-.45 1-1 1ZM12 8.11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                fill: "currentColor"
            })
        ]
    });
};
$09fc2164ef268eb2$var$InfoIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $09fc2164ef268eb2$var$BODY_PART_SEPARATOR = "-";
var $09fc2164ef268eb2$export$43e9cfb736863a7e;
(function(ExerciseDetailsDialogTabs) {
    ExerciseDetailsDialogTabs[ExerciseDetailsDialogTabs["DESCRIPTION"] = 0] = "DESCRIPTION";
    ExerciseDetailsDialogTabs[ExerciseDetailsDialogTabs["COMMENT"] = 1] = "COMMENT";
})($09fc2164ef268eb2$export$43e9cfb736863a7e || ($09fc2164ef268eb2$export$43e9cfb736863a7e = {}));
const $09fc2164ef268eb2$export$33c315563bc08b32 = (props)=>{
    const { trackingContext: trackingContext, tabHeaderDisabled: tabHeaderDisabled = false, relatedExercises: relatedExercises, exerciseIndex: exerciseIndex, editable: editable = true, editorName: editorName, selectedTab: tabSelected = 0, onHide: onHide, ...otherProps } = props;
    const [activeIndex, setActiveIndex] = (0, $81g6h.useState)(tabSelected);
    const [currentExerciseIndex, setCurrentExerciseIndex] = (0, $81g6h.useState)(exerciseIndex);
    const currentExercise = (0, $81g6h.useMemo)(()=>relatedExercises[currentExerciseIndex], [
        currentExerciseIndex,
        relatedExercises
    ]);
    const [initialComment, setInitialComment] = (0, $81g6h.useState)(currentExercise.comment);
    const [arrowClickCount, setArrowClickCount] = (0, $81g6h.useState)(0);
    const [isKeyframeDisplayed, setIsKeyframeDisplayed] = (0, $81g6h.useState)(!(0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).isEmpty(currentExercise.keyframeUrls));
    const { format: format } = (0, $1eHG3.useI18n)();
    const { formatExerciseBodyPart: formatExerciseBodyPart, formatExerciseCategory: formatExerciseCategory } = (0, $kVPyX.useExerciseFormatter)();
    const videoRef = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(null);
    const displayCommentTab = (0, $81g6h.useMemo)(()=>!tabHeaderDisabled && (editable || (0, $lTdpc.isNotNil)(currentExercise.comment)) && (0, $aQb3l.FeatureToggles).ENABLE_COMMENTS, [
        currentExercise.comment,
        tabHeaderDisabled,
        editable
    ]);
    const changeExercise = (0, $81g6h.useCallback)((index)=>{
        let newIndex = index;
        if (index < 0) newIndex = 0;
        else if (index >= relatedExercises.length) newIndex = relatedExercises.length - 1;
        (0, $bFakw.sendAnalyticsEventExerciseDetailsComment)(trackingContext.programId, (0, $auPqo.AnalyticsCategories)[trackingContext.category], currentExercise, initialComment);
        setArrowClickCount(arrowClickCount + 1);
        setCurrentExerciseIndex(newIndex);
        setIsKeyframeDisplayed(!(0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).isEmpty(relatedExercises[newIndex].keyframeUrls));
        setInitialComment(relatedExercises[newIndex].comment);
    }, [
        relatedExercises,
        trackingContext.programId,
        trackingContext.category,
        currentExercise,
        initialComment,
        arrowClickCount
    ]);
    const onHideDialog = (0, $81g6h.useCallback)(()=>{
        (0, $bFakw.sendAnalyticsEventExerciseDetailsComment)(trackingContext.programId, (0, $auPqo.AnalyticsCategories)[trackingContext.category], currentExercise, initialComment);
        (0, $bFakw.sendAnalyticsEventNavigationClick)(arrowClickCount);
        onHide();
    }, [
        arrowClickCount,
        currentExercise,
        initialComment,
        onHide,
        trackingContext.category,
        trackingContext.programId
    ]);
    (0, $2jrEq.useKeyboardKeyPressed)({
        [(0, $2jrEq.KeyboardKeys).ArrowLeft]: ()=>changeExercise(currentExerciseIndex - 1),
        [(0, $2jrEq.KeyboardKeys).ArrowRight]: ()=>changeExercise(currentExerciseIndex + 1)
    });
    return /*#__PURE__*/ (0, $iKObn.jsxs)($09fc2164ef268eb2$var$StyledBaseDialog, {
        draggable: false,
        resizable: false,
        closable: false,
        blockScroll: true,
        header: /*#__PURE__*/ (0, $iKObn.jsxs)($09fc2164ef268eb2$var$DialogHeader, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsxs)($09fc2164ef268eb2$var$Navigation, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $a5hkt.ButtonIcon), {
                            icon: $09fc2164ef268eb2$var$ArrowLeft,
                            onClick: ()=>changeExercise(currentExerciseIndex - 1),
                            size: "condensed",
                            disabled: currentExerciseIndex <= 0
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                            children: `${currentExerciseIndex + 1} ${format("exerciseDetailsModal.navigation.outOf")} ${relatedExercises.length}`
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $a5hkt.ButtonIcon), {
                            icon: $09fc2164ef268eb2$var$ArrowRight,
                            onClick: ()=>changeExercise(currentExerciseIndex + 1),
                            size: "condensed",
                            disabled: currentExerciseIndex >= relatedExercises.length - 1
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)($09fc2164ef268eb2$var$StyledCrossIcon, {
                    width: 40,
                    height: 40,
                    color: (0, $kKnoQ.colors).black,
                    "data-test": (0, $a6fIt.e2eTestId).exerciseDetailsDialog.closeButton,
                    onClick: onHideDialog
                })
            ]
        }),
        onHide: ()=>{},
        width: (0, $gk3fY.DIALOG_SIZE).M,
        ...otherProps,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($09fc2164ef268eb2$var$ExerciseHeader, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($09fc2164ef268eb2$var$MainInfo, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)($09fc2164ef268eb2$var$BodyParts, {
                                className: "p-size-s",
                                children: [
                                    (0, $hLaGu.exerciseBodyParts)(currentExercise).map((bodyPart)=>/*#__PURE__*/ (0, $iKObn.jsxs)($09fc2164ef268eb2$var$BodyPartPill, {
                                            children: [
                                                /*#__PURE__*/ (0, $iKObn.jsx)((0, $9P6Oe.BodyPartIcon), {
                                                    bodyPart: bodyPart
                                                }),
                                                formatExerciseBodyPart(bodyPart),
                                                /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                                                    children: $09fc2164ef268eb2$var$BODY_PART_SEPARATOR
                                                })
                                            ]
                                        }, bodyPart)),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                                        children: formatExerciseCategory(currentExercise.category)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                                className: "p-size-l-bold",
                                children: currentExercise.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        children: !(0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).isEmpty(currentExercise.keyframeUrls) && /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                            style: {
                                whiteSpace: "nowrap"
                            },
                            uiStyle: "secondary_B",
                            label: format(isKeyframeDisplayed ? "exerciseDetailsModal.displayType.video" : "exerciseDetailsModal.displayType.keyframes"),
                            onClick: ()=>{
                                (0, $bFakw.sendAnalyticsEventExerciseDetailsViewVideoOrKeyframe)(currentExercise.id, isKeyframeDisplayed);
                                setIsKeyframeDisplayed(!isKeyframeDisplayed);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($09fc2164ef268eb2$var$AssetsContainer, {
                children: isKeyframeDisplayed ? /*#__PURE__*/ (0, $iKObn.jsx)($09fc2164ef268eb2$var$KeyframeContainer, {
                    children: currentExercise.keyframeUrls.map((keyframe, index)=>/*#__PURE__*/ (0, $iKObn.jsx)($09fc2164ef268eb2$var$ImageContainer, {
                            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $cFUyi.ImageWithLoading), {
                                src: keyframe
                            })
                        }, `${keyframe}-${index}`))
                }) : /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)($09fc2164ef268eb2$var$VideoContainer, {
                            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $5lYAo.VideoPlayer), {
                                ref: videoRef,
                                url: currentExercise.videoUrl,
                                loop: true,
                                autoPlay: true,
                                playsInline: true,
                                displayVideoGradient: false,
                                poster: currentExercise.thumbnails.largeThumbnailUrl
                            }, currentExercise.id)
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $7NE9I.AudioPlayer), {
                            url: currentExercise.audioUrl,
                            controls: true,
                            onPlay: ()=>(0, $bFakw.sendAnalyticsEventPlayVoiceOver)(currentExercise)
                        }, currentExercise.id)
                    ]
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($09fc2164ef268eb2$var$StyledTabView, {
                tabHeaderDisabled: tabHeaderDisabled,
                activeIndex: activeIndex,
                onTabChange: (e)=>setActiveIndex(e.index),
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $bY9wC.TabPanel), {
                        header: /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                            className: "p-size-s-bold",
                            children: format("exerciseDetailsModal.description.title")
                        }),
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $f35Zw.ExerciseDescriptionTab), {
                            exercise: currentExercise
                        })
                    }),
                    displayCommentTab && /*#__PURE__*/ (0, $iKObn.jsx)((0, $bY9wC.TabPanel), {
                        header: /*#__PURE__*/ (0, $iKObn.jsxs)($09fc2164ef268eb2$var$HeaderTab, {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                    className: "p-size-s-bold",
                                    children: editable ? format("exerciseDetailsModal.comment.title") : format("exerciseDetailsModal.comment.title.readonly")
                                }),
                                editable && /*#__PURE__*/ (0, $iKObn.jsx)((0, $02Kb9.Tooltip), {
                                    content: format("exerciseDetailsModal.comment.help"),
                                    placement: "auto",
                                    children: /*#__PURE__*/ (0, $iKObn.jsx)($09fc2164ef268eb2$var$IconContainer, {
                                        children: /*#__PURE__*/ (0, $iKObn.jsx)($09fc2164ef268eb2$var$InfoIcon, {
                                            width: 20,
                                            height: 20,
                                            color: (0, $kKnoQ.colors).grey
                                        })
                                    })
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $fLclJ.ExerciseCommentTab), {
                            exercise: currentExercise,
                            editable: editable,
                            editorName: editorName
                        }, currentExercise.draggableId)
                    })
                ]
            })
        ]
    });
};
const $09fc2164ef268eb2$var$StyledBaseDialog = (0, $5UMQ1.default)((0, $gk3fY.BaseDialog))`
	.p-dialog-content {
		padding: 24px;
	}

	.p-dialog-header {
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
		overflow: hidden;
		padding: 16px;
		border-bottom: 1px solid ${(0, $kKnoQ.colors).primary25};

		.p-dialog-header-icons {
			display: none;
		}
	}

	.p-dialog-footer {
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		.p-dialog-header,
		.p-dialog-footer {
			border-radius: 0;
		}
	}
`;
const $09fc2164ef268eb2$var$DialogHeader = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(0, "spacebetween", "center")};
`;
const $09fc2164ef268eb2$var$Navigation = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8, "center", "center")};
	font-weight: normal;
	font-size: 12px;
	color: ${(0, $kKnoQ.colors).grey};
`;
const $09fc2164ef268eb2$var$StyledCrossIcon = (0, $5UMQ1.default)($09fc2164ef268eb2$var$CrossIcon)`
	cursor: pointer;
	padding: 8px;
	border-radius: 50%;

	:hover {
		background-color: ${(0, $kKnoQ.colors).primaryBackground};
	}
`;
const $09fc2164ef268eb2$var$ExerciseHeader = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(10, "spacebetween", "center")};
	padding-bottom: 24px;
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		${(0, $5WGN2.stack)(16)};
		padding-bottom: 16px;
	}
`;
const $09fc2164ef268eb2$var$MainInfo = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(4)};
`;
const $09fc2164ef268eb2$var$BodyParts = (0, $5UMQ1.default).div`
	display: flex;
	flex-wrap: wrap;
	color: ${(0, $kKnoQ.colors).grey80};
	column-gap: 8px;
`;
const $09fc2164ef268eb2$var$BodyPartPill = (0, $5UMQ1.default).div`
	display: flex;
	place-items: center;
	gap: 8px;
`;
const $09fc2164ef268eb2$var$AssetsContainer = (0, $5UMQ1.default).div`
	margin-bottom: 24px;
`;
const $09fc2164ef268eb2$var$KeyframeContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(16)};
	margin-right: -24px;
	padding-bottom: 8px;
	padding-right: 8px;
	overflow: auto;
	${(0, $jKTFw.getScrollbarStyle)(8)};

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		margin-right: -16px;
	}
`;
const $09fc2164ef268eb2$var$ImageContainer = (0, $5UMQ1.default).div`
	width: 200px;
	height: 200px;
	border: 2px solid ${(0, $kKnoQ.colors).primary10};
	border-radius: 16px;
	overflow: hidden;
	flex: 0 0 auto;
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		width: 150px;
		height: 150px;
	}
`;
const $09fc2164ef268eb2$var$VideoContainer = (0, $5UMQ1.default).div`
	border: 2px solid ${(0, $kKnoQ.colors).primary10};
	overflow: hidden;
	border-radius: 16px;
	margin-bottom: 16px;
`;
const $09fc2164ef268eb2$var$StyledTabView = (0, $5UMQ1.default)((0, $bY9wC.TabView))`
	${({ tabHeaderDisabled: tabHeaderDisabled })=>tabHeaderDisabled && (0, $kkH7g.css)`
			.p-tabview-nav {
				display: none;
			}

			.p-tabview-panels {
				padding: 0;
			}
		`}
`;
const $09fc2164ef268eb2$var$IconContainer = (0, $5UMQ1.default).div`
	height: 16px;
`;
const $09fc2164ef268eb2$var$HeaderTab = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8, "flexstart", "center")}
`;

});
parcelRegister("aQb3l", function(module, exports) {

$parcel$export(module.exports, "FeatureToggles", () => $8c70d6baa39dce9d$export$93400b7ea76be473);
const $8c70d6baa39dce9d$export$93400b7ea76be473 = {
    ENABLE_COMMENTS: true
};

});

parcelRegister("7NE9I", function(module, exports) {

$parcel$export(module.exports, "AudioPlayer", () => $462d75ae6f7dc88c$export$832cc5475f11d8b4);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $jTpg0 = parcelRequire("jTpg0");

var $83DYp = parcelRequire("83DYp");

var $81g6h = parcelRequire("81g6h");
var $462d75ae6f7dc88c$var$PauseIcon = function PauseIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.108 5a1 1 0 0 1 .992 1.008l-.1 12.07a1 1 0 0 1-2-.016l.1-12.07A1 1 0 0 1 9.108 5Zm6.06 0a1 1 0 0 1 .992 1.008l-.1 12.07a1 1 0 0 1-2-.016l.1-12.07A1 1 0 0 1 15.168 5Z",
            fill: "currentColor"
        })
    });
};
$462d75ae6f7dc88c$var$PauseIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $462d75ae6f7dc88c$var$PlayIcon = function PlayIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 7c0-1.597 1.753-2.514 3.071-1.687l.006.003 8.135 5.174c1.222.788 1.242 2.587-.007 3.375L9.08 19.042h-.002C7.741 19.9 6 18.938 6 17.36V7Zm2 .003v10.355l.003-.001 8.132-5.182h-.002c0-.001 0-.002-.002-.002l-.002-.002-8.121-5.164a.055.055 0 0 0-.006-.004H8Z",
            fill: "currentColor"
        })
    });
};
$462d75ae6f7dc88c$var$PlayIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $462d75ae6f7dc88c$var$formatDuration = (seconds)=>{
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60).toString().padStart(2, "0");
    return `${mins}:${secs}`;
};
const $462d75ae6f7dc88c$export$832cc5475f11d8b4 = ({ url: url, ...audioProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const [isPlaying, setIsPlaying] = (0, $81g6h.useState)(false);
    const [duration, setDuration] = (0, $81g6h.useState)(0);
    const [time, setTime] = (0, $81g6h.useState)(0);
    const stringTimeStamp = (0, $81g6h.useMemo)(()=>$462d75ae6f7dc88c$var$formatDuration(time), [
        time
    ]);
    const stringDuration = (0, $81g6h.useMemo)(()=>$462d75ae6f7dc88c$var$formatDuration(duration), [
        duration
    ]);
    const refAudio = (0, $81g6h.useRef)(null);
    const handlePause = (0, $81g6h.useCallback)(()=>{
        setIsPlaying(false);
        refAudio.current?.pause();
    }, []);
    const handlePlay = (0, $81g6h.useCallback)((givenTime)=>{
        let newTime = givenTime ?? time;
        setIsPlaying(true);
        if (newTime === duration) newTime = 0;
        setTime(newTime);
        if (refAudio.current) refAudio.current.currentTime = newTime;
        refAudio.current?.play();
    }, [
        duration,
        time
    ]);
    const toggleIsPlaying = (0, $81g6h.useCallback)(()=>{
        isPlaying ? handlePause() : handlePlay();
    }, [
        handlePause,
        handlePlay,
        isPlaying
    ]);
    const handleLoadedMetadata = (0, $81g6h.useCallback)(()=>{
        setDuration((0, $lTdpc.isNotNil)(refAudio.current?.duration) && (0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).isFinite(refAudio.current.duration) ? refAudio.current.duration : 0);
    }, []);
    const handleEnded = (0, $81g6h.useCallback)(()=>{
        setIsPlaying(false);
    }, []);
    const handleProgressBarClick = (0, $81g6h.useCallback)((val)=>{
        handlePause();
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).isNumber(val)) setTime(val);
    }, [
        handlePause
    ]);
    const handleAudioProgress = (0, $81g6h.useCallback)(()=>{
        if (refAudio.current) setTime(refAudio.current.currentTime);
    }, []);
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($462d75ae6f7dc88c$var$Audio, {
                ref: refAudio,
                ...audioProps,
                onLoadedMetadata: handleLoadedMetadata,
                onTimeUpdate: handleAudioProgress,
                onEnded: handleEnded,
                children: /*#__PURE__*/ (0, $iKObn.jsx)("source", {
                    src: url
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($462d75ae6f7dc88c$var$StyledAudioPlayer, {
                borderColor: (0, $kKnoQ.colors).primary25,
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        className: "p-size-s-bold",
                        children: format("audioPlayer.description")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($462d75ae6f7dc88c$var$PlayerContainer, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($462d75ae6f7dc88c$var$IconsContainer, {
                                children: isPlaying ? /*#__PURE__*/ (0, $iKObn.jsx)($462d75ae6f7dc88c$var$PauseIcon, {
                                    width: 16,
                                    height: 16,
                                    color: (0, $kKnoQ.colors).grey,
                                    onClick: toggleIsPlaying
                                }) : /*#__PURE__*/ (0, $iKObn.jsx)($462d75ae6f7dc88c$var$PlayIcon, {
                                    width: 16,
                                    height: 16,
                                    color: (0, $kKnoQ.colors).grey,
                                    onClick: toggleIsPlaying
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($462d75ae6f7dc88c$var$SliderContainer, {
                                children: /*#__PURE__*/ (0, $iKObn.jsx)($462d75ae6f7dc88c$var$StyledSlider, {
                                    value: time,
                                    max: duration,
                                    step: 0.01,
                                    onChange: (e)=>{
                                        handleProgressBarClick(e.value);
                                    },
                                    onSlideEnd: ({ value: value })=>{
                                        handlePlay((0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).isNumber(value) ? value : undefined);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)($462d75ae6f7dc88c$var$TimeStamp, {
                                children: [
                                    stringTimeStamp,
                                    " / ",
                                    stringDuration
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $462d75ae6f7dc88c$var$Audio = (0, $5UMQ1.default).audio`
	display: none;
`;
const $462d75ae6f7dc88c$var$StyledAudioPlayer = (0, $5UMQ1.default).div`
	width: 100%;
	margin-bottom: 16px;
	padding: 16px;
	border-radius: 8px;
	border: 1px solid;
	border-color: ${(props)=>props.borderColor};
`;
const $462d75ae6f7dc88c$var$PlayerContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")};
`;
const $462d75ae6f7dc88c$var$IconsContainer = (0, $5UMQ1.default).div`
	cursor: pointer;
	width: 16px;
	height: 16px;
`;
const $462d75ae6f7dc88c$var$SliderContainer = (0, $5UMQ1.default).div`
	width: calc(100% - 136px);
`;
const $462d75ae6f7dc88c$var$StyledSlider = (0, $5UMQ1.default)((0, $83DYp.Slider))`
	--thickness: 0.75rem;
	.p-slider-handle {
		margin-top: calc(var(--thickness) / -2) !important;
		margin-left: calc(var(--thickness) / -2) !important;
		height: var(--thickness);
		width: var(--thickness);
		transition-property: var(--thickness);
		transition-duration: 0.2s;
	}
	.p-slider-handle:hover {
		--thickness: 1.25rem;
	}
`;
const $462d75ae6f7dc88c$var$TimeStamp = (0, $5UMQ1.default).div``;

});
parcelRegister("83DYp", function(module, exports) {

$parcel$export(module.exports, "Slider", () => $5ddd9c6d3a21dde7$export$472062a354075cee);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $cfkGk = parcelRequire("cfkGk");
"use client";
function $5ddd9c6d3a21dde7$var$_extends() {
    $5ddd9c6d3a21dde7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5ddd9c6d3a21dde7$var$_extends.apply(this, arguments);
}
function $5ddd9c6d3a21dde7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5ddd9c6d3a21dde7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5ddd9c6d3a21dde7$var$_typeof(o);
}
function $5ddd9c6d3a21dde7$var$_toPrimitive(input, hint) {
    if ($5ddd9c6d3a21dde7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5ddd9c6d3a21dde7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5ddd9c6d3a21dde7$var$_toPropertyKey(arg) {
    var key = $5ddd9c6d3a21dde7$var$_toPrimitive(arg, "string");
    return $5ddd9c6d3a21dde7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5ddd9c6d3a21dde7$var$_defineProperty(obj, key, value) {
    key = $5ddd9c6d3a21dde7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5ddd9c6d3a21dde7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5ddd9c6d3a21dde7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5ddd9c6d3a21dde7$var$_arrayLikeToArray(arr);
}
function $5ddd9c6d3a21dde7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $5ddd9c6d3a21dde7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5ddd9c6d3a21dde7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5ddd9c6d3a21dde7$var$_arrayLikeToArray(o, minLen);
}
function $5ddd9c6d3a21dde7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5ddd9c6d3a21dde7$var$_toConsumableArray(arr) {
    return $5ddd9c6d3a21dde7$var$_arrayWithoutHoles(arr) || $5ddd9c6d3a21dde7$var$_iterableToArray(arr) || $5ddd9c6d3a21dde7$var$_unsupportedIterableToArray(arr) || $5ddd9c6d3a21dde7$var$_nonIterableSpread();
}
function $5ddd9c6d3a21dde7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $5ddd9c6d3a21dde7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $5ddd9c6d3a21dde7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5ddd9c6d3a21dde7$var$_slicedToArray(arr, i) {
    return $5ddd9c6d3a21dde7$var$_arrayWithHoles(arr) || $5ddd9c6d3a21dde7$var$_iterableToArrayLimit(arr, i) || $5ddd9c6d3a21dde7$var$_unsupportedIterableToArray(arr, i) || $5ddd9c6d3a21dde7$var$_nonIterableRest();
}
var $5ddd9c6d3a21dde7$var$classes = {
    handle: function handle(_ref) {
        var index = _ref.index, handleIndex = _ref.handleIndex;
        return (0, $cfkGk.classNames)("p-slider-handle", {
            "p-slider-handle-start": index === 0,
            "p-slider-handle-end": index === 1,
            "p-slider-handle-active": handleIndex.current === index
        });
    },
    range: "p-slider-range",
    root: function root(_ref2) {
        var props = _ref2.props, vertical = _ref2.vertical, horizontal = _ref2.horizontal;
        return (0, $cfkGk.classNames)("p-slider p-component", {
            "p-disabled": props.disabled,
            "p-slider-horizontal": horizontal,
            "p-slider-vertical": vertical
        });
    }
};
var $5ddd9c6d3a21dde7$var$styles = "\n@layer primereact {\n    .p-slider {\n        position: relative;\n    }\n    \n    .p-slider .p-slider-handle {\n        position: absolute;\n        cursor: grab;\n        touch-action: none;\n        display: block;\n        z-index: 1;\n    }\n    \n    .p-slider .p-slider-handle.p-slider-handle-active {\n        z-index: 2;\n    }\n    \n    .p-slider-range {\n        position: absolute;\n        display: block;\n    }\n    \n    .p-slider-horizontal .p-slider-range {\n        top: 0;\n        left: 0;\n        height: 100%;\n    }\n    \n    .p-slider-horizontal .p-slider-handle {\n        top: 50%;\n    }\n    \n    .p-slider-vertical {\n        height: 100px;\n    }\n    \n    .p-slider-vertical .p-slider-handle {\n        left: 50%;\n    }\n    \n    .p-slider-vertical .p-slider-range {\n        bottom: 0;\n        left: 0;\n        width: 100%;\n    }\n}\n";
var $5ddd9c6d3a21dde7$var$inlineStyles = {
    handle: {
        position: "absolute"
    },
    range: {
        position: "absolute"
    }
};
var $5ddd9c6d3a21dde7$var$SliderBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Slider",
        id: null,
        value: null,
        min: 0,
        max: 100,
        orientation: "horizontal",
        step: null,
        range: false,
        style: null,
        className: null,
        disabled: false,
        tabIndex: 0,
        onChange: null,
        onSlideEnd: null,
        children: undefined
    },
    css: {
        classes: $5ddd9c6d3a21dde7$var$classes,
        styles: $5ddd9c6d3a21dde7$var$styles,
        inlineStyles: $5ddd9c6d3a21dde7$var$inlineStyles
    }
});
function $5ddd9c6d3a21dde7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5ddd9c6d3a21dde7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5ddd9c6d3a21dde7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5ddd9c6d3a21dde7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5ddd9c6d3a21dde7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5ddd9c6d3a21dde7$export$472062a354075cee = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $5ddd9c6d3a21dde7$var$SliderBase.getProps(inProps, context);
    var elementRef = $81g6h.useRef(null);
    var handleIndex = $81g6h.useRef(0);
    var sliderHandleClick = $81g6h.useRef(false);
    var dragging = $81g6h.useRef(false);
    var initX = $81g6h.useRef(0);
    var initY = $81g6h.useRef(0);
    var barWidth = $81g6h.useRef(0);
    var barHeight = $81g6h.useRef(0);
    var touchId = $81g6h.useRef();
    var value = props.range ? props.value || [
        props.min,
        props.max
    ] : props.value || props.min || 0;
    var horizontal = props.orientation === "horizontal";
    var vertical = props.orientation === "vertical";
    var _useEventListener = (0, $l2NC0.useEventListener)({
        type: "mousemove",
        listener: function listener(event) {
            return onDrag(event);
        }
    }), _useEventListener2 = $5ddd9c6d3a21dde7$var$_slicedToArray(_useEventListener, 2), bindDocumentMouseMoveListener = _useEventListener2[0], unbindDocumentMouseMoveListener = _useEventListener2[1];
    var _useEventListener3 = (0, $l2NC0.useEventListener)({
        type: "mouseup",
        listener: function listener(event) {
            return onDragEnd(event);
        }
    }), _useEventListener4 = $5ddd9c6d3a21dde7$var$_slicedToArray(_useEventListener3, 2), bindDocumentMouseUpListener = _useEventListener4[0], unbindDocumentMouseUpListener = _useEventListener4[1];
    var _useEventListener5 = (0, $l2NC0.useEventListener)({
        type: "touchmove",
        listener: function listener(event) {
            return onDrag(event);
        }
    }), _useEventListener6 = $5ddd9c6d3a21dde7$var$_slicedToArray(_useEventListener5, 2), bindDocumentTouchMoveListener = _useEventListener6[0], unbindDocumentTouchMoveListener = _useEventListener6[1];
    var _useEventListener7 = (0, $l2NC0.useEventListener)({
        type: "touchend",
        listener: function listener(event) {
            return onDragEnd(event);
        }
    }), _useEventListener8 = $5ddd9c6d3a21dde7$var$_slicedToArray(_useEventListener7, 2), bindDocumentTouchEndListener = _useEventListener8[0], unbindDocumentTouchEndListener = _useEventListener8[1];
    var _SliderBase$setMetaDa = $5ddd9c6d3a21dde7$var$SliderBase.setMetaData({
        props: props
    }), ptm = _SliderBase$setMetaDa.ptm, cx = _SliderBase$setMetaDa.cx, sx = _SliderBase$setMetaDa.sx, isUnstyled = _SliderBase$setMetaDa.isUnstyled;
    (0, $4gQLd.useHandleStyle)($5ddd9c6d3a21dde7$var$SliderBase.css.styles, isUnstyled, {
        name: "slider"
    });
    var spin = function spin(event, dir) {
        var val = props.range ? value[handleIndex.current] : value;
        var step = (props.step || 1) * dir;
        updateValue(event, val + step);
        event.preventDefault();
    };
    var onDragStart = function onDragStart(event, index) {
        if (props.disabled) return;
        dragging.current = true;
        updateDomData();
        sliderHandleClick.current = true;
        if (props.range && value[0] === props.max) handleIndex.current = 0;
        else handleIndex.current = index;
        event.preventDefault();
    };
    var onDrag = function onDrag(event) {
        if (dragging.current) {
            setValue(event);
            event.preventDefault();
        }
    };
    var onDragEnd = function onDragEnd(event) {
        if (dragging.current) {
            dragging.current = false;
            var newValue = setValue(event);
            props.onSlideEnd && props.onSlideEnd({
                originalEvent: event,
                value: newValue
            });
            touchId.current = undefined;
            unbindDocumentMouseMoveListener();
            unbindDocumentMouseUpListener();
            unbindDocumentTouchMoveListener();
            unbindDocumentTouchEndListener();
        }
    };
    var _onMouseDown = function onMouseDown(event, index) {
        bindDocumentMouseMoveListener();
        bindDocumentMouseUpListener();
        onDragStart(event, index);
    };
    var _onTouchStart = function onTouchStart(event, index) {
        if (event.changedTouches && event.changedTouches[0]) touchId.current = event.changedTouches[0].identifier;
        bindDocumentTouchMoveListener();
        bindDocumentTouchEndListener();
        onDragStart(event, index);
    };
    var _onKeyDown = function onKeyDown(event, index) {
        if (props.disabled) return;
        handleIndex.current = index;
        var key = event.key;
        switch(key){
            case "ArrowRight":
            case "ArrowUp":
                spin(event, 1);
                break;
            case "ArrowLeft":
            case "ArrowDown":
                spin(event, -1);
                break;
            case "PageUp":
                spin(event, 10);
                event.preventDefault();
                break;
            case "PageDown":
                spin(event, -10);
                event.preventDefault();
                break;
            case "Home":
                spin(event, -value);
                event.preventDefault();
                break;
            case "End":
                spin(event, props.max);
                event.preventDefault();
                break;
        }
    };
    var onBarClick = function onBarClick(event) {
        if (props.disabled) return;
        if (!sliderHandleClick.current) {
            updateDomData();
            var _value = setValue(event);
            props.onSlideEnd && props.onSlideEnd({
                originalEvent: event,
                value: _value
            });
        }
        sliderHandleClick.current = false;
    };
    var updateDomData = function updateDomData() {
        var rect = elementRef.current.getBoundingClientRect();
        initX.current = rect.left + (0, $cfkGk.DomHandler).getWindowScrollLeft();
        initY.current = rect.top + (0, $cfkGk.DomHandler).getWindowScrollTop();
        barWidth.current = elementRef.current.offsetWidth;
        barHeight.current = elementRef.current.offsetHeight;
    };
    var trackTouch = function trackTouch(event) {
        var _event$changedTouches;
        var _event = Array.from((_event$changedTouches = event.changedTouches) !== null && _event$changedTouches !== void 0 ? _event$changedTouches : []).find(function(t) {
            return t.identifier === touchId.current;
        }) || event;
        return {
            pageX: _event.pageX,
            pageY: _event.pageY
        };
    };
    var setValue = function setValue(event) {
        var handleValue;
        var _trackTouch = trackTouch(event), pageX = _trackTouch.pageX, pageY = _trackTouch.pageY;
        if (!pageX || !pageY) return;
        if (horizontal) handleValue = (pageX - initX.current) * 100 / barWidth.current;
        else handleValue = (initY.current + barHeight.current - pageY) * 100 / barHeight.current;
        var newValue = (props.max - props.min) * (handleValue / 100) + props.min;
        if (props.step) {
            var oldValue = props.range ? value[handleIndex.current] : value;
            var diff = newValue - oldValue;
            if (diff < 0) newValue = oldValue + Math.ceil(newValue / props.step - oldValue / props.step) * props.step;
            else if (diff > 0) newValue = oldValue + Math.floor(newValue / props.step - oldValue / props.step) * props.step;
        } else newValue = Math.floor(newValue);
        return updateValue(event, newValue);
    };
    var updateValue = function updateValue(event, val) {
        var parsedValue = parseFloat(val.toFixed(10));
        var newValue = parsedValue;
        if (props.range) {
            if (handleIndex.current === 0) {
                if (parsedValue < props.min) parsedValue = props.min;
                else if (parsedValue > props.max) parsedValue = props.max;
            } else if (parsedValue > props.max) parsedValue = props.max;
            else if (parsedValue < props.min) parsedValue = props.min;
            newValue = $5ddd9c6d3a21dde7$var$_toConsumableArray(value);
            newValue[handleIndex.current] = parsedValue;
            if (props.onChange) props.onChange({
                originalEvent: event,
                value: newValue
            });
        } else {
            if (parsedValue < props.min) parsedValue = props.min;
            else if (parsedValue > props.max) parsedValue = props.max;
            newValue = parsedValue;
            if (props.onChange) props.onChange({
                originalEvent: event,
                value: newValue
            });
        }
        return newValue;
    };
    var createHandle = function createHandle(leftValue, bottomValue, index) {
        leftValue = (0, $cfkGk.ObjectUtils).isEmpty(leftValue) ? null : leftValue;
        bottomValue = (0, $cfkGk.ObjectUtils).isEmpty(bottomValue) ? null : bottomValue;
        var style = {
            transition: dragging.current ? "none" : null,
            left: leftValue != null ? leftValue + "%" : null,
            bottom: bottomValue != null ? bottomValue + "%" : null
        };
        var handleProps = mergeProps($5ddd9c6d3a21dde7$var$_objectSpread({
            className: cx("handle", {
                index: index,
                handleIndex: handleIndex
            }),
            style: $5ddd9c6d3a21dde7$var$_objectSpread($5ddd9c6d3a21dde7$var$_objectSpread({}, sx("handle", {
                dragging: dragging,
                leftValue: leftValue,
                bottomValue: bottomValue
            })), style),
            tabIndex: props.tabIndex,
            role: "slider",
            onMouseDown: function onMouseDown(event) {
                return _onMouseDown(event, index);
            },
            onTouchStart: function onTouchStart(event) {
                return _onTouchStart(event, index);
            },
            onKeyDown: function onKeyDown(event) {
                return _onKeyDown(event, index);
            },
            "aria-valuemin": props.min,
            "aria-valuemax": props.max,
            "aria-valuenow": leftValue || bottomValue || 0,
            "aria-orientation": props.orientation
        }, ariaProps), ptm("handle"));
        return /*#__PURE__*/ $81g6h.createElement("span", handleProps);
    };
    var createRangeSlider = function createRangeSlider() {
        var handleValueStart = (value[0] < props.min ? props.min : value[0] - props.min) * 100 / (props.max - props.min);
        var handleValueEnd = (value[1] > props.max ? props.max : value[1] - props.min) * 100 / (props.max - props.min);
        var rangeStartHandle = horizontal ? createHandle(handleValueStart, null, 0) : createHandle(null, handleValueStart, 0);
        var rangeEndHandle = horizontal ? createHandle(handleValueEnd, null, 1) : createHandle(null, handleValueEnd, 1);
        var rangeSliderWidth = handleValueEnd > handleValueStart ? handleValueEnd - handleValueStart : handleValueStart - handleValueEnd;
        var rangeSliderPosition = handleValueEnd > handleValueStart ? handleValueStart : handleValueEnd;
        var rangeStyle = horizontal ? {
            left: rangeSliderPosition + "%",
            width: rangeSliderWidth + "%"
        } : {
            bottom: rangeSliderPosition + "%",
            height: rangeSliderWidth + "%"
        };
        var rangeProps = mergeProps({
            className: cx("range"),
            style: $5ddd9c6d3a21dde7$var$_objectSpread($5ddd9c6d3a21dde7$var$_objectSpread({}, sx("range")), rangeStyle)
        }, ptm("range"));
        return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("span", rangeProps), rangeStartHandle, rangeEndHandle);
    };
    var createSingleSlider = function createSingleSlider() {
        var handleValue;
        if (value < props.min) handleValue = props.min;
        else if (value > props.max) handleValue = props.max;
        else handleValue = (value - props.min) * 100 / (props.max - props.min);
        var rangeStyle = horizontal ? {
            width: handleValue + "%"
        } : {
            height: handleValue + "%"
        };
        var handle = horizontal ? createHandle(handleValue, null, null) : createHandle(null, handleValue, null);
        var rangeProps = mergeProps({
            className: cx("range"),
            style: $5ddd9c6d3a21dde7$var$_objectSpread($5ddd9c6d3a21dde7$var$_objectSpread({}, sx("range")), rangeStyle)
        }, ptm("range"));
        return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("span", rangeProps), handle);
    };
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var otherProps = $5ddd9c6d3a21dde7$var$SliderBase.getOtherProps(props);
    var ariaProps = (0, $cfkGk.ObjectUtils).reduceKeys(otherProps, (0, $cfkGk.DomHandler).ARIA_PROPS);
    var content = props.range ? createRangeSlider() : createSingleSlider();
    var rootProps = mergeProps({
        style: props.style,
        className: (0, $cfkGk.classNames)(props.className, cx("root", {
            vertical: vertical,
            horizontal: horizontal
        })),
        onClick: onBarClick
    }, $5ddd9c6d3a21dde7$var$SliderBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $81g6h.createElement("div", $5ddd9c6d3a21dde7$var$_extends({
        id: props.id,
        ref: elementRef
    }, rootProps), content);
}));
$5ddd9c6d3a21dde7$export$472062a354075cee.displayName = "Slider";

});


parcelRegister("a5hkt", function(module, exports) {

$parcel$export(module.exports, "ButtonIcon", () => $83f5afede1b69987$export$e1c22a2ee2645e36);

var $iKObn = parcelRequire("iKObn");

var $kkH7g = parcelRequire("kkH7g");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");

var $9AWgp = parcelRequire("9AWgp");
parcelRequire("81g6h");
const $83f5afede1b69987$export$e1c22a2ee2645e36 = ({ icon: Icon, size: size = "default", onClick: onClick, disabled: disabled, testId: testId })=>/*#__PURE__*/ (0, $iKObn.jsx)($83f5afede1b69987$var$StyledButton, {
        className: "p-button-rounded p-button-text p-button-icon-only",
        onClick: onClick,
        disabled: disabled,
        condensed: size === "condensed",
        "data-test": testId,
        children: /*#__PURE__*/ (0, $iKObn.jsx)(Icon, {
            width: 24,
            height: 24,
            color: disabled ? (0, $kKnoQ.colors).grey50 : (0, $kKnoQ.colors).black
        })
    });
const $83f5afede1b69987$var$StyledButton = (0, $5UMQ1.default)((0, $9AWgp.Button))`
	&.p-button:disabled:not(.p-button-loading) {
		background-color: unset;
	}

	${({ condensed: condensed })=>condensed ? (0, $kkH7g.css)`
					width: 32px !important;
					height: 32px !important;
				` : ""}
`;

});

parcelRegister("fLclJ", function(module, exports) {

$parcel$export(module.exports, "ExerciseCommentTab", () => $3405ddd7ea304a44$export$5dd393e084a5933c);

var $iKObn = parcelRequire("iKObn");

var $he9Ds = parcelRequire("he9Ds");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $bl9tw = parcelRequire("bl9tw");

var $lTdpc = parcelRequire("lTdpc");

var $cD3aa = parcelRequire("cD3aa");

var $1sbGw = parcelRequire("1sbGw");

var $81g6h = parcelRequire("81g6h");
const $3405ddd7ea304a44$export$5dd393e084a5933c = (props)=>{
    const { exercise: exercise, editable: editable = true, editorName: editorName } = props;
    const { format: format, formatDateFull: formatDateFull } = (0, $1eHG3.useI18n)();
    const [value, setValue] = (0, $81g6h.useState)((0, $lTdpc.isNotNil)(exercise.comment) ? exercise.comment.text : "");
    const availableTextSize = (0, $81g6h.useMemo)(()=>(0, $he9Ds.APP_CONSTANTS).EXERCISE_MAX_COMMENT_LENGTH - value.length, [
        value.length
    ]);
    const formattedCommentLastUpdateDate = (0, $81g6h.useMemo)(()=>{
        if ((0, $lTdpc.isNotNil)(exercise.comment)) return format("exerciseDetailsModal.lastCommentUpdate", {
            date: `${formatDateFull((0, (/*@__PURE__*/$parcel$interopDefault($cD3aa)))(exercise.comment.lastUpdateDate))} - ${(0, (/*@__PURE__*/$parcel$interopDefault($cD3aa)))(exercise.comment.lastUpdateDate).format("HH:mm")}`,
            name: exercise.comment.lastEditorName
        });
    }, [
        exercise.comment,
        format,
        formatDateFull
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($3405ddd7ea304a44$var$Content, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $1sbGw.InputTextarea), {
                rows: 5,
                value: value,
                readOnly: !editable,
                placeholder: format("exerciseDetailsModal.comment.placeholder"),
                onChange: (e)=>{
                    setValue(e.target.value);
                    if (e.target.value.length === 0) exercise.comment = undefined;
                    else exercise.comment = {
                        text: e.target.value,
                        lastUpdateDate: new Date(),
                        lastEditorName: editorName
                    };
                },
                maxLength: (0, $he9Ds.APP_CONSTANTS).EXERCISE_MAX_COMMENT_LENGTH,
                autoResize: true
            }),
            editable && /*#__PURE__*/ (0, $iKObn.jsxs)($3405ddd7ea304a44$var$InfoComment, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($3405ddd7ea304a44$var$InfoText, {
                        children: format("global.dialog.textInput.maxLength", {
                            maxLength: (0, $he9Ds.APP_CONSTANTS).EXERCISE_MAX_COMMENT_LENGTH
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($3405ddd7ea304a44$var$InfoText, {
                        style: {
                            color: availableTextSize == 0 ? (0, $kKnoQ.colors).rejection : (0, $kKnoQ.colors).black
                        },
                        children: availableTextSize
                    })
                ]
            }),
            (0, $lTdpc.isNotNil)(exercise.comment) && /*#__PURE__*/ (0, $iKObn.jsx)($3405ddd7ea304a44$var$LastCommentUpdate, {
                children: formattedCommentLastUpdateDate
            })
        ]
    });
};
const $3405ddd7ea304a44$var$Content = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(8, "flexstart", "stretch")};
`;
const $3405ddd7ea304a44$var$InfoComment = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "flexend")}
	flex-wrap: wrap;
`;
const $3405ddd7ea304a44$var$InfoText = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).black};
	margin: 8px;
	font-size: 12px;
	font-weight: 600;
	font-family: ${(0, $bl9tw.fonts).body};
`;
const $3405ddd7ea304a44$var$LastCommentUpdate = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).primary};
	font-size: 16px;
	font-weight: 400;
	font-family: ${(0, $bl9tw.fonts).body};
`;

});

parcelRegister("f35Zw", function(module, exports) {

$parcel$export(module.exports, "ExerciseDescriptionTab", () => $197b645323cb5a70$export$2c6ec590c8835785);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $hLaGu = parcelRequire("hLaGu");

var $kVPyX = parcelRequire("kVPyX");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $bl9tw = parcelRequire("bl9tw");
parcelRequire("81g6h");

var $gMGcG = parcelRequire("gMGcG");

var $3iLEr = parcelRequire("3iLEr");

var $imaOW = parcelRequire("imaOW");
var $197b645323cb5a70$var$DiversityIcon = function DiversityIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.106 13.553a1 1 0 0 1 1.789 0l3 6A1 1 0 0 1 10 21H4a1 1 0 0 1-.894-1.447l3-6ZM5.618 19h2.764L7 16.236 5.618 19ZM15 11a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4Zm1.528 1.734a1 1 0 0 0-.616.19l-3.295 2.394a1 1 0 0 0-.363 1.118l1.26 3.873a1 1 0 0 0 .951.691h4.07a1 1 0 0 0 .952-.691l1.26-3.873a1 1 0 0 0-.364-1.118l-3.295-2.394a1 1 0 0 0-.56-.19ZM16.5 14.97l-2.119 1.54.81 2.491h2.618l.81-2.491-2.119-1.54ZM15 5v4h4V5h-4ZM7 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0-2a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z",
            fill: "currentColor"
        })
    });
};
$197b645323cb5a70$var$DiversityIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $197b645323cb5a70$var$DumbbellIcon = function DumbbellIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("g", {
                clipPath: "url(#clip0_206_244)",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M5.984 4.986A1 1 0 0 0 5 6v5.832a1 1 0 0 0 0 .326V18a1 1 0 1 0 2 0v-5h10v5a1 1 0 1 0 2 0v-5.832a1.003 1.003 0 0 0 0-.326V6a1 1 0 1 0-2 0v5H7V6a1 1 0 0 0-1.016-1.014Zm-3 2A1 1 0 0 0 2 8v3H1a1 1 0 1 0 0 2h1v3a1 1 0 1 0 2 0v-3.832a1 1 0 0 0 0-.326V8a1 1 0 0 0-1.016-1.014Zm18 0A1 1 0 0 0 20 8v3.832a.997.997 0 0 0 0 .326V16a1 1 0 1 0 2 0v-3h1a1 1 0 1 0 0-2h-1V8a1 1 0 0 0-1.016-1.014Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_206_244",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
};
$197b645323cb5a70$var$DumbbellIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $197b645323cb5a70$var$FinishFlagIcon = function FinishFlagIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M5 2a1 1 0 0 0-1 1v18a1 1 0 1 0 2 0v-6h12c1.102 0 2-.898 2-2V4c0-1.102-.898-2-2-2H5Zm4 2h3v3h3V4h3v3h-3v3h3v3h-3v-3h-3v3H9v-3H6V7h3V4Zm0 3v3h3V7H9Z",
            fill: "currentColor"
        })
    });
};
$197b645323cb5a70$var$FinishFlagIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $197b645323cb5a70$var$HelpIcon = function HelpIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M14 20H2c-1.1 0-2-.9-2-2v-1.5C0 13.6 4.73 12 8 12c-1.07 0-2.07-.42-2.83-1.17A4.004 4.004 0 0 1 4 8c0-1.05.43-2.08 1.17-2.83a4.011 4.011 0 0 1 5.66 0C11.58 5.92 12 6.93 12 8s-.43 2.08-1.17 2.83C10.09 11.57 9.06 12 8 12c3.27 0 8 1.6 8 4.5V18c0 1.1-.9 2-2 2Zm-6-6c-2.98 0-6 1.45-6 2.5V18h12v-1.5c0-1.05-3.02-2.5-6-2.5Zm0-8c-.53 0-1.04.21-1.41.58C6.22 6.95 6 7.47 6 8c0 .53.21 1.04.59 1.41.75.75 2.08.75 2.83 0 .37-.37.59-.89.59-1.42 0-.53-.21-1.04-.58-1.41-.37-.37-.89-.59-1.42-.59L8 6Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M16.6 4.41A3.586 3.586 0 0 0 13.02 8c0 .96.38 1.86 1.05 2.54a3.58 3.58 0 0 0 2.53 1.05c.95 0 1.86-.38 2.54-1.05.67-.67 1.05-1.58 1.05-2.54s-.38-1.86-1.05-2.54a3.586 3.586 0 0 0-2.54-1.05ZM17.476 13.13c-.34 0-.7.02-1.06.06 1.27.97 1.554 2.25 1.554 3.87v1.8c0 .56.45 1.01 1.01 1.01h3.39c.59 0 1.08-.5 1.08-1.12v-1.68c0-2.28-2.735-3.92-5.974-3.92v-.02Z",
                fill: "currentColor"
            })
        ]
    });
};
$197b645323cb5a70$var$HelpIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $197b645323cb5a70$var$SpeedometerIcon = function SpeedometerIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M20.67 22H17c-1.1 0-2-.9-2-2H9c0 1.1-.9 2-2 2H3.31c-.95 0-1.52-.62-1.72-1.03A12.015 12.015 0 0 1 0 15C0 8.38 5.38 3 12 3s12 5.38 12 12c0 2.11-.55 4.18-1.6 6-.11.17-.72 1-1.73 1ZM3.36 20.05s.02.03.02.05c0-.02-.02-.04-.02-.05ZM9 18h6c1.1 0 2 .9 2 2h3.66s.01-.03.04-.06c.85-1.5 1.3-3.21 1.3-4.94 0-5.51-4.49-10-10-10S2 9.49 2 15c0 1.76.46 3.48 1.33 5H7c0-1.1.9-2 2-2Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM16.84 7.41c.47.3.61.91.31 1.38-.3.47-.92.6-1.38.31a.995.995 0 1 1 1.07-1.68v-.01ZM7.09 7.45c.47-.3 1.09-.17 1.39.29.3.46.17 1.08-.3 1.38a1 1 0 0 1-1.38-.29 1 1 0 0 1 .29-1.38ZM4.14 10.61c.27-.48.88-.65 1.37-.39a1 1 0 0 1 .38 1.36c-.27.48-.88.65-1.36.39-.48-.27-.65-.88-.39-1.36ZM4 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM13.32 16.49c-.46.41-1.1.62-1.8.45a1.993 1.993 0 0 1-.01-3.87h-.01l.06-.02c.01 0 4.47-1.5 6.53-2.03.46-.12.77.44.44.78l-5.21 4.7v-.01ZM20 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                fill: "currentColor"
            })
        ]
    });
};
$197b645323cb5a70$var$SpeedometerIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $197b645323cb5a70$export$2c6ec590c8835785 = (props)=>{
    const { exercise: exercise } = props;
    const { format: format } = (0, $1eHG3.useI18n)();
    const { formatExerciseCategory: formatExerciseCategory, formatEquipements: formatEquipements, formatExerciseDifficulty: formatExerciseDifficulty, formatExerciseStartingPosition: formatExerciseStartingPosition, formatExerciseCaregiverAssistance: formatExerciseCaregiverAssistance } = (0, $kVPyX.useExerciseFormatter)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($197b645323cb5a70$var$Content, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($197b645323cb5a70$var$Section, {
                children: exercise.patientWarning === (0, $hLaGu.ExercisePatientWarning).AtaxiaWarning && /*#__PURE__*/ (0, $iKObn.jsx)((0, $imaOW.AlertCard), {
                    cardType: (0, $imaOW.CardType).Warning,
                    message: format("exerciseDetailsModal.ataxiaWarning")
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($197b645323cb5a70$var$Section, {
                children: exercise.description ? /*#__PURE__*/ (0, $iKObn.jsx)($197b645323cb5a70$var$MarkdownWrapper, {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $gMGcG.ReactMarkdown), {
                        remarkPlugins: [
                            (0, $3iLEr.default)
                        ],
                        children: exercise.description
                    })
                }) : /*#__PURE__*/ (0, $iKObn.jsx)($197b645323cb5a70$var$SectionContent, {
                    children: format("exerciseDetailsModal.emptySection")
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($197b645323cb5a70$var$Grid, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($197b645323cb5a70$var$Section, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)($197b645323cb5a70$var$TopSection, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($197b645323cb5a70$var$DiversityIcon, {
                                        width: 24,
                                        height: 24,
                                        color: (0, $kKnoQ.colors).grey
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                        className: "p-size-s-bold",
                                        children: format("exercise.category.title")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($197b645323cb5a70$var$SectionContent, {
                                children: formatExerciseCategory(exercise.category)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($197b645323cb5a70$var$Section, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)($197b645323cb5a70$var$TopSection, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($197b645323cb5a70$var$DumbbellIcon, {
                                        width: 24,
                                        height: 24,
                                        color: (0, $kKnoQ.colors).grey
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                        className: "p-size-s-bold",
                                        children: format("exerciseDetailsModal.mandatoryEquipment.title")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($197b645323cb5a70$var$SectionContent, {
                                children: formatEquipements(exercise.requiredEquipments)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($197b645323cb5a70$var$Section, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)($197b645323cb5a70$var$TopSection, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($197b645323cb5a70$var$DumbbellIcon, {
                                        width: 24,
                                        height: 24,
                                        color: (0, $kKnoQ.colors).grey
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                        className: "p-size-s-bold",
                                        children: format("exerciseDetailsModal.optionalEquipment.title")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($197b645323cb5a70$var$SectionContent, {
                                children: formatEquipements(exercise.optionalEquipments)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($197b645323cb5a70$var$Section, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)($197b645323cb5a70$var$TopSection, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($197b645323cb5a70$var$FinishFlagIcon, {
                                        width: 24,
                                        height: 24,
                                        color: (0, $kKnoQ.colors).grey
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                        className: "p-size-s-bold",
                                        children: format("exercise.startingPosition.title")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($197b645323cb5a70$var$SectionContent, {
                                children: formatExerciseStartingPosition(exercise.startingPosition)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($197b645323cb5a70$var$Section, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)($197b645323cb5a70$var$TopSection, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($197b645323cb5a70$var$HelpIcon, {
                                        width: 24,
                                        height: 24,
                                        color: (0, $kKnoQ.colors).grey
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                        className: "p-size-s-bold",
                                        children: format("exercise.caregiverAssistance.title")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($197b645323cb5a70$var$SectionContent, {
                                children: formatExerciseCaregiverAssistance(exercise.helpNeeded)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($197b645323cb5a70$var$Section, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)($197b645323cb5a70$var$TopSection, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($197b645323cb5a70$var$SpeedometerIcon, {
                                        width: 24,
                                        height: 24,
                                        color: (0, $kKnoQ.colors).grey
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                        className: "p-size-s-bold",
                                        children: format("exercise.difficulty.title")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($197b645323cb5a70$var$SectionContent, {
                                children: formatExerciseDifficulty(exercise.difficulty)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $197b645323cb5a70$var$Content = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(8, "flexstart", "stretch")};
`;
const $197b645323cb5a70$var$Section = (0, $5UMQ1.default).section`
	${(0, $5WGN2.stack)(undefined, "flexstart", "stretch")};
`;
const $197b645323cb5a70$var$TopSection = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8, "flexstart", "center")}
`;
const $197b645323cb5a70$var$SectionContent = (0, $5UMQ1.default).div`
	margin-left: 32px;
`;
const $197b645323cb5a70$var$MarkdownWrapper = (0, $5UMQ1.default).div`
	p {
		margin: 8px 0;
	}

	ol {
		margin: 8px 0;
		padding-left: 24px;
		li {
			margin: 0;
			padding: 0px 0 16px 8px;
			::marker {
				font-family: ${(0, $bl9tw.fonts).header};
				font-weight: 500;
			}
		}
	}
`;
const $197b645323cb5a70$var$Grid = (0, $5UMQ1.default).div`
	padding: 16px;
	border-radius: 8px;
	background-color: ${(0, $kKnoQ.colors).primaryBackground};

	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 16px;
`;

});
parcelRegister("gMGcG", function(module, exports) {

$parcel$export(module.exports, "ReactMarkdown", () => $c381ddc56312be35$export$83ef7ab426386201);
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options | undefined} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */ 
var $81g6h = parcelRequire("81g6h");

var $7E8GO = parcelRequire("7E8GO");

var $lB1jM = parcelRequire("lB1jM");

var $hfxLB = parcelRequire("hfxLB");

var $bvZKa = parcelRequire("bvZKa");

var $gc7GP = parcelRequire("gc7GP");

var $4EguK = parcelRequire("4EguK");

var $do97g = parcelRequire("do97g");

var $6yHla = parcelRequire("6yHla");
const $c381ddc56312be35$var$own = {}.hasOwnProperty;
const $c381ddc56312be35$var$changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md";
/** @type {Record<string, Deprecation>} */ const $c381ddc56312be35$var$deprecated = {
    plugins: {
        to: "remarkPlugins",
        id: "change-plugins-to-remarkplugins"
    },
    renderers: {
        to: "components",
        id: "change-renderers-to-components"
    },
    astPlugins: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    allowDangerousHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    escapeHtml: {
        id: "remove-buggy-html-in-markdown-parser"
    },
    source: {
        to: "children",
        id: "change-source-to-children"
    },
    allowNode: {
        to: "allowElement",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    allowedTypes: {
        to: "allowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    disallowedTypes: {
        to: "disallowedElements",
        id: "replace-allownode-allowedtypes-and-disallowedtypes"
    },
    includeNodeIndex: {
        to: "includeElementIndex",
        id: "change-includenodeindex-to-includeelementindex"
    }
};
function $c381ddc56312be35$export$83ef7ab426386201(options) {
    for(const key in $c381ddc56312be35$var$deprecated)if ($c381ddc56312be35$var$own.call($c381ddc56312be35$var$deprecated, key) && $c381ddc56312be35$var$own.call(options, key)) {
        const deprecation = $c381ddc56312be35$var$deprecated[key];
        console.warn(`[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : "remove"} \`${key}\` (see <${$c381ddc56312be35$var$changelog}#${deprecation.id}> for more info)`);
        delete $c381ddc56312be35$var$deprecated[key];
    }
    const processor = (0, $lB1jM.unified)().use((0, $hfxLB.default)).use(options.remarkPlugins || []).use((0, $bvZKa.default), {
        ...options.remarkRehypeOptions,
        allowDangerousHtml: true
    }).use(options.rehypePlugins || []).use((0, $do97g.default), options);
    const file = new (0, $7E8GO.VFile)();
    if (typeof options.children === "string") file.value = options.children;
    else if (options.children !== undefined && options.children !== null) console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`);
    const hastNode = processor.runSync(processor.parse(file), file);
    if (hastNode.type !== "root") throw new TypeError("Expected a `root` node");
    /** @type {ReactElement} */ let result = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).Fragment, {}, (0, $6yHla.childrenToReact)({
        options: options,
        schema: (0, $4EguK.html),
        listDepth: 0
    }, hastNode));
    if (options.className) result = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("div", {
        className: options.className
    }, result);
    return result;
}
$c381ddc56312be35$export$83ef7ab426386201.propTypes = {
    // Core options:
    children: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).string,
    // Layout options:
    className: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).string,
    // Filter options:
    allowElement: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).func,
    allowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).string),
    disallowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).string),
    unwrapDisallowed: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).bool,
    // Plugin options:
    remarkPlugins: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).any)
        ]))
    ])),
    rehypePlugins: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).arrayOf(// prettier-ignore
            // type-coverage:ignore-next-line
            (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).any)
        ]))
    ])),
    // Transform options:
    sourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).bool,
    rawSourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).bool,
    skipHtml: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).bool,
    includeElementIndex: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).bool,
    transformLinkUri: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).bool
    ]),
    linkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).string
    ]),
    transformImageUri: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).func,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).object
};

});
parcelRegister("7E8GO", function(module, exports) {

$parcel$export(module.exports, "VFile", () => $5913025e709fc98e$export$93dff69eb10dc7ce);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {Record<string, unknown> & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {'ascii' | 'utf8' | 'utf-8' | 'utf16le' | 'ucs2' | 'ucs-2' | 'base64' | 'base64url' | 'latin1' | 'binary' | 'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *
 *   This is a copy of the types from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Options | URL | Value | VFile} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {Value | null | undefined} [value]
 *   Set `value`.
 * @property {string | null | undefined} [cwd]
 *   Set `cwd`.
 * @property {Array<string> | null | undefined} [history]
 *   Set `history`.
 * @property {URL | string | null | undefined} [path]
 *   Set `path`.
 * @property {string | null | undefined} [basename]
 *   Set `basename`.
 * @property {string | null | undefined} [stem]
 *   Set `stem`.
 * @property {string | null | undefined} [extname]
 *   Set `extname`.
 * @property {string | null | undefined} [dirname]
 *   Set `dirname`.
 * @property {Data | null | undefined} [data]
 *   Set `data`.
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template {ReporterSettings} Settings
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ 
var $cW1Vo = parcelRequire("cW1Vo");

var $5sHmM = parcelRequire("5sHmM");

var $dNdVl = parcelRequire("dNdVl");

var $kvJkd = parcelRequire("kvJkd");
parcelRequire("eg3VK");
var $55xOg = parcelRequire("55xOg");
var $eg3VK = parcelRequire("eg3VK");
/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 *
 * @type {Array<'basename' | 'dirname' | 'extname' | 'history' | 'path' | 'stem'>}
 */ const $5913025e709fc98e$var$order = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
class $5913025e709fc98e$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if (typeof value === "string" || $5913025e709fc98e$var$buffer(value)) options = {
            value: value
        };
        else if ((0, $55xOg.isUrl)(value)) options = {
            path: value
        };
        else options = value;
        /**
     * Place to store custom information (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * List of filepaths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $kvJkd.proc).cwd();
        /* eslint-disable no-unused-expressions */ /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $5913025e709fc98e$var$order.length){
            const prop = $5913025e709fc98e$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === "history" ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$5913025e709fc98e$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */ set path(path) {
        if ((0, $55xOg.isUrl)(path)) path = (0, $eg3VK.urlToPath)(path);
        $5913025e709fc98e$var$assertNonEmpty(path, "path");
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the parent path (example: `'~'`).
   */ get dirname() {
        return typeof this.path === "string" ? (0, $dNdVl.path).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */ set dirname(dirname) {
        $5913025e709fc98e$var$assertPath(this.basename, "dirname");
        this.path = (0, $dNdVl.path).join(dirname || "", this.basename);
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */ get basename() {
        return typeof this.path === "string" ? (0, $dNdVl.path).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set basename(basename) {
        $5913025e709fc98e$var$assertNonEmpty(basename, "basename");
        $5913025e709fc98e$var$assertPart(basename, "basename");
        this.path = (0, $dNdVl.path).join(this.dirname || "", basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   */ get extname() {
        return typeof this.path === "string" ? (0, $dNdVl.path).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */ set extname(extname) {
        $5913025e709fc98e$var$assertPart(extname, "extname");
        $5913025e709fc98e$var$assertPath(this.dirname, "extname");
        if (extname) {
            if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error("`extname` must start with `.`");
            if (extname.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
        }
        this.path = (0, $dNdVl.path).join(this.dirname, this.stem + (extname || ""));
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */ get stem() {
        return typeof this.path === "string" ? (0, $dNdVl.path).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set stem(stem) {
        $5913025e709fc98e$var$assertNonEmpty(stem, "stem");
        $5913025e709fc98e$var$assertPart(stem, "stem");
        this.path = (0, $dNdVl.path).join(this.dirname || "", stem + (this.extname || ""));
    }
    /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        return (this.value || "").toString(encoding || undefined);
    }
    /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(reason, place, origin) {
        const message = new (0, $5sHmM.VFileMessage)(reason, place, origin);
        if (this.path) {
            message.name = this.path + ":" + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = null;
        return message;
    }
    /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */ fail(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = true;
        throw message;
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {void}
 *   Nothing.
 */ function $5913025e709fc98e$var$assertPart(part, name) {
    if (part && part.includes((0, $dNdVl.path).sep)) throw new Error("`" + name + "` cannot be a path: did not expect `" + (0, $dNdVl.path).sep + "`");
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $5913025e709fc98e$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $5913025e709fc98e$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}
/**
 * Assert `value` is a buffer.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Buffer}
 *   Whether `value` is a Node.js buffer.
 */ function $5913025e709fc98e$var$buffer(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cW1Vo)))(value);
}

});
parcelRegister("cW1Vo", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};

});

parcelRegister("5sHmM", function(module, exports) {

$parcel$export(module.exports, "VFileMessage", () => $3fa134f68614c47c$export$752e5c445fe834ef);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ 
var $ch1PA = parcelRequire("ch1PA");
class $3fa134f68614c47c$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // To do: next major: expose `undefined` everywhere instead of `null`.
    constructor(reason, place, origin){
        /** @type {[string | null, string | null]} */ const parts = [
            null,
            null
        ];
        /** @type {Position} */ let position = {
            // @ts-expect-error: we always follows the structure of `position`.
            start: {
                line: null,
                column: null
            },
            // @ts-expect-error: "
            end: {
                line: null,
                column: null
            }
        };
        super();
        if (typeof place === "string") {
            origin = place;
            place = undefined;
        }
        if (typeof origin === "string") {
            const index = origin.indexOf(":");
            if (index === -1) parts[1] = origin;
            else {
                parts[0] = origin.slice(0, index);
                parts[1] = origin.slice(index + 1);
            }
        }
        if (place) {
            // Node.
            if ("type" in place || "position" in place) {
                if (place.position) // To do: next major: deep clone.
                // @ts-expect-error: looks like a position.
                position = place.position;
            } else if ("start" in place || "end" in place) // @ts-expect-error: looks like a position.
            // To do: next major: deep clone.
            position = place;
            else if ("line" in place || "column" in place) // To do: next major: deep clone.
            position.start = place;
        }
        // Fields from `Error`.
        /**
     * Serialized positional info of error.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $ch1PA.stringifyPosition)(place) || "1:1";
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = typeof reason === "object" ? reason.message : reason;
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = "";
        if (typeof reason === "object" && reason.stack) this.stack = reason.stack;
        /**
     * Reason for message.
     *
     * > 👉 **Note**: you should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /* eslint-disable no-unused-expressions */ /**
     * State of problem.
     *
     * * `true` — marks associated file as no longer processable (error)
     * * `false` — necessitates a (potential) change (warning)
     * * `null | undefined` — for things that might not need changing (info)
     *
     * @type {boolean | null | undefined}
     */ this.fatal;
        /**
     * Starting line of error.
     *
     * @type {number | null}
     */ this.line = position.start.line;
        /**
     * Starting column of error.
     *
     * @type {number | null}
     */ this.column = position.start.column;
        /**
     * Full unist position.
     *
     * @type {Position | null}
     */ this.position = position;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | null}
     */ this.source = parts[0];
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | null}
     */ this.ruleId = parts[1];
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | null}
     */ this.file;
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | null}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | null}
     */ this.expected;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | null}
     */ this.url;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | null}
     */ this.note;
    /* eslint-enable no-unused-expressions */ }
}
$3fa134f68614c47c$export$752e5c445fe834ef.prototype.file = "";
$3fa134f68614c47c$export$752e5c445fe834ef.prototype.name = "";
$3fa134f68614c47c$export$752e5c445fe834ef.prototype.reason = "";
$3fa134f68614c47c$export$752e5c445fe834ef.prototype.message = "";
$3fa134f68614c47c$export$752e5c445fe834ef.prototype.stack = "";
$3fa134f68614c47c$export$752e5c445fe834ef.prototype.fatal = null;
$3fa134f68614c47c$export$752e5c445fe834ef.prototype.column = null;
$3fa134f68614c47c$export$752e5c445fe834ef.prototype.line = null;
$3fa134f68614c47c$export$752e5c445fe834ef.prototype.source = null;
$3fa134f68614c47c$export$752e5c445fe834ef.prototype.ruleId = null;
$3fa134f68614c47c$export$752e5c445fe834ef.prototype.position = null;

});
parcelRegister("ch1PA", function(module, exports) {

$parcel$export(module.exports, "stringifyPosition", () => $024e549d908431be$export$c304dd45fe166145);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Position | PositionLike | Point | PointLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $024e549d908431be$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ("position" in value || "type" in value) return $024e549d908431be$var$position(value.position);
    // Position.
    if ("start" in value || "end" in value) return $024e549d908431be$var$position(value);
    // Point.
    if ("line" in value || "column" in value) return $024e549d908431be$var$point(value);
    // ?
    return "";
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $024e549d908431be$var$point(point) {
    return $024e549d908431be$var$index(point && point.line) + ":" + $024e549d908431be$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $024e549d908431be$var$position(pos) {
    return $024e549d908431be$var$point(pos && pos.start) + "-" + $024e549d908431be$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $024e549d908431be$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}

});


parcelRegister("dNdVl", function(module, exports) {

$parcel$export(module.exports, "path", () => $a0aaa6f1437b72ca$export$bb654e07daaf8c3a);
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $a0aaa6f1437b72ca$export$bb654e07daaf8c3a = {
    basename: $a0aaa6f1437b72ca$var$basename,
    dirname: $a0aaa6f1437b72ca$var$dirname,
    extname: $a0aaa6f1437b72ca$var$extname,
    join: $a0aaa6f1437b72ca$var$join,
    sep: "/"
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $a0aaa6f1437b72ca$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    $a0aaa6f1437b72ca$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? "" : path.slice(start, end);
    }
    if (ext === path) return "";
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $a0aaa6f1437b72ca$var$dirname(path) {
    $a0aaa6f1437b72ca$var$assertPath(path);
    if (path.length === 0) return ".";
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? "/" : "." : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? "//" : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $a0aaa6f1437b72ca$var$extname(path) {
    $a0aaa6f1437b72ca$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $a0aaa6f1437b72ca$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $a0aaa6f1437b72ca$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + "/" + segments[index];
    }
    return joined === undefined ? "." : $a0aaa6f1437b72ca$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $a0aaa6f1437b72ca$var$normalize(path) {
    $a0aaa6f1437b72ca$var$assertPath(path);
    const absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $a0aaa6f1437b72ca$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = ".";
    if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += "/";
    return absolute ? "/" + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $a0aaa6f1437b72ca$var$normalizeString(path, allowAboveRoot) {
    let result = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf("/");
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = "";
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = "";
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + "/.." : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += "/" + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $a0aaa6f1437b72ca$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 

});

parcelRegister("kvJkd", function(module, exports) {

$parcel$export(module.exports, "proc", () => $eee9dc8490507977$export$97a5aaf482767187);
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $eee9dc8490507977$export$97a5aaf482767187 = {
    cwd: $eee9dc8490507977$var$cwd
};
function $eee9dc8490507977$var$cwd() {
    return "/";
}

});

parcelRegister("eg3VK", function(module, exports) {

$parcel$export(module.exports, "urlToPath", () => $a6159bd57d6e314a$export$9b2b676c902de799);
$parcel$export(module.exports, "isUrl", () => (parcelRequire("55xOg")).isUrl);
/// <reference lib="dom" />

var $55xOg = parcelRequire("55xOg");
function $a6159bd57d6e314a$export$9b2b676c902de799(path) {
    if (typeof path === "string") path = new URL(path);
    else if (!(0, $55xOg.isUrl)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + "`");
        error.code = "ERR_INVALID_ARG_TYPE";
        throw error;
    }
    if (path.protocol !== "file:") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError("The URL must be of scheme file");
        error.code = "ERR_INVALID_URL_SCHEME";
        throw error;
    }
    return $a6159bd57d6e314a$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $a6159bd57d6e314a$var$getPathFromURLPosix(url) {
    if (url.hostname !== "") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = "ERR_INVALID_FILE_URL_HOST";
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.charCodeAt(index) === 37 /* `%` */  && pathname.charCodeAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.charCodeAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError("File URL path must not include encoded / characters");
            error.code = "ERR_INVALID_FILE_URL_PATH";
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}

});
parcelRegister("55xOg", function(module, exports) {

$parcel$export(module.exports, "isUrl", () => $3b47a5456ce2554b$export$8304a22d431f958);
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */ /**
 * Check if `fileUrlOrPath` looks like a URL.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function $3b47a5456ce2554b$export$8304a22d431f958(fileUrlOrPath) {
    return fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && // @ts-expect-error: indexable.
    fileUrlOrPath.href && // @ts-expect-error: indexable.
    fileUrlOrPath.origin;
}

});



parcelRegister("lB1jM", function(module, exports) {

$parcel$export(module.exports, "unified", () => $fb8e1364534ae5b6$export$7cc1b2fe10c52bb);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */ 
var $44XyP = parcelRequire("44XyP");

var $cW1Vo = parcelRequire("cW1Vo");

var $8trQ0 = parcelRequire("8trQ0");

var $cRY2J = parcelRequire("cRY2J");

var $6Jvpa = parcelRequire("6Jvpa");

var $7E8GO = parcelRequire("7E8GO");
const $fb8e1364534ae5b6$export$7cc1b2fe10c52bb = $fb8e1364534ae5b6$var$base().freeze();
const $fb8e1364534ae5b6$var$own = {}.hasOwnProperty;
// Function to create the first processor.
/**
 * @returns {Processor}
 */ function $fb8e1364534ae5b6$var$base() {
    const transformers = (0, $6Jvpa.trough)();
    /** @type {Processor['attachers']} */ const attachers = [];
    /** @type {Record<string, unknown>} */ let namespace = {};
    /** @type {boolean|undefined} */ let frozen;
    let freezeIndex = -1;
    // Data management.
    // @ts-expect-error: overloads are handled.
    processor.data = data;
    processor.Parser = undefined;
    processor.Compiler = undefined;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    // @ts-expect-error: overloads are handled.
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    // @ts-expect-error: overloads are handled.
    processor.run = run;
    processor.runSync = runSync;
    // @ts-expect-error: overloads are handled.
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    /** @type {Processor} */ function processor() {
        const destination = $fb8e1364534ae5b6$var$base();
        let index = -1;
        while(++index < attachers.length)destination.use(...attachers[index]);
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($8trQ0)))(true, {}, namespace));
        return destination;
    }
    /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */ function data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $fb8e1364534ae5b6$var$assertUnfrozen("data", frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $fb8e1364534ae5b6$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $fb8e1364534ae5b6$var$assertUnfrozen("data", frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    /** @type {Processor['freeze']} */ function freeze() {
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            const [attacher, ...options] = attachers[freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            /** @type {Transformer|void} */ const transformer = attacher.call(processor, ...options);
            if (typeof transformer === "function") transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Number.POSITIVE_INFINITY;
        return processor;
    }
    /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */ function use(value, ...options) {
        /** @type {Record<string, unknown>|undefined} */ let settings;
        $fb8e1364534ae5b6$var$assertUnfrozen("use", frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin(value, ...options);
        else if (typeof value === "object") {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError("Expected usable value, not `" + value + "`");
        if (settings) namespace.settings = Object.assign(namespace.settings || {}, settings);
        return processor;
        /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */ function add(value) {
            if (typeof value === "function") addPlugin(value);
            else if (typeof value === "object") {
                if (Array.isArray(value)) {
                    const [plugin, ...options] = value;
                    addPlugin(plugin, ...options);
                } else addPreset(value);
            } else throw new TypeError("Expected usable value, not `" + value + "`");
        }
        /**
     * @param {Preset} result
     * @returns {void}
     */ function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = Object.assign(settings || {}, result.settings);
        }
        /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
        }
        /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */ function addPlugin(plugin, value) {
            let index = -1;
            /** @type {Processor['attachers'][number]|undefined} */ let entry;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entry = attachers[index];
                break;
            }
            if (entry) {
                if ((0, $cRY2J.default)(entry[1]) && (0, $cRY2J.default)(value)) value = (0, (/*@__PURE__*/$parcel$interopDefault($8trQ0)))(true, entry[1], value);
                entry[1] = value;
            } else // @ts-expect-error: fine.
            attachers.push([
                ...arguments
            ]);
        }
    }
    /** @type {Processor['parse']} */ function parse(doc) {
        processor.freeze();
        const file = $fb8e1364534ae5b6$var$vfile(doc);
        const Parser = processor.Parser;
        $fb8e1364534ae5b6$var$assertParser("parse", Parser);
        if ($fb8e1364534ae5b6$var$newable(Parser, "parse")) // @ts-expect-error: `newable` checks this.
        return new Parser(String(file), file).parse();
        // @ts-expect-error: `newable` checks this.
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    /** @type {Processor['stringify']} */ function stringify(node, doc) {
        processor.freeze();
        const file = $fb8e1364534ae5b6$var$vfile(doc);
        const Compiler = processor.Compiler;
        $fb8e1364534ae5b6$var$assertCompiler("stringify", Compiler);
        $fb8e1364534ae5b6$var$assertNode(node);
        if ($fb8e1364534ae5b6$var$newable(Compiler, "compile")) // @ts-expect-error: `newable` checks this.
        return new Compiler(node, file).compile();
        // @ts-expect-error: `newable` checks this.
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */ function run(node, doc, callback) {
        $fb8e1364534ae5b6$var$assertNode(node);
        processor.freeze();
        if (!callback && typeof doc === "function") {
            callback = doc;
            doc = undefined;
        }
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
            transformers.run(node, $fb8e1364534ae5b6$var$vfile(doc), done);
            /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */ function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, tree, file);
            }
        }
    }
    /** @type {Processor['runSync']} */ function runSync(node, file) {
        /** @type {Node|undefined} */ let result;
        /** @type {boolean|undefined} */ let complete;
        processor.run(node, file, done);
        $fb8e1364534ae5b6$var$assertDone("runSync", "run", complete);
        // @ts-expect-error: we either bailed on an error or have a tree.
        return result;
        /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */ function done(error, tree) {
            (0, $44XyP.bail)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */ function process(doc, callback) {
        processor.freeze();
        $fb8e1364534ae5b6$var$assertParser("process", processor.Parser);
        $fb8e1364534ae5b6$var$assertCompiler("process", processor.Compiler);
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            const file = $fb8e1364534ae5b6$var$vfile(doc);
            processor.run(processor.parse(file), file, (error, tree, file)=>{
                if (error || !tree || !file) done(error);
                else {
                    /** @type {unknown} */ const result = processor.stringify(tree, file);
                    if (result === undefined || result === null) ;
                    else if ($fb8e1364534ae5b6$var$looksLikeAVFileValue(result)) file.value = result;
                    else file.result = result;
                    done(error, file);
                }
            });
            /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */ function done(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, file);
            }
        }
    }
    /** @type {Processor['processSync']} */ function processSync(doc) {
        /** @type {boolean|undefined} */ let complete;
        processor.freeze();
        $fb8e1364534ae5b6$var$assertParser("processSync", processor.Parser);
        $fb8e1364534ae5b6$var$assertCompiler("processSync", processor.Compiler);
        const file = $fb8e1364534ae5b6$var$vfile(doc);
        processor.process(file, done);
        $fb8e1364534ae5b6$var$assertDone("processSync", "process", complete);
        return file;
        /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */ function done(error) {
            complete = true;
            (0, $44XyP.bail)(error);
        }
    }
}
/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */ function $fb8e1364534ae5b6$var$newable(value, name) {
    return typeof value === "function" && // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    ($fb8e1364534ae5b6$var$keys(value.prototype) || name in value.prototype);
}
/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */ function $fb8e1364534ae5b6$var$keys(value) {
    /** @type {string} */ let key;
    for(key in value){
        if ($fb8e1364534ae5b6$var$own.call(value, key)) return true;
    }
    return false;
}
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $fb8e1364534ae5b6$var$assertParser(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Parser`");
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $fb8e1364534ae5b6$var$assertCompiler(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `Compiler`");
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $fb8e1364534ae5b6$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot call `" + name + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $fb8e1364534ae5b6$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $cRY2J.default)(node) || typeof node.type !== "string") throw new TypeError("Expected node, got `" + node + "`");
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $fb8e1364534ae5b6$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}
/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */ function $fb8e1364534ae5b6$var$vfile(value) {
    return $fb8e1364534ae5b6$var$looksLikeAVFile(value) ? value : new (0, $7E8GO.VFile)(value);
}
/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */ function $fb8e1364534ae5b6$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === "object" && "message" in value && "messages" in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */ function $fb8e1364534ae5b6$var$looksLikeAVFileValue(value) {
    return typeof value === "string" || (0, (/*@__PURE__*/$parcel$interopDefault($cW1Vo)))(value);
}

});
parcelRegister("44XyP", function(module, exports) {

$parcel$export(module.exports, "bail", () => $2f85bca67d84416e$export$dd911e13ecb11e05);
/**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $2f85bca67d84416e$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}

});

parcelRegister("8trQ0", function(module, exports) {
"use strict";
var $62b6a02e48ed14b1$var$hasOwn = Object.prototype.hasOwnProperty;
var $62b6a02e48ed14b1$var$toStr = Object.prototype.toString;
var $62b6a02e48ed14b1$var$defineProperty = Object.defineProperty;
var $62b6a02e48ed14b1$var$gOPD = Object.getOwnPropertyDescriptor;
var $62b6a02e48ed14b1$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $62b6a02e48ed14b1$var$toStr.call(arr) === "[object Array]";
};
var $62b6a02e48ed14b1$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $62b6a02e48ed14b1$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $62b6a02e48ed14b1$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $62b6a02e48ed14b1$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $62b6a02e48ed14b1$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $62b6a02e48ed14b1$var$setProperty = function setProperty(target, options) {
    if ($62b6a02e48ed14b1$var$defineProperty && options.name === "__proto__") $62b6a02e48ed14b1$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $62b6a02e48ed14b1$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$62b6a02e48ed14b1$var$hasOwn.call(obj, name)) return void 0;
        else if ($62b6a02e48ed14b1$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $62b6a02e48ed14b1$var$gOPD(obj, name).value;
    }
    return obj[name];
};
module.exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $62b6a02e48ed14b1$var$getProperty(target, name);
            copy = $62b6a02e48ed14b1$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($62b6a02e48ed14b1$var$isPlainObject(copy) || (copyIsArray = $62b6a02e48ed14b1$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $62b6a02e48ed14b1$var$isArray(src) ? src : [];
                    } else clone = src && $62b6a02e48ed14b1$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $62b6a02e48ed14b1$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $62b6a02e48ed14b1$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};

});

parcelRegister("cRY2J", function(module, exports) {

$parcel$export(module.exports, "default", () => $95e90297e8ef8658$export$2e2bcd8739ae039);
function $95e90297e8ef8658$export$2e2bcd8739ae039(value) {
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}

});

parcelRegister("6Jvpa", function(module, exports) {

$parcel$export(module.exports, "trough", () => $4e6f4e65c0b506ca$export$91b56f5ca106aa43);
// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.
/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */ function $4e6f4e65c0b506ca$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== "function") throw new TypeError("Expected function as last argument, not " + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $4e6f4e65c0b506ca$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== "function") throw new TypeError("Expected `middelware` to be a function, not " + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $4e6f4e65c0b506ca$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result && result.then && typeof result.then === "function") result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}

});


parcelRegister("hfxLB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ee07bd2678ed93$export$2e2bcd8739ae039);
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */ 
var $huD5m = parcelRequire("huD5m");
function $c8ee07bd2678ed93$export$2e2bcd8739ae039(options) {
    /** @type {import('unified').ParserFunction<Root>} */ const parser = (doc)=>{
        // Assume options.
        const settings = /** @type {Options} */ this.data("settings");
        return (0, $huD5m.fromMarkdown)(doc, Object.assign({}, settings, options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: this.data("micromarkExtensions") || [],
            mdastExtensions: this.data("fromMarkdownExtensions") || []
        }));
    };
    Object.assign(this, {
        Parser: parser
    });
}

});
parcelRegister("huD5m", function(module, exports) {

$parcel$export(module.exports, "fromMarkdown", () => $cbc38e8d137c7232$export$d744d789c09bfde6);
/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').StaticPhrasingContent} StaticPhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Root | Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 *
 * @typedef {Omit<UnistParent, 'type' | 'children'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | undefined | null | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Node | Fragment>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {<Key extends keyof CompileData>(key: Key) => CompileData[Key]} getData
 *   Get data from the key/value store.
 * @property {<Key extends keyof CompileData>(key: Key, value?: CompileData[Key]) => void} setData
 *   Set data into the key/value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<Kind extends Node>(this: CompileContext, node: Kind, token: Token, onError?: OnEnterError) => Kind} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ // To do: micromark: create a registry of tokens?
// To do: next major: don’t return given `Node` from `enter`.
// To do: next major: remove setter/getter.

var $7EUFW = parcelRequire("7EUFW");

var $4ufhc = parcelRequire("4ufhc");

var $eZPmd = parcelRequire("eZPmd");

var $4aDOK = parcelRequire("4aDOK");

var $7zorP = parcelRequire("7zorP");

var $aF3E2 = parcelRequire("aF3E2");

var $f7Cpv = parcelRequire("f7Cpv");

var $8DqT9 = parcelRequire("8DqT9");

var $ch1PA = parcelRequire("ch1PA");
const $cbc38e8d137c7232$var$own = {}.hasOwnProperty;
const $cbc38e8d137c7232$export$d744d789c09bfde6 = /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */ /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */ function(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return $cbc38e8d137c7232$var$compiler(options)((0, $4aDOK.postprocess)((0, $4ufhc.parse)(options).document().write((0, $eZPmd.preprocess)()(value, encoding, true))));
};
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $cbc38e8d137c7232$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $cbc38e8d137c7232$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: "root",
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === "enter") listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($cbc38e8d137c7232$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $cbc38e8d137c7232$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $cbc38e8d137c7232$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $cbc38e8d137c7232$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            if (event[1].type === "listUnordered" || event[1].type === "listOrdered" || event[1].type === "blockQuote") {
                if (event[0] === "enter") containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === "lineEndingBlank") {
                if (event[0] === "enter") {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === "linePrefix" || event[1].type === "listItemValue" || event[1].type === "listItemMarker" || event[1].type === "listItemPrefix" || event[1].type === "listItemPrefixWhitespace") ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === "exit") continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        "exit",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    listItem = {
                        type: "listItem",
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    // @ts-expect-error: `listItem` is most definitely defined, TS...
                    events.splice(index, 0, [
                        "enter",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Set data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @param {CompileData[Key]} [value]
   *   New value.
   * @returns {void}
   *   Nothing.
   */ function setData(key, value) {
        data[key] = value;
    }
    /**
   * Get data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @returns {CompileData[Key]}
   *   Value.
   */ function getData(key) {
        return data[key];
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Node} create
   *   Create a node.
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {void}
   */ function buffer() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    /**
   * @template {Node} Kind
   *   Node type.
   * @this {CompileContext}
   *   Context.
   * @param {Kind} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {Kind}
   *   The given node.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
        parent.children.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        // @ts-expect-error: `end` will be patched later.
        node.position = {
            start: $cbc38e8d137c7232$var$point(token.start)
        };
        return node;
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {Node}
   *   The closed node.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error("Cannot close `" + token.type + "` (" + (0, $ch1PA.stringifyPosition)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $cbc38e8d137c7232$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $cbc38e8d137c7232$var$point(token.end);
        return node;
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $7EUFW.toString)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        setData("expectingFirstListItemValue", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData("expectingFirstListItemValue")) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            setData("expectingFirstListItemValue");
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData("flowCodeInside")) return;
        this.buffer();
        setData("flowCodeInside", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        setData("flowCodeInside");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, "");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $f7Cpv.normalizeIdentifier)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData("setextHeadingSlurpLineEnding", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        setData("setextHeadingSlurpLineEnding");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        let tail = node.children[node.children.length - 1];
        if (!tail || tail.type !== "text") {
            // Add a new text node.
            tail = text();
            // @ts-expect-error: we’ll add `end` later.
            tail.position = {
                start: $cbc38e8d137c7232$var$point(token.start)
            };
            // @ts-expect-error: Assume `parent` accepts `text`.
            node.children.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $cbc38e8d137c7232$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData("atHardBreak")) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $cbc38e8d137c7232$var$point(token.end);
            setData("atHardBreak");
            return;
        }
        if (!getData("setextHeadingSlurpLineEnding") && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        setData("atHardBreak", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData("inReference")) {
            /** @type {ReferenceType} */ const referenceType = getData("referenceType") || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData("referenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $aF3E2.decodeString)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $f7Cpv.normalizeIdentifier)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        setData("inReference", true);
        if (node.type === "link") {
            /** @type {Array<StaticPhrasingContent>} */ // @ts-expect-error: Assume static phrasing content.
            const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        setData("inReference");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        setData("referenceType", "collapsed");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $f7Cpv.normalizeIdentifier)(this.sliceSerialize(token)).toLowerCase();
        setData("referenceType", "full");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        setData("characterReferenceType", token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = getData("characterReferenceType");
        /** @type {string} */ let value;
        if (type) {
            value = (0, $7zorP.decodeNumericCharacterReference)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            setData("characterReferenceType");
        } else {
            const result = (0, $8DqT9.decodeNamedCharacterReference)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $cbc38e8d137c7232$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = "mailto:" + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: "blockquote",
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: "emphasis",
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        // @ts-expect-error `depth` will be set later.
        return {
            type: "heading",
            depth: undefined,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: "break"
        };
    }
    /** @returns {HTML} */ function html() {
        return {
            type: "html",
            value: ""
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: "list",
            ordered: token.type === "listOrdered",
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: "listItem",
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: "paragraph",
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: "strong",
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: "text",
            value: ""
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: "thematicBreak"
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $cbc38e8d137c7232$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Extension | Array<Extension>>} extensions
 * @returns {void}
 */ function $cbc38e8d137c7232$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $cbc38e8d137c7232$var$configure(combined, value);
        else $cbc38e8d137c7232$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {void}
 */ function $cbc38e8d137c7232$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($cbc38e8d137c7232$var$own.call(extension, key)) {
        if (key === "canContainEols") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "transforms") {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === "enter" || key === "exit") {
            const right = extension[key];
            if (right) Object.assign(combined[key], right);
        }
    }
}
/** @type {OnEnterError} */ function $cbc38e8d137c7232$var$defaultOnError(left, right) {
    if (left) throw new Error("Cannot close `" + left.type + "` (" + (0, $ch1PA.stringifyPosition)({
        start: left.start,
        end: left.end
    }) + "): a different token (`" + right.type + "`, " + (0, $ch1PA.stringifyPosition)({
        start: right.start,
        end: right.end
    }) + ") is open");
    else throw new Error("Cannot close document, a token (`" + right.type + "`, " + (0, $ch1PA.stringifyPosition)({
        start: right.start,
        end: right.end
    }) + ") is still open");
}

});
parcelRegister("7EUFW", function(module, exports) {

$parcel$export(module.exports, "toString", () => $0170640defa60672$export$f84e8e69fd4488a5);
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s.
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML.
 */ /** @type {Options} */ const $0170640defa60672$var$emptyOptions = {};
function $0170640defa60672$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $0170640defa60672$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === "boolean" ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === "boolean" ? settings.includeHtml : true;
    return $0170640defa60672$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $0170640defa60672$var$one(value, includeImageAlt, includeHtml) {
    if ($0170640defa60672$var$node(value)) {
        if ("value" in value) return value.type === "html" && !includeHtml ? "" : value.value;
        if (includeImageAlt && "alt" in value && value.alt) return value.alt;
        if ("children" in value) return $0170640defa60672$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $0170640defa60672$var$all(value, includeImageAlt, includeHtml);
    return "";
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $0170640defa60672$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $0170640defa60672$var$one(values[index], includeImageAlt, includeHtml);
    return result.join("");
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Node}
 *   Whether `value` is a node.
 */ function $0170640defa60672$var$node(value) {
    return Boolean(value && typeof value === "object");
}

});

parcelRegister("4ufhc", function(module, exports) {

$parcel$export(module.exports, "parse", () => $3445d05d6b42240a$export$98e6a39c04603d36);
/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */ 
var $YC9R7 = parcelRequire("YC9R7");

var $dXdsV = parcelRequire("dXdsV");

var $bsKh0 = parcelRequire("bsKh0");

var $a1EgQ = parcelRequire("a1EgQ");

var $hXGTo = parcelRequire("hXGTo");

var $awdJk = parcelRequire("awdJk");

var $cyNwD = parcelRequire("cyNwD");
function $3445d05d6b42240a$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $YC9R7.combineExtensions)([
        $cyNwD,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $dXdsV.content)),
        document: create((0, $bsKh0.document)),
        flow: create((0, $a1EgQ.flow)),
        string: create((0, $hXGTo.string)),
        text: create((0, $hXGTo.text))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $awdJk.createTokenizer)(parser, initial, from);
        }
    }
}

});
parcelRegister("YC9R7", function(module, exports) {

$parcel$export(module.exports, "combineExtensions", () => $0b633416a5f7021f$export$86a865d89ef3c690);
$parcel$export(module.exports, "combineHtmlExtensions", () => $0b633416a5f7021f$export$eaf8c406dfb0a620);
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */ 
var $eyVyf = parcelRequire("eyVyf");
const $0b633416a5f7021f$var$hasOwnProperty = {}.hasOwnProperty;
function $0b633416a5f7021f$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$0b633416a5f7021f$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $0b633416a5f7021f$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $0b633416a5f7021f$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$0b633416a5f7021f$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $0b633416a5f7021f$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {void}
 */ function $0b633416a5f7021f$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === "after" ? existing : before).push(list[index]);
    (0, $eyVyf.splice)(existing, 0, 0, before);
}
function $0b633416a5f7021f$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$0b633416a5f7021f$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $0b633416a5f7021f$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $0b633416a5f7021f$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}

});
parcelRegister("eyVyf", function(module, exports) {

$parcel$export(module.exports, "splice", () => $a9a0e22c46ae7ead$export$869882364835d202);
$parcel$export(module.exports, "push", () => $a9a0e22c46ae7ead$export$4cbf152802aa238);
/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {void}
 *   Nothing.
 */ function $a9a0e22c46ae7ead$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $a9a0e22c46ae7ead$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $a9a0e22c46ae7ead$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}

});


parcelRegister("dXdsV", function(module, exports) {

$parcel$export(module.exports, "content", () => $a28b3b011a4f7251$export$a7db06668cad9adb);
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ 
var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");
const $a28b3b011a4f7251$export$a7db06668cad9adb = {
    tokenize: $a28b3b011a4f7251$var$initializeContent
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $a28b3b011a4f7251$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $ev8OE.factorySpace)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}

});
parcelRegister("ev8OE", function(module, exports) {

$parcel$export(module.exports, "factorySpace", () => $a8eacca0ebf94dd6$export$ae105c1eb063a0a2);
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
var $7CNzt = parcelRequire("7CNzt");
function $a8eacca0ebf94dd6$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $7CNzt.markdownSpace)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $7CNzt.markdownSpace)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}

});
parcelRegister("7CNzt", function(module, exports) {

$parcel$export(module.exports, "asciiAlpha", () => $58d288d5ea315deb$export$d65d6b62c24d5436);
$parcel$export(module.exports, "asciiAlphanumeric", () => $58d288d5ea315deb$export$75c76db11865a9f4);
$parcel$export(module.exports, "asciiAtext", () => $58d288d5ea315deb$export$4397998b34fe597d);
$parcel$export(module.exports, "asciiControl", () => $58d288d5ea315deb$export$67dbf494fc8394df);
$parcel$export(module.exports, "asciiDigit", () => $58d288d5ea315deb$export$ca8b5b1a6c320e6e);
$parcel$export(module.exports, "asciiHexDigit", () => $58d288d5ea315deb$export$eca2752363989806);
$parcel$export(module.exports, "asciiPunctuation", () => $58d288d5ea315deb$export$35794a7d1db99380);
$parcel$export(module.exports, "markdownLineEnding", () => $58d288d5ea315deb$export$34a1dff1c0936953);
$parcel$export(module.exports, "markdownLineEndingOrSpace", () => $58d288d5ea315deb$export$a30284361b3814b7);
$parcel$export(module.exports, "markdownSpace", () => $58d288d5ea315deb$export$2c6cf65c1127992a);
$parcel$export(module.exports, "unicodePunctuation", () => $58d288d5ea315deb$export$aa04114dd888a7a0);
$parcel$export(module.exports, "unicodeWhitespace", () => $58d288d5ea315deb$export$a0ff789c034ffdf4);
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
var $4c0Ap = parcelRequire("4c0Ap");
const $58d288d5ea315deb$export$d65d6b62c24d5436 = $58d288d5ea315deb$var$regexCheck(/[A-Za-z]/);
const $58d288d5ea315deb$export$75c76db11865a9f4 = $58d288d5ea315deb$var$regexCheck(/[\dA-Za-z]/);
const $58d288d5ea315deb$export$4397998b34fe597d = $58d288d5ea315deb$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $58d288d5ea315deb$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $58d288d5ea315deb$export$ca8b5b1a6c320e6e = $58d288d5ea315deb$var$regexCheck(/\d/);
const $58d288d5ea315deb$export$eca2752363989806 = $58d288d5ea315deb$var$regexCheck(/[\dA-Fa-f]/);
const $58d288d5ea315deb$export$35794a7d1db99380 = $58d288d5ea315deb$var$regexCheck(/[!-/:-@[-`{-~]/);
function $58d288d5ea315deb$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $58d288d5ea315deb$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $58d288d5ea315deb$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $58d288d5ea315deb$export$aa04114dd888a7a0 = $58d288d5ea315deb$var$regexCheck((0, $4c0Ap.unicodePunctuationRegex));
const $58d288d5ea315deb$export$a0ff789c034ffdf4 = $58d288d5ea315deb$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */ function $58d288d5ea315deb$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && regex.test(String.fromCharCode(code));
    }
}

});
parcelRegister("4c0Ap", function(module, exports) {

$parcel$export(module.exports, "unicodePunctuationRegex", () => $30d8bcd9610bd755$export$85b5101f24802e8c);
// This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
/**
 * Regular expression that matches a unicode punctuation character.
 */ const $30d8bcd9610bd755$export$85b5101f24802e8c = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;

});




parcelRegister("bsKh0", function(module, exports) {

$parcel$export(module.exports, "document", () => $8586342260a693d4$export$5a7bfc01df82fcd1);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 */ 
var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");

var $eyVyf = parcelRequire("eyVyf");
const $8586342260a693d4$export$5a7bfc01df82fcd1 = {
    tokenize: $8586342260a693d4$var$initializeDocument
};
/** @type {Construct} */ const $8586342260a693d4$var$containerConstruct = {
    tokenize: $8586342260a693d4$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $8586342260a693d4$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $eyVyf.splice)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($8586342260a693d4$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($8586342260a693d4$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            contentType: "flow",
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {void}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $eyVyf.splice)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {void}
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8586342260a693d4$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $ev8OE.factorySpace)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4);
}

});

parcelRegister("a1EgQ", function(module, exports) {

$parcel$export(module.exports, "flow", () => $74c93c4e2f21f6fb$export$ccc7b0636abaffc3);
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ 
var $tOvBw = parcelRequire("tOvBw");
var $4qoZ1 = parcelRequire("4qoZ1");

var $ev8OE = parcelRequire("ev8OE");

const $74c93c4e2f21f6fb$export$ccc7b0636abaffc3 = {
    tokenize: $74c93c4e2f21f6fb$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $74c93c4e2f21f6fb$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $tOvBw.blankLine), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $ev8OE.factorySpace)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $4qoZ1.content), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}

});
parcelRegister("tOvBw", function(module, exports) {

$parcel$export(module.exports, "blankLine", () => $0599e3886f2a0707$export$d50d28ce3ab2a612);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");
const $0599e3886f2a0707$export$d50d28ce3ab2a612 = {
    tokenize: $0599e3886f2a0707$var$tokenizeBlankLine,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0599e3886f2a0707$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $7CNzt.markdownSpace)(code) ? (0, $ev8OE.factorySpace)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $7CNzt.markdownLineEnding)(code) ? ok(code) : nok(code);
    }
}

});

parcelRegister("4qoZ1", function(module, exports) {

$parcel$export(module.exports, "content", () => $338cf845b2c3ef62$export$a7db06668cad9adb);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");

var $ebc2E = parcelRequire("ebc2E");
const $338cf845b2c3ef62$export$a7db06668cad9adb = {
    tokenize: $338cf845b2c3ef62$var$tokenizeContent,
    resolve: $338cf845b2c3ef62$var$resolveContent
};
/** @type {Construct} */ const $338cf845b2c3ef62$var$continuationConstruct = {
    tokenize: $338cf845b2c3ef62$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $338cf845b2c3ef62$var$resolveContent(events) {
    (0, $ebc2E.subtokenize)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $338cf845b2c3ef62$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $7CNzt.markdownLineEnding)(code)) return effects.check($338cf845b2c3ef62$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $338cf845b2c3ef62$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $ev8OE.factorySpace)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}

});
parcelRegister("ebc2E", function(module, exports) {

$parcel$export(module.exports, "subtokenize", () => $a52b6f0843005626$export$12949d1dd00fddf4);
/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */ 
var $eyVyf = parcelRequire("eyVyf");
function $a52b6f0843005626$export$12949d1dd00fddf4(events) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index];
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === "enter") {
            if (event[1].contentType) {
                Object.assign(jumps, $a52b6f0843005626$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === "enter") {
                        if (lineIndex) events[lineIndex][1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events[lineIndex][1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                (0, $eyVyf.splice)(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $a52b6f0843005626$var$subcontent(events, eventIndex) {
    const token = events[eventIndex][1];
    const context = events[eventIndex][2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === "exit" && childEvents[index - 1][0] === "enter" && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        (0, $eyVyf.splice)(events, start, 2, slice);
    }
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}

});



parcelRegister("hXGTo", function(module, exports) {

$parcel$export(module.exports, "resolver", () => $d13937e25f7fba0f$export$50397835cbfdbc24);
$parcel$export(module.exports, "string", () => $d13937e25f7fba0f$export$22b082955e083ec3);
$parcel$export(module.exports, "text", () => $d13937e25f7fba0f$export$6f093cfa640b7166);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ const $d13937e25f7fba0f$export$50397835cbfdbc24 = {
    resolveAll: $d13937e25f7fba0f$var$createResolver()
};
const $d13937e25f7fba0f$export$22b082955e083ec3 = $d13937e25f7fba0f$var$initializeFactory("string");
const $d13937e25f7fba0f$export$6f093cfa640b7166 = $d13937e25f7fba0f$var$initializeFactory("text");
/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */ function $d13937e25f7fba0f$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $d13937e25f7fba0f$var$createResolver(field === "text" ? $d13937e25f7fba0f$var$resolveAllLineSuffixes : undefined)
    };
    /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */ function $d13937e25f7fba0f$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $d13937e25f7fba0f$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === "string") {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    "enter",
                    token,
                    context
                ], [
                    "exit",
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}

});

parcelRegister("awdJk", function(module, exports) {

$parcel$export(module.exports, "createTokenizer", () => $7a878b090d1aad8f$export$ae34f10ee4b29837);
/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @callback Restore
 * @returns {void}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */ 
var $7CNzt = parcelRequire("7CNzt");

var $eyVyf = parcelRequire("eyVyf");

var $9xN1y = parcelRequire("9xN1y");
function $7a878b090d1aad8f$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | void}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $eyVyf.push)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $9xN1y.resolveAll)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $7a878b090d1aad8f$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $7a878b090d1aad8f$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { line: line, column: column, offset: offset, _index: _index, _bufferIndex: _bufferIndex } = point;
        return {
            line: line,
            column: column,
            offset: offset,
            _index: _index,
            _bufferIndex: _bufferIndex
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === "string") {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            "enter",
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            "exit",
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? handleListOfConstructs(constructs) : "tokenize" in constructs ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $eyVyf.splice)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {void}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */ function $7a878b090d1aad8f$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === "string") view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */ function $7a878b090d1aad8f$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === "string") value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "	";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join("");
}

});
parcelRegister("9xN1y", function(module, exports) {

$parcel$export(module.exports, "resolveAll", () => $6f2d3946e97d353f$export$3ff61ec196ff408b);
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $6f2d3946e97d353f$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}

});


parcelRegister("cyNwD", function(module, exports) {

$parcel$export(module.exports, "document", () => $924f13b1d2d8cc0f$export$5a7bfc01df82fcd1);
$parcel$export(module.exports, "contentInitial", () => $924f13b1d2d8cc0f$export$5a2181fb44b58173);
$parcel$export(module.exports, "flowInitial", () => $924f13b1d2d8cc0f$export$cf8bead395eff824);
$parcel$export(module.exports, "flow", () => $924f13b1d2d8cc0f$export$ccc7b0636abaffc3);
$parcel$export(module.exports, "string", () => $924f13b1d2d8cc0f$export$22b082955e083ec3);
$parcel$export(module.exports, "text", () => $924f13b1d2d8cc0f$export$6f093cfa640b7166);
$parcel$export(module.exports, "insideSpan", () => $924f13b1d2d8cc0f$export$d44f260a3f9b69f5);
$parcel$export(module.exports, "attentionMarkers", () => $924f13b1d2d8cc0f$export$b9c0b60d74426aea);
$parcel$export(module.exports, "disable", () => $924f13b1d2d8cc0f$export$e20fbacbb41798b);
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ 
var $9BgUz = parcelRequire("9BgUz");
var $yHiRK = parcelRequire("yHiRK");
var $a37zB = parcelRequire("a37zB");
var $8i8UQ = parcelRequire("8i8UQ");
var $8tTRd = parcelRequire("8tTRd");
var $6aZCQ = parcelRequire("6aZCQ");
var $64W0g = parcelRequire("64W0g");
var $eJE0j = parcelRequire("eJE0j");
var $6a0k4 = parcelRequire("6a0k4");
var $c54E7 = parcelRequire("c54E7");
var $gvquG = parcelRequire("gvquG");
var $9ZGfx = parcelRequire("9ZGfx");
var $aoUs3 = parcelRequire("aoUs3");
var $6TDST = parcelRequire("6TDST");
var $yHswZ = parcelRequire("yHswZ");
var $bBsQL = parcelRequire("bBsQL");
var $aHvJK = parcelRequire("aHvJK");
var $b1C7w = parcelRequire("b1C7w");
var $P6Xqq = parcelRequire("P6Xqq");
var $mfl0x = parcelRequire("mfl0x");

var $hXGTo = parcelRequire("hXGTo");
const $924f13b1d2d8cc0f$export$5a7bfc01df82fcd1 = {
    [42]: (0, $b1C7w.list),
    [43]: (0, $b1C7w.list),
    [45]: (0, $b1C7w.list),
    [48]: (0, $b1C7w.list),
    [49]: (0, $b1C7w.list),
    [50]: (0, $b1C7w.list),
    [51]: (0, $b1C7w.list),
    [52]: (0, $b1C7w.list),
    [53]: (0, $b1C7w.list),
    [54]: (0, $b1C7w.list),
    [55]: (0, $b1C7w.list),
    [56]: (0, $b1C7w.list),
    [57]: (0, $b1C7w.list),
    [62]: (0, $a37zB.blockQuote)
};
const $924f13b1d2d8cc0f$export$5a2181fb44b58173 = {
    [91]: (0, $6a0k4.definition)
};
const $924f13b1d2d8cc0f$export$cf8bead395eff824 = {
    [-2]: (0, $64W0g.codeIndented),
    [-1]: (0, $64W0g.codeIndented),
    [32]: (0, $64W0g.codeIndented)
};
const $924f13b1d2d8cc0f$export$ccc7b0636abaffc3 = {
    [35]: (0, $gvquG.headingAtx),
    [42]: (0, $mfl0x.thematicBreak),
    [45]: [
        (0, $P6Xqq.setextUnderline),
        (0, $mfl0x.thematicBreak)
    ],
    [60]: (0, $9ZGfx.htmlFlow),
    [61]: (0, $P6Xqq.setextUnderline),
    [95]: (0, $mfl0x.thematicBreak),
    [96]: (0, $6aZCQ.codeFenced),
    [126]: (0, $6aZCQ.codeFenced)
};
const $924f13b1d2d8cc0f$export$22b082955e083ec3 = {
    [38]: (0, $8tTRd.characterReference),
    [92]: (0, $8i8UQ.characterEscape)
};
const $924f13b1d2d8cc0f$export$6f093cfa640b7166 = {
    [-5]: (0, $aHvJK.lineEnding),
    [-4]: (0, $aHvJK.lineEnding),
    [-3]: (0, $aHvJK.lineEnding),
    [33]: (0, $yHswZ.labelStartImage),
    [38]: (0, $8tTRd.characterReference),
    [42]: (0, $9BgUz.attention),
    [60]: [
        (0, $yHiRK.autolink),
        (0, $aoUs3.htmlText)
    ],
    [91]: (0, $bBsQL.labelStartLink),
    [92]: [
        (0, $c54E7.hardBreakEscape),
        (0, $8i8UQ.characterEscape)
    ],
    [93]: (0, $6TDST.labelEnd),
    [95]: (0, $9BgUz.attention),
    [96]: (0, $eJE0j.codeText)
};
const $924f13b1d2d8cc0f$export$d44f260a3f9b69f5 = {
    null: [
        (0, $9BgUz.attention),
        (0, $hXGTo.resolver)
    ]
};
const $924f13b1d2d8cc0f$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $924f13b1d2d8cc0f$export$e20fbacbb41798b = {
    null: []
};

});
parcelRegister("9BgUz", function(module, exports) {

$parcel$export(module.exports, "attention", () => $6fd4b00257e5679b$export$45b92471da762af7);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $eyVyf = parcelRequire("eyVyf");

var $9Mvoc = parcelRequire("9Mvoc");

var $9xN1y = parcelRequire("9xN1y");
const $6fd4b00257e5679b$export$45b92471da762af7 = {
    name: "attention",
    tokenize: $6fd4b00257e5679b$var$tokenizeAttention,
    resolveAll: $6fd4b00257e5679b$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ function $6fd4b00257e5679b$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $6fd4b00257e5679b$var$movePoint(start, -use);
            $6fd4b00257e5679b$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $eyVyf.push)(nextEvents, [
                [
                    "enter",
                    events[open][1],
                    context
                ],
                [
                    "exit",
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $eyVyf.push)(nextEvents, [
                [
                    "enter",
                    group,
                    context
                ],
                [
                    "enter",
                    openingSequence,
                    context
                ],
                [
                    "exit",
                    openingSequence,
                    context
                ],
                [
                    "enter",
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $eyVyf.push)(nextEvents, (0, $9xN1y.resolveAll)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $eyVyf.push)(nextEvents, [
                [
                    "exit",
                    text,
                    context
                ],
                [
                    "enter",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $eyVyf.push)(nextEvents, [
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $eyVyf.splice)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6fd4b00257e5679b$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $9Mvoc.classifyCharacter)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter("attentionSequence");
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit("attentionSequence");
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $9Mvoc.classifyCharacter)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */ function $6fd4b00257e5679b$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

});
parcelRegister("9Mvoc", function(module, exports) {

$parcel$export(module.exports, "classifyCharacter", () => $71f0f20059e29362$export$e3902bc0d835cad0);
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
var $7CNzt = parcelRequire("7CNzt");
function $71f0f20059e29362$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $7CNzt.markdownLineEndingOrSpace)(code) || (0, $7CNzt.unicodeWhitespace)(code)) return 1;
    if ((0, $7CNzt.unicodePunctuation)(code)) return 2;
}

});


parcelRegister("yHiRK", function(module, exports) {

$parcel$export(module.exports, "autolink", () => $0684c438a9488a3d$export$17ddf85e4c916ad6);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $7CNzt = parcelRequire("7CNzt");
const $0684c438a9488a3d$export$17ddf85e4c916ad6 = {
    name: "autolink",
    tokenize: $0684c438a9488a3d$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0684c438a9488a3d$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $7CNzt.asciiAlpha)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $7CNzt.asciiAlphanumeric)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $7CNzt.asciiAlphanumeric)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $7CNzt.asciiControl)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $7CNzt.asciiAtext)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $7CNzt.asciiAlphanumeric)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $7CNzt.asciiAlphanumeric)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

});

parcelRegister("a37zB", function(module, exports) {

$parcel$export(module.exports, "blockQuote", () => $75100f1410aba021$export$200dcd0a5903c968);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");
const $75100f1410aba021$export$200dcd0a5903c968 = {
    name: "blockQuote",
    tokenize: $75100f1410aba021$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $75100f1410aba021$var$tokenizeBlockQuoteContinuation
    },
    exit: $75100f1410aba021$var$exit
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $75100f1410aba021$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $7CNzt.markdownSpace)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $75100f1410aba021$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $7CNzt.markdownSpace)(code)) // Always populated by defaults.
        return (0, $ev8OE.factorySpace)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($75100f1410aba021$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $75100f1410aba021$var$exit(effects) {
    effects.exit("blockQuote");
}

});

parcelRegister("8i8UQ", function(module, exports) {

$parcel$export(module.exports, "characterEscape", () => $6096ebaab8303b53$export$2005478564e78d96);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $7CNzt = parcelRequire("7CNzt");
const $6096ebaab8303b53$export$2005478564e78d96 = {
    name: "characterEscape",
    tokenize: $6096ebaab8303b53$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6096ebaab8303b53$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $7CNzt.asciiPunctuation)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

});

parcelRegister("8tTRd", function(module, exports) {

$parcel$export(module.exports, "characterReference", () => $62cc5c4972153475$export$e31905600aaf3d8e);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $8DqT9 = parcelRequire("8DqT9");

var $7CNzt = parcelRequire("7CNzt");
const $62cc5c4972153475$export$e31905600aaf3d8e = {
    name: "characterReference",
    tokenize: $62cc5c4972153475$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $62cc5c4972153475$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $7CNzt.asciiAlphanumeric);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $7CNzt.asciiHexDigit);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $7CNzt.asciiDigit);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $7CNzt.asciiAlphanumeric) && !(0, $8DqT9.decodeNamedCharacterReference)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

});
parcelRegister("8DqT9", function(module, exports) {

$parcel$export(module.exports, "decodeNamedCharacterReference", () => $6496d2c00f914354$export$289b6a6320f709b4);

var $d6rGF = parcelRequire("d6rGF");
const $6496d2c00f914354$var$own = {}.hasOwnProperty;
function $6496d2c00f914354$export$289b6a6320f709b4(value) {
    return $6496d2c00f914354$var$own.call((0, $d6rGF.characterEntities), value) ? (0, $d6rGF.characterEntities)[value] : false;
}

});
parcelRegister("d6rGF", function(module, exports) {

$parcel$export(module.exports, "characterEntities", () => $98a14ffe0d8fb66f$export$ec810d1aafce79a7);
/**
 * Map of named character references.
 *
 * @type {Record<string, string>}
 */ const $98a14ffe0d8fb66f$export$ec810d1aafce79a7 = {
    AElig: "\xc6",
    AMP: "&",
    Aacute: "\xc1",
    Abreve: "\u0102",
    Acirc: "\xc2",
    Acy: "\u0410",
    Afr: "\uD835\uDD04",
    Agrave: "\xc0",
    Alpha: "\u0391",
    Amacr: "\u0100",
    And: "\u2A53",
    Aogon: "\u0104",
    Aopf: "\uD835\uDD38",
    ApplyFunction: "\u2061",
    Aring: "\xc5",
    Ascr: "\uD835\uDC9C",
    Assign: "\u2254",
    Atilde: "\xc3",
    Auml: "\xc4",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    Barwed: "\u2306",
    Bcy: "\u0411",
    Because: "\u2235",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    Bfr: "\uD835\uDD05",
    Bopf: "\uD835\uDD39",
    Breve: "\u02D8",
    Bscr: "\u212C",
    Bumpeq: "\u224E",
    CHcy: "\u0427",
    COPY: "\xa9",
    Cacute: "\u0106",
    Cap: "\u22D2",
    CapitalDifferentialD: "\u2145",
    Cayleys: "\u212D",
    Ccaron: "\u010C",
    Ccedil: "\xc7",
    Ccirc: "\u0108",
    Cconint: "\u2230",
    Cdot: "\u010A",
    Cedilla: "\xb8",
    CenterDot: "\xb7",
    Cfr: "\u212D",
    Chi: "\u03A7",
    CircleDot: "\u2299",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    Colon: "\u2237",
    Colone: "\u2A74",
    Congruent: "\u2261",
    Conint: "\u222F",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    Coproduct: "\u2210",
    CounterClockwiseContourIntegral: "\u2233",
    Cross: "\u2A2F",
    Cscr: "\uD835\uDC9E",
    Cup: "\u22D3",
    CupCap: "\u224D",
    DD: "\u2145",
    DDotrahd: "\u2911",
    DJcy: "\u0402",
    DScy: "\u0405",
    DZcy: "\u040F",
    Dagger: "\u2021",
    Darr: "\u21A1",
    Dashv: "\u2AE4",
    Dcaron: "\u010E",
    Dcy: "\u0414",
    Del: "\u2207",
    Delta: "\u0394",
    Dfr: "\uD835\uDD07",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: "`",
    DiacriticalTilde: "\u02DC",
    Diamond: "\u22C4",
    DifferentialD: "\u2146",
    Dopf: "\uD835\uDD3B",
    Dot: "\xa8",
    DotDot: "\u20DC",
    DotEqual: "\u2250",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xa8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    Downarrow: "\u21D3",
    Dscr: "\uD835\uDC9F",
    Dstrok: "\u0110",
    ENG: "\u014A",
    ETH: "\xd0",
    Eacute: "\xc9",
    Ecaron: "\u011A",
    Ecirc: "\xca",
    Ecy: "\u042D",
    Edot: "\u0116",
    Efr: "\uD835\uDD08",
    Egrave: "\xc8",
    Element: "\u2208",
    Emacr: "\u0112",
    EmptySmallSquare: "\u25FB",
    EmptyVerySmallSquare: "\u25AB",
    Eogon: "\u0118",
    Eopf: "\uD835\uDD3C",
    Epsilon: "\u0395",
    Equal: "\u2A75",
    EqualTilde: "\u2242",
    Equilibrium: "\u21CC",
    Escr: "\u2130",
    Esim: "\u2A73",
    Eta: "\u0397",
    Euml: "\xcb",
    Exists: "\u2203",
    ExponentialE: "\u2147",
    Fcy: "\u0424",
    Ffr: "\uD835\uDD09",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    Fopf: "\uD835\uDD3D",
    ForAll: "\u2200",
    Fouriertrf: "\u2131",
    Fscr: "\u2131",
    GJcy: "\u0403",
    GT: ">",
    Gamma: "\u0393",
    Gammad: "\u03DC",
    Gbreve: "\u011E",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    Gcy: "\u0413",
    Gdot: "\u0120",
    Gfr: "\uD835\uDD0A",
    Gg: "\u22D9",
    Gopf: "\uD835\uDD3E",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\uD835\uDCA2",
    Gt: "\u226B",
    HARDcy: "\u042A",
    Hacek: "\u02C7",
    Hat: "^",
    Hcirc: "\u0124",
    Hfr: "\u210C",
    HilbertSpace: "\u210B",
    Hopf: "\u210D",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    Hstrok: "\u0126",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    IEcy: "\u0415",
    IJlig: "\u0132",
    IOcy: "\u0401",
    Iacute: "\xcd",
    Icirc: "\xce",
    Icy: "\u0418",
    Idot: "\u0130",
    Ifr: "\u2111",
    Igrave: "\xcc",
    Im: "\u2111",
    Imacr: "\u012A",
    ImaginaryI: "\u2148",
    Implies: "\u21D2",
    Int: "\u222C",
    Integral: "\u222B",
    Intersection: "\u22C2",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    Iogon: "\u012E",
    Iopf: "\uD835\uDD40",
    Iota: "\u0399",
    Iscr: "\u2110",
    Itilde: "\u0128",
    Iukcy: "\u0406",
    Iuml: "\xcf",
    Jcirc: "\u0134",
    Jcy: "\u0419",
    Jfr: "\uD835\uDD0D",
    Jopf: "\uD835\uDD41",
    Jscr: "\uD835\uDCA5",
    Jsercy: "\u0408",
    Jukcy: "\u0404",
    KHcy: "\u0425",
    KJcy: "\u040C",
    Kappa: "\u039A",
    Kcedil: "\u0136",
    Kcy: "\u041A",
    Kfr: "\uD835\uDD0E",
    Kopf: "\uD835\uDD42",
    Kscr: "\uD835\uDCA6",
    LJcy: "\u0409",
    LT: "<",
    Lacute: "\u0139",
    Lambda: "\u039B",
    Lang: "\u27EA",
    Laplacetrf: "\u2112",
    Larr: "\u219E",
    Lcaron: "\u013D",
    Lcedil: "\u013B",
    Lcy: "\u041B",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    LeftRightArrow: "\u2194",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    Leftarrow: "\u21D0",
    Leftrightarrow: "\u21D4",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    LessLess: "\u2AA1",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    Lfr: "\uD835\uDD0F",
    Ll: "\u22D8",
    Lleftarrow: "\u21DA",
    Lmidot: "\u013F",
    LongLeftArrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    LongRightArrow: "\u27F6",
    Longleftarrow: "\u27F8",
    Longleftrightarrow: "\u27FA",
    Longrightarrow: "\u27F9",
    Lopf: "\uD835\uDD43",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    Lscr: "\u2112",
    Lsh: "\u21B0",
    Lstrok: "\u0141",
    Lt: "\u226A",
    Map: "\u2905",
    Mcy: "\u041C",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    MinusPlus: "\u2213",
    Mopf: "\uD835\uDD44",
    Mscr: "\u2133",
    Mu: "\u039C",
    NJcy: "\u040A",
    Nacute: "\u0143",
    Ncaron: "\u0147",
    Ncedil: "\u0145",
    Ncy: "\u041D",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: "\n",
    Nfr: "\uD835\uDD11",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xa0",
    Nopf: "\u2115",
    Not: "\u2AEC",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    Nscr: "\uD835\uDCA9",
    Ntilde: "\xd1",
    Nu: "\u039D",
    OElig: "\u0152",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Ocy: "\u041E",
    Odblac: "\u0150",
    Ofr: "\uD835\uDD12",
    Ograve: "\xd2",
    Omacr: "\u014C",
    Omega: "\u03A9",
    Omicron: "\u039F",
    Oopf: "\uD835\uDD46",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    Or: "\u2A54",
    Oscr: "\uD835\uDCAA",
    Oslash: "\xd8",
    Otilde: "\xd5",
    Otimes: "\u2A37",
    Ouml: "\xd6",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    PartialD: "\u2202",
    Pcy: "\u041F",
    Pfr: "\uD835\uDD13",
    Phi: "\u03A6",
    Pi: "\u03A0",
    PlusMinus: "\xb1",
    Poincareplane: "\u210C",
    Popf: "\u2119",
    Pr: "\u2ABB",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    Prime: "\u2033",
    Product: "\u220F",
    Proportion: "\u2237",
    Proportional: "\u221D",
    Pscr: "\uD835\uDCAB",
    Psi: "\u03A8",
    QUOT: '"',
    Qfr: "\uD835\uDD14",
    Qopf: "\u211A",
    Qscr: "\uD835\uDCAC",
    RBarr: "\u2910",
    REG: "\xae",
    Racute: "\u0154",
    Rang: "\u27EB",
    Rarr: "\u21A0",
    Rarrtl: "\u2916",
    Rcaron: "\u0158",
    Rcedil: "\u0156",
    Rcy: "\u0420",
    Re: "\u211C",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    Rfr: "\u211C",
    Rho: "\u03A1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    Rightarrow: "\u21D2",
    Ropf: "\u211D",
    RoundImplies: "\u2970",
    Rrightarrow: "\u21DB",
    Rscr: "\u211B",
    Rsh: "\u21B1",
    RuleDelayed: "\u29F4",
    SHCHcy: "\u0429",
    SHcy: "\u0428",
    SOFTcy: "\u042C",
    Sacute: "\u015A",
    Sc: "\u2ABC",
    Scaron: "\u0160",
    Scedil: "\u015E",
    Scirc: "\u015C",
    Scy: "\u0421",
    Sfr: "\uD835\uDD16",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    Sigma: "\u03A3",
    SmallCircle: "\u2218",
    Sopf: "\uD835\uDD4A",
    Sqrt: "\u221A",
    Square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    Sscr: "\uD835\uDCAE",
    Star: "\u22C6",
    Sub: "\u22D0",
    Subset: "\u22D0",
    SubsetEqual: "\u2286",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    Sup: "\u22D1",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    Supset: "\u22D1",
    THORN: "\xde",
    TRADE: "\u2122",
    TSHcy: "\u040B",
    TScy: "\u0426",
    Tab: "	",
    Tau: "\u03A4",
    Tcaron: "\u0164",
    Tcedil: "\u0162",
    Tcy: "\u0422",
    Tfr: "\uD835\uDD17",
    Therefore: "\u2234",
    Theta: "\u0398",
    ThickSpace: "\u205F\u200A",
    ThinSpace: "\u2009",
    Tilde: "\u223C",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    Topf: "\uD835\uDD4B",
    TripleDot: "\u20DB",
    Tscr: "\uD835\uDCAF",
    Tstrok: "\u0166",
    Uacute: "\xda",
    Uarr: "\u219F",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    Ubreve: "\u016C",
    Ucirc: "\xdb",
    Ucy: "\u0423",
    Udblac: "\u0170",
    Ufr: "\uD835\uDD18",
    Ugrave: "\xd9",
    Umacr: "\u016A",
    UnderBar: "_",
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    Uopf: "\uD835\uDD4C",
    UpArrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    UpEquilibrium: "\u296E",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    Uparrow: "\u21D1",
    Updownarrow: "\u21D5",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    Upsilon: "\u03A5",
    Uring: "\u016E",
    Uscr: "\uD835\uDCB0",
    Utilde: "\u0168",
    Uuml: "\xdc",
    VDash: "\u22AB",
    Vbar: "\u2AEB",
    Vcy: "\u0412",
    Vdash: "\u22A9",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    Verbar: "\u2016",
    Vert: "\u2016",
    VerticalBar: "\u2223",
    VerticalLine: "|",
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\uD835\uDD19",
    Vopf: "\uD835\uDD4D",
    Vscr: "\uD835\uDCB1",
    Vvdash: "\u22AA",
    Wcirc: "\u0174",
    Wedge: "\u22C0",
    Wfr: "\uD835\uDD1A",
    Wopf: "\uD835\uDD4E",
    Wscr: "\uD835\uDCB2",
    Xfr: "\uD835\uDD1B",
    Xi: "\u039E",
    Xopf: "\uD835\uDD4F",
    Xscr: "\uD835\uDCB3",
    YAcy: "\u042F",
    YIcy: "\u0407",
    YUcy: "\u042E",
    Yacute: "\xdd",
    Ycirc: "\u0176",
    Ycy: "\u042B",
    Yfr: "\uD835\uDD1C",
    Yopf: "\uD835\uDD50",
    Yscr: "\uD835\uDCB4",
    Yuml: "\u0178",
    ZHcy: "\u0416",
    Zacute: "\u0179",
    Zcaron: "\u017D",
    Zcy: "\u0417",
    Zdot: "\u017B",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    Zfr: "\u2128",
    Zopf: "\u2124",
    Zscr: "\uD835\uDCB5",
    aacute: "\xe1",
    abreve: "\u0103",
    ac: "\u223E",
    acE: "\u223E\u0333",
    acd: "\u223F",
    acirc: "\xe2",
    acute: "\xb4",
    acy: "\u0430",
    aelig: "\xe6",
    af: "\u2061",
    afr: "\uD835\uDD1E",
    agrave: "\xe0",
    alefsym: "\u2135",
    aleph: "\u2135",
    alpha: "\u03B1",
    amacr: "\u0101",
    amalg: "\u2A3F",
    amp: "&",
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xc5",
    angzarr: "\u237C",
    aogon: "\u0105",
    aopf: "\uD835\uDD52",
    ap: "\u2248",
    apE: "\u2A70",
    apacir: "\u2A6F",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    approx: "\u2248",
    approxeq: "\u224A",
    aring: "\xe5",
    ascr: "\uD835\uDCB6",
    ast: "*",
    asymp: "\u2248",
    asympeq: "\u224D",
    atilde: "\xe3",
    auml: "\xe4",
    awconint: "\u2233",
    awint: "\u2A11",
    bNot: "\u2AED",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    barvee: "\u22BD",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    bfr: "\uD835\uDD1F",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bnot: "\u2310",
    bopf: "\uD835\uDD53",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxDL: "\u2557",
    boxDR: "\u2554",
    boxDl: "\u2556",
    boxDr: "\u2553",
    boxH: "\u2550",
    boxHD: "\u2566",
    boxHU: "\u2569",
    boxHd: "\u2564",
    boxHu: "\u2567",
    boxUL: "\u255D",
    boxUR: "\u255A",
    boxUl: "\u255C",
    boxUr: "\u2559",
    boxV: "\u2551",
    boxVH: "\u256C",
    boxVL: "\u2563",
    boxVR: "\u2560",
    boxVh: "\u256B",
    boxVl: "\u2562",
    boxVr: "\u255F",
    boxbox: "\u29C9",
    boxdL: "\u2555",
    boxdR: "\u2552",
    boxdl: "\u2510",
    boxdr: "\u250C",
    boxh: "\u2500",
    boxhD: "\u2565",
    boxhU: "\u2568",
    boxhd: "\u252C",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxuL: "\u255B",
    boxuR: "\u2558",
    boxul: "\u2518",
    boxur: "\u2514",
    boxv: "\u2502",
    boxvH: "\u256A",
    boxvL: "\u2561",
    boxvR: "\u255E",
    boxvh: "\u253C",
    boxvl: "\u2524",
    boxvr: "\u251C",
    bprime: "\u2035",
    breve: "\u02D8",
    brvbar: "\xa6",
    bscr: "\uD835\uDCB7",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: "\\",
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    bumpeq: "\u224F",
    cacute: "\u0107",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    ccaps: "\u2A4D",
    ccaron: "\u010D",
    ccedil: "\xe7",
    ccirc: "\u0109",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    cdot: "\u010B",
    cedil: "\xb8",
    cemptyv: "\u29B2",
    cent: "\xa2",
    centerdot: "\xb7",
    cfr: "\uD835\uDD20",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    chi: "\u03C7",
    cir: "\u25CB",
    cirE: "\u29C3",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledR: "\xae",
    circledS: "\u24C8",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    clubs: "\u2663",
    clubsuit: "\u2663",
    colon: ":",
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ",",
    commat: "@",
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    conint: "\u222E",
    copf: "\uD835\uDD54",
    coprod: "\u2210",
    copy: "\xa9",
    copysr: "\u2117",
    crarr: "\u21B5",
    cross: "\u2717",
    cscr: "\uD835\uDCB8",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xa4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    dArr: "\u21D3",
    dHar: "\u2965",
    dagger: "\u2020",
    daleth: "\u2138",
    darr: "\u2193",
    dash: "\u2010",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    dcaron: "\u010F",
    dcy: "\u0434",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    ddotseq: "\u2A77",
    deg: "\xb0",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    dfr: "\uD835\uDD21",
    dharl: "\u21C3",
    dharr: "\u21C2",
    diam: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xa8",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: "$",
    dopf: "\uD835\uDD55",
    dot: "\u02D9",
    doteq: "\u2250",
    doteqdot: "\u2251",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    downarrow: "\u2193",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    dscr: "\uD835\uDCB9",
    dscy: "\u0455",
    dsol: "\u29F6",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    eDDot: "\u2A77",
    eDot: "\u2251",
    eacute: "\xe9",
    easter: "\u2A6E",
    ecaron: "\u011B",
    ecir: "\u2256",
    ecirc: "\xea",
    ecolon: "\u2255",
    ecy: "\u044D",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    efr: "\uD835\uDD22",
    eg: "\u2A9A",
    egrave: "\xe8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    emptyv: "\u2205",
    emsp13: "\u2004",
    emsp14: "\u2005",
    emsp: "\u2003",
    eng: "\u014B",
    ensp: "\u2002",
    eogon: "\u0119",
    eopf: "\uD835\uDD56",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    equals: "=",
    equest: "\u225F",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erDot: "\u2253",
    erarr: "\u2971",
    escr: "\u212F",
    esdot: "\u2250",
    esim: "\u2242",
    eta: "\u03B7",
    eth: "\xf0",
    euml: "\xeb",
    euro: "\u20AC",
    excl: "!",
    exist: "\u2203",
    expectation: "\u2130",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    ffr: "\uD835\uDD23",
    filig: "\uFB01",
    fjlig: "fj",
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    fopf: "\uD835\uDD57",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    fpartint: "\u2A0D",
    frac12: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    fscr: "\uD835\uDCBB",
    gE: "\u2267",
    gEl: "\u2A8C",
    gacute: "\u01F5",
    gamma: "\u03B3",
    gammad: "\u03DD",
    gap: "\u2A86",
    gbreve: "\u011F",
    gcirc: "\u011D",
    gcy: "\u0433",
    gdot: "\u0121",
    ge: "\u2265",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    gfr: "\uD835\uDD24",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    gjcy: "\u0453",
    gl: "\u2277",
    glE: "\u2A92",
    gla: "\u2AA5",
    glj: "\u2AA4",
    gnE: "\u2269",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    gopf: "\uD835\uDD58",
    grave: "`",
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    gt: ">",
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    hArr: "\u21D4",
    hairsp: "\u200A",
    half: "\xbd",
    hamilt: "\u210B",
    hardcy: "\u044A",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    hbar: "\u210F",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    hfr: "\uD835\uDD25",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    hopf: "\uD835\uDD59",
    horbar: "\u2015",
    hscr: "\uD835\uDCBD",
    hslash: "\u210F",
    hstrok: "\u0127",
    hybull: "\u2043",
    hyphen: "\u2010",
    iacute: "\xed",
    ic: "\u2063",
    icirc: "\xee",
    icy: "\u0438",
    iecy: "\u0435",
    iexcl: "\xa1",
    iff: "\u21D4",
    ifr: "\uD835\uDD26",
    igrave: "\xec",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    ijlig: "\u0133",
    imacr: "\u012B",
    image: "\u2111",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    intercal: "\u22BA",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    iocy: "\u0451",
    iogon: "\u012F",
    iopf: "\uD835\uDD5A",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xbf",
    iscr: "\uD835\uDCBE",
    isin: "\u2208",
    isinE: "\u22F9",
    isindot: "\u22F5",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    itilde: "\u0129",
    iukcy: "\u0456",
    iuml: "\xef",
    jcirc: "\u0135",
    jcy: "\u0439",
    jfr: "\uD835\uDD27",
    jmath: "\u0237",
    jopf: "\uD835\uDD5B",
    jscr: "\uD835\uDCBF",
    jsercy: "\u0458",
    jukcy: "\u0454",
    kappa: "\u03BA",
    kappav: "\u03F0",
    kcedil: "\u0137",
    kcy: "\u043A",
    kfr: "\uD835\uDD28",
    kgreen: "\u0138",
    khcy: "\u0445",
    kjcy: "\u045C",
    kopf: "\uD835\uDD5C",
    kscr: "\uD835\uDCC0",
    lAarr: "\u21DA",
    lArr: "\u21D0",
    lAtail: "\u291B",
    lBarr: "\u290E",
    lE: "\u2266",
    lEg: "\u2A8B",
    lHar: "\u2962",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    lambda: "\u03BB",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    laquo: "\xab",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: "{",
    lbrack: "[",
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    lcaron: "\u013E",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: "{",
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    le: "\u2264",
    leftarrow: "\u2190",
    leftarrowtail: "\u21A2",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    leftthreetimes: "\u22CB",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    lessgtr: "\u2276",
    lesssim: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    lfr: "\uD835\uDD29",
    lg: "\u2276",
    lgE: "\u2A91",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    ljcy: "\u0459",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    llhard: "\u296B",
    lltri: "\u25FA",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnE: "\u2268",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    longleftarrow: "\u27F5",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    lopf: "\uD835\uDD5D",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: "_",
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: "(",
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    lscr: "\uD835\uDCC1",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: "[",
    lsquo: "\u2018",
    lsquor: "\u201A",
    lstrok: "\u0142",
    lt: "<",
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltrPar: "\u2996",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    mDDot: "\u223A",
    macr: "\xaf",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    mcy: "\u043C",
    mdash: "\u2014",
    measuredangle: "\u2221",
    mfr: "\uD835\uDD2A",
    mho: "\u2127",
    micro: "\xb5",
    mid: "\u2223",
    midast: "*",
    midcir: "\u2AF0",
    middot: "\xb7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    mopf: "\uD835\uDD5E",
    mp: "\u2213",
    mscr: "\uD835\uDCC2",
    mstpos: "\u223E",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nGg: "\u22D9\u0338",
    nGt: "\u226B\u20D2",
    nGtv: "\u226B\u0338",
    nLeftarrow: "\u21CD",
    nLeftrightarrow: "\u21CE",
    nLl: "\u22D8\u0338",
    nLt: "\u226A\u20D2",
    nLtv: "\u226A\u0338",
    nRightarrow: "\u21CF",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nabla: "\u2207",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xa0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    ncaron: "\u0148",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    neArr: "\u21D7",
    nearhk: "\u2924",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    nexist: "\u2204",
    nexists: "\u2204",
    nfr: "\uD835\uDD2B",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    ngsim: "\u2275",
    ngt: "\u226F",
    ngtr: "\u226F",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlE: "\u2266\u0338",
    nlarr: "\u219A",
    nldr: "\u2025",
    nle: "\u2270",
    nleftarrow: "\u219A",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nlsim: "\u2274",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nmid: "\u2224",
    nopf: "\uD835\uDD5F",
    not: "\xac",
    notin: "\u2209",
    notinE: "\u22F9\u0338",
    notindot: "\u22F5\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    nscr: "\uD835\uDCC3",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    ntilde: "\xf1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    nu: "\u03BD",
    num: "#",
    numero: "\u2116",
    numsp: "\u2007",
    nvDash: "\u22AD",
    nvHarr: "\u2904",
    nvap: "\u224D\u20D2",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwArr: "\u21D6",
    nwarhk: "\u2923",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    oS: "\u24C8",
    oacute: "\xf3",
    oast: "\u229B",
    ocir: "\u229A",
    ocirc: "\xf4",
    ocy: "\u043E",
    odash: "\u229D",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    oelig: "\u0153",
    ofcir: "\u29BF",
    ofr: "\uD835\uDD2C",
    ogon: "\u02DB",
    ograve: "\xf2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    omacr: "\u014D",
    omega: "\u03C9",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    oopf: "\uD835\uDD60",
    opar: "\u29B7",
    operp: "\u29B9",
    oplus: "\u2295",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oscr: "\u2134",
    oslash: "\xf8",
    osol: "\u2298",
    otilde: "\xf5",
    otimes: "\u2297",
    otimesas: "\u2A36",
    ouml: "\xf6",
    ovbar: "\u233D",
    par: "\u2225",
    para: "\xb6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    pcy: "\u043F",
    percnt: "%",
    period: ".",
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    pfr: "\uD835\uDD2D",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: "+",
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    plusmn: "\xb1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xb1",
    pointint: "\u2A15",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    pr: "\u227A",
    prE: "\u2AB3",
    prap: "\u2AB7",
    prcue: "\u227C",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    prime: "\u2032",
    primes: "\u2119",
    prnE: "\u2AB5",
    prnap: "\u2AB9",
    prnsim: "\u22E8",
    prod: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    pscr: "\uD835\uDCC5",
    psi: "\u03C8",
    puncsp: "\u2008",
    qfr: "\uD835\uDD2E",
    qint: "\u2A0C",
    qopf: "\uD835\uDD62",
    qprime: "\u2057",
    qscr: "\uD835\uDCC6",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: "?",
    questeq: "\u225F",
    quot: '"',
    rAarr: "\u21DB",
    rArr: "\u21D2",
    rAtail: "\u291C",
    rBarr: "\u290F",
    rHar: "\u2964",
    race: "\u223D\u0331",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xbb",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: "}",
    rbrack: "]",
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    rcaron: "\u0159",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: "}",
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    reg: "\xae",
    rfisht: "\u297D",
    rfloor: "\u230B",
    rfr: "\uD835\uDD2F",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    rho: "\u03C1",
    rhov: "\u03F1",
    rightarrow: "\u2192",
    rightarrowtail: "\u21A3",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    rightthreetimes: "\u22CC",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    ropf: "\uD835\uDD63",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    rpar: ")",
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    rsaquo: "\u203A",
    rscr: "\uD835\uDCC7",
    rsh: "\u21B1",
    rsqb: "]",
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    ruluhar: "\u2968",
    rx: "\u211E",
    sacute: "\u015B",
    sbquo: "\u201A",
    sc: "\u227B",
    scE: "\u2AB4",
    scap: "\u2AB8",
    scaron: "\u0161",
    sccue: "\u227D",
    sce: "\u2AB0",
    scedil: "\u015F",
    scirc: "\u015D",
    scnE: "\u2AB6",
    scnap: "\u2ABA",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    seArr: "\u21D8",
    searhk: "\u2925",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xa7",
    semi: ";",
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    sfr: "\uD835\uDD30",
    sfrown: "\u2322",
    sharp: "\u266F",
    shchcy: "\u0449",
    shcy: "\u0448",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    shy: "\xad",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    softcy: "\u044C",
    sol: "/",
    solb: "\u29C4",
    solbar: "\u233F",
    sopf: "\uD835\uDD64",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    square: "\u25A1",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    sscr: "\uD835\uDCC8",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xaf",
    sub: "\u2282",
    subE: "\u2AC5",
    subdot: "\u2ABD",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    sum: "\u2211",
    sung: "\u266A",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    sup: "\u2283",
    supE: "\u2AC6",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supe: "\u2287",
    supedot: "\u2AC4",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swArr: "\u21D9",
    swarhk: "\u2926",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xdf",
    target: "\u2316",
    tau: "\u03C4",
    tbrk: "\u23B4",
    tcaron: "\u0165",
    tcedil: "\u0163",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    tfr: "\uD835\uDD31",
    there4: "\u2234",
    therefore: "\u2234",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    thinsp: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    thorn: "\xfe",
    tilde: "\u02DC",
    times: "\xd7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    topf: "\uD835\uDD65",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    tscr: "\uD835\uDCC9",
    tscy: "\u0446",
    tshcy: "\u045B",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    uArr: "\u21D1",
    uHar: "\u2963",
    uacute: "\xfa",
    uarr: "\u2191",
    ubrcy: "\u045E",
    ubreve: "\u016D",
    ucirc: "\xfb",
    ucy: "\u0443",
    udarr: "\u21C5",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    ufr: "\uD835\uDD32",
    ugrave: "\xf9",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    umacr: "\u016B",
    uml: "\xa8",
    uogon: "\u0173",
    uopf: "\uD835\uDD66",
    uparrow: "\u2191",
    updownarrow: "\u2195",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    upsi: "\u03C5",
    upsih: "\u03D2",
    upsilon: "\u03C5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    uring: "\u016F",
    urtri: "\u25F9",
    uscr: "\uD835\uDCCA",
    utdot: "\u22F0",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    uuml: "\xfc",
    uwangle: "\u29A7",
    vArr: "\u21D5",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    vDash: "\u22A8",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    vcy: "\u0432",
    vdash: "\u22A2",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    verbar: "|",
    vert: "|",
    vfr: "\uD835\uDD33",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    vopf: "\uD835\uDD67",
    vprop: "\u221D",
    vrtri: "\u22B3",
    vscr: "\uD835\uDCCB",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    vzigzag: "\u299A",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    wfr: "\uD835\uDD34",
    wopf: "\uD835\uDD68",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    wscr: "\uD835\uDCCC",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    xfr: "\uD835\uDD35",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    xopf: "\uD835\uDD69",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    xscr: "\uD835\uDCCD",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    yacute: "\xfd",
    yacy: "\u044F",
    ycirc: "\u0177",
    ycy: "\u044B",
    yen: "\xa5",
    yfr: "\uD835\uDD36",
    yicy: "\u0457",
    yopf: "\uD835\uDD6A",
    yscr: "\uD835\uDCCE",
    yucy: "\u044E",
    yuml: "\xff",
    zacute: "\u017A",
    zcaron: "\u017E",
    zcy: "\u0437",
    zdot: "\u017C",
    zeetrf: "\u2128",
    zeta: "\u03B6",
    zfr: "\uD835\uDD37",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    zopf: "\uD835\uDD6B",
    zscr: "\uD835\uDCCF",
    zwj: "\u200D",
    zwnj: "\u200C"
};

});



parcelRegister("6aZCQ", function(module, exports) {

$parcel$export(module.exports, "codeFenced", () => $47f37ac7299e94ab$export$c23e4921f8d87e7c);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");
/** @type {Construct} */ const $47f37ac7299e94ab$var$nonLazyContinuation = {
    tokenize: $47f37ac7299e94ab$var$tokenizeNonLazyContinuation,
    partial: true
};
const $47f37ac7299e94ab$export$c23e4921f8d87e7c = {
    name: "codeFenced",
    tokenize: $47f37ac7299e94ab$var$tokenizeCodeFenced,
    concrete: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $47f37ac7299e94ab$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        tokenize: tokenizeCloseStart,
        partial: true
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $7CNzt.markdownSpace)(code) ? (0, $ev8OE.factorySpace)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($47f37ac7299e94ab$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $7CNzt.markdownSpace)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $ev8OE.factorySpace)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $7CNzt.markdownSpace)(code) ? (0, $ev8OE.factorySpace)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) return effects.check($47f37ac7299e94ab$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $7CNzt.markdownSpace)(code) ? (0, $ev8OE.factorySpace)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $7CNzt.markdownSpace)(code) ? (0, $ev8OE.factorySpace)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $7CNzt.markdownLineEnding)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $47f37ac7299e94ab$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

});

parcelRegister("64W0g", function(module, exports) {

$parcel$export(module.exports, "codeIndented", () => $46d01c073e895a4c$export$47910b7ab28d1853);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");
const $46d01c073e895a4c$export$47910b7ab28d1853 = {
    name: "codeIndented",
    tokenize: $46d01c073e895a4c$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $46d01c073e895a4c$var$furtherStart = {
    tokenize: $46d01c073e895a4c$var$tokenizeFurtherStart,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $46d01c073e895a4c$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $ev8OE.factorySpace)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $7CNzt.markdownLineEnding)(code)) return effects.attempt($46d01c073e895a4c$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $46d01c073e895a4c$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $ev8OE.factorySpace)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $7CNzt.markdownLineEnding)(code) ? furtherStart(code) : nok(code);
    }
}

});

parcelRegister("eJE0j", function(module, exports) {

$parcel$export(module.exports, "codeText", () => $aba44ca199b0c10c$export$d24f93e715f9df88);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $7CNzt = parcelRequire("7CNzt");
const $aba44ca199b0c10c$export$d24f93e715f9df88 = {
    name: "codeText",
    tokenize: $aba44ca199b0c10c$var$tokenizeCodeText,
    resolve: $aba44ca199b0c10c$var$resolveCodeText,
    previous: $aba44ca199b0c10c$var$previous
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $aba44ca199b0c10c$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $aba44ca199b0c10c$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $aba44ca199b0c10c$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter("space");
            effects.consume(code);
            effects.exit("space");
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $7CNzt.markdownLineEnding)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

});

parcelRegister("6a0k4", function(module, exports) {

$parcel$export(module.exports, "definition", () => $47c3ed5830e290de$export$69f215ed977cdb73);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $3Hx5q = parcelRequire("3Hx5q");

var $fGzxW = parcelRequire("fGzxW");

var $ev8OE = parcelRequire("ev8OE");

var $4Szc6 = parcelRequire("4Szc6");

var $1UDIw = parcelRequire("1UDIw");

var $7CNzt = parcelRequire("7CNzt");

var $f7Cpv = parcelRequire("f7Cpv");
const $47c3ed5830e290de$export$69f215ed977cdb73 = {
    name: "definition",
    tokenize: $47c3ed5830e290de$var$tokenizeDefinition
};
/** @type {Construct} */ const $47c3ed5830e290de$var$titleBefore = {
    tokenize: $47c3ed5830e290de$var$tokenizeTitleBefore,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $47c3ed5830e290de$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $fGzxW.factoryLabel).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $f7Cpv.normalizeIdentifier)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $7CNzt.markdownLineEndingOrSpace)(code) ? (0, $1UDIw.factoryWhitespace)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $3Hx5q.factoryDestination)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($47c3ed5830e290de$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $7CNzt.markdownSpace)(code) ? (0, $ev8OE.factorySpace)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $47c3ed5830e290de$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $7CNzt.markdownLineEndingOrSpace)(code) ? (0, $1UDIw.factoryWhitespace)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $4Szc6.factoryTitle)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $7CNzt.markdownSpace)(code) ? (0, $ev8OE.factorySpace)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $7CNzt.markdownLineEnding)(code) ? ok(code) : nok(code);
    }
}

});
parcelRegister("3Hx5q", function(module, exports) {

$parcel$export(module.exports, "factoryDestination", () => $2b1f0d8ba9c8d6e6$export$2e6c8deaa96af245);
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
var $7CNzt = parcelRequire("7CNzt");
function $2b1f0d8ba9c8d6e6$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $7CNzt.asciiControl)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $7CNzt.markdownLineEnding)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $7CNzt.markdownLineEndingOrSpace)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $7CNzt.asciiControl)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}

});

parcelRegister("fGzxW", function(module, exports) {

$parcel$export(module.exports, "factoryLabel", () => $b6b65a0ff867bd89$export$7b768614d8ba97a7);
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
var $7CNzt = parcelRequire("7CNzt");
function $b6b65a0ff867bd89$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && "_hiddenFootnoteSupport" in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $7CNzt.markdownLineEnding)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $7CNzt.markdownSpace)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}

});

parcelRegister("4Szc6", function(module, exports) {

$parcel$export(module.exports, "factoryTitle", () => $38d7816807af1f5f$export$f970569cc855e483);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");
function $38d7816807af1f5f$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $ev8OE.factorySpace)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $7CNzt.markdownLineEnding)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}

});

parcelRegister("1UDIw", function(module, exports) {

$parcel$export(module.exports, "factoryWhitespace", () => $1649d46925f03451$export$1f27bd1aa33ce173);
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 
var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");
function $1649d46925f03451$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $7CNzt.markdownSpace)(code)) return (0, $ev8OE.factorySpace)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}

});

parcelRegister("f7Cpv", function(module, exports) {

$parcel$export(module.exports, "normalizeIdentifier", () => $b0254df090fee4b6$export$806d55e226cfcd08);
/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $b0254df090fee4b6$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, "")// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}

});


parcelRegister("c54E7", function(module, exports) {

$parcel$export(module.exports, "hardBreakEscape", () => $8cb98e4506f6ca8b$export$86c573ab9e06f418);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $7CNzt = parcelRequire("7CNzt");
const $8cb98e4506f6ca8b$export$86c573ab9e06f418 = {
    name: "hardBreakEscape",
    tokenize: $8cb98e4506f6ca8b$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8cb98e4506f6ca8b$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

});

parcelRegister("gvquG", function(module, exports) {

$parcel$export(module.exports, "headingAtx", () => $c04417bd9af4357e$export$3871e9deb360695c);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");

var $eyVyf = parcelRequire("eyVyf");
const $c04417bd9af4357e$export$3871e9deb360695c = {
    name: "headingAtx",
    tokenize: $c04417bd9af4357e$var$tokenizeHeadingAtx,
    resolve: $c04417bd9af4357e$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $c04417bd9af4357e$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $eyVyf.splice)(events, contentStart, contentEnd - contentStart + 1, [
            [
                "enter",
                content,
                context
            ],
            [
                "enter",
                text,
                context
            ],
            [
                "exit",
                text,
                context
            ],
            [
                "exit",
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $c04417bd9af4357e$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $7CNzt.markdownLineEndingOrSpace)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $7CNzt.markdownSpace)(code)) return (0, $ev8OE.factorySpace)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $7CNzt.markdownLineEndingOrSpace)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

});

parcelRegister("9ZGfx", function(module, exports) {

$parcel$export(module.exports, "htmlFlow", () => $746a95723689fdc0$export$476ac411cb7d0d8f);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $7CNzt = parcelRequire("7CNzt");

var $9xXKC = parcelRequire("9xXKC");

var $tOvBw = parcelRequire("tOvBw");
const $746a95723689fdc0$export$476ac411cb7d0d8f = {
    name: "htmlFlow",
    tokenize: $746a95723689fdc0$var$tokenizeHtmlFlow,
    resolveTo: $746a95723689fdc0$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $746a95723689fdc0$var$blankLineBefore = {
    tokenize: $746a95723689fdc0$var$tokenizeBlankLineBefore,
    partial: true
};
const $746a95723689fdc0$var$nonLazyContinuationStart = {
    tokenize: $746a95723689fdc0$var$tokenizeNonLazyContinuationStart,
    partial: true
};
/** @type {Resolver} */ function $746a95723689fdc0$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $746a95723689fdc0$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $7CNzt.asciiAlpha)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $7CNzt.asciiAlpha)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $7CNzt.asciiAlpha)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $7CNzt.markdownLineEndingOrSpace)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $9xXKC.htmlRawNames).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $9xXKC.htmlBlockNames).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $7CNzt.asciiAlphanumeric)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $7CNzt.markdownSpace)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $7CNzt.asciiAlpha)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $7CNzt.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $7CNzt.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $7CNzt.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $7CNzt.markdownSpace)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $7CNzt.markdownLineEndingOrSpace)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $7CNzt.markdownSpace)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $7CNzt.markdownSpace)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $7CNzt.markdownLineEnding)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($746a95723689fdc0$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($746a95723689fdc0$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = "";
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $9xXKC.htmlRawNames).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $7CNzt.asciiAlpha)(code) && buffer.length < 8) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $746a95723689fdc0$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $746a95723689fdc0$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $tOvBw.blankLine), ok, nok);
    }
}

});
parcelRegister("9xXKC", function(module, exports) {

$parcel$export(module.exports, "htmlBlockNames", () => $6f358b6d03b5cdd1$export$7364aee1c59d1879);
$parcel$export(module.exports, "htmlRawNames", () => $6f358b6d03b5cdd1$export$948e66da505d080);
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $6f358b6d03b5cdd1$export$7364aee1c59d1879 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
const $6f358b6d03b5cdd1$export$948e66da505d080 = [
    "pre",
    "script",
    "style",
    "textarea"
];

});


parcelRegister("aoUs3", function(module, exports) {

$parcel$export(module.exports, "htmlText", () => $7927ef637e01daf2$export$398af27f284914fe);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");
const $7927ef637e01daf2$export$398af27f284914fe = {
    name: "htmlText",
    tokenize: $7927ef637e01daf2$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7927ef637e01daf2$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $7CNzt.asciiAlpha)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $7CNzt.asciiAlpha)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $7CNzt.asciiAlpha)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $7CNzt.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $7CNzt.markdownSpace)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $7CNzt.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $7CNzt.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $7CNzt.asciiAlpha)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $7CNzt.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $7CNzt.asciiAlphanumeric)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $7CNzt.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $7CNzt.markdownSpace)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $7CNzt.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $7CNzt.markdownLineEndingOrSpace)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $7CNzt.markdownSpace)(code) ? (0, $ev8OE.factorySpace)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

});

parcelRegister("6TDST", function(module, exports) {

$parcel$export(module.exports, "labelEnd", () => $5056d152531e0ca2$export$470a5dafbbf62654);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $3Hx5q = parcelRequire("3Hx5q");

var $fGzxW = parcelRequire("fGzxW");

var $4Szc6 = parcelRequire("4Szc6");

var $1UDIw = parcelRequire("1UDIw");

var $7CNzt = parcelRequire("7CNzt");

var $eyVyf = parcelRequire("eyVyf");

var $f7Cpv = parcelRequire("f7Cpv");

var $9xN1y = parcelRequire("9xN1y");
const $5056d152531e0ca2$export$470a5dafbbf62654 = {
    name: "labelEnd",
    tokenize: $5056d152531e0ca2$var$tokenizeLabelEnd,
    resolveTo: $5056d152531e0ca2$var$resolveToLabelEnd,
    resolveAll: $5056d152531e0ca2$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $5056d152531e0ca2$var$resourceConstruct = {
    tokenize: $5056d152531e0ca2$var$tokenizeResource
};
/** @type {Construct} */ const $5056d152531e0ca2$var$referenceFullConstruct = {
    tokenize: $5056d152531e0ca2$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $5056d152531e0ca2$var$referenceCollapsedConstruct = {
    tokenize: $5056d152531e0ca2$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $5056d152531e0ca2$var$resolveAllLabelEnd(events) {
    let index = -1;
    while(++index < events.length){
        const token = events[index][1];
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $5056d152531e0ca2$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            "enter",
            group,
            context
        ],
        [
            "enter",
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $eyVyf.push)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $eyVyf.push)(media, [
        [
            "enter",
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $eyVyf.push)(media, (0, $9xN1y.resolveAll)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $eyVyf.push)(media, [
        [
            "exit",
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            "exit",
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $eyVyf.push)(media, events.slice(close + 1));
    // Media close.
    media = (0, $eyVyf.push)(media, [
        [
            "exit",
            group,
            context
        ]
    ]);
    (0, $eyVyf.splice)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5056d152531e0ca2$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $f7Cpv.normalizeIdentifier)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($5056d152531e0ca2$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($5056d152531e0ca2$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($5056d152531e0ca2$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5056d152531e0ca2$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $7CNzt.markdownLineEndingOrSpace)(code) ? (0, $1UDIw.factoryWhitespace)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $3Hx5q.factoryDestination)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $7CNzt.markdownLineEndingOrSpace)(code) ? (0, $1UDIw.factoryWhitespace)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $4Szc6.factoryTitle)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $7CNzt.markdownLineEndingOrSpace)(code) ? (0, $1UDIw.factoryWhitespace)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5056d152531e0ca2$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $fGzxW.factoryLabel).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $f7Cpv.normalizeIdentifier)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $5056d152531e0ca2$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

});

parcelRegister("yHswZ", function(module, exports) {

$parcel$export(module.exports, "labelStartImage", () => $0684e32d86aa6d11$export$3d754936e25aa5f5);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $6TDST = parcelRequire("6TDST");
const $0684e32d86aa6d11$export$3d754936e25aa5f5 = {
    name: "labelStartImage",
    tokenize: $0684e32d86aa6d11$var$tokenizeLabelStartImage,
    resolveAll: (0, $6TDST.labelEnd).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0684e32d86aa6d11$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

});

parcelRegister("bBsQL", function(module, exports) {

$parcel$export(module.exports, "labelStartLink", () => $8729876844e9adbb$export$5c0cee0701a3b584);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $6TDST = parcelRequire("6TDST");
const $8729876844e9adbb$export$5c0cee0701a3b584 = {
    name: "labelStartLink",
    tokenize: $8729876844e9adbb$var$tokenizeLabelStartLink,
    resolveAll: (0, $6TDST.labelEnd).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8729876844e9adbb$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

});

parcelRegister("aHvJK", function(module, exports) {

$parcel$export(module.exports, "lineEnding", () => $7ca689d6a4c76d51$export$8e62e0ad51c97b2);
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $ev8OE = parcelRequire("ev8OE");

const $7ca689d6a4c76d51$export$8e62e0ad51c97b2 = {
    name: "lineEnding",
    tokenize: $7ca689d6a4c76d51$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7ca689d6a4c76d51$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $ev8OE.factorySpace)(effects, ok, "linePrefix");
    }
}

});

parcelRegister("b1C7w", function(module, exports) {

$parcel$export(module.exports, "list", () => $806d5b9724b88903$export$8837f4fc672e936d);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");

var $tOvBw = parcelRequire("tOvBw");

var $mfl0x = parcelRequire("mfl0x");
const $806d5b9724b88903$export$8837f4fc672e936d = {
    name: "list",
    tokenize: $806d5b9724b88903$var$tokenizeListStart,
    continuation: {
        tokenize: $806d5b9724b88903$var$tokenizeListContinuation
    },
    exit: $806d5b9724b88903$var$tokenizeListEnd
};
/** @type {Construct} */ const $806d5b9724b88903$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $806d5b9724b88903$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $806d5b9724b88903$var$indentConstruct = {
    tokenize: $806d5b9724b88903$var$tokenizeIndent,
    partial: true
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $806d5b9724b88903$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $7CNzt.asciiDigit)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $mfl0x.thematicBreak), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $7CNzt.asciiDigit)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $tOvBw.blankLine), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($806d5b9724b88903$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $7CNzt.markdownSpace)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $806d5b9724b88903$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $tOvBw.blankLine), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $ev8OE.factorySpace)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $7CNzt.markdownSpace)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($806d5b9724b88903$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $ev8OE.factorySpace)(effects, effects.attempt($806d5b9724b88903$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $806d5b9724b88903$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $ev8OE.factorySpace)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */ function $806d5b9724b88903$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $806d5b9724b88903$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $ev8OE.factorySpace)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $7CNzt.markdownSpace)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

});
parcelRegister("mfl0x", function(module, exports) {

$parcel$export(module.exports, "thematicBreak", () => $042df3f6754eb29e$export$ba7b13e047416c03);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");
const $042df3f6754eb29e$export$ba7b13e047416c03 = {
    name: "thematicBreak",
    tokenize: $042df3f6754eb29e$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $042df3f6754eb29e$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $7CNzt.markdownLineEnding)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $7CNzt.markdownSpace)(code) ? (0, $ev8OE.factorySpace)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}

});


parcelRegister("P6Xqq", function(module, exports) {

$parcel$export(module.exports, "setextUnderline", () => $099a2924cac9de5b$export$e104e2de391dfde9);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");
const $099a2924cac9de5b$export$e104e2de391dfde9 = {
    name: "setextUnderline",
    tokenize: $099a2924cac9de5b$var$tokenizeSetextUnderline,
    resolveTo: $099a2924cac9de5b$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $099a2924cac9de5b$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === "enter") {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            "enter",
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            "exit",
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        "exit",
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $099a2924cac9de5b$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $7CNzt.markdownSpace)(code) ? (0, $ev8OE.factorySpace)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}

});



parcelRegister("eZPmd", function(module, exports) {

$parcel$export(module.exports, "preprocess", () => $aeae99ac838ab329$export$fc37fe19dfda43ee);
/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */ const $aeae99ac838ab329$var$search = /[\0\t\n\r]/g;
function $aeae99ac838ab329$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = "";
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        // @ts-expect-error `Buffer` does allow an encoding.
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = "";
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $aeae99ac838ab329$var$search.lastIndex = startPosition;
            match = $aeae99ac838ab329$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}

});

parcelRegister("4aDOK", function(module, exports) {

$parcel$export(module.exports, "postprocess", () => $3096fb89a15ef632$export$bd0e6e1378a871d7);
/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
var $ebc2E = parcelRequire("ebc2E");
function $3096fb89a15ef632$export$bd0e6e1378a871d7(events) {
    while(!(0, $ebc2E.subtokenize)(events));
    return events;
}

});

parcelRegister("7zorP", function(module, exports) {

$parcel$export(module.exports, "decodeNumericCharacterReference", () => $582ec4189e3de80e$export$15a69557afac2c20);
/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCharCode(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $582ec4189e3de80e$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 /* eslint-enable no-bitwise */  || // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCharCode(code);
}

});

parcelRegister("aF3E2", function(module, exports) {

$parcel$export(module.exports, "decodeString", () => $7c308f82a1081c06$export$a0fb664af7d0cc44);

var $8DqT9 = parcelRequire("8DqT9");

var $7zorP = parcelRequire("7zorP");
const $7c308f82a1081c06$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $7c308f82a1081c06$export$a0fb664af7d0cc44(value) {
    return value.replace($7c308f82a1081c06$var$characterEscapeOrReference, $7c308f82a1081c06$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $7c308f82a1081c06$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $7zorP.decodeNumericCharacterReference)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $8DqT9.decodeNamedCharacterReference)($2) || $0;
}

});



parcelRegister("bvZKa", function(module, exports) {

$parcel$export(module.exports, "default", () => $86227bf80a44ec3d$export$2e2bcd8739ae039);
/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */ 
var $5zygU = parcelRequire("5zygU");
// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(
/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */ const $86227bf80a44ec3d$var$remarkRehype = /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */ function(destination, options) {
    return destination && "run" in destination ? $86227bf80a44ec3d$var$bridge(destination, options) : $86227bf80a44ec3d$var$mutate(destination || options);
};
var $86227bf80a44ec3d$export$2e2bcd8739ae039 = $86227bf80a44ec3d$var$remarkRehype;
/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */ function $86227bf80a44ec3d$var$bridge(destination, options) {
    return (node, file, next)=>{
        destination.run((0, $5zygU.toHast)(node, options), file, (error)=>{
            next(error);
        });
    };
}
/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */ function $86227bf80a44ec3d$var$mutate(options) {
    // @ts-expect-error: assume a corresponding node is returned by `toHast`.
    return (node)=>(0, $5zygU.toHast)(node, options);
}

});
parcelRegister("5zygU", function(module, exports) {

$parcel$export(module.exports, "toHast", () => $40eace4b5c0e3ee4$export$c0e4c5cf07538633);
/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Root} HastRoot
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Root} MdastRoot
 *
 * @typedef {import('./state.js').Options} Options
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 */ 
var $9EFqp = parcelRequire("9EFqp");

var $8MnQO = parcelRequire("8MnQO");
function $40eace4b5c0e3ee4$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $8MnQO.createState)(tree, options);
    const node = state.one(tree, null);
    const foot = (0, $9EFqp.footer)(state);
    if (foot) // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push({
        type: "text",
        value: "\n"
    }, foot);
    // To do: next major: always return root?
    return Array.isArray(node) ? {
        type: "root",
        children: node
    } : node;
}

});
parcelRegister("9EFqp", function(module, exports) {

$parcel$export(module.exports, "footer", () => $7077fb974d94e2cf$export$adb608be33961c98);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ 
var $c6Rt9 = parcelRequire("c6Rt9");
function $7077fb974d94e2cf$export$adb608be33961c98(state) {
    /** @type {Array<ElementContent>} */ const listItems = [];
    let index = -1;
    while(++index < state.footnoteOrder.length){
        const def = state.footnoteById[state.footnoteOrder[index]];
        if (!def) continue;
        const content = state.all(def);
        const id = String(def.identifier).toUpperCase();
        const safeId = (0, $c6Rt9.normalizeUri)(id.toLowerCase());
        let referenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        while(++referenceIndex <= state.footnoteCounts[id]){
            /** @type {Element} */ const backReference = {
                type: "element",
                tagName: "a",
                properties: {
                    href: "#" + state.clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : ""),
                    dataFootnoteBackref: true,
                    className: [
                        "data-footnote-backref"
                    ],
                    ariaLabel: state.footnoteBackLabel
                },
                children: [
                    {
                        type: "text",
                        value: "\u21A9"
                    }
                ]
            };
            if (referenceIndex > 1) backReference.children.push({
                type: "element",
                tagName: "sup",
                children: [
                    {
                        type: "text",
                        value: String(referenceIndex)
                    }
                ]
            });
            if (backReferences.length > 0) backReferences.push({
                type: "text",
                value: " "
            });
            backReferences.push(backReference);
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === "element" && tail.tagName === "p") {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === "text") tailTail.value += " ";
            else tail.children.push({
                type: "text",
                value: " "
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: "element",
            tagName: "li",
            properties: {
                id: state.clobberPrefix + "fn-" + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(def, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: "element",
        tagName: "section",
        properties: {
            dataFootnotes: true,
            className: [
                "footnotes"
            ]
        },
        children: [
            {
                type: "element",
                tagName: state.footnoteLabelTagName,
                properties: {
                    // To do: use structured clone.
                    ...JSON.parse(JSON.stringify(state.footnoteLabelProperties)),
                    id: "footnote-label"
                },
                children: [
                    {
                        type: "text",
                        value: state.footnoteLabel
                    }
                ]
            },
            {
                type: "text",
                value: "\n"
            },
            {
                type: "element",
                tagName: "ol",
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: "text",
                value: "\n"
            }
        ]
    };
}

});
parcelRegister("c6Rt9", function(module, exports) {

$parcel$export(module.exports, "sanitizeUri", () => $8d0f856ba36b497f$export$d130a2d684099e5a);
$parcel$export(module.exports, "normalizeUri", () => $8d0f856ba36b497f$export$e42a3e39590d28b5);

var $7CNzt = parcelRequire("7CNzt");

var $7I53f = parcelRequire("7I53f");
function $8d0f856ba36b497f$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $7I53f.encode)($8d0f856ba36b497f$export$e42a3e39590d28b5(url || ""));
    if (!protocol) return value;
    const colon = value.indexOf(":");
    const questionMark = value.indexOf("?");
    const numberSign = value.indexOf("#");
    const slash = value.indexOf("/");
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return "";
}
function $8d0f856ba36b497f$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = "";
        // A correct percent encoded value.
        if (code === 37 && (0, $7CNzt.asciiAlphanumeric)(value.charCodeAt(index + 1)) && (0, $7CNzt.asciiAlphanumeric)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = "";
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join("") + value.slice(start);
}

});
parcelRegister("7I53f", function(module, exports) {

$parcel$export(module.exports, "encode", () => $59d08f926895426a$export$c564cdbbe6da493);
const $59d08f926895426a$var$characterReferences = {
    '"': "quot",
    "&": "amp",
    "<": "lt",
    ">": "gt"
};
function $59d08f926895426a$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return "&" + $59d08f926895426a$var$characterReferences[value] + ";";
    }
}

});



parcelRegister("8MnQO", function(module, exports) {

$parcel$export(module.exports, "createState", () => $66454eb1743b12cb$export$e6a0daad8304de);
/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} MdastRoot
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 * @typedef {Extract<MdastNodes, MdastParent>} MdastParents
 *
 * @typedef EmbeddedHastFields
 *   hast fields.
 * @property {string | null | undefined} [hName]
 *   Generate a specific element with this tag name instead.
 * @property {HastProperties | null | undefined} [hProperties]
 *   Generate an element with these properties instead.
 * @property {Array<HastElementContent> | null | undefined} [hChildren]
 *   Generate an element with this content instead.
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} MdastData
 *   mdast data with embedded hast fields.
 *
 * @typedef {MdastNodes & {data?: MdastData | null | undefined}} MdastNodeWithData
 *   mdast node with embedded hast data.
 *
 * @typedef PointLike
 *   Point-like value.
 * @property {number | null | undefined} [line]
 *   Line.
 * @property {number | null | undefined} [column]
 *   Column.
 * @property {number | null | undefined} [offset]
 *   Offset.
 *
 * @typedef PositionLike
 *   Position-like value.
 * @property {PointLike | null | undefined} [start]
 *   Point-like value.
 * @property {PointLike | null | undefined} [end]
 *   Point-like value.
 *
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | null | undefined} parent
 *   Parent of `node`.
 * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
 *   hast node.
 *
 * @callback HFunctionProps
 *   Signature of `state` for when props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {HastProperties} props
 *   Properties.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @callback HFunctionNoProps
 *   Signature of `state` for when no props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @typedef HFields
 *   Info on `state`.
 * @property {boolean} dangerous
 *   Whether HTML is allowed.
 * @property {string} clobberPrefix
 *   Prefix to use to prevent DOM clobbering.
 * @property {string} footnoteLabel
 *   Label to use to introduce the footnote section.
 * @property {string} footnoteLabelTagName
 *   HTML used for the footnote label.
 * @property {HastProperties} footnoteLabelProperties
 *   Properties on the HTML tag used for the footnote label.
 * @property {string} footnoteBackLabel
 *   Label to use from backreferences back to their footnote call.
 * @property {(identifier: string) => MdastDefinition | null} definition
 *   Definition cache.
 * @property {Record<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Record<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {Handler} unknownHandler
 *   Handler for any none not in `passThrough` or otherwise handled.
 * @property {(from: MdastNodes, node: HastNodes) => void} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => Type | HastElement} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {(node: MdastNodes, parent: MdastParents | null | undefined) => HastElementContent | Array<HastElementContent> | null | undefined} one
 *   Transform an mdast node to hast.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastContent>(nodes: Array<Type>, loose?: boolean | null | undefined) => Array<Type | HastText>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 * @property {(left: MdastNodeWithData | PositionLike | null | undefined, right: HastElementContent) => HastElementContent} augment
 *   Like `state` but lower-level and usable on non-elements.
 *   Deprecated: use `patch` and `applyData`.
 * @property {Array<string>} passThrough
 *   List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree.
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent it from
 *   *clobbering*.
 * @property {string | null | undefined} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call (affects
 *   screen readers).
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section (affects screen readers).
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (note that `id: 'footnote-label'`
 *   is always added as footnote calls use it with `aria-describedby` to
 *   provide an accessible label).
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   Tag name to use for the footnote label.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes.
 * @property {Array<string> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Handle nodes.
 *
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} State
 *   Info passed around.
 */ 
var $2glrV = parcelRequire("2glrV");

var $5KHdK = parcelRequire("5KHdK");

var $1akdw = parcelRequire("1akdw");

var $6BpEK = parcelRequire("6BpEK");

var $fdPuE = parcelRequire("fdPuE");
const $66454eb1743b12cb$var$own = {}.hasOwnProperty;
function $66454eb1743b12cb$export$e6a0daad8304de(tree, options) {
    const settings = options || {};
    const dangerous = settings.allowDangerousHtml || false;
    /** @type {Record<string, MdastFootnoteDefinition>} */ const footnoteById = {};
    // To do: next major: add `options` to state, remove:
    // `dangerous`, `clobberPrefix`, `footnoteLabel`, `footnoteLabelTagName`,
    // `footnoteLabelProperties`, `footnoteBackLabel`, `passThrough`,
    // `unknownHandler`.
    // To do: next major: move to `state.options.allowDangerousHtml`.
    state.dangerous = dangerous;
    // To do: next major: move to `state.options`.
    state.clobberPrefix = settings.clobberPrefix === undefined || settings.clobberPrefix === null ? "user-content-" : settings.clobberPrefix;
    // To do: next major: move to `state.options`.
    state.footnoteLabel = settings.footnoteLabel || "Footnotes";
    // To do: next major: move to `state.options`.
    state.footnoteLabelTagName = settings.footnoteLabelTagName || "h2";
    // To do: next major: move to `state.options`.
    state.footnoteLabelProperties = settings.footnoteLabelProperties || {
        className: [
            "sr-only"
        ]
    };
    // To do: next major: move to `state.options`.
    state.footnoteBackLabel = settings.footnoteBackLabel || "Back to content";
    // To do: next major: move to `state.options`.
    state.unknownHandler = settings.unknownHandler;
    // To do: next major: move to `state.options`.
    state.passThrough = settings.passThrough;
    state.handlers = {
        ...(0, $fdPuE.handlers),
        ...settings.handlers
    };
    // To do: next major: replace utility with `definitionById` object, so we
    // only walk once (as we need footnotes too).
    state.definition = (0, $6BpEK.definitions)(tree);
    state.footnoteById = footnoteById;
    /** @type {Array<string>} */ state.footnoteOrder = [];
    /** @type {Record<string, number>} */ state.footnoteCounts = {};
    state.patch = $66454eb1743b12cb$var$patch;
    state.applyData = $66454eb1743b12cb$var$applyData;
    state.one = oneBound;
    state.all = allBound;
    state.wrap = $66454eb1743b12cb$export$4997ffc0176396a6;
    // To do: next major: remove `augment`.
    state.augment = augment;
    (0, $2glrV.visit)(tree, "footnoteDefinition", (definition)=>{
        const id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$66454eb1743b12cb$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    });
    // @ts-expect-error Hush, it’s fine!
    return state;
    /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   *
   * @param {MdastNodeWithData | PositionLike | null | undefined} left
   * @param {HastElementContent} right
   * @returns {HastElementContent}
   */ /* c8 ignore start */ // To do: next major: remove.
    function augment(left, right) {
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && "data" in left && left.data) {
            /** @type {MdastData} */ const data = left.data;
            if (data.hName) {
                if (right.type !== "element") right = {
                    type: "element",
                    tagName: "",
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === "element" && data.hProperties) right.properties = {
                ...right.properties,
                ...data.hProperties
            };
            if ("children" in right && right.children && data.hChildren) right.children = data.hChildren;
        }
        if (left) {
            const ctx = "type" in left ? left : {
                position: left
            };
            if (!(0, $1akdw.generated)(ctx)) // @ts-expect-error: fine.
            right.position = {
                start: (0, $5KHdK.pointStart)(ctx),
                end: (0, $5KHdK.pointEnd)(ctx)
            };
        }
        return right;
    }
    /* c8 ignore stop */ /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */ /* c8 ignore start */ // To do: next major: remove.
    function state(node, tagName, props, children) {
        if (Array.isArray(props)) {
            children = props;
            props = {};
        }
        // @ts-expect-error augmenting an element yields an element.
        return augment(node, {
            type: "element",
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    /* c8 ignore stop */ /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | null | undefined} [parent]
   *   Parent of `node`.
   * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
   *   Resulting hast node.
   */ function oneBound(node, parent) {
        // @ts-expect-error: that’s a state :)
        return $66454eb1743b12cb$export$80bf7733f1207381(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function allBound(parent) {
        // @ts-expect-error: that’s a state :)
        return $66454eb1743b12cb$export$84bf76cd7afc7469(state, parent);
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {void}
 *   Nothing.
 */ function $66454eb1743b12cb$var$patch(from, to) {
    if (from.position) to.position = (0, $5KHdK.position)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {Type | HastElement}
 *   Nothing.
 */ function $66454eb1743b12cb$var$applyData(from, to) {
    /** @type {Type | HastElement} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === "string") {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === "element") result.tagName = hName;
            else result = {
                type: "element",
                tagName: hName,
                properties: {},
                children: []
            };
        }
        if (result.type === "element" && hProperties) result.properties = {
            ...result.properties,
            ...hProperties
        };
        if ("children" in result && result.children && hChildren !== null && hChildren !== undefined) // @ts-expect-error: assume valid children are defined.
        result.children = hChildren;
    }
    return result;
}
function $66454eb1743b12cb$export$80bf7733f1207381(state, node, parent) {
    const type = node && node.type;
    // Fail on non-nodes.
    if (!type) throw new Error("Expected node, got `" + node + "`");
    if ($66454eb1743b12cb$var$own.call(state.handlers, type)) return state.handlers[type](state, node, parent);
    if (state.passThrough && state.passThrough.includes(type)) // To do: next major: deep clone.
    // @ts-expect-error: types of passed through nodes are expected to be added manually.
    return "children" in node ? {
        ...node,
        children: $66454eb1743b12cb$export$84bf76cd7afc7469(state, node)
    } : node;
    if (state.unknownHandler) return state.unknownHandler(state, node, parent);
    return $66454eb1743b12cb$var$defaultUnknownHandler(state, node);
}
function $66454eb1743b12cb$export$84bf76cd7afc7469(state, parent) {
    /** @type {Array<HastElementContent>} */ const values = [];
    if ("children" in parent) {
        const nodes = parent.children;
        let index = -1;
        while(++index < nodes.length){
            const result = $66454eb1743b12cb$export$80bf7733f1207381(state, nodes[index], parent);
            // To do: see if we van clean this? Can we merge texts?
            if (result) {
                if (index && nodes[index - 1].type === "break") {
                    if (!Array.isArray(result) && result.type === "text") result.value = result.value.replace(/^\s+/, "");
                    if (!Array.isArray(result) && result.type === "element") {
                        const head = result.children[0];
                        if (head && head.type === "text") head.value = head.value.replace(/^\s+/, "");
                    }
                }
                if (Array.isArray(result)) values.push(...result);
                else values.push(result);
            }
        }
    }
    return values;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastText | HastElement}
 *   Resulting hast node.
 */ function $66454eb1743b12cb$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastText | HastElement} */ const result = "value" in node && !($66454eb1743b12cb$var$own.call(data, "hProperties") || $66454eb1743b12cb$var$own.call(data, "hChildren")) ? {
        type: "text",
        value: node.value
    } : {
        type: "element",
        tagName: "div",
        properties: {},
        children: $66454eb1743b12cb$export$84bf76cd7afc7469(state, node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $66454eb1743b12cb$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<Type | HastText>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: "text",
        value: "\n"
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: "text",
            value: "\n"
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: "text",
        value: "\n"
    });
    return result;
}

});
parcelRegister("2glrV", function(module, exports) {

$parcel$export(module.exports, "visit", () => $1a5db6d305787a11$export$bf638b60ea8b89b7);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * Check if `Child` can be a child of `Ancestor`.
 *
 * Returns the ancestor when `Child` can be a child of `Ancestor`, or returns
 * `never`.
 *
 * @template {Node} Ancestor
 *   Node type.
 * @template {Node} Child
 *   Node type.
 * @typedef {(
 *   Ancestor extends Parent
 *     ? Child extends Ancestor['children'][number]
 *       ? Ancestor
 *       : never
 *     : never
 * )} ParentsOf
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends Node ? number | null : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends Node ? Ancestor | null : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * Build a typed `Visitor` function from a node and all possible parents.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Visited
 *   Node type.
 * @template {Parent} Ancestor
 *   Parent type.
 * @typedef {Visitor<Visited, ParentsOf<Ancestor, Visited>>} BuildVisitorFromMatch
 */ /**
 * Build a typed `Visitor` function from a list of descendants and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     import('unist-util-visit-parents/complex-types.js').Matches<Descendant, Check>,
 *     Extract<Descendant, Parent>
 *   >
 * )} BuildVisitorFromDescendants
 */ /**
 * Build a typed `Visitor` function from a tree and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} [Tree=Node]
 *   Node type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     import('unist-util-visit-parents/complex-types.js').InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 */ 
var $9tBQd = parcelRequire("9tBQd");
const $1a5db6d305787a11$export$bf638b60ea8b89b7 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    (0, $9tBQd.visitParents)(tree, test, overload, reverse);
    /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        return visitor(node, parent ? parent.children.indexOf(node) : null, parent);
    }
};

});
parcelRegister("9tBQd", function(module, exports) {

$parcel$export(module.exports, "visitParents", () => $6e642cfbe6400578$export$70008a21eb6de899);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */ /**
 * @typedef {boolean | 'skip'} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<Ancestor>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * @template {Node} [Tree=Node]
 *   Tree type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {Visitor<import('./complex-types.js').Matches<import('./complex-types.js').InclusiveDescendant<Tree>, Check>, Extract<import('./complex-types.js').InclusiveDescendant<Tree>, Parent>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 */ 
var $j19vp = parcelRequire("j19vp");

var $aGUvR = parcelRequire("aGUvR");
const $6e642cfbe6400578$export$f4d8133c446fe484 = true;
const $6e642cfbe6400578$export$7f100f842f565dc9 = false;
const $6e642cfbe6400578$export$8773f85c2fb2c116 = "skip";
const $6e642cfbe6400578$export$70008a21eb6de899 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor<Node>} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
    }
    const is = (0, $j19vp.convert)(test);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
       * @param {Node} node
       * @param {number | undefined} index
       * @param {Array<Parent>} parents
       */ function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */ // @ts-expect-error: hush
        const value = node && typeof node === "object" ? node : {};
        if (typeof value.type === "string") {
            const name = // `hast`
            typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            Object.defineProperty(visit, "name", {
                value: "node (" + (0, $aGUvR.color)(node.type + (name ? "<" + name + ">" : "")) + ")"
            });
        }
        return visit;
        function visit() {
            /** @type {ActionTuple} */ let result = [];
            /** @type {ActionTuple} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<Parent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $6e642cfbe6400578$var$toResult(visitor(node, parents));
                if (result[0] === $6e642cfbe6400578$export$7f100f842f565dc9) return result;
            }
            // @ts-expect-error looks like a parent.
            if (node.children && result[0] !== $6e642cfbe6400578$export$8773f85c2fb2c116) {
                // @ts-expect-error looks like a parent.
                offset = (reverse ? node.children.length : -1) + step;
                // @ts-expect-error looks like a parent.
                grandparents = parents.concat(node);
                // @ts-expect-error looks like a parent.
                while(offset > -1 && offset < node.children.length){
                    // @ts-expect-error looks like a parent.
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $6e642cfbe6400578$export$7f100f842f565dc9) return subresult;
                    offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
};
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */ function $6e642cfbe6400578$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === "number") return [
        $6e642cfbe6400578$export$f4d8133c446fe484,
        value
    ];
    return [
        value
    ];
}

});
parcelRegister("j19vp", function(module, exports) {

$parcel$export(module.exports, "convert", () => $dd857bf28ad9ad3d$export$9c68d69a4c5bbcf9);
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @typedef {Record<string, unknown>} Props
 * @typedef {null | undefined | string | Props | TestFunctionAnything | Array<string | Props | TestFunctionAnything>} Test
 *   Check for an arbitrary node, unaware of TypeScript inferral.
 *
 * @callback TestFunctionAnything
 *   Check if a node passes a test, unaware of TypeScript inferral.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | void}
 *   Whether this node passes the test.
 */ /**
 * @template {Node} Kind
 *   Node type.
 * @typedef {Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind> | Array<Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind>>} PredicateTest
 *   Check for a node that can be inferred by TypeScript.
 */ /**
 * Check if a node passes a certain test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback TestFunctionPredicate
 *   Complex test function for a node that can be inferred by TypeScript.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this node passes the test.
 */ /**
 * @callback AssertAnything
 *   Check that an arbitrary value is a node, unaware of TypeScript inferral.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if a node is a node and passes a certain node test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback AssertPredicate
 *   Check that an arbitrary value is a specific node, aware of TypeScript.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param node
 *   Thing to check, typically `Node`.
 * @param test
 *   A check for a specific node.
 * @param index
 *   The node’s position in its parent.
 * @param parent
 *   The node’s parent.
 * @returns
 *   Whether `node` is a node and passes a test.
 */ const $dd857bf28ad9ad3d$export$226b3eccf92c9ed9 = /**
   * @type {(
   *   (() => false) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index: number, parent: Parent, context?: unknown) => node is Kind) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index?: null | undefined, parent?: null | undefined, context?: unknown) => node is Kind) &
   *   ((node: unknown, test: Test, index: number, parent: Parent, context?: unknown) => boolean) &
   *   ((node: unknown, test?: Test, index?: null | undefined, parent?: null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function is(node, test, index, parent, context) {
    const check = $dd857bf28ad9ad3d$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== "number" || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error("Expected positive finite index");
    if (parent !== undefined && parent !== null && (!is(parent) || !parent.children)) throw new Error("Expected parent node");
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error("Expected both parent and index");
    // @ts-expect-error Looks like a node.
    return node && node.type && typeof node.type === "string" ? Boolean(check.call(context, node, index, parent)) : false;
};
const $dd857bf28ad9ad3d$export$9c68d69a4c5bbcf9 = /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {AssertAnything}
     */ function(test) {
    if (test === undefined || test === null) return $dd857bf28ad9ad3d$var$ok;
    if (typeof test === "string") return $dd857bf28ad9ad3d$var$typeFactory(test);
    if (typeof test === "object") return Array.isArray(test) ? $dd857bf28ad9ad3d$var$anyFactory(test) : $dd857bf28ad9ad3d$var$propsFactory(test);
    if (typeof test === "function") return $dd857bf28ad9ad3d$var$castFactory(test);
    throw new Error("Expected function, string, or object as test");
};
/**
 * @param {Array<string | Props | TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */ function $dd857bf28ad9ad3d$var$anyFactory(tests) {
    /** @type {Array<AssertAnything>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $dd857bf28ad9ad3d$export$9c68d69a4c5bbcf9(tests[index]);
    return $dd857bf28ad9ad3d$var$castFactory(any);
    /**
   * @this {unknown}
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].call(this, ...parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */ function $dd857bf28ad9ad3d$var$propsFactory(check) {
    return $dd857bf28ad9ad3d$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        /** @type {string} */ let key;
        for(key in check){
            // @ts-expect-error: hush, it sure works as an index.
            if (node[key] !== check[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {AssertAnything}
 */ function $dd857bf28ad9ad3d$var$typeFactory(check) {
    return $dd857bf28ad9ad3d$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */ function $dd857bf28ad9ad3d$var$castFactory(check) {
    return assertion;
    /**
   * @this {unknown}
   * @param {unknown} node
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function assertion(node, ...parameters) {
        return Boolean(node && typeof node === "object" && "type" in node && // @ts-expect-error: fine.
        Boolean(check.call(this, node, ...parameters)));
    }
}
function $dd857bf28ad9ad3d$var$ok() {
    return true;
}

});

parcelRegister("aGUvR", function(module, exports) {

$parcel$export(module.exports, "color", () => $7c89a9e917ca2266$export$35e9368ef982300f);
/**
 * @param {string} d
 * @returns {string}
 */ function $7c89a9e917ca2266$export$35e9368ef982300f(d) {
    return d;
}

});



parcelRegister("5KHdK", function(module, exports) {

$parcel$export(module.exports, "pointStart", () => $4302c658a91ca3ed$export$771bf3e4949bfbee);
$parcel$export(module.exports, "pointEnd", () => $4302c658a91ca3ed$export$da309cdce9dc2a25);
$parcel$export(module.exports, "position", () => $4302c658a91ca3ed$export$5880b8b5730aff45);
/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $4302c658a91ca3ed$export$771bf3e4949bfbee = $4302c658a91ca3ed$var$point("start");
const $4302c658a91ca3ed$export$da309cdce9dc2a25 = $4302c658a91ca3ed$var$point("end");
function $4302c658a91ca3ed$export$5880b8b5730aff45(node) {
    return {
        start: $4302c658a91ca3ed$export$771bf3e4949bfbee(node),
        end: $4302c658a91ca3ed$export$da309cdce9dc2a25(node)
    };
}
/**
 * Get the positional info of `node`.
 *
 * @param {'start' | 'end'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $4302c658a91ca3ed$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {NodeLike | Node | null | undefined} [node]
   * @returns {Point}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        // To do: next major: don’t return points when invalid.
        return {
            // @ts-expect-error: in practice, null is allowed.
            line: point.line || null,
            // @ts-expect-error: in practice, null is allowed.
            column: point.column || null,
            // @ts-expect-error: in practice, null is allowed.
            offset: point.offset > -1 ? point.offset : null
        };
    }
}

});

parcelRegister("1akdw", function(module, exports) {

$parcel$export(module.exports, "generated", () => $0d96684b6260623f$export$41ad1363166ec91a);
/**
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef NodeLike
 * @property {PositionLike | null | undefined} [position]
 */ /**
 * Check if `node` is generated.
 *
 * @param {NodeLike | null | undefined} [node]
 *   Node to check.
 * @returns {boolean}
 *   Whether `node` is generated (does not have positional info).
 */ function $0d96684b6260623f$export$41ad1363166ec91a(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}

});

parcelRegister("6BpEK", function(module, exports) {

$parcel$export(module.exports, "definitions", () => $4cea198cf14ecedd$export$d79264f26953ec1);
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Definition} Definition
 */ /**
 * @typedef {Root | Content} Node
 *
 * @callback GetDefinition
 *   Get a definition by identifier.
 * @param {string | null | undefined} [identifier]
 *   Identifier of definition.
 * @returns {Definition | null}
 *   Definition corresponding to `identifier` or `null`.
 */ 
var $2glrV = parcelRequire("2glrV");
const $4cea198cf14ecedd$var$own = {}.hasOwnProperty;
function $4cea198cf14ecedd$export$d79264f26953ec1(tree) {
    /** @type {Record<string, Definition>} */ const cache = Object.create(null);
    if (!tree || !tree.type) throw new Error("mdast-util-definitions expected node");
    (0, $2glrV.visit)(tree, "definition", (definition)=>{
        const id = $4cea198cf14ecedd$var$clean(definition.identifier);
        if (id && !$4cea198cf14ecedd$var$own.call(cache, id)) cache[id] = definition;
    });
    return definition;
    /** @type {GetDefinition} */ function definition(identifier) {
        const id = $4cea198cf14ecedd$var$clean(identifier);
        // To do: next major: return `undefined` when not found.
        return id && $4cea198cf14ecedd$var$own.call(cache, id) ? cache[id] : null;
    }
}
/**
 * @param {string | null | undefined} [value]
 * @returns {string}
 */ function $4cea198cf14ecedd$var$clean(value) {
    return String(value || "").toUpperCase();
}

});

parcelRegister("fdPuE", function(module, exports) {

$parcel$export(module.exports, "handlers", () => $b150037042dc6f5f$export$455ce229eb3d2472);

var $dVlk4 = parcelRequire("dVlk4");

var $ct5Pm = parcelRequire("ct5Pm");

var $9zPir = parcelRequire("9zPir");

var $2idPE = parcelRequire("2idPE");

var $8BiMH = parcelRequire("8BiMH");

var $6TVmq = parcelRequire("6TVmq");

var $kIurI = parcelRequire("kIurI");

var $9HoyR = parcelRequire("9HoyR");

var $dnvA3 = parcelRequire("dnvA3");

var $6R5m9 = parcelRequire("6R5m9");

var $9kK0A = parcelRequire("9kK0A");

var $j2Utq = parcelRequire("j2Utq");

var $8fVWw = parcelRequire("8fVWw");

var $8dkg1 = parcelRequire("8dkg1");

var $l8pRq = parcelRequire("l8pRq");

var $ePrzN = parcelRequire("ePrzN");

var $btBNI = parcelRequire("btBNI");

var $l4Lbh = parcelRequire("l4Lbh");

var $bbUo8 = parcelRequire("bbUo8");

var $9dHzP = parcelRequire("9dHzP");

var $5ffe8 = parcelRequire("5ffe8");

var $fNMDO = parcelRequire("fNMDO");

var $g5Oob = parcelRequire("g5Oob");

var $33kGw = parcelRequire("33kGw");
const $b150037042dc6f5f$export$455ce229eb3d2472 = {
    blockquote: $dVlk4.blockquote,
    break: (0, $ct5Pm.hardBreak),
    code: $9zPir.code,
    delete: (0, $2idPE.strikethrough),
    emphasis: $8BiMH.emphasis,
    footnoteReference: $6TVmq.footnoteReference,
    footnote: $kIurI.footnote,
    heading: $9HoyR.heading,
    html: $dnvA3.html,
    imageReference: $6R5m9.imageReference,
    image: $9kK0A.image,
    inlineCode: $j2Utq.inlineCode,
    linkReference: $8fVWw.linkReference,
    link: $8dkg1.link,
    listItem: $l8pRq.listItem,
    list: $ePrzN.list,
    paragraph: $btBNI.paragraph,
    root: $l4Lbh.root,
    strong: $bbUo8.strong,
    table: $9dHzP.table,
    tableCell: $fNMDO.tableCell,
    tableRow: $5ffe8.tableRow,
    text: $g5Oob.text,
    thematicBreak: $33kGw.thematicBreak,
    toml: $b150037042dc6f5f$var$ignore,
    yaml: $b150037042dc6f5f$var$ignore,
    definition: $b150037042dc6f5f$var$ignore,
    footnoteDefinition: $b150037042dc6f5f$var$ignore
};
// Return nothing for nodes that are ignored.
function $b150037042dc6f5f$var$ignore() {
    // To do: next major: return `undefined`.
    return null;
}

});
parcelRegister("dVlk4", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $a23123797a0b91ba$export$67dc04e652a298ca);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $a23123797a0b91ba$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "blockquote",
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("ct5Pm", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $913cb6adeee96b81$export$371da9dd35aba193);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $913cb6adeee96b81$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "br",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: "text",
            value: "\n"
        }
    ];
}

});

parcelRegister("9zPir", function(module, exports) {

$parcel$export(module.exports, "code", () => $6f8f2c58b361c0e8$export$6565f9f03506010b);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $6f8f2c58b361c0e8$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + "\n" : "";
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    const lang = node.lang ? node.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null;
    /** @type {Properties} */ const properties = {};
    if (lang) properties.className = [
        "language-" + lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: "element",
        tagName: "code",
        properties: properties,
        children: [
            {
                type: "text",
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: "element",
        tagName: "pre",
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}

});

parcelRegister("2idPE", function(module, exports) {

$parcel$export(module.exports, "strikethrough", () => $1ab7fdfada5e0de3$export$19426ff118fe8be);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $1ab7fdfada5e0de3$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "del",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("8BiMH", function(module, exports) {

$parcel$export(module.exports, "emphasis", () => $643059a668260166$export$bef81ba411953b51);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $643059a668260166$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "em",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("6TVmq", function(module, exports) {

$parcel$export(module.exports, "footnoteReference", () => $50645fcb625d29b8$export$7f87ee744075c1ba);
/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('hast').Element} Element
 * @typedef {import('../state.js').State} State
 */ 
var $c6Rt9 = parcelRequire("c6Rt9");
function $50645fcb625d29b8$export$7f87ee744075c1ba(state, node) {
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $c6Rt9.normalizeUri)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    if (index === -1) {
        state.footnoteOrder.push(id);
        state.footnoteCounts[id] = 1;
        counter = state.footnoteOrder.length;
    } else {
        state.footnoteCounts[id]++;
        counter = index + 1;
    }
    const reuseCounter = state.footnoteCounts[id];
    /** @type {Element} */ const link = {
        type: "element",
        tagName: "a",
        properties: {
            href: "#" + state.clobberPrefix + "fn-" + safeId,
            id: state.clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : ""),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                "footnote-label"
            ]
        },
        children: [
            {
                type: "text",
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: "element",
        tagName: "sup",
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}

});

parcelRegister("kIurI", function(module, exports) {

$parcel$export(module.exports, "footnote", () => $f14f88a68b769813$export$3b6a720baa2c20ec);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../state.js').State} State
 */ 
var $6TVmq = parcelRequire("6TVmq");
function $f14f88a68b769813$export$3b6a720baa2c20ec(state, node) {
    const footnoteById = state.footnoteById;
    let no = 1;
    while(no in footnoteById)no++;
    const identifier = String(no);
    footnoteById[identifier] = {
        type: "footnoteDefinition",
        identifier: identifier,
        children: [
            {
                type: "paragraph",
                children: node.children
            }
        ],
        position: node.position
    };
    return (0, $6TVmq.footnoteReference)(state, {
        type: "footnoteReference",
        identifier: identifier,
        position: node.position
    });
}

});

parcelRegister("9HoyR", function(module, exports) {

$parcel$export(module.exports, "heading", () => $70fb2e910f8f7ace$export$46e4a324ac90507f);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $70fb2e910f8f7ace$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "h" + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("dnvA3", function(module, exports) {

$parcel$export(module.exports, "html", () => $9bd5eb9607a1f986$export$c0bb0b647f701bb5);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').HTML} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Raw | Element | null}
 *   hast node.
 */ function $9bd5eb9607a1f986$export$c0bb0b647f701bb5(state, node) {
    if (state.dangerous) {
        /** @type {Raw} */ const result = {
            type: "raw",
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    // To do: next major: return `undefined`.
    return null;
}

});

parcelRegister("6R5m9", function(module, exports) {

$parcel$export(module.exports, "imageReference", () => $4fdbd8f920ef95cc$export$f281796f6bc3b8db);
/**
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
var $c6Rt9 = parcelRequire("c6Rt9");

var $fC4LM = parcelRequire("fC4LM");
function $4fdbd8f920ef95cc$export$f281796f6bc3b8db(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $fC4LM.revert)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $c6Rt9.normalizeUri)(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});
parcelRegister("fC4LM", function(module, exports) {

$parcel$export(module.exports, "revert", () => $b5de1aca3ee16dfa$export$3fdd26f3d9e7dc78);
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Reference} Reference
 * @typedef {import('mdast').Root} Root
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Reference>} References
 */ // To do: next major: always return array.
/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {References} node
 *   Reference node (image, link).
 * @returns {ElementContent | Array<ElementContent>}
 *   hast content.
 */ function $b5de1aca3ee16dfa$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = "]";
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return {
        type: "text",
        value: "![" + node.alt + suffix
    };
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift({
        type: "text",
        value: "["
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push({
        type: "text",
        value: suffix
    });
    return contents;
}

});


parcelRegister("9kK0A", function(module, exports) {

$parcel$export(module.exports, "image", () => $6cb9ab9fc6f039c4$export$5c452ff88e35e47d);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
var $c6Rt9 = parcelRequire("c6Rt9");
function $6cb9ab9fc6f039c4$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $c6Rt9.normalizeUri)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("j2Utq", function(module, exports) {

$parcel$export(module.exports, "inlineCode", () => $ddda02b913dce350$export$91b9bee19a0d8569);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $ddda02b913dce350$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: "text",
        value: node.value.replace(/\r?\n|\r/g, " ")
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "code",
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("8fVWw", function(module, exports) {

$parcel$export(module.exports, "linkReference", () => $602cabb1d4eb6358$export$e6c469b1b7b2bc6a);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 
var $c6Rt9 = parcelRequire("c6Rt9");

var $fC4LM = parcelRequire("fC4LM");
function $602cabb1d4eb6358$export$e6c469b1b7b2bc6a(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $fC4LM.revert)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $c6Rt9.normalizeUri)(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("8dkg1", function(module, exports) {

$parcel$export(module.exports, "link", () => $5faf40544bd8c4c7$export$9c30223ca0a664fb);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
var $c6Rt9 = parcelRequire("c6Rt9");
function $5faf40544bd8c4c7$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $c6Rt9.normalizeUri)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("l8pRq", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $f62e67b86a3357a8$export$76c7e83ecc9cdf05);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $f62e67b86a3357a8$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $f62e67b86a3357a8$var$listLoose(parent) : $f62e67b86a3357a8$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === "boolean") {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === "element" && head.tagName === "p") paragraph = head;
        else {
            paragraph = {
                type: "element",
                tagName: "p",
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: "text",
            value: " "
        });
        paragraph.children.unshift({
            type: "element",
            tagName: "input",
            properties: {
                type: "checkbox",
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            "task-list-item"
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== "element" || child.tagName !== "p") children.push({
            type: "text",
            value: "\n"
        });
        if (child.type === "element" && child.tagName === "p" && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== "element" || tail.tagName !== "p")) children.push({
        type: "text",
        value: "\n"
    });
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "li",
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $f62e67b86a3357a8$var$listLoose(node) {
    let loose = false;
    if (node.type === "list") {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $f62e67b86a3357a8$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $f62e67b86a3357a8$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}

});

parcelRegister("ePrzN", function(module, exports) {

$parcel$export(module.exports, "list", () => $acbb383858624a73$export$8837f4fc672e936d);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $acbb383858624a73$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === "number" && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === "element" && child.tagName === "li" && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes("task-list-item")) {
            properties.className = [
                "contains-task-list"
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: node.ordered ? "ol" : "ul",
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("btBNI", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $85afb99e2976c0d7$export$9c206ddddb32a9b);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $85afb99e2976c0d7$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "p",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("l4Lbh", function(module, exports) {

$parcel$export(module.exports, "root", () => $f57e91d960c39c1b$export$e8e78c978b129247);
/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastRoot | HastElement}
 *   hast node.
 */ function $f57e91d960c39c1b$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: "root",
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("bbUo8", function(module, exports) {

$parcel$export(module.exports, "strong", () => $825c764d1138b693$export$59ae2c325a998f89);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $825c764d1138b693$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "strong",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("9dHzP", function(module, exports) {

$parcel$export(module.exports, "table", () => $6b67216b1c102b37$export$9852986a3ec5f6a0);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
var $5KHdK = parcelRequire("5KHdK");
function $6b67216b1c102b37$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: "element",
            tagName: "thead",
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: "element",
            tagName: "tbody",
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $5KHdK.pointStart)(node.children[1]);
        const end = (0, $5KHdK.pointEnd)(node.children[node.children.length - 1]);
        if (start.line && end.line) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "table",
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("5ffe8", function(module, exports) {

$parcel$export(module.exports, "tableRow", () => $3d1a2a39905f7f36$export$ce666bf02318c957);
/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $3d1a2a39905f7f36$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? "th" : "td";
    const align = parent && parent.type === "table" ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: "element",
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(node, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "tr",
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("fNMDO", function(module, exports) {

$parcel$export(module.exports, "tableCell", () => $b81129b9d23c44c9$export$e1e720e5f4603e6a);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $b81129b9d23c44c9$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "td",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});

parcelRegister("g5Oob", function(module, exports) {

$parcel$export(module.exports, "text", () => $bb7433316f26c2fd$export$6f093cfa640b7166);
/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ 
var $8dMLC = parcelRequire("8dMLC");
function $bb7433316f26c2fd$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: "text",
        value: (0, $8dMLC.trimLines)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});
parcelRegister("8dMLC", function(module, exports) {

$parcel$export(module.exports, "trimLines", () => $5fc55dbca2f2c17d$export$a771f20bdd13def9);
const $5fc55dbca2f2c17d$var$tab = 9 /* `\t` */ ;
const $5fc55dbca2f2c17d$var$space = 32 /* ` ` */ ;
function $5fc55dbca2f2c17d$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($5fc55dbca2f2c17d$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($5fc55dbca2f2c17d$var$trimLine(source.slice(last), last > 0, false));
    return lines.join("");
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $5fc55dbca2f2c17d$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $5fc55dbca2f2c17d$var$tab || code === $5fc55dbca2f2c17d$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $5fc55dbca2f2c17d$var$tab || code === $5fc55dbca2f2c17d$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : "";
}

});


parcelRegister("33kGw", function(module, exports) {

$parcel$export(module.exports, "thematicBreak", () => $2391b277fcb80494$export$ba7b13e047416c03);
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $2391b277fcb80494$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "hr",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}

});





parcelRegister("4EguK", function(module, exports) {

$parcel$export(module.exports, "html", () => $3627b1669bbfef70$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "svg", () => $3627b1669bbfef70$export$7ed1367e7fa1ad68);
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ 
var $b9YP7 = parcelRequire("b9YP7");

var $2QqaK = parcelRequire("2QqaK");

var $dehKG = parcelRequire("dehKG");

var $3DBJN = parcelRequire("3DBJN");

var $hiihL = parcelRequire("hiihL");

var $8PBic = parcelRequire("8PBic");

var $bZ9tN = parcelRequire("bZ9tN");

var $eIrlv = parcelRequire("eIrlv");

var $9hmGl = parcelRequire("9hmGl");

const $3627b1669bbfef70$export$c0bb0b647f701bb5 = (0, $b9YP7.merge)([
    (0, $dehKG.xml),
    (0, $2QqaK.xlink),
    (0, $3DBJN.xmlns),
    (0, $hiihL.aria),
    (0, $8PBic.html)
], "html");
const $3627b1669bbfef70$export$7ed1367e7fa1ad68 = (0, $b9YP7.merge)([
    (0, $dehKG.xml),
    (0, $2QqaK.xlink),
    (0, $3DBJN.xmlns),
    (0, $hiihL.aria),
    (0, $bZ9tN.svg)
], "svg");

});
parcelRegister("b9YP7", function(module, exports) {

$parcel$export(module.exports, "merge", () => $81ffb73fb436a597$export$4950aa0f605343fb);
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ 
var $gWsbk = parcelRequire("gWsbk");
function $81ffb73fb436a597$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $gWsbk.Schema)(property, normal, space);
}

});
parcelRegister("gWsbk", function(module, exports) {

$parcel$export(module.exports, "Schema", () => $c557ec6ffb1f1101$export$19342e026b58ebb7);
/**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $c557ec6ffb1f1101$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $c557ec6ffb1f1101$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $c557ec6ffb1f1101$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $c557ec6ffb1f1101$export$19342e026b58ebb7.prototype.space = null;

});


parcelRegister("2QqaK", function(module, exports) {

$parcel$export(module.exports, "xlink", () => $2124bd6790d2d69e$export$2bd1230ec7600845);

var $2CWT7 = parcelRequire("2CWT7");
const $2124bd6790d2d69e$export$2bd1230ec7600845 = (0, $2CWT7.create)({
    space: "xlink",
    transform (_, prop) {
        return "xlink:" + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});

});
parcelRegister("2CWT7", function(module, exports) {

$parcel$export(module.exports, "create", () => $1e9ccf4c39441fea$export$185802fd694ee1f5);
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ 
var $19Q2X = parcelRequire("19Q2X");

var $gWsbk = parcelRequire("gWsbk");

var $27i1F = parcelRequire("27i1F");
const $1e9ccf4c39441fea$var$own = {}.hasOwnProperty;
function $1e9ccf4c39441fea$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($1e9ccf4c39441fea$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $27i1F.DefinedInfo)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $19Q2X.normalize)(prop)] = prop;
        normal[(0, $19Q2X.normalize)(info.attribute)] = prop;
    }
    return new (0, $gWsbk.Schema)(property, normal, definition.space);
}

});
parcelRegister("19Q2X", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $0d7f011cc0152b78$export$a3295358bff77e);
/**
 * @param {string} value
 * @returns {string}
 */ function $0d7f011cc0152b78$export$a3295358bff77e(value) {
    return value.toLowerCase();
}

});

parcelRegister("27i1F", function(module, exports) {

$parcel$export(module.exports, "DefinedInfo", () => $18aa37c22a078b90$export$ea6b9f0064e88c9b);

var $ivT3a = parcelRequire("ivT3a");

var $8gAWV = parcelRequire("8gAWV");
/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $18aa37c22a078b90$var$checks = Object.keys($8gAWV);
class $18aa37c22a078b90$export$ea6b9f0064e88c9b extends (0, $ivT3a.Info) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $18aa37c22a078b90$var$mark(this, "space", space);
        if (typeof mask === "number") while(++index < $18aa37c22a078b90$var$checks.length){
            const check = $18aa37c22a078b90$var$checks[index];
            $18aa37c22a078b90$var$mark(this, $18aa37c22a078b90$var$checks[index], (mask & $8gAWV[check]) === $8gAWV[check]);
        }
    }
}
$18aa37c22a078b90$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $18aa37c22a078b90$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}

});
parcelRegister("ivT3a", function(module, exports) {

$parcel$export(module.exports, "Info", () => $d7a5d3091ba4c585$export$c4868e4a24d48fad);
class $d7a5d3091ba4c585$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $d7a5d3091ba4c585$export$c4868e4a24d48fad.prototype.space = null;
$d7a5d3091ba4c585$export$c4868e4a24d48fad.prototype.boolean = false;
$d7a5d3091ba4c585$export$c4868e4a24d48fad.prototype.booleanish = false;
$d7a5d3091ba4c585$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$d7a5d3091ba4c585$export$c4868e4a24d48fad.prototype.number = false;
$d7a5d3091ba4c585$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$d7a5d3091ba4c585$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$d7a5d3091ba4c585$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$d7a5d3091ba4c585$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$d7a5d3091ba4c585$export$c4868e4a24d48fad.prototype.defined = false;

});

parcelRegister("8gAWV", function(module, exports) {

$parcel$export(module.exports, "boolean", () => $604c7ab759ef1866$export$4a21f16c33752377);
$parcel$export(module.exports, "booleanish", () => $604c7ab759ef1866$export$55e9e1fbc638dc8f);
$parcel$export(module.exports, "overloadedBoolean", () => $604c7ab759ef1866$export$242ac3d3042558aa);
$parcel$export(module.exports, "number", () => $604c7ab759ef1866$export$98e628dec113755e);
$parcel$export(module.exports, "spaceSeparated", () => $604c7ab759ef1866$export$ab8645c862eb5a3e);
$parcel$export(module.exports, "commaSeparated", () => $604c7ab759ef1866$export$9c8d678629b3d3);
$parcel$export(module.exports, "commaOrSpaceSeparated", () => $604c7ab759ef1866$export$2ad25cfebf36cacd);
let $604c7ab759ef1866$var$powers = 0;
const $604c7ab759ef1866$export$4a21f16c33752377 = $604c7ab759ef1866$var$increment();
const $604c7ab759ef1866$export$55e9e1fbc638dc8f = $604c7ab759ef1866$var$increment();
const $604c7ab759ef1866$export$242ac3d3042558aa = $604c7ab759ef1866$var$increment();
const $604c7ab759ef1866$export$98e628dec113755e = $604c7ab759ef1866$var$increment();
const $604c7ab759ef1866$export$ab8645c862eb5a3e = $604c7ab759ef1866$var$increment();
const $604c7ab759ef1866$export$9c8d678629b3d3 = $604c7ab759ef1866$var$increment();
const $604c7ab759ef1866$export$2ad25cfebf36cacd = $604c7ab759ef1866$var$increment();
function $604c7ab759ef1866$var$increment() {
    return 2 ** ++$604c7ab759ef1866$var$powers;
}

});




parcelRegister("dehKG", function(module, exports) {

$parcel$export(module.exports, "xml", () => $9a1a5a596d7df4bc$export$f2913fe8983302e);

var $2CWT7 = parcelRequire("2CWT7");
const $9a1a5a596d7df4bc$export$f2913fe8983302e = (0, $2CWT7.create)({
    space: "xml",
    transform (_, prop) {
        return "xml:" + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});

});

parcelRegister("3DBJN", function(module, exports) {

$parcel$export(module.exports, "xmlns", () => $2a62498a3ff7aa73$export$e20c24a128671213);

var $2CWT7 = parcelRequire("2CWT7");

var $18znf = parcelRequire("18znf");
const $2a62498a3ff7aa73$export$e20c24a128671213 = (0, $2CWT7.create)({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: (0, $18znf.caseInsensitiveTransform),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});

});
parcelRegister("18znf", function(module, exports) {

$parcel$export(module.exports, "caseInsensitiveTransform", () => $0d41fa5541692f8f$export$32b9e4cec9c208e1);

var $8Vxua = parcelRequire("8Vxua");
function $0d41fa5541692f8f$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $8Vxua.caseSensitiveTransform)(attributes, property.toLowerCase());
}

});
parcelRegister("8Vxua", function(module, exports) {

$parcel$export(module.exports, "caseSensitiveTransform", () => $67fd9f2559edda3e$export$5b10b3bc32d7efbc);
/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $67fd9f2559edda3e$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}

});



parcelRegister("hiihL", function(module, exports) {

$parcel$export(module.exports, "aria", () => $c9724d3701451adb$export$4d2d26490572750a);

var $8gAWV = parcelRequire("8gAWV");

var $2CWT7 = parcelRequire("2CWT7");
const $c9724d3701451adb$export$4d2d26490572750a = (0, $2CWT7.create)({
    transform (_, prop) {
        return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $8gAWV.booleanish),
        ariaAutoComplete: null,
        ariaBusy: (0, $8gAWV.booleanish),
        ariaChecked: (0, $8gAWV.booleanish),
        ariaColCount: (0, $8gAWV.number),
        ariaColIndex: (0, $8gAWV.number),
        ariaColSpan: (0, $8gAWV.number),
        ariaControls: (0, $8gAWV.spaceSeparated),
        ariaCurrent: null,
        ariaDescribedBy: (0, $8gAWV.spaceSeparated),
        ariaDetails: null,
        ariaDisabled: (0, $8gAWV.booleanish),
        ariaDropEffect: (0, $8gAWV.spaceSeparated),
        ariaErrorMessage: null,
        ariaExpanded: (0, $8gAWV.booleanish),
        ariaFlowTo: (0, $8gAWV.spaceSeparated),
        ariaGrabbed: (0, $8gAWV.booleanish),
        ariaHasPopup: null,
        ariaHidden: (0, $8gAWV.booleanish),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $8gAWV.spaceSeparated),
        ariaLevel: (0, $8gAWV.number),
        ariaLive: null,
        ariaModal: (0, $8gAWV.booleanish),
        ariaMultiLine: (0, $8gAWV.booleanish),
        ariaMultiSelectable: (0, $8gAWV.booleanish),
        ariaOrientation: null,
        ariaOwns: (0, $8gAWV.spaceSeparated),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $8gAWV.number),
        ariaPressed: (0, $8gAWV.booleanish),
        ariaReadOnly: (0, $8gAWV.booleanish),
        ariaRelevant: null,
        ariaRequired: (0, $8gAWV.booleanish),
        ariaRoleDescription: (0, $8gAWV.spaceSeparated),
        ariaRowCount: (0, $8gAWV.number),
        ariaRowIndex: (0, $8gAWV.number),
        ariaRowSpan: (0, $8gAWV.number),
        ariaSelected: (0, $8gAWV.booleanish),
        ariaSetSize: (0, $8gAWV.number),
        ariaSort: null,
        ariaValueMax: (0, $8gAWV.number),
        ariaValueMin: (0, $8gAWV.number),
        ariaValueNow: (0, $8gAWV.number),
        ariaValueText: null,
        role: null
    }
});

});

parcelRegister("8PBic", function(module, exports) {

$parcel$export(module.exports, "html", () => $66e003b04bd9837f$export$c0bb0b647f701bb5);

var $8gAWV = parcelRequire("8gAWV");

var $2CWT7 = parcelRequire("2CWT7");

var $18znf = parcelRequire("18znf");
const $66e003b04bd9837f$export$c0bb0b647f701bb5 = (0, $2CWT7.create)({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: (0, $18znf.caseInsensitiveTransform),
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $8gAWV.commaSeparated),
        acceptCharset: (0, $8gAWV.spaceSeparated),
        accessKey: (0, $8gAWV.spaceSeparated),
        action: null,
        allow: null,
        allowFullScreen: (0, $8gAWV.boolean),
        allowPaymentRequest: (0, $8gAWV.boolean),
        allowUserMedia: (0, $8gAWV.boolean),
        alt: null,
        as: null,
        async: (0, $8gAWV.boolean),
        autoCapitalize: null,
        autoComplete: (0, $8gAWV.spaceSeparated),
        autoFocus: (0, $8gAWV.boolean),
        autoPlay: (0, $8gAWV.boolean),
        blocking: (0, $8gAWV.spaceSeparated),
        capture: null,
        charSet: null,
        checked: (0, $8gAWV.boolean),
        cite: null,
        className: (0, $8gAWV.spaceSeparated),
        cols: (0, $8gAWV.number),
        colSpan: null,
        content: null,
        contentEditable: (0, $8gAWV.booleanish),
        controls: (0, $8gAWV.boolean),
        controlsList: (0, $8gAWV.spaceSeparated),
        coords: (0, $8gAWV.number) | (0, $8gAWV.commaSeparated),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $8gAWV.boolean),
        defer: (0, $8gAWV.boolean),
        dir: null,
        dirName: null,
        disabled: (0, $8gAWV.boolean),
        download: (0, $8gAWV.overloadedBoolean),
        draggable: (0, $8gAWV.booleanish),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $8gAWV.boolean),
        formTarget: null,
        headers: (0, $8gAWV.spaceSeparated),
        height: (0, $8gAWV.number),
        hidden: (0, $8gAWV.boolean),
        high: (0, $8gAWV.number),
        href: null,
        hrefLang: null,
        htmlFor: (0, $8gAWV.spaceSeparated),
        httpEquiv: (0, $8gAWV.spaceSeparated),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $8gAWV.boolean),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $8gAWV.boolean),
        itemId: null,
        itemProp: (0, $8gAWV.spaceSeparated),
        itemRef: (0, $8gAWV.spaceSeparated),
        itemScope: (0, $8gAWV.boolean),
        itemType: (0, $8gAWV.spaceSeparated),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $8gAWV.boolean),
        low: (0, $8gAWV.number),
        manifest: null,
        max: null,
        maxLength: (0, $8gAWV.number),
        media: null,
        method: null,
        min: null,
        minLength: (0, $8gAWV.number),
        multiple: (0, $8gAWV.boolean),
        muted: (0, $8gAWV.boolean),
        name: null,
        nonce: null,
        noModule: (0, $8gAWV.boolean),
        noValidate: (0, $8gAWV.boolean),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $8gAWV.boolean),
        optimum: (0, $8gAWV.number),
        pattern: null,
        ping: (0, $8gAWV.spaceSeparated),
        placeholder: null,
        playsInline: (0, $8gAWV.boolean),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $8gAWV.boolean),
        referrerPolicy: null,
        rel: (0, $8gAWV.spaceSeparated),
        required: (0, $8gAWV.boolean),
        reversed: (0, $8gAWV.boolean),
        rows: (0, $8gAWV.number),
        rowSpan: (0, $8gAWV.number),
        sandbox: (0, $8gAWV.spaceSeparated),
        scope: null,
        scoped: (0, $8gAWV.boolean),
        seamless: (0, $8gAWV.boolean),
        selected: (0, $8gAWV.boolean),
        shadowRootClonable: (0, $8gAWV.boolean),
        shadowRootDelegatesFocus: (0, $8gAWV.boolean),
        shadowRootMode: null,
        shape: null,
        size: (0, $8gAWV.number),
        sizes: null,
        slot: null,
        span: (0, $8gAWV.number),
        spellCheck: (0, $8gAWV.booleanish),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $8gAWV.number),
        step: null,
        style: null,
        tabIndex: (0, $8gAWV.number),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $8gAWV.boolean),
        useMap: null,
        value: (0, $8gAWV.booleanish),
        width: (0, $8gAWV.number),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $8gAWV.spaceSeparated),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $8gAWV.number),
        borderColor: null,
        bottomMargin: (0, $8gAWV.number),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $8gAWV.boolean),
        declare: (0, $8gAWV.boolean),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $8gAWV.number),
        leftMargin: (0, $8gAWV.number),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $8gAWV.number),
        marginWidth: (0, $8gAWV.number),
        noResize: (0, $8gAWV.boolean),
        noHref: (0, $8gAWV.boolean),
        noShade: (0, $8gAWV.boolean),
        noWrap: (0, $8gAWV.boolean),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $8gAWV.number),
        rules: null,
        scheme: null,
        scrolling: (0, $8gAWV.booleanish),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $8gAWV.number),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $8gAWV.number),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $8gAWV.boolean),
        disableRemotePlayback: (0, $8gAWV.boolean),
        prefix: null,
        property: null,
        results: (0, $8gAWV.number),
        security: null,
        unselectable: null
    }
});

});

parcelRegister("bZ9tN", function(module, exports) {

$parcel$export(module.exports, "svg", () => $8b9cbea746cc1f72$export$7ed1367e7fa1ad68);

var $8gAWV = parcelRequire("8gAWV");

var $2CWT7 = parcelRequire("2CWT7");

var $8Vxua = parcelRequire("8Vxua");
const $8b9cbea746cc1f72$export$7ed1367e7fa1ad68 = (0, $2CWT7.create)({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        transformOrigin: "transform-origin",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: (0, $8Vxua.caseSensitiveTransform),
    properties: {
        about: (0, $8gAWV.commaOrSpaceSeparated),
        accentHeight: (0, $8gAWV.number),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $8gAWV.number),
        amplitude: (0, $8gAWV.number),
        arabicForm: null,
        ascent: (0, $8gAWV.number),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $8gAWV.number),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $8gAWV.number),
        by: null,
        calcMode: null,
        capHeight: (0, $8gAWV.number),
        className: (0, $8gAWV.spaceSeparated),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $8gAWV.number),
        diffuseConstant: (0, $8gAWV.number),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $8gAWV.number),
        dominantBaseline: null,
        download: (0, $8gAWV.boolean),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $8gAWV.number),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $8gAWV.number),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $8gAWV.number),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $8gAWV.commaSeparated),
        g2: (0, $8gAWV.commaSeparated),
        glyphName: (0, $8gAWV.commaSeparated),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $8gAWV.number),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $8gAWV.number),
        horizOriginX: (0, $8gAWV.number),
        horizOriginY: (0, $8gAWV.number),
        id: null,
        ideographic: (0, $8gAWV.number),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $8gAWV.number),
        k: (0, $8gAWV.number),
        k1: (0, $8gAWV.number),
        k2: (0, $8gAWV.number),
        k3: (0, $8gAWV.number),
        k4: (0, $8gAWV.number),
        kernelMatrix: (0, $8gAWV.commaOrSpaceSeparated),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $8gAWV.number),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $8gAWV.number),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $8gAWV.number),
        overlineThickness: (0, $8gAWV.number),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $8gAWV.number),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $8gAWV.spaceSeparated),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $8gAWV.number),
        pointsAtY: (0, $8gAWV.number),
        pointsAtZ: (0, $8gAWV.number),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $8gAWV.commaOrSpaceSeparated),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $8gAWV.commaOrSpaceSeparated),
        rev: (0, $8gAWV.commaOrSpaceSeparated),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $8gAWV.commaOrSpaceSeparated),
        requiredFeatures: (0, $8gAWV.commaOrSpaceSeparated),
        requiredFonts: (0, $8gAWV.commaOrSpaceSeparated),
        requiredFormats: (0, $8gAWV.commaOrSpaceSeparated),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $8gAWV.number),
        specularExponent: (0, $8gAWV.number),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $8gAWV.number),
        strikethroughThickness: (0, $8gAWV.number),
        string: null,
        stroke: null,
        strokeDashArray: (0, $8gAWV.commaOrSpaceSeparated),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $8gAWV.number),
        strokeOpacity: (0, $8gAWV.number),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $8gAWV.number),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $8gAWV.commaOrSpaceSeparated),
        tabIndex: (0, $8gAWV.number),
        tableValues: null,
        target: null,
        targetX: (0, $8gAWV.number),
        targetY: (0, $8gAWV.number),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $8gAWV.commaOrSpaceSeparated),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $8gAWV.number),
        underlineThickness: (0, $8gAWV.number),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $8gAWV.number),
        values: null,
        vAlphabetic: (0, $8gAWV.number),
        vMathematical: (0, $8gAWV.number),
        vectorEffect: null,
        vHanging: (0, $8gAWV.number),
        vIdeographic: (0, $8gAWV.number),
        version: null,
        vertAdvY: (0, $8gAWV.number),
        vertOriginX: (0, $8gAWV.number),
        vertOriginY: (0, $8gAWV.number),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $8gAWV.number),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});

});

parcelRegister("eIrlv", function(module, exports) {

$parcel$export(module.exports, "find", () => $ab6a63128bd2cc6e$export$71aa6c912b956294);
/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ 
var $19Q2X = parcelRequire("19Q2X");

var $27i1F = parcelRequire("27i1F");

var $ivT3a = parcelRequire("ivT3a");
const $ab6a63128bd2cc6e$var$valid = /^data[-\w.:]+$/i;
const $ab6a63128bd2cc6e$var$dash = /-[a-z]/g;
const $ab6a63128bd2cc6e$var$cap = /[A-Z]/g;
function $ab6a63128bd2cc6e$export$71aa6c912b956294(schema, value) {
    const normal = (0, $19Q2X.normalize)(value);
    let prop = value;
    let Type = (0, $ivT3a.Info);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === "data" && $ab6a63128bd2cc6e$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") {
            // Turn it into a property.
            const rest = value.slice(5).replace($ab6a63128bd2cc6e$var$dash, $ab6a63128bd2cc6e$var$camelcase);
            prop = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$ab6a63128bd2cc6e$var$dash.test(rest)) {
                let dashes = rest.replace($ab6a63128bd2cc6e$var$cap, $ab6a63128bd2cc6e$var$kebab);
                if (dashes.charAt(0) !== "-") dashes = "-" + dashes;
                value = "data" + dashes;
            }
        }
        Type = (0, $27i1F.DefinedInfo);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $ab6a63128bd2cc6e$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $ab6a63128bd2cc6e$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

});

parcelRegister("9hmGl", function(module, exports) {

$parcel$export(module.exports, "hastToReact", () => $6c174bc54b7d137a$export$d8abd7e5fb6871f9);
/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $6c174bc54b7d137a$export$d8abd7e5fb6871f9 = {
    classId: "classID",
    dataType: "datatype",
    itemId: "itemID",
    strokeDashArray: "strokeDasharray",
    strokeDashOffset: "strokeDashoffset",
    strokeLineCap: "strokeLinecap",
    strokeLineJoin: "strokeLinejoin",
    strokeMiterLimit: "strokeMiterlimit",
    typeOf: "typeof",
    xLinkActuate: "xlinkActuate",
    xLinkArcRole: "xlinkArcrole",
    xLinkHref: "xlinkHref",
    xLinkRole: "xlinkRole",
    xLinkShow: "xlinkShow",
    xLinkTitle: "xlinkTitle",
    xLinkType: "xlinkType",
    xmlnsXLink: "xmlnsXlink"
};

});


parcelRegister("do97g", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf4968231d74abc$export$2e2bcd8739ae039);

var $2glrV = parcelRequire("2glrV");
function $9bf4968231d74abc$export$2e2bcd8739ae039(options) {
    if (options.allowedElements && options.disallowedElements) throw new TypeError("Only one of `allowedElements` and `disallowedElements` should be defined");
    if (options.allowedElements || options.disallowedElements || options.allowElement) return (tree)=>{
        (0, $2glrV.visit)(tree, "element", (node, index, parent_)=>{
            const parent = /** @type {Element|Root} */ parent_;
            /** @type {boolean|undefined} */ let remove;
            if (options.allowedElements) remove = !options.allowedElements.includes(node.tagName);
            else if (options.disallowedElements) remove = options.disallowedElements.includes(node.tagName);
            if (!remove && options.allowElement && typeof index === "number") remove = !options.allowElement(node, index, parent);
            if (remove && typeof index === "number") {
                if (options.unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
            return undefined;
        });
    };
}

});

parcelRegister("6yHla", function(module, exports) {

$parcel$export(module.exports, "childrenToReact", () => $4c67898bae97146d$export$4b745c302603ab5d);
/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */ /**
 * @template {import('react').ElementType} T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */ /**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types.js').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'td'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: false}} TableDataCellProps
 * @typedef {ComponentPropsWithoutRef<'th'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: true}} TableHeaderCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableDataCellProps>} TableDataCellComponent
 * @typedef {ComponentType<TableHeaderCellProps>} TableHeaderCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableDataCellComponent|ReactMarkdownNames} td
 * @property {TableHeaderCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types.js').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */ 
var $81g6h = parcelRequire("81g6h");

var $jg81y = parcelRequire("jg81y");

var $kWCG7 = parcelRequire("kWCG7");

var $eIrlv = parcelRequire("eIrlv");
var $9hmGl = parcelRequire("9hmGl");
var $4EguK = parcelRequire("4EguK");

var $3YjvM = parcelRequire("3YjvM");

var $lue1t = parcelRequire("lue1t");

var $4QgrQ = parcelRequire("4QgrQ");

var $dDzUt = parcelRequire("dDzUt");
const $4c67898bae97146d$var$own = {}.hasOwnProperty;
// The table-related elements that must not contain whitespace text according
// to React.
const $4c67898bae97146d$var$tableElements = new Set([
    "table",
    "thead",
    "tbody",
    "tfoot",
    "tr"
]);
function $4c67898bae97146d$export$4b745c302603ab5d(context, node) {
    /** @type {Array<ReactNode>} */ const children = [];
    let childIndex = -1;
    /** @type {Comment|Doctype|Element|Raw|Text} */ let child;
    while(++childIndex < node.children.length){
        child = node.children[childIndex];
        if (child.type === "element") children.push($4c67898bae97146d$var$toReact(context, child, childIndex, node));
        else if (child.type === "text") // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we drop it.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        // See: <https://github.com/remarkjs/react-markdown/issues/576>.
        {
            if (node.type !== "element" || !$4c67898bae97146d$var$tableElements.has(node.tagName) || !(0, $kWCG7.whitespace)(child)) children.push(child.value);
        } else if (child.type === "raw" && !context.options.skipHtml) // Default behavior is to show (encoded) HTML.
        children.push(child.value);
    }
    return children;
}
/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */ function $4c67898bae97146d$var$toReact(context, node, index, parent) {
    const options = context.options;
    const transform = options.transformLinkUri === undefined ? (0, $dDzUt.uriTransformer) : options.transformLinkUri;
    const parentSchema = context.schema;
    /** @type {ReactMarkdownNames} */ // @ts-expect-error assume a known HTML/SVG element.
    const name = node.tagName;
    /** @type {Record<string, unknown>} */ const properties = {};
    let schema = parentSchema;
    /** @type {string} */ let property;
    if (parentSchema.space === "html" && name === "svg") {
        schema = (0, $4EguK.svg);
        context.schema = schema;
    }
    if (node.properties) {
        for(property in node.properties)if ($4c67898bae97146d$var$own.call(node.properties, property)) $4c67898bae97146d$var$addProperty(properties, property, node.properties[property], context);
    }
    if (name === "ol" || name === "ul") context.listDepth++;
    const children = $4c67898bae97146d$export$4b745c302603ab5d(context, node);
    if (name === "ol" || name === "ul") context.listDepth--;
    // Restore parent schema.
    context.schema = parentSchema;
    // Nodes created by plugins do not have positional info, in which case we use
    // an object that matches the position interface.
    const position = node.position || {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    const component = options.components && $4c67898bae97146d$var$own.call(options.components, name) ? options.components[name] : name;
    const basic = typeof component === "string" || component === (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).Fragment;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($jg81y))).isValidElementType(component)) throw new TypeError(`Component for name \`${name}\` not defined or is not renderable`);
    properties.key = index;
    if (name === "a" && options.linkTarget) properties.target = typeof options.linkTarget === "function" ? options.linkTarget(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null) : options.linkTarget;
    if (name === "a" && transform) properties.href = transform(String(properties.href || ""), node.children, typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "code" && parent.type === "element" && parent.tagName !== "pre") properties.inline = true;
    if (!basic && (name === "h1" || name === "h2" || name === "h3" || name === "h4" || name === "h5" || name === "h6")) properties.level = Number.parseInt(name.charAt(1), 10);
    if (name === "img" && options.transformImageUri) properties.src = options.transformImageUri(String(properties.src || ""), String(properties.alt || ""), typeof properties.title === "string" ? properties.title : null);
    if (!basic && name === "li" && parent.type === "element") {
        const input = $4c67898bae97146d$var$getInputElement(node);
        properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
        properties.index = $4c67898bae97146d$var$getElementsBeforeCount(parent, node);
        properties.ordered = parent.tagName === "ol";
    }
    if (!basic && (name === "ol" || name === "ul")) {
        properties.ordered = name === "ol";
        properties.depth = context.listDepth;
    }
    if (name === "td" || name === "th") {
        if (properties.align) {
            if (!properties.style) properties.style = {};
            // @ts-expect-error assume `style` is an object
            properties.style.textAlign = properties.align;
            delete properties.align;
        }
        if (!basic) properties.isHeader = name === "th";
    }
    if (!basic && name === "tr" && parent.type === "element") properties.isHeader = Boolean(parent.tagName === "thead");
    // If `sourcePos` is given, pass source information (line/column info from markdown source).
    if (options.sourcePos) properties["data-sourcepos"] = $4c67898bae97146d$var$flattenPosition(position);
    if (!basic && options.rawSourcePos) properties.sourcePosition = node.position;
    // If `includeElementIndex` is given, pass node index info to components.
    if (!basic && options.includeElementIndex) {
        properties.index = $4c67898bae97146d$var$getElementsBeforeCount(parent, node);
        properties.siblingCount = $4c67898bae97146d$var$getElementsBeforeCount(parent);
    }
    if (!basic) properties.node = node;
    // Ensure no React warnings are emitted for void elements w/ children.
    return children.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement(component, properties, children) : (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement(component, properties);
}
/**
 * @param {Element|Root} node
 * @returns {Element?}
 */ function $4c67898bae97146d$var$getInputElement(node) {
    let index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        if (child.type === "element" && child.tagName === "input") return child;
    }
    return null;
}
/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */ function $4c67898bae97146d$var$getElementsBeforeCount(parent, node) {
    let index = -1;
    let count = 0;
    while(++index < parent.children.length){
        if (parent.children[index] === node) break;
        if (parent.children[index].type === "element") count++;
    }
    return count;
}
/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */ function $4c67898bae97146d$var$addProperty(props, prop, value, ctx) {
    const info = (0, $eIrlv.find)(ctx.schema, prop);
    let result = value;
    // Ignore nullish and `NaN` values.
    // eslint-disable-next-line no-self-compare
    if (result === null || result === undefined || result !== result) return;
    // Accept `array`.
    // Most props are space-separated.
    if (Array.isArray(result)) result = info.commaSeparated ? (0, $lue1t.stringify)(result) : (0, $3YjvM.stringify)(result);
    if (info.property === "style" && typeof result === "string") result = $4c67898bae97146d$var$parseStyle(result);
    if (info.space && info.property) props[$4c67898bae97146d$var$own.call((0, $9hmGl.hastToReact), info.property) ? (0, $9hmGl.hastToReact)[info.property] : info.property] = result;
    else if (info.attribute) props[info.attribute] = result;
}
/**
 * @param {string} value
 * @returns {Record<string, string>}
 */ function $4c67898bae97146d$var$parseStyle(value) {
    /** @type {Record<string, string>} */ const result = {};
    try {
        (0, $4QgrQ.default)(value, iterator);
    } catch  {
    // Silent.
    }
    return result;
    /**
   * @param {string} name
   * @param {string} v
   */ function iterator(name, v) {
        const k = name.slice(0, 4) === "-ms-" ? `ms-${name.slice(4)}` : name;
        result[k.replace(/-([a-z])/g, $4c67898bae97146d$var$styleReplacer)] = v;
    }
}
/**
 * @param {unknown} _
 * @param {string} $1
 */ function $4c67898bae97146d$var$styleReplacer(_, $1) {
    return $1.toUpperCase();
}
/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */ function $4c67898bae97146d$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ":",
        pos.start.column,
        "-",
        pos.end.line,
        ":",
        pos.end.column
    ].map(String).join("");
}

});
parcelRegister("jg81y", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7t3qb"));

});
parcelRegister("7t3qb", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $56fde5415df0715d$export$a7c73072b1a182ae, (v) => $56fde5415df0715d$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $56fde5415df0715d$export$9f27bc3417b4524d, (v) => $56fde5415df0715d$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $56fde5415df0715d$export$db77ccec0bb4ccac, (v) => $56fde5415df0715d$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $56fde5415df0715d$export$8392c0c9d3dcbd35, (v) => $56fde5415df0715d$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $56fde5415df0715d$export$ffb0004e005737fa, (v) => $56fde5415df0715d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $56fde5415df0715d$export$b624eff549462981, (v) => $56fde5415df0715d$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $56fde5415df0715d$export$7897aa7841a5380c, (v) => $56fde5415df0715d$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $56fde5415df0715d$export$602eac185826482c, (v) => $56fde5415df0715d$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $56fde5415df0715d$export$e2c29f18771995cb, (v) => $56fde5415df0715d$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $56fde5415df0715d$export$5f8d39834fd61797, (v) => $56fde5415df0715d$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $56fde5415df0715d$export$74bf444e3cd11ea5, (v) => $56fde5415df0715d$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $56fde5415df0715d$export$998bcd577473dd93, (v) => $56fde5415df0715d$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $56fde5415df0715d$export$92387174baf9b227, (v) => $56fde5415df0715d$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $56fde5415df0715d$export$ec112efeb987d9c6, (v) => $56fde5415df0715d$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $56fde5415df0715d$export$b706b080d889d2c9, (v) => $56fde5415df0715d$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $56fde5415df0715d$export$5be5a87408f70ddc, (v) => $56fde5415df0715d$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $56fde5415df0715d$export$45a5e7f76e0caa8d, (v) => $56fde5415df0715d$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $56fde5415df0715d$export$455c2e768291efa6, (v) => $56fde5415df0715d$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $56fde5415df0715d$export$9522e17588c12572, (v) => $56fde5415df0715d$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $56fde5415df0715d$export$2110ac352bb060b9, (v) => $56fde5415df0715d$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $56fde5415df0715d$export$56885ab8b9c456ab, (v) => $56fde5415df0715d$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $56fde5415df0715d$export$d927fcb6adf8f9de, (v) => $56fde5415df0715d$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $56fde5415df0715d$export$b82d16f27459e05a, (v) => $56fde5415df0715d$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $56fde5415df0715d$export$522c17b4f5e123e8, (v) => $56fde5415df0715d$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $56fde5415df0715d$export$1aabd8a0274ecfd6, (v) => $56fde5415df0715d$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $56fde5415df0715d$export$3d6c20d97e46b957, (v) => $56fde5415df0715d$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $56fde5415df0715d$export$9b621391a187a31a, (v) => $56fde5415df0715d$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $56fde5415df0715d$export$f5bbd400c2f4426f, (v) => $56fde5415df0715d$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $56fde5415df0715d$export$a7c73072b1a182ae;
var $56fde5415df0715d$export$9f27bc3417b4524d;
var $56fde5415df0715d$export$db77ccec0bb4ccac;
var $56fde5415df0715d$export$8392c0c9d3dcbd35;
var $56fde5415df0715d$export$ffb0004e005737fa;
var $56fde5415df0715d$export$b624eff549462981;
var $56fde5415df0715d$export$7897aa7841a5380c;
var $56fde5415df0715d$export$602eac185826482c;
var $56fde5415df0715d$export$e2c29f18771995cb;
var $56fde5415df0715d$export$5f8d39834fd61797;
var $56fde5415df0715d$export$74bf444e3cd11ea5;
var $56fde5415df0715d$export$998bcd577473dd93;
var $56fde5415df0715d$export$92387174baf9b227;
var $56fde5415df0715d$export$ec112efeb987d9c6;
var $56fde5415df0715d$export$b706b080d889d2c9;
var $56fde5415df0715d$export$5be5a87408f70ddc;
var $56fde5415df0715d$export$45a5e7f76e0caa8d;
var $56fde5415df0715d$export$455c2e768291efa6;
var $56fde5415df0715d$export$9522e17588c12572;
var $56fde5415df0715d$export$2110ac352bb060b9;
var $56fde5415df0715d$export$56885ab8b9c456ab;
var $56fde5415df0715d$export$d927fcb6adf8f9de;
var $56fde5415df0715d$export$b82d16f27459e05a;
var $56fde5415df0715d$export$522c17b4f5e123e8;
var $56fde5415df0715d$export$1aabd8a0274ecfd6;
var $56fde5415df0715d$export$3d6c20d97e46b957;
var $56fde5415df0715d$export$9b621391a187a31a;
var $56fde5415df0715d$export$f5bbd400c2f4426f;
"use strict";
var $56fde5415df0715d$var$b = Symbol.for("react.element"), $56fde5415df0715d$var$c = Symbol.for("react.portal"), $56fde5415df0715d$var$d = Symbol.for("react.fragment"), $56fde5415df0715d$var$e = Symbol.for("react.strict_mode"), $56fde5415df0715d$var$f = Symbol.for("react.profiler"), $56fde5415df0715d$var$g = Symbol.for("react.provider"), $56fde5415df0715d$var$h = Symbol.for("react.context"), $56fde5415df0715d$var$k = Symbol.for("react.server_context"), $56fde5415df0715d$var$l = Symbol.for("react.forward_ref"), $56fde5415df0715d$var$m = Symbol.for("react.suspense"), $56fde5415df0715d$var$n = Symbol.for("react.suspense_list"), $56fde5415df0715d$var$p = Symbol.for("react.memo"), $56fde5415df0715d$var$q = Symbol.for("react.lazy"), $56fde5415df0715d$var$t = Symbol.for("react.offscreen"), $56fde5415df0715d$var$u;
$56fde5415df0715d$var$u = Symbol.for("react.module.reference");
function $56fde5415df0715d$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $56fde5415df0715d$var$b:
                switch(a = a.type, a){
                    case $56fde5415df0715d$var$d:
                    case $56fde5415df0715d$var$f:
                    case $56fde5415df0715d$var$e:
                    case $56fde5415df0715d$var$m:
                    case $56fde5415df0715d$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $56fde5415df0715d$var$k:
                            case $56fde5415df0715d$var$h:
                            case $56fde5415df0715d$var$l:
                            case $56fde5415df0715d$var$q:
                            case $56fde5415df0715d$var$p:
                            case $56fde5415df0715d$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $56fde5415df0715d$var$c:
                return r;
        }
    }
}
$56fde5415df0715d$export$a7c73072b1a182ae = $56fde5415df0715d$var$h;
$56fde5415df0715d$export$9f27bc3417b4524d = $56fde5415df0715d$var$g;
$56fde5415df0715d$export$db77ccec0bb4ccac = $56fde5415df0715d$var$b;
$56fde5415df0715d$export$8392c0c9d3dcbd35 = $56fde5415df0715d$var$l;
$56fde5415df0715d$export$ffb0004e005737fa = $56fde5415df0715d$var$d;
$56fde5415df0715d$export$b624eff549462981 = $56fde5415df0715d$var$q;
$56fde5415df0715d$export$7897aa7841a5380c = $56fde5415df0715d$var$p;
$56fde5415df0715d$export$602eac185826482c = $56fde5415df0715d$var$c;
$56fde5415df0715d$export$e2c29f18771995cb = $56fde5415df0715d$var$f;
$56fde5415df0715d$export$5f8d39834fd61797 = $56fde5415df0715d$var$e;
$56fde5415df0715d$export$74bf444e3cd11ea5 = $56fde5415df0715d$var$m;
$56fde5415df0715d$export$998bcd577473dd93 = $56fde5415df0715d$var$n;
$56fde5415df0715d$export$92387174baf9b227 = function() {
    return !1;
};
$56fde5415df0715d$export$ec112efeb987d9c6 = function() {
    return !1;
};
$56fde5415df0715d$export$b706b080d889d2c9 = function(a) {
    return $56fde5415df0715d$var$v(a) === $56fde5415df0715d$var$h;
};
$56fde5415df0715d$export$5be5a87408f70ddc = function(a) {
    return $56fde5415df0715d$var$v(a) === $56fde5415df0715d$var$g;
};
$56fde5415df0715d$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $56fde5415df0715d$var$b;
};
$56fde5415df0715d$export$455c2e768291efa6 = function(a) {
    return $56fde5415df0715d$var$v(a) === $56fde5415df0715d$var$l;
};
$56fde5415df0715d$export$9522e17588c12572 = function(a) {
    return $56fde5415df0715d$var$v(a) === $56fde5415df0715d$var$d;
};
$56fde5415df0715d$export$2110ac352bb060b9 = function(a) {
    return $56fde5415df0715d$var$v(a) === $56fde5415df0715d$var$q;
};
$56fde5415df0715d$export$56885ab8b9c456ab = function(a) {
    return $56fde5415df0715d$var$v(a) === $56fde5415df0715d$var$p;
};
$56fde5415df0715d$export$d927fcb6adf8f9de = function(a) {
    return $56fde5415df0715d$var$v(a) === $56fde5415df0715d$var$c;
};
$56fde5415df0715d$export$b82d16f27459e05a = function(a) {
    return $56fde5415df0715d$var$v(a) === $56fde5415df0715d$var$f;
};
$56fde5415df0715d$export$522c17b4f5e123e8 = function(a) {
    return $56fde5415df0715d$var$v(a) === $56fde5415df0715d$var$e;
};
$56fde5415df0715d$export$1aabd8a0274ecfd6 = function(a) {
    return $56fde5415df0715d$var$v(a) === $56fde5415df0715d$var$m;
};
$56fde5415df0715d$export$3d6c20d97e46b957 = function(a) {
    return $56fde5415df0715d$var$v(a) === $56fde5415df0715d$var$n;
};
$56fde5415df0715d$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $56fde5415df0715d$var$d || a === $56fde5415df0715d$var$f || a === $56fde5415df0715d$var$e || a === $56fde5415df0715d$var$m || a === $56fde5415df0715d$var$n || a === $56fde5415df0715d$var$t || "object" === typeof a && null !== a && (a.$$typeof === $56fde5415df0715d$var$q || a.$$typeof === $56fde5415df0715d$var$p || a.$$typeof === $56fde5415df0715d$var$g || a.$$typeof === $56fde5415df0715d$var$h || a.$$typeof === $56fde5415df0715d$var$l || a.$$typeof === $56fde5415df0715d$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$56fde5415df0715d$export$f5bbd400c2f4426f = $56fde5415df0715d$var$v;

});


parcelRegister("kWCG7", function(module, exports) {

$parcel$export(module.exports, "whitespace", () => $f3f73a254a3ba990$export$7af1228ff777d175);
/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {unknown} thing
 *   Thing to check (typically `Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`).
 *   If a node is passed it must be a `Text` node, whose `value` field is
 *   checked.
 */ function $f3f73a254a3ba990$export$7af1228ff777d175(thing) {
    /** @type {string} */ const value = // @ts-expect-error looks like a node.
    thing && typeof thing === "object" && thing.type === "text" ? thing.value || "" : thing;
    // HTML whitespace expression.
    // See <https://infra.spec.whatwg.org/#ascii-whitespace>.
    return typeof value === "string" && value.replace(/[ \t\n\f\r]/g, "") === "";
}

});

parcelRegister("3YjvM", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $2e461c444ee5fdb0$export$fac44ee5b035f737);
/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $2e461c444ee5fdb0$export$98e6a39c04603d36(value) {
    const input = String(value || "").trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $2e461c444ee5fdb0$export$fac44ee5b035f737(values) {
    return values.join(" ").trim();
}

});

parcelRegister("lue1t", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $fa4746ee7d2cc04d$export$fac44ee5b035f737);
/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $fa4746ee7d2cc04d$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || "");
    let index = input.indexOf(",");
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(",", start);
    }
    return tokens;
}
function $fa4746ee7d2cc04d$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === "" ? [
        ...values,
        ""
    ] : values;
    return input.join((settings.padRight ? " " : "") + "," + (settings.padLeft === false ? "" : " ")).trim();
}

});

parcelRegister("4QgrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fafaf8a7d44b8f0d$export$2e2bcd8739ae039);

var $a1lKD = parcelRequire("a1lKD");
var $fafaf8a7d44b8f0d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($a1lKD)));

});
parcelRegister("a1lKD", function(module, exports) {

var $94gXq = parcelRequire("94gXq");
/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $74badebba938bae4$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $94gXq(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
module.exports = $74badebba938bae4$var$StyleToObject;
module.exports.default = $74badebba938bae4$var$StyleToObject; // ESM support

});
parcelRegister("94gXq", function(module, exports) {
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $69a1a427dc8aa3a9$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $69a1a427dc8aa3a9$var$NEWLINE_REGEX = /\n/g;
var $69a1a427dc8aa3a9$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $69a1a427dc8aa3a9$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $69a1a427dc8aa3a9$var$COLON_REGEX = /^:\s*/;
var $69a1a427dc8aa3a9$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $69a1a427dc8aa3a9$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $69a1a427dc8aa3a9$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $69a1a427dc8aa3a9$var$NEWLINE = "\n";
var $69a1a427dc8aa3a9$var$FORWARD_SLASH = "/";
var $69a1a427dc8aa3a9$var$ASTERISK = "*";
var $69a1a427dc8aa3a9$var$EMPTY_STRING = "";
// types
var $69a1a427dc8aa3a9$var$TYPE_COMMENT = "comment";
var $69a1a427dc8aa3a9$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ module.exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($69a1a427dc8aa3a9$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($69a1a427dc8aa3a9$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($69a1a427dc8aa3a9$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($69a1a427dc8aa3a9$var$FORWARD_SLASH != style.charAt(0) || $69a1a427dc8aa3a9$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($69a1a427dc8aa3a9$var$EMPTY_STRING != style.charAt(i) && ($69a1a427dc8aa3a9$var$ASTERISK != style.charAt(i) || $69a1a427dc8aa3a9$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($69a1a427dc8aa3a9$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $69a1a427dc8aa3a9$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($69a1a427dc8aa3a9$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($69a1a427dc8aa3a9$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($69a1a427dc8aa3a9$var$VALUE_REGEX);
        var ret = pos({
            type: $69a1a427dc8aa3a9$var$TYPE_DECLARATION,
            property: $69a1a427dc8aa3a9$var$trim(prop[0].replace($69a1a427dc8aa3a9$var$COMMENT_REGEX, $69a1a427dc8aa3a9$var$EMPTY_STRING)),
            value: val ? $69a1a427dc8aa3a9$var$trim(val[0].replace($69a1a427dc8aa3a9$var$COMMENT_REGEX, $69a1a427dc8aa3a9$var$EMPTY_STRING)) : $69a1a427dc8aa3a9$var$EMPTY_STRING
        });
        // ;
        match($69a1a427dc8aa3a9$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $69a1a427dc8aa3a9$var$trim(str) {
    return str ? str.replace($69a1a427dc8aa3a9$var$TRIM_REGEX, $69a1a427dc8aa3a9$var$EMPTY_STRING) : $69a1a427dc8aa3a9$var$EMPTY_STRING;
}

});



parcelRegister("dDzUt", function(module, exports) {

$parcel$export(module.exports, "uriTransformer", () => $9edac5d1facee15b$export$b83532a10e2e268b);
const $9edac5d1facee15b$var$protocols = [
    "http",
    "https",
    "mailto",
    "tel"
];
function $9edac5d1facee15b$export$b83532a10e2e268b(uri) {
    const url = (uri || "").trim();
    const first = url.charAt(0);
    if (first === "#" || first === "/") return url;
    const colon = url.indexOf(":");
    if (colon === -1) return url;
    let index = -1;
    while(++index < $9edac5d1facee15b$var$protocols.length){
        const protocol = $9edac5d1facee15b$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf("?");
    if (index !== -1 && colon > index) return url;
    index = url.indexOf("#");
    if (index !== -1 && colon > index) return url;
    // eslint-disable-next-line no-script-url
    return "javascript:void(0)";
}

});



parcelRegister("3iLEr", function(module, exports) {

$parcel$export(module.exports, "default", () => $2678041c9ee188f1$export$2e2bcd8739ae039);
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('micromark-extension-gfm').Options & import('mdast-util-gfm').Options} Options
 */ 
var $ivi9W = parcelRequire("ivi9W");

var $8fd5h = parcelRequire("8fd5h");
function $2678041c9ee188f1$export$2e2bcd8739ae039(options = {}) {
    const data = this.data();
    add("micromarkExtensions", (0, $ivi9W.gfm)(options));
    add("fromMarkdownExtensions", (0, $8fd5h.gfmFromMarkdown)());
    add("toMarkdownExtensions", (0, $8fd5h.gfmToMarkdown)(options));
    /**
   * @param {string} field
   * @param {unknown} value
   */ function add(field, value) {
        const list = /** @type {unknown[]} */ // Other extensions
        /* c8 ignore next 2 */ data[field] ? data[field] : data[field] = [];
        list.push(value);
    }
}

});
parcelRegister("ivi9W", function(module, exports) {

$parcel$export(module.exports, "gfm", () => $d7893552da7bca9e$export$59ffe8c4d7a4aab2);
/**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ 
var $YC9R7 = parcelRequire("YC9R7");

var $8HBq4 = parcelRequire("8HBq4");
var $lqNP2 = parcelRequire("lqNP2");

var $cb3AI = parcelRequire("cb3AI");
var $152lW = parcelRequire("152lW");

var $682gL = parcelRequire("682gL");
var $iDa4T = parcelRequire("iDa4T");

var $jX99x = parcelRequire("jX99x");
var $7IWtF = parcelRequire("7IWtF");

var $jaRVk = parcelRequire("jaRVk");

var $9gvDj = parcelRequire("9gvDj");
var $l3lj7 = parcelRequire("l3lj7");
function $d7893552da7bca9e$export$59ffe8c4d7a4aab2(options) {
    return (0, $YC9R7.combineExtensions)([
        (0, $8HBq4.gfmAutolinkLiteral),
        (0, $cb3AI.gfmFootnote)(),
        (0, $682gL.gfmStrikethrough)(options),
        (0, $jX99x.gfmTable),
        (0, $9gvDj.gfmTaskListItem)
    ]);
}
function $d7893552da7bca9e$export$6983b82e6105d62a(options) {
    return (0, $YC9R7.combineHtmlExtensions)([
        (0, $lqNP2.gfmAutolinkLiteralHtml),
        (0, $152lW.gfmFootnoteHtml)(options),
        (0, $iDa4T.gfmStrikethroughHtml),
        (0, $7IWtF.gfmTableHtml),
        (0, $jaRVk.gfmTagfilterHtml),
        (0, $l3lj7.gfmTaskListItemHtml)
    ]);
}

});
parcelRegister("8HBq4", function(module, exports) {

$parcel$export(module.exports, "gfmAutolinkLiteral", () => $655f5da2cdcdc3b5$export$608123d9b549151);
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $7CNzt = parcelRequire("7CNzt");
const $655f5da2cdcdc3b5$var$wwwPrefix = {
    tokenize: $655f5da2cdcdc3b5$var$tokenizeWwwPrefix,
    partial: true
};
const $655f5da2cdcdc3b5$var$domain = {
    tokenize: $655f5da2cdcdc3b5$var$tokenizeDomain,
    partial: true
};
const $655f5da2cdcdc3b5$var$path = {
    tokenize: $655f5da2cdcdc3b5$var$tokenizePath,
    partial: true
};
const $655f5da2cdcdc3b5$var$trail = {
    tokenize: $655f5da2cdcdc3b5$var$tokenizeTrail,
    partial: true
};
const $655f5da2cdcdc3b5$var$emailDomainDotTrail = {
    tokenize: $655f5da2cdcdc3b5$var$tokenizeEmailDomainDotTrail,
    partial: true
};
const $655f5da2cdcdc3b5$var$wwwAutolink = {
    tokenize: $655f5da2cdcdc3b5$var$tokenizeWwwAutolink,
    previous: $655f5da2cdcdc3b5$var$previousWww
};
const $655f5da2cdcdc3b5$var$protocolAutolink = {
    tokenize: $655f5da2cdcdc3b5$var$tokenizeProtocolAutolink,
    previous: $655f5da2cdcdc3b5$var$previousProtocol
};
const $655f5da2cdcdc3b5$var$emailAutolink = {
    tokenize: $655f5da2cdcdc3b5$var$tokenizeEmailAutolink,
    previous: $655f5da2cdcdc3b5$var$previousEmail
};
/** @type {ConstructRecord} */ const $655f5da2cdcdc3b5$var$text = {};
const $655f5da2cdcdc3b5$export$608123d9b549151 = {
    text: $655f5da2cdcdc3b5$var$text
};
/** @type {Code} */ let $655f5da2cdcdc3b5$var$code = 48;
// Add alphanumerics.
while($655f5da2cdcdc3b5$var$code < 123){
    $655f5da2cdcdc3b5$var$text[$655f5da2cdcdc3b5$var$code] = $655f5da2cdcdc3b5$var$emailAutolink;
    $655f5da2cdcdc3b5$var$code++;
    if ($655f5da2cdcdc3b5$var$code === 58) $655f5da2cdcdc3b5$var$code = 65;
    else if ($655f5da2cdcdc3b5$var$code === 91) $655f5da2cdcdc3b5$var$code = 97;
}
$655f5da2cdcdc3b5$var$text[43] = $655f5da2cdcdc3b5$var$emailAutolink;
$655f5da2cdcdc3b5$var$text[45] = $655f5da2cdcdc3b5$var$emailAutolink;
$655f5da2cdcdc3b5$var$text[46] = $655f5da2cdcdc3b5$var$emailAutolink;
$655f5da2cdcdc3b5$var$text[95] = $655f5da2cdcdc3b5$var$emailAutolink;
$655f5da2cdcdc3b5$var$text[72] = [
    $655f5da2cdcdc3b5$var$emailAutolink,
    $655f5da2cdcdc3b5$var$protocolAutolink
];
$655f5da2cdcdc3b5$var$text[104] = [
    $655f5da2cdcdc3b5$var$emailAutolink,
    $655f5da2cdcdc3b5$var$protocolAutolink
];
$655f5da2cdcdc3b5$var$text[87] = [
    $655f5da2cdcdc3b5$var$emailAutolink,
    $655f5da2cdcdc3b5$var$wwwAutolink
];
$655f5da2cdcdc3b5$var$text[119] = [
    $655f5da2cdcdc3b5$var$emailAutolink,
    $655f5da2cdcdc3b5$var$wwwAutolink
];
// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.
/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $655f5da2cdcdc3b5$var$tokenizeEmailAutolink(effects, ok, nok) {
    const self = this;
    /** @type {boolean | undefined} */ let dot;
    /** @type {boolean} */ let data;
    return start;
    /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (!$655f5da2cdcdc3b5$var$gfmAtext(code) || !$655f5da2cdcdc3b5$var$previousEmail.call(self, self.previous) || $655f5da2cdcdc3b5$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkEmail");
        return atext(code);
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function atext(code) {
        if ($655f5da2cdcdc3b5$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        if (code === 64) {
            effects.consume(code);
            return emailDomain;
        }
        return nok(code);
    }
    /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */ function emailDomain(code) {
        // Dot followed by alphanumerical (not `-` or `_`).
        if (code === 46) return effects.check($655f5da2cdcdc3b5$var$emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
        // Alphanumerical, `-`, and `_`.
        if (code === 45 || code === 95 || (0, $7CNzt.asciiAlphanumeric)(code)) {
            data = true;
            effects.consume(code);
            return emailDomain;
        }
        // To do: `/` if xmpp.
        // Note: normally we’d truncate trailing punctuation from the link.
        // However, email autolink literals cannot contain any of those markers,
        // except for `.`, but that can only occur if it isn’t trailing.
        // So we can ignore truncating!
        return emailDomainAfter(code);
    }
    /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */ function emailDomainDot(code) {
        effects.consume(code);
        dot = true;
        return emailDomain;
    }
    /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */ function emailDomainAfter(code) {
        // Domain must not be empty, must include a dot, and must end in alphabetical.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
        if (data && dot && (0, $7CNzt.asciiAlpha)(self.previous)) {
            effects.exit("literalAutolinkEmail");
            effects.exit("literalAutolink");
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $655f5da2cdcdc3b5$var$tokenizeWwwAutolink(effects, ok, nok) {
    const self = this;
    return wwwStart;
    /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function wwwStart(code) {
        if (code !== 87 && code !== 119 || !$655f5da2cdcdc3b5$var$previousWww.call(self, self.previous) || $655f5da2cdcdc3b5$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkWww");
        // Note: we *check*, so we can discard the `www.` we parsed.
        // If it worked, we consider it as a part of the domain.
        return effects.check($655f5da2cdcdc3b5$var$wwwPrefix, effects.attempt($655f5da2cdcdc3b5$var$domain, effects.attempt($655f5da2cdcdc3b5$var$path, wwwAfter), nok), nok)(code);
    }
    /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */ function wwwAfter(code) {
        effects.exit("literalAutolinkWww");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $655f5da2cdcdc3b5$var$tokenizeProtocolAutolink(effects, ok, nok) {
    const self = this;
    let buffer = "";
    let seen = false;
    return protocolStart;
    /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function protocolStart(code) {
        if ((code === 72 || code === 104) && $655f5da2cdcdc3b5$var$previousProtocol.call(self, self.previous) && !$655f5da2cdcdc3b5$var$previousUnbalanced(self.events)) {
            effects.enter("literalAutolink");
            effects.enter("literalAutolinkHttp");
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        return nok(code);
    }
    /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */ function protocolPrefixInside(code) {
        // `5` is size of `https`
        if ((0, $7CNzt.asciiAlpha)(code) && buffer.length < 5) {
            // @ts-expect-error: definitely number.
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        if (code === 58) {
            const protocol = buffer.toLowerCase();
            if (protocol === "http" || protocol === "https") {
                effects.consume(code);
                return protocolSlashesInside;
            }
        }
        return nok(code);
    }
    /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */ function protocolSlashesInside(code) {
        if (code === 47) {
            effects.consume(code);
            if (seen) return afterProtocol;
            seen = true;
            return protocolSlashesInside;
        }
        return nok(code);
    }
    /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */ function afterProtocol(code) {
        // To do: this is different from `markdown-rs`:
        // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
        return code === null || (0, $7CNzt.asciiControl)(code) || (0, $7CNzt.markdownLineEndingOrSpace)(code) || (0, $7CNzt.unicodeWhitespace)(code) || (0, $7CNzt.unicodePunctuation)(code) ? nok(code) : effects.attempt($655f5da2cdcdc3b5$var$domain, effects.attempt($655f5da2cdcdc3b5$var$path, protocolAfter), nok)(code);
    }
    /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */ function protocolAfter(code) {
        effects.exit("literalAutolinkHttp");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $655f5da2cdcdc3b5$var$tokenizeWwwPrefix(effects, ok, nok) {
    let size = 0;
    return wwwPrefixInside;
    /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */ function wwwPrefixInside(code) {
        if ((code === 87 || code === 119) && size < 3) {
            size++;
            effects.consume(code);
            return wwwPrefixInside;
        }
        if (code === 46 && size === 3) {
            effects.consume(code);
            return wwwPrefixAfter;
        }
        return nok(code);
    }
    /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */ function wwwPrefixAfter(code) {
        // If there is *anything*, we can link.
        return code === null ? nok(code) : ok(code);
    }
}
/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $655f5da2cdcdc3b5$var$tokenizeDomain(effects, ok, nok) {
    /** @type {boolean | undefined} */ let underscoreInLastSegment;
    /** @type {boolean | undefined} */ let underscoreInLastLastSegment;
    /** @type {boolean | undefined} */ let seen;
    return domainInside;
    /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */ function domainInside(code) {
        // Check whether this marker, which is a trailing punctuation
        // marker, optionally followed by more trailing markers, and then
        // followed by an end.
        if (code === 46 || code === 95) return effects.check($655f5da2cdcdc3b5$var$trail, domainAfter, domainAtPunctuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
        if (code === null || (0, $7CNzt.markdownLineEndingOrSpace)(code) || (0, $7CNzt.unicodeWhitespace)(code) || code !== 45 && (0, $7CNzt.unicodePunctuation)(code)) return domainAfter(code);
        seen = true;
        effects.consume(code);
        return domainInside;
    }
    /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */ function domainAtPunctuation(code) {
        // There is an underscore in the last segment of the domain
        if (code === 95) underscoreInLastSegment = true;
        else {
            underscoreInLastLastSegment = underscoreInLastSegment;
            underscoreInLastSegment = undefined;
        }
        effects.consume(code);
        return domainInside;
    }
    /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */ function domainAfter(code) {
        // Note: that’s GH says a dot is needed, but it’s not true:
        // <https://github.com/github/cmark-gfm/issues/279>
        if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) return nok(code);
        return ok(code);
    }
}
/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $655f5da2cdcdc3b5$var$tokenizePath(effects, ok) {
    let sizeOpen = 0;
    let sizeClose = 0;
    return pathInside;
    /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */ function pathInside(code) {
        if (code === 40) {
            sizeOpen++;
            effects.consume(code);
            return pathInside;
        }
        // To do: `markdown-rs` also needs this.
        // If this is a paren, and there are less closings than openings,
        // we don’t check for a trail.
        if (code === 41 && sizeClose < sizeOpen) return pathAtPunctuation(code);
        // Check whether this trailing punctuation marker is optionally
        // followed by more trailing markers, and then followed
        // by an end.
        if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) return effects.check($655f5da2cdcdc3b5$var$trail, ok, pathAtPunctuation)(code);
        if (code === null || (0, $7CNzt.markdownLineEndingOrSpace)(code) || (0, $7CNzt.unicodeWhitespace)(code)) return ok(code);
        effects.consume(code);
        return pathInside;
    }
    /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */ function pathAtPunctuation(code) {
        // Count closing parens.
        if (code === 41) sizeClose++;
        effects.consume(code);
        return pathInside;
    }
}
/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $655f5da2cdcdc3b5$var$tokenizeTrail(effects, ok, nok) {
    return trail;
    /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */ function trail(code) {
        // Regular trailing punctuation.
        if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
            effects.consume(code);
            return trail;
        }
        // `&` followed by one or more alphabeticals and then a `;`, is
        // as a whole considered as trailing punctuation.
        // In all other cases, it is considered as continuation of the URL.
        if (code === 38) {
            effects.consume(code);
            return trailCharRefStart;
        }
        // Needed because we allow literals after `[`, as we fix:
        // <https://github.com/github/cmark-gfm/issues/278>.
        // Check that it is not followed by `(` or `[`.
        if (code === 93) {
            effects.consume(code);
            return trailBracketAfter;
        }
        if (// `<` is an end.
        code === 60 || // So is whitespace.
        code === null || (0, $7CNzt.markdownLineEndingOrSpace)(code) || (0, $7CNzt.unicodeWhitespace)(code)) return ok(code);
        return nok(code);
    }
    /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailBracketAfter(code) {
        // Whitespace or something that could start a resource or reference is the end.
        // Switch back to trail otherwise.
        if (code === null || code === 40 || code === 91 || (0, $7CNzt.markdownLineEndingOrSpace)(code) || (0, $7CNzt.unicodeWhitespace)(code)) return ok(code);
        return trail(code);
    }
    /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefStart(code) {
        // When non-alpha, it’s not a trail.
        return (0, $7CNzt.asciiAlpha)(code) ? trailCharRefInside(code) : nok(code);
    }
    /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefInside(code) {
        // Switch back to trail if this is well-formed.
        if (code === 59) {
            effects.consume(code);
            return trail;
        }
        if ((0, $7CNzt.asciiAlpha)(code)) {
            effects.consume(code);
            return trailCharRefInside;
        }
        // It’s not a trail.
        return nok(code);
    }
}
/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $655f5da2cdcdc3b5$var$tokenizeEmailDomainDotTrail(effects, ok, nok) {
    return start;
    /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Must be dot.
        effects.consume(code);
        return after;
    }
    /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Not a trail if alphanumeric.
        return (0, $7CNzt.asciiAlphanumeric)(code) ? nok(code) : ok(code);
    }
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */ function $655f5da2cdcdc3b5$var$previousWww(code) {
    return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || (0, $7CNzt.markdownLineEndingOrSpace)(code);
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */ function $655f5da2cdcdc3b5$var$previousProtocol(code) {
    return !(0, $7CNzt.asciiAlpha)(code);
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $655f5da2cdcdc3b5$var$previousEmail(code) {
    // Do not allow a slash “inside” atext.
    // The reference code is a bit weird, but that’s what it results in.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
    // Other than slash, every preceding character is allowed.
    return !(code === 47 || $655f5da2cdcdc3b5$var$gfmAtext(code));
}
/**
 * @param {Code} code
 * @returns {boolean}
 */ function $655f5da2cdcdc3b5$var$gfmAtext(code) {
    return code === 43 || code === 45 || code === 46 || code === 95 || (0, $7CNzt.asciiAlphanumeric)(code);
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */ function $655f5da2cdcdc3b5$var$previousUnbalanced(events) {
    let index = events.length;
    let result = false;
    while(index--){
        const token = events[index][1];
        if ((token.type === "labelLink" || token.type === "labelImage") && !token._balanced) {
            result = true;
            break;
        }
        // If we’ve seen this token, and it was marked as not having any unbalanced
        // bracket before it, we can exit.
        if (token._gfmAutolinkLiteralWalkedInto) {
            result = false;
            break;
        }
    }
    if (events.length > 0 && !result) // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
    return result;
}

});

parcelRegister("lqNP2", function(module, exports) {

$parcel$export(module.exports, "gfmAutolinkLiteralHtml", () => $f9a2ac4f2452b116$export$999603f1f1c3d2f9);
/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').Handle} Handle
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ 
var $c6Rt9 = parcelRequire("c6Rt9");
const $f9a2ac4f2452b116$export$999603f1f1c3d2f9 = {
    exit: {
        literalAutolinkEmail: $f9a2ac4f2452b116$var$literalAutolinkEmail,
        literalAutolinkHttp: $f9a2ac4f2452b116$var$literalAutolinkHttp,
        literalAutolinkWww: $f9a2ac4f2452b116$var$literalAutolinkWww
    }
};
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $f9a2ac4f2452b116$var$literalAutolinkWww(token) {
    $f9a2ac4f2452b116$var$anchorFromToken.call(this, token, "http://");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $f9a2ac4f2452b116$var$literalAutolinkEmail(token) {
    $f9a2ac4f2452b116$var$anchorFromToken.call(this, token, "mailto:");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $f9a2ac4f2452b116$var$literalAutolinkHttp(token) {
    $f9a2ac4f2452b116$var$anchorFromToken.call(this, token);
}
/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {void}
 */ function $f9a2ac4f2452b116$var$anchorFromToken(token, protocol) {
    const url = this.sliceSerialize(token);
    this.tag('<a href="' + (0, $c6Rt9.sanitizeUri)((protocol || "") + url) + '">');
    this.raw(this.encode(url));
    this.tag("</a>");
}

});

parcelRegister("cb3AI", function(module, exports) {

$parcel$export(module.exports, "gfmFootnote", () => $8dd94c42be62367f$export$c82499b6656305df);
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $tOvBw = parcelRequire("tOvBw");

var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");

var $f7Cpv = parcelRequire("f7Cpv");
const $8dd94c42be62367f$var$indent = {
    tokenize: $8dd94c42be62367f$var$tokenizeIndent,
    partial: true
};
function $8dd94c42be62367f$export$c82499b6656305df() {
    /** @type {Extension} */ return {
        document: {
            [91]: {
                tokenize: $8dd94c42be62367f$var$tokenizeDefinitionStart,
                continuation: {
                    tokenize: $8dd94c42be62367f$var$tokenizeDefinitionContinuation
                },
                exit: $8dd94c42be62367f$var$gfmFootnoteDefinitionEnd
            }
        },
        text: {
            [91]: {
                tokenize: $8dd94c42be62367f$var$tokenizeGfmFootnoteCall
            },
            [93]: {
                add: "after",
                tokenize: $8dd94c42be62367f$var$tokenizePotentialGfmFootnoteCall,
                resolveTo: $8dd94c42be62367f$var$resolveToPotentialGfmFootnoteCall
            }
        }
    };
}
// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8dd94c42be62367f$var$tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {Token} */ let labelStart;
    // Find an opening.
    while(index--){
        const token = self.events[index][1];
        if (token.type === "labelImage") {
            labelStart = token;
            break;
        }
        // Exit if we’ve walked far enough.
        if (token.type === "gfmFootnoteCall" || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") break;
    }
    return start;
    /**
   * @type {State}
   */ function start(code) {
        if (!labelStart || !labelStart._balanced) return nok(code);
        const id = (0, $f7Cpv.normalizeIdentifier)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }));
        if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) return nok(code);
        effects.enter("gfmFootnoteCallLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallLabelMarker");
        return ok(code);
    }
}
// To do: remove after micromark update.
/** @type {Resolver} */ function $8dd94c42be62367f$var$resolveToPotentialGfmFootnoteCall(events, context) {
    let index = events.length;
    /** @type {Token | undefined} */ let labelStart;
    // Find an opening.
    while(index--)if (events[index][1].type === "labelImage" && events[index][0] === "enter") {
        labelStart = events[index][1];
        break;
    }
    // Change the `labelImageMarker` to a `data`.
    events[index + 1][1].type = "data";
    events[index + 3][1].type = "gfmFootnoteCallLabelMarker";
    // The whole (without `!`):
    /** @type {Token} */ const call = {
        type: "gfmFootnoteCall",
        start: Object.assign({}, events[index + 3][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // The `^` marker
    /** @type {Token} */ const marker = {
        type: "gfmFootnoteCallMarker",
        start: Object.assign({}, events[index + 3][1].end),
        end: Object.assign({}, events[index + 3][1].end)
    };
    // Increment the end 1 character.
    marker.end.column++;
    marker.end.offset++;
    marker.end._bufferIndex++;
    /** @type {Token} */ const string = {
        type: "gfmFootnoteCallString",
        start: Object.assign({}, marker.end),
        end: Object.assign({}, events[events.length - 1][1].start)
    };
    /** @type {Token} */ const chunk = {
        type: "chunkString",
        contentType: "string",
        start: Object.assign({}, string.start),
        end: Object.assign({}, string.end)
    };
    /** @type {Array<Event>} */ const replacement = [
        // Take the `labelImageMarker` (now `data`, the `!`)
        events[index + 1],
        events[index + 2],
        [
            "enter",
            call,
            context
        ],
        // The `[`
        events[index + 3],
        events[index + 4],
        // The `^`.
        [
            "enter",
            marker,
            context
        ],
        [
            "exit",
            marker,
            context
        ],
        // Everything in between.
        [
            "enter",
            string,
            context
        ],
        [
            "enter",
            chunk,
            context
        ],
        [
            "exit",
            chunk,
            context
        ],
        [
            "exit",
            string,
            context
        ],
        // The ending (`]`, properly parsed and labelled).
        events[events.length - 2],
        events[events.length - 1],
        [
            "exit",
            call,
            context
        ]
    ];
    events.splice(index, events.length - index + 1, ...replacement);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8dd94c42be62367f$var$tokenizeGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    let size = 0;
    /** @type {boolean} */ let data;
    // Note: the implementation of `markdown-rs` is different, because it houses
    // core *and* extensions in one project.
    // Therefore, it can include footnote logic inside `label-end`.
    // We can’t do that, but luckily, we can parse footnotes in a simpler way than
    // needed for labels.
    return start;
    /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("gfmFootnoteCall");
        effects.enter("gfmFootnoteCallLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallLabelMarker");
        return callStart;
    }
    /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function callStart(code) {
        if (code !== 94) return nok(code);
        effects.enter("gfmFootnoteCallMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallMarker");
        effects.enter("gfmFootnoteCallString");
        effects.enter("chunkString").contentType = "string";
        return callData;
    }
    /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */ function callData(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $7CNzt.markdownLineEndingOrSpace)(code)) return nok(code);
        if (code === 93) {
            effects.exit("chunkString");
            const token = effects.exit("gfmFootnoteCallString");
            if (!defined.includes((0, $f7Cpv.normalizeIdentifier)(self.sliceSerialize(token)))) return nok(code);
            effects.enter("gfmFootnoteCallLabelMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteCallLabelMarker");
            effects.exit("gfmFootnoteCall");
            return ok;
        }
        if (!(0, $7CNzt.markdownLineEndingOrSpace)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? callEscape : callData;
    }
    /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */ function callEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return callData;
        }
        return callData(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8dd94c42be62367f$var$tokenizeDefinitionStart(effects, ok, nok) {
    const self = this;
    /** @type {Array<string>} */ // @ts-expect-error It’s fine!
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {string} */ let identifier;
    let size = 0;
    /** @type {boolean | undefined} */ let data;
    return start;
    /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("gfmFootnoteDefinition")._container = true;
        effects.enter("gfmFootnoteDefinitionLabel");
        effects.enter("gfmFootnoteDefinitionLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteDefinitionLabelMarker");
        return labelAtMarker;
    }
    /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */ function labelAtMarker(code) {
        if (code === 94) {
            effects.enter("gfmFootnoteDefinitionMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteDefinitionMarker");
            effects.enter("gfmFootnoteDefinitionLabelString");
            effects.enter("chunkString").contentType = "string";
            return labelInside;
        }
        return nok(code);
    }
    /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $7CNzt.markdownLineEndingOrSpace)(code)) return nok(code);
        if (code === 93) {
            effects.exit("chunkString");
            const token = effects.exit("gfmFootnoteDefinitionLabelString");
            identifier = (0, $f7Cpv.normalizeIdentifier)(self.sliceSerialize(token));
            effects.enter("gfmFootnoteDefinitionLabelMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteDefinitionLabelMarker");
            effects.exit("gfmFootnoteDefinitionLabel");
            return labelAfter;
        }
        if (!(0, $7CNzt.markdownLineEndingOrSpace)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
    /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            if (!defined.includes(identifier)) defined.push(identifier);
            // Any whitespace after the marker is eaten, forming indented code
            // is not possible.
            // No space is also fine, just like a block quote marker.
            return (0, $ev8OE.factorySpace)(effects, whitespaceAfter, "gfmFootnoteDefinitionWhitespace");
        }
        return nok(code);
    }
    /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */ function whitespaceAfter(code) {
        // `markdown-rs` has a wrapping token for the prefix that is closed here.
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8dd94c42be62367f$var$tokenizeDefinitionContinuation(effects, ok, nok) {
    /// Start of footnote definition continuation.
    ///
    /// ```markdown
    ///   | [^a]: b
    /// > |     c
    ///     ^
    /// ```
    //
    // Either a blank line, which is okay, or an indented thing.
    return effects.check((0, $tOvBw.blankLine), ok, effects.attempt($8dd94c42be62367f$var$indent, ok, nok));
}
/** @type {Exiter} */ function $8dd94c42be62367f$var$gfmFootnoteDefinitionEnd(effects) {
    effects.exit("gfmFootnoteDefinition");
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8dd94c42be62367f$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $ev8OE.factorySpace)(effects, afterPrefix, "gfmFootnoteDefinitionIndent", 5);
    /**
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "gfmFootnoteDefinitionIndent" && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code) : nok(code);
    }
}

});

parcelRegister("152lW", function(module, exports) {

$parcel$export(module.exports, "gfmFootnoteHtml", () => $0c98155269306443$export$a731a1f6cf81900c);
/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @callback BackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   * `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   * `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   * `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {string} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent them from
 *   *clobbering*.
 *
 *   The default is `'user-content-'`.
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {string} [label='Footnotes']
 *   Textual label to use for the footnotes section.
 *
 *   The default value is `'Footnotes'`.
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different attributes with the `labelAttributes` option.
 * @property {string} [labelAttributes='class="sr-only"']
 *   Attributes to use on the footnote label.
 *
 *   Change it to show the label and add other attributes.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different attributes.
 *
 *   > 👉 **Note**: `id="footnote-label"` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string} [labelTagName='h2']
 *   HTML tag name to use for the footnote label element.
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different attributes with the `labelAttributes` option.
 * @property {BackLabelTemplate | string} [backLabel]
 *   Textual label to describe the backreference back to references.
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *  }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `aria-label` attribute on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 */ 
var $f7Cpv = parcelRequire("f7Cpv");

var $c6Rt9 = parcelRequire("c6Rt9");
const $0c98155269306443$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $0c98155269306443$var$emptyOptions = {};
function $0c98155269306443$export$a18c77a47f4154b6(referenceIndex, rereferenceIndex) {
    return "Back to reference " + (referenceIndex + 1) + (rereferenceIndex > 1 ? "-" + rereferenceIndex : "");
}
function $0c98155269306443$export$a731a1f6cf81900c(options) {
    const config = options || $0c98155269306443$var$emptyOptions;
    const label = config.label || "Footnotes";
    const labelTagName = config.labelTagName || "h2";
    const labelAttributes = config.labelAttributes === null || config.labelAttributes === undefined ? 'class="sr-only"' : config.labelAttributes;
    const backLabel = config.backLabel || $0c98155269306443$export$a18c77a47f4154b6;
    const clobberPrefix = config.clobberPrefix === null || config.clobberPrefix === undefined ? "user-content-" : config.clobberPrefix;
    return {
        enter: {
            gfmFootnoteDefinition () {
                const stack = this.getData("tightStack");
                stack.push(false);
            },
            gfmFootnoteDefinitionLabelString () {
                this.buffer();
            },
            gfmFootnoteCallString () {
                this.buffer();
            }
        },
        exit: {
            gfmFootnoteDefinition () {
                let definitions = this.getData("gfmFootnoteDefinitions");
                const footnoteStack = this.getData("gfmFootnoteDefinitionStack");
                const tightStack = this.getData("tightStack");
                const current = footnoteStack.pop();
                const value = this.resume();
                if (!definitions) this.setData("gfmFootnoteDefinitions", definitions = {});
                if (!$0c98155269306443$var$own.call(definitions, current)) definitions[current] = value;
                tightStack.pop();
                this.setData("slurpOneLineEnding", true);
                // “Hack” to prevent a line ending from showing up if we’re in a definition in
                // an empty list item.
                this.setData("lastWasTag");
            },
            gfmFootnoteDefinitionLabelString (token) {
                let footnoteStack = /** @type {Array<string>} */ this.getData("gfmFootnoteDefinitionStack");
                if (!footnoteStack) this.setData("gfmFootnoteDefinitionStack", footnoteStack = []);
                footnoteStack.push((0, $f7Cpv.normalizeIdentifier)(this.sliceSerialize(token)));
                this.resume() // Drop the label.
                ;
                this.buffer() // Get ready for a value.
                ;
            },
            gfmFootnoteCallString (token) {
                let calls = this.getData("gfmFootnoteCallOrder");
                let counts = this.getData("gfmFootnoteCallCounts");
                const id = (0, $f7Cpv.normalizeIdentifier)(this.sliceSerialize(token));
                /** @type {number} */ let counter;
                this.resume();
                if (!calls) this.setData("gfmFootnoteCallOrder", calls = []);
                if (!counts) this.setData("gfmFootnoteCallCounts", counts = {});
                const index = calls.indexOf(id);
                const safeId = (0, $c6Rt9.sanitizeUri)(id.toLowerCase());
                if (index === -1) {
                    calls.push(id);
                    counts[id] = 1;
                    counter = calls.length;
                } else {
                    counts[id]++;
                    counter = index + 1;
                }
                const reuseCounter = counts[id];
                this.tag('<sup><a href="#' + clobberPrefix + "fn-" + safeId + '" id="' + clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : "") + '" data-footnote-ref="" aria-describedby="footnote-label">' + String(counter) + "</a></sup>");
            },
            null () {
                const calls = /** @type {Array<string>} */ this.getData("gfmFootnoteCallOrder") || [];
                const counts = /** @type {Record<string, number>} */ this.getData("gfmFootnoteCallCounts") || {};
                const definitions = /** @type {Record<string, string>} */ this.getData("gfmFootnoteDefinitions") || {};
                let index = -1;
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('<section data-footnotes="" class="footnotes"><' + labelTagName + ' id="footnote-label"' + (labelAttributes ? " " + labelAttributes : "") + ">");
                    this.raw(this.encode(label));
                    this.tag("</" + labelTagName + ">");
                    this.lineEndingIfNeeded();
                    this.tag("<ol>");
                }
                while(++index < calls.length){
                    // Called definitions are always defined.
                    const id = calls[index];
                    const safeId = (0, $c6Rt9.sanitizeUri)(id.toLowerCase());
                    let referenceIndex = 0;
                    /** @type {Array<string>} */ const references = [];
                    while(++referenceIndex <= counts[id])references.push('<a href="#' + clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : "") + '" data-footnote-backref="" aria-label="' + this.encode(typeof backLabel === "string" ? backLabel : backLabel(index, referenceIndex)) + '" class="data-footnote-backref">\u21A9' + (referenceIndex > 1 ? "<sup>" + referenceIndex + "</sup>" : "") + "</a>");
                    const reference = references.join(" ");
                    let injected = false;
                    this.lineEndingIfNeeded();
                    this.tag('<li id="' + clobberPrefix + "fn-" + safeId + '">');
                    this.lineEndingIfNeeded();
                    this.tag(definitions[id].replace(/<\/p>(?:\r?\n|\r)?$/, (/** @type {string} */ $0)=>{
                        injected = true;
                        return " " + reference + $0;
                    }));
                    if (!injected) {
                        this.lineEndingIfNeeded();
                        this.tag(reference);
                    }
                    this.lineEndingIfNeeded();
                    this.tag("</li>");
                }
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag("</ol>");
                    this.lineEndingIfNeeded();
                    this.tag("</section>");
                }
            }
        }
    };
}

});

parcelRegister("682gL", function(module, exports) {

$parcel$export(module.exports, "gfmStrikethrough", () => $4765401757332b70$export$8bbec8ea1400a00e);
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean} [singleTilde=true]
 *   Whether to support strikethrough with a single tilde.
 *
 *   Single tildes work on github.com, but are technically prohibited by the
 *   GFM spec.
 */ 
var $eyVyf = parcelRequire("eyVyf");

var $9Mvoc = parcelRequire("9Mvoc");

var $9xN1y = parcelRequire("9xN1y");
function $4765401757332b70$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === "enter" && events[index][1].type === "strikethroughSequenceTemporary" && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === "exit" && events[open][1].type === "strikethroughSequenceTemporary" && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = "strikethroughSequence";
                events[open][1].type = "strikethroughSequence";
                /** @type {Token} */ const strikethrough = {
                    type: "strikethrough",
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: "strikethroughText",
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        "enter",
                        strikethrough,
                        context
                    ],
                    [
                        "enter",
                        events[open][1],
                        context
                    ],
                    [
                        "exit",
                        events[open][1],
                        context
                    ],
                    [
                        "enter",
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $eyVyf.splice)(nextEvents, nextEvents.length, 0, (0, $9xN1y.resolveAll)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $eyVyf.splice)(nextEvents, nextEvents.length, 0, [
                    [
                        "exit",
                        text,
                        context
                    ],
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        strikethrough,
                        context
                    ]
                ]);
                (0, $eyVyf.splice)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === "strikethroughSequenceTemporary") events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter("strikethroughSequenceTemporary");
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $9Mvoc.classifyCharacter)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit("strikethroughSequenceTemporary");
            const after = (0, $9Mvoc.classifyCharacter)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}

});

parcelRegister("iDa4T", function(module, exports) {

$parcel$export(module.exports, "gfmStrikethroughHtml", () => $d903afcd152aab66$export$58acedca46108820);
/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ // To do: next major: expose function instead of object.
/**
 * Extension for `micromark` that can be passed in `htmlExtensions`, to
 * support GFM strikethrough when serializing to HTML.
 *
 * @type {HtmlExtension}
 */ const $d903afcd152aab66$export$58acedca46108820 = {
    enter: {
        strikethrough () {
            this.tag("<del>");
        }
    },
    exit: {
        strikethrough () {
            this.tag("</del>");
        }
    }
};

});

parcelRegister("jX99x", function(module, exports) {

$parcel$export(module.exports, "gfmTable", () => $e86aa090c6f42fe8$export$e36cebda627bf2dd);
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 
var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");

var $dXFKG = parcelRequire("dXFKG");

var $ghZOc = parcelRequire("ghZOc");
const $e86aa090c6f42fe8$export$e36cebda627bf2dd = {
    flow: {
        null: {
            tokenize: $e86aa090c6f42fe8$var$tokenizeTable,
            resolveAll: $e86aa090c6f42fe8$var$resolveTable
        }
    }
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e86aa090c6f42fe8$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === "tableHead" || tail === "tableRow" ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter("tableHead");
        effects.enter("tableRow");
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $7CNzt.markdownLineEnding)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit("tableRow");
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $7CNzt.markdownSpace)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $ev8OE.factorySpace)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $7CNzt.markdownLineEndingOrSpace)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter("tableDelimiterRow");
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $7CNzt.markdownSpace)(code)) return (0, $ev8OE.factorySpace)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $7CNzt.markdownSpace)(code)) return (0, $ev8OE.factorySpace)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter("tableDelimiterFiller");
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit("tableDelimiterFiller");
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit("tableDelimiterFiller");
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $7CNzt.markdownSpace)(code)) return (0, $ev8OE.factorySpace)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit("tableDelimiterRow");
            effects.exit("tableHead");
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter("tableRow");
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return bodyRowBreak;
        }
        if (code === null || (0, $7CNzt.markdownLineEnding)(code)) {
            effects.exit("tableRow");
            return ok(code);
        }
        if ((0, $7CNzt.markdownSpace)(code)) return (0, $ev8OE.factorySpace)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $7CNzt.markdownLineEndingOrSpace)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ // eslint-disable-next-line complexity
function $e86aa090c6f42fe8$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $dXFKG.EditMap)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === "enter") {
            // Start of head.
            if (token.type === "tableHead") {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $e86aa090c6f42fe8$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: "table",
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        "enter",
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: "tableBody",
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            "enter",
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === "tableDelimiterRow" ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $e86aa090c6f42fe8$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === "tableCellDivider") {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $e86aa090c6f42fe8$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === "tableHead") {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $e86aa090c6f42fe8$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $e86aa090c6f42fe8$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) cell[3] = index;
    }
    if (lastTableEnd !== 0) $e86aa090c6f42fe8$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === "enter" && event[1].type === "table") event[1]._align = (0, $ghZOc.gfmTableAlign)(context.events, index);
    }
    return events;
}
/// Generate a cell.
/**
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {Range} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $e86aa090c6f42fe8$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? "tableHeader" : rowKind === 2 ? "tableDelimiter" : "tableData";
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = "tableContent";
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $e86aa090c6f42fe8$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $e86aa090c6f42fe8$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            "enter",
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $e86aa090c6f42fe8$var$getPoint(context.events, range[2]);
        const relatedEnd = $e86aa090c6f42fe8$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                "enter",
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                "exit",
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $e86aa090c6f42fe8$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $e86aa090c6f42fe8$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $e86aa090c6f42fe8$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            "exit",
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        "exit",
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {readonly Point}
 */ function $e86aa090c6f42fe8$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === "enter" ? "start" : "end";
    return event[1][side];
}

});
parcelRegister("dXFKG", function(module, exports) {

$parcel$export(module.exports, "EditMap", () => $a2a12c194268ac49$export$9348908dd4518b4a);
/**
 * @typedef {import('micromark-util-types').Event} Event
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $a2a12c194268ac49$export$9348908dd4518b4a {
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {void}
   */ add(index, remove, add) {
        $a2a12c194268ac49$var$addImpl(this, index, remove, add);
    }
    // To do: not used here.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {void}
    //  */
    // addBefore(index, remove, add) {
    //   addImpl(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {void}
   */ consume(events) {
        this.map.sort((a, b)=>a[0] - b[0]);
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]));
            // eslint-disable-next-line unicorn/no-array-push-push
            vecs.push(this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push([
            ...events
        ]);
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            events.push(...slice);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {void}
 */ function $a2a12c194268ac49$var$addImpl(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       console.log('to do: links?', add, rmCurr)
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }

});

parcelRegister("ghZOc", function(module, exports) {

$parcel$export(module.exports, "gfmTableAlign", () => $bdbe2dca83f7355e$export$bbf4fe2c547a4878);
/**
 * @typedef {import('micromark-util-types').Event} Event
 */ /**
 * @typedef {'left' | 'center' | 'right' | 'none'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {Array<Align>}
 */ function $bdbe2dca83f7355e$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === "enter") // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === "tableContent") align.push(events[index + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
            } else if (event[1].type === "tableContent") {
                if (events[index - 1][1].type === "tableDelimiterMarker") {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === "left" ? "center" : "right";
                }
            } else if (event[1].type === "tableDelimiterRow") break;
        } else if (event[0] === "enter" && event[1].type === "tableDelimiterRow") inDelimiterRow = true;
        index += 1;
    }
    return align;
}

});


parcelRegister("7IWtF", function(module, exports) {

$parcel$export(module.exports, "gfmTableHtml", () => $59fa00e22c932359$export$c64626c032567c7f);
/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @typedef {import('./infer.js').Align} Align
 */ const $59fa00e22c932359$var$alignment = {
    none: "",
    left: ' align="left"',
    right: ' align="right"',
    center: ' align="center"'
};
const $59fa00e22c932359$export$c64626c032567c7f = {
    enter: {
        table (token) {
            const tableAlign = token._align;
            this.lineEndingIfNeeded();
            this.tag("<table>");
            this.setData("tableAlign", tableAlign);
        },
        tableBody () {
            this.tag("<tbody>");
        },
        tableData () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            const align = $59fa00e22c932359$var$alignment[tableAlign[tableColumn]];
            if (align === undefined) // Capture results to ignore them.
            this.buffer();
            else {
                this.lineEndingIfNeeded();
                this.tag("<td" + align + ">");
            }
        },
        tableHead () {
            this.lineEndingIfNeeded();
            this.tag("<thead>");
        },
        tableHeader () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            const align = $59fa00e22c932359$var$alignment[tableAlign[tableColumn]];
            this.lineEndingIfNeeded();
            this.tag("<th" + align + ">");
        },
        tableRow () {
            this.setData("tableColumn", 0);
            this.lineEndingIfNeeded();
            this.tag("<tr>");
        }
    },
    exit: {
        // Overwrite the default code text data handler to unescape escaped pipes when
        // they are in tables.
        codeTextData (token) {
            let value = this.sliceSerialize(token);
            if (this.getData("tableAlign")) value = value.replace(/\\([\\|])/g, $59fa00e22c932359$var$replace);
            this.raw(this.encode(value));
        },
        table () {
            this.setData("tableAlign");
            // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
            // but we do need to reset it to match a funky newline GH generates for
            // list items combined with tables.
            this.setData("slurpAllLineEndings");
            this.lineEndingIfNeeded();
            this.tag("</table>");
        },
        tableBody () {
            this.lineEndingIfNeeded();
            this.tag("</tbody>");
        },
        tableData () {
            const tableAlign = this.getData("tableAlign");
            const tableColumn = this.getData("tableColumn");
            if (tableColumn in tableAlign) {
                this.tag("</td>");
                this.setData("tableColumn", tableColumn + 1);
            } else // Stop capturing.
            this.resume();
        },
        tableHead () {
            this.lineEndingIfNeeded();
            this.tag("</thead>");
        },
        tableHeader () {
            const tableColumn = this.getData("tableColumn");
            this.tag("</th>");
            this.setData("tableColumn", tableColumn + 1);
        },
        tableRow () {
            const tableAlign = this.getData("tableAlign");
            let tableColumn = this.getData("tableColumn");
            while(tableColumn < tableAlign.length){
                this.lineEndingIfNeeded();
                this.tag("<td" + $59fa00e22c932359$var$alignment[tableAlign[tableColumn]] + "></td>");
                tableColumn++;
            }
            this.setData("tableColumn", tableColumn);
            this.lineEndingIfNeeded();
            this.tag("</tr>");
        }
    }
};
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $59fa00e22c932359$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}

});

parcelRegister("jaRVk", function(module, exports) {

$parcel$export(module.exports, "gfmTagfilterHtml", () => $df58c7a1eacd3c40$export$c9bf87ea36d00682);
/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ // An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
const $df58c7a1eacd3c40$var$reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
const $df58c7a1eacd3c40$var$reText = new RegExp("^" + $df58c7a1eacd3c40$var$reFlow.source, "i");
const $df58c7a1eacd3c40$export$c9bf87ea36d00682 = {
    exit: {
        htmlFlowData (token) {
            $df58c7a1eacd3c40$var$exitHtmlData.call(this, token, $df58c7a1eacd3c40$var$reFlow);
        },
        htmlTextData (token) {
            $df58c7a1eacd3c40$var$exitHtmlData.call(this, token, $df58c7a1eacd3c40$var$reText);
        }
    }
};
/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 */ function $df58c7a1eacd3c40$var$exitHtmlData(token, filter) {
    let value = this.sliceSerialize(token);
    if (this.options.allowDangerousHtml) value = value.replace(filter, "&lt;$1$2");
    this.raw(this.encode(value));
}

});

parcelRegister("9gvDj", function(module, exports) {

$parcel$export(module.exports, "gfmTaskListItem", () => $6bee2559a72e66ba$export$2912e8b2802475ff);
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
var $ev8OE = parcelRequire("ev8OE");

var $7CNzt = parcelRequire("7CNzt");
const $6bee2559a72e66ba$var$tasklistCheck = {
    tokenize: $6bee2559a72e66ba$var$tokenizeTasklistCheck
};
const $6bee2559a72e66ba$export$2912e8b2802475ff = {
    text: {
        [91]: $6bee2559a72e66ba$var$tasklistCheck
    }
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6bee2559a72e66ba$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter("taskListCheck");
        effects.enter("taskListCheckMarker");
        effects.consume(code);
        effects.exit("taskListCheckMarker");
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $7CNzt.markdownLineEndingOrSpace)(code)) {
            effects.enter("taskListCheckValueUnchecked");
            effects.consume(code);
            effects.exit("taskListCheckValueUnchecked");
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter("taskListCheckValueChecked");
            effects.consume(code);
            effects.exit("taskListCheckValueChecked");
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter("taskListCheckMarker");
            effects.consume(code);
            effects.exit("taskListCheckMarker");
            effects.exit("taskListCheck");
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $7CNzt.markdownLineEnding)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $7CNzt.markdownSpace)(code)) return effects.check({
            tokenize: $6bee2559a72e66ba$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6bee2559a72e66ba$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $ev8OE.factorySpace)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}

});

parcelRegister("l3lj7", function(module, exports) {

$parcel$export(module.exports, "gfmTaskListItemHtml", () => $03f48e108084b00f$export$4b6a13e2af1b08ed);
/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ // To do: next major: expose function to make extension.
/**
 * Extension for `micromark` that can be passed in `htmlExtensions` to
 * support GFM task list items when serializing to HTML.
 *
 * @type {HtmlExtension}
 */ const $03f48e108084b00f$export$4b6a13e2af1b08ed = {
    enter: {
        taskListCheck () {
            this.tag('<input type="checkbox" disabled="" ');
        }
    },
    exit: {
        taskListCheck () {
            this.tag("/>");
        },
        taskListCheckValueChecked () {
            this.tag('checked="" ');
        }
    }
};

});


parcelRegister("8fd5h", function(module, exports) {

$parcel$export(module.exports, "gfmFromMarkdown", () => $6009dfabd2898e3d$export$95adae814eb7433e);
$parcel$export(module.exports, "gfmToMarkdown", () => $6009dfabd2898e3d$export$ea77de6901e7c72b);
/**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * @typedef {import('mdast-util-gfm-table').Options} Options
 *   Configuration.
 */ 
var $ctfhj = parcelRequire("ctfhj");

var $a5HIk = parcelRequire("a5HIk");

var $aCHGY = parcelRequire("aCHGY");

var $en1Am = parcelRequire("en1Am");

var $itovu = parcelRequire("itovu");
function $6009dfabd2898e3d$export$95adae814eb7433e() {
    return [
        (0, $ctfhj.gfmAutolinkLiteralFromMarkdown),
        (0, $a5HIk.gfmFootnoteFromMarkdown)(),
        (0, $aCHGY.gfmStrikethroughFromMarkdown),
        (0, $en1Am.gfmTableFromMarkdown),
        (0, $itovu.gfmTaskListItemFromMarkdown)
    ];
}
function $6009dfabd2898e3d$export$ea77de6901e7c72b(options) {
    return {
        extensions: [
            (0, $ctfhj.gfmAutolinkLiteralToMarkdown),
            (0, $a5HIk.gfmFootnoteToMarkdown)(),
            (0, $aCHGY.gfmStrikethroughToMarkdown),
            (0, $en1Am.gfmTableToMarkdown)(options),
            (0, $itovu.gfmTaskListItemToMarkdown)
        ]
    };
}

});
parcelRegister("ctfhj", function(module, exports) {

$parcel$export(module.exports, "gfmAutolinkLiteralFromMarkdown", () => $91440b68c297e1f6$export$b6afdfff2163546f);
$parcel$export(module.exports, "gfmAutolinkLiteralToMarkdown", () => $91440b68c297e1f6$export$d3ace9096b01c39d);
/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-from-markdown').Transform} FromMarkdownTransform
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-find-and-replace').ReplaceFunction} ReplaceFunction
 * @typedef {import('mdast-util-find-and-replace').RegExpMatchObject} RegExpMatchObject
 */ 
var $cj5HP = parcelRequire("cj5HP");

var $iX2vW = parcelRequire("iX2vW");

var $7CNzt = parcelRequire("7CNzt");
/** @type {ConstructName} */ const $91440b68c297e1f6$var$inConstruct = "phrasing";
/** @type {Array<ConstructName>} */ const $91440b68c297e1f6$var$notInConstruct = [
    "autolink",
    "link",
    "image",
    "label"
];
const $91440b68c297e1f6$export$b6afdfff2163546f = {
    transforms: [
        $91440b68c297e1f6$var$transformGfmAutolinkLiterals
    ],
    enter: {
        literalAutolink: $91440b68c297e1f6$var$enterLiteralAutolink,
        literalAutolinkEmail: $91440b68c297e1f6$var$enterLiteralAutolinkValue,
        literalAutolinkHttp: $91440b68c297e1f6$var$enterLiteralAutolinkValue,
        literalAutolinkWww: $91440b68c297e1f6$var$enterLiteralAutolinkValue
    },
    exit: {
        literalAutolink: $91440b68c297e1f6$var$exitLiteralAutolink,
        literalAutolinkEmail: $91440b68c297e1f6$var$exitLiteralAutolinkEmail,
        literalAutolinkHttp: $91440b68c297e1f6$var$exitLiteralAutolinkHttp,
        literalAutolinkWww: $91440b68c297e1f6$var$exitLiteralAutolinkWww
    }
};
const $91440b68c297e1f6$export$d3ace9096b01c39d = {
    unsafe: [
        {
            character: "@",
            before: "[+\\-.\\w]",
            after: "[\\-.\\w]",
            inConstruct: $91440b68c297e1f6$var$inConstruct,
            notInConstruct: $91440b68c297e1f6$var$notInConstruct
        },
        {
            character: ".",
            before: "[Ww]",
            after: "[\\-.\\w]",
            inConstruct: $91440b68c297e1f6$var$inConstruct,
            notInConstruct: $91440b68c297e1f6$var$notInConstruct
        },
        {
            character: ":",
            before: "[ps]",
            after: "\\/",
            inConstruct: $91440b68c297e1f6$var$inConstruct,
            notInConstruct: $91440b68c297e1f6$var$notInConstruct
        }
    ]
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $91440b68c297e1f6$var$enterLiteralAutolink(token) {
    this.enter({
        type: "link",
        title: null,
        url: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $91440b68c297e1f6$var$enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $91440b68c297e1f6$var$exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $91440b68c297e1f6$var$exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    const node = /** @type {Link} */ this.stack[this.stack.length - 1];
    node.url = "http://" + this.sliceSerialize(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $91440b68c297e1f6$var$exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $91440b68c297e1f6$var$exitLiteralAutolink(token) {
    this.exit(token);
}
/** @type {FromMarkdownTransform} */ function $91440b68c297e1f6$var$transformGfmAutolinkLiterals(tree) {
    (0, $iX2vW.findAndReplace)(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi,
            $91440b68c297e1f6$var$findUrl
        ],
        [
            /([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g,
            $91440b68c297e1f6$var$findEmail
        ]
    ], {
        ignore: [
            "link",
            "linkReference"
        ]
    });
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Link | Array<PhrasingContent> | false}
 */ // eslint-disable-next-line max-params
function $91440b68c297e1f6$var$findUrl(_, protocol, domain, path, match) {
    let prefix = "";
    // Not an expected previous character.
    if (!$91440b68c297e1f6$var$previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = "";
        prefix = "http://";
    }
    if (!$91440b68c297e1f6$var$isCorrectDomain(domain)) return false;
    const parts = $91440b68c297e1f6$var$splitUrl(domain + path);
    if (!parts[0]) return false;
    /** @type {Link} */ const result = {
        type: "link",
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: "text",
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) return [
        result,
        {
            type: "text",
            value: parts[1]
        }
    ];
    return result;
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */ function $91440b68c297e1f6$var$findEmail(_, atext, label, match) {
    if (// Not an expected previous character.
    !$91440b68c297e1f6$var$previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)) return false;
    return {
        type: "link",
        title: null,
        url: "mailto:" + atext + "@" + label,
        children: [
            {
                type: "text",
                value: atext + "@" + label
            }
        ]
    };
}
/**
 * @param {string} domain
 * @returns {boolean}
 */ function $91440b68c297e1f6$var$isCorrectDomain(domain) {
    const parts = domain.split(".");
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */ function $91440b68c297e1f6$var$splitUrl(url) {
    const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
    if (!trailExec) return [
        url,
        undefined
    ];
    url = url.slice(0, trailExec.index);
    let trail = trailExec[0];
    let closingParenIndex = trail.indexOf(")");
    const openingParens = (0, $cj5HP.ccount)(url, "(");
    let closingParens = (0, $cj5HP.ccount)(url, ")");
    while(closingParenIndex !== -1 && openingParens > closingParens){
        url += trail.slice(0, closingParenIndex + 1);
        trail = trail.slice(closingParenIndex + 1);
        closingParenIndex = trail.indexOf(")");
        closingParens++;
    }
    return [
        url,
        trail
    ];
}
/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */ function $91440b68c297e1f6$var$previous(match, email) {
    const code = match.input.charCodeAt(match.index - 1);
    return (match.index === 0 || (0, $7CNzt.unicodeWhitespace)(code) || (0, $7CNzt.unicodePunctuation)(code)) && (!email || code !== 47);
}

});
parcelRegister("cj5HP", function(module, exports) {

$parcel$export(module.exports, "ccount", () => $8f5baf78cd48ec9c$export$fa42eaa97a352e23);
/**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $8f5baf78cd48ec9c$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== "string") throw new TypeError("Expected character");
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}

});

parcelRegister("iX2vW", function(module, exports) {

$parcel$export(module.exports, "findAndReplace", () => $dcbfafeeddb94f96$export$fb306ebf003fc574);
/**
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Text} Text
 * @typedef {import('unist-util-visit-parents').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Content | Root} Node
 * @typedef {Extract<Node, MdastParent>} Parent
 * @typedef {Exclude<Parent, Root>} ContentParent
 *
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[Root, ...Array<ContentParent>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | undefined | null}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {string | RegExp} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 * @typedef {Record<string, Replace>} FindAndReplaceSchema
 *   Several find and replaces, in object form.
 * @typedef {[Find, Replace]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 * @typedef {string | ReplaceFunction} Replace
 *   Thing to replace with.
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore.
 */ 
var $2t9Rk = parcelRequire("2t9Rk");

var $9tBQd = parcelRequire("9tBQd");

var $j19vp = parcelRequire("j19vp");
const $dcbfafeeddb94f96$var$own = {}.hasOwnProperty;
const $dcbfafeeddb94f96$export$fb306ebf003fc574 = /**
   * @type {(
   *   (<Tree extends Node>(tree: Tree, find: Find, replace?: Replace | null | undefined, options?: Options | null | undefined) => Tree) &
   *   (<Tree extends Node>(tree: Tree, schema: FindAndReplaceSchema | FindAndReplaceList, options?: Options | null | undefined) => Tree)
   * )}
   **/ /**
     * @template {Node} Tree
     * @param {Tree} tree
     * @param {Find | FindAndReplaceSchema | FindAndReplaceList} find
     * @param {Replace | Options | null | undefined} [replace]
     * @param {Options | null | undefined} [options]
     * @returns {Tree}
     */ function(tree, find, replace, options) {
    /** @type {Options | null | undefined} */ let settings;
    /** @type {FindAndReplaceSchema|FindAndReplaceList} */ let schema;
    if (typeof find === "string" || find instanceof RegExp) {
        // @ts-expect-error don’t expect options twice.
        schema = [
            [
                find,
                replace
            ]
        ];
        settings = options;
    } else {
        schema = find;
        // @ts-expect-error don’t expect replace twice.
        settings = replace;
    }
    if (!settings) settings = {};
    const ignored = (0, $j19vp.convert)(settings.ignore || []);
    const pairs = $dcbfafeeddb94f96$var$toPairs(schema);
    let pairIndex = -1;
    while(++pairIndex < pairs.length)(0, $9tBQd.visitParents)(tree, "text", visitor);
    // To do next major: don’t return the given tree.
    return tree;
    /** @type {import('unist-util-visit-parents/complex-types.js').BuildVisitor<Root, 'text'>} */ function visitor(node, parents) {
        let index = -1;
        /** @type {Parent | undefined} */ let grandparent;
        while(++index < parents.length){
            const parent = parents[index];
            if (ignored(parent, // @ts-expect-error: TS doesn’t understand but it’s perfect.
            grandparent ? grandparent.children.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        if (grandparent) return handler(node, parents);
    }
    /**
       * Handle a text node which is not in an ignored parent.
       *
       * @param {Text} node
       *   Text node.
       * @param {Array<Parent>} parents
       *   Parents.
       * @returns {VisitorResult}
       *   Result.
       */ function handler(node, parents) {
        const parent = parents[parents.length - 1];
        const find = pairs[pairIndex][0];
        const replace = pairs[pairIndex][1];
        let start = 0;
        // @ts-expect-error: TS is wrong, some of these children can be text.
        const index = parent.children.indexOf(node);
        let change = false;
        /** @type {Array<PhrasingContent>} */ let nodes = [];
        find.lastIndex = 0;
        let match = find.exec(node.value);
        while(match){
            const position = match.index;
            /** @type {RegExpMatchObject} */ const matchObject = {
                index: match.index,
                input: match.input,
                // @ts-expect-error: stack is fine.
                stack: [
                    ...parents,
                    node
                ]
            };
            let value = replace(...match, matchObject);
            if (typeof value === "string") value = value.length > 0 ? {
                type: "text",
                value: value
            } : undefined;
            // It wasn’t a match after all.
            if (value !== false) {
                if (start !== position) nodes.push({
                    type: "text",
                    value: node.value.slice(start, position)
                });
                if (Array.isArray(value)) nodes.push(...value);
                else if (value) nodes.push(value);
                start = position + match[0].length;
                change = true;
            }
            if (!find.global) break;
            match = find.exec(node.value);
        }
        if (change) {
            if (start < node.value.length) nodes.push({
                type: "text",
                value: node.value.slice(start)
            });
            parent.children.splice(index, 1, ...nodes);
        } else nodes = [
            node
        ];
        return index + nodes.length;
    }
};
/**
 * Turn a schema into pairs.
 *
 * @param {FindAndReplaceSchema | FindAndReplaceList} schema
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */ function $dcbfafeeddb94f96$var$toPairs(schema) {
    /** @type {Pairs} */ const result = [];
    if (typeof schema !== "object") throw new TypeError("Expected array or object as schema");
    if (Array.isArray(schema)) {
        let index = -1;
        while(++index < schema.length)result.push([
            $dcbfafeeddb94f96$var$toExpression(schema[index][0]),
            $dcbfafeeddb94f96$var$toFunction(schema[index][1])
        ]);
    } else {
        /** @type {string} */ let key;
        for(key in schema)if ($dcbfafeeddb94f96$var$own.call(schema, key)) result.push([
            $dcbfafeeddb94f96$var$toExpression(key),
            $dcbfafeeddb94f96$var$toFunction(schema[key])
        ]);
    }
    return result;
}
/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */ function $dcbfafeeddb94f96$var$toExpression(find) {
    return typeof find === "string" ? new RegExp((0, $2t9Rk.default)(find), "g") : find;
}
/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */ function $dcbfafeeddb94f96$var$toFunction(replace) {
    return typeof replace === "function" ? replace : ()=>replace;
}

});
parcelRegister("2t9Rk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cc5f00ac6c69765$export$2e2bcd8739ae039);
function $1cc5f00ac6c69765$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}

});



parcelRegister("a5HIk", function(module, exports) {

$parcel$export(module.exports, "gfmFootnoteFromMarkdown", () => $758c47b211fe0c42$export$c9d5ad4bdf6ff801);
$parcel$export(module.exports, "gfmFootnoteToMarkdown", () => $758c47b211fe0c42$export$3727766a73a6c09f);
/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Map} Map
 */ 
var $f7Cpv = parcelRequire("f7Cpv");

var $kQSyy = parcelRequire("kQSyy");

var $gtoEE = parcelRequire("gtoEE");

var $4NUxg = parcelRequire("4NUxg");

var $2cNBD = parcelRequire("2cNBD");

var $4oDzZ = parcelRequire("4oDzZ");
$758c47b211fe0c42$var$footnoteReference.peek = $758c47b211fe0c42$var$footnoteReferencePeek;
function $758c47b211fe0c42$export$c9d5ad4bdf6ff801() {
    return {
        enter: {
            gfmFootnoteDefinition: $758c47b211fe0c42$var$enterFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $758c47b211fe0c42$var$enterFootnoteDefinitionLabelString,
            gfmFootnoteCall: $758c47b211fe0c42$var$enterFootnoteCall,
            gfmFootnoteCallString: $758c47b211fe0c42$var$enterFootnoteCallString
        },
        exit: {
            gfmFootnoteDefinition: $758c47b211fe0c42$var$exitFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $758c47b211fe0c42$var$exitFootnoteDefinitionLabelString,
            gfmFootnoteCall: $758c47b211fe0c42$var$exitFootnoteCall,
            gfmFootnoteCallString: $758c47b211fe0c42$var$exitFootnoteCallString
        }
    };
}
function $758c47b211fe0c42$export$3727766a73a6c09f() {
    return {
        // This is on by default already.
        unsafe: [
            {
                character: "[",
                inConstruct: [
                    "phrasing",
                    "label",
                    "reference"
                ]
            }
        ],
        handlers: {
            footnoteDefinition: $758c47b211fe0c42$var$footnoteDefinition,
            footnoteReference: $758c47b211fe0c42$var$footnoteReference
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $758c47b211fe0c42$var$enterFootnoteDefinition(token) {
    this.enter({
        type: "footnoteDefinition",
        identifier: "",
        label: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $758c47b211fe0c42$var$enterFootnoteDefinitionLabelString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $758c47b211fe0c42$var$exitFootnoteDefinitionLabelString(token) {
    const label = this.resume();
    const node = /** @type {FootnoteDefinition} */ this.stack[this.stack.length - 1];
    node.label = label;
    node.identifier = (0, $f7Cpv.normalizeIdentifier)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $758c47b211fe0c42$var$exitFootnoteDefinition(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $758c47b211fe0c42$var$enterFootnoteCall(token) {
    this.enter({
        type: "footnoteReference",
        identifier: "",
        label: ""
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $758c47b211fe0c42$var$enterFootnoteCallString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $758c47b211fe0c42$var$exitFootnoteCallString(token) {
    const label = this.resume();
    const node = /** @type {FootnoteDefinition} */ this.stack[this.stack.length - 1];
    node.label = label;
    node.identifier = (0, $f7Cpv.normalizeIdentifier)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $758c47b211fe0c42$var$exitFootnoteCall(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */ function $758c47b211fe0c42$var$footnoteReference(node, _, context, safeOptions) {
    const tracker = (0, $4oDzZ.track)(safeOptions);
    let value = tracker.move("[^");
    const exit = context.enter("footnoteReference");
    const subexit = context.enter("reference");
    value += tracker.move((0, $2cNBD.safe)(context, (0, $kQSyy.association)(node), {
        ...tracker.current(),
        before: value,
        after: "]"
    }));
    subexit();
    exit();
    value += tracker.move("]");
    return value;
}
/** @type {ToMarkdownHandle} */ function $758c47b211fe0c42$var$footnoteReferencePeek() {
    return "[";
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteDefinition} node
 */ function $758c47b211fe0c42$var$footnoteDefinition(node, _, context, safeOptions) {
    const tracker = (0, $4oDzZ.track)(safeOptions);
    let value = tracker.move("[^");
    const exit = context.enter("footnoteDefinition");
    const subexit = context.enter("label");
    value += tracker.move((0, $2cNBD.safe)(context, (0, $kQSyy.association)(node), {
        ...tracker.current(),
        before: value,
        after: "]"
    }));
    subexit();
    value += tracker.move("]:" + (node.children && node.children.length > 0 ? " " : ""));
    tracker.shift(4);
    value += tracker.move((0, $4NUxg.indentLines)((0, $gtoEE.containerFlow)(node, context, tracker.current()), $758c47b211fe0c42$var$map));
    exit();
    return value;
}
/** @type {Map} */ function $758c47b211fe0c42$var$map(line, index, blank) {
    if (index === 0) return line;
    return (blank ? "" : "    ") + line;
}

});
parcelRegister("kQSyy", function(module, exports) {

$parcel$export(module.exports, "association", () => $f2e2fbb8b844d9e0$export$c4ca1a6065421754);
/**
 * @typedef {import('../types.js').AssociationId} AssociationId
 */ 
var $aF3E2 = parcelRequire("aF3E2");
function $f2e2fbb8b844d9e0$export$c4ca1a6065421754(node) {
    if (node.label || !node.identifier) return node.label || "";
    return (0, $aF3E2.decodeString)(node.identifier);
}

});

parcelRegister("gtoEE", function(module, exports) {

$parcel$export(module.exports, "containerFlow", () => $bfe27aaf64af958c$export$134f7fdacfea8b16);
/**
 * @typedef {import('../types.js').FlowContent} FlowContent
 * @typedef {import('../types.js').Node} Node
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').TrackFields} TrackFields
 */ /**
 * @param {Parent & {children: Array<FlowContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $bfe27aaf64af958c$export$134f7fdacfea8b16(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    const tracker = state.createTracker(info);
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    indexStack.push(-1);
    while(++index < children.length){
        const child = children[index];
        indexStack[indexStack.length - 1] = index;
        results.push(tracker.move(state.handle(child, parent, state, {
            before: "\n",
            after: "\n",
            ...tracker.current()
        })));
        if (child.type !== "list") state.bulletLastUsed = undefined;
        if (index < children.length - 1) results.push(tracker.move($bfe27aaf64af958c$var$between(child, children[index + 1], parent, state)));
    }
    indexStack.pop();
    return results.join("");
}
/**
 * @param {Node} left
 * @param {Node} right
 * @param {Parent} parent
 * @param {State} state
 * @returns {string}
 */ function $bfe27aaf64af958c$var$between(left, right, parent, state) {
    let index = state.join.length;
    while(index--){
        const result = state.join[index](left, right, parent, state);
        if (result === true || result === 1) break;
        if (typeof result === "number") return "\n".repeat(1 + result);
        if (result === false) return "\n\n<!---->\n\n";
    }
    return "\n\n";
}

});

parcelRegister("4NUxg", function(module, exports) {

$parcel$export(module.exports, "indentLines", () => $37f797cbd8ad3f75$export$7c3cf23d514b264a);
/**
 * @typedef {import('../types.js').IndentLines} IndentLines
 */ const $37f797cbd8ad3f75$var$eol = /\r?\n|\r/g;
function $37f797cbd8ad3f75$export$7c3cf23d514b264a(value, map) {
    /** @type {Array<string>} */ const result = [];
    let start = 0;
    let line = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = $37f797cbd8ad3f75$var$eol.exec(value)){
        one(value.slice(start, match.index));
        result.push(match[0]);
        start = match.index + match[0].length;
        line++;
    }
    one(value.slice(start));
    return result.join("");
    /**
   * @param {string} value
   */ function one(value) {
        result.push(map(value, line, !value));
    }
}

});

parcelRegister("2cNBD", function(module, exports) {

$parcel$export(module.exports, "safe", () => $19b32e7cd2aac7a4$export$170b8c323eee7bec);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').SafeConfig} SafeConfig
 */ 
var $haLLe = parcelRequire("haLLe");

var $flRS6 = parcelRequire("flRS6");
function $19b32e7cd2aac7a4$export$170b8c323eee7bec(state, input, config) {
    const value = (config.before || "") + (input || "") + (config.after || "");
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const result = [];
    /** @type {Record<number, {before: boolean, after: boolean}>} */ const infos = {};
    let index = -1;
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        if (!(0, $flRS6.patternInScope)(state.stack, pattern)) continue;
        const expression = (0, $haLLe.patternCompile)(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        while(match = expression.exec(value)){
            const before = "before" in pattern || Boolean(pattern.atBreak);
            const after = "after" in pattern;
            const position = match.index + (before ? match[1].length : 0);
            if (positions.includes(position)) {
                if (infos[position].before && !before) infos[position].before = false;
                if (infos[position].after && !after) infos[position].after = false;
            } else {
                positions.push(position);
                infos[position] = {
                    before: before,
                    after: after
                };
            }
        }
    }
    positions.sort($19b32e7cd2aac7a4$var$numerical);
    let start = config.before ? config.before.length : 0;
    const end = value.length - (config.after ? config.after.length : 0);
    index = -1;
    while(++index < positions.length){
        const position = positions[index];
        // Character before or after matched:
        if (position < start || position >= end) continue;
        // If this character is supposed to be escaped because it has a condition on
        // the next character, and the next character is definitly being escaped,
        // then skip this escape.
        if (position + 1 < end && positions[index + 1] === position + 1 && infos[position].after && !infos[position + 1].before && !infos[position + 1].after || positions[index - 1] === position - 1 && infos[position].before && !infos[position - 1].before && !infos[position - 1].after) continue;
        if (start !== position) // If we have to use a character reference, an ampersand would be more
        // correct, but as backslashes only care about punctuation, either will
        // do the trick
        result.push($19b32e7cd2aac7a4$var$escapeBackslashes(value.slice(start, position), "\\"));
        start = position;
        if (/[!-/:-@[-`{-~]/.test(value.charAt(position)) && (!config.encode || !config.encode.includes(value.charAt(position)))) // Character escape.
        result.push("\\");
        else {
            // Character reference.
            result.push("&#x" + value.charCodeAt(position).toString(16).toUpperCase() + ";");
            start++;
        }
    }
    result.push($19b32e7cd2aac7a4$var$escapeBackslashes(value.slice(start, end), config.after));
    return result.join("");
}
/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */ function $19b32e7cd2aac7a4$var$numerical(a, b) {
    return a - b;
}
/**
 * @param {string} value
 * @param {string} after
 * @returns {string}
 */ function $19b32e7cd2aac7a4$var$escapeBackslashes(value, after) {
    const expression = /\\(?=[!-/:-@[-`{-~])/g;
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const results = [];
    const whole = value + after;
    let index = -1;
    let start = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = expression.exec(whole))positions.push(match.index);
    while(++index < positions.length){
        if (start !== positions[index]) results.push(value.slice(start, positions[index]));
        results.push("\\");
        start = positions[index];
    }
    results.push(value.slice(start));
    return results.join("");
}

});
parcelRegister("haLLe", function(module, exports) {

$parcel$export(module.exports, "patternCompile", () => $c8086b24d5de0f26$export$7993761911514c15);
/**
 * @typedef {import('../types.js').Unsafe} Unsafe
 */ /**
 * @param {Unsafe} pattern
 * @returns {RegExp}
 */ function $c8086b24d5de0f26$export$7993761911514c15(pattern) {
    if (!pattern._compiled) {
        const before = (pattern.atBreak ? "[\\r\\n][\\t ]*" : "") + (pattern.before ? "(?:" + pattern.before + ")" : "");
        pattern._compiled = new RegExp((before ? "(" + before + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? "\\" : "") + pattern.character + (pattern.after ? "(?:" + pattern.after + ")" : ""), "g");
    }
    return pattern._compiled;
}

});

parcelRegister("flRS6", function(module, exports) {

$parcel$export(module.exports, "patternInScope", () => $b2d29af9851abb3c$export$78221a09424368d);
/**
 * @typedef {import('../types.js').Unsafe} Unsafe
 * @typedef {import('../types.js').ConstructName} ConstructName
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $b2d29af9851abb3c$export$78221a09424368d(stack, pattern) {
    return $b2d29af9851abb3c$var$listInScope(stack, pattern.inConstruct, true) && !$b2d29af9851abb3c$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $b2d29af9851abb3c$var$listInScope(stack, list, none) {
    if (typeof list === "string") list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}

});


parcelRegister("4oDzZ", function(module, exports) {

$parcel$export(module.exports, "track", () => $33381afb15a0f46d$export$6b2a7d5132615086);
/**
 * @typedef {import('../types.js').CreateTracker} CreateTracker
 * @typedef {import('../types.js').TrackCurrent} TrackCurrent
 * @typedef {import('../types.js').TrackMove} TrackMove
 * @typedef {import('../types.js').TrackShift} TrackShift
 */ /**
 * Track positional info in the output.
 *
 * @type {CreateTracker}
 */ function $33381afb15a0f46d$export$6b2a7d5132615086(config) {
    // Defaults are used to prevent crashes when older utilities somehow activate
    // this code.
    /* c8 ignore next 5 */ const options = config || {};
    const now = options.now || {};
    let lineShift = options.lineShift || 0;
    let line = now.line || 1;
    let column = now.column || 1;
    return {
        move: move,
        current: current,
        shift: shift
    };
    /**
   * Get the current tracked info.
   *
   * @type {TrackCurrent}
   */ function current() {
        return {
            now: {
                line: line,
                column: column
            },
            lineShift: lineShift
        };
    }
    /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @type {TrackShift}
   */ function shift(value) {
        lineShift += value;
    }
    /**
   * Move past some generated markdown.
   *
   * @type {TrackMove}
   */ function move(input) {
        // eslint-disable-next-line unicorn/prefer-default-parameters
        const value = input || "";
        const chunks = value.split(/\r?\n|\r/g);
        const tail = chunks[chunks.length - 1];
        line += chunks.length - 1;
        column = chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift;
        return value;
    }
}

});


parcelRegister("aCHGY", function(module, exports) {

$parcel$export(module.exports, "gfmStrikethroughFromMarkdown", () => $7bbf5857fc598870$export$34d64e709dd0b9bb);
$parcel$export(module.exports, "gfmStrikethroughToMarkdown", () => $7bbf5857fc598870$export$1632835bd2c84956);
/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ 
var $crrN1 = parcelRequire("crrN1");

var $4oDzZ = parcelRequire("4oDzZ");
// To do: next major: expose functions.
// To do: next major: use `state`, state utilities.
/**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ const $7bbf5857fc598870$var$constructsWithoutStrikethrough = [
    "autolink",
    "destinationLiteral",
    "destinationRaw",
    "reference",
    "titleQuote",
    "titleApostrophe"
];
$7bbf5857fc598870$var$handleDelete.peek = $7bbf5857fc598870$var$peekDelete;
const $7bbf5857fc598870$export$34d64e709dd0b9bb = {
    canContainEols: [
        "delete"
    ],
    enter: {
        strikethrough: $7bbf5857fc598870$var$enterStrikethrough
    },
    exit: {
        strikethrough: $7bbf5857fc598870$var$exitStrikethrough
    }
};
const $7bbf5857fc598870$export$1632835bd2c84956 = {
    unsafe: [
        {
            character: "~",
            inConstruct: "phrasing",
            notInConstruct: $7bbf5857fc598870$var$constructsWithoutStrikethrough
        }
    ],
    handlers: {
        delete: $7bbf5857fc598870$var$handleDelete
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7bbf5857fc598870$var$enterStrikethrough(token) {
    this.enter({
        type: "delete",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $7bbf5857fc598870$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $7bbf5857fc598870$var$handleDelete(node, _, context, safeOptions) {
    const tracker = (0, $4oDzZ.track)(safeOptions);
    const exit = context.enter("strikethrough");
    let value = tracker.move("~~");
    value += (0, $crrN1.containerPhrasing)(node, context, {
        ...tracker.current(),
        before: value,
        after: "~"
    });
    value += tracker.move("~~");
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $7bbf5857fc598870$var$peekDelete() {
    return "~";
}

});
parcelRegister("crrN1", function(module, exports) {

$parcel$export(module.exports, "containerPhrasing", () => $90ed901f6a2070d6$export$f4090a9439f37631);
/**
 * @typedef {import('../types.js').Handle} Handle
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').PhrasingContent} PhrasingContent
 * @typedef {import('../types.js').State} State
 */ /**
 * Serialize the children of a parent that contains phrasing children.
 *
 * These children will be joined flush together.
 *
 * @param {Parent & {children: Array<PhrasingContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Info} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined together.
 */ function $90ed901f6a2070d6$export$f4090a9439f37631(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    let before = info.before;
    indexStack.push(-1);
    let tracker = state.createTracker(info);
    while(++index < children.length){
        const child = children[index];
        /** @type {string} */ let after;
        indexStack[indexStack.length - 1] = index;
        if (index + 1 < children.length) {
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            let handle = state.handle.handlers[children[index + 1].type];
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            if (handle && handle.peek) handle = handle.peek;
            after = handle ? handle(children[index + 1], parent, state, {
                before: "",
                after: "",
                ...tracker.current()
            }).charAt(0) : "";
        } else after = info.after;
        // In some cases, html (text) can be found in phrasing right after an eol.
        // When we’d serialize that, in most cases that would be seen as html
        // (flow).
        // As we can’t escape or so to prevent it from happening, we take a somewhat
        // reasonable approach: replace that eol with a space.
        // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
        if (results.length > 0 && (before === "\r" || before === "\n") && child.type === "html") {
            results[results.length - 1] = results[results.length - 1].replace(/(\r?\n|\r)$/, " ");
            before = " ";
            // To do: does this work to reset tracker?
            tracker = state.createTracker(info);
            tracker.move(results.join(""));
        }
        results.push(tracker.move(state.handle(child, parent, state, {
            ...tracker.current(),
            before: before,
            after: after
        })));
        before = results[results.length - 1].slice(-1);
    }
    indexStack.pop();
    return results.join("");
}

});


parcelRegister("en1Am", function(module, exports) {

$parcel$export(module.exports, "gfmTableFromMarkdown", () => $a764717e1cd4ef68$export$8bd0ec8ecf6adb7d);
$parcel$export(module.exports, "gfmTableToMarkdown", () => $a764717e1cd4ef68$export$dafcad76ea6e0045);
/**
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').InlineCode} InlineCode
 *
 * @typedef {import('markdown-table').MarkdownTableOptions} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Context} ToMarkdownContext
 * @typedef {import('mdast-util-to-markdown').SafeOptions} SafeOptions
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells.
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters.
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells
 */ 
var $crrN1 = parcelRequire("crrN1");

var $hLQlM = parcelRequire("hLQlM");

var $jLAo9 = parcelRequire("jLAo9");
const $a764717e1cd4ef68$export$8bd0ec8ecf6adb7d = {
    enter: {
        table: $a764717e1cd4ef68$var$enterTable,
        tableData: $a764717e1cd4ef68$var$enterCell,
        tableHeader: $a764717e1cd4ef68$var$enterCell,
        tableRow: $a764717e1cd4ef68$var$enterRow
    },
    exit: {
        codeText: $a764717e1cd4ef68$var$exitCodeText,
        table: $a764717e1cd4ef68$var$exitTable,
        tableData: $a764717e1cd4ef68$var$exit,
        tableHeader: $a764717e1cd4ef68$var$exit,
        tableRow: $a764717e1cd4ef68$var$exit
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a764717e1cd4ef68$var$enterTable(token) {
    /** @type {Array<'left' | 'right' | 'center' | 'none'>} */ // @ts-expect-error: `align` is custom.
    const align = token._align;
    this.enter({
        type: "table",
        align: align.map((d)=>d === "none" ? null : d),
        children: []
    }, token);
    this.setData("inTable", true);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a764717e1cd4ef68$var$exitTable(token) {
    this.exit(token);
    this.setData("inTable");
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a764717e1cd4ef68$var$enterRow(token) {
    this.enter({
        type: "tableRow",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a764717e1cd4ef68$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a764717e1cd4ef68$var$enterCell(token) {
    this.enter({
        type: "tableCell",
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $a764717e1cd4ef68$var$exitCodeText(token) {
    let value = this.resume();
    if (this.getData("inTable")) value = value.replace(/\\([\\|])/g, $a764717e1cd4ef68$var$replace);
    const node = /** @type {InlineCode} */ this.stack[this.stack.length - 1];
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $a764717e1cd4ef68$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}
function $a764717e1cd4ef68$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? " " : "|";
    return {
        unsafe: [
            {
                character: "\r",
                inConstruct: "tableCell"
            },
            {
                character: "\n",
                inConstruct: "tableCell"
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: "|",
                after: "[	 :-]"
            },
            // A pipe in a cell must be encoded.
            {
                character: "|",
                inConstruct: "tableCell"
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ":",
                after: "-"
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: "-",
                after: "[:|-]"
            }
        ],
        handlers: {
            table: handleTable,
            tableRow: handleTableRow,
            tableCell: handleTableCell,
            inlineCode: inlineCodeWithTable
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, context, safeOptions) {
        return serializeData(handleTableAsData(node, context, safeOptions), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, context, safeOptions) {
        const row = handleTableRowAsData(node, context, safeOptions);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf("\n"));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, context, safeOptions) {
        const exit = context.enter("tableCell");
        const subexit = context.enter("phrasing");
        const value = (0, $crrN1.containerPhrasing)(node, context, {
            ...safeOptions,
            before: around,
            after: around
        });
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $jLAo9.markdownTable)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */ function handleTableAsData(node, context, safeOptions) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = context.enter("table");
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], context, safeOptions);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */ function handleTableRowAsData(node, context, safeOptions) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = context.enter("tableRow");
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, context, safeOptions);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, context) {
        let value = (0, $hLQlM.inlineCode)(node, parent, context);
        if (context.stack.includes("tableCell")) value = value.replace(/\|/g, "\\$&");
        return value;
    }
}

});
parcelRegister("hLQlM", function(module, exports) {

$parcel$export(module.exports, "inlineCode", () => $ceff6f1c706cadba$export$91b9bee19a0d8569);
/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 */ 
var $haLLe = parcelRequire("haLLe");
$ceff6f1c706cadba$export$91b9bee19a0d8569.peek = $ceff6f1c706cadba$var$inlineCodePeek;
function $ceff6f1c706cadba$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || "";
    let sequence = "`";
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp("(^|[^`])" + sequence + "([^`]|$)").test(value))sequence += "`";
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = " " + value + " ";
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = (0, $haLLe.patternCompile)(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + " " + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $ceff6f1c706cadba$var$inlineCodePeek() {
    return "`";
}

});

parcelRegister("jLAo9", function(module, exports) {

$parcel$export(module.exports, "markdownTable", () => $e63ea22068620bda$export$cdb7288612c4f3d6);
/**
 * @typedef Options
 *   Configuration (optional).
 * @property {string|null|ReadonlyArray<string|null|undefined>} [align]
 *   One style for all columns, or styles for their respective columns.
 *   Each style is either `'l'` (left), `'r'` (right), or `'c'` (center).
 *   Other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left.
 *   *Only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean} [padding=true]
 *   Whether to add a space of padding between delimiters and cells.
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {boolean} [delimiterStart=true]
 *   Whether to begin each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean} [delimiterEnd=true]
 *   Whether to end each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean} [alignDelimiters=true]
 *   Whether to align the delimiters.
 *   By default, they are aligned:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {(value: string) => number} [stringLength]
 *   Function to detect the length of table cell content.
 *   This is used when aligning the delimiters (`|`) between table cells.
 *   Full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source.
 *   To fix this, you can pass this function, which receives the cell content
 *   and returns its “visible” size.
 *   Note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @typedef {Options} MarkdownTableOptions
 * @todo
 *   Remove next major.
 */ /**
 * Generate a markdown ([GFM](https://docs.github.com/en/github/writing-on-github/working-with-advanced-formatting/organizing-information-with-tables)) table..
 *
 * @param {ReadonlyArray<ReadonlyArray<string|null|undefined>>} table
 *   Table data (matrix of strings).
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {string}
 */ function $e63ea22068620bda$export$cdb7288612c4f3d6(table, options = {}) {
    const align = (options.align || []).concat();
    const stringLength = options.stringLength || $e63ea22068620bda$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $e63ea22068620bda$var$serialize(table[rowIndex][columnIndex]);
            if (options.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === "object" && "length" in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $e63ea22068620bda$var$toAlignment(align[columnIndex]);
    else {
        const code = $e63ea22068620bda$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = "";
        let after = "";
        if (code === 99 /* `c` */ ) {
            before = ":";
            after = ":";
        } else if (code === 108 /* `l` */ ) before = ":";
        else if (code === 114 /* `r` */ ) after = ":";
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = options.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + "-".repeat(size) + after;
        if (options.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || "";
            let before = "";
            let after = "";
            if (options.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = " ".repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = " ".repeat(size / 2 + 0.5);
                        after = " ".repeat(size / 2 - 0.5);
                    } else {
                        before = " ".repeat(size / 2);
                        after = before;
                    }
                } else after = " ".repeat(size);
            }
            if (options.delimiterStart !== false && !columnIndex) line.push("|");
            if (options.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(options.alignDelimiters === false && cell === "") && (options.delimiterStart !== false || columnIndex)) line.push(" ");
            if (options.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (options.alignDelimiters !== false) line.push(after);
            if (options.padding !== false) line.push(" ");
            if (options.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push("|");
        }
        lines.push(options.delimiterEnd === false ? line.join("").replace(/ +$/, "") : line.join(""));
    }
    return lines.join("\n");
}
/**
 * @param {string|null|undefined} [value]
 * @returns {string}
 */ function $e63ea22068620bda$var$serialize(value) {
    return value === null || value === undefined ? "" : String(value);
}
/**
 * @param {string} value
 * @returns {number}
 */ function $e63ea22068620bda$var$defaultStringLength(value) {
    return value.length;
}
/**
 * @param {string|null|undefined} value
 * @returns {number}
 */ function $e63ea22068620bda$var$toAlignment(value) {
    const code = typeof value === "string" ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}

});


parcelRegister("itovu", function(module, exports) {

$parcel$export(module.exports, "gfmTaskListItemFromMarkdown", () => $d72df1f75d2ef579$export$a427a608608b215f);
$parcel$export(module.exports, "gfmTaskListItemToMarkdown", () => $d72df1f75d2ef579$export$9975722e7e834b78);
/**
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ /**
 * @typedef {Extract<Root | Content, Parent>} Parents
 */ 
var $awUIA = parcelRequire("awUIA");

var $4oDzZ = parcelRequire("4oDzZ");
const $d72df1f75d2ef579$export$a427a608608b215f = {
    exit: {
        taskListCheckValueChecked: $d72df1f75d2ef579$var$exitCheck,
        taskListCheckValueUnchecked: $d72df1f75d2ef579$var$exitCheck,
        paragraph: $d72df1f75d2ef579$var$exitParagraphWithTaskListItem
    }
};
const $d72df1f75d2ef579$export$9975722e7e834b78 = {
    unsafe: [
        {
            atBreak: true,
            character: "-",
            after: "[:|-]"
        }
    ],
    handlers: {
        listItem: $d72df1f75d2ef579$var$listItemWithTaskListItem
    }
};
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $d72df1f75d2ef579$var$exitCheck(token) {
    const node = /** @type {ListItem} */ this.stack[this.stack.length - 2];
    // We’re always in a paragraph, in a list item.
    node.checked = token.type === "taskListCheckValueChecked";
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $d72df1f75d2ef579$var$exitParagraphWithTaskListItem(token) {
    const parent = /** @type {Parents} */ this.stack[this.stack.length - 2];
    if (parent && parent.type === "listItem" && typeof parent.checked === "boolean") {
        const node = /** @type {Paragraph} */ this.stack[this.stack.length - 1];
        const head = node.children[0];
        if (head && head.type === "text") {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === "paragraph") {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === "number") {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $d72df1f75d2ef579$var$listItemWithTaskListItem(node, parent, context, safeOptions) {
    const head = node.children[0];
    const checkable = typeof node.checked === "boolean" && head && head.type === "paragraph";
    const checkbox = "[" + (node.checked ? "x" : " ") + "] ";
    const tracker = (0, $4oDzZ.track)(safeOptions);
    if (checkable) tracker.move(checkbox);
    let value = (0, $awUIA.listItem)(node, parent, context, {
        ...safeOptions,
        ...tracker.current()
    });
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}

});
parcelRegister("awUIA", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $7aa8e3979ba2d35d$export$76c7e83ecc9cdf05);
/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */ 
var $7tRkd = parcelRequire("7tRkd");

var $kTvDv = parcelRequire("kTvDv");
function $7aa8e3979ba2d35d$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $kTvDv.checkListItemIndent)(state);
    let bullet = state.bulletCurrent || (0, $7tRkd.checkBullet)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === "list" && parent.ordered) bullet = (typeof parent.start === "number" && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === "tab" || listItemIndent === "mixed" && (parent && parent.type === "list" && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + " ".repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter("listItem");
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? "" : " ".repeat(size)) + line;
        return (blank ? bullet : bullet + " ".repeat(size - bullet.length)) + line;
    }
}

});
parcelRegister("7tRkd", function(module, exports) {

$parcel$export(module.exports, "checkBullet", () => $57249b157be5cf33$export$7425517207a4d0ae);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $57249b157be5cf33$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || "*";
    if (marker !== "*" && marker !== "+" && marker !== "-") throw new Error("Cannot serialize items with `" + marker + "` for `options.bullet`, expected `*`, `+`, or `-`");
    return marker;
}

});

parcelRegister("kTvDv", function(module, exports) {

$parcel$export(module.exports, "checkListItemIndent", () => $f3617c01b814f154$export$2d5358b63da92261);
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $f3617c01b814f154$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || "tab";
    // To do: remove in a major.
    // @ts-expect-error: deprecated.
    if (style === 1 || style === "1") return "one";
    if (style !== "tab" && style !== "one" && style !== "mixed") throw new Error("Cannot serialize items with `" + style + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`");
    return style;
}

});






parcelRegister("9P6Oe", function(module, exports) {

$parcel$export(module.exports, "BodyPartIcon", () => $eed34e56f909ee00$export$79b606b5906dc7b3);

var $iKObn = parcelRequire("iKObn");

var $hLaGu = parcelRequire("hLaGu");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
var $eed34e56f909ee00$var$FullBodyIcon = function FullBodyIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.429 6.313a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4ZM8.961 17.407c-.373 1.157-1.305 4.532-1.305 4.532.484.136 1.901.149 1.901.149.274-.47.605-1.26.97-2.127.604-1.438 1.3-3.092 1.973-3.873.674.78 1.369 2.435 1.973 3.873.364.868.696 1.657.97 2.127 0 0 1.417-.013 1.902-.15 0 0-.933-3.374-1.306-4.53a182.29 182.29 0 0 1-1.044-3.338c-.063-.733.067-1.475.194-2.205.129-.74.256-1.466.179-2.159-.023-.205 2.197-.312 3.987-.399 1.138-.055 2.102-.102 2.203-.16.262-.15.224-1.454.038-1.64-.131-.132-4.837-.249-7.942-.326l-1.132-.028v-.001h-.044v.001l-1.132.028c-3.105.077-7.81.194-7.942.325-.186.187-.224 1.492.037 1.641.102.058 1.066.105 2.204.16 1.79.087 4.01.194 3.987.4-.077.691.05 1.418.179 2.158.127.73.257 1.472.194 2.205-.236.795-.694 2.25-1.044 3.337Z",
            fill: "#D90840"
        })
    });
};
$eed34e56f909ee00$var$FullBodyIcon.defaultProps = {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $eed34e56f909ee00$var$HeadTrunkIcon = function HeadTrunkIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.572 5.574a3.249 3.249 0 1 1-6.498 0 3.249 3.249 0 0 1 6.498 0Zm-7.26 10.988c-.003.321.394 2.016.75 3.54.13.552.254 1.083.351 1.516l3.066.056H12.521l3.065-.056c.098-.433.222-.964.352-1.517.356-1.523.753-3.218.75-3.539-.002-.22.69-.402 1.395-.588.601-.158 1.212-.32 1.408-.508.445-.427-.591-3.27-1.69-4.096-1.124-.843-3.662-1.245-5.301-1.193-1.64-.052-4.177.35-5.3 1.193-1.1.825-2.136 3.67-1.691 4.096.196.189.807.35 1.408.508.704.186 1.397.368 1.395.588Z",
            fill: "#20BB71"
        })
    });
};
$eed34e56f909ee00$var$HeadTrunkIcon.defaultProps = {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $eed34e56f909ee00$var$LowerLimbsIcon = function LowerLimbsIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M18.574 5.1c-.576-1.15-6.954-2.746-10.072-3.4-1.127 1.362-2.596 4.112-2.586 7.059.73.484 6.527.103 9.053-.04-.656 1.178-1.615 1.593-2.156 3.218-.542 1.626-.063 2.907-.563 4.407-.5 1.5-.625 1.937-1.031 3.28-.308 1.019 2.97 2.683 4.203 2.676 1.064-.006 1.904-.728 1.484-1.372-.525-.806-1.69-1.047-2.867-1.57 6.407-10.512 5.112-13.103 4.536-14.255l-.001-.002Z",
            fill: "#FFAF00"
        })
    });
};
$eed34e56f909ee00$var$LowerLimbsIcon.defaultProps = {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $eed34e56f909ee00$var$UpperLimbsIcon = function UpperLimbsIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M11.88 14.214c-.562-1.625-.37-2.782-1.214-3.844-.844-1.063-2.513-1.25-2.513-1.25.041-2.058-1.16-3.937-3.242-3.187S2.907 8.42 3.678 9.841c.77 1.42 6.418 7.795 7.17 8.104.752.31 1.441.404 2.097.118.657-.286 3.908-4.652 6.029-6.507 1.13-.988.916-.217 2.12-1.182 1.204-.965.702-2.094.003-3.063-.7-.968-2.344-1.03-3.09-.437-.98.779-.416 1.364-.596 2.651-.443.246-2.406 2.375-5.53 4.688Z",
            fill: "#00C3E6"
        })
    });
};
$eed34e56f909ee00$var$UpperLimbsIcon.defaultProps = {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $eed34e56f909ee00$var$bodyPartIconFromBodyPart = {
    [(0, $hLaGu.ExerciseBodyPart).FullBody]: $eed34e56f909ee00$var$FullBodyIcon,
    [(0, $hLaGu.ExerciseBodyPart).HeadTrunk]: $eed34e56f909ee00$var$HeadTrunkIcon,
    [(0, $hLaGu.ExerciseBodyPart).LowerLimbs]: $eed34e56f909ee00$var$LowerLimbsIcon,
    [(0, $hLaGu.ExerciseBodyPart).UpperLimbs]: $eed34e56f909ee00$var$UpperLimbsIcon
};
const $eed34e56f909ee00$export$79b606b5906dc7b3 = ({ bodyPart: bodyPart, additionalBodyPartsCount: additionalBodyPartsCount = 0, width: width = 24, height: height = 24, ...otherProps })=>{
    const Icon = $eed34e56f909ee00$var$bodyPartIconFromBodyPart[bodyPart];
    return /*#__PURE__*/ (0, $iKObn.jsxs)($eed34e56f909ee00$var$Container, {
        width: width,
        height: height,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)(Icon, {
                ...otherProps,
                width: width,
                height: height
            }),
            additionalBodyPartsCount > 0 && /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                className: "p-size-xs-extra-bold",
                children: `+${additionalBodyPartsCount}`
            })
        ]
    });
};
const $eed34e56f909ee00$var$Container = (0, $5UMQ1.default).div`
	width: ${({ width: width })=>width}px;
	height: ${({ height: height })=>height}px;
	position: relative;

	> div {
		position: absolute;
		top: -10px;
		right: -6px;
		color: ${(0, $kKnoQ.colors).grey};
	}
`;

});

parcelRegister("jKTFw", function(module, exports) {

$parcel$export(module.exports, "getScrollbarStyle", () => $0134877f34e34cb0$export$a3ec57a2cf58336e);

var $kkH7g = parcelRequire("kkH7g");

var $kKnoQ = parcelRequire("kKnoQ");
const $0134877f34e34cb0$export$a3ec57a2cf58336e = (thickness)=>(0, $kkH7g.css)`
	::-webkit-scrollbar {
		width: ${thickness}px;
		height: ${thickness}px;
	}

	/* Track */
	::-webkit-scrollbar-track {
		background: ${(0, $kKnoQ.colors).transparent};
	}

	/* Handle */
	::-webkit-scrollbar-thumb {
		background-color: ${(0, $kKnoQ.colors).grey25};
		border-radius: ${thickness}px;

		:hover {
			background-color: ${(0, $kKnoQ.colors).grey50};
		}
	}
`;

});


parcelRegister("a59kI", function(module, exports) {

$parcel$export(module.exports, "DraggableCard", () => $cffc83bda972e3c8$export$d263659cd0f422a8);

var $iKObn = parcelRequire("iKObn");

var $lfEOz = parcelRequire("lfEOz");

var $41NLE = parcelRequire("41NLE");

var $81g6h = parcelRequire("81g6h");

var $iZOKh = parcelRequire("iZOKh");
const $cffc83bda972e3c8$export$d263659cd0f422a8 = ({ exercise: exercise, renderCard: renderCard, index: index, copy: copy })=>{
    const dragAndDropContext = (0, $81g6h.useContext)((0, $41NLE.ExerciseDragAndDropContext));
    const [overriddenUiStyle, setOverriddenUiStyle] = (0, $81g6h.useState)();
    const getCardStyle = (dragProps, isDragging)=>({
            ...dragProps.style,
            ...copy ? {
                //copy style to duplicate item
                transform: isDragging ? dragProps.style?.transform : "translate(0px, 0px)"
            } : {}
        });
    (0, $81g6h.useEffect)(()=>{
        const handleDragEnd = ()=>{
            setOverriddenUiStyle(undefined);
        };
        const handleBeforeCapture = (before)=>{
            if (before.draggableId === exercise.draggableId) {
                const widthItem = document.getElementById("droppable_1")?.getBoundingClientRect().width;
                setOverriddenUiStyle({
                    uiStyle: "card",
                    style: {
                        width: widthItem ? widthItem - 2 * (0, $lfEOz.SESSION_DROPPABLE_HORIZONTAL_PADDING) : undefined,
                        alignSelf: "center"
                    }
                });
            }
        };
        dragAndDropContext?.onDragEnd.add(handleDragEnd);
        dragAndDropContext?.onBeforeCapture.add(handleBeforeCapture);
        return ()=>{
            dragAndDropContext?.onDragEnd.remove(handleDragEnd);
            dragAndDropContext?.onBeforeCapture.remove(handleBeforeCapture);
        };
    }, [
        dragAndDropContext?.onBeforeCapture,
        dragAndDropContext?.onDragEnd,
        exercise.draggableId
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iZOKh.Draggable), {
        draggableId: exercise.draggableId,
        index: index,
        children: (provided, snapshot)=>renderCard({
                cardStyle: {
                    ...getCardStyle(provided.draggableProps, snapshot.isDragging),
                    ...overriddenUiStyle ? overriddenUiStyle.style : {}
                },
                overriddenUiStyle: overriddenUiStyle?.uiStyle,
                provided: provided,
                snapshot: snapshot
            })
    }, exercise.draggableId);
};

});
parcelRegister("lfEOz", function(module, exports) {

$parcel$export(module.exports, "ITEM_SPACING", () => $d0a0bbd145988e6c$export$76935cd5f3fe4dbd);
$parcel$export(module.exports, "CARD_BORDER_SIZE", () => $d0a0bbd145988e6c$export$beea18d747d9e8b8);
$parcel$export(module.exports, "SESSION_DROPPABLE_HORIZONTAL_PADDING", () => $d0a0bbd145988e6c$export$3281e26ffd971cde);
$parcel$export(module.exports, "DayExercisePlaceholder", () => $d0a0bbd145988e6c$export$6d46a65a57015ce3);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $41NLE = parcelRequire("41NLE");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $dU78w = parcelRequire("dU78w");

var $81g6h = parcelRequire("81g6h");
const $d0a0bbd145988e6c$export$76935cd5f3fe4dbd = 8;
const $d0a0bbd145988e6c$export$beea18d747d9e8b8 = 1;
const $d0a0bbd145988e6c$export$3281e26ffd971cde = 8;
const $d0a0bbd145988e6c$export$6d46a65a57015ce3 = ({ dayIndex: dayIndex, display: display, className: className })=>{
    const placeholderStyle = $d0a0bbd145988e6c$var$usePlaceholderStyle(dayIndex);
    return display ? /*#__PURE__*/ (0, $iKObn.jsx)($d0a0bbd145988e6c$var$Placeholder, {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        transition: {
            ease: "easeInOut"
        },
        style: placeholderStyle,
        className: className
    }) : null;
};
const $d0a0bbd145988e6c$var$usePlaceholderStyle = (index)=>{
    const [placeholderStyle, setPlaceholderStyle] = (0, $81g6h.useState)({});
    const dragAndDropContext = (0, $81g6h.useContext)((0, $41NLE.ExerciseDragAndDropContext));
    (0, $81g6h.useEffect)(()=>{
        const handleDragEnd = ()=>{
            setPlaceholderStyle({});
        };
        const handleDragStart = (v)=>{
            const { draggableItem: draggableItem, droppableContainer: droppableContainer } = $d0a0bbd145988e6c$var$getDraggables(v, index);
            if (draggableItem && droppableContainer) {
                const height = draggableItem.getBoundingClientRect().height;
                const top = Array.from(droppableContainer.children).slice(0, v.content.source.index).filter((value)=>(0, $lTdpc.isNotNil)(value)).reduce((total, curr)=>total + curr.clientHeight + $d0a0bbd145988e6c$export$76935cd5f3fe4dbd + 2 * $d0a0bbd145988e6c$export$beea18d747d9e8b8, 0);
                setPlaceholderStyle({
                    height: height,
                    top: top
                });
            }
        };
        const handleDragUpdate = (v)=>{
            const { draggableItem: draggableItem, droppableContainer: droppableContainer } = $d0a0bbd145988e6c$var$getDraggables(v, index);
            if (v.content.destination && draggableItem && droppableContainer) {
                const sourceIndex = v.content.source.index;
                const destinationIndex = v.content.destination.index;
                const height = draggableItem.getBoundingClientRect().height;
                const childrenArray = Array.from(droppableContainer.children);
                if (v.content.source.droppableId === v.content.destination.droppableId) {
                    const [reorderedItem] = childrenArray.splice(sourceIndex, 1);
                    childrenArray.splice(destinationIndex, 0, reorderedItem);
                } else {
                    const movedItem = childrenArray[sourceIndex];
                    childrenArray.splice(destinationIndex, 0, movedItem);
                }
                const top = childrenArray.slice(0, destinationIndex).filter((value)=>(0, $lTdpc.isNotNil)(value)).reduce((total, curr)=>total + curr.clientHeight + $d0a0bbd145988e6c$export$76935cd5f3fe4dbd + 2 * $d0a0bbd145988e6c$export$beea18d747d9e8b8, 0);
                setPlaceholderStyle({
                    height: height,
                    top: top
                });
            }
        };
        dragAndDropContext?.onDragEnd.add(handleDragEnd);
        dragAndDropContext?.onDragStart.add(handleDragStart);
        dragAndDropContext?.onDragUpdate.add(handleDragUpdate);
        return ()=>{
            dragAndDropContext?.onDragEnd.remove(handleDragEnd);
            dragAndDropContext?.onDragStart.remove(handleDragStart);
            dragAndDropContext?.onDragUpdate.remove(handleDragUpdate);
        };
    }, [
        dragAndDropContext?.onDragEnd,
        dragAndDropContext?.onDragStart,
        dragAndDropContext?.onDragUpdate,
        index
    ]);
    return placeholderStyle;
};
const $d0a0bbd145988e6c$var$getDraggables = (v, index)=>{
    if (v) {
        const draggableItem = document.getElementById(v.content.draggableId);
        const droppableContainer = document.getElementById("droppable_" + index);
        return {
            draggableItem: draggableItem,
            droppableContainer: droppableContainer
        };
    }
    return {
        draggableItem: null,
        droppableContainer: null
    };
};
const $d0a0bbd145988e6c$var$Placeholder = (0, $5UMQ1.default)((0, $dU78w.motion).div)`
	position: absolute;
	border-radius: 8px;
	background-color: ${(0, $kKnoQ.colors).primaryBackground};
	width: calc(100% - ${$d0a0bbd145988e6c$export$3281e26ffd971cde * 2}px);
	z-index: 2;
	left: ${$d0a0bbd145988e6c$export$3281e26ffd971cde}px;
	transition: top 0.1s ease-in;
`;

});
parcelRegister("41NLE", function(module, exports) {

$parcel$export(module.exports, "DROPPABLE_ID", () => $5815404b36abdc0c$export$c9e5d20da32b692d);
$parcel$export(module.exports, "ExerciseDragAndDropContext", () => $5815404b36abdc0c$export$5be8ead80bc78899);
$parcel$export(module.exports, "ProgramBuilderDragDropContextProvider", () => $5815404b36abdc0c$export$92238c61fdc1d96f);

var $iKObn = parcelRequire("iKObn");

var $ghfIB = parcelRequire("ghfIB");

var $bFakw = parcelRequire("bFakw");

var $c9OC9 = parcelRequire("c9OC9");

var $lKGAO = parcelRequire("lKGAO");

var $isRr9 = parcelRequire("isRr9");

var $lTdpc = parcelRequire("lTdpc");

var $1IWnK = parcelRequire("1IWnK");

var $gbSxu = parcelRequire("gbSxu");

var $81g6h = parcelRequire("81g6h");

var $iglNQ = parcelRequire("iglNQ");

var $9d072 = parcelRequire("9d072");

var $iZOKh = parcelRequire("iZOKh");

var $kIsT0 = parcelRequire("kIsT0");
const $5815404b36abdc0c$export$c9e5d20da32b692d = {
    ...(0, $c9OC9.DayIndex),
    PreSelectedExercise: "PreSelectedExercise",
    Library: "Library",
    Alternative: "Alternative"
};
const $5815404b36abdc0c$export$5be8ead80bc78899 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createContext(null);
const $5815404b36abdc0c$export$92238c61fdc1d96f = ({ programEditor: programEditor, children: children })=>{
    const [isDragging, setIsDragging] = (0, $81g6h.useState)(false);
    const filteredExercises = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).filteredExercises);
    const filteredPreSelectedExercises = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).filteredSelectedExercises);
    const onDragUpdate = (0, $81g6h.useMemo)(()=>new (0, $gbSxu.Signal)(), []);
    const onDragStart = (0, $81g6h.useMemo)(()=>new (0, $gbSxu.Signal)(), []);
    const onDragEnd = (0, $81g6h.useMemo)(()=>new (0, $gbSxu.Signal)(), []);
    const onBeforeCapture = (0, $81g6h.useMemo)(()=>new (0, $gbSxu.Signal)(), []);
    const trackingContext = (0, $81g6h.useContext)((0, $lKGAO.TrackingContext));
    const currentExercise = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited);
    const handleAlternativeDragAndDrop = (0, $81g6h.useCallback)(async (source, destination)=>{
        switch(source.droppableId){
            case destination.droppableId:
                programEditor.reorderAlternativeExercises(source.index, destination.index);
                break;
            case $5815404b36abdc0c$export$c9e5d20da32b692d.PreSelectedExercise:
                {
                    const exercise = filteredPreSelectedExercises[source.index];
                    (0, $lTdpc.isNotNil)(currentExercise) && (0, $bFakw.sendAnalyticsEventAddAlternativeExercises)(currentExercise, exercise);
                    await programEditor.addLibraryExerciseToAlternatives(exercise, destination.index);
                    break;
                }
            case $5815404b36abdc0c$export$c9e5d20da32b692d.Library:
                {
                    const exercise = filteredExercises[source.index];
                    (0, $lTdpc.isNotNil)(currentExercise) && (0, $bFakw.sendAnalyticsEventAddAlternativeExercises)(currentExercise, exercise);
                    await programEditor.addLibraryExerciseToAlternatives(exercise, destination.index);
                    break;
                }
            default:
                break;
        }
    }, [
        currentExercise,
        filteredPreSelectedExercises,
        filteredExercises,
        programEditor
    ]);
    const updateProgram = (0, $81g6h.useCallback)((result)=>{
        const { source: source, destination: destination } = result;
        // dropped outside the list
        if (!destination) return;
        if (destination.droppableId === $5815404b36abdc0c$export$c9e5d20da32b692d.Alternative) handleAlternativeDragAndDrop(source, destination);
        else {
            const sourceSessionIndex = parseInt(source.droppableId);
            const destinationSessionIndex = parseInt(destination.droppableId);
            switch(source.droppableId){
                case destination.droppableId:
                    programEditor.reorderSessionExercises(sourceSessionIndex, source.index, destination.index);
                    break;
                case $5815404b36abdc0c$export$c9e5d20da32b692d.PreSelectedExercise:
                    {
                        const exercise = filteredPreSelectedExercises[source.index];
                        programEditor.addExerciseToSession(exercise, destinationSessionIndex, destination.index);
                        (0, $bFakw.sendAnalyticsEventAddExercise)(exercise, trackingContext.category);
                    }
                    break;
                case $5815404b36abdc0c$export$c9e5d20da32b692d.Library:
                    {
                        const exercise = filteredExercises[source.index];
                        programEditor.addExerciseToSession(exercise, destinationSessionIndex, destination.index);
                        (0, $bFakw.sendAnalyticsEventAddExercise)(exercise, trackingContext.category);
                        // Mark quickstart step as completed when a library exercise is added
                        (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).ADD_EXERCISE_GUIDE_01);
                    }
                    break;
                default:
                    programEditor.moveExercise(sourceSessionIndex, source.index, destinationSessionIndex, destination.index);
                    break;
            }
        }
    }, [
        filteredPreSelectedExercises,
        filteredExercises,
        handleAlternativeDragAndDrop,
        programEditor,
        trackingContext.category
    ]);
    const contextValue = (0, $81g6h.useMemo)(()=>({
            programEditor: programEditor,
            isDragging: isDragging,
            onDragUpdate: onDragUpdate,
            onDragEnd: onDragEnd,
            onDragStart: onDragStart,
            onBeforeCapture: onBeforeCapture
        }), [
        isDragging,
        onBeforeCapture,
        onDragEnd,
        onDragStart,
        onDragUpdate,
        programEditor
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($5815404b36abdc0c$export$5be8ead80bc78899.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $iZOKh.DragDropContext), {
            sensors: [
                (0, $iZOKh.useMouseSensor),
                (0, $iZOKh.useKeyboardSensor),
                (0, $kIsT0.useTolerantTouchSensor)
            ],
            onBeforeCapture: (before)=>{
                onBeforeCapture.dispatch(before);
            },
            onDragStart: (content, provided)=>{
                setIsDragging(true);
                onDragStart.dispatch({
                    content: content,
                    provided: provided
                });
            },
            onDragEnd: (content, provided)=>{
                setIsDragging(false);
                onDragEnd.dispatch({
                    content: content,
                    provided: provided
                });
                updateProgram(content);
                if ((0, $iglNQ.complementaryGuide3ForceVisible).get()) {
                    const lastAdded = (0, $ghfIB.libraryFilterManager).lastAddedExerciseMetadata.get();
                    if (lastAdded?.isComplementary && lastAdded.draggableId === content.draggableId) {
                        (async ()=>{
                            await (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).COMPLEMENTARY_EXERCISES_GUIDE_03);
                            await (0, $ghfIB.onboardingManager).init();
                        })();
                        (0, $iglNQ.hideComplementaryGuide3)();
                    }
                }
                if ((0, $9d072.alternativeGuide3ForceVisible).get()) {
                    (0, $9d072.hideAlternativeGuide3)();
                    (0, $9d072.setAlternativeGuide3WasCompleted)();
                } else if (!(0, $9d072.alternativePanelQuickstartGuideRequested).get() && content.destination?.droppableId === $5815404b36abdc0c$export$c9e5d20da32b692d.Alternative) (async ()=>{
                    await (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).ALTERNATIVE_EXERCISES_GUIDE_02);
                    await (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).ALTERNATIVE_EXERCISES_GUIDE_03);
                    await (0, $ghfIB.onboardingManager).init();
                })();
            },
            onDragUpdate: (content, provided)=>{
                onDragUpdate.dispatch({
                    content: content,
                    provided: provided
                });
            },
            children: children
        })
    });
};

});
parcelRegister("iglNQ", function(module, exports) {

$parcel$export(module.exports, "complementaryTooltipVisible", () => $f0fe43bb039145bf$export$682c3474d8e38266);
$parcel$export(module.exports, "complementaryQuickstartOrigin", () => $f0fe43bb039145bf$export$8d6fc3fc51c22307);
$parcel$export(module.exports, "showComplementaryTooltip", () => $f0fe43bb039145bf$export$893f7e0f0ed7a19c);
$parcel$export(module.exports, "hideComplementaryTooltip", () => $f0fe43bb039145bf$export$bec9cf0e83a4b7ad);
$parcel$export(module.exports, "clearComplementaryQuickstartOrigin", () => $f0fe43bb039145bf$export$75d15d02581bf454);
$parcel$export(module.exports, "complementaryGuide3ForceVisible", () => $f0fe43bb039145bf$export$2321ec05639ea1e5);
$parcel$export(module.exports, "showComplementaryGuide3", () => $f0fe43bb039145bf$export$7bce44b7457e5649);
$parcel$export(module.exports, "hideComplementaryGuide3", () => $f0fe43bb039145bf$export$d440225fca1f19b5);
$parcel$export(module.exports, "resetComplementaryGuide3", () => $f0fe43bb039145bf$export$c16585117569623f);

var $1IWnK = parcelRequire("1IWnK");
const $f0fe43bb039145bf$export$682c3474d8e38266 = (0, $1IWnK.observable)(false);
const $f0fe43bb039145bf$export$8d6fc3fc51c22307 = (0, $1IWnK.observable)(false);
const $f0fe43bb039145bf$export$893f7e0f0ed7a19c = ()=>{
    $f0fe43bb039145bf$export$682c3474d8e38266.set(true);
    $f0fe43bb039145bf$export$8d6fc3fc51c22307.set(true);
};
const $f0fe43bb039145bf$export$bec9cf0e83a4b7ad = ()=>$f0fe43bb039145bf$export$682c3474d8e38266.set(false);
const $f0fe43bb039145bf$export$75d15d02581bf454 = ()=>$f0fe43bb039145bf$export$8d6fc3fc51c22307.set(false);
const $f0fe43bb039145bf$export$2321ec05639ea1e5 = (0, $1IWnK.observable)(false);
const $f0fe43bb039145bf$export$7bce44b7457e5649 = ()=>$f0fe43bb039145bf$export$2321ec05639ea1e5.set(true);
const $f0fe43bb039145bf$export$d440225fca1f19b5 = ()=>$f0fe43bb039145bf$export$2321ec05639ea1e5.set(false);
const $f0fe43bb039145bf$export$c16585117569623f = ()=>{
    $f0fe43bb039145bf$export$2321ec05639ea1e5.set(false);
};

});

parcelRegister("9d072", function(module, exports) {

$parcel$export(module.exports, "alternativeHaloVisible", () => $d74189bee8d7578a$export$4139585c76f79597);
$parcel$export(module.exports, "showAlternativeHalo", () => $d74189bee8d7578a$export$81c56f926ef49aef);
$parcel$export(module.exports, "hideAlternativeHalo", () => $d74189bee8d7578a$export$e2de11f8e5fcc8bc);
$parcel$export(module.exports, "alternativePanelQuickstartGuideRequested", () => $d74189bee8d7578a$export$9ad9a70db66fc167);
$parcel$export(module.exports, "requestAlternativePanelQuickstartGuide", () => $d74189bee8d7578a$export$da3e6c3405c5da32);
$parcel$export(module.exports, "clearAlternativePanelQuickstartGuide", () => $d74189bee8d7578a$export$b5fc940b52e72a41);
$parcel$export(module.exports, "alternativeGuide3ForceVisible", () => $d74189bee8d7578a$export$b4eb61a2ac6a0ac0);
$parcel$export(module.exports, "showAlternativeGuide3", () => $d74189bee8d7578a$export$288cac97995abef7);
$parcel$export(module.exports, "hideAlternativeGuide3", () => $d74189bee8d7578a$export$29d2af458bda9cc6);
$parcel$export(module.exports, "alternativeGuide3WasCompleted", () => $d74189bee8d7578a$export$5252b4986164d8c7);
$parcel$export(module.exports, "setAlternativeGuide3WasCompleted", () => $d74189bee8d7578a$export$59f529094c5c8433);
$parcel$export(module.exports, "resetAlternativeGuide3", () => $d74189bee8d7578a$export$722a7f4a68916d0c);

var $1IWnK = parcelRequire("1IWnK");
const $d74189bee8d7578a$export$4139585c76f79597 = (0, $1IWnK.observable)(false);
const $d74189bee8d7578a$export$81c56f926ef49aef = ()=>{
    $d74189bee8d7578a$export$4139585c76f79597.set(true);
};
const $d74189bee8d7578a$export$e2de11f8e5fcc8bc = ()=>{
    $d74189bee8d7578a$export$4139585c76f79597.set(false);
};
const $d74189bee8d7578a$export$9ad9a70db66fc167 = (0, $1IWnK.observable)(false);
const $d74189bee8d7578a$export$da3e6c3405c5da32 = ()=>{
    $d74189bee8d7578a$export$9ad9a70db66fc167.set(true);
};
const $d74189bee8d7578a$export$b5fc940b52e72a41 = ()=>{
    $d74189bee8d7578a$export$9ad9a70db66fc167.set(false);
};
const $d74189bee8d7578a$export$b4eb61a2ac6a0ac0 = (0, $1IWnK.observable)(false);
const $d74189bee8d7578a$export$288cac97995abef7 = ()=>$d74189bee8d7578a$export$b4eb61a2ac6a0ac0.set(true);
const $d74189bee8d7578a$export$29d2af458bda9cc6 = ()=>$d74189bee8d7578a$export$b4eb61a2ac6a0ac0.set(false);
const $d74189bee8d7578a$export$5252b4986164d8c7 = (0, $1IWnK.observable)(false);
const $d74189bee8d7578a$export$59f529094c5c8433 = ()=>$d74189bee8d7578a$export$5252b4986164d8c7.set(true);
const $d74189bee8d7578a$export$722a7f4a68916d0c = ()=>{
    $d74189bee8d7578a$export$b4eb61a2ac6a0ac0.set(false);
    $d74189bee8d7578a$export$5252b4986164d8c7.set(false);
};

});

parcelRegister("iZOKh", function(module, exports) {

$parcel$export(module.exports, "useMouseSensor", () => $dd4549797813bb01$export$2f59cd992b42195a);
$parcel$export(module.exports, "useKeyboardSensor", () => $dd4549797813bb01$export$42b74264faad0714);
$parcel$export(module.exports, "DragDropContext", () => $dd4549797813bb01$export$237bd83162c14364);
$parcel$export(module.exports, "Draggable", () => $dd4549797813bb01$export$f2a139e5d18b9882);
$parcel$export(module.exports, "Droppable", () => $dd4549797813bb01$export$423ec2075359570a);

var $81g6h = parcelRequire("81g6h");

var $Q1dTY = parcelRequire("Q1dTY");

var $71WWU = parcelRequire("71WWU");
parcelRequire("hsW4Y");
var $hd224 = parcelRequire("hd224");
var $duc3X = parcelRequire("duc3X");

var $g3Edw = parcelRequire("g3Edw");

var $kZLuh = parcelRequire("kZLuh");

var $6iviE = parcelRequire("6iviE");

var $ed8xX = parcelRequire("ed8xX");

var $6JG9D = parcelRequire("6JG9D");
const $dd4549797813bb01$var$isProduction$1 = true;
const $dd4549797813bb01$var$spacesAndTabs = /[ \t]{2,}/g;
const $dd4549797813bb01$var$lineStartWithSpaces = /^[ \t]*/gm;
const $dd4549797813bb01$var$clean$2 = (value)=>value.replace($dd4549797813bb01$var$spacesAndTabs, " ").replace($dd4549797813bb01$var$lineStartWithSpaces, "").trim();
const $dd4549797813bb01$var$getDevMessage = (message)=>$dd4549797813bb01$var$clean$2(`
  %c@hello-pangea/dnd

  %c${$dd4549797813bb01$var$clean$2(message)}

  %c\u{1F477}\u{200D} This is a development only message. It will be removed in production builds.
`);
const $dd4549797813bb01$var$getFormattedMessage = (message)=>[
        $dd4549797813bb01$var$getDevMessage(message),
        "color: #00C584; font-size: 1.2em; font-weight: bold;",
        "line-height: 1.5",
        "color: #723874;"
    ];
const $dd4549797813bb01$var$isDisabledFlag = "__@hello-pangea/dnd-disable-dev-warnings";
function $dd4549797813bb01$var$log(type, message) {
    if ($dd4549797813bb01$var$isProduction$1) return;
    if (typeof window !== "undefined" && window[$dd4549797813bb01$var$isDisabledFlag]) return;
    console[type](...$dd4549797813bb01$var$getFormattedMessage(message));
}
const $dd4549797813bb01$var$warning = $dd4549797813bb01$var$log.bind(null, "warn");
const $dd4549797813bb01$var$error = $dd4549797813bb01$var$log.bind(null, "error");
function $dd4549797813bb01$var$noop$2() {}
function $dd4549797813bb01$var$getOptions(shared, fromBinding) {
    return {
        ...shared,
        ...fromBinding
    };
}
function $dd4549797813bb01$var$bindEvents(el, bindings, sharedOptions) {
    const unbindings = bindings.map((binding)=>{
        const options = $dd4549797813bb01$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach((unbind)=>{
            unbind();
        });
    };
}
const $dd4549797813bb01$var$isProduction = true;
const $dd4549797813bb01$var$prefix$1 = "Invariant failed";
class $dd4549797813bb01$var$RbdInvariant extends Error {
}
$dd4549797813bb01$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $dd4549797813bb01$var$invariant(condition, message) {
    if (condition) return;
    if ($dd4549797813bb01$var$isProduction) throw new $dd4549797813bb01$var$RbdInvariant($dd4549797813bb01$var$prefix$1);
    else throw new $dd4549797813bb01$var$RbdInvariant(`${$dd4549797813bb01$var$prefix$1}: ${message || ""}`);
}
class $dd4549797813bb01$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).Component {
    constructor(...args){
        super(...args);
        this.callbacks = null;
        this.unbind = $dd4549797813bb01$var$noop$2;
        this.onWindowError = (event)=>{
            const callbacks = this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            const err = event.error;
            if (err instanceof $dd4549797813bb01$var$RbdInvariant) event.preventDefault();
        };
        this.getCallbacks = ()=>{
            if (!this.callbacks) throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
            return this.callbacks;
        };
        this.setCallbacks = (callbacks)=>{
            this.callbacks = callbacks;
        };
    }
    componentDidMount() {
        this.unbind = $dd4549797813bb01$var$bindEvents(window, [
            {
                eventName: "error",
                fn: this.onWindowError
            }
        ]);
    }
    componentDidCatch(err) {
        if (err instanceof $dd4549797813bb01$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    }
    componentWillUnmount() {
        this.unbind();
    }
    render() {
        return this.props.children(this.setCallbacks);
    }
}
const $dd4549797813bb01$var$dragHandleUsageInstructions = `
  Press space bar to start a drag.
  When dragging you can use the arrow keys to move the item around and escape to cancel.
  Some screen readers may require you to be in focus mode or to use your pass through key
`;
const $dd4549797813bb01$var$position = (index)=>index + 1;
const $dd4549797813bb01$var$onDragStart = (start)=>`
  You have lifted an item in position ${$dd4549797813bb01$var$position(start.source.index)}
`;
const $dd4549797813bb01$var$withLocation = (source, destination)=>{
    const isInHomeList = source.droppableId === destination.droppableId;
    const startPosition = $dd4549797813bb01$var$position(source.index);
    const endPosition = $dd4549797813bb01$var$position(destination.index);
    if (isInHomeList) return `
      You have moved the item from position ${startPosition}
      to position ${endPosition}
    `;
    return `
    You have moved the item from position ${startPosition}
    in list ${source.droppableId}
    to list ${destination.droppableId}
    in position ${endPosition}
  `;
};
const $dd4549797813bb01$var$withCombine = (id, source, combine)=>{
    const inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return `
      The item ${id}
      has been combined with ${combine.draggableId}`;
    return `
      The item ${id}
      in list ${source.droppableId}
      has been combined with ${combine.draggableId}
      in list ${combine.droppableId}
    `;
};
const $dd4549797813bb01$var$onDragUpdate = (update)=>{
    const location = update.destination;
    if (location) return $dd4549797813bb01$var$withLocation(update.source, location);
    const combine = update.combine;
    if (combine) return $dd4549797813bb01$var$withCombine(update.draggableId, update.source, combine);
    return "You are over an area that cannot be dropped on";
};
const $dd4549797813bb01$var$returnedToStart = (source)=>`
  The item has returned to its starting position
  of ${$dd4549797813bb01$var$position(source.index)}
`;
const $dd4549797813bb01$var$onDragEnd = (result)=>{
    if (result.reason === "CANCEL") return `
      Movement cancelled.
      ${$dd4549797813bb01$var$returnedToStart(result.source)}
    `;
    const location = result.destination;
    const combine = result.combine;
    if (location) return `
      You have dropped the item.
      ${$dd4549797813bb01$var$withLocation(result.source, location)}
    `;
    if (combine) return `
      You have dropped the item.
      ${$dd4549797813bb01$var$withCombine(result.draggableId, result.source, combine)}
    `;
    return `
    The item has been dropped while not over a drop area.
    ${$dd4549797813bb01$var$returnedToStart(result.source)}
  `;
};
const $dd4549797813bb01$var$preset = {
    dragHandleUsageInstructions: $dd4549797813bb01$var$dragHandleUsageInstructions,
    onDragStart: $dd4549797813bb01$var$onDragStart,
    onDragUpdate: $dd4549797813bb01$var$onDragUpdate,
    onDragEnd: $dd4549797813bb01$var$onDragEnd
};
var $dd4549797813bb01$var$preset$1 = $dd4549797813bb01$var$preset;
const $dd4549797813bb01$var$origin = {
    x: 0,
    y: 0
};
const $dd4549797813bb01$var$add = (point1, point2)=>({
        x: point1.x + point2.x,
        y: point1.y + point2.y
    });
const $dd4549797813bb01$var$subtract = (point1, point2)=>({
        x: point1.x - point2.x,
        y: point1.y - point2.y
    });
const $dd4549797813bb01$var$isEqual$1 = (point1, point2)=>point1.x === point2.x && point1.y === point2.y;
const $dd4549797813bb01$var$negate = (point)=>({
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    });
const $dd4549797813bb01$var$patch = (line, value, otherValue = 0)=>{
    if (line === "x") return {
        x: value,
        y: otherValue
    };
    return {
        x: otherValue,
        y: value
    };
};
const $dd4549797813bb01$var$distance = (point1, point2)=>Math.sqrt((point2.x - point1.x) ** 2 + (point2.y - point1.y) ** 2);
const $dd4549797813bb01$var$closest$1 = (target, points)=>Math.min(...points.map((point)=>$dd4549797813bb01$var$distance(target, point)));
const $dd4549797813bb01$var$apply = (fn)=>(point)=>({
            x: fn(point.x),
            y: fn(point.y)
        });
var $dd4549797813bb01$var$executeClip = (frame, subject)=>{
    const result = (0, $kZLuh.getRect)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
const $dd4549797813bb01$var$offsetByPosition = (spacing, point)=>({
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    });
const $dd4549797813bb01$var$getCorners = (spacing)=>[
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
const $dd4549797813bb01$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
const $dd4549797813bb01$var$scroll$1 = (target, frame)=>{
    if (!frame) return target;
    return $dd4549797813bb01$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
const $dd4549797813bb01$var$increase = (target, axis, withPlaceholder)=>{
    if (withPlaceholder && withPlaceholder.increasedBy) return {
        ...target,
        [axis.end]: target[axis.end] + withPlaceholder.increasedBy[axis.line]
    };
    return target;
};
const $dd4549797813bb01$var$clip = (target, frame)=>{
    if (frame && frame.shouldClipSubject) return $dd4549797813bb01$var$executeClip(frame.pageMarginBox, target);
    return (0, $kZLuh.getRect)(target);
};
var $dd4549797813bb01$var$getSubject = ({ page: page, withPlaceholder: withPlaceholder, axis: axis, frame: frame })=>{
    const scrolled = $dd4549797813bb01$var$scroll$1(page.marginBox, frame);
    const increased = $dd4549797813bb01$var$increase(scrolled, axis, withPlaceholder);
    const clipped = $dd4549797813bb01$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $dd4549797813bb01$var$scrollDroppable = (droppable, newScroll)=>{
    !droppable.frame && $dd4549797813bb01$var$invariant(false);
    const scrollable = droppable.frame;
    const scrollDiff = $dd4549797813bb01$var$subtract(newScroll, scrollable.scroll.initial);
    const scrollDisplacement = $dd4549797813bb01$var$negate(scrollDiff);
    const frame = {
        ...scrollable,
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    };
    const subject = $dd4549797813bb01$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    const result = {
        ...droppable,
        frame: frame,
        subject: subject
    };
    return result;
};
const $dd4549797813bb01$var$toDroppableMap = (0, $6iviE.default)((droppables)=>droppables.reduce((previous, current)=>{
        previous[current.descriptor.id] = current;
        return previous;
    }, {}));
const $dd4549797813bb01$var$toDraggableMap = (0, $6iviE.default)((draggables)=>draggables.reduce((previous, current)=>{
        previous[current.descriptor.id] = current;
        return previous;
    }, {}));
const $dd4549797813bb01$var$toDroppableList = (0, $6iviE.default)((droppables)=>Object.values(droppables));
const $dd4549797813bb01$var$toDraggableList = (0, $6iviE.default)((draggables)=>Object.values(draggables));
var $dd4549797813bb01$var$getDraggablesInsideDroppable = (0, $6iviE.default)((droppableId, draggables)=>{
    const result = $dd4549797813bb01$var$toDraggableList(draggables).filter((draggable)=>droppableId === draggable.descriptor.droppableId).sort((a, b)=>a.descriptor.index - b.descriptor.index);
    return result;
});
function $dd4549797813bb01$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === "REORDER") return impact.at.destination;
    return null;
}
function $dd4549797813bb01$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === "COMBINE") return impact.at.combine;
    return null;
}
var $dd4549797813bb01$var$removeDraggableFromList = (0, $6iviE.default)((remove, list)=>list.filter((item)=>item.descriptor.id !== remove.descriptor.id));
var $dd4549797813bb01$var$moveToNextCombine = ({ isMovingForward: isMovingForward, draggable: draggable, destination: destination, insideDestination: insideDestination, previousImpact: previousImpact })=>{
    if (!destination.isCombineEnabled) return null;
    const location = $dd4549797813bb01$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        const at = {
            type: "COMBINE",
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return {
            ...previousImpact,
            at: at
        };
    }
    const all = previousImpact.displaced.all;
    const closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    const withoutDraggable = $dd4549797813bb01$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        const last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    const indexOfClosest = withoutDraggable.findIndex((d)=>d.descriptor.id === closestId);
    !(indexOfClosest !== -1) && $dd4549797813bb01$var$invariant(false);
    const proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    const before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $dd4549797813bb01$var$isHomeOf = (draggable, destination)=>draggable.descriptor.droppableId === destination.descriptor.id;
const $dd4549797813bb01$var$noDisplacedBy = {
    point: $dd4549797813bb01$var$origin,
    value: 0
};
const $dd4549797813bb01$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
const $dd4549797813bb01$var$noImpact = {
    displaced: $dd4549797813bb01$var$emptyGroups,
    displacedBy: $dd4549797813bb01$var$noDisplacedBy,
    at: null
};
var $dd4549797813bb01$var$noImpact$1 = $dd4549797813bb01$var$noImpact;
var $dd4549797813bb01$var$isWithin = (lowerBound, upperBound)=>(value)=>lowerBound <= value && value <= upperBound;
var $dd4549797813bb01$var$isPartiallyVisibleThroughFrame = (frame)=>{
    const isWithinVertical = $dd4549797813bb01$var$isWithin(frame.top, frame.bottom);
    const isWithinHorizontal = $dd4549797813bb01$var$isWithin(frame.left, frame.right);
    return (subject)=>{
        const isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        const isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        const isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        const isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        const isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        const isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        const isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        const isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $dd4549797813bb01$var$isTotallyVisibleThroughFrame = (frame)=>{
    const isWithinVertical = $dd4549797813bb01$var$isWithin(frame.top, frame.bottom);
    const isWithinHorizontal = $dd4549797813bb01$var$isWithin(frame.left, frame.right);
    return (subject)=>{
        const isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
const $dd4549797813bb01$var$vertical = {
    direction: "vertical",
    line: "y",
    crossAxisLine: "x",
    start: "top",
    end: "bottom",
    size: "height",
    crossAxisStart: "left",
    crossAxisEnd: "right",
    crossAxisSize: "width"
};
const $dd4549797813bb01$var$horizontal = {
    direction: "horizontal",
    line: "x",
    crossAxisLine: "y",
    start: "left",
    end: "right",
    size: "width",
    crossAxisStart: "top",
    crossAxisEnd: "bottom",
    crossAxisSize: "height"
};
var $dd4549797813bb01$var$isTotallyVisibleThroughFrameOnAxis = (axis)=>(frame)=>{
        const isWithinVertical = $dd4549797813bb01$var$isWithin(frame.top, frame.bottom);
        const isWithinHorizontal = $dd4549797813bb01$var$isWithin(frame.left, frame.right);
        return (subject)=>{
            if (axis === $dd4549797813bb01$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
const $dd4549797813bb01$var$getDroppableDisplaced = (target, destination)=>{
    const displacement = destination.frame ? destination.frame.scroll.diff.displacement : $dd4549797813bb01$var$origin;
    return $dd4549797813bb01$var$offsetByPosition(target, displacement);
};
const $dd4549797813bb01$var$isVisibleInDroppable = (target, destination, isVisibleThroughFrameFn)=>{
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
const $dd4549797813bb01$var$isVisibleInViewport = (target, viewport, isVisibleThroughFrameFn)=>isVisibleThroughFrameFn(viewport)(target);
const $dd4549797813bb01$var$isVisible$1 = ({ target: toBeDisplaced, destination: destination, viewport: viewport, withDroppableDisplacement: withDroppableDisplacement, isVisibleThroughFrameFn: isVisibleThroughFrameFn })=>{
    const displacedTarget = withDroppableDisplacement ? $dd4549797813bb01$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $dd4549797813bb01$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $dd4549797813bb01$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
const $dd4549797813bb01$var$isPartiallyVisible = (args)=>$dd4549797813bb01$var$isVisible$1({
        ...args,
        isVisibleThroughFrameFn: $dd4549797813bb01$var$isPartiallyVisibleThroughFrame
    });
const $dd4549797813bb01$var$isTotallyVisible = (args)=>$dd4549797813bb01$var$isVisible$1({
        ...args,
        isVisibleThroughFrameFn: $dd4549797813bb01$var$isTotallyVisibleThroughFrame
    });
const $dd4549797813bb01$var$isTotallyVisibleOnAxis = (args)=>$dd4549797813bb01$var$isVisible$1({
        ...args,
        isVisibleThroughFrameFn: $dd4549797813bb01$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    });
const $dd4549797813bb01$var$getShouldAnimate = (id, last, forceShouldAnimate)=>{
    if (typeof forceShouldAnimate === "boolean") return forceShouldAnimate;
    if (!last) return true;
    const { invisible: invisible, visible: visible } = last;
    if (invisible[id]) return false;
    const previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $dd4549797813bb01$var$getTarget(draggable, displacedBy) {
    const marginBox = draggable.page.marginBox;
    const expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $kZLuh.getRect)((0, $kZLuh.expand)(marginBox, expandBy));
}
function $dd4549797813bb01$var$getDisplacementGroups({ afterDragging: afterDragging, destination: destination, displacedBy: displacedBy, viewport: viewport, forceShouldAnimate: forceShouldAnimate, last: last }) {
    return afterDragging.reduce(function process(groups, draggable) {
        const target = $dd4549797813bb01$var$getTarget(draggable, displacedBy);
        const id = draggable.descriptor.id;
        groups.all.push(id);
        const isVisible = $dd4549797813bb01$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        const shouldAnimate = $dd4549797813bb01$var$getShouldAnimate(id, last, forceShouldAnimate);
        const displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $dd4549797813bb01$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    const indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $dd4549797813bb01$var$goAtEnd({ insideDestination: insideDestination, inHomeList: inHomeList, displacedBy: displacedBy, destination: destination }) {
    const newIndex = $dd4549797813bb01$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $dd4549797813bb01$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $dd4549797813bb01$var$calculateReorderImpact({ draggable: draggable, insideDestination: insideDestination, destination: destination, viewport: viewport, displacedBy: displacedBy, last: last, index: index, forceShouldAnimate: forceShouldAnimate }) {
    const inHomeList = $dd4549797813bb01$var$isHomeOf(draggable, destination);
    if (index == null) return $dd4549797813bb01$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    const match = insideDestination.find((item)=>item.descriptor.index === index);
    if (!match) return $dd4549797813bb01$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    const withoutDragging = $dd4549797813bb01$var$removeDraggableFromList(draggable, insideDestination);
    const sliceFrom = insideDestination.indexOf(match);
    const impacted = withoutDragging.slice(sliceFrom);
    const displaced = $dd4549797813bb01$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $dd4549797813bb01$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $dd4549797813bb01$var$fromCombine = ({ isMovingForward: isMovingForward, destination: destination, draggables: draggables, combine: combine, afterCritical: afterCritical })=>{
    if (!destination.isCombineEnabled) return null;
    const combineId = combine.draggableId;
    const combineWith = draggables[combineId];
    const combineWithIndex = combineWith.descriptor.index;
    const didCombineWithStartAfterCritical = $dd4549797813bb01$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $dd4549797813bb01$var$fromReorder = ({ isMovingForward: isMovingForward, isInHomeList: isInHomeList, insideDestination: insideDestination, location: location })=>{
    if (!insideDestination.length) return null;
    const currentIndex = location.index;
    const proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    const firstIndex = insideDestination[0].descriptor.index;
    const lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    const upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $dd4549797813bb01$var$moveToNextIndex = ({ isMovingForward: isMovingForward, isInHomeList: isInHomeList, draggable: draggable, draggables: draggables, destination: destination, insideDestination: insideDestination, previousImpact: previousImpact, viewport: viewport, afterCritical: afterCritical })=>{
    const wasAt = previousImpact.at;
    !wasAt && $dd4549797813bb01$var$invariant(false);
    if (wasAt.type === "REORDER") {
        const newIndex = $dd4549797813bb01$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (newIndex == null) return null;
        return $dd4549797813bb01$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: newIndex
        });
    }
    const newIndex = $dd4549797813bb01$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $dd4549797813bb01$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $dd4549797813bb01$var$getCombinedItemDisplacement = ({ displaced: displaced, afterCritical: afterCritical, combineWith: combineWith, displacedBy: displacedBy })=>{
    const isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($dd4549797813bb01$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $dd4549797813bb01$var$origin : $dd4549797813bb01$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $dd4549797813bb01$var$origin;
};
var $dd4549797813bb01$var$whenCombining = ({ afterCritical: afterCritical, impact: impact, draggables: draggables })=>{
    const combine = $dd4549797813bb01$var$tryGetCombine(impact);
    !combine && $dd4549797813bb01$var$invariant(false);
    const combineWith = combine.draggableId;
    const center = draggables[combineWith].page.borderBox.center;
    const displaceBy = $dd4549797813bb01$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $dd4549797813bb01$var$add(center, displaceBy);
};
const $dd4549797813bb01$var$distanceFromStartToBorderBoxCenter = (axis, box)=>box.margin[axis.start] + box.borderBox[axis.size] / 2;
const $dd4549797813bb01$var$distanceFromEndToBorderBoxCenter = (axis, box)=>box.margin[axis.end] + box.borderBox[axis.size] / 2;
const $dd4549797813bb01$var$getCrossAxisBorderBoxCenter = (axis, target, isMoving)=>target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
const $dd4549797813bb01$var$goAfter = ({ axis: axis, moveRelativeTo: moveRelativeTo, isMoving: isMoving })=>$dd4549797813bb01$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $dd4549797813bb01$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $dd4549797813bb01$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
const $dd4549797813bb01$var$goBefore = ({ axis: axis, moveRelativeTo: moveRelativeTo, isMoving: isMoving })=>$dd4549797813bb01$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $dd4549797813bb01$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $dd4549797813bb01$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
const $dd4549797813bb01$var$goIntoStart = ({ axis: axis, moveInto: moveInto, isMoving: isMoving })=>$dd4549797813bb01$var$patch(axis.line, moveInto.contentBox[axis.start] + $dd4549797813bb01$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $dd4549797813bb01$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
var $dd4549797813bb01$var$whenReordering = ({ impact: impact, draggable: draggable, draggables: draggables, droppable: droppable, afterCritical: afterCritical })=>{
    const insideDestination = $dd4549797813bb01$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    const draggablePage = draggable.page;
    const axis = droppable.axis;
    if (!insideDestination.length) return $dd4549797813bb01$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    const { displaced: displaced, displacedBy: displacedBy } = impact;
    const closestAfter = displaced.all[0];
    if (closestAfter) {
        const closest = draggables[closestAfter];
        if ($dd4549797813bb01$var$didStartAfterCritical(closestAfter, afterCritical)) return $dd4549797813bb01$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        const withDisplacement = (0, $kZLuh.offset)(closest.page, displacedBy.point);
        return $dd4549797813bb01$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    const last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($dd4549797813bb01$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        const page = (0, $kZLuh.offset)(last.page, $dd4549797813bb01$var$negate(afterCritical.displacedBy.point));
        return $dd4549797813bb01$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $dd4549797813bb01$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $dd4549797813bb01$var$withDroppableDisplacement = (droppable, point)=>{
    const frame = droppable.frame;
    if (!frame) return point;
    return $dd4549797813bb01$var$add(point, frame.scroll.diff.displacement);
};
const $dd4549797813bb01$var$getResultWithoutDroppableDisplacement = ({ impact: impact, draggable: draggable, droppable: droppable, draggables: draggables, afterCritical: afterCritical })=>{
    const original = draggable.page.borderBox.center;
    const at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === "REORDER") return $dd4549797813bb01$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $dd4549797813bb01$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $dd4549797813bb01$var$getPageBorderBoxCenterFromImpact = (args)=>{
    const withoutDisplacement = $dd4549797813bb01$var$getResultWithoutDroppableDisplacement(args);
    const droppable = args.droppable;
    const withDisplacement = droppable ? $dd4549797813bb01$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $dd4549797813bb01$var$scrollViewport = (viewport, newScroll)=>{
    const diff = $dd4549797813bb01$var$subtract(newScroll, viewport.scroll.initial);
    const displacement = $dd4549797813bb01$var$negate(diff);
    const frame = (0, $kZLuh.getRect)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    const updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $dd4549797813bb01$var$getDraggables$1(ids, draggables) {
    return ids.map((id)=>draggables[id]);
}
function $dd4549797813bb01$var$tryGetVisible(id, groups) {
    for(let i = 0; i < groups.length; i++){
        const displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $dd4549797813bb01$var$speculativelyIncrease = ({ impact: impact, viewport: viewport, destination: destination, draggables: draggables, maxScrollChange: maxScrollChange })=>{
    const scrolledViewport = $dd4549797813bb01$var$scrollViewport(viewport, $dd4549797813bb01$var$add(viewport.scroll.current, maxScrollChange));
    const scrolledDroppable = destination.frame ? $dd4549797813bb01$var$scrollDroppable(destination, $dd4549797813bb01$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    const last = impact.displaced;
    const withViewportScroll = $dd4549797813bb01$var$getDisplacementGroups({
        afterDragging: $dd4549797813bb01$var$getDraggables$1(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    const withDroppableScroll = $dd4549797813bb01$var$getDisplacementGroups({
        afterDragging: $dd4549797813bb01$var$getDraggables$1(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    const invisible = {};
    const visible = {};
    const groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach((id)=>{
        const displacement = $dd4549797813bb01$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    const newImpact = {
        ...impact,
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    };
    return newImpact;
};
var $dd4549797813bb01$var$withViewportDisplacement = (viewport, point)=>$dd4549797813bb01$var$add(viewport.scroll.diff.displacement, point);
var $dd4549797813bb01$var$getClientFromPageBorderBoxCenter = ({ pageBorderBoxCenter: pageBorderBoxCenter, draggable: draggable, viewport: viewport })=>{
    const withoutPageScrollChange = $dd4549797813bb01$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    const offset = $dd4549797813bb01$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $dd4549797813bb01$var$add(draggable.client.borderBox.center, offset);
};
var $dd4549797813bb01$var$isTotallyVisibleInNewLocation = ({ draggable: draggable, destination: destination, newPageBorderBoxCenter: newPageBorderBoxCenter, viewport: viewport, withDroppableDisplacement: withDroppableDisplacement, onlyOnMainAxis: onlyOnMainAxis = false })=>{
    const changeNeeded = $dd4549797813bb01$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    const shifted = $dd4549797813bb01$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    const args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $dd4549797813bb01$var$isTotallyVisibleOnAxis(args) : $dd4549797813bb01$var$isTotallyVisible(args);
};
var $dd4549797813bb01$var$moveToNextPlace = ({ isMovingForward: isMovingForward, draggable: draggable, destination: destination, draggables: draggables, previousImpact: previousImpact, viewport: viewport, previousPageBorderBoxCenter: previousPageBorderBoxCenter, previousClientSelection: previousClientSelection, afterCritical: afterCritical })=>{
    if (!destination.isEnabled) return null;
    const insideDestination = $dd4549797813bb01$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    const isInHomeList = $dd4549797813bb01$var$isHomeOf(draggable, destination);
    const impact = $dd4549797813bb01$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $dd4549797813bb01$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    const pageBorderBoxCenter = $dd4549797813bb01$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    const isVisibleInNewLocation = $dd4549797813bb01$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        const clientSelection = $dd4549797813bb01$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    const distance = $dd4549797813bb01$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    const cautious = $dd4549797813bb01$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
const $dd4549797813bb01$var$getKnownActive = (droppable)=>{
    const rect = droppable.subject.active;
    !rect && $dd4549797813bb01$var$invariant(false);
    return rect;
};
var $dd4549797813bb01$var$getBestCrossAxisDroppable = ({ isMovingForward: isMovingForward, pageBorderBoxCenter: pageBorderBoxCenter, source: source, droppables: droppables, viewport: viewport })=>{
    const active = source.subject.active;
    if (!active) return null;
    const axis = source.axis;
    const isBetweenSourceClipped = $dd4549797813bb01$var$isWithin(active[axis.start], active[axis.end]);
    const candidates = $dd4549797813bb01$var$toDroppableList(droppables).filter((droppable)=>droppable !== source).filter((droppable)=>droppable.isEnabled).filter((droppable)=>Boolean(droppable.subject.active)).filter((droppable)=>$dd4549797813bb01$var$isPartiallyVisibleThroughFrame(viewport.frame)($dd4549797813bb01$var$getKnownActive(droppable))).filter((droppable)=>{
        const activeOfTarget = $dd4549797813bb01$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter((droppable)=>{
        const activeOfTarget = $dd4549797813bb01$var$getKnownActive(droppable);
        const isBetweenDestinationClipped = $dd4549797813bb01$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort((a, b)=>{
        const first = $dd4549797813bb01$var$getKnownActive(a)[axis.crossAxisStart];
        const second = $dd4549797813bb01$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter((droppable, index, array)=>$dd4549797813bb01$var$getKnownActive(droppable)[axis.crossAxisStart] === $dd4549797813bb01$var$getKnownActive(array[0])[axis.crossAxisStart]);
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    const contains = candidates.filter((droppable)=>{
        const isWithinDroppable = $dd4549797813bb01$var$isWithin($dd4549797813bb01$var$getKnownActive(droppable)[axis.start], $dd4549797813bb01$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort((a, b)=>$dd4549797813bb01$var$getKnownActive(a)[axis.start] - $dd4549797813bb01$var$getKnownActive(b)[axis.start])[0];
    return candidates.sort((a, b)=>{
        const first = $dd4549797813bb01$var$closest$1(pageBorderBoxCenter, $dd4549797813bb01$var$getCorners($dd4549797813bb01$var$getKnownActive(a)));
        const second = $dd4549797813bb01$var$closest$1(pageBorderBoxCenter, $dd4549797813bb01$var$getCorners($dd4549797813bb01$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $dd4549797813bb01$var$getKnownActive(a)[axis.start] - $dd4549797813bb01$var$getKnownActive(b)[axis.start];
    })[0];
};
const $dd4549797813bb01$var$getCurrentPageBorderBoxCenter = (draggable, afterCritical)=>{
    const original = draggable.page.borderBox.center;
    return $dd4549797813bb01$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $dd4549797813bb01$var$subtract(original, afterCritical.displacedBy.point) : original;
};
const $dd4549797813bb01$var$getCurrentPageBorderBox = (draggable, afterCritical)=>{
    const original = draggable.page.borderBox;
    return $dd4549797813bb01$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $dd4549797813bb01$var$offsetByPosition(original, $dd4549797813bb01$var$negate(afterCritical.displacedBy.point)) : original;
};
var $dd4549797813bb01$var$getClosestDraggable = ({ pageBorderBoxCenter: pageBorderBoxCenter, viewport: viewport, destination: destination, insideDestination: insideDestination, afterCritical: afterCritical })=>{
    const sorted = insideDestination.filter((draggable)=>$dd4549797813bb01$var$isTotallyVisible({
            target: $dd4549797813bb01$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        })).sort((a, b)=>{
        const distanceToA = $dd4549797813bb01$var$distance(pageBorderBoxCenter, $dd4549797813bb01$var$withDroppableDisplacement(destination, $dd4549797813bb01$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        const distanceToB = $dd4549797813bb01$var$distance(pageBorderBoxCenter, $dd4549797813bb01$var$withDroppableDisplacement(destination, $dd4549797813bb01$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $dd4549797813bb01$var$getDisplacedBy = (0, $6iviE.default)(function getDisplacedBy(axis, displaceBy) {
    const displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $dd4549797813bb01$var$patch(axis.line, displacement)
    };
});
const $dd4549797813bb01$var$getRequiredGrowthForPlaceholder = (droppable, placeholderSize, draggables)=>{
    const axis = droppable.axis;
    if (droppable.descriptor.mode === "virtual") return $dd4549797813bb01$var$patch(axis.line, placeholderSize[axis.line]);
    const availableSpace = droppable.subject.page.contentBox[axis.size];
    const insideDroppable = $dd4549797813bb01$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    const spaceUsed = insideDroppable.reduce((sum, dimension)=>sum + dimension.client.marginBox[axis.size], 0);
    const requiredSpace = spaceUsed + placeholderSize[axis.line];
    const needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $dd4549797813bb01$var$patch(axis.line, needsToGrowBy);
};
const $dd4549797813bb01$var$withMaxScroll = (frame, max)=>({
        ...frame,
        scroll: {
            ...frame.scroll,
            max: max
        }
    });
const $dd4549797813bb01$var$addPlaceholder = (droppable, draggable, draggables)=>{
    const frame = droppable.frame;
    !!$dd4549797813bb01$var$isHomeOf(draggable, droppable) && $dd4549797813bb01$var$invariant(false);
    !!droppable.subject.withPlaceholder && $dd4549797813bb01$var$invariant(false);
    const placeholderSize = $dd4549797813bb01$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    const requiredGrowth = $dd4549797813bb01$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    const added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        const subject = $dd4549797813bb01$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return {
            ...droppable,
            subject: subject
        };
    }
    const maxScroll = requiredGrowth ? $dd4549797813bb01$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    const newFrame = $dd4549797813bb01$var$withMaxScroll(frame, maxScroll);
    const subject = $dd4549797813bb01$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return {
        ...droppable,
        subject: subject,
        frame: newFrame
    };
};
const $dd4549797813bb01$var$removePlaceholder = (droppable)=>{
    const added = droppable.subject.withPlaceholder;
    !added && $dd4549797813bb01$var$invariant(false);
    const frame = droppable.frame;
    if (!frame) {
        const subject = $dd4549797813bb01$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return {
            ...droppable,
            subject: subject
        };
    }
    const oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $dd4549797813bb01$var$invariant(false);
    const newFrame = $dd4549797813bb01$var$withMaxScroll(frame, oldMaxScroll);
    const subject = $dd4549797813bb01$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return {
        ...droppable,
        subject: subject,
        frame: newFrame
    };
};
var $dd4549797813bb01$var$moveToNewDroppable = ({ previousPageBorderBoxCenter: previousPageBorderBoxCenter, moveRelativeTo: moveRelativeTo, insideDestination: insideDestination, draggable: draggable, draggables: draggables, destination: destination, viewport: viewport, afterCritical: afterCritical })=>{
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        const proposed = {
            displaced: $dd4549797813bb01$var$emptyGroups,
            displacedBy: $dd4549797813bb01$var$noDisplacedBy,
            at: {
                type: "REORDER",
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        const proposedPageBorderBoxCenter = $dd4549797813bb01$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        const withPlaceholder = $dd4549797813bb01$var$isHomeOf(draggable, destination) ? destination : $dd4549797813bb01$var$addPlaceholder(destination, draggable, draggables);
        const isVisibleInNewLocation = $dd4549797813bb01$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    const isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    const proposedIndex = (()=>{
        const relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    })();
    const displacedBy = $dd4549797813bb01$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $dd4549797813bb01$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $dd4549797813bb01$var$emptyGroups,
        index: proposedIndex
    });
};
var $dd4549797813bb01$var$moveCrossAxis = ({ isMovingForward: isMovingForward, previousPageBorderBoxCenter: previousPageBorderBoxCenter, draggable: draggable, isOver: isOver, draggables: draggables, droppables: droppables, viewport: viewport, afterCritical: afterCritical })=>{
    const destination = $dd4549797813bb01$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    const insideDestination = $dd4549797813bb01$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    const moveRelativeTo = $dd4549797813bb01$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    const impact = $dd4549797813bb01$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    const pageBorderBoxCenter = $dd4549797813bb01$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    const clientSelection = $dd4549797813bb01$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $dd4549797813bb01$var$whatIsDraggedOver = (impact)=>{
    const at = impact.at;
    if (!at) return null;
    if (at.type === "REORDER") return at.destination.droppableId;
    return at.combine.droppableId;
};
const $dd4549797813bb01$var$getDroppableOver$1 = (impact, droppables)=>{
    const id = $dd4549797813bb01$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $dd4549797813bb01$var$moveInDirection = ({ state: state, type: type })=>{
    const isActuallyOver = $dd4549797813bb01$var$getDroppableOver$1(state.impact, state.dimensions.droppables);
    const isMainAxisMovementAllowed = Boolean(isActuallyOver);
    const home = state.dimensions.droppables[state.critical.droppable.id];
    const isOver = isActuallyOver || home;
    const direction = isOver.axis.direction;
    const isMovingOnMainAxis = direction === "vertical" && (type === "MOVE_UP" || type === "MOVE_DOWN") || direction === "horizontal" && (type === "MOVE_LEFT" || type === "MOVE_RIGHT");
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    const isMovingForward = type === "MOVE_DOWN" || type === "MOVE_RIGHT";
    const draggable = state.dimensions.draggables[state.critical.draggable.id];
    const previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    const { draggables: draggables, droppables: droppables } = state.dimensions;
    return isMovingOnMainAxis ? $dd4549797813bb01$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $dd4549797813bb01$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $dd4549797813bb01$var$isMovementAllowed(state) {
    return state.phase === "DRAGGING" || state.phase === "COLLECTING";
}
function $dd4549797813bb01$var$isPositionInFrame(frame) {
    const isWithinVertical = $dd4549797813bb01$var$isWithin(frame.top, frame.bottom);
    const isWithinHorizontal = $dd4549797813bb01$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $dd4549797813bb01$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $dd4549797813bb01$var$getFurthestAway({ pageBorderBox: pageBorderBox, draggable: draggable, candidates: candidates }) {
    const startCenter = draggable.page.borderBox.center;
    const sorted = candidates.map((candidate)=>{
        const axis = candidate.axis;
        const target = $dd4549797813bb01$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $dd4549797813bb01$var$distance(startCenter, target)
        };
    }).sort((a, b)=>b.distance - a.distance);
    return sorted[0] ? sorted[0].id : null;
}
function $dd4549797813bb01$var$getDroppableOver({ pageBorderBox: pageBorderBox, draggable: draggable, droppables: droppables }) {
    const candidates = $dd4549797813bb01$var$toDroppableList(droppables).filter((item)=>{
        if (!item.isEnabled) return false;
        const active = item.subject.active;
        if (!active) return false;
        if (!$dd4549797813bb01$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($dd4549797813bb01$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        const axis = item.axis;
        const childCenter = active.center[axis.crossAxisLine];
        const crossAxisStart = pageBorderBox[axis.crossAxisStart];
        const crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        const isContained = $dd4549797813bb01$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        const isStartContained = isContained(crossAxisStart);
        const isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $dd4549797813bb01$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
const $dd4549797813bb01$var$offsetRectByPosition = (rect, point)=>(0, $kZLuh.getRect)($dd4549797813bb01$var$offsetByPosition(rect, point));
var $dd4549797813bb01$var$withDroppableScroll = (droppable, area)=>{
    const frame = droppable.frame;
    if (!frame) return area;
    return $dd4549797813bb01$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $dd4549797813bb01$var$getIsDisplaced({ displaced: displaced, id: id }) {
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $dd4549797813bb01$var$atIndex({ draggable: draggable, closest: closest, inHomeList: inHomeList }) {
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $dd4549797813bb01$var$getReorderImpact = ({ pageBorderBoxWithDroppableScroll: targetRect, draggable: draggable, destination: destination, insideDestination: insideDestination, last: last, viewport: viewport, afterCritical: afterCritical })=>{
    const axis = destination.axis;
    const displacedBy = $dd4549797813bb01$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    const displacement = displacedBy.value;
    const targetStart = targetRect[axis.start];
    const targetEnd = targetRect[axis.end];
    const withoutDragging = $dd4549797813bb01$var$removeDraggableFromList(draggable, insideDestination);
    const closest = withoutDragging.find((child)=>{
        const id = child.descriptor.id;
        const childCenter = child.page.borderBox.center[axis.line];
        const didStartAfterCritical$1 = $dd4549797813bb01$var$didStartAfterCritical(id, afterCritical);
        const isDisplaced = $dd4549797813bb01$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    }) || null;
    const newIndex = $dd4549797813bb01$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $dd4549797813bb01$var$isHomeOf(draggable, destination)
    });
    return $dd4549797813bb01$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
const $dd4549797813bb01$var$combineThresholdDivisor = 4;
var $dd4549797813bb01$var$getCombineImpact = ({ draggable: draggable, pageBorderBoxWithDroppableScroll: targetRect, previousImpact: previousImpact, destination: destination, insideDestination: insideDestination, afterCritical: afterCritical })=>{
    if (!destination.isCombineEnabled) return null;
    const axis = destination.axis;
    const displacedBy = $dd4549797813bb01$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    const displacement = displacedBy.value;
    const targetStart = targetRect[axis.start];
    const targetEnd = targetRect[axis.end];
    const withoutDragging = $dd4549797813bb01$var$removeDraggableFromList(draggable, insideDestination);
    const combineWith = withoutDragging.find((child)=>{
        const id = child.descriptor.id;
        const childRect = child.page.borderBox;
        const childSize = childRect[axis.size];
        const threshold = childSize / $dd4549797813bb01$var$combineThresholdDivisor;
        const didStartAfterCritical$1 = $dd4549797813bb01$var$didStartAfterCritical(id, afterCritical);
        const isDisplaced = $dd4549797813bb01$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    const impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: "COMBINE",
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $dd4549797813bb01$var$getDragImpact = ({ pageOffset: pageOffset, draggable: draggable, draggables: draggables, droppables: droppables, previousImpact: previousImpact, viewport: viewport, afterCritical: afterCritical })=>{
    const pageBorderBox = $dd4549797813bb01$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    const destinationId = $dd4549797813bb01$var$getDroppableOver({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $dd4549797813bb01$var$noImpact$1;
    const destination = droppables[destinationId];
    const insideDestination = $dd4549797813bb01$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    const pageBorderBoxWithDroppableScroll = $dd4549797813bb01$var$withDroppableScroll(destination, pageBorderBox);
    return $dd4549797813bb01$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $dd4549797813bb01$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $dd4549797813bb01$var$patchDroppableMap = (droppables, updated)=>({
        ...droppables,
        [updated.descriptor.id]: updated
    });
const $dd4549797813bb01$var$clearUnusedPlaceholder = ({ previousImpact: previousImpact, impact: impact, droppables: droppables })=>{
    const last = $dd4549797813bb01$var$whatIsDraggedOver(previousImpact);
    const now = $dd4549797813bb01$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    const lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    const updated = $dd4549797813bb01$var$removePlaceholder(lastDroppable);
    return $dd4549797813bb01$var$patchDroppableMap(droppables, updated);
};
var $dd4549797813bb01$var$recomputePlaceholders = ({ draggable: draggable, draggables: draggables, droppables: droppables, previousImpact: previousImpact, impact: impact })=>{
    const cleaned = $dd4549797813bb01$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    const isOver = $dd4549797813bb01$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    const droppable = droppables[isOver];
    if ($dd4549797813bb01$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    const patched = $dd4549797813bb01$var$addPlaceholder(droppable, draggable, draggables);
    return $dd4549797813bb01$var$patchDroppableMap(cleaned, patched);
};
var $dd4549797813bb01$var$update = ({ state: state, clientSelection: forcedClientSelection, dimensions: forcedDimensions, viewport: forcedViewport, impact: forcedImpact, scrollJumpRequest: scrollJumpRequest })=>{
    const viewport = forcedViewport || state.viewport;
    const dimensions = forcedDimensions || state.dimensions;
    const clientSelection = forcedClientSelection || state.current.client.selection;
    const offset = $dd4549797813bb01$var$subtract(clientSelection, state.initial.client.selection);
    const client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $dd4549797813bb01$var$add(state.initial.client.borderBoxCenter, offset)
    };
    const page = {
        selection: $dd4549797813bb01$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $dd4549797813bb01$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $dd4549797813bb01$var$add(client.offset, viewport.scroll.diff.value)
    };
    const current = {
        client: client,
        page: page
    };
    if (state.phase === "COLLECTING") return {
        ...state,
        dimensions: dimensions,
        viewport: viewport,
        current: current
    };
    const draggable = dimensions.draggables[state.critical.draggable.id];
    const newImpact = forcedImpact || $dd4549797813bb01$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    const withUpdatedPlaceholders = $dd4549797813bb01$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    const result = {
        ...state,
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    };
    return result;
};
function $dd4549797813bb01$var$getDraggables(ids, draggables) {
    return ids.map((id)=>draggables[id]);
}
var $dd4549797813bb01$var$recompute = ({ impact: impact, viewport: viewport, draggables: draggables, destination: destination, forceShouldAnimate: forceShouldAnimate })=>{
    const last = impact.displaced;
    const afterDragging = $dd4549797813bb01$var$getDraggables(last.all, draggables);
    const displaced = $dd4549797813bb01$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return {
        ...impact,
        displaced: displaced
    };
};
var $dd4549797813bb01$var$getClientBorderBoxCenter = ({ impact: impact, draggable: draggable, droppable: droppable, draggables: draggables, viewport: viewport, afterCritical: afterCritical })=>{
    const pageBorderBoxCenter = $dd4549797813bb01$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $dd4549797813bb01$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $dd4549797813bb01$var$refreshSnap = ({ state: state, dimensions: forcedDimensions, viewport: forcedViewport })=>{
    !(state.movementMode === "SNAP") && $dd4549797813bb01$var$invariant(false);
    const needsVisibilityCheck = state.impact;
    const viewport = forcedViewport || state.viewport;
    const dimensions = forcedDimensions || state.dimensions;
    const { draggables: draggables, droppables: droppables } = dimensions;
    const draggable = draggables[state.critical.draggable.id];
    const isOver = $dd4549797813bb01$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $dd4549797813bb01$var$invariant(false);
    const destination = droppables[isOver];
    const impact = $dd4549797813bb01$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    const clientSelection = $dd4549797813bb01$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $dd4549797813bb01$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $dd4549797813bb01$var$getHomeLocation = (descriptor)=>({
        index: descriptor.index,
        droppableId: descriptor.droppableId
    });
var $dd4549797813bb01$var$getLiftEffect = ({ draggable: draggable, home: home, draggables: draggables, viewport: viewport })=>{
    const displacedBy = $dd4549797813bb01$var$getDisplacedBy(home.axis, draggable.displaceBy);
    const insideHome = $dd4549797813bb01$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    const rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $dd4549797813bb01$var$invariant(false);
    const afterDragging = insideHome.slice(rawIndex + 1);
    const effected = afterDragging.reduce((previous, item)=>{
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    const afterCritical = {
        inVirtualList: home.descriptor.mode === "virtual",
        displacedBy: displacedBy,
        effected: effected
    };
    const displaced = $dd4549797813bb01$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    const impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: $dd4549797813bb01$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $dd4549797813bb01$var$patchDimensionMap = (dimensions, updated)=>({
        draggables: dimensions.draggables,
        droppables: $dd4549797813bb01$var$patchDroppableMap(dimensions.droppables, updated)
    });
const $dd4549797813bb01$var$start = (key)=>{};
const $dd4549797813bb01$var$finish = (key)=>{};
var $dd4549797813bb01$var$offsetDraggable = ({ draggable: draggable, offset: offset$1, initialWindowScroll: initialWindowScroll })=>{
    const client = (0, $kZLuh.offset)(draggable.client, offset$1);
    const page = (0, $kZLuh.withScroll)(client, initialWindowScroll);
    const moved = {
        ...draggable,
        placeholder: {
            ...draggable.placeholder,
            client: client
        },
        client: client,
        page: page
    };
    return moved;
};
var $dd4549797813bb01$var$getFrame = (droppable)=>{
    const frame = droppable.frame;
    !frame && $dd4549797813bb01$var$invariant(false);
    return frame;
};
var $dd4549797813bb01$var$adjustAdditionsForScrollChanges = ({ additions: additions, updatedDroppables: updatedDroppables, viewport: viewport })=>{
    const windowScrollChange = viewport.scroll.diff.value;
    return additions.map((draggable)=>{
        const droppableId = draggable.descriptor.droppableId;
        const modified = updatedDroppables[droppableId];
        const frame = $dd4549797813bb01$var$getFrame(modified);
        const droppableScrollChange = frame.scroll.diff.value;
        const totalChange = $dd4549797813bb01$var$add(windowScrollChange, droppableScrollChange);
        const moved = $dd4549797813bb01$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
const $dd4549797813bb01$var$timingsKey = "Processing dynamic changes";
var $dd4549797813bb01$var$publishWhileDraggingInVirtual = ({ state: state, published: published })=>{
    $dd4549797813bb01$var$start();
    const withScrollChange = published.modified.map((update)=>{
        const existing = state.dimensions.droppables[update.droppableId];
        const scrolled = $dd4549797813bb01$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    const droppables = {
        ...state.dimensions.droppables,
        ...$dd4549797813bb01$var$toDroppableMap(withScrollChange)
    };
    const updatedAdditions = $dd4549797813bb01$var$toDraggableMap($dd4549797813bb01$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    const draggables = {
        ...state.dimensions.draggables,
        ...updatedAdditions
    };
    published.removals.forEach((id)=>{
        delete draggables[id];
    });
    const dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    const wasOverId = $dd4549797813bb01$var$whatIsDraggedOver(state.impact);
    const wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    const draggable = dimensions.draggables[state.critical.draggable.id];
    const home = dimensions.droppables[state.critical.droppable.id];
    const { impact: onLiftImpact, afterCritical: afterCritical } = $dd4549797813bb01$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    });
    const previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    const impact = $dd4549797813bb01$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $dd4549797813bb01$var$finish($dd4549797813bb01$var$timingsKey);
    const draggingState = {
        ...state,
        phase: "DRAGGING",
        impact: impact,
        onLiftImpact: onLiftImpact,
        dimensions: dimensions,
        afterCritical: afterCritical,
        forceShouldAnimate: false
    };
    if (state.phase === "COLLECTING") return draggingState;
    const dropPending = {
        ...draggingState,
        phase: "DROP_PENDING",
        reason: state.reason,
        isWaiting: false
    };
    return dropPending;
};
const $dd4549797813bb01$var$isSnapping = (state)=>state.movementMode === "SNAP";
const $dd4549797813bb01$var$postDroppableChange = (state, updated, isEnabledChanging)=>{
    const dimensions = $dd4549797813bb01$var$patchDimensionMap(state.dimensions, updated);
    if (!$dd4549797813bb01$var$isSnapping(state) || isEnabledChanging) return $dd4549797813bb01$var$update({
        state: state,
        dimensions: dimensions
    });
    return $dd4549797813bb01$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $dd4549797813bb01$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === "SNAP") return {
        ...state,
        scrollJumpRequest: null
    };
    return state;
}
const $dd4549797813bb01$var$idle$2 = {
    phase: "IDLE",
    completed: null,
    shouldFlush: false
};
var $dd4549797813bb01$var$reducer = (state = $dd4549797813bb01$var$idle$2, action)=>{
    if (action.type === "FLUSH") return {
        ...$dd4549797813bb01$var$idle$2,
        shouldFlush: true
    };
    if (action.type === "INITIAL_PUBLISH") {
        !(state.phase === "IDLE") && $dd4549797813bb01$var$invariant(false);
        const { critical: critical, clientSelection: clientSelection, viewport: viewport, dimensions: dimensions, movementMode: movementMode } = action.payload;
        const draggable = dimensions.draggables[critical.draggable.id];
        const home = dimensions.droppables[critical.droppable.id];
        const client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $dd4549797813bb01$var$origin
        };
        const initial = {
            client: client,
            page: {
                selection: $dd4549797813bb01$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $dd4549797813bb01$var$add(client.selection, viewport.scroll.initial),
                offset: $dd4549797813bb01$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        const isWindowScrollAllowed = $dd4549797813bb01$var$toDroppableList(dimensions.droppables).every((item)=>!item.isFixedOnPage);
        const { impact: impact, afterCritical: afterCritical } = $dd4549797813bb01$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        });
        const result = {
            phase: "DRAGGING",
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === "COLLECTION_STARTING") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && $dd4549797813bb01$var$invariant(false);
        const result = {
            ...state,
            phase: "COLLECTING"
        };
        return result;
    }
    if (action.type === "PUBLISH_WHILE_DRAGGING") {
        !(state.phase === "COLLECTING" || state.phase === "DROP_PENDING") && $dd4549797813bb01$var$invariant(false);
        return $dd4549797813bb01$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === "MOVE") {
        if (state.phase === "DROP_PENDING") return state;
        !$dd4549797813bb01$var$isMovementAllowed(state) && $dd4549797813bb01$var$invariant(false);
        const { client: clientSelection } = action.payload;
        if ($dd4549797813bb01$var$isEqual$1(clientSelection, state.current.client.selection)) return state;
        return $dd4549797813bb01$var$update({
            state: state,
            clientSelection: clientSelection,
            impact: $dd4549797813bb01$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === "UPDATE_DROPPABLE_SCROLL") {
        if (state.phase === "DROP_PENDING") return $dd4549797813bb01$var$removeScrollJumpRequest(state);
        if (state.phase === "COLLECTING") return $dd4549797813bb01$var$removeScrollJumpRequest(state);
        !$dd4549797813bb01$var$isMovementAllowed(state) && $dd4549797813bb01$var$invariant(false);
        const { id: id, newScroll: newScroll } = action.payload;
        const target = state.dimensions.droppables[id];
        if (!target) return state;
        const scrolled = $dd4549797813bb01$var$scrollDroppable(target, newScroll);
        return $dd4549797813bb01$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !$dd4549797813bb01$var$isMovementAllowed(state) && $dd4549797813bb01$var$invariant(false);
        const { id: id, isEnabled: isEnabled } = action.payload;
        const target = state.dimensions.droppables[id];
        !target && $dd4549797813bb01$var$invariant(false);
        !(target.isEnabled !== isEnabled) && $dd4549797813bb01$var$invariant(false);
        const updated = {
            ...target,
            isEnabled: isEnabled
        };
        return $dd4549797813bb01$var$postDroppableChange(state, updated, true);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !$dd4549797813bb01$var$isMovementAllowed(state) && $dd4549797813bb01$var$invariant(false);
        const { id: id, isCombineEnabled: isCombineEnabled } = action.payload;
        const target = state.dimensions.droppables[id];
        !target && $dd4549797813bb01$var$invariant(false);
        !(target.isCombineEnabled !== isCombineEnabled) && $dd4549797813bb01$var$invariant(false);
        const updated = {
            ...target,
            isCombineEnabled: isCombineEnabled
        };
        return $dd4549797813bb01$var$postDroppableChange(state, updated, true);
    }
    if (action.type === "MOVE_BY_WINDOW_SCROLL") {
        if (state.phase === "DROP_PENDING" || state.phase === "DROP_ANIMATING") return state;
        !$dd4549797813bb01$var$isMovementAllowed(state) && $dd4549797813bb01$var$invariant(false);
        !state.isWindowScrollAllowed && $dd4549797813bb01$var$invariant(false);
        const newScroll = action.payload.newScroll;
        if ($dd4549797813bb01$var$isEqual$1(state.viewport.scroll.current, newScroll)) return $dd4549797813bb01$var$removeScrollJumpRequest(state);
        const viewport = $dd4549797813bb01$var$scrollViewport(state.viewport, newScroll);
        if ($dd4549797813bb01$var$isSnapping(state)) return $dd4549797813bb01$var$refreshSnap({
            state: state,
            viewport: viewport
        });
        return $dd4549797813bb01$var$update({
            state: state,
            viewport: viewport
        });
    }
    if (action.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
        if (!$dd4549797813bb01$var$isMovementAllowed(state)) return state;
        const maxScroll = action.payload.maxScroll;
        if ($dd4549797813bb01$var$isEqual$1(maxScroll, state.viewport.scroll.max)) return state;
        const withMaxScroll = {
            ...state.viewport,
            scroll: {
                ...state.viewport.scroll,
                max: maxScroll
            }
        };
        return {
            ...state,
            viewport: withMaxScroll
        };
    }
    if (action.type === "MOVE_UP" || action.type === "MOVE_DOWN" || action.type === "MOVE_LEFT" || action.type === "MOVE_RIGHT") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && $dd4549797813bb01$var$invariant(false);
        const result = $dd4549797813bb01$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!result) return state;
        return $dd4549797813bb01$var$update({
            state: state,
            impact: result.impact,
            clientSelection: result.clientSelection,
            scrollJumpRequest: result.scrollJumpRequest
        });
    }
    if (action.type === "DROP_PENDING") {
        const reason = action.payload.reason;
        !(state.phase === "COLLECTING") && $dd4549797813bb01$var$invariant(false);
        const newState = {
            ...state,
            phase: "DROP_PENDING",
            isWaiting: true,
            reason: reason
        };
        return newState;
    }
    if (action.type === "DROP_ANIMATE") {
        const { completed: completed, dropDuration: dropDuration, newHomeClientOffset: newHomeClientOffset } = action.payload;
        !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && $dd4549797813bb01$var$invariant(false);
        const result = {
            phase: "DROP_ANIMATING",
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return result;
    }
    if (action.type === "DROP_COMPLETE") {
        const { completed: completed } = action.payload;
        return {
            phase: "IDLE",
            completed: completed,
            shouldFlush: false
        };
    }
    return state;
};
const $dd4549797813bb01$var$beforeInitialCapture = (args)=>({
        type: "BEFORE_INITIAL_CAPTURE",
        payload: args
    });
const $dd4549797813bb01$var$lift$1 = (args)=>({
        type: "LIFT",
        payload: args
    });
const $dd4549797813bb01$var$initialPublish = (args)=>({
        type: "INITIAL_PUBLISH",
        payload: args
    });
const $dd4549797813bb01$var$publishWhileDragging = (args)=>({
        type: "PUBLISH_WHILE_DRAGGING",
        payload: args
    });
const $dd4549797813bb01$var$collectionStarting = ()=>({
        type: "COLLECTION_STARTING",
        payload: null
    });
const $dd4549797813bb01$var$updateDroppableScroll = (args)=>({
        type: "UPDATE_DROPPABLE_SCROLL",
        payload: args
    });
const $dd4549797813bb01$var$updateDroppableIsEnabled = (args)=>({
        type: "UPDATE_DROPPABLE_IS_ENABLED",
        payload: args
    });
const $dd4549797813bb01$var$updateDroppableIsCombineEnabled = (args)=>({
        type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
        payload: args
    });
const $dd4549797813bb01$var$move = (args)=>({
        type: "MOVE",
        payload: args
    });
const $dd4549797813bb01$var$moveByWindowScroll = (args)=>({
        type: "MOVE_BY_WINDOW_SCROLL",
        payload: args
    });
const $dd4549797813bb01$var$updateViewportMaxScroll = (args)=>({
        type: "UPDATE_VIEWPORT_MAX_SCROLL",
        payload: args
    });
const $dd4549797813bb01$var$moveUp = ()=>({
        type: "MOVE_UP",
        payload: null
    });
const $dd4549797813bb01$var$moveDown = ()=>({
        type: "MOVE_DOWN",
        payload: null
    });
const $dd4549797813bb01$var$moveRight = ()=>({
        type: "MOVE_RIGHT",
        payload: null
    });
const $dd4549797813bb01$var$moveLeft = ()=>({
        type: "MOVE_LEFT",
        payload: null
    });
const $dd4549797813bb01$var$flush = ()=>({
        type: "FLUSH",
        payload: null
    });
const $dd4549797813bb01$var$animateDrop = (args)=>({
        type: "DROP_ANIMATE",
        payload: args
    });
const $dd4549797813bb01$var$completeDrop = (args)=>({
        type: "DROP_COMPLETE",
        payload: args
    });
const $dd4549797813bb01$var$drop$1 = (args)=>({
        type: "DROP",
        payload: args
    });
const $dd4549797813bb01$var$dropPending = (args)=>({
        type: "DROP_PENDING",
        payload: args
    });
const $dd4549797813bb01$var$dropAnimationFinished = ()=>({
        type: "DROP_ANIMATION_FINISHED",
        payload: null
    });
function $dd4549797813bb01$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    const indexes = insideDestination.map((d)=>d.descriptor.index);
    const errors = {};
    for(let i = 1; i < indexes.length; i++){
        const current = indexes[i];
        const previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!Object.keys(errors).length) return;
    const formatted = indexes.map((index)=>{
        const hasError = Boolean(errors[index]);
        return hasError ? `[\u{1F525}${index}]` : `${index}`;
    }).join(", ");
}
function $dd4549797813bb01$var$validateDimensions(critical, dimensions) {}
var $dd4549797813bb01$var$lift = (marshal)=>({ getState: getState, dispatch: dispatch })=>(next)=>(action)=>{
                if (action.type !== "LIFT") {
                    next(action);
                    return;
                }
                const { id: id, clientSelection: clientSelection, movementMode: movementMode } = action.payload;
                const initial = getState();
                if (initial.phase === "DROP_ANIMATING") dispatch($dd4549797813bb01$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === "IDLE") && $dd4549797813bb01$var$invariant(false);
                dispatch($dd4549797813bb01$var$flush());
                dispatch($dd4549797813bb01$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                const scrollOptions = {
                    shouldPublishImmediately: movementMode === "SNAP"
                };
                const request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                const { critical: critical, dimensions: dimensions, viewport: viewport } = marshal.startPublishing(request);
                $dd4549797813bb01$var$validateDimensions(critical, dimensions);
                dispatch($dd4549797813bb01$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
var $dd4549797813bb01$var$style = (marshal)=>()=>(next)=>(action)=>{
                if (action.type === "INITIAL_PUBLISH") marshal.dragging();
                if (action.type === "DROP_ANIMATE") marshal.dropping(action.payload.completed.result.reason);
                if (action.type === "FLUSH" || action.type === "DROP_COMPLETE") marshal.resting();
                next(action);
            };
const $dd4549797813bb01$var$curves = {
    outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
    drop: "cubic-bezier(.2,1,.1,1)"
};
const $dd4549797813bb01$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
const $dd4549797813bb01$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
const $dd4549797813bb01$var$outOfTheWayTiming = `${$dd4549797813bb01$var$timings.outOfTheWay}s ${$dd4549797813bb01$var$curves.outOfTheWay}`;
const $dd4549797813bb01$var$transitions = {
    fluid: `opacity ${$dd4549797813bb01$var$outOfTheWayTiming}`,
    snap: `transform ${$dd4549797813bb01$var$outOfTheWayTiming}, opacity ${$dd4549797813bb01$var$outOfTheWayTiming}`,
    drop: (duration)=>{
        const timing = `${duration}s ${$dd4549797813bb01$var$curves.drop}`;
        return `transform ${timing}, opacity ${timing}`;
    },
    outOfTheWay: `transform ${$dd4549797813bb01$var$outOfTheWayTiming}`,
    placeholder: `height ${$dd4549797813bb01$var$outOfTheWayTiming}, width ${$dd4549797813bb01$var$outOfTheWayTiming}, margin ${$dd4549797813bb01$var$outOfTheWayTiming}`
};
const $dd4549797813bb01$var$moveTo = (offset)=>$dd4549797813bb01$var$isEqual$1(offset, $dd4549797813bb01$var$origin) ? undefined : `translate(${offset.x}px, ${offset.y}px)`;
const $dd4549797813bb01$var$transforms = {
    moveTo: $dd4549797813bb01$var$moveTo,
    drop: (offset, isCombining)=>{
        const translate = $dd4549797813bb01$var$moveTo(offset);
        if (!translate) return undefined;
        if (!isCombining) return translate;
        return `${translate} scale(${$dd4549797813bb01$var$combine.scale.drop})`;
    }
};
const { minDropTime: $dd4549797813bb01$var$minDropTime, maxDropTime: $dd4549797813bb01$var$maxDropTime } = $dd4549797813bb01$var$timings;
const $dd4549797813bb01$var$dropTimeRange = $dd4549797813bb01$var$maxDropTime - $dd4549797813bb01$var$minDropTime;
const $dd4549797813bb01$var$maxDropTimeAtDistance = 1500;
const $dd4549797813bb01$var$cancelDropModifier = 0.6;
var $dd4549797813bb01$var$getDropDuration = ({ current: current, destination: destination, reason: reason })=>{
    const distance$1 = $dd4549797813bb01$var$distance(current, destination);
    if (distance$1 <= 0) return $dd4549797813bb01$var$minDropTime;
    if (distance$1 >= $dd4549797813bb01$var$maxDropTimeAtDistance) return $dd4549797813bb01$var$maxDropTime;
    const percentage = distance$1 / $dd4549797813bb01$var$maxDropTimeAtDistance;
    const duration = $dd4549797813bb01$var$minDropTime + $dd4549797813bb01$var$dropTimeRange * percentage;
    const withDuration = reason === "CANCEL" ? duration * $dd4549797813bb01$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $dd4549797813bb01$var$getNewHomeClientOffset = ({ impact: impact, draggable: draggable, dimensions: dimensions, viewport: viewport, afterCritical: afterCritical })=>{
    const { draggables: draggables, droppables: droppables } = dimensions;
    const droppableId = $dd4549797813bb01$var$whatIsDraggedOver(impact);
    const destination = droppableId ? droppables[droppableId] : null;
    const home = droppables[draggable.descriptor.droppableId];
    const newClientCenter = $dd4549797813bb01$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    const offset = $dd4549797813bb01$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $dd4549797813bb01$var$getDropImpact = ({ draggables: draggables, reason: reason, lastImpact: lastImpact, home: home, viewport: viewport, onLiftImpact: onLiftImpact })=>{
    if (!lastImpact.at || reason !== "DROP") {
        const recomputedHomeImpact = $dd4549797813bb01$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === "REORDER") return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    const withoutMovement = {
        ...lastImpact,
        displaced: $dd4549797813bb01$var$emptyGroups
    };
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
const $dd4549797813bb01$var$dropMiddleware = ({ getState: getState, dispatch: dispatch })=>(next)=>(action)=>{
            if (action.type !== "DROP") {
                next(action);
                return;
            }
            const state = getState();
            const reason = action.payload.reason;
            if (state.phase === "COLLECTING") {
                dispatch($dd4549797813bb01$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === "IDLE") return;
            const isWaitingForDrop = state.phase === "DROP_PENDING" && state.isWaiting;
            !!isWaitingForDrop && $dd4549797813bb01$var$invariant(false);
            !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && $dd4549797813bb01$var$invariant(false);
            const critical = state.critical;
            const dimensions = state.dimensions;
            const draggable = dimensions.draggables[state.critical.draggable.id];
            const { impact: impact, didDropInsideDroppable: didDropInsideDroppable } = $dd4549797813bb01$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            });
            const destination = didDropInsideDroppable ? $dd4549797813bb01$var$tryGetDestination(impact) : null;
            const combine = didDropInsideDroppable ? $dd4549797813bb01$var$tryGetCombine(impact) : null;
            const source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            const result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            const newHomeClientOffset = $dd4549797813bb01$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            const completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            const isAnimationRequired = !$dd4549797813bb01$var$isEqual$1(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($dd4549797813bb01$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            const dropDuration = $dd4549797813bb01$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            const args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($dd4549797813bb01$var$animateDrop(args));
        };
var $dd4549797813bb01$var$drop = $dd4549797813bb01$var$dropMiddleware;
var $dd4549797813bb01$var$getWindowScroll = ()=>({
        x: window.pageXOffset,
        y: window.pageYOffset
    });
function $dd4549797813bb01$var$getWindowScrollBinding(update) {
    return {
        eventName: "scroll",
        options: {
            passive: true,
            capture: false
        },
        fn: (event)=>{
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $dd4549797813bb01$var$getScrollListener({ onWindowScroll: onWindowScroll }) {
    function updateScroll() {
        onWindowScroll($dd4549797813bb01$var$getWindowScroll());
    }
    const scheduled = (0, $ed8xX.default)(updateScroll);
    const binding = $dd4549797813bb01$var$getWindowScrollBinding(scheduled);
    let unbind = $dd4549797813bb01$var$noop$2;
    function isActive() {
        return unbind !== $dd4549797813bb01$var$noop$2;
    }
    function start() {
        !!isActive() && $dd4549797813bb01$var$invariant(false);
        unbind = $dd4549797813bb01$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $dd4549797813bb01$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $dd4549797813bb01$var$noop$2;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
const $dd4549797813bb01$var$shouldEnd = (action)=>action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
const $dd4549797813bb01$var$scrollListener = (store)=>{
    const listener = $dd4549797813bb01$var$getScrollListener({
        onWindowScroll: (newScroll)=>{
            store.dispatch($dd4549797813bb01$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return (next)=>(action)=>{
            if (!listener.isActive() && action.type === "INITIAL_PUBLISH") listener.start();
            if (listener.isActive() && $dd4549797813bb01$var$shouldEnd(action)) listener.stop();
            next(action);
        };
};
var $dd4549797813bb01$var$scrollListener$1 = $dd4549797813bb01$var$scrollListener;
var $dd4549797813bb01$var$getExpiringAnnounce = (announce)=>{
    let wasCalled = false;
    let isExpired = false;
    const timeoutId = setTimeout(()=>{
        isExpired = true;
    });
    const result = (message)=>{
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = ()=>wasCalled;
    return result;
};
var $dd4549797813bb01$var$getAsyncMarshal = ()=>{
    const entries = [];
    const execute = (timerId)=>{
        const index = entries.findIndex((item)=>item.timerId === timerId);
        !(index !== -1) && $dd4549797813bb01$var$invariant(false);
        const [entry] = entries.splice(index, 1);
        entry.callback();
    };
    const add = (fn)=>{
        const timerId = setTimeout(()=>execute(timerId));
        const entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    const flush = ()=>{
        if (!entries.length) return;
        const shallow = [
            ...entries
        ];
        entries.length = 0;
        shallow.forEach((entry)=>{
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
const $dd4549797813bb01$var$areLocationsEqual = (first, second)=>{
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
const $dd4549797813bb01$var$isCombineEqual = (first, second)=>{
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
const $dd4549797813bb01$var$isCriticalEqual = (first, second)=>{
    if (first === second) return true;
    const isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    const isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
const $dd4549797813bb01$var$withTimings = (key, fn)=>{
    $dd4549797813bb01$var$start();
    fn();
    $dd4549797813bb01$var$finish();
};
const $dd4549797813bb01$var$getDragStart = (critical, mode)=>({
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    });
function $dd4549797813bb01$var$execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    const willExpire = $dd4549797813bb01$var$getExpiringAnnounce(announce);
    const provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
}
var $dd4549797813bb01$var$getPublisher = (getResponders, announce)=>{
    const asyncMarshal = $dd4549797813bb01$var$getAsyncMarshal();
    let dragging = null;
    const beforeCapture = (draggableId, mode)=>{
        !!dragging && $dd4549797813bb01$var$invariant(false);
        $dd4549797813bb01$var$withTimings("onBeforeCapture", ()=>{
            const fn = getResponders().onBeforeCapture;
            if (fn) {
                const before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    const beforeStart = (critical, mode)=>{
        !!dragging && $dd4549797813bb01$var$invariant(false);
        $dd4549797813bb01$var$withTimings("onBeforeDragStart", ()=>{
            const fn = getResponders().onBeforeDragStart;
            if (fn) fn($dd4549797813bb01$var$getDragStart(critical, mode));
        });
    };
    const start = (critical, mode)=>{
        !!dragging && $dd4549797813bb01$var$invariant(false);
        const data = $dd4549797813bb01$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(()=>{
            $dd4549797813bb01$var$withTimings("onDragStart", ()=>$dd4549797813bb01$var$execute(getResponders().onDragStart, data, announce, $dd4549797813bb01$var$preset$1.onDragStart));
        });
    };
    const update = (critical, impact)=>{
        const location = $dd4549797813bb01$var$tryGetDestination(impact);
        const combine = $dd4549797813bb01$var$tryGetCombine(impact);
        !dragging && $dd4549797813bb01$var$invariant(false);
        const hasCriticalChanged = !$dd4549797813bb01$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        const hasLocationChanged = !$dd4549797813bb01$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        const hasGroupingChanged = !$dd4549797813bb01$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        const data = {
            ...$dd4549797813bb01$var$getDragStart(critical, dragging.mode),
            combine: combine,
            destination: location
        };
        asyncMarshal.add(()=>{
            $dd4549797813bb01$var$withTimings("onDragUpdate", ()=>$dd4549797813bb01$var$execute(getResponders().onDragUpdate, data, announce, $dd4549797813bb01$var$preset$1.onDragUpdate));
        });
    };
    const flush = ()=>{
        !dragging && $dd4549797813bb01$var$invariant(false);
        asyncMarshal.flush();
    };
    const drop = (result)=>{
        !dragging && $dd4549797813bb01$var$invariant(false);
        dragging = null;
        $dd4549797813bb01$var$withTimings("onDragEnd", ()=>$dd4549797813bb01$var$execute(getResponders().onDragEnd, result, announce, $dd4549797813bb01$var$preset$1.onDragEnd));
    };
    const abort = ()=>{
        if (!dragging) return;
        const result = {
            ...$dd4549797813bb01$var$getDragStart(dragging.lastCritical, dragging.mode),
            combine: null,
            destination: null,
            reason: "CANCEL"
        };
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $dd4549797813bb01$var$responders = (getResponders, announce)=>{
    const publisher = $dd4549797813bb01$var$getPublisher(getResponders, announce);
    return (store)=>(next)=>(action)=>{
                if (action.type === "BEFORE_INITIAL_CAPTURE") {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    const critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    const result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === "FLUSH") {
                    publisher.abort();
                    return;
                }
                const state = store.getState();
                if (state.phase === "DRAGGING") publisher.update(state.critical, state.impact);
            };
};
const $dd4549797813bb01$var$dropAnimationFinishMiddleware = (store)=>(next)=>(action)=>{
            if (action.type !== "DROP_ANIMATION_FINISHED") {
                next(action);
                return;
            }
            const state = store.getState();
            !(state.phase === "DROP_ANIMATING") && $dd4549797813bb01$var$invariant(false);
            store.dispatch($dd4549797813bb01$var$completeDrop({
                completed: state.completed
            }));
        };
var $dd4549797813bb01$var$dropAnimationFinish = $dd4549797813bb01$var$dropAnimationFinishMiddleware;
const $dd4549797813bb01$var$dropAnimationFlushOnScrollMiddleware = (store)=>{
    let unbind = null;
    let frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return (next)=>(action)=>{
            if (action.type === "FLUSH" || action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATION_FINISHED") clear();
            next(action);
            if (action.type !== "DROP_ANIMATE") return;
            const binding = {
                eventName: "scroll",
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    const state = store.getState();
                    if (state.phase === "DROP_ANIMATING") store.dispatch($dd4549797813bb01$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(()=>{
                frameId = null;
                unbind = $dd4549797813bb01$var$bindEvents(window, [
                    binding
                ]);
            });
        };
};
var $dd4549797813bb01$var$dropAnimationFlushOnScroll = $dd4549797813bb01$var$dropAnimationFlushOnScrollMiddleware;
var $dd4549797813bb01$var$dimensionMarshalStopper = (marshal)=>()=>(next)=>(action)=>{
                if (action.type === "DROP_COMPLETE" || action.type === "FLUSH" || action.type === "DROP_ANIMATE") marshal.stopPublishing();
                next(action);
            };
var $dd4549797813bb01$var$focus = (marshal)=>{
    let isWatching = false;
    return ()=>(next)=>(action)=>{
                if (action.type === "INITIAL_PUBLISH") {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === "FLUSH") {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    isWatching = false;
                    const result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
};
const $dd4549797813bb01$var$shouldStop = (action)=>action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
var $dd4549797813bb01$var$autoScroll = (autoScroller)=>(store)=>(next)=>(action)=>{
                if ($dd4549797813bb01$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    next(action);
                    const state = store.getState();
                    !(state.phase === "DRAGGING") && $dd4549797813bb01$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
const $dd4549797813bb01$var$pendingDrop = (store)=>(next)=>(action)=>{
            next(action);
            if (action.type !== "PUBLISH_WHILE_DRAGGING") return;
            const postActionState = store.getState();
            if (postActionState.phase !== "DROP_PENDING") return;
            if (postActionState.isWaiting) return;
            store.dispatch($dd4549797813bb01$var$drop$1({
                reason: postActionState.reason
            }));
        };
var $dd4549797813bb01$var$pendingDrop$1 = $dd4549797813bb01$var$pendingDrop;
const $dd4549797813bb01$var$composeEnhancers = (0, $71WWU.compose);
var $dd4549797813bb01$var$createStore = ({ dimensionMarshal: dimensionMarshal, focusMarshal: focusMarshal, styleMarshal: styleMarshal, getResponders: getResponders, announce: announce, autoScroller: autoScroller })=>(0, $71WWU.createStore)($dd4549797813bb01$var$reducer, $dd4549797813bb01$var$composeEnhancers((0, $71WWU.applyMiddleware)($dd4549797813bb01$var$style(styleMarshal), $dd4549797813bb01$var$dimensionMarshalStopper(dimensionMarshal), $dd4549797813bb01$var$lift(dimensionMarshal), $dd4549797813bb01$var$drop, $dd4549797813bb01$var$dropAnimationFinish, $dd4549797813bb01$var$dropAnimationFlushOnScroll, $dd4549797813bb01$var$pendingDrop$1, $dd4549797813bb01$var$autoScroll(autoScroller), $dd4549797813bb01$var$scrollListener$1, $dd4549797813bb01$var$focus(focusMarshal), $dd4549797813bb01$var$responders(getResponders, announce))));
const $dd4549797813bb01$var$clean$1 = ()=>({
        additions: {},
        removals: {},
        modified: {}
    });
function $dd4549797813bb01$var$createPublisher({ registry: registry, callbacks: callbacks }) {
    let staging = $dd4549797813bb01$var$clean$1();
    let frameId = null;
    const collect = ()=>{
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(()=>{
            frameId = null;
            $dd4549797813bb01$var$start();
            const { additions: additions, removals: removals, modified: modified } = staging;
            const added = Object.keys(additions).map((id)=>registry.draggable.getById(id).getDimension($dd4549797813bb01$var$origin)).sort((a, b)=>a.descriptor.index - b.descriptor.index);
            const updated = Object.keys(modified).map((id)=>{
                const entry = registry.droppable.getById(id);
                const scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            const result = {
                additions: added,
                removals: Object.keys(removals),
                modified: updated
            };
            staging = $dd4549797813bb01$var$clean$1();
            $dd4549797813bb01$var$finish();
            callbacks.publish(result);
        });
    };
    const add = (entry)=>{
        const id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    const remove = (entry)=>{
        const descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    const stop = ()=>{
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $dd4549797813bb01$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $dd4549797813bb01$var$getMaxScroll = ({ scrollHeight: scrollHeight, scrollWidth: scrollWidth, height: height, width: width })=>{
    const maxScroll = $dd4549797813bb01$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    const adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $dd4549797813bb01$var$getDocumentElement = ()=>{
    const doc = document.documentElement;
    !doc && $dd4549797813bb01$var$invariant(false);
    return doc;
};
var $dd4549797813bb01$var$getMaxWindowScroll = ()=>{
    const doc = $dd4549797813bb01$var$getDocumentElement();
    const maxScroll = $dd4549797813bb01$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $dd4549797813bb01$var$getViewport = ()=>{
    const scroll = $dd4549797813bb01$var$getWindowScroll();
    const maxScroll = $dd4549797813bb01$var$getMaxWindowScroll();
    const top = scroll.y;
    const left = scroll.x;
    const doc = $dd4549797813bb01$var$getDocumentElement();
    const width = doc.clientWidth;
    const height = doc.clientHeight;
    const right = left + width;
    const bottom = top + height;
    const frame = (0, $kZLuh.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    const viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $dd4549797813bb01$var$origin,
                displacement: $dd4549797813bb01$var$origin
            }
        }
    };
    return viewport;
};
var $dd4549797813bb01$var$getInitialPublish = ({ critical: critical, scrollOptions: scrollOptions, registry: registry })=>{
    $dd4549797813bb01$var$start();
    const viewport = $dd4549797813bb01$var$getViewport();
    const windowScroll = viewport.scroll.current;
    const home = critical.droppable;
    const droppables = registry.droppable.getAllByType(home.type).map((entry)=>entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions));
    const draggables = registry.draggable.getAllByType(critical.draggable.type).map((entry)=>entry.getDimension(windowScroll));
    const dimensions = {
        draggables: $dd4549797813bb01$var$toDraggableMap(draggables),
        droppables: $dd4549797813bb01$var$toDroppableMap(droppables)
    };
    $dd4549797813bb01$var$finish();
    const result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $dd4549797813bb01$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    const home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== "virtual") return false;
    return true;
}
var $dd4549797813bb01$var$createDimensionMarshal = (registry, callbacks)=>{
    let collection = null;
    const publisher = $dd4549797813bb01$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    const updateDroppableIsEnabled = (id, isEnabled)=>{
        !registry.droppable.exists(id) && $dd4549797813bb01$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    const updateDroppableIsCombineEnabled = (id, isCombineEnabled)=>{
        if (!collection) return;
        !registry.droppable.exists(id) && $dd4549797813bb01$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    const updateDroppableScroll = (id, newScroll)=>{
        if (!collection) return;
        !registry.droppable.exists(id) && $dd4549797813bb01$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    const scrollDroppable = (id, change)=>{
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    const stopPublishing = ()=>{
        if (!collection) return;
        publisher.stop();
        const home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach((entry)=>entry.callbacks.dragStopped());
        collection.unsubscribe();
        collection = null;
    };
    const subscriber = (event)=>{
        !collection && $dd4549797813bb01$var$invariant(false);
        const dragging = collection.critical.draggable;
        if (event.type === "ADDITION") {
            if ($dd4549797813bb01$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === "REMOVAL") {
            if ($dd4549797813bb01$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    const startPublishing = (request)=>{
        !!collection && $dd4549797813bb01$var$invariant(false);
        const entry = registry.draggable.getById(request.draggableId);
        const home = registry.droppable.getById(entry.descriptor.droppableId);
        const critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        const unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $dd4549797813bb01$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    const marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $dd4549797813bb01$var$canStartDrag = (state, id)=>{
    if (state.phase === "IDLE") return true;
    if (state.phase !== "DROP_ANIMATING") return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === "DROP";
};
var $dd4549797813bb01$var$scrollWindow = (change)=>{
    window.scrollBy(change.x, change.y);
};
const $dd4549797813bb01$var$getScrollableDroppables = (0, $6iviE.default)((droppables)=>$dd4549797813bb01$var$toDroppableList(droppables).filter((droppable)=>{
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    }));
const $dd4549797813bb01$var$getScrollableDroppableOver = (target, droppables)=>{
    const maybe = $dd4549797813bb01$var$getScrollableDroppables(droppables).find((droppable)=>{
        !droppable.frame && $dd4549797813bb01$var$invariant(false);
        return $dd4549797813bb01$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    }) || null;
    return maybe;
};
var $dd4549797813bb01$var$getBestScrollableDroppable = ({ center: center, destination: destination, droppables: droppables })=>{
    if (destination) {
        const dimension = droppables[destination];
        if (!dimension.frame) return null;
        return dimension;
    }
    const dimension = $dd4549797813bb01$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
const $dd4549797813bb01$var$defaultAutoScrollerOptions = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: (percentage)=>percentage ** 2,
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    },
    disabled: false
};
var $dd4549797813bb01$var$getDistanceThresholds = (container, axis, getAutoScrollerOptions = ()=>$dd4549797813bb01$var$defaultAutoScrollerOptions)=>{
    const autoScrollerOptions = getAutoScrollerOptions();
    const startScrollingFrom = container[axis.size] * autoScrollerOptions.startFromPercentage;
    const maxScrollValueAt = container[axis.size] * autoScrollerOptions.maxScrollAtPercentage;
    const thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $dd4549797813bb01$var$getPercentage = ({ startOfRange: startOfRange, endOfRange: endOfRange, current: current })=>{
    const range = endOfRange - startOfRange;
    if (range === 0) return 0;
    const currentInRange = current - startOfRange;
    const percentage = currentInRange / range;
    return percentage;
};
var $dd4549797813bb01$var$minScroll = 1;
var $dd4549797813bb01$var$getValueFromDistance = (distanceToEdge, thresholds, getAutoScrollerOptions = ()=>$dd4549797813bb01$var$defaultAutoScrollerOptions)=>{
    const autoScrollerOptions = getAutoScrollerOptions();
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return autoScrollerOptions.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $dd4549797813bb01$var$minScroll;
    const percentageFromMaxScrollValueAt = $dd4549797813bb01$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    const percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    const scroll = autoScrollerOptions.maxPixelScroll * autoScrollerOptions.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $dd4549797813bb01$var$dampenValueByTime = (proposedScroll, dragStartTime, getAutoScrollerOptions)=>{
    const autoScrollerOptions = getAutoScrollerOptions();
    const accelerateAt = autoScrollerOptions.durationDampening.accelerateAt;
    const stopAt = autoScrollerOptions.durationDampening.stopDampeningAt;
    const startOfRange = dragStartTime;
    const endOfRange = stopAt;
    const now = Date.now();
    const runTime = now - startOfRange;
    if (runTime >= stopAt) return proposedScroll;
    if (runTime < accelerateAt) return $dd4549797813bb01$var$minScroll;
    const betweenAccelerateAtAndStopAtPercentage = $dd4549797813bb01$var$getPercentage({
        startOfRange: accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    const scroll = proposedScroll * autoScrollerOptions.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $dd4549797813bb01$var$getValue = ({ distanceToEdge: distanceToEdge, thresholds: thresholds, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const scroll = $dd4549797813bb01$var$getValueFromDistance(distanceToEdge, thresholds, getAutoScrollerOptions);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($dd4549797813bb01$var$dampenValueByTime(scroll, dragStartTime, getAutoScrollerOptions), $dd4549797813bb01$var$minScroll);
};
var $dd4549797813bb01$var$getScrollOnAxis = ({ container: container, distanceToEdges: distanceToEdges, dragStartTime: dragStartTime, axis: axis, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const thresholds = $dd4549797813bb01$var$getDistanceThresholds(container, axis, getAutoScrollerOptions);
    const isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $dd4549797813bb01$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    return -1 * $dd4549797813bb01$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
};
var $dd4549797813bb01$var$adjustForSizeLimits = ({ container: container, subject: subject, proposedScroll: proposedScroll })=>{
    const isTooBigVertically = subject.height > container.height;
    const isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
const $dd4549797813bb01$var$clean = $dd4549797813bb01$var$apply((value)=>value === 0 ? 0 : value);
var $dd4549797813bb01$var$getScroll$1 = ({ dragStartTime: dragStartTime, container: container, subject: subject, center: center, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    const y = $dd4549797813bb01$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $dd4549797813bb01$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    const x = $dd4549797813bb01$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $dd4549797813bb01$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    const required = $dd4549797813bb01$var$clean({
        x: x,
        y: y
    });
    if ($dd4549797813bb01$var$isEqual$1(required, $dd4549797813bb01$var$origin)) return null;
    const limited = $dd4549797813bb01$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $dd4549797813bb01$var$isEqual$1(limited, $dd4549797813bb01$var$origin) ? null : limited;
};
const $dd4549797813bb01$var$smallestSigned = $dd4549797813bb01$var$apply((value)=>{
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
const $dd4549797813bb01$var$getOverlap = (()=>{
    const getRemainder = (target, max)=>{
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return ({ current: current, max: max, change: change })=>{
        const targetScroll = $dd4549797813bb01$var$add(current, change);
        const overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($dd4549797813bb01$var$isEqual$1(overlap, $dd4549797813bb01$var$origin)) return null;
        return overlap;
    };
})();
const $dd4549797813bb01$var$canPartiallyScroll = ({ max: rawMax, current: current, change: change })=>{
    const max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    const smallestChange = $dd4549797813bb01$var$smallestSigned(change);
    const overlap = $dd4549797813bb01$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
const $dd4549797813bb01$var$canScrollWindow = (viewport, change)=>$dd4549797813bb01$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
const $dd4549797813bb01$var$getWindowOverlap = (viewport, change)=>{
    if (!$dd4549797813bb01$var$canScrollWindow(viewport, change)) return null;
    const max = viewport.scroll.max;
    const current = viewport.scroll.current;
    return $dd4549797813bb01$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
const $dd4549797813bb01$var$canScrollDroppable = (droppable, change)=>{
    const frame = droppable.frame;
    if (!frame) return false;
    return $dd4549797813bb01$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
const $dd4549797813bb01$var$getDroppableOverlap = (droppable, change)=>{
    const frame = droppable.frame;
    if (!frame) return null;
    if (!$dd4549797813bb01$var$canScrollDroppable(droppable, change)) return null;
    return $dd4549797813bb01$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $dd4549797813bb01$var$getWindowScrollChange = ({ viewport: viewport, subject: subject, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const scroll = $dd4549797813bb01$var$getScroll$1({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    return scroll && $dd4549797813bb01$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $dd4549797813bb01$var$getDroppableScrollChange = ({ droppable: droppable, subject: subject, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const frame = droppable.frame;
    if (!frame) return null;
    const scroll = $dd4549797813bb01$var$getScroll$1({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    return scroll && $dd4549797813bb01$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $dd4549797813bb01$var$scroll = ({ state: state, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, scrollWindow: scrollWindow, scrollDroppable: scrollDroppable, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const center = state.current.page.borderBoxCenter;
    const draggable = state.dimensions.draggables[state.critical.draggable.id];
    const subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        const viewport = state.viewport;
        const change = $dd4549797813bb01$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening,
            getAutoScrollerOptions: getAutoScrollerOptions
        });
        if (change) {
            scrollWindow(change);
            return;
        }
    }
    const droppable = $dd4549797813bb01$var$getBestScrollableDroppable({
        center: center,
        destination: $dd4549797813bb01$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    const change = $dd4549797813bb01$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $dd4549797813bb01$var$createFluidScroller = ({ scrollWindow: scrollWindow, scrollDroppable: scrollDroppable, getAutoScrollerOptions: getAutoScrollerOptions = ()=>$dd4549797813bb01$var$defaultAutoScrollerOptions })=>{
    const scheduleWindowScroll = (0, $ed8xX.default)(scrollWindow);
    const scheduleDroppableScroll = (0, $ed8xX.default)(scrollDroppable);
    let dragging = null;
    const tryScroll = (state)=>{
        !dragging && $dd4549797813bb01$var$invariant(false);
        const { shouldUseTimeDampening: shouldUseTimeDampening, dragStartTime: dragStartTime } = dragging;
        $dd4549797813bb01$var$scroll({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening,
            getAutoScrollerOptions: getAutoScrollerOptions
        });
    };
    const start$1 = (state)=>{
        $dd4549797813bb01$var$start();
        !!dragging && $dd4549797813bb01$var$invariant(false);
        const dragStartTime = Date.now();
        let wasScrollNeeded = false;
        const fakeScrollCallback = ()=>{
            wasScrollNeeded = true;
        };
        $dd4549797813bb01$var$scroll({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback,
            getAutoScrollerOptions: getAutoScrollerOptions
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $dd4549797813bb01$var$finish();
        if (wasScrollNeeded) tryScroll(state);
    };
    const stop = ()=>{
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $dd4549797813bb01$var$createJumpScroller = ({ move: move, scrollDroppable: scrollDroppable, scrollWindow: scrollWindow })=>{
    const moveByOffset = (state, offset)=>{
        const client = $dd4549797813bb01$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    const scrollDroppableAsMuchAsItCan = (droppable, change)=>{
        if (!$dd4549797813bb01$var$canScrollDroppable(droppable, change)) return change;
        const overlap = $dd4549797813bb01$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        const whatTheDroppableCanScroll = $dd4549797813bb01$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        const remainder = $dd4549797813bb01$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    const scrollWindowAsMuchAsItCan = (isWindowScrollAllowed, viewport, change)=>{
        if (!isWindowScrollAllowed) return change;
        if (!$dd4549797813bb01$var$canScrollWindow(viewport, change)) return change;
        const overlap = $dd4549797813bb01$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        const whatTheWindowCanScroll = $dd4549797813bb01$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        const remainder = $dd4549797813bb01$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    const jumpScroller = (state)=>{
        const request = state.scrollJumpRequest;
        if (!request) return;
        const destination = $dd4549797813bb01$var$whatIsDraggedOver(state.impact);
        !destination && $dd4549797813bb01$var$invariant(false);
        const droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        const viewport = state.viewport;
        const windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $dd4549797813bb01$var$createAutoScroller = ({ scrollDroppable: scrollDroppable, scrollWindow: scrollWindow, move: move, getAutoScrollerOptions: getAutoScrollerOptions })=>{
    const fluidScroller = $dd4549797813bb01$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    const jumpScroll = $dd4549797813bb01$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    const scroll = (state)=>{
        const autoScrollerOptions = getAutoScrollerOptions();
        if (autoScrollerOptions.disabled || state.phase !== "DRAGGING") return;
        if (state.movementMode === "FLUID") {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    const scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
const $dd4549797813bb01$var$prefix = "data-rfd";
const $dd4549797813bb01$var$dragHandle = (()=>{
    const base = `${$dd4549797813bb01$var$prefix}-drag-handle`;
    return {
        base: base,
        draggableId: `${base}-draggable-id`,
        contextId: `${base}-context-id`
    };
})();
const $dd4549797813bb01$var$draggable = (()=>{
    const base = `${$dd4549797813bb01$var$prefix}-draggable`;
    return {
        base: base,
        contextId: `${base}-context-id`,
        id: `${base}-id`
    };
})();
const $dd4549797813bb01$var$droppable = (()=>{
    const base = `${$dd4549797813bb01$var$prefix}-droppable`;
    return {
        base: base,
        contextId: `${base}-context-id`,
        id: `${base}-id`
    };
})();
const $dd4549797813bb01$var$scrollContainer = {
    contextId: `${$dd4549797813bb01$var$prefix}-scroll-container-context-id`
};
const $dd4549797813bb01$var$makeGetSelector = (context)=>(attribute)=>`[${attribute}="${context}"]`;
const $dd4549797813bb01$var$getStyles = (rules, property)=>rules.map((rule)=>{
        const value = rule.styles[property];
        if (!value) return "";
        return `${rule.selector} { ${value} }`;
    }).join(" ");
const $dd4549797813bb01$var$noPointerEvents = "pointer-events: none;";
var $dd4549797813bb01$var$getStyles$1 = (contextId)=>{
    const getSelector = $dd4549797813bb01$var$makeGetSelector(contextId);
    const dragHandle$1 = (()=>{
        const grabCursor = `
      cursor: -webkit-grab;
      cursor: grab;
    `;
        return {
            selector: getSelector($dd4549797813bb01$var$dragHandle.contextId),
            styles: {
                always: `
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          touch-action: manipulation;
        `,
                resting: grabCursor,
                dragging: $dd4549797813bb01$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    })();
    const draggable$1 = (()=>{
        const transition = `
      transition: ${$dd4549797813bb01$var$transitions.outOfTheWay};
    `;
        return {
            selector: getSelector($dd4549797813bb01$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    })();
    const droppable$1 = {
        selector: getSelector($dd4549797813bb01$var$droppable.contextId),
        styles: {
            always: `overflow-anchor: none;`
        }
    };
    const body = {
        selector: "body",
        styles: {
            dragging: `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        overflow-anchor: none;
      `
        }
    };
    const rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $dd4549797813bb01$var$getStyles(rules, "always"),
        resting: $dd4549797813bb01$var$getStyles(rules, "resting"),
        dragging: $dd4549797813bb01$var$getStyles(rules, "dragging"),
        dropAnimating: $dd4549797813bb01$var$getStyles(rules, "dropAnimating"),
        userCancel: $dd4549797813bb01$var$getStyles(rules, "userCancel")
    };
};
const $dd4549797813bb01$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $81g6h.useLayoutEffect) : (0, $81g6h.useEffect);
var $dd4549797813bb01$var$useLayoutEffect = $dd4549797813bb01$var$useIsomorphicLayoutEffect;
const $dd4549797813bb01$var$getHead = ()=>{
    const head = document.querySelector("head");
    !head && $dd4549797813bb01$var$invariant(false);
    return head;
};
const $dd4549797813bb01$var$createStyleEl = (nonce)=>{
    const el = document.createElement("style");
    if (nonce) el.setAttribute("nonce", nonce);
    el.type = "text/css";
    return el;
};
function $dd4549797813bb01$var$useStyleMarshal(contextId, nonce) {
    const styles = (0, $g3Edw.useMemo)(()=>$dd4549797813bb01$var$getStyles$1(contextId), [
        contextId
    ]);
    const alwaysRef = (0, $81g6h.useRef)(null);
    const dynamicRef = (0, $81g6h.useRef)(null);
    const setDynamicStyle = (0, $g3Edw.useCallback)((0, $6iviE.default)((proposed)=>{
        const el = dynamicRef.current;
        !el && $dd4549797813bb01$var$invariant(false);
        el.textContent = proposed;
    }), []);
    const setAlwaysStyle = (0, $g3Edw.useCallback)((proposed)=>{
        const el = alwaysRef.current;
        !el && $dd4549797813bb01$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $dd4549797813bb01$var$useLayoutEffect(()=>{
        !(!alwaysRef.current && !dynamicRef.current) && $dd4549797813bb01$var$invariant(false);
        const always = $dd4549797813bb01$var$createStyleEl(nonce);
        const dynamic = $dd4549797813bb01$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute(`${$dd4549797813bb01$var$prefix}-always`, contextId);
        dynamic.setAttribute(`${$dd4549797813bb01$var$prefix}-dynamic`, contextId);
        $dd4549797813bb01$var$getHead().appendChild(always);
        $dd4549797813bb01$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return ()=>{
            const remove = (ref)=>{
                const current = ref.current;
                !current && $dd4549797813bb01$var$invariant(false);
                $dd4549797813bb01$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    const dragging = (0, $g3Edw.useCallback)(()=>setDynamicStyle(styles.dragging), [
        setDynamicStyle,
        styles.dragging
    ]);
    const dropping = (0, $g3Edw.useCallback)((reason)=>{
        if (reason === "DROP") {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    const resting = (0, $g3Edw.useCallback)(()=>{
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    const marshal = (0, $g3Edw.useMemo)(()=>({
            dragging: dragging,
            dropping: dropping,
            resting: resting
        }), [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
function $dd4549797813bb01$var$querySelectorAll(parentNode, selector) {
    return Array.from(parentNode.querySelectorAll(selector));
}
var $dd4549797813bb01$var$getWindowFromEl = (el)=>{
    if (el && el.ownerDocument && el.ownerDocument.defaultView) return el.ownerDocument.defaultView;
    return window;
};
function $dd4549797813bb01$var$isHtmlElement(el) {
    return el instanceof $dd4549797813bb01$var$getWindowFromEl(el).HTMLElement;
}
function $dd4549797813bb01$var$findDragHandle(contextId, draggableId) {
    const selector = `[${$dd4549797813bb01$var$dragHandle.contextId}="${contextId}"]`;
    const possible = $dd4549797813bb01$var$querySelectorAll(document, selector);
    if (!possible.length) return null;
    const handle = possible.find((el)=>{
        return el.getAttribute($dd4549797813bb01$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$dd4549797813bb01$var$isHtmlElement(handle)) return null;
    return handle;
}
function $dd4549797813bb01$var$useFocusMarshal(contextId) {
    const entriesRef = (0, $81g6h.useRef)({});
    const recordRef = (0, $81g6h.useRef)(null);
    const restoreFocusFrameRef = (0, $81g6h.useRef)(null);
    const isMountedRef = (0, $81g6h.useRef)(false);
    const register = (0, $g3Edw.useCallback)(function register(id, focus) {
        const entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            const entries = entriesRef.current;
            const current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    const tryGiveFocus = (0, $g3Edw.useCallback)(function tryGiveFocus(tryGiveFocusTo) {
        const handle = $dd4549797813bb01$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    const tryShiftRecord = (0, $g3Edw.useCallback)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    const tryRestoreFocusRecorded = (0, $g3Edw.useCallback)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(()=>{
            restoreFocusFrameRef.current = null;
            const record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    const tryRecordFocus = (0, $g3Edw.useCallback)(function tryRecordFocus(id) {
        recordRef.current = null;
        const focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($dd4549797813bb01$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $dd4549797813bb01$var$useLayoutEffect(()=>{
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            const frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    const marshal = (0, $g3Edw.useMemo)(()=>({
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        }), [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $dd4549797813bb01$var$createRegistry() {
    const entries = {
        draggables: {},
        droppables: {}
    };
    const subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            const index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach((cb)=>cb(event));
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        const entry = findDraggableById(id);
        !entry && $dd4549797813bb01$var$invariant(false);
        return entry;
    }
    const draggableAPI = {
        register: (entry)=>{
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: "ADDITION",
                value: entry
            });
        },
        update: (entry, last)=>{
            const current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: (entry)=>{
            const draggableId = entry.descriptor.id;
            const current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            if (entries.droppables[entry.descriptor.droppableId]) notify({
                type: "REMOVAL",
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: (id)=>Boolean(findDraggableById(id)),
        getAllByType: (type)=>Object.values(entries.draggables).filter((entry)=>entry.descriptor.type === type)
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        const entry = findDroppableById(id);
        !entry && $dd4549797813bb01$var$invariant(false);
        return entry;
    }
    const droppableAPI = {
        register: (entry)=>{
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: (entry)=>{
            const current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: (id)=>Boolean(findDroppableById(id)),
        getAllByType: (type)=>Object.values(entries.droppables).filter((entry)=>entry.descriptor.type === type)
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $dd4549797813bb01$var$useRegistry() {
    const registry = (0, $g3Edw.useMemo)($dd4549797813bb01$var$createRegistry, []);
    (0, $81g6h.useEffect)(()=>{
        return function unmount() {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).version.startsWith("16") || (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).version.startsWith("17")) requestAnimationFrame(registry.clean);
            else registry.clean();
        };
    }, [
        registry
    ]);
    return registry;
}
var $dd4549797813bb01$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createContext(null);
var $dd4549797813bb01$var$getBodyElement = ()=>{
    const body = document.body;
    !body && $dd4549797813bb01$var$invariant(false);
    return body;
};
const $dd4549797813bb01$var$visuallyHidden = {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    border: "0",
    padding: "0",
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    "clip-path": "inset(100%)"
};
var $dd4549797813bb01$var$visuallyHidden$1 = $dd4549797813bb01$var$visuallyHidden;
const $dd4549797813bb01$var$getId = (contextId)=>`rfd-announcement-${contextId}`;
function $dd4549797813bb01$var$useAnnouncer(contextId) {
    const id = (0, $g3Edw.useMemo)(()=>$dd4549797813bb01$var$getId(contextId), [
        contextId
    ]);
    const ref = (0, $81g6h.useRef)(null);
    (0, $81g6h.useEffect)(function setup() {
        const el = document.createElement("div");
        ref.current = el;
        el.id = id;
        el.setAttribute("aria-live", "assertive");
        el.setAttribute("aria-atomic", "true");
        (0, $6JG9D.default)(el.style, $dd4549797813bb01$var$visuallyHidden$1);
        $dd4549797813bb01$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                const body = $dd4549797813bb01$var$getBodyElement();
                if (body.contains(el)) body.removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    const announce = (0, $g3Edw.useCallback)((message)=>{
        const el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
let $dd4549797813bb01$var$count$1 = 0;
const $dd4549797813bb01$var$defaults = {
    separator: "::"
};
function $dd4549797813bb01$var$resetDeprecatedUniqueId() {
    $dd4549797813bb01$var$count$1 = 0;
}
function $dd4549797813bb01$var$useDeprecatedUniqueId(prefix, options = $dd4549797813bb01$var$defaults) {
    return (0, $g3Edw.useMemo)(()=>`${prefix}${options.separator}${$dd4549797813bb01$var$count$1++}`, [
        options.separator,
        prefix
    ]);
}
function $dd4549797813bb01$var$useUniqueId(prefix, options = $dd4549797813bb01$var$defaults) {
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useId();
    return (0, $g3Edw.useMemo)(()=>`${prefix}${options.separator}${id}`, [
        options.separator,
        prefix,
        id
    ]);
}
var $dd4549797813bb01$var$useUniqueId$1 = "useId" in (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))) ? $dd4549797813bb01$var$useUniqueId : $dd4549797813bb01$var$useDeprecatedUniqueId;
function $dd4549797813bb01$var$getElementId({ contextId: contextId, uniqueId: uniqueId }) {
    return `rfd-hidden-text-${contextId}-${uniqueId}`;
}
function $dd4549797813bb01$var$useHiddenTextElement({ contextId: contextId, text: text }) {
    const uniqueId = $dd4549797813bb01$var$useUniqueId$1("hidden-text", {
        separator: "-"
    });
    const id = (0, $g3Edw.useMemo)(()=>$dd4549797813bb01$var$getElementId({
            contextId: contextId,
            uniqueId: uniqueId
        }), [
        uniqueId,
        contextId
    ]);
    (0, $81g6h.useEffect)(function mount() {
        const el = document.createElement("div");
        el.id = id;
        el.textContent = text;
        el.style.display = "none";
        $dd4549797813bb01$var$getBodyElement().appendChild(el);
        return function unmount() {
            const body = $dd4549797813bb01$var$getBodyElement();
            if (body.contains(el)) body.removeChild(el);
        };
    }, [
        id,
        text
    ]);
    return id;
}
var $dd4549797813bb01$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createContext(null);
var $dd4549797813bb01$var$peerDependencies = {
    react: "^16.8.5 || ^17.0.0 || ^18.0.0",
    "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
};
const $dd4549797813bb01$var$semver = /(\d+)\.(\d+)\.(\d+)/;
const $dd4549797813bb01$var$getVersion = (value)=>{
    const result = $dd4549797813bb01$var$semver.exec(value);
    !(result != null) && $dd4549797813bb01$var$invariant(false);
    const major = Number(result[1]);
    const minor = Number(result[2]);
    const patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
const $dd4549797813bb01$var$isSatisfied = (expected, actual)=>{
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $dd4549797813bb01$var$checkReactVersion = (peerDepValue, actualValue)=>{
    const peerDep = $dd4549797813bb01$var$getVersion(peerDepValue);
    const actual = $dd4549797813bb01$var$getVersion(actualValue);
    if ($dd4549797813bb01$var$isSatisfied(peerDep, actual)) return;
};
const $dd4549797813bb01$var$suffix = `
  We expect a html5 doctype: <!doctype html>
  This is to ensure consistent browser layout and measurement

  More information: https://github.com/hello-pangea/dnd/blob/main/docs/guides/doctype.md
`;
var $dd4549797813bb01$var$checkDoctype = (doc)=>{
    const doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $dd4549797813bb01$var$useDev(useHook) {}
function $dd4549797813bb01$var$useDevSetupWarning(fn, inputs) {
    $dd4549797813bb01$var$useDev(()=>{
        (0, $81g6h.useEffect)(()=>{
            try {
                fn();
            } catch (e) {
                $dd4549797813bb01$var$error(`
          A setup problem was encountered.

          > ${e.message}
        `);
            }
        }, inputs);
    });
}
function $dd4549797813bb01$var$useStartupValidation() {
    $dd4549797813bb01$var$useDevSetupWarning(()=>{
        $dd4549797813bb01$var$checkReactVersion($dd4549797813bb01$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).version);
        $dd4549797813bb01$var$checkDoctype(document);
    }, []);
}
function $dd4549797813bb01$var$usePrevious(current) {
    const ref = (0, $81g6h.useRef)(current);
    (0, $81g6h.useEffect)(()=>{
        ref.current = current;
    });
    return ref;
}
function $dd4549797813bb01$var$create() {
    let lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $dd4549797813bb01$var$invariant(false);
        const newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $dd4549797813bb01$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
function $dd4549797813bb01$var$isDragging(state) {
    if (state.phase === "IDLE" || state.phase === "DROP_ANIMATING") return false;
    return state.isDragging;
}
const $dd4549797813bb01$var$tab = 9;
const $dd4549797813bb01$var$enter = 13;
const $dd4549797813bb01$var$escape = 27;
const $dd4549797813bb01$var$space = 32;
const $dd4549797813bb01$var$pageUp = 33;
const $dd4549797813bb01$var$pageDown = 34;
const $dd4549797813bb01$var$end = 35;
const $dd4549797813bb01$var$home = 36;
const $dd4549797813bb01$var$arrowLeft = 37;
const $dd4549797813bb01$var$arrowUp = 38;
const $dd4549797813bb01$var$arrowRight = 39;
const $dd4549797813bb01$var$arrowDown = 40;
const $dd4549797813bb01$var$preventedKeys = {
    [$dd4549797813bb01$var$enter]: true,
    [$dd4549797813bb01$var$tab]: true
};
var $dd4549797813bb01$var$preventStandardKeyEvents = (event)=>{
    if ($dd4549797813bb01$var$preventedKeys[event.keyCode]) event.preventDefault();
};
const $dd4549797813bb01$var$supportedEventName = (()=>{
    const base = "visibilitychange";
    if (typeof document === "undefined") return base;
    const candidates = [
        base,
        `ms${base}`,
        `webkit${base}`,
        `moz${base}`,
        `o${base}`
    ];
    const supported = candidates.find((eventName)=>`on${eventName}` in document);
    return supported || base;
})();
var $dd4549797813bb01$var$supportedPageVisibilityEventName = $dd4549797813bb01$var$supportedEventName;
const $dd4549797813bb01$var$primaryButton = 0;
const $dd4549797813bb01$var$sloppyClickThreshold = 5;
function $dd4549797813bb01$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $dd4549797813bb01$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $dd4549797813bb01$var$sloppyClickThreshold;
}
const $dd4549797813bb01$var$idle$1 = {
    type: "IDLE"
};
function $dd4549797813bb01$var$getCaptureBindings({ cancel: cancel, completed: completed, getPhase: getPhase, setPhase: setPhase }) {
    return [
        {
            eventName: "mousemove",
            fn: (event)=>{
                const { button: button, clientX: clientX, clientY: clientY } = event;
                if (button !== $dd4549797813bb01$var$primaryButton) return;
                const point = {
                    x: clientX,
                    y: clientY
                };
                const phase = getPhase();
                if (phase.type === "DRAGGING") {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === "PENDING") && $dd4549797813bb01$var$invariant(false);
                const pending = phase.point;
                if (!$dd4549797813bb01$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                const actions = phase.actions.fluidLift(point);
                setPhase({
                    type: "DRAGGING",
                    actions: actions
                });
            }
        },
        {
            eventName: "mouseup",
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "mousedown",
            fn: (event)=>{
                if (getPhase().type === "DRAGGING") event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "keydown",
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type === "PENDING") {
                    cancel();
                    return;
                }
                if (event.keyCode === $dd4549797813bb01$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $dd4549797813bb01$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "scroll",
            options: {
                passive: true,
                capture: false
            },
            fn: ()=>{
                if (getPhase().type === "PENDING") cancel();
            }
        },
        {
            eventName: "webkitmouseforcedown",
            fn: (event)=>{
                const phase = getPhase();
                !(phase.type !== "IDLE") && $dd4549797813bb01$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $dd4549797813bb01$var$supportedPageVisibilityEventName,
            fn: cancel
        }
    ];
}
function $dd4549797813bb01$export$2f59cd992b42195a(api) {
    const phaseRef = (0, $81g6h.useRef)($dd4549797813bb01$var$idle$1);
    const unbindEventsRef = (0, $81g6h.useRef)($dd4549797813bb01$var$noop$2);
    const startCaptureBinding = (0, $g3Edw.useMemo)(()=>({
            eventName: "mousedown",
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $dd4549797813bb01$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                const draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                const actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                const point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        }), [
        api
    ]);
    const preventForcePressBinding = (0, $g3Edw.useMemo)(()=>({
            eventName: "webkitmouseforcewillbegin",
            fn: (event)=>{
                if (event.defaultPrevented) return;
                const id = api.findClosestDraggableId(event);
                if (!id) return;
                const options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        }), [
        api
    ]);
    const listenForCapture = (0, $g3Edw.useCallback)(function listenForCapture() {
        const options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $dd4549797813bb01$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    const stop = (0, $g3Edw.useCallback)(()=>{
        const current = phaseRef.current;
        if (current.type === "IDLE") return;
        phaseRef.current = $dd4549797813bb01$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    const cancel = (0, $g3Edw.useCallback)(()=>{
        const phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    const bindCapturingEvents = (0, $g3Edw.useCallback)(function bindCapturingEvents() {
        const options = {
            capture: true,
            passive: false
        };
        const bindings = $dd4549797813bb01$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: ()=>phaseRef.current,
            setPhase: (phase)=>{
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $dd4549797813bb01$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    const startPendingDrag = (0, $g3Edw.useCallback)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === "IDLE") && $dd4549797813bb01$var$invariant(false);
        phaseRef.current = {
            type: "PENDING",
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $dd4549797813bb01$var$useLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
function $dd4549797813bb01$var$noop$1() {}
const $dd4549797813bb01$var$scrollJumpKeys = {
    [$dd4549797813bb01$var$pageDown]: true,
    [$dd4549797813bb01$var$pageUp]: true,
    [$dd4549797813bb01$var$home]: true,
    [$dd4549797813bb01$var$end]: true
};
function $dd4549797813bb01$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: "keydown",
            fn: (event)=>{
                if (event.keyCode === $dd4549797813bb01$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $dd4549797813bb01$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $dd4549797813bb01$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $dd4549797813bb01$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $dd4549797813bb01$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $dd4549797813bb01$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($dd4549797813bb01$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $dd4549797813bb01$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "mousedown",
            fn: cancel
        },
        {
            eventName: "mouseup",
            fn: cancel
        },
        {
            eventName: "click",
            fn: cancel
        },
        {
            eventName: "touchstart",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "wheel",
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $dd4549797813bb01$var$supportedPageVisibilityEventName,
            fn: cancel
        }
    ];
}
function $dd4549797813bb01$export$42b74264faad0714(api) {
    const unbindEventsRef = (0, $81g6h.useRef)($dd4549797813bb01$var$noop$1);
    const startCaptureBinding = (0, $g3Edw.useMemo)(()=>({
            eventName: "keydown",
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $dd4549797813bb01$var$space) return;
                const draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                const preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                let isCapturing = true;
                const actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $dd4549797813bb01$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $dd4549797813bb01$var$bindEvents(window, $dd4549797813bb01$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        }), [
        api
    ]);
    const listenForCapture = (0, $g3Edw.useCallback)(function tryStartCapture() {
        const options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $dd4549797813bb01$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $dd4549797813bb01$var$useLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
const $dd4549797813bb01$var$idle = {
    type: "IDLE"
};
const $dd4549797813bb01$var$timeForLongPress = 120;
const $dd4549797813bb01$var$forcePressThreshold = 0.15;
function $dd4549797813bb01$var$getWindowBindings({ cancel: cancel, getPhase: getPhase }) {
    return [
        {
            eventName: "orientationchange",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "contextmenu",
            fn: (event)=>{
                event.preventDefault();
            }
        },
        {
            eventName: "keydown",
            fn: (event)=>{
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                if (event.keyCode === $dd4549797813bb01$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $dd4549797813bb01$var$supportedPageVisibilityEventName,
            fn: cancel
        }
    ];
}
function $dd4549797813bb01$var$getHandleBindings({ cancel: cancel, completed: completed, getPhase: getPhase }) {
    return [
        {
            eventName: "touchmove",
            options: {
                capture: false
            },
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                const { clientX: clientX, clientY: clientY } = event.touches[0];
                const point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: "touchend",
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "touchcancel",
            fn: (event)=>{
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "touchforcechange",
            fn: (event)=>{
                const phase = getPhase();
                !(phase.type !== "IDLE") && $dd4549797813bb01$var$invariant(false);
                const touch = event.touches[0];
                if (!touch) return;
                const isForcePress = touch.force >= $dd4549797813bb01$var$forcePressThreshold;
                if (!isForcePress) return;
                const shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === "PENDING") {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $dd4549797813bb01$var$supportedPageVisibilityEventName,
            fn: cancel
        }
    ];
}
function $dd4549797813bb01$export$ac235fd3a7bcf7b4(api) {
    const phaseRef = (0, $81g6h.useRef)($dd4549797813bb01$var$idle);
    const unbindEventsRef = (0, $81g6h.useRef)($dd4549797813bb01$var$noop$2);
    const getPhase = (0, $g3Edw.useCallback)(function getPhase() {
        return phaseRef.current;
    }, []);
    const setPhase = (0, $g3Edw.useCallback)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    const startCaptureBinding = (0, $g3Edw.useMemo)(()=>({
            eventName: "touchstart",
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                const draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                const actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                const touch = event.touches[0];
                const { clientX: clientX, clientY: clientY } = touch;
                const point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        }), [
        api
    ]);
    const listenForCapture = (0, $g3Edw.useCallback)(function listenForCapture() {
        const options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $dd4549797813bb01$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    const stop = (0, $g3Edw.useCallback)(()=>{
        const current = phaseRef.current;
        if (current.type === "IDLE") return;
        if (current.type === "PENDING") clearTimeout(current.longPressTimerId);
        setPhase($dd4549797813bb01$var$idle);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    const cancel = (0, $g3Edw.useCallback)(()=>{
        const phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    const bindCapturingEvents = (0, $g3Edw.useCallback)(function bindCapturingEvents() {
        const options = {
            capture: true,
            passive: false
        };
        const args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        const unbindTarget = $dd4549797813bb01$var$bindEvents(window, $dd4549797813bb01$var$getHandleBindings(args), options);
        const unbindWindow = $dd4549797813bb01$var$bindEvents(window, $dd4549797813bb01$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    const startDragging = (0, $g3Edw.useCallback)(function startDragging() {
        const phase = getPhase();
        !(phase.type === "PENDING") && $dd4549797813bb01$var$invariant(false);
        const actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: "DRAGGING",
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    const startPendingDrag = (0, $g3Edw.useCallback)(function startPendingDrag(actions, point) {
        !(getPhase().type === "IDLE") && $dd4549797813bb01$var$invariant(false);
        const longPressTimerId = setTimeout(startDragging, $dd4549797813bb01$var$timeForLongPress);
        setPhase({
            type: "PENDING",
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $dd4549797813bb01$var$useLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            const phase = getPhase();
            if (phase.type === "PENDING") {
                clearTimeout(phase.longPressTimerId);
                setPhase($dd4549797813bb01$var$idle);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $dd4549797813bb01$var$useLayoutEffect(function webkitHack() {
        const unbind = $dd4549797813bb01$var$bindEvents(window, [
            {
                eventName: "touchmove",
                fn: ()=>{},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $dd4549797813bb01$var$useValidateSensorHooks(sensorHooks) {
    $dd4549797813bb01$var$useDev(()=>{
        const previousRef = $dd4549797813bb01$var$usePrevious(sensorHooks);
        $dd4549797813bb01$var$useDevSetupWarning(()=>{
            !(previousRef.current.length === sensorHooks.length) && $dd4549797813bb01$var$invariant(false);
        });
    });
}
const $dd4549797813bb01$var$interactiveTagNames = [
    "input",
    "button",
    "textarea",
    "select",
    "option",
    "optgroup",
    "video",
    "audio"
];
function $dd4549797813bb01$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    const hasAnInteractiveTag = $dd4549797813bb01$var$interactiveTagNames.includes(current.tagName.toLowerCase());
    if (hasAnInteractiveTag) return true;
    const attribute = current.getAttribute("contenteditable");
    if (attribute === "true" || attribute === "") return true;
    if (current === parent) return false;
    return $dd4549797813bb01$var$isAnInteractiveElement(parent, current.parentElement);
}
function $dd4549797813bb01$var$isEventInInteractiveElement(draggable, event) {
    const target = event.target;
    if (!$dd4549797813bb01$var$isHtmlElement(target)) return false;
    return $dd4549797813bb01$var$isAnInteractiveElement(draggable, target);
}
var $dd4549797813bb01$var$getBorderBoxCenterPosition = (el)=>(0, $kZLuh.getRect)(el.getBoundingClientRect()).center;
function $dd4549797813bb01$var$isElement(el) {
    return el instanceof $dd4549797813bb01$var$getWindowFromEl(el).Element;
}
const $dd4549797813bb01$var$supportedMatchesName = (()=>{
    const base = "matches";
    if (typeof document === "undefined") return base;
    const candidates = [
        base,
        "msMatchesSelector",
        "webkitMatchesSelector"
    ];
    const value = candidates.find((name)=>name in Element.prototype);
    return value || base;
})();
function $dd4549797813bb01$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$dd4549797813bb01$var$supportedMatchesName](selector)) return el;
    return $dd4549797813bb01$var$closestPonyfill(el.parentElement, selector);
}
function $dd4549797813bb01$var$closest(el, selector) {
    if (el.closest) return el.closest(selector);
    return $dd4549797813bb01$var$closestPonyfill(el, selector);
}
function $dd4549797813bb01$var$getSelector(contextId) {
    return `[${$dd4549797813bb01$var$dragHandle.contextId}="${contextId}"]`;
}
function $dd4549797813bb01$var$findClosestDragHandleFromEvent(contextId, event) {
    const target = event.target;
    if (!$dd4549797813bb01$var$isElement(target)) return null;
    const selector = $dd4549797813bb01$var$getSelector(contextId);
    const handle = $dd4549797813bb01$var$closest(target, selector);
    if (!handle) return null;
    if (!$dd4549797813bb01$var$isHtmlElement(handle)) return null;
    return handle;
}
function $dd4549797813bb01$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    const handle = $dd4549797813bb01$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($dd4549797813bb01$var$dragHandle.draggableId);
}
function $dd4549797813bb01$var$findDraggable(contextId, draggableId) {
    const selector = `[${$dd4549797813bb01$var$draggable.contextId}="${contextId}"]`;
    const possible = $dd4549797813bb01$var$querySelectorAll(document, selector);
    const draggable$1 = possible.find((el)=>{
        return el.getAttribute($dd4549797813bb01$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$dd4549797813bb01$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $dd4549797813bb01$var$preventDefault(event) {
    event.preventDefault();
}
function $dd4549797813bb01$var$isActive({ expected: expected, phase: phase, isLockActive: isLockActive, shouldWarn: shouldWarn }) {
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $dd4549797813bb01$var$canStart({ lockAPI: lockAPI, store: store, registry: registry, draggableId: draggableId }) {
    if (lockAPI.isClaimed()) return false;
    const entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$dd4549797813bb01$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $dd4549797813bb01$var$tryStart({ lockAPI: lockAPI, contextId: contextId, store: store, registry: registry, draggableId: draggableId, forceSensorStop: forceSensorStop, sourceEvent: sourceEvent }) {
    const shouldStart = $dd4549797813bb01$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    const entry = registry.draggable.getById(draggableId);
    const el = $dd4549797813bb01$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $dd4549797813bb01$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    const lock = lockAPI.claim(forceSensorStop || $dd4549797813bb01$var$noop$2);
    let phase = "PRE_DRAG";
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($dd4549797813bb01$var$isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    const tryDispatchWhenDragging = tryDispatch.bind(null, "DRAGGING");
    function lift(args) {
        function completed() {
            lockAPI.release();
            phase = "COMPLETED";
        }
        if (phase !== "PRE_DRAG") {
            completed();
            $dd4549797813bb01$var$invariant(false);
        }
        store.dispatch($dd4549797813bb01$var$lift$1(args.liftActionArgs));
        phase = "DRAGGING";
        function finish(reason, options = {
            shouldBlockNextClick: false
        }) {
            args.cleanup();
            if (options.shouldBlockNextClick) {
                const unbind = $dd4549797813bb01$var$bindEvents(window, [
                    {
                        eventName: "click",
                        fn: $dd4549797813bb01$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($dd4549797813bb01$var$drop$1({
                reason: reason
            }));
        }
        return {
            isActive: ()=>$dd4549797813bb01$var$isActive({
                    expected: "DRAGGING",
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                }),
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: (options)=>finish("DROP", options),
            cancel: (options)=>finish("CANCEL", options),
            ...args.actions
        };
    }
    function fluidLift(clientSelection) {
        const move$1 = (0, $ed8xX.default)((client)=>{
            tryDispatchWhenDragging(()=>$dd4549797813bb01$var$move({
                    client: client
                }));
        });
        const api = lift({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: "FLUID"
            },
            cleanup: ()=>move$1.cancel(),
            actions: {
                move: move$1
            }
        });
        return {
            ...api,
            move: move$1
        };
    }
    function snapLift() {
        const actions = {
            moveUp: ()=>tryDispatchWhenDragging($dd4549797813bb01$var$moveUp),
            moveRight: ()=>tryDispatchWhenDragging($dd4549797813bb01$var$moveRight),
            moveDown: ()=>tryDispatchWhenDragging($dd4549797813bb01$var$moveDown),
            moveLeft: ()=>tryDispatchWhenDragging($dd4549797813bb01$var$moveLeft)
        };
        return lift({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $dd4549797813bb01$var$getBorderBoxCenterPosition(el),
                movementMode: "SNAP"
            },
            cleanup: $dd4549797813bb01$var$noop$2,
            actions: actions
        });
    }
    function abortPreDrag() {
        const shouldRelease = $dd4549797813bb01$var$isActive({
            expected: "PRE_DRAG",
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    const preDrag = {
        isActive: ()=>$dd4549797813bb01$var$isActive({
                expected: "PRE_DRAG",
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            }),
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
const $dd4549797813bb01$var$defaultSensors = [
    $dd4549797813bb01$export$2f59cd992b42195a,
    $dd4549797813bb01$export$42b74264faad0714,
    $dd4549797813bb01$export$ac235fd3a7bcf7b4
];
function $dd4549797813bb01$var$useSensorMarshal({ contextId: contextId, store: store, registry: registry, customSensors: customSensors, enableDefaultSensors: enableDefaultSensors }) {
    const useSensors = [
        ...enableDefaultSensors ? $dd4549797813bb01$var$defaultSensors : [],
        ...customSensors || []
    ];
    const lockAPI = (0, $81g6h.useState)(()=>$dd4549797813bb01$var$create())[0];
    const tryAbandonLock = (0, $g3Edw.useCallback)(function tryAbandonLock(previous, current) {
        if ($dd4549797813bb01$var$isDragging(previous) && !$dd4549797813bb01$var$isDragging(current)) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $dd4549797813bb01$var$useLayoutEffect(function listenToStore() {
        let previous = store.getState();
        const unsubscribe = store.subscribe(()=>{
            const current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $dd4549797813bb01$var$useLayoutEffect(()=>{
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    const canGetLock = (0, $g3Edw.useCallback)((draggableId)=>{
        return $dd4549797813bb01$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    const tryGetLock = (0, $g3Edw.useCallback)((draggableId, forceStop, options)=>$dd4549797813bb01$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop || null,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        }), [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    const findClosestDraggableId = (0, $g3Edw.useCallback)((event)=>$dd4549797813bb01$var$tryGetClosestDraggableIdFromEvent(contextId, event), [
        contextId
    ]);
    const findOptionsForDraggable = (0, $g3Edw.useCallback)((id)=>{
        const entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    const tryReleaseLock = (0, $g3Edw.useCallback)(function tryReleaseLock() {
        if (!lockAPI.isClaimed()) return;
        lockAPI.tryAbandon();
        if (store.getState().phase !== "IDLE") store.dispatch($dd4549797813bb01$var$flush());
    }, [
        lockAPI,
        store
    ]);
    const isLockClaimed = (0, $g3Edw.useCallback)(()=>lockAPI.isClaimed(), [
        lockAPI
    ]);
    const api = (0, $g3Edw.useMemo)(()=>({
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        }), [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $dd4549797813bb01$var$useValidateSensorHooks(useSensors);
    for(let i = 0; i < useSensors.length; i++)useSensors[i](api);
}
const $dd4549797813bb01$var$createResponders = (props)=>({
        onBeforeCapture: (t)=>{
            const onBeforeCapureCallback = ()=>{
                if (props.onBeforeCapture) props.onBeforeCapture(t);
            };
            if ((0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).version.startsWith("16") || (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).version.startsWith("17")) onBeforeCapureCallback();
            else (0, $Q1dTY.flushSync)(onBeforeCapureCallback);
        },
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    });
const $dd4549797813bb01$var$createAutoScrollerOptions = (props)=>({
        ...$dd4549797813bb01$var$defaultAutoScrollerOptions,
        ...props.autoScrollerOptions,
        durationDampening: {
            ...$dd4549797813bb01$var$defaultAutoScrollerOptions.durationDampening,
            ...props.autoScrollerOptions
        }
    });
function $dd4549797813bb01$var$getStore(lazyRef) {
    !lazyRef.current && $dd4549797813bb01$var$invariant(false);
    return lazyRef.current;
}
function $dd4549797813bb01$var$App(props) {
    const { contextId: contextId, setCallbacks: setCallbacks, sensors: sensors, nonce: nonce, dragHandleUsageInstructions: dragHandleUsageInstructions } = props;
    const lazyStoreRef = (0, $81g6h.useRef)(null);
    $dd4549797813bb01$var$useStartupValidation();
    const lastPropsRef = $dd4549797813bb01$var$usePrevious(props);
    const getResponders = (0, $g3Edw.useCallback)(()=>{
        return $dd4549797813bb01$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    const getAutoScrollerOptions = (0, $g3Edw.useCallback)(()=>{
        return $dd4549797813bb01$var$createAutoScrollerOptions(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    const announce = $dd4549797813bb01$var$useAnnouncer(contextId);
    const dragHandleUsageInstructionsId = $dd4549797813bb01$var$useHiddenTextElement({
        contextId: contextId,
        text: dragHandleUsageInstructions
    });
    const styleMarshal = $dd4549797813bb01$var$useStyleMarshal(contextId, nonce);
    const lazyDispatch = (0, $g3Edw.useCallback)((action)=>{
        $dd4549797813bb01$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    const marshalCallbacks = (0, $g3Edw.useMemo)(()=>(0, $71WWU.bindActionCreators)({
            publishWhileDragging: $dd4549797813bb01$var$publishWhileDragging,
            updateDroppableScroll: $dd4549797813bb01$var$updateDroppableScroll,
            updateDroppableIsEnabled: $dd4549797813bb01$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $dd4549797813bb01$var$updateDroppableIsCombineEnabled,
            collectionStarting: $dd4549797813bb01$var$collectionStarting
        }, lazyDispatch), [
        lazyDispatch
    ]);
    const registry = $dd4549797813bb01$var$useRegistry();
    const dimensionMarshal = (0, $g3Edw.useMemo)(()=>{
        return $dd4549797813bb01$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    const autoScroller = (0, $g3Edw.useMemo)(()=>$dd4549797813bb01$var$createAutoScroller({
            scrollWindow: $dd4549797813bb01$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable,
            getAutoScrollerOptions: getAutoScrollerOptions,
            ...(0, $71WWU.bindActionCreators)({
                move: $dd4549797813bb01$var$move
            }, lazyDispatch)
        }), [
        dimensionMarshal.scrollDroppable,
        lazyDispatch,
        getAutoScrollerOptions
    ]);
    const focusMarshal = $dd4549797813bb01$var$useFocusMarshal(contextId);
    const store = (0, $g3Edw.useMemo)(()=>$dd4549797813bb01$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        }), [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    const tryResetStore = (0, $g3Edw.useCallback)(()=>{
        const current = $dd4549797813bb01$var$getStore(lazyStoreRef);
        const state = current.getState();
        if (state.phase !== "IDLE") current.dispatch($dd4549797813bb01$var$flush());
    }, []);
    const isDragging = (0, $g3Edw.useCallback)(()=>{
        const state = $dd4549797813bb01$var$getStore(lazyStoreRef).getState();
        if (state.phase === "DROP_ANIMATING") return true;
        if (state.phase === "IDLE") return false;
        return state.isDragging;
    }, []);
    const appCallbacks = (0, $g3Edw.useMemo)(()=>({
            isDragging: isDragging,
            tryAbort: tryResetStore
        }), [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    const getCanLift = (0, $g3Edw.useCallback)((id)=>$dd4549797813bb01$var$canStartDrag($dd4549797813bb01$var$getStore(lazyStoreRef).getState(), id), []);
    const getIsMovementAllowed = (0, $g3Edw.useCallback)(()=>$dd4549797813bb01$var$isMovementAllowed($dd4549797813bb01$var$getStore(lazyStoreRef).getState()), []);
    const appContext = (0, $g3Edw.useMemo)(()=>({
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
            registry: registry
        }), [
        contextId,
        dimensionMarshal,
        dragHandleUsageInstructionsId,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        registry
    ]);
    $dd4549797813bb01$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors || null,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $81g6h.useEffect)(()=>{
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement($dd4549797813bb01$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement((0, $duc3X.default), {
        context: $dd4549797813bb01$var$StoreContext,
        store: store
    }, props.children));
}
let $dd4549797813bb01$var$count = 0;
function $dd4549797813bb01$var$resetDeprecatedUniqueContextId() {
    $dd4549797813bb01$var$count = 0;
}
function $dd4549797813bb01$var$useDeprecatedUniqueContextId() {
    return (0, $g3Edw.useMemo)(()=>`${$dd4549797813bb01$var$count++}`, []);
}
function $dd4549797813bb01$var$useUniqueContextId() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useId();
}
var $dd4549797813bb01$var$useUniqueContextId$1 = "useId" in (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))) ? $dd4549797813bb01$var$useUniqueContextId : $dd4549797813bb01$var$useDeprecatedUniqueContextId;
function $dd4549797813bb01$export$2bfe52350fc0150d() {
    if ("useId" in (0, (/*@__PURE__*/$parcel$interopDefault($81g6h)))) return;
    $dd4549797813bb01$var$resetDeprecatedUniqueContextId();
    $dd4549797813bb01$var$resetDeprecatedUniqueId();
}
function $dd4549797813bb01$export$237bd83162c14364(props) {
    const contextId = $dd4549797813bb01$var$useUniqueContextId$1();
    const dragHandleUsageInstructions = props.dragHandleUsageInstructions || $dd4549797813bb01$var$preset$1.dragHandleUsageInstructions;
    return (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement($dd4549797813bb01$var$ErrorBoundary, null, (setCallbacks)=>(0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement($dd4549797813bb01$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            dragHandleUsageInstructions: dragHandleUsageInstructions,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd,
            autoScrollerOptions: props.autoScrollerOptions
        }, props.children));
}
const $dd4549797813bb01$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
const $dd4549797813bb01$var$getDraggingTransition = (shouldAnimateDragMovement, dropping)=>{
    if (dropping) return $dd4549797813bb01$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $dd4549797813bb01$var$transitions.snap;
    return $dd4549797813bb01$var$transitions.fluid;
};
const $dd4549797813bb01$var$getDraggingOpacity = (isCombining, isDropAnimating)=>{
    if (!isCombining) return undefined;
    return isDropAnimating ? $dd4549797813bb01$var$combine.opacity.drop : $dd4549797813bb01$var$combine.opacity.combining;
};
const $dd4549797813bb01$var$getShouldDraggingAnimate = (dragging)=>{
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === "SNAP";
};
function $dd4549797813bb01$var$getDraggingStyle(dragging) {
    const dimension = dragging.dimension;
    const box = dimension.client;
    const { offset: offset, combineWith: combineWith, dropping: dropping } = dragging;
    const isCombining = Boolean(combineWith);
    const shouldAnimate = $dd4549797813bb01$var$getShouldDraggingAnimate(dragging);
    const isDropAnimating = Boolean(dropping);
    const transform = isDropAnimating ? $dd4549797813bb01$var$transforms.drop(offset, isCombining) : $dd4549797813bb01$var$transforms.moveTo(offset);
    const style = {
        position: "fixed",
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: "border-box",
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $dd4549797813bb01$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $dd4549797813bb01$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $dd4549797813bb01$var$zIndexOptions.dropAnimating : $dd4549797813bb01$var$zIndexOptions.dragging,
        pointerEvents: "none"
    };
    return style;
}
function $dd4549797813bb01$var$getSecondaryStyle(secondary) {
    return {
        transform: $dd4549797813bb01$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? undefined : "none"
    };
}
function $dd4549797813bb01$var$getStyle$1(mapped) {
    return mapped.type === "DRAGGING" ? $dd4549797813bb01$var$getDraggingStyle(mapped) : $dd4549797813bb01$var$getSecondaryStyle(mapped);
}
function $dd4549797813bb01$var$getDimension$1(descriptor, el, windowScroll = $dd4549797813bb01$var$origin) {
    const computedStyles = window.getComputedStyle(el);
    const borderBox = el.getBoundingClientRect();
    const client = (0, $kZLuh.calculateBox)(borderBox, computedStyles);
    const page = (0, $kZLuh.withScroll)(client, windowScroll);
    const placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    const displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    const dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $dd4549797813bb01$var$useDraggablePublisher(args) {
    const uniqueId = $dd4549797813bb01$var$useUniqueId$1("draggable");
    const { descriptor: descriptor, registry: registry, getDraggableRef: getDraggableRef, canDragInteractiveElements: canDragInteractiveElements, shouldRespectForcePress: shouldRespectForcePress, isEnabled: isEnabled } = args;
    const options = (0, $g3Edw.useMemo)(()=>({
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        }), [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    const getDimension = (0, $g3Edw.useCallback)((windowScroll)=>{
        const el = getDraggableRef();
        !el && $dd4549797813bb01$var$invariant(false);
        return $dd4549797813bb01$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    const entry = (0, $g3Edw.useMemo)(()=>({
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        }), [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    const publishedRef = (0, $81g6h.useRef)(entry);
    const isFirstPublishRef = (0, $81g6h.useRef)(true);
    $dd4549797813bb01$var$useLayoutEffect(()=>{
        registry.draggable.register(publishedRef.current);
        return ()=>registry.draggable.unregister(publishedRef.current);
    }, [
        registry.draggable
    ]);
    $dd4549797813bb01$var$useLayoutEffect(()=>{
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        const last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
var $dd4549797813bb01$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createContext(null);
function $dd4549797813bb01$var$checkIsValidInnerRef(el) {
    !(el && $dd4549797813bb01$var$isHtmlElement(el)) && $dd4549797813bb01$var$invariant(false);
}
function $dd4549797813bb01$var$useValidation$1(props, contextId, getRef) {
    $dd4549797813bb01$var$useDevSetupWarning(()=>{
        function prefix(id) {
            return `Draggable[id: ${id}]: `;
        }
        const id = props.draggableId;
        !id && $dd4549797813bb01$var$invariant(false);
        !(typeof id === "string") && $dd4549797813bb01$var$invariant(false);
        !Number.isInteger(props.index) && $dd4549797813bb01$var$invariant(false);
        if (props.mapped.type === "DRAGGING") return;
        $dd4549797813bb01$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$dd4549797813bb01$var$findDragHandle(contextId, id) && $dd4549797813bb01$var$invariant(false);
    });
}
function $dd4549797813bb01$var$useClonePropValidation(isClone) {
    $dd4549797813bb01$var$useDev(()=>{
        const initialRef = (0, $81g6h.useRef)(isClone);
        $dd4549797813bb01$var$useDevSetupWarning(()=>{
            !(isClone === initialRef.current) && $dd4549797813bb01$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $dd4549797813bb01$var$useRequiredContext(Context) {
    const result = (0, $81g6h.useContext)(Context);
    !result && $dd4549797813bb01$var$invariant(false);
    return result;
}
function $dd4549797813bb01$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
const $dd4549797813bb01$var$Draggable = (props)=>{
    const ref = (0, $81g6h.useRef)(null);
    const setRef = (0, $g3Edw.useCallback)((el = null)=>{
        ref.current = el;
    }, []);
    const getRef = (0, $g3Edw.useCallback)(()=>ref.current, []);
    const { contextId: contextId, dragHandleUsageInstructionsId: dragHandleUsageInstructionsId, registry: registry } = $dd4549797813bb01$var$useRequiredContext($dd4549797813bb01$var$AppContext);
    const { type: type, droppableId: droppableId } = $dd4549797813bb01$var$useRequiredContext($dd4549797813bb01$var$DroppableContext);
    const descriptor = (0, $g3Edw.useMemo)(()=>({
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        }), [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    const { children: children, draggableId: draggableId, isEnabled: isEnabled, shouldRespectForcePress: shouldRespectForcePress, canDragInteractiveElements: canDragInteractiveElements, isClone: isClone, mapped: mapped, dropAnimationFinished: dropAnimationFinishedAction } = props;
    $dd4549797813bb01$var$useValidation$1(props, contextId, getRef);
    $dd4549797813bb01$var$useClonePropValidation(isClone);
    if (!isClone) {
        const forPublisher = (0, $g3Edw.useMemo)(()=>({
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            }), [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $dd4549797813bb01$var$useDraggablePublisher(forPublisher);
    }
    const dragHandleProps = (0, $g3Edw.useMemo)(()=>isEnabled ? {
            tabIndex: 0,
            role: "button",
            "aria-describedby": dragHandleUsageInstructionsId,
            "data-rfd-drag-handle-draggable-id": draggableId,
            "data-rfd-drag-handle-context-id": contextId,
            draggable: false,
            onDragStart: $dd4549797813bb01$var$preventHtml5Dnd
        } : null, [
        contextId,
        dragHandleUsageInstructionsId,
        draggableId,
        isEnabled
    ]);
    const onMoveEnd = (0, $g3Edw.useCallback)((event)=>{
        if (mapped.type !== "DRAGGING") return;
        if (!mapped.dropping) return;
        if (event.propertyName !== "transform") return;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).version.startsWith("16") || (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).version.startsWith("17")) dropAnimationFinishedAction();
        else (0, $Q1dTY.flushSync)(dropAnimationFinishedAction);
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    const provided = (0, $g3Edw.useMemo)(()=>{
        const style = $dd4549797813bb01$var$getStyle$1(mapped);
        const onTransitionEnd = mapped.type === "DRAGGING" && mapped.dropping ? onMoveEnd : undefined;
        const result = {
            innerRef: setRef,
            draggableProps: {
                "data-rfd-draggable-context-id": contextId,
                "data-rfd-draggable-id": draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    const rubric = (0, $g3Edw.useMemo)(()=>({
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        }), [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).Fragment, null, children(provided, mapped.snapshot, rubric));
};
var $dd4549797813bb01$var$Draggable$1 = $dd4549797813bb01$var$Draggable;
var $dd4549797813bb01$var$isStrictEqual = (a, b)=>a === b;
var $dd4549797813bb01$var$whatIsDraggedOverFromResult = (result)=>{
    const { combine: combine, destination: destination } = result;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
const $dd4549797813bb01$var$getCombineWithFromResult = (result)=>{
    return result.combine ? result.combine.draggableId : null;
};
const $dd4549797813bb01$var$getCombineWithFromImpact = (impact)=>{
    return impact.at && impact.at.type === "COMBINE" ? impact.at.combine.draggableId : null;
};
function $dd4549797813bb01$var$getDraggableSelector() {
    const memoizedOffset = (0, $6iviE.default)((x, y)=>({
            x: x,
            y: y
        }));
    const getMemoizedSnapshot = (0, $6iviE.default)((mode, isClone, draggingOver = null, combineWith = null, dropping = null)=>({
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        }));
    const getMemoizedProps = (0, $6iviE.default)((offset, mode, dimension, isClone, draggingOver = null, combineWith = null, forceShouldAnimate = null)=>({
            mapped: {
                type: "DRAGGING",
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        }));
    const selector = (state, ownProps)=>{
        if ($dd4549797813bb01$var$isDragging(state)) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            const offset = state.current.client.offset;
            const dimension = state.dimensions.draggables[ownProps.draggableId];
            const draggingOver = $dd4549797813bb01$var$whatIsDraggedOver(state.impact);
            const combineWith = $dd4549797813bb01$var$getCombineWithFromImpact(state.impact);
            const forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === "DROP_ANIMATING") {
            const completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            const isClone = ownProps.isClone;
            const dimension = state.dimensions.draggables[ownProps.draggableId];
            const result = completed.result;
            const mode = result.mode;
            const draggingOver = $dd4549797813bb01$var$whatIsDraggedOverFromResult(result);
            const combineWith = $dd4549797813bb01$var$getCombineWithFromResult(result);
            const duration = state.dropDuration;
            const dropping = {
                duration: duration,
                curve: $dd4549797813bb01$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: combineWith ? $dd4549797813bb01$var$combine.opacity.drop : null,
                scale: combineWith ? $dd4549797813bb01$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: "DRAGGING",
                    offset: state.newHomeClientOffset,
                    dimension: dimension,
                    dropping: dropping,
                    draggingOver: draggingOver,
                    combineWith: combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $dd4549797813bb01$var$getSecondarySnapshot(combineTargetFor = null) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
const $dd4549797813bb01$var$atRest = {
    mapped: {
        type: "SECONDARY",
        offset: $dd4549797813bb01$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $dd4549797813bb01$var$getSecondarySnapshot(null)
    }
};
function $dd4549797813bb01$var$getSecondarySelector() {
    const memoizedOffset = (0, $6iviE.default)((x, y)=>({
            x: x,
            y: y
        }));
    const getMemoizedSnapshot = (0, $6iviE.default)($dd4549797813bb01$var$getSecondarySnapshot);
    const getMemoizedProps = (0, $6iviE.default)((offset, combineTargetFor = null, shouldAnimateDisplacement)=>({
            mapped: {
                type: "SECONDARY",
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        }));
    const getFallback = (combineTargetFor)=>{
        return combineTargetFor ? getMemoizedProps($dd4549797813bb01$var$origin, combineTargetFor, true) : null;
    };
    const getProps = (ownId, draggingId, impact, afterCritical)=>{
        const visualDisplacement = impact.displaced.visible[ownId];
        const isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        const combine = $dd4549797813bb01$var$tryGetCombine(impact);
        const combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            const change = $dd4549797813bb01$var$negate(afterCritical.displacedBy.point);
            const offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        const displaceBy = impact.displacedBy.point;
        const offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    const selector = (state, ownProps)=>{
        if ($dd4549797813bb01$var$isDragging(state)) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === "DROP_ANIMATING") {
            const completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
const $dd4549797813bb01$var$makeMapStateToProps$1 = ()=>{
    const draggingSelector = $dd4549797813bb01$var$getDraggableSelector();
    const secondarySelector = $dd4549797813bb01$var$getSecondarySelector();
    const selector = (state, ownProps)=>draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $dd4549797813bb01$var$atRest;
    return selector;
};
const $dd4549797813bb01$var$mapDispatchToProps$1 = {
    dropAnimationFinished: $dd4549797813bb01$var$dropAnimationFinished
};
const $dd4549797813bb01$var$ConnectedDraggable = (0, $hd224.default)($dd4549797813bb01$var$makeMapStateToProps$1, $dd4549797813bb01$var$mapDispatchToProps$1, null, {
    context: $dd4549797813bb01$var$StoreContext,
    areStatePropsEqual: $dd4549797813bb01$var$isStrictEqual
})($dd4549797813bb01$var$Draggable$1);
var $dd4549797813bb01$var$ConnectedDraggable$1 = $dd4549797813bb01$var$ConnectedDraggable;
function $dd4549797813bb01$var$PrivateDraggable(props) {
    const droppableContext = $dd4549797813bb01$var$useRequiredContext($dd4549797813bb01$var$DroppableContext);
    const isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement($dd4549797813bb01$var$ConnectedDraggable$1, props);
}
function $dd4549797813bb01$export$f2a139e5d18b9882(props) {
    const isEnabled = typeof props.isDragDisabled === "boolean" ? !props.isDragDisabled : true;
    const canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    const shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement($dd4549797813bb01$var$PrivateDraggable, (0, $6JG9D.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
const $dd4549797813bb01$var$isEqual = (base)=>(value)=>base === value;
const $dd4549797813bb01$var$isScroll = $dd4549797813bb01$var$isEqual("scroll");
const $dd4549797813bb01$var$isAuto = $dd4549797813bb01$var$isEqual("auto");
const $dd4549797813bb01$var$isVisible = $dd4549797813bb01$var$isEqual("visible");
const $dd4549797813bb01$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const $dd4549797813bb01$var$isBoth = (overflow, fn)=>fn(overflow.overflowX) && fn(overflow.overflowY);
const $dd4549797813bb01$var$isElementScrollable = (el)=>{
    const style = window.getComputedStyle(el);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $dd4549797813bb01$var$isEither(overflow, $dd4549797813bb01$var$isScroll) || $dd4549797813bb01$var$isEither(overflow, $dd4549797813bb01$var$isAuto);
};
const $dd4549797813bb01$var$isBodyScrollable = ()=>{
    return false;
};
const $dd4549797813bb01$var$getClosestScrollable = (el)=>{
    if (el == null) return null;
    if (el === document.body) return $dd4549797813bb01$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$dd4549797813bb01$var$isElementScrollable(el)) return $dd4549797813bb01$var$getClosestScrollable(el.parentElement);
    return el;
};
var $dd4549797813bb01$var$checkForNestedScrollContainers = (scrollable)=>{
    if (!scrollable) return;
    const anotherScrollParent = $dd4549797813bb01$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $dd4549797813bb01$var$getScroll = (el)=>({
        x: el.scrollLeft,
        y: el.scrollTop
    });
const $dd4549797813bb01$var$getIsFixed = (el)=>{
    if (!el) return false;
    const style = window.getComputedStyle(el);
    if (style.position === "fixed") return true;
    return $dd4549797813bb01$var$getIsFixed(el.parentElement);
};
var $dd4549797813bb01$var$getEnv = (start)=>{
    const closestScrollable = $dd4549797813bb01$var$getClosestScrollable(start);
    const isFixedOnPage = $dd4549797813bb01$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $dd4549797813bb01$var$getDroppableDimension = ({ descriptor: descriptor, isEnabled: isEnabled, isCombineEnabled: isCombineEnabled, isFixedOnPage: isFixedOnPage, direction: direction, client: client, page: page, closest: closest })=>{
    const frame = (()=>{
        if (!closest) return null;
        const { scrollSize: scrollSize, client: frameClient } = closest;
        const maxScroll = $dd4549797813bb01$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $dd4549797813bb01$var$origin,
                    displacement: $dd4549797813bb01$var$origin
                }
            }
        };
    })();
    const axis = direction === "vertical" ? $dd4549797813bb01$var$vertical : $dd4549797813bb01$var$horizontal;
    const subject = $dd4549797813bb01$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    const dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
const $dd4549797813bb01$var$getClient = (targetRef, closestScrollable)=>{
    const base = (0, $kZLuh.getBox)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    const top = base.paddingBox.top - closestScrollable.scrollTop;
    const left = base.paddingBox.left - closestScrollable.scrollLeft;
    const bottom = top + closestScrollable.scrollHeight;
    const right = left + closestScrollable.scrollWidth;
    const paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    const borderBox = (0, $kZLuh.expand)(paddingBox, base.border);
    const client = (0, $kZLuh.createBox)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $dd4549797813bb01$var$getDimension = ({ ref: ref, descriptor: descriptor, env: env, windowScroll: windowScroll, direction: direction, isDropDisabled: isDropDisabled, isCombineEnabled: isCombineEnabled, shouldClipSubject: shouldClipSubject })=>{
    const closestScrollable = env.closestScrollable;
    const client = $dd4549797813bb01$var$getClient(ref, closestScrollable);
    const page = (0, $kZLuh.withScroll)(client, windowScroll);
    const closest = (()=>{
        if (!closestScrollable) return null;
        const frameClient = (0, $kZLuh.getBox)(closestScrollable);
        const scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $kZLuh.withScroll)(frameClient, windowScroll),
            scroll: $dd4549797813bb01$var$getScroll(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    })();
    const dimension = $dd4549797813bb01$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
const $dd4549797813bb01$var$immediate = {
    passive: false
};
const $dd4549797813bb01$var$delayed = {
    passive: true
};
var $dd4549797813bb01$var$getListenerOptions = (options)=>options.shouldPublishImmediately ? $dd4549797813bb01$var$immediate : $dd4549797813bb01$var$delayed;
const $dd4549797813bb01$var$getClosestScrollableFromDrag = (dragging)=>dragging && dragging.env.closestScrollable || null;
function $dd4549797813bb01$var$useDroppablePublisher(args) {
    const whileDraggingRef = (0, $81g6h.useRef)(null);
    const appContext = $dd4549797813bb01$var$useRequiredContext($dd4549797813bb01$var$AppContext);
    const uniqueId = $dd4549797813bb01$var$useUniqueId$1("droppable");
    const { registry: registry, marshal: marshal } = appContext;
    const previousRef = $dd4549797813bb01$var$usePrevious(args);
    const descriptor = (0, $g3Edw.useMemo)(()=>({
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        }), [
        args.droppableId,
        args.mode,
        args.type
    ]);
    const publishedDescriptorRef = (0, $81g6h.useRef)(descriptor);
    const memoizedUpdateScroll = (0, $g3Edw.useMemo)(()=>(0, $6iviE.default)((x, y)=>{
            !whileDraggingRef.current && $dd4549797813bb01$var$invariant(false);
            const scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        }), [
        descriptor.id,
        marshal
    ]);
    const getClosestScroll = (0, $g3Edw.useCallback)(()=>{
        const dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $dd4549797813bb01$var$origin;
        return $dd4549797813bb01$var$getScroll(dragging.env.closestScrollable);
    }, []);
    const updateScroll = (0, $g3Edw.useCallback)(()=>{
        const scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    const scheduleScrollUpdate = (0, $g3Edw.useMemo)(()=>(0, $ed8xX.default)(updateScroll), [
        updateScroll
    ]);
    const onClosestScroll = (0, $g3Edw.useCallback)(()=>{
        const dragging = whileDraggingRef.current;
        const closest = $dd4549797813bb01$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $dd4549797813bb01$var$invariant(false);
        const options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    const getDimensionAndWatchScroll = (0, $g3Edw.useCallback)((windowScroll, options)=>{
        !!whileDraggingRef.current && $dd4549797813bb01$var$invariant(false);
        const previous = previousRef.current;
        const ref = previous.getDroppableRef();
        !ref && $dd4549797813bb01$var$invariant(false);
        const env = $dd4549797813bb01$var$getEnv(ref);
        const dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        const dimension = $dd4549797813bb01$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        const scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($dd4549797813bb01$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener("scroll", onClosestScroll, $dd4549797813bb01$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    const getScrollWhileDragging = (0, $g3Edw.useCallback)(()=>{
        const dragging = whileDraggingRef.current;
        const closest = $dd4549797813bb01$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $dd4549797813bb01$var$invariant(false);
        return $dd4549797813bb01$var$getScroll(closest);
    }, []);
    const dragStopped = (0, $g3Edw.useCallback)(()=>{
        const dragging = whileDraggingRef.current;
        !dragging && $dd4549797813bb01$var$invariant(false);
        const closest = $dd4549797813bb01$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($dd4549797813bb01$var$scrollContainer.contextId);
        closest.removeEventListener("scroll", onClosestScroll, $dd4549797813bb01$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    const scroll = (0, $g3Edw.useCallback)((change)=>{
        const dragging = whileDraggingRef.current;
        !dragging && $dd4549797813bb01$var$invariant(false);
        const closest = $dd4549797813bb01$var$getClosestScrollableFromDrag(dragging);
        !closest && $dd4549797813bb01$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    const callbacks = (0, $g3Edw.useMemo)(()=>{
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    const entry = (0, $g3Edw.useMemo)(()=>({
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        }), [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $dd4549797813bb01$var$useLayoutEffect(()=>{
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return ()=>{
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $dd4549797813bb01$var$useLayoutEffect(()=>{
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $dd4549797813bb01$var$useLayoutEffect(()=>{
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $dd4549797813bb01$var$noop() {}
const $dd4549797813bb01$var$empty = {
    width: 0,
    height: 0,
    margin: $dd4549797813bb01$var$noSpacing
};
const $dd4549797813bb01$var$getSize = ({ isAnimatingOpenOnMount: isAnimatingOpenOnMount, placeholder: placeholder, animate: animate })=>{
    if (isAnimatingOpenOnMount) return $dd4549797813bb01$var$empty;
    if (animate === "close") return $dd4549797813bb01$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
const $dd4549797813bb01$var$getStyle = ({ isAnimatingOpenOnMount: isAnimatingOpenOnMount, placeholder: placeholder, animate: animate })=>{
    const size = $dd4549797813bb01$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: "border-box",
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: "0",
        flexGrow: "0",
        pointerEvents: "none",
        transition: animate !== "none" ? $dd4549797813bb01$var$transitions.placeholder : null
    };
};
const $dd4549797813bb01$var$Placeholder = (props)=>{
    const animateOpenTimerRef = (0, $81g6h.useRef)(null);
    const tryClearAnimateOpenTimer = (0, $g3Edw.useCallback)(()=>{
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    const { animate: animate, onTransitionEnd: onTransitionEnd, onClose: onClose, contextId: contextId } = props;
    const [isAnimatingOpenOnMount, setIsAnimatingOpenOnMount] = (0, $81g6h.useState)(props.animate === "open");
    (0, $81g6h.useEffect)(()=>{
        if (!isAnimatingOpenOnMount) return $dd4549797813bb01$var$noop;
        if (animate !== "open") {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $dd4549797813bb01$var$noop;
        }
        if (animateOpenTimerRef.current) return $dd4549797813bb01$var$noop;
        animateOpenTimerRef.current = setTimeout(()=>{
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    const onSizeChangeEnd = (0, $g3Edw.useCallback)((event)=>{
        if (event.propertyName !== "height") return;
        onTransitionEnd();
        if (animate === "close") onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    const style = $dd4549797813bb01$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement(props.placeholder.tagName, {
        style: style,
        "data-rfd-placeholder-context-id": contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
};
var $dd4549797813bb01$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).memo($dd4549797813bb01$var$Placeholder);
function $dd4549797813bb01$var$isBoolean(value) {
    return typeof value === "boolean";
}
function $dd4549797813bb01$var$runChecks(args, checks) {
    checks.forEach((check)=>check(args));
}
const $dd4549797813bb01$var$shared = [
    function required({ props: props }) {
        !props.droppableId && $dd4549797813bb01$var$invariant(false);
        !(typeof props.droppableId === "string") && $dd4549797813bb01$var$invariant(false);
    },
    function boolean({ props: props }) {
        !$dd4549797813bb01$var$isBoolean(props.isDropDisabled) && $dd4549797813bb01$var$invariant(false);
        !$dd4549797813bb01$var$isBoolean(props.isCombineEnabled) && $dd4549797813bb01$var$invariant(false);
        !$dd4549797813bb01$var$isBoolean(props.ignoreContainerClipping) && $dd4549797813bb01$var$invariant(false);
    },
    function ref({ getDroppableRef: getDroppableRef }) {
        $dd4549797813bb01$var$checkIsValidInnerRef(getDroppableRef());
    }
];
const $dd4549797813bb01$var$standard = [
    function placeholder({ props: props, getPlaceholderRef: getPlaceholderRef }) {
        if (!props.placeholder) return;
        const ref = getPlaceholderRef();
        if (ref) return;
    }
];
const $dd4549797813bb01$var$virtual = [
    function hasClone({ props: props }) {
        !props.renderClone && $dd4549797813bb01$var$invariant(false);
    },
    function hasNoPlaceholder({ getPlaceholderRef: getPlaceholderRef }) {
        !!getPlaceholderRef() && $dd4549797813bb01$var$invariant(false);
    }
];
function $dd4549797813bb01$var$useValidation(args) {
    $dd4549797813bb01$var$useDevSetupWarning(()=>{
        $dd4549797813bb01$var$runChecks(args, $dd4549797813bb01$var$shared);
        if (args.props.mode === "standard") $dd4549797813bb01$var$runChecks(args, $dd4549797813bb01$var$standard);
        if (args.props.mode === "virtual") $dd4549797813bb01$var$runChecks(args, $dd4549797813bb01$var$virtual);
    });
}
class $dd4549797813bb01$var$AnimateInOut extends (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).PureComponent {
    constructor(...args){
        super(...args);
        this.state = {
            isVisible: Boolean(this.props.on),
            data: this.props.on,
            animate: this.props.shouldAnimate && this.props.on ? "open" : "none"
        };
        this.onClose = ()=>{
            if (this.state.animate !== "close") return;
            this.setState({
                isVisible: false
            });
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: "none"
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: "open"
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: "close"
        };
        return {
            isVisible: false,
            animate: "close",
            data: null
        };
    }
    render() {
        if (!this.state.isVisible) return null;
        const provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    }
}
const $dd4549797813bb01$var$Droppable = (props)=>{
    const appContext = (0, $81g6h.useContext)($dd4549797813bb01$var$AppContext);
    !appContext && $dd4549797813bb01$var$invariant(false);
    const { contextId: contextId, isMovementAllowed: isMovementAllowed } = appContext;
    const droppableRef = (0, $81g6h.useRef)(null);
    const placeholderRef = (0, $81g6h.useRef)(null);
    const { children: children, droppableId: droppableId, type: type, mode: mode, direction: direction, ignoreContainerClipping: ignoreContainerClipping, isDropDisabled: isDropDisabled, isCombineEnabled: isCombineEnabled, snapshot: snapshot, useClone: useClone, updateViewportMaxScroll: updateViewportMaxScroll, getContainerForClone: getContainerForClone } = props;
    const getDroppableRef = (0, $g3Edw.useCallback)(()=>droppableRef.current, []);
    const setDroppableRef = (0, $g3Edw.useCallback)((value = null)=>{
        droppableRef.current = value;
    }, []);
    const getPlaceholderRef = (0, $g3Edw.useCallback)(()=>placeholderRef.current, []);
    const setPlaceholderRef = (0, $g3Edw.useCallback)((value = null)=>{
        placeholderRef.current = value;
    }, []);
    $dd4549797813bb01$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    const onPlaceholderTransitionEnd = (0, $g3Edw.useCallback)(()=>{
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $dd4549797813bb01$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $dd4549797813bb01$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    const placeholder = (0, $g3Edw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement($dd4549797813bb01$var$AnimateInOut, {
            on: props.placeholder,
            shouldAnimate: props.shouldAnimatePlaceholder
        }, ({ onClose: onClose, data: data, animate: animate })=>(0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement($dd4549797813bb01$var$Placeholder$1, {
                placeholder: data,
                onClose: onClose,
                innerRef: setPlaceholderRef,
                animate: animate,
                contextId: contextId,
                onTransitionEnd: onPlaceholderTransitionEnd
            })), [
        contextId,
        onPlaceholderTransitionEnd,
        props.placeholder,
        props.shouldAnimatePlaceholder,
        setPlaceholderRef
    ]);
    const provided = (0, $g3Edw.useMemo)(()=>({
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                "data-rfd-droppable-id": droppableId,
                "data-rfd-droppable-context-id": contextId
            }
        }), [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    const isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    const droppableContext = (0, $g3Edw.useMemo)(()=>({
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        }), [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        const { dragging: dragging, render: render } = useClone;
        const node = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement($dd4549797813bb01$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, (draggableProvided, draggableSnapshot)=>render(draggableProvided, draggableSnapshot, dragging));
        return (0, (/*@__PURE__*/$parcel$interopDefault($Q1dTY))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement($dd4549797813bb01$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
};
var $dd4549797813bb01$var$Droppable$1 = $dd4549797813bb01$var$Droppable;
function $dd4549797813bb01$var$getBody() {
    !document.body && $dd4549797813bb01$var$invariant(false);
    return document.body;
}
const $dd4549797813bb01$var$defaultProps = {
    mode: "standard",
    type: "DEFAULT",
    direction: "vertical",
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $dd4549797813bb01$var$getBody
};
const $dd4549797813bb01$var$attachDefaultPropsToOwnProps = (ownProps)=>{
    let mergedProps = {
        ...ownProps
    };
    let defaultPropKey;
    for(defaultPropKey in $dd4549797813bb01$var$defaultProps)if (ownProps[defaultPropKey] === undefined) mergedProps = {
        ...mergedProps,
        [defaultPropKey]: $dd4549797813bb01$var$defaultProps[defaultPropKey]
    };
    return mergedProps;
};
const $dd4549797813bb01$var$isMatchingType = (type, critical)=>type === critical.droppable.type;
const $dd4549797813bb01$var$getDraggable = (critical, dimensions)=>dimensions.draggables[critical.draggable.id];
const $dd4549797813bb01$var$makeMapStateToProps = ()=>{
    const idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    const idleWithoutAnimation = {
        ...idleWithAnimation,
        shouldAnimatePlaceholder: false
    };
    const getDraggableRubric = (0, $6iviE.default)((descriptor)=>({
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        }));
    const getMapProps = (0, $6iviE.default)((id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone)=>{
        const draggableId = dragging.descriptor.id;
        const isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            const useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            const snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        const snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    const selector = (state, ownProps)=>{
        const ownPropsWithDefaultProps = $dd4549797813bb01$var$attachDefaultPropsToOwnProps(ownProps);
        const id = ownPropsWithDefaultProps.droppableId;
        const type = ownPropsWithDefaultProps.type;
        const isEnabled = !ownPropsWithDefaultProps.isDropDisabled;
        const renderClone = ownPropsWithDefaultProps.renderClone;
        if ($dd4549797813bb01$var$isDragging(state)) {
            const critical = state.critical;
            if (!$dd4549797813bb01$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            const dragging = $dd4549797813bb01$var$getDraggable(critical, state.dimensions);
            const isDraggingOver = $dd4549797813bb01$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === "DROP_ANIMATING") {
            const completed = state.completed;
            if (!$dd4549797813bb01$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            const dragging = $dd4549797813bb01$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $dd4549797813bb01$var$whatIsDraggedOverFromResult(completed.result) === id, $dd4549797813bb01$var$whatIsDraggedOver(completed.impact) === id, dragging, renderClone);
        }
        if (state.phase === "IDLE" && state.completed && !state.shouldFlush) {
            const completed = state.completed;
            if (!$dd4549797813bb01$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            const wasOver = $dd4549797813bb01$var$whatIsDraggedOver(completed.impact) === id;
            const wasCombining = Boolean(completed.impact.at && completed.impact.at.type === "COMBINE");
            const isHome = completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
const $dd4549797813bb01$var$mapDispatchToProps = {
    updateViewportMaxScroll: $dd4549797813bb01$var$updateViewportMaxScroll
};
const $dd4549797813bb01$var$ConnectedDroppable = (0, $hd224.default)($dd4549797813bb01$var$makeMapStateToProps, $dd4549797813bb01$var$mapDispatchToProps, (stateProps, dispatchProps, ownProps)=>{
    return {
        ...$dd4549797813bb01$var$attachDefaultPropsToOwnProps(ownProps),
        ...stateProps,
        ...dispatchProps
    };
}, {
    context: $dd4549797813bb01$var$StoreContext,
    areStatePropsEqual: $dd4549797813bb01$var$isStrictEqual
})($dd4549797813bb01$var$Droppable$1);
var $dd4549797813bb01$export$423ec2075359570a = $dd4549797813bb01$var$ConnectedDroppable;

});
parcelRegister("71WWU", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $51e65a7752b7b070$export$f51a9068ac82ea43);
$parcel$export(module.exports, "bindActionCreators", () => $51e65a7752b7b070$export$aea084d96e84da92);
$parcel$export(module.exports, "compose", () => $51e65a7752b7b070$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $51e65a7752b7b070$export$9ff26e0402cc7b7);

var $7DiwO = parcelRequire("7DiwO");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $51e65a7752b7b070$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $51e65a7752b7b070$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $51e65a7752b7b070$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $51e65a7752b7b070$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $51e65a7752b7b070$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $51e65a7752b7b070$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $51e65a7752b7b070$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $51e65a7752b7b070$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $51e65a7752b7b070$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($51e65a7752b7b070$var$isDate(val)) return "date";
    if ($51e65a7752b7b070$var$isError(val)) return "error";
    var constructorName = $51e65a7752b7b070$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $51e65a7752b7b070$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $51e65a7752b7b070$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $51e65a7752b7b070$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $51e65a7752b7b070$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $51e65a7752b7b070$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(1));
        return enhancer($51e65a7752b7b070$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$51e65a7752b7b070$var$isPlainObject(action)) throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $51e65a7752b7b070$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$51e65a7752b7b070$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $51e65a7752b7b070$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$51e65a7752b7b070$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $51e65a7752b7b070$export$8928921ea2d3b126 = $51e65a7752b7b070$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $51e65a7752b7b070$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $51e65a7752b7b070$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $51e65a7752b7b070$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$51e65a7752b7b070$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $51e65a7752b7b070$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $51e65a7752b7b070$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $51e65a7752b7b070$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $51e65a7752b7b070$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $51e65a7752b7b070$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $51e65a7752b7b070$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $51e65a7752b7b070$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $51e65a7752b7b070$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $51e65a7752b7b070$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $51e65a7752b7b070$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $51e65a7752b7b070$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $51e65a7752b7b070$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $51e65a7752b7b070$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($51e65a7752b7b070$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $51e65a7752b7b070$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $7DiwO.default)((0, $7DiwO.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("7DiwO", function(module, exports) {

$parcel$export(module.exports, "default", () => $58ea8c3dc6086631$export$2e2bcd8739ae039);

var $dNNnt = parcelRequire("dNNnt");
function $58ea8c3dc6086631$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $58ea8c3dc6086631$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $58ea8c3dc6086631$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dNNnt.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $58ea8c3dc6086631$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("dNNnt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0c62758b356f881$export$2e2bcd8739ae039);

var $dTHG1 = parcelRequire("dTHG1");
function $a0c62758b356f881$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $dTHG1.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("dTHG1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1e24aba93aab9ce$export$2e2bcd8739ae039);

var $hyosb = parcelRequire("hyosb");

var $1stTg = parcelRequire("1stTg");
function $a1e24aba93aab9ce$export$2e2bcd8739ae039(t) {
    var i = (0, $1stTg.default)(t, "string");
    return "symbol" == (0, $hyosb.default)(i) ? i : i + "";
}

});
parcelRegister("hyosb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc7894978661cf0d$export$2e2bcd8739ae039);
function $cc7894978661cf0d$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $cc7894978661cf0d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cc7894978661cf0d$export$2e2bcd8739ae039(o);
}

});

parcelRegister("1stTg", function(module, exports) {

$parcel$export(module.exports, "default", () => $10ff97912d96ac4d$export$2e2bcd8739ae039);

var $hyosb = parcelRequire("hyosb");
function $10ff97912d96ac4d$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $hyosb.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $hyosb.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("hsW4Y", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("hd224")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("duc3X")).default);
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $gpF4t = parcelRequire("gpF4t");

var $f2Hne = parcelRequire("f2Hne");
parcelRequire("kG7XF");
var $Q1dTY = parcelRequire("Q1dTY");

var $irisY = parcelRequire("irisY");

var $5lAxT = parcelRequire("5lAxT");

var $hd224 = parcelRequire("hd224");
parcelRequire("B85Hq");
(0, $5lAxT.initializeUseSelector)((0, $f2Hne.useSyncExternalStoreWithSelector));
(0, $hd224.initializeConnect)((0, $gpF4t.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $irisY.setBatch)((0, $Q1dTY.unstable_batchedUpdates));

});
parcelRegister("gpF4t", function(module, exports) {
"use strict";

module.exports = (parcelRequire("iYzk8"));

});
parcelRegister("iYzk8", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $dd093b2d8f3f87fe$export$306c0aa65ff9ec16, (v) => $dd093b2d8f3f87fe$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd093b2d8f3f87fe$export$306c0aa65ff9ec16;
"use strict";

var $81g6h = parcelRequire("81g6h");
function $dd093b2d8f3f87fe$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dd093b2d8f3f87fe$var$objectIs = "function" === typeof Object.is ? Object.is : $dd093b2d8f3f87fe$var$is, $dd093b2d8f3f87fe$var$useState = $81g6h.useState, $dd093b2d8f3f87fe$var$useEffect = $81g6h.useEffect, $dd093b2d8f3f87fe$var$useLayoutEffect = $81g6h.useLayoutEffect, $dd093b2d8f3f87fe$var$useDebugValue = $81g6h.useDebugValue;
function $dd093b2d8f3f87fe$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $dd093b2d8f3f87fe$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $dd093b2d8f3f87fe$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $dd093b2d8f3f87fe$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $dd093b2d8f3f87fe$var$useEffect(function() {
        $dd093b2d8f3f87fe$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $dd093b2d8f3f87fe$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $dd093b2d8f3f87fe$var$useDebugValue(value);
    return value;
}
function $dd093b2d8f3f87fe$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dd093b2d8f3f87fe$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dd093b2d8f3f87fe$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $dd093b2d8f3f87fe$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $dd093b2d8f3f87fe$var$useSyncExternalStore$1 : $dd093b2d8f3f87fe$var$useSyncExternalStore$2;
$dd093b2d8f3f87fe$export$306c0aa65ff9ec16 = void 0 !== $81g6h.useSyncExternalStore ? $81g6h.useSyncExternalStore : $dd093b2d8f3f87fe$var$shim;

});


parcelRegister("f2Hne", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fuD9Q"));

});
parcelRegister("fuD9Q", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $b4780840d02b2e29$export$bf730a2d8bf68b42, (v) => $b4780840d02b2e29$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b4780840d02b2e29$export$bf730a2d8bf68b42;
"use strict";

var $81g6h = parcelRequire("81g6h");

var $gpF4t = parcelRequire("gpF4t");
function $b4780840d02b2e29$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $b4780840d02b2e29$var$objectIs = "function" === typeof Object.is ? Object.is : $b4780840d02b2e29$var$is, $b4780840d02b2e29$var$useSyncExternalStore = $gpF4t.useSyncExternalStore, $b4780840d02b2e29$var$useRef = $81g6h.useRef, $b4780840d02b2e29$var$useEffect = $81g6h.useEffect, $b4780840d02b2e29$var$useMemo = $81g6h.useMemo, $b4780840d02b2e29$var$useDebugValue = $81g6h.useDebugValue;
$b4780840d02b2e29$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $b4780840d02b2e29$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $b4780840d02b2e29$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($b4780840d02b2e29$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $b4780840d02b2e29$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $b4780840d02b2e29$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $b4780840d02b2e29$var$useDebugValue(value);
    return value;
};

});


parcelRegister("kG7XF", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("Q1dTY")).unstable_batchedUpdates);

var $Q1dTY = parcelRequire("Q1dTY");

});

parcelRegister("irisY", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $d6c9129d18765ea1$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $d6c9129d18765ea1$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $d6c9129d18765ea1$var$defaultNoopBatch(callback) {
    callback();
}
let $d6c9129d18765ea1$var$batch = $d6c9129d18765ea1$var$defaultNoopBatch; // Allow injecting another batching function later
const $d6c9129d18765ea1$export$4b9874722d0da7bc = (newBatch)=>$d6c9129d18765ea1$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $d6c9129d18765ea1$export$fc47d4c0ba3bd2c6 = ()=>$d6c9129d18765ea1$var$batch;

});

parcelRegister("5lAxT", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", () => $3e4b431a57009570$export$e2e6e3f3f3b782e3);

var $81g6h = parcelRequire("81g6h");

var $bn91s = parcelRequire("bn91s");

var $aDvrI = parcelRequire("aDvrI");

var $kmQNP = parcelRequire("kmQNP");
let $3e4b431a57009570$var$useSyncExternalStoreWithSelector = (0, $kmQNP.notInitialized);
const $3e4b431a57009570$export$e2e6e3f3f3b782e3 = (fn)=>{
    $3e4b431a57009570$var$useSyncExternalStoreWithSelector = fn;
};
const $3e4b431a57009570$var$refEquality = (a, b)=>a === b;
function $3e4b431a57009570$export$2b53f90d2bd1cbfb(context = (0, $aDvrI.ReactReduxContext)) {
    const useReduxContext = context === (0, $aDvrI.ReactReduxContext) ? (0, $bn91s.useReduxContext) : (0, $bn91s.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $3e4b431a57009570$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $81g6h.useRef)(true);
        const wrappedSelector = (0, $81g6h.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $3e4b431a57009570$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $81g6h.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $3e4b431a57009570$export$2105062e25df4afe = /*#__PURE__*/ $3e4b431a57009570$export$2b53f90d2bd1cbfb();

});
parcelRegister("bn91s", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", () => $8478d76064c8a5dd$export$d4d6226d5fc61558);
$parcel$export(module.exports, "useReduxContext", () => $8478d76064c8a5dd$export$c1275ca9a6fd3ec5);

var $81g6h = parcelRequire("81g6h");

var $aDvrI = parcelRequire("aDvrI");
function $8478d76064c8a5dd$export$d4d6226d5fc61558(context = (0, $aDvrI.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $81g6h.useContext)(context);
        return contextValue;
    };
}
const $8478d76064c8a5dd$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $8478d76064c8a5dd$export$d4d6226d5fc61558();

});
parcelRegister("aDvrI", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $7be5f072c1816458$export$cc80c08dc91f1c00);

var $81g6h = parcelRequire("81g6h");
const $7be5f072c1816458$var$ContextKey = Symbol.for(`react-redux-context`);
const $7be5f072c1816458$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $7be5f072c1816458$var$getContext() {
    var _gT$ContextKey;
    if (!$81g6h.createContext) return {};
    const contextMap = (_gT$ContextKey = $7be5f072c1816458$var$gT[$7be5f072c1816458$var$ContextKey]) != null ? _gT$ContextKey : $7be5f072c1816458$var$gT[$7be5f072c1816458$var$ContextKey] = new Map();
    let realContext = contextMap.get($81g6h.createContext);
    if (!realContext) {
        realContext = $81g6h.createContext(null);
        contextMap.set($81g6h.createContext, realContext);
    }
    return realContext;
}
const $7be5f072c1816458$export$cc80c08dc91f1c00 = /*#__PURE__*/ $7be5f072c1816458$var$getContext();
var $7be5f072c1816458$export$2e2bcd8739ae039 = $7be5f072c1816458$export$cc80c08dc91f1c00;

});


parcelRegister("kmQNP", function(module, exports) {

$parcel$export(module.exports, "notInitialized", () => $ed3ed23df4ee6090$export$20656a4825650bd0);
const $ed3ed23df4ee6090$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};

});


parcelRegister("hd224", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", () => $c8753a22f51ce46f$export$36d45daa6a4925b8);
$parcel$export(module.exports, "default", () => $c8753a22f51ce46f$export$2e2bcd8739ae039);

var $6JG9D = parcelRequire("6JG9D");

var $cnuf2 = parcelRequire("cnuf2");

var $khy2w = parcelRequire("khy2w");

var $81g6h = parcelRequire("81g6h");

var $7Jr1S = parcelRequire("7Jr1S");

var $6UftH = parcelRequire("6UftH");

var $i39UI = parcelRequire("i39UI");

var $apW50 = parcelRequire("apW50");

var $cVUvp = parcelRequire("cVUvp");

var $jCTRv = parcelRequire("jCTRv");

var $a77G6 = parcelRequire("a77G6");

var $adOB0 = parcelRequire("adOB0");
parcelRequire("9OkzG");

var $aDvrI = parcelRequire("aDvrI");

var $kmQNP = parcelRequire("kmQNP");
const $c8753a22f51ce46f$var$_excluded = [
    "reactReduxForwardedRef"
];
let $c8753a22f51ce46f$var$useSyncExternalStore = (0, $kmQNP.notInitialized);
const $c8753a22f51ce46f$export$36d45daa6a4925b8 = (fn)=>{
    $c8753a22f51ce46f$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $c8753a22f51ce46f$var$EMPTY_ARRAY = [
    null,
    0
];
const $c8753a22f51ce46f$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $c8753a22f51ce46f$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $c8753a22f51ce46f$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $a77G6.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $c8753a22f51ce46f$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $c8753a22f51ce46f$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $c8753a22f51ce46f$var$initStateUpdates = ()=>$c8753a22f51ce46f$var$EMPTY_ARRAY;
function $c8753a22f51ce46f$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $c8753a22f51ce46f$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $c8753a22f51ce46f$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $c8753a22f51ce46f$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $adOB0.default), areStatePropsEqual: areStatePropsEqual = (0, $adOB0.default), areMergedPropsEqual: areMergedPropsEqual = (0, $adOB0.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $aDvrI.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $apW50.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $i39UI.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $cVUvp.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $81g6h.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $cnuf2.default)(props, $c8753a22f51ce46f$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $81g6h.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $7Jr1S.isContextConsumer)(/*#__PURE__*/ $81g6h.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $81g6h.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $81g6h.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $6UftH.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $81g6h.useMemo(()=>{
                if (!shouldHandleStateChanges) return $c8753a22f51ce46f$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $jCTRv.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $81g6h.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $6JG9D.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $81g6h.useRef();
            const lastWrapperProps = $81g6h.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $81g6h.useRef();
            const renderIsScheduled = $81g6h.useRef(false);
            const isProcessingDispatch = $81g6h.useRef(false);
            const isMounted = $81g6h.useRef(false);
            const latestSubscriptionCallbackError = $81g6h.useRef();
            (0, $a77G6.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $81g6h.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $81g6h.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $c8753a22f51ce46f$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $c8753a22f51ce46f$var$useIsomorphicLayoutEffectWithArgs($c8753a22f51ce46f$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $c8753a22f51ce46f$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $a77G6.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $81g6h.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $81g6h.createElement(WrappedComponent, (0, $6JG9D.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $81g6h.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $81g6h.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $81g6h.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $81g6h.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $81g6h.createElement(Connect, (0, $6JG9D.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($khy2w)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($khy2w)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $c8753a22f51ce46f$export$2e2bcd8739ae039 = $c8753a22f51ce46f$var$connect;

});
parcelRegister("7Jr1S", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8AGcJ"));

});
parcelRegister("8AGcJ", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $64126c7187f95448$export$a7c73072b1a182ae, (v) => $64126c7187f95448$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $64126c7187f95448$export$9f27bc3417b4524d, (v) => $64126c7187f95448$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $64126c7187f95448$export$db77ccec0bb4ccac, (v) => $64126c7187f95448$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $64126c7187f95448$export$8392c0c9d3dcbd35, (v) => $64126c7187f95448$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $64126c7187f95448$export$ffb0004e005737fa, (v) => $64126c7187f95448$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $64126c7187f95448$export$b624eff549462981, (v) => $64126c7187f95448$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $64126c7187f95448$export$7897aa7841a5380c, (v) => $64126c7187f95448$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $64126c7187f95448$export$602eac185826482c, (v) => $64126c7187f95448$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $64126c7187f95448$export$e2c29f18771995cb, (v) => $64126c7187f95448$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $64126c7187f95448$export$5f8d39834fd61797, (v) => $64126c7187f95448$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $64126c7187f95448$export$74bf444e3cd11ea5, (v) => $64126c7187f95448$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $64126c7187f95448$export$998bcd577473dd93, (v) => $64126c7187f95448$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $64126c7187f95448$export$92387174baf9b227, (v) => $64126c7187f95448$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $64126c7187f95448$export$ec112efeb987d9c6, (v) => $64126c7187f95448$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $64126c7187f95448$export$b706b080d889d2c9, (v) => $64126c7187f95448$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $64126c7187f95448$export$5be5a87408f70ddc, (v) => $64126c7187f95448$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $64126c7187f95448$export$45a5e7f76e0caa8d, (v) => $64126c7187f95448$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $64126c7187f95448$export$455c2e768291efa6, (v) => $64126c7187f95448$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $64126c7187f95448$export$9522e17588c12572, (v) => $64126c7187f95448$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $64126c7187f95448$export$2110ac352bb060b9, (v) => $64126c7187f95448$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $64126c7187f95448$export$56885ab8b9c456ab, (v) => $64126c7187f95448$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $64126c7187f95448$export$d927fcb6adf8f9de, (v) => $64126c7187f95448$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $64126c7187f95448$export$b82d16f27459e05a, (v) => $64126c7187f95448$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $64126c7187f95448$export$522c17b4f5e123e8, (v) => $64126c7187f95448$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $64126c7187f95448$export$1aabd8a0274ecfd6, (v) => $64126c7187f95448$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $64126c7187f95448$export$3d6c20d97e46b957, (v) => $64126c7187f95448$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $64126c7187f95448$export$9b621391a187a31a, (v) => $64126c7187f95448$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $64126c7187f95448$export$f5bbd400c2f4426f, (v) => $64126c7187f95448$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $64126c7187f95448$export$a7c73072b1a182ae;
var $64126c7187f95448$export$9f27bc3417b4524d;
var $64126c7187f95448$export$db77ccec0bb4ccac;
var $64126c7187f95448$export$8392c0c9d3dcbd35;
var $64126c7187f95448$export$ffb0004e005737fa;
var $64126c7187f95448$export$b624eff549462981;
var $64126c7187f95448$export$7897aa7841a5380c;
var $64126c7187f95448$export$602eac185826482c;
var $64126c7187f95448$export$e2c29f18771995cb;
var $64126c7187f95448$export$5f8d39834fd61797;
var $64126c7187f95448$export$74bf444e3cd11ea5;
var $64126c7187f95448$export$998bcd577473dd93;
var $64126c7187f95448$export$92387174baf9b227;
var $64126c7187f95448$export$ec112efeb987d9c6;
var $64126c7187f95448$export$b706b080d889d2c9;
var $64126c7187f95448$export$5be5a87408f70ddc;
var $64126c7187f95448$export$45a5e7f76e0caa8d;
var $64126c7187f95448$export$455c2e768291efa6;
var $64126c7187f95448$export$9522e17588c12572;
var $64126c7187f95448$export$2110ac352bb060b9;
var $64126c7187f95448$export$56885ab8b9c456ab;
var $64126c7187f95448$export$d927fcb6adf8f9de;
var $64126c7187f95448$export$b82d16f27459e05a;
var $64126c7187f95448$export$522c17b4f5e123e8;
var $64126c7187f95448$export$1aabd8a0274ecfd6;
var $64126c7187f95448$export$3d6c20d97e46b957;
var $64126c7187f95448$export$9b621391a187a31a;
var $64126c7187f95448$export$f5bbd400c2f4426f;
"use strict";
var $64126c7187f95448$var$b = Symbol.for("react.element"), $64126c7187f95448$var$c = Symbol.for("react.portal"), $64126c7187f95448$var$d = Symbol.for("react.fragment"), $64126c7187f95448$var$e = Symbol.for("react.strict_mode"), $64126c7187f95448$var$f = Symbol.for("react.profiler"), $64126c7187f95448$var$g = Symbol.for("react.provider"), $64126c7187f95448$var$h = Symbol.for("react.context"), $64126c7187f95448$var$k = Symbol.for("react.server_context"), $64126c7187f95448$var$l = Symbol.for("react.forward_ref"), $64126c7187f95448$var$m = Symbol.for("react.suspense"), $64126c7187f95448$var$n = Symbol.for("react.suspense_list"), $64126c7187f95448$var$p = Symbol.for("react.memo"), $64126c7187f95448$var$q = Symbol.for("react.lazy"), $64126c7187f95448$var$t = Symbol.for("react.offscreen"), $64126c7187f95448$var$u;
$64126c7187f95448$var$u = Symbol.for("react.module.reference");
function $64126c7187f95448$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $64126c7187f95448$var$b:
                switch(a = a.type, a){
                    case $64126c7187f95448$var$d:
                    case $64126c7187f95448$var$f:
                    case $64126c7187f95448$var$e:
                    case $64126c7187f95448$var$m:
                    case $64126c7187f95448$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $64126c7187f95448$var$k:
                            case $64126c7187f95448$var$h:
                            case $64126c7187f95448$var$l:
                            case $64126c7187f95448$var$q:
                            case $64126c7187f95448$var$p:
                            case $64126c7187f95448$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $64126c7187f95448$var$c:
                return r;
        }
    }
}
$64126c7187f95448$export$a7c73072b1a182ae = $64126c7187f95448$var$h;
$64126c7187f95448$export$9f27bc3417b4524d = $64126c7187f95448$var$g;
$64126c7187f95448$export$db77ccec0bb4ccac = $64126c7187f95448$var$b;
$64126c7187f95448$export$8392c0c9d3dcbd35 = $64126c7187f95448$var$l;
$64126c7187f95448$export$ffb0004e005737fa = $64126c7187f95448$var$d;
$64126c7187f95448$export$b624eff549462981 = $64126c7187f95448$var$q;
$64126c7187f95448$export$7897aa7841a5380c = $64126c7187f95448$var$p;
$64126c7187f95448$export$602eac185826482c = $64126c7187f95448$var$c;
$64126c7187f95448$export$e2c29f18771995cb = $64126c7187f95448$var$f;
$64126c7187f95448$export$5f8d39834fd61797 = $64126c7187f95448$var$e;
$64126c7187f95448$export$74bf444e3cd11ea5 = $64126c7187f95448$var$m;
$64126c7187f95448$export$998bcd577473dd93 = $64126c7187f95448$var$n;
$64126c7187f95448$export$92387174baf9b227 = function() {
    return !1;
};
$64126c7187f95448$export$ec112efeb987d9c6 = function() {
    return !1;
};
$64126c7187f95448$export$b706b080d889d2c9 = function(a) {
    return $64126c7187f95448$var$v(a) === $64126c7187f95448$var$h;
};
$64126c7187f95448$export$5be5a87408f70ddc = function(a) {
    return $64126c7187f95448$var$v(a) === $64126c7187f95448$var$g;
};
$64126c7187f95448$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $64126c7187f95448$var$b;
};
$64126c7187f95448$export$455c2e768291efa6 = function(a) {
    return $64126c7187f95448$var$v(a) === $64126c7187f95448$var$l;
};
$64126c7187f95448$export$9522e17588c12572 = function(a) {
    return $64126c7187f95448$var$v(a) === $64126c7187f95448$var$d;
};
$64126c7187f95448$export$2110ac352bb060b9 = function(a) {
    return $64126c7187f95448$var$v(a) === $64126c7187f95448$var$q;
};
$64126c7187f95448$export$56885ab8b9c456ab = function(a) {
    return $64126c7187f95448$var$v(a) === $64126c7187f95448$var$p;
};
$64126c7187f95448$export$d927fcb6adf8f9de = function(a) {
    return $64126c7187f95448$var$v(a) === $64126c7187f95448$var$c;
};
$64126c7187f95448$export$b82d16f27459e05a = function(a) {
    return $64126c7187f95448$var$v(a) === $64126c7187f95448$var$f;
};
$64126c7187f95448$export$522c17b4f5e123e8 = function(a) {
    return $64126c7187f95448$var$v(a) === $64126c7187f95448$var$e;
};
$64126c7187f95448$export$1aabd8a0274ecfd6 = function(a) {
    return $64126c7187f95448$var$v(a) === $64126c7187f95448$var$m;
};
$64126c7187f95448$export$3d6c20d97e46b957 = function(a) {
    return $64126c7187f95448$var$v(a) === $64126c7187f95448$var$n;
};
$64126c7187f95448$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $64126c7187f95448$var$d || a === $64126c7187f95448$var$f || a === $64126c7187f95448$var$e || a === $64126c7187f95448$var$m || a === $64126c7187f95448$var$n || a === $64126c7187f95448$var$t || "object" === typeof a && null !== a && (a.$$typeof === $64126c7187f95448$var$q || a.$$typeof === $64126c7187f95448$var$p || a.$$typeof === $64126c7187f95448$var$g || a.$$typeof === $64126c7187f95448$var$h || a.$$typeof === $64126c7187f95448$var$l || a.$$typeof === $64126c7187f95448$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$64126c7187f95448$export$f5bbd400c2f4426f = $64126c7187f95448$var$v;

});


parcelRegister("6UftH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5073faa39823d1fc$export$2e2bcd8739ae039);

var $cnuf2 = parcelRequire("cnuf2");
parcelRequire("6iXMX");
const $5073faa39823d1fc$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $5073faa39823d1fc$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $5073faa39823d1fc$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $cnuf2.default)(_ref, $5073faa39823d1fc$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $5073faa39823d1fc$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("6iXMX", function(module, exports) {

var $9OkzG = parcelRequire("9OkzG");
function $4972cd49cfee6de0$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $9OkzG.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $4972cd49cfee6de0$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $4972cd49cfee6de0$var$verify(mapStateToProps, "mapStateToProps");
    $4972cd49cfee6de0$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $4972cd49cfee6de0$var$verify(mergeProps, "mergeProps");
}

});
parcelRegister("9OkzG", function(module, exports) {

$parcel$export(module.exports, "default", () => $7248be3f1355b13f$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $7248be3f1355b13f$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("i39UI", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", () => $d240327444b196f0$export$b69a785ceac019a6);

var $eMzFI = parcelRequire("eMzFI");

var $8LJNR = parcelRequire("8LJNR");

var $5Bz4g = parcelRequire("5Bz4g");
function $d240327444b196f0$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $8LJNR.wrapMapToPropsConstant)((dispatch)=>(0, $eMzFI.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $8LJNR.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $8LJNR.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : (0, $5Bz4g.createInvalidArgFactory)(mapDispatchToProps, "mapDispatchToProps");
}

});
parcelRegister("eMzFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac31380aca98e6a9$export$2e2bcd8739ae039);
function $ac31380aca98e6a9$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("8LJNR", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $66263e14e76c8de7$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $66263e14e76c8de7$export$8d46c7f53c8c602f);
parcelRequire("l0vc3");
function $66263e14e76c8de7$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $66263e14e76c8de7$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $66263e14e76c8de7$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $66263e14e76c8de7$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $66263e14e76c8de7$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("l0vc3", function(module, exports) {

var $8ADq4 = parcelRequire("8ADq4");

var $9OkzG = parcelRequire("9OkzG");
function $f4b1cb706bdb44e8$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $8ADq4.default)(value)) (0, $9OkzG.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("8ADq4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6410436e3a2da8a0$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $6410436e3a2da8a0$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("5Bz4g", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", () => $414b9c2a2923c545$export$19ef7b929f7e2559);
function $414b9c2a2923c545$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("apW50", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", () => $79594aa103eb3de0$export$e00e93951827eda7);

var $8LJNR = parcelRequire("8LJNR");

var $5Bz4g = parcelRequire("5Bz4g");
function $79594aa103eb3de0$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $8LJNR.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === "function" ? (0, $8LJNR.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : (0, $5Bz4g.createInvalidArgFactory)(mapStateToProps, "mapStateToProps");
}

});

parcelRegister("cVUvp", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", () => $96a6a3be4ff4020e$export$17457cf6fa742f84);

var $6JG9D = parcelRequire("6JG9D");
parcelRequire("l0vc3");

var $5Bz4g = parcelRequire("5Bz4g");
function $96a6a3be4ff4020e$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $6JG9D.default)({}, ownProps, stateProps, dispatchProps);
}
function $96a6a3be4ff4020e$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $96a6a3be4ff4020e$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$96a6a3be4ff4020e$export$691c327fc30bc857 : typeof mergeProps === "function" ? $96a6a3be4ff4020e$export$5b105939c84b5234(mergeProps) : (0, $5Bz4g.createInvalidArgFactory)(mergeProps, "mergeProps");
}

});

parcelRegister("jCTRv", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $e49ce5fb4deaa709$export$d567d2b9af322f8f);

var $irisY = parcelRequire("irisY");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $e49ce5fb4deaa709$var$createListenerCollection() {
    const batch = (0, $irisY.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $e49ce5fb4deaa709$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $e49ce5fb4deaa709$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $e49ce5fb4deaa709$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $e49ce5fb4deaa709$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $e49ce5fb4deaa709$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("a77G6", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $75d0838481bcfc34$export$700979bc83e7db82);

var $81g6h = parcelRequire("81g6h");
const $75d0838481bcfc34$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $75d0838481bcfc34$export$700979bc83e7db82 = $75d0838481bcfc34$export$71594e8a50f746f4 ? $81g6h.useLayoutEffect : $81g6h.useEffect;

});

parcelRegister("adOB0", function(module, exports) {

$parcel$export(module.exports, "default", () => $77125d956bb39151$export$2e2bcd8739ae039);
function $77125d956bb39151$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $77125d956bb39151$export$2e2bcd8739ae039(objA, objB) {
    if ($77125d956bb39151$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$77125d956bb39151$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("B85Hq", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("duc3X")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("hd224")).default);

var $duc3X = parcelRequire("duc3X");

var $hd224 = parcelRequire("hd224");

var $aDvrI = parcelRequire("aDvrI");

var $iSwzC = parcelRequire("iSwzC");

var $5lAxT = parcelRequire("5lAxT");

var $1ppRl = parcelRequire("1ppRl");

var $adOB0 = parcelRequire("adOB0");
parcelRequire("eEBCi");

});
parcelRegister("duc3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d176f1f58b2423f$export$2e2bcd8739ae039);

var $81g6h = parcelRequire("81g6h");

var $aDvrI = parcelRequire("aDvrI");

var $jCTRv = parcelRequire("jCTRv");

var $a77G6 = parcelRequire("a77G6");
function $9d176f1f58b2423f$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $81g6h.useMemo(()=>{
        const subscription = (0, $jCTRv.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $81g6h.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $a77G6.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $aDvrI.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $81g6h.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $9d176f1f58b2423f$export$2e2bcd8739ae039 = $9d176f1f58b2423f$var$Provider;

});

parcelRegister("iSwzC", function(module, exports) {

var $aDvrI = parcelRequire("aDvrI");

var $1ppRl = parcelRequire("1ppRl");
function $dbe689918f00b208$export$bc9b55530897c558(context = (0, $aDvrI.ReactReduxContext)) {
    const useStore = context === (0, $aDvrI.ReactReduxContext) ? (0, $1ppRl.useStore) : (0, $1ppRl.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $dbe689918f00b208$export$8ad76b76a4c905f8 = /*#__PURE__*/ $dbe689918f00b208$export$bc9b55530897c558();

});
parcelRegister("1ppRl", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $106c2f5ca08eb989$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $106c2f5ca08eb989$export$6ccbb43953eebf8);

var $aDvrI = parcelRequire("aDvrI");

var $bn91s = parcelRequire("bn91s");
function $106c2f5ca08eb989$export$671dba69185d0304(context = (0, $aDvrI.ReactReduxContext)) {
    const useReduxContext = context === (0, $aDvrI.ReactReduxContext) ? (0, $bn91s.useReduxContext) : (0, $bn91s.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $106c2f5ca08eb989$export$6ccbb43953eebf8 = /*#__PURE__*/ $106c2f5ca08eb989$export$671dba69185d0304();

});


parcelRegister("eEBCi", function(module, exports) {

});



parcelRegister("g3Edw", function(module, exports) {

$parcel$export(module.exports, "useMemo", () => $bb0c1f685b5fce97$export$1538c33de8887b59);
$parcel$export(module.exports, "useCallback", () => $bb0c1f685b5fce97$export$35808ee640e87ca7);

var $81g6h = parcelRequire("81g6h");
function $bb0c1f685b5fce97$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $bb0c1f685b5fce97$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $81g6h.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $81g6h.useRef)(true);
    var committed = (0, $81g6h.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $bb0c1f685b5fce97$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $81g6h.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $bb0c1f685b5fce97$export$33752cf3ee811995(callback, inputs) {
    return $bb0c1f685b5fce97$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $bb0c1f685b5fce97$export$1538c33de8887b59 = $bb0c1f685b5fce97$export$b6feb8998cd9b342;
var $bb0c1f685b5fce97$export$35808ee640e87ca7 = $bb0c1f685b5fce97$export$33752cf3ee811995;

});

parcelRegister("kZLuh", function(module, exports) {

$parcel$export(module.exports, "getRect", () => $f48e572eefb8ff12$export$4b834cebd9e5cebe);
$parcel$export(module.exports, "expand", () => $f48e572eefb8ff12$export$9f77e0932fb78f72);
$parcel$export(module.exports, "createBox", () => $f48e572eefb8ff12$export$6459fc9e86be362e);
$parcel$export(module.exports, "offset", () => $f48e572eefb8ff12$export$cc800923e997bb8);
$parcel$export(module.exports, "withScroll", () => $f48e572eefb8ff12$export$1d0caec378d7d0ae);
$parcel$export(module.exports, "calculateBox", () => $f48e572eefb8ff12$export$b8dfc5d4e552b8e1);
$parcel$export(module.exports, "getBox", () => $f48e572eefb8ff12$export$34928e660d2a8702);

var $6Woii = parcelRequire("6Woii");
var $f48e572eefb8ff12$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $f48e572eefb8ff12$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $f48e572eefb8ff12$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $f48e572eefb8ff12$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $f48e572eefb8ff12$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $f48e572eefb8ff12$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $f48e572eefb8ff12$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $f48e572eefb8ff12$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $f48e572eefb8ff12$var$noSpacing : _ref2$padding;
    var marginBox = $f48e572eefb8ff12$export$4b834cebd9e5cebe($f48e572eefb8ff12$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $f48e572eefb8ff12$export$4b834cebd9e5cebe($f48e572eefb8ff12$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $f48e572eefb8ff12$export$4b834cebd9e5cebe($f48e572eefb8ff12$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $f48e572eefb8ff12$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $f48e572eefb8ff12$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== "px") return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $6Woii.default)(false);
    return result;
};
var $f48e572eefb8ff12$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $f48e572eefb8ff12$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $f48e572eefb8ff12$var$shift(borderBox, change);
    return $f48e572eefb8ff12$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $f48e572eefb8ff12$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $f48e572eefb8ff12$var$getWindowScroll();
    return $f48e572eefb8ff12$export$cc800923e997bb8(original, scroll);
};
var $f48e572eefb8ff12$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $f48e572eefb8ff12$var$parse(styles.marginTop),
        right: $f48e572eefb8ff12$var$parse(styles.marginRight),
        bottom: $f48e572eefb8ff12$var$parse(styles.marginBottom),
        left: $f48e572eefb8ff12$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $f48e572eefb8ff12$var$parse(styles.paddingTop),
        right: $f48e572eefb8ff12$var$parse(styles.paddingRight),
        bottom: $f48e572eefb8ff12$var$parse(styles.paddingBottom),
        left: $f48e572eefb8ff12$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $f48e572eefb8ff12$var$parse(styles.borderTopWidth),
        right: $f48e572eefb8ff12$var$parse(styles.borderRightWidth),
        bottom: $f48e572eefb8ff12$var$parse(styles.borderBottomWidth),
        left: $f48e572eefb8ff12$var$parse(styles.borderLeftWidth)
    };
    return $f48e572eefb8ff12$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $f48e572eefb8ff12$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $f48e572eefb8ff12$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});
parcelRegister("6Woii", function(module, exports) {

$parcel$export(module.exports, "default", () => $014ddadb88bd0eda$export$2e2bcd8739ae039);
var $014ddadb88bd0eda$var$isProduction = true;
var $014ddadb88bd0eda$var$prefix = "Invariant failed";
function $014ddadb88bd0eda$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($014ddadb88bd0eda$var$isProduction) throw new Error($014ddadb88bd0eda$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($014ddadb88bd0eda$var$prefix, ": ").concat(provided) : $014ddadb88bd0eda$var$prefix;
    throw new Error(value);
}

});


parcelRegister("6iviE", function(module, exports) {

$parcel$export(module.exports, "default", () => $012eea2112f522a9$export$2e2bcd8739ae039);
var $012eea2112f522a9$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $012eea2112f522a9$var$isEqual(first, second) {
    if (first === second) return true;
    if ($012eea2112f522a9$var$safeIsNaN(first) && $012eea2112f522a9$var$safeIsNaN(second)) return true;
    return false;
}
function $012eea2112f522a9$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$012eea2112f522a9$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $012eea2112f522a9$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $012eea2112f522a9$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});

parcelRegister("ed8xX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a588e8c3f79115dc$export$2e2bcd8739ae039);
var $a588e8c3f79115dc$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $a588e8c3f79115dc$export$2e2bcd8739ae039 = $a588e8c3f79115dc$var$rafSchd;

});


parcelRegister("kIsT0", function(module, exports) {

$parcel$export(module.exports, "useTolerantTouchSensor", () => $212c8adba7a3718a$export$df1ebc7728fa20ed);
/**
 * Custom touch sensor for @hello-pangea/dnd that tolerates slight finger
 * movement during the long-press phase before cancelling the drag.
 *
 * The default useTouchSensor cancels the drag on any touchmove during the
 * 120 ms pending window. On tablets fingers naturally tremble a few pixels,
 * so the drag is killed before it ever starts.
 *
 * This sensor allows up to MOVEMENT_TOLERANCE_PX of movement before treating
 * the gesture as a scroll. While within tolerance it calls
 * event.preventDefault() to suppress native scrolling.
 */ 
var $81g6h = parcelRequire("81g6h");
const $212c8adba7a3718a$var$LONG_PRESS_DELAY_MS = 120;
const $212c8adba7a3718a$var$MOVEMENT_TOLERANCE_PX = 8;
const $212c8adba7a3718a$var$IDLE = {
    type: "IDLE"
};
const $212c8adba7a3718a$var$CAP = {
    capture: true,
    passive: false
};
const $212c8adba7a3718a$var$CAP_REMOVE_BUBBLE = {
    capture: false
};
function $212c8adba7a3718a$var$addEvent(name, fn, opts) {
    window.addEventListener(name, fn, opts);
    return ()=>window.removeEventListener(name, fn, opts);
}
function $212c8adba7a3718a$export$df1ebc7728fa20ed(api) {
    const phaseRef = (0, $81g6h.useRef)($212c8adba7a3718a$var$IDLE);
    const unbindRef = (0, $81g6h.useRef)(null);
    // eslint-disable-next-line sonarjs/cognitive-complexity
    (0, $81g6h.useLayoutEffect)(()=>{
        // Use an object so methods can mutually reference each other without
        // circular `const` issues — method bodies are resolved at call time.
        const ctx = {
            stop () {
                const cur = phaseRef.current;
                if (cur.type === "IDLE") return;
                if (cur.type === "PENDING") clearTimeout(cur.timerId);
                phaseRef.current = $212c8adba7a3718a$var$IDLE;
                unbindRef.current?.();
                unbindRef.current = null;
                ctx.listenForCapture();
            },
            cancel () {
                const cur = phaseRef.current;
                ctx.stop();
                if (cur.type === "DRAGGING") cur.actions.cancel({
                    shouldBlockNextClick: true
                });
                if (cur.type === "PENDING") cur.actions.abort();
            },
            startDragging () {
                const cur = phaseRef.current;
                if (cur.type !== "PENDING") return;
                phaseRef.current = {
                    type: "DRAGGING",
                    actions: cur.actions.fluidLift(cur.point)
                };
            },
            onTouchMove (e) {
                const te = e;
                const cur = phaseRef.current;
                if (te.touches.length === 0) {
                    ctx.cancel();
                    return;
                }
                if (cur.type === "PENDING") {
                    const dx = Math.abs(te.touches[0].clientX - cur.point.x);
                    const dy = Math.abs(te.touches[0].clientY - cur.point.y);
                    if (dx <= $212c8adba7a3718a$var$MOVEMENT_TOLERANCE_PX && dy <= $212c8adba7a3718a$var$MOVEMENT_TOLERANCE_PX) {
                        e.preventDefault(); // block native scroll while waiting for long-press
                        return;
                    }
                    ctx.cancel(); // finger moved too far — treat as scroll
                    return;
                }
                if (cur.type !== "DRAGGING") {
                    ctx.cancel();
                    return;
                }
                e.preventDefault();
                cur.actions.move({
                    x: te.touches[0].clientX,
                    y: te.touches[0].clientY
                });
            },
            onTouchEnd (e) {
                const cur = phaseRef.current;
                if (cur.type !== "DRAGGING") {
                    ctx.cancel();
                    return;
                }
                e.preventDefault();
                cur.actions.drop({
                    shouldBlockNextClick: true
                });
                ctx.stop();
            },
            onTouchCancel (e) {
                if (phaseRef.current.type !== "DRAGGING") {
                    ctx.cancel();
                    return;
                }
                e.preventDefault();
                ctx.cancel();
            },
            bindDragEvents () {
                const unbinders = [
                    $212c8adba7a3718a$var$addEvent("touchmove", ctx.onTouchMove, {
                        capture: false,
                        passive: false
                    }),
                    $212c8adba7a3718a$var$addEvent("touchend", ctx.onTouchEnd, $212c8adba7a3718a$var$CAP),
                    $212c8adba7a3718a$var$addEvent("touchcancel", ctx.onTouchCancel, $212c8adba7a3718a$var$CAP),
                    $212c8adba7a3718a$var$addEvent("contextmenu", (e)=>e.preventDefault(), $212c8adba7a3718a$var$CAP),
                    $212c8adba7a3718a$var$addEvent("orientationchange", ctx.cancel, $212c8adba7a3718a$var$CAP),
                    $212c8adba7a3718a$var$addEvent("resize", ctx.cancel, $212c8adba7a3718a$var$CAP),
                    $212c8adba7a3718a$var$addEvent("visibilitychange", ctx.cancel, $212c8adba7a3718a$var$CAP),
                    $212c8adba7a3718a$var$addEvent("keydown", (e)=>{
                        if (e.key === "Escape") e.preventDefault();
                        ctx.cancel();
                    }, $212c8adba7a3718a$var$CAP)
                ];
                unbindRef.current = ()=>unbinders.forEach((u)=>u());
            },
            onTouchStart (e) {
                const te = e;
                if (te.defaultPrevented) return;
                if (te.touches.length === 0) return;
                const draggableId = api.findClosestDraggableId(te);
                if (!draggableId) return;
                const actions = api.tryGetLock(draggableId, ctx.cancel, {
                    sourceEvent: te
                });
                if (!actions) return;
                const { clientX: clientX, clientY: clientY } = te.touches[0];
                // Disarm the touchstart listener before binding drag-phase listeners.
                unbindRef.current?.();
                unbindRef.current = null;
                const timerId = setTimeout(()=>ctx.startDragging(), $212c8adba7a3718a$var$LONG_PRESS_DELAY_MS);
                phaseRef.current = {
                    type: "PENDING",
                    point: {
                        x: clientX,
                        y: clientY
                    },
                    actions: actions,
                    timerId: timerId
                };
                ctx.bindDragEvents();
            },
            listenForCapture () {
                unbindRef.current = $212c8adba7a3718a$var$addEvent("touchstart", ctx.onTouchStart, $212c8adba7a3718a$var$CAP);
            }
        };
        ctx.listenForCapture();
        return ()=>{
            unbindRef.current?.();
            unbindRef.current = null;
            const cur = phaseRef.current;
            if (cur.type === "PENDING") {
                clearTimeout(cur.timerId);
                cur.actions.abort();
                phaseRef.current = $212c8adba7a3718a$var$IDLE;
            } else if (cur.type === "DRAGGING") {
                cur.actions.cancel({
                    shouldBlockNextClick: true
                });
                phaseRef.current = $212c8adba7a3718a$var$IDLE;
            }
        };
    // api is a stable object provided by DragDropContext — [] is intentional.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Safari/WebKit hack: a non-passive touchmove listener on window is needed
    // so that event.preventDefault() inside dynamically-added handlers actually works.
    // https://github.com/atlassian/react-beautiful-dnd/issues/1374
    (0, $81g6h.useLayoutEffect)(()=>{
        const noop = ()=>{};
        window.addEventListener("touchmove", noop, {
            capture: false,
            passive: false
        });
        return ()=>window.removeEventListener("touchmove", noop, $212c8adba7a3718a$var$CAP_REMOVE_BUBBLE);
    }, []);
}

});




parcelRegister("ffhEE", function(module, exports) {

$parcel$export(module.exports, "DraggableExerciseCard", () => $7ef8bf474b54fee5$export$8a081294a939d2c5);
$parcel$export(module.exports, "ExerciseCard", () => $7ef8bf474b54fee5$export$14c51e3613113aa7);

var $iKObn = parcelRequire("iKObn");

var $5gMb7 = parcelRequire("5gMb7");

var $TSc86 = parcelRequire("TSc86");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $hLaGu = parcelRequire("hLaGu");

var $bFakw = parcelRequire("bFakw");

var $kVPyX = parcelRequire("kVPyX");

var $a6fIt = parcelRequire("a6fIt");

var $5UMQ1 = parcelRequire("5UMQ1");

var $ikMhW = parcelRequire("ikMhW");

var $243Cr = parcelRequire("243Cr");

var $5kXMA = parcelRequire("5kXMA");

var $lfEOz = parcelRequire("lfEOz");

var $41NLE = parcelRequire("41NLE");

var $62Ten = parcelRequire("62Ten");

var $9R5kn = parcelRequire("9R5kn");

var $5IWhl = parcelRequire("5IWhl");

var $a59kI = parcelRequire("a59kI");

var $7qSPp = parcelRequire("7qSPp");

var $3cSmf = parcelRequire("3cSmf");

var $3Sk1U = parcelRequire("3Sk1U");

var $keCmP = parcelRequire("keCmP");

var $isRr9 = parcelRequire("isRr9");

var $iglNQ = parcelRequire("iglNQ");

var $g8ETz = parcelRequire("g8ETz");

var $1IWnK = parcelRequire("1IWnK");

var $kKnoQ = parcelRequire("kKnoQ");

var $5WGN2 = parcelRequire("5WGN2");

var $lTdpc = parcelRequire("lTdpc");

var $dU78w = parcelRequire("dU78w");

var $81g6h = parcelRequire("81g6h");

var $9d072 = parcelRequire("9d072");

var $6Sita = parcelRequire("6Sita");
const $7ef8bf474b54fee5$var$COMMENT_LOTTIE_DELAY = 150; // in ms
const $7ef8bf474b54fee5$export$8a081294a939d2c5 = ({ exercise: exercise, uiStyle: uiStyle, index: index, shouldAnimate: shouldAnimate, copy: copy, showAlternatives: showAlternatives = true, onlyAllowPreview: onlyAllowPreview, programEditor: programEditor, className: className, onClick: onClick, onCommentIconClick: onCommentIconClick, updatedExerciseId: updatedExerciseId })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $a59kI.DraggableCard), {
        exercise: exercise,
        index: index,
        renderCard: ({ cardStyle: cardStyle, overriddenUiStyle: overriddenUiStyle, provided: provided, snapshot: snapshot })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($7ef8bf474b54fee5$export$14c51e3613113aa7, {
                        ref: provided.innerRef,
                        ...provided.draggableProps,
                        ...provided.dragHandleProps,
                        className: className,
                        style: cardStyle,
                        onClick: onClick,
                        onCommentIconClick: onCommentIconClick,
                        shouldAnimate: shouldAnimate,
                        exercise: exercise,
                        programEditor: programEditor,
                        showAlternatives: showAlternatives,
                        onlyAllowPreview: onlyAllowPreview,
                        uiStyle: overriddenUiStyle ?? uiStyle,
                        id: exercise.draggableId,
                        isDragging: snapshot.isDragging,
                        draggable: true,
                        updatedExerciseId: updatedExerciseId
                    }),
                    copy && snapshot.isDragging && /*#__PURE__*/ (0, $iKObn.jsx)($7ef8bf474b54fee5$export$14c51e3613113aa7, {
                        exercise: exercise,
                        uiStyle: uiStyle
                    })
                ]
            })
    });
const $7ef8bf474b54fee5$export$14c51e3613113aa7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ uiStyle: uiStyle = "card", deviceType: deviceType = (0, $5kXMA.ResponsiveDeviceType).Desktop, exercise: exercise, shouldAnimate: shouldAnimate, draggable: draggable = false, isDragging: isDragging = false, showAlternatives: showAlternatives = true, hideContent: hideContent = false, onlyAllowPreview: onlyAllowPreview, onClick: onClick, onCommentIconClick: onCommentIconClick, Options: Options, Footer: Footer, updateExercise: updateExercise, updatedExerciseId: updatedExerciseId, disabled: disabled = false, ...props }, ref)=>{
    // use a state instead of css to reset popup menu inside ExerciseOptions
    const dragAndDropContext = (0, $81g6h.useContext)((0, $41NLE.ExerciseDragAndDropContext));
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    (0, $81g6h.useContext)((0, $keCmP.OnboardingContext));
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const { format: format } = (0, $1eHG3.useI18n)();
    const { formatExerciseBodyPart: formatExerciseBodyPart, formatExerciseCategory: formatExerciseCategory } = (0, $kVPyX.useExerciseFormatter)();
    const [isOver, setIsOver] = (0, $81g6h.useState)(false);
    const [initialComment] = (0, $81g6h.useState)(exercise.comment);
    const lottieRef = (0, $81g6h.useRef)(null);
    // Alternative onboarding removed; no per-exercise onboarding state needed
    const isComplementaryTooltipVisible = (0, $1IWnK.useObservable)((0, $iglNQ.complementaryTooltipVisible));
    const fallbackFirstExerciseId$ = (0, $81g6h.useMemo)(()=>(0, $1IWnK.observable)(undefined), []);
    const firstExerciseDraggableId = (0, $1IWnK.useObservable)(dragAndDropContext ? dragAndDropContext.programEditor.firstExerciseDraggableId : fallbackFirstExerciseId$);
    const showComplementaryHere = isComplementaryTooltipVisible && firstExerciseDraggableId === exercise.draggableId;
    const saveExercise = (0, $81g6h.useCallback)((newExercise)=>(0, $lTdpc.isNotNil)(updateExercise) ? updateExercise(newExercise) : (0, $hLaGu.isMainExercise)(newExercise) && dragAndDropContext?.programEditor.editExercise(exercise.draggableId, newExercise), [
        dragAndDropContext?.programEditor,
        exercise,
        updateExercise
    ]);
    const onAlternativeExerciseSave = (0, $81g6h.useCallback)(async (newExercise)=>{
        saveExercise(newExercise);
        await (0, $ghfIB.libraryFilterManager).clearLibraryFiltersAndSearch();
    }, [
        saveExercise
    ]);
    const onClickAddAlternativesButton = (0, $81g6h.useCallback)(async (mainExercise)=>{
        const filteredBodyParts = [
            exercise.primaryBodyPart,
            ...exercise.secondaryBodyParts
        ];
        (0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited.set(mainExercise);
        (0, $ghfIB.libraryFilterManager).activeCategoryFilters.set([
            (0, $6Sita.createBodyPartsFilter)(filteredBodyParts, format("exercise.bodyPart.title"), formatExerciseBodyPart),
            (0, $6Sita.createCategoriesFilter)([
                exercise.category
            ], format("exercise.category.title"), formatExerciseCategory)
        ]);
        (0, $ghfIB.libraryFilterManager).setIsAlternativeExerciseActive();
        isDesktop ? dragAndDropContext?.programEditor.setExerciseWithAlternativesEdited(mainExercise) : dialogContext?.openModal((0, $243Cr.ModalId).MobileAlternativeExercise, {
            exercise: mainExercise,
            onSave: (e)=>{
                onAlternativeExerciseSave(e);
            }
        });
        (0, $bFakw.sendAnalyticsEventOpenAlternativeExercises)(exercise);
        (0, $9d072.hideAlternativeHalo)();
    }, [
        exercise,
        format,
        formatExerciseBodyPart,
        formatExerciseCategory,
        isDesktop,
        dragAndDropContext?.programEditor,
        dialogContext,
        onAlternativeExerciseSave
    ]);
    const renderExerciseOptions = (0, $81g6h.useCallback)(()=>{
        if ((0, $lTdpc.isNotNil)(Options)) return Options;
        else return /*#__PURE__*/ (0, $iKObn.jsx)($7ef8bf474b54fee5$var$ExerciseOptionsContainerFit, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $g8ETz.OnboardingTooltip), {
                placement: "bottom",
                visible: showComplementaryHere,
                onClose: (e)=>{
                    (0, $iglNQ.hideComplementaryTooltip)();
                    e.stopPropagation();
                },
                onClickOutside: ()=>(0, $iglNQ.hideComplementaryTooltip)(),
                onHidden: ()=>(0, $iglNQ.hideComplementaryTooltip)(),
                onboardingStep: (0, $isRr9.OnboardingProgramQuickstartStep).COMPLEMENTARY_EXERCISES_GUIDE_01,
                children: /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                    style: {
                        display: "inline-block"
                    },
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $3Sk1U.ExerciseOptions), {
                        exercise: exercise,
                        onlyAllowPreview: onlyAllowPreview,
                        shouldDisplayHalo: showComplementaryHere
                    })
                })
            })
        });
    }, [
        Options,
        showComplementaryHere,
        exercise,
        onlyAllowPreview
    ]);
    const renderMobileFooter = (0, $81g6h.useCallback)(()=>{
        if (deviceType !== (0, $5kXMA.ResponsiveDeviceType).Mobile) return null;
        if ((0, $lTdpc.isNotNil)(Footer)) return Footer;
        else return /*#__PURE__*/ (0, $iKObn.jsx)((0, $g8ETz.OnboardingTooltip), {
            placement: "bottom",
            visible: showComplementaryHere,
            onClose: (e)=>{
                (0, $iglNQ.hideComplementaryTooltip)();
                e.stopPropagation();
            },
            onClickOutside: ()=>(0, $iglNQ.hideComplementaryTooltip)(),
            onHidden: ()=>(0, $iglNQ.hideComplementaryTooltip)(),
            onboardingStep: (0, $isRr9.OnboardingProgramQuickstartStep).COMPLEMENTARY_EXERCISES_GUIDE_01,
            children: /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                style: {
                    display: "inline-block",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $3cSmf.ExerciseFooterOptions), {
                    exercise: exercise,
                    onlyAllowPreview: onlyAllowPreview,
                    shouldDisplayHalo: showComplementaryHere
                })
            })
        });
    }, [
        Footer,
        deviceType,
        exercise,
        onlyAllowPreview,
        showComplementaryHere
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($7ef8bf474b54fee5$var$ExerciseContainer, {
        "data-test": (0, $a6fIt.e2eTestId).createTemplatePage.exerciseContainer,
        id: exercise.draggableId,
        ref: ref,
        ...props,
        style: {
            ...props.style,
            ...draggable && {
                touchAction: "none"
            }
        },
        layoutId: shouldAnimate ? exercise.draggableId : undefined,
        onMouseEnter: (e)=>{
            setIsOver(true);
            props.onMouseEnter?.(e);
        },
        onMouseLeave: (e)=>{
            setIsOver(false);
            props.onMouseLeave?.(e);
        },
        onTooltipDisplayed: showComplementaryHere,
        children: uiStyle === "row" ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $5IWhl.RowExerciseCard), {
            exercise: exercise,
            onClick: onClick,
            disabled: disabled
        }) : /*#__PURE__*/ (0, $iKObn.jsxs)($7ef8bf474b54fee5$var$CardExerciseContainer, {
            isOver: isOver,
            draggable: draggable,
            isDragging: isDragging,
            children: [
                exercise.comment && /*#__PURE__*/ (0, $iKObn.jsx)($7ef8bf474b54fee5$var$ContainerCommentIcon, {
                    onClick: (event)=>{
                        event.stopPropagation();
                        onCommentIconClick?.();
                    },
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($7ef8bf474b54fee5$var$StyledPlayer, {
                        onEvent: async (event)=>{
                            if (event === (0, $ikMhW.PlayerEvent).Load) {
                                if (initialComment === exercise.comment) lottieRef.current?.setSeeker((0, (/*@__PURE__*/$parcel$interopDefault($5gMb7))).op - 1, false);
                                else {
                                    await (0, $TSc86.delay)($7ef8bf474b54fee5$var$COMMENT_LOTTIE_DELAY);
                                    lottieRef.current?.play();
                                }
                            }
                        },
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5gMb7))),
                        ref: lottieRef,
                        keepLastFrame: true
                    })
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $9R5kn.ExerciseCardHeader), {
                    exercise: exercise,
                    onClick: onClick
                }),
                !hideContent && /*#__PURE__*/ (0, $iKObn.jsxs)($7ef8bf474b54fee5$var$ExerciseCardContent, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $7qSPp.ExerciseDetails), {
                            exercise: exercise,
                            withArrows: deviceType === (0, $5kXMA.ResponsiveDeviceType).Desktop,
                            updateExercise: saveExercise
                        }),
                        deviceType === (0, $5kXMA.ResponsiveDeviceType).Desktop && /*#__PURE__*/ (0, $iKObn.jsx)($7ef8bf474b54fee5$var$ExerciseOptionsContainer, {
                            children: (isOver || showComplementaryHere) && renderExerciseOptions()
                        })
                    ]
                }),
                showAlternatives && (0, $hLaGu.isMainExercise)(exercise) && /*#__PURE__*/ (0, $iKObn.jsx)((0, $62Ten.AddAlternativesButton), {
                    alternatives: exercise.alternativeExercises,
                    onClick: ()=>onClickAddAlternativesButton(exercise),
                    shouldAnimateSuccess: exercise.draggableId === updatedExerciseId,
                    shouldDisplayHalo: firstExerciseDraggableId === exercise.draggableId
                }),
                renderMobileFooter()
            ]
        })
    });
});
$7ef8bf474b54fee5$export$14c51e3613113aa7.displayName = "ExerciseCard";
const $7ef8bf474b54fee5$var$ExerciseContainer = (0, $5UMQ1.default)((0, $dU78w.motion).div)`
	user-select: none;
	/* Bump z-index a bit more when any onboarding tooltip is displayed to avoid card overlap */
	z-index: ${({ onTooltipDisplayed: onTooltipDisplayed })=>onTooltipDisplayed ? 5 : 0};
`;
const $7ef8bf474b54fee5$var$getOutlineColor = (isOver, isDragging)=>{
    if (isDragging) return (0, $kKnoQ.colors).primary;
    if (isOver) return (0, $kKnoQ.colors).primary25;
    return "transparent";
};
const $7ef8bf474b54fee5$var$CardExerciseContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(12, "flexstart", "stretch")};
	flex: none;
	border-radius: 8px;
	position: relative;
	outline: ${(0, $lfEOz.CARD_BORDER_SIZE)}px solid ${({ isOver: isOver, isDragging: isDragging })=>$7ef8bf474b54fee5$var$getOutlineColor(isOver, isDragging)};
	padding-top: 24px;
	padding-bottom: 16px;
	background: ${(0, $kKnoQ.colors).white};
	transform: ${({ isDragging: isDragging })=>isDragging ? "rotate(-2deg)" : "rotate(0deg)"};
	transition: transform 300ms ease-in-out;
	cursor: ${({ draggable: draggable })=>draggable ? "grab" : "not-allowed"};
	touch-action: ${({ draggable: draggable })=>draggable ? "none" : "auto"};
`;
const $7ef8bf474b54fee5$var$ContainerCommentIcon = (0, $5UMQ1.default).div`
	position: absolute;
	top: -10px;
	left: -10px;
	padding: 14px;
	cursor: pointer;
`;
const $7ef8bf474b54fee5$var$StyledPlayer = (0, $5UMQ1.default)((0, $ikMhW.Player))`
	width: 16px;
	height: 16px;
`;
const $7ef8bf474b54fee5$var$ExerciseCardContent = (0, $5UMQ1.default).div`
	display: grid;
	grid-auto-flow: column;
	grid-template-columns: 1fr auto;
	align-items: center;
	padding: 0 16px;
`;
const $7ef8bf474b54fee5$var$ExerciseOptionsContainer = (0, $5UMQ1.default).div`
	width: 24px;
`;
const $7ef8bf474b54fee5$var$ExerciseOptionsContainerFit = (0, $5UMQ1.default).div`
	width: fit-content;
`;

});
parcelRegister("5gMb7", function(module, exports) {
module.exports = JSON.parse('{"v":"4.8.0","meta":{"g":"LottieFiles AE 3.0.2","a":"","k":"","d":"","tc":""},"fr":24,"ip":0,"op":120,"w":800,"h":800,"nm":"Composition 1","ddd":0,"assets":[{"id":"image_0","w":8000,"h":8000,"u":"","p":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAH0AAAB9ACAYAAAAG8a30AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAgAElEQVR4nOzBAQEAAACAkP6v7ggKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACA2YMDAQAAAAAg/9dGUFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVSbs+U0AACAASURBVFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVWEPDgQAAAAAgPxfG0FVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVWFPTgQAAAAAADyf20EVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVtX8EswAAIABJREFUVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVFfbgQAAAAAAAyP+1EVRVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVXYgwMBAAAAACD/10ZQVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVWqFTM8AAAgAElEQVRVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVYQ8OBAAAAACA/F8bQVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVYW9O8iN21qwMHwuKXcya04FOEhpBa4dPC7AgLgDewfvbaV30NpBGQg8ZnZAr0AVOICn1bOHqMj7Bu0kduIYcSKbKun7RuQlWXV28AMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA919ZewAAAAAAcBr64c0mSfLT3KWpXVtqV+em++WFpm5+viyl+fa9j2vZvH9f379/V8kfPwMAAAAAAAAAAAAAAAAAAAAAAAAAgPvlkJrDB5+Usv/9Wf31rC7/V/P229oeUpdDkpR2Ocy1/P/5Ug75r/aQ/Psw7i4+/D8AAAAAAB8ggA4AAAAAD0Q/XHfJ111+mru2XTa/xMubuilJl9L8d5Kklk1J7WpNl5IuSfeRnwUAAAAAAAAAAAAAAAAAAAAAAAAAAE5Jzb6UHGreRtLfRtVrXX5Ikixl/0tE/W1Afdyd79eaCwAAAACsQwAdAAAAAE5YP7zZvBc0fzdmXssmtW6SJCWbNXcCAAAAAAAAAAAAAAAAAAAAAAAAAAAn75CaQ0rZJ0lK3de6/JDaHkpz3P8aTL/Zj7uLw7pTAQAAAIC/SwAdAAAAAO6gfrju8tOjzXth89J8m1q61LpNSZekW3snAAAAAAAAAAAAAAAAAAAAAAAAAADAB9Xs38bSD8n8Q00OpdTp51D6+PLxtPZEAAAAAOCPCaADAAAAwBfWD9dd8nXXzjfb38TNN6l1k5LN2hsBAAAAAAAAAAAAAAAAAAAAAAAAAAC+gENS3obQ51e1tvvSHPdzLYecne3H3fl+1XUAAAAA8IAJoAMAAADAZ9APbza/DZyXmm1NNkm6tfcBAAAAAAAAAAAAAAAAAAAAAAAAAACcgpJMNeWQUvd1Ka9+DaQfp3F3cVh7HwAAAADcVwLoAAAAAPAX/RI5X842pcybpP02tW5Tsll7GwAAAAAAAAAAAAAAAAAAAAAAAAAAwANwSMqU5FAzvyqlTuLoAAAAAHA7BNABAAAA4CP64brL8WzbLGVTmroVOQcAAAAAAAAAAAAAAAAAAAAAAAAAADgJv4+jz81+fPl4WnsYAAAAAJwCAXQAAAAASNIPbzbtfLOty9mmNPVJqdnWZJOkW3sbAAAAAAAAAAAAAAAAAAAAAAAAAAAAt6ckU005JPOrlDrOtRxydpzG3cVh7W0AAAAAcFcIoAMAAADwoPTDdZfj2bap7VboHAAAAAAAAAAAAAAAAAAAAAAAAAAAgJ/9Low+N/vx5eNp7V0AAAAAsAYBdAAAAADurX54s2l+mvvS1G3SPknqNkLnAAAAAAAAAAAAAAAAAAAAAAAAAAAAfIK3YfR9rfl+KfOUs7P9uDvfr70LAAAAAD4nAXQAAAAATl4/XHc5nm2b2m5LU59kSZ+Szdq7AAAAAAAAAAAAAAAAAAAAAAAAAAAAuLcOSZmS+VVKHee52Y8vH09rjwIAAACA2yKADgAAAMBJETsHAAAAAAAAAAAAAAAAAAAAAAAAAADgjhJFBwAAAODeEEAHAAAA4M4SOwcAAAAAAAAAAAAAAAAAAAAAAAAAAODEiaIDAAAAcJIE0AEAAAC4M/rhzaa5qUMp8ya1uRQ7BwAAAAAAAAAAAAAAAAAAAAAAAAAA4B46JGWqmb9fkjFnx2ncXRzWHgUAAAAA7xJABwAAAGAV/XDd5Xi2bZMhaZ8kdZukW3sXAAAAAAAAAAAAAAAAAAAAAAAAAAAAfGklmWrKvpblxVLrfvzum3HtTQAAAAA8bALoAAAAAHwR/fBm09zUoZR5k9pcpmSz9iYAAAAAAAAAAAAAAAAAAAAAAAAAAAC4ow5JmZL51Zzscnacxt3FYe1RAAAAADwcAugAAAAAfBb909d9U9ttKflHUvsk3dqbAAAAAAAAAAAAAAAAAAAAAAAAAAAA4FSVZKolUzK/mNtH07g736+9CQAAAID7SwAdAAAAgL+tH667HM+2b4Pnl0ndRvAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAPpuSTDVlX8vyYpkzjS8fT2tvAgAAAOD+EEAHAAAA4JP9HDxvkyFpnyS1X3sTAAAAAAAAAAAAAAAAAAAAAAAAAAAAPGg1+5QyCaIDAAAAcBsE0AEAAAD4U/qnr/umtttScil4DgAAAAAAAAAAAAAAAAAAAAAAAAAAAHfcu0H0th3H3fl+7UkAAAAAnA4BdAAAAAA+6DfB822Sbu1NAAAAAAAAAAAAAAAAAAAAAAAAAAAAwF9TkqmWTMn8Ym4fTYLoAAAAAHyMADoAAAAASZJ+uIXIHSYAACAASURBVO6am6+el6Y+Sc0QwXMAAAAAAAAAAAAAAAAAAAAAAAAAAAC4x8qYzK/mZJez4zTuLg5rLwIAAADg7hBABwAAAHig+uG6y/Fs2yZDanOZks3amwAAAAAAAAAAAAAAAAAAAAAAAAAAAIBVHJIy1bJcLXOm8eXjae1BAAAAAKxLAB0AAADgAemHH7fNTdOXksuk9mvvAQAAAAAAAAAAAAAAAAAAAAAAAAAAAO6gmn2ajMn8Ym4fTePufL/2JAAAAAC+LAF0AAAAgHusH667zG3f1tInzbMk3dqbAAAAAAAAAAAAAAAAAAAAAAAAAAAAgFNTxlrzYqnLOL58PK29BgAAAIDPTwAdAAAA4J7phzeb5qYOpeQyqf3aewAAAAAAAAAAAAAAAAAAAAAAAAAAAIB7pGafJuNcl6ucHadxd3FYexIAAAAAt08AHQAAAOAe6J++7ttkSG0uU7JZew8AAAAAAAAAAAAAAAAAAAAAAAAAAADwUJSxluVqadtx3J3v114DAAAAwO0QQAcAAAA4Qf1w3WVu+zbtZWqGJN3amwAAAAAAAAAAAAAAAAAAAAAAAAAAAICHrSTTkma35Pj9+N0349p7AAAAAPjrBNABAAAATkQ/XHfNzVfPS8llUvu19wAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8oZp9moxzXa7E0AEAAABOjwA6AAAAwB3WDz9um5umFz0HAAAAAAAAAAAAAAAAAAAAAAAAAAAATlbNPqVMKceruZ3HcXdxWHsSAAAAAB8ngA4AAABwx/RPX/dNzv5RsgxJtmvvAQAAAAAAAAAAAAAAAAAAAAAAAAAAALhFh6RMtSxXS9uO4+58v/YgAAAAAH5PAB0AAADgDuifvu7bZEiaZ0m6tfcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfBllFEMHAAAAuHsE0AEAAABWInoOAAAAAAAAAAAAAAAAAAAAAAAAAAAA8C4xdAAAAIC7QgAdAAAA4AsSPQcAAAAAAAAAAAAAAAAAAAAAAAAAAAD4M8TQAQAAANYkgA4AAADwmfXDj9vm2F6WLP+K6DkAAAAAAAAAAAAAAAAAAAAAAAAAAADAJxJDBwAAAPjSBNABAAAAPoN+uO6a49f/LFmGJNu19wAAAAAAAAAAAAAAAAAAAAAAAAAAAADcD2WXcrya23kcdxeHtdcAAAAA3FcC6AAAAAC3pB+uu+bmq+el5DKp/dp7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAO6tmn2ajHNdrsbvvhnXngMAAABw3wigAwAAAPwN/XDdNfOjodTmmeg5AAAAAAAAAAAAAAAAAAAAAAAAAAAAwArE0AEAAABunQA6AAAAwF/QP33dt6U8Ty2XSbq19wAAAAAAAAAAAAAAAAAAAAAAAAAAAACQlGSqaf93Pqsvxt35fu09AAAAAKdKAB0AAADgT+qHH7ftsT5PmmcRPQcAAAAAAAAAAAAAAAAAAAAAAAAAAAC448pYy3K1tO0ohg4AAADwaQTQAQAAAD6iH6675uar56XkMqn92nsAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+GSHlOzmulyN330zrj0GAAAA4BQIoAMAAAB8QP/0dd+m/WdSh7W3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAHBLavalKbtjW/5n3J3v154DAAAAcFcJoAMAAAC81Q9vNs0xz0qWfyXp1t4DAAAAAAAAAAAAAAAAAAAAAAAAAAAAwOdUxlqWq6W92Y27i8PaawAAAADuEgF0AAAA4EHrh+uumR8NpTbPktqvvQcAgP+wdzfHcZz5AYf/bzdZ1hHX2SKqRhFIITQBnbyD2lEEACMAFQFmIiAYAYEINC5hdTPQGZgZsEtEcXhklXWQC+h+fbDX693VSvwA8c7H80Twy+AHAAAAAAAAAAAAAAAAAAAAAAAAAHDPcnRRRdvn4by92G1L5wAAAACsAgN0AAAAYCs1k9dNHTGNqA4jYqd0DwAAAAAAAAAAAAAAAAAAAAAAAAAAAADlpYiXQ8rPh7pu28WoK90DAAAAUIoBOgAAALA1mumrnermX45Sij9F5KZ0DwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAr612kWPR5OG8vdtvSMQAAAAD3zQAdAAAA2HjN5HVTR0wjqsOI2CndAwAAAAAAAAAAAAAAAAAAAAAAAAAAAMD6SBEvh5SfD3XdtotRV7oHAAAA4D4YoAMAAAAbqZm+2qn6h9OUq8OI3JTuAQAAAAAAAAAAAAAAAAAAAAAAAAAAAGDtvYsUiz4P5+3Fbls6BgAAAOBzMkAHAAAANkozXY7r29unEdVhROyU7gEAAAAAAAAAAAAAAAAAAAAAAAAAAABgE6U2p+F8qOu2XYy60jUAAAAAd80AHQAAANgIzcFP0zo/OI7ITekWAAAAAAAAAAAAAAAAAAAAAAAAAAAAALZEji6qaPu6mhuhAwAAAJvEAB0AAABYW8301U51+8VxiuFpROyU7gEAAAAAAAAAAAAAAAAAAAAAAAAAAABgm6W2j37eXuy2pUsAAAAAPpUBOgAAALB2msnrpk7pKHI6LN0CAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH8jRxepPu0f5H9rF6OudA4AAADAxzBABwAAANbG3sH1UcrVYURuSrcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwO94FykWfZ+ftz8+elk6BgAAAOBDGKADAAAAK62Zvtqpbr84TjE8jYid0j0AAAAAAAAAAAAAAAAAAAAAAAAAAAAA8OFS20c/by9229IlAAAAAO/DAB0AAABYSc30+uu6j6eR02HpFgAAAAAAAAAAAAAAAAAAAAAAAAAAAAC4Ezm6XOX5UNdtuxh1pXMAAAAA/hkDdAAAAGClNJPXTR31SURuSrcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwGeRo4sq2r6u5kboAAAAwCoyQAcAAABWwt7B9VEa0kmkGJduAQAAAAAAAAAAAAAAAAAAAAAAAAAAAIB7k+Ksz8N5e7Hblk4BAAAA+AsDdAAAAKCYZvpqp7r94jjF8DQidkr3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAEA5qe2jnxuhAwAAAKvAAB0AAAC4d810Oa77fhY5/SmMzwEAAAAAAAAAAAAAAAAAAAAAAAAAAADgr3J0ucrzyx8enZVOAQAAALaXAToAAABwb5rJ66ZO6ShyOizdAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAArLUeXU3U2PIjzdjHqSucAAAAA28UAHQAAAPjsmsnrpo76JCI3pVsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYK3k6KKKtq+ruRE6AAAAcF8M0AEAAIDPZu/g+ijldBwRX5duAQAAAAAAAAAAAAAAAAAAAAAAAAAAAIC1l+LMCB0AAAC4DwboAAAAwJ3bO7g+SkM6iRTj0i0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAsHFSnPV5OG8vdtvSKQAAAMBmMkAHAAAA7kQzfbVT3X5xnPJwZHwOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPchtX30cyN0AAAA4K4ZoAMAAACf5P/G5zE8jYid0j0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAsH2M0AEAAIC7ZYAOAAAAfBTjcwAAAAAAAAAAAAAAAAAAAAAAAAAAAABYNanNaTi//OHRWekSAAAAYL0ZoAMAAAAfxPgcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFZcji5XeW6EDgAAAHwsA3QAAADgvRifAwAAAAAAAAAAAAAAAAAAAAAAAAAAAMCaMUIHAAAAPpIBOgAAAPCbjM8BAAAAAAAAAAAAAAAAAAAAAAAAAAAAYM0ZoQMAAAAfyAAdAAAA+FXG5wAAAAAAAAAAAAAAAAAAAAAAAAAAAACwYYzQAQAAgPdkgA4AAAD8DeNzAAAAAAAAAAAAAAAAAAAAAAAAAAAAANhwRugAAADA7zBABwAAACLC+BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAto4ROgAAAPBPGKADAADAljM+BwAAAAAAAAAAAAAAAAAAAAAAAAAAAIBtl9o++nl7sduWLgEAAABWgwE6AAAAbCnjcwAAAAAAAAAAAAAAAAAAAAAAAAAAAADgbxmhAwAAAP/DAB0AAAC20N7B9VEa0kmkGJduAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABWjRE6AAAAbDsDdAAAANgixucAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwHtLcdbX1bxdjLrSKQAAAMD9MkAHAACALdBMXjd1rl4YnwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH8wIHQAAALaOAToAAABssGbyuqmjPonITekWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGC95ahmw4M4N0IHAACAzWeADgAAABuomS7Hdd/PIqfD0i0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAbJ0eVUnRmhAwAAwGYzQAcAAIANYnwOAAAAAAAAAAAAAAAAAAAAAAAAAAAAANyLHF2u8vzyh0dnpVMAAACAu2eADgAAABugmb7aqW6/OE4xPI2IndI9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAMCWyNH1aXjSXuy2pVMAAACAu2OADgAAAGtu7+D6KA3pJFKMS7cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANsqtf0wfNf++Ohl6RIAAADg0xmgAwAAwJpqJq+bOlcvjM8BAAAAAAAAAAAAAAAAAAAAAAAAAAAAgJWR4qyvq3m7GHWlUwAAAICPZ4AOAAAAa6aZLsf1bX4RkZvSLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAv+Jdjup0eBDnRugAAACwngzQAQAAYE000+W47vtZ5HRYugUAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4Hfl6HKV55c/PDornQIAAAB8GAN0AAAAWAN7k+VJiuFpROyUbgEAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+CA5uj4NT9qL3bZ0CgAAAPB+DNABAABghe0dXB+lIZ1EinHpFgAAAAAAAAAAAAAAAAAAAAAAAAAAAACAT5MW/YP0XbsYdaVLAAAAgN9mgA4AAAArqJkux/VtfhGRm9ItAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB3KUc1Gx7EuRE6AAAArC4DdAAAAFghzXQ5rvt+Fjkdlm4BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPhscnS5yvPLHx6dlU4BAAAA/pEBOgAAAKyI/cnb44h+FhE7pVsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAO5DyvHyNg3ftRe7bekWAAAA4K8M0AEAAKCwZvK6qXP1IlKMS7cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABSR4qyvq3m7GHWlUwAAAAADdAAAACimmS7Hdd/PIqfD0i0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMXl6HKqzi4vRvPSKQAAALDtDNABAACggL3J8iTF8DQidkq3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAACslBxdn4Yn7cVuWzoFAAAAtpUBOgAAANyj/YOfpjHUzyLFuHQLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBKS3HW19W8XYy60ikAAACwbQzQAQAA4B400+W47vtZ5HRYugUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYG3k6HKqzi4vRvPSKQAAALBNDNABAADgM9ufvD2O6GcRsVO6BQAAAAAAAAAAAAAAAAAAAAAAAAAAAABgLeXo+jQ8aS9229IpAAAAsA0M0AEAAOAzaSavmzpXLyLFuHQLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBGSHHW19W8XYy60ikAAACwyQzQAQAA4I410+W47vtZ5HRYugUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYOPk6HKk55d//sNp6RQAAADYVAboAAAAcIf2Dq6PUk7PImKndAsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwCZLOV7ePqy+bRejrnQLAAAAbBoDdAAAALgDzXQ5rm/zi4jclG4BAAAAAAAAAAAAAAAAAAAAAAAAAAAAANgmOarZ8CDOjdABAADg7higAwAAwCfaO3jzLOX8tHQHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMDWytFFlb779x/+sCidAgAAAJvAAB0AAAA+UjN53dS5ehEpxqVbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIiBRnfV3N28WoK50CAAAA68wAHQAAAD5QM12O676fRU6HpVsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPg7Oboc6fnln/9wWjoFAAAA1pUBOgAAAHyAvYProzSkk0gxLt0CAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBvSW3/ID1pF6OudAkAAACsGwN0AAAAeA/NdDmub/OziDwt3QIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwHt7l6M6vbwYzUuHAAAAwDoxQAcAAIDfsT95exzRzyJip3QLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfIUfX5/xt++Ojl6VTAAAAYB0YoAMAAMA/0UyX4/q2X0Skr0q3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADw6XJUs+HnX5637ZfvSrcAAADAKjNABwAAgF+xP3l7HNGflu4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOCO5ej6NDxpL3bb0ikAAACwqgzQAQAA4P9ppstxfTNcRYpx6RYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD6fHNVseBDn7WLUlW4BAACAVWOADgAAAP/rm8nyJMcwK90BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMA9ydH1aXjSXuy2pVMAAABglRigAwAAsPWa6XJc3wxXkWJcugUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgPuXo5oND+K8XYy60i0AAACwCgzQAQAA2GrfTJYnOYZZ6Q4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArL0fVpeNJe7LalUwAAAKA0A3QAAAC2UjNdjuub4SpSjEu3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwOnJUs+FBnLeLUVe6BQAAAEoxQAcAAGDrfDNZnuQYZqU7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYUTm6Pg1P2ovdtnQKAAAAlGCADgAAwNZopstxfdsvItJXpVsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFh9OarZ8PMvz9v2y3elWwAAAOA+GaADAACwFfYnb48j+tPSHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArJkcXZ/zt+2Pj16WTgEAAID7YoAOAADARmumy3F9m19E5KZ0CwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA6ytHNbu8GM1LdwAAAMB9MEAHAABgY+0dXB+lnJ5FxE7pFgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1l/K8fL2YfVtuxh1pVsAAADgczJABwAAYOM00+W47vtZ5HRYugUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgI3zLkd1enkxmpcOAQAAgM/FAB0AAICNsn/w0zSG+lmkGJduAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABgk6VF/yB91y5GXekSAAAAuGtV6QAAAAC4K3sHb55Frr83PwcAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4PPL0/pmuNo7uD4qXQIAAAB3LZUOAAAAgE/VTJfj+ma4Mj4HAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKCEHNVseBDn7WLUlW4BAACAu2CADgAAwFrbn7w9juhPS3cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALDlcnR9zt+2Pz56WToFAAAAPpUBOgAAAGupmS7H9W1+FpGnpVsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAvclSzy4vRvHQHAAAAfAoDdAAAANbO/sFP0xjqZ5FiXLoFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD+Xsrx8vZh9W27GHWlWwAAAOBjVKUDAAAA4EPsHbx5Frn+3vwcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBVlVN8Xd8MV3sH10elWwAAAOBjpNIBAAAA8D6a6XJc3wxXxucAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKyTHNVs+PmX52375bvSLQAAAPC+DNABAABYefuTt8cR/Swidkq3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAB8vR9Q+rx+1i1JVOAQAAgPdhgA4AAMDKaqavdur+4WnkdFi6BQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPtG7HNXp5cVoXjoEAAAAfo8BOgAAACupmS7H9c1wFSnGpVsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOCupJROb+v0vF2MutItAAAA8M8YoAMAALBy9idvjyP609IdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwWeTo+ofVYxN0AAAAVpUBOgAAACujmS7H9W1+FpGnpVsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAze5ejOr28GM1LhwAAAMDfM0AHAABgJTTT66/rm/R9pBiXbgEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgPuSUjq9rdPzdjHqSrcAAADAXxigAwAAUNw3k+VJjmFWugMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIrI0fUPq8cm6AAAAKwKA3QAAACKaaavdur+4WnkdFi6BQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACnuXozq9vBjNS4cAAACAAToAAABFNNPluL4ZriLFuHQLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACsipTS6W2dnreLUVe6BQAAgO1lgA4AAMC925+8PY7oT0t3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADASsrR9Q+rxyboAAAAlFKVDgAAAGC77B9cn5mfAwAAAAAAAAAAAAAAAAAAAAAAAAAAAADAb0gxrm+H/9j745unpVMAAADYTql0AAAAANuhmS7H9c1wFSnGpVsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGBd5Khmw8+/PG/bL9+VbgEAAGB7GKADAADw2e0f/DSNXL+IiJ3SLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsHZydP3D6nG7GHWlUwAAANgOVekAAAAANts3k+VJ5Pr7MD8HAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICPk2Jc3wxX+wdvpqVTAAAA2A6pdAAAAACbqZkux/VtfhGRm9ItAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwKXJUs8uL0bx0BwAAAJvNAB0AAIA710yX4/pmuIoU49ItAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwcVKc9XU1bxejrnQKAAAAm8kAHQAAgDu1P3l7HNGflu4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICNlqPrH1aPTdABAAD4HKrSAQAAAGyOvYM3z8zPAQAAAAAAAAAAAAAAAAAAAAAAAAAAAADgHqQY1zfD1d4f3zwtnQIAAMDmSaUDAAAAWH/NdDmub/tFRPqqdAsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGybHNXs8mI0L90BAADA5jBABwAA4JM00+W4vhmuIsW4dAsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGyvtOgfpO/axagrXQIAAMD6M0AHAADgo+1P3h5H9KelOwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgIjI0fUPq8cm6AAAAHyqqnQAAAAA6+mbyfLE/BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFZIinF9M1ztHVwflU4BAABgvaXSAQAAAKyXZroc17f5RURuSrcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC/Lkc1u7wYzUt3AAAAsJ4M0AEAAHhvzXQ5rm+Gq0gxLt0CAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8tpTS6e1//te8bb98V7oFAACA9WKADgAAwHvZP/hpGrl+ERE7pVsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAID3lKPrH1aP28WoK50CAADA+qhKBwAAALD6vpksTyLX34f5OQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArJcU4/pmuGr+9frr0ikAAACsDwN0AAAAftPewZtnOYZZ6Q4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAjpRjXVbramyxPSqcAAACwHlLpAAAAAFZTM12O69t+EZG+Kt0CAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADcjRzV7PJiNC/dAQAAwGozQAcAAOAfNNPluL4ZriLFuHQL8N/s3U9yG+edxvH37TYzXjhV3HIqlWqfYDQ3aJLYBazCnMDyCWSfANAJpBvQNxCroskuAm4g30AoieWeJaviLGwC/c7CdmInkq0/IH4N4PM5wXf/LB4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAgA3L6av1377/crH49CY6BQAAgGFygA4AAMAvnF+8nKRSX6aUjqNbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAO1LScn1UnS6uTpbRKQAAAAxPFR0AAADAcIzG3TSV+klyfg4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPstp6a+7eftpGuiUwAAABgeB+gAAACklH44Py+pn0V3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAW5JTU6/652cX1/ejUwAAABiWHB0AAABArHbSNfWqXKZU2ugWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgRknV7NnTk4fRVwbuXgAAIABJREFUHQAAAAyDA3QAAIAD1k66pr7t5ymnJroFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACI5QQdAACAnzhABwAAOFDOzwEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgH+Xr9Yf5S8XVyfL6BIAAADiOEAHAAA4QOcXLyep1E+iOwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAEqabk+qk6doAMAAByuKjoAAACA7RqNu6nzcwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4I1yaurbft5OuiY6BQAAgBgO0AEAAA7IaNxNS+pn0R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMDA/XiCfn7xchKdAgAAwPbl6AAAAAC24/zi+qtU8mfRHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwG4pqZo9e3ryMLoDAACA7XGADgAAsOfaSdfUq/VVSvm/olsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDd5AQdAADgsDhABwAA2GPtpGvq236ecmqiWwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgN3mBB0AAOBwOEAHAADYU87PAQAAAAAAAAAAAAAAAAAAAAAAAAAAAACAzctX64/yl4urk2V0CQAAAHfHAToAAMAeGo1ftSVVT1JKx9EtAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAnilpuT6qTp2gAwAA7K8qOgAAAIDNOh//34OSqnlyfg4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAANyFnJr6tp+3k66JTgEAAOBuOEAHAADYI6NxN01p/Ti6AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA2HNO0AEAAPaaA3QAAIA9MRp305L6WXQHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwIH48QT+/eDmJTgEAAGCzcnQAAAAAH875OQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEOimpOrxs6cnD6NDAAAA2AwH6AAAADvufPzNPKXSRncAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACHraRq5gQdAABgPzhABwAA2FHtpGvq236ecmqiWwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFJygg4AALAvHKADAADsIOfnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAUDlBBwAA2H0O0AEAAHaM83MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGDocs6PV3/77uFi8elNdAsAAADvzgE6AADADnF+DgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7I58tf72u8+doAMAAOweB+gAAAA7wvk5AAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwc0paro+q08XVyTI6BQAAgLfnAB0AAGAHjMav2pKqeXQHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAO3OCDgAAsHOq6AAAAAB+3fnFy4nzcwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYGfl1NS3/byddE10CgAAAG/HAToAAMCAjcbdNJX6SXQHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAB3GCDgAAsFNydAAAAACvNxp305L6WXQHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAxpS0XB9Vp4urk2V0CgAAAG/mAB0AAGCAnJ8DAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB7ywk6AADA4FXRAQAAAPyS83MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGCv5dTUt/28Hb9qo1MAAAB4vRwdAAAAwD85PwcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7ITcrrz//65z9eRYcAAADwSw7QAQAABsL5OQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcICcoAMAAAyQA3QAAIABcH4OAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcMCfoAAAAA1NFBwAAABw65+cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMCBO06lfnI27qbRIQAAAPwgRwcAAAAcMufnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/1RSNXv29ORhdAcAAMChc4AOAAAQ5Pzi+qtU8mfRHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEPiBB0AACCeA3QAAIAA5+Nv5imVNroDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgiJygAwAAxHKADgAAsGXOzwEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH6bE3QAAIA4DtABAAC2yPk5AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA23OCDgAAEMMBOgAAwJY4PwcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHh3TtABAAC2zwE6AADAFjg/BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeH9O0AEAALbLAToAAMAdc34OAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADw4ZygAwAAbI8DdAAAgDvk/BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGBznKADAABshwN0AACAO+L8HAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYPOcoAMAANy9KjoAAABgH43G3dT5OQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwObl1M/Oxt00ugMAAGCf5egAAACAfTMad9OS+ll0BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwD4rqZo9e3ryMLoDAABgHzlABwAA2CDn5wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANtTSv7y2f/+5+PoDgAAgH3jAB0AAGBDnJ8DAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABs3U3K68//+uc/XkWHAAAA7BMH6AAAABvg/BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACCME3QAAIANc4AOAADwgZyfAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhHOCDgAAsEEO0AEAAD6A83MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDBuFl/VP334upkGR0CAACw66roAAAAgF3l/BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGBQjuvbft5OuiY6BAAAYNfl6AAAAIBd5PwcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgoEparo+q08XVyTI6BQAAYFc5QAcAAHhHzs8BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGzgk6AADAB3GADgAA8A5G41dtSdU8ugMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDf4AQdAADgvTlABwAAeEvOzwEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHaME3QAAID34gAdAADgLbSTrqlX/fOU0nF0CwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAO/ACToAAMA7q6IDAAAAhq6ddE1928+T83MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDdk1NTr8qjtn3hewIAAOAt5egAAACAIfvH+XlOTXQLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHyJfrb/97vPF4tOb6BIAAIChq6IDAAAAhsr5OQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwD4pk+qTjx9EVwAAAOyCHB0AAAAwRM7PAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA9lNJ1ezZ05OH0R0AAABDVkUHAAAADFG9KpfOzwEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPZPTv3sbNxNozsAAACGzAE6AADAvzgff/MkpdJGdwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHA3nKADAAD8OgfoAAAAPzMad9OUyiS6AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgLuVUz87v3jppwIAAOA1HKADAAD8aDTupiX1s+gOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtqTUl+34VRudAQAAMDQ5OgAAAGAInJ8DAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcqJKW66PqdHF1soxOAQAAGAoH6AAAwME7u7i+n0u+jO4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgiBN0AACAX3CADgAAHLR2cn2vXuXn0R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEc4IOAADwD1V0AAAAQJR20jX1bX4S3QEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAA5NTUq3LZti+Oo1MAAACiOUAHAAAO0g/n5/085dREtwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAUpa1//7tH0RUAAADRHKADAAAHx/k5AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAb1TS/bNxN43OAAAAiOQAHQAAODj1qlw6PwcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOBNcupnTtABAIBD5gAdAAA4KKOL60cplTa6AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgGHLqZ+dXVzfj+4AAACI4AAdAAA4GKNxNy0lfxHdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwG7IJT9qx6/a6A4AAIBty9EBAAAA2zAad9OS+ll0BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADumpOX6qDpdXJ0so1MAAAC2xQE6AACw90bjV21J1Ty6AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgB3lBB0AADgwVXQAAADAXWonXVNKdRndAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwA7Lqfnotn/Sti+Oo1MAAAC2wQE6AACwt9pJ19S3/Tzl1ES3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsNtKTvfq3//uUXQHAADANjhABwAA9pbzcwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADaqpPtn424anQEAAHDXHKADAAB76fzi+ivn5wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGxaTv3MCToAALDvHKADAAB7ZzTupqnkz6I7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA2E859V+cX7ycRHcAAADclRwdAAAAsEmjcTctqZ9FdwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALDnSlquj6rTxdXJMjoFAABg0xygAwAAe6OdXN+rV/l5dAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHwgk6AACwp6roAAAAgE1oJ11T3+Yn0R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAckJyaelUu2/bFcXQKAADAJjlABwAAdt4P5+f9POXURLcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwaEpbffLxg+gKAACATXKADgAA7Lx6VS6dnwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAlp352Nu6m0R0AAACb4gAdAADYaaNxN02ptNEdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHLac+tn5xctJdAcAAMAm5OgAAACA9zUad9OS+ll0BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKSUUippuT6qThdXJ8voFAAAgA/hAB0AANhJ7eT6Xr3Kz6M7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4BecoAMAAHugig4AAAB4V+2ka+rb/CS6AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP5NTk29Ko/a9sVxdAoAAMD7coAOAADslHby4ri+7ecppya6BQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAF6vTKpPPn4QXQEAAPC+HKADAAA7pV4fPXZ+DgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwNDl1M/O/vTNF9EdAAAA7yNHBwAAALyt0bibltTPojsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgLd2s+3K6+Msfvo4OAQAAeBcO0AEAgJ1wdnF9P5d8Gd0BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA76Sk5fqoOl1cnSyjUwAAAN6WA3QAAGDw2knX1Kv+eUrpOLoFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3lUu6evV378/XSw+vYluAQAAeBtVdAAAAMCvaSddU9/28+T8HAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgB1Vcrr30e//YxrdAQAA8LYcoAMAAINWr8qjlFMT3QEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfopTyxdm4c4IOAADsBAfoAADAYI3G3TSlMonuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgE3Iqf+iHb9qozsAAAB+S44OAAAAeJ2zi+v7ueTL6A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADYqJKW66PqdHF1soxOAQAAeJMqOgAAAOBftZOuyX2eRncAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAxuXU1Kty2bYvjqNTAAAA3sQBOgAAMCjt5MVxfdvPU05NdAsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADcjdJWn3z8ILoCAADgTRygAwAAg1Kvjx47PwcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGDf5dTPzv70zRfRHQAAAK+TowMAAAB+Mhp305L6WXQHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAbMnNui+ni7/84evoEAAAgJ9zgA4AAAxCO7m+V6/y8+gOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA2KqSluuj6nRxdbKMTgEAAPhJFR0AAADQTrqmvs1PojsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABg63Jq6lV5FJ0BAADwcw7QAQCAcPWqf5JyaqI7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIEaZnI27aXQFAADATxygAwAAoUY/DCf3ojsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgUk79rB2/aqM7AAAAUkopRwcAAACH6+zi+n4u+TK6AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAahpOX6qDpdXJ0so1MAAIDDVkUHAAAAh6mddE3u8zS6AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYjp6Zelcu2fXEcnQIAABw2B+gAAECI+rafp5ya6A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYltJWn3z8ILoCAAA4bA7QAQCArRtdXD9yfg4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACvl1M/O7u4vh/dAQAAHK4cHQAAAByWs4vr+7nky+gOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGLSSluuj6nRxdbKMTgEAAA6PA3QAAGBr2knX1Kv+eUrpOLoFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhi6X9PXq79+fLhaf3kS3AAAAh6WKDgAAAA5HfdvPk/NzAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeCslp3vVJx8/iO4AAAAOjwN0AABgK0YX149STk10BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOySnPrZ2cX1/egOAADgsOToAAAAYP+dXVzfzyVfRncAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADATippuT6qThdXJ8voFAAA4DA4QAcAAO5UO+maetU/TykdR7cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA7sqL9bff/c9i8elNdAkAALD/qugAAABgv9W3/Tw5PwcAAADg/9m7m9s2snyNw+dU0dAF3Aa49a6UgZRBidbKLWIqg2EGUgZ0Bu4MFEI7AzODcQYSLMLcctHaaFg8d9GD25g70+0PSfzz43ki+O3fxQsAAAAAAAAAAAAAAAAAAAAAAAAAwCOVtvrpfy6jKwAAgMPgAB0AAHg25xeLacqpie4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAfZDT+l17cddGdwAAAPsvRwcAAAD76c34c5dK/Wt0BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOyVkm77F9XZ7MPr2+gUAABgf1XRAQAAwP5pu0WT1vX76A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADYOzk19ar4BgEAAJ6VA3QAAODJ1atynXJqojsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgP5VudLGYRlcAAAD7ywE6AADwpM4vFtOUShvdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPssp/VV+3Z+Et0BAADspxwdAAAA7I+2WzT1an0T3QEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHoaTb/v7hdDY7XkanAAAA+6WKDgAAAPZD290M63+uP0Z3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwMHIqRm8OppGZwAAAPvHAToAAPAkBv2Lacqpie4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAQ1JKuRqN55PoDgAAYL/k6AAAAGD3jcbzSS75OroDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADlJJt/2L6mz24fVtdAoAALAfqugAAABgt7XdosnrPI3uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgIOVU1OvynV0BgAAsD8coAMAAI9Sr8p1yqmJ7gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDDVtrRxWIaXQEAAOwHB+gAAMAPO79YTFMqbXQHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkFJO66v27fwkugMAANh9OToAAADYTW23aOrV+ia6AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPhDLunT6v7hbDY7Xka3AAAAu6uKDgAAAHZT/c/1x+gGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4N+VnE4Gr46m0R0AAMBuc4AOAAB8t/Px/H3KqYnuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP5TKeWqvbhrozsAAIDdlaMDAACA3XJ+cdeWVH2M7gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD+Qkm3/YvqbPbh9W10CgAAsHuq6AAAAGB3tN3NsJTqOroDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+IqcmrpfT6MzAACA3eQAHQAA+GZ1/+KXlFMT3QEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8g5Imo/F8Ep0BAADsnhwdAAAA7IbReD7JJV9HdwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADfoaTb/kV1Nvvw+jY6BQAA2B1VdAAAALD92m7R5HWeRncAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3ymnpl6V99EZAADAbnGADgAAfFXd9+9STk10BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPAjSjf6+ctVdAUAALA7cnQAAACw3Ubj+SSXfB3dAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADzKsh9Up7MPr2+jQwAAgO1XRQcAAADbq+0WTV7naXQHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8GjDelWuoyMAAIDd4AAdAAD4U3Xfv0s5NdEdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwFMo7ejnL1fRFQAAwPbL0QEAAMB2Go3nV7nk99EdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwJNa9oPqdPbh9W10CAAAsL2q6AAAAGD7tN2iySVPozsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAJzesV+U6OgIAANhuDtABAID/8K+BYRjdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADyH0o5+/nIVXQEAAGyvHB0AAABsl9F4PsklX0d3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9q2Q+q09mH17fRIQAAwPapogMAAIDt0XaLJq/zNLoDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeHbDelWuoyMAAIDt5AAdAAD4P3Xfv0s5NdEdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwCaUdvTzl6voCgAAYPvk6AAAAGA7jMbzSS75OroDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA2KhlP6hOZx9e30aHAAAA26OKDgAAAOK13aLJ6zyN7gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA2blivynV0BAAAsF0coAMAAKnu+3cppya6AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIhQ2tF4PomuAAAAtkeODgAAAGKNxvNJLvk6ugMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIVNJt/6I6m314fRudAgAAxKuiAwAAgDhtdzPM6zyN7gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACC5dTU/dqXCQAAkFJygA4AAAdt0L+Yppya6A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgC5Q0eTP+0kVnAAAA8XJ0AAAAEOP84q4tqfoY3QEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABskZJu+/uH09nseBmdAgAAxKmiAwAAgBilVNfRDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMCWyakZvDqaRmcAAACxHKADAMABOr9YTFNOTXQHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsH1KKVft2/lJdAcAABAnRwcAAACb1XaLpl6tb6I7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgO2VS/q0un84m82Ol9EtAADA5lXRAQAAwGbVq3Id3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABst5LTSfXyaBLdAQAAxMjRAQAAwOaMxvOrXPL76A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgJyz7QXWPzzQvAAAgAElEQVQ6+/D6NjoEAADYrCo6AAAA2Iy2WzR5nS+jOwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICdMaxX5To6AgAA2DwH6AAAcCDqvn+XcmqiOwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBdUtrReD6JrgAAADYrRwcAAADP7/ziri2p+hjdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOygkm77+4fT2ex4GZ0CAABsRhUdAAAAPL9SquvoBgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGBH5dQMXh1NozMAAIDNcYAOAAB77vxiMU05NdEdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwO4qpVy1b+cn0R0AAMBm5OgAAADg+bTdoqlX63+klIbRLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBuyyV9Wt0/nM1mx8voFgAA4HlV0QEAAMDzqVflOjk/BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJ5Ayemkenk0ie4AAACeX44OAAAAnsdoPJ/kkq+jOwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIC9suwH1ensw+vb6BAAAOD5VNEBAADA02u7m2Fe52l0BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALB3hnW/9o0CAAB7zgE6AADsoUH/YppyaqI7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgD1U0qS9uGujMwAAgOeTowMAAICn1XaLpl6tb6I7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgP2VS/q0un84m82Ol9EtAADA06uiAwAAgKdVr8p1dAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACw30pOJ9XLo0l0BwAA8DxydAAAAPB0RuP5JJfsAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADYhGU/qE5nH17fRocAAABPq4oOAAAAnkbb3QzzOk+jOwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICDMaz7tc8UAADYQw7QAQBgTwz6F9OUUxPdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAByQkibtxV0bnQEAADytHB0AAAA8Xtstmnq1vonuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA5PLunT6v7hbDY7Xka3AAAAT6OKDgAAAB6v7le/RDcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAh6nkdFK9PJpEdwAAAE8nRwcAAACPc35x15ZUfYzuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA5YSbf9/cPpbHa8jE4BAAAer4oOAAAAHqeU6jq6AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADhwOTWDV0fT6AwAAOBpOEAHAIAdNhrPr1JOTXQHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQCll0r6dn0R3AAAAj+cAHQAAdlTbLZpc8jS6AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOBfhnVVvY+OAAAAHs8BOgAA7KhB31+mlIbRHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB/KO2b8ZcuugIAAHicHB0AAAB8v7ZbNPVqfRPdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPD/5ZI+re4fzmaz42V0CwAA8GOq6AAAAOD71atyHd0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8N+UnE6ql0eT6A4AAODH5egAAADg+7wZf+5SqX+N7gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4C8t+UJ3OPry+jQ4BAAC+XxUdAAAAfKd1/T46AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOArhoO+XEZHAAAAP8YBOgAA7JDReH6VcmqiOwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC+ppQyad/OT6I7AACA7+cAHQAAdkTbLZpc8jS6AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAbDeuqeh8dAQAAfD8H6AAAsCMGfX+ZUhpGdwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8u9K2F3dtdAUAAPB9cnQAAADwdW23aOrV+ia6AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOB75ZI+re4fzmaz42V0CwAA8G2q6AAAAODr6n71S3QDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwI8oOZ1Ur1500R0AAMC3y9EBAADAXzu/uGtLqj5GdwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8sJJu+/uH09nseBmdAgAAfF0VHQAAAPy1kqr30Q0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAj5JTU/00uIrOAAAAvo0DdAAA2GKj8XySUjqJ7gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4rJyqy7ZbNNEdAADA1zlABwCALZbXeRrdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPBEhoO+XEZHAAAAX+cAHQAAttRoPL9KOTXRHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABPpZQyad/OT6I7AACAv+YAHQAAtlDb3QzzOl9GdwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8sWFdVdPoCAAA4K85QAcAgC00WA2uUk5NdAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA0ytde3HXRlcAAAB/zgE6AABsmbZbNCVVl9EdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM+lTvU0ugEAAPhzDtABAGDLDPr+MqU0jO4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeD6lfTP+0kVXAAAA/50DdAAA2CJtt2hKyVfRHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADPLa/LNLoBAAD47xygAwDAFqn7/l10AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAmlJxORuP5JLoDAAD4Tzk6AAAA+F3bzU/qVf5HdAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADApuSSPq3uH85ms+NldAsAAPCHKjoAAAD4Xd2Xd9ENAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJtUcjqpXh5NojsAAIB/l6MDAACAlM4v7tqSqo/RHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAbV9Jtf/9wOpsdL6NTAACA31XRAQAAQEol1dPoBgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAQOTXVy6NJdAYAAPCHHB0AAACH7vziri2p+hjdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABBo2f/2cDybHS+jQwAAgJSq6AAAADh0JVXvoxsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgg2rnwZX0REAAMDvcnQAAAAcsjfjz10q9a/RHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABbYNn/9nA8mx0vo0MAAODQVdEBAABw0Eo9jU4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA2BLDwasjny4AALAFHKADAECQN+PPXUrpJLoDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYFuUUiZtt2iiOwAA4NA5QAcAgCjr+n10AgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMCWGQ76chkdAQAAh84BOgAABBiN55OUUxPdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALBtSimTtls00R0AAHDIHKADAECAvM7T6AYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACALTUc9OUyOgIAAA6ZA3QAANiw0Xg+STk10R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA26qUMmm7RRPdAQAAh8oBOgAAbFhe52l0AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMCWGw76chkdAQAAh8oBOgAAbNBoPJ+knJroDgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBtV0qZtN2iie4AAIBD5AAdAAA2KK/zNLoBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYEcMB325jI4AAIBD5AAdAAA2ZDSeT1JOTXQHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwK4opUzabtFEdwAAwKFxgA4AABuS13ka3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwY4aDvlxGRwAAwKFxgA4AABvwZvy5Szk10R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAu6aUMmm7RRPdAQAAh8QBOgAAbEKpp9EJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADtqWK1Wk+gIAAA4JDk6AAAA9t2b8eculfrX6A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAHbbsf3s4ns2Ol9EhAABwCKroAAAA2HulnkYnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOy4YfXT4Co6AgAADkWODgAAgH32Zvy5S6X+NboDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYA8s+98ejmez42V0CAAA7LsqOgAAAPZaGVxGJwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADsiWH10+AqOgIAAA6BA3QAAHgm5xd3bUqlje4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA2Be5VH9v25thdAcAAOw7B+gAAPBMSqqn0Q0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeyWnpnp5NInOAACAfecAHQAAnkHbzU9SKm10BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMC+qVL5e9veDKM7AABgnzlABwCAZ1D35V10AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMA+KjmdVK9edNEdAACwzxygAwDAE2u7RZNK9bfoDgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIB9Va3zZXQDAADsMwfoAADwxOq+fxfdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALDPSk4nb8ZfuugOAADYVw7QAQDgCbXdokkl/y26AwAAAAAAAAAAAAAAAAAAAAAAAAAAAACA/2XvDm7juLYEDJ+61QSBGRGoEKgIpjLgBewVIaMrAzIDKoMJ6YXwlEkDVgPaauGV3c07Gw+gZ8gyRTV5uqq+L4I/gx8AWLwWD9kJAACwVAboAABwQpvD4T4ihuwOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgOVrtb77WLMrAABgiQzQAQDgROq0G1qUh+wOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgLXoo/eMAQCAF2CADgAAJ7I5bN5HxJDdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALAebaq3+zG7AgAAlsYAHQAATqBOu6G1cpfdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALA2fd89ZDcAAMDSGKADAMAJlOPFFF1cZ3cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArE6LqU6frrMzAABgSQzQAQDgBLrWPWQ3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKzUUA6H++wIAABYki47AAAA5u6nX36dovX/yu4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWLHPx99+f/vhw9vP2SEAALAEJTsAAABmr20eshMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVm4o/315nx0BAABLYYAOAAA/oE77MaLV7A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAtSvR7mrdDdkdAACwBAboAADwA/pjvM9uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACCidTH2V5c1uwMAAJbAAB0AAJ6pTp+uo3V32R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/KnFQ3YCAAAsgQE6AAA80+ZwuM9uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOBLrdbb/ZhdAQAAc2eADgAAz1Cn3dCiPGR3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPCf+lL+N7sBAADmzgAdAACeoRwvpogYsjsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+KtW6+1+zK4AAIA5M0AHAIBn6Fr3kN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwFcNpbQpOwIAAOasyw4AAIC5+emXX6do/b+yOwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4W5+Pv/3+9sOHt5+zQwAAYI5KdgAAAMxPd59dAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMA3DeXqYsqOAACAuTJABwCA71Cn/RitbLM7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPi28tg9ZDcAAMBcGaADAMB32BzjLrsBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgH/Wuhjru481uwMAAObIAB0AAJ6oTruhte4+uwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAp+mjf8huAACAOTJABwCAJyrHi/uIGLI7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHiqVuvtfsyuAACAuTFABwCAJ+pad5fdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMB3GUppU3YEAADMTZcdAAAAc/Dzu4+1Rfl3dgcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3+3z8bff33748PZzdggAAMxFyQ4AAIA5aF28z24AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4FmGcnUxZUcAAMCcGKADAMA/qNOn62hlm90BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwPOUx+4huwEAAObEAB0AAP7B5nC4z24AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4PlaF2O93Y/ZHQAAMBcG6AAA8A112g0tykN2BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/pu87LxoAAHgiA3QAAPiG/tjXiBiyOwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4QS2mWnd+NAAA8AQG6AAA8C1t85CdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBJDOXN5n12BAAAzIEBOgAA/I067ceIVrM7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADiN0so2uwEAAObAAB0AAP7G5hh32Q0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAnE7rYqzvPtbsDgAAOHcG6AAA8BV12g2tdffZHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACcVh/9Q3YDAACcOwN0AAD4inK8mCJiyO4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4NRarXXnTwMAAN9ggA4AAF/Rte4huwEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAFzGUN5v32REAAHDODNABAOAv6rQfI2LM7gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgZZRWttkNAABwzgzQAQDgL8qh3Wc3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPByWhdjffexZncAAMC5MkAHAIAv1Gk3dFHusjsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeFl99A/ZDQAAcK4M0AEA4Av9sa8RMWR3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPDSWq1151cDAABfYYAOAABfapuH7AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXsVQ3mzeZ0cAAMA5MkAHAIA/1Wk/RrSa3QEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA6yitbLMbAADgHBmgAwDAnzaHNmU3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPB6Whdjvd2P2R0AAHBuDNABAOBPrZW77AYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXlffdw/ZDQAAcG4M0AEAICJ++uXXKbq4zu4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4JW1mGrdDdkZAABwTgzQAQAgIiK6++wCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFIM/dVlzY4AAIBzYoAOAMDq1Wk3RCs32R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJGnxkJ0AAADnxAAdAIDV2xw27yNiyO4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIEur9XY/ZlcAAMC5MEAHAGD1WpRtdgMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAuUppU3YDAACcCwN0AABWrU77MSLG7A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcpVWttkNAABwLgzQAQBYtc2hTdkNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAORrXYz13cea3QEAAOfAAB0AgNWq025oUR6yOwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4D31X7rIbAADgHBigAwCwWv2xrxExZHcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcCZaTLXufG0AAFg9A3QAAFasu88uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOCsDP3VZc2OAACAbAboAACsUp12Q7Ryk90BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwJlpcZedAAAA2QzQAQBYpXK8mCJiyO4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4Ny0WqdP19kVAACQyQAdAIBV6lq5y24AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4CwN5XC4z44AAIBMBugAAKxOnfZjRKvZHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACcp9LKNrsBAAAyGaADALA6m0ObshsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOF+ti7He7sfsDgAAyGKADgDA6rQo2+wGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM5bKW3KbgAAgCwG6AAArEqd9mNEjNkdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJy30so2uwEAALIYoAMAsCqbQ5uyGwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4f62Lsd7ux+wOAADIYIAOAMCqtFbushsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmIdS2pTdAAAAGQzQAQBYjZ/ffazRxXV2BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADz0LVyV+tuyO4AAIDXZoAOAMBqPEZM2Q0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAzEgX1/FmM2ZnAADAazNABwBgNbood9kNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMxL33nfAACwPgboAACswk+//DpFxJDdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMDMtJhq3fnfAACwKgboAACsRHefXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADALA391WXNjgAAgNdkgA4AwOLVaTdEKzfZHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADMVIu77AQAAHhNBugAACxef+xrRAzZHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADMVau17nxwAABYDQN0AABWoLvPLgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABg1ob+6rJmRwAAwGsxQAcAYNHqtBuilZvsDgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABmrsVddgIAALwWA3QAABatP/Y1IobsDgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADmrtVad344AACsggE6AAAL191nFwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwCEN/dVmzIwAA4DUYoAMAsFh12g3Ryk12BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL0eIuOwEAAF6DAToAAIvVH/saEUN2BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABL0WqtO18cAAAWzwAdAIAF6+6zCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYlKG/uqzZEQAA8NIM0AEAWK5WbrITAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFiWFm2b3QAAAC/NAB0AgEX6+d3HGhFDdgcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAy9I9Rq11548DAMCiGaADALBIjxFTdgMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC9TFdbzZjNkZAADwkgzQAQBYpK6VbXYDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMtUus4jBwCARTNABwBgceq0H6OL6+wOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJapPHY1uwEAAF6SAToAAIuzObQpuwEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACA5WpdjPV2P2Z3AADASzFABwBgcVqUbXYDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMtWSpuyGwAA4KUYoAMAsCh12o8RMWZ3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALBspZVtdgMAALwUA3QAABZlc2hTdgMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAy9e6GOvtfszuAACAl2CADgDAorQo2+wGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANahdFGzGwAA4CUYoAMAsBh12g0RMWZ3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALAOXVe22Q0AAPASDNABAFiM8vvFlN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFS0powAACAASURBVAAAwJq0sdbdkF0BAACnZoAOAMBidH0zQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgNQ391WXNjgAAgFMzQAcAYBHqtBuilZvsDgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWpsVddgIAAJyaAToAAIvQH/saEUN2BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABr02qtO/8cAAAWxQAdAIBFaK2r2Q0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArNIQbzZjdgQAAJySAToAAIvQtbLNbgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgnUpEzW4AAIBTMkAHAGD26rQfo4vr7A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1qm0ss1uAACAUzJABwBg9jaHNmU3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALBerYux3u7H7A4AADgVA3QAAGavRX+T3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAupUuanYDAACcigE6AACzVqfdENHG7A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1q3ryk12AwAAnIoBOgAAs9Yf+xoRQ3YHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGvXaq07Px0AABbBAB0AgFl7jDJlNwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABARAz91WXNjgAAgFMwQAcAYNbKY3eT3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEREtHj11AABYBAN0AABmq077Mbq4zu4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgIiI8tjV7AYAADgFA3QAAGZrc2hTdgMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/L/WxVinT9fZHQAA8KMM0AEAmK0W/U12AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8qRz/qNkNAADwowzQAQCYpTrthog2ZncAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwJe6ttlmNwAAwI8yQAcAYJb6Y18jYsjuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAID/1GqtO38dAABmzQAdAIBZaq2r2Q0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8BVD/NfFdXYEAAD8CAN0AABmqYtyk90AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAF9TSpuyGwAA4EcYoAMAMDt1+nQdEWN2BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8TRf9TXYDAAD8CAN0AABmp/x+rNkNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPD32ljrbsiuAACA5zJABwBgdrq+TdkNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPANQ391WbMjAADguQzQAQCYn8fyP9kJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPAtLR5vshsAAOC5DNABAJiVOu3H6OI6uwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvqU8djW7AQAAnssAHQCAWSl/RM1uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIB/0roY6/TpOrsDAACewwAdAIBZ6Uqr2Q0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8BT9sY3ZDQAA8BwG6AAAzEaddkO0cpPdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABP0aJtsxsAAOA5DNABAJiRi+uIGLIrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOApymOM2Q0AAPAcBugAAMzG5tCm7AYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeKrWxVinT9fZHQAA8L0M0AEAmI3WxZjdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADfoxz/qNkNAADwvQzQAQCYhTrthmjlJrsDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL5P770DAMDsGKADADATF9cRMWRXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMD36B6jZjcA8H/s3cFt3EoWheFbxWeM8YABmMFUBs0MxBA6/402A3QOktg1KxsPHtmSbTVvtfl9EfzrszkA/CwH6AAA3IW/Xvo5uwEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAflqJtp4vLTsDAAB+hgN0AADuQi+xZDcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwK+o2/Oa3QAAAD/DAToAAMNbz49z9PqQ3QEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAv2bywQMAwF1xgA4AwB341CJizq4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgF9Rr7FkNwAAwM9wgA4AwPDqc6zZDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwq3qJZT1fWnYHAAC8lwN0AACGV2pfsxsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4HdMW1+yGwAA4L0coAMAML5eH7ITAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOB39Lj64gEA4G44QAcAYGjr+b9LRMzZHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwO+q1rNkNAADwXg7QAQAYWn2KJbsBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH5XL9HW9XHO7gAAgPdwgA4AwND6FGt2AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8gHn697/W7AgAAHgPB+gAAAytXstDdgMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfITetyW7AQAA3sMBOgAAw1rPlxYlWnYHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHyEEtMpuwEAAN7DAToAAMOatucluwEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPk5f1/Vxzq4AAIC3OEAHAGBYvZc1uwEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPtAcf39q2REAAPAWB+gAAAyrRH3IbgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAj1Sn65LdAAAAb3GADgDAkNbz4xwRLbsDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD7W9JBdAAAAb3GADgDAoD61iJizKwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgI5VrrNkNAADwFgfoAAAMqT4bWAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4A5Vo6/nSsjMAAOBHHKADADCkUvua3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtzBtfcluAACAH3GADgDAmK71lJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALfQ++YAHQCAoTlABwBgOOv50qJEy+4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgFsoMZ2yGwAA4EccoAMAMJxpe16yGwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgZnpf1vVxzs4AAIDvcYAOAMBwSi8O0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4c5VoMX92gA4AwLAcoAMAMJxewgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH+0uj2v2Q0AAPA9DtABABhPrw/ZCQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwW5OvHgAAhuUAHQCAoaznS4uIObsDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG6pXmPJbgAAgO9xgA4AwFDq07ZmNwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADArfUSbV0f5+wOAAB4jQN0AADGUvuSnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAO5jj708tOwIAAF7jAB0AgKGUmE7ZDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwhzpdl+wGAAB4jQN0AAAG042pAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABzE9JBdAAAAr3GADgDAMNbzpUXEnN0BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHuo11iyGwAA4DUO0AEAGEZ92tbsBgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADYSy/R1vVxzu4AAIBvOUAHAGActS/ZCQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwozn+/tSyIwAA4FsO0AEAGEaJ6ZTdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB7qtN1yW4AAIBvOUAHAGAcvbfsBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADYVz1lFwAAwLccoAMAMIT1fGlRomV3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMCeSq9LdgMAAHzLAToAAEOYtmcDKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADH03vLTgAAgG85QAcAYAilFwfoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABxPibaeLy07AwAA/skBOgAAQ+glHKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcEjT1n34AAAwFAfoAACM4VpP2QkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkKH3zQE6AABDcYAOAEC69XxpUaJldwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAhhLTKbsBAAD+yQE6AADp/np5adkNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJCm9yU7AQAA/skBOgAA6a7X0rIbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACBNiXk9X1p2BgAAfOEAHQCAdH2KNbsBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABLN8bTN2REAAPCFA3QAANLVXk7ZDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQqU7XJbsBAAC+cIAOAMAIWnYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOSaHrILAADgCwfoAACkWs+XFhFzdgcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZCq9+PIBAGAYDtABAEg1bc9LdgMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAApOvdnw8AAMNwgA4AQKp+rS27AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADSlWjr+dKyMwAAIMIBOgAAyXqNJbsBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIbw8tKyEwAAIMIBOgAAyWovp+wGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABhBLb1lNwAAQIQDdAAA8rXsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYw/SQXQAAABEO0AEASLSeLy0i5uwOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABhB6cWnDwAAQ3CADgBAmml7XrIbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAYvfv1AQBgCA7QAQBI06+1ZTcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwDBKtPV8adkZAADgAB0AgDS9xpLdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABDedrm7AQAAHCADgBAmtrLKbsBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEZSp+uS3QAAAA7QAQDI02POTgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAofTSshMAAMABOgAAKdbzpUWJlt0BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEMp9T/ZCQAA4AAdAIAk25xdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACjKddYsxsAAMABOgAAKepTLNkNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADCcEvO6Ps7ZGQAAHJsDdAAActTuAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/t8c82cH6AAApHKADgBAil6KcRQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXjFtfcluAADg2BygAwCQol7LQ3YDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIyox8uc3QAAwLE5QAcAIEcJ4ygAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvGp6yC4AAODYHKADALC79XxpEQ7QAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOA1pRcfPwAApHKADgDA7v56eWnZDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwrN6X7AQAAI7NAToAALu7XkvLbgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAYZWY1/Vxzs4AAOC4HKADALC/2pfsBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAY2BzzZwfoAACkcYAOAMDueilGUQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4gWnrS3YDAADH5QAdAIDd1V5O2Q0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMLIeL3N2AwAAx+UAHQCA/fUwigIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAD9VTdgEAAMflAB0AgF2t50uLEi27AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADGVubsAgAAjssBOgAAO9sMogAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwhnqNJbsBAIDjcoAOAMCu6pNBFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADe0iPm7AYAAI7LAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAaEq09Xxp2RkAAByTA3QAAHbVp1izGwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4PgfoAADsqkafsxsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4B5MW1+yGwAAOCYH6AAA7OtaT9kJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAPerzM2Q0AAByTA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAIdVTdgEAAMfkAB0AgN2s50uLEi27AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADuQ5mzCwAAOCYH6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADqtdYshsAADgmB+gAAOymPm1rdgMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3IseMWc3AABwTA7QAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEZUYl7XRyfoAADszgE6AAD7qX3JTgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAOzLH/NkBOgAAu3OADgDAbnopRlAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+BlPm+8fAAB25wAdAIDd1F7/k90AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPekTtcluwEAgONxgA4AwH56b9kJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPyYA3QAAPZTYs5OAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAID7Mj1kFwAAcDwO0AEA2MV6vrQIB+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAo3OADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADCo0kvLbgAA4HgcoAMAsItpe16yGwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADg7vTeshMAADgeB+gAAOyib3XObgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgbQ7QAQDYRwkH6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADws0q09Xxp2RkAAByLA3QAAHbRayzZDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC8zQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwMietjk7AQCAY3GADgDALmovp+wGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALhHdbou2Q0AAByLA3QAAPbRY85OAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOBtDtABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhlZP2QUAAByLA3QAAG5uPV9alGjZHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwn8qcXQAAwLE4QAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC+coAOAMAOtjm7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADuVb3Gkt0AAMCxOEAHAODm6pPhEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB+VY+YsxsAADgWB+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAVw7QAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEZWoq3nS8vOAADgOBygAwBwc32KNbsBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgPdxgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB85QAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYHDT1pfsBgAAjsMBOgAAN1d7OWU3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMA96/EyZzcAAHAcDtABALi9HkZPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgDvhAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgdNc6ZycAAHAcDtABALip9fw4RwmjJwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8jlpO2QkAAByHA3QAAG7s8xzhAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgXjhABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL5ygA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwuHqNJbsBAIDjcIAOAMBNTduzwRMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAflOPmLMbAAA4DgfoAADcVN+qwRMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgjjhABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL5ygA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwuhLzuj7O2RkAAByDA3QAAG6r9iU7AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD+AHPMnx2gAwCwCwfoAADcVC/F2AkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwRxygAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAF85QAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC4B0/bnJ0AAMAxOED/H3t3bNtEGIBh+M52QemW7jaADTADIGUVNmKEjJBNoECiZYDER/d2kRIrpx/HzzPBV3/NCwDApnbT6uwEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgDew258/j94AAMBtEEAHAGBb592n0RMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeDkBdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAC6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAE0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAIoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABchf2X0QsAALgNAugAAGzmdPdnmeZpGb0DAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgJcTQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIADoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAKzCv8zJ6AwAAt0EAHQCAzRweH5fRGwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADg3VjXZfQEAABugwA6AACbOZ/nZfQGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAF5HAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIADoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABABNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAuAbzdDydfh5HzwAA4P0TQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC4Dsfp+EEAHQCAzQmgAwCwmXU/nUZvAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOB1BNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAA6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAF0AAAA2X4kxwAAIABJREFUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIALoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQATQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHIYPQAAAAAA4AL30zz9HT0CAAAAAAAAAAAAAAAAAAAAAAAAAACes56n0zxPy+gdAAAAAACXEEAHAAAAAK7O02H3/eH+46/ROwAAAAAAAAAAAAAAAAAAAAAAAAAA4Dlfv/3+Ma/zMnoHAAAAAMAldqMHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP8PAXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABABNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAA6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAF0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIALoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQATQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgAOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABABdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAC6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAE0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAIoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIADoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABABNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAA6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAF0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIALoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQATQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgAOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABABdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAC6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAE0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAIoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIADoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABABNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4I3NT9PD6A0AAAAAAJcSQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIADoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABABNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAA6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAF0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIALoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQATQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgAOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABABdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAC6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAE0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAIoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIADoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABABNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAA6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAF0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIALoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQATQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEQAHQAAAAAAAAAA4B97d1ACAAgAMBBMZv9KIvhbBVHuEqzBAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeMfaatxsAAPifAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAh707FgAAAAAY5G+9bxQlEgAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAJ9rK7AAAgAElEQVQAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAABA7N1BCQAhAABBEPtnNIhw99sAIviZSbANFgAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHDZGN963QAAAAAAcMoAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAu23Ou1w0AAAAAAKcM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAP/0lSUAACAASURBVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAD42buDGoBBAICBASPDv0n2qwUCuVNQBwUAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwiz3W6QQAAN5ngA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADALcb8TicAAPA+A3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAfvbuWAAAAABgkL/1vlGUSAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAcXcx6wAAIABJREFUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAsXfHAgAAAACD/K33jaJEAgAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmQAcAAAAAAAAAAAAAAAAAAACIvTu2aSAIACB4/6INJOjEASE9QGmUQEABLgWJBhyS8Cbb2CBLx6OZCraDBQAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwdZ+nMcZpdgUAAAAAwG8YoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAlR1f70/jbIAOAAAAAOyTAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgJ5ZtHGY3AADw/xmgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAeta8MAAAgAElEQVQAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBuZgcAAAAAAAAAAAD78vD4cdi25W52BwAAAAAAAAAAAAAAAHCZbT2/H99uj7M7AAAAAAAAAACA/TBABwAAAAAAAAAAfuRrWZ7XdXma3QEAAAAAAAAAAAAAAABcZl2WlzHGcXIGAAAAAAAAAACwI+vsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAODvMEAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAIBv9u5YAAAAAGCQv/W+UZRIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAToAAAAAAACxd8cCAAAAAIP8rfeNokQCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAACa6m1sAACAASURBVAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACdABAAAAAAAAAIi9O6hhEAgAINhzghQk1P+rfeHiwm8FkJALZEbBOlgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7jDGb3UCAAAAAMAVBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcIM55n91AwAAAADAFQboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeZP8e2+oGAADezQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgKcYn211AgAA72eADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAJzs3bEAAAAAwCB/632jKJEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPRo4OgAAIABJREFUAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAnQAAAAAAAAAAGLvjmkAhAEACBLAvwakIAUlLdvPbA3JnYJ38AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIOfqAAAAAAAAAAAA4F+OOa8xtnt1BwAAAAAAAAAAAAAAAPDN2OezugEAAAAAAAAAAPgXA3QAAAAAAAB42btjEwahAACi0T3cxaFTpnAvEeyuNyDfhPcmuA0OAIBLPu9lG90AAAAAAAAAAAAAAAAAAAAAAAAAAAAA3GceHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8hwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP2Q+9nV0AwAA/80AHQAAAAAAAAAAAAAAAAAAAAAAAAAAAABjq1SkAAAgAElEQVQAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC4wXS8ttENAAAAAADfMEAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAABwsnfHAgAAAACD/K33jaJEAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYAB0AAAAAAACIvTsWAAAAABjkb71vFCUSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAJW1RmcAACAASURBVAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAEDs3VEJgFAAwEBUsIb2T2Ey9W8BBHkodwnWYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+JJr2kcnAADwbwboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHzJNG+jEwAA+DcDdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC841+UY3QAAAAAA8IQBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAwM3eHQsAAAAADPK33jeKEgkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAA+G0uPAAAIABJREFUAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAAdAAAAAAAAAAAAIPbumIZBKACAaCF1gZoKqAZSZ3hgR0190O1mtl+S9xScgwMAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADIc3QAAAAAAAAAAABwL6/3d5vPaR3dAQAAAAAAAAAA3MM5PbZjXz6jOwAAAAAAAAAAAAAAAIDr5tEBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwP8wQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAADS2wP7AAAgAElEQVQAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAB+7N1BEUBQAADRL4Y2IosgiiS47d3BGOa9BNtgAQAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+JDpGMvbDQAA/JsBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAA7Z13sc59rc7AAAAAADuMkAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAABwsXfHAgAAAACD/K33jaJEAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAIwE5fIAACAASURBVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgAHQAAAAAAAACIvTsWAAAAABjkb71vFCUSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAE6AAAAAAAAAAAAEDs3UERwCAAwLDhBCmTMP8GsLFfLXBwiYI6KAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAw7zfmrsbAAC4lwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACcZz9ydAADA3QzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAkNXYLQAAIABJREFUAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAfvbumAaBIACA4B1BBuLfAz0BJ2Dkodv+C3KBzChYBwsAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgJxXBwAAAAAAAAAAAL9ljnEfc7xXdwAAAAAAAAAAAL/i/VhdAAAAAAAAAAAAAAAAABxjgA4AAAAAAAAAABxyu162Mca2OAMAAAAAAAAAAAAAAAAAAAAAAAAAAAD4ktPqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4W3M+VycAAAAAABxlgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAX7LP/bW6AQAAAADgKAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAf9u5YAAAAAGCQv/W+UZRIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAADjuVonAAAgAElEQVQAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABOgAAAAAAACxdwclAIAAAAPBZPavJIK/VRDlLsEaDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgMWOvebsBAIB/GaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAcNi7YxoAQACAYeDfFMZI+PZzEJ5WwRwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4JG5x/rdAAAAAABwywAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAABQFZGYAACAASURBVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAOe3dQAwAIBDAsOMG/Se43CwTSKpiDAQAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8Jqz9u0EAAD+ZYAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAADAsHcHNQCAQADDAkbw7/J+s0AgrYI5GAAAAAAAAAAAAAAAAAAAAAAAAMBr1j63EwAA+JcBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA9yf7NQAAIABJREFUAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAADHt3bAIgDABAkKD7z+gIDiBq932KIMLdBL/BAwAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALDI2O7z6wYAAAAAgFkG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwyHiGAToAAAAA8DsG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwyLXvx9cNAAAAAACzDNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAABe9u7YNoooAICo1wdFkFALuhBZoiRMB5SCBCnUQAkOkJyaHO6cTWaJQ9r9f0/vVTAdDAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAD6GjUhAAAgAElEQVQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMQAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABADdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQV6MDAAAAAAAudfhz/nB8/+v36A4AAAAAAAAAAAAAAAAAAAAAAACAlyyH09P3r2+/jO4AAAAAAACA/2GADgAAAADs0PnzcruMjgAAAAAAAAAAAAAAAAAAAAAAAAB42flwc7x7vP/x7c2n0SkAAAAAAABwqdvRAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANdouTndH+8eP47uAAAAAAAAgEsZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKzEBB0AAAAAAIA9MkAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYkQk6AAAAAAAAe2OADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsDITdAAAAAAAAPbEAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGADJugAAAAAAADshQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADARkzQAQAAAAAA2AMDdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgA2ZoAMAAAAAADA7A3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICNmaADAAAAAAAwMwN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAUzQAQAAAAAAmJUBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwCAm6AAAAAAAAMzIAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAgE3QAAAAAAABmY4AOAMBqDufzw+gGAAAAAAAAAAAAAAAAAAAAAAAAAAAA2AMTdAAAAAAAAGZigA4AwGpOp+VhdAMAAAAAAAAAAAAAAAAAAAAAAAAAAADshQk6AAAAAAAAszBABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmIQJOgAAAAAAADMwQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJiICToAAADwL5bTzbvRDQAAXC8DdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgMmYoAMAAAAAADCSAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMCETNABAAAAAAAYxQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgUiboAAAAAAAAjGCADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMDETdAAAAAAAALZmgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA5E3QAAAAAAAC2ZIAOAMBqlsPpaXQDAAAAAAAAAAAAAAAAAAAAAAAAAAAAXAsTdAAAAAAAALZigA4AwGr+Hl7/HN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAA18QEHQAAAAAAgC0YoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOyICToAAAAAAABrM0AHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4Zu8Ojhs3tgCKPpAa5TBL5r9hCFAGVAZwBr1UlYYNL359e2xLM6JE9GsA50RwM7grY4IOAAAAAADAkgzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVsgEHQAAAAAAgKUYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKyUCToAAAAAAABLMEAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYMRN0AAAAAAAA7s0AHQCABb2UiCjZFQAAAAAAAAAAAAAAAAAAAAAAAAAAALB1JugAAAAAAADckwE6AACLGc+nErMBOgAAAAAAAAAAAAAAAAAAAAAAAAAAALRggg4AAAAAAMC9GKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABshAk6AAAAAAAA92CADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsCEm6AAAAAAAAHyVAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMDGmKADAAAAAADwFQboAAAsa4iSnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAB7ZIIOAAAAAADAZxmgAwCwqDrMz9kNAAAAAAAAAAAAAAAAAAAAAAAAAAAAsFcm6AAAAAAAAHyGAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMCGmaADAAAAAABwKwN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAjTNBBwAAAAAA4BYG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADtggg4AAAAAAMBHGaADALCo4RpjdgMAAAAAAAAAAAAAAAAAAAAAAAAAAADwPyboAAAAAAAAfIQBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwI6YoAMAAAAAAPA7BugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7Y4IOAAAAAADArxigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7JAJOgAAAAAAAO8xQAcAYFH1MS7ZDQAAAAAAAAAAAAAAAAAAAAAAAAAAAMDbTNABAAAAAAB4iwE6AAALO5bsAgAAAAAAAAAAAAAAAAAAAAAAAAAAAOB9JugAAAAAAAD8mwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAzpmgAwAAAAAA8DMDdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEzQAQAAAAAA+IsBOgAAixrP36eYY8ruAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH7PBB0AAAAAAIAIA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB+YoIOAAAAAACAAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/YIIOAAAAAACwbwboAAAs71CfsxMAAAAAAAAAAAAAAAAAAAAAAAAAAACA25igAwAAAAAA7JcBOgAAi6sxlOwGAAAAAAAAAAAAAAAAAAAAAAAAAAAA4HYm6AAAAAAAAPtkgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMC7TNABAAAAAAD2xwAdAIDFHed5ym4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAPs8EHQAAAAAAYF8M0AEAWFytw5TdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHyNCToAAAAAAMB+GKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwISboAAAAAAAA+2CADgDA4g6HecpuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAO7DBB0AAAAAAGD7DNABAFjcj4eHKbsBAAAAAAAAAAAAAAAAAAAAAAAAAAAAuB8TdAAAAAAAgG0zQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOBmJugAAAAAAADbZYAOAEADLyUiSnYFAAAAAAAAAAAAAAAAAAAAAAAAAAAAcF8m6AAAAAAAANtkgA4AwOLG86nEbIAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAW2SCDgAAAAAAsD0G6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHyJCToAAAAAAMC2GKADANBEPcxP2Q0AAAAAAAAAAAAAAAAAAAAAAAAAAADAckzQAQAAAAAAtsMAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgLswQQcAAAAAANgGA3QAAJo4zvOU3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAszwQdAAAAAABg/QzQAQBootZhym4AAAAAAAAAAAAAAAAAAAAAAAAAAAAA2jBBBwAAAAAAWDcDdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAO7OBB0AAAAAAGC9DNABAGiiPsYluwEAAAAAAAAAAAAAAAAAAAAAAAAAAABoywQdAAAAAABgnQzQAQBo5FiyCwAAAAAAAAAAAAAAAAAAAAAAAAAAAID2TNABAAAAAADWxwAdAIBGXkpEmKADAAAAAAAAAAAAAAAAAAAAAAAAAADADpmgAwAAAAAArIsBOgAATYznU4nZAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAD2ygQdAAAAAABgPQzQAQBoZzBABwAAAAAAAAAAAAAAAAAAAAAAAAAAgD0zQQcAAAAAAFgHA3QAAJqpw/yc3QAAAAAAAAAAAAAAAAAAAAAAAAAAAADkMkEHAAAAAADonwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAATZmgAwAAAAAA9M0AHQCAZoZrjNkNAAAAAAAAAAAAAAAAAAAAAAAAAAAAQB9M0AEAAAAAAPplgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAKE3QAAAAAAIA+GaADANBMfYxLdgMAAAAAAAAAAAAAAAAAAAAAAAAAAADQFxN0AAAAAACA/higAwDQ0LFkFwAAAAAAAAAAAAAAAAAAAAAAAAAAAAD9MUEHAAAAAADoiwE6AAANvZSIMEEHAAAAAAAAAAAAAAAAAAAAAAAAAAAA/sMEHQAAAAAAoB8G6AAANDOeTyVmA3QAAAAAAAAAAAAAAAAAAAAAAAAAAADgbSboAAAAAAAAfTBABwCgrWGYshMAAAAAAAAAAAAAAAAAAAAAAAAAAACAfpmgAwAAAAAA5DNABwCgqTrUP7IbAAAAAAAAAAAAAAAAAAAAAAAAAAAAgL6ZoAMAAAAAAOQyQAcAoKnjPE/ZDQAAAAAAAAAAAAAAAAAAAAAAAAAAAED/TNABAAAAAADyGKADANBUrcOU3QAAAAAAAAAAAAAAAAAAAAAAAAAAAACsgwk6AAAAAABADgN0AACaOhzmKbsBAAAAAAAAAAAAAAAAAAAAAAAAAAAAWA8TdAAAAAAAgPYM0AEAaOrHw8OU3QAAAAAAAAAAAAAAAAAAAAAAAAAAAACsiwk6AAAAAABAWwboAAA09lIiomRXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOtigg4AAAAAANCOAToAAE2N51OJ2QAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAuJ0JOgAAAAAAQBsG6AAAtHeoz9kJAAAAAAAAAAAAAAAAAAAAAAAAAAAAwDqZoAMAAAAAACzPAB0AgOZqDCW7AQAAAAAAAAAAAAAAAAAAAAAAAAAAAFgvE3QAAAAAAIBlGaADANDccI0xuwEAAAAAAAAAAAAAAAAAAAAAAAAAAABYNxN0AAAAAACA5RigAwDQ3HCsJbsBAAAAAAAAAAAAAAAAAAAAAAAAAAAAWD8TdAAAAAAAgGUYoAMA0Nz1+O2S3QAAAAAAAAAAAAAAAAAAAAAAAAAAAABsgwk6AAAAAADA/RmgAwCQ4KVERMmuAAAAAAAAAAAAAAAAAAAAAAAAAAAAALbBBB0AAAAAAOC+DNABAGhuPJ9KzAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAwP2YoAMAAAAAANyPAToAADkO9Tk7AQAAAAAAAAAAAAAAAAAAAAAAAAAAANgWE3QAAAAAAID7MEAHACBFjaFkNwAAAAAAAAAAAAAAAAAAAAAAAAAAAADbY4IOAAAAAADwdQboAACkGK4xZjcAAAAAAAAAAAAAAAAAAAAAAAAAAAAA22SCDgAAAAAA8DUG6AAApBiOtWQ3AAAAAAAAAAAAAAAAAAAAAAAAAAAAANtlgg4AAAAAAPB5BugAAKS4Hr9dshsAAAAAAAAAAAAAAAAAAAAAAAAAAACAbTNBBwAAAAAA+BwDdAAAkryUiCjZFQAAAAAAAAAAAAAAAAAAAAAAAAAAAMC2maADAAAAAADczgAdAIAU4/lUYjZABwAAAAAAAAAAAAAAAAAAAAAAAAAAAJZngg4AAAAAAHAbA3QAANLUw/yU3QAAAAAAAAAAAAAAAAAAAAAAAAAAAADsgwk6AAAAAADAxxmgAwCQ5jjPU3YDAAAAAAAAAAAAAAAAAAAAAAAAAAAAsB8m6AAAAAAAAB9jgA4AQJpahym7AQAAAAAAAAAAAAAAAAAAAAAAAAAAANgXE3QAAAAAAIDfM0AHACBNfYxLdgMAAAAAAAAAAAAAAAAAAAAAAAAAAACwPyboAAAAAAAAv2aADgBAotcpIkp2BQAAAAAAAAAAAAAAAAAAAAAAAAAAALA/JugAAAAAAADvM0AHACDNeD6VmA3QAQAAAAAAAAAAAAAAAAAAAAAAAAAAgBwm6AAAAAAAAG8zQAcAINehPmcnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPtlgg4AAAAAAPBfBugAAKQa5rhkNwAAAAAAAAAAAAAAAAAAAAAAAAAAAAD7ZoIOAAAAAADwTwboAACkqnWYshsAAAAAAAAAAAAAAAAAAAAAAAAAAAAATNABAAAAAAD+ZoAOAECq+hiX7AYAAAAAAAAAAAAAAAAAAAAAAAAAAACACBN0AAAAAACA/zNABwAg2esUESW7AgAAAAAAAAAAAAAAAAAAAAAAAAAAACDCBB0AAAAAACDCAB0AgGTj+VRiNkAHAAAAAAAAAAAAAAAAAAAAAAAAAAAA+mGCDgAAAAAA7J0BOgAA6ephfspuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPiZCToAAAAAALBnBugAAKQ7zvOU3QAAAAAAAAAAAAAAAAAAAAAAAAAAAADwbyboAAAAAADAXhmgAwCQbh7mS3YDAAAAAAAAAAAAAAAAAAAAAAAAAAAAwFtM0AEAAAAAgD0yQAcAIN31+M0AHQAAAAAAAAAAAAAAAAAAAAAAAAAAAOiWCToAAAAAALA3BugAAKQbz9+nmGPK7gAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4jwk6AAAAAACwJwboAAD0YRim7AQAAAAAAAAAAAAAAAAAAAAAAAAAAACAXzFBBwAAAAAA9sIAHQCALtSh/pHdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPA7JugAAAAAAMAeGKADANCF4RpjdgMAAAAAAAAAAAAAAAAAAAAAAAAAAADAR5igAwAAAAAAW2eADgBAF+pjXLIbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD7KBB0AAAAAANgyA3QAADrxOkVEya4AAAAAAAAAAAAAAAAAAAAAAAAAAAAA+CgTdAAAAAAAYKsM0AEA6MJ4PpWImLI7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAG5hgg4AAAAAAGyRAToAAN2ow/yc3QAAAAAAAAAAAAAAAAAAAAAAAAAAAABwKxN0AAAAAABgawzQAQDoxnCNMbsBAAAAAAAAAAAAAAAAAAAAAAAAAAAA4DNM0AEAAAAAgC0xQAcAoBv1MS7ZDQAAAAAAAAAAAAAAAAAAAAAAAAAAAACfZYIOAAAAAABshQE6AAAdeZ0iomRXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHyWCToAAAAAALAFBugAAHRjPJ9KREzZHQAAAAAAAAAAAAAAAAAAAAAAAAAAAABfYYIOAAAAAACsnQE6AABdqcP8nN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAA8FUm6AAAAAAAwJoZoAMA0JXhGmN2AwAAAAAAAAAAAAAAAAAAAAAAAAAAAMA9mKADAAAAAABrZYAOAEBX6mNcshsAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7sUEHQAAAAAAWCMDdAAAOvM6RUTJrgAAAAAAAAAAAAAAAAAAAAAAAAAAAAC4FxN0AAAAAABgbQzQAQDoyng+lYiYsjsAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7skEHQAAAAAAWBMDdAAAulOH+Tm7AQAAAAAAAAAAAAAAAAAAAAAAAAAAAODeTNABAFMeA3YAACAASURBVAAAAIC1MEAHAKA7wzXG7AYAAAAAAAAAAAAAAAAAAAAAAAAAAACAJZigAwAAAAAAa2CADgBAd+pjXLIbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJZigg4AAAAAAPTOAB0AgA69TjHHlF0BAAAAAAAAAAAAAAAAAAAAAAAAAAAAsBQTdAAAAAAAoGcG6AAAdGc8n0oMw5TdAQAAAAAAAAAAAAAAAAAAAAAAAAAAALAkE3QAAAAAAKBXBugAAHRpiOtTdgMAAAAAAAAAAAAAAAAAAAAAAAAAAADA0kzQAQAAAACAHhmgAwDQpXmYL9kNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC2YoAMAAAAAAL0xQAcAoEvX4zcDdAAAAAAAAAAAAAAAAAAAAAAAAAAAAGA3TNABAAAAAICeGKADANCl8fx9ijmm7A4AAAAAAAAAAAAAAAAAAAAAAAAAAACAVkzQAQAAAACAXhigAwDQrXqYn7IbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFoyQQcAAAAAAHpggA4AQLeGa4zZDQAAAAAAAAAAAAAAAAAAAAAAAAAAAACtmaADAAAAAADZDNABAOhWfYxLdgMAAAAAAAAAAAAAAAAAAAAAAAAAAABABhN0AAAAAAAgkwE6AAAde51ijim7AgAAAAAAAAAAAAAAAAAAAAAAAAAAACCDCToAAAAAAJDFAB0AgG6N51OJQ33O7gAAAAAAAAAAAAAAAAAAAAAAAAAAAADIYoIOAAAAAABkMEAHAKBrwxyX7AYAAAAAAAAAAAAAAAAAAAAAAAAAAACATCboAAAAAABAawboAAD0bswOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMhmgg4AAAAAALRkgA4AQNd+PPy4RETJ7gAAAAAAAAAAAAAAAAAAAAAAAAAAAADIZoIOAAAAAAC0YoAOAEDXxvOpRMSU3QEAAMCf7N3bkdvYFUDRc01KOXRVj6sYqjOQMqAyAMvzOa66zADOgCHgXwTgjxnXvFpSP8g+uMBaEewMNgAAAAAAAAAAAAAAAAAAAAAAALAEJugAAAAAAMB7MEAHAGDxSkyn7AYAAAAAAAAAAAAAAAAAAAAAAAAAAACApTBBBwAAAAAA7s0AHQCAxZvL3Gc3AAAAAAAAAAAAAAAAAAAAAAAAAAAAACyJCToAAAAAAHBPBugAACzeuPvQR8SQ3QEAAAAAAAAAAAAAAAAAAAAAAAAAAACwJCboAAAAAADAvRigAwCweLV7uETEJTkDAAAAAAAAAAAAAAAAAAAAAAAAAAAAYHFM0AEAAAAAgHswQAcAoBHTObsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYIlM0AEAAAAAgFszQAcAoA1lrtkJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEtlgg4AAAAAANySAToAAE0Ydx/6iBiyOwAAAAAAAAAAAAAAAAAAAAAAAAAAAACWygQdAAAAAAC4FQN0AACaULuHS0RckjMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFs0EHQAAAAAAuAUDdAAAGjKdswsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAls4EHQAAAAAAeCsDdAAA2lHmmp0AAAAAAAAAAAAAAAAAAAAAAAAAAAAA0AITdAAAAAAA4C0M0AEAaMa4G2tEDNkdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC0wQQcAAAAAAF7LAB0AgGbU7jBExCW7AwAAAAAAAAAAAAAAAAAAAAAAAAAAAKAVJugAAAAAAMBrGKADANCUEtMpuwEAAAAAAAAAAAAAAAAAAAAAAAAAAACgJSboAAAAAADASxmgAwDQlLnMfXYDAAAAAAAAAAAAAAAAAAAAAAAAAAAAQGtM0AEAAAAAgJcwQAcAoCnjbqwRMWR3AAAAAAAAAAAAAAAAAAAAAAAAAAAAALTGBB0AAAAAAHguA3QAAJpSu8MQUfrsDgAAAAAAAAAAAAAAAAAAAAAAAAAAAIAWmaADAAAAAADPYYAOAEBzSozn7AYAAAAAAAAAAAAAAAAAAAAAAAAAAACAVpmgAwAAAAAAP2KADgBAc6770mU3AAAAAAAAAAAAAAAAAAAAAAAAAAAAALTMBB0AAAAAAPgeA3QAABr09RJzXLIrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFpmgg4AAAAAAHyLAToAAM2p3WGIf0z/ze4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAaJ0JOgAAAAAA8BQDdAAAmjSPpctuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFgDE3QAAAAAAOCvDNABAGjS9HFXsxsAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1sIEHQAAAAAA+CMDdAAAmlS7h0tE9NkdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGthgg4AAAAAAPyfAToAAA2bztkFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGtigg4AAAAAAEQYoAMA0LIy1+wEAAAAAAAAAAAAAAAAAAAAAAAAAAAAgLUxQQcAAAAAAAzQAQBo1rgba0QM2R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAa2OCDgAAAAAA22aADgBAs2p3GKJM5+wOAAAAAAAAAAAAAAAAAAAAAAAAAAAAgDUyQQcAAAAAgO0yQAcAoGnzVGp2AwAAAAAAAAAAAAAAAAAAAAAAAAAAAMBamaADAAAAAMA2GaADANC06UPU7AYAAAAAAAAAAAAAAAAAAAAAAAAAAACANTNBBwAAAACA7TFABwCgabV77COiz+4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAWDMTdAAAAAAA2BYDdAAAVmA6ZxcAAAAAAAAAAAAAAAAAAAAAAAAAAAAArJ0JOgAAAAAAbIcBOgAA7StzzU4AAAAAAAAAAAAAAAAAAAAAAAAAAAAA2AITdAAAAAAA2AYDdAAAmjfuxhoRQ3YHAAAAAAAAAAAAAAAAAAAAAAAAAAAAwBaYoAMAAAAAwPoZoAMA0LzaHYYo0zm7AwAAAAAAAAAAAAAAAAAAAAAAAAAAAGArTNABAAAAAGDdDNABAFiFeSxddgMAAAAAAAAAAAAAAAAAAAAAAAAAAADAlpigAwAAAADAehmgAwCwCtPHXY2IIbsDAAAAAAAAAAAAAAAAAAAAAAAAAAAAYEtM0AEAAAAAYJ0M0AEAWIXaPVwi4pKcAQAAAAAAAAAAAAAAAAAAAAAAAAAAALA5JugAAAAAALA+BugAAKxGiemU3QAAAAAAAAAAAAAAAAAAAAAAAAAAAACwRSboAAAAAACwLgboAACsxnVfuuwGAAAAAAAAAAAAAAAAAAAAAAAAAAAAgK0yQQcAAAAAgPUwQAcAYDVq99hHRJ/dAQAAAAAAAAAAAAAAAAAAAAAAAAAAALBVJugAAAAAALAOBugAAKzMdM4uAAAAAAAAAAAAAAAAAAAAAAAAAAAAANgyE3QAAAAAAGifAToAAKtSIrrsBgAAAAAAAAAAAAAAAAAAAAAAAAAAAICtM0EHAAAAAIC2GaADALAq1/21j4ghuwMAAAAAAAAAAAAAAAAAAAAAAAAAAABg60zQAQAAAACgXQboAACsSu0OQ5TpnN0BAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAk6AAAAAAC0ygAdAIAVmo/ZBQAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8ygQdAAAAAADaY4AOAMDqjLuxRsSQ3QEAAAAAAAAAAAAAAAAAAAAAAAAAAADAr0zQAQAAAACgLQboAACsTu0OQ5TpnN0BAAAAAAAAAAAAAAAAAAAAAAAAAAAAwO9M0AEAAAAAoB0G6AAArNR8zC4AAAAAAAAAAAAAAAAAAAAAAAAAAAAA4M9M0AEAAAAAoA0G6AAArNK4G2tEDNkdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPyZCToAAAAAACyfAToAAKtUu8MQZTpndwAAAAAAAAAAAAAAAAAAAAAAAAAAAADwdyboAAAAAACwbAboAACs1jyWLrsBAAAAAAAAAAAAAAAAAAAAAAAAAAAAgKeZoAMAAAAAwHIZoAMAsFrTx12NiCG7AwAAAAAAAAAAAAAAAAAAAAAAAAAAAICnmaADAAAAAMAyGaADALBatXu4RJQ+uwMAAAAAAAAAAAAAAAAAAAAAAAAAAACAbzNBBwAAAACA5TFABwBg1eZ5OmU3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAPB9JugAAAAAALAsBugAAKza9GHXRcSQ3QEAAAAAAAAAAAAAAAAAAAAAAAAAAADA95mgAwAAAADAchigAwCwarV7uESUPrsDAAAAAAAAAAAAAAAAAAAAAAAAAAAAgB8zQQcAAAAAgGUwQAcAYPXmeTplNwAAAAAAAAAAAAAAAAAAAAAAAAAAAADwPCboAAAAAACQzwAdAIDVmz7suogYsjsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeB4TdAAAAAAAyGWADgDA6tXu4RJR+uwOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJ7PBB0AAAAAAPIYoAMAsA3l+jk7AQAAAAAAAAAAAAAAAAAAAAAAAAAAAICXMUEHAAAAAIAcBugAAGzCuBtrRAzZHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAC8jAk6AAAAAAC8PwN0AAA2oXaHIcp0zu4AAAAAAAAAAAAAAAAAAAAAAAAAAAAA4OVM0AEAAAAA4H0ZoAMAsCHzMbsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgNcxQQcAAAAAgPdjgA4AwGaMu7FGxJDdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAMDrmKADAAAAAMD7MEAHAGAzancYokzn7A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAXs8EHQAAAAAA7s8AHQCAjZmP2QUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvI0JOgAAAAAA3JcBOgAAmzLuxhoRQ3YHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG9jgg4AAAAAAPdjgA4AwKbU7jBEmU/ZHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAC8nQk6AAAAAADchwE6AACbU+b5mN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAwG2YoAMAAAAAwO0ZoAMAsDm//PxTjYg+uwMAAAAAAAAAAAAAAAAAAAAAAAAAAACA2zBBBwAAAACA2zJABwBgk0pMp+wGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG7HBB0AAAAAAG7HAB0AgE267kuX3QAAAAAAAAAAAAAAAAAAAAAAAAAAAADAbZmgAwAAAADAbRigAwCwSbV77COiz+4AAAAAAAAAAAAAAAAAAAAAAAAAAAAA4LZM0AEAAAAA4O0M0AEA2Kx5nr9kNwAAAAAAAAAAAAAAAAAAAAAAAAAAAABweyboAAAAAADwNgboAABs1vTh6zEihuwOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG7PBB0AAAAAAF7PAB0AgM2q3WGIMp2zOwAAAAAAAAAAAAAAAAAAAAAAAAAAAAC4DxN0AAAAAAB4HQN0AAA2bj5mFwAAAAAAAAAAAAAAAAAAAAAAAAAAAABwPyboAAAAAADwcgboAABs2rgba0QM2R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAA3I8JOgAAAAAAvIwBOgAAm1a7w1Bi+pzdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAMB9maADAAAAAMDzGaADALB5133pshsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAuD8TdAAAAAAAeB4DdAAANq92j31E9NkdAAAAAAAAAAAAAAAAAAAAAAAAAAAAANyfCToAAAAAAPyYAToAAEREiemU3QAAAAAAAAAAAAAAAAAAAAAAAAAAAADA+zBBBwAAAACA7zNABwCAiLjur58iYsjuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOB9mKADAAAAAMC3GaADAEBE1O4wRJnO2R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAvB8TdAAAAAAAeJoBOgAA/KbM8Sm7AQAAAAAAAAAAAAAAAAAAAAAAAAAAAID3ZYIOAAAAAAB/Z4AOAAC/ue6vfUT02R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAvC8TdAAAAAAA+DMDdAAA+E3tDkOJ6ZTdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAMD7M0EHAAAAAIDfGaADAMAfXPeli4ghuwMAAAAAAAAAAAAAAAAAAAAAAAAAAACA92eCDgAAAAAAvzJABwCAP6jdYx9lOmd3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAJDDBB0AAAAAAAzQAQDgCfMxuwAAAAAAAAAAAAAAAAAAAAAAAAAAAACAPCboAAAAAABsnQE6AAD8xbgba0T02R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAA5DFBBwAAAABgywzQAQDgL2p3GEpMp+wOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHKZoAMAAAAAsFUG6AAA8ITrvnQRMWR3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAJDLBB0AAAAAgC0yQAcAgCfU7rGPMp2zOwAAAAAAAAAAAAAAAAAAAAAAAAAAAADIZ4IOAAAAAMDWGKADAMA3zcfsAgAAAAAAAAAAAAAAAAAAAAAAAAAAAACWwQQdAAAAAIAtMUAHAIBvGHdjjYg+uwMAAAAAAAAAAAAAAAAAAAAAAAAAAACAZTBBBwAAAABgKwzQAQDgG2p3GEpMp+wOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJbDBB0AAAAAgC0wQAcAgO+47vfHiBiyOwAAAAAAAAAAAAAAAAAAAAAAAAAAAABYDhN0AAAAAADWzgAdAAC+o3YPlyjTObsDAAAAAAAAAAAAAAAAAAAAAAAAAAAAgGUxQQcAAAAAYM0M0AEA4AfKHJ+yGwAAAAAAAAAAAAAAAAAAAAAAAAAAAABYHhN0AAAAAADWygAdAAB+4Jeff6oR0Wd3AAAAAAAAAAAAAAAAAAAAAAAAAAAAALA8JugAAAAAAKyRAToAADzDPM2fsxsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWCYTdAAAAAAA1sYAHQAAnmH6+LWLiCG7AwAAAAAAAAAAAAAAAAAAAAAAAAAAAIBlMkEHAAAAAGBNDNABAOAZancYIqYv2R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAALJcJOgAAAAAAa2GADgAAzzTuyzG7AQAAAAAAAAAAAAAAAAAAAAAAAAAAAIBlM0EHAAAAAGANDNABAOCZavfYR5lO2R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAALJsJOgAAAAAArTNABwCAF5mP2QUAAAAAAAAAAAAAAAAAAAAAAAAAAAAALJ8JOgAAAAAALTNABwCAF/jPv//ZRUSf3QEAAAAAAAAAAAAAAAAAAAAAAAAAAADA8pmgAwAAAADQKgN0AAB4obnMX7IbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGiDCToAAAAAAC0yQAcAgBeadl+PETFkdwAAAAAAAAAAAAAAAAAAAAAAAAAAAADQBhN0AAAAAABaY4AOAAAvVLvDUGL6nN0BAAAAAAAAAAAAAAAAAAAAAAAAAAAAQDtM0AEAAAAAaIkBOgAAvMJ1X7qIGLI7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAGiHCToAAAAAAK0wQAcAgFeo3WMfZTpndwAAAAAAAAAAAAAAAAAAAAAAAAAAAADQFhN0AAAAAABaYIAOAACvVOb4lN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAQHtM0Leldg+XmOOS3QEAAAAA8BIG6AAA8Eq//PxTjYg+uwMAAAAAAAAAAAAAAAAAAAAAAAAAAACA9pigAwAAAACwZAboAADwFmX8V3YCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG0yQQcAAAAAYKkM0AEA4A3G3Vgjos/uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKBNJugAAAAAACyRAToAALxB7Q7DXOYv2R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAtMsEHQAAAACApTFABwCAN5p2X48RMWR3AAAAAAAAAAAAAAAAAAAAAAAAAAAAANAuE3QAAAAAAJbEAB0AAN6odoehxPQ5uwMAAAAAAAAAAAAAAAAAAAAAAAAAAACAtpmgAwAAAACwFAboAABwA9f9/hgRQ3YHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG0zQQcAAAAAYAkM0AEA4AZq93CJMp+yOwAAAAAAAAAAAAAAAAAAAAAAAAAAAABonwk6AAAAAADZDNABAOBGxl18ym4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAYB1M0AEAAAAAyGSADgAAN1K7xz7KdMruAID/sXdvx41jVwBFD0TYOaiK6jJDcgjKYJQBlYGYgZQBplrVX2oVQmAIDAH/InD94Rq7Z6YfehA8JLBWBDuDDQAAAAAAAAAAAAAAAAAAAAAAAAAATIMJOgAAAAAAWQzQAQDggKoSd9kNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEyHCToAAAAAABkM0AEA4ICeHq/aiKrN7gAAAAAAAAAAAAAAAAAAAAAAAAAAAABgOkzQAQAAAAA4NgN0AAA4tGq/yU4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAYFpM0AEAAAAAOCYDdAAAOLCvnz81EbHN7gAAAAAAAAAAAAAAAAAAAAAAAAAAAABgWkzQAQAAAAA4FgN0AAAYQRnKJrsBAAAAAAAAAAAAAAAAAAAAAAAAAAAAgOkxQQcAAAAA4BgM0AEAYATDP1+aiNhmdwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwPSboAAAAAACMzQAdAABG0DarrlTlIbsDAAAAAAAAAAAAAAAAAAAAAAAAAAAAgGkyQQcAAAAAYEwG6AAAMJJh8XJfSuyyOwAAAAAAAAAAAAAAAAAAAAAAAAAAAACYJhN0AAAAAADGYoAOAAAjaZtVFxdlk90BAAAAAAAAAAAAAAAAAAAAAAAAAAAAwHSZoAMAAAAAMAYDdAAAGNGweLmPiC67AwAAAAAAAAAAAAAAAAAAAAAAAAAAAIDpMkEHAAAAAODQDNABAGBEbbPqqhg22R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAATJsJOgAAAAAAh2SADgAAI9vX+7uI6LI7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAJg2E3QAAAAAAA7FAB0AAEbWNquuimGT3QEAAAAAAAAAAAAAAAAAAAAAAAAAAADA9JmgAwAAAABwCAboAABwBPt6fxcRXXYHAAAAAAAAAAAAAAAAAAAAAAAAAAAAANNngg4AAAAAwEcZoAMAwBG0zaqrYthkdwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwDyboAAAAAAB8hAE6AAAcyb7e30VEl90BAAAAAAAAAAAAAAAAAAAAAAAAAAAAwDyYoAMAAAAA8F4G6AAAcCRts+oihofsDgAAAAAAAAAAAAAAAAAAAAAAAAAAAADmwwQdAAAAAID3MEAHAIAj6uv6LiK67A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAA5sMEHQAAAACAtzJABwCAI2qby13E8JDdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAMC8mKADAAAAAPAWBugAAHBkfV3fRUSX3QEAAAAAAAAAAAAAAAAAAAAAAAAAAADAvJigAwAAAADwWgboAABwZG1zuati2GR3AAAAAAAAAAAAAAAAAAAAAAAAAAAAADA/JugAAAAAALyGAToAACTY1/u7iOiyOwAAAAAAAAAAAAAAAAAAAAAAAAAAAACYHxN0AAAAAAB+xQAdAAAStM2qq2LYZHcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAME8m6AAAAAAA/IwBOgAAJNnX+7uI6LI7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAJgnE3QAAAAAAH7EAB0AAJK0zaqrYthkdwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwXyboAAAAAAB8jwE6AAAk2tf7u1Jil90BAAAAAAAAAAAAAAAAAAAAAAAAAAAAwHyZoAMAAAAA8FcG6AAAkKhtVl1clE12BwAAAAAAAAAAAAAAAAAAAAAAAAAAAADzZoIOAAAAAMC3DNABACDZsHi5LyV22R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAzJsJOgAAAAAAfzBABwCAZG2z6uKibLI7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAEHQAAAACACAN0AAA4CcPi5T4ittkdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGCCDgAAAACAAToAAJyAtll1ZSib7A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAiDBBBwAAAACYOwN0AAA4Ec9flvcRsc3uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAIE3QAAAAAgDkzQAcAgFNS9bfZCQAAAAAAAAAAAAAAAAAAAAAAAAAAAADwBxN0AAAAAIB5MkAHAIAT8vXzpyaiarM7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAPJugAAAAAAPNjgA4AACemiv42uwEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvmWCDgAAAAAwLwboAABwYp4er9qoht+zOwAAAAAAAAAAAAAAAAAAAAAAAAAAAADgWyboAAAAAADzYYAOAAAnqF9U64josjsAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4Fsm6AAAAAAA82CADgAAJ6htltuoyu/ZHQAAAAAAAAAAAAAAAAAAAAAAAAAAAADwVyboAAAAAADTZ4AOAAAnql8s1hHRZXcAAAAAAAAAnNwloQAAIABJREFUAAAAAAAAAAAAAAAAAAAAwF+ZoAMAAAAATJsBOgAAnKi2udxFDA/ZHQAAAAAAAAAAAAAAAAAAAAAAAAAAAADwPSboAAAAAADTZYAOAAAnrK/361Jil90BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAN9jgg4AAAAAME0G6AAAcMLaZtXFRdlkdwAAAAAAAAAAAAAAAAAAAAAAAAAAAADAj5igAwAAAABMjwE6AACcuGHxch8R2+wOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgRE3QAAAAAgGkxQAcAgBPXNqsuqv42uwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfsYEHQAAAABgOgzQAQDgDHz9/KmJqNrsDgAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4GRN0AAAAAIBpMEAHAIAz0dfDTXYDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPyKCToAAAAAwPkzQAcAgDPRNsttVOUhuwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfsUEHQAAAADgvBmgAwDAGekXi3VEdNkdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPArJugAAAAAAOfLAB0AAM5I21zuIoaH7A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAeA0TdAAAAACA82SADgAAZ6av9+tSYpfdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAACvYYIOAAAAAHB+DNABAODMtM2qi1JuszsAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4LVM0AEAAAAAzosBOgAAnKHnL8v7iNhmdwAAAAAAAAAAAAAAAAAAAAAAAAAAAADAa5mgAwAAAACcDwN0AAA4U1UMN9kNAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPAWJugAAAAAAOfBAB0AAM7U0+NVG1V5yO4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAgLcwQQcAAAAAOH0G6AAAcMb6xWIdEV12BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAC8hQk6AAAAAMBpM0AHAIAz1jaXu1KV2+wOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHgrE3QAAAAAgNNlgA4AAGduWLzclxK77A4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAeCsTdAAAAACA02SADgAAZ65tVl110d9kdwAAAAAAAAAAAAAAAAAAAAAAAAAAAADAe5igAwAAAACcHgN0AACYgK+fPzURVZvdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAADvYYIOAAAAAHBaDNABAGAi+nq4iYguuwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3sMEHQAAAADgdBigAwDARLTNchsxPGR3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAMB7maADAAAAAJwGA3QAAJiQvt6vS4lddgcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvJcJOgAAAABAPgN0AACYkLZZdVHKbXYHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHyECToAAAAAQC4DdAAAmJjnL8v7iKrN7gAAAAAAAAAAAAAAAAAAAAAAAAAAAACAjzBBBwAAAADIY4AOAAAT1NfDTUR02R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAA8BEm6AAAAAAAOQzQAQBggtpmuY0YHrI7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAOCjTNABAAAAAI7PAB0AACaqr/frUmKX3QEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH2WCDgAAAABwXAboAAAwUW2z6qKU2+wOAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgEE3QAAAAAgOMxQAcAgAl7/rK8j2r4PbsDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7BBB0AAAAA4DgM0AEAYOL6Rf1bRHTZHQAAAAAAAAAAAAAAAAAAAAAAAAAAAABwCCboAAAAAADjM0AHAICJa5vLXanKbXYHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAByKCToAAAAAwLgM0AEAYAaGxct9RGyzOwAAAAAAAAAAAAAAAAAAAAAAAAAAAADgUEzQAQAAAADGY4AOAAAz0DarrorhJrsDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7JBB0AAAAAYBwG6AAAMBNPj1dtxLDJ7gAAAAAAAAAAAAAAAAAAAAAAAAAAAACAQzJBBwAAAAA4PAN0AACYkb7er0uJXXYHAAAAAAAAAAAAAAAAAAAAAAAAAAAAABySCToAAAAAwGEZoAMAwIy0zaqLUm6zOwAAAAAAAAAAAAAAAAAAAAAAAAAAAADg0EzQAQAAAAAOxwAdAABm5vnL8j6iarM7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAODQTNABAAAAAA7DAB0AAGaor6vriOiyOwAAAAAAAAAAAAAAAAAAAAAAAAAAAADg0EzQAQAAAAA+zgAdAABmqG0ud6Uqt9kdAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAGE3QAAAAAgI8xQAcAgJkaFi/3EbHN7gAAAAAAAAAAAAAAAAAAAAAAAAAAAACAMZigAwAAAAC8nwE6AADMVNusur4u1xHRZbcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwBhM0AEAAAAA3scAHQAAZqxtltsqhk12BwAAAAAAAAAAAAAAAAAAAAAAAAAAAACMxQQdAAAAAODtDNABAGDm9vX+LiK22R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBYTdAAAAACAtzFABwCAmWubVVfFcJPdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABjMkEHAAAAAHg9A3QAACCeHq/aiGGT3QEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYzJBBwAAAAB4HQN0AAAgIiL6er8uJXbZHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwJhN0AAAAAIBfM0AHAAAiIqJtVt1FNVxndwAAAAAAAAAAAAAAAAAAAAAAAAAAAADA2EzQAQAAAAB+zgAdAAD4n6fHqzZi2GR3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAMDYTNABAAAAAH7MAB0AAPiTvt6vS4lddgcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAjM0EHQAAAADg+wzQAQCAP2mbVXdRDdfZHQAAAAAAAAAAAAAAAAAAAAAAAAAAAABwDCboAAAAAAB/Z4AOAAD8zdPjVRsxbLI7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAYTNABAAAAAP7MAB0AAPiuvt6vS4lddgcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHIMJOgAAAADA/xmgAwAA39U2q+6iGq6zOwAAAAAAAAAAAAAAAAAAAAAAAAAAAADgWEzQAQAAAAD+ywAdAAD4oafHqzZi2GR3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAMCxmKADAAAAABigAwAAv9DX+3UpscvuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBjMUEHAAAAAObOAB0AAPiptll1F9Vwnd0BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMdkgg4AAAAAzJkBOgAA8EtPj1dtFcNtdgcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHJMJOgAAAAAwVwboAADAq+zr/V1EbLM7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAOCYTNABAAAAgDkyQAcAAF6lbVZdX5friOiyWwAAAAAAAAAAAAAAAAAAAAAAAAAAAADgmEzQAQAAAIC5MUAHAABerW2W2yqGTXYHAAAAAAAAAAAAAAAAAAAAAAAAAAAAABybCToAAAAAMCcG6AAAwJvs6/1dRNVmdwAAAAAAAAAAAAAAAAAAAAAAAAAAAADAsZmgAwAAAABzYYAOAAC8Sdusur6uriOiy24BAAAAAAAAAAAAAAAAAAAAAAAAAAAAgGMzQQcAAAAA5sAAHQAAeLO2udyVqtxmdwAAAAAAAAAAAAAAAAAAAAAAAAAAAABABhN0AAAAAGDqDNABAIB3ef68vIuqPGR3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAGE3QAAAAAYMoM0AEAgHfrF4t1KbHL7gAAAAAAAAAAAAAAAAAAAAAAAAAAAACADCboAAAAAMBUGaADAADv1jaXu+qiv8nuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAsJugAAAAAwBQZoAMAAB/y9fOnJmLYZHcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQBYTdAAAAABgagzQAQCAD+vr/ToittkdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJDFBB0AAAAAmBIDdAAA4MPaZtX1dbmOiC67BQAAAAAAAAAAAAAAAAAAAAAAAAAAAACymKADAAAAAFNhgA4AABxE2yy3pSq32R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAkMkEHQAAAACYAgN0AADgYJ4/L++ixO/ZHQAAAAAAAAAAAAAAAAAAAAAAAAAAAACQyQQdAAAAADh3BugAAMBB9f+4+K2U2GV3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAmE3QAAAAA4JwZoAMAAAfVNpe7i2q4zu4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAgGwm6AAAAADAuTJABwAADu7p8aqtYrjN7gAAAAAAAAAAAAAAAAAAAAAAAAAAAACAbFUM66jiX9kdAAAAAABvYYAOAACMYl/v7yJim90BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvI0BOgAAMIq2WXV9ffHvUmKX3QIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC8ngE6AAAwmra53EUpt9kdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwOsZoAMAAKN6/rK8jxg22R0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA6xigAwAAo+vr/ToittkdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwK8ZoAMAAKNrm1XX1xf/joguuwUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4OQN0AADgKNrmcleGcpPdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPycAToAAHA0z1+W9xHDJrsDAAAAAP7D3r0cOZGlARj9U0hGKEKqaHky8mDKA8oD8EDyoNoD8CAJKVipKtKEMiF3vc0tUJl3Fgw9MNDdPFS6+TjHgs+DDwAAAAAAAAAAAAAAAAAAAAAAAAAABq+I3/717z9+y50BAMA4GaADAAAX1c4fdxHxkLsDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+DYDdAAA4KKqctO089l1RDS5WwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICvGaADAAAXV5XLOnXpZe4OAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4GsG6AAAQBb3b1eviuj2uTsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACALxmgAwAA2TzOH28j4iF3BwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPA/BugAAEA2Vblp2vnsOqWoc7cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHxmgAwAAWVXlsi5m7cvcHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBHBugAAEB2d4ersohun7sDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMEAHAAB64nRc7yLFm9wdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMHUG6AAAQG+0i9mLlKLO3QEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABTZoAOAAD0RlUu624x20ZEk7sFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAApsoAHQAA6JWqXNapSPvcHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADBVBugAAEDv3B9Wt0V0JugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQgQE6AADQS4/zx9uIosrdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFNjgA4AAPRSVW6adl7cpBR17hYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYEgN0AACgt6pyWXeLdB0RTe4WAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmAoDdAAAoNeqcvWQirTP3QEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABTYYAOAAD03v1hdVtEZ4IOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAF2CADgAADMLj/PE2oqhydwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMDYGaADAACDUJWbpp0XNylFnbsFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxswAHQAAGIyqXNbdYraNiCZ3CwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIyVAToAADAoVbmsU5de5u4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAsTJABwAABuf+7epVEd0+dwcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACMkQE6AAAwSKfjehdFep27AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMbGAB0AABis9tmHFylFnbsDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxsQAHQAAGKyq3DTdYrY1QQcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDzMUAHAAAGrSqXdbdI1xHR5G4BAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAMTBABwAABq8qVw+pSPvcHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAGBugAAMAo3B9Wt0V0JugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwiwzQAQCA0Tgd17so0uvcHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADBkBugAAMCotM8+vIiIh9wdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMFQG6AAAwKhU5aZp57PrlKLO3QIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABDZIAOAACMTlUu624x25qgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwI8zQAcAAEapKpd1MWtfRkSTuwUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACGxAAdAAAYrbvDVVlE93vuDgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgSA3QAAGDUTsf1rohun7sDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhsIAHQAAGL3Tcb2LIr3O3QEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABDYIAOAABMQvvsw4uIosrdAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH1ngA4AAExCVW6adl7cpBR17hYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADoMwN0AABgMqpyWXeL2dYEHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP6aAToAADApHyfo6ToimtwtAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0EcG6AAAwORU5eohivYmdwcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD0kQE6AAAwSXeHq7KIbp+7AwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPrGAB0AAJis03G9M0EHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACALxmgAwAAk2aCDgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAF8yQAcAACbvdFzvIsWb3B0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQBwboAAAAEdEu3j+PiIfcHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJCbAToAAEBEVOWmaeez65Sizt0CAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAORmgAwAA/FdVLutuMduaoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADBlBugAAACfMUEHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABg6gzQAQAA/s+nCXpENLlbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4NIM0AEAAL6hKpd1FO1NmKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwMQboAAAAf+HucFWmIu1zdwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAlGaADAAD8jfvD6raIzgQdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAyTBABwAA+Aen43pngg4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBUGKADAAB8BxN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAApsIAHQAA4DuZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAFBugAAAA/wAQdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAsTNABwAA+EGP88fbSPEmdwcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8BQN0AACAH1SVm6ZdvH9ugg4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAYGaADAAD8hD8n6FFUuVsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgnAzQAQAAflJVbpp2XtykFHXuFgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgXA3QAAIBfUJXLulvMtiboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAjIUBOgAAwC8yQQcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGBMDNABAADOwAQdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAsTBABwAAOBMTdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMbAAB0AAOCMTNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYOgN0AACAMzNBBwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYMgM0AEAAJ6ACToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABDZYAOAADwREzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGCIDdAAAgCdkgg4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMDQGKADAAA8MRN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhsQAHQAA4AJM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgKA3QAAIALMUEHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgCAzQAQAALsgEHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgL4zQAcAALgwE3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD6zAAdAAAgAxN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+soAHQAAIBMTdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPrIAB0AACAjE3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD6xgAdAAAgMxN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+sQAHQAAoAdM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOgLA3QAAICeMEEHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACgDwzQAQAAeuTTBD2iqHK3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAME0G6AAAAD1Tlcu6nb+7jhRvcrcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwPQboAAAAPVSVm6ZdvH8eRXqduwUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBpMUAHAADoqarcNHeH1fMiun3uFgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKbDAB0AAKDnTsf1zgQdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACASzFABwAAGAATdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC7FAB0AAGAgTNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC4BAN0AACAATFBBwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4KkZoAMAAAzM6bjepS7dRESTuwUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDxMUAHAAAYoPu3q1dRtDcpRZ27BQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgHExQAcAABiou8NV2S1mWxN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAzskAHQAAYMCqclmboAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHBOBugAAAADZ4IOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAORmgAwAAjMCnCXpEUeVuAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYNgM0AEAAEaiKpd1O393HdH9nrsFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACA4TJABwAAGJGq3DR3x/WLIrp97hYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACGyQAdAABghE7H9c4EHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgJ9hgA4AADBSn03Qm9wtAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABzpU6gAAAgAElEQVQAAAAADIcBOgAAwIidjutdFO1NSlHnbgEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAYDNABAABG7u5wVXaL2dYEHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgO9hgA4AADABVbmsTdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4HgboAAAAE/Fpgh5RVLlbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA6C8DdAAAgAmpymXdzt9dF9Htc7cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQTwboAAAAE1OVm+Z0XO9M0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgWA3QAAICJ+myC3uRuAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoD8M0AEAACbsdFzv2nnaphR17hYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD6wQAdAABg4qpy9dAtZiboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARIQBOgAAABFRlcu6W8y2EfGQuwUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIC8DNABAACIiI8T9Hb+fltEt8/dAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQD4G6AAAAPypKjfN6bjemaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABMlwE6AAAAXzkd17vUpZuUos7dAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwGUZoAMAAPBN929Xr7rFbGuCDgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMC0G6AAAAPylqlzW3WK2jYiH3C0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABchgE6AAAAf6sql3U7f78totvnbgEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAODpGaADAADwj6py05yO650JOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwPgZoAMAAPDdTsf1Lor2OqWoc7cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwNAzQAQAA+CF3h6uyW8y2JugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADjZIAOAADAD6vKZd0tZtso0uvcLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJyXAToAAAA/pSqX9d1h9byIbp+7BQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgPMxQAcAAOCXnI7rXSrSy5Sizt0CAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADArzNABwAA4JfdH1a33WK2NUEHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYPgN0AAAAzqIql3W3mG2j6N7kbgEAAACA/7B3P8dtnHkChn9fG7z7iiLgIjIQIxDg0VEuwxGIikDaCAbIYJSBlEG70JoTwOoQlMF2jVTFq847RH97cHk945U9EkXww5/nieDN4AUAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7s4AHQAAgHvT1sNusxrPU/TL0i0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADcjQE6AAAA927djBe5z89zjq50CwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAF/GAB0AAICduP776HV/Vs1M0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA6LAToAAAA709bDrj/7n8uI/lXpFgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD6PAToAAAA71daTj5tm/DJFv4yIj6V7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+HMG6AAAADyIdTNebAd5lnN0pVsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4YwboAAAAPJi2Hr3rz6pZpP7n0i0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8mgE6AAAAD6qth91mNZ6n6JelWwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPj/DNABAAAoYt2MF5G2P+UcXekWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfmOADgAAQDGb1Xd1f1bNIuJd6RYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB+YYAOAABAUW097DbN+WWKflm6BQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAN0AAAA9sS6GS8ibX/KObrSLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKfMAB0AAIC9sVl9V/dn1Swi3pVuAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOFUG6AAAAOyVth52m+b8MkW/LN0CAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwigzQAQAA2EvrZrxI0c9yjq50CwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwCkxQAcAAGBvrZtx259Vs0j9z6VbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAToUBOgAAAHutrYfdZjWep+iXpVsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABOgQE6AAAAB2HdjBfbQTXJObrSLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMfMAB0AAICD0dbDrj+rZhH9q9ItAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAx8oAHQAAgIPS1sNu04xf5pT/K+foSvcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcGwN0AAAADtL1avS3/qyaRcS70i0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADHxAAdAACAg9XWw27TnF+m6JelWwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAI6FAToAAAAHb92MF9tBvsw5utItAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAh84AHQAAgKPQ1qN3/Vk1S9EvS7cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcMgN0AAAAjkZbD7t1M15E2v6Uc3SlewAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA6RAToAAABHZ7P6ru7Pqlmk/ufSLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIfGAB0AAICj1NbDbrMaz1P0y5yjK90DAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwKAzQAQAAOGrrZrzoz6pZRLwr3QIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAIDNABAAA4em097DbN+WWKfhkRH0v3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7DMDdAAAAE7GuhkvtoPqMufoSrcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADsKwN0AAAATkpbD7vrt+eTFP2ydAsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMA+MkAHAADgJK2b8WI7qCY5R1e6BQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYJ8YoAMAAHCy2nrYXb89n6Tol6VbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA9oUBOgAAACdv3YwX20E1yTm60i0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAClGaADAABARLT1sLt+ez5J0S9LtwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJRkgA4AAAD/Yt2MF9tBNck5utItAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJRigAwAAwO+09bC7fns+SdEvI+Jj6R4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICHZIAOAAAAf2DdjBfbQXUZkdvSLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/FAB0AAAD+RFsPu00zmqXolzlHV7oHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABg1wzQAQAA4DOsm/GiP6tmkfqfS7cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADskgE6AAAAfKa2Hnab1XieU36ec3SlewAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHbBAB0AAAC+0PVq9Lo/q2YR/avSLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPfNAB0AAADuoK2H3aYZv0zRz3KOrnQPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAfTFABwAAgK+wbsbt9dvzSYp+GREfS/cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8LQN0AAAAuAfrZrzYDqrLiNyWbgEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgaBugAAABwT9p62G2a0Syn/Dzn6Er3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3IUBOgAAANyz69XodX9WzVL0y9ItAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAX8oAHQAAAHagrYfduhkvtoN8GRHvSvcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8LgN0AAAA2KG2Hr3bNOeXKfplztGV7gEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPhPDNABAADgAayb8aI/q2aR8pvSLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH/GAB0AAAAeSFsPu81qdJWin+UcXekeAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACATzFABwAAgAe2bsbt9dvzSYp+aYQOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADsGwN0AAAAKGTdjBf9WTWL6F+VbgEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPiVAToAAAAU1NbDbtOMX24H+TIit6V7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADNABAABgD7T16N2mGc1yys9zjq50DwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcLoM0AEAAGCPXK9Gr/uzapaiX0bEx9I9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA6TFABwAAgD3T1sNu3YwX20F1GSm/Kd0DAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACcFgN0AAAA2FNtPew2q9FVin6Wc3SlewAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgNNggA4AAAB7bt2M2+u355Oc8nMjdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYNcM0AEAAOBAXK9Gr/uzapaiXxqhAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAu2KADgAAAAekrYfduhkv+rNqFim/Kd0DAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcHwN0AAAAOEBtPew2q9HVdlBNInJbugcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgeBugAAABwwNp62G2a0SxFP8s5utI9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA4TNABwAAgCOwbsbt9dvzSU75uRE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwNQzQAQAA4Ihcr0av+7NqlqJfGqEDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB3kUoHAAAAALsxnd9cDG5vr3JUfy3dAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwP3bDqpJWw+70h0AAByfqnQAAAAAsBttPezWzXixHVSTSPlN6R4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAwGKADAADAkWvrYbdZja5+GaH3P5fuAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA9psBOgAAAJyIX0bo43mKfhaR29I9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAfjJABwAAgBOzbsbtphnNjNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBPMUAHAACAE/XrCD3S9qecoyvdAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7AcDdAAAADhxm9V39fXb80lO+bkROgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYIAOAAAARETE9Wr02ggdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwQAcAAAD+jRE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACcNgN0AAAA4JOM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4DQZoAMAAAB/yggdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABOiwE6AAAA8FmM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4DQYoAMAAABfxAgdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACOmwE6AAAAcCdG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcJwM0AEAAICv8usIPUU/i8ht6R4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAODrGKADAAAA92LdjNtNM5oZoQMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwGEzQAcAAADu1b+N0FN+U7oHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4MgboAAAAwE6sm3G7WY2utoNqYoQOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACHwwAdAAAA2Km2Hnb/N0KP/lXO0ZVuAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/lgqHQAAAACclun85mJwe3vV5+pZSnFRugcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOBQbQfVpK2HXekOAACOjwE6AAAAUMz3P3y4ij791QgdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgyxmgAwCwK1XpAAAAAOB0Xa9Gr6/fnk9S9LOI3JbuAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADNABAACAPbBuxu2mGc22g3wZKb8p3QMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKcslQ4AAAAA+L3p/OZicHt71efqWUpxUboHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgH20H1aSth13pDgAAjo8BOgAAALDXvv/hw1XK6UVEPCrdAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsE8M0AEA2JWqdAAAAADAn7lejV5vmvPLFP0sIrelewAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4NgZoAMAAAAHYd2M200zmm0H1SRSfpNzdKWbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgGKXSAQAAAAB3MZ3fXFTb7TTl9CIiHpXuAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeGjbQTVp62FXugMAgONjgA4AAAAcvCdP309zSleR07PSLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/FAB0AgF0xQAcAAACOxnR+czG4vb3qc/Uspbgo3QMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALBLBugAAOyKAToAAABwlP7ywz/mkasXEWlaugUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAXDNABANiVqnQAAAAAwC5sVt/Vm2Y02w6qSUT/KufoSjcBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAhSKUDAAAAAB7K9z98uEo5nkWkaekWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAr7UdVJO2HnalOwAAOD4G6AAAAMDJmc5vLr65vX2Zc/VjSnFRugcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAuDNABANgVA3QAAADgpP3lh3/MI1cvItK0dAsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMCXMEAHAGBXDNABAAAAImI6v7mo/rmdR6QXKcVF6R4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAID/xAAdAIBdMUAHAAAA+J0nT99Pc0pXkdOPEfFt6R4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBPMUAHAGBXDNABAAAA/sB0fnNRbbfTlONZRJqW7gEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPhXBugAAOyKAToAAADAZ5jOby6+ub19mXP1Y0pxUboHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAAB0AgF0xQAcAAAD4Qk+evp/mlK5ynx6boQMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKUYoAMAsCsG6AAAAAB3NJ3/97ffbL+ZRq5eRKRp6R4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOC0GKADALArBugAAAAA92A6v7motttpyvHMDB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHgIBugAAOyKAToAAADAPftthp5eRMSj0j0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBxMkAHAGBXDNABAAAAdmg6//BocJvnfa6epRQXpXsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDjYYAOAMCuGKADAAAAPJAnT99Pc0pXuU+PzdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICvZYAOAMCuGKADAAAAFGCGDgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfC0DdAAAdsUAHQAAAKAwM3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAuDNABANgVA3QAAACAPfLk6ftpjphHVI8j4lHpHgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYH8ZoAMAsCsG6AAAAAB7ajr/8Ghwm+c50uOINC3dAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7BcDdAAAdsUAHQAAAOAATOc3F9V2O005npmhAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEQboAADsjgE6AAAAwIH5bYaefoyIaUR8WzgJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAowAAdAIBdMUAHAAAAOHBPnr6f5pSucp8epxQXpXsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICHYYAOAMCuGKADAAAAHJHp/MOj6p/VNKX+x4g0Ld0DAAAAAAAAAAAAAAAAAAAAAPwve3dv3EaWhWH4XKDltytLPRGgM5ieKpmqUmcwoUxKymAVwmZAVolVdMcngLsGKS1nJFEEiYvbP89jHeMYXwYvAAAAAAAAQDkC6AAAlCKADgAAALBQw3jbbQ93feTtnzlHn1J0tTcBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADnI4AOAEApAugAAAAAK/H+w5chR4wRaReRhtp7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAACA1xFABwCgFAF0AAAAgBUaxttue7jrIzZjPqbfU4qu9iYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOA0AugAAJQigA4AAABADONNv7nbDCkdP0akPiLa2psAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICnCaADAFCKADoAAAAA33n/4cuQI8aItItIQ+09AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA9wTQAQAoRQAdAAAAgCcN41W7PWyHiM0YOe0ioq+9CQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEEAHAKAcAXQAAAAATjKMt932cNcLogMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQF0C6AAAlCKADgAAAMCrCKIDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAdAugAAJQigA4AAADAWX0Louc0RKRdRBpqbwIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgCUSQAcAoBQBdAAAAACKGsarttk3/TFv+5SOHyNSHxFt7V0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADB3AugAAJQigA4AAADAxQ3jTb85RJ9y+hgRXUT0lScBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMDsCKADAFCKADoAAAAA1Q3jVdvsmz5HjBFpF5H6iGhr7wIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgCkTQAcAoBQBdAAAAAAmaRhv+u3h2EVOgyg6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8TwAdAIBSBNABAAAAmI33H74Mx5S6FDFEjncRaai9CQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAahFABwCgFAF0AAAAAGbt/YcvQ065jZyGiLSLSH1EtLV3AQAAAAAAAAAAAAAAAAAAAAAAAAAAAABAaQLoAACUIoAOAAAAwOIM402/PRy7R1H0NiL62rsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOCcBNABAChFAB0AAACAVRjGq7bZN/0xb/uUDt1DGL2PiLb2NgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeAkBdAAAShFABwAAAGDVhvGmb/a5vQ+j598jciuMDgAAAAAAAAAAAAAAAAAAAAAAAAAAAADAHAigAwBQigA6AAAAAPzAMF61zb7p78Pohy4i7SJSGxF97W0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAhgA4AQDkC6AAAAABwgmG8aiPedNvDscs59Sk2u4jcRqQ+Itra+wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWA8BdAAAShFABwAAAIAzGcarttk3fU65zcemS5u8i5y7iNRGRF97HwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAyyKADgBAKQLoAAAAAHAhw3jbNft9l1Nuc059Spt3AukAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALyUADoAAKUIoAMAAADARAzjVdvsmymcLtIAACAASURBVD4i4pi3faRDm2Kzi8jtQyS9i4i26kgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACZDAB0AgFIE0AEAAABgRobxqo140zX73OaU23xsukiHNqXNu8i5i4iInLpI0dXcCQAAAAAAAAAAAAAAAAAAAAAAAAAAAABAeQLoAACU0tQeAAAAAAA83+dPv/0dEf99zu/jWHpExPGYutjcR9Lvg+nRRuQ2IrWRoxVNBwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiBNABAAAAYLFOiaU/Noy3XUREs993ERE55TYfNm2kTRvp0EY8BNQj4v8R9Qc5dd9uQXUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmCUBdAAAAADgHz5/env9cF4/8Xayr2H1x75G1p9yPKZf/gAAAAAAAAAAAAAAAAAAAAAAAJxVSn+lFF3tGQAAAAAAAABQS6o9AAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgSobxttvcHf8jgg4AAAAATN2h2fz2+dPb69o7AABYnk3tAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAU/L509vr45vNHznHde0tAAAAAAAAAFCDADoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwL+IoAMAAAAAAACwZgLoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/IIIOAAAAAAAAwFoJoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/IQIOgAAAAAAAABrJIAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPAEEXQAAAAAAAAA1kYAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAADgF0TQAQAAAAAAAFgTAXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgGcQQQcAAAAAAABgLQTQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAACeSQQdAAAAAAAAgDUQQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOIEIOgAAAAAAAABLJ4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAiEXQAAAAAAAAAlkwAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAADgBUTQAQAAAAAAAFgqAXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBcSQQcAAAAAAABgiQTQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABeQQQdAAAAAAAAgKURQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeCURdAAAAAAAAACWRAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAMRNABAAAAAAAAWAoBdAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAMxFBBwAAAAAAAGAJBNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM5IBB0AAAAAAACAuRNABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4MxF0AAAAAAAAAOZMAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAoAARdAAAAAAAAADmSgAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKAQEXQAAAAAAAAA5kgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAACgIBF0AAAAAAAAAOZGAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAoDARdAAAAAAAAADmRAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOACRNABAAAAAAAAmAsBdAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACxFBBwAAAAAAAGAOBNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC5IBB0AAAAAAACAqRNABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAC4MBF0AAAAAAAAAKZMAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAoAIRdAAAAAAAAACmSgAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKASEXQAAAAAAAAApkgAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAACgIhF0AAAAAAAAAKZGAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAoDIRdAAAAAAAAACmRAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGACRNABAAAAAAAAmAoBdAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAiRBBBwAAAAAAAGAKBNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAACZEBB0AAAAAAACA2gTQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmRgQdAAAAAAAAgJoE0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJkgEHQAAAAAAAIBaBNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAACZKBB0AAAAAAACAGgTQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmTAQdAAAAAAAAgEsTQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmDgRdAAAAAAAAAAuSQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAGRNABAAAAAAAAuBQBdAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAmRBBBwAAAAAAAOASBNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGZEBB0AAAAAAACA0gTQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABmRgQdAAAAAAAAgJIE0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZkgEHQAAAAAAAIBSBNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGZKBB0AAAAAAACAEgTQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABmTAQdAAAAAAAAgHMTQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmDkRdAAAAAAAAADOSQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGABRNABAAAAAAAAOBcBdAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAhRBBBwAAAAAAAOAcBNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAABZEBB0AAAAAAACA1xJABwAAAAAAAAAAAAAAAAAAAAAAAAAAAABYGBF0AAAAAAAAAF5DAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAYIFE0AEAAAAAAAB4KQF0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAICFEkEHAAAAAAAA4CUE0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFkwEHQAAAAAAAIBTCaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAACycCDoAAAAAAAAApxBABwAAAAAAAAAAAAAAAAAAAAAAAAAAAABYARF0AAAAAAAAAJ5LAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAYCVE0AEAAAAAAAB4DgF0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAVEUEHAAAAAAAA4FcE0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVkYEHQAAAAAAAICnCKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKyQCDoAAAAAAAAAPyOADgAAAAAAAAAAAAAAAAAAAAAAAAAAAACwUiLoAAAAAAAAAPyIADoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwIqJoAMAAAAAAADwbwLoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArJ4IOAAAAAAAAwGMC6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiKADAAAAAAAA8I0AOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAESGCDgAAAAAAAMA9AXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL4RQQcAAAAAAABAAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAgH8QQQcAAAAAAABYNwF0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC+I4IOAAAAAAAAsF4C6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/JAIOgAAAAAAAMA6CaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPBTIugAAAAAAAAA6yOADgAAAAAAAAAAAAAAAAAAAAAAAAAAAADAk0TQAQAAAAAAANZFAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAgF8SQQcAAAAAAABYDwF0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAACeRQQdAAAAAAAAYB0E0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeDYRdAAAAAAAAIDlE0AHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAkIugAAAAAAAAAyyaADgAAAAAAAAAAAAAAAAAAAAAAAAAAAADAyUTQAQAAAAAAAJZLAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBcRQQcAAAAAAABYJgF0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAABeTAQdAAAAAAAAYHkE0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeBURdAAAAAAAAIBlEUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAODVRNABAAAAAAAAlkMAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAACAsxBBBwAAAAAAAFgGAXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM5GBB0AAAAAAABg/gTQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4KxF0AAAAAAAAgHkTQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4OxE0AEAAAAAAADmSwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAiRNABAAAAAAAA5kkAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAACAYkTQAQAAAAAAAOZHAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAgKJE0AEAAAAAAADmRQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDiRNABAAAAAAAA5kMAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAACAixBBBwAAAAAAAJgHAXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC5GBB0AAAAAAABg+gTQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAC4KBF0AAAAAAAAgGkTQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4OJE0AEAAAAAAACmSwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAqRNABAAAAAAAApkkAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAACAakTQAQAAAAAAAKZHAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAgKpE0AEAAAAAAACmRQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDqRNABAAAAAAAApkMAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAACASRBBBwAAAAAAAJgGAXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACZDBB0AAAAAAACgPgF0AAAAAAAAAAAAAAAAAOB/7N3ZbRRRFEBBi8jIPyWExAdgsD1L9/Rb7lIVwcngAAAAAAAAAAAAQCgm6AAAAAAAAAB7GaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAABCOCToAAAAAAADAPgboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACEZIIOAAAAAAAAsIcBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYZmgAwAAAAAAAKxngA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAQGgm6AAAAAAAAABrGaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAABCeCToAAAAAAADAOgboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACkYIIOAAAAAAAAsIYBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaZigAwAAAAAAAMxngA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAQCom6AAAAAAAAABzGaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJCOCToAAAAAAADAPAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACkZIIOAAAAAAAAMIcBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaZmgAwAAAAAAAIxngA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAQGom6AAAAAAAAABjGaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJCeCToAAAAAAADAOAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACUYIIOAAAAAAAAMIYBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZZigAwAAAAAAAFxngA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAQCkm6AAAAAAAAADXGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFCOCToAAAAAAADA6wzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoyQQdAAAAgOq+/fzxfXcDAAA1GaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFCWCToAAAAAAADAeQboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACUZoIOAAAAAAAAcI4BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA5ZmgAwAAAAAAABxngA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAsm6AAAAAAAAADHGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAANCGCToAAAAAAADAcwboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC0YoIOAAAAAAAA8JgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7ZigAwAAAAAAANxngA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAQEsm6AAAAAAAAAC3GaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAANCWCToAAAAAAADAVwboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC0ZoIOAAAAAAAA8JEBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7ZmgAwAAAAAAAPxjgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG8m6AAAAAAAAAB/GaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAfJugAAAAAAAAABugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPCBCToAAAAAAADQnQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8YoIOAAAAAAAAdGaADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAN5igAwAAAAAAAF0ZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwB0m6AAAAAAAAEBHBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPCACToAAAAAAADQjQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8YYIOAAAAAAAAdGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB5igAwAAAAAAAF0YoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwEEm6AAAAAAAAEAHBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHCCCToAAAAAAABQnQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAACcZIIOAAAAAAAAVGaADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALzBBBwAAAAAAAKoyQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBeZoAMAAAAAAAAVGaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAFJugAAAAAAABANQboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwkQk6AAAAAAAAUIkBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADGCCDgAAAAAAAFRhgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIOYoAMAAAAAAAAVGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBAJugAAAAAAABAdgboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwmAk6AAAAAAAAkJkBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAATGCCDgAAAAAAAGRlgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJOYoAMAAAAAAAAZGaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBEJugAAAAAAABANgboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwmQk6AAAAAAAAkIkBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALGCCDgAAAAAAAGRhgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIuYoAMAAAAAAAAZGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBCJugAAAAAAABAdAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwmAk6AAAAAAAAEJkBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAbGCCDgAAAAAAAERlgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJuYoAMAAAAAAAARGaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBGJugAAAAAAABANAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwmQk6AAAAAAAAEIkBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGCCDgAAAAAAAERhgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEGYoAMAAAAAAAARGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAgJugAAAAAAADAbgboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQjAk6AAAAAAAAsJMBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGSCDgAAAAAAAOxigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEGZoAMAAAAAAAA7GKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBgJugAAAAAAADAagboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQnAk6AAAAAAAAsJIBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJGCCDgAAAAAAAKxigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEmYoAMAAAAAAAArGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAiJugAAAAAAADAbAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQjAk6AAAAAAAAMJMBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJGSCDgAAAAAAAMxigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEmZoAMAAAAAAAAzGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBiJugAAAAAAADAaAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQnAk6AAAAAAAAMJIBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFGCCDgAAAAAAAIxigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEWYoAMAAAAAAAAjGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAhJugAAAAAAADAVQboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQjAk6AAAAAAAAcIUBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFGSCDgAAAAAAALzKAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIoyQQcAAAAAAABeYYAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACFmaADAAAAAAAAZxmgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAABAcSboAAAAAAAAwBkG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0IAJOgAAAAAAAHCUAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADRhgg4AAAAAAAAcYYAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACNmKADAAAAAAAAzxigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAABAMyboAAAAAAAAwCMG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0JAJOgAAAAAAAHCPAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADRlgg4AAAAAAADcYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACNmaADAAAAAAAAnxmgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAABAcyboAAAAAAAAwP8M0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABN0AAAAAAAA4J0BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8Pb2ZoIOAAAAAAAA/GaADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvDNBBwAAAAAAAAzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAACAD0zQAQAAAAAAoDcDdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AsTdAAAAAAAAOjLAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAALjJBB0AAAAAAAB6MkAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADuMkEHAAAAAACAfgzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAACAh0zQAQAAAAAAoBcDdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4CkTdAAAAAAAAOjDAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADjEBB0AAAAAAAB6MEAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOM0EHAAAAAACA+gzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAACAU0zQAQAAAAAAoDYDdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4DQTdAAAAAAAAKjLAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHiJCToAAAAAAADUZIAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC8zAQdAAAAAAAA6jFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALjFBBwAAAAAAgFoM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgMtM0AEAAAAAAKAOA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAIE3QAAAAAAACowQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAY8OGzLwAAIABJREFUxgQdAAAAAAAA8jNABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhjJBBwAAAAAAgNwM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgOFM0AEAAAAAACAvA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAKE3QAAAAAAADIyQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYxgQdAAAAAAAA8jFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAApjJBBwAAAAAAgFwM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgOlM0AEAAAAAACAPA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAJE3QAAAAAAADIwQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYxgQdAAAAAAAA4jNABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAljJBBwAAAAAAgNgM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgOVM0AEAAAAAACAuA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGALE3QAAAAAAACIyQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADYxgQdAAAAAAAA4jFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtjJBBwAAAAAAgFgM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgO1M0AEAAAAAACAOA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAEE3QAAAAAAACIwQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIwwQdAAAAAAAA9jNABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQjFBBwAAAAAAgL0M0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgHBM0AEAAAAAAGAfA3QAAAAAAAAAAAAAAAAA4Bd793FYVRAEAMz9V80BMNj+4YUNE6RGBAAAAAAAAAAAABCSBB0AAAAAAAD2EKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABhSdABAAAAAABgPQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQmgQdAAAAAAAA1hKgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4UnQAQAAAAAAYB0BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkIIEHQAAAAAAANYQoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGlI0AEAAAAAAGA+AToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJCKBB0AAAAAAADmEqADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADpSNABAAAAAABgHgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQkgQdAAAAAAAA5hCgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaUnQAQAAAAAAYDwBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkJoEHQAAAAAAAMYSoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOlJ0AEAAAAAAGAcAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFCCBB0AAAAAAADGEKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABlSNABAAAAAADgPgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQigQdAAAAAAAA7hGgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA5UjQAQAAAAAA4DoBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUJIEHQAAAAAAAK4RoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGVJ0AEAAAAAAOA8AToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFCaBB0AAAAAAADOEaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADlSdABAAAAAADgOAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQggQdAAAAAAAAjhGgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAbUjQAQAAAAAA4D0BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0IoEHQAAAAAAAF4ToAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAO1I0AEAAAAAAOA5AToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANCSBB0AAAAAAAAeE6ADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABtSdABAAAAAADgJwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQmgQdAAAAAAAAvhKgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7UnQAQAAAAAA4B8BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwIcEHQAAAAAAAP4SoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPwhQQcAAAAAAAABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwBcSdAAAAAAAALoToAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHwjQQcAAAAAAKAzAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMADEnQAAAAAAAC6EqADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8IUEHAAAAAACgIwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADACxJ0AAAAAAAAuhGgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvCFBBwAAAAAAoBMBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAESdAAAAAAAALoQoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwkQQcAAAAAAKADAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAJEnQAAAAAAACqE6ADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACcJEEHAAAAAACgMgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADABRJ0AAAAAAAAqhKgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXCRBBwAAAAAAoCIBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwA0SdAAAAAAAAKoRoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANwkQQcAAAAAAKASAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAEnQAAAAAAACqEKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMIkEHAAAAAACgAgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAQBJ0AAAAAAAAshOgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADCZBBwAAAAAAIDMBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAQSdAAAAAAAALISoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEwiQQcAAAAAACAjAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBEEnQAAAAAAACyEaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABMJkEHAAAAAAAgEwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAAhJ0AAAAAAAAshCgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALCJBBwAAAAAAIAMBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwEISdAAAAAAAAKIToAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwmQQcAAAAAACAyAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAGEnQAAAAAAACiEqADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABsIkEHAAAAAAAgIgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAADARhJ0AAAAAAAAohGgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAbCZBBwAAAAAAIBIBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAASdAAAAAAAAKIQoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQhQQcAAAAAACACAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAgEnQAAAAAAAB2E6ADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEI0EHAAAAAABgJwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAQBJ0AAAAAAAAdhGgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABCVBBwAAAAAAYAcBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQGASdAAAAAAAAFYToAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQnQQcAAAAAAGAlAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEACEnQAAAAAAABWEaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkIUEHAAAAAABgBQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAIhJ0AAAAAAAAZhOgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJCNBBwAAAAAAYCYBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQEISdAAAAAAAAGYRoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQlQQcAAAAAAGAGAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBiEnQAAAAAAABGE6ADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkJ0EHAAAAAABgJAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAARJ0AAAAAAAARhGgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFCFBBwAAAAAAYAQBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQCESdAAAAAAAAO4SoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQjQQcAAAAAAOAOAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBBEnQAAAAAAACuEqADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUJUEHAAAAAADgCgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAYRJ0AAAAAAAAzhKgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFCdBBwAAAAAA4AwBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAMSdAAAAAAAAI4SoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQhQQcAAAAAAOAIAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAjEnQAAAAAAADeEaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0I0EHAAAAAADgFQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAQxJ0AAAAAAAAnhGgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANCVBBwAAAAAA4BEBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQGMSdAAAAAAAAL4ToAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQnQQcAAAAAAOB/AnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAk6AAAAAAAAHwSoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPDx8SFBBwAAAAAA4DcBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJ8k6AAAAAAAAAjQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+EKCDgAAAAAA0JsAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgB8k6AAAAAAAAH0J0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHhIgg4AAAAAANCTAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICnJOgAAAAAAAD9CNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4SYIOAAAAAADQiwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAtyToAAAAAAAAfQjQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOESCDgAAAAAA0IMAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgMMk6AAAAAAAAPUJ0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADhFgg4AAAAAAFCbAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDTJOgAAAAAAAB1CdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC4RIIOAAAAAABQkwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAyyToAAAAAAAA9QjQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAuEWCDgAAAAAAUIsAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgNsk6AAAAAAAAHUI0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABhCgg4AAAAAAFCDAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBhJOgAAAAAAAD5CdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYSoIOAAAAAACQmwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACA4SToAAAAAAAAeQnQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmEKCDgAAAAAAkJMAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgGkk6AAAAAAAAPkI0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJhKgg4AAAAAAJCLAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDpJOgAAAAAAAB5CNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYQoIOAAAAAACQgwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAZSToAAAAAAAA8QnQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWEqCDgAAAAAAEJsAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgOUk6AAAAAAAAHEJ0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANhCgg4AAAAAABCTAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBtJOgAAAAAAADxCNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADYSoIOAAAAAAAQiwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACA7SToAAAAAAAAcQjQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACEGCDgAAAAAAEIMAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgDAk6AAAAAAAAPsJ0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhFgg4AAAAAALCXAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBwJOgAAAAAAAD7CNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAISYIOAAAAAACwhwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAsCToAAAAAAAA6wnQAQAAAAAAAAAAAAAAAACAX+zdx2FVQRAAMPdfNQfAYPuHFzZMkBoRAAAAAAAAAAAAhCZBBwAAAAAAWEuADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQHgSdAAAAAAAgHUE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKQgQQcAAAAAAFhDgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAaEnQAAAAAAID5BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACkIkEHAAAAAACYS4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAOhJ0AAAAAACAeQToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAApCRBBwAAAAAAmEOADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQFoSdAAAAAAAgPEE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKQmQQcAAAAAABhLgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEB6EnQAAAAAAIBxBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACUIEEHAAAAAAAYQ4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAGRJ0AAAAAACA+wToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlCJBBwAAAAAAuEeADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQDkSdAAAAAAAgOsE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJQkQQcAAAAAALhGgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBZEnQAAAAAAIDzBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACUJkEHAAAAAAA4R4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAeRJ0AAAAAACA4wToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtCBBBwAAAAAAOEaADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQBsSdAAAAAAAgPcE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALQiQQcAAAAAAHhNgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEA7EnQAAAAAAIDnBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC0JEEHAAAAAAB4TIAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAWxJ0AAAAAACAnwToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtCZBBwAAAAAA+EqADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQHsSdAAAAAAAgH8E6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPAhQQcAAAAAAPhLgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB/SNABAAAAAAAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPCFBB0AAAAAAOhOgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADfSNABAAAAAIDOBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwgAQdAAAAAADoSoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAT0jQAQAAAACAjgToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8IIEHQAAAAAA6EaADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG9I0AEAAAAAgE4E6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHCABB0AAAAAAOhCgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHSdABAAAAAIAOBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwggQdAAAAAACoToAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJ0nQAQAAAACAygToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcIEEHQAAAAAAqEqADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABdJ0AEAAAAAgIoE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHCDBB0AAAAAAKhGgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3SdABAAAAAIBKBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwgAQdAAAAAACoQoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAg0jQAQAAAACACgToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMJAEHQAAAAAAyE6ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAINJ0AEAAAAAgMwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADCBBB0AAAAAAMhKgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACTSNABAAAAAICMBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwkQQdAAAAAADIRoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAk0nQAQAAAACATAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsIAEHQAAAAAAyEKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAItI0AEAAAAAgAwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALCQBB0AAAAAAIhOgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACLSdABAAAAAIDIBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwgQQdAAAAAACISoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAm0jQAQAAAACAiAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsJEEHQAAAAAAiEaADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJtJ0AEAAAAAgEgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABCABB0AAAAAAIhCgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABBSNABAAAAAIAIBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQiAQdAAAAAADYTYAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwUjQAQAAAACAnQToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEJAEHQAAAAAA2EWADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEFJ0AEAAAAAgB0E6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABCYBB0AAAAAAFhNgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADBSdABAAAAAICVBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQgAQdAAAAAABYRYAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAASUjQAQAAAACAFQToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkIgEHQAAAAAAmE2ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMlI0AEAAAAAgJkE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJCQBB0AAAAAAJhFgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABJSdABAAAAAIAZBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQmAQdAAAAAAAYTYAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAyUmByHv+AAAgAElEQVTQAQAAAACAkQToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUIAEHQAAAAAAGEWADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEVI0AEAAAAAgBEE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFCIBB0AAAAAALhLgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADFSNABAAAAAIA7BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQkAQdAAAAAAC4SoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARUnQAQAAAACAKwToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUJgEHQAAAAAAOEuADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMVJ0AEAAAAAgDME6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANCABB0AAAAAADhKgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABNSNABAAAAAIAjBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQiAQdAAAAAAB4R4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAzUjQAQAAAACAVwToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0JAEHQAAAAAAeEaADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE1J0AEAAAAAgEcE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANCYBB0AAAAAAPhOgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADNSdABAAAAAID/CdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACToAAAAAAPBJgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8fHxI0AEAAAAAgN8E6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAnCToAAAAAACBABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL6QoAMAAAAAQG8CdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAHCToAAAAAAPQlQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAekqADAAAAAEBPAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgKQk6AAAAAAD0I0AHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXpKgAwAAAABALwJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4C0JOgAAAAAA9CFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA6RoAMAAAAAQA8CdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAwCToAAAAAANQnQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABOkaADAAAAAEBtAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgNAk6AAAAAADUJUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALpGgAwAAAABATQJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4DIJOgAAAAAA1CNABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG6RoAMAAAAAQC0CdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOA2CToAAAAAANQhQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACGkKADAAAAAEANAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgGAk6AAAAAADkJ0AHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhpKgAwAAAABAbgJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYDgJOgAAAAAA5CVABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKaQoAMAAAAAQE4CdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAaCToAAAAAAOQjQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACmkqADAAAAAEAuAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgOgk6AAAAAADkIUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlpCgAwAAAABADgJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYBkJOgAAAAAAxCdABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJaSoAMAAAAAQGwCdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGA5CToAAAAAAMQlQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC2kKADAAAAAEBMAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgGwk6AAAAAADEI0AHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtpKgAwAAAABALAJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYDsJOgAAAAAAxCFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEKQoAMAAAAAQAwCdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAMCToAAAAAAOwnQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABCkaADAAAAAMBeAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgHAk6AAAAAADsI0AHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQpKgAwAAAADAHgJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICwJOgAAAAAArCdABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEKToAMAAAAAwFoCdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACA8CToAAAAAAKwjQAcAAAAAAAAAAAAAAAAAAAB+sXdnx1FEQQAENwLD8N8rPgCBpD1mdt7RR6YF5UEBAAAAAAAAAACkYIIOAAAAAABrGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaZigAwAAAADAfAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQCom6AAAAAAAMJcBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJCOCToAAAAAAMxjgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACkZIIOAAAAAABzGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaZmgAwAAAADAeAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQGom6AAAAAAAMJYBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJCeCToAANDTj5+7CwAAqMkAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACjBBB0AAAAAAMYwQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADKMEEHAAAAAIDrDNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAUkzQAQAAAADgGgN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoBwTdAAAAAAAeJ8BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFCSCToAAAAAALzHAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoywQdAAAAAADOM0AHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAASjNBBwAAAACAcwzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgPJM0AEAAAAA4DgDdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKAFE3QAAAAAADjGAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABowwQdAAAAAABeM0AHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWjFBBwAAAACA5wzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgHZM0AEAAAAA4DEDdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKAlE3QAAAAAALjPAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABoywQdAAAAAAC+M0AHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWjNBBwAAAACAzwzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgPZM0AEAAAAA4B8DdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICbCToAAAAAAPxlgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwhwk6AAAAAAAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8YoIOAAAAAEB3BugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAX5igAwAAAADQmQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwB0m6AAAAAAAdGWADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPCACToAAAAAAB0ZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8YYIOAAAAAEA3BugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL5igAwAAAADQiQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAEm6AAAAAAAdGGADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHCQCToAAAAAAB0YoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACcYIIOAAAAAEB1BugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJ5mgAwAAAABQmQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwBtM0AEAAAAAqMoAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOBNJugAAAAAAFRkgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwgQk6AAAAAADVGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXGSCDgAAAABAJQboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOYoAMAAAAAUIUBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAgJugAAAAAAFRggA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwkAk6AAAAAADZGaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADGaCDgAAAABAZgboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABOYoAMAAAAAkJUBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAkJugAAAAAAGRkgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwkQk6AAAAAADZGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAATGaCDgAAAABAJgboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAuYoAMAAAAAkIUBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAiJugAAAAAAGRggA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwkAk6AAAAAADRGaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALGaCDgAAAABAZAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABuYoAMAAAAAEJUBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAmJugAAAAAAERkgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwkQk6AAAAAADRGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAbGaCDgAAAABAJAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGYoAMAAAAAEIUBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAQJugAAAAAAERggA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQiAk6AAAAAAC7GaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGOCDgAAAADATgboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGZoAMAAAAAsIsBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBQJugAAAAAAOxggA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQmAk6AAAAAACrGaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGeCDgAAAADASgboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmYoAMAAAAAsIoBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEASJugAAAAAAKxggA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQiAk6AAAAAACzGaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJGOCDgAAAADATAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmZoAMAAAAAMIsBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBSJugAAAAAAMxggA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQmAk6AAAAAACjGaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJGeCDgAAAADASAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWYoAMAAAAAMIoBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEARJugAAAAAAIxggA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQiAk6AAAAAABXGaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFGOCDgAAAADAFQboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWZoAMAAAAA8C4DdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICiTNABAAAAAHiHAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAYSboAAAAAACcZYAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUJwJOgAAAAAAZxigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADRggg4AAAAAwFEG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABNmKADAAAAAHCEAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAIyboAAAAAAC8YoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0IwJOgAAAAAAzxigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADRkgg4AAAAAwCMG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABNmaADAAAAAHCPAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAYyboAAAAAAB8ZYAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0JwJOgAAAAAA/zNABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAEHQAAAACADwboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANxuNxN0AAAAAAB+M0AHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4IMJOgAAAAAABugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfGKCDgAAAADQmwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAN+YoAMAAAAA9GWADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBdJugAAAAAAD0ZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwkAk6AAAAAEA/BugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPGWCDgAAAADQiwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC+ZoAMAAAAA9GGADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAhJugAAAAAAD0YoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwmAk6AAAAAEB9BugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAnGKCDgAAAABQmwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKeZoAMAAAAA1GWADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBbTNABAAAAAGoyQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgbSboAAAAAAD1GKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcIkJOgAAAABALQboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFxmgg4AAAAAUIcBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABDmKADAAAAANRggA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAMCboAAAAAAD5GaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMJQJOgAAAABAbgboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxngg4AAAAAkJcBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABTmKADAAAAAORkgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADANCboAAAAAAD5GKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMJUJOgAAAABALgboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAExngg4AAAAAkIcBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABLmKADAAAAAORggA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAMiboAAAAAADxGaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsJQJOgAAAABAbAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACxngg4AAAAAEJcBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABbmKADAAAAAMRkgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADANiboAAAAAADxGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsJUJOgAAAABALAboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGxngg4AAAAAEIcBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhmKADAAAAAMRggA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAGCboAAAAAAD7GaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEIoJOgAAAADAXgboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIRjgg4AAAAAsI8BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhmaADAAAAAOxhgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAWCboAAAAAADrGaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEJoJOgAAAADAWgboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIRngg4AAAAAsI4BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAApmKADAAAAAKxhgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAGiboAAAAAADzGaADAAAAAAAAAAAAAAAAAAAA8Iu9+zisKggCAOb+q+YAGGz/8MKGCVIjAgAAAAAAAAAASEWCDgAAAAAwlwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgHQk6AAAAAAA8wjQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEhJgg4AAAAAMIcAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIC0JOgAAAAAAOMJ0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABITYIOAAAAADCWAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACA9CToAAAAAADjCNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKEGCDgAAAAAwhgAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgDIk6AAAAAAA9wnQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAChFgg4AAAAAcI8AHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIByJOgAAAAAANcJ0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoSYIOAAAAAHCNAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAsiToAAAAAADnCdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKE2CDgAAAABwjgAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgPIk6AAAAAAAxwnQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGhBgg4AAAAAcIwAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIA2JOgAAAAAAO8J0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABoRYIOAAAAAPCaAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAdiToAAAAAADPCdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaEmCDgAAAADwmAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgLYk6AAAAAAAPwnQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGhNgg4AAAAA8JUAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAID2JOgAAAAAAP8I0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgQ4IOAAAAAPCXAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/pCgAwAAAAAI0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgCwk6AAAAANCdAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvpGgAwAAAACdCdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AEJOgAAAADQlQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJ6QoAMAAAAAHQnQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAFCToAAAAA0I0AHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADekKADAAAAAJ0I0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAk6AAAAANCFAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADpKgAwAAAAAdCNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AQJOgAAAABQnQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKuQ/hIAACAASURBVE6SoAMAAAAAlQnQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOACCToAAAAAUJUAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAukqADAAAAABUJ0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgBgk6AAAAAFCNAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAbpKgAwAAAACVCNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYAAJOgAAAABQhQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaRoAMAAAAAFQjQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAgCToAAAAAkJ0AHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGk6ADAAAAAJkJ0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgAgk6AAAAAJCVAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJpGgAwAAAAAZCdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYCIJOgAAAACQjQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACaToAMAAAAAmQjQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGABCToAAAAAkIUAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWkaADAAAAABkI0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgIQk6AAAAABCdAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFpOgAwAAAACRCdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYAMJOgAAAAAQlQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADaRoAMAAAAAEQnQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAjCToAAAAAEI0AHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA2k6ADAAAAAJEI0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAk6AAAAABCFAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgpCgAwAAAAARCNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBAJOgAAAACwmwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIKRoAMAAAAAOwnQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAgCToAAAAAsIsAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACCkqADAAAAADsI0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgMAk6AAAAALCaAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgpOgAwAAAAArCdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAEJOgAAAACwigAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJKQoAMAAAAAKwjQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACARCToAAAAAMJsAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACSkaADAAAAADMJ0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgIQk6AAAAADCLAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkpKgAwAAAAAzCNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDEJOgAAAAAwmgAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJKToAMAAAAAIwnQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKAACToAAAAAMIoAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACKkKADAAAAACMI0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACgEAk6AAAAAHCXAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAipGgAwAAAAB3CNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoCAJOgAAAABwlQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIqSoAMAAAAAVwjQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKAwCToAAAAAcJYAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACKk6ADAAAAAGcI0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACgAQk6AAAAAHCUAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmpCgAwAAAABHCNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoBEJOgAAAADwjgAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJqRoAMAAAAArwjQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKAhCToAAAAA8IwAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACakqADAAAAAI8I0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACgMQk6AAAAAPCdAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmpOgAwAAAAD/E6ADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABJ0AAAAAOCTAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+Pj4kKADAAAAAL8J0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACATxJ0AAAAAECADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8IUEHAAAAgN4E6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADADxJ0AAAAAOhLgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPCRBBwAAAICeBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwFMSdAAAAADoR4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALwkQQcAAACAXgToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBbEnQAAAAA6EOADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcIkEHAAAAgB4E6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAYRJ0AAAAAKhPgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAnCJBBwAAAIDaBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwGkSdAAAAACoS4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFwiQQcAAACAmgToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBlEnQAAAAAqEeADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADcIkEHAAAAgFoE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAbRJ0AAAAAKhDgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADCFBBwAAAIAaBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwDASdAAAAADIT4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwlQQcAAACA3AToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBwEnQAAAAAyEuADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABMIUEHAAAAgJwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADANBJ0AAAAAMhHgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAATCVBBwAAAIBcBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwHQSdAAAAADIQ4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwhQQcAAACAHAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAyEnQAAAAAiE+ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsJUEHAAAAgNgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAchJ0AAAAAIhLgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAbCFBBwAAAICYBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwDYSdAAAAACIR4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGwlQQcAAACAWAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMB2EnQAAAAAiEOADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACEIEEHAAAAgBgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAGBJ0AAAAANhPgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhCJBBwAAAIC9BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQDgSdAAAAADYR4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIQkQQcAAACAPQToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBYEnQAAAAAWE+ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACEJkEHAAAAgLUE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAeBJ0AAAAAFhHgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAApCBBBwAAAIA1BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQBoSdAAAAACYT4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKQiQQcAAACAuQToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEA6EnQAAAAAmEeADgAAAAAAAAAAAAAAAAAAAADAL/bu47CqIAgAmPuvmgNgsP3DCxsmSI0IAAAAAAAAAABSkqADAAAAwBwCdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgLQk6AAAAAIwnQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUpOgAwAAAMBYAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAID0JOgAAAACMI0AHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEqQoAMAAADAGAJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKAMCToAAAAA3CdABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABKkaADAAAAwD0CdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACgHAk6AAAAAFwnQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAASpKgAwAAAMA1AnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoCwJOgAAAACcJ0AHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEqToAMAAADAOQJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKA8CToAAAAAHCdABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABakKADAAAAwDECdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACgDQk6AAAAALwnQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWpGgAwAAAMBrAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoB0JOgAAAAA8J0AHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFqSoAMAAADAYwJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKAtCToAAAAA/CRABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABak6ADAAAAwFcCdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACgPQk6AAAAAPwjQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+JCgAwAAAMBfAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgD8k6AAAAAAgQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+EKCDgAAAEB3AnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgG8k6AAAAAB0JkAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHhAgg4AAABAVwJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAnJOgAAAAAdCRABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4QYIOAAAAQDcCdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACANyToAAAAAHQiQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOECCDgAAAEAXAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgIMk6AAAAAB0IEAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADhBgg4AAABAdQJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICTJOgAAAAAVCZABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC4QIIOAAAAQFUCdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAiyToAAAAAFQkQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAuEGCDgAAAEA1AnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgJsk6AAAAABUIkAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABhAgg4AAABAFQJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBBJOgAAAAAVCBABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYSIIOAAAAQHYCdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAwSToAAAAAGQmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmECCDgAAAEBWAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgEkk6AAAAABkJEAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJhIgg4AAABANgJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDJJOgAAAAAZCJABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYQIIOAAAAQBYCdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACARSToAAAAAGQgQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWEiCDgAAAEB0AnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgMUk6AAAAABEJkAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANhAgg4AAABAVAJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBNJOgAAAAARCRABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADYSIIOAAAAQDQCdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAzSToAAAAAEQiQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACECCDgAAAEAUAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgCAk6AAAAABEIEAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhEgg4AAADAbgJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBgJOgAAAAA7CRABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAISIIOAAAAwC4CdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAoCToAAAAAOwgQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACEyCDgAAAMBqAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgOAk6AAAAACsJEAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEhAgg4AAADAKgJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAkJOgAAAAArCBABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABIRIIOAAAAwGwCdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAZCToAAAAAMwkQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAASEiCDgAAAMAsAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgKQk6AAAAADMIEAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEhMgg4AAADAaAJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDkJOgAAAAAjCRABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoQIIOAAAAwCgCdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAIiToAAAAAIwgQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKESCDgAAAMBdAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgGIk6AAAAADcIUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAChIgg4AAADAVQJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICiJOgAAAAAXCFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoTIIOAAAAwFkCdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACA4iToAAAAAJwhQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaECCDgAAAMBRAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgCYk6AAAAAAcIUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGhEgg4AAADAOwJ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBmJOgAAAAAvCJABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABoSIIOAAAAwDMCdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACApiToAAAAADwiQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaEyCDgAAAMB3AnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgOYk6AAAAAD8T4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAEHQAAAIBPAnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4+PiToAAAAAPwmQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4JMEHQAAAAABOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAX0jQAQAAAHoToAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8IMEHQAAAKAvAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA9J0AEAAAB6EqADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPCUBB0AAACgHwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvSdABAAAAehGgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwlgQdAAAAoA8BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAh0jQAQAAAHoQoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcJgEHQAAAKA+AToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKdI0AEAAABqE6ADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHCaBB0AAACgLgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACXSNABAAAAahKgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwmQQdAAAAoB4BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAt0jQAQAAAGoRoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcJsEHQAAAKAOAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAENI0AEAAABqEKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADCMBB0AAAAgPwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABDSdABAAAAchOgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwnAQdAAAAIC8BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAU0jQAQAAAHISoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMI0EHQAAACAfAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFNJ0AEAAAByEaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADCdBB0AAAAgDwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABLSNABAAAAchCgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwjAQdAAAAID4BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAS0nQAQAAAGIToAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsJwEHQAAACAuAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFtI0AEAAABiEqADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALCNBB0AAAAgHgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABbSdABAAAAYhGgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwnQQdAAAAIA4BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIUjQAQAAAGIQoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEIYEHQAAAGA/AToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKFI0AEAAAD2EqADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABCOBB0AAABgHwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhSdABAAAA9hCgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQlgQdAAAAYD0BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoUnQAQAAANYSoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEJ4EHQAAAGAdAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAClI0AEAAADWEKADAAAAAAAAAAAAAAAAAAAAAAAAuS8rGAAAIABJREFUAAAAAAAAAJCGBB0AAABgPgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACpSNABAAAA5hKgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQjgQdAAAAYB4BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKUnQAQAAAOYQoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkJYEHQAAAGA8AToAAAAAAAAAAAAAAAAAAAAAAAC/2LuzK6ehKACCJjPyD4rDBzAwgxdZestdqiLoDBoAAAAAAAAAIDUTdAC6+vbj9n13AwAANRmgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQngk6AAAAwDgG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlGCCDgAAADCGAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGWYoAMAAABcZ4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEApJugAAAAA1xigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQjgk6AAAAwHkG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlGSCDgAAAHCOAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGWZoAMAAAC8zwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDSTNABAAAA3mOADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAeSboAAAAAMcZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0IIJOgAAAMAxBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALRhgg4AAADwmgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtmKADAAAAPGeADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAOyboAAAAAI8ZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0JIJOgAAAMB9BugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALRlgg4AAADwPwN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABaM0EHAAAA+MwAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACA9kzQAQAAAP4yQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgJsJOgAAAMAfBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPCbCToAAACAAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHxigg4AAAB0Z4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABfmKADAAAAnRmgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAHSboAAAAQFcG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8IAJOgAAANCRAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADxhgg4AAAB0Y4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvmKADAAAAnRigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAASboAAAAQBcG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcJAJOgAAANCBAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALzBBB0AAACozgAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADeZIIOAAAAVGaADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJ5igAwAAAFUZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwEkm6AAAAEBFBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHCBCToAAABQjQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABcZIIOAAAAVGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA5igAwAAAFUYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwCAm6AAAAEAFBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADCQCToAAACQnQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMZoIOAAAAZGaADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE5igAwAAAFkZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwCQm6AAAAEBGBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADCRCToAAACQjQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABMZoIOAAAAZGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC5igAwAAAFkYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwCIm6AAAAEAGBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALCQCToAAAAQnQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsZoIOAAAARGaADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG5igAwAAAFEZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwCYm6AAAAEBEBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALCRCToAAAAQjQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABsZoIOAAAARGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZigAwAAAFEYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQBAm6AAAAEAEBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABCICToAAACwmwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEY4IOAAAA7GSADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZmgAwAAALsYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQFAm6AAAAMAOBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABCYCToAAACwmgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEZ4IOAAAArGSADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACZigAwAAAKsYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQBIm6AAAAMAKBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJCICToAAAAwmwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkY4IOAAAAzGSADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACZmgAwAAALMYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQFIm6AAAAMAMBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJCYCToAAAAwmgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkZ4IOAAAAjGSADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABZigAwAAAKMYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQBEm6AAAAMAIBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFCICToAAABwlQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUY4IOAAAAXGGADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABZmgAwAAAGcZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQFEm6AAAAMAZBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFCYCToAAADwLgN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAozgQdAAAAeIcBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANGCCDgAAABxlgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE2YoAMAAABHGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAjJugAAADAKwboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQjAk6AAAA8IwBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANGSCDgAAADxigA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE2ZoAMAAAD3GKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBjJugAAADAVwboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQnAk6AAAA8C8DdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAQdAAAA+GCADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3G43E3QAAADgFwN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADggwk6AAAAYIAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8YoIOAAAAvRmgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/zFBBwAAgL4M0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgLtM0AEAAKAnA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAhE3QAAADoxwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4ygQdAAAAejFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXjJBBwAAgD4M0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgENM0AEAAKAHA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAwE3QAAACozwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4iwk6AAAA1GaADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvM0EHQAAAOoyQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE4xQQcAAICaDNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDTTNABAACgHgN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgEhN0AAAAqMUAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAuMwEHQAAAOowQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIYwQQcAAIAaDNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBhTNABAAAgPwN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgKBN0AAAAyM0AHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGM4EHQAAAPIyQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKYwQQcAAICcDNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBpTNABAAAgHwN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgKhN0AAAAyMUAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmM4EHQAAAPIwQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJYwQQcAAIAcDNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBlTNABAAAgPgN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgKRN0AAAAiM0AHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWM4EHQAAAOIyQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALYwQQcAAICYDNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBtTNABAAAgHgN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgKxN0AAAAiMUAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA2M4EHQAAAOIwQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEIwQQcAAIAYDNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAwTNABAABgPwN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgFBN0AAAA2MsAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACMcEHQAAAPYxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEIyQQcAAIA9DNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICwTNABAABgPQN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgNBN0AAAAWMsAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACM8EHQAAANYxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFIwQQcAAIA1DNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIA0TNABAABgPgN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgFRN0AAAAmMsAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAASMcEHQAAAOYxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFIyQQcAAIA5DNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIC0TNABAABgPAN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgNRN0AAAAGMsAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAASM8EHQAAAMYxQAcAAAAAAAAAAAAAAAAAAAAAAOAne/dxWFUQBADM/VfNATDY/uGFDROkRgQAAAAAAAAAACVI0AEAAGAMAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFCGBB0AAADuE6ADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAClSNABAADgHgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQjgQdAAAArhOgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJUnQAQAA4BoBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUJYEHQAAAM4ToAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKVJ0AEAAOAcAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFCeBB0AAACOE6ADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtSNABAADgGAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQhgQdAAAA3hOgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArUjQAQAA4DUBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0I4EHQAAAJ4ToAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC1J0AEAAOAxAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANCWBB0AAAB+EqADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtSdABAADgKwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQngQdAAAA/hGgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfEjQAQAA4C8BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwB8SdAAAABCgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfCFBBwAAoDsBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwDcSdAAAADoToAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwgQQcAAKArAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMATEnQAAAA6EqADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC8IEEHAACgGwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAGxJ0AAAAOhGgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHCBBBwAAoAsBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwEESdAAAADoQoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJwgQQcAAKA6AToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBJEnQAAAAqE6ADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABcIEEHAACgKgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADARRJ0AAAAKhKgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3CBBBwAAoBoBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwE0SdAAAACoRoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwgQQcAAKAKAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAgEnQAAAAqEKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMJEEHAAAgOwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAYBJ0AAAAMhOgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAATCBBBwAAICsBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwCQSdAAAADISoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEwkQQcAACAbAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBkEnQAAAAyEaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsIEEHAAAgCwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAIhJ0AAAAMhCgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALCRBBwAAIDoBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwGISdAAAACIToAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGwgQQcAACAqAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAmEnQAAAAiEqADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABsJEEHAAAgGgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAZhJ0AAAAIhGgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABCBBBwAAIAoBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQBASdAAAACIQoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQiQQcAAGA3AToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAwEnQAAAB2EqADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEJEEHAABgFwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAUBJ0AAAAdhCgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABCZBBwAAYDUBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQHASdAAAAFYSoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQgQQcAAGAVAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEASEnQAAABWEKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkIkEHAABgNgE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAMhJ0AAAAZhKgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJCRBBwAAYBYBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQFISdAAAAGYQoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQmQQcAAGA0AToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEByEnQAAABGEqADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUIEEHAABgFAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAERJ0AAAARhCgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFCJBBwAA4C4BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQDESdAAAAO4QoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQkQQcAAOAqAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBREnQAAACuEKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUJkEHAADgLAE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAcRJ0AAAAzhCgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANCBBBwAA4CgBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQBMSdAAAAI4QoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQiQQcAAOAdAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAzEnQAAABeEaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0JEEHAADgGQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAUxJ0AAAAHhGgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANCZBBwAA4DsBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQHMSdAAAAP4nQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAECCDgAAwCcBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8fHxJ0AAAAfhOgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8EmCDgAAgAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACALyToAAAAvQnQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+EGCDgAA0JcAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgIck6AAAAD0J0AEAAAAAAAAAAAAAAAAAAAATUuzmAAAgAElEQVQAAAAAAAAAAAAAAHhKgg4AANCPAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICXJOgAAAC9CNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4S4IOAADQhwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAQyToAAAAPQjQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOEyCDgAAUJ8AHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgFMk6AAAALUJ0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADhNgg4AAFCXAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBLJOgAAAA1CdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC4TIIOAABQjwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAWyToAAAAtQjQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAuE2CDgAAUIcAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgCEk6AAAADUI0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABhGgg4AAJCfAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIChJOgAAAC5CdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYToIOAACQlwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAKSToAAAAOQnQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmEaCDgAAkI8AHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgKkk6AAAALkI0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJhOgg4AAJCHAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAlJOgAAAA5CNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYRoIOAAAQnwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACApSToAAAAsQnQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWE6CDgAAEJcAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgC0k6AAAADEJ0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANhGgg4AABCPAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICtJOgAAACxCNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADYToIOAAAQhwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAECToAAAAMQjQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACEOCDgAAsJ8AHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgFAk6AAAAHsJ0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhHgg4AALCPAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICQJOgAAAB7CNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIS4IOAACwngAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACA0CToAAAAawnQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACE+CDgAAsI4AHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBQk6AAAAGsI0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEhDgg4AADCfAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBUJOgAAABzCdABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABIR4IOAAAwjwAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAlCToAAAAcwjQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAASEuCDgAAMJ4AHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgNQk6AAAAGMJ0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEhPgg4AADCOAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIASJOgAAABjCNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoQ4IOAABwnwAdAAAAAAAAAAAAAAAAAAAAAAAAgF/s3cmB00AUAFFz4+iQJv8kSIUDMMziRZZa3X95L4LKoAAAAAAAAAAASjFBBwAAOMYAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgHJM0AEAAPYzQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKAkE3QAAIB9DNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoywQdAADgdQboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlGaCDgAA8BoDdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMozQQcAANjOAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAWTNABAAC2MUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACgDRN0AACA5wzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaMUEHQAA4DEDdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANoxQQcAALjPAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICWTNABAABuM0AHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACgLRN0AACA7wzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaM0EHQAA4DMDdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANozQQcAAPjPAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAuJugAAAD/GKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAXyboAAAABugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwiQk6AADQnQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfGGCDgAAdGaADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADeYoAMAAF0ZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAdJugAAEBHBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwgAk6AADQjQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPGGCDgAAdGKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABuYoAMAAF0YoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBGJugAAEAHBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwAhN0AACgOgN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeJEJOgAAUJkBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOxggg4AAFRlgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7maADAAAVGaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAASboAABANQboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcJAJOgAAUIkBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxggg4AAFRhgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACDmKADAAAVGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAQCboAABAdgboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMJgJOgAAkJkBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJzABB0AAMjKAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABOYoIOAABkZIAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJzJBBwAAsjFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgJOZoAMAAJkYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAEJugAAEAWBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwiQk6AACQgQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAATGSCDgAARGeADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJOZoAMAAJEZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMACJugAAEBUBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACwiAk6AAAQkQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALGSCDgAARGOADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIuZoAMAAJEYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAJugAAEAUBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQhAk6AAAQgQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGKCDgAArGaADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMGYoAMAACsZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBAJugAAMAqBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQlAk6AACwggE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGaCDgAAzGaADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMGZoAMAADMZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEACJugAAMAsBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQhAk6AAAwgwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJGKCDgAAnM0AHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJIxQQcAAM5kgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJmaADAABnMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACApEzQAQCAMxigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQGIm6AAAwGgG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJCcCToAADCSAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUYIIOAACMYoAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARZigAwAAIxigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQCEm6AAAwFEG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFCMCToAAHCEAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUZIIOAADsZYAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARZmgAwAAexigAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQGEm6AAAwKsM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKA4E3QAAOAVBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQgAk6AACwlQE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANGGCDgAAbGGADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAI2YoAMAAM8YoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAzJugAAMAjBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQkAk6AABwjwE6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANGWCDgAA3GKADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAI2ZoAMAAF8ZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBzJugAAMBHBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACACToAAPDOAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC4XC4m6AAAwB8G6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMA7E3QAAMAAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPjEBB0AAHozQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC+MUEHAIC+DNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAm0zQAQCgJwN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4C4TdAAA6McAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHjIBB0AAHoxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACeMkEHAIA+DNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACATUzQAQCgBwN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYDMTdAAAqM8AHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHiJCToAANRmgA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC8zAQdAADqMkAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAdjFBBwCAmgzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgN1M0AEAoB4DdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAQE3QAAKjFAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4zAQdAADqMEAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhjBBBwCAGgzQAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgGFM0AEAID8DdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGAoE3QAAMjNAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYzgQdAADyMkAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAATmGCDgAAORmgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKcxQQcAgHwM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBTmaADAEAuBugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA6UzQAQAgDwN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYAoTdAAAyMEAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJjGBB0AAOIzQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACmMkEHAIDYDNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACA6UzQAQAgLgN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYAkTdAAAiMkAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFjGBB0AAOIxQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACWMkEHAIBYDNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACA5UzQAQAgDgN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAQTdAAAiMEAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAjDBB0AANYzQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABCMUEHAIC1DNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAcEzQAQBgHQN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICQTdAAAWMMAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAjLBB0AAOYzQAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABCM0EHAIC5DNABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACA8EzQAQBgHgN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAUTdAAAmMMAHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEjDBP2DH5fr29uv6+oMAADqMUAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUjFBf3e9XH8aoAMAMJwBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJCOCToAAJzHAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABIyQQdAADOYYAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAApGWCDgAA4xmgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKmZoAMAwFgG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEB6JugAADCOAToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQggk6AACMYYAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlGGCDgAAxxmgAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKWYoAMAwDEG6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEA5JugAALCfAToAAAAAAAAAAAAAAAAAAAAAwG/27ty4YSAIgCDzj5amTDliqSjxAUDc3T7dEUwGAwAAAAAAAAAAAACUZIIOAADHGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZZmgAwDAfgboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQGkm6AAAsI8BOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFCeCToAAGxngA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC0YIIOAADbGKADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAbZigAwDAewboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQCsm6AAA8JoBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANCOCToAADxngA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC0ZIIOAACPGaADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAbZmgAwDAfwboAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQGsm6AAAcM8AHQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGjPBB0AAH4ZoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABcTNABAODGAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADghwk6AAAYoAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADcMUEHAKA7A3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAP0zQAQDozAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AETdAAAujJABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHjCBB0AgI4M0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABeMEEHAKAbA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAN0zQAQDoxAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYAMTdAAAujBABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANjIBB0AgA4M0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB2MEEHAKA6A3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAnUzQAQCozAAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AATdAAAqjJABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADjIBB0AgIoM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+YIIOAEA1BugAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHzJBBwCgEgN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgBOYoAMAUIUBOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBJTNABAKjAAB0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgRCboAABkZ4AOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcDITdAAAMjNABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjABB0AgKwM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGMUEHACAjA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAgUzQAQDIxgAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYDATdAAAMjFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJjABB0AgCwM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmMUEHACADA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAiUzQAQCIzgAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYDITdAAAIjNABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFjABB0AgKgM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWMUEHACAiA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAhUzQAQCIxgAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYDETdAAAIjFABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAjABB0AgCgM0AEAAAAAAAAAAAAAAAAAAAAAADqVzCkAACAASURBVAAAAAAAAAAAAACCMEEHACACA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAQEzQAQBYzQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBgTdAAAVjJABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAjIBB0AgFUM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACCMkEHAGAFA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAwEzQAQCYzQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDgTdAAAZjJABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEjABB0AgFkM0AEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACSMEEHAGAGA3QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAREzQAQAYzQAdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIJnbBP1y/bqubgEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPhmDw4EAAAAAID8XxtBVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVpT04JAAAAAAQ9P+1L0wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAdK/paAAACf1JREFUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMwCh9U0/50DlhwAAAAASUVORK5CYII=","e":1}],"layers":[{"ddd":0,"ind":1,"ty":2,"nm":"Menu.png","cl":"png","refId":"image_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":16,"s":[100]}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[-21]},{"t":16,"s":[0]}],"ix":10},"p":{"a":0,"k":[400,400,0],"ix":2},"a":{"a":0,"k":[4000,4000,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[5,5,100]},{"t":16,"s":[10,10,100]}],"ix":6}},"ao":0,"ip":0,"op":120,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Calque de forme 1","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":16,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":37,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":48,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":60,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":76,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":96,"s":[100]},{"t":108,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[400,400,0],"ix":2},"a":{"a":0,"k":[84.957,84.957,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":48,"s":[100,100,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":60,"s":[0,0,100]},{"t":108,"s":[100,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[497.914,497.914],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Trac\xe9 d\'ellipse 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.81568627451,0.823529411765,0.972549019608,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fond 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[84.957,84.957],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[160.789,160.789],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformer "}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120,"st":0,"bm":0}],"markers":[]}');

});

parcelRegister("ikMhW", function(module, exports) {

$parcel$export(module.exports, "PlayerEvent", () => PlayerEvent);
$parcel$export(module.exports, "Player", () => Player);

var $81g6h = parcelRequire("81g6h");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var extendStatics = function(t, e) {
    return (extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    })(t, e);
};
function __extends(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function r() {
        this.constructor = t;
    }
    extendStatics(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
}
var __assign = function() {
    return (__assign = Object.assign || function(t) {
        for(var e, r = 1, i = arguments.length; r < i; r++)for(var a in e = arguments[r])Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
        return t;
    }).apply(this, arguments);
};
function __rest(t, e) {
    var r = {};
    for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (r[i] = t[i]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var a = 0;
        for(i = Object.getOwnPropertySymbols(t); a < i.length; a++)e.indexOf(i[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[a]) && (r[i[a]] = t[i[a]]);
    }
    return r;
}
function __decorate(t, e, r, i) {
    var a, s = arguments.length, n = s < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, r) : i;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) n = Reflect.decorate(t, e, r, i);
    else for(var o = t.length - 1; o >= 0; o--)(a = t[o]) && (n = (s < 3 ? a(n) : s > 3 ? a(e, r, n) : a(e, r)) || n);
    return s > 3 && n && Object.defineProperty(e, r, n), n;
}
function __param(t, e) {
    return function(r, i) {
        e(r, i, t);
    };
}
function __metadata(t, e) {
    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
}
function __awaiter(t, e, r, i) {
    return new (r || (r = Promise))(function(a, s) {
        function n(t) {
            try {
                h(i.next(t));
            } catch (t) {
                s(t);
            }
        }
        function o(t) {
            try {
                h(i.throw(t));
            } catch (t) {
                s(t);
            }
        }
        function h(t) {
            var e;
            t.done ? a(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                t(e);
            })).then(n, o);
        }
        h((i = i.apply(t, e || [])).next());
    });
}
function __generator(t, e) {
    var r, i, a, s, n = {
        label: 0,
        sent: function() {
            if (1 & a[0]) throw a[1];
            return a[1];
        },
        trys: [],
        ops: []
    };
    return s = {
        next: o(0),
        throw: o(1),
        return: o(2)
    }, "function" == typeof Symbol && (s[Symbol.iterator] = function() {
        return this;
    }), s;
    function o(s) {
        return function(o) {
            return function(s) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; n;)try {
                    if (r = 1, i && (a = 2 & s[0] ? i.return : s[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, s[1])).done) return a;
                    switch(i = 0, a && (s = [
                        2 & s[0],
                        a.value
                    ]), s[0]){
                        case 0:
                        case 1:
                            a = s;
                            break;
                        case 4:
                            return n.label++, {
                                value: s[1],
                                done: !1
                            };
                        case 5:
                            n.label++, i = s[1], s = [
                                0
                            ];
                            continue;
                        case 7:
                            s = n.ops.pop(), n.trys.pop();
                            continue;
                        default:
                            if (!(a = n.trys, (a = a.length > 0 && a[a.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                                n = 0;
                                continue;
                            }
                            if (3 === s[0] && (!a || s[1] > a[0] && s[1] < a[3])) {
                                n.label = s[1];
                                break;
                            }
                            if (6 === s[0] && n.label < a[1]) {
                                n.label = a[1], a = s;
                                break;
                            }
                            if (a && n.label < a[2]) {
                                n.label = a[2], n.ops.push(s);
                                break;
                            }
                            a[2] && n.ops.pop(), n.trys.pop();
                            continue;
                    }
                    s = e.call(t, n);
                } catch (t) {
                    s = [
                        6,
                        t
                    ], i = 0;
                } finally{
                    r = a = 0;
                }
                if (5 & s[0]) throw s[1];
                return {
                    value: s[0] ? s[1] : void 0,
                    done: !0
                };
            }([
                s,
                o
            ]);
        };
    }
}
var __createBinding = Object.create ? function(t, e, r, i) {
    void 0 === i && (i = r), Object.defineProperty(t, i, {
        enumerable: !0,
        get: function() {
            return e[r];
        }
    });
} : function(t, e, r, i) {
    void 0 === i && (i = r), t[i] = e[r];
};
function __exportStar(t, e) {
    for(var r in t)"default" === r || Object.prototype.hasOwnProperty.call(e, r) || __createBinding(e, t, r);
}
function __values(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], i = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && i >= t.length && (t = void 0), {
                value: t && t[i++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(t, e) {
    var r = "function" == typeof Symbol && t[Symbol.iterator];
    if (!r) return t;
    var i, a, s = r.call(t), n = [];
    try {
        for(; (void 0 === e || e-- > 0) && !(i = s.next()).done;)n.push(i.value);
    } catch (t) {
        a = {
            error: t
        };
    } finally{
        try {
            i && !i.done && (r = s.return) && r.call(s);
        } finally{
            if (a) throw a.error;
        }
    }
    return n;
}
function __spread() {
    for(var t = [], e = 0; e < arguments.length; e++)t = t.concat(__read(arguments[e]));
    return t;
}
function __spreadArrays() {
    for(var t = 0, e = 0, r = arguments.length; e < r; e++)t += arguments[e].length;
    var i = Array(t), a = 0;
    for(e = 0; e < r; e++)for(var s = arguments[e], n = 0, o = s.length; n < o; n++, a++)i[a] = s[n];
    return i;
}
function __spreadArray(t, e, r) {
    if (r || 2 === arguments.length) for(var i, a = 0, s = e.length; a < s; a++)!i && a in e || (i || (i = Array.prototype.slice.call(e, 0, a)), i[a] = e[a]);
    return t.concat(i || Array.prototype.slice.call(e));
}
function __await(t) {
    return this instanceof __await ? (this.v = t, this) : new __await(t);
}
function __asyncGenerator(t, e, r) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var i, a = r.apply(t, e || []), s = [];
    return i = {}, n("next"), n("throw"), n("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function n(t) {
        a[t] && (i[t] = function(e) {
            return new Promise(function(r, i) {
                s.push([
                    t,
                    e,
                    r,
                    i
                ]) > 1 || o(t, e);
            });
        });
    }
    function o(t, e) {
        try {
            (r = a[t](e)).value instanceof __await ? Promise.resolve(r.value.v).then(h, l) : p(s[0][2], r);
        } catch (t) {
            p(s[0][3], t);
        }
        var r;
    }
    function h(t) {
        o("next", t);
    }
    function l(t) {
        o("throw", t);
    }
    function p(t, e) {
        t(e), s.shift(), s.length && o(s[0][0], s[0][1]);
    }
}
function __asyncDelegator(t) {
    var e, r;
    return e = {}, i("next"), i("throw", function(t) {
        throw t;
    }), i("return"), e[Symbol.iterator] = function() {
        return this;
    }, e;
    function i(i, a) {
        e[i] = t[i] ? function(e) {
            return (r = !r) ? {
                value: __await(t[i](e)),
                done: "return" === i
            } : a ? a(e) : e;
        } : a;
    }
}
function __asyncValues(t) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var e, r = t[Symbol.asyncIterator];
    return r ? r.call(t) : (t = "function" == typeof __values ? __values(t) : t[Symbol.iterator](), e = {}, i("next"), i("throw"), i("return"), e[Symbol.asyncIterator] = function() {
        return this;
    }, e);
    function i(r) {
        e[r] = t[r] && function(e) {
            return new Promise(function(i, a) {
                (function(t, e, r, i) {
                    Promise.resolve(i).then(function(e) {
                        t({
                            value: e,
                            done: r
                        });
                    }, e);
                })(i, a, (e = t[r](e)).done, e.value);
            });
        };
    }
}
function __makeTemplateObject(t, e) {
    return Object.defineProperty ? Object.defineProperty(t, "raw", {
        value: e
    }) : t.raw = e, t;
}
var __setModuleDefault = Object.create ? function(t, e) {
    Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
    });
} : function(t, e) {
    t.default = e;
};
function __importStar(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for(var r in t)"default" !== r && Object.prototype.hasOwnProperty.call(t, r) && __createBinding(e, t, r);
    return __setModuleDefault(e, t), e;
}
function __importDefault(t) {
    return t && t.__esModule ? t : {
        default: t
    };
}
function __classPrivateFieldGet(t, e, r, i) {
    if ("a" === r && !i) throw new TypeError("Private accessor was defined without a getter");
    if ("function" == typeof e ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? i : "a" === r ? i.call(t) : i ? i.value : e.get(t);
}
function __classPrivateFieldSet(t, e, r, i, a) {
    if ("m" === i) throw new TypeError("Private method is not writable");
    if ("a" === i && !a) throw new TypeError("Private accessor was defined without a setter");
    if ("function" == typeof e ? t !== e || !a : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === i ? a.call(t, r) : a ? a.value = r : e.set(t, r), r;
}
var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function unwrapExports(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function createCommonjsModule(t, e) {
    return t(e = {
        exports: {}
    }, e.exports), e.exports;
}
function getCjsExportFromNamespace(t) {
    return t && t.default || t;
}
function commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var lottie = createCommonjsModule(function(module, exports) {
    "undefined" != typeof navigator && function(t, e) {
        module.exports = e();
    }(0, function() {
        var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(t) {
            _useWebWorker = !!t;
        }, getWebWorker = function() {
            return _useWebWorker;
        }, setLocationHref = function(t) {
            locationHref = t;
        }, getLocationHref = function() {
            return locationHref;
        };
        function createTag(t) {
            return document.createElement(t);
        }
        function extendPrototype(t, e) {
            var r, i, a = t.length;
            for(r = 0; r < a; r += 1)for(var s in i = t[r].prototype)Object.prototype.hasOwnProperty.call(i, s) && (e.prototype[s] = i[s]);
        }
        function getDescriptor(t, e) {
            return Object.getOwnPropertyDescriptor(t, e);
        }
        function createProxyFunction(t) {
            function e() {}
            return e.prototype = t, e;
        }
        var audioControllerFactory = function() {
            function t(t) {
                this.audios = [], this.audioFactory = t, this._volume = 1, this._isMuted = !1;
            }
            return t.prototype = {
                addAudio: function(t) {
                    this.audios.push(t);
                },
                pause: function() {
                    var t, e = this.audios.length;
                    for(t = 0; t < e; t += 1)this.audios[t].pause();
                },
                resume: function() {
                    var t, e = this.audios.length;
                    for(t = 0; t < e; t += 1)this.audios[t].resume();
                },
                setRate: function(t) {
                    var e, r = this.audios.length;
                    for(e = 0; e < r; e += 1)this.audios[e].setRate(t);
                },
                createAudio: function(t) {
                    return this.audioFactory ? this.audioFactory(t) : window.Howl ? new window.Howl({
                        src: [
                            t
                        ]
                    }) : {
                        isPlaying: !1,
                        play: function() {
                            this.isPlaying = !0;
                        },
                        seek: function() {
                            this.isPlaying = !1;
                        },
                        playing: function() {},
                        rate: function() {},
                        setVolume: function() {}
                    };
                },
                setAudioFactory: function(t) {
                    this.audioFactory = t;
                },
                setVolume: function(t) {
                    this._volume = t, this._updateVolume();
                },
                mute: function() {
                    this._isMuted = !0, this._updateVolume();
                },
                unmute: function() {
                    this._isMuted = !1, this._updateVolume();
                },
                getVolume: function() {
                    return this._volume;
                },
                _updateVolume: function() {
                    var t, e = this.audios.length;
                    for(t = 0; t < e; t += 1)this.audios[t].volume(this._volume * (this._isMuted ? 0 : 1));
                }
            }, function() {
                return new t;
            };
        }(), createTypedArray = function() {
            function t(t, e) {
                var r, i = 0, a = [];
                switch(t){
                    case "int16":
                    case "uint8c":
                        r = 1;
                        break;
                    default:
                        r = 1.1;
                }
                for(i = 0; i < e; i += 1)a.push(r);
                return a;
            }
            return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array ? function(e, r) {
                return "float32" === e ? new Float32Array(r) : "int16" === e ? new Int16Array(r) : "uint8c" === e ? new Uint8ClampedArray(r) : t(e, r);
            } : t;
        }();
        function createSizedArray(t) {
            return Array.apply(null, {
                length: t
            });
        }
        function _typeof$6(t) {
            return (_typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), _shouldRoundValues = !1, bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
        function ProjectInterface$1() {
            return {};
        }
        !function() {
            var t, e = [
                "abs",
                "acos",
                "acosh",
                "asin",
                "asinh",
                "atan",
                "atanh",
                "atan2",
                "ceil",
                "cbrt",
                "expm1",
                "clz32",
                "cos",
                "cosh",
                "exp",
                "floor",
                "fround",
                "hypot",
                "imul",
                "log",
                "log1p",
                "log2",
                "log10",
                "max",
                "min",
                "pow",
                "random",
                "round",
                "sign",
                "sin",
                "sinh",
                "sqrt",
                "tan",
                "tanh",
                "trunc",
                "E",
                "LN10",
                "LN2",
                "LOG10E",
                "LOG2E",
                "PI",
                "SQRT1_2",
                "SQRT2"
            ], r = e.length;
            for(t = 0; t < r; t += 1)BMMath[e[t]] = Math[e[t]];
        }(), BMMath.random = Math.random, BMMath.abs = function(t) {
            if ("object" === _typeof$6(t) && t.length) {
                var e, r = createSizedArray(t.length), i = t.length;
                for(e = 0; e < i; e += 1)r[e] = Math.abs(t[e]);
                return r;
            }
            return Math.abs(t);
        };
        var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = .5519;
        function roundValues(t) {
            _shouldRoundValues = !!t;
        }
        function bmRnd(t) {
            return _shouldRoundValues ? Math.round(t) : t;
        }
        function styleDiv(t) {
            t.style.position = "absolute", t.style.top = 0, t.style.left = 0, t.style.display = "block", t.style.transformOrigin = "0 0", t.style.webkitTransformOrigin = "0 0", t.style.backfaceVisibility = "visible", t.style.webkitBackfaceVisibility = "visible", t.style.transformStyle = "preserve-3d", t.style.webkitTransformStyle = "preserve-3d", t.style.mozTransformStyle = "preserve-3d";
        }
        function BMEnterFrameEvent(t, e, r, i) {
            this.type = t, this.currentTime = e, this.totalTime = r, this.direction = i < 0 ? -1 : 1;
        }
        function BMCompleteEvent(t, e) {
            this.type = t, this.direction = e < 0 ? -1 : 1;
        }
        function BMCompleteLoopEvent(t, e, r, i) {
            this.type = t, this.currentLoop = r, this.totalLoops = e, this.direction = i < 0 ? -1 : 1;
        }
        function BMSegmentStartEvent(t, e, r) {
            this.type = t, this.firstFrame = e, this.totalFrames = r;
        }
        function BMDestroyEvent(t, e) {
            this.type = t, this.target = e;
        }
        function BMRenderFrameErrorEvent(t, e) {
            this.type = "renderFrameError", this.nativeError = t, this.currentTime = e;
        }
        function BMConfigErrorEvent(t) {
            this.type = "configError", this.nativeError = t;
        }
        function BMAnimationConfigErrorEvent(t, e) {
            this.type = t, this.nativeError = e;
        }
        var createElementID = (_count = 0, function() {
            return idPrefix$1 + "__lottie_element_" + (_count += 1);
        }), _count;
        function HSVtoRGB(t, e, r) {
            var i, a, s, n, o, h, l, p;
            switch(h = r * (1 - e), l = r * (1 - (o = 6 * t - (n = Math.floor(6 * t))) * e), p = r * (1 - (1 - o) * e), n % 6){
                case 0:
                    i = r, a = p, s = h;
                    break;
                case 1:
                    i = l, a = r, s = h;
                    break;
                case 2:
                    i = h, a = r, s = p;
                    break;
                case 3:
                    i = h, a = l, s = r;
                    break;
                case 4:
                    i = p, a = h, s = r;
                    break;
                case 5:
                    i = r, a = h, s = l;
            }
            return [
                i,
                a,
                s
            ];
        }
        function RGBtoHSV(t, e, r) {
            var i, a = Math.max(t, e, r), s = Math.min(t, e, r), n = a - s, o = 0 === a ? 0 : n / a, h = a / 255;
            switch(a){
                case s:
                    i = 0;
                    break;
                case t:
                    i = e - r + n * (e < r ? 6 : 0), i /= 6 * n;
                    break;
                case e:
                    i = r - t + 2 * n, i /= 6 * n;
                    break;
                case r:
                    i = t - e + 4 * n, i /= 6 * n;
            }
            return [
                i,
                o,
                h
            ];
        }
        function addSaturationToRGB(t, e) {
            var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r[1] += e, r[1] > 1 ? r[1] = 1 : r[1] <= 0 && (r[1] = 0), HSVtoRGB(r[0], r[1], r[2]);
        }
        function addBrightnessToRGB(t, e) {
            var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r[2] += e, r[2] > 1 ? r[2] = 1 : r[2] < 0 && (r[2] = 0), HSVtoRGB(r[0], r[1], r[2]);
        }
        function addHueToRGB(t, e) {
            var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r[0] += e / 360, r[0] > 1 ? r[0] -= 1 : r[0] < 0 && (r[0] += 1), HSVtoRGB(r[0], r[1], r[2]);
        }
        var rgbToHex = function() {
            var t, e, r = [];
            for(t = 0; t < 256; t += 1)e = t.toString(16), r[t] = 1 === e.length ? "0" + e : e;
            return function(t, e, i) {
                return t < 0 && (t = 0), e < 0 && (e = 0), i < 0 && (i = 0), "#" + r[t] + r[e] + r[i];
            };
        }(), setSubframeEnabled = function(t) {
            subframeEnabled = !!t;
        }, getSubframeEnabled = function() {
            return subframeEnabled;
        }, setExpressionsPlugin = function(t) {
            expressionsPlugin = t;
        }, getExpressionsPlugin = function() {
            return expressionsPlugin;
        }, setExpressionInterfaces = function(t) {
            expressionsInterfaces = t;
        }, getExpressionInterfaces = function() {
            return expressionsInterfaces;
        }, setDefaultCurveSegments = function(t) {
            defaultCurveSegments = t;
        }, getDefaultCurveSegments = function() {
            return defaultCurveSegments;
        }, setIdPrefix = function(t) {
            idPrefix$1 = t;
        }, getIdPrefix = function() {
            return idPrefix$1;
        };
        function createNS(t) {
            return document.createElementNS(svgNS, t);
        }
        function _typeof$5(t) {
            return (_typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var dataManager = function() {
            var t, e, r = 1, i = [], a = {
                onmessage: function() {},
                postMessage: function(e) {
                    t({
                        data: e
                    });
                }
            }, s = {
                postMessage: function(t) {
                    a.onmessage({
                        data: t
                    });
                }
            };
            function n() {
                e || ((e = function(e) {
                    if (window.Worker && window.Blob && getWebWorker()) {
                        var r = new Blob([
                            "var _workerSelf = self; self.onmessage = ",
                            e.toString()
                        ], {
                            type: "text/javascript"
                        }), i = URL.createObjectURL(r);
                        return new Worker(i);
                    }
                    return t = e, a;
                }(function(t) {
                    if (s.dataManager || (s.dataManager = function() {
                        function t(a, s) {
                            var n, o, h, l, p, c, m = a.length;
                            for(o = 0; o < m; o += 1)if ("ks" in (n = a[o]) && !n.completed) {
                                if (n.completed = !0, n.hasMask) {
                                    var d = n.masksProperties;
                                    for(l = d.length, h = 0; h < l; h += 1)if (d[h].pt.k.i) i(d[h].pt.k);
                                    else for(c = d[h].pt.k.length, p = 0; p < c; p += 1)d[h].pt.k[p].s && i(d[h].pt.k[p].s[0]), d[h].pt.k[p].e && i(d[h].pt.k[p].e[0]);
                                }
                                0 === n.ty ? (n.layers = e(n.refId, s), t(n.layers, s)) : 4 === n.ty ? r(n.shapes) : 5 === n.ty && f(n);
                            }
                        }
                        function e(t, e) {
                            var r = function(t, e) {
                                for(var r = 0, i = e.length; r < i;){
                                    if (e[r].id === t) return e[r];
                                    r += 1;
                                }
                                return null;
                            }(t, e);
                            return r ? r.layers.__used ? JSON.parse(JSON.stringify(r.layers)) : (r.layers.__used = !0, r.layers) : null;
                        }
                        function r(t) {
                            var e, a, s;
                            for(e = t.length - 1; e >= 0; e -= 1)if ("sh" === t[e].ty) {
                                if (t[e].ks.k.i) i(t[e].ks.k);
                                else for(s = t[e].ks.k.length, a = 0; a < s; a += 1)t[e].ks.k[a].s && i(t[e].ks.k[a].s[0]), t[e].ks.k[a].e && i(t[e].ks.k[a].e[0]);
                            } else "gr" === t[e].ty && r(t[e].it);
                        }
                        function i(t) {
                            var e, r = t.i.length;
                            for(e = 0; e < r; e += 1)t.i[e][0] += t.v[e][0], t.i[e][1] += t.v[e][1], t.o[e][0] += t.v[e][0], t.o[e][1] += t.v[e][1];
                        }
                        function a(t, e) {
                            var r = e ? e.split(".") : [
                                100,
                                100,
                                100
                            ];
                            return t[0] > r[0] || !(r[0] > t[0]) && (t[1] > r[1] || !(r[1] > t[1]) && (t[2] > r[2] || !(r[2] > t[2]) && null));
                        }
                        var s, n = function() {
                            var t = [
                                4,
                                4,
                                14
                            ];
                            function e(t) {
                                var e, r, i, a = t.length;
                                for(e = 0; e < a; e += 1)5 === t[e].ty && (r = t[e], i = void 0, i = r.t.d, r.t.d = {
                                    k: [
                                        {
                                            s: i,
                                            t: 0
                                        }
                                    ]
                                });
                            }
                            return function(r) {
                                if (a(t, r.v) && (e(r.layers), r.assets)) {
                                    var i, s = r.assets.length;
                                    for(i = 0; i < s; i += 1)r.assets[i].layers && e(r.assets[i].layers);
                                }
                            };
                        }(), o = (s = [
                            4,
                            7,
                            99
                        ], function(t) {
                            if (t.chars && !a(s, t.v)) {
                                var e, i = t.chars.length;
                                for(e = 0; e < i; e += 1){
                                    var n = t.chars[e];
                                    n.data && n.data.shapes && (r(n.data.shapes), n.data.ip = 0, n.data.op = 99999, n.data.st = 0, n.data.sr = 1, n.data.ks = {
                                        p: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        s: {
                                            k: [
                                                100,
                                                100
                                            ],
                                            a: 0
                                        },
                                        a: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        r: {
                                            k: 0,
                                            a: 0
                                        },
                                        o: {
                                            k: 100,
                                            a: 0
                                        }
                                    }, t.chars[e].t || (n.data.shapes.push({
                                        ty: "no"
                                    }), n.data.shapes[0].it.push({
                                        p: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        s: {
                                            k: [
                                                100,
                                                100
                                            ],
                                            a: 0
                                        },
                                        a: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        r: {
                                            k: 0,
                                            a: 0
                                        },
                                        o: {
                                            k: 100,
                                            a: 0
                                        },
                                        sk: {
                                            k: 0,
                                            a: 0
                                        },
                                        sa: {
                                            k: 0,
                                            a: 0
                                        },
                                        ty: "tr"
                                    })));
                                }
                            }
                        }), h = function() {
                            var t = [
                                5,
                                7,
                                15
                            ];
                            function e(t) {
                                var e, r, i, a = t.length;
                                for(e = 0; e < a; e += 1)5 === t[e].ty && (r = t[e], i = void 0, "number" == typeof (i = r.t.p).a && (i.a = {
                                    a: 0,
                                    k: i.a
                                }), "number" == typeof i.p && (i.p = {
                                    a: 0,
                                    k: i.p
                                }), "number" == typeof i.r && (i.r = {
                                    a: 0,
                                    k: i.r
                                }));
                            }
                            return function(r) {
                                if (a(t, r.v) && (e(r.layers), r.assets)) {
                                    var i, s = r.assets.length;
                                    for(i = 0; i < s; i += 1)r.assets[i].layers && e(r.assets[i].layers);
                                }
                            };
                        }(), l = function() {
                            var t = [
                                4,
                                1,
                                9
                            ];
                            function e(t) {
                                var r, i, a, s = t.length;
                                for(r = 0; r < s; r += 1)if ("gr" === t[r].ty) e(t[r].it);
                                else if ("fl" === t[r].ty || "st" === t[r].ty) {
                                    if (t[r].c.k && t[r].c.k[0].i) for(a = t[r].c.k.length, i = 0; i < a; i += 1)t[r].c.k[i].s && (t[r].c.k[i].s[0] /= 255, t[r].c.k[i].s[1] /= 255, t[r].c.k[i].s[2] /= 255, t[r].c.k[i].s[3] /= 255), t[r].c.k[i].e && (t[r].c.k[i].e[0] /= 255, t[r].c.k[i].e[1] /= 255, t[r].c.k[i].e[2] /= 255, t[r].c.k[i].e[3] /= 255);
                                    else t[r].c.k[0] /= 255, t[r].c.k[1] /= 255, t[r].c.k[2] /= 255, t[r].c.k[3] /= 255;
                                }
                            }
                            function r(t) {
                                var r, i = t.length;
                                for(r = 0; r < i; r += 1)4 === t[r].ty && e(t[r].shapes);
                            }
                            return function(e) {
                                if (a(t, e.v) && (r(e.layers), e.assets)) {
                                    var i, s = e.assets.length;
                                    for(i = 0; i < s; i += 1)e.assets[i].layers && r(e.assets[i].layers);
                                }
                            };
                        }(), p = function() {
                            var t = [
                                4,
                                4,
                                18
                            ];
                            function e(t) {
                                var r, i, a;
                                for(r = t.length - 1; r >= 0; r -= 1)if ("sh" === t[r].ty) {
                                    if (t[r].ks.k.i) t[r].ks.k.c = t[r].closed;
                                    else for(a = t[r].ks.k.length, i = 0; i < a; i += 1)t[r].ks.k[i].s && (t[r].ks.k[i].s[0].c = t[r].closed), t[r].ks.k[i].e && (t[r].ks.k[i].e[0].c = t[r].closed);
                                } else "gr" === t[r].ty && e(t[r].it);
                            }
                            function r(t) {
                                var r, i, a, s, n, o, h = t.length;
                                for(i = 0; i < h; i += 1){
                                    if ((r = t[i]).hasMask) {
                                        var l = r.masksProperties;
                                        for(s = l.length, a = 0; a < s; a += 1)if (l[a].pt.k.i) l[a].pt.k.c = l[a].cl;
                                        else for(o = l[a].pt.k.length, n = 0; n < o; n += 1)l[a].pt.k[n].s && (l[a].pt.k[n].s[0].c = l[a].cl), l[a].pt.k[n].e && (l[a].pt.k[n].e[0].c = l[a].cl);
                                    }
                                    4 === r.ty && e(r.shapes);
                                }
                            }
                            return function(e) {
                                if (a(t, e.v) && (r(e.layers), e.assets)) {
                                    var i, s = e.assets.length;
                                    for(i = 0; i < s; i += 1)e.assets[i].layers && r(e.assets[i].layers);
                                }
                            };
                        }();
                        function f(t) {
                            0 === t.t.a.length && t.t.p;
                        }
                        var c = {
                            completeData: function(r) {
                                r.__complete || (l(r), n(r), o(r), h(r), p(r), t(r.layers, r.assets), function(r, i) {
                                    if (r) {
                                        var a = 0, s = r.length;
                                        for(a = 0; a < s; a += 1)1 === r[a].t && (r[a].data.layers = e(r[a].data.refId, i), t(r[a].data.layers, i));
                                    }
                                }(r.chars, r.assets), r.__complete = !0);
                            }
                        };
                        return c.checkColors = l, c.checkChars = o, c.checkPathProperties = h, c.checkShapes = p, c.completeLayers = t, c;
                    }()), s.assetLoader || (s.assetLoader = function() {
                        function t(t) {
                            var e = t.getResponseHeader("content-type");
                            return e && "json" === t.responseType && -1 !== e.indexOf("json") || t.response && "object" === _typeof$5(t.response) ? t.response : t.response && "string" == typeof t.response ? JSON.parse(t.response) : t.responseText ? JSON.parse(t.responseText) : null;
                        }
                        return {
                            load: function(e, r, i, a) {
                                var s, n = new XMLHttpRequest;
                                try {
                                    n.responseType = "json";
                                } catch (t) {}
                                n.onreadystatechange = function() {
                                    if (4 === n.readyState) {
                                        if (200 === n.status) s = t(n), i(s);
                                        else try {
                                            s = t(n), i(s);
                                        } catch (t) {
                                            a && a(t);
                                        }
                                    }
                                };
                                try {
                                    n.open([
                                        "G",
                                        "E",
                                        "T"
                                    ].join(""), e, !0);
                                } catch (t) {
                                    n.open([
                                        "G",
                                        "E",
                                        "T"
                                    ].join(""), r + "/" + e, !0);
                                }
                                n.send();
                            }
                        };
                    }()), "loadAnimation" === t.data.type) s.assetLoader.load(t.data.path, t.data.fullPath, function(e) {
                        s.dataManager.completeData(e), s.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    }, function() {
                        s.postMessage({
                            id: t.data.id,
                            status: "error"
                        });
                    });
                    else if ("complete" === t.data.type) {
                        var e = t.data.animation;
                        s.dataManager.completeData(e), s.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    } else "loadData" === t.data.type && s.assetLoader.load(t.data.path, t.data.fullPath, function(e) {
                        s.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    }, function() {
                        s.postMessage({
                            id: t.data.id,
                            status: "error"
                        });
                    });
                })).onmessage = function(t) {
                    var e = t.data, r = e.id, a = i[r];
                    i[r] = null, "success" === e.status ? a.onComplete(e.payload) : a.onError && a.onError();
                });
            }
            function o(t, e) {
                var a = "processId_" + (r += 1);
                return i[a] = {
                    onComplete: t,
                    onError: e
                }, a;
            }
            return {
                loadAnimation: function(t, r, i) {
                    n();
                    var a = o(r, i);
                    e.postMessage({
                        type: "loadAnimation",
                        path: t,
                        fullPath: window.location.origin + window.location.pathname,
                        id: a
                    });
                },
                loadData: function(t, r, i) {
                    n();
                    var a = o(r, i);
                    e.postMessage({
                        type: "loadData",
                        path: t,
                        fullPath: window.location.origin + window.location.pathname,
                        id: a
                    });
                },
                completeAnimation: function(t, r, i) {
                    n();
                    var a = o(r, i);
                    e.postMessage({
                        type: "complete",
                        animation: t,
                        id: a
                    });
                }
            };
        }(), ImagePreloader = function() {
            var t = function() {
                var t = createTag("canvas");
                t.width = 1, t.height = 1;
                var e = t.getContext("2d");
                return e.fillStyle = "rgba(0,0,0,0)", e.fillRect(0, 0, 1, 1), t;
            }();
            function e() {
                this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
            }
            function r() {
                this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
            }
            function i(t, e, r) {
                var i = "";
                if (t.e) i = t.p;
                else if (e) {
                    var a = t.p;
                    -1 !== a.indexOf("images/") && (a = a.split("/")[1]), i = e + a;
                } else i = r, i += t.u ? t.u : "", i += t.p;
                return i;
            }
            function a(t) {
                var e = 0, r = setInterval((function() {
                    (t.getBBox().width || e > 500) && (this._imageLoaded(), clearInterval(r)), e += 1;
                }).bind(this), 50);
            }
            function s(t) {
                var e = {
                    assetData: t
                }, r = i(t, this.assetsPath, this.path);
                return dataManager.loadData(r, (function(t) {
                    e.img = t, this._footageLoaded();
                }).bind(this), (function() {
                    e.img = {}, this._footageLoaded();
                }).bind(this)), e;
            }
            function n() {
                this._imageLoaded = e.bind(this), this._footageLoaded = r.bind(this), this.testImageLoaded = a.bind(this), this.createFootageData = s.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
            }
            return n.prototype = {
                loadAssets: function(t, e) {
                    var r;
                    this.imagesLoadedCb = e;
                    var i = t.length;
                    for(r = 0; r < i; r += 1)t[r].layers || (t[r].t && "seq" !== t[r].t ? 3 === t[r].t && (this.totalFootages += 1, this.images.push(this.createFootageData(t[r]))) : (this.totalImages += 1, this.images.push(this._createImageData(t[r]))));
                },
                setAssetsPath: function(t) {
                    this.assetsPath = t || "";
                },
                setPath: function(t) {
                    this.path = t || "";
                },
                loadedImages: function() {
                    return this.totalImages === this.loadedAssets;
                },
                loadedFootages: function() {
                    return this.totalFootages === this.loadedFootagesCount;
                },
                destroy: function() {
                    this.imagesLoadedCb = null, this.images.length = 0;
                },
                getAsset: function(t) {
                    for(var e = 0, r = this.images.length; e < r;){
                        if (this.images[e].assetData === t) return this.images[e].img;
                        e += 1;
                    }
                    return null;
                },
                createImgData: function(e) {
                    var r = i(e, this.assetsPath, this.path), a = createTag("img");
                    a.crossOrigin = "anonymous", a.addEventListener("load", this._imageLoaded, !1), a.addEventListener("error", (function() {
                        s.img = t, this._imageLoaded();
                    }).bind(this), !1), a.src = r;
                    var s = {
                        img: a,
                        assetData: e
                    };
                    return s;
                },
                createImageData: function(e) {
                    var r = i(e, this.assetsPath, this.path), a = createNS("image");
                    isSafari ? this.testImageLoaded(a) : a.addEventListener("load", this._imageLoaded, !1), a.addEventListener("error", (function() {
                        s.img = t, this._imageLoaded();
                    }).bind(this), !1), a.setAttributeNS("http://www.w3.org/1999/xlink", "href", r), this._elementHelper.append ? this._elementHelper.append(a) : this._elementHelper.appendChild(a);
                    var s = {
                        img: a,
                        assetData: e
                    };
                    return s;
                },
                imageLoaded: e,
                footageLoaded: r,
                setCacheType: function(t, e) {
                    "svg" === t ? (this._elementHelper = e, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
                }
            }, n;
        }();
        function BaseEvent() {}
        BaseEvent.prototype = {
            triggerEvent: function(t, e) {
                if (this._cbs[t]) for(var r = this._cbs[t], i = 0; i < r.length; i += 1)r[i](e);
            },
            addEventListener: function(t, e) {
                return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(e), (function() {
                    this.removeEventListener(t, e);
                }).bind(this);
            },
            removeEventListener: function(t, e) {
                if (e) {
                    if (this._cbs[t]) {
                        for(var r = 0, i = this._cbs[t].length; r < i;)this._cbs[t][r] === e && (this._cbs[t].splice(r, 1), r -= 1, i -= 1), r += 1;
                        this._cbs[t].length || (this._cbs[t] = null);
                    }
                } else this._cbs[t] = null;
            }
        };
        var markerParser = function() {
            function t(t) {
                for(var e, r = t.split("\r\n"), i = {}, a = 0, s = 0; s < r.length; s += 1)2 === (e = r[s].split(":")).length && (i[e[0]] = e[1].trim(), a += 1);
                if (0 === a) throw new Error;
                return i;
            }
            return function(e) {
                for(var r = [], i = 0; i < e.length; i += 1){
                    var a = e[i], s = {
                        time: a.tm,
                        duration: a.dr
                    };
                    try {
                        s.payload = JSON.parse(e[i].cm);
                    } catch (r) {
                        try {
                            s.payload = t(e[i].cm);
                        } catch (t) {
                            s.payload = {
                                name: e[i].cm
                            };
                        }
                    }
                    r.push(s);
                }
                return r;
            };
        }(), ProjectInterface = function() {
            function t(t) {
                this.compositions.push(t);
            }
            return function() {
                function e(t) {
                    for(var e = 0, r = this.compositions.length; e < r;){
                        if (this.compositions[e].data && this.compositions[e].data.nm === t) return this.compositions[e].prepareFrame && this.compositions[e].data.xt && this.compositions[e].prepareFrame(this.currentFrame), this.compositions[e].compInterface;
                        e += 1;
                    }
                    return null;
                }
                return e.compositions = [], e.currentFrame = 0, e.registerComposition = t, e;
            };
        }(), renderers = {}, registerRenderer = function(t, e) {
            renderers[t] = e;
        };
        function getRenderer(t) {
            return renderers[t];
        }
        function getRegisteredRenderer() {
            if (renderers.canvas) return "canvas";
            for(var t in renderers)if (renderers[t]) return t;
            return "";
        }
        function _typeof$4(t) {
            return (_typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var AnimationItem = function() {
            this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader, this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0), this.expressionsPlugin = getExpressionsPlugin();
        };
        extendPrototype([
            BaseEvent
        ], AnimationItem), AnimationItem.prototype.setParams = function(t) {
            (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
            var e = "svg";
            t.animType ? e = t.animType : t.renderer && (e = t.renderer);
            var r = getRenderer(e);
            this.renderer = new r(this, t.rendererSettings), this.imagePreloader.setCacheType(e, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = e, "" === t.loop || null === t.loop || void 0 === t.loop || !0 === t.loop ? this.loop = !0 : !1 === t.loop ? this.loop = !1 : this.loop = parseInt(t.loop, 10), this.autoplay = !("autoplay" in t) || t.autoplay, this.name = t.name ? t.name : "", this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") || t.autoloadSegments, this.assetsPath = t.assetsPath, this.initialSegment = t.initialSegment, t.audioFactory && this.audioController.setAudioFactory(t.audioFactory), t.animationData ? this.setupAnimation(t.animationData) : t.path && (-1 !== t.path.lastIndexOf("\\") ? this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1) : this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1), this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(t.path, this.configAnimation, this.onSetupError));
        }, AnimationItem.prototype.onSetupError = function() {
            this.trigger("data_failed");
        }, AnimationItem.prototype.setupAnimation = function(t) {
            dataManager.completeAnimation(t, this.configAnimation);
        }, AnimationItem.prototype.setData = function(t, e) {
            e && "object" !== _typeof$4(e) && (e = JSON.parse(e));
            var r = {
                wrapper: t,
                animationData: e
            }, i = t.attributes;
            r.path = i.getNamedItem("data-animation-path") ? i.getNamedItem("data-animation-path").value : i.getNamedItem("data-bm-path") ? i.getNamedItem("data-bm-path").value : i.getNamedItem("bm-path") ? i.getNamedItem("bm-path").value : "", r.animType = i.getNamedItem("data-anim-type") ? i.getNamedItem("data-anim-type").value : i.getNamedItem("data-bm-type") ? i.getNamedItem("data-bm-type").value : i.getNamedItem("bm-type") ? i.getNamedItem("bm-type").value : i.getNamedItem("data-bm-renderer") ? i.getNamedItem("data-bm-renderer").value : i.getNamedItem("bm-renderer") ? i.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
            var a = i.getNamedItem("data-anim-loop") ? i.getNamedItem("data-anim-loop").value : i.getNamedItem("data-bm-loop") ? i.getNamedItem("data-bm-loop").value : i.getNamedItem("bm-loop") ? i.getNamedItem("bm-loop").value : "";
            "false" === a ? r.loop = !1 : "true" === a ? r.loop = !0 : "" !== a && (r.loop = parseInt(a, 10));
            var s = i.getNamedItem("data-anim-autoplay") ? i.getNamedItem("data-anim-autoplay").value : i.getNamedItem("data-bm-autoplay") ? i.getNamedItem("data-bm-autoplay").value : !i.getNamedItem("bm-autoplay") || i.getNamedItem("bm-autoplay").value;
            r.autoplay = "false" !== s, r.name = i.getNamedItem("data-name") ? i.getNamedItem("data-name").value : i.getNamedItem("data-bm-name") ? i.getNamedItem("data-bm-name").value : i.getNamedItem("bm-name") ? i.getNamedItem("bm-name").value : "", "false" === (i.getNamedItem("data-anim-prerender") ? i.getNamedItem("data-anim-prerender").value : i.getNamedItem("data-bm-prerender") ? i.getNamedItem("data-bm-prerender").value : i.getNamedItem("bm-prerender") ? i.getNamedItem("bm-prerender").value : "") && (r.prerender = !1), r.path ? this.setParams(r) : this.trigger("destroy");
        }, AnimationItem.prototype.includeLayers = function(t) {
            t.op > this.animationData.op && (this.animationData.op = t.op, this.totalFrames = Math.floor(t.op - this.animationData.ip));
            var e, r, i = this.animationData.layers, a = i.length, s = t.layers, n = s.length;
            for(r = 0; r < n; r += 1)for(e = 0; e < a;){
                if (i[e].id === s[r].id) {
                    i[e] = s[r];
                    break;
                }
                e += 1;
            }
            if ((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars), this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)), t.assets) for(a = t.assets.length, e = 0; e < a; e += 1)this.animationData.assets.push(t.assets[e]);
            this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
        }, AnimationItem.prototype.onSegmentComplete = function(t) {
            this.animationData = t;
            var e = getExpressionsPlugin();
            e && e.initExpressions(this), this.loadNextSegment();
        }, AnimationItem.prototype.loadNextSegment = function() {
            var t = this.animationData.segments;
            if (!t || 0 === t.length || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
            var e = t.shift();
            this.timeCompleted = e.time * this.frameRate;
            var r = this.path + this.fileName + "_" + this.segmentPos + ".json";
            this.segmentPos += 1, dataManager.loadData(r, this.includeLayers.bind(this), (function() {
                this.trigger("data_failed");
            }).bind(this));
        }, AnimationItem.prototype.loadSegments = function() {
            this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
        }, AnimationItem.prototype.imagesLoaded = function() {
            this.trigger("loaded_images"), this.checkLoaded();
        }, AnimationItem.prototype.preloadImages = function() {
            this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
        }, AnimationItem.prototype.configAnimation = function(t) {
            if (this.renderer) try {
                this.animationData = t, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t), t.assets || (t.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t.assets), this.markers = markerParser(t.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
            } catch (t) {
                this.triggerConfigError(t);
            }
        }, AnimationItem.prototype.waitForFontsLoaded = function() {
            this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
        }, AnimationItem.prototype.checkLoaded = function() {
            if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || "canvas" !== this.renderer.rendererType) && this.imagePreloader.loadedFootages()) {
                this.isLoaded = !0;
                var t = getExpressionsPlugin();
                t && t.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
                    this.trigger("DOMLoaded");
                }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
            }
        }, AnimationItem.prototype.resize = function(t, e) {
            var r = "number" == typeof t ? t : void 0, i = "number" == typeof e ? e : void 0;
            this.renderer.updateContainerSize(r, i);
        }, AnimationItem.prototype.setSubframe = function(t) {
            this.isSubframeEnabled = !!t;
        }, AnimationItem.prototype.gotoFrame = function() {
            this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
        }, AnimationItem.prototype.renderFrame = function() {
            if (!1 !== this.isLoaded && this.renderer) try {
                this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
            } catch (t) {
                this.triggerRenderFrameError(t);
            }
        }, AnimationItem.prototype.play = function(t) {
            t && this.name !== t || !0 === this.isPaused && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
        }, AnimationItem.prototype.pause = function(t) {
            t && this.name !== t || !1 === this.isPaused && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
        }, AnimationItem.prototype.togglePause = function(t) {
            t && this.name !== t || (!0 === this.isPaused ? this.play() : this.pause());
        }, AnimationItem.prototype.stop = function(t) {
            t && this.name !== t || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
        }, AnimationItem.prototype.getMarkerData = function(t) {
            for(var e, r = 0; r < this.markers.length; r += 1)if ((e = this.markers[r]).payload && e.payload.name === t) return e;
            return null;
        }, AnimationItem.prototype.goToAndStop = function(t, e, r) {
            if (!r || this.name === r) {
                var i = Number(t);
                if (isNaN(i)) {
                    var a = this.getMarkerData(t);
                    a && this.goToAndStop(a.time, !0);
                } else e ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);
                this.pause();
            }
        }, AnimationItem.prototype.goToAndPlay = function(t, e, r) {
            if (!r || this.name === r) {
                var i = Number(t);
                if (isNaN(i)) {
                    var a = this.getMarkerData(t);
                    a && (a.duration ? this.playSegments([
                        a.time,
                        a.time + a.duration
                    ], !0) : this.goToAndStop(a.time, !0));
                } else this.goToAndStop(i, e, r);
                this.play();
            }
        }, AnimationItem.prototype.advanceTime = function(t) {
            if (!0 !== this.isPaused && !1 !== this.isLoaded) {
                var e = this.currentRawFrame + t * this.frameModifier, r = !1;
                e >= this.totalFrames - 1 && this.frameModifier > 0 ? this.loop && this.playCount !== this.loop ? e >= this.totalFrames ? (this.playCount += 1, this.checkSegments(e % this.totalFrames) || (this.setCurrentRawFrameValue(e % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(e) : this.checkSegments(e > this.totalFrames ? e % this.totalFrames : 0) || (r = !0, e = this.totalFrames - 1) : e < 0 ? this.checkSegments(e % this.totalFrames) || (!this.loop || this.playCount-- <= 0 && !0 !== this.loop ? (r = !0, e = 0) : (this.setCurrentRawFrameValue(this.totalFrames + e % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0)) : this.setCurrentRawFrameValue(e), r && (this.setCurrentRawFrameValue(e), this.pause(), this.trigger("complete"));
            }
        }, AnimationItem.prototype.adjustSegment = function(t, e) {
            this.playCount = 0, t[1] < t[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t[0] - t[1], this.timeCompleted = this.totalFrames, this.firstFrame = t[1], this.setCurrentRawFrameValue(this.totalFrames - .001 - e)) : t[1] > t[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t[1] - t[0], this.timeCompleted = this.totalFrames, this.firstFrame = t[0], this.setCurrentRawFrameValue(.001 + e)), this.trigger("segmentStart");
        }, AnimationItem.prototype.setSegment = function(t, e) {
            var r = -1;
            this.isPaused && (this.currentRawFrame + this.firstFrame < t ? r = t : this.currentRawFrame + this.firstFrame > e && (r = e - t)), this.firstFrame = t, this.totalFrames = e - t, this.timeCompleted = this.totalFrames, -1 !== r && this.goToAndStop(r, !0);
        }, AnimationItem.prototype.playSegments = function(t, e) {
            if (e && (this.segments.length = 0), "object" === _typeof$4(t[0])) {
                var r, i = t.length;
                for(r = 0; r < i; r += 1)this.segments.push(t[r]);
            } else this.segments.push(t);
            this.segments.length && e && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
        }, AnimationItem.prototype.resetSegments = function(t) {
            this.segments.length = 0, this.segments.push([
                this.animationData.ip,
                this.animationData.op
            ]), t && this.checkSegments(0);
        }, AnimationItem.prototype.checkSegments = function(t) {
            return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t), !0);
        }, AnimationItem.prototype.destroy = function(t) {
            t && this.name !== t || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
        }, AnimationItem.prototype.setCurrentRawFrameValue = function(t) {
            this.currentRawFrame = t, this.gotoFrame();
        }, AnimationItem.prototype.setSpeed = function(t) {
            this.playSpeed = t, this.updaFrameModifier();
        }, AnimationItem.prototype.setDirection = function(t) {
            this.playDirection = t < 0 ? -1 : 1, this.updaFrameModifier();
        }, AnimationItem.prototype.setLoop = function(t) {
            this.loop = t;
        }, AnimationItem.prototype.setVolume = function(t, e) {
            e && this.name !== e || this.audioController.setVolume(t);
        }, AnimationItem.prototype.getVolume = function() {
            return this.audioController.getVolume();
        }, AnimationItem.prototype.mute = function(t) {
            t && this.name !== t || this.audioController.mute();
        }, AnimationItem.prototype.unmute = function(t) {
            t && this.name !== t || this.audioController.unmute();
        }, AnimationItem.prototype.updaFrameModifier = function() {
            this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
        }, AnimationItem.prototype.getPath = function() {
            return this.path;
        }, AnimationItem.prototype.getAssetsPath = function(t) {
            var e = "";
            if (t.e) e = t.p;
            else if (this.assetsPath) {
                var r = t.p;
                -1 !== r.indexOf("images/") && (r = r.split("/")[1]), e = this.assetsPath + r;
            } else e = this.path, e += t.u ? t.u : "", e += t.p;
            return e;
        }, AnimationItem.prototype.getAssetData = function(t) {
            for(var e = 0, r = this.assets.length; e < r;){
                if (t === this.assets[e].id) return this.assets[e];
                e += 1;
            }
            return null;
        }, AnimationItem.prototype.hide = function() {
            this.renderer.hide();
        }, AnimationItem.prototype.show = function() {
            this.renderer.show();
        }, AnimationItem.prototype.getDuration = function(t) {
            return t ? this.totalFrames : this.totalFrames / this.frameRate;
        }, AnimationItem.prototype.updateDocumentData = function(t, e, r) {
            try {
                this.renderer.getElementByPath(t).updateDocumentData(e, r);
            } catch (t) {}
        }, AnimationItem.prototype.trigger = function(t) {
            if (this._cbs && this._cbs[t]) switch(t){
                case "enterFrame":
                    this.triggerEvent(t, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameModifier));
                    break;
                case "drawnFrame":
                    this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(t, this.drawnFrameEvent);
                    break;
                case "loopComplete":
                    this.triggerEvent(t, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult));
                    break;
                case "complete":
                    this.triggerEvent(t, new BMCompleteEvent(t, this.frameMult));
                    break;
                case "segmentStart":
                    this.triggerEvent(t, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames));
                    break;
                case "destroy":
                    this.triggerEvent(t, new BMDestroyEvent(t, this));
                    break;
                default:
                    this.triggerEvent(t);
            }
            "enterFrame" === t && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameMult)), "loopComplete" === t && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult)), "complete" === t && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(t, this.frameMult)), "segmentStart" === t && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)), "destroy" === t && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t, this));
        }, AnimationItem.prototype.triggerRenderFrameError = function(t) {
            var e = new BMRenderFrameErrorEvent(t, this.currentFrame);
            this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
        }, AnimationItem.prototype.triggerConfigError = function(t) {
            var e = new BMConfigErrorEvent(t, this.currentFrame);
            this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
        };
        var animationManager = function() {
            var t = {}, e = [], r = 0, i = 0, a = 0, s = !0, n = !1;
            function o(t) {
                for(var r = 0, a = t.target; r < i;)e[r].animation === a && (e.splice(r, 1), r -= 1, i -= 1, a.isPaused || p()), r += 1;
            }
            function h(t, r) {
                if (!t) return null;
                for(var a = 0; a < i;){
                    if (e[a].elem === t && null !== e[a].elem) return e[a].animation;
                    a += 1;
                }
                var s = new AnimationItem;
                return f(s, t), s.setData(t, r), s;
            }
            function l() {
                a += 1, d();
            }
            function p() {
                a -= 1;
            }
            function f(t, r) {
                t.addEventListener("destroy", o), t.addEventListener("_active", l), t.addEventListener("_idle", p), e.push({
                    elem: r,
                    animation: t
                }), i += 1;
            }
            function c(t) {
                var o, h = t - r;
                for(o = 0; o < i; o += 1)e[o].animation.advanceTime(h);
                r = t, a && !n ? window.requestAnimationFrame(c) : s = !0;
            }
            function m(t) {
                r = t, window.requestAnimationFrame(c);
            }
            function d() {
                !n && a && s && (window.requestAnimationFrame(m), s = !1);
            }
            return t.registerAnimation = h, t.loadAnimation = function(t) {
                var e = new AnimationItem;
                return f(e, null), e.setParams(t), e;
            }, t.setSpeed = function(t, r) {
                var a;
                for(a = 0; a < i; a += 1)e[a].animation.setSpeed(t, r);
            }, t.setDirection = function(t, r) {
                var a;
                for(a = 0; a < i; a += 1)e[a].animation.setDirection(t, r);
            }, t.play = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.play(t);
            }, t.pause = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.pause(t);
            }, t.stop = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.stop(t);
            }, t.togglePause = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.togglePause(t);
            }, t.searchAnimations = function(t, e, r) {
                var i, a = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), s = a.length;
                for(i = 0; i < s; i += 1)r && a[i].setAttribute("data-bm-type", r), h(a[i], t);
                if (e && 0 === s) {
                    r || (r = "svg");
                    var n = document.getElementsByTagName("body")[0];
                    n.innerText = "";
                    var o = createTag("div");
                    o.style.width = "100%", o.style.height = "100%", o.setAttribute("data-bm-type", r), n.appendChild(o), h(o, t);
                }
            }, t.resize = function() {
                var t;
                for(t = 0; t < i; t += 1)e[t].animation.resize();
            }, t.goToAndStop = function(t, r, a) {
                var s;
                for(s = 0; s < i; s += 1)e[s].animation.goToAndStop(t, r, a);
            }, t.destroy = function(t) {
                var r;
                for(r = i - 1; r >= 0; r -= 1)e[r].animation.destroy(t);
            }, t.freeze = function() {
                n = !0;
            }, t.unfreeze = function() {
                n = !1, d();
            }, t.setVolume = function(t, r) {
                var a;
                for(a = 0; a < i; a += 1)e[a].animation.setVolume(t, r);
            }, t.mute = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.mute(t);
            }, t.unmute = function(t) {
                var r;
                for(r = 0; r < i; r += 1)e[r].animation.unmute(t);
            }, t.getRegisteredAnimations = function() {
                var t, r = e.length, i = [];
                for(t = 0; t < r; t += 1)i.push(e[t].animation);
                return i;
            }, t;
        }(), BezierFactory = function() {
            var t = {
                getBezierEasing: function(t, r, i, a, s) {
                    var n = s || ("bez_" + t + "_" + r + "_" + i + "_" + a).replace(/\./g, "p");
                    if (e[n]) return e[n];
                    var o = new h([
                        t,
                        r,
                        i,
                        a
                    ]);
                    return e[n] = o, o;
                }
            }, e = {};
            var r = "function" == typeof Float32Array;
            function i(t, e) {
                return 1 - 3 * e + 3 * t;
            }
            function a(t, e) {
                return 3 * e - 6 * t;
            }
            function s(t) {
                return 3 * t;
            }
            function n(t, e, r) {
                return ((i(e, r) * t + a(e, r)) * t + s(e)) * t;
            }
            function o(t, e, r) {
                return 3 * i(e, r) * t * t + 2 * a(e, r) * t + s(e);
            }
            function h(t) {
                this._p = t, this._mSampleValues = r ? new Float32Array(11) : new Array(11), this._precomputed = !1, this.get = this.get.bind(this);
            }
            return h.prototype = {
                get: function(t) {
                    var e = this._p[0], r = this._p[1], i = this._p[2], a = this._p[3];
                    return this._precomputed || this._precompute(), e === r && i === a ? t : 0 === t ? 0 : 1 === t ? 1 : n(this._getTForX(t), r, a);
                },
                _precompute: function() {
                    var t = this._p[0], e = this._p[1], r = this._p[2], i = this._p[3];
                    this._precomputed = !0, t === e && r === i || this._calcSampleValues();
                },
                _calcSampleValues: function() {
                    for(var t = this._p[0], e = this._p[2], r = 0; r < 11; ++r)this._mSampleValues[r] = n(.1 * r, t, e);
                },
                _getTForX: function(t) {
                    for(var e = this._p[0], r = this._p[2], i = this._mSampleValues, a = 0, s = 1; 10 !== s && i[s] <= t; ++s)a += .1;
                    var h = a + .1 * ((t - i[--s]) / (i[s + 1] - i[s])), l = o(h, e, r);
                    return l >= .001 ? function(t, e, r, i) {
                        for(var a = 0; a < 4; ++a){
                            var s = o(e, r, i);
                            if (0 === s) return e;
                            e -= (n(e, r, i) - t) / s;
                        }
                        return e;
                    }(t, h, e, r) : 0 === l ? h : function(t, e, r, i, a) {
                        var s, o, h = 0;
                        do (s = n(o = e + (r - e) / 2, i, a) - t) > 0 ? r = o : e = o;
                        while (Math.abs(s) > 1e-7 && ++h < 10);
                        return o;
                    }(t, a, a + .1, e, r);
                }
            }, t;
        }(), pooling = {
            double: function(t) {
                return t.concat(createSizedArray(t.length));
            }
        }, poolFactory = function(t, e, r) {
            var i = 0, a = t, s = createSizedArray(a);
            return {
                newElement: function() {
                    return i ? s[i -= 1] : e();
                },
                release: function(t) {
                    i === a && (s = pooling.double(s), a *= 2), r && r(t), s[i] = t, i += 1;
                }
            };
        }, bezierLengthPool = poolFactory(8, function() {
            return {
                addedLength: 0,
                percents: createTypedArray("float32", getDefaultCurveSegments()),
                lengths: createTypedArray("float32", getDefaultCurveSegments())
            };
        }), segmentsLengthPool = poolFactory(8, function() {
            return {
                lengths: [],
                totalLength: 0
            };
        }, function(t) {
            var e, r = t.lengths.length;
            for(e = 0; e < r; e += 1)bezierLengthPool.release(t.lengths[e]);
            t.lengths.length = 0;
        });
        function bezFunction() {
            var t = Math;
            function e(t, e, r, i, a, s) {
                var n = t * i + e * a + r * s - a * i - s * t - r * e;
                return n > -0.001 && n < .001;
            }
            var r = function(t, e, r, i) {
                var a, s, n, o, h, l, p = getDefaultCurveSegments(), f = 0, c = [], m = [], d = bezierLengthPool.newElement();
                for(n = r.length, a = 0; a < p; a += 1){
                    for(h = a / (p - 1), l = 0, s = 0; s < n; s += 1)o = bmPow(1 - h, 3) * t[s] + 3 * bmPow(1 - h, 2) * h * r[s] + 3 * (1 - h) * bmPow(h, 2) * i[s] + bmPow(h, 3) * e[s], c[s] = o, null !== m[s] && (l += bmPow(c[s] - m[s], 2)), m[s] = c[s];
                    l && (f += l = bmSqrt(l)), d.percents[a] = h, d.lengths[a] = f;
                }
                return d.addedLength = f, d;
            };
            function i(t) {
                this.segmentLength = 0, this.points = new Array(t);
            }
            function a(t, e) {
                this.partialLength = t, this.point = e;
            }
            var s, n = (s = {}, function(t, r, n, o) {
                var h = (t[0] + "_" + t[1] + "_" + r[0] + "_" + r[1] + "_" + n[0] + "_" + n[1] + "_" + o[0] + "_" + o[1]).replace(/\./g, "p");
                if (!s[h]) {
                    var l, p, f, c, m, d, u, y = getDefaultCurveSegments(), g = 0, v = null;
                    2 === t.length && (t[0] !== r[0] || t[1] !== r[1]) && e(t[0], t[1], r[0], r[1], t[0] + n[0], t[1] + n[1]) && e(t[0], t[1], r[0], r[1], r[0] + o[0], r[1] + o[1]) && (y = 2);
                    var b = new i(y);
                    for(f = n.length, l = 0; l < y; l += 1){
                        for(u = createSizedArray(f), m = l / (y - 1), d = 0, p = 0; p < f; p += 1)c = bmPow(1 - m, 3) * t[p] + 3 * bmPow(1 - m, 2) * m * (t[p] + n[p]) + 3 * (1 - m) * bmPow(m, 2) * (r[p] + o[p]) + bmPow(m, 3) * r[p], u[p] = c, null !== v && (d += bmPow(u[p] - v[p], 2));
                        g += d = bmSqrt(d), b.points[l] = new a(d, u), v = u;
                    }
                    b.segmentLength = g, s[h] = b;
                }
                return s[h];
            });
            function o(t, e) {
                var r = e.percents, i = e.lengths, a = r.length, s = bmFloor((a - 1) * t), n = t * e.addedLength, o = 0;
                if (s === a - 1 || 0 === s || n === i[s]) return r[s];
                for(var h = i[s] > n ? -1 : 1, l = !0; l;)if (i[s] <= n && i[s + 1] > n ? (o = (n - i[s]) / (i[s + 1] - i[s]), l = !1) : s += h, s < 0 || s >= a - 1) {
                    if (s === a - 1) return r[s];
                    l = !1;
                }
                return r[s] + (r[s + 1] - r[s]) * o;
            }
            var h = createTypedArray("float32", 8);
            return {
                getSegmentsLength: function(t) {
                    var e, i = segmentsLengthPool.newElement(), a = t.c, s = t.v, n = t.o, o = t.i, h = t._length, l = i.lengths, p = 0;
                    for(e = 0; e < h - 1; e += 1)l[e] = r(s[e], s[e + 1], n[e], o[e + 1]), p += l[e].addedLength;
                    return a && h && (l[e] = r(s[e], s[0], n[e], o[0]), p += l[e].addedLength), i.totalLength = p, i;
                },
                getNewSegment: function(e, r, i, a, s, n, l) {
                    s < 0 ? s = 0 : s > 1 && (s = 1);
                    var p, f = o(s, l), c = o(n = n > 1 ? 1 : n, l), m = e.length, d = 1 - f, u = 1 - c, y = d * d * d, g = f * d * d * 3, v = f * f * d * 3, b = f * f * f, x = d * d * u, E = f * d * u + d * f * u + d * d * c, S = f * f * u + d * f * c + f * d * c, P = f * f * c, C = d * u * u, _ = f * u * u + d * c * u + d * u * c, k = f * c * u + d * c * c + f * u * c, A = f * c * c, T = u * u * u, M = c * u * u + u * c * u + u * u * c, w = c * c * u + u * c * c + c * u * c, D = c * c * c;
                    for(p = 0; p < m; p += 1)h[4 * p] = t.round(1e3 * (y * e[p] + g * i[p] + v * a[p] + b * r[p])) / 1e3, h[4 * p + 1] = t.round(1e3 * (x * e[p] + E * i[p] + S * a[p] + P * r[p])) / 1e3, h[4 * p + 2] = t.round(1e3 * (C * e[p] + _ * i[p] + k * a[p] + A * r[p])) / 1e3, h[4 * p + 3] = t.round(1e3 * (T * e[p] + M * i[p] + w * a[p] + D * r[p])) / 1e3;
                    return h;
                },
                getPointInSegment: function(e, r, i, a, s, n) {
                    var h = o(s, n), l = 1 - h;
                    return [
                        t.round(1e3 * (l * l * l * e[0] + (h * l * l + l * h * l + l * l * h) * i[0] + (h * h * l + l * h * h + h * l * h) * a[0] + h * h * h * r[0])) / 1e3,
                        t.round(1e3 * (l * l * l * e[1] + (h * l * l + l * h * l + l * l * h) * i[1] + (h * h * l + l * h * h + h * l * h) * a[1] + h * h * h * r[1])) / 1e3
                    ];
                },
                buildBezierData: n,
                pointOnLine2D: e,
                pointOnLine3D: function(r, i, a, s, n, o, h, l, p) {
                    if (0 === a && 0 === o && 0 === p) return e(r, i, s, n, h, l);
                    var f, c = t.sqrt(t.pow(s - r, 2) + t.pow(n - i, 2) + t.pow(o - a, 2)), m = t.sqrt(t.pow(h - r, 2) + t.pow(l - i, 2) + t.pow(p - a, 2)), d = t.sqrt(t.pow(h - s, 2) + t.pow(l - n, 2) + t.pow(p - o, 2));
                    return (f = c > m ? c > d ? c - m - d : d - m - c : d > m ? d - m - c : m - c - d) > -0.0001 && f < 1e-4;
                }
            };
        }
        var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
        function interpolateValue(t, e) {
            var r, i = this.offsetTime;
            "multidimensional" === this.propType && (r = createTypedArray("float32", this.pv.length));
            for(var a, s, n, o, h, l, p, f, c, m = e.lastIndex, d = m, u = this.keyframes.length - 1, y = !0; y;){
                if (a = this.keyframes[d], s = this.keyframes[d + 1], d === u - 1 && t >= s.t - i) {
                    a.h && (a = s), m = 0;
                    break;
                }
                if (s.t - i > t) {
                    m = d;
                    break;
                }
                d < u - 1 ? d += 1 : (m = 0, y = !1);
            }
            n = this.keyframesMetadata[d] || {};
            var g, v = s.t - i, b = a.t - i;
            if (a.to) {
                n.bezierData || (n.bezierData = bez.buildBezierData(a.s, s.s || a.e, a.to, a.ti));
                var x = n.bezierData;
                if (t >= v || t < b) {
                    var E = t >= v ? x.points.length - 1 : 0;
                    for(h = x.points[E].point.length, o = 0; o < h; o += 1)r[o] = x.points[E].point[o];
                } else {
                    n.__fnct ? c = n.__fnct : (c = BezierFactory.getBezierEasing(a.o.x, a.o.y, a.i.x, a.i.y, a.n).get, n.__fnct = c), l = c((t - b) / (v - b));
                    var S, P = x.segmentLength * l, C = e.lastFrame < t && e._lastKeyframeIndex === d ? e._lastAddedLength : 0;
                    for(f = e.lastFrame < t && e._lastKeyframeIndex === d ? e._lastPoint : 0, y = !0, p = x.points.length; y;){
                        if (C += x.points[f].partialLength, 0 === P || 0 === l || f === x.points.length - 1) {
                            for(h = x.points[f].point.length, o = 0; o < h; o += 1)r[o] = x.points[f].point[o];
                            break;
                        }
                        if (P >= C && P < C + x.points[f + 1].partialLength) {
                            for(S = (P - C) / x.points[f + 1].partialLength, h = x.points[f].point.length, o = 0; o < h; o += 1)r[o] = x.points[f].point[o] + (x.points[f + 1].point[o] - x.points[f].point[o]) * S;
                            break;
                        }
                        f < p - 1 ? f += 1 : y = !1;
                    }
                    e._lastPoint = f, e._lastAddedLength = C - x.points[f].partialLength, e._lastKeyframeIndex = d;
                }
            } else {
                var _, k, A, T, M;
                if (u = a.s.length, g = s.s || a.e, this.sh && 1 !== a.h) {
                    if (t >= v) r[0] = g[0], r[1] = g[1], r[2] = g[2];
                    else if (t <= b) r[0] = a.s[0], r[1] = a.s[1], r[2] = a.s[2];
                    else quaternionToEuler(r, slerp(createQuaternion(a.s), createQuaternion(g), (t - b) / (v - b)));
                } else for(d = 0; d < u; d += 1)1 !== a.h && (t >= v ? l = 1 : t < b ? l = 0 : (a.o.x.constructor === Array ? (n.__fnct || (n.__fnct = []), n.__fnct[d] ? c = n.__fnct[d] : (_ = void 0 === a.o.x[d] ? a.o.x[0] : a.o.x[d], k = void 0 === a.o.y[d] ? a.o.y[0] : a.o.y[d], A = void 0 === a.i.x[d] ? a.i.x[0] : a.i.x[d], T = void 0 === a.i.y[d] ? a.i.y[0] : a.i.y[d], c = BezierFactory.getBezierEasing(_, k, A, T).get, n.__fnct[d] = c)) : n.__fnct ? c = n.__fnct : (_ = a.o.x, k = a.o.y, A = a.i.x, T = a.i.y, c = BezierFactory.getBezierEasing(_, k, A, T).get, a.keyframeMetadata = c), l = c((t - b) / (v - b)))), g = s.s || a.e, M = 1 === a.h ? a.s[d] : a.s[d] + (g[d] - a.s[d]) * l, "multidimensional" === this.propType ? r[d] = M : r = M;
            }
            return e.lastIndex = m, r;
        }
        function slerp(t, e, r) {
            var i, a, s, n, o, h = [], l = t[0], p = t[1], f = t[2], c = t[3], m = e[0], d = e[1], u = e[2], y = e[3];
            return (a = l * m + p * d + f * u + c * y) < 0 && (a = -a, m = -m, d = -d, u = -u, y = -y), 1 - a > 1e-6 ? (i = Math.acos(a), s = Math.sin(i), n = Math.sin((1 - r) * i) / s, o = Math.sin(r * i) / s) : (n = 1 - r, o = r), h[0] = n * l + o * m, h[1] = n * p + o * d, h[2] = n * f + o * u, h[3] = n * c + o * y, h;
        }
        function quaternionToEuler(t, e) {
            var r = e[0], i = e[1], a = e[2], s = e[3], n = Math.atan2(2 * i * s - 2 * r * a, 1 - 2 * i * i - 2 * a * a), o = Math.asin(2 * r * i + 2 * a * s), h = Math.atan2(2 * r * s - 2 * i * a, 1 - 2 * r * r - 2 * a * a);
            t[0] = n / degToRads, t[1] = o / degToRads, t[2] = h / degToRads;
        }
        function createQuaternion(t) {
            var e = t[0] * degToRads, r = t[1] * degToRads, i = t[2] * degToRads, a = Math.cos(e / 2), s = Math.cos(r / 2), n = Math.cos(i / 2), o = Math.sin(e / 2), h = Math.sin(r / 2), l = Math.sin(i / 2);
            return [
                o * h * n + a * s * l,
                o * s * n + a * h * l,
                a * h * n - o * s * l,
                a * s * n - o * h * l
            ];
        }
        function getValueAtCurrentTime() {
            var t = this.comp.renderedFrame - this.offsetTime, e = this.keyframes[0].t - this.offsetTime, r = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            if (!(t === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= r && t >= r || this._caching.lastFrame < e && t < e))) {
                this._caching.lastFrame >= t && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
                var i = this.interpolateValue(t, this._caching);
                this.pv = i;
            }
            return this._caching.lastFrame = t, this.pv;
        }
        function setVValue(t) {
            var e;
            if ("unidimensional" === this.propType) e = t * this.mult, mathAbs(this.v - e) > 1e-5 && (this.v = e, this._mdf = !0);
            else for(var r = 0, i = this.v.length; r < i;)e = t[r] * this.mult, mathAbs(this.v[r] - e) > 1e-5 && (this.v[r] = e, this._mdf = !0), r += 1;
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) {
                if (this.lock) this.setVValue(this.pv);
                else {
                    var t;
                    this.lock = !0, this._mdf = this._isFirstFrame;
                    var e = this.effectsSequence.length, r = this.kf ? this.pv : this.data.k;
                    for(t = 0; t < e; t += 1)r = this.effectsSequence[t](r);
                    this.setVValue(r), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                }
            }
        }
        function addEffect(t) {
            this.effectsSequence.push(t), this.container.addDynamicProperty(this);
        }
        function ValueProperty(t, e, r, i) {
            this.propType = "unidimensional", this.mult = r || 1, this.data = e, this.v = r ? e.k * r : e.k, this.pv = e.k, this._mdf = !1, this.elem = t, this.container = i, this.comp = t.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
        }
        function MultiDimensionalProperty(t, e, r, i) {
            var a;
            this.propType = "multidimensional", this.mult = r || 1, this.data = e, this._mdf = !1, this.elem = t, this.container = i, this.comp = t.comp, this.k = !1, this.kf = !1, this.frameId = -1;
            var s = e.k.length;
            for(this.v = createTypedArray("float32", s), this.pv = createTypedArray("float32", s), this.vel = createTypedArray("float32", s), a = 0; a < s; a += 1)this.v[a] = e.k[a] * this.mult, this.pv[a] = e.k[a];
            this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
        }
        function KeyframedValueProperty(t, e, r, i) {
            this.propType = "unidimensional", this.keyframes = e.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.frameId = -1, this._caching = {
                lastFrame: initFrame,
                lastIndex: 0,
                value: 0,
                _lastKeyframeIndex: -1
            }, this.k = !0, this.kf = !0, this.data = e, this.mult = r || 1, this.elem = t, this.container = i, this.comp = t.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [
                getValueAtCurrentTime.bind(this)
            ], this.addEffect = addEffect;
        }
        function KeyframedMultidimensionalProperty(t, e, r, i) {
            var a;
            this.propType = "multidimensional";
            var s, n, o, h, l = e.k.length;
            for(a = 0; a < l - 1; a += 1)e.k[a].to && e.k[a].s && e.k[a + 1] && e.k[a + 1].s && (s = e.k[a].s, n = e.k[a + 1].s, o = e.k[a].to, h = e.k[a].ti, (2 === s.length && (s[0] !== n[0] || s[1] !== n[1]) && bez.pointOnLine2D(s[0], s[1], n[0], n[1], s[0] + o[0], s[1] + o[1]) && bez.pointOnLine2D(s[0], s[1], n[0], n[1], n[0] + h[0], n[1] + h[1]) || 3 === s.length && (s[0] !== n[0] || s[1] !== n[1] || s[2] !== n[2]) && bez.pointOnLine3D(s[0], s[1], s[2], n[0], n[1], n[2], s[0] + o[0], s[1] + o[1], s[2] + o[2]) && bez.pointOnLine3D(s[0], s[1], s[2], n[0], n[1], n[2], n[0] + h[0], n[1] + h[1], n[2] + h[2])) && (e.k[a].to = null, e.k[a].ti = null), s[0] === n[0] && s[1] === n[1] && 0 === o[0] && 0 === o[1] && 0 === h[0] && 0 === h[1] && (2 === s.length || s[2] === n[2] && 0 === o[2] && 0 === h[2]) && (e.k[a].to = null, e.k[a].ti = null));
            this.effectsSequence = [
                getValueAtCurrentTime.bind(this)
            ], this.data = e, this.keyframes = e.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = r || 1, this.elem = t, this.container = i, this.comp = t.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
            var p = e.k[0].s.length;
            for(this.v = createTypedArray("float32", p), this.pv = createTypedArray("float32", p), a = 0; a < p; a += 1)this.v[a] = initFrame, this.pv[a] = initFrame;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0,
                value: createTypedArray("float32", p)
            }, this.addEffect = addEffect;
        }
        var PropertyFactory = {
            getProp: function(t, e, r, i, a) {
                var s;
                if (e.sid && (e = t.globalData.slotManager.getProp(e)), e.k.length) {
                    if ("number" == typeof e.k[0]) s = new MultiDimensionalProperty(t, e, i, a);
                    else switch(r){
                        case 0:
                            s = new KeyframedValueProperty(t, e, i, a);
                            break;
                        case 1:
                            s = new KeyframedMultidimensionalProperty(t, e, i, a);
                    }
                } else s = new ValueProperty(t, e, i, a);
                return s.effectsSequence.length && a.addDynamicProperty(s), s;
            }
        };
        function DynamicPropertyContainer() {}
        DynamicPropertyContainer.prototype = {
            addDynamicProperty: function(t) {
                -1 === this.dynamicProperties.indexOf(t) && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0);
            },
            iterateDynamicProperties: function() {
                var t;
                this._mdf = !1;
                var e = this.dynamicProperties.length;
                for(t = 0; t < e; t += 1)this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
            },
            initDynamicPropertyContainer: function(t) {
                this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
            }
        };
        var pointPool = poolFactory(8, function() {
            return createTypedArray("float32", 2);
        });
        function ShapePath() {
            this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
        }
        ShapePath.prototype.setPathData = function(t, e) {
            this.c = t, this.setLength(e);
            for(var r = 0; r < e;)this.v[r] = pointPool.newElement(), this.o[r] = pointPool.newElement(), this.i[r] = pointPool.newElement(), r += 1;
        }, ShapePath.prototype.setLength = function(t) {
            for(; this._maxLength < t;)this.doubleArrayLength();
            this._length = t;
        }, ShapePath.prototype.doubleArrayLength = function() {
            this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
        }, ShapePath.prototype.setXYAt = function(t, e, r, i, a) {
            var s;
            switch(this._length = Math.max(this._length, i + 1), this._length >= this._maxLength && this.doubleArrayLength(), r){
                case "v":
                    s = this.v;
                    break;
                case "i":
                    s = this.i;
                    break;
                case "o":
                    s = this.o;
                    break;
                default:
                    s = [];
            }
            (!s[i] || s[i] && !a) && (s[i] = pointPool.newElement()), s[i][0] = t, s[i][1] = e;
        }, ShapePath.prototype.setTripleAt = function(t, e, r, i, a, s, n, o) {
            this.setXYAt(t, e, "v", n, o), this.setXYAt(r, i, "o", n, o), this.setXYAt(a, s, "i", n, o);
        }, ShapePath.prototype.reverse = function() {
            var t = new ShapePath;
            t.setPathData(this.c, this._length);
            var e = this.v, r = this.o, i = this.i, a = 0;
            this.c && (t.setTripleAt(e[0][0], e[0][1], i[0][0], i[0][1], r[0][0], r[0][1], 0, !1), a = 1);
            var s, n = this._length - 1, o = this._length;
            for(s = a; s < o; s += 1)t.setTripleAt(e[n][0], e[n][1], i[n][0], i[n][1], r[n][0], r[n][1], s, !1), n -= 1;
            return t;
        }, ShapePath.prototype.length = function() {
            return this._length;
        };
        var shapePool = (factory = poolFactory(4, function() {
            return new ShapePath;
        }, function(t) {
            var e, r = t._length;
            for(e = 0; e < r; e += 1)pointPool.release(t.v[e]), pointPool.release(t.i[e]), pointPool.release(t.o[e]), t.v[e] = null, t.i[e] = null, t.o[e] = null;
            t._length = 0, t.c = !1;
        }), factory.clone = function(t) {
            var e, r = factory.newElement(), i = void 0 === t._length ? t.v.length : t._length;
            for(r.setLength(i), r.c = t.c, e = 0; e < i; e += 1)r.setTripleAt(t.v[e][0], t.v[e][1], t.o[e][0], t.o[e][1], t.i[e][0], t.i[e][1], e);
            return r;
        }, factory), factory;
        function ShapeCollection() {
            this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
        }
        ShapeCollection.prototype.addShape = function(t) {
            this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t, this._length += 1;
        }, ShapeCollection.prototype.releaseShapes = function() {
            var t;
            for(t = 0; t < this._length; t += 1)shapePool.release(this.shapes[t]);
            this._length = 0;
        };
        var shapeCollectionPool = (ob = {
            newShapeCollection: function() {
                return _length ? pool[_length -= 1] : new ShapeCollection;
            },
            release: function(t) {
                var e, r = t._length;
                for(e = 0; e < r; e += 1)shapePool.release(t.shapes[e]);
                t._length = 0, _length === _maxLength && (pool = pooling.double(pool), _maxLength *= 2), pool[_length] = t, _length += 1;
            }
        }, _length = 0, _maxLength = 4, pool = createSizedArray(_maxLength), ob), ob, _length, _maxLength, pool, ShapePropertyFactory = function() {
            function t(t, e, r) {
                var i, a, s, n, o, h, l, p, f, c = r.lastIndex, m = this.keyframes;
                if (t < m[0].t - this.offsetTime) i = m[0].s[0], s = !0, c = 0;
                else if (t >= m[m.length - 1].t - this.offsetTime) i = m[m.length - 1].s ? m[m.length - 1].s[0] : m[m.length - 2].e[0], s = !0;
                else {
                    for(var d, u, y, g = c, v = m.length - 1, b = !0; b && (d = m[g], !((u = m[g + 1]).t - this.offsetTime > t));)g < v - 1 ? g += 1 : b = !1;
                    if (y = this.keyframesMetadata[g] || {}, c = g, !(s = 1 === d.h)) {
                        if (t >= u.t - this.offsetTime) p = 1;
                        else if (t < d.t - this.offsetTime) p = 0;
                        else {
                            var x;
                            y.__fnct ? x = y.__fnct : (x = BezierFactory.getBezierEasing(d.o.x, d.o.y, d.i.x, d.i.y).get, y.__fnct = x), p = x((t - (d.t - this.offsetTime)) / (u.t - this.offsetTime - (d.t - this.offsetTime)));
                        }
                        a = u.s ? u.s[0] : d.e[0];
                    }
                    i = d.s[0];
                }
                for(h = e._length, l = i.i[0].length, r.lastIndex = c, n = 0; n < h; n += 1)for(o = 0; o < l; o += 1)f = s ? i.i[n][o] : i.i[n][o] + (a.i[n][o] - i.i[n][o]) * p, e.i[n][o] = f, f = s ? i.o[n][o] : i.o[n][o] + (a.o[n][o] - i.o[n][o]) * p, e.o[n][o] = f, f = s ? i.v[n][o] : i.v[n][o] + (a.v[n][o] - i.v[n][o]) * p, e.v[n][o] = f;
            }
            function e() {
                var t = this.comp.renderedFrame - this.offsetTime, e = this.keyframes[0].t - this.offsetTime, r = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, i = this._caching.lastFrame;
                return -999999 !== i && (i < e && t < e || i > r && t > r) || (this._caching.lastIndex = i < t ? this._caching.lastIndex : 0, this.interpolateShape(t, this.pv, this._caching)), this._caching.lastFrame = t, this.pv;
            }
            function r() {
                this.paths = this.localShapeCollection;
            }
            function i(t) {
                (function(t, e) {
                    if (t._length !== e._length || t.c !== e.c) return !1;
                    var r, i = t._length;
                    for(r = 0; r < i; r += 1)if (t.v[r][0] !== e.v[r][0] || t.v[r][1] !== e.v[r][1] || t.o[r][0] !== e.o[r][0] || t.o[r][1] !== e.o[r][1] || t.i[r][0] !== e.i[r][0] || t.i[r][1] !== e.i[r][1]) return !1;
                    return !0;
                })(this.v, t) || (this.v = shapePool.clone(t), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
            }
            function a() {
                if (this.elem.globalData.frameId !== this.frameId) {
                    if (this.effectsSequence.length) {
                        if (this.lock) this.setVValue(this.pv);
                        else {
                            var t, e;
                            this.lock = !0, this._mdf = !1, t = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
                            var r = this.effectsSequence.length;
                            for(e = 0; e < r; e += 1)t = this.effectsSequence[e](t);
                            this.setVValue(t), this.lock = !1, this.frameId = this.elem.globalData.frameId;
                        }
                    } else this._mdf = !1;
                }
            }
            function s(t, e, i) {
                this.propType = "shape", this.comp = t.comp, this.container = t, this.elem = t, this.data = e, this.k = !1, this.kf = !1, this._mdf = !1;
                var a = 3 === i ? e.pt.k : e.ks.k;
                this.v = shapePool.clone(a), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = r, this.effectsSequence = [];
            }
            function n(t) {
                this.effectsSequence.push(t), this.container.addDynamicProperty(this);
            }
            function o(t, i, a) {
                this.propType = "shape", this.comp = t.comp, this.elem = t, this.container = t, this.offsetTime = t.data.st, this.keyframes = 3 === a ? i.pt.k : i.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
                var s = this.keyframes[0].s[0].i.length;
                this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, s), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = -999999, this.reset = r, this._caching = {
                    lastFrame: -999999,
                    lastIndex: 0
                }, this.effectsSequence = [
                    e.bind(this)
                ];
            }
            s.prototype.interpolateShape = t, s.prototype.getValue = a, s.prototype.setVValue = i, s.prototype.addEffect = n, o.prototype.getValue = a, o.prototype.interpolateShape = t, o.prototype.setVValue = i, o.prototype.addEffect = n;
            var h = function() {
                var t = roundCorner;
                function e(t, e) {
                    this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = e.d, this.elem = t, this.comp = t.comp, this.frameId = -1, this.initDynamicPropertyContainer(t), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
                }
                return e.prototype = {
                    reset: r,
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
                    },
                    convertEllToPath: function() {
                        var e = this.p.v[0], r = this.p.v[1], i = this.s.v[0] / 2, a = this.s.v[1] / 2, s = 3 !== this.d, n = this.v;
                        n.v[0][0] = e, n.v[0][1] = r - a, n.v[1][0] = s ? e + i : e - i, n.v[1][1] = r, n.v[2][0] = e, n.v[2][1] = r + a, n.v[3][0] = s ? e - i : e + i, n.v[3][1] = r, n.i[0][0] = s ? e - i * t : e + i * t, n.i[0][1] = r - a, n.i[1][0] = s ? e + i : e - i, n.i[1][1] = r - a * t, n.i[2][0] = s ? e + i * t : e - i * t, n.i[2][1] = r + a, n.i[3][0] = s ? e - i : e + i, n.i[3][1] = r + a * t, n.o[0][0] = s ? e + i * t : e - i * t, n.o[0][1] = r - a, n.o[1][0] = s ? e + i : e - i, n.o[1][1] = r + a * t, n.o[2][0] = s ? e - i * t : e + i * t, n.o[2][1] = r + a, n.o[3][0] = s ? e - i : e + i, n.o[3][1] = r - a * t;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], e), e;
            }(), l = function() {
                function t(t, e) {
                    this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = t, this.comp = t.comp, this.data = e, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), 1 === e.sy ? (this.ir = PropertyFactory.getProp(t, e.ir, 0, 0, this), this.is = PropertyFactory.getProp(t, e.is, 0, .01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(t, e.pt, 0, 0, this), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.r = PropertyFactory.getProp(t, e.r, 0, degToRads, this), this.or = PropertyFactory.getProp(t, e.or, 0, 0, this), this.os = PropertyFactory.getProp(t, e.os, 0, .01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
                }
                return t.prototype = {
                    reset: r,
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
                    },
                    convertStarToPath: function() {
                        var t, e, r, i, a = 2 * Math.floor(this.pt.v), s = 2 * Math.PI / a, n = !0, o = this.or.v, h = this.ir.v, l = this.os.v, p = this.is.v, f = 2 * Math.PI * o / (2 * a), c = 2 * Math.PI * h / (2 * a), m = -Math.PI / 2;
                        m += this.r.v;
                        var d = 3 === this.data.d ? -1 : 1;
                        for(this.v._length = 0, t = 0; t < a; t += 1){
                            r = n ? l : p, i = n ? f : c;
                            var u = (e = n ? o : h) * Math.cos(m), y = e * Math.sin(m), g = 0 === u && 0 === y ? 0 : y / Math.sqrt(u * u + y * y), v = 0 === u && 0 === y ? 0 : -u / Math.sqrt(u * u + y * y);
                            u += +this.p.v[0], y += +this.p.v[1], this.v.setTripleAt(u, y, u - g * i * r * d, y - v * i * r * d, u + g * i * r * d, y + v * i * r * d, t, !0), n = !n, m += s * d;
                        }
                    },
                    convertPolygonToPath: function() {
                        var t, e = Math.floor(this.pt.v), r = 2 * Math.PI / e, i = this.or.v, a = this.os.v, s = 2 * Math.PI * i / (4 * e), n = .5 * -Math.PI, o = 3 === this.data.d ? -1 : 1;
                        for(n += this.r.v, this.v._length = 0, t = 0; t < e; t += 1){
                            var h = i * Math.cos(n), l = i * Math.sin(n), p = 0 === h && 0 === l ? 0 : l / Math.sqrt(h * h + l * l), f = 0 === h && 0 === l ? 0 : -h / Math.sqrt(h * h + l * l);
                            h += +this.p.v[0], l += +this.p.v[1], this.v.setTripleAt(h, l, h - p * s * a * o, l - f * s * a * o, h + p * s * a * o, l + f * s * a * o, t, !0), n += r * o;
                        }
                        this.paths.length = 0, this.paths[0] = this.v;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], t), t;
            }(), p = function() {
                function t(t, e) {
                    this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = t, this.comp = t.comp, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s, 1, 0, this), this.r = PropertyFactory.getProp(t, e.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
                }
                return t.prototype = {
                    convertRectToPath: function() {
                        var t = this.p.v[0], e = this.p.v[1], r = this.s.v[0] / 2, i = this.s.v[1] / 2, a = bmMin(r, i, this.r.v), s = a * (1 - roundCorner);
                        this.v._length = 0, 2 === this.d || 1 === this.d ? (this.v.setTripleAt(t + r, e - i + a, t + r, e - i + a, t + r, e - i + s, 0, !0), this.v.setTripleAt(t + r, e + i - a, t + r, e + i - s, t + r, e + i - a, 1, !0), 0 !== a ? (this.v.setTripleAt(t + r - a, e + i, t + r - a, e + i, t + r - s, e + i, 2, !0), this.v.setTripleAt(t - r + a, e + i, t - r + s, e + i, t - r + a, e + i, 3, !0), this.v.setTripleAt(t - r, e + i - a, t - r, e + i - a, t - r, e + i - s, 4, !0), this.v.setTripleAt(t - r, e - i + a, t - r, e - i + s, t - r, e - i + a, 5, !0), this.v.setTripleAt(t - r + a, e - i, t - r + a, e - i, t - r + s, e - i, 6, !0), this.v.setTripleAt(t + r - a, e - i, t + r - s, e - i, t + r - a, e - i, 7, !0)) : (this.v.setTripleAt(t - r, e + i, t - r + s, e + i, t - r, e + i, 2), this.v.setTripleAt(t - r, e - i, t - r, e - i + s, t - r, e - i, 3))) : (this.v.setTripleAt(t + r, e - i + a, t + r, e - i + s, t + r, e - i + a, 0, !0), 0 !== a ? (this.v.setTripleAt(t + r - a, e - i, t + r - a, e - i, t + r - s, e - i, 1, !0), this.v.setTripleAt(t - r + a, e - i, t - r + s, e - i, t - r + a, e - i, 2, !0), this.v.setTripleAt(t - r, e - i + a, t - r, e - i + a, t - r, e - i + s, 3, !0), this.v.setTripleAt(t - r, e + i - a, t - r, e + i - s, t - r, e + i - a, 4, !0), this.v.setTripleAt(t - r + a, e + i, t - r + a, e + i, t - r + s, e + i, 5, !0), this.v.setTripleAt(t + r - a, e + i, t + r - s, e + i, t + r - a, e + i, 6, !0), this.v.setTripleAt(t + r, e + i - a, t + r, e + i - a, t + r, e + i - s, 7, !0)) : (this.v.setTripleAt(t - r, e - i, t - r + s, e - i, t - r, e - i, 1, !0), this.v.setTripleAt(t - r, e + i, t - r, e + i - s, t - r, e + i, 2, !0), this.v.setTripleAt(t + r, e + i, t + r - s, e + i, t + r, e + i, 3, !0)));
                    },
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
                    },
                    reset: r
                }, extendPrototype([
                    DynamicPropertyContainer
                ], t), t;
            }();
            var f = {
                getShapeProp: function(t, e, r) {
                    var i;
                    return 3 === r || 4 === r ? i = (3 === r ? e.pt : e.ks).k.length ? new o(t, e, r) : new s(t, e, r) : 5 === r ? i = new p(t, e) : 6 === r ? i = new h(t, e) : 7 === r && (i = new l(t, e)), i.k && t.addDynamicProperty(i), i;
                },
                getConstructorFunction: function() {
                    return s;
                },
                getKeyframedConstructorFunction: function() {
                    return o;
                }
            };
            return f;
        }(), Matrix = function() {
            var t = Math.cos, e = Math.sin, r = Math.tan, i = Math.round;
            function a() {
                return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
            }
            function s(r) {
                if (0 === r) return this;
                var i = t(r), a = e(r);
                return this._t(i, -a, 0, 0, a, i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function n(r) {
                if (0 === r) return this;
                var i = t(r), a = e(r);
                return this._t(1, 0, 0, 0, 0, i, -a, 0, 0, a, i, 0, 0, 0, 0, 1);
            }
            function o(r) {
                if (0 === r) return this;
                var i = t(r), a = e(r);
                return this._t(i, 0, a, 0, 0, 1, 0, 0, -a, 0, i, 0, 0, 0, 0, 1);
            }
            function h(r) {
                if (0 === r) return this;
                var i = t(r), a = e(r);
                return this._t(i, -a, 0, 0, a, i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function l(t, e) {
                return this._t(1, e, t, 1, 0, 0);
            }
            function p(t, e) {
                return this.shear(r(t), r(e));
            }
            function f(i, a) {
                var s = t(a), n = e(a);
                return this._t(s, n, 0, 0, -n, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, r(i), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(s, -n, 0, 0, n, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function c(t, e, r) {
                return r || 0 === r || (r = 1), 1 === t && 1 === e && 1 === r ? this : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, r, 0, 0, 0, 0, 1);
            }
            function m(t, e, r, i, a, s, n, o, h, l, p, f, c, m, d, u) {
                return this.props[0] = t, this.props[1] = e, this.props[2] = r, this.props[3] = i, this.props[4] = a, this.props[5] = s, this.props[6] = n, this.props[7] = o, this.props[8] = h, this.props[9] = l, this.props[10] = p, this.props[11] = f, this.props[12] = c, this.props[13] = m, this.props[14] = d, this.props[15] = u, this;
            }
            function d(t, e, r) {
                return r = r || 0, 0 !== t || 0 !== e || 0 !== r ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, r, 1) : this;
            }
            function u(t, e, r, i, a, s, n, o, h, l, p, f, c, m, d, u) {
                var y = this.props;
                if (1 === t && 0 === e && 0 === r && 0 === i && 0 === a && 1 === s && 0 === n && 0 === o && 0 === h && 0 === l && 1 === p && 0 === f) return y[12] = y[12] * t + y[15] * c, y[13] = y[13] * s + y[15] * m, y[14] = y[14] * p + y[15] * d, y[15] *= u, this._identityCalculated = !1, this;
                var g = y[0], v = y[1], b = y[2], x = y[3], E = y[4], S = y[5], P = y[6], C = y[7], _ = y[8], k = y[9], A = y[10], T = y[11], M = y[12], w = y[13], D = y[14], F = y[15];
                return y[0] = g * t + v * a + b * h + x * c, y[1] = g * e + v * s + b * l + x * m, y[2] = g * r + v * n + b * p + x * d, y[3] = g * i + v * o + b * f + x * u, y[4] = E * t + S * a + P * h + C * c, y[5] = E * e + S * s + P * l + C * m, y[6] = E * r + S * n + P * p + C * d, y[7] = E * i + S * o + P * f + C * u, y[8] = _ * t + k * a + A * h + T * c, y[9] = _ * e + k * s + A * l + T * m, y[10] = _ * r + k * n + A * p + T * d, y[11] = _ * i + k * o + A * f + T * u, y[12] = M * t + w * a + D * h + F * c, y[13] = M * e + w * s + D * l + F * m, y[14] = M * r + w * n + D * p + F * d, y[15] = M * i + w * o + D * f + F * u, this._identityCalculated = !1, this;
            }
            function y(t) {
                var e = t.props;
                return this.transform(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]);
            }
            function g() {
                return this._identityCalculated || (this._identity = !(1 !== this.props[0] || 0 !== this.props[1] || 0 !== this.props[2] || 0 !== this.props[3] || 0 !== this.props[4] || 1 !== this.props[5] || 0 !== this.props[6] || 0 !== this.props[7] || 0 !== this.props[8] || 0 !== this.props[9] || 1 !== this.props[10] || 0 !== this.props[11] || 0 !== this.props[12] || 0 !== this.props[13] || 0 !== this.props[14] || 1 !== this.props[15]), this._identityCalculated = !0), this._identity;
            }
            function v(t) {
                for(var e = 0; e < 16;){
                    if (t.props[e] !== this.props[e]) return !1;
                    e += 1;
                }
                return !0;
            }
            function b(t) {
                var e;
                for(e = 0; e < 16; e += 1)t.props[e] = this.props[e];
                return t;
            }
            function x(t) {
                var e;
                for(e = 0; e < 16; e += 1)this.props[e] = t[e];
            }
            function E(t, e, r) {
                return {
                    x: t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12],
                    y: t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13],
                    z: t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14]
                };
            }
            function S(t, e, r) {
                return t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12];
            }
            function P(t, e, r) {
                return t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13];
            }
            function C(t, e, r) {
                return t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14];
            }
            function _() {
                var t = this.props[0] * this.props[5] - this.props[1] * this.props[4], e = this.props[5] / t, r = -this.props[1] / t, i = -this.props[4] / t, a = this.props[0] / t, s = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t, n = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t, o = new Matrix;
                return o.props[0] = e, o.props[1] = r, o.props[4] = i, o.props[5] = a, o.props[12] = s, o.props[13] = n, o;
            }
            function k(t) {
                return this.getInverseMatrix().applyToPointArray(t[0], t[1], t[2] || 0);
            }
            function A(t) {
                var e, r = t.length, i = [];
                for(e = 0; e < r; e += 1)i[e] = k(t[e]);
                return i;
            }
            function T(t, e, r) {
                var i = createTypedArray("float32", 6);
                if (this.isIdentity()) i[0] = t[0], i[1] = t[1], i[2] = e[0], i[3] = e[1], i[4] = r[0], i[5] = r[1];
                else {
                    var a = this.props[0], s = this.props[1], n = this.props[4], o = this.props[5], h = this.props[12], l = this.props[13];
                    i[0] = t[0] * a + t[1] * n + h, i[1] = t[0] * s + t[1] * o + l, i[2] = e[0] * a + e[1] * n + h, i[3] = e[0] * s + e[1] * o + l, i[4] = r[0] * a + r[1] * n + h, i[5] = r[0] * s + r[1] * o + l;
                }
                return i;
            }
            function M(t, e, r) {
                return this.isIdentity() ? [
                    t,
                    e,
                    r
                ] : [
                    t * this.props[0] + e * this.props[4] + r * this.props[8] + this.props[12],
                    t * this.props[1] + e * this.props[5] + r * this.props[9] + this.props[13],
                    t * this.props[2] + e * this.props[6] + r * this.props[10] + this.props[14]
                ];
            }
            function w(t, e) {
                if (this.isIdentity()) return t + "," + e;
                var r = this.props;
                return Math.round(100 * (t * r[0] + e * r[4] + r[12])) / 100 + "," + Math.round(100 * (t * r[1] + e * r[5] + r[13])) / 100;
            }
            function D() {
                for(var t = 0, e = this.props, r = "matrix3d("; t < 16;)r += i(1e4 * e[t]) / 1e4, r += 15 === t ? ")" : ",", t += 1;
                return r;
            }
            function F(t) {
                return t < 1e-6 && t > 0 || t > -0.000001 && t < 0 ? i(1e4 * t) / 1e4 : t;
            }
            function I() {
                var t = this.props;
                return "matrix(" + F(t[0]) + "," + F(t[1]) + "," + F(t[4]) + "," + F(t[5]) + "," + F(t[12]) + "," + F(t[13]) + ")";
            }
            return function() {
                this.reset = a, this.rotate = s, this.rotateX = n, this.rotateY = o, this.rotateZ = h, this.skew = p, this.skewFromAxis = f, this.shear = l, this.scale = c, this.setTransform = m, this.translate = d, this.transform = u, this.multiply = y, this.applyToPoint = E, this.applyToX = S, this.applyToY = P, this.applyToZ = C, this.applyToPointArray = M, this.applyToTriplePoints = T, this.applyToPointStringified = w, this.toCSS = D, this.to2dCSS = I, this.clone = b, this.cloneFromProps = x, this.equals = v, this.inversePoints = A, this.inversePoint = k, this.getInverseMatrix = _, this._t = this.transform, this.isIdentity = g, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
            };
        }();
        function _typeof$3(t) {
            return (_typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var lottie = {}, standalone = "__[STANDALONE]__", animationData = "__[ANIMATIONDATA]__", renderer = "";
        function setLocation(t) {
            setLocationHref(t);
        }
        function searchAnimations() {
            !0 === standalone ? animationManager.searchAnimations(animationData, standalone, renderer) : animationManager.searchAnimations();
        }
        function setSubframeRendering(t) {
            setSubframeEnabled(t);
        }
        function setPrefix(t) {
            setIdPrefix(t);
        }
        function loadAnimation(t) {
            return !0 === standalone && (t.animationData = JSON.parse(animationData)), animationManager.loadAnimation(t);
        }
        function setQuality(t) {
            if ("string" == typeof t) switch(t){
                case "high":
                    setDefaultCurveSegments(200);
                    break;
                default:
                case "medium":
                    setDefaultCurveSegments(50);
                    break;
                case "low":
                    setDefaultCurveSegments(10);
            }
            else !isNaN(t) && t > 1 && setDefaultCurveSegments(t);
            getDefaultCurveSegments() >= 50 ? roundValues(!1) : roundValues(!0);
        }
        function inBrowser() {
            return "undefined" != typeof navigator;
        }
        function installPlugin(t, e) {
            "expressions" === t && setExpressionsPlugin(e);
        }
        function getFactory(t) {
            switch(t){
                case "propertyFactory":
                    return PropertyFactory;
                case "shapePropertyFactory":
                    return ShapePropertyFactory;
                case "matrix":
                    return Matrix;
                default:
                    return null;
            }
        }
        function checkReady() {
            "complete" === document.readyState && (clearInterval(readyStateCheckInterval), searchAnimations());
        }
        function getQueryVariable(t) {
            for(var e = queryString.split("&"), r = 0; r < e.length; r += 1){
                var i = e[r].split("=");
                if (decodeURIComponent(i[0]) == t) return decodeURIComponent(i[1]);
            }
            return null;
        }
        lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.12.2";
        var queryString = "";
        if (standalone) {
            var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
                src: ""
            };
            queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", renderer = getQueryVariable("renderer");
        }
        var readyStateCheckInterval = setInterval(checkReady, 100);
        try {
            "object" !== _typeof$3(exports) && (window.bodymovin = lottie);
        } catch (t) {}
        var ShapeModifiers = function() {
            var t = {}, e = {};
            return t.registerModifier = function(t, r) {
                e[t] || (e[t] = r);
            }, t.getModifier = function(t, r, i) {
                return new e[t](r, i);
            }, t;
        }();
        function ShapeModifier() {}
        function TrimModifier() {}
        function PuckerAndBloatModifier() {}
        ShapeModifier.prototype.initModifierProperties = function() {}, ShapeModifier.prototype.addShapeToModifier = function() {}, ShapeModifier.prototype.addShape = function(t) {
            if (!this.closed) {
                t.sh.container.addDynamicProperty(t.sh);
                var e = {
                    shape: t.sh,
                    data: t,
                    localShapeCollection: shapeCollectionPool.newShapeCollection()
                };
                this.shapes.push(e), this.addShapeToModifier(e), this._isAnimated && t.setAsAnimated();
            }
        }, ShapeModifier.prototype.init = function(t, e) {
            this.shapes = [], this.elem = t, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
        }, ShapeModifier.prototype.processKeys = function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
        }, extendPrototype([
            DynamicPropertyContainer
        ], ShapeModifier), extendPrototype([
            ShapeModifier
        ], TrimModifier), TrimModifier.prototype.initModifierProperties = function(t, e) {
            this.s = PropertyFactory.getProp(t, e.s, 0, .01, this), this.e = PropertyFactory.getProp(t, e.e, 0, .01, this), this.o = PropertyFactory.getProp(t, e.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = e.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
        }, TrimModifier.prototype.addShapeToModifier = function(t) {
            t.pathsData = [];
        }, TrimModifier.prototype.calculateShapeEdges = function(t, e, r, i, a) {
            var s = [];
            e <= 1 ? s.push({
                s: t,
                e: e
            }) : t >= 1 ? s.push({
                s: t - 1,
                e: e - 1
            }) : (s.push({
                s: t,
                e: 1
            }), s.push({
                s: 0,
                e: e - 1
            }));
            var n, o, h = [], l = s.length;
            for(n = 0; n < l; n += 1){
                var p, f;
                if (!((o = s[n]).e * a < i || o.s * a > i + r)) p = o.s * a <= i ? 0 : (o.s * a - i) / r, f = o.e * a >= i + r ? 1 : (o.e * a - i) / r, h.push([
                    p,
                    f
                ]);
            }
            return h.length || h.push([
                0,
                0
            ]), h;
        }, TrimModifier.prototype.releasePathsData = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)segmentsLengthPool.release(t[e]);
            return t.length = 0, t;
        }, TrimModifier.prototype.processShapes = function(t) {
            var e, r, i, a;
            if (this._mdf || t) {
                var s = this.o.v % 360 / 360;
                if (s < 0 && (s += 1), (e = this.s.v > 1 ? 1 + s : this.s.v < 0 ? 0 + s : this.s.v + s) > (r = this.e.v > 1 ? 1 + s : this.e.v < 0 ? 0 + s : this.e.v + s)) {
                    var n = e;
                    e = r, r = n;
                }
                e = 1e-4 * Math.round(1e4 * e), r = 1e-4 * Math.round(1e4 * r), this.sValue = e, this.eValue = r;
            } else e = this.sValue, r = this.eValue;
            var o, h, l, p, f, c = this.shapes.length, m = 0;
            if (r === e) for(a = 0; a < c; a += 1)this.shapes[a].localShapeCollection.releaseShapes(), this.shapes[a].shape._mdf = !0, this.shapes[a].shape.paths = this.shapes[a].localShapeCollection, this._mdf && (this.shapes[a].pathsData.length = 0);
            else if (1 === r && 0 === e || 0 === r && 1 === e) {
                if (this._mdf) for(a = 0; a < c; a += 1)this.shapes[a].pathsData.length = 0, this.shapes[a].shape._mdf = !0;
            } else {
                var d, u, y = [];
                for(a = 0; a < c; a += 1)if ((d = this.shapes[a]).shape._mdf || this._mdf || t || 2 === this.m) {
                    if (h = (i = d.shape.paths)._length, f = 0, !d.shape._mdf && d.pathsData.length) f = d.totalShapeLength;
                    else {
                        for(l = this.releasePathsData(d.pathsData), o = 0; o < h; o += 1)p = bez.getSegmentsLength(i.shapes[o]), l.push(p), f += p.totalLength;
                        d.totalShapeLength = f, d.pathsData = l;
                    }
                    m += f, d.shape._mdf = !0;
                } else d.shape.paths = d.localShapeCollection;
                var g, v = e, b = r, x = 0;
                for(a = c - 1; a >= 0; a -= 1)if ((d = this.shapes[a]).shape._mdf) {
                    for((u = d.localShapeCollection).releaseShapes(), 2 === this.m && c > 1 ? (g = this.calculateShapeEdges(e, r, d.totalShapeLength, x, m), x += d.totalShapeLength) : g = [
                        [
                            v,
                            b
                        ]
                    ], h = g.length, o = 0; o < h; o += 1){
                        v = g[o][0], b = g[o][1], y.length = 0, b <= 1 ? y.push({
                            s: d.totalShapeLength * v,
                            e: d.totalShapeLength * b
                        }) : v >= 1 ? y.push({
                            s: d.totalShapeLength * (v - 1),
                            e: d.totalShapeLength * (b - 1)
                        }) : (y.push({
                            s: d.totalShapeLength * v,
                            e: d.totalShapeLength
                        }), y.push({
                            s: 0,
                            e: d.totalShapeLength * (b - 1)
                        }));
                        var E = this.addShapes(d, y[0]);
                        if (y[0].s !== y[0].e) {
                            if (y.length > 1) {
                                if (d.shape.paths.shapes[d.shape.paths._length - 1].c) {
                                    var S = E.pop();
                                    this.addPaths(E, u), E = this.addShapes(d, y[1], S);
                                } else this.addPaths(E, u), E = this.addShapes(d, y[1]);
                            }
                            this.addPaths(E, u);
                        }
                    }
                    d.shape.paths = u;
                }
            }
        }, TrimModifier.prototype.addPaths = function(t, e) {
            var r, i = t.length;
            for(r = 0; r < i; r += 1)e.addShape(t[r]);
        }, TrimModifier.prototype.addSegment = function(t, e, r, i, a, s, n) {
            a.setXYAt(e[0], e[1], "o", s), a.setXYAt(r[0], r[1], "i", s + 1), n && a.setXYAt(t[0], t[1], "v", s), a.setXYAt(i[0], i[1], "v", s + 1);
        }, TrimModifier.prototype.addSegmentFromArray = function(t, e, r, i) {
            e.setXYAt(t[1], t[5], "o", r), e.setXYAt(t[2], t[6], "i", r + 1), i && e.setXYAt(t[0], t[4], "v", r), e.setXYAt(t[3], t[7], "v", r + 1);
        }, TrimModifier.prototype.addShapes = function(t, e, r) {
            var i, a, s, n, o, h, l, p, f = t.pathsData, c = t.shape.paths.shapes, m = t.shape.paths._length, d = 0, u = [], y = !0;
            for(r ? (o = r._length, p = r._length) : (r = shapePool.newElement(), o = 0, p = 0), u.push(r), i = 0; i < m; i += 1){
                for(h = f[i].lengths, r.c = c[i].c, s = c[i].c ? h.length : h.length + 1, a = 1; a < s; a += 1)if (d + (n = h[a - 1]).addedLength < e.s) d += n.addedLength, r.c = !1;
                else {
                    if (d > e.e) {
                        r.c = !1;
                        break;
                    }
                    e.s <= d && e.e >= d + n.addedLength ? (this.addSegment(c[i].v[a - 1], c[i].o[a - 1], c[i].i[a], c[i].v[a], r, o, y), y = !1) : (l = bez.getNewSegment(c[i].v[a - 1], c[i].v[a], c[i].o[a - 1], c[i].i[a], (e.s - d) / n.addedLength, (e.e - d) / n.addedLength, h[a - 1]), this.addSegmentFromArray(l, r, o, y), y = !1, r.c = !1), d += n.addedLength, o += 1;
                }
                if (c[i].c && h.length) {
                    if (n = h[a - 1], d <= e.e) {
                        var g = h[a - 1].addedLength;
                        e.s <= d && e.e >= d + g ? (this.addSegment(c[i].v[a - 1], c[i].o[a - 1], c[i].i[0], c[i].v[0], r, o, y), y = !1) : (l = bez.getNewSegment(c[i].v[a - 1], c[i].v[0], c[i].o[a - 1], c[i].i[0], (e.s - d) / g, (e.e - d) / g, h[a - 1]), this.addSegmentFromArray(l, r, o, y), y = !1, r.c = !1);
                    } else r.c = !1;
                    d += n.addedLength, o += 1;
                }
                if (r._length && (r.setXYAt(r.v[p][0], r.v[p][1], "i", p), r.setXYAt(r.v[r._length - 1][0], r.v[r._length - 1][1], "o", r._length - 1)), d > e.e) break;
                i < m - 1 && (r = shapePool.newElement(), y = !0, u.push(r), o = 0);
            }
            return u;
        }, extendPrototype([
            ShapeModifier
        ], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, e.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
        }, PuckerAndBloatModifier.prototype.processPath = function(t, e) {
            var r = e / 100, i = [
                0,
                0
            ], a = t._length, s = 0;
            for(s = 0; s < a; s += 1)i[0] += t.v[s][0], i[1] += t.v[s][1];
            i[0] /= a, i[1] /= a;
            var n, o, h, l, p, f, c = shapePool.newElement();
            for(c.c = t.c, s = 0; s < a; s += 1)n = t.v[s][0] + (i[0] - t.v[s][0]) * r, o = t.v[s][1] + (i[1] - t.v[s][1]) * r, h = t.o[s][0] + (i[0] - t.o[s][0]) * -r, l = t.o[s][1] + (i[1] - t.o[s][1]) * -r, p = t.i[s][0] + (i[0] - t.i[s][0]) * -r, f = t.i[s][1] + (i[1] - t.i[s][1]) * -r, c.setTripleAt(n, o, h, l, p, f, s);
            return c;
        }, PuckerAndBloatModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n, o = this.shapes.length, h = this.amount.v;
            if (0 !== h) for(r = 0; r < o; r += 1){
                if (n = (s = this.shapes[r]).localShapeCollection, s.shape._mdf || this._mdf || t) for(n.releaseShapes(), s.shape._mdf = !0, e = s.shape.paths.shapes, a = s.shape.paths._length, i = 0; i < a; i += 1)n.addShape(this.processPath(e[i], h));
                s.shape.paths = s.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        };
        var TransformPropertyFactory = function() {
            var t = [
                0,
                0
            ];
            function e(t, e, r) {
                if (this.elem = t, this.frameId = -1, this.propType = "transform", this.data = e, this.v = new Matrix, this.pre = new Matrix, this.appliedTransformations = 0, this.initDynamicPropertyContainer(r || t), e.p && e.p.s ? (this.px = PropertyFactory.getProp(t, e.p.x, 0, 0, this), this.py = PropertyFactory.getProp(t, e.p.y, 0, 0, this), e.p.z && (this.pz = PropertyFactory.getProp(t, e.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(t, e.p || {
                    k: [
                        0,
                        0,
                        0
                    ]
                }, 1, 0, this), e.rx) {
                    if (this.rx = PropertyFactory.getProp(t, e.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(t, e.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(t, e.rz, 0, degToRads, this), e.or.k[0].ti) {
                        var i, a = e.or.k.length;
                        for(i = 0; i < a; i += 1)e.or.k[i].to = null, e.or.k[i].ti = null;
                    }
                    this.or = PropertyFactory.getProp(t, e.or, 1, degToRads, this), this.or.sh = !0;
                } else this.r = PropertyFactory.getProp(t, e.r || {
                    k: 0
                }, 0, degToRads, this);
                e.sk && (this.sk = PropertyFactory.getProp(t, e.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(t, e.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(t, e.a || {
                    k: [
                        0,
                        0,
                        0
                    ]
                }, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s || {
                    k: [
                        100,
                        100,
                        100
                    ]
                }, 1, .01, this), e.o ? this.o = PropertyFactory.getProp(t, e.o, 0, .01, t) : this.o = {
                    _mdf: !1,
                    v: 1
                }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
            }
            return e.prototype = {
                applyToMatrix: function(t) {
                    var e = this._mdf;
                    this.iterateDynamicProperties(), this._mdf = this._mdf || e, this.a && t.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && t.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && t.skewFromAxis(-this.sk.v, this.sa.v), this.r ? t.rotate(-this.r.v) : t.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? t.translate(this.px.v, this.py.v, -this.pz.v) : t.translate(this.px.v, this.py.v, 0) : t.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                },
                getValue: function(e) {
                    if (this.elem.globalData.frameId !== this.frameId) {
                        if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || e) {
                            var r;
                            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
                                var i, a;
                                if (r = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime) this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (i = this.p.getValueAtTime((this.p.keyframes[0].t + .01) / r, 0), a = this.p.getValueAtTime(this.p.keyframes[0].t / r, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (i = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / r, 0), a = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - .05) / r, 0)) : (i = this.p.pv, a = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - .01) / r, this.p.offsetTime));
                                else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                                    i = [], a = [];
                                    var s = this.px, n = this.py;
                                    s._caching.lastFrame + s.offsetTime <= s.keyframes[0].t ? (i[0] = s.getValueAtTime((s.keyframes[0].t + .01) / r, 0), i[1] = n.getValueAtTime((n.keyframes[0].t + .01) / r, 0), a[0] = s.getValueAtTime(s.keyframes[0].t / r, 0), a[1] = n.getValueAtTime(n.keyframes[0].t / r, 0)) : s._caching.lastFrame + s.offsetTime >= s.keyframes[s.keyframes.length - 1].t ? (i[0] = s.getValueAtTime(s.keyframes[s.keyframes.length - 1].t / r, 0), i[1] = n.getValueAtTime(n.keyframes[n.keyframes.length - 1].t / r, 0), a[0] = s.getValueAtTime((s.keyframes[s.keyframes.length - 1].t - .01) / r, 0), a[1] = n.getValueAtTime((n.keyframes[n.keyframes.length - 1].t - .01) / r, 0)) : (i = [
                                        s.pv,
                                        n.pv
                                    ], a[0] = s.getValueAtTime((s._caching.lastFrame + s.offsetTime - .01) / r, s.offsetTime), a[1] = n.getValueAtTime((n._caching.lastFrame + n.offsetTime - .01) / r, n.offsetTime));
                                } else i = a = t;
                                this.v.rotate(-Math.atan2(i[1] - a[1], i[0] - a[0]));
                            }
                            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                        }
                        this.frameId = this.elem.globalData.frameId;
                    }
                },
                precalculateMatrix: function() {
                    if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1, !this.s.effectsSequence.length)) {
                        if (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2, this.sk) {
                            if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
                            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
                        }
                        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : this.rz.effectsSequence.length || this.ry.effectsSequence.length || this.rx.effectsSequence.length || this.or.effectsSequence.length || (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
                    }
                },
                autoOrient: function() {}
            }, extendPrototype([
                DynamicPropertyContainer
            ], e), e.prototype.addDynamicProperty = function(t) {
                this._addDynamicProperty(t), this.elem.addDynamicProperty(t), this._isDirty = !0;
            }, e.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty, {
                getTransformProperty: function(t, r, i) {
                    return new e(t, r, i);
                }
            };
        }();
        function RepeaterModifier() {}
        function RoundCornersModifier() {}
        function floatEqual(t, e) {
            return 1e5 * Math.abs(t - e) <= Math.min(Math.abs(t), Math.abs(e));
        }
        function floatZero(t) {
            return Math.abs(t) <= 1e-5;
        }
        function lerp(t, e, r) {
            return t * (1 - r) + e * r;
        }
        function lerpPoint(t, e, r) {
            return [
                lerp(t[0], e[0], r),
                lerp(t[1], e[1], r)
            ];
        }
        function quadRoots(t, e, r) {
            if (0 === t) return [];
            var i = e * e - 4 * t * r;
            if (i < 0) return [];
            var a = -e / (2 * t);
            if (0 === i) return [
                a
            ];
            var s = Math.sqrt(i) / (2 * t);
            return [
                a - s,
                a + s
            ];
        }
        function polynomialCoefficients(t, e, r, i) {
            return [
                3 * e - t - 3 * r + i,
                3 * t - 6 * e + 3 * r,
                -3 * t + 3 * e,
                t
            ];
        }
        function singlePoint(t) {
            return new PolynomialBezier(t, t, t, t, !1);
        }
        function PolynomialBezier(t, e, r, i, a) {
            a && pointEqual(t, e) && (e = lerpPoint(t, i, 1 / 3)), a && pointEqual(r, i) && (r = lerpPoint(t, i, 2 / 3));
            var s = polynomialCoefficients(t[0], e[0], r[0], i[0]), n = polynomialCoefficients(t[1], e[1], r[1], i[1]);
            this.a = [
                s[0],
                n[0]
            ], this.b = [
                s[1],
                n[1]
            ], this.c = [
                s[2],
                n[2]
            ], this.d = [
                s[3],
                n[3]
            ], this.points = [
                t,
                e,
                r,
                i
            ];
        }
        function extrema(t, e) {
            var r = t.points[0][e], i = t.points[t.points.length - 1][e];
            if (r > i) {
                var a = i;
                i = r, r = a;
            }
            for(var s = quadRoots(3 * t.a[e], 2 * t.b[e], t.c[e]), n = 0; n < s.length; n += 1)if (s[n] > 0 && s[n] < 1) {
                var o = t.point(s[n])[e];
                o < r ? r = o : o > i && (i = o);
            }
            return {
                min: r,
                max: i
            };
        }
        function intersectData(t, e, r) {
            var i = t.boundingBox();
            return {
                cx: i.cx,
                cy: i.cy,
                width: i.width,
                height: i.height,
                bez: t,
                t: (e + r) / 2,
                t1: e,
                t2: r
            };
        }
        function splitData(t) {
            var e = t.bez.split(.5);
            return [
                intersectData(e[0], t.t1, t.t),
                intersectData(e[1], t.t, t.t2)
            ];
        }
        function boxIntersect(t, e) {
            return 2 * Math.abs(t.cx - e.cx) < t.width + e.width && 2 * Math.abs(t.cy - e.cy) < t.height + e.height;
        }
        function intersectsImpl(t, e, r, i, a, s) {
            if (boxIntersect(t, e)) {
                if (r >= s || t.width <= i && t.height <= i && e.width <= i && e.height <= i) a.push([
                    t.t,
                    e.t
                ]);
                else {
                    var n = splitData(t), o = splitData(e);
                    intersectsImpl(n[0], o[0], r + 1, i, a, s), intersectsImpl(n[0], o[1], r + 1, i, a, s), intersectsImpl(n[1], o[0], r + 1, i, a, s), intersectsImpl(n[1], o[1], r + 1, i, a, s);
                }
            }
        }
        function crossProduct(t, e) {
            return [
                t[1] * e[2] - t[2] * e[1],
                t[2] * e[0] - t[0] * e[2],
                t[0] * e[1] - t[1] * e[0]
            ];
        }
        function lineIntersection(t, e, r, i) {
            var a = [
                t[0],
                t[1],
                1
            ], s = [
                e[0],
                e[1],
                1
            ], n = [
                r[0],
                r[1],
                1
            ], o = [
                i[0],
                i[1],
                1
            ], h = crossProduct(crossProduct(a, s), crossProduct(n, o));
            return floatZero(h[2]) ? null : [
                h[0] / h[2],
                h[1] / h[2]
            ];
        }
        function polarOffset(t, e, r) {
            return [
                t[0] + Math.cos(e) * r,
                t[1] - Math.sin(e) * r
            ];
        }
        function pointDistance(t, e) {
            return Math.hypot(t[0] - e[0], t[1] - e[1]);
        }
        function pointEqual(t, e) {
            return floatEqual(t[0], e[0]) && floatEqual(t[1], e[1]);
        }
        function ZigZagModifier() {}
        function setPoint(t, e, r, i, a, s, n) {
            var o = r - Math.PI / 2, h = r + Math.PI / 2, l = e[0] + Math.cos(r) * i * a, p = e[1] - Math.sin(r) * i * a;
            t.setTripleAt(l, p, l + Math.cos(o) * s, p - Math.sin(o) * s, l + Math.cos(h) * n, p - Math.sin(h) * n, t.length());
        }
        function getPerpendicularVector(t, e) {
            var r = [
                e[0] - t[0],
                e[1] - t[1]
            ], i = .5 * -Math.PI;
            return [
                Math.cos(i) * r[0] - Math.sin(i) * r[1],
                Math.sin(i) * r[0] + Math.cos(i) * r[1]
            ];
        }
        function getProjectingAngle(t, e) {
            var r = 0 === e ? t.length() - 1 : e - 1, i = (e + 1) % t.length(), a = getPerpendicularVector(t.v[r], t.v[i]);
            return Math.atan2(0, 1) - Math.atan2(a[1], a[0]);
        }
        function zigZagCorner(t, e, r, i, a, s, n) {
            var o = getProjectingAngle(e, r), h = e.v[r % e._length], l = e.v[0 === r ? e._length - 1 : r - 1], p = e.v[(r + 1) % e._length], f = 2 === s ? Math.sqrt(Math.pow(h[0] - l[0], 2) + Math.pow(h[1] - l[1], 2)) : 0, c = 2 === s ? Math.sqrt(Math.pow(h[0] - p[0], 2) + Math.pow(h[1] - p[1], 2)) : 0;
            setPoint(t, e.v[r % e._length], o, n, i, c / (2 * (a + 1)), f / (2 * (a + 1)), s);
        }
        function zigZagSegment(t, e, r, i, a, s) {
            for(var n = 0; n < i; n += 1){
                var o = (n + 1) / (i + 1), h = 2 === a ? Math.sqrt(Math.pow(e.points[3][0] - e.points[0][0], 2) + Math.pow(e.points[3][1] - e.points[0][1], 2)) : 0, l = e.normalAngle(o);
                setPoint(t, e.point(o), l, s, r, h / (2 * (i + 1)), h / (2 * (i + 1)), a), s = -s;
            }
            return s;
        }
        function linearOffset(t, e, r) {
            var i = Math.atan2(e[0] - t[0], e[1] - t[1]);
            return [
                polarOffset(t, i, r),
                polarOffset(e, i, r)
            ];
        }
        function offsetSegment(t, e) {
            var r, i, a, s, n, o, h;
            r = (h = linearOffset(t.points[0], t.points[1], e))[0], i = h[1], a = (h = linearOffset(t.points[1], t.points[2], e))[0], s = h[1], n = (h = linearOffset(t.points[2], t.points[3], e))[0], o = h[1];
            var l = lineIntersection(r, i, a, s);
            null === l && (l = i);
            var p = lineIntersection(n, o, a, s);
            return null === p && (p = n), new PolynomialBezier(r, l, p, o);
        }
        function joinLines(t, e, r, i, a) {
            var s = e.points[3], n = r.points[0];
            if (3 === i) return s;
            if (pointEqual(s, n)) return s;
            if (2 === i) {
                var o = -e.tangentAngle(1), h = -r.tangentAngle(0) + Math.PI, l = lineIntersection(s, polarOffset(s, o + Math.PI / 2, 100), n, polarOffset(n, o + Math.PI / 2, 100)), p = l ? pointDistance(l, s) : pointDistance(s, n) / 2, f = polarOffset(s, o, 2 * p * roundCorner);
                return t.setXYAt(f[0], f[1], "o", t.length() - 1), f = polarOffset(n, h, 2 * p * roundCorner), t.setTripleAt(n[0], n[1], n[0], n[1], f[0], f[1], t.length()), n;
            }
            var c = lineIntersection(pointEqual(s, e.points[2]) ? e.points[0] : e.points[2], s, n, pointEqual(n, r.points[1]) ? r.points[3] : r.points[1]);
            return c && pointDistance(c, s) < a ? (t.setTripleAt(c[0], c[1], c[0], c[1], c[0], c[1], t.length()), c) : s;
        }
        function getIntersection(t, e) {
            var r = t.intersections(e);
            return r.length && floatEqual(r[0][0], 1) && r.shift(), r.length ? r[0] : null;
        }
        function pruneSegmentIntersection(t, e) {
            var r = t.slice(), i = e.slice(), a = getIntersection(t[t.length - 1], e[0]);
            return a && (r[t.length - 1] = t[t.length - 1].split(a[0])[0], i[0] = e[0].split(a[1])[1]), t.length > 1 && e.length > 1 && (a = getIntersection(t[0], e[e.length - 1])) ? [
                [
                    t[0].split(a[0])[0]
                ],
                [
                    e[e.length - 1].split(a[1])[1]
                ]
            ] : [
                r,
                i
            ];
        }
        function pruneIntersections(t) {
            for(var e, r = 1; r < t.length; r += 1)e = pruneSegmentIntersection(t[r - 1], t[r]), t[r - 1] = e[0], t[r] = e[1];
            return t.length > 1 && (e = pruneSegmentIntersection(t[t.length - 1], t[0]), t[t.length - 1] = e[0], t[0] = e[1]), t;
        }
        function offsetSegmentSplit(t, e) {
            var r, i, a, s, n = t.inflectionPoints();
            if (0 === n.length) return [
                offsetSegment(t, e)
            ];
            if (1 === n.length || floatEqual(n[1], 1)) return r = (a = t.split(n[0]))[0], i = a[1], [
                offsetSegment(r, e),
                offsetSegment(i, e)
            ];
            r = (a = t.split(n[0]))[0];
            var o = (n[1] - n[0]) / (1 - n[0]);
            return s = (a = a[1].split(o))[0], i = a[1], [
                offsetSegment(r, e),
                offsetSegment(s, e),
                offsetSegment(i, e)
            ];
        }
        function OffsetPathModifier() {}
        function getFontProperties(t) {
            for(var e = t.fStyle ? t.fStyle.split(" ") : [], r = "normal", i = "normal", a = e.length, s = 0; s < a; s += 1)switch(e[s].toLowerCase()){
                case "italic":
                    i = "italic";
                    break;
                case "bold":
                    r = "700";
                    break;
                case "black":
                    r = "900";
                    break;
                case "medium":
                    r = "500";
                    break;
                case "regular":
                case "normal":
                    r = "400";
                    break;
                case "light":
                case "thin":
                    r = "200";
            }
            return {
                style: i,
                weight: t.fWeight || r
            };
        }
        extendPrototype([
            ShapeModifier
        ], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.c = PropertyFactory.getProp(t, e.c, 0, null, this), this.o = PropertyFactory.getProp(t, e.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(t, e.tr, this), this.so = PropertyFactory.getProp(t, e.tr.so, 0, .01, this), this.eo = PropertyFactory.getProp(t, e.tr.eo, 0, .01, this), this.data = e, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix, this.rMatrix = new Matrix, this.sMatrix = new Matrix, this.tMatrix = new Matrix, this.matrix = new Matrix;
        }, RepeaterModifier.prototype.applyTransforms = function(t, e, r, i, a, s) {
            var n = s ? -1 : 1, o = i.s.v[0] + (1 - i.s.v[0]) * (1 - a), h = i.s.v[1] + (1 - i.s.v[1]) * (1 - a);
            t.translate(i.p.v[0] * n * a, i.p.v[1] * n * a, i.p.v[2]), e.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), e.rotate(-i.r.v * n * a), e.translate(i.a.v[0], i.a.v[1], i.a.v[2]), r.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), r.scale(s ? 1 / o : o, s ? 1 / h : h), r.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
        }, RepeaterModifier.prototype.init = function(t, e, r, i) {
            for(this.elem = t, this.arr = e, this.pos = r, this.elemsData = i, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e[r]); r > 0;)r -= 1, this._elements.unshift(e[r]);
            this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
        }, RepeaterModifier.prototype.resetElements = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)t[e]._processed = !1, "gr" === t[e].ty && this.resetElements(t[e].it);
        }, RepeaterModifier.prototype.cloneElements = function(t) {
            var e = JSON.parse(JSON.stringify(t));
            return this.resetElements(e), e;
        }, RepeaterModifier.prototype.changeGroupRender = function(t, e) {
            var r, i = t.length;
            for(r = 0; r < i; r += 1)t[r]._render = e, "gr" === t[r].ty && this.changeGroupRender(t[r].it, e);
        }, RepeaterModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n = !1;
            if (this._mdf || t) {
                var o, h = Math.ceil(this.c.v);
                if (this._groups.length < h) {
                    for(; this._groups.length < h;){
                        var l = {
                            it: this.cloneElements(this._elements),
                            ty: "gr"
                        };
                        l.it.push({
                            a: {
                                a: 0,
                                ix: 1,
                                k: [
                                    0,
                                    0
                                ]
                            },
                            nm: "Transform",
                            o: {
                                a: 0,
                                ix: 7,
                                k: 100
                            },
                            p: {
                                a: 0,
                                ix: 2,
                                k: [
                                    0,
                                    0
                                ]
                            },
                            r: {
                                a: 1,
                                ix: 6,
                                k: [
                                    {
                                        s: 0,
                                        e: 0,
                                        t: 0
                                    },
                                    {
                                        s: 0,
                                        e: 0,
                                        t: 1
                                    }
                                ]
                            },
                            s: {
                                a: 0,
                                ix: 3,
                                k: [
                                    100,
                                    100
                                ]
                            },
                            sa: {
                                a: 0,
                                ix: 5,
                                k: 0
                            },
                            sk: {
                                a: 0,
                                ix: 4,
                                k: 0
                            },
                            ty: "tr"
                        }), this.arr.splice(0, 0, l), this._groups.splice(0, 0, l), this._currentCopies += 1;
                    }
                    this.elem.reloadShapes(), n = !0;
                }
                for(s = 0, i = 0; i <= this._groups.length - 1; i += 1){
                    if (o = s < h, this._groups[i]._render = o, this.changeGroupRender(this._groups[i].it, o), !o) {
                        var p = this.elemsData[i].it, f = p[p.length - 1];
                        0 !== f.transform.op.v ? (f.transform.op._mdf = !0, f.transform.op.v = 0) : f.transform.op._mdf = !1;
                    }
                    s += 1;
                }
                this._currentCopies = h;
                var c = this.o.v, m = c % 1, d = c > 0 ? Math.floor(c) : Math.ceil(c), u = this.pMatrix.props, y = this.rMatrix.props, g = this.sMatrix.props;
                this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
                var v, b, x = 0;
                if (c > 0) {
                    for(; x < d;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), x += 1;
                    m && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, m, !1), x += m);
                } else if (c < 0) {
                    for(; x > d;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), x -= 1;
                    m && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -m, !0), x -= m);
                }
                for(i = 1 === this.data.m ? 0 : this._currentCopies - 1, a = 1 === this.data.m ? 1 : -1, s = this._currentCopies; s;){
                    if (b = (r = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v.props).length, e[e.length - 1].transform.mProps._mdf = !0, e[e.length - 1].transform.op._mdf = !0, e[e.length - 1].transform.op.v = 1 === this._currentCopies ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1)), 0 !== x) {
                        for((0 !== i && 1 === a || i !== this._currentCopies - 1 && -1 === a) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(y[0], y[1], y[2], y[3], y[4], y[5], y[6], y[7], y[8], y[9], y[10], y[11], y[12], y[13], y[14], y[15]), this.matrix.transform(g[0], g[1], g[2], g[3], g[4], g[5], g[6], g[7], g[8], g[9], g[10], g[11], g[12], g[13], g[14], g[15]), this.matrix.transform(u[0], u[1], u[2], u[3], u[4], u[5], u[6], u[7], u[8], u[9], u[10], u[11], u[12], u[13], u[14], u[15]), v = 0; v < b; v += 1)r[v] = this.matrix.props[v];
                        this.matrix.reset();
                    } else for(this.matrix.reset(), v = 0; v < b; v += 1)r[v] = this.matrix.props[v];
                    x += 1, s -= 1, i += a;
                }
            } else for(s = this._currentCopies, i = 0, a = 1; s;)r = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v.props, e[e.length - 1].transform.mProps._mdf = !1, e[e.length - 1].transform.op._mdf = !1, s -= 1, i += a;
            return n;
        }, RepeaterModifier.prototype.addShape = function() {}, extendPrototype([
            ShapeModifier
        ], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(t, e.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
        }, RoundCornersModifier.prototype.processPath = function(t, e) {
            var r, i = shapePool.newElement();
            i.c = t.c;
            var a, s, n, o, h, l, p, f, c, m, d, u, y = t._length, g = 0;
            for(r = 0; r < y; r += 1)a = t.v[r], n = t.o[r], s = t.i[r], a[0] === n[0] && a[1] === n[1] && a[0] === s[0] && a[1] === s[1] ? 0 !== r && r !== y - 1 || t.c ? (o = 0 === r ? t.v[y - 1] : t.v[r - 1], l = (h = Math.sqrt(Math.pow(a[0] - o[0], 2) + Math.pow(a[1] - o[1], 2))) ? Math.min(h / 2, e) / h : 0, p = d = a[0] + (o[0] - a[0]) * l, f = u = a[1] - (a[1] - o[1]) * l, c = p - (p - a[0]) * roundCorner, m = f - (f - a[1]) * roundCorner, i.setTripleAt(p, f, c, m, d, u, g), g += 1, o = r === y - 1 ? t.v[0] : t.v[r + 1], l = (h = Math.sqrt(Math.pow(a[0] - o[0], 2) + Math.pow(a[1] - o[1], 2))) ? Math.min(h / 2, e) / h : 0, p = c = a[0] + (o[0] - a[0]) * l, f = m = a[1] + (o[1] - a[1]) * l, d = p - (p - a[0]) * roundCorner, u = f - (f - a[1]) * roundCorner, i.setTripleAt(p, f, c, m, d, u, g), g += 1) : (i.setTripleAt(a[0], a[1], n[0], n[1], s[0], s[1], g), g += 1) : (i.setTripleAt(t.v[r][0], t.v[r][1], t.o[r][0], t.o[r][1], t.i[r][0], t.i[r][1], g), g += 1);
            return i;
        }, RoundCornersModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n, o = this.shapes.length, h = this.rd.v;
            if (0 !== h) for(r = 0; r < o; r += 1){
                if (n = (s = this.shapes[r]).localShapeCollection, s.shape._mdf || this._mdf || t) for(n.releaseShapes(), s.shape._mdf = !0, e = s.shape.paths.shapes, a = s.shape.paths._length, i = 0; i < a; i += 1)n.addShape(this.processPath(e[i], h));
                s.shape.paths = s.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        }, PolynomialBezier.prototype.point = function(t) {
            return [
                ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
                ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
            ];
        }, PolynomialBezier.prototype.derivative = function(t) {
            return [
                (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
                (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
            ];
        }, PolynomialBezier.prototype.tangentAngle = function(t) {
            var e = this.derivative(t);
            return Math.atan2(e[1], e[0]);
        }, PolynomialBezier.prototype.normalAngle = function(t) {
            var e = this.derivative(t);
            return Math.atan2(e[0], e[1]);
        }, PolynomialBezier.prototype.inflectionPoints = function() {
            var t = this.a[1] * this.b[0] - this.a[0] * this.b[1];
            if (floatZero(t)) return [];
            var e = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / t, r = e * e - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / t;
            if (r < 0) return [];
            var i = Math.sqrt(r);
            return floatZero(i) ? i > 0 && i < 1 ? [
                e
            ] : [] : [
                e - i,
                e + i
            ].filter(function(t) {
                return t > 0 && t < 1;
            });
        }, PolynomialBezier.prototype.split = function(t) {
            if (t <= 0) return [
                singlePoint(this.points[0]),
                this
            ];
            if (t >= 1) return [
                this,
                singlePoint(this.points[this.points.length - 1])
            ];
            var e = lerpPoint(this.points[0], this.points[1], t), r = lerpPoint(this.points[1], this.points[2], t), i = lerpPoint(this.points[2], this.points[3], t), a = lerpPoint(e, r, t), s = lerpPoint(r, i, t), n = lerpPoint(a, s, t);
            return [
                new PolynomialBezier(this.points[0], e, a, n, !0),
                new PolynomialBezier(n, s, i, this.points[3], !0)
            ];
        }, PolynomialBezier.prototype.bounds = function() {
            return {
                x: extrema(this, 0),
                y: extrema(this, 1)
            };
        }, PolynomialBezier.prototype.boundingBox = function() {
            var t = this.bounds();
            return {
                left: t.x.min,
                right: t.x.max,
                top: t.y.min,
                bottom: t.y.max,
                width: t.x.max - t.x.min,
                height: t.y.max - t.y.min,
                cx: (t.x.max + t.x.min) / 2,
                cy: (t.y.max + t.y.min) / 2
            };
        }, PolynomialBezier.prototype.intersections = function(t, e, r) {
            void 0 === e && (e = 2), void 0 === r && (r = 7);
            var i = [];
            return intersectsImpl(intersectData(this, 0, 1), intersectData(t, 0, 1), 0, e, i, r), i;
        }, PolynomialBezier.shapeSegment = function(t, e) {
            var r = (e + 1) % t.length();
            return new PolynomialBezier(t.v[e], t.o[e], t.i[r], t.v[r], !0);
        }, PolynomialBezier.shapeSegmentInverted = function(t, e) {
            var r = (e + 1) % t.length();
            return new PolynomialBezier(t.v[r], t.i[r], t.o[e], t.v[e], !0);
        }, extendPrototype([
            ShapeModifier
        ], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(t, e.s, 0, null, this), this.frequency = PropertyFactory.getProp(t, e.r, 0, null, this), this.pointsType = PropertyFactory.getProp(t, e.pt, 0, null, this), this._isAnimated = 0 !== this.amplitude.effectsSequence.length || 0 !== this.frequency.effectsSequence.length || 0 !== this.pointsType.effectsSequence.length;
        }, ZigZagModifier.prototype.processPath = function(t, e, r, i) {
            var a = t._length, s = shapePool.newElement();
            if (s.c = t.c, t.c || (a -= 1), 0 === a) return s;
            var n = -1, o = PolynomialBezier.shapeSegment(t, 0);
            zigZagCorner(s, t, 0, e, r, i, n);
            for(var h = 0; h < a; h += 1)n = zigZagSegment(s, o, e, r, i, -n), o = h !== a - 1 || t.c ? PolynomialBezier.shapeSegment(t, (h + 1) % a) : null, zigZagCorner(s, t, h + 1, e, r, i, n);
            return s;
        }, ZigZagModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n, o = this.shapes.length, h = this.amplitude.v, l = Math.max(0, Math.round(this.frequency.v)), p = this.pointsType.v;
            if (0 !== h) for(r = 0; r < o; r += 1){
                if (n = (s = this.shapes[r]).localShapeCollection, s.shape._mdf || this._mdf || t) for(n.releaseShapes(), s.shape._mdf = !0, e = s.shape.paths.shapes, a = s.shape.paths._length, i = 0; i < a; i += 1)n.addShape(this.processPath(e[i], h, l, p));
                s.shape.paths = s.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        }, extendPrototype([
            ShapeModifier
        ], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, e.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(t, e.ml, 0, null, this), this.lineJoin = e.lj, this._isAnimated = 0 !== this.amount.effectsSequence.length;
        }, OffsetPathModifier.prototype.processPath = function(t, e, r, i) {
            var a = shapePool.newElement();
            a.c = t.c;
            var s, n, o, h = t.length();
            t.c || (h -= 1);
            var l = [];
            for(s = 0; s < h; s += 1)o = PolynomialBezier.shapeSegment(t, s), l.push(offsetSegmentSplit(o, e));
            if (!t.c) for(s = h - 1; s >= 0; s -= 1)o = PolynomialBezier.shapeSegmentInverted(t, s), l.push(offsetSegmentSplit(o, e));
            l = pruneIntersections(l);
            var p = null, f = null;
            for(s = 0; s < l.length; s += 1){
                var c = l[s];
                for(f && (p = joinLines(a, f, c[0], r, i)), f = c[c.length - 1], n = 0; n < c.length; n += 1)o = c[n], p && pointEqual(o.points[0], p) ? a.setXYAt(o.points[1][0], o.points[1][1], "o", a.length() - 1) : a.setTripleAt(o.points[0][0], o.points[0][1], o.points[1][0], o.points[1][1], o.points[0][0], o.points[0][1], a.length()), a.setTripleAt(o.points[3][0], o.points[3][1], o.points[3][0], o.points[3][1], o.points[2][0], o.points[2][1], a.length()), p = o.points[3];
            }
            return l.length && joinLines(a, f, l[0][0], r, i), a;
        }, OffsetPathModifier.prototype.processShapes = function(t) {
            var e, r, i, a, s, n, o = this.shapes.length, h = this.amount.v, l = this.miterLimit.v, p = this.lineJoin;
            if (0 !== h) for(r = 0; r < o; r += 1){
                if (n = (s = this.shapes[r]).localShapeCollection, s.shape._mdf || this._mdf || t) for(n.releaseShapes(), s.shape._mdf = !0, e = s.shape.paths.shapes, a = s.shape.paths._length, i = 0; i < a; i += 1)n.addShape(this.processPath(e[i], h, p, l));
                s.shape.paths = s.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        };
        var FontManager = function() {
            var t = {
                w: 0,
                size: 0,
                shapes: [],
                data: {
                    shapes: []
                }
            }, e = [];
            e = e.concat([
                2304,
                2305,
                2306,
                2307,
                2362,
                2363,
                2364,
                2364,
                2366,
                2367,
                2368,
                2369,
                2370,
                2371,
                2372,
                2373,
                2374,
                2375,
                2376,
                2377,
                2378,
                2379,
                2380,
                2381,
                2382,
                2383,
                2387,
                2388,
                2389,
                2390,
                2391,
                2402,
                2403
            ]);
            var r = [
                "d83cdffb",
                "d83cdffc",
                "d83cdffd",
                "d83cdffe",
                "d83cdfff"
            ];
            function i(t, e) {
                var r = createTag("span");
                r.setAttribute("aria-hidden", !0), r.style.fontFamily = e;
                var i = createTag("span");
                i.innerText = "giItT1WQy@!-/#", r.style.position = "absolute", r.style.left = "-10000px", r.style.top = "-10000px", r.style.fontSize = "300px", r.style.fontVariant = "normal", r.style.fontStyle = "normal", r.style.fontWeight = "normal", r.style.letterSpacing = "0", r.appendChild(i), document.body.appendChild(r);
                var a = i.offsetWidth;
                return i.style.fontFamily = function(t) {
                    var e, r = t.split(","), i = r.length, a = [];
                    for(e = 0; e < i; e += 1)"sans-serif" !== r[e] && "monospace" !== r[e] && a.push(r[e]);
                    return a.join(",");
                }(t) + ", " + e, {
                    node: i,
                    w: a,
                    parent: r
                };
            }
            function a(t, e) {
                var r, i = document.body && e ? "svg" : "canvas", a = getFontProperties(t);
                if ("svg" === i) {
                    var s = createNS("text");
                    s.style.fontSize = "100px", s.setAttribute("font-family", t.fFamily), s.setAttribute("font-style", a.style), s.setAttribute("font-weight", a.weight), s.textContent = "1", t.fClass ? (s.style.fontFamily = "inherit", s.setAttribute("class", t.fClass)) : s.style.fontFamily = t.fFamily, e.appendChild(s), r = s;
                } else {
                    var n = new OffscreenCanvas(500, 500).getContext("2d");
                    n.font = a.style + " " + a.weight + " 100px " + t.fFamily, r = n;
                }
                return {
                    measureText: function(t) {
                        return "svg" === i ? (r.textContent = t, r.getComputedTextLength()) : r.measureText(t).width;
                    }
                };
            }
            function s(t) {
                var e = 0, r = t.charCodeAt(0);
                if (r >= 55296 && r <= 56319) {
                    var i = t.charCodeAt(1);
                    i >= 56320 && i <= 57343 && (e = 1024 * (r - 55296) + i - 56320 + 65536);
                }
                return e;
            }
            function n(t) {
                var e = s(t);
                return e >= 127462 && e <= 127487;
            }
            var o = function() {
                this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
            };
            return o.isModifier = function(t, e) {
                var i = t.toString(16) + e.toString(16);
                return -1 !== r.indexOf(i);
            }, o.isZeroWidthJoiner = function(t) {
                return 8205 === t;
            }, o.isFlagEmoji = function(t) {
                return n(t.substr(0, 2)) && n(t.substr(2, 2));
            }, o.isRegionalCode = n, o.isCombinedCharacter = function(t) {
                return -1 !== e.indexOf(t);
            }, o.isRegionalFlag = function(t, e) {
                var r = s(t.substr(e, 2));
                if (127988 !== r) return !1;
                var i = 0;
                for(e += 2; i < 5;){
                    if ((r = s(t.substr(e, 2))) < 917601 || r > 917626) return !1;
                    i += 1, e += 2;
                }
                return 917631 === s(t.substr(e, 2));
            }, o.isVariationSelector = function(t) {
                return 65039 === t;
            }, o.BLACK_FLAG_CODE_POINT = 127988, o.prototype = {
                addChars: function(t) {
                    if (t) {
                        var e;
                        this.chars || (this.chars = []);
                        var r, i, a = t.length, s = this.chars.length;
                        for(e = 0; e < a; e += 1){
                            for(r = 0, i = !1; r < s;)this.chars[r].style === t[e].style && this.chars[r].fFamily === t[e].fFamily && this.chars[r].ch === t[e].ch && (i = !0), r += 1;
                            i || (this.chars.push(t[e]), s += 1);
                        }
                    }
                },
                addFonts: function(t, e) {
                    if (t) {
                        if (this.chars) return this.isLoaded = !0, void (this.fonts = t.list);
                        if (!document.body) return this.isLoaded = !0, t.list.forEach(function(t) {
                            t.helper = a(t), t.cache = {};
                        }), void (this.fonts = t.list);
                        var r, s = t.list, n = s.length, o = n;
                        for(r = 0; r < n; r += 1){
                            var h, l, p = !0;
                            if (s[r].loaded = !1, s[r].monoCase = i(s[r].fFamily, "monospace"), s[r].sansCase = i(s[r].fFamily, "sans-serif"), s[r].fPath) {
                                if ("p" === s[r].fOrigin || 3 === s[r].origin) {
                                    if ((h = document.querySelectorAll('style[f-forigin="p"][f-family="' + s[r].fFamily + '"], style[f-origin="3"][f-family="' + s[r].fFamily + '"]')).length > 0 && (p = !1), p) {
                                        var f = createTag("style");
                                        f.setAttribute("f-forigin", s[r].fOrigin), f.setAttribute("f-origin", s[r].origin), f.setAttribute("f-family", s[r].fFamily), f.type = "text/css", f.innerText = "@font-face {font-family: " + s[r].fFamily + "; font-style: normal; src: url('" + s[r].fPath + "');}", e.appendChild(f);
                                    }
                                } else if ("g" === s[r].fOrigin || 1 === s[r].origin) {
                                    for(h = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), l = 0; l < h.length; l += 1)-1 !== h[l].href.indexOf(s[r].fPath) && (p = !1);
                                    if (p) {
                                        var c = createTag("link");
                                        c.setAttribute("f-forigin", s[r].fOrigin), c.setAttribute("f-origin", s[r].origin), c.type = "text/css", c.rel = "stylesheet", c.href = s[r].fPath, document.body.appendChild(c);
                                    }
                                } else if ("t" === s[r].fOrigin || 2 === s[r].origin) {
                                    for(h = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), l = 0; l < h.length; l += 1)s[r].fPath === h[l].src && (p = !1);
                                    if (p) {
                                        var m = createTag("link");
                                        m.setAttribute("f-forigin", s[r].fOrigin), m.setAttribute("f-origin", s[r].origin), m.setAttribute("rel", "stylesheet"), m.setAttribute("href", s[r].fPath), e.appendChild(m);
                                    }
                                }
                            } else s[r].loaded = !0, o -= 1;
                            s[r].helper = a(s[r], e), s[r].cache = {}, this.fonts.push(s[r]);
                        }
                        0 === o ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
                    } else this.isLoaded = !0;
                },
                getCharData: function(e, r, i) {
                    for(var a = 0, s = this.chars.length; a < s;){
                        if (this.chars[a].ch === e && this.chars[a].style === r && this.chars[a].fFamily === i) return this.chars[a];
                        a += 1;
                    }
                    return ("string" == typeof e && 13 !== e.charCodeAt(0) || !e) && console && console.warn && !this._warned && (this._warned = !0), t;
                },
                getFontByName: function(t) {
                    for(var e = 0, r = this.fonts.length; e < r;){
                        if (this.fonts[e].fName === t) return this.fonts[e];
                        e += 1;
                    }
                    return this.fonts[0];
                },
                measureText: function(t, e, r) {
                    var i = this.getFontByName(e), a = t;
                    if (!i.cache[a]) {
                        var s = i.helper;
                        if (" " === t) {
                            var n = s.measureText("|" + t + "|"), o = s.measureText("||");
                            i.cache[a] = (n - o) / 100;
                        } else i.cache[a] = s.measureText(t) / 100;
                    }
                    return i.cache[a] * r;
                },
                checkLoadedFonts: function() {
                    var t, e, r, i = this.fonts.length, a = i;
                    for(t = 0; t < i; t += 1)this.fonts[t].loaded ? a -= 1 : "n" === this.fonts[t].fOrigin || 0 === this.fonts[t].origin ? this.fonts[t].loaded = !0 : (e = this.fonts[t].monoCase.node, r = this.fonts[t].monoCase.w, e.offsetWidth !== r ? (a -= 1, this.fonts[t].loaded = !0) : (e = this.fonts[t].sansCase.node, r = this.fonts[t].sansCase.w, e.offsetWidth !== r && (a -= 1, this.fonts[t].loaded = !0)), this.fonts[t].loaded && (this.fonts[t].sansCase.parent.parentNode.removeChild(this.fonts[t].sansCase.parent), this.fonts[t].monoCase.parent.parentNode.removeChild(this.fonts[t].monoCase.parent)));
                    0 !== a && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
                },
                setIsLoaded: function() {
                    this.isLoaded = !0;
                }
            }, o;
        }();
        function SlotManager(t) {
            this.animationData = t;
        }
        function slotFactory(t) {
            return new SlotManager(t);
        }
        function RenderableElement() {}
        SlotManager.prototype.getProp = function(t) {
            return this.animationData.slots && this.animationData.slots[t.sid] ? Object.assign(t, this.animationData.slots[t.sid].p) : t;
        }, RenderableElement.prototype = {
            initRenderable: function() {
                this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
            },
            addRenderableComponent: function(t) {
                -1 === this.renderableComponents.indexOf(t) && this.renderableComponents.push(t);
            },
            removeRenderableComponent: function(t) {
                -1 !== this.renderableComponents.indexOf(t) && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
            },
            prepareRenderableFrame: function(t) {
                this.checkLayerLimits(t);
            },
            checkTransparency: function() {
                this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
            },
            checkLayerLimits: function(t) {
                this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? !0 !== this.isInRange && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : !1 !== this.isInRange && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
            },
            renderRenderable: function() {
                var t, e = this.renderableComponents.length;
                for(t = 0; t < e; t += 1)this.renderableComponents[t].renderFrame(this._isFirstFrame);
            },
            sourceRectAtTime: function() {
                return {
                    top: 0,
                    left: 0,
                    width: 100,
                    height: 100
                };
            },
            getLayerSize: function() {
                return 5 === this.data.ty ? {
                    w: this.data.textData.width,
                    h: this.data.textData.height
                } : {
                    w: this.data.width,
                    h: this.data.height
                };
            }
        };
        var getBlendMode = (blendModeEnums = {
            0: "source-over",
            1: "multiply",
            2: "screen",
            3: "overlay",
            4: "darken",
            5: "lighten",
            6: "color-dodge",
            7: "color-burn",
            8: "hard-light",
            9: "soft-light",
            10: "difference",
            11: "exclusion",
            12: "hue",
            13: "saturation",
            14: "color",
            15: "luminosity"
        }, function(t) {
            return blendModeEnums[t] || "";
        }), blendModeEnums;
        function SliderEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function AngleEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function ColorEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 1, 0, r);
        }
        function PointEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 1, 0, r);
        }
        function LayerIndexEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function MaskIndexEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function CheckboxEffect(t, e, r) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
        }
        function NoValueEffect() {
            this.p = {};
        }
        function EffectsManager(t, e) {
            var r, i = t.ef || [];
            this.effectElements = [];
            var a, s = i.length;
            for(r = 0; r < s; r += 1)a = new GroupEffect(i[r], e), this.effectElements.push(a);
        }
        function GroupEffect(t, e) {
            this.init(t, e);
        }
        function BaseElement() {}
        function FrameElement() {}
        function FootageElement(t, e, r) {
            this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.footageData = e.imageLoader.getAsset(this.assetData), this.initBaseData(t, e, r);
        }
        function AudioElement(t, e, r) {
            this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.initBaseData(t, e, r), this._isPlaying = !1, this._canPlay = !1;
            var i = this.globalData.getAssetsPath(this.assetData);
            this.audio = this.globalData.audioController.createAudio(i), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            }, this.lv = PropertyFactory.getProp(this, t.au && t.au.lv ? t.au.lv : {
                k: [
                    100
                ]
            }, 1, .01, this);
        }
        function BaseRenderer() {}
        extendPrototype([
            DynamicPropertyContainer
        ], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(t, e) {
            var r;
            this.data = t, this.effectElements = [], this.initDynamicPropertyContainer(e);
            var i, a = this.data.ef.length, s = this.data.ef;
            for(r = 0; r < a; r += 1){
                switch(i = null, s[r].ty){
                    case 0:
                        i = new SliderEffect(s[r], e, this);
                        break;
                    case 1:
                        i = new AngleEffect(s[r], e, this);
                        break;
                    case 2:
                        i = new ColorEffect(s[r], e, this);
                        break;
                    case 3:
                        i = new PointEffect(s[r], e, this);
                        break;
                    case 4:
                    case 7:
                        i = new CheckboxEffect(s[r], e, this);
                        break;
                    case 10:
                        i = new LayerIndexEffect(s[r], e, this);
                        break;
                    case 11:
                        i = new MaskIndexEffect(s[r], e, this);
                        break;
                    case 5:
                        i = new EffectsManager(s[r], e, this);
                        break;
                    default:
                        i = new NoValueEffect(s[r], e, this);
                }
                i && this.effectElements.push(i);
            }
        }, BaseElement.prototype = {
            checkMasks: function() {
                if (!this.data.hasMask) return !1;
                for(var t = 0, e = this.data.masksProperties.length; t < e;){
                    if ("n" !== this.data.masksProperties[t].mode && !1 !== this.data.masksProperties[t].cl) return !0;
                    t += 1;
                }
                return !1;
            },
            initExpressions: function() {
                var t = getExpressionInterfaces();
                if (t) {
                    var e = t("layer"), r = t("effects"), i = t("shape"), a = t("text"), s = t("comp");
                    this.layerInterface = e(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
                    var n = r.createEffectsInterface(this, this.layerInterface);
                    this.layerInterface.registerEffectsInterface(n), 0 === this.data.ty || this.data.xt ? this.compInterface = s(this) : 4 === this.data.ty ? (this.layerInterface.shapeInterface = i(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : 5 === this.data.ty && (this.layerInterface.textInterface = a(this), this.layerInterface.text = this.layerInterface.textInterface);
                }
            },
            setBlendMode: function() {
                var t = getBlendMode(this.data.bm);
                (this.baseElement || this.layerElement).style["mix-blend-mode"] = t;
            },
            initBaseData: function(t, e, r) {
                this.globalData = e, this.comp = r, this.data = t, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
            },
            getType: function() {
                return this.type;
            },
            sourceRectAtTime: function() {}
        }, FrameElement.prototype = {
            initFrame: function() {
                this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
            },
            prepareProperties: function(t, e) {
                var r, i = this.dynamicProperties.length;
                for(r = 0; r < i; r += 1)(e || this._isParent && "transform" === this.dynamicProperties[r].propType) && (this.dynamicProperties[r].getValue(), this.dynamicProperties[r]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
            },
            addDynamicProperty: function(t) {
                -1 === this.dynamicProperties.indexOf(t) && this.dynamicProperties.push(t);
            }
        }, FootageElement.prototype.prepareFrame = function() {}, extendPrototype([
            RenderableElement,
            BaseElement,
            FrameElement
        ], FootageElement), FootageElement.prototype.getBaseElement = function() {
            return null;
        }, FootageElement.prototype.renderFrame = function() {}, FootageElement.prototype.destroy = function() {}, FootageElement.prototype.initExpressions = function() {
            var t = getExpressionInterfaces();
            if (t) {
                var e = t("footage");
                this.layerInterface = e(this);
            }
        }, FootageElement.prototype.getFootageData = function() {
            return this.footageData;
        }, AudioElement.prototype.prepareFrame = function(t) {
            if (this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), this.tm._placeholder) this._currentTime = t / this.data.sr;
            else {
                var e = this.tm.v;
                this._currentTime = e;
            }
            this._volume = this.lv.v[0];
            var r = this._volume * this._volumeMultiplier;
            this._previousVolume !== r && (this._previousVolume = r, this.audio.volume(r));
        }, extendPrototype([
            RenderableElement,
            BaseElement,
            FrameElement
        ], AudioElement), AudioElement.prototype.renderFrame = function() {
            this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > .1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
        }, AudioElement.prototype.show = function() {}, AudioElement.prototype.hide = function() {
            this.audio.pause(), this._isPlaying = !1;
        }, AudioElement.prototype.pause = function() {
            this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
        }, AudioElement.prototype.resume = function() {
            this._canPlay = !0;
        }, AudioElement.prototype.setRate = function(t) {
            this.audio.rate(t);
        }, AudioElement.prototype.volume = function(t) {
            this._volumeMultiplier = t, this._previousVolume = t * this._volume, this.audio.volume(this._previousVolume);
        }, AudioElement.prototype.getBaseElement = function() {
            return null;
        }, AudioElement.prototype.destroy = function() {}, AudioElement.prototype.sourceRectAtTime = function() {}, AudioElement.prototype.initExpressions = function() {}, BaseRenderer.prototype.checkLayers = function(t) {
            var e, r, i = this.layers.length;
            for(this.completeLayers = !0, e = i - 1; e >= 0; e -= 1)this.elements[e] || (r = this.layers[e]).ip - r.st <= t - this.layers[e].st && r.op - r.st > t - this.layers[e].st && this.buildItem(e), this.completeLayers = !!this.elements[e] && this.completeLayers;
            this.checkPendingElements();
        }, BaseRenderer.prototype.createItem = function(t) {
            switch(t.ty){
                case 2:
                    return this.createImage(t);
                case 0:
                    return this.createComp(t);
                case 1:
                    return this.createSolid(t);
                case 3:
                    return this.createNull(t);
                case 4:
                    return this.createShape(t);
                case 5:
                    return this.createText(t);
                case 6:
                    return this.createAudio(t);
                case 13:
                    return this.createCamera(t);
                case 15:
                    return this.createFootage(t);
                default:
                    return this.createNull(t);
            }
        }, BaseRenderer.prototype.createCamera = function() {
            throw new Error("You're using a 3d camera. Try the html renderer.");
        }, BaseRenderer.prototype.createAudio = function(t) {
            return new AudioElement(t, this.globalData, this);
        }, BaseRenderer.prototype.createFootage = function(t) {
            return new FootageElement(t, this.globalData, this);
        }, BaseRenderer.prototype.buildAllItems = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)this.buildItem(t);
            this.checkPendingElements();
        }, BaseRenderer.prototype.includeLayers = function(t) {
            var e;
            this.completeLayers = !1;
            var r, i = t.length, a = this.layers.length;
            for(e = 0; e < i; e += 1)for(r = 0; r < a;){
                if (this.layers[r].id === t[e].id) {
                    this.layers[r] = t[e];
                    break;
                }
                r += 1;
            }
        }, BaseRenderer.prototype.setProjectInterface = function(t) {
            this.globalData.projectInterface = t;
        }, BaseRenderer.prototype.initItems = function() {
            this.globalData.progressiveLoad || this.buildAllItems();
        }, BaseRenderer.prototype.buildElementParenting = function(t, e, r) {
            for(var i = this.elements, a = this.layers, s = 0, n = a.length; s < n;)a[s].ind == e && (i[s] && !0 !== i[s] ? (r.push(i[s]), i[s].setAsParent(), void 0 !== a[s].parent ? this.buildElementParenting(t, a[s].parent, r) : t.setHierarchy(r)) : (this.buildItem(s), this.addPendingElement(t))), s += 1;
        }, BaseRenderer.prototype.addPendingElement = function(t) {
            this.pendingElements.push(t);
        }, BaseRenderer.prototype.searchExtraCompositions = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)if (t[e].xt) {
                var i = this.createComp(t[e]);
                i.initExpressions(), this.globalData.projectInterface.registerComposition(i);
            }
        }, BaseRenderer.prototype.getElementById = function(t) {
            var e, r = this.elements.length;
            for(e = 0; e < r; e += 1)if (this.elements[e].data.ind === t) return this.elements[e];
            return null;
        }, BaseRenderer.prototype.getElementByPath = function(t) {
            var e, r = t.shift();
            if ("number" == typeof r) e = this.elements[r];
            else {
                var i, a = this.elements.length;
                for(i = 0; i < a; i += 1)if (this.elements[i].data.nm === r) {
                    e = this.elements[i];
                    break;
                }
            }
            return 0 === t.length ? e : e.getElementByPath(t);
        }, BaseRenderer.prototype.setupGlobalData = function(t, e) {
            this.globalData.fontManager = new FontManager, this.globalData.slotManager = slotFactory(t), this.globalData.fontManager.addChars(t.chars), this.globalData.fontManager.addFonts(t.fonts, e), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t.fr, this.globalData.nm = t.nm, this.globalData.compSize = {
                w: t.w,
                h: t.h
            };
        };
        var effectTypes = {
            TRANSFORM_EFFECT: "transformEFfect"
        };
        function TransformElement() {}
        function MaskElement(t, e, r) {
            this.data = t, this.element = e, this.globalData = r, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
            var i, a, s = this.globalData.defs, n = this.masksProperties ? this.masksProperties.length : 0;
            this.viewData = createSizedArray(n), this.solidPath = "";
            var o, h, l, p, f, c, m = this.masksProperties, d = 0, u = [], y = createElementID(), g = "clipPath", v = "clip-path";
            for(i = 0; i < n; i += 1)if (("a" !== m[i].mode && "n" !== m[i].mode || m[i].inv || 100 !== m[i].o.k || m[i].o.x) && (g = "mask", v = "mask"), "s" !== m[i].mode && "i" !== m[i].mode || 0 !== d ? l = null : ((l = createNS("rect")).setAttribute("fill", "#ffffff"), l.setAttribute("width", this.element.comp.data.w || 0), l.setAttribute("height", this.element.comp.data.h || 0), u.push(l)), a = createNS("path"), "n" === m[i].mode) this.viewData[i] = {
                op: PropertyFactory.getProp(this.element, m[i].o, 0, .01, this.element),
                prop: ShapePropertyFactory.getShapeProp(this.element, m[i], 3),
                elem: a,
                lastPath: ""
            }, s.appendChild(a);
            else {
                var b;
                if (d += 1, a.setAttribute("fill", "s" === m[i].mode ? "#000000" : "#ffffff"), a.setAttribute("clip-rule", "nonzero"), 0 !== m[i].x.k ? (g = "mask", v = "mask", c = PropertyFactory.getProp(this.element, m[i].x, 0, null, this.element), b = createElementID(), (p = createNS("filter")).setAttribute("id", b), (f = createNS("feMorphology")).setAttribute("operator", "erode"), f.setAttribute("in", "SourceGraphic"), f.setAttribute("radius", "0"), p.appendChild(f), s.appendChild(p), a.setAttribute("stroke", "s" === m[i].mode ? "#000000" : "#ffffff")) : (f = null, c = null), this.storedData[i] = {
                    elem: a,
                    x: c,
                    expan: f,
                    lastPath: "",
                    lastOperator: "",
                    filterId: b,
                    lastRadius: 0
                }, "i" === m[i].mode) {
                    h = u.length;
                    var x = createNS("g");
                    for(o = 0; o < h; o += 1)x.appendChild(u[o]);
                    var E = createNS("mask");
                    E.setAttribute("mask-type", "alpha"), E.setAttribute("id", y + "_" + d), E.appendChild(a), s.appendChild(E), x.setAttribute("mask", "url(" + getLocationHref() + "#" + y + "_" + d + ")"), u.length = 0, u.push(x);
                } else u.push(a);
                m[i].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[i] = {
                    elem: a,
                    lastPath: "",
                    op: PropertyFactory.getProp(this.element, m[i].o, 0, .01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, m[i], 3),
                    invRect: l
                }, this.viewData[i].prop.k || this.drawPath(m[i], this.viewData[i].prop.v, this.viewData[i]);
            }
            for(this.maskElement = createNS(g), n = u.length, i = 0; i < n; i += 1)this.maskElement.appendChild(u[i]);
            d > 0 && (this.maskElement.setAttribute("id", y), this.element.maskedElement.setAttribute(v, "url(" + getLocationHref() + "#" + y + ")"), s.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
        }
        TransformElement.prototype = {
            initTransform: function() {
                var t = new Matrix;
                this.finalTransform = {
                    mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                        o: 0
                    },
                    _matMdf: !1,
                    _localMatMdf: !1,
                    _opMdf: !1,
                    mat: t,
                    localMat: t,
                    localOpacity: 1
                }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
            },
            renderTransform: function() {
                if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
                    var t, e = this.finalTransform.mat, r = 0, i = this.hierarchy.length;
                    if (!this.finalTransform._matMdf) for(; r < i;){
                        if (this.hierarchy[r].finalTransform.mProp._mdf) {
                            this.finalTransform._matMdf = !0;
                            break;
                        }
                        r += 1;
                    }
                    if (this.finalTransform._matMdf) for(t = this.finalTransform.mProp.v.props, e.cloneFromProps(t), r = 0; r < i; r += 1)e.multiply(this.hierarchy[r].finalTransform.mProp.v);
                }
                this.finalTransform._matMdf && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
            },
            renderLocalTransform: function() {
                if (this.localTransforms) {
                    var t = 0, e = this.localTransforms.length;
                    if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf) for(; t < e;)this.localTransforms[t]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[t]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), t += 1;
                    if (this.finalTransform._localMatMdf) {
                        var r = this.finalTransform.localMat;
                        for(this.localTransforms[0].matrix.clone(r), t = 1; t < e; t += 1){
                            var i = this.localTransforms[t].matrix;
                            r.multiply(i);
                        }
                        r.multiply(this.finalTransform.mat);
                    }
                    if (this.finalTransform._opMdf) {
                        var a = this.finalTransform.localOpacity;
                        for(t = 0; t < e; t += 1)a *= .01 * this.localTransforms[t].opacity;
                        this.finalTransform.localOpacity = a;
                    }
                }
            },
            searchEffectTransforms: function() {
                if (this.renderableEffectsManager) {
                    var t = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                    if (t.length) {
                        this.localTransforms = [], this.finalTransform.localMat = new Matrix;
                        var e = 0, r = t.length;
                        for(e = 0; e < r; e += 1)this.localTransforms.push(t[e]);
                    }
                }
            },
            globalToLocal: function(t) {
                var e = [];
                e.push(this.finalTransform);
                for(var r, i = !0, a = this.comp; i;)a.finalTransform ? (a.data.hasMask && e.splice(0, 0, a.finalTransform), a = a.comp) : i = !1;
                var s, n = e.length;
                for(r = 0; r < n; r += 1)s = e[r].mat.applyToPointArray(0, 0, 0), t = [
                    t[0] - s[0],
                    t[1] - s[1],
                    0
                ];
                return t;
            },
            mHelper: new Matrix
        }, MaskElement.prototype.getMaskProperty = function(t) {
            return this.viewData[t].prop;
        }, MaskElement.prototype.renderFrame = function(t) {
            var e, r = this.element.finalTransform.mat, i = this.masksProperties.length;
            for(e = 0; e < i; e += 1)if ((this.viewData[e].prop._mdf || t) && this.drawPath(this.masksProperties[e], this.viewData[e].prop.v, this.viewData[e]), (this.viewData[e].op._mdf || t) && this.viewData[e].elem.setAttribute("fill-opacity", this.viewData[e].op.v), "n" !== this.masksProperties[e].mode && (this.viewData[e].invRect && (this.element.finalTransform.mProp._mdf || t) && this.viewData[e].invRect.setAttribute("transform", r.getInverseMatrix().to2dCSS()), this.storedData[e].x && (this.storedData[e].x._mdf || t))) {
                var a = this.storedData[e].expan;
                this.storedData[e].x.v < 0 ? ("erode" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "erode", this.storedData[e].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[e].filterId + ")")), a.setAttribute("radius", -this.storedData[e].x.v)) : ("dilate" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "dilate", this.storedData[e].elem.setAttribute("filter", null)), this.storedData[e].elem.setAttribute("stroke-width", 2 * this.storedData[e].x.v));
            }
        }, MaskElement.prototype.getMaskelement = function() {
            return this.maskElement;
        }, MaskElement.prototype.createLayerSolidPath = function() {
            var t = "M0,0 ";
            return t += " h" + this.globalData.compSize.w, t += " v" + this.globalData.compSize.h, t += " h-" + this.globalData.compSize.w, t += " v-" + this.globalData.compSize.h + " ";
        }, MaskElement.prototype.drawPath = function(t, e, r) {
            var i, a, s = " M" + e.v[0][0] + "," + e.v[0][1];
            for(a = e._length, i = 1; i < a; i += 1)s += " C" + e.o[i - 1][0] + "," + e.o[i - 1][1] + " " + e.i[i][0] + "," + e.i[i][1] + " " + e.v[i][0] + "," + e.v[i][1];
            if (e.c && a > 1 && (s += " C" + e.o[i - 1][0] + "," + e.o[i - 1][1] + " " + e.i[0][0] + "," + e.i[0][1] + " " + e.v[0][0] + "," + e.v[0][1]), r.lastPath !== s) {
                var n = "";
                r.elem && (e.c && (n = t.inv ? this.solidPath + s : s), r.elem.setAttribute("d", n)), r.lastPath = s;
            }
        }, MaskElement.prototype.destroy = function() {
            this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
        };
        var filtersFactory = function() {
            var t = {};
            return t.createFilter = function(t, e) {
                var r = createNS("filter");
                r.setAttribute("id", t), !0 !== e && (r.setAttribute("filterUnits", "objectBoundingBox"), r.setAttribute("x", "0%"), r.setAttribute("y", "0%"), r.setAttribute("width", "100%"), r.setAttribute("height", "100%"));
                return r;
            }, t.createAlphaToLuminanceFilter = function() {
                var t = createNS("feColorMatrix");
                return t.setAttribute("type", "matrix"), t.setAttribute("color-interpolation-filters", "sRGB"), t.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), t;
            }, t;
        }(), featureSupport = function() {
            var t = {
                maskType: !0,
                svgLumaHidden: !0,
                offscreenCanvas: "undefined" != typeof OffscreenCanvas
            };
            return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t.maskType = !1), /firefox/i.test(navigator.userAgent) && (t.svgLumaHidden = !1), t;
        }(), registeredEffects$1 = {}, idPrefix = "filter_result_";
        function SVGEffects(t) {
            var e, r, i = "SourceGraphic", a = t.data.ef ? t.data.ef.length : 0, s = createElementID(), n = filtersFactory.createFilter(s, !0), o = 0;
            for(this.filters = [], e = 0; e < a; e += 1){
                r = null;
                var h = t.data.ef[e].ty;
                if (registeredEffects$1[h]) r = new registeredEffects$1[h].effect(n, t.effectsManager.effectElements[e], t, idPrefix + o, i), i = idPrefix + o, registeredEffects$1[h].countsAsEffect && (o += 1);
                r && this.filters.push(r);
            }
            o && (t.globalData.defs.appendChild(n), t.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + s + ")")), this.filters.length && t.addRenderableComponent(this);
        }
        function registerEffect$1(t, e, r) {
            registeredEffects$1[t] = {
                effect: e,
                countsAsEffect: r
            };
        }
        function SVGBaseElement() {}
        function HierarchyElement() {}
        function RenderableDOMElement() {}
        function IImageElement(t, e, r) {
            this.assetData = e.getAssetData(t.refId), this.assetData && this.assetData.sid && (this.assetData = e.slotManager.getProp(this.assetData)), this.initElement(t, e, r), this.sourceRect = {
                top: 0,
                left: 0,
                width: this.assetData.w,
                height: this.assetData.h
            };
        }
        function ProcessedElement(t, e) {
            this.elem = t, this.pos = e;
        }
        function IShapeElement() {}
        SVGEffects.prototype.renderFrame = function(t) {
            var e, r = this.filters.length;
            for(e = 0; e < r; e += 1)this.filters[e].renderFrame(t);
        }, SVGEffects.prototype.getEffects = function(t) {
            var e, r = this.filters.length, i = [];
            for(e = 0; e < r; e += 1)this.filters[e].type === t && i.push(this.filters[e]);
            return i;
        }, SVGBaseElement.prototype = {
            initRendererElement: function() {
                this.layerElement = createNS("g");
            },
            createContainerElements: function() {
                this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
                var t = null;
                if (this.data.td) {
                    this.matteMasks = {};
                    var e = createNS("g");
                    e.setAttribute("id", this.layerId), e.appendChild(this.layerElement), t = e, this.globalData.defs.appendChild(e);
                } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), t = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
                if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 === this.data.ty && !this.data.hd) {
                    var r = createNS("clipPath"), i = createNS("path");
                    i.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                    var a = createElementID();
                    if (r.setAttribute("id", a), r.appendChild(i), this.globalData.defs.appendChild(r), this.checkMasks()) {
                        var s = createNS("g");
                        s.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")"), s.appendChild(this.layerElement), this.transformedElement = s, t ? t.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
                    } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")");
                }
                0 !== this.data.bm && this.setBlendMode();
            },
            renderElement: function() {
                this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
            },
            destroyBaseElement: function() {
                this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
            },
            getBaseElement: function() {
                return this.data.hd ? null : this.baseElement;
            },
            createRenderableComponents: function() {
                this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this), this.searchEffectTransforms();
            },
            getMatte: function(t) {
                if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[t]) {
                    var e, r, i, a, s = this.layerId + "_" + t;
                    if (1 === t || 3 === t) {
                        var n = createNS("mask");
                        n.setAttribute("id", s), n.setAttribute("mask-type", 3 === t ? "luminance" : "alpha"), (i = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), n.appendChild(i), this.globalData.defs.appendChild(n), featureSupport.maskType || 1 !== t || (n.setAttribute("mask-type", "luminance"), e = createElementID(), r = filtersFactory.createFilter(e), this.globalData.defs.appendChild(r), r.appendChild(filtersFactory.createAlphaToLuminanceFilter()), (a = createNS("g")).appendChild(i), n.appendChild(a), a.setAttribute("filter", "url(" + getLocationHref() + "#" + e + ")"));
                    } else if (2 === t) {
                        var o = createNS("mask");
                        o.setAttribute("id", s), o.setAttribute("mask-type", "alpha");
                        var h = createNS("g");
                        o.appendChild(h), e = createElementID(), r = filtersFactory.createFilter(e);
                        var l = createNS("feComponentTransfer");
                        l.setAttribute("in", "SourceGraphic"), r.appendChild(l);
                        var p = createNS("feFuncA");
                        p.setAttribute("type", "table"), p.setAttribute("tableValues", "1.0 0.0"), l.appendChild(p), this.globalData.defs.appendChild(r);
                        var f = createNS("rect");
                        f.setAttribute("width", this.comp.data.w), f.setAttribute("height", this.comp.data.h), f.setAttribute("x", "0"), f.setAttribute("y", "0"), f.setAttribute("fill", "#ffffff"), f.setAttribute("opacity", "0"), h.setAttribute("filter", "url(" + getLocationHref() + "#" + e + ")"), h.appendChild(f), (i = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), h.appendChild(i), featureSupport.maskType || (o.setAttribute("mask-type", "luminance"), r.appendChild(filtersFactory.createAlphaToLuminanceFilter()), a = createNS("g"), h.appendChild(f), a.appendChild(this.layerElement), h.appendChild(a)), this.globalData.defs.appendChild(o);
                    }
                    this.matteMasks[t] = s;
                }
                return this.matteMasks[t];
            },
            setMatte: function(t) {
                this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t + ")");
            }
        }, HierarchyElement.prototype = {
            initHierarchy: function() {
                this.hierarchy = [], this._isParent = !1, this.checkParenting();
            },
            setHierarchy: function(t) {
                this.hierarchy = t;
            },
            setAsParent: function() {
                this._isParent = !0;
            },
            checkParenting: function() {
                void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent, []);
            }
        }, extendPrototype([
            RenderableElement,
            createProxyFunction({
                initElement: function(t, e, r) {
                    this.initFrame(), this.initBaseData(t, e, r), this.initTransform(t, e, r), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
                },
                hide: function() {
                    this.hidden || this.isInRange && !this.isTransparent || ((this.baseElement || this.layerElement).style.display = "none", this.hidden = !0);
                },
                show: function() {
                    this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), this.hidden = !1, this._isFirstFrame = !0);
                },
                renderFrame: function() {
                    this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
                },
                renderInnerContent: function() {},
                prepareFrame: function(t) {
                    this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.checkTransparency();
                },
                destroy: function() {
                    this.innerElem = null, this.destroyBaseElement();
                }
            })
        ], RenderableDOMElement), extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], IImageElement), IImageElement.prototype.createContent = function() {
            var t = this.globalData.getAssetsPath(this.assetData);
            this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.innerElem);
        }, IImageElement.prototype.sourceRectAtTime = function() {
            return this.sourceRect;
        }, IShapeElement.prototype = {
            addShapeToModifiers: function(t) {
                var e, r = this.shapeModifiers.length;
                for(e = 0; e < r; e += 1)this.shapeModifiers[e].addShape(t);
            },
            isShapeInAnimatedModifiers: function(t) {
                for(var e = this.shapeModifiers.length; 0 < e;)if (this.shapeModifiers[0].isAnimatedWithShape(t)) return !0;
                return !1;
            },
            renderModifiers: function() {
                if (this.shapeModifiers.length) {
                    var t, e = this.shapes.length;
                    for(t = 0; t < e; t += 1)this.shapes[t].sh.reset();
                    for(t = (e = this.shapeModifiers.length) - 1; t >= 0 && !this.shapeModifiers[t].processShapes(this._isFirstFrame); t -= 1);
                }
            },
            searchProcessedElement: function(t) {
                for(var e = this.processedElements, r = 0, i = e.length; r < i;){
                    if (e[r].elem === t) return e[r].pos;
                    r += 1;
                }
                return 0;
            },
            addProcessedElement: function(t, e) {
                for(var r = this.processedElements, i = r.length; i;)if (r[i -= 1].elem === t) return void (r[i].pos = e);
                r.push(new ProcessedElement(t, e));
            },
            prepareFrame: function(t) {
                this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
            }
        };
        var lineCapEnum = {
            1: "butt",
            2: "round",
            3: "square"
        }, lineJoinEnum = {
            1: "miter",
            2: "round",
            3: "bevel"
        };
        function SVGShapeData(t, e, r) {
            this.caches = [], this.styles = [], this.transformers = t, this.lStr = "", this.sh = r, this.lvl = e, this._isAnimated = !!r.k;
            for(var i = 0, a = t.length; i < a;){
                if (t[i].mProps.dynamicProperties.length) {
                    this._isAnimated = !0;
                    break;
                }
                i += 1;
            }
        }
        function SVGStyleData(t, e) {
            this.data = t, this.type = t.ty, this.d = "", this.lvl = e, this._mdf = !1, this.closed = !0 === t.hd, this.pElem = createNS("path"), this.msElem = null;
        }
        function DashProperty(t, e, r, i) {
            var a;
            this.elem = t, this.frameId = -1, this.dataProps = createSizedArray(e.length), this.renderer = r, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", e.length ? e.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(i);
            var s, n = e.length || 0;
            for(a = 0; a < n; a += 1)s = PropertyFactory.getProp(t, e[a].v, 0, 0, this), this.k = s.k || this.k, this.dataProps[a] = {
                n: e[a].n,
                p: s
            };
            this.k || this.getValue(!0), this._isAnimated = this.k;
        }
        function SVGStrokeStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.w = PropertyFactory.getProp(t, e.w, 0, null, this), this.d = new DashProperty(t, e.d || {}, "svg", this), this.c = PropertyFactory.getProp(t, e.c, 1, 255, this), this.style = r, this._isAnimated = !!this._isAnimated;
        }
        function SVGFillStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.c = PropertyFactory.getProp(t, e.c, 1, 255, this), this.style = r;
        }
        function SVGNoStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.style = r;
        }
        function GradientProperty(t, e, r) {
            this.data = e, this.c = createTypedArray("uint8c", 4 * e.p);
            var i = e.k.k[0].s ? e.k.k[0].s.length - 4 * e.p : e.k.k.length - 4 * e.p;
            this.o = createTypedArray("float32", i), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = i, this.initDynamicPropertyContainer(r), this.prop = PropertyFactory.getProp(t, e.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
        }
        function SVGGradientFillStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.initGradientData(t, e, r);
        }
        function SVGGradientStrokeStyleData(t, e, r) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(t, e.w, 0, null, this), this.d = new DashProperty(t, e.d || {}, "svg", this), this.initGradientData(t, e, r), this._isAnimated = !!this._isAnimated;
        }
        function ShapeGroupData() {
            this.it = [], this.prevViewData = [], this.gr = createNS("g");
        }
        function SVGTransformData(t, e, r) {
            this.transform = {
                mProps: t,
                op: e,
                container: r
            }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
        }
        SVGShapeData.prototype.setAsAnimated = function() {
            this._isAnimated = !0;
        }, SVGStyleData.prototype.reset = function() {
            this.d = "", this._mdf = !1;
        }, DashProperty.prototype.getValue = function(t) {
            if ((this.elem.globalData.frameId !== this.frameId || t) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t, this._mdf)) {
                var e = 0, r = this.dataProps.length;
                for("svg" === this.renderer && (this.dashStr = ""), e = 0; e < r; e += 1)"o" !== this.dataProps[e].n ? "svg" === this.renderer ? this.dashStr += " " + this.dataProps[e].p.v : this.dashArray[e] = this.dataProps[e].p.v : this.dashoffset[0] = this.dataProps[e].p.v;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], DashProperty), extendPrototype([
            DynamicPropertyContainer
        ], SVGStrokeStyleData), extendPrototype([
            DynamicPropertyContainer
        ], SVGFillStyleData), extendPrototype([
            DynamicPropertyContainer
        ], SVGNoStyleData), GradientProperty.prototype.comparePoints = function(t, e) {
            for(var r = 0, i = this.o.length / 2; r < i;){
                if (Math.abs(t[4 * r] - t[4 * e + 2 * r]) > .01) return !1;
                r += 1;
            }
            return !0;
        }, GradientProperty.prototype.checkCollapsable = function() {
            if (this.o.length / 2 != this.c.length / 4) return !1;
            if (this.data.k.k[0].s) for(var t = 0, e = this.data.k.k.length; t < e;){
                if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
                t += 1;
            }
            else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
            return !0;
        }, GradientProperty.prototype.getValue = function(t) {
            if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t) {
                var e, r, i, a = 4 * this.data.p;
                for(e = 0; e < a; e += 1)r = e % 4 == 0 ? 100 : 255, i = Math.round(this.prop.v[e] * r), this.c[e] !== i && (this.c[e] = i, this._cmdf = !t);
                if (this.o.length) for(a = this.prop.v.length, e = 4 * this.data.p; e < a; e += 1)r = e % 2 == 0 ? 100 : 1, i = e % 2 == 0 ? Math.round(100 * this.prop.v[e]) : this.prop.v[e], this.o[e - 4 * this.data.p] !== i && (this.o[e - 4 * this.data.p] = i, this._omdf = !t);
                this._mdf = !t;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], GradientProperty), SVGGradientFillStyleData.prototype.initGradientData = function(t, e, r) {
            this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.s = PropertyFactory.getProp(t, e.s, 1, null, this), this.e = PropertyFactory.getProp(t, e.e, 1, null, this), this.h = PropertyFactory.getProp(t, e.h || {
                k: 0
            }, 0, .01, this), this.a = PropertyFactory.getProp(t, e.a || {
                k: 0
            }, 0, degToRads, this), this.g = new GradientProperty(t, e.g, this), this.style = r, this.stops = [], this.setGradientData(r.pElem, e), this.setGradientOpacity(e, r), this._isAnimated = !!this._isAnimated;
        }, SVGGradientFillStyleData.prototype.setGradientData = function(t, e) {
            var r = createElementID(), i = createNS(1 === e.t ? "linearGradient" : "radialGradient");
            i.setAttribute("id", r), i.setAttribute("spreadMethod", "pad"), i.setAttribute("gradientUnits", "userSpaceOnUse");
            var a, s, n, o = [];
            for(n = 4 * e.g.p, s = 0; s < n; s += 4)a = createNS("stop"), i.appendChild(a), o.push(a);
            t.setAttribute("gf" === e.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + r + ")"), this.gf = i, this.cst = o;
        }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(t, e) {
            if (this.g._hasOpacity && !this.g._collapsable) {
                var r, i, a, s = createNS("mask"), n = createNS("path");
                s.appendChild(n);
                var o = createElementID(), h = createElementID();
                s.setAttribute("id", h);
                var l = createNS(1 === t.t ? "linearGradient" : "radialGradient");
                l.setAttribute("id", o), l.setAttribute("spreadMethod", "pad"), l.setAttribute("gradientUnits", "userSpaceOnUse"), a = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length;
                var p = this.stops;
                for(i = 4 * t.g.p; i < a; i += 2)(r = createNS("stop")).setAttribute("stop-color", "rgb(255,255,255)"), l.appendChild(r), p.push(r);
                n.setAttribute("gf" === t.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + o + ")"), "gs" === t.ty && (n.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), n.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), 1 === t.lj && n.setAttribute("stroke-miterlimit", t.ml)), this.of = l, this.ms = s, this.ost = p, this.maskId = h, e.msElem = n;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], SVGGradientFillStyleData), extendPrototype([
            SVGGradientFillStyleData,
            DynamicPropertyContainer
        ], SVGGradientStrokeStyleData);
        var buildShapeString = function(t, e, r, i) {
            if (0 === e) return "";
            var a, s = t.o, n = t.i, o = t.v, h = " M" + i.applyToPointStringified(o[0][0], o[0][1]);
            for(a = 1; a < e; a += 1)h += " C" + i.applyToPointStringified(s[a - 1][0], s[a - 1][1]) + " " + i.applyToPointStringified(n[a][0], n[a][1]) + " " + i.applyToPointStringified(o[a][0], o[a][1]);
            return r && e && (h += " C" + i.applyToPointStringified(s[a - 1][0], s[a - 1][1]) + " " + i.applyToPointStringified(n[0][0], n[0][1]) + " " + i.applyToPointStringified(o[0][0], o[0][1]), h += "z"), h;
        }, SVGElementsRenderer = function() {
            var t = new Matrix, e = new Matrix;
            function r(t, e, r) {
                (r || e.transform.op._mdf) && e.transform.container.setAttribute("opacity", e.transform.op.v), (r || e.transform.mProps._mdf) && e.transform.container.setAttribute("transform", e.transform.mProps.v.to2dCSS());
            }
            function i() {}
            function a(r, i, a) {
                var s, n, o, h, l, p, f, c, m, d, u = i.styles.length, y = i.lvl;
                for(p = 0; p < u; p += 1){
                    if (h = i.sh._mdf || a, i.styles[p].lvl < y) {
                        for(c = e.reset(), m = y - i.styles[p].lvl, d = i.transformers.length - 1; !h && m > 0;)h = i.transformers[d].mProps._mdf || h, m -= 1, d -= 1;
                        if (h) for(m = y - i.styles[p].lvl, d = i.transformers.length - 1; m > 0;)c.multiply(i.transformers[d].mProps.v), m -= 1, d -= 1;
                    } else c = t;
                    if (n = (f = i.sh.paths)._length, h) {
                        for(o = "", s = 0; s < n; s += 1)(l = f.shapes[s]) && l._length && (o += buildShapeString(l, l._length, l.c, c));
                        i.caches[p] = o;
                    } else o = i.caches[p];
                    i.styles[p].d += !0 === r.hd ? "" : o, i.styles[p]._mdf = h || i.styles[p]._mdf;
                }
            }
            function s(t, e, r) {
                var i = e.style;
                (e.c._mdf || r) && i.pElem.setAttribute("fill", "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r) && i.pElem.setAttribute("fill-opacity", e.o.v);
            }
            function n(t, e, r) {
                o(t, e, r), h(t, e, r);
            }
            function o(t, e, r) {
                var i, a, s, n, o, h = e.gf, l = e.g._hasOpacity, p = e.s.v, f = e.e.v;
                if (e.o._mdf || r) {
                    var c = "gf" === t.ty ? "fill-opacity" : "stroke-opacity";
                    e.style.pElem.setAttribute(c, e.o.v);
                }
                if (e.s._mdf || r) {
                    var m = 1 === t.t ? "x1" : "cx", d = "x1" === m ? "y1" : "cy";
                    h.setAttribute(m, p[0]), h.setAttribute(d, p[1]), l && !e.g._collapsable && (e.of.setAttribute(m, p[0]), e.of.setAttribute(d, p[1]));
                }
                if (e.g._cmdf || r) {
                    i = e.cst;
                    var u = e.g.c;
                    for(s = i.length, a = 0; a < s; a += 1)(n = i[a]).setAttribute("offset", u[4 * a] + "%"), n.setAttribute("stop-color", "rgb(" + u[4 * a + 1] + "," + u[4 * a + 2] + "," + u[4 * a + 3] + ")");
                }
                if (l && (e.g._omdf || r)) {
                    var y = e.g.o;
                    for(s = (i = e.g._collapsable ? e.cst : e.ost).length, a = 0; a < s; a += 1)n = i[a], e.g._collapsable || n.setAttribute("offset", y[2 * a] + "%"), n.setAttribute("stop-opacity", y[2 * a + 1]);
                }
                if (1 === t.t) (e.e._mdf || r) && (h.setAttribute("x2", f[0]), h.setAttribute("y2", f[1]), l && !e.g._collapsable && (e.of.setAttribute("x2", f[0]), e.of.setAttribute("y2", f[1])));
                else if ((e.s._mdf || e.e._mdf || r) && (o = Math.sqrt(Math.pow(p[0] - f[0], 2) + Math.pow(p[1] - f[1], 2)), h.setAttribute("r", o), l && !e.g._collapsable && e.of.setAttribute("r", o)), e.e._mdf || e.h._mdf || e.a._mdf || r) {
                    o || (o = Math.sqrt(Math.pow(p[0] - f[0], 2) + Math.pow(p[1] - f[1], 2)));
                    var g = Math.atan2(f[1] - p[1], f[0] - p[0]), v = e.h.v;
                    v >= 1 ? v = .99 : v <= -1 && (v = -0.99);
                    var b = o * v, x = Math.cos(g + e.a.v) * b + p[0], E = Math.sin(g + e.a.v) * b + p[1];
                    h.setAttribute("fx", x), h.setAttribute("fy", E), l && !e.g._collapsable && (e.of.setAttribute("fx", x), e.of.setAttribute("fy", E));
                }
            }
            function h(t, e, r) {
                var i = e.style, a = e.d;
                a && (a._mdf || r) && a.dashStr && (i.pElem.setAttribute("stroke-dasharray", a.dashStr), i.pElem.setAttribute("stroke-dashoffset", a.dashoffset[0])), e.c && (e.c._mdf || r) && i.pElem.setAttribute("stroke", "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r) && i.pElem.setAttribute("stroke-opacity", e.o.v), (e.w._mdf || r) && (i.pElem.setAttribute("stroke-width", e.w.v), i.msElem && i.msElem.setAttribute("stroke-width", e.w.v));
            }
            return {
                createRenderFunction: function(t) {
                    switch(t.ty){
                        case "fl":
                            return s;
                        case "gf":
                            return o;
                        case "gs":
                            return n;
                        case "st":
                            return h;
                        case "sh":
                        case "el":
                        case "rc":
                        case "sr":
                            return a;
                        case "tr":
                            return r;
                        case "no":
                            return i;
                        default:
                            return null;
                    }
                }
            };
        }();
        function SVGShapeElement(t, e, r) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t, e, r), this.prevViewData = [];
        }
        function LetterProps(t, e, r, i, a, s) {
            this.o = t, this.sw = e, this.sc = r, this.fc = i, this.m = a, this.p = s, this._mdf = {
                o: !0,
                sw: !!e,
                sc: !!r,
                fc: !!i,
                m: !0,
                p: !0
            };
        }
        function TextProperty(t, e) {
            this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, e.d && e.d.sid && (e.d = t.globalData.slotManager.getProp(e.d)), this.data = e, this.elem = t, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
                ascent: 0,
                boxWidth: this.defaultBoxWidth,
                f: "",
                fStyle: "",
                fWeight: "",
                fc: "",
                j: "",
                justifyOffset: "",
                l: [],
                lh: 0,
                lineWidths: [],
                ls: "",
                of: "",
                s: "",
                sc: "",
                sw: 0,
                t: 0,
                tr: 0,
                sz: 0,
                ps: null,
                fillColorAnim: !1,
                strokeColorAnim: !1,
                strokeWidthAnim: !1,
                yOffset: 0,
                finalSize: 0,
                finalText: [],
                finalLineHeight: 0,
                __complete: !1
            }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
        }
        extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {}, SVGShapeElement.prototype.identityMatrix = new Matrix, SVGShapeElement.prototype.buildExpressionInterface = function() {}, SVGShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
        }, SVGShapeElement.prototype.filterUniqueShapes = function() {
            var t, e, r, i, a = this.shapes.length, s = this.stylesList.length, n = [], o = !1;
            for(r = 0; r < s; r += 1){
                for(i = this.stylesList[r], o = !1, n.length = 0, t = 0; t < a; t += 1)-1 !== (e = this.shapes[t]).styles.indexOf(i) && (n.push(e), o = e._isAnimated || o);
                n.length > 1 && o && this.setShapesAsAnimated(n);
            }
        }, SVGShapeElement.prototype.setShapesAsAnimated = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)t[e].setAsAnimated();
        }, SVGShapeElement.prototype.createStyleElement = function(t, e) {
            var r, i = new SVGStyleData(t, e), a = i.pElem;
            if ("st" === t.ty) r = new SVGStrokeStyleData(this, t, i);
            else if ("fl" === t.ty) r = new SVGFillStyleData(this, t, i);
            else if ("gf" === t.ty || "gs" === t.ty) r = new ("gf" === t.ty ? SVGGradientFillStyleData : SVGGradientStrokeStyleData)(this, t, i), this.globalData.defs.appendChild(r.gf), r.maskId && (this.globalData.defs.appendChild(r.ms), this.globalData.defs.appendChild(r.of), a.setAttribute("mask", "url(" + getLocationHref() + "#" + r.maskId + ")"));
            else "no" === t.ty && (r = new SVGNoStyleData(this, t, i));
            return "st" !== t.ty && "gs" !== t.ty || (a.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), a.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), a.setAttribute("fill-opacity", "0"), 1 === t.lj && a.setAttribute("stroke-miterlimit", t.ml)), 2 === t.r && a.setAttribute("fill-rule", "evenodd"), t.ln && a.setAttribute("id", t.ln), t.cl && a.setAttribute("class", t.cl), t.bm && (a.style["mix-blend-mode"] = getBlendMode(t.bm)), this.stylesList.push(i), this.addToAnimatedContents(t, r), r;
        }, SVGShapeElement.prototype.createGroupElement = function(t) {
            var e = new ShapeGroupData;
            return t.ln && e.gr.setAttribute("id", t.ln), t.cl && e.gr.setAttribute("class", t.cl), t.bm && (e.gr.style["mix-blend-mode"] = getBlendMode(t.bm)), e;
        }, SVGShapeElement.prototype.createTransformElement = function(t, e) {
            var r = TransformPropertyFactory.getTransformProperty(this, t, this), i = new SVGTransformData(r, r.o, e);
            return this.addToAnimatedContents(t, i), i;
        }, SVGShapeElement.prototype.createShapeElement = function(t, e, r) {
            var i = 4;
            "rc" === t.ty ? i = 5 : "el" === t.ty ? i = 6 : "sr" === t.ty && (i = 7);
            var a = new SVGShapeData(e, r, ShapePropertyFactory.getShapeProp(this, t, i, this));
            return this.shapes.push(a), this.addShapeToModifiers(a), this.addToAnimatedContents(t, a), a;
        }, SVGShapeElement.prototype.addToAnimatedContents = function(t, e) {
            for(var r = 0, i = this.animatedContents.length; r < i;){
                if (this.animatedContents[r].element === e) return;
                r += 1;
            }
            this.animatedContents.push({
                fn: SVGElementsRenderer.createRenderFunction(t),
                element: e,
                data: t
            });
        }, SVGShapeElement.prototype.setElementStyles = function(t) {
            var e, r = t.styles, i = this.stylesList.length;
            for(e = 0; e < i; e += 1)this.stylesList[e].closed || r.push(this.stylesList[e]);
        }, SVGShapeElement.prototype.reloadShapes = function() {
            var t;
            this._isFirstFrame = !0;
            var e = this.itemsData.length;
            for(t = 0; t < e; t += 1)this.prevViewData[t] = this.itemsData[t];
            for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), e = this.dynamicProperties.length, t = 0; t < e; t += 1)this.dynamicProperties[t].getValue();
            this.renderModifiers();
        }, SVGShapeElement.prototype.searchShapes = function(t, e, r, i, a, s, n) {
            var o, h, l, p, f, c, m = [].concat(s), d = t.length - 1, u = [], y = [];
            for(o = d; o >= 0; o -= 1){
                if ((c = this.searchProcessedElement(t[o])) ? e[o] = r[c - 1] : t[o]._render = n, "fl" === t[o].ty || "st" === t[o].ty || "gf" === t[o].ty || "gs" === t[o].ty || "no" === t[o].ty) c ? e[o].style.closed = !1 : e[o] = this.createStyleElement(t[o], a), t[o]._render && e[o].style.pElem.parentNode !== i && i.appendChild(e[o].style.pElem), u.push(e[o].style);
                else if ("gr" === t[o].ty) {
                    if (c) for(l = e[o].it.length, h = 0; h < l; h += 1)e[o].prevViewData[h] = e[o].it[h];
                    else e[o] = this.createGroupElement(t[o]);
                    this.searchShapes(t[o].it, e[o].it, e[o].prevViewData, e[o].gr, a + 1, m, n), t[o]._render && e[o].gr.parentNode !== i && i.appendChild(e[o].gr);
                } else "tr" === t[o].ty ? (c || (e[o] = this.createTransformElement(t[o], i)), p = e[o].transform, m.push(p)) : "sh" === t[o].ty || "rc" === t[o].ty || "el" === t[o].ty || "sr" === t[o].ty ? (c || (e[o] = this.createShapeElement(t[o], m, a)), this.setElementStyles(e[o])) : "tm" === t[o].ty || "rd" === t[o].ty || "ms" === t[o].ty || "pb" === t[o].ty || "zz" === t[o].ty || "op" === t[o].ty ? (c ? (f = e[o]).closed = !1 : ((f = ShapeModifiers.getModifier(t[o].ty)).init(this, t[o]), e[o] = f, this.shapeModifiers.push(f)), y.push(f)) : "rp" === t[o].ty && (c ? (f = e[o]).closed = !0 : (f = ShapeModifiers.getModifier(t[o].ty), e[o] = f, f.init(this, t, o, e), this.shapeModifiers.push(f), n = !1), y.push(f));
                this.addProcessedElement(t[o], o + 1);
            }
            for(d = u.length, o = 0; o < d; o += 1)u[o].closed = !0;
            for(d = y.length, o = 0; o < d; o += 1)y[o].closed = !0;
        }, SVGShapeElement.prototype.renderInnerContent = function() {
            var t;
            this.renderModifiers();
            var e = this.stylesList.length;
            for(t = 0; t < e; t += 1)this.stylesList[t].reset();
            for(this.renderShape(), t = 0; t < e; t += 1)(this.stylesList[t]._mdf || this._isFirstFrame) && (this.stylesList[t].msElem && (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d), this.stylesList[t].d = "M0 0" + this.stylesList[t].d), this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"));
        }, SVGShapeElement.prototype.renderShape = function() {
            var t, e, r = this.animatedContents.length;
            for(t = 0; t < r; t += 1)e = this.animatedContents[t], (this._isFirstFrame || e.element._isAnimated) && !0 !== e.data && e.fn(e.data, e.element, this._isFirstFrame);
        }, SVGShapeElement.prototype.destroy = function() {
            this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
        }, LetterProps.prototype.update = function(t, e, r, i, a, s) {
            this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
            var n = !1;
            return this.o !== t && (this.o = t, this._mdf.o = !0, n = !0), this.sw !== e && (this.sw = e, this._mdf.sw = !0, n = !0), this.sc !== r && (this.sc = r, this._mdf.sc = !0, n = !0), this.fc !== i && (this.fc = i, this._mdf.fc = !0, n = !0), this.m !== a && (this.m = a, this._mdf.m = !0, n = !0), !s.length || this.p[0] === s[0] && this.p[1] === s[1] && this.p[4] === s[4] && this.p[5] === s[5] && this.p[12] === s[12] && this.p[13] === s[13] || (this.p = s, this._mdf.p = !0, n = !0), n;
        }, TextProperty.prototype.defaultBoxWidth = [
            0,
            0
        ], TextProperty.prototype.copyData = function(t, e) {
            for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t;
        }, TextProperty.prototype.setCurrentData = function(t) {
            t.__complete || this.completeTextData(t), this.currentData = t, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
        }, TextProperty.prototype.searchProperty = function() {
            return this.searchKeyframes();
        }, TextProperty.prototype.searchKeyframes = function() {
            return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
        }, TextProperty.prototype.addEffect = function(t) {
            this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.getValue = function(t) {
            if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length || t) {
                this.currentData.t = this.data.d.k[this.keysIndex].s.t;
                var e = this.currentData, r = this.keysIndex;
                if (this.lock) this.setCurrentData(this.currentData);
                else {
                    var i;
                    this.lock = !0, this._mdf = !1;
                    var a = this.effectsSequence.length, s = t || this.data.d.k[this.keysIndex].s;
                    for(i = 0; i < a; i += 1)s = r !== this.keysIndex ? this.effectsSequence[i](s, s.t) : this.effectsSequence[i](this.currentData, s.t);
                    e !== s && this.setCurrentData(s), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                }
            }
        }, TextProperty.prototype.getKeyframeValue = function() {
            for(var t = this.data.d.k, e = this.elem.comp.renderedFrame, r = 0, i = t.length; r <= i - 1 && !(r === i - 1 || t[r + 1].t > e);)r += 1;
            return this.keysIndex !== r && (this.keysIndex = r), this.data.d.k[this.keysIndex].s;
        }, TextProperty.prototype.buildFinalText = function(t) {
            for(var e, r, i = [], a = 0, s = t.length, n = !1, o = !1, h = ""; a < s;)n = o, o = !1, e = t.charCodeAt(a), h = t.charAt(a), FontManager.isCombinedCharacter(e) ? n = !0 : e >= 55296 && e <= 56319 ? FontManager.isRegionalFlag(t, a) ? h = t.substr(a, 14) : (r = t.charCodeAt(a + 1)) >= 56320 && r <= 57343 && (FontManager.isModifier(e, r) ? (h = t.substr(a, 2), n = !0) : h = FontManager.isFlagEmoji(t.substr(a, 4)) ? t.substr(a, 4) : t.substr(a, 2)) : e > 56319 ? (r = t.charCodeAt(a + 1), FontManager.isVariationSelector(e) && (n = !0)) : FontManager.isZeroWidthJoiner(e) && (n = !0, o = !0), n ? (i[i.length - 1] += h, n = !1) : i.push(h), a += h.length;
            return i;
        }, TextProperty.prototype.completeTextData = function(t) {
            t.__complete = !0;
            var e, r, i, a, s, n, o, h = this.elem.globalData.fontManager, l = this.data, p = [], f = 0, c = l.m.g, m = 0, d = 0, u = 0, y = [], g = 0, v = 0, b = h.getFontByName(t.f), x = 0, E = getFontProperties(b);
            t.fWeight = E.weight, t.fStyle = E.style, t.finalSize = t.s, t.finalText = this.buildFinalText(t.t), r = t.finalText.length, t.finalLineHeight = t.lh;
            var S, P = t.tr / 1e3 * t.finalSize;
            if (t.sz) for(var C, _, k = !0, A = t.sz[0], T = t.sz[1]; k;){
                C = 0, g = 0, r = (_ = this.buildFinalText(t.t)).length, P = t.tr / 1e3 * t.finalSize;
                var M = -1;
                for(e = 0; e < r; e += 1)S = _[e].charCodeAt(0), i = !1, " " === _[e] ? M = e : 13 !== S && 3 !== S || (g = 0, i = !0, C += t.finalLineHeight || 1.2 * t.finalSize), h.chars ? (o = h.getCharData(_[e], b.fStyle, b.fFamily), x = i ? 0 : o.w * t.finalSize / 100) : x = h.measureText(_[e], t.f, t.finalSize), g + x > A && " " !== _[e] ? (-1 === M ? r += 1 : e = M, C += t.finalLineHeight || 1.2 * t.finalSize, _.splice(e, M === e ? 1 : 0, "\r"), M = -1, g = 0) : (g += x, g += P);
                C += b.ascent * t.finalSize / 100, this.canResize && t.finalSize > this.minimumFontSize && T < C ? (t.finalSize -= 1, t.finalLineHeight = t.finalSize * t.lh / t.s) : (t.finalText = _, r = t.finalText.length, k = !1);
            }
            g = -P, x = 0;
            var w, D = 0;
            for(e = 0; e < r; e += 1)if (i = !1, 13 === (S = (w = t.finalText[e]).charCodeAt(0)) || 3 === S ? (D = 0, y.push(g), v = g > v ? g : v, g = -2 * P, a = "", i = !0, u += 1) : a = w, h.chars ? (o = h.getCharData(w, b.fStyle, h.getFontByName(t.f).fFamily), x = i ? 0 : o.w * t.finalSize / 100) : x = h.measureText(a, t.f, t.finalSize), " " === w ? D += x + P : (g += x + P + D, D = 0), p.push({
                l: x,
                an: x,
                add: m,
                n: i,
                anIndexes: [],
                val: a,
                line: u,
                animatorJustifyOffset: 0
            }), 2 == c) {
                if (m += x, "" === a || " " === a || e === r - 1) {
                    for("" !== a && " " !== a || (m -= x); d <= e;)p[d].an = m, p[d].ind = f, p[d].extra = x, d += 1;
                    f += 1, m = 0;
                }
            } else if (3 == c) {
                if (m += x, "" === a || e === r - 1) {
                    for("" === a && (m -= x); d <= e;)p[d].an = m, p[d].ind = f, p[d].extra = x, d += 1;
                    m = 0, f += 1;
                }
            } else p[f].ind = f, p[f].extra = 0, f += 1;
            if (t.l = p, v = g > v ? g : v, y.push(g), t.sz) t.boxWidth = t.sz[0], t.justifyOffset = 0;
            else switch(t.boxWidth = v, t.j){
                case 1:
                    t.justifyOffset = -t.boxWidth;
                    break;
                case 2:
                    t.justifyOffset = -t.boxWidth / 2;
                    break;
                default:
                    t.justifyOffset = 0;
            }
            t.lineWidths = y;
            var F, I, R, V, B = l.a;
            n = B.length;
            var L = [];
            for(s = 0; s < n; s += 1){
                for((F = B[s]).a.sc && (t.strokeColorAnim = !0), F.a.sw && (t.strokeWidthAnim = !0), (F.a.fc || F.a.fh || F.a.fs || F.a.fb) && (t.fillColorAnim = !0), V = 0, R = F.s.b, e = 0; e < r; e += 1)(I = p[e]).anIndexes[s] = V, (1 == R && "" !== I.val || 2 == R && "" !== I.val && " " !== I.val || 3 == R && (I.n || " " == I.val || e == r - 1) || 4 == R && (I.n || e == r - 1)) && (1 === F.s.rn && L.push(V), V += 1);
                l.a[s].s.totalChars = V;
                var z, G = -1;
                if (1 === F.s.rn) for(e = 0; e < r; e += 1)G != (I = p[e]).anIndexes[s] && (G = I.anIndexes[s], z = L.splice(Math.floor(Math.random() * L.length), 1)[0]), I.anIndexes[s] = z;
            }
            t.yOffset = t.finalLineHeight || 1.2 * t.finalSize, t.ls = t.ls || 0, t.ascent = b.ascent * t.finalSize / 100;
        }, TextProperty.prototype.updateDocumentData = function(t, e) {
            e = void 0 === e ? this.keysIndex : e;
            var r = this.copyData({}, this.data.d.k[e].s);
            r = this.copyData(r, t), this.data.d.k[e].s = r, this.recalculate(e), this.setCurrentData(r), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.recalculate = function(t) {
            var e = this.data.d.k[t].s;
            e.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(e);
        }, TextProperty.prototype.canResizeFont = function(t) {
            this.canResize = t, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.setMinimumFontSize = function(t) {
            this.minimumFontSize = Math.floor(t) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
        };
        var TextSelectorProp = function() {
            var t = Math.max, e = Math.min, r = Math.floor;
            function i(t, e) {
                this._currentTextLength = -1, this.k = !1, this.data = e, this.elem = t, this.comp = t.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(t), this.s = PropertyFactory.getProp(t, e.s || {
                    k: 0
                }, 0, 0, this), this.e = "e" in e ? PropertyFactory.getProp(t, e.e, 0, 0, this) : {
                    v: 100
                }, this.o = PropertyFactory.getProp(t, e.o || {
                    k: 0
                }, 0, 0, this), this.xe = PropertyFactory.getProp(t, e.xe || {
                    k: 0
                }, 0, 0, this), this.ne = PropertyFactory.getProp(t, e.ne || {
                    k: 0
                }, 0, 0, this), this.sm = PropertyFactory.getProp(t, e.sm || {
                    k: 100
                }, 0, 0, this), this.a = PropertyFactory.getProp(t, e.a, 0, .01, this), this.dynamicProperties.length || this.getValue();
            }
            return i.prototype = {
                getMult: function(i) {
                    this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
                    var a = 0, s = 0, n = 1, o = 1;
                    this.ne.v > 0 ? a = this.ne.v / 100 : s = -this.ne.v / 100, this.xe.v > 0 ? n = 1 - this.xe.v / 100 : o = 1 + this.xe.v / 100;
                    var h = BezierFactory.getBezierEasing(a, s, n, o).get, l = 0, p = this.finalS, f = this.finalE, c = this.data.sh;
                    if (2 === c) l = h(l = f === p ? i >= f ? 1 : 0 : t(0, e(.5 / (f - p) + (i - p) / (f - p), 1)));
                    else if (3 === c) l = h(l = f === p ? i >= f ? 0 : 1 : 1 - t(0, e(.5 / (f - p) + (i - p) / (f - p), 1)));
                    else if (4 === c) f === p ? l = 0 : (l = t(0, e(.5 / (f - p) + (i - p) / (f - p), 1))) < .5 ? l *= 2 : l = 1 - 2 * (l - .5), l = h(l);
                    else if (5 === c) {
                        if (f === p) l = 0;
                        else {
                            var m = f - p, d = -m / 2 + (i = e(t(0, i + .5 - p), f - p)), u = m / 2;
                            l = Math.sqrt(1 - d * d / (u * u));
                        }
                        l = h(l);
                    } else 6 === c ? (f === p ? l = 0 : (i = e(t(0, i + .5 - p), f - p), l = (1 + Math.cos(Math.PI + 2 * Math.PI * i / (f - p))) / 2), l = h(l)) : (i >= r(p) && (l = t(0, e(i - p < 0 ? e(f, 1) - (p - i) : f - i, 1))), l = h(l));
                    if (100 !== this.sm.v) {
                        var y = .01 * this.sm.v;
                        0 === y && (y = 1e-8);
                        var g = .5 - .5 * y;
                        l < g ? l = 0 : (l = (l - g) / y) > 1 && (l = 1);
                    }
                    return l * this.a.v;
                },
                getValue: function(t) {
                    this.iterateDynamicProperties(), this._mdf = t || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, t && 2 === this.data.r && (this.e.v = this._currentTextLength);
                    var e = 2 === this.data.r ? 1 : 100 / this.data.totalChars, r = this.o.v / e, i = this.s.v / e + r, a = this.e.v / e + r;
                    if (i > a) {
                        var s = i;
                        i = a, a = s;
                    }
                    this.finalS = i, this.finalE = a;
                }
            }, extendPrototype([
                DynamicPropertyContainer
            ], i), {
                getTextSelectorProp: function(t, e, r) {
                    return new i(t, e, r);
                }
            };
        }();
        function TextAnimatorDataProperty(t, e, r) {
            var i = {
                propType: !1
            }, a = PropertyFactory.getProp, s = e.a;
            this.a = {
                r: s.r ? a(t, s.r, 0, degToRads, r) : i,
                rx: s.rx ? a(t, s.rx, 0, degToRads, r) : i,
                ry: s.ry ? a(t, s.ry, 0, degToRads, r) : i,
                sk: s.sk ? a(t, s.sk, 0, degToRads, r) : i,
                sa: s.sa ? a(t, s.sa, 0, degToRads, r) : i,
                s: s.s ? a(t, s.s, 1, .01, r) : i,
                a: s.a ? a(t, s.a, 1, 0, r) : i,
                o: s.o ? a(t, s.o, 0, .01, r) : i,
                p: s.p ? a(t, s.p, 1, 0, r) : i,
                sw: s.sw ? a(t, s.sw, 0, 0, r) : i,
                sc: s.sc ? a(t, s.sc, 1, 0, r) : i,
                fc: s.fc ? a(t, s.fc, 1, 0, r) : i,
                fh: s.fh ? a(t, s.fh, 0, 0, r) : i,
                fs: s.fs ? a(t, s.fs, 0, .01, r) : i,
                fb: s.fb ? a(t, s.fb, 0, .01, r) : i,
                t: s.t ? a(t, s.t, 0, 0, r) : i
            }, this.s = TextSelectorProp.getTextSelectorProp(t, e.s, r), this.s.t = e.s.t;
        }
        function TextAnimatorProperty(t, e, r) {
            this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t, this._renderType = e, this._elem = r, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
                alignment: {}
            }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(r);
        }
        function ITextElement() {}
        TextAnimatorProperty.prototype.searchProperties = function() {
            var t, e, r = this._textData.a.length, i = PropertyFactory.getProp;
            for(t = 0; t < r; t += 1)e = this._textData.a[t], this._animatorsData[t] = new TextAnimatorDataProperty(this._elem, e, this);
            this._textData.p && "m" in this._textData.p ? (this._pathData = {
                a: i(this._elem, this._textData.p.a, 0, 0, this),
                f: i(this._elem, this._textData.p.f, 0, 0, this),
                l: i(this._elem, this._textData.p.l, 0, 0, this),
                r: i(this._elem, this._textData.p.r, 0, 0, this),
                p: i(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = i(this._elem, this._textData.m.a, 1, 0, this);
        }, TextAnimatorProperty.prototype.getMeasures = function(t, e) {
            if (this.lettersChangedFlag = e, this._mdf || this._isFirstFrame || e || this._hasMaskedPath && this._pathData.m._mdf) {
                this._isFirstFrame = !1;
                var r, i, a, s, n, o, h, l, p, f, c, m, d, u, y, g, v, b, x, E = this._moreOptions.alignment.v, S = this._animatorsData, P = this._textData, C = this.mHelper, _ = this._renderType, k = this.renderedLetters.length, A = t.l;
                if (this._hasMaskedPath) {
                    if (x = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
                        var T, M = x.v;
                        for(this._pathData.r.v && (M = M.reverse()), n = {
                            tLength: 0,
                            segments: []
                        }, s = M._length - 1, g = 0, a = 0; a < s; a += 1)T = bez.buildBezierData(M.v[a], M.v[a + 1], [
                            M.o[a][0] - M.v[a][0],
                            M.o[a][1] - M.v[a][1]
                        ], [
                            M.i[a + 1][0] - M.v[a + 1][0],
                            M.i[a + 1][1] - M.v[a + 1][1]
                        ]), n.tLength += T.segmentLength, n.segments.push(T), g += T.segmentLength;
                        a = s, x.v.c && (T = bez.buildBezierData(M.v[a], M.v[0], [
                            M.o[a][0] - M.v[a][0],
                            M.o[a][1] - M.v[a][1]
                        ], [
                            M.i[0][0] - M.v[0][0],
                            M.i[0][1] - M.v[0][1]
                        ]), n.tLength += T.segmentLength, n.segments.push(T), g += T.segmentLength), this._pathData.pi = n;
                    }
                    if (n = this._pathData.pi, o = this._pathData.f.v, c = 0, f = 1, l = 0, p = !0, u = n.segments, o < 0 && x.v.c) for(n.tLength < Math.abs(o) && (o = -Math.abs(o) % n.tLength), f = (d = u[c = u.length - 1].points).length - 1; o < 0;)o += d[f].partialLength, (f -= 1) < 0 && (f = (d = u[c -= 1].points).length - 1);
                    m = (d = u[c].points)[f - 1], y = (h = d[f]).partialLength;
                }
                s = A.length, r = 0, i = 0;
                var w, D, F, I, R, V = 1.2 * t.finalSize * .714, B = !0;
                F = S.length;
                var L, z, G, O, N, H, j, q, W, $, Y, J, X = -1, Z = o, K = c, U = f, Q = -1, tt = "", et = this.defaultPropsArray;
                if (2 === t.j || 1 === t.j) {
                    var rt = 0, it = 0, at = 2 === t.j ? -0.5 : -1, st = 0, nt = !0;
                    for(a = 0; a < s; a += 1)if (A[a].n) {
                        for(rt && (rt += it); st < a;)A[st].animatorJustifyOffset = rt, st += 1;
                        rt = 0, nt = !0;
                    } else {
                        for(D = 0; D < F; D += 1)(w = S[D].a).t.propType && (nt && 2 === t.j && (it += w.t.v * at), (R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars)).length ? rt += w.t.v * R[0] * at : rt += w.t.v * R * at);
                        nt = !1;
                    }
                    for(rt && (rt += it); st < a;)A[st].animatorJustifyOffset = rt, st += 1;
                }
                for(a = 0; a < s; a += 1){
                    if (C.reset(), O = 1, A[a].n) r = 0, i += t.yOffset, i += B ? 1 : 0, o = Z, B = !1, this._hasMaskedPath && (f = U, m = (d = u[c = K].points)[f - 1], y = (h = d[f]).partialLength, l = 0), tt = "", Y = "", W = "", J = "", et = this.defaultPropsArray;
                    else {
                        if (this._hasMaskedPath) {
                            if (Q !== A[a].line) {
                                switch(t.j){
                                    case 1:
                                        o += g - t.lineWidths[A[a].line];
                                        break;
                                    case 2:
                                        o += (g - t.lineWidths[A[a].line]) / 2;
                                }
                                Q = A[a].line;
                            }
                            X !== A[a].ind && (A[X] && (o += A[X].extra), o += A[a].an / 2, X = A[a].ind), o += E[0] * A[a].an * .005;
                            var ot = 0;
                            for(D = 0; D < F; D += 1)(w = S[D].a).p.propType && ((R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars)).length ? ot += w.p.v[0] * R[0] : ot += w.p.v[0] * R), w.a.propType && ((R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars)).length ? ot += w.a.v[0] * R[0] : ot += w.a.v[0] * R);
                            for(p = !0, this._pathData.a.v && (o = .5 * A[0].an + (g - this._pathData.f.v - .5 * A[0].an - .5 * A[A.length - 1].an) * X / (s - 1), o += this._pathData.f.v); p;)l + y >= o + ot || !d ? (v = (o + ot - l) / h.partialLength, z = m.point[0] + (h.point[0] - m.point[0]) * v, G = m.point[1] + (h.point[1] - m.point[1]) * v, C.translate(-E[0] * A[a].an * .005, -E[1] * V * .01), p = !1) : d && (l += h.partialLength, (f += 1) >= d.length && (f = 0, u[c += 1] ? d = u[c].points : x.v.c ? (f = 0, d = u[c = 0].points) : (l -= h.partialLength, d = null)), d && (m = h, y = (h = d[f]).partialLength));
                            L = A[a].an / 2 - A[a].add, C.translate(-L, 0, 0);
                        } else L = A[a].an / 2 - A[a].add, C.translate(-L, 0, 0), C.translate(-E[0] * A[a].an * .005, -E[1] * V * .01, 0);
                        for(D = 0; D < F; D += 1)(w = S[D].a).t.propType && (R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars), 0 === r && 0 === t.j || (this._hasMaskedPath ? R.length ? o += w.t.v * R[0] : o += w.t.v * R : R.length ? r += w.t.v * R[0] : r += w.t.v * R));
                        for(t.strokeWidthAnim && (H = t.sw || 0), t.strokeColorAnim && (N = t.sc ? [
                            t.sc[0],
                            t.sc[1],
                            t.sc[2]
                        ] : [
                            0,
                            0,
                            0
                        ]), t.fillColorAnim && t.fc && (j = [
                            t.fc[0],
                            t.fc[1],
                            t.fc[2]
                        ]), D = 0; D < F; D += 1)(w = S[D].a).a.propType && ((R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars)).length ? C.translate(-w.a.v[0] * R[0], -w.a.v[1] * R[1], w.a.v[2] * R[2]) : C.translate(-w.a.v[0] * R, -w.a.v[1] * R, w.a.v[2] * R));
                        for(D = 0; D < F; D += 1)(w = S[D].a).s.propType && ((R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars)).length ? C.scale(1 + (w.s.v[0] - 1) * R[0], 1 + (w.s.v[1] - 1) * R[1], 1) : C.scale(1 + (w.s.v[0] - 1) * R, 1 + (w.s.v[1] - 1) * R, 1));
                        for(D = 0; D < F; D += 1){
                            if (w = S[D].a, R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars), w.sk.propType && (R.length ? C.skewFromAxis(-w.sk.v * R[0], w.sa.v * R[1]) : C.skewFromAxis(-w.sk.v * R, w.sa.v * R)), w.r.propType && (R.length ? C.rotateZ(-w.r.v * R[2]) : C.rotateZ(-w.r.v * R)), w.ry.propType && (R.length ? C.rotateY(w.ry.v * R[1]) : C.rotateY(w.ry.v * R)), w.rx.propType && (R.length ? C.rotateX(w.rx.v * R[0]) : C.rotateX(w.rx.v * R)), w.o.propType && (R.length ? O += (w.o.v * R[0] - O) * R[0] : O += (w.o.v * R - O) * R), t.strokeWidthAnim && w.sw.propType && (R.length ? H += w.sw.v * R[0] : H += w.sw.v * R), t.strokeColorAnim && w.sc.propType) for(q = 0; q < 3; q += 1)R.length ? N[q] += (w.sc.v[q] - N[q]) * R[0] : N[q] += (w.sc.v[q] - N[q]) * R;
                            if (t.fillColorAnim && t.fc) {
                                if (w.fc.propType) for(q = 0; q < 3; q += 1)R.length ? j[q] += (w.fc.v[q] - j[q]) * R[0] : j[q] += (w.fc.v[q] - j[q]) * R;
                                w.fh.propType && (j = R.length ? addHueToRGB(j, w.fh.v * R[0]) : addHueToRGB(j, w.fh.v * R)), w.fs.propType && (j = R.length ? addSaturationToRGB(j, w.fs.v * R[0]) : addSaturationToRGB(j, w.fs.v * R)), w.fb.propType && (j = R.length ? addBrightnessToRGB(j, w.fb.v * R[0]) : addBrightnessToRGB(j, w.fb.v * R));
                            }
                        }
                        for(D = 0; D < F; D += 1)(w = S[D].a).p.propType && (R = S[D].s.getMult(A[a].anIndexes[D], P.a[D].s.totalChars), this._hasMaskedPath ? R.length ? C.translate(0, w.p.v[1] * R[0], -w.p.v[2] * R[1]) : C.translate(0, w.p.v[1] * R, -w.p.v[2] * R) : R.length ? C.translate(w.p.v[0] * R[0], w.p.v[1] * R[1], -w.p.v[2] * R[2]) : C.translate(w.p.v[0] * R, w.p.v[1] * R, -w.p.v[2] * R));
                        if (t.strokeWidthAnim && (W = H < 0 ? 0 : H), t.strokeColorAnim && ($ = "rgb(" + Math.round(255 * N[0]) + "," + Math.round(255 * N[1]) + "," + Math.round(255 * N[2]) + ")"), t.fillColorAnim && t.fc && (Y = "rgb(" + Math.round(255 * j[0]) + "," + Math.round(255 * j[1]) + "," + Math.round(255 * j[2]) + ")"), this._hasMaskedPath) {
                            if (C.translate(0, -t.ls), C.translate(0, E[1] * V * .01 + i, 0), this._pathData.p.v) {
                                b = (h.point[1] - m.point[1]) / (h.point[0] - m.point[0]);
                                var ht = 180 * Math.atan(b) / Math.PI;
                                h.point[0] < m.point[0] && (ht += 180), C.rotate(-ht * Math.PI / 180);
                            }
                            C.translate(z, G, 0), o -= E[0] * A[a].an * .005, A[a + 1] && X !== A[a + 1].ind && (o += A[a].an / 2, o += .001 * t.tr * t.finalSize);
                        } else {
                            switch(C.translate(r, i, 0), t.ps && C.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j){
                                case 1:
                                    C.translate(A[a].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[A[a].line]), 0, 0);
                                    break;
                                case 2:
                                    C.translate(A[a].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[A[a].line]) / 2, 0, 0);
                            }
                            C.translate(0, -t.ls), C.translate(L, 0, 0), C.translate(E[0] * A[a].an * .005, E[1] * V * .01, 0), r += A[a].l + .001 * t.tr * t.finalSize;
                        }
                        "html" === _ ? tt = C.toCSS() : "svg" === _ ? tt = C.to2dCSS() : et = [
                            C.props[0],
                            C.props[1],
                            C.props[2],
                            C.props[3],
                            C.props[4],
                            C.props[5],
                            C.props[6],
                            C.props[7],
                            C.props[8],
                            C.props[9],
                            C.props[10],
                            C.props[11],
                            C.props[12],
                            C.props[13],
                            C.props[14],
                            C.props[15]
                        ], J = O;
                    }
                    k <= a ? (I = new LetterProps(J, W, $, Y, tt, et), this.renderedLetters.push(I), k += 1, this.lettersChangedFlag = !0) : (I = this.renderedLetters[a], this.lettersChangedFlag = I.update(J, W, $, Y, tt, et) || this.lettersChangedFlag);
                }
            }
        }, TextAnimatorProperty.prototype.getValue = function() {
            this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
        }, TextAnimatorProperty.prototype.mHelper = new Matrix, TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([
            DynamicPropertyContainer
        ], TextAnimatorProperty), ITextElement.prototype.initElement = function(t, e, r) {
            this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t, e, r), this.textProperty = new TextProperty(this, t.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(t.t, this.renderType, this), this.initTransform(t, e, r), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
        }, ITextElement.prototype.prepareFrame = function(t) {
            this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
        }, ITextElement.prototype.createPathShape = function(t, e) {
            var r, i, a = e.length, s = "";
            for(r = 0; r < a; r += 1)"sh" === e[r].ty && (i = e[r].ks.k, s += buildShapeString(i, i.i.length, !0, t));
            return s;
        }, ITextElement.prototype.updateDocumentData = function(t, e) {
            this.textProperty.updateDocumentData(t, e);
        }, ITextElement.prototype.canResizeFont = function(t) {
            this.textProperty.canResizeFont(t);
        }, ITextElement.prototype.setMinimumFontSize = function(t) {
            this.textProperty.setMinimumFontSize(t);
        }, ITextElement.prototype.applyTextPropertiesToMatrix = function(t, e, r, i, a) {
            switch(t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0), e.translate(0, -t.ls, 0), t.j){
                case 1:
                    e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]), 0, 0);
                    break;
                case 2:
                    e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]) / 2, 0, 0);
            }
            e.translate(i, a, 0);
        }, ITextElement.prototype.buildColor = function(t) {
            return "rgb(" + Math.round(255 * t[0]) + "," + Math.round(255 * t[1]) + "," + Math.round(255 * t[2]) + ")";
        }, ITextElement.prototype.emptyProp = new LetterProps, ITextElement.prototype.destroy = function() {}, ITextElement.prototype.validateText = function() {
            (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
        };
        var emptyShapeData = {
            shapes: []
        };
        function SVGTextLottieElement(t, e, r) {
            this.textSpans = [], this.renderType = "svg", this.initElement(t, e, r);
        }
        function ISolidElement(t, e, r) {
            this.initElement(t, e, r);
        }
        function NullElement(t, e, r) {
            this.initFrame(), this.initBaseData(t, e, r), this.initFrame(), this.initTransform(t, e, r), this.initHierarchy();
        }
        function SVGRendererBase() {}
        function ICompElement() {}
        function SVGCompElement(t, e, r) {
            this.layers = t.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, e, r), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function SVGRenderer(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
            var r = "";
            if (e && e.title) {
                var i = createNS("title"), a = createElementID();
                i.setAttribute("id", a), i.textContent = e.title, this.svgElement.appendChild(i), r += a;
            }
            if (e && e.description) {
                var s = createNS("desc"), n = createElementID();
                s.setAttribute("id", n), s.textContent = e.description, this.svgElement.appendChild(s), r += " " + n;
            }
            r && this.svgElement.setAttribute("aria-labelledby", r);
            var o = createNS("defs");
            this.svgElement.appendChild(o);
            var h = createNS("g");
            this.svgElement.appendChild(h), this.layerElement = h, this.renderConfig = {
                preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e && e.contentVisibility || "visible",
                progressiveLoad: e && e.progressiveLoad || !1,
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                viewBoxOnly: e && e.viewBoxOnly || !1,
                viewBoxSize: e && e.viewBoxSize || !1,
                className: e && e.className || "",
                id: e && e.id || "",
                focusable: e && e.focusable,
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "100%",
                    height: e && e.filterSize && e.filterSize.height || "100%",
                    x: e && e.filterSize && e.filterSize.x || "0%",
                    y: e && e.filterSize && e.filterSize.y || "0%"
                },
                width: e && e.width,
                height: e && e.height,
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                defs: o,
                renderConfig: this.renderConfig
            }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
        }
        function ShapeTransformManager() {
            this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
        }
        extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement
        ], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
            this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
        }, SVGTextLottieElement.prototype.buildTextContents = function(t) {
            for(var e = 0, r = t.length, i = [], a = ""; e < r;)t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3) ? (i.push(a), a = "") : a += t[e], e += 1;
            return i.push(a), i;
        }, SVGTextLottieElement.prototype.buildShapeData = function(t, e) {
            if (t.shapes && t.shapes.length) {
                var r = t.shapes[0];
                if (r.it) {
                    var i = r.it[r.it.length - 1];
                    i.s && (i.s.k[0] = e, i.s.k[1] = e);
                }
            }
            return t;
        }, SVGTextLottieElement.prototype.buildNewText = function() {
            var t, e;
            this.addDynamicProperty(this);
            var r = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(r ? r.l.length : 0), r.fc ? this.layerElement.setAttribute("fill", this.buildColor(r.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), r.sc && (this.layerElement.setAttribute("stroke", this.buildColor(r.sc)), this.layerElement.setAttribute("stroke-width", r.sw)), this.layerElement.setAttribute("font-size", r.finalSize);
            var i = this.globalData.fontManager.getFontByName(r.f);
            if (i.fClass) this.layerElement.setAttribute("class", i.fClass);
            else {
                this.layerElement.setAttribute("font-family", i.fFamily);
                var a = r.fWeight, s = r.fStyle;
                this.layerElement.setAttribute("font-style", s), this.layerElement.setAttribute("font-weight", a);
            }
            this.layerElement.setAttribute("aria-label", r.t);
            var n, o = r.l || [], h = !!this.globalData.fontManager.chars;
            e = o.length;
            var l = this.mHelper, p = this.data.singleShape, f = 0, c = 0, m = !0, d = .001 * r.tr * r.finalSize;
            if (!p || h || r.sz) {
                var u, y = this.textSpans.length;
                for(t = 0; t < e; t += 1){
                    if (this.textSpans[t] || (this.textSpans[t] = {
                        span: null,
                        childSpan: null,
                        glyph: null
                    }), !h || !p || 0 === t) {
                        if (n = y > t ? this.textSpans[t].span : createNS(h ? "g" : "text"), y <= t) {
                            if (n.setAttribute("stroke-linecap", "butt"), n.setAttribute("stroke-linejoin", "round"), n.setAttribute("stroke-miterlimit", "4"), this.textSpans[t].span = n, h) {
                                var g = createNS("g");
                                n.appendChild(g), this.textSpans[t].childSpan = g;
                            }
                            this.textSpans[t].span = n, this.layerElement.appendChild(n);
                        }
                        n.style.display = "inherit";
                    }
                    if (l.reset(), p && (o[t].n && (f = -d, c += r.yOffset, c += m ? 1 : 0, m = !1), this.applyTextPropertiesToMatrix(r, l, o[t].line, f, c), f += o[t].l || 0, f += d), h) {
                        var v;
                        if (1 === (u = this.globalData.fontManager.getCharData(r.finalText[t], i.fStyle, this.globalData.fontManager.getFontByName(r.f).fFamily)).t) v = new SVGCompElement(u.data, this.globalData, this);
                        else {
                            var b = emptyShapeData;
                            u.data && u.data.shapes && (b = this.buildShapeData(u.data, r.finalSize)), v = new SVGShapeElement(b, this.globalData, this);
                        }
                        if (this.textSpans[t].glyph) {
                            var x = this.textSpans[t].glyph;
                            this.textSpans[t].childSpan.removeChild(x.layerElement), x.destroy();
                        }
                        this.textSpans[t].glyph = v, v._debug = !0, v.prepareFrame(0), v.renderFrame(), this.textSpans[t].childSpan.appendChild(v.layerElement), 1 === u.t && this.textSpans[t].childSpan.setAttribute("transform", "scale(" + r.finalSize / 100 + "," + r.finalSize / 100 + ")");
                    } else p && n.setAttribute("transform", "translate(" + l.props[12] + "," + l.props[13] + ")"), n.textContent = o[t].val, n.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                }
                p && n && n.setAttribute("d", "");
            } else {
                var E = this.textContainer, S = "start";
                switch(r.j){
                    case 1:
                        S = "end";
                        break;
                    case 2:
                        S = "middle";
                        break;
                    default:
                        S = "start";
                }
                E.setAttribute("text-anchor", S), E.setAttribute("letter-spacing", d);
                var P = this.buildTextContents(r.finalText);
                for(e = P.length, c = r.ps ? r.ps[1] + r.ascent : 0, t = 0; t < e; t += 1)(n = this.textSpans[t].span || createNS("tspan")).textContent = P[t], n.setAttribute("x", 0), n.setAttribute("y", c), n.style.display = "inherit", E.appendChild(n), this.textSpans[t] || (this.textSpans[t] = {
                    span: null,
                    glyph: null
                }), this.textSpans[t].span = n, c += r.finalLineHeight;
                this.layerElement.appendChild(E);
            }
            for(; t < this.textSpans.length;)this.textSpans[t].span.style.display = "none", t += 1;
            this._sizeChanged = !0;
        }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
            if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
                this._sizeChanged = !1;
                var t = this.layerElement.getBBox();
                this.bbox = {
                    top: t.y,
                    left: t.x,
                    width: t.width,
                    height: t.height
                };
            }
            return this.bbox;
        }, SVGTextLottieElement.prototype.getValue = function() {
            var t, e, r = this.textSpans.length;
            for(this.renderedFrame = this.comp.renderedFrame, t = 0; t < r; t += 1)(e = this.textSpans[t].glyph) && (e.prepareFrame(this.comp.renderedFrame - this.data.st), e._mdf && (this._mdf = !0));
        }, SVGTextLottieElement.prototype.renderInnerContent = function() {
            if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
                var t, e;
                this._sizeChanged = !0;
                var r, i, a, s = this.textAnimator.renderedLetters, n = this.textProperty.currentData.l;
                for(e = n.length, t = 0; t < e; t += 1)n[t].n || (r = s[t], i = this.textSpans[t].span, (a = this.textSpans[t].glyph) && a.renderFrame(), r._mdf.m && i.setAttribute("transform", r.m), r._mdf.o && i.setAttribute("opacity", r.o), r._mdf.sw && i.setAttribute("stroke-width", r.sw), r._mdf.sc && i.setAttribute("stroke", r.sc), r._mdf.fc && i.setAttribute("fill", r.fc));
            }
        }, extendPrototype([
            IImageElement
        ], ISolidElement), ISolidElement.prototype.createContent = function() {
            var t = createNS("rect");
            t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t);
        }, NullElement.prototype.prepareFrame = function(t) {
            this.prepareProperties(t, !0);
        }, NullElement.prototype.renderFrame = function() {}, NullElement.prototype.getBaseElement = function() {
            return null;
        }, NullElement.prototype.destroy = function() {}, NullElement.prototype.sourceRectAtTime = function() {}, NullElement.prototype.hide = function() {}, extendPrototype([
            BaseElement,
            TransformElement,
            HierarchyElement,
            FrameElement
        ], NullElement), extendPrototype([
            BaseRenderer
        ], SVGRendererBase), SVGRendererBase.prototype.createNull = function(t) {
            return new NullElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createShape = function(t) {
            return new SVGShapeElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createText = function(t) {
            return new SVGTextLottieElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createImage = function(t) {
            return new IImageElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createSolid = function(t) {
            return new ISolidElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.configAnimation = function(t) {
            this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t.w), this.svgElement.setAttribute("height", t.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), void 0 !== this.renderConfig.focusable && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
            var e = this.globalData.defs;
            this.setupGlobalData(t, e), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t;
            var r = createNS("clipPath"), i = createNS("rect");
            i.setAttribute("width", t.w), i.setAttribute("height", t.h), i.setAttribute("x", 0), i.setAttribute("y", 0);
            var a = createElementID();
            r.setAttribute("id", a), r.appendChild(i), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")"), e.appendChild(r), this.layers = t.layers, this.elements = createSizedArray(t.layers.length);
        }, SVGRendererBase.prototype.destroy = function() {
            var t;
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
            var e = this.layers ? this.layers.length : 0;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
        }, SVGRendererBase.prototype.updateContainerSize = function() {}, SVGRendererBase.prototype.findIndexByInd = function(t) {
            var e = 0, r = this.layers.length;
            for(e = 0; e < r; e += 1)if (this.layers[e].ind === t) return e;
            return -1;
        }, SVGRendererBase.prototype.buildItem = function(t) {
            var e = this.elements;
            if (!e[t] && 99 !== this.layers[t].ty) {
                e[t] = !0;
                var r = this.createItem(this.layers[t]);
                if (e[t] = r, getExpressionsPlugin() && (0 === this.layers[t].ty && this.globalData.projectInterface.registerComposition(r), r.initExpressions()), this.appendElementInPos(r, t), this.layers[t].tt) {
                    var i = "tp" in this.layers[t] ? this.findIndexByInd(this.layers[t].tp) : t - 1;
                    if (-1 === i) return;
                    if (this.elements[i] && !0 !== this.elements[i]) {
                        var a = e[i].getMatte(this.layers[t].tt);
                        r.setMatte(a);
                    } else this.buildItem(i), this.addPendingElement(r);
                }
            }
        }, SVGRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;){
                var t = this.pendingElements.pop();
                if (t.checkParenting(), t.data.tt) for(var e = 0, r = this.elements.length; e < r;){
                    if (this.elements[e] === t) {
                        var i = "tp" in t.data ? this.findIndexByInd(t.data.tp) : e - 1, a = this.elements[i].getMatte(this.layers[e].tt);
                        t.setMatte(a);
                        break;
                    }
                    e += 1;
                }
            }
        }, SVGRendererBase.prototype.renderFrame = function(t) {
            if (this.renderedFrame !== t && !this.destroyed) {
                var e;
                null === t ? t = this.renderedFrame : this.renderedFrame = t, this.globalData.frameNum = t, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t, this.globalData._mdf = !1;
                var r = this.layers.length;
                for(this.completeLayers || this.checkLayers(t), e = r - 1; e >= 0; e -= 1)(this.completeLayers || this.elements[e]) && this.elements[e].prepareFrame(t - this.layers[e].st);
                if (this.globalData._mdf) for(e = 0; e < r; e += 1)(this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
            }
        }, SVGRendererBase.prototype.appendElementInPos = function(t, e) {
            var r = t.getBaseElement();
            if (r) {
                for(var i, a = 0; a < e;)this.elements[a] && !0 !== this.elements[a] && this.elements[a].getBaseElement() && (i = this.elements[a].getBaseElement()), a += 1;
                i ? this.layerElement.insertBefore(r, i) : this.layerElement.appendChild(r);
            }
        }, SVGRendererBase.prototype.hide = function() {
            this.layerElement.style.display = "none";
        }, SVGRendererBase.prototype.show = function() {
            this.layerElement.style.display = "block";
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], ICompElement), ICompElement.prototype.initElement = function(t, e, r) {
            this.initFrame(), this.initBaseData(t, e, r), this.initTransform(t, e, r), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !this.data.xt && e.progressiveLoad || this.buildAllItems(), this.hide();
        }, ICompElement.prototype.prepareFrame = function(t) {
            if (this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.isInRange || this.data.xt) {
                if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;
                else {
                    var e = this.tm.v;
                    e === this.data.op && (e = this.data.op - 1), this.renderedFrame = e;
                }
                var r, i = this.elements.length;
                for(this.completeLayers || this.checkLayers(this.renderedFrame), r = i - 1; r >= 0; r -= 1)(this.completeLayers || this.elements[r]) && (this.elements[r].prepareFrame(this.renderedFrame - this.layers[r].st), this.elements[r]._mdf && (this._mdf = !0));
            }
        }, ICompElement.prototype.renderInnerContent = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)(this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
        }, ICompElement.prototype.setElements = function(t) {
            this.elements = t;
        }, ICompElement.prototype.getElements = function() {
            return this.elements;
        }, ICompElement.prototype.destroyElements = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy();
        }, ICompElement.prototype.destroy = function() {
            this.destroyElements(), this.destroyBaseElement();
        }, extendPrototype([
            SVGRendererBase,
            ICompElement,
            SVGBaseElement
        ], SVGCompElement), SVGCompElement.prototype.createComp = function(t) {
            return new SVGCompElement(t, this.globalData, this);
        }, extendPrototype([
            SVGRendererBase
        ], SVGRenderer), SVGRenderer.prototype.createComp = function(t) {
            return new SVGCompElement(t, this.globalData, this);
        }, ShapeTransformManager.prototype = {
            addTransformSequence: function(t) {
                var e, r = t.length, i = "_";
                for(e = 0; e < r; e += 1)i += t[e].transform.key + "_";
                var a = this.sequences[i];
                return a || (a = {
                    transforms: [].concat(t),
                    finalTransform: new Matrix,
                    _mdf: !1
                }, this.sequences[i] = a, this.sequenceList.push(a)), a;
            },
            processSequence: function(t, e) {
                for(var r = 0, i = t.transforms.length, a = e; r < i && !e;){
                    if (t.transforms[r].transform.mProps._mdf) {
                        a = !0;
                        break;
                    }
                    r += 1;
                }
                if (a) for(t.finalTransform.reset(), r = i - 1; r >= 0; r -= 1)t.finalTransform.multiply(t.transforms[r].transform.mProps.v);
                t._mdf = a;
            },
            processSequences: function(t) {
                var e, r = this.sequenceList.length;
                for(e = 0; e < r; e += 1)this.processSequence(this.sequenceList[e], t);
            },
            getNewKey: function() {
                return this.transform_key_count += 1, "_" + this.transform_key_count;
            }
        };
        var lumaLoader = function() {
            var t = "__lottie_element_luma_buffer", e = null, r = null, i = null;
            function a() {
                var a, s, n;
                e || (a = createNS("svg"), s = createNS("filter"), n = createNS("feColorMatrix"), s.setAttribute("id", t), n.setAttribute("type", "matrix"), n.setAttribute("color-interpolation-filters", "sRGB"), n.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), s.appendChild(n), a.appendChild(s), a.setAttribute("id", t + "_svg"), featureSupport.svgLumaHidden && (a.style.display = "none"), i = a, document.body.appendChild(i), e = createTag("canvas"), (r = e.getContext("2d")).filter = "url(#" + t + ")", r.fillStyle = "rgba(0,0,0,0)", r.fillRect(0, 0, 1, 1));
            }
            return {
                load: a,
                get: function(i) {
                    return e || a(), e.width = i.width, e.height = i.height, r.filter = "url(#" + t + ")", e;
                }
            };
        };
        function createCanvas(t, e) {
            if (featureSupport.offscreenCanvas) return new OffscreenCanvas(t, e);
            var r = createTag("canvas");
            return r.width = t, r.height = e, r;
        }
        var assetLoader = {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        }, registeredEffects = {};
        function CVEffects(t) {
            var e, r, i = t.data.ef ? t.data.ef.length : 0;
            for(this.filters = [], e = 0; e < i; e += 1){
                r = null;
                var a = t.data.ef[e].ty;
                if (registeredEffects[a]) r = new registeredEffects[a].effect(t.effectsManager.effectElements[e], t);
                r && this.filters.push(r);
            }
            this.filters.length && t.addRenderableComponent(this);
        }
        function registerEffect(t, e) {
            registeredEffects[t] = {
                effect: e
            };
        }
        function CVMaskElement(t, e) {
            var r;
            this.data = t, this.element = e, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
            var i = this.masksProperties.length, a = !1;
            for(r = 0; r < i; r += 1)"n" !== this.masksProperties[r].mode && (a = !0), this.viewData[r] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[r], 3);
            this.hasMasks = a, a && this.element.addRenderableComponent(this);
        }
        function CVBaseElement() {}
        CVEffects.prototype.renderFrame = function(t) {
            var e, r = this.filters.length;
            for(e = 0; e < r; e += 1)this.filters[e].renderFrame(t);
        }, CVEffects.prototype.getEffects = function(t) {
            var e, r = this.filters.length, i = [];
            for(e = 0; e < r; e += 1)this.filters[e].type === t && i.push(this.filters[e]);
            return i;
        }, CVMaskElement.prototype.renderFrame = function() {
            if (this.hasMasks) {
                var t, e, r, i, a = this.element.finalTransform.mat, s = this.element.canvasContext, n = this.masksProperties.length;
                for(s.beginPath(), t = 0; t < n; t += 1)if ("n" !== this.masksProperties[t].mode) {
                    var o;
                    this.masksProperties[t].inv && (s.moveTo(0, 0), s.lineTo(this.element.globalData.compSize.w, 0), s.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), s.lineTo(0, this.element.globalData.compSize.h), s.lineTo(0, 0)), i = this.viewData[t].v, e = a.applyToPointArray(i.v[0][0], i.v[0][1], 0), s.moveTo(e[0], e[1]);
                    var h = i._length;
                    for(o = 1; o < h; o += 1)r = a.applyToTriplePoints(i.o[o - 1], i.i[o], i.v[o]), s.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
                    r = a.applyToTriplePoints(i.o[o - 1], i.i[0], i.v[0]), s.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
                }
                this.element.globalData.renderer.save(!0), s.clip();
            }
        }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
            this.element = null;
        };
        var operationsMap = {
            1: "source-in",
            2: "source-out",
            3: "source-in",
            4: "source-out"
        };
        function CVShapeData(t, e, r, i) {
            this.styledShapes = [], this.tr = [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            var a, s = 4;
            "rc" === e.ty ? s = 5 : "el" === e.ty ? s = 6 : "sr" === e.ty && (s = 7), this.sh = ShapePropertyFactory.getShapeProp(t, e, s, t);
            var n, o = r.length;
            for(a = 0; a < o; a += 1)r[a].closed || (n = {
                transforms: i.addTransformSequence(r[a].transforms),
                trNodes: []
            }, this.styledShapes.push(n), r[a].elements.push(n));
        }
        function CVShapeElement(t, e, r) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager, this.initElement(t, e, r);
        }
        function CVTextElement(t, e, r) {
            this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
                fill: "rgba(0,0,0,0)",
                stroke: "rgba(0,0,0,0)",
                sWidth: 0,
                fValue: ""
            }, this.initElement(t, e, r);
        }
        function CVImageElement(t, e, r) {
            this.assetData = e.getAssetData(t.refId), this.img = e.imageLoader.getAsset(this.assetData), this.initElement(t, e, r);
        }
        function CVSolidElement(t, e, r) {
            this.initElement(t, e, r);
        }
        function CanvasRendererBase() {}
        function CanvasContext() {
            this.opacity = -1, this.transform = createTypedArray("float32", 16), this.fillStyle = "", this.strokeStyle = "", this.lineWidth = "", this.lineCap = "", this.lineJoin = "", this.miterLimit = "", this.id = Math.random();
        }
        function CVContextData() {
            var t;
            this.stack = [], this.cArrPos = 0, this.cTr = new Matrix;
            for(t = 0; t < 15; t += 1){
                var e = new CanvasContext;
                this.stack[t] = e;
            }
            this._length = 15, this.nativeContext = null, this.transformMat = new Matrix, this.currentOpacity = 1, this.currentFillStyle = "", this.appliedFillStyle = "", this.currentStrokeStyle = "", this.appliedStrokeStyle = "", this.currentLineWidth = "", this.appliedLineWidth = "", this.currentLineCap = "", this.appliedLineCap = "", this.currentLineJoin = "", this.appliedLineJoin = "", this.appliedMiterLimit = "", this.currentMiterLimit = "";
        }
        function CVCompElement(t, e, r) {
            this.completeLayers = !1, this.layers = t.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(t, e, r), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function CanvasRenderer(t, e) {
            this.animationItem = t, this.renderConfig = {
                clearCanvas: !e || void 0 === e.clearCanvas || e.clearCanvas,
                context: e && e.context || null,
                progressiveLoad: e && e.progressiveLoad || !1,
                preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e && e.contentVisibility || "visible",
                className: e && e.className || "",
                id: e && e.id || "",
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.renderConfig.dpr = e && e.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = e && e.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
                frameNum: -1,
                _mdf: !1,
                renderConfig: this.renderConfig,
                currentGlobalAlpha: -1
            }, this.contextData = new CVContextData, this.elements = [], this.pendingElements = [], this.transformMat = new Matrix, this.completeLayers = !1, this.rendererType = "canvas", this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData), this.ctxOpacity = this.contextData.opacity.bind(this.contextData), this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData), this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData), this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData), this.ctxLineCap = this.contextData.lineCap.bind(this.contextData), this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData), this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData), this.ctxFill = this.contextData.fill.bind(this.contextData), this.ctxFillRect = this.contextData.fillRect.bind(this.contextData), this.ctxStroke = this.contextData.stroke.bind(this.contextData), this.save = this.contextData.save.bind(this.contextData));
        }
        function HBaseElement() {}
        function HSolidElement(t, e, r) {
            this.initElement(t, e, r);
        }
        function HShapeElement(t, e, r) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(t, e, r), this.prevViewData = [], this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            };
        }
        function HTextElement(t, e, r) {
            this.textSpans = [], this.textPaths = [], this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            }, this.renderType = "svg", this.isMasked = !1, this.initElement(t, e, r);
        }
        function HCameraElement(t, e, r) {
            this.initFrame(), this.initBaseData(t, e, r), this.initHierarchy();
            var i = PropertyFactory.getProp;
            if (this.pe = i(this, t.pe, 0, 0, this), t.ks.p.s ? (this.px = i(this, t.ks.p.x, 1, 0, this), this.py = i(this, t.ks.p.y, 1, 0, this), this.pz = i(this, t.ks.p.z, 1, 0, this)) : this.p = i(this, t.ks.p, 1, 0, this), t.ks.a && (this.a = i(this, t.ks.a, 1, 0, this)), t.ks.or.k.length && t.ks.or.k[0].to) {
                var a, s = t.ks.or.k.length;
                for(a = 0; a < s; a += 1)t.ks.or.k[a].to = null, t.ks.or.k[a].ti = null;
            }
            this.or = i(this, t.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = i(this, t.ks.rx, 0, degToRads, this), this.ry = i(this, t.ks.ry, 0, degToRads, this), this.rz = i(this, t.ks.rz, 0, degToRads, this), this.mat = new Matrix, this._prevMat = new Matrix, this._isFirstFrame = !0, this.finalTransform = {
                mProp: this
            };
        }
        function HImageElement(t, e, r) {
            this.assetData = e.getAssetData(t.refId), this.initElement(t, e, r);
        }
        function HybridRendererBase(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                className: e && e.className || "",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "400%",
                    height: e && e.filterSize && e.filterSize.height || "400%",
                    x: e && e.filterSize && e.filterSize.x || "-100%",
                    y: e && e.filterSize && e.filterSize.y || "-100%"
                }
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
        }
        function HCompElement(t, e, r) {
            this.layers = t.layers, this.supports3d = !t.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, e, r), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function HybridRenderer(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                className: e && e.className || "",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "400%",
                    height: e && e.filterSize && e.filterSize.height || "400%",
                    x: e && e.filterSize && e.filterSize.x || "-100%",
                    y: e && e.filterSize && e.filterSize.y || "-100%"
                },
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
        }
        CVBaseElement.prototype = {
            createElements: function() {},
            initRendererElement: function() {},
            createContainerElements: function() {
                if (this.data.tt >= 1) {
                    this.buffers = [];
                    var t = this.globalData.canvasContext, e = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
                    this.buffers.push(e);
                    var r = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
                    this.buffers.push(r), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
                }
                this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this), this.searchEffectTransforms();
            },
            createContent: function() {},
            setBlendMode: function() {
                var t = this.globalData;
                if (t.blendMode !== this.data.bm) {
                    t.blendMode = this.data.bm;
                    var e = getBlendMode(this.data.bm);
                    t.canvasContext.globalCompositeOperation = e;
                }
            },
            createRenderableComponents: function() {
                this.maskManager = new CVMaskElement(this.data, this), this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
            },
            hideElement: function() {
                this.hidden || this.isInRange && !this.isTransparent || (this.hidden = !0);
            },
            showElement: function() {
                this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
            },
            clearCanvas: function(t) {
                t.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
            },
            prepareLayer: function() {
                if (this.data.tt >= 1) {
                    var t = this.buffers[0].getContext("2d");
                    this.clearCanvas(t), t.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
                }
            },
            exitLayer: function() {
                if (this.data.tt >= 1) {
                    var t = this.buffers[1], e = t.getContext("2d");
                    if (this.clearCanvas(e), e.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform), this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1).renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
                        var r = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                        r.getContext("2d").drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(r, 0, 0);
                    }
                    this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(t, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
                }
            },
            renderFrame: function(t) {
                if (!this.hidden && !this.data.hd && (1 !== this.data.td || t)) {
                    this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.setBlendMode();
                    var e = 0 === this.data.ty;
                    this.prepareLayer(), this.globalData.renderer.save(e), this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity), this.renderInnerContent(), this.globalData.renderer.restore(e), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
                }
            },
            destroy: function() {
                this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
            },
            mHelper: new Matrix
        }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement, CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
            opacity: 1,
            _opMdf: !1
        }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
        }, CVShapeElement.prototype.createStyleElement = function(t, e) {
            var r = {
                data: t,
                type: t.ty,
                preTransforms: this.transformsManager.addTransformSequence(e),
                transforms: [],
                elements: [],
                closed: !0 === t.hd
            }, i = {};
            if ("fl" === t.ty || "st" === t.ty ? (i.c = PropertyFactory.getProp(this, t.c, 1, 255, this), i.c.k || (r.co = "rgb(" + bmFloor(i.c.v[0]) + "," + bmFloor(i.c.v[1]) + "," + bmFloor(i.c.v[2]) + ")")) : "gf" !== t.ty && "gs" !== t.ty || (i.s = PropertyFactory.getProp(this, t.s, 1, null, this), i.e = PropertyFactory.getProp(this, t.e, 1, null, this), i.h = PropertyFactory.getProp(this, t.h || {
                k: 0
            }, 0, .01, this), i.a = PropertyFactory.getProp(this, t.a || {
                k: 0
            }, 0, degToRads, this), i.g = new GradientProperty(this, t.g, this)), i.o = PropertyFactory.getProp(this, t.o, 0, .01, this), "st" === t.ty || "gs" === t.ty) {
                if (r.lc = lineCapEnum[t.lc || 2], r.lj = lineJoinEnum[t.lj || 2], 1 == t.lj && (r.ml = t.ml), i.w = PropertyFactory.getProp(this, t.w, 0, null, this), i.w.k || (r.wi = i.w.v), t.d) {
                    var a = new DashProperty(this, t.d, "canvas", this);
                    i.d = a, i.d.k || (r.da = i.d.dashArray, r.do = i.d.dashoffset[0]);
                }
            } else r.r = 2 === t.r ? "evenodd" : "nonzero";
            return this.stylesList.push(r), i.style = r, i;
        }, CVShapeElement.prototype.createGroupElement = function() {
            return {
                it: [],
                prevViewData: []
            };
        }, CVShapeElement.prototype.createTransformElement = function(t) {
            return {
                transform: {
                    opacity: 1,
                    _opMdf: !1,
                    key: this.transformsManager.getNewKey(),
                    op: PropertyFactory.getProp(this, t.o, 0, .01, this),
                    mProps: TransformPropertyFactory.getTransformProperty(this, t, this)
                }
            };
        }, CVShapeElement.prototype.createShapeElement = function(t) {
            var e = new CVShapeData(this, t, this.stylesList, this.transformsManager);
            return this.shapes.push(e), this.addShapeToModifiers(e), e;
        }, CVShapeElement.prototype.reloadShapes = function() {
            var t;
            this._isFirstFrame = !0;
            var e = this.itemsData.length;
            for(t = 0; t < e; t += 1)this.prevViewData[t] = this.itemsData[t];
            for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), e = this.dynamicProperties.length, t = 0; t < e; t += 1)this.dynamicProperties[t].getValue();
            this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
        }, CVShapeElement.prototype.addTransformToStyleList = function(t) {
            var e, r = this.stylesList.length;
            for(e = 0; e < r; e += 1)this.stylesList[e].closed || this.stylesList[e].transforms.push(t);
        }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
            var t, e = this.stylesList.length;
            for(t = 0; t < e; t += 1)this.stylesList[t].closed || this.stylesList[t].transforms.pop();
        }, CVShapeElement.prototype.closeStyles = function(t) {
            var e, r = t.length;
            for(e = 0; e < r; e += 1)t[e].closed = !0;
        }, CVShapeElement.prototype.searchShapes = function(t, e, r, i, a) {
            var s, n, o, h, l, p, f = t.length - 1, c = [], m = [], d = [].concat(a);
            for(s = f; s >= 0; s -= 1){
                if ((h = this.searchProcessedElement(t[s])) ? e[s] = r[h - 1] : t[s]._shouldRender = i, "fl" === t[s].ty || "st" === t[s].ty || "gf" === t[s].ty || "gs" === t[s].ty) h ? e[s].style.closed = !1 : e[s] = this.createStyleElement(t[s], d), c.push(e[s].style);
                else if ("gr" === t[s].ty) {
                    if (h) for(o = e[s].it.length, n = 0; n < o; n += 1)e[s].prevViewData[n] = e[s].it[n];
                    else e[s] = this.createGroupElement(t[s]);
                    this.searchShapes(t[s].it, e[s].it, e[s].prevViewData, i, d);
                } else "tr" === t[s].ty ? (h || (p = this.createTransformElement(t[s]), e[s] = p), d.push(e[s]), this.addTransformToStyleList(e[s])) : "sh" === t[s].ty || "rc" === t[s].ty || "el" === t[s].ty || "sr" === t[s].ty ? h || (e[s] = this.createShapeElement(t[s])) : "tm" === t[s].ty || "rd" === t[s].ty || "pb" === t[s].ty || "zz" === t[s].ty || "op" === t[s].ty ? (h ? (l = e[s]).closed = !1 : ((l = ShapeModifiers.getModifier(t[s].ty)).init(this, t[s]), e[s] = l, this.shapeModifiers.push(l)), m.push(l)) : "rp" === t[s].ty && (h ? (l = e[s]).closed = !0 : (l = ShapeModifiers.getModifier(t[s].ty), e[s] = l, l.init(this, t, s, e), this.shapeModifiers.push(l), i = !1), m.push(l));
                this.addProcessedElement(t[s], s + 1);
            }
            for(this.removeTransformFromStyleList(), this.closeStyles(c), f = m.length, s = 0; s < f; s += 1)m[s].closed = !0;
        }, CVShapeElement.prototype.renderInnerContent = function() {
            this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
        }, CVShapeElement.prototype.renderShapeTransform = function(t, e) {
            (t._opMdf || e.op._mdf || this._isFirstFrame) && (e.opacity = t.opacity, e.opacity *= e.op.v, e._opMdf = !0);
        }, CVShapeElement.prototype.drawLayer = function() {
            var t, e, r, i, a, s, n, o, h, l = this.stylesList.length, p = this.globalData.renderer, f = this.globalData.canvasContext;
            for(t = 0; t < l; t += 1)if (("st" !== (o = (h = this.stylesList[t]).type) && "gs" !== o || 0 !== h.wi) && h.data._shouldRender && 0 !== h.coOp && 0 !== this.globalData.currentGlobalAlpha) {
                for(p.save(), s = h.elements, "st" === o || "gs" === o ? (p.ctxStrokeStyle("st" === o ? h.co : h.grd), p.ctxLineWidth(h.wi), p.ctxLineCap(h.lc), p.ctxLineJoin(h.lj), p.ctxMiterLimit(h.ml || 0)) : p.ctxFillStyle("fl" === o ? h.co : h.grd), p.ctxOpacity(h.coOp), "st" !== o && "gs" !== o && f.beginPath(), p.ctxTransform(h.preTransforms.finalTransform.props), r = s.length, e = 0; e < r; e += 1){
                    for("st" !== o && "gs" !== o || (f.beginPath(), h.da && (f.setLineDash(h.da), f.lineDashOffset = h.do)), a = (n = s[e].trNodes).length, i = 0; i < a; i += 1)"m" === n[i].t ? f.moveTo(n[i].p[0], n[i].p[1]) : "c" === n[i].t ? f.bezierCurveTo(n[i].pts[0], n[i].pts[1], n[i].pts[2], n[i].pts[3], n[i].pts[4], n[i].pts[5]) : f.closePath();
                    "st" !== o && "gs" !== o || (p.ctxStroke(), h.da && f.setLineDash(this.dashResetter));
                }
                "st" !== o && "gs" !== o && this.globalData.renderer.ctxFill(h.r), p.restore();
            }
        }, CVShapeElement.prototype.renderShape = function(t, e, r, i) {
            var a, s;
            for(s = t, a = e.length - 1; a >= 0; a -= 1)"tr" === e[a].ty ? (s = r[a].transform, this.renderShapeTransform(t, s)) : "sh" === e[a].ty || "el" === e[a].ty || "rc" === e[a].ty || "sr" === e[a].ty ? this.renderPath(e[a], r[a]) : "fl" === e[a].ty ? this.renderFill(e[a], r[a], s) : "st" === e[a].ty ? this.renderStroke(e[a], r[a], s) : "gf" === e[a].ty || "gs" === e[a].ty ? this.renderGradientFill(e[a], r[a], s) : "gr" === e[a].ty ? this.renderShape(s, e[a].it, r[a].it) : e[a].ty;
            i && this.drawLayer();
        }, CVShapeElement.prototype.renderStyledShape = function(t, e) {
            if (this._isFirstFrame || e._mdf || t.transforms._mdf) {
                var r, i, a, s = t.trNodes, n = e.paths, o = n._length;
                s.length = 0;
                var h = t.transforms.finalTransform;
                for(a = 0; a < o; a += 1){
                    var l = n.shapes[a];
                    if (l && l.v) {
                        for(i = l._length, r = 1; r < i; r += 1)1 === r && s.push({
                            t: "m",
                            p: h.applyToPointArray(l.v[0][0], l.v[0][1], 0)
                        }), s.push({
                            t: "c",
                            pts: h.applyToTriplePoints(l.o[r - 1], l.i[r], l.v[r])
                        });
                        1 === i && s.push({
                            t: "m",
                            p: h.applyToPointArray(l.v[0][0], l.v[0][1], 0)
                        }), l.c && i && (s.push({
                            t: "c",
                            pts: h.applyToTriplePoints(l.o[r - 1], l.i[0], l.v[0])
                        }), s.push({
                            t: "z"
                        }));
                    }
                }
                t.trNodes = s;
            }
        }, CVShapeElement.prototype.renderPath = function(t, e) {
            if (!0 !== t.hd && t._shouldRender) {
                var r, i = e.styledShapes.length;
                for(r = 0; r < i; r += 1)this.renderStyledShape(e.styledShapes[r], e.sh);
            }
        }, CVShapeElement.prototype.renderFill = function(t, e, r) {
            var i = e.style;
            (e.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = e.o.v * r.opacity);
        }, CVShapeElement.prototype.renderGradientFill = function(t, e, r) {
            var i, a = e.style;
            if (!a.grd || e.g._mdf || e.s._mdf || e.e._mdf || 1 !== t.t && (e.h._mdf || e.a._mdf)) {
                var s, n = this.globalData.canvasContext, o = e.s.v, h = e.e.v;
                if (1 === t.t) i = n.createLinearGradient(o[0], o[1], h[0], h[1]);
                else {
                    var l = Math.sqrt(Math.pow(o[0] - h[0], 2) + Math.pow(o[1] - h[1], 2)), p = Math.atan2(h[1] - o[1], h[0] - o[0]), f = e.h.v;
                    f >= 1 ? f = .99 : f <= -1 && (f = -0.99);
                    var c = l * f, m = Math.cos(p + e.a.v) * c + o[0], d = Math.sin(p + e.a.v) * c + o[1];
                    i = n.createRadialGradient(m, d, 0, o[0], o[1], l);
                }
                var u = t.g.p, y = e.g.c, g = 1;
                for(s = 0; s < u; s += 1)e.g._hasOpacity && e.g._collapsable && (g = e.g.o[2 * s + 1]), i.addColorStop(y[4 * s] / 100, "rgba(" + y[4 * s + 1] + "," + y[4 * s + 2] + "," + y[4 * s + 3] + "," + g + ")");
                a.grd = i;
            }
            a.coOp = e.o.v * r.opacity;
        }, CVShapeElement.prototype.renderStroke = function(t, e, r) {
            var i = e.style, a = e.d;
            a && (a._mdf || this._isFirstFrame) && (i.da = a.dashArray, i.do = a.dashoffset[0]), (e.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r._opMdf || this._isFirstFrame) && (i.coOp = e.o.v * r.opacity), (e.w._mdf || this._isFirstFrame) && (i.wi = e.w.v);
        }, CVShapeElement.prototype.destroy = function() {
            this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement,
            ITextElement
        ], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
            var t = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
            var e = !1;
            t.fc ? (e = !0, this.values.fill = this.buildColor(t.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = e;
            var r = !1;
            t.sc && (r = !0, this.values.stroke = this.buildColor(t.sc), this.values.sWidth = t.sw);
            var i, a, s, n, o, h, l, p, f, c, m, d, u = this.globalData.fontManager.getFontByName(t.f), y = t.l, g = this.mHelper;
            this.stroke = r, this.values.fValue = t.finalSize + "px " + this.globalData.fontManager.getFontByName(t.f).fFamily, a = t.finalText.length;
            var v = this.data.singleShape, b = .001 * t.tr * t.finalSize, x = 0, E = 0, S = !0, P = 0;
            for(i = 0; i < a; i += 1){
                n = (s = this.globalData.fontManager.getCharData(t.finalText[i], u.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily)) && s.data || {}, g.reset(), v && y[i].n && (x = -b, E += t.yOffset, E += S ? 1 : 0, S = !1), f = (l = n.shapes ? n.shapes[0].it : []).length, g.scale(t.finalSize / 100, t.finalSize / 100), v && this.applyTextPropertiesToMatrix(t, g, y[i].line, x, E), m = createSizedArray(f - 1);
                var C = 0;
                for(p = 0; p < f; p += 1)if ("sh" === l[p].ty) {
                    for(h = l[p].ks.k.i.length, c = l[p].ks.k, d = [], o = 1; o < h; o += 1)1 === o && d.push(g.applyToX(c.v[0][0], c.v[0][1], 0), g.applyToY(c.v[0][0], c.v[0][1], 0)), d.push(g.applyToX(c.o[o - 1][0], c.o[o - 1][1], 0), g.applyToY(c.o[o - 1][0], c.o[o - 1][1], 0), g.applyToX(c.i[o][0], c.i[o][1], 0), g.applyToY(c.i[o][0], c.i[o][1], 0), g.applyToX(c.v[o][0], c.v[o][1], 0), g.applyToY(c.v[o][0], c.v[o][1], 0));
                    d.push(g.applyToX(c.o[o - 1][0], c.o[o - 1][1], 0), g.applyToY(c.o[o - 1][0], c.o[o - 1][1], 0), g.applyToX(c.i[0][0], c.i[0][1], 0), g.applyToY(c.i[0][0], c.i[0][1], 0), g.applyToX(c.v[0][0], c.v[0][1], 0), g.applyToY(c.v[0][0], c.v[0][1], 0)), m[C] = d, C += 1;
                }
                v && (x += y[i].l, x += b), this.textSpans[P] ? this.textSpans[P].elem = m : this.textSpans[P] = {
                    elem: m
                }, P += 1;
            }
        }, CVTextElement.prototype.renderInnerContent = function() {
            var t, e, r, i, a, s;
            this.validateText(), this.canvasContext.font = this.values.fValue, this.globalData.renderer.ctxLineCap("butt"), this.globalData.renderer.ctxLineJoin("miter"), this.globalData.renderer.ctxMiterLimit(4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            var n, o = this.textAnimator.renderedLetters, h = this.textProperty.currentData.l;
            e = h.length;
            var l, p, f = null, c = null, m = null, d = this.globalData.renderer;
            for(t = 0; t < e; t += 1)if (!h[t].n) {
                if ((n = o[t]) && (d.save(), d.ctxTransform(n.p), d.ctxOpacity(n.o)), this.fill) {
                    for(n && n.fc ? f !== n.fc && (d.ctxFillStyle(n.fc), f = n.fc) : f !== this.values.fill && (f = this.values.fill, d.ctxFillStyle(this.values.fill)), i = (l = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), r = 0; r < i; r += 1)for(s = (p = l[r]).length, this.globalData.canvasContext.moveTo(p[0], p[1]), a = 2; a < s; a += 6)this.globalData.canvasContext.bezierCurveTo(p[a], p[a + 1], p[a + 2], p[a + 3], p[a + 4], p[a + 5]);
                    this.globalData.canvasContext.closePath(), d.ctxFill();
                }
                if (this.stroke) {
                    for(n && n.sw ? m !== n.sw && (m = n.sw, d.ctxLineWidth(n.sw)) : m !== this.values.sWidth && (m = this.values.sWidth, d.ctxLineWidth(this.values.sWidth)), n && n.sc ? c !== n.sc && (c = n.sc, d.ctxStrokeStyle(n.sc)) : c !== this.values.stroke && (c = this.values.stroke, d.ctxStrokeStyle(this.values.stroke)), i = (l = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), r = 0; r < i; r += 1)for(s = (p = l[r]).length, this.globalData.canvasContext.moveTo(p[0], p[1]), a = 2; a < s; a += 6)this.globalData.canvasContext.bezierCurveTo(p[a], p[a + 1], p[a + 2], p[a + 3], p[a + 4], p[a + 5]);
                    this.globalData.canvasContext.closePath(), d.ctxStroke();
                }
                n && this.globalData.renderer.restore();
            }
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
            if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
                var t = createTag("canvas");
                t.width = this.assetData.w, t.height = this.assetData.h;
                var e, r, i = t.getContext("2d"), a = this.img.width, s = this.img.height, n = a / s, o = this.assetData.w / this.assetData.h, h = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
                n > o && "xMidYMid slice" === h || n < o && "xMidYMid slice" !== h ? e = (r = s) * o : r = (e = a) / o, i.drawImage(this.img, (a - e) / 2, (s - r) / 2, e, r, 0, 0, this.assetData.w, this.assetData.h), this.img = t;
            }
        }, CVImageElement.prototype.renderInnerContent = function() {
            this.canvasContext.drawImage(this.img, 0, 0);
        }, CVImageElement.prototype.destroy = function() {
            this.img = null;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
            this.globalData.renderer.ctxFillStyle(this.data.sc), this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
        }, extendPrototype([
            BaseRenderer
        ], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(t) {
            return new CVShapeElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createText = function(t) {
            return new CVTextElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createImage = function(t) {
            return new CVImageElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createSolid = function(t) {
            return new CVSolidElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(t) {
            1 === t[0] && 0 === t[1] && 0 === t[4] && 1 === t[5] && 0 === t[12] && 0 === t[13] || this.canvasContext.transform(t[0], t[1], t[4], t[5], t[12], t[13]);
        }, CanvasRendererBase.prototype.ctxOpacity = function(t) {
            this.canvasContext.globalAlpha *= t < 0 ? 0 : t;
        }, CanvasRendererBase.prototype.ctxFillStyle = function(t) {
            this.canvasContext.fillStyle = t;
        }, CanvasRendererBase.prototype.ctxStrokeStyle = function(t) {
            this.canvasContext.strokeStyle = t;
        }, CanvasRendererBase.prototype.ctxLineWidth = function(t) {
            this.canvasContext.lineWidth = t;
        }, CanvasRendererBase.prototype.ctxLineCap = function(t) {
            this.canvasContext.lineCap = t;
        }, CanvasRendererBase.prototype.ctxLineJoin = function(t) {
            this.canvasContext.lineJoin = t;
        }, CanvasRendererBase.prototype.ctxMiterLimit = function(t) {
            this.canvasContext.miterLimit = t;
        }, CanvasRendererBase.prototype.ctxFill = function(t) {
            this.canvasContext.fill(t);
        }, CanvasRendererBase.prototype.ctxFillRect = function(t, e, r, i) {
            this.canvasContext.fillRect(t, e, r, i);
        }, CanvasRendererBase.prototype.ctxStroke = function() {
            this.canvasContext.stroke();
        }, CanvasRendererBase.prototype.reset = function() {
            this.renderConfig.clearCanvas ? this.contextData.reset() : this.canvasContext.restore();
        }, CanvasRendererBase.prototype.save = function() {
            this.canvasContext.save();
        }, CanvasRendererBase.prototype.restore = function(t) {
            this.renderConfig.clearCanvas ? (t && (this.globalData.blendMode = "source-over"), this.contextData.restore(t)) : this.canvasContext.restore();
        }, CanvasRendererBase.prototype.configAnimation = function(t) {
            if (this.animationItem.wrapper) {
                this.animationItem.container = createTag("canvas");
                var e = this.animationItem.container.style;
                e.width = "100%", e.height = "100%";
                var r = "0px 0px 0px";
                e.transformOrigin = r, e.mozTransformOrigin = r, e.webkitTransformOrigin = r, e["-webkit-transform"] = r, e.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
            } else this.canvasContext = this.renderConfig.context;
            this.contextData.setContext(this.canvasContext), this.data = t, this.layers = t.layers, this.transformCanvas = {
                w: t.w,
                h: t.h,
                sx: 0,
                sy: 0,
                tx: 0,
                ty: 0
            }, this.setupGlobalData(t, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(t.layers.length), this.updateContainerSize();
        }, CanvasRendererBase.prototype.updateContainerSize = function(t, e) {
            var r, i, a, s;
            if (this.reset(), t ? (r = t, i = e, this.canvasContext.canvas.width = r, this.canvasContext.canvas.height = i) : (this.animationItem.wrapper && this.animationItem.container ? (r = this.animationItem.wrapper.offsetWidth, i = this.animationItem.wrapper.offsetHeight) : (r = this.canvasContext.canvas.width, i = this.canvasContext.canvas.height), this.canvasContext.canvas.width = r * this.renderConfig.dpr, this.canvasContext.canvas.height = i * this.renderConfig.dpr), -1 !== this.renderConfig.preserveAspectRatio.indexOf("meet") || -1 !== this.renderConfig.preserveAspectRatio.indexOf("slice")) {
                var n = this.renderConfig.preserveAspectRatio.split(" "), o = n[1] || "meet", h = n[0] || "xMidYMid", l = h.substr(0, 4), p = h.substr(4);
                a = r / i, (s = this.transformCanvas.w / this.transformCanvas.h) > a && "meet" === o || s < a && "slice" === o ? (this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = r / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = i / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr)), this.transformCanvas.tx = "xMid" === l && (s < a && "meet" === o || s > a && "slice" === o) ? (r - this.transformCanvas.w * (i / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : "xMax" === l && (s < a && "meet" === o || s > a && "slice" === o) ? (r - this.transformCanvas.w * (i / this.transformCanvas.h)) * this.renderConfig.dpr : 0, this.transformCanvas.ty = "YMid" === p && (s > a && "meet" === o || s < a && "slice" === o) ? (i - this.transformCanvas.h * (r / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : "YMax" === p && (s > a && "meet" === o || s < a && "slice" === o) ? (i - this.transformCanvas.h * (r / this.transformCanvas.w)) * this.renderConfig.dpr : 0;
            } else "none" === this.renderConfig.preserveAspectRatio ? (this.transformCanvas.sx = r / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
            this.transformCanvas.props = [
                this.transformCanvas.sx,
                0,
                0,
                0,
                0,
                this.transformCanvas.sy,
                0,
                0,
                0,
                0,
                1,
                0,
                this.transformCanvas.tx,
                this.transformCanvas.ty,
                0,
                1
            ], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
        }, CanvasRendererBase.prototype.destroy = function() {
            var t;
            for(this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), t = (this.layers ? this.layers.length : 0) - 1; t >= 0; t -= 1)this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
        }, CanvasRendererBase.prototype.renderFrame = function(t, e) {
            if ((this.renderedFrame !== t || !0 !== this.renderConfig.clearCanvas || e) && !this.destroyed && -1 !== t) {
                var r;
                this.renderedFrame = t, this.globalData.frameNum = t - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || e, this.globalData.projectInterface.currentFrame = t;
                var i = this.layers.length;
                for(this.completeLayers || this.checkLayers(t), r = i - 1; r >= 0; r -= 1)(this.completeLayers || this.elements[r]) && this.elements[r].prepareFrame(t - this.layers[r].st);
                if (this.globalData._mdf) {
                    for(!0 === this.renderConfig.clearCanvas ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), r = i - 1; r >= 0; r -= 1)(this.completeLayers || this.elements[r]) && this.elements[r].renderFrame();
                    !0 !== this.renderConfig.clearCanvas && this.restore();
                }
            }
        }, CanvasRendererBase.prototype.buildItem = function(t) {
            var e = this.elements;
            if (!e[t] && 99 !== this.layers[t].ty) {
                var r = this.createItem(this.layers[t], this, this.globalData);
                e[t] = r, r.initExpressions();
            }
        }, CanvasRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
        }, CanvasRendererBase.prototype.hide = function() {
            this.animationItem.container.style.display = "none";
        }, CanvasRendererBase.prototype.show = function() {
            this.animationItem.container.style.display = "block";
        }, CVContextData.prototype.duplicate = function() {
            var t = 2 * this._length, e = 0;
            for(e = this._length; e < t; e += 1)this.stack[e] = new CanvasContext;
            this._length = t;
        }, CVContextData.prototype.reset = function() {
            this.cArrPos = 0, this.cTr.reset(), this.stack[this.cArrPos].opacity = 1;
        }, CVContextData.prototype.restore = function(t) {
            this.cArrPos -= 1;
            var e, r = this.stack[this.cArrPos], i = r.transform, a = this.cTr.props;
            for(e = 0; e < 16; e += 1)a[e] = i[e];
            if (t) {
                this.nativeContext.restore();
                var s = this.stack[this.cArrPos + 1];
                this.appliedFillStyle = s.fillStyle, this.appliedStrokeStyle = s.strokeStyle, this.appliedLineWidth = s.lineWidth, this.appliedLineCap = s.lineCap, this.appliedLineJoin = s.lineJoin, this.appliedMiterLimit = s.miterLimit;
            }
            this.nativeContext.setTransform(i[0], i[1], i[4], i[5], i[12], i[13]), (t || -1 !== r.opacity && this.currentOpacity !== r.opacity) && (this.nativeContext.globalAlpha = r.opacity, this.currentOpacity = r.opacity), this.currentFillStyle = r.fillStyle, this.currentStrokeStyle = r.strokeStyle, this.currentLineWidth = r.lineWidth, this.currentLineCap = r.lineCap, this.currentLineJoin = r.lineJoin, this.currentMiterLimit = r.miterLimit;
        }, CVContextData.prototype.save = function(t) {
            t && this.nativeContext.save();
            var e = this.cTr.props;
            this._length <= this.cArrPos && this.duplicate();
            var r, i = this.stack[this.cArrPos];
            for(r = 0; r < 16; r += 1)i.transform[r] = e[r];
            this.cArrPos += 1;
            var a = this.stack[this.cArrPos];
            a.opacity = i.opacity, a.fillStyle = i.fillStyle, a.strokeStyle = i.strokeStyle, a.lineWidth = i.lineWidth, a.lineCap = i.lineCap, a.lineJoin = i.lineJoin, a.miterLimit = i.miterLimit;
        }, CVContextData.prototype.setOpacity = function(t) {
            this.stack[this.cArrPos].opacity = t;
        }, CVContextData.prototype.setContext = function(t) {
            this.nativeContext = t;
        }, CVContextData.prototype.fillStyle = function(t) {
            this.stack[this.cArrPos].fillStyle !== t && (this.currentFillStyle = t, this.stack[this.cArrPos].fillStyle = t);
        }, CVContextData.prototype.strokeStyle = function(t) {
            this.stack[this.cArrPos].strokeStyle !== t && (this.currentStrokeStyle = t, this.stack[this.cArrPos].strokeStyle = t);
        }, CVContextData.prototype.lineWidth = function(t) {
            this.stack[this.cArrPos].lineWidth !== t && (this.currentLineWidth = t, this.stack[this.cArrPos].lineWidth = t);
        }, CVContextData.prototype.lineCap = function(t) {
            this.stack[this.cArrPos].lineCap !== t && (this.currentLineCap = t, this.stack[this.cArrPos].lineCap = t);
        }, CVContextData.prototype.lineJoin = function(t) {
            this.stack[this.cArrPos].lineJoin !== t && (this.currentLineJoin = t, this.stack[this.cArrPos].lineJoin = t);
        }, CVContextData.prototype.miterLimit = function(t) {
            this.stack[this.cArrPos].miterLimit !== t && (this.currentMiterLimit = t, this.stack[this.cArrPos].miterLimit = t);
        }, CVContextData.prototype.transform = function(t) {
            this.transformMat.cloneFromProps(t);
            var e = this.cTr;
            this.transformMat.multiply(e), e.cloneFromProps(this.transformMat.props);
            var r = e.props;
            this.nativeContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]);
        }, CVContextData.prototype.opacity = function(t) {
            var e = this.stack[this.cArrPos].opacity;
            e *= t < 0 ? 0 : t, this.stack[this.cArrPos].opacity !== e && (this.currentOpacity !== t && (this.nativeContext.globalAlpha = t, this.currentOpacity = t), this.stack[this.cArrPos].opacity = e);
        }, CVContextData.prototype.fill = function(t) {
            this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fill(t);
        }, CVContextData.prototype.fillRect = function(t, e, r, i) {
            this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fillRect(t, e, r, i);
        }, CVContextData.prototype.stroke = function() {
            this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle, this.nativeContext.strokeStyle = this.appliedStrokeStyle), this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth, this.nativeContext.lineWidth = this.appliedLineWidth), this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap, this.nativeContext.lineCap = this.appliedLineCap), this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin, this.nativeContext.lineJoin = this.appliedLineJoin), this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit, this.nativeContext.miterLimit = this.appliedMiterLimit), this.nativeContext.stroke();
        }, extendPrototype([
            CanvasRendererBase,
            ICompElement,
            CVBaseElement
        ], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
            var t, e = this.canvasContext;
            for(e.beginPath(), e.moveTo(0, 0), e.lineTo(this.data.w, 0), e.lineTo(this.data.w, this.data.h), e.lineTo(0, this.data.h), e.lineTo(0, 0), e.clip(), t = this.layers.length - 1; t >= 0; t -= 1)(this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
        }, CVCompElement.prototype.destroy = function() {
            var t;
            for(t = this.layers.length - 1; t >= 0; t -= 1)this.elements[t] && this.elements[t].destroy();
            this.layers = null, this.elements = null;
        }, CVCompElement.prototype.createComp = function(t) {
            return new CVCompElement(t, this.globalData, this);
        }, extendPrototype([
            CanvasRendererBase
        ], CanvasRenderer), CanvasRenderer.prototype.createComp = function(t) {
            return new CVCompElement(t, this.globalData, this);
        }, HBaseElement.prototype = {
            checkBlendMode: function() {},
            initRendererElement: function() {
                this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
            },
            createContainerElements: function() {
                this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 !== this.data.bm && this.setBlendMode();
            },
            renderElement: function() {
                var t = this.transformedElement ? this.transformedElement.style : {};
                if (this.finalTransform._matMdf) {
                    var e = this.finalTransform.mat.toCSS();
                    t.transform = e, t.webkitTransform = e;
                }
                this.finalTransform._opMdf && (t.opacity = this.finalTransform.mProp.o.v);
            },
            renderFrame: function() {
                this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
            },
            destroy: function() {
                this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
            },
            createRenderableComponents: function() {
                this.maskManager = new MaskElement(this.data, this, this.globalData);
            },
            addEffects: function() {},
            setMatte: function() {}
        }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], HSolidElement), HSolidElement.prototype.createContent = function() {
            var t;
            this.data.hasMask ? ((t = createNS("rect")).setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : ((t = createTag("div")).style.width = this.data.sw + "px", t.style.height = this.data.sh + "px", t.style.backgroundColor = this.data.sc), this.layerElement.appendChild(t);
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HSolidElement,
            SVGShapeElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
            var t;
            if (this.baseElement.style.fontSize = 0, this.data.hasMask) this.layerElement.appendChild(this.shapesContainer), t = this.svgElement;
            else {
                t = createNS("svg");
                var e = this.comp.data ? this.comp.data : this.globalData.compSize;
                t.setAttribute("width", e.w), t.setAttribute("height", e.h), t.appendChild(this.shapesContainer), this.layerElement.appendChild(t);
            }
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = t;
        }, HShapeElement.prototype.getTransformedPoint = function(t, e) {
            var r, i = t.length;
            for(r = 0; r < i; r += 1)e = t[r].mProps.v.applyToPointArray(e[0], e[1], 0);
            return e;
        }, HShapeElement.prototype.calculateShapeBoundingBox = function(t, e) {
            var r, i, a, s, n, o = t.sh.v, h = t.transformers, l = o._length;
            if (!(l <= 1)) {
                for(r = 0; r < l - 1; r += 1)i = this.getTransformedPoint(h, o.v[r]), a = this.getTransformedPoint(h, o.o[r]), s = this.getTransformedPoint(h, o.i[r + 1]), n = this.getTransformedPoint(h, o.v[r + 1]), this.checkBounds(i, a, s, n, e);
                o.c && (i = this.getTransformedPoint(h, o.v[r]), a = this.getTransformedPoint(h, o.o[r]), s = this.getTransformedPoint(h, o.i[0]), n = this.getTransformedPoint(h, o.v[0]), this.checkBounds(i, a, s, n, e));
            }
        }, HShapeElement.prototype.checkBounds = function(t, e, r, i, a) {
            this.getBoundsOfCurve(t, e, r, i);
            var s = this.shapeBoundingBox;
            a.x = bmMin(s.left, a.x), a.xMax = bmMax(s.right, a.xMax), a.y = bmMin(s.top, a.y), a.yMax = bmMax(s.bottom, a.yMax);
        }, HShapeElement.prototype.shapeBoundingBox = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, HShapeElement.prototype.tempBoundingBox = {
            x: 0,
            xMax: 0,
            y: 0,
            yMax: 0,
            width: 0,
            height: 0
        }, HShapeElement.prototype.getBoundsOfCurve = function(t, e, r, i) {
            for(var a, s, n, o, h, l, p, f = [
                [
                    t[0],
                    i[0]
                ],
                [
                    t[1],
                    i[1]
                ]
            ], c = 0; c < 2; ++c)s = 6 * t[c] - 12 * e[c] + 6 * r[c], a = -3 * t[c] + 9 * e[c] - 9 * r[c] + 3 * i[c], n = 3 * e[c] - 3 * t[c], s |= 0, n |= 0, 0 === (a |= 0) && 0 === s || (0 === a ? (o = -n / s) > 0 && o < 1 && f[c].push(this.calculateF(o, t, e, r, i, c)) : (h = s * s - 4 * n * a) >= 0 && ((l = (-s + bmSqrt(h)) / (2 * a)) > 0 && l < 1 && f[c].push(this.calculateF(l, t, e, r, i, c)), (p = (-s - bmSqrt(h)) / (2 * a)) > 0 && p < 1 && f[c].push(this.calculateF(p, t, e, r, i, c))));
            this.shapeBoundingBox.left = bmMin.apply(null, f[0]), this.shapeBoundingBox.top = bmMin.apply(null, f[1]), this.shapeBoundingBox.right = bmMax.apply(null, f[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, f[1]);
        }, HShapeElement.prototype.calculateF = function(t, e, r, i, a, s) {
            return bmPow(1 - t, 3) * e[s] + 3 * bmPow(1 - t, 2) * t * r[s] + 3 * (1 - t) * bmPow(t, 2) * i[s] + bmPow(t, 3) * a[s];
        }, HShapeElement.prototype.calculateBoundingBox = function(t, e) {
            var r, i = t.length;
            for(r = 0; r < i; r += 1)t[r] && t[r].sh ? this.calculateShapeBoundingBox(t[r], e) : t[r] && t[r].it ? this.calculateBoundingBox(t[r].it, e) : t[r] && t[r].style && t[r].w && this.expandStrokeBoundingBox(t[r].w, e);
        }, HShapeElement.prototype.expandStrokeBoundingBox = function(t, e) {
            var r = 0;
            if (t.keyframes) {
                for(var i = 0; i < t.keyframes.length; i += 1){
                    var a = t.keyframes[i].s;
                    a > r && (r = a);
                }
                r *= t.mult;
            } else r = t.v * t.mult;
            e.x -= r, e.xMax += r, e.y -= r, e.yMax += r;
        }, HShapeElement.prototype.currentBoxContains = function(t) {
            return this.currentBBox.x <= t.x && this.currentBBox.y <= t.y && this.currentBBox.width + this.currentBBox.x >= t.x + t.width && this.currentBBox.height + this.currentBBox.y >= t.y + t.height;
        }, HShapeElement.prototype.renderInnerContent = function() {
            if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
                var t = this.tempBoundingBox, e = 999999;
                if (t.x = e, t.xMax = -e, t.y = e, t.yMax = -e, this.calculateBoundingBox(this.itemsData, t), t.width = t.xMax < t.x ? 0 : t.xMax - t.x, t.height = t.yMax < t.y ? 0 : t.yMax - t.y, this.currentBoxContains(t)) return;
                var r = !1;
                if (this.currentBBox.w !== t.width && (this.currentBBox.w = t.width, this.shapeCont.setAttribute("width", t.width), r = !0), this.currentBBox.h !== t.height && (this.currentBBox.h = t.height, this.shapeCont.setAttribute("height", t.height), r = !0), r || this.currentBBox.x !== t.x || this.currentBBox.y !== t.y) {
                    this.currentBBox.w = t.width, this.currentBBox.h = t.height, this.currentBBox.x = t.x, this.currentBBox.y = t.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                    var i = this.shapeCont.style, a = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                    i.transform = a, i.webkitTransform = a;
                }
            }
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement
        ], HTextElement), HTextElement.prototype.createContent = function() {
            if (this.isMasked = this.checkMasks(), this.isMasked) {
                this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
                var t = createNS("g");
                this.maskedElement.appendChild(t), this.innerElem = t;
            } else this.renderType = "html", this.innerElem = this.layerElement;
            this.checkParenting();
        }, HTextElement.prototype.buildNewText = function() {
            var t = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
            var e = this.innerElem.style, r = t.fc ? this.buildColor(t.fc) : "rgba(0,0,0,0)";
            e.fill = r, e.color = r, t.sc && (e.stroke = this.buildColor(t.sc), e.strokeWidth = t.sw + "px");
            var i, a, s = this.globalData.fontManager.getFontByName(t.f);
            if (!this.globalData.fontManager.chars) {
                if (e.fontSize = t.finalSize + "px", e.lineHeight = t.finalSize + "px", s.fClass) this.innerElem.className = s.fClass;
                else {
                    e.fontFamily = s.fFamily;
                    var n = t.fWeight, o = t.fStyle;
                    e.fontStyle = o, e.fontWeight = n;
                }
            }
            var h, l, p, f = t.l;
            a = f.length;
            var c, m = this.mHelper, d = "", u = 0;
            for(i = 0; i < a; i += 1){
                if (this.globalData.fontManager.chars ? (this.textPaths[u] ? h = this.textPaths[u] : ((h = createNS("path")).setAttribute("stroke-linecap", lineCapEnum[1]), h.setAttribute("stroke-linejoin", lineJoinEnum[2]), h.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[u] ? p = (l = this.textSpans[u]).children[0] : ((l = createTag("div")).style.lineHeight = 0, (p = createNS("svg")).appendChild(h), styleDiv(l)))) : this.isMasked ? h = this.textPaths[u] ? this.textPaths[u] : createNS("text") : this.textSpans[u] ? (l = this.textSpans[u], h = this.textPaths[u]) : (styleDiv(l = createTag("span")), styleDiv(h = createTag("span")), l.appendChild(h)), this.globalData.fontManager.chars) {
                    var y, g = this.globalData.fontManager.getCharData(t.finalText[i], s.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily);
                    if (y = g ? g.data : null, m.reset(), y && y.shapes && y.shapes.length && (c = y.shapes[0].it, m.scale(t.finalSize / 100, t.finalSize / 100), d = this.createPathShape(m, c), h.setAttribute("d", d)), this.isMasked) this.innerElem.appendChild(h);
                    else {
                        if (this.innerElem.appendChild(l), y && y.shapes) {
                            document.body.appendChild(p);
                            var v = p.getBBox();
                            p.setAttribute("width", v.width + 2), p.setAttribute("height", v.height + 2), p.setAttribute("viewBox", v.x - 1 + " " + (v.y - 1) + " " + (v.width + 2) + " " + (v.height + 2));
                            var b = p.style, x = "translate(" + (v.x - 1) + "px," + (v.y - 1) + "px)";
                            b.transform = x, b.webkitTransform = x, f[i].yOffset = v.y - 1;
                        } else p.setAttribute("width", 1), p.setAttribute("height", 1);
                        l.appendChild(p);
                    }
                } else if (h.textContent = f[i].val, h.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked) this.innerElem.appendChild(h);
                else {
                    this.innerElem.appendChild(l);
                    var E = h.style, S = "translate3d(0," + -t.finalSize / 1.2 + "px,0)";
                    E.transform = S, E.webkitTransform = S;
                }
                this.isMasked ? this.textSpans[u] = h : this.textSpans[u] = l, this.textSpans[u].style.display = "block", this.textPaths[u] = h, u += 1;
            }
            for(; u < this.textSpans.length;)this.textSpans[u].style.display = "none", u += 1;
        }, HTextElement.prototype.renderInnerContent = function() {
            var t;
            if (this.validateText(), this.data.singleShape) {
                if (!this._isFirstFrame && !this.lettersChangedFlag) return;
                if (this.isMasked && this.finalTransform._matMdf) {
                    this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), t = this.svgElement.style;
                    var e = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
                    t.transform = e, t.webkitTransform = e;
                }
            }
            if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                var r, i, a, s, n, o = 0, h = this.textAnimator.renderedLetters, l = this.textProperty.currentData.l;
                for(i = l.length, r = 0; r < i; r += 1)l[r].n ? o += 1 : (s = this.textSpans[r], n = this.textPaths[r], a = h[o], o += 1, a._mdf.m && (this.isMasked ? s.setAttribute("transform", a.m) : (s.style.webkitTransform = a.m, s.style.transform = a.m)), s.style.opacity = a.o, a.sw && a._mdf.sw && n.setAttribute("stroke-width", a.sw), a.sc && a._mdf.sc && n.setAttribute("stroke", a.sc), a.fc && a._mdf.fc && (n.setAttribute("fill", a.fc), n.style.color = a.fc));
                if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
                    var p = this.innerElem.getBBox();
                    this.currentBBox.w !== p.width && (this.currentBBox.w = p.width, this.svgElement.setAttribute("width", p.width)), this.currentBBox.h !== p.height && (this.currentBBox.h = p.height, this.svgElement.setAttribute("height", p.height));
                    if (this.currentBBox.w !== p.width + 2 || this.currentBBox.h !== p.height + 2 || this.currentBBox.x !== p.x - 1 || this.currentBBox.y !== p.y - 1) {
                        this.currentBBox.w = p.width + 2, this.currentBBox.h = p.height + 2, this.currentBBox.x = p.x - 1, this.currentBBox.y = p.y - 1, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), t = this.svgElement.style;
                        var f = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                        t.transform = f, t.webkitTransform = f;
                    }
                }
            }
        }, extendPrototype([
            BaseElement,
            FrameElement,
            HierarchyElement
        ], HCameraElement), HCameraElement.prototype.setup = function() {
            var t, e, r, i, a = this.comp.threeDElements.length;
            for(t = 0; t < a; t += 1)if ("3d" === (e = this.comp.threeDElements[t]).type) {
                r = e.perspectiveElem.style, i = e.container.style;
                var s = this.pe.v + "px", n = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                r.perspective = s, r.webkitPerspective = s, i.transformOrigin = "0px 0px 0px", i.mozTransformOrigin = "0px 0px 0px", i.webkitTransformOrigin = "0px 0px 0px", r.transform = n, r.webkitTransform = n;
            }
        }, HCameraElement.prototype.createElements = function() {}, HCameraElement.prototype.hide = function() {}, HCameraElement.prototype.renderFrame = function() {
            var t, e, r = this._isFirstFrame;
            if (this.hierarchy) for(e = this.hierarchy.length, t = 0; t < e; t += 1)r = this.hierarchy[t].finalTransform.mProp._mdf || r;
            if (r || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
                if (this.mat.reset(), this.hierarchy) for(t = e = this.hierarchy.length - 1; t >= 0; t -= 1){
                    var i = this.hierarchy[t].finalTransform.mProp;
                    this.mat.translate(-i.p.v[0], -i.p.v[1], i.p.v[2]), this.mat.rotateX(-i.or.v[0]).rotateY(-i.or.v[1]).rotateZ(i.or.v[2]), this.mat.rotateX(-i.rx.v).rotateY(-i.ry.v).rotateZ(i.rz.v), this.mat.scale(1 / i.s.v[0], 1 / i.s.v[1], 1 / i.s.v[2]), this.mat.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
                }
                if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
                    var a;
                    a = this.p ? [
                        this.p.v[0] - this.a.v[0],
                        this.p.v[1] - this.a.v[1],
                        this.p.v[2] - this.a.v[2]
                    ] : [
                        this.px.v - this.a.v[0],
                        this.py.v - this.a.v[1],
                        this.pz.v - this.a.v[2]
                    ];
                    var s = Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2)), n = [
                        a[0] / s,
                        a[1] / s,
                        a[2] / s
                    ], o = Math.sqrt(n[2] * n[2] + n[0] * n[0]), h = Math.atan2(n[1], o), l = Math.atan2(n[0], -n[2]);
                    this.mat.rotateY(l).rotateX(-h);
                }
                this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
                var p = !this._prevMat.equals(this.mat);
                if ((p || this.pe._mdf) && this.comp.threeDElements) {
                    var f, c, m;
                    for(e = this.comp.threeDElements.length, t = 0; t < e; t += 1)if ("3d" === (f = this.comp.threeDElements[t]).type) {
                        if (p) {
                            var d = this.mat.toCSS();
                            (m = f.container.style).transform = d, m.webkitTransform = d;
                        }
                        this.pe._mdf && ((c = f.perspectiveElem.style).perspective = this.pe.v + "px", c.webkitPerspective = this.pe.v + "px");
                    }
                    this.mat.clone(this._prevMat);
                }
            }
            this._isFirstFrame = !1;
        }, HCameraElement.prototype.prepareFrame = function(t) {
            this.prepareProperties(t, !0);
        }, HCameraElement.prototype.destroy = function() {}, HCameraElement.prototype.getBaseElement = function() {
            return null;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HSolidElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], HImageElement), HImageElement.prototype.createContent = function() {
            var t = this.globalData.getAssetsPath(this.assetData), e = new Image;
            this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(e), e.crossOrigin = "anonymous", e.src = t, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
        }, extendPrototype([
            BaseRenderer
        ], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
        }, HybridRendererBase.prototype.appendElementInPos = function(t, e) {
            var r = t.getBaseElement();
            if (r) {
                var i = this.layers[e];
                if (i.ddd && this.supports3d) this.addTo3dContainer(r, e);
                else if (this.threeDElements) this.addTo3dContainer(r, e);
                else {
                    for(var a, s, n = 0; n < e;)this.elements[n] && !0 !== this.elements[n] && this.elements[n].getBaseElement && (s = this.elements[n], a = (this.layers[n].ddd ? this.getThreeDContainerByPos(n) : s.getBaseElement()) || a), n += 1;
                    a ? i.ddd && this.supports3d || this.layerElement.insertBefore(r, a) : i.ddd && this.supports3d || this.layerElement.appendChild(r);
                }
            }
        }, HybridRendererBase.prototype.createShape = function(t) {
            return this.supports3d ? new HShapeElement(t, this.globalData, this) : new SVGShapeElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createText = function(t) {
            return this.supports3d ? new HTextElement(t, this.globalData, this) : new SVGTextLottieElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createCamera = function(t) {
            return this.camera = new HCameraElement(t, this.globalData, this), this.camera;
        }, HybridRendererBase.prototype.createImage = function(t) {
            return this.supports3d ? new HImageElement(t, this.globalData, this) : new IImageElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createSolid = function(t) {
            return this.supports3d ? new HSolidElement(t, this.globalData, this) : new ISolidElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(t) {
            for(var e = 0, r = this.threeDElements.length; e < r;){
                if (this.threeDElements[e].startPos <= t && this.threeDElements[e].endPos >= t) return this.threeDElements[e].perspectiveElem;
                e += 1;
            }
            return null;
        }, HybridRendererBase.prototype.createThreeDContainer = function(t, e) {
            var r, i, a = createTag("div");
            styleDiv(a);
            var s = createTag("div");
            if (styleDiv(s), "3d" === e) {
                (r = a.style).width = this.globalData.compSize.w + "px", r.height = this.globalData.compSize.h + "px";
                r.webkitTransformOrigin = "50% 50%", r.mozTransformOrigin = "50% 50%", r.transformOrigin = "50% 50%";
                var n = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                (i = s.style).transform = n, i.webkitTransform = n;
            }
            a.appendChild(s);
            var o = {
                container: s,
                perspectiveElem: a,
                startPos: t,
                endPos: t,
                type: e
            };
            return this.threeDElements.push(o), o;
        }, HybridRendererBase.prototype.build3dContainers = function() {
            var t, e, r = this.layers.length, i = "";
            for(t = 0; t < r; t += 1)this.layers[t].ddd && 3 !== this.layers[t].ty ? ("3d" !== i && (i = "3d", e = this.createThreeDContainer(t, "3d")), e.endPos = Math.max(e.endPos, t)) : ("2d" !== i && (i = "2d", e = this.createThreeDContainer(t, "2d")), e.endPos = Math.max(e.endPos, t));
            for(t = (r = this.threeDElements.length) - 1; t >= 0; t -= 1)this.resizerElem.appendChild(this.threeDElements[t].perspectiveElem);
        }, HybridRendererBase.prototype.addTo3dContainer = function(t, e) {
            for(var r = 0, i = this.threeDElements.length; r < i;){
                if (e <= this.threeDElements[r].endPos) {
                    for(var a, s = this.threeDElements[r].startPos; s < e;)this.elements[s] && this.elements[s].getBaseElement && (a = this.elements[s].getBaseElement()), s += 1;
                    a ? this.threeDElements[r].container.insertBefore(t, a) : this.threeDElements[r].container.appendChild(t);
                    break;
                }
                r += 1;
            }
        }, HybridRendererBase.prototype.configAnimation = function(t) {
            var e = createTag("div"), r = this.animationItem.wrapper, i = e.style;
            i.width = t.w + "px", i.height = t.h + "px", this.resizerElem = e, styleDiv(e), i.transformStyle = "flat", i.mozTransformStyle = "flat", i.webkitTransformStyle = "flat", this.renderConfig.className && e.setAttribute("class", this.renderConfig.className), r.appendChild(e), i.overflow = "hidden";
            var a = createNS("svg");
            a.setAttribute("width", "1"), a.setAttribute("height", "1"), styleDiv(a), this.resizerElem.appendChild(a);
            var s = createNS("defs");
            a.appendChild(s), this.data = t, this.setupGlobalData(t, a), this.globalData.defs = s, this.layers = t.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
        }, HybridRendererBase.prototype.destroy = function() {
            var t;
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
            var e = this.layers ? this.layers.length : 0;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
        }, HybridRendererBase.prototype.updateContainerSize = function() {
            var t, e, r, i, a = this.animationItem.wrapper.offsetWidth, s = this.animationItem.wrapper.offsetHeight, n = a / s;
            this.globalData.compSize.w / this.globalData.compSize.h > n ? (t = a / this.globalData.compSize.w, e = a / this.globalData.compSize.w, r = 0, i = (s - this.globalData.compSize.h * (a / this.globalData.compSize.w)) / 2) : (t = s / this.globalData.compSize.h, e = s / this.globalData.compSize.h, r = (a - this.globalData.compSize.w * (s / this.globalData.compSize.h)) / 2, i = 0);
            var o = this.resizerElem.style;
            o.webkitTransform = "matrix3d(" + t + ",0,0,0,0," + e + ",0,0,0,0,1,0," + r + "," + i + ",0,1)", o.transform = o.webkitTransform;
        }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
            this.resizerElem.style.display = "none";
        }, HybridRendererBase.prototype.show = function() {
            this.resizerElem.style.display = "block";
        }, HybridRendererBase.prototype.initItems = function() {
            if (this.buildAllItems(), this.camera) this.camera.setup();
            else {
                var t, e = this.globalData.compSize.w, r = this.globalData.compSize.h, i = this.threeDElements.length;
                for(t = 0; t < i; t += 1){
                    var a = this.threeDElements[t].perspectiveElem.style;
                    a.webkitPerspective = Math.sqrt(Math.pow(e, 2) + Math.pow(r, 2)) + "px", a.perspective = a.webkitPerspective;
                }
            }
        }, HybridRendererBase.prototype.searchExtraCompositions = function(t) {
            var e, r = t.length, i = createTag("div");
            for(e = 0; e < r; e += 1)if (t[e].xt) {
                var a = this.createComp(t[e], i, this.globalData.comp, null);
                a.initExpressions(), this.globalData.projectInterface.registerComposition(a);
            }
        }, extendPrototype([
            HybridRendererBase,
            ICompElement,
            HBaseElement
        ], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
            this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
        }, HCompElement.prototype.addTo3dContainer = function(t, e) {
            for(var r, i = 0; i < e;)this.elements[i] && this.elements[i].getBaseElement && (r = this.elements[i].getBaseElement()), i += 1;
            r ? this.layerElement.insertBefore(t, r) : this.layerElement.appendChild(t);
        }, HCompElement.prototype.createComp = function(t) {
            return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
        }, extendPrototype([
            HybridRendererBase
        ], HybridRenderer), HybridRenderer.prototype.createComp = function(t) {
            return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
        };
        var CompExpressionInterface = function(t) {
            function e(e) {
                for(var r = 0, i = t.layers.length; r < i;){
                    if (t.layers[r].nm === e || t.layers[r].ind === e) return t.elements[r].layerInterface;
                    r += 1;
                }
                return null;
            }
            return Object.defineProperty(e, "_name", {
                value: t.data.nm
            }), e.layer = e, e.pixelAspect = 1, e.height = t.data.h || t.globalData.compSize.h, e.width = t.data.w || t.globalData.compSize.w, e.pixelAspect = 1, e.frameDuration = 1 / t.globalData.frameRate, e.displayStartTime = 0, e.numLayers = t.layers.length, e;
        };
        function _typeof$2(t) {
            return (_typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        function seedRandom(t, e) {
            var r = this, i = e.pow(256, 6), a = e.pow(2, 52), s = 2 * a;
            function n(t) {
                var e, r = t.length, i = this, a = 0, s = i.i = i.j = 0, n = i.S = [];
                for(r || (t = [
                    r++
                ]); a < 256;)n[a] = a++;
                for(a = 0; a < 256; a++)n[a] = n[s = 255 & s + t[a % r] + (e = n[a])], n[s] = e;
                i.g = function(t) {
                    for(var e, r = 0, a = i.i, s = i.j, n = i.S; t--;)e = n[a = 255 & a + 1], r = 256 * r + n[255 & (n[a] = n[s = 255 & s + e]) + (n[s] = e)];
                    return i.i = a, i.j = s, r;
                };
            }
            function o(t, e) {
                return e.i = t.i, e.j = t.j, e.S = t.S.slice(), e;
            }
            function h(t, e) {
                for(var r, i = t + "", a = 0; a < i.length;)e[255 & a] = 255 & (r ^= 19 * e[255 & a]) + i.charCodeAt(a++);
                return l(e);
            }
            function l(t) {
                return String.fromCharCode.apply(0, t);
            }
            e.seedrandom = function(p, f, c) {
                var m = [], d = h(function t(e, r) {
                    var i, a = [], s = _typeof$2(e);
                    if (r && "object" == s) for(i in e)try {
                        a.push(t(e[i], r - 1));
                    } catch (t) {}
                    return a.length ? a : "string" == s ? e : e + "\0";
                }((f = !0 === f ? {
                    entropy: !0
                } : f || {}).entropy ? [
                    p,
                    l(t)
                ] : null === p ? function() {
                    try {
                        var e = new Uint8Array(256);
                        return (r.crypto || r.msCrypto).getRandomValues(e), l(e);
                    } catch (e) {
                        var i = r.navigator, a = i && i.plugins;
                        return [
                            +new Date,
                            r,
                            a,
                            r.screen,
                            l(t)
                        ];
                    }
                }() : p, 3), m), u = new n(m), y = function() {
                    for(var t = u.g(6), e = i, r = 0; t < a;)t = 256 * (t + r), e *= 256, r = u.g(1);
                    for(; t >= s;)t /= 2, e /= 2, r >>>= 1;
                    return (t + r) / e;
                };
                return y.int32 = function() {
                    return 0 | u.g(4);
                }, y.quick = function() {
                    return u.g(4) / 4294967296;
                }, y.double = y, h(l(u.S), t), (f.pass || c || function(t, r, i, a) {
                    return a && (a.S && o(a, u), t.state = function() {
                        return o(u, {});
                    }), i ? (e.random = t, r) : t;
                })(y, d, "global" in f ? f.global : this == e, f.state);
            }, h(e.random(), t);
        }
        function initialize$2(t) {
            seedRandom([], t);
        }
        var propTypes = {
            SHAPE: "shape"
        };
        function _typeof$1(t) {
            return (_typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var ExpressionManager = function() {
            var ob = {}, Math1 = BMMath, window1 = null, document1 = null, XMLHttpRequest1 = null, fetch1 = null, frames = null, _lottieGlobal = {};
            function resetFrame() {
                _lottieGlobal = {};
            }
            function $bm_isInstanceOfArray(t) {
                return t.constructor === Array || t.constructor === Float32Array;
            }
            function isNumerable(t, e) {
                return "number" === t || e instanceof Number || "boolean" === t || "string" === t;
            }
            function $bm_neg(t) {
                var e = _typeof$1(t);
                if ("number" === e || t instanceof Number || "boolean" === e) return -t;
                if ($bm_isInstanceOfArray(t)) {
                    var r, i = t.length, a = [];
                    for(r = 0; r < i; r += 1)a[r] = -t[r];
                    return a;
                }
                return t.propType ? t.v : -t;
            }
            initialize$2(BMMath);
            var easeInBez = BezierFactory.getBezierEasing(.333, 0, .833, .833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(.167, .167, .667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(.33, 0, .667, 1, "easeInOut").get;
            function sum(t, e) {
                var r = _typeof$1(t), i = _typeof$1(e);
                if (isNumerable(r, t) && isNumerable(i, e) || "string" === r || "string" === i) return t + e;
                if ($bm_isInstanceOfArray(t) && isNumerable(i, e)) return (t = t.slice(0))[0] += e, t;
                if (isNumerable(r, t) && $bm_isInstanceOfArray(e)) return (e = e.slice(0))[0] = t + e[0], e;
                if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                    for(var a = 0, s = t.length, n = e.length, o = []; a < s || a < n;)("number" == typeof t[a] || t[a] instanceof Number) && ("number" == typeof e[a] || e[a] instanceof Number) ? o[a] = t[a] + e[a] : o[a] = void 0 === e[a] ? t[a] : t[a] || e[a], a += 1;
                    return o;
                }
                return 0;
            }
            var add = sum;
            function sub(t, e) {
                var r = _typeof$1(t), i = _typeof$1(e);
                if (isNumerable(r, t) && isNumerable(i, e)) return "string" === r && (t = parseInt(t, 10)), "string" === i && (e = parseInt(e, 10)), t - e;
                if ($bm_isInstanceOfArray(t) && isNumerable(i, e)) return (t = t.slice(0))[0] -= e, t;
                if (isNumerable(r, t) && $bm_isInstanceOfArray(e)) return (e = e.slice(0))[0] = t - e[0], e;
                if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                    for(var a = 0, s = t.length, n = e.length, o = []; a < s || a < n;)("number" == typeof t[a] || t[a] instanceof Number) && ("number" == typeof e[a] || e[a] instanceof Number) ? o[a] = t[a] - e[a] : o[a] = void 0 === e[a] ? t[a] : t[a] || e[a], a += 1;
                    return o;
                }
                return 0;
            }
            function mul(t, e) {
                var r, i, a, s = _typeof$1(t), n = _typeof$1(e);
                if (isNumerable(s, t) && isNumerable(n, e)) return t * e;
                if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) {
                    for(a = t.length, r = createTypedArray("float32", a), i = 0; i < a; i += 1)r[i] = t[i] * e;
                    return r;
                }
                if (isNumerable(s, t) && $bm_isInstanceOfArray(e)) {
                    for(a = e.length, r = createTypedArray("float32", a), i = 0; i < a; i += 1)r[i] = t * e[i];
                    return r;
                }
                return 0;
            }
            function div(t, e) {
                var r, i, a, s = _typeof$1(t), n = _typeof$1(e);
                if (isNumerable(s, t) && isNumerable(n, e)) return t / e;
                if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) {
                    for(a = t.length, r = createTypedArray("float32", a), i = 0; i < a; i += 1)r[i] = t[i] / e;
                    return r;
                }
                if (isNumerable(s, t) && $bm_isInstanceOfArray(e)) {
                    for(a = e.length, r = createTypedArray("float32", a), i = 0; i < a; i += 1)r[i] = t / e[i];
                    return r;
                }
                return 0;
            }
            function mod(t, e) {
                return "string" == typeof t && (t = parseInt(t, 10)), "string" == typeof e && (e = parseInt(e, 10)), t % e;
            }
            var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
            function clamp(t, e, r) {
                if (e > r) {
                    var i = r;
                    r = e, e = i;
                }
                return Math1.min(Math1.max(t, e), r);
            }
            function radiansToDegrees(t) {
                return t / degToRads;
            }
            var radians_to_degrees = radiansToDegrees;
            function degreesToRadians(t) {
                return t * degToRads;
            }
            var degrees_to_radians = radiansToDegrees, helperLengthArray = [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            function length(t, e) {
                if ("number" == typeof t || t instanceof Number) return e = e || 0, Math1.abs(t - e);
                var r;
                e || (e = helperLengthArray);
                var i = Math1.min(t.length, e.length), a = 0;
                for(r = 0; r < i; r += 1)a += Math1.pow(e[r] - t[r], 2);
                return Math1.sqrt(a);
            }
            function normalize(t) {
                return div(t, length(t));
            }
            function rgbToHsl(t) {
                var e, r, i = t[0], a = t[1], s = t[2], n = Math1.max(i, a, s), o = Math1.min(i, a, s), h = (n + o) / 2;
                if (n === o) e = 0, r = 0;
                else {
                    var l = n - o;
                    switch(r = h > .5 ? l / (2 - n - o) : l / (n + o), n){
                        case i:
                            e = (a - s) / l + (a < s ? 6 : 0);
                            break;
                        case a:
                            e = (s - i) / l + 2;
                            break;
                        case s:
                            e = (i - a) / l + 4;
                    }
                    e /= 6;
                }
                return [
                    e,
                    r,
                    h,
                    t[3]
                ];
            }
            function hue2rgb(t, e, r) {
                return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + 6 * (e - t) * r : r < .5 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t;
            }
            function hslToRgb(t) {
                var e, r, i, a = t[0], s = t[1], n = t[2];
                if (0 === s) e = n, i = n, r = n;
                else {
                    var o = n < .5 ? n * (1 + s) : n + s - n * s, h = 2 * n - o;
                    e = hue2rgb(h, o, a + 1 / 3), r = hue2rgb(h, o, a), i = hue2rgb(h, o, a - 1 / 3);
                }
                return [
                    e,
                    r,
                    i,
                    t[3]
                ];
            }
            function linear(t, e, r, i, a) {
                if (void 0 !== i && void 0 !== a || (i = e, a = r, e = 0, r = 1), r < e) {
                    var s = r;
                    r = e, e = s;
                }
                if (t <= e) return i;
                if (t >= r) return a;
                var n, o = r === e ? 0 : (t - e) / (r - e);
                if (!i.length) return i + (a - i) * o;
                var h = i.length, l = createTypedArray("float32", h);
                for(n = 0; n < h; n += 1)l[n] = i[n] + (a[n] - i[n]) * o;
                return l;
            }
            function random(t, e) {
                if (void 0 === e && (void 0 === t ? (t = 0, e = 1) : (e = t, t = void 0)), e.length) {
                    var r, i = e.length;
                    t || (t = createTypedArray("float32", i));
                    var a = createTypedArray("float32", i), s = BMMath.random();
                    for(r = 0; r < i; r += 1)a[r] = t[r] + s * (e[r] - t[r]);
                    return a;
                }
                return void 0 === t && (t = 0), t + BMMath.random() * (e - t);
            }
            function createPath(t, e, r, i) {
                var a, s = t.length, n = shapePool.newElement();
                n.setPathData(!!i, s);
                var o, h, l = [
                    0,
                    0
                ];
                for(a = 0; a < s; a += 1)o = e && e[a] ? e[a] : l, h = r && r[a] ? r[a] : l, n.setTripleAt(t[a][0], t[a][1], h[0] + t[a][0], h[1] + t[a][1], o[0] + t[a][0], o[1] + t[a][1], a, !0);
                return n;
            }
            function initiateExpression(elem, data, property) {
                function noOp(t) {
                    return t;
                }
                if (!elem.globalData.renderConfig.runExpressions) return noOp;
                var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = -1 !== val.indexOf("random"), elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
                thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
                    get: function() {
                        return thisProperty.v;
                    }
                }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
                var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || !0 !== this.data.hd, wiggle = (function(t, e) {
                    var r, i, a = this.pv.length ? this.pv.length : 1, s = createTypedArray("float32", a);
                    var n = Math1.floor(5 * time);
                    for(r = 0, i = 0; r < n;){
                        for(i = 0; i < a; i += 1)s[i] += -e + 2 * e * BMMath.random();
                        r += 1;
                    }
                    var o = 5 * time, h = o - Math1.floor(o), l = createTypedArray("float32", a);
                    if (a > 1) {
                        for(i = 0; i < a; i += 1)l[i] = this.pv[i] + s[i] + (-e + 2 * e * BMMath.random()) * h;
                        return l;
                    }
                    return this.pv + s[0] + (-e + 2 * e * BMMath.random()) * h;
                }).bind(this);
                function loopInDuration(t, e) {
                    return loopIn(t, e, !0);
                }
                function loopOutDuration(t, e) {
                    return loopOut(t, e, !0);
                }
                thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty)), this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
                var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface), time, velocity, value, text, textIndex, textTotal, selectorValue;
                function lookAt(t, e) {
                    var r = [
                        e[0] - t[0],
                        e[1] - t[1],
                        e[2] - t[2]
                    ], i = Math1.atan2(r[0], Math1.sqrt(r[1] * r[1] + r[2] * r[2])) / degToRads;
                    return [
                        -Math1.atan2(r[1], r[2]) / degToRads,
                        i,
                        0
                    ];
                }
                function easeOut(t, e, r, i, a) {
                    return applyEase(easeOutBez, t, e, r, i, a);
                }
                function easeIn(t, e, r, i, a) {
                    return applyEase(easeInBez, t, e, r, i, a);
                }
                function ease(t, e, r, i, a) {
                    return applyEase(easeInOutBez, t, e, r, i, a);
                }
                function applyEase(t, e, r, i, a, s) {
                    void 0 === a ? (a = r, s = i) : e = (e - r) / (i - r), e > 1 ? e = 1 : e < 0 && (e = 0);
                    var n = t(e);
                    if ($bm_isInstanceOfArray(a)) {
                        var o, h = a.length, l = createTypedArray("float32", h);
                        for(o = 0; o < h; o += 1)l[o] = (s[o] - a[o]) * n + a[o];
                        return l;
                    }
                    return (s - a) * n + a;
                }
                function nearestKey(t) {
                    var e, r, i, a = data.k.length;
                    if (data.k.length && "number" != typeof data.k[0]) {
                        if (r = -1, (t *= elem.comp.globalData.frameRate) < data.k[0].t) r = 1, i = data.k[0].t;
                        else {
                            for(e = 0; e < a - 1; e += 1){
                                if (t === data.k[e].t) {
                                    r = e + 1, i = data.k[e].t;
                                    break;
                                }
                                if (t > data.k[e].t && t < data.k[e + 1].t) {
                                    t - data.k[e].t > data.k[e + 1].t - t ? (r = e + 2, i = data.k[e + 1].t) : (r = e + 1, i = data.k[e].t);
                                    break;
                                }
                            }
                            -1 === r && (r = e + 1, i = data.k[e].t);
                        }
                    } else r = 0, i = 0;
                    var s = {};
                    return s.index = r, s.time = i / elem.comp.globalData.frameRate, s;
                }
                function key(t) {
                    var e, r, i;
                    if (!data.k.length || "number" == typeof data.k[0]) throw new Error("The property has no keyframe at index " + t);
                    t -= 1, e = {
                        time: data.k[t].t / elem.comp.globalData.frameRate,
                        value: []
                    };
                    var a = Object.prototype.hasOwnProperty.call(data.k[t], "s") ? data.k[t].s : data.k[t - 1].e;
                    for(i = a.length, r = 0; r < i; r += 1)e[r] = a[r], e.value[r] = a[r];
                    return e;
                }
                function framesToTime(t, e) {
                    return e || (e = elem.comp.globalData.frameRate), t / e;
                }
                function timeToFrames(t, e) {
                    return t || 0 === t || (t = time), e || (e = elem.comp.globalData.frameRate), t * e;
                }
                function seedRandom(t) {
                    BMMath.seedrandom(randSeed + t);
                }
                function sourceRectAtTime() {
                    return elem.sourceRectAtTime();
                }
                function substring(t, e) {
                    return "string" == typeof value ? void 0 === e ? value.substring(t) : value.substring(t, e) : "";
                }
                function substr(t, e) {
                    return "string" == typeof value ? void 0 === e ? value.substr(t) : value.substr(t, e) : "";
                }
                function posterizeTime(t) {
                    time = 0 === t ? 0 : Math1.floor(time * t) / t, value = valueAtTime(time);
                }
                var index = elem.data.ind, hasParent = !(!elem.hierarchy || !elem.hierarchy.length), parent, randSeed = Math1.floor(1e6 * Math1.random()), globalData = elem.globalData;
                function executeExpression(t) {
                    return value = t, this.frameExpressionId === elem.globalData.frameId && "textSelector" !== this.propType ? value : ("textSelector" === this.propType && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), 4 !== elemType || content || (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), (hasParent = !(!elem.hierarchy || !elem.hierarchy.length)) && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt);
                }
                return executeExpression.__preventDeadCodeRemoval = [
                    $bm_transform,
                    anchorPoint,
                    time,
                    velocity,
                    inPoint,
                    outPoint,
                    width,
                    height,
                    name,
                    loop_in,
                    loop_out,
                    smooth,
                    toComp,
                    fromCompToSurface,
                    toWorld,
                    fromWorld,
                    mask,
                    position,
                    rotation,
                    scale,
                    thisComp,
                    numKeys,
                    active,
                    wiggle,
                    loopInDuration,
                    loopOutDuration,
                    comp,
                    lookAt,
                    easeOut,
                    easeIn,
                    ease,
                    nearestKey,
                    key,
                    text,
                    textIndex,
                    textTotal,
                    selectorValue,
                    framesToTime,
                    timeToFrames,
                    sourceRectAtTime,
                    substring,
                    substr,
                    posterizeTime,
                    index,
                    globalData
                ], executeExpression;
            }
            return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [
                window1,
                document1,
                XMLHttpRequest1,
                fetch1,
                frames,
                $bm_neg,
                add,
                $bm_sum,
                $bm_sub,
                $bm_mul,
                $bm_div,
                $bm_mod,
                clamp,
                radians_to_degrees,
                degreesToRadians,
                degrees_to_radians,
                normalize,
                rgbToHsl,
                hslToRgb,
                linear,
                random,
                createPath,
                _lottieGlobal
            ], ob.resetFrame = resetFrame, ob;
        }(), Expressions = function() {
            var t = {};
            return t.initExpressions = function(t) {
                var e = 0, r = [];
                t.renderer.compInterface = CompExpressionInterface(t.renderer), t.renderer.globalData.projectInterface.registerComposition(t.renderer), t.renderer.globalData.pushExpression = function() {
                    e += 1;
                }, t.renderer.globalData.popExpression = function() {
                    0 === (e -= 1) && function() {
                        var t, e = r.length;
                        for(t = 0; t < e; t += 1)r[t].release();
                        r.length = 0;
                    }();
                }, t.renderer.globalData.registerExpressionProperty = function(t) {
                    -1 === r.indexOf(t) && r.push(t);
                };
            }, t.resetFrame = ExpressionManager.resetFrame, t;
        }(), MaskManagerInterface = function() {
            function t(t, e) {
                this._mask = t, this._data = e;
            }
            Object.defineProperty(t.prototype, "maskPath", {
                get: function() {
                    return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
                }
            }), Object.defineProperty(t.prototype, "maskOpacity", {
                get: function() {
                    return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v;
                }
            });
            return function(e) {
                var r, i = createSizedArray(e.viewData.length), a = e.viewData.length;
                for(r = 0; r < a; r += 1)i[r] = new t(e.viewData[r], e.masksProperties[r]);
                return function(t) {
                    for(r = 0; r < a;){
                        if (e.masksProperties[r].nm === t) return i[r];
                        r += 1;
                    }
                    return null;
                };
            };
        }(), ExpressionPropertyInterface = function() {
            var t = {
                pv: 0,
                v: 0,
                mult: 1
            }, e = {
                pv: [
                    0,
                    0,
                    0
                ],
                v: [
                    0,
                    0,
                    0
                ],
                mult: 1
            };
            function r(t, e, r) {
                Object.defineProperty(t, "velocity", {
                    get: function() {
                        return e.getVelocityAtTime(e.comp.currentFrame);
                    }
                }), t.numKeys = e.keyframes ? e.keyframes.length : 0, t.key = function(i) {
                    if (!t.numKeys) return 0;
                    var a = "";
                    a = "s" in e.keyframes[i - 1] ? e.keyframes[i - 1].s : "e" in e.keyframes[i - 2] ? e.keyframes[i - 2].e : e.keyframes[i - 2].s;
                    var s = "unidimensional" === r ? new Number(a) : Object.assign({}, a);
                    return s.time = e.keyframes[i - 1].t / e.elem.comp.globalData.frameRate, s.value = "unidimensional" === r ? a[0] : a, s;
                }, t.valueAtTime = e.getValueAtTime, t.speedAtTime = e.getSpeedAtTime, t.velocityAtTime = e.getVelocityAtTime, t.propertyGroup = e.propertyGroup;
            }
            function i() {
                return t;
            }
            return function(a) {
                return a ? "unidimensional" === a.propType ? function(e) {
                    e && "pv" in e || (e = t);
                    var i = 1 / e.mult, a = e.pv * i, s = new Number(a);
                    return s.value = a, r(s, e, "unidimensional"), function() {
                        return e.k && e.getValue(), a = e.v * i, s.value !== a && ((s = new Number(a)).value = a, r(s, e, "unidimensional")), s;
                    };
                }(a) : function(t) {
                    t && "pv" in t || (t = e);
                    var i = 1 / t.mult, a = t.data && t.data.l || t.pv.length, s = createTypedArray("float32", a), n = createTypedArray("float32", a);
                    return s.value = n, r(s, t, "multidimensional"), function() {
                        t.k && t.getValue();
                        for(var e = 0; e < a; e += 1)n[e] = t.v[e] * i, s[e] = n[e];
                        return s;
                    };
                }(a) : i;
            };
        }(), TransformExpressionInterface = function(t) {
            function e(t) {
                switch(t){
                    case "scale":
                    case "Scale":
                    case "ADBE Scale":
                    case 6:
                        return e.scale;
                    case "rotation":
                    case "Rotation":
                    case "ADBE Rotation":
                    case "ADBE Rotate Z":
                    case 10:
                        return e.rotation;
                    case "ADBE Rotate X":
                        return e.xRotation;
                    case "ADBE Rotate Y":
                        return e.yRotation;
                    case "position":
                    case "Position":
                    case "ADBE Position":
                    case 2:
                        return e.position;
                    case "ADBE Position_0":
                        return e.xPosition;
                    case "ADBE Position_1":
                        return e.yPosition;
                    case "ADBE Position_2":
                        return e.zPosition;
                    case "anchorPoint":
                    case "AnchorPoint":
                    case "Anchor Point":
                    case "ADBE AnchorPoint":
                    case 1:
                        return e.anchorPoint;
                    case "opacity":
                    case "Opacity":
                    case 11:
                        return e.opacity;
                    default:
                        return null;
                }
            }
            var r, i, a, s;
            return Object.defineProperty(e, "rotation", {
                get: ExpressionPropertyInterface(t.r || t.rz)
            }), Object.defineProperty(e, "zRotation", {
                get: ExpressionPropertyInterface(t.rz || t.r)
            }), Object.defineProperty(e, "xRotation", {
                get: ExpressionPropertyInterface(t.rx)
            }), Object.defineProperty(e, "yRotation", {
                get: ExpressionPropertyInterface(t.ry)
            }), Object.defineProperty(e, "scale", {
                get: ExpressionPropertyInterface(t.s)
            }), t.p ? s = ExpressionPropertyInterface(t.p) : (r = ExpressionPropertyInterface(t.px), i = ExpressionPropertyInterface(t.py), t.pz && (a = ExpressionPropertyInterface(t.pz))), Object.defineProperty(e, "position", {
                get: function() {
                    return t.p ? s() : [
                        r(),
                        i(),
                        a ? a() : 0
                    ];
                }
            }), Object.defineProperty(e, "xPosition", {
                get: ExpressionPropertyInterface(t.px)
            }), Object.defineProperty(e, "yPosition", {
                get: ExpressionPropertyInterface(t.py)
            }), Object.defineProperty(e, "zPosition", {
                get: ExpressionPropertyInterface(t.pz)
            }), Object.defineProperty(e, "anchorPoint", {
                get: ExpressionPropertyInterface(t.a)
            }), Object.defineProperty(e, "opacity", {
                get: ExpressionPropertyInterface(t.o)
            }), Object.defineProperty(e, "skew", {
                get: ExpressionPropertyInterface(t.sk)
            }), Object.defineProperty(e, "skewAxis", {
                get: ExpressionPropertyInterface(t.sa)
            }), Object.defineProperty(e, "orientation", {
                get: ExpressionPropertyInterface(t.or)
            }), e;
        }, LayerExpressionInterface = function() {
            function t(t) {
                var e = new Matrix;
                void 0 !== t ? this._elem.finalTransform.mProp.getValueAtTime(t).clone(e) : this._elem.finalTransform.mProp.applyToMatrix(e);
                return e;
            }
            function e(t, e) {
                var r = this.getMatrix(e);
                return r.props[12] = 0, r.props[13] = 0, r.props[14] = 0, this.applyPoint(r, t);
            }
            function r(t, e) {
                var r = this.getMatrix(e);
                return this.applyPoint(r, t);
            }
            function i(t, e) {
                var r = this.getMatrix(e);
                return r.props[12] = 0, r.props[13] = 0, r.props[14] = 0, this.invertPoint(r, t);
            }
            function a(t, e) {
                var r = this.getMatrix(e);
                return this.invertPoint(r, t);
            }
            function s(t, e) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r, i = this._elem.hierarchy.length;
                    for(r = 0; r < i; r += 1)this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(t);
                }
                return t.applyToPointArray(e[0], e[1], e[2] || 0);
            }
            function n(t, e) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r, i = this._elem.hierarchy.length;
                    for(r = 0; r < i; r += 1)this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(t);
                }
                return t.inversePoint(e);
            }
            function o(t) {
                var e = new Matrix;
                if (e.reset(), this._elem.finalTransform.mProp.applyToMatrix(e), this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r, i = this._elem.hierarchy.length;
                    for(r = 0; r < i; r += 1)this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(e);
                    return e.inversePoint(t);
                }
                return e.inversePoint(t);
            }
            function h() {
                return [
                    1,
                    1,
                    1,
                    1
                ];
            }
            return function(l) {
                var p;
                function f(t) {
                    switch(t){
                        case "ADBE Root Vectors Group":
                        case "Contents":
                        case 2:
                            return f.shapeInterface;
                        case 1:
                        case 6:
                        case "Transform":
                        case "transform":
                        case "ADBE Transform Group":
                            return p;
                        case 4:
                        case "ADBE Effect Parade":
                        case "effects":
                        case "Effects":
                            return f.effect;
                        case "ADBE Text Properties":
                            return f.textInterface;
                        default:
                            return null;
                    }
                }
                f.getMatrix = t, f.invertPoint = n, f.applyPoint = s, f.toWorld = r, f.toWorldVec = e, f.fromWorld = a, f.fromWorldVec = i, f.toComp = r, f.fromComp = o, f.sampleImage = h, f.sourceRectAtTime = l.sourceRectAtTime.bind(l), f._elem = l;
                var c = getDescriptor(p = TransformExpressionInterface(l.finalTransform.mProp), "anchorPoint");
                return Object.defineProperties(f, {
                    hasParent: {
                        get: function() {
                            return l.hierarchy.length;
                        }
                    },
                    parent: {
                        get: function() {
                            return l.hierarchy[0].layerInterface;
                        }
                    },
                    rotation: getDescriptor(p, "rotation"),
                    scale: getDescriptor(p, "scale"),
                    position: getDescriptor(p, "position"),
                    opacity: getDescriptor(p, "opacity"),
                    anchorPoint: c,
                    anchor_point: c,
                    transform: {
                        get: function() {
                            return p;
                        }
                    },
                    active: {
                        get: function() {
                            return l.isInRange;
                        }
                    }
                }), f.startTime = l.data.st, f.index = l.data.ind, f.source = l.data.refId, f.height = 0 === l.data.ty ? l.data.h : 100, f.width = 0 === l.data.ty ? l.data.w : 100, f.inPoint = l.data.ip / l.comp.globalData.frameRate, f.outPoint = l.data.op / l.comp.globalData.frameRate, f._name = l.data.nm, f.registerMaskInterface = function(t) {
                    f.mask = new MaskManagerInterface(t, l);
                }, f.registerEffectsInterface = function(t) {
                    f.effect = t;
                }, f;
            };
        }(), propertyGroupFactory = function(t, e) {
            return function(r) {
                return (r = void 0 === r ? 1 : r) <= 0 ? t : e(r - 1);
            };
        }, PropertyInterface = function(t, e) {
            var r = {
                _name: t
            };
            return function(t) {
                return (t = void 0 === t ? 1 : t) <= 0 ? r : e(t - 1);
            };
        }, EffectsExpressionInterface = function() {
            function t(r, i, a, s) {
                function n(t) {
                    for(var e = r.ef, i = 0, a = e.length; i < a;){
                        if (t === e[i].nm || t === e[i].mn || t === e[i].ix) return 5 === e[i].ty ? l[i] : l[i]();
                        i += 1;
                    }
                    throw new Error;
                }
                var o, h = propertyGroupFactory(n, a), l = [], p = r.ef.length;
                for(o = 0; o < p; o += 1)5 === r.ef[o].ty ? l.push(t(r.ef[o], i.effectElements[o], i.effectElements[o].propertyGroup, s)) : l.push(e(i.effectElements[o], r.ef[o].ty, s, h));
                return "ADBE Color Control" === r.mn && Object.defineProperty(n, "color", {
                    get: function() {
                        return l[0]();
                    }
                }), Object.defineProperties(n, {
                    numProperties: {
                        get: function() {
                            return r.np;
                        }
                    },
                    _name: {
                        value: r.nm
                    },
                    propertyGroup: {
                        value: h
                    }
                }), n.enabled = 0 !== r.en, n.active = n.enabled, n;
            }
            function e(t, e, r, i) {
                var a = ExpressionPropertyInterface(t.p);
                return t.p.setGroupProperty && t.p.setGroupProperty(PropertyInterface("", i)), function() {
                    return 10 === e ? r.comp.compInterface(t.p.v) : a();
                };
            }
            return {
                createEffectsInterface: function(e, r) {
                    if (e.effectsManager) {
                        var i, a = [], s = e.data.ef, n = e.effectsManager.effectElements.length;
                        for(i = 0; i < n; i += 1)a.push(t(s[i], e.effectsManager.effectElements[i], r, e));
                        var o = e.data.ef || [], h = function(t) {
                            for(i = 0, n = o.length; i < n;){
                                if (t === o[i].nm || t === o[i].mn || t === o[i].ix) return a[i];
                                i += 1;
                            }
                            return null;
                        };
                        return Object.defineProperty(h, "numProperties", {
                            get: function() {
                                return o.length;
                            }
                        }), h;
                    }
                    return null;
                }
            };
        }(), ShapePathInterface = function(t, e, r) {
            var i = e.sh;
            function a(t) {
                return "Shape" === t || "shape" === t || "Path" === t || "path" === t || "ADBE Vector Shape" === t || 2 === t ? a.path : null;
            }
            var s = propertyGroupFactory(a, r);
            return i.setGroupProperty(PropertyInterface("Path", s)), Object.defineProperties(a, {
                path: {
                    get: function() {
                        return i.k && i.getValue(), i;
                    }
                },
                shape: {
                    get: function() {
                        return i.k && i.getValue(), i;
                    }
                },
                _name: {
                    value: t.nm
                },
                ix: {
                    value: t.ix
                },
                propertyIndex: {
                    value: t.ix
                },
                mn: {
                    value: t.mn
                },
                propertyGroup: {
                    value: r
                }
            }), a;
        }, ShapeExpressionInterface = function() {
            function t(t, o, m) {
                var d, u = [], y = t ? t.length : 0;
                for(d = 0; d < y; d += 1)"gr" === t[d].ty ? u.push(e(t[d], o[d], m)) : "fl" === t[d].ty ? u.push(r(t[d], o[d], m)) : "st" === t[d].ty ? u.push(s(t[d], o[d], m)) : "tm" === t[d].ty ? u.push(n(t[d], o[d], m)) : "tr" === t[d].ty || ("el" === t[d].ty ? u.push(h(t[d], o[d], m)) : "sr" === t[d].ty ? u.push(l(t[d], o[d], m)) : "sh" === t[d].ty ? u.push(ShapePathInterface(t[d], o[d], m)) : "rc" === t[d].ty ? u.push(p(t[d], o[d], m)) : "rd" === t[d].ty ? u.push(f(t[d], o[d], m)) : "rp" === t[d].ty ? u.push(c(t[d], o[d], m)) : "gf" === t[d].ty ? u.push(i(t[d], o[d], m)) : u.push(a(t[d], o[d])));
                return u;
            }
            function e(e, r, i) {
                var a = function(t) {
                    switch(t){
                        case "ADBE Vectors Group":
                        case "Contents":
                        case 2:
                            return a.content;
                        default:
                            return a.transform;
                    }
                };
                a.propertyGroup = propertyGroupFactory(a, i);
                var s = function(e, r, i) {
                    var a, s = function(t) {
                        for(var e = 0, r = a.length; e < r;){
                            if (a[e]._name === t || a[e].mn === t || a[e].propertyIndex === t || a[e].ix === t || a[e].ind === t) return a[e];
                            e += 1;
                        }
                        return "number" == typeof t ? a[t - 1] : null;
                    };
                    s.propertyGroup = propertyGroupFactory(s, i), a = t(e.it, r.it, s.propertyGroup), s.numProperties = a.length;
                    var n = o(e.it[e.it.length - 1], r.it[r.it.length - 1], s.propertyGroup);
                    return s.transform = n, s.propertyIndex = e.cix, s._name = e.nm, s;
                }(e, r, a.propertyGroup), n = o(e.it[e.it.length - 1], r.it[r.it.length - 1], a.propertyGroup);
                return a.content = s, a.transform = n, Object.defineProperty(a, "_name", {
                    get: function() {
                        return e.nm;
                    }
                }), a.numProperties = e.np, a.propertyIndex = e.ix, a.nm = e.nm, a.mn = e.mn, a;
            }
            function r(t, e, r) {
                function i(t) {
                    return "Color" === t || "color" === t ? i.color : "Opacity" === t || "opacity" === t ? i.opacity : null;
                }
                return Object.defineProperties(i, {
                    color: {
                        get: ExpressionPropertyInterface(e.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.c.setGroupProperty(PropertyInterface("Color", r)), e.o.setGroupProperty(PropertyInterface("Opacity", r)), i;
            }
            function i(t, e, r) {
                function i(t) {
                    return "Start Point" === t || "start point" === t ? i.startPoint : "End Point" === t || "end point" === t ? i.endPoint : "Opacity" === t || "opacity" === t ? i.opacity : null;
                }
                return Object.defineProperties(i, {
                    startPoint: {
                        get: ExpressionPropertyInterface(e.s)
                    },
                    endPoint: {
                        get: ExpressionPropertyInterface(e.e)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    type: {
                        get: function() {
                            return "a";
                        }
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.s.setGroupProperty(PropertyInterface("Start Point", r)), e.e.setGroupProperty(PropertyInterface("End Point", r)), e.o.setGroupProperty(PropertyInterface("Opacity", r)), i;
            }
            function a() {
                return function() {
                    return null;
                };
            }
            function s(t, e, r) {
                var i, a = propertyGroupFactory(l, r), s = propertyGroupFactory(h, a);
                function n(r) {
                    Object.defineProperty(h, t.d[r].nm, {
                        get: ExpressionPropertyInterface(e.d.dataProps[r].p)
                    });
                }
                var o = t.d ? t.d.length : 0, h = {};
                for(i = 0; i < o; i += 1)n(i), e.d.dataProps[i].p.setGroupProperty(s);
                function l(t) {
                    return "Color" === t || "color" === t ? l.color : "Opacity" === t || "opacity" === t ? l.opacity : "Stroke Width" === t || "stroke width" === t ? l.strokeWidth : null;
                }
                return Object.defineProperties(l, {
                    color: {
                        get: ExpressionPropertyInterface(e.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    strokeWidth: {
                        get: ExpressionPropertyInterface(e.w)
                    },
                    dash: {
                        get: function() {
                            return h;
                        }
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.c.setGroupProperty(PropertyInterface("Color", a)), e.o.setGroupProperty(PropertyInterface("Opacity", a)), e.w.setGroupProperty(PropertyInterface("Stroke Width", a)), l;
            }
            function n(t, e, r) {
                function i(e) {
                    return e === t.e.ix || "End" === e || "end" === e ? i.end : e === t.s.ix ? i.start : e === t.o.ix ? i.offset : null;
                }
                var a = propertyGroupFactory(i, r);
                return i.propertyIndex = t.ix, e.s.setGroupProperty(PropertyInterface("Start", a)), e.e.setGroupProperty(PropertyInterface("End", a)), e.o.setGroupProperty(PropertyInterface("Offset", a)), i.propertyIndex = t.ix, i.propertyGroup = r, Object.defineProperties(i, {
                    start: {
                        get: ExpressionPropertyInterface(e.s)
                    },
                    end: {
                        get: ExpressionPropertyInterface(e.e)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function o(t, e, r) {
                function i(e) {
                    return t.a.ix === e || "Anchor Point" === e ? i.anchorPoint : t.o.ix === e || "Opacity" === e ? i.opacity : t.p.ix === e || "Position" === e ? i.position : t.r.ix === e || "Rotation" === e || "ADBE Vector Rotation" === e ? i.rotation : t.s.ix === e || "Scale" === e ? i.scale : t.sk && t.sk.ix === e || "Skew" === e ? i.skew : t.sa && t.sa.ix === e || "Skew Axis" === e ? i.skewAxis : null;
                }
                var a = propertyGroupFactory(i, r);
                return e.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", a)), e.transform.mProps.p.setGroupProperty(PropertyInterface("Position", a)), e.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", a)), e.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", a)), e.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", a)), e.transform.mProps.sk && (e.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", a)), e.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", a))), e.transform.op.setGroupProperty(PropertyInterface("Opacity", a)), Object.defineProperties(i, {
                    opacity: {
                        get: ExpressionPropertyInterface(e.transform.mProps.o)
                    },
                    position: {
                        get: ExpressionPropertyInterface(e.transform.mProps.p)
                    },
                    anchorPoint: {
                        get: ExpressionPropertyInterface(e.transform.mProps.a)
                    },
                    scale: {
                        get: ExpressionPropertyInterface(e.transform.mProps.s)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(e.transform.mProps.r)
                    },
                    skew: {
                        get: ExpressionPropertyInterface(e.transform.mProps.sk)
                    },
                    skewAxis: {
                        get: ExpressionPropertyInterface(e.transform.mProps.sa)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.ty = "tr", i.mn = t.mn, i.propertyGroup = r, i;
            }
            function h(t, e, r) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.s.ix === e ? i.size : null;
                }
                var a = propertyGroupFactory(i, r);
                i.propertyIndex = t.ix;
                var s = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return s.s.setGroupProperty(PropertyInterface("Size", a)), s.p.setGroupProperty(PropertyInterface("Position", a)), Object.defineProperties(i, {
                    size: {
                        get: ExpressionPropertyInterface(s.s)
                    },
                    position: {
                        get: ExpressionPropertyInterface(s.p)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function l(t, e, r) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.r.ix === e ? i.rotation : t.pt.ix === e ? i.points : t.or.ix === e || "ADBE Vector Star Outer Radius" === e ? i.outerRadius : t.os.ix === e ? i.outerRoundness : !t.ir || t.ir.ix !== e && "ADBE Vector Star Inner Radius" !== e ? t.is && t.is.ix === e ? i.innerRoundness : null : i.innerRadius;
                }
                var a = propertyGroupFactory(i, r), s = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return i.propertyIndex = t.ix, s.or.setGroupProperty(PropertyInterface("Outer Radius", a)), s.os.setGroupProperty(PropertyInterface("Outer Roundness", a)), s.pt.setGroupProperty(PropertyInterface("Points", a)), s.p.setGroupProperty(PropertyInterface("Position", a)), s.r.setGroupProperty(PropertyInterface("Rotation", a)), t.ir && (s.ir.setGroupProperty(PropertyInterface("Inner Radius", a)), s.is.setGroupProperty(PropertyInterface("Inner Roundness", a))), Object.defineProperties(i, {
                    position: {
                        get: ExpressionPropertyInterface(s.p)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(s.r)
                    },
                    points: {
                        get: ExpressionPropertyInterface(s.pt)
                    },
                    outerRadius: {
                        get: ExpressionPropertyInterface(s.or)
                    },
                    outerRoundness: {
                        get: ExpressionPropertyInterface(s.os)
                    },
                    innerRadius: {
                        get: ExpressionPropertyInterface(s.ir)
                    },
                    innerRoundness: {
                        get: ExpressionPropertyInterface(s.is)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function p(t, e, r) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.r.ix === e ? i.roundness : t.s.ix === e || "Size" === e || "ADBE Vector Rect Size" === e ? i.size : null;
                }
                var a = propertyGroupFactory(i, r), s = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return i.propertyIndex = t.ix, s.p.setGroupProperty(PropertyInterface("Position", a)), s.s.setGroupProperty(PropertyInterface("Size", a)), s.r.setGroupProperty(PropertyInterface("Rotation", a)), Object.defineProperties(i, {
                    position: {
                        get: ExpressionPropertyInterface(s.p)
                    },
                    roundness: {
                        get: ExpressionPropertyInterface(s.r)
                    },
                    size: {
                        get: ExpressionPropertyInterface(s.s)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function f(t, e, r) {
                function i(e) {
                    return t.r.ix === e || "Round Corners 1" === e ? i.radius : null;
                }
                var a = propertyGroupFactory(i, r), s = e;
                return i.propertyIndex = t.ix, s.rd.setGroupProperty(PropertyInterface("Radius", a)), Object.defineProperties(i, {
                    radius: {
                        get: ExpressionPropertyInterface(s.rd)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function c(t, e, r) {
                function i(e) {
                    return t.c.ix === e || "Copies" === e ? i.copies : t.o.ix === e || "Offset" === e ? i.offset : null;
                }
                var a = propertyGroupFactory(i, r), s = e;
                return i.propertyIndex = t.ix, s.c.setGroupProperty(PropertyInterface("Copies", a)), s.o.setGroupProperty(PropertyInterface("Offset", a)), Object.defineProperties(i, {
                    copies: {
                        get: ExpressionPropertyInterface(s.c)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(s.o)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            return function(e, r, i) {
                var a;
                function s(t) {
                    if ("number" == typeof t) return 0 === (t = void 0 === t ? 1 : t) ? i : a[t - 1];
                    for(var e = 0, r = a.length; e < r;){
                        if (a[e]._name === t) return a[e];
                        e += 1;
                    }
                    return null;
                }
                return s.propertyGroup = propertyGroupFactory(s, function() {
                    return i;
                }), a = t(e, r, s.propertyGroup), s.numProperties = a.length, s._name = "Contents", s;
            };
        }(), TextExpressionInterface = function(t) {
            var e;
            function r(t) {
                switch(t){
                    case "ADBE Text Document":
                        return r.sourceText;
                    default:
                        return null;
                }
            }
            return Object.defineProperty(r, "sourceText", {
                get: function() {
                    t.textProperty.getValue();
                    var r = t.textProperty.currentData.t;
                    return e && r === e.value || ((e = new String(r)).value = r || new String(r), Object.defineProperty(e, "style", {
                        get: function() {
                            return {
                                fillColor: t.textProperty.currentData.fc
                            };
                        }
                    })), e;
                }
            }), r;
        };
        function _typeof(t) {
            return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        var FootageInterface = (dataInterfaceFactory = function(t) {
            function e(t) {
                return "Outline" === t ? e.outlineInterface() : null;
            }
            return e._name = "Outline", e.outlineInterface = function(t) {
                var e = "", r = t.getFootageData();
                function i(t) {
                    if (r[t]) return e = t, "object" === _typeof(r = r[t]) ? i : r;
                    var a = t.indexOf(e);
                    if (-1 !== a) {
                        var s = parseInt(t.substr(a + e.length), 10);
                        return "object" === _typeof(r = r[s]) ? i : r;
                    }
                    return "";
                }
                return function() {
                    return e = "", r = t.getFootageData(), i;
                };
            }(t), e;
        }, function(t) {
            function e(t) {
                return "Data" === t ? e.dataInterface : null;
            }
            return e._name = "Data", e.dataInterface = dataInterfaceFactory(t), e;
        }), dataInterfaceFactory, interfaces = {
            layer: LayerExpressionInterface,
            effects: EffectsExpressionInterface,
            comp: CompExpressionInterface,
            shape: ShapeExpressionInterface,
            text: TextExpressionInterface,
            footage: FootageInterface
        };
        function getInterface(t) {
            return interfaces[t] || null;
        }
        var expressionHelpers = {
            searchExpressions: function(t, e, r) {
                e.x && (r.k = !0, r.x = !0, r.initiateExpression = ExpressionManager.initiateExpression, r.effectsSequence.push(r.initiateExpression(t, e, r).bind(r)));
            },
            getSpeedAtTime: function(t) {
                var e = this.getValueAtTime(t), r = this.getValueAtTime(t + -0.01), i = 0;
                if (e.length) {
                    var a;
                    for(a = 0; a < e.length; a += 1)i += Math.pow(r[a] - e[a], 2);
                    i = 100 * Math.sqrt(i);
                } else i = 0;
                return i;
            },
            getVelocityAtTime: function(t) {
                if (void 0 !== this.vel) return this.vel;
                var e, r, i = this.getValueAtTime(t), a = this.getValueAtTime(t + -0.001);
                if (i.length) for(e = createTypedArray("float32", i.length), r = 0; r < i.length; r += 1)e[r] = (a[r] - i[r]) / -0.001;
                else e = (a - i) / -0.001;
                return e;
            },
            getValueAtTime: function(t) {
                return t *= this.elem.globalData.frameRate, (t -= this.offsetTime) !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < t ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(t, this._cachingAtTime), this._cachingAtTime.lastFrame = t), this._cachingAtTime.value;
            },
            getStaticValueAtTime: function() {
                return this.pv;
            },
            setGroupProperty: function(t) {
                this.propertyGroup = t;
            }
        };
        function addPropertyDecorator() {
            function t(t, e, r) {
                if (!this.k || !this.keyframes) return this.pv;
                t = t ? t.toLowerCase() : "";
                var i, a, s, n, o, h = this.comp.renderedFrame, l = this.keyframes, p = l[l.length - 1].t;
                if (h <= p) return this.pv;
                if (r ? a = p - (i = e ? Math.abs(p - this.elem.comp.globalData.frameRate * e) : Math.max(0, p - this.elem.data.ip)) : ((!e || e > l.length - 1) && (e = l.length - 1), i = p - (a = l[l.length - 1 - e].t)), "pingpong" === t) {
                    if (Math.floor((h - a) / i) % 2 != 0) return this.getValueAtTime((i - (h - a) % i + a) / this.comp.globalData.frameRate, 0);
                } else {
                    if ("offset" === t) {
                        var f = this.getValueAtTime(a / this.comp.globalData.frameRate, 0), c = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), m = this.getValueAtTime(((h - a) % i + a) / this.comp.globalData.frameRate, 0), d = Math.floor((h - a) / i);
                        if (this.pv.length) {
                            for(n = (o = new Array(f.length)).length, s = 0; s < n; s += 1)o[s] = (c[s] - f[s]) * d + m[s];
                            return o;
                        }
                        return (c - f) * d + m;
                    }
                    if ("continue" === t) {
                        var u = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), y = this.getValueAtTime((p - .001) / this.comp.globalData.frameRate, 0);
                        if (this.pv.length) {
                            for(n = (o = new Array(u.length)).length, s = 0; s < n; s += 1)o[s] = u[s] + (u[s] - y[s]) * ((h - p) / this.comp.globalData.frameRate) / 5e-4;
                            return o;
                        }
                        return u + (h - p) / .001 * (u - y);
                    }
                }
                return this.getValueAtTime(((h - a) % i + a) / this.comp.globalData.frameRate, 0);
            }
            function e(t, e, r) {
                if (!this.k) return this.pv;
                t = t ? t.toLowerCase() : "";
                var i, a, s, n, o, h = this.comp.renderedFrame, l = this.keyframes, p = l[0].t;
                if (h >= p) return this.pv;
                if (r ? a = p + (i = e ? Math.abs(this.elem.comp.globalData.frameRate * e) : Math.max(0, this.elem.data.op - p)) : ((!e || e > l.length - 1) && (e = l.length - 1), i = (a = l[e].t) - p), "pingpong" === t) {
                    if (Math.floor((p - h) / i) % 2 == 0) return this.getValueAtTime(((p - h) % i + p) / this.comp.globalData.frameRate, 0);
                } else {
                    if ("offset" === t) {
                        var f = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), c = this.getValueAtTime(a / this.comp.globalData.frameRate, 0), m = this.getValueAtTime((i - (p - h) % i + p) / this.comp.globalData.frameRate, 0), d = Math.floor((p - h) / i) + 1;
                        if (this.pv.length) {
                            for(n = (o = new Array(f.length)).length, s = 0; s < n; s += 1)o[s] = m[s] - (c[s] - f[s]) * d;
                            return o;
                        }
                        return m - (c - f) * d;
                    }
                    if ("continue" === t) {
                        var u = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), y = this.getValueAtTime((p + .001) / this.comp.globalData.frameRate, 0);
                        if (this.pv.length) {
                            for(n = (o = new Array(u.length)).length, s = 0; s < n; s += 1)o[s] = u[s] + (u[s] - y[s]) * (p - h) / .001;
                            return o;
                        }
                        return u + (u - y) * (p - h) / .001;
                    }
                }
                return this.getValueAtTime((i - ((p - h) % i + p)) / this.comp.globalData.frameRate, 0);
            }
            function r(t, e) {
                if (!this.k) return this.pv;
                if (t = .5 * (t || .4), (e = Math.floor(e || 5)) <= 1) return this.pv;
                var r, i, a = this.comp.renderedFrame / this.comp.globalData.frameRate, s = a - t, n = e > 1 ? (a + t - s) / (e - 1) : 1, o = 0, h = 0;
                for(r = this.pv.length ? createTypedArray("float32", this.pv.length) : 0; o < e;){
                    if (i = this.getValueAtTime(s + o * n), this.pv.length) for(h = 0; h < this.pv.length; h += 1)r[h] += i[h];
                    else r += i;
                    o += 1;
                }
                if (this.pv.length) for(h = 0; h < this.pv.length; h += 1)r[h] /= e;
                else r /= e;
                return r;
            }
            function i(t) {
                this._transformCachingAtTime || (this._transformCachingAtTime = {
                    v: new Matrix
                });
                var e = this._transformCachingAtTime.v;
                if (e.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
                    var r = this.a.getValueAtTime(t);
                    e.translate(-r[0] * this.a.mult, -r[1] * this.a.mult, r[2] * this.a.mult);
                }
                if (this.appliedTransformations < 2) {
                    var i = this.s.getValueAtTime(t);
                    e.scale(i[0] * this.s.mult, i[1] * this.s.mult, i[2] * this.s.mult);
                }
                if (this.sk && this.appliedTransformations < 3) {
                    var a = this.sk.getValueAtTime(t), s = this.sa.getValueAtTime(t);
                    e.skewFromAxis(-a * this.sk.mult, s * this.sa.mult);
                }
                if (this.r && this.appliedTransformations < 4) {
                    var n = this.r.getValueAtTime(t);
                    e.rotate(-n * this.r.mult);
                } else if (!this.r && this.appliedTransformations < 4) {
                    var o = this.rz.getValueAtTime(t), h = this.ry.getValueAtTime(t), l = this.rx.getValueAtTime(t), p = this.or.getValueAtTime(t);
                    e.rotateZ(-o * this.rz.mult).rotateY(h * this.ry.mult).rotateX(l * this.rx.mult).rotateZ(-p[2] * this.or.mult).rotateY(p[1] * this.or.mult).rotateX(p[0] * this.or.mult);
                }
                if (this.data.p && this.data.p.s) {
                    var f = this.px.getValueAtTime(t), c = this.py.getValueAtTime(t);
                    if (this.data.p.z) {
                        var m = this.pz.getValueAtTime(t);
                        e.translate(f * this.px.mult, c * this.py.mult, -m * this.pz.mult);
                    } else e.translate(f * this.px.mult, c * this.py.mult, 0);
                } else {
                    var d = this.p.getValueAtTime(t);
                    e.translate(d[0] * this.p.mult, d[1] * this.p.mult, -d[2] * this.p.mult);
                }
                return e;
            }
            function a() {
                return this.v.clone(new Matrix);
            }
            var s = TransformPropertyFactory.getTransformProperty;
            TransformPropertyFactory.getTransformProperty = function(t, e, r) {
                var n = s(t, e, r);
                return n.dynamicProperties.length ? n.getValueAtTime = i.bind(n) : n.getValueAtTime = a.bind(n), n.setGroupProperty = expressionHelpers.setGroupProperty, n;
            };
            var n = PropertyFactory.getProp;
            PropertyFactory.getProp = function(i, a, s, o, h) {
                var l = n(i, a, s, o, h);
                l.kf ? l.getValueAtTime = expressionHelpers.getValueAtTime.bind(l) : l.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(l), l.setGroupProperty = expressionHelpers.setGroupProperty, l.loopOut = t, l.loopIn = e, l.smooth = r, l.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(l), l.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(l), l.numKeys = 1 === a.a ? a.k.length : 0, l.propertyIndex = a.ix;
                var p = 0;
                return 0 !== s && (p = createTypedArray("float32", 1 === a.a ? a.k[0].s.length : a.k.length)), l._cachingAtTime = {
                    lastFrame: initialDefaultFrame,
                    lastIndex: 0,
                    value: p
                }, expressionHelpers.searchExpressions(i, a, l), l.k && h.addDynamicProperty(l), l;
            };
            var o = ShapePropertyFactory.getConstructorFunction(), h = ShapePropertyFactory.getKeyframedConstructorFunction();
            function l() {}
            l.prototype = {
                vertices: function(t, e) {
                    this.k && this.getValue();
                    var r, i = this.v;
                    void 0 !== e && (i = this.getValueAtTime(e, 0));
                    var a = i._length, s = i[t], n = i.v, o = createSizedArray(a);
                    for(r = 0; r < a; r += 1)o[r] = "i" === t || "o" === t ? [
                        s[r][0] - n[r][0],
                        s[r][1] - n[r][1]
                    ] : [
                        s[r][0],
                        s[r][1]
                    ];
                    return o;
                },
                points: function(t) {
                    return this.vertices("v", t);
                },
                inTangents: function(t) {
                    return this.vertices("i", t);
                },
                outTangents: function(t) {
                    return this.vertices("o", t);
                },
                isClosed: function() {
                    return this.v.c;
                },
                pointOnPath: function(t, e) {
                    var r = this.v;
                    void 0 !== e && (r = this.getValueAtTime(e, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(r));
                    for(var i, a = this._segmentsLength, s = a.lengths, n = a.totalLength * t, o = 0, h = s.length, l = 0; o < h;){
                        if (l + s[o].addedLength > n) {
                            var p = o, f = r.c && o === h - 1 ? 0 : o + 1, c = (n - l) / s[o].addedLength;
                            i = bez.getPointInSegment(r.v[p], r.v[f], r.o[p], r.i[f], c, s[o]);
                            break;
                        }
                        l += s[o].addedLength, o += 1;
                    }
                    return i || (i = r.c ? [
                        r.v[0][0],
                        r.v[0][1]
                    ] : [
                        r.v[r._length - 1][0],
                        r.v[r._length - 1][1]
                    ]), i;
                },
                vectorOnPath: function(t, e, r) {
                    1 == t ? t = this.v.c : 0 == t && (t = .999);
                    var i = this.pointOnPath(t, e), a = this.pointOnPath(t + .001, e), s = a[0] - i[0], n = a[1] - i[1], o = Math.sqrt(Math.pow(s, 2) + Math.pow(n, 2));
                    return 0 === o ? [
                        0,
                        0
                    ] : "tangent" === r ? [
                        s / o,
                        n / o
                    ] : [
                        -n / o,
                        s / o
                    ];
                },
                tangentOnPath: function(t, e) {
                    return this.vectorOnPath(t, e, "tangent");
                },
                normalOnPath: function(t, e) {
                    return this.vectorOnPath(t, e, "normal");
                },
                setGroupProperty: expressionHelpers.setGroupProperty,
                getValueAtTime: expressionHelpers.getStaticValueAtTime
            }, extendPrototype([
                l
            ], o), extendPrototype([
                l
            ], h), h.prototype.getValueAtTime = function(t) {
                return this._cachingAtTime || (this._cachingAtTime = {
                    shapeValue: shapePool.clone(this.pv),
                    lastIndex: 0,
                    lastTime: initialDefaultFrame
                }), t *= this.elem.globalData.frameRate, (t -= this.offsetTime) !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < t ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = t, this.interpolateShape(t, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
            }, h.prototype.initiateExpression = ExpressionManager.initiateExpression;
            var p = ShapePropertyFactory.getShapeProp;
            ShapePropertyFactory.getShapeProp = function(t, e, r, i, a) {
                var s = p(t, e, r, i, a);
                return s.propertyIndex = e.ix, s.lock = !1, 3 === r ? expressionHelpers.searchExpressions(t, e.pt, s) : 4 === r && expressionHelpers.searchExpressions(t, e.ks, s), s.k && t.addDynamicProperty(s), s;
            };
        }
        function initialize$1() {
            addPropertyDecorator();
        }
        function addDecorator() {
            TextProperty.prototype.getExpressionValue = function(t, e) {
                var r = this.calculateExpression(e);
                if (t.t !== r) {
                    var i = {};
                    return this.copyData(i, t), i.t = r.toString(), i.__complete = !1, i;
                }
                return t;
            }, TextProperty.prototype.searchProperty = function() {
                var t = this.searchKeyframes(), e = this.searchExpressions();
                return this.kf = t || e, this.kf;
            }, TextProperty.prototype.searchExpressions = function() {
                return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
            };
        }
        function initialize() {
            addDecorator();
        }
        function SVGComposableEffect() {}
        SVGComposableEffect.prototype = {
            createMergeNode: function(t, e) {
                var r, i, a = createNS("feMerge");
                for(a.setAttribute("result", t), i = 0; i < e.length; i += 1)(r = createNS("feMergeNode")).setAttribute("in", e[i]), a.appendChild(r), a.appendChild(r);
                return a;
            }
        };
        var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
        function SVGTintFilter(t, e, r, i, a) {
            this.filterManager = e;
            var s = createNS("feColorMatrix");
            s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "linearRGB"), s.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = s, s.setAttribute("result", i + "_tint_1"), t.appendChild(s), (s = createNS("feColorMatrix")).setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), s.setAttribute("result", i + "_tint_2"), t.appendChild(s), this.matrixFilter = s;
            var n = this.createMergeNode(i, [
                a,
                i + "_tint_1",
                i + "_tint_2"
            ]);
            t.appendChild(n);
        }
        function SVGFillFilter(t, e, r, i) {
            this.filterManager = e;
            var a = createNS("feColorMatrix");
            a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), a.setAttribute("result", i), t.appendChild(a), this.matrixFilter = a;
        }
        function SVGStrokeEffect(t, e, r) {
            this.initialized = !1, this.filterManager = e, this.elem = r, this.paths = [];
        }
        function SVGTritoneFilter(t, e, r, i) {
            this.filterManager = e;
            var a = createNS("feColorMatrix");
            a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "linearRGB"), a.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), t.appendChild(a);
            var s = createNS("feComponentTransfer");
            s.setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("result", i), this.matrixFilter = s;
            var n = createNS("feFuncR");
            n.setAttribute("type", "table"), s.appendChild(n), this.feFuncR = n;
            var o = createNS("feFuncG");
            o.setAttribute("type", "table"), s.appendChild(o), this.feFuncG = o;
            var h = createNS("feFuncB");
            h.setAttribute("type", "table"), s.appendChild(h), this.feFuncB = h, t.appendChild(s);
        }
        function SVGProLevelsFilter(t, e, r, i) {
            this.filterManager = e;
            var a = this.filterManager.effectElements, s = createNS("feComponentTransfer");
            (a[10].p.k || 0 !== a[10].p.v || a[11].p.k || 1 !== a[11].p.v || a[12].p.k || 1 !== a[12].p.v || a[13].p.k || 0 !== a[13].p.v || a[14].p.k || 1 !== a[14].p.v) && (this.feFuncR = this.createFeFunc("feFuncR", s)), (a[17].p.k || 0 !== a[17].p.v || a[18].p.k || 1 !== a[18].p.v || a[19].p.k || 1 !== a[19].p.v || a[20].p.k || 0 !== a[20].p.v || a[21].p.k || 1 !== a[21].p.v) && (this.feFuncG = this.createFeFunc("feFuncG", s)), (a[24].p.k || 0 !== a[24].p.v || a[25].p.k || 1 !== a[25].p.v || a[26].p.k || 1 !== a[26].p.v || a[27].p.k || 0 !== a[27].p.v || a[28].p.k || 1 !== a[28].p.v) && (this.feFuncB = this.createFeFunc("feFuncB", s)), (a[31].p.k || 0 !== a[31].p.v || a[32].p.k || 1 !== a[32].p.v || a[33].p.k || 1 !== a[33].p.v || a[34].p.k || 0 !== a[34].p.v || a[35].p.k || 1 !== a[35].p.v) && (this.feFuncA = this.createFeFunc("feFuncA", s)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (s.setAttribute("color-interpolation-filters", "sRGB"), t.appendChild(s)), (a[3].p.k || 0 !== a[3].p.v || a[4].p.k || 1 !== a[4].p.v || a[5].p.k || 1 !== a[5].p.v || a[6].p.k || 0 !== a[6].p.v || a[7].p.k || 1 !== a[7].p.v) && ((s = createNS("feComponentTransfer")).setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("result", i), t.appendChild(s), this.feFuncRComposed = this.createFeFunc("feFuncR", s), this.feFuncGComposed = this.createFeFunc("feFuncG", s), this.feFuncBComposed = this.createFeFunc("feFuncB", s));
        }
        function SVGDropShadowEffect(t, e, r, i, a) {
            var s = e.container.globalData.renderConfig.filterSize, n = e.data.fs || s;
            t.setAttribute("x", n.x || s.x), t.setAttribute("y", n.y || s.y), t.setAttribute("width", n.width || s.width), t.setAttribute("height", n.height || s.height), this.filterManager = e;
            var o = createNS("feGaussianBlur");
            o.setAttribute("in", "SourceAlpha"), o.setAttribute("result", i + "_drop_shadow_1"), o.setAttribute("stdDeviation", "0"), this.feGaussianBlur = o, t.appendChild(o);
            var h = createNS("feOffset");
            h.setAttribute("dx", "25"), h.setAttribute("dy", "0"), h.setAttribute("in", i + "_drop_shadow_1"), h.setAttribute("result", i + "_drop_shadow_2"), this.feOffset = h, t.appendChild(h);
            var l = createNS("feFlood");
            l.setAttribute("flood-color", "#00ff00"), l.setAttribute("flood-opacity", "1"), l.setAttribute("result", i + "_drop_shadow_3"), this.feFlood = l, t.appendChild(l);
            var p = createNS("feComposite");
            p.setAttribute("in", i + "_drop_shadow_3"), p.setAttribute("in2", i + "_drop_shadow_2"), p.setAttribute("operator", "in"), p.setAttribute("result", i + "_drop_shadow_4"), t.appendChild(p);
            var f = this.createMergeNode(i, [
                i + "_drop_shadow_4",
                a
            ]);
            t.appendChild(f);
        }
        extendPrototype([
            SVGComposableEffect
        ], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[0].p.v, r = this.filterManager.effectElements[1].p.v, i = this.filterManager.effectElements[2].p.v / 100;
                this.linearFilter.setAttribute("values", linearFilterValue + " " + i + " 0"), this.matrixFilter.setAttribute("values", r[0] - e[0] + " 0 0 0 " + e[0] + " " + (r[1] - e[1]) + " 0 0 0 " + e[1] + " " + (r[2] - e[2]) + " 0 0 0 " + e[2] + " 0 0 0 1 0");
            }
        }, SVGFillFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[2].p.v, r = this.filterManager.effectElements[6].p.v;
                this.matrixFilter.setAttribute("values", "0 0 0 0 " + e[0] + " 0 0 0 0 " + e[1] + " 0 0 0 0 " + e[2] + " 0 0 0 " + r + " 0");
            }
        }, SVGStrokeEffect.prototype.initialize = function() {
            var t, e, r, i, a = this.elem.layerElement.children || this.elem.layerElement.childNodes;
            for(1 === this.filterManager.effectElements[1].p.v ? (i = this.elem.maskManager.masksProperties.length, r = 0) : i = (r = this.filterManager.effectElements[0].p.v - 1) + 1, (e = createNS("g")).setAttribute("fill", "none"), e.setAttribute("stroke-linecap", "round"), e.setAttribute("stroke-dashoffset", 1); r < i; r += 1)t = createNS("path"), e.appendChild(t), this.paths.push({
                p: t,
                m: r
            });
            if (3 === this.filterManager.effectElements[10].p.v) {
                var s = createNS("mask"), n = createElementID();
                s.setAttribute("id", n), s.setAttribute("mask-type", "alpha"), s.appendChild(e), this.elem.globalData.defs.appendChild(s);
                var o = createNS("g");
                for(o.setAttribute("mask", "url(" + getLocationHref() + "#" + n + ")"); a[0];)o.appendChild(a[0]);
                this.elem.layerElement.appendChild(o), this.masker = s, e.setAttribute("stroke", "#fff");
            } else if (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) {
                if (2 === this.filterManager.effectElements[10].p.v) for(a = this.elem.layerElement.children || this.elem.layerElement.childNodes; a.length;)this.elem.layerElement.removeChild(a[0]);
                this.elem.layerElement.appendChild(e), this.elem.layerElement.removeAttribute("mask"), e.setAttribute("stroke", "#fff");
            }
            this.initialized = !0, this.pathMasker = e;
        }, SVGStrokeEffect.prototype.renderFrame = function(t) {
            var e;
            this.initialized || this.initialize();
            var r, i, a = this.paths.length;
            for(e = 0; e < a; e += 1)if (-1 !== this.paths[e].m && (r = this.elem.maskManager.viewData[this.paths[e].m], i = this.paths[e].p, (t || this.filterManager._mdf || r.prop._mdf) && i.setAttribute("d", r.lastPath), t || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || r.prop._mdf)) {
                var s;
                if (0 !== this.filterManager.effectElements[7].p.v || 100 !== this.filterManager.effectElements[8].p.v) {
                    var n = .01 * Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), o = .01 * Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), h = i.getTotalLength();
                    s = "0 0 0 " + h * n + " ";
                    var l, p = h * (o - n), f = 1 + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01, c = Math.floor(p / f);
                    for(l = 0; l < c; l += 1)s += "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01 + " ";
                    s += "0 " + 10 * h + " 0 0";
                } else s = "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01;
                i.setAttribute("stroke-dasharray", s);
            }
            if ((t || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", 2 * this.filterManager.effectElements[4].p.v), (t || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) && (t || this.filterManager.effectElements[3].p._mdf)) {
                var m = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(255 * m[0]) + "," + bmFloor(255 * m[1]) + "," + bmFloor(255 * m[2]) + ")");
            }
        }, SVGTritoneFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[0].p.v, r = this.filterManager.effectElements[1].p.v, i = this.filterManager.effectElements[2].p.v, a = i[0] + " " + r[0] + " " + e[0], s = i[1] + " " + r[1] + " " + e[1], n = i[2] + " " + r[2] + " " + e[2];
                this.feFuncR.setAttribute("tableValues", a), this.feFuncG.setAttribute("tableValues", s), this.feFuncB.setAttribute("tableValues", n);
            }
        }, SVGProLevelsFilter.prototype.createFeFunc = function(t, e) {
            var r = createNS(t);
            return r.setAttribute("type", "table"), e.appendChild(r), r;
        }, SVGProLevelsFilter.prototype.getTableValue = function(t, e, r, i, a) {
            for(var s, n, o = 0, h = Math.min(t, e), l = Math.max(t, e), p = Array.call(null, {
                length: 256
            }), f = 0, c = a - i, m = e - t; o <= 256;)n = (s = o / 256) <= h ? m < 0 ? a : i : s >= l ? m < 0 ? i : a : i + c * Math.pow((s - t) / m, 1 / r), p[f] = n, f += 1, o += 256 / 255;
            return p.join(" ");
        }, SVGProLevelsFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e, r = this.filterManager.effectElements;
                this.feFuncRComposed && (t || r[3].p._mdf || r[4].p._mdf || r[5].p._mdf || r[6].p._mdf || r[7].p._mdf) && (e = this.getTableValue(r[3].p.v, r[4].p.v, r[5].p.v, r[6].p.v, r[7].p.v), this.feFuncRComposed.setAttribute("tableValues", e), this.feFuncGComposed.setAttribute("tableValues", e), this.feFuncBComposed.setAttribute("tableValues", e)), this.feFuncR && (t || r[10].p._mdf || r[11].p._mdf || r[12].p._mdf || r[13].p._mdf || r[14].p._mdf) && (e = this.getTableValue(r[10].p.v, r[11].p.v, r[12].p.v, r[13].p.v, r[14].p.v), this.feFuncR.setAttribute("tableValues", e)), this.feFuncG && (t || r[17].p._mdf || r[18].p._mdf || r[19].p._mdf || r[20].p._mdf || r[21].p._mdf) && (e = this.getTableValue(r[17].p.v, r[18].p.v, r[19].p.v, r[20].p.v, r[21].p.v), this.feFuncG.setAttribute("tableValues", e)), this.feFuncB && (t || r[24].p._mdf || r[25].p._mdf || r[26].p._mdf || r[27].p._mdf || r[28].p._mdf) && (e = this.getTableValue(r[24].p.v, r[25].p.v, r[26].p.v, r[27].p.v, r[28].p.v), this.feFuncB.setAttribute("tableValues", e)), this.feFuncA && (t || r[31].p._mdf || r[32].p._mdf || r[33].p._mdf || r[34].p._mdf || r[35].p._mdf) && (e = this.getTableValue(r[31].p.v, r[32].p.v, r[33].p.v, r[34].p.v, r[35].p.v), this.feFuncA.setAttribute("tableValues", e));
            }
        }, extendPrototype([
            SVGComposableEffect
        ], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                if ((t || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), t || this.filterManager.effectElements[0].p._mdf) {
                    var e = this.filterManager.effectElements[0].p.v;
                    this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(255 * e[0]), Math.round(255 * e[1]), Math.round(255 * e[2])));
                }
                if ((t || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), t || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                    var r = this.filterManager.effectElements[3].p.v, i = (this.filterManager.effectElements[2].p.v - 90) * degToRads, a = r * Math.cos(i), s = r * Math.sin(i);
                    this.feOffset.setAttribute("dx", a), this.feOffset.setAttribute("dy", s);
                }
            }
        };
        var _svgMatteSymbols = [];
        function SVGMatte3Effect(t, e, r) {
            this.initialized = !1, this.filterManager = e, this.filterElem = t, this.elem = r, r.matteElement = createNS("g"), r.matteElement.appendChild(r.layerElement), r.matteElement.appendChild(r.transformedElement), r.baseElement = r.matteElement;
        }
        function SVGGaussianBlurEffect(t, e, r, i) {
            t.setAttribute("x", "-100%"), t.setAttribute("y", "-100%"), t.setAttribute("width", "300%"), t.setAttribute("height", "300%"), this.filterManager = e;
            var a = createNS("feGaussianBlur");
            a.setAttribute("result", i), t.appendChild(a), this.feGaussianBlur = a;
        }
        function TransformEffect() {}
        function SVGTransformEffect(t, e) {
            this.init(e);
        }
        function CVTransformEffect(t) {
            this.init(t);
        }
        return SVGMatte3Effect.prototype.findSymbol = function(t) {
            for(var e = 0, r = _svgMatteSymbols.length; e < r;){
                if (_svgMatteSymbols[e] === t) return _svgMatteSymbols[e];
                e += 1;
            }
            return null;
        }, SVGMatte3Effect.prototype.replaceInParent = function(t, e) {
            var r = t.layerElement.parentNode;
            if (r) {
                for(var i, a = r.children, s = 0, n = a.length; s < n && a[s] !== t.layerElement;)s += 1;
                s <= n - 2 && (i = a[s + 1]);
                var o = createNS("use");
                o.setAttribute("href", "#" + e), i ? r.insertBefore(o, i) : r.appendChild(o);
            }
        }, SVGMatte3Effect.prototype.setElementAsMask = function(t, e) {
            if (!this.findSymbol(e)) {
                var r = createElementID(), i = createNS("mask");
                i.setAttribute("id", e.layerId), i.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(e);
                var a = t.globalData.defs;
                a.appendChild(i);
                var s = createNS("symbol");
                s.setAttribute("id", r), this.replaceInParent(e, r), s.appendChild(e.layerElement), a.appendChild(s);
                var n = createNS("use");
                n.setAttribute("href", "#" + r), i.appendChild(n), e.data.hd = !1, e.show();
            }
            t.setMatte(e.layerId);
        }, SVGMatte3Effect.prototype.initialize = function() {
            for(var t = this.filterManager.effectElements[0].p.v, e = this.elem.comp.elements, r = 0, i = e.length; r < i;)e[r] && e[r].data.ind === t && this.setElementAsMask(this.elem, e[r]), r += 1;
            this.initialized = !0;
        }, SVGMatte3Effect.prototype.renderFrame = function() {
            this.initialized || this.initialize();
        }, SVGGaussianBlurEffect.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = .3 * this.filterManager.effectElements[0].p.v, r = this.filterManager.effectElements[1].p.v, i = 3 == r ? 0 : e, a = 2 == r ? 0 : e;
                this.feGaussianBlur.setAttribute("stdDeviation", i + " " + a);
                var s = 1 == this.filterManager.effectElements[2].p.v ? "wrap" : "duplicate";
                this.feGaussianBlur.setAttribute("edgeMode", s);
            }
        }, TransformEffect.prototype.init = function(t) {
            this.effectsManager = t, this.type = effectTypes.TRANSFORM_EFFECT, this.matrix = new Matrix, this.opacity = -1, this._mdf = !1, this._opMdf = !1;
        }, TransformEffect.prototype.renderFrame = function(t) {
            if (this._opMdf = !1, this._mdf = !1, t || this.effectsManager._mdf) {
                var e = this.effectsManager.effectElements, r = e[0].p.v, i = e[1].p.v, a = 1 === e[2].p.v, s = e[3].p.v, n = a ? s : e[4].p.v, o = e[5].p.v, h = e[6].p.v, l = e[7].p.v;
                this.matrix.reset(), this.matrix.translate(-r[0], -r[1], r[2]), this.matrix.scale(.01 * n, .01 * s, 1), this.matrix.rotate(-l * degToRads), this.matrix.skewFromAxis(-o * degToRads, (h + 90) * degToRads), this.matrix.translate(i[0], i[1], 0), this._mdf = !0, this.opacity !== e[8].p.v && (this.opacity = e[8].p.v, this._opMdf = !0);
            }
        }, extendPrototype([
            TransformEffect
        ], SVGTransformEffect), extendPrototype([
            TransformEffect
        ], CVTransformEffect), registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect$1(20, SVGTintFilter, !0), registerEffect$1(21, SVGFillFilter, !0), registerEffect$1(22, SVGStrokeEffect, !1), registerEffect$1(23, SVGTritoneFilter, !0), registerEffect$1(24, SVGProLevelsFilter, !0), registerEffect$1(25, SVGDropShadowEffect, !0), registerEffect$1(28, SVGMatte3Effect, !1), registerEffect$1(29, SVGGaussianBlurEffect, !0), registerEffect$1(35, SVGTransformEffect, !1), registerEffect(35, CVTransformEffect), lottie;
    });
}), REACT_LOTTIE_PLAYER_VERSION = "3.5.4", LOTTIE_WEB_VERSION = "^5.12.2", PlayerState, PlayerEvent;
function parseSrc(t) {
    if ("object" == typeof t) return t;
    try {
        return JSON.parse(t);
    } catch (t) {}
    try {
        return new URL(t).toString();
    } catch (t) {}
    return t;
}
!function(t) {
    t.Loading = "loading", t.Playing = "playing", t.Paused = "paused", t.Stopped = "stopped", t.Frozen = "frozen", t.Error = "error";
}(PlayerState || (PlayerState = {})), function(t) {
    t.Load = "load", t.InstanceSaved = "instanceSaved", t.Error = "error", t.Ready = "ready", t.Play = "play", t.Pause = "pause", t.Stop = "stop", t.Freeze = "freeze", t.Loop = "loop", t.Complete = "complete", t.Frame = "frame";
}(PlayerEvent || (PlayerEvent = {}));
var defaultOptions = {
    clearCanvas: !1,
    hideOnTransparent: !0,
    progressiveLoad: !0
}, Player = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.container = null, r.unmounted = !1, r.handleBgChange = function(t) {
            r.setState({
                background: t
            });
        }, r.triggerDownload = function(t, e) {
            var r = document.createElement("a");
            r.href = t, r.download = e, document.body.appendChild(r), r.click(), document.body.removeChild(r);
        }, r.snapshot = function(t) {
            var e;
            void 0 === t && (t = !0);
            var i = r.props.id ? r.props.id : "lottie", a = document.getElementById(i);
            if ("svg" === r.props.renderer) {
                if (a) {
                    var s = a.querySelector("svg");
                    if (s) {
                        var n = (new XMLSerializer).serializeToString(s);
                        e = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(n);
                    }
                }
                t && r.triggerDownload(e, "snapshot.svg");
            } else if ("canvas" === r.props.renderer) {
                if (a) {
                    var o = a.querySelector("canvas");
                    o && (e = o.toDataURL("image/png"));
                }
                t && r.triggerDownload(e, "snapshot.png");
            }
            return e;
        }, "undefined" != typeof window && (window.lottie = lottie), r.state = {
            animationData: null,
            background: "transparent",
            containerRef: $81g6h.createRef(),
            debug: !0,
            instance: null,
            playerState: PlayerState.Loading,
            seeker: 0
        }, r;
    }
    return __extends(e, t), e.getDerivedStateFromProps = function(t, e) {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(r) {
                return t.background !== e.background ? [
                    2,
                    {
                        background: t.background
                    }
                ] : [
                    2,
                    null
                ];
            });
        });
    }, e.prototype.getVersions = function() {
        return {
            lottieWebVersion: LOTTIE_WEB_VERSION,
            lottiePlayerVersion: REACT_LOTTIE_PLAYER_VERSION
        };
    }, e.prototype.componentDidMount = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(t) {
                switch(t.label){
                    case 0:
                        return this.unmounted ? [
                            3,
                            2
                        ] : [
                            4,
                            this.createLottie()
                        ];
                    case 1:
                        t.sent(), t.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.componentWillUnmount = function() {
        this.unmounted = !0, this.state.instance && this.state.instance.destroy();
    }, e.prototype.componentDidUpdate = function(t) {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.props.src === t.src ? [
                            3,
                            2
                        ] : (this.state.instance && this.state.instance.destroy(), [
                            4,
                            this.createLottie()
                        ]);
                    case 1:
                        e.sent(), e.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.render = function() {
        var t = this, e = this.props, r = e.children, i = e.loop, a = e.style, s = e.onBackgroundChange, n = e.className, o = this.state, h = o.animationData, l = o.instance, p = o.playerState, f = o.seeker, c = o.debug, m = o.background;
        return $81g6h.createElement("div", {
            className: "lf-player-container"
        }, this.state.playerState === PlayerState.Error ? $81g6h.createElement("div", {
            className: "lf-error"
        }, $81g6h.createElement("span", {
            "aria-label": "error-symbol",
            role: "img"
        }, "\u26A0\uFE0F")) : $81g6h.createElement("div", {
            id: this.props.id ? this.props.id : "lottie",
            ref: function(e) {
                return t.container = e;
            },
            style: __assign({
                background: m,
                margin: "0 auto",
                outline: "none",
                overflow: "hidden"
            }, a),
            className: n
        }), $81g6h.Children.map(r, function(e) {
            return $81g6h.isValidElement(e) ? $81g6h.cloneElement(e, {
                animationData: h,
                background: m,
                debug: c,
                instance: l,
                loop: i,
                pause: function() {
                    return t.pause();
                },
                play: function() {
                    return t.play();
                },
                playerState: p,
                seeker: f,
                setBackground: function(e) {
                    t.setState({
                        background: e
                    }), "function" == typeof s && s(e);
                },
                setSeeker: function(e, r) {
                    return t.setSeeker(e, r);
                },
                stop: function() {
                    return t.stop();
                },
                toggleDebug: function() {
                    return t.toggleDebug();
                },
                setLoop: function(e) {
                    return t.setLoop(e);
                },
                colorChangedEvent: function(e) {
                    t.handleBgChange(e);
                },
                snapshot: function() {
                    t.snapshot();
                }
            }) : null;
        }));
    }, e.prototype.toggleDebug = function() {
        this.setState({
            debug: !this.state.debug
        });
    }, e.prototype.createLottie = function() {
        return __awaiter(this, void 0, void 0, function() {
            var t, e, r, i, a, s, n, o, h, l, p, f, c, m, d = this;
            return __generator(this, function(u) {
                switch(u.label){
                    case 0:
                        if (t = this.props, e = t.autoplay, r = t.direction, i = t.loop, a = t.lottieRef, s = t.renderer, n = t.speed, o = t.src, h = t.background, l = t.rendererSettings, p = t.hover, f = this.state.instance, !o || !this.container) return [
                            2
                        ];
                        u.label = 1;
                    case 1:
                        return u.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]), "string" != typeof (c = parseSrc(o)) ? [
                            3,
                            4
                        ] : [
                            4,
                            fetch(c).catch(function() {
                                throw d.setState({
                                    playerState: PlayerState.Error
                                }), d.triggerEvent(PlayerEvent.Error), new Error("@LottieFiles/lottie-react: Animation data could not be fetched.");
                            })
                        ];
                    case 2:
                        return [
                            4,
                            u.sent().json().catch(function() {
                                throw d.setState({
                                    playerState: PlayerState.Error
                                }), d.triggerEvent(PlayerEvent.Error), new Error("@LottieFiles/lottie-react: Animation data could not be fetched.");
                            })
                        ];
                    case 3:
                        c = u.sent(), u.label = 4;
                    case 4:
                        return f && f.destroy(), m = lottie.loadAnimation({
                            rendererSettings: l || defaultOptions,
                            animationData: c,
                            autoplay: e || !1,
                            container: this.container,
                            loop: i || !1,
                            renderer: s
                        }), n && m.setSpeed(n), this.setState({
                            animationData: c
                        }), this.setState({
                            instance: m
                        }, function() {
                            d.triggerEvent(PlayerEvent.InstanceSaved), "function" == typeof a && a(m), e && d.play();
                        }), m.addEventListener("enterFrame", function() {
                            d.triggerEvent(PlayerEvent.Frame), d.setState({
                                seeker: Math.floor(m.currentFrame)
                            });
                        }), m.addEventListener("DOMLoaded", function() {
                            d.triggerEvent(PlayerEvent.Load);
                        }), m.addEventListener("data_ready", function() {
                            d.triggerEvent(PlayerEvent.Ready);
                        }), m.addEventListener("data_failed", function() {
                            d.setState({
                                playerState: PlayerState.Error
                            }), d.triggerEvent(PlayerEvent.Error);
                        }), m.addEventListener("loopComplete", function() {
                            d.triggerEvent(PlayerEvent.Loop);
                        }), m.addEventListener("complete", function() {
                            d.triggerEvent(PlayerEvent.Complete), d.setState({
                                playerState: PlayerState.Paused
                            }), d.props.keepLastFrame && !d.props.loop || d.setSeeker(0);
                        }), this.container && (this.container.addEventListener("mouseenter", function() {
                            p && d.state.playerState !== PlayerState.Playing && (d.props.keepLastFrame && d.stop(), d.play());
                        }), this.container.addEventListener("mouseleave", function() {
                            p && d.state.playerState === PlayerState.Playing && d.stop();
                        })), n && this.setPlayerSpeed(n), r && this.setPlayerDirection(r), h && this.setState({
                            background: h
                        }), [
                            3,
                            6
                        ];
                    case 5:
                        return u.sent(), this.setState({
                            playerState: PlayerState.Error
                        }), this.triggerEvent(PlayerEvent.Error), [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.prototype.play = function() {
        var t = this.state.instance;
        t && (this.triggerEvent(PlayerEvent.Play), t.play(), this.setState({
            playerState: PlayerState.Playing
        }));
    }, e.prototype.pause = function() {
        var t = this.state.instance;
        t && (this.triggerEvent(PlayerEvent.Pause), t.pause(), this.setState({
            playerState: PlayerState.Paused
        }));
    }, e.prototype.stop = function() {
        var t = this.state.instance;
        t && (this.triggerEvent(PlayerEvent.Stop), t.stop(), this.setState({
            playerState: PlayerState.Stopped
        }));
    }, e.prototype.setPlayerSpeed = function(t) {
        var e = this.state.instance;
        e && e.setSpeed(t);
    }, e.prototype.setPlayerDirection = function(t) {
        var e = this.state.instance;
        e && e.setDirection(t);
    }, e.prototype.setSeeker = function(t, e) {
        void 0 === e && (e = !1);
        var r = this.state, i = r.instance, a = r.playerState;
        i && (e && a === PlayerState.Playing ? i.goToAndPlay(t, !0) : (i.goToAndStop(t, !0), this.triggerEvent(PlayerEvent.Pause), this.setState({
            playerState: PlayerState.Paused
        })));
    }, e.prototype.setLoop = function(t) {
        var e = this.state.instance;
        e && (e.loop = t, this.setState({
            instance: e
        }));
    }, e.prototype.triggerEvent = function(t) {
        var e = this.props.onEvent;
        e && e(t);
    }, e.defaultProps = {
        loop: !1
    }, e;
}($81g6h.Component);
function styleInject(t, e) {
    void 0 === e && (e = {});
    var r = e.insertAt;
    if (t && "undefined" != typeof document) {
        var i = document.head || document.getElementsByTagName("head")[0], a = document.createElement("style");
        a.type = "text/css", "top" === r && i.firstChild ? i.insertBefore(a, i.firstChild) : i.appendChild(a), a.styleSheet ? a.styleSheet.cssText = t : a.appendChild(document.createTextNode(t));
    }
}
var css_248z = ".lf-progress {\n  -webkit-appearance: none;\n  -moz-apperance: none;\n  width: 100%;\n  /* margin: 0 10px; */\n  height: 4px;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.lf-progress:focus {\n  outline: none;\n  border: none;\n}\n.lf-progress::-moz-range-track {\n  cursor: pointer;\n  background: none;\n  border: none;\n  outline: none;\n}\n.lf-progress::-webkit-slider-thumb {\n  -webkit-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-moz-range-thumb {\n  -moz-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-ms-track {\n  width: 100%;\n  height: 3px;\n  cursor: pointer;\n  background: transparent;\n  border-color: transparent;\n  color: transparent;\n}\n.lf-progress::-ms-fill-lower {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-fill-upper {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-thumb {\n  border: 0;\n  height: 15px;\n  width: 15px;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress:focus::-ms-fill-lower {\n  background: #ccc;\n}\n.lf-progress:focus::-ms-fill-upper {\n  background: #ccc;\n}\n.lf-player-container :focus {\n  outline: 0;\n}\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  opacity: 1;\n  visibility: visible;\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-player-btn-container {\n  display: flex;\n  align-items: center;\n}\n.lf-player-btn {\n  cursor: pointer;\n  fill: #999;\n  width: 14px;\n}\n\n.lf-player-btn.active {\n  fill: #555;\n}\n\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  background-color: #ffffff;\n  opacity: 1;\n\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n  padding: 10px;\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-arrow {\n  position: absolute;\n  z-index: -1;\n  content: '';\n  bottom: -9px;\n  border-style: solid;\n  border-width: 10px 10px 0px 10px;\n}\n\n.lf-left-align,\n.lf-left-align .lfarrow {\n  left: 0;\n  right: unset;\n}\n\n.lf-right-align,\n.lf-right-align .lf-arrow {\n  right: 0;\n  left: unset;\n}\n\n.lf-text-input {\n  border: 1px #ccc solid;\n  border-radius: 5px;\n  padding: 3px;\n  width: 60px;\n  margin: 0;\n}\n\n.lf-color-picker {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  height: 90px;\n}\n\n.lf-color-selectors {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.lf-color-component {\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  align-items: center;\n  justify-content: center;\n}\n\n.lf-color-component strong {\n  width: 40px;\n}\n\n.lf-color-component input[type='range'] {\n  margin: 0 0 0 10px;\n}\n\n.lf-color-component input[type='number'] {\n  width: 50px;\n  margin: 0 0 0 10px;\n}\n\n.lf-color-preview {\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 5px;\n}\n\n.lf-preview {\n  height: 60px;\n  width: 60px;\n}\n\n.lf-popover-snapshot {\n  width: 150px;\n}\n.lf-popover-snapshot h5 {\n  margin: 5px 0 10px 0;\n  font-size: 0.75rem;\n}\n.lf-popover-snapshot a {\n  display: block;\n  text-decoration: none;\n}\n.lf-popover-snapshot a:before {\n  content: '\u297C';\n  margin-right: 5px;\n}\n.lf-popover-snapshot .lf-note {\n  display: block;\n  margin-top: 10px;\n  color: #999;\n}\n.lf-player-controls > div {\n  margin-right: 5px;\n  margin-left: 5px;\n}\n.lf-player-controls > div:first-child {\n  margin-left: 0px;\n}\n.lf-player-controls > div:last-child {\n  margin-right: 0px;\n}\n", stylesheet = ".lf-progress {\n  -webkit-appearance: none;\n  -moz-apperance: none;\n  width: 100%;\n  /* margin: 0 10px; */\n  height: 4px;\n  border-radius: 3px;\n  cursor: pointer;\n}\n.lf-progress:focus {\n  outline: none;\n  border: none;\n}\n.lf-progress::-moz-range-track {\n  cursor: pointer;\n  background: none;\n  border: none;\n  outline: none;\n}\n.lf-progress::-webkit-slider-thumb {\n  -webkit-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-moz-range-thumb {\n  -moz-appearance: none !important;\n  height: 13px;\n  width: 13px;\n  border: 0;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress::-ms-track {\n  width: 100%;\n  height: 3px;\n  cursor: pointer;\n  background: transparent;\n  border-color: transparent;\n  color: transparent;\n}\n.lf-progress::-ms-fill-lower {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-fill-upper {\n  background: #ccc;\n  border-radius: 3px;\n}\n.lf-progress::-ms-thumb {\n  border: 0;\n  height: 15px;\n  width: 15px;\n  border-radius: 50%;\n  background: #0fccce;\n  cursor: pointer;\n}\n.lf-progress:focus::-ms-fill-lower {\n  background: #ccc;\n}\n.lf-progress:focus::-ms-fill-upper {\n  background: #ccc;\n}\n.lf-player-container :focus {\n  outline: 0;\n}\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  opacity: 1;\n  visibility: visible;\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-player-btn-container {\n  display: flex;\n  align-items: center;\n}\n.lf-player-btn {\n  cursor: pointer;\n  fill: #999;\n  width: 14px;\n}\n\n.lf-player-btn.active {\n  fill: #555;\n}\n\n.lf-popover {\n  position: relative;\n}\n\n.lf-popover-content {\n  display: inline-block;\n  position: absolute;\n  background-color: #ffffff;\n  opacity: 1;\n\n  transform: translate(0, -10px);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);\n  transition: all 0.3s cubic-bezier(0.75, -0.02, 0.2, 0.97);\n  padding: 10px;\n}\n\n.lf-popover-content.hidden {\n  opacity: 0;\n  visibility: hidden;\n  transform: translate(0, 0px);\n}\n\n.lf-arrow {\n  position: absolute;\n  z-index: -1;\n  content: '';\n  bottom: -9px;\n  border-style: solid;\n  border-width: 10px 10px 0px 10px;\n}\n\n.lf-left-align,\n.lf-left-align .lfarrow {\n  left: 0;\n  right: unset;\n}\n\n.lf-right-align,\n.lf-right-align .lf-arrow {\n  right: 0;\n  left: unset;\n}\n\n.lf-text-input {\n  border: 1px #ccc solid;\n  border-radius: 5px;\n  padding: 3px;\n  width: 60px;\n  margin: 0;\n}\n\n.lf-color-picker {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  height: 90px;\n}\n\n.lf-color-selectors {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.lf-color-component {\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  align-items: center;\n  justify-content: center;\n}\n\n.lf-color-component strong {\n  width: 40px;\n}\n\n.lf-color-component input[type='range'] {\n  margin: 0 0 0 10px;\n}\n\n.lf-color-component input[type='number'] {\n  width: 50px;\n  margin: 0 0 0 10px;\n}\n\n.lf-color-preview {\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 5px;\n}\n\n.lf-preview {\n  height: 60px;\n  width: 60px;\n}\n\n.lf-popover-snapshot {\n  width: 150px;\n}\n.lf-popover-snapshot h5 {\n  margin: 5px 0 10px 0;\n  font-size: 0.75rem;\n}\n.lf-popover-snapshot a {\n  display: block;\n  text-decoration: none;\n}\n.lf-popover-snapshot a:before {\n  content: '\u297C';\n  margin-right: 5px;\n}\n.lf-popover-snapshot .lf-note {\n  display: block;\n  margin-top: 10px;\n  color: #999;\n}\n.lf-player-controls > div {\n  margin-right: 5px;\n  margin-left: 5px;\n}\n.lf-player-controls > div:first-child {\n  margin-left: 0px;\n}\n.lf-player-controls > div:last-child {\n  margin-right: 0px;\n}\n";
styleInject(css_248z);
var ColorPicker = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.state = {
            red: 0,
            green: 0,
            blue: 0,
            rgba: null,
            hex: "#000000",
            colorComponents: []
        }, e.handleChange = function(t, r) {
            if ("r" === t) {
                var i = "#" + (256 | r).toString(16).slice(1) + (256 | e.state.green).toString(16).slice(1) + (256 | e.state.blue).toString(16).slice(1);
                e.setState({
                    hex: i
                });
            } else if ("g" === t) {
                i = "#" + (256 | e.state.red).toString(16).slice(1) + (256 | r).toString(16).slice(1) + (256 | e.state.blue).toString(16).slice(1);
                e.setState({
                    hex: i
                });
            } else if ("b" === t) {
                i = "#" + (256 | e.state.red).toString(16).slice(1) + (256 | e.state.green).toString(16).slice(1) + (256 | r).toString(16).slice(1);
                e.setState({
                    hex: i
                });
            }
        }, e.parseColor = function(t) {
            var r;
            if ("string" == typeof t) {
                if ("#" === t[0]) {
                    var i = 4 === t.length ? [
                        t.slice(1, 2),
                        t.slice(2, 3),
                        t.slice(3, 4)
                    ].map(function(t) {
                        return parseInt("" + t + t, 16);
                    }) : [
                        t.slice(1, 3),
                        t.slice(3, 5),
                        t.slice(5, 7)
                    ].map(function(t) {
                        return parseInt(t, 16);
                    });
                    e.setState({
                        colorComponents: i
                    });
                } else if (t.startsWith("rgb")) void 0 !== (i = null === (r = t.match(/\d+/g)) || void 0 === r ? void 0 : r.map(function(t) {
                    return parseInt(t);
                })) && e.setState({
                    colorComponents: i
                });
                e.state.colorComponents.length && (e.setState({
                    red: e.state.colorComponents[0]
                }), e.setState({
                    green: e.state.colorComponents[1]
                }), e.setState({
                    blue: e.state.colorComponents[2]
                }));
            }
        }, e;
    }
    return __extends(e, t), e.prototype.componentDidUpdate = function(t, e) {
        return this.props.colorChangedEvent && this.state.hex !== e.hex && this.props.colorChangedEvent(this.state.hex), !0;
    }, e.prototype.render = function() {
        var t = this;
        return $81g6h.createElement("div", {
            className: "lf-color-picker"
        }, $81g6h.createElement("div", {
            className: "lf-color-selectors"
        }, $81g6h.createElement("div", {
            className: "lf-color-component"
        }, $81g6h.createElement("strong", null, "Red"), $81g6h.createElement("input", {
            type: "range",
            min: "0",
            max: "255",
            value: this.state.red,
            onChange: function(e) {
                t.setState({
                    red: e.target.value
                }), t.handleChange("r", e.target.value);
            }
        }), $81g6h.createElement("input", {
            className: "lf-text-input",
            type: "number",
            min: "0",
            max: "255",
            value: this.state.red,
            onChange: function(e) {
                t.setState({
                    red: e.target.value
                }), t.handleChange("r", e.target.value);
            }
        })), $81g6h.createElement("div", {
            className: "lf-color-component"
        }, $81g6h.createElement("strong", null, "Green"), $81g6h.createElement("input", {
            type: "range",
            min: "0",
            max: "255",
            value: this.state.green,
            onChange: function(e) {
                t.setState({
                    green: e.target.value
                }), t.handleChange("g", e.target.value);
            }
        }), $81g6h.createElement("input", {
            className: "lf-text-input",
            type: "number",
            min: "0",
            max: "255",
            value: this.state.green,
            onChange: function(e) {
                t.setState({
                    green: e.target.value
                }), t.handleChange("g", e.target.value);
            }
        })), $81g6h.createElement("div", {
            className: "lf-color-component"
        }, $81g6h.createElement("strong", null, "Blue"), $81g6h.createElement("input", {
            type: "range",
            min: "0",
            max: "255",
            value: this.state.blue,
            onChange: function(e) {
                t.setState({
                    blue: e.target.value
                }), t.handleChange("b", e.target.value);
            }
        }), $81g6h.createElement("input", {
            className: "lf-text-input",
            type: "number",
            min: "0",
            max: "255",
            value: this.state.blue,
            onChange: function(e) {
                t.setState({
                    blue: e.target.value
                }), t.handleChange("b", e.target.value);
            }
        }))), $81g6h.createElement("div", {
            className: "lf-color-preview"
        }, $81g6h.createElement("div", {
            className: "lf-preview",
            style: {
                background: "rgb(" + this.state.red + ", " + this.state.green + ", " + this.state.blue + ")"
            }
        }), $81g6h.createElement("div", null, $81g6h.createElement("input", {
            className: "lf-text-input",
            type: "text",
            value: this.state.hex,
            onChange: function(e) {
                t.setState({
                    hex: e.target.value
                }), t.parseColor(e.target.value);
            }
        }))));
    }, e;
}($81g6h.Component), Popover = function(t) {
    var e = t.children, r = t.icon, i = (0, $81g6h.useState)(null), a = i[0], s = i[1], n = (0, $81g6h.useState)(null), o = n[0], h = n[1], l = (0, $81g6h.useState)(null), p = l[0], f = l[1], c = (0, $81g6h.useState)(!1), m = c[0], d = c[1];
    (0, $81g6h.useEffect)(function() {
        if (a && o) {
            var t = a.getBoundingClientRect(), e = o.getBoundingClientRect(), r = t.left + e.width > window.innerWidth ? -1 : 0;
            f(r);
        }
    }, [
        p,
        o,
        a
    ]);
    return $81g6h.createElement("div", {
        className: "lf-popover",
        onMouseOver: function() {
            d(!0);
        },
        onMouseLeave: function() {
            d(!1);
        },
        ref: function(t) {
            s(t);
        }
    }, $81g6h.createElement("div", {
        className: " lf-player-btn"
    }, r), $81g6h.createElement("div", {
        className: "lf-popover-content",
        ref: function(t) {
            h(t);
        },
        style: {
            bottom: "22px",
            right: "0px",
            zIndex: 2,
            visibility: m ? "visible" : "hidden"
        }
    }, e));
}, Seeker = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.inputRef = $81g6h.createRef(), r.handleChange = function() {
            return function(t) {
                var e = t.target.value, i = Math.floor(e / 100 * r.props.max);
                r.props.onChange(i);
            };
        }, r.state = {
            value: 0
        }, r;
    }
    return __extends(e, t), e.prototype.render = function() {
        var t = this.props.value / this.props.max * 100, e = {
            backgroundImage: "-webkit-gradient(linear, left top, right top, color-stop(" + t + "%, rgba(15, 204, 206, 0.4)), color-stop(" + t + "%, #DAE1E7))"
        }, r = {
            position: "absolute",
            left: 0,
            marginTop: "8px",
            width: "20px",
            display: "block",
            border: "0px",
            backgroundColor: this.props.darkTheme ? "#505050" : "rgb(218, 225, 231)",
            color: this.props.darkTheme ? "#B9B9B9" : "#555",
            padding: "2px",
            textAlign: "center",
            borderRadius: "3px",
            fontSize: "8px",
            fontWeight: "bold"
        }, i = {
            position: "absolute",
            right: 0,
            marginTop: "8px",
            width: "20px",
            display: "block",
            border: "0px",
            backgroundColor: this.props.darkTheme ? "#505050" : "rgb(218, 225, 231)",
            color: this.props.darkTheme ? "#B9B9B9" : "#555",
            padding: "2px",
            textAlign: "center",
            borderRadius: "3px",
            fontSize: "8px",
            fontWeight: "bold"
        };
        return $81g6h.createElement("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                marginRight: "5px",
                marginLeft: "5px",
                position: "relative"
            }
        }, $81g6h.createElement("input", {
            ref: this.inputRef,
            id: "track",
            className: "lf-progress",
            name: "progress",
            "aria-label": "progress",
            type: "range",
            min: "0",
            max: "100",
            step: "0.1",
            value: t,
            onInput: this.handleChange(),
            onChange: this.handleChange(),
            style: e
        }), this.props.showLabels && $81g6h.createElement("div", {
            style: {
                display: "flex",
                justifyContent: "space-between"
            }
        }, $81g6h.createElement("div", {
            style: r
        }, this.props.min), $81g6h.createElement("div", {
            style: i
        }, this.props.max)));
    }, e;
}($81g6h.Component), ControlButtonStyle = {
    display: "inline-flex",
    cursor: "pointer"
}, Controls = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.state = {
            activeFrame: 0,
            mouseDown: !1
        }, r;
    }
    return __extends(e, t), e.prototype.render = function() {
        var t = this, e = this.props, r = e.instance, i = e.playerState, a = e.seeker, s = e.setLoop, n = e.setSeeker, o = e.play, h = e.pause, l = e.stop, p = e.visible, f = e.buttons;
        if (!r) return null;
        if (!p) return null;
        var c = !f || f.includes("play"), m = !f || f.includes("stop"), d = !f || f.includes("repeat"), u = !f || f.includes("frame"), y = !f || f.includes("background"), g = !f || f.includes("snapshot"), v = {
            width: 14,
            height: 14,
            viewBox: "0 0 24 24"
        }, b = Math.round(r.currentFrame);
        return $81g6h.createElement("div", {
            className: "lf-player-controls",
            style: {
                display: "flex",
                justifyContent: "space-between",
                height: "60px",
                alignItems: "center",
                backgroundColor: this.props.transparentTheme ? "transparent" : this.props.darkTheme ? "#3C3C3C" : "#ffffff",
                paddingLeft: "10px",
                paddingRight: "10px"
            }
        }, c && $81g6h.createElement("div", {
            role: "button",
            "aria-label": i === PlayerState.Playing ? PlayerEvent.Pause : PlayerEvent.Play,
            tabIndex: 0,
            onClick: function() {
                i === PlayerState.Playing ? "function" == typeof h && h() : "function" == typeof o && o();
            },
            onKeyDown: function() {
                i === PlayerState.Playing ? "function" == typeof h && h() : "function" == typeof o && o();
            },
            className: "lf-player-btn",
            style: ControlButtonStyle
        }, i === PlayerState.Playing ? $81g6h.createElement("svg", __assign({}, v), $81g6h.createElement("rect", {
            height: "22.9",
            rx: "1.9",
            width: "7.6",
            x: "14",
            y: ".5"
        }), $81g6h.createElement("rect", {
            height: "22.9",
            rx: "1.9",
            width: "7.6",
            x: "2",
            y: ".5"
        })) : $81g6h.createElement("svg", __assign({}, v), $81g6h.createElement("path", {
            d: "M2 3.4C2 1.9 3.5 1 4.8 1.8l16.5 9.6c1.2.7 1.2 2.5 0 3.2L4.8 24.2C3.5 25 2 24.1 2 22.6V3.4z"
        }))), m && $81g6h.createElement("div", {
            tabIndex: 0,
            role: "button",
            "aria-label": PlayerEvent.Stop,
            onClick: function() {
                return l && l();
            },
            onKeyDown: function() {
                return l && l();
            },
            className: i === PlayerState.Stopped ? "lf-player-btn active" : "lf-player-btn",
            style: ControlButtonStyle
        }, $81g6h.createElement("svg", __assign({}, v), $81g6h.createElement("path", {
            d: "M2 3.667A1.67 1.67 0 0 1 3.667 2h16.666A1.67 1.67 0 0 1 22 3.667v16.666A1.67 1.67 0 0 1 20.333\n            22H3.667A1.67 1.67 0 0 1 2 20.333z"
        }))), $81g6h.createElement(Seeker, {
            min: 0,
            step: 1,
            max: r ? r.totalFrames : 1,
            value: a || 0,
            onChange: function(e) {
                n && t.setState({
                    activeFrame: e
                }, function() {
                    n(e, !1);
                });
            },
            onChangeEnd: function(e) {
                n && t.setState({
                    activeFrame: e
                }, function() {
                    n(e, !1);
                });
            },
            showLabels: this.props.showLabels,
            darkTheme: this.props.darkTheme
        }), u && $81g6h.createElement("div", {
            role: "button",
            className: "lf-player-btn-container"
        }, $81g6h.createElement("input", {
            style: {
                outline: "none",
                border: this.props.darkTheme ? "1px #505050 solid" : "1px #ccc solid",
                borderRadius: "3px",
                width: "40px",
                textAlign: "center",
                backgroundColor: this.props.darkTheme ? "#505050" : "#ffffff",
                color: this.props.darkTheme ? "#B9B9B9" : "#999",
                fontSize: "0.7rem",
                padding: "0",
                fontFamily: "inherit"
            },
            type: "text",
            value: b,
            readOnly: !0
        })), d && $81g6h.createElement("div", {
            role: "button",
            "aria-label": PlayerEvent.Loop,
            tabIndex: 0,
            onClick: function() {
                r && s && s(!r.loop);
            },
            onKeyDown: function() {
                r && s && s(!r.loop);
            },
            className: r.loop ? "lf-player-btn active" : "lf-player-btn",
            style: ControlButtonStyle
        }, $81g6h.createElement("svg", __assign({}, v), $81g6h.createElement("path", {
            d: "M12.5 16.8137h-.13v1.8939h4.9696c3.6455 0 6.6113-2.9658 6.6113-6.6116\n            0-3.64549-2.9658-6.61131-6.6113-6.61131-.5231 0-.947.42391-.947.94696 0 .52304.4239.94696.947.94696 2.6011 0\n            4.7174 2.11634 4.7174 4.71739 0 2.6014-2.1166 4.7177-4.7174 4.7177H12.5zM13.6025\n            5.61469v-.13H7.48137C3.83582 5.48469.87 8.45051.87 12.096c0 3.6509 3.17269 6.6117 6.81304 6.6117.52304 0\n            .94696-.424.94696-.947 0-.5231-.42392-.947-.94696-.947-2.60804 0-4.91907-2.1231-4.91907-4.7176 0-2.60115\n            2.11634-4.71744 4.7174-4.71744h6.12113V5.61469z",
            stroke: "#8795A1",
            strokeWidth: ".26"
        }), $81g6h.createElement("path", {
            d: "M11.1482\n            2.20355h0l-.001-.00116c-.3412-.40061-.9405-.44558-1.33668-.0996h-.00001c-.39526.34519-.43936.94795-.09898\n            1.34767l2.51487 3.03683-2.51894 3.06468c-.33872.40088-.29282 1.00363.10347\n            1.34723l.08517-.0982-.08517.0982c.17853.1549.39807.2308.61647.2308.2671 0 .5328-.114.72-.3347h0l.0011-.0014\n            3.0435-3.68655.0006-.00068c.3035-.35872.3025-.88754-.0019-1.24526l-3.0425-3.65786zM13.9453\n            21.7965h0l.001.0011c.3413.4006.9407.4456 1.337.0996h0c.3953-.3452.4395-.9479.099-1.3477l-2.5154-3.0368\n            2.5195-3.0647c.3388-.4008.2929-1.0036-.1035-1.3472l-.0852.0982.0852-.0982c-.1786-.1549-.3981-.2308-.6166-.2308-.2671\n            0-.5329.114-.7202.3347h0l-.0011.0014-3.0442\n            3.6865c-.0001.0003-.0003.0005-.0005.0007-.3036.3587-.3027.8876.0019 1.2453l3.0431 3.6579z",
            fill: "#8795A1",
            stroke: "#8795A1",
            strokeWidth: ".26"
        }))), y && $81g6h.createElement(Popover, {
            icon: $81g6h.createElement("svg", __assign({}, v), $81g6h.createElement("path", {
                d: "M12 3.1L6.1 8.6a7.6 7.6 0 00-2.2 4 7.2 7.2 0 00.4 4.4 7.9 7.9 0 003 3.5 8.7 8.7 0 004.7 1.3c1.6 0\n            3.2-.5 4.6-1.3s2.4-2 3-3.5a7.2 7.2 0 00.5-4.5 7.6 7.6 0 00-2.2-4L12 3.2zM12 0l7.5 7a9.8 9.8 0 013 5.1\n            9.3 9.3 0 01-.6 5.8c-.9 1.8-2.2 3.3-4 4.4A11.2 11.2 0 0112 24a11.2 11.2 0\n            01-6-1.7c-1.7-1-3-2.6-3.9-4.4a9.3 9.3 0 01-.6-5.8c.4-2 1.5-3.7 3-5L12 0zM6 14h12c0 1.5-.7 3-1.8 4s-2.6\n            1.6-4.2 1.6S9 19 7.8 18s-1.7-2.5-1.7-4z"
            }))
        }, $81g6h.createElement("div", {
            slot: "content",
            className: "lf-popover popover-background"
        }, $81g6h.createElement(ColorPicker, {
            colorChangedEvent: this.props.colorChangedEvent
        }))), g && $81g6h.createElement(Popover, {
            icon: $81g6h.createElement("svg", __assign({}, v), $81g6h.createElement("path", {
                clipRule: "evenodd",
                d: "M0 3.01A2.983 2.983 0 012.983.027H16.99a2.983 2.983 0 012.983 2.983v14.008a2.982 2.982 0 01-2.983\n              2.983H2.983A2.983 2.983 0 010 17.018zm2.983-.941a.941.941 0 00-.942.94v14.01c0\n              .52.422.94.942.94H16.99a.94.94 0 00.941-.94V3.008a.941.941 0 00-.94-.94H2.981z",
                fillRule: "evenodd"
            }), $81g6h.createElement("path", {
                d: "M12.229 7.945l-2.07 4.598-2.586-2.605-2.414 2.758v2.146h9.656V11.93z"
            }), $81g6h.createElement("circle", {
                cx: "7.444",
                cy: "6.513",
                r: "2.032"
            }), $81g6h.createElement("path", {
                d: "M9.561 23.916h11.25a2.929 2.929 0 002.926-2.927V9.954a1.06 1.06 0 10-2.122 0v11.035a.805.805 0\n              01-.803.804H9.562a1.061 1.061 0 100 2.123z",
                stroke: "#8795a1",
                strokeWidth: ".215"
            }))
        }, $81g6h.createElement("div", {
            slot: "content",
            className: "lf-popover lf-popover-snapshot",
            onWheel: function(t) {
                n && n(b + (t.deltaY > 0 ? -1 : 1), !1);
            }
        }, $81g6h.createElement("h5", null, "Frame ", b), $81g6h.createElement("div", {
            style: {
                cursor: "pointer",
                color: "#0FCCCE"
            },
            onClick: this.props.snapshot
        }, "Download SVG"), $81g6h.createElement("div", {
            style: {
                cursor: "pointer",
                color: "#0FCCCE"
            },
            onClick: this.props.snapshot
        }, "Download PNG"), $81g6h.createElement("i", {
            className: "lf-note"
        }, "Scroll with mousewheel to find exact frame"))));
    }, e;
}($81g6h.Component);

});

parcelRegister("62Ten", function(module, exports) {

$parcel$export(module.exports, "AddAlternativesButton", () => $50cd356356ea87c9$export$8423392a867d396b);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $isRr9 = parcelRequire("isRr9");

var $5UMQ1 = parcelRequire("5UMQ1");

var $9f2ha = parcelRequire("9f2ha");

var $3cSmf = parcelRequire("3cSmf");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $dU78w = parcelRequire("dU78w");

var $1IWnK = parcelRequire("1IWnK");

var $9d072 = parcelRequire("9d072");

var $81g6h = parcelRequire("81g6h");
var $50cd356356ea87c9$var$PlusIcon = function PlusIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M11 13H6a.967.967 0 0 1-.713-.287A.968.968 0 0 1 5 12c0-.283.096-.52.287-.713A.967.967 0 0 1 6 11h5V6c0-.283.096-.52.287-.713A.968.968 0 0 1 12 5c.283 0 .52.096.713.287.191.192.287.43.287.713v5h5c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 18 13h-5v5c0 .283-.096.52-.287.712A.968.968 0 0 1 12 19a.968.968 0 0 1-.713-.288A.968.968 0 0 1 11 18v-5Z",
            fill: "currentColor"
        })
    });
};
$50cd356356ea87c9$var$PlusIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $50cd356356ea87c9$export$8423392a867d396b = ({ onClick: onClick, alternatives: alternatives, shouldAnimateSuccess: shouldAnimateSuccess, shouldDisplayHalo: shouldDisplayHalo })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const [isHovering, setIsHovering] = (0, $81g6h.useState)(false);
    const signalHalo = (0, $1IWnK.useObservable)((0, $9d072.alternativeHaloVisible));
    const showHalo = signalHalo && (shouldDisplayHalo ?? true);
    const buttonRef = (0, $81g6h.useRef)(null);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($50cd356356ea87c9$var$Container, {
        onClick: async ()=>{
            if (signalHalo) {
                (0, $9d072.resetAlternativeGuide3)();
                (0, $9d072.requestAlternativePanelQuickstartGuide)();
                (0, $9d072.showAlternativeGuide3)();
            }
            (0, $9d072.hideAlternativeHalo)();
            (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).ALTERNATIVE_EXERCISES_GUIDE_01, true);
            onClick();
        },
        onMouseEnter: ()=>{
            setIsHovering(true);
        },
        onMouseOver: ()=>{
            setIsHovering(true);
        },
        onMouseLeave: ()=>{
            setIsHovering(false);
        },
        children: [
            shouldAnimateSuccess && alternatives.length > 0 && /*#__PURE__*/ (0, $iKObn.jsx)($50cd356356ea87c9$var$GreenHalo, {
                style: {
                    width: buttonRef.current?.clientWidth
                },
                animate: {
                    scale: [
                        0,
                        1.1,
                        1.1
                    ],
                    scaleY: [
                        0,
                        1.2,
                        1.2
                    ],
                    opacity: [
                        0,
                        0.15,
                        0
                    ]
                },
                transition: {
                    duration: 0.6,
                    delay: 0.3
                }
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($50cd356356ea87c9$var$AddButton, {
                ref: buttonRef,
                hasAlreadySomeAlternatives: alternatives.length > 0,
                isHovering: isHovering,
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $9f2ha.AnimatedHalo), {
                    shouldDisplayHalo: showHalo,
                    children: /*#__PURE__*/ (0, $iKObn.jsxs)($50cd356356ea87c9$var$AddButtonContent, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($50cd356356ea87c9$var$PlusIcon, {}),
                            /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                                className: "p-size-s-bold",
                                style: {
                                    fontWeight: 600
                                },
                                children: format("programBuilder.exerciseCard.addAlternative", {
                                    alternativesCount: alternatives.length
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
const $50cd356356ea87c9$var$Container = (0, $5UMQ1.default).div`
	height: 24px;
	padding: 0 16px;
	cursor: pointer;
`;
const $50cd356356ea87c9$var$resolveAddButtonColor = (hasAlreadySomeAlternatives, isHovering)=>{
    if (isHovering) return hasAlreadySomeAlternatives ? (0, $kKnoQ.colors).validationDark : (0, $kKnoQ.colors).primary;
    return hasAlreadySomeAlternatives ? (0, $kKnoQ.colors).validation : (0, $kKnoQ.colors).grey;
};
const $50cd356356ea87c9$var$AddButton = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(0, "flexstart", "center")};
	width: max-content;
	color: ${({ hasAlreadySomeAlternatives: hasAlreadySomeAlternatives, isHovering: isHovering })=>$50cd356356ea87c9$var$resolveAddButtonColor(hasAlreadySomeAlternatives, isHovering)};
`;
const $50cd356356ea87c9$var$AddButtonContent = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(0, "flexstart", "center")};
	margin-right: 8px;
`;
const $50cd356356ea87c9$var$GreenHalo = (0, $5UMQ1.default)((0, $dU78w.motion).div)`
	background-color: ${(0, $kKnoQ.colors).validation};
	position: absolute;
	height: 28px;
	left: 16px;
	bottom: 14px;
	border-radius: 20px;
	pointer-events: none;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		bottom: ${(0, $3cSmf.EXERCISE_FOOTER_HEIGHT) + 14}px;
	}
`;

});
parcelRegister("3cSmf", function(module, exports) {

$parcel$export(module.exports, "EXERCISE_FOOTER_HEIGHT", () => $d5456043d1b902e7$export$a9aaefa084eb370d);
$parcel$export(module.exports, "ExerciseFooterOptions", () => $d5456043d1b902e7$export$17f4af2c54fe9a61);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $jG76e = parcelRequire("jG76e");

var $41NLE = parcelRequire("41NLE");

var $3Sk1U = parcelRequire("3Sk1U");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");
const $d5456043d1b902e7$export$a9aaefa084eb370d = 48;
const $d5456043d1b902e7$export$17f4af2c54fe9a61 = ({ exercise: exercise, onlyAllowPreview: onlyAllowPreview, shouldDisplayHalo: shouldDisplayHalo })=>{
    const dragAndDropContext = (0, $81g6h.useContext)((0, $41NLE.ExerciseDragAndDropContext));
    const exerciseIndices = (0, $81g6h.useMemo)(()=>dragAndDropContext?.programEditor.getExerciseIndex(exercise.draggableId), [
        exercise.draggableId,
        dragAndDropContext?.programEditor
    ]);
    if ((0, $lTdpc.isNil)(dragAndDropContext) || (0, $lTdpc.isNil)(exerciseIndices)) return null;
    const handleMoveUp = ()=>{
        dragAndDropContext.programEditor.reorderSessionExercises(exerciseIndices.sessionIndex, exerciseIndices.exerciseIndex, exerciseIndices.exerciseIndex - 1);
    };
    const handleMoveDown = ()=>{
        dragAndDropContext.programEditor.reorderSessionExercises(exerciseIndices.sessionIndex, exerciseIndices.exerciseIndex, exerciseIndices.exerciseIndex + 1);
    };
    return /*#__PURE__*/ (0, $iKObn.jsxs)($d5456043d1b902e7$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($d5456043d1b902e7$var$StyledStepper, {
                onMoveUp: handleMoveUp,
                onMoveDown: handleMoveDown,
                min: 0,
                max: dragAndDropContext.programEditor.getExerciseCountInSession(exerciseIndices.sessionIndex) - 1,
                value: exerciseIndices.exerciseIndex
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $3Sk1U.ExerciseOptions), {
                    exercise: exercise,
                    onlyAllowPreview: onlyAllowPreview,
                    shouldDisplayHalo: shouldDisplayHalo
                })
            })
        ]
    });
};
const $d5456043d1b902e7$var$Container = (0, $5UMQ1.default).div`
	height: ${$d5456043d1b902e7$export$a9aaefa084eb370d}px;
	display: flex;
	justify-content: space-between;
	margin: -4px 4px -8px;

	> svg {
		cursor: pointer;
	}
`;
const $d5456043d1b902e7$var$StyledStepper = (0, $5UMQ1.default)((0, $jG76e.Stepper))`
	margin-left: 12px;
`;

});
parcelRegister("3Sk1U", function(module, exports) {

$parcel$export(module.exports, "ExerciseOptions", () => $0fd3979c56ba2e9d$export$92a45a739fc769ad);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $hLaGu = parcelRequire("hLaGu");

var $bFakw = parcelRequire("bFakw");

var $kVPyX = parcelRequire("kVPyX");

var $isRr9 = parcelRequire("isRr9");

var $4UKJF = parcelRequire("4UKJF");

var $5UMQ1 = parcelRequire("5UMQ1");

var $243Cr = parcelRequire("243Cr");

var $amllh = parcelRequire("amllh");

var $lKGAO = parcelRequire("lKGAO");

var $5kXMA = parcelRequire("5kXMA");

var $41NLE = parcelRequire("41NLE");

var $kBALX = parcelRequire("kBALX");

var $6Sita = parcelRequire("6Sita");

var $jD5Wy = parcelRequire("jD5Wy");

var $iglNQ = parcelRequire("iglNQ");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");

var $1IWnK = parcelRequire("1IWnK");
var $0fd3979c56ba2e9d$var$DeleteIcon = function DeleteIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M10.82 2c-.52 0-1.01.2-1.38.57L9.01 3h-5c-.13 0-.26.02-.39.07a1.004 1.004 0 0 0-.55.55c-.05.12-.07.25-.07.39s.02.26.07.39c.05.12.13.23.22.33.1.09.21.17.33.22.13.05.26.07.39.07h16c.13 0 .26-.02.39-.07a1.004 1.004 0 0 0 .55-.55c.05-.12.07-.25.07-.39s-.02-.26-.07-.39a1.19 1.19 0 0 0-.22-.33c-.1-.09-.21-.17-.33-.22-.13-.05-.26-.07-.39-.07h-5l-.43-.43A1.92 1.92 0 0 0 13.2 2h-2.38ZM16.13 22H7.88c-1.5 0-2.78-1.05-2.97-2.447L3.409 8.136a1 1 0 0 1 .991-1.13h15.22a1 1 0 0 1 .991 1.13L19.11 19.534C18.9 20.95 17.62 22 16.13 22ZM5.5 8.88l1.39 10.448c.06.44.5.797.99.797h8.25c.5 0 .93-.356 1-.825l1.39-10.42H5.5Z",
            fill: "currentColor"
        })
    });
};
$0fd3979c56ba2e9d$var$DeleteIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $0fd3979c56ba2e9d$var$DuplicateIcon = function DuplicateIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M4 2a2 2 0 0 0-2 2v13a1 1 0 0 0 2 0V4h13a1 1 0 0 0 0-2H4Zm4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H8Zm0 2h12v12H8V8Z",
            fill: "currentColor"
        })
    });
};
$0fd3979c56ba2e9d$var$DuplicateIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $0fd3979c56ba2e9d$var$EyeVisibleIcon = function EyeVisibleIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_177_172)",
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M.208 11.128C1.016 9.392 4.511 3 12.01 3c7.473 0 10.978 6.378 11.803 8.11l.005.01.005.01c.246.551.246 1.189 0 1.74l-.005.01-.005.01c-.824 1.73-4.3 8.11-11.803 8.11-7.492 0-10.987-6.399-11.8-8.125a1.974 1.974 0 0 1-.002-1.747ZM12.01 5c-6.225 0-9.23 5.34-9.993 6.981l-.006.013-.003.006.002.004.005.01C2.79 13.662 5.795 19 12.01 19c6.196 0 9.182-5.266 9.99-6.954a.138.138 0 0 0 0-.092C21.193 10.268 18.177 5 12.01 5Z"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M12.01 16.22a4.22 4.22 0 1 0 0-8.44 4.22 4.22 0 0 0 0 8.44Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_177_172",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
};
$0fd3979c56ba2e9d$var$EyeVisibleIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $0fd3979c56ba2e9d$var$FilterIcon = function FilterIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.333 5.333a1 1 0 0 1-1 1H4.5a1 1 0 0 1 0-2h5.833a1 1 0 0 1 1 1ZM20.5 5.333a1 1 0 0 1-1 1h-5.833a1 1 0 1 1 0-2H19.5a1 1 0 0 1 1 1ZM13 12a1 1 0 0 1-1 1H4.5a1 1 0 1 1 0-2H12a1 1 0 0 1 1 1ZM20.5 12a1 1 0 0 1-1 1h-4.167a1 1 0 1 1 0-2H19.5a1 1 0 0 1 1 1ZM9.667 18.667a1 1 0 0 1-1 1H4.5a1 1 0 1 1 0-2h4.167a1 1 0 0 1 1 1ZM20.5 18.667a1 1 0 0 1-1 1H12a1 1 0 1 1 0-2h7.5a1 1 0 0 1 1 1Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.333 1.833a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1ZM15.333 8.5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1ZM8.667 15.167a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Z",
                fill: "currentColor"
            })
        ]
    });
};
$0fd3979c56ba2e9d$var$FilterIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $0fd3979c56ba2e9d$export$92a45a739fc769ad = ({ exercise: exercise, onlyAllowPreview: onlyAllowPreview = false, shouldDisplayHalo: shouldDisplayHalo = false })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const user = (0, $4UKJF.useUser)();
    const exerciseDragAndDropContext = (0, $81g6h.useContext)((0, $41NLE.ExerciseDragAndDropContext));
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const trackingContext = (0, $81g6h.useContext)((0, $lKGAO.TrackingContext));
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    // Halo visibility for the menu item: only on the first exercise and while Quickstart flow is active.
    // Use the persistent origin flag so it remains highlighted even if the tooltip hides on menu open.
    const fallbackFirstExerciseId$ = (0, $81g6h.useMemo)(()=>(0, $1IWnK.observable)(undefined), []);
    const firstExerciseIdObservable = (0, $1IWnK.useObservable)(exerciseDragAndDropContext?.programEditor.firstExerciseDraggableId ?? fallbackFirstExerciseId$);
    const firstExerciseId = exerciseDragAndDropContext ? firstExerciseIdObservable : undefined;
    const isComplementaryTooltipVisible = (0, $1IWnK.useObservable)((0, $iglNQ.complementaryTooltipVisible));
    const isComplementaryOrigin = (0, $1IWnK.useObservable)((0, $iglNQ.complementaryQuickstartOrigin));
    const isQuickstartComplementaryActive = firstExerciseId === exercise.draggableId && (isComplementaryTooltipVisible || isComplementaryOrigin);
    const { openExerciseDetailsModal: openExerciseDetailsModal } = (0, $kBALX.useEditorExerciseCardActions)();
    const exerciseIndices = (0, $81g6h.useMemo)(()=>exerciseDragAndDropContext?.programEditor.getExerciseIndex(exercise.draggableId), [
        exercise.draggableId,
        exerciseDragAndDropContext?.programEditor
    ]);
    const relatedExercises = (0, $81g6h.useMemo)(()=>exerciseIndices && exerciseDragAndDropContext ? exerciseDragAndDropContext.programEditor.getDaySessions(exerciseIndices.sessionIndex) : [], [
        exerciseDragAndDropContext,
        exerciseIndices
    ]);
    const { formatExerciseBodyPart: formatExerciseBodyPart, formatExerciseCategory: formatExerciseCategory } = (0, $kVPyX.useExerciseFormatter)();
    const viewExercise = (0, $81g6h.useCallback)(()=>{
        (0, $lTdpc.isNotNil)(user) && openExerciseDetailsModal(exercise, relatedExercises, (0, $bFakw.AnalyticsViewExerciseDetailOrigin).CANVAS_EXERCISE_DETAIL);
    }, [
        exercise,
        openExerciseDetailsModal,
        relatedExercises,
        user
    ]);
    const filterComplementaryExercises = (0, $81g6h.useCallback)((selectedExercise)=>{
        const filteredBodyParts = [
            selectedExercise.primaryBodyPart,
            ...selectedExercise.secondaryBodyParts
        ];
        const filteredCategories = (0, $hLaGu.exerciseCategories).filter((category)=>selectedExercise.category !== category);
        (0, $ghfIB.libraryFilterManager).activeCategoryFilters.set([
            (0, $6Sita.createCategoriesFilter)(filteredCategories, format("exercise.category.title"), formatExerciseCategory),
            (0, $6Sita.createBodyPartsFilter)(filteredBodyParts, format("exercise.bodyPart.title"), formatExerciseBodyPart)
        ]);
    }, [
        format,
        formatExerciseBodyPart,
        formatExerciseCategory
    ]);
    const duplicateExercise = (0, $81g6h.useCallback)(()=>{
        if (exerciseIndices && exerciseDragAndDropContext) {
            exerciseDragAndDropContext.programEditor.duplicateExercise(exerciseIndices.sessionIndex, exerciseIndices.exerciseIndex);
            (0, $bFakw.sendAnalyticsEventDuplicateExercise)(exercise, trackingContext.category);
        }
    }, [
        exercise,
        exerciseDragAndDropContext,
        exerciseIndices,
        trackingContext.category
    ]);
    const deleteExercise = (0, $81g6h.useCallback)(()=>{
        if (exerciseIndices && exerciseDragAndDropContext) {
            exerciseDragAndDropContext.programEditor.deleteExercise(exerciseIndices.sessionIndex, exerciseIndices.exerciseIndex);
            (0, $bFakw.sendAnalyticsEventRemoveExercise)(exercise, trackingContext.category);
        }
    }, [
        exercise,
        exerciseDragAndDropContext,
        exerciseIndices,
        trackingContext.category
    ]);
    const handleMobileComplementaryClose = (0, $81g6h.useCallback)((exercises)=>{
        const newExercises = exercises;
        if ((0, $lTdpc.isNotNil)(exerciseIndices)) for (const newExercise of newExercises)exerciseDragAndDropContext?.programEditor.addExerciseToSession(newExercise, exerciseIndices.sessionIndex, exerciseDragAndDropContext.programEditor.getExerciseCountInSession(exerciseIndices.sessionIndex), true);
    }, [
        exerciseDragAndDropContext,
        exerciseIndices
    ]);
    const handleComplementaryClick = (0, $81g6h.useCallback)(async ()=>{
        // Close the click-driven Quickstart tooltip as soon as the user commits to this action
        (0, $iglNQ.hideComplementaryTooltip)();
        (0, $iglNQ.resetComplementaryGuide3)();
        (0, $ghfIB.libraryFilterManager).clearLastAddedExerciseMetadata();
        await (0, $ghfIB.libraryFilterManager).clearLibraryFiltersAndSearch();
        filterComplementaryExercises(exercise);
        (0, $ghfIB.libraryFilterManager).setIsComplementaryExerciseActive();
        (0, $bFakw.sendAnalyticsEventOpenComplementaryExercises)(exercise);
        if ((0, $iglNQ.complementaryQuickstartOrigin).get()) {
            await (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).COMPLEMENTARY_EXERCISES_GUIDE_02);
            (0, $iglNQ.showComplementaryGuide3)();
            (0, $iglNQ.clearComplementaryQuickstartOrigin)();
        } else (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).COMPLEMENTARY_EXERCISES_GUIDE_02);
        if (isDesktop) {
            (0, $ghfIB.libraryFilterManager).setSidebarVisible(true);
            return;
        }
        dialogContext?.openModal((0, $243Cr.ModalId).MobileExerciseLibrary, {
            exerciseLibraryAddingFlow: (0, $jD5Wy.ExerciseLibraryFlow).ComplementaryExercises,
            onClose: handleMobileComplementaryClose
        });
    }, [
        dialogContext,
        exercise,
        filterComplementaryExercises,
        isDesktop,
        handleMobileComplementaryClose
    ]);
    const buildPreviewMenuItems = (0, $81g6h.useCallback)(()=>[
            {
                text: format("programBuilder.exerciseCard.details"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($0fd3979c56ba2e9d$var$EyeVisibleIcon, {}),
                onClick: viewExercise
            }
        ], [
        format,
        viewExercise
    ]);
    const buildFullMenuItems = (0, $81g6h.useCallback)(()=>[
            {
                text: format("programBuilder.exerciseCard.details"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($0fd3979c56ba2e9d$var$EyeVisibleIcon, {}),
                onClick: viewExercise
            },
            {
                text: format("programBuilder.exerciseCard.complementaryExercises"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($0fd3979c56ba2e9d$var$FilterIcon, {}),
                shouldDisplayHaloItem: isQuickstartComplementaryActive,
                onClick: ()=>{
                    handleComplementaryClick();
                }
            },
            {
                text: format("programBuilder.exerciseCard.duplicate"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($0fd3979c56ba2e9d$var$DuplicateIcon, {}),
                onClick: duplicateExercise
            },
            {
                text: format("programBuilder.exerciseCard.delete"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($0fd3979c56ba2e9d$var$DeleteIcon, {}),
                onClick: deleteExercise,
                destructive: true
            }
        ], [
        deleteExercise,
        duplicateExercise,
        format,
        isQuickstartComplementaryActive,
        viewExercise,
        handleComplementaryClick
    ]);
    const items = (0, $81g6h.useMemo)(()=>onlyAllowPreview ? buildPreviewMenuItems() : buildFullMenuItems(), [
        onlyAllowPreview,
        buildPreviewMenuItems,
        buildFullMenuItems
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($0fd3979c56ba2e9d$var$StyledMenuButton, {
        menuItems: items,
        menuId: `popup_menu_${exercise.draggableId}`,
        menuPosition: (0, $amllh.MenuPosition).CenteredPosition,
        menuIconSize: 24,
        shouldDisplayHalo: shouldDisplayHalo,
        onMenuClick: ()=>{
            (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).COMPLEMENTARY_EXERCISES_GUIDE_01);
            // Hide the tooltip after the menu has toggled to avoid UI interference
            setTimeout(()=>(0, $iglNQ.hideComplementaryTooltip)(), 0);
        }
    });
};
const $0fd3979c56ba2e9d$var$StyledMenuButton = (0, $5UMQ1.default)((0, $amllh.MenuButton))`
	> button {
		padding: 0 2px;

		> div {
			background-color: unset;
			width: auto;
			height: auto;
			padding: 6px;

			:hover {
				background-color: ${(0, $kKnoQ.colors).primaryBackground};
			}
		}
	}
`;

});
parcelRegister("6Sita", function(module, exports) {

$parcel$export(module.exports, "createCategoriesFilter", () => $cdf6f42d76732016$export$1f16783c33e5364);
$parcel$export(module.exports, "createBodyPartsFilter", () => $cdf6f42d76732016$export$185e423d640e594c);
$parcel$export(module.exports, "createStartingPositionFilter", () => $cdf6f42d76732016$export$cbd489d3e94add6c);
$parcel$export(module.exports, "createWithWheelchairFilter", () => $cdf6f42d76732016$export$e57e6d701a61d2ec);
$parcel$export(module.exports, "createHelpNeededFilter", () => $cdf6f42d76732016$export$5bcd38d52e03ba9f);
$parcel$export(module.exports, "createDifficultyFilter", () => $cdf6f42d76732016$export$431c9e6802027b49);
$parcel$export(module.exports, "createEquipmentFilter", () => $cdf6f42d76732016$export$c8076a72835d8bf8);

var $iKObn = parcelRequire("iKObn");

var $hLaGu = parcelRequire("hLaGu");

var $9P6Oe = parcelRequire("9P6Oe");
parcelRequire("81g6h");
const $cdf6f42d76732016$export$1f16783c33e5364 = (items, label, formatExerciseCategory)=>({
        id: "category",
        label: label,
        filters: items.map((category)=>({
                id: `category-${category}`,
                label: formatExerciseCategory(category),
                predicate: (exercise)=>exercise.category === category
            }))
    });
const $cdf6f42d76732016$export$185e423d640e594c = (items, label, formatExerciseBodyPart)=>({
        id: "bodyPart",
        label: label,
        filters: items.map((bodyPart)=>({
                id: `bodyPart-${bodyPart}`,
                label: formatExerciseBodyPart(bodyPart),
                predicate: (exercise)=>(0, $hLaGu.exerciseBodyParts)(exercise).includes(bodyPart),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)((0, $9P6Oe.BodyPartIcon), {
                    bodyPart: bodyPart,
                    width: 24,
                    height: 24
                })
            }))
    });
const $cdf6f42d76732016$export$cbd489d3e94add6c = (items, label, formatExerciseStartingPosition)=>({
        id: "startingPosition",
        label: label,
        filters: items.map((startingPosition)=>({
                id: `startingPosition-${startingPosition}`,
                label: formatExerciseStartingPosition(startingPosition),
                predicate: (exercise)=>exercise.startingPosition === startingPosition
            }))
    });
const $cdf6f42d76732016$export$e57e6d701a61d2ec = (label, formatExerciseWithWheelchair)=>({
        id: "withWheelchair",
        label: label,
        filters: [
            {
                id: "withWheelchair-true",
                label: formatExerciseWithWheelchair(true),
                predicate: (exercise)=>exercise.withWheelchair === true
            }
        ]
    });
const $cdf6f42d76732016$export$5bcd38d52e03ba9f = (label, formatExerciseHelpNeeded)=>({
        id: "helpNeeded",
        label: label,
        filters: [
            {
                id: "helpNeeded-true",
                label: formatExerciseHelpNeeded(true),
                predicate: (exercise)=>exercise.helpNeeded === true
            }
        ]
    });
const $cdf6f42d76732016$export$431c9e6802027b49 = (items, label, formatExerciseDifficulty)=>({
        id: "difficulty",
        label: label,
        filters: items.map((difficulty)=>({
                id: `difficulty-${difficulty}`,
                label: formatExerciseDifficulty(difficulty),
                predicate: (exercise)=>exercise.difficulty === difficulty
            }))
    });
const $cdf6f42d76732016$export$c8076a72835d8bf8 = (equipmentNames, format)=>({
        id: "equipment",
        label: format("exercise.equipment.title"),
        filters: [
            {
                id: "equipment-none",
                label: format("exercise.equipment.none"),
                predicate: (exercise)=>exercise.optionalEquipments.length === 0 && exercise.requiredEquipments.length === 0
            },
            ...equipmentNames.map((equipment)=>({
                    id: `equipment-${equipment}`,
                    label: equipment,
                    predicate: (exercise)=>exercise.optionalEquipments.some((eq)=>eq.name === equipment) || exercise.requiredEquipments.some((eq)=>eq.name === equipment)
                }))
        ]
    });

});

parcelRegister("jD5Wy", function(module, exports) {

$parcel$export(module.exports, "ExerciseLibraryFlow", () => $a29185462d9fd1f9$export$71cdddae364c61bf);
$parcel$export(module.exports, "MobileExerciseLibraryDialog", () => $a29185462d9fd1f9$export$ee6f989e65e4c357);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $bFakw = parcelRequire("bFakw");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");

var $28f8Y = parcelRequire("28f8Y");

var $1IlhR = parcelRequire("1IlhR");

var $02Kb9 = parcelRequire("02Kb9");

var $lKGAO = parcelRequire("lKGAO");

var $2sRxO = parcelRequire("2sRxO");

var $di5pP = parcelRequire("di5pP");

var $daO8b = parcelRequire("daO8b");

var $3UpOu = parcelRequire("3UpOu");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
var $a29185462d9fd1f9$var$Info = function Info(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Zm0-20c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12.01 17.17c-.55 0-1-.45-1-1v-5.44c0-.55.45-1 1-1s1 .45 1 1v5.44c0 .55-.45 1-1 1ZM12 8.11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                fill: "currentColor"
            })
        ]
    });
};
$a29185462d9fd1f9$var$Info.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $a29185462d9fd1f9$export$71cdddae364c61bf;
(function(ExerciseLibraryFlow) {
    ExerciseLibraryFlow["Default"] = "Default";
    ExerciseLibraryFlow["ComplementaryExercises"] = "ComplementaryExercises";
    ExerciseLibraryFlow["AlternativeExercises"] = "AlternativeExercises";
})($a29185462d9fd1f9$export$71cdddae364c61bf || ($a29185462d9fd1f9$export$71cdddae364c61bf = {}));
const $a29185462d9fd1f9$var$getAddButtonWordingKey = (exerciseLibraryAddingFlow)=>{
    if (exerciseLibraryAddingFlow === "ComplementaryExercises") return "programBuilder.mobileExerciseLibraryDialog.addButton.complementaryExercises";
    if (exerciseLibraryAddingFlow === "AlternativeExercises") return "programBuilder.mobileExerciseLibraryDialog.addButton.alternativeExercises";
    return "programBuilder.mobileExerciseLibraryDialog.addButton";
};
const $a29185462d9fd1f9$export$ee6f989e65e4c357 = ({ exerciseLibraryAddingFlow: exerciseLibraryAddingFlow, onClose: onClose, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const selectedExercisesOnAlternativeSelection = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEditedList);
    const { filteredSelectedExercises: filteredPreSelectedExercises, filteredExercises: filteredExercises, isAnyFilterActive: isAnyFilterActive, hasSelectedExercises: hasPreSelectedExercises, refreshLibraryExercises: refreshLibraryExercises, openExerciseDetailsModal: openExerciseDetailsModal, isError: isError, isLoading: isLoading } = (0, $2sRxO.useExerciseLibrary)();
    const trackingContext = (0, $81g6h.useContext)((0, $lKGAO.TrackingContext));
    const [selectedExercises, setSelectedExercises] = (0, $81g6h.useState)([]);
    const toggleExerciseSelected = (0, $81g6h.useCallback)((exercise)=>{
        setSelectedExercises((current)=>{
            if (current.includes(exercise)) return current.filter((e)=>e.id !== exercise.id);
            else return [
                ...current,
                exercise
            ];
        });
    }, []);
    const renderSelectableMobileLibraryExerciseCard = (exercise)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $3UpOu.MobileLibraryExerciseCard), {
            exercise: exercise,
            selected: selectedExercises.includes(exercise),
            onSelect: ()=>toggleExerciseSelected(exercise),
            onThumbnailClick: ()=>openExerciseDetailsModal(exercise)
        }, exercise.id);
    const addButtonWordingKey = $a29185462d9fd1f9$var$getAddButtonWordingKey(exerciseLibraryAddingFlow);
    let content;
    if (isLoading) content = /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$StyledLoadingContainer, {});
    else if (isError) content = /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$StyledNetworkError, {
        withoutIcon: true,
        description: format("exerciseLibrary.errorMessage"),
        onRefresh: refreshLibraryExercises
    });
    else content = /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $di5pP.ExerciseLibrarySearchFilter), {}),
            !isAnyFilterActive && !hasPreSelectedExercises && /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$StyledExerciseLibraryCounts, {
                mode: "LibraryAndAdded"
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($a29185462d9fd1f9$var$ScrollContainer, {
                children: [
                    filteredPreSelectedExercises.length > 0 && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$Section, {
                                className: "p-size-m-bold",
                                children: format("exerciseLibrary.selectedExercisesSection")
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$StyledExerciseLibraryCounts, {
                                mode: "PreSelected"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$List, {
                                children: filteredPreSelectedExercises.map((exercise)=>renderSelectableMobileLibraryExerciseCard(exercise))
                            })
                        ]
                    }),
                    filteredExercises.length > 0 && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                        children: [
                            hasPreSelectedExercises && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$Section, {
                                        className: "p-size-m-bold",
                                        children: format("exerciseLibrary.librarySection")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$StyledExerciseLibraryCounts, {
                                        mode: "Library"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$List, {
                                children: filteredExercises.map((exercise)=>renderSelectableMobileLibraryExerciseCard(exercise))
                            })
                        ]
                    }),
                    selectedExercisesOnAlternativeSelection.length > 0 && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsxs)($a29185462d9fd1f9$var$Sort, {
                                        children: [
                                            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                                className: "p-size-m-bold",
                                                children: format("exerciseLibrary.alreadyAdded")
                                            }),
                                            /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$StyledTooltip, {
                                                content: format("exerciseLibrary.alreadyInSelectionToolTipMessage", {
                                                    exerciseSelectedCount: selectedExercisesOnAlternativeSelection.length
                                                }),
                                                maxWidth: 300,
                                                children: /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$IconContainer, {
                                                    children: /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$Info, {
                                                        width: 22,
                                                        height: 22,
                                                        color: (0, $kKnoQ.colors).grey80
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    hasPreSelectedExercises && /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$StyledExerciseLibraryCounts, {
                                        mode: "Added"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$List, {
                                children: selectedExercisesOnAlternativeSelection.map((exercise)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $3UpOu.MobileLibraryExerciseCard), {
                                        exercise: exercise,
                                        onSelect: ()=>undefined,
                                        onThumbnailClick: ()=>undefined,
                                        disabled: true
                                    }, exercise.id))
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$StyledDialog, {
        ...otherProps,
        header: format("exerciseLibrary.header"),
        footer: /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$AddButton, {
            disabled: selectedExercises.length === 0,
            onClick: ()=>{
                selectedExercises.forEach((exercise)=>(0, $bFakw.sendAnalyticsEventAddExercise)(exercise, trackingContext.category));
                onClose(selectedExercises);
                otherProps.onHide();
            },
            children: format(addButtonWordingKey, {
                count: selectedExercises.length
            })
        }),
        children: /*#__PURE__*/ (0, $iKObn.jsx)($a29185462d9fd1f9$var$Container, {
            children: content
        })
    });
};
const $a29185462d9fd1f9$var$StyledDialog = (0, $5UMQ1.default)((0, $gk3fY.BaseDialog))`
	.p-dialog-content {
		padding-right: 0;
	}
`;
const $a29185462d9fd1f9$var$AddButton = (0, $5UMQ1.default)((0, $dhb7H.Button))`
	width: 100% !important;
`;
const $a29185462d9fd1f9$var$StyledNetworkError = (0, $5UMQ1.default)((0, $28f8Y.NetworkError))`
	place-content: center;
	flex: 1;
	padding: 32px;
`;
const $a29185462d9fd1f9$var$StyledLoadingContainer = (0, $5UMQ1.default)((0, $1IlhR.LoadingContainer))`
	place-content: center;
	flex: 1;
`;
const $a29185462d9fd1f9$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(8, "flexstart", "stretch")};
	flex: 1;
	min-height: 0px;
`;
const $a29185462d9fd1f9$var$Section = (0, $5UMQ1.default).div`
	margin: 12px 0 0;
`;
const $a29185462d9fd1f9$var$StyledExerciseLibraryCounts = (0, $5UMQ1.default)((0, $daO8b.ExerciseLibraryCounts))`
	margin-bottom: 8px;
`;
const $a29185462d9fd1f9$var$List = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(12, "flexstart", "stretch")};
	padding-top: 4px;
	padding-right: 16px;
`;
const $a29185462d9fd1f9$var$ScrollContainer = (0, $5UMQ1.default).div`
	flex: 1 1 auto;
	overflow-y: auto;
	min-height: 0px;
`;
const $a29185462d9fd1f9$var$Sort = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(16)}
	margin: 12px 0 0;
	color: ${(0, $kKnoQ.colors).grey};
`;
const $a29185462d9fd1f9$var$StyledTooltip = (0, $5UMQ1.default)((0, $02Kb9.Tooltip))`
	font-size: 16px;
`;
const $a29185462d9fd1f9$var$IconContainer = (0, $5UMQ1.default).div`
	display: flex;
`;

});
parcelRegister("2sRxO", function(module, exports) {

$parcel$export(module.exports, "useExerciseLibrary", () => $52b921e4e7bace10$export$e86d66b9762ebfc6);

var $grmoS = parcelRequire("grmoS");

var $ghfIB = parcelRequire("ghfIB");

var $bFakw = parcelRequire("bFakw");

var $243Cr = parcelRequire("243Cr");

var $lKGAO = parcelRequire("lKGAO");

var $keCmP = parcelRequire("keCmP");

var $8EUxW = parcelRequire("8EUxW");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
const $52b921e4e7bace10$export$e86d66b9762ebfc6 = ()=>{
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const trackingContext = (0, $81g6h.useContext)((0, $lKGAO.TrackingContext));
    (0, $81g6h.useContext)((0, $keCmP.OnboardingContext));
    const search = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).searchWord);
    const selectedExercises = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).selectedExercises);
    const filteredSelectedExercises = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).filteredSelectedExercises);
    const filteredExercises = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).filteredExercises);
    const alreadySelectedExercises = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEditedList);
    const [runRefreshLibraryExercises, isLoading, isError] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(async ()=>{
        await (0, $ghfIB.libraryFilterManager).clearLibraryFiltersAndSearch();
        await (0, $ghfIB.libraryFilterManager).listAllExercises();
    }, []), {});
    const activeFilters = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).activeCategoryFilters);
    const activeFiltersCount = (0, $81g6h.useMemo)(()=>activeFilters.reduce((acc, category)=>acc + category.filters.reduce((accByCat)=>accByCat + 1, 0), 0), [
        activeFilters
    ]);
    const isAnyFilterActive = (0, $81g6h.useMemo)(()=>activeFiltersCount > 0 || !!search, [
        activeFiltersCount,
        search
    ]);
    const hasSelectedExercises = (0, $81g6h.useMemo)(()=>selectedExercises.length > 0, [
        selectedExercises
    ]);
    const openExerciseDetailsModal = (0, $81g6h.useCallback)((exercise)=>{
        const exercises = [
            ...filteredSelectedExercises,
            ...filteredExercises,
            ...alreadySelectedExercises
        ];
        dialogContext?.openModal((0, $243Cr.ModalId).ExerciseDetails, {
            relatedExercises: exercises,
            exerciseIndex: exercises.findIndex((ex)=>ex.draggableId === exercise.draggableId),
            tabHeaderDisabled: true,
            trackingContext: trackingContext,
            editorName: ""
        });
        (0, $bFakw.sendAnalyticsEventViewExerciseDetail)(exercise, (0, $bFakw.AnalyticsViewExerciseDetailOrigin).LIBRARY);
    }, [
        dialogContext,
        filteredSelectedExercises,
        filteredExercises,
        alreadySelectedExercises,
        trackingContext
    ]);
    const sendSearchAnalyticsEvent = (0, $81g6h.useCallback)((newSearch)=>(0, $ghfIB.analyticsService).trackEvent({
            category: trackingContext.category,
            action: "searchLibrary",
            params: [
                newSearch
            ]
        }), [
        trackingContext.category
    ]);
    const sendEventOnlyIfSearchIsNotEmpty = (0, $81g6h.useCallback)((newSearch)=>!!newSearch, []);
    (0, $8EUxW.useDelayableCallback)(search, sendSearchAnalyticsEvent, sendEventOnlyIfSearchIsNotEmpty);
    const refreshLibraryExercises = (0, $81g6h.useCallback)(()=>{
        runRefreshLibraryExercises();
    }, [
        runRefreshLibraryExercises
    ]);
    return {
        filteredSelectedExercises: filteredSelectedExercises,
        filteredExercises: filteredExercises,
        isAnyFilterActive: isAnyFilterActive,
        hasSelectedExercises: hasSelectedExercises,
        refreshLibraryExercises: refreshLibraryExercises,
        openExerciseDetailsModal: openExerciseDetailsModal,
        isError: isError,
        isLoading: isLoading,
        search: search
    };
};

});
parcelRegister("keCmP", function(module, exports) {

$parcel$export(module.exports, "OnboardingContext", () => $d17267516c38ba41$export$19b38316c9e7b045);
$parcel$export(module.exports, "OnboardingContextProvider", () => $d17267516c38ba41$export$7cfc5c05ce874ce3);

var $iKObn = parcelRequire("iKObn");

var $ghfIB = parcelRequire("ghfIB");

var $isRr9 = parcelRequire("isRr9");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
const $d17267516c38ba41$export$19b38316c9e7b045 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createContext(null);
const $d17267516c38ba41$export$7cfc5c05ce874ce3 = ({ programEditor: programEditor, programStatus: _programStatus, children: children })=>{
    // Mark intentionally unused props to satisfy lint rules without altering behavior
    _programStatus;
    (0, $1IWnK.useObservable)(programEditor.firstExerciseDraggableId);
    (0, $1IWnK.useObservable)((0, $ghfIB.onboardingManager).onboardingStepsStatus);
    (0, $1IWnK.useObservable)(programEditor.programMetadata);
    const getExerciseCardOnboardings = (0, $81g6h.useCallback)((_exerciseId, _isDragging)=>{
        // Touch params to avoid unused-var lint; logic remains always-false
        _exerciseId || _isDragging;
        return {
            shouldDisplayAlternativeGuide1: false,
            shouldDisplayAlternativeGuide5: false,
            isAlternativeOnboardingGuide1Or5Displayable: false
        };
    }, []);
    const contextValue = (0, $81g6h.useMemo)(()=>({
            getExerciseCardOnboardings: getExerciseCardOnboardings
        }), [
        getExerciseCardOnboardings
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($d17267516c38ba41$export$19b38316c9e7b045.Provider, {
        value: contextValue,
        children: children
    });
};
const $d17267516c38ba41$export$a90023dbf266a226 = (step, stepsStatus)=>stepsStatus?.[step] === (0, $isRr9.OnboardingStepStatus).AVAILABLE || stepsStatus?.[step] === (0, $isRr9.OnboardingStepStatus).DISMISSED_BUT_DISPLAYED;

});

parcelRegister("8EUxW", function(module, exports) {

$parcel$export(module.exports, "useDelayableCallback", () => $19495e24af760d72$export$7b534756773ebee9);

var $81g6h = parcelRequire("81g6h");
function $19495e24af760d72$export$7b534756773ebee9(e, callback, predicate, timeout = 2000) {
    const previousTimeout = (0, $81g6h.useRef)(null);
    (0, $81g6h.useEffect)(()=>{
        const clearPreviousTimeout = (id)=>{
            if (id !== null) clearTimeout(id);
        };
        if (predicate?.(e) ?? true) {
            clearPreviousTimeout(previousTimeout.current);
            previousTimeout.current = setTimeout(()=>{
                callback(e);
            }, timeout);
        } else clearPreviousTimeout(previousTimeout.current);
    }, [
        callback,
        e,
        predicate,
        timeout
    ]);
}

});


parcelRegister("di5pP", function(module, exports) {

$parcel$export(module.exports, "ExerciseLibrarySearchFilter", () => $b0955f44591f4280$export$55aeec4c210993a1);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $eGyIe = parcelRequire("eGyIe");

var $5kXMA = parcelRequire("5kXMA");

var $2sRxO = parcelRequire("2sRxO");

var $lW0lR = parcelRequire("lW0lR");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $daO8b = parcelRequire("daO8b");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");

var $iqdZk = parcelRequire("iqdZk");

var $5uxyt = parcelRequire("5uxyt");

var $brDEY = parcelRequire("brDEY");

var $iglNQ = parcelRequire("iglNQ");

var $9d072 = parcelRequire("9d072");

var $e0e2T = parcelRequire("e0e2T");
const $b0955f44591f4280$export$55aeec4c210993a1 = ({ showFilterLibraryGuidance: showFilterLibraryGuidance, onHideFilterLibraryGuidance: onHideFilterLibraryGuidance })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const { isAnyFilterActive: isAnyFilterActive, filteredSelectedExercises: filteredPreSelectedExercises, filteredExercises: filteredExercises } = (0, $2sRxO.useExerciseLibrary)();
    const activeCategoryFilters = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).activeCategoryFilters);
    const onFilterClear = (0, $81g6h.useCallback)((filter)=>{
        (0, $ghfIB.libraryFilterManager).activeCategoryFilters.set(activeCategoryFilters.map((cat)=>({
                ...cat,
                filters: cat.filters.filter((f)=>f.id !== filter.id)
            })));
        (0, $iglNQ.hideComplementaryGuide3)();
        (0, $9d072.hideAlternativeGuide3)();
    }, [
        activeCategoryFilters
    ]);
    const onClearAll = (0, $81g6h.useCallback)(()=>{
        (0, $ghfIB.libraryFilterManager).activeCategoryFilters.set([]);
        (0, $iglNQ.hideComplementaryGuide3)();
        (0, $9d072.hideAlternativeGuide3)();
        (0, $ghfIB.libraryFilterManager).clearActiveFilteringState();
    }, []);
    const { showComplementaryGuide3Panel: showComplementaryGuide3Panel, showAlternativeGuide3Panel: showAlternativeGuide3Panel, onCloseOnboardingPanel: onCloseOnboardingPanel } = (0, $brDEY.useLibraryGuides)();
    const activeFiltersCount = (0, $81g6h.useMemo)(()=>activeCategoryFilters.reduce((acc, category)=>acc + category.filters.reduce((accByCat)=>accByCat + 1, 0), 0), [
        activeCategoryFilters
    ]);
    const areFilteredExercisesPresent = (0, $81g6h.useMemo)(()=>isAnyFilterActive && (!isDesktop || filteredPreSelectedExercises.length > 0 || filteredExercises.length > 0), [
        filteredExercises.length,
        filteredPreSelectedExercises.length,
        isAnyFilterActive,
        isDesktop
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($b0955f44591f4280$var$SearchFilterContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $lW0lR.SearchFilterComponent), {
                        activeFiltersCount: activeFiltersCount,
                        showFilterLibraryGuidance: showFilterLibraryGuidance,
                        onHideFilterLibraryGuidance: onHideFilterLibraryGuidance
                    }),
                    activeCategoryFilters.length > 0 && /*#__PURE__*/ (0, $iKObn.jsxs)($b0955f44591f4280$var$TagContainer, {
                        children: [
                            activeCategoryFilters.map((category)=>category.filters.map((filter)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $iqdZk.FilterItem), {
                                        filter: filter,
                                        status: (0, $iqdZk.FilterItemStatus).Tag,
                                        onChange: ()=>{
                                            onFilterClear(filter);
                                        }
                                    }, filter.id))),
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $5uxyt.ClickableText), {
                                onClick: onClearAll,
                                children: format("exerciseFilterListingPanel.clear")
                            })
                        ]
                    }),
                    (showComplementaryGuide3Panel || showAlternativeGuide3Panel) && /*#__PURE__*/ (0, $iKObn.jsx)($b0955f44591f4280$var$StyledOnboardingPanel, {
                        text: format(showAlternativeGuide3Panel ? "programBuilder.quickstart.step.addAlternativeExercises.guide03" : "programBuilder.quickstart.step.complementaryExercises.guide03"),
                        onClose: onCloseOnboardingPanel
                    })
                ]
            }),
            areFilteredExercisesPresent && /*#__PURE__*/ (0, $iKObn.jsx)((0, $daO8b.ExerciseLibraryCounts), {
                mode: "SearchResult"
            }),
            areFilteredExercisesPresent && filteredPreSelectedExercises.length === 0 && filteredExercises.length === 0 && /*#__PURE__*/ (0, $iKObn.jsx)((0, $e0e2T.EmptySearch), {})
        ]
    });
};
const $b0955f44591f4280$var$SearchFilterContainer = (0, $5UMQ1.default).div`
	margin: 0px 20px 0px 20px;
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		margin: 0px 20px 0px 0px;
	}
`;
const $b0955f44591f4280$var$TagContainer = (0, $5UMQ1.default).div`
	margin: 12px 0px 0;
	${(0, $5WGN2.row)("XS", "flexstart", "center")};
	flex-wrap: wrap;
`;
const $b0955f44591f4280$var$StyledOnboardingPanel = (0, $5UMQ1.default)((0, $eGyIe.OnboardingPanel))`
	margin: 10px 0px;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		margin-left: 0px;
		margin-right: 16px;
	}
`;

});
parcelRegister("eGyIe", function(module, exports) {

$parcel$export(module.exports, "OnboardingPanel", () => $f335489e3e2a93c6$export$a49e45749effe8da);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");
var $f335489e3e2a93c6$var$CrossIcon = function CrossIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M6.14 5.302a.836.836 0 0 0-.583 1.435l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26a.834.834 0 0 0 1.377-.263.836.836 0 0 0-.195-.919L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 0 0-.6-.254Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.14 5.015a1.123 1.123 0 0 1 .803.338L12 10.41l5.057-5.057a1.123 1.123 0 1 1 1.588 1.589l-5.057 5.056 5.056 5.056c.107.103.192.226.251.363l-.263.114a.836.836 0 0 0-.189-.272L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 1 0-1.182 1.181l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26c.077.08.17.145.271.189l-.114.263a1.124 1.124 0 0 1-.362-.25L12 13.585l-5.056 5.056a1.123 1.123 0 1 1-1.588-1.588l5.056-5.056-5.057-5.056a1.123 1.123 0 0 1 .785-1.927ZM17.532 18.63a.834.834 0 0 0 1.168-.776.836.836 0 0 0-.068-.323l.263-.114a1.125 1.125 0 0 1-1.477 1.476l.114-.263Z",
                fill: "currentColor"
            })
        ]
    });
};
$f335489e3e2a93c6$var$CrossIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $f335489e3e2a93c6$export$a49e45749effe8da = /*#__PURE__*/ (0, $81g6h.forwardRef)(({ onClose: onClose, text: text, ...props }, ref)=>/*#__PURE__*/ (0, $iKObn.jsxs)($f335489e3e2a93c6$var$Container, {
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                className: "p-size-s-bold",
                children: text
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($f335489e3e2a93c6$var$StyledCrossIcon, {
                width: 24,
                height: 24,
                color: (0, $kKnoQ.colors).white,
                onClick: onClose
            })
        ]
    }));
$f335489e3e2a93c6$export$a49e45749effe8da.displayName = "OnboardingPanel";
const $f335489e3e2a93c6$var$Container = (0, $5UMQ1.default).div`
	position: relative;
	padding: 12px 40px 12px 12px;
	background-color: ${(0, $kKnoQ.colors).onboardingPrimary};
	border-radius: 8px;
	color: ${(0, $kKnoQ.colors).white};
`;
const $f335489e3e2a93c6$var$StyledCrossIcon = (0, $5UMQ1.default)($f335489e3e2a93c6$var$CrossIcon)`
	position: absolute;
	top: 10px;
	right: 10px;
	cursor: pointer;
`;

});

parcelRegister("lW0lR", function(module, exports) {

$parcel$export(module.exports, "SearchFilterComponent", () => $b353b69952189880$export$c3574e6e48254235);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $02Kb9 = parcelRequire("02Kb9");

var $eGyIe = parcelRequire("eGyIe");

var $hIci4 = parcelRequire("hIci4");

var $lKGAO = parcelRequire("lKGAO");

var $2sRxO = parcelRequire("2sRxO");

var $esmew = parcelRequire("esmew");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $kKnoQ = parcelRequire("kKnoQ");

var $5WGN2 = parcelRequire("5WGN2");

var $1IWnK = parcelRequire("1IWnK");

var $isRr9 = parcelRequire("isRr9");

var $81g6h = parcelRequire("81g6h");

var $9f2ha = parcelRequire("9f2ha");

var $8qnYi = parcelRequire("8qnYi");

var $iglNQ = parcelRequire("iglNQ");

var $9d072 = parcelRequire("9d072");

var $h1dVk = parcelRequire("h1dVk");
var $b353b69952189880$var$FilterIcon = function FilterIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.333 5.333a1 1 0 0 1-1 1H4.5a1 1 0 0 1 0-2h5.833a1 1 0 0 1 1 1ZM20.5 5.333a1 1 0 0 1-1 1h-5.833a1 1 0 1 1 0-2H19.5a1 1 0 0 1 1 1ZM13 12a1 1 0 0 1-1 1H4.5a1 1 0 1 1 0-2H12a1 1 0 0 1 1 1ZM20.5 12a1 1 0 0 1-1 1h-4.167a1 1 0 1 1 0-2H19.5a1 1 0 0 1 1 1ZM9.667 18.667a1 1 0 0 1-1 1H4.5a1 1 0 1 1 0-2h4.167a1 1 0 0 1 1 1ZM20.5 18.667a1 1 0 0 1-1 1H12a1 1 0 1 1 0-2h7.5a1 1 0 0 1 1 1Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.333 1.833a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1ZM15.333 8.5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1ZM8.667 15.167a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Z",
                fill: "currentColor"
            })
        ]
    });
};
$b353b69952189880$var$FilterIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $b353b69952189880$export$c3574e6e48254235 = ({ activeFiltersCount: activeFiltersCount, showFilterLibraryGuidance: showFilterLibraryGuidance, onHideFilterLibraryGuidance: onHideFilterLibraryGuidance })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const activeCategoryFilters = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).activeCategoryFilters);
    const [filterPanelIsOpened, setFilterPanelIsOpened] = (0, $81g6h.useState)(false);
    const exerciseFilters = (0, $8qnYi.useExerciseFilters)();
    const filterPanelRef = (0, $81g6h.useRef)(null);
    const trackingContext = (0, $81g6h.useContext)((0, $lKGAO.TrackingContext));
    // Local state to show a title tooltip after clicking the guided Filter button
    const [showFilterTitleGuidance, setShowFilterTitleGuidance] = (0, $81g6h.useState)(false);
    const { dragAndDropContext: dragAndDropContext } = (0, $h1dVk.useExerciseDragAndDrop)();
    const { search: search } = (0, $2sRxO.useExerciseLibrary)();
    (0, $81g6h.useEffect)(()=>{
        const closeFilterPanelOnDragStart = ()=>{
            requestAnimationFrame(()=>{
                if (!filterPanelIsOpened) return;
                filterPanelRef.current?.hide();
                setFilterPanelIsOpened(false);
                setShowFilterTitleGuidance(false);
            });
        };
        dragAndDropContext?.onDragStart.add(closeFilterPanelOnDragStart);
        return ()=>{
            dragAndDropContext?.onDragStart.remove(closeFilterPanelOnDragStart);
        };
    }, [
        dragAndDropContext?.onDragStart,
        filterPanelIsOpened
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($b353b69952189880$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("span", {
                className: "p-input-icon-left p-input-icon-right",
                style: {
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("i", {
                        className: "pi pi-search"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                        style: {
                            width: "100%"
                        },
                        placeholder: format("exerciseLibrary.searchInputPlaceholder"),
                        value: search,
                        onChange: (e)=>(0, $ghfIB.libraryFilterManager).searchWord.set(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($b353b69952189880$var$CancelFilterButton, {
                        className: "pi pi-times",
                        displayed: !!search,
                        onClick: ()=>(0, $ghfIB.libraryFilterManager).searchWord.set("")
                    })
                ]
            }),
            showFilterLibraryGuidance ? /*#__PURE__*/ (0, $iKObn.jsx)($b353b69952189880$var$FilterGuideTooltip, {
                interactive: true,
                visible: true,
                placement: "right",
                offset: [
                    0,
                    8
                ],
                arrow: true,
                maxWidth: 370,
                appendTo: (node)=>node.parentElement ?? document.body,
                onClickOutside: onHideFilterLibraryGuidance,
                content: /*#__PURE__*/ (0, $iKObn.jsx)((0, $eGyIe.OnboardingPanel), {
                    text: format("programBuilder.quickstart.guide.searchAndFilter"),
                    onClose: ()=>onHideFilterLibraryGuidance?.()
                }),
                children: /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($b353b69952189880$var$FilterButton, {
                        selected: activeFiltersCount > 0 || filterPanelIsOpened,
                        onClick: (e)=>{
                            onHideFilterLibraryGuidance?.();
                            (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).FILTER_LIBRARY_GUIDE_01);
                            // Show a contextual tooltip over the panel title 
                            // right after clicking the guided Filter button
                            setShowFilterTitleGuidance(true);
                            filterPanelRef.current?.toggle(e);
                        },
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $9f2ha.AnimatedHalo), {
                            shouldDisplayHalo: showFilterLibraryGuidance,
                            children: /*#__PURE__*/ (0, $iKObn.jsx)($b353b69952189880$var$FilterIcon, {
                                width: 24,
                                height: 24
                            })
                        })
                    })
                })
            }) : /*#__PURE__*/ (0, $iKObn.jsx)($b353b69952189880$var$FilterButton, {
                selected: activeFiltersCount > 0 || filterPanelIsOpened,
                onClick: (e)=>{
                    (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).FILTER_LIBRARY_GUIDE_01);
                    filterPanelRef.current?.toggle(e);
                },
                children: /*#__PURE__*/ (0, $iKObn.jsx)($b353b69952189880$var$FilterIcon, {
                    width: 24,
                    height: 24
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($b353b69952189880$var$StyledFilterPanel, {
                ref: filterPanelRef,
                title: showFilterTitleGuidance ? /*#__PURE__*/ (0, $iKObn.jsx)($b353b69952189880$var$FilterGuideTooltip, {
                    interactive: true,
                    visible: true,
                    placement: "top-start",
                    offset: [
                        0,
                        0
                    ],
                    arrow: true,
                    appendTo: ()=>document.body,
                    onClickOutside: ()=>setShowFilterTitleGuidance(false),
                    content: /*#__PURE__*/ (0, $iKObn.jsx)((0, $eGyIe.OnboardingPanel), {
                        text: format("programBuilder.quickstart.guide.applyFilters"),
                        onClose: ()=>setShowFilterTitleGuidance(false)
                    }),
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                        children: format("exerciseFilterPanel.title")
                    })
                }) : format("exerciseFilterPanel.title"),
                appendTo: undefined,
                filterOptions: exerciseFilters,
                onShow: ()=>setFilterPanelIsOpened(true),
                onHide: ()=>{
                    setFilterPanelIsOpened(false);
                    setShowFilterTitleGuidance(false);
                },
                activeFilters: activeCategoryFilters,
                onActiveFiltersChange: (newActiveFilters)=>{
                    (0, $ghfIB.libraryFilterManager).activeCategoryFilters.set(newActiveFilters);
                    (0, $iglNQ.hideComplementaryGuide3)();
                    (0, $9d072.hideAlternativeGuide3)();
                    // If at least one filter is applied, mark FILTER_LIBRARY_GUIDE_02 as completed
                    const hasAnyFilterApplied = newActiveFilters.some((category)=>category.filters.length > 0);
                    if (hasAnyFilterApplied) (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).FILTER_LIBRARY_GUIDE_02);
                },
                onFilterChange: (newFilter)=>newFilter.active && (0, $ghfIB.analyticsService).trackEvent({
                        category: trackingContext.category,
                        action: "filterLibrary",
                        params: [
                            `${newFilter.categoryId}/${newFilter.id.toLowerCase()}`
                        ]
                    })
            })
        ]
    });
};
const $b353b69952189880$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8, "flexstart", "center")};
`;
const $b353b69952189880$var$FilterButton = (0, $5UMQ1.default).button`
	appearance: none;
	margin: 0;
	padding: 8px;
	border: none;
	position: relative;
	cursor: pointer;
	color: ${(props)=>props.selected ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).grey};
	${(0, $5WGN2.stack)(undefined, "center", "center")};
	border-radius: 8px;
	background-color: ${(props)=>props.selected ? (0, $kKnoQ.colors).primaryBackground : (0, $kKnoQ.colors).transparent};

	:hover {
		background-color: ${(0, $kKnoQ.colors).primaryBackground};
	}
`;
const $b353b69952189880$var$CancelFilterButton = (0, $5UMQ1.default).i`
	cursor: pointer;
	display: ${({ displayed: displayed })=>displayed ? undefined : "none"};

	:hover {
		color: ${(0, $kKnoQ.colors).primary} !important;
	}
`;
const $b353b69952189880$var$StyledFilterPanel = (0, $5UMQ1.default)((0, $esmew.FilterPanel))`
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		position: absolute;
		inset: 0;
		max-width: unset;
		max-height: unset;
		height: 100vh;
	}
`;
// Styled tooltip to match onboarding look without tying to a specific onboarding step
const $b353b69952189880$var$FilterGuideTooltip = (0, $5UMQ1.default)((0, $02Kb9.Tooltip))`
	padding: 0;
	.tippy-arrow {
		color: ${(0, $kKnoQ.colors).onboardingPrimary};
	}
	.tippy-content {
		padding: 0;
	}
`;

});
parcelRegister("esmew", function(module, exports) {

$parcel$export(module.exports, "FilterPanel", () => $68e2d13d9907a48e$export$5286927812faf543);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $8qnYi = parcelRequire("8qnYi");

var $5UMQ1 = parcelRequire("5UMQ1");

var $a5hkt = parcelRequire("a5hkt");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $kp7gC = parcelRequire("kp7gC");

var $WrBRE = parcelRequire("WrBRE");

var $81g6h = parcelRequire("81g6h");

var $iqdZk = parcelRequire("iqdZk");

var $1IWnK = parcelRequire("1IWnK");

var $ghfIB = parcelRequire("ghfIB");
var $68e2d13d9907a48e$var$CrossIcon = function CrossIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M6.14 5.302a.836.836 0 0 0-.583 1.435l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26a.834.834 0 0 0 1.377-.263.836.836 0 0 0-.195-.919L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 0 0-.6-.254Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.14 5.015a1.123 1.123 0 0 1 .803.338L12 10.41l5.057-5.057a1.123 1.123 0 1 1 1.588 1.589l-5.057 5.056 5.056 5.056c.107.103.192.226.251.363l-.263.114a.836.836 0 0 0-.189-.272L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 1 0-1.182 1.181l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26c.077.08.17.145.271.189l-.114.263a1.124 1.124 0 0 1-.362-.25L12 13.585l-5.056 5.056a1.123 1.123 0 1 1-1.588-1.588l5.056-5.056-5.057-5.056a1.123 1.123 0 0 1 .785-1.927ZM17.532 18.63a.834.834 0 0 0 1.168-.776.836.836 0 0 0-.068-.323l.263-.114a1.125 1.125 0 0 1-1.477 1.476l.114-.263Z",
                fill: "currentColor"
            })
        ]
    });
};
$68e2d13d9907a48e$var$CrossIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $68e2d13d9907a48e$var$FilterPanelComponent = ({ filterOptions: filterOptions, title: title, onActiveFiltersChange: onActiveFiltersChange, onFilterChange: onFilterChange, ...otherProps }, ref)=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const panelRef = (0, $81g6h.useRef)(null);
    const wrapperRef = (0, $81g6h.useRef)(null);
    (0, $81g6h.useImperativeHandle)(ref, ()=>panelRef.current);
    const activeCategoryFilters2 = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).activeCategoryFilters);
    const exerciseFilters = (0, $8qnYi.useExerciseFilters)();
    const displayFilters = filterOptions.length > 0 ? filterOptions : exerciseFilters;
    const [offsetTop, setOffsetTop] = (0, $81g6h.useState)(0);
    const activeFiltersMap = (0, $81g6h.useMemo)(()=>(0, $kp7gC.OrderedMap)(activeCategoryFilters2.map((category)=>[
                category.id,
                {
                    ...category,
                    filters: (0, $kp7gC.OrderedMap)(category.filters.map((filter)=>[
                            filter.id,
                            filter
                        ]))
                }
            ])), [
        activeCategoryFilters2
    ]);
    (0, $81g6h.useEffect)(()=>{
        console.log("activeCategoryFilters2 changed:", activeCategoryFilters2);
    }, [
        activeCategoryFilters2
    ]);
    const handleShow = ()=>{
        otherProps.onShow?.();
        const element = wrapperRef.current.container || wrapperRef.current;
        if (!element) return;
        const rect = element.getBoundingClientRect();
        const absoluteY = rect.top + window.scrollY;
        setOffsetTop(absoluteY);
    };
    return /*#__PURE__*/ (0, $iKObn.jsx)("div", {
        ref: wrapperRef,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($68e2d13d9907a48e$var$StyledOverlayPanel, {
            ref: panelRef,
            dismissable: true,
            ...otherProps,
            $offsetTop: offsetTop,
            onShow: handleShow,
            children: /*#__PURE__*/ (0, $iKObn.jsxs)($68e2d13d9907a48e$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($68e2d13d9907a48e$var$ButtonContainer, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $a5hkt.ButtonIcon), {
                            icon: $68e2d13d9907a48e$var$CrossIcon,
                            onClick: ()=>panelRef.current?.hide(),
                            size: "condensed"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($68e2d13d9907a48e$var$TitleContainer, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                className: "p-size-l-bold",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($68e2d13d9907a48e$var$ClickableText, {
                                onClick: ()=>onActiveFiltersChange([]),
                                children: format("exerciseFilterPanel.clear")
                            })
                        ]
                    }),
                    displayFilters.map((category)=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $81g6h.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                    className: "p-size-m-bold",
                                    children: category.label
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)($68e2d13d9907a48e$var$FilterContainer, {
                                    children: category.filters.map((filter)=>{
                                        const isActive = activeFiltersMap.get(category.id)?.filters.has(filter.id) ?? false;
                                        const status = isActive ? (0, $iqdZk.FilterItemStatus).Active : (0, $iqdZk.FilterItemStatus).Inactive;
                                        const handleFilterChange = (checked)=>{
                                            onFilterChange?.({
                                                ...filter,
                                                categoryId: category.id,
                                                active: checked
                                            });
                                            const currentCategory = activeFiltersMap.get(category.id) || {
                                                ...category,
                                                filters: (0, $kp7gC.OrderedMap)()
                                            };
                                            const newFilters = checked ? currentCategory.filters.set(filter.id, filter) : currentCategory.filters.remove(filter.id);
                                            const newMap = activeFiltersMap.set(category.id, {
                                                ...currentCategory,
                                                filters: newFilters
                                            });
                                            onActiveFiltersChange($68e2d13d9907a48e$var$internalFilterMapToArray(newMap));
                                        };
                                        return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iqdZk.FilterItem), {
                                            status: status,
                                            filter: filter,
                                            onChange: handleFilterChange
                                        }, filter.id);
                                    })
                                })
                            ]
                        }, category.id))
                ]
            })
        })
    });
};
const $68e2d13d9907a48e$export$5286927812faf543 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef($68e2d13d9907a48e$var$FilterPanelComponent);
function $68e2d13d9907a48e$var$internalFilterMapToArray(filters) {
    return Array.from(filters.values()).reduce((nonEmptyCategories, category)=>{
        const filtersArray = Array.from(category.filters.values());
        if (filtersArray.length === 0) return nonEmptyCategories;
        const result = {
            ...category,
            filters: filtersArray
        };
        return [
            ...nonEmptyCategories,
            result
        ];
    }, []);
}
const $68e2d13d9907a48e$var$StyledOverlayPanel = (0, $5UMQ1.default)((0, $WrBRE.OverlayPanel))`
  padding: 16px;
  max-width: 600px;
  max-height: ${(props)=>props.$offsetTop ? `calc(100dvh - ${props.$offsetTop}px)` : "100dvh"};
  overflow: auto;

	.p-overlaypanel-content {
		padding: 0;
	}

	@media (min-width: ${(0, $eaiXJ.TABLET_BREAKING_POINT)}px) {
		position: absolute !important;
		left: 405px !important;
		top: 155px !important;
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding-bottom: 100px;
	}
`;
const $68e2d13d9907a48e$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(16, "flexstart", "stretch")}
`;
const $68e2d13d9907a48e$var$FilterContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8)};
	margin-top: -5px;
	margin-bottom: 8px;
	flex-flow: wrap;
`;
const $68e2d13d9907a48e$var$ClickableText = (0, $5UMQ1.default).div`
	margin: -5px;
	padding: 5px;
	cursor: pointer;

	:hover {
		color: ${(0, $kKnoQ.colors).primary};
	}
`;
const $68e2d13d9907a48e$var$ButtonContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(0, "flexend", "center")}
`;
const $68e2d13d9907a48e$var$TitleContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(0, "spacebetween", "center")}
`;

});
parcelRegister("8qnYi", function(module, exports) {

$parcel$export(module.exports, "useExerciseFilters", () => $8779c56959091a00$export$3ee2ac89d0717694);

var $1eHG3 = parcelRequire("1eHG3");

var $hLaGu = parcelRequire("hLaGu");

var $5OerI = parcelRequire("5OerI");

var $81g6h = parcelRequire("81g6h");

var $1IWnK = parcelRequire("1IWnK");

var $6Sita = parcelRequire("6Sita");

var $ivrAm = parcelRequire("ivrAm");

var $ghfIB = parcelRequire("ghfIB");

var $kVPyX = parcelRequire("kVPyX");
const $8779c56959091a00$export$3ee2ac89d0717694 = ()=>{
    const allExercises = (0, $1IWnK.useObservable)((0, $ghfIB.exerciseManager).allExercises);
    const exerciseFormatter = (0, $kVPyX.useExerciseFormatter)();
    const { format: format } = (0, $1eHG3.useI18n)();
    (0, $81g6h.useEffect)(()=>{
        if ((0, $ghfIB.exerciseManager).exercisesStatus.get() === (0, $ivrAm.ExerciseFetchState).Undefined) (0, $ghfIB.exerciseManager).fetchExercises();
    }, []);
    const equipmentNames = (0, $81g6h.useMemo)(()=>(0, $5OerI.getAllEquipmentNamesFromExercises)(allExercises), [
        allExercises
    ]);
    return (0, $81g6h.useMemo)(()=>[
            (0, $6Sita.createCategoriesFilter)((0, $hLaGu.exerciseCategories), format("exercise.category.title"), exerciseFormatter.formatExerciseCategory),
            (0, $6Sita.createBodyPartsFilter)((0, $hLaGu.exerciseBodyPartsValues), format("exercise.bodyPart.title"), exerciseFormatter.formatExerciseBodyPart),
            (0, $6Sita.createStartingPositionFilter)((0, $hLaGu.exerciseStartingPositions), format("exercise.startingPosition.title"), exerciseFormatter.formatExerciseStartingPosition),
            (0, $6Sita.createWithWheelchairFilter)(format("exercise.withWheelchair.title"), exerciseFormatter.formatExerciseWithWheelchair),
            (0, $6Sita.createEquipmentFilter)(equipmentNames, format),
            (0, $6Sita.createHelpNeededFilter)(format("exercise.helpNeeded.title"), exerciseFormatter.formatExerciseHelpNeeded),
            (0, $6Sita.createDifficultyFilter)((0, $hLaGu.exerciseDifficulties), format("exercise.difficulty.title"), exerciseFormatter.formatExerciseDifficulty)
        ], [
        equipmentNames,
        exerciseFormatter,
        format
    ]);
};

});
parcelRegister("5OerI", function(module, exports) {

$parcel$export(module.exports, "getAllEquipmentNamesFromExercises", () => $96e93a3f9d4a0694$export$76a9d2b37ed44cb5);
function $96e93a3f9d4a0694$export$76a9d2b37ed44cb5(exercises = []) {
    const equipmentSet = new Set();
    exercises.forEach((ex)=>{
        ex.requiredEquipments.forEach((eq)=>{
            if (eq.name) equipmentSet.add(eq.name);
        });
        ex.optionalEquipments.forEach((eq)=>{
            if (eq.name) equipmentSet.add(eq.name);
        });
    });
    return Array.from(equipmentSet);
}

});


parcelRegister("WrBRE", function(module, exports) {

$parcel$export(module.exports, "OverlayPanel", () => $0afad59bbbd939de$export$500eae29f537c78b);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $lbdsH = parcelRequire("lbdsH");

var $l2NC0 = parcelRequire("l2NC0");

var $4vsYR = parcelRequire("4vsYR");

var $k7ffa = parcelRequire("k7ffa");

var $6b4aU = parcelRequire("6b4aU");

var $9rbaG = parcelRequire("9rbaG");

var $cfkGk = parcelRequire("cfkGk");
"use client";
function $0afad59bbbd939de$var$_extends() {
    $0afad59bbbd939de$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0afad59bbbd939de$var$_extends.apply(this, arguments);
}
function $0afad59bbbd939de$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0afad59bbbd939de$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0afad59bbbd939de$var$_typeof(o);
}
function $0afad59bbbd939de$var$_toPrimitive(input, hint) {
    if ($0afad59bbbd939de$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0afad59bbbd939de$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0afad59bbbd939de$var$_toPropertyKey(arg) {
    var key = $0afad59bbbd939de$var$_toPrimitive(arg, "string");
    return $0afad59bbbd939de$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0afad59bbbd939de$var$_defineProperty(obj, key, value) {
    key = $0afad59bbbd939de$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0afad59bbbd939de$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0afad59bbbd939de$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0afad59bbbd939de$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0afad59bbbd939de$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0afad59bbbd939de$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0afad59bbbd939de$var$_arrayLikeToArray(o, minLen);
}
function $0afad59bbbd939de$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0afad59bbbd939de$var$_slicedToArray(arr, i) {
    return $0afad59bbbd939de$var$_arrayWithHoles(arr) || $0afad59bbbd939de$var$_iterableToArrayLimit(arr, i) || $0afad59bbbd939de$var$_unsupportedIterableToArray(arr, i) || $0afad59bbbd939de$var$_nonIterableRest();
}
var $0afad59bbbd939de$var$classes = {
    root: function root(_ref) {
        _ref.props;
        var context = _ref.context;
        return (0, $cfkGk.classNames)("p-overlaypanel p-component", {
            "p-input-filled": context && context.inputStyle === "filled" || (0, $8Zwsm.default).inputStyle === "filled",
            "p-ripple-disabled": context && context.ripple === false || (0, $8Zwsm.default).ripple === false
        });
    },
    closeIcon: "p-overlaypanel-close-icon",
    closeButton: "p-overlaypanel-close p-link",
    content: "p-overlaypanel-content",
    transition: "p-overlaypanel"
};
var $0afad59bbbd939de$var$styles = '\n@layer primereact {\n    .p-overlaypanel {\n        position: absolute;\n        margin-top: 10px;\n        /* Github #3122: Prevent animation flickering  */\n        top: -9999px;\n        left: -9999px;\n    }\n    \n    .p-overlaypanel-flipped {\n        margin-top: 0;\n        margin-bottom: 10px;\n    }\n    \n    .p-overlaypanel-close {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        overflow: hidden;\n        position: relative;\n    }\n    \n    /* Animation */\n    .p-overlaypanel-enter {\n        opacity: 0;\n        transform: scaleY(0.8);\n    }\n    \n    .p-overlaypanel-enter-active {\n        opacity: 1;\n        transform: scaleY(1);\n        transition: transform .12s cubic-bezier(0, 0, 0.2, 1), opacity .12s cubic-bezier(0, 0, 0.2, 1);\n    }\n    \n    .p-overlaypanel-enter-done {\n        transform: none;\n    }\n    \n    .p-overlaypanel-exit {\n        opacity: 1;\n    }\n    \n    .p-overlaypanel-exit-active {\n        opacity: 0;\n        transition: opacity .1s linear;\n    }\n    \n    .p-overlaypanel:after, .p-overlaypanel:before {\n        bottom: 100%;\n        left: calc(var(--overlayArrowLeft, 0) + 1.25rem);\n        content: " ";\n        height: 0;\n        width: 0;\n        position: absolute;\n        pointer-events: none;\n    }\n    \n    .p-overlaypanel:after {\n        border-width: 8px;\n        margin-left: -8px;\n    }\n    \n    .p-overlaypanel:before {\n        border-width: 10px;\n        margin-left: -10px;\n    }\n    \n    .p-overlaypanel-flipped:after, .p-overlaypanel-flipped:before {\n        bottom: auto;\n        top: 100%;\n    }\n    \n    .p-overlaypanel.p-overlaypanel-flipped:after {\n        border-bottom-color: transparent;\n    }\n    \n    .p-overlaypanel.p-overlaypanel-flipped:before {\n        border-bottom-color: transparent\n    }\n}\n';
var $0afad59bbbd939de$var$OverlayPanelBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "OverlayPanel",
        id: null,
        dismissable: true,
        showCloseIcon: false,
        closeIcon: null,
        style: null,
        className: null,
        appendTo: null,
        breakpoints: null,
        ariaCloseLabel: null,
        transitionOptions: null,
        onShow: null,
        onHide: null,
        children: undefined,
        closeOnEscape: true
    },
    css: {
        classes: $0afad59bbbd939de$var$classes,
        styles: $0afad59bbbd939de$var$styles
    }
});
function $0afad59bbbd939de$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0afad59bbbd939de$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0afad59bbbd939de$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0afad59bbbd939de$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0afad59bbbd939de$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0afad59bbbd939de$export$500eae29f537c78b = /*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $0afad59bbbd939de$var$OverlayPanelBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState(false), _React$useState2 = $0afad59bbbd939de$var$_slicedToArray(_React$useState, 2), visibleState = _React$useState2[0], setVisibleState = _React$useState2[1];
    var _OverlayPanelBase$set = $0afad59bbbd939de$var$OverlayPanelBase.setMetaData({
        props: props,
        state: {
            visible: visibleState
        }
    }), ptm = _OverlayPanelBase$set.ptm, cx = _OverlayPanelBase$set.cx;
    _OverlayPanelBase$set.sx;
    var isUnstyled = _OverlayPanelBase$set.isUnstyled;
    (0, $4gQLd.useHandleStyle)($0afad59bbbd939de$var$OverlayPanelBase.css.styles, isUnstyled, {
        name: "overlaypanel"
    });
    var attributeSelector = $81g6h.useRef("");
    var overlayRef = $81g6h.useRef(null);
    var currentTargetRef = $81g6h.useRef(null);
    var isPanelClicked = $81g6h.useRef(false);
    var styleElement = $81g6h.useRef(null);
    var overlayEventListener = $81g6h.useRef(null);
    var _useOverlayListener = (0, $l2NC0.useOverlayListener)({
        target: currentTargetRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var type = _ref.type, valid = _ref.valid;
            if (valid) switch(type){
                case "outside":
                    props.dismissable && !isPanelClicked.current && hide();
                    break;
                case "resize":
                case "scroll":
                case "orientationchange":
                    align();
                    break;
            }
            isPanelClicked.current = false;
        },
        when: visibleState
    }), _useOverlayListener2 = $0afad59bbbd939de$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var isCloseOnEscape = visibleState && props.closeOnEscape;
    var overlayPanelDisplayOrder = (0, $l2NC0.useDisplayOrder)("overlay-panel", isCloseOnEscape);
    (0, $l2NC0.useGlobalOnEscapeKey)({
        callback: function callback() {
            hide();
        },
        when: isCloseOnEscape && overlayPanelDisplayOrder,
        priority: [
            (0, $l2NC0.ESC_KEY_HANDLING_PRIORITIES).OVERLAY_PANEL,
            overlayPanelDisplayOrder
        ]
    });
    var isOutsideClicked = function isOutsideClicked(target) {
        return overlayRef && overlayRef.current && !(overlayRef.current.isSameNode(target) || overlayRef.current.contains(target));
    };
    var hasTargetChanged = function hasTargetChanged(event, target) {
        return currentTargetRef.current != null && currentTargetRef.current !== (target || event.currentTarget || event.target);
    };
    var onCloseClick = function onCloseClick(event) {
        hide();
        event.preventDefault();
    };
    var onPanelClick = function onPanelClick(event) {
        isPanelClicked.current = true;
        (0, $k7ffa.OverlayService).emit("overlay-click", {
            originalEvent: event,
            target: currentTargetRef.current
        });
    };
    var onContentClick = function onContentClick() {
        isPanelClicked.current = true;
    };
    var toggle = function toggle(event, target) {
        if (visibleState) {
            hide();
            if (hasTargetChanged(event, target)) {
                currentTargetRef.current = target || event.currentTarget || event.target;
                setTimeout(function() {
                    show(event, currentTargetRef.current);
                }, 200);
            }
        } else show(event, target);
    };
    var show = function show(event, target) {
        currentTargetRef.current = target || event.currentTarget || event.target;
        if (visibleState) align();
        else {
            setVisibleState(true);
            overlayEventListener.current = function(e) {
                !isOutsideClicked(e.target) && (isPanelClicked.current = true);
            };
            (0, $k7ffa.OverlayService).on("overlay-click", overlayEventListener.current);
        }
    };
    var hide = function hide() {
        setVisibleState(false);
        (0, $k7ffa.OverlayService).off("overlay-click", overlayEventListener.current);
        overlayEventListener.current = null;
    };
    var onEnter = function onEnter() {
        overlayRef.current.setAttribute(attributeSelector.current, "");
        (0, $cfkGk.ZIndexUtils).set("overlay", overlayRef.current, context && context.autoZIndex || (0, $8Zwsm.default).autoZIndex, context && context.zIndex.overlay || (0, $8Zwsm.default).zIndex.overlay);
        (0, $cfkGk.DomHandler).addStyles(overlayRef.current, {
            position: "absolute",
            top: "0",
            left: "0"
        });
        align();
    };
    var onEntered = function onEntered() {
        bindOverlayListener();
        props.onShow && props.onShow();
    };
    var onExit = function onExit() {
        unbindOverlayListener();
    };
    var onExited = function onExited() {
        (0, $cfkGk.ZIndexUtils).clear(overlayRef.current);
        props.onHide && props.onHide();
    };
    var align = function align() {
        if (currentTargetRef.current && overlayRef.current) {
            (0, $cfkGk.DomHandler).absolutePosition(overlayRef.current, currentTargetRef.current);
            var containerOffset = (0, $cfkGk.DomHandler).getOffset(overlayRef.current);
            var targetOffset = (0, $cfkGk.DomHandler).getOffset(currentTargetRef.current);
            var arrowLeft = 0;
            if (containerOffset.left < targetOffset.left) arrowLeft = targetOffset.left - containerOffset.left;
            overlayRef.current.style.setProperty("--overlayArrowLeft", "".concat(arrowLeft, "px"));
            if (containerOffset.top < targetOffset.top) {
                overlayRef.current.setAttribute("data-p-overlaypanel-flipped", "true");
                isUnstyled && (0, $cfkGk.DomHandler).addClass(overlayRef.current, "p-overlaypanel-flipped");
            } else {
                overlayRef.current.setAttribute("data-p-overlaypanel-flipped", "false");
                isUnstyled && (0, $cfkGk.DomHandler).removeClass(overlayRef.current, "p-overlaypanel-flipped");
            }
        }
    };
    var createStyle = function createStyle() {
        if (!styleElement.current) {
            styleElement.current = (0, $cfkGk.DomHandler).createInlineStyle(context && context.nonce || (0, $8Zwsm.default).nonce, context && context.styleContainer);
            var innerHTML = "";
            for(var breakpoint in props.breakpoints)innerHTML = innerHTML + "\n                    @media screen and (max-width: ".concat(breakpoint, ") {\n                        .p-overlaypanel[").concat(attributeSelector.current, "] {\n                            width: ").concat(props.breakpoints[breakpoint], ";\n                        }\n                    }\n                ");
            styleElement.current.innerHTML = innerHTML;
        }
    };
    (0, $l2NC0.useMountEffect)(function() {
        attributeSelector.current = (0, $cfkGk.UniqueComponentId)();
        if (props.breakpoints) createStyle();
    });
    (0, $l2NC0.useUnmountEffect)(function() {
        styleElement.current = (0, $cfkGk.DomHandler).removeInlineStyle(styleElement.current);
        if (overlayEventListener.current) {
            (0, $k7ffa.OverlayService).off("overlay-click", overlayEventListener.current);
            overlayEventListener.current = null;
        }
        (0, $cfkGk.ZIndexUtils).clear(overlayRef.current);
    });
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            toggle: toggle,
            show: show,
            hide: hide,
            align: align,
            isVisible: function isVisible() {
                return visibleState;
            },
            getElement: function getElement() {
                return overlayRef.current;
            }
        };
    });
    var createCloseIcon = function createCloseIcon() {
        var closeIconProps = mergeProps({
            className: cx("closeIcon"),
            "aria-hidden": true
        }, ptm("closeIcon"));
        var icon = props.closeIcon || /*#__PURE__*/ $81g6h.createElement((0, $4vsYR.TimesIcon), closeIconProps);
        var closeIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $0afad59bbbd939de$var$_objectSpread({}, closeIconProps), {
            props: props
        });
        var ariaLabel = props.ariaCloseLabel || (0, $8Zwsm.localeOption)("close");
        var closeButtonProps = mergeProps({
            type: "button",
            className: cx("closeButton"),
            onClick: function onClick(e) {
                return onCloseClick(e);
            },
            "aria-label": ariaLabel
        }, ptm("closeButton"));
        if (props.showCloseIcon) return /*#__PURE__*/ $81g6h.createElement("button", closeButtonProps, closeIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
        return null;
    };
    var createElement = function createElement() {
        var closeIcon = createCloseIcon();
        var rootProps = mergeProps({
            id: props.id,
            className: (0, $cfkGk.classNames)(props.className, cx("root", {
                context: context
            })),
            style: props.style,
            onClick: function onClick(e) {
                return onPanelClick(e);
            }
        }, $0afad59bbbd939de$var$OverlayPanelBase.getOtherProps(props), ptm("root"));
        var contentProps = mergeProps({
            className: cx("content"),
            onClick: function onClick(e) {
                return onContentClick();
            },
            onMouseDown: onContentClick
        }, $0afad59bbbd939de$var$OverlayPanelBase.getOtherProps(props), ptm("content"));
        var transitionProps = mergeProps({
            classNames: cx("transition"),
            "in": visibleState,
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: onEnter,
            onEntered: onEntered,
            onExit: onExit,
            onExited: onExited
        }, ptm("transition"));
        return /*#__PURE__*/ $81g6h.createElement((0, $lbdsH.CSSTransition), $0afad59bbbd939de$var$_extends({
            nodeRef: overlayRef
        }, transitionProps), /*#__PURE__*/ $81g6h.createElement("div", $0afad59bbbd939de$var$_extends({
            ref: overlayRef
        }, rootProps), /*#__PURE__*/ $81g6h.createElement("div", contentProps, props.children), closeIcon));
    };
    var element = createElement();
    return /*#__PURE__*/ $81g6h.createElement((0, $6b4aU.Portal), {
        element: element,
        appendTo: props.appendTo
    });
});
$0afad59bbbd939de$export$500eae29f537c78b.displayName = "OverlayPanel";

});

parcelRegister("iqdZk", function(module, exports) {

$parcel$export(module.exports, "FilterItemStatus", () => $4bebb5bf531ac6ac$export$89316848d6cf8809);
$parcel$export(module.exports, "FilterItem", () => $4bebb5bf531ac6ac$export$3cf161fcd24b6b4f);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $kKnoQ = parcelRequire("kKnoQ");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5WGN2 = parcelRequire("5WGN2");
var $4bebb5bf531ac6ac$var$Cross = function Cross(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M6.14 5.302a.836.836 0 0 0-.583 1.435l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26a.834.834 0 0 0 1.377-.263.836.836 0 0 0-.195-.919L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 0 0-.6-.254Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.14 5.015a1.123 1.123 0 0 1 .803.338L12 10.41l5.057-5.057a1.123 1.123 0 1 1 1.588 1.589l-5.057 5.056 5.056 5.056c.107.103.192.226.251.363l-.263.114a.836.836 0 0 0-.189-.272L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 1 0-1.182 1.181l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26c.077.08.17.145.271.189l-.114.263a1.124 1.124 0 0 1-.362-.25L12 13.585l-5.056 5.056a1.123 1.123 0 1 1-1.588-1.588l5.056-5.056-5.057-5.056a1.123 1.123 0 0 1 .785-1.927ZM17.532 18.63a.834.834 0 0 0 1.168-.776.836.836 0 0 0-.068-.323l.263-.114a1.125 1.125 0 0 1-1.477 1.476l.114-.263Z",
                fill: "currentColor"
            })
        ]
    });
};
$4bebb5bf531ac6ac$var$Cross.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $4bebb5bf531ac6ac$export$89316848d6cf8809;
(function(FilterItemStatus) {
    FilterItemStatus[FilterItemStatus["Inactive"] = 0] = "Inactive";
    FilterItemStatus[FilterItemStatus["Active"] = 1] = "Active";
    FilterItemStatus[FilterItemStatus["Tag"] = 2] = "Tag";
})($4bebb5bf531ac6ac$export$89316848d6cf8809 || ($4bebb5bf531ac6ac$export$89316848d6cf8809 = {}));
const $4bebb5bf531ac6ac$export$3cf161fcd24b6b4f = ({ status: status, filter: filter, onChange: onChange })=>{
    const handleOnClick = (0, $81g6h.useCallback)(()=>{
        onChange(status === 0);
    }, [
        onChange,
        status
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($4bebb5bf531ac6ac$var$FilterItemContainer, {
        status: status,
        onClick: status === 2 ? undefined : handleOnClick,
        children: [
            filter.icon && /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: filter.icon
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: filter.label
            }),
            status === 2 && /*#__PURE__*/ (0, $iKObn.jsx)($4bebb5bf531ac6ac$var$CrossContainer, {
                onClick: handleOnClick,
                children: /*#__PURE__*/ (0, $iKObn.jsx)($4bebb5bf531ac6ac$var$StyledCross, {})
            })
        ]
    });
};
const $4bebb5bf531ac6ac$var$FilterItemContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(2, undefined, "center")}

	min-height: 36px;
	padding: 0 ${({ status: status })=>status === 2 ? "5px" : "12px"} 0 12px;
	cursor: ${({ status: status })=>status === 2 ? "default" : "pointer"};
	white-space: nowrap;
	width: fit-content;
	border-radius: 8px;
	background-color: ${({ status: status })=>status === 0 ? "transparent" : (0, $kKnoQ.colors).primary10};
	border: 1px solid ${({ status: status })=>status === 0 ? (0, $kKnoQ.colors).primary25 : (0, $kKnoQ.colors).primary};
	color: ${({ status: status })=>status === 0 ? (0, $kKnoQ.colors).grey : (0, $kKnoQ.colors).black};

	:hover {
		background-color: ${({ status: status })=>status === 0 ? (0, $kKnoQ.colors).primaryBackground : (0, $kKnoQ.colors).primary25};
	}
`;
const $4bebb5bf531ac6ac$var$CrossContainer = (0, $5UMQ1.default).div`
	cursor: pointer;
	display: flex;
	padding: 5px 5px;
`;
const $4bebb5bf531ac6ac$var$StyledCross = (0, $5UMQ1.default)($4bebb5bf531ac6ac$var$Cross)`
	color: ${(0, $kKnoQ.colors).grey80};
	width: 20px;
	height: 20px;
`;

});


parcelRegister("h1dVk", function(module, exports) {

$parcel$export(module.exports, "useExerciseDragAndDrop", () => $2263af5e306e1145$export$56c90d76ece07f2e);

var $41NLE = parcelRequire("41NLE");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
const $2263af5e306e1145$export$56c90d76ece07f2e = ()=>{
    const dragAndDropContext = (0, $81g6h.useContext)((0, $41NLE.ExerciseDragAndDropContext));
    const dataIsLoading = (0, $1IWnK.useComputedObservable)(()=>dragAndDropContext?.programEditor.dataIsLoading.get(), [
        dragAndDropContext
    ]);
    const [shouldAnimate, setShouldAnimate] = (0, $81g6h.useState)(!dragAndDropContext?.isDragging && !dataIsLoading);
    (0, $81g6h.useEffect)(()=>{
        const handleDragEnd = ()=>{
            setShouldAnimate(!dataIsLoading);
        };
        const handleBeforeCapture = ()=>{
            setShouldAnimate(false);
        };
        dragAndDropContext?.onBeforeCapture.add(handleBeforeCapture);
        dragAndDropContext?.onDragEnd.add(handleDragEnd);
        handleDragEnd();
        return ()=>{
            dragAndDropContext?.onBeforeCapture.remove(handleBeforeCapture);
            dragAndDropContext?.onDragEnd.remove(handleDragEnd);
        };
    }, [
        dragAndDropContext?.onBeforeCapture,
        dragAndDropContext?.onDragEnd,
        dataIsLoading
    ]);
    return {
        shouldAnimate: shouldAnimate,
        dragAndDropContext: dragAndDropContext
    };
};

});


parcelRegister("daO8b", function(module, exports) {

$parcel$export(module.exports, "ExerciseLibraryCounts", () => $6cfb0c4a7cd34694$export$23de38aa2c3bfd6e);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $1IWnK = parcelRequire("1IWnK");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $ghfIB = parcelRequire("ghfIB");

var $2sRxO = parcelRequire("2sRxO");
const $6cfb0c4a7cd34694$var$LABEL_KEY_EXERCISE_COUNT = "exerciseLibrary.exerciseCount";
const $6cfb0c4a7cd34694$export$23de38aa2c3bfd6e = ({ mode: mode, className: className })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const selectedExercisesOnAlternativeSelection = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEditedList);
    const exerciseCount = (0, $1IWnK.useObservable)((0, $ghfIB.exerciseManager).exerciseTotalCount);
    const { filteredSelectedExercises: filteredPreSelectedExercises, filteredExercises: filteredExercises } = (0, $2sRxO.useExerciseLibrary)();
    const value = (0, $81g6h.useMemo)(()=>{
        switch(mode){
            case "SearchResult":
                return format("exerciseLibrary.filteredExerciseCounts", {
                    filteredCount: filteredPreSelectedExercises.length + filteredExercises.length + selectedExercisesOnAlternativeSelection.length,
                    totalCount: exerciseCount
                });
            case "LibraryAndAdded":
                return format($6cfb0c4a7cd34694$var$LABEL_KEY_EXERCISE_COUNT, {
                    count: filteredExercises.length + selectedExercisesOnAlternativeSelection.length
                });
            case "PreSelected":
                return format($6cfb0c4a7cd34694$var$LABEL_KEY_EXERCISE_COUNT, {
                    count: filteredPreSelectedExercises.length
                });
            case "Library":
                return format($6cfb0c4a7cd34694$var$LABEL_KEY_EXERCISE_COUNT, {
                    count: filteredExercises.length
                });
            case "Added":
                return format($6cfb0c4a7cd34694$var$LABEL_KEY_EXERCISE_COUNT, {
                    count: selectedExercisesOnAlternativeSelection.length
                });
        }
    }, [
        filteredExercises.length,
        filteredPreSelectedExercises.length,
        format,
        mode,
        exerciseCount,
        selectedExercisesOnAlternativeSelection.length
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($6cfb0c4a7cd34694$var$Sort, {
        className: className,
        children: value
    });
};
const $6cfb0c4a7cd34694$var$Sort = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).grey};
	padding: 0 20px;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 0;
	}
`;

});

parcelRegister("5uxyt", function(module, exports) {

$parcel$export(module.exports, "ClickableText", () => $ec7cb680b8f4a393$export$b6867fc5221f9f65);

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");
const $ec7cb680b8f4a393$export$b6867fc5221f9f65 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, $iKObn.jsx)($ec7cb680b8f4a393$var$StyledDiv, {
        onClick: onClick,
        children: children
    });
const $ec7cb680b8f4a393$var$StyledDiv = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).grey};
	cursor: pointer;

	:hover {
		color: ${(0, $kKnoQ.colors).primary};
	}
`;

});

parcelRegister("brDEY", function(module, exports) {

$parcel$export(module.exports, "useLibraryGuides", () => $788233d67e98b0f9$export$950384eb31092223);

var $ghfIB = parcelRequire("ghfIB");

var $isRr9 = parcelRequire("isRr9");

var $1IWnK = parcelRequire("1IWnK");

var $iglNQ = parcelRequire("iglNQ");

var $9d072 = parcelRequire("9d072");

var $81g6h = parcelRequire("81g6h");
function $788233d67e98b0f9$export$950384eb31092223() {
    const lastAddedExerciseMetadata = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).lastAddedExerciseMetadata);
    const forceComplementaryGuide3 = (0, $1IWnK.useObservable)((0, $iglNQ.complementaryGuide3ForceVisible));
    const forceAlternativeGuide3 = (0, $1IWnK.useObservable)((0, $9d072.alternativeGuide3ForceVisible));
    const showComplementaryGuide3Panel = forceComplementaryGuide3;
    const showAlternativeGuide3Panel = forceAlternativeGuide3;
    const [wasGuide3Available, setWasGuide3Available] = (0, $81g6h.useState)(false);
    (0, $81g6h.useEffect)(()=>{
        if (showComplementaryGuide3Panel || showAlternativeGuide3Panel) setWasGuide3Available(true);
    }, [
        showComplementaryGuide3Panel,
        showAlternativeGuide3Panel
    ]);
    (0, $81g6h.useEffect)(()=>{
        if (forceComplementaryGuide3 && wasGuide3Available && !showComplementaryGuide3Panel) (0, $iglNQ.hideComplementaryGuide3)();
    }, [
        forceComplementaryGuide3,
        wasGuide3Available,
        showComplementaryGuide3Panel
    ]);
    (0, $81g6h.useEffect)(()=>{
        if (forceAlternativeGuide3 && wasGuide3Available && !showAlternativeGuide3Panel) {
            (0, $9d072.hideAlternativeGuide3)();
            (0, $9d072.setAlternativeGuide3WasCompleted)();
        }
    }, [
        forceAlternativeGuide3,
        wasGuide3Available,
        showAlternativeGuide3Panel
    ]);
    const lastAddedSnapshotRef = (0, $81g6h.useRef)(null);
    const lastAddedComplementarySnapshotRef = (0, $81g6h.useRef)(null);
    const prevAltVisibleRef = (0, $81g6h.useRef)(false);
    const prevCompVisibleRef = (0, $81g6h.useRef)(false);
    (0, $81g6h.useEffect)(()=>{
        if (showAlternativeGuide3Panel && !prevAltVisibleRef.current) lastAddedSnapshotRef.current = lastAddedExerciseMetadata ?? null;
        if (!showAlternativeGuide3Panel && prevAltVisibleRef.current) lastAddedSnapshotRef.current = null;
        prevAltVisibleRef.current = showAlternativeGuide3Panel;
    }, [
        showAlternativeGuide3Panel,
        lastAddedExerciseMetadata
    ]);
    (0, $81g6h.useEffect)(()=>{
        if (showComplementaryGuide3Panel && !prevCompVisibleRef.current) lastAddedComplementarySnapshotRef.current = lastAddedExerciseMetadata ?? null;
        if (!showComplementaryGuide3Panel && prevCompVisibleRef.current) lastAddedComplementarySnapshotRef.current = null;
        prevCompVisibleRef.current = showComplementaryGuide3Panel;
    }, [
        showComplementaryGuide3Panel,
        lastAddedExerciseMetadata
    ]);
    (0, $81g6h.useEffect)(()=>{
        if (showComplementaryGuide3Panel && wasGuide3Available && lastAddedExerciseMetadata?.isComplementary && lastAddedExerciseMetadata !== lastAddedComplementarySnapshotRef.current) (0, $iglNQ.hideComplementaryGuide3)();
        if (showAlternativeGuide3Panel && wasGuide3Available && lastAddedExerciseMetadata?.isAlternative && lastAddedExerciseMetadata !== lastAddedSnapshotRef.current) {
            (0, $9d072.hideAlternativeGuide3)();
            (0, $9d072.setAlternativeGuide3WasCompleted)();
        }
    }, [
        showComplementaryGuide3Panel,
        showAlternativeGuide3Panel,
        wasGuide3Available,
        lastAddedExerciseMetadata
    ]);
    const onCloseOnboardingPanel = (0, $81g6h.useCallback)(async ()=>{
        if (showComplementaryGuide3Panel) {
            await (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).COMPLEMENTARY_EXERCISES_GUIDE_03);
            (0, $iglNQ.hideComplementaryGuide3)();
        }
        if (showAlternativeGuide3Panel) {
            await (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).ALTERNATIVE_EXERCISES_GUIDE_02);
            (0, $9d072.clearAlternativePanelQuickstartGuide)();
            (0, $9d072.hideAlternativeGuide3)();
            (0, $9d072.setAlternativeGuide3WasCompleted)();
        }
    }, [
        showComplementaryGuide3Panel,
        showAlternativeGuide3Panel
    ]);
    return {
        showComplementaryGuide3Panel: showComplementaryGuide3Panel,
        showAlternativeGuide3Panel: showAlternativeGuide3Panel,
        onCloseOnboardingPanel: onCloseOnboardingPanel
    };
}

});

parcelRegister("e0e2T", function(module, exports) {

$parcel$export(module.exports, "EmptySearch", () => $2d2e25970475e462$export$fbd6ceb34c007233);

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $hR2fr = parcelRequire("hR2fr");
var $2d2e25970475e462$var$EmptyBoxIcon = function EmptyBoxIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M53.97 4.362 4.862 53.47c-5.816 5.816-5.816 15.244 0 21.06l49.108 49.108c5.816 5.816 15.244 5.816 21.06 0l49.108-49.108c5.816-5.816 5.816-15.244 0-21.06L75.03 4.362c-5.816-5.816-15.244-5.816-21.06 0Z",
                fill: "#ECEDFC"
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_3445_42412)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask0_3445_42412",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "32",
                        y: "51",
                        width: "65",
                        height: "43",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "m32.1 72.56 11.655-17.345a7.536 7.536 0 0 1 6.256-3.334h28.163a7.536 7.536 0 0 1 6.257 3.334L96.085 72.56v21.171H32.1s.213-21.385 0-21.171Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("g", {
                        mask: "url(#mask0_3445_42412)",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M29.14 57.492c-5.213-21.23 11.714-38.789 33.025-34.346 21.23-5.214 38.789 11.713 34.346 33.024 5.214 21.23-11.713 38.79-33.024 34.346-21.23 5.215-38.79-11.713-34.346-33.024Z",
                            fill: "#33009A"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask1_3445_42412",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "32",
                        y: "73",
                        width: "65",
                        height: "21",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M77.263 76.608a3.545 3.545 0 0 1-3.547 3.546H54.483a3.545 3.545 0 0 1-3.547-3.546 3.545 3.545 0 0 0-3.547-3.547H32.115v14.687a5.986 5.986 0 0 0 5.985 5.985h52.015a5.986 5.986 0 0 0 5.985-5.985V73.06H80.825a3.545 3.545 0 0 0-3.547 3.547h-.015Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask1_3445_42412)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M67.203 123.835c19.013 0 34.427-15.401 34.427-34.398 0-18.997-15.414-34.397-34.427-34.397-19.014 0-34.427 15.4-34.427 34.397s15.413 34.398 34.427 34.398Z",
                                fill: "#50F"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M92.802 92.984c-3.393 15.774-18.381 26.474-34.39 24.285-7.314-.998-13.578-4.633-17.992-9.84-5.03-5.934-7.432-13.938-6.448-22.266.39-3.304 1.22-6.47 2.49-9.363 5.11-11.573 17.294-19.167 30.586-17.86 5.265.537 10.516 2.189 14.584 5.273 4.098 3.114 6.507 7.52 8.578 12.095 1.593 3.525 3.003 7.13 3.231 11.096.125 2.189-.169 4.4-.639 6.58Z",
                                fill: "#4427FA"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M92.362 92.646c-4.796 16.942-21.172 28.457-38.738 26.738-7.762-.763-14.497-4.259-19.387-9.524-5.582-6.007-8.218-14.409-7.726-23.213.213-3.804.83-7.542 1.99-11.001C33.18 61.89 46.456 51.86 61.768 52.116c6.022.104 12.837 1.227 17.713 4.76 5.104 3.693 6.925 9.488 9.407 14.951 1.939 4.245 4.303 8.247 4.62 13.013.175 2.644-.42 5.265-1.146 7.814v-.008Z",
                                fill: "#334EF5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M81.273 89.98c-4.95 12.998-17.97 21.81-31.93 21.304-5.824-.213-11.008-2.372-14.952-6.015-4.494-4.149-6.682-10.376-6.91-16.927-.11-3.253.037-6.513.683-9.59 2.54-12.183 12.998-22.134 26.018-23.397 5.067-.492 11.735-.448 16.112 2.526 4.781 3.26 5.222 9.018 7.454 13.872 1.755 3.826 4.62 7.057 4.957 11.324.19 2.38-.602 4.7-1.44 6.903h.008Z",
                                fill: "#2275F0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M68.487 87.88c-4.876 9.121-14.753 15.092-25.115 15.87-3.877.294-7.513-.485-10.509-2.504-3.407-2.299-5.31-6.367-6.088-10.641-.492-2.717-.741-5.486-.631-8.188.448-10.604 8.034-20.46 18.778-23.265 4.112-1.072 10.648-2.137 14.503.294 4.465 2.813 3.525 8.548 5.5 12.8 1.58 3.407 4.936 5.86 5.295 9.635.206 2.122-.749 4.149-1.733 5.992v.007Z",
                                fill: "#119CEB"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M55.6 75.624c1.057 2.254 3.965 3.525 4.251 5.992.162 1.41-.624 2.754-1.535 3.84-3.444 4.12-8.753 6.081-13.813 7.873-1.476.522-3.04 1.058-4.575.764-1.748-.33-3.158-1.711-3.98-3.29-.823-1.579-1.146-3.364-1.462-5.119-1.226-6.807 2.336-14.158 8.703-17.463 2.386-1.24 7.218-2.893 9.737-1.461 3.143 1.777 1.38 6.095 2.673 8.856v.008Z",
                                fill: "#00C3E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M63.22 44.237c0 .874.715 1.588 1.589 1.588s1.588-.714 1.588-1.588v-8.769c0-.874-.714-1.588-1.588-1.588-.874 0-1.589.714-1.589 1.588v8.769ZM69.086 45.166c.31.31.715.469 1.12.469h.008c.406 0 .811-.16 1.12-.469l3.65-3.65c.62-.619.62-1.628 0-2.247a1.592 1.592 0 0 0-2.248 0l-3.65 3.65c-.62.62-.62 1.628 0 2.247ZM57.66 45.166c.309.31.714.469 1.12.469h.007a1.591 1.591 0 0 0 1.12-2.716l-3.65-3.65a1.591 1.591 0 0 0-2.247 0c-.62.62-.62 1.628 0 2.248l3.65 3.65Z",
                        fill: "#FF0A4B",
                        stroke: "#FF0A4B",
                        strokeWidth: ".24"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_3445_42412",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(32.1 31.6)",
                        d: "M0 0h64v64H0z"
                    })
                })
            })
        ]
    });
};
$2d2e25970475e462$var$EmptyBoxIcon.defaultProps = {
    width: "129",
    height: "128",
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $2d2e25970475e462$export$fbd6ceb34c007233 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($2d2e25970475e462$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($2d2e25970475e462$var$EmptyBoxIcon, {
                width: 128,
                height: 128
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($2d2e25970475e462$var$Content, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("h3", {
                        children: format("exerciseListing.emptySearch.title")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $hR2fr.TextWithBreaks), {
                        text: format("exerciseListing.emptySearch.description")
                    })
                ]
            })
        ]
    });
};
const $2d2e25970475e462$var$Container = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 24px;
`;
const $2d2e25970475e462$var$Content = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	text-align: center;
`;

});
parcelRegister("hR2fr", function(module, exports) {

$parcel$export(module.exports, "TextWithBreaks", () => $dcb30f44d7982e73$export$a9883b376c214285);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");
const $dcb30f44d7982e73$export$a9883b376c214285 = ({ text: text, align: align = "center", gap: gap, className: className })=>{
    const lines = (0, $81g6h.useMemo)(()=>text ? text.split("\n") : undefined, [
        text
    ]);
    return lines ? /*#__PURE__*/ (0, $iKObn.jsx)($dcb30f44d7982e73$var$Container, {
        align: align,
        gap: gap,
        className: className,
        children: lines.map((line, index)=>/*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: line
            }, `${line}-${index}`))
    }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {});
};
const $dcb30f44d7982e73$var$flexAlignFromAlignment = (alignment)=>{
    switch(alignment){
        case "left":
            return "flex-start";
        case "center":
            return "center";
        case "right":
            return "flex-end";
    }
};
const $dcb30f44d7982e73$var$Container = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: ${({ align: align })=>$dcb30f44d7982e73$var$flexAlignFromAlignment(align)};
	${({ gap: gap })=>gap && `gap: ${gap}px;`}
`;

});



parcelRegister("3UpOu", function(module, exports) {

$parcel$export(module.exports, "MobileLibraryExerciseCard", () => $c88ad2b5b2b9a2ed$export$7358ad89589e46be);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $9P6Oe = parcelRequire("9P6Oe");

var $kKnoQ = parcelRequire("kKnoQ");

var $5WGN2 = parcelRequire("5WGN2");
parcelRequire("81g6h");
var $c88ad2b5b2b9a2ed$var$PlayIcon = function PlayIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 7c0-1.597 1.753-2.514 3.071-1.687l.006.003 8.135 5.174c1.222.788 1.242 2.587-.007 3.375L9.08 19.042h-.002C7.741 19.9 6 18.938 6 17.36V7Zm2 .003v10.355l.003-.001 8.132-5.182h-.002c0-.001 0-.002-.002-.002l-.002-.002-8.121-5.164a.055.055 0 0 0-.006-.004H8Z",
            fill: "currentColor"
        })
    });
};
$c88ad2b5b2b9a2ed$var$PlayIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $c88ad2b5b2b9a2ed$export$7358ad89589e46be = ({ exercise: exercise, onSelect: onSelect, selected: selected = false, onThumbnailClick: onThumbnailClick, disabled: disabled = false })=>/*#__PURE__*/ (0, $iKObn.jsxs)($c88ad2b5b2b9a2ed$var$Container, {
        selected: selected,
        onClick: onSelect,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($c88ad2b5b2b9a2ed$var$ThumbnailContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($c88ad2b5b2b9a2ed$var$Thumbnail, {
                        onClick: (e)=>{
                            e.stopPropagation();
                            onThumbnailClick();
                        },
                        src: exercise.thumbnails.mediumThumbnailUrl
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($c88ad2b5b2b9a2ed$var$PlayIconCircle, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($c88ad2b5b2b9a2ed$var$PlayIcon, {
                            color: (0, $kKnoQ.colors).white
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($c88ad2b5b2b9a2ed$var$ExerciseTitle, {
                className: "p-size-s-rubik-medium",
                children: exercise.title
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $9P6Oe.BodyPartIcon), {
                bodyPart: exercise.primaryBodyPart,
                additionalBodyPartsCount: exercise.secondaryBodyParts.length,
                width: 24,
                height: 24,
                style: {
                    filter: disabled ? "grayscale(1)" : ""
                }
            }),
            disabled && /*#__PURE__*/ (0, $iKObn.jsx)($c88ad2b5b2b9a2ed$var$Overlay, {})
        ]
    });
const $c88ad2b5b2b9a2ed$var$PlayIconCircle = (0, $5UMQ1.default).div`
	width: 24px;
	height: 24px;
	background-color: rgba(0, 0, 0, 0.5);
	border-radius: 12px;
	display: grid;
	place-content: center;
	padding-left: 3px;
	pointer-events: none;
	touch-action: none;
`;
const $c88ad2b5b2b9a2ed$var$ThumbnailContainer = (0, $5UMQ1.default).div`
	display: grid;
	place-items: center;

	> * {
		grid-column: 1;
		grid-row: 1;
	}
`;
const $c88ad2b5b2b9a2ed$var$Container = (0, $5UMQ1.default).div`
	position: relative;
	display: flex;
	border-radius: 8px;
	padding: 8px;
	padding-right: 12px;
	border: 1px solid ${(0, $kKnoQ.colors).primary10};
	border-color: ${({ selected: selected })=>selected ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).primary10};
	gap: 8px;
	align-items: center;
`;
const $c88ad2b5b2b9a2ed$var$Thumbnail = (0, $5UMQ1.default).img`
	cursor: pointer;
	height: 64px;
	width: 64px;
	object-fit: cover;
	border-radius: 2px;
	flex: 0;
`;
const $c88ad2b5b2b9a2ed$var$ExerciseTitle = (0, $5UMQ1.default).div`
	flex-grow: 1;
`;
const $c88ad2b5b2b9a2ed$var$Overlay = (0, $5UMQ1.default).div`
	${(0, $5WGN2.absoluteFillObject)}
	background-color: ${(0, $kKnoQ.colors).grey5};
	opacity: 0.4;
`;

});





parcelRegister("9R5kn", function(module, exports) {

$parcel$export(module.exports, "ExerciseCardHeader", () => $a53ca18f130d079d$export$68f8c2cf9159822);

var $iKObn = parcelRequire("iKObn");

var $kVPyX = parcelRequire("kVPyX");

var $5UMQ1 = parcelRequire("5UMQ1");

var $9P6Oe = parcelRequire("9P6Oe");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
const $a53ca18f130d079d$export$68f8c2cf9159822 = ({ exercise: exercise, onClick: onClick })=>{
    const { formatExerciseCategory: formatExerciseCategory } = (0, $kVPyX.useExerciseFormatter)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($a53ca18f130d079d$var$Header, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($a53ca18f130d079d$var$ExerciseCategory, {
                className: "p-size-s-semi-bold",
                children: formatExerciseCategory(exercise.category)
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($a53ca18f130d079d$var$Row, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($a53ca18f130d079d$var$ExerciseTitle, {
                        className: "p-size-s-rubik-medium",
                        children: exercise.title
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $9P6Oe.BodyPartIcon), {
                        bodyPart: exercise.primaryBodyPart,
                        additionalBodyPartsCount: exercise.secondaryBodyParts.length,
                        width: 24,
                        height: 24
                    })
                ]
            })
        ]
    });
};
const $a53ca18f130d079d$var$Header = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(0, "spacebetween", "stretch")};
	padding: 0 16px;
	cursor: pointer;
`;
const $a53ca18f130d079d$var$Row = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(0, "spacebetween", "center")};
`;
const $a53ca18f130d079d$var$ExerciseCategory = (0, $5UMQ1.default).p`
	color: ${(0, $kKnoQ.colors).grey80};
`;
const $a53ca18f130d079d$var$ExerciseTitle = (0, $5UMQ1.default).div`
	flex: 1;
`;

});

parcelRegister("5IWhl", function(module, exports) {

$parcel$export(module.exports, "RowExerciseCard", () => $4d3c7809efc8eaad$export$6c1e4be4c203396c);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $lfEOz = parcelRequire("lfEOz");

var $9P6Oe = parcelRequire("9P6Oe");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
var $4d3c7809efc8eaad$var$DragIcon = function DragIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M8 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM8 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM8 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM16 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM16 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM16 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
            fill: "currentColor"
        })
    });
};
$4d3c7809efc8eaad$var$DragIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $4d3c7809efc8eaad$export$6c1e4be4c203396c = ({ exercise: exercise, disabled: disabled = false, onClick: onClick })=>/*#__PURE__*/ (0, $iKObn.jsxs)($4d3c7809efc8eaad$var$RowExerciseContainer, {
        onClick: onClick,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($4d3c7809efc8eaad$var$Thumbnail, {
                src: exercise.thumbnails.mediumThumbnailUrl
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($4d3c7809efc8eaad$var$ExerciseTitle, {
                className: "p-size-s-rubik-medium",
                children: exercise.title
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $9P6Oe.BodyPartIcon), {
                bodyPart: exercise.primaryBodyPart,
                additionalBodyPartsCount: exercise.secondaryBodyParts.length,
                width: 24,
                height: 24,
                style: {
                    filter: disabled ? "grayscale(1)" : ""
                }
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($4d3c7809efc8eaad$var$DragIcon, {
                width: 20,
                height: 20,
                color: (0, $kKnoQ.colors).grey25
            }),
            disabled && /*#__PURE__*/ (0, $iKObn.jsx)($4d3c7809efc8eaad$var$Overlay, {})
        ]
    });
const $4d3c7809efc8eaad$var$RowExerciseContainer = (0, $5UMQ1.default).div`
	position: relative;
	${(0, $5WGN2.row)(12, "flexstart", "center")};
	border: ${(0, $lfEOz.CARD_BORDER_SIZE)}px solid ${(0, $kKnoQ.colors).primary10};
	border-radius: 8px;
	flex: none;
	padding: 8px;
	background: ${(0, $kKnoQ.colors).white};
	:hover {
		border-color: ${({ disabled: disabled })=>disabled ? (0, $kKnoQ.colors).primary10 : (0, $kKnoQ.colors).primary25};
	}
`;
const $4d3c7809efc8eaad$var$Thumbnail = (0, $5UMQ1.default).img`
	cursor: pointer;
	height: 64px;
	width: 64px;
	object-fit: cover;
	border-radius: 2px;
`;
const $4d3c7809efc8eaad$var$ExerciseTitle = (0, $5UMQ1.default).div`
	cursor: pointer;
	flex: 1;
`;
const $4d3c7809efc8eaad$var$Overlay = (0, $5UMQ1.default).div`
	${(0, $5WGN2.absoluteFillObject)}
	background-color: ${(0, $kKnoQ.colors).grey5};
	opacity: 0.4;
`;

});

parcelRegister("7qSPp", function(module, exports) {

$parcel$export(module.exports, "ExerciseDetails", () => $a600626e251da627$export$9dc130cf9d7acaf2);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $hLaGu = parcelRequire("hLaGu");

var $a6fIt = parcelRequire("a6fIt");

var $5UMQ1 = parcelRequire("5UMQ1");

var $lKGAO = parcelRequire("lKGAO");

var $loa82 = parcelRequire("loa82");

var $kKnoQ = parcelRequire("kKnoQ");

var $5WGN2 = parcelRequire("5WGN2");

var $81g6h = parcelRequire("81g6h");
var $a600626e251da627$var$CrossIcon = function CrossIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M6.14 5.302a.836.836 0 0 0-.583 1.435l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26a.834.834 0 0 0 1.377-.263.836.836 0 0 0-.195-.919L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 0 0-.6-.254Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.14 5.015a1.123 1.123 0 0 1 .803.338L12 10.41l5.057-5.057a1.123 1.123 0 1 1 1.588 1.589l-5.057 5.056 5.056 5.056c.107.103.192.226.251.363l-.263.114a.836.836 0 0 0-.189-.272L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 1 0-1.182 1.181l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26c.077.08.17.145.271.189l-.114.263a1.124 1.124 0 0 1-.362-.25L12 13.585l-5.056 5.056a1.123 1.123 0 1 1-1.588-1.588l5.056-5.056-5.057-5.056a1.123 1.123 0 0 1 .785-1.927ZM17.532 18.63a.834.834 0 0 0 1.168-.776.836.836 0 0 0-.068-.323l.263-.114a1.125 1.125 0 0 1-1.477 1.476l.114-.263Z",
                fill: "currentColor"
            })
        ]
    });
};
$a600626e251da627$var$CrossIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $a600626e251da627$var$SetIcon = function SetIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M11.842 2.002c-.537.008-1.084.058-1.637.154-4.029.707-7.285 3.925-8.03 7.947C1.004 16.448 5.866 22 12 22c5.135 0 9.378-3.89 9.938-8.879a1.009 1.009 0 0 0-1-1.121c-.5 0-.93.368-.985.865C19.52 16.87 16.118 20 12 20c-4.941 0-8.85-4.502-7.84-9.62.608-3.08 3.073-5.57 6.149-6.204a7.98 7.98 0 0 1 7.336 2.181l-1.43 1.43A.71.71 0 0 0 16.717 9H21a1 1 0 0 0 1-1V3.717a.71.71 0 0 0-1.213-.504l-1.73 1.73a9.942 9.942 0 0 0-7.215-2.941Z",
            fill: "currentColor"
        })
    });
};
$a600626e251da627$var$SetIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $a600626e251da627$var$TimeIcon = function TimeIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2Zm0 18.333A8.333 8.333 0 1 1 20.333 12 8.342 8.342 0 0 1 12 20.333Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12.144 7a.853.853 0 0 0-.605.252.864.864 0 0 0-.25.61v3.724l-2.886 1.819a.863.863 0 0 0-.273 1.19.858.858 0 0 0 1.182.274l3.287-2.067a.86.86 0 0 0 .401-.739V7.861a.864.864 0 0 0-.25-.609.853.853 0 0 0-.606-.252Z",
                fill: "currentColor"
            })
        ]
    });
};
$a600626e251da627$var$TimeIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $a600626e251da627$export$9dc130cf9d7acaf2 = ({ exercise: exercise, updateExercise: updateExercise, withArrows: withArrows })=>{
    const trackingContext = (0, $81g6h.useContext)((0, $lKGAO.TrackingContext));
    const repetitionNumberRef = (0, $81g6h.useRef)(null);
    const setNumberRef = (0, $81g6h.useRef)(null);
    const isExerciseDuration = (0, $hLaGu.isDurationExercise)(exercise);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($a600626e251da627$var$ExerciseDetailsContainer, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($a600626e251da627$var$ExerciseDetailsContent, {
                ref: repetitionNumberRef,
                initial: exercise.units,
                type: isExerciseDuration ? "time" : "number",
                onSuccess: (units)=>{
                    updateExercise({
                        ...exercise,
                        units: units
                    });
                    (0, $ghfIB.analyticsService).trackEvent({
                        category: trackingContext.category,
                        action: isExerciseDuration ? "editDuration" : "editRepetitions",
                        params: [
                            units,
                            exercise.title,
                            exercise.id
                        ]
                    });
                },
                icon: isExerciseDuration ? /*#__PURE__*/ (0, $iKObn.jsx)($a600626e251da627$var$TimeIcon, {
                    width: "15",
                    height: "15"
                }) : /*#__PURE__*/ (0, $iKObn.jsx)($a600626e251da627$var$CrossIcon, {
                    width: "15",
                    height: "15"
                }),
                onTabKeyDown: ()=>setNumberRef.current?.focus(),
                withArrows: withArrows
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($a600626e251da627$var$ExerciseDetailsContent, {
                ref: setNumberRef,
                initial: exercise.setCount,
                onSuccess: (setCount)=>{
                    updateExercise({
                        ...exercise,
                        setCount: setCount
                    });
                    (0, $ghfIB.analyticsService).trackEvent({
                        category: trackingContext.category,
                        action: "editSets",
                        params: [
                            setCount,
                            exercise.title,
                            exercise.id
                        ]
                    });
                },
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($a600626e251da627$var$SetIcon, {
                    width: "15",
                    height: "15"
                }),
                onTabKeyDown: ()=>repetitionNumberRef.current?.focus(),
                withArrows: withArrows
            })
        ]
    });
};
const $a600626e251da627$var$ExerciseDetailsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ initial: initial, icon: icon, type: type = "number", onSuccess: onSuccess, onTabKeyDown: onTabKeyDown, withArrows: withArrows }, ref)=>{
    const [value, setValue] = (0, $81g6h.useState)(initial);
    const [error, setError] = (0, $81g6h.useState)(false);
    const [timeInputIsFocus, setTimeInputIsFocus] = (0, $81g6h.useState)(false);
    const { formatDuration: formatDuration } = (0, $1eHG3.useI18n)();
    (0, $81g6h.useEffect)(()=>{
        setValue(initial);
    }, [
        initial
    ]);
    const innerRef = (0, $81g6h.useRef)(null);
    (0, $81g6h.useImperativeHandle)(ref, ()=>innerRef.current);
    const handleKeyDown = (event)=>{
        switch(event.key){
            case "Tab":
                event.preventDefault();
                innerRef.current?.blur();
                setTimeInputIsFocus(false);
                onSuccess?.(value);
                onTabKeyDown?.();
                break;
            case "Enter":
                innerRef.current?.blur();
                setTimeInputIsFocus(false);
                onSuccess?.(value);
                break;
            case "Escape":
                setTimeInputIsFocus(false);
                innerRef.current?.blur();
                setValue(initial);
                break;
            default:
                break;
        }
    };
    const inputProps = (0, $81g6h.useMemo)(()=>{
        const unFocus = ()=>{
            innerRef.current?.blur();
            onSuccess?.(value);
        };
        return type === "number" ? {
            onBlur: unFocus
        } : {
            onBlur: ()=>{
                setTimeInputIsFocus(false);
                unFocus();
            },
            onFocus: ()=>setTimeInputIsFocus(true)
        };
    }, [
        onSuccess,
        type,
        value
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($a600626e251da627$var$DetailField, {
        ref: innerRef,
        errorMode: error,
        icon: timeInputIsFocus ? null : icon,
        label: type === "time" ? formatDuration(value).slice(1) : value.toString(),
        input: /*#__PURE__*/ (0, $iKObn.jsx)((0, $loa82.InputWithArrows), {
            type: type,
            value: value,
            onValueChange: setValue,
            onKeyDown: handleKeyDown,
            onError: setError,
            withArrows: withArrows,
            ...inputProps
        })
    });
});
$a600626e251da627$var$ExerciseDetailsContent.displayName = "ExerciseDetailsContent";
const $a600626e251da627$var$DetailField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ icon: icon, input: input, label: label, errorMode: errorMode }, ref)=>{
    const [editing, setEditing] = (0, $81g6h.useState)(false);
    let detailMode;
    if (errorMode) detailMode = "error";
    else if (editing) detailMode = "focus";
    (0, $81g6h.useImperativeHandle)(ref, ()=>({
            focus: ()=>setEditing(true),
            blur: ()=>setEditing(false)
        }), []);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($a600626e251da627$var$Details, {
        "data-test": (0, $a6fIt.e2eTestId).createTemplatePage.detailField,
        mode: detailMode,
        textCursor: !editing,
        className: "p-size-s-bold",
        onClick: (e)=>{
            e.stopPropagation();
            !editing && setEditing(true);
        },
        children: [
            icon,
            editing ? input : /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                style: {
                    lineHeight: "1.375rem"
                },
                children: label
            })
        ]
    });
});
$a600626e251da627$var$DetailField.displayName = "DetailField";
const $a600626e251da627$var$ExerciseDetailsContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8)};
`;
const $a600626e251da627$var$getDetailBorderColor = (mode)=>{
    if (mode === "error") return (0, $kKnoQ.colors).rejection;
    if (mode === "focus") return (0, $kKnoQ.colors).primary;
    return (0, $kKnoQ.colors).primary25;
};
const $a600626e251da627$var$Details = (0, $5UMQ1.default).div`
	flex: 1;
	position: relative;
	overflow: hidden;
	min-height: 40px;
	border-radius: 16px;
	${(0, $5WGN2.row)(4, "center", "center")};
	color: ${(0, $kKnoQ.colors).grey};
	cursor: ${(props)=>props.textCursor ? "text" : undefined};

	border-radius: 8px;
	border: 1px solid;
	border-color: ${({ mode: mode })=>$a600626e251da627$var$getDetailBorderColor(mode)};

	:hover {
		border-color: ${(0, $kKnoQ.colors).primary};
	}

	/* Chrome, Safari, Edge, Opera */

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */

	input[type="number"] {
		appearance: textfield;
		-moz-appearance: textfield;
	}
`;

});
parcelRegister("loa82", function(module, exports) {

$parcel$export(module.exports, "InputWithArrows", () => $9901971b430f3e3f$export$5286a26a2637aaf9);

var $iKObn = parcelRequire("iKObn");

var $a6fIt = parcelRequire("a6fIt");

var $5UMQ1 = parcelRequire("5UMQ1");

var $1F29s = parcelRequire("1F29s");

var $hIci4 = parcelRequire("hIci4");

var $kKnoQ = parcelRequire("kKnoQ");

var $5WGN2 = parcelRequire("5WGN2");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");
const $9901971b430f3e3f$export$5286a26a2637aaf9 = ({ type: type = "number", value: value, onValueChange: onValueChange, onKeyDown: onKeyDown, onError: onError, onBlur: onBlur, onFocus: onFocus, withArrows: withArrows })=>{
    // Because we don't want to send NaN to onValueChange but we sometimes want to display
    // nothing in the input (e.g: if the user erase everything), the value can be "masked"
    const [isValueMasked, setValueMasked] = (0, $81g6h.useState)(false);
    const [error, setError] = (0, $81g6h.useState)(false);
    const incrementArrowsRef = (0, $81g6h.useRef)(null);
    const updateError = (0, $81g6h.useCallback)((localError)=>{
        setError(localError);
        onError?.(localError);
    }, [
        onError
    ]);
    const handleKeyDown = (0, $81g6h.useCallback)((event)=>{
        switch(event.key){
            case "Tab":
            case "Enter":
            case "Escape":
                updateError(false);
                break;
            case "ArrowUp":
            case "ArrowDown":
                incrementArrowsRef.current?.hightlightArrow(event.key === "ArrowUp" ? "up" : "down");
                break;
            case "Backspace":
                if (value.toString().length < 2) setValueMasked(true);
                break;
        }
        onKeyDown?.(event);
    }, [
        onKeyDown,
        updateError,
        value
    ]);
    const inputProps = (0, $81g6h.useMemo)(()=>type === "number" ? {
            min: $9901971b430f3e3f$var$MIN_NUMBER,
            max: $9901971b430f3e3f$var$MAX_NUMBER,
            step: $9901971b430f3e3f$var$STEP_NUMBER
        } : {
            min: $9901971b430f3e3f$var$MIN_TIME,
            max: $9901971b430f3e3f$var$MAX_TIME,
            step: $9901971b430f3e3f$var$STEP_TIME
        }, [
        type
    ]);
    const updateValueAndError = (0, $81g6h.useCallback)((localValue)=>{
        if ($9901971b430f3e3f$var$numberIsValid(localValue, inputProps.min, inputProps.max)) {
            onValueChange(localValue);
            updateError(false);
            setValueMasked(false);
        } else updateError(true);
    }, [
        inputProps.max,
        inputProps.min,
        onValueChange,
        updateError
    ]);
    if (type === "number") return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.SmallTextInput), {
                type: "number",
                pattern: "[0-9]*",
                inputMode: "numeric",
                style: {
                    alignSelf: "center"
                },
                ...inputProps,
                value: isValueMasked ? NaN : value,
                autoFocus: true,
                onKeyDown: handleKeyDown,
                onBlur: ()=>{
                    updateError(false);
                    onBlur?.();
                },
                onKeyUp: ()=>incrementArrowsRef.current?.stopHightlighting(),
                onFocus: onFocus,
                onChange: (e)=>{
                    const rep = parseInt(e.target.value);
                    updateValueAndError(rep);
                }
            }),
            withArrows && /*#__PURE__*/ (0, $iKObn.jsx)($9901971b430f3e3f$var$IncrementArrows, {
                ref: incrementArrowsRef,
                ...inputProps,
                errorMode: error,
                onValueChange: onValueChange
            })
        ]
    });
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $1F29s.DurationInput), {
                style: {
                    color: error ? (0, $kKnoQ.colors).rejection : undefined
                },
                ...inputProps,
                durationInSec: isValueMasked ? NaN : value,
                onKeyDown: handleKeyDown,
                autoFocus: true,
                onDurationChange: updateValueAndError,
                onKeyUp: ()=>incrementArrowsRef.current?.stopHightlighting(),
                onFocus: onFocus,
                onBlur: ()=>{
                    updateError(false);
                    onBlur?.();
                }
            }),
            withArrows && /*#__PURE__*/ (0, $iKObn.jsx)($9901971b430f3e3f$var$IncrementArrows, {
                ref: incrementArrowsRef,
                ...inputProps,
                errorMode: error,
                onValueChange: onValueChange
            })
        ]
    });
};
const $9901971b430f3e3f$var$IncrementArrows = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ errorMode: errorMode, step: step, min: min, max: max, onValueChange: onValueChange }, ref)=>{
    const [hightlightedArrow, setHightlightedArrow] = (0, $81g6h.useState)(null);
    const mouseIsDown = (0, $81g6h.useRef)(false);
    const nextIncrementTimeout = (0, $81g6h.useRef)(null);
    const incrementValue = (0, $81g6h.useCallback)((localStep, timeout)=>{
        onValueChange((previousValue)=>{
            const nextValue = previousValue + localStep;
            if (nextValue >= min && nextValue <= max) return nextValue;
            return previousValue;
        });
        if ((0, $lTdpc.isNotNil)(timeout)) nextIncrementTimeout.current = setTimeout(()=>incrementValue(localStep, timeout), timeout);
    }, [
        max,
        min,
        onValueChange
    ]);
    const startIncrementation = (0, $81g6h.useCallback)((localStep)=>{
        mouseIsDown.current = true;
        incrementValue(localStep);
        nextIncrementTimeout.current = setTimeout(()=>incrementValue(localStep, 30), 500);
    }, [
        incrementValue
    ]);
    const stopIncrementAndHighlight = (0, $81g6h.useCallback)(()=>{
        mouseIsDown.current = false;
        if ((0, $lTdpc.isNotNil)(nextIncrementTimeout.current)) clearTimeout(nextIncrementTimeout.current);
        setHightlightedArrow(null);
    }, []);
    (0, $81g6h.useImperativeHandle)(ref, ()=>({
            hightlightArrow: (arrow)=>setHightlightedArrow(arrow),
            stopHightlighting: ()=>setHightlightedArrow(null)
        }));
    return /*#__PURE__*/ (0, $iKObn.jsxs)($9901971b430f3e3f$var$ArrowContainer, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($9901971b430f3e3f$var$Arrow, {
                "data-test": (0, $a6fIt.e2eTestId).createTemplatePage.arrowUp,
                style: !errorMode && hightlightedArrow === "up" ? {
                    backgroundColor: (0, $kKnoQ.colors).primaryDark
                } : undefined,
                errorMode: errorMode,
                onMouseDown: ()=>{
                    setHightlightedArrow("up");
                    startIncrementation(step);
                },
                onMouseUp: stopIncrementAndHighlight,
                children: /*#__PURE__*/ (0, $iKObn.jsx)("i", {
                    className: "pi pi-chevron-up"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($9901971b430f3e3f$var$Arrow, {
                "data-test": (0, $a6fIt.e2eTestId).createTemplatePage.arrowDown,
                style: !errorMode && hightlightedArrow === "down" ? {
                    backgroundColor: (0, $kKnoQ.colors).primaryDark
                } : undefined,
                errorMode: errorMode,
                onMouseDown: ()=>{
                    setHightlightedArrow("down");
                    startIncrementation(-step);
                },
                onMouseUp: stopIncrementAndHighlight,
                children: /*#__PURE__*/ (0, $iKObn.jsx)("i", {
                    className: "pi pi-chevron-down"
                })
            })
        ]
    });
});
$9901971b430f3e3f$var$IncrementArrows.displayName = "IncrementArrows";
const $9901971b430f3e3f$var$MIN_NUMBER = 1;
const $9901971b430f3e3f$var$MAX_NUMBER = 99;
const $9901971b430f3e3f$var$STEP_NUMBER = 1;
const $9901971b430f3e3f$var$MIN_TIME = 10;
const $9901971b430f3e3f$var$MAX_TIME = 590;
const $9901971b430f3e3f$var$STEP_TIME = 10;
function $9901971b430f3e3f$var$numberIsValid(value, min, max) {
    if ((0, $lTdpc.isNil)(value) || isNaN(value)) return false;
    return value >= min && value <= max;
}
const $9901971b430f3e3f$var$ArrowContainer = (0, $5UMQ1.default).div`
	position: absolute;
	height: 100%;
	top: 0;
	right: 0;
	display: flex;
	flex-direction: column;
`;
const $9901971b430f3e3f$var$Arrow = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "center")}
	width: 20px;
	flex: 1;
	background-color: ${(props)=>props.errorMode ? (0, $kKnoQ.colors).rejection : (0, $kKnoQ.colors).primary};
	color: ${(0, $kKnoQ.colors).white};
	cursor: pointer;

	:hover {
		background-color: ${(props)=>props.errorMode ? (0, $kKnoQ.colors).rejectionDark : (0, $kKnoQ.colors).primaryDark50};
	}

	i {
		margin-right: 2px;
		font-size: 10px;
	}
`;

});
parcelRegister("1F29s", function(module, exports) {

$parcel$export(module.exports, "DurationInput", () => $f88c56e9b2a2790a$export$66dc7ff3942a27cc);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $hIci4 = parcelRequire("hIci4");

var $lTdpc = parcelRequire("lTdpc");

var $hEQyt = parcelRequire("hEQyt");

var $81g6h = parcelRequire("81g6h");
const $f88c56e9b2a2790a$export$66dc7ff3942a27cc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ durationInSec: durationInSec, onDurationChange: onDurationChange, min: min, max: max, step: step = 1, onKeyDown: onKeyDown, ...otherProps }, ref)=>{
    const [textDuration, setTextDuration] = (0, $81g6h.useState)($f88c56e9b2a2790a$var$getTextFromDuration(durationInSec));
    (0, $81g6h.useEffect)(()=>{
        setTextDuration((previousTextDuration)=>$f88c56e9b2a2790a$var$getDurationInSecFromText(previousTextDuration) === durationInSec ? previousTextDuration : $f88c56e9b2a2790a$var$getTextFromDuration(durationInSec));
    }, [
        durationInSec
    ]);
    const incrementDuration = (0, $81g6h.useCallback)((currentStep)=>{
        const currentDurationInSec = $f88c56e9b2a2790a$var$getDurationInSecFromText(textDuration);
        const definedDuration = (currentDurationInSec ?? durationInSec) + currentStep;
        if (((0, $lTdpc.isNil)(min) || definedDuration >= min) && ((0, $lTdpc.isNil)(max) || definedDuration <= max)) setTextDuration($f88c56e9b2a2790a$var$getTextFromDuration(definedDuration));
    }, [
        durationInSec,
        max,
        min,
        textDuration
    ]);
    (0, $81g6h.useEffect)(()=>{
        const newDuration = $f88c56e9b2a2790a$var$getDurationInSecFromText(textDuration);
        onDurationChange(newDuration);
    }, [
        onDurationChange,
        textDuration
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($f88c56e9b2a2790a$var$StyledTextInput, {
        ref: ref,
        value: textDuration,
        inputMode: "numeric",
        onKeyDown: (event)=>{
            if (!$f88c56e9b2a2790a$var$keyIsValid(event.key, textDuration)) event.preventDefault();
            if (event.key === "ArrowUp") incrementDuration(step);
            else if (event.key === "ArrowDown") incrementDuration(-step);
            onKeyDown?.(event);
        },
        onChange: (e)=>{
            setTextDuration(e.target.value);
        },
        ...otherProps
    });
});
$f88c56e9b2a2790a$export$66dc7ff3942a27cc.displayName = "DurationInput";
function $f88c56e9b2a2790a$var$getDurationInSecFromText(durationText) {
    const durationRegex = new RegExp(/^((0?[0-5]\d|\d):?([0-5]\d))$/);
    const matchingContent = durationRegex.exec(durationText);
    if (matchingContent?.length == 4) {
        const minutes = parseInt(matchingContent[2]);
        const seconds = parseInt(matchingContent[3]);
        if (!isNaN(minutes) && !isNaN(seconds)) return minutes * 60 + seconds;
    }
    const secondsRegex = new RegExp(/^([0-5]?\d)$/);
    const matchingSeconds = secondsRegex.exec(durationText);
    if (matchingSeconds?.length == 2) {
        const seconds = parseInt(matchingSeconds[0]);
        if (!isNaN(seconds)) return seconds;
    }
    const minutesRegex = new RegExp(/^((0?[0-5]\d|\d):)$/);
    const matchingMinutes = minutesRegex.exec(durationText);
    if (matchingMinutes?.length == 3) {
        const minutes = parseInt(matchingMinutes[2]);
        if (!isNaN(minutes)) return minutes * 60;
    }
}
function $f88c56e9b2a2790a$var$getTextFromDuration(durationInSec) {
    const minutes = Math.floor(durationInSec / 60);
    const seconds = durationInSec % 60;
    return (0, $hEQyt.getTwoDigitStringFromNumber)(minutes) + ":" + (0, $hEQyt.getTwoDigitStringFromNumber)(seconds);
}
const $f88c56e9b2a2790a$var$StyledTextInput = (0, $5UMQ1.default)((0, $hIci4.SmallTextInput))`
	max-width: 2.8rem;
	align-self: center;
`;
const $f88c56e9b2a2790a$var$availableKeys = [
    "Tab",
    "Enter",
    "Escape",
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
    "Backspace"
];
function $f88c56e9b2a2790a$var$keyIsValid(key, currentText) {
    return $f88c56e9b2a2790a$var$availableKeys.includes(key) || !isNaN(parseInt(key)) || key === ":" && !currentText.includes(":");
}

});



parcelRegister("g8ETz", function(module, exports) {

$parcel$export(module.exports, "OnboardingTooltip", () => $855b6be06f9ad821$export$787e7a3a212e116);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $isRr9 = parcelRequire("isRr9");

var $bC9c0 = parcelRequire("bC9c0");

var $5UMQ1 = parcelRequire("5UMQ1");

var $eGyIe = parcelRequire("eGyIe");

var $02Kb9 = parcelRequire("02Kb9");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");
const $855b6be06f9ad821$var$ONBOARDING_TOOLTIP_WORDINGS = {
    [(0, $isRr9.OnboardingProgramQuickstartStep).COMPLEMENTARY_EXERCISES_GUIDE_01]: "programBuilder.quickstart.step.complementaryExercises.guide01",
    [(0, $isRr9.OnboardingProgramQuickstartStep).START_TEMPLATE_GUIDE_01]: "programBuilder.quickstart.step.startTemplate.guide01",
    [(0, $isRr9.OnboardingProgramQuickstartStep).START_DRAFT_GUIDE_01]: "programBuilder.quickstart.step.startDraft.guide01",
    [(0, $isRr9.OnboardingProgramQuickstartStep).START_GUIDE_02]: "programBuilder.quickstart.step.startGuide02"
};
const $855b6be06f9ad821$export$787e7a3a212e116 = ({ onboardingStep: onboardingStep, onClose: onClose, visible: visible, ...props })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    (0, $81g6h.useEffect)(()=>{
        if (visible) (0, $bC9c0.sendAnalyticsEventViewGuide)(onboardingStep);
    }, [
        onboardingStep,
        visible
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($855b6be06f9ad821$var$StyledTooltip, {
        interactive: true,
        appendTo: ()=>document.body,
        zIndex: 10000,
        popperOptions: {
            strategy: "fixed"
        },
        content: /*#__PURE__*/ (0, $iKObn.jsx)((0, $eGyIe.OnboardingPanel), {
            onClose: (e)=>onClose?.(e),
            text: format($855b6be06f9ad821$var$ONBOARDING_TOOLTIP_WORDINGS[onboardingStep])
        }),
        visible: visible,
        ...props
    });
};
const $855b6be06f9ad821$var$StyledTooltip = (0, $5UMQ1.default)((0, $02Kb9.Tooltip))`
	padding: 0;

	.tippy-arrow {
		color: ${(0, $kKnoQ.colors).onboardingPrimary};
	}

	.tippy-content {
		padding: 0;
	}
`;

});



parcelRegister("cYBw6", function(module, exports) {

$parcel$export(module.exports, "MAX_ALTERNATIVE_EXERCISES", () => $9369bcc04ce4f2fa$export$7addbd0ead31204b);
$parcel$export(module.exports, "AlternativeErrorType", () => $9369bcc04ce4f2fa$export$c9bf3ed00ef40f75);
const $9369bcc04ce4f2fa$export$7addbd0ead31204b = 4;
var $9369bcc04ce4f2fa$export$c9bf3ed00ef40f75;
(function(AlternativeErrorType) {
    AlternativeErrorType["ThisAlreadyExists"] = "ThisAlreadyExists";
    AlternativeErrorType["OneAlreadyExists"] = "OneAlreadyExists";
    AlternativeErrorType["MaxExercisesReached"] = "MaxExercisesReached";
})($9369bcc04ce4f2fa$export$c9bf3ed00ef40f75 || ($9369bcc04ce4f2fa$export$c9bf3ed00ef40f75 = {}));

});

parcelRegister("5r5yY", function(module, exports) {

$parcel$export(module.exports, "AlternativeError", () => $fc73525a463ca0c7$export$d1de87cc904f4b68);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5kXMA = parcelRequire("5kXMA");

var $cYBw6 = parcelRequire("cYBw6");

var $3EwEG = parcelRequire("3EwEG");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $dDMmD = parcelRequire("dDMmD");
var $dU78w = parcelRequire("dU78w");

var $81g6h = parcelRequire("81g6h");
const $fc73525a463ca0c7$var$AlternativeErrorWordingKeys = {
    [(0, $cYBw6.AlternativeErrorType).ThisAlreadyExists]: "programBuilder.alternativeExercises.errors.thisAlreadyExists",
    [(0, $cYBw6.AlternativeErrorType).OneAlreadyExists]: "programBuilder.alternativeExercises.errors.oneAlreadyExists",
    [(0, $cYBw6.AlternativeErrorType).MaxExercisesReached]: "programBuilder.alternativeExercises.errors.maximumReached"
};
const $fc73525a463ca0c7$var$ANIMATED_ERROR_STYLE = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1
    },
    exit: {
        opacity: 0,
        transition: {
            type: "easeOut"
        }
    }
};
const $fc73525a463ca0c7$export$d1de87cc904f4b68 = ({ errorType: errorType, cleanError: cleanError })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    (0, $81g6h.useEffect)(()=>{
        if ((0, $lTdpc.isNotNil)(errorType)) setTimeout(()=>cleanError(), 3000);
    }, [
        cleanError,
        errorType,
        format
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $dDMmD.AnimatePresence), {
        initial: false,
        mode: "wait",
        children: (0, $lTdpc.isNotNil)(errorType) && /*#__PURE__*/ (0, $iKObn.jsx)($fc73525a463ca0c7$var$ErrorPanel, {
            isDesktop: isDesktop,
            variants: $fc73525a463ca0c7$var$ANIMATED_ERROR_STYLE,
            initial: "hidden",
            animate: "visible",
            exit: "exit",
            children: /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                className: "p-size-s-bold",
                style: {
                    color: (0, $kKnoQ.colors).rejection
                },
                children: format($fc73525a463ca0c7$var$AlternativeErrorWordingKeys[errorType])
            })
        })
    });
};
const $fc73525a463ca0c7$var$ErrorPanel = (0, $5UMQ1.default)((0, $dU78w.motion).div)`
	position: sticky;
	top: ${({ isDesktop: isDesktop })=>isDesktop ? `${0, $3EwEG.AlternativeExerciseHeaderHeight}px` : "0"};
	right: 0;
	left: 0;
	z-index: 10;
	background-color: ${(0, $kKnoQ.colors).primary10};
	padding: 12px;
`;

});
parcelRegister("3EwEG", function(module, exports) {

$parcel$export(module.exports, "AlternativeExerciseHeaderHeight", () => $08bc6e8782abf5b9$export$792f8d816fd31912);
$parcel$export(module.exports, "AlternativeExerciseHeader", () => $08bc6e8782abf5b9$export$f5f6ade2bb89b699);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $jim7G = parcelRequire("jim7G");

var $bFakw = parcelRequire("bFakw");

var $5UMQ1 = parcelRequire("5UMQ1");

var $243Cr = parcelRequire("243Cr");

var $9f2ha = parcelRequire("9f2ha");

var $eGyIe = parcelRequire("eGyIe");

var $kKnoQ = parcelRequire("kKnoQ");

var $5WGN2 = parcelRequire("5WGN2");

var $1IWnK = parcelRequire("1IWnK");

var $9d072 = parcelRequire("9d072");

var $81g6h = parcelRequire("81g6h");
var $08bc6e8782abf5b9$var$CrossIcon = function CrossIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M6.14 5.302a.836.836 0 0 0-.583 1.435l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26a.834.834 0 0 0 1.377-.263.836.836 0 0 0-.195-.919L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 0 0-.6-.254Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.14 5.015a1.123 1.123 0 0 1 .803.338L12 10.41l5.057-5.057a1.123 1.123 0 1 1 1.588 1.589l-5.057 5.056 5.056 5.056c.107.103.192.226.251.363l-.263.114a.836.836 0 0 0-.189-.272L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 1 0-1.182 1.181l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26c.077.08.17.145.271.189l-.114.263a1.124 1.124 0 0 1-.362-.25L12 13.585l-5.056 5.056a1.123 1.123 0 1 1-1.588-1.588l5.056-5.056-5.057-5.056a1.123 1.123 0 0 1 .785-1.927ZM17.532 18.63a.834.834 0 0 0 1.168-.776.836.836 0 0 0-.068-.323l.263-.114a1.125 1.125 0 0 1-1.477 1.476l.114-.263Z",
                fill: "currentColor"
            })
        ]
    });
};
$08bc6e8782abf5b9$var$CrossIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $08bc6e8782abf5b9$var$InfoIcon = function InfoIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Zm0-20c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12.01 17.17c-.55 0-1-.45-1-1v-5.44c0-.55.45-1 1-1s1 .45 1 1v5.44c0 .55-.45 1-1 1ZM12 8.11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                fill: "currentColor"
            })
        ]
    });
};
$08bc6e8782abf5b9$var$InfoIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $08bc6e8782abf5b9$export$792f8d816fd31912 = 45;
const $08bc6e8782abf5b9$export$f5f6ade2bb89b699 = ({ onCrossClicked: onCrossClicked })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const locale = (0, $1IWnK.useObservable)((0, $ghfIB.localeManager).locale);
    // Show halo only after guide03 is completed (quickstart)
    const [showHalo, setShowHalo] = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useState(()=>Boolean((0, $9d072.alternativeGuide3WasCompleted).get()));
    const [showGuide04Panel, setShowGuide04Panel] = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useState(()=>Boolean((0, $9d072.alternativeGuide3WasCompleted).get()));
    (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useEffect(()=>{
        const sub = (0, $9d072.alternativeGuide3WasCompleted).subscribe((val)=>{
            setShowHalo(Boolean(val));
            setShowGuide04Panel(Boolean(val));
        });
        return ()=>sub();
    }, []);
    const ALTERNATIVE_EXERCISE_FEATURE_PREVIEW = (0, $81g6h.useMemo)(()=>({
            title: format("programBuilder.alternativeExercises.infoDialog.title"),
            pages: [
                {
                    imageUrl: `https://res.cloudinary.com/physio-me/image/upload/v1707823263/Physio.Me/Alternative%20Exercises%20Feature%20Preview/${locale}/image_1.png`,
                    backgroundColor: (0, $kKnoQ.colors).mobilePrimaryBlue50,
                    title: format("programBuilder.alternativeExercises.infoDialog.page1.title"),
                    description: (0, $jim7G.createParagraphBlock)(format("programBuilder.alternativeExercises.infoDialog.page1.description")),
                    ctaLabel: format("global.dialog.next"),
                    shortCtaLabel: format("global.dialog.next")
                },
                {
                    imageUrl: `https://res.cloudinary.com/physio-me/image/upload/v1707823260/Physio.Me/Alternative%20Exercises%20Feature%20Preview/${locale}/image_2.png`,
                    backgroundColor: (0, $kKnoQ.colors).mobilePrimaryBlue15,
                    title: format("programBuilder.alternativeExercises.infoDialog.page2.title"),
                    description: (0, $jim7G.createParagraphBlock)(format("programBuilder.alternativeExercises.infoDialog.page2.description")),
                    ctaLabel: format("global.close"),
                    shortCtaLabel: format("global.close")
                }
            ]
        }), [
        format,
        locale
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($08bc6e8782abf5b9$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $9f2ha.AnimatedHalo), {
                        shouldDisplayHalo: showHalo,
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($08bc6e8782abf5b9$var$StyledInfoIcon, {
                            width: 24,
                            height: 24,
                            color: (0, $kKnoQ.colors).grey,
                            onClick: ()=>{
                                (0, $bFakw.sendAnalyticsOpenAlternativeExercisesInfoTooltip)();
                                dialogContext?.openModal((0, $243Cr.ModalId).Announcement, {
                                    dialogContent: ALTERNATIVE_EXERCISE_FEATURE_PREVIEW
                                });
                                setShowHalo(false);
                                setShowGuide04Panel(false);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                        className: "p-size-m-bold",
                        children: format("programBuilder.alternativeExerciseDialog.header")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($08bc6e8782abf5b9$var$StyledCrossIcon, {
                        width: 24,
                        height: 24,
                        color: (0, $kKnoQ.colors).grey,
                        onClick: onCrossClicked
                    })
                ]
            }),
            showGuide04Panel && /*#__PURE__*/ (0, $iKObn.jsx)($08bc6e8782abf5b9$var$BottomOnboardingPanel, {
                text: format("programBuilder.quickstart.step.addAlternativeExercises.guide04"),
                onClose: async ()=>{
                    // Do NOT pass GUIDE_03 on guide04 close anymore; GUIDE_03 is sent when add completes
                    setShowHalo(false);
                    setShowGuide04Panel(false);
                }
            })
        ]
    });
// Styled components and panel for onboarding
};
const $08bc6e8782abf5b9$var$Header = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(0, "spacebetween", "center")};
	height: ${$08bc6e8782abf5b9$export$792f8d816fd31912}px;
	position: sticky;
	top: 0;
	background-color: ${(0, $kKnoQ.colors).primary10};
	z-index: 30;
`;
const $08bc6e8782abf5b9$var$StyledInfoIcon = (0, $5UMQ1.default)($08bc6e8782abf5b9$var$InfoIcon)`
	cursor: pointer;
`;
const $08bc6e8782abf5b9$var$StyledCrossIcon = (0, $5UMQ1.default)($08bc6e8782abf5b9$var$CrossIcon)`
	cursor: pointer;
`;
const $08bc6e8782abf5b9$var$BottomOnboardingPanel = (0, $5UMQ1.default)((0, $eGyIe.OnboardingPanel))`
	margin-top: 8px;
	margin-bottom: 8px;
`;

});


parcelRegister("41K57", function(module, exports) {

$parcel$export(module.exports, "NO_ALTERNATIVE_PLACEHOLDER_HEIGHT", () => $1d29cf9536b12aaf$export$cb52a9ad64e0191f);
$parcel$export(module.exports, "NoAlternativeExercisePlaceholder", () => $1d29cf9536b12aaf$export$4ae45d559fb4b095);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5kXMA = parcelRequire("5kXMA");

var $kKnoQ = parcelRequire("kKnoQ");

var $dU78w = parcelRequire("dU78w");
parcelRequire("81g6h");
const $1d29cf9536b12aaf$export$cb52a9ad64e0191f = 108;
const $1d29cf9536b12aaf$export$4ae45d559fb4b095 = ({ onClick: onClick, display: display = true })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    return display ? /*#__PURE__*/ (0, $iKObn.jsx)($1d29cf9536b12aaf$var$Placeholder, {
        onClick: onClick,
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        transition: {
            ease: "easeInOut"
        },
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($1d29cf9536b12aaf$var$Text, {
            className: "p-size-xs-semi-bold",
            children: [
                format(isDesktop ? "programBuilder.alternativeExercisePanel.noAlternativeExercisePlaceholder.title" : "programBuilder.alternativeExercisePanel.noAlternativeExercisePlaceholder.mobile_title"),
                /*#__PURE__*/ (0, $iKObn.jsx)($1d29cf9536b12aaf$var$LibraryContainer, {
                    children: format("programBuilder.dayTable.noExercisePlaceholder.libraryTitle")
                })
            ]
        })
    }) : null;
};
const $1d29cf9536b12aaf$var$Text = (0, $5UMQ1.default).p`
	color: ${(0, $kKnoQ.colors).grey};
	max-width: 60%;
`;
const $1d29cf9536b12aaf$var$LibraryContainer = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).primary};
	display: flex;
	place-items: center;
	place-content: center;
	gap: 4px;
`;
const $1d29cf9536b12aaf$var$Placeholder = (0, $5UMQ1.default)((0, $dU78w.motion).div)`
	display: grid;
	cursor: pointer;
	place-content: center;
	place-items: center;
	text-align: center;
	border-radius: 8px;
	background-color: ${(0, $kKnoQ.colors).primaryBackground};
	height: ${$1d29cf9536b12aaf$export$cb52a9ad64e0191f}px;
	border: 1px dashed ${(0, $kKnoQ.colors).primary};

	:hover {
		border-style: solid;
		background-color: ${(0, $kKnoQ.colors).primaryBackground};
	}
`;

});


parcelRegister("74GM7", function(module, exports) {

$parcel$export(module.exports, "DeleteProgramDialog", () => $68228fa50b948566$export$3a878024412c880);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $9XVwj = parcelRequire("9XVwj");

var $9oyj9 = parcelRequire("9oyj9");

var $81g6h = parcelRequire("81g6h");
const $68228fa50b948566$export$3a878024412c880 = ({ patient: patient, program: program, onSuccess: onSuccess, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const [awaitingDelete, setAwaitingDelete] = (0, $81g6h.useState)(false);
    const deleteProgram = (0, $81g6h.useCallback)(async ()=>{
        setAwaitingDelete(true);
        try {
            await (0, $ghfIB.programOperationsManager).performDeleteOperation(patient.id, program.id);
            setAwaitingDelete(false);
            onSuccess?.();
            otherProps.onHide();
            showToast(format("global.deleteProgramOperation.successToast.title"), format("global.deleteProgramOperation.successToast.message", {
                program: program.name
            }), "success");
        } catch (error) {
            console.error("Failed to delete program", error);
            setAwaitingDelete(false);
            showToast(format("global.deleteProgramOperation.errorToast.title"), format("global.deleteProgramOperation.errorToast.message"));
        }
    }, [
        format,
        onSuccess,
        otherProps,
        patient.id,
        program.id,
        program.name,
        showToast
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $9oyj9.ConfirmActionDialog), {
        ...otherProps,
        onCancel: otherProps.onHide,
        onConfirm: deleteProgram,
        confirmLoading: awaitingDelete,
        title: format("programBuilder.deleteDialog.header"),
        message: format("programBuilder.deleteDialog.message")
    });
};

});

parcelRegister("5e5pP", function(module, exports) {

$parcel$export(module.exports, "DayColumnState", () => $74033edf4139c2fc$export$f5145209377dfc1a);
$parcel$export(module.exports, "DuplicateDayColumnDialog", () => $74033edf4139c2fc$export$1d9c032cb1a79c18);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $eAmnG = parcelRequire("eAmnG");

var $c9OC9 = parcelRequire("c9OC9");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");

var $02Kb9 = parcelRequire("02Kb9");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $cfkGk = parcelRequire("cfkGk");

var $81g6h = parcelRequire("81g6h");
var $74033edf4139c2fc$export$f5145209377dfc1a;
(function(DayColumnState) {
    DayColumnState["SOURCE"] = "SOURCE";
    DayColumnState["AVAILABLE"] = "AVAILABLE";
    DayColumnState["NOT_AVAILABLE"] = "NOT_AVAILABLE";
    DayColumnState["SELECTED"] = "SELECTED";
})($74033edf4139c2fc$export$f5145209377dfc1a || ($74033edf4139c2fc$export$f5145209377dfc1a = {}));
const $74033edf4139c2fc$var$stateEdges = {
    AVAILABLE: "SELECTED",
    SELECTED: "AVAILABLE",
    NOT_AVAILABLE: "NOT_AVAILABLE",
    SOURCE: "SOURCE"
};
const $74033edf4139c2fc$export$1d9c032cb1a79c18 = ({ onConfirm: onConfirm, initialDayColumns: initialDayColumns, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const sourceSessionIndex = (0, $81g6h.useMemo)(()=>[
            ...initialDayColumns.entries()
        ].find(([, dayColumnState])=>dayColumnState === "SOURCE")?.[0] ?? (0, $c9OC9.DayIndex).MONDAY, [
        initialDayColumns
    ]);
    const [dayColumns, setDayColumns] = (0, $81g6h.useState)(initialDayColumns);
    const handleDayClicked = (0, $81g6h.useCallback)((clickedDayIndex)=>setDayColumns((current)=>{
            const newDayColumns = new Map([
                ...current.entries()
            ]);
            newDayColumns.set(clickedDayIndex, $74033edf4139c2fc$var$stateEdges[newDayColumns.get(clickedDayIndex) ?? "AVAILABLE"]);
            return newDayColumns;
        }), []);
    const submitSelection = (0, $81g6h.useCallback)(()=>{
        const destinationSessionIndexes = [
            ...dayColumns.entries()
        ].filter(([, dayColumnState])=>dayColumnState === "SELECTED").map(([dayIndex])=>dayIndex);
        onConfirm?.(sourceSessionIndex, destinationSessionIndexes);
        otherProps.onHide();
    }, [
        dayColumns,
        onConfirm,
        sourceSessionIndex,
        otherProps
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $gk3fY.BaseDialog), {
        header: format("programBuilder.dayTable.duplicateDayColumnDialog.header", {
            name: (0, $eAmnG.formatDayColumn)(sourceSessionIndex, "long")
        }),
        footer: /*#__PURE__*/ (0, $iKObn.jsx)($74033edf4139c2fc$var$ButtonContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                label: format("programBuilder.dayTable.duplicateDayColumnDialog.confirmButton"),
                disabled: ![
                    ...dayColumns.values()
                ].some((day)=>day === "SELECTED"),
                onClick: submitSelection
            })
        }),
        width: (0, $gk3fY.DIALOG_SIZE).S,
        ...otherProps,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($74033edf4139c2fc$var$DialogContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsxs)($74033edf4139c2fc$var$Header, {
                children: [
                    format("programBuilder.dayTable.duplicateDayColumnDialog.description", {
                        name: (0, $eAmnG.formatDayColumn)(sourceSessionIndex, "long")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($74033edf4139c2fc$var$DaysContainer, {
                        children: (0, $eAmnG.getDayColumnIndexes)().map((columnIndex)=>{
                            const dayState = dayColumns.get(columnIndex) ?? "AVAILABLE";
                            return /*#__PURE__*/ (0, $iKObn.jsx)((0, $02Kb9.Tooltip), {
                                content: format("programBuilder.dayTable.duplicateDayColumnDialog.tooltip.unavailableDay"),
                                placement: "bottom",
                                disabled: dayState !== "NOT_AVAILABLE",
                                children: /*#__PURE__*/ (0, $iKObn.jsx)($74033edf4139c2fc$var$Day, {
                                    state: dayState,
                                    className: (0, $cfkGk.classNames)("p-size-l-bold", {
                                        "unavailable-day": dayState === "NOT_AVAILABLE"
                                    }),
                                    onClick: ()=>{
                                        if ($74033edf4139c2fc$var$dayColumnStatesAttributes[dayState].selectable) handleDayClicked(columnIndex);
                                    },
                                    children: (0, $eAmnG.formatDayColumn)(columnIndex, "min")
                                })
                            }, columnIndex);
                        })
                    })
                ]
            })
        })
    });
};
const $74033edf4139c2fc$var$dayColumnStatesAttributes = {
    AVAILABLE: {
        normal: {
            backgroundColor: (0, $kKnoQ.colors).white,
            borderColor: (0, $kKnoQ.colors).grey50,
            fontColor: (0, $kKnoQ.colors).grey
        },
        hover: {
            backgroundColor: (0, $kKnoQ.colors).white,
            borderColor: (0, $kKnoQ.colors).primary,
            fontColor: (0, $kKnoQ.colors).primary
        },
        selectable: true
    },
    NOT_AVAILABLE: {
        normal: {
            backgroundColor: (0, $kKnoQ.colors).white,
            borderColor: (0, $kKnoQ.colors).white,
            fontColor: (0, $kKnoQ.colors).grey80
        },
        selectable: false
    },
    SOURCE: {
        normal: {
            backgroundColor: (0, $kKnoQ.colors).primary,
            borderColor: (0, $kKnoQ.colors).primary,
            fontColor: (0, $kKnoQ.colors).white
        },
        selectable: false
    },
    SELECTED: {
        normal: {
            backgroundColor: (0, $kKnoQ.colors).primary25,
            borderColor: (0, $kKnoQ.colors).primary,
            fontColor: (0, $kKnoQ.colors).primary
        },
        selectable: true
    }
};
const $74033edf4139c2fc$var$DialogContainer = (0, $5UMQ1.default).div`
	height: 100%;
	${(0, $5WGN2.stack)("M", "spacebetween", "stretch")}
`;
const $74033edf4139c2fc$var$Header = (0, $5UMQ1.default).div``;
const $74033edf4139c2fc$var$ButtonContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("S", "flexend")}
`;
const $74033edf4139c2fc$var$DaysContainer = (0, $5UMQ1.default).div`
	display: grid;
	grid-auto-flow: column;
	gap: 8px;
	margin-top: 24px;
	margin-bottom: 32px;
`;
const $74033edf4139c2fc$var$Day = (0, $5UMQ1.default).div`
	border-radius: 2px;
	border-style: solid;
	border-width: 2px;
	background-color: ${({ state: state })=>$74033edf4139c2fc$var$dayColumnStatesAttributes[state].normal.backgroundColor};
	border-color: ${({ state: state })=>$74033edf4139c2fc$var$dayColumnStatesAttributes[state].normal.borderColor};
	color: ${({ state: state })=>$74033edf4139c2fc$var$dayColumnStatesAttributes[state].normal.fontColor};
	cursor: ${({ state: state })=>$74033edf4139c2fc$var$dayColumnStatesAttributes[state].selectable ? "pointer" : undefined};
	text-align: center;
	padding: 8px;

	:hover {
		background-color: ${({ state: state })=>$74033edf4139c2fc$var$dayColumnStatesAttributes[state].hover?.backgroundColor};
		border-color: ${({ state: state })=>$74033edf4139c2fc$var$dayColumnStatesAttributes[state].hover?.borderColor};
		color: ${({ state: state })=>$74033edf4139c2fc$var$dayColumnStatesAttributes[state].hover?.fontColor};
	}
`;

});
parcelRegister("eAmnG", function(module, exports) {

$parcel$export(module.exports, "getEmptyNewProgram", () => $9775efb39554a259$export$bf28771b54e5eed2);
$parcel$export(module.exports, "programContentAreEquals", () => $9775efb39554a259$export$68cc94df134ca048);
$parcel$export(module.exports, "isNewProgram", () => $9775efb39554a259$export$944bbbdb55362925);
$parcel$export(module.exports, "getProgramDetails", () => $9775efb39554a259$export$69ddbbb622546469);
$parcel$export(module.exports, "isProgram", () => $9775efb39554a259$export$815dcd8704afdae2);
$parcel$export(module.exports, "formatDayColumn", () => $9775efb39554a259$export$2b9c4dac05fe8c6f);
$parcel$export(module.exports, "getDayColumnIndexes", () => $9775efb39554a259$export$774801081c7313ef);
$parcel$export(module.exports, "getLocaleDayColumnIndex", () => $9775efb39554a259$export$b809370f3d717801);
$parcel$export(module.exports, "programContentDeepCopy", () => $9775efb39554a259$export$8cd77b6dd1c422b4);
$parcel$export(module.exports, "updateExerciseFromProgram", () => $9775efb39554a259$export$1eba89aee861da1);

var $hLaGu = parcelRequire("hLaGu");

var $c9OC9 = parcelRequire("c9OC9");

var $5SzTW = parcelRequire("5SzTW");

var $kLgU7 = parcelRequire("kLgU7");

var $lTdpc = parcelRequire("lTdpc");

var $kXaMn = parcelRequire("kXaMn");

var $hEQyt = parcelRequire("hEQyt");

var $buI4E = parcelRequire("buI4E");

var $cD3aa = parcelRequire("cD3aa");
const $9775efb39554a259$export$bf28771b54e5eed2 = (patientId)=>({
        patientId: patientId,
        days: new (0, $c9OC9.ProgramDays)(),
        status: (0, $5SzTW.ProgramStatus).Draft
    });
function $9775efb39554a259$export$68cc94df134ca048(programContent1, programContent2) {
    const nameEquals = (0, $lTdpc.isNotNil)(programContent1.name || programContent2.name) && programContent1.name === programContent2.name;
    const startDateEquals = !(programContent1.startDate && programContent2.startDate) || !!programContent1.startDate.isSame(programContent2.startDate, "date");
    const endDateEquals = !(programContent1.endDate && programContent2.endDate) || !!programContent1.endDate.isSame(programContent2.endDate, "date");
    return nameEquals && startDateEquals && endDateEquals && programContent1.days.equals(programContent2.days);
}
function $9775efb39554a259$export$944bbbdb55362925(program) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return program.id === undefined;
}
function $9775efb39554a259$export$69ddbbb622546469(days) {
    const emptyProgramDetails = {
        exerciseTitles: [],
        exerciseUnits: [],
        exerciseSets: [],
        exerciseIds: [],
        exerciseRevisions: [],
        exerciseCategories: [],
        exerciseBodyParts: [],
        exerciseDifficulties: [],
        exerciseStartingPosition: []
    };
    return days.map(([, session])=>session).reduce((accDay, day)=>{
        const exerciseDetails = day.exercises.reduce((accExercise, exercise)=>({
                exerciseTitles: [
                    ...accExercise.exerciseTitles,
                    exercise.title
                ],
                exerciseUnits: [
                    ...accExercise.exerciseUnits,
                    exercise.units
                ],
                exerciseSets: [
                    ...accExercise.exerciseSets,
                    exercise.setCount
                ],
                exerciseIds: [
                    ...accExercise.exerciseIds,
                    exercise.id
                ],
                exerciseRevisions: [
                    ...accExercise.exerciseRevisions,
                    exercise.revision
                ],
                exerciseCategories: [
                    ...accExercise.exerciseCategories,
                    exercise.category
                ],
                exerciseBodyParts: [
                    ...accExercise.exerciseBodyParts,
                    (0, $hLaGu.exerciseBodyParts)(exercise).join("&&")
                ],
                exerciseDifficulties: [
                    ...accExercise.exerciseDifficulties,
                    exercise.difficulty
                ],
                exerciseStartingPosition: [
                    ...accExercise.exerciseStartingPosition,
                    exercise.startingPosition
                ]
            }), emptyProgramDetails);
        return {
            exerciseTitles: [
                ...accDay.exerciseTitles,
                ...exerciseDetails.exerciseTitles
            ],
            exerciseUnits: [
                ...accDay.exerciseUnits,
                ...exerciseDetails.exerciseUnits
            ],
            exerciseSets: [
                ...accDay.exerciseSets,
                ...exerciseDetails.exerciseSets
            ],
            exerciseIds: [
                ...accDay.exerciseIds,
                ...exerciseDetails.exerciseIds
            ],
            exerciseRevisions: [
                ...accDay.exerciseRevisions,
                ...exerciseDetails.exerciseRevisions
            ],
            exerciseCategories: [
                ...accDay.exerciseCategories,
                ...exerciseDetails.exerciseCategories
            ],
            exerciseBodyParts: [
                ...accDay.exerciseBodyParts,
                ...exerciseDetails.exerciseBodyParts
            ],
            exerciseDifficulties: [
                ...accDay.exerciseDifficulties,
                ...exerciseDetails.exerciseDifficulties
            ],
            exerciseStartingPosition: [
                ...accDay.exerciseStartingPosition,
                ...exerciseDetails.exerciseStartingPosition
            ]
        };
    }, emptyProgramDetails);
}
function $9775efb39554a259$export$815dcd8704afdae2(program) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return program.id !== undefined;
}
const $9775efb39554a259$export$2b9c4dac05fe8c6f = (columnIndex, formattingType)=>{
    const isShort = formattingType === "short";
    const dayIndex = columnIndex % (0, $kXaMn.WEEK_LENGTH);
    let dayLabel;
    if (formattingType === "long") dayLabel = (0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).weekdays()[dayIndex];
    else if (isShort) dayLabel = (0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).weekdaysShort()[dayIndex];
    else dayLabel = (0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).weekdaysMin()[dayIndex];
    return (0, $buI4E.capitalizeFirstLetter)(dayLabel);
};
const $9775efb39554a259$export$774801081c7313ef = ()=>(0, $kLgU7.offsetArray)((0, $c9OC9.dayIndexes), (0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).localeData().firstDayOfWeek() - 1);
const $9775efb39554a259$export$b809370f3d717801 = (index)=>(0, $hEQyt.positiveModulo)(index - (0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).localeData().firstDayOfWeek(), 7);
function $9775efb39554a259$export$8cd77b6dd1c422b4({ days: days, ...others }) {
    return {
        ...others,
        days: days.copy()
    };
}
const $9775efb39554a259$export$1eba89aee861da1 = (program, exerciseToUpdateDraggableId, newExercise)=>{
    if ((0, $lTdpc.isNil)(exerciseToUpdateDraggableId) || (0, $lTdpc.isNil)(newExercise)) return program;
    return {
        ...program,
        days: new (0, $c9OC9.ProgramDays)(program.days.map(([dayIndex, session])=>[
                dayIndex,
                {
                    exercises: session.exercises.map((e)=>e.draggableId === exerciseToUpdateDraggableId ? newExercise : e)
                }
            ]))
    };
};

});


parcelRegister("cxZ7L", function(module, exports) {

$parcel$export(module.exports, "RenameProgramDialog", () => $bb75b5f712917323$export$96faf2f1b7f97d49);

var $iKObn = parcelRequire("iKObn");

var $he9Ds = parcelRequire("he9Ds");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");

var $lQZUP = parcelRequire("lQZUP");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $dU78w = parcelRequire("dU78w");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
const $bb75b5f712917323$export$96faf2f1b7f97d49 = ({ programName: programName, renameProgram: renameProgram, isTemplate: isTemplate, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { control: control, handleSubmit: handleSubmit } = (0, $eKUeg.useForm)({
        defaultValues: {
            programName: programName
        }
    });
    const onSubmit = (data)=>{
        if (renameProgram) {
            renameProgram(data.programName);
            otherProps.onHide();
        }
    };
    const translationKeys = (0, $81g6h.useMemo)(()=>isTemplate ? {
            title: format("templateBuilder.renameProgramDialog.title"),
            label: format("templateBuilder.renameProgramDialog.newName.label"),
            placeholder: format("templateBuilder.renameProgramDialog.newName.placeholder"),
            saveButton: format("templateBuilder.renameProgramDialog.saveButton")
        } : {
            title: format("programBuilder.renameProgramDialog.title"),
            label: format("programBuilder.renameProgramDialog.newName.label"),
            placeholder: format("programBuilder.renameProgramDialog.newName.placeholder"),
            saveButton: format("programBuilder.renameProgramDialog.saveButton")
        }, [
        format,
        isTemplate
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $gk3fY.BaseDialog), {
        header: translationKeys.title,
        visible: true,
        footer: /*#__PURE__*/ (0, $iKObn.jsx)($bb75b5f712917323$var$ButtonContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                label: translationKeys.saveButton,
                type: "submit",
                onClick: handleSubmit(onSubmit)
            })
        }),
        width: (0, $gk3fY.DIALOG_SIZE).S,
        ...otherProps,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($bb75b5f712917323$var$DialogContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)($bb75b5f712917323$var$Form, {
                onSubmit: handleSubmit(onSubmit),
                children: /*#__PURE__*/ (0, $iKObn.jsxs)($bb75b5f712917323$var$FormField, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                            className: "p-size-m",
                            children: translationKeys.label
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                            name: "programName",
                            control: control,
                            defaultValue: programName,
                            rules: {
                                required: format("global.form.field.requiredError"),
                                maxLength: {
                                    value: (0, $he9Ds.APP_CONSTANTS).PROGRAM_OR_TEMPLATE_MAX_TITLE_LENGTH,
                                    message: format("global.programName.maxLength")
                                }
                            },
                            render: ({ field: { onChange: onChange, value: value, ...otherFields }, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $lQZUP.TextAreaWithCharLimit), {
                                    ...otherFields,
                                    autoComplete: "off",
                                    autoFocus: !value,
                                    text: value,
                                    onTextChange: onChange,
                                    errorMessage: fieldState.error?.message,
                                    charLimit: (0, $he9Ds.APP_CONSTANTS).PROGRAM_OR_TEMPLATE_MAX_TITLE_LENGTH,
                                    placeholder: translationKeys.placeholder
                                })
                        })
                    ]
                })
            })
        })
    });
};
const $bb75b5f712917323$var$DialogContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("M", "flexstart", "stretch")};
	height: 100%;
`;
const $bb75b5f712917323$var$ButtonContainer = (0, $5UMQ1.default).div`
	padding-top: 1.25rem;
	${(0, $5WGN2.row)("S", "flexend")}
`;
const $bb75b5f712917323$var$Form = (0, $5UMQ1.default)((0, $dU78w.motion).form)`
	${(0, $5WGN2.stack)("M", "spacebetween", "stretch")}
	height: 100%;
`;
const $bb75b5f712917323$var$FormField = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("S", "flexstart", "stretch")};
`;

});

parcelRegister("5XbDN", function(module, exports) {

$parcel$export(module.exports, "SaveChangesDialog", () => $d757f431af46ad24$export$9762e808bbbcad90);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $gk3fY = parcelRequire("gk3fY");

var $9oyj9 = parcelRequire("9oyj9");

var $81g6h = parcelRequire("81g6h");
const $d757f431af46ad24$export$9762e808bbbcad90 = ({ onConfirm: onConfirm, onCancel: onCancel, message: message, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const handleConfirm = (0, $81g6h.useCallback)(()=>{
        onConfirm?.();
        otherProps.onHide();
    }, [
        onConfirm,
        otherProps
    ]);
    const handleCancel = (0, $81g6h.useCallback)(()=>{
        onCancel?.();
        otherProps.onHide();
    }, [
        onCancel,
        otherProps
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $9oyj9.ConfirmActionDialog), {
        ...otherProps,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        onHide: handleCancel,
        title: format("global.saveChangesDialog.title"),
        confirmButtonLabel: format("global.saveChangesDialog.confirmButtonLabel"),
        message: message,
        width: (0, $gk3fY.DIALOG_SIZE).M
    });
};

});

parcelRegister("8H969", function(module, exports) {

$parcel$export(module.exports, "ScheduleProgramDialog", () => $1f92ee82526c1f16$export$4d2fe142e0110d5a);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $aEP4N = parcelRequire("aEP4N");

var $eAmnG = parcelRequire("eAmnG");

var $bC9c0 = parcelRequire("bC9c0");

var $5SzTW = parcelRequire("5SzTW");

var $a6fIt = parcelRequire("a6fIt");

var $5UMQ1 = parcelRequire("5UMQ1");

var $imaOW = parcelRequire("imaOW");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");

var $8FlUV = parcelRequire("8FlUV");

var $02Kb9 = parcelRequire("02Kb9");

var $eGyIe = parcelRequire("eGyIe");

var $isRr9 = parcelRequire("isRr9");

var $2sUOK = parcelRequire("2sUOK");

var $1IWnK = parcelRequire("1IWnK");

var $coYyz = parcelRequire("coYyz");

var $9L5pp = parcelRequire("9L5pp");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $kXaMn = parcelRequire("kXaMn");

var $hEQyt = parcelRequire("hEQyt");

var $cD3aa = parcelRequire("cD3aa");

var $dDMmD = parcelRequire("dDMmD");
var $dU78w = parcelRequire("dU78w");

var $jTpg0 = parcelRequire("jTpg0");

var $ebUJr = parcelRequire("ebUJr");

var $cfkGk = parcelRequire("cfkGk");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
var $1f92ee82526c1f16$var$CalendarIcon = function CalendarIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.677 5.773a.807.807 0 0 0-.807.807v12.647c0 .445.361.806.807.806h12.646a.807.807 0 0 0 .807-.806V6.58a.807.807 0 0 0-.807-.807H5.677ZM2.87 6.58a2.807 2.807 0 0 1 2.807-2.807h12.646A2.807 2.807 0 0 1 21.13 6.58v12.647a2.807 2.807 0 0 1-2.807 2.806H5.677a2.807 2.807 0 0 1-2.807-2.806V6.58Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.613 1.967a1 1 0 0 1 1 1V6.58a1 1 0 1 1-2 0V2.967a1 1 0 0 1 1-1ZM8.387 1.967a1 1 0 0 1 1 1V6.58a1 1 0 1 1-2 0V2.967a1 1 0 0 1 1-1ZM2.87 10.193a1 1 0 0 1 1-1h16.26a1 1 0 1 1 0 2H3.87a1 1 0 0 1-1-1Z",
                fill: "currentColor"
            })
        ]
    });
};
$1f92ee82526c1f16$var$CalendarIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $1f92ee82526c1f16$var$MAX_PROGRAM_MONTH_DURATION = 24;
const $1f92ee82526c1f16$var$CalendarFooterContent = ({ text: text })=>/*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$CalendarFooter, {
        className: "p-size-xs-semi-bold",
        children: text
    });
const $1f92ee82526c1f16$export$4d2fe142e0110d5a = ({ program: program, editedProgram: editedProgram, onSave: onSave, patient: patient, secondaryButtonProps: secondaryButtonProps, ...otherProps })=>{
    const { format: format, formatDateShort: formatDateShort, formatDateMed: formatDateMed, formatProgramDuration: formatProgramDuration, getEndWeekDay: getEndWeekDay } = (0, $1eHG3.useI18n)();
    const { formatPatientName: formatPatientName } = (0, $aEP4N.useFormatPatients)();
    const disabledWeekDays = (0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).without((0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).range(7), (0, $hEQyt.positiveModulo)((0, (/*@__PURE__*/$parcel$interopDefault($cD3aa))).localeData().firstDayOfWeek() - 1, 7));
    const maxDate = (0, $81g6h.useMemo)(()=>(0, $kXaMn.now)().add($1f92ee82526c1f16$var$MAX_PROGRAM_MONTH_DURATION, "month").endOf("week"), []);
    const { allPatientPrograms: allPatientPrograms, shouldDisplayProgramEndingSoonAlert: shouldDisplayProgramEndingSoonAlert } = (0, $9L5pp.useAllPatientPrograms)(patient);
    const getDefaultStartDate = (0, $81g6h.useCallback)(()=>{
        switch(program.status){
            case (0, $5SzTW.ProgramStatus).Ended:
            case (0, $5SzTW.ProgramStatus).Ongoing:
                return editedProgram.startDate;
            case (0, $5SzTW.ProgramStatus).Scheduled:
                return (0, $lTdpc.isNotNil)(editedProgram.startDate) && (0, $kXaMn.dateIsBeforeOrSameAs)((0, $kXaMn.now)(), editedProgram.startDate) ? editedProgram.startDate : (0, $kXaMn.now)();
            case (0, $5SzTW.ProgramStatus).Draft:
                {
                    const lastScheduledProgram = (0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).maxBy(allPatientPrograms?.scheduledPrograms, (p)=>p.endDate.valueOf());
                    if ((0, $lTdpc.isNotNil)(lastScheduledProgram)) return lastScheduledProgram.endDate.add(1, "day");
                    return (0, $lTdpc.isNotNil)(allPatientPrograms?.ongoingProgram?.endDate) ? allPatientPrograms.ongoingProgram.endDate.add(1, "day") : (0, $kXaMn.now)();
                }
        }
    }, [
        allPatientPrograms?.ongoingProgram,
        allPatientPrograms?.scheduledPrograms,
        editedProgram.startDate,
        program.status
    ]);
    const { control: control, handleSubmit: handleSubmit, setValue: setValue, watch: watch } = (0, $eKUeg.useForm)({
        defaultValues: {
            startDate: getDefaultStartDate(),
            endDate: editedProgram.endDate
        },
        shouldFocusError: false
    });
    (0, $81g6h.useEffect)(()=>{
        setValue("startDate", getDefaultStartDate());
    }, [
        getDefaultStartDate,
        setValue
    ]);
    const guide02Visible = (0, $1IWnK.useObservable)((0, $2sUOK.startGuide02Requested));
    (0, $81g6h.useEffect)(()=>()=>(0, $2sUOK.clearStartGuide02Request)(), []);
    (0, $81g6h.useEffect)(()=>{
        if (guide02Visible) (0, $bC9c0.sendAnalyticsEventViewGuide)((0, $isRr9.OnboardingProgramQuickstartStep).START_GUIDE_02);
    }, [
        guide02Visible
    ]);
    const scheduleDates = async (dates)=>{
        if ((0, $lTdpc.isNil)(dates.startDate)) throw new Error();
        onSave(dates);
        otherProps.onHide();
        (0, $bC9c0.sendAnalyticsEventDateModification)(patient.id, program, dates);
        if (program.status === (0, $5SzTW.ProgramStatus).Draft) {
            try {
                await (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).START_GUIDE_02);
            } catch  {
            // ignore onboarding errors
            }
            (0, $2sUOK.clearStartGuide02Request)();
        }
    };
    const startDate = watch("startDate");
    const endDate = watch("endDate");
    const overlappedProgram = (0, $81g6h.useMemo)(()=>(0, $lTdpc.isNotNil)(endDate) && (0, $lTdpc.isNotNil)(startDate) && (0, $ghfIB.patientProgramsManager).getOverlappingProgram(patient.id, startDate, endDate, (0, $eAmnG.isNewProgram)(program) ? undefined : program.id), [
        patient,
        startDate,
        endDate,
        program
    ]);
    const setEndDate = (event, date)=>{
        event.preventDefault();
        const clampedEndDate = date.isAfter(maxDate) ? maxDate : date;
        setValue("endDate", clampedEndDate);
    };
    const endingSoonRemainingDays = (0, $81g6h.useMemo)(()=>{
        const days = (0, $lTdpc.isNotNil)(endDate) ? (0, $kXaMn.computeDiffInDays)((0, $kXaMn.nowAsStartOfDay)(), endDate) : undefined;
        return shouldDisplayProgramEndingSoonAlert && (0, $lTdpc.isNotNil)(days) && days < (0, $kXaMn.TWO_MONTH_IN_DAYS) ? days : undefined;
    }, [
        endDate,
        shouldDisplayProgramEndingSoonAlert
    ]);
    const renderSecondaryButton = (0, $81g6h.useCallback)(()=>(0, $lTdpc.isNotNil)(secondaryButtonProps) ? /*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$ResponsiveButton, {
            uiStyle: "secondary",
            ...secondaryButtonProps,
            onClick: ()=>{
                otherProps.onHide();
                secondaryButtonProps.onClick({
                    startDate: startDate,
                    endDate: endDate
                });
            }
        }) : null, [
        endDate,
        otherProps,
        secondaryButtonProps,
        startDate
    ]);
    const durationIsInvalid = (0, $lTdpc.isNil)(endDate) || endDate.isBefore(startDate) || !!overlappedProgram;
    const endWeekDay = getEndWeekDay();
    const calendarFooterText = format("programBuilder.scheduleDialog.calendarFooter", {
        endDay: endWeekDay
    });
    const renderCalendarFooter = (0, $81g6h.useCallback)(()=>/*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$CalendarFooterContent, {
            text: calendarFooterText
        }), [
        calendarFooterText
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $gk3fY.BaseDialog), {
        header: format("programBuilder.scheduleDialog.header"),
        footer: /*#__PURE__*/ (0, $iKObn.jsxs)($1f92ee82526c1f16$var$ButtonContainer, {
            children: [
                renderSecondaryButton(),
                /*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$ResponsiveButton, {
                    type: "submit",
                    onClick: handleSubmit((data)=>scheduleDates(data)),
                    label: format(program.status === (0, $5SzTW.ProgramStatus).Draft ? "programBuilder.scheduleDialog.startButton" : "programBuilder.scheduleDialog.okButton"),
                    "data-test": (0, $a6fIt.e2eTestId).scheduleProgramDialog.submitButton
                })
            ]
        }),
        width: (0, $gk3fY.DIALOG_SIZE).S,
        closeOnEscape: true,
        dismissableMask: true,
        ...otherProps,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$DialogContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$Form, {
                children: /*#__PURE__*/ (0, $iKObn.jsxs)($1f92ee82526c1f16$var$FormContainer, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsxs)((0, $dDMmD.AnimatePresence), {
                            children: [
                                overlappedProgram && /*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$MotionWarnCard, {
                                    message: format("programBuilder.startDialog.overlapWarn.v1_6", {
                                        name: formatPatientName(patient),
                                        startDate: formatDateMed(overlappedProgram.startDate),
                                        endDate: formatDateMed(overlappedProgram.endDate)
                                    }),
                                    initial: {
                                        opacity: 0
                                    },
                                    animate: {
                                        opacity: 1
                                    },
                                    exit: {
                                        opacity: 0
                                    },
                                    cardType: (0, $imaOW.CardType).Warn
                                }),
                                !overlappedProgram && (0, $lTdpc.isNotNil)(endingSoonRemainingDays) && /*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$MotionWarnCard, {
                                    title: format("programBuilder.scheduleDialog.endingSoonAlert.title", {
                                        remainingDays: endingSoonRemainingDays
                                    }),
                                    message: format("programBuilder.scheduleDialog.endingSoonAlert.message", {
                                        patientName: patient.firstName
                                    }),
                                    initial: {
                                        opacity: 0
                                    },
                                    animate: {
                                        opacity: 1
                                    },
                                    exit: {
                                        opacity: 0
                                    },
                                    cardType: (0, $imaOW.CardType).Warn
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsxs)($1f92ee82526c1f16$var$FormField, {
                            children: [
                                guide02Visible && /*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$StyledOnboardingPanel, {
                                    text: format("programBuilder.quickstart.step.startGuide02"),
                                    onClose: ()=>{
                                        (0, $2sUOK.clearStartGuide02Request)();
                                    }
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                                    className: "p-size-m",
                                    children: format("programBuilder.startDialog.startingDate.label")
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                                    name: "startDate",
                                    control: control,
                                    rules: {
                                        required: format("programBuilder.startDialog.startingDate.required"),
                                        validate: ()=>program.status !== (0, $5SzTW.ProgramStatus).Ongoing && overlappedProgram ? format("programBuilder.startDialog.startingDate.invalid") : undefined
                                    },
                                    render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$StyledCalendar, {
                                                    ...field,
                                                    value: field.value?.toDate(),
                                                    disabled: program.status === (0, $5SzTW.ProgramStatus).Ongoing,
                                                    onChange: (e)=>setValue("startDate", (0, $lTdpc.isNotNil)(e.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($cD3aa)))(e.value) : undefined),
                                                    className: (0, $cfkGk.classNames)({
                                                        "p-invalid": fieldState.invalid && !!overlappedProgram
                                                    }),
                                                    minDate: new Date(),
                                                    inputStyle: {
                                                        width: 100
                                                    },
                                                    formatDateTime: ()=>formatDateShort(startDate),
                                                    icon: /*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$CalendarIcon, {
                                                        height: 24,
                                                        width: 24
                                                    }),
                                                    showIcon: true
                                                }),
                                                /*#__PURE__*/ (0, $iKObn.jsx)((0, $8FlUV.ErrorMessage), {
                                                    children: overlappedProgram && fieldState.error?.message
                                                })
                                            ]
                                        })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsxs)($1f92ee82526c1f16$var$FormField, {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                    className: "p-size-m",
                                    children: format("programBuilder.scheduleDialog.endDate.label")
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$DurationShortcuts, {
                                    programStatus: program.status,
                                    startDate: startDate,
                                    endDate: endDate,
                                    maxDate: maxDate,
                                    onClick: setEndDate
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                                    name: "endDate",
                                    control: control,
                                    rules: {
                                        required: format("programBuilder.scheduleDialog.endDate.required"),
                                        validate: ()=>durationIsInvalid ? format("programBuilder.startDialog.startingDate.invalid") : undefined
                                    },
                                    render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$StyledCalendar, {
                                                    ...field,
                                                    value: field.value?.toDate(),
                                                    onChange: (e)=>setValue("endDate", (0, $lTdpc.isNotNil)(e.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($cD3aa)))(e.value) : undefined),
                                                    className: (0, $cfkGk.classNames)({
                                                        "p-invalid": fieldState.invalid && !!overlappedProgram
                                                    }),
                                                    minDate: new Date(),
                                                    maxDate: maxDate.toDate(),
                                                    disabledDays: disabledWeekDays,
                                                    formatDateTime: ()=>formatDateShort(endDate),
                                                    footerTemplate: renderCalendarFooter,
                                                    placeholder: format("programBuilder.scheduleDialog.endDatePlaceholder"),
                                                    icon: /*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$CalendarIcon, {
                                                        height: 24,
                                                        width: 24
                                                    }),
                                                    showIcon: true
                                                }),
                                                /*#__PURE__*/ (0, $iKObn.jsx)((0, $8FlUV.ErrorMessage), {
                                                    children: durationIsInvalid && fieldState.error?.message
                                                })
                                            ]
                                        })
                                }),
                                (0, $lTdpc.isNotNil)(endDate) && (0, $lTdpc.isNotNil)(startDate) && !durationIsInvalid && /*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$Duration, {
                                    className: "p-size-s",
                                    children: format("programBuilder.startDialog.weeks.duration", {
                                        duration: formatProgramDuration(startDate, endDate)
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
const $1f92ee82526c1f16$var$DialogContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("M", "flexstart", "stretch")}
	height: 100%;
`;
const $1f92ee82526c1f16$var$ButtonContainer = (0, $5UMQ1.default).div`
	display: flex;
	gap: 24px;
	justify-content: flex-end;
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		flex-direction: column-reverse;
		gap: 12px;
	}
`;
const $1f92ee82526c1f16$var$Form = (0, $5UMQ1.default)((0, $dU78w.motion).form)`
	${(0, $5WGN2.stack)("M", "spacebetween", "stretch")}
	height: 100%;
`;
const $1f92ee82526c1f16$var$FormContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("M", "flexstart", "stretch")}
`;
const $1f92ee82526c1f16$var$FormField = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("S", "flexstart", "stretch")};
`;
const $1f92ee82526c1f16$var$StyledCalendar = (0, $5UMQ1.default)((0, $ebUJr.Calendar))`
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		max-width: 100%;
	}

	.p-tooltip .p-tooltip-text {
		visibility: hidden !important;
		width: 30px !important;
	}
`;
const $1f92ee82526c1f16$var$ResponsiveButton = (0, $5UMQ1.default)((0, $dhb7H.Button))`
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		align-self: stretch;
	}
`;
const $1f92ee82526c1f16$var$MotionWarnCard = (0, $dU78w.motion)((0, $imaOW.AlertCard));
const $1f92ee82526c1f16$var$CalendarFooter = (0, $5UMQ1.default).div`
	max-width: 375px;
	margin: 12px;
	color: ${(0, $kKnoQ.colors).grey80};
`;
const $1f92ee82526c1f16$var$Duration = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).grey80};
	margin-top: -8px;
`;
const $1f92ee82526c1f16$var$StyledOnboardingPanel = (0, $5UMQ1.default)((0, $eGyIe.OnboardingPanel))`
	margin-bottom: 8px;
`;
const $1f92ee82526c1f16$var$DurationShortcuts = ({ programStatus: programStatus, startDate: startDate, endDate: endDate, maxDate: maxDate, onClick: onClick })=>{
    const shortcuts = (0, $coYyz.useScheduleShortcuts)(programStatus, startDate, endDate);
    const { format: format } = (0, $1eHG3.useI18n)();
    const shouldDisplayTooltip = (0, $81g6h.useCallback)((newEndDate)=>newEndDate.isAfter(maxDate), [
        maxDate
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$ShortcutsContainer, {
        children: shortcuts.map((shortcut, index)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $02Kb9.Tooltip), {
                disabled: !shouldDisplayTooltip(shortcut.newDate),
                content: format("programBuilder.scheduleDialog.endDateTooltip"),
                placement: "auto",
                maxWidth: 400,
                children: /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($1f92ee82526c1f16$var$ShortcutButton, {
                        className: "p-button-secondary ui-button-outlined",
                        onClick: (event)=>{
                            onClick(event, shortcut.newDate);
                            shortcut.sendAnalyticsEvent();
                        },
                        label: shortcut.label,
                        disabled: (0, $lTdpc.isNil)(startDate),
                        "data-test": (0, $a6fIt.e2eTestId).scheduleProgramDialog.shortcut(index)
                    })
                })
            }, `${shortcut.label}-${shortcut.newDate.valueOf()}`))
    });
};
const $1f92ee82526c1f16$var$ShortcutsContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8)}
`;
const $1f92ee82526c1f16$var$ShortcutButton = (0, $5UMQ1.default)((0, $dhb7H.Button))`
	background-color: ${(0, $kKnoQ.colors).white} !important;
	width: 100%;
	padding: 8px 16px;
	font-size: 14px;
`;

});
parcelRegister("2sUOK", function(module, exports) {

$parcel$export(module.exports, "startGuide02Requested", () => $36cf4929d3b5fc3f$export$26d59328b163cedb);
$parcel$export(module.exports, "requestStartGuide02", () => $36cf4929d3b5fc3f$export$848fd658aea0c687);
$parcel$export(module.exports, "clearStartGuide02Request", () => $36cf4929d3b5fc3f$export$2534584e709bc7b7);

var $1IWnK = parcelRequire("1IWnK");
const $36cf4929d3b5fc3f$export$26d59328b163cedb = (0, $1IWnK.observable)(false);
const $36cf4929d3b5fc3f$export$848fd658aea0c687 = ()=>$36cf4929d3b5fc3f$export$26d59328b163cedb.set(true);
const $36cf4929d3b5fc3f$export$2534584e709bc7b7 = ()=>$36cf4929d3b5fc3f$export$26d59328b163cedb.set(false);

});

parcelRegister("coYyz", function(module, exports) {

$parcel$export(module.exports, "useScheduleShortcuts", () => $7d1ec37b9e1c6606$export$9b15a6ed6f19a9a7);

var $1eHG3 = parcelRequire("1eHG3");

var $bC9c0 = parcelRequire("bC9c0");

var $5SzTW = parcelRequire("5SzTW");

var $kXaMn = parcelRequire("kXaMn");
const $7d1ec37b9e1c6606$var$SHORTCUTS_MONTH_LIST = [
    3,
    6,
    9
];
const $7d1ec37b9e1c6606$export$9b15a6ed6f19a9a7 = (programStatus, startDate, endDate)=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    switch(programStatus){
        case (0, $5SzTW.ProgramStatus).Ongoing:
            return $7d1ec37b9e1c6606$var$SHORTCUTS_MONTH_LIST.map((month)=>({
                    label: format("programBuilder.scheduleDialog.addShortcut", {
                        month: month
                    }),
                    newDate: (endDate ?? startDate ?? (0, $kXaMn.now)()).add(month, "month").endOf("week"),
                    sendAnalyticsEvent: ()=>(0, $bC9c0.sendAnalyticsEventProgramDurationExtendedShortcut)(month)
                }));
        case (0, $5SzTW.ProgramStatus).Scheduled:
        case (0, $5SzTW.ProgramStatus).Draft:
            return $7d1ec37b9e1c6606$var$SHORTCUTS_MONTH_LIST.map((month)=>({
                    label: format("programBuilder.scheduleDialog.inShortcut", {
                        month: month
                    }),
                    newDate: (startDate ?? (0, $kXaMn.now)()).add(month, "month").endOf("week"),
                    sendAnalyticsEvent: ()=>(0, $bC9c0.sendAnalyticsEventSetProgramDurationShortcut)(month)
                }));
        case (0, $5SzTW.ProgramStatus).Ended:
            return [];
    }
};

});

parcelRegister("9L5pp", function(module, exports) {

$parcel$export(module.exports, "usePatientProgram", () => $57d1be5912aecba6$export$8343e18dee3b1607);
$parcel$export(module.exports, "useAllPatientPrograms", () => $57d1be5912aecba6$export$5bffa8342b4ba9);

var $ghfIB = parcelRequire("ghfIB");

var $5SzTW = parcelRequire("5SzTW");

var $5stJo = parcelRequire("5stJo");

var $jTpg0 = parcelRequire("jTpg0");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
function $57d1be5912aecba6$export$8343e18dee3b1607({ programId: programId, patientId: patientId, withFetch: withFetch = true }) {
    const [loading, setLoading] = (0, $81g6h.useState)(withFetch && !!programId);
    const [error, setError] = (0, $81g6h.useState)();
    const program = (0, $1IWnK.useComputedObservable)(()=>programId ? (0, $ghfIB.programManager).programsByPatient.get().get(patientId)?.get(programId) : undefined, [
        patientId,
        programId
    ]);
    const refreshProgram = (0, $81g6h.useCallback)(async (patientIdToFetch, programIdToFetch)=>{
        try {
            setLoading(true);
            await (0, $ghfIB.programManager).fetchPatientProgram(patientIdToFetch, programIdToFetch);
            setError(undefined);
        } catch (e) {
            setError(e);
            console.error(e);
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $81g6h.useEffect)(()=>{
        withFetch && programId && refreshProgram(patientId, programId);
    }, [
        patientId,
        programId,
        refreshProgram,
        withFetch
    ]);
    return {
        loading: loading,
        program: program,
        error: error,
        refreshProgram: refreshProgram
    };
}
function $57d1be5912aecba6$export$5bffa8342b4ba9(patient, withFetch = true) {
    const [loading, setLoading] = (0, $81g6h.useState)(withFetch);
    const [error, setError] = (0, $81g6h.useState)(undefined);
    const allPatientPrograms = (0, $1IWnK.useComputedObservable)(()=>(0, $ghfIB.patientProgramsManager).allProgramsByPatient.get().get(patient.id), [
        patient
    ]);
    const refreshAllPrograms = (0, $81g6h.useCallback)(async (patientIdToFetch)=>{
        try {
            await (0, $ghfIB.patientProgramsManager).fetchAllPatientPrograms(patientIdToFetch);
            setError(null);
        } catch (e) {
            setError(e);
            console.error(e);
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $81g6h.useEffect)(()=>{
        withFetch && refreshAllPrograms(patient.id);
    }, [
        patient,
        refreshAllPrograms,
        withFetch
    ]);
    const { shouldDisplayProgramEndingSoonAlert: shouldDisplayProgramEndingSoonAlert, shouldDisplayProgramEndingNoOngoingAlert: shouldDisplayProgramEndingNoOngoingAlert } = (0, $81g6h.useMemo)(()=>{
        const globalProgramStatus = (0, $5stJo.extractGlobalProgramStatusFromPatient)({
            ongoingProgram: allPatientPrograms?.ongoingProgram,
            previousProgram: (0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).head(allPatientPrograms?.endedPrograms),
            nextProgram: (0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).head(allPatientPrograms?.scheduledPrograms)
        });
        return {
            shouldDisplayProgramEndingSoonAlert: globalProgramStatus.type === (0, $5SzTW.GlobalProgramStatusType).EndingSoonProgramWithNoNext,
            shouldDisplayProgramEndingNoOngoingAlert: globalProgramStatus.type === (0, $5SzTW.GlobalProgramStatusType).EndedLastProgram
        };
    }, [
        allPatientPrograms
    ]);
    return {
        loading: loading,
        allPatientPrograms: allPatientPrograms,
        error: error,
        shouldDisplayProgramEndingSoonAlert: shouldDisplayProgramEndingSoonAlert,
        shouldDisplayProgramEndingNoOngoingAlert: shouldDisplayProgramEndingNoOngoingAlert,
        refreshAllPrograms: refreshAllPrograms
    };
}

});

parcelRegister("ebUJr", function(module, exports) {

$parcel$export(module.exports, "Calendar", () => $a54e198ef3baabb4$export$e1aef45b828286de);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $9AWgp = parcelRequire("9AWgp");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $jN2y8 = parcelRequire("jN2y8");

var $jhJol = parcelRequire("jhJol");

var $6mIkN = parcelRequire("6mIkN");

var $gbrlA = parcelRequire("gbrlA");

var $5jNNK = parcelRequire("5jNNK");

var $6ccvc = parcelRequire("6ccvc");

var $k7ffa = parcelRequire("k7ffa");

var $9rbaG = parcelRequire("9rbaG");

var $cfkGk = parcelRequire("cfkGk");

var $lbdsH = parcelRequire("lbdsH");

var $6b4aU = parcelRequire("6b4aU");
"use client";
function $a54e198ef3baabb4$var$_extends() {
    $a54e198ef3baabb4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a54e198ef3baabb4$var$_extends.apply(this, arguments);
}
function $a54e198ef3baabb4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a54e198ef3baabb4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a54e198ef3baabb4$var$_typeof(o);
}
function $a54e198ef3baabb4$var$_toPrimitive(input, hint) {
    if ($a54e198ef3baabb4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a54e198ef3baabb4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $a54e198ef3baabb4$var$_toPropertyKey(arg) {
    var key = $a54e198ef3baabb4$var$_toPrimitive(arg, "string");
    return $a54e198ef3baabb4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a54e198ef3baabb4$var$_defineProperty(obj, key, value) {
    key = $a54e198ef3baabb4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a54e198ef3baabb4$var$_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a54e198ef3baabb4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a54e198ef3baabb4$var$_arrayLikeToArray$1(arr);
}
function $a54e198ef3baabb4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a54e198ef3baabb4$var$_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a54e198ef3baabb4$var$_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a54e198ef3baabb4$var$_arrayLikeToArray$1(o, minLen);
}
function $a54e198ef3baabb4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a54e198ef3baabb4$var$_toConsumableArray(arr) {
    return $a54e198ef3baabb4$var$_arrayWithoutHoles(arr) || $a54e198ef3baabb4$var$_iterableToArray(arr) || $a54e198ef3baabb4$var$_unsupportedIterableToArray$1(arr) || $a54e198ef3baabb4$var$_nonIterableSpread();
}
function $a54e198ef3baabb4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a54e198ef3baabb4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $a54e198ef3baabb4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a54e198ef3baabb4$var$_slicedToArray(arr, i) {
    return $a54e198ef3baabb4$var$_arrayWithHoles(arr) || $a54e198ef3baabb4$var$_iterableToArrayLimit(arr, i) || $a54e198ef3baabb4$var$_unsupportedIterableToArray$1(arr, i) || $a54e198ef3baabb4$var$_nonIterableRest();
}
var $a54e198ef3baabb4$var$styles = "\n@layer primereact {\n    .p-calendar {\n        position: relative;\n        display: inline-flex;\n        max-width: 100%;\n    }\n\n    .p-calendar .p-inputtext {\n        flex: 1 1 auto;\n        width: 1%;\n    }\n\n    .p-calendar-w-btn-right .p-inputtext {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n\n    .p-calendar-w-btn-right .p-datepicker-trigger {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .p-calendar-w-btn-left .p-inputtext {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .p-calendar-w-btn-left .p-datepicker-trigger {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n\n    /* Fluid */\n    .p-fluid .p-calendar {\n        display: flex;\n    }\n\n    .p-fluid .p-calendar .p-inputtext {\n        width: 1%;\n    }\n\n    /* Datepicker */\n    .p-calendar .p-datepicker {\n        min-width: 100%;\n    }\n\n    .p-datepicker {\n        width: auto;\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n\n    .p-datepicker-inline {\n        display: inline-block;\n        position: static;\n        overflow-x: auto;\n    }\n\n    /* Header */\n    .p-datepicker-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .p-datepicker-header .p-datepicker-title {\n        margin: 0 auto;\n    }\n\n    .p-datepicker-prev,\n    .p-datepicker-next {\n        cursor: pointer;\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        overflow: hidden;\n        position: relative;\n    }\n\n    /* Multiple Month DatePicker */\n    .p-datepicker-multiple-month .p-datepicker-group-container {\n        display: flex;\n    }\n\n    .p-datepicker-multiple-month .p-datepicker-group-container .p-datepicker-group {\n        flex: 1 1 auto;\n    }\n\n    /* Multiple Month DatePicker */\n    .p-datepicker-multiple-month .p-datepicker-group-container {\n        display: flex;\n    }\n\n    /* DatePicker Table */\n    .p-datepicker table {\n        width: 100%;\n        border-collapse: collapse;\n    }\n\n    .p-datepicker td > span {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        margin: 0 auto;\n        overflow: hidden;\n        position: relative;\n    }\n\n    /* Month Picker */\n    .p-monthpicker-month {\n        width: 33.3%;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        overflow: hidden;\n        position: relative;\n    }\n\n    /*  Button Bar */\n    .p-datepicker-buttonbar {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    /* Time Picker */\n    .p-timepicker {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .p-timepicker button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .p-timepicker > div {\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n    }\n\n    /* Touch UI */\n    .p-datepicker-touch-ui,\n    .p-calendar .p-datepicker-touch-ui {\n        position: fixed;\n        top: 50%;\n        left: 50%;\n        min-width: 80vw;\n        transform: translate(-50%, -50%);\n    }\n\n    /* Year Picker */\n    .p-yearpicker-year {\n        width: 50%;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        overflow: hidden;\n        position: relative;\n    }\n}\n";
var $a54e198ef3baabb4$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, focusedState = _ref.focusedState, isFilled = _ref.isFilled, panelVisible = _ref.panelVisible;
        return (0, $cfkGk.classNames)("p-calendar p-component p-inputwrapper", $a54e198ef3baabb4$var$_defineProperty($a54e198ef3baabb4$var$_defineProperty($a54e198ef3baabb4$var$_defineProperty($a54e198ef3baabb4$var$_defineProperty($a54e198ef3baabb4$var$_defineProperty($a54e198ef3baabb4$var$_defineProperty($a54e198ef3baabb4$var$_defineProperty({}, "p-calendar-w-btn p-calendar-w-btn-".concat(props.iconPos), props.showIcon), "p-calendar-disabled", props.disabled), "p-invalid", props.invalid), "p-calendar-timeonly", props.timeOnly), "p-inputwrapper-filled", props.value || isFilled), "p-inputwrapper-focus", focusedState), "p-focus", focusedState || panelVisible));
    },
    input: function input(_ref2) {
        var props = _ref2.props, context = _ref2.context;
        return (0, $cfkGk.classNames)("p-inputtext p-component", {
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled"
        });
    },
    dropdownButton: "p-datepicker-trigger",
    buttonbar: "p-datepicker-buttonbar",
    todayButton: "p-button-text",
    clearButton: "p-button-text",
    footer: "p-datepicker-footer",
    yearPicker: "p-yearpicker",
    year: function year(_ref3) {
        var isYearSelected = _ref3.isYearSelected, y = _ref3.y, isMonthYearDisabled = _ref3.isMonthYearDisabled;
        return (0, $cfkGk.classNames)("p-yearpicker-year", {
            "p-highlight": isYearSelected(y),
            "p-disabled": isMonthYearDisabled(-1, y)
        });
    },
    monthPicker: "p-monthpicker",
    month: function month(_ref4) {
        var isMonthSelected = _ref4.isMonthSelected, isMonthYearDisabled = _ref4.isMonthYearDisabled, i = _ref4.i, currentYear = _ref4.currentYear;
        return (0, $cfkGk.classNames)("p-monthpicker-month", {
            "p-highlight": isMonthSelected(i),
            "p-disabled": isMonthYearDisabled(i, currentYear)
        });
    },
    hourPicker: "p-hour-picker",
    secondPicker: "p-second-picker",
    minutePicker: "p-minute-picker",
    millisecondPicker: "p-millisecond-picker",
    ampmPicker: "p-ampm-picker",
    separatorContainer: "p-separator",
    dayLabel: function dayLabel(_ref5) {
        var className = _ref5.className;
        return className;
    },
    day: function day(_ref6) {
        var date = _ref6.date;
        return (0, $cfkGk.classNames)({
            "p-datepicker-other-month": date.otherMonth,
            "p-datepicker-today": date.today
        });
    },
    panel: function panel(_ref7) {
        var panelClassName = _ref7.panelClassName;
        return panelClassName;
    },
    previousIcon: "p-datepicker-prev-icon",
    previousButton: "p-datepicker-prev",
    nextIcon: "p-datepicker-next-icon",
    nextButton: "p-datepicker-next",
    incrementButton: "p-link",
    decrementButton: "p-link",
    title: "p-datepicker-title",
    timePicker: "p-timepicker",
    monthTitle: "p-datepicker-month p-link",
    yearTitle: "p-datepicker-year p-link",
    decadeTitle: "p-datepicker-decade",
    header: "p-datepicker-header",
    groupContainer: "p-datepicker-group-container",
    group: "p-datepicker-group",
    select: function select(_ref8) {
        var props = _ref8.props;
        return props.monthNavigator && props.view !== "month" ? "p-datepicker-month" : props.yearNavigator ? "p-datepicker-year" : undefined;
    },
    weekHeader: "p-datepicker-weekheader p-disabled",
    weekNumber: "p-datepicker-weeknumber",
    weekLabelContainer: "p-disabled",
    container: "p-datepicker-calendar-container",
    table: "p-datepicker-calendar",
    transition: "p-connected-overlay"
};
var $a54e198ef3baabb4$var$CalendarBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Calendar",
        appendTo: null,
        ariaLabelledBy: null,
        ariaLabel: null,
        autoZIndex: true,
        autoFocus: false,
        baseZIndex: 0,
        className: null,
        clearButtonClassName: "p-button-secondary",
        dateFormat: null,
        dateTemplate: null,
        decadeTemplate: null,
        decrementIcon: null,
        disabled: false,
        disabledDates: null,
        disabledDays: null,
        enabledDates: null,
        footerTemplate: null,
        formatDateTime: null,
        headerTemplate: null,
        hideOnDateTimeSelect: false,
        hideOnRangeSelection: false,
        hourFormat: "24",
        icon: null,
        iconPos: "right",
        id: null,
        incrementIcon: null,
        inline: false,
        inputClassName: null,
        inputId: null,
        inputMode: "none",
        inputRef: null,
        inputStyle: null,
        variant: null,
        invalid: false,
        keepInvalid: false,
        locale: null,
        mask: null,
        maskSlotChar: "_",
        maxDate: null,
        maxDateCount: null,
        minDate: null,
        monthNavigator: false,
        monthNavigatorTemplate: null,
        name: null,
        nextIcon: null,
        numberOfMonths: 1,
        onBlur: null,
        onChange: null,
        onClearButtonClick: null,
        onFocus: null,
        onHide: null,
        onInput: null,
        onMonthChange: null,
        onSelect: null,
        onShow: null,
        onTodayButtonClick: null,
        onViewDateChange: null,
        onVisibleChange: null,
        panelClassName: null,
        panelStyle: null,
        parseDateTime: null,
        placeholder: null,
        prevIcon: null,
        readOnlyInput: false,
        required: false,
        selectOtherMonths: false,
        selectionMode: "single",
        shortYearCutoff: "+10",
        showButtonBar: false,
        showIcon: false,
        showMillisec: false,
        showMinMaxRange: false,
        showOnFocus: true,
        showOtherMonths: true,
        showSeconds: false,
        showTime: false,
        showWeek: false,
        stepHour: 1,
        stepMillisec: 1,
        stepMinute: 1,
        stepSecond: 1,
        style: null,
        tabIndex: null,
        timeOnly: false,
        todayButtonClassName: "p-button-secondary",
        tooltip: null,
        tooltipOptions: null,
        touchUI: false,
        transitionOptions: null,
        value: null,
        view: "date",
        viewDate: null,
        visible: false,
        yearNavigator: false,
        yearNavigatorTemplate: null,
        yearRange: null,
        children: undefined
    },
    css: {
        classes: $a54e198ef3baabb4$var$classes,
        styles: $a54e198ef3baabb4$var$styles
    }
});
var $a54e198ef3baabb4$var$CalendarPanel = /*#__PURE__*/ $81g6h.forwardRef(function(props, ref) {
    var cx = props.cx;
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var createElement = function createElement() {
        var panelProps = mergeProps({
            className: cx("panel", {
                panelClassName: props.className
            }),
            style: props.style,
            role: props.inline ? null : "dialog",
            id: props.id,
            "aria-label": (0, $8Zwsm.localeOption)("chooseDate", props.locale),
            "aria-modal": props.inline ? null : "true",
            onClick: props.onClick,
            onMouseUp: props.onMouseUp
        }, props.ptm("panel", {
            hostName: props.hostName
        }));
        var transitionProps = mergeProps({
            classNames: cx("transition"),
            "in": props["in"],
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: props.onEnter,
            onEntered: props.onEntered,
            onExit: props.onExit,
            onExited: props.onExited
        }, props.ptm("transition", {
            hostName: props.hostName
        }));
        return /*#__PURE__*/ $81g6h.createElement((0, $lbdsH.CSSTransition), $a54e198ef3baabb4$var$_extends({
            nodeRef: ref
        }, transitionProps), /*#__PURE__*/ $81g6h.createElement("div", $a54e198ef3baabb4$var$_extends({
            ref: ref
        }, panelProps), props.children));
    };
    var element = createElement();
    return props.inline ? element : /*#__PURE__*/ $81g6h.createElement((0, $6b4aU.Portal), {
        element: element,
        appendTo: props.appendTo
    });
});
$a54e198ef3baabb4$var$CalendarPanel.displayName = "CalendarPanel";
function $a54e198ef3baabb4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a54e198ef3baabb4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a54e198ef3baabb4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a54e198ef3baabb4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a54e198ef3baabb4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a54e198ef3baabb4$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $a54e198ef3baabb4$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $a54e198ef3baabb4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a54e198ef3baabb4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a54e198ef3baabb4$var$_arrayLikeToArray(o, minLen);
}
function $a54e198ef3baabb4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $a54e198ef3baabb4$export$e1aef45b828286de = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $a54e198ef3baabb4$var$CalendarBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState(false), _React$useState2 = $a54e198ef3baabb4$var$_slicedToArray(_React$useState, 2), focusedState = _React$useState2[0], setFocusedState = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(false), _React$useState4 = $a54e198ef3baabb4$var$_slicedToArray(_React$useState3, 2), overlayVisibleState = _React$useState4[0], setOverlayVisibleState = _React$useState4[1];
    var _React$useState5 = $81g6h.useState(null), _React$useState6 = $a54e198ef3baabb4$var$_slicedToArray(_React$useState5, 2), viewDateState = _React$useState6[0], setViewDateState = _React$useState6[1];
    var _React$useState7 = $81g6h.useState(props.id), _React$useState8 = $a54e198ef3baabb4$var$_slicedToArray(_React$useState7, 2), idState = _React$useState8[0], setIdState = _React$useState8[1];
    var isTypingRef = $81g6h.useRef(false);
    var metaData = {
        props: props,
        state: {
            focused: focusedState,
            overlayVisible: overlayVisibleState,
            viewDate: viewDateState
        }
    };
    var _CalendarBase$setMeta = $a54e198ef3baabb4$var$CalendarBase.setMetaData(metaData), ptm = _CalendarBase$setMeta.ptm, cx = _CalendarBase$setMeta.cx, isUnstyled = _CalendarBase$setMeta.isUnstyled;
    (0, $4gQLd.useHandleStyle)($a54e198ef3baabb4$var$CalendarBase.css.styles, isUnstyled, {
        name: "calendar"
    });
    var elementRef = $81g6h.useRef(null);
    var overlayRef = $81g6h.useRef(null);
    var inputRef = $81g6h.useRef(props.inputRef);
    var navigation = $81g6h.useRef(null);
    var ignoreFocusFunctionality = $81g6h.useRef(false);
    var timePickerTimer = $81g6h.useRef(null);
    var viewStateChanged = $81g6h.useRef(false);
    var touchUIMask = $81g6h.useRef(null);
    var overlayEventListener = $81g6h.useRef(null);
    var touchUIMaskClickListener = $81g6h.useRef(null);
    var isOverlayClicked = $81g6h.useRef(false);
    var previousButton = $81g6h.useRef(false);
    var nextButton = $81g6h.useRef(false);
    var viewChangedWithKeyDown = $81g6h.useRef(false);
    var onChangeRef = $81g6h.useRef(null);
    var isClearClicked = $81g6h.useRef(false);
    var _React$useState9 = $81g6h.useState("date"), _React$useState10 = $a54e198ef3baabb4$var$_slicedToArray(_React$useState9, 2), currentView = _React$useState10[0], setCurrentView = _React$useState10[1];
    var _React$useState11 = $81g6h.useState(null), _React$useState12 = $a54e198ef3baabb4$var$_slicedToArray(_React$useState11, 2), currentMonth = _React$useState12[0], setCurrentMonth = _React$useState12[1];
    var _React$useState13 = $81g6h.useState(null), _React$useState14 = $a54e198ef3baabb4$var$_slicedToArray(_React$useState13, 2), currentYear = _React$useState14[0], setCurrentYear = _React$useState14[1];
    var _React$useState15 = $81g6h.useState([]), _React$useState16 = $a54e198ef3baabb4$var$_slicedToArray(_React$useState15, 2), yearOptions = _React$useState16[0], setYearOptions = _React$useState16[1];
    var previousValue = (0, $l2NC0.usePrevious)(props.value);
    var visible = props.inline || (props.onVisibleChange ? props.visible : overlayVisibleState);
    var attributeSelector = (0, $cfkGk.UniqueComponentId)();
    var panelId = idState + "_panel";
    var _useOverlayListener = (0, $l2NC0.useOverlayListener)({
        target: elementRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var type = _ref.type, valid = _ref.valid;
            if (valid) type === "outside" ? !isOverlayClicked.current && !isNavIconClicked(event.target) && hide("outside") : hide();
            isOverlayClicked.current = false;
        },
        when: !(props.touchUI || props.inline) && visible,
        type: "mousedown"
    }), _useOverlayListener2 = $a54e198ef3baabb4$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var getDateFormat = function getDateFormat() {
        return props.dateFormat || (0, $8Zwsm.localeOption)("dateFormat", props.locale);
    };
    var onInputFocus = function onInputFocus(event) {
        if (ignoreFocusFunctionality.current) {
            setFocusedState(true);
            ignoreFocusFunctionality.current = false;
        } else {
            if (props.showOnFocus && !visible) show();
            setFocusedState(true);
            props.onFocus && props.onFocus(event);
        }
    };
    var onInputBlur = function onInputBlur(event) {
        updateInputfield(props.value);
        props.onBlur && props.onBlur(event);
        setFocusedState(false);
    };
    var onInputKeyDown = function onInputKeyDown(event) {
        switch(event.code){
            case "ArrowDown":
                if (!overlayVisibleState) show();
                else {
                    focusToFirstCell();
                    event.preventDefault();
                }
                break;
            case "Escape":
                hide();
                props.touchUI && disableModality();
                break;
            case "Tab":
                if (overlayRef && overlayRef.current) {
                    (0, $cfkGk.DomHandler).getFocusableElements(overlayRef.current).forEach(function(el) {
                        return el.tabIndex = "-1";
                    });
                    hide();
                    props.touchUI && disableModality();
                }
                break;
        }
    };
    var onUserInput = function onUserInput(event) {
        updateValueOnInput(event, event.target.value);
        props.onInput && props.onInput(event);
    };
    var updateValueOnInput = function updateValueOnInput(event, rawValue, invalidCallback) {
        try {
            var value = parseValueFromString(props.timeOnly ? rawValue.replace("_", "") : rawValue);
            if (isValidSelection(value)) {
                isTypingRef.current = true;
                updateModel(event, value);
                updateViewDate(event, value.length ? value[0] : value);
            }
        } catch (err) {
            //invalid date
            if (invalidCallback) invalidCallback();
            else {
                var _value = props.keepInvalid ? rawValue : null;
                updateModel(event, _value);
            }
        }
    };
    var reFocusInputField = function reFocusInputField() {
        if (!props.inline && inputRef.current) {
            ignoreFocusFunctionality.current = true;
            (0, $cfkGk.DomHandler).focus(inputRef.current);
        }
    };
    var isValidSelection = function isValidSelection(value) {
        var isValid = true;
        if (isSingleSelection()) {
            if (!(isSelectable(value.getDate(), value.getMonth(), value.getFullYear(), false) && isSelectableTime(value))) isValid = false;
        } else if (value.every(function(v) {
            return isSelectable(v.getDate(), v.getMonth(), v.getFullYear(), false) && isSelectableTime(v);
        })) {
            if (isRangeSelection()) isValid = value.length > 1 && value[1] > value[0] ? true : false;
        }
        return isValid;
    };
    var onButtonClick = function onButtonClick() {
        visible ? hide() : show();
    };
    var onPrevButtonClick = function onPrevButtonClick(event) {
        navigation.current = {
            backward: true,
            button: true
        };
        navBackward(event);
    };
    var onNextButtonClick = function onNextButtonClick(event) {
        navigation.current = {
            backward: false,
            button: true
        };
        navForward(event);
    };
    var onContainerButtonKeydown = function onContainerButtonKeydown(event) {
        switch(event.code){
            case "Tab":
                !props.inline && trapFocus(event);
                break;
            case "Escape":
                hide(null, reFocusInputField);
                event.preventDefault();
                break;
        }
    };
    var onPickerKeyDown = function onPickerKeyDown(event, type, direction) {
        if (event.key === "Enter" || event.key === "Space") {
            onTimePickerElementMouseDown(event, type, direction);
            event.preventDefault();
            return;
        }
        onContainerButtonKeydown(event);
    };
    var onPickerKeyUp = function onPickerKeyUp(event) {
        if (event.key === "Enter" || event.key === "Space") {
            onTimePickerElementMouseUp();
            event.preventDefault();
            return;
        }
    };
    var trapFocus = function trapFocus(event) {
        event === null || event === void 0 || event.preventDefault();
        var focusableElements = (0, $cfkGk.DomHandler).getFocusableElements(overlayRef.current);
        if (focusableElements && focusableElements.length > 0) {
            if (!document.activeElement) focusableElements[0].focus();
            else {
                var focusedIndex = focusableElements.indexOf(document.activeElement);
                if (event !== null && event !== void 0 && event.shiftKey) {
                    if (focusedIndex === -1 || focusedIndex === 0) focusableElements[focusableElements.length - 1].focus();
                    else focusableElements[focusedIndex - 1].focus();
                } else if (focusedIndex === -1 || focusedIndex === focusableElements.length - 1) focusableElements[0].focus();
                else focusableElements[focusedIndex + 1].focus();
            }
        }
    };
    var updateFocus = function updateFocus() {
        if (navigation.current) {
            if (navigation.current.button) {
                initFocusableCell();
                if (navigation.current.backward) previousButton.current.focus();
                else nextButton.current.focus();
            } else {
                var cell;
                if (navigation.current.backward) {
                    var cells = (0, $cfkGk.DomHandler).find(overlayRef.current, 'table td span:not([data-p-disabled="true"])');
                    cell = cells[cells.length - 1];
                } else cell = (0, $cfkGk.DomHandler).findSingle(overlayRef.current, 'table td span:not([data-p-disabled="true"])');
                if (cell) {
                    cell.tabIndex = "0";
                    cell.focus();
                }
            }
            navigation.current = null;
        } else initFocusableCell();
    };
    var initFocusableCell = function initFocusableCell() {
        var cell;
        if (currentView === "month") {
            var cells = (0, $cfkGk.DomHandler).find(overlayRef.current, '[data-pc-section="monthpicker"] [data-pc-section="month"]');
            var selectedCell = (0, $cfkGk.DomHandler).findSingle(overlayRef.current, '[data-pc-section="monthpicker"] [data-pc-section="month"][data-p-highlight="true"]');
            cells.forEach(function(cell) {
                return cell.tabIndex = -1;
            });
            cell = selectedCell || cells[0];
        } else {
            cell = (0, $cfkGk.DomHandler).findSingle(overlayRef.current, 'span[data-p-highlight="true"]');
            if (!cell) {
                var todayCell = (0, $cfkGk.DomHandler).findSingle(overlayRef.current, "td.p-datepicker-today span:not(.p-disabled)");
                cell = todayCell || (0, $cfkGk.DomHandler).findSingle(overlayRef.current, 'table td span:not([data-p-disabled="true"])');
            }
        }
        if (cell) cell.tabIndex = "0";
    };
    var focusToFirstCell = function focusToFirstCell() {
        if (currentView) {
            var cell;
            if (currentView === "date") {
                cell = (0, $cfkGk.DomHandler).findSingle(overlayRef.current, 'span[data-p-highlight="true"]');
                if (!cell) {
                    var todayCell = (0, $cfkGk.DomHandler).findSingle(overlayRef.current, "td.p-datepicker-today span:not(.p-disabled)");
                    cell = todayCell || (0, $cfkGk.DomHandler).findSingle(overlayRef.current, 'table td span:not([data-p-disabled="true"])');
                }
            } else if (currentView === "month" || currentView === "year") {
                cell = (0, $cfkGk.DomHandler).findSingle(overlayRef.current, 'span[data-p-highlight="true"]');
                if (!cell) cell = (0, $cfkGk.DomHandler).findSingle(overlayRef.current, '[data-pc-section="'.concat(currentView, 'picker"] [data-pc-section="').concat(currentView, '"]:not([data-p-disabled="true"])'));
            }
            if (cell) {
                cell.tabIndex = "0";
                cell && cell.focus();
            }
        }
    };
    var navBackward = function navBackward(event) {
        if (props.disabled) {
            event.preventDefault();
            return;
        }
        var newViewDate = cloneDate(getViewDate());
        newViewDate.setDate(1);
        if (currentView === "date") {
            if (newViewDate.getMonth() === 0) {
                var newYear = decrementYear();
                newViewDate.setMonth(11);
                newViewDate.setFullYear(newYear);
                props.onMonthChange && props.onMonthChange({
                    month: 11,
                    year: newYear
                });
                setCurrentMonth(11);
            } else {
                newViewDate.setMonth(newViewDate.getMonth() - 1);
                props.onMonthChange && props.onMonthChange({
                    month: currentMonth - 1,
                    year: currentYear
                });
                setCurrentMonth(function(prevState) {
                    return prevState - 1;
                });
            }
        } else if (currentView === "month") {
            var _newYear = newViewDate.getFullYear() - 1;
            if (props.yearNavigator) {
                var minYear = parseInt(props.yearRange.split(":")[0], 10);
                if (_newYear < minYear) _newYear = minYear;
            }
            newViewDate.setFullYear(_newYear);
        }
        if (currentView === "month") newViewDate.setFullYear(decrementYear());
        else if (currentView === "year") newViewDate.setFullYear(decrementDecade());
        updateViewDate(event, newViewDate);
        event.preventDefault();
    };
    var navForward = function navForward(event) {
        if (props.disabled) {
            event.preventDefault();
            return;
        }
        var newViewDate = cloneDate(getViewDate());
        newViewDate.setDate(1);
        if (currentView === "date") {
            if (newViewDate.getMonth() === 11) {
                var newYear = incrementYear();
                newViewDate.setMonth(0);
                newViewDate.setFullYear(newYear);
                props.onMonthChange && props.onMonthChange({
                    month: 0,
                    year: newYear
                });
                setCurrentMonth(0);
            } else {
                newViewDate.setMonth(newViewDate.getMonth() + 1);
                props.onMonthChange && props.onMonthChange({
                    month: currentMonth + 1,
                    year: currentYear
                });
                setCurrentMonth(function(prevState) {
                    return prevState + 1;
                });
            }
        } else if (currentView === "month") {
            var _newYear2 = newViewDate.getFullYear() + 1;
            if (props.yearNavigator) {
                var maxYear = parseInt(props.yearRange.split(":")[1], 10);
                if (_newYear2 > maxYear) _newYear2 = maxYear;
            }
            newViewDate.setFullYear(_newYear2);
        }
        if (currentView === "month") newViewDate.setFullYear(incrementYear());
        else if (currentView === "year") newViewDate.setFullYear(incrementDecade());
        updateViewDate(event, newViewDate);
        event.preventDefault();
    };
    var populateYearOptions = function populateYearOptions(start, end) {
        var _yearOptions = [];
        for(var i = start; i <= end; i++)yearOptions.push(i);
        setYearOptions(_yearOptions);
    };
    var decrementYear = function decrementYear() {
        var _currentYear = currentYear - 1;
        setCurrentYear(_currentYear);
        if (props.yearNavigator && _currentYear < yearOptions[0]) {
            var difference = yearOptions[yearOptions.length - 1] - yearOptions[0];
            populateYearOptions(yearOptions[0] - difference, yearOptions[yearOptions.length - 1] - difference);
        }
        return _currentYear;
    };
    var incrementYear = function incrementYear() {
        var _currentYear = currentYear + 1;
        setCurrentYear(_currentYear);
        if (props.yearNavigator && _currentYear.current > yearOptions[yearOptions.length - 1]) {
            var difference = yearOptions[yearOptions.length - 1] - yearOptions[0];
            populateYearOptions(yearOptions[0] + difference, yearOptions[yearOptions.length - 1] + difference);
        }
        return _currentYear;
    };
    var onMonthDropdownChange = function onMonthDropdownChange(event, value) {
        var currentViewDate = getViewDate();
        var newViewDate = cloneDate(currentViewDate);
        newViewDate.setDate(1);
        newViewDate.setMonth(parseInt(value, 10));
        updateViewDate(event, newViewDate);
    };
    var onYearDropdownChange = function onYearDropdownChange(event, value) {
        var currentViewDate = getViewDate();
        var newViewDate = cloneDate(currentViewDate);
        newViewDate.setFullYear(parseInt(value, 10));
        updateViewDate(event, newViewDate);
    };
    var onTodayButtonClick = function onTodayButtonClick(event) {
        var today = new Date();
        var dateMeta = {
            day: today.getDate(),
            month: today.getMonth(),
            year: today.getFullYear(),
            today: true,
            selectable: true
        };
        var timeMeta = {
            hours: today.getHours(),
            minutes: today.getMinutes(),
            seconds: today.getSeconds(),
            milliseconds: today.getMilliseconds()
        };
        updateViewDate(event, today);
        onDateSelect(event, dateMeta, timeMeta);
        props.onTodayButtonClick && props.onTodayButtonClick(event);
    };
    var onClearButtonClick = function onClearButtonClick(event) {
        isClearClicked.current = true;
        updateModel(event, null);
        updateInputfield(null);
        hide();
        props.onClearButtonClick && props.onClearButtonClick(event);
    };
    var onPanelClick = function onPanelClick(event) {
        if (!props.inline) (0, $k7ffa.OverlayService).emit("overlay-click", {
            originalEvent: event,
            target: elementRef.current
        });
    };
    var onPanelMouseUp = function onPanelMouseUp(event) {
        onPanelClick(event);
    };
    var onTimePickerElementMouseDown = function onTimePickerElementMouseDown(event, type, direction) {
        if (!props.disabled) {
            repeat(event, null, type, direction);
            event.preventDefault();
        }
    };
    var onTimePickerElementMouseUp = function onTimePickerElementMouseUp() {
        if (!props.disabled) clearTimePickerTimer();
    };
    var onTimePickerElementMouseLeave = function onTimePickerElementMouseLeave() {
        if (!props.disabled) clearTimePickerTimer();
    };
    var repeat = function repeat(event, interval, type, direction) {
        clearTimePickerTimer();
        timePickerTimer.current = setTimeout(function() {
            repeat(event, 100, type, direction);
        }, interval || 500);
        switch(type){
            case 0:
                if (direction === 1) incrementHour(event);
                else decrementHour(event);
                break;
            case 1:
                if (direction === 1) incrementMinute(event);
                else decrementMinute(event);
                break;
            case 2:
                if (direction === 1) incrementSecond(event);
                else decrementSecond(event);
                break;
            case 3:
                if (direction === 1) incrementMilliSecond(event);
                else decrementMilliSecond(event);
                break;
        }
    };
    var clearTimePickerTimer = function clearTimePickerTimer() {
        if (timePickerTimer.current) clearTimeout(timePickerTimer.current);
    };
    var roundMinutesToStep = function roundMinutesToStep(minutes) {
        if (props.stepMinute) return Math.round(minutes / props.stepMinute) * props.stepMinute;
        return minutes;
    };
    var incrementHour = function incrementHour(event) {
        var currentTime = getCurrentDateTime();
        var currentHour = currentTime.getHours();
        var newHour = currentHour + props.stepHour;
        newHour = newHour >= 24 ? newHour - 24 : newHour;
        if (validateHour(newHour, currentTime)) {
            if (props.maxDate && props.maxDate.toDateString() === currentTime.toDateString() && props.maxDate.getHours() === newHour) {
                if (props.maxDate.getMinutes() < currentTime.getMinutes()) {
                    if (props.maxDate.getSeconds() < currentTime.getSeconds()) {
                        if (props.maxDate.getMilliseconds() < currentTime.getMilliseconds()) updateTime(event, newHour, props.maxDate.getMinutes(), props.maxDate.getSeconds(), props.maxDate.getMilliseconds());
                        else updateTime(event, newHour, props.maxDate.getMinutes(), props.maxDate.getSeconds(), currentTime.getMilliseconds());
                    } else updateTime(event, newHour, props.maxDate.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                } else if (props.maxDate.getMinutes() === currentTime.getMinutes()) {
                    if (props.maxDate.getSeconds() < currentTime.getSeconds()) {
                        if (props.maxDate.getMilliseconds() < currentTime.getMilliseconds()) updateTime(event, newHour, props.maxDate.getMinutes(), props.maxDate.getSeconds(), props.maxDate.getMilliseconds());
                        else updateTime(event, newHour, props.maxDate.getMinutes(), props.maxDate.getSeconds(), currentTime.getMilliseconds());
                    } else updateTime(event, newHour, props.maxDate.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                } else updateTime(event, newHour, roundMinutesToStep(currentTime.getMinutes()), currentTime.getSeconds(), currentTime.getMilliseconds());
            } else updateTime(event, newHour, roundMinutesToStep(currentTime.getMinutes()), currentTime.getSeconds(), currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var decrementHour = function decrementHour(event) {
        var currentTime = getCurrentDateTime();
        var currentHour = currentTime.getHours();
        var newHour = currentHour - props.stepHour;
        newHour = newHour < 0 ? newHour + 24 : newHour;
        if (validateHour(newHour, currentTime)) {
            if (props.minDate && props.minDate.toDateString() === currentTime.toDateString() && props.minDate.getHours() === newHour) {
                if (props.minDate.getMinutes() > currentTime.getMinutes()) {
                    if (props.minDate.getSeconds() > currentTime.getSeconds()) {
                        if (props.minDate.getMilliseconds() > currentTime.getMilliseconds()) updateTime(event, newHour, props.minDate.getMinutes(), props.minDate.getSeconds(), props.minDate.getMilliseconds());
                        else updateTime(event, newHour, props.minDate.getMinutes(), props.minDate.getSeconds(), currentTime.getMilliseconds());
                    } else updateTime(event, newHour, props.minDate.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                } else if (props.minDate.getMinutes() === currentTime.getMinutes()) {
                    if (props.minDate.getSeconds() > currentTime.getSeconds()) {
                        if (props.minDate.getMilliseconds() > currentTime.getMilliseconds()) updateTime(event, newHour, props.minDate.getMinutes(), props.minDate.getSeconds(), props.minDate.getMilliseconds());
                        else updateTime(event, newHour, props.minDate.getMinutes(), props.minDate.getSeconds(), currentTime.getMilliseconds());
                    } else updateTime(event, newHour, props.minDate.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
                } else updateTime(event, newHour, roundMinutesToStep(currentTime.getMinutes()), currentTime.getSeconds(), currentTime.getMilliseconds());
            } else updateTime(event, newHour, roundMinutesToStep(currentTime.getMinutes()), currentTime.getSeconds(), currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var doStepMinute = function doStepMinute(currentMinute, step) {
        if (props.stepMinute <= 1) return step ? currentMinute + step : currentMinute;
        if (!step) {
            step = props.stepMinute;
            if (currentMinute % step === 0) return currentMinute;
        }
        return Math.floor((currentMinute + step) / step) * step;
    };
    var incrementMinute = function incrementMinute(event) {
        var currentTime = getCurrentDateTime();
        var currentMinute = currentTime.getMinutes();
        var newMinute = doStepMinute(currentMinute, props.stepMinute);
        newMinute = newMinute > 59 ? newMinute - 60 : newMinute;
        if (validateMinute(newMinute, currentTime)) {
            if (props.maxDate && props.maxDate.toDateString() === currentTime.toDateString() && props.maxDate.getMinutes() === newMinute) {
                if (props.maxDate.getSeconds() < currentTime.getSeconds()) {
                    if (props.maxDate.getMilliseconds() < currentTime.getMilliseconds()) updateTime(event, currentTime.getHours(), newMinute, props.maxDate.getSeconds(), props.maxDate.getMilliseconds());
                    else updateTime(event, currentTime.getHours(), newMinute, props.maxDate.getSeconds(), currentTime.getMilliseconds());
                } else updateTime(event, currentTime.getHours(), newMinute, currentTime.getSeconds(), currentTime.getMilliseconds());
            } else updateTime(event, currentTime.getHours(), newMinute, currentTime.getSeconds(), currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var decrementMinute = function decrementMinute(event) {
        var currentTime = getCurrentDateTime();
        var currentMinute = currentTime.getMinutes();
        var newMinute = doStepMinute(currentMinute, -props.stepMinute);
        newMinute = newMinute < 0 ? newMinute + 60 : newMinute;
        if (validateMinute(newMinute, currentTime)) {
            if (props.minDate && props.minDate.toDateString() === currentTime.toDateString() && props.minDate.getMinutes() === newMinute) {
                if (props.minDate.getSeconds() > currentTime.getSeconds()) {
                    if (props.minDate.getMilliseconds() > currentTime.getMilliseconds()) updateTime(event, currentTime.getHours(), newMinute, props.minDate.getSeconds(), props.minDate.getMilliseconds());
                    else updateTime(event, currentTime.getHours(), newMinute, props.minDate.getSeconds(), currentTime.getMilliseconds());
                } else updateTime(event, currentTime.getHours(), newMinute, currentTime.getSeconds(), currentTime.getMilliseconds());
            } else updateTime(event, currentTime.getHours(), newMinute, currentTime.getSeconds(), currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var incrementSecond = function incrementSecond(event) {
        var currentTime = getCurrentDateTime();
        var currentSecond = currentTime.getSeconds();
        var newSecond = currentSecond + props.stepSecond;
        newSecond = newSecond > 59 ? newSecond - 60 : newSecond;
        if (validateSecond(newSecond, currentTime)) {
            if (props.maxDate && props.maxDate.toDateString() === currentTime.toDateString() && props.maxDate.getSeconds() === newSecond) {
                if (props.maxDate.getMilliseconds() < currentTime.getMilliseconds()) updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, props.maxDate.getMilliseconds());
                else updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, currentTime.getMilliseconds());
            } else updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var decrementSecond = function decrementSecond(event) {
        var currentTime = getCurrentDateTime();
        var currentSecond = currentTime.getSeconds();
        var newSecond = currentSecond - props.stepSecond;
        newSecond = newSecond < 0 ? newSecond + 60 : newSecond;
        if (validateSecond(newSecond, currentTime)) {
            if (props.minDate && props.minDate.toDateString() === currentTime.toDateString() && props.minDate.getSeconds() === newSecond) {
                if (props.minDate.getMilliseconds() > currentTime.getMilliseconds()) updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, props.minDate.getMilliseconds());
                else updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, currentTime.getMilliseconds());
            } else updateTime(event, currentTime.getHours(), currentTime.getMinutes(), newSecond, currentTime.getMilliseconds());
        }
        event.preventDefault();
    };
    var incrementMilliSecond = function incrementMilliSecond(event) {
        var currentTime = getCurrentDateTime();
        var currentMillisecond = currentTime.getMilliseconds();
        var newMillisecond = currentMillisecond + props.stepMillisec;
        newMillisecond = newMillisecond > 999 ? newMillisecond - 1000 : newMillisecond;
        if (validateMillisecond(newMillisecond, currentTime)) updateTime(event, currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), newMillisecond);
        event.preventDefault();
    };
    var decrementMilliSecond = function decrementMilliSecond(event) {
        var currentTime = getCurrentDateTime();
        var currentMillisecond = currentTime.getMilliseconds();
        var newMillisecond = currentMillisecond - props.stepMillisec;
        newMillisecond = newMillisecond < 0 ? newMillisecond + 999 : newMillisecond;
        if (validateMillisecond(newMillisecond, currentTime)) updateTime(event, currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), newMillisecond);
        event.preventDefault();
    };
    var toggleAmPm = function toggleAmPm(event) {
        var currentTime = getCurrentDateTime();
        var currentHour = currentTime.getHours();
        var newHour = currentHour >= 12 ? currentHour - 12 : currentHour + 12;
        if (validateHour(convertTo24Hour(newHour, currentHour > 11), currentTime)) updateTime(event, newHour, currentTime.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());
        event.preventDefault();
    };
    var getViewDate = function getViewDate(date) {
        var propValue = props.value;
        var viewDate = date || (props.onViewDateChange ? props.viewDate : viewDateState);
        if (Array.isArray(propValue)) propValue = propValue[0];
        return viewDate && isValidDate(viewDate) ? viewDate : propValue && isValidDate(propValue) ? propValue : new Date();
    };
    var getCurrentDateTime = function getCurrentDateTime() {
        if (isSingleSelection()) return props.value && props.value instanceof Date ? cloneDate(props.value) : getViewDate();
        else if (isMultipleSelection()) {
            if (props.value && props.value.length) return cloneDate(props.value[props.value.length - 1]);
        } else if (isRangeSelection()) {
            if (props.value && props.value.length) {
                var startDate = cloneDate(props.value[0]);
                var endDate = cloneDate(props.value[1]);
                return endDate || startDate;
            }
        }
        return new Date();
    };
    var cloneDate = function cloneDate(date) {
        return isValidDate(date) ? new Date(date.valueOf()) : date;
    };
    var isValidDate = function isValidDate(date) {
        return date instanceof Date && !isNaN(date);
    };
    var convertTo24Hour = function convertTo24Hour(hour, pm) {
        if (props.hourFormat === "12") return hour === 12 ? pm ? 12 : 0 : pm ? hour + 12 : hour;
        return hour;
    };
    var validateHour = function validateHour(hour, value) {
        var valid = true;
        var valueDateString = value ? value.toDateString() : null;
        if (props.minDate && valueDateString && props.minDate.toDateString() === valueDateString) {
            if (props.minDate.getHours() > hour) valid = false;
        }
        if (props.maxDate && valueDateString && props.maxDate.toDateString() === valueDateString) {
            if (props.maxDate.getHours() < hour) valid = false;
        }
        return valid;
    };
    var validateMinute = function validateMinute(minute, value) {
        var valid = true;
        var valueDateString = value ? value.toDateString() : null;
        if (props.minDate && valueDateString && props.minDate.toDateString() === valueDateString) {
            if (value.getHours() === props.minDate.getHours()) {
                if (props.minDate.getMinutes() > minute) valid = false;
            }
        }
        if (props.maxDate && valueDateString && props.maxDate.toDateString() === valueDateString) {
            if (value.getHours() === props.maxDate.getHours()) {
                if (props.maxDate.getMinutes() < minute) valid = false;
            }
        }
        return valid;
    };
    var validateSecond = function validateSecond(second, value) {
        var valid = true;
        var valueDateString = value ? value.toDateString() : null;
        if (props.minDate && valueDateString && props.minDate.toDateString() === valueDateString) {
            if (value.getHours() === props.minDate.getHours() && value.getMinutes() === props.minDate.getMinutes()) {
                if (props.minDate.getSeconds() > second) valid = false;
            }
        }
        if (props.maxDate && valueDateString && props.maxDate.toDateString() === valueDateString) {
            if (value.getHours() === props.maxDate.getHours() && value.getMinutes() === props.maxDate.getMinutes()) {
                if (props.maxDate.getSeconds() < second) valid = false;
            }
        }
        return valid;
    };
    var validateMillisecond = function validateMillisecond(millisecond, value) {
        var valid = true;
        var valueDateString = value ? value.toDateString() : null;
        if (props.minDate && valueDateString && props.minDate.toDateString() === valueDateString) {
            if (value.getHours() === props.minDate.getHours() && value.getSeconds() === props.minDate.getSeconds() && value.getMinutes() === props.minDate.getMinutes()) {
                if (props.minDate.getMilliseconds() > millisecond) valid = false;
            }
        }
        if (props.maxDate && valueDateString && props.maxDate.toDateString() === valueDateString) {
            if (value.getHours() === props.maxDate.getHours() && value.getSeconds() === props.maxDate.getSeconds() && value.getMinutes() === props.maxDate.getMinutes()) {
                if (props.maxDate.getMilliseconds() < millisecond) valid = false;
            }
        }
        return valid;
    };
    var validateDate = function validateDate(value) {
        if (props.yearNavigator) {
            var viewYear = value.getFullYear();
            var minRangeYear = props.yearRange ? parseInt(props.yearRange.split(":")[0], 10) : null;
            var maxRangeYear = props.yearRange ? parseInt(props.yearRange.split(":")[1], 10) : null;
            var minYear = props.minDate && minRangeYear != null ? Math.max(props.minDate.getFullYear(), minRangeYear) : props.minDate || minRangeYear;
            var maxYear = props.maxDate && maxRangeYear != null ? Math.min(props.maxDate.getFullYear(), maxRangeYear) : props.maxDate || maxRangeYear;
            if (minYear && minYear > viewYear) viewYear = minYear;
            if (maxYear && maxYear < viewYear) viewYear = maxYear;
            value.setFullYear(viewYear);
        }
        if (renderMonthsNavigator(0)) {
            var viewMonth = value.getMonth();
            var viewMonthWithMinMax = parseInt(isInMinYear(value) && Math.max(props.minDate.getMonth(), viewMonth).toString() || isInMaxYear(value) && Math.min(props.maxDate.getMonth(), viewMonth).toString() || viewMonth);
            value.setMonth(viewMonthWithMinMax);
        }
    };
    var updateTime = function updateTime(event, hour, minute, second, millisecond) {
        var newDateTime = getCurrentDateTime();
        newDateTime.setHours(hour);
        newDateTime.setMinutes(minute);
        newDateTime.setSeconds(second);
        newDateTime.setMilliseconds(millisecond);
        if (isMultipleSelection()) {
            if (props.value && props.value.length) {
                var value = $a54e198ef3baabb4$var$_toConsumableArray(props.value);
                value[value.length - 1] = newDateTime;
                newDateTime = value;
            } else newDateTime = [
                newDateTime
            ];
        } else if (isRangeSelection()) {
            if (props.value && props.value.length) {
                var startDate = props.value[0];
                var endDate = props.value[1];
                newDateTime = endDate ? [
                    startDate,
                    newDateTime
                ] : [
                    newDateTime,
                    null
                ];
            } else newDateTime = [
                newDateTime,
                null
            ];
        }
        updateModel(event, newDateTime);
        if (props.onSelect) props.onSelect({
            originalEvent: event,
            value: newDateTime
        });
        updateInputfield(newDateTime);
    };
    var updateViewDate = function updateViewDate(event, value) {
        validateDate(value);
        if (props.onViewDateChange && event) props.onViewDateChange({
            originalEvent: event,
            value: value
        });
        else {
            viewStateChanged.current = true;
            setViewDateState(value);
        }
        if (!value) onClearButtonClick(event);
        if (value && props.onSelect) {
            var day = value.getDate();
            var month = value.getMonth();
            var year = value.getFullYear();
            onDateSelect(event, {
                day: day,
                month: month,
                year: year,
                selectable: isSelectable(day, month, year)
            });
        }
    };
    var setNavigationState = function setNavigationState(newViewDate) {
        if (!newViewDate || !props.showMinMaxRange || props.view !== "date" || !overlayRef.current) return;
        var navPrev = (0, $cfkGk.DomHandler).findSingle(overlayRef.current, '[data-pc-section="previousbutton"]');
        var navNext = (0, $cfkGk.DomHandler).findSingle(overlayRef.current, '[data-pc-section="nextbutton"]');
        if (props.disabled) {
            !isUnstyled() && (0, $cfkGk.DomHandler).addClass(navPrev, "p-disabled");
            navPrev.setAttribute("data-p-disabled", true);
            !isUnstyled() && (0, $cfkGk.DomHandler).addClass(navNext, "p-disabled");
            navNext.setAttribute("data-p-disabled", true);
            return;
        }
        // previous (check first day of month at 00:00:00)
        if (props.minDate) {
            var firstDayOfMonth = cloneDate(newViewDate);
            if (firstDayOfMonth.getMonth() === 0) {
                firstDayOfMonth.setMonth(11, 1);
                firstDayOfMonth.setFullYear(firstDayOfMonth.getFullYear() - 1);
            } else firstDayOfMonth.setMonth(firstDayOfMonth.getMonth(), 1);
            firstDayOfMonth.setHours(0);
            firstDayOfMonth.setMinutes(0);
            firstDayOfMonth.setSeconds(0);
            if (props.minDate > firstDayOfMonth) (0, $cfkGk.DomHandler).addClass(navPrev, "p-disabled");
            else (0, $cfkGk.DomHandler).removeClass(navPrev, "p-disabled");
        }
        // next (check last day of month at 11:59:59)
        if (props.maxDate) {
            var lastDayOfMonth = cloneDate(newViewDate);
            if (lastDayOfMonth.getMonth() === 11) {
                lastDayOfMonth.setMonth(0, 1);
                lastDayOfMonth.setFullYear(lastDayOfMonth.getFullYear() + 1);
            } else lastDayOfMonth.setMonth(lastDayOfMonth.getMonth() + 1, 1);
            lastDayOfMonth.setHours(0);
            lastDayOfMonth.setMinutes(0);
            lastDayOfMonth.setSeconds(0);
            lastDayOfMonth.setSeconds(-1);
            if (props.maxDate < lastDayOfMonth) (0, $cfkGk.DomHandler).addClass(navNext, "p-disabled");
            else (0, $cfkGk.DomHandler).removeClass(navNext, "p-disabled");
        }
    };
    var onDateCellKeydown = function onDateCellKeydown(event, date, groupIndex) {
        var cellContent = event.currentTarget;
        var cell = cellContent.parentElement;
        var cellIndex = (0, $cfkGk.DomHandler).index(cell);
        switch(event.code){
            case "ArrowDown":
                cellContent.tabIndex = "-1";
                var nextRow = cell.parentElement.nextElementSibling;
                if (nextRow) {
                    var tableRowIndex = (0, $cfkGk.DomHandler).index(cell.parentElement);
                    var tableRows = Array.from(cell.parentElement.parentElement.children);
                    var nextTableRows = tableRows.slice(tableRowIndex + 1);
                    var hasNextFocusableDate = nextTableRows.find(function(el) {
                        var focusCell = el.children[cellIndex].children[0];
                        return !(0, $cfkGk.DomHandler).getAttribute(focusCell, "data-p-disabled");
                    });
                    if (hasNextFocusableDate) {
                        var focusCell = hasNextFocusableDate.children[cellIndex].children[0];
                        focusCell.tabIndex = "0";
                        focusCell.focus();
                    } else {
                        navigation.current = {
                            backward: false
                        };
                        navForward(event);
                    }
                } else {
                    navigation.current = {
                        backward: false
                    };
                    navForward(event);
                }
                event.preventDefault();
                break;
            case "ArrowUp":
                cellContent.tabIndex = "-1";
                if (event.altKey) hide(null, reFocusInputField);
                else {
                    var prevRow = cell.parentElement.previousElementSibling;
                    if (prevRow) {
                        var _tableRowIndex = (0, $cfkGk.DomHandler).index(cell.parentElement);
                        var _tableRows = Array.from(cell.parentElement.parentElement.children);
                        var prevTableRows = _tableRows.slice(0, _tableRowIndex).reverse();
                        var _hasNextFocusableDate = prevTableRows.find(function(el) {
                            var focusCell = el.children[cellIndex].children[0];
                            return !(0, $cfkGk.DomHandler).getAttribute(focusCell, "data-p-disabled");
                        });
                        if (_hasNextFocusableDate) {
                            var _focusCell = _hasNextFocusableDate.children[cellIndex].children[0];
                            _focusCell.tabIndex = "0";
                            _focusCell.focus();
                        } else {
                            navigation.current = {
                                backward: true
                            };
                            navBackward(event);
                        }
                    } else {
                        navigation.current = {
                            backward: true
                        };
                        navBackward(event);
                    }
                }
                event.preventDefault();
                break;
            case "ArrowLeft":
                cellContent.tabIndex = "-1";
                var prevCell = cell.previousElementSibling;
                if (prevCell) {
                    var cells = Array.from(cell.parentElement.children);
                    var prevCells = cells.slice(0, cellIndex).reverse();
                    var _hasNextFocusableDate2 = prevCells.find(function(el) {
                        var focusCell = el.children[0];
                        return !(0, $cfkGk.DomHandler).getAttribute(focusCell, "data-p-disabled");
                    });
                    if (_hasNextFocusableDate2) {
                        var _focusCell2 = _hasNextFocusableDate2.children[0];
                        _focusCell2.tabIndex = "0";
                        _focusCell2.focus();
                    } else navigateToMonth(true, groupIndex, event);
                } else navigateToMonth(true, groupIndex, event);
                event.preventDefault();
                break;
            case "ArrowRight":
                cellContent.tabIndex = "-1";
                var nextCell = cell.nextElementSibling;
                if (nextCell) {
                    var _cells = Array.from(cell.parentElement.children);
                    var nextCells = _cells.slice(cellIndex + 1);
                    var _hasNextFocusableDate3 = nextCells.find(function(el) {
                        var focusCell = el.children[0];
                        return !(0, $cfkGk.DomHandler).getAttribute(focusCell, "data-p-disabled");
                    });
                    if (_hasNextFocusableDate3) {
                        var _focusCell3 = _hasNextFocusableDate3.children[0];
                        _focusCell3.tabIndex = "0";
                        _focusCell3.focus();
                    } else navigateToMonth(false, groupIndex, event);
                } else navigateToMonth(false, groupIndex, event);
                event.preventDefault();
                break;
            case "Enter":
            case "NumpadEnter":
            case "Space":
                onDateSelect(event, date);
                event.preventDefault();
                break;
            case "Escape":
                hide(null, reFocusInputField);
                event.preventDefault();
                break;
            case "Tab":
                if (!props.inline) trapFocus(event);
                break;
            case "Home":
                cellContent.tabIndex = "-1";
                var currentRow = cell.parentElement;
                var _focusCell4 = currentRow.children[0].children[0];
                if ((0, $cfkGk.DomHandler).getAttribute(_focusCell4, "data-p-disabled")) navigateToMonth(groupIndex, true, event);
                else {
                    _focusCell4.tabIndex = "0";
                    _focusCell4.focus();
                }
                event.preventDefault();
                break;
            case "End":
                cellContent.tabIndex = "-1";
                var _currentRow = cell.parentElement;
                var _focusCell5 = _currentRow.children[_currentRow.children.length - 1].children[0];
                if ((0, $cfkGk.DomHandler).getAttribute(_focusCell5, "data-p-disabled")) navigateToMonth(groupIndex, false, event);
                else {
                    _focusCell5.tabIndex = "0";
                    _focusCell5.focus();
                }
                event.preventDefault();
                break;
            case "PageUp":
                cellContent.tabIndex = "-1";
                if (event.shiftKey) {
                    navigation.current = {
                        backward: true
                    };
                    navBackward(event);
                } else navigateToMonth(groupIndex, true, event);
                event.preventDefault();
                break;
            case "PageDown":
                cellContent.tabIndex = "-1";
                if (event.shiftKey) {
                    navigation.current = {
                        backward: false
                    };
                    navForward(event);
                } else navigateToMonth(groupIndex, false, event);
                event.preventDefault();
                break;
        }
    };
    var navigateToMonth = function navigateToMonth(prev, groupIndex, event) {
        if (prev) {
            if (props.numberOfMonths === 1 || groupIndex === 0) {
                navigation.current = {
                    backward: true
                };
                navBackward(event);
            } else {
                var prevMonthContainer = overlayRef.current.children[groupIndex - 1];
                var cells = (0, $cfkGk.DomHandler).find(prevMonthContainer, 'table td span:not([data-p-disabled="true"])');
                var focusCell = cells[cells.length - 1];
                focusCell.tabIndex = "0";
                focusCell.focus();
            }
        } else if (props.numberOfMonths === 1 || groupIndex === props.numberOfMonths - 1) {
            navigation.current = {
                backward: false
            };
            navForward(event);
        } else {
            var nextMonthContainer = overlayRef.current.children[groupIndex + 1];
            var _focusCell6 = (0, $cfkGk.DomHandler).findSingle(nextMonthContainer, 'table td span:not([data-p-disabled="true"])');
            _focusCell6.tabIndex = "0";
            _focusCell6.focus();
        }
    };
    var onMonthCellKeydown = function onMonthCellKeydown(event, index) {
        var cell = event.currentTarget;
        switch(event.code){
            //arrows
            case "ArrowUp":
            case "ArrowDown":
                cell.tabIndex = "-1";
                var cells = cell.parentElement.children;
                var cellIndex = (0, $cfkGk.DomHandler).index(cell);
                var nextCell = cells[event.which === 40 ? cellIndex + 3 : cellIndex - 3];
                if (nextCell) {
                    nextCell.tabIndex = "0";
                    nextCell.focus();
                }
                event.preventDefault();
                break;
            case "ArrowLeft":
                cell.tabIndex = "-1";
                var prevCell = cell.previousElementSibling;
                if (prevCell) {
                    prevCell.tabIndex = "0";
                    prevCell.focus();
                } else {
                    navigation.current = {
                        backward: true
                    };
                    navBackward(event);
                }
                event.preventDefault();
                break;
            case "ArrowRight":
                cell.tabIndex = "-1";
                var _nextCell = cell.nextElementSibling;
                if (_nextCell) {
                    _nextCell.tabIndex = "0";
                    _nextCell.focus();
                } else {
                    navigation.current = {
                        backward: false
                    };
                    navForward(event);
                }
                event.preventDefault();
                break;
            case "PageUp":
                if (event.shiftKey) return;
                navigation.current = {
                    backward: true
                };
                navBackward(event);
                break;
            case "PageDown":
                if (event.shiftKey) return;
                navigation.current = {
                    backward: false
                };
                navForward(event);
                break;
            case "Enter":
            case "NumpadEnter":
            case "Space":
                if (props.view !== "month") viewChangedWithKeyDown.current = true;
                onMonthSelect(event, index);
                event.preventDefault();
                break;
            case "Escape":
                hide(null, reFocusInputField);
                event.preventDefault();
                break;
            case "Tab":
                trapFocus(event);
                break;
        }
    };
    var onYearCellKeydown = function onYearCellKeydown(event, index) {
        var cell = event.currentTarget;
        switch(event.code){
            //arrows
            case "ArrowUp":
            case "ArrowDown":
                cell.tabIndex = "-1";
                var cells = cell.parentElement.children;
                var cellIndex = (0, $cfkGk.DomHandler).index(cell);
                var nextCell = cells[event.code === "ArrowDown" ? cellIndex + 2 : cellIndex - 2];
                if (nextCell) {
                    nextCell.tabIndex = "0";
                    nextCell.focus();
                }
                event.preventDefault();
                break;
            case "ArrowLeft":
                cell.tabIndex = "-1";
                var prevCell = cell.previousElementSibling;
                if (prevCell) {
                    prevCell.tabIndex = "0";
                    prevCell.focus();
                } else {
                    navigation.current = {
                        backward: true
                    };
                    navBackward(event);
                }
                event.preventDefault();
                break;
            case "ArrowRight":
                cell.tabIndex = "-1";
                var _nextCell2 = cell.nextElementSibling;
                if (_nextCell2) {
                    _nextCell2.tabIndex = "0";
                    _nextCell2.focus();
                } else {
                    navigation.current = {
                        backward: false
                    };
                    navForward(event);
                }
                event.preventDefault();
                break;
            case "PageUp":
                if (event.shiftKey) return;
                navigation.current = {
                    backward: true
                };
                navBackward(event);
                break;
            case "PageDown":
                if (event.shiftKey) return;
                navigation.current = {
                    backward: false
                };
                navForward(event);
                break;
            case "Enter":
            case "NumpadEnter":
            case "Space":
                if (props.view !== "year") viewChangedWithKeyDown.current = true;
                onYearSelect(event, index);
                event.preventDefault();
                break;
            case "Escape":
                hide(null, reFocusInputField);
                event.preventDefault();
                break;
            case "Tab":
                trapFocus(event);
                break;
        }
    };
    var onDateSelect = function onDateSelect(event, dateMeta, timeMeta) {
        if (!event) return;
        if (props.disabled || !dateMeta.selectable) {
            event.preventDefault();
            return;
        }
        (0, $cfkGk.DomHandler).find(overlayRef.current, 'table td span:not([data-p-disabled="true"])').forEach(function(cell) {
            return cell.tabIndex = -1;
        });
        event.currentTarget.focus();
        if (isMultipleSelection()) {
            if (isSelected(dateMeta)) {
                var value = props.value.filter(function(date) {
                    return !isDateEquals(date, dateMeta);
                });
                updateModel(event, value);
                updateInputfield(value);
            } else if (!props.maxDateCount || !props.value || props.maxDateCount > props.value.length) selectDate(event, dateMeta, timeMeta);
        } else selectDate(event, dateMeta, timeMeta);
        if (!props.inline && isSingleSelection() && (!props.showTime || props.hideOnDateTimeSelect)) {
            setTimeout(function() {
                hide("dateselect");
            }, 100);
            if (touchUIMask.current) disableModality();
        }
        event.preventDefault();
    };
    var selectTime = function selectTime(date, timeMeta) {
        if (props.showTime) {
            var hours;
            var minutes;
            var seconds;
            var milliseconds;
            if (timeMeta) {
                hours = timeMeta.hours;
                minutes = timeMeta.minutes;
                seconds = timeMeta.seconds;
                milliseconds = timeMeta.milliseconds;
            } else {
                var time = getCurrentDateTime();
                var _ref2 = [
                    time.getHours(),
                    time.getMinutes(),
                    time.getSeconds(),
                    time.getMilliseconds()
                ];
                hours = _ref2[0];
                minutes = _ref2[1];
                seconds = _ref2[2];
                milliseconds = _ref2[3];
            }
            date.setHours(hours);
            date.setMinutes(doStepMinute(minutes));
            date.setSeconds(seconds);
            date.setMilliseconds(milliseconds);
        }
    };
    var selectDate = function selectDate(event, dateMeta, timeMeta) {
        var date = new Date(dateMeta.year, dateMeta.month, dateMeta.day);
        selectTime(date, timeMeta);
        if (props.minDate && props.minDate > date) date = props.minDate;
        if (props.maxDate && props.maxDate < date) date = props.maxDate;
        var selectedValues = date;
        if (isSingleSelection()) updateModel(event, date);
        else if (isMultipleSelection()) {
            selectedValues = props.value ? [].concat($a54e198ef3baabb4$var$_toConsumableArray(props.value), [
                date
            ]) : [
                date
            ];
            updateModel(event, selectedValues);
        } else if (isRangeSelection()) {
            if (props.value && props.value.length) {
                var startDate = props.value[0];
                var endDate = props.value[1];
                if (!endDate) {
                    if (date.getTime() >= startDate.getTime()) endDate = date;
                    else {
                        endDate = startDate;
                        startDate = date;
                    }
                } else {
                    startDate = date;
                    endDate = null;
                }
                selectedValues = [
                    startDate,
                    endDate
                ];
                updateModel(event, selectedValues);
                if (props.hideOnRangeSelection && endDate !== null) setTimeout(function() {
                    setOverlayVisibleState(false);
                }, 150);
            } else {
                selectedValues = [
                    date,
                    null
                ];
                updateModel(event, selectedValues);
            }
        }
        if (props.onSelect) props.onSelect({
            originalEvent: event,
            value: date
        });
        updateInputfield(selectedValues);
    };
    var decrementDecade = function decrementDecade() {
        var _currentYear = currentYear - 10;
        setCurrentYear(_currentYear);
        return _currentYear;
    };
    var incrementDecade = function incrementDecade() {
        var _currentYear = currentYear + 10;
        setCurrentYear(_currentYear);
        return _currentYear;
    };
    var switchToMonthView = function switchToMonthView(event) {
        if (event && event.code && (event.code === "Enter" || event.code === "NumpadEnter" || event.code === "Space")) viewChangedWithKeyDown.current = true;
        setCurrentView("month");
        event.preventDefault();
    };
    var switchToYearView = function switchToYearView(event) {
        if (event && event.code && (event.code === "Enter" || event.code === "NumpadEnter" || event.code === "Space")) viewChangedWithKeyDown.current = true;
        setCurrentView("year");
        event.preventDefault();
    };
    var onMonthSelect = function onMonthSelect(event, month) {
        if (props.view === "month") {
            onDateSelect(event, {
                year: currentYear,
                month: month,
                day: 1,
                selectable: true
            });
            event.preventDefault();
        } else {
            setCurrentMonth(month);
            createMonthsMeta(month, currentYear);
            var currentDate = cloneDate(getCurrentDateTime());
            currentDate.setDate(1); // #2948 always set to 1st of month
            currentDate.setMonth(month);
            currentDate.setYear(currentYear);
            setViewDateState(currentDate);
            setCurrentView("date");
            props.onMonthChange && props.onMonthChange({
                month: month + 1,
                year: currentYear
            });
            updateViewDate(event, currentDate);
        }
    };
    var onYearSelect = function onYearSelect(event, year) {
        if (props.view === "year") onDateSelect(event, {
            year: year,
            month: 0,
            day: 1,
            selectable: true
        });
        else {
            setCurrentYear(year);
            setCurrentView("month");
            props.onMonthChange && props.onMonthChange({
                month: currentMonth + 1,
                year: year
            });
        }
    };
    var updateModel = function updateModel(event, value) {
        if (props.onChange) {
            var newValue = cloneDate(value);
            viewStateChanged.current = true;
            onChangeRef.current({
                originalEvent: event,
                value: newValue,
                stopPropagation: function stopPropagation() {
                    event === null || event === void 0 || event.stopPropagation();
                },
                preventDefault: function preventDefault() {
                    event === null || event === void 0 || event.preventDefault();
                },
                target: {
                    name: props.name,
                    id: props.id,
                    value: newValue
                }
            });
        }
    };
    var show = function show(type) {
        if (props.onVisibleChange) props.onVisibleChange({
            visible: true,
            type: type
        });
        else {
            setOverlayVisibleState(true);
            overlayEventListener.current = function(e) {
                if (!isOutsideClicked(e)) isOverlayClicked.current = true;
            };
            (0, $k7ffa.OverlayService).on("overlay-click", overlayEventListener.current);
        }
    };
    var hide = function hide(type, callback) {
        var _hideCallback = function _hideCallback() {
            viewStateChanged.current = false;
            ignoreFocusFunctionality.current = false;
            isOverlayClicked.current = false;
            callback && callback();
            (0, $k7ffa.OverlayService).off("overlay-click", overlayEventListener.current);
            overlayEventListener.current = null;
        };
        props.touchUI && disableModality();
        if (props.onVisibleChange) props.onVisibleChange({
            visible: type !== "dateselect",
            // false only if selecting a value to close panel
            type: type,
            callback: _hideCallback
        });
        else {
            setOverlayVisibleState(false);
            _hideCallback();
        }
    };
    var onOverlayEnter = function onOverlayEnter() {
        var styles = props.touchUI ? {
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
        } : !props.inline ? {
            position: "absolute",
            top: "0",
            left: "0"
        } : undefined;
        (0, $cfkGk.DomHandler).addStyles(overlayRef.current, styles);
        if (props.autoZIndex) {
            var key = props.touchUI ? "modal" : "overlay";
            (0, $cfkGk.ZIndexUtils).set(key, overlayRef.current, context && context.autoZIndex || (0, $8Zwsm.default).autoZIndex, props.baseZIndex || context && context.zIndex[key] || (0, $8Zwsm.default).zIndex[key]);
        }
        if (!props.touchUI && overlayRef && overlayRef.current && inputRef && inputRef.current && !appendDisabled()) {
            var inputWidth = (0, $cfkGk.DomHandler).getOuterWidth(inputRef.current);
            // #5435 must have reasonable width if input is too small
            if (inputWidth < 220) inputWidth = 220;
            if (props.view === "date") overlayRef.current.style.width = (0, $cfkGk.DomHandler).getOuterWidth(overlayRef.current) + "px";
            else overlayRef.current.style.width = inputWidth + "px";
            // #5830 Tailwind does not need a min width it breaks the styling
            if (!isUnstyled()) overlayRef.current.style.minWidth = inputWidth + "px";
        }
        alignOverlay();
    };
    var onOverlayEntered = function onOverlayEntered() {
        bindOverlayListener();
        props.onShow && props.onShow();
        setFocusedState(false);
    };
    var onOverlayExit = function onOverlayExit() {
        unbindOverlayListener();
    };
    var onOverlayExited = function onOverlayExited() {
        (0, $cfkGk.ZIndexUtils).clear(overlayRef.current);
        props.onHide && props.onHide();
    };
    var appendDisabled = function appendDisabled() {
        var appendTo = props.appendTo || context && context.appendTo || (0, $8Zwsm.default).appendTo;
        return appendTo === "self" || props.inline;
    };
    var alignOverlay = function alignOverlay() {
        if (props.touchUI) enableModality();
        else if (overlayRef && overlayRef.current && inputRef && inputRef.current) {
            (0, $cfkGk.DomHandler).alignOverlay(overlayRef.current, inputRef.current, props.appendTo || context && context.appendTo || (0, $8Zwsm.default).appendTo);
            if (appendDisabled()) (0, $cfkGk.DomHandler).relativePosition(overlayRef.current, inputRef.current);
            else (0, $cfkGk.DomHandler).absolutePosition(overlayRef.current, inputRef.current);
        }
    };
    var enableModality = function enableModality() {
        if (!touchUIMask.current) {
            touchUIMask.current = document.createElement("div");
            touchUIMask.current.style.zIndex = String((0, $cfkGk.ZIndexUtils).get(overlayRef.current) - 1);
            !isUnstyled() && (0, $cfkGk.DomHandler).addMultipleClasses(touchUIMask.current, "p-component-overlay p-datepicker-mask p-datepicker-mask-scrollblocker p-component-overlay-enter");
            touchUIMaskClickListener.current = function() {
                disableModality();
                hide();
            };
            touchUIMask.current.addEventListener("click", touchUIMaskClickListener.current);
            document.body.appendChild(touchUIMask.current);
            (0, $cfkGk.DomHandler).blockBodyScroll();
        }
    };
    var disableModality = function disableModality() {
        if (touchUIMask.current) {
            if (isUnstyled) destroyMask();
            else {
                !isUnstyled() && (0, $cfkGk.DomHandler).addClass(touchUIMask.current, "p-component-overlay-leave");
                if ((0, $cfkGk.DomHandler).hasCSSAnimation(touchUIMask.current) > 0) touchUIMask.current.addEventListener("animationend", function() {
                    destroyMask();
                });
                else destroyMask();
            }
        }
    };
    var destroyMask = function destroyMask() {
        if (touchUIMask.current) {
            touchUIMask.current.removeEventListener("click", touchUIMaskClickListener.current);
            touchUIMaskClickListener.current = null;
            document.body.removeChild(touchUIMask.current);
            touchUIMask.current = null;
        }
        var bodyChildren = document.body.children;
        var hasBlockerMasks;
        for(var i = 0; i < bodyChildren.length; i++){
            var bodyChild = bodyChildren[i];
            if ((0, $cfkGk.DomHandler).hasClass(bodyChild, "p-datepicker-mask-scrollblocker")) {
                hasBlockerMasks = true;
                break;
            }
        }
        if (!hasBlockerMasks) (0, $cfkGk.DomHandler).unblockBodyScroll();
    };
    var isOutsideClicked = function isOutsideClicked(event) {
        return elementRef.current && !(elementRef.current.isSameNode(event.target) || isNavIconClicked(event.target) || elementRef.current.contains(event.target) || overlayRef.current && overlayRef.current.contains(event.target));
    };
    var isNavIconClicked = function isNavIconClicked(target) {
        return previousButton.current && (previousButton.current.isSameNode(target) || previousButton.current.contains(target)) || nextButton.current && (nextButton.current.isSameNode(target) || nextButton.current.contains(target));
    };
    var getFirstDayOfMonthIndex = function getFirstDayOfMonthIndex(month, year) {
        var day = new Date();
        day.setDate(1);
        day.setMonth(month);
        day.setFullYear(year);
        var dayIndex = day.getDay() + getSundayIndex();
        return dayIndex >= 7 ? dayIndex - 7 : dayIndex;
    };
    var getDaysCountInMonth = function getDaysCountInMonth(month, year) {
        return 32 - daylightSavingAdjust(new Date(year, month, 32)).getDate();
    };
    var getDaysCountInPrevMonth = function getDaysCountInPrevMonth(month, year) {
        var prev = getPreviousMonthAndYear(month, year);
        return getDaysCountInMonth(prev.month, prev.year);
    };
    var daylightSavingAdjust = function daylightSavingAdjust(date) {
        if (!date) return null;
        date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
        return date;
    };
    var getPreviousMonthAndYear = function getPreviousMonthAndYear(month, year) {
        var m;
        var y;
        if (month === 0) {
            m = 11;
            y = year - 1;
        } else {
            m = month - 1;
            y = year;
        }
        return {
            month: m,
            year: y
        };
    };
    var getNextMonthAndYear = function getNextMonthAndYear(month, year) {
        var m;
        var y;
        if (month === 11) {
            m = 0;
            y = year + 1;
        } else {
            m = month + 1;
            y = year;
        }
        return {
            month: m,
            year: y
        };
    };
    var getSundayIndex = function getSundayIndex() {
        var firstDayOfWeek = (0, $8Zwsm.localeOption)("firstDayOfWeek", props.locale);
        return firstDayOfWeek > 0 ? 7 - firstDayOfWeek : 0;
    };
    var createWeekDaysMeta = function createWeekDaysMeta() {
        var weekDays = [];
        var _localeOptions = (0, $8Zwsm.localeOptions)(props.locale), dayIndex = _localeOptions.firstDayOfWeek, dayNamesMin = _localeOptions.dayNamesMin;
        for(var i = 0; i < 7; i++){
            weekDays.push(dayNamesMin[dayIndex]);
            dayIndex = dayIndex === 6 ? 0 : ++dayIndex;
        }
        return weekDays;
    };
    var createMonthsMeta = function createMonthsMeta(month, year) {
        var months = [];
        for(var i = 0; i < props.numberOfMonths; i++){
            var m = month + i;
            var y = year;
            if (m > 11) {
                m = m % 11 - 1;
                y = year + 1;
            }
            months.push(createMonthMeta(m, y));
        }
        return months;
    };
    var createMonthMeta = function createMonthMeta(month, year) {
        var dates = [];
        var firstDay = getFirstDayOfMonthIndex(month, year);
        var daysLength = getDaysCountInMonth(month, year);
        var prevMonthDaysLength = getDaysCountInPrevMonth(month, year);
        var dayNo = 1;
        var today = new Date();
        var weekNumbers = [];
        var monthRows = Math.ceil((daysLength + firstDay) / 7);
        for(var i = 0; i < monthRows; i++){
            var week = [];
            if (i === 0) {
                for(var j = prevMonthDaysLength - firstDay + 1; j <= prevMonthDaysLength; j++){
                    var prev = getPreviousMonthAndYear(month, year);
                    week.push({
                        day: j,
                        month: prev.month,
                        year: prev.year,
                        otherMonth: true,
                        today: isToday(today, j, prev.month, prev.year),
                        selectable: isSelectable(j, prev.month, prev.year, true)
                    });
                }
                var remainingDaysLength = 7 - week.length;
                for(var _j = 0; _j < remainingDaysLength; _j++){
                    week.push({
                        day: dayNo,
                        month: month,
                        year: year,
                        today: isToday(today, dayNo, month, year),
                        selectable: isSelectable(dayNo, month, year, false)
                    });
                    dayNo++;
                }
            } else for(var _j2 = 0; _j2 < 7; _j2++){
                if (dayNo > daysLength) {
                    var next = getNextMonthAndYear(month, year);
                    week.push({
                        day: dayNo - daysLength,
                        month: next.month,
                        year: next.year,
                        otherMonth: true,
                        today: isToday(today, dayNo - daysLength, next.month, next.year),
                        selectable: isSelectable(dayNo - daysLength, next.month, next.year, true)
                    });
                } else week.push({
                    day: dayNo,
                    month: month,
                    year: year,
                    today: isToday(today, dayNo, month, year),
                    selectable: isSelectable(dayNo, month, year, false)
                });
                dayNo++;
            }
            if (props.showWeek) weekNumbers.push(getWeekNumber(new Date(week[0].year, week[0].month, week[0].day)));
            dates.push(week);
        }
        return {
            month: month,
            year: year,
            dates: dates,
            weekNumbers: weekNumbers
        };
    };
    var getWeekNumber = function getWeekNumber(date) {
        var checkDate = cloneDate(date);
        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));
        var time = checkDate.getTime();
        checkDate.setMonth(0);
        checkDate.setDate(1);
        return Math.floor(Math.round((time - checkDate.getTime()) / 86400000) / 7) + 1;
    };
    var isSelectable = function isSelectable(day, month, year, otherMonth) {
        var validMin = true;
        var validMax = true;
        var validDate = true;
        var validDay = true;
        var validMonth = true;
        if (props.minDate) {
            if (props.minDate.getFullYear() > year) validMin = false;
            else if (props.minDate.getFullYear() === year) {
                if (month > -1 && props.minDate.getMonth() > month) validMin = false;
                else if (month > -1 && props.minDate.getMonth() === month) {
                    if (day > 0 && props.minDate.getDate() > day) validMin = false;
                }
            }
        }
        if (props.maxDate) {
            if (props.maxDate.getFullYear() < year) validMax = false;
            else if (props.maxDate.getFullYear() === year) {
                if (month > -1 && props.maxDate.getMonth() < month) validMax = false;
                else if (month > -1 && props.maxDate.getMonth() === month) {
                    if (day > 0 && props.maxDate.getDate() < day) validMax = false;
                }
            }
        }
        if (props.disabledDates || props.enabledDates || props.disabledDays) validDay = !isDayDisabled(day, month, year);
        if (props.selectOtherMonths === false && otherMonth) validMonth = false;
        return validMin && validMax && validDate && validDay && validMonth;
    };
    var isSelectableTime = function isSelectableTime(value) {
        var validMin = true;
        var validMax = true;
        if (props.minDate && props.minDate.toDateString() === value.toDateString()) {
            if (props.minDate.getHours() > value.getHours()) validMin = false;
            else if (props.minDate.getHours() === value.getHours()) {
                if (props.minDate.getMinutes() > value.getMinutes()) validMin = false;
                else if (props.minDate.getMinutes() === value.getMinutes()) {
                    if (props.minDate.getSeconds() > value.getSeconds()) validMin = false;
                    else if (props.minDate.getSeconds() === value.getSeconds()) {
                        if (props.minDate.getMilliseconds() > value.getMilliseconds()) validMin = false;
                    }
                }
            }
        }
        if (props.maxDate && props.maxDate.toDateString() === value.toDateString()) {
            if (props.maxDate.getHours() < value.getHours()) validMax = false;
            else if (props.maxDate.getHours() === value.getHours()) {
                if (props.maxDate.getMinutes() < value.getMinutes()) validMax = false;
                else if (props.maxDate.getMinutes() === value.getMinutes()) {
                    if (props.maxDate.getSeconds() < value.getSeconds()) validMax = false;
                    else if (props.maxDate.getSeconds() === value.getSeconds()) {
                        if (props.maxDate.getMilliseconds() < value.getMilliseconds()) validMax = false;
                    }
                }
            }
        }
        return validMin && validMax;
    };
    var isSelected = function isSelected(dateMeta) {
        if (props.value) {
            if (isSingleSelection()) return isDateEquals(props.value, dateMeta);
            else if (isMultipleSelection()) {
                var selected = false;
                var _iterator = $a54e198ef3baabb4$var$_createForOfIteratorHelper(props.value), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var date = _step.value;
                        selected = isDateEquals(date, dateMeta);
                        if (selected) break;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return selected;
            } else if (isRangeSelection()) {
                if (props.value[1]) return isDateEquals(props.value[0], dateMeta) || isDateEquals(props.value[1], dateMeta) || isDateBetween(props.value[0], props.value[1], dateMeta);
                return isDateEquals(props.value[0], dateMeta);
            }
        } else return false;
    };
    var isComparable = function isComparable() {
        return props.value != null && typeof props.value !== "string";
    };
    var isMonthSelected = function isMonthSelected(month) {
        if (!isComparable()) return false;
        if (isMultipleSelection()) return props.value.some(function(v) {
            return v.getMonth() === month && v.getFullYear() === currentYear;
        });
        else if (isRangeSelection()) {
            var _props$value = $a54e198ef3baabb4$var$_slicedToArray(props.value, 2), start = _props$value[0], end = _props$value[1];
            var startYear = start ? start.getFullYear() : null;
            var endYear = end ? end.getFullYear() : null;
            var startMonth = start ? start.getMonth() : null;
            var endMonth = end ? end.getMonth() : null;
            if (!end) return startYear === currentYear && startMonth === month;
            else {
                var currentDate = new Date(currentYear, month, 1);
                var startDate = new Date(startYear, startMonth, 1);
                var endDate = new Date(endYear, endMonth, 1);
                return currentDate >= startDate && currentDate <= endDate;
            }
        } else return props.value.getMonth() === month && props.value.getFullYear() === currentYear;
    };
    var isYearSelected = function isYearSelected(year) {
        if (!isComparable()) return false;
        if (isMultipleSelection()) return props.value.some(function(v) {
            return v.getFullYear() === year;
        });
        else if (isRangeSelection()) {
            var start = props.value[0] ? props.value[0].getFullYear() : null;
            var end = props.value[1] ? props.value[1].getFullYear() : null;
            return start === year || end === year || start < year && end > year;
        } else return props.value.getFullYear() === year;
    };
    var switchViewButtonDisabled = function switchViewButtonDisabled() {
        return props.numberOfMonths > 1 || props.disabled;
    };
    var isDateEquals = function isDateEquals(value, dateMeta) {
        if (value && value instanceof Date) return value.getDate() === dateMeta.day && value.getMonth() === dateMeta.month && value.getFullYear() === dateMeta.year;
        return false;
    };
    var isDateBetween = function isDateBetween(start, end, dateMeta) {
        var between = false;
        if (start && end) {
            var date = new Date(dateMeta.year, dateMeta.month, dateMeta.day);
            return start.getTime() <= date.getTime() && end.getTime() >= date.getTime();
        }
        return between;
    };
    var isSingleSelection = function isSingleSelection() {
        return props.selectionMode === "single";
    };
    var isRangeSelection = function isRangeSelection() {
        return props.selectionMode === "range";
    };
    var isMultipleSelection = function isMultipleSelection() {
        return props.selectionMode === "multiple";
    };
    var isToday = function isToday(today, day, month, year) {
        return today.getDate() === day && today.getMonth() === month && today.getFullYear() === year;
    };
    var isDayDisabled = function isDayDisabled(day, month, year) {
        var isDisabled = false;
        // first check for disabled dates
        if (props.disabledDates) {
            if (props.disabledDates.some(function(d) {
                return d.getFullYear() === year && d.getMonth() === month && d.getDate() === day;
            })) isDisabled = true;
        }
        // next if not disabled then check for disabled days
        if (!isDisabled && props.disabledDays && currentView === "date") {
            var weekday = new Date(year, month, day);
            var weekdayNumber = weekday.getDay();
            if (props.disabledDays.indexOf(weekdayNumber) !== -1) isDisabled = true;
        }
        // last check for enabled dates to force dates enabled
        if (props.enabledDates) {
            var isEnabled = props.enabledDates.some(function(d) {
                return d.getFullYear() === year && d.getMonth() === month && d.getDate() === day;
            });
            if (isEnabled) isDisabled = false;
            else if (!props.disabledDays && !props.disabledDates) // disable other dates when only enabledDates are present
            isDisabled = true;
        }
        return isDisabled;
    };
    var isMonthYearDisabled = function isMonthYearDisabled(month, year) {
        var daysCountInAllMonth = month === -1 ? new Array(12).fill(0).map(function(_, i) {
            return getDaysCountInMonth(i, year);
        }) : [
            getDaysCountInMonth(month, year)
        ];
        for(var i = 0; i < daysCountInAllMonth.length; i++){
            var monthDays = daysCountInAllMonth[i];
            var _month = month === -1 ? i : month;
            for(var day = 1; day <= monthDays; day++){
                var isDateSelectable = isSelectable(day, _month, year);
                if (isDateSelectable) return false;
            }
        }
        return true;
    };
    var updateInputfield = function updateInputfield(value) {
        if (!inputRef.current) return;
        var formattedValue = "";
        if (value) try {
            if (isSingleSelection()) formattedValue = isValidDate(value) ? formatDateTime(value) : props.keepInvalid ? value : "";
            else if (isMultipleSelection()) for(var i = 0; i < value.length; i++){
                var selectedValue = value[i];
                var dateAsString = isValidDate(selectedValue) ? formatDateTime(selectedValue) : "";
                formattedValue = formattedValue + dateAsString;
                if (i !== value.length - 1) formattedValue = formattedValue + ", ";
            }
            else if (isRangeSelection()) {
                if (value && value.length) {
                    var startDate = value[0];
                    var endDate = value[1];
                    formattedValue = isValidDate(startDate) ? formatDateTime(startDate) : "";
                    if (endDate) formattedValue = formattedValue + (isValidDate(endDate) ? " - " + formatDateTime(endDate) : "");
                }
            }
        } catch (err) {
            formattedValue = value;
        }
        inputRef.current.value = formattedValue;
    };
    var formatDateTime = function formatDateTime(date) {
        if (props.formatDateTime) return props.formatDateTime(date);
        var formattedValue = null;
        if (date) {
            if (props.timeOnly) formattedValue = formatTime(date);
            else {
                formattedValue = formatDate(date, getDateFormat());
                if (props.showTime) formattedValue = formattedValue + (" " + formatTime(date));
            }
        }
        return formattedValue;
    };
    var formatDate = function formatDate(date, format) {
        if (!date) return "";
        var iFormat;
        var lookAhead = function lookAhead(match) {
            var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
            if (matches) iFormat++;
            return matches;
        };
        var formatNumber = function formatNumber(match, value, len) {
            var num = "" + value;
            if (lookAhead(match)) while(num.length < len)num = "0" + num;
            return num;
        };
        var formatName = function formatName(match, value, shortNames, longNames) {
            return lookAhead(match) ? longNames[value] : shortNames[value];
        };
        var output = "";
        var literal = false;
        var _localeOptions2 = (0, $8Zwsm.localeOptions)(props.locale), dayNamesShort = _localeOptions2.dayNamesShort, dayNames = _localeOptions2.dayNames, monthNamesShort = _localeOptions2.monthNamesShort, monthNames = _localeOptions2.monthNames;
        if (date) {
            for(iFormat = 0; iFormat < format.length; iFormat++)if (literal) {
                if (format.charAt(iFormat) === "'" && !lookAhead("'")) literal = false;
                else output = output + format.charAt(iFormat);
            } else switch(format.charAt(iFormat)){
                case "d":
                    output = output + formatNumber("d", date.getDate(), 2);
                    break;
                case "D":
                    output = output + formatName("D", date.getDay(), dayNamesShort, dayNames);
                    break;
                case "o":
                    output = output + formatNumber("o", Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000), 3);
                    break;
                case "m":
                    output = output + formatNumber("m", date.getMonth() + 1, 2);
                    break;
                case "M":
                    output = output + formatName("M", date.getMonth(), monthNamesShort, monthNames);
                    break;
                case "y":
                    output = output + (lookAhead("y") ? date.getFullYear() : (date.getFullYear() % 100 < 10 ? "0" : "") + date.getFullYear() % 100);
                    break;
                case "@":
                    output = output + date.getTime();
                    break;
                case "!":
                    output = output + (date.getTime() * 10000 + ticksTo1970);
                    break;
                case "'":
                    if (lookAhead("'")) output = output + "'";
                    else literal = true;
                    break;
                default:
                    output = output + format.charAt(iFormat);
            }
        }
        return output;
    };
    var formatTime = function formatTime(date) {
        if (!date) return "";
        var output = "";
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        var milliseconds = date.getMilliseconds();
        if (props.hourFormat === "12" && hours > 11 && hours !== 12) hours = hours - 12;
        if (props.hourFormat === "12") output = output + (hours === 0 ? 12 : hours < 10 ? "0" + hours : hours);
        else output = output + (hours < 10 ? "0" + hours : hours);
        output = output + ":";
        output = output + (minutes < 10 ? "0" + minutes : minutes);
        if (props.showSeconds) {
            output = output + ":";
            output = output + (seconds < 10 ? "0" + seconds : seconds);
        }
        if (props.showMillisec) {
            output = output + ".";
            output = output + (milliseconds < 100 ? (milliseconds < 10 ? "00" : "0") + milliseconds : milliseconds);
        }
        if (props.hourFormat === "12") output = output + (date.getHours() > 11 ? " PM" : " AM");
        return output;
    };
    var parseValueFromString = function parseValueFromString(text) {
        if (!text || text.trim().length === 0) return null;
        var value;
        if (isSingleSelection()) value = parseDateTime(text);
        else if (isMultipleSelection()) {
            var tokens = text.split(",");
            value = [];
            var _iterator2 = $a54e198ef3baabb4$var$_createForOfIteratorHelper(tokens), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var token = _step2.value;
                    value.push(parseDateTime(token.trim()));
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        } else if (isRangeSelection()) {
            var _tokens = text.split(" - ");
            value = [];
            for(var i = 0; i < _tokens.length; i++)value[i] = parseDateTime(_tokens[i].trim());
        }
        return value;
    };
    var parseDateTime = function parseDateTime(text) {
        if (props.parseDateTime) return props.parseDateTime(text);
        var date;
        var parts = text.split(" ");
        if (props.timeOnly) {
            date = new Date();
            populateTime(date, parts[0], parts[1]);
        } else if (props.showTime) {
            date = parseDate(parts[0], getDateFormat());
            populateTime(date, parts[1], parts[2]);
        } else date = parseDate(text, getDateFormat());
        return date;
    };
    var populateTime = function populateTime(value, timeString, ampm) {
        if (props.hourFormat === "12" && ampm !== "PM" && ampm !== "AM") throw new Error("Invalid Time");
        var time = parseTime(timeString, ampm);
        value.setHours(time.hour);
        value.setMinutes(time.minute);
        value.setSeconds(time.second);
        value.setMilliseconds(time.millisecond);
    };
    var parseTime = function parseTime(value, ampm) {
        value = props.showMillisec ? value.replace(".", ":") : value;
        var tokens = value.split(":");
        var validTokenLength = props.showSeconds ? 3 : 2;
        validTokenLength = props.showMillisec ? validTokenLength + 1 : validTokenLength;
        if (tokens.length !== validTokenLength || tokens[0].length !== 2 || tokens[1].length !== 2 || props.showSeconds && tokens[2].length !== 2 || props.showMillisec && tokens[3].length !== 3) throw new Error("Invalid time");
        var h = parseInt(tokens[0], 10);
        var m = parseInt(tokens[1], 10);
        var s = props.showSeconds ? parseInt(tokens[2], 10) : null;
        var ms = props.showMillisec ? parseInt(tokens[3], 10) : null;
        if (isNaN(h) || isNaN(m) || h > 23 || m > 59 || props.hourFormat === "12" && h > 12 || props.showSeconds && (isNaN(s) || s > 59) || props.showMillisec && (isNaN(s) || s > 1000)) throw new Error("Invalid time");
        else {
            if (props.hourFormat === "12") {
                if (h !== 12 && ampm === "PM") h = h + 12;
                if (h === 12 && ampm === "AM") h = h - 12;
            }
            return {
                hour: h,
                minute: m,
                second: s,
                millisecond: ms
            };
        }
    };
    // Ported from jquery-ui datepicker parseDate
    var parseDate = function parseDate(value, format) {
        if (format == null || value == null) throw new Error("Invalid arguments");
        value = $a54e198ef3baabb4$var$_typeof(value) === "object" ? value.toString() : value + "";
        if (value === "") return null;
        var iFormat;
        var dim;
        var extra;
        var iValue = 0;
        var shortYearCutoff = typeof props.shortYearCutoff !== "string" ? props.shortYearCutoff : new Date().getFullYear() % 100 + parseInt(props.shortYearCutoff, 10);
        var year = -1;
        var month = -1;
        var day = -1;
        var doy = -1;
        var literal = false;
        var date;
        var lookAhead = function lookAhead(match) {
            var matches = iFormat + 1 < format.length && format.charAt(iFormat + 1) === match;
            if (matches) iFormat++;
            return matches;
        };
        var getNumber = function getNumber(match) {
            var isDoubled = lookAhead(match);
            var size = match === "@" ? 14 : match === "!" ? 20 : match === "y" && isDoubled ? 4 : match === "o" ? 3 : 2;
            var minSize = match === "y" ? size : 1;
            var digits = new RegExp("^\\d{" + minSize + "," + size + "}");
            var num = value.substring(iValue).match(digits);
            if (!num) throw new Error("Missing number at position " + iValue);
            iValue = iValue + num[0].length;
            return parseInt(num[0], 10);
        };
        var getName = function getName(match, shortNames, longNames) {
            var index = -1;
            var arr = lookAhead(match) ? longNames : shortNames;
            var names = [];
            for(var i = 0; i < arr.length; i++)names.push([
                i,
                arr[i]
            ]);
            names.sort(function(a, b) {
                return -(a[1].length - b[1].length);
            });
            for(var _i = 0; _i < names.length; _i++){
                var name = names[_i][1];
                if (value.substr(iValue, name.length).toLowerCase() === name.toLowerCase()) {
                    index = names[_i][0];
                    iValue = iValue + name.length;
                    break;
                }
            }
            if (index !== -1) return index + 1;
            throw new Error("Unknown name at position " + iValue);
        };
        var checkLiteral = function checkLiteral() {
            if (value.charAt(iValue) !== format.charAt(iFormat)) throw new Error("Unexpected literal at position " + iValue);
            iValue++;
        };
        if (props.view === "month") day = 1;
        if (props.view === "year") {
            day = 1;
            month = 1;
        }
        var _localeOptions3 = (0, $8Zwsm.localeOptions)(props.locale), dayNamesShort = _localeOptions3.dayNamesShort, dayNames = _localeOptions3.dayNames, monthNamesShort = _localeOptions3.monthNamesShort, monthNames = _localeOptions3.monthNames;
        for(iFormat = 0; iFormat < format.length; iFormat++)if (literal) {
            if (format.charAt(iFormat) === "'" && !lookAhead("'")) literal = false;
            else checkLiteral();
        } else switch(format.charAt(iFormat)){
            case "d":
                day = getNumber("d");
                break;
            case "D":
                getName("D", dayNamesShort, dayNames);
                break;
            case "o":
                doy = getNumber("o");
                break;
            case "m":
                month = getNumber("m");
                break;
            case "M":
                month = getName("M", monthNamesShort, monthNames);
                break;
            case "y":
                year = getNumber("y");
                break;
            case "@":
                date = new Date(getNumber("@"));
                year = date.getFullYear();
                month = date.getMonth() + 1;
                day = date.getDate();
                break;
            case "!":
                date = new Date((getNumber("!") - ticksTo1970) / 10000);
                year = date.getFullYear();
                month = date.getMonth() + 1;
                day = date.getDate();
                break;
            case "'":
                if (lookAhead("'")) checkLiteral();
                else literal = true;
                break;
            default:
                checkLiteral();
        }
        if (iValue < value.length) {
            extra = value.substr(iValue);
            if (!/^\s+/.test(extra)) throw new Error("Extra/unparsed characters found in date: " + extra);
        }
        if (year === -1) year = new Date().getFullYear();
        else if (year < 100) year = year + (new Date().getFullYear() - new Date().getFullYear() % 100 + (year <= shortYearCutoff ? 0 : -100));
        if (doy > -1) {
            month = 1;
            day = doy;
            do {
                dim = getDaysCountInMonth(year, month - 1);
                if (day <= dim) break;
                month++;
                day = day - dim;
            }while (true);
        }
        date = daylightSavingAdjust(new Date(year, month - 1, day));
        if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) throw new Error("Invalid date"); // E.g. 31/02/00
        return date;
    };
    var isInMinYear = function isInMinYear(viewDate) {
        return props.minDate && props.minDate.getFullYear() === viewDate.getFullYear();
    };
    var isInMaxYear = function isInMaxYear(viewDate) {
        return props.maxDate && props.maxDate.getFullYear() === viewDate.getFullYear();
    };
    $81g6h.useEffect(function() {
        (0, $cfkGk.ObjectUtils).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $l2NC0.useMountEffect)(function() {
        var viewDate = getViewDate(props.viewDate);
        validateDate(viewDate);
        setViewDateState(viewDate);
        setCurrentMonth(viewDate.getMonth());
        setCurrentYear(viewDate.getFullYear());
        setCurrentView(props.view);
        if (!idState) {
            var uniqueId = (0, $cfkGk.UniqueComponentId)();
            !idState && setIdState(uniqueId);
        }
        if (props.inline) {
            overlayRef && overlayRef.current.setAttribute(attributeSelector, "");
            if (!props.disabled) {
                initFocusableCell();
                if (props.numberOfMonths === 1) overlayRef.current.style.width = (0, $cfkGk.DomHandler).getOuterWidth(overlayRef.current) + "px";
            }
        }
        if (props.value) {
            updateInputfield(props.value);
            setValue(props.value);
        }
        if (props.autoFocus) // delay showing until rendered so `alignPanel()` method aligns the popup in the right location
        setTimeout(function() {
            return (0, $cfkGk.DomHandler).focus(inputRef.current, props.autoFocus);
        }, 200);
    });
    $81g6h.useEffect(function() {
        // see https://github.com/primefaces/primereact/issues/4030
        onChangeRef.current = props.onChange;
    }, [
        props.onChange
    ]);
    $81g6h.useEffect(function() {
        var unbindMaskEvents = null;
        if (props.mask) unbindMaskEvents = (0, $cfkGk.mask)(inputRef.current, {
            mask: props.mask,
            slotChar: props.maskSlotChar,
            readOnly: props.readOnlyInput || props.disabled,
            onChange: function onChange(e) {
                updateValueOnInput(e.originalEvent, e.value, function() {
                    return false;
                });
            },
            onBlur: function onBlur(e) {
                updateValueOnInput(e, e.target.value);
            }
        }).unbindEvents;
        return function() {
            props.mask && unbindMaskEvents && unbindMaskEvents();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.disabled,
        props.mask,
        props.readOnlyInput
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (viewChangedWithKeyDown.current) setCurrentView(props.view);
        viewChangedWithKeyDown.current = false;
    }, [
        props.view
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        focusToFirstCell();
    }, [
        currentView
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (!props.onViewDateChange && !viewStateChanged.current) setValue(props.value);
        if (props.viewDate) updateViewDate(null, getViewDate(props.viewDate));
    }, [
        props.onViewDateChange,
        props.value,
        props.viewDate
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (overlayVisibleState || props.visible) // Github #5529
        setTimeout(function() {
            alignOverlay();
        });
    }, [
        currentView,
        overlayVisibleState,
        props.visible
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        var newDate = props.value;
        if (previousValue !== newDate) {
            if (!isTypingRef.current) updateInputfield(newDate);
            isTypingRef.current = false;
            // #3516 view date not updated when value set programatically
            if (!newDate) return;
            var viewDate = newDate;
            if (isMultipleSelection()) {
                if (newDate.length) viewDate = newDate[newDate.length - 1];
            } else if (isRangeSelection()) {
                if (newDate.length) {
                    var startDate = newDate[0];
                    var endDate = newDate[1];
                    viewDate = endDate || startDate;
                }
            }
            if (viewDate instanceof Date) {
                validateDate(viewDate);
                setViewDateState(viewDate);
                setCurrentMonth(viewDate.getMonth());
                setCurrentYear(viewDate.getFullYear());
            }
        }
    }, [
        props.value,
        visible
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        updateInputfield(props.value);
    }, [
        props.dateFormat,
        props.hourFormat,
        props.timeOnly,
        props.showSeconds,
        props.showMillisec,
        props.showTime,
        props.locale
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (overlayRef.current) {
            setNavigationState(viewDateState);
            updateFocus();
        }
    });
    (0, $l2NC0.useUnmountEffect)(function() {
        if (touchUIMask.current) {
            disableModality();
            touchUIMask.current = null;
        }
        (0, $cfkGk.ZIndexUtils).clear(overlayRef.current);
    });
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            hide: hide,
            getCurrentDateTime: getCurrentDateTime,
            getViewDate: getViewDate,
            updateViewDate: updateViewDate,
            focus: function focus() {
                return (0, $cfkGk.DomHandler).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getOverlay: function getOverlay() {
                return overlayRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            }
        };
    });
    var setValue = function setValue(propValue) {
        if (Array.isArray(propValue)) propValue = propValue[0];
        var prevPropValue = previousValue;
        if (Array.isArray(prevPropValue)) prevPropValue = prevPropValue[0];
        var viewDate = props.viewDate && isValidDate(props.viewDate) ? props.viewDate : propValue && isValidDate(propValue) ? propValue : new Date();
        if (isClearClicked.current && props.showTime) {
            viewDate.setHours(0, 0, 0);
            isClearClicked.current = false;
        }
        if (!prevPropValue && propValue || propValue && propValue instanceof Date && propValue.getTime() !== prevPropValue.getTime()) validateDate(viewDate);
        setViewDateState(viewDate);
        viewStateChanged.current = true;
    };
    var createBackwardNavigator = function createBackwardNavigator(isVisible) {
        var navigatorProps = isVisible ? {
            onClick: onPrevButtonClick,
            onKeyDown: function onKeyDown(e) {
                return onContainerButtonKeydown(e);
            }
        } : {
            style: {
                visibility: "hidden"
            }
        };
        var previousIconProps = mergeProps({
            className: cx("previousIcon")
        }, ptm("previousIcon"));
        var icon = props.prevIcon || /*#__PURE__*/ $81g6h.createElement((0, $6mIkN.ChevronLeftIcon), previousIconProps);
        var backwardNavigatorIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $a54e198ef3baabb4$var$_objectSpread({}, previousIconProps), {
            props: props
        });
        var _localeOptions4 = (0, $8Zwsm.localeOptions)(props.locale), prevDecade = _localeOptions4.prevDecade, prevYear = _localeOptions4.prevYear, prevMonth = _localeOptions4.prevMonth;
        var previousButtonLabel = currentView === "year" ? prevDecade : currentView === "month" ? prevYear : prevMonth;
        var previousButtonProps = mergeProps($a54e198ef3baabb4$var$_objectSpread({
            type: "button",
            className: cx("previousButton"),
            "aria-label": previousButtonLabel
        }, navigatorProps), ptm("previousButton"));
        return /*#__PURE__*/ $81g6h.createElement("button", $a54e198ef3baabb4$var$_extends({
            ref: previousButton
        }, previousButtonProps), backwardNavigatorIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
    };
    var createForwardNavigator = function createForwardNavigator(isVisible) {
        var navigatorProps = isVisible ? {
            onClick: onNextButtonClick,
            onKeyDown: function onKeyDown(e) {
                return onContainerButtonKeydown(e);
            }
        } : {
            style: {
                visibility: "hidden"
            }
        };
        var nextIconProps = mergeProps({
            className: cx("nextIcon")
        }, ptm("nextIcon"));
        var icon = props.nextIcon || /*#__PURE__*/ $81g6h.createElement((0, $gbrlA.ChevronRightIcon), nextIconProps);
        var forwardNavigatorIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $a54e198ef3baabb4$var$_objectSpread({}, nextIconProps), {
            props: props
        });
        var _localeOptions5 = (0, $8Zwsm.localeOptions)(props.locale), nextDecade = _localeOptions5.nextDecade, nextYear = _localeOptions5.nextYear, nextMonth = _localeOptions5.nextMonth;
        var nextButtonLabel = currentView === "year" ? nextDecade : currentView === "month" ? nextYear : nextMonth;
        var nextButtonProps = mergeProps($a54e198ef3baabb4$var$_objectSpread({
            type: "button",
            className: cx("nextButton"),
            "aria-label": nextButtonLabel
        }, navigatorProps), ptm("nextButton"));
        return /*#__PURE__*/ $81g6h.createElement("button", $a54e198ef3baabb4$var$_extends({
            ref: nextButton
        }, nextButtonProps), forwardNavigatorIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
    };
    var renderMonthsNavigator = function renderMonthsNavigator(index) {
        return props.monthNavigator && props.view !== "month" && (props.numberOfMonths === 1 || index === 0);
    };
    var createTitleMonthElement = function createTitleMonthElement(month, monthIndex) {
        var monthNames = (0, $8Zwsm.localeOption)("monthNames", props.locale);
        if (renderMonthsNavigator(monthIndex)) {
            var viewDate = getViewDate();
            var viewMonth = viewDate.getMonth();
            var displayedMonthOptions = monthNames.map(function(month, index) {
                return (!isInMinYear(viewDate) || index >= props.minDate.getMonth()) && (!isInMaxYear(viewDate) || index <= props.maxDate.getMonth()) ? {
                    label: month,
                    value: index,
                    index: index
                } : null;
            }).filter(function(option) {
                return !!option;
            });
            var displayedMonthNames = displayedMonthOptions.map(function(option) {
                return option.label;
            });
            var selectProps = mergeProps({
                className: cx("select"),
                onChange: function onChange(e) {
                    return onMonthDropdownChange(e, e.target.value);
                },
                value: viewMonth
            }, ptm("select"));
            var _content = /*#__PURE__*/ $81g6h.createElement("select", selectProps, displayedMonthOptions.map(function(option) {
                var optionProps = mergeProps({
                    value: option.value
                }, ptm("option"));
                return /*#__PURE__*/ $81g6h.createElement("option", $a54e198ef3baabb4$var$_extends({}, optionProps, {
                    key: option.label
                }), option.label);
            }));
            if (props.monthNavigatorTemplate) {
                var defaultContentOptions = {
                    onChange: onMonthDropdownChange,
                    className: "p-datepicker-month",
                    value: viewMonth,
                    names: displayedMonthNames,
                    options: displayedMonthOptions,
                    element: _content,
                    props: props
                };
                return (0, $cfkGk.ObjectUtils).getJSXElement(props.monthNavigatorTemplate, defaultContentOptions);
            }
            return _content;
        }
        var monthTitleProps = mergeProps({
            className: cx("monthTitle"),
            onKeyDown: onContainerButtonKeydown,
            "aria-label": (0, $8Zwsm.localeOption)("chooseMonth", props.locale),
            onClick: switchToMonthView,
            disabled: switchViewButtonDisabled()
        }, ptm("monthTitle"));
        return currentView === "date" && /*#__PURE__*/ $81g6h.createElement("button", monthTitleProps, monthNames[month]);
    };
    var createTitleYearElement = function createTitleYearElement(metaYear) {
        var viewDate = getViewDate();
        var viewYear = viewDate.getFullYear();
        var displayYear = props.numberOfMonths > 1 ? metaYear : currentYear;
        if (props.yearNavigator) {
            var _yearOptions2 = [];
            if (props.yearRange) {
                var years = props.yearRange.split(":");
                var yearStart = parseInt(years[0], 10);
                var yearEnd = parseInt(years[1], 10);
                for(var i = yearStart; i <= yearEnd; i++)_yearOptions2.push(i);
            } else {
                var base = viewYear - viewYear % 10;
                for(var _i2 = 0; _i2 < 10; _i2++)_yearOptions2.push(base + _i2);
            }
            var displayedYearNames = _yearOptions2.filter(function(year) {
                return !(props.minDate && props.minDate.getFullYear() > year) && !(props.maxDate && props.maxDate.getFullYear() < year);
            });
            var selectProps = mergeProps({
                className: cx("select"),
                onChange: function onChange(e) {
                    return onYearDropdownChange(e, e.target.value);
                },
                value: displayYear
            }, ptm("select"));
            var _content2 = /*#__PURE__*/ $81g6h.createElement("select", selectProps, displayedYearNames.map(function(year) {
                var optionProps = mergeProps({
                    value: year
                }, ptm("option"));
                return /*#__PURE__*/ $81g6h.createElement("option", $a54e198ef3baabb4$var$_extends({}, optionProps, {
                    key: year
                }), year);
            }));
            if (props.yearNavigatorTemplate) {
                var options = displayedYearNames.map(function(name, i) {
                    return {
                        label: name,
                        value: name,
                        index: i
                    };
                });
                var defaultContentOptions = {
                    onChange: onYearDropdownChange,
                    className: "p-datepicker-year",
                    value: viewYear,
                    names: displayedYearNames,
                    options: options,
                    element: _content2,
                    props: props
                };
                return (0, $cfkGk.ObjectUtils).getJSXElement(props.yearNavigatorTemplate, defaultContentOptions);
            }
            return _content2;
        }
        var yearTitleProps = mergeProps({
            className: cx("yearTitle"),
            "aria-label": (0, $8Zwsm.localeOption)("chooseYear", props.locale),
            onClick: function onClick(e) {
                return switchToYearView(e);
            },
            disabled: switchViewButtonDisabled()
        }, ptm("yearTitle"));
        return currentView !== "year" && /*#__PURE__*/ $81g6h.createElement("button", yearTitleProps, displayYear);
    };
    var createTitleDecadeElement = function createTitleDecadeElement() {
        var years = yearPickerValues();
        var decadeTitleProps = mergeProps({
            className: cx("decadeTitle")
        }, ptm("decadeTitle"));
        if (currentView === "year") {
            var decadeTitleTextProps = mergeProps(ptm("decadeTitleText"));
            return /*#__PURE__*/ $81g6h.createElement("span", decadeTitleProps, props.decadeTemplate ? props.decadeTemplate(years) : /*#__PURE__*/ $81g6h.createElement("span", decadeTitleTextProps, "".concat(yearPickerValues()[0], " - ").concat(yearPickerValues()[yearPickerValues().length - 1])));
        }
        return null;
    };
    var createTitle = function createTitle(monthMetaData, index) {
        var month = createTitleMonthElement(monthMetaData.month, index);
        var year = createTitleYearElement(monthMetaData.year);
        var decade = createTitleDecadeElement();
        var titleProps = mergeProps({
            className: cx("title")
        }, ptm("title"));
        var showMonthAfterYear = (0, $8Zwsm.localeOption)("showMonthAfterYear", props.locale);
        return /*#__PURE__*/ $81g6h.createElement("div", titleProps, showMonthAfterYear ? year : month, showMonthAfterYear ? month : year, decade);
    };
    var createDayNames = function createDayNames(weekDays) {
        var weekDayProps = mergeProps(ptm("weekDay"));
        var tableHeaderCellProps = mergeProps({
            scope: "col"
        }, ptm("tableHeaderCell"));
        var dayNames = weekDays.map(function(weekDay, index) {
            return /*#__PURE__*/ $81g6h.createElement("th", $a54e198ef3baabb4$var$_extends({}, tableHeaderCellProps, {
                key: "".concat(weekDay, "-").concat(index)
            }), /*#__PURE__*/ $81g6h.createElement("span", weekDayProps, weekDay));
        });
        if (props.showWeek) {
            var weekHeaderProps = mergeProps({
                scope: "col",
                className: cx("weekHeader"),
                "data-p-disabled": props.showWeek
            }, ptm("weekHeader", {
                context: {
                    disabled: props.showWeek
                }
            }));
            var weekLabel = mergeProps(ptm("weekLabel"));
            var weekHeader = /*#__PURE__*/ $81g6h.createElement("th", $a54e198ef3baabb4$var$_extends({}, weekHeaderProps, {
                key: "wn"
            }), /*#__PURE__*/ $81g6h.createElement("span", weekLabel, (0, $8Zwsm.localeOption)("weekHeader", props.locale)));
            return [
                weekHeader
            ].concat($a54e198ef3baabb4$var$_toConsumableArray(dayNames));
        }
        return dayNames;
    };
    var createDateCellContent = function createDateCellContent(date, className, groupIndex) {
        var content = props.dateTemplate ? props.dateTemplate(date) : date.day;
        var selected = isSelected(date);
        var dayLabelProps = mergeProps({
            className: cx("dayLabel", {
                className: className
            }),
            "aria-selected": selected,
            "aria-disabled": !date.selectable,
            onClick: function onClick(e) {
                return onDateSelect(e, date);
            },
            onKeyDown: function onKeyDown(e) {
                return onDateCellKeydown(e, date, groupIndex);
            },
            "data-p-highlight": selected,
            "data-p-disabled": !date.selectable
        }, ptm("dayLabel", {
            context: {
                selected: selected,
                disabled: !date.selectable
            }
        }));
        return /*#__PURE__*/ $81g6h.createElement("span", dayLabelProps, content, selected && /*#__PURE__*/ $81g6h.createElement("div", {
            "aria-live": "polite",
            className: "p-hidden-accessible",
            "data-p-hidden-accessible": true,
            pt: ptm("hiddenSelectedDay")
        }));
    };
    var createWeek = function createWeek(weekDates, weekNumber, groupIndex) {
        var week = weekDates.map(function(date) {
            var selected = isSelected(date);
            var dateClassName = (0, $cfkGk.classNames)({
                "p-highlight": selected,
                "p-disabled": !date.selectable
            });
            var content = date.otherMonth && !props.showOtherMonths ? null : createDateCellContent(date, dateClassName, groupIndex);
            var dayProps = mergeProps({
                className: cx("day", {
                    date: date
                }),
                "aria-label": date.day,
                "data-p-today": date.today,
                "data-p-other-month": date.otherMonth
            }, ptm("day", {
                context: {
                    date: date,
                    today: date.today,
                    otherMonth: date.otherMonth
                }
            }));
            return /*#__PURE__*/ $81g6h.createElement("td", $a54e198ef3baabb4$var$_extends({}, dayProps, {
                key: date.day
            }), content);
        });
        if (props.showWeek) {
            var weekNumberProps = mergeProps({
                className: cx("weekNumber")
            }, ptm("weekNumber"));
            var weekLabelContainerProps = mergeProps({
                className: cx("weekLabelContainer"),
                "data-p-disabled": props.showWeek
            }, ptm("weekLabelContainer", {
                context: {
                    disabled: props.showWeek
                }
            }));
            var weekNumberCell = /*#__PURE__*/ $81g6h.createElement("td", $a54e198ef3baabb4$var$_extends({}, weekNumberProps, {
                key: "wn" + weekNumber
            }), /*#__PURE__*/ $81g6h.createElement("span", weekLabelContainerProps, weekNumber));
            return [
                weekNumberCell
            ].concat($a54e198ef3baabb4$var$_toConsumableArray(week));
        }
        return week;
    };
    var createDates = function createDates(monthMetaData, groupIndex) {
        var tableBodyRowProps = mergeProps(ptm("tableBodyRowProps"));
        return monthMetaData.dates.map(function(weekDates, index) {
            return /*#__PURE__*/ $81g6h.createElement("tr", $a54e198ef3baabb4$var$_extends({}, tableBodyRowProps, {
                key: index
            }), createWeek(weekDates, monthMetaData.weekNumbers[index], groupIndex));
        });
    };
    var createDateViewGrid = function createDateViewGrid(monthMetaData, weekDays, groupIndex) {
        var dayNames = createDayNames(weekDays);
        var dates = createDates(monthMetaData, groupIndex);
        var containerProps = mergeProps({
            className: cx("container"),
            key: (0, $cfkGk.UniqueComponentId)("calendar_container_")
        }, ptm("container"));
        var tableProps = mergeProps({
            role: "grid",
            className: cx("table")
        }, ptm("table"));
        var tableHeaderProps = mergeProps(ptm("tableHeader"));
        var tableHeaderRowProps = mergeProps(ptm("tableHeaderRow"));
        var tableBodyProps = mergeProps(ptm("tableBody"));
        return currentView === "date" && /*#__PURE__*/ $81g6h.createElement("div", containerProps, /*#__PURE__*/ $81g6h.createElement("table", tableProps, /*#__PURE__*/ $81g6h.createElement("thead", tableHeaderProps, /*#__PURE__*/ $81g6h.createElement("tr", tableHeaderRowProps, dayNames)), /*#__PURE__*/ $81g6h.createElement("tbody", tableBodyProps, dates)));
    };
    var createMonth = function createMonth(monthMetaData, index) {
        var weekDays = createWeekDaysMeta();
        var backwardNavigator = createBackwardNavigator(index === 0);
        var forwardNavigator = createForwardNavigator(props.numberOfMonths === 1 || index === props.numberOfMonths - 1);
        var title = createTitle(monthMetaData, index);
        var dateViewGrid = createDateViewGrid(monthMetaData, weekDays, index);
        var header = props.headerTemplate ? props.headerTemplate() : null;
        var monthKey = monthMetaData.month + "-" + monthMetaData.year;
        var groupProps = mergeProps({
            className: cx("group")
        }, ptm("group"));
        var headerProps = mergeProps({
            className: cx("header"),
            key: index
        }, ptm("header"));
        return /*#__PURE__*/ $81g6h.createElement("div", $a54e198ef3baabb4$var$_extends({}, groupProps, {
            key: monthKey
        }), /*#__PURE__*/ $81g6h.createElement("div", headerProps, header, backwardNavigator, title, forwardNavigator), dateViewGrid);
    };
    var createMonths = function createMonths(monthsMetaData) {
        var groups = monthsMetaData.map(createMonth);
        var groupContainerProps = mergeProps({
            className: cx("groupContainer")
        }, ptm("groupContainer"));
        return /*#__PURE__*/ $81g6h.createElement("div", groupContainerProps, groups);
    };
    var createDateView = function createDateView() {
        var viewDate = getViewDate();
        var monthsMetaData = createMonthsMeta(viewDate.getMonth(), viewDate.getFullYear());
        var months = createMonths(monthsMetaData);
        return months;
    };
    var monthPickerValues = function monthPickerValues() {
        var monthPickerValues = [];
        var monthNamesShort = (0, $8Zwsm.localeOption)("monthNamesShort", props.locale);
        for(var i = 0; i <= 11; i++)monthPickerValues.push(monthNamesShort[i]);
        return monthPickerValues;
    };
    var yearPickerValues = function yearPickerValues() {
        var yearPickerValues = [];
        var base = currentYear - currentYear % 10;
        for(var i = 0; i < 10; i++)yearPickerValues.push(base + i);
        return yearPickerValues;
    };
    var createMonthYearView = function createMonthYearView() {
        var backwardNavigator = createBackwardNavigator(true);
        var forwardNavigator = createForwardNavigator(true);
        var yearElement = createTitleYearElement(getViewDate().getFullYear());
        var decade = createTitleDecadeElement();
        var groupContainerProps = mergeProps({
            className: cx("groupContainer")
        }, ptm("groupContainer"));
        var groupProps = mergeProps({
            className: cx("group")
        }, ptm("group"));
        var headerProps = mergeProps({
            className: cx("header")
        }, ptm("header"));
        var titleProps = mergeProps({
            className: cx("title")
        }, ptm("title"));
        return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("div", groupContainerProps, /*#__PURE__*/ $81g6h.createElement("div", groupProps, /*#__PURE__*/ $81g6h.createElement("div", headerProps, backwardNavigator, /*#__PURE__*/ $81g6h.createElement("div", titleProps, yearElement, decade), forwardNavigator))));
    };
    var createDatePicker = function createDatePicker() {
        if (!props.timeOnly) {
            if (props.view === "date") return createDateView();
            return createMonthYearView();
        }
        return null;
    };
    var incrementIconProps = mergeProps(ptm("incrementIcon"));
    var decrementIconProps = mergeProps(ptm("decrementIcon"));
    var incrementIcon = (0, $cfkGk.IconUtils).getJSXIcon(props.incrementIcon || /*#__PURE__*/ $81g6h.createElement((0, $5jNNK.ChevronUpIcon), incrementIconProps), $a54e198ef3baabb4$var$_objectSpread({}, incrementIconProps), {
        props: props
    });
    var decrementIcon = (0, $cfkGk.IconUtils).getJSXIcon(props.decrementIcon || /*#__PURE__*/ $81g6h.createElement((0, $jhJol.ChevronDownIcon), decrementIconProps), $a54e198ef3baabb4$var$_objectSpread({}, decrementIconProps), {
        props: props
    });
    var createHourPicker = function createHourPicker() {
        var currentTime = getCurrentDateTime();
        var minute = doStepMinute(currentTime.getMinutes());
        var hour = currentTime.getHours();
        // #3770 account for step minutes rolling to next hour
        hour = minute > 59 ? hour + 1 : hour;
        if (props.hourFormat === "12") {
            if (hour === 0) hour = 12;
            else if (hour > 11 && hour !== 12) hour = hour - 12;
        }
        var hourProps = mergeProps(ptm("hour"));
        var _localeOptions6 = (0, $8Zwsm.localeOptions)(props.locale), nextHour = _localeOptions6.nextHour, prevHour = _localeOptions6.prevHour;
        var hourDisplay = hour < 10 ? "0" + hour : hour;
        var hourPickerProps = mergeProps({
            className: cx("hourPicker")
        }, ptm("hourPicker"));
        var incrementButtonProps = mergeProps({
            type: "button",
            className: cx("incrementButton"),
            "aria-label": nextHour,
            onMouseDown: function onMouseDown(e) {
                return onTimePickerElementMouseDown(e, 0, 1);
            },
            onMouseUp: onTimePickerElementMouseUp,
            onMouseLeave: onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
                return onPickerKeyDown(e, 0, 1);
            },
            onKeyUp: onPickerKeyUp
        }, ptm("incrementButton"));
        var decrementButtonProps = mergeProps({
            type: "button",
            className: cx("decrementButton"),
            "aria-label": prevHour,
            onMouseDown: function onMouseDown(e) {
                return onTimePickerElementMouseDown(e, 0, -1);
            },
            onMouseUp: onTimePickerElementMouseUp,
            onMouseLeave: onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
                return onPickerKeyDown(e, 0, -1);
            },
            onKeyUp: onPickerKeyUp
        }, ptm("decrementButton"));
        return /*#__PURE__*/ $81g6h.createElement("div", hourPickerProps, /*#__PURE__*/ $81g6h.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null)), /*#__PURE__*/ $81g6h.createElement("span", hourProps, hourDisplay), /*#__PURE__*/ $81g6h.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null)));
    };
    var createMinutePicker = function createMinutePicker() {
        var currentTime = getCurrentDateTime();
        var minute = doStepMinute(currentTime.getMinutes());
        minute = minute > 59 ? minute - 60 : minute;
        var minuteProps = mergeProps(ptm("minute"));
        var _localeOptions7 = (0, $8Zwsm.localeOptions)(props.locale), nextMinute = _localeOptions7.nextMinute, prevMinute = _localeOptions7.prevMinute;
        var minuteDisplay = minute < 10 ? "0" + minute : minute;
        var minutePickerProps = mergeProps({
            className: cx("minutePicker")
        }, ptm("minutePicker"));
        var incrementButtonProps = mergeProps({
            type: "button",
            className: cx("incrementButton"),
            "aria-label": nextMinute,
            onMouseDown: function onMouseDown(e) {
                return onTimePickerElementMouseDown(e, 1, 1);
            },
            onMouseUp: onTimePickerElementMouseUp,
            onMouseLeave: onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
                return onPickerKeyDown(e, 1, 1);
            },
            onKeyUp: onPickerKeyUp
        }, ptm("incrementButton"));
        var decrementButtonProps = mergeProps({
            type: "button",
            className: cx("decrementButton"),
            "aria-label": prevMinute,
            onMouseDown: function onMouseDown(e) {
                return onTimePickerElementMouseDown(e, 1, -1);
            },
            onMouseUp: onTimePickerElementMouseUp,
            onMouseLeave: onTimePickerElementMouseLeave,
            onKeyDown: function onKeyDown(e) {
                return onPickerKeyDown(e, 1, -1);
            },
            onKeyUp: onPickerKeyUp
        }, ptm("decrementButton"));
        return /*#__PURE__*/ $81g6h.createElement("div", minutePickerProps, /*#__PURE__*/ $81g6h.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null)), /*#__PURE__*/ $81g6h.createElement("span", minuteProps, minuteDisplay), /*#__PURE__*/ $81g6h.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null)));
    };
    var createSecondPicker = function createSecondPicker() {
        if (props.showSeconds) {
            var currentTime = getCurrentDateTime();
            var _localeOptions8 = (0, $8Zwsm.localeOptions)(props.locale), nextSecond = _localeOptions8.nextSecond, prevSecond = _localeOptions8.prevSecond;
            var secondProps = mergeProps(ptm("second"));
            var second = currentTime.getSeconds();
            var secondDisplay = second < 10 ? "0" + second : second;
            var secondPickerProps = mergeProps({
                className: cx("secondPicker")
            }, ptm("secondPicker"));
            var incrementButtonProps = mergeProps({
                type: "button",
                className: cx("incrementButton"),
                "aria-label": nextSecond,
                onMouseDown: function onMouseDown(e) {
                    return onTimePickerElementMouseDown(e, 2, 1);
                },
                onMouseUp: onTimePickerElementMouseUp,
                onMouseLeave: onTimePickerElementMouseLeave,
                onKeyDown: function onKeyDown(e) {
                    return onPickerKeyDown(e, 2, 1);
                },
                onKeyUp: onPickerKeyUp
            }, ptm("incrementButton"));
            var decrementButtonProps = mergeProps({
                type: "button",
                className: cx("decrementButton"),
                "aria-label": prevSecond,
                onMouseDown: function onMouseDown(e) {
                    return onTimePickerElementMouseDown(e, 2, -1);
                },
                onMouseUp: onTimePickerElementMouseUp,
                onMouseLeave: onTimePickerElementMouseLeave,
                onKeyDown: function onKeyDown(e) {
                    return onPickerKeyDown(e, 2, -1);
                },
                onKeyUp: onPickerKeyUp
            }, ptm("decrementButton"));
            return /*#__PURE__*/ $81g6h.createElement("div", secondPickerProps, /*#__PURE__*/ $81g6h.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null)), /*#__PURE__*/ $81g6h.createElement("span", secondProps, secondDisplay), /*#__PURE__*/ $81g6h.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null)));
        }
        return null;
    };
    var createMiliSecondPicker = function createMiliSecondPicker() {
        if (props.showMillisec) {
            var currentTime = getCurrentDateTime();
            var _localeOptions9 = (0, $8Zwsm.localeOptions)(props.locale), nextMilliSecond = _localeOptions9.nextMilliSecond, prevMilliSecond = _localeOptions9.prevMilliSecond;
            var millisecondProps = mergeProps(ptm("millisecond"));
            var millisecond = currentTime.getMilliseconds();
            var millisecondDisplay = millisecond < 100 ? (millisecond < 10 ? "00" : "0") + millisecond : millisecond;
            var millisecondPickerProps = mergeProps({
                className: cx("millisecondPicker")
            }, ptm("millisecondPicker"));
            var incrementButtonProps = mergeProps({
                type: "button",
                className: cx("incrementButton"),
                "aria-label": nextMilliSecond,
                onMouseDown: function onMouseDown(e) {
                    return onTimePickerElementMouseDown(e, 3, 1);
                },
                onMouseUp: onTimePickerElementMouseUp,
                onMouseLeave: onTimePickerElementMouseLeave,
                onKeyDown: function onKeyDown(e) {
                    return onPickerKeyDown(e, 3, 1);
                },
                onKeyUp: onPickerKeyUp
            }, ptm("incrementButton"));
            var decrementButtonProps = mergeProps({
                type: "button",
                className: cx("decrementButton"),
                "aria-label": prevMilliSecond,
                onMouseDown: function onMouseDown(e) {
                    return onTimePickerElementMouseDown(e, 3, -1);
                },
                onMouseUp: onTimePickerElementMouseUp,
                onMouseLeave: onTimePickerElementMouseLeave,
                onKeyDown: function onKeyDown(e) {
                    return onPickerKeyDown(e, 3, -1);
                },
                onKeyUp: onPickerKeyUp
            }, ptm("decrementButton"));
            return /*#__PURE__*/ $81g6h.createElement("div", millisecondPickerProps, /*#__PURE__*/ $81g6h.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null)), /*#__PURE__*/ $81g6h.createElement("span", millisecondProps, millisecondDisplay), /*#__PURE__*/ $81g6h.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null)));
        }
        return null;
    };
    var createAmPmPicker = function createAmPmPicker() {
        if (props.hourFormat === "12") {
            var currentTime = getCurrentDateTime();
            var _localeOptions10 = (0, $8Zwsm.localeOptions)(props.locale), am = _localeOptions10.am, pm = _localeOptions10.pm;
            var hour = currentTime.getHours();
            var display = hour > 11 ? "PM" : "AM";
            var ampmProps = mergeProps(ptm("ampm"));
            var ampmPickerProps = mergeProps({
                className: cx("ampmPicker")
            }, ptm("ampmPicker"));
            var incrementButtonProps = mergeProps({
                type: "button",
                className: cx("incrementButton"),
                "aria-label": am,
                onClick: function onClick(e) {
                    return toggleAmPm(e);
                }
            }, ptm("incrementButton"));
            var decrementButtonProps = mergeProps({
                type: "button",
                className: cx("decrementButton"),
                "aria-label": pm,
                onClick: function onClick(e) {
                    return toggleAmPm(e);
                }
            }, ptm("decrementButton"));
            return /*#__PURE__*/ $81g6h.createElement("div", ampmPickerProps, /*#__PURE__*/ $81g6h.createElement("button", incrementButtonProps, incrementIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null)), /*#__PURE__*/ $81g6h.createElement("span", ampmProps, display), /*#__PURE__*/ $81g6h.createElement("button", decrementButtonProps, decrementIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null)));
        }
        return null;
    };
    var createSeparator = function createSeparator(separator) {
        var separatorContainerProps = mergeProps({
            className: cx("separatorContainer")
        }, ptm("separatorContainer"));
        var separatorProps = mergeProps(ptm("separator"));
        return /*#__PURE__*/ $81g6h.createElement("div", separatorContainerProps, /*#__PURE__*/ $81g6h.createElement("span", separatorProps, separator));
    };
    var createTimePicker = function createTimePicker() {
        if ((props.showTime || props.timeOnly) && currentView === "date") {
            var timePickerProps = mergeProps({
                className: cx("timePicker")
            }, ptm("timePicker"));
            return /*#__PURE__*/ $81g6h.createElement("div", timePickerProps, createHourPicker(), createSeparator(":"), createMinutePicker(), props.showSeconds && createSeparator(":"), createSecondPicker(), props.showMillisec && createSeparator("."), createMiliSecondPicker(), props.hourFormat === "12" && createSeparator(":"), createAmPmPicker());
        }
        return null;
    };
    var createInputElement = function createInputElement() {
        if (!props.inline) return /*#__PURE__*/ $81g6h.createElement((0, $6ccvc.InputText), {
            ref: inputRef,
            id: props.inputId,
            name: props.name,
            type: "text",
            role: "combobox",
            className: (0, $cfkGk.classNames)(props.inputClassName, cx("input", {
                context: context
            })),
            style: props.inputStyle,
            readOnly: props.readOnlyInput,
            disabled: props.disabled,
            required: props.required,
            autoComplete: "off",
            placeholder: props.placeholder,
            tabIndex: props.tabIndex,
            onInput: onUserInput,
            onFocus: onInputFocus,
            onBlur: onInputBlur,
            onKeyDown: onInputKeyDown,
            "aria-expanded": overlayVisibleState,
            "aria-autocomplete": "none",
            "aria-haspopup": "dialog",
            "aria-controls": panelId,
            "aria-labelledby": props.ariaLabelledBy,
            "aria-label": props.ariaLabel,
            inputMode: props.inputMode,
            tooltip: props.tooltip,
            tooltipOptions: props.tooltipOptions,
            pt: ptm("input"),
            __parentMetadata: {
                parent: metaData
            }
        });
        return null;
    };
    var createButton = function createButton() {
        if (props.showIcon) return /*#__PURE__*/ $81g6h.createElement((0, $9AWgp.Button), {
            type: "button",
            icon: props.icon || /*#__PURE__*/ $81g6h.createElement((0, $jN2y8.CalendarIcon), null),
            onClick: onButtonClick,
            tabIndex: "-1",
            disabled: props.disabled,
            "aria-haspopup": "dialog",
            "aria-label": (0, $8Zwsm.localeOption)("chooseDate", props.locale),
            "aria-expanded": overlayVisibleState,
            "aria-controls": panelId,
            className: cx("dropdownButton"),
            pt: ptm("dropdownButton"),
            __parentMetadata: {
                parent: metaData
            }
        });
        return null;
    };
    var createContent = function createContent() {
        var input = createInputElement();
        var button = createButton();
        if (props.iconPos === "left") return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, button, input);
        return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, input, button);
    };
    var createButtonBar = function createButtonBar() {
        if (props.showButtonBar) {
            var _localeOptions11 = (0, $8Zwsm.localeOptions)(props.locale), today = _localeOptions11.today, clear = _localeOptions11.clear, now = _localeOptions11.now;
            var nowDate = new Date();
            var isHidden = props.minDate && props.minDate > nowDate || props.maxDate && props.maxDate < nowDate;
            var buttonbarProps = mergeProps({
                className: cx("buttonbar")
            }, ptm("buttonbar"));
            return /*#__PURE__*/ $81g6h.createElement("div", buttonbarProps, /*#__PURE__*/ $81g6h.createElement((0, $9AWgp.Button), {
                type: "button",
                label: props.showTime ? now : today,
                onClick: onTodayButtonClick,
                onKeyDown: function onKeyDown(e) {
                    return onContainerButtonKeydown(e);
                },
                className: (0, $cfkGk.classNames)(props.todayButtonClassName, cx("todayButton")),
                pt: ptm("todayButton"),
                style: isHidden ? {
                    visibility: "hidden"
                } : undefined
            }), /*#__PURE__*/ $81g6h.createElement((0, $9AWgp.Button), {
                type: "button",
                label: clear,
                onClick: onClearButtonClick,
                onKeyDown: function onKeyDown(e) {
                    return onContainerButtonKeydown(e);
                },
                className: (0, $cfkGk.classNames)(props.clearButtonClassName, cx("clearButton")),
                pt: ptm("clearButton")
            }));
        }
        return null;
    };
    var createFooter = function createFooter() {
        if (props.footerTemplate) {
            var _content3 = props.footerTemplate();
            var footerProps = mergeProps({
                className: cx("footer")
            }, ptm("footer"));
            return /*#__PURE__*/ $81g6h.createElement("div", footerProps, _content3);
        }
        return null;
    };
    var createMonthPicker = function createMonthPicker() {
        if (currentView === "month") {
            var monthPickerProps = mergeProps({
                className: cx("monthPicker")
            }, ptm("monthPicker"));
            return /*#__PURE__*/ $81g6h.createElement("div", monthPickerProps, monthPickerValues().map(function(m, i) {
                var selected = isMonthSelected(i);
                var monthProps = mergeProps({
                    className: cx("month", {
                        isMonthSelected: isMonthSelected,
                        isMonthYearDisabled: isMonthYearDisabled,
                        i: i,
                        currentYear: currentYear
                    }),
                    onClick: function onClick(event) {
                        return onMonthSelect(event, i);
                    },
                    onKeyDown: function onKeyDown(event) {
                        return onMonthCellKeydown(event, i);
                    },
                    "data-p-disabled": isMonthYearDisabled(i, currentYear),
                    "data-p-highlight": selected
                }, ptm("month", {
                    context: {
                        month: m,
                        monthIndex: i,
                        selected: selected,
                        disabled: isMonthYearDisabled(i, currentYear)
                    }
                }));
                return /*#__PURE__*/ $81g6h.createElement("span", $a54e198ef3baabb4$var$_extends({}, monthProps, {
                    key: "month".concat(i + 1)
                }), m, selected && /*#__PURE__*/ $81g6h.createElement("div", {
                    "aria-live": "polite",
                    className: "p-hidden-accessible",
                    "data-p-hidden-accessible": true,
                    pt: ptm("hiddenMonth")
                }, m));
            }));
        }
        return null;
    };
    var createYearPicker = function createYearPicker() {
        if (currentView === "year") {
            var yearPickerProps = mergeProps({
                className: cx("yearPicker")
            }, ptm("yearPicker"));
            return /*#__PURE__*/ $81g6h.createElement("div", yearPickerProps, yearPickerValues().map(function(y, i) {
                var selected = isYearSelected(y);
                var yearProps = mergeProps({
                    className: cx("year", {
                        isYearSelected: isYearSelected,
                        isMonthYearDisabled: isMonthYearDisabled,
                        y: y
                    }),
                    onClick: function onClick(event) {
                        return onYearSelect(event, y);
                    },
                    onKeyDown: function onKeyDown(event) {
                        return onYearCellKeydown(event, y);
                    },
                    "data-p-highlight": isYearSelected(y),
                    "data-p-disabled": isMonthYearDisabled(-1, y)
                }, ptm("year", {
                    context: {
                        year: y,
                        yearIndex: i,
                        selected: selected,
                        disabled: isMonthYearDisabled(-1, y)
                    }
                }));
                return /*#__PURE__*/ $81g6h.createElement("span", $a54e198ef3baabb4$var$_extends({}, yearProps, {
                    key: "year".concat(i + 1)
                }), y, selected && /*#__PURE__*/ $81g6h.createElement("div", {
                    "aria-live": "polite",
                    className: "p-hidden-accessible",
                    "data-p-hidden-accessible": true,
                    pt: ptm("hiddenYear")
                }, y));
            }));
        }
        return null;
    };
    var panelClassName = (0, $cfkGk.classNames)("p-datepicker p-component", props.panelClassName, {
        "p-datepicker-inline": props.inline,
        "p-disabled": props.disabled,
        "p-datepicker-timeonly": props.timeOnly,
        "p-datepicker-multiple-month": props.numberOfMonths > 1,
        "p-datepicker-monthpicker": currentView === "month",
        "p-datepicker-touch-ui": props.touchUI,
        "p-input-filled": context && context.inputStyle === "filled" || (0, $8Zwsm.default).inputStyle === "filled",
        "p-ripple-disabled": context && context.ripple === false || (0, $8Zwsm.default).ripple === false
    });
    var content = createContent();
    var datePicker = createDatePicker();
    var timePicker = createTimePicker();
    var buttonBar = createButtonBar();
    var footer = createFooter();
    var monthPicker = createMonthPicker();
    var yearPicker = createYearPicker();
    var isFilled = (0, $cfkGk.DomHandler).hasClass(inputRef.current, "p-filled") && inputRef.current.value !== "";
    var rootProps = mergeProps({
        id: props.id,
        className: (0, $cfkGk.classNames)(props.className, cx("root", {
            focusedState: focusedState,
            isFilled: isFilled,
            panelVisible: visible
        })),
        style: props.style
    }, $a54e198ef3baabb4$var$CalendarBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $81g6h.createElement("span", $a54e198ef3baabb4$var$_extends({
        ref: elementRef
    }, rootProps), content, /*#__PURE__*/ $81g6h.createElement($a54e198ef3baabb4$var$CalendarPanel, {
        hostName: "Calendar",
        id: panelId,
        locale: props.locale,
        ref: overlayRef,
        className: panelClassName,
        style: props.panelStyle,
        appendTo: props.appendTo,
        inline: props.inline,
        onClick: onPanelClick,
        onMouseUp: onPanelMouseUp,
        "in": visible,
        onEnter: onOverlayEnter,
        onEntered: onOverlayEntered,
        onExit: onOverlayExit,
        onExited: onOverlayExited,
        transitionOptions: props.transitionOptions,
        ptm: ptm,
        cx: cx
    }, datePicker, timePicker, monthPicker, yearPicker, buttonBar, footer));
}));
$a54e198ef3baabb4$export$e1aef45b828286de.displayName = "Calendar";

});
parcelRegister("jN2y8", function(module, exports) {

$parcel$export(module.exports, "CalendarIcon", () => $e68492331bf5af8a$export$5fda1783bb83f57b);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $e68492331bf5af8a$var$_extends() {
    $e68492331bf5af8a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e68492331bf5af8a$var$_extends.apply(this, arguments);
}
var $e68492331bf5af8a$export$5fda1783bb83f57b = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $e68492331bf5af8a$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M10.7838 1.51351H9.83783V0.567568C9.83783 0.417039 9.77804 0.272676 9.6716 0.166237C9.56516 0.0597971 9.42079 0 9.27027 0C9.11974 0 8.97538 0.0597971 8.86894 0.166237C8.7625 0.272676 8.7027 0.417039 8.7027 0.567568V1.51351H5.29729V0.567568C5.29729 0.417039 5.2375 0.272676 5.13106 0.166237C5.02462 0.0597971 4.88025 0 4.72973 0C4.5792 0 4.43484 0.0597971 4.3284 0.166237C4.22196 0.272676 4.16216 0.417039 4.16216 0.567568V1.51351H3.21621C2.66428 1.51351 2.13494 1.73277 1.74467 2.12305C1.35439 2.51333 1.13513 3.04266 1.13513 3.59459V11.9189C1.13513 12.4709 1.35439 13.0002 1.74467 13.3905C2.13494 13.7807 2.66428 14 3.21621 14H10.7838C11.3357 14 11.865 13.7807 12.2553 13.3905C12.6456 13.0002 12.8649 12.4709 12.8649 11.9189V3.59459C12.8649 3.04266 12.6456 2.51333 12.2553 2.12305C11.865 1.73277 11.3357 1.51351 10.7838 1.51351ZM3.21621 2.64865H4.16216V3.59459C4.16216 3.74512 4.22196 3.88949 4.3284 3.99593C4.43484 4.10237 4.5792 4.16216 4.72973 4.16216C4.88025 4.16216 5.02462 4.10237 5.13106 3.99593C5.2375 3.88949 5.29729 3.74512 5.29729 3.59459V2.64865H8.7027V3.59459C8.7027 3.74512 8.7625 3.88949 8.86894 3.99593C8.97538 4.10237 9.11974 4.16216 9.27027 4.16216C9.42079 4.16216 9.56516 4.10237 9.6716 3.99593C9.77804 3.88949 9.83783 3.74512 9.83783 3.59459V2.64865H10.7838C11.0347 2.64865 11.2753 2.74831 11.4527 2.92571C11.6301 3.10311 11.7297 3.34371 11.7297 3.59459V5.67568H2.27027V3.59459C2.27027 3.34371 2.36993 3.10311 2.54733 2.92571C2.72473 2.74831 2.96533 2.64865 3.21621 2.64865ZM10.7838 12.8649H3.21621C2.96533 12.8649 2.72473 12.7652 2.54733 12.5878C2.36993 12.4104 2.27027 12.1698 2.27027 11.9189V6.81081H11.7297V11.9189C11.7297 12.1698 11.6301 12.4104 11.4527 12.5878C11.2753 12.7652 11.0347 12.8649 10.7838 12.8649Z",
        fill: "currentColor"
    }));
}));
$e68492331bf5af8a$export$5fda1783bb83f57b.displayName = "CalendarIcon";

});

parcelRegister("5jNNK", function(module, exports) {

$parcel$export(module.exports, "ChevronUpIcon", () => $3df55b9fe6dcd325$export$7f01a6cbee61a0f2);

var $81g6h = parcelRequire("81g6h");

var $2u9US = parcelRequire("2u9US");
"use client";
function $3df55b9fe6dcd325$var$_extends() {
    $3df55b9fe6dcd325$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3df55b9fe6dcd325$var$_extends.apply(this, arguments);
}
var $3df55b9fe6dcd325$export$7f01a6cbee61a0f2 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var pti = (0, $2u9US.IconBase).getPTI(inProps);
    return /*#__PURE__*/ $81g6h.createElement("svg", $3df55b9fe6dcd325$var$_extends({
        ref: ref,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, pti), /*#__PURE__*/ $81g6h.createElement("path", {
        d: "M12.2097 10.4113C12.1057 10.4118 12.0027 10.3915 11.9067 10.3516C11.8107 10.3118 11.7237 10.2532 11.6506 10.1792L6.93602 5.46461L2.22139 10.1476C2.07272 10.244 1.89599 10.2877 1.71953 10.2717C1.54307 10.2556 1.3771 10.1808 1.24822 10.0593C1.11933 9.93766 1.035 9.77633 1.00874 9.6011C0.982477 9.42587 1.0158 9.2469 1.10338 9.09287L6.37701 3.81923C6.52533 3.6711 6.72639 3.58789 6.93602 3.58789C7.14565 3.58789 7.3467 3.6711 7.49502 3.81923L12.7687 9.09287C12.9168 9.24119 13 9.44225 13 9.65187C13 9.8615 12.9168 10.0626 12.7687 10.2109C12.616 10.3487 12.4151 10.4207 12.2097 10.4113Z",
        fill: "currentColor"
    }));
}));
$3df55b9fe6dcd325$export$7f01a6cbee61a0f2.displayName = "ChevronUpIcon";

});



parcelRegister("9eehA", function(module, exports) {

$parcel$export(module.exports, "StartProgramDialog", () => $b7cbc2eacbb4f53b$export$40cf06269f8c8abc);

var $iKObn = parcelRequire("iKObn");

var $giAv5 = parcelRequire("giAv5");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $eAmnG = parcelRequire("eAmnG");

var $bC9c0 = parcelRequire("bC9c0");

var $fIuLY = parcelRequire("fIuLY");

var $lbkrH = parcelRequire("lbkrH");

var $5SzTW = parcelRequire("5SzTW");

var $9XVwj = parcelRequire("9XVwj");

var $9oyj9 = parcelRequire("9oyj9");

var $8H969 = parcelRequire("8H969");

var $81g6h = parcelRequire("81g6h");
const $b7cbc2eacbb4f53b$export$40cf06269f8c8abc = ({ patient: patient, editor: editor, editedProgram: editedProgram, program: program, onSuccess: onSuccess, skipDialogConfirmation: skipDialogConfirmation, handleLoading: handleLoading, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const [loadingSubmit, setLoadingSubmit] = (0, $81g6h.useState)(false);
    const [confirmModeWithData, setConfirmModeWithData] = (0, $81g6h.useState)(null);
    const newProgram = (0, $81g6h.useMemo)(()=>({
            ...program,
            ...editedProgram
        }), [
        editedProgram,
        program
    ]);
    const saveAndStart = (0, $81g6h.useCallback)(async (data, forceChanges)=>{
        try {
            handleLoading?.(true);
            setLoadingSubmit(true);
            const startedProgram = await $b7cbc2eacbb4f53b$var$saveAndStartProgramOperation(patient.id, data, newProgram, editor, forceChanges);
            await (0, $ghfIB.getStartedManager).tryMarkProgramsStepAsCompleted();
            $b7cbc2eacbb4f53b$var$sendAnalytics(patient, program, {
                ...newProgram,
                ...data
            }, startedProgram);
            if (skipDialogConfirmation) showToast(format("programBuilder.updateFutureProgramDialog.successToast.title"), format("programBuilder.updateFutureProgramDialog.successToast.message", {
                program: newProgram.name
            }), "success");
            else showToast(format("programBuilder.startDialog.successToast.title"), format("programBuilder.startDialog.successToast.message"), "success");
            otherProps.onHide();
            onSuccess?.();
        } catch (e) {
            if (e instanceof (0, $fIuLY.ProgramNameTooLong)) {
                showToast(format("programBuilder.startDialog.errorToast.title"), format("programBuilder.startDialog.errorToast.nameTooLongMessage"));
                return;
            }
            if (e instanceof (0, $lbkrH.SessionDoneContentChangedError)) {
                setConfirmModeWithData({
                    data: data,
                    description: format("programBuilder.editOngoingProgramDialog.confirmDialog.sessionDoneContentChanged.message")
                });
                return;
            }
            if (e instanceof (0, $lbkrH.SessionOrderChangedError)) {
                setConfirmModeWithData({
                    data: data,
                    description: format("programBuilder.editOngoingProgramDialog.confirmDialog.sessionOrderChanged.message"),
                    confirmButtonLabel: format("programBuilder.editOngoingProgramDialog.confirmDialog.sessionOrderChanged.confirmButtonLabel"),
                    confirmButtonStyle: "primary"
                });
                return;
            }
            console.error(e);
            setConfirmModeWithData(null);
            showToast(format("programBuilder.startDialog.errorToast.title"), format("programBuilder.startDialog.errorToast.message"));
        } finally{
            setLoadingSubmit(false);
            handleLoading?.(false);
        }
    }, [
        handleLoading,
        newProgram,
        editor,
        patient,
        program,
        skipDialogConfirmation,
        otherProps,
        onSuccess,
        showToast,
        format
    ]);
    (0, $giAv5.useOnceEffect)(()=>saveAndStart(editedProgram, false), skipDialogConfirmation, [
        editedProgram,
        saveAndStart,
        skipDialogConfirmation
    ]);
    if (confirmModeWithData) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $9oyj9.ConfirmActionDialog), {
        ...otherProps,
        title: format("programBuilder.editOngoingProgramDialog.confirmDialog.title.v2_0"),
        message: confirmModeWithData.description,
        confirmButtonLabel: confirmModeWithData.confirmButtonLabel,
        confirmLoading: loadingSubmit,
        onCancel: ()=>setConfirmModeWithData(null),
        onHide: ()=>setConfirmModeWithData(null),
        onConfirm: ()=>saveAndStart(confirmModeWithData.data, true)
    });
    if (skipDialogConfirmation) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {});
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $8H969.ScheduleProgramDialog), {
        patient: patient,
        program: newProgram,
        editedProgram: editedProgram,
        onSave: (data)=>saveAndStart({
                ...editedProgram,
                ...data
            }, false),
        ...otherProps
    });
};
async function $b7cbc2eacbb4f53b$var$saveAndStartProgramOperation(patientId, programContent, currentProgram, editor, forceChanges = false) {
    let startedProgram;
    if (currentProgram.status === (0, $5SzTW.ProgramStatus).Ongoing) startedProgram = await (0, $ghfIB.programOperationsManager).performUpdateOngoingOperation(patientId, currentProgram.id, programContent, editor, forceChanges);
    else startedProgram = await (0, $ghfIB.programOperationsManager).performStartOperation(patientId, programContent, currentProgram.status, editor, (0, $eAmnG.isNewProgram)(currentProgram) ? undefined : currentProgram.id);
    return startedProgram;
}
function $b7cbc2eacbb4f53b$var$sendAnalytics(patient, previousProgram, newProgram, startedProgram) {
    const previousStatus = previousProgram.status;
    if (previousStatus === (0, $5SzTW.ProgramStatus).Scheduled || previousStatus === (0, $5SzTW.ProgramStatus).Ongoing) (0, $bC9c0.sendAnalyticsEventEditProgram)([
        patient?.analyticsId ?? "",
        startedProgram.id,
        previousStatus === (0, $5SzTW.ProgramStatus).Ongoing ? "ongoing" : "planned",
        $b7cbc2eacbb4f53b$var$getProgramChangesLabel(previousProgram, newProgram).join(";")
    ]);
    else {
        const exerciseDetails = (0, $eAmnG.getProgramDetails)(newProgram.days);
        (0, $bC9c0.sendAnalyticsEventStartProgram)(patient?.analyticsId ?? "", startedProgram, exerciseDetails, patient?.status);
    }
}
function $b7cbc2eacbb4f53b$var$getProgramChangesLabel(previousProgram, newProgram) {
    const changes = [
        newProgram.endDate !== previousProgram.endDate ? "durationChanged" : "",
        !newProgram.days.equals(previousProgram.days) ? "sessionChanged" : "",
        newProgram.name !== previousProgram.name ? "titleChanged" : ""
    ];
    return changes.filter((change)=>!!change);
}

});

parcelRegister("6AeQE", function(module, exports) {

$parcel$export(module.exports, "StopProgramDialog", () => $965a23f7616038e0$export$197c7aec93598873);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $5SzTW = parcelRequire("5SzTW");

var $9XVwj = parcelRequire("9XVwj");

var $9oyj9 = parcelRequire("9oyj9");

var $81g6h = parcelRequire("81g6h");
const $965a23f7616038e0$export$197c7aec93598873 = ({ patient: patient, program: program, editor: editor, onSuccess: onSuccess, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const [awaitingStop, setAwaitingStop] = (0, $81g6h.useState)(false);
    const stopProgram = (0, $81g6h.useCallback)(async ()=>{
        setAwaitingStop(true);
        try {
            const { status: status } = await (0, $ghfIB.programOperationsManager).performStopProgramOperation(patient.id, program.id, editor);
            setAwaitingStop(false);
            onSuccess?.();
            otherProps.onHide();
            showToast(format("global.stopProgramOperation.successToast.title"), format(status === (0, $5SzTW.ProgramStatus).Draft ? "global.stopProgramOperation.draft.successToast.message" : "global.stopProgramOperation.successToast.message"), "success");
        } catch (error) {
            console.error("Failed to stop program", error);
            setAwaitingStop(false);
            showToast(format("global.stopProgramOperation.errorToast.title"), format("global.stopProgramOperation.errorToast.message"));
        }
    }, [
        editor,
        format,
        onSuccess,
        otherProps,
        patient.id,
        program.id,
        showToast
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $9oyj9.ConfirmActionDialog), {
        ...otherProps,
        onCancel: otherProps.onHide,
        onConfirm: stopProgram,
        confirmLoading: awaitingStop,
        title: format("programBuilder.stopDialog.header"),
        message: format("programBuilder.stopDialog.message")
    });
};

});

parcelRegister("4iUgP", function(module, exports) {

$parcel$export(module.exports, "ConfirmDuplicationDialog", () => $55b1c46d7ac1bf60$export$8376974f9e0bc615);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $243Cr = parcelRequire("243Cr");

var $9oyj9 = parcelRequire("9oyj9");

var $81g6h = parcelRequire("81g6h");
const $55b1c46d7ac1bf60$export$8376974f9e0bc615 = ({ onConfirm: onConfirm, onCancel: onCancel, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const handleConfirm = (0, $81g6h.useCallback)(()=>{
        onConfirm?.();
        dialogContext?.closeAll();
    }, [
        dialogContext,
        onConfirm
    ]);
    const handleCancel = (0, $81g6h.useCallback)(()=>{
        onCancel?.();
        dialogContext?.closeAll();
    }, [
        dialogContext,
        onCancel
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $9oyj9.ConfirmActionDialog), {
        ...otherProps,
        onConfirm: handleConfirm,
        onCancel: handleCancel,
        title: format("global.confirmDuplicationDialog.title"),
        confirmButtonLabel: format("global.confirmDuplicationDialog.confirmButtonLabel"),
        message: format("global.confirmDuplicationDialog.message")
    });
};

});

parcelRegister("2xBCC", function(module, exports) {

$parcel$export(module.exports, "ProgramBuilderActionsDialog", () => $c21255d929d2e145$export$8e9b1e1a09480165);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $c22GE = parcelRequire("c22GE");

var $gk3fY = parcelRequire("gk3fY");

var $243Cr = parcelRequire("243Cr");

var $1CiDH = parcelRequire("1CiDH");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");
const $c21255d929d2e145$export$8e9b1e1a09480165 = ({ programName: programName, patient: patient, statusMessage: statusMessage, programActions: programActions, onNameChanged: onNameChanged, ...otherProps })=>{
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const [name, setName] = (0, $81g6h.useState)(programName);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $gk3fY.BaseDialog), {
        visible: true,
        width: (0, $gk3fY.DIALOG_SIZE).S,
        ...otherProps,
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($c21255d929d2e145$var$DialogContainer, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsxs)($c21255d929d2e145$var$Row, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                            className: "p-size-l-bold",
                            children: name
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)($c21255d929d2e145$var$EditIconWrapper, {
                            onClick: ()=>{
                                dialogContext?.openModal((0, $243Cr.ModalId).RenameProgram, {
                                    programName: programName,
                                    renameProgram: (newProgramName)=>{
                                        setName(newProgramName);
                                        onNameChanged(newProgramName);
                                    }
                                });
                            },
                            children: /*#__PURE__*/ (0, $iKObn.jsx)("i", {
                                className: "pi pi-pencil black"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                    className: "p-size-s",
                    children: statusMessage
                }),
                (0, $lTdpc.isNotNil)(patient) && /*#__PURE__*/ (0, $iKObn.jsx)($c21255d929d2e145$var$PatientDetailsContainer, {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $1CiDH.PatientDetailsContent), {
                        patient: patient,
                        isLightMode: true,
                        isEditable: false
                    })
                }),
                programActions.length > 0 && /*#__PURE__*/ (0, $iKObn.jsx)($c21255d929d2e145$var$Options, {
                    children: programActions.map(({ itemClassName: itemClassName, disabled: disabled, destructive: destructive, text: text, icon: icon, onClick: onClick })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $c22GE.TertiaryButton), {
                            uiStyle: destructive ? "danger" : "primary",
                            disabled: disabled,
                            onClick: onClick,
                            icon: icon,
                            className: itemClassName,
                            label: text
                        }, text))
                })
            ]
        })
    });
};
const $c21255d929d2e145$var$DialogContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "flexstart", "stretch")};
	height: 100%;
`;
const $c21255d929d2e145$var$Row = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8, "flexstart", "center")};
`;
const $c21255d929d2e145$var$PatientDetailsContainer = (0, $5UMQ1.default).div`
	margin: 24px 0;
	border-radius: 16px;
	padding: 16px;
	border: 1px solid ${(0, $kKnoQ.colors).primary25};
`;
const $c21255d929d2e145$var$EditIconWrapper = (0, $5UMQ1.default).div`
	height: 24px;
	width: 24px;
	${(0, $5WGN2.row)(undefined, "center", "center")}
	cursor: pointer;

	i {
		color: ${(0, $kKnoQ.colors).black};
	}
`;
const $c21255d929d2e145$var$Options = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(24, "center", "flexstart")};
`;

});
parcelRegister("1CiDH", function(module, exports) {

$parcel$export(module.exports, "PatientDetailsColumn", () => $c07732bdc0a7aa48$export$2a796922c192eab5);
$parcel$export(module.exports, "PatientDetailsContent", () => $c07732bdc0a7aa48$export$5692a301e6715f67);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $lG6Cp = parcelRequire("lG6Cp");

var $lfUub = parcelRequire("lfUub");

var $g3eyb = parcelRequire("g3eyb");

var $aEP4N = parcelRequire("aEP4N");

var $6Yxa2 = parcelRequire("6Yxa2");

var $5UMQ1 = parcelRequire("5UMQ1");

var $jrnUx = parcelRequire("jrnUx");

var $243Cr = parcelRequire("243Cr");

var $5kXMA = parcelRequire("5kXMA");

var $1acTy = parcelRequire("1acTy");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");
var $c07732bdc0a7aa48$var$ArrowDownIcon = function ArrowDownIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M17.712 12.71a1.001 1.001 0 0 0-1.42 0L13.003 16V6a1 1 0 0 0-2 0v10l-3.29-3.29a1 1 0 1 0-1.42 1.41l4.3 4.29a2 2 0 0 0 1.41.59 2 2 0 0 0 1.4-.59l4.3-4.29a1 1 0 0 0 .01-1.41Z",
            fill: "currentColor"
        })
    });
};
$c07732bdc0a7aa48$var$ArrowDownIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $c07732bdc0a7aa48$var$ArrowUpIcon = function ArrowUpIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "m17.71 9.376-4.3-4.29a2 2 0 0 0-2.82 0l-4.3 4.29a1 1 0 1 0 1.42 1.41L11 7.496v11a1 1 0 0 0 2 0v-11l3.29 3.29a1 1 0 0 0 1.42-1.41Z",
            fill: "currentColor"
        })
    });
};
$c07732bdc0a7aa48$var$ArrowUpIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $c07732bdc0a7aa48$var$CareIcon = function CareIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M10.81 11.54c-1.26 0-2.48-.51-3.37-1.4-.9-.9-1.39-2.1-1.39-3.37s.5-2.47 1.39-3.37C8.33 2.5 9.56 2 10.81 2s2.48.51 3.37 1.4c.89.89 1.39 2.1 1.39 3.37s-.5 2.47-1.39 3.37c-.89.89-2.12 1.4-3.37 1.4Zm0-7.53c-.73 0-1.44.3-1.96.81a2.779 2.779 0 0 0 0 3.92c1.03 1.03 2.88 1.03 3.91 0a2.779 2.779 0 0 0 0-3.92c-.52-.51-1.23-.81-1.96-.81h.01ZM20.798 11.54a2.107 2.107 0 0 0-2 2.2 2.107 2.107 0 0 0-2-2.2 2.107 2.107 0 0 0-2 2.2c0 1.73 2.256 3.757 3.38 4.659a.992.992 0 0 0 1.24 0c1.124-.9 3.38-2.929 3.38-4.659a2.107 2.107 0 0 0-2-2.2Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.268 13.965a1 1 0 0 1-.933 1.063c-1.523.099-3.47.511-5.004 1.204-.767.346-1.377.738-1.782 1.149-.396.402-.549.771-.549 1.119V20h11.77a1 1 0 1 1 0 2H4c-1.102 0-2-.898-2-2v-1.5c0-1.017.476-1.863 1.124-2.522.64-.65 1.49-1.166 2.385-1.57 1.79-.807 3.979-1.265 5.696-1.376a1 1 0 0 1 1.063.933Z",
                fill: "currentColor"
            })
        ]
    });
};
$c07732bdc0a7aa48$var$CareIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $c07732bdc0a7aa48$var$ACCORDION_VERTICAL_PADDING = 32;
const $c07732bdc0a7aa48$export$2a796922c192eab5 = ({ patient: patient })=>{
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const [containerHeight, setContainerHeight] = (0, $81g6h.useState)(0);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
        children: isDesktop ? /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$StickyPatientDetailsContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$StickyPatientDetailsSection, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$export$5692a301e6715f67, {
                    patient: patient
                })
            })
        }) : /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$BackgroundContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$AccordionPatientDetailsContainer, {
                height: containerHeight,
                children: /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$AccordionPatientDetailsSection, {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$export$5692a301e6715f67, {
                        patient: patient,
                        setContainerHeight: setContainerHeight
                    })
                })
            })
        })
    });
};
const $c07732bdc0a7aa48$export$5692a301e6715f67 = ({ patient: patient, isLightMode: isLightMode = false, isEditable: isEditable = true, setContainerHeight: setContainerHeight })=>{
    const { format: format, formatAge: formatAge, formatDateMed: formatDateMed } = (0, $1eHG3.useI18n)();
    const { formatPatientName: formatPatientName } = (0, $aEP4N.useFormatPatients)();
    const formatGender = (0, $lfUub.useFormatGender)();
    const { getGenderIcon: getGenderIcon } = (0, $g3eyb.useGenderIcon)();
    const { formatDisease: formatDisease, formatFunctionalStatus: formatFunctionalStatus } = (0, $lG6Cp.useFormatMedicalCondition)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const { shouldDisplayLegalAgeDisclaimer: shouldDisplayLegalAgeDisclaimer } = (0, $1acTy.useCountryConfig)();
    const [closedContainerHeight, setClosedContainerHeight] = (0, $81g6h.useState)(0);
    const [openedContainerHeight, setOpenedContainerHeight] = (0, $81g6h.useState)();
    const [isOpen, setIsOpen] = (0, $81g6h.useState)(false);
    const headerInfoRef = (0, $81g6h.useRef)(null);
    const patientDetailsRef = (0, $81g6h.useRef)(null);
    (0, $81g6h.useEffect)(()=>{
        if (!patientDetailsRef.current?.clientHeight || !headerInfoRef.current?.clientHeight) return;
        setOpenedContainerHeight(patientDetailsRef.current.clientHeight);
        setClosedContainerHeight(headerInfoRef.current.clientHeight);
        setContainerHeight?.(headerInfoRef.current.clientHeight + $c07732bdc0a7aa48$var$ACCORDION_VERTICAL_PADDING);
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        patientDetailsRef.current,
        headerInfoRef.current
    ]);
    const patientAgeGender = (0, $81g6h.useMemo)(()=>!(0, $6Yxa2.isPendingPatient)(patient) ? [
            ...patient.birthDate ? [
                formatAge(patient.birthDate)
            ] : [],
            ...patient.gender ? [
                formatGender(patient.gender)
            ] : []
        ].join(", ") : undefined, [
        formatAge,
        formatGender,
        patient
    ]);
    const GenderIcon = (0, $81g6h.useMemo)(()=>getGenderIcon(patient), [
        getGenderIcon,
        patient
    ]);
    const toggleAccordion = (newStatus)=>{
        if (newStatus && openedContainerHeight) {
            setIsOpen(true);
            setContainerHeight?.(openedContainerHeight + $c07732bdc0a7aa48$var$ACCORDION_VERTICAL_PADDING);
        }
        if (!newStatus && closedContainerHeight) {
            setIsOpen(false);
            setContainerHeight?.(closedContainerHeight + $c07732bdc0a7aa48$var$ACCORDION_VERTICAL_PADDING);
        }
    };
    const lightModeStyle = {
        color: isLightMode ? (0, $kKnoQ.colors).grey : (0, $kKnoQ.colors).white
    };
    return /*#__PURE__*/ (0, $iKObn.jsxs)($c07732bdc0a7aa48$var$DetailsContainer, {
        ref: patientDetailsRef,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($c07732bdc0a7aa48$var$HeaderContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($c07732bdc0a7aa48$var$HeaderInfo, {
                        ref: headerInfoRef,
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)(GenderIcon, {
                                width: "40",
                                height: "40"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)($c07732bdc0a7aa48$var$HeaderInfoTextContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$PatientName, {
                                        className: "p-size-m-bold",
                                        style: lightModeStyle,
                                        children: /*#__PURE__*/ (0, $iKObn.jsx)("abbr", {
                                            style: {
                                                textDecoration: "none"
                                            },
                                            title: formatPatientName(patient),
                                            children: formatPatientName(patient)
                                        })
                                    }),
                                    patientAgeGender && /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                        style: lightModeStyle,
                                        children: patientAgeGender
                                    })
                                ]
                            })
                        ]
                    }),
                    !isDesktop && /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$SwitchButton, {
                        onClick: ()=>toggleAccordion(!isOpen),
                        children: isOpen ? /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$ArrowUpIcon, {
                            height: 24,
                            width: 24,
                            color: (0, $kKnoQ.colors).white
                        }) : /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$ArrowDownIcon, {
                            height: 24,
                            width: 24,
                            color: (0, $kKnoQ.colors).white
                        })
                    })
                ]
            }),
            (0, $lTdpc.isNotNil)(patient.email) && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($c07732bdc0a7aa48$var$PatientDetailsGroup, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$PatientDetailsTitle, {
                                text: format("patientDetails.column.contactSection"),
                                isLightMode: isLightMode
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$EmailText, {
                                style: lightModeStyle,
                                children: /*#__PURE__*/ (0, $iKObn.jsx)("abbr", {
                                    style: {
                                        textDecoration: "none"
                                    },
                                    title: patient.email,
                                    children: patient.email
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$Separator, {
                        isLightMode: true
                    })
                ]
            }),
            (0, $6Yxa2.isPendingPatient)(patient) && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($c07732bdc0a7aa48$var$PatientDetailsGroup, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$PatientDetailsTitle, {
                                text: format("patientDetails.column.pendingPatient.invitationCode"),
                                isLightMode: isLightMode
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                style: lightModeStyle,
                                children: patient.activationCode
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$Separator, {
                        isLightMode: true
                    })
                ]
            }),
            !(0, $6Yxa2.isPendingPatient)(patient) && /*#__PURE__*/ (0, $iKObn.jsxs)($c07732bdc0a7aa48$var$PatientDetailsGroup, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($c07732bdc0a7aa48$var$ConditionTitle, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$PatientDetailsTitle, {
                                text: format("patientDetails.column.medicalSection"),
                                isLightMode: isLightMode
                            }),
                            isEditable && /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$PressableIcon, {
                                className: "pi pi-pencil",
                                onClick: ()=>dialogContext?.openModal((0, $243Cr.ModalId).EditPatientInfo, {
                                        patient: patient
                                    }),
                                isLightMode: isLightMode
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        style: lightModeStyle,
                        children: formatDisease(patient.disease)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($c07732bdc0a7aa48$var$PatientDetailsGroup, {
                children: [
                    (0, $6Yxa2.isPendingPatient)(patient) ? /*#__PURE__*/ (0, $iKObn.jsxs)($c07732bdc0a7aa48$var$ConditionTitle, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$PatientDetailsTitle, {
                                text: format("patientDetails.column.functionalStatusSection"),
                                isLightMode: isLightMode
                            }),
                            isEditable && /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$PressableIcon, {
                                className: "pi pi-pencil",
                                onClick: ()=>{
                                    dialogContext?.openModal((0, $243Cr.ModalId).EditPatientInfo, {
                                        patient: patient
                                    });
                                },
                                isLightMode: isLightMode
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$PatientDetailsTitle, {
                        text: format("patientDetails.column.functionalStatusSection"),
                        isLightMode: isLightMode
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        style: lightModeStyle,
                        children: formatFunctionalStatus(patient.functionalStatus)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$Separator, {
                isLightMode: true
            }),
            !(0, $6Yxa2.isPendingPatient)(patient) && (0, $lTdpc.isNotEmpty)(patient.aspiration) && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($c07732bdc0a7aa48$var$PatientDetailsGroup, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$PatientAspirationTitle, {
                                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $jrnUx.ContentWithTooltip), {
                                    tooltip: format("patientDetails.column.patientAspiration.tooltip"),
                                    iconColor: isLightMode ? (0, $kKnoQ.colors).grey : (0, $kKnoQ.colors).white,
                                    children: /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$PatientDetailsTitle, {
                                        isLightMode: isLightMode,
                                        text: format("patientDetails.column.patientAspiration")
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$PatientAspiration, {
                                style: lightModeStyle,
                                children: patient.aspiration
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$Separator, {
                        isLightMode: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$PatientDetailsTitle, {
                        text: format("patientDetails.column.profileCreation"),
                        isLightMode: isLightMode
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        style: lightModeStyle,
                        children: formatDateMed(patient.creationDate)
                    })
                ]
            }),
            shouldDisplayLegalAgeDisclaimer(patient) && /*#__PURE__*/ (0, $iKObn.jsxs)($c07732bdc0a7aa48$var$LegalAgeDisclaimerContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($c07732bdc0a7aa48$var$Row, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($c07732bdc0a7aa48$var$CareIcon, {
                                width: 16,
                                height: 16
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                className: "p-size-s-bold",
                                color: (0, $kKnoQ.colors).white,
                                children: format("patientDetails.column.legalAgeDisclaimer.title")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        className: "p-size-xs-semi-bold",
                        color: (0, $kKnoQ.colors).white,
                        children: format("patientDetails.column.legalAgeDisclaimer.description")
                    })
                ]
            })
        ]
    });
};
const $c07732bdc0a7aa48$var$PatientDetailsTitle = ({ text: text, isLightMode: isLightMode })=>/*#__PURE__*/ (0, $iKObn.jsx)("div", {
        className: "p-size-s-bold",
        style: {
            color: isLightMode ? (0, $kKnoQ.colors).grey : (0, $kKnoQ.colors).white
        },
        children: text
    });
const $c07732bdc0a7aa48$var$StickyPatientDetailsContainer = (0, $5UMQ1.default).section`
	min-width: 228px;
	max-width: 20vw;
	background-color: ${(0, $kKnoQ.colors).grey};
	border-radius: 16px 16px 0 0;
	color: ${(0, $kKnoQ.colors).white};

	abbr {
		text-decoration: inherit;
	}
`;
const $c07732bdc0a7aa48$var$AccordionPatientDetailsSection = (0, $5UMQ1.default).section`
	background-color: ${(0, $kKnoQ.colors).grey};
	color: ${(0, $kKnoQ.colors).white};
	padding: 16px;

	abbr {
		text-decoration: inherit;
	}
`;
const $c07732bdc0a7aa48$var$StickyPatientDetailsSection = (0, $5UMQ1.default).div`
	position: sticky;
	top: 0;
	padding: 24px;
`;
const $c07732bdc0a7aa48$var$DetailsContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(16)};
`;
const $c07732bdc0a7aa48$var$BackgroundContainer = (0, $5UMQ1.default).div`
	background-color: ${(0, $kKnoQ.colors).primaryBackground};
	padding-bottom: 24px;
`;
const $c07732bdc0a7aa48$var$AccordionPatientDetailsContainer = (0, $5UMQ1.default).div`
	height: ${({ height: height })=>height ? `${height}px` : "unset"};
	transition: height 0.5s ease-in-out;
	overflow: hidden;
	margin: 0 16px;
	border-radius: 16px;
`;
const $c07732bdc0a7aa48$var$PressableIcon = (0, $5UMQ1.default).i`
	cursor: pointer;
	font-size: 13px;
	color: ${({ isLightMode: isLightMode })=>isLightMode ? (0, $kKnoQ.colors).grey : (0, $kKnoQ.colors).white};
`;
const $c07732bdc0a7aa48$var$ConditionTitle = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("S", "spacebetween", "center")}
`;
const $c07732bdc0a7aa48$var$PatientAspiration = (0, $5UMQ1.default).div`
	overflow-wrap: break-word;
`;
const $c07732bdc0a7aa48$var$PatientAspirationTitle = (0, $5UMQ1.default).div`
	display: flex;
	gap: 4px;
	place-items: center;
`;
const $c07732bdc0a7aa48$var$PatientDetailsGroup = (0, $5UMQ1.default).div`
	width: 100%;
`;
const $c07732bdc0a7aa48$var$Separator = (0, $5UMQ1.default).div`
	height: 1px;
	width: 100%;
	background-color: ${({ isLightMode: isLightMode })=>isLightMode ? (0, $kKnoQ.colors).primary10 : (0, $kKnoQ.colors).grey80};
`;
const $c07732bdc0a7aa48$var$HeaderContainer = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: row;
	align-self: stretch;
	justify-content: space-between;
`;
const $c07732bdc0a7aa48$var$HeaderInfo = (0, $5UMQ1.default).div`
	display: grid;
	grid-template-columns: 40px 1fr;
	place-items: center;
	gap: 16px;
`;
const $c07732bdc0a7aa48$var$HeaderInfoTextContainer = (0, $5UMQ1.default).div`
	display: grid;
	place-content: center;
`;
const $c07732bdc0a7aa48$var$SwitchButton = (0, $5UMQ1.default).button`
	cursor: pointer;
	border: 0;
	border-radius: 8px;
	padding: 16px 24px;
	background-color: ${(0, $kKnoQ.colors).transparent};
	${(0, $5WGN2.row)(undefined, "center", "center")};
	margin-right: -8px;
`;
const $c07732bdc0a7aa48$var$EmailText = (0, $5UMQ1.default).div`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;
const $c07732bdc0a7aa48$var$PatientName = (0, $5UMQ1.default).div`
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	overflow-wrap: break-word;
`;
const $c07732bdc0a7aa48$var$LegalAgeDisclaimerContainer = (0, $5UMQ1.default).div`
	margin-top: 8px;
	padding: 16px;
	border-radius: 8px;
	${(0, $5WGN2.stack)(0, "spacebetween", "flexstart")}
	background-color: ${(0, $kKnoQ.colors).grey80};
`;
const $c07732bdc0a7aa48$var$Row = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8, "flexstart", "center")}
`;

});
parcelRegister("lfUub", function(module, exports) {

$parcel$export(module.exports, "useFormatGender", () => $4919d3d24ee00193$export$1eb7ab33c0e95447);

var $1eHG3 = parcelRequire("1eHG3");

var $4QZSk = parcelRequire("4QZSk");

var $81g6h = parcelRequire("81g6h");
const $4919d3d24ee00193$export$1eb7ab33c0e95447 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return (0, $81g6h.useCallback)((gender)=>{
        switch(gender){
            case (0, $4QZSk.Gender).Man:
                return format("global.gender.man");
            case (0, $4QZSk.Gender).Woman:
                return format("global.gender.woman");
            case (0, $4QZSk.Gender).Other:
                return format("global.gender.other");
            default:
                return "";
        }
    }, [
        format
    ]);
};

});



parcelRegister("iOLvt", function(module, exports) {

$parcel$export(module.exports, "EditPasswordDialog", () => $2a2c29e16ed13bf5$export$f8bd1d2cd8759d61);

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $12cV0 = parcelRequire("12cV0");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");

var $8FlUV = parcelRequire("8FlUV");

var $hIci4 = parcelRequire("hIci4");

var $9XVwj = parcelRequire("9XVwj");

var $jjBFV = parcelRequire("jjBFV");

var $kvJz4 = parcelRequire("kvJz4");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $dU78w = parcelRequire("dU78w");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
const $2a2c29e16ed13bf5$export$f8bd1d2cd8759d61 = ({ ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const { control: control, handleSubmit: handleSubmit, setError: setError } = (0, $eKUeg.useForm)({
        defaultValues: {
            currentPassword: "",
            newPassword: ""
        }
    });
    const [submitNewPassword, isLoading] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(async ({ currentPassword: currentPassword, newPassword: newPassword })=>{
        try {
            await (0, $ghfIB.userManager).changePassword(currentPassword, newPassword);
            (0, $kvJz4.sendAnalyticsEventSavePasswordAccount)();
            showToast("", format("settings.accountTab.editPasswordDialog.successToast.detail"), "success");
            otherProps.onHide();
        } catch (e) {
            if (e instanceof (0, $12cV0.NotAuthorizedCodeError)) setError("currentPassword", {
                message: format("settings.accountTab.editPasswordDialog.currentPassword.invalidError")
            });
            console.error("Failure to change password", e);
        }
    }, [
        format,
        otherProps,
        setError,
        showToast
    ]), {});
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $gk3fY.BaseDialog), {
        closeOnEscape: false,
        header: format("settings.accountTab.editPasswordDialog.header"),
        footer: /*#__PURE__*/ (0, $iKObn.jsx)($2a2c29e16ed13bf5$var$ButtonContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                loading: isLoading,
                type: "submit",
                label: format("global.dialog.save"),
                onClick: handleSubmit(submitNewPassword)
            })
        }),
        width: (0, $gk3fY.DIALOG_SIZE).S,
        ...otherProps,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($2a2c29e16ed13bf5$var$Form, {
            onSubmit: handleSubmit(submitNewPassword),
            children: /*#__PURE__*/ (0, $iKObn.jsxs)($2a2c29e16ed13bf5$var$ControllersContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                        name: "currentPassword",
                        control: control,
                        rules: {
                            required: format("global.form.field.requiredError")
                        },
                        render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                        className: "p-size-m",
                                        children: format("settings.accountTab.editPasswordDialog.currentPassword.label")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.PasswordInput), {
                                        ...field,
                                        placeholder: format("settings.accountTab.editPasswordDialog.currentPassword.placeholder"),
                                        error: fieldState.invalid
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $8FlUV.ErrorMessage), {
                                        children: fieldState.error?.message
                                    })
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($2a2c29e16ed13bf5$var$FormField, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $jjBFV.PasswordField), {
                            control: control,
                            error: false,
                            placeholder: format("settings.accountTab.editPasswordDialog.newPassword.placeholder"),
                            name: "newPassword",
                            label: format("settings.accountTab.editPasswordDialog.newPassword.label"),
                            labelStyle: {
                                marginTop: "16px"
                            },
                            rulesStyle: {
                                fontSize: "0.75rem",
                                marginTop: 8
                            }
                        })
                    })
                ]
            })
        })
    });
};
const $2a2c29e16ed13bf5$var$Form = (0, $5UMQ1.default)((0, $dU78w.motion).form)`
	${(0, $5WGN2.stack)("M", "spacebetween", "stretch")};
	height: 100%;
`;
const $2a2c29e16ed13bf5$var$ControllersContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("M", "flexstart", "stretch")};
`;
const $2a2c29e16ed13bf5$var$FormField = (0, $5UMQ1.default)((0, $dU78w.motion).div)`
	${(0, $5WGN2.stack)("S", "flexstart", "stretch")};
`;
const $2a2c29e16ed13bf5$var$ButtonContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(24, "flexend")}
`;

});
parcelRegister("jjBFV", function(module, exports) {

$parcel$export(module.exports, "PasswordField", () => $40a623453b8748d7$export$65ed9482db2257fa);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $8FlUV = parcelRequire("8FlUV");

var $hIci4 = parcelRequire("hIci4");

var $lTdpc = parcelRequire("lTdpc");

var $cfkGk = parcelRequire("cfkGk");
parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
const $40a623453b8748d7$var$hasCorrectLength = (value)=>value.length >= 12;
const $40a623453b8748d7$var$hasNumber = (value)=>new RegExp(/\d/).test(value);
const $40a623453b8748d7$var$hasUpperCaseLetter = (value)=>new RegExp(/[A-Z]/).test(value);
const $40a623453b8748d7$var$hasLowerCaseLetter = (value)=>new RegExp(/[a-z]/).test(value);
const $40a623453b8748d7$var$hasSpecialCharacter = (value)=>new RegExp(/[\^$*.[\]{}()?\-"!@#%&/,><':;|_~`]/).test(value);
const $40a623453b8748d7$export$65ed9482db2257fa = ({ additionalPasswordValidation: additionalPasswordValidation, control: control, error: error, name: name, label: label, labelStyle: labelStyle, rulesStyle: rulesStyle, placeholder: placeholder, dataTest: dataTest })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
        name: name,
        control: control,
        rules: {
            required: format("passwordField.password.requiredError"),
            validate: (value)=>{
                const result = additionalPasswordValidation?.(value);
                if ((0, $lTdpc.isNotNil)(result)) return result;
                if (!$40a623453b8748d7$var$hasCorrectLength(value) || !$40a623453b8748d7$var$hasNumber(value) || !$40a623453b8748d7$var$hasUpperCaseLetter(value) || !$40a623453b8748d7$var$hasLowerCaseLetter(value) || !$40a623453b8748d7$var$hasSpecialCharacter(value)) return format("passwordField.password.incorrectRuleError");
            }
        },
        render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                        style: labelStyle,
                        className: "p-size-m",
                        children: (0, $lTdpc.isNotEmpty)(label) ? label : format("passwordField.create.your.password.label")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($40a623453b8748d7$var$StyledPasswordInput, {
                        ...field,
                        "data-test": dataTest,
                        placeholder: placeholder ?? format("passwordField.password.placeholder"),
                        error: fieldState.invalid || !!error
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $8FlUV.ErrorMessage), {
                        children: fieldState.error?.message
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
                        style: rulesStyle,
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                                children: format("passwordField.rules.description")
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)($40a623453b8748d7$var$Ul, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($40a623453b8748d7$var$Li, {
                                        error: fieldState.error && !$40a623453b8748d7$var$hasCorrectLength(field.value),
                                        valid: $40a623453b8748d7$var$hasCorrectLength(field.value),
                                        children: format("passwordField.rules.minLength")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($40a623453b8748d7$var$Li, {
                                        error: fieldState.error && !$40a623453b8748d7$var$hasNumber(field.value),
                                        valid: $40a623453b8748d7$var$hasNumber(field.value),
                                        children: format("passwordField.rules.numberIncluded")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($40a623453b8748d7$var$Li, {
                                        error: fieldState.error && !$40a623453b8748d7$var$hasLowerCaseLetter(field.value),
                                        valid: $40a623453b8748d7$var$hasLowerCaseLetter(field.value),
                                        children: format("passwordField.rules.lowerCaseLetterIncluded")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($40a623453b8748d7$var$Li, {
                                        error: fieldState.error && !$40a623453b8748d7$var$hasUpperCaseLetter(field.value),
                                        valid: $40a623453b8748d7$var$hasUpperCaseLetter(field.value),
                                        children: format("passwordField.rules.upperCaseLetterIncluded")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($40a623453b8748d7$var$Li, {
                                        error: fieldState.error && !$40a623453b8748d7$var$hasSpecialCharacter(field.value),
                                        valid: $40a623453b8748d7$var$hasSpecialCharacter(field.value),
                                        children: format("passwordField.rules.specialCharacterIncluded")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
    });
};
const $40a623453b8748d7$var$StyledPasswordInput = (0, $5UMQ1.default)((0, $hIci4.PasswordInput))`
	margin-top: 8px;
	margin-bottom: 8px;
`;
const $40a623453b8748d7$var$Ul = (0, $5UMQ1.default).ul`
	margin: 0;
	padding-left: 1.5em;
`;
const $40a623453b8748d7$var$Li = ({ error: error, valid: valid, children: children })=>/*#__PURE__*/ (0, $iKObn.jsx)("li", {
        className: (0, $cfkGk.classNames)({
            "p-error": !!error,
            "p-valid": !!valid
        }),
        children: children
    });

});

parcelRegister("kvJz4", function(module, exports) {

$parcel$export(module.exports, "sendAnalyticsEventSavePasswordAccount", () => $1348737c5c717e1a$export$52db29d3ea821218);
$parcel$export(module.exports, "sendAnalyticsEventAccountUpdated", () => $1348737c5c717e1a$export$b54e5fe9bae757a4);
$parcel$export(module.exports, "sendAnalyticsEventEditPassword", () => $1348737c5c717e1a$export$c80edb353e6941ca);
$parcel$export(module.exports, "sendAnalyticsEventEditProfile", () => $1348737c5c717e1a$export$dea097e575abded8);
$parcel$export(module.exports, "sendAnalyticsEventAccountDeleted", () => $1348737c5c717e1a$export$3298da5df571d977);
$parcel$export(module.exports, "sendAnalyticsEventDeleteAccountCTA", () => $1348737c5c717e1a$export$fd5bd26254cb8c2);

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");
const $1348737c5c717e1a$export$52db29d3ea821218 = ()=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).SETTINGS,
        action: "saveAccount",
        params: [
            "password"
        ]
    });
const $1348737c5c717e1a$export$b54e5fe9bae757a4 = (data)=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).SETTINGS,
        action: "saveAccount",
        params: [
            data
        ]
    });
const $1348737c5c717e1a$export$c80edb353e6941ca = ()=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).SETTINGS,
        action: "editInformation",
        params: [
            "password"
        ]
    });
const $1348737c5c717e1a$export$dea097e575abded8 = ()=>(0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).SETTINGS,
        action: "editInformation",
        params: [
            "yourInformation"
        ]
    });
const $1348737c5c717e1a$export$3298da5df571d977 = (leavingReasons)=>{
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).SETTINGS,
        action: "accountDeleted",
        params: leavingReasons
    });
};
const $1348737c5c717e1a$export$fd5bd26254cb8c2 = ()=>{
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).SETTINGS,
        action: "clickCtaDeleteAccount",
        params: []
    });
};

});


parcelRegister("1prVa", function(module, exports) {

$parcel$export(module.exports, "EditProfessionalInformationDialog", () => $53d03ad363ee7b2c$export$76b9f514de1e69e9);

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");

var $28f8Y = parcelRequire("28f8Y");

var $hIci4 = parcelRequire("hIci4");

var $1IlhR = parcelRequire("1IlhR");

var $9XVwj = parcelRequire("9XVwj");

var $5RTr6 = parcelRequire("5RTr6");

var $8MrZI = parcelRequire("8MrZI");

var $kvJz4 = parcelRequire("kvJz4");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $lTdpc = parcelRequire("lTdpc");

var $dU78w = parcelRequire("dU78w");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
const $53d03ad363ee7b2c$export$76b9f514de1e69e9 = ({ defaultValues: defaultValues, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const { control: control, handleSubmit: handleSubmit } = (0, $eKUeg.useForm)({
        defaultValues: defaultValues
    });
    const { selectedPostalCodeTemplate: selectedPostalCodeTemplate, isLoading: isConfigLoading, isError: isConfigError, refresh: refreshConfig } = (0, $8MrZI.useRegistrationCountryUserConfig)("", ()=>null);
    const fieldRequiredErrorMessage = format("global.form.field.requiredError");
    const [submitForm, isLoading] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(async (data)=>{
        const updatedData = Object.fromEntries(Object.entries(data).filter(([key, value])=>defaultValues[key] !== value));
        try {
            await (0, $ghfIB.userManager).updateUser(updatedData);
            (0, $kvJz4.sendAnalyticsEventAccountUpdated)(Object.keys(updatedData).join(";"));
            showToast("", format("settings.accountTab.editInfoDialog.successToast.detail"), "success");
            otherProps.onHide();
        } catch (e) {
            console.error("Failure to submit form", e);
        }
    }, [
        defaultValues,
        format,
        otherProps,
        showToast
    ]), {});
    let dialogContent;
    if (isConfigLoading) dialogContent = /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {});
    else if (isConfigError) dialogContent = /*#__PURE__*/ (0, $iKObn.jsx)($53d03ad363ee7b2c$var$StyledNetworkError, {
        onRefresh: refreshConfig
    });
    else dialogContent = /*#__PURE__*/ (0, $iKObn.jsx)($53d03ad363ee7b2c$var$Form, {
        onSubmit: handleSubmit(submitForm),
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($53d03ad363ee7b2c$var$ControllersContainer, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                    name: "firstName",
                    control: control,
                    rules: {
                        required: fieldRequiredErrorMessage
                    },
                    render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $5RTr6.FormField), {
                            title: format("settings.accountTab.professionalInformationSection.firstName"),
                            errorMessage: fieldState.error?.message,
                            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                ...field,
                                placeholder: format("settings.accountTab.professionalInformationSection.firstName"),
                                error: fieldState.invalid,
                                inputMode: "text",
                                autoCorrect: "off",
                                autoCapitalize: "none"
                            })
                        })
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                    name: "lastName",
                    control: control,
                    rules: {
                        required: fieldRequiredErrorMessage
                    },
                    render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $5RTr6.FormField), {
                            title: format("settings.accountTab.professionalInformationSection.lastName"),
                            errorMessage: fieldState.error?.message,
                            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                ...field,
                                placeholder: format("settings.accountTab.professionalInformationSection.lastName"),
                                error: fieldState.invalid,
                                inputMode: "text",
                                autoCorrect: "off",
                                autoCapitalize: "none"
                            })
                        })
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                    name: "postalCode",
                    control: control,
                    rules: {
                        required: {
                            value: (0, $lTdpc.isNotNil)(defaultValues.postalCode),
                            message: fieldRequiredErrorMessage
                        },
                        pattern: {
                            value: new RegExp(selectedPostalCodeTemplate?.validationRegex ?? ""),
                            message: format("settings.accountTab.professionalInformationSection.postalCode.errorMessage")
                        }
                    },
                    render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $5RTr6.FormField), {
                            title: format("settings.accountTab.professionalInformationSection.postalCode"),
                            errorMessage: fieldState.error?.message,
                            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                ...field,
                                placeholder: selectedPostalCodeTemplate?.placeholder,
                                error: fieldState.invalid,
                                inputMode: "text",
                                autoCorrect: "off",
                                autoCapitalize: "none"
                            })
                        })
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                    name: "cityOfPractice",
                    control: control,
                    rules: {
                        required: {
                            value: (0, $lTdpc.isNotNil)(defaultValues.cityOfPractice),
                            message: fieldRequiredErrorMessage
                        }
                    },
                    render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $5RTr6.FormField), {
                            title: format("settings.accountTab.professionalInformationSection.cityOfPractice"),
                            errorMessage: fieldState.error?.message,
                            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                ...field,
                                placeholder: format("settings.accountTab.professionalInformationSection.cityOfPractice"),
                                error: fieldState.invalid,
                                inputMode: "text",
                                autoCorrect: "off",
                                autoCapitalize: "none"
                            })
                        })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $gk3fY.BaseDialog), {
        closeOnEscape: false,
        header: format("settings.accountTab.editInfoDialog.header"),
        footer: /*#__PURE__*/ (0, $iKObn.jsx)($53d03ad363ee7b2c$var$ButtonContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                loading: isLoading,
                type: "submit",
                label: format("global.dialog.save"),
                onClick: handleSubmit(submitForm)
            })
        }),
        width: (0, $gk3fY.DIALOG_SIZE).S,
        ...otherProps,
        children: dialogContent
    });
};
const $53d03ad363ee7b2c$var$Form = (0, $5UMQ1.default)((0, $dU78w.motion).form)`
	${(0, $5WGN2.stack)("M", "spacebetween", "stretch")};
	height: 100%;
`;
const $53d03ad363ee7b2c$var$ControllersContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("M", "flexstart", "stretch")};
`;
const $53d03ad363ee7b2c$var$ButtonContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(24, "flexend")}
`;
const $53d03ad363ee7b2c$var$StyledNetworkError = (0, $5UMQ1.default)((0, $28f8Y.NetworkError))`
	margin-top: 8px;
`;

});
parcelRegister("5RTr6", function(module, exports) {

$parcel$export(module.exports, "FormField", () => $2c3f878695137143$export$56e87bf42978147a);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $8FlUV = parcelRequire("8FlUV");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $lTdpc = parcelRequire("lTdpc");
parcelRequire("81g6h");
const $2c3f878695137143$export$56e87bf42978147a = ({ children: children, title: title, errorMessage: errorMessage, className: className })=>/*#__PURE__*/ (0, $iKObn.jsxs)($2c3f878695137143$var$Container, {
        className: className,
        children: [
            (0, $lTdpc.isNotNil)(title) && /*#__PURE__*/ (0, $iKObn.jsx)($2c3f878695137143$var$Title, {
                className: "p-size-m",
                children: title
            }),
            children,
            (0, $lTdpc.isNotNil)(errorMessage) && /*#__PURE__*/ (0, $iKObn.jsx)($2c3f878695137143$var$StyledErrorMessage, {
                children: errorMessage
            })
        ]
    });
const $2c3f878695137143$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(8, "flexstart", "stretch")};
`;
const $2c3f878695137143$var$Title = (0, $5UMQ1.default).label`
	margin-bottom: 8px;
`;
const $2c3f878695137143$var$StyledErrorMessage = (0, $5UMQ1.default)((0, $8FlUV.ErrorMessage))``;

});

parcelRegister("8MrZI", function(module, exports) {

$parcel$export(module.exports, "useRegistrationCountryUserConfig", () => $e91ebd0efae5e5ee$export$aec605802bb5cb63);

var $grmoS = parcelRequire("grmoS");

var $ghfIB = parcelRequire("ghfIB");

var $9EcNY = parcelRequire("9EcNY");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
const $e91ebd0efae5e5ee$export$aec605802bb5cb63 = (selectedIdName, setSelectedIdName)=>{
    const localizeConfig = (0, $1IWnK.useObservable)((0, $ghfIB.countryManager).countryUserConfig);
    const professionalIdentifiers = localizeConfig?.ptProfessionalIds;
    const selectedPostalCodeTemplate = localizeConfig?.postalCode;
    const medicalProfessions = localizeConfig?.ptMedicalProfessions;
    const countryCode = (0, $1IWnK.useObservable)((0, $ghfIB.localeManager).countryCode);
    const idTypeOptions = (0, $81g6h.useMemo)(()=>[
            ...professionalIdentifiers ?? []
        ].map(([name, details])=>({
                value: name,
                label: details.label
            })), [
        professionalIdentifiers
    ]);
    const { medicalProfessionOptions: medicalProfessionOptions } = (0, $9EcNY.useMedicalProfessionOptions)({
        medicalProfessions: medicalProfessions ?? []
    });
    const [fetchProfessionalIdentifiers, isLoading, isError] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(async ()=>await (0, $ghfIB.countryManager).getCountryUserConfig(countryCode), [
        countryCode
    ]), {});
    // Set idType's value to be the first available professional identifiers
    (0, $81g6h.useEffect)(()=>{
        if (professionalIdentifiers && professionalIdentifiers.size > 0 && !professionalIdentifiers.has(selectedIdName ?? "")) {
            const firstIdType = professionalIdentifiers.keys().next().value;
            setSelectedIdName?.(firstIdType);
        }
    }, [
        professionalIdentifiers,
        selectedIdName,
        setSelectedIdName
    ]);
    const selectedIdProps = (0, $81g6h.useMemo)(()=>professionalIdentifiers?.get(selectedIdName ?? ""), [
        selectedIdName,
        professionalIdentifiers
    ]);
    (0, $81g6h.useEffect)(()=>{
        fetchProfessionalIdentifiers();
    }, [
        fetchProfessionalIdentifiers
    ]);
    const isEmpty = (0, $81g6h.useMemo)(()=>professionalIdentifiers?.size === 0, [
        professionalIdentifiers
    ]);
    const refresh = (0, $81g6h.useCallback)(()=>{
        fetchProfessionalIdentifiers();
    }, [
        fetchProfessionalIdentifiers
    ]);
    return {
        isEmpty: isEmpty,
        isLoading: isLoading,
        isError: isError,
        idTypeOptions: idTypeOptions,
        medicalProfessionOptions: medicalProfessionOptions,
        selectedIdProps: selectedIdProps,
        selectedPostalCodeTemplate: selectedPostalCodeTemplate,
        refresh: refresh
    };
};

});
parcelRegister("9EcNY", function(module, exports) {

$parcel$export(module.exports, "useMedicalProfessionOptions", () => $89c4018f70458c62$export$f8fb5ba7e9ff20db);

var $8uAJp = parcelRequire("8uAJp");

var $81g6h = parcelRequire("81g6h");
function $89c4018f70458c62$export$f8fb5ba7e9ff20db({ medicalProfessions: medicalProfessions }) {
    const { formatMedicalProfession: formatMedicalProfession } = (0, $8uAJp.useMedicalProfession)();
    const medicalProfessionOptions = (0, $81g6h.useMemo)(()=>medicalProfessions.map((profession)=>({
                value: profession,
                label: formatMedicalProfession(profession)
            })), [
        formatMedicalProfession,
        medicalProfessions
    ]);
    return {
        medicalProfessionOptions: medicalProfessionOptions
    };
}

});
parcelRegister("8uAJp", function(module, exports) {

$parcel$export(module.exports, "useMedicalProfession", () => $c803d11db5eb24d0$export$7c268d4c4c0fa736);

var $1eHG3 = parcelRequire("1eHG3");

var $afCFk = parcelRequire("afCFk");

var $81g6h = parcelRequire("81g6h");
const $c803d11db5eb24d0$var$ALL_MEDICAL_PROFESSIONS_TRANSLATION_KEYS = {
    [(0, $afCFk.MedicalProfession).EmployedPT]: "global.medicalProfession.employedPt",
    [(0, $afCFk.MedicalProfession).IndependentPT]: "global.medicalProfession.independentPt",
    [(0, $afCFk.MedicalProfession).OccupationalPT]: "global.medicalProfession.occupationalPt",
    [(0, $afCFk.MedicalProfession).PmrPhysician]: "global.medicalProfession.pmrPhysician",
    [(0, $afCFk.MedicalProfession).Eapa]: "global.medicalProfession.eapa",
    [(0, $afCFk.MedicalProfession).PsychomotorTherapist]: "global.medicalProfession.psychomotorTherapist",
    [(0, $afCFk.MedicalProfession).Neurologist]: "global.medicalProfession.neurologist",
    [(0, $afCFk.MedicalProfession).Other]: "global.medicalProfession.other",
    [(0, $afCFk.MedicalProfession).None]: "global.medicalProfession.none"
};
function $c803d11db5eb24d0$export$7c268d4c4c0fa736() {
    const { format: format } = (0, $1eHG3.useI18n)();
    const formatMedicalProfession = (0, $81g6h.useCallback)((profession)=>(0, $afCFk.medicalProfessions).includes(profession) ? format($c803d11db5eb24d0$var$ALL_MEDICAL_PROFESSIONS_TRANSLATION_KEYS[profession]) : format("global.empty"), [
        format
    ]);
    return {
        formatMedicalProfession: formatMedicalProfession
    };
}

});
parcelRegister("afCFk", function(module, exports) {

$parcel$export(module.exports, "MedicalProfession", () => $205df1aaa5b3791c$export$1e1eed33f3dcd4f6);
$parcel$export(module.exports, "medicalProfessions", () => $205df1aaa5b3791c$export$56c3925fe3a9700b);

var $d90o3 = parcelRequire("d90o3");
var $205df1aaa5b3791c$export$1e1eed33f3dcd4f6;
(function(MedicalProfession) {
    MedicalProfession["IndependentPT"] = "INDEPENDENT_PT";
    MedicalProfession["EmployedPT"] = "EMPLOYED_PT";
    MedicalProfession["OccupationalPT"] = "OCCUPATIONAL_PT";
    MedicalProfession["PmrPhysician"] = "PMR_PHYSICIAN";
    MedicalProfession["PsychomotorTherapist"] = "PSYCHOMOTOR_THERAPIST";
    MedicalProfession["Eapa"] = "EAPA";
    MedicalProfession["Neurologist"] = "NEUROLOGIST";
    MedicalProfession["Other"] = "OTHER";
    MedicalProfession["None"] = "NONE";
})($205df1aaa5b3791c$export$1e1eed33f3dcd4f6 || ($205df1aaa5b3791c$export$1e1eed33f3dcd4f6 = {}));
const $205df1aaa5b3791c$export$56c3925fe3a9700b = (0, $d90o3.getEnumValues)($205df1aaa5b3791c$export$1e1eed33f3dcd4f6);

});





parcelRegister("aw1du", function(module, exports) {

$parcel$export(module.exports, "AssignTemplateDialog", () => $4243e708ed4ba091$export$1f2f4852a15052d1);

var $iKObn = parcelRequire("iKObn");

var $TSc86 = parcelRequire("TSc86");

var $he9Ds = parcelRequire("he9Ds");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $eAmnG = parcelRequire("eAmnG");

var $iBbjf = parcelRequire("iBbjf");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $1IlhR = parcelRequire("1IlhR");

var $lQZUP = parcelRequire("lQZUP");

var $lDZlX = parcelRequire("lDZlX");

var $4Y3GU = parcelRequire("4Y3GU");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $dU78w = parcelRequire("dU78w");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");

var $8Yj45 = parcelRequire("8Yj45");

var $gk3fY = parcelRequire("gk3fY");
var $4243e708ed4ba091$var$AssignTemplateIcon = function AssignTemplateIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                opacity: ".5",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "path-1-inside-1_2402_42315",
                        fill: "#fff",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M0 9.008A9.008 9.008 0 0 1 9.008 0h151.254a9.007 9.007 0 0 1 9.007 9.008v101.38a9.006 9.006 0 0 1-9.007 9.007H9.008A9.007 9.007 0 0 1 0 110.388V9.008Z"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M0 9.008A9.008 9.008 0 0 1 9.008 0h151.254a9.007 9.007 0 0 1 9.007 9.008v101.38a9.006 9.006 0 0 1-9.007 9.007H9.008A9.007 9.007 0 0 1 0 110.388V9.008Z",
                        fill: "#F6F6FE"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M9.008 5.63h151.254V-5.63H9.008V5.63ZM163.64 9.008v101.38h11.259V9.008H163.64Zm-3.378 104.758H9.008v11.259h151.254v-11.259ZM5.63 110.388V9.008H-5.63v101.38H5.63Zm3.378 3.378a3.378 3.378 0 0 1-3.378-3.378H-5.63c0 8.084 6.554 14.637 14.638 14.637v-11.259Zm154.632-3.378a3.379 3.379 0 0 1-3.378 3.378v11.259c8.084 0 14.637-6.553 14.637-14.637H163.64ZM160.262 5.63a3.378 3.378 0 0 1 3.378 3.378h11.259c0-8.084-6.553-14.638-14.637-14.638V5.63ZM9.008-5.63C.924-5.63-5.63.924-5.63 9.008H5.63A3.378 3.378 0 0 1 9.008 5.63V-5.63Z",
                        fill: "#434CE5",
                        mask: "url(#path-1-inside-1_2402_42315)"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "path-3-inside-2_2402_42315",
                        fill: "#fff",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M0 9.008A9.008 9.008 0 0 1 9.008 0h151.254a9.007 9.007 0 0 1 9.007 9.008V24.18H0V9.008Z"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M169.269 24.181v5.63h5.63v-5.63h-5.63ZM0 24.181h-5.63v5.63H0v-5.63ZM9.008 5.63h151.254V-5.63H9.008V5.63ZM163.64 9.008V24.18h11.259V9.008H163.64Zm5.629 9.544H0v11.26h169.269v-11.26Zm-163.64 5.63V9.007H-5.63V24.18H5.63ZM160.263 5.63a3.378 3.378 0 0 1 3.378 3.378h11.259c0-8.084-6.553-14.638-14.637-14.638V5.63ZM9.008-5.63C.924-5.63-5.63.924-5.63 9.008H5.63A3.378 3.378 0 0 1 9.008 5.63V-5.63Z",
                        fill: "#434CE5",
                        mask: "url(#path-3-inside-2_2402_42315)"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("circle", {
                        cx: "10.577",
                        cy: "12.091",
                        r: "3.023",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("circle", {
                        cx: "21.155",
                        cy: "12.091",
                        r: "3.023",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("circle", {
                        cx: "31.734",
                        cy: "12.091",
                        r: "3.023",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                        x: "7.555",
                        y: "29.471",
                        width: "24.937",
                        height: "11.335",
                        rx: "2.252",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                        x: "134.508",
                        y: "29.471",
                        width: "24.937",
                        height: "11.335",
                        rx: "2.252",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                        x: "39.293",
                        y: "29.471",
                        width: "24.937",
                        height: "11.335",
                        rx: "2.252",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                        x: "71.027",
                        y: "29.471",
                        width: "24.937",
                        height: "11.335",
                        rx: "2.252",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                        x: "102.766",
                        y: "29.471",
                        width: "24.937",
                        height: "11.335",
                        rx: "2.252",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                        x: "7.555",
                        y: "46.851",
                        width: "24.937",
                        height: "12.091",
                        rx: "2.252",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                        x: "134.508",
                        y: "46.851",
                        width: "24.937",
                        height: "12.091",
                        rx: "2.252",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                        x: "39.293",
                        y: "46.851",
                        width: "24.937",
                        height: "12.091",
                        rx: "2.252",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                        x: "102.766",
                        y: "46.851",
                        width: "24.937",
                        height: "12.091",
                        rx: "2.252",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                        x: "7.555",
                        y: "64.232",
                        width: "24.937",
                        height: "12.091",
                        rx: "2.252",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                        x: "134.508",
                        y: "64.232",
                        width: "24.937",
                        height: "12.091",
                        rx: "2.252",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                        x: "102.766",
                        y: "64.232",
                        width: "24.937",
                        height: "12.091",
                        rx: "2.252",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                        x: "7.555",
                        y: "81.612",
                        width: "24.937",
                        height: "12.091",
                        rx: "2.252",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                        x: "134.508",
                        y: "81.612",
                        width: "24.937",
                        height: "12.091",
                        rx: "2.252",
                        fill: "#434CE5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                        x: "134.508",
                        y: "99.748",
                        width: "24.937",
                        height: "11.335",
                        rx: "2.252",
                        fill: "#434CE5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "path-23-inside-3_2402_42315",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M130.73 73.24a9.008 9.008 0 0 1 9.008-9.008h151.254A9.008 9.008 0 0 1 300 73.239V174.62a9.008 9.008 0 0 1-9.008 9.007H139.738a9.008 9.008 0 0 1-9.008-9.007V73.24Z"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M130.73 73.24a9.008 9.008 0 0 1 9.008-9.008h151.254A9.008 9.008 0 0 1 300 73.239V174.62a9.008 9.008 0 0 1-9.008 9.007H139.738a9.008 9.008 0 0 1-9.008-9.007V73.24Z",
                fill: "#F6F6FE"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M139.738 69.861h151.254V58.602H139.738v11.26ZM294.37 73.24V174.62h11.26V73.24h-11.26Zm-3.378 104.758H139.738v11.26h151.254v-11.26ZM136.36 174.62V73.24h-11.259v101.38h11.259Zm3.378 3.377a3.377 3.377 0 0 1-3.378-3.377h-11.259c0 8.083 6.553 14.637 14.637 14.637v-11.26Zm154.632-3.377a3.377 3.377 0 0 1-3.378 3.377v11.26c8.084 0 14.638-6.553 14.638-14.637h-11.26Zm-3.378-104.759a3.378 3.378 0 0 1 3.378 3.378h11.26c0-8.084-6.554-14.637-14.638-14.637v11.26ZM139.738 58.602c-8.084 0-14.637 6.553-14.637 14.637h11.259a3.378 3.378 0 0 1 3.378-3.378V58.602Z",
                fill: "#434CE5",
                mask: "url(#path-23-inside-3_2402_42315)"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M130.73 73.24a9.008 9.008 0 0 1 9.008-9.008h151.254A9.008 9.008 0 0 1 300 73.239v15.174H130.73V73.239Z",
                fill: "#434CE5"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("circle", {
                cx: "141.312",
                cy: "76.323",
                r: "3.023",
                fill: "#F6F6FE"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("circle", {
                cx: "151.89",
                cy: "76.323",
                r: "3.023",
                fill: "#F6F6FE"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("circle", {
                cx: "162.468",
                cy: "76.323",
                r: "3.023",
                fill: "#F6F6FE"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M215.365 108.816a10.076 10.076 0 1 0 .001 20.152 10.076 10.076 0 0 0-.001-20.152Zm0 27.708c-7.566 0-22.67 3.798-22.67 11.335v3.778a2.52 2.52 0 0 0 2.519 2.519h40.302a2.52 2.52 0 0 0 2.519-2.519v-3.778c0-7.537-15.103-11.335-22.67-11.335Z",
                fill: "#434CE5"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M213.773 60.534c.88.88 2.305.88 3.185 0l14.331-14.331a2.253 2.253 0 0 0-3.185-3.185l-12.738 12.739-12.739-12.739a2.252 2.252 0 0 0-3.185 3.185l14.331 14.33Zm1.593-16.01h2.251-2.251Zm-68.011-6.756h59.003v-4.504h-59.003v4.504Zm65.759 6.755v14.419h4.503V44.523h-4.503Zm-6.756-6.755a6.756 6.756 0 0 1 6.756 6.755h4.503c0-6.218-5.041-11.259-11.259-11.259v4.504ZM126.76 132.916c.88.879.88 2.305 0 3.185l-14.331 14.331a2.252 2.252 0 0 1-3.184-3.185l12.738-12.739-12.738-12.738a2.251 2.251 0 1 1 3.184-3.185l14.331 14.331Zm-65.612 1.592v-2.252 2.252Zm-6.756-81.612v72.605H49.89V52.896h4.503Zm6.756 79.36h64.02v4.504h-64.02v-4.504Zm-6.756-6.755a6.755 6.755 0 0 0 6.756 6.755v4.504c-6.218 0-11.26-5.041-11.26-11.259h4.505Z",
                fill: "#00099E"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("circle", {
                cx: "52.139",
                cy: "52.896",
                r: "4.534",
                fill: "#00099E"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("circle", {
                cx: "146.596",
                cy: "35.516",
                r: "4.534",
                fill: "#00099E"
            })
        ]
    });
};
$4243e708ed4ba091$var$AssignTemplateIcon.defaultProps = {
    viewBox: "0 0 300 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $4243e708ed4ba091$export$1f2f4852a15052d1 = ({ template: template, onCancel: onCancel, onHide: onHide, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    const { control: control, handleSubmit: handleSubmit } = (0, $eKUeg.useForm)({
        defaultValues: {
            name: template.name,
            patient: undefined
        }
    });
    const [submittedPatient, setSubmittedPatient] = (0, $81g6h.useState)(null);
    const [assignTemplate, loadingSubmit] = (0, $grmoS.useAsyncOperation)(async ({ patient: selectedPatient, name: name })=>{
        try {
            setSubmittedPatient(selectedPatient);
            const days = template.days;
            const newProgram = {
                name: name,
                days: days
            };
            const [programMetadata] = await Promise.all([
                (0, $ghfIB.templateOperationsManager).performAssignOperation(selectedPatient.id, newProgram),
                (0, $ghfIB.getStartedManager).tryMarkProgramsStepAsCompleted(),
                (0, $TSc86.delay)(3000)
            ]);
            const exerciseDetails = (0, $eAmnG.getProgramDetails)(days);
            (0, $iBbjf.sendAnalyticsEventAssignProgram)(selectedPatient.analyticsId, programMetadata.id, days, exerciseDetails);
            navigate((0, $lDZlX.RoutesPath).ProgramBuilder, {
                route: {
                    patientId: selectedPatient.id
                },
                query: {
                    programId: programMetadata.id
                }
            }, {
                replace: true
            });
            onHide();
        } catch (e) {
            console.error("Failure to assign template to patient", e);
        }
    }, {
        deps: [
            navigate,
            otherProps,
            template
        ]
    });
    (0, $81g6h.useEffect)(()=>{
        if (!loadingSubmit) setSubmittedPatient(null);
    }, [
        loadingSubmit
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $8Yj45.RestrictedDialog), {
        onHide: ()=>{
            onHide();
            onCancel();
        },
        context: "AssignTemplate",
        header: format("templateBuilder.assignTemplateDialog.title"),
        footer: loadingSubmit && submittedPatient ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {}) : /*#__PURE__*/ (0, $iKObn.jsx)($4243e708ed4ba091$var$ButtonContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                label: format("templateBuilder.assignTemplateDialog.submitButton"),
                onClick: handleSubmit(assignTemplate),
                type: "submit"
            })
        }),
        width: (0, $gk3fY.DIALOG_SIZE).S,
        ...otherProps,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($4243e708ed4ba091$var$DialogContainer, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)($4243e708ed4ba091$var$Form, {
                    onSubmit: handleSubmit(assignTemplate),
                    children: /*#__PURE__*/ (0, $iKObn.jsxs)($4243e708ed4ba091$var$FormContainer, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)($4243e708ed4ba091$var$FormField, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                        className: "p-size-m",
                                        children: format("programBuilder.startDialog.programName.label")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                                        name: "name",
                                        control: control,
                                        rules: {
                                            required: format("global.form.field.requiredError"),
                                            maxLength: {
                                                value: (0, $he9Ds.APP_CONSTANTS).PROGRAM_OR_TEMPLATE_MAX_TITLE_LENGTH,
                                                message: format("global.programName.maxLength")
                                            }
                                        },
                                        render: ({ field: { onChange: onChange, value: value, ...otherFields }, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $lQZUP.TextAreaWithCharLimit), {
                                                ...otherFields,
                                                autoComplete: "off",
                                                autoFocus: !value,
                                                text: value,
                                                onTextChange: onChange,
                                                errorMessage: fieldState.error?.message,
                                                charLimit: (0, $he9Ds.APP_CONSTANTS).PROGRAM_OR_TEMPLATE_MAX_TITLE_LENGTH,
                                                placeholder: format("programBuilder.startDialog.programName.placeholder")
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)($4243e708ed4ba091$var$FormField, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                        className: "p-size-m",
                                        children: format("templateBuilder.assignTemplateDialog.patientInput.label")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $4Y3GU.PatientAutocomplete), {
                                        control: control,
                                        name: "patient"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            loadingSubmit && submittedPatient && /*#__PURE__*/ (0, $iKObn.jsxs)($4243e708ed4ba091$var$LoadingCover, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        className: "p-size-l",
                        style: {
                            textAlign: "center"
                        },
                        children: format("templateBuilder.assignTemplateDialog.loading.v2_6", {
                            name: submittedPatient.name
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {
                        style: {
                            height: "unset"
                        }
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($4243e708ed4ba091$var$AssignTemplateIcon, {
                        width: 300,
                        height: 184
                    })
                ]
            })
        ]
    });
};
const $4243e708ed4ba091$var$DialogContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("M", "flexstart", "stretch")};
	height: 100%;
`;
const $4243e708ed4ba091$var$ButtonContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("S", "flexend")}
`;
const $4243e708ed4ba091$var$Form = (0, $5UMQ1.default)((0, $dU78w.motion).form)`
	${(0, $5WGN2.stack)("M", "spacebetween", "stretch")}
	height: 100%;
`;
const $4243e708ed4ba091$var$FormContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("M", "flexstart", "stretch")}
`;
const $4243e708ed4ba091$var$FormField = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("S", "flexstart", "stretch")};
`;
const $4243e708ed4ba091$var$LoadingCover = (0, $5UMQ1.default).div`
	position: absolute;
	inset: 0;
	background-color: ${(0, $kKnoQ.colors).white};
	border-radius: 1rem;
	padding: 32px 40px;
	height: 100%;
	${(0, $5WGN2.stack)(32, "center", "center")};
`;

});
parcelRegister("4Y3GU", function(module, exports) {

$parcel$export(module.exports, "PatientAutocomplete", () => $a3745727f300db67$export$f8a52aadf8938953);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $aEP4N = parcelRequire("aEP4N");

var $5UMQ1 = parcelRequire("5UMQ1");

var $8FlUV = parcelRequire("8FlUV");

var $aFn0C = parcelRequire("aFn0C");

var $1IlhR = parcelRequire("1IlhR");
parcelRequire("42FK8");
var $kwJi4 = parcelRequire("kwJi4");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $buI4E = parcelRequire("buI4E");

var $jTpg0 = parcelRequire("jTpg0");

var $2H1Ut = parcelRequire("2H1Ut");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
function $a3745727f300db67$var$isSelectablePatientItem(patientItem) {
    return patientItem.selectable;
}
const $a3745727f300db67$export$f8a52aadf8938953 = ({ control: control, name: name })=>{
    const { patientNames: patientNames, loading: loading } = (0, $aEP4N.usePatientNames)();
    const { format: format } = (0, $1eHG3.useI18n)();
    const [query, setQuery] = (0, $81g6h.useState)("");
    const autoCompleteRef = (0, $81g6h.useRef)(null);
    const allPatientsWithName = (0, $81g6h.useMemo)(()=>patientNames.map((patient)=>({
                id: patient.id,
                analyticsId: patient.analyticsId,
                name: (0, $buI4E.formatName)(patient),
                selectable: true
            })).sort((p1, p2)=>p1.name.localeCompare(p2.name)).filter($a3745727f300db67$var$isSelectablePatientItem), [
        patientNames
    ]);
    const findPatientWithNameFromString = (0, $81g6h.useCallback)((searchedValue)=>allPatientsWithName.find((patient)=>(0, $buI4E.removeDiacriticsFromString)(patient.name).toLowerCase().trim() === (0, $buI4E.removeDiacriticsFromString)(searchedValue).toLowerCase().trim()), [
        allPatientsWithName
    ]);
    const filteredPatients = (0, $81g6h.useMemo)(()=>{
        const trimmedPatients = allPatientsWithName.filter((patient)=>{
            const trimmedQuery = (0, $buI4E.removeDiacriticsFromString)(query).toLowerCase().trim();
            const patientName = (0, $buI4E.removeDiacriticsFromString)(patient.name).toLowerCase().trim();
            return (0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).isEmpty(trimmedQuery) ? true : patientName.includes(trimmedQuery);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).isEmpty(trimmedPatients) ? [
            {
                name: format("templateBuilder.assignTemplateDialog.patientInput.emptyList"),
                selectable: false
            }
        ] : trimmedPatients;
    }, [
        allPatientsWithName,
        format,
        query
    ]);
    const itemRenderTemplate = (0, $81g6h.useCallback)((currentPatient)=>{
        if (loading) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {
            style: {
                height: 20
            }
        });
        if (currentPatient.selectable) return /*#__PURE__*/ (0, $iKObn.jsx)($a3745727f300db67$var$DropDownItem, {
            name: currentPatient.name,
            queryString: query
        });
        return currentPatient.name;
    }, [
        loading,
        query
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
        name: name,
        control: control,
        rules: {
            required: format("global.form.field.requiredError"),
            validate: (value)=>{
                if (typeof value === "string") return format("templateBuilder.assignTemplateDialog.patientInput.incorrectPatient");
            }
        },
        render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($a3745727f300db67$var$StyledAutoComplete, {
                        ...field,
                        inputClassName: fieldState.error ? "p-invalid" : undefined,
                        onChange: (e)=>{
                            if (typeof e.value === "string") {
                                setQuery(e.value);
                                const patient = findPatientWithNameFromString(e.value);
                                if ((0, $lTdpc.isNotNil)(patient)) field.onChange(patient);
                                else field.onChange(e);
                            } else {
                                const selectedPatient = e.value;
                                if (selectedPatient.selectable) field.onChange(e);
                            }
                        },
                        ref: autoCompleteRef,
                        onClick: ()=>autoCompleteRef.current?.show(),
                        onClear: ()=>autoCompleteRef.current?.show(),
                        onFocus: ()=>{
                            if (typeof field.value === "string") autoCompleteRef.current?.show();
                        },
                        suggestions: filteredPatients,
                        field: "name",
                        itemTemplate: itemRenderTemplate,
                        placeholder: format("templateBuilder.assignTemplateDialog.patientInput.placeholder"),
                        panelFooterTemplate: $a3745727f300db67$var$AutoCompleteFooter,
                        panelStyle: {
                            maxWidth: 400
                        }
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $8FlUV.ErrorMessage), {
                        children: fieldState.error?.message
                    })
                ]
            })
    });
};
const $a3745727f300db67$var$AutoCompleteFooter = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)($a3745727f300db67$var$StyledFooter, {
        children: /*#__PURE__*/ (0, $iKObn.jsx)($a3745727f300db67$var$FooterText, {
            className: "p-size-xs",
            children: format("templateBuilder.assignTemplateDialog.patientInput.footerMessage")
        })
    });
};
const $a3745727f300db67$var$FooterText = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).grey80};
`;
const $a3745727f300db67$var$StyledFooter = (0, $5UMQ1.default).div`
	border-top: 1px solid ${(0, $kKnoQ.colors).grey25};
	padding: 12px ${(0, $kwJi4.spacings).S};
`;
const $a3745727f300db67$var$StyledAutoComplete = (0, $5UMQ1.default)((0, $2H1Ut.AutoComplete))`
	input {
		width: 100%;
		border-radius: 0.5rem !important;
	}
`;
const $a3745727f300db67$var$DropDownItem = ({ name: name, queryString: queryString })=>/*#__PURE__*/ (0, $iKObn.jsx)("div", {
        className: "p-size-s",
        style: {
            color: (0, $kKnoQ.colors).grey
        },
        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $aFn0C.HighlightedString), {
            text: name,
            queryString: queryString
        })
    });

});
parcelRegister("aFn0C", function(module, exports) {

$parcel$export(module.exports, "HighlightedString", () => $af5c78d57dc43093$export$80e428abbd483312);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");

var $buI4E = parcelRequire("buI4E");

var $81g6h = parcelRequire("81g6h");
const $af5c78d57dc43093$export$80e428abbd483312 = ({ text: text, queryString: queryString })=>{
    const stringParts = (0, $81g6h.useMemo)(()=>(0, $buI4E.splitTextWithQueryString)(text, queryString), [
        queryString,
        text
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
        children: stringParts.map((substring, index)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $81g6h.Fragment), {
                children: substring.isQueryString ? /*#__PURE__*/ (0, $iKObn.jsx)($af5c78d57dc43093$var$HighlightedSpan, {
                    children: substring.text
                }) : /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                    children: substring.text
                })
            }, `${substring.text}-${index}`))
    });
};
const $af5c78d57dc43093$var$HighlightedSpan = (0, $5UMQ1.default).span`
	font-weight: bold;
	background-color: ${(0, $kKnoQ.colors).primary10};
	border-radius: 0.1em;
`;

});

parcelRegister("2H1Ut", function(module, exports) {

$parcel$export(module.exports, "AutoComplete", () => $1f61142c64ee961a$export$6b41f50dc0c59fb3);

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $9AWgp = parcelRequire("9AWgp");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $jhJol = parcelRequire("jhJol");

var $dPQhb = parcelRequire("dPQhb");

var $6BqT9 = parcelRequire("6BqT9");

var $6ccvc = parcelRequire("6ccvc");

var $k7ffa = parcelRequire("k7ffa");

var $7hMfd = parcelRequire("7hMfd");

var $cfkGk = parcelRequire("cfkGk");

var $lbdsH = parcelRequire("lbdsH");

var $6b4aU = parcelRequire("6b4aU");

var $9rbaG = parcelRequire("9rbaG");

var $2Sldw = parcelRequire("2Sldw");
"use client";
function $1f61142c64ee961a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1f61142c64ee961a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1f61142c64ee961a$var$_typeof(o);
}
function $1f61142c64ee961a$var$_toPrimitive(input, hint) {
    if ($1f61142c64ee961a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1f61142c64ee961a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1f61142c64ee961a$var$_toPropertyKey(arg) {
    var key = $1f61142c64ee961a$var$_toPrimitive(arg, "string");
    return $1f61142c64ee961a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1f61142c64ee961a$var$_defineProperty(obj, key, value) {
    key = $1f61142c64ee961a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1f61142c64ee961a$var$_extends() {
    $1f61142c64ee961a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1f61142c64ee961a$var$_extends.apply(this, arguments);
}
function $1f61142c64ee961a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1f61142c64ee961a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1f61142c64ee961a$var$_arrayLikeToArray(arr);
}
function $1f61142c64ee961a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1f61142c64ee961a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1f61142c64ee961a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1f61142c64ee961a$var$_arrayLikeToArray(o, minLen);
}
function $1f61142c64ee961a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1f61142c64ee961a$var$_toConsumableArray(arr) {
    return $1f61142c64ee961a$var$_arrayWithoutHoles(arr) || $1f61142c64ee961a$var$_iterableToArray(arr) || $1f61142c64ee961a$var$_unsupportedIterableToArray(arr) || $1f61142c64ee961a$var$_nonIterableSpread();
}
function $1f61142c64ee961a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1f61142c64ee961a$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $1f61142c64ee961a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1f61142c64ee961a$var$_slicedToArray(arr, i) {
    return $1f61142c64ee961a$var$_arrayWithHoles(arr) || $1f61142c64ee961a$var$_iterableToArrayLimit(arr, i) || $1f61142c64ee961a$var$_unsupportedIterableToArray(arr, i) || $1f61142c64ee961a$var$_nonIterableRest();
}
var $1f61142c64ee961a$var$classes = {
    root: function root(_ref) {
        var props = _ref.props, focusedState = _ref.focusedState;
        return (0, $cfkGk.classNames)("p-autocomplete p-component p-inputwrapper", {
            "p-autocomplete-dd": props.dropdown,
            "p-autocomplete-multiple": props.multiple,
            "p-inputwrapper-filled": props.value,
            "p-invalid": props.invalid,
            "p-inputwrapper-focus": focusedState
        });
    },
    container: function container(_ref2) {
        var props = _ref2.props, context = _ref2.context;
        return (0, $cfkGk.classNames)("p-autocomplete-multiple-container p-component p-inputtext", {
            "p-disabled": props.disabled,
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled"
        });
    },
    loadingIcon: "p-autocomplete-loader",
    dropdownButton: "p-autocomplete-dropdown",
    removeTokenIcon: "p-autocomplete-token-icon",
    token: "p-autocomplete-token p-highlight",
    tokenLabel: "p-autocomplete-token-label",
    inputToken: "p-autocomplete-input-token",
    input: function input(_ref3) {
        var props = _ref3.props, context = _ref3.context;
        return (0, $cfkGk.classNames)("p-autocomplete-input", {
            "p-autocomplete-dd-input": props.dropdown,
            "p-variant-filled": props.variant ? props.variant === "filled" : context && context.inputStyle === "filled"
        });
    },
    panel: function panel(_ref4) {
        var context = _ref4.context;
        return (0, $cfkGk.classNames)("p-autocomplete-panel p-component", {
            "p-ripple-disabled": context && context.ripple === false || (0, $8Zwsm.default).ripple === false
        });
    },
    listWrapper: "p-autocomplete-items-wrapper",
    list: function list(_ref5) {
        var virtualScrollerOptions = _ref5.virtualScrollerOptions, options = _ref5.options;
        return virtualScrollerOptions ? (0, $cfkGk.classNames)("p-autocomplete-items", options.className) : "p-autocomplete-items";
    },
    emptyMessage: "p-autocomplete-item",
    item: function item(_ref6) {
        var suggestion = _ref6.suggestion, optionGroupLabel = _ref6.optionGroupLabel;
        return optionGroupLabel ? (0, $cfkGk.classNames)("p-autocomplete-item", {
            "p-disabled": suggestion.disabled
        }) : (0, $cfkGk.classNames)("p-autocomplete-item", {
            "p-disabled": suggestion.disabled
        });
    },
    itemGroup: "p-autocomplete-item-group",
    footer: "p-autocomplete-footer",
    transition: "p-connected-overlay"
};
var $1f61142c64ee961a$var$styles = "\n@layer primereact {\n    .p-autocomplete {\n        display: inline-flex;\n        position: relative;\n    }\n    \n    .p-autocomplete-loader {\n        position: absolute;\n        top: 50%;\n        margin-top: -.5rem;\n    }\n    \n    .p-autocomplete-dd .p-autocomplete-input {\n        flex: 1 1 auto;\n        width: 1%;\n    }\n    \n    .p-autocomplete-dd .p-autocomplete-input,\n    .p-autocomplete-dd .p-autocomplete-multiple-container {\n         border-top-right-radius: 0;\n         border-bottom-right-radius: 0;\n     }\n    \n    .p-autocomplete-dd .p-autocomplete-dropdown {\n         border-top-left-radius: 0;\n         border-bottom-left-radius: 0px;\n    }\n    \n    .p-autocomplete .p-autocomplete-panel {\n        min-width: 100%;\n    }\n    \n    .p-autocomplete-panel {\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n    \n    .p-autocomplete-items {\n        margin: 0;\n        padding: 0;\n        list-style-type: none;\n    }\n    \n    .p-autocomplete-item {\n        cursor: pointer;\n        white-space: nowrap;\n        position: relative;\n        overflow: hidden;\n    }\n    \n    .p-autocomplete-multiple-container {\n        margin: 0;\n        padding: 0;\n        list-style-type: none;\n        cursor: text;\n        overflow: hidden;\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n    }\n    \n    .p-autocomplete-token {\n        cursor: default;\n        display: inline-flex;\n        align-items: center;\n        flex: 0 0 auto;\n    }\n    \n    .p-autocomplete-token-icon {\n        cursor: pointer;\n    }\n    \n    .p-autocomplete-input-token {\n        flex: 1 1 auto;\n        display: inline-flex;\n    }\n    \n    .p-autocomplete-input-token input {\n        border: 0 none;\n        outline: 0 none;\n        background-color: transparent;\n        margin: 0;\n        padding: 0;\n        box-shadow: none;\n        border-radius: 0;\n        width: 100%;\n    }\n    \n    .p-fluid .p-autocomplete {\n        display: flex;\n    }\n    \n    .p-fluid .p-autocomplete-dd .p-autocomplete-input {\n        width: 1%;\n    }\n    \n    .p-autocomplete-items-wrapper {\n        overflow: auto;\n    } \n}\n";
var $1f61142c64ee961a$var$AutoCompleteBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "AutoComplete",
        id: null,
        appendTo: null,
        autoFocus: false,
        autoHighlight: false,
        className: null,
        completeMethod: null,
        delay: 300,
        disabled: false,
        dropdown: false,
        dropdownAriaLabel: null,
        dropdownAutoFocus: true,
        dropdownIcon: null,
        dropdownMode: "blank",
        emptyMessage: null,
        field: null,
        forceSelection: false,
        inputClassName: null,
        inputId: null,
        inputRef: null,
        inputStyle: null,
        variant: null,
        invalid: false,
        itemTemplate: null,
        loadingIcon: null,
        maxLength: null,
        minLength: 1,
        multiple: false,
        name: null,
        onBlur: null,
        onChange: null,
        onClear: null,
        onClick: null,
        onContextMenu: null,
        onDblClick: null,
        onDropdownClick: null,
        onFocus: null,
        onHide: null,
        onKeyPress: null,
        onKeyUp: null,
        onMouseDown: null,
        onSelect: null,
        onShow: null,
        onUnselect: null,
        optionGroupChildren: null,
        optionGroupLabel: null,
        optionGroupTemplate: null,
        panelClassName: null,
        panelFooterTemplate: null,
        panelStyle: null,
        placeholder: null,
        readOnly: false,
        removeTokenIcon: null,
        scrollHeight: "200px",
        selectedItemTemplate: null,
        selectionLimit: null,
        showEmptyMessage: false,
        size: null,
        style: null,
        suggestions: null,
        tabIndex: null,
        tooltip: null,
        tooltipOptions: null,
        transitionOptions: null,
        type: "text",
        value: null,
        virtualScrollerOptions: null,
        children: undefined
    },
    css: {
        classes: $1f61142c64ee961a$var$classes,
        styles: $1f61142c64ee961a$var$styles
    }
});
function $1f61142c64ee961a$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1f61142c64ee961a$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1f61142c64ee961a$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $1f61142c64ee961a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1f61142c64ee961a$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1f61142c64ee961a$var$AutoCompletePanel = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(props, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var ptm = props.ptm, cx = props.cx;
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var _ptm = function _ptm(key, options) {
        return ptm(key, $1f61142c64ee961a$var$_objectSpread$1({
            hostName: props.hostName
        }, options));
    };
    var getPTOptions = function getPTOptions(item, key) {
        return _ptm(key, {
            context: {
                selected: props.selectedItem.current === item,
                disabled: item.disabled
            }
        });
    };
    var getOptionGroupRenderKey = function getOptionGroupRenderKey(optionGroup) {
        return (0, $cfkGk.ObjectUtils).resolveFieldData(optionGroup, props.optionGroupLabel);
    };
    var getOptionRenderKey = function getOptionRenderKey(option) {
        return (0, $cfkGk.ObjectUtils).resolveFieldData(option, props.field);
    };
    var createFooter = function createFooter() {
        if (props.panelFooterTemplate) {
            var content = (0, $cfkGk.ObjectUtils).getJSXElement(props.panelFooterTemplate, props, props.onOverlayHide);
            var footerProps = mergeProps({
                className: cx("footer")
            }, _ptm("footer"));
            return /*#__PURE__*/ $81g6h.createElement("div", footerProps, content);
        }
        return null;
    };
    var findKeyIndex = function findKeyIndex(array, key, value) {
        return array.findIndex(function(obj) {
            return obj[key] === value;
        });
    };
    var latestKey = $81g6h.useRef({
        key: null,
        index: 0,
        keyIndex: 0
    });
    var createLabelItem = function createLabelItem(item, key, index, labelItemProps) {
        var content = props.optionGroupTemplate ? (0, $cfkGk.ObjectUtils).getJSXElement(props.optionGroupTemplate, item, index) : props.getOptionGroupLabel(item) || item;
        var itemGroupProps = mergeProps($1f61142c64ee961a$var$_objectSpread$1({
            index: index,
            key: key ? key : null,
            className: cx("itemGroup"),
            "data-p-highlight": false
        }, labelItemProps), _ptm("itemGroup"));
        return /*#__PURE__*/ $81g6h.createElement("li", itemGroupProps, content);
    };
    var createListItem = function createListItem(item, key, index, listItemProps) {
        var selected = (0, $cfkGk.ObjectUtils).deepEquals(props.selectedItem, item);
        var content = props.itemTemplate ? (0, $cfkGk.ObjectUtils).getJSXElement(props.itemTemplate, item, index) : props.field ? (0, $cfkGk.ObjectUtils).resolveFieldData(item, props.field) : item;
        var itemProps = mergeProps($1f61142c64ee961a$var$_objectSpread$1({
            index: index,
            role: "option",
            className: cx("item", {
                optionGroupLabel: props.optionGroupLabel,
                suggestion: item
            }),
            onClick: function onClick(e) {
                return props.onItemClick(e, item);
            },
            "aria-selected": selected
        }, listItemProps), getPTOptions(item, "item"));
        return /*#__PURE__*/ $81g6h.createElement("li", $1f61142c64ee961a$var$_extends({
            key: key
        }, itemProps), content, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
    };
    var createGroupChildren = function createGroupChildren(optionGroup, i) {
        var groupChildren = props.getOptionGroupChildren(optionGroup);
        return groupChildren.map(function(item, j) {
            var key = i + "_" + j;
            var itemProps = mergeProps({
                "data-group": i,
                "data-index": j,
                "data-p-disabled": item.disabled
            });
            return createListItem(item, key, j, itemProps);
        });
    };
    var createItem = function createItem(suggestion, index) {
        var scrollerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var style = {
            height: scrollerOptions.props ? scrollerOptions.props.itemSize : undefined
        };
        if (props.optionGroupLabel) {
            if (props.virtualScrollerOptions) {
                var keyIndex = findKeyIndex(props.suggestions, props.optionGroupLabel, suggestion);
                if (keyIndex !== -1) {
                    latestKey.current = {
                        key: suggestion,
                        index: index,
                        keyIndex: keyIndex
                    };
                    var _key = index + "_" + getOptionGroupRenderKey(suggestion);
                    return createLabelItem(suggestion, _key, index, {
                        style: style
                    });
                }
                var _key2 = index + "_" + latestKey.current.keyIndex;
                var _itemProps = mergeProps({
                    style: style,
                    "data-group": latestKey.current.keyIndex,
                    "data-index": index - latestKey.current.index - 1,
                    "data-p-disabled": suggestion.disabled
                });
                return createListItem(suggestion, _key2, index, _itemProps);
            }
            var childrenContent = createGroupChildren(suggestion, index);
            var _key3 = index + "_" + getOptionGroupRenderKey(suggestion);
            return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, {
                key: _key3
            }, createLabelItem(suggestion, undefined, index, {
                style: style
            }), childrenContent);
        }
        var key = "".concat(index, "_").concat((0, $cfkGk.ObjectUtils).isObject(suggestion) ? getOptionRenderKey(suggestion) : suggestion);
        var itemProps = mergeProps({
            style: style,
            "data-p-disabled": suggestion.disabled
        }, getPTOptions(suggestion, "item"));
        return createListItem(suggestion, key, index, itemProps);
    };
    var createItems = function createItems() {
        return props.suggestions ? props.suggestions.map(createItem) : null;
    };
    var flattenGroupedItems = function flattenGroupedItems(items) {
        try {
            return items === null || items === void 0 ? void 0 : items.map(function(item) {
                return [
                    item === null || item === void 0 ? void 0 : item[props === null || props === void 0 ? void 0 : props.optionGroupLabel]
                ].concat($1f61142c64ee961a$var$_toConsumableArray(item === null || item === void 0 ? void 0 : item[props === null || props === void 0 ? void 0 : props.optionGroupChildren]));
            }).flat();
        } catch (e) {}
    };
    var createContent = function createContent() {
        if (props.showEmptyMessage && (0, $cfkGk.ObjectUtils).isEmpty(props.suggestions)) {
            var emptyMessage = props.emptyMessage || (0, $8Zwsm.localeOption)("emptyMessage");
            var emptyMessageProps = mergeProps({
                className: cx("emptyMessage")
            }, _ptm("emptyMesage"));
            var _listProps = mergeProps({
                className: cx("list")
            }, _ptm("list"));
            return /*#__PURE__*/ $81g6h.createElement("ul", _listProps, /*#__PURE__*/ $81g6h.createElement("li", emptyMessageProps, emptyMessage));
        }
        if (props.virtualScrollerOptions) {
            var _items = props.suggestions ? props.optionGroupLabel ? flattenGroupedItems(props === null || props === void 0 ? void 0 : props.suggestions) : props.suggestions : null;
            var virtualScrollerProps = $1f61142c64ee961a$var$_objectSpread$1($1f61142c64ee961a$var$_objectSpread$1({}, props.virtualScrollerOptions), {
                style: $1f61142c64ee961a$var$_objectSpread$1($1f61142c64ee961a$var$_objectSpread$1({}, props.virtualScrollerOptions.style), {
                    height: props.scrollHeight
                }),
                autoSize: true,
                items: _items,
                itemTemplate: function itemTemplate(item, options) {
                    return item && createItem(item, options.index, options);
                },
                contentTemplate: function contentTemplate(options) {
                    var listProps = mergeProps({
                        id: props.listId,
                        ref: options.contentRef,
                        style: options.style,
                        className: cx("list", {
                            virtualScrollerProps: virtualScrollerProps,
                            options: options
                        }),
                        role: "listbox"
                    }, _ptm("list"));
                    return /*#__PURE__*/ $81g6h.createElement("ul", listProps, options.children);
                }
            });
            return /*#__PURE__*/ $81g6h.createElement((0, $2Sldw.VirtualScroller), $1f61142c64ee961a$var$_extends({
                ref: props.virtualScrollerRef
            }, virtualScrollerProps, {
                pt: _ptm("virtualScroller"),
                __parentMetadata: {
                    parent: props.metaData
                }
            }));
        }
        var items = createItems();
        var listProps = mergeProps({
            id: props.listId,
            className: cx("list"),
            role: "listbox"
        }, _ptm("list"));
        var listWrapperProps = mergeProps({
            className: cx("listWrapper"),
            style: {
                maxHeight: props.scrollHeight || "auto"
            }
        }, _ptm("listWrapper"));
        return /*#__PURE__*/ $81g6h.createElement("div", listWrapperProps, /*#__PURE__*/ $81g6h.createElement("ul", listProps, items));
    };
    var createElement = function createElement() {
        var style = $1f61142c64ee961a$var$_objectSpread$1({}, props.panelStyle || {});
        var content = createContent();
        var footer = createFooter();
        var panelProps = mergeProps({
            className: (0, $cfkGk.classNames)(props.panelClassName, cx("panel", {
                context: context
            })),
            style: style,
            onClick: function onClick(e) {
                return props.onClick(e);
            }
        }, _ptm("panel"));
        var transitionProps = mergeProps({
            classNames: cx("transition"),
            "in": props["in"],
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: props.onEnter,
            onEntering: props.onEntering,
            onEntered: props.onEntered,
            onExit: props.onExit,
            onExited: props.onExited
        }, _ptm("transition"));
        return /*#__PURE__*/ $81g6h.createElement((0, $lbdsH.CSSTransition), $1f61142c64ee961a$var$_extends({
            nodeRef: ref
        }, transitionProps), /*#__PURE__*/ $81g6h.createElement("div", $1f61142c64ee961a$var$_extends({
            ref: ref
        }, panelProps), content, footer));
    };
    var element = createElement();
    return /*#__PURE__*/ $81g6h.createElement((0, $6b4aU.Portal), {
        element: element,
        appendTo: props.appendTo
    });
}));
$1f61142c64ee961a$var$AutoCompletePanel.displayName = "AutoCompletePanel";
function $1f61142c64ee961a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1f61142c64ee961a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1f61142c64ee961a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1f61142c64ee961a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1f61142c64ee961a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1f61142c64ee961a$export$6b41f50dc0c59fb3 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $1f61142c64ee961a$var$AutoCompleteBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState(props.id), _React$useState2 = $1f61142c64ee961a$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0], setIdState = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(false), _React$useState4 = $1f61142c64ee961a$var$_slicedToArray(_React$useState3, 2), searchingState = _React$useState4[0], setSearchingState = _React$useState4[1];
    var _React$useState5 = $81g6h.useState(false), _React$useState6 = $1f61142c64ee961a$var$_slicedToArray(_React$useState5, 2), focusedState = _React$useState6[0], setFocusedState = _React$useState6[1];
    var _React$useState7 = $81g6h.useState(false), _React$useState8 = $1f61142c64ee961a$var$_slicedToArray(_React$useState7, 2), overlayVisibleState = _React$useState8[0], setOverlayVisibleState = _React$useState8[1];
    var metaData = {
        props: props,
        state: {
            id: idState,
            searching: searchingState,
            focused: focusedState,
            overlayVisible: overlayVisibleState
        }
    };
    var _AutoCompleteBase$set = $1f61142c64ee961a$var$AutoCompleteBase.setMetaData(metaData), ptm = _AutoCompleteBase$set.ptm, cx = _AutoCompleteBase$set.cx, sx = _AutoCompleteBase$set.sx, isUnstyled = _AutoCompleteBase$set.isUnstyled;
    (0, $4gQLd.useHandleStyle)($1f61142c64ee961a$var$AutoCompleteBase.css.styles, isUnstyled, {
        name: "autocomplete"
    });
    var elementRef = $81g6h.useRef(null);
    var overlayRef = $81g6h.useRef(null);
    var inputRef = $81g6h.useRef(props.inputRef);
    var multiContainerRef = $81g6h.useRef(null);
    var virtualScrollerRef = $81g6h.useRef(null);
    var timeout = $81g6h.useRef(null);
    var selectedItem = $81g6h.useRef(null);
    var _useOverlayListener = (0, $l2NC0.useOverlayListener)({
        target: elementRef,
        overlay: overlayRef,
        listener: function listener(event, _ref) {
            var type = _ref.type, valid = _ref.valid;
            if (valid) type === "outside" ? !isInputClicked(event) && hide() : hide();
        },
        when: overlayVisibleState
    }), _useOverlayListener2 = $1f61142c64ee961a$var$_slicedToArray(_useOverlayListener, 2), bindOverlayListener = _useOverlayListener2[0], unbindOverlayListener = _useOverlayListener2[1];
    var isInputClicked = function isInputClicked(event) {
        return props.multiple ? event.target === multiContainerRef.current || multiContainerRef.current.contains(event.target) : event.target === inputRef.current;
    };
    var onInputChange = function onInputChange(event) {
        //Cancel the search request if user types within the timeout
        if (timeout.current) clearTimeout(timeout.current);
        var query = event.target.value;
        if (!props.multiple) updateModel(event, query);
        if ((0, $cfkGk.ObjectUtils).isEmpty(query)) {
            hide();
            props.onClear && props.onClear(event);
        } else if (query.length >= props.minLength) timeout.current = setTimeout(function() {
            search(event, query, "input");
        }, props.delay);
        else hide();
    };
    var search = function search(event, query, source) {
        //allow empty string but not undefined or null
        if (query === undefined || query === null) return;
        //do not search blank values on input change
        if (source === "input" && query.trim().length === 0) return;
        if (props.completeMethod) {
            setSearchingState(true);
            props.completeMethod({
                originalEvent: event,
                query: query
            });
        }
    };
    var selectItem = function selectItem(event, option, preventInputFocus) {
        if (props.multiple) {
            inputRef.current.value = "";
            // allows empty value/selectionlimit and within sectionlimit
            if (!isSelected(option) && isAllowMoreValues()) {
                var newValue = props.value ? [].concat($1f61142c64ee961a$var$_toConsumableArray(props.value), [
                    option
                ]) : [
                    option
                ];
                updateModel(event, newValue);
            }
        } else {
            updateInputField(option);
            updateModel(event, option);
        }
        if (props.onSelect) props.onSelect({
            originalEvent: event,
            value: option
        });
        if (!preventInputFocus) {
            (0, $cfkGk.DomHandler).focus(inputRef.current);
            hide();
        }
    };
    var updateModel = function updateModel(event, value) {
        if (props.onChange) props.onChange({
            originalEvent: event,
            value: value,
            stopPropagation: function stopPropagation() {
                event.stopPropagation();
            },
            preventDefault: function preventDefault() {
                event.preventDefault();
            },
            target: {
                name: props.name,
                id: idState,
                value: value
            }
        });
        selectedItem.current = (0, $cfkGk.ObjectUtils).isNotEmpty(value) ? value : null;
    };
    var formatValue = function formatValue(value) {
        if ((0, $cfkGk.ObjectUtils).isNotEmpty(value)) {
            if (typeof value === "string") return value;
            else if (props.selectedItemTemplate) {
                var resolvedFieldData = (0, $cfkGk.ObjectUtils).getJSXElement(props.selectedItemTemplate, value);
                return resolvedFieldData ? resolvedFieldData : value;
            } else if (props.field) {
                var _resolvedFieldData = (0, $cfkGk.ObjectUtils).resolveFieldData(value, props.field);
                return _resolvedFieldData !== null && _resolvedFieldData !== undefined ? _resolvedFieldData : value;
            }
            return value;
        }
        return "";
    };
    var updateInputField = function updateInputField(value) {
        inputRef.current.value = formatValue(value);
    };
    var show = function show() {
        setOverlayVisibleState(true);
    };
    var hide = function hide() {
        setOverlayVisibleState(false);
        setSearchingState(false);
    };
    var onOverlayEnter = function onOverlayEnter() {
        (0, $cfkGk.ZIndexUtils).set("overlay", overlayRef.current, context && context.autoZIndex || (0, $8Zwsm.default).autoZIndex, context && context.zIndex.overlay || (0, $8Zwsm.default).zIndex.overlay);
        (0, $cfkGk.DomHandler).addStyles(overlayRef.current, {
            position: "absolute",
            top: "0",
            left: "0"
        });
        alignOverlay();
    };
    var onOverlayEntering = function onOverlayEntering() {
        if (props.autoHighlight && props.suggestions && props.suggestions.length) {
            var element = getScrollableElement().firstChild.firstChild;
            if (element) {
                !isUnstyled() && (0, $cfkGk.DomHandler).addClass(element, "p-highlight");
                element.setAttribute("data-p-highlight", true);
            }
        }
    };
    var onOverlayEntered = function onOverlayEntered() {
        bindOverlayListener();
        props.onShow && props.onShow();
    };
    var onOverlayExit = function onOverlayExit() {
        unbindOverlayListener();
    };
    var onOverlayExited = function onOverlayExited() {
        (0, $cfkGk.ZIndexUtils).clear(overlayRef.current);
        props.onHide && props.onHide();
    };
    var alignOverlay = function alignOverlay() {
        var target = props.multiple ? multiContainerRef.current : inputRef.current;
        (0, $cfkGk.DomHandler).alignOverlay(overlayRef.current, target, props.appendTo || context && context.appendTo || (0, $8Zwsm.default).appendTo);
    };
    var onPanelClick = function onPanelClick(event) {
        (0, $k7ffa.OverlayService).emit("overlay-click", {
            originalEvent: event,
            target: elementRef.current
        });
    };
    var onDropdownClick = function onDropdownClick(event) {
        if (props.dropdownAutoFocus) (0, $cfkGk.DomHandler).focus(inputRef.current, props.dropdownAutoFocus);
        if (props.dropdownMode === "blank") search(event, "", "dropdown");
        else if (props.dropdownMode === "current") search(event, inputRef.current.value, "dropdown");
        if (props.onDropdownClick) props.onDropdownClick({
            originalEvent: event,
            query: inputRef.current.value
        });
    };
    var removeItem = function removeItem(event, index) {
        var removedValue = props.value[index];
        var newValue = props.value.filter(function(_, i) {
            return index !== i;
        });
        updateModel(event, newValue);
        if (props.onUnselect) props.onUnselect({
            originalEvent: event,
            value: removedValue
        });
    };
    var onInputKeyDown = function onInputKeyDown(event) {
        if (overlayVisibleState) {
            var highlightItem = (0, $cfkGk.DomHandler).findSingle(overlayRef.current, 'li[data-p-highlight="true"]');
            switch(event.which){
                //down
                case 40:
                    if (highlightItem) {
                        var nextElement = findNextItem(highlightItem);
                        if (nextElement) {
                            !isUnstyled() && (0, $cfkGk.DomHandler).addClass(nextElement, "p-highlight");
                            nextElement.setAttribute("data-p-highlight", true);
                            !isUnstyled() && (0, $cfkGk.DomHandler).removeClass(highlightItem, "p-highlight");
                            highlightItem.setAttribute("data-p-highlight", false);
                            (0, $cfkGk.DomHandler).scrollInView(getScrollableElement(), nextElement);
                        }
                    } else {
                        highlightItem = (0, $cfkGk.DomHandler).findSingle(overlayRef.current, "li");
                        if ((0, $cfkGk.DomHandler).getAttribute(highlightItem, "data-pc-section") === "itemgroup") highlightItem = findNextItem(highlightItem);
                        if (highlightItem) {
                            !isUnstyled() && (0, $cfkGk.DomHandler).addClass(highlightItem, "p-highlight");
                            highlightItem.setAttribute("data-p-highlight", true);
                        }
                    }
                    event.preventDefault();
                    break;
                //up
                case 38:
                    if (highlightItem) {
                        var previousElement = findPrevItem(highlightItem);
                        if (previousElement) {
                            !isUnstyled() && (0, $cfkGk.DomHandler).addClass(previousElement, "p-highlight");
                            previousElement.setAttribute("data-p-highlight", true);
                            !isUnstyled() && (0, $cfkGk.DomHandler).removeClass(highlightItem, "p-highlight");
                            highlightItem.setAttribute("data-p-highlight", false);
                            (0, $cfkGk.DomHandler).scrollInView(getScrollableElement(), previousElement);
                        }
                    }
                    event.preventDefault();
                    break;
                //enter
                case 13:
                    if (highlightItem) {
                        selectHighlightItem(event, highlightItem);
                        hide();
                        event.preventDefault();
                    }
                    break;
                //escape
                case 27:
                    hide();
                    event.preventDefault();
                    break;
                //tab
                case 9:
                    if (highlightItem) selectHighlightItem(event, highlightItem);
                    hide();
                    break;
            }
        }
        if (props.multiple) switch(event.which){
            //backspace
            case 8:
                if (props.value && props.value.length && !inputRef.current.value) {
                    var removedValue = props.value[props.value.length - 1];
                    var newValue = props.value.slice(0, -1);
                    updateModel(event, newValue);
                    if (props.onUnselect) props.onUnselect({
                        originalEvent: event,
                        value: removedValue
                    });
                }
                break;
        }
    };
    var selectHighlightItem = function selectHighlightItem(event, item) {
        if (props.optionGroupLabel) {
            var optionGroup = props.suggestions[item.dataset.group];
            selectItem(event, getOptionGroupChildren(optionGroup)[item.dataset.index]);
        } else selectItem(event, props.suggestions[item.getAttribute("index")]);
    };
    var findNextItem = function findNextItem(item) {
        var nextItem = item.nextElementSibling;
        return nextItem ? (0, $cfkGk.DomHandler).getAttribute(nextItem, "data-pc-section") === "itemgroup" ? findNextItem(nextItem) : nextItem : null;
    };
    var findPrevItem = function findPrevItem(item) {
        var prevItem = item.previousElementSibling;
        return prevItem ? (0, $cfkGk.DomHandler).getAttribute(prevItem, "data-pc-section") === "itemgroup" ? findPrevItem(prevItem) : prevItem : null;
    };
    var onInputFocus = function onInputFocus(event) {
        setFocusedState(true);
        props.onFocus && props.onFocus(event);
    };
    var forceItemSelection = function forceItemSelection(event) {
        if (props.multiple) {
            inputRef.current.value = "";
            return;
        }
        var inputValue = (0, $cfkGk.ObjectUtils).trim(event.target.value);
        var item = (props.suggestions || []).find(function(it) {
            var value = props.field ? (0, $cfkGk.ObjectUtils).resolveFieldData(it, props.field) : it;
            return value && inputValue === (0, $cfkGk.ObjectUtils).trim(value);
        });
        if (item) selectItem(event, item, true);
        else {
            inputRef.current.value = "";
            updateModel(event, null);
            props.onClear && props.onClear(event);
        }
    };
    var onInputBlur = function onInputBlur(event) {
        setFocusedState(false);
        if (props.forceSelection) forceItemSelection(event);
        props.onBlur && props.onBlur(event);
    };
    var onMultiContainerClick = function onMultiContainerClick(event) {
        (0, $cfkGk.DomHandler).focus(inputRef.current);
        props.onClick && props.onClick(event);
    };
    var onMultiInputFocus = function onMultiInputFocus(event) {
        onInputFocus(event);
        !isUnstyled() && (0, $cfkGk.DomHandler).addClass(multiContainerRef.current, "p-focus");
        multiContainerRef.current.setAttribute("data-p-focus", true);
    };
    var onMultiInputBlur = function onMultiInputBlur(event) {
        onInputBlur(event);
        !isUnstyled() && (0, $cfkGk.DomHandler).removeClass(multiContainerRef.current, "p-focus");
        multiContainerRef.current.setAttribute("data-p-focus", false);
    };
    var isSelected = function isSelected(val) {
        return props.value ? props.value.some(function(v) {
            return (0, $cfkGk.ObjectUtils).equals(v, val);
        }) : false;
    };
    var getScrollableElement = function getScrollableElement() {
        return overlayRef.current.firstChild;
    };
    var getOptionGroupLabel = function getOptionGroupLabel(optionGroup) {
        return props.optionGroupLabel ? (0, $cfkGk.ObjectUtils).resolveFieldData(optionGroup, props.optionGroupLabel) : optionGroup;
    };
    var getOptionGroupChildren = function getOptionGroupChildren(optionGroup) {
        return (0, $cfkGk.ObjectUtils).resolveFieldData(optionGroup, props.optionGroupChildren);
    };
    var isAllowMoreValues = function isAllowMoreValues() {
        return !props.value || !props.selectionLimit || props.value.length < props.selectionLimit;
    };
    $81g6h.useEffect(function() {
        (0, $cfkGk.ObjectUtils).combinedRefs(inputRef, props.inputRef);
    }, [
        inputRef,
        props.inputRef
    ]);
    (0, $l2NC0.useMountEffect)(function() {
        if (!idState) setIdState((0, $cfkGk.UniqueComponentId)());
        if (props.autoFocus) (0, $cfkGk.DomHandler).focus(inputRef.current, props.autoFocus);
        alignOverlay();
    });
    (0, $l2NC0.useUpdateEffect)(function() {
        if (searchingState) {
            (0, $cfkGk.ObjectUtils).isNotEmpty(props.suggestions) || props.showEmptyMessage ? show() : hide();
            setSearchingState(false);
        }
    }, [
        props.suggestions
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (inputRef.current && !props.multiple) updateInputField(props.value);
        if (overlayVisibleState) alignOverlay();
    });
    (0, $l2NC0.useUnmountEffect)(function() {
        if (timeout.current) clearTimeout(timeout.current);
        (0, $cfkGk.ZIndexUtils).clear(overlayRef.current);
    });
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            search: search,
            show: show,
            hide: hide,
            focus: function focus() {
                return (0, $cfkGk.DomHandler).focus(inputRef.current);
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            getOverlay: function getOverlay() {
                return overlayRef.current;
            },
            getInput: function getInput() {
                return inputRef.current;
            },
            getVirtualScroller: function getVirtualScroller() {
                return virtualScrollerRef.current;
            }
        };
    });
    var createSimpleAutoComplete = function createSimpleAutoComplete() {
        var value = formatValue(props.value);
        var ariaControls = overlayVisibleState ? idState + "_list" : null;
        return /*#__PURE__*/ $81g6h.createElement((0, $6ccvc.InputText), $1f61142c64ee961a$var$_extends({
            ref: inputRef,
            id: props.inputId,
            type: props.type,
            name: props.name,
            defaultValue: value,
            role: "combobox",
            "aria-autocomplete": "list",
            "aria-controls": ariaControls,
            "aria-haspopup": "listbox",
            "aria-expanded": overlayVisibleState,
            className: (0, $cfkGk.classNames)(props.inputClassName, cx("input", {
                context: context
            })),
            style: props.inputStyle,
            autoComplete: "off",
            readOnly: props.readOnly,
            required: props.required,
            disabled: props.disabled,
            placeholder: props.placeholder,
            size: props.size,
            maxLength: props.maxLength,
            tabIndex: props.tabIndex,
            onBlur: onInputBlur,
            onFocus: onInputFocus,
            onChange: onInputChange,
            onMouseDown: props.onMouseDown,
            onKeyUp: props.onKeyUp,
            onKeyDown: onInputKeyDown,
            onKeyPress: props.onKeyPress,
            onContextMenu: props.onContextMenu,
            onClick: props.onClick,
            onDoubleClick: props.onDblClick,
            pt: ptm("input")
        }, ariaProps, {
            __parentMetadata: {
                parent: metaData
            }
        }));
    };
    var createChips = function createChips() {
        if ((0, $cfkGk.ObjectUtils).isNotEmpty(props.value)) return props.value.map(function(val, index) {
            var key = index + "multi-item";
            var removeTokenIconProps = mergeProps({
                className: cx("removeTokenIcon"),
                onClick: function onClick(e) {
                    return removeItem(e, index);
                }
            }, ptm("removeTokenIcon"));
            var icon = props.removeTokenIcon || /*#__PURE__*/ $81g6h.createElement((0, $6BqT9.TimesCircleIcon), removeTokenIconProps);
            var removeTokenIcon = !props.disabled && (0, $cfkGk.IconUtils).getJSXIcon(icon, $1f61142c64ee961a$var$_objectSpread({}, removeTokenIconProps), {
                props: props
            });
            var tokenProps = mergeProps({
                className: cx("token")
            }, ptm("token"));
            var tokenLabelProps = mergeProps({
                className: cx("tokenLabel")
            }, ptm("tokenLabel"));
            return /*#__PURE__*/ $81g6h.createElement("li", $1f61142c64ee961a$var$_extends({
                key: key
            }, tokenProps), /*#__PURE__*/ $81g6h.createElement("span", tokenLabelProps, formatValue(val)), removeTokenIcon);
        });
        selectedItem.current = null;
        return null;
    };
    var createMultiInput = function createMultiInput(allowMoreValues) {
        var ariaControls = overlayVisibleState ? idState + "_list" : null;
        var inputTokenProps = mergeProps({
            className: cx("inputToken")
        }, ptm("inputToken"));
        var inputProps = mergeProps($1f61142c64ee961a$var$_objectSpread({
            id: props.inputId,
            ref: inputRef,
            "aria-autocomplete": "list",
            "aria-controls": ariaControls,
            "aria-expanded": overlayVisibleState,
            "aria-haspopup": "listbox",
            autoComplete: "off",
            className: props.inputClassName,
            disabled: props.disabled,
            maxLength: props.maxLength,
            name: props.name,
            onBlur: onMultiInputBlur,
            onChange: allowMoreValues ? onInputChange : undefined,
            onFocus: onMultiInputFocus,
            onKeyDown: allowMoreValues ? onInputKeyDown : undefined,
            onKeyPress: props.onKeyPress,
            onKeyUp: props.onKeyUp,
            placeholder: allowMoreValues ? props.placeholder : undefined,
            readOnly: props.readOnly || !allowMoreValues,
            required: props.required,
            role: "combobox",
            style: props.inputStyle,
            tabIndex: props.tabIndex,
            type: props.type
        }, ariaProps), ptm("input"));
        return /*#__PURE__*/ $81g6h.createElement("li", inputTokenProps, /*#__PURE__*/ $81g6h.createElement("input", inputProps));
    };
    var createMultipleAutoComplete = function createMultipleAutoComplete() {
        var allowMoreValues = isAllowMoreValues();
        var tokens = createChips();
        var input = createMultiInput(allowMoreValues);
        var containerProps = mergeProps({
            ref: multiContainerRef,
            className: cx("container", {
                context: context
            }),
            onClick: allowMoreValues ? onMultiContainerClick : undefined,
            onContextMenu: props.onContextMenu,
            onMouseDown: props.onMouseDown,
            onDoubleClick: props.onDblClick,
            "data-p-focus": focusedState,
            "data-p-disabled": props.disabled
        }, ptm("container"));
        return /*#__PURE__*/ $81g6h.createElement("ul", containerProps, tokens, input);
    };
    var createDropdown = function createDropdown() {
        if (props.dropdown) {
            var ariaLabel = props.dropdownAriaLabel || props.placeholder || (0, $8Zwsm.localeOption)("choose");
            return /*#__PURE__*/ $81g6h.createElement((0, $9AWgp.Button), {
                type: "button",
                icon: props.dropdownIcon || /*#__PURE__*/ $81g6h.createElement((0, $jhJol.ChevronDownIcon), null),
                className: cx("dropdownButton"),
                disabled: props.disabled,
                onClick: onDropdownClick,
                "aria-label": ariaLabel,
                pt: ptm("dropdownButton"),
                __parentMetadata: {
                    parent: metaData
                }
            });
        }
        return null;
    };
    var createLoader = function createLoader() {
        if (searchingState) {
            var loadingIconProps = mergeProps({
                className: cx("loadingIcon")
            }, ptm("loadingIcon"));
            var icon = props.loadingIcon || /*#__PURE__*/ $81g6h.createElement((0, $dPQhb.SpinnerIcon), $1f61142c64ee961a$var$_extends({}, loadingIconProps, {
                spin: true
            }));
            var loaderIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $1f61142c64ee961a$var$_objectSpread({}, loadingIconProps), {
                props: props
            });
            return loaderIcon;
        }
        return null;
    };
    var createInput = function createInput() {
        return props.multiple ? createMultipleAutoComplete() : createSimpleAutoComplete();
    };
    var listId = idState + "_list";
    var hasTooltip = (0, $cfkGk.ObjectUtils).isNotEmpty(props.tooltip);
    var otherProps = $1f61142c64ee961a$var$AutoCompleteBase.getOtherProps(props);
    var ariaProps = (0, $cfkGk.ObjectUtils).reduceKeys(otherProps, (0, $cfkGk.DomHandler).ARIA_PROPS);
    var loader = createLoader();
    var input = createInput();
    var dropdown = createDropdown();
    var rootProps = mergeProps({
        id: idState,
        ref: elementRef,
        style: props.style,
        className: (0, $cfkGk.classNames)(props.className, cx("root", {
            focusedState: focusedState
        }))
    }, otherProps, ptm("root"));
    return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("span", rootProps, input, loader, dropdown, /*#__PURE__*/ $81g6h.createElement($1f61142c64ee961a$var$AutoCompletePanel, $1f61142c64ee961a$var$_extends({
        hostName: "AutoComplete",
        ref: overlayRef,
        virtualScrollerRef: virtualScrollerRef
    }, props, {
        listId: listId,
        onItemClick: selectItem,
        selectedItem: selectedItem,
        onClick: onPanelClick,
        getOptionGroupLabel: getOptionGroupLabel,
        getOptionGroupChildren: getOptionGroupChildren,
        "in": overlayVisibleState,
        onEnter: onOverlayEnter,
        onEntering: onOverlayEntering,
        onEntered: onOverlayEntered,
        onExit: onOverlayExit,
        onExited: onOverlayExited,
        ptm: ptm,
        cx: cx,
        sx: sx
    }))), hasTooltip && /*#__PURE__*/ $81g6h.createElement((0, $7hMfd.Tooltip), $1f61142c64ee961a$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$1f61142c64ee961a$export$6b41f50dc0c59fb3.displayName = "AutoComplete";

});



parcelRegister("eXK3g", function(module, exports) {

$parcel$export(module.exports, "DeleteTemplateDialog", () => $207255194b78eda9$export$83f7a371f92e85f8);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $iBbjf = parcelRequire("iBbjf");

var $9XVwj = parcelRequire("9XVwj");

var $9oyj9 = parcelRequire("9oyj9");

var $81g6h = parcelRequire("81g6h");
const $207255194b78eda9$export$83f7a371f92e85f8 = ({ templateId: templateId, templateName: templateName, onSuccess: onSuccess, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const [awaitingDelete, setAwaitingDelete] = (0, $81g6h.useState)(false);
    const deleteTemplate = (0, $81g6h.useCallback)(async ()=>{
        setAwaitingDelete(true);
        try {
            await (0, $ghfIB.templateOperationsManager).performDeleteOperation(templateId, templateName);
            setAwaitingDelete(false);
            (0, $iBbjf.sendAnalyticsEventDeleteTemplate)(templateId);
            showToast(format("global.deleteTemplateOperation.successToast.title"), format("global.deleteTemplateOperation.successToast.message", {
                name: templateName
            }), "success");
            otherProps.onHide();
            onSuccess?.();
        } catch (error) {
            console.error("Failed to delete template", error);
            setAwaitingDelete(false);
            showToast(format("global.deleteTemplateOperation.errorToast.title"), format("global.deleteTemplateOperation.errorToast.message"));
        }
    }, [
        format,
        onSuccess,
        otherProps,
        showToast,
        templateId,
        templateName
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $9oyj9.ConfirmActionDialog), {
        ...otherProps,
        onCancel: otherProps.onHide,
        onConfirm: deleteTemplate,
        confirmLoading: awaitingDelete,
        title: format("deleteTemplateDialog.title"),
        message: format("deleteTemplateDialog.message")
    });
};

});

parcelRegister("cWD63", function(module, exports) {

$parcel$export(module.exports, "TemplateNameDialog", () => $af4f8af3934e7274$export$83d3285862bafdd4);

var $iKObn = parcelRequire("iKObn");

var $he9Ds = parcelRequire("he9Ds");

var $1eHG3 = parcelRequire("1eHG3");

var $a6fIt = parcelRequire("a6fIt");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $gk3fY = parcelRequire("gk3fY");

var $lQZUP = parcelRequire("lQZUP");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $dU78w = parcelRequire("dU78w");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
const $af4f8af3934e7274$export$83d3285862bafdd4 = ({ template: template, onSubmit: onSubmit, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const [loadingSubmit, setLoadingSubmit] = (0, $81g6h.useState)(false);
    const { control: control, handleSubmit: handleSubmit } = (0, $eKUeg.useForm)({
        defaultValues: {
            name: template.name
        }
    });
    const saveTemplate = async ({ name: name })=>{
        setLoadingSubmit(true);
        await onSubmit(name);
        setLoadingSubmit(false);
        otherProps.onHide();
    };
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $gk3fY.BaseDialog), {
        header: format("templateBuilder.templateNameDialog.title.v2_6"),
        footer: /*#__PURE__*/ (0, $iKObn.jsx)($af4f8af3934e7274$var$ButtonContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                label: format("templateBuilder.templateNameDialog.saveButton.v2_6"),
                "data-test": (0, $a6fIt.e2eTestId).createTemplatePage.confirmButton,
                loading: loadingSubmit,
                type: "submit",
                onClick: handleSubmit(saveTemplate)
            })
        }),
        width: (0, $gk3fY.DIALOG_SIZE).S,
        ...otherProps,
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($af4f8af3934e7274$var$DialogContainer, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                    className: "p-size-m",
                    children: format("templateBuilder.templateNameDialog.description")
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)($af4f8af3934e7274$var$Form, {
                    onSubmit: handleSubmit(saveTemplate),
                    children: /*#__PURE__*/ (0, $iKObn.jsxs)($af4f8af3934e7274$var$FormField, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                className: "p-size-m",
                                children: format("templateBuilder.templateNameDialog.nameInput.label")
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                                name: "name",
                                control: control,
                                rules: {
                                    required: format("global.form.field.requiredError"),
                                    maxLength: {
                                        value: (0, $he9Ds.APP_CONSTANTS).PROGRAM_OR_TEMPLATE_MAX_TITLE_LENGTH,
                                        message: format("global.templateName.maxLength")
                                    }
                                },
                                render: ({ field: { onChange: onChange, value: value, ...otherFields }, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $lQZUP.TextAreaWithCharLimit), {
                                        ...otherFields,
                                        "data-test": (0, $a6fIt.e2eTestId).createTemplatePage.templateNameInput,
                                        autoComplete: "off",
                                        autoFocus: !value,
                                        text: value,
                                        onTextChange: onChange,
                                        errorMessage: fieldState.error?.message,
                                        charLimit: (0, $he9Ds.APP_CONSTANTS).PROGRAM_OR_TEMPLATE_MAX_TITLE_LENGTH,
                                        placeholder: format("templateBuilder.templateNameDialog.nameInput.placeholder")
                                    })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $af4f8af3934e7274$var$DialogContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("M", "flexstart", "stretch")}
	height: 100%;
`;
const $af4f8af3934e7274$var$ButtonContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("S", "flexend")}
`;
const $af4f8af3934e7274$var$Form = (0, $5UMQ1.default)((0, $dU78w.motion).form)`
	${(0, $5WGN2.stack)("M", "spacebetween", "stretch")}
	height: 100%;
`;
const $af4f8af3934e7274$var$FormField = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("S", "flexstart", "stretch")};
`;

});

parcelRegister("jxWDh", function(module, exports) {

$parcel$export(module.exports, "GetStartedCompletedDialog", () => $2e209bfd6bfa349f$export$39fc66b6fc9e410c);

var $iKObn = parcelRequire("iKObn");

var $cy0hL = parcelRequire("cy0hL");
parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $gk3fY = parcelRequire("gk3fY");

var $gOhJS = parcelRequire("gOhJS");

var $dhb7H = parcelRequire("dhb7H");

var $ikMhW = parcelRequire("ikMhW");

var $kKnoQ = parcelRequire("kKnoQ");
const $2e209bfd6bfa349f$export$39fc66b6fc9e410c = ({ onClose: onClose, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($2e209bfd6bfa349f$var$StyledDialog, {
        visible: true,
        dismissableMask: false,
        modal: false,
        position: "bottom-right",
        blockScroll: false,
        showHeader: false,
        ...otherProps,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($2e209bfd6bfa349f$var$AnimationContainer, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)($2e209bfd6bfa349f$var$PlayerContainer, {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($2e209bfd6bfa349f$var$StyledPlayer, {
                        autoplay: true,
                        keepLastFrame: true,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($cy0hL)))
                    })
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                className: "p-size-l-bold",
                children: format("getStarted.dialog.title")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                className: "p-size-s",
                children: format("getStarted.dialog.subTitle")
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($2e209bfd6bfa349f$var$StepsContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($2e209bfd6bfa349f$var$StyledStep, {
                        step: format("getStarted.dialog.step.exercises")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($2e209bfd6bfa349f$var$StyledStep, {
                        step: format("getStarted.dialog.step.programs")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($2e209bfd6bfa349f$var$StyledStep, {
                        step: format("getStarted.dialog.step.patients")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($2e209bfd6bfa349f$var$StyledHr, {}),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                className: "p-size-s-bold",
                children: format("getStarted.dialog.autoHideNotice")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($2e209bfd6bfa349f$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                    size: "small",
                    uiStyle: "secondary_B",
                    label: format("getStarted.dialog.closeButton"),
                    onClick: ()=>onClose(otherProps.onHide)
                })
            })
        ]
    });
};
const $2e209bfd6bfa349f$var$Step = ({ step: step, className: className })=>/*#__PURE__*/ (0, $iKObn.jsxs)("div", {
        className: `p-size-s-bold ${className}`,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $gOhJS.CheckmarkIcon), {
                size: "S"
            }),
            step
        ]
    });
const $2e209bfd6bfa349f$var$StyledDialog = (0, $5UMQ1.default)((0, $gk3fY.BaseDialog))`
	position: fixed;
	margin-right: 56px;
	margin-bottom: 56px;
	width: 340px;

	.p-dialog-content {
		${(0, $5WGN2.stack)(13, "flexstart", "stretch")};	
		padding: 0 24px 8px 24px;
		border-radius: 16px 16px 0 0;
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		margin-right: 0;
		margin-bottom: 0;

	.p-dialog-content {
		border-radius: 0;
	}
`;
const $2e209bfd6bfa349f$var$AnimationContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "center")};
	position: relative;
	width: 100%;
	height: 135px;
	min-height: 135px;
`;
const $2e209bfd6bfa349f$var$PlayerContainer = (0, $5UMQ1.default).div`
	position: absolute;
	top: -45px;
`;
const $2e209bfd6bfa349f$var$StyledPlayer = (0, $5UMQ1.default)((0, $ikMhW.Player))`
	width: 100%;
	height: 254px;
`;
const $2e209bfd6bfa349f$var$StepsContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(13)};
	margin-left: 8px;
`;
const $2e209bfd6bfa349f$var$StyledStep = (0, $5UMQ1.default)($2e209bfd6bfa349f$var$Step)`
	${(0, $5WGN2.row)("S", "flexstart", "center")};
`;
const $2e209bfd6bfa349f$var$StyledHr = (0, $5UMQ1.default).hr`
	color: ${(0, $kKnoQ.colors).grey50};
	width: 55%;
`;
const $2e209bfd6bfa349f$var$ButtonContainer = (0, $5UMQ1.default).div`
	align-self: center;
`;

});
parcelRegister("cy0hL", function(module, exports) {
module.exports = JSON.parse('{"nm":"success 3","ddd":0,"h":850,"w":800,"meta":{"g":"@lottiefiles/toolkit-js 0.26.1"},"layers":[{"ty":0,"nm":"final","sr":1,"st":0,"op":120,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[400,425,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[400,425,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"w":800,"h":850,"refId":"comp_0","ind":1}],"v":"5.8.1","fr":24,"op":120,"ip":0,"fonts":{"list":[{"ascent":71.8994140625,"fClass":"","fFamily":"Helvetica","fStyle":"Regular","fName":"Helvetica","fPath":"","fWeight":"","origin":0}]},"assets":[{"nm":"final","id":"comp_0","fr":24,"layers":[{"ty":5,"nm":"Successful","sr":1,"st":-5,"op":235,"ip":55,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[-0.815,-33.278,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.499,"y":0},"i":{"x":0.577,"y":1},"s":[400,418,0],"t":55,"ti":[0,43.167,0],"to":[0,-43.167,0]},{"s":[400,159,0],"t":60}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":1,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":55},{"s":[100],"t":60}],"ix":11}},"ef":[],"t":{"m":{"a":{"a":0,"k":[0,0],"ix":2},"g":1},"p":{},"a":[],"d":{"k":[{"s":{"f":"Helvetica","s":88,"t":"","fc":[0.4745,0.8392,0.6667],"lh":105.600006103516,"tr":0,"j":2,"ca":0},"t":0}]}},"ind":1},{"ty":4,"nm":"Shape Layer 3","sr":1,"st":31,"op":261,"ip":31,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[77,2,0],"ix":1},"s":{"a":0,"k":[30.158,30.158,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[-44,120,0],"ix":2},"r":{"a":1,"k":[{"o":{"x":0.865,"y":0},"i":{"x":0.833,"y":0.833},"s":[-225],"t":43},{"s":[-180],"t":60}],"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Shape 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":false,"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-56,6],[30,92],[210,-88]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":2,"lj":2,"ml":1,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":70,"ix":5},"c":{"a":0,"k":[1,1,1],"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"tm","bm":0,"hd":false,"mn":"ADBE Vector Filter - Trim","nm":"Trim Paths 1","ix":2,"e":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0,"y":1},"s":[0],"t":43},{"s":[100],"t":55}],"ix":2},"o":{"a":0,"k":0,"ix":3},"s":{"a":0,"k":0,"ix":1},"m":1}],"ind":2,"parent":4},{"ty":4,"nm":"Shape Layer 1","sr":1,"st":0,"op":61,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[-44,120,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.243,"y":0},"i":{"x":0.322,"y":1},"s":[50,50,100],"t":24},{"o":{"x":1,"y":0},"i":{"x":0.833,"y":0.833},"s":[115,115,100],"t":48},{"s":[100,100,100],"t":60}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[400,418,0],"ix":2},"r":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":15},{"s":[270],"t":48}],"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":48},{"s":[0],"t":60}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[246.094,246.094],"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":2,"lj":2,"ml":1,"o":{"a":0,"k":100,"ix":4},"w":{"a":1,"k":[{"o":{"x":0.863,"y":0},"i":{"x":0.206,"y":1},"s":[60],"t":24},{"s":[18],"t":43}],"ix":5},"c":{"a":0,"k":[0.0784,0.7098,0.0667],"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-44,120],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"tm","bm":0,"hd":false,"mn":"ADBE Vector Filter - Trim","nm":"Trim Paths 1","ix":2,"e":{"a":0,"k":0,"ix":2},"o":{"a":0,"k":0,"ix":3},"s":{"a":1,"k":[{"o":{"x":0.84,"y":0},"i":{"x":0.273,"y":1},"s":[0],"t":7},{"s":[100],"t":48}],"ix":1},"m":1}],"ind":3},{"ty":4,"nm":"Shape Layer 2","sr":1,"st":0,"op":240,"ip":48,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[-44,120,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":1,"y":0},"i":{"x":0.833,"y":0.833},"s":[115,115,100],"t":48},{"s":[100,100,100],"t":60}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[400,418,0],"ix":2},"r":{"a":0,"k":540,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":48},{"s":[100],"t":60}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[246.094,246.094],"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":2,"lj":2,"ml":1,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":6,"ix":5},"c":{"a":0,"k":[0.0784,0.7098,0.0667],"ix":3}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.0784,0.7098,0.0667],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-44,120],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"tm","bm":0,"hd":false,"mn":"ADBE Vector Filter - Trim","nm":"Trim Paths 1","ix":2,"e":{"a":0,"k":0,"ix":2},"o":{"a":0,"k":0,"ix":3},"s":{"a":0,"k":100,"ix":1},"m":1}],"ind":4},{"ty":4,"nm":"Shape Layer 4","sr":1,"st":-3,"op":237,"ip":45,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[-44,120,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0,"y":1},"s":[127,127,100],"t":45},{"s":[170,170,100],"t":60}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[400,418,0],"ix":2},"r":{"a":0,"k":270,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0,"y":1},"s":[60],"t":45},{"s":[0],"t":60}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[246.094,246.094],"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":2,"lj":2,"ml":1,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":30,"ix":5},"c":{"a":0,"k":[0.0784,0.7098,0.0667],"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-44,120],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"tm","bm":0,"hd":false,"mn":"ADBE Vector Filter - Trim","nm":"Trim Paths 1","ix":2,"e":{"a":0,"k":0,"ix":2},"o":{"a":0,"k":0,"ix":3},"s":{"a":0,"k":100,"ix":1},"m":1}],"ind":5},{"ty":0,"nm":"Confetti 1","sr":1,"st":58,"op":106,"ip":58,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[256,256,0],"ix":1},"s":{"a":0,"k":[193,193,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[400,425,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"w":512,"h":512,"refId":"comp_1","ind":6}]},{"nm":"Confetti 1","id":"comp_1","layers":[{"ty":3,"nm":"Null 3","sr":1,"st":0,"op":48,"ip":4,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[102,102,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[256,256,0],"ix":2},"r":{"a":0,"k":260,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":0,"ix":11}},"ef":[],"ind":1},{"ty":4,"nm":"Shape Layer 50","sr":1,"st":11.2,"op":48,"ip":11.2,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[41,41,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[50,50,0],"ix":2},"r":{"a":0,"k":487,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":11.2},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":15.2},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":32.8},{"s":[0],"t":45.6}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Shape 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":false,"i":[[0,0],[-19.362,34.498],[7.899,-25.433],[37.607,53.867],[11.905,108.592]],"o":[[0,0],[42.457,-75.648],[-9.025,29.061],[-47.221,-67.637],[-3.807,-34.72]],"v":[[1,2],[-48.536,-23.607],[-76.476,-100.021],[27.098,-130.112],[-120.809,-222.715]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"c":{"a":0,"k":[0.0784,0.7098,0.0667],"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"tm","bm":0,"hd":false,"mn":"ADBE Vector Filter - Trim","nm":"Trim Paths 1","ix":2,"e":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":11.2},{"s":[100],"t":39.2}],"ix":2},"o":{"a":0,"k":0,"ix":3},"s":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":13.6},{"s":[100],"t":43.2}],"ix":1},"m":1}],"ind":2,"parent":1},{"ty":4,"nm":"Shape Layer 49","sr":1,"st":10.4,"op":48,"ip":10.4,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[70,70,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[50,50,0],"ix":2},"r":{"a":0,"k":353,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":10.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":14.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":32},{"s":[0],"t":44.8}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Shape 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":false,"i":[[0,0],[-14,37],[8.506,-58.529],[28.328,67.272],[11.905,108.592]],"o":[[0,0],[9.966,-26.338],[-12.365,85.083],[-32.013,-76.024],[-3.807,-34.72]],"v":[[1,2],[-48.536,-23.607],[-76.476,-100.021],[27.098,-130.112],[-120.809,-222.715]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"c":{"a":0,"k":[1,0.3569,0.0118],"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"tm","bm":0,"hd":false,"mn":"ADBE Vector Filter - Trim","nm":"Trim Paths 1","ix":2,"e":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":10.4},{"s":[100],"t":38.4}],"ix":2},"o":{"a":0,"k":0,"ix":3},"s":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":12.8},{"s":[100],"t":42.4}],"ix":1},"m":1}],"ind":3,"parent":1},{"ty":4,"nm":"Shape Layer 48","sr":1,"st":9.6,"op":48,"ip":9.6,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[70,70,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[50,50,0],"ix":2},"r":{"a":0,"k":187,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":9.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":13.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":31.2},{"s":[0],"t":44}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Shape 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":false,"i":[[0,0],[-14,37],[8.254,-31.239],[20.685,70.001],[17.795,30.055]],"o":[[0,0],[9.966,-26.338],[-7.439,28.154],[-10.769,-36.442],[-17.795,-30.055]],"v":[[1,2],[2.692,-79.782],[-49.416,-90.653],[-14.589,-135.23],[-105.31,-168.421]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"c":{"a":0,"k":[1,0.6863,0],"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"tm","bm":0,"hd":false,"mn":"ADBE Vector Filter - Trim","nm":"Trim Paths 1","ix":2,"e":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":9.6},{"s":[100],"t":37.6}],"ix":2},"o":{"a":0,"k":0,"ix":3},"s":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":12},{"s":[100],"t":41.6}],"ix":1},"m":1}],"ind":4,"parent":1},{"ty":4,"nm":"Shape Layer 47","sr":1,"st":8.8,"op":48,"ip":8.8,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[58,58,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[50,50,0],"ix":2},"r":{"a":0,"k":203,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":8.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":12.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":30.4},{"s":[0],"t":43.2}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Shape 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":false,"i":[[0,0],[-14,37],[-1,38],[35.009,-27.828],[-11,31]],"o":[[0,0],[9.966,-26.338],[1,-38],[-39,31],[11,-31]],"v":[[1,2],[48,-39],[29,-112],[136,-107],[103,-176]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"c":{"a":0,"k":[1,0.3569,0.0118],"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"tm","bm":0,"hd":false,"mn":"ADBE Vector Filter - Trim","nm":"Trim Paths 1","ix":2,"e":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":8.8},{"s":[100],"t":36.8}],"ix":2},"o":{"a":0,"k":0,"ix":3},"s":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":11.2},{"s":[100],"t":40.8}],"ix":1},"m":1}],"ind":5,"parent":1},{"ty":4,"nm":"Shape Layer 46","sr":1,"st":8,"op":48,"ip":8,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[50,50,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":12},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":29.6},{"s":[0],"t":42.4}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Shape 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":false,"i":[[0,0],[-14,37],[-1,38],[35.009,-27.828],[-11,31]],"o":[[0,0],[9.966,-26.338],[1,-38],[-39,31],[11,-31]],"v":[[1,2],[48,-39],[29,-112],[136,-107],[103,-176]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"c":{"a":0,"k":[0.0784,0.7098,0.0667],"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"tm","bm":0,"hd":false,"mn":"ADBE Vector Filter - Trim","nm":"Trim Paths 1","ix":2,"e":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":8},{"s":[100],"t":36}],"ix":2},"o":{"a":0,"k":0,"ix":3},"s":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":10.4},{"s":[100],"t":40}],"ix":1},"m":1}],"ind":6,"parent":1},{"ty":4,"nm":"Shape Layer 45","sr":1,"st":7.2,"op":48,"ip":7.2,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[41,41,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[256,256,0],"ix":2},"r":{"a":0,"k":487,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":7.2},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":11.2},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":28.8},{"s":[0],"t":41.6}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Shape 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":false,"i":[[0,0],[-19.362,34.498],[7.899,-25.433],[37.607,53.867],[11.905,108.592]],"o":[[0,0],[42.457,-75.648],[-9.025,29.061],[-47.221,-67.637],[-3.807,-34.72]],"v":[[1,2],[-48.536,-23.607],[-76.476,-100.021],[27.098,-130.112],[-120.809,-222.715]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"c":{"a":0,"k":[0.0784,0.7098,0.0667],"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"tm","bm":0,"hd":false,"mn":"ADBE Vector Filter - Trim","nm":"Trim Paths 1","ix":2,"e":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":7.2},{"s":[100],"t":35.2}],"ix":2},"o":{"a":0,"k":0,"ix":3},"s":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":9.6},{"s":[100],"t":39.2}],"ix":1},"m":1}],"ind":7},{"ty":4,"nm":"Shape Layer 43","sr":1,"st":6.4,"op":48,"ip":6.4,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[70,70,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[256,256,0],"ix":2},"r":{"a":0,"k":353,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":6.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":10.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":28},{"s":[0],"t":40.8}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Shape 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":false,"i":[[0,0],[-14,37],[8.506,-58.529],[28.328,67.272],[11.905,108.592]],"o":[[0,0],[9.966,-26.338],[-12.365,85.083],[-32.013,-76.024],[-3.807,-34.72]],"v":[[1,2],[-48.536,-23.607],[-76.476,-100.021],[27.098,-130.112],[-120.809,-222.715]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"c":{"a":0,"k":[1,0.3569,0.0118],"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"tm","bm":0,"hd":false,"mn":"ADBE Vector Filter - Trim","nm":"Trim Paths 1","ix":2,"e":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":6.4},{"s":[100],"t":34.4}],"ix":2},"o":{"a":0,"k":0,"ix":3},"s":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":8.8},{"s":[100],"t":38.4}],"ix":1},"m":1}],"ind":8},{"ty":4,"nm":"Shape Layer 42","sr":1,"st":5.6,"op":48,"ip":5.6,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[70,70,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[256,256,0],"ix":2},"r":{"a":0,"k":187,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":5.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":9.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":27.2},{"s":[0],"t":40}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Shape 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":false,"i":[[0,0],[-14,37],[8.254,-31.239],[20.685,70.001],[17.795,30.055]],"o":[[0,0],[9.966,-26.338],[-7.439,28.154],[-10.769,-36.442],[-17.795,-30.055]],"v":[[1,2],[2.692,-79.782],[-49.416,-90.653],[-14.589,-135.23],[-105.31,-168.421]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"c":{"a":0,"k":[1,0.6863,0],"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"tm","bm":0,"hd":false,"mn":"ADBE Vector Filter - Trim","nm":"Trim Paths 1","ix":2,"e":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":5.6},{"s":[100],"t":33.6}],"ix":2},"o":{"a":0,"k":0,"ix":3},"s":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":8},{"s":[100],"t":37.6}],"ix":1},"m":1}],"ind":9},{"ty":4,"nm":"Shape Layer 44","sr":1,"st":4.8,"op":48,"ip":4.8,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[58,58,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[256,256,0],"ix":2},"r":{"a":0,"k":203,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":4.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":8.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":26.4},{"s":[0],"t":39.2}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Shape 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":false,"i":[[0,0],[-14,37],[-1,38],[35.009,-27.828],[-11,31]],"o":[[0,0],[9.966,-26.338],[1,-38],[-39,31],[11,-31]],"v":[[1,2],[48,-39],[29,-112],[136,-107],[103,-176]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"c":{"a":0,"k":[1,0.3569,0.0118],"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"tm","bm":0,"hd":false,"mn":"ADBE Vector Filter - Trim","nm":"Trim Paths 1","ix":2,"e":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":4.8},{"s":[100],"t":32.8}],"ix":2},"o":{"a":0,"k":0,"ix":3},"s":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":7.2},{"s":[100],"t":36.8}],"ix":1},"m":1}],"ind":10},{"ty":4,"nm":"Shape Layer 41","sr":1,"st":4,"op":48,"ip":4,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[256,256,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":25.6},{"s":[0],"t":38.4}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Shape 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":false,"i":[[0,0],[-14,37],[-1,38],[35.009,-27.828],[-11,31]],"o":[[0,0],[9.966,-26.338],[1,-38],[-39,31],[11,-31]],"v":[[1,2],[48,-39],[29,-112],[136,-107],[103,-176]]},"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"c":{"a":0,"k":[0.0784,0.7098,0.0667],"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"tm","bm":0,"hd":false,"mn":"ADBE Vector Filter - Trim","nm":"Trim Paths 1","ix":2,"e":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":4},{"s":[100],"t":32}],"ix":2},"o":{"a":0,"k":0,"ix":3},"s":{"a":1,"k":[{"o":{"x":0.139,"y":0},"i":{"x":0,"y":1},"s":[0],"t":6.4},{"s":[100],"t":36}],"ix":1},"m":1}],"ind":11},{"ty":4,"nm":"Shape Layer 40","sr":1,"st":4.8,"op":48,"ip":4.8,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":1.27},"s":[140.028,87.797,100],"t":4.8},{"o":{"x":0.167,"y":0.064},"i":{"x":0.833,"y":0.945},"s":[149.724,81.426,100],"t":5.6},{"o":{"x":0.167,"y":-0.158},"i":{"x":0.833,"y":1.242},"s":[108.654,80.328,100],"t":6.4},{"o":{"x":0.167,"y":0.062},"i":{"x":0.833,"y":0.932},"s":[122.85,125.952,100],"t":7.2},{"o":{"x":0.167,"y":-0.361},"i":{"x":0.833,"y":0.849},"s":[67.435,113.999,100],"t":8},{"o":{"x":0.167,"y":0.186},"i":{"x":0.833,"y":0.46},"s":[77.828,139.764,100],"t":8.8},{"o":{"x":0.167,"y":0.099},"i":{"x":0.833,"y":0.921},"s":[86.275,118.232,100],"t":9.6},{"o":{"x":0.167,"y":-1.604},"i":{"x":0.833,"y":-0.039},"s":[132.517,84.447,100],"t":10.4},{"o":{"x":0.167,"y":0.091},"i":{"x":0.833,"y":0.895},"s":[130.233,85.124,100],"t":11.2},{"o":{"x":0.167,"y":0.399},"i":{"x":0.833,"y":1.337},"s":[104.061,104.576,100],"t":12},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.903},"s":[97.155,67.886,100],"t":12.8},{"o":{"x":0.167,"y":0.607},"i":{"x":0.833,"y":1.652},"s":[131.988,124.186,100],"t":13.6},{"o":{"x":0.167,"y":0.074},"i":{"x":0.833,"y":0.86},"s":[137.528,73.357,100],"t":14.4},{"o":{"x":0.167,"y":0.207},"i":{"x":0.833,"y":1.036},"s":[88.621,106.456,100],"t":15.2},{"o":{"x":0.167,"y":0.025},"i":{"x":0.833,"y":0.926},"s":[55.617,129.849,100],"t":16},{"o":{"x":0.167,"y":-0.634},"i":{"x":0.833,"y":0.262},"s":[102.914,93.756,100],"t":16.8},{"o":{"x":0.167,"y":0.094},"i":{"x":0.833,"y":0.946},"s":[97.417,93.144,100],"t":17.6},{"o":{"x":0.167,"y":-0.154},"i":{"x":0.833,"y":0.703},"s":[54.264,122.898,100],"t":18.4},{"o":{"x":0.167,"y":0.116},"i":{"x":0.833,"y":0.998},"s":[69.385,112.598,100],"t":19.2},{"o":{"x":0.167,"y":-0.002},"i":{"x":0.833,"y":0.949},"s":[108.191,60.937,100],"t":20},{"o":{"x":0.167,"y":-0.135},"i":{"x":0.833,"y":0.912},"s":[70.4,49.44,100],"t":20.8},{"o":{"x":0.167,"y":1.486},"i":{"x":0.833,"y":0.585},"s":[84.854,97.16,100],"t":21.6},{"o":{"x":0.167,"y":0.104},"i":{"x":0.833,"y":1.234},"s":[85.713,111.857,100],"t":22.4},{"o":{"x":0.167,"y":0.061},"i":{"x":0.833,"y":0.975},"s":[89.136,97.385,100],"t":23.2},{"o":{"x":0.167,"y":-0.036},"i":{"x":0.833,"y":1.375},"s":[76.083,63.267,100],"t":24},{"o":{"x":0.167,"y":0.068},"i":{"x":0.833,"y":1.021},"s":[85.219,64.136,100],"t":24.8},{"o":{"x":0.167,"y":0.017},"i":{"x":0.833,"y":0.877},"s":[34.985,72.111,100],"t":25.6},{"o":{"x":0.167,"y":0.257},"i":{"x":0.833,"y":0.984},"s":[97.846,83.275,100],"t":26.4},{"o":{"x":0.167,"y":-0.02},"i":{"x":0.833,"y":0.901},"s":[127.941,67.428,100],"t":27.2},{"o":{"x":0.167,"y":0.536},"i":{"x":0.833,"y":0.553},"s":[103.695,66.821,100],"t":28},{"o":{"x":0.167,"y":0.102},"i":{"x":0.833,"y":0.782},"s":[99.227,81.408,100],"t":28.8},{"o":{"x":0.167,"y":0.135},"i":{"x":0.833,"y":0.859},"s":[79.727,70.137,100],"t":29.6},{"o":{"x":0.167,"y":0.203},"i":{"x":0.833,"y":0.953},"s":[48.153,40.939,100],"t":30.4},{"o":{"x":0.167,"y":-0.106},"i":{"x":0.833,"y":0.831},"s":[26.225,1.63,100],"t":31.2},{"o":{"x":0.167,"y":0.164},"i":{"x":0.833,"y":1.052},"s":[35.878,18.283,100],"t":32},{"o":{"x":0.167,"y":0.032},"i":{"x":0.833,"y":0.639},"s":[45.795,60.473,100],"t":32.8},{"o":{"x":0.167,"y":0.108},"i":{"x":0.833,"y":0.99},"s":[29.734,37.417,100],"t":33.6},{"o":{"x":0.167,"y":-0.011},"i":{"x":0.833,"y":0.965},"s":[-23.828,13.866,100],"t":34.4},{"o":{"x":0.167,"y":-0.06},"i":{"x":0.833,"y":0.893},"s":[23.282,15.847,100],"t":35.2},{"o":{"x":0.167,"y":0.379},"i":{"x":0.833,"y":1.57},"s":[-4.081,51.66,100],"t":36},{"o":{"x":0.167,"y":0.073},"i":{"x":0.833,"y":0.965},"s":[-11.795,71.385,100],"t":36.8},{"o":{"x":0.167,"y":-0.061},"i":{"x":0.833,"y":0.84},"s":[48.641,43.137,100],"t":37.6},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":1.129},"s":[13.642,2.267,100],"t":38.4},{"o":{"x":0.167,"y":0.051},"i":{"x":0.833,"y":0.979},"s":[-18.389,32.951,100],"t":39.2},{"o":{"x":0.167,"y":-0.028},"i":{"x":0.833,"y":0.947},"s":[63.189,66.722,100],"t":40},{"o":{"x":0.167,"y":-0.146},"i":{"x":0.833,"y":0.844},"s":[2.261,24.31,100],"t":40.8},{"o":{"x":0.167,"y":0.179},"i":{"x":0.833,"y":0.934},"s":[24.372,-2.358,100],"t":41.6},{"o":{"x":0.167,"y":-0.314},"i":{"x":0.833,"y":0.521},"s":[43.66,54.3,100],"t":42.4},{"o":{"x":0.167,"y":0.101},"i":{"x":0.833,"y":0.932},"s":[39.61,13.352,100],"t":43.2},{"o":{"x":0.167,"y":-0.359},"i":{"x":0.833,"y":0.265},"s":[20.359,53.589,100],"t":44},{"o":{"x":0.167,"y":0.094},"i":{"x":0.833,"y":0.823},"s":[23.988,18.274,100],"t":44.8},{"o":{"x":0.167,"y":0.157},"i":{"x":0.833,"y":1.068},"s":[52.384,8.05,100],"t":45.6},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":0.833},"s":[84.408,-0.484,100],"t":46.4},{"s":[26.091,14.017,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[269.95,307.113,0],"t":4.8,"ti":[1.346,1.541,0],"to":[-0.323,-0.36,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[268.011,304.951,0],"t":5.6,"ti":[2.46,3.542,0],"to":[-1.346,-1.541,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[261.875,297.864,0],"t":6.4,"ti":[2.232,5.312,0],"to":[-2.46,-3.542,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[253.252,283.701,0],"t":7.2,"ti":[0.637,5.627,0],"to":[-2.232,-5.312,0]},{"o":{"x":0.167,"y":0.01},"i":{"x":0.833,"y":0.991},"s":[248.481,265.992,0],"t":8,"ti":[-0.921,4.788,0],"to":[-0.637,-5.627,0]},{"o":{"x":0.167,"y":0.062},"i":{"x":0.833,"y":0.948},"s":[249.431,249.939,0],"t":8.8,"ti":[-1.796,3.705,0],"to":[0.921,-4.788,0]},{"o":{"x":0.167,"y":0.099},"i":{"x":0.833,"y":0.916},"s":[254.007,237.262,0],"t":9.6,"ti":[-2.147,2.784,0],"to":[1.796,-3.705,0]},{"o":{"x":0.167,"y":0.123},"i":{"x":0.833,"y":0.894},"s":[260.206,227.707,0],"t":10.4,"ti":[-2.218,2.088,0],"to":[2.147,-2.784,0]},{"o":{"x":0.167,"y":0.139},"i":{"x":0.833,"y":0.878},"s":[266.89,220.559,0],"t":11.2,"ti":[-2.161,1.578,0],"to":[2.218,-2.088,0]},{"o":{"x":0.167,"y":0.15},"i":{"x":0.833,"y":0.867},"s":[273.513,215.179,0],"t":12,"ti":[-2.053,1.203,0],"to":[2.161,-1.578,0]},{"o":{"x":0.167,"y":0.157},"i":{"x":0.833,"y":0.859},"s":[279.855,211.089,0],"t":12.8,"ti":[-1.93,0.918,0],"to":[2.053,-1.203,0]},{"o":{"x":0.167,"y":0.162},"i":{"x":0.833,"y":0.854},"s":[285.832,207.964,0],"t":13.6,"ti":[-1.801,0.7,0],"to":[1.93,-0.918,0]},{"o":{"x":0.167,"y":0.165},"i":{"x":0.833,"y":0.85},"s":[291.433,205.582,0],"t":14.4,"ti":[-1.666,0.538,0],"to":[1.801,-0.7,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.847},"s":[296.641,203.764,0],"t":15.2,"ti":[-1.53,0.417,0],"to":[1.666,-0.538,0]},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.846},"s":[301.428,202.354,0],"t":16,"ti":[-1.402,0.32,0],"to":[1.53,-0.417,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.844},"s":[305.818,201.265,0],"t":16.8,"ti":[-1.283,0.243,0],"to":[1.402,-0.32,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.843},"s":[309.838,200.433,0],"t":17.6,"ti":[-1.172,0.18,0],"to":[1.283,-0.243,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.842},"s":[313.514,199.809,0],"t":18.4,"ti":[-1.068,0.128,0],"to":[1.172,-0.18,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.842},"s":[316.868,199.355,0],"t":19.2,"ti":[-0.97,0.084,0],"to":[1.068,-0.128,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.841},"s":[319.92,199.043,0],"t":20,"ti":[-0.879,0.048,0],"to":[0.97,-0.084,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.842},"s":[322.69,198.85,0],"t":20.8,"ti":[-0.793,0.017,0],"to":[0.879,-0.048,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.842},"s":[325.194,198.756,0],"t":21.6,"ti":[-0.712,-0.009,0],"to":[0.793,-0.017,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.842},"s":[327.449,198.747,0],"t":22.4,"ti":[-0.636,-0.03,0],"to":[0.712,0.009,0]},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":0.843},"s":[329.469,198.808,0],"t":23.2,"ti":[-0.564,-0.048,0],"to":[0.636,0.03,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.844},"s":[331.266,198.928,0],"t":24,"ti":[-0.497,-0.063,0],"to":[0.564,0.048,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.846},"s":[332.854,199.098,0],"t":24.8,"ti":[-0.434,-0.076,0],"to":[0.497,0.063,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.847},"s":[334.247,199.309,0],"t":25.6,"ti":[-0.375,-0.085,0],"to":[0.434,0.076,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.85},"s":[335.457,199.552,0],"t":26.4,"ti":[-0.32,-0.092,0],"to":[0.375,0.085,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.854},"s":[336.496,199.819,0],"t":27.2,"ti":[-0.269,-0.097,0],"to":[0.32,0.092,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.857},"s":[337.376,200.105,0],"t":28,"ti":[-0.221,-0.099,0],"to":[0.269,0.097,0]},{"o":{"x":0.167,"y":0.162},"i":{"x":0.833,"y":0.863},"s":[338.108,200.401,0],"t":28.8,"ti":[-0.178,-0.1,0],"to":[0.221,0.099,0]},{"o":{"x":0.167,"y":0.155},"i":{"x":0.833,"y":0.871},"s":[338.704,200.702,0],"t":29.6,"ti":[-0.138,-0.098,0],"to":[0.178,0.1,0]},{"o":{"x":0.167,"y":0.143},"i":{"x":0.833,"y":0.883},"s":[339.176,200.999,0],"t":30.4,"ti":[-0.103,-0.094,0],"to":[0.138,0.098,0]},{"o":{"x":0.167,"y":0.127},"i":{"x":0.833,"y":0.897},"s":[339.534,201.288,0],"t":31.2,"ti":[-0.071,-0.087,0],"to":[0.103,0.094,0]},{"o":{"x":0.167,"y":0.103},"i":{"x":0.833,"y":0.917},"s":[339.791,201.562,0],"t":32,"ti":[-0.043,-0.079,0],"to":[0.071,0.087,0]},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.944},"s":[339.958,201.813,0],"t":32.8,"ti":[-0.02,-0.068,0],"to":[0.043,0.079,0]},{"o":{"x":0.167,"y":0.026},"i":{"x":0.833,"y":0.98},"s":[340.049,202.035,0],"t":33.6,"ti":[0,-0.055,0],"to":[0.02,0.068,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[340.075,202.222,0],"t":34.4,"ti":[0.014,-0.04,0],"to":[0,0.055,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[340.051,202.365,0],"t":35.2,"ti":[0.025,-0.022,0],"to":[-0.014,0.04,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[339.989,202.459,0],"t":36,"ti":[0.024,-0.002,0],"to":[-0.025,0.022,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[339.903,202.496,0],"t":36.8,"ti":[0.008,0.02,0],"to":[-0.024,0.002,0]},{"o":{"x":0.167,"y":0.02},"i":{"x":0.833,"y":0.968},"s":[339.844,202.469,0],"t":37.6,"ti":[-0.011,0.042,0],"to":[-0.008,-0.02,0]},{"o":{"x":0.167,"y":0.041},"i":{"x":0.833,"y":0.945},"s":[339.858,202.373,0],"t":38.4,"ti":[-0.012,0.057,0],"to":[0.011,-0.042,0]},{"o":{"x":0.167,"y":0.016},"i":{"x":0.833,"y":0.982},"s":[339.908,202.219,0],"t":39.2,"ti":[-0.001,0.066,0],"to":[0.012,-0.057,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[339.927,202.033,0],"t":40,"ti":[0.008,0.072,0],"to":[0.001,-0.066,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[339.916,201.823,0],"t":40.8,"ti":[0.017,0.076,0],"to":[-0.008,-0.072,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[339.877,201.599,0],"t":41.6,"ti":[0.026,0.078,0],"to":[-0.017,-0.076,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[339.812,201.365,0],"t":42.4,"ti":[0.033,0.078,0],"to":[-0.026,-0.078,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[339.723,201.128,0],"t":43.2,"ti":[0.04,0.076,0],"to":[-0.033,-0.078,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[339.613,200.895,0],"t":44,"ti":[0.046,0.073,0],"to":[-0.04,-0.076,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[339.484,200.67,0],"t":44.8,"ti":[0.051,0.068,0],"to":[-0.046,-0.073,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[339.339,200.457,0],"t":45.6,"ti":[0.055,0.062,0],"to":[-0.051,-0.068,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[339.179,200.262,0],"t":46.4,"ti":[0.029,0.029,0],"to":[-0.055,-0.062,0]},{"s":[339.007,200.087,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":4.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":8.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":26.4},{"s":[0],"t":39.2}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Polystar 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sr","bm":0,"hd":false,"mn":"ADBE Vector Shape - Star","nm":"Polystar Path 1","ix":1,"d":1,"pt":{"a":0,"k":3,"ix":3},"p":{"a":0,"k":[6,32],"ix":4},"or":{"a":0,"k":6.599,"ix":7},"os":{"a":0,"k":0,"ix":9},"r":{"a":0,"k":0,"ix":5},"sy":2},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.4745,0.8392,0.6667],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-7.382,-25.677],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":12},{"ty":4,"nm":"Shape Layer 39","sr":1,"st":8.8,"op":48,"ip":8.8,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.877},"s":[59.343,96.124,100],"t":8.8},{"o":{"x":0.167,"y":0.259},"i":{"x":0.833,"y":0.969},"s":[89.744,43.042,100],"t":9.6},{"o":{"x":0.167,"y":-0.05},"i":{"x":0.833,"y":0.861},"s":[104.203,66.307,100],"t":10.4},{"o":{"x":0.167,"y":0.208},"i":{"x":0.833,"y":1.424},"s":[95.197,89.821,100],"t":11.2},{"o":{"x":0.167,"y":0.07},"i":{"x":0.833,"y":0.819},"s":[89.153,41.816,100],"t":12},{"o":{"x":0.167,"y":0.154},"i":{"x":0.833,"y":0.993},"s":[125.946,74.556,100],"t":12.8},{"o":{"x":0.167,"y":-0.008},"i":{"x":0.833,"y":0.815},"s":[169.121,79.673,100],"t":13.6},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.937},"s":[129.751,102.297,100],"t":14.4},{"o":{"x":0.167,"y":-0.266},"i":{"x":0.833,"y":0.747},"s":[81.726,99.791,100],"t":15.2},{"o":{"x":0.167,"y":0.124},"i":{"x":0.833,"y":1.055},"s":[93.197,117.733,100],"t":16},{"o":{"x":0.167,"y":0.033},"i":{"x":0.833,"y":0.922},"s":[116.588,84.536,100],"t":16.8},{"o":{"x":0.167,"y":-1.179},"i":{"x":0.833,"y":0.473},"s":[77.774,77.458,100],"t":17.6},{"o":{"x":0.167,"y":0.099},"i":{"x":0.833,"y":0.932},"s":[80.336,112.065,100],"t":18.4},{"o":{"x":0.167,"y":-0.364},"i":{"x":0.833,"y":1.026},"s":[93.979,55.33,100],"t":19.2},{"o":{"x":0.167,"y":0.02},"i":{"x":0.833,"y":1.832},"s":[91.437,45.624,100],"t":20},{"o":{"x":0.167,"y":0.076},"i":{"x":0.833,"y":1.069},"s":[94.777,67.955,100],"t":20.8},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":0.954},"s":[58.109,118.474,100],"t":21.6},{"o":{"x":0.167,"y":-0.102},"i":{"x":0.833,"y":0.954},"s":[125.074,97.355,100],"t":22.4},{"o":{"x":0.167,"y":-0.104},"i":{"x":0.833,"y":1.408},"s":[95.015,93.056,100],"t":23.2},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":0.982},"s":[108.364,63.932,100],"t":24},{"o":{"x":0.167,"y":-0.022},"i":{"x":0.833,"y":0.838},"s":[29.719,92.263,100],"t":24.8},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.943},"s":[91.786,90.449,100],"t":25.6},{"o":{"x":0.167,"y":-0.177},"i":{"x":0.833,"y":0.84},"s":[150.239,55.635,100],"t":26.4},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.842},"s":[131.528,79.867,100],"t":27.2},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":0.948},"s":[114.424,104,100],"t":28},{"o":{"x":0.167,"y":-0.141},"i":{"x":0.833,"y":1.464},"s":[99.134,112.3,100],"t":28.8},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.912},"s":[104.825,98.77,100],"t":29.6},{"o":{"x":0.167,"y":1.54},"i":{"x":0.833,"y":1.398},"s":[67.48,67.824,100],"t":30.4},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":0.924},"s":[65.344,10.519,100],"t":31.2},{"o":{"x":0.167,"y":-0.911},"i":{"x":0.833,"y":-3.208},"s":[77.671,71.977,100],"t":32},{"o":{"x":0.167,"y":0.085},"i":{"x":0.833,"y":0.93},"s":[76.639,101.368,100],"t":32.8},{"o":{"x":0.167,"y":-0.443},"i":{"x":0.833,"y":0.96},"s":[25.532,39.221,100],"t":33.6},{"o":{"x":0.167,"y":-0.077},"i":{"x":0.833,"y":1.134},"s":[33.627,30.543,100],"t":34.4},{"o":{"x":0.167,"y":0.051},"i":{"x":0.833,"y":0.683},"s":[29.417,64.046,100],"t":35.2},{"o":{"x":0.167,"y":0.113},"i":{"x":0.833,"y":1.008},"s":[40.374,53.993,100],"t":36},{"o":{"x":0.167,"y":0.007},"i":{"x":0.833,"y":0.787},"s":[71.134,29.6,100],"t":36.8},{"o":{"x":0.167,"y":0.137},"i":{"x":0.833,"y":1.078},"s":[37.38,38.828,100],"t":37.6},{"o":{"x":0.167,"y":0.04},"i":{"x":0.833,"y":0.948},"s":[-15.322,-10.291,100],"t":38.4},{"o":{"x":0.167,"y":-0.139},"i":{"x":0.833,"y":0.912},"s":[86.713,39.937,100],"t":39.2},{"o":{"x":0.167,"y":1.669},"i":{"x":0.833,"y":1.314},"s":[48.493,27.546,100],"t":40},{"o":{"x":0.167,"y":0.066},"i":{"x":0.833,"y":0.73},"s":[46.484,-5.44,100],"t":40.8},{"o":{"x":0.167,"y":0.12},"i":{"x":0.833,"y":1.035},"s":[56.051,33.097,100],"t":41.6},{"o":{"x":0.167,"y":0.025},"i":{"x":0.833,"y":0.934},"s":[77.513,62.169,100],"t":42.4},{"o":{"x":0.167,"y":-0.324},"i":{"x":0.833,"y":0.866},"s":[46.909,73.396,100],"t":43.2},{"o":{"x":0.167,"y":0.222},"i":{"x":0.833,"y":0.037},"s":[53.173,25.847,100],"t":44},{"o":{"x":0.167,"y":0.091},"i":{"x":0.833,"y":1.024},"s":[56.946,-11.873,100],"t":44.8},{"o":{"x":0.167,"y":0.019},"i":{"x":0.833,"y":0.891},"s":[96.787,-13.805,100],"t":45.6},{"o":{"x":0.167,"y":0.356},"i":{"x":0.833,"y":0.833},"s":[45.548,-2.059,100],"t":46.4},{"s":[29.917,33.378,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[266.709,299.63,0],"t":8.8,"ti":[0.204,-1.854,0],"to":[-0.015,0.376,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[266.621,301.887,0],"t":9.6,"ti":[0.96,-4.091,0],"to":[-0.204,1.854,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[265.488,310.754,0],"t":10.4,"ti":[2.202,-5.284,0],"to":[-0.96,4.091,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[260.859,326.432,0],"t":11.2,"ti":[3.145,-4.688,0],"to":[-2.202,5.284,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[252.276,342.456,0],"t":12,"ti":[3.441,-3.397,0],"to":[-3.145,4.688,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[241.99,354.561,0],"t":12.8,"ti":[3.35,-2.293,0],"to":[-3.441,3.397,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[231.629,362.84,0],"t":13.6,"ti":[3.107,-1.507,0],"to":[-3.35,2.293,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[221.889,368.32,0],"t":14.4,"ti":[2.823,-0.973,0],"to":[-3.107,1.507,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[212.988,371.885,0],"t":15.2,"ti":[2.545,-0.61,0],"to":[-2.823,0.973,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[204.948,374.155,0],"t":16,"ti":[2.287,-0.361,0],"to":[-2.545,0.61,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[197.719,375.542,0],"t":16.8,"ti":[2.057,-0.189,0],"to":[-2.287,0.361,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[191.223,376.321,0],"t":17.6,"ti":[1.855,-0.069,0],"to":[-2.057,0.189,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[185.374,376.678,0],"t":18.4,"ti":[1.678,0.016,0],"to":[-1.855,0.069,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[180.091,376.736,0],"t":19.2,"ti":[1.52,0.078,0],"to":[-1.678,-0.016,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[175.308,376.58,0],"t":20,"ti":[1.379,0.122,0],"to":[-1.52,-0.078,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[170.97,376.27,0],"t":20.8,"ti":[1.252,0.155,0],"to":[-1.379,-0.122,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[167.033,375.845,0],"t":21.6,"ti":[1.137,0.18,0],"to":[-1.252,-0.155,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[163.458,375.337,0],"t":22.4,"ti":[1.031,0.198,0],"to":[-1.137,-0.18,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[160.214,374.766,0],"t":23.2,"ti":[0.933,0.212,0],"to":[-1.031,-0.198,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[157.274,374.147,0],"t":24,"ti":[0.843,0.223,0],"to":[-0.933,-0.212,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[154.615,373.492,0],"t":24.8,"ti":[0.758,0.232,0],"to":[-0.843,-0.223,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[152.218,372.807,0],"t":25.6,"ti":[0.683,0.239,0],"to":[-0.758,-0.232,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[150.067,372.098,0],"t":26.4,"ti":[0.619,0.242,0],"to":[-0.683,-0.239,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[148.12,371.372,0],"t":27.2,"ti":[0.56,0.239,0],"to":[-0.619,-0.242,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[146.355,370.647,0],"t":28,"ti":[0.506,0.232,0],"to":[-0.56,-0.239,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[144.758,369.937,0],"t":28.8,"ti":[0.454,0.219,0],"to":[-0.506,-0.232,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[143.32,369.258,0],"t":29.6,"ti":[0.406,0.203,0],"to":[-0.454,-0.219,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[142.032,368.621,0],"t":30.4,"ti":[0.36,0.184,0],"to":[-0.406,-0.203,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[140.885,368.038,0],"t":31.2,"ti":[0.317,0.162,0],"to":[-0.36,-0.184,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[139.871,367.517,0],"t":32,"ti":[0.277,0.138,0],"to":[-0.317,-0.162,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[138.982,367.066,0],"t":32.8,"ti":[0.238,0.111,0],"to":[-0.277,-0.138,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[138.211,366.692,0],"t":33.6,"ti":[0.201,0.083,0],"to":[-0.238,-0.111,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[137.554,366.399,0],"t":34.4,"ti":[0.166,0.055,0],"to":[-0.201,-0.083,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[137.005,366.191,0],"t":35.2,"ti":[0.132,0.025,0],"to":[-0.166,-0.055,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[136.559,366.071,0],"t":36,"ti":[0.1,-0.005,0],"to":[-0.132,-0.025,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[136.211,366.04,0],"t":36.8,"ti":[0.069,-0.034,0],"to":[-0.1,0.005,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[135.959,366.098,0],"t":37.6,"ti":[0.039,-0.063,0],"to":[-0.069,0.034,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[135.797,366.244,0],"t":38.4,"ti":[0.011,-0.091,0],"to":[-0.039,0.063,0]},{"o":{"x":0.167,"y":0.004},"i":{"x":0.833,"y":0.995},"s":[135.723,366.476,0],"t":39.2,"ti":[-0.016,-0.118,0],"to":[-0.011,0.091,0]},{"o":{"x":0.167,"y":0.033},"i":{"x":0.833,"y":0.96},"s":[135.732,366.79,0],"t":40,"ti":[-0.036,-0.141,0],"to":[0.016,0.118,0]},{"o":{"x":0.167,"y":0.042},"i":{"x":0.833,"y":0.952},"s":[135.82,367.181,0],"t":40.8,"ti":[-0.044,-0.159,0],"to":[0.036,0.141,0]},{"o":{"x":0.167,"y":0.041},"i":{"x":0.833,"y":0.955},"s":[135.95,367.634,0],"t":41.6,"ti":[-0.046,-0.173,0],"to":[0.044,0.159,0]},{"o":{"x":0.167,"y":0.04},"i":{"x":0.833,"y":0.957},"s":[136.085,368.134,0],"t":42.4,"ti":[-0.047,-0.184,0],"to":[0.046,0.173,0]},{"o":{"x":0.167,"y":0.039},"i":{"x":0.833,"y":0.959},"s":[136.223,368.671,0],"t":43.2,"ti":[-0.048,-0.193,0],"to":[0.047,0.184,0]},{"o":{"x":0.167,"y":0.039},"i":{"x":0.833,"y":0.96},"s":[136.365,369.239,0],"t":44,"ti":[-0.048,-0.197,0],"to":[0.048,0.193,0]},{"o":{"x":0.167,"y":0.039},"i":{"x":0.833,"y":0.961},"s":[136.509,369.827,0],"t":44.8,"ti":[-0.048,-0.198,0],"to":[0.048,0.197,0]},{"o":{"x":0.167,"y":0.039},"i":{"x":0.833,"y":0.962},"s":[136.653,370.423,0],"t":45.6,"ti":[-0.047,-0.195,0],"to":[0.048,0.198,0]},{"o":{"x":0.167,"y":0.04},"i":{"x":0.833,"y":0.96},"s":[136.796,371.017,0],"t":46.4,"ti":[-0.023,-0.096,0],"to":[0.047,0.195,0]},{"s":[136.937,371.594,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":8.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":12.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":30.4},{"s":[0],"t":43.2}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Polystar 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sr","bm":0,"hd":false,"mn":"ADBE Vector Shape - Star","nm":"Polystar Path 1","ix":1,"d":1,"pt":{"a":0,"k":3,"ix":3},"p":{"a":0,"k":[6,32],"ix":4},"or":{"a":0,"k":6.599,"ix":7},"os":{"a":0,"k":0,"ix":9},"r":{"a":0,"k":0,"ix":5},"sy":2},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0,0.7647,0.902],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-7.382,-25.677],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":13},{"ty":4,"nm":"Shape Layer 38","sr":1,"st":5.6,"op":48,"ip":5.6,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.684},"s":[100.63,69.657,100],"t":5.6},{"o":{"x":0.167,"y":0.113},"i":{"x":0.833,"y":1.351},"s":[104.514,69.052,100],"t":6.4},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.905},"s":[115.346,69.821,100],"t":7.2},{"o":{"x":0.167,"y":0.695},"i":{"x":0.833,"y":1.398},"s":[58.871,88.161,100],"t":8},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":0.965},"s":[51.174,36.165,100],"t":8.8},{"o":{"x":0.167,"y":-0.06},"i":{"x":0.833,"y":0.972},"s":[95.636,55.822,100],"t":9.6},{"o":{"x":0.167,"y":-0.042},"i":{"x":0.833,"y":0.882},"s":[69.725,97.853,100],"t":10.4},{"o":{"x":0.167,"y":0.285},"i":{"x":0.833,"y":0.246},"s":[86.959,82.233,100],"t":11.2},{"o":{"x":0.167,"y":0.094},"i":{"x":0.833,"y":0.96},"s":[94.096,56.625,100],"t":12},{"o":{"x":0.167,"y":-0.077},"i":{"x":0.833,"y":0.833},"s":[151.503,104.404,100],"t":12.8},{"o":{"x":0.167,"y":0.166},"i":{"x":0.833,"y":0.845},"s":[121.653,123.646,100],"t":13.6},{"o":{"x":0.167,"y":0.181},"i":{"x":0.833,"y":0.987},"s":[91.668,73.435,100],"t":14.4},{"o":{"x":0.167,"y":-0.015},"i":{"x":0.833,"y":0.867},"s":[66.045,99.285,100],"t":15.2},{"o":{"x":0.167,"y":0.223},"i":{"x":0.833,"y":0.952},"s":[87.746,66.291,100],"t":16},{"o":{"x":0.167,"y":-0.113},"i":{"x":0.833,"y":0.929},"s":[100.66,48.526,100],"t":16.8},{"o":{"x":0.167,"y":-0.477},"i":{"x":0.833,"y":1.102},"s":[95.172,108.893,100],"t":17.6},{"o":{"x":0.167,"y":0.046},"i":{"x":0.833,"y":2.575},"s":[95.987,89.94,100],"t":18.4},{"o":{"x":0.167,"y":0.079},"i":{"x":0.833,"y":1.108},"s":[94.176,58.401,100],"t":19.2},{"o":{"x":0.167,"y":0.047},"i":{"x":0.833,"y":0.975},"s":[130.21,65.835,100],"t":20},{"o":{"x":0.167,"y":-0.036},"i":{"x":0.833,"y":0.897},"s":[47.499,124.757,100],"t":20.8},{"o":{"x":0.167,"y":0.43},"i":{"x":0.833,"y":0.822},"s":[105.068,83.037,100],"t":21.6},{"o":{"x":0.167,"y":0.157},"i":{"x":0.833,"y":1.17},"s":[118.917,107.79,100],"t":22.4},{"o":{"x":0.167,"y":0.056},"i":{"x":0.833,"y":0.86},"s":[134.616,75.912,100],"t":23.2},{"o":{"x":0.167,"y":0.205},"i":{"x":0.833,"y":1.094},"s":[86.877,99.716,100],"t":24},{"o":{"x":0.167,"y":0.044},"i":{"x":0.833,"y":0.948},"s":[54.265,96.009,100],"t":24.8},{"o":{"x":0.167,"y":-0.139},"i":{"x":0.833,"y":0.9},"s":[123.839,64.381,100],"t":25.6},{"o":{"x":0.167,"y":0.496},"i":{"x":0.833,"y":0.39},"s":[97.726,39.711,100],"t":26.4},{"o":{"x":0.167,"y":0.097},"i":{"x":0.833,"y":0.984},"s":[92.458,75.119,100],"t":27.2},{"o":{"x":0.167,"y":-0.019},"i":{"x":0.833,"y":0.931},"s":[59.151,108.162,100],"t":28},{"o":{"x":0.167,"y":-0.405},"i":{"x":0.833,"y":0.407},"s":[86.256,126.307,100],"t":28.8},{"o":{"x":0.167,"y":0.097},"i":{"x":0.833,"y":0.957},"s":[81.627,95.551,100],"t":29.6},{"o":{"x":0.167,"y":-0.089},"i":{"x":0.833,"y":0.83},"s":[53.31,31.043,100],"t":30.4},{"o":{"x":0.167,"y":0.164},"i":{"x":0.833,"y":1.098},"s":[67.002,42.37,100],"t":31.2},{"o":{"x":0.167,"y":0.045},"i":{"x":0.833,"y":0.867},"s":[81.207,78.404,100],"t":32},{"o":{"x":0.167,"y":0.224},"i":{"x":0.833,"y":0.908},"s":[50.269,13.881,100],"t":32.8},{"o":{"x":0.167,"y":0.933},"i":{"x":0.833,"y":1.43},"s":[31.981,57.039,100],"t":33.6},{"o":{"x":0.167,"y":0.07},"i":{"x":0.833,"y":0.97},"s":[30.188,54.035,100],"t":34.4},{"o":{"x":0.167,"y":-0.046},"i":{"x":0.833,"y":0.919},"s":[41.246,45.317,100],"t":35.2},{"o":{"x":0.167,"y":-2.661},"i":{"x":0.833,"y":17.435},"s":[34.148,-11.396,100],"t":36},{"o":{"x":0.167,"y":0.083},"i":{"x":0.833,"y":0.997},"s":[34.363,9.033,100],"t":36.8},{"o":{"x":0.167,"y":-0.004},"i":{"x":0.833,"y":0.893},"s":[-8.365,-24.009,100],"t":37.6},{"o":{"x":0.167,"y":0.375},"i":{"x":0.833,"y":0.892},"s":[32.621,-15.669,100],"t":38.4},{"o":{"x":0.167,"y":0.364},"i":{"x":0.833,"y":0.847},"s":[44.332,-6.94,100],"t":39.2},{"o":{"x":0.167,"y":0.183},"i":{"x":0.833,"y":0.476},"s":[47.804,-14.568,100],"t":40},{"o":{"x":0.167,"y":0.099},"i":{"x":0.833,"y":1.098},"s":[50.704,8.589,100],"t":40.8},{"o":{"x":0.167,"y":0.045},"i":{"x":0.833,"y":0.912},"s":[66.039,65.528,100],"t":41.6},{"o":{"x":0.167,"y":1.665},"i":{"x":0.833,"y":1.638},"s":[32.735,78.112,100],"t":42.4},{"o":{"x":0.167,"y":0.074},"i":{"x":0.833,"y":0.718},"s":[30.98,12.995,100],"t":43.2},{"o":{"x":0.167,"y":0.118},"i":{"x":0.833,"y":0.934},"s":[46.164,-40.385,100],"t":44},{"o":{"x":0.167,"y":-0.313},"i":{"x":0.833,"y":0.25},"s":[82.432,-28.944,100],"t":44.8},{"o":{"x":0.167,"y":0.094},"i":{"x":0.833,"y":0.952},"s":[74.813,1.96,100],"t":45.6},{"o":{"x":0.167,"y":-0.112},"i":{"x":0.833,"y":0.833},"s":[13.817,22.06,100],"t":46.4},{"s":[39.779,9.173,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.156},"i":{"x":0.833,"y":0.618},"s":[262.436,299.331,0],"t":5.6,"ti":[-2.348,1.046,0],"to":[0.489,-0.187,0]},{"o":{"x":0.167,"y":0.095},"i":{"x":0.833,"y":0.786},"s":[265.373,298.21,0],"t":6.4,"ti":[-5.031,2.854,0],"to":[2.348,-1.046,0]},{"o":{"x":0.167,"y":0.109},"i":{"x":0.833,"y":0.851},"s":[276.523,293.055,0],"t":7.2,"ti":[-6.175,4.882,0],"to":[5.031,-2.854,0]},{"o":{"x":0.167,"y":0.114},"i":{"x":0.833,"y":0.888},"s":[295.56,281.084,0],"t":8,"ti":[-4.919,5.974,0],"to":[6.175,-4.882,0]},{"o":{"x":0.167,"y":0.094},"i":{"x":0.833,"y":0.919},"s":[313.573,263.763,0],"t":8.8,"ti":[-2.793,5.995,0],"to":[4.919,-5.974,0]},{"o":{"x":0.167,"y":0.053},"i":{"x":0.833,"y":0.956},"s":[325.076,245.24,0],"t":9.6,"ti":[-0.958,5.467,0],"to":[2.793,-5.995,0]},{"o":{"x":0.167,"y":0.006},"i":{"x":0.833,"y":0.995},"s":[330.333,227.794,0],"t":10.4,"ti":[0.382,4.708,0],"to":[0.958,-5.467,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[330.823,212.44,0],"t":11.2,"ti":[1.261,3.892,0],"to":[-0.382,-4.708,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[328.039,199.545,0],"t":12,"ti":[1.765,3.129,0],"to":[-1.261,-3.892,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[323.257,189.086,0],"t":12.8,"ti":[2.001,2.482,0],"to":[-1.765,-3.129,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[317.447,180.769,0],"t":13.6,"ti":[2.064,1.961,0],"to":[-2.001,-2.482,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[311.25,174.195,0],"t":14.4,"ti":[2.024,1.552,0],"to":[-2.064,-1.961,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[305.064,169.001,0],"t":15.2,"ti":[1.932,1.236,0],"to":[-2.024,-1.552,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[299.106,164.881,0],"t":16,"ti":[1.816,0.99,0],"to":[-1.932,-1.236,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[293.474,161.588,0],"t":16.8,"ti":[1.69,0.797,0],"to":[-1.816,-0.99,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[288.212,158.939,0],"t":17.6,"ti":[1.563,0.644,0],"to":[-1.69,-0.797,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[283.333,156.803,0],"t":18.4,"ti":[1.437,0.519,0],"to":[-1.563,-0.644,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[278.836,155.078,0],"t":19.2,"ti":[1.316,0.416,0],"to":[-1.437,-0.519,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[274.712,153.691,0],"t":20,"ti":[1.201,0.33,0],"to":[-1.316,-0.416,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[270.942,152.585,0],"t":20.8,"ti":[1.094,0.257,0],"to":[-1.201,-0.33,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[267.505,151.714,0],"t":21.6,"ti":[0.992,0.194,0],"to":[-1.094,-0.257,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[264.381,151.045,0],"t":22.4,"ti":[0.897,0.139,0],"to":[-0.992,-0.194,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[261.551,150.551,0],"t":23.2,"ti":[0.808,0.091,0],"to":[-0.897,-0.139,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[258.997,150.211,0],"t":24,"ti":[0.724,0.048,0],"to":[-0.808,-0.091,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[256.702,150.007,0],"t":24.8,"ti":[0.646,0.009,0],"to":[-0.724,-0.048,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[254.651,149.925,0],"t":25.6,"ti":[0.572,-0.025,0],"to":[-0.646,-0.009,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[252.828,149.951,0],"t":26.4,"ti":[0.502,-0.055,0],"to":[-0.572,0.025,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[251.221,150.073,0],"t":27.2,"ti":[0.437,-0.082,0],"to":[-0.502,0.055,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[249.815,150.281,0],"t":28,"ti":[0.377,-0.105,0],"to":[-0.437,0.082,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[248.597,150.563,0],"t":28.8,"ti":[0.321,-0.125,0],"to":[-0.377,0.105,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[247.552,150.91,0],"t":29.6,"ti":[0.269,-0.141,0],"to":[-0.321,0.125,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[246.671,151.311,0],"t":30.4,"ti":[0.22,-0.154,0],"to":[-0.269,0.141,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[245.941,151.756,0],"t":31.2,"ti":[0.174,-0.163,0],"to":[-0.22,0.154,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[245.353,152.233,0],"t":32,"ti":[0.132,-0.168,0],"to":[-0.174,0.163,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[244.897,152.732,0],"t":32.8,"ti":[0.093,-0.169,0],"to":[-0.132,0.168,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[244.562,153.241,0],"t":33.6,"ti":[0.057,-0.166,0],"to":[-0.093,0.169,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[244.34,153.746,0],"t":34.4,"ti":[0.024,-0.158,0],"to":[-0.057,0.166,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[244.221,154.236,0],"t":35.2,"ti":[-0.006,-0.145,0],"to":[-0.024,0.158,0]},{"o":{"x":0.167,"y":0.025},"i":{"x":0.833,"y":0.977},"s":[244.197,154.694,0],"t":36,"ti":[-0.033,-0.128,0],"to":[0.006,0.145,0]},{"o":{"x":0.167,"y":0.063},"i":{"x":0.833,"y":0.943},"s":[244.257,155.108,0],"t":36.8,"ti":[-0.049,-0.109,0],"to":[0.033,0.128,0]},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":0.92},"s":[244.394,155.461,0],"t":37.6,"ti":[-0.051,-0.108,0],"to":[0.049,0.109,0]},{"o":{"x":0.167,"y":0.063},"i":{"x":0.833,"y":0.932},"s":[244.552,155.765,0],"t":38.4,"ti":[-0.047,-0.12,0],"to":[0.051,0.108,0]},{"o":{"x":0.167,"y":0.054},"i":{"x":0.833,"y":0.942},"s":[244.699,156.107,0],"t":39.2,"ti":[-0.044,-0.131,0],"to":[0.047,0.12,0]},{"o":{"x":0.167,"y":0.049},"i":{"x":0.833,"y":0.949},"s":[244.836,156.487,0],"t":40,"ti":[-0.041,-0.137,0],"to":[0.044,0.131,0]},{"o":{"x":0.167,"y":0.046},"i":{"x":0.833,"y":0.954},"s":[244.964,156.891,0],"t":40.8,"ti":[-0.039,-0.14,0],"to":[0.041,0.137,0]},{"o":{"x":0.167,"y":0.043},"i":{"x":0.833,"y":0.957},"s":[245.085,157.309,0],"t":41.6,"ti":[-0.037,-0.14,0],"to":[0.039,0.14,0]},{"o":{"x":0.167,"y":0.042},"i":{"x":0.833,"y":0.959},"s":[245.198,157.733,0],"t":42.4,"ti":[-0.035,-0.138,0],"to":[0.037,0.14,0]},{"o":{"x":0.167,"y":0.041},"i":{"x":0.833,"y":0.961},"s":[245.305,158.152,0],"t":43.2,"ti":[-0.033,-0.133,0],"to":[0.035,0.138,0]},{"o":{"x":0.167,"y":0.041},"i":{"x":0.833,"y":0.961},"s":[245.406,158.559,0],"t":44,"ti":[-0.031,-0.125,0],"to":[0.033,0.133,0]},{"o":{"x":0.167,"y":0.042},"i":{"x":0.833,"y":0.961},"s":[245.502,158.947,0],"t":44.8,"ti":[-0.03,-0.116,0],"to":[0.031,0.125,0]},{"o":{"x":0.167,"y":0.045},"i":{"x":0.833,"y":0.959},"s":[245.594,159.31,0],"t":45.6,"ti":[-0.029,-0.104,0],"to":[0.03,0.116,0]},{"o":{"x":0.167,"y":0.049},"i":{"x":0.833,"y":0.953},"s":[245.683,159.641,0],"t":46.4,"ti":[-0.014,-0.049,0],"to":[0.029,0.104,0]},{"s":[245.769,159.936,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":5.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":9.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":27.2},{"s":[0],"t":40}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Polystar 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sr","bm":0,"hd":false,"mn":"ADBE Vector Shape - Star","nm":"Polystar Path 1","ix":1,"d":1,"pt":{"a":0,"k":3,"ix":3},"p":{"a":0,"k":[6,32],"ix":4},"or":{"a":0,"k":6.599,"ix":7},"os":{"a":0,"k":0,"ix":9},"r":{"a":0,"k":0,"ix":5},"sy":2},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.4745,0.8392,0.6667],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-7.382,-25.677],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":14},{"ty":4,"nm":"Shape Layer 37","sr":1,"st":7.2,"op":48,"ip":7.2,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":2.237},"s":[60.433,69.807,100],"t":7.2},{"o":{"x":0.167,"y":0.078},"i":{"x":0.833,"y":0.948},"s":[57.035,63.909,100],"t":8},{"o":{"x":0.167,"y":-0.136},"i":{"x":0.833,"y":0.869},"s":[110.865,70.792,100],"t":8.8},{"o":{"x":0.167,"y":0.23},"i":{"x":0.833,"y":0.993},"s":[90.384,117.236,100],"t":9.6},{"o":{"x":0.167,"y":-0.008},"i":{"x":0.833,"y":0.615},"s":[78.755,118.657,100],"t":10.4},{"o":{"x":0.167,"y":0.106},"i":{"x":0.833,"y":0.957},"s":[89.349,90.995,100],"t":11.2},{"o":{"x":0.167,"y":-0.09},"i":{"x":0.833,"y":0.759},"s":[127.76,125.63,100],"t":12},{"o":{"x":0.167,"y":0.128},"i":{"x":0.833,"y":0.85},"s":[109.298,141.669,100],"t":12.8},{"o":{"x":0.167,"y":0.187},"i":{"x":0.833,"y":0.93},"s":[74.466,65.123,100],"t":13.6},{"o":{"x":0.167,"y":-0.45},"i":{"x":0.833,"y":0.468},"s":[46.407,94.474,100],"t":14.4},{"o":{"x":0.167,"y":0.099},"i":{"x":0.833,"y":0.94},"s":[50.79,61.594,100],"t":15.2},{"o":{"x":0.167,"y":-0.209},"i":{"x":0.833,"y":1.179},"s":[74.379,60.195,100],"t":16},{"o":{"x":0.167,"y":0.057},"i":{"x":0.833,"y":0.903},"s":[67.656,89.669,100],"t":16.8},{"o":{"x":0.167,"y":0.577},"i":{"x":0.833,"y":-0.318},"s":[88.817,119.34,100],"t":17.6},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":1.032},"s":[92.391,70.889,100],"t":18.4},{"o":{"x":0.167,"y":0.023},"i":{"x":0.833,"y":0.912},"s":[145.365,97.56,100],"t":19.2},{"o":{"x":0.167,"y":1.509},"i":{"x":0.833,"y":1.702},"s":[71.948,114.853,100],"t":20},{"o":{"x":0.167,"y":0.074},"i":{"x":0.833,"y":0.886},"s":[67.657,97.077,100],"t":20.8},{"o":{"x":0.167,"y":0.312},"i":{"x":0.833,"y":0.837},"s":[108.077,92.496,100],"t":21.6},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":1.302},"s":[122.812,108.142,100],"t":22.4},{"o":{"x":0.167,"y":0.065},"i":{"x":0.833,"y":0.944},"s":[136.892,105.97,100],"t":23.2},{"o":{"x":0.167,"y":-0.168},"i":{"x":0.833,"y":0.917},"s":[71.752,114.791,100],"t":24},{"o":{"x":0.167,"y":-10.728},"i":{"x":0.833,"y":4.698},"s":[93.325,80.942,100],"t":24.8},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":1.281},"s":[93.159,47.153,100],"t":25.6},{"o":{"x":0.167,"y":0.064},"i":{"x":0.833,"y":0.918},"s":[100.704,44.07,100],"t":26.4},{"o":{"x":0.167,"y":-7.898},"i":{"x":0.833,"y":-6.847},"s":[67.68,88.243,100],"t":27.2},{"o":{"x":0.167,"y":0.084},"i":{"x":0.833,"y":0.94},"s":[68.025,152.101,100],"t":28},{"o":{"x":0.167,"y":-0.209},"i":{"x":0.833,"y":0.562},"s":[100.152,137.254,100],"t":28.8},{"o":{"x":0.167,"y":0.103},"i":{"x":0.833,"y":0.999},"s":[91.001,95.342,100],"t":29.6},{"o":{"x":0.167,"y":-0.001},"i":{"x":0.833,"y":0.918},"s":[52.026,87.036,100],"t":30.4},{"o":{"x":0.167,"y":-3.839},"i":{"x":0.833,"y":-2.601},"s":[90.362,85.565,100],"t":31.2},{"o":{"x":0.167,"y":0.085},"i":{"x":0.833,"y":0.926},"s":[89.547,32.423,100],"t":32},{"o":{"x":0.167,"y":-0.669},"i":{"x":0.833,"y":1.446},"s":[55.168,83.983,100],"t":32.8},{"o":{"x":0.167,"y":0.07},"i":{"x":0.833,"y":0.934},"s":[58.978,88.274,100],"t":33.6},{"o":{"x":0.167,"y":-0.325},"i":{"x":0.833,"y":1.109},"s":[34.79,80.994,100],"t":34.4},{"o":{"x":0.167,"y":0.047},"i":{"x":0.833,"y":0.922},"s":[39.732,2.714,100],"t":35.2},{"o":{"x":0.167,"y":-1.292},"i":{"x":0.833,"y":4.228},"s":[28.352,-0.992,100],"t":36},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":0.984},"s":[29.041,12.182,100],"t":36.8},{"o":{"x":0.167,"y":-0.02},"i":{"x":0.833,"y":0.923},"s":[1.635,-20.19,100],"t":37.6},{"o":{"x":0.167,"y":-0.991},"i":{"x":0.833,"y":2.207},"s":[23.803,1.627,100],"t":38.4},{"o":{"x":0.167,"y":0.078},"i":{"x":0.833,"y":0.933},"s":[22.083,0.392,100],"t":39.2},{"o":{"x":0.167,"y":-0.338},"i":{"x":0.833,"y":0.444},"s":[48.704,41.779,100],"t":40},{"o":{"x":0.167,"y":0.098},"i":{"x":0.833,"y":0.843},"s":[43.437,45.791,100],"t":40.8},{"o":{"x":0.167,"y":0.178},"i":{"x":0.833,"y":1.042},"s":[13.575,72.931,100],"t":41.6},{"o":{"x":0.167,"y":0.028},"i":{"x":0.833,"y":0.846},"s":[-12.851,42.13,100],"t":42.4},{"o":{"x":0.167,"y":0.181},"i":{"x":0.833,"y":0.907},"s":[26.868,-22.827,100],"t":43.2},{"o":{"x":0.167,"y":0.832},"i":{"x":0.833,"y":2.014},"s":[60.696,-28.382,100],"t":44},{"o":{"x":0.167,"y":0.077},"i":{"x":0.833,"y":0.956},"s":[64.461,8.569,100],"t":44.8},{"o":{"x":0.167,"y":-0.093},"i":{"x":0.833,"y":0.945},"s":[14.897,8.85,100],"t":45.6},{"o":{"x":0.167,"y":-0.162},"i":{"x":0.833,"y":0.833},"s":[38.326,-8.337,100],"t":46.4},{"s":[30.376,9.931,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[264.075,300.144,0],"t":7.2,"ti":[0.355,-2.342,0],"to":[-0.069,0.468,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[263.663,302.955,0],"t":8,"ti":[0.559,-5.353,0],"to":[-0.355,2.342,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[261.945,314.199,0],"t":8.8,"ti":[0.004,-7.357,0],"to":[-0.559,5.353,0]},{"o":{"x":0.167,"y":0.011},"i":{"x":0.833,"y":0.989},"s":[260.312,335.072,0],"t":9.6,"ti":[-1.215,-7.142,0],"to":[-0.004,7.357,0]},{"o":{"x":0.167,"y":0.05},"i":{"x":0.833,"y":0.957},"s":[261.922,358.34,0],"t":10.4,"ti":[-2.396,-5.718,0],"to":[1.215,7.142,0]},{"o":{"x":0.167,"y":0.093},"i":{"x":0.833,"y":0.922},"s":[267.601,377.926,0],"t":11.2,"ti":[-3.152,-4.167,0],"to":[2.396,5.718,0]},{"o":{"x":0.167,"y":0.128},"i":{"x":0.833,"y":0.891},"s":[276.299,392.647,0],"t":12,"ti":[-3.444,-2.85,0],"to":[3.152,4.167,0]},{"o":{"x":0.167,"y":0.15},"i":{"x":0.833,"y":0.87},"s":[286.512,402.925,0],"t":12.8,"ti":[-3.405,-1.874,0],"to":[3.444,2.85,0]},{"o":{"x":0.167,"y":0.164},"i":{"x":0.833,"y":0.857},"s":[296.962,409.748,0],"t":13.6,"ti":[-3.2,-1.208,0],"to":[3.405,1.874,0]},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.849},"s":[306.94,414.169,0],"t":14.4,"ti":[-2.937,-0.769,0],"to":[3.2,1.208,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.845},"s":[316.159,416.998,0],"t":15.2,"ti":[-2.672,-0.481,0],"to":[2.937,0.769,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.843},"s":[324.559,418.783,0],"t":16,"ti":[-2.428,-0.291,0],"to":[2.672,0.481,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.842},"s":[332.191,419.883,0],"t":16.8,"ti":[-2.206,-0.163,0],"to":[2.428,0.291,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.841},"s":[339.125,420.527,0],"t":17.6,"ti":[-2.007,-0.077,0],"to":[2.206,0.163,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.841},"s":[345.429,420.863,0],"t":18.4,"ti":[-1.827,-0.019,0],"to":[2.007,0.077,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.841},"s":[351.165,420.991,0],"t":19.2,"ti":[-1.665,0.021,0],"to":[1.827,0.019,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.841},"s":[356.391,420.977,0],"t":20,"ti":[-1.519,0.049,0],"to":[1.665,-0.021,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.841},"s":[361.156,420.865,0],"t":20.8,"ti":[-1.386,0.069,0],"to":[1.519,-0.049,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.841},"s":[365.504,420.683,0],"t":21.6,"ti":[-1.264,0.084,0],"to":[1.386,-0.069,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.841},"s":[369.472,420.452,0],"t":22.4,"ti":[-1.151,0.096,0],"to":[1.264,-0.084,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.842},"s":[373.088,420.182,0],"t":23.2,"ti":[-1.046,0.107,0],"to":[1.151,-0.096,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.842},"s":[376.379,419.878,0],"t":24,"ti":[-0.947,0.118,0],"to":[1.046,-0.107,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.842},"s":[379.365,419.542,0],"t":24.8,"ti":[-0.856,0.124,0],"to":[0.947,-0.118,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.843},"s":[382.063,419.172,0],"t":25.6,"ti":[-0.773,0.118,0],"to":[0.856,-0.124,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.844},"s":[384.499,418.801,0],"t":26.4,"ti":[-0.697,0.107,0],"to":[0.773,-0.118,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.844},"s":[386.7,418.464,0],"t":27.2,"ti":[-0.626,0.097,0],"to":[0.697,-0.107,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.844},"s":[388.681,418.159,0],"t":28,"ti":[-0.561,0.088,0],"to":[0.626,-0.097,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.845},"s":[390.459,417.883,0],"t":28.8,"ti":[-0.5,0.079,0],"to":[0.561,-0.088,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.845},"s":[392.047,417.633,0],"t":29.6,"ti":[-0.443,0.072,0],"to":[0.5,-0.079,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.846},"s":[393.458,417.406,0],"t":30.4,"ti":[-0.39,0.066,0],"to":[0.443,-0.072,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.846},"s":[394.704,417.199,0],"t":31.2,"ti":[-0.34,0.061,0],"to":[0.39,-0.066,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.848},"s":[395.795,417.009,0],"t":32,"ti":[-0.293,0.057,0],"to":[0.34,-0.061,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.849},"s":[396.741,416.833,0],"t":32.8,"ti":[-0.249,0.053,0],"to":[0.293,-0.057,0]},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":0.851},"s":[397.551,416.669,0],"t":33.6,"ti":[-0.207,0.05,0],"to":[0.249,-0.053,0]},{"o":{"x":0.167,"y":0.178},"i":{"x":0.833,"y":0.854},"s":[398.233,416.514,0],"t":34.4,"ti":[-0.168,0.048,0],"to":[0.207,-0.05,0]},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":0.858},"s":[398.794,416.367,0],"t":35.2,"ti":[-0.132,0.046,0],"to":[0.168,-0.048,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.865},"s":[399.242,416.225,0],"t":36,"ti":[-0.097,0.045,0],"to":[0.132,-0.046,0]},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.875},"s":[399.584,416.088,0],"t":36.8,"ti":[-0.064,0.044,0],"to":[0.097,-0.045,0]},{"o":{"x":0.167,"y":0.149},"i":{"x":0.833,"y":0.894},"s":[399.824,415.954,0],"t":37.6,"ti":[-0.034,0.043,0],"to":[0.064,-0.044,0]},{"o":{"x":0.167,"y":0.08},"i":{"x":0.833,"y":0.934},"s":[399.97,415.824,0],"t":38.4,"ti":[-0.012,0.044,0],"to":[0.034,-0.043,0]},{"o":{"x":0.167,"y":0.018},"i":{"x":0.833,"y":0.98},"s":[400.026,415.696,0],"t":39.2,"ti":[-0.006,0.049,0],"to":[0.012,-0.044,0]},{"o":{"x":0.167,"y":0.022},"i":{"x":0.833,"y":0.976},"s":[400.041,415.559,0],"t":40,"ti":[-0.008,0.056,0],"to":[0.006,-0.049,0]},{"o":{"x":0.167,"y":0.025},"i":{"x":0.833,"y":0.973},"s":[400.063,415.401,0],"t":40.8,"ti":[-0.011,0.062,0],"to":[0.008,-0.056,0]},{"o":{"x":0.167,"y":0.031},"i":{"x":0.833,"y":0.967},"s":[400.091,415.224,0],"t":41.6,"ti":[-0.014,0.066,0],"to":[0.011,-0.062,0]},{"o":{"x":0.167,"y":0.035},"i":{"x":0.833,"y":0.963},"s":[400.129,415.031,0],"t":42.4,"ti":[-0.017,0.07,0],"to":[0.014,-0.066,0]},{"o":{"x":0.167,"y":0.042},"i":{"x":0.833,"y":0.956},"s":[400.175,414.825,0],"t":43.2,"ti":[-0.021,0.073,0],"to":[0.017,-0.07,0]},{"o":{"x":0.167,"y":0.049},"i":{"x":0.833,"y":0.95},"s":[400.232,414.61,0],"t":44,"ti":[-0.025,0.074,0],"to":[0.021,-0.073,0]},{"o":{"x":0.167,"y":0.057},"i":{"x":0.833,"y":0.943},"s":[400.301,414.389,0],"t":44.8,"ti":[-0.029,0.073,0],"to":[0.025,-0.074,0]},{"o":{"x":0.167,"y":0.066},"i":{"x":0.833,"y":0.934},"s":[400.382,414.168,0],"t":45.6,"ti":[-0.034,0.071,0],"to":[0.029,-0.073,0]},{"o":{"x":0.167,"y":0.077},"i":{"x":0.833,"y":0.923},"s":[400.476,413.95,0],"t":46.4,"ti":[-0.018,0.035,0],"to":[0.034,-0.071,0]},{"s":[400.585,413.741,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":7.2},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":11.2},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":28.8},{"s":[0],"t":41.6}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Polystar 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sr","bm":0,"hd":false,"mn":"ADBE Vector Shape - Star","nm":"Polystar Path 1","ix":1,"d":1,"pt":{"a":0,"k":3,"ix":3},"p":{"a":0,"k":[6,32],"ix":4},"or":{"a":0,"k":6.599,"ix":7},"os":{"a":0,"k":0,"ix":9},"r":{"a":0,"k":0,"ix":5},"sy":2},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0,0.7647,0.902],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-7.382,-25.677],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":15},{"ty":4,"nm":"Shape Layer 36","sr":1,"st":4,"op":48,"ip":4,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.896},"s":[111.822,109.374,100],"t":4},{"o":{"x":0.167,"y":0.414},"i":{"x":0.833,"y":0.087},"s":[100.055,106.422,100],"t":4.8},{"o":{"x":0.167,"y":0.092},"i":{"x":0.833,"y":0.951},"s":[97.093,40.951,100],"t":5.6},{"o":{"x":0.167,"y":-0.117},"i":{"x":0.833,"y":0.773},"s":[67.613,71.247,100],"t":6.4},{"o":{"x":0.167,"y":0.132},"i":{"x":0.833,"y":0.893},"s":[79.872,109.348,100],"t":7.2},{"o":{"x":0.167,"y":0.381},"i":{"x":0.833,"y":1.215},"s":[101.054,94.428,100],"t":8},{"o":{"x":0.167,"y":0.06},"i":{"x":0.833,"y":0.929},"s":[106.979,137.485,100],"t":8.8},{"o":{"x":0.167,"y":-0.477},"i":{"x":0.833,"y":0.974},"s":[85.798,101.174,100],"t":9.6},{"o":{"x":0.167,"y":-0.039},"i":{"x":0.833,"y":1.674},"s":[88.947,113.411,100],"t":10.4},{"o":{"x":0.167,"y":0.074},"i":{"x":0.833,"y":0.924},"s":[86.793,131.596,100],"t":11.2},{"o":{"x":0.167,"y":-0.914},"i":{"x":0.833,"y":-0.583},"s":[106.377,110.603,100],"t":12},{"o":{"x":0.167,"y":0.088},"i":{"x":0.833,"y":0.868},"s":[104.74,50.192,100],"t":12.8},{"o":{"x":0.167,"y":0.225},"i":{"x":0.833,"y":0.873},"s":[75.287,93.627,100],"t":13.6},{"o":{"x":0.167,"y":0.244},"i":{"x":0.833,"y":0.914},"s":[57.971,102.957,100],"t":14.4},{"o":{"x":0.167,"y":2.53},"i":{"x":0.833,"y":6.07},"s":[48.983,104.599,100],"t":15.2},{"o":{"x":0.167,"y":0.082},"i":{"x":0.833,"y":0.801},"s":[48.677,103.694,100],"t":16},{"o":{"x":0.167,"y":0.143},"i":{"x":0.833,"y":0.786},"s":[67.607,107.546,100],"t":16.8},{"o":{"x":0.167,"y":0.136},"i":{"x":0.833,"y":0.999},"s":[93.956,61.633,100],"t":17.6},{"o":{"x":0.167,"y":-0.001},"i":{"x":0.833,"y":0.898},"s":[135.372,117.12,100],"t":18.4},{"o":{"x":0.167,"y":0.448},"i":{"x":0.833,"y":0.936},"s":[94.654,82.761,100],"t":19.2},{"o":{"x":0.167,"y":-0.276},"i":{"x":0.833,"y":0.146},"s":[85.351,85.606,100],"t":20},{"o":{"x":0.167,"y":0.092},"i":{"x":0.833,"y":0.778},"s":[87.506,70.455,100],"t":20.8},{"o":{"x":0.167,"y":0.134},"i":{"x":0.833,"y":0.973},"s":[107.432,104.297,100],"t":21.6},{"o":{"x":0.167,"y":-0.04},"i":{"x":0.833,"y":0.792},"s":[140.473,106.399,100],"t":22.4},{"o":{"x":0.167,"y":0.139},"i":{"x":0.833,"y":0.967},"s":[118.147,128.441,100],"t":23.2},{"o":{"x":0.167,"y":-0.054},"i":{"x":0.833,"y":0.974},"s":[84.776,65.43,100],"t":24},{"o":{"x":0.167,"y":-0.038},"i":{"x":0.833,"y":0.673},"s":[105.029,77.29,100],"t":24.8},{"o":{"x":0.167,"y":0.112},"i":{"x":0.833,"y":0.925},"s":[91.068,48.266,100],"t":25.6},{"o":{"x":0.167,"y":-0.747},"i":{"x":0.833,"y":0.647},"s":[50.228,37.635,100],"t":26.4},{"o":{"x":0.167,"y":0.109},"i":{"x":0.833,"y":0.827},"s":[54.329,100.336,100],"t":27.2},{"o":{"x":0.167,"y":0.161},"i":{"x":0.833,"y":1.244},"s":[67.613,90.964,100],"t":28},{"o":{"x":0.167,"y":0.062},"i":{"x":0.833,"y":0.954},"s":[81.902,93.51,100],"t":28.8},{"o":{"x":0.167,"y":-0.101},"i":{"x":0.833,"y":0.785},"s":[25.699,89.858,100],"t":29.6},{"o":{"x":0.167,"y":0.136},"i":{"x":0.833,"y":0.976},"s":[51.156,75.74,100],"t":30.4},{"o":{"x":0.167,"y":-0.034},"i":{"x":0.833,"y":0.939},"s":[91.35,60.958,100],"t":31.2},{"o":{"x":0.167,"y":-0.231},"i":{"x":0.833,"y":1.534},"s":[62.734,57.409,100],"t":32},{"o":{"x":0.167,"y":0.072},"i":{"x":0.833,"y":0.938},"s":[70.32,67.319,100],"t":32.8},{"o":{"x":0.167,"y":-0.24},"i":{"x":0.833,"y":0.896},"s":[14.17,58.838,100],"t":33.6},{"o":{"x":0.167,"y":0.419},"i":{"x":0.833,"y":1.32},"s":[28.636,19.113,100],"t":34.4},{"o":{"x":0.167,"y":0.066},"i":{"x":0.833,"y":0.869},"s":[32.23,22.336,100],"t":35.2},{"o":{"x":0.167,"y":0.228},"i":{"x":0.833,"y":1.092},"s":[14.851,31.15,100],"t":36},{"o":{"x":0.167,"y":0.044},"i":{"x":0.833,"y":0.899},"s":[4.812,10.283,100],"t":36.8},{"o":{"x":0.167,"y":0.472},"i":{"x":0.833,"y":1.075},"s":[25.925,32.587,100],"t":37.6},{"o":{"x":0.167,"y":0.04},"i":{"x":0.833,"y":0.799},"s":[30.453,9.9,100],"t":38.4},{"o":{"x":0.167,"y":0.142},"i":{"x":0.833,"y":0.842},"s":[21.826,85.625,100],"t":39.2},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":0.674},"s":[9.608,24.619,100],"t":40},{"o":{"x":0.167,"y":0.112},"i":{"x":0.833,"y":1.022},"s":[-1.289,66.096,100],"t":40.8},{"o":{"x":0.167,"y":0.018},"i":{"x":0.833,"y":0.84},"s":[-33.054,59.758,100],"t":41.6},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.926},"s":[7.239,14.644,100],"t":42.4},{"o":{"x":0.167,"y":-0.683},"i":{"x":0.833,"y":0.273},"s":[44.549,12.547,100],"t":43.2},{"o":{"x":0.167,"y":0.094},"i":{"x":0.833,"y":0.913},"s":[40.492,17.184,100],"t":44},{"o":{"x":0.167,"y":1.953},"i":{"x":0.833,"y":2.637},"s":[9.161,-7.703,100],"t":44.8},{"o":{"x":0.167,"y":0.079},"i":{"x":0.833,"y":0.935},"s":[7.764,16.458,100],"t":45.6},{"o":{"x":0.167,"y":-0.3},"i":{"x":0.833,"y":0.833},"s":[36.594,-26.534,100],"t":46.4},{"s":[30.332,11.798,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.133},"i":{"x":0.833,"y":0.684},"s":[268.501,303.894,0],"t":4,"ti":[-1.332,1.601,0],"to":[0.373,-0.267,0]},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.877},"s":[270.738,302.29,0],"t":4.8,"ti":[1.952,1.768,0],"to":[1.332,-1.601,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[276.491,294.286,0],"t":5.6,"ti":[6.31,0.166,0],"to":[-1.952,-1.768,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[259.026,291.685,0],"t":6.4,"ti":[6.364,-0.502,0],"to":[-6.31,-0.166,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[238.628,293.288,0],"t":7.2,"ti":[5.435,-0.368,0],"to":[-6.364,0.502,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[220.844,294.694,0],"t":8,"ti":[4.549,-0.177,0],"to":[-5.435,0.368,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[206.017,295.497,0],"t":8.8,"ti":[3.853,-0.014,0],"to":[-4.549,0.177,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[193.549,295.758,0],"t":9.6,"ti":[3.314,0.117,0],"to":[-3.853,0.014,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[182.897,295.583,0],"t":10.4,"ti":[2.886,0.223,0],"to":[-3.314,-0.117,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[173.668,295.056,0],"t":11.2,"ti":[2.537,0.31,0],"to":[-2.886,-0.223,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[165.584,294.243,0],"t":12,"ti":[2.246,0.383,0],"to":[-2.537,-0.31,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[158.446,293.194,0],"t":12.8,"ti":[2.001,0.441,0],"to":[-2.246,-0.383,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[152.105,291.947,0],"t":13.6,"ti":[1.789,0.485,0],"to":[-2.001,-0.441,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[146.441,290.551,0],"t":14.4,"ti":[1.601,0.519,0],"to":[-1.789,-0.485,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[141.373,289.038,0],"t":15.2,"ti":[1.435,0.544,0],"to":[-1.601,-0.519,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[136.833,287.437,0],"t":16,"ti":[1.285,0.562,0],"to":[-1.435,-0.544,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[132.765,285.771,0],"t":16.8,"ti":[1.15,0.573,0],"to":[-1.285,-0.562,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[129.121,284.063,0],"t":17.6,"ti":[1.027,0.578,0],"to":[-1.15,-0.573,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[125.863,282.331,0],"t":18.4,"ti":[0.915,0.576,0],"to":[-1.027,-0.578,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[122.957,280.597,0],"t":19.2,"ti":[0.814,0.569,0],"to":[-0.915,-0.576,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[120.371,278.877,0],"t":20,"ti":[0.721,0.558,0],"to":[-0.814,-0.569,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[118.075,277.184,0],"t":20.8,"ti":[0.637,0.542,0],"to":[-0.721,-0.558,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[116.044,275.532,0],"t":21.6,"ti":[0.56,0.523,0],"to":[-0.637,-0.542,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[114.254,273.931,0],"t":22.4,"ti":[0.49,0.502,0],"to":[-0.56,-0.523,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[112.684,272.392,0],"t":23.2,"ti":[0.427,0.478,0],"to":[-0.49,-0.502,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[111.312,270.921,0],"t":24,"ti":[0.369,0.453,0],"to":[-0.427,-0.478,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[110.122,269.523,0],"t":24.8,"ti":[0.317,0.426,0],"to":[-0.369,-0.453,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[109.095,268.204,0],"t":25.6,"ti":[0.27,0.399,0],"to":[-0.317,-0.426,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[108.219,266.966,0],"t":26.4,"ti":[0.226,0.37,0],"to":[-0.27,-0.399,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[107.478,265.812,0],"t":27.2,"ti":[0.186,0.342,0],"to":[-0.226,-0.37,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[106.862,264.743,0],"t":28,"ti":[0.15,0.313,0],"to":[-0.186,-0.342,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[106.36,263.762,0],"t":28.8,"ti":[0.117,0.283,0],"to":[-0.15,-0.313,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[105.962,262.868,0],"t":29.6,"ti":[0.086,0.254,0],"to":[-0.117,-0.283,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[105.66,262.062,0],"t":30.4,"ti":[0.058,0.224,0],"to":[-0.086,-0.254,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[105.445,261.346,0],"t":31.2,"ti":[0.032,0.194,0],"to":[-0.058,-0.224,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[105.312,260.718,0],"t":32,"ti":[0.008,0.164,0],"to":[-0.032,-0.194,0]},{"o":{"x":0.167,"y":0.004},"i":{"x":0.833,"y":0.997},"s":[105.253,260.18,0],"t":32.8,"ti":[-0.014,0.135,0],"to":[-0.008,-0.164,0]},{"o":{"x":0.167,"y":0.037},"i":{"x":0.833,"y":0.97},"s":[105.263,259.732,0],"t":33.6,"ti":[-0.034,0.104,0],"to":[0.014,-0.135,0]},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":0.932},"s":[105.336,259.373,0],"t":34.4,"ti":[-0.052,0.074,0],"to":[0.034,-0.104,0]},{"o":{"x":0.167,"y":0.129},"i":{"x":0.833,"y":0.884},"s":[105.467,259.105,0],"t":35.2,"ti":[-0.065,0.05,0],"to":[0.052,-0.074,0]},{"o":{"x":0.167,"y":0.149},"i":{"x":0.833,"y":0.86},"s":[105.65,258.927,0],"t":36,"ti":[-0.069,0.036,0],"to":[0.065,-0.05,0]},{"o":{"x":0.167,"y":0.156},"i":{"x":0.833,"y":0.863},"s":[105.86,258.807,0],"t":36.8,"ti":[-0.062,0.029,0],"to":[0.069,-0.036,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.87},"s":[106.065,258.712,0],"t":37.6,"ti":[-0.047,0.024,0],"to":[0.062,-0.029,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.881},"s":[106.232,258.632,0],"t":38.4,"ti":[-0.031,0.02,0],"to":[0.047,-0.024,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.9},"s":[106.349,258.566,0],"t":39.2,"ti":[-0.015,0.014,0],"to":[0.031,-0.02,0]},{"o":{"x":0.167,"y":0.128},"i":{"x":0.833,"y":0.924},"s":[106.418,258.515,0],"t":40,"ti":[0.001,0.009,0],"to":[0.015,-0.014,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[106.44,258.479,0],"t":40.8,"ti":[0.016,0.003,0],"to":[-0.001,-0.009,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[106.414,258.46,0],"t":41.6,"ti":[0.031,-0.003,0],"to":[-0.016,-0.003,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[106.343,258.459,0],"t":42.4,"ti":[0.045,-0.008,0],"to":[-0.031,0.003,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[106.228,258.475,0],"t":43.2,"ti":[0.059,-0.014,0],"to":[-0.045,0.008,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[106.07,258.51,0],"t":44,"ti":[0.072,-0.02,0],"to":[-0.059,0.014,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[105.873,258.562,0],"t":44.8,"ti":[0.084,-0.026,0],"to":[-0.072,0.02,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[105.639,258.632,0],"t":45.6,"ti":[0.095,-0.032,0],"to":[-0.084,0.026,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[105.369,258.719,0],"t":46.4,"ti":[0.05,-0.017,0],"to":[-0.095,0.032,0]},{"s":[105.069,258.823,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":25.6},{"s":[0],"t":38.4}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Polystar 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sr","bm":0,"hd":false,"mn":"ADBE Vector Shape - Star","nm":"Polystar Path 1","ix":1,"d":1,"pt":{"a":0,"k":3,"ix":3},"p":{"a":0,"k":[6,32],"ix":4},"or":{"a":0,"k":6.599,"ix":7},"os":{"a":0,"k":0,"ix":9},"r":{"a":0,"k":0,"ix":5},"sy":2},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.4745,0.8392,0.6667],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-7.382,-25.677],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":16},{"ty":4,"nm":"Shape Layer 35","sr":1,"st":3.2,"op":48,"ip":3.2,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":1.112},"s":[102.583,113.906,100],"t":3.2},{"o":{"x":0.167,"y":0.048},"i":{"x":0.833,"y":0.982},"s":[89.34,107.749,100],"t":4},{"o":{"x":0.167,"y":-0.023},"i":{"x":0.833,"y":0.826},"s":[120.4,44.201,100],"t":4.8},{"o":{"x":0.167,"y":0.16},"i":{"x":0.833,"y":0.974},"s":[96.055,80.415,100],"t":5.6},{"o":{"x":0.167,"y":-0.038},"i":{"x":0.833,"y":1.007},"s":[69.666,135.77,100],"t":6.4},{"o":{"x":0.167,"y":0.007},"i":{"x":0.833,"y":1.054},"s":[87.726,103.756,100],"t":7.2},{"o":{"x":0.167,"y":0.033},"i":{"x":0.833,"y":0.958},"s":[68.046,117.794,100],"t":8},{"o":{"x":0.167,"y":-0.085},"i":{"x":0.833,"y":0.847},"s":[100.548,82.836,100],"t":8.8},{"o":{"x":0.167,"y":0.184},"i":{"x":0.833,"y":0.903},"s":[84.441,88.646,100],"t":9.6},{"o":{"x":0.167,"y":0.581},"i":{"x":0.833,"y":2.653},"s":[71.053,121.348,100],"t":10.4},{"o":{"x":0.167,"y":0.079},"i":{"x":0.833,"y":0.928},"s":[68.813,98.016,100],"t":11.2},{"o":{"x":0.167,"y":-0.52},"i":{"x":0.833,"y":0.876},"s":[115.484,42.548,100],"t":12},{"o":{"x":0.167,"y":0.255},"i":{"x":0.833,"y":-0.015},"s":[109.038,48.103,100],"t":12.8},{"o":{"x":0.167,"y":0.091},"i":{"x":0.833,"y":0.942},"s":[105.912,134.682,100],"t":13.6},{"o":{"x":0.167,"y":-0.189},"i":{"x":0.833,"y":0.984},"s":[70.98,122.635,100],"t":14.4},{"o":{"x":0.167,"y":-0.021},"i":{"x":0.833,"y":1.191},"s":[81.664,121.409,100],"t":15.2},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.88},"s":[73.094,107.712,100],"t":16},{"o":{"x":0.167,"y":0.271},"i":{"x":0.833,"y":1.105},"s":[101.314,57.875,100],"t":16.8},{"o":{"x":0.167,"y":0.046},"i":{"x":0.833,"y":1.034},"s":[113.878,107.014,100],"t":17.6},{"o":{"x":0.167,"y":0.024},"i":{"x":0.833,"y":0.956},"s":[85.547,53.745,100],"t":18.4},{"o":{"x":0.167,"y":-0.094},"i":{"x":0.833,"y":0.812},"s":[125.423,51.139,100],"t":19.2},{"o":{"x":0.167,"y":0.149},"i":{"x":0.833,"y":1.021},"s":[106.714,52.421,100],"t":20},{"o":{"x":0.167,"y":0.017},"i":{"x":0.833,"y":0.926},"s":[83.118,81.524,100],"t":20.8},{"o":{"x":0.167,"y":-0.689},"i":{"x":0.833,"y":0.571},"s":[112.603,117.515,100],"t":21.6},{"o":{"x":0.167,"y":0.103},"i":{"x":0.833,"y":1.176},"s":[109.423,124.06,100],"t":22.4},{"o":{"x":0.167,"y":0.057},"i":{"x":0.833,"y":0.971},"s":[96.227,76.928,100],"t":23.2},{"o":{"x":0.167,"y":-0.044},"i":{"x":0.833,"y":0.758},"s":[137.222,85.21,100],"t":24},{"o":{"x":0.167,"y":0.127},"i":{"x":0.833,"y":0.901},"s":[110.401,85.868,100],"t":24.8},{"o":{"x":0.167,"y":0.527},"i":{"x":0.833,"y":1.016},"s":[59.435,51.153,100],"t":25.6},{"o":{"x":0.167,"y":0.013},"i":{"x":0.833,"y":0.802},"s":[49.857,71.912,100],"t":26.4},{"o":{"x":0.167,"y":0.144},"i":{"x":0.833,"y":1.11},"s":[61.259,54.038,100],"t":27.2},{"o":{"x":0.167,"y":0.047},"i":{"x":0.833,"y":0.954},"s":[76.982,82.665,100],"t":28},{"o":{"x":0.167,"y":-0.103},"i":{"x":0.833,"y":0.849},"s":[40.562,65.859,100],"t":28.8},{"o":{"x":0.167,"y":0.187},"i":{"x":0.833,"y":1.016},"s":[56.885,58.517,100],"t":29.6},{"o":{"x":0.167,"y":0.013},"i":{"x":0.833,"y":1.025},"s":[70.044,78.995,100],"t":30.4},{"o":{"x":0.167,"y":0.019},"i":{"x":0.833,"y":1.03},"s":[54.364,48.853,100],"t":31.2},{"o":{"x":0.167,"y":0.022},"i":{"x":0.833,"y":0.85},"s":[74.752,49.207,100],"t":32},{"o":{"x":0.167,"y":0.188},"i":{"x":0.833,"y":1.102},"s":[46.926,41.924,100],"t":32.8},{"o":{"x":0.167,"y":0.046},"i":{"x":0.833,"y":1.008},"s":[24.667,22.936,100],"t":33.6},{"o":{"x":0.167,"y":0.008},"i":{"x":0.833,"y":0.923},"s":[74.072,58.487,100],"t":34.4},{"o":{"x":0.167,"y":-1.08},"i":{"x":0.833,"y":0.782},"s":[19.734,34.651,100],"t":35.2},{"o":{"x":0.167,"y":0.135},"i":{"x":0.833,"y":0.772},"s":[23.626,41.571,100],"t":36},{"o":{"x":0.167,"y":0.131},"i":{"x":0.833,"y":1.128},"s":[29.896,49.314,100],"t":36.8},{"o":{"x":0.167,"y":0.05},"i":{"x":0.833,"y":0.837},"s":[40.776,26.063,100],"t":37.6},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.946},"s":[13.174,79.764,100],"t":38.4},{"o":{"x":0.167,"y":-0.153},"i":{"x":0.833,"y":0.934},"s":[-13.177,9.252,100],"t":39.2},{"o":{"x":0.167,"y":-0.32},"i":{"x":0.833,"y":1.831},"s":[-3.882,58.452,100],"t":40},{"o":{"x":0.167,"y":0.076},"i":{"x":0.833,"y":0.879},"s":[-5.803,51.522,100],"t":40.8},{"o":{"x":0.167,"y":0.266},"i":{"x":0.833,"y":0.861},"s":[15.263,30.594,100],"t":41.6},{"o":{"x":0.167,"y":0.208},"i":{"x":0.833,"y":1.125},"s":[24.861,22.138,100],"t":42.4},{"o":{"x":0.167,"y":0.05},"i":{"x":0.833,"y":0.882},"s":[31.285,23.603,100],"t":43.2},{"o":{"x":0.167,"y":0.282},"i":{"x":0.833,"y":1.155},"s":[15.205,2.136,100],"t":44},{"o":{"x":0.167,"y":0.054},"i":{"x":0.833,"y":1.018},"s":[8.46,15.435,100],"t":44.8},{"o":{"x":0.167,"y":0.015},"i":{"x":0.833,"y":1.07},"s":[27.717,-26.636,100],"t":45.6},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":0.833},"s":[4.398,-31.997,100],"t":46.4},{"s":[47.278,52.184,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.126},"i":{"x":0.833,"y":0.682},"s":[269.847,301.952,0],"t":3.2,"ti":[-0.855,0.741,0],"to":[0.17,-0.147,0]},{"o":{"x":0.167,"y":0.079},"i":{"x":0.833,"y":0.821},"s":[270.865,301.071,0],"t":4,"ti":[-1.897,1.74,0],"to":[0.855,-0.741,0]},{"o":{"x":0.167,"y":0.094},"i":{"x":0.833,"y":0.872},"s":[274.976,297.505,0],"t":4.8,"ti":[-2.487,2.492,0],"to":[1.897,-1.74,0]},{"o":{"x":0.167,"y":0.109},"i":{"x":0.833,"y":0.893},"s":[282.245,290.631,0],"t":5.6,"ti":[-2.333,2.568,0],"to":[2.487,-2.492,0]},{"o":{"x":0.167,"y":0.117},"i":{"x":0.833,"y":0.9},"s":[289.898,282.555,0],"t":6.4,"ti":[-1.909,2.26,0],"to":[2.333,-2.568,0]},{"o":{"x":0.167,"y":0.117},"i":{"x":0.833,"y":0.903},"s":[296.244,275.226,0],"t":7.2,"ti":[-1.56,1.916,0],"to":[1.909,-2.26,0]},{"o":{"x":0.167,"y":0.115},"i":{"x":0.833,"y":0.903},"s":[301.355,268.994,0],"t":8,"ti":[-1.325,1.619,0],"to":[1.56,-1.916,0]},{"o":{"x":0.167,"y":0.116},"i":{"x":0.833,"y":0.9},"s":[305.606,263.727,0],"t":8.8,"ti":[-1.185,1.356,0],"to":[1.325,-1.619,0]},{"o":{"x":0.167,"y":0.121},"i":{"x":0.833,"y":0.894},"s":[309.304,259.281,0],"t":9.6,"ti":[-1.147,1.074,0],"to":[1.185,-1.356,0]},{"o":{"x":0.167,"y":0.138},"i":{"x":0.833,"y":0.879},"s":[312.714,255.59,0],"t":10.4,"ti":[-1.205,0.459,0],"to":[1.147,-1.074,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.841},"s":[316.183,252.839,0],"t":11.2,"ti":[-0.955,-0.508,0],"to":[1.205,-0.459,0]},{"o":{"x":0.167,"y":0.091},"i":{"x":0.833,"y":0.916},"s":[319.947,252.839,0],"t":12,"ti":[-0.499,-1.03,0],"to":[0.955,0.508,0]},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.95},"s":[321.913,255.888,0],"t":12.8,"ti":[-0.292,-1.003,0],"to":[0.499,1.03,0]},{"o":{"x":0.167,"y":0.042},"i":{"x":0.833,"y":0.962},"s":[322.944,259.018,0],"t":13.6,"ti":[-0.216,-0.921,0],"to":[0.292,1.003,0]},{"o":{"x":0.167,"y":0.037},"i":{"x":0.833,"y":0.966},"s":[323.663,261.908,0],"t":14.4,"ti":[-0.18,-0.838,0],"to":[0.216,0.921,0]},{"o":{"x":0.167,"y":0.036},"i":{"x":0.833,"y":0.967},"s":[324.24,264.543,0],"t":15.2,"ti":[-0.16,-0.762,0],"to":[0.18,0.838,0]},{"o":{"x":0.167,"y":0.036},"i":{"x":0.833,"y":0.967},"s":[324.742,266.939,0],"t":16,"ti":[-0.149,-0.692,0],"to":[0.16,0.762,0]},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":0.966},"s":[325.202,269.115,0],"t":16.8,"ti":[-0.143,-0.628,0],"to":[0.149,0.692,0]},{"o":{"x":0.167,"y":0.04},"i":{"x":0.833,"y":0.964},"s":[325.638,271.093,0],"t":17.6,"ti":[-0.139,-0.568,0],"to":[0.143,0.628,0]},{"o":{"x":0.167,"y":0.043},"i":{"x":0.833,"y":0.961},"s":[326.06,272.884,0],"t":18.4,"ti":[-0.136,-0.513,0],"to":[0.139,0.568,0]},{"o":{"x":0.167,"y":0.047},"i":{"x":0.833,"y":0.957},"s":[326.472,274.503,0],"t":19.2,"ti":[-0.134,-0.461,0],"to":[0.136,0.513,0]},{"o":{"x":0.167,"y":0.051},"i":{"x":0.833,"y":0.954},"s":[326.877,275.962,0],"t":20,"ti":[-0.131,-0.413,0],"to":[0.134,0.461,0]},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.95},"s":[327.274,277.271,0],"t":20.8,"ti":[-0.128,-0.369,0],"to":[0.131,0.413,0]},{"o":{"x":0.167,"y":0.06},"i":{"x":0.833,"y":0.946},"s":[327.663,278.442,0],"t":21.6,"ti":[-0.123,-0.327,0],"to":[0.128,0.369,0]},{"o":{"x":0.167,"y":0.065},"i":{"x":0.833,"y":0.942},"s":[328.039,279.483,0],"t":22.4,"ti":[-0.117,-0.287,0],"to":[0.123,0.327,0]},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":0.939},"s":[328.401,280.402,0],"t":23.2,"ti":[-0.109,-0.251,0],"to":[0.117,0.287,0]},{"o":{"x":0.167,"y":0.073},"i":{"x":0.833,"y":0.936},"s":[328.742,281.208,0],"t":24,"ti":[-0.095,-0.217,0],"to":[0.109,0.251,0]},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.94},"s":[329.057,281.906,0],"t":24.8,"ti":[-0.065,-0.188,0],"to":[0.095,0.217,0]},{"o":{"x":0.167,"y":0.044},"i":{"x":0.833,"y":0.963},"s":[329.315,282.507,0],"t":25.6,"ti":[-0.024,-0.165,0],"to":[0.065,0.188,0]},{"o":{"x":0.167,"y":0.005},"i":{"x":0.833,"y":0.996},"s":[329.447,283.036,0],"t":26.4,"ti":[0.014,-0.145,0],"to":[0.024,0.165,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[329.46,283.5,0],"t":27.2,"ti":[0.05,-0.126,0],"to":[-0.014,0.145,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[329.361,283.904,0],"t":28,"ti":[0.083,-0.109,0],"to":[-0.05,0.126,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[329.16,284.255,0],"t":28.8,"ti":[0.113,-0.092,0],"to":[-0.083,0.109,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[328.864,284.555,0],"t":29.6,"ti":[0.14,-0.078,0],"to":[-0.113,0.092,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[328.482,284.81,0],"t":30.4,"ti":[0.165,-0.064,0],"to":[-0.14,0.078,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[328.022,285.021,0],"t":31.2,"ti":[0.187,-0.05,0],"to":[-0.165,0.064,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[327.492,285.191,0],"t":32,"ti":[0.206,-0.038,0],"to":[-0.187,0.05,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[326.902,285.323,0],"t":32.8,"ti":[0.222,-0.026,0],"to":[-0.206,0.038,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[326.259,285.418,0],"t":33.6,"ti":[0.235,-0.015,0],"to":[-0.222,0.026,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[325.573,285.479,0],"t":34.4,"ti":[0.245,-0.007,0],"to":[-0.235,0.015,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[324.851,285.506,0],"t":35.2,"ti":[0.251,-0.008,0],"to":[-0.245,0.007,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[324.104,285.522,0],"t":36,"ti":[0.255,-0.011,0],"to":[-0.251,0.008,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[323.342,285.551,0],"t":36.8,"ti":[0.256,-0.015,0],"to":[-0.255,0.011,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[322.574,285.591,0],"t":37.6,"ti":[0.254,-0.018,0],"to":[-0.256,0.015,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[321.808,285.64,0],"t":38.4,"ti":[0.248,-0.02,0],"to":[-0.254,0.018,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[321.053,285.698,0],"t":39.2,"ti":[0.24,-0.022,0],"to":[-0.248,0.02,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[320.318,285.762,0],"t":40,"ti":[0.229,-0.023,0],"to":[-0.24,0.022,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[319.612,285.831,0],"t":40.8,"ti":[0.214,-0.024,0],"to":[-0.229,0.023,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[318.945,285.902,0],"t":41.6,"ti":[0.197,-0.024,0],"to":[-0.214,0.024,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[318.326,285.973,0],"t":42.4,"ti":[0.176,-0.022,0],"to":[-0.197,0.024,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[317.764,286.043,0],"t":43.2,"ti":[0.153,-0.02,0],"to":[-0.176,0.022,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[317.268,286.108,0],"t":44,"ti":[0.126,-0.017,0],"to":[-0.153,0.02,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[316.848,286.165,0],"t":44.8,"ti":[0.096,-0.013,0],"to":[-0.126,0.017,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[316.513,286.212,0],"t":45.6,"ti":[0.062,-0.008,0],"to":[-0.096,0.013,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[316.273,286.245,0],"t":46.4,"ti":[0.022,-0.003,0],"to":[-0.062,0.008,0]},{"s":[316.139,286.261,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":3.2},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":7.2},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":24.8},{"s":[0],"t":37.6}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Polystar 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sr","bm":0,"hd":false,"mn":"ADBE Vector Shape - Star","nm":"Polystar Path 1","ix":1,"d":1,"pt":{"a":0,"k":3,"ix":3},"p":{"a":0,"k":[6,32],"ix":4},"or":{"a":0,"k":6.599,"ix":7},"os":{"a":0,"k":0,"ix":9},"r":{"a":0,"k":0,"ix":5},"sy":2},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0,0.7647,0.902],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-7.382,-25.677],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":17},{"ty":4,"nm":"Shape Layer 34","sr":1,"st":8,"op":48,"ip":8,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":1.023},"s":[92.348,80.588,100],"t":8},{"o":{"x":0.167,"y":0.018},"i":{"x":0.833,"y":1.063},"s":[63.239,83.148,100],"t":8.8},{"o":{"x":0.167,"y":0.036},"i":{"x":0.833,"y":0.953},"s":[100.528,112.151,100],"t":9.6},{"o":{"x":0.167,"y":-0.11},"i":{"x":0.833,"y":0.799},"s":[34.84,119.029,100],"t":10.4},{"o":{"x":0.167,"y":0.142},"i":{"x":0.833,"y":0.908},"s":[63.172,73.511,100],"t":11.2},{"o":{"x":0.167,"y":0.917},"i":{"x":0.833,"y":1.12},"s":[103.227,26.126,100],"t":12},{"o":{"x":0.167,"y":0.049},"i":{"x":0.833,"y":1.04},"s":[107.23,99.638,100],"t":12.8},{"o":{"x":0.167,"y":0.027},"i":{"x":0.833,"y":0.987},"s":[97.456,100.244,100],"t":13.6},{"o":{"x":0.167,"y":-0.016},"i":{"x":0.833,"y":1.007},"s":[111.909,123.776,100],"t":14.4},{"o":{"x":0.167,"y":0.006},"i":{"x":0.833,"y":1.079},"s":[99.739,108.689,100],"t":15.2},{"o":{"x":0.167,"y":0.04},"i":{"x":0.833,"y":0.885},"s":[112.92,86.203,100],"t":16},{"o":{"x":0.167,"y":0.304},"i":{"x":0.833,"y":1.27},"s":[87.298,80.298,100],"t":16.8},{"o":{"x":0.167,"y":0.064},"i":{"x":0.833,"y":0.89},"s":[77.606,46.38,100],"t":17.6},{"o":{"x":0.167,"y":0.348},"i":{"x":0.833,"y":1.303},"s":[118.751,41.284,100],"t":18.4},{"o":{"x":0.167,"y":0.065},"i":{"x":0.833,"y":0.938},"s":[131.696,56.225,100],"t":19.2},{"o":{"x":0.167,"y":-0.244},"i":{"x":0.833,"y":0.997},"s":[71.627,58.284,100],"t":20},{"o":{"x":0.167,"y":-0.003},"i":{"x":0.833,"y":0.977},"s":[86.93,136.413,100],"t":20.8},{"o":{"x":0.167,"y":-0.032},"i":{"x":0.833,"y":0.554},"s":[72.183,131.272,100],"t":21.6},{"o":{"x":0.167,"y":0.102},"i":{"x":0.833,"y":0.904},"s":[82.81,109.279,100],"t":22.4},{"o":{"x":0.167,"y":0.64},"i":{"x":0.833,"y":1.416},"s":[129.066,93.807,100],"t":23.2},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":0.845},"s":[135.997,104.839,100],"t":24},{"o":{"x":0.167,"y":0.18},"i":{"x":0.833,"y":0.974},"s":[94.456,94.071,100],"t":24.8},{"o":{"x":0.167,"y":-0.038},"i":{"x":0.833,"y":0.873},"s":[58.778,74.421,100],"t":25.6},{"o":{"x":0.167,"y":0.243},"i":{"x":0.833,"y":0.889},"s":[83.328,71.244,100],"t":26.4},{"o":{"x":0.167,"y":0.338},"i":{"x":0.833,"y":0.695},"s":[96.122,97.929,100],"t":27.2},{"o":{"x":0.167,"y":0.115},"i":{"x":0.833,"y":1.062},"s":[100.314,87.693,100],"t":28},{"o":{"x":0.167,"y":0.036},"i":{"x":0.833,"y":0.795},"s":[111.459,73.549,100],"t":28.8},{"o":{"x":0.167,"y":0.141},"i":{"x":0.833,"y":0.993},"s":[91.979,97.003,100],"t":29.6},{"o":{"x":0.167,"y":-0.007},"i":{"x":0.833,"y":0.87},"s":[63.62,73.964,100],"t":30.4},{"o":{"x":0.167,"y":0.232},"i":{"x":0.833,"y":1.09},"s":[89.728,68.683,100],"t":31.2},{"o":{"x":0.167,"y":0.043},"i":{"x":0.833,"y":0.977},"s":[104.347,89.888,100],"t":32},{"o":{"x":0.167,"y":-0.032},"i":{"x":0.833,"y":0.984},"s":[74.014,53.405,100],"t":32.8},{"o":{"x":0.167,"y":-0.02},"i":{"x":0.833,"y":0.81},"s":[95.84,90.08,100],"t":33.6},{"o":{"x":0.167,"y":0.148},"i":{"x":0.833,"y":0.816},"s":[78.32,38.425,100],"t":34.4},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.899},"s":[55.867,54.538,100],"t":35.2},{"o":{"x":0.167,"y":0.487},"i":{"x":0.833,"y":0.701},"s":[28.81,84.258,100],"t":36},{"o":{"x":0.167,"y":0.115},"i":{"x":0.833,"y":0.904},"s":[23.23,56.921,100],"t":36.8},{"o":{"x":0.167,"y":0.611},"i":{"x":0.833,"y":0.701},"s":[8.759,81.032,100],"t":37.6},{"o":{"x":0.167,"y":0.116},"i":{"x":0.833,"y":1.089},"s":[6.473,12.233,100],"t":38.4},{"o":{"x":0.167,"y":0.043},"i":{"x":0.833,"y":0.758},"s":[0.558,46.8,100],"t":39.2},{"o":{"x":0.167,"y":0.127},"i":{"x":0.833,"y":0.984},"s":[12.808,39.141,100],"t":40},{"o":{"x":0.167,"y":-0.02},"i":{"x":0.833,"y":0.938},"s":[36.176,49.79,100],"t":40.8},{"o":{"x":0.167,"y":-0.242},"i":{"x":0.833,"y":0.867},"s":[17.41,4.217,100],"t":41.6},{"o":{"x":0.167,"y":0.224},"i":{"x":0.833,"y":0.67},"s":[22.21,23.867,100],"t":42.4},{"o":{"x":0.167,"y":0.112},"i":{"x":0.833,"y":0.825},"s":[25.048,15.014,100],"t":43.2},{"o":{"x":0.167,"y":0.159},"i":{"x":0.833,"y":1.216},"s":[33.433,17.425,100],"t":44},{"o":{"x":0.167,"y":0.06},"i":{"x":0.833,"y":0.985},"s":[42.612,3.611,100],"t":44.8},{"o":{"x":0.167,"y":-0.019},"i":{"x":0.833,"y":1.012},"s":[9.673,-36.008,100],"t":45.6},{"o":{"x":0.167,"y":0.01},"i":{"x":0.833,"y":0.833},"s":[36.625,41.5,100],"t":46.4},{"s":[5.886,33.044,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.137},"i":{"x":0.833,"y":0.689},"s":[271.252,303.813,0],"t":8,"ti":[-1.149,1.055,0],"to":[0.284,-0.193,0]},{"o":{"x":0.167,"y":0.076},"i":{"x":0.833,"y":0.835},"s":[272.957,302.654,0],"t":8.8,"ti":[-2.022,2.73,0],"to":[1.149,-1.055,0]},{"o":{"x":0.167,"y":0.068},"i":{"x":0.833,"y":0.907},"s":[278.144,297.481,0],"t":9.6,"ti":[-1.91,4.187,0],"to":[2.022,-2.73,0]},{"o":{"x":0.167,"y":0.049},"i":{"x":0.833,"y":0.952},"s":[285.092,286.273,0],"t":10.4,"ti":[-1.055,4.438,0],"to":[1.91,-4.187,0]},{"o":{"x":0.167,"y":0.025},"i":{"x":0.833,"y":0.978},"s":[289.604,272.358,0],"t":11.2,"ti":[-0.359,3.914,0],"to":[1.055,-4.438,0]},{"o":{"x":0.167,"y":0.006},"i":{"x":0.833,"y":0.995},"s":[291.42,259.644,0],"t":12,"ti":[0.022,3.308,0],"to":[0.359,-3.914,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[291.76,248.874,0],"t":12.8,"ti":[0.239,2.795,0],"to":[-0.022,-3.308,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[291.291,239.797,0],"t":13.6,"ti":[0.374,2.38,0],"to":[-0.239,-2.795,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[290.325,232.102,0],"t":14.4,"ti":[0.463,2.046,0],"to":[-0.374,-2.38,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[289.046,225.517,0],"t":15.2,"ti":[0.527,1.772,0],"to":[-0.463,-2.046,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[287.548,219.827,0],"t":16,"ti":[0.577,1.542,0],"to":[-0.527,-1.772,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[285.886,214.884,0],"t":16.8,"ti":[0.62,1.344,0],"to":[-0.577,-1.542,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[284.087,210.573,0],"t":17.6,"ti":[0.662,1.168,0],"to":[-0.62,-1.344,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[282.165,206.818,0],"t":18.4,"ti":[0.709,1.006,0],"to":[-0.662,-1.168,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[280.115,203.564,0],"t":19.2,"ti":[0.773,0.841,0],"to":[-0.709,-1.006,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[277.909,200.78,0],"t":20,"ti":[0.882,0.613,0],"to":[-0.773,-0.841,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[275.475,198.518,0],"t":20.8,"ti":[0.968,0.094,0],"to":[-0.882,-0.613,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[272.616,197.104,0],"t":21.6,"ti":[0.794,-0.512,0],"to":[-0.968,-0.094,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[269.666,197.956,0],"t":22.4,"ti":[0.517,-0.748,0],"to":[-0.794,0.512,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[267.851,200.177,0],"t":23.2,"ti":[0.389,-0.735,0],"to":[-0.517,0.748,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[266.566,202.443,0],"t":24,"ti":[0.329,-0.691,0],"to":[-0.389,0.735,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[265.514,204.588,0],"t":24.8,"ti":[0.293,-0.642,0],"to":[-0.329,0.691,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[264.591,206.588,0],"t":25.6,"ti":[0.267,-0.593,0],"to":[-0.293,0.642,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[263.756,208.44,0],"t":26.4,"ti":[0.245,-0.545,0],"to":[-0.267,0.593,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[262.99,210.145,0],"t":27.2,"ti":[0.226,-0.497,0],"to":[-0.245,0.545,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[262.283,211.707,0],"t":28,"ti":[0.206,-0.451,0],"to":[-0.226,0.497,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[261.635,213.129,0],"t":28.8,"ti":[0.186,-0.406,0],"to":[-0.206,0.451,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[261.046,214.413,0],"t":29.6,"ti":[0.164,-0.36,0],"to":[-0.186,0.406,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[260.52,215.562,0],"t":30.4,"ti":[0.14,-0.315,0],"to":[-0.164,0.36,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[260.062,216.575,0],"t":31.2,"ti":[0.114,-0.269,0],"to":[-0.14,0.315,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[259.679,217.45,0],"t":32,"ti":[0.086,-0.224,0],"to":[-0.114,0.269,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[259.376,218.188,0],"t":32.8,"ti":[0.055,-0.178,0],"to":[-0.086,0.224,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[259.162,218.791,0],"t":33.6,"ti":[0.022,-0.132,0],"to":[-0.055,0.178,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[259.045,219.258,0],"t":34.4,"ti":[-0.015,-0.086,0],"to":[-0.022,0.132,0]},{"o":{"x":0.167,"y":0.097},"i":{"x":0.833,"y":0.921},"s":[259.032,219.585,0],"t":35.2,"ti":[-0.054,-0.038,0],"to":[0.015,0.086,0]},{"o":{"x":0.167,"y":0.157},"i":{"x":0.833,"y":0.808},"s":[259.133,219.772,0],"t":36,"ti":[-0.089,-0.002,0],"to":[0.054,0.038,0]},{"o":{"x":0.167,"y":0.143},"i":{"x":0.833,"y":0.819},"s":[259.355,219.813,0],"t":36.8,"ti":[-0.114,0.012,0],"to":[0.089,0.002,0]},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.824},"s":[259.669,219.787,0],"t":37.6,"ti":[-0.131,0.018,0],"to":[0.114,-0.012,0]},{"o":{"x":0.167,"y":0.155},"i":{"x":0.833,"y":0.828},"s":[260.041,219.743,0],"t":38.4,"ti":[-0.144,0.024,0],"to":[0.131,-0.018,0]},{"o":{"x":0.167,"y":0.158},"i":{"x":0.833,"y":0.833},"s":[260.458,219.681,0],"t":39.2,"ti":[-0.153,0.025,0],"to":[0.144,-0.024,0]},{"o":{"x":0.167,"y":0.161},"i":{"x":0.833,"y":0.834},"s":[260.907,219.601,0],"t":40,"ti":[-0.159,0.017,0],"to":[0.153,-0.025,0]},{"o":{"x":0.167,"y":0.165},"i":{"x":0.833,"y":0.833},"s":[261.377,219.531,0],"t":40.8,"ti":[-0.161,0.006,0],"to":[0.159,-0.017,0]},{"o":{"x":0.167,"y":0.166},"i":{"x":0.833,"y":0.834},"s":[261.86,219.498,0],"t":41.6,"ti":[-0.161,-0.005,0],"to":[0.161,-0.006,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.836},"s":[262.346,219.497,0],"t":42.4,"ti":[-0.157,-0.014,0],"to":[0.161,0.005,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.838},"s":[262.825,219.527,0],"t":43.2,"ti":[-0.151,-0.023,0],"to":[0.157,0.014,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.841},"s":[263.289,219.583,0],"t":44,"ti":[-0.142,-0.03,0],"to":[0.151,0.023,0]},{"o":{"x":0.167,"y":0.166},"i":{"x":0.833,"y":0.844},"s":[263.73,219.663,0],"t":44.8,"ti":[-0.132,-0.036,0],"to":[0.142,0.03,0]},{"o":{"x":0.167,"y":0.165},"i":{"x":0.833,"y":0.847},"s":[264.142,219.763,0],"t":45.6,"ti":[-0.119,-0.041,0],"to":[0.132,0.036,0]},{"o":{"x":0.167,"y":0.162},"i":{"x":0.833,"y":0.844},"s":[264.519,219.88,0],"t":46.4,"ti":[-0.056,-0.022,0],"to":[0.119,0.041,0]},{"s":[264.857,220.011,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":12},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":29.6},{"s":[0],"t":42.4}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Rectangle 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[0.012,10.621],[-5.695,5.34],[-2.557,-7.377],[3.15,-2.096]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[1,0.6863,0],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-3.421,4.043],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":18},{"ty":4,"nm":"Shape Layer 33","sr":1,"st":0.8,"op":48,"ip":0.8,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":1.161},"s":[88.706,125.309,100],"t":0.8},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.987},"s":[101.05,65.647,100],"t":1.6},{"o":{"x":0.167,"y":-0.015},"i":{"x":0.833,"y":0.822},"s":[64.822,119.625,100],"t":2.4},{"o":{"x":0.167,"y":0.156},"i":{"x":0.833,"y":1.03},"s":[95.37,85.974,100],"t":3.2},{"o":{"x":0.167,"y":0.022},"i":{"x":0.833,"y":0.939},"s":[130.225,63.782,100],"t":4},{"o":{"x":0.167,"y":-0.229},"i":{"x":0.833,"y":0.866},"s":[82.767,137.754,100],"t":4.8},{"o":{"x":0.167,"y":0.219},"i":{"x":0.833,"y":1.05},"s":[95.438,114.769,100],"t":5.6},{"o":{"x":0.167,"y":0.031},"i":{"x":0.833,"y":0.544},"s":[103.2,80.591,100],"t":6.4},{"o":{"x":0.167,"y":0.102},"i":{"x":0.833,"y":1.032},"s":[90.818,98.938,100],"t":7.2},{"o":{"x":0.167,"y":0.023},"i":{"x":0.833,"y":0.967},"s":[35.459,109.792,100],"t":8},{"o":{"x":0.167,"y":-0.056},"i":{"x":0.833,"y":0.842},"s":[111.828,112.627,100],"t":8.8},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":1.085},"s":[66.113,132.396,100],"t":9.6},{"o":{"x":0.167,"y":0.042},"i":{"x":0.833,"y":0.934},"s":[25.062,87.733,100],"t":10.4},{"o":{"x":0.167,"y":-0.328},"i":{"x":0.833,"y":0.884},"s":[107.997,65.085,100],"t":11.2},{"o":{"x":0.167,"y":0.298},"i":{"x":0.833,"y":1.34},"s":[91.212,67.15,100],"t":12},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.92},"s":[84.699,52.844,100],"t":12.8},{"o":{"x":0.167,"y":-2.065},"i":{"x":0.833,"y":1.04},"s":[117.811,115.589,100],"t":13.6},{"o":{"x":0.167,"y":0.027},"i":{"x":0.833,"y":2.695},"s":[116.527,92.87,100],"t":14.4},{"o":{"x":0.167,"y":0.079},"i":{"x":0.833,"y":0.902},"s":[118.433,95.846,100],"t":15.2},{"o":{"x":0.167,"y":0.556},"i":{"x":0.833,"y":1.407},"s":[77.764,57.746,100],"t":16},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":0.863},"s":[70.59,60.792,100],"t":16.8},{"o":{"x":0.167,"y":0.213},"i":{"x":0.833,"y":1.073},"s":[112.827,65.643,100],"t":17.6},{"o":{"x":0.167,"y":0.039},"i":{"x":0.833,"y":0.871},"s":[139.959,82.972,100],"t":18.4},{"o":{"x":0.167,"y":0.235},"i":{"x":0.833,"y":0.858},"s":[89.044,39.953,100],"t":19.2},{"o":{"x":0.167,"y":0.202},"i":{"x":0.833,"y":1.03},"s":[61.106,115.024,100],"t":20},{"o":{"x":0.167,"y":0.022},"i":{"x":0.833,"y":0.926},"s":[41.52,141.346,100],"t":20.8},{"o":{"x":0.167,"y":-0.674},"i":{"x":0.833,"y":2.086},"s":[68.262,107.246,100],"t":21.6},{"o":{"x":0.167,"y":0.077},"i":{"x":0.833,"y":0.999},"s":[65.317,84.613,100],"t":22.4},{"o":{"x":0.167,"y":-0.001},"i":{"x":0.833,"y":0.919},"s":[106.651,57.805,100],"t":23.2},{"o":{"x":0.167,"y":-3.288},"i":{"x":0.833,"y":0.947},"s":[66.005,65.265,100],"t":24},{"o":{"x":0.167,"y":-0.143},"i":{"x":0.833,"y":-1.723},"s":[67.009,46.429,100],"t":24.8},{"o":{"x":0.167,"y":0.086},"i":{"x":0.833,"y":0.991},"s":[66.639,51.274,100],"t":25.6},{"o":{"x":0.167,"y":-0.01},"i":{"x":0.833,"y":0.778},"s":[54.923,71.216,100],"t":26.4},{"o":{"x":0.167,"y":0.133},"i":{"x":0.833,"y":1.071},"s":[65.427,35.22,100],"t":27.2},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":0.878},"s":[82.893,37.183,100],"t":28},{"o":{"x":0.167,"y":0.264},"i":{"x":0.833,"y":0.906},"s":[50.525,41.333,100],"t":28.8},{"o":{"x":0.167,"y":0.747},"i":{"x":0.833,"y":2.063},"s":[35.563,32.66,100],"t":29.6},{"o":{"x":0.167,"y":0.077},"i":{"x":0.833,"y":0.889},"s":[33.685,23.422,100],"t":30.4},{"o":{"x":0.167,"y":0.331},"i":{"x":0.833,"y":1.055},"s":[59.517,70.825,100],"t":31.2},{"o":{"x":0.167,"y":0.033},"i":{"x":0.833,"y":0.967},"s":[68.226,22.181,100],"t":32},{"o":{"x":0.167,"y":-0.055},"i":{"x":0.833,"y":1.215},"s":[53.746,26.302,100],"t":32.8},{"o":{"x":0.167,"y":0.06},"i":{"x":0.833,"y":0.832},"s":[62.499,-7.882,100],"t":33.6},{"o":{"x":0.167,"y":0.166},"i":{"x":0.833,"y":0.925},"s":[31.128,3.701,100],"t":34.4},{"o":{"x":0.167,"y":-0.72},"i":{"x":0.833,"y":1.261},"s":[-0.586,59.702,100],"t":35.2},{"o":{"x":0.167,"y":0.063},"i":{"x":0.833,"y":1.131},"s":[2.703,25.328,100],"t":36},{"o":{"x":0.167,"y":0.051},"i":{"x":0.833,"y":0.938},"s":[-10.892,49.534,100],"t":36.8},{"o":{"x":0.167,"y":-0.242},"i":{"x":0.833,"y":0.851},"s":[24.109,12.637,100],"t":37.6},{"o":{"x":0.167,"y":0.189},"i":{"x":0.833,"y":1.541},"s":[15.151,21.155,100],"t":38.4},{"o":{"x":0.167,"y":0.072},"i":{"x":0.833,"y":0.973},"s":[8.06,16.479,100],"t":39.2},{"o":{"x":0.167,"y":-0.04},"i":{"x":0.833,"y":0.881},"s":[61.168,27.875,100],"t":40},{"o":{"x":0.167,"y":0.278},"i":{"x":0.833,"y":1.037},"s":[25.413,-14.304,100],"t":40.8},{"o":{"x":0.167,"y":0.026},"i":{"x":0.833,"y":0.927},"s":[10.106,8.552,100],"t":41.6},{"o":{"x":0.167,"y":-0.597},"i":{"x":0.833,"y":0.809},"s":[32.24,5.058,100],"t":42.4},{"o":{"x":0.167,"y":0.148},"i":{"x":0.833,"y":0.896},"s":[29.528,36.767,100],"t":43.2},{"o":{"x":0.167,"y":0.422},"i":{"x":0.833,"y":0.876},"s":[26.015,30.226,100],"t":44},{"o":{"x":0.167,"y":0.252},"i":{"x":0.833,"y":0.716},"s":[25.151,18.362,100],"t":44.8},{"o":{"x":0.167,"y":0.118},"i":{"x":0.833,"y":1.719},"s":[24.725,54.585,100],"t":45.6},{"o":{"x":0.167,"y":0.075},"i":{"x":0.833,"y":0.833},"s":[23.696,35.402,100],"t":46.4},{"s":[33.602,11.392,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.125},"i":{"x":0.833,"y":0.727},"s":[270.415,303.961,0],"t":0.8,"ti":[-1.389,1.063,0],"to":[0.303,-0.268,0]},{"o":{"x":0.167,"y":0.086},"i":{"x":0.833,"y":0.839},"s":[272.233,302.354,0],"t":1.6,"ti":[-2.915,0.504,0],"to":[1.389,-1.063,0]},{"o":{"x":0.167,"y":0.133},"i":{"x":0.833,"y":0.815},"s":[278.751,297.585,0],"t":2.4,"ti":[-1.552,-2.903,0],"to":[2.915,-0.504,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[289.724,299.332,0],"t":3.2,"ti":[0.807,-4.867,0],"to":[1.552,2.903,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[288.065,315.004,0],"t":4,"ti":[1.017,-4.14,0],"to":[-0.807,4.867,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[284.884,328.537,0],"t":4.8,"ti":[0.905,-3.485,0],"to":[-1.017,4.14,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[281.965,339.842,0],"t":5.6,"ti":[0.776,-2.987,0],"to":[-0.905,3.485,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[279.455,349.449,0],"t":6.4,"ti":[0.667,-2.607,0],"to":[-0.776,2.987,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[277.308,357.764,0],"t":7.2,"ti":[0.578,-2.312,0],"to":[-0.667,2.607,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[275.455,365.094,0],"t":8,"ti":[0.505,-2.074,0],"to":[-0.578,2.312,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[273.842,371.638,0],"t":8.8,"ti":[0.444,-1.876,0],"to":[-0.505,2.074,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[272.427,377.536,0],"t":9.6,"ti":[0.393,-1.708,0],"to":[-0.444,1.876,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[271.178,382.891,0],"t":10.4,"ti":[0.349,-1.562,0],"to":[-0.393,1.708,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[270.071,387.781,0],"t":11.2,"ti":[0.31,-1.434,0],"to":[-0.349,1.562,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[269.086,392.264,0],"t":12,"ti":[0.275,-1.32,0],"to":[-0.31,1.434,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[268.211,396.386,0],"t":12.8,"ti":[0.243,-1.215,0],"to":[-0.275,1.32,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[267.436,400.181,0],"t":13.6,"ti":[0.213,-1.118,0],"to":[-0.243,1.215,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[266.752,403.676,0],"t":14.4,"ti":[0.185,-1.028,0],"to":[-0.213,1.118,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[266.156,406.891,0],"t":15.2,"ti":[0.158,-0.941,0],"to":[-0.185,1.028,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[265.642,409.842,0],"t":16,"ti":[0.131,-0.859,0],"to":[-0.158,0.941,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[265.209,412.54,0],"t":16.8,"ti":[0.105,-0.779,0],"to":[-0.131,0.859,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[264.855,414.996,0],"t":17.6,"ti":[0.078,-0.702,0],"to":[-0.105,0.779,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[264.581,417.216,0],"t":18.4,"ti":[0.051,-0.625,0],"to":[-0.078,0.702,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[264.386,419.205,0],"t":19.2,"ti":[0.024,-0.55,0],"to":[-0.051,0.625,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[264.272,420.968,0],"t":20,"ti":[-0.004,-0.475,0],"to":[-0.024,0.55,0]},{"o":{"x":0.167,"y":0.007},"i":{"x":0.833,"y":0.994},"s":[264.241,422.506,0],"t":20.8,"ti":[-0.032,-0.401,0],"to":[0.004,0.475,0]},{"o":{"x":0.167,"y":0.023},"i":{"x":0.833,"y":0.981},"s":[264.295,423.82,0],"t":21.6,"ti":[-0.062,-0.326,0],"to":[0.032,0.401,0]},{"o":{"x":0.167,"y":0.048},"i":{"x":0.833,"y":0.961},"s":[264.435,424.912,0],"t":22.4,"ti":[-0.092,-0.251,0],"to":[0.062,0.326,0]},{"o":{"x":0.167,"y":0.084},"i":{"x":0.833,"y":0.932},"s":[264.666,425.779,0],"t":23.2,"ti":[-0.123,-0.178,0],"to":[0.092,0.251,0]},{"o":{"x":0.167,"y":0.127},"i":{"x":0.833,"y":0.889},"s":[264.99,426.419,0],"t":24,"ti":[-0.144,-0.125,0],"to":[0.123,0.178,0]},{"o":{"x":0.167,"y":0.141},"i":{"x":0.833,"y":0.867},"s":[265.403,426.848,0],"t":24.8,"ti":[-0.154,-0.094,0],"to":[0.144,0.125,0]},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.855},"s":[265.856,427.168,0],"t":25.6,"ti":[-0.158,-0.068,0],"to":[0.154,0.094,0]},{"o":{"x":0.167,"y":0.16},"i":{"x":0.833,"y":0.847},"s":[266.328,427.409,0],"t":26.4,"ti":[-0.158,-0.046,0],"to":[0.158,0.068,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.842},"s":[266.806,427.579,0],"t":27.2,"ti":[-0.155,-0.026,0],"to":[0.158,0.046,0]},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.839},"s":[267.278,427.686,0],"t":28,"ti":[-0.148,-0.008,0],"to":[0.155,0.026,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.839},"s":[267.736,427.736,0],"t":28.8,"ti":[-0.139,0.007,0],"to":[0.148,0.008,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.841},"s":[268.169,427.736,0],"t":29.6,"ti":[-0.127,0.022,0],"to":[0.139,-0.007,0]},{"o":{"x":0.167,"y":0.169},"i":{"x":0.833,"y":0.844},"s":[268.571,427.692,0],"t":30.4,"ti":[-0.114,0.034,0],"to":[0.127,-0.022,0]},{"o":{"x":0.167,"y":0.162},"i":{"x":0.833,"y":0.852},"s":[268.934,427.607,0],"t":31.2,"ti":[-0.098,0.046,0],"to":[0.114,-0.034,0]},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.865},"s":[269.252,427.486,0],"t":32,"ti":[-0.081,0.051,0],"to":[0.098,-0.046,0]},{"o":{"x":0.167,"y":0.147},"i":{"x":0.833,"y":0.879},"s":[269.522,427.333,0],"t":32.8,"ti":[-0.064,0.046,0],"to":[0.081,-0.051,0]},{"o":{"x":0.167,"y":0.155},"i":{"x":0.833,"y":0.885},"s":[269.74,427.18,0],"t":33.6,"ti":[-0.047,0.035,0],"to":[0.064,-0.046,0]},{"o":{"x":0.167,"y":0.159},"i":{"x":0.833,"y":0.896},"s":[269.907,427.059,0],"t":34.4,"ti":[-0.029,0.025,0],"to":[0.047,-0.035,0]},{"o":{"x":0.167,"y":0.16},"i":{"x":0.833,"y":0.917},"s":[270.02,426.97,0],"t":35.2,"ti":[-0.011,0.015,0],"to":[0.029,-0.025,0]},{"o":{"x":0.167,"y":0.032},"i":{"x":0.833,"y":0.977},"s":[270.079,426.911,0],"t":36,"ti":[0.007,0.006,0],"to":[0.011,-0.015,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[270.083,426.879,0],"t":36.8,"ti":[0.025,-0.002,0],"to":[-0.007,-0.006,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[270.035,426.873,0],"t":37.6,"ti":[0.041,-0.009,0],"to":[-0.025,0.002,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[269.935,426.889,0],"t":38.4,"ti":[0.056,-0.014,0],"to":[-0.041,0.009,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[269.788,426.925,0],"t":39.2,"ti":[0.07,-0.019,0],"to":[-0.056,0.014,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[269.597,426.976,0],"t":40,"ti":[0.082,-0.022,0],"to":[-0.07,0.019,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[269.367,427.038,0],"t":40.8,"ti":[0.092,-0.023,0],"to":[-0.082,0.022,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[269.104,427.106,0],"t":41.6,"ti":[0.099,-0.022,0],"to":[-0.092,0.023,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[268.815,427.175,0],"t":42.4,"ti":[0.104,-0.02,0],"to":[-0.099,0.022,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[268.508,427.24,0],"t":43.2,"ti":[0.105,-0.015,0],"to":[-0.104,0.02,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[268.192,427.293,0],"t":44,"ti":[0.103,-0.008,0],"to":[-0.105,0.015,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[267.876,427.329,0],"t":44.8,"ti":[0.098,0.002,0],"to":[-0.103,0.008,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[267.571,427.341,0],"t":45.6,"ti":[0.088,0.014,0],"to":[-0.098,-0.002,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[267.289,427.32,0],"t":46.4,"ti":[0.041,0.01,0],"to":[-0.088,-0.014,0]},{"s":[267.042,427.258,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":0.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":4.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":22.4},{"s":[0],"t":35.2}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Rectangle 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[0.012,10.621],[-5.695,5.34],[-2.557,-7.377],[3.15,-2.096]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.4745,0.8392,0.6667],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-3.421,4.043],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":19},{"ty":4,"nm":"Shape Layer 32","sr":1,"st":3.2,"op":48,"ip":3.2,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.916},"s":[146.545,56.981,100],"t":3.2},{"o":{"x":0.167,"y":7.109},"i":{"x":0.833,"y":2.984},"s":[102.654,113.791,100],"t":4},{"o":{"x":0.167,"y":0.08},"i":{"x":0.833,"y":1.082},"s":[102.133,114.538,100],"t":4.8},{"o":{"x":0.167,"y":0.041},"i":{"x":0.833,"y":0.769},"s":[115.051,67.711,100],"t":5.6},{"o":{"x":0.167,"y":0.13},"i":{"x":0.833,"y":0.979},"s":[89.461,104.174,100],"t":6.4},{"o":{"x":0.167,"y":-0.029},"i":{"x":0.833,"y":0.843},"s":[44.049,120.312,100],"t":7.2},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":1.068},"s":[77.823,118.832,100],"t":8},{"o":{"x":0.167,"y":0.037},"i":{"x":0.833,"y":1.009},"s":[107.747,119.743,100],"t":8.8},{"o":{"x":0.167,"y":0.009},"i":{"x":0.833,"y":0.92},"s":[53.479,67.782,100],"t":9.6},{"o":{"x":0.167,"y":-2.064},"i":{"x":0.833,"y":-1.061},"s":[113.921,99.393,100],"t":10.4},{"o":{"x":0.167,"y":0.087},"i":{"x":0.833,"y":0.981},"s":[111.576,88.565,100],"t":11.2},{"o":{"x":0.167,"y":-0.025},"i":{"x":0.833,"y":0.95},"s":[55.899,36.375,100],"t":12},{"o":{"x":0.167,"y":-0.128},"i":{"x":0.833,"y":1.094},"s":[98.768,100.4,100],"t":12.8},{"o":{"x":0.167,"y":0.044},"i":{"x":0.833,"y":0.97},"s":[81.873,108.568,100],"t":13.6},{"o":{"x":0.167,"y":-0.047},"i":{"x":0.833,"y":0.853},"s":[117.879,85.877,100],"t":14.4},{"o":{"x":0.167,"y":0.192},"i":{"x":0.833,"y":1.034},"s":[94.849,58.578,100],"t":15.2},{"o":{"x":0.167,"y":0.024},"i":{"x":0.833,"y":0.781},"s":[77.175,81.139,100],"t":16},{"o":{"x":0.167,"y":0.135},"i":{"x":0.833,"y":0.98},"s":[102.134,95.906,100],"t":16.8},{"o":{"x":0.167,"y":-0.026},"i":{"x":0.833,"y":0.835},"s":[142.654,110.218,100],"t":17.6},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.797},"s":[111.887,49.352,100],"t":18.4},{"o":{"x":0.167,"y":0.141},"i":{"x":0.833,"y":1.009},"s":[81.638,92.763,100],"t":19.2},{"o":{"x":0.167,"y":0.008},"i":{"x":0.833,"y":0.947},"s":[38.028,132.048,100],"t":20},{"o":{"x":0.167,"y":-0.143},"i":{"x":0.833,"y":1.012},"s":[86.128,88.194,100],"t":20.8},{"o":{"x":0.167,"y":0.011},"i":{"x":0.833,"y":1.088},"s":[68.431,76.37,100],"t":21.6},{"o":{"x":0.167,"y":0.043},"i":{"x":0.833,"y":1.042},"s":[88.699,62.632,100],"t":22.4},{"o":{"x":0.167,"y":0.028},"i":{"x":0.833,"y":0.935},"s":[46.98,59.998,100],"t":23.2},{"o":{"x":0.167,"y":-0.298},"i":{"x":0.833,"y":0.851},"s":[109.874,70.958,100],"t":24},{"o":{"x":0.167,"y":0.189},"i":{"x":0.833,"y":0.881},"s":[96.114,55.137,100],"t":24.8},{"o":{"x":0.167,"y":0.278},"i":{"x":0.833,"y":1.231},"s":[85.214,90.54,100],"t":25.6},{"o":{"x":0.167,"y":0.061},"i":{"x":0.833,"y":1.189},"s":[80.545,35.132,100],"t":26.4},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.94},"s":[98.178,65.031,100],"t":27.2},{"o":{"x":0.167,"y":-0.209},"i":{"x":0.833,"y":0.966},"s":[40.533,60.003,100],"t":28},{"o":{"x":0.167,"y":-0.059},"i":{"x":0.833,"y":0.938},"s":[56.966,52.732,100],"t":28.8},{"o":{"x":0.167,"y":-0.244},"i":{"x":0.833,"y":0.747},"s":[47.335,25.638,100],"t":29.6},{"o":{"x":0.167,"y":0.124},"i":{"x":0.833,"y":0.818},"s":[49.783,59.415,100],"t":30.4},{"o":{"x":0.167,"y":0.154},"i":{"x":0.833,"y":1.061},"s":[54.761,18.968,100],"t":31.2},{"o":{"x":0.167,"y":0.035},"i":{"x":0.833,"y":0.894},"s":[60.644,13.657,100],"t":32},{"o":{"x":0.167,"y":0.384},"i":{"x":0.833,"y":-0.945},"s":[50.471,7.064,100],"t":32.8},{"o":{"x":0.167,"y":0.087},"i":{"x":0.833,"y":0.973},"s":[47.647,18.253,100],"t":33.6},{"o":{"x":0.167,"y":-0.04},"i":{"x":0.833,"y":0.927},"s":[-15.426,58.31,100],"t":34.4},{"o":{"x":0.167,"y":-0.604},"i":{"x":0.833,"y":1.52},"s":[27.159,27.049,100],"t":35.2},{"o":{"x":0.167,"y":0.072},"i":{"x":0.833,"y":0.928},"s":[21.997,13.425,100],"t":36},{"o":{"x":0.167,"y":-0.54},"i":{"x":0.833,"y":0.588},"s":[59.347,9.373,100],"t":36.8},{"o":{"x":0.167,"y":0.104},"i":{"x":0.833,"y":1.055},"s":[54.352,8.634,100],"t":37.6},{"o":{"x":0.167,"y":0.033},"i":{"x":0.833,"y":0.999},"s":[34.643,10.569,100],"t":38.4},{"o":{"x":0.167,"y":-0.001},"i":{"x":0.833,"y":0.881},"s":[67.47,-8.566,100],"t":39.2},{"o":{"x":0.167,"y":0.276},"i":{"x":0.833,"y":0.92},"s":[34.991,-28.664,100],"t":40},{"o":{"x":0.167,"y":-1.801},"i":{"x":0.833,"y":3.321},"s":[20.908,-15.133,100],"t":40.8},{"o":{"x":0.167,"y":0.08},"i":{"x":0.833,"y":0.876},"s":[21.531,-2.998,100],"t":41.6},{"o":{"x":0.167,"y":0.256},"i":{"x":0.833,"y":1.331},"s":[3.556,37.39,100],"t":42.4},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.912},"s":[-5.112,48.357,100],"t":43.2},{"o":{"x":0.167,"y":1.482},"i":{"x":0.833,"y":0.837},"s":[37.958,65.386,100],"t":44},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.163},"s":[40.525,59.682,100],"t":44.8},{"o":{"x":0.167,"y":0.093},"i":{"x":0.833,"y":1.082},"s":[42.972,53.735,100],"t":45.6},{"o":{"x":0.167,"y":0.041},"i":{"x":0.833,"y":0.833},"s":[65.106,-1.291,100],"t":46.4},{"s":[21.097,5.723,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[267.904,308.221,0],"t":3.2,"ti":[-0.406,2.013,0],"to":[-0.062,-0.384,0]},{"o":{"x":0.167,"y":0.028},"i":{"x":0.833,"y":0.934},"s":[267.529,305.917,0],"t":4,"ti":[-2.229,4.277,0],"to":[0.406,-2.013,0]},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.903},"s":[270.337,296.143,0],"t":4.8,"ti":[-4.056,5.365,0],"to":[2.229,-4.277,0]},{"o":{"x":0.167,"y":0.102},"i":{"x":0.833,"y":0.899},"s":[280.902,280.252,0],"t":5.6,"ti":[-4.394,5.019,0],"to":[4.056,-5.365,0]},{"o":{"x":0.167,"y":0.12},"i":{"x":0.833,"y":0.897},"s":[294.676,263.955,0],"t":6.4,"ti":[-3.868,4.214,0],"to":[4.394,-5.019,0]},{"o":{"x":0.167,"y":0.124},"i":{"x":0.833,"y":0.895},"s":[307.264,250.141,0],"t":7.2,"ti":[-3.257,3.538,0],"to":[3.868,-4.214,0]},{"o":{"x":0.167,"y":0.123},"i":{"x":0.833,"y":0.895},"s":[317.883,238.67,0],"t":8,"ti":[-2.752,3.047,0],"to":[3.257,-3.538,0]},{"o":{"x":0.167,"y":0.12},"i":{"x":0.833,"y":0.896},"s":[326.809,228.915,0],"t":8.8,"ti":[-2.349,2.69,0],"to":[2.752,-3.047,0]},{"o":{"x":0.167,"y":0.116},"i":{"x":0.833,"y":0.897},"s":[334.394,220.39,0],"t":9.6,"ti":[-2.023,2.427,0],"to":[2.349,-2.69,0]},{"o":{"x":0.167,"y":0.111},"i":{"x":0.833,"y":0.9},"s":[340.902,212.773,0],"t":10.4,"ti":[-1.753,2.23,0],"to":[2.023,-2.427,0]},{"o":{"x":0.167,"y":0.106},"i":{"x":0.833,"y":0.904},"s":[346.531,205.826,0],"t":11.2,"ti":[-1.519,2.072,0],"to":[1.753,-2.23,0]},{"o":{"x":0.167,"y":0.101},"i":{"x":0.833,"y":0.908},"s":[351.417,199.393,0],"t":12,"ti":[-1.306,1.928,0],"to":[1.519,-2.072,0]},{"o":{"x":0.167,"y":0.095},"i":{"x":0.833,"y":0.914},"s":[355.644,193.397,0],"t":12.8,"ti":[-1.106,1.797,0],"to":[1.306,-1.928,0]},{"o":{"x":0.167,"y":0.088},"i":{"x":0.833,"y":0.92},"s":[359.255,187.824,0],"t":13.6,"ti":[-0.913,1.682,0],"to":[1.106,-1.797,0]},{"o":{"x":0.167,"y":0.078},"i":{"x":0.833,"y":0.929},"s":[362.28,182.616,0],"t":14.4,"ti":[-0.72,1.579,0],"to":[0.913,-1.682,0]},{"o":{"x":0.167,"y":0.066},"i":{"x":0.833,"y":0.94},"s":[364.731,177.73,0],"t":15.2,"ti":[-0.524,1.479,0],"to":[0.72,-1.579,0]},{"o":{"x":0.167,"y":0.05},"i":{"x":0.833,"y":0.955},"s":[366.601,173.143,0],"t":16,"ti":[-0.321,1.378,0],"to":[0.524,-1.479,0]},{"o":{"x":0.167,"y":0.029},"i":{"x":0.833,"y":0.974},"s":[367.872,168.855,0],"t":16.8,"ti":[-0.115,1.264,0],"to":[0.321,-1.378,0]},{"o":{"x":0.167,"y":0.002},"i":{"x":0.833,"y":0.998},"s":[368.526,164.876,0],"t":17.6,"ti":[0.083,1.13,0],"to":[0.115,-1.264,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[368.561,161.269,0],"t":18.4,"ti":[0.254,0.978,0],"to":[-0.083,-1.13,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[368.028,158.096,0],"t":19.2,"ti":[0.382,0.82,0],"to":[-0.254,-0.978,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[367.038,155.4,0],"t":20,"ti":[0.464,0.67,0],"to":[-0.382,-0.82,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[365.735,153.176,0],"t":20.8,"ti":[0.506,0.539,0],"to":[-0.464,-0.67,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[364.254,151.378,0],"t":21.6,"ti":[0.52,0.43,0],"to":[-0.506,-0.539,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[362.7,149.94,0],"t":22.4,"ti":[0.517,0.343,0],"to":[-0.52,-0.43,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[361.136,148.795,0],"t":23.2,"ti":[0.505,0.273,0],"to":[-0.517,-0.343,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[359.597,147.883,0],"t":24,"ti":[0.487,0.216,0],"to":[-0.505,-0.273,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[358.105,147.16,0],"t":24.8,"ti":[0.465,0.169,0],"to":[-0.487,-0.216,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[356.676,146.589,0],"t":25.6,"ti":[0.441,0.132,0],"to":[-0.465,-0.169,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[355.317,146.143,0],"t":26.4,"ti":[0.415,0.101,0],"to":[-0.441,-0.132,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[354.033,145.799,0],"t":27.2,"ti":[0.388,0.076,0],"to":[-0.415,-0.101,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[352.827,145.538,0],"t":28,"ti":[0.36,0.056,0],"to":[-0.388,-0.076,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[351.704,145.343,0],"t":28.8,"ti":[0.33,0.04,0],"to":[-0.36,-0.056,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[350.668,145.203,0],"t":29.6,"ti":[0.298,0.027,0],"to":[-0.33,-0.04,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[349.724,145.104,0],"t":30.4,"ti":[0.263,0.019,0],"to":[-0.298,-0.027,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[348.882,145.038,0],"t":31.2,"ti":[0.227,0.013,0],"to":[-0.263,-0.019,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[348.144,144.993,0],"t":32,"ti":[0.189,0.011,0],"to":[-0.227,-0.013,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[347.517,144.959,0],"t":32.8,"ti":[0.146,0.011,0],"to":[-0.189,-0.011,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[347.011,144.929,0],"t":33.6,"ti":[0.1,0.014,0],"to":[-0.146,-0.011,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[346.639,144.893,0],"t":34.4,"ti":[0.056,0.022,0],"to":[-0.1,-0.014,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[346.413,144.843,0],"t":35.2,"ti":[0.03,0.033,0],"to":[-0.056,-0.022,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[346.304,144.761,0],"t":36,"ti":[0.031,0.038,0],"to":[-0.03,-0.033,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[346.234,144.648,0],"t":36.8,"ti":[0.045,0.038,0],"to":[-0.031,-0.038,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[346.12,144.534,0],"t":37.6,"ti":[0.059,0.037,0],"to":[-0.045,-0.038,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[345.962,144.422,0],"t":38.4,"ti":[0.072,0.036,0],"to":[-0.059,-0.037,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[345.764,144.313,0],"t":39.2,"ti":[0.083,0.034,0],"to":[-0.072,-0.036,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[345.53,144.207,0],"t":40,"ti":[0.093,0.033,0],"to":[-0.083,-0.034,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[345.264,144.107,0],"t":40.8,"ti":[0.102,0.031,0],"to":[-0.093,-0.033,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[344.97,144.011,0],"t":41.6,"ti":[0.11,0.029,0],"to":[-0.102,-0.031,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[344.65,143.922,0],"t":42.4,"ti":[0.117,0.026,0],"to":[-0.11,-0.029,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[344.308,143.839,0],"t":43.2,"ti":[0.123,0.024,0],"to":[-0.117,-0.026,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[343.947,143.764,0],"t":44,"ti":[0.127,0.022,0],"to":[-0.123,-0.024,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[343.572,143.695,0],"t":44.8,"ti":[0.13,0.019,0],"to":[-0.127,-0.022,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[343.185,143.634,0],"t":45.6,"ti":[0.133,0.017,0],"to":[-0.13,-0.019,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[342.79,143.581,0],"t":46.4,"ti":[0.067,0.008,0],"to":[-0.133,-0.017,0]},{"s":[342.389,143.535,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":3.2},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":7.2},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":24.8},{"s":[0],"t":37.6}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Rectangle 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[0.012,10.621],[-5.695,5.34],[-2.557,-7.377],[3.15,-2.096]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[1,0.6863,0],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-3.421,4.043],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":20},{"ty":4,"nm":"Shape Layer 31","sr":1,"st":4,"op":48,"ip":4,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":1.272},"s":[88.213,98.042,100],"t":4},{"o":{"x":0.167,"y":0.064},"i":{"x":0.833,"y":0.933},"s":[98.671,49.922,100],"t":4.8},{"o":{"x":0.167,"y":-0.333},"i":{"x":0.833,"y":0.952},"s":[54.098,71.655,100],"t":5.6},{"o":{"x":0.167,"y":-0.111},"i":{"x":0.833,"y":1.856},"s":[63.017,105.433,100],"t":6.4},{"o":{"x":0.167,"y":0.076},"i":{"x":0.833,"y":0.962},"s":[59.185,119.254,100],"t":7.2},{"o":{"x":0.167,"y":-0.071},"i":{"x":0.833,"y":0.999},"s":[102.36,105.209,100],"t":8},{"o":{"x":0.167,"y":-0.001},"i":{"x":0.833,"y":0.903},"s":[79.066,71.811,100],"t":8.8},{"o":{"x":0.167,"y":0.579},"i":{"x":0.833,"y":1.893},"s":[101.985,115.908,100],"t":9.6},{"o":{"x":0.167,"y":0.076},"i":{"x":0.833,"y":0.972},"s":[105.84,113.791,100],"t":10.4},{"o":{"x":0.167,"y":-0.042},"i":{"x":0.833,"y":1.033},"s":[60.688,44.915,100],"t":11.2},{"o":{"x":0.167,"y":0.024},"i":{"x":0.833,"y":1.04},"s":[90.735,61.894,100],"t":12},{"o":{"x":0.167,"y":0.027},"i":{"x":0.833,"y":0.924},"s":[48.636,106.533,100],"t":12.8},{"o":{"x":0.167,"y":-0.867},"i":{"x":0.833,"y":1.029},"s":[110.804,104.766,100],"t":13.6},{"o":{"x":0.167,"y":0.022},"i":{"x":0.833,"y":1.309},"s":[105.35,91.067,100],"t":14.4},{"o":{"x":0.167,"y":0.066},"i":{"x":0.833,"y":1.026},"s":[112.726,102.388,100],"t":15.2},{"o":{"x":0.167,"y":0.02},"i":{"x":0.833,"y":0.929},"s":[78.021,118.647,100],"t":16},{"o":{"x":0.167,"y":-0.493},"i":{"x":0.833,"y":0.73},"s":[123.499,128.748,100],"t":16.8},{"o":{"x":0.167,"y":0.12},"i":{"x":0.833,"y":0.684},"s":[116.924,82.593,100],"t":17.6},{"o":{"x":0.167,"y":0.113},"i":{"x":0.833,"y":0.991},"s":[102.179,95.418,100],"t":18.4},{"o":{"x":0.167,"y":-0.01},"i":{"x":0.833,"y":0.886},"s":[61.093,131.691,100],"t":19.2},{"o":{"x":0.167,"y":0.309},"i":{"x":0.833,"y":0.995},"s":[97.755,79.275,100],"t":20},{"o":{"x":0.167,"y":-0.006},"i":{"x":0.833,"y":0.561},"s":[111.269,51.174,100],"t":20.8},{"o":{"x":0.167,"y":0.103},"i":{"x":0.833,"y":0.977},"s":[98.597,85.374,100],"t":21.6},{"o":{"x":0.167,"y":-0.031},"i":{"x":0.833,"y":0.896},"s":[44.555,68.006,100],"t":22.4},{"o":{"x":0.167,"y":0.425},"i":{"x":0.833,"y":1.03},"s":[83.792,66.311,100],"t":23.2},{"o":{"x":0.167,"y":0.022},"i":{"x":0.833,"y":1.079},"s":[93.366,52.935,100],"t":24},{"o":{"x":0.167,"y":0.041},"i":{"x":0.833,"y":0.872},"s":[80.351,77.978,100],"t":24.8},{"o":{"x":0.167,"y":0.24},"i":{"x":0.833,"y":1.459},"s":[105.736,46.617,100],"t":25.6},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.918},"s":[119.231,66.597,100],"t":26.4},{"o":{"x":0.167,"y":-4.839},"i":{"x":0.833,"y":-0.338},"s":[31.333,68.163,100],"t":27.2},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":0.923},"s":[32.821,63.516,100],"t":28},{"o":{"x":0.167,"y":-1.049},"i":{"x":0.833,"y":0.316},"s":[55.229,35.157,100],"t":28.8},{"o":{"x":0.167,"y":0.095},"i":{"x":0.833,"y":1.082},"s":[53.579,43.75,100],"t":29.6},{"o":{"x":0.167,"y":0.041},"i":{"x":0.833,"y":1.008},"s":[41.681,9.938,100],"t":30.4},{"o":{"x":0.167,"y":0.008},"i":{"x":0.833,"y":1.021},"s":[65.338,25.314,100],"t":31.2},{"o":{"x":0.167,"y":0.017},"i":{"x":0.833,"y":1.135},"s":[39.293,35.228,100],"t":32},{"o":{"x":0.167,"y":0.052},"i":{"x":0.833,"y":0.942},"s":[71.909,22.453,100],"t":32.8},{"o":{"x":0.167,"y":-0.192},"i":{"x":0.833,"y":0.84},"s":[-13.722,50.113,100],"t":33.6},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.78},"s":[12.165,54.928,100],"t":34.4},{"o":{"x":0.167,"y":0.134},"i":{"x":0.833,"y":0.932},"s":[36.047,7.012,100],"t":35.2},{"o":{"x":0.167,"y":-0.369},"i":{"x":0.833,"y":0.981},"s":[75.273,-11.082,100],"t":36},{"o":{"x":0.167,"y":-0.024},"i":{"x":0.833,"y":0.976},"s":[68.05,17.747,100],"t":36.8},{"o":{"x":0.167,"y":-0.033},"i":{"x":0.833,"y":0.142},"s":[73.648,32.314,100],"t":37.6},{"o":{"x":0.167,"y":0.092},"i":{"x":0.833,"y":0.915},"s":[69.641,-15.771,100],"t":38.4},{"o":{"x":0.167,"y":4.378},"i":{"x":0.833,"y":0.919},"s":[32.387,-24.312,100],"t":39.2},{"o":{"x":0.167,"y":-3.24},"i":{"x":0.833,"y":216.66},"s":[31.664,-22.708,100],"t":40},{"o":{"x":0.167,"y":0.083},"i":{"x":0.833,"y":0.938},"s":[31.682,0.419,100],"t":40.8},{"o":{"x":0.167,"y":-0.235},"i":{"x":0.833,"y":0.616},"s":[-15.245,26.807,100],"t":41.6},{"o":{"x":0.167,"y":0.106},"i":{"x":0.833,"y":0.903},"s":[-2.957,39.841,100],"t":42.4},{"o":{"x":0.167,"y":0.581},"i":{"x":0.833,"y":0.946},"s":[41.396,91.664,100],"t":43.2},{"o":{"x":0.167,"y":-0.15},"i":{"x":0.833,"y":1.754},"s":[48.828,48.327,100],"t":44},{"o":{"x":0.167,"y":0.075},"i":{"x":0.833,"y":1.071},"s":[46.178,24.721,100],"t":44.8},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":0.871},"s":[72.828,8.231,100],"t":45.6},{"o":{"x":0.167,"y":0.235},"i":{"x":0.833,"y":0.833},"s":[23.424,10.493,100],"t":46.4},{"s":[-3.769,24.296,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[274.616,306.243,0],"t":4,"ti":[0.824,2.77,0],"to":[-0.115,-0.59,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[273.925,302.703,0],"t":4.8,"ti":[2.181,6.093,0],"to":[-0.824,-2.77,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[269.674,289.624,0],"t":5.6,"ti":[3.267,8.196,0],"to":[-2.181,-6.093,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[260.838,266.142,0],"t":6.4,"ti":[3.485,7.964,0],"to":[-3.267,-8.196,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[250.074,240.449,0],"t":7.2,"ti":[3.198,6.707,0],"to":[-3.485,-7.964,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[239.929,218.357,0],"t":8,"ti":[2.853,5.529,0],"to":[-3.198,-6.707,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[230.887,200.209,0],"t":8.8,"ti":[2.563,4.612,0],"to":[-2.853,-5.529,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[222.813,185.182,0],"t":9.6,"ti":[2.332,3.906,0],"to":[-2.563,-4.612,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[215.51,172.535,0],"t":10.4,"ti":[2.146,3.349,0],"to":[-2.332,-3.906,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[208.822,161.746,0],"t":11.2,"ti":[1.992,2.898,0],"to":[-2.146,-3.349,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[202.636,152.442,0],"t":12,"ti":[1.863,2.525,0],"to":[-1.992,-2.898,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[196.868,144.357,0],"t":12.8,"ti":[1.751,2.21,0],"to":[-1.863,-2.525,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[191.458,137.291,0],"t":13.6,"ti":[1.653,1.941,0],"to":[-1.751,-2.21,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[186.36,131.094,0],"t":14.4,"ti":[1.563,1.706,0],"to":[-1.653,-1.941,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[181.542,125.648,0],"t":15.2,"ti":[1.481,1.501,0],"to":[-1.563,-1.706,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[176.98,120.856,0],"t":16,"ti":[1.403,1.32,0],"to":[-1.481,-1.501,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[172.656,116.64,0],"t":16.8,"ti":[1.328,1.158,0],"to":[-1.403,-1.32,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[168.561,112.936,0],"t":17.6,"ti":[1.255,1.014,0],"to":[-1.328,-1.158,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[164.687,109.689,0],"t":18.4,"ti":[1.183,0.886,0],"to":[-1.255,-1.014,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[161.03,106.849,0],"t":19.2,"ti":[1.111,0.771,0],"to":[-1.183,-0.886,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[157.59,104.374,0],"t":20,"ti":[1.038,0.668,0],"to":[-1.111,-0.771,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[154.367,102.223,0],"t":20.8,"ti":[0.964,0.577,0],"to":[-1.038,-0.668,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[151.363,100.364,0],"t":21.6,"ti":[0.888,0.495,0],"to":[-0.964,-0.577,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[148.583,98.763,0],"t":22.4,"ti":[0.81,0.422,0],"to":[-0.888,-0.495,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[146.035,97.394,0],"t":23.2,"ti":[0.741,0.358,0],"to":[-0.81,-0.422,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[143.723,96.23,0],"t":24,"ti":[0.687,0.303,0],"to":[-0.741,-0.358,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[141.59,95.244,0],"t":24.8,"ti":[0.639,0.255,0],"to":[-0.687,-0.303,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[139.604,94.413,0],"t":25.6,"ti":[0.592,0.214,0],"to":[-0.639,-0.255,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[137.759,93.715,0],"t":26.4,"ti":[0.547,0.179,0],"to":[-0.592,-0.214,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[136.052,93.13,0],"t":27.2,"ti":[0.502,0.149,0],"to":[-0.547,-0.179,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[134.48,92.643,0],"t":28,"ti":[0.46,0.124,0],"to":[-0.502,-0.149,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[133.038,92.238,0],"t":28.8,"ti":[0.418,0.103,0],"to":[-0.46,-0.124,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[131.723,91.901,0],"t":29.6,"ti":[0.378,0.085,0],"to":[-0.418,-0.103,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[130.53,91.622,0],"t":30.4,"ti":[0.339,0.071,0],"to":[-0.378,-0.085,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[129.457,91.39,0],"t":31.2,"ti":[0.301,0.059,0],"to":[-0.339,-0.071,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[128.499,91.197,0],"t":32,"ti":[0.264,0.049,0],"to":[-0.301,-0.059,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[127.654,91.037,0],"t":32.8,"ti":[0.228,0.041,0],"to":[-0.264,-0.049,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[126.917,90.903,0],"t":33.6,"ti":[0.193,0.034,0],"to":[-0.228,-0.041,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[126.287,90.791,0],"t":34.4,"ti":[0.158,0.028,0],"to":[-0.193,-0.034,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[125.761,90.698,0],"t":35.2,"ti":[0.134,0.025,0],"to":[-0.158,-0.028,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[125.337,90.622,0],"t":36,"ti":[0.126,0.027,0],"to":[-0.134,-0.025,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[124.96,90.547,0],"t":36.8,"ti":[0.127,0.03,0],"to":[-0.126,-0.027,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[124.579,90.461,0],"t":37.6,"ti":[0.127,0.034,0],"to":[-0.127,-0.03,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[124.196,90.364,0],"t":38.4,"ti":[0.126,0.037,0],"to":[-0.127,-0.034,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[123.816,90.257,0],"t":39.2,"ti":[0.124,0.04,0],"to":[-0.126,-0.037,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[123.44,90.141,0],"t":40,"ti":[0.121,0.042,0],"to":[-0.124,-0.04,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[123.073,90.017,0],"t":40.8,"ti":[0.116,0.044,0],"to":[-0.121,-0.042,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[122.717,89.887,0],"t":41.6,"ti":[0.11,0.046,0],"to":[-0.116,-0.044,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[122.376,89.751,0],"t":42.4,"ti":[0.103,0.046,0],"to":[-0.11,-0.046,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[122.055,89.613,0],"t":43.2,"ti":[0.095,0.046,0],"to":[-0.103,-0.046,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[121.755,89.474,0],"t":44,"ti":[0.086,0.045,0],"to":[-0.095,-0.046,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[121.483,89.337,0],"t":44.8,"ti":[0.075,0.043,0],"to":[-0.086,-0.045,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[121.241,89.204,0],"t":45.6,"ti":[0.062,0.041,0],"to":[-0.075,-0.043,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[121.035,89.077,0],"t":46.4,"ti":[0.028,0.019,0],"to":[-0.062,-0.041,0]},{"s":[120.867,88.96,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":25.6},{"s":[0],"t":38.4}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Rectangle 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[0.012,10.621],[-5.695,5.34],[-2.557,-7.377],[3.15,-2.096]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.4745,0.8392,0.6667],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-3.421,4.043],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":21},{"ty":4,"nm":"Shape Layer 30","sr":1,"st":6.4,"op":48,"ip":6.4,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.949},"s":[62.161,96.543,100],"t":6.4},{"o":{"x":0.167,"y":-0.13},"i":{"x":0.833,"y":0.907},"s":[100.156,112.306,100],"t":7.2},{"o":{"x":0.167,"y":0.78},"i":{"x":0.833,"y":-0.255},"s":[85.337,71.714,100],"t":8},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":0.914},"s":[83.564,111.805,100],"t":8.8},{"o":{"x":0.167,"y":2.881},"i":{"x":0.833,"y":3.317},"s":[58.626,100.499,100],"t":9.6},{"o":{"x":0.167,"y":0.08},"i":{"x":0.833,"y":0.968},"s":[57.883,76.161,100],"t":10.4},{"o":{"x":0.167,"y":-0.051},"i":{"x":0.833,"y":1.128},"s":[79.277,69.687,100],"t":11.2},{"o":{"x":0.167,"y":0.051},"i":{"x":0.833,"y":0.956},"s":[66.041,57.442,100],"t":12},{"o":{"x":0.167,"y":-0.092},"i":{"x":0.833,"y":1.189},"s":[99.685,95.603,100],"t":12.8},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":1.016},"s":[83.661,113.563,100],"t":13.6},{"o":{"x":0.167,"y":0.013},"i":{"x":0.833,"y":0.924},"s":[136.015,111.04,100],"t":14.4},{"o":{"x":0.167,"y":-0.873},"i":{"x":0.833,"y":0.746},"s":[73.781,116.06,100],"t":15.2},{"o":{"x":0.167,"y":0.124},"i":{"x":0.833,"y":0.967},"s":[79.202,103.731,100],"t":16},{"o":{"x":0.167,"y":-0.055},"i":{"x":0.833,"y":1.027},"s":[90.283,100.207,100],"t":16.8},{"o":{"x":0.167,"y":0.02},"i":{"x":0.833,"y":0.852},"s":[83.612,83.82,100],"t":17.6},{"o":{"x":0.167,"y":0.191},"i":{"x":0.833,"y":0.603},"s":[92.451,118.313,100],"t":18.4},{"o":{"x":0.167,"y":0.106},"i":{"x":0.833,"y":0.909},"s":[99.265,89.881,100],"t":19.2},{"o":{"x":0.167,"y":1.02},"i":{"x":0.833,"y":3.481},"s":[124.872,26,100],"t":20},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":0.92},"s":[127.15,89.446,100],"t":20.8},{"o":{"x":0.167,"y":-2.332},"i":{"x":0.833,"y":0.841},"s":[57.069,79.381,100],"t":21.6},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.572},"s":[59.486,44.49,100],"t":22.4},{"o":{"x":0.167,"y":0.103},"i":{"x":0.833,"y":0.638},"s":[61.689,53.354,100],"t":23.2},{"o":{"x":0.167,"y":0.108},"i":{"x":0.833,"y":0.822},"s":[70.8,66.698,100],"t":24},{"o":{"x":0.167,"y":0.157},"i":{"x":0.833,"y":1.094},"s":[101.268,70.196,100],"t":24.8},{"o":{"x":0.167,"y":0.044},"i":{"x":0.833,"y":0.89},"s":[135.914,62.272,100],"t":25.6},{"o":{"x":0.167,"y":0.345},"i":{"x":0.833,"y":1.08},"s":[62.097,63.174,100],"t":26.4},{"o":{"x":0.167,"y":0.041},"i":{"x":0.833,"y":0.94},"s":[38.578,89.373,100],"t":27.2},{"o":{"x":0.167,"y":-0.213},"i":{"x":0.833,"y":0.898},"s":[84.734,80.668,100],"t":28},{"o":{"x":0.167,"y":0.457},"i":{"x":0.833,"y":1.645},"s":[71.735,80.523,100],"t":28.8},{"o":{"x":0.167,"y":0.074},"i":{"x":0.833,"y":0.967},"s":[68.832,20.271,100],"t":29.6},{"o":{"x":0.167,"y":-0.053},"i":{"x":0.833,"y":0.963},"s":[94.213,63.191,100],"t":30.4},{"o":{"x":0.167,"y":-0.065},"i":{"x":0.833,"y":1.499},"s":[78.745,70.653,100],"t":31.2},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.912},"s":[87.422,62.786,100],"t":32},{"o":{"x":0.167,"y":1.658},"i":{"x":0.833,"y":0.903},"s":[26.733,44.597,100],"t":32.8},{"o":{"x":0.167,"y":0.609},"i":{"x":0.833,"y":8.954},"s":[23.521,65.429,100],"t":33.6},{"o":{"x":0.167,"y":0.082},"i":{"x":0.833,"y":0.931},"s":[23.011,48.501,100],"t":34.4},{"o":{"x":0.167,"y":-0.407},"i":{"x":0.833,"y":1.153},"s":[72.162,14.125,100],"t":35.2},{"o":{"x":0.167,"y":0.054},"i":{"x":0.833,"y":0.994},"s":[63.801,47.128,100],"t":36},{"o":{"x":0.167,"y":-0.006},"i":{"x":0.833,"y":0.742},"s":[87.498,84.73,100],"t":36.8},{"o":{"x":0.167,"y":0.123},"i":{"x":0.833,"y":0.929},"s":[65.378,13.453,100],"t":37.6},{"o":{"x":0.167,"y":-0.497},"i":{"x":0.833,"y":0.536},"s":[19.027,16.413,100],"t":38.4},{"o":{"x":0.167,"y":0.102},"i":{"x":0.833,"y":1.076},"s":[25.686,2.971,100],"t":39.2},{"o":{"x":0.167,"y":0.04},"i":{"x":0.833,"y":0.924},"s":[56.116,29.236,100],"t":40},{"o":{"x":0.167,"y":-0.906},"i":{"x":0.833,"y":0.444},"s":[-1.889,16.583,100],"t":40.8},{"o":{"x":0.167,"y":0.098},"i":{"x":0.833,"y":0.986},"s":[2.996,9.45,100],"t":41.6},{"o":{"x":0.167,"y":-0.017},"i":{"x":0.833,"y":0.952},"s":[30.717,70.822,100],"t":42.4},{"o":{"x":0.167,"y":-0.111},"i":{"x":0.833,"y":0.484},"s":[7.584,38.216,100],"t":43.2},{"o":{"x":0.167,"y":0.099},"i":{"x":0.833,"y":0.947},"s":[17.496,-6.813,100],"t":44},{"o":{"x":0.167,"y":-0.143},"i":{"x":0.833,"y":0.773},"s":[68.936,20.442,100],"t":44.8},{"o":{"x":0.167,"y":0.132},"i":{"x":0.833,"y":0.98},"s":[50.024,11.466,100],"t":45.6},{"o":{"x":0.167,"y":-0.027},"i":{"x":0.833,"y":0.833},"s":[17.481,29.004,100],"t":46.4},{"s":[42.14,69.391,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[273.484,300.616,0],"t":6.4,"ti":[0.394,1.23,0],"to":[-0.073,-0.268,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[273.044,299.005,0],"t":7.2,"ti":[0.97,2.68,0],"to":[-0.394,-1.23,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[271.118,293.234,0],"t":8,"ti":[1.519,3.557,0],"to":[-0.97,-2.68,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[267.222,282.925,0],"t":8.8,"ti":[1.983,3.196,0],"to":[-1.519,-3.557,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[262.002,271.894,0],"t":9.6,"ti":[2.392,1.007,0],"to":[-1.983,-3.196,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[255.326,263.748,0],"t":10.4,"ti":[1.906,-1.439,0],"to":[-2.392,-1.007,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[247.647,265.854,0],"t":11.2,"ti":[1.029,-2.094,0],"to":[-1.906,1.439,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[243.888,272.381,0],"t":12,"ti":[0.709,-1.9,0],"to":[-1.029,2.094,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[241.473,278.416,0],"t":12.8,"ti":[0.56,-1.691,0],"to":[-0.709,1.9,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[239.636,283.781,0],"t":13.6,"ti":[0.476,-1.51,0],"to":[-0.56,1.691,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[238.111,288.564,0],"t":14.4,"ti":[0.423,-1.353,0],"to":[-0.476,1.51,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[236.781,292.841,0],"t":15.2,"ti":[0.389,-1.218,0],"to":[-0.423,1.353,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[235.575,296.684,0],"t":16,"ti":[0.367,-1.099,0],"to":[-0.389,1.218,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[234.45,300.149,0],"t":16.8,"ti":[0.353,-0.992,0],"to":[-0.367,1.099,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[233.375,303.275,0],"t":17.6,"ti":[0.346,-0.895,0],"to":[-0.353,0.992,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[232.33,306.098,0],"t":18.4,"ti":[0.345,-0.807,0],"to":[-0.346,0.895,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[231.297,308.646,0],"t":19.2,"ti":[0.347,-0.725,0],"to":[-0.345,0.807,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[230.261,310.941,0],"t":20,"ti":[0.353,-0.648,0],"to":[-0.347,0.725,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[229.214,312.998,0],"t":20.8,"ti":[0.361,-0.575,0],"to":[-0.353,0.648,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[228.146,314.83,0],"t":21.6,"ti":[0.371,-0.504,0],"to":[-0.361,0.575,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[227.049,316.449,0],"t":22.4,"ti":[0.381,-0.434,0],"to":[-0.371,0.504,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[225.922,317.856,0],"t":23.2,"ti":[0.391,-0.366,0],"to":[-0.381,0.434,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[224.764,319.055,0],"t":24,"ti":[0.401,-0.298,0],"to":[-0.391,0.366,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[223.576,320.049,0],"t":24.8,"ti":[0.41,-0.232,0],"to":[-0.401,0.298,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[222.359,320.843,0],"t":25.6,"ti":[0.415,-0.168,0],"to":[-0.41,0.232,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[221.118,321.443,0],"t":26.4,"ti":[0.412,-0.106,0],"to":[-0.415,0.168,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[219.872,321.85,0],"t":27.2,"ti":[0.401,-0.05,0],"to":[-0.412,0.106,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[218.647,322.076,0],"t":28,"ti":[0.385,-0.003,0],"to":[-0.401,0.05,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[217.463,322.147,0],"t":28.8,"ti":[0.364,0.034,0],"to":[-0.385,0.003,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[216.337,322.093,0],"t":29.6,"ti":[0.341,0.06,0],"to":[-0.364,-0.034,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[215.276,321.946,0],"t":30.4,"ti":[0.316,0.077,0],"to":[-0.341,-0.06,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[214.288,321.735,0],"t":31.2,"ti":[0.29,0.086,0],"to":[-0.316,-0.077,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[213.378,321.486,0],"t":32,"ti":[0.265,0.09,0],"to":[-0.29,-0.086,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[212.546,321.219,0],"t":32.8,"ti":[0.239,0.088,0],"to":[-0.265,-0.09,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[211.79,320.949,0],"t":33.6,"ti":[0.212,0.083,0],"to":[-0.239,-0.088,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[211.114,320.689,0],"t":34.4,"ti":[0.186,0.075,0],"to":[-0.212,-0.083,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[210.521,320.45,0],"t":35.2,"ti":[0.176,0.067,0],"to":[-0.186,-0.075,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[209.997,320.238,0],"t":36,"ti":[0.178,0.059,0],"to":[-0.176,-0.067,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[209.465,320.047,0],"t":36.8,"ti":[0.179,0.05,0],"to":[-0.178,-0.059,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[208.927,319.881,0],"t":37.6,"ti":[0.179,0.042,0],"to":[-0.179,-0.05,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[208.392,319.745,0],"t":38.4,"ti":[0.184,0.036,0],"to":[-0.179,-0.042,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[207.85,319.63,0],"t":39.2,"ti":[0.189,0.031,0],"to":[-0.184,-0.036,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[207.287,319.528,0],"t":40,"ti":[0.191,0.026,0],"to":[-0.189,-0.031,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[206.714,319.442,0],"t":40.8,"ti":[0.19,0.019,0],"to":[-0.191,-0.026,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[206.14,319.374,0],"t":41.6,"ti":[0.186,0.013,0],"to":[-0.19,-0.019,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[205.574,319.326,0],"t":42.4,"ti":[0.18,0.006,0],"to":[-0.186,-0.013,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[205.024,319.298,0],"t":43.2,"ti":[0.171,-0.002,0],"to":[-0.18,-0.006,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[204.495,319.292,0],"t":44,"ti":[0.161,-0.009,0],"to":[-0.171,0.002,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[203.995,319.308,0],"t":44.8,"ti":[0.149,-0.017,0],"to":[-0.161,0.009,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[203.528,319.347,0],"t":45.6,"ti":[0.136,-0.024,0],"to":[-0.149,0.017,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[203.099,319.409,0],"t":46.4,"ti":[0.065,-0.014,0],"to":[-0.136,0.024,0]},{"s":[202.712,319.493,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":6.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":10.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":28},{"s":[0],"t":40.8}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Rectangle 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[0.012,10.621],[-5.695,5.34],[-2.557,-7.377],[3.15,-2.096]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[1,0.6863,0],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-3.421,4.043],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":22},{"ty":4,"nm":"Shape Layer 29","sr":1,"st":9.6,"op":48,"ip":9.6,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.332},"s":[64.57,85.432,100],"t":9.6},{"o":{"x":0.167,"y":0.095},"i":{"x":0.833,"y":0.875},"s":[69.942,108.953,100],"t":10.4},{"o":{"x":0.167,"y":0.249},"i":{"x":0.833,"y":1.206},"s":[107.607,32.831,100],"t":11.2},{"o":{"x":0.167,"y":0.059},"i":{"x":0.833,"y":0.969},"s":[126.531,60.735,100],"t":12},{"o":{"x":0.167,"y":-0.048},"i":{"x":0.833,"y":1},"s":[60.769,85.755,100],"t":12.8},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":0.908},"s":[102.39,109.836,100],"t":13.6},{"o":{"x":0.167,"y":0.877},"i":{"x":0.833,"y":1.333},"s":[60.887,124.258,100],"t":14.4},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.949},"s":[56.529,83.394,100],"t":15.2},{"o":{"x":0.167,"y":-0.133},"i":{"x":0.833,"y":1.322},"s":[78.284,97.261,100],"t":16},{"o":{"x":0.167,"y":0.066},"i":{"x":0.833,"y":0.976},"s":[69.892,74.45,100],"t":16.8},{"o":{"x":0.167,"y":-0.033},"i":{"x":0.833,"y":0.923},"s":[110.724,88.677,100],"t":17.6},{"o":{"x":0.167,"y":-0.984},"i":{"x":0.833,"y":0.066},"s":[81.454,110.927,100],"t":18.4},{"o":{"x":0.167,"y":0.091},"i":{"x":0.833,"y":1.003},"s":[83.739,40.242,100],"t":19.2},{"o":{"x":0.167,"y":0.002},"i":{"x":0.833,"y":0.86},"s":[107.061,61.553,100],"t":20},{"o":{"x":0.167,"y":0.206},"i":{"x":0.833,"y":0.865},"s":[83.024,56.466,100],"t":20.8},{"o":{"x":0.167,"y":0.217},"i":{"x":0.833,"y":0.851},"s":[66.63,33.237,100],"t":21.6},{"o":{"x":0.167,"y":0.189},"i":{"x":0.833,"y":1.158},"s":[56.437,57.54,100],"t":22.4},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.865},"s":[48.398,71.747,100],"t":23.2},{"o":{"x":0.167,"y":0.218},"i":{"x":0.833,"y":0.754},"s":[71.71,81.652,100],"t":24},{"o":{"x":0.167,"y":0.126},"i":{"x":0.833,"y":1.096},"s":[86.087,39.983,100],"t":24.8},{"o":{"x":0.167,"y":0.045},"i":{"x":0.833,"y":0.99},"s":[114.075,52.122,100],"t":25.6},{"o":{"x":0.167,"y":-0.012},"i":{"x":0.833,"y":0.96},"s":[53.751,86.117,100],"t":26.4},{"o":{"x":0.167,"y":-0.077},"i":{"x":0.833,"y":0.928},"s":[106.75,131.89,100],"t":27.2},{"o":{"x":0.167,"y":-0.532},"i":{"x":0.833,"y":0.204},"s":[79.216,106.312,100],"t":28},{"o":{"x":0.167,"y":0.093},"i":{"x":0.833,"y":0.915},"s":[82.944,67.378,100],"t":28.8},{"o":{"x":0.167,"y":3.696},"i":{"x":0.833,"y":0.454},"s":[114.826,97.73,100],"t":29.6},{"o":{"x":0.167,"y":0.098},"i":{"x":0.833,"y":1.872},"s":[115.562,107.689,100],"t":30.4},{"o":{"x":0.167,"y":0.076},"i":{"x":0.833,"y":0.944},"s":[119.647,104.826,100],"t":31.2},{"o":{"x":0.167,"y":-0.17},"i":{"x":0.833,"y":1.157},"s":[72.833,76.34,100],"t":32},{"o":{"x":0.167,"y":0.054},"i":{"x":0.833,"y":0.962},"s":[88.225,72.82,100],"t":32.8},{"o":{"x":0.167,"y":-0.07},"i":{"x":0.833,"y":0.853},"s":[43.922,58.537,100],"t":33.6},{"o":{"x":0.167,"y":0.193},"i":{"x":0.833,"y":0.885},"s":[67.927,67.475,100],"t":34.4},{"o":{"x":0.167,"y":0.3},"i":{"x":0.833,"y":1.471},"s":[86.125,70.552,100],"t":35.2},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.904},"s":[93.113,112.383,100],"t":36},{"o":{"x":0.167,"y":0.633},"i":{"x":0.833,"y":0.526},"s":[46.616,46.845,100],"t":36.8},{"o":{"x":0.167,"y":0.101},"i":{"x":0.833,"y":1.045},"s":[39.563,60.724,100],"t":37.6},{"o":{"x":0.167,"y":0.029},"i":{"x":0.833,"y":0.969},"s":[6.525,44.501,100],"t":38.4},{"o":{"x":0.167,"y":-0.05},"i":{"x":0.833,"y":0.929},"s":[57.474,81.367,100],"t":39.2},{"o":{"x":0.167,"y":-0.48},"i":{"x":0.833,"y":0.854},"s":[25.518,32.394,100],"t":40},{"o":{"x":0.167,"y":0.195},"i":{"x":0.833,"y":1.966},"s":[30.245,31.253,100],"t":40.8},{"o":{"x":0.167,"y":0.077},"i":{"x":0.833,"y":0.921},"s":[33.783,37.163,100],"t":41.6},{"o":{"x":0.167,"y":-1.48},"i":{"x":0.833,"y":-0.996},"s":[-10.763,44.348,100],"t":42.4},{"o":{"x":0.167,"y":0.087},"i":{"x":0.833,"y":0.91},"s":[-8.389,9.855,100],"t":43.2},{"o":{"x":0.167,"y":1.177},"i":{"x":0.833,"y":1.194},"s":[46.091,35.382,100],"t":44},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":1.01},"s":[50.24,13.115,100],"t":44.8},{"o":{"x":0.167,"y":0.009},"i":{"x":0.833,"y":0.876},"s":[36.428,29.519,100],"t":45.6},{"o":{"x":0.167,"y":0.252},"i":{"x":0.833,"y":0.833},"s":[51.9,63.715,100],"t":46.4},{"s":[59.535,37.52,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[270.833,305.959,0],"t":9.6,"ti":[0.479,1.681,0],"to":[-0.088,-0.333,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[270.305,303.959,0],"t":10.4,"ti":[0.843,3.89,0],"to":[-0.479,-1.681,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[267.957,295.871,0],"t":11.2,"ti":[-1.367,3.831,0],"to":[-0.843,-3.89,0]},{"o":{"x":0.167,"y":0.138},"i":{"x":0.833,"y":0.864},"s":[265.25,280.619,0],"t":12,"ti":[-4.031,0.131,0],"to":[1.367,-3.831,0]},{"o":{"x":0.167,"y":0.14},"i":{"x":0.833,"y":0.867},"s":[276.159,272.888,0],"t":12.8,"ti":[-3.947,-2.293,0],"to":[4.031,-0.131,0]},{"o":{"x":0.167,"y":0.155},"i":{"x":0.833,"y":0.872},"s":[289.438,279.833,0],"t":13.6,"ti":[-3.163,-2.107,0],"to":[3.947,2.293,0]},{"o":{"x":0.167,"y":0.151},"i":{"x":0.833,"y":0.873},"s":[299.839,286.644,0],"t":14.4,"ti":[-2.643,-1.789,0],"to":[3.163,2.107,0]},{"o":{"x":0.167,"y":0.151},"i":{"x":0.833,"y":0.871},"s":[308.416,292.475,0],"t":15.2,"ti":[-2.265,-1.502,0],"to":[2.643,1.789,0]},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.869},"s":[315.699,297.38,0],"t":16,"ti":[-1.975,-1.258,0],"to":[2.265,1.502,0]},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.867},"s":[322.005,301.489,0],"t":16.8,"ti":[-1.746,-1.051,0],"to":[1.975,1.258,0]},{"o":{"x":0.167,"y":0.155},"i":{"x":0.833,"y":0.864},"s":[327.55,304.928,0],"t":17.6,"ti":[-1.558,-0.872,0],"to":[1.746,1.051,0]},{"o":{"x":0.167,"y":0.157},"i":{"x":0.833,"y":0.862},"s":[332.48,307.794,0],"t":18.4,"ti":[-1.4,-0.715,0],"to":[1.558,0.872,0]},{"o":{"x":0.167,"y":0.16},"i":{"x":0.833,"y":0.859},"s":[336.899,310.159,0],"t":19.2,"ti":[-1.265,-0.574,0],"to":[1.4,0.715,0]},{"o":{"x":0.167,"y":0.163},"i":{"x":0.833,"y":0.855},"s":[340.882,312.081,0],"t":20,"ti":[-1.148,-0.448,0],"to":[1.265,0.574,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.851},"s":[344.489,313.605,0],"t":20.8,"ti":[-1.045,-0.333,0],"to":[1.148,0.448,0]},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.848},"s":[347.771,314.769,0],"t":21.6,"ti":[-0.954,-0.228,0],"to":[1.045,0.333,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.845},"s":[350.762,315.603,0],"t":22.4,"ti":[-0.867,-0.129,0],"to":[0.954,0.228,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.844},"s":[353.494,316.134,0],"t":23.2,"ti":[-0.779,-0.034,0],"to":[0.867,0.129,0]},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":0.842},"s":[355.966,316.376,0],"t":24,"ti":[-0.692,0.054,0],"to":[0.779,0.034,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.844},"s":[358.169,316.339,0],"t":24.8,"ti":[-0.607,0.132,0],"to":[0.692,-0.054,0]},{"o":{"x":0.167,"y":0.169},"i":{"x":0.833,"y":0.848},"s":[360.118,316.051,0],"t":25.6,"ti":[-0.525,0.197,0],"to":[0.607,-0.132,0]},{"o":{"x":0.167,"y":0.158},"i":{"x":0.833,"y":0.855},"s":[361.814,315.546,0],"t":26.4,"ti":[-0.446,0.247,0],"to":[0.525,-0.197,0]},{"o":{"x":0.167,"y":0.145},"i":{"x":0.833,"y":0.866},"s":[363.265,314.868,0],"t":27.2,"ti":[-0.374,0.281,0],"to":[0.446,-0.247,0]},{"o":{"x":0.167,"y":0.131},"i":{"x":0.833,"y":0.879},"s":[364.49,314.065,0],"t":28,"ti":[-0.309,0.299,0],"to":[0.374,-0.281,0]},{"o":{"x":0.167,"y":0.117},"i":{"x":0.833,"y":0.892},"s":[365.508,313.183,0],"t":28.8,"ti":[-0.254,0.304,0],"to":[0.309,-0.299,0]},{"o":{"x":0.167,"y":0.104},"i":{"x":0.833,"y":0.904},"s":[366.345,312.269,0],"t":29.6,"ti":[-0.208,0.299,0],"to":[0.254,-0.304,0]},{"o":{"x":0.167,"y":0.094},"i":{"x":0.833,"y":0.915},"s":[367.029,311.356,0],"t":30.4,"ti":[-0.171,0.285,0],"to":[0.208,-0.299,0]},{"o":{"x":0.167,"y":0.086},"i":{"x":0.833,"y":0.922},"s":[367.591,310.475,0],"t":31.2,"ti":[-0.143,0.266,0],"to":[0.171,-0.285,0]},{"o":{"x":0.167,"y":0.08},"i":{"x":0.833,"y":0.928},"s":[368.057,309.644,0],"t":32,"ti":[-0.123,0.244,0],"to":[0.143,-0.266,0]},{"o":{"x":0.167,"y":0.078},"i":{"x":0.833,"y":0.931},"s":[368.451,308.877,0],"t":32.8,"ti":[-0.108,0.219,0],"to":[0.123,-0.244,0]},{"o":{"x":0.167,"y":0.078},"i":{"x":0.833,"y":0.931},"s":[368.793,308.182,0],"t":33.6,"ti":[-0.097,0.192,0],"to":[0.108,-0.219,0]},{"o":{"x":0.167,"y":0.082},"i":{"x":0.833,"y":0.928},"s":[369.097,307.564,0],"t":34.4,"ti":[-0.091,0.166,0],"to":[0.097,-0.192,0]},{"o":{"x":0.167,"y":0.09},"i":{"x":0.833,"y":0.922},"s":[369.377,307.027,0],"t":35.2,"ti":[-0.087,0.139,0],"to":[0.091,-0.166,0]},{"o":{"x":0.167,"y":0.101},"i":{"x":0.833,"y":0.913},"s":[369.642,306.571,0],"t":36,"ti":[-0.085,0.112,0],"to":[0.087,-0.139,0]},{"o":{"x":0.167,"y":0.117},"i":{"x":0.833,"y":0.9},"s":[369.899,306.194,0],"t":36.8,"ti":[-0.083,0.087,0],"to":[0.085,-0.112,0]},{"o":{"x":0.167,"y":0.135},"i":{"x":0.833,"y":0.884},"s":[370.15,305.896,0],"t":37.6,"ti":[-0.082,0.062,0],"to":[0.083,-0.087,0]},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.867},"s":[370.398,305.674,0],"t":38.4,"ti":[-0.081,0.039,0],"to":[0.082,-0.062,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.85},"s":[370.644,305.522,0],"t":39.2,"ti":[-0.079,0.017,0],"to":[0.081,-0.039,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.839},"s":[370.885,305.438,0],"t":40,"ti":[-0.075,-0.004,0],"to":[0.079,-0.017,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.837},"s":[371.117,305.419,0],"t":40.8,"ti":[-0.071,-0.019,0],"to":[0.075,0.004,0]},{"o":{"x":0.167,"y":0.157},"i":{"x":0.833,"y":0.842},"s":[371.334,305.462,0],"t":41.6,"ti":[-0.071,-0.023,0],"to":[0.071,0.019,0]},{"o":{"x":0.167,"y":0.16},"i":{"x":0.833,"y":0.844},"s":[371.546,305.533,0],"t":42.4,"ti":[-0.069,-0.021,0],"to":[0.071,0.023,0]},{"o":{"x":0.167,"y":0.164},"i":{"x":0.833,"y":0.848},"s":[371.758,305.598,0],"t":43.2,"ti":[-0.064,-0.018,0],"to":[0.069,0.021,0]},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.854},"s":[371.962,305.656,0],"t":44,"ti":[-0.056,-0.014,0],"to":[0.064,0.018,0]},{"o":{"x":0.167,"y":0.18},"i":{"x":0.833,"y":0.863},"s":[372.145,305.704,0],"t":44.8,"ti":[-0.042,-0.01,0],"to":[0.056,0.014,0]},{"o":{"x":0.167,"y":0.199},"i":{"x":0.833,"y":0.885},"s":[372.295,305.741,0],"t":45.6,"ti":[-0.025,-0.005,0],"to":[0.042,0.01,0]},{"o":{"x":0.167,"y":0.282},"i":{"x":0.833,"y":0.835},"s":[372.399,305.764,0],"t":46.4,"ti":[-0.007,-0.001,0],"to":[0.025,0.005,0]},{"s":[372.443,305.77,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":9.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":13.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":31.2},{"s":[0],"t":44}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Rectangle 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[0.012,10.621],[-5.695,5.34],[-2.557,-7.377],[3.15,-2.096]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.4745,0.8392,0.6667],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-3.421,4.043],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":23},{"ty":4,"nm":"Shape Layer 28","sr":1,"st":2.4,"op":48,"ip":2.4,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.903},"s":[94.702,122.655,100],"t":2.4},{"o":{"x":0.167,"y":0.6},"i":{"x":0.833,"y":1.272},"s":[127.289,129.977,100],"t":3.2},{"o":{"x":0.167,"y":0.064},"i":{"x":0.833,"y":0.732},"s":[132.545,85.581,100],"t":4},{"o":{"x":0.167,"y":0.121},"i":{"x":0.833,"y":0.963},"s":[110.128,50.029,100],"t":4.8},{"o":{"x":0.167,"y":-0.066},"i":{"x":0.833,"y":0.861},"s":[60.526,135.359,100],"t":5.6},{"o":{"x":0.167,"y":0.209},"i":{"x":0.833,"y":1.066},"s":[88.167,136.482,100],"t":6.4},{"o":{"x":0.167,"y":0.037},"i":{"x":0.833,"y":0.966},"s":[106.49,110.542,100],"t":7.2},{"o":{"x":0.167,"y":-0.056},"i":{"x":0.833,"y":0.936},"s":[73.621,57.227,100],"t":8},{"o":{"x":0.167,"y":-0.27},"i":{"x":0.833,"y":1.484},"s":[93.234,67.259,100],"t":8.8},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.866},"s":[88.608,126.279,100],"t":9.6},{"o":{"x":0.167,"y":0.221},"i":{"x":0.833,"y":1.185},"s":[120.076,52.9,100],"t":10.4},{"o":{"x":0.167,"y":0.057},"i":{"x":0.833,"y":0.916},"s":[139.099,69.169,100],"t":11.2},{"o":{"x":0.167,"y":6.732},"i":{"x":0.833,"y":-1.441},"s":[77.908,80.095,100],"t":12},{"o":{"x":0.167,"y":0.086},"i":{"x":0.833,"y":0.941},"s":[77.141,107.685,100],"t":12.8},{"o":{"x":0.167,"y":-0.198},"i":{"x":0.833,"y":0.598},"s":[55.437,139.887,100],"t":13.6},{"o":{"x":0.167,"y":0.105},"i":{"x":0.833,"y":0.889},"s":[61.857,102.633,100],"t":14.4},{"o":{"x":0.167,"y":0.337},"i":{"x":0.833,"y":0.557},"s":[86.378,76.933,100],"t":15.2},{"o":{"x":0.167,"y":0.103},"i":{"x":0.833,"y":1.048},"s":[94.434,93.656,100],"t":16},{"o":{"x":0.167,"y":0.03},"i":{"x":0.833,"y":0.894},"s":[129.176,79.379,100],"t":16.8},{"o":{"x":0.167,"y":0.385},"i":{"x":0.833,"y":1.003},"s":[74.62,126.637,100],"t":17.6},{"o":{"x":0.167,"y":0.003},"i":{"x":0.833,"y":0.783},"s":[59.528,96.902,100],"t":18.4},{"o":{"x":0.167,"y":0.135},"i":{"x":0.833,"y":0.987},"s":[75.163,71.778,100],"t":19.2},{"o":{"x":0.167,"y":-0.016},"i":{"x":0.833,"y":0.98},"s":[100.236,49.638,100],"t":20},{"o":{"x":0.167,"y":-0.026},"i":{"x":0.833,"y":1.196},"s":[79.183,52.988,100],"t":20.8},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.937},"s":[95.26,83.538,100],"t":21.6},{"o":{"x":0.167,"y":-0.251},"i":{"x":0.833,"y":0.998},"s":[41.321,92.009,100],"t":22.4},{"o":{"x":0.167,"y":-0.002},"i":{"x":0.833,"y":1.333},"s":[54.762,82.447,100],"t":23.2},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.996},"s":[41.586,27.852,100],"t":24},{"o":{"x":0.167,"y":-0.004},"i":{"x":0.833,"y":0.941},"s":[107.415,51.724,100],"t":24.8},{"o":{"x":0.167,"y":-0.201},"i":{"x":0.833,"y":0.942},"s":[44.413,59.172,100],"t":25.6},{"o":{"x":0.167,"y":-0.19},"i":{"x":0.833,"y":0.637},"s":[62.871,120.641,100],"t":26.4},{"o":{"x":0.167,"y":0.108},"i":{"x":0.833,"y":0.914},"s":[57.246,63.863,100],"t":27.2},{"o":{"x":0.167,"y":2.63},"i":{"x":0.833,"y":3.767},"s":[38.372,50.708,100],"t":28},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":0.822},"s":[37.754,69.059,100],"t":28.8},{"o":{"x":0.167,"y":0.156},"i":{"x":0.833,"y":0.994},"s":[58.88,85.746,100],"t":29.6},{"o":{"x":0.167,"y":-0.007},"i":{"x":0.833,"y":0.943},"s":[83,55.846,100],"t":30.4},{"o":{"x":0.167,"y":-0.184},"i":{"x":0.833,"y":1.235},"s":[60.74,29.847,100],"t":31.2},{"o":{"x":0.167,"y":0.061},"i":{"x":0.833,"y":0.881},"s":[67.668,58.5,100],"t":32},{"o":{"x":0.167,"y":0.279},"i":{"x":0.833,"y":1.257},"s":[41.227,1.342,100],"t":32.8},{"o":{"x":0.167,"y":0.063},"i":{"x":0.833,"y":0.914},"s":[29.972,34.049,100],"t":33.6},{"o":{"x":0.167,"y":2.356},"i":{"x":0.833,"y":3.558},"s":[75.997,41.447,100],"t":34.4},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":0.923},"s":[77.684,34.902,100],"t":35.2},{"o":{"x":0.167,"y":-1.086},"i":{"x":0.833,"y":1.665},"s":[24.202,32.753,100],"t":36},{"o":{"x":0.167,"y":0.074},"i":{"x":0.833,"y":1.007},"s":[28.012,28.648,100],"t":36.8},{"o":{"x":0.167,"y":0.006},"i":{"x":0.833,"y":0.981},"s":[-6.22,39.267,100],"t":37.6},{"o":{"x":0.167,"y":-0.024},"i":{"x":0.833,"y":1},"s":[30.742,74.855,100],"t":38.4},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":0.934},"s":[2.023,50.337,100],"t":39.2},{"o":{"x":0.167,"y":-0.326},"i":{"x":0.833,"y":0.727},"s":[30.77,69.402,100],"t":40},{"o":{"x":0.167,"y":0.12},"i":{"x":0.833,"y":0.902},"s":[24.92,24.502,100],"t":40.8},{"o":{"x":0.167,"y":0.55},"i":{"x":0.833,"y":2.108},"s":[11.611,6.547,100],"t":41.6},{"o":{"x":0.167,"y":0.078},"i":{"x":0.833,"y":0.948},"s":[9.235,34.159,100],"t":42.4},{"o":{"x":0.167,"y":-0.138},"i":{"x":0.833,"y":0.825},"s":[43.201,36.778,100],"t":43.2},{"o":{"x":0.167,"y":0.159},"i":{"x":0.833,"y":0.973},"s":[30.429,37.192,100],"t":44},{"o":{"x":0.167,"y":-0.039},"i":{"x":0.833,"y":0.903},"s":[16.318,43.768,100],"t":44.8},{"o":{"x":0.167,"y":0.6},"i":{"x":0.833,"y":-0.408},"s":[25.931,51.757,100],"t":45.6},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":0.833},"s":[27.481,40.555,100],"t":46.4},{"s":[52.128,20.168,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[270.565,305.387,0],"t":2.4,"ti":[0.928,2.118,0],"to":[-0.175,-0.467,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[269.518,302.585,0],"t":3.2,"ti":[2.866,4.132,0],"to":[-0.928,-2.118,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[264.999,292.679,0],"t":4,"ti":[5.573,3.332,0],"to":[-2.866,-4.132,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[252.323,277.795,0],"t":4.8,"ti":[6.454,-0.145,0],"to":[-5.573,-3.332,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[231.564,272.688,0],"t":5.6,"ti":[5.175,-2.485,0],"to":[-6.454,0.145,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[213.599,278.665,0],"t":6.4,"ti":[3.799,-3.017,0],"to":[-5.175,2.485,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[200.516,287.597,0],"t":7.2,"ti":[2.848,-2.986,0],"to":[-3.799,3.017,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[190.807,296.767,0],"t":8,"ti":[2.177,-2.823,0],"to":[-2.848,2.986,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[183.426,305.511,0],"t":8.8,"ti":[1.672,-2.64,0],"to":[-2.177,2.823,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[177.747,313.704,0],"t":9.6,"ti":[1.269,-2.465,0],"to":[-1.672,2.64,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[173.394,321.352,0],"t":10.4,"ti":[0.931,-2.298,0],"to":[-1.269,2.465,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[170.134,328.494,0],"t":11.2,"ti":[0.638,-2.135,0],"to":[-0.931,2.298,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[167.806,335.14,0],"t":12,"ti":[0.374,-1.972,0],"to":[-0.638,2.135,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[166.306,341.307,0],"t":12.8,"ti":[0.132,-1.802,0],"to":[-0.374,1.972,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[165.565,346.975,0],"t":13.6,"ti":[-0.087,-1.628,0],"to":[-0.132,1.802,0]},{"o":{"x":0.167,"y":0.021},"i":{"x":0.833,"y":0.98},"s":[165.516,352.122,0],"t":14.4,"ti":[-0.279,-1.446,0],"to":[0.087,1.628,0]},{"o":{"x":0.167,"y":0.046},"i":{"x":0.833,"y":0.959},"s":[166.088,356.74,0],"t":15.2,"ti":[-0.435,-1.255,0],"to":[0.279,1.446,0]},{"o":{"x":0.167,"y":0.07},"i":{"x":0.833,"y":0.937},"s":[167.189,360.798,0],"t":16,"ti":[-0.549,-1.065,0],"to":[0.435,1.255,0]},{"o":{"x":0.167,"y":0.092},"i":{"x":0.833,"y":0.917},"s":[168.697,364.273,0],"t":16.8,"ti":[-0.622,-0.888,0],"to":[0.549,1.065,0]},{"o":{"x":0.167,"y":0.11},"i":{"x":0.833,"y":0.9},"s":[170.482,367.189,0],"t":17.6,"ti":[-0.661,-0.731,0],"to":[0.622,0.888,0]},{"o":{"x":0.167,"y":0.125},"i":{"x":0.833,"y":0.886},"s":[172.43,369.6,0],"t":18.4,"ti":[-0.672,-0.596,0],"to":[0.661,0.731,0]},{"o":{"x":0.167,"y":0.137},"i":{"x":0.833,"y":0.875},"s":[174.447,371.574,0],"t":19.2,"ti":[-0.665,-0.483,0],"to":[0.672,0.596,0]},{"o":{"x":0.167,"y":0.145},"i":{"x":0.833,"y":0.866},"s":[176.464,373.178,0],"t":20,"ti":[-0.646,-0.39,0],"to":[0.665,0.483,0]},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.86},"s":[178.436,374.475,0],"t":20.8,"ti":[-0.62,-0.314,0],"to":[0.646,0.39,0]},{"o":{"x":0.167,"y":0.158},"i":{"x":0.833,"y":0.855},"s":[180.337,375.52,0],"t":21.6,"ti":[-0.589,-0.251,0],"to":[0.62,0.314,0]},{"o":{"x":0.167,"y":0.162},"i":{"x":0.833,"y":0.851},"s":[182.153,376.359,0],"t":22.4,"ti":[-0.557,-0.198,0],"to":[0.589,0.251,0]},{"o":{"x":0.167,"y":0.166},"i":{"x":0.833,"y":0.848},"s":[183.874,377.025,0],"t":23.2,"ti":[-0.524,-0.154,0],"to":[0.557,0.198,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.845},"s":[185.496,377.549,0],"t":24,"ti":[-0.49,-0.117,0],"to":[0.524,0.154,0]},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.843},"s":[187.016,377.951,0],"t":24.8,"ti":[-0.456,-0.086,0],"to":[0.49,0.117,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.842},"s":[188.435,378.252,0],"t":25.6,"ti":[-0.422,-0.059,0],"to":[0.456,0.086,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.842},"s":[189.752,378.465,0],"t":26.4,"ti":[-0.387,-0.035,0],"to":[0.422,0.059,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.842},"s":[190.966,378.603,0],"t":27.2,"ti":[-0.352,-0.015,0],"to":[0.387,0.035,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.843},"s":[192.076,378.677,0],"t":28,"ti":[-0.316,0.002,0],"to":[0.352,0.015,0]},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":0.844},"s":[193.079,378.696,0],"t":28.8,"ti":[-0.278,0.017,0],"to":[0.316,-0.002,0]},{"o":{"x":0.167,"y":0.178},"i":{"x":0.833,"y":0.846},"s":[193.971,378.666,0],"t":29.6,"ti":[-0.239,0.029,0],"to":[0.278,-0.017,0]},{"o":{"x":0.167,"y":0.179},"i":{"x":0.833,"y":0.85},"s":[194.747,378.596,0],"t":30.4,"ti":[-0.199,0.039,0],"to":[0.239,-0.029,0]},{"o":{"x":0.167,"y":0.179},"i":{"x":0.833,"y":0.855},"s":[195.405,378.492,0],"t":31.2,"ti":[-0.156,0.047,0],"to":[0.199,-0.039,0]},{"o":{"x":0.167,"y":0.178},"i":{"x":0.833,"y":0.865},"s":[195.939,378.361,0],"t":32,"ti":[-0.11,0.054,0],"to":[0.156,-0.047,0]},{"o":{"x":0.167,"y":0.166},"i":{"x":0.833,"y":0.883},"s":[196.341,378.209,0],"t":32.8,"ti":[-0.061,0.058,0],"to":[0.11,-0.054,0]},{"o":{"x":0.167,"y":0.106},"i":{"x":0.833,"y":0.921},"s":[196.601,378.04,0],"t":33.6,"ti":[-0.017,0.06,0],"to":[0.061,-0.058,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[196.709,377.862,0],"t":34.4,"ti":[0.003,0.066,0],"to":[0.017,-0.06,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[196.702,377.682,0],"t":35.2,"ti":[-0.001,0.08,0],"to":[-0.003,-0.066,0]},{"o":{"x":0.167,"y":0.009},"i":{"x":0.833,"y":0.989},"s":[196.693,377.464,0],"t":36,"ti":[-0.01,0.093,0],"to":[0.001,-0.08,0]},{"o":{"x":0.167,"y":0.022},"i":{"x":0.833,"y":0.975},"s":[196.709,377.203,0],"t":36.8,"ti":[-0.019,0.104,0],"to":[0.01,-0.093,0]},{"o":{"x":0.167,"y":0.034},"i":{"x":0.833,"y":0.963},"s":[196.752,376.906,0],"t":37.6,"ti":[-0.028,0.112,0],"to":[0.019,-0.104,0]},{"o":{"x":0.167,"y":0.044},"i":{"x":0.833,"y":0.952},"s":[196.823,376.58,0],"t":38.4,"ti":[-0.038,0.118,0],"to":[0.028,-0.112,0]},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.942},"s":[196.923,376.233,0],"t":39.2,"ti":[-0.049,0.122,0],"to":[0.038,-0.118,0]},{"o":{"x":0.167,"y":0.065},"i":{"x":0.833,"y":0.932},"s":[197.053,375.871,0],"t":40,"ti":[-0.059,0.124,0],"to":[0.049,-0.122,0]},{"o":{"x":0.167,"y":0.075},"i":{"x":0.833,"y":0.923},"s":[197.215,375.501,0],"t":40.8,"ti":[-0.069,0.124,0],"to":[0.059,-0.124,0]},{"o":{"x":0.167,"y":0.084},"i":{"x":0.833,"y":0.913},"s":[197.407,375.127,0],"t":41.6,"ti":[-0.079,0.122,0],"to":[0.069,-0.124,0]},{"o":{"x":0.167,"y":0.094},"i":{"x":0.833,"y":0.904},"s":[197.63,374.756,0],"t":42.4,"ti":[-0.089,0.119,0],"to":[0.079,-0.122,0]},{"o":{"x":0.167,"y":0.103},"i":{"x":0.833,"y":0.895},"s":[197.883,374.392,0],"t":43.2,"ti":[-0.099,0.115,0],"to":[0.089,-0.119,0]},{"o":{"x":0.167,"y":0.112},"i":{"x":0.833,"y":0.886},"s":[198.166,374.04,0],"t":44,"ti":[-0.108,0.109,0],"to":[0.099,-0.115,0]},{"o":{"x":0.167,"y":0.121},"i":{"x":0.833,"y":0.879},"s":[198.477,373.703,0],"t":44.8,"ti":[-0.116,0.102,0],"to":[0.108,-0.109,0]},{"o":{"x":0.167,"y":0.128},"i":{"x":0.833,"y":0.871},"s":[198.814,373.385,0],"t":45.6,"ti":[-0.124,0.095,0],"to":[0.116,-0.102,0]},{"o":{"x":0.167,"y":0.135},"i":{"x":0.833,"y":0.864},"s":[199.175,373.088,0],"t":46.4,"ti":[-0.064,0.045,0],"to":[0.124,-0.095,0]},{"s":[199.559,372.816,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":2.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":6.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":24},{"s":[0],"t":36.8}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[10,10],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.8353,0.749,1],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":24},{"ty":4,"nm":"Shape Layer 27","sr":1,"st":0.8,"op":48,"ip":0.8,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":-0.282},"s":[72.171,102.828,100],"t":0.8},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":0.885},"s":[75.523,112.995,100],"t":1.6},{"o":{"x":0.167,"y":0.304},"i":{"x":0.833,"y":1.019},"s":[123.744,153.636,100],"t":2.4},{"o":{"x":0.167,"y":0.016},"i":{"x":0.833,"y":0.693},"s":[141.925,93.916,100],"t":3.2},{"o":{"x":0.167,"y":0.114},"i":{"x":0.833,"y":0.936},"s":[119.587,65.139,100],"t":4},{"o":{"x":0.167,"y":-0.276},"i":{"x":0.833,"y":0.769},"s":[59.668,105.203,100],"t":4.8},{"o":{"x":0.167,"y":0.13},"i":{"x":0.833,"y":1.003},"s":[73.555,121.412,100],"t":5.6},{"o":{"x":0.167,"y":0.003},"i":{"x":0.833,"y":1.032},"s":[98.171,125.813,100],"t":6.4},{"o":{"x":0.167,"y":0.023},"i":{"x":0.833,"y":0.887},"s":[72.643,66.925,100],"t":7.2},{"o":{"x":0.167,"y":0.315},"i":{"x":0.833,"y":0.904},"s":[108.084,58.564,100],"t":8},{"o":{"x":0.167,"y":0.612},"i":{"x":0.833,"y":1.479},"s":[120.859,117.368,100],"t":8.8},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.764},"s":[122.874,80.731,100],"t":9.6},{"o":{"x":0.167,"y":0.129},"i":{"x":0.833,"y":0.916},"s":[109.267,103.32,100],"t":10.4},{"o":{"x":0.167,"y":12.53},"i":{"x":0.833,"y":3.633},"s":[84.332,113.266,100],"t":11.2},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":0.72},"s":[84.165,101.864,100],"t":12},{"o":{"x":0.167,"y":0.119},"i":{"x":0.833,"y":0.993},"s":[89.607,136.724,100],"t":12.8},{"o":{"x":0.167,"y":-0.007},"i":{"x":0.833,"y":0.905},"s":[102.429,122.041,100],"t":13.6},{"o":{"x":0.167,"y":0.667},"i":{"x":0.833,"y":2.566},"s":[90.653,61.798,100],"t":14.4},{"o":{"x":0.167,"y":0.079},"i":{"x":0.833,"y":1.025},"s":[88.97,83.343,100],"t":15.2},{"o":{"x":0.167,"y":0.019},"i":{"x":0.833,"y":0.879},"s":[122.282,78.321,100],"t":16},{"o":{"x":0.167,"y":0.27},"i":{"x":0.833,"y":1.099},"s":[78.796,102.131,100],"t":16.8},{"o":{"x":0.167,"y":0.045},"i":{"x":0.833,"y":0.927},"s":[59.361,112.137,100],"t":17.6},{"o":{"x":0.167,"y":-0.587},"i":{"x":0.833,"y":1.136},"s":[102.002,113.104,100],"t":18.4},{"o":{"x":0.167,"y":0.052},"i":{"x":0.833,"y":0.943},"s":[96.704,64.316,100],"t":19.2},{"o":{"x":0.167,"y":-0.183},"i":{"x":0.833,"y":0.841},"s":[110.65,98.408,100],"t":20},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.252},"s":[106.279,96.788,100],"t":20.8},{"o":{"x":0.167,"y":0.094},"i":{"x":0.833,"y":0.859},"s":[102.331,121.007,100],"t":21.6},{"o":{"x":0.167,"y":0.205},"i":{"x":0.833,"y":0.964},"s":[70.842,91.027,100],"t":22.4},{"o":{"x":0.167,"y":-0.063},"i":{"x":0.833,"y":1.045},"s":[49.193,51.754,100],"t":23.2},{"o":{"x":0.167,"y":0.029},"i":{"x":0.833,"y":0.816},"s":[61.557,57.576,100],"t":24},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":1.115},"s":[42.519,80.235,100],"t":24.8},{"o":{"x":0.167,"y":0.048},"i":{"x":0.833,"y":0.93},"s":[19.507,62.344,100],"t":25.6},{"o":{"x":0.167,"y":-0.45},"i":{"x":0.833,"y":0.463},"s":[74.401,46.72,100],"t":26.4},{"o":{"x":0.167,"y":0.099},"i":{"x":0.833,"y":0.951},"s":[65.831,31.185,100],"t":27.2},{"o":{"x":0.167,"y":-0.12},"i":{"x":0.833,"y":0.744},"s":[19.228,52.105,100],"t":28},{"o":{"x":0.167,"y":0.124},"i":{"x":0.833,"y":0.91},"s":[38.347,68.326,100],"t":28.8},{"o":{"x":0.167,"y":1.166},"i":{"x":0.833,"y":1.615},"s":[77.863,38.956,100],"t":29.6},{"o":{"x":0.167,"y":0.073},"i":{"x":0.833,"y":0.84},"s":[80.904,1.852,100],"t":30.4},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.914},"s":[55.41,69.603,100],"t":31.2},{"o":{"x":0.167,"y":2.748},"i":{"x":0.833,"y":4.375},"s":[31.879,6.237,100],"t":32},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":0.903},"s":[31.143,11.494,100],"t":32.8},{"o":{"x":0.167,"y":0.59},"i":{"x":0.833,"y":1.257},"s":[61.679,56.19,100],"t":33.6},{"o":{"x":0.167,"y":0.063},"i":{"x":0.833,"y":0.875},"s":[66.703,-15.414,100],"t":34.4},{"o":{"x":0.167,"y":0.252},"i":{"x":0.833,"y":0.777},"s":[46.165,32.254,100],"t":35.2},{"o":{"x":0.167,"y":0.133},"i":{"x":0.833,"y":1.071},"s":[36.01,-9.217,100],"t":36},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":1.042},"s":[18.977,17.016,100],"t":36.8},{"o":{"x":0.167,"y":0.028},"i":{"x":0.833,"y":0.967},"s":[50.584,43.433,100],"t":37.6},{"o":{"x":0.167,"y":-0.054},"i":{"x":0.833,"y":0.951},"s":[3.2,50.175,100],"t":38.4},{"o":{"x":0.167,"y":-0.121},"i":{"x":0.833,"y":0.826},"s":[31.978,72.587,100],"t":39.2},{"o":{"x":0.167,"y":0.16},"i":{"x":0.833,"y":0.958},"s":[20.225,43.283,100],"t":40},{"o":{"x":0.167,"y":-0.084},"i":{"x":0.833,"y":0.531},"s":[7.424,-37.423,100],"t":40.8},{"o":{"x":0.167,"y":0.101},"i":{"x":0.833,"y":0.924},"s":[13.811,28.463,100],"t":41.6},{"o":{"x":0.167,"y":-0.872},"i":{"x":0.833,"y":-0.207},"s":[43.338,42.467,100],"t":42.4},{"o":{"x":0.167,"y":0.09},"i":{"x":0.833,"y":0.956},"s":[40.761,47.811,100],"t":43.2},{"o":{"x":0.167,"y":-0.092},"i":{"x":0.833,"y":1.074},"s":[6.006,60.269,100],"t":44},{"o":{"x":0.167,"y":0.039},"i":{"x":0.833,"y":0.951},"s":[22.502,56.273,100],"t":44.8},{"o":{"x":0.167,"y":-0.12},"i":{"x":0.833,"y":0.823},"s":[-8.669,60.085,100],"t":45.6},{"o":{"x":0.167,"y":0.158},"i":{"x":0.833,"y":0.833},"s":[4.137,9.589,100],"t":46.4},{"s":[18.516,54.805,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.074},"i":{"x":0.833,"y":0.802},"s":[264.583,303.394,0],"t":0.8,"ti":[-0.732,1.703,0],"to":[0.152,-0.309,0]},{"o":{"x":0.167,"y":0.039},"i":{"x":0.833,"y":0.909},"s":[265.494,301.541,0],"t":1.6,"ti":[-1.362,4.094,0],"to":[0.732,-1.703,0]},{"o":{"x":0.167,"y":0.036},"i":{"x":0.833,"y":0.951},"s":[268.975,293.174,0],"t":2.4,"ti":[-1.445,5.76,0],"to":[1.362,-4.094,0]},{"o":{"x":0.167,"y":0.033},"i":{"x":0.833,"y":0.967},"s":[273.666,276.977,0],"t":3.2,"ti":[-1.23,5.729,0],"to":[1.445,-5.76,0]},{"o":{"x":0.167,"y":0.037},"i":{"x":0.833,"y":0.968},"s":[277.646,258.613,0],"t":4,"ti":[-1.123,4.869,0],"to":[1.23,-5.729,0]},{"o":{"x":0.167,"y":0.045},"i":{"x":0.833,"y":0.962},"s":[281.044,242.601,0],"t":4.8,"ti":[-1.146,4.013,0],"to":[1.123,-4.869,0]},{"o":{"x":0.167,"y":0.057},"i":{"x":0.833,"y":0.952},"s":[284.385,229.397,0],"t":5.6,"ti":[-1.227,3.315,0],"to":[1.146,-4.013,0]},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.939},"s":[287.919,218.524,0],"t":6.4,"ti":[-1.326,2.748,0],"to":[1.227,-3.315,0]},{"o":{"x":0.167,"y":0.087},"i":{"x":0.833,"y":0.924},"s":[291.745,209.508,0],"t":7.2,"ti":[-1.42,2.27,0],"to":[1.326,-2.748,0]},{"o":{"x":0.167,"y":0.103},"i":{"x":0.833,"y":0.908},"s":[295.873,202.037,0],"t":8,"ti":[-1.493,1.856,0],"to":[1.42,-2.27,0]},{"o":{"x":0.167,"y":0.119},"i":{"x":0.833,"y":0.893},"s":[300.264,195.89,0],"t":8.8,"ti":[-1.535,1.495,0],"to":[1.493,-1.856,0]},{"o":{"x":0.167,"y":0.133},"i":{"x":0.833,"y":0.879},"s":[304.832,190.902,0],"t":9.6,"ti":[-1.541,1.186,0],"to":[1.535,-1.495,0]},{"o":{"x":0.167,"y":0.145},"i":{"x":0.833,"y":0.868},"s":[309.473,186.917,0],"t":10.4,"ti":[-1.513,0.928,0],"to":[1.541,-1.186,0]},{"o":{"x":0.167,"y":0.153},"i":{"x":0.833,"y":0.859},"s":[314.076,183.786,0],"t":11.2,"ti":[-1.459,0.719,0],"to":[1.513,-0.928,0]},{"o":{"x":0.167,"y":0.159},"i":{"x":0.833,"y":0.854},"s":[318.551,181.352,0],"t":12,"ti":[-1.388,0.557,0],"to":[1.459,-0.719,0]},{"o":{"x":0.167,"y":0.164},"i":{"x":0.833,"y":0.849},"s":[322.832,179.47,0],"t":12.8,"ti":[-1.306,0.432,0],"to":[1.388,-0.557,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.847},"s":[326.879,178.013,0],"t":13.6,"ti":[-1.218,0.338,0],"to":[1.306,-0.432,0]},{"o":{"x":0.167,"y":0.169},"i":{"x":0.833,"y":0.845},"s":[330.667,176.878,0],"t":14.4,"ti":[-1.129,0.269,0],"to":[1.218,-0.338,0]},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.844},"s":[334.187,175.983,0],"t":15.2,"ti":[-1.043,0.219,0],"to":[1.129,-0.269,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.843},"s":[337.444,175.264,0],"t":16,"ti":[-0.959,0.182,0],"to":[1.043,-0.219,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.844},"s":[340.444,174.672,0],"t":16.8,"ti":[-0.877,0.155,0],"to":[0.959,-0.182,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.843},"s":[343.196,174.174,0],"t":17.6,"ti":[-0.798,0.134,0],"to":[0.877,-0.155,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.844},"s":[345.706,173.744,0],"t":18.4,"ti":[-0.72,0.119,0],"to":[0.798,-0.134,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.844},"s":[347.981,173.367,0],"t":19.2,"ti":[-0.644,0.106,0],"to":[0.72,-0.119,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.845},"s":[350.026,173.032,0],"t":20,"ti":[-0.57,0.094,0],"to":[0.644,-0.106,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.847},"s":[351.847,172.732,0],"t":20.8,"ti":[-0.497,0.083,0],"to":[0.57,-0.094,0]},{"o":{"x":0.167,"y":0.178},"i":{"x":0.833,"y":0.847},"s":[353.446,172.467,0],"t":21.6,"ti":[-0.429,0.075,0],"to":[0.497,-0.083,0]},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":0.842},"s":[354.827,172.237,0],"t":22.4,"ti":[-0.38,0.083,0],"to":[0.429,-0.075,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.844},"s":[356.018,172.02,0],"t":23.2,"ti":[-0.347,0.103,0],"to":[0.38,-0.083,0]},{"o":{"x":0.167,"y":0.163},"i":{"x":0.833,"y":0.847},"s":[357.106,171.74,0],"t":24,"ti":[-0.318,0.12,0],"to":[0.347,-0.103,0]},{"o":{"x":0.167,"y":0.159},"i":{"x":0.833,"y":0.851},"s":[358.103,171.404,0],"t":24.8,"ti":[-0.291,0.134,0],"to":[0.318,-0.12,0]},{"o":{"x":0.167,"y":0.154},"i":{"x":0.833,"y":0.855},"s":[359.015,171.022,0],"t":25.6,"ti":[-0.265,0.144,0],"to":[0.291,-0.134,0]},{"o":{"x":0.167,"y":0.148},"i":{"x":0.833,"y":0.86},"s":[359.846,170.603,0],"t":26.4,"ti":[-0.24,0.151,0],"to":[0.265,-0.144,0]},{"o":{"x":0.167,"y":0.142},"i":{"x":0.833,"y":0.867},"s":[360.602,170.159,0],"t":27.2,"ti":[-0.216,0.155,0],"to":[0.24,-0.151,0]},{"o":{"x":0.167,"y":0.137},"i":{"x":0.833,"y":0.872},"s":[361.284,169.698,0],"t":28,"ti":[-0.193,0.156,0],"to":[0.216,-0.155,0]},{"o":{"x":0.167,"y":0.132},"i":{"x":0.833,"y":0.878},"s":[361.896,169.23,0],"t":28.8,"ti":[-0.172,0.154,0],"to":[0.193,-0.156,0]},{"o":{"x":0.167,"y":0.126},"i":{"x":0.833,"y":0.884},"s":[362.443,168.763,0],"t":29.6,"ti":[-0.151,0.15,0],"to":[0.172,-0.154,0]},{"o":{"x":0.167,"y":0.12},"i":{"x":0.833,"y":0.89},"s":[362.927,168.306,0],"t":30.4,"ti":[-0.13,0.143,0],"to":[0.151,-0.15,0]},{"o":{"x":0.167,"y":0.115},"i":{"x":0.833,"y":0.898},"s":[363.348,167.866,0],"t":31.2,"ti":[-0.109,0.134,0],"to":[0.13,-0.143,0]},{"o":{"x":0.167,"y":0.107},"i":{"x":0.833,"y":0.904},"s":[363.707,167.448,0],"t":32,"ti":[-0.095,0.123,0],"to":[0.109,-0.134,0]},{"o":{"x":0.167,"y":0.108},"i":{"x":0.833,"y":0.901},"s":[364.004,167.059,0],"t":32.8,"ti":[-0.093,0.109,0],"to":[0.095,-0.123,0]},{"o":{"x":0.167,"y":0.117},"i":{"x":0.833,"y":0.89},"s":[364.278,166.709,0],"t":33.6,"ti":[-0.096,0.093,0],"to":[0.093,-0.109,0]},{"o":{"x":0.167,"y":0.131},"i":{"x":0.833,"y":0.878},"s":[364.562,166.405,0],"t":34.4,"ti":[-0.099,0.076,0],"to":[0.096,-0.093,0]},{"o":{"x":0.167,"y":0.143},"i":{"x":0.833,"y":0.867},"s":[364.856,166.152,0],"t":35.2,"ti":[-0.1,0.058,0],"to":[0.099,-0.076,0]},{"o":{"x":0.167,"y":0.155},"i":{"x":0.833,"y":0.856},"s":[365.154,165.951,0],"t":36,"ti":[-0.1,0.041,0],"to":[0.1,-0.058,0]},{"o":{"x":0.167,"y":0.164},"i":{"x":0.833,"y":0.846},"s":[365.455,165.803,0],"t":36.8,"ti":[-0.099,0.023,0],"to":[0.1,-0.041,0]},{"o":{"x":0.167,"y":0.169},"i":{"x":0.833,"y":0.839},"s":[365.754,165.707,0],"t":37.6,"ti":[-0.096,0.006,0],"to":[0.099,-0.023,0]},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.835},"s":[366.048,165.664,0],"t":38.4,"ti":[-0.093,-0.01,0],"to":[0.096,-0.006,0]},{"o":{"x":0.167,"y":0.165},"i":{"x":0.833,"y":0.838},"s":[366.333,165.672,0],"t":39.2,"ti":[-0.088,-0.026,0],"to":[0.093,0.01,0]},{"o":{"x":0.167,"y":0.156},"i":{"x":0.833,"y":0.846},"s":[366.605,165.727,0],"t":40,"ti":[-0.082,-0.04,0],"to":[0.088,0.026,0]},{"o":{"x":0.167,"y":0.143},"i":{"x":0.833,"y":0.857},"s":[366.86,165.827,0],"t":40.8,"ti":[-0.074,-0.052,0],"to":[0.082,0.04,0]},{"o":{"x":0.167,"y":0.128},"i":{"x":0.833,"y":0.873},"s":[367.094,165.966,0],"t":41.6,"ti":[-0.065,-0.063,0],"to":[0.074,0.052,0]},{"o":{"x":0.167,"y":0.11},"i":{"x":0.833,"y":0.891},"s":[367.302,166.14,0],"t":42.4,"ti":[-0.054,-0.071,0],"to":[0.065,0.063,0]},{"o":{"x":0.167,"y":0.091},"i":{"x":0.833,"y":0.911},"s":[367.481,166.343,0],"t":43.2,"ti":[-0.042,-0.077,0],"to":[0.054,0.071,0]},{"o":{"x":0.167,"y":0.068},"i":{"x":0.833,"y":0.934},"s":[367.625,166.567,0],"t":44,"ti":[-0.028,-0.08,0],"to":[0.042,0.077,0]},{"o":{"x":0.167,"y":0.042},"i":{"x":0.833,"y":0.96},"s":[367.73,166.804,0],"t":44.8,"ti":[-0.012,-0.079,0],"to":[0.028,0.08,0]},{"o":{"x":0.167,"y":0.009},"i":{"x":0.833,"y":0.992},"s":[367.791,167.045,0],"t":45.6,"ti":[0.003,-0.077,0],"to":[0.012,0.079,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[367.803,167.28,0],"t":46.4,"ti":[0.005,-0.038,0],"to":[-0.003,0.077,0]},{"s":[367.776,167.508,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":0.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":4.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":22.4},{"s":[0],"t":35.2}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[10,10],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.8353,0.749,1],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":25},{"ty":4,"nm":"Shape Layer 26","sr":1,"st":3.2,"op":48,"ip":3.2,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.947},"s":[97.409,66.055,100],"t":3.2},{"o":{"x":0.167,"y":-0.148},"i":{"x":0.833,"y":0.753},"s":[44.567,76.147,100],"t":4},{"o":{"x":0.167,"y":0.126},"i":{"x":0.833,"y":1.004},"s":[63.613,73.054,100],"t":4.8},{"o":{"x":0.167,"y":0.004},"i":{"x":0.833,"y":0.971},"s":[100.946,97.634,100],"t":5.6},{"o":{"x":0.167,"y":-0.045},"i":{"x":0.833,"y":0.792},"s":[61.805,70.187,100],"t":6.4},{"o":{"x":0.167,"y":0.139},"i":{"x":0.833,"y":0.951},"s":[87.307,64.612,100],"t":7.2},{"o":{"x":0.167,"y":-0.12},"i":{"x":0.833,"y":0.68},"s":[125.487,111.62,100],"t":8},{"o":{"x":0.167,"y":0.113},"i":{"x":0.833,"y":0.883},"s":[109.816,104.073,100],"t":8.8},{"o":{"x":0.167,"y":0.289},"i":{"x":0.833,"y":1.123},"s":[65.323,104.689,100],"t":9.6},{"o":{"x":0.167,"y":0.05},"i":{"x":0.833,"y":0.897},"s":[47.252,134.038,100],"t":10.4},{"o":{"x":0.167,"y":0.445},"i":{"x":0.833,"y":0.754},"s":[91.917,108.765,100],"t":11.2},{"o":{"x":0.167,"y":0.126},"i":{"x":0.833,"y":0.965},"s":[102.196,140.322,100],"t":12},{"o":{"x":0.167,"y":-0.059},"i":{"x":0.833,"y":0.598},"s":[122.314,110.374,100],"t":12.8},{"o":{"x":0.167,"y":0.105},"i":{"x":0.833,"y":0.954},"s":[110.56,62.157,100],"t":13.6},{"o":{"x":0.167,"y":-0.102},"i":{"x":0.833,"y":0.992},"s":[65.661,77.47,100],"t":14.4},{"o":{"x":0.167,"y":-0.009},"i":{"x":0.833,"y":0.964},"s":[85.871,65.321,100],"t":15.2},{"o":{"x":0.167,"y":-0.062},"i":{"x":0.833,"y":0.389},"s":[67.714,49.917,100],"t":16},{"o":{"x":0.167,"y":0.096},"i":{"x":0.833,"y":0.983},"s":[78.115,97.527,100],"t":16.8},{"o":{"x":0.167,"y":-0.021},"i":{"x":0.833,"y":0.976},"s":[143.974,113.298,100],"t":17.6},{"o":{"x":0.167,"y":-0.034},"i":{"x":0.833,"y":1.021},"s":[91.205,80.878,100],"t":18.4},{"o":{"x":0.167,"y":0.017},"i":{"x":0.833,"y":1.004},"s":[128.534,117.961,100],"t":19.2},{"o":{"x":0.167,"y":0.004},"i":{"x":0.833,"y":0.938},"s":[81.833,74.831,100],"t":20},{"o":{"x":0.167,"y":-0.245},"i":{"x":0.833,"y":0.701},"s":[130.604,103.951,100],"t":20.8},{"o":{"x":0.167,"y":0.115},"i":{"x":0.833,"y":0.848},"s":[118.24,117.585,100],"t":21.6},{"o":{"x":0.167,"y":0.185},"i":{"x":0.833,"y":0.924},"s":[86.185,91.54,100],"t":22.4},{"o":{"x":0.167,"y":-0.857},"i":{"x":0.833,"y":2.239},"s":[59.806,81.372,100],"t":23.2},{"o":{"x":0.167,"y":0.078},"i":{"x":0.833,"y":1.06},"s":[62.144,101.879,100],"t":24},{"o":{"x":0.167,"y":0.035},"i":{"x":0.833,"y":0.904},"s":[25.053,61.948,100],"t":24.8},{"o":{"x":0.167,"y":0.64},"i":{"x":0.833,"y":1.113},"s":[88.839,64.113,100],"t":25.6},{"o":{"x":0.167,"y":0.048},"i":{"x":0.833,"y":0.878},"s":[98.389,60.046,100],"t":26.4},{"o":{"x":0.167,"y":0.265},"i":{"x":0.833,"y":0.973},"s":[75.918,45.28,100],"t":27.2},{"o":{"x":0.167,"y":-0.04},"i":{"x":0.833,"y":0.487},"s":[65.601,48.361,100],"t":28},{"o":{"x":0.167,"y":0.1},"i":{"x":0.833,"y":1.02},"s":[72.571,31.73,100],"t":28.8},{"o":{"x":0.167,"y":0.016},"i":{"x":0.833,"y":0.839},"s":[108.482,26.833,100],"t":29.6},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.939},"s":[64.065,74.946,100],"t":30.4},{"o":{"x":0.167,"y":-0.226},"i":{"x":0.833,"y":0.807},"s":[22.794,25.686,100],"t":31.2},{"o":{"x":0.167,"y":0.147},"i":{"x":0.833,"y":1.039},"s":[33.918,6.407,100],"t":32},{"o":{"x":0.167,"y":0.027},"i":{"x":0.833,"y":0.952},"s":[48.539,53.893,100],"t":32.8},{"o":{"x":0.167,"y":-0.114},"i":{"x":0.833,"y":0.843},"s":[27.022,-9.839,100],"t":33.6},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":1.415},"s":[36.118,31.361,100],"t":34.4},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":1.042},"s":[44.181,-10.557,100],"t":35.2},{"o":{"x":0.167,"y":0.028},"i":{"x":0.833,"y":0.979},"s":[-4.037,-4.307,100],"t":36},{"o":{"x":0.167,"y":-0.027},"i":{"x":0.833,"y":0.945},"s":[68.255,26.661,100],"t":36.8},{"o":{"x":0.167,"y":-0.164},"i":{"x":0.833,"y":0.863},"s":[13.766,42.343,100],"t":37.6},{"o":{"x":0.167,"y":0.213},"i":{"x":0.833,"y":1.171},"s":[32.121,48.441,100],"t":38.4},{"o":{"x":0.167,"y":0.056},"i":{"x":0.833,"y":0.938},"s":[43.941,45.171,100],"t":39.2},{"o":{"x":0.167,"y":-0.238},"i":{"x":0.833,"y":0.907},"s":[7.866,-41.801,100],"t":40},{"o":{"x":0.167,"y":0.767},"i":{"x":0.833,"y":-0.765},"s":[17.231,-5.411,100],"t":40.8},{"o":{"x":0.167,"y":0.087},"i":{"x":0.833,"y":0.963},"s":[18.373,36.907,100],"t":41.6},{"o":{"x":0.167,"y":-0.066},"i":{"x":0.833,"y":1.047},"s":[41.417,41.547,100],"t":42.4},{"o":{"x":0.167,"y":0.03},"i":{"x":0.833,"y":1.142},"s":[28.526,49.618,100],"t":43.2},{"o":{"x":0.167,"y":0.053},"i":{"x":0.833,"y":0.933},"s":[48.627,48.688,100],"t":44},{"o":{"x":0.167,"y":-0.344},"i":{"x":0.833,"y":0.831},"s":[-5.742,52.477,100],"t":44.8},{"o":{"x":0.167,"y":0.164},"i":{"x":0.833,"y":0.959},"s":[4.853,21.683,100],"t":45.6},{"o":{"x":0.167,"y":-0.082},"i":{"x":0.833,"y":0.833},"s":[15.758,47.142,100],"t":46.4},{"s":[10.26,18.203,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.136},"i":{"x":0.833,"y":0.665},"s":[269.491,306.01,0],"t":3.2,"ti":[-1.762,-1.355,0],"to":[0.367,0.261,0]},{"o":{"x":0.167,"y":0.083},"i":{"x":0.833,"y":0.814},"s":[271.692,307.579,0],"t":4,"ti":[-4.055,-2.961,0],"to":[1.762,1.355,0]},{"o":{"x":0.167,"y":0.106},"i":{"x":0.833,"y":0.856},"s":[280.065,314.139,0],"t":4.8,"ti":[-5.763,-3.712,0],"to":[4.055,2.961,0]},{"o":{"x":0.167,"y":0.136},"i":{"x":0.833,"y":0.866},"s":[296.024,325.342,0],"t":5.6,"ti":[-5.909,-3.26,0],"to":[5.763,3.712,0]},{"o":{"x":0.167,"y":0.16},"i":{"x":0.833,"y":0.863},"s":[314.641,336.411,0],"t":6.4,"ti":[-5.199,-2.461,0],"to":[5.909,3.26,0]},{"o":{"x":0.167,"y":0.169},"i":{"x":0.833,"y":0.86},"s":[331.476,344.903,0],"t":7.2,"ti":[-4.435,-1.834,0],"to":[5.199,2.461,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.856},"s":[345.833,351.179,0],"t":8,"ti":[-3.802,-1.398,0],"to":[4.435,1.834,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.854},"s":[358.083,355.908,0],"t":8.8,"ti":[-3.292,-1.093,0],"to":[3.802,1.398,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.851},"s":[368.642,359.567,0],"t":9.6,"ti":[-2.886,-0.867,0],"to":[3.292,1.093,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.849},"s":[377.836,362.467,0],"t":10.4,"ti":[-2.566,-0.687,0],"to":[2.886,0.867,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.847},"s":[385.959,364.771,0],"t":11.2,"ti":[-2.306,-0.543,0],"to":[2.566,0.687,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.845},"s":[393.233,366.589,0],"t":12,"ti":[-2.085,-0.431,0],"to":[2.306,0.543,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.844},"s":[399.792,368.03,0],"t":12.8,"ti":[-1.895,-0.342,0],"to":[2.085,0.431,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.843},"s":[405.741,369.174,0],"t":13.6,"ti":[-1.729,-0.272,0],"to":[1.895,0.342,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.842},"s":[411.16,370.082,0],"t":14.4,"ti":[-1.583,-0.217,0],"to":[1.729,0.272,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.841},"s":[416.115,370.805,0],"t":15.2,"ti":[-1.452,-0.173,0],"to":[1.583,0.217,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.841},"s":[420.657,371.382,0],"t":16,"ti":[-1.335,-0.139,0],"to":[1.452,0.173,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.841},"s":[424.829,371.844,0],"t":16.8,"ti":[-1.229,-0.113,0],"to":[1.335,0.139,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.841},"s":[428.668,372.218,0],"t":17.6,"ti":[-1.131,-0.094,0],"to":[1.229,0.113,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.841},"s":[432.201,372.525,0],"t":18.4,"ti":[-1.041,-0.08,0],"to":[1.131,0.094,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.84},"s":[435.454,372.783,0],"t":19.2,"ti":[-0.958,-0.071,0],"to":[1.041,0.08,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.84},"s":[438.448,373.008,0],"t":20,"ti":[-0.88,-0.066,0],"to":[0.958,0.071,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.84},"s":[441.201,373.211,0],"t":20.8,"ti":[-0.807,-0.063,0],"to":[0.88,0.066,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.841},"s":[443.727,373.403,0],"t":21.6,"ti":[-0.738,-0.063,0],"to":[0.807,0.063,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.842},"s":[446.042,373.591,0],"t":22.4,"ti":[-0.673,-0.065,0],"to":[0.738,0.063,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.842},"s":[448.156,373.783,0],"t":23.2,"ti":[-0.611,-0.069,0],"to":[0.673,0.065,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.842},"s":[450.079,373.983,0],"t":24,"ti":[-0.552,-0.073,0],"to":[0.611,0.069,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.844},"s":[451.822,374.195,0],"t":24.8,"ti":[-0.495,-0.077,0],"to":[0.552,0.073,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.844},"s":[453.39,374.419,0],"t":25.6,"ti":[-0.44,-0.082,0],"to":[0.495,0.077,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.846},"s":[454.792,374.659,0],"t":26.4,"ti":[-0.387,-0.086,0],"to":[0.44,0.082,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.848},"s":[456.031,374.911,0],"t":27.2,"ti":[-0.336,-0.09,0],"to":[0.387,0.086,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.851},"s":[457.115,375.176,0],"t":28,"ti":[-0.286,-0.092,0],"to":[0.336,0.09,0]},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.856},"s":[458.047,375.45,0],"t":28.8,"ti":[-0.237,-0.093,0],"to":[0.286,0.092,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.862},"s":[458.831,375.73,0],"t":29.6,"ti":[-0.19,-0.093,0],"to":[0.237,0.093,0]},{"o":{"x":0.167,"y":0.163},"i":{"x":0.833,"y":0.87},"s":[459.47,376.01,0],"t":30.4,"ti":[-0.143,-0.09,0],"to":[0.19,0.093,0]},{"o":{"x":0.167,"y":0.153},"i":{"x":0.833,"y":0.883},"s":[459.968,376.286,0],"t":31.2,"ti":[-0.097,-0.085,0],"to":[0.143,0.09,0]},{"o":{"x":0.167,"y":0.131},"i":{"x":0.833,"y":0.904},"s":[460.328,376.55,0],"t":32,"ti":[-0.052,-0.077,0],"to":[0.097,0.085,0]},{"o":{"x":0.167,"y":0.075},"i":{"x":0.833,"y":0.944},"s":[460.55,376.795,0],"t":32.8,"ti":[-0.007,-0.066,0],"to":[0.052,0.077,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[460.639,377.012,0],"t":33.6,"ti":[0.032,-0.061,0],"to":[0.007,0.066,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[460.595,377.193,0],"t":34.4,"ti":[0.056,-0.069,0],"to":[-0.032,0.061,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[460.445,377.377,0],"t":35.2,"ti":[0.06,-0.083,0],"to":[-0.056,0.069,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[460.259,377.605,0],"t":36,"ti":[0.055,-0.097,0],"to":[-0.06,0.083,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[460.084,377.877,0],"t":36.8,"ti":[0.049,-0.11,0],"to":[-0.055,0.097,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[459.926,378.189,0],"t":37.6,"ti":[0.042,-0.121,0],"to":[-0.049,0.11,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[459.788,378.537,0],"t":38.4,"ti":[0.034,-0.13,0],"to":[-0.042,0.121,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[459.673,378.915,0],"t":39.2,"ti":[0.025,-0.138,0],"to":[-0.034,0.13,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[459.585,379.319,0],"t":40,"ti":[0.015,-0.145,0],"to":[-0.025,0.138,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[459.525,379.745,0],"t":40.8,"ti":[0.004,-0.15,0],"to":[-0.015,0.145,0]},{"o":{"x":0.167,"y":0.001},"i":{"x":0.833,"y":0.999},"s":[459.496,380.189,0],"t":41.6,"ti":[-0.006,-0.154,0],"to":[-0.004,0.15,0]},{"o":{"x":0.167,"y":0.013},"i":{"x":0.833,"y":0.987},"s":[459.499,380.647,0],"t":42.4,"ti":[-0.017,-0.157,0],"to":[0.006,0.154,0]},{"o":{"x":0.167,"y":0.023},"i":{"x":0.833,"y":0.976},"s":[459.535,381.115,0],"t":43.2,"ti":[-0.028,-0.158,0],"to":[0.017,0.157,0]},{"o":{"x":0.167,"y":0.034},"i":{"x":0.833,"y":0.965},"s":[459.603,381.589,0],"t":44,"ti":[-0.039,-0.159,0],"to":[0.028,0.158,0]},{"o":{"x":0.167,"y":0.045},"i":{"x":0.833,"y":0.955},"s":[459.705,382.066,0],"t":44.8,"ti":[-0.05,-0.158,0],"to":[0.039,0.159,0]},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.945},"s":[459.838,382.542,0],"t":45.6,"ti":[-0.059,-0.156,0],"to":[0.05,0.158,0]},{"o":{"x":0.167,"y":0.064},"i":{"x":0.833,"y":0.936},"s":[460.002,383.013,0],"t":46.4,"ti":[-0.032,-0.077,0],"to":[0.059,0.156,0]},{"s":[460.195,383.477,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":3.2},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":7.2},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":24.8},{"s":[0],"t":37.6}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[10,10],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.4745,0.8392,0.6667],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":26},{"ty":4,"nm":"Shape Layer 25","sr":1,"st":8,"op":48,"ip":8,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.872},"s":[110.669,116.358,100],"t":8},{"o":{"x":0.167,"y":0.239},"i":{"x":0.833,"y":1.04},"s":[59.779,98.507,100],"t":8.8},{"o":{"x":0.167,"y":0.027},"i":{"x":0.833,"y":0.934},"s":[32.558,118.992,100],"t":9.6},{"o":{"x":0.167,"y":-0.327},"i":{"x":0.833,"y":1.283},"s":[72.99,108.43,100],"t":10.4},{"o":{"x":0.167,"y":0.064},"i":{"x":0.833,"y":0.904},"s":[64.776,140.246,100],"t":11.2},{"o":{"x":0.167,"y":0.643},"i":{"x":0.833,"y":1.471},"s":[100.849,115.061,100],"t":12},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.917},"s":[106.224,64.521,100],"t":12.8},{"o":{"x":0.167,"y":-10.254},"i":{"x":0.833,"y":7.839},"s":[70.46,107.342,100],"t":13.6},{"o":{"x":0.167,"y":0.082},"i":{"x":0.833,"y":1.07},"s":[70.749,89.722,100],"t":14.4},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":0.822},"s":[46.798,35.679,100],"t":15.2},{"o":{"x":0.167,"y":0.157},"i":{"x":0.833,"y":1.002},"s":[90.882,81.249,100],"t":16},{"o":{"x":0.167,"y":0.002},"i":{"x":0.833,"y":0.942},"s":[140.894,104.127,100],"t":16.8},{"o":{"x":0.167,"y":-0.196},"i":{"x":0.833,"y":1.056},"s":[89.564,96.8,100],"t":17.6},{"o":{"x":0.167,"y":0.034},"i":{"x":0.833,"y":0.972},"s":[104.901,119.028,100],"t":18.4},{"o":{"x":0.167,"y":-0.041},"i":{"x":0.833,"y":0.839},"s":[79.173,77.868,100],"t":19.2},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":1.075},"s":[96.359,55.376,100],"t":20},{"o":{"x":0.167,"y":0.04},"i":{"x":0.833,"y":0.864},"s":[112.425,111.326,100],"t":20.8},{"o":{"x":0.167,"y":0.216},"i":{"x":0.833,"y":0.964},"s":[81.872,79.606,100],"t":21.6},{"o":{"x":0.167,"y":-0.063},"i":{"x":0.833,"y":1.136},"s":[62.674,105.212,100],"t":22.4},{"o":{"x":0.167,"y":0.052},"i":{"x":0.833,"y":1.04},"s":[73.611,91.797,100],"t":23.2},{"o":{"x":0.167,"y":0.027},"i":{"x":0.833,"y":0.897},"s":[44.883,90.141,100],"t":24},{"o":{"x":0.167,"y":0.445},"i":{"x":0.833,"y":0.864},"s":[87.448,78.456,100],"t":24.8},{"o":{"x":0.167,"y":0.216},"i":{"x":0.833,"y":0.687},"s":[97.261,88.946,100],"t":25.6},{"o":{"x":0.167,"y":0.114},"i":{"x":0.833,"y":1.172},"s":[103.41,77.55,100],"t":26.4},{"o":{"x":0.167,"y":0.056},"i":{"x":0.833,"y":1.025},"s":[120.354,63.853,100],"t":27.2},{"o":{"x":0.167,"y":0.019},"i":{"x":0.833,"y":0.939},"s":[68.478,41.315,100],"t":28},{"o":{"x":0.167,"y":-0.226},"i":{"x":0.833,"y":0.781},"s":[135.85,62.489,100],"t":28.8},{"o":{"x":0.167,"y":0.135},"i":{"x":0.833,"y":0.836},"s":[117.729,98.108,100],"t":29.6},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.955},"s":[88.261,61.749,100],"t":30.4},{"o":{"x":0.167,"y":-0.097},"i":{"x":0.833,"y":1.161},"s":[59.775,53.492,100],"t":31.2},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.92},"s":[72.912,35.197,100],"t":32},{"o":{"x":0.167,"y":-1.932},"i":{"x":0.833,"y":0.014},"s":[34.35,26.941,100],"t":32.8},{"o":{"x":0.167,"y":0.091},"i":{"x":0.833,"y":1.166},"s":[35.945,36.212,100],"t":33.6},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":1.01},"s":[53.22,25.739,100],"t":34.4},{"o":{"x":0.167,"y":0.009},"i":{"x":0.833,"y":0.967},"s":[1.613,10.927,100],"t":35.2},{"o":{"x":0.167,"y":-0.054},"i":{"x":0.833,"y":0.916},"s":[59.191,27.12,100],"t":36},{"o":{"x":0.167,"y":28.082},"i":{"x":0.833,"y":32.334},"s":[24.376,49.1,100],"t":36.8},{"o":{"x":0.167,"y":0.083},"i":{"x":0.833,"y":0.963},"s":[24.272,48.429,100],"t":37.6},{"o":{"x":0.167,"y":-0.066},"i":{"x":0.833,"y":0.911},"s":[63.337,56.778,100],"t":38.4},{"o":{"x":0.167,"y":1.325},"i":{"x":0.833,"y":-0.402},"s":[41.555,-12.234,100],"t":39.2},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":0.891},"s":[40.094,-14.365,100],"t":40},{"o":{"x":0.167,"y":0.357},"i":{"x":0.833,"y":1.348},"s":[16.969,11.25,100],"t":40.8},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.893},"s":[9.934,26.464,100],"t":41.6},{"o":{"x":0.167,"y":0.372},"i":{"x":0.833,"y":1.223},"s":[46.338,15.586,100],"t":42.4},{"o":{"x":0.167,"y":0.061},"i":{"x":0.833,"y":0.949},"s":[56.833,34.129,100],"t":43.2},{"o":{"x":0.167,"y":-0.133},"i":{"x":0.833,"y":0.872},"s":[18.206,6.413,100],"t":44},{"o":{"x":0.167,"y":0.239},"i":{"x":0.833,"y":1.098},"s":[33.108,26.401,100],"t":44.8},{"o":{"x":0.167,"y":0.045},"i":{"x":0.833,"y":0.855},"s":[41.083,52.674,100],"t":45.6},{"o":{"x":0.167,"y":0.195},"i":{"x":0.833,"y":0.833},"s":[23.746,52.627,100],"t":46.4},{"s":[10.82,-18.691,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.154},"i":{"x":0.833,"y":0.623},"s":[269.753,298.518,0],"t":8,"ti":[-1.794,0.84,0],"to":[0.371,-0.157,0]},{"o":{"x":0.167,"y":0.095},"i":{"x":0.833,"y":0.787},"s":[271.976,297.574,0],"t":8.8,"ti":[-3.913,2.158,0],"to":[1.794,-0.84,0]},{"o":{"x":0.167,"y":0.111},"i":{"x":0.833,"y":0.849},"s":[280.516,293.478,0],"t":9.6,"ti":[-5.148,3.28,0],"to":[3.913,-2.158,0]},{"o":{"x":0.167,"y":0.131},"i":{"x":0.833,"y":0.871},"s":[295.452,284.625,0],"t":10.4,"ti":[-4.973,3.376,0],"to":[5.148,-3.28,0]},{"o":{"x":0.167,"y":0.148},"i":{"x":0.833,"y":0.873},"s":[311.406,273.799,0],"t":11.2,"ti":[-4.286,2.798,0],"to":[4.973,-3.376,0]},{"o":{"x":0.167,"y":0.156},"i":{"x":0.833,"y":0.87},"s":[325.289,264.369,0],"t":12,"ti":[-3.685,2.155,0],"to":[4.286,-2.798,0]},{"o":{"x":0.167,"y":0.161},"i":{"x":0.833,"y":0.865},"s":[337.123,257.014,0],"t":12.8,"ti":[-3.222,1.625,0],"to":[3.685,-2.155,0]},{"o":{"x":0.167,"y":0.164},"i":{"x":0.833,"y":0.859},"s":[347.398,251.439,0],"t":13.6,"ti":[-2.85,1.213,0],"to":[3.222,-1.625,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.854},"s":[356.453,247.262,0],"t":14.4,"ti":[-2.541,0.896,0],"to":[2.85,-1.213,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.85},"s":[364.5,244.163,0],"t":15.2,"ti":[-2.276,0.656,0],"to":[2.541,-0.896,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.847},"s":[371.696,241.885,0],"t":16,"ti":[-2.047,0.474,0],"to":[2.276,-0.656,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.845},"s":[378.157,240.228,0],"t":16.8,"ti":[-1.845,0.337,0],"to":[2.047,-0.474,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.844},"s":[383.976,239.042,0],"t":17.6,"ti":[-1.666,0.235,0],"to":[1.845,-0.337,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.843},"s":[389.227,238.206,0],"t":18.4,"ti":[-1.505,0.161,0],"to":[1.666,-0.235,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.842},"s":[393.971,237.63,0],"t":19.2,"ti":[-1.361,0.108,0],"to":[1.505,-0.161,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.841},"s":[398.259,237.241,0],"t":20,"ti":[-1.229,0.074,0],"to":[1.361,-0.108,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.841},"s":[402.134,236.98,0],"t":20.8,"ti":[-1.111,0.051,0],"to":[1.229,-0.074,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.841},"s":[405.636,236.799,0],"t":21.6,"ti":[-1.01,0.021,0],"to":[1.111,-0.051,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.84},"s":[408.801,236.672,0],"t":22.4,"ti":[-0.926,-0.021,0],"to":[1.01,-0.021,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.84},"s":[411.696,236.673,0],"t":23.2,"ti":[-0.853,-0.06,0],"to":[0.926,0.021,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.84},"s":[414.357,236.801,0],"t":24,"ti":[-0.787,-0.092,0],"to":[0.853,0.06,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.841},"s":[416.812,237.033,0],"t":24.8,"ti":[-0.729,-0.118,0],"to":[0.787,0.092,0]},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.842},"s":[419.082,237.352,0],"t":25.6,"ti":[-0.677,-0.139,0],"to":[0.729,0.118,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.842},"s":[421.188,237.741,0],"t":26.4,"ti":[-0.631,-0.156,0],"to":[0.677,0.139,0]},{"o":{"x":0.167,"y":0.166},"i":{"x":0.833,"y":0.844},"s":[423.146,238.187,0],"t":27.2,"ti":[-0.589,-0.169,0],"to":[0.631,0.156,0]},{"o":{"x":0.167,"y":0.163},"i":{"x":0.833,"y":0.845},"s":[424.973,238.678,0],"t":28,"ti":[-0.552,-0.179,0],"to":[0.589,0.169,0]},{"o":{"x":0.167,"y":0.162},"i":{"x":0.833,"y":0.847},"s":[426.682,239.204,0],"t":28.8,"ti":[-0.518,-0.186,0],"to":[0.552,0.179,0]},{"o":{"x":0.167,"y":0.16},"i":{"x":0.833,"y":0.847},"s":[428.285,239.754,0],"t":29.6,"ti":[-0.488,-0.19,0],"to":[0.518,0.186,0]},{"o":{"x":0.167,"y":0.158},"i":{"x":0.833,"y":0.849},"s":[429.793,240.32,0],"t":30.4,"ti":[-0.46,-0.192,0],"to":[0.488,0.19,0]},{"o":{"x":0.167,"y":0.157},"i":{"x":0.833,"y":0.85},"s":[431.212,240.895,0],"t":31.2,"ti":[-0.433,-0.191,0],"to":[0.46,0.192,0]},{"o":{"x":0.167,"y":0.156},"i":{"x":0.833,"y":0.852},"s":[432.55,241.471,0],"t":32,"ti":[-0.408,-0.188,0],"to":[0.433,0.191,0]},{"o":{"x":0.167,"y":0.155},"i":{"x":0.833,"y":0.853},"s":[433.811,242.041,0],"t":32.8,"ti":[-0.384,-0.184,0],"to":[0.408,0.188,0]},{"o":{"x":0.167,"y":0.154},"i":{"x":0.833,"y":0.854},"s":[434.998,242.6,0],"t":33.6,"ti":[-0.36,-0.177,0],"to":[0.384,0.184,0]},{"o":{"x":0.167,"y":0.154},"i":{"x":0.833,"y":0.856},"s":[436.114,243.143,0],"t":34.4,"ti":[-0.337,-0.169,0],"to":[0.36,0.177,0]},{"o":{"x":0.167,"y":0.154},"i":{"x":0.833,"y":0.856},"s":[437.16,243.663,0],"t":35.2,"ti":[-0.314,-0.159,0],"to":[0.337,0.169,0]},{"o":{"x":0.167,"y":0.154},"i":{"x":0.833,"y":0.857},"s":[438.136,244.156,0],"t":36,"ti":[-0.29,-0.148,0],"to":[0.314,0.159,0]},{"o":{"x":0.167,"y":0.155},"i":{"x":0.833,"y":0.858},"s":[439.041,244.617,0],"t":36.8,"ti":[-0.265,-0.135,0],"to":[0.29,0.148,0]},{"o":{"x":0.167,"y":0.156},"i":{"x":0.833,"y":0.859},"s":[439.873,245.043,0],"t":37.6,"ti":[-0.239,-0.121,0],"to":[0.265,0.135,0]},{"o":{"x":0.167,"y":0.158},"i":{"x":0.833,"y":0.861},"s":[440.629,245.429,0],"t":38.4,"ti":[-0.211,-0.106,0],"to":[0.239,0.121,0]},{"o":{"x":0.167,"y":0.16},"i":{"x":0.833,"y":0.859},"s":[441.306,245.771,0],"t":39.2,"ti":[-0.188,-0.091,0],"to":[0.211,0.106,0]},{"o":{"x":0.167,"y":0.16},"i":{"x":0.833,"y":0.854},"s":[441.897,246.067,0],"t":40,"ti":[-0.176,-0.076,0],"to":[0.188,0.091,0]},{"o":{"x":0.167,"y":0.16},"i":{"x":0.833,"y":0.852},"s":[442.436,246.318,0],"t":40.8,"ti":[-0.167,-0.062,0],"to":[0.176,0.076,0]},{"o":{"x":0.167,"y":0.165},"i":{"x":0.833,"y":0.851},"s":[442.952,246.526,0],"t":41.6,"ti":[-0.154,-0.046,0],"to":[0.167,0.062,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.85},"s":[443.435,246.688,0],"t":42.4,"ti":[-0.137,-0.029,0],"to":[0.154,0.046,0]},{"o":{"x":0.167,"y":0.179},"i":{"x":0.833,"y":0.851},"s":[443.874,246.8,0],"t":43.2,"ti":[-0.117,-0.011,0],"to":[0.137,0.029,0]},{"o":{"x":0.167,"y":0.186},"i":{"x":0.833,"y":0.853},"s":[444.258,246.86,0],"t":44,"ti":[-0.092,0.008,0],"to":[0.117,0.011,0]},{"o":{"x":0.167,"y":0.187},"i":{"x":0.833,"y":0.854},"s":[444.574,246.866,0],"t":44.8,"ti":[-0.065,0.028,0],"to":[0.092,-0.008,0]},{"o":{"x":0.167,"y":0.15},"i":{"x":0.833,"y":0.847},"s":[444.81,246.814,0],"t":45.6,"ti":[-0.052,0.051,0],"to":[0.065,-0.028,0]},{"o":{"x":0.167,"y":0.095},"i":{"x":0.833,"y":0.893},"s":[444.965,246.7,0],"t":46.4,"ti":[-0.027,0.032,0],"to":[0.052,-0.051,0]},{"s":[445.124,246.509,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":12},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":29.6},{"s":[0],"t":42.4}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[10,10],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.8353,0.749,1],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":27},{"ty":4,"nm":"Shape Layer 24","sr":1,"st":5.6,"op":48,"ip":5.6,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":1.856},"s":[67.557,101.258,100],"t":5.6},{"o":{"x":0.167,"y":0.076},"i":{"x":0.833,"y":0.965},"s":[62.081,60.567,100],"t":6.4},{"o":{"x":0.167,"y":-0.062},"i":{"x":0.833,"y":0.899},"s":[123.801,89.604,100],"t":7.2},{"o":{"x":0.167,"y":0.485},"i":{"x":0.833,"y":0.652},"s":[88.344,110.822,100],"t":8},{"o":{"x":0.167,"y":0.11},"i":{"x":0.833,"y":0.902},"s":[80.981,89.674,100],"t":8.8},{"o":{"x":0.167,"y":0.569},"i":{"x":0.833,"y":1.494},"s":[57.576,88.067,100],"t":9.6},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.815},"s":[53.56,101.12,100],"t":10.4},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":1.035},"s":[81.37,114.583,100],"t":11.2},{"o":{"x":0.167,"y":0.025},"i":{"x":0.833,"y":0.939},"s":[115.142,82.186,100],"t":12},{"o":{"x":0.167,"y":-0.235},"i":{"x":0.833,"y":1.154},"s":[67.083,110.768,100],"t":12.8},{"o":{"x":0.167,"y":0.054},"i":{"x":0.833,"y":1.037},"s":[79.677,116.611,100],"t":13.6},{"o":{"x":0.167,"y":0.026},"i":{"x":0.833,"y":0.885},"s":[43.885,79.546,100],"t":14.4},{"o":{"x":0.167,"y":0.301},"i":{"x":0.833,"y":0.972},"s":[95.707,49.721,100],"t":15.2},{"o":{"x":0.167,"y":-0.043},"i":{"x":0.833,"y":0.783},"s":[115.579,101.629,100],"t":16},{"o":{"x":0.167,"y":0.135},"i":{"x":0.833,"y":0.957},"s":[102.439,106.687,100],"t":16.8},{"o":{"x":0.167,"y":-0.087},"i":{"x":0.833,"y":0.875},"s":[81.407,137.444,100],"t":17.6},{"o":{"x":0.167,"y":0.25},"i":{"x":0.833,"y":0.844},"s":[91.687,108.575,100],"t":18.4},{"o":{"x":0.167,"y":0.178},"i":{"x":0.833,"y":1.4},"s":[96.813,65.889,100],"t":19.2},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":0.924},"s":[101.302,98.9,100],"t":20},{"o":{"x":0.167,"y":-0.902},"i":{"x":0.833,"y":1.186},"s":[75.267,62.121,100],"t":20.8},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.894},"s":[77.47,105.409,100],"t":21.6},{"o":{"x":0.167,"y":0.393},"i":{"x":0.833,"y":1.167},"s":[70.35,111.04,100],"t":22.4},{"o":{"x":0.167,"y":0.056},"i":{"x":0.833,"y":0.394},"s":[68.432,113.069,100],"t":23.2},{"o":{"x":0.167,"y":0.097},"i":{"x":0.833,"y":0.999},"s":[74.202,79.548,100],"t":24},{"o":{"x":0.167,"y":-0.001},"i":{"x":0.833,"y":0.979},"s":[110.376,76.788,100],"t":24.8},{"o":{"x":0.167,"y":-0.029},"i":{"x":0.833,"y":1.071},"s":[74.587,98.699,100],"t":25.6},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":1.005},"s":[101.235,82.443,100],"t":26.4},{"o":{"x":0.167,"y":0.004},"i":{"x":0.833,"y":0.897},"s":[51.784,49.555,100],"t":27.2},{"o":{"x":0.167,"y":0.43},"i":{"x":0.833,"y":0.916},"s":[103.982,40.922,100],"t":28},{"o":{"x":0.167,"y":6.077},"i":{"x":0.833,"y":22.316},"s":[116.519,59.525,100],"t":28.8},{"o":{"x":0.167,"y":0.083},"i":{"x":0.833,"y":0.868},"s":[116.693,44.996,100],"t":29.6},{"o":{"x":0.167,"y":0.226},"i":{"x":0.833,"y":0.915},"s":[71.936,84.414,100],"t":30.4},{"o":{"x":0.167,"y":4.525},"i":{"x":0.833,"y":-0.19},"s":[45.732,21.041,100],"t":31.2},{"o":{"x":0.167,"y":0.09},"i":{"x":0.833,"y":0.945},"s":[45.24,32.32,100],"t":32},{"o":{"x":0.167,"y":-0.16},"i":{"x":0.833,"y":2.147},"s":[38.713,14.915,100],"t":32.8},{"o":{"x":0.167,"y":0.078},"i":{"x":0.833,"y":1.02},"s":[40.945,10.011,100],"t":33.6},{"o":{"x":0.167,"y":0.016},"i":{"x":0.833,"y":0.96},"s":[7.998,4.532,100],"t":34.4},{"o":{"x":0.167,"y":-0.078},"i":{"x":0.833,"y":0.811},"s":[48.948,-0.907,100],"t":35.2},{"o":{"x":0.167,"y":0.149},"i":{"x":0.833,"y":0.977},"s":[27.778,23.742,100],"t":36},{"o":{"x":0.167,"y":-0.033},"i":{"x":0.833,"y":0.789},"s":[0.947,21.32,100],"t":36.8},{"o":{"x":0.167,"y":0.138},"i":{"x":0.833,"y":0.934},"s":[20.246,55.394,100],"t":37.6},{"o":{"x":0.167,"y":-0.317},"i":{"x":0.833,"y":0.839},"s":[49.89,6.617,100],"t":38.4},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.533},"s":[43.72,-1.776,100],"t":39.2},{"o":{"x":0.167,"y":0.101},"i":{"x":0.833,"y":0.939},"s":[37.975,13.785,100],"t":40},{"o":{"x":0.167,"y":-0.234},"i":{"x":0.833,"y":0.517},"s":[11.499,16.406,100],"t":40.8},{"o":{"x":0.167,"y":0.101},"i":{"x":0.833,"y":0.963},"s":[18.462,-8.949,100],"t":41.6},{"o":{"x":0.167,"y":-0.068},"i":{"x":0.833,"y":1.022},"s":[51.821,29.36,100],"t":42.4},{"o":{"x":0.167,"y":0.017},"i":{"x":0.833,"y":0.996},"s":[33.392,1.359,100],"t":43.2},{"o":{"x":0.167,"y":-0.004},"i":{"x":0.833,"y":0.888},"s":[56.645,-3.016,100],"t":44},{"o":{"x":0.167,"y":0.324},"i":{"x":0.833,"y":0.486},"s":[34.461,37.994,100],"t":44.8},{"o":{"x":0.167,"y":0.099},"i":{"x":0.833,"y":1.009},"s":[26.772,63.226,100],"t":45.6},{"o":{"x":0.167,"y":0.008},"i":{"x":0.833,"y":0.833},"s":[-12.998,42.488,100],"t":46.4},{"s":[31.14,31.954,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[265.04,301.431,0],"t":5.6,"ti":[1.527,0.877,0],"to":[-0.341,-0.143,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[262.993,300.574,0],"t":6.4,"ti":[3.095,2.404,0],"to":[-1.527,-0.877,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[255.881,296.17,0],"t":7.2,"ti":[3.636,3.902,0],"to":[-3.095,-2.404,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[244.425,286.149,0],"t":8,"ti":[2.978,4.369,0],"to":[-3.636,-3.902,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[234.064,272.758,0],"t":8.8,"ti":[2.214,3.975,0],"to":[-2.978,-4.369,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[226.554,259.936,0],"t":9.6,"ti":[1.769,3.38,0],"to":[-2.214,-3.975,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[220.781,248.906,0],"t":10.4,"ti":[1.52,2.839,0],"to":[-1.769,-3.38,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[215.943,239.657,0],"t":11.2,"ti":[1.364,2.397,0],"to":[-1.52,-2.839,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[211.658,231.874,0],"t":12,"ti":[1.247,2.04,0],"to":[-1.364,-2.397,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[207.761,225.273,0],"t":12.8,"ti":[1.147,1.749,0],"to":[-1.247,-2.04,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[204.179,219.632,0],"t":13.6,"ti":[1.054,1.508,0],"to":[-1.147,-1.749,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[200.881,214.781,0],"t":14.4,"ti":[0.966,1.308,0],"to":[-1.054,-1.508,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[197.852,210.583,0],"t":15.2,"ti":[0.881,1.139,0],"to":[-0.966,-1.308,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[195.083,206.935,0],"t":16,"ti":[0.798,0.996,0],"to":[-0.881,-1.139,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[192.565,203.748,0],"t":16.8,"ti":[0.718,0.875,0],"to":[-0.798,-0.996,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[190.293,200.956,0],"t":17.6,"ti":[0.64,0.771,0],"to":[-0.718,-0.875,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[188.258,198.5,0],"t":18.4,"ti":[0.565,0.681,0],"to":[-0.64,-0.771,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[186.453,196.332,0],"t":19.2,"ti":[0.494,0.604,0],"to":[-0.565,-0.681,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[184.867,194.413,0],"t":20,"ti":[0.425,0.537,0],"to":[-0.494,-0.604,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[183.491,192.71,0],"t":20.8,"ti":[0.361,0.479,0],"to":[-0.425,-0.537,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[182.314,191.193,0],"t":21.6,"ti":[0.301,0.428,0],"to":[-0.361,-0.479,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[181.325,189.838,0],"t":22.4,"ti":[0.244,0.384,0],"to":[-0.301,-0.428,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[180.511,188.625,0],"t":23.2,"ti":[0.192,0.346,0],"to":[-0.244,-0.384,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[179.859,187.534,0],"t":24,"ti":[0.145,0.312,0],"to":[-0.192,-0.346,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[179.357,186.551,0],"t":24.8,"ti":[0.103,0.284,0],"to":[-0.145,-0.312,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[178.99,185.66,0],"t":25.6,"ti":[0.066,0.259,0],"to":[-0.103,-0.284,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[178.741,184.85,0],"t":26.4,"ti":[0.034,0.238,0],"to":[-0.066,-0.259,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[178.596,184.107,0],"t":27.2,"ti":[0.008,0.219,0],"to":[-0.034,-0.238,0]},{"o":{"x":0.167,"y":0.002},"i":{"x":0.833,"y":0.998},"s":[178.536,183.424,0],"t":28,"ti":[-0.011,0.204,0],"to":[-0.008,-0.219,0]},{"o":{"x":0.167,"y":0.017},"i":{"x":0.833,"y":0.984},"s":[178.545,182.791,0],"t":28.8,"ti":[-0.025,0.191,0],"to":[0.011,-0.204,0]},{"o":{"x":0.167,"y":0.028},"i":{"x":0.833,"y":0.973},"s":[178.604,182.2,0],"t":29.6,"ti":[-0.033,0.18,0],"to":[0.025,-0.191,0]},{"o":{"x":0.167,"y":0.033},"i":{"x":0.833,"y":0.968},"s":[178.696,181.645,0],"t":30.4,"ti":[-0.033,0.171,0],"to":[0.033,-0.18,0]},{"o":{"x":0.167,"y":0.033},"i":{"x":0.833,"y":0.969},"s":[178.8,181.121,0],"t":31.2,"ti":[-0.027,0.163,0],"to":[0.033,-0.171,0]},{"o":{"x":0.167,"y":0.024},"i":{"x":0.833,"y":0.977},"s":[178.897,180.622,0],"t":32,"ti":[-0.014,0.157,0],"to":[0.027,-0.163,0]},{"o":{"x":0.167,"y":0.006},"i":{"x":0.833,"y":0.994},"s":[178.964,180.143,0],"t":32.8,"ti":[-0.002,0.154,0],"to":[0.014,-0.157,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[178.981,179.68,0],"t":33.6,"ti":[-0.011,0.158,0],"to":[0.002,-0.154,0]},{"o":{"x":0.167,"y":0.023},"i":{"x":0.833,"y":0.976},"s":[178.978,179.217,0],"t":34.4,"ti":[-0.033,0.162,0],"to":[0.011,-0.158,0]},{"o":{"x":0.167,"y":0.042},"i":{"x":0.833,"y":0.957},"s":[179.048,178.732,0],"t":35.2,"ti":[-0.051,0.161,0],"to":[0.033,-0.162,0]},{"o":{"x":0.167,"y":0.057},"i":{"x":0.833,"y":0.943},"s":[179.179,178.243,0],"t":36,"ti":[-0.064,0.155,0],"to":[0.051,-0.161,0]},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.932},"s":[179.355,177.765,0],"t":36.8,"ti":[-0.069,0.148,0],"to":[0.064,-0.155,0]},{"o":{"x":0.167,"y":0.072},"i":{"x":0.833,"y":0.931},"s":[179.564,177.312,0],"t":37.6,"ti":[-0.061,0.142,0],"to":[0.069,-0.148,0]},{"o":{"x":0.167,"y":0.062},"i":{"x":0.833,"y":0.943},"s":[179.767,176.879,0],"t":38.4,"ti":[-0.046,0.136,0],"to":[0.061,-0.142,0]},{"o":{"x":0.167,"y":0.047},"i":{"x":0.833,"y":0.957},"s":[179.929,176.457,0],"t":39.2,"ti":[-0.028,0.126,0],"to":[0.046,-0.136,0]},{"o":{"x":0.167,"y":0.028},"i":{"x":0.833,"y":0.976},"s":[180.041,176.061,0],"t":40,"ti":[-0.009,0.113,0],"to":[0.028,-0.126,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[180.098,175.7,0],"t":40.8,"ti":[0.012,0.096,0],"to":[0.009,-0.113,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[180.095,175.385,0],"t":41.6,"ti":[0.034,0.077,0],"to":[-0.012,-0.096,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[180.027,175.124,0],"t":42.4,"ti":[0.057,0.055,0],"to":[-0.034,-0.077,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[179.891,174.924,0],"t":43.2,"ti":[0.08,0.032,0],"to":[-0.057,-0.055,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[179.687,174.792,0],"t":44,"ti":[0.103,0.008,0],"to":[-0.08,-0.032,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[179.413,174.732,0],"t":44.8,"ti":[0.125,-0.018,0],"to":[-0.103,-0.008,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[179.07,174.747,0],"t":45.6,"ti":[0.147,-0.043,0],"to":[-0.125,0.018,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[178.66,174.838,0],"t":46.4,"ti":[0.079,-0.028,0],"to":[-0.147,0.043,0]},{"s":[178.187,175.006,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":5.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":9.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":27.2},{"s":[0],"t":40}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[10,10],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.4745,0.8392,0.6667],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":28},{"ty":4,"nm":"Shape Layer 23","sr":1,"st":4,"op":48,"ip":4,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.657},"s":[122.178,94.449,100],"t":4},{"o":{"x":0.167,"y":0.11},"i":{"x":0.833,"y":0.995},"s":[102.174,113.837,100],"t":4.8},{"o":{"x":0.167,"y":-0.005},"i":{"x":0.833,"y":0.918},"s":[39.796,99.783,100],"t":5.6},{"o":{"x":0.167,"y":-5.85},"i":{"x":0.833,"y":3.373},"s":[98.461,58.708,100],"t":6.4},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":1.007},"s":[97.637,98.226,100],"t":7.2},{"o":{"x":0.167,"y":0.006},"i":{"x":0.833,"y":0.861},"s":[121.922,85.826,100],"t":8},{"o":{"x":0.167,"y":0.208},"i":{"x":0.833,"y":0.953},"s":[95.646,85.311,100],"t":8.8},{"o":{"x":0.167,"y":-0.109},"i":{"x":0.833,"y":0.37},"s":[78.043,76.794,100],"t":9.6},{"o":{"x":0.167,"y":0.096},"i":{"x":0.833,"y":1.019},"s":[85.681,102.643,100],"t":10.4},{"o":{"x":0.167,"y":0.016},"i":{"x":0.833,"y":0.951},"s":[135.804,103.775,100],"t":11.2},{"o":{"x":0.167,"y":-0.12},"i":{"x":0.833,"y":0.984},"s":[74.18,98.145,100],"t":12},{"o":{"x":0.167,"y":-0.019},"i":{"x":0.833,"y":1.067},"s":[99.49,115.703,100],"t":12.8},{"o":{"x":0.167,"y":0.037},"i":{"x":0.833,"y":0.975},"s":[78.946,120.079,100],"t":13.6},{"o":{"x":0.167,"y":-0.036},"i":{"x":0.833,"y":0.978},"s":[115.943,47.625,100],"t":14.4},{"o":{"x":0.167,"y":-0.029},"i":{"x":0.833,"y":1.04},"s":[90.116,69.173,100],"t":15.2},{"o":{"x":0.167,"y":0.027},"i":{"x":0.833,"y":1.011},"s":[109.209,130.363,100],"t":16},{"o":{"x":0.167,"y":0.01},"i":{"x":0.833,"y":0.972},"s":[80.945,147.149,100],"t":16.8},{"o":{"x":0.167,"y":-0.043},"i":{"x":0.833,"y":1.048},"s":[112.856,117.083,100],"t":17.6},{"o":{"x":0.167,"y":0.03},"i":{"x":0.833,"y":1.002},"s":[91.758,113.226,100],"t":18.4},{"o":{"x":0.167,"y":0.002},"i":{"x":0.833,"y":0.913},"s":[124.953,107.402,100],"t":19.2},{"o":{"x":0.167,"y":1.871},"i":{"x":0.833,"y":-0.03},"s":[90.896,86.565,100],"t":20},{"o":{"x":0.167,"y":0.091},"i":{"x":0.833,"y":1.06},"s":[89.309,96.814,100],"t":20.8},{"o":{"x":0.167,"y":0.035},"i":{"x":0.833,"y":0.994},"s":[71.266,127.218,100],"t":21.6},{"o":{"x":0.167,"y":-0.007},"i":{"x":0.833,"y":1.064},"s":[102.251,147.752,100],"t":22.4},{"o":{"x":0.167,"y":0.036},"i":{"x":0.833,"y":1.023},"s":[73.55,78.754,100],"t":23.2},{"o":{"x":0.167,"y":0.018},"i":{"x":0.833,"y":0.89},"s":[124.448,72.546,100],"t":24},{"o":{"x":0.167,"y":0.347},"i":{"x":0.833,"y":0.937},"s":[59.508,90.091,100],"t":24.8},{"o":{"x":0.167,"y":-0.254},"i":{"x":0.833,"y":0.122},"s":[39,90.083,100],"t":25.6},{"o":{"x":0.167,"y":0.092},"i":{"x":0.833,"y":0.937},"s":[44.062,72.23,100],"t":26.4},{"o":{"x":0.167,"y":-0.262},"i":{"x":0.833,"y":1.05},"s":[92.349,38.4,100],"t":27.2},{"o":{"x":0.167,"y":0.031},"i":{"x":0.833,"y":1.058},"s":[80.711,40.702,100],"t":28},{"o":{"x":0.167,"y":0.034},"i":{"x":0.833,"y":0.872},"s":[99.332,43.228,100],"t":28.8},{"o":{"x":0.167,"y":0.238},"i":{"x":0.833,"y":0.945},"s":[67.744,96.178,100],"t":29.6},{"o":{"x":0.167,"y":-0.16},"i":{"x":0.833,"y":0.837},"s":[50.721,69.109,100],"t":30.4},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.787},"s":[56.555,71.779,100],"t":31.2},{"o":{"x":0.167,"y":0.137},"i":{"x":0.833,"y":1.453},"s":[62.129,50.654,100],"t":32},{"o":{"x":0.167,"y":0.07},"i":{"x":0.833,"y":0.984},"s":[70.779,19.084,100],"t":32.8},{"o":{"x":0.167,"y":-0.02},"i":{"x":0.833,"y":0.921},"s":[15.062,-11.663,100],"t":33.6},{"o":{"x":0.167,"y":-1.554},"i":{"x":0.833,"y":-0.296},"s":[59.871,-21.902,100],"t":34.4},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":0.84},"s":[57.59,-8.938,100],"t":35.2},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":1.049},"s":[24.406,-20.323,100],"t":36},{"o":{"x":0.167,"y":0.031},"i":{"x":0.833,"y":0.912},"s":[-6.116,25.019,100],"t":36.8},{"o":{"x":0.167,"y":1.626},"i":{"x":0.833,"y":0.989},"s":[42.39,11.059,100],"t":37.6},{"o":{"x":0.167,"y":-0.013},"i":{"x":0.833,"y":1.274},"s":[45.011,-1.68,100],"t":38.4},{"o":{"x":0.167,"y":0.064},"i":{"x":0.833,"y":1.577},"s":[42.735,24.617,100],"t":39.2},{"o":{"x":0.167,"y":0.073},"i":{"x":0.833,"y":0.975},"s":[52.491,40.139,100],"t":40},{"o":{"x":0.167,"y":-0.036},"i":{"x":0.833,"y":0.91},"s":[-24.813,18.208,100],"t":40.8},{"o":{"x":0.167,"y":1.154},"i":{"x":0.833,"y":0.149},"s":[29.263,22.673,100],"t":41.6},{"o":{"x":0.167,"y":0.092},"i":{"x":0.833,"y":1.047},"s":[33.471,25.402,100],"t":42.4},{"o":{"x":0.167,"y":0.03},"i":{"x":0.833,"y":0.891},"s":[72.245,-1.354,100],"t":43.2},{"o":{"x":0.167,"y":0.355},"i":{"x":0.833,"y":0.937},"s":[11.503,13.161,100],"t":44},{"o":{"x":0.167,"y":-0.26},"i":{"x":0.833,"y":0.127},"s":[-7.15,35.893,100],"t":44.8},{"o":{"x":0.167,"y":0.092},"i":{"x":0.833,"y":0.908},"s":[-2.619,63.648,100],"t":45.6},{"o":{"x":0.167,"y":0.867},"i":{"x":0.833,"y":0.833},"s":[40.328,63.147,100],"t":46.4},{"s":[44.897,46.852,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[261.789,302.009,0],"t":4,"ti":[0.71,2.293,0],"to":[-0.181,-0.464,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[260.702,299.226,0],"t":4.8,"ti":[1.003,5.268,0],"to":[-0.71,-2.293,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[257.531,288.249,0],"t":5.6,"ti":[0.104,7.272,0],"to":[-1.003,-5.268,0]},{"o":{"x":0.167,"y":0.015},"i":{"x":0.833,"y":0.985},"s":[254.686,267.621,0],"t":6.4,"ti":[-1.513,7.003,0],"to":[-0.104,-7.272,0]},{"o":{"x":0.167,"y":0.061},"i":{"x":0.833,"y":0.948},"s":[256.909,244.618,0],"t":7.2,"ti":[-2.58,5.598,0],"to":[1.513,-7.003,0]},{"o":{"x":0.167,"y":0.093},"i":{"x":0.833,"y":0.922},"s":[263.763,225.603,0],"t":8,"ti":[-2.89,4.322,0],"to":[2.58,-5.598,0]},{"o":{"x":0.167,"y":0.111},"i":{"x":0.833,"y":0.906},"s":[272.387,211.032,0],"t":8.8,"ti":[-2.817,3.434,0],"to":[2.89,-4.322,0]},{"o":{"x":0.167,"y":0.119},"i":{"x":0.833,"y":0.897},"s":[281.103,199.67,0],"t":9.6,"ti":[-2.604,2.843,0],"to":[2.817,-3.434,0]},{"o":{"x":0.167,"y":0.123},"i":{"x":0.833,"y":0.892},"s":[289.287,190.426,0],"t":10.4,"ti":[-2.352,2.444,0],"to":[2.604,-2.843,0]},{"o":{"x":0.167,"y":0.124},"i":{"x":0.833,"y":0.89},"s":[296.729,182.612,0],"t":11.2,"ti":[-2.098,2.172,0],"to":[2.352,-2.444,0]},{"o":{"x":0.167,"y":0.122},"i":{"x":0.833,"y":0.891},"s":[303.402,175.762,0],"t":12,"ti":[-1.847,1.982,0],"to":[2.098,-2.172,0]},{"o":{"x":0.167,"y":0.118},"i":{"x":0.833,"y":0.893},"s":[309.316,169.581,0],"t":12.8,"ti":[-1.599,1.847,0],"to":[1.847,-1.982,0]},{"o":{"x":0.167,"y":0.112},"i":{"x":0.833,"y":0.899},"s":[314.483,163.871,0],"t":13.6,"ti":[-1.351,1.749,0],"to":[1.599,-1.847,0]},{"o":{"x":0.167,"y":0.102},"i":{"x":0.833,"y":0.907},"s":[318.909,158.499,0],"t":14.4,"ti":[-1.1,1.67,0],"to":[1.351,-1.749,0]},{"o":{"x":0.167,"y":0.09},"i":{"x":0.833,"y":0.919},"s":[322.589,153.379,0],"t":15.2,"ti":[-0.847,1.597,0],"to":[1.1,-1.67,0]},{"o":{"x":0.167,"y":0.074},"i":{"x":0.833,"y":0.934},"s":[325.509,148.477,0],"t":16,"ti":[-0.598,1.514,0],"to":[0.847,-1.597,0]},{"o":{"x":0.167,"y":0.054},"i":{"x":0.833,"y":0.951},"s":[327.669,143.798,0],"t":16.8,"ti":[-0.368,1.415,0],"to":[0.598,-1.514,0]},{"o":{"x":0.167,"y":0.033},"i":{"x":0.833,"y":0.97},"s":[329.098,139.39,0],"t":17.6,"ti":[-0.17,1.301,0],"to":[0.368,-1.415,0]},{"o":{"x":0.167,"y":0.011},"i":{"x":0.833,"y":0.99},"s":[329.877,135.307,0],"t":18.4,"ti":[-0.012,1.178,0],"to":[0.17,-1.301,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[330.12,131.586,0],"t":19.2,"ti":[0.108,1.057,0],"to":[0.012,-1.178,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[329.95,128.236,0],"t":20,"ti":[0.197,0.942,0],"to":[-0.108,-1.057,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[329.473,125.245,0],"t":20.8,"ti":[0.245,0.841,0],"to":[-0.197,-0.942,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[328.77,122.586,0],"t":21.6,"ti":[0.252,0.756,0],"to":[-0.245,-0.841,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[328.003,120.201,0],"t":22.4,"ti":[0.241,0.68,0],"to":[-0.252,-0.756,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[327.259,118.051,0],"t":23.2,"ti":[0.227,0.611,0],"to":[-0.241,-0.68,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[326.555,116.118,0],"t":24,"ti":[0.211,0.546,0],"to":[-0.227,-0.611,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[325.898,114.387,0],"t":24.8,"ti":[0.196,0.484,0],"to":[-0.211,-0.546,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[325.288,112.845,0],"t":25.6,"ti":[0.183,0.426,0],"to":[-0.196,-0.484,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[324.72,111.482,0],"t":26.4,"ti":[0.173,0.371,0],"to":[-0.183,-0.426,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[324.187,110.287,0],"t":27.2,"ti":[0.164,0.318,0],"to":[-0.173,-0.371,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[323.684,109.255,0],"t":28,"ti":[0.159,0.267,0],"to":[-0.164,-0.318,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[323.201,108.379,0],"t":28.8,"ti":[0.156,0.217,0],"to":[-0.159,-0.267,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[322.731,107.655,0],"t":29.6,"ti":[0.154,0.168,0],"to":[-0.156,-0.217,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[322.267,107.078,0],"t":30.4,"ti":[0.155,0.121,0],"to":[-0.154,-0.168,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[321.804,106.645,0],"t":31.2,"ti":[0.157,0.075,0],"to":[-0.155,-0.121,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[321.338,106.352,0],"t":32,"ti":[0.16,0.031,0],"to":[-0.157,-0.075,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[320.863,106.193,0],"t":32.8,"ti":[0.165,-0.011,0],"to":[-0.16,-0.031,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[320.376,106.164,0],"t":33.6,"ti":[0.169,-0.052,0],"to":[-0.165,0.011,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[319.875,106.261,0],"t":34.4,"ti":[0.172,-0.092,0],"to":[-0.169,0.052,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[319.363,106.479,0],"t":35.2,"ti":[0.18,-0.125,0],"to":[-0.172,0.092,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[318.841,106.814,0],"t":36,"ti":[0.197,-0.144,0],"to":[-0.18,0.125,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[318.282,107.227,0],"t":36.8,"ti":[0.217,-0.157,0],"to":[-0.197,0.144,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[317.66,107.68,0],"t":37.6,"ti":[0.233,-0.168,0],"to":[-0.217,0.157,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[316.983,108.169,0],"t":38.4,"ti":[0.246,-0.177,0],"to":[-0.233,0.168,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[316.262,108.687,0],"t":39.2,"ti":[0.254,-0.183,0],"to":[-0.246,0.177,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[315.509,109.229,0],"t":40,"ti":[0.259,-0.188,0],"to":[-0.254,0.183,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[314.735,109.788,0],"t":40.8,"ti":[0.258,-0.189,0],"to":[-0.259,0.188,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[313.957,110.355,0],"t":41.6,"ti":[0.251,-0.187,0],"to":[-0.258,0.189,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[313.19,110.921,0],"t":42.4,"ti":[0.238,-0.182,0],"to":[-0.251,0.187,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[312.452,111.477,0],"t":43.2,"ti":[0.219,-0.173,0],"to":[-0.238,0.182,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[311.761,112.011,0],"t":44,"ti":[0.192,-0.16,0],"to":[-0.219,0.173,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[311.139,112.513,0],"t":44.8,"ti":[0.164,-0.143,0],"to":[-0.192,0.16,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[310.606,112.97,0],"t":45.6,"ti":[0.139,-0.125,0],"to":[-0.164,0.143,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[310.154,113.373,0],"t":46.4,"ti":[0.064,-0.057,0],"to":[-0.139,0.125,0]},{"s":[309.77,113.717,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":25.6},{"s":[0],"t":38.4}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[10,10],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.8353,0.749,1],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":29},{"ty":4,"nm":"Shape Layer 22","sr":1,"st":1.6,"op":48,"ip":1.6,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.986},"s":[78.01,99.254,100],"t":1.6},{"o":{"x":0.167,"y":-0.017},"i":{"x":0.833,"y":0.926},"s":[128.233,72.965,100],"t":2.4},{"o":{"x":0.167,"y":-0.687},"i":{"x":0.833,"y":1.337},"s":[86.694,79.056,100],"t":3.2},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.838},"s":[91.188,107.271,100],"t":4},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":1.041},"s":[68.543,121.799,100],"t":4.8},{"o":{"x":0.167,"y":0.027},"i":{"x":0.833,"y":0.872},"s":[47.195,85.924,100],"t":5.6},{"o":{"x":0.167,"y":0.24},"i":{"x":0.833,"y":0.787},"s":[79.057,53.992,100],"t":6.4},{"o":{"x":0.167,"y":0.137},"i":{"x":0.833,"y":1.016},"s":[95.971,69,100],"t":7.2},{"o":{"x":0.167,"y":0.013},"i":{"x":0.833,"y":0.952},"s":[122.24,79.447,100],"t":8},{"o":{"x":0.167,"y":-0.111},"i":{"x":0.833,"y":0.768},"s":[91.043,95.99,100],"t":8.8},{"o":{"x":0.167,"y":0.13},"i":{"x":0.833,"y":1.026},"s":[104.449,114.638,100],"t":9.6},{"o":{"x":0.167,"y":0.02},"i":{"x":0.833,"y":0.962},"s":[128.392,101.122,100],"t":10.4},{"o":{"x":0.167,"y":-0.071},"i":{"x":0.833,"y":0.99},"s":[96.902,83.222,100],"t":11.2},{"o":{"x":0.167,"y":-0.011},"i":{"x":0.833,"y":1.026},"s":[113.87,113.437,100],"t":12},{"o":{"x":0.167,"y":0.02},"i":{"x":0.833,"y":0.96},"s":[98.911,116.933,100],"t":12.8},{"o":{"x":0.167,"y":-0.077},"i":{"x":0.833,"y":0.845},"s":[118.545,83.843,100],"t":13.6},{"o":{"x":0.167,"y":0.18},"i":{"x":0.833,"y":0.612},"s":[108.334,51.632,100],"t":14.4},{"o":{"x":0.167,"y":0.106},"i":{"x":0.833,"y":1.07},"s":[99.536,120.079,100],"t":15.2},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":0.987},"s":[67.373,144.525,100],"t":16},{"o":{"x":0.167,"y":-0.016},"i":{"x":0.833,"y":0.993},"s":[126.372,85.891,100],"t":16.8},{"o":{"x":0.167,"y":-0.008},"i":{"x":0.833,"y":0.911},"s":[76.632,103.785,100],"t":17.6},{"o":{"x":0.167,"y":1.349},"i":{"x":0.833,"y":1.779},"s":[122.04,117.809,100],"t":18.4},{"o":{"x":0.167,"y":0.075},"i":{"x":0.833,"y":0.843},"s":[125.029,102.081,100],"t":19.2},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":1.135},"s":[94.09,112.18,100],"t":20},{"o":{"x":0.167,"y":0.052},"i":{"x":0.833,"y":0.981},"s":[66.677,91.705,100],"t":20.8},{"o":{"x":0.167,"y":-0.024},"i":{"x":0.833,"y":0.946},"s":[138.63,151.835,100],"t":21.6},{"o":{"x":0.167,"y":-0.153},"i":{"x":0.833,"y":1.1},"s":[82.794,103.616,100],"t":22.4},{"o":{"x":0.167,"y":0.045},"i":{"x":0.833,"y":0.825},"s":[102.519,85.419,100],"t":23.2},{"o":{"x":0.167,"y":0.159},"i":{"x":0.833,"y":0.959},"s":[59.163,85.522,100],"t":24},{"o":{"x":0.167,"y":-0.081},"i":{"x":0.833,"y":0.781},"s":[11.254,57.108,100],"t":24.8},{"o":{"x":0.167,"y":0.134},"i":{"x":0.833,"y":0.97},"s":[35.57,75.366,100],"t":25.6},{"o":{"x":0.167,"y":-0.047},"i":{"x":0.833,"y":0.91},"s":[75.263,44.021,100],"t":26.4},{"o":{"x":0.167,"y":1.081},"i":{"x":0.833,"y":-0.16},"s":[49.845,53.322,100],"t":27.2},{"o":{"x":0.167,"y":0.09},"i":{"x":0.833,"y":1.019},"s":[47.721,46.924,100],"t":28},{"o":{"x":0.167,"y":0.016},"i":{"x":0.833,"y":0.937},"s":[20.292,87.156,100],"t":28.8},{"o":{"x":0.167,"y":-0.252},"i":{"x":0.833,"y":0.992},"s":[54.089,72.277,100],"t":29.6},{"o":{"x":0.167,"y":-0.008},"i":{"x":0.833,"y":0.683},"s":[45.702,78.056,100],"t":30.4},{"o":{"x":0.167,"y":0.113},"i":{"x":0.833,"y":1.156},"s":[53.33,71.575,100],"t":31.2},{"o":{"x":0.167,"y":0.054},"i":{"x":0.833,"y":0.955},"s":[74.741,52.442,100],"t":32},{"o":{"x":0.167,"y":-0.096},"i":{"x":0.833,"y":0.831},"s":[13.206,-5.553,100],"t":32.8},{"o":{"x":0.167,"y":0.164},"i":{"x":0.833,"y":0.979},"s":[41.869,-17.736,100],"t":33.6},{"o":{"x":0.167,"y":-0.027},"i":{"x":0.833,"y":0.774},"s":[71.33,-7.435,100],"t":34.4},{"o":{"x":0.167,"y":0.132},"i":{"x":0.833,"y":0.967},"s":[49.137,-24.086,100],"t":35.2},{"o":{"x":0.167,"y":-0.056},"i":{"x":0.833,"y":0.882},"s":[11.219,-4.255,100],"t":36},{"o":{"x":0.167,"y":0.282},"i":{"x":0.833,"y":0.917},"s":[33.923,16.004,100],"t":36.8},{"o":{"x":0.167,"y":-41.353},"i":{"x":0.833,"y":26.627},"s":[43.431,10.768,100],"t":37.6},{"o":{"x":0.167,"y":0.083},"i":{"x":0.833,"y":2.023},"s":[43.412,3.234,100],"t":38.4},{"o":{"x":0.167,"y":0.077},"i":{"x":0.833,"y":0.937},"s":[49.311,57.286,100],"t":39.2},{"o":{"x":0.167,"y":-0.255},"i":{"x":0.833,"y":0.757},"s":[-29.011,45.06,100],"t":40},{"o":{"x":0.167,"y":0.127},"i":{"x":0.833,"y":0.807},"s":[-9.692,22.004,100],"t":40.8},{"o":{"x":0.167,"y":0.147},"i":{"x":0.833,"y":1.012},"s":[27.268,14.157,100],"t":41.6},{"o":{"x":0.167,"y":0.01},"i":{"x":0.833,"y":0.85},"s":[75.93,32.89,100],"t":42.4},{"o":{"x":0.167,"y":0.187},"i":{"x":0.833,"y":0.972},"s":[20.351,30.629,100],"t":43.2},{"o":{"x":0.167,"y":-0.041},"i":{"x":0.833,"y":0.765},"s":[-24.176,27.418,100],"t":44},{"o":{"x":0.167,"y":0.129},"i":{"x":0.833,"y":0.956},"s":[5.634,22.754,100],"t":44.8},{"o":{"x":0.167,"y":-0.092},"i":{"x":0.833,"y":0.972},"s":[59.79,72.494,100],"t":45.6},{"o":{"x":0.167,"y":-0.043},"i":{"x":0.833,"y":0.833},"s":[34.087,63.804,100],"t":46.4},{"s":[51.017,38.534,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[263.182,299.465,0],"t":1.6,"ti":[1.949,-0.179,0],"to":[-0.365,0.027,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[260.99,299.63,0],"t":2.4,"ti":[4.498,-0.649,0],"to":[-1.949,0.179,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[251.489,300.54,0],"t":3.2,"ti":[6.073,-1.426,0],"to":[-4.498,0.649,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[234.001,303.526,0],"t":4,"ti":[5.777,-2.109,0],"to":[-6.073,1.426,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[215.049,309.096,0],"t":4.8,"ti":[4.639,-2.46,0],"to":[-5.777,2.109,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[199.338,316.18,0],"t":5.6,"ti":[3.563,-2.581,0],"to":[-4.639,2.46,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[187.213,323.857,0],"t":6.4,"ti":[2.716,-2.584,0],"to":[-3.563,2.581,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[177.957,331.668,0],"t":7.2,"ti":[2.065,-2.517,0],"to":[-2.716,2.584,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[170.915,339.358,0],"t":8,"ti":[1.564,-2.411,0],"to":[-2.065,2.517,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[165.569,346.772,0],"t":8.8,"ti":[1.165,-2.278,0],"to":[-1.564,2.411,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[161.531,353.821,0],"t":9.6,"ti":[0.843,-2.131,0],"to":[-1.165,2.278,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[158.58,360.44,0],"t":10.4,"ti":[0.594,-1.982,0],"to":[-0.843,2.131,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[156.475,366.609,0],"t":11.2,"ti":[0.404,-1.836,0],"to":[-0.594,1.982,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[155.019,372.333,0],"t":12,"ti":[0.261,-1.696,0],"to":[-0.404,1.836,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[154.052,377.626,0],"t":12.8,"ti":[0.155,-1.565,0],"to":[-0.261,1.696,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[153.453,382.511,0],"t":13.6,"ti":[0.078,-1.441,0],"to":[-0.155,1.565,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[153.124,387.013,0],"t":14.4,"ti":[0.024,-1.327,0],"to":[-0.078,1.441,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[152.987,391.16,0],"t":15.2,"ti":[-0.012,-1.222,0],"to":[-0.024,1.327,0]},{"o":{"x":0.167,"y":0.004},"i":{"x":0.833,"y":0.996},"s":[152.981,394.977,0],"t":16,"ti":[-0.034,-1.124,0],"to":[0.012,1.222,0]},{"o":{"x":0.167,"y":0.007},"i":{"x":0.833,"y":0.994},"s":[153.059,398.49,0],"t":16.8,"ti":[-0.044,-1.033,0],"to":[0.034,1.124,0]},{"o":{"x":0.167,"y":0.008},"i":{"x":0.833,"y":0.993},"s":[153.183,401.72,0],"t":17.6,"ti":[-0.045,-0.949,0],"to":[0.044,1.033,0]},{"o":{"x":0.167,"y":0.008},"i":{"x":0.833,"y":0.992},"s":[153.322,404.688,0],"t":18.4,"ti":[-0.039,-0.87,0],"to":[0.045,0.949,0]},{"o":{"x":0.167,"y":0.007},"i":{"x":0.833,"y":0.993},"s":[153.452,407.413,0],"t":19.2,"ti":[-0.028,-0.797,0],"to":[0.039,0.87,0]},{"o":{"x":0.167,"y":0.005},"i":{"x":0.833,"y":0.996},"s":[153.556,409.91,0],"t":20,"ti":[-0.013,-0.729,0],"to":[0.028,0.797,0]},{"o":{"x":0.167,"y":0.001},"i":{"x":0.833,"y":0.999},"s":[153.62,412.195,0],"t":20.8,"ti":[0.005,-0.666,0],"to":[0.013,0.729,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[153.633,414.284,0],"t":21.6,"ti":[0.025,-0.607,0],"to":[-0.005,0.666,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[153.589,416.19,0],"t":22.4,"ti":[0.045,-0.552,0],"to":[-0.025,0.607,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[153.484,417.926,0],"t":23.2,"ti":[0.066,-0.501,0],"to":[-0.045,0.552,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[153.316,419.502,0],"t":24,"ti":[0.086,-0.452,0],"to":[-0.066,0.501,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[153.086,420.929,0],"t":24.8,"ti":[0.105,-0.407,0],"to":[-0.086,0.452,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[152.797,422.216,0],"t":25.6,"ti":[0.122,-0.364,0],"to":[-0.105,0.407,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[152.454,423.37,0],"t":26.4,"ti":[0.137,-0.324,0],"to":[-0.122,0.364,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[152.063,424.4,0],"t":27.2,"ti":[0.149,-0.286,0],"to":[-0.137,0.324,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[151.631,425.314,0],"t":28,"ti":[0.157,-0.251,0],"to":[-0.149,0.286,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[151.17,426.118,0],"t":28.8,"ti":[0.161,-0.217,0],"to":[-0.157,0.251,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[150.689,426.818,0],"t":29.6,"ti":[0.161,-0.186,0],"to":[-0.161,0.217,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[150.202,427.422,0],"t":30.4,"ti":[0.156,-0.157,0],"to":[-0.161,0.186,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[149.722,427.936,0],"t":31.2,"ti":[0.145,-0.13,0],"to":[-0.156,0.157,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[149.266,428.364,0],"t":32,"ti":[0.13,-0.103,0],"to":[-0.145,0.13,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[148.849,428.714,0],"t":32.8,"ti":[0.112,-0.075,0],"to":[-0.13,0.103,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[148.487,428.98,0],"t":33.6,"ti":[0.095,-0.052,0],"to":[-0.112,0.075,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[148.176,429.161,0],"t":34.4,"ti":[0.076,-0.036,0],"to":[-0.095,0.052,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[147.92,429.292,0],"t":35.2,"ti":[0.058,-0.02,0],"to":[-0.076,0.036,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[147.718,429.375,0],"t":36,"ti":[0.041,-0.005,0],"to":[-0.058,0.02,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[147.57,429.411,0],"t":36.8,"ti":[0.024,0.009,0],"to":[-0.041,0.005,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[147.473,429.404,0],"t":37.6,"ti":[0.007,0.022,0],"to":[-0.024,-0.009,0]},{"o":{"x":0.167,"y":0.003},"i":{"x":0.833,"y":0.995},"s":[147.427,429.356,0],"t":38.4,"ti":[-0.008,0.035,0],"to":[-0.007,-0.022,0]},{"o":{"x":0.167,"y":0.05},"i":{"x":0.833,"y":0.929},"s":[147.429,429.27,0],"t":39.2,"ti":[-0.023,0.046,0],"to":[0.008,-0.035,0]},{"o":{"x":0.167,"y":0.073},"i":{"x":0.833,"y":0.904},"s":[147.476,429.149,0],"t":40,"ti":[-0.037,0.056,0],"to":[0.023,-0.046,0]},{"o":{"x":0.167,"y":0.087},"i":{"x":0.833,"y":0.894},"s":[147.567,428.995,0],"t":40.8,"ti":[-0.05,0.065,0],"to":[0.037,-0.056,0]},{"o":{"x":0.167,"y":0.096},"i":{"x":0.833,"y":0.888},"s":[147.698,428.811,0],"t":41.6,"ti":[-0.061,0.073,0],"to":[0.05,-0.065,0]},{"o":{"x":0.167,"y":0.102},"i":{"x":0.833,"y":0.884},"s":[147.866,428.602,0],"t":42.4,"ti":[-0.072,0.08,0],"to":[0.061,-0.073,0]},{"o":{"x":0.167,"y":0.107},"i":{"x":0.833,"y":0.882},"s":[148.067,428.371,0],"t":43.2,"ti":[-0.081,0.086,0],"to":[0.072,-0.08,0]},{"o":{"x":0.167,"y":0.111},"i":{"x":0.833,"y":0.881},"s":[148.297,428.121,0],"t":44,"ti":[-0.088,0.09,0],"to":[0.081,-0.086,0]},{"o":{"x":0.167,"y":0.114},"i":{"x":0.833,"y":0.88},"s":[148.552,427.857,0],"t":44.8,"ti":[-0.094,0.093,0],"to":[0.088,-0.09,0]},{"o":{"x":0.167,"y":0.117},"i":{"x":0.833,"y":0.879},"s":[148.827,427.581,0],"t":45.6,"ti":[-0.099,0.094,0],"to":[0.094,-0.093,0]},{"o":{"x":0.167,"y":0.12},"i":{"x":0.833,"y":0.879},"s":[149.118,427.299,0],"t":46.4,"ti":[-0.05,0.047,0],"to":[0.099,-0.094,0]},{"s":[149.419,427.014,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":1.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":5.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":23.2},{"s":[0],"t":36}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[10,10],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.8353,0.749,1],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":30},{"ty":4,"nm":"Shape Layer 21","sr":1,"st":6.4,"op":48,"ip":6.4,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":-5.266},"s":[101.238,48.218,100],"t":6.4},{"o":{"x":0.167,"y":0.084},"i":{"x":0.833,"y":0.994},"s":[100.863,56.49,100],"t":7.2},{"o":{"x":0.167,"y":-0.006},"i":{"x":0.833,"y":0.87},"s":[73.006,100.241,100],"t":8},{"o":{"x":0.167,"y":0.233},"i":{"x":0.833,"y":0.943},"s":[98.954,118.86,100],"t":8.8},{"o":{"x":0.167,"y":-0.185},"i":{"x":0.833,"y":0.692},"s":[113.422,99.365,100],"t":9.6},{"o":{"x":0.167,"y":0.114},"i":{"x":0.833,"y":0.962},"s":[108.921,52.336,100],"t":10.4},{"o":{"x":0.167,"y":-0.07},"i":{"x":0.833,"y":1.185},"s":[96.758,95.263,100],"t":11.2},{"o":{"x":0.167,"y":0.057},"i":{"x":0.833,"y":1.076},"s":[103.361,78.328,100],"t":12},{"o":{"x":0.167,"y":0.04},"i":{"x":0.833,"y":0.937},"s":[82.062,77.962,100],"t":12.8},{"o":{"x":0.167,"y":-0.254},"i":{"x":0.833,"y":0.435},"s":[122.901,80.818,100],"t":13.6},{"o":{"x":0.167,"y":0.098},"i":{"x":0.833,"y":0.986},"s":[112.827,89.288,100],"t":14.4},{"o":{"x":0.167,"y":-0.016},"i":{"x":0.833,"y":0.908},"s":[54.614,133.963,100],"t":15.2},{"o":{"x":0.167,"y":0.871},"i":{"x":0.833,"y":0.977},"s":[103.222,83.744,100],"t":16},{"o":{"x":0.167,"y":-0.032},"i":{"x":0.833,"y":1.079},"s":[108.364,68.125,100],"t":16.8},{"o":{"x":0.167,"y":0.04},"i":{"x":0.833,"y":0.812},"s":[104.662,106.75,100],"t":17.6},{"o":{"x":0.167,"y":0.15},"i":{"x":0.833,"y":1.481},"s":[111.862,108.291,100],"t":18.4},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":1.008},"s":[120.907,132.514,100],"t":19.2},{"o":{"x":0.167,"y":0.007},"i":{"x":0.833,"y":0.948},"s":[59.613,61.164,100],"t":20},{"o":{"x":0.167,"y":-0.141},"i":{"x":0.833,"y":0.83},"s":[126.782,105.209,100],"t":20.8},{"o":{"x":0.167,"y":0.163},"i":{"x":0.833,"y":0.965},"s":[101.882,118.255,100],"t":21.6},{"o":{"x":0.167,"y":-0.059},"i":{"x":0.833,"y":1.119},"s":[75.979,90.498,100],"t":22.4},{"o":{"x":0.167,"y":0.049},"i":{"x":0.833,"y":0.983},"s":[91.099,129.32,100],"t":23.2},{"o":{"x":0.167,"y":-0.022},"i":{"x":0.833,"y":0.873},"s":[54.42,48.147,100],"t":24},{"o":{"x":0.167,"y":0.244},"i":{"x":0.833,"y":1.036},"s":[83.4,81.807,100],"t":24.8},{"o":{"x":0.167,"y":0.025},"i":{"x":0.833,"y":0.914},"s":[98.473,97.441,100],"t":25.6},{"o":{"x":0.167,"y":3.172},"i":{"x":0.833,"y":-4.522},"s":[76.975,98.454,100],"t":26.4},{"o":{"x":0.167,"y":0.085},"i":{"x":0.833,"y":0.977},"s":[76.395,75.312,100],"t":27.2},{"o":{"x":0.167,"y":-0.032},"i":{"x":0.833,"y":0.837},"s":[38.536,99.649,100],"t":28},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.978},"s":[65.888,73.73,100],"t":28.8},{"o":{"x":0.167,"y":-0.03},"i":{"x":0.833,"y":1.051},"s":[91.971,74.174,100],"t":29.6},{"o":{"x":0.167,"y":0.032},"i":{"x":0.833,"y":1.063},"s":[72.715,67.868,100],"t":30.4},{"o":{"x":0.167,"y":0.036},"i":{"x":0.833,"y":0.933},"s":[103.785,85.634,100],"t":31.2},{"o":{"x":0.167,"y":-0.353},"i":{"x":0.833,"y":0.65},"s":[49.165,38.912,100],"t":32},{"o":{"x":0.167,"y":0.109},"i":{"x":0.833,"y":0.946},"s":[59.594,35.561,100],"t":32.8},{"o":{"x":0.167,"y":-0.154},"i":{"x":0.833,"y":0.678},"s":[92.977,55.629,100],"t":33.6},{"o":{"x":0.167,"y":0.112},"i":{"x":0.833,"y":0.84},"s":[81.252,48.654,100],"t":34.4},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.985},"s":[47.617,24.458,100],"t":35.2},{"o":{"x":0.167,"y":-0.018},"i":{"x":0.833,"y":0.939},"s":[16.653,43.696,100],"t":36},{"o":{"x":0.167,"y":-0.225},"i":{"x":0.833,"y":0.962},"s":[42.187,47.804,100],"t":36.8},{"o":{"x":0.167,"y":-0.07},"i":{"x":0.833,"y":1.962},"s":[35.289,12.804,100],"t":37.6},{"o":{"x":0.167,"y":0.077},"i":{"x":0.833,"y":0.877},"s":[39.035,40.12,100],"t":38.4},{"o":{"x":0.167,"y":0.257},"i":{"x":0.833,"y":1.027},"s":[-7.944,24.911,100],"t":39.2},{"o":{"x":0.167,"y":0.02},"i":{"x":0.833,"y":0.741},"s":[-30.445,6.276,100],"t":40},{"o":{"x":0.167,"y":0.123},"i":{"x":0.833,"y":0.947},"s":[-0.773,-4.844,100],"t":40.8},{"o":{"x":0.167,"y":-0.147},"i":{"x":0.833,"y":0.692},"s":[61.907,51.792,100],"t":41.6},{"o":{"x":0.167,"y":0.114},"i":{"x":0.833,"y":0.975},"s":[39.231,67.006,100],"t":42.4},{"o":{"x":0.167,"y":-0.035},"i":{"x":0.833,"y":0.829},"s":[-21.899,55.157,100],"t":43.2},{"o":{"x":0.167,"y":0.163},"i":{"x":0.833,"y":0.981},"s":[21.199,-8.63,100],"t":44},{"o":{"x":0.167,"y":-0.025},"i":{"x":0.833,"y":0.959},"s":[66.363,30.41,100],"t":44.8},{"o":{"x":0.167,"y":-0.08},"i":{"x":0.833,"y":0.943},"s":[31.738,47.268,100],"t":45.6},{"o":{"x":0.167,"y":-0.182},"i":{"x":0.833,"y":0.833},"s":[49.437,25.928,100],"t":46.4},{"s":[43.876,17.029,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.001},"i":{"x":0.833,"y":0.998},"s":[268.269,306.17,0],"t":6.4,"ti":[-0.124,-2.305,0],"to":[0.003,0.494,0]},{"o":{"x":0.167,"y":0.007},"i":{"x":0.833,"y":0.984},"s":[268.288,309.137,0],"t":7.2,"ti":[-0.683,-5.046,0],"to":[0.124,2.305,0]},{"o":{"x":0.167,"y":0.022},"i":{"x":0.833,"y":0.97},"s":[269.014,319.997,0],"t":8,"ti":[-1.89,-6.606,0],"to":[0.683,5.046,0]},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.943},"s":[272.384,339.414,0],"t":8.8,"ti":[-3.289,-5.823,0],"to":[1.89,6.606,0]},{"o":{"x":0.167,"y":0.111},"i":{"x":0.833,"y":0.905},"s":[280.355,359.634,0],"t":9.6,"ti":[-4.111,-3.921,0],"to":[3.289,5.823,0]},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.874},"s":[292.117,374.353,0],"t":10.4,"ti":[-4.169,-2.298,0],"to":[4.111,3.921,0]},{"o":{"x":0.167,"y":0.169},"i":{"x":0.833,"y":0.858},"s":[305.021,383.162,0],"t":11.2,"ti":[-3.808,-1.326,0],"to":[4.169,2.298,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.851},"s":[317.131,388.142,0],"t":12,"ti":[-3.36,-0.831,0],"to":[3.808,1.326,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.847},"s":[327.87,391.116,0],"t":12.8,"ti":[-2.951,-0.601,0],"to":[3.36,0.831,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.846},"s":[337.294,393.129,0],"t":13.6,"ti":[-2.599,-0.51,0],"to":[2.951,0.601,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.845},"s":[345.577,394.723,0],"t":14.4,"ti":[-2.295,-0.495,0],"to":[2.599,0.51,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.846},"s":[352.885,396.19,0],"t":15.2,"ti":[-2.032,-0.524,0],"to":[2.295,0.495,0]},{"o":{"x":0.167,"y":0.169},"i":{"x":0.833,"y":0.847},"s":[359.349,397.694,0],"t":16,"ti":[-1.8,-0.577,0],"to":[2.032,0.524,0]},{"o":{"x":0.167,"y":0.165},"i":{"x":0.833,"y":0.85},"s":[365.075,399.331,0],"t":16.8,"ti":[-1.589,-0.643,0],"to":[1.8,0.577,0]},{"o":{"x":0.167,"y":0.159},"i":{"x":0.833,"y":0.854},"s":[370.148,401.158,0],"t":17.6,"ti":[-1.392,-0.71,0],"to":[1.589,0.643,0]},{"o":{"x":0.167,"y":0.151},"i":{"x":0.833,"y":0.861},"s":[374.61,403.19,0],"t":18.4,"ti":[-1.21,-0.771,0],"to":[1.392,0.71,0]},{"o":{"x":0.167,"y":0.142},"i":{"x":0.833,"y":0.869},"s":[378.501,405.417,0],"t":19.2,"ti":[-1.047,-0.823,0],"to":[1.21,0.771,0]},{"o":{"x":0.167,"y":0.13},"i":{"x":0.833,"y":0.879},"s":[381.873,407.817,0],"t":20,"ti":[-0.897,-0.852,0],"to":[1.047,0.823,0]},{"o":{"x":0.167,"y":0.12},"i":{"x":0.833,"y":0.89},"s":[384.78,410.354,0],"t":20.8,"ti":[-0.758,-0.847,0],"to":[0.897,0.852,0]},{"o":{"x":0.167,"y":0.112},"i":{"x":0.833,"y":0.899},"s":[387.255,412.931,0],"t":21.6,"ti":[-0.635,-0.817,0],"to":[0.758,0.847,0]},{"o":{"x":0.167,"y":0.103},"i":{"x":0.833,"y":0.907},"s":[389.33,415.438,0],"t":22.4,"ti":[-0.53,-0.777,0],"to":[0.635,0.817,0]},{"o":{"x":0.167,"y":0.094},"i":{"x":0.833,"y":0.914},"s":[391.063,417.835,0],"t":23.2,"ti":[-0.442,-0.729,0],"to":[0.53,0.777,0]},{"o":{"x":0.167,"y":0.087},"i":{"x":0.833,"y":0.921},"s":[392.509,420.098,0],"t":24,"ti":[-0.37,-0.677,0],"to":[0.442,0.729,0]},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":0.927},"s":[393.717,422.209,0],"t":24.8,"ti":[-0.311,-0.623,0],"to":[0.37,0.677,0]},{"o":{"x":0.167,"y":0.076},"i":{"x":0.833,"y":0.932},"s":[394.73,424.158,0],"t":25.6,"ti":[-0.263,-0.569,0],"to":[0.311,0.623,0]},{"o":{"x":0.167,"y":0.072},"i":{"x":0.833,"y":0.936},"s":[395.584,425.945,0],"t":26.4,"ti":[-0.224,-0.517,0],"to":[0.263,0.569,0]},{"o":{"x":0.167,"y":0.068},"i":{"x":0.833,"y":0.939},"s":[396.309,427.572,0],"t":27.2,"ti":[-0.192,-0.467,0],"to":[0.224,0.517,0]},{"o":{"x":0.167,"y":0.066},"i":{"x":0.833,"y":0.941},"s":[396.928,429.046,0],"t":28,"ti":[-0.166,-0.419,0],"to":[0.192,0.467,0]},{"o":{"x":0.167,"y":0.064},"i":{"x":0.833,"y":0.943},"s":[397.461,430.372,0],"t":28.8,"ti":[-0.144,-0.373,0],"to":[0.166,0.419,0]},{"o":{"x":0.167,"y":0.063},"i":{"x":0.833,"y":0.944},"s":[397.921,431.558,0],"t":29.6,"ti":[-0.125,-0.33,0],"to":[0.144,0.373,0]},{"o":{"x":0.167,"y":0.063},"i":{"x":0.833,"y":0.945},"s":[398.322,432.612,0],"t":30.4,"ti":[-0.11,-0.29,0],"to":[0.125,0.33,0]},{"o":{"x":0.167,"y":0.064},"i":{"x":0.833,"y":0.945},"s":[398.672,433.54,0],"t":31.2,"ti":[-0.096,-0.253,0],"to":[0.11,0.29,0]},{"o":{"x":0.167,"y":0.064},"i":{"x":0.833,"y":0.944},"s":[398.98,434.351,0],"t":32,"ti":[-0.085,-0.219,0],"to":[0.096,0.253,0]},{"o":{"x":0.167,"y":0.066},"i":{"x":0.833,"y":0.943},"s":[399.251,435.056,0],"t":32.8,"ti":[-0.075,-0.187,0],"to":[0.085,0.219,0]},{"o":{"x":0.167,"y":0.068},"i":{"x":0.833,"y":0.942},"s":[399.491,435.663,0],"t":33.6,"ti":[-0.066,-0.157,0],"to":[0.075,0.187,0]},{"o":{"x":0.167,"y":0.073},"i":{"x":0.833,"y":0.94},"s":[399.701,436.178,0],"t":34.4,"ti":[-0.058,-0.129,0],"to":[0.066,0.157,0]},{"o":{"x":0.167,"y":0.078},"i":{"x":0.833,"y":0.937},"s":[399.886,436.606,0],"t":35.2,"ti":[-0.05,-0.103,0],"to":[0.058,0.129,0]},{"o":{"x":0.167,"y":0.085},"i":{"x":0.833,"y":0.934},"s":[400.047,436.953,0],"t":36,"ti":[-0.042,-0.078,0],"to":[0.05,0.103,0]},{"o":{"x":0.167,"y":0.098},"i":{"x":0.833,"y":0.929},"s":[400.184,437.223,0],"t":36.8,"ti":[-0.035,-0.055,0],"to":[0.042,0.078,0]},{"o":{"x":0.167,"y":0.118},"i":{"x":0.833,"y":0.911},"s":[400.3,437.422,0],"t":37.6,"ti":[-0.029,-0.04,0],"to":[0.035,0.055,0]},{"o":{"x":0.167,"y":0.106},"i":{"x":0.833,"y":0.898},"s":[400.393,437.552,0],"t":38.4,"ti":[-0.025,-0.04,0],"to":[0.029,0.04,0]},{"o":{"x":0.167,"y":0.074},"i":{"x":0.833,"y":0.917},"s":[400.471,437.661,0],"t":39.2,"ti":[-0.022,-0.048,0],"to":[0.025,0.04,0]},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.935},"s":[400.541,437.792,0],"t":40,"ti":[-0.019,-0.055,0],"to":[0.022,0.048,0]},{"o":{"x":0.167,"y":0.044},"i":{"x":0.833,"y":0.951},"s":[400.602,437.946,0],"t":40.8,"ti":[-0.015,-0.062,0],"to":[0.019,0.055,0]},{"o":{"x":0.167,"y":0.032},"i":{"x":0.833,"y":0.965},"s":[400.653,438.122,0],"t":41.6,"ti":[-0.012,-0.069,0],"to":[0.015,0.062,0]},{"o":{"x":0.167,"y":0.022},"i":{"x":0.833,"y":0.976},"s":[400.694,438.32,0],"t":42.4,"ti":[-0.008,-0.076,0],"to":[0.012,0.069,0]},{"o":{"x":0.167,"y":0.013},"i":{"x":0.833,"y":0.986},"s":[400.724,438.538,0],"t":43.2,"ti":[-0.004,-0.082,0],"to":[0.008,0.076,0]},{"o":{"x":0.167,"y":0.005},"i":{"x":0.833,"y":0.994},"s":[400.743,438.775,0],"t":44,"ti":[0.001,-0.09,0],"to":[0.004,0.082,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[400.751,439.03,0],"t":44.8,"ti":[0.01,-0.102,0],"to":[-0.001,0.09,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[400.737,439.316,0],"t":45.6,"ti":[0.019,-0.113,0],"to":[-0.01,0.102,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[400.693,439.644,0],"t":46.4,"ti":[0.011,-0.059,0],"to":[-0.019,0.113,0]},{"s":[400.624,439.996,0],"t":47.2}],"ix":2},"r":{"a":0,"k":92,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":6.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":10.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":28},{"s":[0],"t":40.8}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[10,10],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.8353,0.749,1],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":31},{"ty":4,"nm":"Shape Layer 20","sr":1,"st":4.8,"op":48,"ip":4.8,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":1.05},"s":[113.755,94.294,100],"t":4.8},{"o":{"x":0.167,"y":0.031},"i":{"x":0.833,"y":0.873},"s":[142.324,42.5,100],"t":5.6},{"o":{"x":0.167,"y":0.241},"i":{"x":0.833,"y":0.888},"s":[96.482,48.003,100],"t":6.4},{"o":{"x":0.167,"y":0.325},"i":{"x":0.833,"y":1.204},"s":[72.3,93.591,100],"t":7.2},{"o":{"x":0.167,"y":0.059},"i":{"x":0.833,"y":0.921},"s":[63.951,85.144,100],"t":8},{"o":{"x":0.167,"y":-1.529},"i":{"x":0.833,"y":-0.459},"s":[92.765,73.936,100],"t":8.8},{"o":{"x":0.167,"y":0.088},"i":{"x":0.833,"y":0.995},"s":[91.276,28.604,100],"t":9.6},{"o":{"x":0.167,"y":-0.006},"i":{"x":0.833,"y":0.992},"s":[66.684,57.392,100],"t":10.4},{"o":{"x":0.167,"y":-0.008},"i":{"x":0.833,"y":0.995},"s":[89.679,71.451,100],"t":11.2},{"o":{"x":0.167,"y":-0.005},"i":{"x":0.833,"y":0.731},"s":[68.777,51.94,100],"t":12},{"o":{"x":0.167,"y":0.121},"i":{"x":0.833,"y":1.035},"s":[88.421,74.596,100],"t":12.8},{"o":{"x":0.167,"y":0.025},"i":{"x":0.833,"y":0.935},"s":[132.23,89.048,100],"t":13.6},{"o":{"x":0.167,"y":-0.305},"i":{"x":0.833,"y":0.575},"s":[69.974,126.315,100],"t":14.4},{"o":{"x":0.167,"y":0.104},"i":{"x":0.833,"y":0.931},"s":[83.338,98.135,100],"t":15.2},{"o":{"x":0.167,"y":-0.391},"i":{"x":0.833,"y":0.313},"s":[138.117,73.778,100],"t":16},{"o":{"x":0.167,"y":0.095},"i":{"x":0.833,"y":0.993},"s":[128.488,92.265,100],"t":16.8},{"o":{"x":0.167,"y":-0.008},"i":{"x":0.833,"y":0.953},"s":[58.681,121.955,100],"t":17.6},{"o":{"x":0.167,"y":-0.109},"i":{"x":0.833,"y":0.815},"s":[122.512,146.761,100],"t":18.4},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.991},"s":[94.854,78.682,100],"t":19.2},{"o":{"x":0.167,"y":-0.01},"i":{"x":0.833,"y":1.02},"s":[61.077,78.352,100],"t":20},{"o":{"x":0.167,"y":0.016},"i":{"x":0.833,"y":0.963},"s":[91.084,94.97,100],"t":20.8},{"o":{"x":0.167,"y":-0.068},"i":{"x":0.833,"y":0.849},"s":[53.825,43.095,100],"t":21.6},{"o":{"x":0.167,"y":0.186},"i":{"x":0.833,"y":0.888},"s":[74.356,105.62,100],"t":22.4},{"o":{"x":0.167,"y":0.324},"i":{"x":0.833,"y":0.814},"s":[91.09,66.721,100],"t":23.2},{"o":{"x":0.167,"y":0.151},"i":{"x":0.833,"y":1.498},"s":[96.876,55.445,100],"t":24},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.992},"s":[104.026,86.476,100],"t":24.8},{"o":{"x":0.167,"y":-0.009},"i":{"x":0.833,"y":0.986},"s":[54.137,91.081,100],"t":25.6},{"o":{"x":0.167,"y":-0.017},"i":{"x":0.833,"y":0.906},"s":[99.353,40.985,100],"t":26.4},{"o":{"x":0.167,"y":0.764},"i":{"x":0.833,"y":1.666},"s":[61.794,49.744,100],"t":27.2},{"o":{"x":0.167,"y":0.074},"i":{"x":0.833,"y":0.993},"s":[57.194,46.834,100],"t":28},{"o":{"x":0.167,"y":-0.008},"i":{"x":0.833,"y":1.011},"s":[98.549,37.625,100],"t":28.8},{"o":{"x":0.167,"y":0.009},"i":{"x":0.833,"y":1.007},"s":[60.683,30.783,100],"t":29.6},{"o":{"x":0.167,"y":0.007},"i":{"x":0.833,"y":0.882},"s":[103.351,52.891,100],"t":30.4},{"o":{"x":0.167,"y":0.282},"i":{"x":0.833,"y":1.098},"s":[56.948,22.459,100],"t":31.2},{"o":{"x":0.167,"y":0.045},"i":{"x":0.833,"y":0.953},"s":[37.48,29.284,100],"t":32},{"o":{"x":0.167,"y":-0.106},"i":{"x":0.833,"y":0.913},"s":[79.938,50.562,100],"t":32.8},{"o":{"x":0.167,"y":1.804},"i":{"x":0.833,"y":-5.816},"s":[61.287,72.597,100],"t":33.6},{"o":{"x":0.167,"y":0.084},"i":{"x":0.833,"y":0.946},"s":[60.383,54.282,100],"t":34.4},{"o":{"x":0.167,"y":-0.155},"i":{"x":0.833,"y":0.87},"s":[-12.609,74.447,100],"t":35.2},{"o":{"x":0.167,"y":0.231},"i":{"x":0.833,"y":0.795},"s":[12.933,44.106,100],"t":36},{"o":{"x":0.167,"y":0.141},"i":{"x":0.833,"y":1.094},"s":[27.371,38.441,100],"t":36.8},{"o":{"x":0.167,"y":0.044},"i":{"x":0.833,"y":0.924},"s":[48.387,42.359,100],"t":37.6},{"o":{"x":0.167,"y":-0.898},"i":{"x":0.833,"y":1.231},"s":[3.703,3.258,100],"t":38.4},{"o":{"x":0.167,"y":0.061},"i":{"x":0.833,"y":1.188},"s":[7.498,-13.404,100],"t":39.2},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.899},"s":[-6.825,-11.313,100],"t":40},{"o":{"x":0.167,"y":0.485},"i":{"x":0.833,"y":1.382},"s":[39.727,31.017,100],"t":40.8},{"o":{"x":0.167,"y":0.068},"i":{"x":0.833,"y":0.967},"s":[49.384,58.012,100],"t":41.6},{"o":{"x":0.167,"y":-0.055},"i":{"x":0.833,"y":0.795},"s":[-4.528,65.442,100],"t":42.4},{"o":{"x":0.167,"y":0.141},"i":{"x":0.833,"y":0.999},"s":[27.852,6.982,100],"t":43.2},{"o":{"x":0.167,"y":-0.001},"i":{"x":0.833,"y":0.947},"s":[75.027,5.405,100],"t":44},{"o":{"x":0.167,"y":-0.146},"i":{"x":0.833,"y":0.867},"s":[28.477,20.053,100],"t":44.8},{"o":{"x":0.167,"y":0.224},"i":{"x":0.833,"y":1.164},"s":[45.412,21.822,100],"t":45.6},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.833},"s":[55.436,31.442,100],"t":46.4},{"s":[25.653,-23.168,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[273.987,258.212,0],"t":4.8,"ti":[1.235,-1.262,0],"to":[-0.226,0.261,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[272.634,259.781,0],"t":5.6,"ti":[3.172,-2.472,0],"to":[-1.235,1.262,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[266.579,265.787,0],"t":6.4,"ti":[4.928,-2.338,0],"to":[-3.172,2.472,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[253.605,274.613,0],"t":7.2,"ti":[5.281,-0.789,0],"to":[-4.928,2.338,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[237.011,279.814,0],"t":8,"ti":[4.495,0.772,0],"to":[-5.281,0.789,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[221.916,279.349,0],"t":8.8,"ti":[3.459,1.674,0],"to":[-4.495,-0.772,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[210.041,275.183,0],"t":9.6,"ti":[2.573,2.049,0],"to":[-3.459,-1.674,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[201.165,269.307,0],"t":10.4,"ti":[1.908,2.132,0],"to":[-2.573,-2.049,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[194.6,262.891,0],"t":11.2,"ti":[1.43,2.079,0],"to":[-1.908,-2.132,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[189.714,256.512,0],"t":12,"ti":[1.088,1.968,0],"to":[-1.43,-2.079,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[186.021,250.417,0],"t":12.8,"ti":[0.842,1.835,0],"to":[-1.088,-1.968,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[183.185,244.707,0],"t":13.6,"ti":[0.663,1.699,0],"to":[-0.842,-1.835,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[180.968,239.407,0],"t":14.4,"ti":[0.532,1.568,0],"to":[-0.663,-1.699,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[179.205,234.511,0],"t":15.2,"ti":[0.434,1.443,0],"to":[-0.532,-1.568,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[177.777,230,0],"t":16,"ti":[0.361,1.326,0],"to":[-0.434,-1.443,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[176.6,225.853,0],"t":16.8,"ti":[0.305,1.218,0],"to":[-0.361,-1.326,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[175.612,222.043,0],"t":17.6,"ti":[0.263,1.116,0],"to":[-0.305,-1.218,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[174.767,218.548,0],"t":18.4,"ti":[0.231,1.022,0],"to":[-0.263,-1.116,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[174.033,215.345,0],"t":19.2,"ti":[0.205,0.934,0],"to":[-0.231,-1.022,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[173.383,212.416,0],"t":20,"ti":[0.185,0.851,0],"to":[-0.205,-0.934,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[172.801,209.743,0],"t":20.8,"ti":[0.169,0.773,0],"to":[-0.185,-0.851,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[172.273,207.311,0],"t":21.6,"ti":[0.155,0.7,0],"to":[-0.169,-0.773,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[171.79,205.104,0],"t":22.4,"ti":[0.143,0.63,0],"to":[-0.155,-0.7,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[171.345,203.111,0],"t":23.2,"ti":[0.131,0.565,0],"to":[-0.143,-0.63,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[170.934,201.322,0],"t":24,"ti":[0.12,0.503,0],"to":[-0.131,-0.565,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[170.557,199.723,0],"t":24.8,"ti":[0.109,0.444,0],"to":[-0.12,-0.503,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[170.213,198.306,0],"t":25.6,"ti":[0.097,0.389,0],"to":[-0.109,-0.444,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[169.903,197.059,0],"t":26.4,"ti":[0.085,0.336,0],"to":[-0.097,-0.389,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[169.629,195.974,0],"t":27.2,"ti":[0.07,0.287,0],"to":[-0.085,-0.336,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[169.396,195.042,0],"t":28,"ti":[0.055,0.24,0],"to":[-0.07,-0.287,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[169.206,194.254,0],"t":28.8,"ti":[0.037,0.195,0],"to":[-0.055,-0.24,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[169.067,193.604,0],"t":29.6,"ti":[0.018,0.153,0],"to":[-0.037,-0.195,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[168.983,193.083,0],"t":30.4,"ti":[-0.004,0.114,0],"to":[-0.018,-0.153,0]},{"o":{"x":0.167,"y":0.032},"i":{"x":0.833,"y":0.977},"s":[168.961,192.685,0],"t":31.2,"ti":[-0.028,0.076,0],"to":[0.004,-0.114,0]},{"o":{"x":0.167,"y":0.11},"i":{"x":0.833,"y":0.917},"s":[169.007,192.402,0],"t":32,"ti":[-0.046,0.036,0],"to":[0.028,-0.076,0]},{"o":{"x":0.167,"y":0.178},"i":{"x":0.833,"y":0.832},"s":[169.128,192.228,0],"t":32.8,"ti":[-0.055,-0.006,0],"to":[0.046,-0.036,0]},{"o":{"x":0.167,"y":0.141},"i":{"x":0.833,"y":0.824},"s":[169.284,192.183,0],"t":33.6,"ti":[-0.06,-0.042,0],"to":[0.055,0.006,0]},{"o":{"x":0.167,"y":0.105},"i":{"x":0.833,"y":0.864},"s":[169.457,192.261,0],"t":34.4,"ti":[-0.063,-0.073,0],"to":[0.06,0.042,0]},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":0.893},"s":[169.642,192.438,0],"t":35.2,"ti":[-0.065,-0.097,0],"to":[0.063,0.073,0]},{"o":{"x":0.167,"y":0.08},"i":{"x":0.833,"y":0.912},"s":[169.834,192.698,0],"t":36,"ti":[-0.066,-0.11,0],"to":[0.065,0.097,0]},{"o":{"x":0.167,"y":0.083},"i":{"x":0.833,"y":0.919},"s":[170.032,193.022,0],"t":36.8,"ti":[-0.066,-0.107,0],"to":[0.066,0.11,0]},{"o":{"x":0.167,"y":0.095},"i":{"x":0.833,"y":0.913},"s":[170.231,193.359,0],"t":37.6,"ti":[-0.066,-0.094,0],"to":[0.066,0.107,0]},{"o":{"x":0.167,"y":0.106},"i":{"x":0.833,"y":0.906},"s":[170.43,193.661,0],"t":38.4,"ti":[-0.064,-0.077,0],"to":[0.066,0.094,0]},{"o":{"x":0.167,"y":0.122},"i":{"x":0.833,"y":0.896},"s":[170.626,193.92,0],"t":39.2,"ti":[-0.062,-0.058,0],"to":[0.064,0.077,0]},{"o":{"x":0.167,"y":0.144},"i":{"x":0.833,"y":0.882},"s":[170.816,194.125,0],"t":40,"ti":[-0.059,-0.037,0],"to":[0.062,0.058,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.859},"s":[170.999,194.269,0],"t":40.8,"ti":[-0.056,-0.014,0],"to":[0.059,0.037,0]},{"o":{"x":0.167,"y":0.178},"i":{"x":0.833,"y":0.833},"s":[171.172,194.347,0],"t":41.6,"ti":[-0.052,0.01,0],"to":[0.056,0.014,0]},{"o":{"x":0.167,"y":0.149},"i":{"x":0.833,"y":0.834},"s":[171.335,194.353,0],"t":42.4,"ti":[-0.048,0.036,0],"to":[0.052,-0.01,0]},{"o":{"x":0.167,"y":0.104},"i":{"x":0.833,"y":0.872},"s":[171.485,194.284,0],"t":43.2,"ti":[-0.043,0.061,0],"to":[0.048,-0.036,0]},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.91},"s":[171.621,194.138,0],"t":44,"ti":[-0.038,0.087,0],"to":[0.043,-0.061,0]},{"o":{"x":0.167,"y":0.051},"i":{"x":0.833,"y":0.938},"s":[171.743,193.915,0],"t":44.8,"ti":[-0.033,0.112,0],"to":[0.038,-0.087,0]},{"o":{"x":0.167,"y":0.036},"i":{"x":0.833,"y":0.957},"s":[171.851,193.615,0],"t":45.6,"ti":[-0.028,0.137,0],"to":[0.033,-0.112,0]},{"o":{"x":0.167,"y":0.026},"i":{"x":0.833,"y":0.972},"s":[171.943,193.241,0],"t":46.4,"ti":[-0.013,0.074,0],"to":[0.028,-0.137,0]},{"s":[172.02,192.796,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":4.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":8.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":26.4},{"s":[0],"t":39.2}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Polystar 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sr","bm":0,"hd":false,"mn":"ADBE Vector Shape - Star","nm":"Polystar Path 1","ix":1,"d":1,"pt":{"a":0,"k":3,"ix":3},"p":{"a":0,"k":[6,32],"ix":4},"or":{"a":0,"k":6.599,"ix":7},"os":{"a":0,"k":0,"ix":9},"r":{"a":0,"k":0,"ix":5},"sy":2},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.4745,0.8392,0.6667],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-7.382,-25.677],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":32},{"ty":4,"nm":"Shape Layer 19","sr":1,"st":8.8,"op":48,"ip":8.8,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":2.45},"s":[64.676,29.575,100],"t":8.8},{"o":{"x":0.167,"y":0.079},"i":{"x":0.833,"y":0.851},"s":[63.619,31.654,100],"t":9.6},{"o":{"x":0.167,"y":0.189},"i":{"x":0.833,"y":1.096},"s":[83.082,94.984,100],"t":10.4},{"o":{"x":0.167,"y":0.045},"i":{"x":0.833,"y":1.044},"s":[98.428,68.346,100],"t":11.2},{"o":{"x":0.167,"y":0.029},"i":{"x":0.833,"y":0.951},"s":[65.326,46.692,100],"t":12},{"o":{"x":0.167,"y":-0.117},"i":{"x":0.833,"y":0.846},"s":[115.976,81.786,100],"t":12.8},{"o":{"x":0.167,"y":0.181},"i":{"x":0.833,"y":1.191},"s":[94.867,134.538,100],"t":13.6},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.903},"s":[76.907,82.463,100],"t":14.4},{"o":{"x":0.167,"y":0.576},"i":{"x":0.833,"y":1.592},"s":[136.087,72.163,100],"t":15.2},{"o":{"x":0.167,"y":0.073},"i":{"x":0.833,"y":0.95},"s":[146.093,94.38,100],"t":16},{"o":{"x":0.167,"y":-0.126},"i":{"x":0.833,"y":0.84},"s":[64.998,132.461,100],"t":16.8},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":1.163},"s":[97.241,152.104,100],"t":17.6},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.936},"s":[126.81,118.253,100],"t":18.4},{"o":{"x":0.167,"y":-0.273},"i":{"x":0.833,"y":0.87},"s":[39.419,102.155,100],"t":19.2},{"o":{"x":0.167,"y":0.231},"i":{"x":0.833,"y":1.013},"s":[59.845,93.89,100],"t":20},{"o":{"x":0.167,"y":0.011},"i":{"x":0.833,"y":1.068},"s":[71.34,47.538,100],"t":20.8},{"o":{"x":0.167,"y":0.037},"i":{"x":0.833,"y":0.87},"s":[58.098,44.818,100],"t":21.6},{"o":{"x":0.167,"y":0.234},"i":{"x":0.833,"y":0.848},"s":[82.135,88.74,100],"t":22.4},{"o":{"x":0.167,"y":0.185},"i":{"x":0.833,"y":1.37},"s":[95.452,70.689,100],"t":23.2},{"o":{"x":0.167,"y":0.068},"i":{"x":0.833,"y":0.991},"s":[106.399,41.339,100],"t":24},{"o":{"x":0.167,"y":-0.01},"i":{"x":0.833,"y":0.931},"s":[46.837,95.066,100],"t":24.8},{"o":{"x":0.167,"y":-0.417},"i":{"x":0.833,"y":0.867},"s":[100.241,76.371,100],"t":25.6},{"o":{"x":0.167,"y":0.224},"i":{"x":0.833,"y":1.202},"s":[91.348,46.624,100],"t":26.4},{"o":{"x":0.167,"y":0.059},"i":{"x":0.833,"y":0.962},"s":[86.082,72.273,100],"t":27.2},{"o":{"x":0.167,"y":-0.069},"i":{"x":0.833,"y":1.193},"s":[104.113,51.031,100],"t":28},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.964},"s":[94.281,62.125,100],"t":28.8},{"o":{"x":0.167,"y":-0.063},"i":{"x":0.833,"y":0.717},"s":[126.942,93.089,100],"t":29.6},{"o":{"x":0.167,"y":0.118},"i":{"x":0.833,"y":0.99},"s":[108.331,65.944,100],"t":30.4},{"o":{"x":0.167,"y":-0.012},"i":{"x":0.833,"y":0.969},"s":[63.723,44.138,100],"t":31.2},{"o":{"x":0.167,"y":-0.049},"i":{"x":0.833,"y":0.947},"s":[102.921,48.671,100],"t":32},{"o":{"x":0.167,"y":-0.147},"i":{"x":0.833,"y":1.464},"s":[78.268,71.671,100],"t":32.8},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.902},"s":[87.176,75.352,100],"t":33.6},{"o":{"x":0.167,"y":0.554},"i":{"x":0.833,"y":1.234},"s":[28.705,110.854,100],"t":34.4},{"o":{"x":0.167,"y":0.061},"i":{"x":0.833,"y":0.845},"s":[18.357,46.477,100],"t":35.2},{"o":{"x":0.167,"y":0.181},"i":{"x":0.833,"y":1.091},"s":[57.758,39.913,100],"t":36},{"o":{"x":0.167,"y":0.044},"i":{"x":0.833,"y":0.948},"s":[91.489,81.222,100],"t":36.8},{"o":{"x":0.167,"y":-0.137},"i":{"x":0.833,"y":0.953},"s":[20.878,48.853,100],"t":37.6},{"o":{"x":0.167,"y":-0.108},"i":{"x":0.833,"y":0.976},"s":[47.568,3.824,100],"t":38.4},{"o":{"x":0.167,"y":-0.035},"i":{"x":0.833,"y":0.831},"s":[35.966,11.947,100],"t":39.2},{"o":{"x":0.167,"y":0.165},"i":{"x":0.833,"y":1.412},"s":[44.168,4.41,100],"t":40},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":0.937},"s":[52.575,15.778,100],"t":40.8},{"o":{"x":0.167,"y":-0.254},"i":{"x":0.833,"y":0.454},"s":[2.557,60.137,100],"t":41.6},{"o":{"x":0.167,"y":0.098},"i":{"x":0.833,"y":0.959},"s":[14.899,27.604,100],"t":42.4},{"o":{"x":0.167,"y":-0.082},"i":{"x":0.833,"y":0.849},"s":[83.445,31.436,100],"t":43.2},{"o":{"x":0.167,"y":0.186},"i":{"x":0.833,"y":1.046},"s":[48.803,8.908,100],"t":44},{"o":{"x":0.167,"y":0.03},"i":{"x":0.833,"y":0.963},"s":[20.805,49.183,100],"t":44.8},{"o":{"x":0.167,"y":-0.065},"i":{"x":0.833,"y":0.959},"s":[64.315,40.919,100],"t":45.6},{"o":{"x":0.167,"y":-0.079},"i":{"x":0.833,"y":0.833},"s":[39.92,18.864,100],"t":46.4},{"s":[52.411,-3.555,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.164},"i":{"x":0.833,"y":0.519},"s":[273.717,253.598,0],"t":8.8,"ti":[-1.664,-0.082,0],"to":[0.28,-0.028,0]},{"o":{"x":0.167,"y":0.1},"i":{"x":0.833,"y":0.76},"s":[275.395,253.428,0],"t":9.6,"ti":[-3.922,-0.767,0],"to":[1.664,0.082,0]},{"o":{"x":0.167,"y":0.123},"i":{"x":0.833,"y":0.829},"s":[283.7,254.091,0],"t":10.4,"ti":[-5.158,-1.975,0],"to":[3.922,0.767,0]},{"o":{"x":0.167,"y":0.141},"i":{"x":0.833,"y":0.861},"s":[298.929,258.033,0],"t":11.2,"ti":[-4.6,-2.946,0],"to":[5.158,1.975,0]},{"o":{"x":0.167,"y":0.138},"i":{"x":0.833,"y":0.882},"s":[314.649,265.939,0],"t":12,"ti":[-3.328,-3.296,0],"to":[4.6,2.946,0]},{"o":{"x":0.167,"y":0.115},"i":{"x":0.833,"y":0.903},"s":[326.529,275.709,0],"t":12.8,"ti":[-2.233,-3.252,0],"to":[3.328,3.296,0]},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":0.925},"s":[334.618,285.714,0],"t":13.6,"ti":[-1.455,-3.046,0],"to":[2.233,3.252,0]},{"o":{"x":0.167,"y":0.065},"i":{"x":0.833,"y":0.943},"s":[339.929,295.223,0],"t":14.4,"ti":[-0.931,-2.79,0],"to":[1.455,3.046,0]},{"o":{"x":0.167,"y":0.047},"i":{"x":0.833,"y":0.959},"s":[343.35,303.988,0],"t":15.2,"ti":[-0.582,-2.533,0],"to":[0.931,2.79,0]},{"o":{"x":0.167,"y":0.032},"i":{"x":0.833,"y":0.971},"s":[345.513,311.964,0],"t":16,"ti":[-0.353,-2.293,0],"to":[0.582,2.533,0]},{"o":{"x":0.167,"y":0.021},"i":{"x":0.833,"y":0.981},"s":[346.843,319.188,0],"t":16.8,"ti":[-0.205,-2.077,0],"to":[0.353,2.293,0]},{"o":{"x":0.167,"y":0.013},"i":{"x":0.833,"y":0.988},"s":[347.63,325.723,0],"t":17.6,"ti":[-0.115,-1.887,0],"to":[0.205,2.077,0]},{"o":{"x":0.167,"y":0.008},"i":{"x":0.833,"y":0.993},"s":[348.075,331.651,0],"t":18.4,"ti":[-0.064,-1.719,0],"to":[0.115,1.887,0]},{"o":{"x":0.167,"y":0.005},"i":{"x":0.833,"y":0.995},"s":[348.319,337.046,0],"t":19.2,"ti":[-0.041,-1.573,0],"to":[0.064,1.719,0]},{"o":{"x":0.167,"y":0.004},"i":{"x":0.833,"y":0.996},"s":[348.461,341.968,0],"t":20,"ti":[-0.028,-1.452,0],"to":[0.041,1.573,0]},{"o":{"x":0.167,"y":0.003},"i":{"x":0.833,"y":0.998},"s":[348.564,346.482,0],"t":20.8,"ti":[-0.019,-1.351,0],"to":[0.028,1.452,0]},{"o":{"x":0.167,"y":0.002},"i":{"x":0.833,"y":0.998},"s":[348.628,350.68,0],"t":21.6,"ti":[-0.016,-1.256,0],"to":[0.019,1.351,0]},{"o":{"x":0.167,"y":0.002},"i":{"x":0.833,"y":0.998},"s":[348.676,354.586,0],"t":22.4,"ti":[-0.018,-1.167,0],"to":[0.016,1.256,0]},{"o":{"x":0.167,"y":0.003},"i":{"x":0.833,"y":0.997},"s":[348.724,358.218,0],"t":23.2,"ti":[-0.022,-1.082,0],"to":[0.018,1.167,0]},{"o":{"x":0.167,"y":0.004},"i":{"x":0.833,"y":0.996},"s":[348.783,361.589,0],"t":24,"ti":[-0.029,-1,0],"to":[0.022,1.082,0]},{"o":{"x":0.167,"y":0.006},"i":{"x":0.833,"y":0.995},"s":[348.858,364.71,0],"t":24.8,"ti":[-0.036,-0.921,0],"to":[0.029,1,0]},{"o":{"x":0.167,"y":0.008},"i":{"x":0.833,"y":0.993},"s":[348.955,367.59,0],"t":25.6,"ti":[-0.043,-0.844,0],"to":[0.036,0.921,0]},{"o":{"x":0.167,"y":0.01},"i":{"x":0.833,"y":0.991},"s":[349.073,370.236,0],"t":26.4,"ti":[-0.05,-0.768,0],"to":[0.043,0.844,0]},{"o":{"x":0.167,"y":0.013},"i":{"x":0.833,"y":0.989},"s":[349.212,372.652,0],"t":27.2,"ti":[-0.056,-0.694,0],"to":[0.05,0.768,0]},{"o":{"x":0.167,"y":0.016},"i":{"x":0.833,"y":0.986},"s":[349.372,374.845,0],"t":28,"ti":[-0.062,-0.622,0],"to":[0.056,0.694,0]},{"o":{"x":0.167,"y":0.019},"i":{"x":0.833,"y":0.983},"s":[349.55,376.819,0],"t":28.8,"ti":[-0.067,-0.551,0],"to":[0.062,0.622,0]},{"o":{"x":0.167,"y":0.024},"i":{"x":0.833,"y":0.979},"s":[349.743,378.577,0],"t":29.6,"ti":[-0.07,-0.481,0],"to":[0.067,0.551,0]},{"o":{"x":0.167,"y":0.028},"i":{"x":0.833,"y":0.975},"s":[349.95,380.124,0],"t":30.4,"ti":[-0.073,-0.413,0],"to":[0.07,0.481,0]},{"o":{"x":0.167,"y":0.035},"i":{"x":0.833,"y":0.971},"s":[350.166,381.464,0],"t":31.2,"ti":[-0.075,-0.348,0],"to":[0.073,0.413,0]},{"o":{"x":0.167,"y":0.042},"i":{"x":0.833,"y":0.965},"s":[350.389,382.603,0],"t":32,"ti":[-0.075,-0.284,0],"to":[0.075,0.348,0]},{"o":{"x":0.167,"y":0.053},"i":{"x":0.833,"y":0.958},"s":[350.614,383.549,0],"t":32.8,"ti":[-0.075,-0.222,0],"to":[0.075,0.284,0]},{"o":{"x":0.167,"y":0.068},"i":{"x":0.833,"y":0.948},"s":[350.84,384.306,0],"t":33.6,"ti":[-0.073,-0.163,0],"to":[0.075,0.222,0]},{"o":{"x":0.167,"y":0.093},"i":{"x":0.833,"y":0.933},"s":[351.062,384.882,0],"t":34.4,"ti":[-0.071,-0.106,0],"to":[0.073,0.163,0]},{"o":{"x":0.167,"y":0.134},"i":{"x":0.833,"y":0.908},"s":[351.279,385.285,0],"t":35.2,"ti":[-0.068,-0.053,0],"to":[0.071,0.106,0]},{"o":{"x":0.167,"y":0.187},"i":{"x":0.833,"y":0.854},"s":[351.487,385.521,0],"t":36,"ti":[-0.064,-0.002,0],"to":[0.068,0.053,0]},{"o":{"x":0.167,"y":0.16},"i":{"x":0.833,"y":0.821},"s":[351.685,385.601,0],"t":36.8,"ti":[-0.059,0.045,0],"to":[0.064,0.002,0]},{"o":{"x":0.167,"y":0.093},"i":{"x":0.833,"y":0.874},"s":[351.87,385.535,0],"t":37.6,"ti":[-0.054,0.088,0],"to":[0.059,-0.045,0]},{"o":{"x":0.167,"y":0.062},"i":{"x":0.833,"y":0.919},"s":[352.04,385.333,0],"t":38.4,"ti":[-0.049,0.127,0],"to":[0.054,-0.088,0]},{"o":{"x":0.167,"y":0.044},"i":{"x":0.833,"y":0.946},"s":[352.195,385.007,0],"t":39.2,"ti":[-0.043,0.161,0],"to":[0.049,-0.127,0]},{"o":{"x":0.167,"y":0.033},"i":{"x":0.833,"y":0.962},"s":[352.331,384.571,0],"t":40,"ti":[-0.035,0.185,0],"to":[0.043,-0.161,0]},{"o":{"x":0.167,"y":0.025},"i":{"x":0.833,"y":0.974},"s":[352.45,384.039,0],"t":40.8,"ti":[-0.024,0.192,0],"to":[0.035,-0.185,0]},{"o":{"x":0.167,"y":0.016},"i":{"x":0.833,"y":0.984},"s":[352.541,383.461,0],"t":41.6,"ti":[-0.013,0.188,0],"to":[0.024,-0.192,0]},{"o":{"x":0.167,"y":0.006},"i":{"x":0.833,"y":0.994},"s":[352.596,382.887,0],"t":42.4,"ti":[-0.001,0.179,0],"to":[0.013,-0.188,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[352.617,382.333,0],"t":43.2,"ti":[0.007,0.165,0],"to":[0.001,-0.179,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[352.603,381.814,0],"t":44,"ti":[0.003,0.149,0],"to":[-0.007,-0.165,0]},{"o":{"x":0.167,"y":0.005},"i":{"x":0.833,"y":0.995},"s":[352.574,381.345,0],"t":44.8,"ti":[-0.011,0.133,0],"to":[-0.003,-0.149,0]},{"o":{"x":0.167,"y":0.024},"i":{"x":0.833,"y":0.978},"s":[352.587,380.922,0],"t":45.6,"ti":[-0.023,0.117,0],"to":[0.011,-0.133,0]},{"o":{"x":0.167,"y":0.044},"i":{"x":0.833,"y":0.958},"s":[352.639,380.546,0],"t":46.4,"ti":[-0.014,0.055,0],"to":[0.023,-0.117,0]},{"s":[352.724,380.217,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":8.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":12.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":30.4},{"s":[0],"t":43.2}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Polystar 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sr","bm":0,"hd":false,"mn":"ADBE Vector Shape - Star","nm":"Polystar Path 1","ix":1,"d":1,"pt":{"a":0,"k":3,"ix":3},"p":{"a":0,"k":[6,32],"ix":4},"or":{"a":0,"k":6.599,"ix":7},"os":{"a":0,"k":0,"ix":9},"r":{"a":0,"k":0,"ix":5},"sy":2},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0,0.7647,0.902],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-7.382,-25.677],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":33},{"ty":4,"nm":"Shape Layer 18","sr":1,"st":9.6,"op":48,"ip":9.6,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":1.085},"s":[95.923,97.698,100],"t":9.6},{"o":{"x":0.167,"y":0.042},"i":{"x":0.833,"y":0.959},"s":[119.853,100.809,100],"t":10.4},{"o":{"x":0.167,"y":-0.082},"i":{"x":0.833,"y":0.846},"s":[71.61,47.548,100],"t":11.2},{"o":{"x":0.167,"y":0.182},"i":{"x":0.833,"y":1.108},"s":[95.909,74.187,100],"t":12},{"o":{"x":0.167,"y":0.047},"i":{"x":0.833,"y":0.971},"s":[116.529,126.213,100],"t":12.8},{"o":{"x":0.167,"y":-0.046},"i":{"x":0.833,"y":0.765},"s":[69.282,82.296,100],"t":13.6},{"o":{"x":0.167,"y":0.129},"i":{"x":0.833,"y":1.014},"s":[99.804,62.944,100],"t":14.4},{"o":{"x":0.167,"y":0.012},"i":{"x":0.833,"y":0.925},"s":[155.455,101.204,100],"t":15.2},{"o":{"x":0.167,"y":-0.787},"i":{"x":0.833,"y":0.797},"s":[90.335,142.892,100],"t":16},{"o":{"x":0.167,"y":0.141},"i":{"x":0.833,"y":1.16},"s":[96.569,142.898,100],"t":16.8},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.834},"s":[105.516,144.953,100],"t":17.6},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.994},"s":[79.375,124.659,100],"t":18.4},{"o":{"x":0.167,"y":-0.007},"i":{"x":0.833,"y":0.849},"s":[53.599,121.011,100],"t":19.2},{"o":{"x":0.167,"y":0.187},"i":{"x":0.833,"y":1.006},"s":[77.44,94.418,100],"t":20},{"o":{"x":0.167,"y":0.006},"i":{"x":0.833,"y":0.991},"s":[96.658,47.588,100],"t":20.8},{"o":{"x":0.167,"y":-0.01},"i":{"x":0.833,"y":0.869},"s":[75.964,78.236,100],"t":21.6},{"o":{"x":0.167,"y":0.23},"i":{"x":0.833,"y":1.159},"s":[94.431,116.596,100],"t":22.4},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.918},"s":[104.908,41.132,100],"t":23.2},{"o":{"x":0.167,"y":-4.52},"i":{"x":0.833,"y":-2.162},"s":[74.497,85.65,100],"t":24},{"o":{"x":0.167,"y":0.086},"i":{"x":0.833,"y":0.955},"s":[75.047,137.348,100],"t":24.8},{"o":{"x":0.167,"y":-0.097},"i":{"x":0.833,"y":0.922},"s":[95.389,78.111,100],"t":25.6},{"o":{"x":0.167,"y":-1.248},"i":{"x":0.833,"y":3.564},"s":[85.987,106.338,100],"t":26.4},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":1.138},"s":[86.576,59.064,100],"t":27.2},{"o":{"x":0.167,"y":0.052},"i":{"x":0.833,"y":0.92},"s":[67.887,77.283,100],"t":28},{"o":{"x":0.167,"y":-1.951},"i":{"x":0.833,"y":0.048},"s":[117.559,112.652,100],"t":28.8},{"o":{"x":0.167,"y":0.091},"i":{"x":0.833,"y":0.968},"s":[115.524,117.508,100],"t":29.6},{"o":{"x":0.167,"y":-0.052},"i":{"x":0.833,"y":1.028},"s":[94.322,71.923,100],"t":30.4},{"o":{"x":0.167,"y":0.021},"i":{"x":0.833,"y":0.911},"s":[107.41,58.262,100],"t":31.2},{"o":{"x":0.167,"y":1.225},"i":{"x":0.833,"y":-1.313},"s":[89.918,50.26,100],"t":32},{"o":{"x":0.167,"y":0.086},"i":{"x":0.833,"y":0.885},"s":[88.641,56.58,100],"t":32.8},{"o":{"x":0.167,"y":0.303},"i":{"x":0.833,"y":1.028},"s":[54.485,73.842,100],"t":33.6},{"o":{"x":0.167,"y":0.021},"i":{"x":0.833,"y":0.806},"s":[41.537,63.86,100],"t":34.4},{"o":{"x":0.167,"y":0.146},"i":{"x":0.833,"y":1.052},"s":[58.89,12.33,100],"t":35.2},{"o":{"x":0.167,"y":0.032},"i":{"x":0.833,"y":0.928},"s":[81.867,81.726,100],"t":36},{"o":{"x":0.167,"y":-0.543},"i":{"x":0.833,"y":0.858},"s":[44.5,97.298,100],"t":36.8},{"o":{"x":0.167,"y":0.202},"i":{"x":0.833,"y":1.018},"s":[49.475,29.648,100],"t":37.6},{"o":{"x":0.167,"y":0.015},"i":{"x":0.833,"y":1.415},"s":[52.978,19.812,100],"t":38.4},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":1.126},"s":[48.737,19.789,100],"t":39.2},{"o":{"x":0.167,"y":0.05},"i":{"x":0.833,"y":0.939},"s":[74.095,0.809,100],"t":40},{"o":{"x":0.167,"y":-0.229},"i":{"x":0.833,"y":0.788},"s":[10.268,62.842,100],"t":40.8},{"o":{"x":0.167,"y":0.137},"i":{"x":0.833,"y":0.913},"s":[27.318,46.475,100],"t":41.6},{"o":{"x":0.167,"y":2.212},"i":{"x":0.833,"y":3.588},"s":[53.611,68.98,100],"t":42.4},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":0.93},"s":[54.64,8.452,100],"t":43.2},{"o":{"x":0.167,"y":-0.428},"i":{"x":0.833,"y":0.974},"s":[21.647,41.626,100],"t":44},{"o":{"x":0.167,"y":-0.037},"i":{"x":0.833,"y":1.031},"s":[27.025,20.873,100],"t":44.8},{"o":{"x":0.167,"y":0.023},"i":{"x":0.833,"y":1.011},"s":[23.296,26.051,100],"t":45.6},{"o":{"x":0.167,"y":0.01},"i":{"x":0.833,"y":0.833},"s":[28.415,26.722,100],"t":46.4},{"s":[22.608,32.219,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[267.865,255.269,0],"t":9.6,"ti":[1.026,2.138,0],"to":[-0.161,-0.402,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[266.901,252.858,0],"t":10.4,"ti":[2.899,4.739,0],"to":[-1.026,-2.138,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[261.706,242.443,0],"t":11.2,"ti":[4.94,5.799,0],"to":[-2.899,-4.739,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[249.506,224.427,0],"t":12,"ti":[5.963,4.5,0],"to":[-4.94,-5.799,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[232.069,207.647,0],"t":12.8,"ti":[5.888,2.374,0],"to":[-5.963,-4.5,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[213.727,197.425,0],"t":13.6,"ti":[5.276,0.563,0],"to":[-5.888,-2.374,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[196.743,193.401,0],"t":14.4,"ti":[4.452,-0.741,0],"to":[-5.276,-0.563,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[182.074,194.046,0],"t":15.2,"ti":[3.589,-1.577,0],"to":[-4.452,0.741,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[170.029,197.845,0],"t":16,"ti":[2.794,-2.037,0],"to":[-3.589,1.577,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[160.537,203.508,0],"t":16.8,"ti":[2.125,-2.229,0],"to":[-2.794,2.037,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[153.265,210.066,0],"t":17.6,"ti":[1.595,-2.253,0],"to":[-2.125,2.229,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[147.784,216.885,0],"t":18.4,"ti":[1.188,-2.18,0],"to":[-1.595,2.253,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[143.692,223.586,0],"t":19.2,"ti":[0.88,-2.056,0],"to":[-1.188,2.18,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[140.657,229.963,0],"t":20,"ti":[0.65,-1.912,0],"to":[-0.88,2.056,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[138.413,235.924,0],"t":20.8,"ti":[0.477,-1.76,0],"to":[-0.65,1.912,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[136.76,241.434,0],"t":21.6,"ti":[0.347,-1.607,0],"to":[-0.477,1.76,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[135.553,246.481,0],"t":22.4,"ti":[0.25,-1.458,0],"to":[-0.347,1.607,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[134.678,251.075,0],"t":23.2,"ti":[0.178,-1.316,0],"to":[-0.25,1.458,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[134.053,255.23,0],"t":24,"ti":[0.125,-1.182,0],"to":[-0.178,1.316,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[133.611,258.969,0],"t":24.8,"ti":[0.088,-1.057,0],"to":[-0.125,1.182,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[133.302,262.321,0],"t":25.6,"ti":[0.062,-0.942,0],"to":[-0.088,1.057,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[133.085,265.313,0],"t":26.4,"ti":[0.045,-0.835,0],"to":[-0.062,0.942,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[132.931,267.971,0],"t":27.2,"ti":[0.035,-0.737,0],"to":[-0.045,0.835,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[132.816,270.322,0],"t":28,"ti":[0.031,-0.648,0],"to":[-0.035,0.737,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[132.72,272.392,0],"t":28.8,"ti":[0.031,-0.567,0],"to":[-0.031,0.648,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[132.63,274.209,0],"t":29.6,"ti":[0.035,-0.496,0],"to":[-0.031,0.567,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[132.533,275.797,0],"t":30.4,"ti":[0.04,-0.432,0],"to":[-0.035,0.496,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[132.422,277.182,0],"t":31.2,"ti":[0.043,-0.377,0],"to":[-0.04,0.432,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[132.291,278.392,0],"t":32,"ti":[0.036,-0.328,0],"to":[-0.043,0.377,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[132.166,279.447,0],"t":32.8,"ti":[0.026,-0.282,0],"to":[-0.036,0.328,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[132.075,280.359,0],"t":33.6,"ti":[0.017,-0.24,0],"to":[-0.026,0.282,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[132.011,281.139,0],"t":34.4,"ti":[0.01,-0.201,0],"to":[-0.017,0.24,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[131.972,281.799,0],"t":35.2,"ti":[0.003,-0.166,0],"to":[-0.01,0.201,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[131.954,282.347,0],"t":36,"ti":[-0.002,-0.133,0],"to":[-0.003,0.166,0]},{"o":{"x":0.167,"y":0.008},"i":{"x":0.833,"y":0.994},"s":[131.953,282.792,0],"t":36.8,"ti":[-0.007,-0.102,0],"to":[0.002,0.133,0]},{"o":{"x":0.167,"y":0.02},"i":{"x":0.833,"y":0.985},"s":[131.967,283.142,0],"t":37.6,"ti":[-0.011,-0.073,0],"to":[0.007,0.102,0]},{"o":{"x":0.167,"y":0.042},"i":{"x":0.833,"y":0.973},"s":[131.994,283.403,0],"t":38.4,"ti":[-0.014,-0.046,0],"to":[0.011,0.073,0]},{"o":{"x":0.167,"y":0.096},"i":{"x":0.833,"y":0.943},"s":[132.031,283.58,0],"t":39.2,"ti":[-0.017,-0.02,0],"to":[0.014,0.046,0]},{"o":{"x":0.167,"y":0.201},"i":{"x":0.833,"y":0.835},"s":[132.078,283.677,0],"t":40,"ti":[-0.019,0.004,0],"to":[0.017,0.02,0]},{"o":{"x":0.167,"y":0.115},"i":{"x":0.833,"y":0.857},"s":[132.132,283.7,0],"t":40.8,"ti":[-0.021,0.02,0],"to":[0.019,-0.004,0]},{"o":{"x":0.167,"y":0.106},"i":{"x":0.833,"y":0.892},"s":[132.193,283.651,0],"t":41.6,"ti":[-0.023,0.018,0],"to":[0.021,-0.02,0]},{"o":{"x":0.167,"y":0.157},"i":{"x":0.833,"y":0.858},"s":[132.259,283.583,0],"t":42.4,"ti":[-0.025,0.008,0],"to":[0.023,-0.018,0]},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.832},"s":[132.331,283.544,0],"t":43.2,"ti":[-0.026,0,0],"to":[0.025,-0.008,0]},{"o":{"x":0.167,"y":0.162},"i":{"x":0.833,"y":0.829},"s":[132.408,283.533,0],"t":44,"ti":[-0.027,-0.008,0],"to":[0.026,0,0]},{"o":{"x":0.167,"y":0.147},"i":{"x":0.833,"y":0.84},"s":[132.487,283.545,0],"t":44.8,"ti":[-0.027,-0.014,0],"to":[0.027,0.008,0]},{"o":{"x":0.167,"y":0.135},"i":{"x":0.833,"y":0.855},"s":[132.568,283.579,0],"t":45.6,"ti":[-0.027,-0.019,0],"to":[0.027,0.014,0]},{"o":{"x":0.167,"y":0.125},"i":{"x":0.833,"y":0.871},"s":[132.649,283.63,0],"t":46.4,"ti":[-0.013,-0.011,0],"to":[0.027,0.019,0]},{"s":[132.728,283.695,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":9.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":13.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":31.2},{"s":[0],"t":44}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Polystar 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sr","bm":0,"hd":false,"mn":"ADBE Vector Shape - Star","nm":"Polystar Path 1","ix":1,"d":1,"pt":{"a":0,"k":3,"ix":3},"p":{"a":0,"k":[6,32],"ix":4},"or":{"a":0,"k":6.599,"ix":7},"os":{"a":0,"k":0,"ix":9},"r":{"a":0,"k":0,"ix":5},"sy":2},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0,0.7647,0.902],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-7.382,-25.677],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":34},{"ty":4,"nm":"Shape Layer 17","sr":1,"st":6.4,"op":48,"ip":6.4,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.944},"s":[49.219,103.811,100],"t":6.4},{"o":{"x":0.167,"y":-0.166},"i":{"x":0.833,"y":1.111},"s":[96.918,92.8,100],"t":7.2},{"o":{"x":0.167,"y":0.048},"i":{"x":0.833,"y":0.903},"s":[80.991,61.448,100],"t":8},{"o":{"x":0.167,"y":0.607},"i":{"x":0.833,"y":1.606},"s":[118.185,61.313,100],"t":8.8},{"o":{"x":0.167,"y":0.073},"i":{"x":0.833,"y":0.989},"s":[124.101,107.653,100],"t":9.6},{"o":{"x":0.167,"y":-0.013},"i":{"x":0.833,"y":0.917},"s":[75.181,59.182,100],"t":10.4},{"o":{"x":0.167,"y":-62.917},"i":{"x":0.833,"y":-66.49},"s":[117.68,86.992,100],"t":11.2},{"o":{"x":0.167,"y":0.083},"i":{"x":0.833,"y":0.946},"s":[117.624,94.022,100],"t":12},{"o":{"x":0.167,"y":-0.154},"i":{"x":0.833,"y":0.649},"s":[72.153,89.729,100],"t":12.8},{"o":{"x":0.167,"y":0.109},"i":{"x":0.833,"y":0.994},"s":[88.106,68.252,100],"t":13.6},{"o":{"x":0.167,"y":-0.006},"i":{"x":0.833,"y":0.926},"s":[139.441,79.894,100],"t":14.4},{"o":{"x":0.167,"y":-0.681},"i":{"x":0.833,"y":1.246},"s":[91.59,121.922,100],"t":15.2},{"o":{"x":0.167,"y":0.062},"i":{"x":0.833,"y":1.031},"s":[96.806,109.051,100],"t":16},{"o":{"x":0.167,"y":0.023},"i":{"x":0.833,"y":0.909},"s":[76.174,121.699,100],"t":16.8},{"o":{"x":0.167,"y":1.035},"i":{"x":0.833,"y":2.265},"s":[104.516,94.655,100],"t":17.6},{"o":{"x":0.167,"y":0.078},"i":{"x":0.833,"y":1.009},"s":[106.997,114.689,100],"t":18.4},{"o":{"x":0.167,"y":0.008},"i":{"x":0.833,"y":0.918},"s":[66.837,106.412,100],"t":19.2},{"o":{"x":0.167,"y":-4.987},"i":{"x":0.833,"y":-2.408},"s":[111.464,106.778,100],"t":20},{"o":{"x":0.167,"y":0.085},"i":{"x":0.833,"y":0.975},"s":[110.731,78.932,100],"t":20.8},{"o":{"x":0.167,"y":-0.036},"i":{"x":0.833,"y":0.884},"s":[81.464,118.575,100],"t":21.6},{"o":{"x":0.167,"y":0.293},"i":{"x":0.833,"y":1.215},"s":[101.82,56.948,100],"t":22.4},{"o":{"x":0.167,"y":0.06},"i":{"x":0.833,"y":0.963},"s":[109.895,78.255,100],"t":23.2},{"o":{"x":0.167,"y":-0.066},"i":{"x":0.833,"y":0.916},"s":[80.942,137.249,100],"t":24},{"o":{"x":0.167,"y":12.816},"i":{"x":0.833,"y":-6.827},"s":[97.117,101.933,100],"t":24.8},{"o":{"x":0.167,"y":0.084},"i":{"x":0.833,"y":1.453},"s":[97.223,128.384,100],"t":25.6},{"o":{"x":0.167,"y":0.07},"i":{"x":0.833,"y":0.989},"s":[107.061,77.679,100],"t":26.4},{"o":{"x":0.167,"y":-0.013},"i":{"x":0.833,"y":0.947},"s":[43.764,81.828,100],"t":27.2},{"o":{"x":0.167,"y":-0.143},"i":{"x":0.833,"y":0.92},"s":[98.569,96.663,100],"t":28},{"o":{"x":0.167,"y":-2.31},"i":{"x":0.833,"y":2.435},"s":[78.363,95.331,100],"t":28.8},{"o":{"x":0.167,"y":0.079},"i":{"x":0.833,"y":0.931},"s":[79.067,61.85,100],"t":29.6},{"o":{"x":0.167,"y":-0.407},"i":{"x":0.833,"y":0.227},"s":[66.248,62.633,100],"t":30.4},{"o":{"x":0.167,"y":0.093},"i":{"x":0.833,"y":1.092},"s":[68.428,44.364,100],"t":31.2},{"o":{"x":0.167,"y":0.044},"i":{"x":0.833,"y":0.901},"s":[86.481,43.437,100],"t":32},{"o":{"x":0.167,"y":0.541},"i":{"x":0.833,"y":0.779},"s":[48.571,9.591,100],"t":32.8},{"o":{"x":0.167,"y":0.134},"i":{"x":0.833,"y":0.776},"s":[41.665,51.149,100],"t":33.6},{"o":{"x":0.167,"y":0.133},"i":{"x":0.833,"y":1.092},"s":[30.243,-8.194,100],"t":34.4},{"o":{"x":0.167,"y":0.044},"i":{"x":0.833,"y":0.935},"s":[10.976,57.43,100],"t":35.2},{"o":{"x":0.167,"y":-0.287},"i":{"x":0.833,"y":0.606},"s":[51.537,57.699,100],"t":36},{"o":{"x":0.167,"y":0.106},"i":{"x":0.833,"y":0.918},"s":[42.412,29.51,100],"t":36.8},{"o":{"x":0.167,"y":-5.253},"i":{"x":0.833,"y":-8.496},"s":[8.401,-24.232,100],"t":37.6},{"o":{"x":0.167,"y":0.084},"i":{"x":0.833,"y":0.961},"s":[8.932,21.756,100],"t":38.4},{"o":{"x":0.167,"y":-0.072},"i":{"x":0.833,"y":0.956},"s":[68.92,29.447,100],"t":39.2},{"o":{"x":0.167,"y":-0.094},"i":{"x":0.833,"y":1.049},"s":[36.715,52.274,100],"t":40},{"o":{"x":0.167,"y":0.031},"i":{"x":0.833,"y":0.899},"s":[51.861,53.306,100],"t":40.8},{"o":{"x":0.167,"y":0.481},"i":{"x":0.833,"y":1.136},"s":[27.738,59.151,100],"t":41.6},{"o":{"x":0.167,"y":0.052},"i":{"x":0.833,"y":1.062},"s":[22.685,9.056,100],"t":42.4},{"o":{"x":0.167,"y":0.035},"i":{"x":0.833,"y":0.882},"s":[35.966,4.115,100],"t":43.2},{"o":{"x":0.167,"y":0.285},"i":{"x":0.833,"y":1.028},"s":[12.831,-31.117,100],"t":44},{"o":{"x":0.167,"y":0.021},"i":{"x":0.833,"y":0.846},"s":[3.287,-4.957,100],"t":44.8},{"o":{"x":0.167,"y":0.182},"i":{"x":0.833,"y":0.815},"s":[16.066,27.774,100],"t":45.6},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.833},"s":[26.832,45.045,100],"t":46.4},{"s":[39.927,35.232,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.16},"i":{"x":0.833,"y":0.644},"s":[275.449,259.557,0],"t":6.4,"ti":[-2.494,-0.483,0],"to":[0.546,0.159,0]},{"o":{"x":0.167,"y":0.106},"i":{"x":0.833,"y":0.77},"s":[278.724,260.512,0],"t":7.2,"ti":[-5.49,-0.572,0],"to":[2.494,0.483,0]},{"o":{"x":0.167,"y":0.13},"i":{"x":0.833,"y":0.826},"s":[290.414,262.453,0],"t":8,"ti":[-7.452,0.063,0],"to":[5.49,0.572,0]},{"o":{"x":0.167,"y":0.158},"i":{"x":0.833,"y":0.845},"s":[311.663,263.943,0],"t":8.8,"ti":[-7.172,1.285,0],"to":[7.452,-0.063,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.854},"s":[335.126,262.075,0],"t":9.6,"ti":[-5.684,2.429,0],"to":[7.172,-1.285,0]},{"o":{"x":0.167,"y":0.157},"i":{"x":0.833,"y":0.869},"s":[354.697,256.231,0],"t":10.4,"ti":[-4.084,3.144,0],"to":[5.684,-2.429,0]},{"o":{"x":0.167,"y":0.128},"i":{"x":0.833,"y":0.892},"s":[369.23,247.5,0],"t":11.2,"ti":[-2.734,3.404,0],"to":[4.084,-3.144,0]},{"o":{"x":0.167,"y":0.096},"i":{"x":0.833,"y":0.917},"s":[379.199,237.368,0],"t":12,"ti":[-1.736,3.345,0],"to":[2.734,-3.404,0]},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.941},"s":[385.634,227.077,0],"t":12.8,"ti":[-1.056,3.132,0],"to":[1.736,-3.345,0]},{"o":{"x":0.167,"y":0.045},"i":{"x":0.833,"y":0.96},"s":[389.616,217.298,0],"t":13.6,"ti":[-0.604,2.868,0],"to":[1.056,-3.132,0]},{"o":{"x":0.167,"y":0.027},"i":{"x":0.833,"y":0.976},"s":[391.967,208.287,0],"t":14.4,"ti":[-0.305,2.608,0],"to":[0.604,-2.868,0]},{"o":{"x":0.167,"y":0.013},"i":{"x":0.833,"y":0.988},"s":[393.24,200.09,0],"t":15.2,"ti":[-0.105,2.371,0],"to":[0.305,-2.608,0]},{"o":{"x":0.167,"y":0.002},"i":{"x":0.833,"y":0.998},"s":[393.797,192.641,0],"t":16,"ti":[0.031,2.158,0],"to":[0.105,-2.371,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[393.871,185.865,0],"t":16.8,"ti":[0.123,1.968,0],"to":[-0.031,-2.158,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[393.614,179.691,0],"t":17.6,"ti":[0.186,1.797,0],"to":[-0.123,-1.968,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[393.131,174.057,0],"t":18.4,"ti":[0.228,1.644,0],"to":[-0.186,-1.797,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[392.497,168.908,0],"t":19.2,"ti":[0.251,1.504,0],"to":[-0.228,-1.644,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[391.765,164.196,0],"t":20,"ti":[0.261,1.377,0],"to":[-0.251,-1.504,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[390.988,159.882,0],"t":20.8,"ti":[0.262,1.261,0],"to":[-0.261,-1.377,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[390.199,155.932,0],"t":21.6,"ti":[0.256,1.155,0],"to":[-0.262,-1.261,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[389.418,152.313,0],"t":22.4,"ti":[0.246,1.057,0],"to":[-0.256,-1.155,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[388.662,149,0],"t":23.2,"ti":[0.233,0.967,0],"to":[-0.246,-1.057,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[387.941,145.969,0],"t":24,"ti":[0.217,0.882,0],"to":[-0.233,-0.967,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[387.264,143.201,0],"t":24.8,"ti":[0.199,0.803,0],"to":[-0.217,-0.882,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[386.64,140.677,0],"t":25.6,"ti":[0.18,0.729,0],"to":[-0.199,-0.803,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[386.071,138.382,0],"t":26.4,"ti":[0.159,0.659,0],"to":[-0.18,-0.729,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[385.563,136.303,0],"t":27.2,"ti":[0.138,0.594,0],"to":[-0.159,-0.659,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[385.116,134.426,0],"t":28,"ti":[0.117,0.531,0],"to":[-0.138,-0.594,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[384.732,132.741,0],"t":28.8,"ti":[0.096,0.473,0],"to":[-0.117,-0.531,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[384.411,131.237,0],"t":29.6,"ti":[0.076,0.417,0],"to":[-0.096,-0.473,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[384.153,129.905,0],"t":30.4,"ti":[0.055,0.364,0],"to":[-0.076,-0.417,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[383.957,128.736,0],"t":31.2,"ti":[0.036,0.314,0],"to":[-0.055,-0.364,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[383.821,127.721,0],"t":32,"ti":[0.017,0.266,0],"to":[-0.036,-0.314,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[383.742,126.852,0],"t":32.8,"ti":[0,0.222,0],"to":[-0.017,-0.266,0]},{"o":{"x":0.167,"y":0.008},"i":{"x":0.833,"y":0.993},"s":[383.718,126.122,0],"t":33.6,"ti":[-0.017,0.179,0],"to":[0,-0.222,0]},{"o":{"x":0.167,"y":0.029},"i":{"x":0.833,"y":0.977},"s":[383.745,125.523,0],"t":34.4,"ti":[-0.032,0.139,0],"to":[0.017,-0.179,0]},{"o":{"x":0.167,"y":0.059},"i":{"x":0.833,"y":0.954},"s":[383.819,125.048,0],"t":35.2,"ti":[-0.046,0.101,0],"to":[0.032,-0.139,0]},{"o":{"x":0.167,"y":0.101},"i":{"x":0.833,"y":0.92},"s":[383.937,124.69,0],"t":36,"ti":[-0.058,0.066,0],"to":[0.046,-0.101,0]},{"o":{"x":0.167,"y":0.146},"i":{"x":0.833,"y":0.873},"s":[384.093,124.442,0],"t":36.8,"ti":[-0.068,0.032,0],"to":[0.058,-0.066,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.838},"s":[384.283,124.297,0],"t":37.6,"ti":[-0.074,0.009,0],"to":[0.068,-0.032,0]},{"o":{"x":0.167,"y":0.166},"i":{"x":0.833,"y":0.838},"s":[384.5,124.247,0],"t":38.4,"ti":[-0.073,0.002,0],"to":[0.074,-0.009,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.84},"s":[384.725,124.244,0],"t":39.2,"ti":[-0.068,0.003,0],"to":[0.073,-0.002,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.843},"s":[384.937,124.237,0],"t":40,"ti":[-0.061,0.006,0],"to":[0.068,-0.003,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.848},"s":[385.131,124.223,0],"t":40.8,"ti":[-0.052,0.011,0],"to":[0.061,-0.006,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.854},"s":[385.302,124.198,0],"t":41.6,"ti":[-0.041,0.017,0],"to":[0.052,-0.011,0]},{"o":{"x":0.167,"y":0.158},"i":{"x":0.833,"y":0.866},"s":[385.442,124.158,0],"t":42.4,"ti":[-0.028,0.024,0],"to":[0.041,-0.017,0]},{"o":{"x":0.167,"y":0.113},"i":{"x":0.833,"y":0.898},"s":[385.546,124.097,0],"t":43.2,"ti":[-0.026,0.021,0],"to":[0.028,-0.024,0]},{"o":{"x":0.167,"y":0.153},"i":{"x":0.833,"y":0.836},"s":[385.612,124.016,0],"t":44,"ti":[-0.034,0.006,0],"to":[0.026,-0.021,0]},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.815},"s":[385.701,123.974,0],"t":44.8,"ti":[-0.043,-0.01,0],"to":[0.034,-0.006,0]},{"o":{"x":0.167,"y":0.139},"i":{"x":0.833,"y":0.83},"s":[385.818,123.981,0],"t":45.6,"ti":[-0.048,-0.025,0],"to":[0.043,0.01,0]},{"o":{"x":0.167,"y":0.129},"i":{"x":0.833,"y":0.859},"s":[385.957,124.035,0],"t":46.4,"ti":[-0.025,-0.016,0],"to":[0.048,0.025,0]},{"s":[386.107,124.13,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":6.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":10.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":28},{"s":[0],"t":40.8}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Polystar 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sr","bm":0,"hd":false,"mn":"ADBE Vector Shape - Star","nm":"Polystar Path 1","ix":1,"d":1,"pt":{"a":0,"k":3,"ix":3},"p":{"a":0,"k":[6,32],"ix":4},"or":{"a":0,"k":6.599,"ix":7},"os":{"a":0,"k":0,"ix":9},"r":{"a":0,"k":0,"ix":5},"sy":2},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0,0.7647,0.902],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-7.382,-25.677],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":35},{"ty":4,"nm":"Shape Layer 16","sr":1,"st":7.2,"op":48,"ip":7.2,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.563},"s":[92.322,93.922,100],"t":7.2},{"o":{"x":0.167,"y":0.103},"i":{"x":0.833,"y":1.109},"s":[95.253,42.092,100],"t":8},{"o":{"x":0.167,"y":0.047},"i":{"x":0.833,"y":1.054},"s":[107.675,106.42,100],"t":8.8},{"o":{"x":0.167,"y":0.033},"i":{"x":0.833,"y":0.929},"s":[79.026,82.445,100],"t":9.6},{"o":{"x":0.167,"y":-0.475},"i":{"x":0.833,"y":0.393},"s":[126.398,74.729,100],"t":10.4},{"o":{"x":0.167,"y":0.097},"i":{"x":0.833,"y":0.968},"s":[119.33,57.001,100],"t":11.2},{"o":{"x":0.167,"y":-0.053},"i":{"x":0.833,"y":0.834},"s":[74.88,81.854,100],"t":12},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":1.042},"s":[102.06,93.554,100],"t":12.8},{"o":{"x":0.167,"y":0.028},"i":{"x":0.833,"y":0.894},"s":[129.135,51.875,100],"t":13.6},{"o":{"x":0.167,"y":0.389},"i":{"x":0.833,"y":0.863},"s":[88.364,81.23,100],"t":14.4},{"o":{"x":0.167,"y":0.212},"i":{"x":0.833,"y":1.102},"s":[77.256,59.947,100],"t":15.2},{"o":{"x":0.167,"y":0.046},"i":{"x":0.833,"y":0.698},"s":[70.037,87.966,100],"t":16},{"o":{"x":0.167,"y":0.115},"i":{"x":0.833,"y":0.995},"s":[86.104,70.53,100],"t":16.8},{"o":{"x":0.167,"y":-0.006},"i":{"x":0.833,"y":0.904},"s":[128.201,94.177,100],"t":17.6},{"o":{"x":0.167,"y":0.627},"i":{"x":0.833,"y":1.376},"s":[88.836,56.66,100],"t":18.4},{"o":{"x":0.167,"y":0.068},"i":{"x":0.833,"y":0.999},"s":[82.802,125.882,100],"t":19.2},{"o":{"x":0.167,"y":-0.002},"i":{"x":0.833,"y":0.976},"s":[116.041,83.757,100],"t":20},{"o":{"x":0.167,"y":-0.033},"i":{"x":0.833,"y":0.9},"s":[83.397,114.487,100],"t":20.8},{"o":{"x":0.167,"y":0.508},"i":{"x":0.833,"y":1.069},"s":[106.769,47.904,100],"t":21.6},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":0.758},"s":[111.355,78.308,100],"t":22.4},{"o":{"x":0.167,"y":0.127},"i":{"x":0.833,"y":1.163},"s":[102.953,84.434,100],"t":23.2},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.9},"s":[86.963,81.742,100],"t":24},{"o":{"x":0.167,"y":0.493},"i":{"x":0.833,"y":1.429},"s":[134.26,102.822,100],"t":24.8},{"o":{"x":0.167,"y":0.07},"i":{"x":0.833,"y":0.944},"s":[143.885,103.815,100],"t":25.6},{"o":{"x":0.167,"y":-0.171},"i":{"x":0.833,"y":0.922},"s":[84.672,96.517,100],"t":26.4},{"o":{"x":0.167,"y":-1.171},"i":{"x":0.833,"y":-0.547},"s":[104.079,117.449,100],"t":27.2},{"o":{"x":0.167,"y":0.088},"i":{"x":0.833,"y":0.772},"s":[102.79,67.476,100],"t":28},{"o":{"x":0.167,"y":0.131},"i":{"x":0.833,"y":0.975},"s":[80.144,55.767,100],"t":28.8},{"o":{"x":0.167,"y":-0.036},"i":{"x":0.833,"y":0.822},"s":[40.802,55.268,100],"t":29.6},{"o":{"x":0.167,"y":0.157},"i":{"x":0.833,"y":0.966},"s":[68.335,58.584,100],"t":30.4},{"o":{"x":0.167,"y":-0.058},"i":{"x":0.833,"y":0.795},"s":[99.544,51.985,100],"t":31.2},{"o":{"x":0.167,"y":0.141},"i":{"x":0.833,"y":0.792},"s":[81.176,23.398,100],"t":32},{"o":{"x":0.167,"y":0.139},"i":{"x":0.833,"y":0.896},"s":[54.468,66.977,100],"t":32.8},{"o":{"x":0.167,"y":0.427},"i":{"x":0.833,"y":1.334},"s":[14.561,3.526,100],"t":33.6},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.853},"s":[4.89,62.465,100],"t":34.4},{"o":{"x":0.167,"y":0.192},"i":{"x":0.833,"y":1.066},"s":[53.289,10.271,100],"t":35.2},{"o":{"x":0.167,"y":0.037},"i":{"x":0.833,"y":0.882},"s":[90.493,46.486,100],"t":36},{"o":{"x":0.167,"y":0.284},"i":{"x":0.833,"y":1.078},"s":[23.844,-5.784,100],"t":36.8},{"o":{"x":0.167,"y":0.04},"i":{"x":0.833,"y":0.862},"s":[-3.767,9.434,100],"t":37.6},{"o":{"x":0.167,"y":0.211},"i":{"x":0.833,"y":0.96},"s":[49.843,42.088,100],"t":38.4},{"o":{"x":0.167,"y":-0.077},"i":{"x":0.833,"y":0.76},"s":[84.879,49.437,100],"t":39.2},{"o":{"x":0.167,"y":0.128},"i":{"x":0.833,"y":0.867},"s":[66.624,30.104,100],"t":40},{"o":{"x":0.167,"y":0.222},"i":{"x":0.833,"y":0.951},"s":[32.305,26.858,100],"t":40.8},{"o":{"x":0.167,"y":-0.117},"i":{"x":0.833,"y":0.916},"s":[11.683,-0.538,100],"t":41.6},{"o":{"x":0.167,"y":10.387},"i":{"x":0.833,"y":2.198},"s":[20.245,17.535,100],"t":42.4},{"o":{"x":0.167,"y":0.078},"i":{"x":0.833,"y":0.475},"s":[20.314,-45.662,100],"t":43.2},{"o":{"x":0.167,"y":0.099},"i":{"x":0.833,"y":1.442},"s":[19.25,-8.935,100],"t":44},{"o":{"x":0.167,"y":0.07},"i":{"x":0.833,"y":0.962},"s":[13.603,32.461,100],"t":44.8},{"o":{"x":0.167,"y":-0.071},"i":{"x":0.833,"y":1.007},"s":[49.18,13.788,100],"t":45.6},{"o":{"x":0.167,"y":0.006},"i":{"x":0.833,"y":0.833},"s":[29.913,35.117,100],"t":46.4},{"s":[50.756,73.724,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[275.519,261.1,0],"t":7.2,"ti":[1.698,1.185,0],"to":[-0.307,-0.313,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[273.678,259.22,0],"t":8,"ti":[1.745,-2.083,0],"to":[-1.698,-1.185,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[265.331,253.99,0],"t":8.8,"ti":[-0.013,-6.364,0],"to":[-1.745,2.083,0]},{"o":{"x":0.167,"y":0.017},"i":{"x":0.833,"y":0.983},"s":[263.209,271.718,0],"t":9.6,"ti":[-0.69,-6.377,0],"to":[0.013,6.364,0]},{"o":{"x":0.167,"y":0.019},"i":{"x":0.833,"y":0.983},"s":[265.411,292.176,0],"t":10.4,"ti":[-0.533,-5.437,0],"to":[0.69,6.377,0]},{"o":{"x":0.167,"y":0.016},"i":{"x":0.833,"y":0.987},"s":[267.35,309.98,0],"t":11.2,"ti":[-0.321,-4.543,0],"to":[0.533,5.437,0]},{"o":{"x":0.167,"y":0.01},"i":{"x":0.833,"y":0.992},"s":[268.609,324.8,0],"t":12,"ti":[-0.144,-3.839,0],"to":[0.321,4.543,0]},{"o":{"x":0.167,"y":0.003},"i":{"x":0.833,"y":0.997},"s":[269.275,337.239,0],"t":12.8,"ti":[-0.006,-3.291,0],"to":[0.144,3.839,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[269.475,347.837,0],"t":13.6,"ti":[0.101,-2.855,0],"to":[0.006,3.291,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[269.314,356.986,0],"t":14.4,"ti":[0.186,-2.499,0],"to":[-0.101,2.855,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[268.867,364.967,0],"t":15.2,"ti":[0.253,-2.201,0],"to":[-0.186,2.499,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[268.196,371.978,0],"t":16,"ti":[0.306,-1.947,0],"to":[-0.253,2.201,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[267.347,378.17,0],"t":16.8,"ti":[0.347,-1.728,0],"to":[-0.306,1.947,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[266.36,383.661,0],"t":17.6,"ti":[0.377,-1.535,0],"to":[-0.347,1.728,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[265.266,388.537,0],"t":18.4,"ti":[0.399,-1.366,0],"to":[-0.377,1.535,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[264.095,392.873,0],"t":19.2,"ti":[0.413,-1.215,0],"to":[-0.399,1.366,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[262.872,396.731,0],"t":20,"ti":[0.42,-1.082,0],"to":[-0.413,1.215,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[261.617,400.166,0],"t":20.8,"ti":[0.421,-0.962,0],"to":[-0.42,1.082,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[260.351,403.22,0],"t":21.6,"ti":[0.416,-0.854,0],"to":[-0.421,0.962,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[259.092,405.935,0],"t":22.4,"ti":[0.407,-0.759,0],"to":[-0.416,0.854,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[257.854,408.347,0],"t":23.2,"ti":[0.395,-0.675,0],"to":[-0.407,0.759,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[256.649,410.491,0],"t":24,"ti":[0.379,-0.6,0],"to":[-0.395,0.675,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[255.487,412.396,0],"t":24.8,"ti":[0.361,-0.535,0],"to":[-0.379,0.6,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[254.375,414.092,0],"t":25.6,"ti":[0.343,-0.477,0],"to":[-0.361,0.535,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[253.318,415.604,0],"t":26.4,"ti":[0.323,-0.427,0],"to":[-0.343,0.477,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[252.319,416.955,0],"t":27.2,"ti":[0.304,-0.384,0],"to":[-0.323,0.427,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[251.378,418.167,0],"t":28,"ti":[0.285,-0.347,0],"to":[-0.304,0.384,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[250.495,419.259,0],"t":28.8,"ti":[0.268,-0.316,0],"to":[-0.285,0.347,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[249.666,420.25,0],"t":29.6,"ti":[0.252,-0.289,0],"to":[-0.268,0.316,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[248.887,421.154,0],"t":30.4,"ti":[0.235,-0.266,0],"to":[-0.252,0.289,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[248.153,421.986,0],"t":31.2,"ti":[0.208,-0.241,0],"to":[-0.235,0.266,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[247.479,422.749,0],"t":32,"ti":[0.175,-0.214,0],"to":[-0.208,0.241,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[246.907,423.43,0],"t":32.8,"ti":[0.145,-0.189,0],"to":[-0.175,0.214,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[246.43,424.033,0],"t":33.6,"ti":[0.118,-0.164,0],"to":[-0.145,0.189,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[246.038,424.562,0],"t":34.4,"ti":[0.094,-0.141,0],"to":[-0.118,0.164,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[245.721,425.02,0],"t":35.2,"ti":[0.073,-0.118,0],"to":[-0.094,0.141,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[245.472,425.408,0],"t":36,"ti":[0.055,-0.096,0],"to":[-0.073,0.118,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[245.282,425.73,0],"t":36.8,"ti":[0.039,-0.074,0],"to":[-0.055,0.096,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[245.143,425.985,0],"t":37.6,"ti":[0.025,-0.053,0],"to":[-0.039,0.074,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[245.048,426.176,0],"t":38.4,"ti":[0.019,-0.036,0],"to":[-0.025,0.053,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[244.991,426.303,0],"t":39.2,"ti":[0.026,-0.027,0],"to":[-0.019,0.036,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[244.933,426.392,0],"t":40,"ti":[0.039,-0.021,0],"to":[-0.026,0.027,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[244.836,426.464,0],"t":40.8,"ti":[0.052,-0.016,0],"to":[-0.039,0.021,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[244.701,426.519,0],"t":41.6,"ti":[0.065,-0.01,0],"to":[-0.052,0.016,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[244.525,426.558,0],"t":42.4,"ti":[0.079,-0.004,0],"to":[-0.065,0.01,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[244.308,426.579,0],"t":43.2,"ti":[0.092,0.002,0],"to":[-0.079,0.004,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[244.051,426.582,0],"t":44,"ti":[0.105,0.007,0],"to":[-0.092,-0.002,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[243.755,426.569,0],"t":44.8,"ti":[0.117,0.012,0],"to":[-0.105,-0.007,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[243.422,426.54,0],"t":45.6,"ti":[0.128,0.017,0],"to":[-0.117,-0.012,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[243.055,426.497,0],"t":46.4,"ti":[0.066,0.01,0],"to":[-0.128,-0.017,0]},{"s":[242.656,426.439,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":7.2},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":11.2},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":28.8},{"s":[0],"t":41.6}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Polystar 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sr","bm":0,"hd":false,"mn":"ADBE Vector Shape - Star","nm":"Polystar Path 1","ix":1,"d":1,"pt":{"a":0,"k":3,"ix":3},"p":{"a":0,"k":[6,32],"ix":4},"or":{"a":0,"k":6.599,"ix":7},"os":{"a":0,"k":0,"ix":9},"r":{"a":0,"k":0,"ix":5},"sy":2},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0,0.7647,0.902],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-7.382,-25.677],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":36},{"ty":4,"nm":"Shape Layer 15","sr":1,"st":4.8,"op":48,"ip":4.8,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.755},"s":[82.502,83.365,100],"t":4.8},{"o":{"x":0.167,"y":0.126},"i":{"x":0.833,"y":1.13},"s":[92.567,121.915,100],"t":5.6},{"o":{"x":0.167,"y":0.051},"i":{"x":0.833,"y":0.954},"s":[112.053,80.824,100],"t":6.4},{"o":{"x":0.167,"y":-0.103},"i":{"x":0.833,"y":0.879},"s":[62.128,51.3,100],"t":7.2},{"o":{"x":0.167,"y":0.269},"i":{"x":0.833,"y":0.612},"s":[84.48,96.186,100],"t":8},{"o":{"x":0.167,"y":0.106},"i":{"x":0.833,"y":0.946},"s":[94.531,118.987,100],"t":8.8},{"o":{"x":0.167,"y":-0.155},"i":{"x":0.833,"y":0.7},"s":[131.266,61.724,100],"t":9.6},{"o":{"x":0.167,"y":0.115},"i":{"x":0.833,"y":0.907},"s":[118.417,29.003,100],"t":10.4},{"o":{"x":0.167,"y":0.826},"i":{"x":0.833,"y":1.355},"s":[85.075,64.302,100],"t":11.2},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.982},"s":[81.335,124.25,100],"t":12},{"o":{"x":0.167,"y":-0.023},"i":{"x":0.833,"y":0.912},"s":[101.012,65.094,100],"t":12.8},{"o":{"x":0.167,"y":1.722},"i":{"x":0.833,"y":-1.675},"s":[85.57,52.183,100],"t":13.6},{"o":{"x":0.167,"y":0.086},"i":{"x":0.833,"y":0.895},"s":[84.785,45.511,100],"t":14.4},{"o":{"x":0.167,"y":0.406},"i":{"x":0.833,"y":1.611},"s":[60.369,76.428,100],"t":15.2},{"o":{"x":0.167,"y":0.073},"i":{"x":0.833,"y":0.931},"s":[54.064,86.903,100],"t":16},{"o":{"x":0.167,"y":-0.399},"i":{"x":0.833,"y":0.849},"s":[106.629,102.562,100],"t":16.8},{"o":{"x":0.167,"y":0.186},"i":{"x":0.833,"y":0.815},"s":[97.556,35.47,100],"t":17.6},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.903},"s":[90.213,83.359,100],"t":18.4},{"o":{"x":0.167,"y":0.578},"i":{"x":0.833,"y":3.319},"s":[81.292,80.783,100],"t":19.2},{"o":{"x":0.167,"y":0.08},"i":{"x":0.833,"y":0.951},"s":[79.79,120.257,100],"t":20},{"o":{"x":0.167,"y":-0.122},"i":{"x":0.833,"y":0.962},"s":[123.086,57.838,100],"t":20.8},{"o":{"x":0.167,"y":-0.07},"i":{"x":0.833,"y":1.232},"s":[105.488,95.827,100],"t":21.6},{"o":{"x":0.167,"y":0.061},"i":{"x":0.833,"y":1.055},"s":[115.025,71.124,100],"t":22.4},{"o":{"x":0.167,"y":0.033},"i":{"x":0.833,"y":0.912},"s":[78.946,58.294,100],"t":23.2},{"o":{"x":0.167,"y":1.606},"i":{"x":0.833,"y":1.622},"s":[138.694,53.428,100],"t":24},{"o":{"x":0.167,"y":0.073},"i":{"x":0.833,"y":0.84},"s":[141.965,96.547,100],"t":24.8},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":1.001},"s":[114.285,104.867,100],"t":25.6},{"o":{"x":0.167,"y":0.001},"i":{"x":0.833,"y":1.034},"s":[88.923,121.377,100],"t":26.4},{"o":{"x":0.167,"y":0.024},"i":{"x":0.833,"y":0.803},"s":[114.574,47.291,100],"t":27.2},{"o":{"x":0.167,"y":0.145},"i":{"x":0.833,"y":0.958},"s":[78.466,55.906,100],"t":28},{"o":{"x":0.167,"y":-0.086},"i":{"x":0.833,"y":0.8},"s":[29.34,29.523,100],"t":28.8},{"o":{"x":0.167,"y":0.143},"i":{"x":0.833,"y":0.943},"s":[53.468,40.837,100],"t":29.6},{"o":{"x":0.167,"y":-0.176},"i":{"x":0.833,"y":0.752},"s":[87.347,20.728,100],"t":30.4},{"o":{"x":0.167,"y":0.126},"i":{"x":0.833,"y":0.766},"s":[76.456,37.629,100],"t":31.2},{"o":{"x":0.167,"y":0.129},"i":{"x":0.833,"y":0.931},"s":[54.995,87.783,100],"t":32},{"o":{"x":0.167,"y":-0.403},"i":{"x":0.833,"y":1.044},"s":[16.235,25.439,100],"t":32.8},{"o":{"x":0.167,"y":0.029},"i":{"x":0.833,"y":1.502},"s":[22.876,56.837,100],"t":33.6},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.932},"s":[12.722,-7.888,100],"t":34.4},{"o":{"x":0.167,"y":-0.373},"i":{"x":0.833,"y":0.475},"s":[84.051,38.375,100],"t":35.2},{"o":{"x":0.167,"y":0.099},"i":{"x":0.833,"y":0.949},"s":[71.021,35.491,100],"t":36},{"o":{"x":0.167,"y":-0.133},"i":{"x":0.833,"y":0.795},"s":[1.946,15.801,100],"t":36.8},{"o":{"x":0.167,"y":0.14},"i":{"x":0.833,"y":0.93},"s":[28.567,8.027,100],"t":37.6},{"o":{"x":0.167,"y":-0.452},"i":{"x":0.833,"y":0.248},"s":[67.532,49.862,100],"t":38.4},{"o":{"x":0.167,"y":0.094},"i":{"x":0.833,"y":0.928},"s":[61.469,0.74,100],"t":39.2},{"o":{"x":0.167,"y":-0.542},"i":{"x":0.833,"y":0.813},"s":[12.831,3.931,100],"t":40},{"o":{"x":0.167,"y":0.15},"i":{"x":0.833,"y":1.066},"s":[19.315,-27.951,100],"t":40.8},{"o":{"x":0.167,"y":0.037},"i":{"x":0.833,"y":1.028},"s":[27.419,33.62,100],"t":41.6},{"o":{"x":0.167,"y":0.021},"i":{"x":0.833,"y":1.067},"s":[12.92,-9.628,100],"t":42.4},{"o":{"x":0.167,"y":0.037},"i":{"x":0.833,"y":0.982},"s":[32.326,1.452,100],"t":43.2},{"o":{"x":0.167,"y":-0.022},"i":{"x":0.833,"y":0.849},"s":[-2.724,60.543,100],"t":44},{"o":{"x":0.167,"y":0.186},"i":{"x":0.833,"y":0.975},"s":[24.945,-5.97,100],"t":44.8},{"o":{"x":0.167,"y":-0.035},"i":{"x":0.833,"y":0.875},"s":[47.481,-1.498,100],"t":45.6},{"o":{"x":0.167,"y":0.25},"i":{"x":0.833,"y":0.833},"s":[31.587,60.823,100],"t":46.4},{"s":[23.622,20.517,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[275.485,257.563,0],"t":4.8,"ti":[0.689,1.001,0],"to":[-0.11,-0.249,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[274.824,256.066,0],"t":5.6,"ti":[1.729,2.01,0],"to":[-0.689,-1.001,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[271.354,251.559,0],"t":6.4,"ti":[2.505,2.573,0],"to":[-1.729,-2.01,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[264.452,244.008,0],"t":7.2,"ti":[2.58,2.412,0],"to":[-2.505,-2.573,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[256.321,236.124,0],"t":8,"ti":[2.262,1.991,0],"to":[-2.58,-2.412,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[248.97,229.538,0],"t":8.8,"ti":[1.91,1.643,0],"to":[-2.262,-1.991,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[242.747,224.176,0],"t":9.6,"ti":[1.608,1.404,0],"to":[-1.91,-1.643,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[237.508,219.678,0],"t":10.4,"ti":[1.343,1.257,0],"to":[-1.608,-1.404,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[233.099,215.75,0],"t":11.2,"ti":[1.062,1.209,0],"to":[-1.343,-1.257,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[229.447,212.138,0],"t":12,"ti":[0.452,1.267,0],"to":[-1.062,-1.209,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[226.724,208.498,0],"t":12.8,"ti":[-0.52,1.026,0],"to":[-0.452,-1.267,0]},{"o":{"x":0.167,"y":0.138},"i":{"x":0.833,"y":0.874},"s":[226.732,204.537,0],"t":13.6,"ti":[-1.055,0.562,0],"to":[0.52,-1.026,0]},{"o":{"x":0.167,"y":0.166},"i":{"x":0.833,"y":0.852},"s":[229.844,202.343,0],"t":14.4,"ti":[-1.033,0.324,0],"to":[1.055,-0.562,0]},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.847},"s":[233.062,201.165,0],"t":15.2,"ti":[-0.951,0.215,0],"to":[1.033,-0.324,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.844},"s":[236.043,200.396,0],"t":16,"ti":[-0.867,0.144,0],"to":[0.951,-0.215,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.842},"s":[238.767,199.873,0],"t":16.8,"ti":[-0.789,0.088,0],"to":[0.867,-0.144,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.842},"s":[241.247,199.533,0],"t":17.6,"ti":[-0.717,0.039,0],"to":[0.789,-0.088,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.84},"s":[243.501,199.346,0],"t":18.4,"ti":[-0.654,0.005,0],"to":[0.717,-0.039,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.84},"s":[245.548,199.298,0],"t":19.2,"ti":[-0.601,-0.009,0],"to":[0.654,-0.005,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.84},"s":[247.425,199.317,0],"t":20,"ti":[-0.552,-0.013,0],"to":[0.601,0.009,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.841},"s":[249.152,199.353,0],"t":20.8,"ti":[-0.504,-0.015,0],"to":[0.552,0.013,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.841},"s":[250.734,199.397,0],"t":21.6,"ti":[-0.457,-0.014,0],"to":[0.504,0.015,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.842},"s":[252.175,199.441,0],"t":22.4,"ti":[-0.412,-0.011,0],"to":[0.457,0.014,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.843},"s":[253.479,199.479,0],"t":23.2,"ti":[-0.367,-0.007,0],"to":[0.412,0.011,0]},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":0.844},"s":[254.647,199.506,0],"t":24,"ti":[-0.324,-0.001,0],"to":[0.367,0.007,0]},{"o":{"x":0.167,"y":0.179},"i":{"x":0.833,"y":0.845},"s":[255.684,199.519,0],"t":24.8,"ti":[-0.281,0.005,0],"to":[0.324,0.001,0]},{"o":{"x":0.167,"y":0.18},"i":{"x":0.833,"y":0.847},"s":[256.59,199.514,0],"t":25.6,"ti":[-0.238,0.012,0],"to":[0.281,-0.005,0]},{"o":{"x":0.167,"y":0.183},"i":{"x":0.833,"y":0.849},"s":[257.369,199.488,0],"t":26.4,"ti":[-0.197,0.019,0],"to":[0.238,-0.012,0]},{"o":{"x":0.167,"y":0.184},"i":{"x":0.833,"y":0.852},"s":[258.021,199.442,0],"t":27.2,"ti":[-0.156,0.027,0],"to":[0.197,-0.019,0]},{"o":{"x":0.167,"y":0.184},"i":{"x":0.833,"y":0.858},"s":[258.548,199.373,0],"t":28,"ti":[-0.116,0.034,0],"to":[0.156,-0.027,0]},{"o":{"x":0.167,"y":0.18},"i":{"x":0.833,"y":0.866},"s":[258.956,199.282,0],"t":28.8,"ti":[-0.078,0.042,0],"to":[0.116,-0.034,0]},{"o":{"x":0.167,"y":0.158},"i":{"x":0.833,"y":0.883},"s":[259.247,199.167,0],"t":29.6,"ti":[-0.042,0.049,0],"to":[0.078,-0.042,0]},{"o":{"x":0.167,"y":0.078},"i":{"x":0.833,"y":0.931},"s":[259.427,199.031,0],"t":30.4,"ti":[-0.007,0.055,0],"to":[0.042,-0.049,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[259.498,198.875,0],"t":31.2,"ti":[0.027,0.061,0],"to":[0.007,-0.055,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[259.466,198.699,0],"t":32,"ti":[0.059,0.066,0],"to":[-0.027,-0.061,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[259.336,198.506,0],"t":32.8,"ti":[0.089,0.071,0],"to":[-0.059,-0.066,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[259.112,198.3,0],"t":33.6,"ti":[0.117,0.074,0],"to":[-0.089,-0.071,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[258.802,198.083,0],"t":34.4,"ti":[0.142,0.075,0],"to":[-0.117,-0.074,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[258.411,197.859,0],"t":35.2,"ti":[0.165,0.075,0],"to":[-0.142,-0.075,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[257.947,197.632,0],"t":36,"ti":[0.182,0.074,0],"to":[-0.165,-0.075,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[257.418,197.407,0],"t":36.8,"ti":[0.188,0.072,0],"to":[-0.182,-0.074,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[256.856,197.186,0],"t":37.6,"ti":[0.188,0.068,0],"to":[-0.188,-0.072,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[256.29,196.974,0],"t":38.4,"ti":[0.184,0.062,0],"to":[-0.188,-0.068,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[255.73,196.777,0],"t":39.2,"ti":[0.178,0.054,0],"to":[-0.184,-0.062,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[255.185,196.601,0],"t":40,"ti":[0.168,0.043,0],"to":[-0.178,-0.054,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[254.664,196.453,0],"t":40.8,"ti":[0.154,0.03,0],"to":[-0.168,-0.043,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[254.178,196.341,0],"t":41.6,"ti":[0.136,0.014,0],"to":[-0.154,-0.03,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[253.74,196.272,0],"t":42.4,"ti":[0.114,-0.009,0],"to":[-0.136,-0.014,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[253.361,196.256,0],"t":43.2,"ti":[0.088,-0.039,0],"to":[-0.114,0.009,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[253.059,196.325,0],"t":44,"ti":[0.062,-0.069,0],"to":[-0.088,0.039,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[252.835,196.49,0],"t":44.8,"ti":[0.038,-0.096,0],"to":[-0.062,0.069,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[252.687,196.74,0],"t":45.6,"ti":[0.015,-0.119,0],"to":[-0.038,0.096,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[252.609,197.066,0],"t":46.4,"ti":[0.002,-0.065,0],"to":[-0.015,0.119,0]},{"s":[252.597,197.456,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":4.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":8.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":26.4},{"s":[0],"t":39.2}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Polystar 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sr","bm":0,"hd":false,"mn":"ADBE Vector Shape - Star","nm":"Polystar Path 1","ix":1,"d":1,"pt":{"a":0,"k":3,"ix":3},"p":{"a":0,"k":[6,32],"ix":4},"or":{"a":0,"k":6.599,"ix":7},"os":{"a":0,"k":0,"ix":9},"r":{"a":0,"k":0,"ix":5},"sy":2},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0,0.7647,0.902],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-7.382,-25.677],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":37},{"ty":4,"nm":"Shape Layer 14","sr":1,"st":5.6,"op":48,"ip":5.6,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.973},"s":[98.652,70.754,100],"t":5.6},{"o":{"x":0.167,"y":-0.04},"i":{"x":0.833,"y":0.848},"s":[52.407,72.577,100],"t":6.4},{"o":{"x":0.167,"y":0.184},"i":{"x":0.833,"y":0.779},"s":[83.757,80.783,100],"t":7.2},{"o":{"x":0.167,"y":0.134},"i":{"x":0.833,"y":0.979},"s":[109.776,120.093,100],"t":8},{"o":{"x":0.167,"y":-0.028},"i":{"x":0.833,"y":0.877},"s":[152.905,82.158,100],"t":8.8},{"o":{"x":0.167,"y":0.257},"i":{"x":0.833,"y":0.679},"s":[120.66,59.419,100],"t":9.6},{"o":{"x":0.167,"y":0.113},"i":{"x":0.833,"y":0.91},"s":[105.207,68.721,100],"t":10.4},{"o":{"x":0.167,"y":1.14},"i":{"x":0.833,"y":1.545},"s":[61.164,101.207,100],"t":11.2},{"o":{"x":0.167,"y":0.072},"i":{"x":0.833,"y":0.937},"s":[57.69,84.913,100],"t":12},{"o":{"x":0.167,"y":-0.256},"i":{"x":0.833,"y":0.643},"s":[83.888,62.79,100],"t":12.8},{"o":{"x":0.167,"y":0.109},"i":{"x":0.833,"y":0.821},"s":[77.451,85.785,100],"t":13.6},{"o":{"x":0.167,"y":0.156},"i":{"x":0.833,"y":1.087},"s":[56.288,101.636,100],"t":14.4},{"o":{"x":0.167,"y":0.042},"i":{"x":0.833,"y":0.943},"s":[32.111,124.298,100],"t":15.2},{"o":{"x":0.167,"y":-0.178},"i":{"x":0.833,"y":1.091},"s":[81.428,129.386,100],"t":16},{"o":{"x":0.167,"y":0.043},"i":{"x":0.833,"y":1.009},"s":[65.685,67.723,100],"t":16.8},{"o":{"x":0.167,"y":0.008},"i":{"x":0.833,"y":0.955},"s":[98.593,38.482,100],"t":17.6},{"o":{"x":0.167,"y":-0.096},"i":{"x":0.833,"y":0.732},"s":[62.324,56.222,100],"t":18.4},{"o":{"x":0.167,"y":0.121},"i":{"x":0.833,"y":0.936},"s":[79.166,81.278,100],"t":19.2},{"o":{"x":0.167,"y":-0.276},"i":{"x":0.833,"y":0.932},"s":[116.554,85.792,100],"t":20},{"o":{"x":0.167,"y":-0.377},"i":{"x":0.833,"y":1.592},"s":[107.89,120.793,100],"t":20.8},{"o":{"x":0.167,"y":0.073},"i":{"x":0.833,"y":1.083},"s":[109.46,111.669,100],"t":21.6},{"o":{"x":0.167,"y":0.042},"i":{"x":0.833,"y":0.998},"s":[96.752,92.8,100],"t":22.4},{"o":{"x":0.167,"y":-0.002},"i":{"x":0.833,"y":0.958},"s":[122.109,58.72,100],"t":23.2},{"o":{"x":0.167,"y":-0.084},"i":{"x":0.833,"y":1.192},"s":[97.302,70.284,100],"t":24},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.964},"s":[109.621,102.162,100],"t":24.8},{"o":{"x":0.167,"y":-0.063},"i":{"x":0.833,"y":0.897},"s":[68.943,121.676,100],"t":25.6},{"o":{"x":0.167,"y":0.428},"i":{"x":0.833,"y":1.514},"s":[92.184,74.87,100],"t":26.4},{"o":{"x":0.167,"y":0.072},"i":{"x":0.833,"y":0.944},"s":[97.803,100.145,100],"t":27.2},{"o":{"x":0.167,"y":-0.175},"i":{"x":0.833,"y":0.734},"s":[57.518,90.885,100],"t":28},{"o":{"x":0.167,"y":0.121},"i":{"x":0.833,"y":1.006},"s":[70.533,61.657,100],"t":28.8},{"o":{"x":0.167,"y":0.006},"i":{"x":0.833,"y":0.907},"s":[99.011,22.279,100],"t":29.6},{"o":{"x":0.167,"y":0.773},"i":{"x":0.833,"y":1.045},"s":[68.391,34.404,100],"t":30.4},{"o":{"x":0.167,"y":0.029},"i":{"x":0.833,"y":0.907},"s":[64.692,74.939,100],"t":31.2},{"o":{"x":0.167,"y":0.82},"i":{"x":0.833,"y":8.194},"s":[70.385,95.308,100],"t":32},{"o":{"x":0.167,"y":0.082},"i":{"x":0.833,"y":0.944},"s":[71.029,82.647,100],"t":32.8},{"o":{"x":0.167,"y":-0.168},"i":{"x":0.833,"y":0.654},"s":[14.793,22.846,100],"t":33.6},{"o":{"x":0.167,"y":0.11},"i":{"x":0.833,"y":1.026},"s":[33.445,25.195,100],"t":34.4},{"o":{"x":0.167,"y":0.02},"i":{"x":0.833,"y":0.908},"s":[92.281,46.336,100],"t":35.2},{"o":{"x":0.167,"y":0.884},"i":{"x":0.833,"y":0.981},"s":[15.049,48.962,100],"t":36},{"o":{"x":0.167,"y":-0.024},"i":{"x":0.833,"y":0.761},"s":[7.007,31.245,100],"t":36.8},{"o":{"x":0.167,"y":0.128},"i":{"x":0.833,"y":1.054},"s":[13.248,38.566,100],"t":37.6},{"o":{"x":0.167,"y":0.033},"i":{"x":0.833,"y":0.957},"s":[24.888,3.264,100],"t":38.4},{"o":{"x":0.167,"y":-0.09},"i":{"x":0.833,"y":0.6},"s":[5.738,12.341,100],"t":39.2},{"o":{"x":0.167,"y":0.105},"i":{"x":0.833,"y":0.956},"s":[14.963,-1.634,100],"t":40},{"o":{"x":0.167,"y":-0.091},"i":{"x":0.833,"y":0.929},"s":[50.015,13.874,100],"t":40.8},{"o":{"x":0.167,"y":-0.46},"i":{"x":0.833,"y":2.185},"s":[33.27,10.27,100],"t":41.6},{"o":{"x":0.167,"y":0.078},"i":{"x":0.833,"y":0.869},"s":[35.84,-1.726,100],"t":42.4},{"o":{"x":0.167,"y":0.228},"i":{"x":0.833,"y":1.164},"s":[-3.278,56.039,100],"t":43.2},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.948},"s":[-25.859,19.601,100],"t":44},{"o":{"x":0.167,"y":-0.139},"i":{"x":0.833,"y":0.951},"s":[41.265,-12.971,100],"t":44.8},{"o":{"x":0.167,"y":-0.118},"i":{"x":0.833,"y":1.325},"s":[16.064,44.564,100],"t":45.6},{"o":{"x":0.167,"y":0.066},"i":{"x":0.833,"y":0.833},"s":[26.47,30.06,100],"t":46.4},{"s":[-24.557,-2.189,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[276.873,250.83,0],"t":5.6,"ti":[1.057,0.986,0],"to":[-0.189,-0.223,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[275.739,249.492,0],"t":6.4,"ti":[2.736,1.782,0],"to":[-1.057,-0.986,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[270.529,244.915,0],"t":7.2,"ti":[4.156,1.618,0],"to":[-2.736,-1.782,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[259.324,238.803,0],"t":8,"ti":[4.345,0.759,0],"to":[-4.156,-1.618,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[245.595,235.21,0],"t":8.8,"ti":[3.769,0.09,0],"to":[-4.345,-0.759,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[233.251,234.251,0],"t":9.6,"ti":[3.138,-0.25,0],"to":[-3.769,-0.09,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[222.982,234.672,0],"t":10.4,"ti":[2.634,-0.412,0],"to":[-3.138,0.25,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[214.421,235.749,0],"t":11.2,"ti":[2.24,-0.491,0],"to":[-2.634,0.412,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[207.179,237.146,0],"t":12,"ti":[1.931,-0.529,0],"to":[-2.24,0.491,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[200.979,238.697,0],"t":12.8,"ti":[1.683,-0.547,0],"to":[-1.931,0.529,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[195.596,240.321,0],"t":13.6,"ti":[1.48,-0.555,0],"to":[-1.683,0.547,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[190.881,241.977,0],"t":14.4,"ti":[1.309,-0.559,0],"to":[-1.48,0.555,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[186.716,243.649,0],"t":15.2,"ti":[1.16,-0.566,0],"to":[-1.309,0.559,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[183.025,245.334,0],"t":16,"ti":[1.025,-0.581,0],"to":[-1.16,0.566,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[179.755,247.045,0],"t":16.8,"ti":[0.884,-0.616,0],"to":[-1.025,0.581,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[176.877,248.822,0],"t":17.6,"ti":[0.678,-0.697,0],"to":[-0.884,0.616,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[174.448,250.742,0],"t":18.4,"ti":[0.181,-0.747,0],"to":[-0.678,0.697,0]},{"o":{"x":0.167,"y":0.043},"i":{"x":0.833,"y":0.963},"s":[172.806,253.001,0],"t":19.2,"ti":[-0.395,-0.538,0],"to":[-0.181,0.747,0]},{"o":{"x":0.167,"y":0.153},"i":{"x":0.833,"y":0.865},"s":[173.36,255.224,0],"t":20,"ti":[-0.6,-0.241,0],"to":[0.395,0.538,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.849},"s":[175.177,256.227,0],"t":20.8,"ti":[-0.564,-0.106,0],"to":[0.6,0.241,0]},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":0.845},"s":[176.961,256.669,0],"t":21.6,"ti":[-0.502,-0.043,0],"to":[0.564,0.106,0]},{"o":{"x":0.167,"y":0.179},"i":{"x":0.833,"y":0.844},"s":[178.564,256.865,0],"t":22.4,"ti":[-0.439,-0.008,0],"to":[0.502,0.043,0]},{"o":{"x":0.167,"y":0.179},"i":{"x":0.833,"y":0.845},"s":[179.975,256.928,0],"t":23.2,"ti":[-0.38,0.014,0],"to":[0.439,0.008,0]},{"o":{"x":0.167,"y":0.18},"i":{"x":0.833,"y":0.846},"s":[181.2,256.911,0],"t":24,"ti":[-0.325,0.028,0],"to":[0.38,-0.014,0]},{"o":{"x":0.167,"y":0.18},"i":{"x":0.833,"y":0.847},"s":[182.253,256.843,0],"t":24.8,"ti":[-0.275,0.036,0],"to":[0.325,-0.028,0]},{"o":{"x":0.167,"y":0.18},"i":{"x":0.833,"y":0.849},"s":[183.148,256.743,0],"t":25.6,"ti":[-0.23,0.04,0],"to":[0.275,-0.036,0]},{"o":{"x":0.167,"y":0.179},"i":{"x":0.833,"y":0.851},"s":[183.9,256.626,0],"t":26.4,"ti":[-0.19,0.041,0],"to":[0.23,-0.04,0]},{"o":{"x":0.167,"y":0.179},"i":{"x":0.833,"y":0.852},"s":[184.526,256.502,0],"t":27.2,"ti":[-0.155,0.04,0],"to":[0.19,-0.041,0]},{"o":{"x":0.167,"y":0.178},"i":{"x":0.833,"y":0.856},"s":[185.04,256.378,0],"t":28,"ti":[-0.125,0.037,0],"to":[0.155,-0.04,0]},{"o":{"x":0.167,"y":0.179},"i":{"x":0.833,"y":0.857},"s":[185.458,256.261,0],"t":28.8,"ti":[-0.1,0.031,0],"to":[0.125,-0.037,0]},{"o":{"x":0.167,"y":0.179},"i":{"x":0.833,"y":0.855},"s":[185.791,256.158,0],"t":29.6,"ti":[-0.082,0.022,0],"to":[0.1,-0.031,0]},{"o":{"x":0.167,"y":0.18},"i":{"x":0.833,"y":0.842},"s":[186.06,256.075,0],"t":30.4,"ti":[-0.073,0.001,0],"to":[0.082,-0.022,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.827},"s":[186.284,256.027,0],"t":31.2,"ti":[-0.069,-0.03,0],"to":[0.073,-0.001,0]},{"o":{"x":0.167,"y":0.13},"i":{"x":0.833,"y":0.848},"s":[186.495,256.07,0],"t":32,"ti":[-0.067,-0.059,0],"to":[0.069,0.03,0]},{"o":{"x":0.167,"y":0.103},"i":{"x":0.833,"y":0.878},"s":[186.699,256.205,0],"t":32.8,"ti":[-0.065,-0.084,0],"to":[0.067,0.059,0]},{"o":{"x":0.167,"y":0.086},"i":{"x":0.833,"y":0.9},"s":[186.897,256.422,0],"t":33.6,"ti":[-0.063,-0.106,0],"to":[0.065,0.084,0]},{"o":{"x":0.167,"y":0.074},"i":{"x":0.833,"y":0.917},"s":[187.09,256.71,0],"t":34.4,"ti":[-0.062,-0.125,0],"to":[0.063,0.106,0]},{"o":{"x":0.167,"y":0.065},"i":{"x":0.833,"y":0.928},"s":[187.278,257.059,0],"t":35.2,"ti":[-0.059,-0.141,0],"to":[0.062,0.125,0]},{"o":{"x":0.167,"y":0.059},"i":{"x":0.833,"y":0.937},"s":[187.46,257.46,0],"t":36,"ti":[-0.057,-0.153,0],"to":[0.059,0.141,0]},{"o":{"x":0.167,"y":0.054},"i":{"x":0.833,"y":0.943},"s":[187.635,257.904,0],"t":36.8,"ti":[-0.059,-0.163,0],"to":[0.057,0.153,0]},{"o":{"x":0.167,"y":0.057},"i":{"x":0.833,"y":0.94},"s":[187.802,258.381,0],"t":37.6,"ti":[-0.07,-0.168,0],"to":[0.059,0.163,0]},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.93},"s":[187.988,258.88,0],"t":38.4,"ti":[-0.084,-0.171,0],"to":[0.07,0.168,0]},{"o":{"x":0.167,"y":0.076},"i":{"x":0.833,"y":0.921},"s":[188.22,259.391,0],"t":39.2,"ti":[-0.097,-0.171,0],"to":[0.084,0.171,0]},{"o":{"x":0.167,"y":0.085},"i":{"x":0.833,"y":0.914},"s":[188.492,259.907,0],"t":40,"ti":[-0.108,-0.169,0],"to":[0.097,0.171,0]},{"o":{"x":0.167,"y":0.092},"i":{"x":0.833,"y":0.907},"s":[188.799,260.419,0],"t":40.8,"ti":[-0.117,-0.165,0],"to":[0.108,0.169,0]},{"o":{"x":0.167,"y":0.099},"i":{"x":0.833,"y":0.901},"s":[189.138,260.923,0],"t":41.6,"ti":[-0.125,-0.159,0],"to":[0.117,0.165,0]},{"o":{"x":0.167,"y":0.106},"i":{"x":0.833,"y":0.895},"s":[189.502,261.41,0],"t":42.4,"ti":[-0.13,-0.151,0],"to":[0.125,0.159,0]},{"o":{"x":0.167,"y":0.113},"i":{"x":0.833,"y":0.89},"s":[189.886,261.876,0],"t":43.2,"ti":[-0.134,-0.141,0],"to":[0.13,0.151,0]},{"o":{"x":0.167,"y":0.119},"i":{"x":0.833,"y":0.885},"s":[190.284,262.315,0],"t":44,"ti":[-0.135,-0.13,0],"to":[0.134,0.141,0]},{"o":{"x":0.167,"y":0.126},"i":{"x":0.833,"y":0.88},"s":[190.69,262.722,0],"t":44.8,"ti":[-0.135,-0.117,0],"to":[0.135,0.13,0]},{"o":{"x":0.167,"y":0.133},"i":{"x":0.833,"y":0.876},"s":[191.097,263.093,0],"t":45.6,"ti":[-0.132,-0.103,0],"to":[0.135,0.117,0]},{"o":{"x":0.167,"y":0.139},"i":{"x":0.833,"y":0.865},"s":[191.499,263.423,0],"t":46.4,"ti":[-0.065,-0.048,0],"to":[0.132,0.103,0]},{"s":[191.888,263.709,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":5.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":9.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":27.2},{"s":[0],"t":40}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Rectangle 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[0.012,10.621],[-5.695,5.34],[-2.557,-7.377],[3.15,-2.096]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[1,0.6863,0],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-3.421,4.043],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":38},{"ty":4,"nm":"Shape Layer 13","sr":1,"st":8,"op":48,"ip":8,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.884},"s":[150.023,84.302,100],"t":8},{"o":{"x":0.167,"y":0.295},"i":{"x":0.833,"y":0.718},"s":[115.536,94.772,100],"t":8.8},{"o":{"x":0.167,"y":0.118},"i":{"x":0.833,"y":0.873},"s":[101.947,84.391,100],"t":9.6},{"o":{"x":0.167,"y":0.243},"i":{"x":0.833,"y":1.035},"s":[69.48,67.085,100],"t":10.4},{"o":{"x":0.167,"y":0.025},"i":{"x":0.833,"y":0.989},"s":[52.556,63.303,100],"t":11.2},{"o":{"x":0.167,"y":-0.012},"i":{"x":0.833,"y":0.856},"s":[76.674,80.31,100],"t":12},{"o":{"x":0.167,"y":0.197},"i":{"x":0.833,"y":0.805},"s":[55.698,101.414,100],"t":12.8},{"o":{"x":0.167,"y":0.145},"i":{"x":0.833,"y":1.152},"s":[40.385,120.878,100],"t":13.6},{"o":{"x":0.167,"y":0.054},"i":{"x":0.833,"y":0.954},"s":[19.82,111.938,100],"t":14.4},{"o":{"x":0.167,"y":-0.102},"i":{"x":0.833,"y":1.016},"s":[78.004,125.754,100],"t":15.2},{"o":{"x":0.167,"y":0.013},"i":{"x":0.833,"y":0.949},"s":[51.803,75.606,100],"t":16},{"o":{"x":0.167,"y":-0.135},"i":{"x":0.833,"y":1.062},"s":[82.948,47.853,100],"t":16.8},{"o":{"x":0.167,"y":0.035},"i":{"x":0.833,"y":0.885},"s":[71.038,46.152,100],"t":17.6},{"o":{"x":0.167,"y":0.302},"i":{"x":0.833,"y":0.784},"s":[91.761,46.937,100],"t":18.4},{"o":{"x":0.167,"y":0.136},"i":{"x":0.833,"y":0.922},"s":[99.655,57.625,100],"t":19.2},{"o":{"x":0.167,"y":-1.133},"i":{"x":0.833,"y":0.883},"s":[112.222,122.076,100],"t":20},{"o":{"x":0.167,"y":0.289},"i":{"x":0.833,"y":4.25},"s":[111.361,120.336,100],"t":20.8},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":1.223},"s":[111.012,117.65,100],"t":21.6},{"o":{"x":0.167,"y":0.061},"i":{"x":0.833,"y":0.926},"s":[124.959,96.101,100],"t":22.4},{"o":{"x":0.167,"y":-0.648},"i":{"x":0.833,"y":1.488},"s":[73.624,74.745,100],"t":23.2},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.933},"s":[79.474,96.927,100],"t":24},{"o":{"x":0.167,"y":-0.337},"i":{"x":0.833,"y":0.44},"s":[39.363,83.33,100],"t":24.8},{"o":{"x":0.167,"y":0.098},"i":{"x":0.833,"y":0.955},"s":[47.32,90.031,100],"t":25.6},{"o":{"x":0.167,"y":-0.099},"i":{"x":0.833,"y":0.968},"s":[92.847,97.529,100],"t":26.4},{"o":{"x":0.167,"y":-0.051},"i":{"x":0.833,"y":0.719},"s":[72.017,148.186,100],"t":27.2},{"o":{"x":0.167,"y":0.118},"i":{"x":0.833,"y":1.036},"s":[84.935,114.918,100],"t":28},{"o":{"x":0.167,"y":0.025},"i":{"x":0.833,"y":0.917},"s":[115.633,56.769,100],"t":28.8},{"o":{"x":0.167,"y":-14.6},"i":{"x":0.833,"y":-3.33},"s":[71.733,63.301,100],"t":29.6},{"o":{"x":0.167,"y":0.085},"i":{"x":0.833,"y":0.842},"s":[71.982,53.5,100],"t":30.4},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":1.296},"s":[84.68,111.004,100],"t":31.2},{"o":{"x":0.167,"y":0.065},"i":{"x":0.833,"y":0.873},"s":[96.026,124.642,100],"t":32},{"o":{"x":0.167,"y":0.241},"i":{"x":0.833,"y":1.082},"s":[44.359,68.117,100],"t":32.8},{"o":{"x":0.167,"y":0.041},"i":{"x":0.833,"y":0.979},"s":[16.99,33.186,100],"t":33.6},{"o":{"x":0.167,"y":-0.028},"i":{"x":0.833,"y":0.848},"s":[71.31,31.618,100],"t":34.4},{"o":{"x":0.167,"y":0.185},"i":{"x":0.833,"y":0.963},"s":[30.563,51.009,100],"t":35.2},{"o":{"x":0.167,"y":-0.066},"i":{"x":0.833,"y":0.958},"s":[-2.843,83.398,100],"t":36},{"o":{"x":0.167,"y":-0.084},"i":{"x":0.833,"y":1.188},"s":[15.771,36.624,100],"t":36.8},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.924},"s":[6.523,25.933,100],"t":37.6},{"o":{"x":0.167,"y":-0.823},"i":{"x":0.833,"y":1.308},"s":[36.606,28.591,100],"t":38.4},{"o":{"x":0.167,"y":0.066},"i":{"x":0.833,"y":0.857},"s":[33.84,58.624,100],"t":39.2},{"o":{"x":0.167,"y":0.199},"i":{"x":0.833,"y":1.022},"s":[46.823,19.638,100],"t":40},{"o":{"x":0.167,"y":0.018},"i":{"x":0.833,"y":0.667},"s":[56.147,-3.469,100],"t":40.8},{"o":{"x":0.167,"y":0.111},"i":{"x":0.833,"y":0.868},"s":[44.338,8.441,100],"t":41.6},{"o":{"x":0.167,"y":0.227},"i":{"x":0.833,"y":1.071},"s":[8.892,30.372,100],"t":42.4},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":1.016},"s":[-11.629,50.878,100],"t":43.2},{"o":{"x":0.167,"y":0.013},"i":{"x":0.833,"y":1.012},"s":[26.385,8.842,100],"t":44},{"o":{"x":0.167,"y":0.011},"i":{"x":0.833,"y":0.938},"s":[-18.969,35.342,100],"t":44.8},{"o":{"x":0.167,"y":-0.244},"i":{"x":0.833,"y":1.128},"s":[33.051,65.059,100],"t":45.6},{"o":{"x":0.167,"y":0.051},"i":{"x":0.833,"y":0.833},"s":[19.792,-16.798,100],"t":46.4},{"s":[53.472,-1.378,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[278.346,255.953,0],"t":8,"ti":[0.991,1.248,0],"to":[-0.206,-0.234,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[277.109,254.547,0],"t":8.8,"ti":[0.533,2.822,0],"to":[-0.991,-1.248,0]},{"o":{"x":0.167,"y":0.018},"i":{"x":0.833,"y":0.974},"s":[272.4,248.463,0],"t":9.6,"ti":[-2.874,1.607,0],"to":[-0.533,-2.822,0]},{"o":{"x":0.167,"y":0.141},"i":{"x":0.833,"y":0.847},"s":[273.909,237.613,0],"t":10.4,"ti":[-4.877,-0.657,0],"to":[2.874,-1.607,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.851},"s":[289.644,238.823,0],"t":11.2,"ti":[-4.118,-0.868,0],"to":[4.877,0.657,0]},{"o":{"x":0.167,"y":0.18},"i":{"x":0.833,"y":0.851},"s":[303.171,241.554,0],"t":12,"ti":[-3.424,-0.757,0],"to":[4.118,0.868,0]},{"o":{"x":0.167,"y":0.179},"i":{"x":0.833,"y":0.85},"s":[314.351,244.031,0],"t":12.8,"ti":[-2.889,-0.625,0],"to":[3.424,0.757,0]},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":0.848},"s":[323.717,246.095,0],"t":13.6,"ti":[-2.477,-0.51,0],"to":[2.889,0.625,0]},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":0.847},"s":[331.687,247.782,0],"t":14.4,"ti":[-2.154,-0.414,0],"to":[2.477,0.51,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.846},"s":[338.58,249.155,0],"t":15.2,"ti":[-1.892,-0.333,0],"to":[2.154,0.414,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.845},"s":[344.611,250.265,0],"t":16,"ti":[-1.675,-0.265,0],"to":[1.892,0.333,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.844},"s":[349.933,251.155,0],"t":16.8,"ti":[-1.493,-0.207,0],"to":[1.675,0.265,0]},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.842},"s":[354.663,251.856,0],"t":17.6,"ti":[-1.344,-0.162,0],"to":[1.493,0.207,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.841},"s":[358.894,252.395,0],"t":18.4,"ti":[-1.227,-0.138,0],"to":[1.344,0.162,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.841},"s":[362.724,252.827,0],"t":19.2,"ti":[-1.133,-0.127,0],"to":[1.227,0.138,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.84},"s":[366.255,253.222,0],"t":20,"ti":[-1.051,-0.117,0],"to":[1.133,0.127,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.84},"s":[369.523,253.587,0],"t":20.8,"ti":[-0.978,-0.109,0],"to":[1.051,0.117,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.84},"s":[372.561,253.926,0],"t":21.6,"ti":[-0.912,-0.101,0],"to":[0.978,0.109,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.84},"s":[375.391,254.24,0],"t":22.4,"ti":[-0.852,-0.093,0],"to":[0.912,0.101,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.84},"s":[378.033,254.529,0],"t":23.2,"ti":[-0.796,-0.085,0],"to":[0.852,0.093,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.84},"s":[380.502,254.795,0],"t":24,"ti":[-0.745,-0.076,0],"to":[0.796,0.085,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.84},"s":[382.812,255.037,0],"t":24.8,"ti":[-0.697,-0.068,0],"to":[0.745,0.076,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.84},"s":[384.972,255.253,0],"t":25.6,"ti":[-0.651,-0.059,0],"to":[0.697,0.068,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.84},"s":[386.993,255.443,0],"t":26.4,"ti":[-0.608,-0.05,0],"to":[0.651,0.059,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.839},"s":[388.881,255.606,0],"t":27.2,"ti":[-0.567,-0.04,0],"to":[0.608,0.05,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.839},"s":[390.642,255.741,0],"t":28,"ti":[-0.527,-0.03,0],"to":[0.567,0.04,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.84},"s":[392.281,255.845,0],"t":28.8,"ti":[-0.488,-0.019,0],"to":[0.527,0.03,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.84},"s":[393.801,255.919,0],"t":29.6,"ti":[-0.45,-0.008,0],"to":[0.488,0.019,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.841},"s":[395.207,255.96,0],"t":30.4,"ti":[-0.412,0.002,0],"to":[0.45,0.008,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.841},"s":[396.499,255.969,0],"t":31.2,"ti":[-0.375,0.014,0],"to":[0.412,-0.002,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.842},"s":[397.679,255.945,0],"t":32,"ti":[-0.338,0.025,0],"to":[0.375,-0.014,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.844},"s":[398.748,255.888,0],"t":32.8,"ti":[-0.301,0.036,0],"to":[0.338,-0.025,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.845},"s":[399.706,255.797,0],"t":33.6,"ti":[-0.264,0.047,0],"to":[0.301,-0.036,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.847},"s":[400.554,255.673,0],"t":34.4,"ti":[-0.227,0.057,0],"to":[0.264,-0.047,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.853},"s":[401.291,255.517,0],"t":35.2,"ti":[-0.189,0.067,0],"to":[0.227,-0.057,0]},{"o":{"x":0.167,"y":0.166},"i":{"x":0.833,"y":0.859},"s":[401.915,255.33,0],"t":36,"ti":[-0.151,0.077,0],"to":[0.189,-0.067,0]},{"o":{"x":0.167,"y":0.156},"i":{"x":0.833,"y":0.87},"s":[402.427,255.112,0],"t":36.8,"ti":[-0.113,0.086,0],"to":[0.151,-0.077,0]},{"o":{"x":0.167,"y":0.131},"i":{"x":0.833,"y":0.889},"s":[402.824,254.867,0],"t":37.6,"ti":[-0.074,0.094,0],"to":[0.113,-0.086,0]},{"o":{"x":0.167,"y":0.086},"i":{"x":0.833,"y":0.922},"s":[403.104,254.596,0],"t":38.4,"ti":[-0.034,0.101,0],"to":[0.074,-0.094,0]},{"o":{"x":0.167,"y":0.022},"i":{"x":0.833,"y":0.978},"s":[403.266,254.302,0],"t":39.2,"ti":[0.002,0.108,0],"to":[0.034,-0.101,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[403.307,253.989,0],"t":40,"ti":[0.028,0.114,0],"to":[-0.002,-0.108,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[403.256,253.656,0],"t":40.8,"ti":[0.05,0.119,0],"to":[-0.028,-0.114,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[403.14,253.307,0],"t":41.6,"ti":[0.071,0.117,0],"to":[-0.05,-0.119,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[402.953,252.945,0],"t":42.4,"ti":[0.081,0.103,0],"to":[-0.071,-0.117,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[402.716,252.603,0],"t":43.2,"ti":[0.084,0.081,0],"to":[-0.081,-0.103,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[402.468,252.328,0],"t":44,"ti":[0.087,0.059,0],"to":[-0.084,-0.081,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[402.212,252.118,0],"t":44.8,"ti":[0.089,0.038,0],"to":[-0.087,-0.059,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[401.947,251.973,0],"t":45.6,"ti":[0.091,0.018,0],"to":[-0.089,-0.038,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[401.676,251.89,0],"t":46.4,"ti":[0.046,0.004,0],"to":[-0.091,-0.018,0]},{"s":[401.399,251.868,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":12},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":29.6},{"s":[0],"t":42.4}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Rectangle 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[0.012,10.621],[-5.695,5.34],[-2.557,-7.377],[3.15,-2.096]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[1,0.6863,0],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-3.421,4.043],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":39},{"ty":4,"nm":"Shape Layer 12","sr":1,"st":8.8,"op":48,"ip":8.8,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.894},"s":[70.371,73.099,100],"t":8.8},{"o":{"x":0.167,"y":0.387},"i":{"x":0.833,"y":1.011},"s":[81.451,49.764,100],"t":9.6},{"o":{"x":0.167,"y":0.009},"i":{"x":0.833,"y":0.535},"s":[84.489,60.747,100],"t":10.4},{"o":{"x":0.167,"y":0.102},"i":{"x":0.833,"y":0.814},"s":[81.065,81.842,100],"t":11.2},{"o":{"x":0.167,"y":0.151},"i":{"x":0.833,"y":0.818},"s":[65.388,72.828,100],"t":12},{"o":{"x":0.167,"y":0.154},"i":{"x":0.833,"y":1.16},"s":[46.083,98.818,100],"t":12.8},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.958},"s":[23.236,67.65,100],"t":13.6},{"o":{"x":0.167,"y":-0.086},"i":{"x":0.833,"y":0.924},"s":[90.073,84.988,100],"t":14.4},{"o":{"x":0.167,"y":-0.806},"i":{"x":0.833,"y":-0.171},"s":[57.21,68.22,100],"t":15.2},{"o":{"x":0.167,"y":0.09},"i":{"x":0.833,"y":0.965},"s":[60.29,67.062,100],"t":16},{"o":{"x":0.167,"y":-0.06},"i":{"x":0.833,"y":0.989},"s":[100.479,79.398,100],"t":16.8},{"o":{"x":0.167,"y":-0.013},"i":{"x":0.833,"y":0.87},"s":[77.165,62.735,100],"t":17.6},{"o":{"x":0.167,"y":0.233},"i":{"x":0.833,"y":0.823},"s":[97.376,34.245,100],"t":18.4},{"o":{"x":0.167,"y":0.158},"i":{"x":0.833,"y":1.123},"s":[108.611,101.546,100],"t":19.2},{"o":{"x":0.167,"y":0.05},"i":{"x":0.833,"y":0.977},"s":[121.197,111.543,100],"t":20},{"o":{"x":0.167,"y":-0.031},"i":{"x":0.833,"y":0.983},"s":[90.035,98.098,100],"t":20.8},{"o":{"x":0.167,"y":-0.021},"i":{"x":0.833,"y":0.835},"s":[112.765,84.756,100],"t":21.6},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.751},"s":[94.608,103.076,100],"t":22.4},{"o":{"x":0.167,"y":0.125},"i":{"x":0.833,"y":0.906},"s":[76.78,111.632,100],"t":23.2},{"o":{"x":0.167,"y":0.74},"i":{"x":0.833,"y":1.547},"s":[41.278,78.465,100],"t":24},{"o":{"x":0.167,"y":0.072},"i":{"x":0.833,"y":0.914},"s":[36.77,77.159,100],"t":24.8},{"o":{"x":0.167,"y":2.649},"i":{"x":0.833,"y":0.441},"s":[70.888,58.554,100],"t":25.6},{"o":{"x":0.167,"y":0.098},"i":{"x":0.833,"y":0.52},"s":[71.996,119.193,100],"t":26.4},{"o":{"x":0.167,"y":0.101},"i":{"x":0.833,"y":0.977},"s":[78.321,136.39,100],"t":27.2},{"o":{"x":0.167,"y":-0.031},"i":{"x":0.833,"y":0.766},"s":[108.467,75.868,100],"t":28},{"o":{"x":0.167,"y":0.129},"i":{"x":0.833,"y":0.959},"s":[86.503,101.319,100],"t":28.8},{"o":{"x":0.167,"y":-0.079},"i":{"x":0.833,"y":0.84},"s":[46.776,74.608,100],"t":29.6},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.98},"s":[67.187,89.94,100],"t":30.4},{"o":{"x":0.167,"y":-0.027},"i":{"x":0.833,"y":0.699},"s":[85.904,106.857,100],"t":31.2},{"o":{"x":0.167,"y":0.115},"i":{"x":0.833,"y":0.914},"s":[71.727,108.364,100],"t":32},{"o":{"x":0.167,"y":2.984},"i":{"x":0.833,"y":2.929},"s":[34.691,61.105,100],"t":32.8},{"o":{"x":0.167,"y":0.08},"i":{"x":0.833,"y":1.084},"s":[33.627,48.718,100],"t":33.6},{"o":{"x":0.167,"y":0.042},"i":{"x":0.833,"y":1.001},"s":[59.325,36.458,100],"t":34.4},{"o":{"x":0.167,"y":0.001},"i":{"x":0.833,"y":0.944},"s":[7.81,92.753,100],"t":35.2},{"o":{"x":0.167,"y":-0.168},"i":{"x":0.833,"y":0.889},"s":[59.941,37.215,100],"t":36},{"o":{"x":0.167,"y":0.335},"i":{"x":0.833,"y":1.33},"s":[42.632,44.663,100],"t":36.8},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.973},"s":[36.89,40.928,100],"t":37.6},{"o":{"x":0.167,"y":-0.04},"i":{"x":0.833,"y":0.915},"s":[65.36,59.633,100],"t":38.4},{"o":{"x":0.167,"y":3.347},"i":{"x":0.833,"y":0.366},"s":[46.071,42.784,100],"t":39.2},{"o":{"x":0.167,"y":0.096},"i":{"x":0.833,"y":0.284},"s":[45.578,-11.282,100],"t":40},{"o":{"x":0.167,"y":0.094},"i":{"x":0.833,"y":0.976},"s":[42.321,31.087,100],"t":40.8},{"o":{"x":0.167,"y":-0.033},"i":{"x":0.833,"y":0.91},"s":[17.582,31.566,100],"t":41.6},{"o":{"x":0.167,"y":1.171},"i":{"x":0.833,"y":4.784},"s":[35.243,70.197,100],"t":42.4},{"o":{"x":0.167,"y":0.082},"i":{"x":0.833,"y":0.95},"s":[36.597,40.776,100],"t":43.2},{"o":{"x":0.167,"y":-0.123},"i":{"x":0.833,"y":0.762},"s":[-26.212,12.89,100],"t":44},{"o":{"x":0.167,"y":0.128},"i":{"x":0.833,"y":0.889},"s":[-0.792,72.669,100],"t":44.8},{"o":{"x":0.167,"y":0.335},"i":{"x":0.833,"y":0.804},"s":[46.469,-1.813,100],"t":45.6},{"o":{"x":0.167,"y":0.145},"i":{"x":0.833,"y":0.833},"s":[62.111,19.267,100],"t":46.4},{"s":[83.28,20.895,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[278.886,263.108,0],"t":8.8,"ti":[2.046,0.295,0],"to":[-0.396,0.093,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[276.51,263.668,0],"t":9.6,"ti":[4.357,2.028,0],"to":[-2.046,-0.295,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[266.607,261.339,0],"t":10.4,"ti":[5.491,3.808,0],"to":[-4.357,-2.028,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[250.369,251.499,0],"t":11.2,"ti":[5.141,4.15,0],"to":[-5.491,-3.808,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[233.659,238.49,0],"t":12,"ti":[4.303,3.645,0],"to":[-5.141,-4.15,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[219.52,226.601,0],"t":12.8,"ti":[3.589,3.053,0],"to":[-4.303,-3.645,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[207.84,216.618,0],"t":13.6,"ti":[3.064,2.559,0],"to":[-3.589,-3.053,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[197.984,208.283,0],"t":14.4,"ti":[2.675,2.164,0],"to":[-3.064,-2.559,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[189.458,201.262,0],"t":15.2,"ti":[2.381,1.843,0],"to":[-2.675,-2.164,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[181.933,195.3,0],"t":16,"ti":[2.153,1.575,0],"to":[-2.381,-1.843,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[175.17,190.206,0],"t":16.8,"ti":[1.971,1.344,0],"to":[-2.153,-1.575,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[169.014,185.852,0],"t":17.6,"ti":[1.824,1.14,0],"to":[-1.971,-1.344,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[163.346,182.143,0],"t":18.4,"ti":[1.703,0.954,0],"to":[-1.824,-1.14,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[158.073,179.012,0],"t":19.2,"ti":[1.601,0.778,0],"to":[-1.703,-0.954,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[153.127,176.419,0],"t":20,"ti":[1.512,0.605,0],"to":[-1.601,-0.778,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[148.464,174.344,0],"t":20.8,"ti":[1.427,0.431,0],"to":[-1.512,-0.605,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[144.054,172.787,0],"t":21.6,"ti":[1.341,0.252,0],"to":[-1.427,-0.431,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[139.899,171.759,0],"t":22.4,"ti":[1.243,0.072,0],"to":[-1.341,-0.252,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[136.007,171.274,0],"t":23.2,"ti":[1.123,-0.099,0],"to":[-1.243,-0.072,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[132.443,171.328,0],"t":24,"ti":[0.987,-0.242,0],"to":[-1.123,0.099,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[129.266,171.868,0],"t":24.8,"ti":[0.844,-0.342,0],"to":[-0.987,0.242,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[126.522,172.779,0],"t":25.6,"ti":[0.71,-0.397,0],"to":[-0.844,0.342,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[124.202,173.921,0],"t":26.4,"ti":[0.594,-0.415,0],"to":[-0.71,0.397,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[122.26,175.163,0],"t":27.2,"ti":[0.499,-0.407,0],"to":[-0.594,0.415,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[120.635,176.409,0],"t":28,"ti":[0.424,-0.386,0],"to":[-0.499,0.407,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[119.263,177.604,0],"t":28.8,"ti":[0.362,-0.359,0],"to":[-0.424,0.386,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[118.093,178.724,0],"t":29.6,"ti":[0.312,-0.329,0],"to":[-0.362,0.359,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[117.089,179.757,0],"t":30.4,"ti":[0.271,-0.298,0],"to":[-0.312,0.329,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[116.22,180.697,0],"t":31.2,"ti":[0.237,-0.267,0],"to":[-0.271,0.298,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[115.461,181.543,0],"t":32,"ti":[0.208,-0.237,0],"to":[-0.237,0.267,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[114.796,182.298,0],"t":32.8,"ti":[0.183,-0.208,0],"to":[-0.208,0.237,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[114.21,182.964,0],"t":33.6,"ti":[0.161,-0.181,0],"to":[-0.183,0.208,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[113.696,183.547,0],"t":34.4,"ti":[0.141,-0.155,0],"to":[-0.161,0.181,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[113.244,184.051,0],"t":35.2,"ti":[0.122,-0.131,0],"to":[-0.141,0.155,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[112.85,184.48,0],"t":36,"ti":[0.105,-0.107,0],"to":[-0.122,0.131,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[112.51,184.835,0],"t":36.8,"ti":[0.089,-0.086,0],"to":[-0.105,0.107,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[112.219,185.124,0],"t":37.6,"ti":[0.074,-0.066,0],"to":[-0.089,0.086,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[111.973,185.351,0],"t":38.4,"ti":[0.06,-0.046,0],"to":[-0.074,0.066,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[111.772,185.518,0],"t":39.2,"ti":[0.046,-0.026,0],"to":[-0.06,0.046,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[111.612,185.626,0],"t":40,"ti":[0.035,-0.013,0],"to":[-0.046,0.026,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[111.493,185.674,0],"t":40.8,"ti":[0.027,-0.015,0],"to":[-0.035,0.013,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[111.404,185.706,0],"t":41.6,"ti":[0.021,-0.022,0],"to":[-0.027,0.015,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[111.333,185.761,0],"t":42.4,"ti":[0.015,-0.028,0],"to":[-0.021,0.022,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[111.28,185.837,0],"t":43.2,"ti":[0.01,-0.033,0],"to":[-0.015,0.028,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[111.243,185.929,0],"t":44,"ti":[0.006,-0.036,0],"to":[-0.01,0.033,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[111.219,186.034,0],"t":44.8,"ti":[0.003,-0.038,0],"to":[-0.006,0.036,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[111.207,186.148,0],"t":45.6,"ti":[0,-0.039,0],"to":[-0.003,0.038,0]},{"o":{"x":0.167,"y":0.003},"i":{"x":0.833,"y":0.997},"s":[111.203,186.265,0],"t":46.4,"ti":[0,-0.019,0],"to":[0,0.039,0]},{"s":[111.205,186.381,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":8.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":12.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":30.4},{"s":[0],"t":43.2}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Rectangle 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[0.012,10.621],[-5.695,5.34],[-2.557,-7.377],[3.15,-2.096]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[1,0.6863,0],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-3.421,4.043],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":40},{"ty":4,"nm":"Shape Layer 11","sr":1,"st":4,"op":48,"ip":4,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.938},"s":[49.45,148.28,100],"t":4},{"o":{"x":0.167,"y":-0.246},"i":{"x":0.833,"y":1.038},"s":[96.233,59.296,100],"t":4.8},{"o":{"x":0.167,"y":0.026},"i":{"x":0.833,"y":0.894},"s":[84.39,38.927,100],"t":5.6},{"o":{"x":0.167,"y":0.391},"i":{"x":0.833,"y":1.66},"s":[101.568,62.764,100],"t":6.4},{"o":{"x":0.167,"y":0.074},"i":{"x":0.833,"y":0.929},"s":[106.222,57.834,100],"t":7.2},{"o":{"x":0.167,"y":-0.472},"i":{"x":0.833,"y":0.162},"s":[64.691,35.274,100],"t":8},{"o":{"x":0.167,"y":0.093},"i":{"x":0.833,"y":0.955},"s":[70.923,57.653,100],"t":8.8},{"o":{"x":0.167,"y":-0.098},"i":{"x":0.833,"y":0.827},"s":[127.324,74.727,100],"t":9.6},{"o":{"x":0.167,"y":0.161},"i":{"x":0.833,"y":0.934},"s":[101.458,99.601,100],"t":10.4},{"o":{"x":0.167,"y":-0.314},"i":{"x":0.833,"y":1.386},"s":[73.693,68.044,100],"t":11.2},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":1.064},"s":[79.522,77.427,100],"t":12},{"o":{"x":0.167,"y":0.036},"i":{"x":0.833,"y":0.928},"s":[46.671,43.016,100],"t":12.8},{"o":{"x":0.167,"y":-0.543},"i":{"x":0.833,"y":0.358},"s":[104.84,38.219,100],"t":13.6},{"o":{"x":0.167,"y":0.096},"i":{"x":0.833,"y":1.006},"s":[97.095,66.774,100],"t":14.4},{"o":{"x":0.167,"y":0.006},"i":{"x":0.833,"y":0.947},"s":[45.158,58.378,100],"t":15.2},{"o":{"x":0.167,"y":-0.142},"i":{"x":0.833,"y":0.954},"s":[100.992,91.978,100],"t":16},{"o":{"x":0.167,"y":-0.105},"i":{"x":0.833,"y":0.782},"s":[80.364,100.301,100],"t":16.8},{"o":{"x":0.167,"y":0.135},"i":{"x":0.833,"y":0.813},"s":[89.494,62.471,100],"t":17.6},{"o":{"x":0.167,"y":0.15},"i":{"x":0.833,"y":1.187},"s":[104.25,68.373,100],"t":18.4},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.922},"s":[122.573,87.899,100],"t":19.2},{"o":{"x":0.167,"y":-1.303},"i":{"x":0.833,"y":-0.546},"s":[63.056,70.386,100],"t":20},{"o":{"x":0.167,"y":0.088},"i":{"x":0.833,"y":0.939},"s":[66.633,34.869,100],"t":20.8},{"o":{"x":0.167,"y":-0.233},"i":{"x":0.833,"y":0.782},"s":[129.403,72.011,100],"t":21.6},{"o":{"x":0.167,"y":0.135},"i":{"x":0.833,"y":0.806},"s":[112.863,90.111,100],"t":22.4},{"o":{"x":0.167,"y":0.146},"i":{"x":0.833,"y":0.928},"s":[86.228,114.396,100],"t":23.2},{"o":{"x":0.167,"y":-0.514},"i":{"x":0.833,"y":1.021},"s":[50.891,82.427,100],"t":24},{"o":{"x":0.167,"y":0.017},"i":{"x":0.833,"y":1.248},"s":[55.82,44.045,100],"t":24.8},{"o":{"x":0.167,"y":0.062},"i":{"x":0.833,"y":0.895},"s":[49.632,53.61,100],"t":25.6},{"o":{"x":0.167,"y":0.404},"i":{"x":0.833,"y":0.992},"s":[74.255,114.253,100],"t":26.4},{"o":{"x":0.167,"y":-0.009},"i":{"x":0.833,"y":0.123},"s":[80.651,78.395,100],"t":27.2},{"o":{"x":0.167,"y":0.092},"i":{"x":0.833,"y":0.943},"s":[74.861,75.817,100],"t":28},{"o":{"x":0.167,"y":-0.176},"i":{"x":0.833,"y":0.802},"s":[19.702,76.263,100],"t":28.8},{"o":{"x":0.167,"y":0.144},"i":{"x":0.833,"y":0.938},"s":[37.393,80.265,100],"t":29.6},{"o":{"x":0.167,"y":-0.243},"i":{"x":0.833,"y":0.507},"s":[61.705,41.546,100],"t":30.4},{"o":{"x":0.167,"y":0.1},"i":{"x":0.833,"y":0.85},"s":[55.488,100.178,100],"t":31.2},{"o":{"x":0.167,"y":0.187},"i":{"x":0.833,"y":1.039},"s":[24.961,77.623,100],"t":32},{"o":{"x":0.167,"y":0.026},"i":{"x":0.833,"y":1.03},"s":[0.375,68.025,100],"t":32.8},{"o":{"x":0.167,"y":0.022},"i":{"x":0.833,"y":1.01},"s":[36.365,33.155,100],"t":33.6},{"o":{"x":0.167,"y":0.009},"i":{"x":0.833,"y":0.865},"s":[-12.521,56.708,100],"t":34.4},{"o":{"x":0.167,"y":0.219},"i":{"x":0.833,"y":1.071},"s":[42.47,-4.293,100],"t":35.2},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":0.953},"s":[76.363,33.422,100],"t":36},{"o":{"x":0.167,"y":-0.108},"i":{"x":0.833,"y":0.979},"s":[13.419,37.087,100],"t":36.8},{"o":{"x":0.167,"y":-0.028},"i":{"x":0.833,"y":0.943},"s":[40.835,16.71,100],"t":37.6},{"o":{"x":0.167,"y":-0.176},"i":{"x":0.833,"y":0.911},"s":[20.376,34.131,100],"t":38.4},{"o":{"x":0.167,"y":1.367},"i":{"x":0.833,"y":3.32},"s":[26.948,1.687,100],"t":39.2},{"o":{"x":0.167,"y":0.08},"i":{"x":0.833,"y":1.176},"s":[27.375,36.914,100],"t":40},{"o":{"x":0.167,"y":0.057},"i":{"x":0.833,"y":0.984},"s":[15.071,41.282,100],"t":40.8},{"o":{"x":0.167,"y":-0.019},"i":{"x":0.833,"y":0.862},"s":[53.354,66.388,100],"t":41.6},{"o":{"x":0.167,"y":0.21},"i":{"x":0.833,"y":0.873},"s":[22.228,81.077,100],"t":42.4},{"o":{"x":0.167,"y":0.242},"i":{"x":0.833,"y":1.145},"s":[1.727,-9.051,100],"t":43.2},{"o":{"x":0.167,"y":0.053},"i":{"x":0.833,"y":0.874},"s":[-9.032,27.824,100],"t":44},{"o":{"x":0.167,"y":0.245},"i":{"x":0.833,"y":0.791},"s":[20.502,3.731,100],"t":44.8},{"o":{"x":0.167,"y":0.139},"i":{"x":0.833,"y":1.021},"s":[35.73,4.373,100],"t":45.6},{"o":{"x":0.167,"y":0.017},"i":{"x":0.833,"y":0.833},"s":[58.616,37.243,100],"t":46.4},{"s":[30.021,32.047,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[280.895,263.305,0],"t":4,"ti":[2.713,-0.992,0],"to":[-0.567,0.175,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[277.49,264.357,0],"t":4.8,"ti":[6.007,-2.449,0],"to":[-2.713,0.992,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[264.618,269.257,0],"t":5.6,"ti":[8.091,-3.591,0],"to":[-6.007,2.449,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[241.447,279.054,0],"t":6.4,"ti":[7.873,-3.782,0],"to":[-8.091,3.591,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[216.07,290.801,0],"t":7.2,"ti":[6.648,-3.432,0],"to":[-7.873,3.782,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[194.207,301.746,0],"t":8,"ti":[5.503,-3.025,0],"to":[-6.648,3.432,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[176.185,311.391,0],"t":8.8,"ti":[4.615,-2.683,0],"to":[-5.503,3.025,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[161.19,319.898,0],"t":9.6,"ti":[3.935,-2.407,0],"to":[-4.615,2.683,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[148.493,327.489,0],"t":10.4,"ti":[3.399,-2.181,0],"to":[-3.935,2.407,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[137.583,334.338,0],"t":11.2,"ti":[2.966,-1.993,0],"to":[-3.399,2.181,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[128.098,340.575,0],"t":12,"ti":[2.607,-1.832,0],"to":[-2.966,1.993,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[119.785,346.294,0],"t":12.8,"ti":[2.302,-1.693,0],"to":[-2.607,1.832,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[112.455,351.568,0],"t":13.6,"ti":[2.037,-1.57,0],"to":[-2.302,1.693,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[105.973,356.452,0],"t":14.4,"ti":[1.803,-1.461,0],"to":[-2.037,1.57,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[100.233,360.99,0],"t":15.2,"ti":[1.593,-1.362,0],"to":[-1.803,1.461,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[95.155,365.216,0],"t":16,"ti":[1.401,-1.271,0],"to":[-1.593,1.362,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[90.677,369.16,0],"t":16.8,"ti":[1.224,-1.188,0],"to":[-1.401,1.271,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[86.752,372.844,0],"t":17.6,"ti":[1.07,-1.108,0],"to":[-1.224,1.188,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[83.332,376.285,0],"t":18.4,"ti":[0.937,-1.031,0],"to":[-1.07,1.108,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[80.332,379.49,0],"t":19.2,"ti":[0.818,-0.958,0],"to":[-0.937,1.031,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[77.708,382.471,0],"t":20,"ti":[0.71,-0.889,0],"to":[-0.818,0.958,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[75.425,385.239,0],"t":20.8,"ti":[0.612,-0.822,0],"to":[-0.71,0.889,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[73.45,387.804,0],"t":21.6,"ti":[0.523,-0.758,0],"to":[-0.612,0.822,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[71.754,390.173,0],"t":22.4,"ti":[0.442,-0.696,0],"to":[-0.523,0.758,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[70.313,392.354,0],"t":23.2,"ti":[0.369,-0.637,0],"to":[-0.442,0.696,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[69.102,394.352,0],"t":24,"ti":[0.304,-0.579,0],"to":[-0.369,0.637,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[68.096,396.175,0],"t":24.8,"ti":[0.245,-0.524,0],"to":[-0.304,0.579,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[67.277,397.829,0],"t":25.6,"ti":[0.193,-0.471,0],"to":[-0.245,0.524,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[66.624,399.32,0],"t":26.4,"ti":[0.147,-0.42,0],"to":[-0.193,0.471,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[66.118,400.656,0],"t":27.2,"ti":[0.105,-0.37,0],"to":[-0.147,0.42,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[65.744,401.84,0],"t":28,"ti":[0.069,-0.322,0],"to":[-0.105,0.37,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[65.487,402.877,0],"t":28.8,"ti":[0.037,-0.276,0],"to":[-0.069,0.322,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[65.332,403.773,0],"t":29.6,"ti":[0.009,-0.231,0],"to":[-0.037,0.276,0]},{"o":{"x":0.167,"y":0.003},"i":{"x":0.833,"y":0.997},"s":[65.265,404.532,0],"t":30.4,"ti":[-0.014,-0.188,0],"to":[-0.009,0.231,0]},{"o":{"x":0.167,"y":0.028},"i":{"x":0.833,"y":0.978},"s":[65.276,405.16,0],"t":31.2,"ti":[-0.034,-0.146,0],"to":[0.014,0.188,0]},{"o":{"x":0.167,"y":0.061},"i":{"x":0.833,"y":0.952},"s":[65.351,405.66,0],"t":32,"ti":[-0.051,-0.106,0],"to":[0.034,0.146,0]},{"o":{"x":0.167,"y":0.106},"i":{"x":0.833,"y":0.915},"s":[65.481,406.037,0],"t":32.8,"ti":[-0.064,-0.066,0],"to":[0.051,0.106,0]},{"o":{"x":0.167,"y":0.153},"i":{"x":0.833,"y":0.866},"s":[65.655,406.293,0],"t":33.6,"ti":[-0.074,-0.028,0],"to":[0.064,0.066,0]},{"o":{"x":0.167,"y":0.169},"i":{"x":0.833,"y":0.827},"s":[65.864,406.433,0],"t":34.4,"ti":[-0.081,0.01,0],"to":[0.074,0.028,0]},{"o":{"x":0.167,"y":0.149},"i":{"x":0.833,"y":0.837},"s":[66.098,406.459,0],"t":35.2,"ti":[-0.083,0.038,0],"to":[0.081,-0.01,0]},{"o":{"x":0.167,"y":0.139},"i":{"x":0.833,"y":0.861},"s":[66.349,406.373,0],"t":36,"ti":[-0.078,0.048,0],"to":[0.083,-0.038,0]},{"o":{"x":0.167,"y":0.143},"i":{"x":0.833,"y":0.867},"s":[66.596,406.231,0],"t":36.8,"ti":[-0.069,0.051,0],"to":[0.078,-0.048,0]},{"o":{"x":0.167,"y":0.135},"i":{"x":0.833,"y":0.877},"s":[66.819,406.083,0],"t":37.6,"ti":[-0.057,0.054,0],"to":[0.069,-0.051,0]},{"o":{"x":0.167,"y":0.117},"i":{"x":0.833,"y":0.893},"s":[67.01,405.928,0],"t":38.4,"ti":[-0.042,0.058,0],"to":[0.057,-0.054,0]},{"o":{"x":0.167,"y":0.083},"i":{"x":0.833,"y":0.921},"s":[67.16,405.761,0],"t":39.2,"ti":[-0.023,0.063,0],"to":[0.042,-0.058,0]},{"o":{"x":0.167,"y":0.032},"i":{"x":0.833,"y":0.967},"s":[67.259,405.58,0],"t":40,"ti":[-0.001,0.07,0],"to":[0.023,-0.063,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[67.298,405.38,0],"t":40.8,"ti":[0.023,0.076,0],"to":[0.001,-0.07,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[67.266,405.158,0],"t":41.6,"ti":[0.046,0.073,0],"to":[-0.023,-0.076,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[67.158,404.922,0],"t":42.4,"ti":[0.062,0.06,0],"to":[-0.046,-0.073,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[66.993,404.72,0],"t":43.2,"ti":[0.076,0.046,0],"to":[-0.062,-0.06,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[66.783,404.561,0],"t":44,"ti":[0.086,0.031,0],"to":[-0.076,-0.046,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[66.539,404.446,0],"t":44.8,"ti":[0.093,0.016,0],"to":[-0.086,-0.031,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[66.269,404.376,0],"t":45.6,"ti":[0.097,0,0],"to":[-0.093,-0.016,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[65.982,404.352,0],"t":46.4,"ti":[0.049,-0.004,0],"to":[-0.097,0,0]},{"s":[65.686,404.375,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":25.6},{"s":[0],"t":38.4}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Rectangle 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[0.012,10.621],[-5.695,5.34],[-2.557,-7.377],[3.15,-2.096]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.4745,0.8392,0.6667],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-3.421,4.043],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":41},{"ty":4,"nm":"Shape Layer 10","sr":1,"st":6.4,"op":48,"ip":6.4,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.866},"s":[127.438,90.591,100],"t":6.4},{"o":{"x":0.167,"y":0.22},"i":{"x":0.833,"y":1.119},"s":[90.096,28.016,100],"t":7.2},{"o":{"x":0.167,"y":0.049},"i":{"x":0.833,"y":0.948},"s":[67.312,81.384,100],"t":8},{"o":{"x":0.167,"y":-0.141},"i":{"x":0.833,"y":0.746},"s":[122.538,69.77,100],"t":8.8},{"o":{"x":0.167,"y":0.124},"i":{"x":0.833,"y":0.94},"s":[102.02,98.906,100],"t":9.6},{"o":{"x":0.167,"y":-0.21},"i":{"x":0.833,"y":0.968},"s":[60.035,90.043,100],"t":10.4},{"o":{"x":0.167,"y":-0.051},"i":{"x":0.833,"y":1.429},"s":[71.968,116.451,100],"t":11.2},{"o":{"x":0.167,"y":0.07},"i":{"x":0.833,"y":0.886},"s":[64.586,63.443,100],"t":12},{"o":{"x":0.167,"y":0.307},"i":{"x":0.833,"y":1.12},"s":[109.991,44.631,100],"t":12.8},{"o":{"x":0.167,"y":0.049},"i":{"x":0.833,"y":0.887},"s":[126.937,59.824,100],"t":13.6},{"o":{"x":0.167,"y":0.316},"i":{"x":0.833,"y":0.971},"s":[85.604,73.442,100],"t":14.4},{"o":{"x":0.167,"y":-0.045},"i":{"x":0.833,"y":0.831},"s":[70.771,70.802,100],"t":15.2},{"o":{"x":0.167,"y":0.164},"i":{"x":0.833,"y":0.913},"s":[80.389,96.73,100],"t":16},{"o":{"x":0.167,"y":1.79},"i":{"x":0.833,"y":0.179},"s":[90.289,87.923,100],"t":16.8},{"o":{"x":0.167,"y":0.093},"i":{"x":0.833,"y":1.589},"s":[90.772,58.569,100],"t":17.6},{"o":{"x":0.167,"y":0.073},"i":{"x":0.833,"y":0.878},"s":[95.049,54.421,100],"t":18.4},{"o":{"x":0.167,"y":0.262},"i":{"x":0.833,"y":1.33},"s":[60.54,68.48,100],"t":19.2},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.901},"s":[44.437,36.222,100],"t":20},{"o":{"x":0.167,"y":0.525},"i":{"x":0.833,"y":0.929},"s":[124.279,47.844,100],"t":20.8},{"o":{"x":0.167,"y":-0.486},"i":{"x":0.833,"y":-1.352},"s":[139.353,46.441,100],"t":21.6},{"o":{"x":0.167,"y":0.086},"i":{"x":0.833,"y":0.883},"s":[137.147,101.148,100],"t":22.4},{"o":{"x":0.167,"y":0.29},"i":{"x":0.833,"y":0.867},"s":[77.097,103.625,100],"t":23.2},{"o":{"x":0.167,"y":0.222},"i":{"x":0.833,"y":1.16},"s":[52.92,67.602,100],"t":24},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.876},"s":[38.391,66.346,100],"t":24.8},{"o":{"x":0.167,"y":0.255},"i":{"x":0.833,"y":1.058},"s":[80.849,88.417,100],"t":25.6},{"o":{"x":0.167,"y":0.034},"i":{"x":0.833,"y":0.897},"s":[101.514,109.026,100],"t":26.4},{"o":{"x":0.167,"y":0.446},"i":{"x":0.833,"y":1.242},"s":[66.389,95.048,100],"t":27.2},{"o":{"x":0.167,"y":0.062},"i":{"x":0.833,"y":0.892},"s":[58.31,67.448,100],"t":28},{"o":{"x":0.167,"y":0.364},"i":{"x":0.833,"y":1.044},"s":[89.867,114.12,100],"t":28.8},{"o":{"x":0.167,"y":0.029},"i":{"x":0.833,"y":0.587},"s":[99.232,53.341,100],"t":29.6},{"o":{"x":0.167,"y":0.104},"i":{"x":0.833,"y":0.912},"s":[84.926,94.953,100],"t":30.4},{"o":{"x":0.167,"y":1.495},"i":{"x":0.833,"y":1.439},"s":[28.265,109.679,100],"t":31.2},{"o":{"x":0.167,"y":0.07},"i":{"x":0.833,"y":1.035},"s":[24.92,76.564,100],"t":32},{"o":{"x":0.167,"y":0.025},"i":{"x":0.833,"y":0.948},"s":[45.873,56.751,100],"t":32.8},{"o":{"x":0.167,"y":-0.138},"i":{"x":0.833,"y":0.603},"s":[16.102,65.143,100],"t":33.6},{"o":{"x":0.167,"y":0.105},"i":{"x":0.833,"y":1.028},"s":[27.313,-5.503,100],"t":34.4},{"o":{"x":0.167,"y":0.021},"i":{"x":0.833,"y":0.923},"s":[69.528,52.086,100],"t":35.2},{"o":{"x":0.167,"y":-1.056},"i":{"x":0.833,"y":1.395},"s":[13.347,55.885,100],"t":36},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":0.991},"s":[17.457,26.517,100],"t":36.8},{"o":{"x":0.167,"y":-0.01},"i":{"x":0.833,"y":0.906},"s":[-6.114,46.16,100],"t":37.6},{"o":{"x":0.167,"y":0.74},"i":{"x":0.833,"y":1.079},"s":[14.941,35.961,100],"t":38.4},{"o":{"x":0.167,"y":0.041},"i":{"x":0.833,"y":1.225},"s":[17.614,44.753,100],"t":39.2},{"o":{"x":0.167,"y":0.061},"i":{"x":0.833,"y":1.151},"s":[12.402,22.217,100],"t":40},{"o":{"x":0.167,"y":0.054},"i":{"x":0.833,"y":0.952},"s":[31.658,24.926,100],"t":40.8},{"o":{"x":0.167,"y":-0.115},"i":{"x":0.833,"y":0.879},"s":[-22.38,66.727,100],"t":41.6},{"o":{"x":0.167,"y":0.269},"i":{"x":0.833,"y":0.835},"s":[0.27,30.796,100],"t":42.4},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.829},"s":[10.423,7.981,100],"t":43.2},{"o":{"x":0.167,"y":0.162},"i":{"x":0.833,"y":0.817},"s":[20.367,26.148,100],"t":44},{"o":{"x":0.167,"y":0.153},"i":{"x":0.833,"y":1.012},"s":[30.864,-6.905,100],"t":44.8},{"o":{"x":0.167,"y":0.011},"i":{"x":0.833,"y":0.986},"s":[43.453,19.525,100],"t":45.6},{"o":{"x":0.167,"y":-0.017},"i":{"x":0.833,"y":0.833},"s":[29.038,24.824,100],"t":46.4},{"s":[41.021,15.933,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[272.114,255.071,0],"t":6.4,"ti":[1.216,-0.382,0],"to":[-0.266,0.053,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[270.517,255.387,0],"t":7.2,"ti":[2.644,-1.017,0],"to":[-1.216,0.382,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[264.819,257.361,0],"t":8,"ti":[3.502,-1.605,0],"to":[-2.644,1.017,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[254.654,261.49,0],"t":8.8,"ti":[3.128,-2.062,0],"to":[-3.502,1.605,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[243.809,266.989,0],"t":9.6,"ti":[0.929,-2.4,0],"to":[-3.128,2.062,0]},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.954},"s":[235.889,273.86,0],"t":10.4,"ti":[-1.493,-1.834,0],"to":[-0.929,2.4,0]},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.864},"s":[238.235,281.389,0],"t":11.2,"ti":[-2.114,-0.944,0],"to":[1.493,1.834,0]},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.853},"s":[244.846,284.864,0],"t":12,"ti":[-1.909,-0.642,0],"to":[2.114,0.944,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.85},"s":[250.917,287.051,0],"t":12.8,"ti":[-1.697,-0.51,0],"to":[1.909,0.642,0]},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.848},"s":[256.301,288.717,0],"t":13.6,"ti":[-1.516,-0.438,0],"to":[1.697,0.51,0]},{"o":{"x":0.167,"y":0.169},"i":{"x":0.833,"y":0.848},"s":[261.1,290.112,0],"t":14.4,"ti":[-1.362,-0.392,0],"to":[1.516,0.438,0]},{"o":{"x":0.167,"y":0.169},"i":{"x":0.833,"y":0.847},"s":[265.397,291.343,0],"t":15.2,"ti":[-1.229,-0.362,0],"to":[1.362,0.392,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.848},"s":[269.269,292.467,0],"t":16,"ti":[-1.114,-0.341,0],"to":[1.229,0.362,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.848},"s":[272.774,293.517,0],"t":16.8,"ti":[-1.012,-0.326,0],"to":[1.114,0.341,0]},{"o":{"x":0.167,"y":0.166},"i":{"x":0.833,"y":0.848},"s":[275.955,294.515,0],"t":17.6,"ti":[-0.921,-0.314,0],"to":[1.012,0.326,0]},{"o":{"x":0.167,"y":0.164},"i":{"x":0.833,"y":0.849},"s":[278.847,295.472,0],"t":18.4,"ti":[-0.839,-0.305,0],"to":[0.921,0.314,0]},{"o":{"x":0.167,"y":0.163},"i":{"x":0.833,"y":0.85},"s":[281.482,296.4,0],"t":19.2,"ti":[-0.762,-0.298,0],"to":[0.839,0.305,0]},{"o":{"x":0.167,"y":0.161},"i":{"x":0.833,"y":0.852},"s":[283.879,297.304,0],"t":20,"ti":[-0.69,-0.293,0],"to":[0.762,0.298,0]},{"o":{"x":0.167,"y":0.159},"i":{"x":0.833,"y":0.855},"s":[286.053,298.19,0],"t":20.8,"ti":[-0.621,-0.288,0],"to":[0.69,0.293,0]},{"o":{"x":0.167,"y":0.157},"i":{"x":0.833,"y":0.857},"s":[288.016,299.06,0],"t":21.6,"ti":[-0.554,-0.284,0],"to":[0.621,0.288,0]},{"o":{"x":0.167,"y":0.154},"i":{"x":0.833,"y":0.861},"s":[289.778,299.918,0],"t":22.4,"ti":[-0.486,-0.279,0],"to":[0.554,0.284,0]},{"o":{"x":0.167,"y":0.15},"i":{"x":0.833,"y":0.866},"s":[291.338,300.763,0],"t":23.2,"ti":[-0.419,-0.273,0],"to":[0.486,0.279,0]},{"o":{"x":0.167,"y":0.145},"i":{"x":0.833,"y":0.872},"s":[292.695,301.592,0],"t":24,"ti":[-0.351,-0.266,0],"to":[0.419,0.273,0]},{"o":{"x":0.167,"y":0.137},"i":{"x":0.833,"y":0.881},"s":[293.849,302.402,0],"t":24.8,"ti":[-0.283,-0.258,0],"to":[0.351,0.266,0]},{"o":{"x":0.167,"y":0.126},"i":{"x":0.833,"y":0.893},"s":[294.801,303.189,0],"t":25.6,"ti":[-0.215,-0.245,0],"to":[0.283,0.258,0]},{"o":{"x":0.167,"y":0.111},"i":{"x":0.833,"y":0.909},"s":[295.549,303.949,0],"t":26.4,"ti":[-0.147,-0.225,0],"to":[0.215,0.245,0]},{"o":{"x":0.167,"y":0.087},"i":{"x":0.833,"y":0.93},"s":[296.09,304.662,0],"t":27.2,"ti":[-0.082,-0.198,0],"to":[0.147,0.225,0]},{"o":{"x":0.167,"y":0.051},"i":{"x":0.833,"y":0.96},"s":[296.429,305.301,0],"t":28,"ti":[-0.024,-0.164,0],"to":[0.082,0.198,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[296.583,305.847,0],"t":28.8,"ti":[0.026,-0.131,0],"to":[0.024,0.164,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[296.574,306.285,0],"t":29.6,"ti":[0.067,-0.108,0],"to":[-0.026,0.131,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[296.425,306.636,0],"t":30.4,"ti":[0.097,-0.091,0],"to":[-0.067,0.108,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[296.17,306.934,0],"t":31.2,"ti":[0.117,-0.076,0],"to":[-0.097,0.091,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[295.842,307.183,0],"t":32,"ti":[0.129,-0.065,0],"to":[-0.117,0.076,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[295.468,307.393,0],"t":32.8,"ti":[0.134,-0.057,0],"to":[-0.129,0.065,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[295.071,307.574,0],"t":33.6,"ti":[0.133,-0.051,0],"to":[-0.134,0.057,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[294.667,307.733,0],"t":34.4,"ti":[0.128,-0.046,0],"to":[-0.133,0.051,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[294.272,307.878,0],"t":35.2,"ti":[0.12,-0.044,0],"to":[-0.128,0.046,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[293.898,308.012,0],"t":36,"ti":[0.108,-0.042,0],"to":[-0.12,0.044,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[293.554,308.14,0],"t":36.8,"ti":[0.094,-0.041,0],"to":[-0.108,0.042,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[293.249,308.264,0],"t":37.6,"ti":[0.08,-0.044,0],"to":[-0.094,0.041,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[292.988,308.385,0],"t":38.4,"ti":[0.068,-0.055,0],"to":[-0.08,0.044,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[292.767,308.528,0],"t":39.2,"ti":[0.056,-0.069,0],"to":[-0.068,0.055,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[292.579,308.714,0],"t":40,"ti":[0.044,-0.082,0],"to":[-0.056,0.069,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[292.428,308.941,0],"t":40.8,"ti":[0.03,-0.094,0],"to":[-0.044,0.082,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[292.318,309.205,0],"t":41.6,"ti":[0.016,-0.105,0],"to":[-0.03,0.094,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[292.249,309.504,0],"t":42.4,"ti":[0.001,-0.114,0],"to":[-0.016,0.105,0]},{"o":{"x":0.167,"y":0.009},"i":{"x":0.833,"y":0.991},"s":[292.223,309.833,0],"t":43.2,"ti":[-0.013,-0.122,0],"to":[-0.001,0.114,0]},{"o":{"x":0.167,"y":0.026},"i":{"x":0.833,"y":0.972},"s":[292.242,310.189,0],"t":44,"ti":[-0.028,-0.128,0],"to":[0.013,0.122,0]},{"o":{"x":0.167,"y":0.042},"i":{"x":0.833,"y":0.956},"s":[292.304,310.564,0],"t":44.8,"ti":[-0.042,-0.131,0],"to":[0.028,0.128,0]},{"o":{"x":0.167,"y":0.056},"i":{"x":0.833,"y":0.941},"s":[292.408,310.955,0],"t":45.6,"ti":[-0.055,-0.133,0],"to":[0.042,0.131,0]},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":0.93},"s":[292.554,311.353,0],"t":46.4,"ti":[-0.031,-0.067,0],"to":[0.055,0.133,0]},{"s":[292.738,311.753,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":6.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":10.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":28},{"s":[0],"t":40.8}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Rectangle 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[0.012,10.621],[-5.695,5.34],[-2.557,-7.377],[3.15,-2.096]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[1,0.6863,0],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-3.421,4.043],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":42},{"ty":4,"nm":"Shape Layer 9","sr":1,"st":8,"op":48,"ip":8,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.838},"s":[109.864,70.089,100],"t":8},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.856},"s":[86.733,68.252,100],"t":8.8},{"o":{"x":0.167,"y":0.199},"i":{"x":0.833,"y":1.028},"s":[64.924,89.385,100],"t":9.6},{"o":{"x":0.167,"y":0.021},"i":{"x":0.833,"y":0.797},"s":[49.171,146.99,100],"t":10.4},{"o":{"x":0.167,"y":0.141},"i":{"x":0.833,"y":0.92},"s":[70.147,94.506,100],"t":11.2},{"o":{"x":0.167,"y":-1.941},"i":{"x":0.833,"y":2.944},"s":[100.345,84.223,100],"t":12},{"o":{"x":0.167,"y":0.08},"i":{"x":0.833,"y":1.003},"s":[99.102,64.322,100],"t":12.8},{"o":{"x":0.167,"y":0.002},"i":{"x":0.833,"y":0.843},"s":[129.334,103.257,100],"t":13.6},{"o":{"x":0.167,"y":0.177},"i":{"x":0.833,"y":0.977},"s":[98.181,73.031,100],"t":14.4},{"o":{"x":0.167,"y":-0.032},"i":{"x":0.833,"y":0.969},"s":[70.521,73.149,100],"t":15.2},{"o":{"x":0.167,"y":-0.048},"i":{"x":0.833,"y":0.819},"s":[90.481,75.792,100],"t":16},{"o":{"x":0.167,"y":0.155},"i":{"x":0.833,"y":0.879},"s":[77.84,74.224,100],"t":16.8},{"o":{"x":0.167,"y":0.269},"i":{"x":0.833,"y":1.071},"s":[63.067,64.426,100],"t":17.6},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":0.698},"s":[56.422,72.999,100],"t":18.4},{"o":{"x":0.167,"y":0.115},"i":{"x":0.833,"y":0.807},"s":[68.741,79.126,100],"t":19.2},{"o":{"x":0.167,"y":0.147},"i":{"x":0.833,"y":0.911},"s":[101.082,75.355,100],"t":20},{"o":{"x":0.167,"y":1.265},"i":{"x":0.833,"y":1.698},"s":[143.609,54.475,100],"t":20.8},{"o":{"x":0.167,"y":0.074},"i":{"x":0.833,"y":0.73},"s":[146.608,63.972,100],"t":21.6},{"o":{"x":0.167,"y":0.121},"i":{"x":0.833,"y":0.888},"s":[118.472,92.79,100],"t":22.4},{"o":{"x":0.167,"y":0.324},"i":{"x":0.833,"y":1.05},"s":[55.394,59.194,100],"t":23.2},{"o":{"x":0.167,"y":0.031},"i":{"x":0.833,"y":0.866},"s":[33.53,103.661,100],"t":24},{"o":{"x":0.167,"y":0.22},"i":{"x":0.833,"y":1.028},"s":[68.551,76.112,100],"t":24.8},{"o":{"x":0.167,"y":0.021},"i":{"x":0.833,"y":0.9},"s":[89.966,83.951,100],"t":25.6},{"o":{"x":0.167,"y":0.497},"i":{"x":0.833,"y":2.007},"s":[61.396,110.752,100],"t":26.4},{"o":{"x":0.167,"y":0.077},"i":{"x":0.833,"y":0.966},"s":[55.64,56.936,100],"t":27.2},{"o":{"x":0.167,"y":-0.058},"i":{"x":0.833,"y":0.958},"s":[130.926,113.733,100],"t":28},{"o":{"x":0.167,"y":-0.086},"i":{"x":0.833,"y":1.106},"s":[86.439,76.969,100],"t":28.8},{"o":{"x":0.167,"y":0.047},"i":{"x":0.833,"y":0.866},"s":[108.294,95.156,100],"t":29.6},{"o":{"x":0.167,"y":0.221},"i":{"x":0.833,"y":1.04},"s":[58.545,89.141,100],"t":30.4},{"o":{"x":0.167,"y":0.027},"i":{"x":0.833,"y":0.947},"s":[28.376,66.139,100],"t":31.2},{"o":{"x":0.167,"y":-0.148},"i":{"x":0.833,"y":0.89},"s":[72.983,43.989,100],"t":32},{"o":{"x":0.167,"y":0.339},"i":{"x":0.833,"y":1.128},"s":[56.935,55.362,100],"t":32.8},{"o":{"x":0.167,"y":0.05},"i":{"x":0.833,"y":1.199},"s":[51.706,12.909,100],"t":33.6},{"o":{"x":0.167,"y":0.059},"i":{"x":0.833,"y":0.938},"s":[64.946,65.932,100],"t":34.4},{"o":{"x":0.167,"y":-0.238},"i":{"x":0.833,"y":1.252},"s":[20.13,72.328,100],"t":35.2},{"o":{"x":0.167,"y":0.063},"i":{"x":0.833,"y":0.97},"s":[31.738,37.588,100],"t":36},{"o":{"x":0.167,"y":-0.046},"i":{"x":0.833,"y":0.893},"s":[-14.966,72.869,100],"t":36.8},{"o":{"x":0.167,"y":0.373},"i":{"x":0.833,"y":1.07},"s":[15.041,59.042,100],"t":37.6},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":1.075},"s":[23.68,76.032,100],"t":38.4},{"o":{"x":0.167,"y":0.039},"i":{"x":0.833,"y":1.071},"s":[7.79,16.858,100],"t":39.2},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":0.941},"s":[37.924,1.088,100],"t":40},{"o":{"x":0.167,"y":-0.205},"i":{"x":0.833,"y":0.813},"s":[-17.733,11.662,100],"t":40.8},{"o":{"x":0.167,"y":0.15},"i":{"x":0.833,"y":0.814},"s":[-1.626,56.352,100],"t":41.6},{"o":{"x":0.167,"y":0.151},"i":{"x":0.833,"y":0.897},"s":[18.416,34.888,100],"t":42.4},{"o":{"x":0.167,"y":0.441},"i":{"x":0.833,"y":0.817},"s":[43.027,58.529,100],"t":43.2},{"o":{"x":0.167,"y":0.153},"i":{"x":0.833,"y":0.877},"s":[48.754,17.354,100],"t":44},{"o":{"x":0.167,"y":0.259},"i":{"x":0.833,"y":1.206},"s":[55.61,17.816,100],"t":44.8},{"o":{"x":0.167,"y":0.059},"i":{"x":0.833,"y":0.986},"s":[58.864,4.732,100],"t":45.6},{"o":{"x":0.167,"y":-0.017},"i":{"x":0.833,"y":0.833},"s":[47.582,-17.422,100],"t":46.4},{"s":[56.939,20.914,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[279.864,255.271,0],"t":8,"ti":[1.691,-0.679,0],"to":[-0.343,0.177,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[277.804,256.336,0],"t":8.8,"ti":[3.887,-1.09,0],"to":[-1.691,0.679,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[269.719,259.347,0],"t":9.6,"ti":[3.906,1.153,0],"to":[-3.887,1.09,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[254.482,262.875,0],"t":10.4,"ti":[0.302,3.979,0],"to":[-3.906,-1.153,0]},{"o":{"x":0.167,"y":0.068},"i":{"x":0.833,"y":0.936},"s":[246.284,252.432,0],"t":11.2,"ti":[-2.124,4.016,0],"to":[-0.302,-3.979,0]},{"o":{"x":0.167,"y":0.094},"i":{"x":0.833,"y":0.922},"s":[252.67,238.999,0],"t":12,"ti":[-1.967,3.264,0],"to":[2.124,-4.016,0]},{"o":{"x":0.167,"y":0.095},"i":{"x":0.833,"y":0.919},"s":[259.026,228.335,0],"t":12.8,"ti":[-1.669,2.774,0],"to":[1.967,-3.264,0]},{"o":{"x":0.167,"y":0.092},"i":{"x":0.833,"y":0.921},"s":[264.471,219.412,0],"t":13.6,"ti":[-1.398,2.426,0],"to":[1.669,-2.774,0]},{"o":{"x":0.167,"y":0.087},"i":{"x":0.833,"y":0.923},"s":[269.041,211.694,0],"t":14.4,"ti":[-1.168,2.169,0],"to":[1.398,-2.426,0]},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":0.928},"s":[272.862,204.857,0],"t":15.2,"ti":[-0.974,1.973,0],"to":[1.168,-2.169,0]},{"o":{"x":0.167,"y":0.075},"i":{"x":0.833,"y":0.933},"s":[276.051,198.681,0],"t":16,"ti":[-0.806,1.82,0],"to":[0.974,-1.973,0]},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.939},"s":[278.705,193.017,0],"t":16.8,"ti":[-0.644,1.685,0],"to":[0.806,-1.82,0]},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.948},"s":[280.888,187.764,0],"t":17.6,"ti":[-0.482,1.558,0],"to":[0.644,-1.685,0]},{"o":{"x":0.167,"y":0.046},"i":{"x":0.833,"y":0.959},"s":[282.57,182.907,0],"t":18.4,"ti":[-0.333,1.443,0],"to":[0.482,-1.558,0]},{"o":{"x":0.167,"y":0.032},"i":{"x":0.833,"y":0.97},"s":[283.781,178.414,0],"t":19.2,"ti":[-0.197,1.336,0],"to":[0.333,-1.443,0]},{"o":{"x":0.167,"y":0.018},"i":{"x":0.833,"y":0.984},"s":[284.566,174.251,0],"t":20,"ti":[-0.074,1.237,0],"to":[0.197,-1.336,0]},{"o":{"x":0.167,"y":0.002},"i":{"x":0.833,"y":0.998},"s":[284.965,170.396,0],"t":20.8,"ti":[0.038,1.14,0],"to":[0.074,-1.237,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[285.012,166.831,0],"t":21.6,"ti":[0.139,1.044,0],"to":[-0.038,-1.14,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[284.739,163.555,0],"t":22.4,"ti":[0.228,0.947,0],"to":[-0.139,-1.044,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[284.178,160.569,0],"t":23.2,"ti":[0.304,0.848,0],"to":[-0.228,-0.947,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[283.368,157.874,0],"t":24,"ti":[0.363,0.748,0],"to":[-0.304,-0.848,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[282.355,155.48,0],"t":24.8,"ti":[0.405,0.649,0],"to":[-0.363,-0.748,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[281.189,153.386,0],"t":25.6,"ti":[0.428,0.554,0],"to":[-0.405,-0.649,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[279.927,151.584,0],"t":26.4,"ti":[0.433,0.464,0],"to":[-0.428,-0.554,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[278.623,150.062,0],"t":27.2,"ti":[0.424,0.383,0],"to":[-0.433,-0.464,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[277.326,148.798,0],"t":28,"ti":[0.403,0.31,0],"to":[-0.424,-0.383,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[276.078,147.765,0],"t":28.8,"ti":[0.372,0.245,0],"to":[-0.403,-0.31,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[274.911,146.939,0],"t":29.6,"ti":[0.335,0.19,0],"to":[-0.372,-0.245,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[273.847,146.293,0],"t":30.4,"ti":[0.294,0.141,0],"to":[-0.335,-0.19,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[272.9,145.802,0],"t":31.2,"ti":[0.25,0.1,0],"to":[-0.294,-0.141,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[272.082,145.445,0],"t":32,"ti":[0.205,0.064,0],"to":[-0.25,-0.1,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[271.398,145.204,0],"t":32.8,"ti":[0.16,0.034,0],"to":[-0.205,-0.064,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[270.85,145.06,0],"t":33.6,"ti":[0.115,0.009,0],"to":[-0.16,-0.034,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[270.438,144.999,0],"t":34.4,"ti":[0.071,-0.011,0],"to":[-0.115,-0.009,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[270.159,145.005,0],"t":35.2,"ti":[0.029,-0.027,0],"to":[-0.071,0.011,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[270.01,145.067,0],"t":36,"ti":[-0.01,-0.039,0],"to":[-0.029,0.027,0]},{"o":{"x":0.167,"y":0.078},"i":{"x":0.833,"y":0.884},"s":[269.983,145.17,0],"t":36.8,"ti":[-0.046,-0.046,0],"to":[0.01,0.039,0]},{"o":{"x":0.167,"y":0.109},"i":{"x":0.833,"y":0.845},"s":[270.07,145.3,0],"t":37.6,"ti":[-0.08,-0.05,0],"to":[0.046,0.046,0]},{"o":{"x":0.167,"y":0.128},"i":{"x":0.833,"y":0.836},"s":[270.262,145.447,0],"t":38.4,"ti":[-0.111,-0.049,0],"to":[0.08,0.05,0]},{"o":{"x":0.167,"y":0.141},"i":{"x":0.833,"y":0.839},"s":[270.551,145.599,0],"t":39.2,"ti":[-0.133,-0.043,0],"to":[0.111,0.049,0]},{"o":{"x":0.167,"y":0.156},"i":{"x":0.833,"y":0.84},"s":[270.927,145.744,0],"t":40,"ti":[-0.141,-0.026,0],"to":[0.133,0.043,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.834},"s":[271.347,145.854,0],"t":40.8,"ti":[-0.142,-0.004,0],"to":[0.141,0.026,0]},{"o":{"x":0.167,"y":0.165},"i":{"x":0.833,"y":0.832},"s":[271.77,145.903,0],"t":41.6,"ti":[-0.143,0.021,0],"to":[0.142,0.004,0]},{"o":{"x":0.167,"y":0.161},"i":{"x":0.833,"y":0.836},"s":[272.2,145.876,0],"t":42.4,"ti":[-0.142,0.042,0],"to":[0.143,-0.021,0]},{"o":{"x":0.167,"y":0.154},"i":{"x":0.833,"y":0.843},"s":[272.629,145.78,0],"t":43.2,"ti":[-0.137,0.061,0],"to":[0.142,-0.042,0]},{"o":{"x":0.167,"y":0.147},"i":{"x":0.833,"y":0.852},"s":[273.049,145.622,0],"t":44,"ti":[-0.13,0.077,0],"to":[0.137,-0.061,0]},{"o":{"x":0.167,"y":0.137},"i":{"x":0.833,"y":0.863},"s":[273.452,145.412,0],"t":44.8,"ti":[-0.12,0.091,0],"to":[0.13,-0.077,0]},{"o":{"x":0.167,"y":0.128},"i":{"x":0.833,"y":0.874},"s":[273.829,145.157,0],"t":45.6,"ti":[-0.109,0.102,0],"to":[0.12,-0.091,0]},{"o":{"x":0.167,"y":0.116},"i":{"x":0.833,"y":0.884},"s":[274.175,144.866,0],"t":46.4,"ti":[-0.051,0.054,0],"to":[0.109,-0.102,0]},{"s":[274.483,144.545,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":12},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":29.6},{"s":[0],"t":42.4}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Rectangle 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[0.012,10.621],[-5.695,5.34],[-2.557,-7.377],[3.15,-2.096]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[1,0.6863,0],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[-3.421,4.043],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":43},{"ty":4,"nm":"Shape Layer 8","sr":1,"st":7.2,"op":48,"ip":7.2,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.872},"s":[121.274,69.223,100],"t":7.2},{"o":{"x":0.167,"y":0.239},"i":{"x":0.833,"y":0.683},"s":[102.389,75.161,100],"t":8},{"o":{"x":0.167,"y":0.113},"i":{"x":0.833,"y":0.98},"s":[92.262,61.994,100],"t":8.8},{"o":{"x":0.167,"y":-0.026},"i":{"x":0.833,"y":0.931},"s":[63.863,104.769,100],"t":9.6},{"o":{"x":0.167,"y":-0.401},"i":{"x":0.833,"y":0.274},"s":[85.432,85.001,100],"t":10.4},{"o":{"x":0.167,"y":0.094},"i":{"x":0.833,"y":1.092},"s":[81.722,108.079,100],"t":11.2},{"o":{"x":0.167,"y":0.044},"i":{"x":0.833,"y":0.882},"s":[53.108,98.543,100],"t":12},{"o":{"x":0.167,"y":0.286},"i":{"x":0.833,"y":1.078},"s":[113.303,131.662,100],"t":12.8},{"o":{"x":0.167,"y":0.04},"i":{"x":0.833,"y":0.91},"s":[138.039,101.322,100],"t":13.6},{"o":{"x":0.167,"y":1.209},"i":{"x":0.833,"y":0.965},"s":[90.083,83.561,100],"t":14.4},{"o":{"x":0.167,"y":-0.061},"i":{"x":0.833,"y":2.383},"s":[86.533,62.73,100],"t":15.2},{"o":{"x":0.167,"y":0.079},"i":{"x":0.833,"y":0.943},"s":[88.578,85.983,100],"t":16},{"o":{"x":0.167,"y":-0.181},"i":{"x":0.833,"y":0.633},"s":[52.598,119.725,100],"t":16.8},{"o":{"x":0.167,"y":0.108},"i":{"x":0.833,"y":0.913},"s":[63.951,75.737,100],"t":17.6},{"o":{"x":0.167,"y":1.9},"i":{"x":0.833,"y":-0.114},"s":[102.646,109.959,100],"t":18.4},{"o":{"x":0.167,"y":0.09},"i":{"x":0.833,"y":0.968},"s":[104.421,111.717,100],"t":19.2},{"o":{"x":0.167,"y":-0.051},"i":{"x":0.833,"y":0.984},"s":[126.369,86.671,100],"t":20},{"o":{"x":0.167,"y":-0.02},"i":{"x":0.833,"y":1.465},"s":[112.748,85.867,100],"t":20.8},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.895},"s":[123.717,88.551,100],"t":21.6},{"o":{"x":0.167,"y":0.407},"i":{"x":0.833,"y":1.153},"s":[51.588,47.768,100],"t":22.4},{"o":{"x":0.167,"y":0.054},"i":{"x":0.833,"y":0.924},"s":[33.003,102.64,100],"t":23.2},{"o":{"x":0.167,"y":-0.892},"i":{"x":0.833,"y":1.199},"s":[85.701,106.264,100],"t":24},{"o":{"x":0.167,"y":0.059},"i":{"x":0.833,"y":1.078},"s":[81.198,58.493,100],"t":24.8},{"o":{"x":0.167,"y":0.04},"i":{"x":0.833,"y":1.008},"s":[96.43,113.732,100],"t":25.6},{"o":{"x":0.167,"y":0.007},"i":{"x":0.833,"y":1.02},"s":[67.01,81.239,100],"t":26.4},{"o":{"x":0.167,"y":0.016},"i":{"x":0.833,"y":0.963},"s":[99.306,110.284,100],"t":27.2},{"o":{"x":0.167,"y":-0.067},"i":{"x":0.833,"y":0.823},"s":[59.341,106.769,100],"t":28},{"o":{"x":0.167,"y":0.158},"i":{"x":0.833,"y":1.189},"s":[81.457,100.615,100],"t":28.8},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.974},"s":[106.222,55.153,100],"t":29.6},{"o":{"x":0.167,"y":-0.038},"i":{"x":0.833,"y":0.965},"s":[25.147,58.283,100],"t":30.4},{"o":{"x":0.167,"y":-0.061},"i":{"x":0.833,"y":0.948},"s":[80.819,44.863,100],"t":31.2},{"o":{"x":0.167,"y":-0.137},"i":{"x":0.833,"y":0.833},"s":[48.72,13.108,100],"t":32},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":1.058},"s":[60.869,29.019,100],"t":32.8},{"o":{"x":0.167,"y":0.034},"i":{"x":0.833,"y":0.967},"s":[73.011,43.835,100],"t":33.6},{"o":{"x":0.167,"y":-0.054},"i":{"x":0.833,"y":1.288},"s":[52.393,51.855,100],"t":34.4},{"o":{"x":0.167,"y":0.065},"i":{"x":0.833,"y":0.942},"s":[64.871,9.492,100],"t":35.2},{"o":{"x":0.167,"y":-0.193},"i":{"x":0.833,"y":0.756},"s":[9.336,58.19,100],"t":36},{"o":{"x":0.167,"y":0.127},"i":{"x":0.833,"y":1.038},"s":[26.111,64.455,100],"t":36.8},{"o":{"x":0.167,"y":0.026},"i":{"x":0.833,"y":1.014},"s":[58.4,75.08,100],"t":37.6},{"o":{"x":0.167,"y":0.012},"i":{"x":0.833,"y":0.98},"s":[11.51,35.267,100],"t":38.4},{"o":{"x":0.167,"y":-0.026},"i":{"x":0.833,"y":0.932},"s":[66.25,16.716,100],"t":39.2},{"o":{"x":0.167,"y":-0.377},"i":{"x":0.833,"y":0.825},"s":[24.642,-15.996,100],"t":40},{"o":{"x":0.167,"y":0.159},"i":{"x":0.833,"y":0.942},"s":[32.168,40.121,100],"t":40.8},{"o":{"x":0.167,"y":-0.193},"i":{"x":0.833,"y":1.214},"s":[40.464,74.155,100],"t":41.6},{"o":{"x":0.167,"y":0.06},"i":{"x":0.833,"y":0.906},"s":[37.96,67.475,100],"t":42.4},{"o":{"x":0.167,"y":0.711},"i":{"x":0.833,"y":-0.566},"s":[46.883,24.242,100],"t":43.2},{"o":{"x":0.167,"y":0.088},"i":{"x":0.833,"y":1.073},"s":[48.067,45.748,100],"t":44},{"o":{"x":0.167,"y":0.039},"i":{"x":0.833,"y":0.938},"s":[69.141,7.771,100],"t":44.8},{"o":{"x":0.167,"y":-0.247},"i":{"x":0.833,"y":1.021},"s":[29.508,-32.064,100],"t":45.6},{"o":{"x":0.167,"y":0.017},"i":{"x":0.833,"y":0.833},"s":[39.499,17.057,100],"t":46.4},{"s":[27.006,34.616,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[278.864,255.82,0],"t":7.2,"ti":[2.192,-0.891,0],"to":[-0.509,0.141,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[275.812,256.665,0],"t":8,"ti":[4.157,-2.88,0],"to":[-2.192,0.891,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[265.713,261.168,0],"t":8.8,"ti":[3.28,-5.54,0],"to":[-4.157,2.88,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[250.868,273.944,0],"t":9.6,"ti":[-0.211,-6.285,0],"to":[-3.28,5.54,0]},{"o":{"x":0.167,"y":0.059},"i":{"x":0.833,"y":0.95},"s":[246.03,294.41,0],"t":10.4,"ti":[-2.493,-4.913,0],"to":[0.211,6.285,0]},{"o":{"x":0.167,"y":0.108},"i":{"x":0.833,"y":0.91},"s":[252.134,311.655,0],"t":11.2,"ti":[-2.968,-3.51,0],"to":[2.493,4.913,0]},{"o":{"x":0.167,"y":0.131},"i":{"x":0.833,"y":0.89},"s":[260.991,323.886,0],"t":12,"ti":[-2.895,-2.554,0],"to":[2.968,3.51,0]},{"o":{"x":0.167,"y":0.144},"i":{"x":0.833,"y":0.877},"s":[269.941,332.712,0],"t":12.8,"ti":[-2.702,-1.885,0],"to":[2.895,2.554,0]},{"o":{"x":0.167,"y":0.153},"i":{"x":0.833,"y":0.867},"s":[278.362,339.211,0],"t":13.6,"ti":[-2.495,-1.387,0],"to":[2.702,1.885,0]},{"o":{"x":0.167,"y":0.161},"i":{"x":0.833,"y":0.859},"s":[286.152,344.024,0],"t":14.4,"ti":[-2.299,-0.994,0],"to":[2.495,1.387,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.852},"s":[293.332,347.535,0],"t":15.2,"ti":[-2.119,-0.668,0],"to":[2.299,0.994,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.847},"s":[299.949,349.988,0],"t":16,"ti":[-1.954,-0.387,0],"to":[2.119,0.668,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.843},"s":[306.048,351.543,0],"t":16.8,"ti":[-1.795,-0.137,0],"to":[1.954,0.387,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.841},"s":[311.672,352.309,0],"t":17.6,"ti":[-1.633,0.088,0],"to":[1.795,0.137,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.841},"s":[316.816,352.363,0],"t":18.4,"ti":[-1.471,0.288,0],"to":[1.633,-0.088,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.846},"s":[321.472,351.78,0],"t":19.2,"ti":[-1.306,0.458,0],"to":[1.471,-0.288,0]},{"o":{"x":0.167,"y":0.158},"i":{"x":0.833,"y":0.854},"s":[325.642,350.637,0],"t":20,"ti":[-1.135,0.591,0],"to":[1.306,-0.458,0]},{"o":{"x":0.167,"y":0.148},"i":{"x":0.833,"y":0.864},"s":[329.308,349.031,0],"t":20.8,"ti":[-0.968,0.681,0],"to":[1.135,-0.591,0]},{"o":{"x":0.167,"y":0.135},"i":{"x":0.833,"y":0.876},"s":[332.455,347.089,0],"t":21.6,"ti":[-0.817,0.731,0],"to":[0.968,-0.681,0]},{"o":{"x":0.167,"y":0.122},"i":{"x":0.833,"y":0.887},"s":[335.117,344.942,0],"t":22.4,"ti":[-0.687,0.746,0],"to":[0.817,-0.731,0]},{"o":{"x":0.167,"y":0.111},"i":{"x":0.833,"y":0.897},"s":[337.355,342.705,0],"t":23.2,"ti":[-0.581,0.735,0],"to":[0.687,-0.746,0]},{"o":{"x":0.167,"y":0.103},"i":{"x":0.833,"y":0.905},"s":[339.24,340.468,0],"t":24,"ti":[-0.497,0.706,0],"to":[0.581,-0.735,0]},{"o":{"x":0.167,"y":0.097},"i":{"x":0.833,"y":0.911},"s":[340.842,338.297,0],"t":24.8,"ti":[-0.432,0.666,0],"to":[0.497,-0.706,0]},{"o":{"x":0.167,"y":0.092},"i":{"x":0.833,"y":0.915},"s":[342.224,336.234,0],"t":25.6,"ti":[-0.383,0.622,0],"to":[0.432,-0.666,0]},{"o":{"x":0.167,"y":0.09},"i":{"x":0.833,"y":0.917},"s":[343.437,334.299,0],"t":26.4,"ti":[-0.345,0.576,0],"to":[0.383,-0.622,0]},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":0.918},"s":[344.521,332.502,0],"t":27.2,"ti":[-0.315,0.529,0],"to":[0.345,-0.576,0]},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":0.918},"s":[345.505,330.845,0],"t":28,"ti":[-0.292,0.487,0],"to":[0.315,-0.529,0]},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":0.916},"s":[346.41,329.327,0],"t":28.8,"ti":[-0.279,0.457,0],"to":[0.292,-0.487,0]},{"o":{"x":0.167,"y":0.09},"i":{"x":0.833,"y":0.914},"s":[347.258,327.924,0],"t":29.6,"ti":[-0.273,0.434,0],"to":[0.279,-0.457,0]},{"o":{"x":0.167,"y":0.091},"i":{"x":0.833,"y":0.913},"s":[348.086,326.587,0],"t":30.4,"ti":[-0.265,0.411,0],"to":[0.273,-0.434,0]},{"o":{"x":0.167,"y":0.093},"i":{"x":0.833,"y":0.912},"s":[348.894,325.317,0],"t":31.2,"ti":[-0.255,0.387,0],"to":[0.265,-0.411,0]},{"o":{"x":0.167,"y":0.096},"i":{"x":0.833,"y":0.911},"s":[349.675,324.119,0],"t":32,"ti":[-0.243,0.361,0],"to":[0.255,-0.387,0]},{"o":{"x":0.167,"y":0.097},"i":{"x":0.833,"y":0.91},"s":[350.425,322.996,0],"t":32.8,"ti":[-0.229,0.334,0],"to":[0.243,-0.361,0]},{"o":{"x":0.167,"y":0.098},"i":{"x":0.833,"y":0.91},"s":[351.135,321.951,0],"t":33.6,"ti":[-0.212,0.306,0],"to":[0.229,-0.334,0]},{"o":{"x":0.167,"y":0.1},"i":{"x":0.833,"y":0.909},"s":[351.799,320.989,0],"t":34.4,"ti":[-0.194,0.278,0],"to":[0.212,-0.306,0]},{"o":{"x":0.167,"y":0.101},"i":{"x":0.833,"y":0.91},"s":[352.409,320.113,0],"t":35.2,"ti":[-0.173,0.249,0],"to":[0.194,-0.278,0]},{"o":{"x":0.167,"y":0.101},"i":{"x":0.833,"y":0.912},"s":[352.961,319.322,0],"t":36,"ti":[-0.15,0.219,0],"to":[0.173,-0.249,0]},{"o":{"x":0.167,"y":0.101},"i":{"x":0.833,"y":0.914},"s":[353.448,318.619,0],"t":36.8,"ti":[-0.126,0.188,0],"to":[0.15,-0.219,0]},{"o":{"x":0.167,"y":0.101},"i":{"x":0.833,"y":0.918},"s":[353.864,318.007,0],"t":37.6,"ti":[-0.101,0.156,0],"to":[0.126,-0.188,0]},{"o":{"x":0.167,"y":0.099},"i":{"x":0.833,"y":0.92},"s":[354.205,317.489,0],"t":38.4,"ti":[-0.075,0.131,0],"to":[0.101,-0.156,0]},{"o":{"x":0.167,"y":0.083},"i":{"x":0.833,"y":0.928},"s":[354.467,317.068,0],"t":39.2,"ti":[-0.049,0.118,0],"to":[0.075,-0.131,0]},{"o":{"x":0.167,"y":0.054},"i":{"x":0.833,"y":0.952},"s":[354.652,316.704,0],"t":40,"ti":[-0.024,0.112,0],"to":[0.049,-0.118,0]},{"o":{"x":0.167,"y":0.019},"i":{"x":0.833,"y":0.983},"s":[354.762,316.358,0],"t":40.8,"ti":[0.001,0.104,0],"to":[0.024,-0.112,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[354.797,316.033,0],"t":41.6,"ti":[0.025,0.094,0],"to":[-0.001,-0.104,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[354.758,315.735,0],"t":42.4,"ti":[0.049,0.084,0],"to":[-0.025,-0.094,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[354.646,315.467,0],"t":43.2,"ti":[0.071,0.072,0],"to":[-0.049,-0.084,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[354.465,315.232,0],"t":44,"ti":[0.091,0.06,0],"to":[-0.071,-0.072,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[354.22,315.034,0],"t":44.8,"ti":[0.109,0.047,0],"to":[-0.091,-0.06,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[353.918,314.873,0],"t":45.6,"ti":[0.124,0.033,0],"to":[-0.109,-0.047,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[353.565,314.754,0],"t":46.4,"ti":[0.066,0.013,0],"to":[-0.124,-0.033,0]},{"s":[353.172,314.677,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":7.2},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":11.2},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":28.8},{"s":[0],"t":41.6}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[10,10],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.8353,0.749,1],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":44},{"ty":4,"nm":"Shape Layer 7","sr":1,"st":4,"op":48,"ip":4,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":1.747},"s":[67.084,129.75,100],"t":4},{"o":{"x":0.167,"y":0.075},"i":{"x":0.833,"y":0.927},"s":[62.33,109.198,100],"t":4.8},{"o":{"x":0.167,"y":-0.593},"i":{"x":0.833,"y":1.16},"s":[109.714,82.895,100],"t":5.6},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.95},"s":[103.874,63.18,100],"t":6.4},{"o":{"x":0.167,"y":-0.126},"i":{"x":0.833,"y":0.652},"s":[120.913,108.471,100],"t":7.2},{"o":{"x":0.167,"y":0.11},"i":{"x":0.833,"y":0.996},"s":[114.137,57.365,100],"t":8},{"o":{"x":0.167,"y":-0.004},"i":{"x":0.833,"y":0.991},"s":[92.637,77.058,100],"t":8.8},{"o":{"x":0.167,"y":-0.01},"i":{"x":0.833,"y":0.717},"s":[113.058,64.766,100],"t":9.6},{"o":{"x":0.167,"y":0.118},"i":{"x":0.833,"y":0.956},"s":[94.823,104.736,100],"t":10.4},{"o":{"x":0.167,"y":-0.095},"i":{"x":0.833,"y":0.686},"s":[51.043,116.383,100],"t":11.2},{"o":{"x":0.167,"y":0.113},"i":{"x":0.833,"y":0.935},"s":[71.52,124.057,100],"t":12},{"o":{"x":0.167,"y":-0.292},"i":{"x":0.833,"y":0.826},"s":[128.168,95.925,100],"t":12.8},{"o":{"x":0.167,"y":0.16},"i":{"x":0.833,"y":0.867},"s":[115.579,82.608,100],"t":13.6},{"o":{"x":0.167,"y":0.223},"i":{"x":0.833,"y":0.512},"s":[101.896,75.048,100],"t":14.4},{"o":{"x":0.167,"y":0.1},"i":{"x":0.833,"y":0.973},"s":[93.758,93.897,100],"t":15.2},{"o":{"x":0.167,"y":-0.041},"i":{"x":0.833,"y":0.898},"s":[54.25,131.368,100],"t":16},{"o":{"x":0.167,"y":0.465},"i":{"x":0.833,"y":0.724},"s":[80.758,87.771,100],"t":16.8},{"o":{"x":0.167,"y":0.119},"i":{"x":0.833,"y":0.924},"s":[86.54,91.108,100],"t":17.6},{"o":{"x":0.167,"y":-0.912},"i":{"x":0.833,"y":0.904},"s":[99.918,122.044,100],"t":18.4},{"o":{"x":0.167,"y":0.63},"i":{"x":0.833,"y":11.64},"s":[98.798,85.895,100],"t":19.2},{"o":{"x":0.167,"y":0.083},"i":{"x":0.833,"y":1.179},"s":[98.627,119.725,100],"t":20},{"o":{"x":0.167,"y":0.057},"i":{"x":0.833,"y":0.897},"s":[120.625,99.715,100],"t":20.8},{"o":{"x":0.167,"y":0.428},"i":{"x":0.833,"y":1.129},"s":[51.46,62.943,100],"t":21.6},{"o":{"x":0.167,"y":0.051},"i":{"x":0.833,"y":0.842},"s":[34.76,99.837,100],"t":22.4},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.887},"s":[77.215,131.147,100],"t":23.2},{"o":{"x":0.167,"y":0.319},"i":{"x":0.833,"y":1.072},"s":[115.216,78.51,100],"t":24},{"o":{"x":0.167,"y":0.039},"i":{"x":0.833,"y":0.783},"s":[128.632,112.897,100],"t":24.8},{"o":{"x":0.167,"y":0.135},"i":{"x":0.833,"y":0.926},"s":[103.693,78.444,100],"t":25.6},{"o":{"x":0.167,"y":-0.662},"i":{"x":0.833,"y":1.008},"s":[63.665,77.742,100],"t":26.4},{"o":{"x":0.167,"y":0.007},"i":{"x":0.833,"y":1.628},"s":[68.138,109.713,100],"t":27.2},{"o":{"x":0.167,"y":0.074},"i":{"x":0.833,"y":1.039},"s":[63.26,82.764,100],"t":28},{"o":{"x":0.167,"y":0.027},"i":{"x":0.833,"y":0.925},"s":[104.89,51.456,100],"t":28.8},{"o":{"x":0.167,"y":-0.727},"i":{"x":0.833,"y":1.219},"s":[43.633,26.02,100],"t":29.6},{"o":{"x":0.167,"y":0.06},"i":{"x":0.833,"y":0.892},"s":[49.933,72.695,100],"t":30.4},{"o":{"x":0.167,"y":0.367},"i":{"x":0.833,"y":1.243},"s":[27.075,9.722,100],"t":31.2},{"o":{"x":0.167,"y":0.062},"i":{"x":0.833,"y":0.832},"s":[20.365,47.293,100],"t":32},{"o":{"x":0.167,"y":0.165},"i":{"x":0.833,"y":0.936},"s":[46.638,15.298,100],"t":32.8},{"o":{"x":0.167,"y":-0.284},"i":{"x":0.833,"y":0.362},"s":[73.418,16.565,100],"t":33.6},{"o":{"x":0.167,"y":0.096},"i":{"x":0.833,"y":0.887},"s":[67.341,-22.905,100],"t":34.4},{"o":{"x":0.167,"y":0.315},"i":{"x":0.833,"y":1.174},"s":[26.919,6.334,100],"t":35.2},{"o":{"x":0.167,"y":0.056},"i":{"x":0.833,"y":0.937},"s":[12.404,51.222,100],"t":36},{"o":{"x":0.167,"y":-0.264},"i":{"x":0.833,"y":1.142},"s":[57.152,18.419,100],"t":36.8},{"o":{"x":0.167,"y":0.052},"i":{"x":0.833,"y":0.933},"s":[46.41,13.418,100],"t":37.6},{"o":{"x":0.167,"y":-0.344},"i":{"x":0.833,"y":0.849},"s":[75.422,32.787,100],"t":38.4},{"o":{"x":0.167,"y":0.185},"i":{"x":0.833,"y":1.055},"s":[69.769,-12.086,100],"t":39.2},{"o":{"x":0.167,"y":0.033},"i":{"x":0.833,"y":1.398},"s":[65.147,13.473,100],"t":40},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":0.884},"s":[72.836,58.774,100],"t":40.8},{"o":{"x":0.167,"y":0.296},"i":{"x":0.833,"y":0.911},"s":[28.388,61.475,100],"t":41.6},{"o":{"x":0.167,"y":1.317},"i":{"x":0.833,"y":3.369},"s":[10.975,11.341,100],"t":42.4},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":1.072},"s":[9.799,27.481,100],"t":43.2},{"o":{"x":0.167,"y":0.039},"i":{"x":0.833,"y":0.975},"s":[44.403,41.158,100],"t":44},{"o":{"x":0.167,"y":-0.036},"i":{"x":0.833,"y":0.912},"s":[-20.175,-14.141,100],"t":44.8},{"o":{"x":0.167,"y":1.504},"i":{"x":0.833,"y":0.193},"s":[25.048,19.928,100],"t":45.6},{"o":{"x":0.167,"y":0.093},"i":{"x":0.833,"y":0.833},"s":[27.7,14.076,100],"t":46.4},{"s":[50.717,49.703,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[269.945,256.942,0],"t":4,"ti":[1.991,0.807,0],"to":[-0.448,-0.21,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[267.255,255.684,0],"t":4.8,"ti":[4.389,1.346,0],"to":[-1.991,-0.807,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[257.999,252.103,0],"t":5.6,"ti":[6.039,1.363,0],"to":[-4.389,-1.346,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[240.923,247.608,0],"t":6.4,"ti":[5.978,1.14,0],"to":[-6.039,-1.363,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[221.767,243.923,0],"t":7.2,"ti":[5.09,1.054,0],"to":[-5.978,-1.14,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[205.053,240.767,0],"t":8,"ti":[4.207,1.095,0],"to":[-5.09,-1.054,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[191.227,237.6,0],"t":8.8,"ti":[3.481,1.188,0],"to":[-4.207,-1.095,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[179.812,234.195,0],"t":9.6,"ti":[2.886,1.294,0],"to":[-3.481,-1.188,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[170.338,230.471,0],"t":10.4,"ti":[2.378,1.39,0],"to":[-2.886,-1.294,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[162.496,226.433,0],"t":11.2,"ti":[1.933,1.462,0],"to":[-2.378,-1.39,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[156.068,222.132,0],"t":12,"ti":[1.54,1.499,0],"to":[-1.933,-1.462,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[150.896,217.662,0],"t":12.8,"ti":[1.198,1.498,0],"to":[-1.54,-1.499,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[146.827,213.136,0],"t":13.6,"ti":[0.906,1.46,0],"to":[-1.198,-1.498,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[143.71,208.674,0],"t":14.4,"ti":[0.665,1.393,0],"to":[-0.906,-1.46,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[141.391,204.376,0],"t":15.2,"ti":[0.471,1.306,0],"to":[-0.665,-1.393,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[139.72,200.316,0],"t":16,"ti":[0.313,1.216,0],"to":[-0.471,-1.306,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[138.565,196.541,0],"t":16.8,"ti":[0.184,1.137,0],"to":[-0.313,-1.216,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[137.84,193.02,0],"t":17.6,"ti":[0.081,1.063,0],"to":[-0.184,-1.137,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[137.463,189.72,0],"t":18.4,"ti":[0.003,0.99,0],"to":[-0.081,-1.063,0]},{"o":{"x":0.167,"y":0.005},"i":{"x":0.833,"y":0.995},"s":[137.352,186.641,0],"t":19.2,"ti":[-0.055,0.919,0],"to":[-0.003,-0.99,0]},{"o":{"x":0.167,"y":0.015},"i":{"x":0.833,"y":0.986},"s":[137.442,183.779,0],"t":20,"ti":[-0.097,0.849,0],"to":[0.055,-0.919,0]},{"o":{"x":0.167,"y":0.024},"i":{"x":0.833,"y":0.978},"s":[137.68,181.129,0],"t":20.8,"ti":[-0.126,0.781,0],"to":[0.097,-0.849,0]},{"o":{"x":0.167,"y":0.031},"i":{"x":0.833,"y":0.971},"s":[138.024,178.686,0],"t":21.6,"ti":[-0.145,0.716,0],"to":[0.126,-0.781,0]},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":0.965},"s":[138.439,176.442,0],"t":22.4,"ti":[-0.156,0.653,0],"to":[0.145,-0.716,0]},{"o":{"x":0.167,"y":0.043},"i":{"x":0.833,"y":0.961},"s":[138.897,174.391,0],"t":23.2,"ti":[-0.159,0.592,0],"to":[0.156,-0.653,0]},{"o":{"x":0.167,"y":0.048},"i":{"x":0.833,"y":0.957},"s":[139.374,172.526,0],"t":24,"ti":[-0.157,0.533,0],"to":[0.159,-0.592,0]},{"o":{"x":0.167,"y":0.052},"i":{"x":0.833,"y":0.954},"s":[139.853,170.839,0],"t":24.8,"ti":[-0.15,0.477,0],"to":[0.157,-0.533,0]},{"o":{"x":0.167,"y":0.054},"i":{"x":0.833,"y":0.952},"s":[140.317,169.325,0],"t":25.6,"ti":[-0.139,0.422,0],"to":[0.15,-0.477,0]},{"o":{"x":0.167,"y":0.057},"i":{"x":0.833,"y":0.95},"s":[140.753,167.978,0],"t":26.4,"ti":[-0.125,0.37,0],"to":[0.139,-0.422,0]},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.95},"s":[141.152,166.791,0],"t":27.2,"ti":[-0.109,0.319,0],"to":[0.125,-0.37,0]},{"o":{"x":0.167,"y":0.059},"i":{"x":0.833,"y":0.951},"s":[141.505,165.76,0],"t":28,"ti":[-0.091,0.27,0],"to":[0.109,-0.319,0]},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.953},"s":[141.806,164.879,0],"t":28.8,"ti":[-0.072,0.222,0],"to":[0.091,-0.27,0]},{"o":{"x":0.167,"y":0.056},"i":{"x":0.833,"y":0.956},"s":[142.051,164.142,0],"t":29.6,"ti":[-0.052,0.176,0],"to":[0.072,-0.222,0]},{"o":{"x":0.167,"y":0.051},"i":{"x":0.833,"y":0.963},"s":[142.237,163.545,0],"t":30.4,"ti":[-0.032,0.132,0],"to":[0.052,-0.176,0]},{"o":{"x":0.167,"y":0.039},"i":{"x":0.833,"y":0.974},"s":[142.363,163.084,0],"t":31.2,"ti":[-0.012,0.09,0],"to":[0.032,-0.132,0]},{"o":{"x":0.167,"y":0.005},"i":{"x":0.833,"y":0.997},"s":[142.428,162.753,0],"t":32,"ti":[0.007,0.05,0],"to":[0.012,-0.09,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[142.433,162.544,0],"t":32.8,"ti":[0.026,0.012,0],"to":[-0.007,-0.05,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[142.383,162.452,0],"t":33.6,"ti":[0.042,-0.024,0],"to":[-0.026,-0.012,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[142.28,162.472,0],"t":34.4,"ti":[0.057,-0.059,0],"to":[-0.042,0.024,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[142.128,162.599,0],"t":35.2,"ti":[0.07,-0.085,0],"to":[-0.057,0.059,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[141.935,162.827,0],"t":36,"ti":[0.078,-0.097,0],"to":[-0.07,0.085,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[141.71,163.111,0],"t":36.8,"ti":[0.083,-0.101,0],"to":[-0.078,0.097,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[141.466,163.41,0],"t":37.6,"ti":[0.085,-0.104,0],"to":[-0.083,0.101,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[141.211,163.718,0],"t":38.4,"ti":[0.084,-0.104,0],"to":[-0.085,0.104,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[140.955,164.031,0],"t":39.2,"ti":[0.078,-0.103,0],"to":[-0.084,0.104,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[140.709,164.343,0],"t":40,"ti":[0.08,-0.102,0],"to":[-0.078,0.103,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[140.484,164.649,0],"t":40.8,"ti":[0.095,-0.103,0],"to":[-0.08,0.102,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[140.231,164.956,0],"t":41.6,"ti":[0.112,-0.102,0],"to":[-0.095,0.103,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[139.917,165.266,0],"t":42.4,"ti":[0.125,-0.098,0],"to":[-0.112,0.102,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[139.556,165.569,0],"t":43.2,"ti":[0.134,-0.092,0],"to":[-0.125,0.098,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[139.164,165.856,0],"t":44,"ti":[0.138,-0.083,0],"to":[-0.134,0.092,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[138.753,166.12,0],"t":44.8,"ti":[0.139,-0.072,0],"to":[-0.138,0.083,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[138.335,166.353,0],"t":45.6,"ti":[0.135,-0.059,0],"to":[-0.139,0.072,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[137.921,166.55,0],"t":46.4,"ti":[0.067,-0.026,0],"to":[-0.135,0.059,0]},{"s":[137.522,166.706,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":25.6},{"s":[0],"t":38.4}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[10,10],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.8353,0.749,1],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":45},{"ty":4,"nm":"Shape Layer 6","sr":1,"st":9.6,"op":48,"ip":9.6,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.887},"s":[119.548,103.77,100],"t":9.6},{"o":{"x":0.167,"y":0.32},"i":{"x":0.833,"y":1.117},"s":[75.487,97.516,100],"t":10.4},{"o":{"x":0.167,"y":0.049},"i":{"x":0.833,"y":0.839},"s":[59.951,93.123,100],"t":11.2},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.919},"s":[97.388,66.554,100],"t":12},{"o":{"x":0.167,"y":-2.464},"i":{"x":0.833,"y":-2.744},"s":[132.453,47.628,100],"t":12.8},{"o":{"x":0.167,"y":0.085},"i":{"x":0.833,"y":0.896},"s":[131.306,81.38,100],"t":13.6},{"o":{"x":0.167,"y":0.42},"i":{"x":0.833,"y":1.123},"s":[80.905,117.92,100],"t":14.4},{"o":{"x":0.167,"y":0.05},"i":{"x":0.833,"y":1.005},"s":[68.413,89.26,100],"t":15.2},{"o":{"x":0.167,"y":0.004},"i":{"x":0.833,"y":0.919},"s":[99.306,97.223,100],"t":16},{"o":{"x":0.167,"y":-3.282},"i":{"x":0.833,"y":-0.384},"s":[66.686,61.177,100],"t":16.8},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":0.766},"s":[67.494,97.2,100],"t":17.6},{"o":{"x":0.167,"y":0.129},"i":{"x":0.833,"y":0.858},"s":[80.098,71.917,100],"t":18.4},{"o":{"x":0.167,"y":0.201},"i":{"x":0.833,"y":1.241},"s":[102.945,123.537,100],"t":19.2},{"o":{"x":0.167,"y":0.062},"i":{"x":0.833,"y":0.932},"s":[119.07,82.641,100],"t":20},{"o":{"x":0.167,"y":-0.378},"i":{"x":0.833,"y":0.957},"s":[56.225,72.735,100],"t":20.8},{"o":{"x":0.167,"y":-0.089},"i":{"x":0.833,"y":1.764},"s":[67.587,112.547,100],"t":21.6},{"o":{"x":0.167,"y":0.075},"i":{"x":0.833,"y":0.911},"s":[62.103,128.666,100],"t":22.4},{"o":{"x":0.167,"y":1.415},"i":{"x":0.833,"y":1.018},"s":[117.871,115.971,100],"t":23.2},{"o":{"x":0.167,"y":0.015},"i":{"x":0.833,"y":0.145},"s":[121.362,130.232,100],"t":24},{"o":{"x":0.167,"y":0.092},"i":{"x":0.833,"y":1.007},"s":[117.096,82.77,100],"t":24.8},{"o":{"x":0.167,"y":0.007},"i":{"x":0.833,"y":0.944},"s":[77.619,50.423,100],"t":25.6},{"o":{"x":0.167,"y":-0.172},"i":{"x":0.833,"y":0.856},"s":[120.562,98.344,100],"t":26.4},{"o":{"x":0.167,"y":0.199},"i":{"x":0.833,"y":1},"s":[106.534,95.106,100],"t":27.2},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1.217},"s":[96.391,87.062,100],"t":28},{"o":{"x":0.167,"y":0.06},"i":{"x":0.833,"y":0.943},"s":[106.476,45.285,100],"t":28.8},{"o":{"x":0.167,"y":-0.179},"i":{"x":0.833,"y":1.104},"s":[70.097,118.413,100],"t":29.6},{"o":{"x":0.167,"y":0.046},"i":{"x":0.833,"y":1.008},"s":[81.643,85.768,100],"t":30.4},{"o":{"x":0.167,"y":0.007},"i":{"x":0.833,"y":0.912},"s":[55.641,116.896,100],"t":31.2},{"o":{"x":0.167,"y":1.675},"i":{"x":0.833,"y":-0.011},"s":[83.987,53.173,100],"t":32},{"o":{"x":0.167,"y":0.091},"i":{"x":0.833,"y":1.17},"s":[85.471,49.147,100],"t":32.8},{"o":{"x":0.167,"y":0.056},"i":{"x":0.833,"y":0.916},"s":[102.003,27.383,100],"t":33.6},{"o":{"x":0.167,"y":7.85},"i":{"x":0.833,"y":1.131},"s":[51.831,22.635,100],"t":34.4},{"o":{"x":0.167,"y":0.051},"i":{"x":0.833,"y":-1.033},"s":[51.293,70.822,100],"t":35.2},{"o":{"x":0.167,"y":0.087},"i":{"x":0.833,"y":0.9},"s":[52.676,10.032,100],"t":36},{"o":{"x":0.167,"y":0.491},"i":{"x":0.833,"y":0.828},"s":[85.033,7.021,100],"t":36.8},{"o":{"x":0.167,"y":0.162},"i":{"x":0.833,"y":1.048},"s":[91.644,38.996,100],"t":37.6},{"o":{"x":0.167,"y":0.031},"i":{"x":0.833,"y":0.854},"s":[98.641,12.455,100],"t":38.4},{"o":{"x":0.167,"y":0.195},"i":{"x":0.833,"y":0.425},"s":[87.583,3.883,100],"t":39.2},{"o":{"x":0.167,"y":0.097},"i":{"x":0.833,"y":0.84},"s":[79.333,25.603,100],"t":40},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.932},"s":[30.689,41.218,100],"t":40.8},{"o":{"x":0.167,"y":-0.362},"i":{"x":0.833,"y":0.381},"s":[-14.018,28.37,100],"t":41.6},{"o":{"x":0.167,"y":0.096},"i":{"x":0.833,"y":1.031},"s":[-5.646,3.642,100],"t":42.4},{"o":{"x":0.167,"y":0.022},"i":{"x":0.833,"y":0.941},"s":[48.164,39.412,100],"t":43.2},{"o":{"x":0.167,"y":-0.197},"i":{"x":0.833,"y":0.726},"s":[-25.525,31.762,100],"t":44},{"o":{"x":0.167,"y":0.12},"i":{"x":0.833,"y":0.914},"s":[-3.614,25.17,100],"t":44.8},{"o":{"x":0.167,"y":2.415},"i":{"x":0.833,"y":2.387},"s":[46.515,-8.426,100],"t":45.6},{"o":{"x":0.167,"y":0.079},"i":{"x":0.833,"y":0.833},"s":[48.307,46.093,100],"t":46.4},{"s":[16.689,-4.541,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.116},"i":{"x":0.833,"y":0.723},"s":[269.021,253.165,0],"t":9.6,"ti":[-1.472,1.743,0],"to":[0.334,-0.343,0]},{"o":{"x":0.167,"y":0.066},"i":{"x":0.833,"y":0.852},"s":[271.027,251.106,0],"t":10.4,"ti":[-3.01,4.091,0],"to":[1.472,-1.743,0]},{"o":{"x":0.167,"y":0.074},"i":{"x":0.833,"y":0.899},"s":[277.851,242.705,0],"t":11.2,"ti":[-3.712,5.823,0],"to":[3.01,-4.091,0]},{"o":{"x":0.167,"y":0.08},"i":{"x":0.833,"y":0.921},"s":[289.088,226.561,0],"t":12,"ti":[-3.262,5.954,0],"to":[3.712,-5.823,0]},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":0.931},"s":[300.123,207.765,0],"t":12.8,"ti":[-2.491,5.217,0],"to":[3.262,-5.954,0]},{"o":{"x":0.167,"y":0.075},"i":{"x":0.833,"y":0.938},"s":[308.66,190.839,0],"t":13.6,"ti":[-1.89,4.434,0],"to":[2.491,-5.217,0]},{"o":{"x":0.167,"y":0.068},"i":{"x":0.833,"y":0.942},"s":[315.071,176.461,0],"t":14.4,"ti":[-1.471,3.789,0],"to":[1.89,-4.434,0]},{"o":{"x":0.167,"y":0.063},"i":{"x":0.833,"y":0.946},"s":[320.001,164.236,0],"t":15.2,"ti":[-1.175,3.273,0],"to":[1.471,-3.789,0]},{"o":{"x":0.167,"y":0.059},"i":{"x":0.833,"y":0.949},"s":[323.898,153.727,0],"t":16,"ti":[-0.958,2.857,0],"to":[1.175,-3.273,0]},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.952},"s":[327.049,144.595,0],"t":16.8,"ti":[-0.794,2.513,0],"to":[0.958,-2.857,0]},{"o":{"x":0.167,"y":0.052},"i":{"x":0.833,"y":0.954},"s":[329.644,136.588,0],"t":17.6,"ti":[-0.666,2.226,0],"to":[0.794,-2.513,0]},{"o":{"x":0.167,"y":0.05},"i":{"x":0.833,"y":0.956},"s":[331.811,129.516,0],"t":18.4,"ti":[-0.563,1.981,0],"to":[0.666,-2.226,0]},{"o":{"x":0.167,"y":0.047},"i":{"x":0.833,"y":0.958},"s":[333.638,123.235,0],"t":19.2,"ti":[-0.48,1.769,0],"to":[0.563,-1.981,0]},{"o":{"x":0.167,"y":0.045},"i":{"x":0.833,"y":0.96},"s":[335.19,117.632,0],"t":20,"ti":[-0.41,1.586,0],"to":[0.48,-1.769,0]},{"o":{"x":0.167,"y":0.043},"i":{"x":0.833,"y":0.961},"s":[336.516,112.618,0],"t":20.8,"ti":[-0.351,1.424,0],"to":[0.41,-1.586,0]},{"o":{"x":0.167,"y":0.041},"i":{"x":0.833,"y":0.963},"s":[337.65,108.119,0],"t":21.6,"ti":[-0.3,1.282,0],"to":[0.351,-1.424,0]},{"o":{"x":0.167,"y":0.039},"i":{"x":0.833,"y":0.965},"s":[338.62,104.073,0],"t":22.4,"ti":[-0.255,1.156,0],"to":[0.3,-1.282,0]},{"o":{"x":0.167,"y":0.037},"i":{"x":0.833,"y":0.967},"s":[339.448,100.428,0],"t":23.2,"ti":[-0.216,1.044,0],"to":[0.255,-1.156,0]},{"o":{"x":0.167,"y":0.034},"i":{"x":0.833,"y":0.969},"s":[340.152,97.139,0],"t":24,"ti":[-0.181,0.944,0],"to":[0.216,-1.044,0]},{"o":{"x":0.167,"y":0.032},"i":{"x":0.833,"y":0.971},"s":[340.744,94.166,0],"t":24.8,"ti":[-0.149,0.856,0],"to":[0.181,-0.944,0]},{"o":{"x":0.167,"y":0.028},"i":{"x":0.833,"y":0.974},"s":[341.237,91.474,0],"t":25.6,"ti":[-0.12,0.778,0],"to":[0.149,-0.856,0]},{"o":{"x":0.167,"y":0.025},"i":{"x":0.833,"y":0.977},"s":[341.639,89.031,0],"t":26.4,"ti":[-0.094,0.709,0],"to":[0.12,-0.778,0]},{"o":{"x":0.167,"y":0.021},"i":{"x":0.833,"y":0.981},"s":[341.96,86.808,0],"t":27.2,"ti":[-0.069,0.648,0],"to":[0.094,-0.709,0]},{"o":{"x":0.167,"y":0.016},"i":{"x":0.833,"y":0.986},"s":[342.205,84.778,0],"t":28,"ti":[-0.038,0.59,0],"to":[0.069,-0.648,0]},{"o":{"x":0.167,"y":0.006},"i":{"x":0.833,"y":0.994},"s":[342.374,82.918,0],"t":28.8,"ti":[-0.003,0.532,0],"to":[0.038,-0.59,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[342.434,81.24,0],"t":29.6,"ti":[0.027,0.479,0],"to":[0.003,-0.532,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[342.395,79.728,0],"t":30.4,"ti":[0.051,0.433,0],"to":[-0.027,-0.479,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[342.275,78.364,0],"t":31.2,"ti":[0.069,0.392,0],"to":[-0.051,-0.433,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[342.091,77.129,0],"t":32,"ti":[0.082,0.356,0],"to":[-0.069,-0.392,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[341.861,76.01,0],"t":32.8,"ti":[0.091,0.324,0],"to":[-0.082,-0.356,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[341.597,74.992,0],"t":33.6,"ti":[0.096,0.296,0],"to":[-0.091,-0.324,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[341.314,74.063,0],"t":34.4,"ti":[0.096,0.272,0],"to":[-0.096,-0.296,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[341.023,73.213,0],"t":35.2,"ti":[0.094,0.25,0],"to":[-0.096,-0.272,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[340.736,72.433,0],"t":36,"ti":[0.088,0.23,0],"to":[-0.094,-0.25,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[340.462,71.716,0],"t":36.8,"ti":[0.08,0.212,0],"to":[-0.088,-0.23,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[340.209,71.055,0],"t":37.6,"ti":[0.069,0.195,0],"to":[-0.08,-0.212,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[339.984,70.445,0],"t":38.4,"ti":[0.056,0.18,0],"to":[-0.069,-0.195,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[339.795,69.882,0],"t":39.2,"ti":[0.042,0.165,0],"to":[-0.056,-0.18,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[339.646,69.365,0],"t":40,"ti":[0.027,0.151,0],"to":[-0.042,-0.165,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[339.542,68.892,0],"t":40.8,"ti":[0.01,0.143,0],"to":[-0.027,-0.151,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[339.484,68.461,0],"t":41.6,"ti":[-0.008,0.149,0],"to":[-0.01,-0.143,0]},{"o":{"x":0.167,"y":0.019},"i":{"x":0.833,"y":0.98},"s":[339.48,68.033,0],"t":42.4,"ti":[-0.028,0.16,0],"to":[0.008,-0.149,0]},{"o":{"x":0.167,"y":0.035},"i":{"x":0.833,"y":0.962},"s":[339.535,67.568,0],"t":43.2,"ti":[-0.047,0.169,0],"to":[0.028,-0.16,0]},{"o":{"x":0.167,"y":0.05},"i":{"x":0.833,"y":0.947},"s":[339.647,67.072,0],"t":44,"ti":[-0.065,0.176,0],"to":[0.047,-0.169,0]},{"o":{"x":0.167,"y":0.062},"i":{"x":0.833,"y":0.934},"s":[339.816,66.553,0],"t":44.8,"ti":[-0.083,0.179,0],"to":[0.065,-0.176,0]},{"o":{"x":0.167,"y":0.073},"i":{"x":0.833,"y":0.924},"s":[340.039,66.018,0],"t":45.6,"ti":[-0.099,0.18,0],"to":[0.083,-0.179,0]},{"o":{"x":0.167,"y":0.084},"i":{"x":0.833,"y":0.915},"s":[340.312,65.476,0],"t":46.4,"ti":[-0.053,0.09,0],"to":[0.099,-0.18,0]},{"s":[340.633,64.937,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":9.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":13.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":31.2},{"s":[0],"t":44}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[10,10],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.8353,0.749,1],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":46},{"ty":4,"nm":"Shape Layer 5","sr":1,"st":6.4,"op":48,"ip":6.4,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.87},"s":[119.453,55.55,100],"t":6.4},{"o":{"x":0.167,"y":0.231},"i":{"x":0.833,"y":0.948},"s":[106.941,69.697,100],"t":7.2},{"o":{"x":0.167,"y":-0.135},"i":{"x":0.833,"y":1.287},"s":[99.865,94.324,100],"t":8},{"o":{"x":0.167,"y":0.065},"i":{"x":0.833,"y":0.885},"s":[102.566,91.274,100],"t":8.8},{"o":{"x":0.167,"y":0.301},"i":{"x":0.833,"y":0.741},"s":[90.563,78.91,100],"t":9.6},{"o":{"x":0.167,"y":0.123},"i":{"x":0.833,"y":1.394},"s":[85.972,70.463,100],"t":10.4},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":0.896},"s":[76.313,75.971,100],"t":11.2},{"o":{"x":0.167,"y":0.413},"i":{"x":0.833,"y":1.334},"s":[131.692,39.582,100],"t":12},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.923},"s":[145.687,64.182,100],"t":12.8},{"o":{"x":0.167,"y":-0.941},"i":{"x":0.833,"y":0.286},"s":[75.572,116.009,100],"t":13.6},{"o":{"x":0.167,"y":0.094},"i":{"x":0.833,"y":1.026},"s":[81.277,90.372,100],"t":14.4},{"o":{"x":0.167,"y":0.02},"i":{"x":0.833,"y":0.88},"s":[124.472,91.912,100],"t":15.2},{"o":{"x":0.167,"y":0.275},"i":{"x":0.833,"y":1.062},"s":[67.544,42.493,100],"t":16},{"o":{"x":0.167,"y":0.036},"i":{"x":0.833,"y":0.861},"s":[42.728,69.036,100],"t":16.8},{"o":{"x":0.167,"y":0.208},"i":{"x":0.833,"y":0.922},"s":[85.996,66.957,100],"t":17.6},{"o":{"x":0.167,"y":-1.187},"i":{"x":0.833,"y":-1.537},"s":[114.947,80.491,100],"t":18.4},{"o":{"x":0.167,"y":0.086},"i":{"x":0.833,"y":0.967},"s":[113.049,80.506,100],"t":19.2},{"o":{"x":0.167,"y":-0.054},"i":{"x":0.833,"y":0.925},"s":[57.15,89.382,100],"t":20},{"o":{"x":0.167,"y":-0.754},"i":{"x":0.833,"y":1.098},"s":[91.118,126.727,100],"t":20.8},{"o":{"x":0.167,"y":0.045},"i":{"x":0.833,"y":1.09},"s":[87.736,126.364,100],"t":21.6},{"o":{"x":0.167,"y":0.043},"i":{"x":0.833,"y":0.908},"s":[95.097,147.312,100],"t":22.4},{"o":{"x":0.167,"y":0.913},"i":{"x":0.833,"y":-0.56},"s":[79.819,128.237,100],"t":23.2},{"o":{"x":0.167,"y":0.088},"i":{"x":0.833,"y":1.128},"s":[78.286,116.992,100],"t":24},{"o":{"x":0.167,"y":0.051},"i":{"x":0.833,"y":0.943},"s":[51.103,62.981,100],"t":24.8},{"o":{"x":0.167,"y":-0.177},"i":{"x":0.833,"y":0.755},"s":[120.097,71.216,100],"t":25.6},{"o":{"x":0.167,"y":0.126},"i":{"x":0.833,"y":0.967},"s":[97.985,101.356,100],"t":26.4},{"o":{"x":0.167,"y":-0.054},"i":{"x":0.833,"y":0.958},"s":[55.144,84.965,100],"t":27.2},{"o":{"x":0.167,"y":-0.086},"i":{"x":0.833,"y":0.921},"s":[81.051,58.096,100],"t":28},{"o":{"x":0.167,"y":-1.655},"i":{"x":0.833,"y":1.51},"s":[68.289,62.454,100],"t":28.8},{"o":{"x":0.167,"y":0.072},"i":{"x":0.833,"y":1.243},"s":[68.9,58.129,100],"t":29.6},{"o":{"x":0.167,"y":0.062},"i":{"x":0.833,"y":1.116},"s":[64.548,91.624,100],"t":30.4},{"o":{"x":0.167,"y":0.048},"i":{"x":0.833,"y":1.007},"s":[81.603,41.501,100],"t":31.2},{"o":{"x":0.167,"y":0.007},"i":{"x":0.833,"y":1.027},"s":[40.821,48.785,100],"t":32},{"o":{"x":0.167,"y":0.02},"i":{"x":0.833,"y":0.952},"s":[85.22,46.522,100],"t":32.8},{"o":{"x":0.167,"y":-0.112},"i":{"x":0.833,"y":0.945},"s":[26.513,0.273,100],"t":33.6},{"o":{"x":0.167,"y":-0.158},"i":{"x":0.833,"y":0.934},"s":[51.537,35.891,100],"t":34.4},{"o":{"x":0.167,"y":-0.318},"i":{"x":0.833,"y":-0.358},"s":[42.897,-9.828,100],"t":35.2},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":0.956},"s":[44.69,-10.668,100],"t":36},{"o":{"x":0.167,"y":-0.095},"i":{"x":0.833,"y":0.922},"s":[72.117,-3.689,100],"t":36.8},{"o":{"x":0.167,"y":-1.25},"i":{"x":0.833,"y":2.789},"s":[59.287,14.778,100],"t":37.6},{"o":{"x":0.167,"y":0.08},"i":{"x":0.833,"y":0.827},"s":[60.089,8.351,100],"t":38.4},{"o":{"x":0.167,"y":0.161},"i":{"x":0.833,"y":0.698},"s":[42.069,0.529,100],"t":39.2},{"o":{"x":0.167,"y":0.115},"i":{"x":0.833,"y":0.95},"s":[22.609,3.273,100],"t":40},{"o":{"x":0.167,"y":-0.126},"i":{"x":0.833,"y":0.627},"s":[-28.548,46.76,100],"t":40.8},{"o":{"x":0.167,"y":0.107},"i":{"x":0.833,"y":0.957},"s":[-8.217,10.367,100],"t":41.6},{"o":{"x":0.167,"y":-0.089},"i":{"x":0.833,"y":0.796},"s":[62.57,14.39,100],"t":42.4},{"o":{"x":0.167,"y":0.141},"i":{"x":0.833,"y":0.988},"s":[28.321,49.863,100],"t":43.2},{"o":{"x":0.167,"y":-0.015},"i":{"x":0.833,"y":0.858},"s":[-21.183,41.528,100],"t":44},{"o":{"x":0.167,"y":0.202},"i":{"x":0.833,"y":1.006},"s":[20.981,4.416,100],"t":44.8},{"o":{"x":0.167,"y":0.005},"i":{"x":0.833,"y":0.939},"s":[50.62,41.308,100],"t":45.6},{"o":{"x":0.167,"y":-0.223},"i":{"x":0.833,"y":0.833},"s":[18.942,21.34,100],"t":46.4},{"s":[27.547,17.011,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[272.244,257.087,0],"t":6.4,"ti":[0.816,1.673,0],"to":[-0.124,-0.32,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[271.5,255.164,0],"t":7.2,"ti":[2.219,3.742,0],"to":[-0.816,-1.673,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[267.351,247.049,0],"t":8,"ti":[3.396,4.937,0],"to":[-2.219,-3.742,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[258.186,232.713,0],"t":8.8,"ti":[3.5,4.76,0],"to":[-3.396,-4.937,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[246.972,217.428,0],"t":9.6,"ti":[2.913,4.097,0],"to":[-3.5,-4.76,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[237.183,204.156,0],"t":10.4,"ti":[2.265,3.524,0],"to":[-2.913,-4.097,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[229.496,192.846,0],"t":11.2,"ti":[1.734,3.087,0],"to":[-2.265,-3.524,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[223.596,183.013,0],"t":12,"ti":[1.325,2.741,0],"to":[-1.734,-3.087,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[219.089,174.323,0],"t":12.8,"ti":[1.014,2.455,0],"to":[-1.325,-2.741,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[215.647,166.568,0],"t":13.6,"ti":[0.78,2.215,0],"to":[-1.014,-2.455,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[213.008,159.593,0],"t":14.4,"ti":[0.606,2.01,0],"to":[-0.78,-2.215,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[210.967,153.279,0],"t":15.2,"ti":[0.48,1.83,0],"to":[-0.606,-2.01,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[209.371,147.533,0],"t":16,"ti":[0.392,1.66,0],"to":[-0.48,-1.83,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[208.089,142.301,0],"t":16.8,"ti":[0.329,1.501,0],"to":[-0.392,-1.66,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[207.021,137.573,0],"t":17.6,"ti":[0.281,1.36,0],"to":[-0.329,-1.501,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[206.115,133.293,0],"t":18.4,"ti":[0.243,1.235,0],"to":[-0.281,-1.36,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[205.336,129.411,0],"t":19.2,"ti":[0.212,1.123,0],"to":[-0.243,-1.235,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[204.658,125.885,0],"t":20,"ti":[0.187,1.022,0],"to":[-0.212,-1.123,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[204.062,122.676,0],"t":20.8,"ti":[0.165,0.933,0],"to":[-0.187,-1.022,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[203.537,119.751,0],"t":21.6,"ti":[0.145,0.852,0],"to":[-0.165,-0.933,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[203.075,117.081,0],"t":22.4,"ti":[0.126,0.779,0],"to":[-0.145,-0.852,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[202.67,114.64,0],"t":23.2,"ti":[0.108,0.713,0],"to":[-0.126,-0.779,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[202.32,112.406,0],"t":24,"ti":[0.09,0.654,0],"to":[-0.108,-0.713,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[202.024,110.359,0],"t":24.8,"ti":[0.072,0.599,0],"to":[-0.09,-0.654,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[201.781,108.484,0],"t":25.6,"ti":[0.054,0.55,0],"to":[-0.072,-0.599,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[201.591,106.763,0],"t":26.4,"ti":[0.036,0.505,0],"to":[-0.054,-0.55,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[201.455,105.183,0],"t":27.2,"ti":[0.018,0.464,0],"to":[-0.036,-0.505,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[201.374,103.731,0],"t":28,"ti":[-0.001,0.427,0],"to":[-0.018,-0.464,0]},{"o":{"x":0.167,"y":0.004},"i":{"x":0.833,"y":0.996},"s":[201.348,102.397,0],"t":28.8,"ti":[-0.019,0.391,0],"to":[0.001,-0.427,0]},{"o":{"x":0.167,"y":0.013},"i":{"x":0.833,"y":0.988},"s":[201.377,101.171,0],"t":29.6,"ti":[-0.037,0.358,0],"to":[0.019,-0.391,0]},{"o":{"x":0.167,"y":0.023},"i":{"x":0.833,"y":0.979},"s":[201.462,100.048,0],"t":30.4,"ti":[-0.055,0.327,0],"to":[0.037,-0.358,0]},{"o":{"x":0.167,"y":0.035},"i":{"x":0.833,"y":0.968},"s":[201.6,99.021,0],"t":31.2,"ti":[-0.072,0.298,0],"to":[0.055,-0.327,0]},{"o":{"x":0.167,"y":0.048},"i":{"x":0.833,"y":0.956},"s":[201.792,98.084,0],"t":32,"ti":[-0.089,0.269,0],"to":[0.072,-0.298,0]},{"o":{"x":0.167,"y":0.062},"i":{"x":0.833,"y":0.943},"s":[202.034,97.235,0],"t":32.8,"ti":[-0.104,0.241,0],"to":[0.089,-0.269,0]},{"o":{"x":0.167,"y":0.076},"i":{"x":0.833,"y":0.929},"s":[202.325,96.471,0],"t":33.6,"ti":[-0.118,0.213,0],"to":[0.104,-0.241,0]},{"o":{"x":0.167,"y":0.092},"i":{"x":0.833,"y":0.915},"s":[202.66,95.791,0],"t":34.4,"ti":[-0.131,0.186,0],"to":[0.118,-0.213,0]},{"o":{"x":0.167,"y":0.108},"i":{"x":0.833,"y":0.9},"s":[203.035,95.192,0],"t":35.2,"ti":[-0.142,0.158,0],"to":[0.131,-0.186,0]},{"o":{"x":0.167,"y":0.123},"i":{"x":0.833,"y":0.885},"s":[203.446,94.675,0],"t":36,"ti":[-0.151,0.13,0],"to":[0.142,-0.158,0]},{"o":{"x":0.167,"y":0.137},"i":{"x":0.833,"y":0.871},"s":[203.886,94.242,0],"t":36.8,"ti":[-0.157,0.102,0],"to":[0.151,-0.13,0]},{"o":{"x":0.167,"y":0.151},"i":{"x":0.833,"y":0.855},"s":[204.349,93.894,0],"t":37.6,"ti":[-0.161,0.078,0],"to":[0.157,-0.102,0]},{"o":{"x":0.167,"y":0.155},"i":{"x":0.833,"y":0.847},"s":[204.827,93.632,0],"t":38.4,"ti":[-0.163,0.067,0],"to":[0.161,-0.078,0]},{"o":{"x":0.167,"y":0.156},"i":{"x":0.833,"y":0.845},"s":[205.315,93.423,0],"t":39.2,"ti":[-0.166,0.057,0],"to":[0.163,-0.067,0]},{"o":{"x":0.167,"y":0.16},"i":{"x":0.833,"y":0.838},"s":[205.808,93.233,0],"t":40,"ti":[-0.172,0.042,0],"to":[0.166,-0.057,0]},{"o":{"x":0.167,"y":0.162},"i":{"x":0.833,"y":0.835},"s":[206.31,93.079,0],"t":40.8,"ti":[-0.179,0.025,0],"to":[0.172,-0.042,0]},{"o":{"x":0.167,"y":0.164},"i":{"x":0.833,"y":0.834},"s":[206.839,92.979,0],"t":41.6,"ti":[-0.182,0.01,0],"to":[0.179,-0.025,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.834},"s":[207.382,92.928,0],"t":42.4,"ti":[-0.181,-0.005,0],"to":[0.182,-0.01,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.836},"s":[207.929,92.922,0],"t":43.2,"ti":[-0.176,-0.017,0],"to":[0.181,0.005,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.838},"s":[208.467,92.955,0],"t":44,"ti":[-0.169,-0.028,0],"to":[0.176,0.017,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.841},"s":[208.986,93.024,0],"t":44.8,"ti":[-0.158,-0.038,0],"to":[0.169,0.028,0]},{"o":{"x":0.167,"y":0.166},"i":{"x":0.833,"y":0.845},"s":[209.478,93.124,0],"t":45.6,"ti":[-0.145,-0.046,0],"to":[0.158,0.038,0]},{"o":{"x":0.167,"y":0.163},"i":{"x":0.833,"y":0.843},"s":[209.934,93.25,0],"t":46.4,"ti":[-0.069,-0.025,0],"to":[0.145,0.046,0]},{"s":[210.348,93.398,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":6.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":10.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":28},{"s":[0],"t":40.8}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[10,10],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.8353,0.749,1],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":47},{"ty":4,"nm":"Shape Layer 4","sr":1,"st":1.6,"op":48,"ip":1.6,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":1.052},"s":[91.411,73.902,100],"t":1.6},{"o":{"x":0.167,"y":0.032},"i":{"x":0.833,"y":0.827},"s":[65.83,91.918,100],"t":2.4},{"o":{"x":0.167,"y":0.161},"i":{"x":0.833,"y":1.046},"s":[107.448,92.901,100],"t":3.2},{"o":{"x":0.167,"y":0.03},"i":{"x":0.833,"y":0.942},"s":[152.078,99.113,100],"t":4},{"o":{"x":0.167,"y":-0.195},"i":{"x":0.833,"y":0.847},"s":[82.703,50.368,100],"t":4.8},{"o":{"x":0.167,"y":0.183},"i":{"x":0.833,"y":1.029},"s":[103.48,54.226,100],"t":5.6},{"o":{"x":0.167,"y":0.022},"i":{"x":0.833,"y":0.79},"s":[120.884,65.462,100],"t":6.4},{"o":{"x":0.167,"y":0.138},"i":{"x":0.833,"y":0.94},"s":[97.362,90.861,100],"t":7.2},{"o":{"x":0.167,"y":-0.209},"i":{"x":0.833,"y":0.855},"s":[61.56,81.156,100],"t":8},{"o":{"x":0.167,"y":0.196},"i":{"x":0.833,"y":1.023},"s":[71.774,85.037,100],"t":8.8},{"o":{"x":0.167,"y":0.018},"i":{"x":0.833,"y":1.369},"s":[79.328,46.686,100],"t":9.6},{"o":{"x":0.167,"y":0.068},"i":{"x":0.833,"y":0.894},"s":[69.652,98.9,100],"t":10.4},{"o":{"x":0.167,"y":0.384},"i":{"x":0.833,"y":1.223},"s":[122.192,89.119,100],"t":11.2},{"o":{"x":0.167,"y":0.061},"i":{"x":0.833,"y":0.92},"s":[136.768,80.556,100],"t":12},{"o":{"x":0.167,"y":-1.772},"i":{"x":0.833,"y":-0.268},"s":[83.231,96.867,100],"t":12.8},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":1.041},"s":[85.636,104.189,100],"t":13.6},{"o":{"x":0.167,"y":0.028},"i":{"x":0.833,"y":0.882},"s":[119.843,86.028,100],"t":14.4},{"o":{"x":0.167,"y":0.286},"i":{"x":0.833,"y":1.101},"s":[68.608,42.162,100],"t":15.2},{"o":{"x":0.167,"y":0.046},"i":{"x":0.833,"y":0.862},"s":[47.52,43.647,100],"t":16},{"o":{"x":0.167,"y":0.21},"i":{"x":0.833,"y":0.951},"s":[94.079,83.818,100],"t":16.8},{"o":{"x":0.167,"y":-0.12},"i":{"x":0.833,"y":0.63},"s":[124.614,45.446,100],"t":17.6},{"o":{"x":0.167,"y":0.108},"i":{"x":0.833,"y":0.959},"s":[112.121,74.09,100],"t":18.4},{"o":{"x":0.167,"y":-0.082},"i":{"x":0.833,"y":0.798},"s":[69.17,105.139,100],"t":19.2},{"o":{"x":0.167,"y":0.142},"i":{"x":0.833,"y":0.989},"s":[90.804,123.544,100],"t":20},{"o":{"x":0.167,"y":-0.013},"i":{"x":0.833,"y":0.836},"s":[121.588,95.744,100],"t":20.8},{"o":{"x":0.167,"y":0.17},"i":{"x":0.833,"y":0.88},"s":[95.051,142.325,100],"t":21.6},{"o":{"x":0.167,"y":0.275},"i":{"x":0.833,"y":0.702},"s":[69.508,113.896,100],"t":22.4},{"o":{"x":0.167,"y":0.116},"i":{"x":0.833,"y":0.962},"s":[58.415,111.056,100],"t":23.2},{"o":{"x":0.167,"y":-0.069},"i":{"x":0.833,"y":0.975},"s":[29.777,98.67,100],"t":24},{"o":{"x":0.167,"y":-0.036},"i":{"x":0.833,"y":0.682},"s":[45.407,56.133,100],"t":24.8},{"o":{"x":0.167,"y":0.113},"i":{"x":0.833,"y":0.99},"s":[34.491,83.602,100],"t":25.6},{"o":{"x":0.167,"y":-0.012},"i":{"x":0.833,"y":0.867},"s":[3.789,68.283,100],"t":26.4},{"o":{"x":0.167,"y":0.224},"i":{"x":0.833,"y":0.991},"s":[30.69,80.365,100],"t":27.2},{"o":{"x":0.167,"y":-0.01},"i":{"x":0.833,"y":1.11},"s":[46.645,32.371,100],"t":28},{"o":{"x":0.167,"y":0.047},"i":{"x":0.833,"y":0.919},"s":[32.343,1.12,100],"t":28.8},{"o":{"x":0.167,"y":-2.466},"i":{"x":0.833,"y":-0.962},"s":[65.552,37.014,100],"t":29.6},{"o":{"x":0.167,"y":0.087},"i":{"x":0.833,"y":1.026},"s":[64.467,12.19,100],"t":30.4},{"o":{"x":0.167,"y":0.02},"i":{"x":0.833,"y":1.059},"s":[40,37.362,100],"t":31.2},{"o":{"x":0.167,"y":0.034},"i":{"x":0.833,"y":0.936},"s":[72.228,33.594,100],"t":32},{"o":{"x":0.167,"y":-0.269},"i":{"x":0.833,"y":0.744},"s":[17.233,-8.641,100],"t":32.8},{"o":{"x":0.167,"y":0.124},"i":{"x":0.833,"y":1.021},"s":[30.25,-1.935,100],"t":33.6},{"o":{"x":0.167,"y":0.017},"i":{"x":0.833,"y":0.994},"s":[57.17,-4.506,100],"t":34.4},{"o":{"x":0.167,"y":-0.006},"i":{"x":0.833,"y":0.998},"s":[23.549,2.656,100],"t":35.2},{"o":{"x":0.167,"y":-0.002},"i":{"x":0.833,"y":0.948},"s":[54.911,-2.436,100],"t":36},{"o":{"x":0.167,"y":-0.138},"i":{"x":0.833,"y":1.044},"s":[24.231,30.266,100],"t":36.8},{"o":{"x":0.167,"y":0.029},"i":{"x":0.833,"y":0.98},"s":[35.767,50.837,100],"t":37.6},{"o":{"x":0.167,"y":-0.027},"i":{"x":0.833,"y":1.284},"s":[18.177,10.486,100],"t":38.4},{"o":{"x":0.167,"y":0.064},"i":{"x":0.833,"y":0.93},"s":[31.443,16.354,100],"t":39.2},{"o":{"x":0.167,"y":-0.427},"i":{"x":0.833,"y":0.369},"s":[-27.024,56.172,100],"t":40},{"o":{"x":0.167,"y":0.096},"i":{"x":0.833,"y":0.885},"s":[-17.47,27.705,100],"t":40.8},{"o":{"x":0.167,"y":0.306},"i":{"x":0.833,"y":1.145},"s":[45.271,-6.879,100],"t":41.6},{"o":{"x":0.167,"y":0.053},"i":{"x":0.833,"y":0.872},"s":[68.762,25.916,100],"t":42.4},{"o":{"x":0.167,"y":0.239},"i":{"x":0.833,"y":1.048},"s":[4.456,44.914,100],"t":43.2},{"o":{"x":0.167,"y":0.03},"i":{"x":0.833,"y":0.954},"s":[-30.068,7.408,100],"t":44},{"o":{"x":0.167,"y":-0.101},"i":{"x":0.833,"y":1.082},"s":[24.371,62.294,100],"t":44.8},{"o":{"x":0.167,"y":0.041},"i":{"x":0.833,"y":0.894},"s":[-0.235,34.376,100],"t":45.6},{"o":{"x":0.167,"y":0.394},"i":{"x":0.833,"y":0.833},"s":[48.622,36.203,100],"t":46.4},{"s":[61.716,0.231,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[273.94,260.349,0],"t":1.6,"ti":[0.915,-1.476,0],"to":[-0.179,0.314,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[272.864,262.231,0],"t":2.4,"ti":[2.375,-3.065,0],"to":[-0.915,1.476,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[268.451,269.206,0],"t":3.2,"ti":[3.841,-3.636,0],"to":[-2.375,3.065,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[258.614,280.62,0],"t":4,"ti":[4.317,-2.988,0],"to":[-3.841,3.636,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[245.406,291.021,0],"t":4.8,"ti":[3.939,-2.213,0],"to":[-4.317,2.988,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[232.715,298.549,0],"t":5.6,"ti":[3.368,-1.76,0],"to":[-3.939,2.213,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[221.77,304.296,0],"t":6.4,"ti":[2.855,-1.514,0],"to":[-3.368,1.76,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[212.51,309.106,0],"t":7.2,"ti":[2.434,-1.366,0],"to":[-2.855,1.514,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[204.641,313.381,0],"t":8,"ti":[2.092,-1.261,0],"to":[-2.434,1.366,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[197.904,317.3,0],"t":8.8,"ti":[1.81,-1.177,0],"to":[-2.092,1.261,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[192.09,320.946,0],"t":9.6,"ti":[1.575,-1.103,0],"to":[-1.81,1.177,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[187.044,324.36,0],"t":10.4,"ti":[1.376,-1.035,0],"to":[-1.575,1.103,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[182.643,327.564,0],"t":11.2,"ti":[1.205,-0.972,0],"to":[-1.376,1.035,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[178.791,330.572,0],"t":12,"ti":[1.057,-0.911,0],"to":[-1.205,0.972,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[175.413,333.393,0],"t":12.8,"ti":[0.928,-0.852,0],"to":[-1.057,0.911,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[172.447,336.036,0],"t":13.6,"ti":[0.814,-0.797,0],"to":[-0.928,0.852,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[169.845,338.508,0],"t":14.4,"ti":[0.712,-0.743,0],"to":[-0.814,0.797,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[167.565,340.816,0],"t":15.2,"ti":[0.621,-0.692,0],"to":[-0.712,0.743,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[165.574,342.967,0],"t":16,"ti":[0.539,-0.642,0],"to":[-0.621,0.692,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[163.841,344.967,0],"t":16.8,"ti":[0.464,-0.595,0],"to":[-0.539,0.642,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[162.342,346.821,0],"t":17.6,"ti":[0.397,-0.549,0],"to":[-0.464,0.595,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[161.056,348.535,0],"t":18.4,"ti":[0.336,-0.504,0],"to":[-0.397,0.549,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[159.962,350.113,0],"t":19.2,"ti":[0.28,-0.461,0],"to":[-0.336,0.504,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[159.042,351.559,0],"t":20,"ti":[0.23,-0.419,0],"to":[-0.28,0.461,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[158.282,352.878,0],"t":20.8,"ti":[0.185,-0.378,0],"to":[-0.23,0.419,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[157.663,354.073,0],"t":21.6,"ti":[0.145,-0.339,0],"to":[-0.185,0.378,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[157.172,355.149,0],"t":22.4,"ti":[0.11,-0.301,0],"to":[-0.145,0.339,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[156.793,356.108,0],"t":23.2,"ti":[0.08,-0.264,0],"to":[-0.11,0.301,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[156.511,356.955,0],"t":24,"ti":[0.054,-0.227,0],"to":[-0.08,0.264,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[156.313,357.691,0],"t":24.8,"ti":[0.034,-0.191,0],"to":[-0.054,0.227,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[156.184,358.318,0],"t":25.6,"ti":[0.018,-0.156,0],"to":[-0.034,0.191,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[156.11,358.839,0],"t":26.4,"ti":[0.007,-0.122,0],"to":[-0.018,0.156,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[156.077,359.255,0],"t":27.2,"ti":[-0.009,-0.098,0],"to":[-0.007,0.122,0]},{"o":{"x":0.167,"y":0.037},"i":{"x":0.833,"y":0.964},"s":[156.07,359.568,0],"t":28,"ti":[-0.034,-0.089,0],"to":[0.009,0.098,0]},{"o":{"x":0.167,"y":0.077},"i":{"x":0.833,"y":0.917},"s":[156.129,359.841,0],"t":28.8,"ti":[-0.059,-0.084,0],"to":[0.034,0.089,0]},{"o":{"x":0.167,"y":0.105},"i":{"x":0.833,"y":0.886},"s":[156.271,360.101,0],"t":29.6,"ti":[-0.08,-0.078,0],"to":[0.059,0.084,0]},{"o":{"x":0.167,"y":0.123},"i":{"x":0.833,"y":0.867},"s":[156.482,360.344,0],"t":30.4,"ti":[-0.098,-0.071,0],"to":[0.08,0.078,0]},{"o":{"x":0.167,"y":0.136},"i":{"x":0.833,"y":0.856},"s":[156.751,360.569,0],"t":31.2,"ti":[-0.112,-0.063,0],"to":[0.098,0.071,0]},{"o":{"x":0.167,"y":0.145},"i":{"x":0.833,"y":0.848},"s":[157.068,360.771,0],"t":32,"ti":[-0.124,-0.054,0],"to":[0.112,0.063,0]},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.844},"s":[157.425,360.948,0],"t":32.8,"ti":[-0.129,-0.049,0],"to":[0.124,0.054,0]},{"o":{"x":0.167,"y":0.156},"i":{"x":0.833,"y":0.846},"s":[157.811,361.097,0],"t":33.6,"ti":[-0.126,-0.051,0],"to":[0.129,0.049,0]},{"o":{"x":0.167,"y":0.155},"i":{"x":0.833,"y":0.851},"s":[158.201,361.241,0],"t":34.4,"ti":[-0.118,-0.056,0],"to":[0.126,0.051,0]},{"o":{"x":0.167,"y":0.152},"i":{"x":0.833,"y":0.856},"s":[158.569,361.404,0],"t":35.2,"ti":[-0.109,-0.06,0],"to":[0.118,0.056,0]},{"o":{"x":0.167,"y":0.148},"i":{"x":0.833,"y":0.862},"s":[158.91,361.58,0],"t":36,"ti":[-0.098,-0.062,0],"to":[0.109,0.06,0]},{"o":{"x":0.167,"y":0.143},"i":{"x":0.833,"y":0.868},"s":[159.221,361.765,0],"t":36.8,"ti":[-0.087,-0.063,0],"to":[0.098,0.062,0]},{"o":{"x":0.167,"y":0.137},"i":{"x":0.833,"y":0.876},"s":[159.499,361.954,0],"t":37.6,"ti":[-0.074,-0.063,0],"to":[0.087,0.063,0]},{"o":{"x":0.167,"y":0.13},"i":{"x":0.833,"y":0.884},"s":[159.741,362.144,0],"t":38.4,"ti":[-0.062,-0.061,0],"to":[0.074,0.063,0]},{"o":{"x":0.167,"y":0.121},"i":{"x":0.833,"y":0.895},"s":[159.945,362.33,0],"t":39.2,"ti":[-0.049,-0.058,0],"to":[0.062,0.061,0]},{"o":{"x":0.167,"y":0.108},"i":{"x":0.833,"y":0.908},"s":[160.111,362.509,0],"t":40,"ti":[-0.036,-0.053,0],"to":[0.049,0.058,0]},{"o":{"x":0.167,"y":0.091},"i":{"x":0.833,"y":0.925},"s":[160.237,362.677,0],"t":40.8,"ti":[-0.023,-0.048,0],"to":[0.036,0.053,0]},{"o":{"x":0.167,"y":0.065},"i":{"x":0.833,"y":0.947},"s":[160.325,362.83,0],"t":41.6,"ti":[-0.011,-0.042,0],"to":[0.023,0.048,0]},{"o":{"x":0.167,"y":0.023},"i":{"x":0.833,"y":0.982},"s":[160.376,362.965,0],"t":42.4,"ti":[0.001,-0.034,0],"to":[0.011,0.042,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[160.39,363.08,0],"t":43.2,"ti":[0.011,-0.026,0],"to":[-0.001,0.034,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[160.371,363.171,0],"t":44,"ti":[0.021,-0.017,0],"to":[-0.011,0.026,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[160.322,363.235,0],"t":44.8,"ti":[0.029,-0.006,0],"to":[-0.021,0.017,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[160.247,363.27,0],"t":45.6,"ti":[0.035,0.004,0],"to":[-0.029,0.006,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[160.149,363.273,0],"t":46.4,"ti":[0.019,0.005,0],"to":[-0.035,-0.004,0]},{"s":[160.035,363.244,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":1.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":5.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":23.2},{"s":[0],"t":36}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[10,10],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.8353,0.749,1],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":48},{"ty":4,"nm":"Shape Layer 3","sr":1,"st":5.6,"op":48,"ip":5.6,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.852},"s":[121.49,88.737,100],"t":5.6},{"o":{"x":0.167,"y":0.19},"i":{"x":0.833,"y":0.91},"s":[91.076,88.159,100],"t":6.4},{"o":{"x":0.167,"y":1.162},"i":{"x":0.833,"y":0.429},"s":[67.412,108.062,100],"t":7.2},{"o":{"x":0.167,"y":0.098},"i":{"x":0.833,"y":1.033},"s":[65.583,106.955,100],"t":8},{"o":{"x":0.167,"y":0.024},"i":{"x":0.833,"y":0.841},"s":[54.874,48.475,100],"t":8.8},{"o":{"x":0.167,"y":0.176},"i":{"x":0.833,"y":0.733},"s":[69.879,74.186,100],"t":9.6},{"o":{"x":0.167,"y":0.121},"i":{"x":0.833,"y":1.032},"s":[83.434,108.14,100],"t":10.4},{"o":{"x":0.167,"y":0.023},"i":{"x":0.833,"y":0.978},"s":[113.236,125.507,100],"t":11.2},{"o":{"x":0.167,"y":-0.03},"i":{"x":0.833,"y":0.937},"s":[72.085,108.002,100],"t":12},{"o":{"x":0.167,"y":-0.261},"i":{"x":0.833,"y":0.63},"s":[102.383,97.845,100],"t":12.8},{"o":{"x":0.167,"y":0.108},"i":{"x":0.833,"y":0.922},"s":[95.054,74.753,100],"t":13.6},{"o":{"x":0.167,"y":-1.116},"i":{"x":0.833,"y":0.758},"s":[69.833,55.593,100],"t":14.4},{"o":{"x":0.167,"y":0.127},"i":{"x":0.833,"y":-0.253},"s":[71.585,33.206,100],"t":15.2},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":0.962},"s":[74.924,83.413,100],"t":16},{"o":{"x":0.167,"y":-0.069},"i":{"x":0.833,"y":0.895},"s":[121.778,73.433,100],"t":16.8},{"o":{"x":0.167,"y":0.41},"i":{"x":0.833,"y":0.929},"s":[96.063,64.842,100],"t":17.6},{"o":{"x":0.167,"y":-0.493},"i":{"x":0.833,"y":-2.344},"s":[89.506,91.864,100],"t":18.4},{"o":{"x":0.167,"y":0.085},"i":{"x":0.833,"y":1},"s":[90.453,96.143,100],"t":19.2},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":0.913},"s":[127.532,66.021,100],"t":20},{"o":{"x":0.167,"y":1.831},"i":{"x":0.833,"y":1.203},"s":[90.276,96.965,100],"t":20.8},{"o":{"x":0.167,"y":0.059},"i":{"x":0.833,"y":1.094},"s":[88.5,122.317,100],"t":21.6},{"o":{"x":0.167,"y":0.044},"i":{"x":0.833,"y":0.722},"s":[94.599,91.269,100],"t":22.4},{"o":{"x":0.167,"y":0.119},"i":{"x":0.833,"y":0.905},"s":[81.585,110.87,100],"t":23.2},{"o":{"x":0.167,"y":0.689},"i":{"x":0.833,"y":0.81},"s":[51.164,75.568,100],"t":24},{"o":{"x":0.167,"y":0.148},"i":{"x":0.833,"y":0.817},"s":[46.977,93.082,100],"t":24.8},{"o":{"x":0.167,"y":0.153},"i":{"x":0.833,"y":1.272},"s":[41.615,86.585,100],"t":25.6},{"o":{"x":0.167,"y":0.064},"i":{"x":0.833,"y":0.928},"s":[35.186,124.337,100],"t":26.4},{"o":{"x":0.167,"y":-0.532},"i":{"x":0.833,"y":1.499},"s":[62.591,88.269,100],"t":27.2},{"o":{"x":0.167,"y":0.071},"i":{"x":0.833,"y":0.951},"s":[58.881,26.321,100],"t":28},{"o":{"x":0.167,"y":-0.121},"i":{"x":0.833,"y":1.072},"s":[84.818,48.109,100],"t":28.8},{"o":{"x":0.167,"y":0.038},"i":{"x":0.833,"y":0.946},"s":[74.254,46.968,100],"t":29.6},{"o":{"x":0.167,"y":-0.15},"i":{"x":0.833,"y":0.594},"s":[93.883,59.486,100],"t":30.4},{"o":{"x":0.167,"y":0.105},"i":{"x":0.833,"y":0.867},"s":[86.872,59.571,100],"t":31.2},{"o":{"x":0.167,"y":0.224},"i":{"x":0.833,"y":1.076},"s":[59.763,24.304,100],"t":32},{"o":{"x":0.167,"y":0.04},"i":{"x":0.833,"y":1.02},"s":[43.653,28.352,100],"t":32.8},{"o":{"x":0.167,"y":0.016},"i":{"x":0.833,"y":0.928},"s":[74.399,44.017,100],"t":33.6},{"o":{"x":0.167,"y":-0.523},"i":{"x":0.833,"y":1.401},"s":[36.198,34.152,100],"t":34.4},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":0.943},"s":[41.448,50.974,100],"t":35.2},{"o":{"x":0.167,"y":-0.183},"i":{"x":0.833,"y":1.109},"s":[10.923,53.931,100],"t":36},{"o":{"x":0.167,"y":0.047},"i":{"x":0.833,"y":1.042},"s":[20.467,78.157,100],"t":36.8},{"o":{"x":0.167,"y":0.028},"i":{"x":0.833,"y":1.003},"s":[-1.575,13.482,100],"t":37.6},{"o":{"x":0.167,"y":0.003},"i":{"x":0.833,"y":0.927},"s":[31.467,39.632,100],"t":38.4},{"o":{"x":0.167,"y":-0.568},"i":{"x":0.833,"y":0.201},"s":[-2.832,75.796,100],"t":39.2},{"o":{"x":0.167,"y":0.093},"i":{"x":0.833,"y":0.885},"s":[1.556,50.773,100],"t":40},{"o":{"x":0.167,"y":0.302},"i":{"x":0.833,"y":0.966},"s":[39.258,-25.561,100],"t":40.8},{"o":{"x":0.167,"y":-0.057},"i":{"x":0.833,"y":0.108},"s":[53.602,3.457,100],"t":41.6},{"o":{"x":0.167,"y":0.092},"i":{"x":0.833,"y":0.962},"s":[45.062,33.613,100],"t":42.4},{"o":{"x":0.167,"y":-0.07},"i":{"x":0.833,"y":0.964},"s":[-37.848,-8.287,100],"t":43.2},{"o":{"x":0.167,"y":-0.063},"i":{"x":0.833,"y":1.116},"s":[7.213,56.765,100],"t":44},{"o":{"x":0.167,"y":0.049},"i":{"x":0.833,"y":0.896},"s":[-18.526,38.06,100],"t":44.8},{"o":{"x":0.167,"y":0.416},"i":{"x":0.833,"y":0.835},"s":[43.172,56.215,100],"t":45.6},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.833},"s":[58.626,-14.531,100],"t":46.4},{"s":[73.773,0.993,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[272.377,258.087,0],"t":5.6,"ti":[2.139,-0.681,0],"to":[-0.394,0.137,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[270.01,258.906,0],"t":6.4,"ti":[5.098,-1.104,0],"to":[-2.139,0.681,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[259.541,262.172,0],"t":7.2,"ti":[7.13,-0.303,0],"to":[-5.098,1.104,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[239.424,265.531,0],"t":8,"ti":[6.918,1.295,0],"to":[-7.13,0.303,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[216.76,263.988,0],"t":8.8,"ti":[5.553,2.383,0],"to":[-6.918,-1.295,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[197.916,257.762,0],"t":9.6,"ti":[4.294,2.71,0],"to":[-5.553,-2.383,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[183.44,249.693,0],"t":10.4,"ti":[3.412,2.643,0],"to":[-4.294,-2.71,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[172.149,241.499,0],"t":11.2,"ti":[2.824,2.427,0],"to":[-3.412,-2.643,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[162.967,233.838,0],"t":12,"ti":[2.43,2.167,0],"to":[-2.824,-2.427,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[155.204,226.937,0],"t":12.8,"ti":[2.166,1.903,0],"to":[-2.43,-2.167,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[148.386,220.833,0],"t":13.6,"ti":[1.988,1.643,0],"to":[-2.166,-1.903,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[142.207,215.519,0],"t":14.4,"ti":[1.866,1.384,0],"to":[-1.988,-1.643,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[136.458,210.978,0],"t":15.2,"ti":[1.768,1.113,0],"to":[-1.866,-1.384,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[131.01,207.214,0],"t":16,"ti":[1.677,0.828,0],"to":[-1.768,-1.113,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[125.848,204.301,0],"t":16.8,"ti":[1.589,0.546,0],"to":[-1.677,-0.828,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[120.949,202.245,0],"t":17.6,"ti":[1.493,0.277,0],"to":[-1.589,-0.546,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[116.315,201.024,0],"t":18.4,"ti":[1.38,0.034,0],"to":[-1.493,-0.277,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[111.993,200.584,0],"t":19.2,"ti":[1.254,-0.168,0],"to":[-1.38,-0.034,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[108.033,200.82,0],"t":20,"ti":[1.122,-0.322,0],"to":[-1.254,0.168,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[104.469,201.591,0],"t":20.8,"ti":[0.991,-0.429,0],"to":[-1.122,0.322,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[101.304,202.75,0],"t":21.6,"ti":[0.869,-0.496,0],"to":[-0.991,0.429,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[98.52,204.163,0],"t":22.4,"ti":[0.759,-0.533,0],"to":[-0.869,0.496,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[96.088,205.725,0],"t":23.2,"ti":[0.662,-0.548,0],"to":[-0.759,0.533,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[93.965,207.359,0],"t":24,"ti":[0.577,-0.547,0],"to":[-0.662,0.548,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[92.114,209.011,0],"t":24.8,"ti":[0.502,-0.535,0],"to":[-0.577,0.547,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[90.501,210.642,0],"t":25.6,"ti":[0.436,-0.515,0],"to":[-0.502,0.535,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[89.1,212.221,0],"t":26.4,"ti":[0.376,-0.488,0],"to":[-0.436,0.515,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[87.887,213.729,0],"t":27.2,"ti":[0.324,-0.458,0],"to":[-0.376,0.488,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[86.842,215.15,0],"t":28,"ti":[0.277,-0.424,0],"to":[-0.324,0.458,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[85.945,216.475,0],"t":28.8,"ti":[0.234,-0.388,0],"to":[-0.277,0.424,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[85.182,217.694,0],"t":29.6,"ti":[0.195,-0.349,0],"to":[-0.234,0.388,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[84.541,218.8,0],"t":30.4,"ti":[0.16,-0.31,0],"to":[-0.195,0.349,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[84.009,219.79,0],"t":31.2,"ti":[0.129,-0.269,0],"to":[-0.16,0.31,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[83.578,220.658,0],"t":32,"ti":[0.099,-0.226,0],"to":[-0.129,0.269,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[83.238,221.401,0],"t":32.8,"ti":[0.072,-0.183,0],"to":[-0.099,0.226,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[82.984,222.016,0],"t":33.6,"ti":[0.048,-0.14,0],"to":[-0.072,0.183,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[82.806,222.502,0],"t":34.4,"ti":[0.026,-0.097,0],"to":[-0.048,0.14,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[82.697,222.858,0],"t":35.2,"ti":[0.005,-0.052,0],"to":[-0.026,0.097,0]},{"o":{"x":0.167,"y":0.045},"i":{"x":0.833,"y":0.975},"s":[82.651,223.082,0],"t":36,"ti":[-0.014,-0.008,0],"to":[-0.005,0.052,0]},{"o":{"x":0.167,"y":0.139},"i":{"x":0.833,"y":0.801},"s":[82.666,223.173,0],"t":36.8,"ti":[-0.027,0.032,0],"to":[0.014,0.008,0]},{"o":{"x":0.167,"y":0.064},"i":{"x":0.833,"y":0.899},"s":[82.736,223.128,0],"t":37.6,"ti":[-0.027,0.062,0],"to":[0.027,-0.032,0]},{"o":{"x":0.167,"y":0.046},"i":{"x":0.833,"y":0.941},"s":[82.826,222.979,0],"t":38.4,"ti":[-0.023,0.085,0],"to":[0.027,-0.062,0]},{"o":{"x":0.167,"y":0.032},"i":{"x":0.833,"y":0.962},"s":[82.9,222.757,0],"t":39.2,"ti":[-0.025,0.099,0],"to":[0.023,-0.085,0]},{"o":{"x":0.167,"y":0.044},"i":{"x":0.833,"y":0.954},"s":[82.964,222.469,0],"t":40,"ti":[-0.032,0.102,0],"to":[0.025,-0.099,0]},{"o":{"x":0.167,"y":0.053},"i":{"x":0.833,"y":0.946},"s":[83.05,222.164,0],"t":40.8,"ti":[-0.036,0.101,0],"to":[0.032,-0.102,0]},{"o":{"x":0.167,"y":0.059},"i":{"x":0.833,"y":0.942},"s":[83.155,221.857,0],"t":41.6,"ti":[-0.038,0.098,0],"to":[0.036,-0.101,0]},{"o":{"x":0.167,"y":0.064},"i":{"x":0.833,"y":0.94},"s":[83.269,221.556,0],"t":42.4,"ti":[-0.038,0.093,0],"to":[0.038,-0.098,0]},{"o":{"x":0.167,"y":0.066},"i":{"x":0.833,"y":0.939},"s":[83.385,221.268,0],"t":43.2,"ti":[-0.035,0.085,0],"to":[0.038,-0.093,0]},{"o":{"x":0.167,"y":0.067},"i":{"x":0.833,"y":0.94},"s":[83.497,221,0],"t":44,"ti":[-0.031,0.076,0],"to":[0.035,-0.085,0]},{"o":{"x":0.167,"y":0.066},"i":{"x":0.833,"y":0.944},"s":[83.598,220.758,0],"t":44.8,"ti":[-0.024,0.065,0],"to":[0.031,-0.076,0]},{"o":{"x":0.167,"y":0.061},"i":{"x":0.833,"y":0.951},"s":[83.682,220.545,0],"t":45.6,"ti":[-0.017,0.053,0],"to":[0.024,-0.065,0]},{"o":{"x":0.167,"y":0.048},"i":{"x":0.833,"y":0.958},"s":[83.745,220.367,0],"t":46.4,"ti":[-0.006,0.023,0],"to":[0.017,-0.053,0]},{"s":[83.781,220.227,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":5.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":9.6},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":27.2},{"s":[0],"t":40}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[10,10],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.4745,0.8392,0.6667],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":49},{"ty":4,"nm":"Shape Layer 2","sr":1,"st":4.8,"op":48,"ip":4.8,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.867},"s":[119.144,105.827,100],"t":4.8},{"o":{"x":0.167,"y":0.222},"i":{"x":0.833,"y":0.795},"s":[108.917,89.684,100],"t":5.6},{"o":{"x":0.167,"y":0.141},"i":{"x":0.833,"y":0.672},"s":[102.765,122.894,100],"t":6.4},{"o":{"x":0.167,"y":0.112},"i":{"x":0.833,"y":0.908},"s":[93.801,138.844,100],"t":7.2},{"o":{"x":0.167,"y":0.904},"i":{"x":0.833,"y":0.347},"s":[67.511,88.612,100],"t":8},{"o":{"x":0.167,"y":0.096},"i":{"x":0.833,"y":1.047},"s":[64.842,45.024,100],"t":8.8},{"o":{"x":0.167,"y":0.03},"i":{"x":0.833,"y":1.006},"s":[46.604,54.307,100],"t":9.6},{"o":{"x":0.167,"y":0.006},"i":{"x":0.833,"y":1.068},"s":[75.236,155.919,100],"t":10.4},{"o":{"x":0.167,"y":0.037},"i":{"x":0.833,"y":0.917},"s":[44.513,140.008,100],"t":11.2},{"o":{"x":0.167,"y":270.231},"i":{"x":0.833,"y":152.337},"s":[100.175,95.172,100],"t":12},{"o":{"x":0.167,"y":0.083},"i":{"x":0.833,"y":1.025},"s":[100.192,64.696,100],"t":12.8},{"o":{"x":0.167,"y":0.02},"i":{"x":0.833,"y":1.006},"s":[68.993,82.975,100],"t":13.6},{"o":{"x":0.167,"y":0.006},"i":{"x":0.833,"y":0.991},"s":[109.723,76.983,100],"t":14.4},{"o":{"x":0.167,"y":-0.01},"i":{"x":0.833,"y":0.999},"s":[65.994,44.292,100],"t":15.2},{"o":{"x":0.167,"y":-0.001},"i":{"x":0.833,"y":0.952},"s":[105.048,87.05,100],"t":16},{"o":{"x":0.167,"y":-0.115},"i":{"x":0.833,"y":0.907},"s":[66.25,88.729,100],"t":16.8},{"o":{"x":0.167,"y":0.774},"i":{"x":0.833,"y":-0.395},"s":[82.513,53.595,100],"t":17.6},{"o":{"x":0.167,"y":0.089},"i":{"x":0.833,"y":1.013},"s":[84.475,49.774,100],"t":18.4},{"o":{"x":0.167,"y":0.011},"i":{"x":0.833,"y":0.914},"s":[115.346,55.183,100],"t":19.2},{"o":{"x":0.167,"y":2.433},"i":{"x":0.833,"y":3.517},"s":[79.807,68.878,100],"t":20},{"o":{"x":0.167,"y":0.081},"i":{"x":0.833,"y":0.948},"s":[78.547,127.052,100],"t":20.8},{"o":{"x":0.167,"y":-0.137},"i":{"x":0.833,"y":0.885},"s":[117.885,89.313,100],"t":21.6},{"o":{"x":0.167,"y":0.305},"i":{"x":0.833,"y":0.672},"s":[103.035,99.348,100],"t":22.4},{"o":{"x":0.167,"y":0.112},"i":{"x":0.833,"y":0.965},"s":[97.463,73.594,100],"t":23.2},{"o":{"x":0.167,"y":-0.06},"i":{"x":0.833,"y":1.366},"s":[81.079,66.939,100],"t":24},{"o":{"x":0.167,"y":0.068},"i":{"x":0.833,"y":0.944},"s":[90.595,82.121,100],"t":24.8},{"o":{"x":0.167,"y":-0.173},"i":{"x":0.833,"y":0.794},"s":[39.327,80.989,100],"t":25.6},{"o":{"x":0.167,"y":0.14},"i":{"x":0.833,"y":0.967},"s":[55.998,99.978,100],"t":26.4},{"o":{"x":0.167,"y":-0.055},"i":{"x":0.833,"y":0.774},"s":[80.566,71.181,100],"t":27.2},{"o":{"x":0.167,"y":0.132},"i":{"x":0.833,"y":1.053},"s":[65.735,50.454,100],"t":28},{"o":{"x":0.167,"y":0.032},"i":{"x":0.833,"y":0.93},"s":[40.364,78.153,100],"t":28.8},{"o":{"x":0.167,"y":-0.444},"i":{"x":0.833,"y":0.919},"s":[81.902,78.284,100],"t":29.6},{"o":{"x":0.167,"y":-2.408},"i":{"x":0.833,"y":8.691},"s":[75.338,75.857,100],"t":30.4},{"o":{"x":0.167,"y":0.082},"i":{"x":0.833,"y":0.962},"s":[75.557,47.651,100],"t":31.2},{"o":{"x":0.167,"y":-0.069},"i":{"x":0.833,"y":1.151},"s":[55.074,52.465,100],"t":32},{"o":{"x":0.167,"y":0.054},"i":{"x":0.833,"y":0.832},"s":[66.306,80.999,100],"t":32.8},{"o":{"x":0.167,"y":0.165},"i":{"x":0.833,"y":0.912},"s":[34.754,40.269,100],"t":33.6},{"o":{"x":0.167,"y":1.584},"i":{"x":0.833,"y":1.421},"s":[2.594,59.324,100],"t":34.4},{"o":{"x":0.167,"y":0.07},"i":{"x":0.833,"y":1.174},"s":[0.808,61.219,100],"t":35.2},{"o":{"x":0.167,"y":0.056},"i":{"x":0.833,"y":1.039},"s":[11.618,55.345,100],"t":36},{"o":{"x":0.167,"y":0.027},"i":{"x":0.833,"y":0.955},"s":[-21.777,-19.555,100],"t":36.8},{"o":{"x":0.167,"y":-0.096},"i":{"x":0.833,"y":1.083},"s":[27.422,8.427,100],"t":37.6},{"o":{"x":0.167,"y":0.042},"i":{"x":0.833,"y":0.896},"s":[4.597,66.513,100],"t":38.4},{"o":{"x":0.167,"y":0.425},"i":{"x":0.833,"y":1.087},"s":[50.12,55.561,100],"t":39.2},{"o":{"x":0.167,"y":0.043},"i":{"x":0.833,"y":0.942},"s":[61.217,-19.054,100],"t":40},{"o":{"x":0.167,"y":-0.186},"i":{"x":0.833,"y":1.717},"s":[38.47,-4.836,100],"t":40.8},{"o":{"x":0.167,"y":0.075},"i":{"x":0.833,"y":0.956},"s":[45.499,17.824,100],"t":41.6},{"o":{"x":0.167,"y":-0.092},"i":{"x":0.833,"y":0.926},"s":[-22.007,-6.623,100],"t":42.4},{"o":{"x":0.167,"y":-0.679},"i":{"x":0.833,"y":1.362},"s":[10.024,38.847,100],"t":43.2},{"o":{"x":0.167,"y":0.068},"i":{"x":0.833,"y":0.873},"s":[6.522,42.131,100],"t":44},{"o":{"x":0.167,"y":0.243},"i":{"x":0.833,"y":0.708},"s":[25.242,42.037,100],"t":44.8},{"o":{"x":0.167,"y":0.117},"i":{"x":0.833,"y":0.976},"s":[35.027,2.106,100],"t":45.6},{"o":{"x":0.167,"y":-0.034},"i":{"x":0.833,"y":0.833},"s":[59.478,5.911,100],"t":46.4},{"s":[42.168,56.973,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.008},"i":{"x":0.833,"y":0.979},"s":[272.75,257.654,0],"t":4.8,"ti":[-0.208,-2.079,0],"to":[0.022,0.426,0]},{"o":{"x":0.167,"y":0.012},"i":{"x":0.833,"y":0.974},"s":[272.88,260.209,0],"t":5.6,"ti":[-0.762,-4.636,0],"to":[0.208,2.079,0]},{"o":{"x":0.167,"y":0.024},"i":{"x":0.833,"y":0.967},"s":[273.997,270.127,0],"t":6.4,"ti":[-1.59,-6.205,0],"to":[0.762,4.636,0]},{"o":{"x":0.167,"y":0.047},"i":{"x":0.833,"y":0.953},"s":[277.455,288.025,0],"t":7.2,"ti":[-2.259,-5.901,0],"to":[1.59,6.205,0]},{"o":{"x":0.167,"y":0.075},"i":{"x":0.833,"y":0.936},"s":[283.537,307.355,0],"t":8,"ti":[-2.568,-4.763,0],"to":[2.259,5.901,0]},{"o":{"x":0.167,"y":0.098},"i":{"x":0.833,"y":0.918},"s":[291.011,323.433,0],"t":8.8,"ti":[-2.65,-3.689,0],"to":[2.568,4.763,0]},{"o":{"x":0.167,"y":0.116},"i":{"x":0.833,"y":0.901},"s":[298.946,335.933,0],"t":9.6,"ti":[-2.621,-2.842,0],"to":[2.65,3.689,0]},{"o":{"x":0.167,"y":0.13},"i":{"x":0.833,"y":0.887},"s":[306.911,345.569,0],"t":10.4,"ti":[-2.532,-2.186,0],"to":[2.621,2.842,0]},{"o":{"x":0.167,"y":0.142},"i":{"x":0.833,"y":0.875},"s":[314.674,352.986,0],"t":11.2,"ti":[-2.408,-1.678,0],"to":[2.532,2.186,0]},{"o":{"x":0.167,"y":0.151},"i":{"x":0.833,"y":0.866},"s":[322.1,358.684,0],"t":12,"ti":[-2.266,-1.285,0],"to":[2.408,1.678,0]},{"o":{"x":0.167,"y":0.158},"i":{"x":0.833,"y":0.859},"s":[329.119,363.056,0],"t":12.8,"ti":[-2.117,-0.981,0],"to":[2.266,1.285,0]},{"o":{"x":0.167,"y":0.162},"i":{"x":0.833,"y":0.853},"s":[335.695,366.397,0],"t":13.6,"ti":[-1.968,-0.746,0],"to":[2.117,0.981,0]},{"o":{"x":0.167,"y":0.166},"i":{"x":0.833,"y":0.849},"s":[341.819,368.944,0],"t":14.4,"ti":[-1.824,-0.565,0],"to":[1.968,0.746,0]},{"o":{"x":0.167,"y":0.169},"i":{"x":0.833,"y":0.847},"s":[347.502,370.875,0],"t":15.2,"ti":[-1.688,-0.424,0],"to":[1.824,0.565,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.844},"s":[352.764,372.332,0],"t":16,"ti":[-1.56,-0.315,0],"to":[1.688,0.424,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.842},"s":[357.63,373.419,0],"t":16.8,"ti":[-1.442,-0.23,0],"to":[1.56,0.315,0]},{"o":{"x":0.167,"y":0.172},"i":{"x":0.833,"y":0.842},"s":[362.126,374.22,0],"t":17.6,"ti":[-1.332,-0.163,0],"to":[1.442,0.23,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.841},"s":[366.28,374.797,0],"t":18.4,"ti":[-1.23,-0.11,0],"to":[1.332,0.163,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.84},"s":[370.118,375.198,0],"t":19.2,"ti":[-1.135,-0.068,0],"to":[1.23,0.11,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.84},"s":[373.661,375.459,0],"t":20,"ti":[-1.047,-0.035,0],"to":[1.135,0.068,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.84},"s":[376.93,375.608,0],"t":20.8,"ti":[-0.963,-0.007,0],"to":[1.047,0.035,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.84},"s":[379.942,375.666,0],"t":21.6,"ti":[-0.884,0.016,0],"to":[0.963,0.007,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.841},"s":[382.71,375.649,0],"t":22.4,"ti":[-0.808,0.036,0],"to":[0.884,-0.016,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.841},"s":[385.245,375.569,0],"t":23.2,"ti":[-0.736,0.053,0],"to":[0.808,-0.036,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.842},"s":[387.559,375.434,0],"t":24,"ti":[-0.666,0.068,0],"to":[0.736,-0.053,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.843},"s":[389.659,375.251,0],"t":24.8,"ti":[-0.598,0.082,0],"to":[0.666,-0.068,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.845},"s":[391.553,375.025,0],"t":25.6,"ti":[-0.531,0.096,0],"to":[0.598,-0.082,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.845},"s":[393.245,374.757,0],"t":26.4,"ti":[-0.471,0.106,0],"to":[0.531,-0.096,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.845},"s":[394.738,374.451,0],"t":27.2,"ti":[-0.425,0.111,0],"to":[0.471,-0.106,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.847},"s":[396.069,374.119,0],"t":28,"ti":[-0.387,0.11,0],"to":[0.425,-0.111,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.849},"s":[397.286,373.785,0],"t":28.8,"ti":[-0.348,0.107,0],"to":[0.387,-0.11,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.85},"s":[398.388,373.457,0],"t":29.6,"ti":[-0.31,0.102,0],"to":[0.348,-0.107,0]},{"o":{"x":0.167,"y":0.168},"i":{"x":0.833,"y":0.852},"s":[399.376,373.143,0],"t":30.4,"ti":[-0.272,0.094,0],"to":[0.31,-0.102,0]},{"o":{"x":0.167,"y":0.169},"i":{"x":0.833,"y":0.855},"s":[400.249,372.847,0],"t":31.2,"ti":[-0.233,0.086,0],"to":[0.272,-0.094,0]},{"o":{"x":0.167,"y":0.169},"i":{"x":0.833,"y":0.858},"s":[401.007,372.576,0],"t":32,"ti":[-0.195,0.076,0],"to":[0.233,-0.086,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.862},"s":[401.649,372.333,0],"t":32.8,"ti":[-0.156,0.064,0],"to":[0.195,-0.076,0]},{"o":{"x":0.167,"y":0.174},"i":{"x":0.833,"y":0.868},"s":[402.175,372.123,0],"t":33.6,"ti":[-0.118,0.052,0],"to":[0.156,-0.064,0]},{"o":{"x":0.167,"y":0.18},"i":{"x":0.833,"y":0.877},"s":[402.586,371.947,0],"t":34.4,"ti":[-0.079,0.039,0],"to":[0.118,-0.052,0]},{"o":{"x":0.167,"y":0.188},"i":{"x":0.833,"y":0.896},"s":[402.881,371.81,0],"t":35.2,"ti":[-0.041,0.026,0],"to":[0.079,-0.039,0]},{"o":{"x":0.167,"y":0.207},"i":{"x":0.833,"y":0.916},"s":[403.061,371.711,0],"t":36,"ti":[-0.01,0.014,0],"to":[0.041,-0.026,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[403.128,371.653,0],"t":36.8,"ti":[0.008,0.004,0],"to":[0.01,-0.014,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[403.122,371.629,0],"t":37.6,"ti":[0.019,-0.005,0],"to":[-0.008,-0.004,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[403.083,371.63,0],"t":38.4,"ti":[0.031,-0.013,0],"to":[-0.019,0.005,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[403.008,371.658,0],"t":39.2,"ti":[0.042,-0.022,0],"to":[-0.031,0.013,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[402.898,371.711,0],"t":40,"ti":[0.053,-0.03,0],"to":[-0.042,0.022,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[402.755,371.79,0],"t":40.8,"ti":[0.064,-0.038,0],"to":[-0.053,0.03,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[402.579,371.893,0],"t":41.6,"ti":[0.074,-0.045,0],"to":[-0.064,0.038,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[402.371,372.019,0],"t":42.4,"ti":[0.083,-0.052,0],"to":[-0.074,0.045,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[402.135,372.165,0],"t":43.2,"ti":[0.091,-0.057,0],"to":[-0.083,0.052,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[401.874,372.329,0],"t":44,"ti":[0.097,-0.062,0],"to":[-0.091,0.057,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[401.591,372.509,0],"t":44.8,"ti":[0.102,-0.065,0],"to":[-0.097,0.062,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[401.29,372.7,0],"t":45.6,"ti":[0.106,-0.067,0],"to":[-0.102,0.065,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[400.977,372.899,0],"t":46.4,"ti":[0.053,-0.034,0],"to":[-0.106,0.067,0]},{"s":[400.657,373.102,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":4.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":8.8},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":26.4},{"s":[0],"t":39.2}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[10,10],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.8353,0.749,1],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":50},{"ty":4,"nm":"Shape Layer 1","sr":1,"st":2.4,"op":48,"ip":2.4,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":1.013},"s":[94.174,88.68,100],"t":2.4},{"o":{"x":0.167,"y":0.011},"i":{"x":0.833,"y":0.854},"s":[62.657,103.74,100],"t":3.2},{"o":{"x":0.167,"y":0.195},"i":{"x":0.833,"y":1},"s":[98.913,90.256,100],"t":4},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":0.962},"s":[126.059,82.91,100],"t":4.8},{"o":{"x":0.167,"y":-0.071},"i":{"x":0.833,"y":1.12},"s":[99.016,79.175,100],"t":5.6},{"o":{"x":0.167,"y":0.049},"i":{"x":0.833,"y":0.877},"s":[113.623,121.094,100],"t":6.4},{"o":{"x":0.167,"y":0.258},"i":{"x":0.833,"y":0.808},"s":[77.907,107.132,100],"t":7.2},{"o":{"x":0.167,"y":0.147},"i":{"x":0.833,"y":1.024},"s":[60.895,73.957,100],"t":8},{"o":{"x":0.167,"y":0.019},"i":{"x":0.833,"y":1.02},"s":[38.746,40.656,100],"t":8.8},{"o":{"x":0.167,"y":0.016},"i":{"x":0.833,"y":0.997},"s":[67.397,109.363,100],"t":9.6},{"o":{"x":0.167,"y":-0.003},"i":{"x":0.833,"y":0.787},"s":[31.725,152.383,100],"t":10.4},{"o":{"x":0.167,"y":0.137},"i":{"x":0.833,"y":0.983},"s":[66.258,88.662,100],"t":11.2},{"o":{"x":0.167,"y":-0.021},"i":{"x":0.833,"y":0.996},"s":[119.803,60.228,100],"t":12},{"o":{"x":0.167,"y":-0.004},"i":{"x":0.833,"y":0.949},"s":[76.922,81.625,100],"t":12.8},{"o":{"x":0.167,"y":-0.135},"i":{"x":0.833,"y":0.975},"s":[117.696,124.097,100],"t":13.6},{"o":{"x":0.167,"y":-0.036},"i":{"x":0.833,"y":1.215},"s":[102.098,51.832,100],"t":14.4},{"o":{"x":0.167,"y":0.06},"i":{"x":0.833,"y":0.928},"s":[113.025,46.206,100],"t":15.2},{"o":{"x":0.167,"y":-0.543},"i":{"x":0.833,"y":0.706},"s":[73.843,99.907,100],"t":16},{"o":{"x":0.167,"y":0.116},"i":{"x":0.833,"y":0.753},"s":[79.054,62.467,100],"t":16.8},{"o":{"x":0.167,"y":0.126},"i":{"x":0.833,"y":1.064},"s":[92.238,50.379,100],"t":17.6},{"o":{"x":0.167,"y":0.036},"i":{"x":0.833,"y":0.883},"s":[118.149,58.916,100],"t":18.4},{"o":{"x":0.167,"y":0.287},"i":{"x":0.833,"y":1.141},"s":[72.379,101.804,100],"t":19.2},{"o":{"x":0.167,"y":0.052},"i":{"x":0.833,"y":0.893},"s":[53.668,118.311,100],"t":20},{"o":{"x":0.167,"y":0.378},"i":{"x":0.833,"y":0.925},"s":[103.965,104.335,100],"t":20.8},{"o":{"x":0.167,"y":-0.756},"i":{"x":0.833,"y":0.059},"s":[118.191,89.162,100],"t":21.6},{"o":{"x":0.167,"y":0.091},"i":{"x":0.833,"y":1.036},"s":[116.779,112.396,100],"t":22.4},{"o":{"x":0.167,"y":0.025},"i":{"x":0.833,"y":1.158},"s":[102.243,72.439,100],"t":23.2},{"o":{"x":0.167,"y":0.055},"i":{"x":0.833,"y":0.897},"s":[123.077,85.771,100],"t":24},{"o":{"x":0.167,"y":0.435},"i":{"x":0.833,"y":1.064},"s":[62.652,37.969,100],"t":24.8},{"o":{"x":0.167,"y":0.036},"i":{"x":0.833,"y":0.949},"s":[48.316,78.523,100],"t":25.6},{"o":{"x":0.167,"y":-0.131},"i":{"x":0.833,"y":0.545},"s":[73.718,102.173,100],"t":26.4},{"o":{"x":0.167,"y":0.102},"i":{"x":0.833,"y":0.979},"s":[63.843,62.973,100],"t":27.2},{"o":{"x":0.167,"y":-0.028},"i":{"x":0.833,"y":0.921},"s":[19.791,64.173,100],"t":28},{"o":{"x":0.167,"y":-1.621},"i":{"x":0.833,"y":0.758},"s":[52.853,88.034,100],"t":28.8},{"o":{"x":0.167,"y":0.127},"i":{"x":0.833,"y":1.306},"s":[51.236,50.431,100],"t":29.6},{"o":{"x":0.167,"y":0.065},"i":{"x":0.833,"y":0.889},"s":[48.161,59.44,100],"t":30.4},{"o":{"x":0.167,"y":0.334},"i":{"x":0.833,"y":1.538},"s":[62.531,61.263,100],"t":31.2},{"o":{"x":0.167,"y":0.072},"i":{"x":0.833,"y":0.759},"s":[67.316,86.954,100],"t":32},{"o":{"x":0.167,"y":0.127},"i":{"x":0.833,"y":0.954},"s":[31.655,48.638,100],"t":32.8},{"o":{"x":0.167,"y":-0.1},"i":{"x":0.833,"y":0.875},"s":[-35.843,19.827,100],"t":33.6},{"o":{"x":0.167,"y":0.249},"i":{"x":0.833,"y":1.076},"s":[-5.221,63.199,100],"t":34.4},{"o":{"x":0.167,"y":0.04},"i":{"x":0.833,"y":1.027},"s":[10.17,23.011,100],"t":35.2},{"o":{"x":0.167,"y":0.02},"i":{"x":0.833,"y":0.934},"s":[-19.321,-21.801,100],"t":36},{"o":{"x":0.167,"y":-0.321},"i":{"x":0.833,"y":1.313},"s":[19.702,-9.718,100],"t":36.8},{"o":{"x":0.167,"y":0.066},"i":{"x":0.833,"y":0.894},"s":[11.661,35.883,100],"t":37.6},{"o":{"x":0.167,"y":0.392},"i":{"x":0.833,"y":1.021},"s":[49.934,29.715,100],"t":38.4},{"o":{"x":0.167,"y":0.016},"i":{"x":0.833,"y":0.685},"s":[60.278,-1.013,100],"t":39.2},{"o":{"x":0.167,"y":0.113},"i":{"x":0.833,"y":0.849},"s":[47.382,13.308,100],"t":40},{"o":{"x":0.167,"y":0.187},"i":{"x":0.833,"y":0.934},"s":[11.559,15.87,100],"t":40.8},{"o":{"x":0.167,"y":-0.311},"i":{"x":0.833,"y":0.35},"s":[-17.364,-15.186,100],"t":41.6},{"o":{"x":0.167,"y":0.096},"i":{"x":0.833,"y":0.953},"s":[-11.255,42.917,100],"t":42.4},{"o":{"x":0.167,"y":-0.107},"i":{"x":0.833,"y":1.05},"s":[30.321,51.283,100],"t":43.2},{"o":{"x":0.167,"y":0.031},"i":{"x":0.833,"y":0.897},"s":[12.149,26.161,100],"t":44},{"o":{"x":0.167,"y":0.44},"i":{"x":0.833,"y":1.244},"s":[41.324,10.186,100],"t":44.8},{"o":{"x":0.167,"y":0.062},"i":{"x":0.833,"y":0.878},"s":[48.144,39.687,100],"t":45.6},{"o":{"x":0.167,"y":0.262},"i":{"x":0.833,"y":0.833},"s":[21.344,35.23,100],"t":46.4},{"s":[8.869,34.392,100],"t":47.2}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.166},"i":{"x":0.833,"y":0.628},"s":[273.808,259.665,0],"t":2.4,"ti":[-2.371,0.302,0],"to":[0.527,-0.068,0]},{"o":{"x":0.167,"y":0.106},"i":{"x":0.833,"y":0.769},"s":[276.968,259.259,0],"t":3.2,"ti":[-5.103,0.961,0],"to":[2.371,-0.302,0]},{"o":{"x":0.167,"y":0.127},"i":{"x":0.833,"y":0.828},"s":[288.032,257.854,0],"t":4,"ti":[-6.631,2.225,0],"to":[5.103,-0.961,0]},{"o":{"x":0.167,"y":0.145},"i":{"x":0.833,"y":0.858},"s":[307.589,253.495,0],"t":4.8,"ti":[-5.809,3.598,0],"to":[6.631,-2.225,0]},{"o":{"x":0.167,"y":0.135},"i":{"x":0.833,"y":0.884},"s":[327.818,244.501,0],"t":5.6,"ti":[-3.886,4.355,0],"to":[5.809,-3.598,0]},{"o":{"x":0.167,"y":0.099},"i":{"x":0.833,"y":0.918},"s":[342.441,231.905,0],"t":6.4,"ti":[-2.267,4.355,0],"to":[3.886,-4.355,0]},{"o":{"x":0.167,"y":0.066},"i":{"x":0.833,"y":0.944},"s":[351.136,218.373,0],"t":7.2,"ti":[-1.31,3.958,0],"to":[2.267,-4.355,0]},{"o":{"x":0.167,"y":0.046},"i":{"x":0.833,"y":0.96},"s":[356.042,205.774,0],"t":8,"ti":[-0.831,3.49,0],"to":[1.31,-3.958,0]},{"o":{"x":0.167,"y":0.037},"i":{"x":0.833,"y":0.968},"s":[358.996,194.624,0],"t":8.8,"ti":[-0.612,3.067,0],"to":[0.831,-3.49,0]},{"o":{"x":0.167,"y":0.033},"i":{"x":0.833,"y":0.971},"s":[361.029,184.836,0],"t":9.6,"ti":[-0.528,2.704,0],"to":[0.612,-3.067,0]},{"o":{"x":0.167,"y":0.035},"i":{"x":0.833,"y":0.969},"s":[362.67,176.222,0],"t":10.4,"ti":[-0.514,2.391,0],"to":[0.528,-2.704,0]},{"o":{"x":0.167,"y":0.04},"i":{"x":0.833,"y":0.964},"s":[364.195,168.613,0],"t":11.2,"ti":[-0.538,2.117,0],"to":[0.514,-2.391,0]},{"o":{"x":0.167,"y":0.047},"i":{"x":0.833,"y":0.957},"s":[365.753,161.877,0],"t":12,"ti":[-0.583,1.874,0],"to":[0.538,-2.117,0]},{"o":{"x":0.167,"y":0.058},"i":{"x":0.833,"y":0.948},"s":[367.425,155.911,0],"t":12.8,"ti":[-0.636,1.65,0],"to":[0.583,-1.874,0]},{"o":{"x":0.167,"y":0.069},"i":{"x":0.833,"y":0.938},"s":[369.252,150.634,0],"t":13.6,"ti":[-0.685,1.438,0],"to":[0.636,-1.65,0]},{"o":{"x":0.167,"y":0.082},"i":{"x":0.833,"y":0.926},"s":[371.238,146.01,0],"t":14.4,"ti":[-0.735,1.242,0],"to":[0.685,-1.438,0]},{"o":{"x":0.167,"y":0.097},"i":{"x":0.833,"y":0.912},"s":[373.362,142.007,0],"t":15.2,"ti":[-0.783,1.066,0],"to":[0.735,-1.242,0]},{"o":{"x":0.167,"y":0.11},"i":{"x":0.833,"y":0.899},"s":[375.646,138.557,0],"t":16,"ti":[-0.813,0.905,0],"to":[0.783,-1.066,0]},{"o":{"x":0.167,"y":0.123},"i":{"x":0.833,"y":0.887},"s":[378.057,135.612,0],"t":16.8,"ti":[-0.823,0.759,0],"to":[0.813,-0.905,0]},{"o":{"x":0.167,"y":0.133},"i":{"x":0.833,"y":0.878},"s":[380.527,133.13,0],"t":17.6,"ti":[-0.814,0.633,0],"to":[0.823,-0.759,0]},{"o":{"x":0.167,"y":0.142},"i":{"x":0.833,"y":0.87},"s":[382.995,131.056,0],"t":18.4,"ti":[-0.791,0.525,0],"to":[0.814,-0.633,0]},{"o":{"x":0.167,"y":0.148},"i":{"x":0.833,"y":0.864},"s":[385.412,129.334,0],"t":19.2,"ti":[-0.756,0.434,0],"to":[0.791,-0.525,0]},{"o":{"x":0.167,"y":0.154},"i":{"x":0.833,"y":0.86},"s":[387.738,127.909,0],"t":20,"ti":[-0.712,0.358,0],"to":[0.756,-0.434,0]},{"o":{"x":0.167,"y":0.158},"i":{"x":0.833,"y":0.856},"s":[389.945,126.733,0],"t":20.8,"ti":[-0.664,0.295,0],"to":[0.712,-0.358,0]},{"o":{"x":0.167,"y":0.162},"i":{"x":0.833,"y":0.853},"s":[392.013,125.763,0],"t":21.6,"ti":[-0.613,0.243,0],"to":[0.664,-0.295,0]},{"o":{"x":0.167,"y":0.164},"i":{"x":0.833,"y":0.852},"s":[393.931,124.963,0],"t":22.4,"ti":[-0.561,0.201,0],"to":[0.613,-0.243,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.85},"s":[395.694,124.303,0],"t":23.2,"ti":[-0.508,0.165,0],"to":[0.561,-0.201,0]},{"o":{"x":0.167,"y":0.169},"i":{"x":0.833,"y":0.85},"s":[397.298,123.76,0],"t":24,"ti":[-0.456,0.135,0],"to":[0.508,-0.165,0]},{"o":{"x":0.167,"y":0.171},"i":{"x":0.833,"y":0.85},"s":[398.744,123.313,0],"t":24.8,"ti":[-0.404,0.11,0],"to":[0.456,-0.135,0]},{"o":{"x":0.167,"y":0.173},"i":{"x":0.833,"y":0.85},"s":[400.032,122.948,0],"t":25.6,"ti":[-0.352,0.089,0],"to":[0.404,-0.11,0]},{"o":{"x":0.167,"y":0.175},"i":{"x":0.833,"y":0.85},"s":[401.165,122.652,0],"t":26.4,"ti":[-0.302,0.071,0],"to":[0.352,-0.089,0]},{"o":{"x":0.167,"y":0.178},"i":{"x":0.833,"y":0.852},"s":[402.144,122.415,0],"t":27.2,"ti":[-0.253,0.055,0],"to":[0.302,-0.071,0]},{"o":{"x":0.167,"y":0.18},"i":{"x":0.833,"y":0.853},"s":[402.975,122.228,0],"t":28,"ti":[-0.207,0.041,0],"to":[0.253,-0.055,0]},{"o":{"x":0.167,"y":0.185},"i":{"x":0.833,"y":0.856},"s":[403.664,122.085,0],"t":28.8,"ti":[-0.163,0.029,0],"to":[0.207,-0.041,0]},{"o":{"x":0.167,"y":0.19},"i":{"x":0.833,"y":0.861},"s":[404.217,121.981,0],"t":29.6,"ti":[-0.119,0.018,0],"to":[0.163,-0.029,0]},{"o":{"x":0.167,"y":0.201},"i":{"x":0.833,"y":0.869},"s":[404.639,121.911,0],"t":30.4,"ti":[-0.078,0.008,0],"to":[0.119,-0.018,0]},{"o":{"x":0.167,"y":0.225},"i":{"x":0.833,"y":0.887},"s":[404.934,121.872,0],"t":31.2,"ti":[-0.038,-0.001,0],"to":[0.078,-0.008,0]},{"o":{"x":0.167,"y":0.286},"i":{"x":0.833,"y":0.838},"s":[405.107,121.862,0],"t":32,"ti":[0,-0.01,0],"to":[0.038,0.001,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[405.163,121.879,0],"t":32.8,"ti":[0.036,-0.018,0],"to":[0,0.01,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[405.107,121.921,0],"t":33.6,"ti":[0.064,-0.025,0],"to":[-0.036,0.018,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[404.945,121.988,0],"t":34.4,"ti":[0.075,-0.028,0],"to":[-0.064,0.025,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[404.725,122.069,0],"t":35.2,"ti":[0.078,-0.03,0],"to":[-0.075,0.028,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[404.495,122.157,0],"t":36,"ti":[0.079,-0.032,0],"to":[-0.078,0.03,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[404.258,122.252,0],"t":36.8,"ti":[0.08,-0.034,0],"to":[-0.079,0.032,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[404.019,122.352,0],"t":37.6,"ti":[0.078,-0.036,0],"to":[-0.08,0.034,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[403.781,122.458,0],"t":38.4,"ti":[0.065,-0.038,0],"to":[-0.078,0.036,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[403.552,122.57,0],"t":39.2,"ti":[0.039,-0.038,0],"to":[-0.065,0.038,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[403.392,122.685,0],"t":40,"ti":[0.013,-0.038,0],"to":[-0.039,0.038,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[403.315,122.8,0],"t":40.8,"ti":[-0.011,-0.037,0],"to":[-0.013,0.038,0]},{"o":{"x":0.167,"y":0.08},"i":{"x":0.833,"y":0.903},"s":[403.314,122.914,0],"t":41.6,"ti":[-0.033,-0.036,0],"to":[0.011,0.037,0]},{"o":{"x":0.167,"y":0.114},"i":{"x":0.833,"y":0.856},"s":[403.381,123.025,0],"t":42.4,"ti":[-0.052,-0.035,0],"to":[0.033,0.036,0]},{"o":{"x":0.167,"y":0.131},"i":{"x":0.833,"y":0.84},"s":[403.509,123.131,0],"t":43.2,"ti":[-0.069,-0.033,0],"to":[0.052,0.035,0]},{"o":{"x":0.167,"y":0.141},"i":{"x":0.833,"y":0.835},"s":[403.692,123.233,0],"t":44,"ti":[-0.084,-0.031,0],"to":[0.069,0.033,0]},{"o":{"x":0.167,"y":0.148},"i":{"x":0.833,"y":0.833},"s":[403.923,123.328,0],"t":44.8,"ti":[-0.096,-0.028,0],"to":[0.084,0.031,0]},{"o":{"x":0.167,"y":0.154},"i":{"x":0.833,"y":0.833},"s":[404.195,123.417,0],"t":45.6,"ti":[-0.107,-0.025,0],"to":[0.096,0.028,0]},{"o":{"x":0.167,"y":0.156},"i":{"x":0.833,"y":0.837},"s":[404.501,123.497,0],"t":46.4,"ti":[-0.056,-0.012,0],"to":[0.107,0.025,0]},{"s":[404.836,123.569,0],"t":47.2}],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":2.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":6.4},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":24},{"s":[0],"t":36.8}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[10,10],"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.8353,0.749,1],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":51}]}]}');

});

parcelRegister("gOhJS", function(module, exports) {

$parcel$export(module.exports, "CheckmarkIcon", () => $2e05530de893a5d9$export$906a919e30cdbd5c);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");
var $2e05530de893a5d9$var$CheckIcon = function CheckIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.064 5.318c.449.449.449 1.177 0 1.626L9.325 18.683a1.15 1.15 0 0 1-1.626 0L2.936 13.92a1.15 1.15 0 0 1 1.627-1.627l3.95 3.95L19.437 5.318a1.15 1.15 0 0 1 1.626 0Z",
            fill: "currentColor"
        })
    });
};
$2e05530de893a5d9$var$CheckIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $2e05530de893a5d9$var$checkmarksizes = {
    S: {
        circle: "1.5rem",
        check: 15
    },
    M: {
        circle: "2.5rem",
        check: 24
    },
    L: {
        circle: "4.5rem",
        check: 45
    }
};
const $2e05530de893a5d9$export$906a919e30cdbd5c = ({ size: size = "S", colors: colors = {
    circle: (0, $kKnoQ.colors).validation,
    check: (0, $kKnoQ.colors).white
}, className: className })=>{
    const { circle: circle, check: check } = (0, $81g6h.useMemo)(()=>$2e05530de893a5d9$var$checkmarksizes[size], [
        size
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($2e05530de893a5d9$var$Circle, {
        size: circle,
        backgroundColor: colors.circle,
        className: className,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($2e05530de893a5d9$var$CheckIcon, {
            width: check,
            height: check,
            color: colors.check
        })
    });
};
const $2e05530de893a5d9$var$Circle = (0, $5UMQ1.default).div`
	display: grid;
	place-items: center;
	width: ${({ size: size })=>size};
	height: ${({ size: size })=>size};
	border-radius: 50%;
	${({ backgroundColor: backgroundColor })=>backgroundColor && `background-color: ${backgroundColor};`}
`;

});


parcelRegister("397Q6", function(module, exports) {

$parcel$export(module.exports, "ExerciseFiltersDialog", () => $acba704437f194e8$export$deeecdaf038eb290);

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5WGN2 = parcelRequire("5WGN2");

var $gk3fY = parcelRequire("gk3fY");

var $3iKWb = parcelRequire("3iKWb");
const $acba704437f194e8$export$deeecdaf038eb290 = (props)=>/*#__PURE__*/ (0, $iKObn.jsx)($acba704437f194e8$var$StyledBaseDialog, {
        ...props,
        tabletSameAsMobile: true,
        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $3iKWb.FilterListingPanel), {})
    });
const $acba704437f194e8$var$StyledBaseDialog = (0, $5UMQ1.default)((0, $gk3fY.BaseDialog))`
	& .p-dialog-header {
		${(0, $5WGN2.row)()};
		padding-right: 5px;
		padding-bottom: 5px;
	}

	& .p-dialog-header:after {
		display: none;
	}

	& .p-dialog-content {
		padding-top: 0;
	}
`;

});
parcelRegister("3iKWb", function(module, exports) {

$parcel$export(module.exports, "FilterListingPanel", () => $5f5b8f55caffb43e$export$585486148169e876);

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5WGN2 = parcelRequire("5WGN2");

var $5kXMA = parcelRequire("5kXMA");

var $5uxyt = parcelRequire("5uxyt");

var $3whlY = parcelRequire("3whlY");

var $8qnYi = parcelRequire("8qnYi");

var $iqdZk = parcelRequire("iqdZk");

var $hFruA = parcelRequire("hFruA");

var $auPqo = parcelRequire("auPqo");
const $5f5b8f55caffb43e$export$585486148169e876 = ({ className: className })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const { activeFiltersMap: activeFiltersMap, clearAllActiveFilters: clearAllActiveFilters, updateActiveFilters: updateActiveFilters } = (0, $3whlY.useExercisePage)();
    const filters = (0, $8qnYi.useExerciseFilters)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($5f5b8f55caffb43e$var$FilterPanelContainer, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($5f5b8f55caffb43e$var$TagListContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($5f5b8f55caffb43e$var$Header, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                className: "p-size-l-bold",
                                children: format("exerciseFilterListingPanel.title")
                            }),
                            activeFiltersMap.size > 0 && /*#__PURE__*/ (0, $iKObn.jsx)((0, $5uxyt.ClickableText), {
                                onClick: clearAllActiveFilters,
                                children: format("exerciseFilterListingPanel.clear")
                            })
                        ]
                    }),
                    isDesktop && /*#__PURE__*/ (0, $iKObn.jsx)((0, $hFruA.ActiveFilterListing), {})
                ]
            }),
            filters.map((category)=>/*#__PURE__*/ (0, $iKObn.jsxs)($5f5b8f55caffb43e$var$CategoryContainer, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                            className: "p-size-m-bold",
                            children: category.label
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)($5f5b8f55caffb43e$var$FilterItemListContainer, {
                            children: category.filters.map((filter)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $iqdZk.FilterItem), {
                                    filter: filter,
                                    status: activeFiltersMap.get(category.id)?.filters.get(filter.id) ? (0, $iqdZk.FilterItemStatus).Active : (0, $iqdZk.FilterItemStatus).Inactive,
                                    onChange: async (isActive)=>{
                                        updateActiveFilters(category, filter, isActive);
                                        await (0, $ghfIB.getStartedManager).tryMarkExercisesStepAsCompleted();
                                        isActive && (0, $ghfIB.analyticsService).trackEvent({
                                            category: (0, $auPqo.AnalyticsCategory).EXERCISE,
                                            action: "filterLibrary",
                                            params: [
                                                `${category.id}/${filter.id.toLowerCase()}`
                                            ]
                                        });
                                    }
                                }, filter.id))
                        })
                    ]
                }, category.id))
        ]
    });
};
const $5f5b8f55caffb43e$var$FilterPanelContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(16, undefined, "stretch")}
`;
const $5f5b8f55caffb43e$var$TagListContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("XS", undefined, "stretch")}
`;
const $5f5b8f55caffb43e$var$Header = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")}
`;
const $5f5b8f55caffb43e$var$CategoryContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("XS")}
`;
const $5f5b8f55caffb43e$var$FilterItemListContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("XS")}
	flex-wrap: wrap;
`;

});
parcelRegister("3whlY", function(module, exports) {

$parcel$export(module.exports, "useExercisePage", () => $fa42a625417965a1$export$ca59750cb248f30b);

var $kp7gC = parcelRequire("kp7gC");

var $ghfIB = parcelRequire("ghfIB");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");

var $grmoS = parcelRequire("grmoS");

var $243Cr = parcelRequire("243Cr");

var $lKGAO = parcelRequire("lKGAO");

var $bFakw = parcelRequire("bFakw");

var $8qnYi = parcelRequire("8qnYi");

var $ivrAm = parcelRequire("ivrAm");
const $fa42a625417965a1$var$EQUIPMENT_FILTER_ID = "equipment";
const $fa42a625417965a1$export$ca59750cb248f30b = ()=>{
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const trackingContext = (0, $81g6h.useContext)((0, $lKGAO.TrackingContext));
    const search = (0, $1IWnK.useObservable)((0, $ghfIB.exerciseFilterManager).searchWord);
    const filteredExercises = (0, $1IWnK.useObservable)((0, $ghfIB.exerciseFilterManager).filteredExercises);
    const selectedExercises = (0, $1IWnK.useObservable)((0, $ghfIB.exerciseFilterManager).selectedExercises);
    const activeFilters = (0, $1IWnK.useObservable)((0, $ghfIB.exerciseFilterManager).activeFilters);
    const filters = (0, $8qnYi.useExerciseFilters)();
    (0, $81g6h.useEffect)(()=>{
        if ((0, $ghfIB.exerciseManager).exercisesStatus.get() === (0, $ivrAm.ExerciseFetchState).Undefined) (0, $ghfIB.exerciseManager).fetchExercises();
    }, []);
    const activeFiltersMap = (0, $81g6h.useMemo)(()=>(0, $kp7gC.OrderedMap)(activeFilters.map((category)=>[
                category.id,
                {
                    ...category,
                    filters: (0, $kp7gC.OrderedMap)(category.filters.map((filter)=>[
                            filter.id,
                            filter
                        ]))
                }
            ])), [
        activeFilters
    ]);
    const [refreshExercisesAsync, isLoading, isError] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(async ()=>{
        (0, $ghfIB.exerciseFilterManager).clearAllSelectedExercises();
        (0, $ghfIB.exerciseFilterManager).clearAllFiltersAndSearch();
        await (0, $ghfIB.exerciseFilterManager).fetchExercises();
        (0, $ghfIB.exerciseFilterManager).filterExercises();
    }, []), {
        initialLoadingState: true
    });
    const openExerciseDetailsModal = (0, $81g6h.useCallback)((exercise, relatedExercises)=>{
        dialogContext?.openModal((0, $243Cr.ModalId).ExerciseDetails, {
            relatedExercises: relatedExercises,
            exerciseIndex: relatedExercises.findIndex((ex)=>ex === exercise),
            tabHeaderDisabled: true,
            trackingContext: trackingContext,
            editorName: ""
        });
        (0, $bFakw.sendAnalyticsEventViewExerciseDetail)(exercise, (0, $bFakw.AnalyticsViewExerciseDetailOrigin).EXERCISE);
    }, [
        dialogContext,
        trackingContext
    ]);
    const openFilteredExerciseDetailsModal = (0, $81g6h.useCallback)((exercise)=>{
        openExerciseDetailsModal(exercise, filteredExercises);
    }, [
        filteredExercises,
        openExerciseDetailsModal
    ]);
    const openSelectedExerciseDetailsModal = (0, $81g6h.useCallback)((exercise)=>{
        openExerciseDetailsModal(exercise, selectedExercises);
    }, [
        openExerciseDetailsModal,
        selectedExercises
    ]);
    const clearAllActiveFilters = (0, $81g6h.useCallback)(()=>{
        (0, $ghfIB.exerciseFilterManager).activeFilters.set([]);
    }, []);
    const selectedEquipment = (0, $81g6h.useMemo)(()=>{
        const equipmentCategory = activeFilters.find((cat)=>cat.id === $fa42a625417965a1$var$EQUIPMENT_FILTER_ID);
        return equipmentCategory ? equipmentCategory.filters.map((f)=>f.id) : [];
    }, [
        activeFilters
    ]);
    const updateActiveFilters = (0, $81g6h.useCallback)((category, filter, isActive)=>{
        const categoryFilters = activeFiltersMap.get(category.id)?.filters ?? (0, $kp7gC.OrderedMap)();
        const newMap = activeFiltersMap.set(category.id, {
            ...category,
            filters: isActive ? categoryFilters.set(filter.id, filter) : categoryFilters.remove(filter.id)
        });
        (0, $ghfIB.exerciseFilterManager).activeFilters.set($fa42a625417965a1$var$internalFilterMapToArray(newMap, filters, isActive));
    }, [
        activeFiltersMap,
        filters
    ]);
    const filteredExercisesWithEquipment = (0, $81g6h.useMemo)(()=>{
        if (selectedEquipment.length === 0 && activeFilters.find((cat)=>cat.id === $fa42a625417965a1$var$EQUIPMENT_FILTER_ID)) return [];
        return filteredExercises;
    }, [
        filteredExercises,
        selectedEquipment,
        activeFilters
    ]);
    return {
        // allExercises,
        // exerciseTotalCount,
        filteredExercises: filteredExercisesWithEquipment,
        selectedExercises: selectedExercises,
        activeFiltersMap: activeFiltersMap,
        search: search,
        isLoading: isLoading,
        isError: isError,
        refreshExercises: ()=>{
            refreshExercisesAsync();
        },
        openFilteredExerciseDetailsModal: openFilteredExerciseDetailsModal,
        openSelectedExerciseDetailsModal: openSelectedExerciseDetailsModal,
        clearAllActiveFilters: clearAllActiveFilters,
        updateActiveFilters: updateActiveFilters,
        activeFilters: activeFilters
    };
};
const $fa42a625417965a1$var$internalFilterMapToArray = (map, allFilters, shouldSort)=>shouldSort ? allFilters.reduce((categories, category)=>{
        const mapCategory = map.get(category.id);
        return mapCategory?.filters.size ? [
            ...categories,
            {
                ...mapCategory,
                filters: category.filters.reduce((filters, filter)=>{
                    const mapFilter = mapCategory.filters.get(filter.id);
                    return mapFilter ? [
                        ...filters,
                        mapFilter
                    ] : filters;
                }, [])
            }
        ] : categories;
    }, []) : Array.from(map.values()).reduce((categories, category)=>{
        const filtersArray = Array.from(category.filters.values());
        return filtersArray.length === 0 ? categories : [
            ...categories,
            {
                ...category,
                filters: filtersArray
            }
        ];
    }, []);

});

parcelRegister("hFruA", function(module, exports) {

$parcel$export(module.exports, "ActiveFilterListing", () => $13954ec9e5ac359d$export$3348715b6019512a);

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $1IWnK = parcelRequire("1IWnK");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5WGN2 = parcelRequire("5WGN2");

var $5kXMA = parcelRequire("5kXMA");

var $3whlY = parcelRequire("3whlY");

var $ghfIB = parcelRequire("ghfIB");

var $5uxyt = parcelRequire("5uxyt");

var $iqdZk = parcelRequire("iqdZk");
const $13954ec9e5ac359d$export$3348715b6019512a = ({ className: className })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const activeFilters = (0, $1IWnK.useObservable)((0, $ghfIB.exerciseFilterManager).activeFilters);
    const { clearAllActiveFilters: clearAllActiveFilters, updateActiveFilters: updateActiveFilters } = (0, $3whlY.useExercisePage)();
    return activeFilters.length > 0 && /*#__PURE__*/ (0, $iKObn.jsxs)($13954ec9e5ac359d$var$Container, {
        className: className,
        children: [
            activeFilters.map((category)=>category.filters.map((filter)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $iqdZk.FilterItem), {
                        filter: filter,
                        status: (0, $iqdZk.FilterItemStatus).Tag,
                        onChange: ()=>updateActiveFilters(category, filter, false)
                    }, filter.id))),
            !isDesktop && /*#__PURE__*/ (0, $iKObn.jsx)((0, $5uxyt.ClickableText), {
                onClick: clearAllActiveFilters,
                children: format("exerciseFilterListingPanel.clear")
            })
        ]
    });
};
const $13954ec9e5ac359d$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("XS", "flexstart", "center")};
	flex-wrap: wrap;
`;

});



parcelRegister("iIujE", function(module, exports) {

$parcel$export(module.exports, "EditUserLocaleDialog", () => $abb74d2505599432$export$386a2bc8ce6a63a5);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dU78w = parcelRequire("dU78w");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $1eHG3 = parcelRequire("1eHG3");

var $grmoS = parcelRequire("grmoS");

var $gk3fY = parcelRequire("gk3fY");

var $dhb7H = parcelRequire("dhb7H");

var $kY2I3 = parcelRequire("kY2I3");

var $ghfIB = parcelRequire("ghfIB");

var $9XVwj = parcelRequire("9XVwj");
function $abb74d2505599432$export$386a2bc8ce6a63a5({ currentLocale: currentLocale, currentCountry: currentCountry, userSupportedLocales: userSupportedLocales, onHide: onHide, ...otherProps }) {
    const { format: format, locale: currentI18nLocale } = (0, $1eHG3.useI18n)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const { control: control, handleSubmit: handleSubmit, watch: watch } = (0, $eKUeg.useForm)({
        defaultValues: {
            newLocale: currentLocale
        }
    });
    const newLocale = watch("newLocale");
    const [hasShownToast, setHasShownToast] = (0, $81g6h.useState)(false);
    (0, $81g6h.useEffect)(()=>{
        if (currentI18nLocale === newLocale && newLocale !== currentLocale && !hasShownToast) {
            showToast("", format("settings.accountTab.editLanguageDialog.successToast.detail"), "success");
            setHasShownToast(true);
        }
    }, [
        currentI18nLocale,
        newLocale,
        currentLocale,
        format,
        showToast,
        hasShownToast
    ]);
    const [submitNewLocale, isLoading] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(async ({ newLocale: locale })=>{
        try {
            await (0, $ghfIB.userManager).updateUser({
                locale: locale
            });
            onHide();
        } catch (error) {
            console.error("Failed to update locale", error);
            throw error;
        }
    }, [
        onHide
    ]), {});
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $gk3fY.BaseDialog), {
        closeOnEscape: false,
        header: format("settings.accountTab.editLanguageDialog.header"),
        footer: /*#__PURE__*/ (0, $iKObn.jsx)($abb74d2505599432$var$ButtonContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                loading: isLoading,
                type: "submit",
                label: format("global.dialog.save"),
                onClick: handleSubmit(submitNewLocale)
            })
        }),
        width: (0, $gk3fY.DIALOG_SIZE).S,
        onHide: onHide,
        ...otherProps,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($abb74d2505599432$var$Form, {
            onSubmit: handleSubmit(submitNewLocale),
            children: /*#__PURE__*/ (0, $iKObn.jsx)($abb74d2505599432$var$ControllersContainer, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                    name: "newLocale",
                    control: control,
                    render: ({ field: field })=>/*#__PURE__*/ (0, $iKObn.jsx)($abb74d2505599432$var$StyledCountryLanguageInput, {
                            id: "edit-user-locale-dialog",
                            locales: new Map([
                                [
                                    currentCountry,
                                    userSupportedLocales
                                ]
                            ]),
                            placeholder: format("global.form.dropdown.placeholder"),
                            emptyMessage: format("register.countrySelection.countryDropdown.emptyMessage"),
                            ...field
                        })
                })
            })
        })
    });
}
const $abb74d2505599432$var$Form = (0, $5UMQ1.default)((0, $dU78w.motion).form)`
    ${(0, $5WGN2.stack)("M", "spacebetween", "stretch")};
    height: 100%;
`;
const $abb74d2505599432$var$ControllersContainer = (0, $5UMQ1.default).div`
    ${(0, $5WGN2.stack)("M", "flexstart", "stretch")};
`;
const $abb74d2505599432$var$ButtonContainer = (0, $5UMQ1.default).div`
    ${(0, $5WGN2.row)(24, "flexend")};
`;
const $abb74d2505599432$var$StyledCountryLanguageInput = (0, $5UMQ1.default)((0, $kY2I3.CountryLanguageInput))`
    margin-top: 8px;
`;

});
parcelRegister("kY2I3", function(module, exports) {

$parcel$export(module.exports, "CountryLanguageInput", () => $b8b5b80b13e11967$export$cbe3f6fb09feb2c0);

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $bXTqq = parcelRequire("bXTqq");

var $5UMQ1 = parcelRequire("5UMQ1");

var $2XcA7 = parcelRequire("2XcA7");

var $lTdpc = parcelRequire("lTdpc");

var $aZEA4 = parcelRequire("aZEA4");

var $eT9rN = parcelRequire("eT9rN");

var $9IUdZ = parcelRequire("9IUdZ");
const $b8b5b80b13e11967$export$cbe3f6fb09feb2c0 = ({ error: error = false, locales: locales, forceLongName: forceLongName = false, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const countrylanguageOptions = (0, $9IUdZ.useCountryLanguageOptions)(locales, forceLongName, $b8b5b80b13e11967$export$fa513dd82f0cb8f9);
    const options = (0, $81g6h.useMemo)(()=>Array.from(countrylanguageOptions.keys()), [
        countrylanguageOptions
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $eT9rN.Dropdown), {
        ...otherProps,
        className: error ? "p-invalid" : undefined,
        options: options,
        emptyMessage: format("register.countrySelection.countryDropdown.emptyMessage"),
        valueTemplate: (locale)=>$b8b5b80b13e11967$var$CountryLanguageOptionTemplate(locale, countrylanguageOptions),
        itemTemplate: (locale)=>$b8b5b80b13e11967$var$CountryLanguageOptionTemplate(locale, countrylanguageOptions)
    });
};
const $b8b5b80b13e11967$export$fa513dd82f0cb8f9 = (countryCode)=>(0, $aZEA4.countries)[countryCode.toUpperCase()].native;
const $b8b5b80b13e11967$var$CountryLanguageOptionTemplate = (locale, options)=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    if ((0, $lTdpc.isNotNil)(locale)) {
        const countryCode = (0, $bXTqq.getLowercaseCountryCodeFromIntlLocale)(locale);
        return /*#__PURE__*/ (0, $iKObn.jsx)($b8b5b80b13e11967$var$DropdownItemContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($b8b5b80b13e11967$var$StyledCountryFlag, {
                        code: countryCode.toUpperCase()
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        children: options.get(locale)
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $iKObn.jsx)($b8b5b80b13e11967$var$DropdownItemContainer, {
        children: /*#__PURE__*/ (0, $iKObn.jsx)("p", {
            children: format("global.form.dropdown.placeholder")
        })
    });
};
const $b8b5b80b13e11967$var$DropdownItemContainer = (0, $5UMQ1.default).div`
	display: flex;
	place-items: center;
	gap: 0.75em;
`;
const $b8b5b80b13e11967$var$StyledCountryFlag = (0, $5UMQ1.default)((0, $2XcA7.CountryFlag))`
	height: 1em;
	width: 1.5em;
	border-radius: 2px;
`;

});
parcelRegister("2XcA7", function(module, exports) {

$parcel$export(module.exports, "CountryFlag", () => $4e2aa29556eea9b0$export$780a8cb2c23ae04b);

var $iKObn = parcelRequire("iKObn");

var $lTdpc = parcelRequire("lTdpc");

var $fOtxy = parcelRequire("fOtxy");
parcelRequire("81g6h");
var $4e2aa29556eea9b0$var$MissingCountryFlag = function MissingCountryFlag(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M0 0h513v342H0z"
        })
    });
};
$4e2aa29556eea9b0$var$MissingCountryFlag.defaultProps = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
};
const $4e2aa29556eea9b0$export$780a8cb2c23ae04b = ({ code: code, ...otherProps })=>{
    const Icon = (0, $lTdpc.isNotNil)(code) && code in (0, $fOtxy.default) ? (0, $fOtxy.default)[code] : $4e2aa29556eea9b0$var$MissingCountryFlag;
    return /*#__PURE__*/ (0, $iKObn.jsx)(Icon, {
        ...otherProps
    });
};

});
parcelRegister("fOtxy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b832709c107c9253$export$2e2bcd8739ae039);

var $81g6h = parcelRequire("81g6h");
var $b832709c107c9253$var$_excluded = [
    "title"
], $b832709c107c9253$var$_excluded2 = [
    "title"
], $b832709c107c9253$var$_excluded3 = [
    "title"
], $b832709c107c9253$var$_excluded4 = [
    "title"
], $b832709c107c9253$var$_excluded5 = [
    "title"
], $b832709c107c9253$var$_excluded6 = [
    "title"
], $b832709c107c9253$var$_excluded7 = [
    "title"
], $b832709c107c9253$var$_excluded8 = [
    "title"
], $b832709c107c9253$var$_excluded9 = [
    "title"
], $b832709c107c9253$var$_excluded10 = [
    "title"
], $b832709c107c9253$var$_excluded11 = [
    "title"
], $b832709c107c9253$var$_excluded12 = [
    "title"
], $b832709c107c9253$var$_excluded13 = [
    "title"
], $b832709c107c9253$var$_excluded14 = [
    "title"
], $b832709c107c9253$var$_excluded15 = [
    "title"
], $b832709c107c9253$var$_excluded16 = [
    "title"
], $b832709c107c9253$var$_excluded17 = [
    "title"
], $b832709c107c9253$var$_excluded18 = [
    "title"
], $b832709c107c9253$var$_excluded19 = [
    "title"
], $b832709c107c9253$var$_excluded20 = [
    "title"
], $b832709c107c9253$var$_excluded21 = [
    "title"
], $b832709c107c9253$var$_excluded22 = [
    "title"
], $b832709c107c9253$var$_excluded23 = [
    "title"
], $b832709c107c9253$var$_excluded24 = [
    "title"
], $b832709c107c9253$var$_excluded25 = [
    "title"
], $b832709c107c9253$var$_excluded26 = [
    "title"
], $b832709c107c9253$var$_excluded27 = [
    "title"
], $b832709c107c9253$var$_excluded28 = [
    "title"
], $b832709c107c9253$var$_excluded29 = [
    "title"
], $b832709c107c9253$var$_excluded30 = [
    "title"
], $b832709c107c9253$var$_excluded31 = [
    "title"
], $b832709c107c9253$var$_excluded32 = [
    "title"
], $b832709c107c9253$var$_excluded33 = [
    "title"
], $b832709c107c9253$var$_excluded34 = [
    "title"
], $b832709c107c9253$var$_excluded35 = [
    "title"
], $b832709c107c9253$var$_excluded36 = [
    "title"
], $b832709c107c9253$var$_excluded37 = [
    "title"
], $b832709c107c9253$var$_excluded38 = [
    "title"
], $b832709c107c9253$var$_excluded39 = [
    "title"
], $b832709c107c9253$var$_excluded40 = [
    "title"
], $b832709c107c9253$var$_excluded41 = [
    "title"
], $b832709c107c9253$var$_excluded42 = [
    "title"
], $b832709c107c9253$var$_excluded43 = [
    "title"
], $b832709c107c9253$var$_excluded44 = [
    "title"
], $b832709c107c9253$var$_excluded45 = [
    "title"
], $b832709c107c9253$var$_excluded46 = [
    "title"
], $b832709c107c9253$var$_excluded47 = [
    "title"
], $b832709c107c9253$var$_excluded48 = [
    "title"
], $b832709c107c9253$var$_excluded49 = [
    "title"
], $b832709c107c9253$var$_excluded50 = [
    "title"
], $b832709c107c9253$var$_excluded51 = [
    "title"
], $b832709c107c9253$var$_excluded52 = [
    "title"
], $b832709c107c9253$var$_excluded53 = [
    "title"
], $b832709c107c9253$var$_excluded54 = [
    "title"
], $b832709c107c9253$var$_excluded55 = [
    "title"
], $b832709c107c9253$var$_excluded56 = [
    "title"
], $b832709c107c9253$var$_excluded57 = [
    "title"
], $b832709c107c9253$var$_excluded58 = [
    "title"
], $b832709c107c9253$var$_excluded59 = [
    "title"
], $b832709c107c9253$var$_excluded60 = [
    "title"
], $b832709c107c9253$var$_excluded61 = [
    "title"
], $b832709c107c9253$var$_excluded62 = [
    "title"
], $b832709c107c9253$var$_excluded63 = [
    "title"
], $b832709c107c9253$var$_excluded64 = [
    "title"
], $b832709c107c9253$var$_excluded65 = [
    "title"
], $b832709c107c9253$var$_excluded66 = [
    "title"
], $b832709c107c9253$var$_excluded67 = [
    "title"
], $b832709c107c9253$var$_excluded68 = [
    "title"
], $b832709c107c9253$var$_excluded69 = [
    "title"
], $b832709c107c9253$var$_excluded70 = [
    "title"
], $b832709c107c9253$var$_excluded71 = [
    "title"
], $b832709c107c9253$var$_excluded72 = [
    "title"
], $b832709c107c9253$var$_excluded73 = [
    "title"
], $b832709c107c9253$var$_excluded74 = [
    "title"
], $b832709c107c9253$var$_excluded75 = [
    "title"
], $b832709c107c9253$var$_excluded76 = [
    "title"
], $b832709c107c9253$var$_excluded77 = [
    "title"
], $b832709c107c9253$var$_excluded78 = [
    "title"
], $b832709c107c9253$var$_excluded79 = [
    "title"
], $b832709c107c9253$var$_excluded80 = [
    "title"
], $b832709c107c9253$var$_excluded81 = [
    "title"
], $b832709c107c9253$var$_excluded82 = [
    "title"
], $b832709c107c9253$var$_excluded83 = [
    "title"
], $b832709c107c9253$var$_excluded84 = [
    "title"
], $b832709c107c9253$var$_excluded85 = [
    "title"
], $b832709c107c9253$var$_excluded86 = [
    "title"
], $b832709c107c9253$var$_excluded87 = [
    "title"
], $b832709c107c9253$var$_excluded88 = [
    "title"
], $b832709c107c9253$var$_excluded89 = [
    "title"
], $b832709c107c9253$var$_excluded90 = [
    "title"
], $b832709c107c9253$var$_excluded91 = [
    "title"
], $b832709c107c9253$var$_excluded92 = [
    "title"
], $b832709c107c9253$var$_excluded93 = [
    "title"
], $b832709c107c9253$var$_excluded94 = [
    "title"
], $b832709c107c9253$var$_excluded95 = [
    "title"
], $b832709c107c9253$var$_excluded96 = [
    "title"
], $b832709c107c9253$var$_excluded97 = [
    "title"
], $b832709c107c9253$var$_excluded98 = [
    "title"
], $b832709c107c9253$var$_excluded99 = [
    "title"
], $b832709c107c9253$var$_excluded100 = [
    "title"
], $b832709c107c9253$var$_excluded101 = [
    "title"
], $b832709c107c9253$var$_excluded102 = [
    "title"
], $b832709c107c9253$var$_excluded103 = [
    "title"
], $b832709c107c9253$var$_excluded104 = [
    "title"
], $b832709c107c9253$var$_excluded105 = [
    "title"
], $b832709c107c9253$var$_excluded106 = [
    "title"
], $b832709c107c9253$var$_excluded107 = [
    "title"
], $b832709c107c9253$var$_excluded108 = [
    "title"
], $b832709c107c9253$var$_excluded109 = [
    "title"
], $b832709c107c9253$var$_excluded110 = [
    "title"
], $b832709c107c9253$var$_excluded111 = [
    "title"
], $b832709c107c9253$var$_excluded112 = [
    "title"
], $b832709c107c9253$var$_excluded113 = [
    "title"
], $b832709c107c9253$var$_excluded114 = [
    "title"
], $b832709c107c9253$var$_excluded115 = [
    "title"
], $b832709c107c9253$var$_excluded116 = [
    "title"
], $b832709c107c9253$var$_excluded117 = [
    "title"
], $b832709c107c9253$var$_excluded118 = [
    "title"
], $b832709c107c9253$var$_excluded119 = [
    "title"
], $b832709c107c9253$var$_excluded120 = [
    "title"
], $b832709c107c9253$var$_excluded121 = [
    "title"
], $b832709c107c9253$var$_excluded122 = [
    "title"
], $b832709c107c9253$var$_excluded123 = [
    "title"
], $b832709c107c9253$var$_excluded124 = [
    "title"
], $b832709c107c9253$var$_excluded125 = [
    "title"
], $b832709c107c9253$var$_excluded126 = [
    "title"
], $b832709c107c9253$var$_excluded127 = [
    "title"
], $b832709c107c9253$var$_excluded128 = [
    "title"
], $b832709c107c9253$var$_excluded129 = [
    "title"
], $b832709c107c9253$var$_excluded130 = [
    "title"
], $b832709c107c9253$var$_excluded131 = [
    "title"
], $b832709c107c9253$var$_excluded132 = [
    "title"
], $b832709c107c9253$var$_excluded133 = [
    "title"
], $b832709c107c9253$var$_excluded134 = [
    "title"
], $b832709c107c9253$var$_excluded135 = [
    "title"
], $b832709c107c9253$var$_excluded136 = [
    "title"
], $b832709c107c9253$var$_excluded137 = [
    "title"
], $b832709c107c9253$var$_excluded138 = [
    "title"
], $b832709c107c9253$var$_excluded139 = [
    "title"
], $b832709c107c9253$var$_excluded140 = [
    "title"
], $b832709c107c9253$var$_excluded141 = [
    "title"
], $b832709c107c9253$var$_excluded142 = [
    "title"
], $b832709c107c9253$var$_excluded143 = [
    "title"
], $b832709c107c9253$var$_excluded144 = [
    "title"
], $b832709c107c9253$var$_excluded145 = [
    "title"
], $b832709c107c9253$var$_excluded146 = [
    "title"
], $b832709c107c9253$var$_excluded147 = [
    "title"
], $b832709c107c9253$var$_excluded148 = [
    "title"
], $b832709c107c9253$var$_excluded149 = [
    "title"
], $b832709c107c9253$var$_excluded150 = [
    "title"
], $b832709c107c9253$var$_excluded151 = [
    "title"
], $b832709c107c9253$var$_excluded152 = [
    "title"
], $b832709c107c9253$var$_excluded153 = [
    "title"
], $b832709c107c9253$var$_excluded154 = [
    "title"
], $b832709c107c9253$var$_excluded155 = [
    "title"
], $b832709c107c9253$var$_excluded156 = [
    "title"
], $b832709c107c9253$var$_excluded157 = [
    "title"
], $b832709c107c9253$var$_excluded158 = [
    "title"
], $b832709c107c9253$var$_excluded159 = [
    "title"
], $b832709c107c9253$var$_excluded160 = [
    "title"
], $b832709c107c9253$var$_excluded161 = [
    "title"
], $b832709c107c9253$var$_excluded162 = [
    "title"
], $b832709c107c9253$var$_excluded163 = [
    "title"
], $b832709c107c9253$var$_excluded164 = [
    "title"
], $b832709c107c9253$var$_excluded165 = [
    "title"
], $b832709c107c9253$var$_excluded166 = [
    "title"
], $b832709c107c9253$var$_excluded167 = [
    "title"
], $b832709c107c9253$var$_excluded168 = [
    "title"
], $b832709c107c9253$var$_excluded169 = [
    "title"
], $b832709c107c9253$var$_excluded170 = [
    "title"
], $b832709c107c9253$var$_excluded171 = [
    "title"
], $b832709c107c9253$var$_excluded172 = [
    "title"
], $b832709c107c9253$var$_excluded173 = [
    "title"
], $b832709c107c9253$var$_excluded174 = [
    "title"
], $b832709c107c9253$var$_excluded175 = [
    "title"
], $b832709c107c9253$var$_excluded176 = [
    "title"
], $b832709c107c9253$var$_excluded177 = [
    "title"
], $b832709c107c9253$var$_excluded178 = [
    "title"
], $b832709c107c9253$var$_excluded179 = [
    "title"
], $b832709c107c9253$var$_excluded180 = [
    "title"
], $b832709c107c9253$var$_excluded181 = [
    "title"
], $b832709c107c9253$var$_excluded182 = [
    "title"
], $b832709c107c9253$var$_excluded183 = [
    "title"
], $b832709c107c9253$var$_excluded184 = [
    "title"
], $b832709c107c9253$var$_excluded185 = [
    "title"
], $b832709c107c9253$var$_excluded186 = [
    "title"
], $b832709c107c9253$var$_excluded187 = [
    "title"
], $b832709c107c9253$var$_excluded188 = [
    "title"
], $b832709c107c9253$var$_excluded189 = [
    "title"
], $b832709c107c9253$var$_excluded190 = [
    "title"
], $b832709c107c9253$var$_excluded191 = [
    "title"
], $b832709c107c9253$var$_excluded192 = [
    "title"
], $b832709c107c9253$var$_excluded193 = [
    "title"
], $b832709c107c9253$var$_excluded194 = [
    "title"
], $b832709c107c9253$var$_excluded195 = [
    "title"
], $b832709c107c9253$var$_excluded196 = [
    "title"
], $b832709c107c9253$var$_excluded197 = [
    "title"
], $b832709c107c9253$var$_excluded198 = [
    "title"
], $b832709c107c9253$var$_excluded199 = [
    "title"
], $b832709c107c9253$var$_excluded200 = [
    "title"
], $b832709c107c9253$var$_excluded201 = [
    "title"
], $b832709c107c9253$var$_excluded202 = [
    "title"
], $b832709c107c9253$var$_excluded203 = [
    "title"
], $b832709c107c9253$var$_excluded204 = [
    "title"
], $b832709c107c9253$var$_excluded205 = [
    "title"
], $b832709c107c9253$var$_excluded206 = [
    "title"
], $b832709c107c9253$var$_excluded207 = [
    "title"
], $b832709c107c9253$var$_excluded208 = [
    "title"
], $b832709c107c9253$var$_excluded209 = [
    "title"
], $b832709c107c9253$var$_excluded210 = [
    "title"
], $b832709c107c9253$var$_excluded211 = [
    "title"
], $b832709c107c9253$var$_excluded212 = [
    "title"
], $b832709c107c9253$var$_excluded213 = [
    "title"
], $b832709c107c9253$var$_excluded214 = [
    "title"
], $b832709c107c9253$var$_excluded215 = [
    "title"
], $b832709c107c9253$var$_excluded216 = [
    "title"
], $b832709c107c9253$var$_excluded217 = [
    "title"
], $b832709c107c9253$var$_excluded218 = [
    "title"
], $b832709c107c9253$var$_excluded219 = [
    "title"
], $b832709c107c9253$var$_excluded220 = [
    "title"
], $b832709c107c9253$var$_excluded221 = [
    "title"
], $b832709c107c9253$var$_excluded222 = [
    "title"
], $b832709c107c9253$var$_excluded223 = [
    "title"
], $b832709c107c9253$var$_excluded224 = [
    "title"
], $b832709c107c9253$var$_excluded225 = [
    "title"
], $b832709c107c9253$var$_excluded226 = [
    "title"
], $b832709c107c9253$var$_excluded227 = [
    "title"
], $b832709c107c9253$var$_excluded228 = [
    "title"
], $b832709c107c9253$var$_excluded229 = [
    "title"
], $b832709c107c9253$var$_excluded230 = [
    "title"
], $b832709c107c9253$var$_excluded231 = [
    "title"
], $b832709c107c9253$var$_excluded232 = [
    "title"
], $b832709c107c9253$var$_excluded233 = [
    "title"
], $b832709c107c9253$var$_excluded234 = [
    "title"
], $b832709c107c9253$var$_excluded235 = [
    "title"
], $b832709c107c9253$var$_excluded236 = [
    "title"
], $b832709c107c9253$var$_excluded237 = [
    "title"
], $b832709c107c9253$var$_excluded238 = [
    "title"
], $b832709c107c9253$var$_excluded239 = [
    "title"
], $b832709c107c9253$var$_excluded240 = [
    "title"
], $b832709c107c9253$var$_excluded241 = [
    "title"
], $b832709c107c9253$var$_excluded242 = [
    "title"
], $b832709c107c9253$var$_excluded243 = [
    "title"
], $b832709c107c9253$var$_excluded244 = [
    "title"
], $b832709c107c9253$var$_excluded245 = [
    "title"
], $b832709c107c9253$var$_excluded246 = [
    "title"
], $b832709c107c9253$var$_excluded247 = [
    "title"
], $b832709c107c9253$var$_excluded248 = [
    "title"
], $b832709c107c9253$var$_excluded249 = [
    "title"
], $b832709c107c9253$var$_excluded250 = [
    "title"
], $b832709c107c9253$var$_excluded251 = [
    "title"
], $b832709c107c9253$var$_excluded252 = [
    "title"
], $b832709c107c9253$var$_excluded253 = [
    "title"
], $b832709c107c9253$var$_excluded254 = [
    "title"
];
function $b832709c107c9253$var$_extends() {
    $b832709c107c9253$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b832709c107c9253$var$_extends.apply(this, arguments);
}
function $b832709c107c9253$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b832709c107c9253$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b832709c107c9253$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b832709c107c9253$export$871e5f91a510f021 = function AC(_ref) {
    var title = _ref.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref, $b832709c107c9253$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M440.1 181.1c-.1 39.2-6.4 81.4-57.4 101.5-51.1-20.1-57.3-62.3-57.4-101.5h114.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#29DBFF",
        d: "M439.6 197.7c-2.8 34.9-12.4 67.4-57 85-44.4-17.6-54.5-51.2-56.9-84.9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M437.8 214.1c-3.2 24.3-16.7 53.5-55.1 68.6-38.4-15.1-50.5-42.5-55.1-68.4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#29DBFF",
        d: "M434.2 230.3c-5.7 17.7-19.3 39.4-51.3 52.8-32-12.6-45.2-33.8-51.4-53"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M426.7 246.9c-6.5 11.3-17.7 25.4-44 35.9-27.5-11.5-37.4-25.3-44-36.1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#29DBFF",
        d: "M412.4 265.1c-8.1 7.2-12 11.2-29.6 17.9-20.1-7.9-22.6-11.6-29.2-17.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#5CC85C",
        d: "M383.3 231.6c-.2-.2-27.9 35.7-27.9 35.7-1.8-1.3-10-9.5-13.3-15l41.3-50.1 40.2 49.7c-3.9 6.5-11.4 13.6-13.2 15M382.6 85.3l-26.5 45h53z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        transform: "rotate(-82.3 291.431 225.686)",
        fill: "#F7A226",
        cx: 291.4,
        cy: 225.7,
        rx: 48.7,
        ry: 15.7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        transform: "rotate(-68.099 303.087 164.67)",
        fill: "#DDC7AB",
        cx: 303.1,
        cy: 164.7,
        rx: 11.7,
        ry: 7.2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        transform: "rotate(-81.738 291.697 271.697)",
        fill: "#DDC7AB",
        cx: 291.7,
        cy: 271.7,
        rx: 11.4,
        ry: 3.3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        transform: "matrix(.9986 -.05353 .05353 .9986 -13.992 16.424)",
        fill: "#DDC7AB",
        cx: 299.6,
        cy: 269.4,
        rx: 3.3,
        ry: 11
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        transform: "rotate(-21.518 314.54 201.06)",
        fill: "#DDC7AB",
        cx: 314.5,
        cy: 201.1,
        rx: 4.1,
        ry: 13.7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        transform: "rotate(-21.518 317.511 178.077)",
        fill: "#DDC7AB",
        cx: 317.5,
        cy: 178.1,
        rx: 13.7,
        ry: 4.1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        transform: "rotate(-7.7 473.781 225.857)",
        fill: "#F7A226",
        cx: 473.6,
        cy: 225.9,
        rx: 15.7,
        ry: 48.7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        transform: "rotate(-21.901 462.057 164.866)",
        fill: "#DDC7AB",
        cx: 462,
        cy: 164.9,
        rx: 7.2,
        ry: 11.7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        transform: "rotate(-8.27 473.27 271.908)",
        fill: "#DDC7AB",
        cx: 473.4,
        cy: 271.9,
        rx: 3.3,
        ry: 11.4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        transform: "matrix(.05353 -.9986 .9986 .05353 171.34 719.998)",
        fill: "#DDC7AB",
        cx: 465.5,
        cy: 269.6,
        rx: 11,
        ry: 3.3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        transform: "rotate(-68.482 450.552 201.247)",
        fill: "#DDC7AB",
        cx: 450.6,
        cy: 201.2,
        rx: 13.7,
        ry: 4.1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        transform: "rotate(-68.482 447.58 178.265)",
        fill: "#DDC7AB",
        cx: 447.6,
        cy: 178.3,
        rx: 4.1,
        ry: 13.7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#B0C6CC",
        d: "M373.3 130.3 356.1 155l17.8 26.1H396l4.7-25.4-5.4-25.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2E52B2",
        d: "M256 22.7v30.7h-46.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
    }));
};
var $b832709c107c9253$export$132ea4ffd82bf2b2 = function AD(_ref2) {
    var title = _ref2.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref2, $b832709c107c9253$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h171v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M342 0h171v342H342zM198.9 113.6H256v64.8h-57.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M267.6 113.6v64.7m16.6-64.7v64.7m16.6-64.7v64.7",
        stroke: "#D80027",
        strokeWidth: 7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M247.4 178.4v64.7m-13.3-64.7v64.7m-13.3-64.6v53.9m-13.7-53.9v47.1",
        stroke: "#D80027",
        strokeWidth: 5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m199.9 146 27.6-32.4 28.5 32.3-28.1 32.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#BC8B00",
        d: "M182.2 95.9v92.2c0 34.3 27.3 54.2 48.6 64.5-.8 1.4 25.1 8.3 25.1 8.3s25.9-6.9 25.1-8.3c21.4-10.3 48.6-30.1 48.6-64.5V95.9H182.2zm129.9 92.2c0 16.9-10 29.4-32.8 43.9-8.6 5.5-17.5 9-23.3 11-5.8-2-14.7-5.5-23.3-11-22.8-14.5-32.8-28-32.8-43.9v-74.5h112.2v74.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M264.4 188.9h29.5v8.6h-29.5zm0 17.6h29.5v8.6h-29.5z"
    }));
};
var $b832709c107c9253$export$2b2c8e343c91a153 = function AE(_ref3) {
    var title = _ref3.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref3, $b832709c107c9253$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#009e49",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 228h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ce1126",
        d: "M0 0h171v342H0z"
    }));
};
var $b832709c107c9253$export$515692adc069839f = function AF(_ref4) {
    var title = _ref4.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref4, $b832709c107c9253$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#DB3E00",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#479900",
        d: "M331 0h182v342H331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h181.8v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256 126.7c-19.4 0-35.2 15.8-35.2 35.2v52.8h70.4v-52.8c0-19.5-15.8-35.2-35.2-35.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256 84.3c-47.7 0-86.4 38.7-86.4 86.4S208.3 257 256 257s86.4-38.7 86.4-86.4-38.7-86.3-86.4-86.3zm0 157.7c-39.4 0-71.4-32-71.4-71.4 0-39.4 32-71.4 71.4-71.4 39.4 0 71.4 32 71.4 71.4 0 39.5-32 71.4-71.4 71.4z"
    }));
};
var $b832709c107c9253$export$9b1a14e161c718eb = function AG(_ref5) {
    var title = _ref5.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref5, $b832709c107c9253$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0072c6",
        d: "M88.8 136.5c-2.2 12.9-3.4 26.2-3.4 39.8 0 13.6 1.2 27 3.4 39.8L256 228.3l167.2-12.1c2.2-12.9 3.4-26.2 3.4-39.8s-1.2-27-3.4-39.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M423.2 219H88.8c15.8 69.8 84.7 122.3 167.2 122.3S407.4 288.8 423.2 219z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M365.9 136.5H146.1l44.9-21.1-23.9-43.5 48.8 9.4L222 32l34 36.2L290 32l6.1 49.3 48.8-9.4-23.9 43.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#ce1126"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M256.5 342 0 0v342z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M513 342V0L256 342z"
    })));
};
var $b832709c107c9253$export$d710c5f50fc7496a = function AI(_ref6) {
    var title = _ref6.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref6, $b832709c107c9253$var$_excluded6);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#00318b",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M454.8 265.38c7.94-10.93 13.24-24.27 13.24-40.42V104.89a59.754 59.754 0 0 1-36.02 12.01c-19.64 0-37.07-9.43-48.03-24.01-10.95 14.58-28.39 24.01-48.03 24.01-13.52 0-25.99-4.47-36.02-12v120.06c0 16.16 5.3 29.5 13.24 40.42H454.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#8DCCFF",
        d: "M310.23 260.98C332.65 296.96 384 309 384 309s51.35-12.04 73.77-48.02H310.23z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D87B00",
        d: "M396.66 172.21c.32 1.42 8.72 10.17 17.56 20.15 1.39 1.57-8.74 12.63-6.91 12.59 4.75-.12 19.27-17.26 19.34 6.65.05 15.94-30 27.51-30 27.51h17.47l.65 14.96s4.97-13.34 7.59-16.57c8.1-9.97 20.18-30.07 34.59-27.1 14.41 2.97-13.66-13.92-13.66-13.92s-5.2-15.19-16.63-16.97c-10.06-1.57-14.29-2.51-26.64-7.3-1.68-.65-3.88-2.32-3.36 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D87B00",
        d: "M359.69 198.69c1.07-.99 4.46-12.63 8.69-25.28.67-1.99 15.31 1.27 14.35-.3-2.47-4.06-24.58-8.08-3.9-20.08 13.79-8 38.82 12.27 38.82 12.27l-8.72-15.14 12.64-8.03s-14.05 2.35-18.14 1.69c-12.68-2.04-36.13-2.48-40.75-16.45-4.62-13.97-5.25 18.79-5.25 18.79s-10.56 12.08-6.4 22.88c3.66 9.5 4.96 13.64 6.97 26.73.29 1.79-.06 4.53 1.69 2.92z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D87B00",
        d: "M395.67 219.87c-1.39-.43-13.16 2.49-26.22 5.18-2.06.42-6.59-13.88-7.47-12.26-2.27 4.17 5.36 25.31-15.41 13.45-13.84-7.91-8.89-39.73-8.89-39.73l-8.71 15.14-13.29-6.9s9.09 10.96 10.57 14.84c4.6 11.99 16 32.49 6.24 43.49-9.76 11.01 18.88-4.9 18.88-4.9s15.76 3.07 23-5.96c6.38-7.94 9.3-11.14 19.61-19.45 1.43-1.12 3.97-2.19 1.69-2.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256.5 0h-23.1L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1V171h22.6L96 121.8V171h64v-49.2l73.4 49.2h23.1v-22.9l-46.6-30.7h46.6v-64h-46.6l46.6-30.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M144 0h-32v69.4H0v32h112V171h32v-69.6h112.5v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 171v-11.3l62.5-42.3h22.6L7.3 171zM7.3.1l77.8 53.2H62.5L0 11.1V.1zm249.2 0v11l-63 42.3h-22.6L248.7.1zM248.7 171l-77.8-53.6h22.6l63 42.3V171z"
    }));
};
var $b832709c107c9253$export$1bb1140fe1358b00 = function AL(_ref7) {
    var title = _ref7.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref7, $b832709c107c9253$var$_excluded7);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 90 60"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ED2024",
        d: "M0 0h90v60H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#212121",
        d: "M32.5 12.2v16l7.1 2.5-5 4.9 2.4 3 5.3-5.5 1.2 2.3-3 4.9 3.6 5.6-1.8 2.6 2.8 3.6 2.7-3.7-1.5-2.6 3-5.8-2.7-4.6 1.2-2.3 5.2 5.5 2.5-2.9-5.2-5.1 7.2-2.6V12.2l-5.2 1.9-.1 3.8-3.3.3v-2.6l1.7-2.3 5.6-2.2-2.3-.4 1.4-1.2.9.4-.8-1.4L54 9l-1-1.1L47.5 9l1.4 1.1-3.8 4.9-3.8-4.8 1.3-1.1-5-1.2L36.2 9l-1.5-.4-.8 1.4.9-.6 1.6 1.1-2.3.5 5.5 2 1.6 2.3v2.9l-3.3-.3v-3.6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M26.2 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM57.4 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM53.4 36.1h6.4V38h-6.4zm-23.2 0h6.4V38h-6.4z",
        fill: "#212121"
    }));
};
var $b832709c107c9253$export$1507e1869e034170 = function AM(_ref8) {
    var title = _ref8.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref8, $b832709c107c9253$var$_excluded8);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FF9811",
        d: "M0 228h513v114H0z"
    }));
};
var $b832709c107c9253$export$98cc8105f49bb278 = function AO(_ref9) {
    var title = _ref9.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref9, $b832709c107c9253$var$_excluded9);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 171h513v171H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v171H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFDA44"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m332.7 135.6 17.5-8.6-7.4-19-18.7 6.2zm-45.6-56 5.5-18.8-19.1-7.2-8 18zm29.4 23.2 12.2-15.3-14.9-13.9-14.2 13.6zm19.4 68.9 19.5-.8v-21.3l-22.9.2zm-12.6 38.1 18.8 5.5 7.3-19-18-8zm-29 32.4 14.9 12.7 14.4-14.4-13.1-14.7zm-47-147.7 9.8 19.9 21.9 3.3-15.9 15.5 3.6 21.9-19.6-10.4-19.7 10.2 3.8-21.9-15.8-15.5 22-3.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m250.8 61.3-2.7 18.3c43.1 3.2 77 39.2 77 83.1 0 46-37.3 82.9-83.4 83.4-29.2.3-51.3-14.8-67-33.7l-13.9 12.3c15 19 40.8 39.9 80.9 39.9 56.3 0 101.9-45.6 101.9-101.9.1-53.2-40.7-96.9-92.8-101.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#000",
        d: "m291.9 223.4-11.8 14s51.9 38.9 53.6 40.4c1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-2-1.5-51.8-42-51.8-42z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M206.1 157.2c-7.7 10.3-7.5 23.1 2.8 30.9 0 0 135.2 101.5 136.9 103 1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-1.9-1.5-149.7-121.5-149.7-121.5zm47.7 99.1 7.3 18.2 19.5-6-4.8-19.1zm-40.4-3.7-2 19.5 20.1 3.6 4.5-19.1zm-35.7-21.2L167.4 248l16.4 12.1 12.5-15.2z"
    })));
};
var $b832709c107c9253$export$123513653fa883e4 = function AQ(_ref10) {
    var title = _ref10.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref10, $b832709c107c9253$var$_excluded10);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 744 496"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#3A7DCE",
        d: "M0 0h744v496H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#fff",
        d: "m120 125 90 63 54-14 23-81 61-36 92 14 105 55 6 90 34 12v92l-65 115-78 24-72-17 18-30-8-32-10 9-162-25-49-85 20-46-49-62z"
    }));
};
var $b832709c107c9253$export$1cd25c0dace0921a = function AR(_ref11) {
    var title = _ref11.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref11, $b832709c107c9253$var$_excluded11);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h512v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M0 0h512v114H0zm0 228h512v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFDA44",
        stroke: "#d6ab00",
        strokeWidth: 5,
        cx: 256.5,
        cy: 171,
        r: 40
    }));
};
var $b832709c107c9253$export$33f07343a4b8be1f = function AS(_ref12) {
    var title = _ref12.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref12, $b832709c107c9253$var$_excluded12);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#10338c",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M513 33 95.3 171 513 310.76V342L0 171 513 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M513 287.18v24.58L81.72 171 513 30v24.16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#A2001D",
        d: "m476.98 140.21-21.89 10.68-3.18-15.32 31.19-29.77s-9.42-40.65-13.75-44.98l-112.32 55.82-6.84 36.76-31.9 28.59-.4 34.2 34.29-22.76 67.23-2.66-1.51 38.11h22.23l11.9-44.64 31.55-24.61-6.6-19.42z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#EFC100",
        stroke: "#231F20",
        strokeMiterlimit: 10,
        d: "m317.89 238.41-22.24-11.11 22.24-11.11h144.46v22.22z"
    }));
};
var $b832709c107c9253$export$537de78b98ba1ef0 = function AT(_ref13) {
    var title = _ref13.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref13, $b832709c107c9253$var$_excluded13);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 114h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v114H0zm0 228h513v114H0z"
    }));
};
var $b832709c107c9253$export$24f205cbfb89b8fc = function AU(_ref14) {
    var title = _ref14.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref14, $b832709c107c9253$var$_excluded14);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#10338c",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M222.2 170.7c.3-.3.5-.6.8-.9-.2.3-.5.6-.8.9zM188 212.6l11 22.9 24.7-5.7-11 22.8 19.9 15.8-24.8 5.6.1 25.4-19.9-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9L332 136zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm42.5 49.7 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.4-7.6-9.5 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zM398 166.5l4.1 12.7h13.3l-10.8 7.8 4.2 12.7-10.8-7.9-10.8 7.9 4.1-12.7-10.7-7.8h13.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M254.8 0v30.6l-45.1 25.1h45.1V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9H99v-48.6l-87.4 48.6H-1.2v-30.6L44 115H-1.2V55.7h59.1L-1.2 22.8V0h26.7L99 40.8V0h55.6v48.6L242.1 0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M142.8 0h-32v69.3h-112v32h112v69.4h32v-69.4h112v-32h-112z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "m154.6 115 100.2 55.7v-15.8L183 115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m154.6 115 100.2 55.7v-15.8L183 115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m154.6 115 100.2 55.7v-15.8L183 115zm-83.9 0-71.9 39.9v15.8L99 115z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M99 55.7-1.2 0v15.7l71.9 40z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M99 55.7-1.2 0v15.7l71.9 40z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M99 55.7-1.2 0v15.7l71.9 40zm84 0 71.8-40V0L154.6 55.7z",
        fill: "#D80027"
    }));
};
var $b832709c107c9253$export$d170d5872abbd45 = function AW(_ref15) {
    var title = _ref15.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref15, $b832709c107c9253$var$_excluded15);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 363 242"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M0 0h363v242H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M57 96.9 14.7 78.2 57 59.6l18.6-42.2 18.6 42.2 42.3 18.6-42.3 18.7-18.6 42.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#f30028",
        d: "m75.6 40.6 11.5 26.1 26.1 11.5-26.1 11.5-11.5 26.1-11.5-26.1L38 78.2l26.1-11.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 152.2h363v15.7H0zm0 31.4h363v15.7H0z",
        fill: "#FFDA44"
    }));
};
var $b832709c107c9253$export$f5cd1d288a5591fb = function AX(_ref16) {
    var title = _ref16.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref16, $b832709c107c9253$var$_excluded16);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M513 210.9H202.2V342h-79.8V210.9H0v-79.8h122.4V0h79.8v131.1H513v61.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M513 149.7v42.6H183.7V342H141V192.3H0v-42.6h141V0h42.7v149.7z"
    }));
};
var $b832709c107c9253$export$16cde7da05f651a = function AZ(_ref17) {
    var title = _ref17.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref17, $b832709c107c9253$var$_excluded17);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ef3340",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#00b5e2",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#509e2f",
        d: "M0 228h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M265.6 212.6c-23 0-41.6-18.6-41.6-41.6s18.6-41.6 41.6-41.6c7.2 0 13.9 1.8 19.8 5-9.2-9-21.9-14.6-35.8-14.6-28.3 0-51.2 22.9-51.2 51.2s22.9 51.2 51.2 51.2c13.9 0 26.6-5.6 35.8-14.6-5.9 3.2-12.6 5-19.8 5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m297.6 142.2 5.5 15.5 14.9-7.1-7.1 14.9 15.5 5.5-15.5 5.5 7.1 14.9-14.9-7.1-5.5 15.5-5.5-15.5-14.9 7.1 7.1-14.9-15.5-5.5 15.5-5.5-7.1-14.9 14.9 7.1z"
    })));
};
var $b832709c107c9253$export$a73c4d14459b698d = function BA(_ref18) {
    var title = _ref18.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref18, $b832709c107c9253$var$_excluded18);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#10338C",
        d: "M0 0h513.1v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#F6C500",
        d: "M99.9 0h342v342"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M19.9 21.1 40.3 6.2 60.9 21 54 0H26.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M92.3 25.5 84.4 1.3l-7.8 24.2H51.3l20.5 14.8-7.8 24 20.4-14.8L105 64.3l-7.9-24 20.5-14.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m136.3 69.2-7.8-24-7.8 24H95.5l20.4 14.9-7.8 24 20.4-14.8 20.6 14.8-7.8-24 20.4-14.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m179.4 112.3-7.8-24.1-7.8 24.1h-25.3l20.5 14.9-7.8 24 20.4-14.8 20.6 14.8-7.9-24 20.5-15z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m222.5 155.3-7.8-24-7.8 24h-25.4l20.6 15-7.8 24 20.4-14.9 20.4 14.9-7.8-24 20.6-15z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m265.6 198.4-7.8-24-7.8 24h-25.4l20.6 14.9-7.8 24.1 20.4-14.9 20.4 14.9-7.8-24.2 20.5-14.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m308.7 241.5-7.9-24-7.8 24h-25.3l20.5 14.8-7.9 24.2 20.6-14.9 20.4 14.8-7.8-24.1 20.5-14.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m351.7 284.6-7.8-24.2-7.8 24.2h-25.3l20.4 14.8-7.8 24.1 20.5-14.9 20.5 14.9-7.8-24.1 20.4-14.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m387 303.5-7.9 24.1-25.3.1 19.8 14.3h26.6l19.9-14.4h-25.3z"
    })));
};
var $b832709c107c9253$export$921068d8846a1559 = function BB(_ref19) {
    var title = _ref19.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref19, $b832709c107c9253$var$_excluded19);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ffc726",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h171v342H0zm342 0h171v342H342z",
        fill: "#00267f"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m325.74 101.02-31.97 12.4c-.68 1.35-5.79 7.54-8.18 53.06h-17.05v-60.42L256 78.68l-12.54 27v60.8H226.4c-2.39-45.53-7.8-52.48-8.47-53.84l-31.68-11.63c.15.31 15.4 31.34 15.4 78.01v12.54h41.81v71.07h25.08v-71.07h41.81v-12.54c0-24.13 4.17-44.02 7.68-56.46 3.82-13.57 7.7-21.49 7.74-21.57l-.03.03z"
    }));
};
var $b832709c107c9253$export$2672079d1ac1dedf = function BD(_ref20) {
    var title = _ref20.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref20, $b832709c107c9253$var$_excluded20);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2d6e41",
        d: "M0 85.331h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#F40B32",
        cx: 218.902,
        cy: 256.5,
        r: 115
    }));
};
var $b832709c107c9253$export$69784246352913ed = function BE(_ref21) {
    var title = _ref21.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref21, $b832709c107c9253$var$_excluded21);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#fdda25",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h171v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ef3340",
        d: "M342 0h171v342H342z"
    }));
};
var $b832709c107c9253$export$5d7d56d6166de861 = function BF(_ref22) {
    var title = _ref22.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref22, $b832709c107c9253$var$_excluded22);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#3d944f",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ef2b2d",
        d: "M0 0h513v171H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m256 102.6 16.9 52h54.7l-44.2 32.2 16.8 52-44.2-32.1-44.2 32.1 16.8-52-44.2-32.2h54.7z"
    }));
};
var $b832709c107c9253$export$7ecc97c3ec9172d0 = function BG(_ref23) {
    var title = _ref23.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref23, $b832709c107c9253$var$_excluded23);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#00966e",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#d62612",
        d: "M0 228h513v114H0z"
    }));
};
var $b832709c107c9253$export$873be2d0c4c0f90f = function BH(_ref24) {
    var title = _ref24.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref24, $b832709c107c9253$var$_excluded24);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m222.8 34.3-85.2 34.2 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.8H0V0h137.6z"
    }));
};
var $b832709c107c9253$export$2601bd2ab73f6dbe = function BI(_ref25) {
    var title = _ref25.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref25, $b832709c107c9253$var$_excluded25);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M215.9 170.7 0 314.6V26.8zM513 26.8v287.8L297.1 170.7z",
        fill: "#47a644"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M513 26.8 296.1 170.7 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M513 26.8 297.1 170.7 513 314.6V342h-40L256 197.4 39 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFF",
        cx: 251.6,
        cy: 170.7,
        r: 100.2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m251.4 103.6 7.4 12.9h14.8l-7.4 12.8 7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8H244zm38.8 66.7 7.4 12.9h14.8L305 196l7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.9l7.4-12.8-7.4-12.8h14.9zm-77.2 0 7.4 12.9h14.9l-7.4 12.8 7.4 12.8h-14.9l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8h14.8z",
        fill: "#D80027",
        stroke: "#47a644",
        strokeWidth: 3
    }));
};
var $b832709c107c9253$export$289e628e47fc68d4 = function BJ(_ref26) {
    var title = _ref26.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref26, $b832709c107c9253$var$_excluded26);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#008751",
        d: "M0 85.333h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#fcd116",
        d: "M196.666 85.333H513v171H196.666z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#e8112d",
        d: "M196.666 256H513v171H196.666z"
    }));
};
var $b832709c107c9253$export$b54e584898971a5 = function BL(_ref27) {
    var title = _ref27.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref27, $b832709c107c9253$var$_excluded27);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#E6BC00",
        d: "M157.31 199.76s-9.04 43.93-19.31 40.39c-10.62-3.54-17.53-18.76-17.53-18.76l-14.52 21.24s38.18 8.48 41.01 5.47c1.22-1.14 8.21-15.1 10.34-26.05v-22.29zm-56.13 60.57s-2.48 20.18-1.06 22.66c1.24 2.3 39.48 11.33 39.48 11.33s-24.96 16.46-29.74 20.54L91.8 284.94l-.71-24.61h10.09zm11.33-165.69s39.65 41.6 40.36 45.5c.71 3.72-4.25 3.19-4.25 3.19s-44.79-37.53-49.92-41.07c-5.31-3.55 13.81-7.62 13.81-7.62z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ADADAD",
        d: "M99.41 104.73s16.99-.71 16.64-11.51c-.35-10.62-11.15-14.87-19.12-12.39-7.97 2.3-23.01 13.45-13.63 35.05 9.38 21.42 23.37 29.39 26.2 47.8 0 0-5.46 9.86-19.12.35-16.9-11.77-6.2-38.24-10.44-44.96-4.25-7.08-40.95-38.92-40.95-38.92s-30.24 39.37-18 74.92c16.95 49.21 51.74 31.98 64.61 36.76 0 0-42.13 61.96-49.57 67.09 0 0 24.08 8.32 47.8-18.76 0 0 5.84 9.74 7.08 20.18h10.27c4.78-26.2 51.51-64.26 49.92-82.32-1.77-21.25-49.21-49.39-51.69-73.29z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#E6BC00",
        d: "M359.17 201.27s8.96 42.43 19.23 38.89c10.62-3.54 17.53-18.76 17.53-18.76l14.52 21.24s-37 8.48-39.83 5.47c-1.21-1.14-9.32-13.79-11.52-24.66l.07-22.18zm56.05 59.06s2.48 20.18 1.06 22.66c-1.24 2.3-39.48 11.33-39.48 11.33s24.96 16.46 29.74 20.54l18.06-29.92.71-24.61h-10.09zM403.89 94.64s-39.65 41.6-40.36 45.5c-.71 3.72 4.25 3.19 4.25 3.19s44.79-37.53 49.92-41.07c5.14-3.55-13.81-7.62-13.81-7.62z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#125ECC",
        d: "M157.31 87.06H359.1v145.46c0 16.06-9.69 21.39-21.91 31.85l-45.92 39.41c-18.25 15.62-47.91 15.57-66.07 0l-46.01-39.43c-12.08-10.35-21.88-15.71-21.88-31.82V87.06z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFE600",
        d: "M200.55 147.71c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65-3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zM214.96 274.43c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c.01 7.96-6.45 14.41-14.41 14.41zm43.24 14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c0 7.95-6.45 14.41-14.41 14.41zm43.24-14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D60537",
        d: "M157.31 175.36H359.1v57.65H157.31v-57.65z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#EACE00",
        d: "M142.9 43.82s57.65-14.41 115.31-14.41 115.31 14.41 115.31 14.41l-14.41 57.65s-50.45-14.41-100.89-14.41-100.89 14.41-100.89 14.41L142.9 43.82z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#7A6920",
        d: "M258.2 72.65c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 5c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm-115.3 0c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ADADAD",
        d: "M365.08 178.02c-1.59 18.06 45.14 56.12 49.92 82.32h10.27c1.24-10.44 7.08-20.18 7.08-20.18 23.72 27.09 47.8 18.76 47.8 18.76-7.44-5.13-49.57-67.09-49.57-67.09 12.88-4.78 47.67 12.45 64.61-36.76 12.24-35.55-18-74.92-18-74.92s-36.7 31.84-40.95 38.92c-4.25 6.73 6.46 33.2-10.44 44.96-13.66 9.51-19.12-.35-19.12-.35 2.83-18.41 16.82-26.38 26.2-47.8 9.38-21.6-5.66-32.75-13.63-35.05-7.97-2.48-18.76 1.77-19.12 12.39-.35 10.8 16.64 11.51 16.64 11.51-2.48 23.9-49.92 52.04-51.69 73.29z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFF",
        cx: 258.2,
        cy: 204.19,
        r: 16.93
    }));
};
var $b832709c107c9253$export$f063c90a7fd94f53 = function BM(_ref28) {
    var title = _ref28.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref28, $b832709c107c9253$var$_excluded28);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#c8102e",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#012169",
        d: "M0 .1h256.5v171H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256 0h-22.6L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1v22.6h22.6L96 121.8v48.9h64v-48.9l73.4 48.9H256v-22.6l-46.1-30.7H256v-64h-46.1L256 22.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#c8102e",
        d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#c8102e",
        d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        transform: "translate(13 5)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#fff",
        d: "M303.9 94.94v99.69c0 59.81 79.75 99.69 79.75 99.69s79.75-39.88 79.75-99.69V94.94H303.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2F8F22",
        d: "M436.37 254.44H330.93c23.13 25.08 52.72 39.88 52.72 39.88s29.59-14.8 52.72-39.88z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#65B5D2",
        cx: 383.65,
        cy: 214.56,
        r: 39.88
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#c8102e",
        cx: 343.77,
        cy: 194.63,
        r: 19.94
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#c8102e",
        cx: 423.52,
        cy: 194.63,
        r: 19.94
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#c8102e",
        cx: 383.65,
        cy: 154.75,
        r: 19.94
    })));
};
var $b832709c107c9253$export$ed16643e9b9e3dfe = function BN(_ref29) {
    var title = _ref29.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref29, $b832709c107c9253$var$_excluded29);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m0 193.74 513 127.19V214.26L0 97.08z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M513 234.26v-86.67L0 20.41v86.67"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#D80027",
        stroke: "#231F20",
        strokeWidth: 3,
        strokeMiterlimit: 10
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M306.4 134.01a50.28 50.28 0 0 1 6.07 24.02c0 21.55-13.51 39.94-32.52 47.19v-59.51c5.7-1.19 10-6.37 10-12.59 6.9 0 12.5-5.75 12.5-12.85h-.42c6.9 0 12.91-5.75 12.91-12.85h-34.99V76.58l-14.99-27.71-15 27.71v30.84h-34.99c0 7.1 6.01 12.85 12.91 12.85h-.42c0 7.1 5.6 12.85 12.5 12.85 0 6.22 4.29 11.4 9.99 12.59v61.37c-22.09-5.39-38.48-25.3-38.48-49.05 0-8.7 2.2-16.88 6.07-24.02-10.96 11.21-17.72 26.53-17.72 43.44 0 34.32 27.82 62.15 62.15 62.15s62.15-27.83 62.15-62.15c0-16.91-6.77-32.24-17.72-43.44z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M198.46 226.81s20.69 27.71 66.5 27.71 66.5-27.71 66.5-27.71l13.47 28.37s-21.03 27.71-79.97 27.71-79.97-27.71-79.97-27.71l13.47-28.37zm-69.22-93.63h20.88l24.93 27.26v73.45h-26.28v-68.37zm270.76 0h-20.88l-24.93 27.26v73.45h26.27v-68.37z"
    })));
};
var $b832709c107c9253$export$cd6527c992e4b6fe = function BO(_ref30) {
    var title = _ref30.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref30, $b832709c107c9253$var$_excluded30);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#d52b1e",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#f9e300",
        d: "M0 114h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#007934",
        d: "M0 228h513v114H0z"
    }));
};
var $b832709c107c9253$export$2ca204c58a1fc922 = function BQ(_ref31) {
    var title = _ref31.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref31, $b832709c107c9253$var$_excluded31);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#012a87",
        d: "M0 342h513V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#f9d90f",
        d: "M250.4 0H0v166.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#dc171d",
        d: "m140.4 118.3 12.2 21.2h24.5l-12.3 21.1 12.3 21.2h-24.5L140.4 203l-12.2-21.2h-24.5l12.3-21.2-12.3-21.1h24.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "none",
        stroke: "#000",
        strokeWidth: 9,
        strokeMiterlimit: 10,
        cx: 140.4,
        cy: 160.6,
        r: 57.7
    }));
};
var $b832709c107c9253$export$b3e0c086157e0a90 = function BR(_ref32) {
    var title = _ref32.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref32, $b832709c107c9253$var$_excluded32);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#009b3a",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#fedf00",
        d: "m256.5 19.3 204.9 151.4L256.5 322 50.6 170.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFF",
        cx: 256.5,
        cy: 171,
        r: 80.4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#002776",
        d: "M215.9 165.7c-13.9 0-27.4 2.1-40.1 6 .6 43.9 36.3 79.3 80.3 79.3 27.2 0 51.3-13.6 65.8-34.3-24.9-31-63.2-51-106-51zm119 20.3c.9-5 1.5-10.1 1.5-15.4 0-44.4-36-80.4-80.4-80.4-33.1 0-61.5 20.1-73.9 48.6 10.9-2.2 22.1-3.4 33.6-3.4 46.8.1 89 19.5 119.2 50.6z"
    }));
};
var $b832709c107c9253$export$66ea4a98fa009686 = function BS(_ref33) {
    var title = _ref33.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref33, $b832709c107c9253$var$_excluded33);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ffc72c",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v114H0zm0 228h513v114H0z",
        fill: "#00778b"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M256 171 0 342V0z"
    }));
};
var $b832709c107c9253$export$433b53d451a98e6d = function BT(_ref34) {
    var title = _ref34.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref34, $b832709c107c9253$var$_excluded34);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FF7415",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M513 0H0v342"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "none",
        stroke: "#FFF",
        strokeWidth: 42,
        strokeMiterlimit: 10,
        d: "M128.7 255.5s35 54 67.3 32.4c56.9-37.9-68.9-108.6-2.9-152.6 58.3-38.8 76.6 103.5 137.6 62.8 59-39.3-64.7-111.4-9.2-148.4 33.4-22.2 67.1 32.6 67.1 32.6"
    }));
};
var $b832709c107c9253$export$8ba1594c72a88684 = function BV(_ref35) {
    var title = _ref35.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref35, $b832709c107c9253$var$_excluded35);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 33.333 1100 733.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ef2b2d",
        d: "M0 0h1100v800H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#fff",
        d: "M300 0h200v800H300z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#fff",
        d: "M0 300h1100v200H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#002868",
        d: "M350 0h100v800H350z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#002868",
        d: "M0 350h1100v100H0z"
    }));
};
var $b832709c107c9253$export$cd7b90d76addb66a = function BW(_ref36) {
    var title = _ref36.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref36, $b832709c107c9253$var$_excluded36);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 238h513v104H0zM0 0h513v104H0z",
        fill: "#6da9d2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 125.5h513v89.656H0z"
    }));
};
var $b832709c107c9253$export$558af6901b7fc79a = function BY(_ref37) {
    var title = _ref37.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref37, $b832709c107c9253$var$_excluded37);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#007C30",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#CE1720",
        d: "M0 230h513V0H0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M100 230V0H0v342h513-413z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M28 159.6 8.6 128.2 28 97.4l19.3 30.8zm44.6 0-19.3-31.4 19.3-30.8L92 128.2zM28 241.2 8.6 209.8 28 179l19.3 30.8zm44.6 0-19.3-31.4L72.6 179 92 209.8z",
        fill: "#CE1720"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m28 73.8-16.1-26L28 22.2l16 25.6zm44.6 0-16-26 16-25.6 16.1 25.6zM28 318l-16.1-26.1L28 266.3l16 25.6zm44.6 0-16-26.1 16-25.6 16.1 25.6z",
        fill: "none",
        stroke: "#CE1720",
        strokeWidth: 7
    }));
};
var $b832709c107c9253$export$8af59566cb38fe85 = function BZ(_ref38) {
    var title = _ref38.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref38, $b832709c107c9253$var$_excluded38);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#003e87",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFF",
        cx: 260.9,
        cy: 170.9,
        r: 118.9
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "none",
        stroke: "#6DA544",
        strokeWidth: 18,
        strokeMiterlimit: 10,
        cx: 261.9,
        cy: 173.1,
        r: 94.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        stroke: "#000"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#003e87",
        d: "m261.9 151.5-50.6 23.4v20c0 11.8 6.1 22.8 16.2 28.9L262 239l34.5-15.2c10-6.2 16.2-17.1 16.2-28.9v-20l-50.8-23.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M211.3 128.1h101.3v46.7H211.3z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v35H0zm0 306h513v35H0z",
        fill: "#ce1127"
    }));
};
var $b832709c107c9253$export$8de6180416dff1fc = function CA(_ref39) {
    var title = _ref39.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref39, $b832709c107c9253$var$_excluded39);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h142v342H0zm371 0h142v342H371zm-64.5 206 50.4-25.2-25.2-12.6V143l-50.4 25.2 25.2-50.4h-25.2L256.1 80l-25.2 37.8h-25.2l25.2 50.4-50.4-25.2v25.2l-25.2 12.6 50.4 25.2-12.6 25.2h50.4V269h25.2v-37.8h50.4z",
        fill: "red"
    }));
};
var $b832709c107c9253$export$183b2a0874e6e919 = function CC(_ref40) {
    var title = _ref40.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref40, $b832709c107c9253$var$_excluded40);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "green",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m422.7 252.4 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.2V301l-11.1-8.9-11.1 8.9v-14.2l-13.8-3.2 11.1-8.8-6.2-12.8 13.9 3.2zm-46.6-136.3 6.2 12.9 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.1v14.3l-11.1-8.9-11.1 8.9.1-14.3-13.9-3.1 11.1-8.8-6.2-12.8L370 129zm37-77.8 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.9-13.9 3.1v14.2L413.1 78 402 86.9l.1-14.2-13.9-3.1 11.1-8.9-6.2-12.8 13.9 3.2zm51.8 58.4 6.2 12.8 13.9-3.2-6.3 12.8 11.2 8.9-13.9 3.1.1 14.2-11.2-8.9-11.1 8.9.1-14.2L440 128l11.2-8.9-6.3-12.8 13.9 3.2zm-28 68.1 4.9 14.8h15.6l-12.6 9.2 4.8 14.9-12.7-9.2-12.6 9.2 4.8-14.9-12.6-9.2h15.6zM306.8 254.7c-49.2 0-89.1-39.9-89.1-89.1s39.9-89.1 89.1-89.1c15.3 0 29.8 3.9 42.4 10.7C329.4 67.9 302.3 56 272.5 56c-60.5 0-109.6 49.1-109.6 109.6S212 275.3 272.5 275.3c29.8 0 56.9-11.9 76.6-31.3-12.6 6.8-27 10.7-42.3 10.7zM140.4 59.5C129.7 41 109.7 28.6 86.8 28.6S44 41 33.3 59.5h107.1zm.2.4-53.8 53.8-53.7-53.8C28 68.9 25 79.3 25 90.5c0 34.2 27.7 61.9 61.9 61.9s61.9-27.7 61.9-61.9c-.1-11.2-3.1-21.6-8.2-30.6z",
        fill: "#FFDA44"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#A2001D",
        d: "M71.4 98.2v52.2c4.9 1.3 10.1 1.9 15.5 1.9s10.5-.7 15.5-1.9V98.2h-31z"
    }));
};
var $b832709c107c9253$export$6ede307faf7aaec4 = function CD(_ref41) {
    var title = _ref41.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref41, $b832709c107c9253$var$_excluded41);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M513 66.9V0H411.7L0 274.4V342h100.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M513 0v40.1L60.2 342H0v-40.8L451.8 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m93.6 31.2 16.3 50.4H163l-42.9 31.2 16.4 50.5-42.9-31.2-43 31.2L67 112.8 24.1 81.6h53.1z"
    }));
};
var $b832709c107c9253$export$ba26f2d80491fb47 = function CF(_ref42) {
    var title = _ref42.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref42, $b832709c107c9253$var$_excluded42);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#d21034",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 171h211.5v85.3H0zm300.5 0H512v85.3H300.5z",
        fill: "#3a9927"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#003082",
        d: "M0 0v85.3h211.5V0h89v85.3H513V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M300.5 85.3H512v85.3H300.5zM0 85.3h211.5v85.3H0z",
        fill: "#FFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M300.5 342h-89v-86H0v86h513v-86H300.5zM105.7 8.6l8.6 26.2h27.5L119.5 51l8.6 26.2L105.7 61 83.4 77.2 91.9 51 69.6 34.8h27.6z",
        fill: "#ffce00"
    }));
};
var $b832709c107c9253$export$9e8da9070f3c2e68 = function CG(_ref43) {
    var title = _ref43.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref43, $b832709c107c9253$var$_excluded43);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#da1a35",
        d: "M0 85.331h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#009543",
        d: "M443.726 85.331 102.4 426.657H0V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#fbde4a",
        d: "M500.124 85.331 158.798 426.657H11.876L353.202 85.331z"
    }));
};
var $b832709c107c9253$export$31ff2235b44019b8 = function CH(_ref44) {
    var title = _ref44.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref44, $b832709c107c9253$var$_excluded44);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "red",
        d: "M0 85.337h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M356.174 222.609h-66.783v-66.783h-66.782v66.783h-66.783v66.782h66.783v66.783h66.782v-66.783h66.783z"
    }));
};
var $b832709c107c9253$export$ddcf9efc80efb978 = function CI(_ref45) {
    var title = _ref45.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref45, $b832709c107c9253$var$_excluded45);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#009e60",
        d: "M342 0h171v342H342z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#f77f00",
        d: "M0 0h171v342H0z"
    }));
};
var $b832709c107c9253$export$2779adff9720d9c9 = function CK(_ref46) {
    var title = _ref46.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref46, $b832709c107c9253$var$_excluded46);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#01237a",
        d: "M0 85.332h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m384 156.705 5.283 16.254h17.089l-13.826 10.045 5.281 16.254L384 189.211l-13.825 10.047 5.28-16.254-13.825-10.045h17.089zm-70.209 29.081 15.228 7.758 12.084-12.083-2.673 16.879 15.227 7.759-16.879 2.673-2.674 16.88-7.76-15.227-16.878 2.673 12.086-12.084zm-29.081 70.209 16.254-5.281.001-17.089 10.044 13.825 16.254-5.282-10.046 13.827 10.046 13.826-16.254-5.28-10.044 13.825v-17.09zm29.081 70.209 7.759-15.229-12.084-12.084 16.881 2.674 7.757-15.227 2.674 16.879 16.879 2.672-15.227 7.759 2.673 16.882-12.084-12.087zM384 355.284l-5.281-16.253h-17.091l13.827-10.045-5.28-16.254L384 322.776l13.827-10.044-5.281 16.254 13.826 10.045h-17.089zm70.209-29.08-15.229-7.758-12.083 12.084 2.673-16.882-15.227-7.756 16.879-2.675 2.675-16.879 7.756 15.227 16.881-2.674-12.086 12.085zm29.081-70.209-16.254 5.281v17.09l-10.045-13.826-16.254 5.281 10.046-13.826-10.046-13.827 16.254 5.282 10.045-13.825v17.089zm-29.081-70.207-7.757 15.226 12.082 12.084-16.881-2.673-7.756 15.227-2.675-16.88-16.879-2.675 15.227-7.757-2.673-16.878 12.084 12.082zM0 186.665v16h46.069L0 233.377v7.539l57.377-38.252H80L0 255.998h112v-69.334H0zm96 69.331H22.628L96 207.083v48.913zm80-117.331 80-53.334H144v69.334h112v-16h-46.069L256 107.951v-7.539l-57.377 38.251H176v.002zm-16-53.332h73.372L160 134.246V85.333zm-16 170.665h112l-80-53.334h22.623L256 240.917v-7.539l-46.069-30.713H256v-16H144v69.333zm16-48.915 73.372 48.913H160v-48.913zM112 85.331H0l80 53.334H57.377L0 100.413v7.539l46.069 30.712H0v16h112V85.331zm-16 48.915L22.628 85.333H96v48.913z",
        fill: "#FFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M144 85.331h-32v69.334H0v32h112v69.333h32v-69.333h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M80 138.665 0 85.331v15.082l57.377 38.252zm96 0h22.623L256 100.413V85.331zm-118.623 64L0 240.917v15.081l80-53.333zm118.623 0 80 53.333v-15.081l-57.377-38.252z"
    })));
};
var $b832709c107c9253$export$9bf3043cb7503aa1 = function CL(_ref47) {
    var title = _ref47.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref47, $b832709c107c9253$var$_excluded47);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M196 0h317v171H196z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0037A1",
        d: "M0 0h196v171H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M98 24.5 113.1 71H162l-39.6 28.7 15.2 46.5L98 117.5l-39.6 28.7 15.2-46.5L34 71h48.9z"
    }));
};
var $b832709c107c9253$export$dcd191669c0a595f = function CM(_ref48) {
    var title = _ref48.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref48, $b832709c107c9253$var$_excluded48);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ce1126",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#007a5e",
        d: "M0 0h171v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M342 0h171v342H342zm-86 102.2 17.2 53H329L283.9 188l17.2 53-45.1-32.7-45.1 32.7 17.2-53-45.1-32.8h55.8z",
        fill: "#fcd116"
    }));
};
var $b832709c107c9253$export$f175668af5171efd = function CN(_ref49) {
    var title = _ref49.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref49, $b832709c107c9253$var$_excluded49);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m226.8 239.2-9.7-15.6-17.9 4.4 11.9-14.1-9.7-15.6 17.1 6.9 11.8-14.1-1.3 18.4 17.1 6.9-17.9 4.4zM290.6 82l-10.1 15.4 11.6 14.3-17.7-4.8-10.1 15.5-1-18.4-17.7-4.8 17.2-6.6-1-18.4 11.6 14.3zm-54.4-56.6-2 18.3 16.8 7.6-18 3.8-2 18.3-9.2-16-17.9 3.8 12.3-13.7-9.2-15.9 16.8 7.5zm56.6 136.4-14.9 10.9 5.8 17.5-14.9-10.8-14.9 11 5.6-17.6-14.9-10.7 18.4-.1 5.6-17.6 5.8 17.5zM115 46.3l17.3 53.5h56.2l-45.4 32.9 17.3 53.5-45.4-33-45.5 33 17.4-53.5-45.5-32.9h56.3z",
        fill: "#FFDA44"
    }));
};
var $b832709c107c9253$export$423e5ab65bdedcb8 = function CO(_ref50) {
    var title = _ref50.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref50, $b832709c107c9253$var$_excluded50);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 256.5h513V342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 171h513v85.5H0z"
    }));
};
var $b832709c107c9253$export$de92be486109a1df = function CR(_ref51) {
    var title = _ref51.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref51, $b832709c107c9253$var$_excluded51);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 114h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 285h513v57H0zM0 0h513v57H0z"
    }));
};
var $b832709c107c9253$export$6f478fc577ffffe3 = function CU(_ref52) {
    var title = _ref52.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref52, $b832709c107c9253$var$_excluded52);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FF9811",
        d: "M0-40.8v422.9-211.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v68.3H0zm0 136.5h513v68.3H0zm0 136.6h513v68.3H0z",
        fill: "#0052B4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M256 170.7 0 342V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m86.5 111.4 12.7 39.2h41.3l-33.4 24.2 12.8 39.3-33.4-24.2-33.4 24.2 12.8-39.3-33.4-24.2h41.2z"
    }));
};
var $b832709c107c9253$export$9c7a4b602f1ee953 = function CV(_ref53) {
    var title = _ref53.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref53, $b832709c107c9253$var$_excluded53);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#003893",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#cf2027",
        d: "M0 182.2h513v41.4H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 140.8h513v41.4H0zm0 82.8h513V265H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m150.4 70 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13.1-17.9 13.1 6.8-21.1-17.9-13.1h22.2zm0 209.7 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13h22.2zm-97.6-70.9 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13H46zM90.1 91l6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-18-13h22.3zm-66.3 71H46l6.8-21.1 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13-17.9 13 6.8-21.1zm48.4 148.9 6.8-21.1-18-13h22.3l6.8-21.2 6.9 21.2h22.2l-18 13 6.9 21.1-18-13zM248 208.8l-6.9 21.1h-22.2l18 13-6.9 21.2 18-13.1 18 13.1-6.9-21.2 18-13h-22.2zM210.7 91l-6.8 21.1h-22.2l17.9 13-6.8 21.2 17.9-13.1 18 13.1-6.9-21.2 18-13h-22.2zm66.4 71h-22.2l-6.9-21.1-6.9 21.1h-22.2l18 13.1-6.9 21.1 18-13 18 13-6.9-21.1zm-48.4 148.9-6.9-21.1 18-13h-22.2l-6.9-21.2-6.8 21.2h-22.2l17.9 13-6.8 21.1 17.9-13z",
        fill: "#f7d116",
        stroke: "#000"
    }));
};
var $b832709c107c9253$export$640171019d58eb6d = function CW(_ref54) {
    var title = _ref54.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref54, $b832709c107c9253$var$_excluded54);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#002b7f",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#f9e814",
        d: "M0 233.5h513v51H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m168.7 86.5 12.9 39.8h41.8l-33.8 24.5 12.9 39.7-33.8-24.5-33.8 24.5 12.9-39.7-33.8-24.5h41.8zm-83.3-54 7.8 23.9h25L97.9 71.1l7.8 23.8-20.3-14.7-20.3 14.7 7.8-23.8-20.3-14.7h25.1z",
        fill: "#FFF"
    }));
};
var $b832709c107c9253$export$ef748afa94c5c5f9 = function CX(_ref55) {
    var title = _ref55.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref55, $b832709c107c9253$var$_excluded55);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0021ad",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#1c8a42",
        d: "M0 0h513v342"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m77.6 272 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9V317l-10.3-8.3-10.2 8.3v-13.2l-12.8-2.9 10.3-8.1-5.8-11.9 12.9 3zm-37.1-98.9 5.7 11.9 12.8-3-5.7 11.8 10.3 8.2-12.9 2.9.1 13.2-10.3-8.3-10.3 8.3.1-13.2-12.9-2.9 10.4-8.2L22 182l12.8 3zm37.1-80.9 5.7 11.8 12.8-2.9-5.7 11.8 10.3 8.2-12.8 2.9v13.1l-10.3-8.2-10.2 8.2V124l-12.8-2.9 10.3-8.2-5.8-11.8L72 104zm46.1 62.9 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9v13.2l-10.3-8.2-10.2 8.2v-13.2l-12.8-2.9 10.3-8.1-5.7-11.9 12.8 3zm-32.9 54 4.4 13.7h14.5L98 231.3l4.5 13.7-11.7-8.4-11.7 8.4 4.5-13.7-11.7-8.5h14.4z",
        fill: "#FFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#ffc639",
        cx: 267.1,
        cy: 170.7,
        r: 74.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#1c8a42",
        d: "M267.1 220.3h24.8s10.8-19 0-37.2l24.8-24.8-12.4-24.8h-12.4s-6.2 18.6-31 18.6-31-18.6-31-18.6h-12.4l12.4 24.8-12.4 24.8 12.4 12.4s12.4-24.8 37.2-12.4c0 0 10.5 15.5 0 37.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ffc639",
        d: "M464.4 92.2c.6-2.9-.2-17.6-.2-20.7 0-21.3-13.9-39.4-33.2-45.7 5.9 12 9.2 25.4 9.2 39.7 0 4.8-.4 9.5-1.1 14.1-2.9-4.7-6.6-8.9-11.2-12.6-17.1-13.6-40.6-14-57.9-2.5 13.4 2.9 26.3 8.9 37.7 18 9 7.1 16.2 16.8 21.7 26.1 0 0-17.8 10.9-31 15.1s-42.3 7.9-42.3 7.9c72 12 132-36 132-36-6.5-13.4-15.8-4-23.7-3.4z"
    }));
};
var $b832709c107c9253$export$e5e7583d5d9c5f7b = function CY(_ref56) {
    var title = _ref56.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref56, $b832709c107c9253$var$_excluded56);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#DB7D00",
        d: "M141.7 154.7s.2 67.1 74.7 65.3l4.5 13.9h8.9s-7.4-41.1 60.1-41.5c0 0 0-27.6 27.6-27.6H359s-66-51.8 58.9-118l1.8-13.1s-129.9 71-198.9 57.2c0 0 10.7 42.5-10.8 42.5-10.8 0-9.7-8.1-32.3-8.1-18.7 0-17.3 19.7-26.3 19.5-8.9-.2-18.8-12.3-19.6-10.2-.7 2.1 9.9 20.1 9.9 20.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#006651"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M237.2 308.1c6.9-5 13-6.6 22.4-8.3s19.4-4.4 24.6-5.8-17.7 6.6-23.5 8.3c-5.8 1.6-23.5 5.8-23.5 5.8zm37.9-14.7c-1.9-11.9 2.8-24.3 13.5-29.3 2.5 8.6-5.2 23.2-13.5 29.3zm18.2-6.2c-5.8-9.8 4-22.6 11.1-28.8 3.3 6-2.5 23.7-11.1 28.8zm16.9-7.6c-6.2-8.4 1.1-23.2 8.8-29 3.1 8.2.1 23.2-8.8 29zm16.9-10.6c-5.6-8-1.7-20.4 6.3-28.4 5.8 6.6.9 21-6.3 28.4zm13.5-10.7c-4.7-7.5 1.1-25.4 8.6-30.4 3.3 6.6.8 25.4-8.6 30.4zm10.8-2.8c-1.4-10.8 17.4-22.7 25.2-22.4-.9 8.9-8.9 18.6-25.2 22.4zm-10.5 12.2c8.8-9.1 26-9.1 32.1-7.2-1.7 5.3-21.9 16.9-32.1 7.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M328.7 276.8c12.4-3.3 20.5-6.1 27.9 1.7-5.2 6.6-25.4 4.7-27.9-1.7zm-17.7 8c11.9-6.4 26.3 3 28.5 8.6-13.3 5.5-28.7-7.2-28.5-8.6zm-16.3 9.2c10.8-4.1 23.2 1.4 28.2 7.5-5.8 2.7-21 5.7-28.2-7.5zm-14.9 4.7c12.4-1.4 24.4 8 27 13.4-15.9 1.5-22-3.2-27-13.4zm-4 9.4c-6.9-5-13-6.6-22.4-8.3-9.4-1.7-19.4-4.4-24.6-5.8-5.3-1.4 17.7 6.6 23.5 8.3 5.8 1.6 23.5 5.8 23.5 5.8zm-37.9-14.7c1.9-11.9-2.8-24.3-13.5-29.3-2.5 8.6 5.2 23.2 13.5 29.3zm-18.2-6.2c5.8-9.8-4-22.6-11.1-28.8-3.3 6 2.5 23.7 11.1 28.8zm-16.9-7.6c6.2-8.4-1.1-23.2-8.8-29-3.1 8.2-.1 23.2 8.8 29zM185.9 269c5.6-8 1.7-20.4-6.3-28.4-5.8 6.6-.9 21 6.3 28.4zm-13.5-10.7c4.7-7.5-1.1-25.4-8.6-30.4-3.3 6.6-.8 25.4 8.6 30.4zm-10.8-2.8c1.4-10.8-17.4-22.7-25.2-22.4.9 8.9 8.9 18.6 25.2 22.4zm10.5 12.2c-8.8-9.1-26-9.1-32.1-7.2 1.7 5.3 21.9 16.9 32.1 7.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M184.3 276.8c-12.4-3.3-20.5-6.1-27.9 1.7 5.2 6.6 25.4 4.7 27.9-1.7zm17.7 8c-11.9-6.4-26.3 3-28.5 8.6 13.3 5.5 28.7-7.2 28.5-8.6zm16.3 9.2c-10.8-4.1-23.2 1.4-28.2 7.5 5.8 2.7 21 5.7 28.2-7.5zm14.9 4.7c-12.4-1.4-24.4 8-27 13.4 15.9 1.5 22-3.2 27-13.4z"
    })));
};
var $b832709c107c9253$export$3aa7db55ae20a642 = function CZ(_ref57) {
    var title = _ref57.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref57, $b832709c107c9253$var$_excluded57);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#11457e",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#d7141a",
        d: "M513 171v171H0l215-171z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M513 0v171H215.185L0 0z"
    }));
};
var $b832709c107c9253$export$b2bfc53cef5629f5 = function DE(_ref58) {
    var title = _ref58.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref58, $b832709c107c9253$var$_excluded58);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 228h513v114H0z"
    }));
};
var $b832709c107c9253$export$b116121769fff50f = function DJ(_ref59) {
    var title = _ref59.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref59, $b832709c107c9253$var$_excluded59);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#12ad2b",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6ab2e7",
        d: "M513 0v166.7L0 170.8V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256 170.7 0 342V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#d7141a",
        d: "m89.8 92.5 17 52.4H162l-44.6 32.5 17 52.4-44.6-32.4-44.6 32.4 17-52.4-44.6-32.5h55.2z"
    }));
};
var $b832709c107c9253$export$861a3271cad515fc = function DK(_ref60) {
    var title = _ref60.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref60, $b832709c107c9253$var$_excluded60);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#c60c30",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M190 0h-60v140H0v60h130v142h60V200h323v-60H190z"
    }));
};
var $b832709c107c9253$export$c63caaa7a05b64da = function DM(_ref61) {
    var title = _ref61.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref61, $b832709c107c9253$var$_excluded61);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#496E2D",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 110.7v120h513v-120z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 110.7h513v40H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 190.7h513v40H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M196 0h120v342H196z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M196 0h40v342h-40z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M274.7 0h40v342h-40z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#D80027",
        cx: 256,
        cy: 170.7,
        r: 123.1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m256 58.6 4.6 14.2h15l-12.1 8.9 4.6 14.2-12.1-8.8-12.1 8.8 4.6-14.2-12.1-8.9h15zM190.1 80l12.2 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15l-4.6 14.2-4.7-14.2h-15l12.1-8.8zm-40.7 56h15l4.6-14.2 4.7 14.2h15l-12.2 8.8 4.7 14.3-12.2-8.8-12.1 8.8 4.6-14.3zm0 69.3 12.1-8.8-4.6-14.3L169 191l12.2-8.8-4.7 14.3 12.2 8.8h-15l-4.7 14.3-4.6-14.3zm40.7 56.1 4.6-14.3-12.1-8.8h15l4.7-14.3 4.6 14.3h15l-12.1 8.8 4.6 14.3-12.1-8.9zm65.9 21.4-4.6-14.3h-15l12.1-8.8-4.6-14.3 12.1 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15zm65.9-21.4-12.2-8.9-12.1 8.9 4.6-14.3-12.1-8.8h15l4.6-14.3 4.7 14.3h15l-12.1 8.8zm40.7-56.1h-15l-4.6 14.3-4.7-14.3h-15l12.2-8.8-4.7-14.3L343 191l12.1-8.8-4.6 14.3zm0-69.3-12.1 8.8 4.6 14.3-12.1-8.8-12.2 8.8 4.7-14.3-12.2-8.8h15l4.7-14.2 4.6 14.2zm-40.7-56-4.6 14.3 12.1 8.8h-15l-4.7 14.2-4.6-14.2h-15l12.1-8.8-4.6-14.3 12.1 8.8zM279.3 168.7c-11-21.1-14.5-25.1-14.5-25.1s.4-9.7.4-15.6c0-8.8-7.4-15.8-16.5-15.8-8.6 0-15.7 2.9-16.5 11-4.2.9-8.6 4.1-8.6 10.7 0 4.8 1 7.3 5.2 9.3 2.1-4.6 4.3-4.8 9.3-6.4.8.6 1.7 3 2.6 3.4l.3 1s-13.3 6.6-13.3 30.9c0 29.5 22 45.4 22 45.4l-1.8.3-1.9 7.1h22v-7.2l11 17.5c.3-.3 10.2-47.6.3-66.5z",
        fill: "#496E2D"
    }));
};
var $b832709c107c9253$export$fe81c0b6cf107daf = function DO(_ref62) {
    var title = _ref62.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref62, $b832709c107c9253$var$_excluded62);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 215.2h211.5v126.1H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h211.5v126.2H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M300.5 0H512v126.2H300.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M300.5 215.2H512v126.1H300.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        stroke: "#FFF",
        strokeWidth: 5,
        strokeMiterlimit: 10
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M256 130h-49.9v49.4s19.5 6 49.9 6V130z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M206.1 179.4v6c0 27.5 22.3 49.9 49.9 49.9v-49.9c-30.4 0-49.9-6-49.9-6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M256 235.3c27.5 0 49.9-22.3 49.9-49.9v-6s-19.5 6-49.9 6v49.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M256 130v55.4c30.4 0 49.9-6 49.9-6V130H256z"
    })));
};
var $b832709c107c9253$export$d2309a4fc782a0d1 = function DZ(_ref63) {
    var title = _ref63.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref63, $b832709c107c9253$var$_excluded63);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#41662E",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256.5 0H513v342H256.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m341.5 105.3-29.4 40.4-47.5-15.4 29.4 40.4-29.4 40.4 47.5-15.4 29.4 40.4v-50l47.5-15.5-47.5-15.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M309.9 276.7c-58.5 0-106-47.5-106-106s47.5-106 106-106c18.3 0 35.4 4.6 50.4 12.7-23.5-23-55.7-37.2-91.2-37.2-72 0-130.4 58.4-130.4 130.4S197.1 301 269.1 301c35.5 0 67.7-14.2 91.2-37.2-14.9 8.2-32.1 12.9-50.4 12.9z"
    })));
};
var $b832709c107c9253$export$129fe12d32abc311 = function EC(_ref64) {
    var title = _ref64.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref64, $b832709c107c9253$var$_excluded64);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 170.7h513V256H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 256h513v85.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFDA44",
        cx: 256,
        cy: 171,
        r: 60
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#4C1F00",
        d: "M369.2 79.9s-27.2-13.8-33.9-16c-6.7-2.2-49.1-13.2-49.1-7 0 10.3-13.5 12-15.5 12s-2-5.3-14.8-5.3-13.7 4.8-15.8 4.8c-2.2 0-14.5-1-14.5-11.5 0-5.2-42.9 4-49.1 7-6.1 3.1-33.9 16-33.9 16s45.8 2.7 53.9 6.2 43.8 16.5 43.8 16.5l-2.8 13.3h37.8l-3.8-13.3s35.1-12.7 43.8-16.5 53.9-6.2 53.9-6.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#57BA17",
        d: "M217.7 171.7c0 21.1 17.2 38.3 38.3 38.3 21.1 0 38.3-17.2 38.3-38.3v-11.5h-76.5v11.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M256 110.5c-21.1 0-38.3 17.2-38.3 38.3v11.5h76.5v-11.5c.1-21.1-17.1-38.3-38.2-38.3z"
    }));
};
var $b832709c107c9253$export$3f443bcc5237c742 = function EE(_ref65) {
    var title = _ref65.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref65, $b832709c107c9253$var$_excluded65);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#111",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#368FD8",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 228h513v114H0z"
    }));
};
var $b832709c107c9253$export$e107e11ec3489258 = function EG(_ref66) {
    var title = _ref66.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref66, $b832709c107c9253$var$_excluded66);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 228h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#C09300",
        d: "M220.3 204.4s0-58.4 4.5-64.7c3.1-4.3 16.8 5.2 22.7 4.5 0 0 4.2-7.5 4.5-12 .3-4.6-1.1-7.6-4.9-6.2 0 0-1.2-2.1.5-3.3 1.6-1.2 5.6.1 5.6.1s-.5-1 1.6-.9c2.9.2 7.2 1.4 7.4 5.6.2 3.1.3 7.7.4 8.7.7 6.8 2.7 8.7 2.7 8.7s18.4-9.2 22-5.2c3.3 3.8 4.5 64.7 4.5 64.7l-18.1-16.8 12.1 29.5s-14.4 2.4-28.9 2.4c-14.5 0-31.1-4.2-31.1-4.2l13.8-28.2-19.3 17.3z"
    }));
};
var $b832709c107c9253$export$8e048a19e03780a2 = function EH(_ref67) {
    var title = _ref67.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref67, $b832709c107c9253$var$_excluded67);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#428823",
        d: "M0 228h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M256 171 0 342V0zm53.1 0c0-22.9 13.1-42.1 34.6-46.8-3.3-.7-6.7-1.1-10.3-1.1-26.4 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9c3.5 0 7-.4 10.3-1.1-21.5-5.1-34.6-24.2-34.6-46.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m365 129.2 10.3 31.7h33.3l-27 19.6 10.3 31.7-26.9-19.6-27 19.6 10.3-31.7-27-19.6h33.4z"
    })));
};
var $b832709c107c9253$export$20e28a5cfb7c13df = function ER(_ref68) {
    var title = _ref68.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref68, $b832709c107c9253$var$_excluded68);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#56AF35",
        d: "M0 0h513v171H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "m0 342 513-171L0 0v342z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#ffc945"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M134.7 231.5c33.6 0 60.8-27.2 60.8-60.8s-27.2-60.8-60.8-60.8-60.8 27.2-60.8 60.8 27.2 60.8 60.8 60.8zm0 24.3c-47 0-85.2-38.1-85.2-85.2s38.1-85.2 85.2-85.2 85.2 38.1 85.2 85.2-38.2 85.2-85.2 85.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 119.5,
        cy: 148.3,
        r: 17.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 148.9,
        cy: 158.5,
        r: 17.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 134.7,
        cy: 135.2,
        r: 17.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 119.5,
        cy: 172.7,
        r: 17.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 149.9,
        cy: 182.8,
        r: 17.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 122.5,
        cy: 198,
        r: 17.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 145.9,
        cy: 205.2,
        r: 17.5
    })));
};
var $b832709c107c9253$export$a723e6e41cced9bd = function ES(_ref69) {
    var title = _ref69.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref69, $b832709c107c9253$var$_excluded69);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 22.5 15"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h22.5v15H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D03433",
        d: "M0 0h22.5v4H0V0zm0 11h22.5v4H0v-4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FBCA46",
        d: "M0 4h22.5v7H0V4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M7.8 7h1v.5h-1V7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#A41517",
        d: "M7.2 8.5c0 .3.3.5.6.5s.6-.2.6-.5L8.5 7H7.1l.1 1.5zM6.6 7c0-.3.2-.5.4-.5h1.5c.3 0 .5.2.5.4V7l-.1 1.5c-.1.6-.5 1-1.1 1-.6 0-1-.4-1.1-1L6.6 7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#A41517",
        d: "M6.8 7.5h2V8h-.5l-.5 1-.5-1h-.5v-.5zM5.3 6h1v3.5h-1V6zm4 0h1v3.5h-1V6zm-2.5-.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v.2c0 .2-.1.3-.3.3H7c-.1 0-.2-.1-.2-.2v-.3z"
    }));
};
var $b832709c107c9253$export$404386694049c788 = function ET(_ref70) {
    var title = _ref70.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref70, $b832709c107c9253$var$_excluded70);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 22.5 15"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#20AA46",
        d: "M0 0h22.5v5H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#E92F3B",
        d: "M0 10h22.5v5H0v-5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FADF50",
        d: "M0 5h22.5v5H0V5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#205CCA",
        cx: 11.3,
        cy: 7.5,
        r: 5.2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        stroke: "#FFDB3D",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m11.3 8.8-2.1 1.5.8-2.4-2-1.5h2.5l.8-2.3.8 2.3h2.6l-2.1 1.5.8 2.4-2.1-1.5zm-1-2.4h1.9M9.9 7.8l1.3 1m.8-2.6.7 1.8M10 7.9l.6-1.8M11 9l1.6-1.1",
        strokeWidth: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m8.7 3.9 1.1 1.6m4-1.7-1 1.6m-1.5 4.7V12M8.9 8.3 7.1 9m8.4 0-1.8-.7",
        strokeWidth: 0.25
    })));
};
var $b832709c107c9253$export$f005962cdbec7017 = function EU(_ref71) {
    var title = _ref71.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref71, $b832709c107c9253$var$_excluded71);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 810 540"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#039",
        d: "M0 0h810v540H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FC0",
        d: "m404.951 59.865 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-90 24 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-66 66 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-24 89.999 6.735 20.719h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm24 90.001 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm66 66 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm180-312 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm66 66 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm24 90 6.735 20.718h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm-24 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm-156 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm90-24.001 6.735 20.719h21.894l-17.633 12.812 6.639 20.74-17.635-12.812-17.633 12.812 6.735-20.73-17.633-12.811h21.797z"
    }));
};
var $b832709c107c9253$export$b742dc37108d5cac = function FI(_ref72) {
    var title = _ref72.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref72, $b832709c107c9253$var$_excluded72);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2E52B2",
        d: "M513 129.3V212H203.7v130H121V212H0v-82.7h121V0h82.7v129.3z"
    }));
};
var $b832709c107c9253$export$4cd493ed69e3bc18 = function FJ(_ref73) {
    var title = _ref73.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref73, $b832709c107c9253$var$_excluded73);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#62B5E5",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#F3F3F3",
        d: "M307.1 127.1v92c0 61.6 80.5 80.5 80.5 80.5s80.4-19 80.4-80.6v-92l-80.5-23-80.4 23.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M468 132.8V98.3H307.1v34.5h69v69h-69v23h69V296c6.9 2.5 11.5 3.5 11.5 3.5s4.6-1.1 11.5-3.5v-71.2h69v-23h-69v-69H468z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h256.5v170.6H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m155.9 115 100.6 55.6v-15.8L184.6 115h-28.7zm-55.7-59.3L0 0v15.8l71.8 39.9h28.4z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m196.9 115 59.6 32.9V115h-59.6zm-41 0 100.6 55.6v-15.8L184.6 115h-28.7zm73.4 55.6-73.5-40.9v40.9h73.5zM45.2 115 0 140.1V115h45.2zm55 7.1v48.6H12.8l87.4-48.6zM59.1 55.7 0 22.8v32.8s59.1 0 59.1.1zm41.1 0L0 0v15.8l71.8 39.9h28.4zM26.7 0l73.5 40.8V0H26.7zm184.2 55.7 45.6-25.1v25.1h-45.6zm-55-7.2V0h87.4l-87.4 48.5z",
        fill: "#0052B4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M144.3-.2h-32.1v69.5H0v32.1h112.2v69.5h32.1v-69.5h112.2V69.3H144.3V-.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m155.9 115 100.6 55.6v-15.8L184.6 115h-28.7zm-84.1 0L0 154.9v15.8L100.2 115H71.8zm28.4-59.3L0 0v15.8l71.8 39.9h28.4zm83.9 0 72.4-39.9V0L155.9 55.7h28.2z"
    })));
};
var $b832709c107c9253$export$58f4e3559034e3ed = function FK(_ref74) {
    var title = _ref74.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref74, $b832709c107c9253$var$_excluded74);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M155.8 115 256 170.7v-15.8L184.2 115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M155.8 115 256 170.7v-15.8L184.2 115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#1F8BDE",
        d: "M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3zm79.6 86.3c7.9-4.5 15.9-10 23.2-16.7 20.5-18.5 32.6-41.4 32.6-69.7v-90c0-.3-120.4-.3-120.4-.3v90.3c0 28.3 12.1 51.2 32.6 69.7 8.3 7.5 17.6 13.9 27.6 19 1.4-.6 2.8-1.4 4.4-2.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#187536",
        d: "M347.1 193.4c-2.6-7.9 1.7-14.3 10.1-14.3h60.5c8.2 0 12.8 6.3 10.1 14.3l-5.5 16.5c-2.6 7.9-8.9 9.2-15.8 4 0 0 2.6-4.8-19.1-4.8-21.7 0-19.1 4.8-19.1 4.8-6.1 5.7-13.1 4-15.8-4 .1.1-5.4-16.5-5.4-16.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M357.4 179.1c8.1 1.6 17.8-15 30.1-15 13.1 0 21.8 17.1 30.1 15 7.4-1.8 15-22.2 15-30.1 0-16.6-20.2-30.1-45.1-30.1-24.9 0-45.1 13.5-45.1 30.1-.1 8.5 6.6 28.5 15 30.1zm-1.4 91.6c6.2.4 12.5-1.8 17.2-6.5l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c4.7 4.7 11 6.9 17.1 6.5 5.3-.3 32.5-33.5 25.7-32.6-4.6.6-9.1 2.8-12.7 6.3l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-3.5-3.5-7.8-5.6-12.3-6.3-6.7-1.1 20.1 32.2 25.3 32.5zM322.1 210c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0 0 0 5.5-14.8 2.5-15.9-7.9-2.9-17.2-1.2-23.5 5.2l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-6.2-6.2-15.1-8-22.8-5.5-3.1 1.1 1.9 16.1 1.9 16.1z"
    }));
};
var $b832709c107c9253$export$ae39d226e90e08ef = function FM(_ref75) {
    var title = _ref75.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref75, $b832709c107c9253$var$_excluded75);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m256 37.9 10.1 31.2H299l-26.6 19.3 10.2 31.2-26.6-19.3-26.6 19.3 10.2-31.2L213 69.1h32.9zM123.2 170.7l31.2-10.2v-32.8l19.3 26.6 31.2-10.2-19.3 26.6 19.3 26.5-31.2-10.1-19.3 26.5v-32.8zM256 303.5l-10.1-31.2H213l26.6-19.3-10.2-31.3L256 241l26.6-19.3-10.2 31.3 26.6 19.3h-32.9zm132.8-132.8-31.2 10.1v32.8l-19.3-26.5-31.2 10.1 19.3-26.5-19.3-26.6 31.2 10.2 19.3-26.6v32.8z",
        fill: "#FFF"
    }));
};
var $b832709c107c9253$export$3117889032a11ab0 = function FO(_ref76) {
    var title = _ref76.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref76, $b832709c107c9253$var$_excluded76);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0F61A5",
        d: "M513 214.5H206.2V342h-87.8V214.5H0v-87.7h118.4V0h87.8v126.8H513V192z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#E50E3D",
        d: "M513 149.3V192H183.7v150H141V192H0v-42.7h141V0h42.7v149.3z"
    }));
};
var $b832709c107c9253$export$b0bfe88d8be86eef = function FR(_ref77) {
    var title = _ref77.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref77, $b832709c107c9253$var$_excluded77);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#00318A",
        d: "M0 0h171v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M342 0h171v342H342z"
    }));
};
var $b832709c107c9253$export$2c816677949efbbf = function GA(_ref78) {
    var title = _ref78.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref78, $b832709c107c9253$var$_excluded78);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 228h513v114H0z"
    }));
};
var $b832709c107c9253$export$5c1daad85ece4f0d = function GB(_ref79) {
    var title = _ref79.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref79, $b832709c107c9253$var$_excluded79);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v341.3H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M311.7 230 513 341.3v-31.5L369.3 230h-57.6zM200.3 111.3 0 0v31.5l143.7 79.8h56.6z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M393.8 230 513 295.7V230H393.8zm-82.1 0L513 341.3v-31.5L369.3 230h-57.6zm146.9 111.3-147-81.7v81.7h147zM90.3 230 0 280.2V230h90.3zm110 14.2v97.2H25.5l174.8-97.2zm-82.1-132.9L0 45.6v65.7h118.2zm82.1 0L0 0v31.5l143.7 79.8h56.6zM53.4 0l147 81.7V0h-147zm368.3 111.3L513 61.1v50.2h-91.3zm-110-14.2V0h174.9L311.7 97.1z",
        fill: "#0052B4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M288 0h-64v138.7H0v64h224v138.7h64V202.7h224v-64H288V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M311.7 230 513 341.3v-31.5L369.3 230h-57.6zm-168 0L0 309.9v31.5L200.3 230h-56.6zm56.6-118.7L0 0v31.5l143.7 79.8h56.6zm168 0L513 31.5V0L311.7 111.3h56.6z"
    })));
};
var $b832709c107c9253$export$44132903afebf574 = function GD(_ref80) {
    var title = _ref80.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref80, $b832709c107c9253$var$_excluded80);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#c60a0a",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#3E8446",
        d: "m256.5 170.7-212 126.1V44.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m256.5 170.7 211 126.1h-423zm211-126.2-211 126.2-212-126.2z",
        fill: "#FFDA44"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#3E8446",
        d: "M467.5 44.5v252.3l-211-126.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m256.5 10.4 2.8 10.2H270l-8.6 6.3 3.3 10.2-8.2-6.3-9.2 6.3 3.3-10.2-8.6-6.3h10.7zm-86.4 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm-85.4 293.8 2.8 10.2H270l-8.6 6.3 3.3 10.2-8.2-6.3-9.2 6.3 3.3-10.2-8.6-6.3h10.7zm-86.4 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7z",
        fill: "#FFDA44"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#c60a0a",
        cx: 244.5,
        cy: 170.7,
        r: 76.2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m244.5 110.1 13.6 41.8h44l-35.6 25.8 13.6 41.8-35.6-25.8-35.5 25.8 13.6-41.8-35.6-25.8h44zm-136.8 57.7c4.4 6.9 2.3 16.1-4.6 20.5s-16.1 2.3-20.5-4.6c-7.9-12.5-3.3-33-3.3-33s20.4 4.6 28.4 17.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#A2001D",
        cx: 99.1,
        cy: 182.1,
        r: 7.4
    }));
};
var $b832709c107c9253$export$64f1adb8dced2c27 = function GE(_ref81) {
    var title = _ref81.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref81, $b832709c107c9253$var$_excluded81);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 22.5 15"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M.8 0h21v15H.8V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#eb000e",
        d: "M9.8 6H0v3h9.8v6h3V9h9.8V6h-9.8V0h-3v6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#eb000e",
        d: "m17.3 2.7-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm-12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm0 9-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2z"
    }));
};
var $b832709c107c9253$export$a1c692af90f0ad93 = function GF(_ref82) {
    var title = _ref82.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref82, $b832709c107c9253$var$_excluded82);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 90 60"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FDEB01",
        d: "m0 0 90 60H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#58A846",
        d: "M90 0v60L0 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ED3D24",
        d: "m50.7 33.3 9.3-6.7H48.5L45 15.7l-3.5 10.9H30l9.3 6.7-3.6 11 9.3-6.7 9.3 6.7z"
    }));
};
var $b832709c107c9253$export$ffd553dab4f92f72 = function GG(_ref83) {
    var title = _ref83.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref83, $b832709c107c9253$var$_excluded83);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M308 0H204v118.7H0v104h204V342h104V222.7h205v-104H308z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m368.6 188 26 17.3V136l-26 17.3h-95.3V58.1l17.3-26h-69.2l17.3 26v95.2h-95.3l-26-17.3v69.3l26-17.3h95.3v95.2l-17.3 26h69.2l-17.3-26V188z"
    }));
};
var $b832709c107c9253$export$2063236980199869 = function GH(_ref84) {
    var title = _ref84.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref84, $b832709c107c9253$var$_excluded84);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#496E2D",
        d: "M0 228h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m255.9 113.8 14.1 43.4 40.4 3.2-37 26.9 19.5 40.3-37-26.9-37 26.9 14.1-43.5-36.9-26.9h45.7z"
    }));
};
var $b832709c107c9253$export$b3b059666b470a4 = function GI(_ref85) {
    var title = _ref85.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref85, $b832709c107c9253$var$_excluded85);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 230h513v112H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        stroke: "#000",
        strokeMiterlimit: 10,
        d: "M363.1 131.8V99.1H374V77.3h-21.9v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7h-21.8V55.5h10.9V33.7h-21.8v10.9h-10.9V33.7H254v10.9h-10.9V33.7h-21.8v21.8h10.9v76.3h-21.8V99.1h10.9V77.3h-21.8v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7H145V219h239.9v-87.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        stroke: "#000",
        strokeMiterlimit: 10,
        d: "m264.9 235.5-24.2 18.2 19.1 14.3v31.3h-23.2v9h23v7.9h-23v9.3H270V268l19.1-14.3-24.2-18.2zm0 25.3-10.1-7.1 10.1-7.1 10.1 7.1-10.1 7.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M239.6 209.7v-27.9s.1-22.3 25-22.3c24.8 0 25.7 22 25.7 22v28.2h-50.7zm-69.1 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M169.1 209.7v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm151.8 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm8.4-77.7v-15.7s.1-12.1 11.3-12.1c11.3 0 11.7 11.9 11.7 11.9V132h-23zm-78.8 0v-23.7s.1-18.3 14.3-18.3c14.2 0 14.7 18 14.7 18v24h-29zm-73 0v-15.7s.1-12.1 11.3-12.1 11.7 11.9 11.7 11.9V132h-23z"
    }));
};
var $b832709c107c9253$export$bad2a840ccda93b6 = function GL(_ref86) {
    var title = _ref86.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref86, $b832709c107c9253$var$_excluded86);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M513 0v171H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFF",
        cx: 185.8,
        cy: 171.2,
        r: 117.8
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M68 171c0-65.1 52.8-117.8 117.8-117.8 65.1 0 117.8 52.8 117.8 117.8"
    }));
};
var $b832709c107c9253$export$af02b8e3ecf08df4 = function GM(_ref87) {
    var title = _ref87.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref87, $b832709c107c9253$var$_excluded87);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#cf0d19",
        d: "M0 0h513v100H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 121h513v100H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#1a7e25",
        d: "M0 242h513v100H0z"
    }));
};
var $b832709c107c9253$export$49b768d2cda4fc68 = function GN(_ref88) {
    var title = _ref88.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref88, $b832709c107c9253$var$_excluded88);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h512v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M342 0h171v342H342z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h171v342H0z"
    }));
};
var $b832709c107c9253$export$a1e9daa76fd80d91 = function GP(_ref89) {
    var title = _ref89.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref89, $b832709c107c9253$var$_excluded89);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#00318A",
        d: "M0 0h171v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M342 0h171v342H342z"
    }));
};
var $b832709c107c9253$export$64532cc081f88b3a = function GQ(_ref90) {
    var title = _ref90.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref90, $b832709c107c9253$var$_excluded90);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 0h513v113.8H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 227.6h513V342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0070C8",
        d: "M126 171 0 342V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeMiterlimit: 10,
        d: "M233.8 139.4v40.4c0 35.6 35.6 35.6 35.6 35.6s35.6 0 35.6-35.6v-40.4h-71.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#786145",
        d: "M264.5 179.8h9.8l4 25.8h-17.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M287.2 162c0-9.8-8-14.8-17.8-14.8s-17.8 5-17.8 14.8c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9h35.6c4.9 0 8.9-4 8.9-8.9s-4-8.9-8.9-8.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m230.7 120 1.9 3.3h3.8l-1.9 3.3 1.9 3.2h-3.8l-1.9 3.3-1.9-3.3H225l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.8 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H279l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm16 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H295l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm15 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2H310l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8z",
        fill: "#FFDA00",
        stroke: "#000",
        strokeMiterlimit: 10
    }));
};
var $b832709c107c9253$export$be3bb2d6fb94aa6 = function GR(_ref91) {
    var title = _ref91.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref91, $b832709c107c9253$var$_excluded91);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#0d5eaf"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h190v190H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 76h190v38H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M76 0h38v190H76z"
    })));
};
var $b832709c107c9253$export$f7fbe7cb90eabcb4 = function GS(_ref92) {
    var title = _ref92.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref92, $b832709c107c9253$var$_excluded92);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2E52B2",
        d: "M256 22.7v30.7h-46.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        fill: "#FFF",
        cx: 443.4,
        cy: 233.6,
        rx: 29,
        ry: 43.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        fill: "#FFCE00",
        cx: 406.9,
        cy: 317.7,
        rx: 22,
        ry: 9.3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        fill: "#FFCE00",
        cx: 364,
        cy: 317.7,
        rx: 22,
        ry: 9.3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#39B200",
        d: "m342 190.1 43.4 86.9 43.5-86.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        fill: "#9B9B9B",
        cx: 327.5,
        cy: 233.6,
        rx: 29,
        ry: 43.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#757575",
        d: "m371 175.6-14.5 14.5h57.9l-14.5-14.5 14.5-43.5s-13-29-29-29-29 29-29 29l14.6 43.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#C6B56F",
        cx: 385.4,
        cy: 67,
        r: 29
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#A54A00",
        cx: 386,
        cy: 88.7,
        r: 29
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFF",
        cx: 443.4,
        cy: 117.7,
        r: 29
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#0049FF",
        cx: 342.2,
        cy: 146.7,
        r: 29
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#0041F9",
        cx: 429.8,
        cy: 146.7,
        r: 29
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#F7D71E",
        cx: 386,
        cy: 233.6,
        r: 29
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#CEC851",
        cx: 457.9,
        cy: 190.1,
        r: 29
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFF",
        cx: 385.4,
        cy: 289.5,
        r: 29
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#7C0B29",
        d: "m371 135.7 14.5-3.5 14.5 3.5c0 7.5-14.5 11-14.5 11s-14.5-3.5-14.5-11z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFF",
        cx: 327.5,
        cy: 117.4,
        r: 29
    }));
};
var $b832709c107c9253$export$b023c82b48e70453 = function GT(_ref93) {
    var title = _ref93.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref93, $b832709c107c9253$var$_excluded93);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h171v342H0zm342 0h171v342H342z",
        fill: "#338AF3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#DCC26D",
        cx: 256,
        cy: 155.8,
        r: 25.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#628A40",
        d: "M194.2 155.9c0 22.1 11.8 42.5 30.8 53.5 5.9 3.4 13.5 1.4 16.9-4.5 3.4-5.9 1.4-13.5-4.5-16.9-11.5-6.6-18.5-18.9-18.5-32.1 0-6.8-5.5-12.4-12.4-12.4s-12.3 5.5-12.3 12.4zm95.1 52.1c17.8-11.4 28.6-31 28.5-52.1 0-6.8-5.5-12.4-12.4-12.4-6.8 0-12.4 5.5-12.4 12.4 0 12.7-6.5 24.5-17.1 31.3-5.8 3.6-7.7 11.2-4.1 17 3.6 5.8 11.2 7.7 17 4.1.2-.1.3-.2.5-.3z"
    }));
};
var $b832709c107c9253$export$875a05f1afdc3a63 = function GU(_ref94) {
    var title = _ref94.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref94, $b832709c107c9253$var$_excluded94);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M11.1 11.1h489.7v319.1H11.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#7DBEF1",
        d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#1C8AE6",
        d: "M179.8 180.7h152.6l-29.3 64.9h-95.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF042",
        d: "M192.3 205.9s40.5 38.2 51 38.2c12.4 0 12.6-18.4 25.5-25.5 20.2-11.1 51-12.7 51-12.7L297 248.7l-41 36.6-46.8-39.7-16.9-39.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#259C7B",
        d: "m256 157.5-22.5 15.6 7.9-26.2-21.8-16.5 27.4-.5 9-25.9 9 25.9 27.4.5-21.8 16.6 7.9 26.2-22.5-15.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#8E5715",
        d: "M249.7 144.6c-.9 9.2-1.5 18.4-1.7 27.6-.3 11.9.3 20.7 2 26 2.2 6.6 7.2 12.9 14.2 18.9 5.3 4.6 10.6 8.1 14.2 10.1 3.1 1.7 7 .6 8.7-2.4 1.7-3.1.6-7-2.4-8.7-4.3-2.5-8.4-5.4-12.2-8.7-5.4-4.6-9.1-9.2-10.4-13.3-1.1-3.4-1.6-11.3-1.4-21.7.2-8.9.8-17.8 1.7-26.6.4-3.5-2.2-6.6-5.7-7-3.6-.3-6.7 2.3-7 5.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m217.8 170.7 25.5 38.2h-25.5v-38.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "none",
        stroke: "#D80027",
        strokeWidth: 12,
        strokeMiterlimit: 10,
        d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
    }));
};
var $b832709c107c9253$export$4f7b2a18b14c6e6 = function GW(_ref95) {
    var title = _ref95.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref95, $b832709c107c9253$var$_excluded95);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 0h512v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h512v171H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h182v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m98.3 109.8 15.1 46.5h48.9L122.8 185l15.1 46.5-39.6-28.7-39.5 28.7L73.9 185l-39.6-28.7h48.9z"
    }));
};
var $b832709c107c9253$export$f433acc20da515b9 = function GY(_ref96) {
    var title = _ref96.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref96, $b832709c107c9253$var$_excluded96);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 900 600"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#009E49",
        d: "M0 0h900v600H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m0 0 947 300L0 600V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFD00D",
        d: "M0 26.1 870 300 0 573.9V26.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2D2D2D",
        d: "m0 0 450 300L0 600V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D3132F",
        d: "m0 35 397.5 265L0 565V35z"
    }));
};
var $b832709c107c9253$export$7bf8e436292b0d9 = function HK(_ref97) {
    var title = _ref97.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref97, $b832709c107c9253$var$_excluded97);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        viewBox: "0 0.5 21 14",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h21v15H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ee1c25",
        d: "M0 0h21v15H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M12 7.19c-.798-.5-1 .409-1 0 0-.828.895-1.5 2-1.5s2 .672 2 1.5c-.949 0-1.044.5-1.5.5-.56 0-.702 0-1.5-.5zM13.25 7a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5zm-1.81 1.962c.228-.913-.698-.824-.31-.95.788-.257 1.703.387 2.045 1.438.341 1.05-.021 2.11-.809 2.366-.293-.903-.798-.838-.939-1.272-.173-.533-.217-.668.012-1.582zm.566 1.13a.25.25 0 1 0 .476-.154.25.25 0 0 0-.476.154zM9.58 8.977c.94-.065.57-.919.81-.588.486.67.157 1.74-.737 2.389-.894.65-2.013.632-2.5-.038.768-.558.55-1.018.92-1.286.453-.33.568-.413 1.507-.477zm-.899.888a.25.25 0 1 0 .294.405.25.25 0 0 0-.294-.405zm.312-2.652c.351.874 1.049.258.809.588-.487.67-1.606.687-2.5.038-.894-.65-1.223-1.719-.736-2.39.767.559 1.138.21 1.507.478.453.33.568.413.92 1.286zm-1.124-.58a.25.25 0 1 0-.293.404.25.25 0 0 0 .293-.404zm2.619-.524c-.722.605.08 1.078-.309.951-.788-.256-1.15-1.315-.809-2.365.342-1.05 1.257-1.695 2.045-1.439-.293.903.153 1.147.012 1.581-.173.533-.217.668-.939 1.272zm.205-1.247a.25.25 0 1 0-.475-.155.25.25 0 0 0 .475.155z",
        fill: "#FFF"
    })));
};
var $b832709c107c9253$export$e8ae668e70e7a813 = function HM(_ref98) {
    var title = _ref98.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref98, $b832709c107c9253$var$_excluded98);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M223.4 170.7c.3-.3.5-.6.8-.9-.3.3-.5.6-.8.9zm-34.2 41.9 11 22.9 24.7-5.7-11.1 22.8 19.9 15.8L209 274v25.4l-19.8-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.9-2.6 9.5-7.5-5.3-10.9 11.9 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6v-12.1l-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9 11.9 2.7zm42.4 49.7 5.3 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.5-7.6-9.4 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-30.3 57.9 4.1 12.7h13.3l-10.8 7.8 4.1 12.6-10.7-7.8-10.8 7.8 4.1-12.6-10.7-7.8h13.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M155.8 115 256 170.7v-15.8L184.2 115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M155.8 115 256 170.7v-15.8L184.2 115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z",
        fill: "#D80027"
    }));
};
var $b832709c107c9253$export$d654914ee99e1b51 = function HN(_ref99) {
    var title = _ref99.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref99, $b832709c107c9253$var$_excluded99);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v114H0zm0 228h513v114H0zm203.5-110.1 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zM256 147.6l6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm-52.5 29.7 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1z",
        fill: "#338AF3"
    }));
};
var $b832709c107c9253$export$41dbabafe943a3bc = function HR(_ref100) {
    var title = _ref100.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref100, $b832709c107c9253$var$_excluded100);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 228h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M309.3 113.2v-44l17.5-14.4 17.7 14.4v44zm-105.6 0v-44l-17.3-14.4-17.9 14.4v44zm35.2 0v-44l17.6-14.4 17.6 14.4v44z",
        fill: "#338AF3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M309.3 113.2h-35.2v-44l17.5-14.4 17.7 14.4zm-70.4 0h-35.2v-44l17.5-14.4 17.7 14.4z",
        fill: "#0052B4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        stroke: "#D80027",
        fill: "#FFF",
        d: "M168.5 113.2v101.9c0 24.3 14.4 46.2 35.4 59.4 21.3 13.4 42.1 14.7 52.6 14.7s31.4-1.7 52.6-14.8c21-13 35.4-35.1 35.4-59.3V113.2h-176z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M168.5 113.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm35.2 35.2h35.2V254h-35.2zm35.2-35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-35.2 35.2h35.2V254h-35.2zm35.2 55.5c8.6-5.4 16.2-12.3 22-20.3h-22v20.3zM181.7 254c5.8 8 13.3 14.9 22 20.4V254h-22zm57.2 0v33.7c7.2 1.2 13.3 1.5 17.6 1.5 4.3 0 10.4-.3 17.6-1.6V254h-35.2z",
        fill: "#D80027"
    }));
};
var $b832709c107c9253$export$3927bce5ead7457e = function HT(_ref101) {
    var title = _ref101.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref101, $b832709c107c9253$var$_excluded101);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#A2001D",
        d: "M0 0h513v172H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 172h513v172H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m381.4 251.5-110.7-13.8-110.8 13.8V85.4h221.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#0052B4",
        cx: 270.7,
        cy: 182.3,
        r: 55.4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#A2001D",
        cx: 270.7,
        cy: 182.3,
        r: 27.7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M229.1 113.1h83.1l-41.5 41.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M256.8 140.8h27.7v83h-27.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M314.9 215.5h-88.5l-66.5 36h221.5z"
    }));
};
var $b832709c107c9253$export$2cba20fb7b4c6fda = function HU(_ref102) {
    var title = _ref102.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref102, $b832709c107c9253$var$_excluded102);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 228h513v114H0z"
    }));
};
var $b832709c107c9253$export$520d469a2f25f64a = function IC(_ref103) {
    var title = _ref103.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref103, $b832709c107c9253$var$_excluded103);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 300 200"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#fc0",
        d: "M0 0h300v200H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0768a9",
        d: "M0 0h200v200H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#fff",
        d: "M0 0h100v200H0z"
    }));
};
var $b832709c107c9253$export$8be180ec26319f9f = function ID(_ref104) {
    var title = _ref104.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref104, $b832709c107c9253$var$_excluded104);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#E00",
        d: "M0 0h513v171H0z"
    }));
};
var $b832709c107c9253$export$5056f4df3c1a040a = function IE(_ref105) {
    var title = _ref105.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref105, $b832709c107c9253$var$_excluded105);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 0h171v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FF9811",
        d: "M342 0h171v342H342z"
    }));
};
var $b832709c107c9253$export$747f5b589ac90db = function IL(_ref106) {
    var title = _ref106.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref106, $b832709c107c9253$var$_excluded106);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M340.6 122.4h-56.1l-28-48.6-28 48.6h-56.1l28 48.6-28 48.6h56.1l28 48.6 28-48.6h56.1l-28-48.6 28-48.6zM293.2 171 276 204.2h-38.9L219.8 171l17.2-33.2h38.9l17.3 33.2zm-36.7-71.8 11.9 23.3h-23.9l12-23.3zm-58.3 38.6h23.9l-10.8 21-13.1-21zm0 66.4 13-22.1 11.9 22.1h-24.9zm58.3 37.5-11.9-22.1h23.9l-12 22.1zm59.4-37.5h-25l11.9-22.1 13.1 22.1zm-26.1-66.4h26.1l-13 22.1-13.1-22.1zM0 21.3h512V64H0zm0 256h512V320H0z",
        fill: "#2E52B2"
    }));
};
var $b832709c107c9253$export$5e0fd3f816252990 = function IM(_ref107) {
    var title = _ref107.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref107, $b832709c107c9253$var$_excluded107);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#E52D42",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M393.3 68.2h-45.8l-33.8 80.2-34.4-22.9s-24.7-59.1-34.4-68.2c-9.7-9.7-18.7-.6-48.9 7.8-29.6 8.4-30.8 18.7-42.2 18.7-4.8 0-19.9-17.5-27.7-22.3-12.1-7.8-16.9-4.2-13.9 7.2 1.2 4.8 10.9 10.9 16.9 19.9 7.8 11.5 12.7 25.9 12.7 25.9s10.9-10.3 16.9-12.1c9-2.4 19.3 1.8 31.4 0 15.1-2.4 31.4-10.9 31.4-10.9l4.2 43.4s-54.3 50.7-49.5 70.6 56.1 44.6 68.2 62.7c12.1 17.5-7.2 24.1-7.2 32.6s-1.8 19.9 7.2 16.3c9-3.6 10.3-18.1 18.7-31.4 6-9 10.3-13.9 11.5-17.5 1.8-9-23.5-32-37.4-48.9-6.6-7.8-19.9-18.7-19.9-18.7l39.2-29.6s67.6 27.7 82.6 18.7c15.1-9 19.3-98.3 19.3-98.3l47-11.5-12.1-11.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#F8DD4E",
        d: "M279.3 262.4c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.8-182.8c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm0 91.1c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6 0 11.5 4.8 11.5 11.5-.6 6.7-5.5 11.5-11.5 11.5zm-136.9 45.8c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.2-136.9c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-4.8 11.5-11.5 11.5zm22.9 91.1c-6 0-11.5-10.3-11.5-22.9s4.8-22.9 11.5-22.9c6 0 11.5 10.3 11.5 22.9s-4.8 22.9-11.5 22.9zm-114-45.2c-6 0-11.5-4.8-11.5-11.5 0-6.6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5 0 6.6-4.8 11.5-11.5 11.5z"
    }));
};
var $b832709c107c9253$export$70824c8942178d60 = function IN(_ref108) {
    var title = _ref108.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref108, $b832709c107c9253$var$_excluded108);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#F93",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#fff",
        d: "M0 114h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#138808",
        d: "M0 228h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 256.5,
        cy: 171,
        r: 34.2,
        stroke: "navy",
        strokeWidth: 4,
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 256.5,
        cy: 171,
        r: 3.42,
        fill: "navy"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m265.3 138.159-17.6 65.682m17.6-65.682-17.6 65.682m25.8-62.286-34 58.89m41.042-53.487-48.084 48.084M285.945 154l-58.89 34m62.286-25.8-65.682 17.6M290.5 171h-68m66.841 8.8-65.682-17.6m62.286 25.8-58.89-34m53.487 41.042-48.084-48.084m41.042 53.487-34-58.89m25.8 62.286-17.6-65.682M256.5 205v-68m-8.8 66.841 17.6-65.682m-25.8 62.286 34-58.89m-41.042 53.487 48.084-48.084M227.055 188l58.89-34m-62.286 25.8 65.682-17.6M222.5 171h68m-66.841-8.8 65.682 17.6M227.055 154l58.89 34m-53.487-41.042 48.084 48.084M239.5 141.555l34 58.89m-25.8-62.286 17.6 65.682",
        stroke: "navy",
        strokeWidth: 2
    }));
};
var $b832709c107c9253$export$8f8422ac5947a789 = function IO(_ref109) {
    var title = _ref109.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref109, $b832709c107c9253$var$_excluded109);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0-.3h513V342H0V-.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M462.9 198.1c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zM0 31.7l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 1-20 6-30.1 12-7 4-16 9-20 9s-14-5-21-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-11-30.1-12v22zm462.9 55.2c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 3.9-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 1 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-8 19-9v-23zm-50.1 133.3c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 0 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-9 19-9v-23z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0-.3h256v171H0V-.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M389.8 119.9H408v78.8h-18.3l.1-78.8zm0 117.8H408v75.1h-18.3l.1-75.1z",
        fill: "#A2001D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M144-.3h-32v70H0v32h112v69h32v-69h112v-32H144v-70z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0-.3v15l57 39h23L0-.3zm256 0v15l-57 39h-23l80-54z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0-.3v15l57 39h23L0-.3zm256 0v15l-57 39h-23l80-54zM0 170.7v-15l57-38h23l-80 53zm256 0v-15l-57-38h-23l80 53z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#2E52B2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zm160 23v31h-46l46-31zm-96-23v49l73-49h-73z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zm160 23v31h-46l46-31zm-96-23v49l73-49h-73zM0 147.7v-30h46l-46 30zm96 23v-49l-73 49h73zm160-23v-30h-46l46 30zm-96 23v-49l73 49h-73z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#5DA51E",
        stroke: "#45602C",
        strokeWidth: 4,
        strokeMiterlimit: 10,
        d: "M462.8 91.5h-29.1l25.7-25.7c4.5-4.4 4.5-11.4 0-15.8l-3.4-3.4c-4.4-4.4-11.4-4.4-15.8 0l-25.9 25.9V37.4c0-6.2-5.1-11.3-11.3-11.3h-4.7c-6.2 0-11.3 5.1-11.3 11.3v31.7l-23.5-23.8c-4.7-4.7-12.2-4.7-16.9 0l-3.6 3.6c-4.7 4.7-4.7 12.4 0 17.2l25 25.4h-30.6c-6 0-10.9 4.9-10.9 10.9v4.6c0 6 4.9 10.9 10.9 10.9H369l-20.7 20.7c-4.4 4.4-4.4 11.4 0 15.8l3.4 3.4c4.4 4.4 11.4 4.4 15.8 0l19.6-19.6V167c0 6.1 5.1 11.1 11.3 11.3h4.7c6.2 0 11.3-5.1 11.3-11.3v-28.3l22.2 22.6c4.7 4.7 12.4 4.7 17.1 0l3.6-3.6c4.7-4.7 4.7-12.4 0-17.2L435.2 118h27.6c5.9 0 10.7-4.9 10.9-10.9v-4.6c0-6.1-4.9-11-10.9-11z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#E2DD24",
        stroke: "#525625",
        strokeWidth: 4,
        strokeMiterlimit: 10,
        d: "M439.2 249.1h-79.8s-.9-13.4-6-21.8c-6.2-10.4-13.9-28.1-1.4-36.7 15.9-10.9 33.7.8 48.2.8 11.8.1 26.9-14 45-.8 12.2 8.9 3.9 28.2-1.3 36.7-7 11.5-4.7 21.8-4.7 21.8z"
    }));
};
var $b832709c107c9253$export$776a9becd139230f = function IQ(_ref110) {
    var title = _ref110.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref110, $b832709c107c9253$var$_excluded110);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#CE1126",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 228h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M219.2 160.7h-29.3c1.5-5.7 6.6-9.9 12.8-9.9v-19.9c-18.3 0-33.1 14.9-33.1 33.1v16.5h49.6c1.8 0 3.3 1.5 3.3 3.3v6.6h-66.2v19.9h86.1v-26.5c0-12.7-10.4-23.1-23.2-23.1zm49.6 29.8v-59.6H249v79.5h33.1v-19.9zm66.2 0v-59.6h-19.8v59.6h-6.6v-19.8h-19.9v39.7h59.6v-19.9z",
        fill: "#547C31"
    }));
};
var $b832709c107c9253$export$35f3e3f7e3ce71e0 = function IR(_ref111) {
    var title = _ref111.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref111, $b832709c107c9253$var$_excluded111);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h512v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 227.9h513v114H0zm278.8-93.1c.1 2 8.7 26.2 4.4 39.4-6.6 20.3-15.8 21.8-19.8 24.5V134l-6.9-4.2-6.9 4.2v64.7c-4-2.7-12.4-2.4-19.8-24.5-4.3-12.7 5.7-37.3 5.8-39.2 0 0-9.5 8.1-15.8 24-5.9 14.8 1.9 49.6 29.5 54.8 2.3.4 4.7 5.6 7.2 5.6 2.1 0 4.1-5.2 6-5.5 28.4-4.6 35-41.7 29.9-55.6-5.4-14.6-13.6-23.5-13.6-23.5z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M44.6 98.9h22.3v24.4H44.6zM0 98.9h22.3v24.4H0zm89.2 0h22.3v24.4H89.2zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4H223zm44.7 0H290v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0H513v24.4h-22.3zm-446.1 118h22.3v25.5H44.6zm-44.6 0h22.3v25.5H0zm89.2 0h22.3v25.5H89.2zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5H223zm44.7 0H290v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0H513v25.5h-22.3z",
        fill: "#FFF",
        opacity: 0.5
    }));
};
var $b832709c107c9253$export$bfe27467c1de9413 = function IS(_ref112) {
    var title = _ref112.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref112, $b832709c107c9253$var$_excluded112);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M513 210.6H202.2v130.7h-79.8V210.6H0v-79.8h122.4V0h79.8v130.8H513v18.5l-1 42.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M513 149.3V192H183.7v149.3H141V192H0v-42.7h141V0h42.7v149.3z"
    }));
};
var $b832709c107c9253$export$c8c4756768edc1be = function IT(_ref113) {
    var title = _ref113.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref113, $b832709c107c9253$var$_excluded113);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#F4F5F0",
        d: "M342 0H0v341.3h512V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#008C45",
        d: "M0 0h171v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#CD212A",
        d: "M342 0h171v342H342z"
    }));
};
var $b832709c107c9253$export$7300d7e65520d9c0 = function JE(_ref114) {
    var title = _ref114.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref114, $b832709c107c9253$var$_excluded114);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M301.8 171 513 30.2V0h-45.3L256.5 140.8 45.3 0H0v30.2L211.2 171 0 311.8V342h45.3l211.2-140.8L467.7 342H513v-30.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m233.7 44.6 22.3 5.6 22.3-5.6 4-20.9-14.9 6.5L256 14.8l-11.4 15.4-14.9-6.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M233.7 44.6s-4 12.9-4 29.9c0 27.9 26.3 41.3 26.3 41.3s26.3-15.5 26.3-41.3c0-15.4-4-29.9-4-29.9s-8.1-5-22.3-5-22.3 5-22.3 5z"
    }));
};
var $b832709c107c9253$export$62925b2b1d8826f = function JM(_ref115) {
    var title = _ref115.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref115, $b832709c107c9253$var$_excluded115);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M215.9 171 0 314.6V26.8zM513 26.8v287.8L296.1 171z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M513 26.8 296.1 171 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4L215.9 171 0 26.8V0h40.1L256 143.9 471.9 0H513z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M513 26.8 296.1 171 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4L215.9 171 0 26.8V0h40.1L256 143.9 471.9 0H513z"
    }));
};
var $b832709c107c9253$export$4ff8ba3b6e78910e = function JO(_ref116) {
    var title = _ref116.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref116, $b832709c107c9253$var$_excluded116);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 228h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M256.5 170.7 0 341.3V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m77.9 139.5 7.9 16.4 17.8-4.1-8 16.5 14.3 11.3-17.8 4 .1 18.3-14.3-11.5-14.2 11.5v-18.3l-17.8-4 14.3-11.3-7.9-16.5 17.7 4.1z"
    }));
};
var $b832709c107c9253$export$4165087edc6149ea = function JP(_ref117) {
    var title = _ref117.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref117, $b832709c107c9253$var$_excluded117);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h512v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#D80027",
        cx: 256.5,
        cy: 171,
        r: 96
    }));
};
var $b832709c107c9253$export$ebf06250eda1662e = function KE(_ref118) {
    var title = _ref118.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref118, $b832709c107c9253$var$_excluded118);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h512v90.579H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#496E2D",
        d: "M0 251h513v91H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#A2001D",
        d: "M0 114h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m323.3 54.5-25.6-11.8L256 137l-41.7-94.3-25.6 11.8 51.8 116.2-51.8 116.2 25.6 11.8 41.7-94.4 41.7 94.4 25.6-11.8-51.8-116.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M273.4 65.6c-9.9-10.8-17.4-17-17.4-17s-7.5 6.2-17.4 17v210.1c9.9 10.8 17.4 17 17.4 17s7.5-6.2 17.4-17V65.6z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M209 105.9v129.5c10.5 18.5 23.3 33.7 32.9 43.8V62.1c-9.6 10.1-22.4 25.3-32.9 43.8zm94 0c-10.5-18.5-23.3-33.7-32.9-43.8v217.2c9.6-10.1 22.4-25.3 32.9-43.8V105.9z",
        fill: "#A2001D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M303 105.9v129.5c10.6-18.8 18.8-41 18.8-64.8s-8.2-45.9-18.8-64.7zm-94 0v129.5c-10.6-18.8-18.8-41-18.8-64.8s8.2-45.9 18.8-64.7z"
    }));
};
var $b832709c107c9253$export$32f37961c13d8178 = function KG(_ref119) {
    var title = _ref119.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref119, $b832709c107c9253$var$_excluded119);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 256,
        cy: 170.7,
        r: 170.7
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M382.4 170.7 330.8 195l27.5 50-56.1-10.7-7.1 56.6-39.1-41.7-39.1 41.7-7.1-56.6-56.1 10.7 27.5-50-51.6-24.3 51.6-24.3-27.5-50.1 56.1 10.8 7.1-56.7L256 92.1l39.1-41.7 7.1 56.7 56.1-10.8-27.5 50.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#D80027",
        cx: 257.4,
        cy: 170.7,
        r: 71.6
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M214.2 170.7c-2.1 0-4.1.1-6.2.3.1 12 4.4 22.9 11.6 31.5 3.8-10.3 9.5-19.6 16.7-27.7-6.9-2.7-14.3-4.1-22.1-4.1zm26.6 46.5c5.2 1.9 10.8 2.9 16.6 2.9 5.8 0 11.4-1 16.6-2.9-2.8-11.1-8.7-21-16.6-28.8-7.9 7.8-13.8 17.7-16.6 28.8zm59.4-71.2c-8.5-14.8-24.5-24.7-42.8-24.7-18.3 0-34.2 9.9-42.8 24.7 15.6.1 30.2 4.3 42.8 11.6 12.6-7.3 27.2-11.6 42.8-11.6zm-21.7 28.8c7.2 8 12.9 17.4 16.7 27.7 7.2-8.5 11.5-19.5 11.6-31.5-2-.2-4.1-.3-6.2-.3-7.7 0-15.2 1.4-22.1 4.1z",
        fill: "#FFDA44"
    }));
};
var $b832709c107c9253$export$96381358fb12b492 = function KH(_ref120) {
    var title = _ref120.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref120, $b832709c107c9253$var$_excluded120);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v114H0zm0 228h513v114H0z",
        fill: "#0052B4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M303.5 196.6v-17.8h-11.9v-23.7l-11.9-11.9-11.8 11.9v-23.8L256 119.5l-11.9 11.8v23.8l-11.8-11.9-11.9 11.9v23.7h-11.9v17.8h-11.9v17.8h118.8v-17.8z"
    }));
};
var $b832709c107c9253$export$8aa7bcd4299a59b9 = function KI(_ref121) {
    var title = _ref121.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref121, $b832709c107c9253$var$_excluded121);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 450 300"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#CE1126",
        d: "M0 0h450v300H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FCD116"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 227.6,
        cy: 161.2,
        r: 56.2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m254.1 73.4-23.7 26 28.6 6.5zm-51.5.2-4.8 33.1 28.5-8zm94.3 26.7-34.7 8.5 20.1 23.7zm-138.3-1.8 15.5 32.7 20.2-22.7zm159 45.3-34.4-9.9 5.6 29.5zm-182-2.6 31.9 19.8 5.2-27.7z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#003F87",
        d: "M0 175h450v125H0V175z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 267c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FCD116",
        d: "m183.2 48.3-1.1-5.3 22.4-3.7s-30.1-7.1-40-10.7c-14.3-5.1-16.3-12.1-16.3-12.1s44.7 11 64.8 11c4.3 0 12.8 10.7 12.8 10.7s14.8-14.9 21.9-15.4c32.1-2.3 66.6-6.4 66.6-6.4s-10 6.7-16 8.5c-16.2 4.9-50.6 11.7-50.6 11.7l-4.8 7.5H277l-14.4 4.3 7.4 6.9s-7.8-4.1-18.1-2.1c-7.1 1.3-15.4 6-22.9 8-18.7 4.8-29.9-12.8-29.9-12.8l-15.9-.1z"
    }));
};
var $b832709c107c9253$export$7ca86d88f982585b = function KM(_ref122) {
    var title = _ref122.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref122, $b832709c107c9253$var$_excluded122);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h513v85.5H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.5h513V171H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 171h513v85.5H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M256.5 171 0 342V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M68.6 170.7c0-24.9 17.5-45.6 40.8-50.7-3.6-.8-7.3-1.2-11.1-1.2-28.7 0-51.9 23.3-51.9 51.9s23.3 51.9 51.9 51.9c3.8 0 7.5-.4 11.1-1.2-23.3-5.1-40.8-25.9-40.8-50.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m108.9 126.1 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.2-7.3 5.2 2.8-8.5-7.2-5.3h8.9zm0 22.3 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.3-7.3 5.3 2.8-8.5-7.2-5.3h8.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m108.9 170.7 2.7 8.5h9l-7.3 5.2 2.8 8.5-7.2-5.2-7.3 5.2 2.8-8.5-7.2-5.2h8.9zm0 22.2 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.3-7.3 5.3 2.8-8.5-7.2-5.3h8.9z"
    })));
};
var $b832709c107c9253$export$fd8f06eb7ce62883 = function KN(_ref123) {
    var title = _ref123.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref123, $b832709c107c9253$var$_excluded123);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M512 0H0v342"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M307.7 0 0 194.5V342h206.9L513 148.5V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M513 0H385.2L0 249.4V341l126.2 1L513 91.6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m141.1 187 31.2 24 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.3-22.2zM310.6 70.8l31.2 23.9 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.4-22.2z",
        fill: "#FFF"
    }));
};
var $b832709c107c9253$export$171643e72dc5e91 = function KP(_ref124) {
    var title = _ref124.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref124, $b832709c107c9253$var$_excluded124);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#91DC5A",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v57.188H0zm0 284.1h513v57.177H0z",
        fill: "#0052B4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 79.9h513v181.582H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFF",
        cx: 190.33,
        cy: 171,
        r: 65.668
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "m190.3 105 14.8 45.3h47.7l-38.6 28.1 14.8 45.5-38.7-28.2-38.6 28.1 14.8-45.4-38.6-28.1h47.7z"
    }));
};
var $b832709c107c9253$export$ced591d2396bbc3f = function KR(_ref125) {
    var title = _ref125.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref125, $b832709c107c9253$var$_excluded125);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 900 600"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h900v600H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        transform: "rotate(-56.31)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M-75 228.3H75m-150 37.5H75m-150 37.5H75m-150 475H75m-150 37.5H75m-150 37.5H75",
        stroke: "#000",
        strokeWidth: 25
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        stroke: "#FFF",
        strokeWidth: 12.5,
        d: "M0 753.3v125"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#ca163a",
        cy: 540.8,
        r: 150
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0e4896",
        d: "M0 390.8c-41.4 0-75 33.6-75 75s33.6 75 75 75 75 33.6 75 75-33.6 75-75 75c-82.8 0-150-67.2-150-150s67.2-150 150-150z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m231.56 535.73-83.205-124.808M262.76 514.928l-83.205-124.807m114.407 104.006-83.205-124.808m478.43-138.675-83.205-124.807M720.39 209.843 637.184 85.036m114.407 104.006L668.386 64.234",
        stroke: "#000",
        strokeWidth: 25
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        stroke: "#FFF",
        strokeWidth: 12.5,
        d: "m205.6 462.897 31.202-20.8m389.981-259.989 36.444-24.296m31.202-20.801 31.202-20.801"
    }));
};
var $b832709c107c9253$export$867391011d376267 = function KW(_ref126) {
    var title = _ref126.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref126, $b832709c107c9253$var$_excluded126);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 228h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M167 227.6 0 341.3V0l167 113.8z"
    }));
};
var $b832709c107c9253$export$ea257f329676e0aa = function KY(_ref127) {
    var title = _ref127.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref127, $b832709c107c9253$var$_excluded127);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#6DA544",
        cx: 384,
        cy: 96.5,
        r: 29.7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M332.1 89H436v44.5H332.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#496E2D",
        d: "M435.9 170.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M332.1 200.3V230h15.6c9.4 9.2 22.2 14.8 36.3 14.8 14.1 0 27-5.7 36.3-14.8h15.6v-29.7H332.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M332.1 126.1v44.5c0 39.8 51.9 51.9 51.9 51.9s51.9-12.2 51.9-51.9v-44.5H332.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M384 149.9c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9v20.8c13 0 13 11.9 26 11.9s13-11.9 26-11.9 13 11.9 26 11.9 13-11.9 26-11.9v-20.8c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9zm0-41.6c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9v20.8c13 0 13 11.9 26 11.9s13-11.9 26-11.9 13 11.9 26 11.9 13-11.9 26-11.9v-20.8c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9z",
        fill: "#F3F3F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256 0v22.6l-46.1 30.7H256v64h-46.1L256 148v22.7h-22.6l-73.4-49v49H96v-49l-73.4 49H0V148l46.1-30.7H0v-64h46.1L0 22.6V0h22.6L96 48.9V0h64v48.9L233.4 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176zM0 170.7v-15.1l57.4-38.3H80zm256 0v-15.1l-57.4-38.3H176z"
    })));
};
var $b832709c107c9253$export$45edc2c6b51c02b3 = function KZ(_ref128) {
    var title = _ref128.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref128, $b832709c107c9253$var$_excluded128);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#36B6CC",
        d: "M0 0h513v342H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFD400",
        cx: 256.5,
        cy: 170.9,
        r: 68.4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFD400",
        d: "m256.5 251.5-27.9 41.7-7.1-49.7-43.2 25.5 15.2-47.8-50 4.2 34.4-36.5-46.9-18 46.8-18-34.4-36.5 50 4.2-15.2-47.8 43.2 25.4 7.1-49.7 27.9 41.7 27.9-41.7 7.1 49.7 43.2-25.4-15.2 47.8 50-4.2-34.3 36.6 46.8 17.9-46.8 18 34.4 36.5-50-4.2 15.2 47.8-43.2-25.4-7.1 49.7c0-.1-27.9-41.8-27.9-41.8zm0-.8c44.1 0 79.9-35.8 79.9-79.9S300.6 91 256.5 91s-79.9 35.8-79.9 79.9 35.8 79.8 79.9 79.8zM22.8 28.3c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V28.3zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V74zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm22.8-22.8c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7V245c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V188zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V96.8zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V51.2z"
    }));
};
var $b832709c107c9253$export$64f943d6c6d62030 = function LA(_ref129) {
    var title = _ref129.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref129, $b832709c107c9253$var$_excluded129);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 .1h513v90.7H0zm0 251.2h513V342H0z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFF",
        cx: 256.5,
        cy: 171,
        r: 65.9
    }));
};
var $b832709c107c9253$export$1dd3e96947fb44fc = function LB(_ref130) {
    var title = _ref130.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref130, $b832709c107c9253$var$_excluded130);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 .2h513v90.7H0zm.5 251.1H513V342H.5z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M290.3 193.5 256 130.7l-34.3 62.8h25.7v17.2h17.2v-17.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#14AF5A",
        d: "M241.3 213.1c4.4-4.4 4.4-11.6-.1-16l4.7 4.7c-5.2-4.7-12.2-6.6-19.1-5.3l-23.5 5.9c-6.1 1.5-6.8-.4-1.8-4.2l27.1-20.3c5.1-3.8 4.2-6.9-2.3-6.9h-11c-6.4 0-7-2.3-1.5-5.1l25.3-12.7c5.6-2.8 5.1-5.1-1.5-5.1h-11c-6.4 0-7.4-3.1-2.3-6.9l27.1-20.3c5.6-3.8 12.9-3.8 18.5 0l27.1 20.3c5.1 3.8 4.2 6.9-2.3 6.9h-11c-6.4 0-7 2.3-1.5 5.1l25.3 12.7c5.6 2.8 5.1 5.1-1.5 5.1h-11c-6.4 0-7.4 3.1-2.3 6.9l27.1 20.3c5.1 3.8 4.4 5.7-1.8 4.2l-23.5-5.9c-6.8-1.3-13.9.6-19.1 5.3l4.7-4.7c-4.4 4.4-4.5 11.5-.1 16l6.8 6.8c4.4 4.4 3.1 8-3.3 8h-45.8c-6.2 0-7.7-3.6-3.3-8 .1.1 6.9-6.8 6.9-6.8z"
    }));
};
var $b832709c107c9253$export$3cb73e0e841fe17f = function LC(_ref131) {
    var title = _ref131.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref131, $b832709c107c9253$var$_excluded131);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#55B2FF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#F3F3F3",
        d: "M148.5 298.1h216l-108-254.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#333",
        d: "m186 272.7 70.5-160.3L327 272.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M148.5 298.1h216l-108-101.7z"
    }));
};
var $b832709c107c9253$export$2e3013aac067a692 = function LI(_ref132) {
    var title = _ref132.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref132, $b832709c107c9253$var$_excluded132);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v171H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M149.3 98.1c0-14-11.3-25.3-25.3-25.3-6.5 0-12.4 2.4-16.9 6.4V64.4h8.4V47.5h-8.4v-8.4H90.3v8.4h-8.4v16.9h8.4v14.9c-4.5-4-10.4-6.4-16.9-6.4-14 0-25.3 11.3-25.3 25.3 0 7.5 3.3 14.2 8.4 18.8v14.9h84.3V117c5.3-4.7 8.5-11.5 8.5-18.9z"
    }));
};
var $b832709c107c9253$export$782aca1f2c103f6b = function LK(_ref133) {
    var title = _ref133.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref133, $b832709c107c9253$var$_excluded133);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#A2001D",
        d: "M222.6 22.3h267.1v296.8H222.6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M22.3 22.3h200.3v296.8H22.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M200.3 0h22.3v342h-22.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M22.3 22.3h89v296.8h-89z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FF9811",
        d: "M111.3 22.3h89v296.8h-89z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M368.2 156.8c-1.4-2 0-37.9 0-37.9.9-7.4.1-8.4 1-11.4.9-2.9 5.4-11.6 5.4-11.6s-6-2.3-10.3-.6c-4.3 1.7-24.7-7.5-31.2 3.4-4.4 7-23.6 16.2-24.6 14-1-2.2-5.9-5-6.9-2.9s-.7 13.9 0 16c.8 2.6 9.8 2 12.3 3.1 3.7 1.8 12.2 8.2 11.9 10.7-.3 2.5-22.5-6-24.2-4.5-1.4 1.2-1.9 13.2-.4 15 1.8 2.1 23.4 5.6 25 7.5 1.6 1.9-13.1 7.4-12.3 25 .7 14.7 8 17.4 8 17.4s-2.4 3.6-7.8 3.1c-6.2-.6-27.4-17.7-27.4-17.7s-3.5-109 3.6-121.4c4.9-8.5-22.7 10.1-22.7 50.8V151c0 6.6-1.4 22.4 2.6 34 0 0-.4 46.9 1.5 49.6s12.7 2.2 14.8 0 0-30 0-30c7.7.2 18.3 17.5 32.5 16.4 20.6-1.6 28.7-9.9 34.3-5 8.1 7.1 5.5 23.2.4 31.5-2.2 3.5-14.3 4.7-15.7 7.6-1.4 2.9.5 5.4.5 5.4h29.7s1.4-20.5 2.7-26.1c1.3-5.7-.6-10.7 5.9-10.4 23.5 1.1 39.8-15.3 45.5-8 3.2 4.1 5.6 29.9 3.3 33.3-2.2 3.4-13.8 2.8-15.2 6.7-1.4 4 .8 4.4.8 4.4h29.7s-.4-21.2 2.5-27.7 4.9-10.4 9.3-17.2c4.4-6.8 11.3-15.7 11.3-36.2 0-14.2-8.1-22.8-8.1-22.8H417c-14.1.2-47.4 2.3-48.8.3zm-136-124.5c10.7-10.6 20.2-2.7 22.2 2.1 1.9 4.8 2.1 8.2 2.8 13.6.9 6.9 4.9 14 4.9 14s-7.1-3.8-14.7-4.2c-4.7-.3-9-.6-13.6-2.5-5.7-2.3-11.7-12.9-1.6-23zm248.4-.1c10.7 10.6 2.8 20.2-2 22.2s-8.2 2.1-13.6 2.8c-6.9.9-14 5-14 5s3.7-7.1 4.2-14.7c.3-4.7.6-9.1 2.4-13.6 2.2-5.7 12.8-11.8 23-1.7zm.1 276.9c-10.7 10.6-20.2 2.6-22.2-2.2-1.9-4.8-2.1-8.2-2.7-13.6-.8-6.9-4.9-14.1-4.9-14.1s7 3.8 14.7 4.3c4.7.3 9 .6 13.6 2.5 5.7 2.4 11.7 13.1 1.5 23.1zm-248.2-.1c-10.6-10.7-2.7-20.2 2.1-22.2 4.8-1.9 8.2-2.1 13.6-2.8 6.9-.9 14-4.9 14-4.9s-3.8 7.1-4.2 14.7c-.3 4.7-.6 9-2.5 13.6-2.3 5.7-12.9 11.8-23 1.6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "none",
        stroke: "#FFDA44",
        strokeWidth: 6,
        strokeMiterlimit: 10,
        d: "M446.9 162.4s7.5-2.6 8.4-16.1c.6-8.6-19.8-16-39-11.5-19.7 4.6-34-3.1-34-14.6 0-22.9 29.7-16.2 38.9-11.3 9.1 4.9 29.7 23.5 35.1 9.4"
    }));
};
var $b832709c107c9253$export$9e0d336de5ae0eb3 = function LR(_ref134) {
    var title = _ref134.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref134, $b832709c107c9253$var$_excluded134);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v31.1H0zm0 62.2h513v31.1H0zm0 62.3h513v31.1H0zm0 62.3h513v31.1H0zm0 62.5h513v31.1H0zm0 61.6h513V342H0z",
        fill: "#bf0a30"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#002868",
        d: "M0 0h155.6v155.6H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m77.8 30.2 10.7 32.9h34.6l-28 20.4 10.7 32.9-28-20.3-28 20.3 10.7-32.9-28-20.4h34.6z"
    }));
};
var $b832709c107c9253$export$c6944423ed371873 = function LS(_ref135) {
    var title = _ref135.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref135, $b832709c107c9253$var$_excluded135);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 227.6h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m245.2 171 7.7-23.1c2-5.9 5.1-6 7.1 0l7.7 23.1 19.4 29.1c1.7 2.6 1.3 6.3-1.2 8 0 0-6.9 8-29.5 8s-29.5-8-29.5-8c-2.4-2-2.9-5.4-1.2-8l19.5-29.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M256.5 171c-12.5 0-22.6-10.1-22.6-22.6 0-12.5 10.1-22.6 22.6-22.6s22.6 10.1 22.6 22.6c0 12.5-10.2 22.6-22.6 22.6zm0 0c6.2 0 11.3-16.3 11.3-22.6 0-6.2-5.1-11.3-11.3-11.3-6.2 0-11.3 5.1-11.3 11.3 0 6.3 5 22.6 11.3 22.6z"
    }));
};
var $b832709c107c9253$export$7158f0ceb70f54c7 = function LT(_ref136) {
    var title = _ref136.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref136, $b832709c107c9253$var$_excluded136);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 228h513v114H0z"
    }));
};
var $b832709c107c9253$export$b6a2dd8a7c2d6cd5 = function LU(_ref137) {
    var title = _ref137.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref137, $b832709c107c9253$var$_excluded137);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M0 228h513v114H0z"
    }));
};
var $b832709c107c9253$export$feea9fafc15a0118 = function LV(_ref138) {
    var title = _ref138.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref138, $b832709c107c9253$var$_excluded138);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        className: "prefix__st1",
        d: "M0 0h513v127.6H0zm0 214.4h513V342H0z",
        fill: "#A2001D"
    }));
};
var $b832709c107c9253$export$4eb7334fca20385f = function LY(_ref139) {
    var title = _ref139.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref139, $b832709c107c9253$var$_excluded139);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#496E2D",
        d: "M0 228h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m281.4 150.7 9 12.3 14.5-4.7-9 12.4 9 12.3-14.5-4.7-9 12.3v-15.2l-14.5-4.7 14.5-4.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M257 201.5c-17 0-30.9-13.8-30.9-30.9s13.8-30.9 30.9-30.9c5.3 0 10.3 1.3 14.7 3.7-6.9-6.7-16.2-10.8-26.6-10.8-21 0-38 17-38 38s17 38 38 38c10.3 0 19.7-4.1 26.6-10.8-4.4 2.4-9.4 3.7-14.7 3.7z"
    })));
};
var $b832709c107c9253$export$d88940c21edc1e8e = function MA(_ref140) {
    var title = _ref140.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref140, $b832709c107c9253$var$_excluded140);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 .3V342h513V.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#20661B",
        d: "M359.8 148.9h-73.3l-22.7-69.7-22.7 69.7h-73.3l59.3 43.1-22.7 69.7 59.3-43.1 59.3 43.1-22.5-69.7 59.3-43.1zm-116.1 37.7 7.7-23.6h24.8l7.7 23.6-20.1 14.6-20.1-14.6zm27.9-37.7H256l7.8-24 7.8 24zm24.3 29-4.8-14.9h25.3l-20.5 14.9zM236.6 163l-4.8 14.9-20.5-14.9h25.3zm-5.3 61.8 7.8-24 12.6 9.2-20.4 14.8zm44.5-14.9 12.6-9.2 7.8 24-20.4-14.8z"
    }));
};
var $b832709c107c9253$export$cd68417dc2ec295d = function MC(_ref141) {
    var title = _ref141.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref141, $b832709c107c9253$var$_excluded141);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.333h512v341.333H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#c70000",
        d: "M0 85.333h512V256H0z"
    }));
};
var $b832709c107c9253$export$3c37c3bdb860ae1e = function MD(_ref142) {
    var title = _ref142.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref142, $b832709c107c9253$var$_excluded142);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M342 0h171v342H342z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h171v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#AF7F59",
        d: "M206.2 129.1h33.2L256 79.3l16.6 49.8h33.2v99.6L256 262l-49.8-33.2v-99.7zm33.2 33.3v49.8h33.2v-49.8h-33.2z"
    }));
};
var $b832709c107c9253$export$4898541b722d275d = function ME(_ref143) {
    var title = _ref143.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref143, $b832709c107c9253$var$_excluded143);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#E6BE53",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#E01D24",
        d: "M20 20h473v302H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#E6BE53",
        d: "M248.5 112.9c4.4 4.4 11.6 4.4 16 0l-4.7 4.7 22.7-22.7c4.9-4.5 12.1-5.6 18.2-2.8l2.1 1c5.7 2.9 6.7 8.7 2.3 13.1l4.7-4.7-22.8 22.8c-4.5 4.9-5.6 12.1-2.8 18.2l1 2.1c2.9 5.7 5.1 15.4 5.1 21.6v-11.3c0 6.2 4.4 9.1 10.2 6.2l2.1-1c5.7-2.9 6.7-8.7 2.3-13.1l4.7 4.7c-4.4-4.4-4.4-11.6 0-16l-4.7 4.7c5.2-5.5 9.6-11.6 13.1-18.2l1-2.1c2.9-5.7 6.3-15.1 7.9-21.2l5.8-23.3c1.5-6 5.9-6.8 9.6-1.8l20.2 26.9c3.8 5.1 6.9 14 6.9 20.6v22.4c0 6.3-2.2 15.8-5.1 21.7l-1 2.1c-3.5 6.6-7.9 12.7-13.1 18.2l-6.8 6.8c-5.4 5.2-11.5 9.6-18.2 13.1l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.2 0-6.9 2.2-1.1 5.1l2.1 1c5.7 2.9 13.8 8.7 18.2 13.1l-4.7-4.7c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L339 226c4.6 4.9 5.7 12.1 2.9 18.2l-1 2.1c-2.9 5.7-10.4 10.2-16.4 10.2-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.5-3.6-11.8-8.9-15.4-15.4l-1-2.1c-2.9-5.7-8.7-6.7-13.1-2.3l4.7-4.7c-4.4 4.7-5.2 11.8-1.8 17.3l10.3 15.4c3.4 5.1 2 12.1-3.1 15.5L266 284.4c-5.7 3.4-12.8 3.4-18.6 0L232 274.1c-5.1-3.4-6.5-10.3-3.1-15.5l10.3-15.4c3.4-5.5 2.6-12.6-1.8-17.3l4.7 4.7c-4.4-4.4-10.2-3.6-13.1 2.3l-1 2.1c-2.9 5.7-9.5 12.4-15.4 15.4l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.9-.3-13.1-4.2-16.4-10.2l-1-2.1c-2.8-6.1-1.6-13.3 2.9-18.2l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L181 226c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c5.5-5.2 11.6-9.6 18.2-13.1l2.1-1c5.7-2.9 5-5.1-1.1-5.1-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.6-3.5-12.7-7.9-18.2-13.1l-6.8-6.8c-5.2-5.4-9.6-11.5-13.1-18.2l-1-2.1c-3.1-6.8-4.9-14.2-5.1-21.7V121c0-6.3 3.1-15.6 6.9-20.6l20.2-26.9c3.8-5.1 8.1-4.3 9.6 1.8l5.8 23.3c2 7.3 4.6 14.4 7.9 21.2l1 2.1c2.9 5.7 8.7 13.8 13.1 18.2l-4.7-4.7c4.4 4.4 4.4 11.6 0 16l4.7-4.7c-4.4 4.4-3.6 10.2 2.3 13.1l2.1 1c5.7 2.9 10.2 0 10.2-6.2v11.3c0-6.2 2.2-15.7 5.1-21.6l1-2.1c2.8-6.1 1.7-13.2-2.8-18.2l-22.7-22.7 4.7 4.7c-4.4-4.4-3.6-10.2 2.3-13.1l2.1-1c6.1-2.8 13.2-1.7 18.2 2.8l22.7 22.7-4.8-4.5zm-18-40.7c-4.4-4.4-3.2-9.5 2.8-11.5l12.4-4.2c6-2 15.5-2 21.5 0l12.4 4.2c6 2 7.2 7.1 2.8 11.5l-6.8 6.8c-5.3 4.7-12.1 7.5-19.2 7.9-6.2 0-14.8-3.5-19.2-7.9.1 0-6.7-6.8-6.7-6.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#215F90",
        d: "M233.9 200.2c0 6.2 1.7 6.4 4.2.5 0 0 7.1-23.2 18.4-23.2 11.3 0 18.6 23.6 18.6 23.6 2.2 5.7 4 5.3 4-1.1v-11.2c0-18.7-10.1-33.9-22.6-33.9-12.5 0-22.6 15.2-22.6 33.9v11.4z"
    }));
};
var $b832709c107c9253$export$33916af50bbab5f5 = function MF(_ref144) {
    var title = _ref144.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref144, $b832709c107c9253$var$_excluded144);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 108 72"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h108v72H0z",
        fill: "#003787"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h108L60 48v24H48V48z",
        fill: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 54,
        cy: 30,
        r: 8,
        fill: "#f9d90f"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M44 30h20L54 48z",
        fill: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M54 48 38 33h32z",
        fill: "#cf142b"
    }));
};
var $b832709c107c9253$export$d7c1ae0cf4ef5274 = function MG(_ref145) {
    var title = _ref145.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref145, $b832709c107c9253$var$_excluded145);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M512 426.666V85.329H0v341.337h512z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M512 85.331H0v170.666h512V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.334h181.793v341.337H0z"
    }));
};
var $b832709c107c9253$export$61a81a4b59098e0c = function MH(_ref146) {
    var title = _ref146.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref146, $b832709c107c9253$var$_excluded146);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#1E509C",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M513 176.1V81.3L0 342l513-165.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#F18D36",
        d: "M513 0v81.3L0 342 513 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m126.7 99.3-7.8-54.1-7.7 54.1-20.8-23.7 10.7 31.6-31.5-10.7 23.6 20.8-54.1 7.7 54.1 7.7-23.6 20.8 31.5-10.7-10.7 31.6 20.8-23.7 7.7 54.1 7.8-54.1 20.7 23.7-10.6-31.6 31.5 10.7-23.6-20.8 54-7.7-54-7.7 23.6-20.8-31.5 10.7 10.6-31.6z"
    }));
};
var $b832709c107c9253$export$9391ff7d7f7d79ce = function MK(_ref147) {
    var title = _ref147.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref147, $b832709c107c9253$var$_excluded147);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.333h512V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M383.875 426.662 256 252.286l26.827 174.376zM133.565 85.33 256 252.286 230.314 85.33zm95.606 341.332L256 252.286 128.124 426.662zM0 85.33V212.9l256 39.386L28.333 85.33zm0 341.332h18.212L256 252.286 0 291.67zm256-174.376L512 212.9V85.33h-28.331zM281.686 85.33 256 252.286 378.434 85.33zM512 426.662V291.671l-256-39.385 237.787 174.376z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 256,
        cy: 252.29,
        r: 59.359
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFDA44",
        cx: 256,
        cy: 252.29,
        r: 44.522
    }));
};
var $b832709c107c9253$export$670dad092b145ea = function ML(_ref148) {
    var title = _ref148.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref148, $b832709c107c9253$var$_excluded148);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 85.331h170.663v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M341.337 85.331H512v341.337H341.337z"
    }));
};
var $b832709c107c9253$export$eefdfd8a735ff143 = function MM(_ref149) {
    var title = _ref149.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref149, $b832709c107c9253$var$_excluded149);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M384 227.261h-97.783L256 134.265l-30.217 92.997H128l79.108 57.475-30.217 92.998L256 320.925l79.108 56.81-30.217-92.998L384 227.261z"
    }));
};
var $b832709c107c9253$export$30e7c6589c527eef = function MN(_ref150) {
    var title = _ref150.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref150, $b832709c107c9253$var$_excluded150);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#095FAD",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M342 0h171v342H342zM0 0h171v342H0z",
        fill: "#BE1229"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFDA44"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M108.3 166.3h14.8v74.2h-14.8zm-59.4 0h14.8v74.2H48.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 86,
        cy: 203.4,
        r: 14.8
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M71.2 225.7h29.7v14.8H71.2zm0-59.4h29.7v14.8H71.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 86,
        cy: 144,
        r: 14.8
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M76.3 123.9h19.5L86 108.3z"
    })));
};
var $b832709c107c9253$export$511fbc18fa6ca984 = function MO(_ref151) {
    var title = _ref151.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref151, $b832709c107c9253$var$_excluded151);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#00745a",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M285.682 248.878c-4.19 0-8.166.836-11.861 2.164 2.023-4.509 3.379-9.527 3.379-14.885 0-21.201-21.201-37.101-21.201-37.101s-21.201 15.901-21.201 37.101c0 5.357 1.356 10.375 3.379 14.885-3.693-1.328-7.671-2.164-11.861-2.164-21.201 0-37.101 21.201-37.101 21.201s15.901 21.201 37.101 21.201c12.429 0 23.031-7.286 29.682-13.315 6.65 6.03 17.251 13.315 29.682 13.315 21.201 0 37.101-21.201 37.101-21.201s-15.899-21.201-37.099-21.201z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m256 152.111 4.38 13.476h14.171l-11.464 8.332 4.376 13.476-11.463-8.33-11.463 8.33 4.376-13.476-11.464-8.332h14.171zm-53.888 23.572 8.425 7.585 9.818-5.667-4.61 10.355 8.423 7.588-11.274-1.185-4.611 10.355-2.358-11.088-11.275-1.185 9.818-5.669zm-39.45 39.449 11.09 2.358 5.668-9.818 1.186 11.274 11.089 2.358-10.357 4.61 1.186 11.274-7.587-8.423-10.357 4.61 5.669-9.818zm147.227-39.449-8.425 7.585-9.818-5.667 4.611 10.355-8.425 7.588 11.275-1.185 4.61 10.355 2.359-11.088 11.275-1.185-9.818-5.669zm39.449 39.449-11.089 2.358-5.669-9.818-1.186 11.274-11.088 2.358 10.357 4.61-1.185 11.274 7.586-8.423 10.357 4.61-5.669-9.818z",
        fill: "#FFDA44"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M256 350.642c16.84 0 32.363-5.619 44.816-15.073h-89.63c12.451 9.454 27.974 15.073 44.814 15.073zm-68.023-44.522a74.138 74.138 0 0 0 8.85 15.073h118.345a74.13 74.13 0 0 0 8.85-15.073H187.977z",
        fill: "#FFF"
    }));
};
var $b832709c107c9253$export$15b7d6cdd29b06a0 = function MP(_ref152) {
    var title = _ref152.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref152, $b832709c107c9253$var$_excluded152);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 750 500"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0071BC",
        d: "M0 0h750v500H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF",
        stroke: "#000",
        strokeWidth: 1.9
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 375,
        cy: 245,
        r: 225,
        fill: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 375,
        cy: 245,
        r: 165,
        fill: "#0071BC"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        stroke: "#000"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#8C8A8C",
        strokeWidth: 1.9,
        d: "M444.7 450c.7 11-7.8 20-18.8 20H323.6c-11 0-19.5-9-19-20l16.7-325c.6-11 10-20 21-20h61.4c11 0 20.5 9 21.2 20l19.8 325z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        strokeWidth: 2,
        strokeLinejoin: "round",
        d: "m373 114 30 93h97l-78 56 29 92-78-56-78 57 30-93-79-57h97l30-92z"
    })));
};
var $b832709c107c9253$export$451b471c9c9066b = function MQ(_ref153) {
    var title = _ref153.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref153, $b832709c107c9253$var$_excluded153);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        viewBox: "0 0 900 600",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#231f1e",
        d: "M0 0h900v600H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#00a650",
        d: "M0 0h900v300H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ef1923",
        d: "m0 0 450 300L0 600z"
    }));
};
var $b832709c107c9253$export$c4e38e98e3fb5f60 = function MR(_ref154) {
    var title = _ref154.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref154, $b832709c107c9253$var$_excluded154);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 100 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#006233",
        d: "M0 100h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#cd2a3e",
        d: "M0 100h513v46H0zm0 296h513v46H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ffc400",
        d: "M256 298.851c-45.956 0-84.348-32.298-93.767-75.429A96.288 96.288 0 0 0 160 243.994c0 53.02 42.979 96 96 96s96-42.98 96-96c0-7.066-.785-13.942-2.233-20.572-9.419 43.131-47.811 75.429-93.767 75.429z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ffc400",
        d: "m255.999 171.994 8.935 27.502h28.918l-23.394 16.996 8.936 27.503-23.395-16.998-23.394 16.998 8.937-27.503-23.394-16.996h28.915z"
    }));
};
var $b832709c107c9253$export$71ad59f2e432cfe8 = function MS(_ref155) {
    var title = _ref155.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref155, $b832709c107c9253$var$_excluded155);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#1B4991",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#00A2B8",
        stroke: "#FFF",
        strokeWidth: 3,
        d: "M318.2 106.7v106.5c0 51.9 67.8 67.8 67.8 67.8s67.8-15.9 67.8-67.8V106.7H318.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#A35023",
        d: "M319.7 212.7c0 50.8 66.3 66.3 66.3 66.3s66.3-15.6 66.3-66.3H319.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M415.1 155.1h-19.4v-19.4h-19.4v19.4H357v19.4h19.3v58.1h19.4v-58.1h19.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M155.8 115 256 170.7v-15.8L184.2 115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M155.8 115 256 170.7v-15.8L184.2 115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z"
    }));
};
var $b832709c107c9253$export$b900a375df2ae552 = function MT(_ref156) {
    var title = _ref156.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref156, $b832709c107c9253$var$_excluded156);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#C31B28",
        d: "M256 0h256.5v342H256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ACABB1",
        stroke: "#C31B28",
        strokeWidth: 2,
        d: "M101.2 68.2V33H66v35.2H30.8v35.2H66v35.2h35.2v-35.2h35.2V68.2z"
    }));
};
var $b832709c107c9253$export$c5764e4399dad848 = function MU(_ref157) {
    var title = _ref157.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref157, $b832709c107c9253$var$_excluded157);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#f7ce00",
        d: "M0 85.331h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#e32737",
        d: "M0 85.331h512v85.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#191f6a",
        d: "M0 170.657h512v85.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#00a04e",
        d: "M0 341.331h512v85.337H0z"
    }));
};
var $b832709c107c9253$export$20138591ba7d4d60 = function MV(_ref158) {
    var title = _ref158.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref158, $b832709c107c9253$var$_excluded158);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#d01920",
        d: "M0 85.331h512v341.333H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#017c3b",
        d: "M144.696 174.375h222.609v163.25H144.696z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M283.484 304.226c-26.637 0-48.232-21.594-48.232-48.232s21.594-48.232 48.232-48.232c8.306 0 16.12 2.1 22.943 5.797-10.703-10.467-25.341-16.927-41.494-16.927-32.784 0-59.362 26.577-59.362 59.362s26.578 59.362 59.362 59.362c16.154 0 30.791-6.461 41.494-16.927-6.822 3.698-14.636 5.797-22.943 5.797z"
    }));
};
var $b832709c107c9253$export$a3772f6eb527275b = function MW(_ref159) {
    var title = _ref159.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref159, $b832709c107c9253$var$_excluded159);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#272727",
        d: "M0 0h512v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#e40112",
        d: "M0 114h512v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#07893f",
        d: "M0 228h512v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#e40112",
        cx: 256,
        cy: 125,
        r: 95
    }));
};
var $b832709c107c9253$export$80b36494c451f15f = function MX(_ref160) {
    var title = _ref160.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref160, $b832709c107c9253$var$_excluded160);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#dc2339",
        d: "M342 0H0v341.3h513V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#11865d",
        d: "M0 0h171v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M171 0h171v342H171z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#8C9157",
        d: "M195.8 171.2c0 21.6 11.5 41.7 30.3 52.5 5.8 3.4 13.2 1.4 16.6-4.4 3.4-5.8 1.4-13.2-4.4-16.6-11.3-6.5-18.2-18.5-18.2-31.5 0-6.7-5.4-12.1-12.1-12.1-6.7 0-12.2 5.4-12.2 12.1zm93.4 51.1c17.5-11.1 28-30.4 28-51.1 0-6.7-5.4-12.1-12.1-12.1s-12.1 5.4-12.1 12.1c0 12.4-6.3 24-16.8 30.7-5.7 3.5-7.5 10.9-4.1 16.7s10.9 7.5 16.7 4.1c0-.2.2-.3.4-.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        fill: "#C59262",
        cx: 256.5,
        cy: 159.1,
        rx: 24.3,
        ry: 36.4
    }));
};
var $b832709c107c9253$export$655dc88003efaac0 = function MY(_ref161) {
    var title = _ref161.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref161, $b832709c107c9253$var$_excluded161);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0zm0 48.9h513V171H0zm0 48.8h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0z",
        fill: "#c00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#006",
        d: "M0 0h256.5v195.4H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M153.3 42.1C122.6 30.7 88.5 46.3 77.1 77s4.2 64.8 34.9 76.2c13.3 5 28 5 41.4 0-30.7 24.5-75.4 19.6-100-11.1s-19.6-75.4 11.1-100c26-20.7 62.9-20.7 88.8 0zm26.7 75-20.6 23.3 5.4-30.6-31-1.6 27.3-14.9L143 68l28.6 12 8.4-29.9 8.4 29.9L217 68l-18 25.4 27.3 14.9-31 1.6 5.4 30.6-20.7-23.4z",
        fill: "#fc0"
    }));
};
var $b832709c107c9253$export$b5030f3cedb7f384 = function MZ(_ref162) {
    var title = _ref162.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref162, $b832709c107c9253$var$_excluded162);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.333h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#f4d900",
        d: "M0 323.333h513v104H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#006d66",
        d: "M0 85.333h513v104H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 204.333h513v104H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#cb0f31",
        d: "M256 256.006 0 426.668V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#f4d900",
        d: "m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
    }));
};
var $b832709c107c9253$export$dbd1925f4fe9ec65 = function NA(_ref163) {
    var title = _ref163.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref163, $b832709c107c9253$var$_excluded163);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#496E2D",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 426.663V85.337h512"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#A2001D",
        d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m187.737 189.212-22.741 10.696 12.11 22.024-24.693-4.724-3.129 24.945-17.199-18.347-17.2 18.347-3.129-24.945-24.693 4.723 12.109-22.023-22.739-10.696 22.74-10.697-12.11-22.022 24.693 4.722 3.13-24.944 17.199 18.347 17.2-18.347 3.128 24.944 24.693-4.722-12.108 22.024z"
    }));
};
var $b832709c107c9253$export$fbcebdb931d67ac9 = function NC(_ref164) {
    var title = _ref164.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref164, $b832709c107c9253$var$_excluded164);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 640 426.7"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#009543",
        d: "M0 293h640v133.7H0V293z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ED4135",
        d: "M0 132h640v161.3H0V132z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0035AD",
        d: "M0 0h640v133.3H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FAE600",
        stroke: "#000",
        strokeWidth: 5.3,
        cx: 240,
        cy: 213.3,
        r: 157.3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m307.9 354.5-31.8 12-36.1 4.2-37.8-2.4-35.9-15.5s28.6-29.3 40.7-33.5c8.6-3 22.4-3.7 22.4-3.7V122l-.3-66H246l-.5 67.5v191.7s15.3 1.2 22.1 4.1c11.3 4.9 40.3 35.2 40.3 35.2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m212.727 102.375 42.955-21.418 5.577 11.187-42.955 21.417z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        cx: 237.8,
        cy: 280.5,
        rx: 16.8,
        ry: 26.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 237.4,
        cy: 143.4,
        r: 20.9
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        cx: 238.4,
        cy: 211.1,
        rx: 19.9,
        ry: 12.1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M213.8 177h47v10h-47zm0 57h47v10h-47z"
    }));
};
var $b832709c107c9253$export$8719acbfb72c829 = function NE(_ref165) {
    var title = _ref165.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref165, $b832709c107c9253$var$_excluded165);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#e05206",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0db02b",
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#e05206",
        cx: 256,
        cy: 256,
        r: 32
    }));
};
var $b832709c107c9253$export$ebe65a9e9fde641f = function NF(_ref166) {
    var title = _ref166.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref166, $b832709c107c9253$var$_excluded166);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.5 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.5h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.5h171v342H0zm342 0h171v342H342zm-38 226.495-48-152.001-48 152.001h36v39.999h24v-39.999z",
        fill: "#007b23"
    }));
};
var $b832709c107c9253$export$d9501190a8cd7a46 = function NG(_ref167) {
    var title = _ref167.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref167, $b832709c107c9253$var$_excluded167);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.5 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.5h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.5h171v342H0zm342 0h171v342H342z",
        fill: "#007b23"
    }));
};
var $b832709c107c9253$export$2128ddd8b6e5cc05 = function NI(_ref168) {
    var title = _ref168.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref168, $b832709c107c9253$var$_excluded168);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
        fill: "#338AF3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M256 214.447c-22.949 0-41.553 18.603-41.553 41.553S233.05 297.553 256 297.553c22.949 0 41.553-18.603 41.553-41.553S278.949 214.447 256 214.447zm0 65.298c-13.114 0-23.745-10.631-23.745-23.745s10.631-23.745 23.745-23.745 23.745 10.631 23.745 23.745-10.631 23.745-23.745 23.745z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M276.563 261.936 256 256l-20.563 5.936-6.855 11.873h54.836z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "m256 226.32-13.709 23.744L256 256l13.709-5.936z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M235.437 261.936h41.126l-6.854-11.872h-27.418z"
    }));
};
var $b832709c107c9253$export$e51d3c675bb0140d = function NL(_ref169) {
    var title = _ref169.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref169, $b832709c107c9253$var$_excluded169);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 114h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#cd1f2a",
        d: "M0 0h513v114H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#1d4185",
        d: "M0 228h513v114H0z"
    }));
};
var $b832709c107c9253$export$c01351c0af048e39 = function NO(_ref170) {
    var title = _ref170.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref170, $b832709c107c9253$var$_excluded170);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.334h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2E52B2",
        d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
    }));
};
var $b832709c107c9253$export$575bf2af220888ee = function NP(_ref171) {
    var title = _ref171.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref171, $b832709c107c9253$var$_excluded171);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 426.663V85.337l280.419 174.75H87.61l183.576 166.576z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M244.769 249.888 10.199 103.71v312.754h234.57L61.193 249.888z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m98.003 324.433-14.589-6.863 7.77-14.13-15.844 3.03-2.008-16.005-11.035 11.772-11.036-11.772-2.008 16.005-15.843-3.031 7.77 14.131-14.591 6.863 14.591 6.862-7.77 14.13 15.844-3.029 2.007 16.004 11.036-11.772L73.332 358.4l2.008-16.004 15.843 3.03-7.769-14.13zm-9.735-132.771-10.612-4.991 5.651-10.278-11.523 2.205-1.461-11.641-8.026 8.561-8.026-8.561-1.46 11.641-11.525-2.205 5.652 10.278-10.613 4.991 25.972 5.194z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M93.462 191.662c0 17.212-13.953 31.165-31.165 31.165s-31.165-13.953-31.165-31.165"
    })));
};
var $b832709c107c9253$export$8885480fb36cb8cc = function NR(_ref172) {
    var title = _ref172.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref172, $b832709c107c9253$var$_excluded172);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 239.994h512v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m174.802 341.329-19.124 8.996 10.184 18.521-20.767-3.973-2.631 20.978L128 370.422l-14.465 15.429-2.63-20.978-20.767 3.973 10.183-18.521-19.123-8.996 19.124-8.995-10.184-18.52 20.766 3.971 2.632-20.978L128 312.236l14.465-15.429 2.63 20.978 20.767-3.971-10.183 18.521z"
    }));
};
var $b832709c107c9253$export$8227ca023eb0daaa = function NU(_ref173) {
    var title = _ref173.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref173, $b832709c107c9253$var$_excluded173);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.334h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.334h256v170.663H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.329v15.083l57.377 38.251H80z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
        fill: "#2E52B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M256 85.329v15.083l-57.377 38.251H176z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
        fill: "#2E52B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.329v15.083l57.377 38.251H80z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
        fill: "#2E52B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M256 85.329v15.083l-57.377 38.251H176z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
        fill: "#2E52B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 255.997v-15.082l57.377-38.252H80z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 233.376v-30.713h46.069zm96 22.618v-48.912l-73.372 48.912z",
        fill: "#2E52B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M256 255.997v-15.082l-57.377-38.252H176z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#2E52B2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M256 233.376v-30.713h-46.069zm-96 22.618v-48.912l73.372 48.912z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 128,
        cy: 170.66,
        r: 22.627
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m128 154.663 3.97 12.222h12.854l-10.398 7.556 3.971 12.222L128 179.109l-10.398 7.554 3.972-12.222-10.398-7.556h12.853zm0 65.14 2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm0-117.334 2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm69.931 58.667 2.365 7.277h7.653l-6.192 4.499 2.365 7.279-6.191-4.498-6.191 4.498 2.365-7.279-6.191-4.499h7.652zm-139.862 0 2.364 7.277h7.653l-6.191 4.499 2.364 7.279-6.19-4.498-6.191 4.498 2.365-7.279-6.192-4.499h7.653z",
        fill: "#FFDA44"
    }));
};
var $b832709c107c9253$export$b6db8d689596ccb0 = function NZ(_ref174) {
    var title = _ref174.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref174, $b832709c107c9253$var$_excluded174);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.334h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m425.301 233.745 3.388 10.428h10.963l-8.87 6.444 3.388 10.427-8.869-6.444-8.871 6.444 3.388-10.427-8.87-6.444h10.963zm-39.194 75.072 5.083 15.642h16.445l-13.305 9.667 5.082 15.64-13.305-9.667-13.305 9.667 5.083-15.64-13.305-9.667h16.445zm1.481-122.846 4.236 13.036h13.704l-11.088 8.054 4.235 13.034-11.087-8.056-11.088 8.056 4.235-13.034-11.087-8.054h13.704zm-37.712 47.32 5.082 15.641h16.446l-13.306 9.666 5.084 15.641-13.306-9.666-13.305 9.666 5.082-15.641-13.305-9.666h16.445z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256.003 85.329v30.564l-45.178 25.088h45.178v59.359H196.89l59.113 32.846v22.806h-26.69l-73.484-40.826v40.826h-55.652v-48.573l-87.429 48.573H.003v-30.553l45.168-25.099H.003v-59.359h59.103L.003 108.147V85.329h26.68l73.494 40.838V85.329h55.652v48.573l87.43-48.573z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M144 85.33h-32v69.334H0v32h112v69.334h32v-69.334h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915zm-83.98 0L0 240.259v15.739l100.174-55.654z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M100.174 140.983 0 85.33v15.738l71.847 39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M100.174 140.983 0 85.33v15.738l71.847 39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M100.174 140.983 0 85.33v15.738l71.847 39.915zm83.98 0L256 101.068V85.33l-100.174 55.653z",
        fill: "#D80027"
    }));
};
var $b832709c107c9253$export$1ed389bd9cb529 = function OM(_ref175) {
    var title = _ref175.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref175, $b832709c107c9253$var$_excluded175);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M138 0h377v114H138z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#4A7C3A",
        d: "M138 230h377v114H138z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "none",
        stroke: "#FFF",
        strokeWidth: 10,
        strokeMiterlimit: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M40.3 35.2s37.1 48 50.8 54.5c13.7 6.5 17.1 5.7 17.1 5.7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M100 35.2S62.9 80.6 53.3 87.6c-9.6 7-18.7 7.8-18.7 7.8m17.1-30.1h37.9M70.7 35.2v30.1"
    })));
};
var $b832709c107c9253$export$ff7e3d480d313da2 = function PA(_ref176) {
    var title = _ref176.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref176, $b832709c107c9253$var$_excluded176);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M256 256v170.663H0V256h256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M512 85.337V256H256V85.337h256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "m128 123.034 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L128 195.813l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "m384 293.697 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L384 366.476l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
    }));
};
var $b832709c107c9253$export$d5e55eb9565ea8d5 = function PE(_ref177) {
    var title = _ref177.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref177, $b832709c107c9253$var$_excluded177);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.331h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.331h170.663v341.337H0zm341.337 0H512v341.337H341.337z",
        fill: "#D80027"
    }));
};
var $b832709c107c9253$export$7d19ebf018caa9aa = function PF(_ref178) {
    var title = _ref178.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref178, $b832709c107c9253$var$_excluded178);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M293.991 256c0 20.982-17.01 33.243-37.992 33.243S218.008 276.982 218.008 256s17.01-37.992 37.992-37.992 37.991 17.01 37.991 37.992z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M293.991 256c0 20.982-17.01 37.992-37.992 37.992s-37.992-17.01-37.992-37.992"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M232.259 246.506h9.498v19h-9.498zm37.988 0h9.498v19h-9.498zm-19-14.247h9.498v33.243h-9.498z",
        fill: "#D80027"
    }));
};
var $b832709c107c9253$export$c56943b7b8ffea21 = function PG(_ref179) {
    var title = _ref179.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref179, $b832709c107c9253$var$_excluded179);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.333h512V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#A2001D",
        d: "M0 85.33h512v341.332"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m204.631 326.488 2.762 8.504h8.941l-7.233 5.255 2.763 8.502-7.233-5.254-7.233 5.254 2.762-8.502-7.233-5.255h8.94zm-22.834-81.622 4.605 14.172h14.901l-12.056 8.757 4.605 14.172-12.055-8.759-12.055 8.759 4.606-14.172-12.056-8.757h14.901zm0 103.883 4.604 14.173h14.902l-12.057 8.757 4.606 14.173-12.055-8.759-12.055 8.759 4.604-14.173-12.054-8.757h14.899zm43.566-66.782 4.606 14.172h14.901l-12.056 8.758 4.605 14.172-12.056-8.759-12.054 8.759 4.606-14.172-12.056-8.758h14.901zm-87.133 0 4.606 14.172h14.899l-12.054 8.758 4.603 14.172-12.054-8.759-12.055 8.759 4.605-14.172-12.055-8.758h14.9z",
        fill: "#FFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M376.526 204.163c-7.628-7.628-17.538-12.133-28.189-12.908l31.88-24.795c-12.698-12.698-29.714-18.431-46.319-17.218a44.31 44.31 0 0 0-11.396-19.511l-12.593 25.186a18.47 18.47 0 0 0-3.148-4.197c-7.245-7.245-18.991-7.244-26.234 0s-7.245 18.99 0 26.234a18.536 18.536 0 0 0 4.197 3.148l-25.186 12.593a44.303 44.303 0 0 0 19.519 11.399c-1.217 16.606 4.511 33.619 17.209 46.317L324.12 214.6a11.053 11.053 0 0 1 7.807-3.202c2.973 0 5.768 1.158 7.87 3.26a11.055 11.055 0 0 1 3.26 7.87c0 2.974-1.158 5.768-3.26 7.87l10.494 10.494c4.905-4.905 7.607-11.428 7.607-18.364 0-5.675-1.81-11.071-5.153-15.534a29.492 29.492 0 0 1 13.288 7.662c11.573 11.572 11.573 30.403 0 41.975l10.494 10.494c8.409-8.409 13.039-19.59 13.039-31.481-.001-11.892-4.632-23.072-13.04-31.481z"
    }));
};
var $b832709c107c9253$export$38ea63fabb2c685f = function PH(_ref180) {
    var title = _ref180.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref180, $b832709c107c9253$var$_excluded180);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M512 85.337V256H256L0 85.337z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M512 256v170.663H0L256 256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m161.908 256-27.288-12.835 14.532-26.428-29.632 5.668-3.755-29.933-20.64 22.015-20.639-22.015-3.755 29.933-29.631-5.669 14.531 26.428L28.343 256l27.288 12.835L41.1 295.263l29.633-5.668 3.753 29.933 20.639-22.015 20.64 22.015 3.755-29.933 29.631 5.669-14.532-26.427zM21.789 117.607l9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.694-14.809-4.932-9.268 12.559.117-15.608-14.809-4.934 14.88-4.712zm0 235.923 9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.695-14.809-4.933-9.268 12.558.117-15.607-14.809-4.934 14.88-4.712zm188.606-117.961-9.081 12.695-14.879-4.713 9.268 12.559-9.081 12.696 14.809-4.933 9.268 12.558-.117-15.607 14.809-4.934-14.88-4.713z",
        fill: "#FFDA44"
    }));
};
var $b832709c107c9253$export$73910688e185534c = function PK(_ref181) {
    var title = _ref181.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref181, $b832709c107c9253$var$_excluded181);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m393.508 170.516 17.512 18.875 23.363-10.821-12.541 22.487 17.513 18.876-25.263-4.978-12.539 22.488-3.073-25.564-25.263-4.978 23.363-10.82z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.343h512v341.326H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#01411c",
        d: "M128 85.331h384v341.337H128z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M361.909 298.793c-31.037 22.426-74.378 15.446-96.804-15.592-22.427-31.038-15.446-74.379 15.593-96.804 9.677-6.992 20.55-11.125 31.613-12.563-21.283-3.183-43.777 1.613-62.598 15.211-38.2 27.602-46.792 80.944-19.191 119.145 27.601 38.199 80.944 46.792 119.145 19.189 18.82-13.598 30.436-33.448 34.096-54.655-4.839 10.05-12.176 19.076-21.854 26.069zm-1.329-125.904 17.484 18.842 23.322-10.802-12.519 22.447 17.483 18.844-25.219-4.968-12.519 22.45-3.067-25.521-25.22-4.969 23.323-10.802z",
        fill: "#FFF"
    }));
};
var $b832709c107c9253$export$9e95f02561f2d9f9 = function PL(_ref182) {
    var title = _ref182.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref182, $b832709c107c9253$var$_excluded182);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.337h512V256H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 256h512v170.663H0z"
    }));
};
var $b832709c107c9253$export$164607a37e7daeba = function PM(_ref183) {
    var title = _ref183.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref183, $b832709c107c9253$var$_excluded183);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#00318A",
        d: "M0 0h171v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M342 0h171v342H342z"
    }));
};
var $b832709c107c9253$export$6bc8c38c416ebf89 = function PN(_ref184) {
    var title = _ref184.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref184, $b832709c107c9253$var$_excluded184);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.333h512V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ACABB1",
        d: "M400.696 219.822 384 225.387l-16.696-5.565-5.565-13.913 5.565-13.913h33.392l-5.566 13.913z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M345.043 219.822v61.217c0 29.821 38.957 38.957 38.957 38.957s38.957-9.137 38.957-38.957v-61.217h-77.914z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M348.555 295.541C358.131 313.927 384 319.996 384 319.996s25.869-6.069 35.445-24.455L384 236.518l-35.445 59.023z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M422.957 280.421 384 219.822l-38.957 60.599v.618c0 5.518 1.337 10.328 3.512 14.503L384 240.405l35.445 55.137c2.175-4.175 3.512-8.983 3.512-14.503v-.618z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
        fill: "#D80027"
    }));
};
var $b832709c107c9253$export$af5f8d68aad3cd3a = function PR(_ref185) {
    var title = _ref185.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref185, $b832709c107c9253$var$_excluded185);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.337h512V153.6H0zm0 136.526h512v68.263H0zM0 358.4h512v68.263H0z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M256 256.006 0 426.668V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
    }));
};
var $b832709c107c9253$export$5adddb0645f34b2 = function PS(_ref186) {
    var title = _ref186.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref186, $b832709c107c9253$var$_excluded186);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#268024",
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#e4312b",
        d: "M256 256.006 0 426.668V85.331z"
    }));
};
var $b832709c107c9253$export$3961bdb9130b90e7 = function PT(_ref187) {
    var title = _ref187.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref187, $b832709c107c9253$var$_excluded187);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M196.641 85.337v341.326H0V85.337z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFDA44",
        cx: 196.641,
        cy: 256,
        r: 64
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M160.638 224v40.001c0 19.882 16.118 36 36 36s36-16.118 36-36V224h-72z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M196.638 276c-6.617 0-12-5.383-12-12v-16h24.001v16c-.001 6.616-5.385 12-12.001 12z"
    }));
};
var $b832709c107c9253$export$5f5211c171c1b47a = function PW(_ref188) {
    var title = _ref188.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref188, $b832709c107c9253$var$_excluded188);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFDA44",
        cx: 218.902,
        cy: 255.994,
        r: 74.207
    }));
};
var $b832709c107c9253$export$21b6e0fb60b525ae = function PY(_ref189) {
    var title = _ref189.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref189, $b832709c107c9253$var$_excluded189);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "m289.579 216.738-12.592 12.592c5.37 5.372 8.693 12.792 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.112-5.316-24.985-13.91-33.579z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m256 232.51 4.421 13.605h14.304l-11.573 8.408 4.421 13.604L256 259.719l-11.573 8.408 4.421-13.604-11.573-8.408h14.304z"
    }));
};
var $b832709c107c9253$export$a7078eadaecd4b6f = function QA(_ref190) {
    var title = _ref190.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref190, $b832709c107c9253$var$_excluded190);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#751A46",
        d: "M0 0h512v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0v342h150.3l37.7-19.6-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19 37.7-18.9-37.7-19 37.7-19-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19L188 57l-37.7-19L188 19.1 150.3 0z"
    }));
};
var $b832709c107c9253$export$ded96516917cab2a = function RE(_ref191) {
    var title = _ref191.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref191, $b832709c107c9253$var$_excluded191);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#00318A",
        d: "M0 0h171v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M342 0h171v342H342z"
    }));
};
var $b832709c107c9253$export$993ec495e78d530d = function RO(_ref192) {
    var title = _ref192.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref192, $b832709c107c9253$var$_excluded192);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.331h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.331h170.663v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M341.337 85.331H512v341.337H341.337z"
    }));
};
var $b832709c107c9253$export$e9d8d46fbf5f29f6 = function RS(_ref193) {
    var title = _ref193.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref193, $b832709c107c9253$var$_excluded193);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.331h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 312.882h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M129.468 181.793v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.356 256 266.929v-85.136H129.468z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M155.634 196.634h74.201v-29.681l-14.841 7.42-22.261-22.26-22.259 22.26-14.84-7.42zm85.526 82.148-48.231-48.231-48.231 48.231 15.741 15.74 32.49-32.49 32.49 32.49z",
        fill: "#FFDA44"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M241.16 233.734h-22.504a14.74 14.74 0 0 0 2.001-7.418c0-8.196-6.645-14.84-14.84-14.84-5.663 0-10.581 3.172-13.083 7.836-2.502-4.663-7.421-7.836-13.083-7.836-8.195 0-14.84 6.644-14.84 14.84 0 2.706.736 5.235 2.001 7.418h-22.114c0 8.196 7.139 14.84 15.334 14.84h-.494c0 8.196 6.644 14.84 14.84 14.84 0 7.257 5.211 13.286 12.094 14.576l-11.694 26.401a48.075 48.075 0 0 0 18.149 3.544 48.079 48.079 0 0 0 18.149-3.544l-11.694-26.401c6.883-1.29 12.094-7.319 12.094-14.576 8.196 0 14.84-6.644 14.84-14.84h-.494c8.199 0 15.338-6.644 15.338-14.84z"
    }));
};
var $b832709c107c9253$export$6c2517b5e52f01cc = function RU(_ref194) {
    var title = _ref194.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref194, $b832709c107c9253$var$_excluded194);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.33v341.332h512V85.33z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.333h512V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.333h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 312.884h512v113.775H0z"
    }));
};
var $b832709c107c9253$export$ef5ca6a08aac8ca5 = function RW(_ref195) {
    var title = _ref195.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref195, $b832709c107c9253$var$_excluded195);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 255.994h512v81.619H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#496E2D",
        d: "M0 337.614h512v89.043H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m278.261 185.209 20.844 9.804-11.099 20.186 22.632-4.33 2.868 22.865 15.765-16.816 15.766 16.816 2.867-22.865 22.633 4.33-11.099-20.186 20.843-9.804-20.844-9.805 11.1-20.185-22.633 4.329-2.868-22.864-15.765 16.816-15.766-16.816-2.867 22.864-22.634-4.329 11.1 20.187z"
    }));
};
var $b832709c107c9253$export$da51c6332ad11d7b = function SA(_ref196) {
    var title = _ref196.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref196, $b832709c107c9253$var$_excluded196);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#055e1c",
        d: "M0 85.333h512v341.333H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M183.548 289.386c0 12.295 9.731 22.261 21.736 22.261h65.208c0 10.244 8.11 18.551 18.114 18.551h21.736c10.004 0 18.114-8.306 18.114-18.551v-22.261H183.548zm146.716-107.595v51.942c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942h-21.735zm-155.773 51.943c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942H174.49v51.942z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M297.661 181.788h21.736v51.942h-21.736zm-32.604 29.685c0 2.046-1.625 3.71-3.623 3.71-1.998 0-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 2.046-1.625 3.71-3.623 3.71s-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 14.32 11.376 25.971 25.358 25.971 5.385 0 10.38-1.733 14.491-4.677 4.11 2.944 9.106 4.677 14.491 4.677 1.084 0 2.15-.078 3.2-.215-1.54 6.499-7.255 11.345-14.068 11.345v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.943h-21.736l.002 29.682z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M207.093 248.57h32.601v22.261h-32.601z"
    })));
};
var $b832709c107c9253$export$279f8048cbf05e80 = function SB(_ref197) {
    var title = _ref197.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref197, $b832709c107c9253$var$_excluded197);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#496E2D",
        d: "M0 85.334h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 426.663V85.329h512"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 396.494v30.169h45.255L512 115.499v-30.17h-45.255z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m85.688 108.787 5.12 15.756h16.566l-13.403 9.737 5.12 15.757-13.403-9.738-13.405 9.738 5.12-15.757L64 124.543h16.567zm84.624 0 5.121 15.756H192l-13.403 9.737 5.12 15.757-13.405-9.738-13.403 9.738 5.12-15.757-13.403-9.737h16.566zm-84.624 82.502 5.12 15.756h16.566l-13.403 9.738 5.12 15.757-13.403-9.739-13.405 9.739 5.12-15.757L64 207.045h16.567zm84.624 0 5.121 15.756H192l-13.403 9.738 5.12 15.757-13.405-9.739-13.403 9.739 5.12-15.757-13.403-9.738h16.566zM128 150.037l5.12 15.756h16.568l-13.405 9.738 5.12 15.758L128 181.55l-13.403 9.739 5.12-15.758-13.405-9.738h16.568z",
        fill: "#FFF"
    }));
};
var $b832709c107c9253$export$f49cccbff6374af4 = function SC(_ref198) {
    var title = _ref198.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref198, $b832709c107c9253$var$_excluded198);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M235.454 85.337 0 426.663 427.345 85.337z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M512 329.393 0 426.663h512z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M512 85.337h-84.655L0 426.663l512-204.512z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.337v341.326L235.454 85.337z"
    }));
};
var $b832709c107c9253$export$5b088def975a652b = function SD(_ref199) {
    var title = _ref199.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref199, $b832709c107c9253$var$_excluded199);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#496E2D",
        d: "M0 426.668V85.331l256 170.675z"
    }));
};
var $b832709c107c9253$export$88d2e60d4be28663 = function SE(_ref200) {
    var title = _ref200.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref200, $b832709c107c9253$var$_excluded200);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.333h512V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M192 85.33h-64v138.666H0v64h128v138.666h64V287.996h320v-64H192z"
    }));
};
var $b832709c107c9253$export$bea437c40441867d = function SG(_ref201) {
    var title = _ref201.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref201, $b832709c107c9253$var$_excluded201);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512V256H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M83.478 170.666c0-24.865 17.476-45.637 40.812-50.734a52.059 52.059 0 0 0-11.13-1.208c-28.688 0-51.942 23.254-51.942 51.941s23.255 51.942 51.942 51.942c3.822 0 7.543-.425 11.13-1.208-23.336-5.095-40.812-25.867-40.812-50.733zm66.783-48.231 3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m121.344 144.696 3.683 11.337h11.921l-9.645 7.007 3.684 11.337-9.643-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921zm57.834 0 3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.685-11.337-9.645-7.007h11.921zm-11.131 33.391 3.684 11.337h11.921l-9.644 7.007 3.684 11.337-9.645-7.006-9.643 7.006 3.684-11.337-9.644-7.007h11.92zm-35.573 0 3.683 11.337h11.921l-9.644 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.684-11.337-9.644-7.007h11.92z"
    })));
};
var $b832709c107c9253$export$c713cf928ffb5e8e = function SH(_ref202) {
    var title = _ref202.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref202, $b832709c107c9253$var$_excluded202);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2E52B2",
        d: "M256 22.7v30.7h-46.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2E52B2",
        d: "M256 22.7v30.7h-46.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#29DBFF",
        d: "M449 139.7c-.1 44.4-7.2 92.1-65 114.9-57.8-22.8-64.9-70.5-65-114.9h130z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ffda44",
        d: "M449 139.7c0-16.7-.9-32.9-.5-47.1C426.9 83 398.4 81 383.9 81s-42.9 2-64.6 11.6c.4 14.2-.5 30.4-.5 47.1H449z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#BF521B",
        d: "m369.5 204.5.3 10.3-12.8.2 4.9 13.2h-17.3c-18-20.2-23.4-42.4-24.9-68.1l9.1-9.7 8.3 14.3 10.8-12.8 7 7.8.8 15.7 13.8 29.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#474747",
        d: "m436.6 192.5-8.6 18.3h-47l-29.2-19.5 25.7 10.5h25.1l3.7-6.5 7.2.2 2-3z"
    }));
};
var $b832709c107c9253$export$e6702cab675b095 = function SI(_ref203) {
    var title = _ref203.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref203, $b832709c107c9253$var$_excluded203);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 199.112h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l14.848 14.837 29.674-22.261 29.685 22.261 14.837-14.837z"
    }));
};
var $b832709c107c9253$export$e9f025fd23256930 = function SJ(_ref204) {
    var title = _ref204.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref204, $b832709c107c9253$var$_excluded204);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.334h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2E52B2",
        d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
    }));
};
var $b832709c107c9253$export$5f584391ee0d99b4 = function SK(_ref205) {
    var title = _ref205.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref205, $b832709c107c9253$var$_excluded205);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 196.641h512v118.717H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 315.359h512v111.304H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M129.468 181.799v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.362 256 266.935v-85.136H129.468z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M146.126 184.294v81.941c0 5.472 1.215 10.64 3.623 15.485h85.97c2.408-4.844 3.623-10.012 3.623-15.485v-81.941h-93.216z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M221.301 241.427h-21.425v-14.283h14.284v-14.283h-14.284v-14.284h-14.283v14.284h-14.282v14.283h14.282v14.283h-21.426v14.284h21.426v14.283h14.283v-14.283h21.425z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M169.232 301.658c9.204 5.783 18.66 9.143 23.502 10.636 4.842-1.494 14.298-4.852 23.502-10.636 9.282-5.833 15.79-12.506 19.484-19.939a24.878 24.878 0 0 0-14.418-4.583c-1.956 0-3.856.232-5.682.657-3.871-8.796-12.658-14.94-22.884-14.94-10.227 0-19.013 6.144-22.884 14.94a25.048 25.048 0 0 0-5.682-.657 24.88 24.88 0 0 0-14.418 4.583c3.691 7.433 10.198 14.106 19.48 19.939z"
    }));
};
var $b832709c107c9253$export$b49d6918df199090 = function SL(_ref206) {
    var title = _ref206.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref206, $b832709c107c9253$var$_excluded206);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M0 312.888h512v113.775H0z"
    }));
};
var $b832709c107c9253$export$59096964bd9627ef = function SM(_ref207) {
    var title = _ref207.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref207, $b832709c107c9253$var$_excluded207);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.34h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M512 85.334v166.69L0 256.175V85.334z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M323.744 203.099 256 270.843l-67.744-67.744a81.156 81.156 0 0 0-13.879 45.483v22.261c0 35.744 23.097 66.193 55.148 77.213-4.277 8.385-3.556 18.848 2.712 26.671l24.258-19.439 24.258 19.439c6.342-7.915 7.011-18.534 2.564-26.968 31.614-11.261 54.308-41.485 54.308-76.916v-22.261a81.174 81.174 0 0 0-13.881-45.483z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M256 330.206c-32.732 0-59.362-26.63-59.362-59.362v-22.261c0-32.733 26.63-59.363 59.362-59.363s59.362 26.63 59.362 59.362v22.261c0 32.733-26.63 59.363-59.362 59.363z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M293.101 270.843v-22.261c0-20.458-16.643-37.101-37.101-37.101s-37.101 16.643-37.101 37.101v22.261L256 278.264l37.101-7.421z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M218.899 270.843c0 20.458 16.643 37.101 37.101 37.101s37.101-16.643 37.101-37.101h-74.202z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M300.522 189.22c0-12.295-9.966-22.261-22.261-22.261a22.173 22.173 0 0 0-14.84 5.672v-13.093h7.421v-14.84h-7.421v-7.421h-14.84v7.421h-7.421v14.84h7.421v13.093a22.177 22.177 0 0 0-14.841-5.672c-12.295 0-22.261 9.966-22.261 22.261 0 6.591 2.867 12.512 7.421 16.589v13.093h74.203v-13.093c4.552-4.077 7.419-9.997 7.419-16.589z"
    }));
};
var $b832709c107c9253$export$b70f9dd36a734be4 = function SN(_ref208) {
    var title = _ref208.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref208, $b832709c107c9253$var$_excluded208);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.331h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M330.207 85.331H512v341.337H330.207z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.331h181.793v341.337H0zm255.999 111.301 14.733 45.347h47.685l-38.576 28.029 14.734 45.348-38.576-28.026-38.577 28.026 14.737-45.348-38.576-28.029h47.681z",
        fill: "#496E2D"
    }));
};
var $b832709c107c9253$export$f6311706676f39f2 = function SO(_ref209) {
    var title = _ref209.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref209, $b832709c107c9253$var$_excluded209);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m256 157.273 22.663 69.748H352l-59.332 43.106 22.664 69.749L256 296.769l-59.332 43.107 22.664-69.749L160 227.021h73.337z"
    }));
};
var $b832709c107c9253$export$13acf42283a26926 = function SR(_ref210) {
    var title = _ref210.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref210, $b832709c107c9253$var$_excluded210);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#A2001D",
        d: "M0 196.636h512v118.728H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 352.462h512v74.207H0zM0 85.331h512v74.207H0z",
        fill: "#6DA544"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m256.742 218.003 9.43 29.021h30.518L272 264.963l9.431 29.023-24.689-17.937-24.689 17.937 9.431-29.023-24.69-17.939h30.518z"
    }));
};
var $b832709c107c9253$export$8cda4cf3f4deb8c2 = function SS(_ref211) {
    var title = _ref211.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref211, $b832709c107c9253$var$_excluded211);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#496E2D",
        d: "M0 322.783h512v103.88H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.337h512v104.515H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#A2001D",
        d: "M0 210.877h512v89.656H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M256 256.006 0 426.668V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m73.178 209.188 20.831 29.067 34.084-10.83-21.207 28.795 20.83 29.069-33.939-11.271-21.208 28.794.234-35.762-33.94-11.273 34.083-10.83z"
    }));
};
var $b832709c107c9253$export$80980ed6b6f31397 = function ST(_ref212) {
    var title = _ref212.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref212, $b832709c107c9253$var$_excluded212);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
        fill: "#6DA544"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M256 256.006 0 426.668V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m302.049 226.318 7.368 22.674h23.842l-19.288 14.016 7.366 22.674-19.288-14.015-19.287 14.015 7.366-22.674-19.288-14.016h23.842zm74.203 0 7.367 22.674h23.842l-19.288 14.016 7.367 22.674-19.288-14.015-19.288 14.015 7.367-22.674-19.288-14.016h23.842z"
    }));
};
var $b832709c107c9253$export$8fc936c6ebd916b3 = function SV(_ref213) {
    var title = _ref213.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref213, $b832709c107c9253$var$_excluded213);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
        fill: "#0052B4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M228.582 261.936 256 214.447l27.418 47.489z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M291.616 277.616 256 295.425l-35.616-17.809v-23.744h71.232z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m289.579 216.485-12.592 12.592c5.37 5.372 8.693 12.791 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.114-5.316-24.987-13.91-33.579z"
    }));
};
var $b832709c107c9253$export$b4f896bb97547f66 = function SX(_ref214) {
    var title = _ref214.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref214, $b832709c107c9253$var$_excluded214);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M512 85.331v166.69L0 256.173V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256 256.006 0 426.668V85.331z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFDA44"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M59.621 256a59.546 59.546 0 0 0-.193 4.57c0 32.821 26.607 59.429 59.429 59.429s59.429-26.607 59.429-59.429c0-1.539-.078-3.061-.193-4.57H59.621z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 118.862,
        cy: 210.287,
        r: 18.286
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M77.715 205.714v59.429c0 31.494 41.144 41.143 41.144 41.143s41.144-9.649 41.144-41.143v-59.429H77.715z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M118.877 287.148c-7.632-2.746-22.876-9.767-22.876-22.006v-41.144h45.715v41.144c-.001 12.28-15.244 19.283-22.839 22.006z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#F3F3F3",
        d: "M128.001 246.856v-9.142l-9.144-4.571-9.142 4.571v9.142l-4.571 4.573v18.285h27.428v-18.285z"
    }));
};
var $b832709c107c9253$export$2e8caadc521d7cbb = function SY(_ref215) {
    var title = _ref215.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref215, $b832709c107c9253$var$_excluded215);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 900 600"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h900v600H0z",
        fill: "#0f0f0f"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h900v400H0z",
        fill: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h900v200H0z",
        fill: "#047a3f"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m176.26 375 48.738-150 48.738 150-127.6-92.705h157.72M626.256 375l48.738-150 48.738 150-127.6-92.705h157.72M401.252 375l48.738-150 48.738 150-127.6-92.705h157.72",
        fill: "#ce1126"
    }));
};
var $b832709c107c9253$export$988c8b3cfeed3531 = function SZ(_ref216) {
    var title = _ref216.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref216, $b832709c107c9253$var$_excluded216);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 900 600"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2B5DEA",
        d: "M0 0h900v600H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDF29",
        d: "M0 100h900v400H0V100z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D70000",
        d: "M0 150h900v300H0V150z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M450 171.4v257.2c114.3 0 171.4-85.7 214.3-128.6-42.9-42.9-100-128.6-214.3-128.6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M450 171.4c-100 0-171.4 85.7-214.3 128.6C278.6 342.9 350 428.6 450 428.6V171.4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M346.3 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M477.8 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
    }));
};
var $b832709c107c9253$export$6b4abaf3a097db68 = function TA(_ref217) {
    var title = _ref217.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref217, $b832709c107c9253$var$_excluded217);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2E52B2",
        d: "M256 22.7v30.7h-46.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2E52B2",
        d: "M256 22.7v30.7h-46.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#29DBFF",
        d: "M448.9 169.5c0 9.6-.3 29.6-1.4 39.2-4.1 34.9-23.5 68.8-62.1 85.9-45.3-17.9-60.8-51-64.9-85.9-1.1-9.6-1.5-19.4-1.5-29l.3-47.1h129.2l.4 36.9z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M447.5 208.7c-.2 1.6-.4 3.3-.6 4.9-4.8 33.1-22.9 65.4-61.5 81-43.2-17-59.4-47.9-64.2-81-.2-1.6-.4-3.2-.6-4.9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#29DBFF",
        d: "m385.4 251.7-22.9-43h45.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m385.4 165.8-22.9 42.9h45.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        fill: "#FFBE57",
        cx: 474.8,
        cy: 236.8,
        rx: 16.8,
        ry: 43.3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        fill: "#FFBE57",
        cx: 295.3,
        cy: 236.8,
        rx: 16.8,
        ry: 43.3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m385.4 31.5-33.4 44h68.5zM315.5 280s33.8 29.5 69.9 29.5 67.1-29.5 67.1-29.5l8.5 14.6S439.2 326 385.4 326 307 294.6 307 294.6l8.5-14.6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("ellipse", {
        fill: "#A5A5A5",
        cx: 386.3,
        cy: 104.3,
        rx: 34.3,
        ry: 23.3
    }));
};
var $b832709c107c9253$export$bf91931db7b40921 = function TC(_ref218) {
    var title = _ref218.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref218, $b832709c107c9253$var$_excluded218);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.333h512V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M332.058 191.996v78.221c0 38.103 51.942 49.779 51.942 49.779s51.942-11.675 51.942-49.779v-78.221H332.058z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FF9811",
        d: "M376.579 220.44c0 7.855-6.644 28.445-14.84 28.445s-14.84-20.589-14.84-28.445c0-7.856 14.84-14.222 14.84-14.222s14.84 6.367 14.84 14.222z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#A2001D",
        d: "M415.961 235.93c2.394-5.6 4.257-13.785 4.257-17.86 0-6.546-8.904-11.852-8.904-11.852s-8.904 5.306-8.904 11.852c0 4.075 1.862 12.26 4.257 17.86l-5.141 11.123a26.898 26.898 0 0 0 9.788 1.831c3.463 0 6.766-.654 9.788-1.831l-5.141-11.123z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M372.87 270.217s-7.421 14.222-7.421 28.445h37.101c0-14.222-7.421-28.445-7.421-28.445l-11.13-7.111-11.129 7.111z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M395.13 270.217v-3.555c0-5.891-4.983-10.666-11.13-10.666-6.147 0-11.13 4.776-11.13 10.666v3.555h22.26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
        fill: "#D80027"
    }));
};
var $b832709c107c9253$export$9cf5b401f969f5e3 = function TD(_ref219) {
    var title = _ref219.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref219, $b832709c107c9253$var$_excluded219);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.331h170.663v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M341.337 85.331H512v341.337H341.337z"
    }));
};
var $b832709c107c9253$export$4014e91f2965d3df = function TF(_ref220) {
    var title = _ref220.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref220, $b832709c107c9253$var$_excluded220);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 22.5 15"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h21v15H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0A388A",
        d: "M0 0h22.5v15H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h11.3v7.5H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M7.1 0h3.6v7H7.1V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0A388A",
        d: "M0 0h3.6v7H0V0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M3.6 0h3.6v7H3.6V0zm10.9 6h5L19 7h-1.5v.5h1l-.5 1h-.5V10h-1V7H15l-.5-1zm4 2.5 1 1.5h-2l1-1.5zm-3 0 1 1.5h-2l1-1.5zm1.5 3L16 10h2l-1 1.5zM20 8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-6 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm1 4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm4 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-2 1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5z"
    }));
};
var $b832709c107c9253$export$3909ee2d70cce411 = function TG(_ref221) {
    var title = _ref221.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref221, $b832709c107c9253$var$_excluded221);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.337h512V153.6H0zM0 358.4h512v68.263H0zm0-136.537h512v68.263H0z",
        fill: "#496E2D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h204.054v204.054H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m102.026 133.938 13.26 40.812h42.916l-34.718 25.226 13.26 40.814-34.718-25.224-34.719 25.224 13.263-40.814-34.718-25.226h42.913z"
    }));
};
var $b832709c107c9253$export$2b39a3648955dd09 = function TH(_ref222) {
    var title = _ref222.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref222, $b832709c107c9253$var$_excluded222);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.334h512V426.66H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 194.056h512v123.882H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.334h512v54.522H0zm0 286.809h512v54.522H0z",
        fill: "#D80027"
    }));
};
var $b832709c107c9253$export$f5448d52a2727e70 = function TJ(_ref223) {
    var title = _ref223.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref223, $b832709c107c9253$var$_excluded223);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 312.888h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M226.318 300.522h59.364v-25.23l-11.873 5.937L256 263.421l-17.809 17.808-11.873-5.937zm-33.963-29.682 2.763 8.504h8.94l-7.233 5.255 2.763 8.502-7.233-5.255-7.234 5.255 2.763-8.502-7.233-5.255h8.94zm8.566-29.68 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm24.488-22.261 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm94.236 51.941-2.763 8.504h-8.94l7.233 5.255-2.763 8.502 7.233-5.255 7.234 5.255-2.763-8.502 7.233-5.255h-8.94zm-8.566-29.68-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zm-24.488-22.261-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zM256 207.767l2.763 8.503h8.941l-7.234 5.256 2.763 8.502-7.233-5.254-7.233 5.254 2.763-8.502-7.234-5.256h8.941z",
        fill: "#FFDA44"
    }));
};
var $b832709c107c9253$export$73184284939cbbe8 = function TK(_ref224) {
    var title = _ref224.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref224, $b832709c107c9253$var$_excluded224);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m210.715 174.377 3.684 11.338h11.919l-9.643 7.006 3.684 11.337-9.644-7.007-9.644 7.007 3.684-11.337-9.645-7.006h11.921zm-93.899 107.594 4.605 14.172h14.9l-12.055 8.757 4.606 14.173-12.056-8.76-12.055 8.76 4.604-14.173-12.054-8.757h14.899zm27.88-162.292 4.604 14.172h14.901l-12.056 8.758 4.606 14.171-12.055-8.759-12.056 8.759 4.606-14.171-12.055-8.758h14.9zm-75.157 55.652 4.604 14.172h14.9l-12.055 8.758 4.606 14.171-12.055-8.758-12.056 8.758 4.606-14.171-12.055-8.758h14.9z",
        fill: "#FFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M483.386 354.503H117.801s109.234-88.562 310.593-220.938c.001 0-88.443 128.935 54.992 220.938zm-365.585 11.586c-11.177 0-11.195 17.37 0 17.37h365.585c11.177 0 11.195-17.37 0-17.37H117.801z",
        fill: "#FFDA44"
    }));
};
var $b832709c107c9253$export$28666a74ae2b9cff = function TL(_ref225) {
    var title = _ref225.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref225, $b832709c107c9253$var$_excluded225);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M256 256 0 90.691v44.242L155.826 256 0 377.067v44.242z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 90.691v330.618L189.217 256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m44.184 213.36 24.912 23.577 30.121-16.41-14.723 30.98 24.911 23.575-34.012-4.43L60.67 301.63l-6.296-33.716-34.012-4.43 30.119-16.408z"
    }));
};
var $b832709c107c9253$export$e3227e6e5fca8775 = function TM(_ref226) {
    var title = _ref226.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref226, $b832709c107c9253$var$_excluded226);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#496E2D",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M357.208 183.679c8.397-23.404-1.036-48.858-21.281-61.536a52.131 52.131 0 0 1 10.884 2.621c27.002 9.688 41.038 39.428 31.35 66.431s-39.428 41.038-66.431 31.35a52.182 52.182 0 0 1-10.069-4.895c23.686 3.084 47.15-10.566 55.547-33.971zm-46.571-67.95-7.297 9.427-11.22-4.026 6.712 9.852-7.296 9.427 11.443-3.338 6.712 9.852.361-11.914 11.444-3.339-11.221-4.025z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m330.338 146.448-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.443-3.339 6.712 9.853.36-11.915 11.445-3.34-11.221-4.024zM275.9 126.916l-7.296 9.427-11.219-4.024 6.711 9.851-7.296 9.426 11.443-3.338 6.712 9.852.361-11.915 11.444-3.337-11.221-4.027zm-.799 35.189-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.444-3.338 6.711 9.852.362-11.915 11.443-3.338-11.22-4.026zm33.484 12.013-7.296 9.427-11.22-4.026 6.712 9.853-7.297 9.426 11.444-3.338 6.712 9.852.36-11.915 11.443-3.338-11.219-4.025z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M83.478 85.337h89.043v341.326H83.478z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m117.458 175.191-14.908-11.105v-15.705l14.908-11.105h21.084l14.908 11.105v15.705l-14.908 11.105z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M128 137.276h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.105v-8.012H128z",
        fill: "#FF9811"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m117.458 374.725-14.908-11.106v-15.704l14.908-11.105h21.084l14.908 11.105v15.704l-14.908 11.106z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M128 336.81h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.106v-8.011H128z",
        fill: "#FF9811"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m117.458 274.957-14.908-11.105v-15.703l14.908-11.106h21.084l14.908 11.106v15.703l-14.908 11.105zm36.513 24.434h-6.493v-6.493h-11.411l-8.068-8.068-8.067 8.068h-11.41v6.493h-6.493v12.986h6.493v6.492h11.41l8.068 8.069 8.068-8.069h11.41v-6.492h6.493zm0-99.768h-6.493v-6.492h-11.411l-8.068-8.069-8.067 8.069h-11.41v6.492h-6.493v12.986h6.493v6.492h11.41l8.068 8.07 8.068-8.07h11.41v-6.492h6.493z",
        fill: "#496E2D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M120.576 248.576h14.84v14.84h-14.84z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 128,
        cy: 206.113,
        r: 7.421
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        cx: 128,
        cy: 305.887,
        r: 7.421
    })));
};
var $b832709c107c9253$export$82039c5ab5b44a72 = function TN(_ref227) {
    var title = _ref227.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref227, $b832709c107c9253$var$_excluded227);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFF",
        cx: 256,
        cy: 255.994,
        r: 96
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m267.826 219.291 16.47 22.695 26.673-8.649-16.496 22.676 16.468 22.695-26.664-8.681-16.495 22.676.017-28.04-26.664-8.682 26.674-8.648z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M277.818 312.724c-31.33 0-56.727-25.397-56.727-56.727s25.397-56.727 56.727-56.727c9.769 0 18.96 2.47 26.985 6.819-12.589-12.31-29.804-19.909-48.803-19.909-38.558 0-69.818 31.259-69.818 69.818s31.26 69.818 69.818 69.818c18.999 0 36.215-7.599 48.803-19.909-8.026 4.347-17.216 6.817-26.985 6.817z"
    })));
};
var $b832709c107c9253$export$ee525e60afffec7b = function TO(_ref228) {
    var title = _ref228.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref228, $b832709c107c9253$var$_excluded228);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.331h256v170.663H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M141.357 157.303V130.59h-26.714v26.713H87.93v26.713h26.713v26.713h26.714v-26.713h26.713v-26.713z"
    }));
};
var $b832709c107c9253$export$5582bd7183a5e873 = function TR(_ref229) {
    var title = _ref229.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref229, $b832709c107c9253$var$_excluded229);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#E30A17",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M259.7 118.6c-13.1-9.5-29-14.6-45.3-14.5-40.8 0-73.8 30.8-73.8 68.9s33.1 68.9 73.8 68.9c17.1 0 32.9-5.4 45.3-14.5-30 38.6-85.7 45.6-124.3 15.5s-45.6-85.7-15.5-124.3 85.7-45.6 124.3-15.5c5.8 4.5 11 9.8 15.5 15.5zm39.9 65.8-18.1 21.9 1.2-28.4-26.4-10.4 27.3-7.6 1.8-28.3 15.6 23.7 27.5-7.1-17.5 22 15.3 23.9-26.7-9.7z"
    }));
};
var $b832709c107c9253$export$c506431d6b27243b = function TT(_ref230) {
    var title = _ref230.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref230, $b832709c107c9253$var$_excluded230);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m6.066 85.337 207.961 212.636 131.584 128.69h160.323L297.973 214.027 166.389 85.337z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M43.364 85.337 384.69 426.663h83.946L127.31 85.337z"
    }));
};
var $b832709c107c9253$export$9e799ed47e538f9d = function TV(_ref231) {
    var title = _ref231.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref231, $b832709c107c9253$var$_excluded231);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 900 600"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h900v600H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#00B2EE",
        d: "M0 300h450V0h450v600H0V300z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m345.3 480.9 29.4 90.6-77.1-56H393l-77.1 56 29.4-90.6zM706.4 340l29.4 90.6-77.1-56H754l-77.1 56 29.5-90.6zm106.4-78.5 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zm0-224.1 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M449.9 0v206.3h-81l81 54V300h-39.7l-129-85.9V300H168.7v-85.9L39.7 300H0v-39.7l81-54H0V93.8h81L0 39.9V0h39.7l129 85.9V0h112.5v85.9L410.2 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M253.1 0h-56.3v122H0v56.2h196.8V300h56.3V178.2h196.8V122H253.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2E52B2",
        d: "M449.9 39.9v53.9h-81z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 300v-19.3l109.9-74.4h39.7L12.8 300zM12.8.1l136.8 93.7h-39.7L0 19.4V.1zm437.1.1v19.3L340 93.8h-39.7L437.1.2zM437.1 300l-136.8-93.7H340l109.9 74.4V300z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m719.9 131.6 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM584 187.7l29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zm30 242.9 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM488 332l29.4 90.6-77.1-56h95.3l-77.1 56L488 332zm0 132 29.4 90.6-77.1-56h95.3l-77.1 56L488 464z"
    }));
};
var $b832709c107c9253$export$1d1fd77441e66de6 = function TW(_ref232) {
    var title = _ref232.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref232, $b832709c107c9253$var$_excluded232);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.337h256V256H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M186.435 170.669 162.558 181.9l12.714 23.125-25.927-4.961-3.286 26.192L128 206.993l-18.06 19.263-3.285-26.192-25.927 4.96 12.714-23.125-23.877-11.23 23.877-11.231-12.714-23.125 25.927 4.96 3.286-26.192L128 134.344l18.06-19.263 3.285 26.192 25.928-4.96-12.715 23.125z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#0052B4",
        cx: 128,
        cy: 170.674,
        r: 29.006
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M128 190.06c-10.692 0-19.391-8.7-19.391-19.391 0-10.692 8.7-19.391 19.391-19.391 10.692 0 19.391 8.7 19.391 19.391 0 10.691-8.699 19.391-19.391 19.391z"
    }));
};
var $b832709c107c9253$export$786aa6dc686c7fa2 = function TZ(_ref233) {
    var title = _ref233.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref233, $b832709c107c9253$var$_excluded233);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 426.663V85.337h512"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
    }));
};
var $b832709c107c9253$export$4b88e746e0f81154 = function UA(_ref234) {
    var title = _ref234.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref234, $b832709c107c9253$var$_excluded234);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.337h512V256H0z"
    }));
};
var $b832709c107c9253$export$c5b3cc9fdc52ea1d = function UG(_ref235) {
    var title = _ref235.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref235, $b832709c107c9253$var$_excluded235);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#232323",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 56.9h512v56.9H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D32300",
        d: "M0 113.8h512v56.9H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 227.6h512v56.9H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D32300",
        d: "M0 284.4h512v56.9H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FFF",
        cx: 256,
        cy: 170.7,
        r: 80.7
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M234.5 127.5c.9-1.4-19.6-2-19.6-2 1.7-2.5 18.4-10.5 18.4-10.5s-.9-6 2.7-9.8l-4.5-9.8s7-3.4 18.4-3.4 19.9 7 21 13.1l-6.4 3.4c-.1 4.7 1.7 11.6-4.3 17.3-5.9 5.7-8.3 6.9-8.5 18.8 0 3.9 2.3 8.2 8.8 11.7 17.4 9.3 38.6 28.2 44.6 33.9 6.1 5.7 5.1 19.2 2.6 25.2s-12.1 14.3-14.3 13.6c-2.2-.6 1.2-9.2-3.5-11.6 0 0-8.9-7.6-16.8.6s-.2 25.2 3.9 28c4.1 2.8 1.7 5-1.9 5H247c-3.8 0-5.4-2.3-1.9-5 7.6-3.8 12.4-15.3 7.4-20.3-4.9-4.9-18.3 1.5-21.5 6.3-2.8 2.8-8.8 3.6-12.9-1.4s-4.1-10.4-1.1-12.5c7-4.8 0 0 .1-.1 0 0 11.9-8.6 29.9-9 3.9 0 4.8-2.2 2.2-4.8 0 0-30.9-27.4-28.1-44.2 3-18.3 20-26.3 13.4-32.5-1.3-1.8 0 0 0 0z"
    }));
};
var $b832709c107c9253$export$a0e1852ae1fae17b = function UM(_ref236) {
    var title = _ref236.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref236, $b832709c107c9253$var$_excluded236);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2E52B2",
        d: "M0 0h256.5v184.1H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
        fill: "#FFF"
    }));
};
var $b832709c107c9253$export$6137fb82cd5996e9 = function US(_ref237) {
    var title = _ref237.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref237, $b832709c107c9253$var$_excluded237);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2E52B2",
        d: "M0 0h256.5v184.1H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
        fill: "#FFF"
    }));
};
var $b832709c107c9253$export$3f448fbd9cc8b25f = function UY(_ref238) {
    var title = _ref238.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref238, $b832709c107c9253$var$_excluded238);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 513 342"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h513v342H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 38h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z",
        fill: "#0038a8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h256.5v190H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FED443",
        d: "m128.3 138.7-15.1 22.6-3.8-26.9L86 148.2l8.2-25.9-27.2 2.2 18.6-19.8L60.3 95l25.4-9.7L67 65.5l27.1 2.3-8.2-25.9 23.4 13.8 3.9-26.9 15.1 22.6 15.1-22.6 3.8 26.9 23.4-13.8-8.2 25.9 27.1-2.2-18.6 19.8 25.4 9.7-25.4 9.7 18.6 19.8-27.1-2.2 8.2 25.9-23.4-13.8-3.9 26.9-15-22.7zm0-.5c23.9.9 44-17.6 44.9-41.5.9-23.9-17.6-44-41.5-44.9h-3.4c-23.9.8-42.6 20.8-41.8 44.6.6 22.8 19 41.1 41.8 41.8zm0-10.6c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.3 34-34 34z"
    }));
};
var $b832709c107c9253$export$6553e0f362fae356 = function UZ(_ref239) {
    var title = _ref239.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref239, $b832709c107c9253$var$_excluded239);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M0 322.783h512v103.88H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.337h512v104.515H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 210.877h512v89.656H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.337h512v104.515H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M188.688 137.589c0-15.984 11.234-29.339 26.236-32.614a33.531 33.531 0 0 0-7.155-.777c-18.442 0-33.391 14.949-33.391 33.391s14.949 33.391 33.391 33.391c2.458 0 4.85-.273 7.155-.777-15.002-3.275-26.236-16.63-26.236-32.614zm45.97 15.177 2.261 6.957h7.315l-5.918 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.261-6.956-5.918-4.301h7.315zm23.348 0 2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zm23.347 0 2.26 6.957h7.315l-5.917 4.301 2.26 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.918-4.301h7.315zm23.347 0 2.262 6.957h7.315l-5.919 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.262-6.956-5.919-4.301h7.314zm23.348 0 2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zm-70.042-24.284 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zm23.347 0 2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.918-4.3h7.315zm23.347 0 2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.299-5.918 4.299 2.262-6.957-5.919-4.3h7.314zm23.348 0 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zm-46.695-24.284 2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.918-4.3h7.315zm23.347 0 2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.3-5.918 4.3 2.262-6.957-5.919-4.3h7.314zm23.348 0 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.917-4.3h7.314z",
        fill: "#FFF"
    }));
};
var $b832709c107c9253$export$8f976c058e984810 = function VA(_ref240) {
    var title = _ref240.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref240, $b832709c107c9253$var$_excluded240);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.331h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256 85.331h256v341.337H256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ACABB1",
        d: "m321.353 233.837 32.073 42.43c-5.053 7.651-5.026 17.961.817 25.692 7.414 9.807 21.374 11.748 31.182 4.335 9.807-7.414 11.748-21.374 4.334-31.182-5.843-7.731-15.756-10.568-24.495-7.795l-49.988-66.129-11.838 8.949-17.759 13.424 17.899 23.677 17.775-13.401zm46.175 48.78a7.421 7.421 0 1 1 8.95 11.84 7.421 7.421 0 0 1-8.95-11.84z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m376.367 247.24 17.899-23.677-17.759-13.424-11.838-8.949-49.988 66.129c-8.74-2.775-18.651.063-24.495 7.795-7.414 9.808-5.473 23.768 4.334 31.182 9.808 7.414 23.768 5.473 31.182-4.335 5.845-7.731 5.871-18.041.817-25.692l32.073-42.43 17.775 13.401zm-62.504 45.771a7.42 7.42 0 1 1-11.84-8.95 7.42 7.42 0 0 1 11.84 8.95z"
    }));
};
var $b832709c107c9253$export$c3ea4fdfa4d8ecb7 = function VC(_ref241) {
    var title = _ref241.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref241, $b832709c107c9253$var$_excluded241);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#338AF3",
        d: "M0 85.331h170.663v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M341.337 85.331H512v341.337H341.337zM214.261 283.82l-33.393-50.086 33.392-50.087 33.392 50.087zm83.478 0-33.391-50.086 33.391-50.087 33.393 50.087zM256 350.603l-33.391-50.087L256 250.429l33.391 50.087z",
        fill: "#6DA544"
    }));
};
var $b832709c107c9253$export$d7d2699f2b01bb80 = function VE(_ref242) {
    var title = _ref242.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref242, $b832709c107c9253$var$_excluded242);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 22.5 15"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFCE00",
        d: "M0 0h22.5v5H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#203899",
        d: "M0 5h22.5v5H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D82B2B",
        d: "M0 10h22.5v5H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "m12.13 5.38.14.46.45.14-.39.27.01.48-.38-.29-.45.15.15-.44-.28-.38h.47zm-1.77 0 .27.39h.47l-.28.38.15.45-.45-.16-.38.28.01-.47-.39-.28.45-.13zm3.44.56-.01.48.39.27-.46.14-.14.45-.27-.38h-.48l.29-.38-.15-.45.45.16zm-5.11.02.4.27.44-.18-.13.46.3.36-.47.02-.26.4-.16-.44-.46-.12.37-.3zm6.55 1.17-.2.44.25.4-.47-.05-.31.36-.1-.46-.43-.18.41-.24.03-.47.35.31zm.19 1.12.21.43.47.07-.34.33.08.46-.42-.22-.42.22.08-.46-.34-.33.47-.07zM7 8.2l.21.43.47.06-.34.33.08.47L7 9.27l-.42.22.08-.47-.34-.33.47-.06zm.31-1.15.45.14.38-.29v.48l.39.26-.45.15-.13.46-.28-.38-.47.01.27-.38z"
    }));
};
var $b832709c107c9253$export$42769a1039364fc6 = function VG(_ref243) {
    var title = _ref243.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref243, $b832709c107c9253$var$_excluded243);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.334h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M256 85.334V202.66h-46.069L256 233.38v22.617h-22.628L160 207.078v48.919H96v-48.919l-73.372 48.919H0V233.38l46.069-30.72H0v-64h46.069L0 107.951V85.334h22.628L96 134.241V85.334h64v48.907l73.372-48.907z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#D80027"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2E52B2",
        d: "M256 107.951v30.712h-46.069z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#2E52B2",
        d: "M256 107.951v30.712h-46.069z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 255.997v-15.082l57.377-38.252H80zm256 0v-15.082l-57.377-38.252H176z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m384 259.706-46.129 46.129c8.645 16.675 26.051 28.074 46.129 28.074s37.484-11.4 46.129-28.074L384 259.706z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M332.058 178.084v81.624c.001 39.759 51.942 51.941 51.942 51.941s51.941-12.182 51.942-51.942v-81.623H332.058z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M372.87 215.181h22.261v59.359H372.87z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#A2001D",
        cx: 384,
        cy: 215.181,
        r: 11.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M346.902 192.92h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84zm59.359-66.783h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84z",
        fill: "#FFDA44"
    }));
};
var $b832709c107c9253$export$ae144c30ed7463e6 = function VI(_ref244) {
    var title = _ref244.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref244, $b832709c107c9253$var$_excluded244);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.3"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h512v341.3H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#1583C4",
        d: "m397.7 166.3-51 97.7c-1.1 2-.3 4.5 1.8 5.6 2 1.1 4.5.3 5.6-1.8l51-97.7c1-2.1.1-4.6-2-5.5-2-.9-4.3-.2-5.4 1.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#1583C4",
        d: "m404.9 188-57.8 75.4c-1.3 1.9-.8 4.5 1.1 5.8 1.7 1.2 4.1.9 5.5-.7l57.8-75.4c1.4-1.8 1.1-4.4-.8-5.8-1.8-1.5-4.4-1.1-5.8.7z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#1583C4",
        d: "m379 181.3-32.5 83.1c-.8 2.1.2 4.6 2.4 5.4 2.1.8 4.6-.2 5.4-2.4l32.5-83.1c.7-2.2-.4-4.5-2.6-5.3-2.1-.6-4.3.4-5.2 2.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#409347",
        d: "M122.1 171.9c.4 1.7 1.2 4.7 2.2 8.5 1.7 6.4 3.6 12.8 5.6 18.7 2.3 6.9 14.7 31.4 20.2 39.1 6.9 9.7 14.1 19.3 21.5 28.6 1.6 1.9 4.5 2.1 6.4.5 1.8-1.6 2.1-4.3.7-6.2-7.3-9.2-14.4-18.6-21.2-28.2-4.2-5.8-17.2-31.1-19-36.7-2.9-8.7-5.4-17.6-7.6-26.5-.5-2.4-2.9-4-5.3-3.5s-4 2.9-3.5 5.3c-.1.2 0 .3 0 .4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFD836",
        stroke: "#231F20",
        strokeMiterlimit: 10
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M297.1 114.9S279.5 42.8 261 42.8c-6.9 0-11.9-.6-15.4 6.4-.9 1.7-20.7-1.6-19.1 20.8.5 6.9 1.1-9.8 14.9-3.4 6.3 3-16.4 48.2-16.4 48.2h72.1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m466.1 48.4-90.9 22c-75.3 18.3-42.1 44.4-42.1 44.4l-72.1 12-72.1-12s33.2-26.1-42.1-44.4l-90.9-22C43.1 45.3 38.1 51.8 45.3 63c0 0 106.6 104 126.8 112 20.2 8.1 40.8 0 40.8 0s-14.9 8.7-24 24c-9.2 15.3-4.6 34.7-38.9 40.2-5.5 6.6-5 14 2.9 19.9 7.9 5.8 72.1-48.1 72.1-48.1s-24 24.4-24 36.1c0 5.1 44.1 53.8 60.1 53.8s60.1-48.7 60.1-53.8c0-11.7-24-36.1-24-36.1s64.2 53.9 72.1 48.1 11.4-19.3 2.8-19.9c-28-1.8-29.7-24.9-38.9-40.2-9.2-15.3-24-24-24-24s20.6 8.1 40.8 0S476.7 63 476.7 63c7.2-11.2 2.3-17.7-10.6-14.6z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        stroke: "#231F20",
        strokeMiterlimit: 10,
        d: "M201.3 111.8v80.3c0 45.7 59.7 59.7 59.7 59.7s59.7-14 59.7-59.7v-80.3H201.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M225.2 137.7V235c8.2 6 17 10.2 23.9 12.9V137.7h-23.9zm71.6 0V235c-8.2 6-17 10.2-23.9 12.9V137.7h23.9z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M201.3 111.8h119.4v37.9H201.3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#1583C4",
        d: "m60.1 210.5-21.9-58.1H15.7l31.8 80.8h25.2l31.5-80.8H81.7zm391.4-58.6h18.9v81.7h-18.9z"
    }));
};
var $b832709c107c9253$export$4ef9166b5b9f8bef = function VN(_ref245) {
    var title = _ref245.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref245, $b832709c107c9253$var$_excluded245);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M196.641 85.337H0v341.326h512V85.337z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m256 157.279 22.663 69.747H352l-59.332 43.106 22.664 69.749L256 296.774l-59.332 43.107 22.664-69.749L160 227.026h73.337z"
    }));
};
var $b832709c107c9253$export$e4fcd53a919210fd = function VU(_ref246) {
    var title = _ref246.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref246, $b832709c107c9253$var$_excluded246);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#6DA544",
        d: "M512 256v170.663H0L215.185 256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M512 85.337V256H215.185L0 85.337z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M221.001 239.304 26.868 85.337H8.956l208.168 165.098H512v-11.131zM8.956 426.663h17.912l194.133-153.967H512v-11.131H217.124zM0 92.44v14.206L188.317 256 0 405.354v14.205L206.229 256z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("g", {
        fill: "#FFDA44"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M8.956 85.337H0v7.103L206.229 256 0 419.559v7.104h8.956l208.168-165.098H512v-11.13H217.124z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M63.718 292.382v-14.295c14.265 0 25.87-11.606 25.87-25.869 0-10.092-8.211-18.303-18.304-18.303-6.875 0-12.469 5.593-12.469 12.469 0 4.397 3.577 7.974 7.974 7.974a4.514 4.514 0 0 0 4.508-4.508h14.295c0 10.368-8.435 18.804-18.802 18.804-12.279-.002-22.269-9.993-22.269-22.271 0-14.758 12.006-26.764 26.764-26.764 17.975 0 32.599 14.623 32.599 32.599 0 22.145-18.018 40.164-40.166 40.164z"
    })));
};
var $b832709c107c9253$export$2791da67db7afdb6 = function WF(_ref247) {
    var title = _ref247.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref247, $b832709c107c9253$var$_excluded247);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 150 100"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80B30",
        d: "M0 0h150v100H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#00318A",
        d: "M0 0h20v44.33H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M20 0h20v44.33H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "none",
        stroke: "#FFF",
        strokeWidth: 3,
        d: "M0 44.33h62.75V0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M108.08 43.29 87.96 23.17h40.25l-20.13 20.12zm-6.7 6.71L81.25 29.88v40.25L101.38 50zm6.7 6.71L87.96 76.83h40.25l-20.13-20.12zm6.71-6.71 20.13-20.13v40.25L114.79 50z"
    }));
};
var $b832709c107c9253$export$911baa0677ac404c = function WS(_ref248) {
    var title = _ref248.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref248, $b832709c107c9253$var$_excluded248);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 85.331h256v170.663H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m165.483 181.79 2.764 8.504h8.939l-7.232 5.254 2.763 8.503-7.234-5.255-7.233 5.255 2.763-8.503-7.233-5.254h8.94zm-44.904-66.783 4.606 14.173h14.9l-12.055 8.757 4.605 14.171-12.056-8.758-12.054 8.758 4.605-14.171-12.056-8.757h14.901zm44.522 14.841 4.606 14.172h14.9l-12.055 8.757 4.604 14.173-12.055-8.76-12.054 8.76 4.604-14.173-12.055-8.757h14.9zm-35.192 59.363 4.606 14.172h14.9l-12.055 8.758 4.604 14.171-12.055-8.759-12.054 8.759 4.604-14.171-12.055-8.758h14.9zm-39.01-37.103 4.605 14.173h14.9l-12.055 8.757 4.604 14.173-12.054-8.76-12.055 8.76 4.604-14.173-12.055-8.757h14.9z",
        fill: "#FFF"
    }));
};
var $b832709c107c9253$export$ba5d28d969e41cd5 = function XK(_ref249) {
    var title = _ref249.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref249, $b832709c107c9253$var$_excluded249);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 341.33"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#0052B4",
        d: "M0 0h512v341.34H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "m220.72 42.63 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.36-15.9 8.36 3.03-17.7-12.86-12.54 17.78-2.58zm70.56-.06 7.95 16.1 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59zm62.08 11.36 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.87-12.54 17.78-2.58zm63.01 18.3 7.95 16.11 17.77 2.59-12.86 12.53 3.04 17.71-15.9-8.36-15.9 8.36 3.03-17.71-12.86-12.53 17.78-2.59zm-257.73-18.3 7.95 16.11 17.78 2.58-12.87 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.86-12.54 17.77-2.58zm-63.01 18.3 7.95 16.11 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59z",
        fill: "#FFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m217.53 259.33-27.22-13.61-27.22-54.43h27.22l27.22-27.22 13.61-27.22 27.22-13.61 13.61 13.61 27.22 13.61v13.61l13.61 13.61 40.83 27.22L340 245.73l-40.83 40.83-13.61-27.22-40.83 27.22v27.22l-13.61-13.61-13.59-40.84z"
    }));
};
var $b832709c107c9253$export$5c4a0ca5352789e5 = function YE(_ref250) {
    var title = _ref250.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref250, $b832709c107c9253$var$_excluded250);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M0 85.337h512v113.775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 312.888h512v113.775H0z"
    }));
};
var $b832709c107c9253$export$8c2e794969bbe829 = function YT(_ref251) {
    var title = _ref251.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref251, $b832709c107c9253$var$_excluded251);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 90 60"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 0h90v60H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        stroke: "#7f7f7f",
        strokeWidth: 0.25,
        fill: "#ABABAB",
        d: "M75.6 39.6c-1.1.7 0 1.8-.6 1.9-.6.1-1.5-1.4-.2-2.5 1.6-1.5 5.8 0 5.9 4.3 0 2.2-.9 6.8-7.2 6.8-7.6 0-11.4-5.7-11.4-11.4 0-4.8 3.7-13.5 6.5-14.6 3.1-1.2 6.7-3.5 6.8-5 0-.5-1.4-.1-3.3.9-3.1 1.7-6.6 2.5-6.6 1.4s2.9-3.1 4-4.6c1.2-1.6.9-5.5 3-5.5 7.6 0 9.9 7.7 7 11.7-1.9 2.6 4.3 1 4.3 1s0 5.3-3.2 7.3c-3 1.8-4.8 3.9-4.8 3.9s.2-4.6-.5-3.9c-.6.7-11.1 4.5-10.3 12 .3 3 4.5 5.4 8.5 5.2s5.7-2.4 5.8-4.9c.1-3.9-3-4.4-3.7-4zm-64.9 4c.1 2.5 1.8 4.7 5.8 4.9s8.2-2.2 8.5-5.2c.8-7.5-9.7-11.3-10.3-12-.7-.7-.5 3.9-.5 3.9s-1.8-2.1-4.8-3.9c-3.2-2-3.2-7.3-3.2-7.3s6.2 1.6 4.3-1c-2.9-4-.6-11.7 7-11.7 2.1 0 1.8 3.9 3 5.5 1.1 1.5 4 3.5 4 4.6s-3.5.3-6.6-1.4c-1.9-1-3.3-1.4-3.3-.9.1 1.5 3.7 3.8 6.8 5 2.8 1.1 6.5 9.8 6.5 14.6 0 5.7-3.8 11.4-11.4 11.4-6.3 0-7.2-4.6-7.2-6.8.1-4.3 4.3-5.8 5.9-4.3 1.2 1.1.4 2.7-.2 2.5-.6-.1.6-1.2-.6-1.9-.6-.4-3.7.1-3.7 4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#DE393A",
        d: "M31 28.8v14c0 1.9 2.1 1.6 2.1 1.6h9.3c1.2 0 2.6 2.3 2.6 2.3s1.4-2.3 2.5-2.3h9.6s2 .2 2-1.8V28.7H31z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#3951A3",
        d: "M31 13.1h28v15.7H31z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M50.1 16.5c-.4 2.4-2.5 4.2-5.1 4.2-2.5 0-4.6-1.8-5.1-4.2-.5.9-.8 1.9-.8 3 0 3.3 2.6 5.9 5.9 5.9 3.3 0 5.9-2.6 5.9-5.9 0-1.1-.3-2.1-.8-3z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FEE05F",
        cx: 39.1,
        cy: 36.5,
        r: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("circle", {
        fill: "#FEE05F",
        cx: 50.9,
        cy: 36.5,
        r: 3
    }));
};
var $b832709c107c9253$export$b2eccbdcd109dde0 = function ZA(_ref252) {
    var title = _ref252.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref252, $b832709c107c9253$var$_excluded252);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M0 85.337h512v341.326H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M114.024 256.001 0 141.926v228.17z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#ffb915",
        d: "M161.192 256 0 94.7v47.226l114.024 114.075L0 370.096v47.138z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#007847",
        d: "M509.833 289.391c.058-.44.804-.878 2.167-1.318v-65.464H222.602L85.33 85.337H0V94.7L161.192 256 0 417.234v9.429h85.33l137.272-137.272h287.231z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#000c8a",
        d: "M503.181 322.783H236.433l-103.881 103.88H512v-103.88z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#e1392d",
        d: "M503.181 189.217H512V85.337H132.552l103.881 103.88z"
    }));
};
var $b832709c107c9253$export$8b0f08115411339f = function ZM(_ref253) {
    var title = _ref253.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref253, $b832709c107c9253$var$_excluded253);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#496E2D",
        d: "M0 85.331h512v341.337H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FF9811",
        d: "M490.668 195.476h-48c0-8.836-7.164-16-16-16s-16 7.164-16 16h-48c0 8.836 7.697 16 16.533 16h-.533c0 8.836 7.162 16 16 16 0 8.836 7.162 16 16 16h32c8.836 0 16-7.164 16-16 8.836 0 16-7.164 16-16h-.533c8.837 0 16.533-7.164 16.533-16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "M341.337 255.994h56.888v170.663h-56.888z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FF9811",
        d: "M455.112 255.994H512v170.663h-56.888z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M398.225 255.994h56.888v170.663h-56.888z"
    }));
};
var $b832709c107c9253$export$b2fd9c01d360241f = function ZW(_ref254) {
    var title = _ref254.title, rest = $b832709c107c9253$var$_objectWithoutProperties(_ref254, $b832709c107c9253$var$_excluded254);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("svg", $b832709c107c9253$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 85.333 512 341.333"
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 85.333h512V426.67H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 134.196h512v48.868H0zm0 195.472h512v48.868H0z",
        fill: "#FFDA44"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#057f44",
        d: "M0 85.333h512v48.868H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M0 183.069h512v48.868H0zm0 97.737h512v48.868H0z",
        fill: "#D80027"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#057f44",
        d: "M0 378.542h512v48.128H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFF",
        d: "M276.992 255.996 106.329 426.659H0V85.333h106.329z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        d: "M256 255.996 85.334 426.662h20.987l170.667-170.666L106.321 85.33H85.334z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#D80027",
        d: "m102.465 202.57 13.259 40.812h42.917l-34.718 25.226 13.26 40.814-34.718-25.224-34.72 25.224 13.262-40.814-34.718-25.226h42.915z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement("path", {
        fill: "#FFDA44",
        d: "m138.94 259.335-34.559-12.243s-2.553-23.955-2.708-24.766c-1.173-6.18-6.603-10.851-13.123-10.851-7.376 0-13.357 5.98-13.357 13.357 0 1.223.178 2.402.486 3.528l-9.689 9.755h17.229c0 17.882-13.344 17.882-13.344 35.691l7.402 17.809h44.522l7.422-17.809h-.004a17.782 17.782 0 0 0 1.381-5.231c6.397-2.589 8.342-9.24 8.342-9.24z"
    }));
};
var $b832709c107c9253$export$2e2bcd8739ae039 = {
    AC: $b832709c107c9253$export$871e5f91a510f021,
    AD: $b832709c107c9253$export$132ea4ffd82bf2b2,
    AE: $b832709c107c9253$export$2b2c8e343c91a153,
    AF: $b832709c107c9253$export$515692adc069839f,
    AG: $b832709c107c9253$export$9b1a14e161c718eb,
    AI: $b832709c107c9253$export$d710c5f50fc7496a,
    AL: $b832709c107c9253$export$1bb1140fe1358b00,
    AM: $b832709c107c9253$export$1507e1869e034170,
    AO: $b832709c107c9253$export$98cc8105f49bb278,
    AQ: $b832709c107c9253$export$123513653fa883e4,
    AR: $b832709c107c9253$export$1cd25c0dace0921a,
    AS: $b832709c107c9253$export$33f07343a4b8be1f,
    AT: $b832709c107c9253$export$537de78b98ba1ef0,
    AU: $b832709c107c9253$export$24f205cbfb89b8fc,
    AW: $b832709c107c9253$export$d170d5872abbd45,
    AX: $b832709c107c9253$export$f5cd1d288a5591fb,
    AZ: $b832709c107c9253$export$16cde7da05f651a,
    BA: $b832709c107c9253$export$a73c4d14459b698d,
    BB: $b832709c107c9253$export$921068d8846a1559,
    BD: $b832709c107c9253$export$2672079d1ac1dedf,
    BE: $b832709c107c9253$export$69784246352913ed,
    BF: $b832709c107c9253$export$5d7d56d6166de861,
    BG: $b832709c107c9253$export$7ecc97c3ec9172d0,
    BH: $b832709c107c9253$export$873be2d0c4c0f90f,
    BI: $b832709c107c9253$export$2601bd2ab73f6dbe,
    BJ: $b832709c107c9253$export$289e628e47fc68d4,
    BL: $b832709c107c9253$export$b54e584898971a5,
    BM: $b832709c107c9253$export$f063c90a7fd94f53,
    BN: $b832709c107c9253$export$ed16643e9b9e3dfe,
    BO: $b832709c107c9253$export$cd6527c992e4b6fe,
    BQ: $b832709c107c9253$export$2ca204c58a1fc922,
    BR: $b832709c107c9253$export$b3e0c086157e0a90,
    BS: $b832709c107c9253$export$66ea4a98fa009686,
    BT: $b832709c107c9253$export$433b53d451a98e6d,
    BV: $b832709c107c9253$export$8ba1594c72a88684,
    BW: $b832709c107c9253$export$cd7b90d76addb66a,
    BY: $b832709c107c9253$export$558af6901b7fc79a,
    BZ: $b832709c107c9253$export$8af59566cb38fe85,
    CA: $b832709c107c9253$export$8de6180416dff1fc,
    CC: $b832709c107c9253$export$183b2a0874e6e919,
    CD: $b832709c107c9253$export$6ede307faf7aaec4,
    CF: $b832709c107c9253$export$ba26f2d80491fb47,
    CG: $b832709c107c9253$export$9e8da9070f3c2e68,
    CH: $b832709c107c9253$export$31ff2235b44019b8,
    CI: $b832709c107c9253$export$ddcf9efc80efb978,
    CK: $b832709c107c9253$export$2779adff9720d9c9,
    CL: $b832709c107c9253$export$9bf3043cb7503aa1,
    CM: $b832709c107c9253$export$dcd191669c0a595f,
    CN: $b832709c107c9253$export$f175668af5171efd,
    CO: $b832709c107c9253$export$423e5ab65bdedcb8,
    CR: $b832709c107c9253$export$de92be486109a1df,
    CU: $b832709c107c9253$export$6f478fc577ffffe3,
    CV: $b832709c107c9253$export$9c7a4b602f1ee953,
    CW: $b832709c107c9253$export$640171019d58eb6d,
    CX: $b832709c107c9253$export$ef748afa94c5c5f9,
    CY: $b832709c107c9253$export$e5e7583d5d9c5f7b,
    CZ: $b832709c107c9253$export$3aa7db55ae20a642,
    DE: $b832709c107c9253$export$b2bfc53cef5629f5,
    DJ: $b832709c107c9253$export$b116121769fff50f,
    DK: $b832709c107c9253$export$861a3271cad515fc,
    DM: $b832709c107c9253$export$c63caaa7a05b64da,
    DO: $b832709c107c9253$export$fe81c0b6cf107daf,
    DZ: $b832709c107c9253$export$d2309a4fc782a0d1,
    EC: $b832709c107c9253$export$129fe12d32abc311,
    EE: $b832709c107c9253$export$3f443bcc5237c742,
    EG: $b832709c107c9253$export$e107e11ec3489258,
    EH: $b832709c107c9253$export$8e048a19e03780a2,
    ER: $b832709c107c9253$export$20e28a5cfb7c13df,
    ES: $b832709c107c9253$export$a723e6e41cced9bd,
    ET: $b832709c107c9253$export$404386694049c788,
    EU: $b832709c107c9253$export$f005962cdbec7017,
    FI: $b832709c107c9253$export$b742dc37108d5cac,
    FJ: $b832709c107c9253$export$4cd493ed69e3bc18,
    FK: $b832709c107c9253$export$58f4e3559034e3ed,
    FM: $b832709c107c9253$export$ae39d226e90e08ef,
    FO: $b832709c107c9253$export$3117889032a11ab0,
    FR: $b832709c107c9253$export$b0bfe88d8be86eef,
    GA: $b832709c107c9253$export$2c816677949efbbf,
    GB: $b832709c107c9253$export$5c1daad85ece4f0d,
    GD: $b832709c107c9253$export$44132903afebf574,
    GE: $b832709c107c9253$export$64f1adb8dced2c27,
    GF: $b832709c107c9253$export$a1c692af90f0ad93,
    GG: $b832709c107c9253$export$ffd553dab4f92f72,
    GH: $b832709c107c9253$export$2063236980199869,
    GI: $b832709c107c9253$export$b3b059666b470a4,
    GL: $b832709c107c9253$export$bad2a840ccda93b6,
    GM: $b832709c107c9253$export$af02b8e3ecf08df4,
    GN: $b832709c107c9253$export$49b768d2cda4fc68,
    GP: $b832709c107c9253$export$a1e9daa76fd80d91,
    GQ: $b832709c107c9253$export$64532cc081f88b3a,
    GR: $b832709c107c9253$export$be3bb2d6fb94aa6,
    GS: $b832709c107c9253$export$f7fbe7cb90eabcb4,
    GT: $b832709c107c9253$export$b023c82b48e70453,
    GU: $b832709c107c9253$export$875a05f1afdc3a63,
    GW: $b832709c107c9253$export$4f7b2a18b14c6e6,
    GY: $b832709c107c9253$export$f433acc20da515b9,
    HK: $b832709c107c9253$export$7bf8e436292b0d9,
    HM: $b832709c107c9253$export$e8ae668e70e7a813,
    HN: $b832709c107c9253$export$d654914ee99e1b51,
    HR: $b832709c107c9253$export$41dbabafe943a3bc,
    HT: $b832709c107c9253$export$3927bce5ead7457e,
    HU: $b832709c107c9253$export$2cba20fb7b4c6fda,
    IC: $b832709c107c9253$export$520d469a2f25f64a,
    ID: $b832709c107c9253$export$8be180ec26319f9f,
    IE: $b832709c107c9253$export$5056f4df3c1a040a,
    IL: $b832709c107c9253$export$747f5b589ac90db,
    IM: $b832709c107c9253$export$5e0fd3f816252990,
    IN: $b832709c107c9253$export$70824c8942178d60,
    IO: $b832709c107c9253$export$8f8422ac5947a789,
    IQ: $b832709c107c9253$export$776a9becd139230f,
    IR: $b832709c107c9253$export$35f3e3f7e3ce71e0,
    IS: $b832709c107c9253$export$bfe27467c1de9413,
    IT: $b832709c107c9253$export$c8c4756768edc1be,
    JE: $b832709c107c9253$export$7300d7e65520d9c0,
    JM: $b832709c107c9253$export$62925b2b1d8826f,
    JO: $b832709c107c9253$export$4ff8ba3b6e78910e,
    JP: $b832709c107c9253$export$4165087edc6149ea,
    KE: $b832709c107c9253$export$ebf06250eda1662e,
    KG: $b832709c107c9253$export$32f37961c13d8178,
    KH: $b832709c107c9253$export$96381358fb12b492,
    KI: $b832709c107c9253$export$8aa7bcd4299a59b9,
    KM: $b832709c107c9253$export$7ca86d88f982585b,
    KN: $b832709c107c9253$export$fd8f06eb7ce62883,
    KP: $b832709c107c9253$export$171643e72dc5e91,
    KR: $b832709c107c9253$export$ced591d2396bbc3f,
    KW: $b832709c107c9253$export$867391011d376267,
    KY: $b832709c107c9253$export$ea257f329676e0aa,
    KZ: $b832709c107c9253$export$45edc2c6b51c02b3,
    LA: $b832709c107c9253$export$64f943d6c6d62030,
    LB: $b832709c107c9253$export$1dd3e96947fb44fc,
    LC: $b832709c107c9253$export$3cb73e0e841fe17f,
    LI: $b832709c107c9253$export$2e3013aac067a692,
    LK: $b832709c107c9253$export$782aca1f2c103f6b,
    LR: $b832709c107c9253$export$9e0d336de5ae0eb3,
    LS: $b832709c107c9253$export$c6944423ed371873,
    LT: $b832709c107c9253$export$7158f0ceb70f54c7,
    LU: $b832709c107c9253$export$b6a2dd8a7c2d6cd5,
    LV: $b832709c107c9253$export$feea9fafc15a0118,
    LY: $b832709c107c9253$export$4eb7334fca20385f,
    MA: $b832709c107c9253$export$d88940c21edc1e8e,
    MC: $b832709c107c9253$export$cd68417dc2ec295d,
    MD: $b832709c107c9253$export$3c37c3bdb860ae1e,
    ME: $b832709c107c9253$export$4898541b722d275d,
    MF: $b832709c107c9253$export$33916af50bbab5f5,
    MG: $b832709c107c9253$export$d7c1ae0cf4ef5274,
    MH: $b832709c107c9253$export$61a81a4b59098e0c,
    MK: $b832709c107c9253$export$9391ff7d7f7d79ce,
    ML: $b832709c107c9253$export$670dad092b145ea,
    MM: $b832709c107c9253$export$eefdfd8a735ff143,
    MN: $b832709c107c9253$export$30e7c6589c527eef,
    MO: $b832709c107c9253$export$511fbc18fa6ca984,
    MP: $b832709c107c9253$export$15b7d6cdd29b06a0,
    MQ: $b832709c107c9253$export$451b471c9c9066b,
    MR: $b832709c107c9253$export$c4e38e98e3fb5f60,
    MS: $b832709c107c9253$export$71ad59f2e432cfe8,
    MT: $b832709c107c9253$export$b900a375df2ae552,
    MU: $b832709c107c9253$export$c5764e4399dad848,
    MV: $b832709c107c9253$export$20138591ba7d4d60,
    MW: $b832709c107c9253$export$a3772f6eb527275b,
    MX: $b832709c107c9253$export$80b36494c451f15f,
    MY: $b832709c107c9253$export$655dc88003efaac0,
    MZ: $b832709c107c9253$export$b5030f3cedb7f384,
    NA: $b832709c107c9253$export$dbd1925f4fe9ec65,
    NC: $b832709c107c9253$export$fbcebdb931d67ac9,
    NE: $b832709c107c9253$export$8719acbfb72c829,
    NF: $b832709c107c9253$export$ebe65a9e9fde641f,
    NG: $b832709c107c9253$export$d9501190a8cd7a46,
    NI: $b832709c107c9253$export$2128ddd8b6e5cc05,
    NL: $b832709c107c9253$export$e51d3c675bb0140d,
    NO: $b832709c107c9253$export$c01351c0af048e39,
    NP: $b832709c107c9253$export$575bf2af220888ee,
    NR: $b832709c107c9253$export$8885480fb36cb8cc,
    NU: $b832709c107c9253$export$8227ca023eb0daaa,
    NZ: $b832709c107c9253$export$b6db8d689596ccb0,
    OM: $b832709c107c9253$export$1ed389bd9cb529,
    PA: $b832709c107c9253$export$ff7e3d480d313da2,
    PE: $b832709c107c9253$export$d5e55eb9565ea8d5,
    PF: $b832709c107c9253$export$7d19ebf018caa9aa,
    PG: $b832709c107c9253$export$c56943b7b8ffea21,
    PH: $b832709c107c9253$export$38ea63fabb2c685f,
    PK: $b832709c107c9253$export$73910688e185534c,
    PL: $b832709c107c9253$export$9e95f02561f2d9f9,
    PM: $b832709c107c9253$export$164607a37e7daeba,
    PN: $b832709c107c9253$export$6bc8c38c416ebf89,
    PR: $b832709c107c9253$export$af5f8d68aad3cd3a,
    PS: $b832709c107c9253$export$5adddb0645f34b2,
    PT: $b832709c107c9253$export$3961bdb9130b90e7,
    PW: $b832709c107c9253$export$5f5211c171c1b47a,
    PY: $b832709c107c9253$export$21b6e0fb60b525ae,
    QA: $b832709c107c9253$export$a7078eadaecd4b6f,
    RE: $b832709c107c9253$export$ded96516917cab2a,
    RO: $b832709c107c9253$export$993ec495e78d530d,
    RS: $b832709c107c9253$export$e9d8d46fbf5f29f6,
    RU: $b832709c107c9253$export$6c2517b5e52f01cc,
    RW: $b832709c107c9253$export$ef5ca6a08aac8ca5,
    SA: $b832709c107c9253$export$da51c6332ad11d7b,
    SB: $b832709c107c9253$export$279f8048cbf05e80,
    SC: $b832709c107c9253$export$f49cccbff6374af4,
    SD: $b832709c107c9253$export$5b088def975a652b,
    SE: $b832709c107c9253$export$88d2e60d4be28663,
    SG: $b832709c107c9253$export$bea437c40441867d,
    SH: $b832709c107c9253$export$c713cf928ffb5e8e,
    SI: $b832709c107c9253$export$e6702cab675b095,
    SJ: $b832709c107c9253$export$e9f025fd23256930,
    SK: $b832709c107c9253$export$5f584391ee0d99b4,
    SL: $b832709c107c9253$export$b49d6918df199090,
    SM: $b832709c107c9253$export$59096964bd9627ef,
    SN: $b832709c107c9253$export$b70f9dd36a734be4,
    SO: $b832709c107c9253$export$f6311706676f39f2,
    SR: $b832709c107c9253$export$13acf42283a26926,
    SS: $b832709c107c9253$export$8cda4cf3f4deb8c2,
    ST: $b832709c107c9253$export$80980ed6b6f31397,
    SV: $b832709c107c9253$export$8fc936c6ebd916b3,
    SX: $b832709c107c9253$export$b4f896bb97547f66,
    SY: $b832709c107c9253$export$2e8caadc521d7cbb,
    SZ: $b832709c107c9253$export$988c8b3cfeed3531,
    TA: $b832709c107c9253$export$6b4abaf3a097db68,
    TC: $b832709c107c9253$export$bf91931db7b40921,
    TD: $b832709c107c9253$export$9cf5b401f969f5e3,
    TF: $b832709c107c9253$export$4014e91f2965d3df,
    TG: $b832709c107c9253$export$3909ee2d70cce411,
    TH: $b832709c107c9253$export$2b39a3648955dd09,
    TJ: $b832709c107c9253$export$f5448d52a2727e70,
    TK: $b832709c107c9253$export$73184284939cbbe8,
    TL: $b832709c107c9253$export$28666a74ae2b9cff,
    TM: $b832709c107c9253$export$e3227e6e5fca8775,
    TN: $b832709c107c9253$export$82039c5ab5b44a72,
    TO: $b832709c107c9253$export$ee525e60afffec7b,
    TR: $b832709c107c9253$export$5582bd7183a5e873,
    TT: $b832709c107c9253$export$c506431d6b27243b,
    TV: $b832709c107c9253$export$9e799ed47e538f9d,
    TW: $b832709c107c9253$export$1d1fd77441e66de6,
    TZ: $b832709c107c9253$export$786aa6dc686c7fa2,
    UA: $b832709c107c9253$export$4b88e746e0f81154,
    UG: $b832709c107c9253$export$c5b3cc9fdc52ea1d,
    UM: $b832709c107c9253$export$a0e1852ae1fae17b,
    US: $b832709c107c9253$export$6137fb82cd5996e9,
    UY: $b832709c107c9253$export$3f448fbd9cc8b25f,
    UZ: $b832709c107c9253$export$6553e0f362fae356,
    VA: $b832709c107c9253$export$8f976c058e984810,
    VC: $b832709c107c9253$export$c3ea4fdfa4d8ecb7,
    VE: $b832709c107c9253$export$d7d2699f2b01bb80,
    VG: $b832709c107c9253$export$42769a1039364fc6,
    VI: $b832709c107c9253$export$ae144c30ed7463e6,
    VN: $b832709c107c9253$export$4ef9166b5b9f8bef,
    VU: $b832709c107c9253$export$e4fcd53a919210fd,
    WF: $b832709c107c9253$export$2791da67db7afdb6,
    WS: $b832709c107c9253$export$911baa0677ac404c,
    XK: $b832709c107c9253$export$ba5d28d969e41cd5,
    YE: $b832709c107c9253$export$5c4a0ca5352789e5,
    YT: $b832709c107c9253$export$8c2e794969bbe829,
    ZA: $b832709c107c9253$export$b2eccbdcd109dde0,
    ZM: $b832709c107c9253$export$8b0f08115411339f,
    ZW: $b832709c107c9253$export$b2fd9c01d360241f
};

});


parcelRegister("aZEA4", function(module, exports) {

$parcel$export(module.exports, "countries", () => $800f1464c09562a0$export$e5ad74579c86b003);
/*! countries-list v3.1.1 by Annexare | MIT */ var $800f1464c09562a0$export$1215efa45e6f9581 = {
    AF: "Africa",
    AN: "Antarctica",
    AS: "Asia",
    EU: "Europe",
    NA: "North America",
    OC: "Oceania",
    SA: "South America"
};
var $800f1464c09562a0$export$e5ad74579c86b003 = {
    AD: {
        name: "Andorra",
        native: "Andorra",
        phone: [
            376
        ],
        continent: "EU",
        capital: "Andorra la Vella",
        currency: [
            "EUR"
        ],
        languages: [
            "ca"
        ]
    },
    AE: {
        name: "United Arab Emirates",
        native: "\u062F\u0648\u0644\u0629 \u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
        phone: [
            971
        ],
        continent: "AS",
        capital: "Abu Dhabi",
        currency: [
            "AED"
        ],
        languages: [
            "ar"
        ]
    },
    AF: {
        name: "Afghanistan",
        native: "\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646",
        phone: [
            93
        ],
        continent: "AS",
        capital: "Kabul",
        currency: [
            "AFN"
        ],
        languages: [
            "ps",
            "uz",
            "tk"
        ]
    },
    AG: {
        name: "Antigua and Barbuda",
        native: "Antigua and Barbuda",
        phone: [
            1268
        ],
        continent: "NA",
        capital: "Saint John's",
        currency: [
            "XCD"
        ],
        languages: [
            "en"
        ]
    },
    AI: {
        name: "Anguilla",
        native: "Anguilla",
        phone: [
            1264
        ],
        continent: "NA",
        capital: "The Valley",
        currency: [
            "XCD"
        ],
        languages: [
            "en"
        ]
    },
    AL: {
        name: "Albania",
        native: "Shqip\xebria",
        phone: [
            355
        ],
        continent: "EU",
        capital: "Tirana",
        currency: [
            "ALL"
        ],
        languages: [
            "sq"
        ]
    },
    AM: {
        name: "Armenia",
        native: "\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576",
        phone: [
            374
        ],
        continent: "AS",
        capital: "Yerevan",
        currency: [
            "AMD"
        ],
        languages: [
            "hy",
            "ru"
        ]
    },
    AO: {
        name: "Angola",
        native: "Angola",
        phone: [
            244
        ],
        continent: "AF",
        capital: "Luanda",
        currency: [
            "AOA"
        ],
        languages: [
            "pt"
        ]
    },
    AQ: {
        name: "Antarctica",
        native: "Antarctica",
        phone: [
            672
        ],
        continent: "AN",
        capital: "",
        currency: [],
        languages: []
    },
    AR: {
        name: "Argentina",
        native: "Argentina",
        phone: [
            54
        ],
        continent: "SA",
        capital: "Buenos Aires",
        currency: [
            "ARS"
        ],
        languages: [
            "es",
            "gn"
        ]
    },
    AS: {
        name: "American Samoa",
        native: "American Samoa",
        phone: [
            1684
        ],
        continent: "OC",
        capital: "Pago Pago",
        currency: [
            "USD"
        ],
        languages: [
            "en",
            "sm"
        ]
    },
    AT: {
        name: "Austria",
        native: "\xd6sterreich",
        phone: [
            43
        ],
        continent: "EU",
        capital: "Vienna",
        currency: [
            "EUR"
        ],
        languages: [
            "de"
        ]
    },
    AU: {
        name: "Australia",
        native: "Australia",
        phone: [
            61
        ],
        continent: "OC",
        capital: "Canberra",
        currency: [
            "AUD"
        ],
        languages: [
            "en"
        ]
    },
    AW: {
        name: "Aruba",
        native: "Aruba",
        phone: [
            297
        ],
        continent: "NA",
        capital: "Oranjestad",
        currency: [
            "AWG"
        ],
        languages: [
            "nl",
            "pa"
        ]
    },
    AX: {
        name: "Aland",
        native: "\xc5land",
        phone: [
            358
        ],
        continent: "EU",
        capital: "Mariehamn",
        currency: [
            "EUR"
        ],
        languages: [
            "sv"
        ],
        partOf: "FI"
    },
    AZ: {
        name: "Azerbaijan",
        native: "Az\u0259rbaycan",
        phone: [
            994
        ],
        continent: "AS",
        continents: [
            "AS",
            "EU"
        ],
        capital: "Baku",
        currency: [
            "AZN"
        ],
        languages: [
            "az"
        ]
    },
    BA: {
        name: "Bosnia and Herzegovina",
        native: "Bosna i Hercegovina",
        phone: [
            387
        ],
        continent: "EU",
        capital: "Sarajevo",
        currency: [
            "BAM"
        ],
        languages: [
            "bs",
            "hr",
            "sr"
        ]
    },
    BB: {
        name: "Barbados",
        native: "Barbados",
        phone: [
            1246
        ],
        continent: "NA",
        capital: "Bridgetown",
        currency: [
            "BBD"
        ],
        languages: [
            "en"
        ]
    },
    BD: {
        name: "Bangladesh",
        native: "Bangladesh",
        phone: [
            880
        ],
        continent: "AS",
        capital: "Dhaka",
        currency: [
            "BDT"
        ],
        languages: [
            "bn"
        ]
    },
    BE: {
        name: "Belgium",
        native: "Belgi\xeb",
        phone: [
            32
        ],
        continent: "EU",
        capital: "Brussels",
        currency: [
            "EUR"
        ],
        languages: [
            "nl",
            "fr",
            "de"
        ]
    },
    BF: {
        name: "Burkina Faso",
        native: "Burkina Faso",
        phone: [
            226
        ],
        continent: "AF",
        capital: "Ouagadougou",
        currency: [
            "XOF"
        ],
        languages: [
            "fr",
            "ff"
        ]
    },
    BG: {
        name: "Bulgaria",
        native: "\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F",
        phone: [
            359
        ],
        continent: "EU",
        capital: "Sofia",
        currency: [
            "BGN"
        ],
        languages: [
            "bg"
        ]
    },
    BH: {
        name: "Bahrain",
        native: "\u200F\u0627\u0644\u0628\u062D\u0631\u064A\u0646",
        phone: [
            973
        ],
        continent: "AS",
        capital: "Manama",
        currency: [
            "BHD"
        ],
        languages: [
            "ar"
        ]
    },
    BI: {
        name: "Burundi",
        native: "Burundi",
        phone: [
            257
        ],
        continent: "AF",
        capital: "Bujumbura",
        currency: [
            "BIF"
        ],
        languages: [
            "fr",
            "rn"
        ]
    },
    BJ: {
        name: "Benin",
        native: "B\xe9nin",
        phone: [
            229
        ],
        continent: "AF",
        capital: "Porto-Novo",
        currency: [
            "XOF"
        ],
        languages: [
            "fr"
        ]
    },
    BL: {
        name: "Saint Barthelemy",
        native: "Saint-Barth\xe9lemy",
        phone: [
            590
        ],
        continent: "NA",
        capital: "Gustavia",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    BM: {
        name: "Bermuda",
        native: "Bermuda",
        phone: [
            1441
        ],
        continent: "NA",
        capital: "Hamilton",
        currency: [
            "BMD"
        ],
        languages: [
            "en"
        ]
    },
    BN: {
        name: "Brunei",
        native: "Negara Brunei Darussalam",
        phone: [
            673
        ],
        continent: "AS",
        capital: "Bandar Seri Begawan",
        currency: [
            "BND"
        ],
        languages: [
            "ms"
        ]
    },
    BO: {
        name: "Bolivia",
        native: "Bolivia",
        phone: [
            591
        ],
        continent: "SA",
        capital: "Sucre",
        currency: [
            "BOB",
            "BOV"
        ],
        languages: [
            "es",
            "ay",
            "qu"
        ]
    },
    BQ: {
        name: "Bonaire",
        native: "Bonaire",
        phone: [
            5997
        ],
        continent: "NA",
        capital: "Kralendijk",
        currency: [
            "USD"
        ],
        languages: [
            "nl"
        ]
    },
    BR: {
        name: "Brazil",
        native: "Brasil",
        phone: [
            55
        ],
        continent: "SA",
        capital: "Bras\xedlia",
        currency: [
            "BRL"
        ],
        languages: [
            "pt"
        ]
    },
    BS: {
        name: "Bahamas",
        native: "Bahamas",
        phone: [
            1242
        ],
        continent: "NA",
        capital: "Nassau",
        currency: [
            "BSD"
        ],
        languages: [
            "en"
        ]
    },
    BT: {
        name: "Bhutan",
        native: "\u02BCbrug-yul",
        phone: [
            975
        ],
        continent: "AS",
        capital: "Thimphu",
        currency: [
            "BTN",
            "INR"
        ],
        languages: [
            "dz"
        ]
    },
    BV: {
        name: "Bouvet Island",
        native: "Bouvet\xf8ya",
        phone: [
            47
        ],
        continent: "AN",
        capital: "",
        currency: [
            "NOK"
        ],
        languages: [
            "no",
            "nb",
            "nn"
        ]
    },
    BW: {
        name: "Botswana",
        native: "Botswana",
        phone: [
            267
        ],
        continent: "AF",
        capital: "Gaborone",
        currency: [
            "BWP"
        ],
        languages: [
            "en",
            "tn"
        ]
    },
    BY: {
        name: "Belarus",
        native: "\u0411\u0435\u043B\u0430\u0440\u0443\u0301\u0441\u044C",
        phone: [
            375
        ],
        continent: "EU",
        capital: "Minsk",
        currency: [
            "BYN"
        ],
        languages: [
            "be",
            "ru"
        ]
    },
    BZ: {
        name: "Belize",
        native: "Belize",
        phone: [
            501
        ],
        continent: "NA",
        capital: "Belmopan",
        currency: [
            "BZD"
        ],
        languages: [
            "en",
            "es"
        ]
    },
    CA: {
        name: "Canada",
        native: "Canada",
        phone: [
            1
        ],
        continent: "NA",
        capital: "Ottawa",
        currency: [
            "CAD"
        ],
        languages: [
            "en",
            "fr"
        ]
    },
    CC: {
        name: "Cocos (Keeling) Islands",
        native: "Cocos (Keeling) Islands",
        phone: [
            61
        ],
        continent: "AS",
        capital: "West Island",
        currency: [
            "AUD"
        ],
        languages: [
            "en"
        ]
    },
    CD: {
        name: "Democratic Republic of the Congo",
        native: "R\xe9publique d\xe9mocratique du Congo",
        phone: [
            243
        ],
        continent: "AF",
        capital: "Kinshasa",
        currency: [
            "CDF"
        ],
        languages: [
            "fr",
            "ln",
            "kg",
            "sw",
            "lu"
        ]
    },
    CF: {
        name: "Central African Republic",
        native: "K\xf6d\xf6r\xf6s\xease t\xee B\xeaafr\xeeka",
        phone: [
            236
        ],
        continent: "AF",
        capital: "Bangui",
        currency: [
            "XAF"
        ],
        languages: [
            "fr",
            "sg"
        ]
    },
    CG: {
        name: "Republic of the Congo",
        native: "R\xe9publique du Congo",
        phone: [
            242
        ],
        continent: "AF",
        capital: "Brazzaville",
        currency: [
            "XAF"
        ],
        languages: [
            "fr",
            "ln"
        ]
    },
    CH: {
        name: "Switzerland",
        native: "Schweiz",
        phone: [
            41
        ],
        continent: "EU",
        capital: "Bern",
        currency: [
            "CHE",
            "CHF",
            "CHW"
        ],
        languages: [
            "de",
            "fr",
            "it"
        ]
    },
    CI: {
        name: "Ivory Coast",
        native: "C\xf4te d'Ivoire",
        phone: [
            225
        ],
        continent: "AF",
        capital: "Yamoussoukro",
        currency: [
            "XOF"
        ],
        languages: [
            "fr"
        ]
    },
    CK: {
        name: "Cook Islands",
        native: "Cook Islands",
        phone: [
            682
        ],
        continent: "OC",
        capital: "Avarua",
        currency: [
            "NZD"
        ],
        languages: [
            "en"
        ]
    },
    CL: {
        name: "Chile",
        native: "Chile",
        phone: [
            56
        ],
        continent: "SA",
        capital: "Santiago",
        currency: [
            "CLF",
            "CLP"
        ],
        languages: [
            "es"
        ]
    },
    CM: {
        name: "Cameroon",
        native: "Cameroon",
        phone: [
            237
        ],
        continent: "AF",
        capital: "Yaound\xe9",
        currency: [
            "XAF"
        ],
        languages: [
            "en",
            "fr"
        ]
    },
    CN: {
        name: "China",
        native: "\u4E2D\u56FD",
        phone: [
            86
        ],
        continent: "AS",
        capital: "Beijing",
        currency: [
            "CNY"
        ],
        languages: [
            "zh"
        ]
    },
    CO: {
        name: "Colombia",
        native: "Colombia",
        phone: [
            57
        ],
        continent: "SA",
        capital: "Bogot\xe1",
        currency: [
            "COP"
        ],
        languages: [
            "es"
        ]
    },
    CR: {
        name: "Costa Rica",
        native: "Costa Rica",
        phone: [
            506
        ],
        continent: "NA",
        capital: "San Jos\xe9",
        currency: [
            "CRC"
        ],
        languages: [
            "es"
        ]
    },
    CU: {
        name: "Cuba",
        native: "Cuba",
        phone: [
            53
        ],
        continent: "NA",
        capital: "Havana",
        currency: [
            "CUC",
            "CUP"
        ],
        languages: [
            "es"
        ]
    },
    CV: {
        name: "Cape Verde",
        native: "Cabo Verde",
        phone: [
            238
        ],
        continent: "AF",
        capital: "Praia",
        currency: [
            "CVE"
        ],
        languages: [
            "pt"
        ]
    },
    CW: {
        name: "Curacao",
        native: "Cura\xe7ao",
        phone: [
            5999
        ],
        continent: "NA",
        capital: "Willemstad",
        currency: [
            "ANG"
        ],
        languages: [
            "nl",
            "pa",
            "en"
        ]
    },
    CX: {
        name: "Christmas Island",
        native: "Christmas Island",
        phone: [
            61
        ],
        continent: "AS",
        capital: "Flying Fish Cove",
        currency: [
            "AUD"
        ],
        languages: [
            "en"
        ]
    },
    CY: {
        name: "Cyprus",
        native: "\u039A\u03CD\u03C0\u03C1\u03BF\u03C2",
        phone: [
            357
        ],
        continent: "EU",
        capital: "Nicosia",
        currency: [
            "EUR"
        ],
        languages: [
            "el",
            "tr",
            "hy"
        ]
    },
    CZ: {
        name: "Czech Republic",
        native: "\u010Cesk\xe1 republika",
        phone: [
            420
        ],
        continent: "EU",
        capital: "Prague",
        currency: [
            "CZK"
        ],
        languages: [
            "cs"
        ]
    },
    DE: {
        name: "Germany",
        native: "Deutschland",
        phone: [
            49
        ],
        continent: "EU",
        capital: "Berlin",
        currency: [
            "EUR"
        ],
        languages: [
            "de"
        ]
    },
    DJ: {
        name: "Djibouti",
        native: "Djibouti",
        phone: [
            253
        ],
        continent: "AF",
        capital: "Djibouti",
        currency: [
            "DJF"
        ],
        languages: [
            "fr",
            "ar"
        ]
    },
    DK: {
        name: "Denmark",
        native: "Danmark",
        phone: [
            45
        ],
        continent: "EU",
        continents: [
            "EU",
            "NA"
        ],
        capital: "Copenhagen",
        currency: [
            "DKK"
        ],
        languages: [
            "da"
        ]
    },
    DM: {
        name: "Dominica",
        native: "Dominica",
        phone: [
            1767
        ],
        continent: "NA",
        capital: "Roseau",
        currency: [
            "XCD"
        ],
        languages: [
            "en"
        ]
    },
    DO: {
        name: "Dominican Republic",
        native: "Rep\xfablica Dominicana",
        phone: [
            1809,
            1829,
            1849
        ],
        continent: "NA",
        capital: "Santo Domingo",
        currency: [
            "DOP"
        ],
        languages: [
            "es"
        ]
    },
    DZ: {
        name: "Algeria",
        native: "\u0627\u0644\u062C\u0632\u0627\u0626\u0631",
        phone: [
            213
        ],
        continent: "AF",
        capital: "Algiers",
        currency: [
            "DZD"
        ],
        languages: [
            "ar"
        ]
    },
    EC: {
        name: "Ecuador",
        native: "Ecuador",
        phone: [
            593
        ],
        continent: "SA",
        capital: "Quito",
        currency: [
            "USD"
        ],
        languages: [
            "es"
        ]
    },
    EE: {
        name: "Estonia",
        native: "Eesti",
        phone: [
            372
        ],
        continent: "EU",
        capital: "Tallinn",
        currency: [
            "EUR"
        ],
        languages: [
            "et"
        ]
    },
    EG: {
        name: "Egypt",
        native: "\u0645\u0635\u0631\u200E",
        phone: [
            20
        ],
        continent: "AF",
        continents: [
            "AF",
            "AS"
        ],
        capital: "Cairo",
        currency: [
            "EGP"
        ],
        languages: [
            "ar"
        ]
    },
    EH: {
        name: "Western Sahara",
        native: "\u0627\u0644\u0635\u062D\u0631\u0627\u0621 \u0627\u0644\u063A\u0631\u0628\u064A\u0629",
        phone: [
            212
        ],
        continent: "AF",
        capital: "El Aai\xfan",
        currency: [
            "MAD",
            "DZD",
            "MRU"
        ],
        languages: [
            "es"
        ]
    },
    ER: {
        name: "Eritrea",
        native: "\u12A4\u122D\u1275\u122B",
        phone: [
            291
        ],
        continent: "AF",
        capital: "Asmara",
        currency: [
            "ERN"
        ],
        languages: [
            "ti",
            "ar",
            "en"
        ]
    },
    ES: {
        name: "Spain",
        native: "Espa\xf1a",
        phone: [
            34
        ],
        continent: "EU",
        capital: "Madrid",
        currency: [
            "EUR"
        ],
        languages: [
            "es",
            "eu",
            "ca",
            "gl",
            "oc"
        ]
    },
    ET: {
        name: "Ethiopia",
        native: "\u12A2\u1275\u12EE\u1335\u12EB",
        phone: [
            251
        ],
        continent: "AF",
        capital: "Addis Ababa",
        currency: [
            "ETB"
        ],
        languages: [
            "am"
        ]
    },
    FI: {
        name: "Finland",
        native: "Suomi",
        phone: [
            358
        ],
        continent: "EU",
        capital: "Helsinki",
        currency: [
            "EUR"
        ],
        languages: [
            "fi",
            "sv"
        ]
    },
    FJ: {
        name: "Fiji",
        native: "Fiji",
        phone: [
            679
        ],
        continent: "OC",
        capital: "Suva",
        currency: [
            "FJD"
        ],
        languages: [
            "en",
            "fj",
            "hi",
            "ur"
        ]
    },
    FK: {
        name: "Falkland Islands",
        native: "Falkland Islands",
        phone: [
            500
        ],
        continent: "SA",
        capital: "Stanley",
        currency: [
            "FKP"
        ],
        languages: [
            "en"
        ]
    },
    FM: {
        name: "Micronesia",
        native: "Micronesia",
        phone: [
            691
        ],
        continent: "OC",
        capital: "Palikir",
        currency: [
            "USD"
        ],
        languages: [
            "en"
        ]
    },
    FO: {
        name: "Faroe Islands",
        native: "F\xf8royar",
        phone: [
            298
        ],
        continent: "EU",
        capital: "T\xf3rshavn",
        currency: [
            "DKK"
        ],
        languages: [
            "fo"
        ]
    },
    FR: {
        name: "France",
        native: "France",
        phone: [
            33
        ],
        continent: "EU",
        capital: "Paris",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    GA: {
        name: "Gabon",
        native: "Gabon",
        phone: [
            241
        ],
        continent: "AF",
        capital: "Libreville",
        currency: [
            "XAF"
        ],
        languages: [
            "fr"
        ]
    },
    GB: {
        name: "United Kingdom",
        native: "United Kingdom",
        phone: [
            44
        ],
        continent: "EU",
        capital: "London",
        currency: [
            "GBP"
        ],
        languages: [
            "en"
        ]
    },
    GD: {
        name: "Grenada",
        native: "Grenada",
        phone: [
            1473
        ],
        continent: "NA",
        capital: "St. George's",
        currency: [
            "XCD"
        ],
        languages: [
            "en"
        ]
    },
    GE: {
        name: "Georgia",
        native: "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD",
        phone: [
            995
        ],
        continent: "AS",
        continents: [
            "AS",
            "EU"
        ],
        capital: "Tbilisi",
        currency: [
            "GEL"
        ],
        languages: [
            "ka"
        ]
    },
    GF: {
        name: "French Guiana",
        native: "Guyane fran\xe7aise",
        phone: [
            594
        ],
        continent: "SA",
        capital: "Cayenne",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    GG: {
        name: "Guernsey",
        native: "Guernsey",
        phone: [
            44
        ],
        continent: "EU",
        capital: "St. Peter Port",
        currency: [
            "GBP"
        ],
        languages: [
            "en",
            "fr"
        ]
    },
    GH: {
        name: "Ghana",
        native: "Ghana",
        phone: [
            233
        ],
        continent: "AF",
        capital: "Accra",
        currency: [
            "GHS"
        ],
        languages: [
            "en"
        ]
    },
    GI: {
        name: "Gibraltar",
        native: "Gibraltar",
        phone: [
            350
        ],
        continent: "EU",
        capital: "Gibraltar",
        currency: [
            "GIP"
        ],
        languages: [
            "en"
        ]
    },
    GL: {
        name: "Greenland",
        native: "Kalaallit Nunaat",
        phone: [
            299
        ],
        continent: "NA",
        capital: "Nuuk",
        currency: [
            "DKK"
        ],
        languages: [
            "kl"
        ]
    },
    GM: {
        name: "Gambia",
        native: "Gambia",
        phone: [
            220
        ],
        continent: "AF",
        capital: "Banjul",
        currency: [
            "GMD"
        ],
        languages: [
            "en"
        ]
    },
    GN: {
        name: "Guinea",
        native: "Guin\xe9e",
        phone: [
            224
        ],
        continent: "AF",
        capital: "Conakry",
        currency: [
            "GNF"
        ],
        languages: [
            "fr",
            "ff"
        ]
    },
    GP: {
        name: "Guadeloupe",
        native: "Guadeloupe",
        phone: [
            590
        ],
        continent: "NA",
        capital: "Basse-Terre",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    GQ: {
        name: "Equatorial Guinea",
        native: "Guinea Ecuatorial",
        phone: [
            240
        ],
        continent: "AF",
        capital: "Malabo",
        currency: [
            "XAF"
        ],
        languages: [
            "es",
            "fr"
        ]
    },
    GR: {
        name: "Greece",
        native: "\u0395\u03BB\u03BB\u03AC\u03B4\u03B1",
        phone: [
            30
        ],
        continent: "EU",
        capital: "Athens",
        currency: [
            "EUR"
        ],
        languages: [
            "el"
        ]
    },
    GS: {
        name: "South Georgia and the South Sandwich Islands",
        native: "South Georgia",
        phone: [
            500
        ],
        continent: "AN",
        capital: "King Edward Point",
        currency: [
            "GBP"
        ],
        languages: [
            "en"
        ]
    },
    GT: {
        name: "Guatemala",
        native: "Guatemala",
        phone: [
            502
        ],
        continent: "NA",
        capital: "Guatemala City",
        currency: [
            "GTQ"
        ],
        languages: [
            "es"
        ]
    },
    GU: {
        name: "Guam",
        native: "Guam",
        phone: [
            1671
        ],
        continent: "OC",
        capital: "Hag\xe5t\xf1a",
        currency: [
            "USD"
        ],
        languages: [
            "en",
            "ch",
            "es"
        ]
    },
    GW: {
        name: "Guinea-Bissau",
        native: "Guin\xe9-Bissau",
        phone: [
            245
        ],
        continent: "AF",
        capital: "Bissau",
        currency: [
            "XOF"
        ],
        languages: [
            "pt"
        ]
    },
    GY: {
        name: "Guyana",
        native: "Guyana",
        phone: [
            592
        ],
        continent: "SA",
        capital: "Georgetown",
        currency: [
            "GYD"
        ],
        languages: [
            "en"
        ]
    },
    HK: {
        name: "Hong Kong",
        native: "\u9999\u6E2F",
        phone: [
            852
        ],
        continent: "AS",
        capital: "City of Victoria",
        currency: [
            "HKD"
        ],
        languages: [
            "zh",
            "en"
        ]
    },
    HM: {
        name: "Heard Island and McDonald Islands",
        native: "Heard Island and McDonald Islands",
        phone: [
            61
        ],
        continent: "AN",
        capital: "",
        currency: [
            "AUD"
        ],
        languages: [
            "en"
        ]
    },
    HN: {
        name: "Honduras",
        native: "Honduras",
        phone: [
            504
        ],
        continent: "NA",
        capital: "Tegucigalpa",
        currency: [
            "HNL"
        ],
        languages: [
            "es"
        ]
    },
    HR: {
        name: "Croatia",
        native: "Hrvatska",
        phone: [
            385
        ],
        continent: "EU",
        capital: "Zagreb",
        currency: [
            "EUR"
        ],
        languages: [
            "hr"
        ]
    },
    HT: {
        name: "Haiti",
        native: "Ha\xefti",
        phone: [
            509
        ],
        continent: "NA",
        capital: "Port-au-Prince",
        currency: [
            "HTG",
            "USD"
        ],
        languages: [
            "fr",
            "ht"
        ]
    },
    HU: {
        name: "Hungary",
        native: "Magyarorsz\xe1g",
        phone: [
            36
        ],
        continent: "EU",
        capital: "Budapest",
        currency: [
            "HUF"
        ],
        languages: [
            "hu"
        ]
    },
    ID: {
        name: "Indonesia",
        native: "Indonesia",
        phone: [
            62
        ],
        continent: "AS",
        capital: "Jakarta",
        currency: [
            "IDR"
        ],
        languages: [
            "id"
        ]
    },
    IE: {
        name: "Ireland",
        native: "\xc9ire",
        phone: [
            353
        ],
        continent: "EU",
        capital: "Dublin",
        currency: [
            "EUR"
        ],
        languages: [
            "ga",
            "en"
        ]
    },
    IL: {
        name: "Israel",
        native: "\u05D9\u05B4\u05E9\u05B0\u05C2\u05E8\u05B8\u05D0\u05B5\u05DC",
        phone: [
            972
        ],
        continent: "AS",
        capital: "Jerusalem",
        currency: [
            "ILS"
        ],
        languages: [
            "he",
            "ar"
        ]
    },
    IM: {
        name: "Isle of Man",
        native: "Isle of Man",
        phone: [
            44
        ],
        continent: "EU",
        capital: "Douglas",
        currency: [
            "GBP"
        ],
        languages: [
            "en",
            "gv"
        ]
    },
    IN: {
        name: "India",
        native: "\u092D\u093E\u0930\u0924",
        phone: [
            91
        ],
        continent: "AS",
        capital: "New Delhi",
        currency: [
            "INR"
        ],
        languages: [
            "hi",
            "en"
        ]
    },
    IO: {
        name: "British Indian Ocean Territory",
        native: "British Indian Ocean Territory",
        phone: [
            246
        ],
        continent: "AS",
        capital: "Diego Garcia",
        currency: [
            "USD"
        ],
        languages: [
            "en"
        ]
    },
    IQ: {
        name: "Iraq",
        native: "\u0627\u0644\u0639\u0631\u0627\u0642",
        phone: [
            964
        ],
        continent: "AS",
        capital: "Baghdad",
        currency: [
            "IQD"
        ],
        languages: [
            "ar",
            "ku"
        ]
    },
    IR: {
        name: "Iran",
        native: "\u0627\u06CC\u0631\u0627\u0646",
        phone: [
            98
        ],
        continent: "AS",
        capital: "Tehran",
        currency: [
            "IRR"
        ],
        languages: [
            "fa"
        ]
    },
    IS: {
        name: "Iceland",
        native: "\xcdsland",
        phone: [
            354
        ],
        continent: "EU",
        capital: "Reykjavik",
        currency: [
            "ISK"
        ],
        languages: [
            "is"
        ]
    },
    IT: {
        name: "Italy",
        native: "Italia",
        phone: [
            39
        ],
        continent: "EU",
        capital: "Rome",
        currency: [
            "EUR"
        ],
        languages: [
            "it"
        ]
    },
    JE: {
        name: "Jersey",
        native: "Jersey",
        phone: [
            44
        ],
        continent: "EU",
        capital: "Saint Helier",
        currency: [
            "GBP"
        ],
        languages: [
            "en",
            "fr"
        ]
    },
    JM: {
        name: "Jamaica",
        native: "Jamaica",
        phone: [
            1876
        ],
        continent: "NA",
        capital: "Kingston",
        currency: [
            "JMD"
        ],
        languages: [
            "en"
        ]
    },
    JO: {
        name: "Jordan",
        native: "\u0627\u0644\u0623\u0631\u062F\u0646",
        phone: [
            962
        ],
        continent: "AS",
        capital: "Amman",
        currency: [
            "JOD"
        ],
        languages: [
            "ar"
        ]
    },
    JP: {
        name: "Japan",
        native: "\u65E5\u672C",
        phone: [
            81
        ],
        continent: "AS",
        capital: "Tokyo",
        currency: [
            "JPY"
        ],
        languages: [
            "ja"
        ]
    },
    KE: {
        name: "Kenya",
        native: "Kenya",
        phone: [
            254
        ],
        continent: "AF",
        capital: "Nairobi",
        currency: [
            "KES"
        ],
        languages: [
            "en",
            "sw"
        ]
    },
    KG: {
        name: "Kyrgyzstan",
        native: "\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D",
        phone: [
            996
        ],
        continent: "AS",
        capital: "Bishkek",
        currency: [
            "KGS"
        ],
        languages: [
            "ky",
            "ru"
        ]
    },
    KH: {
        name: "Cambodia",
        native: "K\xe2mp\u016Dch\xe9a",
        phone: [
            855
        ],
        continent: "AS",
        capital: "Phnom Penh",
        currency: [
            "KHR"
        ],
        languages: [
            "km"
        ]
    },
    KI: {
        name: "Kiribati",
        native: "Kiribati",
        phone: [
            686
        ],
        continent: "OC",
        capital: "South Tarawa",
        currency: [
            "AUD"
        ],
        languages: [
            "en"
        ]
    },
    KM: {
        name: "Comoros",
        native: "Komori",
        phone: [
            269
        ],
        continent: "AF",
        capital: "Moroni",
        currency: [
            "KMF"
        ],
        languages: [
            "ar",
            "fr"
        ]
    },
    KN: {
        name: "Saint Kitts and Nevis",
        native: "Saint Kitts and Nevis",
        phone: [
            1869
        ],
        continent: "NA",
        capital: "Basseterre",
        currency: [
            "XCD"
        ],
        languages: [
            "en"
        ]
    },
    KP: {
        name: "North Korea",
        native: "\uBD81\uD55C",
        phone: [
            850
        ],
        continent: "AS",
        capital: "Pyongyang",
        currency: [
            "KPW"
        ],
        languages: [
            "ko"
        ]
    },
    KR: {
        name: "South Korea",
        native: "\uB300\uD55C\uBBFC\uAD6D",
        phone: [
            82
        ],
        continent: "AS",
        capital: "Seoul",
        currency: [
            "KRW"
        ],
        languages: [
            "ko"
        ]
    },
    KW: {
        name: "Kuwait",
        native: "\u0627\u0644\u0643\u0648\u064A\u062A",
        phone: [
            965
        ],
        continent: "AS",
        capital: "Kuwait City",
        currency: [
            "KWD"
        ],
        languages: [
            "ar"
        ]
    },
    KY: {
        name: "Cayman Islands",
        native: "Cayman Islands",
        phone: [
            1345
        ],
        continent: "NA",
        capital: "George Town",
        currency: [
            "KYD"
        ],
        languages: [
            "en"
        ]
    },
    KZ: {
        name: "Kazakhstan",
        native: "\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D",
        phone: [
            7
        ],
        continent: "AS",
        continents: [
            "AS",
            "EU"
        ],
        capital: "Astana",
        currency: [
            "KZT"
        ],
        languages: [
            "kk",
            "ru"
        ]
    },
    LA: {
        name: "Laos",
        native: "\u0EAA\u0E9B\u0E9B\u0EA5\u0EB2\u0EA7",
        phone: [
            856
        ],
        continent: "AS",
        capital: "Vientiane",
        currency: [
            "LAK"
        ],
        languages: [
            "lo"
        ]
    },
    LB: {
        name: "Lebanon",
        native: "\u0644\u0628\u0646\u0627\u0646",
        phone: [
            961
        ],
        continent: "AS",
        capital: "Beirut",
        currency: [
            "LBP"
        ],
        languages: [
            "ar",
            "fr"
        ]
    },
    LC: {
        name: "Saint Lucia",
        native: "Saint Lucia",
        phone: [
            1758
        ],
        continent: "NA",
        capital: "Castries",
        currency: [
            "XCD"
        ],
        languages: [
            "en"
        ]
    },
    LI: {
        name: "Liechtenstein",
        native: "Liechtenstein",
        phone: [
            423
        ],
        continent: "EU",
        capital: "Vaduz",
        currency: [
            "CHF"
        ],
        languages: [
            "de"
        ]
    },
    LK: {
        name: "Sri Lanka",
        native: "\u015Br\u012B la\u1E43k\u0101va",
        phone: [
            94
        ],
        continent: "AS",
        capital: "Colombo",
        currency: [
            "LKR"
        ],
        languages: [
            "si",
            "ta"
        ]
    },
    LR: {
        name: "Liberia",
        native: "Liberia",
        phone: [
            231
        ],
        continent: "AF",
        capital: "Monrovia",
        currency: [
            "LRD"
        ],
        languages: [
            "en"
        ]
    },
    LS: {
        name: "Lesotho",
        native: "Lesotho",
        phone: [
            266
        ],
        continent: "AF",
        capital: "Maseru",
        currency: [
            "LSL",
            "ZAR"
        ],
        languages: [
            "en",
            "st"
        ]
    },
    LT: {
        name: "Lithuania",
        native: "Lietuva",
        phone: [
            370
        ],
        continent: "EU",
        capital: "Vilnius",
        currency: [
            "EUR"
        ],
        languages: [
            "lt"
        ]
    },
    LU: {
        name: "Luxembourg",
        native: "Luxembourg",
        phone: [
            352
        ],
        continent: "EU",
        capital: "Luxembourg",
        currency: [
            "EUR"
        ],
        languages: [
            "fr",
            "de",
            "lb"
        ]
    },
    LV: {
        name: "Latvia",
        native: "Latvija",
        phone: [
            371
        ],
        continent: "EU",
        capital: "Riga",
        currency: [
            "EUR"
        ],
        languages: [
            "lv"
        ]
    },
    LY: {
        name: "Libya",
        native: "\u200F\u0644\u064A\u0628\u064A\u0627",
        phone: [
            218
        ],
        continent: "AF",
        capital: "Tripoli",
        currency: [
            "LYD"
        ],
        languages: [
            "ar"
        ]
    },
    MA: {
        name: "Morocco",
        native: "\u0627\u0644\u0645\u063A\u0631\u0628",
        phone: [
            212
        ],
        continent: "AF",
        capital: "Rabat",
        currency: [
            "MAD"
        ],
        languages: [
            "ar"
        ]
    },
    MC: {
        name: "Monaco",
        native: "Monaco",
        phone: [
            377
        ],
        continent: "EU",
        capital: "Monaco",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    MD: {
        name: "Moldova",
        native: "Moldova",
        phone: [
            373
        ],
        continent: "EU",
        capital: "Chi\u0219in\u0103u",
        currency: [
            "MDL"
        ],
        languages: [
            "ro"
        ]
    },
    ME: {
        name: "Montenegro",
        native: "\u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430",
        phone: [
            382
        ],
        continent: "EU",
        capital: "Podgorica",
        currency: [
            "EUR"
        ],
        languages: [
            "sr",
            "bs",
            "sq",
            "hr"
        ]
    },
    MF: {
        name: "Saint Martin",
        native: "Saint-Martin",
        phone: [
            590
        ],
        continent: "NA",
        capital: "Marigot",
        currency: [
            "EUR"
        ],
        languages: [
            "en",
            "fr",
            "nl"
        ]
    },
    MG: {
        name: "Madagascar",
        native: "Madagasikara",
        phone: [
            261
        ],
        continent: "AF",
        capital: "Antananarivo",
        currency: [
            "MGA"
        ],
        languages: [
            "fr",
            "mg"
        ]
    },
    MH: {
        name: "Marshall Islands",
        native: "M\u0327aje\u013C",
        phone: [
            692
        ],
        continent: "OC",
        capital: "Majuro",
        currency: [
            "USD"
        ],
        languages: [
            "en",
            "mh"
        ]
    },
    MK: {
        name: "North Macedonia",
        native: "\u0421\u0435\u0432\u0435\u0440\u043D\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430",
        phone: [
            389
        ],
        continent: "EU",
        capital: "Skopje",
        currency: [
            "MKD"
        ],
        languages: [
            "mk"
        ]
    },
    ML: {
        name: "Mali",
        native: "Mali",
        phone: [
            223
        ],
        continent: "AF",
        capital: "Bamako",
        currency: [
            "XOF"
        ],
        languages: [
            "fr"
        ]
    },
    MM: {
        name: "Myanmar (Burma)",
        native: "\u1019\u103C\u1014\u103A\u1019\u102C",
        phone: [
            95
        ],
        continent: "AS",
        capital: "Naypyidaw",
        currency: [
            "MMK"
        ],
        languages: [
            "my"
        ]
    },
    MN: {
        name: "Mongolia",
        native: "\u041C\u043E\u043D\u0433\u043E\u043B \u0443\u043B\u0441",
        phone: [
            976
        ],
        continent: "AS",
        capital: "Ulan Bator",
        currency: [
            "MNT"
        ],
        languages: [
            "mn"
        ]
    },
    MO: {
        name: "Macao",
        native: "\u6FB3\u9580",
        phone: [
            853
        ],
        continent: "AS",
        capital: "",
        currency: [
            "MOP"
        ],
        languages: [
            "zh",
            "pt"
        ]
    },
    MP: {
        name: "Northern Mariana Islands",
        native: "Northern Mariana Islands",
        phone: [
            1670
        ],
        continent: "OC",
        capital: "Saipan",
        currency: [
            "USD"
        ],
        languages: [
            "en",
            "ch"
        ]
    },
    MQ: {
        name: "Martinique",
        native: "Martinique",
        phone: [
            596
        ],
        continent: "NA",
        capital: "Fort-de-France",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    MR: {
        name: "Mauritania",
        native: "\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627",
        phone: [
            222
        ],
        continent: "AF",
        capital: "Nouakchott",
        currency: [
            "MRU"
        ],
        languages: [
            "ar"
        ]
    },
    MS: {
        name: "Montserrat",
        native: "Montserrat",
        phone: [
            1664
        ],
        continent: "NA",
        capital: "Plymouth",
        currency: [
            "XCD"
        ],
        languages: [
            "en"
        ]
    },
    MT: {
        name: "Malta",
        native: "Malta",
        phone: [
            356
        ],
        continent: "EU",
        capital: "Valletta",
        currency: [
            "EUR"
        ],
        languages: [
            "mt",
            "en"
        ]
    },
    MU: {
        name: "Mauritius",
        native: "Maurice",
        phone: [
            230
        ],
        continent: "AF",
        capital: "Port Louis",
        currency: [
            "MUR"
        ],
        languages: [
            "en"
        ]
    },
    MV: {
        name: "Maldives",
        native: "Maldives",
        phone: [
            960
        ],
        continent: "AS",
        capital: "Mal\xe9",
        currency: [
            "MVR"
        ],
        languages: [
            "dv"
        ]
    },
    MW: {
        name: "Malawi",
        native: "Malawi",
        phone: [
            265
        ],
        continent: "AF",
        capital: "Lilongwe",
        currency: [
            "MWK"
        ],
        languages: [
            "en",
            "ny"
        ]
    },
    MX: {
        name: "Mexico",
        native: "M\xe9xico",
        phone: [
            52
        ],
        continent: "NA",
        capital: "Mexico City",
        currency: [
            "MXN"
        ],
        languages: [
            "es"
        ]
    },
    MY: {
        name: "Malaysia",
        native: "Malaysia",
        phone: [
            60
        ],
        continent: "AS",
        capital: "Kuala Lumpur",
        currency: [
            "MYR"
        ],
        languages: [
            "ms"
        ]
    },
    MZ: {
        name: "Mozambique",
        native: "Mo\xe7ambique",
        phone: [
            258
        ],
        continent: "AF",
        capital: "Maputo",
        currency: [
            "MZN"
        ],
        languages: [
            "pt"
        ]
    },
    NA: {
        name: "Namibia",
        native: "Namibia",
        phone: [
            264
        ],
        continent: "AF",
        capital: "Windhoek",
        currency: [
            "NAD",
            "ZAR"
        ],
        languages: [
            "en",
            "af"
        ]
    },
    NC: {
        name: "New Caledonia",
        native: "Nouvelle-Cal\xe9donie",
        phone: [
            687
        ],
        continent: "OC",
        capital: "Noum\xe9a",
        currency: [
            "XPF"
        ],
        languages: [
            "fr"
        ]
    },
    NE: {
        name: "Niger",
        native: "Niger",
        phone: [
            227
        ],
        continent: "AF",
        capital: "Niamey",
        currency: [
            "XOF"
        ],
        languages: [
            "fr"
        ]
    },
    NF: {
        name: "Norfolk Island",
        native: "Norfolk Island",
        phone: [
            672
        ],
        continent: "OC",
        capital: "Kingston",
        currency: [
            "AUD"
        ],
        languages: [
            "en"
        ]
    },
    NG: {
        name: "Nigeria",
        native: "Nigeria",
        phone: [
            234
        ],
        continent: "AF",
        capital: "Abuja",
        currency: [
            "NGN"
        ],
        languages: [
            "en"
        ]
    },
    NI: {
        name: "Nicaragua",
        native: "Nicaragua",
        phone: [
            505
        ],
        continent: "NA",
        capital: "Managua",
        currency: [
            "NIO"
        ],
        languages: [
            "es"
        ]
    },
    NL: {
        name: "Netherlands",
        native: "Nederland",
        phone: [
            31
        ],
        continent: "EU",
        capital: "Amsterdam",
        currency: [
            "EUR"
        ],
        languages: [
            "nl"
        ]
    },
    NO: {
        name: "Norway",
        native: "Norge",
        phone: [
            47
        ],
        continent: "EU",
        capital: "Oslo",
        currency: [
            "NOK"
        ],
        languages: [
            "no",
            "nb",
            "nn"
        ]
    },
    NP: {
        name: "Nepal",
        native: "\u0928\u0947\u092A\u093E\u0932",
        phone: [
            977
        ],
        continent: "AS",
        capital: "Kathmandu",
        currency: [
            "NPR"
        ],
        languages: [
            "ne"
        ]
    },
    NR: {
        name: "Nauru",
        native: "Nauru",
        phone: [
            674
        ],
        continent: "OC",
        capital: "Yaren",
        currency: [
            "AUD"
        ],
        languages: [
            "en",
            "na"
        ]
    },
    NU: {
        name: "Niue",
        native: "Niu\u0113",
        phone: [
            683
        ],
        continent: "OC",
        capital: "Alofi",
        currency: [
            "NZD"
        ],
        languages: [
            "en"
        ]
    },
    NZ: {
        name: "New Zealand",
        native: "New Zealand",
        phone: [
            64
        ],
        continent: "OC",
        capital: "Wellington",
        currency: [
            "NZD"
        ],
        languages: [
            "en",
            "mi"
        ]
    },
    OM: {
        name: "Oman",
        native: "\u0639\u0645\u0627\u0646",
        phone: [
            968
        ],
        continent: "AS",
        capital: "Muscat",
        currency: [
            "OMR"
        ],
        languages: [
            "ar"
        ]
    },
    PA: {
        name: "Panama",
        native: "Panam\xe1",
        phone: [
            507
        ],
        continent: "NA",
        capital: "Panama City",
        currency: [
            "PAB",
            "USD"
        ],
        languages: [
            "es"
        ]
    },
    PE: {
        name: "Peru",
        native: "Per\xfa",
        phone: [
            51
        ],
        continent: "SA",
        capital: "Lima",
        currency: [
            "PEN"
        ],
        languages: [
            "es"
        ]
    },
    PF: {
        name: "French Polynesia",
        native: "Polyn\xe9sie fran\xe7aise",
        phone: [
            689
        ],
        continent: "OC",
        capital: "Papeet\u0113",
        currency: [
            "XPF"
        ],
        languages: [
            "fr"
        ]
    },
    PG: {
        name: "Papua New Guinea",
        native: "Papua Niugini",
        phone: [
            675
        ],
        continent: "OC",
        capital: "Port Moresby",
        currency: [
            "PGK"
        ],
        languages: [
            "en"
        ]
    },
    PH: {
        name: "Philippines",
        native: "Pilipinas",
        phone: [
            63
        ],
        continent: "AS",
        capital: "Manila",
        currency: [
            "PHP"
        ],
        languages: [
            "en"
        ]
    },
    PK: {
        name: "Pakistan",
        native: "Pakistan",
        phone: [
            92
        ],
        continent: "AS",
        capital: "Islamabad",
        currency: [
            "PKR"
        ],
        languages: [
            "en",
            "ur"
        ]
    },
    PL: {
        name: "Poland",
        native: "Polska",
        phone: [
            48
        ],
        continent: "EU",
        capital: "Warsaw",
        currency: [
            "PLN"
        ],
        languages: [
            "pl"
        ]
    },
    PM: {
        name: "Saint Pierre and Miquelon",
        native: "Saint-Pierre-et-Miquelon",
        phone: [
            508
        ],
        continent: "NA",
        capital: "Saint-Pierre",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    PN: {
        name: "Pitcairn Islands",
        native: "Pitcairn Islands",
        phone: [
            64
        ],
        continent: "OC",
        capital: "Adamstown",
        currency: [
            "NZD"
        ],
        languages: [
            "en"
        ]
    },
    PR: {
        name: "Puerto Rico",
        native: "Puerto Rico",
        phone: [
            1787,
            1939
        ],
        continent: "NA",
        capital: "San Juan",
        currency: [
            "USD"
        ],
        languages: [
            "es",
            "en"
        ]
    },
    PS: {
        name: "Palestine",
        native: "\u0641\u0644\u0633\u0637\u064A\u0646",
        phone: [
            970
        ],
        continent: "AS",
        capital: "Ramallah",
        currency: [
            "ILS"
        ],
        languages: [
            "ar"
        ]
    },
    PT: {
        name: "Portugal",
        native: "Portugal",
        phone: [
            351
        ],
        continent: "EU",
        capital: "Lisbon",
        currency: [
            "EUR"
        ],
        languages: [
            "pt"
        ]
    },
    PW: {
        name: "Palau",
        native: "Palau",
        phone: [
            680
        ],
        continent: "OC",
        capital: "Ngerulmud",
        currency: [
            "USD"
        ],
        languages: [
            "en"
        ]
    },
    PY: {
        name: "Paraguay",
        native: "Paraguay",
        phone: [
            595
        ],
        continent: "SA",
        capital: "Asunci\xf3n",
        currency: [
            "PYG"
        ],
        languages: [
            "es",
            "gn"
        ]
    },
    QA: {
        name: "Qatar",
        native: "\u0642\u0637\u0631",
        phone: [
            974
        ],
        continent: "AS",
        capital: "Doha",
        currency: [
            "QAR"
        ],
        languages: [
            "ar"
        ]
    },
    RE: {
        name: "Reunion",
        native: "La R\xe9union",
        phone: [
            262
        ],
        continent: "AF",
        capital: "Saint-Denis",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    RO: {
        name: "Romania",
        native: "Rom\xe2nia",
        phone: [
            40
        ],
        continent: "EU",
        capital: "Bucharest",
        currency: [
            "RON"
        ],
        languages: [
            "ro"
        ]
    },
    RS: {
        name: "Serbia",
        native: "\u0421\u0440\u0431\u0438\u0458\u0430",
        phone: [
            381
        ],
        continent: "EU",
        capital: "Belgrade",
        currency: [
            "RSD"
        ],
        languages: [
            "sr"
        ]
    },
    RU: {
        name: "Russia",
        native: "\u0420\u043E\u0441\u0441\u0438\u044F",
        phone: [
            7
        ],
        continent: "AS",
        continents: [
            "AS",
            "EU"
        ],
        capital: "Moscow",
        currency: [
            "RUB"
        ],
        languages: [
            "ru"
        ]
    },
    RW: {
        name: "Rwanda",
        native: "Rwanda",
        phone: [
            250
        ],
        continent: "AF",
        capital: "Kigali",
        currency: [
            "RWF"
        ],
        languages: [
            "rw",
            "en",
            "fr"
        ]
    },
    SA: {
        name: "Saudi Arabia",
        native: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629",
        phone: [
            966
        ],
        continent: "AS",
        capital: "Riyadh",
        currency: [
            "SAR"
        ],
        languages: [
            "ar"
        ]
    },
    SB: {
        name: "Solomon Islands",
        native: "Solomon Islands",
        phone: [
            677
        ],
        continent: "OC",
        capital: "Honiara",
        currency: [
            "SBD"
        ],
        languages: [
            "en"
        ]
    },
    SC: {
        name: "Seychelles",
        native: "Seychelles",
        phone: [
            248
        ],
        continent: "AF",
        capital: "Victoria",
        currency: [
            "SCR"
        ],
        languages: [
            "fr",
            "en"
        ]
    },
    SD: {
        name: "Sudan",
        native: "\u0627\u0644\u0633\u0648\u062F\u0627\u0646",
        phone: [
            249
        ],
        continent: "AF",
        capital: "Khartoum",
        currency: [
            "SDG"
        ],
        languages: [
            "ar",
            "en"
        ]
    },
    SE: {
        name: "Sweden",
        native: "Sverige",
        phone: [
            46
        ],
        continent: "EU",
        capital: "Stockholm",
        currency: [
            "SEK"
        ],
        languages: [
            "sv"
        ]
    },
    SG: {
        name: "Singapore",
        native: "Singapore",
        phone: [
            65
        ],
        continent: "AS",
        capital: "Singapore",
        currency: [
            "SGD"
        ],
        languages: [
            "en",
            "ms",
            "ta",
            "zh"
        ]
    },
    SH: {
        name: "Saint Helena",
        native: "Saint Helena",
        phone: [
            290
        ],
        continent: "AF",
        capital: "Jamestown",
        currency: [
            "SHP"
        ],
        languages: [
            "en"
        ]
    },
    SI: {
        name: "Slovenia",
        native: "Slovenija",
        phone: [
            386
        ],
        continent: "EU",
        capital: "Ljubljana",
        currency: [
            "EUR"
        ],
        languages: [
            "sl"
        ]
    },
    SJ: {
        name: "Svalbard and Jan Mayen",
        native: "Svalbard og Jan Mayen",
        phone: [
            4779
        ],
        continent: "EU",
        capital: "Longyearbyen",
        currency: [
            "NOK"
        ],
        languages: [
            "no"
        ]
    },
    SK: {
        name: "Slovakia",
        native: "Slovensko",
        phone: [
            421
        ],
        continent: "EU",
        capital: "Bratislava",
        currency: [
            "EUR"
        ],
        languages: [
            "sk"
        ]
    },
    SL: {
        name: "Sierra Leone",
        native: "Sierra Leone",
        phone: [
            232
        ],
        continent: "AF",
        capital: "Freetown",
        currency: [
            "SLL"
        ],
        languages: [
            "en"
        ]
    },
    SM: {
        name: "San Marino",
        native: "San Marino",
        phone: [
            378
        ],
        continent: "EU",
        capital: "City of San Marino",
        currency: [
            "EUR"
        ],
        languages: [
            "it"
        ]
    },
    SN: {
        name: "Senegal",
        native: "S\xe9n\xe9gal",
        phone: [
            221
        ],
        continent: "AF",
        capital: "Dakar",
        currency: [
            "XOF"
        ],
        languages: [
            "fr"
        ]
    },
    SO: {
        name: "Somalia",
        native: "Soomaaliya",
        phone: [
            252
        ],
        continent: "AF",
        capital: "Mogadishu",
        currency: [
            "SOS"
        ],
        languages: [
            "so",
            "ar"
        ]
    },
    SR: {
        name: "Suriname",
        native: "Suriname",
        phone: [
            597
        ],
        continent: "SA",
        capital: "Paramaribo",
        currency: [
            "SRD"
        ],
        languages: [
            "nl"
        ]
    },
    SS: {
        name: "South Sudan",
        native: "South Sudan",
        phone: [
            211
        ],
        continent: "AF",
        capital: "Juba",
        currency: [
            "SSP"
        ],
        languages: [
            "en"
        ]
    },
    ST: {
        name: "Sao Tome and Principe",
        native: "S\xe3o Tom\xe9 e Pr\xedncipe",
        phone: [
            239
        ],
        continent: "AF",
        capital: "S\xe3o Tom\xe9",
        currency: [
            "STN"
        ],
        languages: [
            "pt"
        ]
    },
    SV: {
        name: "El Salvador",
        native: "El Salvador",
        phone: [
            503
        ],
        continent: "NA",
        capital: "San Salvador",
        currency: [
            "SVC",
            "USD"
        ],
        languages: [
            "es"
        ]
    },
    SX: {
        name: "Sint Maarten",
        native: "Sint Maarten",
        phone: [
            1721
        ],
        continent: "NA",
        capital: "Philipsburg",
        currency: [
            "ANG"
        ],
        languages: [
            "nl",
            "en"
        ]
    },
    SY: {
        name: "Syria",
        native: "\u0633\u0648\u0631\u064A\u0627",
        phone: [
            963
        ],
        continent: "AS",
        capital: "Damascus",
        currency: [
            "SYP"
        ],
        languages: [
            "ar"
        ]
    },
    SZ: {
        name: "Eswatini",
        native: "Eswatini",
        phone: [
            268
        ],
        continent: "AF",
        capital: "Lobamba",
        currency: [
            "SZL"
        ],
        languages: [
            "en",
            "ss"
        ]
    },
    TC: {
        name: "Turks and Caicos Islands",
        native: "Turks and Caicos Islands",
        phone: [
            1649
        ],
        continent: "NA",
        capital: "Cockburn Town",
        currency: [
            "USD"
        ],
        languages: [
            "en"
        ]
    },
    TD: {
        name: "Chad",
        native: "Tchad",
        phone: [
            235
        ],
        continent: "AF",
        capital: "N'Djamena",
        currency: [
            "XAF"
        ],
        languages: [
            "fr",
            "ar"
        ]
    },
    TF: {
        name: "French Southern Territories",
        native: "Territoire des Terres australes et antarctiques fr",
        phone: [
            262
        ],
        continent: "AN",
        capital: "Port-aux-Fran\xe7ais",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    TG: {
        name: "Togo",
        native: "Togo",
        phone: [
            228
        ],
        continent: "AF",
        capital: "Lom\xe9",
        currency: [
            "XOF"
        ],
        languages: [
            "fr"
        ]
    },
    TH: {
        name: "Thailand",
        native: "\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22",
        phone: [
            66
        ],
        continent: "AS",
        capital: "Bangkok",
        currency: [
            "THB"
        ],
        languages: [
            "th"
        ]
    },
    TJ: {
        name: "Tajikistan",
        native: "\u0422\u043E\u04B7\u0438\u043A\u0438\u0441\u0442\u043E\u043D",
        phone: [
            992
        ],
        continent: "AS",
        capital: "Dushanbe",
        currency: [
            "TJS"
        ],
        languages: [
            "tg",
            "ru"
        ]
    },
    TK: {
        name: "Tokelau",
        native: "Tokelau",
        phone: [
            690
        ],
        continent: "OC",
        capital: "Fakaofo",
        currency: [
            "NZD"
        ],
        languages: [
            "en"
        ]
    },
    TL: {
        name: "East Timor",
        native: "Timor-Leste",
        phone: [
            670
        ],
        continent: "OC",
        capital: "Dili",
        currency: [
            "USD"
        ],
        languages: [
            "pt"
        ]
    },
    TM: {
        name: "Turkmenistan",
        native: "T\xfcrkmenistan",
        phone: [
            993
        ],
        continent: "AS",
        capital: "Ashgabat",
        currency: [
            "TMT"
        ],
        languages: [
            "tk",
            "ru"
        ]
    },
    TN: {
        name: "Tunisia",
        native: "\u062A\u0648\u0646\u0633",
        phone: [
            216
        ],
        continent: "AF",
        capital: "Tunis",
        currency: [
            "TND"
        ],
        languages: [
            "ar"
        ]
    },
    TO: {
        name: "Tonga",
        native: "Tonga",
        phone: [
            676
        ],
        continent: "OC",
        capital: "Nuku'alofa",
        currency: [
            "TOP"
        ],
        languages: [
            "en",
            "to"
        ]
    },
    TR: {
        name: "Turkey",
        native: "T\xfcrkiye",
        phone: [
            90
        ],
        continent: "AS",
        continents: [
            "AS",
            "EU"
        ],
        capital: "Ankara",
        currency: [
            "TRY"
        ],
        languages: [
            "tr"
        ]
    },
    TT: {
        name: "Trinidad and Tobago",
        native: "Trinidad and Tobago",
        phone: [
            1868
        ],
        continent: "NA",
        capital: "Port of Spain",
        currency: [
            "TTD"
        ],
        languages: [
            "en"
        ]
    },
    TV: {
        name: "Tuvalu",
        native: "Tuvalu",
        phone: [
            688
        ],
        continent: "OC",
        capital: "Funafuti",
        currency: [
            "AUD"
        ],
        languages: [
            "en"
        ]
    },
    TW: {
        name: "Taiwan",
        native: "\u81FA\u7063",
        phone: [
            886
        ],
        continent: "AS",
        capital: "Taipei",
        currency: [
            "TWD"
        ],
        languages: [
            "zh"
        ]
    },
    TZ: {
        name: "Tanzania",
        native: "Tanzania",
        phone: [
            255
        ],
        continent: "AF",
        capital: "Dodoma",
        currency: [
            "TZS"
        ],
        languages: [
            "sw",
            "en"
        ]
    },
    UA: {
        name: "Ukraine",
        native: "\u0423\u043A\u0440\u0430\u0457\u043D\u0430",
        phone: [
            380
        ],
        continent: "EU",
        capital: "Kyiv",
        currency: [
            "UAH"
        ],
        languages: [
            "uk"
        ]
    },
    UG: {
        name: "Uganda",
        native: "Uganda",
        phone: [
            256
        ],
        continent: "AF",
        capital: "Kampala",
        currency: [
            "UGX"
        ],
        languages: [
            "en",
            "sw"
        ]
    },
    UM: {
        name: "U.S. Minor Outlying Islands",
        native: "United States Minor Outlying Islands",
        phone: [
            1
        ],
        continent: "OC",
        capital: "",
        currency: [
            "USD"
        ],
        languages: [
            "en"
        ]
    },
    US: {
        name: "United States",
        native: "United States",
        phone: [
            1
        ],
        continent: "NA",
        capital: "Washington D.C.",
        currency: [
            "USD",
            "USN",
            "USS"
        ],
        languages: [
            "en"
        ]
    },
    UY: {
        name: "Uruguay",
        native: "Uruguay",
        phone: [
            598
        ],
        continent: "SA",
        capital: "Montevideo",
        currency: [
            "UYI",
            "UYU"
        ],
        languages: [
            "es"
        ]
    },
    UZ: {
        name: "Uzbekistan",
        native: "O'zbekiston",
        phone: [
            998
        ],
        continent: "AS",
        capital: "Tashkent",
        currency: [
            "UZS"
        ],
        languages: [
            "uz",
            "ru"
        ]
    },
    VA: {
        name: "Vatican City",
        native: "Vaticano",
        phone: [
            379
        ],
        continent: "EU",
        capital: "Vatican City",
        currency: [
            "EUR"
        ],
        languages: [
            "it",
            "la"
        ]
    },
    VC: {
        name: "Saint Vincent and the Grenadines",
        native: "Saint Vincent and the Grenadines",
        phone: [
            1784
        ],
        continent: "NA",
        capital: "Kingstown",
        currency: [
            "XCD"
        ],
        languages: [
            "en"
        ]
    },
    VE: {
        name: "Venezuela",
        native: "Venezuela",
        phone: [
            58
        ],
        continent: "SA",
        capital: "Caracas",
        currency: [
            "VES"
        ],
        languages: [
            "es"
        ]
    },
    VG: {
        name: "British Virgin Islands",
        native: "British Virgin Islands",
        phone: [
            1284
        ],
        continent: "NA",
        capital: "Road Town",
        currency: [
            "USD"
        ],
        languages: [
            "en"
        ]
    },
    VI: {
        name: "U.S. Virgin Islands",
        native: "United States Virgin Islands",
        phone: [
            1340
        ],
        continent: "NA",
        capital: "Charlotte Amalie",
        currency: [
            "USD"
        ],
        languages: [
            "en"
        ]
    },
    VN: {
        name: "Vietnam",
        native: "Vi\u1EC7t Nam",
        phone: [
            84
        ],
        continent: "AS",
        capital: "Hanoi",
        currency: [
            "VND"
        ],
        languages: [
            "vi"
        ]
    },
    VU: {
        name: "Vanuatu",
        native: "Vanuatu",
        phone: [
            678
        ],
        continent: "OC",
        capital: "Port Vila",
        currency: [
            "VUV"
        ],
        languages: [
            "bi",
            "en",
            "fr"
        ]
    },
    WF: {
        name: "Wallis and Futuna",
        native: "Wallis et Futuna",
        phone: [
            681
        ],
        continent: "OC",
        capital: "Mata-Utu",
        currency: [
            "XPF"
        ],
        languages: [
            "fr"
        ]
    },
    WS: {
        name: "Samoa",
        native: "Samoa",
        phone: [
            685
        ],
        continent: "OC",
        capital: "Apia",
        currency: [
            "WST"
        ],
        languages: [
            "sm",
            "en"
        ]
    },
    XK: {
        name: "Kosovo",
        native: "Republika e Kosov\xebs",
        phone: [
            377,
            381,
            383,
            386
        ],
        continent: "EU",
        capital: "Pristina",
        currency: [
            "EUR"
        ],
        languages: [
            "sq",
            "sr"
        ],
        userAssigned: !0
    },
    YE: {
        name: "Yemen",
        native: "\u0627\u0644\u064A\u064E\u0645\u064E\u0646",
        phone: [
            967
        ],
        continent: "AS",
        capital: "Sana'a",
        currency: [
            "YER"
        ],
        languages: [
            "ar"
        ]
    },
    YT: {
        name: "Mayotte",
        native: "Mayotte",
        phone: [
            262
        ],
        continent: "AF",
        capital: "Mamoudzou",
        currency: [
            "EUR"
        ],
        languages: [
            "fr"
        ]
    },
    ZA: {
        name: "South Africa",
        native: "South Africa",
        phone: [
            27
        ],
        continent: "AF",
        capital: "Pretoria",
        currency: [
            "ZAR"
        ],
        languages: [
            "af",
            "en",
            "nr",
            "st",
            "ss",
            "tn",
            "ts",
            "ve",
            "xh",
            "zu"
        ]
    },
    ZM: {
        name: "Zambia",
        native: "Zambia",
        phone: [
            260
        ],
        continent: "AF",
        capital: "Lusaka",
        currency: [
            "ZMW"
        ],
        languages: [
            "en"
        ]
    },
    ZW: {
        name: "Zimbabwe",
        native: "Zimbabwe",
        phone: [
            263
        ],
        continent: "AF",
        capital: "Harare",
        currency: [
            "USD",
            "ZAR",
            "BWP",
            "GBP",
            "AUD",
            "CNY",
            "INR",
            "JPY"
        ],
        languages: [
            "en",
            "sn",
            "nd"
        ]
    }
};
var $800f1464c09562a0$export$d0d68bb9ed2c643d = {
    aa: {
        name: "Afar",
        native: "Afar"
    },
    ab: {
        name: "Abkhazian",
        native: "\u0410\u04A7\u0441\u0443\u0430"
    },
    af: {
        name: "Afrikaans",
        native: "Afrikaans"
    },
    ak: {
        name: "Akan",
        native: "Akana"
    },
    am: {
        name: "Amharic",
        native: "\u12A0\u121B\u122D\u129B"
    },
    an: {
        name: "Aragonese",
        native: "Aragon\xe9s"
    },
    ar: {
        name: "Arabic",
        native: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        rtl: 1
    },
    as: {
        name: "Assamese",
        native: "\u0985\u09B8\u09AE\u09C0\u09AF\u09BC\u09BE"
    },
    av: {
        name: "Avar",
        native: "\u0410\u0432\u0430\u0440"
    },
    ay: {
        name: "Aymara",
        native: "Aymar"
    },
    az: {
        name: "Azerbaijani",
        native: "Az\u0259rbaycanca / \u0622\u0630\u0631\u0628\u0627\u064A\u062C\u0627\u0646"
    },
    ba: {
        name: "Bashkir",
        native: "\u0411\u0430\u0448\u04A1\u043E\u0440\u0442"
    },
    be: {
        name: "Belarusian",
        native: "\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F"
    },
    bg: {
        name: "Bulgarian",
        native: "\u0411\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438"
    },
    bh: {
        name: "Bihari",
        native: "\u092D\u094B\u091C\u092A\u0941\u0930\u0940"
    },
    bi: {
        name: "Bislama",
        native: "Bislama"
    },
    bm: {
        name: "Bambara",
        native: "Bamanankan"
    },
    bn: {
        name: "Bengali",
        native: "\u09AC\u09BE\u0982\u09B2\u09BE"
    },
    bo: {
        name: "Tibetan",
        native: "\u0F56\u0F7C\u0F51\u0F0B\u0F61\u0F72\u0F42 / Bod skad"
    },
    br: {
        name: "Breton",
        native: "Brezhoneg"
    },
    bs: {
        name: "Bosnian",
        native: "Bosanski"
    },
    ca: {
        name: "Catalan",
        native: "Catal\xe0"
    },
    ce: {
        name: "Chechen",
        native: "\u041D\u043E\u0445\u0447\u0438\u0439\u043D"
    },
    ch: {
        name: "Chamorro",
        native: "Chamoru"
    },
    co: {
        name: "Corsican",
        native: "Corsu"
    },
    cr: {
        name: "Cree",
        native: "Nehiyaw"
    },
    cs: {
        name: "Czech",
        native: "\u010Ce\u0161tina"
    },
    cu: {
        name: "Old Church Slavonic / Old Bulgarian",
        native: "\u0441\u043B\u043E\u0432\u0463\u043D\u044C\u0441\u043A\u044A / slov\u011Bn\u012Dsk\u016D"
    },
    cv: {
        name: "Chuvash",
        native: "\u0427\u0103\u0432\u0430\u0448"
    },
    cy: {
        name: "Welsh",
        native: "Cymraeg"
    },
    da: {
        name: "Danish",
        native: "Dansk"
    },
    de: {
        name: "German",
        native: "Deutsch"
    },
    dv: {
        name: "Divehi",
        native: "\u078B\u07A8\u0788\u07AC\u0780\u07A8\u0784\u07A6\u0790\u07B0",
        rtl: 1
    },
    dz: {
        name: "Dzongkha",
        native: "\u0F47\u0F7C\u0F44\u0F0B\u0F41"
    },
    ee: {
        name: "Ewe",
        native: "\u0190\u028B\u025B"
    },
    el: {
        name: "Greek",
        native: "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC"
    },
    en: {
        name: "English",
        native: "English"
    },
    eo: {
        name: "Esperanto",
        native: "Esperanto"
    },
    es: {
        name: "Spanish",
        native: "Espa\xf1ol"
    },
    et: {
        name: "Estonian",
        native: "Eesti"
    },
    eu: {
        name: "Basque",
        native: "Euskara"
    },
    fa: {
        name: "Persian",
        native: "\u0641\u0627\u0631\u0633\u06CC",
        rtl: 1
    },
    ff: {
        name: "Peul",
        native: "Fulfulde"
    },
    fi: {
        name: "Finnish",
        native: "Suomi"
    },
    fj: {
        name: "Fijian",
        native: "Na Vosa Vakaviti"
    },
    fo: {
        name: "Faroese",
        native: "F\xf8royskt"
    },
    fr: {
        name: "French",
        native: "Fran\xe7ais"
    },
    fy: {
        name: "West Frisian",
        native: "Frysk"
    },
    ga: {
        name: "Irish",
        native: "Gaeilge"
    },
    gd: {
        name: "Scottish Gaelic",
        native: "G\xe0idhlig"
    },
    gl: {
        name: "Galician",
        native: "Galego"
    },
    gn: {
        name: "Guarani",
        native: "Ava\xf1e'\u1EBD"
    },
    gu: {
        name: "Gujarati",
        native: "\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0"
    },
    gv: {
        name: "Manx",
        native: "Gaelg"
    },
    ha: {
        name: "Hausa",
        native: "\u0647\u064E\u0648\u064F\u0633\u064E",
        rtl: 1
    },
    he: {
        name: "Hebrew",
        native: "\u05E2\u05D1\u05E8\u05D9\u05EA",
        rtl: 1
    },
    hi: {
        name: "Hindi",
        native: "\u0939\u093F\u0928\u094D\u0926\u0940"
    },
    ho: {
        name: "Hiri Motu",
        native: "Hiri Motu"
    },
    hr: {
        name: "Croatian",
        native: "Hrvatski"
    },
    ht: {
        name: "Haitian",
        native: "Kr\xe8yol ayisyen"
    },
    hu: {
        name: "Hungarian",
        native: "Magyar"
    },
    hy: {
        name: "Armenian",
        native: "\u0540\u0561\u0575\u0565\u0580\u0565\u0576"
    },
    hz: {
        name: "Herero",
        native: "Otsiherero"
    },
    ia: {
        name: "Interlingua",
        native: "Interlingua"
    },
    id: {
        name: "Indonesian",
        native: "Bahasa Indonesia"
    },
    ie: {
        name: "Interlingue",
        native: "Interlingue"
    },
    ig: {
        name: "Igbo",
        native: "Igbo"
    },
    ii: {
        name: "Sichuan Yi",
        native: "\uA187\uA259 / \u56DB\u5DDD\u5F5D\u8BED"
    },
    ik: {
        name: "Inupiak",
        native: "I\xf1upiak"
    },
    io: {
        name: "Ido",
        native: "Ido"
    },
    is: {
        name: "Icelandic",
        native: "\xcdslenska"
    },
    it: {
        name: "Italian",
        native: "Italiano"
    },
    iu: {
        name: "Inuktitut",
        native: "\u1403\u14C4\u1483\u144E\u1450\u1466"
    },
    ja: {
        name: "Japanese",
        native: "\u65E5\u672C\u8A9E"
    },
    jv: {
        name: "Javanese",
        native: "Basa Jawa"
    },
    ka: {
        name: "Georgian",
        native: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8"
    },
    kg: {
        name: "Kongo",
        native: "KiKongo"
    },
    ki: {
        name: "Kikuyu",
        native: "G\u0129k\u0169y\u0169"
    },
    kj: {
        name: "Kuanyama",
        native: "Kuanyama"
    },
    kk: {
        name: "Kazakh",
        native: "\u049A\u0430\u0437\u0430\u049B\u0448\u0430"
    },
    kl: {
        name: "Greenlandic",
        native: "Kalaallisut"
    },
    km: {
        name: "Cambodian",
        native: "\u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A"
    },
    kn: {
        name: "Kannada",
        native: "\u0C95\u0CA8\u0CCD\u0CA8\u0CA1"
    },
    ko: {
        name: "Korean",
        native: "\uD55C\uAD6D\uC5B4"
    },
    kr: {
        name: "Kanuri",
        native: "Kanuri"
    },
    ks: {
        name: "Kashmiri",
        native: "\u0915\u0936\u094D\u092E\u0940\u0930\u0940 / \u0643\u0634\u0645\u064A\u0631\u064A",
        rtl: 1
    },
    ku: {
        name: "Kurdish",
        native: "Kurd\xee / \u0643\u0648\u0631\u062F\u06CC",
        rtl: 1
    },
    kv: {
        name: "Komi",
        native: "\u041A\u043E\u043C\u0438"
    },
    kw: {
        name: "Cornish",
        native: "Kernewek"
    },
    ky: {
        name: "Kyrgyz",
        native: "\u041A\u044B\u0440\u0433\u044B\u0437\u0447\u0430"
    },
    la: {
        name: "Latin",
        native: "Latina"
    },
    lb: {
        name: "Luxembourgish",
        native: "L\xebtzebuergesch"
    },
    lg: {
        name: "Ganda",
        native: "Luganda"
    },
    li: {
        name: "Limburgian",
        native: "Limburgs"
    },
    ln: {
        name: "Lingala",
        native: "Ling\xe1la"
    },
    lo: {
        name: "Laotian",
        native: "\u0EA5\u0EB2\u0EA7 / Pha xa lao"
    },
    lt: {
        name: "Lithuanian",
        native: "Lietuvi\u0173"
    },
    lu: {
        name: "Luba-Katanga",
        native: "Tshiluba"
    },
    lv: {
        name: "Latvian",
        native: "Latvie\u0161u"
    },
    mg: {
        name: "Malagasy",
        native: "Malagasy"
    },
    mh: {
        name: "Marshallese",
        native: "Kajin Majel / Ebon"
    },
    mi: {
        name: "Maori",
        native: "M\u0101ori"
    },
    mk: {
        name: "Macedonian",
        native: "\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438"
    },
    ml: {
        name: "Malayalam",
        native: "\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02"
    },
    mn: {
        name: "Mongolian",
        native: "\u041C\u043E\u043D\u0433\u043E\u043B"
    },
    mo: {
        name: "Moldovan",
        native: "Moldoveneasc\u0103"
    },
    mr: {
        name: "Marathi",
        native: "\u092E\u0930\u093E\u0920\u0940"
    },
    ms: {
        name: "Malay",
        native: "Bahasa Melayu"
    },
    mt: {
        name: "Maltese",
        native: "bil-Malti"
    },
    my: {
        name: "Burmese",
        native: "\u1019\u103C\u1014\u103A\u1019\u102C\u1005\u102C"
    },
    na: {
        name: "Nauruan",
        native: "Dorerin Naoero"
    },
    nb: {
        name: "Norwegian Bokm\xe5l",
        native: "Norsk bokm\xe5l"
    },
    nd: {
        name: "North Ndebele",
        native: "Sindebele"
    },
    ne: {
        name: "Nepali",
        native: "\u0928\u0947\u092A\u093E\u0932\u0940"
    },
    ng: {
        name: "Ndonga",
        native: "Oshiwambo"
    },
    nl: {
        name: "Dutch",
        native: "Nederlands"
    },
    nn: {
        name: "Norwegian Nynorsk",
        native: "Norsk nynorsk"
    },
    no: {
        name: "Norwegian",
        native: "Norsk"
    },
    nr: {
        name: "South Ndebele",
        native: "isiNdebele"
    },
    nv: {
        name: "Navajo",
        native: "Din\xe9 bizaad"
    },
    ny: {
        name: "Chichewa",
        native: "Chi-Chewa"
    },
    oc: {
        name: "Occitan",
        native: "Occitan"
    },
    oj: {
        name: "Ojibwa",
        native: "\u140A\u14C2\u1511\u14C8\u142F\u14A7\u140E\u14D0 / Anishinaabemowin"
    },
    om: {
        name: "Oromo",
        native: "Oromoo"
    },
    or: {
        name: "Oriya",
        native: "\u0B13\u0B21\u0B3C\u0B3F\u0B06"
    },
    os: {
        name: "Ossetian / Ossetic",
        native: "\u0418\u0440\u043E\u043D\u0430\u0443"
    },
    pa: {
        name: "Panjabi / Punjabi",
        native: "\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40 / \u092A\u0902\u091C\u093E\u092C\u0940 / \u067E\u0646\u062C\u0627\u0628\u064A"
    },
    pi: {
        name: "Pali",
        native: "P\u0101li / \u092A\u093E\u0934\u093F"
    },
    pl: {
        name: "Polish",
        native: "Polski"
    },
    ps: {
        name: "Pashto",
        native: "\u067E\u069A\u062A\u0648",
        rtl: 1
    },
    pt: {
        name: "Portuguese",
        native: "Portugu\xeas"
    },
    qu: {
        name: "Quechua",
        native: "Runa Simi"
    },
    rm: {
        name: "Raeto Romance",
        native: "Rumantsch"
    },
    rn: {
        name: "Kirundi",
        native: "Kirundi"
    },
    ro: {
        name: "Romanian",
        native: "Rom\xe2n\u0103"
    },
    ru: {
        name: "Russian",
        native: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439"
    },
    rw: {
        name: "Rwandi",
        native: "Kinyarwandi"
    },
    sa: {
        name: "Sanskrit",
        native: "\u0938\u0902\u0938\u094D\u0915\u0943\u0924\u092E\u094D"
    },
    sc: {
        name: "Sardinian",
        native: "Sardu"
    },
    sd: {
        name: "Sindhi",
        native: "\u0938\u093F\u0928\u0927\u093F"
    },
    se: {
        name: "Northern Sami",
        native: "S\xe1megiella"
    },
    sg: {
        name: "Sango",
        native: "S\xe4ng\xf6"
    },
    sh: {
        name: "Serbo-Croatian",
        native: "Srpskohrvatski / \u0421\u0440\u043F\u0441\u043A\u043E\u0445\u0440\u0432\u0430\u0442\u0441\u043A\u0438"
    },
    si: {
        name: "Sinhalese",
        native: "\u0DC3\u0DD2\u0D82\u0DC4\u0DBD"
    },
    sk: {
        name: "Slovak",
        native: "Sloven\u010Dina"
    },
    sl: {
        name: "Slovenian",
        native: "Sloven\u0161\u010Dina"
    },
    sm: {
        name: "Samoan",
        native: "Gagana Samoa"
    },
    sn: {
        name: "Shona",
        native: "chiShona"
    },
    so: {
        name: "Somalia",
        native: "Soomaaliga"
    },
    sq: {
        name: "Albanian",
        native: "Shqip"
    },
    sr: {
        name: "Serbian",
        native: "\u0421\u0440\u043F\u0441\u043A\u0438"
    },
    ss: {
        name: "Swati",
        native: "SiSwati"
    },
    st: {
        name: "Southern Sotho",
        native: "Sesotho"
    },
    su: {
        name: "Sundanese",
        native: "Basa Sunda"
    },
    sv: {
        name: "Swedish",
        native: "Svenska"
    },
    sw: {
        name: "Swahili",
        native: "Kiswahili"
    },
    ta: {
        name: "Tamil",
        native: "\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD"
    },
    te: {
        name: "Telugu",
        native: "\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41"
    },
    tg: {
        name: "Tajik",
        native: "\u0422\u043E\u04B7\u0438\u043A\u04E3"
    },
    th: {
        name: "Thai",
        native: "\u0E44\u0E17\u0E22 / Phasa Thai"
    },
    ti: {
        name: "Tigrinya",
        native: "\u1275\u130D\u122D\u129B"
    },
    tk: {
        name: "Turkmen",
        native: "\u0422\u0443\u0440\u043A\u043C\u0435\u043D / \u062A\u0631\u0643\u0645\u0646"
    },
    tl: {
        name: "Tagalog / Filipino",
        native: "Tagalog"
    },
    tn: {
        name: "Tswana",
        native: "Setswana"
    },
    to: {
        name: "Tonga",
        native: "Lea Faka-Tonga"
    },
    tr: {
        name: "Turkish",
        native: "T\xfcrk\xe7e"
    },
    ts: {
        name: "Tsonga",
        native: "Xitsonga"
    },
    tt: {
        name: "Tatar",
        native: "Tatar\xe7a"
    },
    tw: {
        name: "Twi",
        native: "Twi"
    },
    ty: {
        name: "Tahitian",
        native: "Reo M\u0101`ohi"
    },
    ug: {
        name: "Uyghur",
        native: "Uy\u01A3urq\u0259 / \u0626\u06C7\u064A\u063A\u06C7\u0631\u0686\u06D5"
    },
    uk: {
        name: "Ukrainian",
        native: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430"
    },
    ur: {
        name: "Urdu",
        native: "\u0627\u0631\u062F\u0648",
        rtl: 1
    },
    uz: {
        name: "Uzbek",
        native: "O'zbekcha"
    },
    ve: {
        name: "Venda",
        native: "Tshiven\u1E13a"
    },
    vi: {
        name: "Vietnamese",
        native: "Ti\u1EBFng Vi\u1EC7t"
    },
    vo: {
        name: "Volap\xfck",
        native: "Volap\xfck"
    },
    wa: {
        name: "Walloon",
        native: "Walon"
    },
    wo: {
        name: "Wolof",
        native: "Wollof"
    },
    xh: {
        name: "Xhosa",
        native: "isiXhosa"
    },
    yi: {
        name: "Yiddish",
        native: "\u05D9\u05D9\u05B4\u05D3\u05D9\u05E9",
        rtl: 1
    },
    yo: {
        name: "Yoruba",
        native: "Yor\xf9b\xe1"
    },
    za: {
        name: "Zhuang",
        native: "Cuengh / T\xf4\xf4 / \u58EE\u8BED"
    },
    zh: {
        name: "Chinese",
        native: "\u4E2D\u6587"
    },
    zu: {
        name: "Zulu",
        native: "isiZulu"
    }
};
var $800f1464c09562a0$var$r = {
    AD: "AND",
    AE: "ARE",
    AF: "AFG",
    AG: "ATG",
    AI: "AIA",
    AL: "ALB",
    AM: "ARM",
    AO: "AGO",
    AQ: "ATA",
    AR: "ARG",
    AS: "ASM",
    AT: "AUT",
    AU: "AUS",
    AW: "ABW",
    AX: "ALA",
    AZ: "AZE",
    BA: "BIH",
    BB: "BRB",
    BD: "BGD",
    BE: "BEL",
    BF: "BFA",
    BG: "BGR",
    BH: "BHR",
    BI: "BDI",
    BJ: "BEN",
    BL: "BLM",
    BM: "BMU",
    BN: "BRN",
    BO: "BOL",
    BQ: "BES",
    BR: "BRA",
    BS: "BHS",
    BT: "BTN",
    BV: "BVT",
    BW: "BWA",
    BY: "BLR",
    BZ: "BLZ",
    CA: "CAN",
    CC: "CCK",
    CD: "COD",
    CF: "CAF",
    CG: "COG",
    CH: "CHE",
    CI: "CIV",
    CK: "COK",
    CL: "CHL",
    CM: "CMR",
    CN: "CHN",
    CO: "COL",
    CR: "CRI",
    CU: "CUB",
    CV: "CPV",
    CW: "CUW",
    CX: "CXR",
    CY: "CYP",
    CZ: "CZE",
    DE: "DEU",
    DJ: "DJI",
    DK: "DNK",
    DM: "DMA",
    DO: "DOM",
    DZ: "DZA",
    EC: "ECU",
    EE: "EST",
    EG: "EGY",
    EH: "ESH",
    ER: "ERI",
    ES: "ESP",
    ET: "ETH",
    FI: "FIN",
    FJ: "FJI",
    FK: "FLK",
    FM: "FSM",
    FO: "FRO",
    FR: "FRA",
    GA: "GAB",
    GB: "GBR",
    GD: "GRD",
    GE: "GEO",
    GF: "GUF",
    GG: "GGY",
    GH: "GHA",
    GI: "GIB",
    GL: "GRL",
    GM: "GMB",
    GN: "GIN",
    GP: "GLP",
    GQ: "GNQ",
    GR: "GRC",
    GS: "SGS",
    GT: "GTM",
    GU: "GUM",
    GW: "GNB",
    GY: "GUY",
    HK: "HKG",
    HM: "HMD",
    HN: "HND",
    HR: "HRV",
    HT: "HTI",
    HU: "HUN",
    ID: "IDN",
    IE: "IRL",
    IL: "ISR",
    IM: "IMN",
    IN: "IND",
    IO: "IOT",
    IQ: "IRQ",
    IR: "IRN",
    IS: "ISL",
    IT: "ITA",
    JE: "JEY",
    JM: "JAM",
    JO: "JOR",
    JP: "JPN",
    KE: "KEN",
    KG: "KGZ",
    KH: "KHM",
    KI: "KIR",
    KM: "COM",
    KN: "KNA",
    KP: "PRK",
    KR: "KOR",
    KW: "KWT",
    KY: "CYM",
    KZ: "KAZ",
    LA: "LAO",
    LB: "LBN",
    LC: "LCA",
    LI: "LIE",
    LK: "LKA",
    LR: "LBR",
    LS: "LSO",
    LT: "LTU",
    LU: "LUX",
    LV: "LVA",
    LY: "LBY",
    MA: "MAR",
    MC: "MCO",
    MD: "MDA",
    ME: "MNE",
    MF: "MAF",
    MG: "MDG",
    MH: "MHL",
    MK: "MKD",
    ML: "MLI",
    MM: "MMR",
    MN: "MNG",
    MO: "MAC",
    MP: "MNP",
    MQ: "MTQ",
    MR: "MRT",
    MS: "MSR",
    MT: "MLT",
    MU: "MUS",
    MV: "MDV",
    MW: "MWI",
    MX: "MEX",
    MY: "MYS",
    MZ: "MOZ",
    NA: "NAM",
    NC: "NCL",
    NE: "NER",
    NF: "NFK",
    NG: "NGA",
    NI: "NIC",
    NL: "NLD",
    NO: "NOR",
    NP: "NPL",
    NR: "NRU",
    NU: "NIU",
    NZ: "NZL",
    OM: "OMN",
    PA: "PAN",
    PE: "PER",
    PF: "PYF",
    PG: "PNG",
    PH: "PHL",
    PK: "PAK",
    PL: "POL",
    PM: "SPM",
    PN: "PCN",
    PR: "PRI",
    PS: "PSE",
    PT: "PRT",
    PW: "PLW",
    PY: "PRY",
    QA: "QAT",
    RE: "REU",
    RO: "ROU",
    RS: "SRB",
    RU: "RUS",
    RW: "RWA",
    SA: "SAU",
    SB: "SLB",
    SC: "SYC",
    SD: "SDN",
    SE: "SWE",
    SG: "SGP",
    SH: "SHN",
    SI: "SVN",
    SJ: "SJM",
    SK: "SVK",
    SL: "SLE",
    SM: "SMR",
    SN: "SEN",
    SO: "SOM",
    SR: "SUR",
    SS: "SSD",
    ST: "STP",
    SV: "SLV",
    SX: "SXM",
    SY: "SYR",
    SZ: "SWZ",
    TC: "TCA",
    TD: "TCD",
    TF: "ATF",
    TG: "TGO",
    TH: "THA",
    TJ: "TJK",
    TK: "TKL",
    TL: "TLS",
    TM: "TKM",
    TN: "TUN",
    TO: "TON",
    TR: "TUR",
    TT: "TTO",
    TV: "TUV",
    TW: "TWN",
    TZ: "TZA",
    UA: "UKR",
    UG: "UGA",
    UM: "UMI",
    US: "USA",
    UY: "URY",
    UZ: "UZB",
    VA: "VAT",
    VC: "VCT",
    VE: "VEN",
    VG: "VGB",
    VI: "VIR",
    VN: "VNM",
    VU: "VUT",
    WF: "WLF",
    WS: "WSM",
    XK: "XKX",
    YE: "YEM",
    YT: "MYT",
    ZA: "ZAF",
    ZM: "ZMB",
    ZW: "ZWE"
};
var $800f1464c09562a0$export$9fa40dab52a2897a = (n)=>({
        ...$800f1464c09562a0$export$e5ad74579c86b003[n],
        iso2: n,
        iso3: $800f1464c09562a0$var$r[n]
    }), $800f1464c09562a0$export$cc292de47df4a76 = ()=>Object.keys($800f1464c09562a0$export$e5ad74579c86b003).map((n)=>$800f1464c09562a0$export$9fa40dab52a2897a(n));
var $800f1464c09562a0$var$g = $800f1464c09562a0$export$cc292de47df4a76(), $800f1464c09562a0$export$63fb30b9076ed333 = (n)=>{
    let e = `${n}`.trim().replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d"), i = new RegExp("^" + e + "$", "i");
    return $800f1464c09562a0$var$g.find(({ name: o, native: l })=>i.test(o) || i.test(l))?.iso2 || !1;
};
var $800f1464c09562a0$var$p = 127397, $800f1464c09562a0$var$v = /^[A-Z]{2}$/, $800f1464c09562a0$export$632016834768939e = (n)=>$800f1464c09562a0$var$v.test(n) ? String.fromCodePoint(...n.split("").map((e)=>$800f1464c09562a0$var$p + e.toUpperCase().charCodeAt(0))) : "";

});

parcelRegister("9IUdZ", function(module, exports) {

$parcel$export(module.exports, "useCountryLanguageOptions", () => $2791434d3ec77f6e$export$9266733e305a0eef);

var $1eHG3 = parcelRequire("1eHG3");

var $bXTqq = parcelRequire("bXTqq");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");

var $d6b7y = parcelRequire("d6b7y");

var $buI4E = parcelRequire("buI4E");
const $2791434d3ec77f6e$export$9266733e305a0eef = (locales, forceLongName, fallback)=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { getCountryName: getCountryName } = (0, $d6b7y.useI18nIsoCountries)();
    return (0, $81g6h.useMemo)(()=>{
        const options = [];
        locales.forEach((countryLocales, countryCode)=>{
            if (!forceLongName && countryLocales.length === 1) {
                const intlLocale = (0, $bXTqq.localeToIntlLocale)(countryLocales[0]);
                const language = (0, $bXTqq.getLanguageSelfNameFromIntlLocale)(intlLocale);
                const countryName = getCountryName(countryCode, language, fallback);
                options.push({
                    locale: intlLocale,
                    label: countryName
                });
            } else countryLocales.forEach((locale)=>{
                const intlLocale = (0, $bXTqq.localeToIntlLocale)(locale);
                const languageCode = (0, $bXTqq.getLowercaseLanguageCodeFromIntlLocale)(intlLocale);
                if ((0, $lTdpc.isNil)(languageCode)) return;
                const language = (0, $bXTqq.getLanguageSelfNameFromIntlLocale)(intlLocale);
                const countryName = getCountryName(countryCode, languageCode, fallback);
                options.push({
                    locale: intlLocale,
                    label: format("register.countrySelection.countryDropdown.CountryAndLanguage", {
                        country: countryName,
                        language: language
                    })
                });
            });
        });
        return new Map((0, $buI4E.orderList)(options, "label").map(({ locale: locale, label: label })=>[
                locale,
                label
            ]));
    }, [
        fallback,
        format,
        getCountryName,
        locales,
        forceLongName
    ]);
};

});
parcelRegister("d6b7y", function(module, exports) {

$parcel$export(module.exports, "useI18nIsoCountries", () => $3b9a461f0f78236a$export$8a9a695d5b12e291);

var $81g6h = parcelRequire("81g6h");

var $aHXYe = parcelRequire("aHXYe");

var $k7d66 = parcelRequire("k7d66");

var $4Q3G4 = parcelRequire("4Q3G4");

var $84Ucc = parcelRequire("84Ucc");

var $j9HIt = parcelRequire("j9HIt");

var $6xmu9 = parcelRequire("6xmu9");
const $3b9a461f0f78236a$var$localeMap = {
    de: (/*@__PURE__*/$parcel$interopDefault($k7d66)),
    en: (/*@__PURE__*/$parcel$interopDefault($4Q3G4)),
    fr: (/*@__PURE__*/$parcel$interopDefault($84Ucc)),
    it: (/*@__PURE__*/$parcel$interopDefault($j9HIt)),
    nl: (/*@__PURE__*/$parcel$interopDefault($6xmu9))
};
const $3b9a461f0f78236a$var$SUPPORTED_LANGUAGES = Object.keys($3b9a461f0f78236a$var$localeMap);
$3b9a461f0f78236a$var$SUPPORTED_LANGUAGES.forEach((lang)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($aHXYe))).registerLocale($3b9a461f0f78236a$var$localeMap[lang]);
});
const $3b9a461f0f78236a$export$8a9a695d5b12e291 = ()=>{
    const getCountryName = (0, $81g6h.useCallback)((countryCode, languageCode, fallback)=>{
        if ($3b9a461f0f78236a$var$SUPPORTED_LANGUAGES.includes(languageCode)) return (0, (/*@__PURE__*/$parcel$interopDefault($aHXYe))).getName(countryCode, languageCode) ?? fallback(countryCode);
        return fallback(countryCode);
    }, []);
    return {
        getCountryName: getCountryName
    };
};

});
parcelRegister("aHXYe", function(module, exports) {

$parcel$export(module.exports, "registerLocale", () => $7cbc707060dc4935$export$bab6a7822cc1e2cd, (v) => $7cbc707060dc4935$export$bab6a7822cc1e2cd = v);
$parcel$export(module.exports, "alpha3ToAlpha2", () => $7cbc707060dc4935$export$2a91d0f6f59b9f68, (v) => $7cbc707060dc4935$export$2a91d0f6f59b9f68 = v);
$parcel$export(module.exports, "alpha2ToAlpha3", () => $7cbc707060dc4935$export$65a456803fd0f049, (v) => $7cbc707060dc4935$export$65a456803fd0f049 = v);
$parcel$export(module.exports, "alpha3ToNumeric", () => $7cbc707060dc4935$export$442b6884bee533cd, (v) => $7cbc707060dc4935$export$442b6884bee533cd = v);
$parcel$export(module.exports, "alpha2ToNumeric", () => $7cbc707060dc4935$export$e8f1fd30e9fba660, (v) => $7cbc707060dc4935$export$e8f1fd30e9fba660 = v);
$parcel$export(module.exports, "numericToAlpha3", () => $7cbc707060dc4935$export$c50ba58d0968541f, (v) => $7cbc707060dc4935$export$c50ba58d0968541f = v);
$parcel$export(module.exports, "numericToAlpha2", () => $7cbc707060dc4935$export$e21a59c72a3c77a7, (v) => $7cbc707060dc4935$export$e21a59c72a3c77a7 = v);
$parcel$export(module.exports, "toAlpha3", () => $7cbc707060dc4935$export$3d1d5c3d00561285, (v) => $7cbc707060dc4935$export$3d1d5c3d00561285 = v);
$parcel$export(module.exports, "toAlpha2", () => $7cbc707060dc4935$export$53e0b99b5d556acf, (v) => $7cbc707060dc4935$export$53e0b99b5d556acf = v);
$parcel$export(module.exports, "getName", () => $7cbc707060dc4935$export$7d9f7e9c1c02b41e, (v) => $7cbc707060dc4935$export$7d9f7e9c1c02b41e = v);
$parcel$export(module.exports, "getNames", () => $7cbc707060dc4935$export$dc8de070e3f64a1a, (v) => $7cbc707060dc4935$export$dc8de070e3f64a1a = v);
$parcel$export(module.exports, "getAlpha2Code", () => $7cbc707060dc4935$export$9abd449eff192ddc, (v) => $7cbc707060dc4935$export$9abd449eff192ddc = v);
$parcel$export(module.exports, "getSimpleAlpha2Code", () => $7cbc707060dc4935$export$2db6702cc2165503, (v) => $7cbc707060dc4935$export$2db6702cc2165503 = v);
$parcel$export(module.exports, "getAlpha2Codes", () => $7cbc707060dc4935$export$f340c49a8d00de7f, (v) => $7cbc707060dc4935$export$f340c49a8d00de7f = v);
$parcel$export(module.exports, "getAlpha3Code", () => $7cbc707060dc4935$export$51175d5ff4bc4261, (v) => $7cbc707060dc4935$export$51175d5ff4bc4261 = v);
$parcel$export(module.exports, "getSimpleAlpha3Code", () => $7cbc707060dc4935$export$13496d6083a3d6ac, (v) => $7cbc707060dc4935$export$13496d6083a3d6ac = v);
$parcel$export(module.exports, "getAlpha3Codes", () => $7cbc707060dc4935$export$5b1d6865bbe9ebc, (v) => $7cbc707060dc4935$export$5b1d6865bbe9ebc = v);
$parcel$export(module.exports, "getNumericCodes", () => $7cbc707060dc4935$export$5169b68793e9dfd1, (v) => $7cbc707060dc4935$export$5169b68793e9dfd1 = v);
$parcel$export(module.exports, "langs", () => $7cbc707060dc4935$export$359be4c8544d6fb1, (v) => $7cbc707060dc4935$export$359be4c8544d6fb1 = v);
$parcel$export(module.exports, "getSupportedLanguages", () => $7cbc707060dc4935$export$3308a67cbbb588bc, (v) => $7cbc707060dc4935$export$3308a67cbbb588bc = v);
$parcel$export(module.exports, "isValid", () => $7cbc707060dc4935$export$1ea939691cdc45b8, (v) => $7cbc707060dc4935$export$1ea939691cdc45b8 = v);
/**
 * Register countries in browsers' environment:
 * @param {object} localeData
 * @example countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
 * @return void
 */ var $7cbc707060dc4935$export$bab6a7822cc1e2cd;
var $7cbc707060dc4935$export$2a91d0f6f59b9f68;
var $7cbc707060dc4935$export$65a456803fd0f049;
var $7cbc707060dc4935$export$442b6884bee533cd;
var $7cbc707060dc4935$export$e8f1fd30e9fba660;
var $7cbc707060dc4935$export$c50ba58d0968541f;
var $7cbc707060dc4935$export$e21a59c72a3c77a7;
var $7cbc707060dc4935$export$3d1d5c3d00561285;
var $7cbc707060dc4935$export$53e0b99b5d556acf;
/**
 * @param {string | number | Alpha2Code | Alpha3Code} code
 * @param {String} lang          language for country name
 * @param {GetNameOptions} options
 * @return {String | String[] | undefined}  name
 */ var $7cbc707060dc4935$export$7d9f7e9c1c02b41e;
/**
 * @param {String} lang             language for country names
 * @param {GetNameOptions} options   getNames Options
 * @return {LocalizedCountryNames}  country code
 *                                  mapped to county name
 */ var $7cbc707060dc4935$export$dc8de070e3f64a1a;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-2 or undefined
 */ var $7cbc707060dc4935$export$9abd449eff192ddc;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-2 or undefined
 */ var $7cbc707060dc4935$export$2db6702cc2165503;
/*
 * @return Object of alpha-2 codes mapped to alpha-3 codes
 */ var $7cbc707060dc4935$export$f340c49a8d00de7f;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-3 or undefined
 */ var $7cbc707060dc4935$export$51175d5ff4bc4261;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-3 or undefined
 */ var $7cbc707060dc4935$export$13496d6083a3d6ac;
/*
 * @return Object of alpha-3 codes mapped to alpha-2 codes
 */ var $7cbc707060dc4935$export$5b1d6865bbe9ebc;
/*
 * @return Object of numeric codes mapped to alpha-2 codes
 */ var $7cbc707060dc4935$export$5169b68793e9dfd1;
/*
 * @return Array of registered languages
 */ var $7cbc707060dc4935$export$359be4c8544d6fb1;
/*
 * @return Array of supported languages
 */ var $7cbc707060dc4935$export$3308a67cbbb588bc;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return Boolean
 */ var $7cbc707060dc4935$export$1ea939691cdc45b8;
"use strict";

var $3SnvK = parcelRequire("3SnvK");

var $g65z0 = parcelRequire("g65z0");

var $cqwWz = parcelRequire("cqwWz");
var $7cbc707060dc4935$require$removeDiacritics = $cqwWz.remove;
const $7cbc707060dc4935$var$registeredLocales = {};
/*
 * All codes map to ISO 3166-1 alpha-2
 */ const $7cbc707060dc4935$var$alpha2 = {}, $7cbc707060dc4935$var$alpha3 = {}, $7cbc707060dc4935$var$numeric = {}, $7cbc707060dc4935$var$invertedNumeric = {};
$3SnvK.forEach(function(codeInformation) {
    const s = codeInformation;
    $7cbc707060dc4935$var$alpha2[s[0]] = s[1];
    $7cbc707060dc4935$var$alpha3[s[1]] = s[0];
    $7cbc707060dc4935$var$numeric[s[2]] = s[0];
    $7cbc707060dc4935$var$invertedNumeric[s[0]] = s[2];
});
/**
 * @private
 * @param {number} code
 */ function $7cbc707060dc4935$var$formatNumericCode(code) {
    return String("000" + (code ? code : "")).slice(-3);
}
/**
 * @private
 * Avoid using obj.hasOwnProperty directly as `hasOwnProperty` could be a
 * property in itself ({ hasOwnProperty: 1 }) and cause weird bugs
 * https://eslint.org/docs/rules/no-prototype-builtins
 */ function $7cbc707060dc4935$var$hasOwnProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
/**
 * @private
 * Pass localeList through a filter and return a newLocaleList obj
 * with the same structure of the old localeList.
 *
 * @param {LocalizedCountryNames} localeList  Local List in raw
 * @param {Function} filter    callback to set filter rule
 * @return {String | String[]} new filtered Local List
 */ function $7cbc707060dc4935$var$localeFilter(localeList, filter) {
    return Object.keys(localeList).reduce(function(newLocaleList, alpha2) {
        const nameList = localeList[alpha2];
        newLocaleList[alpha2] = filter(nameList, alpha2);
        return newLocaleList;
    }, {});
}
/**
 * @private
 * Preserve for getName & getNames
 *
 * @param {GetNameOptions.select} type all | official | alias
 * @param countryNameList  string array of country's
 *                         official name and alias
 * @return {String | String[]} of a country name
 */ function $7cbc707060dc4935$var$filterNameBy(type, countryNameList) {
    switch(type){
        case "official":
            return Array.isArray(countryNameList) ? countryNameList[0] : countryNameList;
        case "all":
            return typeof countryNameList === "string" ? [
                countryNameList
            ] : countryNameList;
        case "alias":
            return Array.isArray(countryNameList) ? countryNameList[1] || countryNameList[0] : countryNameList;
        default:
            throw new TypeError("LocaleNameType must be one of these: all, official, alias!");
    }
}
$7cbc707060dc4935$export$bab6a7822cc1e2cd = function(localeData) {
    if (!localeData.locale) throw new TypeError("Missing localeData.locale");
    if (!localeData.countries) throw new TypeError("Missing localeData.countries");
    $7cbc707060dc4935$var$registeredLocales[localeData.locale] = localeData.countries;
};
/*
 * @param code Alpha-3 code
 * @return Alpha-2 code or undefined
 */ function $7cbc707060dc4935$var$alpha3ToAlpha2(code) {
    return $7cbc707060dc4935$var$alpha3[code];
}
$7cbc707060dc4935$export$2a91d0f6f59b9f68 = $7cbc707060dc4935$var$alpha3ToAlpha2;
/*
 * @param code Alpha-2 code
 * @return Alpha-3 code or undefined
 */ function $7cbc707060dc4935$var$alpha2ToAlpha3(code) {
    return $7cbc707060dc4935$var$alpha2[code];
}
$7cbc707060dc4935$export$65a456803fd0f049 = $7cbc707060dc4935$var$alpha2ToAlpha3;
/*
 * @param code Alpha-3 code
 * @return Numeric code or undefined
 */ function $7cbc707060dc4935$var$alpha3ToNumeric(code) {
    return $7cbc707060dc4935$var$invertedNumeric[$7cbc707060dc4935$var$alpha3ToAlpha2(code)];
}
$7cbc707060dc4935$export$442b6884bee533cd = $7cbc707060dc4935$var$alpha3ToNumeric;
/*
 * @param code Alpha-2 code
 * @return Numeric code or undefined
 */ function $7cbc707060dc4935$var$alpha2ToNumeric(code) {
    return $7cbc707060dc4935$var$invertedNumeric[code];
}
$7cbc707060dc4935$export$e8f1fd30e9fba660 = $7cbc707060dc4935$var$alpha2ToNumeric;
/*
 * @param code Numeric code
 * @return Alpha-3 code or undefined
 */ function $7cbc707060dc4935$var$numericToAlpha3(code) {
    const padded = $7cbc707060dc4935$var$formatNumericCode(code);
    return $7cbc707060dc4935$var$alpha2ToAlpha3($7cbc707060dc4935$var$numeric[padded]);
}
$7cbc707060dc4935$export$c50ba58d0968541f = $7cbc707060dc4935$var$numericToAlpha3;
/*
 * @param code Numeric code
 * @return Alpha-2 code or undefined
 */ function $7cbc707060dc4935$var$numericToAlpha2(code) {
    const padded = $7cbc707060dc4935$var$formatNumericCode(code);
    return $7cbc707060dc4935$var$numeric[padded];
}
$7cbc707060dc4935$export$e21a59c72a3c77a7 = $7cbc707060dc4935$var$numericToAlpha2;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return ISO 3166-1 alpha-3
 */ function $7cbc707060dc4935$var$toAlpha3(code) {
    if (typeof code === "string") {
        if (/^[0-9]*$/.test(code)) return $7cbc707060dc4935$var$numericToAlpha3(code);
        if (code.length === 2) return $7cbc707060dc4935$var$alpha2ToAlpha3(code.toUpperCase());
        if (code.length === 3) return code.toUpperCase();
    }
    if (typeof code === "number") return $7cbc707060dc4935$var$numericToAlpha3(code);
    return undefined;
}
$7cbc707060dc4935$export$3d1d5c3d00561285 = $7cbc707060dc4935$var$toAlpha3;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return ISO 3166-1 alpha-2
 */ function $7cbc707060dc4935$var$toAlpha2(code) {
    if (typeof code === "string") {
        if (/^[0-9]*$/.test(code)) return $7cbc707060dc4935$var$numericToAlpha2(code);
        if (code.length === 2) return code.toUpperCase();
        if (code.length === 3) return $7cbc707060dc4935$var$alpha3ToAlpha2(code.toUpperCase());
    }
    if (typeof code === "number") return $7cbc707060dc4935$var$numericToAlpha2(code);
    return undefined;
}
$7cbc707060dc4935$export$53e0b99b5d556acf = $7cbc707060dc4935$var$toAlpha2;
$7cbc707060dc4935$export$7d9f7e9c1c02b41e = function(code, lang, options = {}) {
    if (!("select" in options)) options.select = "official";
    try {
        const codeMaps = $7cbc707060dc4935$var$registeredLocales[lang.toLowerCase()];
        const nameList = codeMaps[$7cbc707060dc4935$var$toAlpha2(code)];
        return $7cbc707060dc4935$var$filterNameBy(options.select, nameList);
    } catch (err) {
        return undefined;
    }
};
$7cbc707060dc4935$export$dc8de070e3f64a1a = function(lang, options = {}) {
    if (!("select" in options)) options.select = "official";
    const localeList = $7cbc707060dc4935$var$registeredLocales[lang.toLowerCase()];
    if (localeList === undefined) return {};
    return $7cbc707060dc4935$var$localeFilter(localeList, function(nameList) {
        return $7cbc707060dc4935$var$filterNameBy(options.select, nameList);
    });
};
$7cbc707060dc4935$export$9abd449eff192ddc = function(name, lang) {
    const normalizeString = (string)=>string.toLowerCase();
    const areSimilar = (a, b)=>normalizeString(a) === normalizeString(b);
    try {
        const codenames = $7cbc707060dc4935$var$registeredLocales[lang.toLowerCase()];
        for(const p in codenames){
            if (!$7cbc707060dc4935$var$hasOwnProperty(codenames, p)) continue;
            if (typeof codenames[p] === "string") {
                if (areSimilar(codenames[p], name)) return p;
            }
            if (Array.isArray(codenames[p])) for (const mappedName of codenames[p]){
                if (areSimilar(mappedName, name)) return p;
            }
        }
        return undefined;
    } catch (err) {
        return undefined;
    }
};
$7cbc707060dc4935$export$2db6702cc2165503 = function(name, lang) {
    const normalizeString = (string)=>$7cbc707060dc4935$require$removeDiacritics(string.toLowerCase());
    const areSimilar = (a, b)=>normalizeString(a) === normalizeString(b);
    try {
        const codenames = $7cbc707060dc4935$var$registeredLocales[lang.toLowerCase()];
        for(const p in codenames){
            if (!$7cbc707060dc4935$var$hasOwnProperty(codenames, p)) continue;
            if (typeof codenames[p] === "string") {
                if (areSimilar(codenames[p], name)) return p;
            }
            if (Array.isArray(codenames[p])) for (const mappedName of codenames[p]){
                if (areSimilar(mappedName, name)) return p;
            }
        }
        return undefined;
    } catch (err) {
        return undefined;
    }
};
$7cbc707060dc4935$export$f340c49a8d00de7f = function() {
    return $7cbc707060dc4935$var$alpha2;
};
$7cbc707060dc4935$export$51175d5ff4bc4261 = function(name, lang) {
    const alpha2 = $7cbc707060dc4935$export$9abd449eff192ddc(name, lang);
    if (alpha2) return $7cbc707060dc4935$export$3d1d5c3d00561285(alpha2);
    else return undefined;
};
$7cbc707060dc4935$export$13496d6083a3d6ac = function(name, lang) {
    const alpha2 = $7cbc707060dc4935$export$2db6702cc2165503(name, lang);
    if (alpha2) return $7cbc707060dc4935$export$3d1d5c3d00561285(alpha2);
    else return undefined;
};
$7cbc707060dc4935$export$5b1d6865bbe9ebc = function() {
    return $7cbc707060dc4935$var$alpha3;
};
$7cbc707060dc4935$export$5169b68793e9dfd1 = function() {
    return $7cbc707060dc4935$var$numeric;
};
$7cbc707060dc4935$export$359be4c8544d6fb1 = function() {
    return Object.keys($7cbc707060dc4935$var$registeredLocales);
};
$7cbc707060dc4935$export$3308a67cbbb588bc = function() {
    return $g65z0;
};
$7cbc707060dc4935$export$1ea939691cdc45b8 = function(code) {
    if (!code) return false;
    const coerced = code.toString().toUpperCase();
    return $7cbc707060dc4935$var$hasOwnProperty($7cbc707060dc4935$var$alpha3, coerced) || $7cbc707060dc4935$var$hasOwnProperty($7cbc707060dc4935$var$alpha2, coerced) || $7cbc707060dc4935$var$hasOwnProperty($7cbc707060dc4935$var$numeric, coerced);
};

});
parcelRegister("3SnvK", function(module, exports) {
module.exports = JSON.parse('[["AF","AFG","004","ISO 3166-2:AF"],["AL","ALB","008","ISO 3166-2:AL"],["DZ","DZA","012","ISO 3166-2:DZ"],["AS","ASM","016","ISO 3166-2:AS"],["AD","AND","020","ISO 3166-2:AD"],["AO","AGO","024","ISO 3166-2:AO"],["AI","AIA","660","ISO 3166-2:AI"],["AQ","ATA","010","ISO 3166-2:AQ"],["AG","ATG","028","ISO 3166-2:AG"],["AR","ARG","032","ISO 3166-2:AR"],["AM","ARM","051","ISO 3166-2:AM"],["AW","ABW","533","ISO 3166-2:AW"],["AU","AUS","036","ISO 3166-2:AU"],["AT","AUT","040","ISO 3166-2:AT"],["AZ","AZE","031","ISO 3166-2:AZ"],["BS","BHS","044","ISO 3166-2:BS"],["BH","BHR","048","ISO 3166-2:BH"],["BD","BGD","050","ISO 3166-2:BD"],["BB","BRB","052","ISO 3166-2:BB"],["BY","BLR","112","ISO 3166-2:BY"],["BE","BEL","056","ISO 3166-2:BE"],["BZ","BLZ","084","ISO 3166-2:BZ"],["BJ","BEN","204","ISO 3166-2:BJ"],["BM","BMU","060","ISO 3166-2:BM"],["BT","BTN","064","ISO 3166-2:BT"],["BO","BOL","068","ISO 3166-2:BO"],["BA","BIH","070","ISO 3166-2:BA"],["BW","BWA","072","ISO 3166-2:BW"],["BV","BVT","074","ISO 3166-2:BV"],["BR","BRA","076","ISO 3166-2:BR"],["IO","IOT","086","ISO 3166-2:IO"],["BN","BRN","096","ISO 3166-2:BN"],["BG","BGR","100","ISO 3166-2:BG"],["BF","BFA","854","ISO 3166-2:BF"],["BI","BDI","108","ISO 3166-2:BI"],["KH","KHM","116","ISO 3166-2:KH"],["CM","CMR","120","ISO 3166-2:CM"],["CA","CAN","124","ISO 3166-2:CA"],["CV","CPV","132","ISO 3166-2:CV"],["KY","CYM","136","ISO 3166-2:KY"],["CF","CAF","140","ISO 3166-2:CF"],["TD","TCD","148","ISO 3166-2:TD"],["CL","CHL","152","ISO 3166-2:CL"],["CN","CHN","156","ISO 3166-2:CN"],["CX","CXR","162","ISO 3166-2:CX"],["CC","CCK","166","ISO 3166-2:CC"],["CO","COL","170","ISO 3166-2:CO"],["KM","COM","174","ISO 3166-2:KM"],["CG","COG","178","ISO 3166-2:CG"],["CD","COD","180","ISO 3166-2:CD"],["CK","COK","184","ISO 3166-2:CK"],["CR","CRI","188","ISO 3166-2:CR"],["CI","CIV","384","ISO 3166-2:CI"],["HR","HRV","191","ISO 3166-2:HR"],["CU","CUB","192","ISO 3166-2:CU"],["CY","CYP","196","ISO 3166-2:CY"],["CZ","CZE","203","ISO 3166-2:CZ"],["DK","DNK","208","ISO 3166-2:DK"],["DJ","DJI","262","ISO 3166-2:DJ"],["DM","DMA","212","ISO 3166-2:DM"],["DO","DOM","214","ISO 3166-2:DO"],["EC","ECU","218","ISO 3166-2:EC"],["EG","EGY","818","ISO 3166-2:EG"],["SV","SLV","222","ISO 3166-2:SV"],["GQ","GNQ","226","ISO 3166-2:GQ"],["ER","ERI","232","ISO 3166-2:ER"],["EE","EST","233","ISO 3166-2:EE"],["ET","ETH","231","ISO 3166-2:ET"],["FK","FLK","238","ISO 3166-2:FK"],["FO","FRO","234","ISO 3166-2:FO"],["FJ","FJI","242","ISO 3166-2:FJ"],["FI","FIN","246","ISO 3166-2:FI"],["FR","FRA","250","ISO 3166-2:FR"],["GF","GUF","254","ISO 3166-2:GF"],["PF","PYF","258","ISO 3166-2:PF"],["TF","ATF","260","ISO 3166-2:TF"],["GA","GAB","266","ISO 3166-2:GA"],["GM","GMB","270","ISO 3166-2:GM"],["GE","GEO","268","ISO 3166-2:GE"],["DE","DEU","276","ISO 3166-2:DE"],["GH","GHA","288","ISO 3166-2:GH"],["GI","GIB","292","ISO 3166-2:GI"],["GR","GRC","300","ISO 3166-2:GR"],["GL","GRL","304","ISO 3166-2:GL"],["GD","GRD","308","ISO 3166-2:GD"],["GP","GLP","312","ISO 3166-2:GP"],["GU","GUM","316","ISO 3166-2:GU"],["GT","GTM","320","ISO 3166-2:GT"],["GN","GIN","324","ISO 3166-2:GN"],["GW","GNB","624","ISO 3166-2:GW"],["GY","GUY","328","ISO 3166-2:GY"],["HT","HTI","332","ISO 3166-2:HT"],["HM","HMD","334","ISO 3166-2:HM"],["VA","VAT","336","ISO 3166-2:VA"],["HN","HND","340","ISO 3166-2:HN"],["HK","HKG","344","ISO 3166-2:HK"],["HU","HUN","348","ISO 3166-2:HU"],["IS","ISL","352","ISO 3166-2:IS"],["IN","IND","356","ISO 3166-2:IN"],["ID","IDN","360","ISO 3166-2:ID"],["IR","IRN","364","ISO 3166-2:IR"],["IQ","IRQ","368","ISO 3166-2:IQ"],["IE","IRL","372","ISO 3166-2:IE"],["IL","ISR","376","ISO 3166-2:IL"],["IT","ITA","380","ISO 3166-2:IT"],["JM","JAM","388","ISO 3166-2:JM"],["JP","JPN","392","ISO 3166-2:JP"],["JO","JOR","400","ISO 3166-2:JO"],["KZ","KAZ","398","ISO 3166-2:KZ"],["KE","KEN","404","ISO 3166-2:KE"],["KI","KIR","296","ISO 3166-2:KI"],["KP","PRK","408","ISO 3166-2:KP"],["KR","KOR","410","ISO 3166-2:KR"],["KW","KWT","414","ISO 3166-2:KW"],["KG","KGZ","417","ISO 3166-2:KG"],["LA","LAO","418","ISO 3166-2:LA"],["LV","LVA","428","ISO 3166-2:LV"],["LB","LBN","422","ISO 3166-2:LB"],["LS","LSO","426","ISO 3166-2:LS"],["LR","LBR","430","ISO 3166-2:LR"],["LY","LBY","434","ISO 3166-2:LY"],["LI","LIE","438","ISO 3166-2:LI"],["LT","LTU","440","ISO 3166-2:LT"],["LU","LUX","442","ISO 3166-2:LU"],["MO","MAC","446","ISO 3166-2:MO"],["MG","MDG","450","ISO 3166-2:MG"],["MW","MWI","454","ISO 3166-2:MW"],["MY","MYS","458","ISO 3166-2:MY"],["MV","MDV","462","ISO 3166-2:MV"],["ML","MLI","466","ISO 3166-2:ML"],["MT","MLT","470","ISO 3166-2:MT"],["MH","MHL","584","ISO 3166-2:MH"],["MQ","MTQ","474","ISO 3166-2:MQ"],["MR","MRT","478","ISO 3166-2:MR"],["MU","MUS","480","ISO 3166-2:MU"],["YT","MYT","175","ISO 3166-2:YT"],["MX","MEX","484","ISO 3166-2:MX"],["FM","FSM","583","ISO 3166-2:FM"],["MD","MDA","498","ISO 3166-2:MD"],["MC","MCO","492","ISO 3166-2:MC"],["MN","MNG","496","ISO 3166-2:MN"],["MS","MSR","500","ISO 3166-2:MS"],["MA","MAR","504","ISO 3166-2:MA"],["MZ","MOZ","508","ISO 3166-2:MZ"],["MM","MMR","104","ISO 3166-2:MM"],["NA","NAM","516","ISO 3166-2:NA"],["NR","NRU","520","ISO 3166-2:NR"],["NP","NPL","524","ISO 3166-2:NP"],["NL","NLD","528","ISO 3166-2:NL"],["NC","NCL","540","ISO 3166-2:NC"],["NZ","NZL","554","ISO 3166-2:NZ"],["NI","NIC","558","ISO 3166-2:NI"],["NE","NER","562","ISO 3166-2:NE"],["NG","NGA","566","ISO 3166-2:NG"],["NU","NIU","570","ISO 3166-2:NU"],["NF","NFK","574","ISO 3166-2:NF"],["MP","MNP","580","ISO 3166-2:MP"],["MK","MKD","807","ISO 3166-2:MK"],["NO","NOR","578","ISO 3166-2:NO"],["OM","OMN","512","ISO 3166-2:OM"],["PK","PAK","586","ISO 3166-2:PK"],["PW","PLW","585","ISO 3166-2:PW"],["PS","PSE","275","ISO 3166-2:PS"],["PA","PAN","591","ISO 3166-2:PA"],["PG","PNG","598","ISO 3166-2:PG"],["PY","PRY","600","ISO 3166-2:PY"],["PE","PER","604","ISO 3166-2:PE"],["PH","PHL","608","ISO 3166-2:PH"],["PN","PCN","612","ISO 3166-2:PN"],["PL","POL","616","ISO 3166-2:PL"],["PT","PRT","620","ISO 3166-2:PT"],["PR","PRI","630","ISO 3166-2:PR"],["QA","QAT","634","ISO 3166-2:QA"],["RE","REU","638","ISO 3166-2:RE"],["RO","ROU","642","ISO 3166-2:RO"],["RU","RUS","643","ISO 3166-2:RU"],["RW","RWA","646","ISO 3166-2:RW"],["SH","SHN","654","ISO 3166-2:SH"],["KN","KNA","659","ISO 3166-2:KN"],["LC","LCA","662","ISO 3166-2:LC"],["PM","SPM","666","ISO 3166-2:PM"],["VC","VCT","670","ISO 3166-2:VC"],["WS","WSM","882","ISO 3166-2:WS"],["SM","SMR","674","ISO 3166-2:SM"],["ST","STP","678","ISO 3166-2:ST"],["SA","SAU","682","ISO 3166-2:SA"],["SN","SEN","686","ISO 3166-2:SN"],["SC","SYC","690","ISO 3166-2:SC"],["SL","SLE","694","ISO 3166-2:SL"],["SG","SGP","702","ISO 3166-2:SG"],["SK","SVK","703","ISO 3166-2:SK"],["SI","SVN","705","ISO 3166-2:SI"],["SB","SLB","090","ISO 3166-2:SB"],["SO","SOM","706","ISO 3166-2:SO"],["ZA","ZAF","710","ISO 3166-2:ZA"],["GS","SGS","239","ISO 3166-2:GS"],["ES","ESP","724","ISO 3166-2:ES"],["LK","LKA","144","ISO 3166-2:LK"],["SD","SDN","729","ISO 3166-2:SD"],["SR","SUR","740","ISO 3166-2:SR"],["SJ","SJM","744","ISO 3166-2:SJ"],["SZ","SWZ","748","ISO 3166-2:SZ"],["SE","SWE","752","ISO 3166-2:SE"],["CH","CHE","756","ISO 3166-2:CH"],["SY","SYR","760","ISO 3166-2:SY"],["TW","TWN","158","ISO 3166-2:TW"],["TJ","TJK","762","ISO 3166-2:TJ"],["TZ","TZA","834","ISO 3166-2:TZ"],["TH","THA","764","ISO 3166-2:TH"],["TL","TLS","626","ISO 3166-2:TL"],["TG","TGO","768","ISO 3166-2:TG"],["TK","TKL","772","ISO 3166-2:TK"],["TO","TON","776","ISO 3166-2:TO"],["TT","TTO","780","ISO 3166-2:TT"],["TN","TUN","788","ISO 3166-2:TN"],["TR","TUR","792","ISO 3166-2:TR"],["TM","TKM","795","ISO 3166-2:TM"],["TC","TCA","796","ISO 3166-2:TC"],["TV","TUV","798","ISO 3166-2:TV"],["UG","UGA","800","ISO 3166-2:UG"],["UA","UKR","804","ISO 3166-2:UA"],["AE","ARE","784","ISO 3166-2:AE"],["GB","GBR","826","ISO 3166-2:GB"],["US","USA","840","ISO 3166-2:US"],["UM","UMI","581","ISO 3166-2:UM"],["UY","URY","858","ISO 3166-2:UY"],["UZ","UZB","860","ISO 3166-2:UZ"],["VU","VUT","548","ISO 3166-2:VU"],["VE","VEN","862","ISO 3166-2:VE"],["VN","VNM","704","ISO 3166-2:VN"],["VG","VGB","092","ISO 3166-2:VG"],["VI","VIR","850","ISO 3166-2:VI"],["WF","WLF","876","ISO 3166-2:WF"],["EH","ESH","732","ISO 3166-2:EH"],["YE","YEM","887","ISO 3166-2:YE"],["ZM","ZMB","894","ISO 3166-2:ZM"],["ZW","ZWE","716","ISO 3166-2:ZW"],["AX","ALA","248","ISO 3166-2:AX"],["BQ","BES","535","ISO 3166-2:BQ"],["CW","CUW","531","ISO 3166-2:CW"],["GG","GGY","831","ISO 3166-2:GG"],["IM","IMN","833","ISO 3166-2:IM"],["JE","JEY","832","ISO 3166-2:JE"],["ME","MNE","499","ISO 3166-2:ME"],["BL","BLM","652","ISO 3166-2:BL"],["MF","MAF","663","ISO 3166-2:MF"],["RS","SRB","688","ISO 3166-2:RS"],["SX","SXM","534","ISO 3166-2:SX"],["SS","SSD","728","ISO 3166-2:SS"],["XK","XKK","983","ISO 3166-2:XK"]]');

});

parcelRegister("g65z0", function(module, exports) {
module.exports = JSON.parse('["br","cy","dv","sw","eu","af","am","ha","ku","ml","mt","no","ps","sd","so","sq","ta","tg","tt","ug","ur","vi","ar","az","be","bg","bn","bs","ca","cs","da","de","el","en","es","et","fa","fi","fr","ga","gl","he","hi","hr","hu","hy","id","is","it","ja","ka","kk","km","ko","ky","lt","lv","mk","mn","mr","ms","nb","nl","nn","pl","pt","ro","ru","sk","sl","sr","sv","th","tk","tr","uk","uz","zh"]');

});

parcelRegister("cqwWz", function(module, exports) {

$parcel$export(module.exports, "remove", () => $90c177a952398f09$export$cd7f480d6b8286c3, (v) => $90c177a952398f09$export$cd7f480d6b8286c3 = v);
var $90c177a952398f09$export$cd7f480d6b8286c3;
var $90c177a952398f09$export$452fcf31d2a11c49;
var $90c177a952398f09$export$a078a2660a2c4d03;
$90c177a952398f09$export$cd7f480d6b8286c3 = $90c177a952398f09$var$removeDiacritics;
var $90c177a952398f09$var$replacementList = [
    {
        base: " ",
        chars: "\xa0"
    },
    {
        base: "0",
        chars: "\u07C0"
    },
    {
        base: "A",
        chars: "\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        chars: "\uA732"
    },
    {
        base: "AE",
        chars: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        chars: "\uA734"
    },
    {
        base: "AU",
        chars: "\uA736"
    },
    {
        base: "AV",
        chars: "\uA738\uA73A"
    },
    {
        base: "AY",
        chars: "\uA73C"
    },
    {
        base: "B",
        chars: "\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0181"
    },
    {
        base: "C",
        chars: "\u24B8\uFF23\uA73E\u1E08\u0106C\u0108\u010A\u010C\xc7\u0187\u023B"
    },
    {
        base: "D",
        chars: "\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018A\u0189\u1D05\uA779"
    },
    {
        base: "Dh",
        chars: "\xd0"
    },
    {
        base: "DZ",
        chars: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        chars: "\u01F2\u01C5"
    },
    {
        base: "E",
        chars: "\u025B\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E\u1D07"
    },
    {
        base: "F",
        chars: "\uA77C\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        chars: "\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E\u0262"
    },
    {
        base: "H",
        chars: "\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        chars: "\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        chars: "\u24BF\uFF2A\u0134\u0248\u0237"
    },
    {
        base: "K",
        chars: "\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        chars: "\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        chars: "\u01C7"
    },
    {
        base: "Lj",
        chars: "\u01C8"
    },
    {
        base: "M",
        chars: "\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C\u03FB"
    },
    {
        base: "N",
        chars: "\uA7A4\u0220\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u019D\uA790\u1D0E"
    },
    {
        base: "NJ",
        chars: "\u01CA"
    },
    {
        base: "Nj",
        chars: "\u01CB"
    },
    {
        base: "O",
        chars: "\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OE",
        chars: "\u0152"
    },
    {
        base: "OI",
        chars: "\u01A2"
    },
    {
        base: "OO",
        chars: "\uA74E"
    },
    {
        base: "OU",
        chars: "\u0222"
    },
    {
        base: "P",
        chars: "\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        chars: "\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        chars: "\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        chars: "\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        chars: "\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "Th",
        chars: "\xde"
    },
    {
        base: "TZ",
        chars: "\uA728"
    },
    {
        base: "U",
        chars: "\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        chars: "\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        chars: "\uA760"
    },
    {
        base: "W",
        chars: "\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        chars: "\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        chars: "\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        chars: "\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        chars: "\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251"
    },
    {
        base: "aa",
        chars: "\uA733"
    },
    {
        base: "ae",
        chars: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        chars: "\uA735"
    },
    {
        base: "au",
        chars: "\uA737"
    },
    {
        base: "av",
        chars: "\uA739\uA73B"
    },
    {
        base: "ay",
        chars: "\uA73D"
    },
    {
        base: "b",
        chars: "\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253\u0182"
    },
    {
        base: "c",
        chars: "\uFF43\u24D2\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        chars: "\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\u018B\u13E7\u0501\uA7AA"
    },
    {
        base: "dh",
        chars: "\xf0"
    },
    {
        base: "dz",
        chars: "\u01F3\u01C6"
    },
    {
        base: "e",
        chars: "\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u01DD"
    },
    {
        base: "f",
        chars: "\u24D5\uFF46\u1E1F\u0192"
    },
    {
        base: "ff",
        chars: "\uFB00"
    },
    {
        base: "fi",
        chars: "\uFB01"
    },
    {
        base: "fl",
        chars: "\uFB02"
    },
    {
        base: "ffi",
        chars: "\uFB03"
    },
    {
        base: "ffl",
        chars: "\uFB04"
    },
    {
        base: "g",
        chars: "\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\uA77F\u1D79"
    },
    {
        base: "h",
        chars: "\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        chars: "\u0195"
    },
    {
        base: "i",
        chars: "\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        chars: "\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        chars: "\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        chars: "\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747\u026D"
    },
    {
        base: "lj",
        chars: "\u01C9"
    },
    {
        base: "m",
        chars: "\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        chars: "\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509"
    },
    {
        base: "nj",
        chars: "\u01CC"
    },
    {
        base: "o",
        chars: "\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\uA74B\uA74D\u0275\u0254\u1D11"
    },
    {
        base: "oe",
        chars: "\u0153"
    },
    {
        base: "oi",
        chars: "\u01A3"
    },
    {
        base: "oo",
        chars: "\uA74F"
    },
    {
        base: "ou",
        chars: "\u0223"
    },
    {
        base: "p",
        chars: "\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755\u03C1"
    },
    {
        base: "q",
        chars: "\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        chars: "\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        chars: "\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u0282"
    },
    {
        base: "ss",
        chars: "\xdf"
    },
    {
        base: "t",
        chars: "\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "th",
        chars: "\xfe"
    },
    {
        base: "tz",
        chars: "\uA729"
    },
    {
        base: "u",
        chars: "\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        chars: "\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        chars: "\uA761"
    },
    {
        base: "w",
        chars: "\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        chars: "\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        chars: "\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        chars: "\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $90c177a952398f09$var$diacriticsMap = {};
for(var $90c177a952398f09$var$i = 0; $90c177a952398f09$var$i < $90c177a952398f09$var$replacementList.length; $90c177a952398f09$var$i += 1){
    var $90c177a952398f09$var$chars = $90c177a952398f09$var$replacementList[$90c177a952398f09$var$i].chars;
    for(var $90c177a952398f09$var$j = 0; $90c177a952398f09$var$j < $90c177a952398f09$var$chars.length; $90c177a952398f09$var$j += 1)$90c177a952398f09$var$diacriticsMap[$90c177a952398f09$var$chars[$90c177a952398f09$var$j]] = $90c177a952398f09$var$replacementList[$90c177a952398f09$var$i].base;
}
function $90c177a952398f09$var$removeDiacritics(str) {
    return str.replace(/[^\u0000-\u007e]/g, function(c) {
        return $90c177a952398f09$var$diacriticsMap[c] || c;
    });
}
$90c177a952398f09$export$452fcf31d2a11c49 = $90c177a952398f09$var$replacementList;
$90c177a952398f09$export$a078a2660a2c4d03 = $90c177a952398f09$var$diacriticsMap;

});


parcelRegister("k7d66", function(module, exports) {
module.exports = JSON.parse('{"locale":"de","countries":{"AF":"Afghanistan","EG":"\xc4gypten","AX":"\xc5land","AL":"Albanien","DZ":"Algerien","AS":"Amerikanisch-Samoa","VI":"Amerikanische Jungferninseln","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarktis","AG":"Antigua und Barbuda","GQ":"\xc4quatorialguinea","AR":"Argentinien","AM":"Armenien","AW":"Aruba","AZ":"Aserbaidschan","ET":"\xc4thiopien","AU":"Australien","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesch","BB":"Barbados","BY":"Belarus","BE":"Belgien","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivien","BQ":"Bonaire","BA":"Bosnien und Herzegowina","BW":"Botswana","BV":"Bouvetinsel","BR":"Brasilien","VG":"Britische Jungferninseln","IO":"Britisches Territorium im Indischen Ozean","BN":"Brunei Darussalam","BG":"Bulgarien","BF":"Burkina Faso","BI":"Burundi","CL":"Chile","CN":"China","CK":"Cookinseln","CR":"Costa Rica","CI":"Elfenbeink\xfcste","CW":"Cura\xe7ao","DK":"D\xe4nemark","DE":"Deutschland","DM":"Dominica","DO":"Dominikanische Republik","DJ":"Dschibuti","EC":"Ecuador","SV":"El Salvador","ER":"Eritrea","EE":"Estland","FK":"Falklandinseln","FO":"F\xe4r\xf6er","FJ":"Fidschi","FI":"Finnland","FR":"Frankreich","GF":"Franz\xf6sisch-Guayana","PF":"Franz\xf6sisch-Polynesien","TF":"Franz\xf6sische S\xfcd- und Antarktisgebiete","GA":"Gabun","GM":"Gambia","GE":"Georgien","GH":"Ghana","GI":"Gibraltar","GD":"Grenada","GR":"Griechenland","GL":"Gr\xf6nland","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard und McDonaldinseln","HN":"Honduras","HK":["Hongkong","Hong Kong"],"IN":"Indien","ID":"Indonesien","IM":"Insel Man","IQ":"Irak","IR":"Iran","IE":"Irland","IS":"Island","IL":"Israel","IT":"Italien","JM":"Jamaika","JP":"Japan","YE":"Jemen","JE":"Jersey","JO":"Jordanien","KY":"Kaimaninseln","KH":"Kambodscha","CM":"Kamerun","CA":"Kanada","CV":"Kap Verde","KZ":"Kasachstan","QA":"Katar","KE":"Kenia","KG":"Kirgisistan","KI":"Kiribati","CC":"Kokosinseln","CO":"Kolumbien","KM":"Komoren","CD":"Kongo","KP":"Nordkorea","KR":"S\xfcdkorea","HR":"Kroatien","CU":"Kuba","KW":"Kuwait","LA":"Laos","LS":"Lesotho","LV":"Lettland","LB":"Libanon","LR":"Liberia","LY":"Libyen","LI":"Liechtenstein","LT":"Litauen","LU":"Luxemburg","MO":"Macao","MG":"Madagaskar","MW":"Malawi","MY":"Malaysia","MV":"Malediven","ML":"Mali","MT":"Malta","MA":"Marokko","MH":"Marshallinseln","MQ":"Martinique","MR":"Mauretanien","MU":"Mauritius","YT":"Mayotte","MX":"Mexiko","FM":"Mikronesien","MD":"Moldawien","MC":"Monaco","MN":"Mongolei","ME":"Montenegro","MS":"Montserrat","MZ":"Mosambik","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NC":"Neukaledonien","NZ":"Neuseeland","NI":"Nicaragua","NL":"Niederlande","NE":"Niger","NG":"Nigeria","NU":"Niue","MK":"Nordmazedonien","MP":"N\xf6rdliche Marianen","NF":"Norfolkinsel","NO":"Norwegen","OM":"Oman","AT":"\xd6sterreich","TL":"Osttimor","PK":"Pakistan","PS":"Staat Pal\xe4stina","PW":"Palau","PA":"Panama","PG":"Papua-Neuguinea","PY":"Paraguay","PE":"Peru","PH":"Philippinen","PN":"Pitcairninseln","PL":"Polen","PT":"Portugal","PR":"Puerto Rico","TW":"Taiwan","CG":"Republik Kongo","RE":"R\xe9union","RW":"Ruanda","RO":"Rum\xe4nien","RU":["Russische F\xf6deration","Russland"],"BL":"Saint-Barth\xe9lemy","MF":"Saint-Martin","SB":"Salomonen","ZM":"Sambia","WS":"Samoa","SM":"San Marino","ST":"S\xe3o Tom\xe9 und Pr\xedncipe","SA":"Saudi-Arabien","SE":"Schweden","CH":"Schweiz","SN":"Senegal","RS":"Serbien","SC":"Seychellen","SL":"Sierra Leone","ZW":"Simbabwe","SG":"Singapur","SX":"Sint Maarten","SK":"Slowakei","SI":"Slowenien","SO":"Somalia","ES":"Spanien","LK":"Sri Lanka","SH":"St. Helena","KN":"St. Kitts und Nevis","LC":"St. Lucia","PM":"Saint-Pierre und Miquelon","VC":"St. Vincent und die Grenadinen","ZA":"S\xfcdafrika","SD":"Sudan","GS":"S\xfcdgeorgien und die S\xfcdlichen Sandwichinseln","SS":"S\xfcdsudan","SR":"Suriname","SJ":"Svalbard und Jan Mayen","SZ":"Eswatini","SY":"Syrien, Arabische Republik","TJ":"Tadschikistan","TZ":["Tansania, Vereinigte Republik","Tansania"],"TH":"Thailand","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad und Tobago","TD":"Tschad","CZ":["Tschechische Republik","Tschechien"],"TN":"Tunesien","TR":"T\xfcrkei","TM":"Turkmenistan","TC":"Turks- und Caicosinseln","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","HU":"Ungarn","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Usbekistan","VU":"Vanuatu","VA":"Vatikanstadt","VE":"Venezuela","AE":"Vereinigte Arabische Emirate","US":["Vereinigte Staaten von Amerika","Vereinigte Staaten","USA"],"GB":["Vereinigtes K\xf6nigreich","Gro\xdfbritannien"],"VN":"Vietnam","WF":"Wallis und Futuna","CX":"Weihnachtsinsel","EH":"Westsahara","CF":"Zentralafrikanische Republik","CY":"Zypern","XK":"Kosovo"}}');

});

parcelRegister("4Q3G4", function(module, exports) {
module.exports = JSON.parse('{"locale":"en","countries":{"AF":"Afghanistan","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":["People\'s Republic of China","China"],"CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":["Republic of the Congo","Congo"],"CD":["Democratic Republic of the Congo","Congo"],"CK":"Cook Islands","CR":"Costa Rica","CI":["Cote d\'Ivoire","C\xf4te d\'Ivoire","Ivory Coast"],"HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":["Czech Republic","Czechia"],"DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":["Republic of The Gambia","The Gambia","Gambia"],"GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","VA":"Holy See (Vatican City State)","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":["Islamic Republic of Iran","Iran"],"IQ":"Iraq","IE":"Ireland","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"North Korea","KR":["South Korea","Korea, Republic of","Republic of Korea"],"KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People\'s Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":["Netherlands","The Netherlands","Netherlands (Kingdom of the)"],"NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","MK":["The Republic of North Macedonia","North Macedonia"],"MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":["State of Palestine","Palestine"],"PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":["Pitcairn","Pitcairn Islands"],"PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Reunion","RO":"Romania","RU":["Russian Federation","Russia"],"RW":"Rwanda","SH":"Saint Helena","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"Sao Tome and Principe","SA":"Saudi Arabia","SN":"Senegal","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Eswatini","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":["Taiwan, Province of China","Taiwan"],"TJ":"Tajikistan","TZ":["United Republic of Tanzania","Tanzania"],"TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":["T\xfcrkiye","Turkey"],"TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","AE":["United Arab Emirates","UAE"],"GB":["United Kingdom","UK","Great Britain"],"US":["United States of America","United States","USA","U.S.A.","US","U.S."],"UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe","AX":["\xc5land Islands","Aland Islands"],"BQ":"Bonaire, Sint Eustatius and Saba","CW":"Cura\xe7ao","GG":"Guernsey","IM":"Isle of Man","JE":"Jersey","ME":"Montenegro","BL":"Saint Barth\xe9lemy","MF":"Saint Martin (French part)","RS":"Serbia","SX":"Sint Maarten (Dutch part)","SS":"South Sudan","XK":"Kosovo"}}');

});

parcelRegister("84Ucc", function(module, exports) {
module.exports = JSON.parse('{"locale":"fr","countries":{"AF":"Afghanistan","AL":"Albanie","DZ":"Alg\xe9rie","AS":"Samoa am\xe9ricaines","AD":"Andorre","AO":"Angola","AI":"Anguilla","AQ":"Antarctique","AG":"Antigua-et-Barbuda","AR":"Argentine","AM":"Arm\xe9nie","AW":"Aruba","AU":"Australie","AT":"Autriche","AZ":"Azerba\xefdjan","BS":"Bahamas","BH":"Bahre\xefn","BD":"Bangladesh","BB":"Barbade","BY":"Bi\xe9lorussie","BE":"Belgique","BZ":"Belize","BJ":"B\xe9nin","BM":"Bermudes","BT":"Bhoutan","BO":"Bolivie","BA":"Bosnie-Herz\xe9govine","BW":"Botswana","BV":"\xcele Bouvet","BR":"Br\xe9sil","IO":"Oc\xe9an Indien Britannique","BN":"Brunei Darussalam","BG":"Bulgarie","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodge","CM":"Cameroun","CA":"Canada","CV":"Cap-Vert","KY":"\xceles Ca\xefmans","CF":"R\xe9publique Centrafricaine","TD":"Tchad","CL":"Chili","CN":"Chine","CX":"\xcele Christmas","CC":"\xceles Cocos","CO":"Colombie","KM":"Comores","CG":"R\xe9publique du Congo","CD":"R\xe9publique d\xe9mocratique du Congo","CK":"\xceles Cook","CR":"Costa Rica","CI":"C\xf4te-d\'Ivoire","HR":"Croatie","CU":"Cuba","CY":"Chypre","CZ":"R\xe9publique Tch\xe8que","DK":"Danemark","DJ":"Djibouti","DM":"Dominique","DO":"R\xe9publique Dominicaine","EC":"\xc9quateur","EG":"\xc9gypte","SV":"El Salvador","GQ":"Guin\xe9e \xe9quatoriale","ER":"\xc9rythr\xe9e","EE":"Estonie","ET":"\xc9thiopie","FK":"\xceles Malouines","FO":"\xceles F\xe9ro\xe9","FJ":"Fidji","FI":"Finlande","FR":"France","GF":"Guyane fran\xe7aise","PF":"Polyn\xe9sie fran\xe7aise","TF":"Terres australes fran\xe7aises","GA":"Gabon","GM":"Gambie","GE":"G\xe9orgie","DE":"Allemagne","GH":"Ghana","GI":"Gibraltar","GR":"Gr\xe8ce","GL":"Groenland","GD":"Grenade","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GN":"Guin\xe9e","GW":"Guin\xe9e-Bissau","GY":"Guyana","HT":"Ha\xefti","HM":"\xceles Heard-et-MacDonald","VA":"Saint-Si\xe8ge (Vatican)","HN":"Honduras","HK":"Hong Kong","HU":"Hongrie","IS":"Islande","IN":"Inde","ID":"Indon\xe9sie","IR":"Iran","IQ":"Irak","IE":"Irlande","IL":"Isra\xebl","IT":"Italie","JM":"Jama\xefque","JP":"Japon","JO":"Jordanie","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"Cor\xe9e du Nord","KR":"Cor\xe9e du Sud","KW":"Kowe\xeft","KG":"Kirghizistan","LA":"Laos","LV":"Lettonie","LB":"Liban","LS":"Lesotho","LR":"Lib\xe9ria","LY":"Libye","LI":"Liechtenstein","LT":"Lituanie","LU":"Luxembourg","MO":"Macao","MK":"Mac\xe9doine du Nord","MG":"Madagascar","MW":"Malawi","MY":"Malaisie","MV":"Maldives","ML":"Mali","MT":"Malte","MH":"\xceles Marshall","MQ":"Martinique","MR":"Mauritanie","MU":"Maurice","YT":"Mayotte","MX":"Mexique","FM":"Micron\xe9sie","MD":"Moldavie","MC":"Monaco","MN":"Mongolie","MS":"Montserrat","MA":"Maroc","MZ":"Mozambique","MM":"Myanmar","NA":"Namibie","NR":"Nauru","NP":"N\xe9pal","NL":"Pays-Bas","NC":"Nouvelle-Cal\xe9donie","NZ":"Nouvelle-Z\xe9lande","NI":"Nicaragua","NE":"Niger","NG":"Nig\xe9ria","NU":"Niu\xe9","NF":"\xcele Norfolk","MP":"\xceles Mariannes du Nord","NO":"Norv\xe8ge","OM":"Oman","PK":"Pakistan","PW":"Palaos","PS":"Palestine","PA":"Panama","PG":"Papouasie-Nouvelle-Guin\xe9e","PY":"Paraguay","PE":"P\xe9rou","PH":"Philippines","PN":"\xceles Pitcairn","PL":"Pologne","PT":"Portugal","PR":"Porto Rico","QA":"Qatar","RE":"R\xe9union","RO":"Roumanie","RU":"Russie","RW":"Rwanda","SH":"Sainte-H\xe9l\xe8ne","KN":"Saint-Christophe-et-Ni\xe9v\xe8s","LC":"Sainte-Lucie","PM":"Saint-Pierre-et-Miquelon","VC":"Saint-Vincent-et-les-Grenadines","WS":"Samoa","SM":"Saint-Marin","ST":"S\xe3o Tom\xe9-et-Principe","SA":"Arabie Saoudite","SN":"S\xe9n\xe9gal","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapour","SK":"Slovaquie","SI":"Slov\xe9nie","SB":"\xceles Salomon","SO":"Somalie","ZA":"Afrique du Sud","GS":"G\xe9orgie du Sud-et-les \xceles Sandwich du Sud","ES":"Espagne","LK":"Sri Lanka","SD":"Soudan","SR":"Suriname","SJ":"Svalbard et \xcele Jan Mayen","SZ":"Royaume d\'Eswatini","SE":"Su\xe8de","CH":"Suisse","SY":"Syrie","TW":"Ta\xefwan","TJ":"Tadjikistan","TZ":"R\xe9publique unie de Tanzanie","TH":"Tha\xeflande","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinit\xe9-et-Tobago","TN":"Tunisie","TR":"Turquie","TM":"Turkm\xe9nistan","TC":"\xceles Turques-et-Ca\xefques","TV":"Tuvalu","UG":"Ouganda","UA":"Ukraine","AE":"\xc9mirats Arabes Unis","GB":"Royaume-Uni","US":"\xc9tats-Unis d\'Am\xe9rique","UM":"\xceles mineures \xe9loign\xe9es des \xc9tats-Unis","UY":"Uruguay","UZ":"Ouzb\xe9kistan","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","VG":"\xceles vierges britanniques","VI":"\xceles vierges am\xe9ricaines","WF":"Wallis-et-Futuna","EH":"Sahara occidental","YE":"Y\xe9men","ZM":"Zambie","ZW":"Zimbabwe","AX":"\xc5land","BQ":"Bonaire, Saint-Eustache et Saba","CW":"Cura\xe7ao","GG":"Guernesey","IM":"\xcele de Man","JE":"Jersey","ME":"Mont\xe9n\xe9gro","BL":"Saint-Barth\xe9lemy","MF":"Saint-Martin (partie fran\xe7aise)","RS":"Serbie","SX":"Saint-Martin (partie n\xe9erlandaise)","SS":"Soudan du Sud","XK":"Kosovo"}}');

});

parcelRegister("j9HIt", function(module, exports) {
module.exports = JSON.parse('{"locale":"it","countries":{"AD":"Andorra","AE":"Emirati Arabi Uniti","AF":"Afghanistan","AG":"Antigua e Barbuda","AI":"Anguilla","AL":"Albania","AM":"Armenia","AO":"Angola","AQ":"Antartide","AR":"Argentina","AS":"Samoa Americane","AT":"Austria","AU":"Australia","AW":"Aruba","AX":"Isole \xc5land","AZ":"Azerbaigian","BA":"Bosnia ed Erzegovina","BB":"Barbados","BD":"Bangladesh","BE":"Belgio","BF":"Burkina Faso","BG":"Bulgaria","BH":"Bahrain","BI":"Burundi","BJ":"Benin","BL":"Saint-Barth\xe9lemy","BM":"Bermuda","BN":"Brunei","BO":"Bolivia","BQ":"Isole BES","BR":"Brasile","BS":"Bahamas","BT":"Bhutan","BV":"Isola Bouvet","BW":"Botswana","BY":"Bielorussia","BZ":"Belize","CA":"Canada","CC":"Isole Cocos e Keeling","CD":"Repubblica Democratica del Congo","CF":"Repubblica Centrafricana","CG":"Repubblica del Congo","CH":"Svizzera","CI":"Costa d\'Avorio","CK":"Isole Cook","CL":"Cile","CM":"Camerun","CN":"Cina","CO":"Colombia","CR":"Costa Rica","CU":"Cuba","CV":"Capo Verde","CW":"Cura\xe7ao","CX":"Isola del Natale","CY":"Cipro","CZ":"Repubblica Ceca","DE":"Germania","DJ":"Gibuti","DK":"Danimarca","DM":"Dominica","DO":"Repubblica Dominicana","DZ":"Algeria","EC":"Ecuador","EE":"Estonia","EG":"Egitto","EH":"Sahara Occidentale","ER":"Eritrea","ES":"Spagna","ET":"Etiopia","FI":"Finlandia","FJ":"Figi","FK":"Isole Falkland","FM":"Stati Federati di Micronesia","FO":"Isole F\xe6r \xd8er","FR":"Francia","GA":"Gabon","GB":"Regno Unito","GD":"Grenada","GE":"Georgia","GF":"Guyana Francese","GG":"Guernsey","GH":"Ghana","GI":"Gibilterra","GL":"Groenlandia","GM":"Gambia","GN":"Guinea","GP":"Guadalupa","GQ":"Guinea Equatoriale","GR":"Grecia","GS":"Georgia del Sud e isole Sandwich meridionali","GT":"Guatemala","GU":"Guam","GW":"Guinea-Bissau","GY":"Guyana","HK":"Hong Kong","HM":"Isole Heard e McDonald","HN":"Honduras","HR":"Croazia","HT":"Haiti","HU":"Ungheria","ID":"Indonesia","IE":"Irlanda","IL":"Israele","IM":"Isola di Man","IN":"India","IO":"Territori Britannici dell\'Oceano Indiano","IQ":"Iraq","IR":"Iran","IS":"Islanda","IT":"Italia","JE":"Jersey","JM":"Giamaica","JO":"Giordania","JP":"Giappone","KE":"Kenya","KG":"Kirghizistan","KH":"Cambogia","KI":"Kiribati","KM":"Comore","KN":"Saint Kitts e Nevis","KP":"Corea del Nord","KR":"Corea del Sud","KW":"Kuwait","KY":"Isole Cayman","KZ":"Kazakistan","LA":"Laos","LB":"Libano","LC":"Santa Lucia","LI":"Liechtenstein","LK":"Sri Lanka","LR":"Liberia","LS":"Lesotho","LT":"Lituania","LU":"Lussemburgo","LV":"Lettonia","LY":"Libia","MA":"Marocco","MC":"Monaco","MD":"Moldavia","ME":"Montenegro","MF":"Saint-Martin","MG":"Madagascar","MH":"Isole Marshall","MK":"Macedonia del Nord","ML":"Mali","MM":"Birmania  Myanmar","MN":"Mongolia","MO":"Macao","MP":"Isole Marianne Settentrionali","MQ":"Martinica","MR":"Mauritania","MS":"Montserrat","MT":"Malta","MU":"Mauritius","MV":"Maldive","MW":"Malawi","MX":"Messico","MY":"Malesia","MZ":"Mozambico","NA":"Namibia","NC":"Nuova Caledonia","NE":"Niger","NF":"Isola Norfolk","NG":"Nigeria","NI":"Nicaragua","NL":"Paesi Bassi","NO":"Norvegia","NP":"Nepal","NR":"Nauru","NU":"Niue","NZ":"Nuova Zelanda","OM":"Oman","PA":"Panam\xe1","PE":"Per\xf9","PF":"Polinesia Francese","PG":"Papua Nuova Guinea","PH":"Filippine","PK":"Pakistan","PL":"Polonia","PM":"Saint Pierre e Miquelon","PN":"Isole Pitcairn","PR":"Porto Rico","PS":"Stato di Palestina","PT":"Portogallo","PW":"Palau","PY":"Paraguay","QA":"Qatar","RE":"R\xe9union","RO":"Romania","RS":"Serbia","RU":"Russia","RW":"Ruanda","SA":"Arabia Saudita","SB":"Isole Salomone","SC":"Seychelles","SD":"Sudan","SE":"Svezia","SG":"Singapore","SH":"Sant\'Elena, Isola di Ascensione e Tristan da Cunha","SI":"Slovenia","SJ":"Svalbard e Jan Mayen","SK":"Slovacchia","SL":"Sierra Leone","SM":"San Marino","SN":"Senegal","SO":"Somalia","SR":"Suriname","SS":"Sudan del Sud","ST":"S\xe3o Tom\xe9 e Pr\xedncipe","SV":"El Salvador","SX":"Sint Maarten","SY":"Siria","SZ":"Eswatini","TC":"Isole Turks e Caicos","TD":"Ciad","TF":"Territori Francesi del Sud","TG":"Togo","TH":"Thailandia","TJ":"Tagikistan","TK":"Tokelau","TL":"Timor Est","TM":"Turkmenistan","TN":"Tunisia","TO":"Tonga","TR":"Turchia","TT":"Trinidad e Tobago","TV":"Tuvalu","TW":["Repubblica di Cina","Taiwan"],"TZ":"Tanzania","UA":"Ucraina","UG":"Uganda","UM":"Isole minori esterne degli Stati Uniti","US":"Stati Uniti d\'America","UY":"Uruguay","UZ":"Uzbekistan","VA":"Citt\xe0 del Vaticano","VC":"Saint Vincent e Grenadine","VE":"Venezuela","VG":"Isole Vergini Britanniche","VI":"Isole Vergini Americane","VN":"Vietnam","VU":"Vanuatu","WF":"Wallis e Futuna","WS":"Samoa","YE":"Yemen","YT":"Mayotte","ZA":"Sudafrica","ZM":"Zambia","ZW":"Zimbabwe","XK":"Kosovo"}}');

});

parcelRegister("6xmu9", function(module, exports) {
module.exports = JSON.parse('{"locale":"nl","countries":{"AF":["Islamitisch Emiraat Afghanistan","Afghanistan"],"AL":["Republiek Albani\xeb","Albani\xeb"],"DZ":["Democratische Volksrepubliek Algerije","Algerije"],"AS":"Amerikaans-Samoa","AD":["Vorstendom Andorra","Andorra"],"AO":["Republiek Angola","Angola"],"AI":"Anguilla","AQ":"Antarctica","AG":"Antigua en Barbuda","AR":["Argentijnse Republiek","Argentini\xeb"],"AM":["Republiek Armeni\xeb","Armeni\xeb"],"AW":"Aruba","AU":["Gemenebest van Australi\xeb","Australi\xeb"],"AT":["Republiek Oostenrijk","Oostenrijk"],"AZ":["Republiek Azerbeidzjan","Azerbeidzjan"],"BS":["Gemenebest van de Bahama\'s","Bahama\'s"],"BH":["Koninkrijk Bahrein","Bahrein"],"BD":["Volksrepubliek Bangladesh","Bangladesh"],"BB":["Barbados","Barbados"],"BY":["Republiek Wit-Rusland","Wit-Rusland"],"BE":["Koninkrijk Belgi\xeb","Belgi\xeb"],"BZ":["Belize","Belize"],"BJ":["Republiek Benin","Benin"],"BM":"Bermuda","BT":["Koninkrijk Bhutan","Bhutan"],"BO":["Plurinationale Staat Bolivia","Bolivi\xeb"],"BA":["Bosni\xeb en Herzegovina","Bosni\xeb-Herzegovina"],"BW":["Republiek Botswana","Botswana"],"BV":"Bouvet Eiland","BR":["Federale Republiek Brazili\xeb","Brazili\xeb"],"IO":"Brits Indische oceaan","BN":["Brunei Darussalam","Brunei"],"BG":["Republiek Bulgarije","Bulgarije"],"BF":["Burkina Faso","Burkina Faso"],"BI":["Republiek Burundi","Burundi"],"KH":["Koninkrijk Cambodja","Cambodja"],"CM":["Republiek Kameroen","Kameroen"],"CA":"Canada","CV":["Republiek Kaapverdi\xeb","Kaapverdi\xeb"],"KY":"Kaaimaneilanden","CF":"Centraal-Afrikaanse Republiek","TD":["Republiek Tsjaad","Tsjaad"],"CL":["Republiek Chili","Chili"],"CN":["Volksrepubliek China","China"],"CX":["Christmaseiland","Kersteiland"],"CC":"Cocoseilanden","CO":["Republiek Colombia","Colombia"],"KM":["Unie der Comoren","Comoren"],"CG":["Republiek Congo","Congo-Brazzaville"],"CD":["Democratische Republiek Congo","Congo-Kinshasa"],"CK":"Cookeilanden","CR":["Republiek Costa Rica","Costa Rica"],"CI":["Republiek Ivoorkust","Ivoorkust"],"HR":["Republiek Kroati\xeb","Kroati\xeb"],"CU":["Republiek Cuba","Cuba"],"CY":["Republiek Cyprus","Cyprus"],"CZ":["Tsjechische Republiek","Tsjechi\xeb"],"DK":["Koninkrijk Denemarken","Denemarken"],"DJ":["Republiek Djibouti","Djibouti"],"DM":["Gemenebest Dominica","Dominica"],"DO":"Dominicaanse Republiek","EC":["Republiek Ecuador","Ecuador"],"EG":["Arabische Republiek Egypte","Egypte"],"SV":["Republiek El Salvador","El Salvador"],"GQ":["Republiek Equatoriaal-Guinea","Equatoriaal-Guinea"],"ER":["Staat Eritrea","Eritrea"],"EE":["Republiek Estland","Estland"],"ET":["Federale Democratische Republiek Ethiopi\xeb","Ethiopi\xeb"],"FK":"Falklandeilanden","FO":"Faer\xf6er","FJ":["Republiek Fiji","Fiji"],"FI":["Republiek Finland","Finland"],"FR":["Franse Republiek","Frankrijk"],"GF":"Frans-Guyana","PF":"Frans-Polynesi\xeb","TF":"Franse Zuidelijke Gebieden","GA":["Republiek Gabon","Gabon"],"GM":["Republiek Gambia","Gambia"],"GE":["Georgi\xeb","Georgi\xeb"],"DE":["Bondsrepubliek Duitsland","Duitsland"],"GH":["Republiek Ghana","Ghana"],"GI":"Gibraltar","GR":["Helleense Republiek","Griekenland"],"GL":"Groenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":["Republiek Guatemala","Guatemala"],"GN":["Republiek Guinee","Guinea"],"GW":["Republiek Guinee-Bissau","Guinee-Bissau"],"GY":["Co\xf6peratieve Republiek Guyana","Guyana"],"HT":["Republiek Ha\xefti","Ha\xefti"],"HM":"Heard en McDonaldeilanden","VA":["Vaticaanstad","Vaticaanstad"],"HN":["Republiek Honduras","Honduras"],"HK":"Hong Kong","HU":["Hongaarse Republiek","Hongarije"],"IS":["IJslandse Republiek","IJsland"],"IN":["Republiek India","India"],"ID":["Republiek Indonesi\xeb","Indonesi\xeb"],"IR":["Islamitische Republiek Iran","Iran"],"IQ":["Republiek Irak","Irak"],"IE":["Ierse Republiek","Ierland"],"IL":["Staat Isra\xebl","Isra\xebl"],"IT":["Italiaanse Republiek","Itali\xeb"],"JM":"Jamaica","JP":"Japan","JO":["Hasjemitisch Koninkrijk Jordani\xeb","Jordani\xeb"],"KZ":["Republiek Kazachstan","Kazachstan"],"KE":["Republiek Kenia","Kenia"],"KI":["Republiek Kiribati","Kiribati"],"KP":["Democratische Volksrepubliek Korea","Noord-Korea"],"KR":["Republiek Korea","Zuid-Korea"],"KW":["Staat Koeweit","Koeweit"],"KG":["Kirgizische Republiek","Kirgizi\xeb"],"LA":["Lao Democratische Volksrepubliek","Laos"],"LV":["Republiek Letland","Letland"],"LB":["Libanese Republiek","Libanon"],"LS":["Koninkrijk Lesotho","Lesotho"],"LR":["Republiek Liberia","Liberia"],"LY":["Staat Libi\xeb","Libi\xeb"],"LI":["Vorstendom Liechtenstein","Liechtenstein"],"LT":["Republiek Litouwen","Litouwen"],"LU":["Groothertogdom Luxemburg","Luxemburg"],"MO":"Macao","MG":["Republiek Madagaskar","Madagaskar"],"MW":["Republiek Malawi","Malawi"],"MY":["Maleisi\xeb","Maleisi\xeb"],"MV":["Republiek der Maldiven","Maldiven"],"ML":["Republiek Mali","Mali"],"MT":["Republiek Malta","Malta"],"MH":["Republiek der Marshalleilanden","Marshalleilanden"],"MQ":"Martinique","MR":["Islamitische Republiek Mauritani\xeb","Mauritani\xeb"],"MU":["Republiek Mauritius","Mauritius"],"YT":"Mayotte","MX":["Verenigde Mexicaanse Staten","Mexico"],"FM":["Federale Staten van Micronesi\xeb","Micronesi\xeb"],"MD":["Republiek Moldavi\xeb","Moldavi\xeb"],"MC":["Vorstendom Monaco","Monaco"],"MN":["Mongoli\xeb","Mongoli\xeb"],"MS":"Montserrat","MA":["Koninkrijk Marokko","Marokko"],"MZ":["Republiek Mozambique","Mozambique"],"MM":["Republiek van de Unie van Myanmar","Myanmar"],"NA":["Republiek Namibi\xeb","Namibi\xeb"],"NR":["Republiek Nauru","Nauru"],"NP":["Federale Democratische Republiek Nepal","Nepal"],"NL":["Koninkrijk der Nederlanden","Nederland"],"NC":["Nieuw-Caledoni\xeb","Nieuw-Caledoni\xeb"],"NZ":["Nieuw-Zeeland","Nieuw-Zeeland"],"NI":["Republiek Nicaragua","Nicaragua"],"NE":["Republiek Niger","Niger"],"NG":["Federale Republiek Nigeria","Nigeria"],"NU":"Niue","NF":"Norfolk","MP":"Noordelijke Marianen","MK":["Republiek Noord-Macedoni\xeb","Noord-Macedoni\xeb"],"NO":["Koninkrijk Noorwegen","Noorwegen"],"OM":["Sultanaat Oman","Oman"],"PK":["Islamitische Republiek Pakistan","Pakistan"],"PW":["Republiek Palau","Palau"],"PS":["Staat Palestina","Palestina"],"PA":["Republiek Panama","Panama"],"PG":["Onafhankelijke Staat Papoea-Nieuw-Guinea","Papoea-Nieuw-Guinea"],"PY":["Republiek Paraguay","Paraguay"],"PE":["Republiek Peru","Peru"],"PH":["Republiek der Filipijnen","Filipijnen"],"PN":"Pitcairn","PL":["Republiek Polen","Polen"],"PT":["Portugese Republiek","Portugal"],"PR":"Puerto Rico","QA":["Staat Qatar","Qatar"],"RE":"R\xe9union","RO":["Roemeense Republiek","Roemeni\xeb"],"RU":["Russische Federatie","Rusland"],"RW":["Republiek Rwanda","Rwanda"],"SH":"Sint-Helena","KN":["Federatie Saint Kitts en Nevis","Saint Kitts en Nevis"],"LC":["Saint Lucia","Saint Lucia"],"PM":["Saint-Pierre en Miquelon","Saint-Pierre en Miquelon"],"VC":["Saint Vincent en de Grenadines","Saint Vincent en de Grenadines"],"WS":["Onafhankelijke Staat Samoa","Samoa"],"SM":["Republiek San Marino","San Marino"],"ST":["Democratische Republiek S\xe3o Tom\xe9 en Principe","S\xe3o Tom\xe9 en Principe"],"SA":["Koninkrijk Saudi-Arabi\xeb","Saudi-Arabi\xeb"],"SN":["Republiek Senegal","Senegal"],"SC":["Republiek der Seychellen","Seychellen"],"SL":["Republiek Sierra Leone","Sierra Leone"],"SG":["Republiek Singapore","Singapore"],"SK":["Slowaakse Republiek","Slowakije"],"SI":["Republiek Sloveni\xeb","Sloveni\xeb"],"SB":["Salomonseilanden","Salomonseilanden"],"SO":["Federale Republiek Somali\xeb","Somali\xeb"],"ZA":["Republiek Zuid-Afrika","Zuid-Afrika"],"GS":"Zuid-Georgia en de Zuidelijke Sandwicheilanden","ES":["Koninkrijk Spanje","Spanje"],"LK":["Democratische Socialistische Republiek Sri Lanka","Sri Lanka"],"SD":["Republiek Soedan","Soedan"],"SR":["Republiek Suriname","Suriname"],"SJ":"Spitsbergen en Jan Mayen","SZ":["Koninkrijk Eswatini","Eswatini","Swaziland"],"SE":["Koninkrijk Zweden","Zweden"],"CH":["Zwitserse Bondsstaat","Zwitserland"],"SY":["Syrische Arabische Republiek","Syri\xeb"],"TW":["Taiwan","Taiwan"],"TJ":["Republiek Tadzjikistan","Tadzjikistan"],"TZ":["Verenigde Republiek Tanzania","Tanzania"],"TH":["Koninkrijk Thailand","Thailand"],"TL":["Democratische Republiek Timor-Leste","Timor Leste"],"TG":["Togolese Republiek","Togo"],"TK":"Tokelau","TO":["Koninkrijk Tonga","Tonga"],"TT":["Republiek Trinidad en Tobago","Trinidad en Tobago"],"TN":["Republiek Tunesi\xeb","Tunesi\xeb"],"TR":["Republiek Turkije","Turkije"],"TM":["Turkmeense Republiek","Turkmenistan"],"TC":"Turks- en Caicoseilanden","TV":["Tuvalu","Tuvalu"],"UG":["Republiek Oeganda","Oeganda"],"UA":["Oekra\xefne","Oekra\xefne"],"AE":["Verenigde Arabische Emiraten","Verenigde Arabische Emiraten"],"GB":["Verenigd Koninkrijk van Groot-Brittanni\xeb en Noord-Ierland","Verenigd Koninkrijk"],"US":["Verenigde Staten van Amerika","Verenigde Staten"],"UM":"Amerikaanse Kleinere Afgelegen Eilanden","UY":["Oostelijke Republiek Uruguay","Uruguay"],"UZ":["Republiek Oezbekistan","Oezbekistan"],"VU":["Republiek Vanuatu","Vanuatu"],"VE":["Bolivariaanse Republiek Venezuela","Venezuela"],"VN":["Socialistische Republiek Vietnam","Vietnam"],"VG":"Britse Maagdeneilanden","VI":"Amerikaanse Maagdeneilanden","WF":"Wallis en Futuna","EH":"Westelijke Sahara","YE":["Republiek Jemen","Jemen"],"ZM":["Republiek Zambia","Zambia"],"ZW":["Republiek Zimbabwe","Zimbabwe"],"AX":"\xc5land","BQ":"Bonaire, Sint Eustatius en Saba","CW":"Cura\xe7ao","GG":"Guernsey","IM":"Man Eiland","JE":"Jersey","ME":["Montenegro","Montenegro"],"BL":"Saint Barth\xe9lemy","MF":["Sint-Maarten (Frans deel)","Sint-Maarten (Franse Antillen)","Collectiviteit van Sint-Maarten"],"RS":["Republiek Servi\xeb","Servi\xeb"],"SX":["Sint Maarten","Sint-Maarten","Sint Maarten (Nederlands deel)","Land Sint Maarten"],"SS":["Republiek Zuid-Soedan","Zuid-Soedan"],"XK":["Republiek Kosovo","Kosovo"]}}');

});






parcelRegister("lKlJT", function(module, exports) {

$parcel$export(module.exports, "Page", () => $8825bf0e701e85fb$export$6955bcca4cd3539f);

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");
const $8825bf0e701e85fb$export$6955bcca4cd3539f = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "flexstart", "stretch")}
	flex-grow: 1;
	margin: 0 auto;
	max-width: calc(100vw - 40px);
	padding-bottom: ${(0, $5WGN2.sizes).M};
`;

});

parcelRegister("6Px22", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $568884a28dca6352$export$3b4e64e77073e307);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
const $568884a28dca6352$export$3b4e64e77073e307 = ({ text: text, icon: Icon, uiStyle: uiStyle = "warn", className: className, onDelete: onDelete, rightComponent: rightComponent })=>/*#__PURE__*/ (0, $iKObn.jsxs)($568884a28dca6352$var$BannerContainer, {
        uiStyle: uiStyle,
        className: className,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($568884a28dca6352$var$MessageContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)(Icon, {
                        width: 20,
                        height: 20
                    }),
                    text,
                    rightComponent
                ]
            }),
            onDelete && /*#__PURE__*/ (0, $iKObn.jsx)($568884a28dca6352$var$DeleteIcon, {
                className: "pi pi-times",
                uiStyle: uiStyle,
                onClick: onDelete
            })
        ]
    });
const $568884a28dca6352$var$MessageContainer = (0, $5UMQ1.default).div`
	display: flex;
	gap: 10px;
`;
const $568884a28dca6352$var$BannerContainer = (0, $5UMQ1.default).div`
	display: grid;
	grid-template-columns: 1fr auto;
	place-items: center;
	gap: 10px;
	color: ${({ uiStyle: uiStyle })=>uiStyle === "warn" ? (0, $kKnoQ.colors).warnDark : (0, $kKnoQ.colors).validationDark};
	background-color: ${({ uiStyle: uiStyle })=>uiStyle === "warn" ? (0, $kKnoQ.colors).warn : (0, $kKnoQ.colors).validation10};
	padding: 10px 24px;
`;
const $568884a28dca6352$var$DeleteIcon = (0, $5UMQ1.default).i`
	cursor: pointer;
`;

});

parcelRegister("eWFm9", function(module, exports) {

$parcel$export(module.exports, "ProgressCircle", () => $e1488af54405f0b7$export$c79b9d6b4cc92af7);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");

var $4QSST = parcelRequire("4QSST");

var $81g6h = parcelRequire("81g6h");
const $e1488af54405f0b7$export$c79b9d6b4cc92af7 = ({ progress: progress, size: size, strokeWidth: strokeWidth, strokeBackgroundColor: strokeBackgroundColor = (0, $kKnoQ.colors).grey10, strokeProgressColor: strokeProgressColor = (0, $kKnoQ.colors).primary, counterClockWise: counterClockWise = false, showRemaining: showRemaining = false, animated: animated = false, children: children })=>{
    const { radius: radius, circumference: circumference, percentage: percentage } = (0, $81g6h.useMemo)(()=>{
        const r = (size - strokeWidth) / 2;
        const c = (0, $4QSST.getCircumference)(r);
        const p = (0, $4QSST.getAdjustedCircumferencePercentage)(c, progress, showRemaining);
        return {
            radius: r,
            circumference: c,
            percentage: p
        };
    }, [
        size,
        strokeWidth,
        progress,
        showRemaining
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($e1488af54405f0b7$var$Container, {
        size: size,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($e1488af54405f0b7$var$CircleContainer, {
                width: size,
                height: size,
                viewBox: `0 0 ${size} ${size}`,
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("circle", {
                        r: radius,
                        cx: size / 2,
                        cy: size / 2,
                        stroke: strokeBackgroundColor,
                        strokeWidth: strokeWidth,
                        strokeDasharray: circumference,
                        strokeDashoffset: 0,
                        fill: "transparent"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($e1488af54405f0b7$var$InnerCircle, {
                        r: radius,
                        cx: size / 2,
                        cy: size / 2,
                        stroke: strokeProgressColor,
                        strokeWidth: strokeWidth,
                        circumference: circumference,
                        percentage: percentage,
                        counterClockWise: counterClockWise,
                        animated: animated,
                        fill: "transparent"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($e1488af54405f0b7$var$ChildContainer, {
                children: children
            })
        ]
    });
};
const $e1488af54405f0b7$var$Container = (0, $5UMQ1.default).div`
	position: relative;
	height: ${({ size: size })=>size}px;
	width: ${({ size: size })=>size}px;
`;
const $e1488af54405f0b7$var$CircleContainer = (0, $5UMQ1.default).svg`
	transform: rotate(-90deg);
`;
const $e1488af54405f0b7$var$InnerCircle = (0, $5UMQ1.default).circle`
	stroke-linecap: round;
	stroke-dasharray: ${({ circumference: circumference })=>circumference}px;
	stroke-dashoffset: ${({ percentage: percentage })=>percentage}px;
	transform: ${({ counterClockWise: counterClockWise })=>counterClockWise ? "translate(0, 100%) scaleY(-1)" : ""};
	animation: ${({ animated: animated })=>animated ? "progress 1s ease-in-out" : "none"};

	@keyframes progress {
		from {
			stroke-dashoffset: 0;
		}
		to {
			stroke-dashoffset: ${({ percentage: percentage })=>percentage}px;
		}
	}
`;
const $e1488af54405f0b7$var$ChildContainer = (0, $5UMQ1.default).div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;

});
parcelRegister("4QSST", function(module, exports) {

$parcel$export(module.exports, "getCircumference", () => $e339fa25d929dc91$export$2130eb43cb01b531);
$parcel$export(module.exports, "getAdjustedCircumferencePercentage", () => $e339fa25d929dc91$export$204db76e4f1145ab);
function $e339fa25d929dc91$export$2130eb43cb01b531(radius) {
    return 2 * Math.PI * radius;
}
function $e339fa25d929dc91$export$204db76e4f1145ab(circumference, progress, showRemaining) {
    return showRemaining ? circumference * progress / 100 : circumference * (100 - progress) / 100;
}

});


parcelRegister("8CNE2", function(module, exports) {

$parcel$export(module.exports, "PageHeader", () => $73a22548e9d60c6e$export$53f1cd6809577fc5);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $5UMQ1 = parcelRequire("5UMQ1");

var $c22GE = parcelRequire("c22GE");

var $hIci4 = parcelRequire("hIci4");

var $amllh = parcelRequire("amllh");

var $02Kb9 = parcelRequire("02Kb9");

var $5kXMA = parcelRequire("5kXMA");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");
var $73a22548e9d60c6e$var$BackIcon = function BackIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M10 5.342c-.256 0-.512.1-.707.295l-5.656 5.656a.999.999 0 0 0 0 1.414l5.656 5.656a.999.999 0 0 0 1.414 0l.086-.086a.999.999 0 0 0 0-1.414L6.93 13H20a1 1 0 0 0 0-2H6.93l3.863-3.863a.999.999 0 0 0 0-1.414l-.086-.086A.998.998 0 0 0 10 5.342Z",
            fill: "currentColor"
        })
    });
};
$73a22548e9d60c6e$var$BackIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $73a22548e9d60c6e$var$InfoIcon = function InfoIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Zm0-20c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12.01 17.17c-.55 0-1-.45-1-1v-5.44c0-.55.45-1 1-1s1 .45 1 1v5.44c0 .55-.45 1-1 1ZM12 8.11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                fill: "currentColor"
            })
        ]
    });
};
$73a22548e9d60c6e$var$InfoIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $73a22548e9d60c6e$export$53f1cd6809577fc5 = ({ title: title, tooltip: tooltip, canGoBack: canGoBack, displaySearch: displaySearch, primaryButton: primaryButton, tertiaryButton: tertiaryButton, menuItems: menuItems, className: className, style: style })=>{
    const [search, setSearch] = (0, $81g6h.useState)("");
    const goBack = (0, $htiSH.useGoBack)();
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isMobile: isMobile } = (0, $5kXMA.useDimensions)();
    const displayRightPanel = (0, $81g6h.useMemo)(()=>displaySearch || (0, $lTdpc.isNotNil)(primaryButton) || (0, $lTdpc.isNotNil)(tertiaryButton), [
        displaySearch,
        primaryButton,
        tertiaryButton
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($73a22548e9d60c6e$var$Header, {
        className: className,
        style: style,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($73a22548e9d60c6e$var$Row, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
                        children: [
                            canGoBack && /*#__PURE__*/ (0, $iKObn.jsxs)($73a22548e9d60c6e$var$BackContainer, {
                                onClick: goBack,
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($73a22548e9d60c6e$var$BackIcon, {
                                        color: (0, $kKnoQ.colors).primary
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($73a22548e9d60c6e$var$BackTitle, {
                                        className: "p-size-s-bold",
                                        children: format("global.dialog.back")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)($73a22548e9d60c6e$var$Row, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                                        className: isMobile ? "p-header-3" : "p-header-2",
                                        children: title
                                    }),
                                    (0, $lTdpc.isNotNil)(tooltip) && /*#__PURE__*/ (0, $iKObn.jsx)((0, $02Kb9.Tooltip), {
                                        content: tooltip,
                                        children: /*#__PURE__*/ (0, $iKObn.jsx)($73a22548e9d60c6e$var$IconContainer, {
                                            children: /*#__PURE__*/ (0, $iKObn.jsx)($73a22548e9d60c6e$var$StyledInfoIcon, {
                                                width: 20,
                                                height: 20,
                                                color: (0, $kKnoQ.colors).grey80
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $lTdpc.isNotNil)(menuItems) && /*#__PURE__*/ (0, $iKObn.jsx)($73a22548e9d60c6e$var$ActionButton, {
                        iconPosition: (0, $amllh.IconPosition).Left,
                        itemIconColor: (0, $kKnoQ.colors).primary,
                        menuItems: menuItems
                    })
                ]
            }),
            displayRightPanel && /*#__PURE__*/ (0, $iKObn.jsxs)($73a22548e9d60c6e$var$RightPanel, {
                children: [
                    displaySearch && /*#__PURE__*/ (0, $iKObn.jsxs)("span", {
                        className: "p-input-icon-left p-input-icon-right",
                        style: {
                            flex: 1,
                            backgroundColor: (0, $kKnoQ.colors).primaryBackground
                        },
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("i", {
                                className: "pi pi-search"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                style: {
                                    width: "100%"
                                },
                                placeholder: format("global.search.placeholder"),
                                value: search,
                                onChange: (e)=>setSearch(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($73a22548e9d60c6e$var$ClearSearchButton, {
                                className: "pi pi-times",
                                displayed: !!search,
                                onClick: ()=>setSearch("")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($73a22548e9d60c6e$var$ButtonsContainer, {
                        children: [
                            (0, $lTdpc.isNotNil)(tertiaryButton) && /*#__PURE__*/ (0, $iKObn.jsx)((0, $c22GE.TertiaryButton), {
                                label: tertiaryButton.label,
                                onClick: tertiaryButton.onClick,
                                icon: tertiaryButton.icon
                            }),
                            (0, $lTdpc.isNotNil)(primaryButton) && primaryButton
                        ]
                    })
                ]
            })
        ]
    });
};
const $73a22548e9d60c6e$var$Header = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(24, "spacebetween", "center")};
	padding: 40px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		${(0, $5WGN2.stack)(24)}
		padding: 24px;
	}
`;
const $73a22548e9d60c6e$var$Row = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")};
	align-self: stretch;
`;
const $73a22548e9d60c6e$var$BackContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8, undefined, "center")};
	cursor: pointer;
	margin-bottom: 4px;
`;
const $73a22548e9d60c6e$var$BackTitle = (0, $5UMQ1.default).p`
	color: ${(0, $kKnoQ.colors).primary};
`;
const $73a22548e9d60c6e$var$ClearSearchButton = (0, $5UMQ1.default).i`
	cursor: pointer;
	display: ${({ displayed: displayed })=>displayed ? undefined : "none"};

	:hover {
		color: ${(0, $kKnoQ.colors).primary} !important;
	}
`;
const $73a22548e9d60c6e$var$RightPanel = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(24, "center", "center")};

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		${(0, $5WGN2.stack)(24)}
	}
`;
const $73a22548e9d60c6e$var$ActionButton = (0, $5UMQ1.default)((0, $amllh.MenuButton))`
	.menu-button {
		background-color: ${(0, $kKnoQ.colors).transparent};

		:hover {
			background-color: ${(0, $kKnoQ.colors).primary10};
		}
	}
`;
const $73a22548e9d60c6e$var$StyledInfoIcon = (0, $5UMQ1.default)($73a22548e9d60c6e$var$InfoIcon)`
	align-self: center;
	justify-self: center;
`;
const $73a22548e9d60c6e$var$IconContainer = (0, $5UMQ1.default).div`
	display: flex;
	align-items: center;
	margin-left: 8px;
`;
const $73a22548e9d60c6e$var$ButtonsContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(24, undefined, "center")};
	justify-content: center;
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		flex-direction: row-reverse;
		display: flex;
		gap: 16px;
	}
`;

});

parcelRegister("bhNoX", function(module, exports) {

$parcel$export(module.exports, "useSupportedLocales", () => $acac5d04c756bcce$export$1a28c4dff96f1e06);

var $81g6h = parcelRequire("81g6h");

var $1IWnK = parcelRequire("1IWnK");

var $grmoS = parcelRequire("grmoS");
const $acac5d04c756bcce$export$1a28c4dff96f1e06 = ({ localeManager: localeManager })=>{
    const supportedLocales = (0, $1IWnK.useObservable)(localeManager.supportedLocales);
    const [fetchSupportedLocales] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(()=>localeManager.fetchSupportedLocales(), [
        localeManager
    ]), {});
    (0, $81g6h.useEffect)(()=>{
        if (supportedLocales.size === 0) fetchSupportedLocales();
    }, [
        fetchSupportedLocales,
        supportedLocales
    ]);
    return {
        supportedLocales: supportedLocales,
        fetchSupportedLocales: fetchSupportedLocales
    };
};

});

parcelRegister("6nO8b", function(module, exports) {

$parcel$export(module.exports, "LoginContainer", () => $af0a9dabc6139ca1$export$dad1da3cda010137);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5kXMA = parcelRequire("5kXMA");

var $2i7xU = parcelRequire("2i7xU");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $hAuJ9 = parcelRequire("hAuJ9");

var $81g6h = parcelRequire("81g6h");

var $22plg = parcelRequire("22plg");
var $af0a9dabc6139ca1$var$CircleBg = function CircleBg(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_1_401",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "1460",
                height: "1460",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    fill: "#50F",
                    d: "M0 0h1460v1460H0z"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_1_401)",
                fill: "#fff",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                        opacity: ".2",
                        cx: "679.388",
                        cy: "678.678",
                        rx: "679.388",
                        ry: "678.678",
                        transform: "matrix(-.99702 -.07711 -.07728 .99701 1459.81 105.74)"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                        opacity: ".15",
                        cx: "499.497",
                        cy: "498.975",
                        rx: "499.497",
                        ry: "498.975",
                        transform: "matrix(-.99702 -.07711 -.07728 .99701 1266.17 271.359)"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                        opacity: ".12",
                        cx: "296.835",
                        cy: "296.524",
                        rx: "296.835",
                        ry: "296.524",
                        transform: "matrix(-.99702 -.07711 -.07728 .99701 1048.73 457.922)"
                    })
                ]
            })
        ]
    });
};
$af0a9dabc6139ca1$var$CircleBg.defaultProps = {
    width: "1460",
    height: "1460",
    viewBox: "0 0 1460 1460",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $af0a9dabc6139ca1$var$RESPONSIVE_PADDING = {
    [(0, $5kXMA.ResponsiveDeviceType).Desktop]: 20,
    [(0, $5kXMA.ResponsiveDeviceType).Tablet]: 32,
    [(0, $5kXMA.ResponsiveDeviceType).Mobile]: 16
};
const $af0a9dabc6139ca1$export$dad1da3cda010137 = ({ form: form, showPhysioMeMonochromeLogo: showPhysioMeMonochromeLogo })=>{
    const { height: height, ref: ref } = (0, $22plg.useResizeDetector)();
    const { responsiveDeviceType: responsiveDeviceType } = (0, $5kXMA.useDimensions)();
    const backgroundOffset = (0, $81g6h.useMemo)(()=>{
        if ((0, $lTdpc.isNil)(height)) return 0;
        return height + $af0a9dabc6139ca1$var$RESPONSIVE_PADDING[responsiveDeviceType] * 2;
    }, [
        height,
        responsiveDeviceType
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($af0a9dabc6139ca1$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($af0a9dabc6139ca1$var$BackgroundCircles, {
                insetTop: backgroundOffset
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($af0a9dabc6139ca1$var$FormContainer, {
                ref: ref,
                children: /*#__PURE__*/ (0, $iKObn.jsx)($af0a9dabc6139ca1$var$FormCard, {
                    children: form
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $2i7xU.default), {
                showPhysioMeMonochromeLogo: showPhysioMeMonochromeLogo
            })
        ]
    });
};
const $af0a9dabc6139ca1$var$Container = (0, $5UMQ1.default).div`
	background-color: ${(0, $kKnoQ.colors).mobilePrimaryBlue};
	min-height: 100vh;
	max-width: 100vw;
	flex: 1;
	display: flex;
	flex-direction: row;
	padding: ${$af0a9dabc6139ca1$var$RESPONSIVE_PADDING[(0, $5kXMA.ResponsiveDeviceType).Desktop]}px;
	gap: 56px;
	overflow: hidden;
	position: relative;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		flex-direction: column;
		padding: 0 0 100px 0;
		gap: 0;
	}
`;
const $af0a9dabc6139ca1$var$FormContainer = (0, $5UMQ1.default).div`
	z-index: 1;
	display: flex;
	flex: 1;
	justify-content: center;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: ${$af0a9dabc6139ca1$var$RESPONSIVE_PADDING[(0, $5kXMA.ResponsiveDeviceType).Tablet]}px 118px;
		background-color: ${(0, $kKnoQ.colors).white};
	}
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding: ${$af0a9dabc6139ca1$var$RESPONSIVE_PADDING[(0, $5kXMA.ResponsiveDeviceType).Mobile]}px;
	}
`;
const $af0a9dabc6139ca1$var$FormCard = (0, $5UMQ1.default).div`
	flex: 1;
	display: flex;
	border-radius: 40px;
	background-color: ${(0, $kKnoQ.colors).white};
	padding: 80px 118px;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 0 32px;
		min-width: 500px;
		max-width: 712px;
	}
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding: 0 16px;
		min-width: unset;
	}
`;
const $af0a9dabc6139ca1$var$BackgroundCircles = (0, $5UMQ1.default).div`
	background-image: ${(0, $hAuJ9.svgComponentToCSS)(/*#__PURE__*/ (0, $iKObn.jsx)($af0a9dabc6139ca1$var$CircleBg, {
    width: "100%",
    height: "100%"
}))};
	background-position-x: 600px;
	background-position-y: 328px;
	-webkit-background-size: cover;
	background-size: cover;
	background-repeat: no-repeat;
	min-height: 100%;
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		background-position: center bottom;
		right: 0px;
		bottom: -400px;
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		background-image: ${(0, $hAuJ9.svgComponentToCSS)(/*#__PURE__*/ (0, $iKObn.jsx)($af0a9dabc6139ca1$var$CircleBg, {
    width: 375,
    height: "100%"
}))};
		top: ${({ insetTop: insetTop })=>insetTop - 70}px;
	}
`;

});
parcelRegister("2i7xU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4549c19e0c22c368$export$2e2bcd8739ae039);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $GDBjl = parcelRequire("GDBjl");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
var $4549c19e0c22c368$var$DumbbellsIcon = function DumbbellsIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("g", {
                clipPath: "url(#clip0_2664_10984)",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M15.295 4.811 13.84 3.356l.631-.631a.666.666 0 1 0-.942-.943l-.632.631L11.442.96a2.467 2.467 0 0 0-3.403 0 2.406 2.406 0 0 0 0 3.404l1.454 1.454-3.929 3.93L4.11 8.292a2.467 2.467 0 0 0-3.404 0 2.406 2.406 0 0 0 0 3.404L2.16 13.15l-.631.63a.667.667 0 1 0 .942.944l.632-.632 1.455 1.455a2.405 2.405 0 0 0 4.109-1.702 2.406 2.406 0 0 0-.706-1.701L6.507 10.69l3.933-3.93 1.455 1.455a2.406 2.406 0 1 0 3.403-3.404h-.003Zm-7.962 9.036a1.067 1.067 0 0 1-.314.758 1.098 1.098 0 0 1-1.518 0l-3.853-3.852a1.073 1.073 0 0 1 1.518-1.518l3.853 3.852a1.067 1.067 0 0 1 .314.76Zm7.02-6.575a1.098 1.098 0 0 1-1.519 0L8.981 3.419A1.073 1.073 0 0 1 10.5 1.901l3.853 3.853a1.074 1.074 0 0 1 0 1.518Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_2664_10984",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(0 .253)",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    });
};
$4549c19e0c22c368$var$DumbbellsIcon.defaultProps = {
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $4549c19e0c22c368$var$FireIcon = function FireIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M11.996 22C7.865 22 4.5 18.563 4.5 14.344c0-4.577 5.239-10.285 6.288-11.383l.5-.502c.458-.467.891-.501 1.174-.433.283.06.667.263.891.884l.225.69c.109.306.417 1.165.916 2.296.342-.417.733-.502.983-.493.283.008.683.144.991.68l.342.69c.15.306.325.638.508.986.891 1.668 2.107 3.956 2.165 6.398v.017a.758.758 0 0 1 0 .238c-.058 4.21-3.398 7.58-7.495 7.58l.008.008Zm0-17.865c-2.69 2.816-5.822 7.172-5.822 10.209 0 3.284 2.615 5.955 5.83 5.955s5.83-2.671 5.83-5.955V14.3c-.016-2.067-1.14-4.177-1.965-5.725-.192-.366-.367-.698-.517-1.004-.108.153-.225.315-.316.451a.835.835 0 0 1-.741.366.826.826 0 0 1-.683-.46 31.912 31.912 0 0 1-1.591-3.743l-.017-.042-.008-.009Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M9.272 15.258c.075-2.144 1.708-4.262 2.407-5.07a.24.24 0 0 1 .417.11c.674 2.476 2.732 3.31 2.623 5.104-.1 1.6-1.324 2.893-2.931 2.774-1.433-.11-2.557-1.438-2.516-2.91v-.008Z",
                fill: "currentColor"
            })
        ]
    });
};
$4549c19e0c22c368$var$FireIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $4549c19e0c22c368$var$TemplatesIcon = function TemplatesIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("g", {
                clipPath: "url(#clip0_1202_1679)",
                fill: "currentColor",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M13 22V11a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2Zm9 0V11h-7v11h7ZM24 2v3a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2Zm-9 0v3h7V2h-7ZM11 19v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2Zm-9 0v3h7v-3H2ZM11 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2ZM2 2v11h7V2H2Z"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_1202_1679",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
};
$4549c19e0c22c368$var$TemplatesIcon.defaultProps = {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $4549c19e0c22c368$var$TrophyIcon = function TrophyIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("g", {
                clipPath: "url(#clip0_1202_1592)",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M15.091 16C21.661 15.964 24 12.484 24 9.5a3.5 3.5 0 0 0-2.764-3.419c.136-.387.254-.742.333-1.011a3.886 3.886 0 0 0-.626-3.458A3.98 3.98 0 0 0 17.729 0H6.271a3.979 3.979 0 0 0-3.214 1.612 3.887 3.887 0 0 0-.626 3.458c.079.269.2.624.333 1.011A3.5 3.5 0 0 0 0 9.5c0 2.984 2.339 6.464 8.909 6.5.058.304.089.612.091.921V20a1.883 1.883 0 0 1-2 2H6a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2h-.992A1.883 1.883 0 0 1 15 20v-3.08c.002-.309.033-.617.091-.92ZM20.5 8A1.5 1.5 0 0 1 22 9.5c0 2.034-1.609 4.2-6.036 4.47.221-.302.477-.578.762-.821a15.133 15.133 0 0 0 3.727-5.159c.016.001.03.01.047.01ZM2 9.5A1.5 1.5 0 0 1 3.5 8c.017 0 .031-.009.047-.01a15.132 15.132 0 0 0 3.727 5.159c.285.243.54.519.762.821C3.609 13.7 2 11.534 2 9.5ZM10.513 22A4.08 4.08 0 0 0 11 20v-3.079a6.93 6.93 0 0 0-2.431-5.295A15.338 15.338 0 0 1 4.349 4.5a1.9 1.9 0 0 1 .31-1.694A1.994 1.994 0 0 1 6.271 2h11.458a1.994 1.994 0 0 1 1.612.81 1.9 1.9 0 0 1 .31 1.694 15.338 15.338 0 0 1-4.22 7.122A6.927 6.927 0 0 0 13 16.92V20a4.08 4.08 0 0 0 .487 2h-2.974Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_1202_1592",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
};
$4549c19e0c22c368$var$TrophyIcon.defaultProps = {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
function $4549c19e0c22c368$export$2e2bcd8739ae039({ showPhysioMeMonochromeLogo: showPhysioMeMonochromeLogo }) {
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($4549c19e0c22c368$var$ContentRight, {
        children: [
            showPhysioMeMonochromeLogo && /*#__PURE__*/ (0, $iKObn.jsx)($4549c19e0c22c368$var$StyledAppLogo, {
                height: 57,
                type: "monochrome"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($4549c19e0c22c368$var$StyledSubTitle, {
                children: format("register.description.subTitle")
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($4549c19e0c22c368$var$NotesContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($4549c19e0c22c368$var$StyledIcon, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($4549c19e0c22c368$var$DumbbellsIcon, {
                            width: 16,
                            color: (0, $kKnoQ.colors).mobilePrimaryBlue
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        className: "p-size-m",
                        children: format("login.description.v1_6.note1")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($4549c19e0c22c368$var$StyledIcon, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($4549c19e0c22c368$var$FireIcon, {
                            width: 16,
                            color: (0, $kKnoQ.colors).mobilePrimaryBlue
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        className: "p-size-m",
                        children: format("login.description.v1_6.note2")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($4549c19e0c22c368$var$StyledIcon, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($4549c19e0c22c368$var$TemplatesIcon, {
                            width: 16,
                            color: (0, $kKnoQ.colors).mobilePrimaryBlue
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        className: "p-size-m",
                        children: format("login.description.v1_6.note3")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($4549c19e0c22c368$var$StyledIcon, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($4549c19e0c22c368$var$TrophyIcon, {
                            width: 16,
                            color: (0, $kKnoQ.colors).mobilePrimaryBlue
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        className: "p-size-m",
                        children: format("login.description.v1_6.note4")
                    })
                ]
            })
        ]
    });
}
const $4549c19e0c22c368$var$ContentRight = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, undefined, "flexstart")};
	flex: 1;
	color: ${(0, $kKnoQ.colors).white};
	padding-top: 140px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 48px 32px;
	}
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding: 48px 16px;
	}
`;
const $4549c19e0c22c368$var$StyledAppLogo = (0, $5UMQ1.default)((0, $GDBjl.AppLogo))`
	color: ${(0, $kKnoQ.colors).white};
	margin-bottom: 56px;
`;
const $4549c19e0c22c368$var$StyledSubTitle = (0, $5UMQ1.default).h2`
	font-size: 24px;
	margin-bottom: 32px;
`;
const $4549c19e0c22c368$var$NotesContainer = (0, $5UMQ1.default).div`
	display: grid;
	grid-template-columns: auto 1fr;
	gap: 16px;
	line-height: 32px;
`;
const $4549c19e0c22c368$var$StyledIcon = (0, $5UMQ1.default).div`
	background-color: ${(0, $kKnoQ.colors).white};
	border-radius: 16px;
	padding: 8px;
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

});

parcelRegister("hAuJ9", function(module, exports) {

$parcel$export(module.exports, "svgComponentToCSS", () => $d437f1bc79ed10f5$export$3905b3eb1bc4a842);

var $9Nlca = parcelRequire("9Nlca");
const $d437f1bc79ed10f5$export$3905b3eb1bc4a842 = (Component)=>`url("data:image/svg+xml,${encodeURIComponent((0, $9Nlca.renderToStaticMarkup)(Component))}")`;

});
parcelRegister("9Nlca", function(module, exports) {

$parcel$export(module.exports, "renderToStaticMarkup", () => $721921940d1cd47e$export$eb3a06aef9e6ee51, (v) => $721921940d1cd47e$export$eb3a06aef9e6ee51 = v);
var $721921940d1cd47e$export$83d89fbfd8236492;
var $721921940d1cd47e$export$80e7718417253a51;
var $721921940d1cd47e$export$eb3a06aef9e6ee51;
var $721921940d1cd47e$export$307591e98609eddd;
var $721921940d1cd47e$export$b23711c915539651;
var $721921940d1cd47e$export$7020a3240b287705;
"use strict";
var $721921940d1cd47e$var$l, $721921940d1cd47e$var$s;

$721921940d1cd47e$var$l = (parcelRequire("loaut"));

$721921940d1cd47e$var$s = (parcelRequire("7OgLq"));
$721921940d1cd47e$export$83d89fbfd8236492 = $721921940d1cd47e$var$l.version;
$721921940d1cd47e$export$80e7718417253a51 = $721921940d1cd47e$var$l.renderToString;
$721921940d1cd47e$export$eb3a06aef9e6ee51 = $721921940d1cd47e$var$l.renderToStaticMarkup;
$721921940d1cd47e$export$307591e98609eddd = $721921940d1cd47e$var$l.renderToNodeStream;
$721921940d1cd47e$export$b23711c915539651 = $721921940d1cd47e$var$l.renderToStaticNodeStream;
$721921940d1cd47e$export$7020a3240b287705 = $721921940d1cd47e$var$s.renderToReadableStream;

});
parcelRegister("loaut", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $f923fa0e5fa8a178$export$307591e98609eddd, (v) => $f923fa0e5fa8a178$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $f923fa0e5fa8a178$export$eb3a06aef9e6ee51, (v) => $f923fa0e5fa8a178$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $f923fa0e5fa8a178$export$b23711c915539651, (v) => $f923fa0e5fa8a178$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $f923fa0e5fa8a178$export$80e7718417253a51, (v) => $f923fa0e5fa8a178$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $f923fa0e5fa8a178$export$83d89fbfd8236492, (v) => $f923fa0e5fa8a178$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f923fa0e5fa8a178$export$307591e98609eddd;
var $f923fa0e5fa8a178$export$eb3a06aef9e6ee51;
var $f923fa0e5fa8a178$export$b23711c915539651;
var $f923fa0e5fa8a178$export$80e7718417253a51;
var $f923fa0e5fa8a178$export$83d89fbfd8236492;
"use strict";

var $81g6h = parcelRequire("81g6h");
function $f923fa0e5fa8a178$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $f923fa0e5fa8a178$var$p = Object.prototype.hasOwnProperty, $f923fa0e5fa8a178$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $f923fa0e5fa8a178$var$ha = {}, $f923fa0e5fa8a178$var$ia = {};
function $f923fa0e5fa8a178$var$ja(a) {
    if ($f923fa0e5fa8a178$var$p.call($f923fa0e5fa8a178$var$ia, a)) return !0;
    if ($f923fa0e5fa8a178$var$p.call($f923fa0e5fa8a178$var$ha, a)) return !1;
    if ($f923fa0e5fa8a178$var$fa.test(a)) return $f923fa0e5fa8a178$var$ia[a] = !0;
    $f923fa0e5fa8a178$var$ha[a] = !0;
    return !1;
}
function $f923fa0e5fa8a178$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $f923fa0e5fa8a178$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $f923fa0e5fa8a178$var$t[a] = new $f923fa0e5fa8a178$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $f923fa0e5fa8a178$var$t[b] = new $f923fa0e5fa8a178$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $f923fa0e5fa8a178$var$t[a] = new $f923fa0e5fa8a178$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $f923fa0e5fa8a178$var$t[a] = new $f923fa0e5fa8a178$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $f923fa0e5fa8a178$var$t[a] = new $f923fa0e5fa8a178$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $f923fa0e5fa8a178$var$t[a] = new $f923fa0e5fa8a178$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $f923fa0e5fa8a178$var$t[a] = new $f923fa0e5fa8a178$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $f923fa0e5fa8a178$var$t[a] = new $f923fa0e5fa8a178$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $f923fa0e5fa8a178$var$t[a] = new $f923fa0e5fa8a178$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $f923fa0e5fa8a178$var$ka = /[\-:]([a-z])/g;
function $f923fa0e5fa8a178$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($f923fa0e5fa8a178$var$ka, $f923fa0e5fa8a178$var$la);
    $f923fa0e5fa8a178$var$t[b] = new $f923fa0e5fa8a178$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($f923fa0e5fa8a178$var$ka, $f923fa0e5fa8a178$var$la);
    $f923fa0e5fa8a178$var$t[b] = new $f923fa0e5fa8a178$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($f923fa0e5fa8a178$var$ka, $f923fa0e5fa8a178$var$la);
    $f923fa0e5fa8a178$var$t[b] = new $f923fa0e5fa8a178$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $f923fa0e5fa8a178$var$t[a] = new $f923fa0e5fa8a178$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$f923fa0e5fa8a178$var$t.xlinkHref = new $f923fa0e5fa8a178$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $f923fa0e5fa8a178$var$t[a] = new $f923fa0e5fa8a178$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $f923fa0e5fa8a178$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $f923fa0e5fa8a178$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($f923fa0e5fa8a178$var$u).forEach(function(a) {
    $f923fa0e5fa8a178$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $f923fa0e5fa8a178$var$u[b] = $f923fa0e5fa8a178$var$u[a];
    });
});
var $f923fa0e5fa8a178$var$na = /["'&<>]/;
function $f923fa0e5fa8a178$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $f923fa0e5fa8a178$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $f923fa0e5fa8a178$var$oa = /([A-Z])/g, $f923fa0e5fa8a178$var$pa = /^ms-/, $f923fa0e5fa8a178$var$qa = Array.isArray;
function $f923fa0e5fa8a178$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $f923fa0e5fa8a178$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $f923fa0e5fa8a178$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $f923fa0e5fa8a178$var$w(2, null);
        case "math":
            return $f923fa0e5fa8a178$var$w(3, null);
        case "foreignObject":
            return $f923fa0e5fa8a178$var$w(1, null);
        case "table":
            return $f923fa0e5fa8a178$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $f923fa0e5fa8a178$var$w(5, null);
        case "colgroup":
            return $f923fa0e5fa8a178$var$w(7, null);
        case "tr":
            return $f923fa0e5fa8a178$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $f923fa0e5fa8a178$var$w(1, null) : a;
}
var $f923fa0e5fa8a178$var$sa = new Map;
function $f923fa0e5fa8a178$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($f923fa0e5fa8a178$var$l(62));
    b = !0;
    for(var d in c)if ($f923fa0e5fa8a178$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $f923fa0e5fa8a178$var$v(d);
                f = $f923fa0e5fa8a178$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $f923fa0e5fa8a178$var$sa.get(e);
                void 0 !== g ? e = g : (g = $f923fa0e5fa8a178$var$v(e.replace($f923fa0e5fa8a178$var$oa, "-$1").toLowerCase().replace($f923fa0e5fa8a178$var$pa, "-ms-")), $f923fa0e5fa8a178$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $f923fa0e5fa8a178$var$p.call($f923fa0e5fa8a178$var$u, d) ? "" + f : f + "px" : $f923fa0e5fa8a178$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $f923fa0e5fa8a178$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $f923fa0e5fa8a178$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $f923fa0e5fa8a178$var$t.hasOwnProperty(c) ? $f923fa0e5fa8a178$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $f923fa0e5fa8a178$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $f923fa0e5fa8a178$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $f923fa0e5fa8a178$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $f923fa0e5fa8a178$var$v(d), '"');
            }
        } else if ($f923fa0e5fa8a178$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $f923fa0e5fa8a178$var$v(d), '"');
        }
    }
}
function $f923fa0e5fa8a178$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($f923fa0e5fa8a178$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($f923fa0e5fa8a178$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $f923fa0e5fa8a178$var$ua(a) {
    var b = "";
    $81g6h.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $f923fa0e5fa8a178$var$va(a, b, c, d) {
    a.push($f923fa0e5fa8a178$var$A(c));
    var f = c = null, e;
    for(e in b)if ($f923fa0e5fa8a178$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $f923fa0e5fa8a178$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $f923fa0e5fa8a178$var$y(a, f, c);
    return "string" === typeof c ? (a.push($f923fa0e5fa8a178$var$v(c)), null) : c;
}
var $f923fa0e5fa8a178$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $f923fa0e5fa8a178$var$xa = new Map;
function $f923fa0e5fa8a178$var$A(a) {
    var b = $f923fa0e5fa8a178$var$xa.get(a);
    if (void 0 === b) {
        if (!$f923fa0e5fa8a178$var$wa.test(a)) throw Error($f923fa0e5fa8a178$var$l(65, a));
        b = "<" + a;
        $f923fa0e5fa8a178$var$xa.set(a, b);
    }
    return b;
}
function $f923fa0e5fa8a178$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($f923fa0e5fa8a178$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($f923fa0e5fa8a178$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $f923fa0e5fa8a178$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $f923fa0e5fa8a178$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($f923fa0e5fa8a178$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($f923fa0e5fa8a178$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $f923fa0e5fa8a178$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $f923fa0e5fa8a178$var$ua(h), $f923fa0e5fa8a178$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $f923fa0e5fa8a178$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($f923fa0e5fa8a178$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($f923fa0e5fa8a178$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($f923fa0e5fa8a178$var$l(91));
                default:
                    $f923fa0e5fa8a178$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($f923fa0e5fa8a178$var$l(92));
                if ($f923fa0e5fa8a178$var$qa(n) && 1 < n.length) throw Error($f923fa0e5fa8a178$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($f923fa0e5fa8a178$var$v("" + e));
            return null;
        case "input":
            a.push($f923fa0e5fa8a178$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($f923fa0e5fa8a178$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($f923fa0e5fa8a178$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $f923fa0e5fa8a178$var$x(a, d, g, m);
            }
            null !== n ? $f923fa0e5fa8a178$var$x(a, d, "checked", n) : null !== k && $f923fa0e5fa8a178$var$x(a, d, "checked", k);
            null !== e ? $f923fa0e5fa8a178$var$x(a, d, "value", e) : null !== h && $f923fa0e5fa8a178$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($f923fa0e5fa8a178$var$A("menuitem"));
            for(var C in c)if ($f923fa0e5fa8a178$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($f923fa0e5fa8a178$var$l(400));
                default:
                    $f923fa0e5fa8a178$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($f923fa0e5fa8a178$var$A("title"));
            e = null;
            for(q in c)if ($f923fa0e5fa8a178$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($f923fa0e5fa8a178$var$l(434));
                default:
                    $f923fa0e5fa8a178$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($f923fa0e5fa8a178$var$A(b));
            g = e = null;
            for(k in c)if ($f923fa0e5fa8a178$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $f923fa0e5fa8a178$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($f923fa0e5fa8a178$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($f923fa0e5fa8a178$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($f923fa0e5fa8a178$var$A(b));
            for(var D in c)if ($f923fa0e5fa8a178$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($f923fa0e5fa8a178$var$l(399, b));
                default:
                    $f923fa0e5fa8a178$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $f923fa0e5fa8a178$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $f923fa0e5fa8a178$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $f923fa0e5fa8a178$var$va(a, c, b, d);
            a.push($f923fa0e5fa8a178$var$A(b));
            g = e = null;
            for(m in c)if ($f923fa0e5fa8a178$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $f923fa0e5fa8a178$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $f923fa0e5fa8a178$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $f923fa0e5fa8a178$var$v(h), '"');
            }
            a.push(">");
            $f923fa0e5fa8a178$var$y(a, g, e);
            return e;
    }
}
function $f923fa0e5fa8a178$var$za(a, b, c) {
    a.push('<!--$?--><template id="');
    if (null === c) throw Error($f923fa0e5fa8a178$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $f923fa0e5fa8a178$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($f923fa0e5fa8a178$var$l(397));
    }
}
function $f923fa0e5fa8a178$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($f923fa0e5fa8a178$var$l(397));
    }
}
var $f923fa0e5fa8a178$var$Ca = /[<\u2028\u2029]/g;
function $f923fa0e5fa8a178$var$Da(a) {
    return JSON.stringify(a).replace($f923fa0e5fa8a178$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $f923fa0e5fa8a178$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $f923fa0e5fa8a178$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($f923fa0e5fa8a178$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("<!-- -->"), a.push($f923fa0e5fa8a178$var$v(b)), a = !0);
    return a;
}
var $f923fa0e5fa8a178$var$B = Object.assign, $f923fa0e5fa8a178$var$Ga = Symbol.for("react.element"), $f923fa0e5fa8a178$var$Ha = Symbol.for("react.portal"), $f923fa0e5fa8a178$var$Ia = Symbol.for("react.fragment"), $f923fa0e5fa8a178$var$Ja = Symbol.for("react.strict_mode"), $f923fa0e5fa8a178$var$Ka = Symbol.for("react.profiler"), $f923fa0e5fa8a178$var$La = Symbol.for("react.provider"), $f923fa0e5fa8a178$var$Ma = Symbol.for("react.context"), $f923fa0e5fa8a178$var$Na = Symbol.for("react.forward_ref"), $f923fa0e5fa8a178$var$Oa = Symbol.for("react.suspense"), $f923fa0e5fa8a178$var$Pa = Symbol.for("react.suspense_list"), $f923fa0e5fa8a178$var$Qa = Symbol.for("react.memo"), $f923fa0e5fa8a178$var$Ra = Symbol.for("react.lazy"), $f923fa0e5fa8a178$var$Sa = Symbol.for("react.scope"), $f923fa0e5fa8a178$var$Ta = Symbol.for("react.debug_trace_mode"), $f923fa0e5fa8a178$var$Ua = Symbol.for("react.legacy_hidden"), $f923fa0e5fa8a178$var$Va = Symbol.for("react.default_value"), $f923fa0e5fa8a178$var$Wa = Symbol.iterator;
function $f923fa0e5fa8a178$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $f923fa0e5fa8a178$var$Ia:
            return "Fragment";
        case $f923fa0e5fa8a178$var$Ha:
            return "Portal";
        case $f923fa0e5fa8a178$var$Ka:
            return "Profiler";
        case $f923fa0e5fa8a178$var$Ja:
            return "StrictMode";
        case $f923fa0e5fa8a178$var$Oa:
            return "Suspense";
        case $f923fa0e5fa8a178$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $f923fa0e5fa8a178$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $f923fa0e5fa8a178$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $f923fa0e5fa8a178$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $f923fa0e5fa8a178$var$Qa:
            return b = a.displayName || null, null !== b ? b : $f923fa0e5fa8a178$var$Xa(a.type) || "Memo";
        case $f923fa0e5fa8a178$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $f923fa0e5fa8a178$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $f923fa0e5fa8a178$var$Ya = {};
function $f923fa0e5fa8a178$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $f923fa0e5fa8a178$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $f923fa0e5fa8a178$var$E = null;
function $f923fa0e5fa8a178$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($f923fa0e5fa8a178$var$l(401));
        } else {
            if (null === c) throw Error($f923fa0e5fa8a178$var$l(401));
            $f923fa0e5fa8a178$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $f923fa0e5fa8a178$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $f923fa0e5fa8a178$var$$a(a);
}
function $f923fa0e5fa8a178$var$ab(a) {
    var b = a.parent;
    null !== b && $f923fa0e5fa8a178$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $f923fa0e5fa8a178$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($f923fa0e5fa8a178$var$l(402));
    a.depth === b.depth ? $f923fa0e5fa8a178$var$F(a, b) : $f923fa0e5fa8a178$var$bb(a, b);
}
function $f923fa0e5fa8a178$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($f923fa0e5fa8a178$var$l(402));
    a.depth === c.depth ? $f923fa0e5fa8a178$var$F(a, c) : $f923fa0e5fa8a178$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $f923fa0e5fa8a178$var$G(a) {
    var b = $f923fa0e5fa8a178$var$E;
    b !== a && (null === b ? $f923fa0e5fa8a178$var$ab(a) : null === a ? $f923fa0e5fa8a178$var$$a(b) : b.depth === a.depth ? $f923fa0e5fa8a178$var$F(b, a) : b.depth > a.depth ? $f923fa0e5fa8a178$var$bb(b, a) : $f923fa0e5fa8a178$var$cb(b, a), $f923fa0e5fa8a178$var$E = a);
}
var $f923fa0e5fa8a178$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $f923fa0e5fa8a178$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $f923fa0e5fa8a178$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $f923fa0e5fa8a178$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $f923fa0e5fa8a178$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $f923fa0e5fa8a178$var$B({}, e, h)) : $f923fa0e5fa8a178$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $f923fa0e5fa8a178$var$fb = {
    id: 1,
    overflow: ""
};
function $f923fa0e5fa8a178$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $f923fa0e5fa8a178$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $f923fa0e5fa8a178$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $f923fa0e5fa8a178$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $f923fa0e5fa8a178$var$H = Math.clz32 ? Math.clz32 : $f923fa0e5fa8a178$var$hb, $f923fa0e5fa8a178$var$ib = Math.log, $f923fa0e5fa8a178$var$jb = Math.LN2;
function $f923fa0e5fa8a178$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($f923fa0e5fa8a178$var$ib(a) / $f923fa0e5fa8a178$var$jb | 0) | 0;
}
function $f923fa0e5fa8a178$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f923fa0e5fa8a178$var$lb = "function" === typeof Object.is ? Object.is : $f923fa0e5fa8a178$var$kb, $f923fa0e5fa8a178$var$I = null, $f923fa0e5fa8a178$var$ob = null, $f923fa0e5fa8a178$var$J = null, $f923fa0e5fa8a178$var$K = null, $f923fa0e5fa8a178$var$L = !1, $f923fa0e5fa8a178$var$M = !1, $f923fa0e5fa8a178$var$N = 0, $f923fa0e5fa8a178$var$O = null, $f923fa0e5fa8a178$var$P = 0;
function $f923fa0e5fa8a178$var$Q() {
    if (null === $f923fa0e5fa8a178$var$I) throw Error($f923fa0e5fa8a178$var$l(321));
    return $f923fa0e5fa8a178$var$I;
}
function $f923fa0e5fa8a178$var$pb() {
    if (0 < $f923fa0e5fa8a178$var$P) throw Error($f923fa0e5fa8a178$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $f923fa0e5fa8a178$var$qb() {
    null === $f923fa0e5fa8a178$var$K ? null === $f923fa0e5fa8a178$var$J ? ($f923fa0e5fa8a178$var$L = !1, $f923fa0e5fa8a178$var$J = $f923fa0e5fa8a178$var$K = $f923fa0e5fa8a178$var$pb()) : ($f923fa0e5fa8a178$var$L = !0, $f923fa0e5fa8a178$var$K = $f923fa0e5fa8a178$var$J) : null === $f923fa0e5fa8a178$var$K.next ? ($f923fa0e5fa8a178$var$L = !1, $f923fa0e5fa8a178$var$K = $f923fa0e5fa8a178$var$K.next = $f923fa0e5fa8a178$var$pb()) : ($f923fa0e5fa8a178$var$L = !0, $f923fa0e5fa8a178$var$K = $f923fa0e5fa8a178$var$K.next);
    return $f923fa0e5fa8a178$var$K;
}
function $f923fa0e5fa8a178$var$rb() {
    $f923fa0e5fa8a178$var$ob = $f923fa0e5fa8a178$var$I = null;
    $f923fa0e5fa8a178$var$M = !1;
    $f923fa0e5fa8a178$var$J = null;
    $f923fa0e5fa8a178$var$P = 0;
    $f923fa0e5fa8a178$var$K = $f923fa0e5fa8a178$var$O = null;
}
function $f923fa0e5fa8a178$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $f923fa0e5fa8a178$var$tb(a, b, c) {
    $f923fa0e5fa8a178$var$I = $f923fa0e5fa8a178$var$Q();
    $f923fa0e5fa8a178$var$K = $f923fa0e5fa8a178$var$qb();
    if ($f923fa0e5fa8a178$var$L) {
        var d = $f923fa0e5fa8a178$var$K.queue;
        b = d.dispatch;
        if (null !== $f923fa0e5fa8a178$var$O && (c = $f923fa0e5fa8a178$var$O.get(d), void 0 !== c)) {
            $f923fa0e5fa8a178$var$O.delete(d);
            d = $f923fa0e5fa8a178$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $f923fa0e5fa8a178$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $f923fa0e5fa8a178$var$K.memoizedState,
            b
        ];
    }
    a = a === $f923fa0e5fa8a178$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $f923fa0e5fa8a178$var$K.memoizedState = a;
    a = $f923fa0e5fa8a178$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $f923fa0e5fa8a178$var$ub.bind(null, $f923fa0e5fa8a178$var$I, a);
    return [
        $f923fa0e5fa8a178$var$K.memoizedState,
        a
    ];
}
function $f923fa0e5fa8a178$var$vb(a, b) {
    $f923fa0e5fa8a178$var$I = $f923fa0e5fa8a178$var$Q();
    $f923fa0e5fa8a178$var$K = $f923fa0e5fa8a178$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $f923fa0e5fa8a178$var$K) {
        var c = $f923fa0e5fa8a178$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$f923fa0e5fa8a178$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $f923fa0e5fa8a178$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f923fa0e5fa8a178$var$ub(a, b, c) {
    if (25 <= $f923fa0e5fa8a178$var$P) throw Error($f923fa0e5fa8a178$var$l(301));
    if (a === $f923fa0e5fa8a178$var$I) {
        if ($f923fa0e5fa8a178$var$M = !0, a = {
            action: c,
            next: null
        }, null === $f923fa0e5fa8a178$var$O && ($f923fa0e5fa8a178$var$O = new Map), c = $f923fa0e5fa8a178$var$O.get(b), void 0 === c) $f923fa0e5fa8a178$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $f923fa0e5fa8a178$var$wb() {
    throw Error($f923fa0e5fa8a178$var$l(394));
}
function $f923fa0e5fa8a178$var$R() {}
var $f923fa0e5fa8a178$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $f923fa0e5fa8a178$var$Q();
        return a._currentValue2;
    },
    useMemo: $f923fa0e5fa8a178$var$vb,
    useReducer: $f923fa0e5fa8a178$var$tb,
    useRef: function(a) {
        $f923fa0e5fa8a178$var$I = $f923fa0e5fa8a178$var$Q();
        $f923fa0e5fa8a178$var$K = $f923fa0e5fa8a178$var$qb();
        var b = $f923fa0e5fa8a178$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $f923fa0e5fa8a178$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $f923fa0e5fa8a178$var$tb($f923fa0e5fa8a178$var$sb, a);
    },
    useInsertionEffect: $f923fa0e5fa8a178$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $f923fa0e5fa8a178$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $f923fa0e5fa8a178$var$R,
    useEffect: $f923fa0e5fa8a178$var$R,
    useDebugValue: $f923fa0e5fa8a178$var$R,
    useDeferredValue: function(a) {
        $f923fa0e5fa8a178$var$Q();
        return a;
    },
    useTransition: function() {
        $f923fa0e5fa8a178$var$Q();
        return [
            !1,
            $f923fa0e5fa8a178$var$wb
        ];
    },
    useId: function() {
        var a = $f923fa0e5fa8a178$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $f923fa0e5fa8a178$var$H(a) - 1)).toString(32) + b;
        var c = $f923fa0e5fa8a178$var$S;
        if (null === c) throw Error($f923fa0e5fa8a178$var$l(404));
        b = $f923fa0e5fa8a178$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $f923fa0e5fa8a178$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($f923fa0e5fa8a178$var$l(407));
        return c();
    }
}, $f923fa0e5fa8a178$var$S = null, $f923fa0e5fa8a178$var$yb = $81g6h.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $f923fa0e5fa8a178$var$zb(a) {
    console.error(a);
    return null;
}
function $f923fa0e5fa8a178$var$T() {}
function $f923fa0e5fa8a178$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $f923fa0e5fa8a178$var$zb : f,
        onAllReady: void 0 === e ? $f923fa0e5fa8a178$var$T : e,
        onShellReady: void 0 === g ? $f923fa0e5fa8a178$var$T : g,
        onShellError: void 0 === h ? $f923fa0e5fa8a178$var$T : h,
        onFatalError: void 0 === k ? $f923fa0e5fa8a178$var$T : k
    };
    c = $f923fa0e5fa8a178$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $f923fa0e5fa8a178$var$Bb(b, a, null, c, n, $f923fa0e5fa8a178$var$Ya, null, $f923fa0e5fa8a178$var$fb);
    m.push(a);
    return b;
}
function $f923fa0e5fa8a178$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $f923fa0e5fa8a178$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $f923fa0e5fa8a178$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $f923fa0e5fa8a178$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $f923fa0e5fa8a178$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $f923fa0e5fa8a178$var$Db(a, b, c, d, f) {
    $f923fa0e5fa8a178$var$I = {};
    $f923fa0e5fa8a178$var$ob = b;
    $f923fa0e5fa8a178$var$N = 0;
    for(a = c(d, f); $f923fa0e5fa8a178$var$M;)$f923fa0e5fa8a178$var$M = !1, $f923fa0e5fa8a178$var$N = 0, $f923fa0e5fa8a178$var$P += 1, $f923fa0e5fa8a178$var$K = null, a = c(d, f);
    $f923fa0e5fa8a178$var$rb();
    return a;
}
function $f923fa0e5fa8a178$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($f923fa0e5fa8a178$var$l(108, $f923fa0e5fa8a178$var$Xa(d) || "Unknown", h));
            d = $f923fa0e5fa8a178$var$B({}, g, c);
        }
        b.legacyContext = d;
        $f923fa0e5fa8a178$var$X(a, b, f);
        b.legacyContext = g;
    } else $f923fa0e5fa8a178$var$X(a, b, f);
}
function $f923fa0e5fa8a178$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $f923fa0e5fa8a178$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $f923fa0e5fa8a178$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $f923fa0e5fa8a178$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $f923fa0e5fa8a178$var$eb(e, c, d, f);
            $f923fa0e5fa8a178$var$Eb(a, b, e, c);
        } else {
            e = $f923fa0e5fa8a178$var$Za(c, b.legacyContext);
            f = $f923fa0e5fa8a178$var$Db(a, b, c, d, e);
            var g = 0 !== $f923fa0e5fa8a178$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $f923fa0e5fa8a178$var$eb(f, c, d, e), $f923fa0e5fa8a178$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $f923fa0e5fa8a178$var$gb(d, 1, 0);
                try {
                    $f923fa0e5fa8a178$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $f923fa0e5fa8a178$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $f923fa0e5fa8a178$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $f923fa0e5fa8a178$var$ra(g, c, d);
        $f923fa0e5fa8a178$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $f923fa0e5fa8a178$var$Ua:
            case $f923fa0e5fa8a178$var$Ta:
            case $f923fa0e5fa8a178$var$Ja:
            case $f923fa0e5fa8a178$var$Ka:
            case $f923fa0e5fa8a178$var$Ia:
                $f923fa0e5fa8a178$var$X(a, b, d.children);
                return;
            case $f923fa0e5fa8a178$var$Pa:
                $f923fa0e5fa8a178$var$X(a, b, d.children);
                return;
            case $f923fa0e5fa8a178$var$Sa:
                throw Error($f923fa0e5fa8a178$var$l(343));
            case $f923fa0e5fa8a178$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $f923fa0e5fa8a178$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $f923fa0e5fa8a178$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($f923fa0e5fa8a178$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("<!-- -->"), m.status = 1, $f923fa0e5fa8a178$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $f923fa0e5fa8a178$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $f923fa0e5fa8a178$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $f923fa0e5fa8a178$var$Na:
                d = $f923fa0e5fa8a178$var$Db(a, b, c.render, d, f);
                if (0 !== $f923fa0e5fa8a178$var$N) {
                    c = b.treeContext;
                    b.treeContext = $f923fa0e5fa8a178$var$gb(c, 1, 0);
                    try {
                        $f923fa0e5fa8a178$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $f923fa0e5fa8a178$var$X(a, b, d);
                return;
            case $f923fa0e5fa8a178$var$Qa:
                c = c.type;
                d = $f923fa0e5fa8a178$var$Fb(c, d);
                $f923fa0e5fa8a178$var$Gb(a, b, c, d, f);
                return;
            case $f923fa0e5fa8a178$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $f923fa0e5fa8a178$var$E;
                $f923fa0e5fa8a178$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $f923fa0e5fa8a178$var$X(a, b, f);
                a = $f923fa0e5fa8a178$var$E;
                if (null === a) throw Error($f923fa0e5fa8a178$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $f923fa0e5fa8a178$var$Va ? a.context._defaultValue : d;
                a = $f923fa0e5fa8a178$var$E = a.parent;
                b.context = a;
                return;
            case $f923fa0e5fa8a178$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $f923fa0e5fa8a178$var$X(a, b, d);
                return;
            case $f923fa0e5fa8a178$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $f923fa0e5fa8a178$var$Fb(c, d);
                $f923fa0e5fa8a178$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($f923fa0e5fa8a178$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $f923fa0e5fa8a178$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $f923fa0e5fa8a178$var$Ga:
                $f923fa0e5fa8a178$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $f923fa0e5fa8a178$var$Ha:
                throw Error($f923fa0e5fa8a178$var$l(257));
            case $f923fa0e5fa8a178$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $f923fa0e5fa8a178$var$X(a, b, c);
                return;
        }
        if ($f923fa0e5fa8a178$var$qa(c)) {
            $f923fa0e5fa8a178$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $f923fa0e5fa8a178$var$Wa && c[$f923fa0e5fa8a178$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $f923fa0e5fa8a178$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($f923fa0e5fa8a178$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $f923fa0e5fa8a178$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $f923fa0e5fa8a178$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $f923fa0e5fa8a178$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $f923fa0e5fa8a178$var$gb(e, d, f);
        try {
            $f923fa0e5fa8a178$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $f923fa0e5fa8a178$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $f923fa0e5fa8a178$var$X(a, b, c);
    } catch (k) {
        if ($f923fa0e5fa8a178$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $f923fa0e5fa8a178$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $f923fa0e5fa8a178$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $f923fa0e5fa8a178$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $f923fa0e5fa8a178$var$G(e), k;
    }
}
function $f923fa0e5fa8a178$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $f923fa0e5fa8a178$var$Kb(this, b, a);
}
function $f923fa0e5fa8a178$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($f923fa0e5fa8a178$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $f923fa0e5fa8a178$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $f923fa0e5fa8a178$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $f923fa0e5fa8a178$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $f923fa0e5fa8a178$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($f923fa0e5fa8a178$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $f923fa0e5fa8a178$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $f923fa0e5fa8a178$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($f923fa0e5fa8a178$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($f923fa0e5fa8a178$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $f923fa0e5fa8a178$var$Cb(a) {
    if (2 !== a.status) {
        var b = $f923fa0e5fa8a178$var$E, c = $f923fa0e5fa8a178$var$yb.current;
        $f923fa0e5fa8a178$var$yb.current = $f923fa0e5fa8a178$var$xb;
        var d = $f923fa0e5fa8a178$var$S;
        $f923fa0e5fa8a178$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $f923fa0e5fa8a178$var$G(g.context);
                    try {
                        $f923fa0e5fa8a178$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("<!-- -->"), g.abortSet.delete(g), k.status = 1, $f923fa0e5fa8a178$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($f923fa0e5fa8a178$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $f923fa0e5fa8a178$var$V(h, q);
                            null === n ? $f923fa0e5fa8a178$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $f923fa0e5fa8a178$var$Mb(a, a.destination);
        } catch (z) {
            $f923fa0e5fa8a178$var$V(a, z), $f923fa0e5fa8a178$var$W(a, z);
        } finally{
            $f923fa0e5fa8a178$var$S = d, $f923fa0e5fa8a178$var$yb.current = c, c === $f923fa0e5fa8a178$var$xb && $f923fa0e5fa8a178$var$G(b);
        }
    }
}
function $f923fa0e5fa8a178$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $f923fa0e5fa8a178$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($f923fa0e5fa8a178$var$l(390));
    }
}
function $f923fa0e5fa8a178$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $f923fa0e5fa8a178$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("<!--$!-->"), b.push("<template"), d && (b.push(' data-dgst="'), d = $f923fa0e5fa8a178$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $f923fa0e5fa8a178$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("<!--/$-->"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $f923fa0e5fa8a178$var$za(b, a.responseState, d);
        $f923fa0e5fa8a178$var$Z(a, b, c);
        return b.push("<!--/$-->");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $f923fa0e5fa8a178$var$za(b, a.responseState, d.id), $f923fa0e5fa8a178$var$Z(a, b, c), b.push("<!--/$-->");
    a.responseState.generateStaticMarkup || b.push("<!--$-->");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($f923fa0e5fa8a178$var$l(391));
    $f923fa0e5fa8a178$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("<!--/$-->");
    return a;
}
function $f923fa0e5fa8a178$var$Ob(a, b, c) {
    $f923fa0e5fa8a178$var$Aa(b, a.responseState, c.formatContext, c.id);
    $f923fa0e5fa8a178$var$Nb(a, b, c);
    return $f923fa0e5fa8a178$var$Ba(b, c.formatContext);
}
function $f923fa0e5fa8a178$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$f923fa0e5fa8a178$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($f923fa0e5fa8a178$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")</script>');
}
function $f923fa0e5fa8a178$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($f923fa0e5fa8a178$var$l(392));
        return $f923fa0e5fa8a178$var$Ob(a, b, d);
    }
    $f923fa0e5fa8a178$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")</script>');
}
function $f923fa0e5fa8a178$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $f923fa0e5fa8a178$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($f923fa0e5fa8a178$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $f923fa0e5fa8a178$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $f923fa0e5fa8a178$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $f923fa0e5fa8a178$var$Da(q);
                d.push(z);
            }
            if (!d.push(")</script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$f923fa0e5fa8a178$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$f923fa0e5fa8a178$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$f923fa0e5fa8a178$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $f923fa0e5fa8a178$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $f923fa0e5fa8a178$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $f923fa0e5fa8a178$var$Mb(a, a.destination);
    } catch (d) {
        $f923fa0e5fa8a178$var$V(a, d), $f923fa0e5fa8a178$var$W(a, d);
    }
}
function $f923fa0e5fa8a178$var$Sb() {}
function $f923fa0e5fa8a178$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $f923fa0e5fa8a178$var$Ab(a, $f923fa0e5fa8a178$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $f923fa0e5fa8a178$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $f923fa0e5fa8a178$var$Cb(a);
    $f923fa0e5fa8a178$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $f923fa0e5fa8a178$var$Mb(a, h);
        } catch (m) {
            $f923fa0e5fa8a178$var$V(a, m), $f923fa0e5fa8a178$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($f923fa0e5fa8a178$var$l(426));
    return g;
}
$f923fa0e5fa8a178$export$307591e98609eddd = function() {
    throw Error($f923fa0e5fa8a178$var$l(207));
};
$f923fa0e5fa8a178$export$eb3a06aef9e6ee51 = function(a, b) {
    return $f923fa0e5fa8a178$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$f923fa0e5fa8a178$export$b23711c915539651 = function() {
    throw Error($f923fa0e5fa8a178$var$l(208));
};
$f923fa0e5fa8a178$export$80e7718417253a51 = function(a, b) {
    return $f923fa0e5fa8a178$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$f923fa0e5fa8a178$export$83d89fbfd8236492 = "18.3.1";

});

parcelRegister("7OgLq", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", () => $5afa34dcf7de60d0$export$7020a3240b287705, (v) => $5afa34dcf7de60d0$export$7020a3240b287705 = v);
$parcel$export(module.exports, "version", () => $5afa34dcf7de60d0$export$83d89fbfd8236492, (v) => $5afa34dcf7de60d0$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5afa34dcf7de60d0$export$7020a3240b287705;
var $5afa34dcf7de60d0$export$83d89fbfd8236492;
"use strict";

var $81g6h = parcelRequire("81g6h");
function $5afa34dcf7de60d0$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $5afa34dcf7de60d0$var$l = null, $5afa34dcf7de60d0$var$n = 0;
function $5afa34dcf7de60d0$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $5afa34dcf7de60d0$var$n && (a.enqueue(new Uint8Array($5afa34dcf7de60d0$var$l.buffer, 0, $5afa34dcf7de60d0$var$n)), $5afa34dcf7de60d0$var$l = new Uint8Array(512), $5afa34dcf7de60d0$var$n = 0), a.enqueue(b);
        else {
            var c = $5afa34dcf7de60d0$var$l.length - $5afa34dcf7de60d0$var$n;
            c < b.length && (0 === c ? a.enqueue($5afa34dcf7de60d0$var$l) : ($5afa34dcf7de60d0$var$l.set(b.subarray(0, c), $5afa34dcf7de60d0$var$n), a.enqueue($5afa34dcf7de60d0$var$l), b = b.subarray(c)), $5afa34dcf7de60d0$var$l = new Uint8Array(512), $5afa34dcf7de60d0$var$n = 0);
            $5afa34dcf7de60d0$var$l.set(b, $5afa34dcf7de60d0$var$n);
            $5afa34dcf7de60d0$var$n += b.length;
        }
    }
}
function $5afa34dcf7de60d0$var$t(a, b) {
    $5afa34dcf7de60d0$var$p(a, b);
    return !0;
}
function $5afa34dcf7de60d0$var$ba(a) {
    $5afa34dcf7de60d0$var$l && 0 < $5afa34dcf7de60d0$var$n && (a.enqueue(new Uint8Array($5afa34dcf7de60d0$var$l.buffer, 0, $5afa34dcf7de60d0$var$n)), $5afa34dcf7de60d0$var$l = null, $5afa34dcf7de60d0$var$n = 0);
}
var $5afa34dcf7de60d0$var$ca = new TextEncoder;
function $5afa34dcf7de60d0$var$u(a) {
    return $5afa34dcf7de60d0$var$ca.encode(a);
}
function $5afa34dcf7de60d0$var$w(a) {
    return $5afa34dcf7de60d0$var$ca.encode(a);
}
function $5afa34dcf7de60d0$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $5afa34dcf7de60d0$var$x = Object.prototype.hasOwnProperty, $5afa34dcf7de60d0$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $5afa34dcf7de60d0$var$fa = {}, $5afa34dcf7de60d0$var$ha = {};
function $5afa34dcf7de60d0$var$ia(a) {
    if ($5afa34dcf7de60d0$var$x.call($5afa34dcf7de60d0$var$ha, a)) return !0;
    if ($5afa34dcf7de60d0$var$x.call($5afa34dcf7de60d0$var$fa, a)) return !1;
    if ($5afa34dcf7de60d0$var$ea.test(a)) return $5afa34dcf7de60d0$var$ha[a] = !0;
    $5afa34dcf7de60d0$var$fa[a] = !0;
    return !1;
}
function $5afa34dcf7de60d0$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $5afa34dcf7de60d0$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $5afa34dcf7de60d0$var$z[a] = new $5afa34dcf7de60d0$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $5afa34dcf7de60d0$var$z[b] = new $5afa34dcf7de60d0$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $5afa34dcf7de60d0$var$z[a] = new $5afa34dcf7de60d0$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $5afa34dcf7de60d0$var$z[a] = new $5afa34dcf7de60d0$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $5afa34dcf7de60d0$var$z[a] = new $5afa34dcf7de60d0$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $5afa34dcf7de60d0$var$z[a] = new $5afa34dcf7de60d0$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $5afa34dcf7de60d0$var$z[a] = new $5afa34dcf7de60d0$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $5afa34dcf7de60d0$var$z[a] = new $5afa34dcf7de60d0$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $5afa34dcf7de60d0$var$z[a] = new $5afa34dcf7de60d0$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $5afa34dcf7de60d0$var$ja = /[\-:]([a-z])/g;
function $5afa34dcf7de60d0$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($5afa34dcf7de60d0$var$ja, $5afa34dcf7de60d0$var$ka);
    $5afa34dcf7de60d0$var$z[b] = new $5afa34dcf7de60d0$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($5afa34dcf7de60d0$var$ja, $5afa34dcf7de60d0$var$ka);
    $5afa34dcf7de60d0$var$z[b] = new $5afa34dcf7de60d0$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($5afa34dcf7de60d0$var$ja, $5afa34dcf7de60d0$var$ka);
    $5afa34dcf7de60d0$var$z[b] = new $5afa34dcf7de60d0$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $5afa34dcf7de60d0$var$z[a] = new $5afa34dcf7de60d0$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$5afa34dcf7de60d0$var$z.xlinkHref = new $5afa34dcf7de60d0$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $5afa34dcf7de60d0$var$z[a] = new $5afa34dcf7de60d0$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $5afa34dcf7de60d0$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $5afa34dcf7de60d0$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($5afa34dcf7de60d0$var$B).forEach(function(a) {
    $5afa34dcf7de60d0$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $5afa34dcf7de60d0$var$B[b] = $5afa34dcf7de60d0$var$B[a];
    });
});
var $5afa34dcf7de60d0$var$oa = /["'&<>]/;
function $5afa34dcf7de60d0$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $5afa34dcf7de60d0$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $5afa34dcf7de60d0$var$pa = /([A-Z])/g, $5afa34dcf7de60d0$var$qa = /^ms-/, $5afa34dcf7de60d0$var$ra = Array.isArray, $5afa34dcf7de60d0$var$sa = $5afa34dcf7de60d0$var$w("<script>"), $5afa34dcf7de60d0$var$ta = $5afa34dcf7de60d0$var$w("</script>"), $5afa34dcf7de60d0$var$ua = $5afa34dcf7de60d0$var$w('<script src="'), $5afa34dcf7de60d0$var$va = $5afa34dcf7de60d0$var$w('<script type="module" src="'), $5afa34dcf7de60d0$var$wa = $5afa34dcf7de60d0$var$w('" async=""></script>'), $5afa34dcf7de60d0$var$xa = /(<\/|<)(s)(cript)/gi;
function $5afa34dcf7de60d0$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $5afa34dcf7de60d0$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $5afa34dcf7de60d0$var$sa : $5afa34dcf7de60d0$var$w('<script nonce="' + $5afa34dcf7de60d0$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $5afa34dcf7de60d0$var$u(("" + c).replace($5afa34dcf7de60d0$var$xa, $5afa34dcf7de60d0$var$ya)), $5afa34dcf7de60d0$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($5afa34dcf7de60d0$var$ua, $5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$C(d[c])), $5afa34dcf7de60d0$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($5afa34dcf7de60d0$var$va, $5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$C(f[d])), $5afa34dcf7de60d0$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $5afa34dcf7de60d0$var$w(a + "P:"),
        segmentPrefix: $5afa34dcf7de60d0$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $5afa34dcf7de60d0$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $5afa34dcf7de60d0$var$Aa(a) {
    return $5afa34dcf7de60d0$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $5afa34dcf7de60d0$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $5afa34dcf7de60d0$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $5afa34dcf7de60d0$var$D(2, null);
        case "math":
            return $5afa34dcf7de60d0$var$D(3, null);
        case "foreignObject":
            return $5afa34dcf7de60d0$var$D(1, null);
        case "table":
            return $5afa34dcf7de60d0$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $5afa34dcf7de60d0$var$D(5, null);
        case "colgroup":
            return $5afa34dcf7de60d0$var$D(7, null);
        case "tr":
            return $5afa34dcf7de60d0$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $5afa34dcf7de60d0$var$D(1, null) : a;
}
var $5afa34dcf7de60d0$var$Ca = $5afa34dcf7de60d0$var$w("<!-- -->");
function $5afa34dcf7de60d0$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($5afa34dcf7de60d0$var$Ca);
    a.push($5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$C(b)));
    return !0;
}
var $5afa34dcf7de60d0$var$Ea = new Map, $5afa34dcf7de60d0$var$Fa = $5afa34dcf7de60d0$var$w(' style="'), $5afa34dcf7de60d0$var$Ga = $5afa34dcf7de60d0$var$w(":"), $5afa34dcf7de60d0$var$Ha = $5afa34dcf7de60d0$var$w(";");
function $5afa34dcf7de60d0$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($5afa34dcf7de60d0$var$k(62));
    b = !0;
    for(var d in c)if ($5afa34dcf7de60d0$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$C(d));
                f = $5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $5afa34dcf7de60d0$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $5afa34dcf7de60d0$var$w($5afa34dcf7de60d0$var$C(e.replace($5afa34dcf7de60d0$var$pa, "-$1").toLowerCase().replace($5afa34dcf7de60d0$var$qa, "-ms-"))), $5afa34dcf7de60d0$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $5afa34dcf7de60d0$var$x.call($5afa34dcf7de60d0$var$B, d) ? $5afa34dcf7de60d0$var$u("" + f) : $5afa34dcf7de60d0$var$u(f + "px") : $5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($5afa34dcf7de60d0$var$Fa, e, $5afa34dcf7de60d0$var$Ga, f)) : a.push($5afa34dcf7de60d0$var$Ha, e, $5afa34dcf7de60d0$var$Ga, f);
        }
    }
    b || a.push($5afa34dcf7de60d0$var$E);
}
var $5afa34dcf7de60d0$var$H = $5afa34dcf7de60d0$var$w(" "), $5afa34dcf7de60d0$var$I = $5afa34dcf7de60d0$var$w('="'), $5afa34dcf7de60d0$var$E = $5afa34dcf7de60d0$var$w('"'), $5afa34dcf7de60d0$var$Ja = $5afa34dcf7de60d0$var$w('=""');
function $5afa34dcf7de60d0$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $5afa34dcf7de60d0$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $5afa34dcf7de60d0$var$z.hasOwnProperty(c) ? $5afa34dcf7de60d0$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $5afa34dcf7de60d0$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($5afa34dcf7de60d0$var$H, c, $5afa34dcf7de60d0$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($5afa34dcf7de60d0$var$H, c, $5afa34dcf7de60d0$var$Ja) : !1 !== d && a.push($5afa34dcf7de60d0$var$H, c, $5afa34dcf7de60d0$var$I, $5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$C(d)), $5afa34dcf7de60d0$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($5afa34dcf7de60d0$var$H, c, $5afa34dcf7de60d0$var$I, $5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$C(d)), $5afa34dcf7de60d0$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($5afa34dcf7de60d0$var$H, c, $5afa34dcf7de60d0$var$I, $5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$C(d)), $5afa34dcf7de60d0$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($5afa34dcf7de60d0$var$H, c, $5afa34dcf7de60d0$var$I, $5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$C(d)), $5afa34dcf7de60d0$var$E);
            }
        } else if ($5afa34dcf7de60d0$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($5afa34dcf7de60d0$var$H, $5afa34dcf7de60d0$var$u(c), $5afa34dcf7de60d0$var$I, $5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$C(d)), $5afa34dcf7de60d0$var$E);
        }
    }
}
var $5afa34dcf7de60d0$var$K = $5afa34dcf7de60d0$var$w(">"), $5afa34dcf7de60d0$var$Ka = $5afa34dcf7de60d0$var$w("/>");
function $5afa34dcf7de60d0$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($5afa34dcf7de60d0$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($5afa34dcf7de60d0$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($5afa34dcf7de60d0$var$u("" + b));
    }
}
function $5afa34dcf7de60d0$var$La(a) {
    var b = "";
    $81g6h.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $5afa34dcf7de60d0$var$Ma = $5afa34dcf7de60d0$var$w(' selected=""');
function $5afa34dcf7de60d0$var$Na(a, b, c, d) {
    a.push($5afa34dcf7de60d0$var$M(c));
    var f = c = null, e;
    for(e in b)if ($5afa34dcf7de60d0$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $5afa34dcf7de60d0$var$J(a, d, e, g);
        }
    }
    a.push($5afa34dcf7de60d0$var$K);
    $5afa34dcf7de60d0$var$L(a, f, c);
    return "string" === typeof c ? (a.push($5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$C(c))), null) : c;
}
var $5afa34dcf7de60d0$var$Oa = $5afa34dcf7de60d0$var$w("\n"), $5afa34dcf7de60d0$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $5afa34dcf7de60d0$var$Qa = new Map;
function $5afa34dcf7de60d0$var$M(a) {
    var b = $5afa34dcf7de60d0$var$Qa.get(a);
    if (void 0 === b) {
        if (!$5afa34dcf7de60d0$var$Pa.test(a)) throw Error($5afa34dcf7de60d0$var$k(65, a));
        b = $5afa34dcf7de60d0$var$w("<" + a);
        $5afa34dcf7de60d0$var$Qa.set(a, b);
    }
    return b;
}
var $5afa34dcf7de60d0$var$Ra = $5afa34dcf7de60d0$var$w("<!DOCTYPE html>");
function $5afa34dcf7de60d0$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($5afa34dcf7de60d0$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($5afa34dcf7de60d0$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $5afa34dcf7de60d0$var$J(a, d, r, h);
                }
            }
            a.push($5afa34dcf7de60d0$var$K);
            $5afa34dcf7de60d0$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($5afa34dcf7de60d0$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($5afa34dcf7de60d0$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $5afa34dcf7de60d0$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $5afa34dcf7de60d0$var$La(h), $5afa34dcf7de60d0$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($5afa34dcf7de60d0$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($5afa34dcf7de60d0$var$Ma);
            } else q && a.push($5afa34dcf7de60d0$var$Ma);
            a.push($5afa34dcf7de60d0$var$K);
            $5afa34dcf7de60d0$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($5afa34dcf7de60d0$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($5afa34dcf7de60d0$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($5afa34dcf7de60d0$var$k(91));
                default:
                    $5afa34dcf7de60d0$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($5afa34dcf7de60d0$var$K);
            if (null != r) {
                if (null != e) throw Error($5afa34dcf7de60d0$var$k(92));
                if ($5afa34dcf7de60d0$var$ra(r) && 1 < r.length) throw Error($5afa34dcf7de60d0$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($5afa34dcf7de60d0$var$Oa);
            null !== e && a.push($5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$C("" + e)));
            return null;
        case "input":
            a.push($5afa34dcf7de60d0$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($5afa34dcf7de60d0$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($5afa34dcf7de60d0$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $5afa34dcf7de60d0$var$J(a, d, g, q);
            }
            null !== r ? $5afa34dcf7de60d0$var$J(a, d, "checked", r) : null !== m && $5afa34dcf7de60d0$var$J(a, d, "checked", m);
            null !== e ? $5afa34dcf7de60d0$var$J(a, d, "value", e) : null !== h && $5afa34dcf7de60d0$var$J(a, d, "value", h);
            a.push($5afa34dcf7de60d0$var$Ka);
            return null;
        case "menuitem":
            a.push($5afa34dcf7de60d0$var$M("menuitem"));
            for(var A in c)if ($5afa34dcf7de60d0$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($5afa34dcf7de60d0$var$k(400));
                default:
                    $5afa34dcf7de60d0$var$J(a, d, A, e);
            }
            a.push($5afa34dcf7de60d0$var$K);
            return null;
        case "title":
            a.push($5afa34dcf7de60d0$var$M("title"));
            e = null;
            for(v in c)if ($5afa34dcf7de60d0$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($5afa34dcf7de60d0$var$k(434));
                default:
                    $5afa34dcf7de60d0$var$J(a, d, v, g);
            }
            a.push($5afa34dcf7de60d0$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($5afa34dcf7de60d0$var$M(b));
            g = e = null;
            for(m in c)if ($5afa34dcf7de60d0$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $5afa34dcf7de60d0$var$J(a, d, m, h);
            }
            a.push($5afa34dcf7de60d0$var$K);
            if (null != g) {
                if (null != e) throw Error($5afa34dcf7de60d0$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($5afa34dcf7de60d0$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($5afa34dcf7de60d0$var$Oa, $5afa34dcf7de60d0$var$u(c)) : a.push($5afa34dcf7de60d0$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($5afa34dcf7de60d0$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($5afa34dcf7de60d0$var$M(b));
            for(var F in c)if ($5afa34dcf7de60d0$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($5afa34dcf7de60d0$var$k(399, b));
                default:
                    $5afa34dcf7de60d0$var$J(a, d, F, e);
            }
            a.push($5afa34dcf7de60d0$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $5afa34dcf7de60d0$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($5afa34dcf7de60d0$var$Ra), $5afa34dcf7de60d0$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $5afa34dcf7de60d0$var$Na(a, c, b, d);
            a.push($5afa34dcf7de60d0$var$M(b));
            g = e = null;
            for(q in c)if ($5afa34dcf7de60d0$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $5afa34dcf7de60d0$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $5afa34dcf7de60d0$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($5afa34dcf7de60d0$var$H, $5afa34dcf7de60d0$var$u(q), $5afa34dcf7de60d0$var$I, $5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$C(h)), $5afa34dcf7de60d0$var$E);
            }
            a.push($5afa34dcf7de60d0$var$K);
            $5afa34dcf7de60d0$var$L(a, g, e);
            return e;
    }
}
var $5afa34dcf7de60d0$var$Ta = $5afa34dcf7de60d0$var$w("</"), $5afa34dcf7de60d0$var$Ua = $5afa34dcf7de60d0$var$w(">"), $5afa34dcf7de60d0$var$Va = $5afa34dcf7de60d0$var$w('<template id="'), $5afa34dcf7de60d0$var$Wa = $5afa34dcf7de60d0$var$w('"></template>'), $5afa34dcf7de60d0$var$Xa = $5afa34dcf7de60d0$var$w("<!--$-->"), $5afa34dcf7de60d0$var$Ya = $5afa34dcf7de60d0$var$w('<!--$?--><template id="'), $5afa34dcf7de60d0$var$Za = $5afa34dcf7de60d0$var$w('"></template>'), $5afa34dcf7de60d0$var$$a = $5afa34dcf7de60d0$var$w("<!--$!-->"), $5afa34dcf7de60d0$var$ab = $5afa34dcf7de60d0$var$w("<!--/$-->"), $5afa34dcf7de60d0$var$bb = $5afa34dcf7de60d0$var$w("<template"), $5afa34dcf7de60d0$var$cb = $5afa34dcf7de60d0$var$w('"'), $5afa34dcf7de60d0$var$db = $5afa34dcf7de60d0$var$w(' data-dgst="');
$5afa34dcf7de60d0$var$w(' data-msg="');
$5afa34dcf7de60d0$var$w(' data-stck="');
var $5afa34dcf7de60d0$var$eb = $5afa34dcf7de60d0$var$w("></template>");
function $5afa34dcf7de60d0$var$fb(a, b, c) {
    $5afa34dcf7de60d0$var$p(a, $5afa34dcf7de60d0$var$Ya);
    if (null === c) throw Error($5afa34dcf7de60d0$var$k(395));
    $5afa34dcf7de60d0$var$p(a, c);
    return $5afa34dcf7de60d0$var$t(a, $5afa34dcf7de60d0$var$Za);
}
var $5afa34dcf7de60d0$var$gb = $5afa34dcf7de60d0$var$w('<div hidden id="'), $5afa34dcf7de60d0$var$hb = $5afa34dcf7de60d0$var$w('">'), $5afa34dcf7de60d0$var$ib = $5afa34dcf7de60d0$var$w("</div>"), $5afa34dcf7de60d0$var$jb = $5afa34dcf7de60d0$var$w('<svg aria-hidden="true" style="display:none" id="'), $5afa34dcf7de60d0$var$kb = $5afa34dcf7de60d0$var$w('">'), $5afa34dcf7de60d0$var$lb = $5afa34dcf7de60d0$var$w("</svg>"), $5afa34dcf7de60d0$var$mb = $5afa34dcf7de60d0$var$w('<math aria-hidden="true" style="display:none" id="'), $5afa34dcf7de60d0$var$nb = $5afa34dcf7de60d0$var$w('">'), $5afa34dcf7de60d0$var$ob = $5afa34dcf7de60d0$var$w("</math>"), $5afa34dcf7de60d0$var$pb = $5afa34dcf7de60d0$var$w('<table hidden id="'), $5afa34dcf7de60d0$var$qb = $5afa34dcf7de60d0$var$w('">'), $5afa34dcf7de60d0$var$rb = $5afa34dcf7de60d0$var$w("</table>"), $5afa34dcf7de60d0$var$sb = $5afa34dcf7de60d0$var$w('<table hidden><tbody id="'), $5afa34dcf7de60d0$var$tb = $5afa34dcf7de60d0$var$w('">'), $5afa34dcf7de60d0$var$ub = $5afa34dcf7de60d0$var$w("</tbody></table>"), $5afa34dcf7de60d0$var$vb = $5afa34dcf7de60d0$var$w('<table hidden><tr id="'), $5afa34dcf7de60d0$var$wb = $5afa34dcf7de60d0$var$w('">'), $5afa34dcf7de60d0$var$xb = $5afa34dcf7de60d0$var$w("</tr></table>"), $5afa34dcf7de60d0$var$yb = $5afa34dcf7de60d0$var$w('<table hidden><colgroup id="'), $5afa34dcf7de60d0$var$zb = $5afa34dcf7de60d0$var$w('">'), $5afa34dcf7de60d0$var$Ab = $5afa34dcf7de60d0$var$w("</colgroup></table>");
function $5afa34dcf7de60d0$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $5afa34dcf7de60d0$var$p(a, $5afa34dcf7de60d0$var$gb), $5afa34dcf7de60d0$var$p(a, b.segmentPrefix), $5afa34dcf7de60d0$var$p(a, $5afa34dcf7de60d0$var$u(d.toString(16))), $5afa34dcf7de60d0$var$t(a, $5afa34dcf7de60d0$var$hb);
        case 2:
            return $5afa34dcf7de60d0$var$p(a, $5afa34dcf7de60d0$var$jb), $5afa34dcf7de60d0$var$p(a, b.segmentPrefix), $5afa34dcf7de60d0$var$p(a, $5afa34dcf7de60d0$var$u(d.toString(16))), $5afa34dcf7de60d0$var$t(a, $5afa34dcf7de60d0$var$kb);
        case 3:
            return $5afa34dcf7de60d0$var$p(a, $5afa34dcf7de60d0$var$mb), $5afa34dcf7de60d0$var$p(a, b.segmentPrefix), $5afa34dcf7de60d0$var$p(a, $5afa34dcf7de60d0$var$u(d.toString(16))), $5afa34dcf7de60d0$var$t(a, $5afa34dcf7de60d0$var$nb);
        case 4:
            return $5afa34dcf7de60d0$var$p(a, $5afa34dcf7de60d0$var$pb), $5afa34dcf7de60d0$var$p(a, b.segmentPrefix), $5afa34dcf7de60d0$var$p(a, $5afa34dcf7de60d0$var$u(d.toString(16))), $5afa34dcf7de60d0$var$t(a, $5afa34dcf7de60d0$var$qb);
        case 5:
            return $5afa34dcf7de60d0$var$p(a, $5afa34dcf7de60d0$var$sb), $5afa34dcf7de60d0$var$p(a, b.segmentPrefix), $5afa34dcf7de60d0$var$p(a, $5afa34dcf7de60d0$var$u(d.toString(16))), $5afa34dcf7de60d0$var$t(a, $5afa34dcf7de60d0$var$tb);
        case 6:
            return $5afa34dcf7de60d0$var$p(a, $5afa34dcf7de60d0$var$vb), $5afa34dcf7de60d0$var$p(a, b.segmentPrefix), $5afa34dcf7de60d0$var$p(a, $5afa34dcf7de60d0$var$u(d.toString(16))), $5afa34dcf7de60d0$var$t(a, $5afa34dcf7de60d0$var$wb);
        case 7:
            return $5afa34dcf7de60d0$var$p(a, $5afa34dcf7de60d0$var$yb), $5afa34dcf7de60d0$var$p(a, b.segmentPrefix), $5afa34dcf7de60d0$var$p(a, $5afa34dcf7de60d0$var$u(d.toString(16))), $5afa34dcf7de60d0$var$t(a, $5afa34dcf7de60d0$var$zb);
        default:
            throw Error($5afa34dcf7de60d0$var$k(397));
    }
}
function $5afa34dcf7de60d0$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $5afa34dcf7de60d0$var$t(a, $5afa34dcf7de60d0$var$ib);
        case 2:
            return $5afa34dcf7de60d0$var$t(a, $5afa34dcf7de60d0$var$lb);
        case 3:
            return $5afa34dcf7de60d0$var$t(a, $5afa34dcf7de60d0$var$ob);
        case 4:
            return $5afa34dcf7de60d0$var$t(a, $5afa34dcf7de60d0$var$rb);
        case 5:
            return $5afa34dcf7de60d0$var$t(a, $5afa34dcf7de60d0$var$ub);
        case 6:
            return $5afa34dcf7de60d0$var$t(a, $5afa34dcf7de60d0$var$xb);
        case 7:
            return $5afa34dcf7de60d0$var$t(a, $5afa34dcf7de60d0$var$Ab);
        default:
            throw Error($5afa34dcf7de60d0$var$k(397));
    }
}
var $5afa34dcf7de60d0$var$Db = $5afa34dcf7de60d0$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $5afa34dcf7de60d0$var$Eb = $5afa34dcf7de60d0$var$w('$RS("'), $5afa34dcf7de60d0$var$Gb = $5afa34dcf7de60d0$var$w('","'), $5afa34dcf7de60d0$var$Hb = $5afa34dcf7de60d0$var$w('")</script>'), $5afa34dcf7de60d0$var$Ib = $5afa34dcf7de60d0$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $5afa34dcf7de60d0$var$Jb = $5afa34dcf7de60d0$var$w('$RC("'), $5afa34dcf7de60d0$var$Kb = $5afa34dcf7de60d0$var$w('","'), $5afa34dcf7de60d0$var$Lb = $5afa34dcf7de60d0$var$w('")</script>'), $5afa34dcf7de60d0$var$Mb = $5afa34dcf7de60d0$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $5afa34dcf7de60d0$var$Nb = $5afa34dcf7de60d0$var$w('$RX("'), $5afa34dcf7de60d0$var$Ob = $5afa34dcf7de60d0$var$w('"'), $5afa34dcf7de60d0$var$Pb = $5afa34dcf7de60d0$var$w(")</script>"), $5afa34dcf7de60d0$var$Qb = $5afa34dcf7de60d0$var$w(","), $5afa34dcf7de60d0$var$Rb = /[<\u2028\u2029]/g;
function $5afa34dcf7de60d0$var$Sb(a) {
    return JSON.stringify(a).replace($5afa34dcf7de60d0$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $5afa34dcf7de60d0$var$N = Object.assign, $5afa34dcf7de60d0$var$Tb = Symbol.for("react.element"), $5afa34dcf7de60d0$var$Ub = Symbol.for("react.portal"), $5afa34dcf7de60d0$var$Vb = Symbol.for("react.fragment"), $5afa34dcf7de60d0$var$Wb = Symbol.for("react.strict_mode"), $5afa34dcf7de60d0$var$Xb = Symbol.for("react.profiler"), $5afa34dcf7de60d0$var$Yb = Symbol.for("react.provider"), $5afa34dcf7de60d0$var$Zb = Symbol.for("react.context"), $5afa34dcf7de60d0$var$$b = Symbol.for("react.forward_ref"), $5afa34dcf7de60d0$var$ac = Symbol.for("react.suspense"), $5afa34dcf7de60d0$var$bc = Symbol.for("react.suspense_list"), $5afa34dcf7de60d0$var$cc = Symbol.for("react.memo"), $5afa34dcf7de60d0$var$dc = Symbol.for("react.lazy"), $5afa34dcf7de60d0$var$ec = Symbol.for("react.scope"), $5afa34dcf7de60d0$var$fc = Symbol.for("react.debug_trace_mode"), $5afa34dcf7de60d0$var$gc = Symbol.for("react.legacy_hidden"), $5afa34dcf7de60d0$var$hc = Symbol.for("react.default_value"), $5afa34dcf7de60d0$var$ic = Symbol.iterator;
function $5afa34dcf7de60d0$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $5afa34dcf7de60d0$var$Vb:
            return "Fragment";
        case $5afa34dcf7de60d0$var$Ub:
            return "Portal";
        case $5afa34dcf7de60d0$var$Xb:
            return "Profiler";
        case $5afa34dcf7de60d0$var$Wb:
            return "StrictMode";
        case $5afa34dcf7de60d0$var$ac:
            return "Suspense";
        case $5afa34dcf7de60d0$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $5afa34dcf7de60d0$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $5afa34dcf7de60d0$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $5afa34dcf7de60d0$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $5afa34dcf7de60d0$var$cc:
            return b = a.displayName || null, null !== b ? b : $5afa34dcf7de60d0$var$jc(a.type) || "Memo";
        case $5afa34dcf7de60d0$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $5afa34dcf7de60d0$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $5afa34dcf7de60d0$var$kc = {};
function $5afa34dcf7de60d0$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $5afa34dcf7de60d0$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $5afa34dcf7de60d0$var$O = null;
function $5afa34dcf7de60d0$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($5afa34dcf7de60d0$var$k(401));
        } else {
            if (null === c) throw Error($5afa34dcf7de60d0$var$k(401));
            $5afa34dcf7de60d0$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $5afa34dcf7de60d0$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $5afa34dcf7de60d0$var$mc(a);
}
function $5afa34dcf7de60d0$var$nc(a) {
    var b = a.parent;
    null !== b && $5afa34dcf7de60d0$var$nc(b);
    a.context._currentValue = a.value;
}
function $5afa34dcf7de60d0$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($5afa34dcf7de60d0$var$k(402));
    a.depth === b.depth ? $5afa34dcf7de60d0$var$P(a, b) : $5afa34dcf7de60d0$var$oc(a, b);
}
function $5afa34dcf7de60d0$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($5afa34dcf7de60d0$var$k(402));
    a.depth === c.depth ? $5afa34dcf7de60d0$var$P(a, c) : $5afa34dcf7de60d0$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $5afa34dcf7de60d0$var$Q(a) {
    var b = $5afa34dcf7de60d0$var$O;
    b !== a && (null === b ? $5afa34dcf7de60d0$var$nc(a) : null === a ? $5afa34dcf7de60d0$var$mc(b) : b.depth === a.depth ? $5afa34dcf7de60d0$var$P(b, a) : b.depth > a.depth ? $5afa34dcf7de60d0$var$oc(b, a) : $5afa34dcf7de60d0$var$pc(b, a), $5afa34dcf7de60d0$var$O = a);
}
var $5afa34dcf7de60d0$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $5afa34dcf7de60d0$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $5afa34dcf7de60d0$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $5afa34dcf7de60d0$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $5afa34dcf7de60d0$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $5afa34dcf7de60d0$var$N({}, e, h)) : $5afa34dcf7de60d0$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $5afa34dcf7de60d0$var$sc = {
    id: 1,
    overflow: ""
};
function $5afa34dcf7de60d0$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $5afa34dcf7de60d0$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $5afa34dcf7de60d0$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $5afa34dcf7de60d0$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $5afa34dcf7de60d0$var$uc = Math.clz32 ? Math.clz32 : $5afa34dcf7de60d0$var$vc, $5afa34dcf7de60d0$var$wc = Math.log, $5afa34dcf7de60d0$var$xc = Math.LN2;
function $5afa34dcf7de60d0$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($5afa34dcf7de60d0$var$wc(a) / $5afa34dcf7de60d0$var$xc | 0) | 0;
}
function $5afa34dcf7de60d0$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $5afa34dcf7de60d0$var$zc = "function" === typeof Object.is ? Object.is : $5afa34dcf7de60d0$var$yc, $5afa34dcf7de60d0$var$R = null, $5afa34dcf7de60d0$var$Ac = null, $5afa34dcf7de60d0$var$Bc = null, $5afa34dcf7de60d0$var$S = null, $5afa34dcf7de60d0$var$T = !1, $5afa34dcf7de60d0$var$Cc = !1, $5afa34dcf7de60d0$var$U = 0, $5afa34dcf7de60d0$var$V = null, $5afa34dcf7de60d0$var$Dc = 0;
function $5afa34dcf7de60d0$var$W() {
    if (null === $5afa34dcf7de60d0$var$R) throw Error($5afa34dcf7de60d0$var$k(321));
    return $5afa34dcf7de60d0$var$R;
}
function $5afa34dcf7de60d0$var$Ec() {
    if (0 < $5afa34dcf7de60d0$var$Dc) throw Error($5afa34dcf7de60d0$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $5afa34dcf7de60d0$var$Fc() {
    null === $5afa34dcf7de60d0$var$S ? null === $5afa34dcf7de60d0$var$Bc ? ($5afa34dcf7de60d0$var$T = !1, $5afa34dcf7de60d0$var$Bc = $5afa34dcf7de60d0$var$S = $5afa34dcf7de60d0$var$Ec()) : ($5afa34dcf7de60d0$var$T = !0, $5afa34dcf7de60d0$var$S = $5afa34dcf7de60d0$var$Bc) : null === $5afa34dcf7de60d0$var$S.next ? ($5afa34dcf7de60d0$var$T = !1, $5afa34dcf7de60d0$var$S = $5afa34dcf7de60d0$var$S.next = $5afa34dcf7de60d0$var$Ec()) : ($5afa34dcf7de60d0$var$T = !0, $5afa34dcf7de60d0$var$S = $5afa34dcf7de60d0$var$S.next);
    return $5afa34dcf7de60d0$var$S;
}
function $5afa34dcf7de60d0$var$Gc() {
    $5afa34dcf7de60d0$var$Ac = $5afa34dcf7de60d0$var$R = null;
    $5afa34dcf7de60d0$var$Cc = !1;
    $5afa34dcf7de60d0$var$Bc = null;
    $5afa34dcf7de60d0$var$Dc = 0;
    $5afa34dcf7de60d0$var$S = $5afa34dcf7de60d0$var$V = null;
}
function $5afa34dcf7de60d0$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $5afa34dcf7de60d0$var$Ic(a, b, c) {
    $5afa34dcf7de60d0$var$R = $5afa34dcf7de60d0$var$W();
    $5afa34dcf7de60d0$var$S = $5afa34dcf7de60d0$var$Fc();
    if ($5afa34dcf7de60d0$var$T) {
        var d = $5afa34dcf7de60d0$var$S.queue;
        b = d.dispatch;
        if (null !== $5afa34dcf7de60d0$var$V && (c = $5afa34dcf7de60d0$var$V.get(d), void 0 !== c)) {
            $5afa34dcf7de60d0$var$V.delete(d);
            d = $5afa34dcf7de60d0$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $5afa34dcf7de60d0$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $5afa34dcf7de60d0$var$S.memoizedState,
            b
        ];
    }
    a = a === $5afa34dcf7de60d0$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $5afa34dcf7de60d0$var$S.memoizedState = a;
    a = $5afa34dcf7de60d0$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $5afa34dcf7de60d0$var$Jc.bind(null, $5afa34dcf7de60d0$var$R, a);
    return [
        $5afa34dcf7de60d0$var$S.memoizedState,
        a
    ];
}
function $5afa34dcf7de60d0$var$Kc(a, b) {
    $5afa34dcf7de60d0$var$R = $5afa34dcf7de60d0$var$W();
    $5afa34dcf7de60d0$var$S = $5afa34dcf7de60d0$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $5afa34dcf7de60d0$var$S) {
        var c = $5afa34dcf7de60d0$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$5afa34dcf7de60d0$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $5afa34dcf7de60d0$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $5afa34dcf7de60d0$var$Jc(a, b, c) {
    if (25 <= $5afa34dcf7de60d0$var$Dc) throw Error($5afa34dcf7de60d0$var$k(301));
    if (a === $5afa34dcf7de60d0$var$R) {
        if ($5afa34dcf7de60d0$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $5afa34dcf7de60d0$var$V && ($5afa34dcf7de60d0$var$V = new Map), c = $5afa34dcf7de60d0$var$V.get(b), void 0 === c) $5afa34dcf7de60d0$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $5afa34dcf7de60d0$var$Lc() {
    throw Error($5afa34dcf7de60d0$var$k(394));
}
function $5afa34dcf7de60d0$var$Mc() {}
var $5afa34dcf7de60d0$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $5afa34dcf7de60d0$var$W();
        return a._currentValue;
    },
    useMemo: $5afa34dcf7de60d0$var$Kc,
    useReducer: $5afa34dcf7de60d0$var$Ic,
    useRef: function(a) {
        $5afa34dcf7de60d0$var$R = $5afa34dcf7de60d0$var$W();
        $5afa34dcf7de60d0$var$S = $5afa34dcf7de60d0$var$Fc();
        var b = $5afa34dcf7de60d0$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $5afa34dcf7de60d0$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $5afa34dcf7de60d0$var$Ic($5afa34dcf7de60d0$var$Hc, a);
    },
    useInsertionEffect: $5afa34dcf7de60d0$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $5afa34dcf7de60d0$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $5afa34dcf7de60d0$var$Mc,
    useEffect: $5afa34dcf7de60d0$var$Mc,
    useDebugValue: $5afa34dcf7de60d0$var$Mc,
    useDeferredValue: function(a) {
        $5afa34dcf7de60d0$var$W();
        return a;
    },
    useTransition: function() {
        $5afa34dcf7de60d0$var$W();
        return [
            !1,
            $5afa34dcf7de60d0$var$Lc
        ];
    },
    useId: function() {
        var a = $5afa34dcf7de60d0$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $5afa34dcf7de60d0$var$uc(a) - 1)).toString(32) + b;
        var c = $5afa34dcf7de60d0$var$Nc;
        if (null === c) throw Error($5afa34dcf7de60d0$var$k(404));
        b = $5afa34dcf7de60d0$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $5afa34dcf7de60d0$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($5afa34dcf7de60d0$var$k(407));
        return c();
    }
}, $5afa34dcf7de60d0$var$Nc = null, $5afa34dcf7de60d0$var$Pc = $81g6h.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $5afa34dcf7de60d0$var$Qc(a) {
    console.error(a);
    return null;
}
function $5afa34dcf7de60d0$var$X() {}
function $5afa34dcf7de60d0$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $5afa34dcf7de60d0$var$Qc : f,
        onAllReady: void 0 === e ? $5afa34dcf7de60d0$var$X : e,
        onShellReady: void 0 === g ? $5afa34dcf7de60d0$var$X : g,
        onShellError: void 0 === h ? $5afa34dcf7de60d0$var$X : h,
        onFatalError: void 0 === m ? $5afa34dcf7de60d0$var$X : m
    };
    c = $5afa34dcf7de60d0$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $5afa34dcf7de60d0$var$Tc(b, a, null, c, r, $5afa34dcf7de60d0$var$kc, null, $5afa34dcf7de60d0$var$sc);
    q.push(a);
    return b;
}
function $5afa34dcf7de60d0$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $5afa34dcf7de60d0$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $5afa34dcf7de60d0$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $5afa34dcf7de60d0$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $5afa34dcf7de60d0$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $5afa34dcf7de60d0$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $5afa34dcf7de60d0$var$Wc(a, b, c, d, f) {
    $5afa34dcf7de60d0$var$R = {};
    $5afa34dcf7de60d0$var$Ac = b;
    $5afa34dcf7de60d0$var$U = 0;
    for(a = c(d, f); $5afa34dcf7de60d0$var$Cc;)$5afa34dcf7de60d0$var$Cc = !1, $5afa34dcf7de60d0$var$U = 0, $5afa34dcf7de60d0$var$Dc += 1, $5afa34dcf7de60d0$var$S = null, a = c(d, f);
    $5afa34dcf7de60d0$var$Gc();
    return a;
}
function $5afa34dcf7de60d0$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($5afa34dcf7de60d0$var$k(108, $5afa34dcf7de60d0$var$jc(d) || "Unknown", h));
            d = $5afa34dcf7de60d0$var$N({}, g, c);
        }
        b.legacyContext = d;
        $5afa34dcf7de60d0$var$Z(a, b, f);
        b.legacyContext = g;
    } else $5afa34dcf7de60d0$var$Z(a, b, f);
}
function $5afa34dcf7de60d0$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $5afa34dcf7de60d0$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $5afa34dcf7de60d0$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $5afa34dcf7de60d0$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $5afa34dcf7de60d0$var$rc(e, c, d, f);
            $5afa34dcf7de60d0$var$Xc(a, b, e, c);
        } else {
            e = $5afa34dcf7de60d0$var$lc(c, b.legacyContext);
            f = $5afa34dcf7de60d0$var$Wc(a, b, c, d, e);
            var g = 0 !== $5afa34dcf7de60d0$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $5afa34dcf7de60d0$var$rc(f, c, d, e), $5afa34dcf7de60d0$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $5afa34dcf7de60d0$var$tc(d, 1, 0);
                try {
                    $5afa34dcf7de60d0$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $5afa34dcf7de60d0$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $5afa34dcf7de60d0$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $5afa34dcf7de60d0$var$Ba(g, c, d);
        $5afa34dcf7de60d0$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($5afa34dcf7de60d0$var$Ta, $5afa34dcf7de60d0$var$u(c), $5afa34dcf7de60d0$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $5afa34dcf7de60d0$var$gc:
            case $5afa34dcf7de60d0$var$fc:
            case $5afa34dcf7de60d0$var$Wb:
            case $5afa34dcf7de60d0$var$Xb:
            case $5afa34dcf7de60d0$var$Vb:
                $5afa34dcf7de60d0$var$Z(a, b, d.children);
                return;
            case $5afa34dcf7de60d0$var$bc:
                $5afa34dcf7de60d0$var$Z(a, b, d.children);
                return;
            case $5afa34dcf7de60d0$var$ec:
                throw Error($5afa34dcf7de60d0$var$k(343));
            case $5afa34dcf7de60d0$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $5afa34dcf7de60d0$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $5afa34dcf7de60d0$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($5afa34dcf7de60d0$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($5afa34dcf7de60d0$var$Ca), q.status = 1, $5afa34dcf7de60d0$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $5afa34dcf7de60d0$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $5afa34dcf7de60d0$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $5afa34dcf7de60d0$var$$b:
                d = $5afa34dcf7de60d0$var$Wc(a, b, c.render, d, f);
                if (0 !== $5afa34dcf7de60d0$var$U) {
                    c = b.treeContext;
                    b.treeContext = $5afa34dcf7de60d0$var$tc(c, 1, 0);
                    try {
                        $5afa34dcf7de60d0$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $5afa34dcf7de60d0$var$Z(a, b, d);
                return;
            case $5afa34dcf7de60d0$var$cc:
                c = c.type;
                d = $5afa34dcf7de60d0$var$Yc(c, d);
                $5afa34dcf7de60d0$var$Zc(a, b, c, d, f);
                return;
            case $5afa34dcf7de60d0$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $5afa34dcf7de60d0$var$O;
                $5afa34dcf7de60d0$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $5afa34dcf7de60d0$var$Z(a, b, f);
                a = $5afa34dcf7de60d0$var$O;
                if (null === a) throw Error($5afa34dcf7de60d0$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $5afa34dcf7de60d0$var$hc ? a.context._defaultValue : d;
                a = $5afa34dcf7de60d0$var$O = a.parent;
                b.context = a;
                return;
            case $5afa34dcf7de60d0$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $5afa34dcf7de60d0$var$Z(a, b, d);
                return;
            case $5afa34dcf7de60d0$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $5afa34dcf7de60d0$var$Yc(c, d);
                $5afa34dcf7de60d0$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($5afa34dcf7de60d0$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $5afa34dcf7de60d0$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $5afa34dcf7de60d0$var$Tb:
                $5afa34dcf7de60d0$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $5afa34dcf7de60d0$var$Ub:
                throw Error($5afa34dcf7de60d0$var$k(257));
            case $5afa34dcf7de60d0$var$dc:
                var d = c._init;
                c = d(c._payload);
                $5afa34dcf7de60d0$var$Z(a, b, c);
                return;
        }
        if ($5afa34dcf7de60d0$var$ra(c)) {
            $5afa34dcf7de60d0$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $5afa34dcf7de60d0$var$ic && c[$5afa34dcf7de60d0$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $5afa34dcf7de60d0$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($5afa34dcf7de60d0$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $5afa34dcf7de60d0$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $5afa34dcf7de60d0$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $5afa34dcf7de60d0$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $5afa34dcf7de60d0$var$tc(e, d, f);
        try {
            $5afa34dcf7de60d0$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $5afa34dcf7de60d0$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $5afa34dcf7de60d0$var$Z(a, b, c);
    } catch (m) {
        if ($5afa34dcf7de60d0$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $5afa34dcf7de60d0$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $5afa34dcf7de60d0$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $5afa34dcf7de60d0$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $5afa34dcf7de60d0$var$Q(e), m;
    }
}
function $5afa34dcf7de60d0$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $5afa34dcf7de60d0$var$dd(this, b, a);
}
function $5afa34dcf7de60d0$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($5afa34dcf7de60d0$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $5afa34dcf7de60d0$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $5afa34dcf7de60d0$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $5afa34dcf7de60d0$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $5afa34dcf7de60d0$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($5afa34dcf7de60d0$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $5afa34dcf7de60d0$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $5afa34dcf7de60d0$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($5afa34dcf7de60d0$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($5afa34dcf7de60d0$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $5afa34dcf7de60d0$var$Uc(a) {
    if (2 !== a.status) {
        var b = $5afa34dcf7de60d0$var$O, c = $5afa34dcf7de60d0$var$Pc.current;
        $5afa34dcf7de60d0$var$Pc.current = $5afa34dcf7de60d0$var$Oc;
        var d = $5afa34dcf7de60d0$var$Nc;
        $5afa34dcf7de60d0$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $5afa34dcf7de60d0$var$Q(g.context);
                    try {
                        $5afa34dcf7de60d0$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($5afa34dcf7de60d0$var$Ca), g.abortSet.delete(g), m.status = 1, $5afa34dcf7de60d0$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($5afa34dcf7de60d0$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $5afa34dcf7de60d0$var$Y(h, v);
                            null === r ? $5afa34dcf7de60d0$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $5afa34dcf7de60d0$var$fd(a, a.destination);
        } catch (G) {
            $5afa34dcf7de60d0$var$Y(a, G), $5afa34dcf7de60d0$var$Vc(a, G);
        } finally{
            $5afa34dcf7de60d0$var$Nc = d, $5afa34dcf7de60d0$var$Pc.current = c, c === $5afa34dcf7de60d0$var$Oc && $5afa34dcf7de60d0$var$Q(b);
        }
    }
}
function $5afa34dcf7de60d0$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $5afa34dcf7de60d0$var$p(b, $5afa34dcf7de60d0$var$Va);
            $5afa34dcf7de60d0$var$p(b, a.placeholderPrefix);
            a = $5afa34dcf7de60d0$var$u(d.toString(16));
            $5afa34dcf7de60d0$var$p(b, a);
            return $5afa34dcf7de60d0$var$t(b, $5afa34dcf7de60d0$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$5afa34dcf7de60d0$var$p(b, d[e]);
                f = $5afa34dcf7de60d0$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$5afa34dcf7de60d0$var$p(b, d[e]);
            e < d.length && (f = $5afa34dcf7de60d0$var$t(b, d[e]));
            return f;
        default:
            throw Error($5afa34dcf7de60d0$var$k(390));
    }
}
function $5afa34dcf7de60d0$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $5afa34dcf7de60d0$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $5afa34dcf7de60d0$var$t(b, $5afa34dcf7de60d0$var$$a), $5afa34dcf7de60d0$var$p(b, $5afa34dcf7de60d0$var$bb), d && ($5afa34dcf7de60d0$var$p(b, $5afa34dcf7de60d0$var$db), $5afa34dcf7de60d0$var$p(b, $5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$C(d))), $5afa34dcf7de60d0$var$p(b, $5afa34dcf7de60d0$var$cb)), $5afa34dcf7de60d0$var$t(b, $5afa34dcf7de60d0$var$eb), $5afa34dcf7de60d0$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $5afa34dcf7de60d0$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $5afa34dcf7de60d0$var$fb(b, a.responseState, d);
        $5afa34dcf7de60d0$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $5afa34dcf7de60d0$var$fb(b, a.responseState, d.id), $5afa34dcf7de60d0$var$gd(a, b, c);
    else {
        $5afa34dcf7de60d0$var$t(b, $5afa34dcf7de60d0$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($5afa34dcf7de60d0$var$k(391));
        $5afa34dcf7de60d0$var$hd(a, b, c[0]);
    }
    return $5afa34dcf7de60d0$var$t(b, $5afa34dcf7de60d0$var$ab);
}
function $5afa34dcf7de60d0$var$id(a, b, c) {
    $5afa34dcf7de60d0$var$Bb(b, a.responseState, c.formatContext, c.id);
    $5afa34dcf7de60d0$var$hd(a, b, c);
    return $5afa34dcf7de60d0$var$Cb(b, c.formatContext);
}
function $5afa34dcf7de60d0$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$5afa34dcf7de60d0$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $5afa34dcf7de60d0$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $5afa34dcf7de60d0$var$p(b, $5afa34dcf7de60d0$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $5afa34dcf7de60d0$var$p(b, $5afa34dcf7de60d0$var$Ib));
    if (null === d) throw Error($5afa34dcf7de60d0$var$k(395));
    c = $5afa34dcf7de60d0$var$u(c.toString(16));
    $5afa34dcf7de60d0$var$p(b, d);
    $5afa34dcf7de60d0$var$p(b, $5afa34dcf7de60d0$var$Kb);
    $5afa34dcf7de60d0$var$p(b, a.segmentPrefix);
    $5afa34dcf7de60d0$var$p(b, c);
    return $5afa34dcf7de60d0$var$t(b, $5afa34dcf7de60d0$var$Lb);
}
function $5afa34dcf7de60d0$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($5afa34dcf7de60d0$var$k(392));
        return $5afa34dcf7de60d0$var$id(a, b, d);
    }
    $5afa34dcf7de60d0$var$id(a, b, d);
    a = a.responseState;
    $5afa34dcf7de60d0$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $5afa34dcf7de60d0$var$p(b, $5afa34dcf7de60d0$var$Eb) : (a.sentCompleteSegmentFunction = !0, $5afa34dcf7de60d0$var$p(b, $5afa34dcf7de60d0$var$Db));
    $5afa34dcf7de60d0$var$p(b, a.segmentPrefix);
    f = $5afa34dcf7de60d0$var$u(f.toString(16));
    $5afa34dcf7de60d0$var$p(b, f);
    $5afa34dcf7de60d0$var$p(b, $5afa34dcf7de60d0$var$Gb);
    $5afa34dcf7de60d0$var$p(b, a.placeholderPrefix);
    $5afa34dcf7de60d0$var$p(b, f);
    return $5afa34dcf7de60d0$var$t(b, $5afa34dcf7de60d0$var$Hb);
}
function $5afa34dcf7de60d0$var$fd(a, b) {
    $5afa34dcf7de60d0$var$l = new Uint8Array(512);
    $5afa34dcf7de60d0$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $5afa34dcf7de60d0$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$5afa34dcf7de60d0$var$p(b, d[c]);
            c < d.length && $5afa34dcf7de60d0$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $5afa34dcf7de60d0$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $5afa34dcf7de60d0$var$p(d, $5afa34dcf7de60d0$var$Nb) : (h.sentClientRenderFunction = !0, $5afa34dcf7de60d0$var$p(d, $5afa34dcf7de60d0$var$Mb));
            if (null === m) throw Error($5afa34dcf7de60d0$var$k(395));
            $5afa34dcf7de60d0$var$p(d, m);
            $5afa34dcf7de60d0$var$p(d, $5afa34dcf7de60d0$var$Ob);
            if (q || r || v) $5afa34dcf7de60d0$var$p(d, $5afa34dcf7de60d0$var$Qb), $5afa34dcf7de60d0$var$p(d, $5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$Sb(q || "")));
            if (r || v) $5afa34dcf7de60d0$var$p(d, $5afa34dcf7de60d0$var$Qb), $5afa34dcf7de60d0$var$p(d, $5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$Sb(r || "")));
            v && ($5afa34dcf7de60d0$var$p(d, $5afa34dcf7de60d0$var$Qb), $5afa34dcf7de60d0$var$p(d, $5afa34dcf7de60d0$var$u($5afa34dcf7de60d0$var$Sb(v))));
            if (!$5afa34dcf7de60d0$var$t(d, $5afa34dcf7de60d0$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$5afa34dcf7de60d0$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $5afa34dcf7de60d0$var$ba(b);
        $5afa34dcf7de60d0$var$l = new Uint8Array(512);
        $5afa34dcf7de60d0$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$5afa34dcf7de60d0$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$5afa34dcf7de60d0$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $5afa34dcf7de60d0$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $5afa34dcf7de60d0$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $5afa34dcf7de60d0$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $5afa34dcf7de60d0$var$fd(a, a.destination);
    } catch (d) {
        $5afa34dcf7de60d0$var$Y(a, d), $5afa34dcf7de60d0$var$Vc(a, d);
    }
}
$5afa34dcf7de60d0$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $5afa34dcf7de60d0$var$Rc(a, $5afa34dcf7de60d0$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $5afa34dcf7de60d0$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $5afa34dcf7de60d0$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $5afa34dcf7de60d0$var$fd(h, a);
                        } catch (A) {
                            $5afa34dcf7de60d0$var$Y(h, A), $5afa34dcf7de60d0$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $5afa34dcf7de60d0$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $5afa34dcf7de60d0$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $5afa34dcf7de60d0$var$Uc(h);
    });
};
$5afa34dcf7de60d0$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("22plg", function(module, exports) {

$parcel$export(module.exports, "useResizeDetector", () => $17bf6d100f12215c$export$453c3d1cba18d800);

var $81g6h = parcelRequire("81g6h");

var $Q1dTY = parcelRequire("Q1dTY");

var $7KdWo = parcelRequire("7KdWo");

var $4wMZc = parcelRequire("4wMZc");
/* global Reflect, Promise, SuppressedError, Symbol */ var $17bf6d100f12215c$var$extendStatics = function(d, b) {
    $17bf6d100f12215c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $17bf6d100f12215c$var$extendStatics(d, b);
};
function $17bf6d100f12215c$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $17bf6d100f12215c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $17bf6d100f12215c$var$__assign = function() {
    $17bf6d100f12215c$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $17bf6d100f12215c$var$__assign.apply(this, arguments);
};
function $17bf6d100f12215c$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;
var $17bf6d100f12215c$var$patchResizeCallback = function(resizeCallback, refreshMode, refreshRate, refreshOptions) {
    switch(refreshMode){
        case "debounce":
            return (0, (/*@__PURE__*/$parcel$interopDefault($7KdWo)))(resizeCallback, refreshRate, refreshOptions);
        case "throttle":
            return (0, (/*@__PURE__*/$parcel$interopDefault($4wMZc)))(resizeCallback, refreshRate, refreshOptions);
        default:
            return resizeCallback;
    }
};
var $17bf6d100f12215c$var$isFunction = function(fn) {
    return typeof fn === "function";
};
var $17bf6d100f12215c$var$isSSR = function() {
    return typeof window === "undefined";
};
var $17bf6d100f12215c$var$isDOMElement = function(element) {
    return element instanceof Element || element instanceof HTMLDocument;
};
var $17bf6d100f12215c$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    $17bf6d100f12215c$var$__extends(ResizeDetector, _super);
    function ResizeDetector(props) {
        var _this = _super.call(this, props) || this;
        _this.cancelHandler = function() {
            if (_this.resizeHandler && _this.resizeHandler.cancel) {
                // cancel debounced handler
                _this.resizeHandler.cancel();
                _this.resizeHandler = null;
            }
        };
        _this.attachObserver = function() {
            var _a = _this.props, targetRef = _a.targetRef, observerOptions = _a.observerOptions;
            if ($17bf6d100f12215c$var$isSSR()) return;
            if (targetRef && targetRef.current) _this.targetRef.current = targetRef.current;
            var element = _this.getElement();
            if (!element) // can't find element to observe
            return;
            if (_this.observableElement && _this.observableElement === element) // element is already observed
            return;
            _this.observableElement = element;
            _this.resizeObserver.observe(element, observerOptions);
        };
        _this.getElement = function() {
            var _a = _this.props, querySelector = _a.querySelector, targetDomEl = _a.targetDomEl;
            if ($17bf6d100f12215c$var$isSSR()) return null;
            // in case we pass a querySelector
            if (querySelector) return document.querySelector(querySelector);
            // in case we pass a DOM element
            if (targetDomEl && $17bf6d100f12215c$var$isDOMElement(targetDomEl)) return targetDomEl;
            // in case we pass a React ref using React.createRef()
            if (_this.targetRef && $17bf6d100f12215c$var$isDOMElement(_this.targetRef.current)) return _this.targetRef.current;
            // the worse case when we don't receive any information from the parent and the library doesn't add any wrappers
            // we have to use a deprecated `findDOMNode` method in order to find a DOM element to attach to
            var currentElement = (0, $Q1dTY.findDOMNode)(_this);
            if (!currentElement) return null;
            var renderType = _this.getRenderType();
            switch(renderType){
                case "renderProp":
                    return currentElement;
                case "childFunction":
                    return currentElement;
                case "child":
                    return currentElement;
                case "childArray":
                    return currentElement;
                default:
                    return currentElement.parentElement;
            }
        };
        _this.createResizeHandler = function(entries) {
            var _a = _this.props, _b = _a.handleWidth, handleWidth = _b === void 0 ? true : _b, _c = _a.handleHeight, handleHeight = _c === void 0 ? true : _c, onResize = _a.onResize;
            if (!handleWidth && !handleHeight) return;
            var notifyResize = function(_a) {
                var width = _a.width, height = _a.height;
                if (_this.state.width === width && _this.state.height === height) // skip if dimensions haven't changed
                return;
                if (_this.state.width === width && !handleHeight || _this.state.height === height && !handleWidth) // process `handleHeight/handleWidth` props
                return;
                onResize === null || onResize === void 0 || onResize(width, height);
                _this.setState({
                    width: width,
                    height: height
                });
            };
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !_this.skipOnMount && !$17bf6d100f12215c$var$isSSR();
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                _this.skipOnMount = false;
            });
        };
        _this.getRenderType = function() {
            var _a = _this.props, render = _a.render, children = _a.children;
            if ($17bf6d100f12215c$var$isFunction(render)) // DEPRECATED. Use `Child Function Pattern` instead
            return "renderProp";
            if ($17bf6d100f12215c$var$isFunction(children)) return "childFunction";
            if ((0, $81g6h.isValidElement)(children)) return "child";
            if (Array.isArray(children)) // DEPRECATED. Wrap children with a single parent
            return "childArray";
            // DEPRECATED. Use `Child Function Pattern` instead
            return "parent";
        };
        var skipOnMount = props.skipOnMount, refreshMode = props.refreshMode, _a = props.refreshRate, refreshRate = _a === void 0 ? 1000 : _a, refreshOptions = props.refreshOptions;
        _this.state = {
            width: undefined,
            height: undefined
        };
        _this.sizeRef = {
            current: _this.state
        };
        _this.skipOnMount = skipOnMount;
        _this.targetRef = (0, $81g6h.createRef)();
        _this.observableElement = null;
        if ($17bf6d100f12215c$var$isSSR()) return _this;
        _this.resizeHandler = $17bf6d100f12215c$var$patchResizeCallback(_this.createResizeHandler, refreshMode, refreshRate, refreshOptions);
        _this.resizeObserver = new window.ResizeObserver(_this.resizeHandler);
        return _this;
    }
    ResizeDetector.prototype.componentDidMount = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentDidUpdate = function() {
        this.attachObserver();
        this.sizeRef.current = this.state;
    };
    ResizeDetector.prototype.componentWillUnmount = function() {
        if ($17bf6d100f12215c$var$isSSR()) return;
        this.observableElement = null;
        this.resizeObserver.disconnect();
        this.cancelHandler();
    };
    ResizeDetector.prototype.render = function() {
        var _a = this.props, render = _a.render, children = _a.children, _b = _a.nodeType, WrapperTag = _b === void 0 ? "div" : _b;
        var _c = this.state, width = _c.width, height = _c.height;
        var childProps = {
            width: width,
            height: height,
            targetRef: this.targetRef
        };
        var renderType = this.getRenderType();
        switch(renderType){
            case "renderProp":
                return render === null || render === void 0 ? void 0 : render(childProps);
            case "childFunction":
                var childFunction = children;
                return childFunction === null || childFunction === void 0 ? void 0 : childFunction(childProps);
            case "child":
                // @TODO bug prone logic
                var child = children;
                if (child.type && typeof child.type === "string") {
                    // child is a native DOM elements such as div, span etc
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    childProps.targetRef;
                    var nativeProps = $17bf6d100f12215c$var$__rest(childProps, [
                        "targetRef"
                    ]);
                    return (0, $81g6h.cloneElement)(child, nativeProps);
                }
                // class or functional component otherwise
                return (0, $81g6h.cloneElement)(child, childProps);
            case "childArray":
                var childArray = children;
                return childArray.map(function(el) {
                    return !!el && (0, $81g6h.cloneElement)(el, childProps);
                });
            default:
                return (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement(WrapperTag, null);
        }
    };
    return ResizeDetector;
}((0, $81g6h.PureComponent));
function $17bf6d100f12215c$export$fa0519968090da40(ComponentInner, options) {
    if (options === void 0) options = {};
    var ResizeDetectorHOC = /** @class */ function(_super) {
        $17bf6d100f12215c$var$__extends(ResizeDetectorHOC, _super);
        function ResizeDetectorHOC() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ref = (0, $81g6h.createRef)();
            return _this;
        }
        ResizeDetectorHOC.prototype.render = function() {
            var _a = this.props, forwardedRef = _a.forwardedRef, rest = $17bf6d100f12215c$var$__rest(_a, [
                "forwardedRef"
            ]);
            var targetRef = forwardedRef !== null && forwardedRef !== void 0 ? forwardedRef : this.ref;
            return (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement($17bf6d100f12215c$export$2e2bcd8739ae039, $17bf6d100f12215c$var$__assign({}, options, {
                targetRef: targetRef
            }), (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement(ComponentInner, $17bf6d100f12215c$var$__assign({
                targetRef: targetRef
            }, rest)));
        };
        return ResizeDetectorHOC;
    }((0, $81g6h.Component));
    function forwardRefWrapper(props, ref) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement(ResizeDetectorHOC, $17bf6d100f12215c$var$__assign({}, props, {
            forwardedRef: ref
        }));
    }
    var name = ComponentInner.displayName || ComponentInner.name;
    forwardRefWrapper.displayName = "withResizeDetector(".concat(name, ")");
    return (0, $81g6h.forwardRef)(forwardRefWrapper);
}
function $17bf6d100f12215c$export$453c3d1cba18d800(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.skipOnMount, skipOnMount = _c === void 0 ? false : _c, refreshMode = _b.refreshMode, _d = _b.refreshRate, refreshRate = _d === void 0 ? 1000 : _d, refreshOptions = _b.refreshOptions, _e = _b.handleWidth, handleWidth = _e === void 0 ? true : _e, _f = _b.handleHeight, handleHeight = _f === void 0 ? true : _f, targetRef = _b.targetRef, observerOptions = _b.observerOptions, onResize = _b.onResize;
    var skipResize = (0, $81g6h.useRef)(skipOnMount);
    var _g = (0, $81g6h.useState)({
        width: undefined,
        height: undefined
    }), size = _g[0], setSize = _g[1];
    // we are going to use this ref to store the last element that was passed to the hook
    var _h = (0, $81g6h.useState)((targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) || null), refElement = _h[0], setRefElement = _h[1];
    // if targetRef is passed, we need to update the refElement
    // we have to use setTimeout because ref get assigned after the hook is called
    // in the future releases we are going to remove targetRef and force users to use ref returned by the hook
    if (targetRef) setTimeout(function() {
        if (targetRef.current !== refElement) setRefElement(targetRef.current);
    }, 0);
    // this is a callback that will be called every time the ref is changed
    // we call setState inside to trigger rerender
    var onRefChange = (0, $81g6h.useCallback)(function(node) {
        if (node !== refElement) setRefElement(node);
    }, [
        refElement
    ]);
    // adding `current` to make it compatible with useRef shape
    onRefChange.current = refElement;
    var shouldSetSize = (0, $81g6h.useCallback)(function(prevSize, nextSize) {
        if (prevSize.width === nextSize.width && prevSize.height === nextSize.height) // skip if dimensions haven't changed
        return false;
        if (prevSize.width === nextSize.width && !handleHeight || prevSize.height === nextSize.height && !handleWidth) // process `handleHeight/handleWidth` props
        return false;
        return true;
    }, [
        handleWidth,
        handleHeight
    ]);
    var resizeCallback = (0, $81g6h.useCallback)(function(entries) {
        if (!handleWidth && !handleHeight) return;
        if (skipResize.current) {
            skipResize.current = false;
            return;
        }
        entries.forEach(function(entry) {
            var _a = (entry === null || entry === void 0 ? void 0 : entry.contentRect) || {}, width = _a.width, height = _a.height;
            setSize(function(prevSize) {
                if (!shouldSetSize(prevSize, {
                    width: width,
                    height: height
                })) return prevSize;
                return {
                    width: width,
                    height: height
                };
            });
        });
    }, [
        handleWidth,
        handleHeight,
        skipResize,
        shouldSetSize
    ]);
    var resizeHandler = (0, $81g6h.useCallback)($17bf6d100f12215c$var$patchResizeCallback(resizeCallback, refreshMode, refreshRate, refreshOptions), [
        resizeCallback,
        refreshMode,
        refreshRate,
        refreshOptions
    ]);
    // on refElement change
    (0, $81g6h.useEffect)(function() {
        var resizeObserver;
        if (refElement) {
            resizeObserver = new window.ResizeObserver(resizeHandler);
            resizeObserver.observe(refElement, observerOptions);
        } else if (size.width || size.height) setSize({
            width: undefined,
            height: undefined
        });
        return function() {
            var _a, _b, _c;
            (_a = resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect) === null || _a === void 0 || _a.call(resizeObserver);
            (_c = (_b = resizeHandler).cancel) === null || _c === void 0 || _c.call(_b);
        };
    }, [
        resizeHandler,
        refElement
    ]);
    (0, $81g6h.useEffect)(function() {
        onResize === null || onResize === void 0 || onResize(size.width, size.height);
    }, [
        size
    ]);
    return $17bf6d100f12215c$var$__assign({
        ref: onRefChange
    }, size);
}

});
parcelRegister("7KdWo", function(module, exports) {

var $hQ52h = parcelRequire("hQ52h");

var $i5G4y = parcelRequire("i5G4y");

var $j3sau = parcelRequire("j3sau");
/** Error message constants. */ var $5a37a49eaa0af479$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5a37a49eaa0af479$var$nativeMax = Math.max, $5a37a49eaa0af479$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $5a37a49eaa0af479$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($5a37a49eaa0af479$var$FUNC_ERROR_TEXT);
    wait = $j3sau(wait) || 0;
    if ($hQ52h(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $5a37a49eaa0af479$var$nativeMax($j3sau(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $5a37a49eaa0af479$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $i5G4y();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($i5G4y());
    }
    function debounced() {
        var time = $i5G4y(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $5a37a49eaa0af479$var$debounce;

});
parcelRegister("hQ52h", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $cfcb32fba509530a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $cfcb32fba509530a$var$isObject;

});

parcelRegister("i5G4y", function(module, exports) {

var $5e9HU = parcelRequire("5e9HU");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $d2b954522b2e0216$var$now = function() {
    return $5e9HU.Date.now();
};
module.exports = $d2b954522b2e0216$var$now;

});
parcelRegister("5e9HU", function(module, exports) {

var $e30CW = parcelRequire("e30CW");
/** Detect free variable `self`. */ var $3ce5ca308e92393f$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $3ce5ca308e92393f$var$root = $e30CW || $3ce5ca308e92393f$var$freeSelf || Function("return this")();
module.exports = $3ce5ca308e92393f$var$root;

});
parcelRegister("e30CW", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $a3a1d5061c59c497$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $a3a1d5061c59c497$var$freeGlobal;

});



parcelRegister("j3sau", function(module, exports) {

var $dPHW6 = parcelRequire("dPHW6");

var $hQ52h = parcelRequire("hQ52h");

var $gIOnJ = parcelRequire("gIOnJ");
/** Used as references for various `Number` constants. */ var $ddf425c01d8ec88c$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $ddf425c01d8ec88c$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $ddf425c01d8ec88c$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $ddf425c01d8ec88c$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $ddf425c01d8ec88c$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $ddf425c01d8ec88c$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($gIOnJ(value)) return $ddf425c01d8ec88c$var$NAN;
    if ($hQ52h(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $hQ52h(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $dPHW6(value);
    var isBinary = $ddf425c01d8ec88c$var$reIsBinary.test(value);
    return isBinary || $ddf425c01d8ec88c$var$reIsOctal.test(value) ? $ddf425c01d8ec88c$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $ddf425c01d8ec88c$var$reIsBadHex.test(value) ? $ddf425c01d8ec88c$var$NAN : +value;
}
module.exports = $ddf425c01d8ec88c$var$toNumber;

});
parcelRegister("dPHW6", function(module, exports) {

var $9oVUs = parcelRequire("9oVUs");
/** Used to match leading whitespace. */ var $a1221e96c44fa360$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $a1221e96c44fa360$var$baseTrim(string) {
    return string ? string.slice(0, $9oVUs(string) + 1).replace($a1221e96c44fa360$var$reTrimStart, "") : string;
}
module.exports = $a1221e96c44fa360$var$baseTrim;

});
parcelRegister("9oVUs", function(module, exports) {
/** Used to match a single whitespace character. */ var $6d8346997cf87beb$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $6d8346997cf87beb$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $6d8346997cf87beb$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $6d8346997cf87beb$var$trimmedEndIndex;

});


parcelRegister("gIOnJ", function(module, exports) {

var $4gyi5 = parcelRequire("4gyi5");

var $gWhSo = parcelRequire("gWhSo");
/** `Object#toString` result references. */ var $c2c7d62de7e3806b$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $c2c7d62de7e3806b$var$isSymbol(value) {
    return typeof value == "symbol" || $gWhSo(value) && $4gyi5(value) == $c2c7d62de7e3806b$var$symbolTag;
}
module.exports = $c2c7d62de7e3806b$var$isSymbol;

});
parcelRegister("4gyi5", function(module, exports) {

var $j8v8o = parcelRequire("j8v8o");

var $8BuVw = parcelRequire("8BuVw");

var $jLUSd = parcelRequire("jLUSd");
/** `Object#toString` result references. */ var $31b3417b6762dd24$var$nullTag = "[object Null]", $31b3417b6762dd24$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $31b3417b6762dd24$var$symToStringTag = $j8v8o ? $j8v8o.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $31b3417b6762dd24$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $31b3417b6762dd24$var$undefinedTag : $31b3417b6762dd24$var$nullTag;
    return $31b3417b6762dd24$var$symToStringTag && $31b3417b6762dd24$var$symToStringTag in Object(value) ? $8BuVw(value) : $jLUSd(value);
}
module.exports = $31b3417b6762dd24$var$baseGetTag;

});
parcelRegister("j8v8o", function(module, exports) {

var $5e9HU = parcelRequire("5e9HU");
/** Built-in value references. */ var $dee6ea50a073b785$var$Symbol = $5e9HU.Symbol;
module.exports = $dee6ea50a073b785$var$Symbol;

});

parcelRegister("8BuVw", function(module, exports) {

var $j8v8o = parcelRequire("j8v8o");
/** Used for built-in method references. */ var $6439c4dc43c43c90$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6439c4dc43c43c90$var$hasOwnProperty = $6439c4dc43c43c90$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $6439c4dc43c43c90$var$nativeObjectToString = $6439c4dc43c43c90$var$objectProto.toString;
/** Built-in value references. */ var $6439c4dc43c43c90$var$symToStringTag = $j8v8o ? $j8v8o.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $6439c4dc43c43c90$var$getRawTag(value) {
    var isOwn = $6439c4dc43c43c90$var$hasOwnProperty.call(value, $6439c4dc43c43c90$var$symToStringTag), tag = value[$6439c4dc43c43c90$var$symToStringTag];
    try {
        value[$6439c4dc43c43c90$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $6439c4dc43c43c90$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$6439c4dc43c43c90$var$symToStringTag] = tag;
        else delete value[$6439c4dc43c43c90$var$symToStringTag];
    }
    return result;
}
module.exports = $6439c4dc43c43c90$var$getRawTag;

});

parcelRegister("jLUSd", function(module, exports) {
/** Used for built-in method references. */ var $e64e85fa63dd24ce$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e64e85fa63dd24ce$var$nativeObjectToString = $e64e85fa63dd24ce$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $e64e85fa63dd24ce$var$objectToString(value) {
    return $e64e85fa63dd24ce$var$nativeObjectToString.call(value);
}
module.exports = $e64e85fa63dd24ce$var$objectToString;

});


parcelRegister("gWhSo", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c54fedfd8256429f$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $c54fedfd8256429f$var$isObjectLike;

});




parcelRegister("4wMZc", function(module, exports) {

var $7KdWo = parcelRequire("7KdWo");

var $hQ52h = parcelRequire("hQ52h");
/** Error message constants. */ var $34c0262cf69783bf$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $34c0262cf69783bf$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($34c0262cf69783bf$var$FUNC_ERROR_TEXT);
    if ($hQ52h(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $7KdWo(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
module.exports = $34c0262cf69783bf$var$throttle;

});



parcelRegister("gVYTG", function(module, exports) {

$parcel$export(module.exports, "ConsentContainer", () => $5788218c4e76558d$export$d3dad333bafe0395);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");

var $68IWj = parcelRequire("68IWj");

var $1eHG3 = parcelRequire("1eHG3");

var $lDZlX = parcelRequire("lDZlX");

var $8FlUV = parcelRequire("8FlUV");

var $a6fIt = parcelRequire("a6fIt");
const $5788218c4e76558d$export$d3dad333bafe0395 = ({ control: control, isDirectAccess: isDirectAccess = false, documentsLocale: documentsLocale })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const termsOfUseUrl = `${(0, $lDZlX.RoutesPath).RegisterTermsOfUse}?locale=${encodeURIComponent(documentsLocale)}`;
    const privacyNoticeUrl = `${(0, $lDZlX.RoutesPath).RegisterPrivacyNotice}?locale=${encodeURIComponent(documentsLocale)}`;
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            isDirectAccess && /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                name: "agreeToLicensedPtConsent",
                control: control,
                rules: {
                    required: format("global.form.field.requiredError")
                },
                render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)($5788218c4e76558d$var$CheckboxContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $68IWj.Checkbox), {
                                        inputId: "agreeToLicensedPtConsent",
                                        ...field,
                                        checked: field.value
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                        htmlFor: "agreeToLicensedPtConsent",
                                        children: format("global.register.licensedPt.confirmation")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($5788218c4e76558d$var$StyledErrorMessage, {
                                children: fieldState.error?.message
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                name: "consent",
                control: control,
                rules: {
                    required: format("global.register.consent.tou.and.pn.required")
                },
                render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)($5788218c4e76558d$var$ConsentCheckboxContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $68IWj.Checkbox), {
                                        ...field,
                                        inputId: "consent",
                                        checked: field.value,
                                        id: (0, $a6fIt.e2eTestId).registerPt.consentCheckbox
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                        htmlFor: "consent",
                                        children: format("global.register.consent.tou.and.pn", {
                                            link: {
                                                className: "p-size-s-bold text-primary",
                                                onClick: (event)=>{
                                                    event.preventDefault();
                                                    window.open(termsOfUseUrl, "_blank");
                                                }
                                            },
                                            link2: {
                                                className: "p-size-s-bold text-primary",
                                                onClick: (event)=>{
                                                    event.preventDefault();
                                                    window.open(privacyNoticeUrl, "_blank");
                                                }
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($5788218c4e76558d$var$StyledErrorMessage, {
                                children: fieldState.error?.message
                            })
                        ]
                    })
            }),
            !isDirectAccess && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                        name: "agreeToPhysiomeEmails",
                        control: control,
                        render: ({ field: field })=>/*#__PURE__*/ (0, $iKObn.jsxs)($5788218c4e76558d$var$CheckboxContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $68IWj.Checkbox), {
                                        inputId: "mailPhysio",
                                        ...field,
                                        checked: field.value
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                        htmlFor: "mailPhysio",
                                        children: format("global.register.physiomeEmails.v1_6")
                                    })
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                        name: "agreeToBiogenEmails",
                        control: control,
                        render: ({ field: field })=>/*#__PURE__*/ (0, $iKObn.jsxs)($5788218c4e76558d$var$CheckboxContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $68IWj.Checkbox), {
                                        inputId: "mailBiogen",
                                        ...field,
                                        checked: field.value
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                        htmlFor: "mailBiogen",
                                        children: format("global.register.biogenEmails.v1_6")
                                    })
                                ]
                            })
                    })
                ]
            })
        ]
    });
};
const $5788218c4e76558d$var$CheckboxContainer = (0, $5UMQ1.default).div`
	display: flex;
	place-items: center;
	gap: 16px;
	margin-top: 12px;
`;
const $5788218c4e76558d$var$ConsentCheckboxContainer = (0, $5UMQ1.default)($5788218c4e76558d$var$CheckboxContainer)`
	margin-top: 24px;
`;
const $5788218c4e76558d$var$StyledErrorMessage = (0, $5UMQ1.default)((0, $8FlUV.ErrorMessage))`
	margin-top: 8px;
`;

});

parcelRegister("4Ms0E", function(module, exports) {

$parcel$export(module.exports, "CountryLanguagesField", () => $b49e9da24450bac6$export$b27272828f4a9050);

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $eKUeg = parcelRequire("eKUeg");

var $kY2I3 = parcelRequire("kY2I3");
const $b49e9da24450bac6$export$b27272828f4a9050 = ({ name: name, control: control, locales: locales, labelStyle: labelStyle })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
        name: name,
        control: control,
        render: ({ field: field })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                        style: labelStyle,
                        className: "p-size-m",
                        children: format("passwordField.countryLanguage.label")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $kY2I3.CountryLanguageInput), {
                        locales: locales,
                        placeholder: format("global.form.dropdown.placeholder"),
                        ...field
                    })
                ]
            })
    });
};

});

parcelRegister("70tpO", function(module, exports) {

$parcel$export(module.exports, "NotificationRow", () => $497d6ec7293aaad9$export$5d68a62471681b79);

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $5UMQ1 = parcelRequire("5UMQ1");

var $02Kb9 = parcelRequire("02Kb9");

var $5kXMA = parcelRequire("5kXMA");

var $1DH4E = parcelRequire("1DH4E");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");
var $497d6ec7293aaad9$var$CalendarIcon = function CalendarIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.677 5.773a.807.807 0 0 0-.807.807v12.647c0 .445.361.806.807.806h12.646a.807.807 0 0 0 .807-.806V6.58a.807.807 0 0 0-.807-.807H5.677ZM2.87 6.58a2.807 2.807 0 0 1 2.807-2.807h12.646A2.807 2.807 0 0 1 21.13 6.58v12.647a2.807 2.807 0 0 1-2.807 2.806H5.677a2.807 2.807 0 0 1-2.807-2.806V6.58Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.613 1.967a1 1 0 0 1 1 1V6.58a1 1 0 1 1-2 0V2.967a1 1 0 0 1 1-1ZM8.387 1.967a1 1 0 0 1 1 1V6.58a1 1 0 1 1-2 0V2.967a1 1 0 0 1 1-1ZM2.87 10.193a1 1 0 0 1 1-1h16.26a1 1 0 1 1 0 2H3.87a1 1 0 0 1-1-1Z",
                fill: "currentColor"
            })
        ]
    });
};
$497d6ec7293aaad9$var$CalendarIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $497d6ec7293aaad9$var$CheckIcon = function CheckIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.064 5.318c.449.449.449 1.177 0 1.626L9.325 18.683a1.15 1.15 0 0 1-1.626 0L2.936 13.92a1.15 1.15 0 0 1 1.627-1.627l3.95 3.95L19.437 5.318a1.15 1.15 0 0 1 1.626 0Z",
            fill: "currentColor"
        })
    });
};
$497d6ec7293aaad9$var$CheckIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $497d6ec7293aaad9$var$HctIcon = function HctIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M14 20H2c-1.1 0-2-.9-2-2v-1.5C0 13.6 4.73 12 8 12c-1.07 0-2.07-.42-2.83-1.17A4.004 4.004 0 0 1 4 8c0-1.05.43-2.08 1.17-2.83a4.011 4.011 0 0 1 5.66 0C11.58 5.92 12 6.93 12 8s-.43 2.08-1.17 2.83C10.09 11.57 9.06 12 8 12c3.27 0 8 1.6 8 4.5V18c0 1.1-.9 2-2 2Zm-6-6c-2.98 0-6 1.45-6 2.5V18h12v-1.5c0-1.05-3.02-2.5-6-2.5Zm0-8c-.53 0-1.04.21-1.41.58C6.22 6.95 6 7.47 6 8c0 .53.21 1.04.59 1.41.75.75 2.08.75 2.83 0 .37-.37.59-.89.59-1.42 0-.53-.21-1.04-.58-1.41-.37-.37-.89-.59-1.42-.59L8 6Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M16.6 4.41A3.586 3.586 0 0 0 13.02 8c0 .96.38 1.86 1.05 2.54a3.58 3.58 0 0 0 2.53 1.05c.95 0 1.86-.38 2.54-1.05.67-.67 1.05-1.58 1.05-2.54s-.38-1.86-1.05-2.54a3.586 3.586 0 0 0-2.54-1.05ZM17.476 13.13c-.34 0-.7.02-1.06.06 1.27.97 1.554 2.25 1.554 3.87v1.8c0 .56.45 1.01 1.01 1.01h3.39c.59 0 1.08-.5 1.08-1.12v-1.68c0-2.28-2.735-3.92-5.974-3.92v-.02Z",
                fill: "currentColor"
            })
        ]
    });
};
$497d6ec7293aaad9$var$HctIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $497d6ec7293aaad9$var$LoaderIcon = function LoaderIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M11.984 1.986A1 1 0 0 0 11 3v2a1 1 0 1 0 2 0V3a1.001 1.001 0 0 0-1.016-1.014Zm4.532 1.207a1 1 0 0 0-.881.512l-1 1.732a1 1 0 1 0 1.73 1l1-1.732a1 1 0 0 0-.85-1.512Zm-9.06.002a1 1 0 0 0-.821 1.51l1 1.732a1 1 0 1 0 1.73-1l-1-1.732a1 1 0 0 0-.91-.51ZM4.23 6.492a1 1 0 0 0-.525 1.873l1.732 1a1 1 0 1 0 1-1.73l-1.732-1a1 1 0 0 0-.475-.143Zm15.608.002a1 1 0 0 0-.543.14l-1.733 1a1 1 0 1 0 1 1.731l1.733-1a1 1 0 0 0-.457-1.87ZM3 11a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2H3Zm16 0a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm-.912 3.492c-.033 0-.067 0-.1.002a1 1 0 0 0-.425 1.871l1.732 1a1 1 0 1 0 1-1.73l-1.733-1a1 1 0 0 0-.474-.143Zm-12.106.002a1 1 0 0 0-.545.14l-1.732 1a1 1 0 1 0 1 1.731l1.732-1a1 1 0 0 0-.455-1.87Zm2.534 2.555a1 1 0 0 0-.881.514l-1 1.732a1 1 0 1 0 1.73 1l1-1.733a1 1 0 0 0-.85-1.513Zm6.94.002a1 1 0 0 0-.821 1.512l1 1.732a1 1 0 1 0 1.73-1l-1-1.733a1 1 0 0 0-.91-.511Zm-3.472.935A1 1 0 0 0 11 19v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1.016-1.014Z",
            fill: "currentColor"
        })
    });
};
$497d6ec7293aaad9$var$LoaderIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $497d6ec7293aaad9$var$MailOpenedIcon = function MailOpenedIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M20 22.52H4c-1.65 0-3-1.35-3-3V9.5c0-1.06.57-2.05 1.48-2.59l7.51-4.38c1.19-.71 2.82-.71 4.03 0l7.49 4.37c.92.54 1.49 1.53 1.49 2.59v10.03c0 1.65-1.35 3-3 3ZM12 3.99c-.35 0-.71.09-1 .27L3.49 8.63c-.3.18-.49.51-.49.86v10.03c0 .54.46 1 1 1h16c.54 0 1-.46 1-1V9.5a1 1 0 0 0-.5-.86L13 4.27c-.3-.18-.65-.27-1.01-.27l.01-.01Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.134 9.919a1 1 0 0 1 1.378-.315l4.956 3.113a1 1 0 0 0 1.064 0l4.956-3.113a1 1 0 0 1 1.063 1.694l-4.955 3.112a3 3 0 0 1-3.192 0L5.45 11.298a1 1 0 0 1-.315-1.38Z",
                fill: "currentColor"
            })
        ]
    });
};
$497d6ec7293aaad9$var$MailOpenedIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $497d6ec7293aaad9$var$MailClosedIcon = function MailClosedIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M20 21H4c-1.65 0-3-1.35-3-3V6c0-1.65 1.35-3 3-3h16c1.65 0 3 1.35 3 3v12c0 1.65-1.35 3-3 3ZM4 5c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H4Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.134 7.919a1 1 0 0 1 1.378-.315l4.956 3.113a1 1 0 0 0 1.064 0l4.956-3.113a1 1 0 1 1 1.063 1.694l-4.955 3.112a3 3 0 0 1-3.192 0L5.45 9.298a1 1 0 0 1-.315-1.38Z",
                fill: "currentColor"
            })
        ]
    });
};
$497d6ec7293aaad9$var$MailClosedIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $497d6ec7293aaad9$var$NotificationTypeToIcon = {
    PATIENT_PROGRAM_STARTED: $497d6ec7293aaad9$var$CalendarIcon,
    PATIENT_PROGRAM_ENDING_SOON: $497d6ec7293aaad9$var$CalendarIcon,
    PATIENT_PROGRAM_ENDED: $497d6ec7293aaad9$var$CalendarIcon,
    PATIENT_REGISTERED: $497d6ec7293aaad9$var$HctIcon,
    HCT_INVITATION_SENT: $497d6ec7293aaad9$var$HctIcon,
    HCT_INVITATION_ACCEPTED: $497d6ec7293aaad9$var$HctIcon,
    PT_ACCOUNT_VALIDATION_PENDING: $497d6ec7293aaad9$var$LoaderIcon,
    PT_ACCOUNT_VALIDATED: $497d6ec7293aaad9$var$CheckIcon,
    PATIENT_HAS_DELETED_HIS_ACCOUNT: $497d6ec7293aaad9$var$HctIcon,
    PT_LEFT_HCT: $497d6ec7293aaad9$var$HctIcon
};
const $497d6ec7293aaad9$export$5d68a62471681b79 = ({ notification: notification, separator: separator = false, debugOnClickOverride: debugOnClickOverride })=>{
    const { format: format, formatDateMed: formatDateMed } = (0, $1eHG3.useI18n)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const [isHovered, setIsHovered] = (0, $81g6h.useState)(false);
    const Icon = $497d6ec7293aaad9$var$NotificationTypeToIcon[notification.type];
    const MailIcon = notification.isRead ? $497d6ec7293aaad9$var$MailOpenedIcon : $497d6ec7293aaad9$var$MailClosedIcon;
    const { onNotificationClicked: onNotificationClicked, formatNotification: formatNotification } = (0, $1DH4E.useNotification)();
    const [toggleIsRead] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(async ()=>{
        if (notification.isRead) await (0, $ghfIB.notificationManager).markAsUnread(notification.id);
        else await (0, $ghfIB.notificationManager).markAsRead(notification.id);
        (0, $ghfIB.notificationBadgeManager).saveLastUnreadCount();
        (0, $ghfIB.analyticsService).trackEvent({
            category: (0, $auPqo.AnalyticsCategory).NOTIFICATIONS,
            action: notification.isRead ? "notificationRead" : "notificationUnRead",
            params: [
                notification.type
            ]
        });
    }, [
        notification.id,
        notification.isRead,
        notification.type
    ]), {});
    return /*#__PURE__*/ (0, $iKObn.jsx)($497d6ec7293aaad9$var$RowContainer, {
        onClick: (0, $lTdpc.isNotNil)(debugOnClickOverride) ? ()=>debugOnClickOverride(notification) : async ()=>await onNotificationClicked(notification, "notification-center"),
        separator: separator,
        isRead: notification.isRead,
        onMouseEnter: ()=>{
            setIsHovered(true);
        },
        onMouseOver: ()=>{
            setIsHovered(true);
        },
        onMouseLeave: ()=>{
            setIsHovered(false);
        },
        isHovered: isHovered,
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($497d6ec7293aaad9$var$Row, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsxs)($497d6ec7293aaad9$var$ContentContainer, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)($497d6ec7293aaad9$var$Dot, {
                            visible: !notification.isRead
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                            children: /*#__PURE__*/ (0, $iKObn.jsx)(Icon, {
                                width: 24,
                                height: 24,
                                color: (0, $kKnoQ.colors).primary
                            })
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                    children: formatNotification(notification)
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)($497d6ec7293aaad9$var$Timestamp, {
                                    className: "p-size-xs-semi-bold",
                                    children: formatDateMed(notification.creationDate)
                                })
                            ]
                        })
                    ]
                }),
                isHovered && isDesktop && /*#__PURE__*/ (0, $iKObn.jsx)($497d6ec7293aaad9$var$MailIconContainer, {
                    onClick: (e)=>{
                        e.stopPropagation();
                        toggleIsRead();
                    },
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $02Kb9.Tooltip), {
                        content: notification.isRead ? format("notificationCenter.list.row.markAsUnread.tooltip") : format("notificationCenter.list.row.markAsRead.tooltip"),
                        placement: "left",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                            children: /*#__PURE__*/ (0, $iKObn.jsx)(MailIcon, {
                                className: "mail-icon",
                                width: 16,
                                height: 16,
                                color: (0, $kKnoQ.colors).grey
                            })
                        })
                    })
                })
            ]
        })
    });
};
const $497d6ec7293aaad9$var$Timestamp = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).grey};
`;
const $497d6ec7293aaad9$var$getRowBackgroundColor = ({ isHovered: isHovered, isRead: isRead })=>{
    if (isHovered) return (0, $kKnoQ.colors).grey5;
    if (isRead) return (0, $kKnoQ.colors).white;
    return (0, $kKnoQ.colors).primaryBackground;
};
const $497d6ec7293aaad9$var$RowContainer = (0, $5UMQ1.default).div`
	cursor: pointer;
	padding: 16px;
	padding-right: 42px;
	border-bottom-color: ${(0, $kKnoQ.colors).grey25};
	border-bottom-style: solid;
	border-bottom-width: ${({ separator: separator })=>separator ? "1px" : 0};
	background-color: ${({ isRead: isRead, isHovered: isHovered })=>$497d6ec7293aaad9$var$getRowBackgroundColor({
        isRead: isRead,
        isHovered: isHovered
    })};
`;
const $497d6ec7293aaad9$var$Row = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("M", "spacebetween", "center")};
`;
const $497d6ec7293aaad9$var$ContentContainer = (0, $5UMQ1.default).div`
	display: flex;
	place-items: center;
	gap: 16px;
`;
const $497d6ec7293aaad9$var$Dot = (0, $5UMQ1.default).div`
	width: 8px;
	height: 8px;
	border-radius: 4px;
	background-color: ${({ visible: visible })=>visible && (0, $kKnoQ.colors).primary};
	flex-shrink: 0;
`;
const $497d6ec7293aaad9$var$MailIconContainer = (0, $5UMQ1.default).div`
	width: 24px;
	height: 24px;
	border-radius: 12px;
	display: grid;
	place-content: center;
	cursor: pointer;

	&:hover {
		background-color: ${(0, $kKnoQ.colors).grey10};
	}
`;

});
parcelRegister("1DH4E", function(module, exports) {

$parcel$export(module.exports, "useNotification", () => $00db59b2453c9d74$export$9949bd9c713ba425);

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $81g6h = parcelRequire("81g6h");
const $00db59b2453c9d74$export$9949bd9c713ba425 = ()=>{
    const navigate = (0, $htiSH.useNavigate)();
    const i18n = (0, $1eHG3.useI18n)();
    const formatNotification = (0, $81g6h.useCallback)((notification)=>notification.format(i18n), [
        i18n
    ]);
    const onNotificationClicked = (0, $81g6h.useCallback)(async (notification, location)=>{
        if (!notification.isRead) {
            await (0, $ghfIB.notificationManager).markAsRead(notification.id);
            (0, $ghfIB.notificationBadgeManager).saveLastUnreadCount();
        }
        notification.onClick(navigate);
        (0, $ghfIB.analyticsService).trackEvent({
            category: (0, $auPqo.AnalyticsCategory).NOTIFICATIONS,
            action: location === "notification-center" ? "clickNotification" : "clickNotificationToast",
            params: [
                notification.type
            ]
        });
    }, [
        navigate
    ]);
    return {
        onNotificationClicked: onNotificationClicked,
        formatNotification: formatNotification
    };
};

});


parcelRegister("7CwXm", function(module, exports) {

$parcel$export(module.exports, "NotificationSection", () => $31f668ac67b0ab3b$export$616e7bf1df373f5d);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
const $31f668ac67b0ab3b$export$616e7bf1df373f5d = ({ title: title, children: children })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($31f668ac67b0ab3b$var$SectionHeader, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($31f668ac67b0ab3b$var$Line, {}),
                    title,
                    /*#__PURE__*/ (0, $iKObn.jsx)($31f668ac67b0ab3b$var$Line, {})
                ]
            }),
            children
        ]
    });
const $31f668ac67b0ab3b$var$SectionHeader = (0, $5UMQ1.default).div`
	padding: 8px 0px;
	display: grid;
	grid-template-columns: 1fr auto 1fr;
	gap: 16px;
	align-items: center;
`;
const $31f668ac67b0ab3b$var$Line = (0, $5UMQ1.default).div`
	height: 1px;
	background-color: ${(0, $kKnoQ.colors).grey10};
`;

});

parcelRegister("9tyB9", function(module, exports) {

var $gwUeX = parcelRequire("gwUeX");
module.exports = $gwUeX("8nih1").then(()=>parcelRequire("l7PvM"));

});
parcelRegister("gwUeX", function(module, exports) {
"use strict";

function $c08b42aa936f5dc6$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("36v5Z")).resolve(id));
}
module.exports = $c08b42aa936f5dc6$var$load;

});


parcelRegister("5O4Jv", function(module, exports) {

$parcel$export(module.exports, "ProspectCampaigns", () => $061bc4d14c4ca633$export$23f4ead7519ae035);
var $061bc4d14c4ca633$export$23f4ead7519ae035;
(function(ProspectCampaigns) {
    ProspectCampaigns["DEMO_REQUEST"] = "demo-request";
    ProspectCampaigns["INVITE_YOUR_PT"] = "invite-your-pt";
})($061bc4d14c4ca633$export$23f4ead7519ae035 || ($061bc4d14c4ca633$export$23f4ead7519ae035 = {}));

});

parcelRegister("jCNJs", function(module, exports) {

$parcel$export(module.exports, "RoundedButton", () => $d2f22b1990c3aede$export$1bb79dad5199d1c9);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
const $d2f22b1990c3aede$export$1bb79dad5199d1c9 = (props)=>/*#__PURE__*/ (0, $iKObn.jsx)($d2f22b1990c3aede$var$StyledButton, {
        ...props
    });
const $d2f22b1990c3aede$var$StyledButton = (0, $5UMQ1.default)((0, $dhb7H.Button))`
	border-radius: 100px;
	padding: 20px 35px;
	background-color: ${(0, $kKnoQ.colors).mobilePrimaryBlue};
	width: 100%;

	:hover {
		background-color: ${(0, $kKnoQ.colors).mobileDarkPrimaryBlue} !important;
	}

	span {
		font-family: "HeadingNow";
		font-size: 16px;
		font-weight: 400 !important;
	}
`;

});

parcelRegister("2kge5", function(module, exports) {

$parcel$export(module.exports, "PtInfoControls", () => $f2f4817a43c42272$export$ed73ccdb94023986);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $5O4Jv = parcelRequire("5O4Jv");

var $5UMQ1 = parcelRequire("5UMQ1");

var $jQBUc = parcelRequire("jQBUc");

var $hIci4 = parcelRequire("hIci4");

var $1acTy = parcelRequire("1acTy");

var $66I1K = parcelRequire("66I1K");

var $5RTr6 = parcelRequire("5RTr6");

var $JizAa = parcelRequire("JizAa");

var $kQLNK = parcelRequire("kQLNK");

var $6mFZi = parcelRequire("6mFZi");

var $9EcNY = parcelRequire("9EcNY");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
function $f2f4817a43c42272$export$ed73ccdb94023986({ config: config, control: control, resetField: resetField, clearErrors: clearErrors, className: className, campaign: campaign, initialCountryCode: initialCountryCode, onPrivacyNoticeUrlChange: onPrivacyNoticeUrlChange }) {
    const { format: format } = (0, $1eHG3.useI18n)();
    const ptControl = control;
    const resetPtField = resetField;
    const { referential: referential, selectReferential: selectReferential } = (0, $6mFZi.useProspectRequestReferential)(config);
    const { countryConfig: countryConfig } = (0, $1acTy.useCountryConfig)();
    (0, $81g6h.useEffect)(()=>{
        onPrivacyNoticeUrlChange((campaign === (0, $5O4Jv.ProspectCampaigns).DEMO_REQUEST ? countryConfig?.ptBiogenPrivacyNoticeUrl : countryConfig?.patientBiogenPrivacyNoticeUrl) ?? "");
    }, [
        campaign,
        referential,
        onPrivacyNoticeUrlChange,
        countryConfig?.ptBiogenPrivacyNoticeUrl,
        countryConfig?.patientBiogenPrivacyNoticeUrl
    ]);
    const { medicalProfessionOptions: medicalProfessionOptions } = (0, $9EcNY.useMedicalProfessionOptions)({
        medicalProfessions: referential.medicalProfessions
    });
    const fieldRequiredErrorMessage = format("global.form.field.requiredError");
    const switchCountry = (0, $81g6h.useCallback)((event)=>{
        const { classList: classList } = document.documentElement;
        if (classList.contains("translated-ltr") || classList.contains("translated-rtl")) return;
        const countryCode = event.target.value;
        selectReferential(countryCode);
        const newLocale = (0, $ghfIB.localeManager).resolveLocaleForCountry(countryCode);
        if (newLocale) (0, $ghfIB.localeManager).changeLocale(newLocale);
        resetPtField("postalCode");
        resetPtField("medicalProfession");
        clearErrors();
    }, [
        clearErrors,
        resetPtField,
        selectReferential
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($f2f4817a43c42272$var$FormContainer, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($f2f4817a43c42272$var$TwoColumnLayout, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                        name: "firstName",
                        control: ptControl,
                        rules: {
                            required: fieldRequiredErrorMessage
                        },
                        render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $5RTr6.FormField), {
                                title: format("demoRequest.firstNameField.title"),
                                errorMessage: fieldState.error?.message,
                                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                    ...field,
                                    placeholder: format("demoRequest.firstNameField.placeholder"),
                                    error: fieldState.invalid,
                                    inputMode: "text",
                                    autoCorrect: "off",
                                    autoCapitalize: "none"
                                })
                            })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                        name: "lastName",
                        control: ptControl,
                        rules: {
                            required: fieldRequiredErrorMessage
                        },
                        render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $5RTr6.FormField), {
                                title: format("demoRequest.lastNameField.title"),
                                errorMessage: fieldState.error?.message,
                                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                    ...field,
                                    placeholder: format("demoRequest.lastNameField.placeholder"),
                                    error: fieldState.invalid,
                                    inputMode: "text",
                                    autoCorrect: "off",
                                    autoCapitalize: "none"
                                })
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($f2f4817a43c42272$var$TwoColumnLayout, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                        name: "countryCode",
                        control: ptControl,
                        rules: {
                            required: fieldRequiredErrorMessage,
                            onChange: switchCountry
                        },
                        render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $5RTr6.FormField), {
                                title: format("demoRequest.countryField.title"),
                                errorMessage: fieldState.error?.message,
                                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $jQBUc.CountryInput), {
                                    countryCodes: config.supportedCountries,
                                    ...field
                                })
                            })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                        name: "postalCode",
                        control: ptControl,
                        rules: {
                            required: fieldRequiredErrorMessage,
                            pattern: {
                                value: new RegExp(referential.postalCode.validationRegex),
                                message: format("demoRequest.postalCodeField.errorInvalidCodeMessage")
                            }
                        },
                        render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $5RTr6.FormField), {
                                title: format("demoRequest.postalCodeField.title"),
                                errorMessage: fieldState.error?.message,
                                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                    ...field,
                                    placeholder: referential.postalCode.placeholder,
                                    error: fieldState.invalid,
                                    inputMode: "text",
                                    autoCorrect: "off",
                                    autoCapitalize: "none"
                                })
                            })
                    })
                ]
            }),
            campaign === (0, $5O4Jv.ProspectCampaigns).DEMO_REQUEST ? /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $66I1K.EmailController), {
                        control: ptControl,
                        isRequired: true
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $kQLNK.PhoneNumberController), {
                        control: ptControl,
                        initialCountryCode: initialCountryCode
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $JizAa.MedicalProfessionController), {
                        control: ptControl,
                        options: medicalProfessionOptions,
                        isRequired: true
                    })
                ]
            }) : /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $kQLNK.PhoneNumberController), {
                        control: ptControl,
                        initialCountryCode: initialCountryCode
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $JizAa.MedicalProfessionController), {
                        control: ptControl,
                        options: medicalProfessionOptions
                    })
                ]
            })
        ]
    });
}
const $f2f4817a43c42272$var$FormContainer = (0, $5UMQ1.default).div`
	display: grid;
	gap: 16px;
`;
const $f2f4817a43c42272$var$TwoColumnLayout = (0, $5UMQ1.default).div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 24px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		grid-template-columns: unset;
	}
`;

});
parcelRegister("jQBUc", function(module, exports) {

$parcel$export(module.exports, "CountryInput", () => $1143ab2aa1d8660e$export$8f0c3d9dce974dbe);
$parcel$export(module.exports, "GET_COUNTRY_NAME", () => $1143ab2aa1d8660e$export$fa513dd82f0cb8f9);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $2XcA7 = parcelRequire("2XcA7");

var $lTdpc = parcelRequire("lTdpc");

var $aZEA4 = parcelRequire("aZEA4");

var $eT9rN = parcelRequire("eT9rN");
parcelRequire("81g6h");
const $1143ab2aa1d8660e$export$8f0c3d9dce974dbe = ({ error: error = false, countryCodes: countryCodes, ...otherProps })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $eT9rN.Dropdown), {
        ...otherProps,
        className: error ? "p-invalid" : undefined,
        options: countryCodes,
        emptyMessage: format("register.countrySelection.countryDropdown.emptyMessage"),
        valueTemplate: $1143ab2aa1d8660e$var$CountryOptionTemplate,
        itemTemplate: $1143ab2aa1d8660e$var$CountryOptionTemplate
    });
};
const $1143ab2aa1d8660e$export$fa513dd82f0cb8f9 = (countryCode)=>(0, $aZEA4.countries)[countryCode.toUpperCase()].native;
const $1143ab2aa1d8660e$var$CountryOptionTemplate = (countryCode)=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)($1143ab2aa1d8660e$var$DropdownItemContainer, {
        children: (0, $lTdpc.isNotNil)(countryCode) ? /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)($1143ab2aa1d8660e$var$StyledCountryFlag, {
                    code: countryCode.toUpperCase()
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                    children: $1143ab2aa1d8660e$export$fa513dd82f0cb8f9(countryCode)
                })
            ]
        }) : /*#__PURE__*/ (0, $iKObn.jsx)("p", {
            children: format("global.form.dropdown.placeholder")
        })
    });
};
const $1143ab2aa1d8660e$var$DropdownItemContainer = (0, $5UMQ1.default).div`
	display: flex;
	place-items: center;
	gap: 0.75em;
`;
const $1143ab2aa1d8660e$var$StyledCountryFlag = (0, $5UMQ1.default)((0, $2XcA7.CountryFlag))`
	height: 1em;
	width: 1.5em;
	border-radius: 2px;
`;

});

parcelRegister("66I1K", function(module, exports) {

$parcel$export(module.exports, "EmailController", () => $9d85e46ab3284034$export$308f1fc0e74d6ae5);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $hIci4 = parcelRequire("hIci4");

var $5RTr6 = parcelRequire("5RTr6");

var $kI5xQ = parcelRequire("kI5xQ");
parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
function $9d85e46ab3284034$export$308f1fc0e74d6ae5({ control: control, isRequired: isRequired = false }) {
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
        name: "email",
        control: control,
        rules: {
            required: isRequired ? format("global.form.field.requiredError") : undefined,
            pattern: {
                value: (0, $kI5xQ.REGEX_EMAIL),
                message: format("demoRequest.emailField.formatError")
            }
        },
        render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $5RTr6.FormField), {
                title: isRequired ? format("demoRequest.emailField.title") : format("inviteYourPt.form.ptSection.email.title"),
                errorMessage: fieldState.error?.message,
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                    ...field,
                    placeholder: format("demoRequest.emailField.placeholder"),
                    error: fieldState.invalid,
                    inputMode: "text",
                    autoCorrect: "off",
                    autoCapitalize: "none"
                })
            })
    });
}

});

parcelRegister("JizAa", function(module, exports) {

$parcel$export(module.exports, "MedicalProfessionController", () => $f1b3b3ef8fbbf2dd$export$8e666ba46b657c07);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5RTr6 = parcelRequire("5RTr6");

var $eT9rN = parcelRequire("eT9rN");
parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
function $f1b3b3ef8fbbf2dd$export$8e666ba46b657c07({ control: control, isRequired: isRequired = false, options: options }) {
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
        name: "medicalProfession",
        control: control,
        rules: {
            required: isRequired ? format("global.form.field.requiredError") : undefined
        },
        render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $5RTr6.FormField), {
                title: isRequired ? format("demoRequest.medicalProfessionField.title") : format("inviteYourPt.form.ptSection.medicalProfession.title"),
                errorMessage: fieldState.error?.message,
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $eT9rN.Dropdown), {
                    options: options,
                    optionLabel: "label",
                    optionValue: "value",
                    placeholder: format("global.form.dropdown.placeholder"),
                    className: fieldState.error ? "p-invalid" : undefined,
                    ...field
                })
            })
    });
}

});

parcelRegister("kQLNK", function(module, exports) {

$parcel$export(module.exports, "PhoneNumberController", () => $24971d23ee2db189$export$1964d9aa77938f99);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $cZkDo = parcelRequire("cZkDo");

var $5RTr6 = parcelRequire("5RTr6");

var $iXc4P = parcelRequire("iXc4P");
parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
const $24971d23ee2db189$export$1964d9aa77938f99 = ({ control: control, initialCountryCode: initialCountryCode })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
        name: "phoneNumber",
        control: control,
        rules: {
            required: format("global.form.field.requiredError"),
            validate: (value)=>(0, $iXc4P.isValidPhoneNumber)(value) || format("global.form.phoneNumberInput.invalidError")
        },
        render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $5RTr6.FormField), {
                title: format("demoRequest.phoneNumberField.title"),
                errorMessage: fieldState.error?.message,
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $cZkDo.PhoneNumberInput), {
                    ...field,
                    error: fieldState.invalid,
                    initialCountryCode: initialCountryCode
                })
            })
    });
};

});
parcelRegister("cZkDo", function(module, exports) {

$parcel$export(module.exports, "PhoneNumberInput", () => $51d6be85ff760386$export$2c2f1151cfbd6048);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $7NBmI = parcelRequire("7NBmI");

var $kKnoQ = parcelRequire("kKnoQ");

var $9IdLQ = parcelRequire("9IdLQ");
var $iYaNE = parcelRequire("iYaNE");
var $bcYIH = parcelRequire("bcYIH");
var $4Sqx5 = parcelRequire("4Sqx5");
var $9uWDQ = parcelRequire("9uWDQ");
var $72S2h = parcelRequire("72S2h");

var $9ZYkg = parcelRequire("9ZYkg");

var $81g6h = parcelRequire("81g6h");
const $51d6be85ff760386$export$2c2f1151cfbd6048 = ({ error: error = false, onChange: onChange, initialCountryCode: initialCountryCode })=>{
    const [phoneNumber, setPhoneNumber] = (0, $81g6h.useState)("");
    const [countryCode, setCountryCode] = (0, $81g6h.useState)((0, $7NBmI.DEFAULT_COUNTRY_CODE));
    (0, $81g6h.useEffect)(()=>{
        if (phoneNumber === "") {
            const givenCountryCode = initialCountryCode.toUpperCase();
            if ((0, $9uWDQ.isSupportedCountry)(givenCountryCode)) setCountryCode(givenCountryCode);
            else setCountryCode((0, $7NBmI.DEFAULT_COUNTRY_CODE));
        }
    }, [
        initialCountryCode,
        phoneNumber
    ]);
    const { countryCallingCode: countryCallingCode, phonePlaceholder: phonePlaceholder } = (0, $81g6h.useMemo)(()=>{
        const callingCode = "+" + (0, $bcYIH.getCountryCallingCode)(countryCode) + " ";
        const placeholder = (0, $4Sqx5.getExampleNumber)(countryCode, (0, $9ZYkg.default))?.formatInternational().substring(callingCode.length).replace(/\d/g, "0");
        return {
            countryCallingCode: callingCode,
            phonePlaceholder: placeholder
        };
    }, [
        countryCode
    ]);
    const handlePhoneNumberChanged = (0, $81g6h.useCallback)((event)=>{
        // Convert value to E.164 to avoid leading zeros
        const asYouType = new (0, $9IdLQ.AsYouType)(countryCode);
        asYouType.input(countryCallingCode + event.target.value);
        const e164 = asYouType.getNumber()?.format("E.164") ?? countryCallingCode;
        let formattedPhoneNumber = (0, $iYaNE.formatIncompletePhoneNumber)(e164, countryCode);
        if ((0, $72S2h.validatePhoneNumberLength)(formattedPhoneNumber) === "TOO_LONG") return;
        event.target.value = formattedPhoneNumber;
        onChange?.(event);
        formattedPhoneNumber = formattedPhoneNumber.substring(countryCallingCode.length);
        setPhoneNumber(formattedPhoneNumber);
    }, [
        countryCallingCode,
        countryCode,
        onChange
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($51d6be85ff760386$var$InputContainer, {
        error: error,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $7NBmI.PhoneCountryDropdown), {
                value: countryCode,
                onChange: (value)=>{
                    setCountryCode(value);
                    setPhoneNumber("");
                }
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: countryCallingCode
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($51d6be85ff760386$var$StyledInput, {
                className: "p-size-s",
                placeholder: phonePlaceholder,
                value: phoneNumber,
                onChange: handlePhoneNumberChanged
            })
        ]
    });
};
const $51d6be85ff760386$var$InputContainer = (0, $5UMQ1.default).div`
	display: flex;
	align-items: center;
	background-color: ${(0, $kKnoQ.colors).primaryBackground};
	font-size: 1rem;
	color: ${(0, $kKnoQ.colors).black};
	border: 1px solid;
	border-radius: 0.5rem;
	transition: border-color 0.2s;
	border-color: ${({ error: error })=>error ? (0, $kKnoQ.colors).rejection : "transparent"};

	:hover,
	:focus-within {
		border-color: ${({ error: error })=>error ? (0, $kKnoQ.colors).rejection : (0, $kKnoQ.colors).primary};
	}
`;
const $51d6be85ff760386$var$StyledInput = (0, $5UMQ1.default).input`
	padding: 1em 1.5em;
	padding-left: 0.5em;
	width: 100%;
	background-color: unset;
	border: none;

	:not(.p-disabled) {
		box-shadow: none !important;
	}

	:focus-visible {
		outline: none;
	}
`;

});
parcelRegister("7NBmI", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COUNTRY_CODE", () => $5193eafa0c4969fb$export$7baaffefa21dec1);
$parcel$export(module.exports, "PhoneCountryDropdown", () => $5193eafa0c4969fb$export$548345a7a7ec3df2);

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $2XcA7 = parcelRequire("2XcA7");

var $jQBUc = parcelRequire("jQBUc");

var $aZEA4 = parcelRequire("aZEA4");

var $8hrim = parcelRequire("8hrim");

var $9uWDQ = parcelRequire("9uWDQ");

var $eT9rN = parcelRequire("eT9rN");

var $81g6h = parcelRequire("81g6h");
const $5193eafa0c4969fb$export$7baaffefa21dec1 = "FR";
const $5193eafa0c4969fb$export$548345a7a7ec3df2 = ({ value: value, onChange: onChange })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    // Generate country list. This step also makes sure that each country code is mutually recognized by
    //  - "country-flag-icons" which provides the flag icons
    //  - "countries-list" which provides the localized country name
    //  - "libphonenumber-js" which provides the phone number validation
    const availableCountryCodes = (0, $81g6h.useMemo)(()=>(0, $8hrim.default).filter((code)=>code in (0, $aZEA4.countries)).filter((code)=>(0, $9uWDQ.isSupportedCountry)(code)), []);
    return /*#__PURE__*/ (0, $iKObn.jsx)($5193eafa0c4969fb$var$StyledDropdown, {
        value: value,
        onChange: (e)=>onChange(e.value ?? $5193eafa0c4969fb$export$7baaffefa21dec1),
        options: availableCountryCodes,
        filter: true,
        showFilterClear: true,
        resetFilterOnHide: true,
        filterPlaceholder: format("global.form.phoneNumberInput.country.search.placeholder"),
        emptyFilterMessage: format("global.form.phoneNumberInput.country.search.empty"),
        valueTemplate: $5193eafa0c4969fb$var$selectedCountryTemplate,
        itemTemplate: $5193eafa0c4969fb$var$countryOptionTemplate
    });
};
const $5193eafa0c4969fb$var$selectedCountryTemplate = (code)=>/*#__PURE__*/ (0, $iKObn.jsx)($5193eafa0c4969fb$var$StyledCountryFlag, {
        code: code
    });
const $5193eafa0c4969fb$var$countryOptionTemplate = (code)=>/*#__PURE__*/ (0, $iKObn.jsxs)($5193eafa0c4969fb$var$DropdownItemContainer, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($5193eafa0c4969fb$var$StyledCountryFlag, {
                code: code
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: (0, $jQBUc.GET_COUNTRY_NAME)(code)
            })
        ]
    });
const $5193eafa0c4969fb$var$DropdownItemContainer = (0, $5UMQ1.default).div`
	display: flex;
	gap: 0.75em;
`;
const $5193eafa0c4969fb$var$StyledCountryFlag = (0, $5UMQ1.default)((0, $2XcA7.CountryFlag))`
	height: 1em;
	width: 1.5em;
	border-radius: 2px;
`;
const $5193eafa0c4969fb$var$StyledDropdown = (0, $5UMQ1.default)((0, $eT9rN.Dropdown))`
	width: unset;
	background-color: unset;
	border-radius: unset;
	border: unset;
	padding: 1em;
	padding-left: 1.5em;
	gap: 0.75em;

	.p-dropdown-label {
		border-radius: unset;
		padding: 0;
		display: grid;
		place-content: center;
	}

	.p-dropdown-trigger {
		border-radius: unset;
		padding: 0;
		width: unset;
	}
`;

});
parcelRegister("8hrim", function(module, exports) {

$parcel$export(module.exports, "default", () => $6075157e1a013d56$export$2e2bcd8739ae039);
var $6075157e1a013d56$export$2e2bcd8739ae039 = [
    "AC",
    "AD",
    "AE",
    "AF",
    "AG",
    "AI",
    "AL",
    "AM",
    "AO",
    "AQ",
    "AR",
    "AS",
    "AT",
    "AU",
    "AW",
    "AX",
    "AZ",
    "BA",
    "BB",
    "BD",
    "BE",
    "BF",
    "BG",
    "BH",
    "BI",
    "BJ",
    "BL",
    "BM",
    "BN",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BT",
    "BV",
    "BW",
    "BY",
    "BZ",
    "CA",
    "CC",
    "CD",
    "CF",
    "CG",
    "CH",
    "CI",
    "CK",
    "CL",
    "CM",
    "CN",
    "CO",
    "CR",
    "CU",
    "CV",
    "CW",
    "CX",
    "CY",
    "CZ",
    "DE",
    "DJ",
    "DK",
    "DM",
    "DO",
    "DZ",
    "EC",
    "EE",
    "EG",
    "EH",
    "ER",
    "ES",
    "ET",
    "EU",
    "FI",
    "FJ",
    "FK",
    "FM",
    "FO",
    "FR",
    "GA",
    "GB",
    "GD",
    "GE",
    "GF",
    "GG",
    "GH",
    "GI",
    "GL",
    "GM",
    "GN",
    "GP",
    "GQ",
    "GR",
    "GS",
    "GT",
    "GU",
    "GW",
    "GY",
    "HK",
    "HM",
    "HN",
    "HR",
    "HT",
    "HU",
    "IC",
    "ID",
    "IE",
    "IL",
    "IM",
    "IN",
    "IO",
    "IQ",
    "IR",
    "IS",
    "IT",
    "JE",
    "JM",
    "JO",
    "JP",
    "KE",
    "KG",
    "KH",
    "KI",
    "KM",
    "KN",
    "KP",
    "KR",
    "KW",
    "KY",
    "KZ",
    "LA",
    "LB",
    "LC",
    "LI",
    "LK",
    "LR",
    "LS",
    "LT",
    "LU",
    "LV",
    "LY",
    "MA",
    "MC",
    "MD",
    "ME",
    "MF",
    "MG",
    "MH",
    "MK",
    "ML",
    "MM",
    "MN",
    "MO",
    "MP",
    "MQ",
    "MR",
    "MS",
    "MT",
    "MU",
    "MV",
    "MW",
    "MX",
    "MY",
    "MZ",
    "NA",
    "NC",
    "NE",
    "NF",
    "NG",
    "NI",
    "NL",
    "NO",
    "NP",
    "NR",
    "NU",
    "NZ",
    "OM",
    "PA",
    "PE",
    "PF",
    "PG",
    "PH",
    "PK",
    "PL",
    "PM",
    "PN",
    "PR",
    "PS",
    "PT",
    "PW",
    "PY",
    "QA",
    "RE",
    "RO",
    "RS",
    "RU",
    "RW",
    "SA",
    "SB",
    "SC",
    "SD",
    "SE",
    "SG",
    "SH",
    "SI",
    "SJ",
    "SK",
    "SL",
    "SM",
    "SN",
    "SO",
    "SR",
    "SS",
    "ST",
    "SV",
    "SX",
    "SY",
    "SZ",
    "TA",
    "TC",
    "TD",
    "TF",
    "TG",
    "TH",
    "TJ",
    "TK",
    "TL",
    "TM",
    "TN",
    "TO",
    "TR",
    "TT",
    "TV",
    "TW",
    "TZ",
    "UA",
    "UG",
    "UM",
    "US",
    "UY",
    "UZ",
    "VA",
    "VC",
    "VE",
    "VG",
    "VI",
    "VN",
    "VU",
    "WF",
    "WS",
    "XK",
    "YE",
    "YT",
    "ZA",
    "ZM",
    "ZW"
];

});

parcelRegister("9uWDQ", function(module, exports) {

$parcel$export(module.exports, "isSupportedCountry", () => $6ea4676b904959ef$export$bd9e113b8b17202a);

var $5AEiK = parcelRequire("5AEiK");

var $7t6iH = parcelRequire("7t6iH");
function $6ea4676b904959ef$export$bd9e113b8b17202a() {
    return (0, $5AEiK.default)((0, $7t6iH.isSupportedCountry), arguments);
}

});
parcelRegister("5AEiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $411f938af6328d2d$export$2e2bcd8739ae039);
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.

var $4UKpA = parcelRequire("4UKpA");
function $411f938af6328d2d$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $4UKpA.default));
    return func.apply(this, args);
}

});
parcelRegister("4UKpA", function(module, exports) {

$parcel$export(module.exports, "default", () => $394064c5283e2140$export$2e2bcd8739ae039);
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $394064c5283e2140$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|2[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "(?:01\\d|[24-689])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[235]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                        "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "46"
                    ]
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6|90"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6|7[245]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ]
                ],
                [
                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "3[2-8]\\d{9,10}",
                    [
                        11,
                        12
                    ]
                ],
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[0135-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(0-$1)",
                    1
                ]
            ],
            "0",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|452|678|86",
                        "[12]|452|6788|86"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]|8(?:0[6-9]|[36])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "[2-9]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[0467]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}",
            [
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "709\\d{6}|(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "[6-9]\\d{6}|[1-6]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "(?:[2489]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-9]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|7[67]|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-359]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-4]|5[1-3]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[59]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[689]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[1245]|3[12])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "(?:[1-6]\\d|71)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[67]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                0,
                0,
                [
                    "305209\\d{4}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "00",
            "(?:20|33|[5-9]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ]
                ]
            ]
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[47-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2|39"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|[579]\\d|63)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[235-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "2\\d{8}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                [
                    "348[57]\\d{7}",
                    [
                        11
                    ]
                ],
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};

});


parcelRegister("7t6iH", function(module, exports) {

$parcel$export(module.exports, "default", () => $570021010aebc7bd$export$2e2bcd8739ae039);
$parcel$export(module.exports, "validateMetadata", () => $570021010aebc7bd$export$a0b100d4662a8795);
$parcel$export(module.exports, "getCountryCallingCode", () => $570021010aebc7bd$export$32876ca2f1919cf0);
$parcel$export(module.exports, "isSupportedCountry", () => $570021010aebc7bd$export$bd9e113b8b17202a);

var $e3LUJ = parcelRequire("e3LUJ");

var $hVkdz = parcelRequire("hVkdz");
function $570021010aebc7bd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $570021010aebc7bd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $570021010aebc7bd$var$_typeof(obj);
}
function $570021010aebc7bd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $570021010aebc7bd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $570021010aebc7bd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $570021010aebc7bd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $570021010aebc7bd$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $570021010aebc7bd$var$V2 = "1.0.18"; // Added "idd_prefix" and "default_idd_prefix".
var $570021010aebc7bd$var$V3 = "1.2.0"; // Moved `001` country code to "nonGeographic" section of metadata.
var $570021010aebc7bd$var$V4 = "1.7.35";
var $570021010aebc7bd$var$DEFAULT_EXT_PREFIX = " ext. ";
var $570021010aebc7bd$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $570021010aebc7bd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $570021010aebc7bd$var$_classCallCheck(this, Metadata);
        $570021010aebc7bd$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $570021010aebc7bd$var$setVersion.call(this, metadata);
    }
    $570021010aebc7bd$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== "001";
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $570021010aebc7bd$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== "001") {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $570021010aebc7bd$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $570021010aebc7bd$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return this.metadata.countries["001"];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $570021010aebc7bd$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $570021010aebc7bd$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $570021010aebc7bd$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $570021010aebc7bd$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $570021010aebc7bd$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $570021010aebc7bd$var$getType(this.types(), _type2)) return new $570021010aebc7bd$var$Type($570021010aebc7bd$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $570021010aebc7bd$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $570021010aebc7bd$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $570021010aebc7bd$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $570021010aebc7bd$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $570021010aebc7bd$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$570021010aebc7bd$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $570021010aebc7bd$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $570021010aebc7bd$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $570021010aebc7bd$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $570021010aebc7bd$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $570021010aebc7bd$var$getType(types, type) {
    switch(type){
        case "FIXED_LINE":
            return types[0];
        case "MOBILE":
            return types[1];
        case "TOLL_FREE":
            return types[2];
        case "PREMIUM_RATE":
            return types[3];
        case "PERSONAL_NUMBER":
            return types[4];
        case "VOICEMAIL":
            return types[5];
        case "UAN":
            return types[6];
        case "PAGER":
            return types[7];
        case "VOIP":
            return types[8];
        case "SHARED_COST":
            return types[9];
    }
}
function $570021010aebc7bd$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
     // `country_phone_code_to_countries` was renamed to `country_calling_codes` in `1.0.18`.
    // For that reason, it's not used in this detection algorithm.
    // Instead, it detects by `countries: {}` property existence.
    if (!(0, $hVkdz.default)(metadata) || !(0, $hVkdz.default)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $hVkdz.default)(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + $570021010aebc7bd$var$typeOf(metadata) + ": " + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $570021010aebc7bd$var$typeOf = function typeOf(_) {
    return $570021010aebc7bd$var$_typeof(_);
};
function $570021010aebc7bd$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $570021010aebc7bd$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $570021010aebc7bd$var$DEFAULT_EXT_PREFIX;
}
function $570021010aebc7bd$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $570021010aebc7bd$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $570021010aebc7bd$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $570021010aebc7bd$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === "number") {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $e3LUJ.default)(version, $570021010aebc7bd$var$V3) === -1) this.v2 = true;
        else if ((0, $e3LUJ.default)(version, $570021010aebc7bd$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }

});
parcelRegister("e3LUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3c6833eab056f58$export$2e2bcd8739ae039);
// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $a3c6833eab056f58$export$2e2bcd8739ae039(a, b) {
    a = a.split("-");
    b = b.split("-");
    var pa = a[0].split(".");
    var pb = b[0].split(".");
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

});

parcelRegister("hVkdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0c7716527f348e8$export$2e2bcd8739ae039);
var $d0c7716527f348e8$var$objectConstructor = {}.constructor;
function $d0c7716527f348e8$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $d0c7716527f348e8$var$objectConstructor;
}

});




parcelRegister("9IdLQ", function(module, exports) {

$parcel$export(module.exports, "AsYouType", () => $7122e7b48f4accde$export$80d8c6912928a4eb);
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.

var $4UKpA = parcelRequire("4UKpA");

var $gAlXg = parcelRequire("gAlXg");
function $7122e7b48f4accde$export$80d8c6912928a4eb(country) {
    return (0, $gAlXg.default).call(this, country, (0, $4UKpA.default));
}
$7122e7b48f4accde$export$80d8c6912928a4eb.prototype = Object.create((0, $gAlXg.default).prototype, {});
$7122e7b48f4accde$export$80d8c6912928a4eb.prototype.constructor = $7122e7b48f4accde$export$80d8c6912928a4eb;

});
parcelRegister("gAlXg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c13109efd413265c$export$2e2bcd8739ae039);

var $7t6iH = parcelRequire("7t6iH");

var $40ywJ = parcelRequire("40ywJ");

var $i28zi = parcelRequire("i28zi");

var $4VbsE = parcelRequire("4VbsE");
var $3GzrS = parcelRequire("3GzrS");

var $jXuK7 = parcelRequire("jXuK7");

var $iotMN = parcelRequire("iotMN");

var $icOY5 = parcelRequire("icOY5");

var $hVkdz = parcelRequire("hVkdz");
function $c13109efd413265c$var$_slicedToArray(arr, i) {
    return $c13109efd413265c$var$_arrayWithHoles(arr) || $c13109efd413265c$var$_iterableToArrayLimit(arr, i) || $c13109efd413265c$var$_unsupportedIterableToArray(arr, i) || $c13109efd413265c$var$_nonIterableRest();
}
function $c13109efd413265c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c13109efd413265c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c13109efd413265c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c13109efd413265c$var$_arrayLikeToArray(o, minLen);
}
function $c13109efd413265c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c13109efd413265c$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c13109efd413265c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c13109efd413265c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c13109efd413265c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c13109efd413265c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c13109efd413265c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c13109efd413265c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $c13109efd413265c$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $c13109efd413265c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */ function AsYouType(optionsOrDefaultCountry, metadata) {
        $c13109efd413265c$var$_classCallCheck(this, AsYouType);
        this.metadata = new (0, $7t6iH.default)(metadata);
        var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry), _this$getCountryAndCa2 = $c13109efd413265c$var$_slicedToArray(_this$getCountryAndCa, 2), defaultCountry = _this$getCountryAndCa2[0], defaultCallingCode = _this$getCountryAndCa2[1]; // `this.defaultCountry` and `this.defaultCallingCode` aren't required to be in sync.
        // For example, `this.defaultCountry` could be `"AR"` and `this.defaultCallingCode` could be `undefined`.
        // So `this.defaultCountry` and `this.defaultCallingCode` are totally independent.
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.reset();
    }
    $c13109efd413265c$var$_createClass(AsYouType, [
        {
            key: "getCountryAndCallingCode",
            value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
                // Set `defaultCountry` and `defaultCallingCode` options.
                var defaultCountry;
                var defaultCallingCode; // Turns out `null` also has type "object". Weird.
                if (optionsOrDefaultCountry) {
                    if ((0, $hVkdz.default)(optionsOrDefaultCountry)) {
                        defaultCountry = optionsOrDefaultCountry.defaultCountry;
                        defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
                    } else defaultCountry = optionsOrDefaultCountry;
                }
                if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) defaultCountry = undefined;
                if (defaultCallingCode) {
                    /* istanbul ignore if */ if ($c13109efd413265c$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                        if (this.metadata.isNonGeographicCallingCode(defaultCallingCode)) defaultCountry = "001";
                    }
                }
                return [
                    defaultCountry,
                    defaultCallingCode
                ];
            }
        },
        {
            key: "input",
            value: function input(text) {
                var _this$parser$input = this.parser.input(text, this.state), digits = _this$parser$input.digits, justLeadingPlus = _this$parser$input.justLeadingPlus;
                if (justLeadingPlus) this.formattedOutput = "+";
                else if (digits) {
                    this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.
                    if (this.state.nationalSignificantNumber) this.formatter.narrowDownMatchingFormats(this.state);
                    var formattedNationalNumber;
                    if (this.metadata.hasSelectedNumberingPlan()) formattedNationalNumber = this.formatter.format(digits, this.state);
                    if (formattedNationalNumber === undefined) // See if another national (significant) number could be re-extracted.
                    {
                        if (this.parser.reExtractNationalSignificantNumber(this.state)) {
                            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.
                            var nationalDigits = this.state.getNationalDigits();
                            if (nationalDigits) formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
                        }
                    }
                    this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
                }
                return this.formattedOutput;
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this = this;
                this.state = new (0, $i28zi.default)({
                    onCountryChange: function onCountryChange(country) {
                        // Before version `1.6.0`, the official `AsYouType` formatter API
                        // included the `.country` property of an `AsYouType` instance.
                        // Since that property (along with the others) have been moved to
                        // `this.state`, `this.country` property is emulated for compatibility
                        // with the old versions.
                        _this.country = country;
                    },
                    onCallingCodeChange: function onCallingCodeChange(callingCode, country) {
                        _this.metadata.selectNumberingPlan(country, callingCode);
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                        _this.parser.reset(_this.metadata.numberingPlan);
                    }
                });
                this.formatter = new (0, $4VbsE.default)({
                    state: this.state,
                    metadata: this.metadata
                });
                this.parser = new (0, $jXuK7.default)({
                    defaultCountry: this.defaultCountry,
                    defaultCallingCode: this.defaultCallingCode,
                    metadata: this.metadata,
                    state: this.state,
                    onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
                        _this.determineTheCountryIfNeeded();
                        _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
                    }
                });
                this.state.reset({
                    country: this.defaultCountry,
                    callingCode: this.defaultCallingCode
                });
                this.formattedOutput = "";
                return this;
            }
        },
        {
            key: "isInternational",
            value: function isInternational() {
                return this.state.international;
            }
        },
        {
            key: "getCallingCode",
            value: function getCallingCode() {
                // If the number is being input in national format and some "default calling code"
                // has been passed to `AsYouType` constructor, then `this.state.callingCode`
                // is equal to that "default calling code".
                //
                // If the number is being input in national format and no "default calling code"
                // has been passed to `AsYouType` constructor, then returns `undefined`,
                // even if a "default country" has been passed to `AsYouType` constructor.
                //
                if (this.isInternational()) return this.state.callingCode;
            } // A legacy alias.
        },
        {
            key: "getCountryCallingCode",
            value: function getCountryCallingCode() {
                return this.getCallingCode();
            }
        },
        {
            key: "getCountry",
            value: function getCountry() {
                var digits = this.state.digits; // Return `undefined` if no digits have been input yet.
                if (digits) return this._getCountry();
            }
        },
        {
            key: "_getCountry",
            value: function _getCountry() {
                var country = this.state.country;
                /* istanbul ignore if */ if ($c13109efd413265c$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                    // `AsYouType.getCountry()` returns `undefined`
                    // for "non-geographic" phone numbering plans.
                    if (country === "001") return;
                }
                return country;
            }
        },
        {
            key: "determineTheCountryIfNeeded",
            value: function determineTheCountryIfNeeded() {
                // Suppose a user enters a phone number in international format,
                // and there're several countries corresponding to that country calling code,
                // and a country has been derived from the number, and then
                // a user enters one more digit and the number is no longer
                // valid for the derived country, so the country should be re-derived
                // on every new digit in those cases.
                //
                // If the phone number is being input in national format,
                // then it could be a case when `defaultCountry` wasn't specified
                // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
                // and that "calling code" could correspond to a "non-geographic entity",
                // or there could be several countries corresponding to that country calling code.
                // In those cases, `this.country` is `undefined` and should be derived
                // from the number. Again, if country calling code is ambiguous, then
                // `this.country` should be re-derived with each new digit.
                //
                if (!this.state.country || this.isCountryCallingCodeAmbiguous()) this.determineTheCountry();
            } // Prepends `+CountryCode ` in case of an international phone number
        },
        {
            key: "getFullNumber",
            value: function getFullNumber(formattedNationalNumber) {
                var _this2 = this;
                if (this.isInternational()) {
                    var prefix = function prefix(text) {
                        return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
                            spacing: text ? true : false
                        }) + text;
                    };
                    var callingCode = this.state.callingCode;
                    if (!callingCode) return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
                    if (!formattedNationalNumber) return prefix(callingCode);
                    return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
                }
                return formattedNationalNumber;
            }
        },
        {
            key: "getNonFormattedNationalNumberWithPrefix",
            value: function getNonFormattedNationalNumberWithPrefix() {
                var _this$state = this.state, nationalSignificantNumber = _this$state.nationalSignificantNumber, complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber, nationalPrefix = _this$state.nationalPrefix;
                var number = nationalSignificantNumber;
                var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;
                if (prefix) number = prefix + number;
                return number;
            }
        },
        {
            key: "getNonFormattedNumber",
            value: function getNonFormattedNumber() {
                var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
                return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
            }
        },
        {
            key: "getNonFormattedTemplate",
            value: function getNonFormattedTemplate() {
                var number = this.getNonFormattedNumber();
                if (number) return number.replace(/[\+\d]/g, (0, $3GzrS.DIGIT_PLACEHOLDER));
            }
        },
        {
            key: "isCountryCallingCodeAmbiguous",
            value: function isCountryCallingCodeAmbiguous() {
                var callingCode = this.state.callingCode;
                var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
                return countryCodes && countryCodes.length > 1;
            } // Determines the country of the phone number
        },
        {
            key: "determineTheCountry",
            value: function determineTheCountry() {
                this.state.setCountry((0, $iotMN.default)(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
                    nationalNumber: this.state.nationalSignificantNumber,
                    defaultCountry: this.defaultCountry,
                    metadata: this.metadata
                }));
            }
        },
        {
            key: "getNumberValue",
            value: function getNumberValue() {
                var _this$state2 = this.state, digits = _this$state2.digits, callingCode = _this$state2.callingCode, country = _this$state2.country, nationalSignificantNumber = _this$state2.nationalSignificantNumber; // Will return `undefined` if no digits have been input.
                if (!digits) return;
                if (this.isInternational()) {
                    if (callingCode) return "+" + callingCode + nationalSignificantNumber;
                    else return "+" + digits;
                } else if (country || callingCode) {
                    var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
                    return "+" + callingCode_ + nationalSignificantNumber;
                }
            }
        },
        {
            key: "getNumber",
            value: function getNumber() {
                var _this$state3 = this.state, nationalSignificantNumber = _this$state3.nationalSignificantNumber, carrierCode = _this$state3.carrierCode, callingCode = _this$state3.callingCode; // `this._getCountry()` is basically same as `this.state.country`
                // with the only change that it return `undefined` in case of a
                // "non-geographic" numbering plan instead of `"001"` "internal use" value.
                var country = this._getCountry();
                if (!nationalSignificantNumber) return;
                 // `state.country` and `state.callingCode` aren't required to be in sync.
                // For example, `country` could be `"AR"` and `callingCode` could be `undefined`.
                // So `country` and `callingCode` are totally independent.
                if (!country && !callingCode) return;
                 // By default, if `defaultCountry` parameter was passed when
                // creating `AsYouType` instance, `state.country` is gonna be
                // that `defaultCountry`, which doesn't entirely conform with
                // `parsePhoneNumber()`'s behavior where it attempts to determine
                // the country more precisely in cases when multiple countries
                // could correspond to the same `countryCallingCode`.
                // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/103#note_1417192969
                //
                // Because `AsYouType.getNumber()` method is supposed to be a 1:1
                // equivalent for `parsePhoneNumber(AsYouType.getNumberValue())`,
                // then it should also behave accordingly in cases of `country` ambiguity.
                // That's how users of this library would expect it to behave anyway.
                //
                if (country) {
                    if (country === this.defaultCountry) {
                        // `state.country` and `state.callingCode` aren't required to be in sync.
                        // For example, `state.country` could be `"AR"` and `state.callingCode` could be `undefined`.
                        // So `state.country` and `state.callingCode` are totally independent.
                        var metadata = new (0, $7t6iH.default)(this.metadata.metadata);
                        metadata.selectNumberingPlan(country);
                        var _callingCode = metadata.numberingPlan.callingCode();
                        var ambiguousCountries = this.metadata.getCountryCodesForCallingCode(_callingCode);
                        if (ambiguousCountries.length > 1) {
                            var exactCountry = (0, $icOY5.default)(nationalSignificantNumber, {
                                countries: ambiguousCountries,
                                defaultCountry: this.defaultCountry,
                                metadata: this.metadata.metadata
                            });
                            if (exactCountry) country = exactCountry;
                        }
                    }
                }
                var phoneNumber = new (0, $40ywJ.default)(country || callingCode, nationalSignificantNumber, this.metadata.metadata);
                if (carrierCode) phoneNumber.carrierCode = carrierCode;
                 // Phone number extensions are not supported by "As You Type" formatter.
                return phoneNumber;
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isPossible();
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                var phoneNumber = this.getNumber();
                if (!phoneNumber) return false;
                return phoneNumber.isValid();
            }
        },
        {
            key: "getNationalNumber",
            value: function getNationalNumber() {
                return this.state.nationalSignificantNumber;
            }
        },
        {
            key: "getChars",
            value: function getChars() {
                return (this.state.international ? "+" : "") + this.state.digits;
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate() {
                return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
            }
        }
    ]);
    return AsYouType;
}();

});
parcelRegister("40ywJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb1f1d853395948$export$2e2bcd8739ae039);

var $7t6iH = parcelRequire("7t6iH");

var $aXREX = parcelRequire("aXREX");

var $ersuz = parcelRequire("ersuz");

var $iDRUh = parcelRequire("iDRUh");

var $i0adv = parcelRequire("i0adv");

var $hq6Lf = parcelRequire("hq6Lf");

var $hVkdz = parcelRequire("hVkdz");

var $4N58T = parcelRequire("4N58T");
function $2eb1f1d853395948$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2eb1f1d853395948$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2eb1f1d853395948$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2eb1f1d853395948$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2eb1f1d853395948$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2eb1f1d853395948$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2eb1f1d853395948$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2eb1f1d853395948$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2eb1f1d853395948$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2eb1f1d853395948$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2eb1f1d853395948$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $2eb1f1d853395948$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $2eb1f1d853395948$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $2eb1f1d853395948$var$_classCallCheck(this, PhoneNumber);
        // Validate `countryOrCountryCallingCode` argument.
        if (!countryOrCountryCallingCode) throw new TypeError("First argument is required");
        if (typeof countryOrCountryCallingCode !== "string") throw new TypeError("First argument must be a string");
         // In case of public API use: `constructor(number, metadata)`.
        // Transform the arguments from `constructor(number, metadata)` to
        // `constructor(countryOrCountryCallingCode, nationalNumber, metadata)`.
        if (typeof countryOrCountryCallingCode === "string") {
            if (countryOrCountryCallingCode[0] === "+" && !nationalNumber) throw new TypeError("`metadata` argument not passed");
            if ((0, $hVkdz.default)(nationalNumber) && (0, $hVkdz.default)(nationalNumber.countries)) {
                metadata = nationalNumber;
                var e164Number = countryOrCountryCallingCode;
                if (!$2eb1f1d853395948$var$E164_NUMBER_REGEXP.test(e164Number)) throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
                var _extractCountryCallin = (0, $hq6Lf.default)(e164Number, undefined, undefined, metadata), _countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
                nationalNumber = number;
                countryOrCountryCallingCode = _countryCallingCode;
                if (!nationalNumber) throw new Error("Invalid `number` argument passed: too short");
            }
        } // Validate `nationalNumber` argument.
        if (!nationalNumber) throw new TypeError("`nationalNumber` argument is required");
        if (typeof nationalNumber !== "string") throw new TypeError("`nationalNumber` argument must be a string");
         // Validate `metadata` argument.
        (0, $7t6iH.validateMetadata)(metadata); // Initialize properties.
        var _getCountryAndCountry = $2eb1f1d853395948$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = "+" + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $2eb1f1d853395948$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $i0adv.default)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $aXREX.default)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $ersuz.default)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $7t6iH.default)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $iDRUh.default)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $4N58T.default)(this, _format, options ? $2eb1f1d853395948$var$_objectSpread($2eb1f1d853395948$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format("NATIONAL", options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format("INTERNATIONAL", options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format("RFC3966", options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $2eb1f1d853395948$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $2eb1f1d853395948$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $7t6iH.default)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($2eb1f1d853395948$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($2eb1f1d853395948$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = "001";
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}
var $2eb1f1d853395948$var$E164_NUMBER_REGEXP = /^\+\d+$/;

});
parcelRegister("aXREX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fb909c1a60078cf$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isPossibleNumber", () => $7fb909c1a60078cf$export$4f8890cedf1e0497);

var $7t6iH = parcelRequire("7t6iH");

var $ct34l = parcelRequire("ct34l");
function $7fb909c1a60078cf$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $7t6iH.default)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $7fb909c1a60078cf$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $7fb909c1a60078cf$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $ct34l.default)(nationalNumber, metadata)){
        case "IS_POSSIBLE":
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}

});
parcelRegister("ct34l", function(module, exports) {

$parcel$export(module.exports, "default", () => $913a92e9b44c20f6$export$2e2bcd8739ae039);

var $9SJTA = parcelRequire("9SJTA");
function $913a92e9b44c20f6$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $913a92e9b44c20f6$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $913a92e9b44c20f6$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return "IS_POSSIBLE";
    if (type === "FIXED_LINE_OR_MOBILE") {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type("FIXED_LINE")) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $913a92e9b44c20f6$export$69333f603c7d5931(nationalNumber, "MOBILE", metadata);
        var mobile_type = metadata.type("MOBILE");
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $9SJTA.default)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return "INVALID_LENGTH";
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return "IS_POSSIBLE";
    if (minimum_length > actual_length) return "TOO_SHORT";
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return "TOO_LONG";
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}

});
parcelRegister("9SJTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $731cc21ce977eb7e$export$2e2bcd8739ae039);
function $731cc21ce977eb7e$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $731cc21ce977eb7e$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $731cc21ce977eb7e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $731cc21ce977eb7e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $731cc21ce977eb7e$var$_arrayLikeToArray(o, minLen);
}
function $731cc21ce977eb7e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $731cc21ce977eb7e$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $731cc21ce977eb7e$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}

});



parcelRegister("ersuz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a839b0414e8b3e70$export$2e2bcd8739ae039);

var $7t6iH = parcelRequire("7t6iH");

var $fDGKs = parcelRequire("fDGKs");

var $iDRUh = parcelRequire("iDRUh");
function $a839b0414e8b3e70$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $7t6iH.default)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $iDRUh.default)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $fDGKs.default)(nationalNumber, metadata.nationalNumberPattern());
}

});
parcelRegister("fDGKs", function(module, exports) {

$parcel$export(module.exports, "default", () => $b62ba8728c9cfcf6$export$2e2bcd8739ae039);
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $b62ba8728c9cfcf6$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || "";
    return new RegExp("^(?:" + regular_expression + ")$").test(text);
}

});

parcelRegister("iDRUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d925af4b7a315e37$export$2e2bcd8739ae039);

var $7t6iH = parcelRequire("7t6iH");

var $fDGKs = parcelRequire("fDGKs");
function $d925af4b7a315e37$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d925af4b7a315e37$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d925af4b7a315e37$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d925af4b7a315e37$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d925af4b7a315e37$var$_arrayLikeToArray(o, minLen);
}
function $d925af4b7a315e37$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $d925af4b7a315e37$var$NON_FIXED_LINE_PHONE_TYPES = [
    "MOBILE",
    "PREMIUM_RATE",
    "TOLL_FREE",
    "SHARED_COST",
    "VOIP",
    "PERSONAL_NUMBER",
    "PAGER",
    "UAN",
    "VOICEMAIL"
]; // Finds out national phone number type (fixed line, mobile, etc)
function $d925af4b7a315e37$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $7t6iH.default)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $fDGKs.default)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($d925af4b7a315e37$export$7bd37b39ade0214d(nationalNumber, "FIXED_LINE", metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") return "FIXED_LINE_OR_MOBILE";
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type("MOBILE")) return "FIXED_LINE_OR_MOBILE";
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($d925af4b7a315e37$export$7bd37b39ade0214d(nationalNumber, "MOBILE", metadata)) return "FIXED_LINE_OR_MOBILE";
        return "FIXED_LINE";
    }
    for(var _iterator = $d925af4b7a315e37$var$_createForOfIteratorHelperLoose($d925af4b7a315e37$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($d925af4b7a315e37$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $d925af4b7a315e37$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $fDGKs.default)(nationalNumber, type.pattern());
}

});


parcelRegister("i0adv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1b026eabde4d307$export$2e2bcd8739ae039);

var $7t6iH = parcelRequire("7t6iH");
function $d1b026eabde4d307$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $7t6iH.default)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $d1b026eabde4d307$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $d1b026eabde4d307$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $7t6iH.default)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}

});

parcelRegister("hq6Lf", function(module, exports) {

$parcel$export(module.exports, "default", () => $caea1bf67d09108b$export$2e2bcd8739ae039);

var $9vIpU = parcelRequire("9vIpU");

var $ctFk7 = parcelRequire("ctFk7");

var $7t6iH = parcelRequire("7t6iH");

var $e78xe = parcelRequire("e78xe");
function $caea1bf67d09108b$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== "+") {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $9vIpU.default)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = "+" + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $ctFk7.default)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === "0") return {};
    metadata = new (0, $7t6iH.default)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $e78xe.MAX_LENGTH_COUNTRY_CODE) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }

});
parcelRegister("9vIpU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec976916cca8ad6$export$2e2bcd8739ae039);

var $7t6iH = parcelRequire("7t6iH");

var $e78xe = parcelRequire("e78xe");
var $6ec976916cca8ad6$var$CAPTURING_DIGIT_PATTERN = new RegExp("([" + (0, $e78xe.VALID_DIGITS) + "])");
function $6ec976916cca8ad6$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $7t6iH.default)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($6ec976916cca8ad6$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === "0") return;
    }
    return number;
}

});
parcelRegister("e78xe", function(module, exports) {

$parcel$export(module.exports, "MIN_LENGTH_FOR_NSN", () => $a46857060cea9ad3$export$cd8355bcbe13154);
$parcel$export(module.exports, "MAX_LENGTH_FOR_NSN", () => $a46857060cea9ad3$export$85ddd8c9b243679b);
$parcel$export(module.exports, "MAX_LENGTH_COUNTRY_CODE", () => $a46857060cea9ad3$export$514717690676fb4a);
$parcel$export(module.exports, "VALID_DIGITS", () => $a46857060cea9ad3$export$852d1d4a47329634);
$parcel$export(module.exports, "VALID_PUNCTUATION", () => $a46857060cea9ad3$export$7f01587e28f9194);
$parcel$export(module.exports, "PLUS_CHARS", () => $a46857060cea9ad3$export$207c99ccf3902df8);
// The minimum length of the national significant number.
var $a46857060cea9ad3$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $a46857060cea9ad3$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $a46857060cea9ad3$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $a46857060cea9ad3$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $a46857060cea9ad3$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $a46857060cea9ad3$var$SLASHES = "\uFF0F/";
var $a46857060cea9ad3$var$DOTS = "\uFF0E.";
var $a46857060cea9ad3$export$20542845033f576e = " \xa0\xad\u200B\u2060\u3000";
var $a46857060cea9ad3$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $a46857060cea9ad3$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $a46857060cea9ad3$export$7f01587e28f9194 = "".concat($a46857060cea9ad3$var$DASHES).concat($a46857060cea9ad3$var$SLASHES).concat($a46857060cea9ad3$var$DOTS).concat($a46857060cea9ad3$export$20542845033f576e).concat($a46857060cea9ad3$var$BRACKETS).concat($a46857060cea9ad3$var$TILDES);
var $a46857060cea9ad3$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

});


parcelRegister("ctFk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $91583f7899a1cda5$export$2e2bcd8739ae039);

var $7t6iH = parcelRequire("7t6iH");

var $fDGKs = parcelRequire("fDGKs");

var $C7z0t = parcelRequire("C7z0t");

var $ct34l = parcelRequire("ct34l");

var $7t6iH = parcelRequire("7t6iH");
function $91583f7899a1cda5$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $7t6iH.getCountryCallingCode)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $7t6iH.default)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $C7z0t.default)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $C7z0t.default)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $fDGKs.default)(nationalNumber, metadata.nationalNumberPattern()) && (0, $fDGKs.default)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $ct34l.default)(nationalNumber, metadata) === "TOO_LONG") return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}

});
parcelRegister("C7z0t", function(module, exports) {

$parcel$export(module.exports, "default", () => $07296ab3cafdfe3f$export$2e2bcd8739ae039);

var $5Xvib = parcelRequire("5Xvib");

var $fDGKs = parcelRequire("fDGKs");

var $ct34l = parcelRequire("ct34l");
function $07296ab3cafdfe3f$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $5Xvib.default)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$07296ab3cafdfe3f$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$07296ab3cafdfe3f$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $07296ab3cafdfe3f$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $fDGKs.default)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $fDGKs.default)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $07296ab3cafdfe3f$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $ct34l.default)(nationalNumber, metadata)){
        case "TOO_SHORT":
        case "INVALID_LENGTH":
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}

});
parcelRegister("5Xvib", function(module, exports) {

$parcel$export(module.exports, "default", () => $456abc715188aed4$export$2e2bcd8739ae039);
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $456abc715188aed4$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}

});




parcelRegister("4N58T", function(module, exports) {

$parcel$export(module.exports, "default", () => $37cfba3177280539$export$2e2bcd8739ae039);

var $fDGKs = parcelRequire("fDGKs");

var $kU83r = parcelRequire("kU83r");

var $7t6iH = parcelRequire("7t6iH");

var $8n2FB = parcelRequire("8n2FB");

var $9tFxg = parcelRequire("9tFxg");
function $37cfba3177280539$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $37cfba3177280539$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $37cfba3177280539$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $37cfba3177280539$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $37cfba3177280539$var$_arrayLikeToArray(o, minLen);
}
function $37cfba3177280539$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $37cfba3177280539$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $37cfba3177280539$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $37cfba3177280539$var$ownKeys(Object(source), !0).forEach(function(key) {
            $37cfba3177280539$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $37cfba3177280539$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $37cfba3177280539$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $37cfba3177280539$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $37cfba3177280539$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $37cfba3177280539$var$_objectSpread($37cfba3177280539$var$_objectSpread({}, $37cfba3177280539$var$DEFAULT_OPTIONS), options);
    else options = $37cfba3177280539$var$DEFAULT_OPTIONS;
    metadata = new (0, $7t6iH.default)(metadata);
    if (input.country && input.country !== "001") {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || "";
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case "NATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "";
            number = $37cfba3177280539$var$formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
            return $37cfba3177280539$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "INTERNATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $37cfba3177280539$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $37cfba3177280539$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "E.164":
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case "RFC3966":
            return (0, $9tFxg.formatRFC3966)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case "IDD":
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $37cfba3177280539$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $37cfba3177280539$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
    }
}
function $37cfba3177280539$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $37cfba3177280539$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $kU83r.default)(number, format, {
        useInternationalFormat: formatAs === "INTERNATIONAL",
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $37cfba3177280539$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $37cfba3177280539$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $fDGKs.default)(nationalNnumber, format.pattern())) return format;
    }
}
function $37cfba3177280539$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $37cfba3177280539$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $7t6iH.getCountryCallingCode)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $37cfba3177280539$var$formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === "1") return countryCallingCode + " " + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $8n2FB.default)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($37cfba3177280539$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
}

});
parcelRegister("kU83r", function(module, exports) {

$parcel$export(module.exports, "FIRST_GROUP_PATTERN", () => $f37f4916a3c48309$export$4f32ad1c51a7a6be);
$parcel$export(module.exports, "default", () => $f37f4916a3c48309$export$2e2bcd8739ae039);

var $6uRTn = parcelRequire("6uRTn");
var $f37f4916a3c48309$export$4f32ad1c51a7a6be = /(\$\d)/;
function $f37f4916a3c48309$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($f37f4916a3c48309$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $6uRTn.default)(formattedNumber);
    return formattedNumber;
}

});
parcelRegister("6uRTn", function(module, exports) {

$parcel$export(module.exports, "default", () => $4baf594cc34ec75a$export$2e2bcd8739ae039);

var $e78xe = parcelRequire("e78xe");
function $4baf594cc34ec75a$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $e78xe.VALID_PUNCTUATION), "]+"), "g"), " ").trim();
}

});


parcelRegister("8n2FB", function(module, exports) {

$parcel$export(module.exports, "default", () => $61828ae7b70aa8de$export$2e2bcd8739ae039);

var $7t6iH = parcelRequire("7t6iH");
/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $61828ae7b70aa8de$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $61828ae7b70aa8de$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $7t6iH.default)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($61828ae7b70aa8de$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}

});

parcelRegister("9tFxg", function(module, exports) {

$parcel$export(module.exports, "formatRFC3966", () => $6e670a92b2460a39$export$d4f2d2bc1159d115);

var $lqfDS = parcelRequire("lqfDS");
function $6e670a92b2460a39$var$_slicedToArray(arr, i) {
    return $6e670a92b2460a39$var$_arrayWithHoles(arr) || $6e670a92b2460a39$var$_iterableToArrayLimit(arr, i) || $6e670a92b2460a39$var$_unsupportedIterableToArray(arr, i) || $6e670a92b2460a39$var$_nonIterableRest();
}
function $6e670a92b2460a39$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6e670a92b2460a39$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $6e670a92b2460a39$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6e670a92b2460a39$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $6e670a92b2460a39$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6e670a92b2460a39$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6e670a92b2460a39$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6e670a92b2460a39$var$_arrayLikeToArray(o, minLen);
}
function $6e670a92b2460a39$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6e670a92b2460a39$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, "tel=");
    for(var _iterator = $6e670a92b2460a39$var$_createForOfIteratorHelperLoose(text.split(";")), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split("="), _part$split2 = $6e670a92b2460a39$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case "tel":
                number = value;
                break;
            case "ext":
                ext = value;
                break;
            case "phone-context":
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === "+") number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $lqfDS.default)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $6e670a92b2460a39$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return "";
    if (number[0] !== "+") throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
    return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}

});
parcelRegister("lqfDS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f98828e7cf817fca$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isViablePhoneNumberStart", () => $f98828e7cf817fca$export$4c3f76c95c05197c);

var $e78xe = parcelRequire("e78xe");

var $gRlJZ = parcelRequire("gRlJZ");
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $f98828e7cf817fca$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + (0, $e78xe.VALID_DIGITS) + "]{" + (0, $e78xe.MIN_LENGTH_FOR_NSN) + "}"; //
var $f98828e7cf817fca$export$a77dd7471651eee = "[" + (0, $e78xe.PLUS_CHARS) + "]{0,1}" + "(?:" + "[" + (0, $e78xe.VALID_PUNCTUATION) + "]*" + "[" + (0, $e78xe.VALID_DIGITS) + "]" + "){3,}" + "[" + (0, $e78xe.VALID_PUNCTUATION) + (0, $e78xe.VALID_DIGITS) + "]*"; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $f98828e7cf817fca$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $e78xe.PLUS_CHARS) + "]{0,1}" + "(?:" + "[" + (0, $e78xe.VALID_PUNCTUATION) + "]*" + "[" + (0, $e78xe.VALID_DIGITS) + "]" + "){1,2}" + "$", "i");
var $f98828e7cf817fca$export$a2d12a04749c087d = $f98828e7cf817fca$export$a77dd7471651eee + // Phone number extensions
"(?:" + (0, $gRlJZ.default)() + ")?"; // The combined regular expression for valid phone numbers:
//
var $f98828e7cf817fca$var$VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + $f98828e7cf817fca$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + "$" + "|" + // Or a longer fully parsed phone number (min 3 characters)
"^" + $f98828e7cf817fca$export$a2d12a04749c087d + "$", "i"); // Checks to see if the string of characters could possibly be a phone number at
function $f98828e7cf817fca$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $e78xe.MIN_LENGTH_FOR_NSN) && $f98828e7cf817fca$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $f98828e7cf817fca$export$4c3f76c95c05197c(number) {
    return $f98828e7cf817fca$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}

});
parcelRegister("gRlJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46275dd8e5977f0$export$2e2bcd8739ae039);

var $e78xe = parcelRequire("e78xe");
var $c46275dd8e5977f0$var$RFC3966_EXTN_PREFIX = ";ext=";
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $c46275dd8e5977f0$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $e78xe.VALID_DIGITS), "]{1,").concat(maxLength, "})");
};
function $c46275dd8e5977f0$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = "20";
    /** @type {string} */ var extLimitAfterLikelyLabel = "15";
    /** @type {string} */ var extLimitAfterAmbiguousChar = "9";
    /** @type {string} */ var extLimitWhenNotSure = "6";
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xa0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xa0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xf3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xa0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $c46275dd8e5977f0$var$RFC3966_EXTN_PREFIX + $c46275dd8e5977f0$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $c46275dd8e5977f0$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $c46275dd8e5977f0$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $c46275dd8e5977f0$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $c46275dd8e5977f0$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $c46275dd8e5977f0$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

});





parcelRegister("i28zi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d20f0f67e48481a4$export$2e2bcd8739ae039);
function $d20f0f67e48481a4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d20f0f67e48481a4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d20f0f67e48481a4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d20f0f67e48481a4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d20f0f67e48481a4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// This "state" object simply holds the state of the "AsYouType" parser:
//
// * `country?: string`
// * `callingCode?: string`
// * `digits: string`
// * `international: boolean`
// * `missingPlus: boolean`
// * `IDDPrefix?: string`
// * `carrierCode?: string`
// * `nationalPrefix?: string`
// * `nationalSignificantNumber?: string`
// * `nationalSignificantNumberMatchesInput: boolean`
// * `complexPrefixBeforeNationalSignificantNumber?: string`
//
// `state.country` and `state.callingCode` aren't required to be in sync.
// For example, `state.country` could be `"AR"` and `state.callingCode` could be `undefined`.
// So `state.country` and `state.callingCode` are totally independent.
//
var $d20f0f67e48481a4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeState(_ref) {
        var onCountryChange = _ref.onCountryChange, onCallingCodeChange = _ref.onCallingCodeChange;
        $d20f0f67e48481a4$var$_classCallCheck(this, AsYouTypeState);
        this.onCountryChange = onCountryChange;
        this.onCallingCodeChange = onCallingCodeChange;
    }
    $d20f0f67e48481a4$var$_createClass(AsYouTypeState, [
        {
            key: "reset",
            value: function reset(_ref2) {
                var country = _ref2.country, callingCode = _ref2.callingCode;
                this.international = false;
                this.missingPlus = false;
                this.IDDPrefix = undefined;
                this.callingCode = undefined;
                this.digits = "";
                this.resetNationalSignificantNumber();
                this.initCountryAndCallingCode(country, callingCode);
            }
        },
        {
            key: "resetNationalSignificantNumber",
            value: function resetNationalSignificantNumber() {
                this.nationalSignificantNumber = this.getNationalDigits();
                this.nationalSignificantNumberMatchesInput = true;
                this.nationalPrefix = undefined;
                this.carrierCode = undefined;
                this.complexPrefixBeforeNationalSignificantNumber = undefined;
            }
        },
        {
            key: "update",
            value: function update(properties) {
                for(var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++){
                    var key = _Object$keys[_i];
                    this[key] = properties[key];
                }
            }
        },
        {
            key: "initCountryAndCallingCode",
            value: function initCountryAndCallingCode(country, callingCode) {
                this.setCountry(country);
                this.setCallingCode(callingCode);
            }
        },
        {
            key: "setCountry",
            value: function setCountry(country) {
                this.country = country;
                this.onCountryChange(country);
            }
        },
        {
            key: "setCallingCode",
            value: function setCallingCode(callingCode) {
                this.callingCode = callingCode;
                this.onCallingCodeChange(callingCode, this.country);
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber(country, callingCode) {
                // Prepend the `+` to parsed input.
                this.international = true; // If a default country was set then reset it
                // because an explicitly international phone
                // number is being entered.
                this.initCountryAndCallingCode(country, callingCode);
            }
        },
        {
            key: "appendDigits",
            value: function appendDigits(nextDigits) {
                this.digits += nextDigits;
            }
        },
        {
            key: "appendNationalSignificantNumberDigits",
            value: function appendNationalSignificantNumberDigits(nextDigits) {
                this.nationalSignificantNumber += nextDigits;
            }
        },
        {
            key: "getNationalDigits",
            value: function getNationalDigits() {
                if (this.international) return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
                return this.digits;
            }
        },
        {
            key: "getDigitsWithoutInternationalPrefix",
            value: function getDigitsWithoutInternationalPrefix() {
                if (this.international) {
                    if (this.IDDPrefix) return this.digits.slice(this.IDDPrefix.length);
                }
                return this.digits;
            }
        }
    ]);
    return AsYouTypeState;
}();

});

parcelRegister("4VbsE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3955603f0ff7ee47$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DIGIT_PLACEHOLDER", () => (parcelRequire("3GzrS")).DIGIT_PLACEHOLDER);

var $3GzrS = parcelRequire("3GzrS");

var $dT8F8 = parcelRequire("dT8F8");

var $7vGJV = parcelRequire("7vGJV");

var $8CJvs = parcelRequire("8CJvs");

var $kU83r = parcelRequire("kU83r");

var $e78xe = parcelRequire("e78xe");

var $6uRTn = parcelRequire("6uRTn");
function $3955603f0ff7ee47$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $3955603f0ff7ee47$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3955603f0ff7ee47$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3955603f0ff7ee47$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3955603f0ff7ee47$var$_arrayLikeToArray(o, minLen);
}
function $3955603f0ff7ee47$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3955603f0ff7ee47$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3955603f0ff7ee47$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3955603f0ff7ee47$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3955603f0ff7ee47$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3955603f0ff7ee47$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// Could be any digit, I guess.
var $3955603f0ff7ee47$var$DUMMY_DIGIT = "9"; // I don't know why is it exactly `15`
var $3955603f0ff7ee47$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.
var $3955603f0ff7ee47$var$LONGEST_DUMMY_PHONE_NUMBER = (0, $3GzrS.repeat)($3955603f0ff7ee47$var$DUMMY_DIGIT, $3955603f0ff7ee47$var$LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.
var $3955603f0ff7ee47$var$NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// https://github.com/googlei18n/libphonenumber/commit/a395b4fef3caf57c4bc5f082e1152a4d2bd0ba4c
// "We no longer have numbers in formatting matching patterns, only \d."
// Because this library supports generating custom metadata
// some users may still be using old metadata so the relevant
// code seems to stay until some next major version update.
var $3955603f0ff7ee47$var$SUPPORT_LEGACY_FORMATTING_PATTERNS = true; // A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".
var $3955603f0ff7ee47$var$CREATE_CHARACTER_CLASS_PATTERN = $3955603f0ff7ee47$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.
var $3955603f0ff7ee47$var$CREATE_STANDALONE_DIGIT_PATTERN = $3955603f0ff7ee47$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && function() {
    return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//
var $3955603f0ff7ee47$var$NON_ALTERING_FORMAT_REG_EXP = new RegExp("[" + (0, $e78xe.VALID_PUNCTUATION) + "]*" + // Google developers say:
// "We require that the first matching group is present in the
//  output pattern to ensure no data is lost while formatting."
"\\$1" + "[" + (0, $e78xe.VALID_PUNCTUATION) + "]*" + "(\\$\\d[" + (0, $e78xe.VALID_PUNCTUATION) + "]*)*" + "$"); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.
var $3955603f0ff7ee47$var$MIN_LEADING_DIGITS_LENGTH = 3;
var $3955603f0ff7ee47$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeFormatter(_ref) {
        var state = _ref.state, metadata = _ref.metadata;
        $3955603f0ff7ee47$var$_classCallCheck(this, AsYouTypeFormatter);
        this.metadata = metadata;
        this.resetFormat();
    }
    $3955603f0ff7ee47$var$_createClass(AsYouTypeFormatter, [
        {
            key: "resetFormat",
            value: function resetFormat() {
                this.chosenFormat = undefined;
                this.template = undefined;
                this.nationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplate = undefined;
                this.populatedNationalNumberTemplatePosition = -1;
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan, state) {
                this.resetFormat();
                if (numberingPlan) {
                    this.isNANP = numberingPlan.callingCode() === "1";
                    this.matchingFormats = numberingPlan.formats();
                    if (state.nationalSignificantNumber) this.narrowDownMatchingFormats(state);
                } else {
                    this.isNANP = undefined;
                    this.matchingFormats = [];
                }
            }
        },
        {
            key: "format",
            value: function format(nextDigits, state) {
                var _this = this;
                // See if the phone number digits can be formatted as a complete phone number.
                // If not, use the results from `formatNationalNumberWithNextDigits()`,
                // which formats based on the chosen formatting pattern.
                //
                // Attempting to format complete phone number first is how it's done
                // in Google's `libphonenumber`, so this library just follows it.
                // Google's `libphonenumber` code doesn't explain in detail why does it
                // attempt to format digits as a complete phone number
                // instead of just going with a previoulsy (or newly) chosen `format`:
                //
                // "Checks to see if there is an exact pattern match for these digits.
                //  If so, we should use this instead of any other formatting template
                //  whose leadingDigitsPattern also matches the input."
                //
                if ((0, $dT8F8.canFormatCompleteNumber)(state.nationalSignificantNumber, this.metadata)) for(var _iterator = $3955603f0ff7ee47$var$_createForOfIteratorHelperLoose(this.matchingFormats), _step; !(_step = _iterator()).done;){
                    var format = _step.value;
                    var formattedCompleteNumber = (0, $dT8F8.default)(state, format, {
                        metadata: this.metadata,
                        shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
                            return _this.shouldTryNationalPrefixFormattingRule(format, {
                                international: state.international,
                                nationalPrefix: state.nationalPrefix
                            });
                        },
                        getSeparatorAfterNationalPrefix: function getSeparatorAfterNationalPrefix(format) {
                            return _this.getSeparatorAfterNationalPrefix(format);
                        }
                    });
                    if (formattedCompleteNumber) {
                        this.resetFormat();
                        this.chosenFormat = format;
                        this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, (0, $3GzrS.DIGIT_PLACEHOLDER)), state);
                        this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
                        // using the old template needs to be reset.
                        this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf((0, $3GzrS.DIGIT_PLACEHOLDER));
                        return formattedCompleteNumber;
                    }
                }
                 // Format the digits as a partial (incomplete) phone number
                // using the previously chosen formatting pattern (or a newly chosen one).
                return this.formatNationalNumberWithNextDigits(nextDigits, state);
            } // Formats the next phone number digits.
        },
        {
            key: "formatNationalNumberWithNextDigits",
            value: function formatNationalNumberWithNextDigits(nextDigits, state) {
                var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.
                var newlyChosenFormat = this.chooseFormat(state);
                if (newlyChosenFormat) {
                    if (newlyChosenFormat === previouslyChosenFormat) // If it can format the next (current) digits
                    // using the previously chosen phone number format
                    // then return the updated formatted number.
                    return this.formatNextNationalNumberDigits(nextDigits);
                    else // If a more appropriate phone number format
                    // has been chosen for these "leading digits",
                    // then re-format the national phone number part
                    // using the newly selected format.
                    return this.formatNextNationalNumberDigits(state.getNationalDigits());
                }
            }
        },
        {
            key: "narrowDownMatchingFormats",
            value: function narrowDownMatchingFormats(_ref2) {
                var _this2 = this;
                var nationalSignificantNumber = _ref2.nationalSignificantNumber, nationalPrefix = _ref2.nationalPrefix, international = _ref2.international;
                var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
                // "leading digits" pattern fitting a maximum of 3 leading digits.
                // So, after a user inputs 3 digits of a national (significant) phone number
                // this national (significant) number can already be formatted.
                // The next "leading digits" pattern is for 4 leading digits max,
                // and the "leading digits" pattern after it is for 5 leading digits max, etc.
                // This implementation is different from Google's
                // in that it searches for a fitting format
                // even if the user has entered less than
                // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
                // Because some leading digit patterns already match for a single first digit.
                var leadingDigitsPatternIndex = leadingDigits.length - $3955603f0ff7ee47$var$MIN_LEADING_DIGITS_LENGTH;
                if (leadingDigitsPatternIndex < 0) leadingDigitsPatternIndex = 0;
                this.matchingFormats = this.matchingFormats.filter(function(format) {
                    return _this2.formatSuits(format, international, nationalPrefix) && _this2.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
                }); // If there was a phone number format chosen
                // and it no longer holds given the new leading digits then reset it.
                // The test for this `if` condition is marked as:
                // "Reset a chosen format when it no longer holds given the new leading digits".
                // To construct a valid test case for this one can find a country
                // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
                // and yielding another format for 4 `<leadingDigits>` (Australia in this case).
                if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) this.resetFormat();
            }
        },
        {
            key: "formatSuits",
            value: function formatSuits(format, international, nationalPrefix) {
                // When a prefix before a national (significant) number is
                // simply a national prefix, then it's parsed as `this.nationalPrefix`.
                // In more complex cases, a prefix before national (significant) number
                // could include a national prefix as well as some "capturing groups",
                // and in that case there's no info whether a national prefix has been parsed.
                // If national prefix is not used when formatting a phone number
                // using this format, but a national prefix has been entered by the user,
                // and was extracted, then discard such phone number format.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
                if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
                !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) return false;
                 // If national prefix is mandatory for this phone number format
                // and there're no guarantees that a national prefix is present in user input
                // then discard this phone number format as not suitable.
                // In Google's "AsYouType" formatter code, the equivalent would be this part:
                // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193
                if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) return false;
                return true;
            }
        },
        {
            key: "formatMatches",
            value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
                var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
                // leading digits pattern then it fits.
                // The test case could be found by searching for "leadingDigitsPatternsCount === 0".
                if (leadingDigitsPatternsCount === 0) return true;
                 // Start narrowing down the list of possible formats based on the leading digits.
                // (only previously matched formats take part in the narrowing down process)
                // `leading_digits_patterns` start with 3 digits min
                // and then go up from there one digit at a time.
                leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
                var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Google imposes a requirement on the leading digits
                // to be minimum 3 digits long in order to be eligible
                // for checking those with a leading digits pattern.
                //
                // Since `leading_digits_patterns` start with 3 digits min,
                // Google's original `libphonenumber` library only starts
                // excluding any non-matching formats only when the
                // national number entered so far is at least 3 digits long,
                // otherwise format matching would give false negatives.
                //
                // For example, when the digits entered so far are `2`
                // and the leading digits pattern is `21` –
                // it's quite obvious in this case that the format could be the one
                // but due to the absence of further digits it would give false negative.
                //
                // Also, `leading_digits_patterns` doesn't always correspond to a single
                // digits count. For example, `60|8` pattern would already match `8`
                // but the `60` part would require having at least two leading digits,
                // so the whole pattern would require inputting two digits first in order to
                // decide on whether it matches the input, even when the input is "80".
                //
                // This library — `libphonenumber-js` — allows filtering by `leading_digits_patterns`
                // even when there's only 1 or 2 digits of the national (significant) number.
                // To do that, it uses a non-strict pattern matcher written specifically for that.
                //
                if (leadingDigits.length < $3955603f0ff7ee47$var$MIN_LEADING_DIGITS_LENGTH) // Before leading digits < 3 matching was implemented:
                // return true
                //
                // After leading digits < 3 matching was implemented:
                try {
                    return new (0, $7vGJV.default)(leadingDigitsPattern).match(leadingDigits, {
                        allowOverflow: true
                    }) !== undefined;
                } catch (error) /* istanbul ignore next */ {
                    // There's a slight possibility that there could be some undiscovered bug
                    // in the pattern matcher code. Since the "leading digits < 3 matching"
                    // feature is not "essential" for operation, it can fall back to the old way
                    // in case of any issues rather than halting the application's execution.
                    console.error(error);
                    return true;
                }
                 // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are
                // available then use the usual regular expression matching.
                //
                // The whole pattern is wrapped in round brackets (`()`) because
                // the pattern can use "or" operator (`|`) at the top level of the pattern.
                //
                return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
            }
        },
        {
            key: "getFormatFormat",
            value: function getFormatFormat(format, international) {
                return international ? format.internationalFormat() : format.format();
            }
        },
        {
            key: "chooseFormat",
            value: function chooseFormat(state) {
                var _this3 = this;
                var _loop = function _loop() {
                    var format = _step2.value;
                    // If this format is currently being used
                    // and is still suitable, then stick to it.
                    if (_this3.chosenFormat === format) return "break";
                     // Sometimes, a formatting rule inserts additional digits in a phone number,
                    // and "as you type" formatter can't do that: it should only use the digits
                    // that the user has input.
                    //
                    // For example, in Argentina, there's a format for mobile phone numbers:
                    //
                    // {
                    //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    //    "leading_digits_patterns": ["91"],
                    //    "national_prefix_formatting_rule": "0$1",
                    //    "format": "$2 15-$3-$4",
                    //    "international_format": "$1 $2 $3-$4"
                    // }
                    //
                    // In that format, `international_format` is used instead of `format`
                    // because `format` inserts `15` in the formatted number,
                    // and `AsYouType` formatter should only use the digits
                    // the user has actually input, without adding any extra digits.
                    // In this case, it wouldn't make a difference, because the `15`
                    // is first stripped when applying `national_prefix_for_parsing`
                    // and then re-added when using `format`, so in reality it doesn't
                    // add any new digits to the number, but to detect that, the code
                    // would have to be more complex: it would have to try formatting
                    // the digits using the format and then see if any digits have
                    // actually been added or removed, and then, every time a new digit
                    // is input, it should re-check whether the chosen format doesn't
                    // alter the digits.
                    //
                    // Google's code doesn't go that far, and so does this library:
                    // it simply requires that a `format` doesn't add any additonal
                    // digits to user's input.
                    //
                    // Also, people in general should move from inputting phone numbers
                    // in national format (possibly with national prefixes)
                    // and use international phone number format instead:
                    // it's a logical thing in the modern age of mobile phones,
                    // globalization and the internet.
                    //
                    /* istanbul ignore if */ if (!$3955603f0ff7ee47$var$NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format, state.international))) return "continue";
                    if (!_this3.createTemplateForFormat(format, state)) {
                        // Remove the format if it can't generate a template.
                        _this3.matchingFormats = _this3.matchingFormats.filter(function(_) {
                            return _ !== format;
                        });
                        return "continue";
                    }
                    _this3.chosenFormat = format;
                    return "break";
                };
                // When there are multiple available formats, the formatter uses the first
                // format where a formatting template could be created.
                //
                // For some weird reason, `istanbul` says "else path not taken"
                // for the `for of` line below. Supposedly that means that
                // the loop doesn't ever go over the last element in the list.
                // That's true because there always is `this.chosenFormat`
                // when `this.matchingFormats` is non-empty.
                // And, for some weird reason, it doesn't think that the case
                // with empty `this.matchingFormats` qualifies for a valid "else" path.
                // So simply muting this `istanbul` warning.
                // It doesn't skip the contents of the `for of` loop,
                // it just skips the `for of` line.
                //
                /* istanbul ignore next */ for(var _iterator2 = $3955603f0ff7ee47$var$_createForOfIteratorHelperLoose(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done;){
                    var _ret = _loop();
                    if (_ret === "break") break;
                    if (_ret === "continue") continue;
                }
                if (!this.chosenFormat) // No format matches the national (significant) phone number.
                this.resetFormat();
                return this.chosenFormat;
            }
        },
        {
            key: "createTemplateForFormat",
            value: function createTemplateForFormat(format, state) {
                // The formatter doesn't format numbers when numberPattern contains '|', e.g.
                // (20|3)\d{4}. In those cases we quickly return.
                // (Though there's no such format in current metadata)
                /* istanbul ignore if */ if ($3955603f0ff7ee47$var$SUPPORT_LEGACY_FORMATTING_PATTERNS && format.pattern().indexOf("|") >= 0) return;
                 // Get formatting template for this phone number format
                var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
                // for any phone number format, then abort.
                if (template) {
                    this.setNationalNumberTemplate(template, state);
                    return true;
                }
            }
        },
        {
            key: "getSeparatorAfterNationalPrefix",
            value: function getSeparatorAfterNationalPrefix(format) {
                // `US` metadata doesn't have a `national_prefix_formatting_rule`,
                // so the `if` condition below doesn't apply to `US`,
                // but in reality there shoudl be a separator
                // between a national prefix and a national (significant) number.
                // So `US` national prefix separator is a "special" "hardcoded" case.
                if (this.isNANP) return " ";
                 // If a `format` has a `national_prefix_formatting_rule`
                // and that rule has a separator after a national prefix,
                // then it means that there should be a separator
                // between a national prefix and a national (significant) number.
                if (format && format.nationalPrefixFormattingRule() && $3955603f0ff7ee47$var$NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) return " ";
                 // At this point, there seems to be no clear evidence that
                // there should be a separator between a national prefix
                // and a national (significant) number. So don't insert one.
                return "";
            }
        },
        {
            key: "getInternationalPrefixBeforeCountryCallingCode",
            value: function getInternationalPrefixBeforeCountryCallingCode(_ref3, options) {
                var IDDPrefix = _ref3.IDDPrefix, missingPlus = _ref3.missingPlus;
                if (IDDPrefix) return options && options.spacing === false ? IDDPrefix : IDDPrefix + " ";
                if (missingPlus) return "";
                return "+";
            }
        },
        {
            key: "getTemplate",
            value: function getTemplate(state) {
                if (!this.template) return;
                 // `this.template` holds the template for a "complete" phone number.
                // The currently entered phone number is most likely not "complete",
                // so trim all non-populated digits.
                var index = -1;
                var i = 0;
                var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
                    spacing: false
                }) : "";
                while(i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length){
                    index = this.template.indexOf((0, $3GzrS.DIGIT_PLACEHOLDER), index + 1);
                    i++;
                }
                return (0, $3GzrS.cutAndStripNonPairedParens)(this.template, index + 1);
            }
        },
        {
            key: "setNationalNumberTemplate",
            value: function setNationalNumberTemplate(template, state) {
                this.nationalNumberTemplate = template;
                this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
                // using the old template needs to be reset.
                this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
                // contains the whole international number
                // if the phone number being input is international:
                // 'x' for the '+' sign, 'x'es for the country phone code,
                // a spacebar and then the template for the formatted national number.
                if (state.international) this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, (0, $3GzrS.DIGIT_PLACEHOLDER)) + (0, $3GzrS.repeat)((0, $3GzrS.DIGIT_PLACEHOLDER), state.callingCode.length) + " " + template;
                else this.template = template;
            }
        },
        {
            key: "getTemplateForFormat",
            value: function getTemplateForFormat(format, _ref4) {
                var nationalSignificantNumber = _ref4.nationalSignificantNumber, international = _ref4.international, nationalPrefix = _ref4.nationalPrefix, complexPrefixBeforeNationalSignificantNumber = _ref4.complexPrefixBeforeNationalSignificantNumber;
                var pattern = format.pattern();
                /* istanbul ignore else */ if ($3955603f0ff7ee47$var$SUPPORT_LEGACY_FORMATTING_PATTERNS) pattern = pattern // Replace anything in the form of [..] with \d
                .replace($3955603f0ff7ee47$var$CREATE_CHARACTER_CLASS_PATTERN(), "\\d") // Replace any standalone digit (not the one in `{}`) with \d
                .replace($3955603f0ff7ee47$var$CREATE_STANDALONE_DIGIT_PATTERN(), "\\d");
                 // Generate a dummy national number (consisting of `9`s)
                // that fits this format's `pattern`.
                //
                // This match will always succeed,
                // because the "longest dummy phone number"
                // has enough length to accomodate any possible
                // national phone number format pattern.
                //
                var digits = $3955603f0ff7ee47$var$LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
                // for any phone number format, then abort.
                if (nationalSignificantNumber.length > digits.length) return;
                 // Get a formatting template which can be used to efficiently format
                // a partial number where digits are added one by one.
                // Below `strictPattern` is used for the
                // regular expression (with `^` and `$`).
                // This wasn't originally in Google's `libphonenumber`
                // and I guess they don't really need it
                // because they're not using "templates" to format phone numbers
                // but I added `strictPattern` after encountering
                // South Korean phone number formatting bug.
                //
                // Non-strict regular expression bug demonstration:
                //
                // this.nationalSignificantNumber : `111111111` (9 digits)
                //
                // pattern : (\d{2})(\d{3,4})(\d{4})
                // format : `$1 $2 $3`
                // digits : `9999999999` (10 digits)
                //
                // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
                //
                // template : xx xxxx xxxx
                //
                // But the correct template in this case is `xx xxx xxxx`.
                // The template was generated incorrectly because of the
                // `{3,4}` variability in the `pattern`.
                //
                // The fix is, if `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
                // is used instead of `digits`.
                var strictPattern = new RegExp("^" + pattern + "$");
                var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, $3955603f0ff7ee47$var$DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
                // to satisfy the `pattern` completely then use it
                // instead of `digits`.
                if (strictPattern.test(nationalNumberDummyDigits)) digits = nationalNumberDummyDigits;
                var numberFormat = this.getFormatFormat(format, international);
                var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
                // and if a `format` does have a national prefix formatting rule,
                // then see if that national prefix formatting rule
                // prepends exactly the same national prefix the user has input.
                // If that's the case, then use the `format` with the national prefix formatting rule.
                // Otherwise, use  the `format` without the national prefix formatting rule,
                // and prepend a national prefix manually to it.
                if (this.shouldTryNationalPrefixFormattingRule(format, {
                    international: international,
                    nationalPrefix: nationalPrefix
                })) {
                    var numberFormatWithNationalPrefix = numberFormat.replace((0, $kU83r.FIRST_GROUP_PATTERN), format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
                    // national prefix at the start of a national (significant) number,
                    // then such formatting can be used with `AsYouType` formatter.
                    // There seems to be no `else` case: everywhere in metadata,
                    // national prefix formatting rule is national prefix + $1,
                    // or `($1)`, in which case such format isn't even considered
                    // when the user has input a national prefix.
                    /* istanbul ignore else */ if ((0, $8CJvs.default)(format.nationalPrefixFormattingRule()) === (nationalPrefix || "") + (0, $8CJvs.default)("$1")) {
                        numberFormat = numberFormatWithNationalPrefix;
                        nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
                        // with `DIGIT_PLACEHOLDER`s.
                        if (nationalPrefix) {
                            var i = nationalPrefix.length;
                            while(i > 0){
                                numberFormat = numberFormat.replace(/\d/, (0, $3GzrS.DIGIT_PLACEHOLDER));
                                i--;
                            }
                        }
                    }
                } // Generate formatting template for this phone number format.
                var template = digits // Format the dummy phone number according to the format.
                .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
                .replace(new RegExp($3955603f0ff7ee47$var$DUMMY_DIGIT, "g"), (0, $3GzrS.DIGIT_PLACEHOLDER)); // If a prefix of a national (significant) number is not as simple
                // as just a basic national prefix, then just prepend such prefix
                // before the national (significant) number, optionally spacing
                // the two with a whitespace.
                if (!nationalPrefixIncludedInTemplate) {
                    if (complexPrefixBeforeNationalSignificantNumber) // Prepend the prefix to the template manually.
                    template = (0, $3GzrS.repeat)((0, $3GzrS.DIGIT_PLACEHOLDER), complexPrefixBeforeNationalSignificantNumber.length) + " " + template;
                    else if (nationalPrefix) // Prepend national prefix to the template manually.
                    template = (0, $3GzrS.repeat)((0, $3GzrS.DIGIT_PLACEHOLDER), nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
                }
                if (international) template = (0, $6uRTn.default)(template);
                return template;
            }
        },
        {
            key: "formatNextNationalNumberDigits",
            value: function formatNextNationalNumberDigits(digits) {
                var result = (0, $3GzrS.populateTemplateWithDigits)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);
                if (!result) {
                    // Reset the format.
                    this.resetFormat();
                    return;
                }
                this.populatedNationalNumberTemplate = result[0];
                this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.
                return (0, $3GzrS.cutAndStripNonPairedParens)(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
            // for `react-phone-number-input`'s default input (`InputBasic`).
            // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
            // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
            }
        },
        {
            key: "shouldTryNationalPrefixFormattingRule",
            value: function shouldTryNationalPrefixFormattingRule(format, _ref5) {
                var international = _ref5.international, nationalPrefix = _ref5.nationalPrefix;
                if (format.nationalPrefixFormattingRule()) {
                    // In some countries, `national_prefix_formatting_rule` is `($1)`,
                    // so it applies even if the user hasn't input a national prefix.
                    // `format.usesNationalPrefix()` detects such cases.
                    var usesNationalPrefix = format.usesNationalPrefix();
                    if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) return true;
                }
            }
        }
    ]);
    return AsYouTypeFormatter;
}();

});
parcelRegister("3GzrS", function(module, exports) {

$parcel$export(module.exports, "DIGIT_PLACEHOLDER", () => $2af0caad3a2abb40$export$2a0174a7c311f338);
$parcel$export(module.exports, "repeat", () => $2af0caad3a2abb40$export$76d90c956114f2c2);
$parcel$export(module.exports, "cutAndStripNonPairedParens", () => $2af0caad3a2abb40$export$ac095dcff0205861);
$parcel$export(module.exports, "populateTemplateWithDigits", () => $2af0caad3a2abb40$export$a15547494b55ca4e);
function $2af0caad3a2abb40$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $2af0caad3a2abb40$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2af0caad3a2abb40$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2af0caad3a2abb40$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2af0caad3a2abb40$var$_arrayLikeToArray(o, minLen);
}
function $2af0caad3a2abb40$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $2af0caad3a2abb40$export$2a0174a7c311f338 = "x"; // '\u2008' (punctuation space)
var $2af0caad3a2abb40$var$DIGIT_PLACEHOLDER_MATCHER = new RegExp($2af0caad3a2abb40$export$2a0174a7c311f338); // Counts all occurences of a symbol in a string.
function $2af0caad3a2abb40$export$af0de81b5898251d(symbol, string) {
    var count = 0; // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for counting brackets it is safe.
    // for (const character of string)
    for(var _iterator = $2af0caad3a2abb40$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        if (character === symbol) count++;
    }
    return count;
} // Repeats a string (or a symbol) N times.
function $2af0caad3a2abb40$export$76d90c956114f2c2(string, times) {
    if (times < 1) return "";
    var result = "";
    while(times > 1){
        if (times & 1) result += string;
        times >>= 1;
        string += string;
    }
    return result + string;
}
function $2af0caad3a2abb40$export$ac095dcff0205861(string, cutBeforeIndex) {
    if (string[cutBeforeIndex] === ")") cutBeforeIndex++;
    return $2af0caad3a2abb40$export$a464e056bc212edb(string.slice(0, cutBeforeIndex));
}
function $2af0caad3a2abb40$export$54ba366c9ffed8f9(template, cut_before) {
    var retained_template = template.slice(0, cut_before);
    var opening_braces = $2af0caad3a2abb40$export$af0de81b5898251d("(", retained_template);
    var closing_braces = $2af0caad3a2abb40$export$af0de81b5898251d(")", retained_template);
    var dangling_braces = opening_braces - closing_braces;
    while(dangling_braces > 0 && cut_before < template.length){
        if (template[cut_before] === ")") dangling_braces--;
        cut_before++;
    }
    return template.slice(0, cut_before);
}
function $2af0caad3a2abb40$export$a464e056bc212edb(string) {
    var dangling_braces = [];
    var i = 0;
    while(i < string.length){
        if (string[i] === "(") dangling_braces.push(i);
        else if (string[i] === ")") dangling_braces.pop();
        i++;
    }
    var start = 0;
    var cleared_string = "";
    dangling_braces.push(string.length);
    for(var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++){
        var index = _dangling_braces[_i];
        cleared_string += string.slice(start, index);
        start = index + 1;
    }
    return cleared_string;
}
function $2af0caad3a2abb40$export$a15547494b55ca4e(template, position, digits) {
    // Using `.split('')` to iterate through a string here
    // to avoid requiring `Symbol.iterator` polyfill.
    // `.split('')` is generally not safe for Unicode,
    // but in this particular case for `digits` it is safe.
    // for (const digit of digits)
    for(var _iterator2 = $2af0caad3a2abb40$var$_createForOfIteratorHelperLoose(digits.split("")), _step2; !(_step2 = _iterator2()).done;){
        var digit = _step2.value;
        // If there is room for more digits in current `template`,
        // then set the next digit in the `template`,
        // and return the formatted digits so far.
        // If more digits are entered than the current format could handle.
        if (template.slice(position + 1).search($2af0caad3a2abb40$var$DIGIT_PLACEHOLDER_MATCHER) < 0) return;
        position = template.search($2af0caad3a2abb40$var$DIGIT_PLACEHOLDER_MATCHER);
        template = template.replace($2af0caad3a2abb40$var$DIGIT_PLACEHOLDER_MATCHER, digit);
    }
    return [
        template,
        position
    ];
}

});

parcelRegister("dT8F8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1c72197b50632be$export$2e2bcd8739ae039);
$parcel$export(module.exports, "canFormatCompleteNumber", () => $a1c72197b50632be$export$9e33d25ea5d3e526);

var $ct34l = parcelRequire("ct34l");

var $8CJvs = parcelRequire("8CJvs");

var $kU83r = parcelRequire("kU83r");
function $a1c72197b50632be$export$2e2bcd8739ae039(state, format, _ref) {
    var metadata = _ref.metadata, shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
    var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));
    if (matcher.test(state.nationalSignificantNumber)) return $a1c72197b50632be$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
        metadata: metadata,
        shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
}
function $a1c72197b50632be$export$9e33d25ea5d3e526(nationalSignificantNumber, metadata) {
    return (0, $ct34l.default)(nationalSignificantNumber, metadata) === "IS_POSSIBLE";
}
function $a1c72197b50632be$var$formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
    var metadata = _ref2.metadata, shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
    // `format` has already been checked for `nationalPrefix` requirement.
    var nationalSignificantNumber = state.nationalSignificantNumber, international = state.international, nationalPrefix = state.nationalPrefix, carrierCode = state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
    // If the resulting formatted number is a valid formatted number, then return it.
    //
    // Google's AsYouType formatter is different in a way that it doesn't try
    // to format using the "national prefix formatting rule", and instead it
    // simply prepends a national prefix followed by a " " character.
    // This code does that too, but as a fallback.
    // The reason is that "national prefix formatting rule" may use parentheses,
    // which wouldn't be included has it used the simpler Google's way.
    //
    if (shouldTryNationalPrefixFormattingRule(format)) {
        var formattedNumber = $a1c72197b50632be$var$formatNationalNumber(state, format, {
            useNationalPrefixFormattingRule: true,
            getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
            metadata: metadata
        });
        if (formattedNumber) return formattedNumber;
    } // Format the number without using `national_prefix_formatting_rule`.
    return $a1c72197b50632be$var$formatNationalNumber(state, format, {
        useNationalPrefixFormattingRule: false,
        getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
        metadata: metadata
    });
}
function $a1c72197b50632be$var$formatNationalNumber(state, format, _ref3) {
    var metadata = _ref3.metadata, useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule, getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
    var formattedNationalNumber = (0, $kU83r.default)(state.nationalSignificantNumber, format, {
        carrierCode: state.carrierCode,
        useInternationalFormat: state.international,
        withNationalPrefix: useNationalPrefixFormattingRule,
        metadata: metadata
    });
    if (!useNationalPrefixFormattingRule) {
        if (state.nationalPrefix) // If a national prefix was extracted, then just prepend it,
        // followed by a " " character.
        formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
        else if (state.complexPrefixBeforeNationalSignificantNumber) formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + " " + formattedNationalNumber;
    }
    if ($a1c72197b50632be$var$isValidFormattedNationalNumber(formattedNationalNumber, state)) return formattedNationalNumber;
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//
function $a1c72197b50632be$var$isValidFormattedNationalNumber(formattedNationalNumber, state) {
    return (0, $8CJvs.default)(formattedNationalNumber) === state.getNationalDigits();
}

});
parcelRegister("8CJvs", function(module, exports) {

$parcel$export(module.exports, "parseDigit", () => $64752bf0f25787b0$export$1d16fddea1437169);
$parcel$export(module.exports, "default", () => $64752bf0f25787b0$export$2e2bcd8739ae039);
function $64752bf0f25787b0$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $64752bf0f25787b0$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $64752bf0f25787b0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $64752bf0f25787b0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $64752bf0f25787b0$var$_arrayLikeToArray(o, minLen);
}
function $64752bf0f25787b0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $64752bf0f25787b0$export$2848f3d68c08fe69 = {
    "0": "0",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "\uFF10": "0",
    // Fullwidth digit 0
    "\uFF11": "1",
    // Fullwidth digit 1
    "\uFF12": "2",
    // Fullwidth digit 2
    "\uFF13": "3",
    // Fullwidth digit 3
    "\uFF14": "4",
    // Fullwidth digit 4
    "\uFF15": "5",
    // Fullwidth digit 5
    "\uFF16": "6",
    // Fullwidth digit 6
    "\uFF17": "7",
    // Fullwidth digit 7
    "\uFF18": "8",
    // Fullwidth digit 8
    "\uFF19": "9",
    // Fullwidth digit 9
    "\u0660": "0",
    // Arabic-indic digit 0
    "\u0661": "1",
    // Arabic-indic digit 1
    "\u0662": "2",
    // Arabic-indic digit 2
    "\u0663": "3",
    // Arabic-indic digit 3
    "\u0664": "4",
    // Arabic-indic digit 4
    "\u0665": "5",
    // Arabic-indic digit 5
    "\u0666": "6",
    // Arabic-indic digit 6
    "\u0667": "7",
    // Arabic-indic digit 7
    "\u0668": "8",
    // Arabic-indic digit 8
    "\u0669": "9",
    // Arabic-indic digit 9
    "\u06F0": "0",
    // Eastern-Arabic digit 0
    "\u06F1": "1",
    // Eastern-Arabic digit 1
    "\u06F2": "2",
    // Eastern-Arabic digit 2
    "\u06F3": "3",
    // Eastern-Arabic digit 3
    "\u06F4": "4",
    // Eastern-Arabic digit 4
    "\u06F5": "5",
    // Eastern-Arabic digit 5
    "\u06F6": "6",
    // Eastern-Arabic digit 6
    "\u06F7": "7",
    // Eastern-Arabic digit 7
    "\u06F8": "8",
    // Eastern-Arabic digit 8
    "\u06F9": "9" // Eastern-Arabic digit 9
};
function $64752bf0f25787b0$export$1d16fddea1437169(character) {
    return $64752bf0f25787b0$export$2848f3d68c08fe69[character];
}
function $64752bf0f25787b0$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $64752bf0f25787b0$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $64752bf0f25787b0$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}

});


parcelRegister("7vGJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $577c94e446569035$export$2e2bcd8739ae039);

var $euQpX = parcelRequire("euQpX");
function $577c94e446569035$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $577c94e446569035$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $577c94e446569035$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $577c94e446569035$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $577c94e446569035$var$_arrayLikeToArray(o, minLen);
}
function $577c94e446569035$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $577c94e446569035$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $577c94e446569035$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $577c94e446569035$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $577c94e446569035$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $577c94e446569035$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $577c94e446569035$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PatternMatcher(pattern) {
        $577c94e446569035$var$_classCallCheck(this, PatternMatcher);
        this.matchTree = new (0, $euQpX.default)().parse(pattern);
    }
    $577c94e446569035$var$_createClass(PatternMatcher, [
        {
            key: "match",
            value: function match(string) {
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, allowOverflow = _ref.allowOverflow;
                if (!string) throw new Error("String is required");
                var result = $577c94e446569035$var$_match(string.split(""), this.matchTree, true);
                if (result && result.match) delete result.matchedChars;
                if (result && result.overflow) {
                    if (!allowOverflow) return;
                }
                return result;
            }
        }
    ]);
    return PatternMatcher;
}();
function $577c94e446569035$var$_match(characters, tree, last) {
    // If `tree` is a string, then `tree` is a single character.
    // That's because when a pattern is parsed, multi-character-string parts
    // of a pattern are compiled into arrays of single characters.
    // I still wrote this piece of code for a "general" hypothetical case
    // when `tree` could be a string of several characters, even though
    // such case is not possible with the current implementation.
    if (typeof tree === "string") {
        var characterString = characters.join("");
        if (tree.indexOf(characterString) === 0) {
            // `tree` is always a single character.
            // If `tree.indexOf(characterString) === 0`
            // then `characters.length === tree.length`.
            /* istanbul ignore else */ if (characters.length === tree.length) return {
                match: true,
                matchedChars: characters
            };
             // `tree` is always a single character.
            // If `tree.indexOf(characterString) === 0`
            // then `characters.length === tree.length`.
            /* istanbul ignore next */ return {
                partialMatch: true // matchedChars: characters
            };
        }
        if (characterString.indexOf(tree) === 0) {
            if (last) {
                // The `else` path is not possible because `tree` is always a single character.
                // The `else` case for `characters.length > tree.length` would be
                // `characters.length <= tree.length` which means `characters.length <= 1`.
                // `characters` array can't be empty, so that means `characters === [tree]`,
                // which would also mean `tree.indexOf(characterString) === 0` and that'd mean
                // that the `if (tree.indexOf(characterString) === 0)` condition before this
                // `if` condition would be entered, and returned from there, not reaching this code.
                /* istanbul ignore else */ if (characters.length > tree.length) return {
                    overflow: true
                };
            }
            return {
                match: true,
                matchedChars: characters.slice(0, tree.length)
            };
        }
        return;
    }
    if (Array.isArray(tree)) {
        var restCharacters = characters.slice();
        var i = 0;
        while(i < tree.length){
            var subtree = tree[i];
            var result = $577c94e446569035$var$_match(restCharacters, subtree, last && i === tree.length - 1);
            if (!result) return;
            else if (result.overflow) return result;
            else if (result.match) {
                // Continue with the next subtree with the rest of the characters.
                restCharacters = restCharacters.slice(result.matchedChars.length);
                if (restCharacters.length === 0) {
                    if (i === tree.length - 1) return {
                        match: true,
                        matchedChars: characters
                    };
                    else return {
                        partialMatch: true // matchedChars: characters
                    };
                }
            } else {
                /* istanbul ignore else */ if (result.partialMatch) return {
                    partialMatch: true // matchedChars: characters
                };
                else throw new Error("Unsupported match result:\n".concat(JSON.stringify(result, null, 2)));
            }
            i++;
        } // If `last` then overflow has already been checked
        // by the last element of the `tree` array.
        /* istanbul ignore if */ if (last) return {
            overflow: true
        };
        return {
            match: true,
            matchedChars: characters.slice(0, characters.length - restCharacters.length)
        };
    }
    switch(tree.op){
        case "|":
            var partialMatch;
            for(var _iterator = $577c94e446569035$var$_createForOfIteratorHelperLoose(tree.args), _step; !(_step = _iterator()).done;){
                var branch = _step.value;
                var _result = $577c94e446569035$var$_match(characters, branch, last);
                if (_result) {
                    if (_result.overflow) return _result;
                    else if (_result.match) return {
                        match: true,
                        matchedChars: _result.matchedChars
                    };
                    else {
                        /* istanbul ignore else */ if (_result.partialMatch) partialMatch = true;
                        else throw new Error("Unsupported match result:\n".concat(JSON.stringify(_result, null, 2)));
                    }
                }
            }
            if (partialMatch) return {
                partialMatch: true // matchedChars: ...
            };
             // Not even a partial match.
            return;
        case "[]":
            for(var _iterator2 = $577c94e446569035$var$_createForOfIteratorHelperLoose(tree.args), _step2; !(_step2 = _iterator2()).done;){
                var _char = _step2.value;
                if (characters[0] === _char) {
                    if (characters.length === 1) return {
                        match: true,
                        matchedChars: characters
                    };
                    if (last) return {
                        overflow: true
                    };
                    return {
                        match: true,
                        matchedChars: [
                            _char
                        ]
                    };
                }
            } // No character matches.
            return;
        /* istanbul ignore next */ default:
            throw new Error("Unsupported instruction tree: ".concat(tree));
    }
}

});
parcelRegister("euQpX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8dc8717f76b8774$export$2e2bcd8739ae039);
function $a8dc8717f76b8774$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a8dc8717f76b8774$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a8dc8717f76b8774$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a8dc8717f76b8774$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a8dc8717f76b8774$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $a8dc8717f76b8774$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PatternParser() {
        $a8dc8717f76b8774$var$_classCallCheck(this, PatternParser);
    }
    $a8dc8717f76b8774$var$_createClass(PatternParser, [
        {
            key: "parse",
            value: function parse(pattern) {
                this.context = [
                    {
                        or: true,
                        instructions: []
                    }
                ];
                this.parsePattern(pattern);
                if (this.context.length !== 1) throw new Error("Non-finalized contexts left when pattern parse ended");
                var _this$context$ = this.context[0], branches = _this$context$.branches, instructions = _this$context$.instructions;
                if (branches) return {
                    op: "|",
                    args: branches.concat([
                        $a8dc8717f76b8774$var$expandSingleElementArray(instructions)
                    ])
                };
                /* istanbul ignore if */ if (instructions.length === 0) throw new Error("Pattern is required");
                if (instructions.length === 1) return instructions[0];
                return instructions;
            }
        },
        {
            key: "startContext",
            value: function startContext(context) {
                this.context.push(context);
            }
        },
        {
            key: "endContext",
            value: function endContext() {
                this.context.pop();
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                return this.context[this.context.length - 1];
            }
        },
        {
            key: "parsePattern",
            value: function parsePattern(pattern) {
                if (!pattern) throw new Error("Pattern is required");
                var match = pattern.match($a8dc8717f76b8774$var$OPERATOR);
                if (!match) {
                    if ($a8dc8717f76b8774$var$ILLEGAL_CHARACTER_REGEXP.test(pattern)) throw new Error("Illegal characters found in a pattern: ".concat(pattern));
                    this.getContext().instructions = this.getContext().instructions.concat(pattern.split(""));
                    return;
                }
                var operator = match[1];
                var before = pattern.slice(0, match.index);
                var rightPart = pattern.slice(match.index + operator.length);
                switch(operator){
                    case "(?:":
                        if (before) this.parsePattern(before);
                        this.startContext({
                            or: true,
                            instructions: [],
                            branches: []
                        });
                        break;
                    case ")":
                        if (!this.getContext().or) throw new Error('")" operator must be preceded by "(?:" operator');
                        if (before) this.parsePattern(before);
                        if (this.getContext().instructions.length === 0) throw new Error('No instructions found after "|" operator in an "or" group');
                        var _this$getContext = this.getContext(), branches = _this$getContext.branches;
                        branches.push($a8dc8717f76b8774$var$expandSingleElementArray(this.getContext().instructions));
                        this.endContext();
                        this.getContext().instructions.push({
                            op: "|",
                            args: branches
                        });
                        break;
                    case "|":
                        if (!this.getContext().or) throw new Error('"|" operator can only be used inside "or" groups');
                        if (before) this.parsePattern(before);
                         // The top-level is an implicit "or" group, if required.
                        if (!this.getContext().branches) {
                            // `branches` are not defined only for the root implicit "or" operator.
                            /* istanbul ignore else */ if (this.context.length === 1) this.getContext().branches = [];
                            else throw new Error('"branches" not found in an "or" group context');
                        }
                        this.getContext().branches.push($a8dc8717f76b8774$var$expandSingleElementArray(this.getContext().instructions));
                        this.getContext().instructions = [];
                        break;
                    case "[":
                        if (before) this.parsePattern(before);
                        this.startContext({
                            oneOfSet: true
                        });
                        break;
                    case "]":
                        if (!this.getContext().oneOfSet) throw new Error('"]" operator must be preceded by "[" operator');
                        this.endContext();
                        this.getContext().instructions.push({
                            op: "[]",
                            args: $a8dc8717f76b8774$var$parseOneOfSet(before)
                        });
                        break;
                    /* istanbul ignore next */ default:
                        throw new Error("Unknown operator: ".concat(operator));
                }
                if (rightPart) this.parsePattern(rightPart);
            }
        }
    ]);
    return PatternParser;
}();
function $a8dc8717f76b8774$var$parseOneOfSet(pattern) {
    var values = [];
    var i = 0;
    while(i < pattern.length){
        if (pattern[i] === "-") {
            if (i === 0 || i === pattern.length - 1) throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
            var prevValue = pattern[i - 1].charCodeAt(0) + 1;
            var nextValue = pattern[i + 1].charCodeAt(0) - 1;
            var value = prevValue;
            while(value <= nextValue){
                values.push(String.fromCharCode(value));
                value++;
            }
        } else values.push(pattern[i]);
        i++;
    }
    return values;
}
var $a8dc8717f76b8774$var$ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/;
var $a8dc8717f76b8774$var$OPERATOR = new RegExp("(\\||\\(\\?\\:|\\)|\\[|\\])");
function $a8dc8717f76b8774$var$expandSingleElementArray(array) {
    if (array.length === 1) return array[0];
    return array;
}

});



parcelRegister("jXuK7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e87b5fe38ec7941e$export$2e2bcd8739ae039);

var $hq6Lf = parcelRequire("hq6Lf");

var $ctFk7 = parcelRequire("ctFk7");

var $5Xvib = parcelRequire("5Xvib");

var $9vIpU = parcelRequire("9vIpU");

var $8CJvs = parcelRequire("8CJvs");

var $e78xe = parcelRequire("e78xe");
function $e87b5fe38ec7941e$var$_slicedToArray(arr, i) {
    return $e87b5fe38ec7941e$var$_arrayWithHoles(arr) || $e87b5fe38ec7941e$var$_iterableToArrayLimit(arr, i) || $e87b5fe38ec7941e$var$_unsupportedIterableToArray(arr, i) || $e87b5fe38ec7941e$var$_nonIterableRest();
}
function $e87b5fe38ec7941e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e87b5fe38ec7941e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e87b5fe38ec7941e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e87b5fe38ec7941e$var$_arrayLikeToArray(o, minLen);
}
function $e87b5fe38ec7941e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e87b5fe38ec7941e$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e87b5fe38ec7941e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e87b5fe38ec7941e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e87b5fe38ec7941e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e87b5fe38ec7941e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e87b5fe38ec7941e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e87b5fe38ec7941e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $e87b5fe38ec7941e$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = "[" + (0, $e78xe.VALID_PUNCTUATION) + (0, $e78xe.VALID_DIGITS) + "]+";
var $e87b5fe38ec7941e$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp("^" + $e87b5fe38ec7941e$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + "$", "i");
var $e87b5fe38ec7941e$var$VALID_FORMATTED_PHONE_NUMBER_PART = "(?:[" + (0, $e78xe.PLUS_CHARS) + "]" + "[" + (0, $e78xe.VALID_PUNCTUATION) + (0, $e78xe.VALID_DIGITS) + "]*" + "|" + "[" + (0, $e78xe.VALID_PUNCTUATION) + (0, $e78xe.VALID_DIGITS) + "]+" + ")";
var $e87b5fe38ec7941e$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp("[^" + (0, $e78xe.VALID_PUNCTUATION) + (0, $e78xe.VALID_DIGITS) + "]+" + ".*" + "$"); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.
var $e87b5fe38ec7941e$var$COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;
var $e87b5fe38ec7941e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AsYouTypeParser(_ref) {
        var defaultCountry = _ref.defaultCountry, defaultCallingCode = _ref.defaultCallingCode, metadata = _ref.metadata, onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;
        $e87b5fe38ec7941e$var$_classCallCheck(this, AsYouTypeParser);
        this.defaultCountry = defaultCountry;
        this.defaultCallingCode = defaultCallingCode;
        this.metadata = metadata;
        this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
    }
    $e87b5fe38ec7941e$var$_createClass(AsYouTypeParser, [
        {
            key: "input",
            value: function input(text, state) {
                var _extractFormattedDigi = $e87b5fe38ec7941e$export$84f1aacb72e7dba5(text), _extractFormattedDigi2 = $e87b5fe38ec7941e$var$_slicedToArray(_extractFormattedDigi, 2), formattedDigits = _extractFormattedDigi2[0], hasPlus = _extractFormattedDigi2[1];
                var digits = (0, $8CJvs.default)(formattedDigits); // Checks for a special case: just a leading `+` has been entered.
                var justLeadingPlus;
                if (hasPlus) {
                    if (!state.digits) {
                        state.startInternationalNumber();
                        if (!digits) justLeadingPlus = true;
                    }
                }
                if (digits) this.inputDigits(digits, state);
                return {
                    digits: digits,
                    justLeadingPlus: justLeadingPlus
                };
            }
        },
        {
            key: "inputDigits",
            value: function inputDigits(nextDigits, state) {
                var digits = state.digits;
                var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.
                state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
                // Some users input their phone number in international format,
                // but in an "out-of-country" dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers as soon as there're at least 3 digits.
                // Google's library attempts to extract IDD prefix at 3 digits,
                // so this library just copies that behavior.
                // I guess that's because the most commot IDD prefixes are
                // `00` (Europe) and `011` (US).
                // There exist really long IDD prefixes too:
                // for example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                // An IDD prefix is extracted here, and then every time when
                // there's a new digit and the number couldn't be formatted.
                if (hasReceivedThreeLeadingDigits) this.extractIddPrefix(state);
                if (this.isWaitingForCountryCallingCode(state)) {
                    if (!this.extractCountryCallingCode(state)) return;
                } else state.appendNationalSignificantNumberDigits(nextDigits);
                 // If a phone number is being input in international format,
                // then it's not valid for it to have a national prefix.
                // Still, some people incorrectly input such numbers with a national prefix.
                // In such cases, only attempt to strip a national prefix if the number becomes too long.
                // (but that is done later, not here)
                if (!state.international) {
                    if (!this.hasExtractedNationalSignificantNumber) this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
                        return state.update(stateUpdate);
                    });
                }
            }
        },
        {
            key: "isWaitingForCountryCallingCode",
            value: function isWaitingForCountryCallingCode(_ref2) {
                var international = _ref2.international, callingCode = _ref2.callingCode;
                return international && !callingCode;
            } // Extracts a country calling code from a number
        },
        {
            key: "extractCountryCallingCode",
            value: function extractCountryCallingCode(state) {
                var _extractCountryCallin = (0, $hq6Lf.default)("+" + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
                if (countryCallingCode) {
                    state.setCallingCode(countryCallingCode);
                    state.update({
                        nationalSignificantNumber: number
                    });
                    return true;
                }
            }
        },
        {
            key: "reset",
            value: function reset(numberingPlan) {
                if (numberingPlan) {
                    this.hasSelectedNumberingPlan = true;
                    var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && $e87b5fe38ec7941e$var$COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
                } else {
                    this.hasSelectedNumberingPlan = undefined;
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractNationalSignificantNumber",
            value: function extractNationalSignificantNumber(nationalDigits, setState) {
                if (!this.hasSelectedNumberingPlan) return;
                var _extractNationalNumbe = (0, $5Xvib.default)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe.nationalPrefix, nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
                if (nationalNumber === nationalDigits) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "extractAnotherNationalSignificantNumber",
            value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
                if (!this.hasExtractedNationalSignificantNumber) return this.extractNationalSignificantNumber(nationalDigits, setState);
                if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) return;
                var _extractNationalNumbe2 = (0, $5Xvib.default)(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe2.nationalPrefix, nationalNumber = _extractNationalNumbe2.nationalNumber, carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
                // then it's always extracted as additional digits are added.
                // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
                // doesn't do anything different from what it currently does.
                // So, just in case, here's this check, though it doesn't occur.
                /* istanbul ignore if */ if (nationalNumber === prevNationalSignificantNumber) return;
                this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
                return true;
            }
        },
        {
            key: "onExtractedNationalNumber",
            value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
                var complexPrefixBeforeNationalSignificantNumber;
                var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.
                var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
                // last substring of the `digits`, then it means that it hasn't been altered:
                // no digits have been removed from the national (significant) number
                // while applying `national_prefix_transform_rule`.
                // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
                if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
                    nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
                    // as just a basic national prefix, then such prefix is stored in
                    // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
                    // prepended "as is" to the national (significant) number to produce
                    // a formatted result.
                    var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
                    // because `onExtractedNationalNumber()` isn't called
                    // when a national (significant) number hasn't been actually "extracted":
                    // when a national (significant) number is equal to the national part of `digits`,
                    // then `onExtractedNationalNumber()` doesn't get called.
                    if (prefixBeforeNationalNumber !== nationalPrefix) complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
                }
                setState({
                    nationalPrefix: nationalPrefix,
                    carrierCode: carrierCode,
                    nationalSignificantNumber: nationalSignificantNumber,
                    nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
                    complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
                }); // `onExtractedNationalNumber()` is only called when
                // the national (significant) number actually did change.
                this.hasExtractedNationalSignificantNumber = true;
                this.onNationalSignificantNumberChange();
            }
        },
        {
            key: "reExtractNationalSignificantNumber",
            value: function reExtractNationalSignificantNumber(state) {
                // Attempt to extract a national prefix.
                //
                // Some people incorrectly input national prefix
                // in an international phone number.
                // For example, some people write British phone numbers as `+44(0)...`.
                //
                // Also, in some rare cases, it is valid for a national prefix
                // to be a part of an international phone number.
                // For example, mobile phone numbers in Mexico are supposed to be
                // dialled internationally using a `1` national prefix,
                // so the national prefix will be part of an international number.
                //
                // Quote from:
                // https://www.mexperience.com/dialing-cell-phones-in-mexico/
                //
                // "Dialing a Mexican cell phone from abroad
                // When you are calling a cell phone number in Mexico from outside Mexico,
                // it’s necessary to dial an additional “1” after Mexico’s country code
                // (which is “52”) and before the area code.
                // You also ignore the 045, and simply dial the area code and the
                // cell phone’s number.
                //
                // If you don’t add the “1”, you’ll receive a recorded announcement
                // asking you to redial using it.
                //
                // For example, if you are calling from the USA to a cell phone
                // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
                // (Note that this is different to calling a land line in Mexico City
                // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
                //
                // Google's demo output:
                // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
                //
                if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function(stateUpdate) {
                    return state.update(stateUpdate);
                })) return true;
                 // If no format matches the phone number, then it could be
                // "a really long IDD" (quote from a comment in Google's library).
                // An IDD prefix is first extracted when the user has entered at least 3 digits,
                // and then here — every time when there's a new digit and the number
                // couldn't be formatted.
                // For example, in Australia the default IDD prefix is `0011`,
                // and it could even be as long as `14880011`.
                //
                // Could also check `!hasReceivedThreeLeadingDigits` here
                // to filter out the case when this check duplicates the one
                // already performed when there're 3 leading digits,
                // but it's not a big deal, and in most cases there
                // will be a suitable `format` when there're 3 leading digits.
                //
                if (this.extractIddPrefix(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                } // Google's AsYouType formatter supports sort of an "autocorrection" feature
                // when it "autocorrects" numbers that have been input for a country
                // with that country's calling code.
                // Such "autocorrection" feature looks weird, but different people have been requesting it:
                // https://github.com/catamphetamine/libphonenumber-js/issues/376
                // https://github.com/catamphetamine/libphonenumber-js/issues/375
                // https://github.com/catamphetamine/libphonenumber-js/issues/316
                if (this.fixMissingPlus(state)) {
                    this.extractCallingCodeAndNationalSignificantNumber(state);
                    return true;
                }
            }
        },
        {
            key: "extractIddPrefix",
            value: function extractIddPrefix(state) {
                // An IDD prefix can't be present in a number written with a `+`.
                // Also, don't re-extract an IDD prefix if has already been extracted.
                var international = state.international, IDDPrefix = state.IDDPrefix, digits = state.digits, nationalSignificantNumber = state.nationalSignificantNumber;
                if (international || IDDPrefix) return;
                 // Some users input their phone number in "out-of-country"
                // dialing format instead of using the leading `+`.
                // https://github.com/catamphetamine/libphonenumber-js/issues/185
                // Detect such numbers.
                var numberWithoutIDD = (0, $9vIpU.default)(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
                if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
                    // If an IDD prefix was stripped then convert the IDD-prefixed number
                    // to international number for subsequent parsing.
                    state.update({
                        IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
                    });
                    this.startInternationalNumber(state, {
                        country: undefined,
                        callingCode: undefined
                    });
                    return true;
                }
            }
        },
        {
            key: "fixMissingPlus",
            value: function fixMissingPlus(state) {
                if (!state.international) {
                    var _extractCountryCallin2 = (0, $ctFk7.default)(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), newCallingCode = _extractCountryCallin2.countryCallingCode, number = _extractCountryCallin2.number;
                    if (newCallingCode) {
                        state.update({
                            missingPlus: true
                        });
                        this.startInternationalNumber(state, {
                            country: state.country,
                            callingCode: newCallingCode
                        });
                        return true;
                    }
                }
            }
        },
        {
            key: "startInternationalNumber",
            value: function startInternationalNumber(state, _ref3) {
                var country = _ref3.country, callingCode = _ref3.callingCode;
                state.startInternationalNumber(country, callingCode); // If a national (significant) number has been extracted before, reset it.
                if (state.nationalSignificantNumber) {
                    state.resetNationalSignificantNumber();
                    this.onNationalSignificantNumberChange();
                    this.hasExtractedNationalSignificantNumber = undefined;
                }
            }
        },
        {
            key: "extractCallingCodeAndNationalSignificantNumber",
            value: function extractCallingCodeAndNationalSignificantNumber(state) {
                if (this.extractCountryCallingCode(state)) // `this.extractCallingCode()` is currently called when the number
                // couldn't be formatted during the standard procedure.
                // Normally, the national prefix would be re-extracted
                // for an international number if such number couldn't be formatted,
                // but since it's already not able to be formatted,
                // there won't be yet another retry, so also extract national prefix here.
                this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
                    return state.update(stateUpdate);
                });
            }
        }
    ]);
    return AsYouTypeParser;
}();
function $e87b5fe38ec7941e$var$extractFormattedPhoneNumber(text) {
    // Attempt to extract a possible number from the string passed in.
    var startsAt = text.search($e87b5fe38ec7941e$var$VALID_FORMATTED_PHONE_NUMBER_PART);
    if (startsAt < 0) return;
     // Trim everything to the left of the phone number.
    text = text.slice(startsAt); // Trim the `+`.
    var hasPlus;
    if (text[0] === "+") {
        hasPlus = true;
        text = text.slice(1);
    } // Trim everything to the right of the phone number.
    text = text.replace($e87b5fe38ec7941e$var$AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ""); // Re-add the previously trimmed `+`.
    if (hasPlus) text = "+" + text;
    return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */ function $e87b5fe38ec7941e$var$_extractFormattedDigitsAndPlus(text) {
    // Extract a formatted phone number part from text.
    var extractedNumber = $e87b5fe38ec7941e$var$extractFormattedPhoneNumber(text) || ""; // Trim a `+`.
    if (extractedNumber[0] === "+") return [
        extractedNumber.slice(1),
        true
    ];
    return [
        extractedNumber
    ];
}
function $e87b5fe38ec7941e$export$84f1aacb72e7dba5(text) {
    var _extractFormattedDigi3 = $e87b5fe38ec7941e$var$_extractFormattedDigitsAndPlus(text), _extractFormattedDigi4 = $e87b5fe38ec7941e$var$_slicedToArray(_extractFormattedDigi3, 2), formattedDigits = _extractFormattedDigi4[0], hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
    // can possibly be a part of some valid phone number
    // then parse phone number characters from a formatted phone number.
    if (!$e87b5fe38ec7941e$var$VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) formattedDigits = "";
    return [
        formattedDigits,
        hasPlus
    ];
}

});

parcelRegister("iotMN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64192cb8e6ab0f0$export$2e2bcd8739ae039);

var $icOY5 = parcelRequire("icOY5");
var $d64192cb8e6ab0f0$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $d64192cb8e6ab0f0$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($d64192cb8e6ab0f0$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return "001";
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $icOY5.default)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}

});
parcelRegister("icOY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d410e230bdd7ee52$export$2e2bcd8739ae039);

var $7t6iH = parcelRequire("7t6iH");

var $iDRUh = parcelRequire("iDRUh");
function $d410e230bdd7ee52$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d410e230bdd7ee52$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d410e230bdd7ee52$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d410e230bdd7ee52$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d410e230bdd7ee52$var$_arrayLikeToArray(o, minLen);
}
function $d410e230bdd7ee52$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d410e230bdd7ee52$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $7t6iH.default)(metadata); // const matchingCountries = []
    for(var _iterator = $d410e230bdd7ee52$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $iDRUh.default)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) // If both the `defaultCountry` and the "main" one match the phone number,
        // don't prefer the `defaultCountry` over the "main" one.
        // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
        return country; // // If the `defaultCountry` is among the `matchingCountries` then return it.
    } // // Return the first ("main") one of the `matchingCountries`.
// if (matchingCountries.length > 0) {
// 	return matchingCountries[0]
// }
}

});




parcelRegister("iYaNE", function(module, exports) {

$parcel$export(module.exports, "formatIncompletePhoneNumber", () => $dcf6353322b890ab$export$2ea1a6ddf8ad24d2);

var $5AEiK = parcelRequire("5AEiK");

var $jBr4H = parcelRequire("jBr4H");
function $dcf6353322b890ab$export$2ea1a6ddf8ad24d2() {
    return (0, $5AEiK.default)((0, $jBr4H.default), arguments);
}

});
parcelRegister("jBr4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4567987f9ec111b$export$2e2bcd8739ae039);

var $gAlXg = parcelRequire("gAlXg");
function $e4567987f9ec111b$export$2e2bcd8739ae039(value, optionsOrDefaultCountry, metadata) {
    if (!metadata) {
        metadata = optionsOrDefaultCountry;
        optionsOrDefaultCountry = undefined;
    }
    return new (0, $gAlXg.default)(optionsOrDefaultCountry, metadata).input(value);
}

});


parcelRegister("bcYIH", function(module, exports) {

$parcel$export(module.exports, "getCountryCallingCode", () => $828fea6b22d14ce5$export$32876ca2f1919cf0);

var $5AEiK = parcelRequire("5AEiK");

var $7t6iH = parcelRequire("7t6iH");
function $828fea6b22d14ce5$export$32876ca2f1919cf0() {
    return (0, $5AEiK.default)((0, $7t6iH.getCountryCallingCode), arguments);
}

});

parcelRegister("4Sqx5", function(module, exports) {

$parcel$export(module.exports, "getExampleNumber", () => $38d0c9699b166d00$export$8d138e316fcc113);

var $5AEiK = parcelRequire("5AEiK");

var $has23 = parcelRequire("has23");
function $38d0c9699b166d00$export$8d138e316fcc113() {
    return (0, $5AEiK.default)((0, $has23.default), arguments);
}

});
parcelRegister("has23", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7f91d7004078a20$export$2e2bcd8739ae039);

var $40ywJ = parcelRequire("40ywJ");
function $c7f91d7004078a20$export$2e2bcd8739ae039(country, examples, metadata) {
    if (examples[country]) return new (0, $40ywJ.default)(country, examples[country], metadata);
}

});


parcelRegister("72S2h", function(module, exports) {

$parcel$export(module.exports, "validatePhoneNumberLength", () => $5212a2aa3087c69a$export$13219010f133c5b0);

var $5AEiK = parcelRequire("5AEiK");

var $1ENZp = parcelRequire("1ENZp");
function $5212a2aa3087c69a$export$13219010f133c5b0() {
    return (0, $5AEiK.default)((0, $1ENZp.default), arguments);
}

});
parcelRegister("1ENZp", function(module, exports) {

$parcel$export(module.exports, "default", () => $13504dc1be0a8aab$export$2e2bcd8739ae039);

var $1XdsL = parcelRequire("1XdsL");

var $fYkMF = parcelRequire("fYkMF");

var $hXblZ = parcelRequire("hXblZ");

var $7t6iH = parcelRequire("7t6iH");

var $ct34l = parcelRequire("ct34l");
function $13504dc1be0a8aab$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $13504dc1be0a8aab$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $13504dc1be0a8aab$var$ownKeys(Object(source), !0).forEach(function(key) {
            $13504dc1be0a8aab$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $13504dc1be0a8aab$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $13504dc1be0a8aab$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $13504dc1be0a8aab$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $1XdsL.default)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $13504dc1be0a8aab$var$_objectSpread($13504dc1be0a8aab$var$_objectSpread({}, options), {}, {
        extract: false
    }); // Parse phone number.
    try {
        var phoneNumber = (0, $fYkMF.default)(text, options, metadata);
        metadata = new (0, $7t6iH.default)(metadata);
        metadata.selectNumberingPlan(phoneNumber.countryCallingCode);
        var result = (0, $ct34l.default)(phoneNumber.nationalNumber, metadata);
        if (result !== "IS_POSSIBLE") return result;
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $hXblZ.default)) return error.message;
        else throw error;
    }
}

});
parcelRegister("1XdsL", function(module, exports) {

$parcel$export(module.exports, "default", () => $16c5be91cdf9d865$export$2e2bcd8739ae039);

var $hVkdz = parcelRequire("hVkdz");
function $16c5be91cdf9d865$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $16c5be91cdf9d865$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $16c5be91cdf9d865$var$ownKeys(Object(source), !0).forEach(function(key) {
            $16c5be91cdf9d865$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $16c5be91cdf9d865$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $16c5be91cdf9d865$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $16c5be91cdf9d865$var$_slicedToArray(arr, i) {
    return $16c5be91cdf9d865$var$_arrayWithHoles(arr) || $16c5be91cdf9d865$var$_iterableToArrayLimit(arr, i) || $16c5be91cdf9d865$var$_unsupportedIterableToArray(arr, i) || $16c5be91cdf9d865$var$_nonIterableRest();
}
function $16c5be91cdf9d865$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $16c5be91cdf9d865$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $16c5be91cdf9d865$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $16c5be91cdf9d865$var$_arrayLikeToArray(o, minLen);
}
function $16c5be91cdf9d865$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $16c5be91cdf9d865$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $16c5be91cdf9d865$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $16c5be91cdf9d865$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $16c5be91cdf9d865$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === "string") text = arg_1;
    else throw new TypeError("A text for parsing must be a string."); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === "string") {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $16c5be91cdf9d865$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $hVkdz.default)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}

});

parcelRegister("fYkMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba0c94da7002b744$export$2e2bcd8739ae039);

var $iVW0P = parcelRequire("iVW0P");
function $ba0c94da7002b744$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ba0c94da7002b744$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ba0c94da7002b744$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ba0c94da7002b744$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ba0c94da7002b744$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ba0c94da7002b744$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ba0c94da7002b744$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $iVW0P.default)(text, $ba0c94da7002b744$var$_objectSpread($ba0c94da7002b744$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}

});
parcelRegister("iVW0P", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc8a8cecfb68b1e6$export$2e2bcd8739ae039);
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js

var $e78xe = parcelRequire("e78xe");

var $hXblZ = parcelRequire("hXblZ");

var $7t6iH = parcelRequire("7t6iH");

var $lqfDS = parcelRequire("lqfDS");

var $8iabE = parcelRequire("8iabE");

var $ezQmf = parcelRequire("ezQmf");

var $7t6iH = parcelRequire("7t6iH");

var $aXREX = parcelRequire("aXREX");

var $40ywJ = parcelRequire("40ywJ");

var $fDGKs = parcelRequire("fDGKs");

var $hq6Lf = parcelRequire("hq6Lf");

var $C7z0t = parcelRequire("C7z0t");


var $iotMN = parcelRequire("iotMN");

var $aTN2O = parcelRequire("aTN2O");
// This prevents malicious input from consuming CPU.
var $dc8a8cecfb68b1e6$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $dc8a8cecfb68b1e6$var$PHONE_NUMBER_START_PATTERN = new RegExp("[" + (0, $e78xe.PLUS_CHARS) + (0, $e78xe.VALID_DIGITS) + "]"); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $dc8a8cecfb68b1e6$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + (0, $e78xe.VALID_DIGITS) + "#" + "]+$");
var $dc8a8cecfb68b1e6$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $dc8a8cecfb68b1e6$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $7t6iH.default)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $hXblZ.default)("INVALID_COUNTRY");
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $dc8a8cecfb68b1e6$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === "TOO_SHORT") throw new (0, $hXblZ.default)("TOO_SHORT");
            throw new (0, $hXblZ.default)("NOT_A_NUMBER");
        }
        return {};
    }
    var _parsePhoneNumber = $dc8a8cecfb68b1e6$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $hXblZ.default)("INVALID_COUNTRY");
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $e78xe.MIN_LENGTH_FOR_NSN)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $hXblZ.default)("TOO_SHORT");
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $e78xe.MAX_LENGTH_FOR_NSN)) {
        if (options.v2) throw new (0, $hXblZ.default)("TOO_LONG");
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $40ywJ.default)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $fDGKs.default)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $dc8a8cecfb68b1e6$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $aXREX.isPossibleNumber)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $dc8a8cecfb68b1e6$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $dc8a8cecfb68b1e6$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $hXblZ.default)("TOO_LONG");
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($dc8a8cecfb68b1e6$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($dc8a8cecfb68b1e6$var$AFTER_PHONE_NUMBER_END_PATTERN, "");
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $dc8a8cecfb68b1e6$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $aTN2O.default)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $dc8a8cecfb68b1e6$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $lqfDS.default)(number)) {
        if ((0, $lqfDS.isViablePhoneNumberStart)(number)) return {
            error: "TOO_SHORT"
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $8iabE.default)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $dc8a8cecfb68b1e6$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $dc8a8cecfb68b1e6$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $hq6Lf.default)((0, $ezQmf.default)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($dc8a8cecfb68b1e6$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = "001";
            }
        }
        countryCallingCode = defaultCallingCode || (0, $7t6iH.getCountryCallingCode)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $C7z0t.default)((0, $ezQmf.default)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $iotMN.default)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === "001") ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}

});
parcelRegister("hXblZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d120c0f50dbf1e5d$export$2e2bcd8739ae039);
function $d120c0f50dbf1e5d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d120c0f50dbf1e5d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d120c0f50dbf1e5d$var$_typeof(obj);
}
function $d120c0f50dbf1e5d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d120c0f50dbf1e5d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d120c0f50dbf1e5d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d120c0f50dbf1e5d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d120c0f50dbf1e5d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d120c0f50dbf1e5d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d120c0f50dbf1e5d$var$_setPrototypeOf(subClass, superClass);
}
function $d120c0f50dbf1e5d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d120c0f50dbf1e5d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d120c0f50dbf1e5d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d120c0f50dbf1e5d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d120c0f50dbf1e5d$var$_possibleConstructorReturn(this, result);
    };
}
function $d120c0f50dbf1e5d$var$_possibleConstructorReturn(self, call) {
    if (call && ($d120c0f50dbf1e5d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d120c0f50dbf1e5d$var$_assertThisInitialized(self);
}
function $d120c0f50dbf1e5d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d120c0f50dbf1e5d$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $d120c0f50dbf1e5d$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$d120c0f50dbf1e5d$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $d120c0f50dbf1e5d$var$_construct(Class, arguments, $d120c0f50dbf1e5d$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $d120c0f50dbf1e5d$var$_setPrototypeOf(Wrapper, Class);
    };
    return $d120c0f50dbf1e5d$var$_wrapNativeSuper(Class);
}
function $d120c0f50dbf1e5d$var$_construct(Parent, args, Class) {
    if ($d120c0f50dbf1e5d$var$_isNativeReflectConstruct()) $d120c0f50dbf1e5d$var$_construct = Reflect.construct;
    else $d120c0f50dbf1e5d$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $d120c0f50dbf1e5d$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $d120c0f50dbf1e5d$var$_construct.apply(null, arguments);
}
function $d120c0f50dbf1e5d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d120c0f50dbf1e5d$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $d120c0f50dbf1e5d$var$_setPrototypeOf(o, p) {
    $d120c0f50dbf1e5d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d120c0f50dbf1e5d$var$_setPrototypeOf(o, p);
}
function $d120c0f50dbf1e5d$var$_getPrototypeOf(o) {
    $d120c0f50dbf1e5d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d120c0f50dbf1e5d$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $d120c0f50dbf1e5d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $d120c0f50dbf1e5d$var$_inherits(ParseError, _Error);
    var _super = $d120c0f50dbf1e5d$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $d120c0f50dbf1e5d$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($d120c0f50dbf1e5d$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $d120c0f50dbf1e5d$var$_createClass(ParseError);
}(/*#__PURE__*/ $d120c0f50dbf1e5d$var$_wrapNativeSuper(Error));

});

parcelRegister("8iabE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6097e818331f755a$export$2e2bcd8739ae039);

var $gRlJZ = parcelRequire("gRlJZ");
// 1 or more valid digits, for use when parsing.
var $6097e818331f755a$var$EXTN_PATTERN = new RegExp("(?:" + (0, $gRlJZ.default)() + ")$", "i"); // Strips any extension (as in, the part of the number dialled after the call is
function $6097e818331f755a$export$2e2bcd8739ae039(number) {
    var start = number.search($6097e818331f755a$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($6097e818331f755a$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}

});

parcelRegister("ezQmf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9ccf2b971ba35ed$export$2e2bcd8739ae039);

var $8CJvs = parcelRequire("8CJvs");
function $a9ccf2b971ba35ed$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $a9ccf2b971ba35ed$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a9ccf2b971ba35ed$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a9ccf2b971ba35ed$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a9ccf2b971ba35ed$var$_arrayLikeToArray(o, minLen);
}
function $a9ccf2b971ba35ed$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a9ccf2b971ba35ed$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $a9ccf2b971ba35ed$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $a9ccf2b971ba35ed$export$13d8790d7fb84c28(character, result) || "";
    }
    return result;
}
function $a9ccf2b971ba35ed$export$13d8790d7fb84c28(character, prevParsedCharacters, emitEvent) {
    // Only allow a leading `+`.
    if (character === "+") {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) {
            // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
            // Any 3rd-party code that used to `import` and call this function before that
            // won't be passing any `emitEvent` argument.
            //
            // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
            // of parsing an input string when the user inputs something like `"2+7"
            // https://github.com/catamphetamine/react-phone-number-input/issues/437
            //
            // If the parser encounters an unexpected `+` in a string being parsed
            // then it simply discards that out-of-place `+` and any following characters.
            //
            if (typeof emitEvent === "function") emitEvent("end");
            return;
        }
        return "+";
    } // Allow digits.
    return (0, $8CJvs.parseDigit)(character);
}

});

parcelRegister("aTN2O", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ef515a5a2ce7ef0$export$2e2bcd8739ae039);

var $1dJAG = parcelRequire("1dJAG");

var $hXblZ = parcelRequire("hXblZ");
function $7ef515a5a2ce7ef0$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $1dJAG.default)(numberToParse);
    if (!(0, $1dJAG.isPhoneContextValid)(phoneContext)) throw new (0, $hXblZ.default)("NOT_A_NUMBER");
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
    else {
        phoneNumberString = ""; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $1dJAG.PLUS_SIGN)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $1dJAG.RFC3966_PREFIX_));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $1dJAG.RFC3966_PREFIX_).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $1dJAG.RFC3966_PHONE_CONTEXT_));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $1dJAG.RFC3966_ISDN_SUBADDRESS_));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== "") return phoneNumberString;
}

});
parcelRegister("1dJAG", function(module, exports) {

$parcel$export(module.exports, "PLUS_SIGN", () => $0e3a5eae18582524$export$1ddc7eed78155f68);
$parcel$export(module.exports, "RFC3966_PREFIX_", () => $0e3a5eae18582524$export$70d485ce3f6de783);
$parcel$export(module.exports, "RFC3966_PHONE_CONTEXT_", () => $0e3a5eae18582524$export$f6d5879d582c3a27);
$parcel$export(module.exports, "RFC3966_ISDN_SUBADDRESS_", () => $0e3a5eae18582524$export$9e356e12edb00a81);
$parcel$export(module.exports, "default", () => $0e3a5eae18582524$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isPhoneContextValid", () => $0e3a5eae18582524$export$474a4aa22ad6959a);
// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $e78xe = parcelRequire("e78xe");
var $0e3a5eae18582524$export$1ddc7eed78155f68 = "+";
var $0e3a5eae18582524$var$RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var $0e3a5eae18582524$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $e78xe.VALID_DIGITS) + "]" + "|" + $0e3a5eae18582524$var$RFC3966_VISUAL_SEPARATOR_ + ")";
var $0e3a5eae18582524$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $0e3a5eae18582524$export$1ddc7eed78155f68 + $0e3a5eae18582524$var$RFC3966_PHONE_DIGIT_ + "*" + "[" + (0, $e78xe.VALID_DIGITS) + "]" + $0e3a5eae18582524$var$RFC3966_PHONE_DIGIT_ + "*" + "$";
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $0e3a5eae18582524$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($0e3a5eae18582524$var$RFC3966_GLOBAL_NUMBER_DIGITS_, "g"); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $0e3a5eae18582524$var$ALPHANUM_ = (0, $e78xe.VALID_DIGITS);
var $0e3a5eae18582524$var$RFC3966_DOMAINLABEL_ = "[" + $0e3a5eae18582524$var$ALPHANUM_ + "]+((\\-)*[" + $0e3a5eae18582524$var$ALPHANUM_ + "])*";
var $0e3a5eae18582524$var$VALID_ALPHA_ = "a-zA-Z";
var $0e3a5eae18582524$var$RFC3966_TOPLABEL_ = "[" + $0e3a5eae18582524$var$VALID_ALPHA_ + "]+((\\-)*[" + $0e3a5eae18582524$var$ALPHANUM_ + "])*";
var $0e3a5eae18582524$var$RFC3966_DOMAINNAME_ = "^(" + $0e3a5eae18582524$var$RFC3966_DOMAINLABEL_ + "\\.)*" + $0e3a5eae18582524$var$RFC3966_TOPLABEL_ + "\\.?$";
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $0e3a5eae18582524$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($0e3a5eae18582524$var$RFC3966_DOMAINNAME_, "g");
var $0e3a5eae18582524$export$70d485ce3f6de783 = "tel:";
var $0e3a5eae18582524$export$f6d5879d582c3a27 = ";phone-context=";
var $0e3a5eae18582524$export$9e356e12edb00a81 = ";isub=";
function $0e3a5eae18582524$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($0e3a5eae18582524$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $0e3a5eae18582524$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return "";
    var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $0e3a5eae18582524$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $0e3a5eae18582524$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $0e3a5eae18582524$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}

});






parcelRegister("9ZYkg", function(module, exports) {

$parcel$export(module.exports, "default", () => $74789b075d798049$export$2e2bcd8739ae039);
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $74789b075d798049$export$2e2bcd8739ae039 = {
    "AC": "40123",
    "AD": "312345",
    "AE": "501234567",
    "AF": "701234567",
    "AG": "2684641234",
    "AI": "2642351234",
    "AL": "672123456",
    "AM": "77123456",
    "AO": "923123456",
    "AR": "91123456789",
    "AS": "6847331234",
    "AT": "664123456",
    "AU": "412345678",
    "AW": "5601234",
    "AX": "412345678",
    "AZ": "401234567",
    "BA": "61123456",
    "BB": "2462501234",
    "BD": "1812345678",
    "BE": "470123456",
    "BF": "70123456",
    "BG": "43012345",
    "BH": "36001234",
    "BI": "79561234",
    "BJ": "0195123456",
    "BL": "690001234",
    "BM": "4413701234",
    "BN": "7123456",
    "BO": "71234567",
    "BQ": "3181234",
    "BR": "11961234567",
    "BS": "2423591234",
    "BT": "17123456",
    "BW": "71123456",
    "BY": "294911911",
    "BZ": "6221234",
    "CA": "5062345678",
    "CC": "412345678",
    "CD": "991234567",
    "CF": "70012345",
    "CG": "061234567",
    "CH": "781234567",
    "CI": "0123456789",
    "CK": "71234",
    "CL": "221234567",
    "CM": "671234567",
    "CN": "13123456789",
    "CO": "3211234567",
    "CR": "83123456",
    "CU": "51234567",
    "CV": "9911234",
    "CW": "95181234",
    "CX": "412345678",
    "CY": "96123456",
    "CZ": "601123456",
    "DE": "15123456789",
    "DJ": "77831001",
    "DK": "34412345",
    "DM": "7672251234",
    "DO": "8092345678",
    "DZ": "551234567",
    "EC": "991234567",
    "EE": "51234567",
    "EG": "1001234567",
    "EH": "650123456",
    "ER": "7123456",
    "ES": "612345678",
    "ET": "911234567",
    "FI": "412345678",
    "FJ": "7012345",
    "FK": "51234",
    "FM": "3501234",
    "FO": "211234",
    "FR": "612345678",
    "GA": "06031234",
    "GB": "7400123456",
    "GD": "4734031234",
    "GE": "555123456",
    "GF": "694201234",
    "GG": "7781123456",
    "GH": "231234567",
    "GI": "57123456",
    "GL": "221234",
    "GM": "3012345",
    "GN": "601123456",
    "GP": "690001234",
    "GQ": "222123456",
    "GR": "6912345678",
    "GT": "51234567",
    "GU": "6713001234",
    "GW": "955012345",
    "GY": "6091234",
    "HK": "51234567",
    "HN": "91234567",
    "HR": "921234567",
    "HT": "34101234",
    "HU": "201234567",
    "ID": "812345678",
    "IE": "850123456",
    "IL": "502345678",
    "IM": "7924123456",
    "IN": "8123456789",
    "IO": "3801234",
    "IQ": "7912345678",
    "IR": "9123456789",
    "IS": "6111234",
    "IT": "3123456789",
    "JE": "7797712345",
    "JM": "8762101234",
    "JO": "790123456",
    "JP": "9012345678",
    "KE": "712123456",
    "KG": "700123456",
    "KH": "91234567",
    "KI": "72001234",
    "KM": "3212345",
    "KN": "8697652917",
    "KP": "1921234567",
    "KR": "1020000000",
    "KW": "50012345",
    "KY": "3453231234",
    "KZ": "7710009998",
    "LA": "2023123456",
    "LB": "71123456",
    "LC": "7582845678",
    "LI": "660234567",
    "LK": "712345678",
    "LR": "770123456",
    "LS": "50123456",
    "LT": "61234567",
    "LU": "628123456",
    "LV": "21234567",
    "LY": "912345678",
    "MA": "650123456",
    "MC": "612345678",
    "MD": "62112345",
    "ME": "67622901",
    "MF": "690001234",
    "MG": "321234567",
    "MH": "2351234",
    "MK": "72345678",
    "ML": "65012345",
    "MM": "92123456",
    "MN": "88123456",
    "MO": "66123456",
    "MP": "6702345678",
    "MQ": "696201234",
    "MR": "22123456",
    "MS": "6644923456",
    "MT": "96961234",
    "MU": "52512345",
    "MV": "7712345",
    "MW": "991234567",
    "MX": "2221234567",
    "MY": "123456789",
    "MZ": "821234567",
    "NA": "811234567",
    "NC": "751234",
    "NE": "93123456",
    "NF": "381234",
    "NG": "8021234567",
    "NI": "81234567",
    "NL": "612345678",
    "NO": "40612345",
    "NP": "9841234567",
    "NR": "5551234",
    "NU": "8884012",
    "NZ": "211234567",
    "OM": "92123456",
    "PA": "61234567",
    "PE": "912345678",
    "PF": "87123456",
    "PG": "70123456",
    "PH": "9051234567",
    "PK": "3012345678",
    "PL": "512345678",
    "PM": "551234",
    "PR": "7872345678",
    "PS": "599123456",
    "PT": "912345678",
    "PW": "6201234",
    "PY": "961456789",
    "QA": "33123456",
    "RE": "692123456",
    "RO": "712034567",
    "RS": "601234567",
    "RU": "9123456789",
    "RW": "720123456",
    "SA": "512345678",
    "SB": "7421234",
    "SC": "2510123",
    "SD": "911231234",
    "SE": "701234567",
    "SG": "81234567",
    "SH": "51234",
    "SI": "31234567",
    "SJ": "41234567",
    "SK": "912123456",
    "SL": "25123456",
    "SM": "66661212",
    "SN": "701234567",
    "SO": "71123456",
    "SR": "7412345",
    "SS": "977123456",
    "ST": "9812345",
    "SV": "70123456",
    "SX": "7215205678",
    "SY": "944567890",
    "SZ": "76123456",
    "TA": "8999",
    "TC": "6492311234",
    "TD": "63012345",
    "TG": "90112345",
    "TH": "812345678",
    "TJ": "917123456",
    "TK": "7290",
    "TL": "77212345",
    "TM": "66123456",
    "TN": "20123456",
    "TO": "7715123",
    "TR": "5012345678",
    "TT": "8682911234",
    "TV": "901234",
    "TW": "912345678",
    "TZ": "621234567",
    "UA": "501234567",
    "UG": "712345678",
    "US": "2015550123",
    "UY": "94231234",
    "UZ": "912345678",
    "VA": "3123456789",
    "VC": "7844301234",
    "VE": "4121234567",
    "VG": "2843001234",
    "VI": "3406421234",
    "VN": "912345678",
    "VU": "5912345",
    "WF": "821234",
    "WS": "7212345",
    "XK": "43201234",
    "YE": "712345678",
    "YT": "639012345",
    "ZA": "711234567",
    "ZM": "955123456",
    "ZW": "712345678"
};

});


parcelRegister("iXc4P", function(module, exports) {

$parcel$export(module.exports, "isValidPhoneNumber", () => $dcc71ae4544b96fc$export$992e2df24bec72ba);

var $5AEiK = parcelRequire("5AEiK");

var $6jS1v = parcelRequire("6jS1v");
function $dcc71ae4544b96fc$export$992e2df24bec72ba() {
    return (0, $5AEiK.default)((0, $6jS1v.default), arguments);
}

});
parcelRegister("6jS1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $499e6c54de47c733$export$2e2bcd8739ae039);

var $1XdsL = parcelRequire("1XdsL");

var $fxz7L = parcelRequire("fxz7L");
function $499e6c54de47c733$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $499e6c54de47c733$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $499e6c54de47c733$var$ownKeys(Object(source), !0).forEach(function(key) {
            $499e6c54de47c733$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $499e6c54de47c733$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $499e6c54de47c733$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $499e6c54de47c733$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $1XdsL.default)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $499e6c54de47c733$var$_objectSpread($499e6c54de47c733$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $fxz7L.default)(text, options, metadata);
    return phoneNumber && phoneNumber.isValid() || false;
}

});
parcelRegister("fxz7L", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5052f05f8c553b5$export$2e2bcd8739ae039);

var $fYkMF = parcelRequire("fYkMF");

var $hXblZ = parcelRequire("hXblZ");

var $7t6iH = parcelRequire("7t6iH");
function $b5052f05f8c553b5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b5052f05f8c553b5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b5052f05f8c553b5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b5052f05f8c553b5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b5052f05f8c553b5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b5052f05f8c553b5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b5052f05f8c553b5$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $7t6iH.isSupportedCountry)(options.defaultCountry, metadata)) options = $b5052f05f8c553b5$var$_objectSpread($b5052f05f8c553b5$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $fYkMF.default)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $hXblZ.default)) ;
        else throw error;
    }
}

});




parcelRegister("6mFZi", function(module, exports) {

$parcel$export(module.exports, "useProspectRequestReferential", () => $e7ba14dca5821c1e$export$c28aad8377b4ccc4);

var $ghfIB = parcelRequire("ghfIB");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");
const $e7ba14dca5821c1e$export$c28aad8377b4ccc4 = (config)=>{
    const [referential, setReferential] = (0, $81g6h.useState)(config.referentialsMap.get(config.initialCountryCode));
    const selectReferential = (0, $81g6h.useCallback)((countryCode)=>{
        const newReferential = config.referentialsMap.get(countryCode);
        if ((0, $lTdpc.isNotNil)(newReferential)) {
            setReferential(newReferential);
            (0, $ghfIB.prospectRequestManager).selectCountry(countryCode);
        }
    }, [
        config.referentialsMap
    ]);
    return {
        referential: referential,
        selectReferential: selectReferential
    };
};

});


parcelRegister("6uwo0", function(module, exports) {

$parcel$export(module.exports, "useProspectRequestLoading", () => $45df55737361b225$export$383a19f739c4e4e9);

var $grmoS = parcelRequire("grmoS");

var $ghfIB = parcelRequire("ghfIB");

var $81g6h = parcelRequire("81g6h");
function $45df55737361b225$export$383a19f739c4e4e9(locale) {
    const [config, setConfig] = (0, $81g6h.useState)(undefined);
    const [fetchConfig, configLoading, configError] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(async ()=>{
        const [prospectRequestConfig] = await Promise.all([
            (0, $ghfIB.prospectRequestManager).prepareProspectRequest(locale),
            (0, $ghfIB.localeManager).fetchSupportedLocales().catch(()=>undefined)
        ]);
        setConfig(prospectRequestConfig);
    }, [
        locale
    ]), {
        initialLoadingState: true
    });
    (0, $81g6h.useEffect)(()=>{
        fetchConfig();
    }, [
        fetchConfig
    ]);
    return {
        config: config,
        configLoading: configLoading,
        configError: configError
    };
}

});

parcelRegister("4Mcub", function(module, exports) {

$parcel$export(module.exports, "ProspectFormContainer", () => $799a4c690fb3ce22$export$6ecf3feaa68a2837);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
parcelRequire("81g6h");
const $799a4c690fb3ce22$export$6ecf3feaa68a2837 = ({ title: title, description: description, children: children })=>/*#__PURE__*/ (0, $iKObn.jsxs)($799a4c690fb3ce22$var$FormContainer, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($799a4c690fb3ce22$var$Title, {
                children: title
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: description
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: children
            })
        ]
    });
const $799a4c690fb3ce22$var$Title = (0, $5UMQ1.default).div`
	font-family: "HeadingNow";
	font-style: normal;
	font-weight: 500;
	font-size: 4rem;
	line-height: 100%;
	overflow-wrap: break-word;

	span {
		font-family: "HeadingNow";
	}

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		font-size: 2.5rem;
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		font-size: 2rem;
	}
`;
const $799a4c690fb3ce22$var$FormContainer = (0, $5UMQ1.default).div`
	display: grid;
	place-self: start center;
	gap: 24px;
`;

});

parcelRegister("itAai", function(module, exports) {

$parcel$export(module.exports, "ProspectPage", () => $cd779efad0e5e360$export$a12c6bc57381a162);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $GDBjl = parcelRequire("GDBjl");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $kKnoQ = parcelRequire("kKnoQ");

var $hAuJ9 = parcelRequire("hAuJ9");
parcelRequire("81g6h");
var $cd779efad0e5e360$var$CirclesBg = function CirclesBg(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_2437_76221",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "1440",
                height: "1168",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M1440 1.638 0 0v1168h1440V1.638Z",
                    fill: "#50F"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_2437_76221)",
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                        opacity: ".15",
                        cx: "34.935",
                        cy: "1162.8",
                        rx: "1076.54",
                        ry: "1076.3"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                        opacity: ".15",
                        cx: "34.936",
                        cy: "1162.8",
                        rx: "757.159",
                        ry: "756.991"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                        opacity: ".15",
                        cx: "34.746",
                        cy: "1163.05",
                        rx: "500.177",
                        ry: "500.066"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                        opacity: ".15",
                        cx: "35.049",
                        cy: "1162.84",
                        rx: "297.239",
                        ry: "297.173"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                        opacity: ".15",
                        cx: "35.023",
                        cy: "1162.69",
                        rx: "176.552",
                        ry: "176.513"
                    })
                ]
            })
        ]
    });
};
$cd779efad0e5e360$var$CirclesBg.defaultProps = {
    viewBox: "0 0 1440 1168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $cd779efad0e5e360$var$CONTENT_PADDING = 40;
const $cd779efad0e5e360$var$LOGO_HEIGHT = 65;
const $cd779efad0e5e360$export$a12c6bc57381a162 = ({ backgroundColor: backgroundColor, children: children })=>/*#__PURE__*/ (0, $iKObn.jsx)($cd779efad0e5e360$var$Background, {
        backgroundColor: backgroundColor,
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($cd779efad0e5e360$var$PageContainer, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $GDBjl.AppLogo), {
                    width: 242,
                    height: $cd779efad0e5e360$var$LOGO_HEIGHT,
                    color: (0, $kKnoQ.colors).white,
                    type: "monochrome"
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)($cd779efad0e5e360$var$ContentContainer, {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($cd779efad0e5e360$var$InnerContentContainer, {
                        children: children
                    })
                })
            ]
        })
    });
const $cd779efad0e5e360$var$Background = (0, $5UMQ1.default).div`
	min-height: 100vh;
	width: 100%;
	background-color: ${({ backgroundColor: backgroundColor })=>backgroundColor};
	background-image: ${(0, $hAuJ9.svgComponentToCSS)(/*#__PURE__*/ (0, $iKObn.jsx)($cd779efad0e5e360$var$CirclesBg, {
    color: (0, $kKnoQ.colors).white
}))};
	background-repeat: no-repeat;
	background-position: bottom left;
	background-size: 100% auto;
	padding: 40px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 0px;
		padding-top: 40px;
		background-position: top left;
	}
`;
const $cd779efad0e5e360$var$PageContainer = (0, $5UMQ1.default).div`
	display: grid;
	place-items: center;
	place-content: center;
	gap: ${$cd779efad0e5e360$var$CONTENT_PADDING}px;
	overflow-x: hidden;
`;
const $cd779efad0e5e360$var$ContentContainer = (0, $5UMQ1.default).div`
	background-color: ${(0, $kKnoQ.colors).white};
	display: grid;
	justify-content: center;
	border-radius: 16px;
	width: 1080px;
	max-width: calc(100vw - ${$cd779efad0e5e360$var$CONTENT_PADDING * 2}px);

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		width: 100vw;
		max-width: unset;
		border-radius: unset;
		min-height: calc(100vh - ${$cd779efad0e5e360$var$CONTENT_PADDING * 2 + $cd779efad0e5e360$var$LOGO_HEIGHT}px);
	}
`;
const $cd779efad0e5e360$var$InnerContentContainer = (0, $5UMQ1.default).div`
	display: grid;
	padding: 40px 80px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		max-width: 688px;
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		max-width: 100%;
		padding: 40px 16px;
	}
`;

});

parcelRegister("7a0sk", function(module, exports) {

$parcel$export(module.exports, "ProspectSuccessMessage", () => $480fb796d4d0449c$export$fa4d08296b298737);

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $jCNJs = parcelRequire("jCNJs");
parcelRequire("81g6h");
var $480fb796d4d0449c$var$SuccessIcon = function SuccessIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M53.47 4.362 4.362 53.47c-5.816 5.816-5.816 15.244 0 21.06l49.108 49.108c5.816 5.816 15.244 5.816 21.06 0l49.108-49.108c5.816-5.816 5.816-15.244 0-21.06L74.53 4.362c-5.816-5.816-15.244-5.816-21.06 0Z",
                fill: "#F2E9FF"
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_2535_77279)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M82.78 41.2H44.42c-3.546 0-6.42 2.996-6.42 6.69v31.42c0 3.695 2.874 6.69 6.42 6.69h38.36c3.546 0 6.42-2.995 6.42-6.69V47.89c0-3.694-2.874-6.69-6.42-6.69Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask0_2535_77279",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "42",
                        y: "32",
                        width: "54",
                        height: "42",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M59.028 73.765a5.151 5.151 0 0 1-3.64-1.507L43.504 60.374a5.157 5.157 0 0 1 0-7.28 5.157 5.157 0 0 1 7.28 0l8.244 8.25 27.44-27.44a5.157 5.157 0 0 1 7.28 0 5.157 5.157 0 0 1 0 7.28L62.674 72.258a5.151 5.151 0 0 1-3.64 1.507h-.006Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask0_2535_77279)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M61.538 77.526c13.836 0 25.052-11.216 25.052-25.051 0-13.836-11.216-25.052-25.052-25.052S36.486 38.639 36.486 52.475c0 13.835 11.216 25.051 25.052 25.051Z",
                                fill: "#29D37A"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M90.651 46.395c1.207 10.307-7.3 22.459-19.815 24.298-12.517 1.84-24.298-7.325-25.505-17.631-1.207-10.307 7.299-22.46 19.815-24.298 12.516-1.84 24.298 7.324 25.505 17.63Z",
                                fill: "#3ADE88"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M94.884 43.228c.804 6.871-6.373 18.73-17.657 20.799-11.29 2.069-22.408-6.431-23.213-13.302-.804-6.871 6.373-18.73 17.657-20.799 11.284-2.069 22.408 6.43 23.213 13.302Z",
                                fill: "#4CE997"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M99.124 40.06c.403 3.436-5.447 15-15.504 17.3-10.058 2.298-20.524-5.53-20.927-8.966-.402-3.436 5.447-15 15.505-17.3 10.058-2.299 20.524 5.53 20.927 8.966Z",
                                fill: "#5DF4A5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M103.358 36.893s-4.521 11.265-13.353 13.8c-8.832 2.529-18.634-4.636-18.634-4.636s4.521-11.265 13.353-13.8c8.831-2.535 18.634 4.636 18.634 4.636Z",
                                fill: "#6EFFB3"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_2535_77279",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(31.6 31.6)",
                        d: "M0 0h64v64H0z"
                    })
                })
            })
        ]
    });
};
$480fb796d4d0449c$var$SuccessIcon.defaultProps = {
    width: "128",
    height: "128",
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $480fb796d4d0449c$export$fa4d08296b298737 = ({ title: title, description: description, buttonLabel: buttonLabel, onButtonClick: onButtonClick })=>/*#__PURE__*/ (0, $iKObn.jsxs)($480fb796d4d0449c$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($480fb796d4d0449c$var$SuccessIcon, {
                width: 128,
                height: 128
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($480fb796d4d0449c$var$MessageContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("h3", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $jCNJs.RoundedButton), {
                label: buttonLabel,
                onClick: onButtonClick
            })
        ]
    });
const $480fb796d4d0449c$var$MessageContainer = (0, $5UMQ1.default).div`
	display: grid;
	place-items: center;
	text-align: center;
	gap: 16px;
`;
const $480fb796d4d0449c$var$Container = (0, $5UMQ1.default).div`
	display: grid;
	place-items: center;
	place-self: center;
	gap: 40px;
`;

});

parcelRegister("gYCcI", function(module, exports) {

var $gwUeX = parcelRequire("gwUeX");
module.exports = Promise.all([
    $gwUeX("cRFNe"),
    $gwUeX("762lp")
]).then(()=>parcelRequire("gRI9Y"));

});

parcelRegister("915oF", function(module, exports) {

var $gwUeX = parcelRequire("gwUeX");
module.exports = Promise.all([
    $gwUeX("cRFNe"),
    $gwUeX("lwSZr")
]).then(()=>parcelRequire("6MIOE"));

});

parcelRegister("eRh25", function(module, exports) {

var $gwUeX = parcelRequire("gwUeX");
module.exports = Promise.all([
    $gwUeX("cRFNe"),
    $gwUeX("39SXW")
]).then(()=>parcelRequire("iIhti"));

});

parcelRegister("ioeVs", function(module, exports) {

var $gwUeX = parcelRequire("gwUeX");
module.exports = $gwUeX("hn0QC").then(()=>parcelRequire("aA86t"));

});

parcelRegister("bzn3S", function(module, exports) {

var $gwUeX = parcelRequire("gwUeX");
module.exports = $gwUeX("hxONS").then(()=>parcelRequire("ahOGE"));

});

parcelRegister("bLBWM", function(module, exports) {

var $gwUeX = parcelRequire("gwUeX");
module.exports = $gwUeX("bHQ4C").then(()=>parcelRequire("9r4ey"));

});

parcelRegister("hQaMG", function(module, exports) {

$parcel$export(module.exports, "branchManager", () => $beb8cd796f770898$export$8ded47ff6e0435df);
function $beb8cd796f770898$var$isObject(value) {
    return typeof value === "object" && value !== null;
}
// Branch match IDs are numeric/alphanumeric identifiers — reject anything else.
function $beb8cd796f770898$var$sanitizeMatchId(value) {
    const cleaned = value.replace(/[^a-zA-Z0-9\-_]/g, "").slice(0, 128);
    return cleaned || undefined;
}
// Branch referrers are URL-encoded strings; strip HTML-injection chars, dangerous URI schemes, and cap length.
function $beb8cd796f770898$var$sanitizeReferrer(value) {
    const cleaned = value.trim().replace(/[<>"'`\r\n\t\f\v]/g, "").replace(/^(javascript|data|vbscript):/i, "").slice(0, 2048);
    return cleaned || undefined;
}
const $beb8cd796f770898$var$STORAGE_KEY = "branch-session";
const $beb8cd796f770898$var$DEFAULT_SESSION = {
    fromBranch: false
};
class $beb8cd796f770898$export$817744ed4c8f4ee7 {
    async init(branchKey) {
        this.detectFromUrl(window);
        const key = this.resolveBranchKey(branchKey);
        await this.ensureSdkLoaded();
        const branch = window.branch;
        if (!branch?.init) return;
        this.branch = branch;
        if (window.__branchEarlyInitDone__) {
            this.initialized = true;
            this.adoptBranchDataSession();
            this.flushPending();
            return;
        }
        if (!key) return;
        this.configureSdk(branch);
        const opts = this.buildInitOptions();
        branch.init(key, opts, (err)=>{
            if (err) return;
            this.initialized = true;
            this.detectFromUrl(window);
            this.adoptBranchDataSession();
            this.flushPending();
        });
    }
    resolveBranchKey(explicit) {
        if (explicit) return explicit;
        try {
            const url = new URL(window.location.href);
            const fromUrl = url.searchParams.get("branch_key");
            if (fromUrl) return fromUrl;
        } catch  {
        /* noop */ }
        const env = this.getEnv();
        return env.BRANCH_KEY;
    }
    async ensureSdkLoaded() {
        const exists = !!document.querySelector('script[src*="cdn.branch.io/branch-latest.min.js"]');
        if (exists) return;
        await new Promise((resolve, reject)=>{
            const script = document.createElement("script");
            script.src = "https://cdn.branch.io/branch-latest.min.js";
            script.async = true;
            try {
                script.dataset.cookieconsent = "marketing";
            } catch  {}
            script.onload = ()=>resolve();
            script.onerror = ()=>reject(new Error("Failed to load Branch SDK script"));
            document.body.appendChild(script);
        });
    }
    buildInitOptions() {
        const opts = {};
        try {
            const url = new URL(window.location.href);
            const mid = url.searchParams.get("_branch_match_id");
            if (mid) opts.branch_match_id = mid;
        } catch  {
        /* noop */ }
        return opts;
    }
    configureSdk(branch) {
        try {
            const url = new URL(window.location.href);
            const mid = url.searchParams.get("_branch_match_id");
            if (mid) branch.setRequestMetadata?.("branch_match_id", mid);
            const env = this.getEnv();
            branch.setRequestMetadata?.("environment", env.ENVIRONMENT || "dev");
            branch.setRequestMetadata?.("platform", "web");
            const apiUrl = url.searchParams.get("branch_api_url") || env.BRANCH_API_URL;
            if (apiUrl) branch.setAPIUrl?.(apiUrl);
        } catch  {
        /* noop */ }
    }
    getEnv() {
        try {
            const w = window;
            return w.process?.env ?? {};
        } catch  {
            return {};
        }
    }
    detectFromUrl(windowObj) {
        const parsed = this.parseBranchParams(windowObj);
        if (parsed) {
            this.session = {
                fromBranch: true,
                matchId: parsed.matchId,
                referrer: parsed.referrer,
                completeRegistrationTracked: false
            };
            try {
                localStorage.setItem($beb8cd796f770898$var$STORAGE_KEY, JSON.stringify(this.session));
            } catch  {}
            return;
        }
        const restored = this.restoreSessionFromStorage();
        if (restored) this.session = restored;
    }
    parseBranchParams(windowObj) {
        try {
            const url = new URL(windowObj.location.href);
            const rawMatchId = url.searchParams.get("_branch_match_id") ?? undefined;
            const rawReferrer = url.searchParams.get("_branch_referrer") ?? undefined;
            const matchId = rawMatchId ? $beb8cd796f770898$var$sanitizeMatchId(rawMatchId) : undefined;
            const referrer = rawReferrer ? $beb8cd796f770898$var$sanitizeReferrer(rawReferrer) : undefined;
            if (matchId || referrer) return {
                matchId: matchId,
                referrer: referrer
            };
        } catch  {
        /* noop */ }
        return null;
    }
    restoreSessionFromStorage() {
        try {
            const saved = localStorage.getItem($beb8cd796f770898$var$STORAGE_KEY);
            if (!saved) return null;
            const raw = JSON.parse(saved);
            if (!$beb8cd796f770898$var$isObject(raw)) return null;
            const fromBranch = typeof raw.fromBranch === "boolean" ? raw.fromBranch : false;
            const matchId = typeof raw.matchId === "string" ? raw.matchId : undefined;
            const referrer = typeof raw.referrer === "string" ? raw.referrer : undefined;
            const complete = typeof raw.completeRegistrationTracked === "boolean" ? raw.completeRegistrationTracked : false;
            return {
                fromBranch: fromBranch,
                matchId: matchId,
                referrer: referrer,
                completeRegistrationTracked: complete
            };
        } catch  {
            return null;
        }
    }
    getSession() {
        return this.session;
    }
    clearSession() {
        this.session = $beb8cd796f770898$var$DEFAULT_SESSION;
        localStorage.removeItem($beb8cd796f770898$var$STORAGE_KEY);
    }
    trackCompleteRegistration(extra) {
        if (!this.session.fromBranch) return;
        if (this.session.completeRegistrationTracked) return;
        const payload = {
            ...this.session.matchId ? {
                _branch_match_id: this.session.matchId
            } : {},
            ...this.session.referrer ? {
                _branch_referrer: this.session.referrer
            } : {},
            ...extra ?? {},
            tags: [
                "COMPLETE_REGISTRATION"
            ]
        };
        try {
            this.sendEvent("COMPLETE_REGISTRATION", payload);
            this.session.completeRegistrationTracked = true;
            localStorage.setItem($beb8cd796f770898$var$STORAGE_KEY, JSON.stringify(this.session));
        } catch (err) {
        /* noop */ }
    }
    sendEvent(event, payload) {
        if (this.queueOrAdopt(event, payload)) return;
        this.sendViaSdk(event, payload);
    }
    queueOrAdopt(event, payload) {
        if (this.isReady()) return false;
        this.adoptGlobalBranchIfAny();
        if (this.isReady()) return false;
        this.queueOnce(event, payload);
        return true;
    }
    isReady() {
        return !!this.branch && this.initialized;
    }
    adoptGlobalBranchIfAny() {
        const maybeBranch = window.branch;
        if (!maybeBranch) return;
        this.branch ??= maybeBranch;
        if (!this.initialized) this.initialized = true;
    }
    queueOnce(event, payload) {
        const serialized = JSON.stringify(payload);
        const alreadyQueued = this.pendingEvents.some((e)=>e.event === event && JSON.stringify(e.payload) === serialized);
        if (alreadyQueued) return;
        this.pendingEvents.push({
            event: event,
            payload: payload
        });
    }
    sendViaSdk(event, payload) {
        const sdk = this.branch;
        if (!sdk) return;
        if (sdk.logEvent) {
            const alias = event === "COMPLETE_REGISTRATION" ? "completeRegistration" : undefined;
            sdk.logEvent(event, payload, undefined, alias);
            return;
        }
        if (sdk.track) {
            if (event === "COMPLETE_REGISTRATION") sdk.track("completeRegistration", {
                ...payload,
                customer_event_alias: "completeRegistration"
            });
            else sdk.track(event, payload);
        }
    }
    flushPending() {
        if (!this.branch || !this.initialized || this.pendingEvents.length === 0) return;
        const queued = [
            ...this.pendingEvents
        ];
        this.pendingEvents = [];
        queued.forEach(({ event: event, payload: payload })=>this.sendEvent(event, payload));
    }
    adoptBranchDataSession() {
        const sdk = this.branch;
        if (!sdk?.data) return;
        try {
            sdk.data(this.onBranchDataBound);
        } catch  {
        /* noop */ }
    }
    onBranchData(err, data) {
        if (err || !$beb8cd796f770898$var$isObject(data)) return;
        const clicked = this.extractClickedBranchLink(data);
        if (!clicked || this.session.fromBranch) return;
        this.session.fromBranch = true;
        try {
            localStorage.setItem($beb8cd796f770898$var$STORAGE_KEY, JSON.stringify(this.session));
        } catch  {}
    }
    extractClickedBranchLink(data) {
        const raw = data["+clicked_branch_link"];
        return typeof raw === "boolean" ? raw : false;
    }
    constructor(){
        this.session = $beb8cd796f770898$var$DEFAULT_SESSION;
        this.initialized = false;
        this.pendingEvents = [];
        this.onBranchDataBound = (err, data)=>{
            this.onBranchData(err, data);
        };
    }
}
const $beb8cd796f770898$export$8ded47ff6e0435df = new $beb8cd796f770898$export$817744ed4c8f4ee7();

});

/* eslint-disable no-relative-import-paths/no-relative-import-paths */ 
var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");
var $caa473416a32e491$export$882461b6382ed46c;
var $caa473416a32e491$export$757ceba2d55c277e;
"use strict";

var $Q1dTY = parcelRequire("Q1dTY");
var $caa473416a32e491$var$i;
$caa473416a32e491$export$882461b6382ed46c = $Q1dTY.createRoot;
$caa473416a32e491$export$757ceba2d55c277e = $Q1dTY.hydrateRoot;



var $iKObn = parcelRequire("iKObn");




var $04Qjn = parcelRequire("04Qjn");

var $ghfIB = parcelRequire("ghfIB");

var $gMt2l = parcelRequire("gMt2l");

var $kkH7g = parcelRequire("kkH7g");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $91044c9f4e912660$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $e12526d3482a2b29$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $e12526d3482a2b29$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $e12526d3482a2b29$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $e12526d3482a2b29$var$isGlobalObj(window) || typeof self == "object" && $e12526d3482a2b29$var$isGlobalObj(self) || typeof $parcel$global == "object" && $e12526d3482a2b29$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $e12526d3482a2b29$export$256479dc0cea61c4() {
    return $e12526d3482a2b29$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $e12526d3482a2b29$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $e12526d3482a2b29$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}


/** Prefix for logging strings */ const $04de90e46e565a98$var$PREFIX = "Sentry Logger ";
const $04de90e46e565a98$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $04de90e46e565a98$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $04de90e46e565a98$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($04de90e46e565a98$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $04de90e46e565a98$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $04de90e46e565a98$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $91044c9f4e912660$export$16a28057038b10ef) $04de90e46e565a98$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $04de90e46e565a98$export$cda52e2a8927a2ca(()=>{
                (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).console[name](`${$04de90e46e565a98$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $04de90e46e565a98$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $04de90e46e565a98$export$af88d00dbe7f521 = $04de90e46e565a98$var$makeLogger();


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $6e88aab9796f5acd$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



const $7f221ab95ceb1d0f$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $7f221ab95ceb1d0f$export$7740643b9eeaf0c4() {
    return Date.now() / $7f221ab95ceb1d0f$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $7f221ab95ceb1d0f$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $7f221ab95ceb1d0f$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $7f221ab95ceb1d0f$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $7f221ab95ceb1d0f$export$ee52dced521e3e18 = $7f221ab95ceb1d0f$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $7f221ab95ceb1d0f$export$c5907b5a8838db13 = $7f221ab95ceb1d0f$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $7f221ab95ceb1d0f$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $7f221ab95ceb1d0f$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $7f221ab95ceb1d0f$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $7f221ab95ceb1d0f$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $7f221ab95ceb1d0f$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $7f221ab95ceb1d0f$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();

// eslint-disable-next-line @typescript-eslint/unbound-method
const $0bdf548a001e670c$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $0bdf548a001e670c$export$e6127cc7fe7395c3(wat) {
    switch($0bdf548a001e670c$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $0bdf548a001e670c$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $0bdf548a001e670c$var$isBuiltin(wat, className) {
    return $0bdf548a001e670c$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $0bdf548a001e670c$export$9f9636d330b71954(wat) {
    return $0bdf548a001e670c$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $0bdf548a001e670c$export$ef9e2056653f0c8e(wat) {
    return $0bdf548a001e670c$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $0bdf548a001e670c$export$12e869b2a583f783(wat) {
    return $0bdf548a001e670c$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $0bdf548a001e670c$export$844ec244b1367d54(wat) {
    return $0bdf548a001e670c$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $0bdf548a001e670c$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $0bdf548a001e670c$export$c3825b437cbdea5c(wat) {
    return wat === null || $0bdf548a001e670c$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $0bdf548a001e670c$export$53b83ca8eaab0383(wat) {
    return $0bdf548a001e670c$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $0bdf548a001e670c$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $0bdf548a001e670c$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $0bdf548a001e670c$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $0bdf548a001e670c$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $0bdf548a001e670c$export$49841c62b9eff15(wat) {
    return $0bdf548a001e670c$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $0bdf548a001e670c$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $0bdf548a001e670c$export$bc2894c7158efbac(wat) {
    return $0bdf548a001e670c$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $0bdf548a001e670c$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $0bdf548a001e670c$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $0bdf548a001e670c$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}



// eslint-disable-next-line deprecation/deprecation
const $6e7a6d8500b7a471$var$WINDOW = (0, $e12526d3482a2b29$export$256479dc0cea61c4)();
const $6e7a6d8500b7a471$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $6e7a6d8500b7a471$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $6e7a6d8500b7a471$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $6e7a6d8500b7a471$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $6e7a6d8500b7a471$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($6e7a6d8500b7a471$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $0bdf548a001e670c$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $6e7a6d8500b7a471$export$1cfafeee2987818b() {
    try {
        return $6e7a6d8500b7a471$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6e7a6d8500b7a471$export$c660c1f3ab49225c(selector) {
    if ($6e7a6d8500b7a471$var$WINDOW.document && $6e7a6d8500b7a471$var$WINDOW.document.querySelector) return $6e7a6d8500b7a471$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $6e7a6d8500b7a471$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$6e7a6d8500b7a471$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $f28175ac6747d0c5$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $f28175ac6747d0c5$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f28175ac6747d0c5$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $0bdf548a001e670c$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $f28175ac6747d0c5$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $0bdf548a001e670c$export$844ec244b1367d54)(value)) return false;
    if ((0, $0bdf548a001e670c$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $0bdf548a001e670c$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $f28175ac6747d0c5$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$f28175ac6747d0c5$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $3573f39c9e00bebb$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $3573f39c9e00bebb$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $3573f39c9e00bebb$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $91044c9f4e912660$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $3573f39c9e00bebb$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $3573f39c9e00bebb$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $3573f39c9e00bebb$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $3573f39c9e00bebb$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $3573f39c9e00bebb$export$62ff257738bf57f5(value) {
    if ((0, $0bdf548a001e670c$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$3573f39c9e00bebb$var$getOwnProperties(value)
    };
    else if ((0, $0bdf548a001e670c$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $3573f39c9e00bebb$var$serializeEventTarget(value.target),
            currentTarget: $3573f39c9e00bebb$var$serializeEventTarget(value.currentTarget),
            ...$3573f39c9e00bebb$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $0bdf548a001e670c$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $3573f39c9e00bebb$var$serializeEventTarget(target) {
    try {
        return (0, $0bdf548a001e670c$export$45a5e7f76e0caa8d)(target) ? (0, $6e7a6d8500b7a471$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $3573f39c9e00bebb$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $3573f39c9e00bebb$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($3573f39c9e00bebb$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $f28175ac6747d0c5$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $f28175ac6747d0c5$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $3573f39c9e00bebb$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $3573f39c9e00bebb$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $3573f39c9e00bebb$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($3573f39c9e00bebb$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $3573f39c9e00bebb$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($3573f39c9e00bebb$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $3573f39c9e00bebb$var$isPojo(input) {
    if (!(0, $0bdf548a001e670c$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $3573f39c9e00bebb$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $0bdf548a001e670c$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $3801c6184ad1b674$export$19f53698e68b2496() {
    const gbl = (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $3801c6184ad1b674$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $3801c6184ad1b674$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $3801c6184ad1b674$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $3801c6184ad1b674$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $3801c6184ad1b674$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $3801c6184ad1b674$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $3801c6184ad1b674$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $3801c6184ad1b674$export$d364f2020ab30578(input) {
    const match = input.match($3801c6184ad1b674$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $3801c6184ad1b674$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $f28175ac6747d0c5$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $f28175ac6747d0c5$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $f28175ac6747d0c5$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $3801c6184ad1b674$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $3573f39c9e00bebb$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $3801c6184ad1b674$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $7000f88a3a764342$export$849dbeeeda01ae98 = "production";





/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $c7ebba5fa2c683f8$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($c7ebba5fa2c683f8$var$States || ($c7ebba5fa2c683f8$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $c7ebba5fa2c683f8$export$1fda8aa4d135f8aa(value) {
    return new $c7ebba5fa2c683f8$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $c7ebba5fa2c683f8$export$78e43115b553f358(reason) {
    return new $c7ebba5fa2c683f8$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $c7ebba5fa2c683f8$export$6f292d4960313241 {
    constructor(executor){
        $c7ebba5fa2c683f8$export$6f292d4960313241.prototype.__init.call(this);
        $c7ebba5fa2c683f8$export$6f292d4960313241.prototype.__init2.call(this);
        $c7ebba5fa2c683f8$export$6f292d4960313241.prototype.__init3.call(this);
        $c7ebba5fa2c683f8$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $c7ebba5fa2c683f8$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $c7ebba5fa2c683f8$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $c7ebba5fa2c683f8$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($c7ebba5fa2c683f8$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($c7ebba5fa2c683f8$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $c7ebba5fa2c683f8$var$States.PENDING) return;
            if ((0, $0bdf548a001e670c$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $c7ebba5fa2c683f8$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $c7ebba5fa2c683f8$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $c7ebba5fa2c683f8$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $5dce13d6e1d08926$export$3c4238858b85e8ac() {
    return (0, $e12526d3482a2b29$export$7e223ec222791509)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $5dce13d6e1d08926$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $5dce13d6e1d08926$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $5dce13d6e1d08926$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $c7ebba5fa2c683f8$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && processor.id && result === null && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $0bdf548a001e670c$export$f5b060c2914b97c8)(result)) result.then((final)=>$5dce13d6e1d08926$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $5dce13d6e1d08926$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $6634c575d393290e$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $7f221ab95ceb1d0f$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $3801c6184ad1b674$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$6634c575d393290e$var$sessionToJSON(session)
    };
    if (context) $6634c575d393290e$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $6634c575d393290e$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $7f221ab95ceb1d0f$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $3801c6184ad1b674$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $6634c575d393290e$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $6634c575d393290e$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $6634c575d393290e$var$sessionToJSON(session) {
    return (0, $3573f39c9e00bebb$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}











/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $8972e802511990fb$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Does this filename look like it's part of the app code?
 */ function $336c8b0746b22832$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $336c8b0746b22832$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $336c8b0746b22832$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $3756b13f7e84670f$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $3756b13f7e84670f$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $3756b13f7e84670f$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $3756b13f7e84670f$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $3756b13f7e84670f$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($3756b13f7e84670f$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $3756b13f7e84670f$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $3756b13f7e84670f$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $3756b13f7e84670f$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $3756b13f7e84670f$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $3756b13f7e84670f$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($3756b13f7e84670f$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($3756b13f7e84670f$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $3756b13f7e84670f$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $3756b13f7e84670f$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $3756b13f7e84670f$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $3756b13f7e84670f$var$defaultFunctionName;
        return fn.name || $3756b13f7e84670f$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $3756b13f7e84670f$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $3756b13f7e84670f$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $336c8b0746b22832$export$35059013cd4a06db)(getModule)
    ];
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $13f5bb06d3146fad$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $13f5bb06d3146fad$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $13f5bb06d3146fad$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $13f5bb06d3146fad$export$a3295358bff77e(object, depth);
    if ($13f5bb06d3146fad$var$jsonSize(normalized) > maxSize) return $13f5bb06d3146fad$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $13f5bb06d3146fad$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $8972e802511990fb$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $0bdf548a001e670c$export$c9f5652083b8129d)(value)) return value;
    const stringified = $13f5bb06d3146fad$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $13f5bb06d3146fad$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $3573f39c9e00bebb$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $13f5bb06d3146fad$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $13f5bb06d3146fad$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $0bdf548a001e670c$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $0bdf548a001e670c$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $3756b13f7e84670f$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $13f5bb06d3146fad$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $13f5bb06d3146fad$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $13f5bb06d3146fad$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $13f5bb06d3146fad$var$jsonSize(value) {
    return $13f5bb06d3146fad$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $13f5bb06d3146fad$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}









const $edf3a25c0187af20$export$9ca9946bd449ac06 = "baggage";
const $edf3a25c0187af20$export$6e69537d67fa20f = "sentry-";
const $edf3a25c0187af20$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $edf3a25c0187af20$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $edf3a25c0187af20$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $0bdf548a001e670c$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $edf3a25c0187af20$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $edf3a25c0187af20$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($edf3a25c0187af20$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($edf3a25c0187af20$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $edf3a25c0187af20$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$edf3a25c0187af20$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $edf3a25c0187af20$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $edf3a25c0187af20$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $edf3a25c0187af20$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $edf3a25c0187af20$export$bdd844ddb2def819) {
            (0, $91044c9f4e912660$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $ab87fd75b55e34cf$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $ab87fd75b55e34cf$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($ab87fd75b55e34cf$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $ab87fd75b55e34cf$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $ab87fd75b55e34cf$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $edf3a25c0187af20$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $3801c6184ad1b674$export$19f53698e68b2496)(),
            spanId: (0, $3801c6184ad1b674$export$19f53698e68b2496)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $3801c6184ad1b674$export$19f53698e68b2496)(),
            parentSpanId: parentSpanId || (0, $3801c6184ad1b674$export$19f53698e68b2496)().substring(16),
            spanId: (0, $3801c6184ad1b674$export$19f53698e68b2496)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $ab87fd75b55e34cf$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $ab87fd75b55e34cf$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $edf3a25c0187af20$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $3801c6184ad1b674$export$19f53698e68b2496)(),
        spanId: (0, $3801c6184ad1b674$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $3801c6184ad1b674$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $3801c6184ad1b674$export$19f53698e68b2496)().substring(16),
        spanId: (0, $3801c6184ad1b674$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $ab87fd75b55e34cf$export$f35d907436da45cf(traceId = (0, $3801c6184ad1b674$export$19f53698e68b2496)(), spanId = (0, $3801c6184ad1b674$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}


// These are aligned with OpenTelemetry trace flags
const $4a255e6465f9994f$export$208d5b368507fb8b = 0x0;
const $4a255e6465f9994f$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $4a255e6465f9994f$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $4a255e6465f9994f$export$92d8c23565496537(span);
    return (0, $3573f39c9e00bebb$export$d25f2688db1bb433)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $4a255e6465f9994f$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $4a255e6465f9994f$export$5caecac1caaf3a71(span);
    return (0, $ab87fd75b55e34cf$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $4a255e6465f9994f$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $4a255e6465f9994f$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $4a255e6465f9994f$var$ensureTimestampInSeconds(input.getTime());
    return (0, $7f221ab95ceb1d0f$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $4a255e6465f9994f$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $4a255e6465f9994f$export$92d8c23565496537(span) {
    if ($4a255e6465f9994f$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $4a255e6465f9994f$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $4a255e6465f9994f$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $4a255e6465f9994f$export$eb571cd9b5d98de8);
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $e0529c7e0a1e5be4$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $3801c6184ad1b674$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $7f221ab95ceb1d0f$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $e0529c7e0a1e5be4$var$applyClientOptions(prepared, options);
    $e0529c7e0a1e5be4$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $e0529c7e0a1e5be4$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $e0529c7e0a1e5be4$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $3801c6184ad1b674$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $73c3a31b1f3ba92e$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $34eca470d735867d$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $34eca470d735867d$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $34eca470d735867d$export$43988bc651a80216)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $5dce13d6e1d08926$export$3c4238858b85e8ac)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $5dce13d6e1d08926$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $e0529c7e0a1e5be4$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $e0529c7e0a1e5be4$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $e0529c7e0a1e5be4$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $7000f88a3a764342$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $f28175ac6747d0c5$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $f28175ac6747d0c5$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $f28175ac6747d0c5$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $e0529c7e0a1e5be4$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $e0529c7e0a1e5be4$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $e0529c7e0a1e5be4$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $e0529c7e0a1e5be4$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $e0529c7e0a1e5be4$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $e0529c7e0a1e5be4$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $e0529c7e0a1e5be4$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $13f5bb06d3146fad$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $13f5bb06d3146fad$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $13f5bb06d3146fad$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $13f5bb06d3146fad$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $13f5bb06d3146fad$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $4a255e6465f9994f$export$92d8c23565496537)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $13f5bb06d3146fad$export$a3295358bff77e)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $e0529c7e0a1e5be4$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $73c3a31b1f3ba92e$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $e0529c7e0a1e5be4$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($e0529c7e0a1e5be4$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($e0529c7e0a1e5be4$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $e0529c7e0a1e5be4$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $73c3a31b1f3ba92e$export$775b6bb06e53a214) || typeof hint === "function";
}
const $e0529c7e0a1e5be4$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $e0529c7e0a1e5be4$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$e0529c7e0a1e5be4$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $15458dde2c60d92b$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)().captureException(exception, (0, $e0529c7e0a1e5be4$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $15458dde2c60d92b$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $15458dde2c60d92b$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $15458dde2c60d92b$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $15458dde2c60d92b$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $15458dde2c60d92b$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $15458dde2c60d92b$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $15458dde2c60d92b$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $15458dde2c60d92b$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $15458dde2c60d92b$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $15458dde2c60d92b$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $15458dde2c60d92b$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $15458dde2c60d92b$export$9a4fed82c350c2bd(callback) {
    return (0, $6ea9c05e188f19de$export$70d775fb1f267027)(()=>{
        return callback((0, $6ea9c05e188f19de$export$68f3af03034c9e90)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $15458dde2c60d92b$export$e57ac09b143d92a2(span, callback) {
    return $15458dde2c60d92b$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $15458dde2c60d92b$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $15458dde2c60d92b$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $15458dde2c60d92b$export$c7be4b0125a10cba();
    const client = $15458dde2c60d92b$export$6bb76d6eba7e258c();
    if (!client) (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $3801c6184ad1b674$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $15458dde2c60d92b$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $15458dde2c60d92b$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $7f221ab95ceb1d0f$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $15458dde2c60d92b$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $7f221ab95ceb1d0f$export$ee52dced521e3e18)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $0bdf548a001e670c$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $15458dde2c60d92b$export$4909b86c8034bf73(timeout) {
    const client = $15458dde2c60d92b$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $15458dde2c60d92b$export$8360e631d277ea4d(timeout) {
    const client = $15458dde2c60d92b$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $15458dde2c60d92b$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $15458dde2c60d92b$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $15458dde2c60d92b$export$3f95c6f800b78024() {
    return !!$15458dde2c60d92b$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $15458dde2c60d92b$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $15458dde2c60d92b$export$c0d84948cecf78d8(context) {
    const client = $15458dde2c60d92b$export$6bb76d6eba7e258c();
    const isolationScope = (0, $6ea9c05e188f19de$export$68f3af03034c9e90)();
    const currentScope = $15458dde2c60d92b$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $7000f88a3a764342$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $6634c575d393290e$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $6634c575d393290e$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $15458dde2c60d92b$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $15458dde2c60d92b$export$17a5be43989a0bc1() {
    const isolationScope = (0, $6ea9c05e188f19de$export$68f3af03034c9e90)();
    const currentScope = $15458dde2c60d92b$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $6634c575d393290e$export$56521d9ba90f62ee)(session);
    $15458dde2c60d92b$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $15458dde2c60d92b$var$_sendSessionUpdate() {
    const isolationScope = (0, $6ea9c05e188f19de$export$68f3af03034c9e90)();
    const currentScope = $15458dde2c60d92b$export$c7be4b0125a10cba();
    const client = $15458dde2c60d92b$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $15458dde2c60d92b$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $15458dde2c60d92b$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $15458dde2c60d92b$var$_sendSessionUpdate();
}


/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $0cb9d88e8dab2146$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}



/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $0b16142076d4c1de$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $3573f39c9e00bebb$export$d25f2688db1bb433)({
        environment: options.environment || (0, $7000f88a3a764342$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $0b16142076d4c1de$export$a117f995597e25df(span) {
    const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $0b16142076d4c1de$export$366bad00d6815eed((0, $4a255e6465f9994f$export$92d8c23565496537)(span).trace_id || "", client, (0, $15458dde2c60d92b$export$c7be4b0125a10cba)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $0cb9d88e8dab2146$export$c4c6a79b1260ca1b)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $4a255e6465f9994f$export$92d8c23565496537)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $4a255e6465f9994f$export$5caecac1caaf3a71)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $34eca470d735867d$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $34eca470d735867d$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $34eca470d735867d$var$applySpanToEvent(event, span);
    $34eca470d735867d$var$applyFingerprintToEvent(event, fingerprint);
    $34eca470d735867d$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $34eca470d735867d$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $34eca470d735867d$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $34eca470d735867d$export$b1a120a2871faa46(data, "extra", extra);
    $34eca470d735867d$export$b1a120a2871faa46(data, "tags", tags);
    $34eca470d735867d$export$b1a120a2871faa46(data, "user", user);
    $34eca470d735867d$export$b1a120a2871faa46(data, "contexts", contexts);
    $34eca470d735867d$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $34eca470d735867d$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $34eca470d735867d$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $3573f39c9e00bebb$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $3573f39c9e00bebb$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $3573f39c9e00bebb$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $3573f39c9e00bebb$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $34eca470d735867d$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $34eca470d735867d$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $34eca470d735867d$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $4a255e6465f9994f$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    const rootSpan = (0, $0cb9d88e8dab2146$export$c4c6a79b1260ca1b)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $0b16142076d4c1de$export$a117f995597e25df)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $4a255e6465f9994f$export$92d8c23565496537)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $34eca470d735867d$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $3801c6184ad1b674$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $73c3a31b1f3ba92e$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $73c3a31b1f3ba92e$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $73c3a31b1f3ba92e$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $73c3a31b1f3ba92e$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $73c3a31b1f3ba92e$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $73c3a31b1f3ba92e$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $6634c575d393290e$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $73c3a31b1f3ba92e$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $0bdf548a001e670c$export$53b83ca8eaab0383)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $73c3a31b1f3ba92e$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $73c3a31b1f3ba92e$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $7f221ab95ceb1d0f$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $34eca470d735867d$export$43988bc651a80216)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $5dce13d6e1d08926$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ];
        return (0, $5dce13d6e1d08926$export$bf2a096c3e883e79)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $3801c6184ad1b674$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $3801c6184ad1b674$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $3801c6184ad1b674$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $73c3a31b1f3ba92e$export$aa55d5ab8e05984f() {
    if (!$73c3a31b1f3ba92e$var$globalScope) $73c3a31b1f3ba92e$var$globalScope = new $73c3a31b1f3ba92e$export$775b6bb06e53a214();
    return $73c3a31b1f3ba92e$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $73c3a31b1f3ba92e$export$c83048efd17527d6(scope) {
    $73c3a31b1f3ba92e$var$globalScope = scope;
}
function $73c3a31b1f3ba92e$var$generatePropagationContext() {
    return {
        traceId: (0, $3801c6184ad1b674$export$19f53698e68b2496)(),
        spanId: (0, $3801c6184ad1b674$export$19f53698e68b2496)().substring(16)
    };
}



const $05d6e4b55befa410$export$31499a9cd224b78c = "7.118.0";


/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $6ea9c05e188f19de$export$24a86ef7798177e4 = parseFloat((0, $05d6e4b55befa410$export$31499a9cd224b78c));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $6ea9c05e188f19de$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $6ea9c05e188f19de$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $6ea9c05e188f19de$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $73c3a31b1f3ba92e$export$775b6bb06e53a214)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $73c3a31b1f3ba92e$export$775b6bb06e53a214)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $0bdf548a001e670c$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $3801c6184ad1b674$export$19f53698e68b2496)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $3801c6184ad1b674$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $3801c6184ad1b674$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $6ea9c05e188f19de$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $7f221ab95ceb1d0f$export$7740643b9eeaf0c4)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $04de90e46e565a98$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $6ea9c05e188f19de$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $6ea9c05e188f19de$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $6e88aab9796f5acd$export$16a28057038b10ef) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $6634c575d393290e$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $7000f88a3a764342$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).navigator || {};
        const session = (0, $6634c575d393290e$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $6634c575d393290e$export$531818e825e774db)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $6ea9c05e188f19de$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $6ea9c05e188f19de$export$19eade501500c6c1() {
    (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).__SENTRY__ = (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $e12526d3482a2b29$export$f1a6cdb1459e81d1;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $6ea9c05e188f19de$export$4188a14ad302d1bc(hub) {
    const registry = $6ea9c05e188f19de$export$19eade501500c6c1();
    const oldHub = $6ea9c05e188f19de$export$bfa8a924a84a76b7(registry);
    $6ea9c05e188f19de$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $6ea9c05e188f19de$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $6ea9c05e188f19de$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $6ea9c05e188f19de$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $6ea9c05e188f19de$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $6ea9c05e188f19de$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $6ea9c05e188f19de$var$getGlobalHub(registry = $6ea9c05e188f19de$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$6ea9c05e188f19de$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $6ea9c05e188f19de$export$bfa8a924a84a76b7(registry).isOlderThan($6ea9c05e188f19de$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $6ea9c05e188f19de$export$849f05434e95d2f2(registry, new $6ea9c05e188f19de$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $6ea9c05e188f19de$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $6ea9c05e188f19de$export$236689a79f5aa020(carrier, parent = $6ea9c05e188f19de$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$6ea9c05e188f19de$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $6ea9c05e188f19de$export$bfa8a924a84a76b7(carrier).isOlderThan($6ea9c05e188f19de$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $6ea9c05e188f19de$export$849f05434e95d2f2(carrier, new $6ea9c05e188f19de$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $6ea9c05e188f19de$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $6ea9c05e188f19de$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $6ea9c05e188f19de$export$70d775fb1f267027(callback, options = {}) {
    const registry = $6ea9c05e188f19de$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $6ea9c05e188f19de$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $6ea9c05e188f19de$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $e12526d3482a2b29$export$7e223ec222791509)("hub", ()=>new $6ea9c05e188f19de$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $6ea9c05e188f19de$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}







// We keep the handlers globally
const $550d0e553f060ebd$var$handlers = {};
const $550d0e553f060ebd$var$instrumented = {};
/** Add a handler function. */ function $550d0e553f060ebd$export$a4e09611e30da72e(type, handler) {
    $550d0e553f060ebd$var$handlers[type] = $550d0e553f060ebd$var$handlers[type] || [];
    $550d0e553f060ebd$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $550d0e553f060ebd$export$b17eab759a1cb5fe() {
    Object.keys($550d0e553f060ebd$var$handlers).forEach((key)=>{
        $550d0e553f060ebd$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $550d0e553f060ebd$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$550d0e553f060ebd$var$instrumented[type]) {
        instrumentFn();
        $550d0e553f060ebd$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $550d0e553f060ebd$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $550d0e553f060ebd$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $91044c9f4e912660$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $3756b13f7e84670f$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


let $8ab90ffae30d643c$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $8ab90ffae30d643c$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $550d0e553f060ebd$export$a4e09611e30da72e)(type, handler);
    (0, $550d0e553f060ebd$export$e18d6c5462c01368)(type, $8ab90ffae30d643c$var$instrumentError);
}
function $8ab90ffae30d643c$var$instrumentError() {
    $8ab90ffae30d643c$var$_oldOnErrorHandler = (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).onerror;
    (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $550d0e553f060ebd$export$b18c893e424d3127)("error", handlerData);
        if ($8ab90ffae30d643c$var$_oldOnErrorHandler && !$8ab90ffae30d643c$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $8ab90ffae30d643c$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $04599fc7a61401dd$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $04599fc7a61401dd$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $550d0e553f060ebd$export$a4e09611e30da72e)(type, handler);
    (0, $550d0e553f060ebd$export$e18d6c5462c01368)(type, $04599fc7a61401dd$var$instrumentUnhandledRejection);
}
function $04599fc7a61401dd$var$instrumentUnhandledRejection() {
    $04599fc7a61401dd$var$_oldOnUnhandledRejectionHandler = (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $550d0e553f060ebd$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($04599fc7a61401dd$var$_oldOnUnhandledRejectionHandler && !$04599fc7a61401dd$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $04599fc7a61401dd$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $fa42f5cc1383fe7d$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $fa42f5cc1383fe7d$export$8e9a29865c0a1226 = (0, $ab87fd75b55e34cf$export$8e9a29865c0a1226);


let $c63ed6cc640fafdb$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $c63ed6cc640fafdb$export$637857c1d87b640c() {
    if ($c63ed6cc640fafdb$var$errorsInstrumented) return;
    $c63ed6cc640fafdb$var$errorsInstrumented = true;
    (0, $8ab90ffae30d643c$export$55b5c3ba2194f0c6)($c63ed6cc640fafdb$var$errorCallback);
    (0, $04599fc7a61401dd$export$8bf4fc6858821a4e)($c63ed6cc640fafdb$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $c63ed6cc640fafdb$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $fa42f5cc1383fe7d$export$a7feb32fdd923295)();
    if (activeTransaction) {
        const status = "internal_error";
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$c63ed6cc640fafdb$var$errorCallback.tag = "sentry_tracingErrorCallback";




















/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $2d5c99d63236ed1e$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $2d5c99d63236ed1e$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $2d5c99d63236ed1e$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $0bdf548a001e670c$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $659a02a25d0877fc$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}


/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $7bc0a43bc95a30e2$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)();
    const scope = (0, $15458dde2c60d92b$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $7bc0a43bc95a30e2$var$normalizeContext(context);
    const activeSpan = $7bc0a43bc95a30e2$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $2d5c99d63236ed1e$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $7bc0a43bc95a30e2$export$a1bd95187356f372(context, callback) {
    const spanContext = $7bc0a43bc95a30e2$var$normalizeContext(context);
    return (0, $6ea9c05e188f19de$export$70d775fb1f267027)(()=>{
        return (0, $15458dde2c60d92b$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $7bc0a43bc95a30e2$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $2d5c99d63236ed1e$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $4a255e6465f9994f$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $7bc0a43bc95a30e2$export$cb9e396e6b90b703 = $7bc0a43bc95a30e2$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $7bc0a43bc95a30e2$export$c10292ad04b92aea(context, callback) {
    const spanContext = $7bc0a43bc95a30e2$var$normalizeContext(context);
    return (0, $6ea9c05e188f19de$export$70d775fb1f267027)(()=>{
        return (0, $15458dde2c60d92b$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $7bc0a43bc95a30e2$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $2d5c99d63236ed1e$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $4a255e6465f9994f$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $7bc0a43bc95a30e2$export$63dbba021a6b4047(context) {
    if (!(0, $659a02a25d0877fc$export$5008da00b1b6dee6)()) return undefined;
    const spanContext = $7bc0a43bc95a30e2$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)();
    const parentSpan = context.scope ? context.scope.getSpan() : $7bc0a43bc95a30e2$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $15458dde2c60d92b$export$c7be4b0125a10cba)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $7bc0a43bc95a30e2$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $7bc0a43bc95a30e2$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $15458dde2c60d92b$export$c7be4b0125a10cba)().getSpan();
}
const $7bc0a43bc95a30e2$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $15458dde2c60d92b$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $ab87fd75b55e34cf$export$ca5c066532785b6e)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $6e88aab9796f5acd$export$16a28057038b10ef) && traceparentData) (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $3573f39c9e00bebb$export$d25f2688db1bb433)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $6ea9c05e188f19de$export$70d775fb1f267027)(()=>{
        return callback(transactionContext);
    });
};
function $7bc0a43bc95a30e2$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $659a02a25d0877fc$export$5008da00b1b6dee6)()) return undefined;
    const isolationScope = (0, $6ea9c05e188f19de$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $0b16142076d4c1de$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $4a255e6465f9994f$export$5caecac1caaf3a71)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $7bc0a43bc95a30e2$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $7bc0a43bc95a30e2$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $4a255e6465f9994f$export$3f7581298f56c6d7)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $7bc0a43bc95a30e2$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $7bc0a43bc95a30e2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $7bc0a43bc95a30e2$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $3573f39c9e00bebb$export$e73679ffaf56810e)(span, $7bc0a43bc95a30e2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $3573f39c9e00bebb$export$e73679ffaf56810e)(span, $7bc0a43bc95a30e2$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $7bc0a43bc95a30e2$export$c08fbc656a245d03(span) {
    return {
        scope: span[$7bc0a43bc95a30e2$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$7bc0a43bc95a30e2$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $b88822e3d2facd98$var$SPAN_METRIC_SUMMARY;
function $b88822e3d2facd98$var$getMetricStorageForSpan(span) {
    return $b88822e3d2facd98$var$SPAN_METRIC_SUMMARY ? $b88822e3d2facd98$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $b88822e3d2facd98$export$2e7205e45c58797d(span) {
    const storage = $b88822e3d2facd98$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $3573f39c9e00bebb$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $b88822e3d2facd98$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $7bc0a43bc95a30e2$export$1be426a8e585c83e)();
    if (span) {
        const storage = $b88822e3d2facd98$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$b88822e3d2facd98$var$SPAN_METRIC_SUMMARY) $b88822e3d2facd98$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $b88822e3d2facd98$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $2a38ddd8bc83e514$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $2a38ddd8bc83e514$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $2a38ddd8bc83e514$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $2a38ddd8bc83e514$export$cca8dd30f57f805e = "sentry.origin";
/**
 * The id of the profile that this span occured in.
 */ const $2a38ddd8bc83e514$export$1efec95406bbe327 = "profile_id";




/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $8a177456b38bb278$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})($8a177456b38bb278$export$beb8e6a823e89c5d || ($8a177456b38bb278$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $8a177456b38bb278$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $8a177456b38bb278$export$ac65c70d78fcdb55 = $8a177456b38bb278$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $8a177456b38bb278$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag("http.status_code", String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData("http.response.status_code", httpStatus);
    const spanStatus = $8a177456b38bb278$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== "unknown_error") span.setStatus(spanStatus);
}


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $4adcf809c0f00acf$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $4adcf809c0f00acf$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $3801c6184ad1b674$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $3801c6184ad1b674$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $7f221ab95ceb1d0f$export$ee52dced521e3e18)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this._attributes = {};
        this.setAttributes({
            [(0, $2a38ddd8bc83e514$export$cca8dd30f57f805e)]: spanContext.origin || "manual",
            [(0, $2a38ddd8bc83e514$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || "";
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $2a38ddd8bc83e514$export$1a413bd9a88fdb09];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $2a38ddd8bc83e514$export$1a413bd9a88fdb09), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $2a38ddd8bc83e514$export$cca8dd30f57f805e];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $2a38ddd8bc83e514$export$cca8dd30f57f805e), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $4a255e6465f9994f$export$eb571cd9b5d98de8) : (0, $4a255e6465f9994f$export$208d5b368507fb8b)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $4adcf809c0f00acf$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $0cb9d88e8dab2146$export$c4c6a79b1260ca1b)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $6e88aab9796f5acd$export$16a28057038b10ef) && rootSpan) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = (0, $4a255e6465f9994f$export$92d8c23565496537)(childSpan).description || "< unknown name >";
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $04de90e46e565a98$export$af88d00dbe7f521).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $8a177456b38bb278$export$2ad6630ec8164254)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === "ok";
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $0cb9d88e8dab2146$export$c4c6a79b1260ca1b)(this);
        if ((0, $6e88aab9796f5acd$export$16a28057038b10ef) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $04de90e46e565a98$export$af88d00dbe7f521).log(logMessage.replace("Starting", "Finishing"));
        }
        this._endTime = (0, $4a255e6465f9994f$export$3f7581298f56c6d7)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $4a255e6465f9994f$export$7e9f8ae9e4a328ab)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $3573f39c9e00bebb$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $4a255e6465f9994f$export$46c6fbd1d265ebf0)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $3573f39c9e00bebb$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $2a38ddd8bc83e514$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $2a38ddd8bc83e514$export$cca8dd30f57f805e],
            _metrics_summary: (0, $b88822e3d2facd98$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $2a38ddd8bc83e514$export$1efec95406bbe327],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}











/** JSDoc */ class $75c8bcd6877ac7eb$export$febc5573c75cefb0 extends (0, $4adcf809c0f00acf$export$5f1714a13ed34c01) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)();
        this._name = transactionContext.name || "";
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: "custom",
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $2a38ddd8bc83e514$export$d7a7d984b0791405] && {
                source: this._attributes[0, $2a38ddd8bc83e514$export$d7a7d984b0791405]
            },
            ...this._attributes[0, $2a38ddd8bc83e514$export$ccfe0a40627cc34b] && {
                sampleRate: this._attributes[0, $2a38ddd8bc83e514$export$ccfe0a40627cc34b]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = "custom") {
        this._name = name;
        this.setAttribute((0, $2a38ddd8bc83e514$export$d7a7d984b0791405), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $4adcf809c0f00acf$export$10c95c129cd0d4fe)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $4a255e6465f9994f$export$3f7581298f56c6d7)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $3573f39c9e00bebb$export$d25f2688db1bb433)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $0b16142076d4c1de$export$a117f995597e25df)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts["profile"] !== undefined) return this._contexts["profile"].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $4a255e6465f9994f$export$92d8c23565496537)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $4a255e6465f9994f$export$92d8c23565496537)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $7bc0a43bc95a30e2$export$c08fbc656a245d03)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $4a255e6465f9994f$export$46c6fbd1d265ebf0)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $3573f39c9e00bebb$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $0b16142076d4c1de$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $b88822e3d2facd98$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}


const $645dec74aac904d7$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $645dec74aac904d7$var$FINISH_REASON_TAG = "finishReason";
const $645dec74aac904d7$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $645dec74aac904d7$export$370d6113c18ba86c extends (0, $4adcf809c0f00acf$export$10c95c129cd0d4fe) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $4a255e6465f9994f$export$92d8c23565496537)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $645dec74aac904d7$export$b279e6bd7040371f extends (0, $75c8bcd6877ac7eb$export$febc5573c75cefb0) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $645dec74aac904d7$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $645dec74aac904d7$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $645dec74aac904d7$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $645dec74aac904d7$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $645dec74aac904d7$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $4a255e6465f9994f$export$3f7581298f56c6d7)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === "ui.action.click") this.setAttribute($645dec74aac904d7$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
            (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $4a255e6465f9994f$export$92d8c23565496537)(span).timestamp) {
                    span.setStatus("cancelled");
                    span.end(endTimestampInS);
                    (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $4a255e6465f9994f$export$92d8c23565496537)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $6e88aab9796f5acd$export$16a28057038b10ef) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Tracing] flushing IdleTransaction");
        } else (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $645dec74aac904d7$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $645dec74aac904d7$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Tracing] Received finish signal for idle transaction.");
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $645dec74aac904d7$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $7f221ab95ceb1d0f$export$ee52dced521e3e18)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $645dec74aac904d7$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Tracing] Transaction finished because of no change for 3 heart beats");
                this.setStatus("deadline_exceeded");
                this._finishReason = $645dec74aac904d7$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}







/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $7b93f520cfc3d78b$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $659a02a25d0877fc$export$5008da00b1b6dee6)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $2a38ddd8bc83e514$export$ccfe0a40627cc34b), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $2a38ddd8bc83e514$export$ccfe0a40627cc34b), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $2a38ddd8bc83e514$export$ccfe0a40627cc34b), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $2a38ddd8bc83e514$export$ccfe0a40627cc34b), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$7b93f520cfc3d78b$export$2603c8d332a51c42(sampleRate)) {
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $6e88aab9796f5acd$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
    (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $4a255e6465f9994f$export$92d8c23565496537)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $7b93f520cfc3d78b$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $0bdf548a001e670c$export$c9f5652083b8129d)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}



/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $d1d9031d0117d401$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": (0, $4a255e6465f9994f$export$7e9f8ae9e4a328ab)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $d1d9031d0117d401$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $75c8bcd6877ac7eb$export$febc5573c75cefb0)(transactionContext, this);
    transaction = (0, $7b93f520cfc3d78b$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $d1d9031d0117d401$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $645dec74aac904d7$export$b279e6bd7040371f)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $7b93f520cfc3d78b$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $d1d9031d0117d401$export$653d0ef2bad9cdf9() {
    const carrier = (0, $6ea9c05e188f19de$export$19eade501500c6c1)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $d1d9031d0117d401$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $d1d9031d0117d401$var$traceHeaders;
    (0, $c63ed6cc640fafdb$export$637857c1d87b640c)();
}







// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $2d0a9d349a0f6b7c$var$WINDOW = (0, $e12526d3482a2b29$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $2d0a9d349a0f6b7c$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $2d0a9d349a0f6b7c$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $2d0a9d349a0f6b7c$var$WINDOW && !!$2d0a9d349a0f6b7c$var$WINDOW.history.pushState && !!$2d0a9d349a0f6b7c$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $25558ab1f79d7e77$var$WINDOW = (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1);
let $25558ab1f79d7e77$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $25558ab1f79d7e77$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $550d0e553f060ebd$export$a4e09611e30da72e)(type, handler);
    (0, $550d0e553f060ebd$export$e18d6c5462c01368)(type, $25558ab1f79d7e77$var$instrumentHistory);
}
function $25558ab1f79d7e77$var$instrumentHistory() {
    if (!(0, $2d0a9d349a0f6b7c$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $25558ab1f79d7e77$var$WINDOW.onpopstate;
    $25558ab1f79d7e77$var$WINDOW.onpopstate = function(...args) {
        const to = $25558ab1f79d7e77$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $25558ab1f79d7e77$var$lastHref;
        $25558ab1f79d7e77$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $550d0e553f060ebd$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $25558ab1f79d7e77$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $25558ab1f79d7e77$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $550d0e553f060ebd$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $3573f39c9e00bebb$export$9563e054e6f787fb)($25558ab1f79d7e77$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $3573f39c9e00bebb$export$9563e054e6f787fb)($25558ab1f79d7e77$var$WINDOW.history, "replaceState", historyReplacementFunction);
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $453e81e4c2a52375$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;






const $574af554ec58c6c0$export$56d8a8a25bd48b81 = (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $4762b7f3056b9823$export$6f18f55521af71a1() {
    if ((0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document) (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $fa42f5cc1383fe7d$export$a7feb32fdd923295)();
        if ((0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            const { op: op, status: status } = (0, $4a255e6465f9994f$export$92d8c23565496537)(activeTransaction);
            (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.end();
        }
    });
    else (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}




const $2017c3ebbb3e49c8$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $d068acaec32fef2b$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4bf61cab9b67433f$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $4bf61cab9b67433f$export$6431553786c94949 = ()=>{
    if ((0, $574af554ec58c6c0$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $4bf61cab9b67433f$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4799e8c6288a9acd$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $4bf61cab9b67433f$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d58d495fc34e4f07$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $4bf61cab9b67433f$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document && (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document.prerendering || (0, $4799e8c6288a9acd$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $d068acaec32fef2b$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $cfbfa9ddc205a669$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1c0ec2f98e8872e4$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $515c85d4466c0b17$export$a7873055838e5ad8 = (onReport, options = {})=>{
    const metric = (0, $d58d495fc34e4f07$export$3c29b44508a0612b)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $cfbfa9ddc205a669$export$d1203567a167490e)("layout-shift", handleEntries);
    if (po) {
        report = (0, $2017c3ebbb3e49c8$export$17679dccdd551979)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $1c0ec2f98e8872e4$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $3faddefc86569283$var$firstHiddenTime = -1;
const $3faddefc86569283$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document && (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document.visibilityState) $3faddefc86569283$var$firstHiddenTime = (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $3faddefc86569283$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $1c0ec2f98e8872e4$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $3faddefc86569283$var$firstHiddenTime = timeStamp;
    }, true);
};
const $3faddefc86569283$export$443f86b2c77012c4 = ()=>{
    if ($3faddefc86569283$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $3faddefc86569283$var$initHiddenTime();
        $3faddefc86569283$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $3faddefc86569283$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $b77cfa17e82fabc7$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $3faddefc86569283$export$443f86b2c77012c4)();
    const metric = (0, $d58d495fc34e4f07$export$3c29b44508a0612b)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $cfbfa9ddc205a669$export$d1203567a167490e)("first-input", handleEntries);
    report = (0, $2017c3ebbb3e49c8$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $1c0ec2f98e8872e4$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







let $756bcb4c6f622509$var$interactionCountEstimate = 0;
let $756bcb4c6f622509$var$minKnownInteractionId = Infinity;
let $756bcb4c6f622509$var$maxKnownInteractionId = 0;
const $756bcb4c6f622509$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $756bcb4c6f622509$var$minKnownInteractionId = Math.min($756bcb4c6f622509$var$minKnownInteractionId, e.interactionId);
            $756bcb4c6f622509$var$maxKnownInteractionId = Math.max($756bcb4c6f622509$var$maxKnownInteractionId, e.interactionId);
            $756bcb4c6f622509$var$interactionCountEstimate = $756bcb4c6f622509$var$maxKnownInteractionId ? ($756bcb4c6f622509$var$maxKnownInteractionId - $756bcb4c6f622509$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $756bcb4c6f622509$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $756bcb4c6f622509$export$8a962f2683a476d1 = ()=>{
    return $756bcb4c6f622509$var$po ? $756bcb4c6f622509$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $756bcb4c6f622509$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $756bcb4c6f622509$var$po) return;
    $756bcb4c6f622509$var$po = (0, $cfbfa9ddc205a669$export$d1203567a167490e)("event", $756bcb4c6f622509$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $9113aa1135c13ada$var$getInteractionCountForNavigation = ()=>{
    return (0, $756bcb4c6f622509$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $9113aa1135c13ada$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $9113aa1135c13ada$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $9113aa1135c13ada$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $9113aa1135c13ada$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $9113aa1135c13ada$var$longestInteractionList[$9113aa1135c13ada$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $9113aa1135c13ada$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $9113aa1135c13ada$var$longestInteractionList.length < $9113aa1135c13ada$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $9113aa1135c13ada$var$longestInteractionMap[interaction.id] = interaction;
            $9113aa1135c13ada$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $9113aa1135c13ada$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $9113aa1135c13ada$var$longestInteractionList.splice($9113aa1135c13ada$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $9113aa1135c13ada$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $9113aa1135c13ada$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($9113aa1135c13ada$var$longestInteractionList.length - 1, Math.floor($9113aa1135c13ada$var$getInteractionCountForNavigation() / 50));
    return $9113aa1135c13ada$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $9113aa1135c13ada$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $756bcb4c6f622509$export$67d90cda6b78a2eb)();
    const metric = (0, $d58d495fc34e4f07$export$3c29b44508a0612b)("INP");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $9113aa1135c13ada$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === "first-input") {
                const noMatchingEntry = !$9113aa1135c13ada$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $9113aa1135c13ada$var$processEntry(entry);
            }
        });
        const inp = $9113aa1135c13ada$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $cfbfa9ddc205a669$export$d1203567a167490e)("event", handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $2017c3ebbb3e49c8$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: "first-input",
            buffered: true
        });
        (0, $1c0ec2f98e8872e4$export$91ec2be6fdd8f1b4)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $9113aa1135c13ada$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ff9edc0c39268f2c$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $ff9edc0c39268f2c$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $3faddefc86569283$export$443f86b2c77012c4)();
    const metric = (0, $d58d495fc34e4f07$export$3c29b44508a0612b)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $4799e8c6288a9acd$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $cfbfa9ddc205a669$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $2017c3ebbb3e49c8$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$ff9edc0c39268f2c$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $ff9edc0c39268f2c$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            if ((0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $1c0ec2f98e8872e4$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $d6900672cb5a9056$var$whenReady = (callback)=>{
    if (!(0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document) return;
    if ((0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document.prerendering) addEventListener("prerenderingchange", ()=>$d6900672cb5a9056$var$whenReady(callback), true);
    else if ((0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document.readyState !== "complete") addEventListener("load", ()=>$d6900672cb5a9056$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $d6900672cb5a9056$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $d58d495fc34e4f07$export$3c29b44508a0612b)("TTFB");
    const report = (0, $2017c3ebbb3e49c8$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    $d6900672cb5a9056$var$whenReady(()=>{
        const navEntry = (0, $4bf61cab9b67433f$export$6431553786c94949)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $4799e8c6288a9acd$export$d3e828b3c7b5b845)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $f711f072777a2234$var$handlers = {};
const $f711f072777a2234$var$instrumented = {};
let $f711f072777a2234$var$_previousCls;
let $f711f072777a2234$var$_previousFid;
let $f711f072777a2234$var$_previousLcp;
let $f711f072777a2234$var$_previousTtfb;
let $f711f072777a2234$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $f711f072777a2234$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $f711f072777a2234$var$addMetricObserver("cls", callback, $f711f072777a2234$var$instrumentCls, $f711f072777a2234$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $f711f072777a2234$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $f711f072777a2234$var$addMetricObserver("lcp", callback, $f711f072777a2234$var$instrumentLcp, $f711f072777a2234$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $f711f072777a2234$export$699d9529c099a797(callback) {
    return $f711f072777a2234$var$addMetricObserver("ttfb", callback, $f711f072777a2234$var$instrumentTtfb, $f711f072777a2234$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $f711f072777a2234$export$2707d7471c0b918f(callback) {
    return $f711f072777a2234$var$addMetricObserver("fid", callback, $f711f072777a2234$var$instrumentFid, $f711f072777a2234$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $f711f072777a2234$export$da3b76aa2022cbd7(callback) {
    return $f711f072777a2234$var$addMetricObserver("inp", callback, $f711f072777a2234$var$instrumentInp, $f711f072777a2234$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $f711f072777a2234$export$69816c1a049f8db6(type, callback) {
    $f711f072777a2234$var$addHandler(type, callback);
    if (!$f711f072777a2234$var$instrumented[type]) {
        $f711f072777a2234$var$instrumentPerformanceObserver(type);
        $f711f072777a2234$var$instrumented[type] = true;
    }
    return $f711f072777a2234$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $f711f072777a2234$var$triggerHandlers(type, data) {
    const typeHandlers = $f711f072777a2234$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $3756b13f7e84670f$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $f711f072777a2234$var$instrumentCls() {
    return (0, $515c85d4466c0b17$export$a7873055838e5ad8)((metric)=>{
        $f711f072777a2234$var$triggerHandlers("cls", {
            metric: metric
        });
        $f711f072777a2234$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $f711f072777a2234$var$instrumentFid() {
    return (0, $b77cfa17e82fabc7$export$39705a25c49af873)((metric)=>{
        $f711f072777a2234$var$triggerHandlers("fid", {
            metric: metric
        });
        $f711f072777a2234$var$_previousFid = metric;
    });
}
function $f711f072777a2234$var$instrumentLcp() {
    return (0, $ff9edc0c39268f2c$export$947b1626ab8d5632)((metric)=>{
        $f711f072777a2234$var$triggerHandlers("lcp", {
            metric: metric
        });
        $f711f072777a2234$var$_previousLcp = metric;
    });
}
function $f711f072777a2234$var$instrumentTtfb() {
    return (0, $d6900672cb5a9056$export$33a01e6c5f2c7e33)((metric)=>{
        $f711f072777a2234$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $f711f072777a2234$var$_previousTtfb = metric;
    });
}
function $f711f072777a2234$var$instrumentInp() {
    return (0, $9113aa1135c13ada$export$7df4b36ecaed99e1)((metric)=>{
        $f711f072777a2234$var$triggerHandlers("inp", {
            metric: metric
        });
        $f711f072777a2234$var$_previousInp = metric;
    });
}
function $f711f072777a2234$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $f711f072777a2234$var$addHandler(type, callback);
    let stopListening;
    if (!$f711f072777a2234$var$instrumented[type]) {
        stopListening = instrumentFn();
        $f711f072777a2234$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $f711f072777a2234$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $f711f072777a2234$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $cfbfa9ddc205a669$export$d1203567a167490e)(type, (entries)=>{
        $f711f072777a2234$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $f711f072777a2234$var$addHandler(type, handler) {
    $f711f072777a2234$var$handlers[type] = $f711f072777a2234$var$handlers[type] || [];
    $f711f072777a2234$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $f711f072777a2234$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $f711f072777a2234$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}




/** Regular expression used to parse a Dsn. */ const $6a32dc741d9d6083$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $6a32dc741d9d6083$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $6a32dc741d9d6083$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $6a32dc741d9d6083$export$b892860177f70a30(str) {
    const match = $6a32dc741d9d6083$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $04de90e46e565a98$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $6a32dc741d9d6083$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $6a32dc741d9d6083$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $6a32dc741d9d6083$var$validateDsn(dsn) {
    if (!(0, $91044c9f4e912660$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $04de90e46e565a98$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $04de90e46e565a98$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$6a32dc741d9d6083$var$isValidProtocol(protocol)) {
        (0, $04de90e46e565a98$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $04de90e46e565a98$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $6a32dc741d9d6083$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $6a32dc741d9d6083$export$b892860177f70a30(from) : $6a32dc741d9d6083$var$dsnFromComponents(from);
    if (!components || !$6a32dc741d9d6083$var$validateDsn(components)) return undefined;
    return components;
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $a7dd6b8d5d1f9a4e$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $a7dd6b8d5d1f9a4e$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $a7dd6b8d5d1f9a4e$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $a7dd6b8d5d1f9a4e$export$604a45d95a155e2b(envelope, types) {
    return $a7dd6b8d5d1f9a4e$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $a7dd6b8d5d1f9a4e$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $a7dd6b8d5d1f9a4e$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $a7dd6b8d5d1f9a4e$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $a7dd6b8d5d1f9a4e$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $13f5bb06d3146fad$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $a7dd6b8d5d1f9a4e$var$concatBuffers(parts);
}
function $a7dd6b8d5d1f9a4e$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $a7dd6b8d5d1f9a4e$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $a7dd6b8d5d1f9a4e$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $a7dd6b8d5d1f9a4e$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $3573f39c9e00bebb$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $a7dd6b8d5d1f9a4e$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $a7dd6b8d5d1f9a4e$export$b11169581eeaf237(type) {
    return $a7dd6b8d5d1f9a4e$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $a7dd6b8d5d1f9a4e$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $a7dd6b8d5d1f9a4e$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $6a32dc741d9d6083$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $3573f39c9e00bebb$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}


/**
 * Create envelope from Span item.
 */ function $5c3d10719a3f717c$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $6a32dc741d9d6083$export$44d472fbb931a776)(dsn);
    const items = spans.map($5c3d10719a3f717c$var$createSpanItem);
    return (0, $a7dd6b8d5d1f9a4e$export$f93f7f385160c44e)(headers, items);
}
function $5c3d10719a3f717c$var$createSpanItem(span) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        span
    ];
}


/**
 * Adds a measurement to the current active transaction.
 */ function $0e234267d37e82f3$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $fa42f5cc1383fe7d$export$a7feb32fdd923295)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}


/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $b019d6bec233af0f$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $b019d6bec233af0f$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $b019d6bec233af0f$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $b019d6bec233af0f$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}






/**
 * Checks if a given value is a valid measurement value.
 */ function $4e6a5fcf1a8d545e$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $4e6a5fcf1a8d545e$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}



const $e6ede07928f42191$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $e6ede07928f42191$var$msToSec(time) {
    return time / 1000;
}
function $e6ede07928f42191$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $574af554ec58c6c0$export$56d8a8a25bd48b81) && (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).addEventListener && (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).performance;
}
let $e6ede07928f42191$var$_performanceCursor = 0;
let $e6ede07928f42191$var$_measurements = {};
let $e6ede07928f42191$var$_lcpEntry;
let $e6ede07928f42191$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $e6ede07928f42191$export$7c69f0412d101b88() {
    const performance = $e6ede07928f42191$var$getBrowserPerformanceAPI();
    if (performance && (0, $7f221ab95ceb1d0f$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCallback = $e6ede07928f42191$var$_trackFID();
        const clsCallback = $e6ede07928f42191$var$_trackCLS();
        const lcpCallback = $e6ede07928f42191$var$_trackLCP();
        const ttfbCallback = $e6ede07928f42191$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $e6ede07928f42191$export$f396d19077034ad2() {
    (0, $f711f072777a2234$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $fa42f5cc1383fe7d$export$a7feb32fdd923295)();
            if (!transaction) return;
            const startTime = $e6ede07928f42191$var$msToSec((0, $7f221ab95ceb1d0f$export$baf075a948ffc0bf) + entry.startTime);
            const duration = $e6ede07928f42191$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $e6ede07928f42191$export$e27543e0976315e4() {
    (0, $f711f072777a2234$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $fa42f5cc1383fe7d$export$a7feb32fdd923295)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $e6ede07928f42191$var$msToSec((0, $7f221ab95ceb1d0f$export$baf075a948ffc0bf) + entry.startTime);
                const duration = $e6ede07928f42191$var$msToSec(entry.duration);
                const span = {
                    description: (0, $6e7a6d8500b7a471$export$5647df6b7814ac86)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $6e7a6d8500b7a471$export$26727cfcc4d7e0fc)(entry.target);
                if (componentName) span.attributes = {
                    "ui.component_name": componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $e6ede07928f42191$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $e6ede07928f42191$var$getBrowserPerformanceAPI();
    if (performance && (0, $7f221ab95ceb1d0f$export$baf075a948ffc0bf)) {
        const inpCallback = $e6ede07928f42191$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $e6ede07928f42191$var$_trackCLS() {
    return (0, $f711f072777a2234$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Measurements] Adding CLS");
        $e6ede07928f42191$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $e6ede07928f42191$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $e6ede07928f42191$var$_trackLCP() {
    return (0, $f711f072777a2234$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Measurements] Adding LCP");
        $e6ede07928f42191$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $e6ede07928f42191$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $e6ede07928f42191$var$_trackFID() {
    return (0, $f711f072777a2234$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $e6ede07928f42191$var$msToSec((0, $7f221ab95ceb1d0f$export$baf075a948ffc0bf));
        const startTime = $e6ede07928f42191$var$msToSec(entry.startTime);
        (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Measurements] Adding FID");
        $e6ede07928f42191$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $e6ede07928f42191$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $e6ede07928f42191$var$_trackTtfb() {
    return (0, $f711f072777a2234$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Measurements] Adding TTFB");
        $e6ede07928f42191$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
const $e6ede07928f42191$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $e6ede07928f42191$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $f711f072777a2234$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $e6ede07928f42191$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
        if (!entry || !client) return;
        const interactionType = $e6ede07928f42191$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $e6ede07928f42191$var$msToSec((0, $7f221ab95ceb1d0f$export$baf075a948ffc0bf) + entry.startTime);
        const duration = $e6ede07928f42191$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $4adcf809c0f00acf$export$5f1714a13ed34c01)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $6e7a6d8500b7a471$export$5647df6b7814ac86)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== "" ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: "millisecond"
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $e6ede07928f42191$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $5c3d10719a3f717c$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).error("Error while sending interaction:", reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $e6ede07928f42191$export$5f8fa6b3467a7443(transaction) {
    const performance = $e6ede07928f42191$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $574af554ec58c6c0$export$56d8a8a25bd48b81).performance.getEntries || !(0, $7f221ab95ceb1d0f$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $e6ede07928f42191$var$msToSec((0, $7f221ab95ceb1d0f$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $4a255e6465f9994f$export$92d8c23565496537)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($e6ede07928f42191$var$_performanceCursor).forEach((entry)=>{
        const startTime = $e6ede07928f42191$var$msToSec(entry.startTime);
        const duration = $e6ede07928f42191$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $e6ede07928f42191$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $e6ede07928f42191$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $3faddefc86569283$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Measurements] Adding FP");
                        $e6ede07928f42191$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Measurements] Adding FCP");
                        $e6ede07928f42191$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $e6ede07928f42191$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $e6ede07928f42191$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $e6ede07928f42191$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $e6ede07928f42191$var$_addTtfbRequestTimeToMeasurements($e6ede07928f42191$var$_measurements);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$e6ede07928f42191$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $e6ede07928f42191$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $e6ede07928f42191$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $e6ede07928f42191$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $e6ede07928f42191$var$_measurements["mark.fid"];
        if (fidMark && $e6ede07928f42191$var$_measurements["fid"]) {
            // create span for FID
            (0, $4e6a5fcf1a8d545e$export$8bd469e1f37aa721)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $e6ede07928f42191$var$msToSec($e6ede07928f42191$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $e6ede07928f42191$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $e6ede07928f42191$var$_measurements)) delete $e6ede07928f42191$var$_measurements.cls;
        Object.keys($e6ede07928f42191$var$_measurements).forEach((measurementName)=>{
            (0, $0e234267d37e82f3$export$7cc31b475d33a706)(measurementName, $e6ede07928f42191$var$_measurements[measurementName].value, $e6ede07928f42191$var$_measurements[measurementName].unit);
        });
        $e6ede07928f42191$var$_tagMetricInfo(transaction);
    }
    $e6ede07928f42191$var$_lcpEntry = undefined;
    $e6ede07928f42191$var$_clsEntry = undefined;
    $e6ede07928f42191$var$_measurements = {};
}
/** Create measure related spans */ function $e6ede07928f42191$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $4e6a5fcf1a8d545e$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e6ede07928f42191$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $e6ede07928f42191$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $e6ede07928f42191$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $e6ede07928f42191$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $e6ede07928f42191$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $e6ede07928f42191$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $e6ede07928f42191$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $4e6a5fcf1a8d545e$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $e6ede07928f42191$var$msToSec(start),
        endTimestamp: timeOrigin + $e6ede07928f42191$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e6ede07928f42191$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $4e6a5fcf1a8d545e$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + $e6ede07928f42191$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $e6ede07928f42191$var$msToSec(entry.responseEnd)
        });
        (0, $4e6a5fcf1a8d545e$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + $e6ede07928f42191$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $e6ede07928f42191$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $e6ede07928f42191$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $b019d6bec233af0f$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $e6ede07928f42191$var$setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    $e6ede07928f42191$var$setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    $e6ede07928f42191$var$setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data["server.address"] = parsedUrl.host;
    data["url.same_origin"] = resourceUrl.includes((0, $574af554ec58c6c0$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $4e6a5fcf1a8d545e$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $574af554ec58c6c0$export$56d8a8a25bd48b81).location.origin, ""),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $e6ede07928f42191$var$_trackNavigator(transaction) {
    const navigator = (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("connectionType", connection.type);
        if ((0, $4e6a5fcf1a8d545e$export$27169ccae1b439e3)(connection.rtt)) $e6ede07928f42191$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $4e6a5fcf1a8d545e$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $4e6a5fcf1a8d545e$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $e6ede07928f42191$var$_tagMetricInfo(transaction) {
    if ($e6ede07928f42191$var$_lcpEntry) {
        (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($e6ede07928f42191$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.element", (0, $6e7a6d8500b7a471$export$5647df6b7814ac86)($e6ede07928f42191$var$_lcpEntry.element));
        if ($e6ede07928f42191$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.id", $e6ede07928f42191$var$_lcpEntry.id);
        if ($e6ede07928f42191$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.url", $e6ede07928f42191$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", $e6ede07928f42191$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($e6ede07928f42191$var$_clsEntry && $e6ede07928f42191$var$_clsEntry.sources) {
        (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Measurements] Adding CLS Data");
        $e6ede07928f42191$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $6e7a6d8500b7a471$export$5647df6b7814ac86)(source.node)));
    }
}
function $e6ede07928f42191$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $e6ede07928f42191$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $e6ede07928f42191$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $4bf61cab9b67433f$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Measurements] Adding TTFB Request Time");
        _measurements["ttfb.requestTime"] = {
            value: responseStart - requestStart,
            unit: "millisecond"
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $e6ede07928f42191$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $659a02a25d0877fc$export$5008da00b1b6dee6)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === "function") sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $7b93f520cfc3d78b$export$2603c8d332a51c42)(sampleRate)) {
        (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("[Tracing] Discarding interaction span because of invalid sample rate.");
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}







// eslint-disable-next-line deprecation/deprecation
const $c16ac02288bf2a10$var$WINDOW = (0, $e12526d3482a2b29$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $c16ac02288bf2a10$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $c16ac02288bf2a10$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $c16ac02288bf2a10$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $c16ac02288bf2a10$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $c16ac02288bf2a10$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $c16ac02288bf2a10$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $c16ac02288bf2a10$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$c16ac02288bf2a10$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($c16ac02288bf2a10$export$18cf36ed71d733e7($c16ac02288bf2a10$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $c16ac02288bf2a10$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $c16ac02288bf2a10$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $91044c9f4e912660$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $c16ac02288bf2a10$export$531055a6c684a70a() {
    return "ReportingObserver" in $c16ac02288bf2a10$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $c16ac02288bf2a10$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$c16ac02288bf2a10$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}




/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $0ebf475f67650c89$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $550d0e553f060ebd$export$a4e09611e30da72e)(type, handler);
    (0, $550d0e553f060ebd$export$e18d6c5462c01368)(type, $0ebf475f67650c89$var$instrumentFetch);
}
function $0ebf475f67650c89$var$instrumentFetch() {
    if (!(0, $c16ac02288bf2a10$export$c82d238e23c40b21)()) return;
    (0, $3573f39c9e00bebb$export$9563e054e6f787fb)((0, $e12526d3482a2b29$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $0ebf475f67650c89$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $550d0e553f060ebd$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $e12526d3482a2b29$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $550d0e553f060ebd$export$b18c893e424d3127)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $550d0e553f060ebd$export$b18c893e424d3127)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $0ebf475f67650c89$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $0ebf475f67650c89$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($0ebf475f67650c89$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $0ebf475f67650c89$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $0ebf475f67650c89$var$getUrlFromResource(url),
            method: $0ebf475f67650c89$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $0ebf475f67650c89$var$getUrlFromResource(arg),
        method: $0ebf475f67650c89$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}





const $1d16459f93df57a1$var$WINDOW = (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1);
const $1d16459f93df57a1$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $1d16459f93df57a1$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $550d0e553f060ebd$export$a4e09611e30da72e)(type, handler);
    (0, $550d0e553f060ebd$export$e18d6c5462c01368)(type, $1d16459f93df57a1$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $1d16459f93df57a1$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$1d16459f93df57a1$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $3573f39c9e00bebb$export$9563e054e6f787fb)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $0bdf548a001e670c$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $1d16459f93df57a1$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$1d16459f93df57a1$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$1d16459f93df57a1$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $550d0e553f060ebd$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $3573f39c9e00bebb$export$9563e054e6f787fb)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $3573f39c9e00bebb$export$9563e054e6f787fb)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$1d16459f93df57a1$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $0bdf548a001e670c$export$844ec244b1367d54)(header) && (0, $0bdf548a001e670c$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $3573f39c9e00bebb$export$9563e054e6f787fb)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$1d16459f93df57a1$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $550d0e553f060ebd$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $1d16459f93df57a1$var$parseUrl(url) {
    if ((0, $0bdf548a001e670c$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}




/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $c1763ea31130944e$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!(0, $659a02a25d0877fc$export$5008da00b1b6dee6)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $c1763ea31130944e$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $15458dde2c60d92b$export$c7be4b0125a10cba)();
    const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $c1763ea31130944e$var$getFullURL(url);
    const host = fullUrl ? (0, $b019d6bec233af0f$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $7bc0a43bc95a30e2$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host,
            [(0, $2a38ddd8bc83e514$export$cca8dd30f57f805e)]: spanOrigin
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $c1763ea31130944e$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $c1763ea31130944e$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $6ea9c05e188f19de$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $4a255e6465f9994f$export$7e9f8ae9e4a328ab)(span) : (0, $ab87fd75b55e34cf$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $edf3a25c0187af20$export$56766feef403f365)(dsc || (span ? (0, $0b16142076d4c1de$export$a117f995597e25df)(span) : (0, $0b16142076d4c1de$export$366bad00d6815eed)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== "undefined" && (0, $0bdf548a001e670c$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $0bdf548a001e670c$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $edf3a25c0187af20$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $edf3a25c0187af20$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
function $c1763ea31130944e$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $c1763ea31130944e$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $8a177456b38bb278$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus("internal_error");
    span.end();
}




/* eslint-disable max-lines */ const $9cccddd084514f9b$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $9cccddd084514f9b$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $9cccddd084514f9b$export$15bd0305d05ad07b,
    tracePropagationTargets: $9cccddd084514f9b$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $9cccddd084514f9b$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $9cccddd084514f9b$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $9cccddd084514f9b$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$9cccddd084514f9b$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $0ebf475f67650c89$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $c1763ea31130944e$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $9cccddd084514f9b$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $b019d6bec233af0f$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                "http.url": fullUrl,
                "server.address": host
            });
        }
        if (enableHTTPTimings && createdSpan) $9cccddd084514f9b$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $1d16459f93df57a1$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $9cccddd084514f9b$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $9cccddd084514f9b$var$addHTTPTimings(createdSpan);
    });
}
function $9cccddd084514f9b$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $9cccddd084514f9b$var$addHTTPTimings(span) {
    const { url: url } = (0, $4a255e6465f9994f$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $f711f072777a2234$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($9cccddd084514f9b$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $9cccddd084514f9b$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $9cccddd084514f9b$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $9cccddd084514f9b$var$getAbsoluteTime(time = 0) {
    return (((0, $7f221ab95ceb1d0f$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $9cccddd084514f9b$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $9cccddd084514f9b$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $7f221ab95ceb1d0f$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $9cccddd084514f9b$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $9cccddd084514f9b$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $9cccddd084514f9b$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $9cccddd084514f9b$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $9cccddd084514f9b$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $9cccddd084514f9b$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $9cccddd084514f9b$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $9cccddd084514f9b$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $9cccddd084514f9b$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $9cccddd084514f9b$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $9cccddd084514f9b$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $f28175ac6747d0c5$export$a7a5ec66062ea5d)(url, tracePropagationTargets || $9cccddd084514f9b$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $9cccddd084514f9b$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $1d16459f93df57a1$export$55b6bb1e45c6cf59];
    if (!(0, $659a02a25d0877fc$export$5008da00b1b6dee6)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $8a177456b38bb278$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $15458dde2c60d92b$export$c7be4b0125a10cba)();
    const isolationScope = (0, $6ea9c05e188f19de$export$68f3af03034c9e90)();
    const fullUrl = $9cccddd084514f9b$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $b019d6bec233af0f$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $7bc0a43bc95a30e2$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host,
            [(0, $2a38ddd8bc83e514$export$cca8dd30f57f805e)]: "auto.http.browser"
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $4a255e6465f9994f$export$7e9f8ae9e4a328ab)(span) : (0, $ab87fd75b55e34cf$export$f35d907436da45cf)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $edf3a25c0187af20$export$56766feef403f365)(dsc || (span ? (0, $0b16142076d4c1de$export$a117f995597e25df)(span) : (0, $0b16142076d4c1de$export$366bad00d6815eed)(traceId, client, scope)));
        $9cccddd084514f9b$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $9cccddd084514f9b$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $edf3a25c0187af20$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $9cccddd084514f9b$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}



const $25167119000bf015$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $25167119000bf015$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $645dec74aac904d7$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $9cccddd084514f9b$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $25167119000bf015$export$b4109253475213e9 = (_options = {})=>{
    const _hasSetTracePropagationTargets = (0, $453e81e4c2a52375$export$16a28057038b10ef) ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0, $d1d9031d0117d401$export$653d0ef2bad9cdf9)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
    const options = {
        ...$25167119000bf015$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $e6ede07928f42191$export$7c69f0412d101b88)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ const interactionIdToRouteNameMapping = {};
    if (options.enableInp) (0, $e6ede07928f42191$export$f17d06681a4744a3)(interactionIdToRouteNameMapping, options.interactionsSampleRate);
    if (options.enableLongTask) (0, $e6ede07928f42191$export$f396d19077034ad2)();
    if (options._experiments.enableInteractions) (0, $e6ede07928f42191$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        context: undefined
    };
    /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)();
        const { beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $25167119000bf015$export$f147b32b03c9cf11("sentry-trace") : "";
            const baggage = isPageloadTransaction ? $25167119000bf015$export$f147b32b03c9cf11("baggage") : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $ab87fd75b55e34cf$export$261f383d16a93e39)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $574af554ec58c6c0$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $d1d9031d0117d401$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document) {
            (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                "interactive",
                "complete"
            ].includes((0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            _collectWebVitals();
            (0, $e6ede07928f42191$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    return {
        name: $25167119000bf015$export$bbd2089f30bd3708,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: ()=>{},
        afterAllSetup (client) {
            const clientOptions = client.getOptions();
            const { markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = options;
            const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if ((0, $453e81e4c2a52375$export$16a28057038b10ef) && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
            let activeSpan;
            let startingUrl = (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).location && (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).location.href;
            if (client.on) {
                client.on("startNavigationSpan", (context)=>{
                    if (activeSpan) {
                        (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $4a255e6465f9994f$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "navigation",
                        ...context
                    });
                });
                client.on("startPageLoadSpan", (context)=>{
                    if (activeSpan) {
                        (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $4a255e6465f9994f$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "pageload",
                        ...context
                    });
                });
            }
            if (options.instrumentPageLoad && client.emit && (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).location) {
                const context = {
                    name: (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: (0, $7f221ab95ceb1d0f$export$baf075a948ffc0bf) ? (0, $7f221ab95ceb1d0f$export$baf075a948ffc0bf) / 1000 : undefined,
                    origin: "auto.pageload.browser",
                    attributes: {
                        [(0, $2a38ddd8bc83e514$export$d7a7d984b0791405)]: "url"
                    }
                };
                $25167119000bf015$export$aa44a07f82af519f(client, context);
            }
            if (options.instrumentNavigation && client.emit && (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).location) (0, $25558ab1f79d7e77$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    const context = {
                        name: (0, $574af554ec58c6c0$export$56d8a8a25bd48b81).location.pathname,
                        origin: "auto.navigation.browser",
                        attributes: {
                            [(0, $2a38ddd8bc83e514$export$d7a7d984b0791405)]: "url"
                        }
                    };
                    $25167119000bf015$export$7d159749bd9969ad(client, context);
                }
            });
            if (markBackgroundSpan) (0, $4762b7f3056b9823$export$6f18f55521af71a1)();
            if (_experiments.enableInteractions) $25167119000bf015$var$registerInteractionListener(options, latestRoute);
            if (options.enableInp) $25167119000bf015$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
            (0, $9cccddd084514f9b$export$864489cb3478db3e)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        options: // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $25167119000bf015$export$aa44a07f82af519f(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startPageLoadSpan", spanOptions);
    const span = (0, $7bc0a43bc95a30e2$export$1be426a8e585c83e)();
    const op = span && (0, $4a255e6465f9994f$export$92d8c23565496537)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $25167119000bf015$export$7d159749bd9969ad(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startNavigationSpan", spanOptions);
    const span = (0, $7bc0a43bc95a30e2$export$1be426a8e585c83e)();
    const op = span && (0, $4a255e6465f9994f$export$92d8c23565496537)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function $25167119000bf015$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $6e7a6d8500b7a471$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function $25167119000bf015$var$registerInteractionListener(options, latestRoute) {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = ()=>{
        const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const op = "ui.action.click";
        // eslint-disable-next-line deprecation/deprecation
        const currentTransaction = (0, $fa42f5cc1383fe7d$export$a7feb32fdd923295)();
        if (currentTransaction && currentTransaction.op && [
            "navigation",
            "pageload"
        ].includes(currentTransaction.op)) {
            (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason("interactionInterrupted");
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            (0, $453e81e4c2a52375$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        const { location: location } = (0, $574af554ec58c6c0$export$56d8a8a25bd48b81);
        const context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: {
                [(0, $2a38ddd8bc83e514$export$d7a7d984b0791405)]: latestRoute.context ? $25167119000bf015$var$getSource(latestRoute.context) : "url"
            }
        };
        inflightInteractionTransaction = (0, $d1d9031d0117d401$export$479dbd817e392a4f)(// eslint-disable-next-line deprecation/deprecation
        (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        "click"
    ].forEach((type)=>{
        if ((0, $574af554ec58c6c0$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
            once: false,
            capture: true
        });
    });
}
function $25167119000bf015$var$isPerformanceEventTiming(entry) {
    return "duration" in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $25167119000bf015$var$MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function $25167119000bf015$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
        const replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $fa42f5cc1383fe7d$export$a7feb32fdd923295)();
        const currentScope = (0, $15458dde2c60d92b$export$c7be4b0125a10cba)();
        const user = currentScope !== undefined ? currentScope.getUser() : undefined;
        entries.forEach((entry)=>{
            if ($25167119000bf015$var$isPerformanceEventTiming(entry)) {
                const interactionId = entry.interactionId;
                if (interactionId === undefined) return;
                const existingInteraction = interactionIdToRouteNameMapping[interactionId];
                const duration = entry.duration;
                const startTime = entry.startTime;
                const keys = Object.keys(interactionIdToRouteNameMapping);
                const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                    return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration ? a : b;
                }) : undefined;
                // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                // This is also checked in the web-vitals library.
                if (entry.entryType === "first-input") {
                    const matchingEntry = keys.map((key)=>interactionIdToRouteNameMapping[key]).some((interaction)=>{
                        return interaction.duration === duration && interaction.startTime === startTime;
                    });
                    if (matchingEntry) return;
                }
                // Interactions with an id of 0 and are not first-input are not valid.
                if (!interactionId) return;
                // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                else if (keys.length < $25167119000bf015$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > interactionIdToRouteNameMapping[minInteractionId].duration) {
                    // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                    const routeName = latestRoute.name;
                    const parentContext = latestRoute.context;
                    if (routeName && parentContext) {
                        if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= $25167119000bf015$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                        delete interactionIdToRouteNameMapping[minInteractionId];
                        interactionIdToRouteNameMapping[interactionId] = {
                            routeName: routeName,
                            duration: duration,
                            parentContext: parentContext,
                            user: user,
                            activeTransaction: activeTransaction,
                            replayId: replayId,
                            startTime: startTime
                        };
                    }
                }
            }
        });
    };
    (0, $f711f072777a2234$export$69816c1a049f8db6)("event", handleEntries);
    (0, $f711f072777a2234$export$69816c1a049f8db6)("first-input", handleEntries);
}
function $25167119000bf015$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $2a38ddd8bc83e514$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $2a38ddd8bc83e514$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}






const $2384715dee2beb9a$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $2384715dee2beb9a$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $2384715dee2beb9a$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $3801c6184ad1b674$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $2384715dee2beb9a$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $2384715dee2beb9a$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $2384715dee2beb9a$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $2384715dee2beb9a$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $2384715dee2beb9a$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $2384715dee2beb9a$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($2384715dee2beb9a$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $5dce13d6e1d08926$export$8e4e25f54d456511), (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c));
        $2384715dee2beb9a$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $2384715dee2beb9a$export$2d8f5188773bcddd(integration) {
    const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
    if (!client || !client.addIntegration) {
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $2384715dee2beb9a$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $2384715dee2beb9a$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $2384715dee2beb9a$export$2323046b9414659f(fn) {
    return fn;
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $1195f16bf4ea7400$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


const $24ab5428e3ae71ca$var$INTEGRATION_NAME = "ExtraErrorData";
const $24ab5428e3ae71ca$var$_extraErrorDataIntegration = (options = {})=>{
    const depth = options.depth || 3;
    // TODO(v8): Flip the default for this option to true
    const captureErrorCause = options.captureErrorCause || false;
    return {
        name: $24ab5428e3ae71ca$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, hint) {
            return $24ab5428e3ae71ca$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause);
        }
    };
};
const $24ab5428e3ae71ca$export$6e0872131894301d = (0, $2384715dee2beb9a$export$2323046b9414659f)($24ab5428e3ae71ca$var$_extraErrorDataIntegration);
/**
 * Extract additional data for from original exceptions.
 * @deprecated Use `extraErrorDataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $24ab5428e3ae71ca$export$56d961ef3a52a072 = (0, $2384715dee2beb9a$export$afa219bf23651160)($24ab5428e3ae71ca$var$INTEGRATION_NAME, $24ab5428e3ae71ca$export$6e0872131894301d);
function $24ab5428e3ae71ca$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause) {
    if (!hint.originalException || !(0, $0bdf548a001e670c$export$e6127cc7fe7395c3)(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $24ab5428e3ae71ca$var$_extractErrorData(hint.originalException, captureErrorCause);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = (0, $13f5bb06d3146fad$export$a3295358bff77e)(errorData, depth);
        if ((0, $0bdf548a001e670c$export$53b83ca8eaab0383)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, $3573f39c9e00bebb$export$e73679ffaf56810e)(normalizedErrorData, "__sentry_skip_normalization__", true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function $24ab5428e3ae71ca$var$_extractErrorData(error, captureErrorCause) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            "name",
            "message",
            "stack",
            "line",
            "column",
            "fileName",
            "lineNumber",
            "columnNumber",
            "toJSON"
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = (0, $0bdf548a001e670c$export$e6127cc7fe7395c3)(value) ? value.toString() : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) extraErrorInfo.cause = (0, $0bdf548a001e670c$export$e6127cc7fe7395c3)(error.cause) ? error.cause.toString() : error.cause;
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === "function") {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = (0, $0bdf548a001e670c$export$e6127cc7fe7395c3)(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, $1195f16bf4ea7400$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).error("Unable to extract extra data from the Error object:", oO);
    }
    return null;
}




let $7e387b2dcd612739$var$originalFunctionToString;
const $7e387b2dcd612739$var$INTEGRATION_NAME = "FunctionToString";
const $7e387b2dcd612739$var$SETUP_CLIENTS = new WeakMap();
const $7e387b2dcd612739$var$_functionToStringIntegration = ()=>{
    return {
        name: $7e387b2dcd612739$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $7e387b2dcd612739$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $3573f39c9e00bebb$export$e6cc1e135e2092e5)(this);
                    const context = $7e387b2dcd612739$var$SETUP_CLIENTS.has((0, $15458dde2c60d92b$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $7e387b2dcd612739$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $7e387b2dcd612739$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $7e387b2dcd612739$export$7918117e9202e4fb = (0, $2384715dee2beb9a$export$2323046b9414659f)($7e387b2dcd612739$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $7e387b2dcd612739$export$da4704525c20ae79 = (0, $2384715dee2beb9a$export$afa219bf23651160)($7e387b2dcd612739$var$INTEGRATION_NAME, $7e387b2dcd612739$export$7918117e9202e4fb);


const $a9dbe3993bfc02ed$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $a9dbe3993bfc02ed$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $a9dbe3993bfc02ed$var$_getIngestEndpoint(dsn) {
    return `${$a9dbe3993bfc02ed$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $a9dbe3993bfc02ed$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $3573f39c9e00bebb$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $a9dbe3993bfc02ed$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $a9dbe3993bfc02ed$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$a9dbe3993bfc02ed$var$_getIngestEndpoint(dsn)}?${$a9dbe3993bfc02ed$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $a9dbe3993bfc02ed$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $6a32dc741d9d6083$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$a9dbe3993bfc02ed$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $6a32dc741d9d6083$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $3959a590b2f43389$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $3959a590b2f43389$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $3959a590b2f43389$var$INTEGRATION_NAME = "InboundFilters";
const $3959a590b2f43389$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $3959a590b2f43389$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $3959a590b2f43389$var$_mergeOptions(options, clientOptions);
            return $3959a590b2f43389$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $3959a590b2f43389$export$cb3c5c2ceb9818ba = (0, $2384715dee2beb9a$export$2323046b9414659f)($3959a590b2f43389$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $3959a590b2f43389$export$2ffbb5359dcc6be4 = (0, $2384715dee2beb9a$export$afa219bf23651160)($3959a590b2f43389$var$INTEGRATION_NAME, $3959a590b2f43389$export$cb3c5c2ceb9818ba);
function $3959a590b2f43389$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $3959a590b2f43389$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $3959a590b2f43389$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $3959a590b2f43389$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $3959a590b2f43389$var$_isSentryError(event)) {
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $3801c6184ad1b674$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($3959a590b2f43389$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $3801c6184ad1b674$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($3959a590b2f43389$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $3801c6184ad1b674$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($3959a590b2f43389$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $3801c6184ad1b674$export$4157119e2b157127)(event)}.\nUrl: ${$3959a590b2f43389$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$3959a590b2f43389$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $3801c6184ad1b674$export$4157119e2b157127)(event)}.\nUrl: ${$3959a590b2f43389$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $3959a590b2f43389$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $3959a590b2f43389$var$_getPossibleEventMessages(event).some((message)=>(0, $f28175ac6747d0c5$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $3959a590b2f43389$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $f28175ac6747d0c5$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $3959a590b2f43389$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $3959a590b2f43389$var$_getEventFilterUrl(event);
    return !url ? false : (0, $f28175ac6747d0c5$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $3959a590b2f43389$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $3959a590b2f43389$var$_getEventFilterUrl(event);
    return !url ? true : (0, $f28175ac6747d0c5$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $3959a590b2f43389$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $6e88aab9796f5acd$export$16a28057038b10ef) && possibleMessages.length === 0) (0, $04de90e46e565a98$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $3801c6184ad1b674$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $3959a590b2f43389$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $3959a590b2f43389$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $3959a590b2f43389$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $3959a590b2f43389$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $3801c6184ad1b674$export$4157119e2b157127)(event)}`);
        return null;
    }
}





/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $0583f127bf5c708b$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $6e88aab9796f5acd$export$16a28057038b10ef) (0, $04de90e46e565a98$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $04de90e46e565a98$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $15458dde2c60d92b$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $0583f127bf5c708b$export$ecb76f41d43c0e43(client);
    $0583f127bf5c708b$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $0583f127bf5c708b$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $0583f127bf5c708b$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}




/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $f11ab1e7429c35a4$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $05d6e4b55befa410$export$31499a9cd224b78c)
            })),
        version: (0, $05d6e4b55befa410$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}

/** An error emitted by Sentry SDKs and related utilities. */ class $2986c2df799d59ae$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $726ad0dc70107da0$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $726ad0dc70107da0$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $a7dd6b8d5d1f9a4e$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $6a32dc741d9d6083$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $a7dd6b8d5d1f9a4e$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $726ad0dc70107da0$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $a7dd6b8d5d1f9a4e$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $726ad0dc70107da0$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $a7dd6b8d5d1f9a4e$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $a7dd6b8d5d1f9a4e$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}







/**
 * Generate bucket key from metric properties.
 */ function $40688e7ba64a6b32$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $3573f39c9e00bebb$export$d25f2688db1bb433)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $40688e7ba64a6b32$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $40688e7ba64a6b32$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $40688e7ba64a6b32$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, "_");
}
/** Sanitizes metric keys */ function $40688e7ba64a6b32$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, "_");
}
function $40688e7ba64a6b32$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, "");
}
const $40688e7ba64a6b32$var$tagValueReplacements = [
    [
        "\n",
        "\\n"
    ],
    [
        "\r",
        "\\r"
    ],
    [
        "	",
        "\\t"
    ],
    [
        "\\",
        "\\\\"
    ],
    [
        "|",
        "\\u{7c}"
    ],
    [
        ",",
        "\\u{2c}"
    ]
];
function $40688e7ba64a6b32$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $40688e7ba64a6b32$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $40688e7ba64a6b32$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $40688e7ba64a6b32$var$getCharOrReplacement(char), "");
}
/**
 * Sanitizes tags.
 */ function $40688e7ba64a6b32$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $40688e7ba64a6b32$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $40688e7ba64a6b32$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $da25c5de3f4d6935$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $6a32dc741d9d6083$export$44d472fbb931a776)(dsn);
    const item = $da25c5de3f4d6935$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $a7dd6b8d5d1f9a4e$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $da25c5de3f4d6935$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $40688e7ba64a6b32$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}





const $2de82d876e342b72$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $2de82d876e342b72$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $6a32dc741d9d6083$export$128827c3562ec0cb)(options.dsn);
        else (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $a9dbe3993bfc02ed$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $3801c6184ad1b674$export$6de4ffac6a2f1098)(exception)) {
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log($2de82d876e342b72$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $0bdf548a001e670c$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $0bdf548a001e670c$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $3801c6184ad1b674$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log($2de82d876e342b72$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $6634c575d393290e$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $c7ebba5fa2c683f8$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $2384715dee2beb9a$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $2384715dee2beb9a$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $726ad0dc70107da0$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $a7dd6b8d5d1f9a4e$export$d650323442802f6f)(env, (0, $a7dd6b8d5d1f9a4e$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $726ad0dc70107da0$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $da25c5de3f4d6935$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $2384715dee2beb9a$export$51abed9797baa598)(this, integrations);
        (0, $2384715dee2beb9a$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $6634c575d393290e$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $c7ebba5fa2c683f8$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $6ea9c05e188f19de$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $e0529c7e0a1e5be4$export$2d67fb380bd11267)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $0b16142076d4c1de$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $6e88aab9796f5acd$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $04de90e46e565a98$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $2de82d876e342b72$var$isTransactionEvent(event);
        const isError = $2de82d876e342b72$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $c7ebba5fa2c683f8$export$78e43115b553f358)(new (0, $2986c2df799d59ae$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $2986c2df799d59ae$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $2de82d876e342b72$var$processBeforeSend(options, prepared, hint);
            return $2de82d876e342b72$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $2986c2df799d59ae$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $2986c2df799d59ae$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $2986c2df799d59ae$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).error("Error while sending event:", reason);
        });
        else (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $2de82d876e342b72$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $0bdf548a001e670c$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $0bdf548a001e670c$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $2986c2df799d59ae$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $2986c2df799d59ae$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $0bdf548a001e670c$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $2986c2df799d59ae$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $2de82d876e342b72$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($2de82d876e342b72$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($2de82d876e342b72$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $2de82d876e342b72$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $2de82d876e342b72$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $2de82d876e342b72$export$9aac0b9f77928fbf(callback) {
    const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $2bfd0d9d4e63b3c3$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $7f221ab95ceb1d0f$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $a7dd6b8d5d1f9a4e$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $j1fad = parcelRequire("j1fad");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $d725d2219f7bf80e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;




/**
 * This function creates an exception from a JavaScript Error
 */ function $d71d509404cc9123$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $d71d509404cc9123$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $d71d509404cc9123$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $d71d509404cc9123$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $0bdf548a001e670c$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $d71d509404cc9123$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $13f5bb06d3146fad$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $d71d509404cc9123$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $d71d509404cc9123$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $d71d509404cc9123$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $d71d509404cc9123$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $d71d509404cc9123$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $d71d509404cc9123$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $d71d509404cc9123$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($d71d509404cc9123$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $d71d509404cc9123$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $d71d509404cc9123$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $d71d509404cc9123$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $3801c6184ad1b674$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $c7ebba5fa2c683f8$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $d71d509404cc9123$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $d71d509404cc9123$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $c7ebba5fa2c683f8$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $d71d509404cc9123$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $0bdf548a001e670c$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $d71d509404cc9123$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $0bdf548a001e670c$export$ef9e2056653f0c8e)(exception) || (0, $0bdf548a001e670c$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $d71d509404cc9123$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $0bdf548a001e670c$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $d71d509404cc9123$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $3801c6184ad1b674$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $0bdf548a001e670c$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $d71d509404cc9123$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $0bdf548a001e670c$export$53b83ca8eaab0383)(exception) || (0, $0bdf548a001e670c$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $d71d509404cc9123$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $3801c6184ad1b674$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $d71d509404cc9123$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $3801c6184ad1b674$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $3801c6184ad1b674$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $d71d509404cc9123$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $d71d509404cc9123$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $0bdf548a001e670c$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $d71d509404cc9123$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $3573f39c9e00bebb$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $0bdf548a001e670c$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $0bdf548a001e670c$export$9671ea99bd126ace)(exception)) {
        const className = $d71d509404cc9123$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $d71d509404cc9123$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}





const $e56212619ce00c0e$export$56d8a8a25bd48b81 = (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1);
let $e56212619ce00c0e$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $e56212619ce00c0e$export$b79738ab10c590b2() {
    return $e56212619ce00c0e$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $e56212619ce00c0e$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $e56212619ce00c0e$var$ignoreOnError++;
    setTimeout(()=>{
        $e56212619ce00c0e$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $e56212619ce00c0e$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $3573f39c9e00bebb$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$e56212619ce00c0e$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $e56212619ce00c0e$export$1265a142ff5ba165();
            (0, $15458dde2c60d92b$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $3801c6184ad1b674$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $3801c6184ad1b674$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $15458dde2c60d92b$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $3573f39c9e00bebb$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $3573f39c9e00bebb$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $c0d4eede4fb63d9f$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $6a32dc741d9d6083$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $c0d4eede4fb63d9f$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $a7dd6b8d5d1f9a4e$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $c0d4eede4fb63d9f$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $3875374f67599049$export$1df9218a526d318d extends (0, $2de82d876e342b72$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $j1fad.getSDKSource)();
        (0, $f11ab1e7429c35a4$export$b9f95b027256052c)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).document) (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $e56212619ce00c0e$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $d71d509404cc9123$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $d71d509404cc9123$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $d725d2219f7bf80e$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $c0d4eede4fb63d9f$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $d725d2219f7bf80e$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $d725d2219f7bf80e$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $d725d2219f7bf80e$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $2bfd0d9d4e63b3c3$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $6a32dc741d9d6083$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}









const $8ceebd0242a3a56c$var$WINDOW = (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1);
const $8ceebd0242a3a56c$var$DEBOUNCE_DURATION = 1000;
let $8ceebd0242a3a56c$var$debounceTimerID;
let $8ceebd0242a3a56c$var$lastCapturedEventType;
let $8ceebd0242a3a56c$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $8ceebd0242a3a56c$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $550d0e553f060ebd$export$a4e09611e30da72e)(type, handler);
    (0, $550d0e553f060ebd$export$e18d6c5462c01368)(type, $8ceebd0242a3a56c$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $8ceebd0242a3a56c$export$3014bbf0af0e1d4a() {
    if (!$8ceebd0242a3a56c$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $550d0e553f060ebd$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $8ceebd0242a3a56c$var$makeDOMEventHandler(triggerDOMHandler, true);
    $8ceebd0242a3a56c$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $8ceebd0242a3a56c$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $8ceebd0242a3a56c$var$WINDOW[target] && $8ceebd0242a3a56c$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $3573f39c9e00bebb$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $8ceebd0242a3a56c$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $3573f39c9e00bebb$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $8ceebd0242a3a56c$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $8ceebd0242a3a56c$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $8ceebd0242a3a56c$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $8ceebd0242a3a56c$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $8ceebd0242a3a56c$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $8ceebd0242a3a56c$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($8ceebd0242a3a56c$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $3573f39c9e00bebb$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $3573f39c9e00bebb$export$e73679ffaf56810e)(target, "_sentryId", (0, $3801c6184ad1b674$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$8ceebd0242a3a56c$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $8ceebd0242a3a56c$var$lastCapturedEventType = event.type;
            $8ceebd0242a3a56c$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($8ceebd0242a3a56c$var$debounceTimerID);
        $8ceebd0242a3a56c$var$debounceTimerID = $8ceebd0242a3a56c$var$WINDOW.setTimeout(()=>{
            $8ceebd0242a3a56c$var$lastCapturedEventTargetId = undefined;
            $8ceebd0242a3a56c$var$lastCapturedEventType = undefined;
        }, $8ceebd0242a3a56c$var$DEBOUNCE_DURATION);
    };
}
function $8ceebd0242a3a56c$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $13a9d2262e05730b$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $550d0e553f060ebd$export$a4e09611e30da72e)(type, handler);
    (0, $550d0e553f060ebd$export$e18d6c5462c01368)(type, $13a9d2262e05730b$var$instrumentConsole);
}
function $13a9d2262e05730b$var$instrumentConsole() {
    if (!("console" in (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1))) return;
    (0, $04de90e46e565a98$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).console)) return;
        (0, $3573f39c9e00bebb$export$9563e054e6f787fb)((0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $04de90e46e565a98$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $550d0e553f060ebd$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $04de90e46e565a98$export$77c4ce905194557b)[level];
                log && log.apply((0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $bb1126bf38246d20$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $bb1126bf38246d20$export$e01cef29b4327697(level) {
    return $bb1126bf38246d20$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $bb1126bf38246d20$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $bb1126bf38246d20$export$411d0ffdba845b6c.includes(level) ? level : "log";
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $4df35ebf0eeb9743$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $4df35ebf0eeb9743$var$INTEGRATION_NAME = "Breadcrumbs";
const $4df35ebf0eeb9743$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $4df35ebf0eeb9743$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $13a9d2262e05730b$export$1d6e0d073f9e6723)($4df35ebf0eeb9743$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $8ceebd0242a3a56c$export$5aeffd3db2cf9df7)($4df35ebf0eeb9743$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $1d16459f93df57a1$export$26ace48dd54c9aea)($4df35ebf0eeb9743$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $0ebf475f67650c89$export$f75d3c772c923df0)($4df35ebf0eeb9743$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $25558ab1f79d7e77$export$3f18c56c58114e75)($4df35ebf0eeb9743$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $4df35ebf0eeb9743$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $4df35ebf0eeb9743$export$c079d904b326663a = (0, $2384715dee2beb9a$export$2323046b9414659f)($4df35ebf0eeb9743$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $4df35ebf0eeb9743$export$2dc68d50d56fbbd = (0, $2384715dee2beb9a$export$afa219bf23651160)($4df35ebf0eeb9743$var$INTEGRATION_NAME, $4df35ebf0eeb9743$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $4df35ebf0eeb9743$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $15458dde2c60d92b$export$6bb76d6eba7e258c)() !== client) return;
        (0, $15458dde2c60d92b$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $3801c6184ad1b674$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $4df35ebf0eeb9743$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $15458dde2c60d92b$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $4df35ebf0eeb9743$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $d725d2219f7bf80e$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$4df35ebf0eeb9743$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$4df35ebf0eeb9743$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $4df35ebf0eeb9743$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $4df35ebf0eeb9743$var$_isEvent(event) ? event.target : event;
            target = (0, $6e7a6d8500b7a471$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $6e7a6d8500b7a471$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $15458dde2c60d92b$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $4df35ebf0eeb9743$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $15458dde2c60d92b$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $bb1126bf38246d20$export$d771ef054122c30a)(handlerData.level),
            message: (0, $f28175ac6747d0c5$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $f28175ac6747d0c5$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $15458dde2c60d92b$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $4df35ebf0eeb9743$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $15458dde2c60d92b$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $1d16459f93df57a1$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $15458dde2c60d92b$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $4df35ebf0eeb9743$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $15458dde2c60d92b$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $15458dde2c60d92b$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $15458dde2c60d92b$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $4df35ebf0eeb9743$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $15458dde2c60d92b$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $b019d6bec233af0f$export$7a5253c0f62e0150)((0, $e56212619ce00c0e$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $b019d6bec233af0f$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $b019d6bec233af0f$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $15458dde2c60d92b$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $4df35ebf0eeb9743$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $5ac03215a537fd75$var$INTEGRATION_NAME = "Dedupe";
const $5ac03215a537fd75$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $5ac03215a537fd75$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($5ac03215a537fd75$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $d725d2219f7bf80e$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $5ac03215a537fd75$export$6d39aa44cd0c7567 = (0, $2384715dee2beb9a$export$2323046b9414659f)($5ac03215a537fd75$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $5ac03215a537fd75$export$688d98c249d31ad3 = (0, $2384715dee2beb9a$export$afa219bf23651160)($5ac03215a537fd75$var$INTEGRATION_NAME, $5ac03215a537fd75$export$6d39aa44cd0c7567);
function $5ac03215a537fd75$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($5ac03215a537fd75$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($5ac03215a537fd75$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $5ac03215a537fd75$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$5ac03215a537fd75$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$5ac03215a537fd75$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $5ac03215a537fd75$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $5ac03215a537fd75$var$_getExceptionFromEvent(previousEvent);
    const currentException = $5ac03215a537fd75$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$5ac03215a537fd75$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$5ac03215a537fd75$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $5ac03215a537fd75$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $5ac03215a537fd75$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $5ac03215a537fd75$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $5ac03215a537fd75$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $5ac03215a537fd75$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $5ac03215a537fd75$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}







/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $1dec51759b786c1d$var$INTEGRATION_NAME = "GlobalHandlers";
const $1dec51759b786c1d$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $1dec51759b786c1d$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $1dec51759b786c1d$var$_installGlobalOnErrorHandler(client);
                $1dec51759b786c1d$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $1dec51759b786c1d$var$_installGlobalOnUnhandledRejectionHandler(client);
                $1dec51759b786c1d$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $1dec51759b786c1d$export$66acc70e8cf2b71a = (0, $2384715dee2beb9a$export$2323046b9414659f)($1dec51759b786c1d$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $1dec51759b786c1d$export$204155decbc90e5a = (0, $2384715dee2beb9a$export$afa219bf23651160)($1dec51759b786c1d$var$INTEGRATION_NAME, $1dec51759b786c1d$export$66acc70e8cf2b71a);
function $1dec51759b786c1d$var$_installGlobalOnErrorHandler(client) {
    (0, $8ab90ffae30d643c$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $1dec51759b786c1d$var$getOptions();
        if ((0, $15458dde2c60d92b$export$6bb76d6eba7e258c)() !== client || (0, $e56212619ce00c0e$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $0bdf548a001e670c$export$844ec244b1367d54)(msg) ? $1dec51759b786c1d$var$_eventFromIncompleteOnError(msg, url, line, column) : $1dec51759b786c1d$var$_enhanceEventWithInitialFrame((0, $d71d509404cc9123$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $15458dde2c60d92b$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $1dec51759b786c1d$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $04599fc7a61401dd$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $1dec51759b786c1d$var$getOptions();
        if ((0, $15458dde2c60d92b$export$6bb76d6eba7e258c)() !== client || (0, $e56212619ce00c0e$export$b79738ab10c590b2)()) return;
        const error = $1dec51759b786c1d$var$_getUnhandledRejectionError(e);
        const event = (0, $0bdf548a001e670c$export$c3825b437cbdea5c)(error) ? $1dec51759b786c1d$var$_eventFromRejectionWithPrimitive(error) : (0, $d71d509404cc9123$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $15458dde2c60d92b$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $1dec51759b786c1d$var$_getUnhandledRejectionError(error) {
    if ((0, $0bdf548a001e670c$export$c3825b437cbdea5c)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $1dec51759b786c1d$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1dec51759b786c1d$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $0bdf548a001e670c$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $1dec51759b786c1d$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1dec51759b786c1d$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $0bdf548a001e670c$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $6e7a6d8500b7a471$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $1dec51759b786c1d$var$globalHandlerLog(type) {
    (0, $d725d2219f7bf80e$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $1dec51759b786c1d$var$getOptions() {
    const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $7b88e537562e859e$var$INTEGRATION_NAME = "HttpContext";
const $7b88e537562e859e$var$_httpContextIntegration = ()=>{
    return {
        name: $7b88e537562e859e$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $e56212619ce00c0e$export$56d8a8a25bd48b81).navigator && !(0, $e56212619ce00c0e$export$56d8a8a25bd48b81).location && !(0, $e56212619ce00c0e$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).location && (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $7b88e537562e859e$export$1378794447170364 = (0, $2384715dee2beb9a$export$2323046b9414659f)($7b88e537562e859e$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $7b88e537562e859e$export$5d2ee9a544b09a94 = (0, $2384715dee2beb9a$export$afa219bf23651160)($7b88e537562e859e$var$INTEGRATION_NAME, $7b88e537562e859e$export$1378794447170364);





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $a634b9625794c667$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $0bdf548a001e670c$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $a634b9625794c667$var$truncateAggregateExceptions($a634b9625794c667$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $a634b9625794c667$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $0bdf548a001e670c$export$49034edbe6b62415)(error[key], Error)) {
        $a634b9625794c667$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $a634b9625794c667$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $a634b9625794c667$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $0bdf548a001e670c$export$49034edbe6b62415)(childError, Error)) {
            $a634b9625794c667$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $a634b9625794c667$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $a634b9625794c667$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $a634b9625794c667$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $a634b9625794c667$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $a634b9625794c667$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $f28175ac6747d0c5$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $ed5aa22d284f1a4f$var$DEFAULT_KEY = "cause";
const $ed5aa22d284f1a4f$var$DEFAULT_LIMIT = 5;
const $ed5aa22d284f1a4f$var$INTEGRATION_NAME = "LinkedErrors";
const $ed5aa22d284f1a4f$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $ed5aa22d284f1a4f$var$DEFAULT_LIMIT;
    const key = options.key || $ed5aa22d284f1a4f$var$DEFAULT_KEY;
    return {
        name: $ed5aa22d284f1a4f$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $a634b9625794c667$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $d71d509404cc9123$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $ed5aa22d284f1a4f$export$ebabb00eb7f3a395 = (0, $2384715dee2beb9a$export$2323046b9414659f)($ed5aa22d284f1a4f$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $ed5aa22d284f1a4f$export$8d1e60aaf616fb4f = (0, $2384715dee2beb9a$export$afa219bf23651160)($ed5aa22d284f1a4f$var$INTEGRATION_NAME, $ed5aa22d284f1a4f$export$ebabb00eb7f3a395);





const $7259d49a0e991bbb$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $7259d49a0e991bbb$var$INTEGRATION_NAME = "TryCatch";
const $7259d49a0e991bbb$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $7259d49a0e991bbb$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $3573f39c9e00bebb$export$9563e054e6f787fb)((0, $e56212619ce00c0e$export$56d8a8a25bd48b81), "setTimeout", $7259d49a0e991bbb$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $3573f39c9e00bebb$export$9563e054e6f787fb)((0, $e56212619ce00c0e$export$56d8a8a25bd48b81), "setInterval", $7259d49a0e991bbb$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $3573f39c9e00bebb$export$9563e054e6f787fb)((0, $e56212619ce00c0e$export$56d8a8a25bd48b81), "requestAnimationFrame", $7259d49a0e991bbb$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $e56212619ce00c0e$export$56d8a8a25bd48b81)) (0, $3573f39c9e00bebb$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $7259d49a0e991bbb$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $7259d49a0e991bbb$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($7259d49a0e991bbb$var$_wrapEventTarget);
            }
        }
    };
};
const $7259d49a0e991bbb$export$59bfe9f1c76150e = (0, $2384715dee2beb9a$export$2323046b9414659f)($7259d49a0e991bbb$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $7259d49a0e991bbb$export$f1a018517668e6d3 = (0, $2384715dee2beb9a$export$afa219bf23651160)($7259d49a0e991bbb$var$INTEGRATION_NAME, $7259d49a0e991bbb$export$59bfe9f1c76150e);
function $7259d49a0e991bbb$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $e56212619ce00c0e$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $3756b13f7e84670f$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7259d49a0e991bbb$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $e56212619ce00c0e$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $3756b13f7e84670f$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $7259d49a0e991bbb$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $3573f39c9e00bebb$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $3756b13f7e84670f$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $3573f39c9e00bebb$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $3756b13f7e84670f$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $e56212619ce00c0e$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $7259d49a0e991bbb$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $e56212619ce00c0e$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $3573f39c9e00bebb$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $e56212619ce00c0e$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $3756b13f7e84670f$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $e56212619ce00c0e$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $3756b13f7e84670f$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $3573f39c9e00bebb$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



// global reference to slice
const $7f75416bd1e3f742$var$UNKNOWN_FUNCTION = "?";
const $7f75416bd1e3f742$var$OPERA10_PRIORITY = 10;
const $7f75416bd1e3f742$var$OPERA11_PRIORITY = 20;
const $7f75416bd1e3f742$var$CHROME_PRIORITY = 30;
const $7f75416bd1e3f742$var$WINJS_PRIORITY = 40;
const $7f75416bd1e3f742$var$GECKO_PRIORITY = 50;
function $7f75416bd1e3f742$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $7f75416bd1e3f742$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $7f75416bd1e3f742$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $7f75416bd1e3f742$var$chromeStackParserFn = (line)=>{
    const parts = $7f75416bd1e3f742$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $7f75416bd1e3f742$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $7f75416bd1e3f742$var$extractSafariExtensionDetails(parts[1] || $7f75416bd1e3f742$var$UNKNOWN_FUNCTION, parts[2]);
        return $7f75416bd1e3f742$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $7f75416bd1e3f742$export$263a749fff749872 = [
    $7f75416bd1e3f742$var$CHROME_PRIORITY,
    $7f75416bd1e3f742$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $7f75416bd1e3f742$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $7f75416bd1e3f742$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $7f75416bd1e3f742$var$gecko = (line)=>{
    const parts = $7f75416bd1e3f742$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $7f75416bd1e3f742$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $7f75416bd1e3f742$var$UNKNOWN_FUNCTION;
        [func, filename] = $7f75416bd1e3f742$var$extractSafariExtensionDetails(func, filename);
        return $7f75416bd1e3f742$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $7f75416bd1e3f742$export$cdba47a5dd2804d = [
    $7f75416bd1e3f742$var$GECKO_PRIORITY,
    $7f75416bd1e3f742$var$gecko
];
const $7f75416bd1e3f742$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $7f75416bd1e3f742$var$winjs = (line)=>{
    const parts = $7f75416bd1e3f742$var$winjsRegex.exec(line);
    return parts ? $7f75416bd1e3f742$var$createFrame(parts[2], parts[1] || $7f75416bd1e3f742$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $7f75416bd1e3f742$export$179460296da408e8 = [
    $7f75416bd1e3f742$var$WINJS_PRIORITY,
    $7f75416bd1e3f742$var$winjs
];
const $7f75416bd1e3f742$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $7f75416bd1e3f742$var$opera10 = (line)=>{
    const parts = $7f75416bd1e3f742$var$opera10Regex.exec(line);
    return parts ? $7f75416bd1e3f742$var$createFrame(parts[2], parts[3] || $7f75416bd1e3f742$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $7f75416bd1e3f742$export$f892b52c880ffc7a = [
    $7f75416bd1e3f742$var$OPERA10_PRIORITY,
    $7f75416bd1e3f742$var$opera10
];
const $7f75416bd1e3f742$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $7f75416bd1e3f742$var$opera11 = (line)=>{
    const parts = $7f75416bd1e3f742$var$opera11Regex.exec(line);
    return parts ? $7f75416bd1e3f742$var$createFrame(parts[5], parts[3] || parts[4] || $7f75416bd1e3f742$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $7f75416bd1e3f742$export$af11af13f09fb0dc = [
    $7f75416bd1e3f742$var$OPERA11_PRIORITY,
    $7f75416bd1e3f742$var$opera11
];
const $7f75416bd1e3f742$export$7197c0fe6554c079 = [
    $7f75416bd1e3f742$export$263a749fff749872,
    $7f75416bd1e3f742$export$cdba47a5dd2804d,
    $7f75416bd1e3f742$export$179460296da408e8
];
const $7f75416bd1e3f742$export$2b2b997d81bf3907 = (0, $3756b13f7e84670f$export$a5739666fb2d03d4)(...$7f75416bd1e3f742$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $7f75416bd1e3f742$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $7f75416bd1e3f742$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $abd63e7b0ecf3c92$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $abd63e7b0ecf3c92$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $abd63e7b0ecf3c92$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $abd63e7b0ecf3c92$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $abd63e7b0ecf3c92$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $abd63e7b0ecf3c92$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $abd63e7b0ecf3c92$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $abd63e7b0ecf3c92$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $709ed791aaab5aa5$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $c7ebba5fa2c683f8$export$78e43115b553f358)(new (0, $2986c2df799d59ae$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $c7ebba5fa2c683f8$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $c7ebba5fa2c683f8$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $36705fbcf6ad42b4$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $36705fbcf6ad42b4$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $709ed791aaab5aa5$export$85a4f67f852183e6)(options.bufferSize || $36705fbcf6ad42b4$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $a7dd6b8d5d1f9a4e$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $a7dd6b8d5d1f9a4e$export$b11169581eeaf237)(type);
            if ((0, $abd63e7b0ecf3c92$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $36705fbcf6ad42b4$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $c7ebba5fa2c683f8$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $a7dd6b8d5d1f9a4e$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $a7dd6b8d5d1f9a4e$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $36705fbcf6ad42b4$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $a7dd6b8d5d1f9a4e$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $a7dd6b8d5d1f9a4e$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $abd63e7b0ecf3c92$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $2986c2df799d59ae$export$5949942ba2a7c0e2)) {
                (0, $6e88aab9796f5acd$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $c7ebba5fa2c683f8$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $36705fbcf6ad42b4$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}






let $6f34239aafd73408$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $6f34239aafd73408$export$8be2119ce08e3379() {
    if ($6f34239aafd73408$var$cachedFetchImpl) return $6f34239aafd73408$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $c16ac02288bf2a10$export$18cf36ed71d733e7)((0, $e56212619ce00c0e$export$56d8a8a25bd48b81).fetch)) return $6f34239aafd73408$var$cachedFetchImpl = (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).fetch.bind((0, $e56212619ce00c0e$export$56d8a8a25bd48b81));
    const document = (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $d725d2219f7bf80e$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $6f34239aafd73408$var$cachedFetchImpl = fetchImpl.bind((0, $e56212619ce00c0e$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $6f34239aafd73408$export$d499686d2dd738c6() {
    $6f34239aafd73408$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $b76972111dfee599$export$b2311068c46d7cc8(options, nativeFetch = (0, $6f34239aafd73408$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $6f34239aafd73408$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $c7ebba5fa2c683f8$export$78e43115b553f358)(e);
        }
    }
    return (0, $36705fbcf6ad42b4$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $1de92ac546fb0d34$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $1de92ac546fb0d34$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $c7ebba5fa2c683f8$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $1de92ac546fb0d34$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $36705fbcf6ad42b4$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $d20a3bc6f2685edd$export$5ef831fccfce35e5 = [
    (0, $3959a590b2f43389$export$cb3c5c2ceb9818ba)(),
    (0, $7e387b2dcd612739$export$7918117e9202e4fb)(),
    (0, $7259d49a0e991bbb$export$59bfe9f1c76150e)(),
    (0, $4df35ebf0eeb9743$export$c079d904b326663a)(),
    (0, $1dec51759b786c1d$export$66acc70e8cf2b71a)(),
    (0, $ed5aa22d284f1a4f$export$ebabb00eb7f3a395)(),
    (0, $5ac03215a537fd75$export$6d39aa44cd0c7567)(),
    (0, $7b88e537562e859e$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $d20a3bc6f2685edd$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$d20a3bc6f2685edd$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $d20a3bc6f2685edd$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $d20a3bc6f2685edd$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $e56212619ce00c0e$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $3756b13f7e84670f$export$1d5cf88b347146d4)(options.stackParser || (0, $7f75416bd1e3f742$export$2b2b997d81bf3907)),
        integrations: (0, $2384715dee2beb9a$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $c16ac02288bf2a10$export$edf3cb81fd7d2a3e)() ? (0, $b76972111dfee599$export$b2311068c46d7cc8) : (0, $1de92ac546fb0d34$export$5e1441cee30d5a39))
    };
    (0, $0583f127bf5c708b$export$5333c3f1c58d9bc1)((0, $3875374f67599049$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $d20a3bc6f2685edd$var$startSessionTracking();
}
const $d20a3bc6f2685edd$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $6ea9c05e188f19de$export$a07cdf6544bbd7c)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $e56212619ce00c0e$export$56d8a8a25bd48b81).document) {
        (0, $d725d2219f7bf80e$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $d725d2219f7bf80e$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $a9dbe3993bfc02ed$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).document.head || (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $d725d2219f7bf80e$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $d20a3bc6f2685edd$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $d20a3bc6f2685edd$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d20a3bc6f2685edd$export$4997ffc0176396a6(fn) {
    return (0, $e56212619ce00c0e$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $d20a3bc6f2685edd$var$startSessionTracking() {
    if (typeof (0, $e56212619ce00c0e$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $d725d2219f7bf80e$export$16a28057038b10ef) && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $15458dde2c60d92b$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $15458dde2c60d92b$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $25558ab1f79d7e77$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $15458dde2c60d92b$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $15458dde2c60d92b$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $d20a3bc6f2685edd$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
    if (client) client.captureUserFeedback(feedback);
}



/**
 * Inits the React SDK
 */ function $8b28b65f4c22988d$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $f11ab1e7429c35a4$export$b9f95b027256052c)(opts, "react");
    (0, $d20a3bc6f2685edd$export$2cd8252107eb640b)(opts);
}

// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $294446217f44a888$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $93a581f0a1baade9$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}


var $9pHcQ = parcelRequire("9pHcQ");

/**
 * Returns true if we are in the browser.
 */ function $ba79970519f89b28$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, $9pHcQ.isNodeEnv)() || $ba79970519f89b28$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $ba79970519f89b28$var$isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).process !== undefined && (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1).process.type === "renderer");
}


/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ // eslint-disable-next-line deprecation/deprecation
function $d99cf49ba4c3e0e5$export$d92e61f5600202af(url, hubOrClient) {
    const client = hubOrClient && $d99cf49ba4c3e0e5$var$isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $d99cf49ba4c3e0e5$var$checkDsn(url, dsn) || $d99cf49ba4c3e0e5$var$checkTunnel(url, tunnel);
}
function $d99cf49ba4c3e0e5$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $d99cf49ba4c3e0e5$var$removeTrailingSlash(url) === $d99cf49ba4c3e0e5$var$removeTrailingSlash(tunnel);
}
function $d99cf49ba4c3e0e5$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $d99cf49ba4c3e0e5$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
// eslint-disable-next-line deprecation/deprecation
function $d99cf49ba4c3e0e5$var$isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}



// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $2c6845a34a9d5bee$var$WINDOW = (0, $e12526d3482a2b29$export$f1a6cdb1459e81d1);
const $2c6845a34a9d5bee$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $2c6845a34a9d5bee$var$REPLAY_EVENT_NAME = "replay_event";
const $2c6845a34a9d5bee$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
// The idle limit for a session after which recording is paused.
const $2c6845a34a9d5bee$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $2c6845a34a9d5bee$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $2c6845a34a9d5bee$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $2c6845a34a9d5bee$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $2c6845a34a9d5bee$var$BUFFER_CHECKOUT_TIME = 60000;
const $2c6845a34a9d5bee$var$RETRY_BASE_INTERVAL = 5000;
const $2c6845a34a9d5bee$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $2c6845a34a9d5bee$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $2c6845a34a9d5bee$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $2c6845a34a9d5bee$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $2c6845a34a9d5bee$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $2c6845a34a9d5bee$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $2c6845a34a9d5bee$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $2c6845a34a9d5bee$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $2c6845a34a9d5bee$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $2c6845a34a9d5bee$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $2c6845a34a9d5bee$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $2c6845a34a9d5bee$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($2c6845a34a9d5bee$var$NodeType$1 || ($2c6845a34a9d5bee$var$NodeType$1 = {}));
function $2c6845a34a9d5bee$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $2c6845a34a9d5bee$var$isShadowRoot(n) {
    const host = $2c6845a34a9d5bee$var$_optionalChain$5([
        n,
        "optionalAccess",
        (_)=>_.host
    ]);
    return Boolean($2c6845a34a9d5bee$var$_optionalChain$5([
        host,
        "optionalAccess",
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $2c6845a34a9d5bee$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $2c6845a34a9d5bee$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $2c6845a34a9d5bee$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $2c6845a34a9d5bee$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $2c6845a34a9d5bee$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $2c6845a34a9d5bee$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $2c6845a34a9d5bee$var$stringifyRule(rule) {
    let importStringified;
    if ($2c6845a34a9d5bee$var$isCSSImportRule(rule)) try {
        importStringified = $2c6845a34a9d5bee$var$stringifyStylesheet(rule.styleSheet) || $2c6845a34a9d5bee$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($2c6845a34a9d5bee$var$isCSSStyleRule(rule) && rule.selectorText.includes(":")) return $2c6845a34a9d5bee$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $2c6845a34a9d5bee$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $2c6845a34a9d5bee$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $2c6845a34a9d5bee$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $2c6845a34a9d5bee$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $2c6845a34a9d5bee$var$_optionalChain$5([
            this,
            "access",
            (_3)=>_3.getMeta,
            "call",
            (_4)=>_4(n),
            "optionalAccess",
            (_5)=>_5.id
        ]);
        return $2c6845a34a9d5bee$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $2c6845a34a9d5bee$var$createMirror() {
    return new $2c6845a34a9d5bee$var$Mirror();
}
function $2c6845a34a9d5bee$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $2c6845a34a9d5bee$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $2c6845a34a9d5bee$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $2c6845a34a9d5bee$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $2c6845a34a9d5bee$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $2c6845a34a9d5bee$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $2c6845a34a9d5bee$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$2c6845a34a9d5bee$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $2c6845a34a9d5bee$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $2c6845a34a9d5bee$var$toLowerCase(type) : null;
}
function $2c6845a34a9d5bee$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
let $2c6845a34a9d5bee$var$_id = 1;
const $2c6845a34a9d5bee$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $2c6845a34a9d5bee$var$IGNORED_NODE = -2;
function $2c6845a34a9d5bee$var$genId() {
    return $2c6845a34a9d5bee$var$_id++;
}
function $2c6845a34a9d5bee$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $2c6845a34a9d5bee$var$toLowerCase(element.tagName);
    if ($2c6845a34a9d5bee$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $2c6845a34a9d5bee$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $2c6845a34a9d5bee$var$canvasService;
let $2c6845a34a9d5bee$var$canvasCtx;
const $2c6845a34a9d5bee$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $2c6845a34a9d5bee$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $2c6845a34a9d5bee$var$URL_WWW_MATCH = /^www\..*/i;
const $2c6845a34a9d5bee$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $2c6845a34a9d5bee$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($2c6845a34a9d5bee$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($2c6845a34a9d5bee$var$URL_PROTOCOL_MATCH.test(filePath) || $2c6845a34a9d5bee$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($2c6845a34a9d5bee$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$2c6845a34a9d5bee$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $2c6845a34a9d5bee$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $2c6845a34a9d5bee$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $2c6845a34a9d5bee$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($2c6845a34a9d5bee$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($2c6845a34a9d5bee$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $2c6845a34a9d5bee$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $2c6845a34a9d5bee$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
function $2c6845a34a9d5bee$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    const a = doc.createElement("a");
    a.href = attributeValue;
    return a.href;
}
function $2c6845a34a9d5bee$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $2c6845a34a9d5bee$var$getHref() {
    const a = document.createElement("a");
    a.href = "";
    return a.href;
}
function $2c6845a34a9d5bee$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $2c6845a34a9d5bee$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $2c6845a34a9d5bee$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $2c6845a34a9d5bee$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $2c6845a34a9d5bee$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $2c6845a34a9d5bee$var$absoluteToStylesheet(value, $2c6845a34a9d5bee$var$getHref());
    else if (tagName === "object" && name === "data") return $2c6845a34a9d5bee$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $2c6845a34a9d5bee$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $2c6845a34a9d5bee$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $2c6845a34a9d5bee$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $2c6845a34a9d5bee$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $2c6845a34a9d5bee$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $2c6845a34a9d5bee$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($2c6845a34a9d5bee$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $2c6845a34a9d5bee$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $2c6845a34a9d5bee$var$distanceToMatch(el, $2c6845a34a9d5bee$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $2c6845a34a9d5bee$var$distanceToMatch(el, $2c6845a34a9d5bee$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $2c6845a34a9d5bee$var$distanceToMatch(el, $2c6845a34a9d5bee$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $2c6845a34a9d5bee$var$distanceToMatch(el, $2c6845a34a9d5bee$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $2c6845a34a9d5bee$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $2c6845a34a9d5bee$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $2c6845a34a9d5bee$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $2c6845a34a9d5bee$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $2c6845a34a9d5bee$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $2c6845a34a9d5bee$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $2c6845a34a9d5bee$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $2c6845a34a9d5bee$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $2c6845a34a9d5bee$var$serializeTextNode(n, {
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $2c6845a34a9d5bee$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $2c6845a34a9d5bee$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $2c6845a34a9d5bee$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $2c6845a34a9d5bee$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : undefined;
    const isScript = parentTagName === "SCRIPT" ? true : undefined;
    const isTextarea = parentTagName === "TEXTAREA" ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($2c6845a34a9d5bee$var$_optionalChain$5([
                n,
                "access",
                (_6)=>_6.parentNode,
                "access",
                (_7)=>_7.sheet,
                "optionalAccess",
                (_8)=>_8.cssRules
            ])) textContent = $2c6845a34a9d5bee$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $2c6845a34a9d5bee$var$absoluteToStylesheet(textContent, $2c6845a34a9d5bee$var$getHref());
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $2c6845a34a9d5bee$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $2c6845a34a9d5bee$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $2c6845a34a9d5bee$var$maskInputValue({
            isMasked: $2c6845a34a9d5bee$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $2c6845a34a9d5bee$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $2c6845a34a9d5bee$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $2c6845a34a9d5bee$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $2c6845a34a9d5bee$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$2c6845a34a9d5bee$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $2c6845a34a9d5bee$var$transformAttribute(doc, tagName, $2c6845a34a9d5bee$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $2c6845a34a9d5bee$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $2c6845a34a9d5bee$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $2c6845a34a9d5bee$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $2c6845a34a9d5bee$var$absoluteToStylesheet(cssText, $2c6845a34a9d5bee$var$getHref());
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = $2c6845a34a9d5bee$var$getInputType(el);
        const value = $2c6845a34a9d5bee$var$getInputValue(el, $2c6845a34a9d5bee$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $2c6845a34a9d5bee$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $2c6845a34a9d5bee$var$shouldMaskInput({
                type: type,
                tagName: $2c6845a34a9d5bee$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $2c6845a34a9d5bee$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$2c6845a34a9d5bee$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$2c6845a34a9d5bee$var$canvasService) {
            $2c6845a34a9d5bee$var$canvasService = doc.createElement("canvas");
            $2c6845a34a9d5bee$var$canvasCtx = $2c6845a34a9d5bee$var$canvasService.getContext("2d");
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = "anonymous";
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $2c6845a34a9d5bee$var$canvasService.width = image.naturalWidth;
                $2c6845a34a9d5bee$var$canvasService.height = image.naturalHeight;
                $2c6845a34a9d5bee$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $2c6845a34a9d5bee$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes.rr_mediaState = n.paused ? "paused" : "played";
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $2c6845a34a9d5bee$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $2c6845a34a9d5bee$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $2c6845a34a9d5bee$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $2c6845a34a9d5bee$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $2c6845a34a9d5bee$var$NodeType$1.Comment) return true;
    else if (sn.type === $2c6845a34a9d5bee$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === "script" || sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && sn.attributes.href.endsWith(".js"))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "application-name" || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.rel) === "icon" || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "robots" || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "googlebot" || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "author" || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "generator" || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "framework" || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "publisher" || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "progid" || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "verification" || $2c6845a34a9d5bee$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $2c6845a34a9d5bee$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $2c6845a34a9d5bee$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($2c6845a34a9d5bee$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $2c6845a34a9d5bee$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $2c6845a34a9d5bee$var$IGNORED_NODE;
    else id = $2c6845a34a9d5bee$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $2c6845a34a9d5bee$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $2c6845a34a9d5bee$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $2c6845a34a9d5bee$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $2c6845a34a9d5bee$var$NodeType$1.Document || serializedNode.type === $2c6845a34a9d5bee$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $2c6845a34a9d5bee$var$NodeType$1.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $2c6845a34a9d5bee$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($2c6845a34a9d5bee$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $2c6845a34a9d5bee$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $2c6845a34a9d5bee$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $2c6845a34a9d5bee$var$isShadowRoot(n.parentNode) && $2c6845a34a9d5bee$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $2c6845a34a9d5bee$var$NodeType$1.Element && serializedNode.tagName === "iframe") $2c6845a34a9d5bee$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $2c6845a34a9d5bee$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $2c6845a34a9d5bee$var$NodeType$1.Element && serializedNode.tagName === "link" && serializedNode.attributes.rel === "stylesheet") $2c6845a34a9d5bee$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $2c6845a34a9d5bee$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $2c6845a34a9d5bee$var$snapshot(n, options) {
    const { mirror: mirror = new $2c6845a34a9d5bee$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $2c6845a34a9d5bee$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $2c6845a34a9d5bee$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $2c6845a34a9d5bee$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $2c6845a34a9d5bee$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $2c6845a34a9d5bee$var$_mirror = {
    map: {},
    getId () {
        console.error($2c6845a34a9d5bee$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($2c6845a34a9d5bee$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($2c6845a34a9d5bee$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($2c6845a34a9d5bee$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($2c6845a34a9d5bee$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $2c6845a34a9d5bee$var$_mirror = new Proxy($2c6845a34a9d5bee$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($2c6845a34a9d5bee$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $2c6845a34a9d5bee$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $2c6845a34a9d5bee$var$clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $2c6845a34a9d5bee$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $2c6845a34a9d5bee$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $2c6845a34a9d5bee$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$2c6845a34a9d5bee$var$hookSetter(target, key, original || {}, true);
}
function $2c6845a34a9d5bee$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $2c6845a34a9d5bee$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $2c6845a34a9d5bee$var$nowTimestamp = ()=>new Date().getTime();
function $2c6845a34a9d5bee$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $2c6845a34a9d5bee$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_)=>_.documentElement,
            "access",
            (_2)=>_2.scrollLeft
        ]) || $2c6845a34a9d5bee$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_3)=>_3.body,
            "optionalAccess",
            (_4)=>_4.parentElement,
            "optionalAccess",
            (_5)=>_5.scrollLeft
        ]) || $2c6845a34a9d5bee$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_6)=>_6.body,
            "optionalAccess",
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $2c6845a34a9d5bee$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_8)=>_8.documentElement,
            "access",
            (_9)=>_9.scrollTop
        ]) || $2c6845a34a9d5bee$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_10)=>_10.body,
            "optionalAccess",
            (_11)=>_11.parentElement,
            "optionalAccess",
            (_12)=>_12.scrollTop
        ]) || $2c6845a34a9d5bee$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_13)=>_13.body,
            "optionalAccess",
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $2c6845a34a9d5bee$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $2c6845a34a9d5bee$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $2c6845a34a9d5bee$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $2c6845a34a9d5bee$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $2c6845a34a9d5bee$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $2c6845a34a9d5bee$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $2c6845a34a9d5bee$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $2c6845a34a9d5bee$var$distanceToMatch(el, $2c6845a34a9d5bee$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $2c6845a34a9d5bee$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $2c6845a34a9d5bee$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $2c6845a34a9d5bee$var$IGNORED_NODE;
}
function $2c6845a34a9d5bee$var$isAncestorRemoved(target, mirror) {
    if ($2c6845a34a9d5bee$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $2c6845a34a9d5bee$var$isAncestorRemoved(target.parentNode, mirror);
}
function $2c6845a34a9d5bee$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $2c6845a34a9d5bee$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $2c6845a34a9d5bee$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $2c6845a34a9d5bee$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $2c6845a34a9d5bee$var$hasShadowRoot(n) {
    return Boolean($2c6845a34a9d5bee$var$_optionalChain$4([
        n,
        "optionalAccess",
        (_18)=>_18.shadowRoot
    ]));
}
class $2c6845a34a9d5bee$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $294446217f44a888$export$8db64e83cc1a933c)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $2c6845a34a9d5bee$var$getShadowHost(n) {
    let shadowHost = null;
    if ($2c6845a34a9d5bee$var$_optionalChain$4([
        n,
        "access",
        (_19)=>_19.getRootNode,
        "optionalCall",
        (_20)=>_20(),
        "optionalAccess",
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $2c6845a34a9d5bee$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $2c6845a34a9d5bee$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $2c6845a34a9d5bee$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $2c6845a34a9d5bee$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $2c6845a34a9d5bee$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $2c6845a34a9d5bee$var$shadowHostInDom(n);
}
const $2c6845a34a9d5bee$var$cachedImplementations = {};
function $2c6845a34a9d5bee$var$getImplementation(name) {
    const cached = $2c6845a34a9d5bee$var$cachedImplementations[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === "function") try {
        const sandbox = document1.createElement("iframe");
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $2c6845a34a9d5bee$var$cachedImplementations[name] = impl.bind(window);
}
function $2c6845a34a9d5bee$var$onRequestAnimationFrame(...rest) {
    return $2c6845a34a9d5bee$var$getImplementation("requestAnimationFrame")(...rest);
}
function $2c6845a34a9d5bee$var$setTimeout$1(...rest) {
    return $2c6845a34a9d5bee$var$getImplementation("setTimeout")(...rest);
}
function $2c6845a34a9d5bee$var$clearTimeout$1(...rest) {
    return $2c6845a34a9d5bee$var$getImplementation("clearTimeout")(...rest);
}
var $2c6845a34a9d5bee$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($2c6845a34a9d5bee$var$EventType || {});
var $2c6845a34a9d5bee$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($2c6845a34a9d5bee$var$IncrementalSource || {});
var $2c6845a34a9d5bee$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($2c6845a34a9d5bee$var$MouseInteractions || {});
var $2c6845a34a9d5bee$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($2c6845a34a9d5bee$var$PointerTypes || {});
function $2c6845a34a9d5bee$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $2c6845a34a9d5bee$var$isNodeInLinkedList(n) {
    return "__ln" in n;
}
class $2c6845a34a9d5bee$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = $2c6845a34a9d5bee$var$_optionalChain$3([
            current,
            "optionalAccess",
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $2c6845a34a9d5bee$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $2c6845a34a9d5bee$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $2c6845a34a9d5bee$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $2c6845a34a9d5bee$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $2c6845a34a9d5bee$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $2c6845a34a9d5bee$var$IGNORED_NODE;
                while(nextId === $2c6845a34a9d5bee$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$2c6845a34a9d5bee$var$inDom(n)) return;
                const parentId = $2c6845a34a9d5bee$var$isShadowRoot(n.parentNode) ? this.mirror.getId($2c6845a34a9d5bee$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $2c6845a34a9d5bee$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($2c6845a34a9d5bee$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($2c6845a34a9d5bee$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($2c6845a34a9d5bee$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($2c6845a34a9d5bee$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$2c6845a34a9d5bee$var$isAncestorInSet(this.droppedSet, n) && !$2c6845a34a9d5bee$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($2c6845a34a9d5bee$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($2c6845a34a9d5bee$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$2c6845a34a9d5bee$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $2c6845a34a9d5bee$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $2c6845a34a9d5bee$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $2c6845a34a9d5bee$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $2c6845a34a9d5bee$var$getInputValue(target, tagName, type);
                            const isInputMasked = $2c6845a34a9d5bee$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $2c6845a34a9d5bee$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $2c6845a34a9d5bee$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($2c6845a34a9d5bee$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$2c6845a34a9d5bee$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $2c6845a34a9d5bee$var$transformAttribute(this.doc, $2c6845a34a9d5bee$var$toLowerCase(target.tagName), $2c6845a34a9d5bee$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($2c6845a34a9d5bee$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $2c6845a34a9d5bee$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($2c6845a34a9d5bee$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $2c6845a34a9d5bee$var$isIgnored(n, this.mirror) || !$2c6845a34a9d5bee$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $2c6845a34a9d5bee$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($2c6845a34a9d5bee$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$2c6845a34a9d5bee$var$moveKey(nodeId, parentId)]) $2c6845a34a9d5bee$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $2c6845a34a9d5bee$var$isShadowRoot(m.target) && $2c6845a34a9d5bee$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($2c6845a34a9d5bee$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$2c6845a34a9d5bee$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$2c6845a34a9d5bee$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($2c6845a34a9d5bee$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $2c6845a34a9d5bee$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$2c6845a34a9d5bee$var$deepDelete(addsSet, childN));
}
function $2c6845a34a9d5bee$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $2c6845a34a9d5bee$var$_isParentRemoved(removes, n, mirror);
}
function $2c6845a34a9d5bee$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $2c6845a34a9d5bee$var$_isParentRemoved(removes, parentNode, mirror);
}
function $2c6845a34a9d5bee$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $2c6845a34a9d5bee$var$_isAncestorInSet(set, n);
}
function $2c6845a34a9d5bee$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $2c6845a34a9d5bee$var$_isAncestorInSet(set, parentNode);
}
let $2c6845a34a9d5bee$var$errorHandler;
function $2c6845a34a9d5bee$var$registerErrorHandler(handler) {
    $2c6845a34a9d5bee$var$errorHandler = handler;
}
function $2c6845a34a9d5bee$var$unregisterErrorHandler() {
    $2c6845a34a9d5bee$var$errorHandler = undefined;
}
const $2c6845a34a9d5bee$var$callbackWrapper = (cb)=>{
    if (!$2c6845a34a9d5bee$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($2c6845a34a9d5bee$var$errorHandler && $2c6845a34a9d5bee$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $2c6845a34a9d5bee$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $2c6845a34a9d5bee$var$mutationBuffers = [];
function $2c6845a34a9d5bee$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $2c6845a34a9d5bee$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $2c6845a34a9d5bee$var$MutationBuffer();
    $2c6845a34a9d5bee$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $2c6845a34a9d5bee$var$_optionalChain$2([
        window,
        "optionalAccess",
        (_)=>_.Zone,
        "optionalAccess",
        (_2)=>_2.__symbol__,
        "optionalCall",
        (_3)=>_3("MutationObserver")
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($2c6845a34a9d5bee$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $2c6845a34a9d5bee$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $2c6845a34a9d5bee$var$throttle$1($2c6845a34a9d5bee$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $2c6845a34a9d5bee$var$callbackWrapper($2c6845a34a9d5bee$var$throttle$1($2c6845a34a9d5bee$var$callbackWrapper((evt)=>{
        const target = $2c6845a34a9d5bee$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $2c6845a34a9d5bee$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $2c6845a34a9d5bee$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $2c6845a34a9d5bee$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $2c6845a34a9d5bee$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $2c6845a34a9d5bee$var$IncrementalSource.MouseMove : $2c6845a34a9d5bee$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $2c6845a34a9d5bee$var$on("mousemove", updatePosition, doc),
        $2c6845a34a9d5bee$var$on("touchmove", updatePosition, doc),
        $2c6845a34a9d5bee$var$on("drag", updatePosition, doc)
    ];
    return $2c6845a34a9d5bee$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $2c6845a34a9d5bee$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $2c6845a34a9d5bee$var$getEventTarget(event);
            if ($2c6845a34a9d5bee$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $2c6845a34a9d5bee$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $2c6845a34a9d5bee$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $2c6845a34a9d5bee$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $2c6845a34a9d5bee$var$PointerTypes.Touch) {
                    if ($2c6845a34a9d5bee$var$MouseInteractions[eventKey] === $2c6845a34a9d5bee$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($2c6845a34a9d5bee$var$MouseInteractions[eventKey] === $2c6845a34a9d5bee$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $2c6845a34a9d5bee$var$PointerTypes.Pen;
            } else if ($2c6845a34a9d5bee$var$legacy_isTouchEvent(event)) pointerType = $2c6845a34a9d5bee$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $2c6845a34a9d5bee$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $2c6845a34a9d5bee$var$PointerTypes.Mouse) pointerType = null;
            } else if ($2c6845a34a9d5bee$var$MouseInteractions[eventKey] === $2c6845a34a9d5bee$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $2c6845a34a9d5bee$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $2c6845a34a9d5bee$var$callbackWrapper(mouseInteractionCb)({
                type: $2c6845a34a9d5bee$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($2c6845a34a9d5bee$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $2c6845a34a9d5bee$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($2c6845a34a9d5bee$var$MouseInteractions[eventKey]){
            case $2c6845a34a9d5bee$var$MouseInteractions.MouseDown:
            case $2c6845a34a9d5bee$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $2c6845a34a9d5bee$var$MouseInteractions.TouchStart:
            case $2c6845a34a9d5bee$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($2c6845a34a9d5bee$var$on(eventName, handler, doc));
    });
    return $2c6845a34a9d5bee$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $2c6845a34a9d5bee$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $2c6845a34a9d5bee$var$callbackWrapper($2c6845a34a9d5bee$var$throttle$1($2c6845a34a9d5bee$var$callbackWrapper((evt)=>{
        const target = $2c6845a34a9d5bee$var$getEventTarget(evt);
        if (!target || $2c6845a34a9d5bee$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $2c6845a34a9d5bee$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $2c6845a34a9d5bee$var$on("scroll", updatePosition, doc);
}
function $2c6845a34a9d5bee$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $2c6845a34a9d5bee$var$callbackWrapper($2c6845a34a9d5bee$var$throttle$1($2c6845a34a9d5bee$var$callbackWrapper(()=>{
        const height = $2c6845a34a9d5bee$var$getWindowHeight();
        const width = $2c6845a34a9d5bee$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $2c6845a34a9d5bee$var$on("resize", updateDimension, win);
}
const $2c6845a34a9d5bee$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $2c6845a34a9d5bee$var$lastInputValueMap = new WeakMap();
function $2c6845a34a9d5bee$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $2c6845a34a9d5bee$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $2c6845a34a9d5bee$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $2c6845a34a9d5bee$var$INPUT_TAGS.indexOf(tagName) < 0 || $2c6845a34a9d5bee$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $2c6845a34a9d5bee$var$getInputType(target);
        let text = $2c6845a34a9d5bee$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $2c6845a34a9d5bee$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $2c6845a34a9d5bee$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $2c6845a34a9d5bee$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $2c6845a34a9d5bee$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $2c6845a34a9d5bee$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $2c6845a34a9d5bee$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $2c6845a34a9d5bee$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $2c6845a34a9d5bee$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$2c6845a34a9d5bee$var$on(eventName, $2c6845a34a9d5bee$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$2c6845a34a9d5bee$var$hookSetter(p[0], p[1], {
            set () {
                $2c6845a34a9d5bee$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $2c6845a34a9d5bee$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $2c6845a34a9d5bee$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($2c6845a34a9d5bee$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $2c6845a34a9d5bee$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $2c6845a34a9d5bee$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $2c6845a34a9d5bee$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $2c6845a34a9d5bee$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $2c6845a34a9d5bee$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $2c6845a34a9d5bee$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $2c6845a34a9d5bee$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $2c6845a34a9d5bee$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $2c6845a34a9d5bee$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $2c6845a34a9d5bee$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $2c6845a34a9d5bee$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $2c6845a34a9d5bee$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $2c6845a34a9d5bee$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($2c6845a34a9d5bee$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($2c6845a34a9d5bee$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($2c6845a34a9d5bee$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($2c6845a34a9d5bee$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $2c6845a34a9d5bee$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $2c6845a34a9d5bee$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$2c6845a34a9d5bee$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $2c6845a34a9d5bee$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $2c6845a34a9d5bee$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$2c6845a34a9d5bee$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $2c6845a34a9d5bee$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $2c6845a34a9d5bee$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? $2c6845a34a9d5bee$var$_optionalChain$2([
        host,
        "access",
        (_4)=>_4.defaultView,
        "optionalAccess",
        (_5)=>_5.Document
    ]) : $2c6845a34a9d5bee$var$_optionalChain$2([
        host,
        "access",
        (_6)=>_6.ownerDocument,
        "optionalAccess",
        (_7)=>_7.defaultView,
        "optionalAccess",
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $2c6845a34a9d5bee$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($2c6845a34a9d5bee$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_10)=>_10.prototype
    ]), "adoptedStyleSheets") : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $2c6845a34a9d5bee$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_11)=>_11.get,
                "optionalAccess",
                (_12)=>_12.call,
                "call",
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $2c6845a34a9d5bee$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_14)=>_14.set,
                "optionalAccess",
                (_15)=>_15.call,
                "call",
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $2c6845a34a9d5bee$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $2c6845a34a9d5bee$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $2c6845a34a9d5bee$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $2c6845a34a9d5bee$var$getIdAndStyleId($2c6845a34a9d5bee$var$_optionalChain$2([
                thisArg,
                "access",
                (_17)=>_17.parentRule,
                "optionalAccess",
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $2c6845a34a9d5bee$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $2c6845a34a9d5bee$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $2c6845a34a9d5bee$var$getIdAndStyleId($2c6845a34a9d5bee$var$_optionalChain$2([
                thisArg,
                "access",
                (_19)=>_19.parentRule,
                "optionalAccess",
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $2c6845a34a9d5bee$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $2c6845a34a9d5bee$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $2c6845a34a9d5bee$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $2c6845a34a9d5bee$var$callbackWrapper((type)=>$2c6845a34a9d5bee$var$throttle$1($2c6845a34a9d5bee$var$callbackWrapper((event)=>{
            const target = $2c6845a34a9d5bee$var$getEventTarget(event);
            if (!target || $2c6845a34a9d5bee$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $2c6845a34a9d5bee$var$on("play", handler(0), doc),
        $2c6845a34a9d5bee$var$on("pause", handler(1), doc),
        $2c6845a34a9d5bee$var$on("seeked", handler(2), doc),
        $2c6845a34a9d5bee$var$on("volumechange", handler(3), doc),
        $2c6845a34a9d5bee$var$on("ratechange", handler(4), doc)
    ];
    return $2c6845a34a9d5bee$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $2c6845a34a9d5bee$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $2c6845a34a9d5bee$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            $2c6845a34a9d5bee$var$setTimeout$1($2c6845a34a9d5bee$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $2c6845a34a9d5bee$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $2c6845a34a9d5bee$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $2c6845a34a9d5bee$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $2c6845a34a9d5bee$var$_optionalChain$2([
            selection,
            "optionalAccess",
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $2c6845a34a9d5bee$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $2c6845a34a9d5bee$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $2c6845a34a9d5bee$var$on("selectionchange", updateSelection);
}
function $2c6845a34a9d5bee$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $2c6845a34a9d5bee$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $2c6845a34a9d5bee$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    const mutationObserver = $2c6845a34a9d5bee$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $2c6845a34a9d5bee$var$initMoveObserver(o);
    const mouseInteractionHandler = $2c6845a34a9d5bee$var$initMouseInteractionObserver(o);
    const scrollHandler = $2c6845a34a9d5bee$var$initScrollObserver(o);
    const viewportResizeHandler = $2c6845a34a9d5bee$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $2c6845a34a9d5bee$var$initInputObserver(o);
    const mediaInteractionHandler = $2c6845a34a9d5bee$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $2c6845a34a9d5bee$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const adoptedStyleSheetObserver = $2c6845a34a9d5bee$var$initAdoptedStyleSheetObserver(o, o.doc);
    const styleDeclarationObserver = $2c6845a34a9d5bee$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $2c6845a34a9d5bee$var$initFontObserver(o) : ()=>{};
    const selectionObserver = $2c6845a34a9d5bee$var$initSelectionObserver(o);
    const customElementObserver = $2c6845a34a9d5bee$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $2c6845a34a9d5bee$var$callbackWrapper(()=>{
        $2c6845a34a9d5bee$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $2c6845a34a9d5bee$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $2c6845a34a9d5bee$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $2c6845a34a9d5bee$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $2c6845a34a9d5bee$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $2c6845a34a9d5bee$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $2c6845a34a9d5bee$var$CrossOriginIframeMirror($2c6845a34a9d5bee$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $2c6845a34a9d5bee$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $2c6845a34a9d5bee$var$CrossOriginIframeMirror($2c6845a34a9d5bee$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $2c6845a34a9d5bee$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $2c6845a34a9d5bee$var$_optionalChain$1([
            this,
            "access",
            (_)=>_.loadListener,
            "optionalCall",
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $2c6845a34a9d5bee$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2c6845a34a9d5bee$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $2c6845a34a9d5bee$var$EventType.Meta:
            case $2c6845a34a9d5bee$var$EventType.Load:
            case $2c6845a34a9d5bee$var$EventType.DomContentLoaded:
                return false;
            case $2c6845a34a9d5bee$var$EventType.Plugin:
                return e;
            case $2c6845a34a9d5bee$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e;
            case $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $2c6845a34a9d5bee$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $2c6845a34a9d5bee$var$IncrementalSource.Drag:
                    case $2c6845a34a9d5bee$var$IncrementalSource.TouchMove:
                    case $2c6845a34a9d5bee$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $2c6845a34a9d5bee$var$IncrementalSource.ViewportResize:
                        return false;
                    case $2c6845a34a9d5bee$var$IncrementalSource.MediaInteraction:
                    case $2c6845a34a9d5bee$var$IncrementalSource.MouseInteraction:
                    case $2c6845a34a9d5bee$var$IncrementalSource.Scroll:
                    case $2c6845a34a9d5bee$var$IncrementalSource.CanvasMutation:
                    case $2c6845a34a9d5bee$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        return e;
                    case $2c6845a34a9d5bee$var$IncrementalSource.StyleSheetRule:
                    case $2c6845a34a9d5bee$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleId"
                        ]);
                        return e;
                    case $2c6845a34a9d5bee$var$IncrementalSource.Font:
                        return e;
                    case $2c6845a34a9d5bee$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e;
                    case $2c6845a34a9d5bee$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleIds"
                        ]);
                        $2c6845a34a9d5bee$var$_optionalChain$1([
                            e,
                            "access",
                            (_3)=>_3.data,
                            "access",
                            (_4)=>_4.styles,
                            "optionalAccess",
                            (_5)=>_5.forEach,
                            "call",
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        "styleId"
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $2c6845a34a9d5bee$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $2c6845a34a9d5bee$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $2c6845a34a9d5bee$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$2c6845a34a9d5bee$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = $2c6845a34a9d5bee$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($2c6845a34a9d5bee$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $2c6845a34a9d5bee$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($2c6845a34a9d5bee$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($2c6845a34a9d5bee$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $2c6845a34a9d5bee$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}
class $2c6845a34a9d5bee$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
}
class $2c6845a34a9d5bee$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $2c6845a34a9d5bee$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $2c6845a34a9d5bee$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $2c6845a34a9d5bee$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        $2c6845a34a9d5bee$var$onRequestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
let $2c6845a34a9d5bee$var$wrappedEmit;
let $2c6845a34a9d5bee$var$_takeFullSnapshot;
const $2c6845a34a9d5bee$var$mirror = $2c6845a34a9d5bee$var$createMirror();
function $2c6845a34a9d5bee$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $2c6845a34a9d5bee$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $2c6845a34a9d5bee$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $2c6845a34a9d5bee$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $2c6845a34a9d5bee$var$wrappedEmit = (r, isCheckout)=>{
        const e = r;
        e.timestamp = $2c6845a34a9d5bee$var$nowTimestamp();
        if ((0, $93a581f0a1baade9$export$3cc482e6b02f32f7)([
            $2c6845a34a9d5bee$var$mutationBuffers,
            "access",
            (_)=>_[0],
            "optionalAccess",
            (_2)=>_2.isFrozen,
            "call",
            (_3)=>_3()
        ]) && e.type !== $2c6845a34a9d5bee$var$EventType.FullSnapshot && !(e.type === $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot && e.data.source === $2c6845a34a9d5bee$var$IncrementalSource.Mutation)) $2c6845a34a9d5bee$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $93a581f0a1baade9$export$3cc482e6b02f32f7)([
            emit,
            "optionalCall",
            (_4)=>_4(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e.type === $2c6845a34a9d5bee$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $2c6845a34a9d5bee$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $2c6845a34a9d5bee$var$wrappedEmit({
            type: $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot,
            data: {
                source: $2c6845a34a9d5bee$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$2c6845a34a9d5bee$var$wrappedEmit({
            type: $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot,
            data: {
                source: $2c6845a34a9d5bee$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$2c6845a34a9d5bee$var$wrappedEmit({
            type: $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot,
            data: {
                source: $2c6845a34a9d5bee$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a)=>$2c6845a34a9d5bee$var$wrappedEmit({
            type: $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot,
            data: {
                source: $2c6845a34a9d5bee$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        });
    const stylesheetManager = new $2c6845a34a9d5bee$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $2c6845a34a9d5bee$var$IframeManagerNoop() : new $2c6845a34a9d5bee$var$IframeManager({
        mirror: $2c6845a34a9d5bee$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $2c6845a34a9d5bee$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $2c6845a34a9d5bee$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $2c6845a34a9d5bee$var$ProcessedNodeManager();
    const canvasManager = $2c6845a34a9d5bee$var$_getCanvasManager(getCanvasManager, {
        mirror: $2c6845a34a9d5bee$var$mirror,
        win: window,
        mutationCb: (p)=>$2c6845a34a9d5bee$var$wrappedEmit({
                type: $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot,
                data: {
                    source: $2c6845a34a9d5bee$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $2c6845a34a9d5bee$var$ShadowDomManagerNoop() : new $2c6845a34a9d5bee$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $2c6845a34a9d5bee$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        $2c6845a34a9d5bee$var$wrappedEmit({
            type: $2c6845a34a9d5bee$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $2c6845a34a9d5bee$var$getWindowWidth(),
                height: $2c6845a34a9d5bee$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $2c6845a34a9d5bee$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $2c6845a34a9d5bee$var$snapshot(document, {
            mirror: $2c6845a34a9d5bee$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($2c6845a34a9d5bee$var$isSerializedIframe(n, $2c6845a34a9d5bee$var$mirror)) iframeManager.addIframe(n);
                if ($2c6845a34a9d5bee$var$isSerializedStylesheet(n, $2c6845a34a9d5bee$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($2c6845a34a9d5bee$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $2c6845a34a9d5bee$var$wrappedEmit({
            type: $2c6845a34a9d5bee$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $2c6845a34a9d5bee$var$getWindowScroll(window)
            }
        });
        $2c6845a34a9d5bee$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $2c6845a34a9d5bee$var$mirror.getId(document));
    };
    $2c6845a34a9d5bee$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $2c6845a34a9d5bee$var$callbackWrapper($2c6845a34a9d5bee$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$2c6845a34a9d5bee$var$wrappedEmit({
                        type: $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$2c6845a34a9d5bee$var$wrappedEmit({
                        type: $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2c6845a34a9d5bee$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$2c6845a34a9d5bee$var$wrappedEmit({
                        type: $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2c6845a34a9d5bee$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v)=>$2c6845a34a9d5bee$var$wrappedEmit({
                        type: $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2c6845a34a9d5bee$var$IncrementalSource.Input,
                            ...v
                        }
                    }),
                mediaInteractionCb: (p)=>$2c6845a34a9d5bee$var$wrappedEmit({
                        type: $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2c6845a34a9d5bee$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r)=>$2c6845a34a9d5bee$var$wrappedEmit({
                        type: $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2c6845a34a9d5bee$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    }),
                styleDeclarationCb: (r)=>$2c6845a34a9d5bee$var$wrappedEmit({
                        type: $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2c6845a34a9d5bee$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$2c6845a34a9d5bee$var$wrappedEmit({
                        type: $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2c6845a34a9d5bee$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $2c6845a34a9d5bee$var$wrappedEmit({
                        type: $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2c6845a34a9d5bee$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c)=>{
                    $2c6845a34a9d5bee$var$wrappedEmit({
                        type: $2c6845a34a9d5bee$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $2c6845a34a9d5bee$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $2c6845a34a9d5bee$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $93a581f0a1baade9$export$3cc482e6b02f32f7)([
                    plugins,
                    "optionalAccess",
                    (_5)=>_5.filter,
                    "call",
                    (_6)=>_6((p)=>p.observer),
                    "optionalAccess",
                    (_7)=>_7.map,
                    "call",
                    (_8)=>_8((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>$2c6845a34a9d5bee$var$wrappedEmit({
                                        type: $2c6845a34a9d5bee$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    })
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($2c6845a34a9d5bee$var$on("DOMContentLoaded", ()=>{
                $2c6845a34a9d5bee$var$wrappedEmit({
                    type: $2c6845a34a9d5bee$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($2c6845a34a9d5bee$var$on("load", ()=>{
                $2c6845a34a9d5bee$var$wrappedEmit({
                    type: $2c6845a34a9d5bee$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $2c6845a34a9d5bee$var$_takeFullSnapshot = undefined;
            $2c6845a34a9d5bee$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $2c6845a34a9d5bee$var$takeFullSnapshot(isCheckout) {
    if (!$2c6845a34a9d5bee$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $2c6845a34a9d5bee$var$_takeFullSnapshot(isCheckout);
}
$2c6845a34a9d5bee$var$record.mirror = $2c6845a34a9d5bee$var$mirror;
$2c6845a34a9d5bee$var$record.takeFullSnapshot = $2c6845a34a9d5bee$var$takeFullSnapshot;
function $2c6845a34a9d5bee$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $2c6845a34a9d5bee$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn("Unable to initialize CanvasManager");
        return new $2c6845a34a9d5bee$var$CanvasManagerNoop();
    }
}
const $2c6845a34a9d5bee$var$ReplayEventTypeIncrementalSnapshot = 3;
const $2c6845a34a9d5bee$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $2c6845a34a9d5bee$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $2c6845a34a9d5bee$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $2c6845a34a9d5bee$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $2c6845a34a9d5bee$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $13f5bb06d3146fad$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === "console";
    });
}
const $2c6845a34a9d5bee$var$INTERACTIVE_SELECTOR = "button,a";
/** Get the closest interactive parent element, or else return the given element. */ function $2c6845a34a9d5bee$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($2c6845a34a9d5bee$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $2c6845a34a9d5bee$var$getClickTargetNode(event) {
    const target = $2c6845a34a9d5bee$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $2c6845a34a9d5bee$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $2c6845a34a9d5bee$var$getTargetNode(event) {
    if ($2c6845a34a9d5bee$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $2c6845a34a9d5bee$var$isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
let $2c6845a34a9d5bee$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $2c6845a34a9d5bee$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$2c6845a34a9d5bee$var$handlers) {
        $2c6845a34a9d5bee$var$handlers = [];
        $2c6845a34a9d5bee$var$monkeyPatchWindowOpen();
    }
    $2c6845a34a9d5bee$var$handlers.push(cb);
    return ()=>{
        const pos = $2c6845a34a9d5bee$var$handlers ? $2c6845a34a9d5bee$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $2c6845a34a9d5bee$var$handlers.splice(pos, 1);
    };
}
function $2c6845a34a9d5bee$var$monkeyPatchWindowOpen() {
    (0, $3573f39c9e00bebb$export$9563e054e6f787fb)($2c6845a34a9d5bee$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($2c6845a34a9d5bee$var$handlers) try {
                $2c6845a34a9d5bee$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($2c6845a34a9d5bee$var$WINDOW, args);
        };
    });
}
/** Handle a click. */ function $2c6845a34a9d5bee$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $2c6845a34a9d5bee$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $2c6845a34a9d5bee$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $2c6845a34a9d5bee$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $2c6845a34a9d5bee$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($2c6845a34a9d5bee$var$ignoreElement(node, this._ignoreSelector) || !$2c6845a34a9d5bee$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $2c6845a34a9d5bee$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $2c6845a34a9d5bee$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $2c6845a34a9d5bee$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $2c6845a34a9d5bee$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $2c6845a34a9d5bee$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $2c6845a34a9d5bee$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $2c6845a34a9d5bee$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = setTimeout(()=>this._checkClicks(), 1000);
    }
}
const $2c6845a34a9d5bee$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
/** exported for tests only */ function $2c6845a34a9d5bee$var$ignoreElement(node, ignoreSelector) {
    if (!$2c6845a34a9d5bee$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $2c6845a34a9d5bee$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $2c6845a34a9d5bee$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $2c6845a34a9d5bee$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$2c6845a34a9d5bee$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if (source === $2c6845a34a9d5bee$var$IncrementalSource.Mutation) clickDetector.registerMutation(event.timestamp);
        if (source === $2c6845a34a9d5bee$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($2c6845a34a9d5bee$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $2c6845a34a9d5bee$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $2c6845a34a9d5bee$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $2c6845a34a9d5bee$var$isIncrementalEvent(event) {
    return event.type === $2c6845a34a9d5bee$var$ReplayEventTypeIncrementalSnapshot;
}
function $2c6845a34a9d5bee$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $2c6845a34a9d5bee$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $2c6845a34a9d5bee$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: "default",
        ...breadcrumb
    };
}
var $2c6845a34a9d5bee$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($2c6845a34a9d5bee$var$NodeType || ($2c6845a34a9d5bee$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $2c6845a34a9d5bee$var$ATTRIBUTES_TO_RECORD = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $2c6845a34a9d5bee$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($2c6845a34a9d5bee$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $2c6845a34a9d5bee$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $2c6845a34a9d5bee$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $2c6845a34a9d5bee$var$handleClick(replay.clickDetector, result, $2c6845a34a9d5bee$var$getClickTargetNode(handlerData.event));
        $2c6845a34a9d5bee$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $2c6845a34a9d5bee$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $2c6845a34a9d5bee$var$record.mirror.getId(target);
    const node = nodeId && $2c6845a34a9d5bee$var$record.mirror.getNode(nodeId);
    const meta = node && $2c6845a34a9d5bee$var$record.mirror.getMeta(node);
    const element = meta && $2c6845a34a9d5bee$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $2c6845a34a9d5bee$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(""),
                attributes: $2c6845a34a9d5bee$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $2c6845a34a9d5bee$var$handleDom(handlerData) {
    const { target: target, message: message } = $2c6845a34a9d5bee$var$getDomTarget(handlerData);
    return $2c6845a34a9d5bee$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$2c6845a34a9d5bee$var$getBaseDomBreadcrumb(target, message)
    });
}
function $2c6845a34a9d5bee$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $2c6845a34a9d5bee$var$getClickTargetNode(handlerData.event) : $2c6845a34a9d5bee$var$getTargetNode(handlerData.event);
        message = (0, $6e7a6d8500b7a471$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $2c6845a34a9d5bee$var$isElement(node) {
    return node.type === $2c6845a34a9d5bee$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $2c6845a34a9d5bee$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $2c6845a34a9d5bee$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $2c6845a34a9d5bee$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $2c6845a34a9d5bee$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $2c6845a34a9d5bee$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $6e7a6d8500b7a471$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $2c6845a34a9d5bee$var$getBaseDomBreadcrumb(target, message);
    return $2c6845a34a9d5bee$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $2c6845a34a9d5bee$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $2c6845a34a9d5bee$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $2c6845a34a9d5bee$var$createResourceEntry,
    paint: $2c6845a34a9d5bee$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $2c6845a34a9d5bee$var$createNavigationEntry
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $2c6845a34a9d5bee$var$createPerformanceEntries(entries) {
    return entries.map($2c6845a34a9d5bee$var$createPerformanceEntry).filter(Boolean);
}
function $2c6845a34a9d5bee$var$createPerformanceEntry(entry) {
    if (!$2c6845a34a9d5bee$var$ENTRY_TYPES[entry.entryType]) return null;
    return $2c6845a34a9d5bee$var$ENTRY_TYPES[entry.entryType](entry);
}
function $2c6845a34a9d5bee$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $7f221ab95ceb1d0f$export$baf075a948ffc0bf) || $2c6845a34a9d5bee$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $2c6845a34a9d5bee$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $2c6845a34a9d5bee$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $2c6845a34a9d5bee$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $2c6845a34a9d5bee$var$getAbsoluteTime(startTime),
        end: $2c6845a34a9d5bee$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $2c6845a34a9d5bee$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $2c6845a34a9d5bee$var$getAbsoluteTime(startTime),
        end: $2c6845a34a9d5bee$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on an LCP metric.
 */ function $2c6845a34a9d5bee$var$getLargestContentfulPaint(metric) {
    const entries = metric.entries;
    const lastEntry = entries[entries.length - 1];
    const element = lastEntry ? lastEntry.element : undefined;
    const value = metric.value;
    const end = $2c6845a34a9d5bee$var$getAbsoluteTime(value);
    const data = {
        type: "largest-contentful-paint",
        name: "largest-contentful-paint",
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            nodeId: element ? $2c6845a34a9d5bee$var$record.mirror.getId(element) : undefined
        }
    };
    return data;
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $2c6845a34a9d5bee$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $f711f072777a2234$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $f711f072777a2234$export$3fd4b53331200102)(({ metric: metric })=>{
        replay.replayPerformanceEntries.push($2c6845a34a9d5bee$var$getLargestContentfulPaint(metric));
    }));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $2c6845a34a9d5bee$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const $2c6845a34a9d5bee$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $2c6845a34a9d5bee$var$e() {
    const e = new Blob([
        $2c6845a34a9d5bee$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function $2c6845a34a9d5bee$var$logInfo(message, shouldAddBreadcrumb) {
    if (!$2c6845a34a9d5bee$var$DEBUG_BUILD) return;
    (0, $04de90e46e565a98$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) $2c6845a34a9d5bee$var$addLogBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function $2c6845a34a9d5bee$var$logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!$2c6845a34a9d5bee$var$DEBUG_BUILD) return;
    (0, $04de90e46e565a98$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(()=>{
        $2c6845a34a9d5bee$var$addLogBreadcrumb(message);
    }, 0);
}
function $2c6845a34a9d5bee$var$addLogBreadcrumb(message) {
    (0, $15458dde2c60d92b$export$efda9a273d7a036d)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: "info",
        message: message
    }, {
        level: "info"
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $2c6845a34a9d5bee$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$2c6845a34a9d5bee$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $2c6845a34a9d5bee$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $2c6845a34a9d5bee$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $2c6845a34a9d5bee$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $2c6845a34a9d5bee$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $2c6845a34a9d5bee$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $2c6845a34a9d5bee$var$logInfo("[Replay] Destroying compression worker");
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener("message", listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).error("[Replay]", response.response);
                    reject(new Error("Error in compression worker"));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener("message", listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $2c6845a34a9d5bee$var$EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new $2c6845a34a9d5bee$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $2c6845a34a9d5bee$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $2c6845a34a9d5bee$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $2c6845a34a9d5bee$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage("clear").then(null, (e)=>{
            $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn('[Replay] Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $2c6845a34a9d5bee$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $2c6845a34a9d5bee$var$EventBufferArray();
        this._compression = new $2c6845a34a9d5bee$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $2c6845a34a9d5bee$var$logInfo("[Replay] Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("[Replay] Failed to add events when switching buffers.", error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $2c6845a34a9d5bee$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $2c6845a34a9d5bee$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $2c6845a34a9d5bee$var$logInfo("[Replay] Using simple buffer");
    return new $2c6845a34a9d5bee$var$EventBufferArray();
}
function $2c6845a34a9d5bee$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $2c6845a34a9d5bee$var$_getWorkerUrl();
        if (!workerUrl) return;
        $2c6845a34a9d5bee$var$logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $2c6845a34a9d5bee$var$EventBufferProxy(worker);
    } catch (error) {
        $2c6845a34a9d5bee$var$logInfo("[Replay] Failed to create compression worker");
    // Fall back to use simple event buffer array
    }
}
function $2c6845a34a9d5bee$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $2c6845a34a9d5bee$var$e();
    return "";
}
/** If sessionStorage is available. */ function $2c6845a34a9d5bee$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return "sessionStorage" in $2c6845a34a9d5bee$var$WINDOW && !!$2c6845a34a9d5bee$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $2c6845a34a9d5bee$var$clearSession(replay) {
    $2c6845a34a9d5bee$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $2c6845a34a9d5bee$var$deleteSession() {
    if (!$2c6845a34a9d5bee$var$hasSessionStorage()) return;
    try {
        $2c6845a34a9d5bee$var$WINDOW.sessionStorage.removeItem($2c6845a34a9d5bee$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $2c6845a34a9d5bee$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $2c6845a34a9d5bee$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $3801c6184ad1b674$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $2c6845a34a9d5bee$var$saveSession(session) {
    if (!$2c6845a34a9d5bee$var$hasSessionStorage()) return;
    try {
        $2c6845a34a9d5bee$var$WINDOW.sessionStorage.setItem($2c6845a34a9d5bee$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $2c6845a34a9d5bee$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $2c6845a34a9d5bee$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $2c6845a34a9d5bee$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $2c6845a34a9d5bee$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $2c6845a34a9d5bee$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $2c6845a34a9d5bee$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $2c6845a34a9d5bee$var$fetchSession(traceInternals) {
    if (!$2c6845a34a9d5bee$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $2c6845a34a9d5bee$var$WINDOW.sessionStorage.getItem($2c6845a34a9d5bee$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $2c6845a34a9d5bee$var$logInfoNextTick("[Replay] Loading existing session", traceInternals);
        return $2c6845a34a9d5bee$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $2c6845a34a9d5bee$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $2c6845a34a9d5bee$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $2c6845a34a9d5bee$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $2c6845a34a9d5bee$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $2c6845a34a9d5bee$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$2c6845a34a9d5bee$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $2c6845a34a9d5bee$var$loadOrCreateSession({ traceInternals: traceInternals, sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $2c6845a34a9d5bee$var$fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        $2c6845a34a9d5bee$var$logInfoNextTick("[Replay] Creating new session", traceInternals);
        return $2c6845a34a9d5bee$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$2c6845a34a9d5bee$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $2c6845a34a9d5bee$var$logInfoNextTick("[Replay] Session in sessionStorage is expired, creating new one...");
    return $2c6845a34a9d5bee$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $2c6845a34a9d5bee$var$isCustomEvent(event) {
    return event.type === $2c6845a34a9d5bee$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $2c6845a34a9d5bee$var$addEventSync(replay, event, isCheckout) {
    if (!$2c6845a34a9d5bee$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $2c6845a34a9d5bee$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $2c6845a34a9d5bee$var$addEvent(replay, event, isCheckout) {
    if (!$2c6845a34a9d5bee$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $2c6845a34a9d5bee$var$_addEvent(replay, event, isCheckout);
}
async function $2c6845a34a9d5bee$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === "buffer") replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $2c6845a34a9d5bee$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $2c6845a34a9d5bee$var$EventBufferSizeExceededError ? "addEventSizeExceeded" : "addEvent";
        $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).error(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
        if (client) client.recordDroppedEvent("internal_sdk_error", "replay");
    }
}
/** Exported only for tests. */ function $2c6845a34a9d5bee$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $2c6845a34a9d5bee$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $2c6845a34a9d5bee$var$logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function $2c6845a34a9d5bee$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $2c6845a34a9d5bee$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).error("[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...", error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function $2c6845a34a9d5bee$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $2c6845a34a9d5bee$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** If the event is an replay event */ function $2c6845a34a9d5bee$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
/** If the event is a feedback event */ function $2c6845a34a9d5bee$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $2c6845a34a9d5bee$var$handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = $2c6845a34a9d5bee$var$isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$2c6845a34a9d5bee$var$isErrorEvent(event) && !$2c6845a34a9d5bee$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        if ($2c6845a34a9d5bee$var$isTransactionEvent(event)) {
            $2c6845a34a9d5bee$var$handleTransactionEvent(replay, event);
            return;
        }
        $2c6845a34a9d5bee$var$handleErrorEvent(replay, event);
    };
}
function $2c6845a34a9d5bee$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $2c6845a34a9d5bee$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== "buffer" || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    setTimeout(()=>{
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
function $2c6845a34a9d5bee$var$isBaseTransportSend() {
    const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $2c6845a34a9d5bee$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$2c6845a34a9d5bee$var$isErrorEvent(event)) return;
        $2c6845a34a9d5bee$var$handleHydrationError(replay, event);
    };
}
function $2c6845a34a9d5bee$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $2c6845a34a9d5bee$var$createBreadcrumb({
            category: "replay.hydrate-error"
        });
        $2c6845a34a9d5bee$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $2c6845a34a9d5bee$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $2c6845a34a9d5bee$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $2c6845a34a9d5bee$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $2c6845a34a9d5bee$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $2c6845a34a9d5bee$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $2c6845a34a9d5bee$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $2c6845a34a9d5bee$var$handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? $2c6845a34a9d5bee$var$handleAfterSendEvent(replay) : undefined;
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($2c6845a34a9d5bee$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$2c6845a34a9d5bee$var$isErrorEvent(event) && !$2c6845a34a9d5bee$var$isTransactionEvent(event) && !$2c6845a34a9d5bee$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if ($2c6845a34a9d5bee$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $2c6845a34a9d5bee$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($2c6845a34a9d5bee$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).log("[Replay] Ignoring error from rrweb internals", event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $2c6845a34a9d5bee$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    }, {
        id: "Replay"
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $2c6845a34a9d5bee$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $2c6845a34a9d5bee$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $2c6845a34a9d5bee$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $2c6845a34a9d5bee$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $2c6845a34a9d5bee$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $2c6845a34a9d5bee$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $2c6845a34a9d5bee$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($2c6845a34a9d5bee$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $d99cf49ba4c3e0e5$export$d92e61f5600202af)(url, (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)());
}
/** Add a performance entry breadcrumb */ function $2c6845a34a9d5bee$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($2c6845a34a9d5bee$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $2c6845a34a9d5bee$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function $2c6845a34a9d5bee$var$handleFetch(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, fetchData: fetchData, response: response } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url } = fetchData;
    return {
        type: "resource.fetch",
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response ? response.status : undefined
        }
    };
}
/**
 * Returns a listener to be added to `addFetchInstrumentationHandler(listener)`.
 */ function $2c6845a34a9d5bee$var$handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $2c6845a34a9d5bee$var$handleFetch(handlerData);
        $2c6845a34a9d5bee$var$addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function $2c6845a34a9d5bee$var$handleXhr(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, xhr: xhr } = handlerData;
    const sentryXhrData = xhr[0, $1d16459f93df57a1$export$55b6bb1e45c6cf59];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url, status_code: statusCode } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: "resource.xhr",
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addXhrInstrumentationHandler(listener)`.
 */ function $2c6845a34a9d5bee$var$handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $2c6845a34a9d5bee$var$handleXhr(handlerData);
        $2c6845a34a9d5bee$var$addNetworkBreadcrumb(replay, result);
    };
}
/** Get the size of a body. */ function $2c6845a34a9d5bee$var$getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $2c6845a34a9d5bee$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $2c6845a34a9d5bee$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $2c6845a34a9d5bee$var$getBodyString(body) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $2c6845a34a9d5bee$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
/** Merge a warning into an existing network request/response. */ function $2c6845a34a9d5bee$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $2c6845a34a9d5bee$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $3573f39c9e00bebb$export$d25f2688db1bb433)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $2c6845a34a9d5bee$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $2c6845a34a9d5bee$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $2c6845a34a9d5bee$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $2c6845a34a9d5bee$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $2c6845a34a9d5bee$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $2c6845a34a9d5bee$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $2c6845a34a9d5bee$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $2c6845a34a9d5bee$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $2c6845a34a9d5bee$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e3) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $2c6845a34a9d5bee$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === "[" && last === "]" || first === "{" && last === "}";
}
/** Match an URL against a list of strings/Regex. */ function $2c6845a34a9d5bee$var$urlMatches(url, urls) {
    const fullUrl = $2c6845a34a9d5bee$var$getFullUrl(url);
    return (0, $f28175ac6747d0c5$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $2c6845a34a9d5bee$var$getFullUrl(url, baseURI = $2c6845a34a9d5bee$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($2c6845a34a9d5bee$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $2c6845a34a9d5bee$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $2c6845a34a9d5bee$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $2c6845a34a9d5bee$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $2c6845a34a9d5bee$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).error("[Replay] Failed to capture fetch breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $2c6845a34a9d5bee$var$enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input: input, response: response } = hint;
    const body = input ? $2c6845a34a9d5bee$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $2c6845a34a9d5bee$var$getBodySize(body, options.textEncoder);
    const resSize = response ? $2c6845a34a9d5bee$var$parseContentLengthHeader(response.headers.get("content-length")) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $2c6845a34a9d5bee$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $2c6845a34a9d5bee$var$urlMatches(url, options.networkDetailAllowUrls) && !$2c6845a34a9d5bee$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $2c6845a34a9d5bee$var$_getRequestInfo(options, hint.input, requestBodySize) : $2c6845a34a9d5bee$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $2c6845a34a9d5bee$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $2c6845a34a9d5bee$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $2c6845a34a9d5bee$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $2c6845a34a9d5bee$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $2c6845a34a9d5bee$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $2c6845a34a9d5bee$var$getBodyString(requestBody);
    const data = $2c6845a34a9d5bee$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $2c6845a34a9d5bee$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $2c6845a34a9d5bee$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $2c6845a34a9d5bee$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $2c6845a34a9d5bee$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $2c6845a34a9d5bee$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $2c6845a34a9d5bee$var$_parseFetchResponseBody(response);
    const result = $2c6845a34a9d5bee$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        textEncoder: textEncoder,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $2c6845a34a9d5bee$var$mergeWarning(result, warning);
    return result;
}
function $2c6845a34a9d5bee$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $2c6845a34a9d5bee$var$getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return $2c6845a34a9d5bee$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $2c6845a34a9d5bee$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $2c6845a34a9d5bee$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("[Replay] Failed to serialize response body", error);
        // fallback
        return $2c6845a34a9d5bee$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $2c6845a34a9d5bee$var$_parseFetchResponseBody(response) {
    const res = $2c6845a34a9d5bee$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $2c6845a34a9d5bee$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("[Replay] Failed to get text body from response", error);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $2c6845a34a9d5bee$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== "object") return undefined;
    return fetchArgs[1].body;
}
function $2c6845a34a9d5bee$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $2c6845a34a9d5bee$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $2c6845a34a9d5bee$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $2c6845a34a9d5bee$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $2c6845a34a9d5bee$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $2c6845a34a9d5bee$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $2c6845a34a9d5bee$var$getAllowedHeaders(headers, allowedHeaders);
}
function $2c6845a34a9d5bee$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("[Replay] Failed to clone response body", error);
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $2c6845a34a9d5bee$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = setTimeout(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $2c6845a34a9d5bee$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $2c6845a34a9d5bee$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $2c6845a34a9d5bee$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $2c6845a34a9d5bee$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $2c6845a34a9d5bee$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $2c6845a34a9d5bee$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).error("[Replay] Failed to capture xhr breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $2c6845a34a9d5bee$var$enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $2c6845a34a9d5bee$var$getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader("content-length") ? $2c6845a34a9d5bee$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $2c6845a34a9d5bee$var$_getBodySize(xhr.response, xhr.responseType, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $2c6845a34a9d5bee$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$2c6845a34a9d5bee$var$urlMatches(url, options.networkDetailAllowUrls) || $2c6845a34a9d5bee$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $2c6845a34a9d5bee$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $2c6845a34a9d5bee$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $1d16459f93df57a1$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $2c6845a34a9d5bee$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $2c6845a34a9d5bee$var$getAllowedHeaders($2c6845a34a9d5bee$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $2c6845a34a9d5bee$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $2c6845a34a9d5bee$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $2c6845a34a9d5bee$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $2c6845a34a9d5bee$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $2c6845a34a9d5bee$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $2c6845a34a9d5bee$var$mergeWarning(response, responseWarning) : response
    };
}
function $2c6845a34a9d5bee$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $2c6845a34a9d5bee$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $2c6845a34a9d5bee$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("[Replay] Failed to get xhr response body", ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $2c6845a34a9d5bee$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && body && typeof body === "object") return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $2c6845a34a9d5bee$var$_getBodySize(body, responseType, textEncoder) {
    try {
        const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
        return $2c6845a34a9d5bee$var$getBodySize(bodyStr, textEncoder);
    } catch (e3) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $2c6845a34a9d5bee$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$2c6845a34a9d5bee$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, $0ebf475f67650c89$export$f75d3c772c923df0)($2c6845a34a9d5bee$var$handleFetchSpanListener(replay));
            (0, $1d16459f93df57a1$export$26ace48dd54c9aea)($2c6845a34a9d5bee$var$handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $2c6845a34a9d5bee$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($2c6845a34a9d5bee$var$_isXhrBreadcrumb(breadcrumb) && $2c6845a34a9d5bee$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $2c6845a34a9d5bee$var$enrichXhrBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $2c6845a34a9d5bee$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($2c6845a34a9d5bee$var$_isFetchBreadcrumb(breadcrumb) && $2c6845a34a9d5bee$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $2c6845a34a9d5bee$var$enrichFetchBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $2c6845a34a9d5bee$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("Error when enriching network breadcrumb");
    }
}
function $2c6845a34a9d5bee$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $2c6845a34a9d5bee$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $2c6845a34a9d5bee$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $2c6845a34a9d5bee$var$_isFetchHint(hint) {
    return hint && hint.response;
}
let $2c6845a34a9d5bee$var$_LAST_BREADCRUMB = null;
function $2c6845a34a9d5bee$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
const $2c6845a34a9d5bee$var$handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = $2c6845a34a9d5bee$var$handleScope(scope);
        if (!result) return;
        $2c6845a34a9d5bee$var$addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function $2c6845a34a9d5bee$var$handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if ($2c6845a34a9d5bee$var$_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    $2c6845a34a9d5bee$var$_LAST_BREADCRUMB = newBreadcrumb;
    if (!$2c6845a34a9d5bee$var$isBreadcrumbWithCategory(newBreadcrumb) || [
        "fetch",
        "xhr",
        "sentry.event",
        "sentry.transaction"
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith("ui.")) return null;
    if (newBreadcrumb.category === "console") return $2c6845a34a9d5bee$var$normalizeConsoleBreadcrumb(newBreadcrumb);
    return $2c6845a34a9d5bee$var$createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function $2c6845a34a9d5bee$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $2c6845a34a9d5bee$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $2c6845a34a9d5bee$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $2c6845a34a9d5bee$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $13f5bb06d3146fad$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $2c6845a34a9d5bee$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $2c6845a34a9d5bee$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $2c6845a34a9d5bee$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function $2c6845a34a9d5bee$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, $15458dde2c60d92b$export$c7be4b0125a10cba)();
    const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
    scope.addScopeListener($2c6845a34a9d5bee$var$handleScopeListener(replay));
    (0, $8ceebd0242a3a56c$export$5aeffd3db2cf9df7)($2c6845a34a9d5bee$var$handleDomListener(replay));
    (0, $25558ab1f79d7e77$export$3f18c56c58114e75)($2c6845a34a9d5bee$var$handleHistorySpanListener(replay));
    $2c6845a34a9d5bee$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $2c6845a34a9d5bee$var$handleGlobalEventListener(replay, !$2c6845a34a9d5bee$var$hasHooks(client));
    if (client && client.addEventProcessor) client.addEventProcessor(eventProcessor);
    else (0, $2de82d876e342b72$export$9aac0b9f77928fbf)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if ($2c6845a34a9d5bee$var$hasHooks(client)) {
        client.on("beforeSendEvent", $2c6845a34a9d5bee$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $2c6845a34a9d5bee$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("startTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on("finishTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We want to flush replay
        client.on("beforeSendFeedback", (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2c6845a34a9d5bee$var$hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $2c6845a34a9d5bee$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($2c6845a34a9d5bee$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $2c6845a34a9d5bee$var$createMemoryEntry($2c6845a34a9d5bee$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $2c6845a34a9d5bee$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $2c6845a34a9d5bee$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $2c6845a34a9d5bee$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).warn("[Replay] Received replay event after session expired.");
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $2c6845a34a9d5bee$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$2c6845a34a9d5bee$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $2c6845a34a9d5bee$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === "buffer" && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $2c6845a34a9d5bee$var$logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $2c6845a34a9d5bee$var$saveSession(replay.session);
                }
            }
            if (replay.recordingMode === "session") // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $2c6845a34a9d5bee$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $2c6845a34a9d5bee$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $2c6845a34a9d5bee$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $2c6845a34a9d5bee$var$addEventSync(replay, $2c6845a34a9d5bee$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $2c6845a34a9d5bee$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $a7dd6b8d5d1f9a4e$export$f93f7f385160c44e)((0, $a7dd6b8d5d1f9a4e$export$92b6093782fe661b)(replayEvent, (0, $a7dd6b8d5d1f9a4e$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $2c6845a34a9d5bee$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $2c6845a34a9d5bee$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === "object" && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    if (client.emit) client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $e0529c7e0a1e5be4$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $6ea9c05e188f19de$export$68f3af03034c9e90)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0"
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $2c6845a34a9d5bee$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $2c6845a34a9d5bee$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
    const scope = (0, $15458dde2c60d92b$export$c7be4b0125a10cba)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: $2c6845a34a9d5bee$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $2c6845a34a9d5bee$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "replay", baseEvent);
        $2c6845a34a9d5bee$var$logInfo("An event processor returned `null`, will not send event.");
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $2c6845a34a9d5bee$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($2c6845a34a9d5bee$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $2c6845a34a9d5bee$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $abd63e7b0ecf3c92$export$699aff705e0d49d4)({}, response);
    if ((0, $abd63e7b0ecf3c92$export$6c91fec22056810a)(rateLimits, "replay")) throw new $2c6845a34a9d5bee$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $2c6845a34a9d5bee$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $2c6845a34a9d5bee$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $2c6845a34a9d5bee$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $2c6845a34a9d5bee$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $2c6845a34a9d5bee$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $2c6845a34a9d5bee$var$TransportStatusCodeError || err instanceof $2c6845a34a9d5bee$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $15458dde2c60d92b$export$2f04de43fe27971a)("Replays", {
            _retryCount: retryConfig.count
        });
        if ($2c6845a34a9d5bee$var$DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) (0, $15458dde2c60d92b$export$f5282963edea4a68)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $2c6845a34a9d5bee$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$2c6845a34a9d5bee$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $2c6845a34a9d5bee$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $2c6845a34a9d5bee$var$THROTTLED = "__THROTTLED";
const $2c6845a34a9d5bee$var$SKIPPED = "__SKIPPED";
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2c6845a34a9d5bee$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $2c6845a34a9d5bee$var$SKIPPED : $2c6845a34a9d5bee$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $2c6845a34a9d5bee$var$ReplayContainer {
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $2c6845a34a9d5bee$var$ReplayContainer.prototype.__init.call(this);
        $2c6845a34a9d5bee$var$ReplayContainer.prototype.__init2.call(this);
        $2c6845a34a9d5bee$var$ReplayContainer.prototype.__init3.call(this);
        $2c6845a34a9d5bee$var$ReplayContainer.prototype.__init4.call(this);
        $2c6845a34a9d5bee$var$ReplayContainer.prototype.__init5.call(this);
        $2c6845a34a9d5bee$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $2c6845a34a9d5bee$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $2c6845a34a9d5bee$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $2c6845a34a9d5bee$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $2c6845a34a9d5bee$var$throttle((event, isCheckout)=>$2c6845a34a9d5bee$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($2c6845a34a9d5bee$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $2c6845a34a9d5bee$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $2c6845a34a9d5bee$var$ClickDetector(this, slowClickConfig);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $2c6845a34a9d5bee$var$logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") throw new Error("Replay recording is already in progress");
        if (this._isEnabled && this.recordingMode === "buffer") throw new Error("Replay buffering is in progress, call `flush()` to save the replay");
        $2c6845a34a9d5bee$var$logInfoNextTick("[Replay] Starting replay in session mode", this._options._experiments.traceInternals);
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $2c6845a34a9d5bee$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error("Replay recording is already in progress");
        $2c6845a34a9d5bee$var$logInfoNextTick("[Replay] Starting replay in buffer mode", this._options._experiments.traceInternals);
        const session = $2c6845a34a9d5bee$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $2c6845a34a9d5bee$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" && {
                    checkoutEveryNms: $2c6845a34a9d5bee$var$BUFFER_CHECKOUT_TIME
                },
                emit: $2c6845a34a9d5bee$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $2c6845a34a9d5bee$var$logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ""}`, this._options._experiments.traceInternals);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $2c6845a34a9d5bee$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $2c6845a34a9d5bee$var$logInfo("[Replay] Pausing replay", this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $2c6845a34a9d5bee$var$logInfo("[Replay] Resuming replay", this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $2c6845a34a9d5bee$var$logInfo("[Replay] Converting buffer to session", this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === "session") return;
        // Re-start recording in session-mode
        this.recordingMode = "session";
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === "buffer") return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $2c6845a34a9d5bee$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$2c6845a34a9d5bee$var$WINDOW.location.pathname}${$2c6845a34a9d5bee$var$WINDOW.location.hash}${$2c6845a34a9d5bee$var$WINDOW.location.search}`;
        const url = `${$2c6845a34a9d5bee$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $2c6845a34a9d5bee$var$THROTTLED) {
            const breadcrumb = $2c6845a34a9d5bee$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$2c6845a34a9d5bee$var$addEventSync(this, {
                    type: $2c6845a34a9d5bee$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        // eslint-disable-next-line deprecation/deprecation
        const lastTransaction = this.lastTransaction || (0, $15458dde2c60d92b$export$c7be4b0125a10cba)().getTransaction();
        const attributes = lastTransaction && (0, $4a255e6465f9994f$export$92d8c23565496537)(lastTransaction).data || {};
        const source = attributes[0, $2a38ddd8bc83e514$export$d7a7d984b0791405];
        if (!lastTransaction || !source || ![
            "route",
            "custom"
        ].includes(source)) return undefined;
        return (0, $4a255e6465f9994f$export$92d8c23565496537)(lastTransaction).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $2c6845a34a9d5bee$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).error("[Replay]", error);
        if ($2c6845a34a9d5bee$var$DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) (0, $15458dde2c60d92b$export$f5282963edea4a68)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $2c6845a34a9d5bee$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($2c6845a34a9d5bee$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "refresh session"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $2c6845a34a9d5bee$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $2c6845a34a9d5bee$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $2c6845a34a9d5bee$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $2c6845a34a9d5bee$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $2c6845a34a9d5bee$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        this._performanceCleanupCallback = $2c6845a34a9d5bee$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $2c6845a34a9d5bee$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $2c6845a34a9d5bee$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $2c6845a34a9d5bee$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $2c6845a34a9d5bee$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($2c6845a34a9d5bee$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $2c6845a34a9d5bee$var$createBreadcrumb({
                category: "ui.blur"
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $2c6845a34a9d5bee$var$createBreadcrumb({
                category: "ui.focus"
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $2c6845a34a9d5bee$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $2c6845a34a9d5bee$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $2c6845a34a9d5bee$var$logInfo("[Replay] Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $2c6845a34a9d5bee$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        const performanceEntries = $2c6845a34a9d5bee$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        return Promise.all($2c6845a34a9d5bee$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).error("[Replay] No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $2c6845a34a9d5bee$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error("Session is too long, not sending replay");
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $2c6845a34a9d5bee$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: timestamp
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: "sendReplay"
            });
            const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
            if (client) client.recordDroppedEvent("send_error", "replay");
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).error("[Replay] Attempting to finish replay event after session expired.");
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $2c6845a34a9d5bee$var$logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`, this._options._experiments.traceInternals);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $2c6845a34a9d5bee$var$logInfo("[Replay] Flushing initial segment without checkout.", this._options._experiments.traceInternals);
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                $2c6845a34a9d5bee$var$DEBUG_BUILD && (0, $04de90e46e565a98$export$af88d00dbe7f521).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $2c6845a34a9d5bee$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $2c6845a34a9d5bee$var$createBreadcrumb({
                    category: "replay.mutations",
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: "mutationLimit",
                    forceFlush: this.recordingMode === "session"
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $2c6845a34a9d5bee$var$getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === "string" ? deprecatedSelectorOption.split(",") : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== "undefined") {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === "string") allSelectors.push(`.${deprecatedClassOption}`);
        (0, $04de90e46e565a98$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.");
        });
    }
    return allSelectors.join(",");
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $2c6845a34a9d5bee$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore, blockClass: // eslint-disable-next-line deprecation/deprecation
blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
blockSelector, maskTextClass: // eslint-disable-next-line deprecation/deprecation
maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
ignoreClass }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $2c6845a34a9d5bee$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = $2c6845a34a9d5bee$var$getOption(unmask, [
        ".sentry-unmask",
        "[data-sentry-unmask]"
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $2c6845a34a9d5bee$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: $2c6845a34a9d5bee$var$getOption(unblock, [
            ".sentry-unblock",
            "[data-sentry-unblock]"
        ]),
        ignoreSelector: $2c6845a34a9d5bee$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $2c6845a34a9d5bee$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "")) return value.replace(/[\S]/g, "*");
    return value;
}
const $2c6845a34a9d5bee$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $2c6845a34a9d5bee$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
let $2c6845a34a9d5bee$var$_initialized = false;
const $2c6845a34a9d5bee$export$2832a2ae028f5e28 = (options)=>{
    // eslint-disable-next-line deprecation/deprecation
    return new $2c6845a34a9d5bee$export$6b59b88de1ff9cb7(options);
};
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 * @deprecated Use `replayIntegration()` instead.
 */ class $2c6845a34a9d5bee$export$6b59b88de1ff9cb7 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Replay";
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $2c6845a34a9d5bee$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $2c6845a34a9d5bee$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $2c6845a34a9d5bee$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $2c6845a34a9d5bee$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, sessionSampleRate: sessionSampleRate, errorSampleRate: errorSampleRate, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, blockClass: // eslint-disable-next-line deprecation/deprecation
    blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
    blockSelector, maskInputOptions: // eslint-disable-next-line deprecation/deprecation
    maskInputOptions, maskTextClass: // eslint-disable-next-line deprecation/deprecation
    maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
    maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
    ignoreClass } = {}){
        // eslint-disable-next-line deprecation/deprecation
        this.name = $2c6845a34a9d5bee$export$6b59b88de1ff9cb7.id;
        const privacyOptions = $2c6845a34a9d5bee$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            ignoreClass: ignoreClass
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$2c6845a34a9d5bee$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $2c6845a34a9d5bee$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $2c6845a34a9d5bee$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $2c6845a34a9d5bee$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $2c6845a34a9d5bee$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $2c6845a34a9d5bee$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$2c6845a34a9d5bee$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $ba79970519f89b28$export$4e09c449d6c407f7)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $2c6845a34a9d5bee$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $2c6845a34a9d5bee$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!(0, $ba79970519f89b28$export$4e09c449d6c407f7)()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === "session"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        // We have to run this in _initialize, because this runs in setTimeout
        // So when this runs all integrations have been added
        // Before this, we cannot access integrations on the client,
        // so we need to mutate the options here
        this._maybeLoadFromReplayCanvasIntegration();
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $2c6845a34a9d5bee$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $2c6845a34a9d5bee$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration() {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$2c6845a34a9d5bee$export$6b59b88de1ff9cb7.__initStatic();
/** Parse Replay-related options from SDK options */ function $2c6845a34a9d5bee$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $3573f39c9e00bebb$export$d25f2688db1bb433)(initialOptions)
    };
    if (!opt) {
        (0, $04de90e46e565a98$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("SDK client is not available.");
        });
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) (0, $04de90e46e565a98$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (typeof opt.replaysSessionSampleRate === "number") finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === "number") finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function $2c6845a34a9d5bee$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$2c6845a34a9d5bee$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ // eslint-disable-next-line deprecation/deprecation
function $2c6845a34a9d5bee$export$81cc0d0f72285d1() {
    const client = (0, $15458dde2c60d92b$export$6bb76d6eba7e258c)();
    return client && client.getIntegrationByName && client.getIntegrationByName("Replay");
}
// eslint-disable-next-line deprecation/deprecation
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $2c6845a34a9d5bee$export$b28310b2f161456b = $2c6845a34a9d5bee$export$81cc0d0f72285d1;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $2c6845a34a9d5bee$export$d7706faf7ab354bf = $2c6845a34a9d5bee$export$2832a2ae028f5e28;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ // eslint-disable-next-line deprecation/deprecation
class $2c6845a34a9d5bee$export$a35c789ed37ee0f7 extends $2c6845a34a9d5bee$export$6b59b88de1ff9cb7 {
}



var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $GDBjl = parcelRequire("GDBjl");

var $8miOT = parcelRequire("8miOT");

var $28f8Y = parcelRequire("28f8Y");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
var $27ea4d9f023c86f3$var$ErrorIcon = function ErrorIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_222_14150)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M42.635 49.056c-.557 1.478-6.632 1.96-8.017 3.193-1.386 1.234.549 4.402-1.538 5.314-2.087.912-6.438-1.174-8.913-.743-2.475.43-5.01 3.734-7.519 3.607-2.517-.135-2.585-3.599-4.579-4.25-2.061-.675-7.772.88-9.107-.21-1.335-1.09 2.872-3.887 2.433-5.264C4.955 49.326-.51 48.278.039 46.8c.549-1.478 6.632-1.96 8.017-3.194 1.386-1.233 7.967-4.14 10.442-4.57 2.476-.43 5.01-3.734 7.52-3.607 2.517.135 2.584 3.599 4.578 4.25 2.062.675 7.773-.88 9.108.21 1.334 1.09-2.873 3.886-2.434 5.264.423 1.334 5.906 2.424 5.357 3.903h.008Z",
                        fill: "#FF0B4B"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask0_222_14150",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "6",
                        y: "27",
                        width: "33",
                        height: "23",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M35.015 31.56c-5.086-5.087-13.323-5.087-18.41 0a12.937 12.937 0 0 0-3.286 5.575c-8.33 4.36-7.045 11.963-7.045 11.963l29.442.093c4.359-5.111 4.123-12.8-.71-17.632h.009Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask0_222_14150)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M62.877 43.353a4.838 4.838 0 0 0-5.12 2.805 4.836 4.836 0 0 0-4.401-2.915A4.822 4.822 0 0 0 48.92 46.1a4.836 4.836 0 0 0-4.402-2.915 4.822 4.822 0 0 0-4.435 2.856 4.836 4.836 0 0 0-4.402-2.915 4.823 4.823 0 0 0-4.435 2.855 4.837 4.837 0 0 0-4.402-2.914 4.823 4.823 0 0 0-4.435 2.855 4.836 4.836 0 0 0-4.402-2.914 4.822 4.822 0 0 0-4.435 2.855 4.836 4.836 0 0 0-5.086-2.872c-2.146.279-3.886 2.036-4.148 4.19a4.831 4.831 0 0 0 4.765 5.432 4.817 4.817 0 0 0 3.295-1.275 1.64 1.64 0 0 1 2.264.017 4.795 4.795 0 0 0 3.278 1.318 4.777 4.777 0 0 0 3.294-1.276c.651-.6 1.623-.592 2.265.017a4.816 4.816 0 0 0 6.573.042 1.64 1.64 0 0 1 2.264.017 4.816 4.816 0 0 0 6.573.042c.65-.6 1.622-.591 2.264.017a4.794 4.794 0 0 0 3.277 1.318 4.778 4.778 0 0 0 3.295-1.276 1.64 1.64 0 0 1 2.264.017 4.795 4.795 0 0 0 3.278 1.318 4.778 4.778 0 0 0 3.295-1.276c.65-.6 1.622-.591 2.264.017a4.794 4.794 0 0 0 3.278 1.318 4.834 4.834 0 0 0 4.833-5.373c-.237-2.154-1.943-3.937-4.09-4.24h.01Z",
                                fill: "#FF0B4B"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M62.911 38.529a4.837 4.837 0 0 0-5.12 2.805 4.837 4.837 0 0 0-4.401-2.915 4.822 4.822 0 0 0-4.436 2.856 4.836 4.836 0 0 0-4.401-2.915 4.836 4.836 0 0 0-4.435 2.855 4.837 4.837 0 0 0-4.402-2.914 4.823 4.823 0 0 0-4.436 2.855 4.836 4.836 0 0 0-4.401-2.914 4.822 4.822 0 0 0-4.435 2.855 4.836 4.836 0 0 0-4.402-2.915 4.822 4.822 0 0 0-4.435 2.856 4.836 4.836 0 0 0-5.086-2.872c-2.264.295-3.886 2.036-4.148 4.19a4.831 4.831 0 0 0 4.765 5.432 4.817 4.817 0 0 0 3.294-1.275c.651-.6 1.623-.592 2.265.016a4.794 4.794 0 0 0 3.277 1.318 4.778 4.778 0 0 0 3.295-1.275 1.64 1.64 0 0 1 2.264.017 4.795 4.795 0 0 0 3.278 1.318 4.777 4.777 0 0 0 3.295-1.276c.65-.6 1.622-.592 2.264.017a4.795 4.795 0 0 0 3.278 1.318 4.777 4.777 0 0 0 3.295-1.276c.65-.6 1.622-.591 2.264.017a4.795 4.795 0 0 0 3.278 1.318 4.777 4.777 0 0 0 3.295-1.276c.65-.6 1.622-.591 2.264.017a4.795 4.795 0 0 0 3.278 1.318 4.778 4.778 0 0 0 3.295-1.276c.65-.6 1.622-.591 2.264.017a4.795 4.795 0 0 0 3.278 1.318 4.833 4.833 0 0 0 4.832-5.373c-.236-2.154-1.943-3.937-4.088-4.241h.008Z",
                                fill: "#FE6C93"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M62.936 34.094a4.837 4.837 0 0 0-5.12 2.804 4.836 4.836 0 0 0-4.4-2.914 4.822 4.822 0 0 0-4.436 2.855 4.836 4.836 0 0 0-4.402-2.914 4.823 4.823 0 0 0-4.435 2.855 4.837 4.837 0 0 0-4.402-2.915 4.823 4.823 0 0 0-4.435 2.856 4.836 4.836 0 0 0-4.402-2.915 4.822 4.822 0 0 0-4.435 2.856 4.836 4.836 0 0 0-4.402-2.915 4.822 4.822 0 0 0-4.435 2.856 4.836 4.836 0 0 0-5.086-2.873c-2.146.28-3.886 2.036-4.148 4.19a4.831 4.831 0 0 0 4.765 5.433 4.817 4.817 0 0 0 3.295-1.276 1.64 1.64 0 0 1 2.264.017A4.795 4.795 0 0 0 18 43.412a4.778 4.778 0 0 0 3.295-1.276 1.64 1.64 0 0 1 2.264.017 4.796 4.796 0 0 0 3.278 1.318 4.777 4.777 0 0 0 3.295-1.275c.65-.6 1.622-.592 2.264.016a4.816 4.816 0 0 0 6.573.042c.65-.6 1.621-.59 2.264.018a4.795 4.795 0 0 0 3.278 1.317 4.777 4.777 0 0 0 3.294-1.275c.65-.6 1.623-.592 2.265.017a4.795 4.795 0 0 0 3.277 1.318 4.777 4.777 0 0 0 3.295-1.276c.65-.6 1.622-.591 2.264.017a4.795 4.795 0 0 0 3.278 1.318 4.833 4.833 0 0 0 4.833-5.373c-.237-2.155-1.943-3.937-4.09-4.241h.01Z",
                                fill: "#FF0B4B"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M62.97 29.27a4.837 4.837 0 0 0-5.12 2.804 4.837 4.837 0 0 0-4.401-2.914 4.822 4.822 0 0 0-4.435 2.855 4.837 4.837 0 0 0-4.402-2.914 4.823 4.823 0 0 0-4.436 2.855 4.836 4.836 0 0 0-4.401-2.915 4.823 4.823 0 0 0-4.435 2.856 4.836 4.836 0 0 0-4.402-2.915 4.822 4.822 0 0 0-4.435 2.856 4.837 4.837 0 0 0-4.402-2.915 4.822 4.822 0 0 0-4.435 2.856 4.836 4.836 0 0 0-5.086-2.873c-2.146.28-3.886 2.036-4.148 4.19a4.831 4.831 0 0 0 4.765 5.433 4.816 4.816 0 0 0 3.295-1.276c.65-.6 1.622-.591 2.264.017a4.794 4.794 0 0 0 3.278 1.318 4.778 4.778 0 0 0 3.294-1.276c.651-.6 1.623-.591 2.265.017a4.816 4.816 0 0 0 6.573.042c.65-.6 1.621-.59 2.263.017a4.795 4.795 0 0 0 3.279 1.318 4.777 4.777 0 0 0 3.294-1.275 1.64 1.64 0 0 1 2.264.017 4.795 4.795 0 0 0 3.278 1.318 4.777 4.777 0 0 0 3.295-1.276 1.64 1.64 0 0 1 2.264.017 4.795 4.795 0 0 0 3.278 1.318 4.778 4.778 0 0 0 3.295-1.276c.65-.6 1.622-.591 2.264.017a4.794 4.794 0 0 0 3.278 1.318 4.833 4.833 0 0 0 4.832-5.373c-.236-2.155-1.943-3.937-4.088-4.241h.008Z",
                                fill: "#D90841"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M63.004 23.905c-2.256-.338-4.275.972-5.12 2.965-.735-1.8-2.425-3.058-4.401-3.075-1.977-.017-3.675 1.234-4.444 3.016-.735-1.8-2.425-3.058-4.402-3.075-1.977-.017-3.675 1.233-4.444 3.016-.734-1.8-2.424-3.058-4.401-3.075-1.977-.017-3.675 1.233-4.444 3.016-.735-1.8-2.424-3.058-4.401-3.075-1.977-.009-3.675 1.233-4.444 3.016-.735-1.8-2.425-3.058-4.402-3.075-1.977-.017-3.675 1.233-4.443 3.016-.82-2.002-2.822-3.337-5.086-3.025-2.265.313-3.887 2.154-4.148 4.427-.355 3.084 1.909 5.72 4.764 5.737a4.722 4.722 0 0 0 3.295-1.344c.65-.633 1.622-.625 2.264.017a4.67 4.67 0 0 0 3.278 1.386 4.686 4.686 0 0 0 3.295-1.344c.65-.633 1.622-.625 2.264.017a4.67 4.67 0 0 0 3.278 1.386 4.723 4.723 0 0 0 3.295-1.343c.65-.634 1.622-.626 2.264.016a4.67 4.67 0 0 0 3.278 1.386 4.686 4.686 0 0 0 3.295-1.343c.65-.634 1.622-.626 2.264.017a4.67 4.67 0 0 0 3.278 1.385 4.686 4.686 0 0 0 3.295-1.343c.65-.634 1.622-.625 2.264.017a4.67 4.67 0 0 0 3.278 1.385 4.686 4.686 0 0 0 3.295-1.343c.65-.634 1.622-.625 2.264.017a4.67 4.67 0 0 0 3.278 1.385c2.855.017 5.153-2.585 4.832-5.677-.228-2.272-1.943-4.156-4.089-4.477l.05-.009Z",
                                fill: "#98062D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask1_222_14150",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "26",
                        y: "3",
                        width: "38",
                        height: "38",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M63.536 7.296 42.322 40.59 26.01 24.277 59.734 3.435c2.518-1.554 5.399 1.369 3.81 3.86h-.008Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask1_222_14150)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M45.66 40.802c10.96 0 19.844-8.885 19.844-19.845 0-10.96-8.884-19.845-19.845-19.845-10.96 0-19.845 8.884-19.845 19.845 0 10.96 8.885 19.845 19.846 19.845Z",
                                fill: "#4427FA"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M49.774 35.707c9.686 0 17.538-7.852 17.538-17.538C67.313 8.482 59.46.63 49.775.63S32.235 8.482 32.235 18.17c0 9.686 7.853 17.538 17.539 17.538Z",
                                fill: "#334EF5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M52.25 27.74c7.227 0 13.086-5.858 13.086-13.086 0-7.227-5.86-13.086-13.087-13.086-7.227 0-13.086 5.859-13.086 13.086 0 7.228 5.859 13.087 13.086 13.087Z",
                                fill: "#2275F0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M56.11 22.74c5.487 0 9.935-4.449 9.935-9.936s-4.448-9.935-9.935-9.935-9.935 4.448-9.935 9.935 4.448 9.935 9.935 9.935Z",
                                fill: "#119CEB"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M60.47 15.271a6.818 6.818 0 1 0 0-13.636 6.818 6.818 0 0 0 0 13.636Z",
                                fill: "#00C3E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "m37.591 48.833-19.91-19.911 3.984-3.985a4.222 4.222 0 0 1 5.962 0l13.949 13.95a4.222 4.222 0 0 1 0 5.961l-3.985 3.985Z",
                        fill: "#33009A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_222_14150",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h64v64H0z"
                    })
                })
            })
        ]
    });
};
$27ea4d9f023c86f3$var$ErrorIcon.defaultProps = {
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $27ea4d9f023c86f3$export$dba1278861bf0dc1;
(function(ErrorType) {
    ErrorType["NETWORK"] = "Network";
    ErrorType["SERVER"] = "Server";
})($27ea4d9f023c86f3$export$dba1278861bf0dc1 || ($27ea4d9f023c86f3$export$dba1278861bf0dc1 = {}));
const $27ea4d9f023c86f3$export$c83f1bc4d3f4576d = ({ refresh: refresh, errorType: errorType })=>/*#__PURE__*/ (0, $iKObn.jsxs)($27ea4d9f023c86f3$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($27ea4d9f023c86f3$var$HeaderContainer, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $GDBjl.AppLogo), {
                    height: 32,
                    width: 125
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($27ea4d9f023c86f3$var$ContentContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
                        onRefresh: refresh,
                        icon: /*#__PURE__*/ (0, $iKObn.jsx)($27ea4d9f023c86f3$var$ErrorIcon, {
                            color: (0, $kKnoQ.colors).grey,
                            width: 96,
                            height: 96
                        })
                    }),
                    errorType === "Server" && /*#__PURE__*/ (0, $iKObn.jsx)((0, $8miOT.ContactSupport), {
                        uiStyle: "primary"
                    })
                ]
            })
        ]
    });
const $27ea4d9f023c86f3$var$Container = (0, $5UMQ1.default).div`
	height: 100vh;
	display: flex;
	flex-direction: column;
`;
const $27ea4d9f023c86f3$var$ContentContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(16, "center", "center")};
	display: flex;
	flex: 1;
`;
const $27ea4d9f023c86f3$var$HeaderContainer = (0, $5UMQ1.default).div`
	height: 80px;
	align-self: stretch;
	border-bottom: 1px solid ${(0, $kKnoQ.colors).primary25};
	background-color: ${(0, $kKnoQ.colors).white};
	display: grid;
	grid-template-columns: 128px 1fr 128px;
	place-items: center;
	padding-left: 40px;
	padding-right: 40px;
`;



var $9XVwj = parcelRequire("9XVwj");

var $iKObn = parcelRequire("iKObn");

var $iKObn = parcelRequire("iKObn");

var $ghfIB = parcelRequire("ghfIB");

var $81g6h = parcelRequire("81g6h");

var $hE6rp = parcelRequire("hE6rp");
const $23b723217c7bc267$export$cd680e3bc94f76c3 = ({ children: children })=>{
    const location = (0, $hE6rp.useLocation)();
    (0, $81g6h.useEffect)(()=>{
        (0, $ghfIB.analyticsDimensionsManager).computeCustomDimensions();
        (0, $ghfIB.analyticsRoutesManager).setCurrentRoute(location);
    }, [
        location
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
        children: children
    });
};



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $4UKJF = parcelRequire("4UKJF");

var $02mFA = parcelRequire("02mFA");

var $5UMQ1 = parcelRequire("5UMQ1");

var $243Cr = parcelRequire("243Cr");

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $02mFA = parcelRequire("02mFA");

var $5UMQ1 = parcelRequire("5UMQ1");

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $lKlJT = parcelRequire("lKlJT");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
const $826d73f11e1ff0f1$export$346860c7284a7905 = ({ title: title, description: description, subtitle: subtitle, children: children })=>/*#__PURE__*/ (0, $iKObn.jsx)($826d73f11e1ff0f1$var$StyledPage, {
        children: /*#__PURE__*/ (0, $iKObn.jsx)($826d73f11e1ff0f1$var$Content, {
            children: /*#__PURE__*/ (0, $iKObn.jsxs)($826d73f11e1ff0f1$var$Wrapper, {
                children: [
                    title && /*#__PURE__*/ (0, $iKObn.jsx)($826d73f11e1ff0f1$var$Title, {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($826d73f11e1ff0f1$var$Subtitle, {
                        children: subtitle
                    }),
                    description && /*#__PURE__*/ (0, $iKObn.jsx)($826d73f11e1ff0f1$var$Description, {
                        children: description
                    }),
                    children
                ]
            })
        })
    });
const $826d73f11e1ff0f1$var$Content = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "center", "center")};
`;
const $826d73f11e1ff0f1$var$Wrapper = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("M", "flexstart", "center")};
`;
const $826d73f11e1ff0f1$var$Title = (0, $5UMQ1.default).h1`
	color: ${(0, $kKnoQ.colors).primary};
	text-align: center;
`;
const $826d73f11e1ff0f1$var$Subtitle = (0, $5UMQ1.default).h3`
	text-align: center;
`;
const $826d73f11e1ff0f1$var$Description = (0, $5UMQ1.default).div`
	text-align: center;
`;
const $826d73f11e1ff0f1$var$StyledPage = (0, $5UMQ1.default)((0, $lKlJT.Page))`
	justify-content: center;
`;



var $lDZlX = parcelRequire("lDZlX");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $lDZlX = parcelRequire("lDZlX");
parcelRequire("81g6h");
const $762df3681f2b711e$export$15805d4f5c1f8eca = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)($762df3681f2b711e$var$PrivacyNoticeText, {
        children: format("global.register.privacy_notice.description", {
            link: {
                className: "text-primary",
                onClick: (event)=>{
                    event.preventDefault();
                    window.open((0, $lDZlX.RoutesPath).RegisterPrivacyNotice, "_blank");
                }
            }
        })
    });
};
const $762df3681f2b711e$var$PrivacyNoticeText = (0, $5UMQ1.default).div`
	font-size: 12px;
`;



var $5WGN2 = parcelRequire("5WGN2");

var $9AWgp = parcelRequire("9AWgp");

var $68IWj = parcelRequire("68IWj");

var $81g6h = parcelRequire("81g6h");
const $36be0bf19afd5029$export$492ccad72e408928 = ()=>{
    const { format: format, locale: locale } = (0, $1eHG3.useI18n)();
    const [isConsentChecked, setIsConsentChecked] = (0, $81g6h.useState)(false);
    const [isMailPhysioChecked, setIsMailPhysioChecked] = (0, $81g6h.useState)(false);
    const [isMailBiogenChecked, setIsMailBiogenChecked] = (0, $81g6h.useState)(false);
    const [consentToLegalDocuments, isLoading] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(async ()=>{
        try {
            await (0, $ghfIB.legalContentManager).retrieveLegalDocuments(locale);
            await (0, $ghfIB.legalContentManager).consentToLegalDocuments();
            await (0, $ghfIB.userManager).setConsentEmails({
                physioMeEmails: isMailPhysioChecked ? (0, $02mFA.PtNotificationPreferencesStatus).ENABLED : (0, $02mFA.PtNotificationPreferencesStatus).DISABLED,
                biogenEmails: isMailBiogenChecked ? (0, $02mFA.PtNotificationPreferencesStatus).ENABLED : (0, $02mFA.PtNotificationPreferencesStatus).DISABLED
            });
            await (0, $ghfIB.userManager).retrieveUser();
            (0, $ghfIB.analyticsService).trackEvent({
                category: (0, $auPqo.AnalyticsCategory).PERMISSIONS,
                action: isMailBiogenChecked ? "acceptEmailConsent" : "refuseEmailConsent",
                params: [
                    "registration",
                    "biogen"
                ]
            });
            (0, $ghfIB.analyticsService).trackEvent({
                category: (0, $auPqo.AnalyticsCategory).PERMISSIONS,
                action: isMailPhysioChecked ? "acceptEmailConsent" : "refuseEmailConsent",
                params: [
                    "registration",
                    "physiome"
                ]
            });
            (0, $ghfIB.analyticsService).trackEvent({
                category: (0, $auPqo.AnalyticsCategory).REGISTRATION,
                action: "validateAdminFlow"
            });
        } catch (e) {
            console.error("Failed to retrieve or consent to the legal documents", e);
            (0, $ghfIB.networkActionsErrorsManager).reportError(e);
        }
    }, [
        isMailBiogenChecked,
        isMailPhysioChecked,
        locale
    ]), {});
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $826d73f11e1ff0f1$export$346860c7284a7905), {
        title: format("legalContent.registration.title"),
        subtitle: format("legalContent.registration.subtitle"),
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($36be0bf19afd5029$var$Container, {
            className: "p-card",
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                    className: "p-size-m",
                    children: format("legalContent.registration.form.text")
                }),
                /*#__PURE__*/ (0, $iKObn.jsxs)($36be0bf19afd5029$var$CheckboxesContainer, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsxs)($36be0bf19afd5029$var$CheckboxContainer, {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)($36be0bf19afd5029$var$StyledCheckbox, {
                                    inputId: "consent",
                                    checked: isConsentChecked,
                                    onChange: ()=>setIsConsentChecked((current)=>!current)
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                    htmlFor: "consent",
                                    children: format("global.register.consent.tou", {
                                        link: {
                                            className: "p-size-s-bold text-primary",
                                            onClick: (event)=>{
                                                event.preventDefault();
                                                window.open((0, $lDZlX.RoutesPath).RegisterTermsOfUse, "_blank");
                                            }
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsxs)($36be0bf19afd5029$var$CheckboxContainer, {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)($36be0bf19afd5029$var$StyledCheckbox, {
                                    inputId: "mailPhysio",
                                    checked: isMailPhysioChecked,
                                    onChange: ()=>setIsMailPhysioChecked((current)=>!current)
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                    htmlFor: "mailPhysio",
                                    children: format("global.register.physiomeEmails.v1_6")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsxs)($36be0bf19afd5029$var$CheckboxContainer, {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)($36be0bf19afd5029$var$StyledCheckbox, {
                                    inputId: "mailBiogen",
                                    checked: isMailBiogenChecked,
                                    onChange: ()=>setIsMailBiogenChecked((current)=>!current)
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                    htmlFor: "mailBiogen",
                                    children: format("global.register.biogenEmails.v1_6")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)($36be0bf19afd5029$var$StyledButton, {
                    label: format("legalContent.registration.form.continueButton"),
                    disabled: !isConsentChecked,
                    onClick: ()=>{
                        consentToLegalDocuments();
                    },
                    loading: isLoading
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $762df3681f2b711e$export$15805d4f5c1f8eca), {})
            ]
        })
    });
};
const $36be0bf19afd5029$var$CheckboxContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, undefined, "center")}
`;
const $36be0bf19afd5029$var$CheckboxesContainer = (0, $5UMQ1.default).div`
	display: grid;
	gap: 8px;
`;
const $36be0bf19afd5029$var$StyledCheckbox = (0, $5UMQ1.default)((0, $68IWj.Checkbox))`
	margin-right: 1rem;
`;
const $36be0bf19afd5029$var$StyledButton = (0, $5UMQ1.default)((0, $9AWgp.Button))`
	margin-top: 16px;
	width: 100%;
`;
const $36be0bf19afd5029$var$Container = (0, $5UMQ1.default).div`
	display: grid;
	gap: 16px;
	padding: 32px;
	width: min(calc(100vw - 40px), 496px);
`;



var $9XVwj = parcelRequire("9XVwj");

var $iKObn = parcelRequire("iKObn");

var $8zvzh = parcelRequire("8zvzh");

var $ghfIB = parcelRequire("ghfIB");

var $2Bm53 = parcelRequire("2Bm53");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $2Bm53 = parcelRequire("2Bm53");

var $5UMQ1 = parcelRequire("5UMQ1");

var $6Px22 = parcelRequire("6Px22");

var $IR0l7 = parcelRequire("IR0l7");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");
var $e11b033f8352880f$var$InfoIcon = function InfoIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Zm0-20c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12.01 17.17c-.55 0-1-.45-1-1v-5.44c0-.55.45-1 1-1s1 .45 1 1v5.44c0 .55-.45 1-1 1ZM12 8.11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                fill: "currentColor"
            })
        ]
    });
};
$e11b033f8352880f$var$InfoIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $e11b033f8352880f$var$Play = function Play(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 7c0-1.597 1.753-2.514 3.071-1.687l.006.003 8.135 5.174c1.222.788 1.242 2.587-.007 3.375L9.08 19.042h-.002C7.741 19.9 6 18.938 6 17.36V7Zm2 .003v10.355l.003-.001 8.132-5.182h-.002c0-.001 0-.002-.002-.002l-.002-.002-8.121-5.164a.055.055 0 0 0-.006-.004H8Z",
            fill: "currentColor"
        })
    });
};
$e11b033f8352880f$var$Play.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $e11b033f8352880f$var$BannerMessages = {
    [(0, $2Bm53.TutorialBannerType).INVITE_TO_HCT]: "tutorialBanner.hct",
    [(0, $2Bm53.TutorialBannerType).MONITOR_PATIENT_PROGRAM]: "tutorialBanner.monitorProgram"
};
const $e11b033f8352880f$export$e8f6c4f4c0db666 = ({ bannerType: bannerType })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const [dialogVisible, setDialogVisible] = (0, $81g6h.useState)(false);
    const tutorial = (0, $ghfIB.tutorialBannerManager).getTutorialLink(bannerType);
    if (!tutorial) return null;
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $6Px22.Banner), {
                text: format($e11b033f8352880f$var$BannerMessages[bannerType]),
                icon: $e11b033f8352880f$var$InfoIcon,
                uiStyle: "success",
                rightComponent: /*#__PURE__*/ (0, $iKObn.jsxs)($e11b033f8352880f$var$VideoCTA, {
                    onClick: ()=>setDialogVisible(true),
                    children: [
                        format("tutorialBanner.cta"),
                        /*#__PURE__*/ (0, $iKObn.jsx)($e11b033f8352880f$var$PlayIcon, {
                            color: (0, $kKnoQ.colors).primary,
                            width: 10,
                            height: 10
                        })
                    ]
                }),
                onDelete: ()=>(0, $ghfIB.tutorialBannerManager).closeBanner(bannerType)
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $IR0l7.TutorialDialog), {
                visible: dialogVisible,
                tutorial: tutorial,
                tutorialType: bannerType,
                onHide: ()=>setDialogVisible(false)
            })
        ]
    });
};
const $e11b033f8352880f$var$VideoCTA = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).primary};
	font-size: 16px;
	font-weight: 700;
	cursor: pointer;
`;
const $e11b033f8352880f$var$PlayIcon = (0, $5UMQ1.default)($e11b033f8352880f$var$Play)`
	margin-left: 10px;
`;



var $lDZlX = parcelRequire("lDZlX");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");

var $hE6rp = parcelRequire("hE6rp");
const $de6ea493ba34a070$var$TutorialsRule = {
    [(0, $2Bm53.TutorialBannerType).MONITOR_PATIENT_PROGRAM]: {
        activeScreens: [
            (0, $lDZlX.RoutesPath).PatientDetails
        ],
        activeTab: (0, $lDZlX.TabPatientDetails).PROGRESS_TAB
    },
    [(0, $2Bm53.TutorialBannerType).INVITE_TO_HCT]: {
        activeScreens: [
            (0, $lDZlX.RoutesPath).PatientDetails
        ],
        activeTab: (0, $lDZlX.TabPatientDetails).HEALTHCARE_TAB
    }
};
const $de6ea493ba34a070$export$218db699b77cbd4f = ()=>{
    const banners = (0, $1IWnK.useObservable)((0, $ghfIB.tutorialBannerManager).displayedBanners);
    const location = (0, $hE6rp.useLocation)();
    const { active: active } = (0, $8zvzh.useQueryParams)();
    const ptStatus = (0, $1IWnK.useObservable)((0, $ghfIB.userStatusManager).ptRegistrationStatus);
    (0, $81g6h.useEffect)(()=>{
        (0, $ghfIB.tutorialBannerManager).hideBanners();
        const shouldDisplayBanner = (rules)=>rules.activeScreens.some((path)=>path.includes(":") ? location.pathname.startsWith(path.split(":")[0]) : location.pathname === path) && (rules.activeTab ?? active) === active;
        (0, $2Bm53.tutorialBannerTypes).forEach((type)=>{
            if (shouldDisplayBanner($de6ea493ba34a070$var$TutorialsRule[type])) (0, $ghfIB.tutorialBannerManager).displayBanner(type);
        });
    }, [
        active,
        location,
        ptStatus
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
        children: banners.map((bannerType)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $e11b033f8352880f$export$e8f6c4f4c0db666), {
                bannerType: bannerType
            }, bannerType))
    });
};



var $iKObn = parcelRequire("iKObn");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");
const $5d3762e0012a57fc$export$a5ceee2b1c92266a = ({ onFocus: onFocus = null, onBlur: onBlur = null, children: children })=>{
    (0, $81g6h.useEffect)(()=>{
        if ((0, $lTdpc.isNotNil)(onFocus)) window.addEventListener("focus", onFocus);
        if ((0, $lTdpc.isNotNil)(onBlur)) window.addEventListener("blur", onBlur);
        // Calls onFocus when the window first loads
        onFocus?.();
        // Specify how to clean up after this effect:
        return ()=>{
            if ((0, $lTdpc.isNotNil)(onBlur)) window.removeEventListener("blur", onBlur);
            if ((0, $lTdpc.isNotNil)(onFocus)) window.removeEventListener("focus", onFocus);
        };
    }, [
        onBlur,
        onFocus
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
        children: children
    });
};



var $243Cr = parcelRequire("243Cr");

var $81g6h = parcelRequire("81g6h");

var $hE6rp = parcelRequire("hE6rp");
const $eb5a63d431e6b13e$export$b6343d86957a1a7b = ()=>{
    const location = (0, $hE6rp.useLocation)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    (0, $81g6h.useEffect)(()=>{
        dialogContext?.closeAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location
    ]);
    return null;
};



var $lDZlX = parcelRequire("lDZlX");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $iBbjf = parcelRequire("iBbjf");

var $a6fIt = parcelRequire("a6fIt");

var $5UMQ1 = parcelRequire("5UMQ1");

var $GDBjl = parcelRequire("GDBjl");

var $5kXMA = parcelRequire("5kXMA");

var $lDZlX = parcelRequire("lDZlX");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
const $3de05cedc2af47d9$export$1d55303f9e94a39c = ({ context: context, label: label, icon: icon, iconSelected: iconSelected })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const isItemSelected = context.index === context.selectedTabIndex;
    const Icon = isItemSelected ? iconSelected : icon;
    const itemColor = isItemSelected ? (0, $kKnoQ.colors).primaryDark : (0, $kKnoQ.colors).grey80;
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($3de05cedc2af47d9$var$IconContainer, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)(Icon, {
                    height: 32,
                    width: 32,
                    color: itemColor
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($3de05cedc2af47d9$var$MenuItemLabel, {
                className: "p-size-xs-extra-bold",
                color: itemColor,
                children: format(label, undefined)
            })
        ]
    });
};
const $3de05cedc2af47d9$var$IconContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)()};
	position: relative;
`;
const $3de05cedc2af47d9$var$MenuItemLabel = (0, $5UMQ1.default).span`
	color: ${(props)=>props.color};
`;



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $4UKJF = parcelRequire("4UKJF");

var $a6fIt = parcelRequire("a6fIt");

var $5UMQ1 = parcelRequire("5UMQ1");

var $243Cr = parcelRequire("243Cr");

var $lDZlX = parcelRequire("lDZlX");

var $iKObn = parcelRequire("iKObn");

var $a6fIt = parcelRequire("a6fIt");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
const $a0c0cf690ab5551c$export$20dc64867e1691d0 = ({ title: title, icon: Icon, onClick: onClick })=>/*#__PURE__*/ (0, $iKObn.jsxs)($a0c0cf690ab5551c$var$MenuRowContainer, {
        onClick: onClick,
        "data-test": (0, $a6fIt.e2eTestId).homePage.profileMenuItem,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($a0c0cf690ab5551c$var$IconContainer, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)(Icon, {
                    height: 20,
                    width: 20,
                    color: (0, $kKnoQ.colors).primary
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                className: "p-size-s",
                children: title
            })
        ]
    });
const $a0c0cf690ab5551c$var$MenuRowContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8, "flexstart", "center")}
	padding: 8px 8px 8px 16px;
	transition: background-color 0.2s;
	cursor: pointer;

	:hover {
		background-color: ${(0, $kKnoQ.colors).primaryBackground};
	}

	:active {
		background-color: ${(0, $kKnoQ.colors).primary10};
	}
`;
const $a0c0cf690ab5551c$var$IconContainer = (0, $5UMQ1.default).div`
	display: flex;
	justify-content: center;
`;



var $iKObn = parcelRequire("iKObn");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $lDZlX = parcelRequire("lDZlX");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $kKnoQ = parcelRequire("kKnoQ");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");

var $hE6rp = parcelRequire("hE6rp");
var $6a89d46bbc0f1b6e$var$NotificationIcon = function NotificationIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M3.98 19.7c-.326 0-.598-.105-.817-.316-.22-.211-.33-.472-.33-.784 0-.312.11-.573.33-.784.22-.21.491-.316.816-.316h1.146V9.8c0-1.522.477-2.874 1.432-4.056.955-1.183 2.196-1.957 3.724-2.324v-.77c0-.458.167-.848.502-1.169.334-.32.74-.481 1.217-.481.477 0 .883.16 1.217.481.335.321.502.71.502 1.169v.77c1.527.367 2.769 1.141 3.724 2.324A6.277 6.277 0 0 1 18.875 9.8v7.7h1.146c.324 0 .596.105.816.316.22.211.33.472.33.784 0 .312-.11.573-.33.784-.22.21-.492.316-.816.316H3.979Zm3.437-2.2h9.166V9.8c0-1.21-.448-2.246-1.346-3.108C14.339 5.832 13.26 5.4 12 5.4s-2.34.43-3.237 1.292C7.865 7.554 7.417 8.59 7.417 9.8v7.7ZM10.473 22.554c.449.43.988.646 1.619.646.63 0 1.17-.215 1.618-.646.449-.431.673-.949.673-1.554H9.8c0 .605.224 1.123.673 1.554Z",
            fill: "currentColor"
        })
    });
};
$6a89d46bbc0f1b6e$var$NotificationIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $6a89d46bbc0f1b6e$export$6031ddd8d07bd265 = ()=>{
    const shouldDisplayBadge = (0, $1IWnK.useObservable)((0, $ghfIB.notificationBadgeManager).shouldDisplayBadge);
    const navigate = (0, $htiSH.useNavigate)();
    const location = (0, $hE6rp.useLocation)();
    const [isHovered, setIsHovered] = (0, $81g6h.useState)(false);
    const isTabActive = (0, $81g6h.useMemo)(()=>location.pathname === (0, $lDZlX.RoutesPath).NotificationCenter, [
        location
    ]);
    const onContainerClick = (0, $81g6h.useCallback)(()=>{
        (0, $ghfIB.notificationBadgeManager).saveLastUnreadCount();
        navigate((0, $lDZlX.RoutesPath).NotificationCenter);
    }, [
        navigate
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($6a89d46bbc0f1b6e$var$Container, {
        active: isTabActive,
        onClick: onContainerClick,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($6a89d46bbc0f1b6e$var$IconContainer, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)($6a89d46bbc0f1b6e$var$NotificationIcon, {
                    width: 24,
                    height: 24,
                    color: isTabActive || isHovered ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).black
                }),
                shouldDisplayBadge && /*#__PURE__*/ (0, $iKObn.jsx)($6a89d46bbc0f1b6e$var$NotificationBadge, {
                    isHovered: isHovered
                })
            ]
        })
    });
};
const $6a89d46bbc0f1b6e$var$Container = (0, $5UMQ1.default).div`
	cursor: pointer;
	border-bottom: ${({ active: active })=>active ? "2px" : "0px"} solid ${(0, $kKnoQ.colors).primary};
	align-self: stretch;
	display: flex;
	align-items: center;
	margin-bottom: -3px;
	padding: 0 8px;
	border-radius: 12px 12px 0 0;

	:hover {
		background-color: ${(0, $kKnoQ.colors).primary10};
	}

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		margin-bottom: 0;
	}
`;
const $6a89d46bbc0f1b6e$var$IconContainer = (0, $5UMQ1.default).div`
	position: relative;
`;
const $6a89d46bbc0f1b6e$var$NotificationBadge = (0, $5UMQ1.default).div`
	position: absolute;
	top: 1px;
	right: 1px;
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background-color: ${(0, $kKnoQ.colors).rejection};
	border: 2px solid ${({ isHovered: isHovered })=>isHovered ? `${(0, $kKnoQ.colors).primary10}` : `${(0, $kKnoQ.colors).white}`};
`;



var $1acTy = parcelRequire("1acTy");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $1pD6E = parcelRequire("1pD6E");

var $81g6h = parcelRequire("81g6h");
var $aac7fee7b713e4b3$var$BugIcon = function BugIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.465 2.187a1 1 0 0 1 1.414 0l1.8 1.799A1 1 0 0 1 9.263 5.4l-1.8-1.8a1 1 0 0 1 0-1.413ZM16.535 2.187a1 1 0 0 1 0 1.414L14.736 5.4a1 1 0 1 1-1.414-1.414l1.8-1.8a1 1 0 0 1 1.413 0Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 4.844a1.874 1.874 0 0 0-1.871 2.002v.957a1 1 0 1 1-2 0v-.936a3.874 3.874 0 1 1 7.742 0v.936a1 1 0 0 1-2 0v-.957l.001-.044A1.872 1.872 0 0 0 12 4.844Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.086 8.679a2.828 2.828 0 0 0-2.828 2.828v2.871c0 2.606 2.136 4.742 4.742 4.742s4.742-2.136 4.742-4.742v-2.871a2.828 2.828 0 0 0-2.828-2.828h-3.828Zm-3.414-.586a4.828 4.828 0 0 1 3.414-1.414h3.828a4.828 4.828 0 0 1 4.828 4.828v2.871c0 3.71-3.031 6.742-6.742 6.742-3.71 0-6.742-3.031-6.742-6.742v-2.871c0-1.28.509-2.509 1.414-3.414Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 10.507a1 1 0 0 1 1 1v8.613a1 1 0 1 1-2 0v-8.613a1 1 0 0 1 1-1ZM3.387 4.765a1 1 0 0 1 1 1c0 1.499 1.145 2.695 2.481 2.833a1 1 0 0 1-.206 1.99c-2.358-.245-4.275-2.303-4.275-4.823a1 1 0 0 1 1-1ZM1.43 13.421a1 1 0 0 1 1-1h3.828a1 1 0 1 1 0 2H2.43a1 1 0 0 1-1-1ZM8.022 17.202a1 1 0 0 1-.95 1.046c-1.472.07-2.685 1.348-2.685 2.83a1 1 0 1 1-2 0c0-2.54 2.041-4.706 4.589-4.828a1 1 0 0 1 1.046.952ZM20.585 4.765a1 1 0 0 1 1 1c0 2.516-1.913 4.577-4.245 4.823a1 1 0 0 1-.21-1.99c1.304-.137 2.455-1.33 2.455-2.833a1 1 0 0 1 1-1ZM16.742 13.421a1 1 0 0 1 1-1h3.828a1 1 0 1 1 0 2h-3.828a1 1 0 0 1-1-1ZM15.978 17.202a1 1 0 0 1 1.046-.952c2.548.122 4.59 2.289 4.59 4.827a1 1 0 1 1-2 0c0-1.48-1.213-2.759-2.685-2.829a1 1 0 0 1-.951-1.046Z",
                fill: "currentColor"
            })
        ]
    });
};
$aac7fee7b713e4b3$var$BugIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $aac7fee7b713e4b3$var$DocumentsIcon = function DocumentsIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M5 1c-1.1 0-2 .9-2 2v13c0 .55.45 1 1 1s1-.45 1-1V3.4c0-.22.18-.4.4-.4H16c.55 0 1-.45 1-1s-.45-1-1-1H5Zm4 4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7a2 2 0 0 0-2-2H9Zm.34 2h10.32c.19 0 .34.15.34.34v13.32c0 .19-.15.34-.34.34H9.34c-.19 0-.34-.15-.34-.34V7.34c0-.19.15-.34.34-.34ZM11 10c0 .55.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1h-5c-.55 0-1 .45-1 1Zm0 4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1h-5c-.55 0-1 .45-1 1Zm0 4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1h-5c-.55 0-1 .45-1 1Z",
            fill: "currentColor"
        })
    });
};
$aac7fee7b713e4b3$var$DocumentsIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $aac7fee7b713e4b3$var$InfoIcon = function InfoIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Zm0-20c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12.01 17.17c-.55 0-1-.45-1-1v-5.44c0-.55.45-1 1-1s1 .45 1 1v5.44c0 .55-.45 1-1 1ZM12 8.11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                fill: "currentColor"
            })
        ]
    });
};
$aac7fee7b713e4b3$var$InfoIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $aac7fee7b713e4b3$var$LogoutIcon = function LogoutIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M5 5h6c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6c.55 0 1-.45 1-1s-.45-1-1-1H5V5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "m20.65 11.65-2.79-2.79a.501.501 0 0 0-.86.35V11h-7c-.55 0-1 .45-1 1s.45 1 1 1h7v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.19.2-.51.01-.7Z",
                fill: "currentColor"
            })
        ]
    });
};
$aac7fee7b713e4b3$var$LogoutIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $aac7fee7b713e4b3$var$MailIcon = function MailIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M20 21H4c-1.65 0-3-1.35-3-3V6c0-1.65 1.35-3 3-3h16c1.65 0 3 1.35 3 3v12c0 1.65-1.35 3-3 3ZM4 5c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H4Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.134 7.919a1 1 0 0 1 1.378-.315l4.956 3.113a1 1 0 0 0 1.064 0l4.956-3.113a1 1 0 1 1 1.063 1.694l-4.955 3.112a3 3 0 0 1-3.192 0L5.45 9.298a1 1 0 0 1-.315-1.38Z",
                fill: "currentColor"
            })
        ]
    });
};
$aac7fee7b713e4b3$var$MailIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $aac7fee7b713e4b3$var$PrivacyIcon = function PrivacyIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M13 16v-4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0ZM11 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.892 3.038C10.042 4.652 7.322 6 5 6v7c0 2.236.77 3.861 1.987 5.106 1.243 1.274 2.997 2.194 5.01 2.889l.022.008c2.005-.7 3.754-1.622 4.995-2.895C18.229 16.861 19 15.236 19 13V6c-2.32 0-5.032-1.338-6.892-2.962a.17.17 0 0 0-.216 0ZM10.59 1.52a2.17 2.17 0 0 1 2.82 0l.008.007C15.058 2.961 17.323 4 19 4a2 2 0 0 1 2 2v7c0 2.764-.98 4.889-2.554 6.504-1.547 1.588-3.625 2.64-5.777 3.39l-.008.003a2 2 0 0 1-1.327-.015c-2.154-.745-4.231-1.794-5.778-3.378C3.979 17.889 3 15.764 3 13V6a2 2 0 0 1 2-2c1.676 0 3.952-1.049 5.582-2.473l.008-.007Z",
                fill: "currentColor"
            })
        ]
    });
};
$aac7fee7b713e4b3$var$PrivacyIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $aac7fee7b713e4b3$var$HelpIcon = function HelpIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M11 17a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1.61-10.96c-2.06-.3-3.88.97-4.43 2.79-.18.58.26 1.17.87 1.17h.2c.41 0 .74-.29.88-.67.32-.89 1.27-1.5 2.3-1.28.95.2 1.65 1.13 1.57 2.1-.1 1.34-1.62 1.63-2.45 2.88 0 .01-.01.01-.01.02-.01.02-.02.03-.03.05-.09.15-.18.32-.25.5-.01.03-.03.05-.04.08-.01.02-.01.04-.02.07-.03.082-.056.169-.08.26-.14.534.328.99.88.99s.977-.471 1.224-.965c.018-.036.037-.07.056-.105.02-.03.03-.06.05-.09.08-.14.18-.27.28-.39.01-.01.02-.03.03-.04.1-.12.21-.23.33-.34.96-.91 2.26-1.65 1.99-3.56-.24-1.74-1.61-3.21-3.35-3.47Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 1c6.07 0 11 4.93 11 11s-4.93 11-11 11S1 18.07 1 12 5.93 1 12 1Zm0 20c4.96 0 9-4.04 9-9s-4.04-9-9-9-9 4.04-9 9 4.04 9 9 9Z",
                fill: "currentColor"
            })
        ]
    });
};
$aac7fee7b713e4b3$var$HelpIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $aac7fee7b713e4b3$var$SettingsIcon = function SettingsIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M16.007 10.855a4.13 4.13 0 0 0-2.893-2.872C9.96 7.14 7.129 9.99 7.994 13.145a4.13 4.13 0 0 0 2.893 2.872c3.153.843 5.984-2.008 5.12-5.162ZM14.02 12.51a2.063 2.063 0 0 1-1.498 1.51c-1.562.374-2.904-.969-2.54-2.53a2.062 2.062 0 0 1 1.499-1.51c1.56-.374 2.903.969 2.54 2.53Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "m19.745 13.583-.37-.213a7.587 7.587 0 0 0 0-2.742l.37-.213a2.503 2.503 0 0 0-2.5-4.333l-.37.214A7.482 7.482 0 0 0 14.5 4.927V4.5a2.5 2.5 0 1 0-5 0v.428a7.48 7.48 0 0 0-2.373 1.371l-.373-.216a2.501 2.501 0 1 0-2.5 4.334l.37.213a7.584 7.584 0 0 0 0 2.742l-.37.213a2.501 2.501 0 1 0 2.5 4.333l.371-.214A7.48 7.48 0 0 0 9.5 19.073v.427a2.5 2.5 0 0 0 5 0v-.427a7.48 7.48 0 0 0 2.373-1.372l.373.215a2.501 2.501 0 1 0 2.5-4.334v.001Zm-2.123-3.146a5.873 5.873 0 0 1 0 3.125.834.834 0 0 0 .387.944l.903.521a.834.834 0 0 1-.834 1.445l-.904-.524a.833.833 0 0 0-1.013.138 5.82 5.82 0 0 1-2.703 1.562.834.834 0 0 0-.625.808V19.5a.833.833 0 0 1-1.667 0v-1.043a.833.833 0 0 0-.626-.808 5.82 5.82 0 0 1-2.702-1.566.834.834 0 0 0-1.012-.137l-.903.522a.833.833 0 1 1-.834-1.443l.904-.522a.833.833 0 0 0 .386-.944 5.873 5.873 0 0 1 0-3.125.833.833 0 0 0-.387-.94l-.904-.522a.834.834 0 0 1 .834-1.444l.905.523a.833.833 0 0 0 1.011-.134 5.82 5.82 0 0 1 2.703-1.563.833.833 0 0 0 .626-.81V4.5a.833.833 0 1 1 1.667 0v1.043a.833.833 0 0 0 .625.808 5.82 5.82 0 0 1 2.703 1.566.834.834 0 0 0 1.012.137l.904-.522a.833.833 0 1 1 .833 1.443l-.903.522a.833.833 0 0 0-.386.94Z",
                fill: "currentColor"
            })
        ]
    });
};
$aac7fee7b713e4b3$var$SettingsIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
// helper for creating menu item templates outside of component definition
function $aac7fee7b713e4b3$var$menuTemplate(icon, title, onClick) {
    // eslint-disable-next-line react/display-name
    return ()=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $a0c0cf690ab5551c$export$20dc64867e1691d0), {
            icon: icon,
            title: title,
            onClick: onClick
        });
}
const $aac7fee7b713e4b3$export$b04dd99d751ebb47 = ()=>{
    const user = (0, $4UKJF.useUser)();
    const { countryConfig: countryConfig } = (0, $1acTy.useCountryConfig)();
    const { format: format } = (0, $1eHG3.useI18n)();
    const profileMenuRef = (0, $81g6h.useRef)(null);
    const navigate = (0, $htiSH.useNavigate)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const profileMenuItems = (0, $81g6h.useMemo)(()=>[
            ...user?.isTester ? [
                {
                    template: $aac7fee7b713e4b3$var$menuTemplate($aac7fee7b713e4b3$var$BugIcon, "Debug page", ()=>navigate((0, $lDZlX.RoutesPath).Debug))
                }
            ] : [],
            {
                template: $aac7fee7b713e4b3$var$menuTemplate($aac7fee7b713e4b3$var$PrivacyIcon, format("tabbar.privacyNotice"), ()=>navigate((0, $lDZlX.RoutesPath).PrivacyNotice))
            },
            {
                template: $aac7fee7b713e4b3$var$menuTemplate($aac7fee7b713e4b3$var$DocumentsIcon, format("tabbar.termsOfUse"), ()=>navigate((0, $lDZlX.RoutesPath).TermsOfUse))
            },
            ...user?.hasAgreedToLegalDocuments ? [
                {
                    template: $aac7fee7b713e4b3$var$menuTemplate($aac7fee7b713e4b3$var$SettingsIcon, format("tabbar.settings"), ()=>navigate((0, $lDZlX.RoutesPath).Settings))
                }
            ] : [],
            ...(0, $lTdpc.isNotNil)(countryConfig?.faqUrl) ? [
                {
                    template: $aac7fee7b713e4b3$var$menuTemplate($aac7fee7b713e4b3$var$HelpIcon, format("tabbar.faq"), ()=>{
                        (0, $ghfIB.analyticsService).trackEvent({
                            category: (0, $auPqo.AnalyticsCategory).COMMUNICATION,
                            action: "viewFAQ",
                            params: [
                                countryConfig.faqUrl
                            ]
                        });
                        window.open(countryConfig.faqUrl, "_blank");
                    })
                }
            ] : [],
            {
                template: $aac7fee7b713e4b3$var$menuTemplate($aac7fee7b713e4b3$var$InfoIcon, format("tabbar.about"), ()=>{
                    dialogContext?.openModal((0, $243Cr.ModalId).AboutPhysiome);
                })
            },
            {
                template: $aac7fee7b713e4b3$var$menuTemplate($aac7fee7b713e4b3$var$MailIcon, format("global.contactUs"), ()=>{
                    (0, $ghfIB.analyticsService).trackEvent({
                        category: (0, $auPqo.AnalyticsCategory).COMMUNICATION,
                        action: "contactCustomerSupport"
                    });
                    window.open(`mailto:${countryConfig?.customerSupportEmail}`);
                })
            },
            {
                template: $aac7fee7b713e4b3$var$menuTemplate($aac7fee7b713e4b3$var$LogoutIcon, format("tabbar.logout"), ()=>{
                    (0, $ghfIB.userManager).logout();
                    (0, $ghfIB.analyticsService).trackEvent({
                        category: (0, $auPqo.AnalyticsCategory).LOGIN,
                        action: "logout"
                    });
                    navigate((0, $lDZlX.RoutesPath).Login);
                })
            }
        ], [
        countryConfig,
        dialogContext,
        format,
        navigate,
        user?.hasAgreedToLegalDocuments,
        user?.isTester
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($aac7fee7b713e4b3$var$MenuContainer, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $6a89d46bbc0f1b6e$export$6031ddd8d07bd265), {}),
            /*#__PURE__*/ (0, $iKObn.jsxs)($aac7fee7b713e4b3$var$MenuItemContainer, {
                "data-test": (0, $a6fIt.e2eTestId).homePage.profileMenu,
                className: "p-size-m p-button p-button-text",
                onClick: (event)=>profileMenuRef.current?.toggle(event),
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($aac7fee7b713e4b3$var$StyledMenu, {
                        model: profileMenuItems,
                        popup: true,
                        ref: profileMenuRef
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($aac7fee7b713e4b3$var$RoundProfileContainer, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($aac7fee7b713e4b3$var$RoundProfile, {
                            className: "p-size-s-rubik-medium",
                            children: `${user?.firstName.charAt(0)}${user?.lastName.charAt(0)}`
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("i", {
                        className: "black pi pi-angle-down hidden lg:block"
                    })
                ]
            })
        ]
    });
};
const $aac7fee7b713e4b3$var$RoundProfileContainer = (0, $5UMQ1.default).div`
	position: relative;
`;
const $aac7fee7b713e4b3$var$MenuContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(0, "center", "center")};
	align-self: stretch;
`;
const $aac7fee7b713e4b3$var$MenuItemContainer = (0, $5UMQ1.default).button`
	${(0, $5WGN2.row)(8, "flexstart", "center")};

	border: none;
	background: ${(0, $kKnoQ.colors).transparent};
	cursor: pointer;

	.black {
		color: ${(0, $kKnoQ.colors).black};
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		margin: 0;
	}
`;
const $aac7fee7b713e4b3$var$RoundProfile = (0, $5UMQ1.default).div`
	width: 2.5rem;
	height: 2.5rem;
	${(0, $5WGN2.row)(undefined, "center", "center")};
	border-radius: 50%;

	background-color: ${(0, $kKnoQ.colors).primary10};
	text-transform: uppercase;
	color: ${(0, $kKnoQ.colors).primary};
`;
const $aac7fee7b713e4b3$var$StyledMenu = (0, $5UMQ1.default)((0, $1pD6E.Menu))`
	background-color: ${(0, $kKnoQ.colors).white} !important;
	margin-top: 1px;
	width: auto;
	max-width: 400px;
`;


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $6NeNe = parcelRequire("6NeNe");

var $cfkGk = parcelRequire("cfkGk");

var $5sgNc = parcelRequire("5sgNc");

var $1gPAC = parcelRequire("1gPAC");

var $9rbaG = parcelRequire("9rbaG");
"use client";
function $2e9efb2a85f1d0ec$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2e9efb2a85f1d0ec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2e9efb2a85f1d0ec$var$_typeof(o);
}
function $2e9efb2a85f1d0ec$var$_toPrimitive(input, hint) {
    if ($2e9efb2a85f1d0ec$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2e9efb2a85f1d0ec$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $2e9efb2a85f1d0ec$var$_toPropertyKey(arg) {
    var key = $2e9efb2a85f1d0ec$var$_toPrimitive(arg, "string");
    return $2e9efb2a85f1d0ec$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2e9efb2a85f1d0ec$var$_defineProperty(obj, key, value) {
    key = $2e9efb2a85f1d0ec$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2e9efb2a85f1d0ec$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2e9efb2a85f1d0ec$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2e9efb2a85f1d0ec$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2e9efb2a85f1d0ec$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2e9efb2a85f1d0ec$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2e9efb2a85f1d0ec$var$_arrayLikeToArray(o, minLen);
}
function $2e9efb2a85f1d0ec$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2e9efb2a85f1d0ec$var$_slicedToArray(arr, i) {
    return $2e9efb2a85f1d0ec$var$_arrayWithHoles(arr) || $2e9efb2a85f1d0ec$var$_iterableToArrayLimit(arr, i) || $2e9efb2a85f1d0ec$var$_unsupportedIterableToArray(arr, i) || $2e9efb2a85f1d0ec$var$_nonIterableRest();
}
var $2e9efb2a85f1d0ec$var$classes = {
    start: "p-menubar-start",
    end: "p-menubar-end",
    button: "p-menubar-button",
    root: function root(_ref) {
        var mobileActiveState = _ref.mobileActiveState;
        return (0, $cfkGk.classNames)("p-menubar p-component", {
            "p-menubar-mobile-active": mobileActiveState
        });
    },
    separator: "p-menuitem-separator",
    icon: "p-menuitem-icon",
    label: "p-menuitem-text",
    submenuIcon: "p-submenu-icon",
    menuitem: function menuitem(_ref2) {
        var active = _ref2.active, focused = _ref2.focused, disabled = _ref2.disabled;
        return (0, $cfkGk.classNames)("p-menuitem", {
            "p-menuitem-active p-highlight": active,
            "p-focus": focused,
            "p-disabled": disabled
        });
    },
    menu: "p-menubar-root-list",
    content: "p-menuitem-content",
    submenu: "p-submenu-list",
    action: function action(_ref3) {
        var disabled = _ref3.disabled;
        return (0, $cfkGk.classNames)("p-menuitem-link", {
            "p-disabled": disabled
        });
    }
};
var $2e9efb2a85f1d0ec$var$styles = "\n@layer primereact {\n    .p-menubar {\n        display: flex;\n        align-items: center;\n    }\n\n    .p-menubar ul {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n    }\n\n    .p-menubar .p-menuitem-link {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        text-decoration: none;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .p-menubar .p-menuitem-text {\n        line-height: 1;\n    }\n\n    .p-menubar .p-menuitem {\n        position: relative;\n    }\n\n    .p-menubar-root-list {\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n    }\n\n    .p-menubar-root-list > li ul {\n        display: none;\n        z-index: 1;\n    }\n\n    .p-menubar-root-list > .p-menuitem-active > .p-submenu-list {\n        display: block;\n    }\n\n    .p-menubar .p-submenu-list {\n        display: none;\n        position: absolute;\n        z-index: 1;\n    }\n\n    .p-menubar .p-submenu-list > .p-menuitem-active > .p-submenu-list {\n        display: block;\n        left: 100%;\n        top: 0;\n    }\n\n    .p-menubar .p-submenu-list .p-menuitem .p-menuitem-content .p-menuitem-link .p-submenu-icon {\n        margin-left: auto;\n    }\n\n    .p-menubar .p-menubar-end {\n        margin-left: auto;\n        align-self: center;\n    }\n\n    .p-menubar-button {\n        display: none;\n        cursor: pointer;\n        align-items: center;\n        justify-content: center;\n        text-decoration: none;\n    }\n}\n";
var $2e9efb2a85f1d0ec$var$MenubarBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Menubar",
        id: null,
        model: null,
        style: null,
        className: null,
        start: null,
        ariaLabel: null,
        ariaLabelledBy: null,
        onFocus: null,
        onBlur: null,
        submenuIcon: null,
        menuIcon: null,
        end: null,
        children: undefined
    },
    css: {
        classes: $2e9efb2a85f1d0ec$var$classes,
        styles: $2e9efb2a85f1d0ec$var$styles
    }
});
function $2e9efb2a85f1d0ec$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2e9efb2a85f1d0ec$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2e9efb2a85f1d0ec$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $2e9efb2a85f1d0ec$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e9efb2a85f1d0ec$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2e9efb2a85f1d0ec$var$MenubarSub = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(props, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var ptm = props.ptm, cx = props.cx;
    var getPTOptions = function getPTOptions(processedItem, key, index) {
        return ptm(key, {
            props: props,
            hostName: props.hostName,
            context: {
                item: processedItem,
                index: index,
                active: isItemActive(processedItem),
                focused: isItemFocused(processedItem),
                disabled: isItemDisabled(processedItem),
                level: props.level
            }
        });
    };
    var onItemMouseEnter = function onItemMouseEnter(event, item) {
        if (isItemDisabled(item) || props.mobileActive) {
            event.preventDefault();
            return;
        }
        props.onItemMouseEnter && props.onItemMouseEnter({
            originalEvent: event,
            processedItem: item
        });
    };
    var onItemClick = function onItemClick(event, processedItem) {
        var item = processedItem.item;
        if (isItemDisabled(processedItem)) {
            event.preventDefault();
            return;
        }
        if (item.command) item.command({
            originalEvent: event,
            item: item
        });
        onLeafClick({
            originalEvent: event,
            processedItem: processedItem,
            isFocus: true
        });
        if (!item.url) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    var onLeafClick = function onLeafClick(event) {
        props.onLeafClick && props.onLeafClick(event);
    };
    var getItemId = function getItemId(processedItem) {
        var _processedItem$item;
        return (_processedItem$item = processedItem.item) === null || _processedItem$item === void 0 ? void 0 : _processedItem$item.id;
    };
    var getItemDataId = function getItemDataId(processedItem) {
        return "".concat(props.id, "_").concat(processedItem.key);
    };
    var getItemProp = function getItemProp(processedItem, name, params) {
        return processedItem && processedItem.item ? (0, $cfkGk.ObjectUtils).getItemValue(processedItem.item[name], params) : undefined;
    };
    var isItemActive = function isItemActive(processedItem) {
        return props.activeItemPath.some(function(path) {
            return path.key === processedItem.key;
        });
    };
    var isItemVisible = function isItemVisible(processedItem) {
        return getItemProp(processedItem, "visible") !== false;
    };
    var isItemDisabled = function isItemDisabled(processedItem) {
        return getItemProp(processedItem, "disabled");
    };
    var isItemFocused = function isItemFocused(processedItem) {
        return props.focusedItemId === getItemDataId(processedItem);
    };
    var isItemGroup = function isItemGroup(processedItem) {
        return (0, $cfkGk.ObjectUtils).isNotEmpty(processedItem.items);
    };
    var getAriaSetSize = function getAriaSetSize() {
        return props.model.filter(function(processedItem) {
            return isItemVisible(processedItem) && !getItemProp(processedItem, "separator");
        }).length;
    };
    var getAriaPosInset = function getAriaPosInset(index) {
        return index - props.model.slice(0, index).filter(function(processedItem) {
            return isItemVisible(processedItem) && getItemProp(processedItem, "separator");
        }).length + 1;
    };
    var createSeparator = function createSeparator(index) {
        var key = props.id + "_separator_" + index;
        var separatorProps = mergeProps({
            key: key,
            "data-id": key,
            className: cx("separator"),
            role: "separator"
        }, ptm("separator", {
            hostName: props.hostName
        }));
        return /*#__PURE__*/ $81g6h.createElement("li", separatorProps);
    };
    var createSubmenu = function createSubmenu(processedItem) {
        var items = processedItem && processedItem.items;
        if (items) return /*#__PURE__*/ $81g6h.createElement($2e9efb2a85f1d0ec$var$MenubarSub, {
            id: props.id,
            hostName: props.hostName,
            menuProps: props.menuProps,
            level: props.level + 1,
            model: items,
            activeItemPath: props.activeItemPath,
            focusedItemId: props.focusedItemId,
            onLeafClick: onLeafClick,
            onItemMouseEnter: props.onItemMouseEnter,
            submenuIcon: props.submenuIcon,
            ptm: ptm,
            style: {
                display: isItemActive(processedItem) ? "block" : "none"
            },
            cx: cx
        });
        return null;
    };
    var createMenuitem = function createMenuitem(processedItem, index) {
        var item = processedItem.item;
        if (!isItemVisible(processedItem)) return null;
        var id = getItemId(processedItem);
        var dataId = getItemDataId(processedItem);
        var active = isItemActive(processedItem);
        var focused = isItemFocused(processedItem);
        var disabled = isItemDisabled(processedItem) || false;
        var group = isItemGroup(processedItem);
        var linkClassName = (0, $cfkGk.classNames)("p-menuitem-link", {
            "p-disabled": disabled
        });
        var iconClassName = (0, $cfkGk.classNames)("p-menuitem-icon", getItemProp(processedItem, "icon"));
        var iconProps = mergeProps({
            className: cx("icon")
        }, getPTOptions(processedItem, "icon", index));
        var icon = (0, $cfkGk.IconUtils).getJSXIcon(item.icon, $2e9efb2a85f1d0ec$var$_objectSpread$1({}, iconProps), {
            props: props.menuProps
        });
        var labelProps = mergeProps({
            className: cx("label")
        }, getPTOptions(processedItem, "label", index));
        var label = item.label && /*#__PURE__*/ $81g6h.createElement("span", labelProps, item.label);
        var items = getItemProp(processedItem, "items");
        var submenuIconClassName = "p-submenu-icon";
        var submenuIconProps = mergeProps({
            className: cx("submenuIcon")
        }, getPTOptions(processedItem, "submenuIcon", index));
        var submenuIcon = items && (0, $cfkGk.IconUtils).getJSXIcon(!props.root ? props.submenuIcon || /*#__PURE__*/ $81g6h.createElement((0, $1gPAC.AngleRightIcon), submenuIconProps) : props.submenuIcon || /*#__PURE__*/ $81g6h.createElement((0, $5sgNc.AngleDownIcon), submenuIconProps), $2e9efb2a85f1d0ec$var$_objectSpread$1({}, submenuIconProps), {
            props: $2e9efb2a85f1d0ec$var$_objectSpread$1({
                menuProps: props.menuProps
            }, props)
        });
        var submenu = createSubmenu(processedItem);
        var actionProps = mergeProps({
            href: item.url || "#",
            tabIndex: "-1",
            "aria-hidden": "true",
            className: cx("action", {
                disabled: disabled
            }),
            onFocus: function onFocus(event) {
                return event.stopPropagation();
            },
            target: getItemProp(processedItem, "target"),
            "aria-haspopup": items != null
        }, getPTOptions(processedItem, "action", index));
        var content = /*#__PURE__*/ $81g6h.createElement("a", actionProps, icon, label, submenuIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
        if (item.template) {
            var defaultContentOptions = {
                className: linkClassName,
                labelClassName: "p-menuitem-text",
                iconClassName: iconClassName,
                submenuIconClassName: submenuIconClassName,
                element: content,
                props: props
            };
            content = (0, $cfkGk.ObjectUtils).getJSXElement(item.template, item, defaultContentOptions);
        }
        var contentProps = mergeProps({
            onClick: function onClick(event) {
                return onItemClick(event, processedItem);
            },
            onMouseEnter: function onMouseEnter(event) {
                return onItemMouseEnter(event, processedItem);
            },
            className: cx("content")
        }, getPTOptions(processedItem, "content", index));
        var itemClassName = getItemProp(processedItem, "className");
        var menuitemProps = mergeProps($2e9efb2a85f1d0ec$var$_defineProperty({
            id: id,
            key: dataId,
            "data-id": dataId,
            role: "menuitem",
            "aria-label": item.label,
            "aria-disabled": disabled,
            "aria-expanded": group ? active : undefined,
            "aria-haspopup": group && !item.url ? "menu" : undefined,
            "aria-level": props.level + 1,
            "aria-setsize": getAriaSetSize(),
            "aria-posinset": getAriaPosInset(index),
            "data-p-highlight": active,
            "data-p-focused": focused,
            "data-p-disabled": disabled,
            className: (0, $cfkGk.classNames)(itemClassName, cx("menuitem", {
                active: active,
                focused: focused,
                disabled: disabled
            }))
        }, "data-p-disabled", disabled || false), getPTOptions(processedItem, "menuitem", index));
        return /*#__PURE__*/ $81g6h.createElement("li", menuitemProps, /*#__PURE__*/ $81g6h.createElement("div", contentProps, content), submenu);
    };
    var createItem = function createItem(processedItem, index) {
        return getItemProp(processedItem, "separator") ? createSeparator(index) : createMenuitem(processedItem, index);
    };
    var createMenu = function createMenu() {
        return props.model ? props.model.map(createItem) : null;
    };
    var role = props.root ? "menubar" : "menu";
    var ptKey = props.root ? "menu" : "submenu";
    var tabIndex = props.root ? "0" : null;
    var submenu = createMenu();
    var menuProps = mergeProps({
        ref: ref,
        className: cx(ptKey),
        level: props.level,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        onKeyDown: props.onKeyDown,
        "data-id": props.id,
        tabIndex: tabIndex,
        "aria-activedescendant": props.ariaActivedescendant,
        style: props.style,
        role: role
    }, ptm(ptKey));
    return /*#__PURE__*/ $81g6h.createElement("ul", menuProps, submenu);
}));
$2e9efb2a85f1d0ec$var$MenubarSub.displayName = "MenubarSub";
function $2e9efb2a85f1d0ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2e9efb2a85f1d0ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2e9efb2a85f1d0ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2e9efb2a85f1d0ec$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e9efb2a85f1d0ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2e9efb2a85f1d0ec$export$7d4583da7581e674 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $2e9efb2a85f1d0ec$var$MenubarBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState(props.id), _React$useState2 = $2e9efb2a85f1d0ec$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0], setIdState = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(false), _React$useState4 = $2e9efb2a85f1d0ec$var$_slicedToArray(_React$useState3, 2), mobileActiveState = _React$useState4[0], setMobileActiveState = _React$useState4[1];
    var _React$useState5 = $81g6h.useState(false), _React$useState6 = $2e9efb2a85f1d0ec$var$_slicedToArray(_React$useState5, 2), focused = _React$useState6[0], setFocused = _React$useState6[1];
    var _React$useState7 = $81g6h.useState({
        index: -1,
        level: 0,
        parentKey: ""
    }), _React$useState8 = $2e9efb2a85f1d0ec$var$_slicedToArray(_React$useState7, 2), focusedItemInfo = _React$useState8[0], setFocusedItemInfo = _React$useState8[1];
    var _React$useState9 = $81g6h.useState(null), _React$useState10 = $2e9efb2a85f1d0ec$var$_slicedToArray(_React$useState9, 2), focusedItemId = _React$useState10[0], setFocusedItemId = _React$useState10[1];
    var _React$useState11 = $81g6h.useState([]), _React$useState12 = $2e9efb2a85f1d0ec$var$_slicedToArray(_React$useState11, 2), activeItemPath = _React$useState12[0], setActiveItemPath = _React$useState12[1];
    var _React$useState13 = $81g6h.useState([]), _React$useState14 = $2e9efb2a85f1d0ec$var$_slicedToArray(_React$useState13, 2), visibleItems = _React$useState14[0], setVisibleItems = _React$useState14[1];
    var _React$useState15 = $81g6h.useState([]), _React$useState16 = $2e9efb2a85f1d0ec$var$_slicedToArray(_React$useState15, 2), processedItems = _React$useState16[0], setProcessedItems = _React$useState16[1];
    var _React$useState17 = $81g6h.useState(false), _React$useState18 = $2e9efb2a85f1d0ec$var$_slicedToArray(_React$useState17, 2), focusTrigger = _React$useState18[0], setFocusTrigger = _React$useState18[1];
    var _React$useState19 = $81g6h.useState(false), _React$useState20 = $2e9efb2a85f1d0ec$var$_slicedToArray(_React$useState19, 2), dirty = _React$useState20[0], setDirty = _React$useState20[1];
    var elementRef = $81g6h.useRef(null);
    var rootMenuRef = $81g6h.useRef(null);
    var menuButtonRef = $81g6h.useRef(null);
    var searchValue = $81g6h.useRef("");
    var searchTimeout = $81g6h.useRef(null);
    var reverseTrigger = $81g6h.useRef(false);
    var _MenubarBase$setMetaD = $2e9efb2a85f1d0ec$var$MenubarBase.setMetaData({
        props: props,
        state: {
            id: idState,
            mobileActive: mobileActiveState
        }
    }), ptm = _MenubarBase$setMetaD.ptm, cx = _MenubarBase$setMetaD.cx, isUnstyled = _MenubarBase$setMetaD.isUnstyled;
    (0, $4gQLd.useHandleStyle)($2e9efb2a85f1d0ec$var$MenubarBase.css.styles, isUnstyled, {
        name: "menubar"
    });
    var _useEventListener = (0, $l2NC0.useEventListener)({
        type: "click",
        listener: function listener(event) {
            if (isOutsideClicked(event)) {
                var isOutsideContainer = elementRef.current && !elementRef.current.contains(event.target);
                if (isOutsideContainer) hide();
            }
        }
    }), _useEventListener2 = $2e9efb2a85f1d0ec$var$_slicedToArray(_useEventListener, 2), bindOutsideClickListener = _useEventListener2[0], unbindOutsideClickListener = _useEventListener2[1];
    var _useResizeListener = (0, $l2NC0.useResizeListener)({
        listener: function listener(event) {
            if (!(0, $cfkGk.DomHandler).isTouchDevice()) hide(event);
        }
    }), _useResizeListener2 = $2e9efb2a85f1d0ec$var$_slicedToArray(_useResizeListener, 2), bindResizeListener = _useResizeListener2[0], unbindResizeListener = _useResizeListener2[1];
    var toggle = function toggle(event) {
        if (mobileActiveState) {
            setMobileActiveState(false);
            hide();
        } else {
            setMobileActiveState(true);
            setTimeout(function() {
                show();
            }, 1);
        }
        event.preventDefault();
    };
    var show = function show() {
        setFocusedItemInfo({
            index: findFirstFocusedItemIndex(),
            level: 0,
            parentKey: ""
        });
        (0, $cfkGk.DomHandler).focus(rootMenuRef.current);
    };
    var hide = function hide(isFocus) {
        if (mobileActiveState) {
            setMobileActiveState(false);
            setTimeout(function() {
                (0, $cfkGk.DomHandler).focus(menuButtonRef.current);
            }, 0);
        }
        setActiveItemPath([]);
        setFocusedItemInfo({
            index: -1,
            level: 0,
            parentKey: ""
        });
        isFocus && (0, $cfkGk.DomHandler).focus(rootMenuRef.current);
        setDirty(false);
    };
    var menuButtonKeydown = function menuButtonKeydown(event) {
        (event.code === "Enter" || event.code === "NumpadEnter" || event.code === "Space") && toggle(event);
    };
    var isOutsideClicked = function isOutsideClicked(event) {
        return rootMenuRef.current !== event.target && !rootMenuRef.current.contains(event.target) && menuButtonRef.current !== event.target && !menuButtonRef.current.contains(event.target);
    };
    var getItemProp = function getItemProp(item, name) {
        return item ? (0, $cfkGk.ObjectUtils).getItemValue(item[name]) : undefined;
    };
    var getItemLabel = function getItemLabel(item) {
        return getItemProp(item, "label");
    };
    var isItemDisabled = function isItemDisabled(item) {
        return getItemProp(item, "disabled");
    };
    var isItemSeparator = function isItemSeparator(item) {
        return getItemProp(item, "separator");
    };
    var getProccessedItemLabel = function getProccessedItemLabel(processedItem) {
        return processedItem ? getItemLabel(processedItem.item) : undefined;
    };
    var isProccessedItemGroup = function isProccessedItemGroup(processedItem) {
        return processedItem && (0, $cfkGk.ObjectUtils).isNotEmpty(processedItem.items);
    };
    var onFocus = function onFocus(event) {
        setFocused(true);
        setFocusedItemInfo(focusedItemInfo.index !== -1 ? focusedItemInfo : {
            index: findFirstFocusedItemIndex(),
            level: 0,
            parentKey: ""
        });
        props.onFocus && props.onFocus(event);
    };
    var onBlur = function onBlur(event) {
        setFocused(false);
        setFocusedItemInfo({
            index: -1,
            level: 0,
            parentKey: ""
        });
        searchValue.current = "";
        setDirty(false);
        props.onBlur && props.onBlur(event);
    };
    var onKeyDown = function onKeyDown(event) {
        var metaKey = event.metaKey || event.ctrlKey;
        var code = event.code;
        switch(code){
            case "ArrowDown":
                onArrowDownKey(event);
                break;
            case "ArrowUp":
                onArrowUpKey(event);
                break;
            case "ArrowLeft":
                onArrowLeftKey(event);
                break;
            case "ArrowRight":
                onArrowRightKey(event);
                break;
            case "Home":
                onHomeKey(event);
                break;
            case "End":
                onEndKey(event);
                break;
            case "Space":
                onSpaceKey(event);
                break;
            case "Enter":
            case "NumpadEnter":
                onEnterKey(event);
                break;
            case "Escape":
                onEscapeKey();
                break;
            case "Tab":
                onTabKey(event);
                break;
            case "PageDown":
            case "PageUp":
            case "Backspace":
            case "ShiftLeft":
            case "ShiftRight":
                break;
            default:
                if (!metaKey && (0, $cfkGk.ObjectUtils).isPrintableCharacter(event.key)) searchItems(event, event.key);
                break;
        }
    };
    var onItemChange = function onItemChange(event) {
        var processedItem = event.processedItem, isFocus = event.isFocus;
        if ((0, $cfkGk.ObjectUtils).isEmpty(processedItem)) return;
        var index = processedItem.index, key = processedItem.key, level = processedItem.level, parentKey = processedItem.parentKey, items = processedItem.items;
        var grouped = (0, $cfkGk.ObjectUtils).isNotEmpty(items);
        var _activeItemPath = activeItemPath.filter(function(p) {
            return p.parentKey !== parentKey && p.parentKey !== key;
        });
        grouped && _activeItemPath.push(processedItem);
        setFocusedItemInfo({
            index: index,
            level: level,
            parentKey: parentKey
        });
        setActiveItemPath(_activeItemPath);
        grouped && setDirty(true);
        isFocus && (0, $cfkGk.DomHandler).focus(rootMenuRef.current);
    };
    var onItemClick = function onItemClick(event) {
        var originalEvent = event.originalEvent, processedItem = event.processedItem;
        var grouped = isProccessedItemGroup(processedItem);
        var root = (0, $cfkGk.ObjectUtils).isEmpty(processedItem.parent);
        var selected = isSelected(processedItem);
        if (selected) {
            var index = processedItem.index, key = processedItem.key, level = processedItem.level, parentKey = processedItem.parentKey;
            setActiveItemPath(activeItemPath.filter(function(p) {
                return key !== p.key && key.startsWith(p.key);
            }));
            setFocusedItemInfo({
                index: index,
                level: level,
                parentKey: parentKey
            });
            if (!grouped) setDirty(!root);
            setTimeout(function() {
                (0, $cfkGk.DomHandler).focus(rootMenuRef.current);
                if (grouped) setDirty(true);
            }, 0);
        } else if (grouped) {
            (0, $cfkGk.DomHandler).focus(rootMenuRef.current);
            onItemChange({
                originalEvent: originalEvent,
                processedItem: processedItem
            });
        } else {
            var rootProcessedItem = root ? processedItem : activeItemPath.find(function(p) {
                return p.parentKey === "";
            });
            var rootProcessedItemIndex = rootProcessedItem ? rootProcessedItem.index : -1;
            hide(originalEvent);
            setFocusedItemInfo({
                index: rootProcessedItemIndex,
                parentKey: rootProcessedItem ? rootProcessedItem.parentKey : ""
            });
            setMobileActiveState(false);
        }
    };
    var onItemMouseEnter = function onItemMouseEnter(event) {
        if (!mobileActiveState && dirty) onItemChange(event);
    };
    var onArrowDownKey = function onArrowDownKey(event) {
        var processedItem = visibleItems[focusedItemInfo.index];
        var root = processedItem ? (0, $cfkGk.ObjectUtils).isEmpty(processedItem.parent) : null;
        if (root) {
            var grouped = isProccessedItemGroup(processedItem);
            if (grouped) {
                onItemChange({
                    originalEvent: event,
                    processedItem: processedItem
                });
                setFocusedItemInfo({
                    index: -1,
                    parentKey: processedItem.key
                });
                setTimeout(function() {
                    return setFocusTrigger(true);
                }, 0);
            }
        } else {
            var itemIndex = focusedItemInfo.index !== -1 ? findNextItemIndex(focusedItemInfo.index) : findFirstFocusedItemIndex();
            changeFocusedItemIndex(itemIndex);
        }
        event.preventDefault();
    };
    var onArrowUpKey = function onArrowUpKey(event) {
        var processedItem = visibleItems[focusedItemInfo.index];
        var root = (0, $cfkGk.ObjectUtils).isEmpty(processedItem.parent);
        if (root) {
            var grouped = isProccessedItemGroup(processedItem);
            if (grouped) {
                onItemChange({
                    originalEvent: event,
                    processedItem: processedItem
                });
                setFocusedItemInfo({
                    index: -1,
                    parentKey: processedItem.key
                });
                reverseTrigger.current = true;
                setTimeout(function() {
                    return setFocusTrigger(true);
                }, 0);
            }
        } else {
            var parentItem = activeItemPath.find(function(p) {
                return p.key === processedItem.parentKey;
            });
            if (focusedItemInfo.index === 0 && parentItem && parentItem.parentKey === "") {
                setFocusedItemInfo({
                    index: -1,
                    parentKey: parentItem ? parentItem.parentKey : ""
                });
                searchValue.current = "";
                onArrowLeftKey(event);
            } else {
                var itemIndex = focusedItemInfo.index !== -1 ? findPrevItemIndex(focusedItemInfo.index) : findLastFocusedItemIndex();
                changeFocusedItemIndex(itemIndex);
            }
        }
        event.preventDefault();
    };
    var onArrowLeftKey = function onArrowLeftKey(event) {
        var processedItem = visibleItems[focusedItemInfo.index];
        var parentItem = processedItem ? activeItemPath.find(function(p) {
            return p.key === processedItem.parentKey;
        }) : null;
        if (parentItem) {
            onItemChange({
                originalEvent: event,
                processedItem: parentItem
            });
            setActiveItemPath(activeItemPath.filter(function(p) {
                return p.key !== parentItem.key;
            }));
        } else {
            var itemIndex = focusedItemInfo.index !== -1 ? findPrevItemIndex(focusedItemInfo.index) : findLastFocusedItemIndex();
            changeFocusedItemIndex(itemIndex);
        }
        event.preventDefault();
    };
    var onArrowRightKey = function onArrowRightKey(event) {
        var processedItem = visibleItems[focusedItemInfo.index];
        var parentItem = processedItem ? activeItemPath.find(function(p) {
            return p.key === processedItem.parentKey;
        }) : null;
        if (parentItem) {
            var grouped = isProccessedItemGroup(processedItem);
            if (grouped) {
                onItemChange({
                    originalEvent: event,
                    processedItem: processedItem
                });
                setFocusedItemInfo({
                    index: -1,
                    parentKey: processedItem.key
                });
                setTimeout(function() {
                    return setFocusTrigger(true);
                }, 0);
            }
        } else {
            var itemIndex = focusedItemInfo.index !== -1 ? findNextItemIndex(focusedItemInfo.index) : findFirstFocusedItemIndex();
            changeFocusedItemIndex(itemIndex);
        }
        event.preventDefault();
    };
    var onHomeKey = function onHomeKey(event) {
        changeFocusedItemIndex(findFirstItemIndex());
        event.preventDefault();
    };
    var onEndKey = function onEndKey(event) {
        changeFocusedItemIndex(findLastItemIndex());
        event.preventDefault();
    };
    var onEnterKey = function onEnterKey(event) {
        if (focusedItemInfo.index !== -1) {
            var element = (0, $cfkGk.DomHandler).findSingle(rootMenuRef.current, 'li[data-id="'.concat("".concat(focusedItemId), '"]'));
            var anchorElement = element && (0, $cfkGk.DomHandler).findSingle(element, 'a[data-pc-section="action"]');
            anchorElement ? anchorElement.click() : element && element.click();
        }
        event.preventDefault();
    };
    var onSpaceKey = function onSpaceKey(event) {
        onEnterKey(event);
    };
    var onEscapeKey = function onEscapeKey(event) {
        hide(true);
        setFocusedItemInfo({
            focusedItemInfo: focusedItemInfo,
            index: findFirstFocusedItemIndex()
        });
    };
    var onTabKey = function onTabKey(event) {
        if (focusedItemInfo.index !== -1) {
            var processedItem = visibleItems[focusedItemInfo.index];
            var grouped = isProccessedItemGroup(processedItem);
            !grouped && onItemChange({
                originalEvent: event,
                processedItem: processedItem
            });
        }
        hide();
    };
    var isItemMatched = function isItemMatched(processedItem) {
        return isValidItem(processedItem) && getProccessedItemLabel(processedItem).toLocaleLowerCase().startsWith(searchValue.current.toLocaleLowerCase());
    };
    var isValidItem = function isValidItem(processedItem) {
        return !!processedItem && !isItemDisabled(processedItem.item) && !isItemSeparator(processedItem.item);
    };
    var isValidSelectedItem = function isValidSelectedItem(processedItem) {
        return isValidItem(processedItem) && isSelected(processedItem);
    };
    var isSelected = function isSelected(processedItem) {
        return activeItemPath.some(function(p) {
            return p.key === processedItem.key;
        });
    };
    var findFirstItemIndex = function findFirstItemIndex() {
        return visibleItems.findIndex(function(processedItem) {
            return isValidItem(processedItem);
        });
    };
    var findLastItemIndex = function findLastItemIndex() {
        return (0, $cfkGk.ObjectUtils).findLastIndex(visibleItems, function(processedItem) {
            return isValidItem(processedItem);
        });
    };
    var findNextItemIndex = function findNextItemIndex(index) {
        var matchedItemIndex = index < visibleItems.length - 1 ? visibleItems.slice(index + 1).findIndex(function(processedItem) {
            return isValidItem(processedItem);
        }) : -1;
        return matchedItemIndex > -1 ? matchedItemIndex + index + 1 : index;
    };
    var findPrevItemIndex = function findPrevItemIndex(index) {
        var matchedItemIndex = index > 0 ? (0, $cfkGk.ObjectUtils).findLastIndex(visibleItems.slice(0, index), function(processedItem) {
            return isValidItem(processedItem);
        }) : -1;
        return matchedItemIndex > -1 ? matchedItemIndex : index;
    };
    var findSelectedItemIndex = function findSelectedItemIndex() {
        return visibleItems.findIndex(function(processedItem) {
            return isValidSelectedItem(processedItem);
        });
    };
    var findFirstFocusedItemIndex = function findFirstFocusedItemIndex() {
        var selectedIndex = findSelectedItemIndex();
        return selectedIndex < 0 ? findFirstItemIndex() : selectedIndex;
    };
    var findLastFocusedItemIndex = function findLastFocusedItemIndex() {
        var selectedIndex = findSelectedItemIndex();
        return selectedIndex < 0 ? findLastItemIndex() : selectedIndex;
    };
    var searchItems = function searchItems(event, _char) {
        searchValue.current = (searchValue.current || "") + _char;
        var itemIndex = -1;
        var matched = false;
        if (focusedItemInfo.index !== -1) {
            itemIndex = visibleItems.slice(focusedItemInfo.index).findIndex(function(processedItem) {
                return isItemMatched(processedItem);
            });
            itemIndex = itemIndex === -1 ? visibleItems.slice(0, focusedItemInfo.index).findIndex(function(processedItem) {
                return isItemMatched(processedItem);
            }) : itemIndex + focusedItemInfo.index;
        } else itemIndex = visibleItems.findIndex(function(processedItem) {
            return isItemMatched(processedItem);
        });
        if (itemIndex !== -1) matched = true;
        if (itemIndex === -1 && focusedItemInfo.index === -1) itemIndex = findFirstFocusedItemIndex();
        if (itemIndex !== -1) changeFocusedItemIndex(itemIndex);
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(function() {
            searchValue.current = "";
            searchTimeout.current = null;
        }, 500);
        return matched;
    };
    var changeFocusedItemIndex = function changeFocusedItemIndex(index) {
        if (focusedItemInfo.index !== index) {
            setFocusedItemInfo($2e9efb2a85f1d0ec$var$_objectSpread($2e9efb2a85f1d0ec$var$_objectSpread({}, focusedItemInfo), {}, {
                index: index
            }));
            scrollInView();
        }
    };
    var scrollInView = function scrollInView() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
        var id = index !== -1 ? "".concat(idState, "_").concat(index) : focusedItemId;
        var element = (0, $cfkGk.DomHandler).findSingle(rootMenuRef.current, 'li[data-id="'.concat(id, '"]'));
        if (element) element.scrollIntoView && element.scrollIntoView({
            block: "nearest",
            inline: "start"
        });
    };
    var createProcessedItems = $81g6h.useCallback(function(items) {
        var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var parentKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
        var _processedItems = [];
        items && items.forEach(function(item, index) {
            var key = (parentKey !== "" ? parentKey + "_" : "") + index;
            var newItem = {
                item: item,
                index: index,
                level: level,
                key: key,
                parent: parent,
                parentKey: parentKey
            };
            newItem.items = createProcessedItems(item.items, level + 1, newItem, key);
            _processedItems.push(newItem);
        });
        return _processedItems;
    }, []);
    (0, $l2NC0.useMountEffect)(function() {
        if (!idState) setIdState((0, $cfkGk.UniqueComponentId)());
    });
    (0, $l2NC0.useUpdateEffect)(function() {
        if (mobileActiveState) {
            bindOutsideClickListener();
            bindResizeListener();
            (0, $cfkGk.ZIndexUtils).set("menu", rootMenuRef.current, context && context.autoZIndex || (0, $8Zwsm.default).autoZIndex, context && context.zIndex.menu || (0, $8Zwsm.default).zIndex.menu);
        } else {
            unbindResizeListener();
            unbindOutsideClickListener();
            (0, $cfkGk.ZIndexUtils).clear(rootMenuRef.current);
        }
    }, [
        mobileActiveState
    ]);
    $81g6h.useEffect(function() {
        var itemsToProcess = props.model || [];
        var processed = createProcessedItems(itemsToProcess, 0, null, "");
        setProcessedItems(processed);
    }, [
        props.model,
        createProcessedItems
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        var processedItem = activeItemPath.find(function(p) {
            return p.key === focusedItemInfo.parentKey;
        });
        var _processedItems = processedItem ? processedItem.items : processedItems;
        setVisibleItems(_processedItems);
    }, [
        activeItemPath,
        focusedItemInfo,
        processedItems
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if ((0, $cfkGk.ObjectUtils).isNotEmpty(activeItemPath)) {
            bindOutsideClickListener();
            bindResizeListener();
        } else {
            unbindOutsideClickListener();
            unbindResizeListener();
        }
    }, [
        activeItemPath
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (focusTrigger) {
            var itemIndex = focusedItemInfo.index !== -1 ? findNextItemIndex(focusedItemInfo.index) : reverseTrigger.current ? findLastItemIndex() : findFirstFocusedItemIndex();
            changeFocusedItemIndex(itemIndex);
            reverseTrigger.current = false;
            setFocusTrigger(false);
        }
    }, [
        focusTrigger
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        setFocusedItemId(focusedItemInfo.index !== -1 ? "".concat(idState).concat((0, $cfkGk.ObjectUtils).isNotEmpty(focusedItemInfo.parentKey) ? "_" + focusedItemInfo.parentKey : "", "_").concat(focusedItemInfo.index) : null);
    }, [
        focusedItemInfo
    ]);
    (0, $l2NC0.useUnmountEffect)(function() {
        (0, $cfkGk.ZIndexUtils).clear(rootMenuRef.current);
    });
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            toggle: toggle,
            getElement: function getElement() {
                return elementRef.current;
            },
            getRootMenu: function getRootMenu() {
                return rootMenuRef.current;
            },
            getMenuButton: function getMenuButton() {
                return menuButtonRef.current;
            }
        };
    });
    var createStartContent = function createStartContent() {
        if (props.start) {
            var _start = (0, $cfkGk.ObjectUtils).getJSXElement(props.start, props);
            var startProps = mergeProps({
                className: cx("start")
            }, ptm("start"));
            return /*#__PURE__*/ $81g6h.createElement("div", startProps, _start);
        }
        return null;
    };
    var createEndContent = function createEndContent() {
        if (props.end) {
            var _end = (0, $cfkGk.ObjectUtils).getJSXElement(props.end, props);
            var endProps = mergeProps({
                className: cx("end")
            }, ptm("end"));
            return /*#__PURE__*/ $81g6h.createElement("div", endProps, _end);
        }
        return null;
    };
    var createMenuButton = function createMenuButton() {
        if (props.model && props.model.length < 1) return null;
        var buttonProps = mergeProps($2e9efb2a85f1d0ec$var$_defineProperty($2e9efb2a85f1d0ec$var$_defineProperty($2e9efb2a85f1d0ec$var$_defineProperty($2e9efb2a85f1d0ec$var$_defineProperty({
            ref: menuButtonRef,
            href: "#",
            tabIndex: "0",
            "aria-haspopup": mobileActiveState && props.model && props.model.length > 0 ? true : false,
            "aria-expanded": mobileActiveState,
            "aria-label": (0, $8Zwsm.ariaLabel)("navigation"),
            "aria-controls": idState,
            role: "button"
        }, "tabIndex", 0), "className", cx("button")), "onKeyDown", function onKeyDown(e) {
            return menuButtonKeydown(e);
        }), "onClick", function onClick(e) {
            return toggle(e);
        }), ptm("button"));
        var popupIconProps = mergeProps(ptm("popupIcon"));
        var icon = props.menuIcon || /*#__PURE__*/ $81g6h.createElement((0, $6NeNe.BarsIcon), popupIconProps);
        var menuIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $2e9efb2a85f1d0ec$var$_objectSpread({}, popupIconProps), {
            props: props
        });
        /* eslint-disable */ var button = /*#__PURE__*/ $81g6h.createElement("a", buttonProps, menuIcon);
        /* eslint-enable */ return button;
    };
    var start = createStartContent();
    var end = createEndContent();
    var menuButton = createMenuButton();
    var submenu = /*#__PURE__*/ $81g6h.createElement($2e9efb2a85f1d0ec$var$MenubarSub, {
        hostName: "Menubar",
        ariaActivedescendant: focused ? focusedItemId : undefined,
        level: 0,
        id: idState,
        ref: rootMenuRef,
        menuProps: props,
        model: processedItems,
        onLeafClick: onItemClick,
        onItemMouseEnter: onItemMouseEnter,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        root: true,
        activeItemPath: activeItemPath,
        focusedItemId: focused ? focusedItemId : undefined,
        submenuIcon: props.submenuIcon,
        ptm: ptm,
        cx: cx
    });
    var rootProps = mergeProps({
        id: props.id,
        ref: elementRef,
        className: (0, $cfkGk.classNames)(props.className, cx("root", {
            mobileActiveState: mobileActiveState
        })),
        style: props.style
    }, $2e9efb2a85f1d0ec$var$MenubarBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $81g6h.createElement("div", rootProps, start, menuButton, submenu, end);
}));
$2e9efb2a85f1d0ec$export$7d4583da7581e674.displayName = "Menubar";



var $bY9wC = parcelRequire("bY9wC");

var $cfkGk = parcelRequire("cfkGk");

var $81g6h = parcelRequire("81g6h");
parcelRequire("hE6rp");
var $kEwLa = parcelRequire("kEwLa");
var $hE6rp = parcelRequire("hE6rp");

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $5kXMA = parcelRequire("5kXMA");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $eWFm9 = parcelRequire("eWFm9");

var $kKnoQ = parcelRequire("kKnoQ");

var $ghfIB = parcelRequire("ghfIB");

var $1IWnK = parcelRequire("1IWnK");

var $4nRkH = parcelRequire("4nRkH");
var $fd62a67a5ad1fb95$var$DesktopTabState;
(function(DesktopTabState) {
    DesktopTabState["DEFAULT"] = "default";
    DesktopTabState["HOVER"] = "hover";
})($fd62a67a5ad1fb95$var$DesktopTabState || ($fd62a67a5ad1fb95$var$DesktopTabState = {}));
const $fd62a67a5ad1fb95$var$DESKTOP_TAB_COLORS = {
    ["default"]: (0, $kKnoQ.colors).onboardingPrimary,
    ["hover"]: (0, $kKnoQ.colors).onboardingPrimaryDark
};
var $fd62a67a5ad1fb95$var$MobileTabState;
(function(MobileTabState) {
    MobileTabState["DEFAULT"] = "default";
    MobileTabState["ACTIVE"] = "active";
})($fd62a67a5ad1fb95$var$MobileTabState || ($fd62a67a5ad1fb95$var$MobileTabState = {}));
const $fd62a67a5ad1fb95$var$MOBILE_TAB_COLORS = {
    ["default"]: (0, $kKnoQ.colors).grey80,
    ["active"]: (0, $kKnoQ.colors).onboardingPrimary
};
const $fd62a67a5ad1fb95$export$be2c7398042971e0 = ({ isSelected: isSelected = false })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const completedCount = (0, $1IWnK.useObservable)((0, $ghfIB.getStartedManager).completedCount);
    const progress = (0, $81g6h.useMemo)(()=>$fd62a67a5ad1fb95$var$toPercentage(completedCount, (0, $4nRkH.getStartedSteps).length), [
        completedCount
    ]);
    const progressCircle = (0, $81g6h.useMemo)(()=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $eWFm9.ProgressCircle), {
            size: isDesktop ? 24 : 22,
            strokeWidth: 4,
            progress: progress,
            strokeProgressColor: "rgba(255, 255, 255, 0.85)",
            strokeBackgroundColor: "rgba(255, 255, 255, 0.35)"
        }), [
        isDesktop,
        progress
    ]);
    return isDesktop ? /*#__PURE__*/ (0, $iKObn.jsxs)($fd62a67a5ad1fb95$var$DesktopContainer, {
        isSelected: isSelected,
        children: [
            progressCircle,
            /*#__PURE__*/ (0, $iKObn.jsx)($fd62a67a5ad1fb95$var$DekstopLabelContainer, {
                className: "p-size-s-bold",
                children: format("tabbar.getStarted", {
                    completedCount: completedCount,
                    totalCount: 3
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $iKObn.jsxs)($fd62a67a5ad1fb95$var$MobileContainer, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($fd62a67a5ad1fb95$var$MobileProgressCircleContainer, {
                isSelected: isSelected,
                children: progressCircle
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($fd62a67a5ad1fb95$var$MobileLabelContainer, {
                isSelected: isSelected,
                className: "p-size-xs-extra-bold",
                children: format("tabbar.getStarted.mobile")
            })
        ]
    });
};
const $fd62a67a5ad1fb95$var$toPercentage = (completedCount, countMax)=>completedCount === countMax ? 100 : Math.trunc(completedCount / countMax * 100);
const $fd62a67a5ad1fb95$var$DesktopContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("XS", undefined, "center")};
	width: fit-content;
	border-radius: 10px;
	padding-inline: 10px;
	padding-block: 7px;
	background-color: ${$fd62a67a5ad1fb95$var$DESKTOP_TAB_COLORS.default};
	box-shadow: 0px 3px 7px 0px ${(0, $kKnoQ.colors).grey3};

	${({ isSelected: isSelected })=>!isSelected && `&:hover {
		background-color: ${$fd62a67a5ad1fb95$var$DESKTOP_TAB_COLORS.hover};
	}`}
`;
const $fd62a67a5ad1fb95$var$DekstopLabelContainer = (0, $5UMQ1.default).p`
	color: ${(0, $kKnoQ.colors).white};
`;
const $fd62a67a5ad1fb95$var$MobileContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "center")};
`;
const $fd62a67a5ad1fb95$var$MobileProgressCircleContainer = (0, $5UMQ1.default).div`
	display: grid;
	place-items: center;
	border-radius: 50%;
	width: 28px;
	height: 28px;
	margin-block: 2px 2px;
	background-color: ${({ isSelected: isSelected })=>isSelected ? $fd62a67a5ad1fb95$var$MOBILE_TAB_COLORS.active : $fd62a67a5ad1fb95$var$MOBILE_TAB_COLORS.default};
`;
const $fd62a67a5ad1fb95$var$MobileLabelContainer = (0, $5UMQ1.default).span`
	color: ${({ isSelected: isSelected })=>isSelected ? $fd62a67a5ad1fb95$var$MOBILE_TAB_COLORS.active : $fd62a67a5ad1fb95$var$MOBILE_TAB_COLORS.default};
`;



var $lTdpc = parcelRequire("lTdpc");

var $ghfIB = parcelRequire("ghfIB");

var $1IWnK = parcelRequire("1IWnK");
var $9d5737b4788a71b9$var$PatientListSelectedIcon = function PatientListSelectedIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M21.333 18.667c-1.11 0-2.055-.39-2.833-1.167-.778-.778-1.167-1.722-1.167-2.833 0-1.111.39-2.056 1.167-2.834.778-.777 1.722-1.166 2.833-1.166 1.111 0 2.056.389 2.834 1.166.777.778 1.166 1.723 1.166 2.834 0 1.11-.389 2.055-1.166 2.833-.778.778-1.723 1.167-2.834 1.167Zm-6.666 8a1.29 1.29 0 0 1-.95-.384 1.29 1.29 0 0 1-.384-.95v-1.2c0-.466.111-.91.334-1.333a2.53 2.53 0 0 1 .933-1c1-.6 2.061-1.05 3.183-1.35 1.123-.3 2.306-.45 3.55-.45 1.245 0 2.428.15 3.55.45 1.123.3 2.184.75 3.184 1.35.4.244.71.578.933 1 .222.422.333.867.333 1.333v1.2c0 .378-.127.695-.383.95a1.29 1.29 0 0 1-.95.384H14.667ZM16.2 24h10.267A9.916 9.916 0 0 0 24 23a10.695 10.695 0 0 0-2.667-.333c-.91 0-1.8.11-2.666.333a9.916 9.916 0 0 0-2.467 1Zm5.133-8c.378 0 .695-.128.95-.383a1.29 1.29 0 0 0 .384-.95 1.29 1.29 0 0 0-.384-.95 1.29 1.29 0 0 0-.95-.384 1.29 1.29 0 0 0-.95.384 1.29 1.29 0 0 0-.383.95c0 .377.128.694.383.95.256.255.573.383.95.383Zm-8 2.667h-8a1.29 1.29 0 0 1-.95-.384 1.29 1.29 0 0 1-.383-.95c0-.377.128-.694.383-.95a1.29 1.29 0 0 1 .95-.383h8c.378 0 .695.128.95.383.256.256.384.573.384.95 0 .378-.128.695-.384.95a1.29 1.29 0 0 1-.95.384ZM18.667 8H5.333a1.29 1.29 0 0 1-.95-.383A1.29 1.29 0 0 1 4 6.667c0-.378.128-.695.383-.95a1.29 1.29 0 0 1 .95-.384h13.334c.377 0 .694.128.95.384.255.255.383.572.383.95 0 .377-.128.694-.383.95a1.29 1.29 0 0 1-.95.383ZM14.8 13.333H5.333a1.29 1.29 0 0 1-.95-.383A1.29 1.29 0 0 1 4 12c0-.378.128-.694.383-.95a1.29 1.29 0 0 1 .95-.383H16a5.022 5.022 0 0 0-.75 1.233 8.003 8.003 0 0 0-.45 1.433Z",
            fill: "currentColor"
        })
    });
};
$9d5737b4788a71b9$var$PatientListSelectedIcon.defaultProps = {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $9d5737b4788a71b9$var$PatientListIcon = function PatientListIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M21.333 18.667c-1.11 0-2.055-.39-2.833-1.167-.778-.778-1.167-1.722-1.167-2.833 0-1.111.39-2.056 1.167-2.834.778-.777 1.722-1.166 2.833-1.166 1.111 0 2.056.389 2.834 1.166.777.778 1.166 1.723 1.166 2.834 0 1.11-.389 2.055-1.166 2.833-.778.778-1.723 1.167-2.834 1.167Zm-6.666 8a1.29 1.29 0 0 1-.95-.384 1.29 1.29 0 0 1-.384-.95v-1.2c0-.466.111-.91.334-1.333a2.53 2.53 0 0 1 .933-1c1-.6 2.061-1.05 3.183-1.35 1.123-.3 2.306-.45 3.55-.45 1.245 0 2.428.15 3.55.45 1.123.3 2.184.75 3.184 1.35.4.244.71.578.933 1 .222.422.333.867.333 1.333v1.2c0 .378-.127.695-.383.95a1.29 1.29 0 0 1-.95.384H14.667ZM16.2 24h10.267A9.916 9.916 0 0 0 24 23a10.695 10.695 0 0 0-2.667-.333c-.91 0-1.8.11-2.666.333a9.916 9.916 0 0 0-2.467 1Zm5.133-8c.378 0 .695-.128.95-.383a1.29 1.29 0 0 0 .384-.95 1.29 1.29 0 0 0-.384-.95 1.29 1.29 0 0 0-.95-.384 1.29 1.29 0 0 0-.95.384 1.29 1.29 0 0 0-.383.95c0 .377.128.694.383.95.256.255.573.383.95.383Zm-8 2.667h-8a1.29 1.29 0 0 1-.95-.384 1.29 1.29 0 0 1-.383-.95c0-.377.128-.694.383-.95a1.29 1.29 0 0 1 .95-.383h8c.378 0 .695.128.95.383.256.256.384.573.384.95 0 .378-.128.695-.384.95a1.29 1.29 0 0 1-.95.384ZM18.667 8H5.333a1.29 1.29 0 0 1-.95-.383A1.29 1.29 0 0 1 4 6.667c0-.378.128-.695.383-.95a1.29 1.29 0 0 1 .95-.384h13.334c.377 0 .694.128.95.384.255.255.383.572.383.95 0 .377-.128.694-.383.95a1.29 1.29 0 0 1-.95.383ZM14.8 13.333H5.333a1.29 1.29 0 0 1-.95-.383A1.29 1.29 0 0 1 4 12c0-.378.128-.694.383-.95a1.29 1.29 0 0 1 .95-.383H16a5.022 5.022 0 0 0-.75 1.233 8.003 8.003 0 0 0-.45 1.433Z",
            fill: "currentColor"
        })
    });
};
$9d5737b4788a71b9$var$PatientListIcon.defaultProps = {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $9d5737b4788a71b9$var$TemplateSelectedIcon = function TemplateSelectedIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M13.818 11.09a.88.88 0 0 0 .648-.26.88.88 0 0 0 .261-.648v-.91h.91a.88.88 0 0 0 .647-.26.88.88 0 0 0 .261-.648.88.88 0 0 0-.261-.648.88.88 0 0 0-.648-.261h-.909v-.91a.88.88 0 0 0-.261-.647.88.88 0 0 0-.648-.262.88.88 0 0 0-.648.262.88.88 0 0 0-.261.647v.91h-.91a.88.88 0 0 0-.647.26.88.88 0 0 0-.261.649.88.88 0 0 0 .261.647.88.88 0 0 0 .648.262h.909v.909a.88.88 0 0 0 .261.647.88.88 0 0 0 .648.262ZM12 14.728h3.636a.88.88 0 0 0 .648-.261.88.88 0 0 0 .261-.648.88.88 0 0 0-.261-.647.88.88 0 0 0-.648-.262H12a.88.88 0 0 0-.648.261.88.88 0 0 0-.261.648.88.88 0 0 0 .261.648.88.88 0 0 0 .648.261Zm-3.182 3.637c-.5 0-.928-.178-1.284-.535A1.75 1.75 0 0 1 7 16.546V3.819c0-.5.178-.928.534-1.284A1.75 1.75 0 0 1 8.818 2h5.614a1.795 1.795 0 0 1 1.272.523l4.41 4.409a1.795 1.795 0 0 1 .523 1.273v8.34c0 .5-.179.928-.535 1.284a1.75 1.75 0 0 1-1.284.535h-10Zm0-1.819h10V8.365l-4.545-4.546H8.818v12.728ZM5.182 22c-.5 0-.928-.178-1.284-.534a1.75 1.75 0 0 1-.534-1.284V8.364a.88.88 0 0 1 .26-.648.88.88 0 0 1 .649-.261.88.88 0 0 1 .647.26.88.88 0 0 1 .262.649v11.818h9.09a.88.88 0 0 1 .648.261.88.88 0 0 1 .262.648.88.88 0 0 1-.262.648.88.88 0 0 1-.647.261H5.182Z",
            fill: "currentColor"
        })
    });
};
$9d5737b4788a71b9$var$TemplateSelectedIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $9d5737b4788a71b9$var$TemplateIcon = function TemplateIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M13.818 11.09a.88.88 0 0 0 .648-.26.88.88 0 0 0 .261-.648v-.91h.91a.88.88 0 0 0 .647-.26.88.88 0 0 0 .261-.648.88.88 0 0 0-.261-.648.88.88 0 0 0-.648-.261h-.909v-.91a.88.88 0 0 0-.261-.647.88.88 0 0 0-.648-.262.88.88 0 0 0-.648.262.88.88 0 0 0-.261.647v.91h-.91a.88.88 0 0 0-.647.26.88.88 0 0 0-.261.649.88.88 0 0 0 .261.647.88.88 0 0 0 .648.262h.909v.909a.88.88 0 0 0 .261.647.88.88 0 0 0 .648.262ZM12 14.728h3.636a.88.88 0 0 0 .648-.261.88.88 0 0 0 .261-.648.88.88 0 0 0-.261-.647.88.88 0 0 0-.648-.262H12a.88.88 0 0 0-.648.261.88.88 0 0 0-.261.648.88.88 0 0 0 .261.648.88.88 0 0 0 .648.261Zm-3.182 3.637c-.5 0-.928-.178-1.284-.535A1.75 1.75 0 0 1 7 16.546V3.819c0-.5.178-.928.534-1.284A1.75 1.75 0 0 1 8.818 2h5.614a1.795 1.795 0 0 1 1.272.523l4.41 4.409a1.795 1.795 0 0 1 .523 1.273v8.34c0 .5-.179.928-.535 1.284a1.75 1.75 0 0 1-1.284.535h-10Zm0-1.819h10V8.365l-4.545-4.546H8.818v12.728ZM5.182 22c-.5 0-.928-.178-1.284-.534a1.75 1.75 0 0 1-.534-1.284V8.364a.88.88 0 0 1 .26-.648.88.88 0 0 1 .649-.261.88.88 0 0 1 .647.26.88.88 0 0 1 .262.649v11.818h9.09a.88.88 0 0 1 .648.261.88.88 0 0 1 .262.648.88.88 0 0 1-.262.648.88.88 0 0 1-.647.261H5.182Z",
            fill: "currentColor"
        })
    });
};
$9d5737b4788a71b9$var$TemplateIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $9d5737b4788a71b9$var$LearnSelectedIcon = function LearnSelectedIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M14.666 6.667v18.666m0-18.666a5.333 5.333 0 0 0-5.333-5.334H2.666a1.333 1.333 0 0 0-1.333 1.334V20a1.333 1.333 0 0 0 1.333 1.333h8a4 4 0 0 1 4 4m0-18.666A5.333 5.333 0 0 1 20 1.333h6.666A1.333 1.333 0 0 1 28 2.667V20a1.333 1.333 0 0 1-1.334 1.333h-8a4 4 0 0 0-4 4",
            stroke: "currentColor",
            strokeWidth: "2.667",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
$9d5737b4788a71b9$var$LearnSelectedIcon.defaultProps = {
    width: "30",
    height: "27",
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $9d5737b4788a71b9$var$LearnIcon = function LearnIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M14.666 6.667v18.666m0-18.666a5.333 5.333 0 0 0-5.333-5.334H2.666a1.333 1.333 0 0 0-1.333 1.334V20a1.333 1.333 0 0 0 1.333 1.333h8a4 4 0 0 1 4 4m0-18.666A5.333 5.333 0 0 1 20 1.333h6.666A1.333 1.333 0 0 1 28 2.667V20a1.333 1.333 0 0 1-1.334 1.333h-8a4 4 0 0 0-4 4",
            stroke: "currentColor",
            strokeWidth: "2.667",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
$9d5737b4788a71b9$var$LearnIcon.defaultProps = {
    width: "30",
    height: "27",
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $9d5737b4788a71b9$var$DumbbellSelectedIcon = function DumbbellSelectedIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("g", {
                clipPath: "url(#clip0_206_244)",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M5.984 4.986A1 1 0 0 0 5 6v5.832a1 1 0 0 0 0 .326V18a1 1 0 1 0 2 0v-5h10v5a1 1 0 1 0 2 0v-5.832a1.003 1.003 0 0 0 0-.326V6a1 1 0 1 0-2 0v5H7V6a1 1 0 0 0-1.016-1.014Zm-3 2A1 1 0 0 0 2 8v3H1a1 1 0 1 0 0 2h1v3a1 1 0 1 0 2 0v-3.832a1 1 0 0 0 0-.326V8a1 1 0 0 0-1.016-1.014Zm18 0A1 1 0 0 0 20 8v3.832a.997.997 0 0 0 0 .326V16a1 1 0 1 0 2 0v-3h1a1 1 0 1 0 0-2h-1V8a1 1 0 0 0-1.016-1.014Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_206_244",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
};
$9d5737b4788a71b9$var$DumbbellSelectedIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $9d5737b4788a71b9$var$DumbbellIcon = function DumbbellIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("g", {
                clipPath: "url(#clip0_206_244)",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M5.984 4.986A1 1 0 0 0 5 6v5.832a1 1 0 0 0 0 .326V18a1 1 0 1 0 2 0v-5h10v5a1 1 0 1 0 2 0v-5.832a1.003 1.003 0 0 0 0-.326V6a1 1 0 1 0-2 0v5H7V6a1 1 0 0 0-1.016-1.014Zm-3 2A1 1 0 0 0 2 8v3H1a1 1 0 1 0 0 2h1v3a1 1 0 1 0 2 0v-3.832a1 1 0 0 0 0-.326V8a1 1 0 0 0-1.016-1.014Zm18 0A1 1 0 0 0 20 8v3.832a.997.997 0 0 0 0 .326V16a1 1 0 1 0 2 0v-3h1a1 1 0 1 0 0-2h-1V8a1 1 0 0 0-1.016-1.014Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_206_244",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
};
$9d5737b4788a71b9$var$DumbbellIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $9d5737b4788a71b9$var$tabKeys = [
    "getStarted",
    "patientListing",
    "exerciseListing",
    "templateListing",
    "learnListing"
];
// mobile version renderers defined outside of TabBar to satisfy Sonar
const $9d5737b4788a71b9$var$getStartedMobileVersion = (context)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $fd62a67a5ad1fb95$export$be2c7398042971e0), {
        isSelected: context.index === context.selectedTabIndex
    });
const $9d5737b4788a71b9$var$patientListingMobileVersion = (context)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $3de05cedc2af47d9$export$1d55303f9e94a39c), {
        context: context,
        label: "tabbar.patients.mobile",
        icon: $9d5737b4788a71b9$var$PatientListIcon,
        iconSelected: $9d5737b4788a71b9$var$PatientListSelectedIcon
    });
const $9d5737b4788a71b9$var$exerciseListingMobileVersion = (context)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $3de05cedc2af47d9$export$1d55303f9e94a39c), {
        context: context,
        label: "tabbar.exercises.mobile",
        icon: $9d5737b4788a71b9$var$DumbbellIcon,
        iconSelected: $9d5737b4788a71b9$var$DumbbellSelectedIcon
    });
const $9d5737b4788a71b9$var$templateListingMobileVersion = (context)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $3de05cedc2af47d9$export$1d55303f9e94a39c), {
        context: context,
        label: "tabbar.programs.mobile",
        icon: $9d5737b4788a71b9$var$TemplateIcon,
        iconSelected: $9d5737b4788a71b9$var$TemplateSelectedIcon
    });
const $9d5737b4788a71b9$var$learnListingMobileVersion = (context)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $3de05cedc2af47d9$export$1d55303f9e94a39c), {
        context: context,
        label: "tabbar.learn.mobile",
        icon: $9d5737b4788a71b9$var$LearnIcon,
        iconSelected: $9d5737b4788a71b9$var$LearnSelectedIcon
    });
const $9d5737b4788a71b9$var$DesktopTabs = ({ selectedTab: selectedTab, tabs: tabs, format: format, onTabChange: onTabChange })=>/*#__PURE__*/ (0, $iKObn.jsxs)($9d5737b4788a71b9$var$StyledTabView, {
        className: "p-size-m-bold",
        activeIndex: selectedTab,
        onTabChange: (e)=>onTabChange(e.index),
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $bY9wC.TabPanel), {
                visible: tabs["getStarted"].visible,
                className: (0, $cfkGk.classNames)([
                    "mx-2",
                    (0, $a6fIt.e2eTestId).homePage.tabGetStarted
                ]),
                header: /*#__PURE__*/ (0, $iKObn.jsx)((0, $fd62a67a5ad1fb95$export$be2c7398042971e0), {
                    isSelected: selectedTab === tabs["getStarted"].index
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $bY9wC.TabPanel), {
                headerClassName: "patients",
                className: (0, $cfkGk.classNames)([
                    "mx-2",
                    (0, $a6fIt.e2eTestId).homePage.tabPatient
                ]),
                header: format("tabbar.patients")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $bY9wC.TabPanel), {
                className: (0, $cfkGk.classNames)([
                    "mx-2",
                    (0, $a6fIt.e2eTestId).homePage.tabExercise
                ]),
                header: format("tabbar.exercises")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $bY9wC.TabPanel), {
                className: (0, $cfkGk.classNames)([
                    "mx-2",
                    (0, $a6fIt.e2eTestId).homePage.tabProgram
                ]),
                header: format("tabbar.programs")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $bY9wC.TabPanel), {
                visible: tabs["learnListing"].visible,
                className: (0, $cfkGk.classNames)([
                    "mx-2"
                ]),
                header: format("tabbar.learn")
            })
        ]
    });
const $9d5737b4788a71b9$export$f97dc4a5a0177256 = ({ displayTabs: displayTabs = true, children: children })=>{
    const navigate = (0, $htiSH.useNavigate)();
    const { format: format } = (0, $1eHG3.useI18n)();
    const location = (0, $hE6rp.useLocation)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const shouldDisplayGetStartedTab = (0, $1IWnK.useObservable)((0, $ghfIB.getStartedManager).shouldDisplayGetStartedTab);
    const learnHasItems = (0, $1IWnK.useObservable)((0, $ghfIB.learnManager).hasItems);
    const tabs = (0, $81g6h.useMemo)(()=>({
            getStarted: {
                index: 0,
                route: (0, $lDZlX.RoutesPath).GetStarted,
                matchRoutes: [
                    (0, $lDZlX.RoutesPath).GetStarted
                ],
                visible: shouldDisplayGetStartedTab,
                mobileVersion: $9d5737b4788a71b9$var$getStartedMobileVersion
            },
            patientListing: {
                index: 1,
                route: (0, $lDZlX.RoutesPath).Home,
                matchRoutes: [
                    (0, $lDZlX.RoutesPath).Home,
                    (0, $lDZlX.RoutesPath).PatientDetails,
                    (0, $lDZlX.RoutesPath).ProgramBuilder
                ],
                label: "tabbar.patients",
                mobileVersion: $9d5737b4788a71b9$var$patientListingMobileVersion
            },
            exerciseListing: {
                index: 2,
                route: (0, $lDZlX.RoutesPath).ExerciseList,
                matchRoutes: [
                    (0, $lDZlX.RoutesPath).ExerciseList
                ],
                label: "tabbar.exercises",
                mobileVersion: $9d5737b4788a71b9$var$exerciseListingMobileVersion
            },
            templateListing: {
                index: 3,
                route: (0, $lDZlX.RoutesPath).ProgramList,
                matchRoutes: [
                    (0, $lDZlX.RoutesPath).ProgramList,
                    (0, $lDZlX.RoutesPath).TemplateBuilder
                ],
                label: "tabbar.programs",
                analyticsEvent: (0, $iBbjf.sendAnalyticsEventViewTemplateList),
                mobileVersion: $9d5737b4788a71b9$var$templateListingMobileVersion
            },
            learnListing: {
                index: 4,
                route: (0, $lDZlX.RoutesPath).Learn,
                matchRoutes: [
                    (0, $lDZlX.RoutesPath).Learn,
                    (0, $lDZlX.RoutesPath).LearnDocument
                ],
                label: "tabbar.learn",
                visible: learnHasItems,
                mobileVersion: $9d5737b4788a71b9$var$learnListingMobileVersion
            }
        }), [
        shouldDisplayGetStartedTab,
        learnHasItems
    ]);
    const selectedTab = (0, $81g6h.useMemo)(()=>{
        for (const tabKey of $9d5737b4788a71b9$var$tabKeys){
            if ((0, $kEwLa.matchRoutes)(tabs[tabKey].matchRoutes.map((route)=>({
                    path: route
                })), location)) return tabs[tabKey].index;
        }
        return -1;
    }, [
        tabs,
        location
    ]);
    const onTabChange = (0, $81g6h.useCallback)((index)=>{
        for (const tabKey of $9d5737b4788a71b9$var$tabKeys){
            const tab = tabs[tabKey];
            if (tab.index === index) {
                tab.analyticsEvent?.();
                navigate(tab.route);
                break;
            }
        }
    }, [
        navigate,
        tabs
    ]);
    const menuItems = (0, $81g6h.useMemo)(()=>[
            ...$9d5737b4788a71b9$var$tabKeys.map((tabKey)=>{
                const tab = tabs[tabKey];
                return {
                    className: "lg:hidden",
                    label: (0, $lTdpc.isNotNil)(tab.label) ? format(tab.label, undefined) : "",
                    command: ()=>onTabChange(tab.index)
                };
            }),
            {
                className: "hidden lg:block",
                template: ()=>/*#__PURE__*/ (0, $iKObn.jsx)($9d5737b4788a71b9$var$DesktopTabs, {
                        selectedTab: selectedTab,
                        tabs: tabs,
                        format: format,
                        onTabChange: onTabChange
                    })
            },
            {
                separator: true
            }
        ], [
        format,
        onTabChange,
        selectedTab,
        tabs
    ]);
    const mobileMenuItems = (0, $81g6h.useMemo)(()=>isDesktop ? [] : $9d5737b4788a71b9$var$tabKeys.map((tabKey)=>({
                ...tabs[tabKey],
                tabKey: tabKey
            })).sort((k1, k2)=>k1.index - k2.index).map((eachMenuItem)=>eachMenuItem.visible !== false && /*#__PURE__*/ (0, $iKObn.jsx)($9d5737b4788a71b9$var$BottomMobileMenuTabContainer, {
                onClick: ()=>onTabChange(eachMenuItem.index),
                children: eachMenuItem.mobileVersion({
                    index: eachMenuItem.index,
                    selectedTabIndex: selectedTab
                })
            }, eachMenuItem.tabKey)), [
        isDesktop,
        onTabChange,
        selectedTab,
        tabs
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
        children: isDesktop ? /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
            children: [
                displayTabs && /*#__PURE__*/ (0, $iKObn.jsx)($9d5737b4788a71b9$var$StyledMenuBar, {
                    className: "lg:py-0",
                    model: menuItems,
                    start: /*#__PURE__*/ (0, $iKObn.jsx)($9d5737b4788a71b9$var$StyledAppLogo, {
                        height: 32,
                        width: 125,
                        onClick: ()=>navigate((0, $lDZlX.RoutesPath).Home)
                    }),
                    end: /*#__PURE__*/ (0, $iKObn.jsx)((0, $aac7fee7b713e4b3$export$b04dd99d751ebb47), {}),
                    displayTabs: displayTabs
                }),
                children
            ]
        }) : /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
            children: [
                displayTabs && /*#__PURE__*/ (0, $iKObn.jsxs)($9d5737b4788a71b9$var$TopMobileMenuBar, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)($9d5737b4788a71b9$var$StyledAppLogo, {
                            height: 32,
                            width: 125,
                            onClick: ()=>navigate((0, $lDZlX.RoutesPath).Home)
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $aac7fee7b713e4b3$export$b04dd99d751ebb47), {})
                    ]
                }),
                children,
                displayTabs && /*#__PURE__*/ (0, $iKObn.jsx)($9d5737b4788a71b9$var$BottomMobileMenuBar, {
                    children: mobileMenuItems.map((item)=>item)
                })
            ]
        })
    });
};
const $9d5737b4788a71b9$var$StyledMenuBar = (0, $5UMQ1.default)((0, $2e9efb2a85f1d0ec$export$7d4583da7581e674))`
	border-radius: 0;
	border-width: 0 0 1px 0;
	background-color: ${(0, $kKnoQ.colors).white};

	.p-menubar-root-list {
		width: 100%;
		justify-content: center;
	}

	.p-menubar-button,
	.p-tabview {
		visibility: ${({ displayTabs: displayTabs })=>displayTabs ? "visible" : "hidden"};
	}

	.p-tabview-title {
		line-height: 1.25em;
	}

	.p-menu-separator {
		flex: 1;
	}

	.p-menuitem-text {
		color: ${(0, $kKnoQ.colors).grey} !important;
	}

	.p-menuitem-link * {
		font-weight: bold;
		font-size: 1.125rem;
	}
`;
const $9d5737b4788a71b9$var$StyledAppLogo = (0, $5UMQ1.default)((0, $GDBjl.AppLogo))`
	cursor: pointer;
	margin-left: 40px;
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		margin: 0;
	}
`;
const $9d5737b4788a71b9$var$StyledTabView = (0, $5UMQ1.default)((0, $bY9wC.TabView))`
	.p-tabview-panels {
		display: none;
	}

	.p-tabview-nav {
		display: flex;
		border-bottom: 2px solid ${(0, $kKnoQ.colors).transparent};

		li .p-tabview-nav-link {
			margin-top: 0.75rem;
			padding: 0.75rem 0.5rem 1.5rem 0.5rem;
			color: ${(0, $kKnoQ.colors).black};
		}

		.p-unselectable-text:not(.p-tabview-selected) {
			.p-tabview-nav-link {
				border-bottom: 2px solid ${(0, $kKnoQ.colors).transparent} !important;
			}
		}

		li.homePage-tab-get-started {
			display: flex;

			.p-tabview-nav-link {
				margin-top: 0;
				padding-block: 0;
				border-bottom-color: ${(0, $kKnoQ.colors).onboardingPrimary};

				:hover {
					background-color: transparent !important;
				}
			}
		}
	}
`;
const $9d5737b4788a71b9$var$TopMobileMenuBar = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")};
	position: sticky;
	top: 0;
	height: 80px;
	padding: 0 24px;
	background: ${(0, $kKnoQ.colors).white};
	z-index: 22;
	border-bottom: 1px solid ${(0, $kKnoQ.colors).primary25};

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding-right: 0;
	}
`;
const $9d5737b4788a71b9$var$BottomMobileMenuBar = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacearound", "center")};
	position: sticky;
	bottom: 0;
	width: 100%;

	padding: 8px 24px;
	background: ${(0, $kKnoQ.colors).white};
	z-index: 99;
	border-top: 1px solid ${(0, $kKnoQ.colors).primary25};
`;
const $9d5737b4788a71b9$var$BottomMobileMenuTabContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "flexend", "center")}
	position: relative;
	width: 104px;
	opacity: ${({ disabled: disabled })=>disabled ? "0.5" : "1"};
	cursor: ${({ disabled: disabled })=>disabled ? "not-allowed" : "pointer"};
`;



var $ghfIB = parcelRequire("ghfIB");

var $d8lNf = parcelRequire("d8lNf");

var $4UKJF = parcelRequire("4UKJF");

var $243Cr = parcelRequire("243Cr");

var $lTdpc = parcelRequire("lTdpc");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
const $d1e6902c25c22bae$export$82aef1ef22358a7f = ()=>{
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const announcement = (0, $1IWnK.useObservable)((0, $ghfIB.announcementManager).announcement);
    const user = (0, $4UKJF.useUser)();
    (0, $81g6h.useEffect)(()=>{
        if (!user?.hasAgreedToLegalDocuments) return;
        if ((0, $lTdpc.isNil)(announcement)) return;
        (0, $d8lNf.sendAnnouncementDisplayEvent)(announcement);
        dialogContext?.openModal((0, $243Cr.ModalId).Announcement, {
            dialogContent: announcement,
            onClose: async (closeModal)=>{
                await (0, $ghfIB.announcementManager).markAsViewed(announcement.documentId);
                closeModal();
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        announcement,
        user?.hasAgreedToLegalDocuments
    ]);
    return null;
};



var $81g6h = parcelRequire("81g6h");

var $1IWnK = parcelRequire("1IWnK");

var $243Cr = parcelRequire("243Cr");

var $ghfIB = parcelRequire("ghfIB");

var $hE6rp = parcelRequire("hE6rp");

var $auPqo = parcelRequire("auPqo");
const $739608b89122fbfb$export$ce7d8df70b67fa9d = ()=>{
    const location = (0, $hE6rp.useLocation)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const [shouldTrackEvent, setShouldTrackEvent] = (0, $81g6h.useState)(true);
    const shouldDisplayGetStartedCompletedDialog = (0, $1IWnK.useObservable)((0, $ghfIB.getStartedManager).shouldDisplayGetStartedCompletedDialog);
    (0, $81g6h.useEffect)(()=>{
        if (!shouldDisplayGetStartedCompletedDialog) return;
        if (shouldTrackEvent) {
            (0, $ghfIB.analyticsService).trackEvent({
                category: (0, $auPqo.AnalyticsCategory).GETSTARTED,
                action: "allStepsCompletedPage"
            });
            setShouldTrackEvent(false);
        }
        dialogContext?.openModal((0, $243Cr.ModalId).GetStartedCompleted, {
            onClose: (closeModal)=>{
                (0, $ghfIB.getStartedManager).shouldDisplayGetStartedCompletedDialog.set(false);
                closeModal();
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location,
        shouldDisplayGetStartedCompletedDialog
    ]);
    return null;
};



var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $9XVwj = parcelRequire("9XVwj");

var $lDZlX = parcelRequire("lDZlX");

var $1DH4E = parcelRequire("1DH4E");

var $lTdpc = parcelRequire("lTdpc");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");

var $hE6rp = parcelRequire("hE6rp");
const $1cae100a348baca7$export$9aa116a81b4a4b26 = ()=>{
    const navigate = (0, $hE6rp.useNavigate)();
    const { format: format } = (0, $1eHG3.useI18n)();
    const isNewUnreadNotificationAvailable = (0, $1IWnK.useObservable)((0, $ghfIB.notificationManager).isNewUnsentNotificationsAvailable);
    const { formatNotification: formatNotification, onNotificationClicked: onNotificationClicked } = (0, $1DH4E.useNotification)();
    const { showNotification: showNotification, clearToasts: clearToasts } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    (0, $81g6h.useEffect)(()=>{
        if (!isNewUnreadNotificationAvailable) return;
        const newUnreadNotificationData = (0, $ghfIB.notificationManager).newUnsentNotificationData;
        if ((0, $lTdpc.isNil)(newUnreadNotificationData)) return;
        const { notification: notification, count: count } = newUnreadNotificationData;
        if ((0, $lTdpc.isNotNil)(notification)) showNotification(formatNotification(notification), async ()=>{
            clearToasts();
            await onNotificationClicked(notification, "toast");
        });
        else showNotification(format("global.notifications.toast.newNotificationsReceived", {
            count: count
        }), ()=>{
            clearToasts();
            (0, $ghfIB.analyticsService).trackEvent({
                category: (0, $auPqo.AnalyticsCategory).PERMISSIONS,
                action: "clickNotificationToast",
                params: [
                    "notificationCenter"
                ]
            });
            navigate((0, $lDZlX.RoutesPath).NotificationCenter);
        });
    }, [
        format,
        formatNotification,
        navigate,
        showNotification,
        onNotificationClicked,
        isNewUnreadNotificationAvailable,
        clearToasts
    ]);
    return {
        showNotification: showNotification
    };
};


parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $lTdpc = parcelRequire("lTdpc");
const $d9ef825a130e6009$export$d877f8a65893e102 = (location, routes)=>routes.some((path)=>path.includes(":") ? location.pathname.startsWith(path.split(":")[0]) : location.pathname === path);



var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");

var $hE6rp = parcelRequire("hE6rp");

var $aanF2 = parcelRequire("aanF2");
const $e7772db0426f0484$var$routesAvailableWithoutConsent = [
    (0, $lDZlX.RoutesPath).TermsOfUse,
    (0, $lDZlX.RoutesPath).PrivacyNotice,
    (0, $lDZlX.RoutesPath).Debug,
    (0, $lDZlX.RoutesPath).Login,
    (0, $lDZlX.RoutesPath).VipLogin
];
const $e7772db0426f0484$var$routesWithoutTabbars = [
    (0, $lDZlX.RoutesPath).TemplateBuilder,
    (0, $lDZlX.RoutesPath).ProgramBuilder,
    (0, $lDZlX.RoutesPath).ProfessionalInformation
];
const $e7772db0426f0484$export$86b66307423b6077 = ()=>{
    const ptRegistrationStatus = (0, $1IWnK.useObservable)((0, $ghfIB.userStatusManager).ptRegistrationStatus);
    const user = (0, $4UKJF.useUser)();
    const location = (0, $hE6rp.useLocation)();
    const navigate = (0, $htiSH.useNavigate)();
    const [searchParams] = (0, $aanF2.useSearchParams)();
    const { format: format } = (0, $1eHG3.useI18n)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const showTabBar = (0, $81g6h.useMemo)(()=>{
        if (!user?.hasAgreedToLegalDocuments) return false;
        if (ptRegistrationStatus === (0, $02mFA.RegistrationStatus).REJECTED) return false;
        if ((0, $d9ef825a130e6009$export$d877f8a65893e102)(location, $e7772db0426f0484$var$routesWithoutTabbars)) return false;
        return true;
    }, [
        location,
        ptRegistrationStatus,
        user?.hasAgreedToLegalDocuments
    ]);
    (0, $81g6h.useEffect)(()=>{
        if ((0, $lTdpc.isNil)(user?.id)) {
            navigate((0, $lDZlX.RoutesPath).Login, {
                query: {
                    patientId: searchParams.get("patientId") ?? undefined,
                    ptId: searchParams.get("ptId") ?? undefined,
                    lang: searchParams.get("lang") ?? undefined
                }
            });
            return;
        }
        if (ptRegistrationStatus === (0, $02mFA.RegistrationStatus).REJECTED) navigate((0, $lDZlX.RoutesPath).Rejected);
    // remove navigate from dependencies 'cause navigate is refresh at each navigate
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location.pathname,
        ptRegistrationStatus,
        searchParams,
        user?.id
    ]);
    (0, $81g6h.useEffect)(()=>{
        const navigateToHomePageWithToast = ()=>{
            navigate((0, $lDZlX.RoutesPath).Home);
            showToast("", format("patientDetails.errorToast.notInHealthcareTeam"));
        };
        (0, $ghfIB.errorManager).onPtNotInHealthcareTeam.add(navigateToHomePageWithToast);
        return ()=>(0, $ghfIB.errorManager).onPtNotInHealthcareTeam.remove(navigateToHomePageWithToast);
    }, [
        format,
        navigate,
        showToast
    ]);
    const onWindowFocus = (0, $81g6h.useCallback)(async ()=>{
        await (0, $ghfIB.userManager).retrieveUser();
    }, []);
    (0, $1cae100a348baca7$export$9aa116a81b4a4b26)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $243Cr.DialogProvider), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $aanF2.ScrollRestoration), {}),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $eb5a63d431e6b13e$export$b6343d86957a1a7b), {}),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $d1e6902c25c22bae$export$82aef1ef22358a7f), {}),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $739608b89122fbfb$export$ce7d8df70b67fa9d), {}),
            ptRegistrationStatus && /*#__PURE__*/ (0, $iKObn.jsx)($e7772db0426f0484$var$Content, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $5d3762e0012a57fc$export$a5ceee2b1c92266a), {
                    onFocus: onWindowFocus,
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $9d5737b4788a71b9$export$f97dc4a5a0177256), {
                        displayTabs: showTabBar,
                        children: user?.hasAgreedToLegalDocuments || $e7772db0426f0484$var$routesAvailableWithoutConsent.includes(location.pathname) ? /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)((0, $de6ea493ba34a070$export$218db699b77cbd4f), {}),
                                /*#__PURE__*/ (0, $iKObn.jsx)((0, $hE6rp.Outlet), {})
                            ]
                        }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $36be0bf19afd5029$export$492ccad72e408928), {})
                    })
                })
            })
        ]
    });
};
const $e7772db0426f0484$export$c12aa631bb452f60 = ()=>{
    const user = (0, $4UKJF.useUser)();
    const navigate = (0, $htiSH.useNavigate)();
    const [searchParams] = (0, $aanF2.useSearchParams)();
    const { clearToasts: clearToasts } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    (0, $81g6h.useEffect)(()=>{
        if ((0, $lTdpc.isNotNil)(user)) {
            const patientId = searchParams.get("patientId");
            const ptId = searchParams.get("ptId");
            navigate((0, $lDZlX.RoutesPath).Home, {
                query: {
                    patientId: patientId ?? undefined,
                    ptId: ptId ?? undefined
                }
            });
        }
        // clear toast when not authenticated.
        clearToasts();
    }, [
        clearToasts,
        navigate,
        searchParams,
        user
    ]);
    (0, $81g6h.useEffect)(()=>{
        const userDeletingInfos = (0, $ghfIB.userManager).userDeletingInfos;
        if ((0, $lTdpc.isNotNil)(userDeletingInfos)) navigate((0, $lDZlX.RoutesPath).AccountDeleted, {
            state: userDeletingInfos
        });
    }, [
        navigate
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $243Cr.DialogProvider), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $aanF2.ScrollRestoration), {}),
            !user && /*#__PURE__*/ (0, $iKObn.jsx)((0, $hE6rp.Outlet), {})
        ]
    });
};
const $e7772db0426f0484$export$8786dd0748f1ae31 = ()=>{
    const user = (0, $4UKJF.useUser)();
    return user?.isTester ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $hE6rp.Outlet), {}) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $hE6rp.Navigate), {
        to: (0, $lDZlX.RoutesPath).Home
    });
};
const $e7772db0426f0484$var$Content = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "flexstart", "stretch")}
	min-height: 100vh;
`;



var $lDZlX = parcelRequire("lDZlX");

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $bXTqq = parcelRequire("bXTqq");

var $htiSH = parcelRequire("htiSH");

var $8zvzh = parcelRequire("8zvzh");

var $8fBuh = parcelRequire("8fBuh");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $GDBjl = parcelRequire("GDBjl");

var $9Q47x = parcelRequire("9Q47x");

var $dhb7H = parcelRequire("dhb7H");

var $lDZlX = parcelRequire("lDZlX");

var $kvJz4 = parcelRequire("kvJz4");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
var $a91cd70ef7aee32a$var$HeartWithHands = function HeartWithHands(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_1334_191",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "61",
                height: "61",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "m2.51 25.409 31.244 34c5.146 3.676 8.27-.864 8.27-3.114l-7.352-8.832 7.352 7.886c5.146 1.47 6.675-3.425 6.19-5.265l-8.947-9.972 9.19 9.19c5.145.734 5.82-3.37 5.513-5.514l-8.27-9.19 7.351 7.352c2.206 2.205 4.595 1.531 5.514.918 2.94-2.94 1.225-5.783 0-7.009L26.402 2.435c-5.882-4.411-14.09-1.225-17.46.919C-1.35 10.705.365 21.12 2.509 25.409Z",
                    fill: "#FF0A4B"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_1334_191)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M63.473 35.776C62.223 17.84 46.67 4.316 28.735 5.566s-31.46 16.803-30.21 34.737c1.25 17.935 16.803 31.46 34.738 30.21s31.46-16.803 30.21-34.738Z",
                        fill: "#119CEB"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M39.499 19.839c-.934-13.387-12.542-23.483-25.93-22.55C.184-1.776-9.912 9.833-8.978 23.22-8.046 36.606 3.563 46.7 16.95 45.769c13.387-.934 23.482-12.543 22.549-25.93Z",
                        fill: "#00C3E6"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M22.797 10.152C22.09-.012 13.275-7.678 3.112-6.969c-10.164.709-17.828 9.522-17.12 19.685.709 10.164 9.522 17.828 19.686 17.12 10.163-.709 17.828-9.522 17.12-19.686Z",
                        fill: "#2275F0"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M13.113 6.594c-.486-6.97-6.53-12.227-13.5-11.74-6.971.485-12.228 6.53-11.742 13.5.486 6.97 6.53 12.227 13.501 11.741 6.97-.486 12.227-6.53 11.741-13.5Z",
                        fill: "#334EF5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M24.774 24.114c-2.205-2.206-.306-4.595.92-5.514L39.478 4.816c5.146-3.676 11.334-3.37 13.784-2.757 5.882.735 10.415 5.82 11.947 8.27 2.94 4.411 1.837 12.253.919 15.623-.736 3.675-5.208 8.27-7.352 10.108L40.398 18.6l-7.352 6.433c-3.675 2.94-7.046.612-8.272-.92Z",
                fill: "#4427FA"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask1_1334_191",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "23",
                y: "1",
                width: "45",
                height: "36",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M24.774 24.114c-2.205-2.206-.306-4.595.92-5.514L39.478 4.816c5.146-3.676 11.334-3.37 13.784-2.757 5.882.735 10.415 5.82 11.947 8.27 2.94 4.411 1.837 12.253.919 15.623-.736 3.675-5.208 8.27-7.352 10.108L40.398 18.6l-7.352 6.433c-3.675 2.94-7.046.612-8.272-.92Z",
                    fill: "#000"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("g", {
                mask: "url(#mask1_1334_191)",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M52.344 19.187c-.735.735-2.757 2.17-4.595 2.17-3.675 0-4.9-.92-6.432-1.838l2.216 2.258c2.757.919 5.353.835 7.023 0 1.838-.92 1.781-.804 2.7-1.723.675-.867-.106-1.673-.912-.867Z",
                    fill: "#33009A"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M41.973 56.225a.442.442 0 0 1-.323-.155l-9.832-10.686a.466.466 0 0 1 .027-.668.466.466 0 0 1 .669.028l9.832 10.686a.466.466 0 0 1-.028.668.473.473 0 0 1-.335.127h-.01ZM48.135 50.064a.442.442 0 0 1-.324-.155l-9.832-10.686a.466.466 0 0 1 .028-.669.466.466 0 0 1 .668.028l9.832 10.686a.466.466 0 0 1-.028.669.473.473 0 0 1-.335.127h-.01ZM54.296 43.903a.441.441 0 0 1-.324-.155L44.14 33.062a.466.466 0 0 1 .028-.669.466.466 0 0 1 .668.028l9.832 10.686a.466.466 0 0 1-.028.669.473.473 0 0 1-.335.127h-.01Z",
                fill: "#33009A"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "m18.992 30.833-9.185 8.27c-3.672 4.595 1.84 8.27 4.59 6.433l10.11-9.19c2.756-4.594-2.758-7.35-5.515-5.513Z",
                fill: "#4427FA"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "m24.926 36.022-9.185 8.27c-3.672 4.594 1.84 8.27 4.59 6.432l10.11-9.19c2.756-4.594-2.757-7.35-5.515-5.512Z",
                fill: "#4427FA"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "m29.965 42.048-8.321 7.474c-3.362 4.19 1.396 7.759 3.87 6.116l9.162-8.307c2.555-4.213-2.23-6.926-4.71-5.283Z",
                fill: "#4427FA"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "m33.762 47.7-7.21 6.59c-2.83 3.456 1.381 5.89 3.356 4.602l7.479-6.71c2.229-3.525-1.646-5.77-3.625-4.483Z",
                fill: "#4427FA"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M25.421 55.346a.379.379 0 0 1 .133-.272l8.958-8.165a.377.377 0 0 1 .55.033.402.402 0 0 1-.034.565l-8.958 8.165a.377.377 0 0 1-.55-.033.406.406 0 0 1-.1-.286l.001-.008ZM20.8 49.785a.379.379 0 0 1 .133-.271l8.958-8.166a.377.377 0 0 1 .55.033.402.402 0 0 1-.034.565l-8.958 8.165a.377.377 0 0 1-.55-.033.406.406 0 0 1-.1-.285l.001-.008ZM14.94 44.594a.398.398 0 0 1 .137-.283l9.24-8.533a.385.385 0 0 1 .566.034.424.424 0 0 1-.035.59l-9.24 8.533a.385.385 0 0 1-.567-.034.427.427 0 0 1-.102-.298v-.009Z",
                fill: "#33009A"
            })
        ]
    });
};
$a91cd70ef7aee32a$var$HeartWithHands.defaultProps = {
    width: "68",
    height: "61",
    viewBox: "0 0 68 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $a91cd70ef7aee32a$export$5f403e64283a9db4 = ()=>{
    const { leavingReasons: leavingReasons } = (0, $8fBuh.useStateParams)();
    const { lang: lang } = (0, $8zvzh.useQueryParams)();
    const navigate = (0, $htiSH.useNavigate)();
    const { format: format } = (0, $1eHG3.useI18n)();
    const supportedCountries = (0, $1IWnK.useObservable)((0, $ghfIB.countryManager).supportedCountries);
    const [fetchSupportedCountries] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(()=>(0, $ghfIB.countryManager).fetchSupportedCountries(), []), {});
    (0, $81g6h.useEffect)(()=>{
        // ensure we have a valid array before sending analytics
        (0, $lTdpc.isNotNil)(leavingReasons);
        (0, $kvJz4.sendAnalyticsEventAccountDeleted)(leavingReasons ?? []);
        const shouldFetchCountries = supportedCountries.length === 0;
        if (shouldFetchCountries) fetchSupportedCountries();
        (0, $bXTqq.applyCountryCodeFromLang)((0, $ghfIB.registerManager), lang, supportedCountries);
    }, [
        lang,
        supportedCountries,
        fetchSupportedCountries,
        leavingReasons
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($a91cd70ef7aee32a$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $GDBjl.AppLogo), {
                style: {
                    height: 50,
                    position: "absolute"
                }
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($a91cd70ef7aee32a$var$Content, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $9Q47x.BackgroundIcon), {
                        iconSvg: $a91cd70ef7aee32a$var$HeartWithHands
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                        className: "p-size-l-bold",
                        children: format("accountDeleted.title")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($a91cd70ef7aee32a$var$Description, {
                        className: "p-size-m",
                        children: format("accountDeleted.description")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                        label: format("accountDeleted.cta"),
                        onClick: ()=>navigate((0, $lDZlX.RoutesPath).Login)
                    })
                ]
            })
        ]
    });
};
const $a91cd70ef7aee32a$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, undefined, "center")}
	padding: 48px;
	height: 100vh;
`;
const $a91cd70ef7aee32a$var$Content = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(16, "center", "center")};
	flex: 1;
`;
const $a91cd70ef7aee32a$var$Description = (0, $5UMQ1.default).p`
	color: ${(0, $kKnoQ.colors).grey80};
	white-space: pre-line;
	text-align: center;
`;



var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $c22GE = parcelRequire("c22GE");

var $lKlJT = parcelRequire("lKlJT");

var $8CNE2 = parcelRequire("8CNE2");

var $1acTy = parcelRequire("1acTy");

var $kvJz4 = parcelRequire("kvJz4");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $jTpg0 = parcelRequire("jTpg0");

var $68IWj = parcelRequire("68IWj");

var $81g6h = parcelRequire("81g6h");
var $394c3fa8ef25a3bf$var$Cross = function Cross(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M6.14 5.302a.836.836 0 0 0-.583 1.435l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26a.834.834 0 0 0 1.377-.263.836.836 0 0 0-.195-.919L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 0 0-.6-.254Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.14 5.015a1.123 1.123 0 0 1 .803.338L12 10.41l5.057-5.057a1.123 1.123 0 1 1 1.588 1.589l-5.057 5.056 5.056 5.056c.107.103.192.226.251.363l-.263.114a.836.836 0 0 0-.189-.272L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 1 0-1.182 1.181l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26c.077.08.17.145.271.189l-.114.263a1.124 1.124 0 0 1-.362-.25L12 13.585l-5.056 5.056a1.123 1.123 0 1 1-1.588-1.588l5.056-5.056-5.057-5.056a1.123 1.123 0 0 1 .785-1.927ZM17.532 18.63a.834.834 0 0 0 1.168-.776.836.836 0 0 0-.068-.323l.263-.114a1.125 1.125 0 0 1-1.477 1.476l.114-.263Z",
                fill: "currentColor"
            })
        ]
    });
};
$394c3fa8ef25a3bf$var$Cross.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $394c3fa8ef25a3bf$var$ExternalLinkIcon = function ExternalLinkIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M19.98 2.99a1 1 0 0 0-.11.01H15a1 1 0 1 0 0 2h2.586l-9.293 9.293a1 1 0 1 0 1.414 1.414L19 6.414V9a1 1 0 1 0 2 0V4.127a1 1 0 0 0-1.02-1.137ZM5 3c-1.093 0-2 .907-2 2v14c0 1.093.907 2 2 2h14c1.093 0 2-.907 2-2v-6a1 1 0 1 0-2 0v6H5V5h6a1 1 0 1 0 0-2H5Z",
            fill: "currentColor"
        })
    });
};
$394c3fa8ef25a3bf$var$ExternalLinkIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $394c3fa8ef25a3bf$export$88303b5339e942f3;
(function(LeavingReason) {
    LeavingReason["OTHER"] = "OTHER";
    LeavingReason["DIFFICULT_USE"] = "DIFFICULT_USE";
    LeavingReason["TIME_CONSUMING"] = "TIME_CONSUMING";
    LeavingReason["NO_PATIENTS"] = "NO_PATIENTS";
    LeavingReason["MISSING_GUIDANCE"] = "MISSING_GUIDANCE";
    LeavingReason["PRIVACY_CONCERNS"] = "PRIVACY_CONCERNS";
    LeavingReason["NO_BENEFIT"] = "NO_BENEFIT";
    LeavingReason["SPAM"] = "SPAM";
    LeavingReason["TECHNICAL_ISSUES"] = "TECHNICAL_ISSUES";
})($394c3fa8ef25a3bf$export$88303b5339e942f3 || ($394c3fa8ef25a3bf$export$88303b5339e942f3 = {}));
const $394c3fa8ef25a3bf$var$DeleteReasonWordings = {
    ["OTHER"]: "leavingReason.other",
    ["DIFFICULT_USE"]: "leavingReason.difficult_use",
    ["TIME_CONSUMING"]: "leavingReason.time_consuming",
    ["NO_PATIENTS"]: "leavingReason.no_patients",
    ["MISSING_GUIDANCE"]: "leavingReason.missing_guidance",
    ["TECHNICAL_ISSUES"]: "leavingReason.technical_issues",
    ["SPAM"]: "leavingReason.spam",
    ["NO_BENEFIT"]: "leavingReason.no_benefit",
    ["PRIVACY_CONCERNS"]: "leavingReason.privacy_concerns"
};
const $394c3fa8ef25a3bf$var$MAX_LEAVING_REASONS = 3;
const $394c3fa8ef25a3bf$export$6831430b1ff54dd2 = ()=>{
    const [selectedReasons, setSelectedReasons] = (0, $81g6h.useState)([]);
    const { format: format } = (0, $1eHG3.useI18n)();
    const [consequencesAcknowledged, setConsequencesAcknowledged] = (0, $81g6h.useState)(false);
    const goBack = (0, $htiSH.useGoBack)();
    const { countryConfig: countryConfig } = (0, $1acTy.useCountryConfig)();
    const shuffledDeleteReasons = (0, $81g6h.useMemo)(()=>{
        const [otherOption, ...reasons] = Object.values($394c3fa8ef25a3bf$export$88303b5339e942f3);
        return [
            ...(0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).shuffle(reasons),
            otherOption
        ];
    }, []);
    const checkReason = (0, $81g6h.useCallback)((reason)=>{
        const reasonChecked = selectedReasons.includes(reason);
        let newSelectedReasons;
        if (reasonChecked) newSelectedReasons = selectedReasons.filter((r)=>r !== reason);
        else newSelectedReasons = [
            ...selectedReasons,
            reason
        ];
        setSelectedReasons(newSelectedReasons);
    }, [
        selectedReasons
    ]);
    const [deleteAccount, loading] = (0, $grmoS.useAsyncOperation)(async ()=>{
        (0, $kvJz4.sendAnalyticsEventDeleteAccountCTA)();
        await (0, $ghfIB.userManager).deleteUser(selectedReasons);
    }, {});
    return /*#__PURE__*/ (0, $iKObn.jsxs)($394c3fa8ef25a3bf$var$StyledPage, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $8CNE2.PageHeader), {
                title: format("settings.leavingReasons.header.title"),
                canGoBack: true
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($394c3fa8ef25a3bf$var$ResponsiveContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($394c3fa8ef25a3bf$var$Card, {
                        className: "p-card",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                                        className: "p-size-m",
                                        children: format("settings.leavingReasons.instructions.title")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($394c3fa8ef25a3bf$var$Instructions, {
                                        className: "p-size-s",
                                        children: format("settings.leavingReasons.instructions.subtitle")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($394c3fa8ef25a3bf$var$CheckboxesContainer, {
                                        children: shuffledDeleteReasons.map((reason)=>/*#__PURE__*/ (0, $iKObn.jsx)($394c3fa8ef25a3bf$var$Reason, {
                                                checked: selectedReasons.includes(reason),
                                                disabled: selectedReasons.length >= $394c3fa8ef25a3bf$var$MAX_LEAVING_REASONS && !selectedReasons.includes(reason),
                                                onClick: ()=>checkReason(reason),
                                                label: format($394c3fa8ef25a3bf$var$DeleteReasonWordings[reason])
                                            }, reason))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)($394c3fa8ef25a3bf$var$Consequences, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                                        children: format("settings.leavingReasons.consequences.title")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($394c3fa8ef25a3bf$var$Consequence, {
                                        label: format("settings.leavingReasons.consequences.one.title"),
                                        description: format("settings.leavingReasons.consequences.one.description")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($394c3fa8ef25a3bf$var$Consequence, {
                                        label: format("settings.leavingReasons.consequences.two.title"),
                                        description: format("settings.leavingReasons.consequences.two.description")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($394c3fa8ef25a3bf$var$Consequence, {
                                        label: format("settings.leavingReasons.consequences.three.title"),
                                        description: format("settings.leavingReasons.consequences.three.description")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($394c3fa8ef25a3bf$var$Reason, {
                                checked: consequencesAcknowledged,
                                onClick: ()=>setConsequencesAcknowledged(!consequencesAcknowledged),
                                label: format("settings.leavingReasons.consequencesAcknowledgement")
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($394c3fa8ef25a3bf$var$DeleteButton, {
                                        uiStyle: "danger",
                                        label: format("settings.leavingReasons.deleteCTA"),
                                        disabled: !consequencesAcknowledged,
                                        loading: loading,
                                        onClick: deleteAccount
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                                        uiStyle: "secondary",
                                        label: format("global.dialog.cancel"),
                                        onClick: goBack
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($394c3fa8ef25a3bf$var$SideContainer, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                                className: "p-size-m-bold",
                                children: format("settings.leavingReasons.helpSection.title")
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                                className: "p-size-s",
                                children: format("settings.leavingReasons.helpSection.description")
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($394c3fa8ef25a3bf$var$ExternalLink, {
                                onClick: ()=>window.open(countryConfig?.faqUrl, "_blank"),
                                label: format("settings.leavingReasons.helpSection.helpCenter"),
                                icon: /*#__PURE__*/ (0, $iKObn.jsx)($394c3fa8ef25a3bf$var$ExternalLinkIcon, {
                                    width: 16,
                                    height: 16
                                }),
                                size: "S"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $c22GE.TertiaryButton), {
                                onClick: ()=>window.open(`mailto:${countryConfig?.customerSupportEmail}`),
                                label: format("global.contactUs"),
                                icon: /*#__PURE__*/ (0, $iKObn.jsx)($394c3fa8ef25a3bf$var$ExternalLinkIcon, {
                                    width: 16,
                                    height: 16
                                }),
                                size: "S"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $394c3fa8ef25a3bf$var$StyledPage = (0, $5UMQ1.default)((0, $lKlJT.Page))`
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 0;
		max-width: 100%;
	}
`;
const $394c3fa8ef25a3bf$var$ResponsiveContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(40)};
	flex: 1;
	align-self: center;
	width: 1200px;
	max-width: 100%;
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		${(0, $5WGN2.stack)(40)};
	}
`;
const $394c3fa8ef25a3bf$var$Card = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(32)};
	padding: 40px;
	align-self: stretch;
	flex: 2;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding: 16px;
		border-radius: 0;
	}
`;
const $394c3fa8ef25a3bf$var$CheckboxesContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(8)};
	margin-top: 8px;
`;
const $394c3fa8ef25a3bf$var$DeleteButton = (0, $5UMQ1.default)((0, $dhb7H.Button))`
	margin-right: 16px;
`;
const $394c3fa8ef25a3bf$var$SideContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)()};
	flex: 1;
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding: 0 16px 16px 16px;
	}
`;
const $394c3fa8ef25a3bf$var$Instructions = (0, $5UMQ1.default).p`
	color: ${(0, $kKnoQ.colors).grey80};
`;
const $394c3fa8ef25a3bf$var$Consequences = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(16)}
`;
const $394c3fa8ef25a3bf$var$ExternalLink = (0, $5UMQ1.default)((0, $c22GE.TertiaryButton))`
	margin: 8px 0;
`;
const $394c3fa8ef25a3bf$var$Reason = ({ label: label, onClick: onClick, disabled: disabled = false, checked: checked })=>/*#__PURE__*/ (0, $iKObn.jsxs)($394c3fa8ef25a3bf$var$CheckboxContainer, {
        onClick: onClick,
        disabled: disabled && !checked,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($394c3fa8ef25a3bf$var$StyledCheckbox, {
                checked: checked
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($394c3fa8ef25a3bf$var$Label, {
                disabled: disabled && !checked,
                children: label
            })
        ]
    });
const $394c3fa8ef25a3bf$var$Label = (0, $5UMQ1.default).p`
	color: ${({ disabled: disabled })=>disabled ? (0, $kKnoQ.colors).grey : (0, $kKnoQ.colors).black};
`;
const $394c3fa8ef25a3bf$var$CheckboxContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, undefined, "center")};
	cursor: ${({ disabled: disabled })=>disabled ? "not-allowed" : "pointer"};
	pointer-events: ${({ disabled: disabled })=>disabled ? "none" : "auto"};
`;
const $394c3fa8ef25a3bf$var$StyledCheckbox = (0, $5UMQ1.default)((0, $68IWj.Checkbox))`
	margin-right: 1rem;
`;
const $394c3fa8ef25a3bf$var$Consequence = ({ label: label, description: description })=>/*#__PURE__*/ (0, $iKObn.jsxs)($394c3fa8ef25a3bf$var$ConsequenceContainer, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)($394c3fa8ef25a3bf$var$CrossContainer, {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($394c3fa8ef25a3bf$var$Cross, {
                        width: 12,
                        height: 12,
                        color: (0, $kKnoQ.colors).rejection
                    })
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($394c3fa8ef25a3bf$var$ConsequenceContent, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                        className: "p-size-m-bold",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                        className: "p-size-m",
                        style: {
                            color: (0, $kKnoQ.colors).grey80
                        },
                        children: description
                    })
                ]
            })
        ]
    });
const $394c3fa8ef25a3bf$var$CrossContainer = (0, $5UMQ1.default).div`
	background-color: ${(0, $kKnoQ.colors).rejection25};
	border-radius: 100px;
	height: 20px;
	width: 20px;
	justify-content: center;
	align-items: center;
	display: flex;
	margin-top: 2px;
`;
const $394c3fa8ef25a3bf$var$ConsequenceContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(12)}
`;
const $394c3fa8ef25a3bf$var$ConsequenceContent = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(0, "center")}
`;



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $81g6h = parcelRequire("81g6h");

var $3TO5x = parcelRequire("3TO5x");
var $3f058afc10146c2e$var$CongratulationIcon = function CongratulationIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M62.66 5.111 5.111 62.661c-6.815 6.814-6.815 17.864 0 24.678l57.55 57.55c6.814 6.815 17.864 6.815 24.678 0l57.55-57.55c6.815-6.814 6.815-17.864 0-24.678L87.339 5.11c-6.814-6.815-17.864-6.815-24.678 0Z",
                fill: "#F5EEFD"
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_3693_25513)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask0_3693_25513",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "37",
                        y: "54",
                        width: "37",
                        height: "52",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M73.286 80.648c-.69-.945-2.25-1.265-3.322-.78-2.3 1.036-3.705 2.032-6.158 3.501-1.048.627-2.415.013-2.632-1.188-.754-4.242-1.355-8.918-1.52-11.486v-9.837c0-1.189-.934-2.466-2.096-2.696a2.621 2.621 0 0 0-2.939 1.546c-.025.064-.127.038-.127-.026v-2.836c0-1.457-1.38-2.632-3.067-2.632-1.686 0-3.066 1.175-3.066 2.632v1.622a2.626 2.626 0 0 0-2.785-1.724c-1.278.14-2.313 1.354-2.313 2.695l-.064 4.651s-.038.025-.038 0c-.166-.997-.945-1.814-1.968-1.917a2.217 2.217 0 0 0-2.44 2.21l-.715 13.263s-3.654 16.251 2.977 19.01c.012 1.291.025 2.441.025 3.348 0 1.546.83 2.99 2.21 3.705a13.3 13.3 0 0 0 6.542 1.546c2.619-.064 4.714-.894 6.184-1.712 1.328-.741 2.12-2.159 2.12-3.68v-3.385s3.961.422 6.913-5.11c2.005-3.744 4.356-5.213 7.448-6.874 1.393-.741 1.814-2.555.869-3.859l-.038.013Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask0_3693_25513)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M53.47 106.611c13.95 0 25.258-11.308 25.258-25.258S67.42 56.094 53.47 56.094 28.21 67.403 28.21 81.353c0 13.95 11.31 25.258 25.26 25.258Z",
                                fill: "#4427FA"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M52.218 97.475c12.327 0 22.32-9.993 22.32-22.32s-9.993-22.32-22.32-22.32c-12.328 0-22.32 9.993-22.32 22.32s9.992 22.32 22.32 22.32Z",
                                fill: "#334EF5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M49.305 87.191c9.2 0 16.66-7.46 16.66-16.66 0-9.202-7.46-16.66-16.66-16.66-9.202 0-16.66 7.459-16.66 16.66 0 9.2 7.458 16.66 16.66 16.66Z",
                                fill: "#2275F0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M49.024 77.738c6.985 0 12.648-5.663 12.648-12.649 0-6.985-5.663-12.648-12.648-12.648-6.986 0-12.649 5.663-12.649 12.648 0 6.986 5.663 12.649 12.649 12.649Z",
                                fill: "#119CEB"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M46.992 68.653a8.675 8.675 0 1 0 0-17.35 8.675 8.675 0 0 0 0 17.35Z",
                                fill: "#00C3E6"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M43.249 76.257a.64.64 0 0 1-.639-.638l.064-10.784a.65.65 0 0 1 .639-.638.64.64 0 0 1 .639.638l-.064 10.784a.65.65 0 0 1-.64.638ZM48.334 74.736a.633.633 0 0 1-.639-.639V59.136c0-.358.281-.639.639-.639s.639.281.639.639v14.961a.633.633 0 0 1-.64.639ZM54.53 75.426a.633.633 0 0 1-.639-.639V60.401c0-.358.281-.639.64-.639.357 0 .638.281.638.64v14.385a.633.633 0 0 1-.639.64ZM49.126 99.892c-6.516-.064-8.7-2.351-8.79-2.44a.633.633 0 0 1 .038-.908.64.64 0 0 1 .894.026c.039.038 2.02 1.98 7.87 2.044a.64.64 0 0 1 .64.639.65.65 0 0 1-.64.639h-.012Z",
                                fill: "#1D0255"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M41.703 77.645a.665.665 0 0 1-.37-.115.647.647 0 0 1-.154-.882c.153-.204 3.73-5.033 15.548-1.827a.634.634 0 1 1-.332 1.227c-10.872-2.939-14.143 1.29-14.169 1.341a.666.666 0 0 1-.523.269v-.013Z",
                        fill: "#1D0255"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask1_3693_25513",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "75",
                        y: "54",
                        width: "38",
                        height: "52",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M75.777 80.648c.69-.945 2.249-1.265 3.322-.78 2.3 1.036 3.705 2.032 6.158 3.501 1.048.627 2.415.013 2.632-1.188.754-4.242 1.355-8.918 1.52-11.486v-9.837c0-1.189.933-2.466 2.096-2.696a2.621 2.621 0 0 1 2.938 1.546c.026.064.128.038.128-.026v-2.836c0-1.457 1.38-2.632 3.067-2.632 1.686 0 3.066 1.175 3.066 2.632v1.622a2.626 2.626 0 0 1 2.785-1.724c1.278.14 2.313 1.354 2.313 2.695l.063 4.651s.039.025.039 0c.166-.997.945-1.814 1.967-1.917a2.217 2.217 0 0 1 2.441 2.21l.715 13.263s3.654 16.251-2.977 19.01c-.013 1.291-.025 2.441-.025 3.348 0 1.546-.831 2.99-2.211 3.705a13.298 13.298 0 0 1-6.541 1.546c-2.62-.064-4.715-.894-6.184-1.712-1.329-.741-2.12-2.159-2.12-3.68v-3.385s-3.961.422-6.913-5.11c-2.006-3.744-4.356-5.213-7.448-6.874-1.393-.741-1.815-2.555-.87-3.859l.04.013Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask1_3693_25513)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M95.593 106.611c13.95 0 25.259-11.308 25.259-25.258s-11.309-25.259-25.259-25.259c-13.95 0-25.259 11.309-25.259 25.259 0 13.95 11.309 25.258 25.26 25.258Z",
                                fill: "#4427FA"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M96.858 97.475c12.327 0 22.32-9.993 22.32-22.32s-9.993-22.32-22.32-22.32-22.32 9.993-22.32 22.32 9.993 22.32 22.32 22.32Z",
                                fill: "#334EF5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M99.758 87.191c9.201 0 16.661-7.46 16.661-16.66 0-9.202-7.46-16.66-16.66-16.66-9.202 0-16.661 7.459-16.661 16.66 0 9.2 7.459 16.66 16.66 16.66Z",
                                fill: "#2275F0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M100.052 77.738c6.985 0 12.648-5.663 12.648-12.649 0-6.985-5.663-12.648-12.648-12.648-6.986 0-12.649 5.663-12.649 12.648 0 6.986 5.663 12.649 12.649 12.649Z",
                                fill: "#119CEB"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M102.071 68.653a8.675 8.675 0 1 0 0-17.35 8.675 8.675 0 0 0 0 17.35Z",
                                fill: "#00C3E6"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M105.827 76.257a.64.64 0 0 1-.639-.638l-.064-10.784c0-.357.281-.638.639-.638.409 0 .639.28.639.638l.064 10.784a.633.633 0 0 1-.639.638ZM100.729 74.736a.633.633 0 0 1-.639-.639V59.136c0-.358.281-.639.639-.639s.639.281.639.639v14.961a.633.633 0 0 1-.639.639ZM94.532 75.426a.633.633 0 0 1-.638-.639V60.401c0-.358.28-.639.638-.639s.64.281.64.64v14.385a.633.633 0 0 1-.64.64ZM99.937 99.891a.64.64 0 0 1-.639-.639c0-.357.281-.638.639-.638 5.877-.052 7.857-2.019 7.87-2.045a.644.644 0 0 1 .907-.025.628.628 0 0 1 .026.894c-.09.102-2.287 2.39-8.79 2.44l-.013.013Z",
                                fill: "#1D0255"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M107.36 77.658a.632.632 0 0 1-.524-.269c-.051-.063-3.334-4.28-14.169-1.341a.628.628 0 0 1-.779-.447.638.638 0 0 1 .447-.78c11.818-3.206 15.396 1.623 15.549 1.827a.638.638 0 0 1-.524 1.01Z",
                        fill: "#1D0255"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "m72.238 53.206-.638-8.164c-.103-2.862 4.126-2.875 4.011 0l-.639 8.164c-.14 1.673-2.593 1.66-2.734 0ZM77.668 52.055l2.836-3.96c2.134-2.633 5.686.932 3.054 3.053l-3.96 2.836c-1.266.907-2.837-.69-1.93-1.93ZM67.383 53.998l-3.96-2.836c-2.633-2.134.932-5.686 3.053-3.054l2.836 3.96c.907 1.266-.69 2.837-1.929 1.93Z",
                        fill: "#00C3E6"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_3693_25513",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(37.031 37.031)",
                        d: "M0 0h75v75H0z"
                    })
                })
            })
        ]
    });
};
$3f058afc10146c2e$var$CongratulationIcon.defaultProps = {
    width: "150",
    height: "150",
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $3f058afc10146c2e$export$87d14518ad540bf9 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    (0, $81g6h.useEffect)(()=>{
        window.parent.postMessage((0, $3TO5x.SURVEY_COMPLETION_POSTMESSAGE), window.location.origin);
    }, []);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($3f058afc10146c2e$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($3f058afc10146c2e$var$CongratulationIcon, {}),
            /*#__PURE__*/ (0, $iKObn.jsx)("h1", {
                children: format("survey.popup.thankYou.title")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                children: format("survey.popup.thankYou.body")
            })
        ]
    });
};
const $3f058afc10146c2e$var$Container = (0, $5UMQ1.default).div`
	background-color: white;
	${(0, $5WGN2.stack)("L", "flexstart", "center")}
	text-align: center;
	padding: 24px;
	min-height: 100vh;
`;



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $8fBuh = parcelRequire("8fBuh");

var $iV9Zw = parcelRequire("iV9Zw");

var $hjTZh = parcelRequire("hjTZh");

var $5UMQ1 = parcelRequire("5UMQ1");

var $lKlJT = parcelRequire("lKlJT");

var $8CNE2 = parcelRequire("8CNE2");

var $9XVwj = parcelRequire("9XVwj");

var $243Cr = parcelRequire("243Cr");

var $djk4t = parcelRequire("djk4t");

var $8Njzk = parcelRequire("8Njzk");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $4UKJF = parcelRequire("4UKJF");

var $02mFA = parcelRequire("02mFA");

var $5UMQ1 = parcelRequire("5UMQ1");

var $imaOW = parcelRequire("imaOW");

var $lDZlX = parcelRequire("lDZlX");

var $kXaMn = parcelRequire("kXaMn");

var $jTpg0 = parcelRequire("jTpg0");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
const $15ade5a6153d87cc$export$8534dc24c72e73ef = ({ hideForValidatedPt: hideForValidatedPt, showForPendingPt: showForPendingPt, className: className })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    const ptRegistrationStatus = (0, $1IWnK.useObservable)((0, $ghfIB.userStatusManager).ptRegistrationStatus);
    const [hideBanner, setHideBanner] = (0, $81g6h.useState)(false);
    const user = (0, $4UKJF.useUser)();
    const currentPtId = user?.id ? user.id : "";
    const closeValidatedBanner = ()=>{
        setHideBanner(true);
        (0, $ghfIB.userBannerManager).updateValidatedAccountBanner(currentPtId);
    };
    (0, $81g6h.useEffect)(()=>{
        if ((0, $ghfIB.userBannerManager).hasValidatedAccountBanner(currentPtId)) setHideBanner(true);
        else if (!(0, $jTpg0.isNil)(user?.hcpValidationDate) && !(0, $jTpg0.isNil)(user.identityValidationDate) && !hideBanner) {
            const currentDate = (0, $kXaMn.now)();
            const { month: hcpMonthElapsed } = (0, $kXaMn.computeDiffBetween)(user.hcpValidationDate, currentDate);
            const { month: validationMonthElapsed } = (0, $kXaMn.computeDiffBetween)(user.identityValidationDate, currentDate);
            if (hcpMonthElapsed > 0 && validationMonthElapsed > 0) setHideBanner(true);
        }
    }, [
        ptRegistrationStatus,
        hideBanner,
        user?.hcpValidationDate,
        user?.id,
        user?.identityValidationDate,
        currentPtId
    ]);
    switch(ptRegistrationStatus){
        case (0, $02mFA.RegistrationStatus).PENDING:
            return showForPendingPt && /*#__PURE__*/ (0, $iKObn.jsx)($15ade5a6153d87cc$var$Card, {
                className: className,
                cardType: (0, $imaOW.CardType).Pending,
                title: format("home.validatePendingAccountCard.title"),
                message: format("home.validatePendingAccountCard.message")
            });
        case (0, $02mFA.RegistrationStatus).INCOMPLETE:
            return /*#__PURE__*/ (0, $iKObn.jsx)($15ade5a6153d87cc$var$Card, {
                className: className,
                cardType: (0, $imaOW.CardType).Info,
                title: format("home.validateAccountCard.title"),
                message: format("home.validateAccountCard.message"),
                secondaryButtons: [
                    {
                        title: format("home.validateAccountCard.cta"),
                        onPressed: ()=>{
                            (0, $ghfIB.analyticsService).trackEvent({
                                category: (0, $auPqo.AnalyticsCategory).REGISTRATION,
                                action: "startVerificationFlowCTA",
                                params: [
                                    "patients"
                                ]
                            });
                            navigate((0, $lDZlX.RoutesPath).ProfessionalInformation);
                        }
                    }
                ]
            });
        case (0, $02mFA.RegistrationStatus).VALIDATED:
            return hideForValidatedPt && !hideBanner && /*#__PURE__*/ (0, $iKObn.jsx)($15ade5a6153d87cc$var$Card, {
                className: className,
                cardType: (0, $imaOW.CardType).Validated,
                title: format("settings.AccountValidatedAccountCard.title"),
                message: format("settings.AccountValidatedAccountCard.message"),
                onCrossClicked: closeValidatedBanner
            });
        default:
            return null;
    }
};
const $15ade5a6153d87cc$var$Card = (0, $5UMQ1.default)((0, $imaOW.AlertCard))`
	margin-top: 24px;
`;



var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $Ukx0s = parcelRequire("Ukx0s");

var $hjTZh = parcelRequire("hjTZh");

var $243Cr = parcelRequire("243Cr");

var $9XVwj = parcelRequire("9XVwj");

var $lDZlX = parcelRequire("lDZlX");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");

var $aanF2 = parcelRequire("aanF2");
const $5f5677a2a8c01285$export$ac0bc81069c1b702 = ({ onError: onError })=>{
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const navigate = (0, $htiSH.useNavigate)();
    const [searchParams] = (0, $aanF2.useSearchParams)();
    const [hasBeenPresented, setHasBeenPresented] = (0, $81g6h.useState)(false);
    const { format: format } = (0, $1eHG3.useI18n)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const goToPatientDetailsWithErrorAlreadyAccepted = (0, $81g6h.useCallback)((patientId)=>{
        showToast(format("patientDetails.healthcareTeam.toastAlreadyJoinedError.title"), format("patientDetails.healthcareTeam.toastAlreadyJoinedError.subtitle"), "success");
        navigate((0, $lDZlX.RoutesPath).PatientDetails, {
            route: {
                patientId: patientId
            },
            query: {
                active: (0, $lDZlX.TabPatientDetails).HEALTHCARE_TAB
            }
        });
    }, [
        navigate,
        format,
        showToast
    ]);
    (0, $81g6h.useEffect)(()=>{
        const handleHealthcareTeamAcceptDialog = async (patientId)=>{
            try {
                const healthcareTeamOutput = await (0, $ghfIB.healthcareTeamManager).getInvitationDetails(patientId);
                dialogContext?.openModal((0, $243Cr.ModalId).HealthcareTeamAccept, {
                    healthcareTeamOutput: healthcareTeamOutput
                });
                (0, $Ukx0s.sendAnalyticsEventOpenInvitation)(healthcareTeamOutput.patient);
            } catch (error) {
                if (error instanceof (0, $hjTZh.InvitationAlreadyAcceptedError)) goToPatientDetailsWithErrorAlreadyAccepted(patientId);
                onError(error);
                console.error("Failed to send healthcare team invite confirmation", error);
            }
        };
        if (!hasBeenPresented) {
            const patientId = searchParams.get("patientId");
            if ((0, $lTdpc.isNotNil)(patientId)) {
                handleHealthcareTeamAcceptDialog(patientId);
                setHasBeenPresented(true);
            }
        }
    }, [
        dialogContext,
        goToPatientDetailsWithErrorAlreadyAccepted,
        hasBeenPresented,
        navigate,
        onError,
        searchParams
    ]);
};


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $81g6h = parcelRequire("81g6h");

var $giAv5 = parcelRequire("giAv5");
const $95cdcb34c06a4072$export$36d69433c4f81145 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { cleanHistory: cleanHistory } = (0, $iV9Zw.useHistory)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const stateParams = (0, $8fBuh.useStateParams)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    (0, $giAv5.useOnceEffect)(()=>stateParams.openAddPatientModal && dialogContext?.openModal((0, $243Cr.ModalId).AddPatient, {
            contentStyle: {
                overflowY: "visible"
            }
        }));
    (0, $5f5677a2a8c01285$export$ac0bc81069c1b702)({
        onError: (error)=>{
            if (error instanceof (0, $hjTZh.InvitationPtNotInvitedError)) {
                showToast(format("home.healthcareTeam.errorToast.ptNotInvited.title"), format("home.healthcareTeam.errorToast.ptNotInvited.subtitle"), "error");
                cleanHistory();
            }
        }
    });
    return /*#__PURE__*/ (0, $iKObn.jsxs)($95cdcb34c06a4072$var$StyledPage, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $15ade5a6153d87cc$export$8534dc24c72e73ef), {
                showForPendingPt: true
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $8CNE2.PageHeader), {
                title: format("home.title"),
                primaryButton: /*#__PURE__*/ (0, $iKObn.jsx)((0, $djk4t.AddPatientButton), {})
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($95cdcb34c06a4072$var$Card, {
                className: "p-card",
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $8Njzk.PatientTabs), {})
            })
        ]
    });
};
const $95cdcb34c06a4072$var$StyledPage = (0, $5UMQ1.default)((0, $lKlJT.Page))`
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		margin: 0;
		padding: 0;
		width: 100%;
		max-width: unset;
	}
`;
const $95cdcb34c06a4072$var$Card = (0, $5UMQ1.default).div`
	padding: 32px;
	width: 1200px;
	max-width: 100%;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 0;
		flex-grow: 1;
		border-radius: 0;
	}
`;



var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $28f8Y = parcelRequire("28f8Y");

var $1IlhR = parcelRequire("1IlhR");

var $lDZlX = parcelRequire("lDZlX");

var $iKObn = parcelRequire("iKObn");

var $htiSH = parcelRequire("htiSH");

var $5UMQ1 = parcelRequire("5UMQ1");

var $lKlJT = parcelRequire("lKlJT");

var $8CNE2 = parcelRequire("8CNE2");

var $kKnoQ = parcelRequire("kKnoQ");

var $bl9tw = parcelRequire("bl9tw");

var $jKTFw = parcelRequire("jKTFw");
parcelRequire("81g6h");
const $d0520af42d86d748$export$c749023b2d124212 = ({ title: title, content: content, headerLink: headerLink })=>{
    const navigate = (0, $htiSH.useNavigate)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($d0520af42d86d748$var$StyledPage, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $8CNE2.PageHeader), {
                title: title,
                tertiaryButton: {
                    label: headerLink.label,
                    onClick: ()=>navigate(headerLink.to)
                }
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($d0520af42d86d748$var$Container, {
                className: "p-card",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                    className: "document-content",
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                })
            })
        ]
    });
};
const $d0520af42d86d748$var$Container = (0, $5UMQ1.default).div`
	padding: 32px;

	.document-content {
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		${(0, $jKTFw.getScrollbarStyle)(8)};
	}

	.document-content h1 {
		font-family: ${(0, $bl9tw.fonts).header};
		font-size: 32px;
		font-weight: bold;
	}

	.document-content h2 {
		font-family: ${(0, $bl9tw.fonts).header};
		font-size: 24px;
		font-weight: bold;
	}

	.document-content h3 {
		font-family: ${(0, $bl9tw.fonts).header};
		font-size: 18px;
		font-weight: bold;
	}

	.document-content table {
		width: 100%;
		border-collapse: collapse;
	}

	.document-content th,
	.document-content td {
		padding: 6px 10px;
		vertical-align: top;
		border: 1px solid ${(0, $kKnoQ.colors).grey};
	}
`;
const $d0520af42d86d748$var$StyledPage = (0, $5UMQ1.default)((0, $lKlJT.Page))`
	width: min(calc(100vw - 40px), 832px);
	place-content: center;
`;



var $5WGN2 = parcelRequire("5WGN2");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
const $ea594a6041ee1c5f$export$652846203595a37c = ()=>{
    const { format: format, locale: locale } = (0, $1eHG3.useI18n)();
    const fetchPrivacyNotice = (0, $81g6h.useCallback)(()=>(0, $ghfIB.legalContentManager).retrievePrivacyNotice(locale), [
        locale
    ]);
    const [operation, isLoading, isError] = (0, $grmoS.useAsyncOperation)(fetchPrivacyNotice, {});
    const privacyNotice = (0, $1IWnK.useObservable)((0, $ghfIB.legalContentManager).privacyNotice);
    (0, $81g6h.useEffect)(()=>{
        operation();
    }, [
        operation
    ]);
    let content;
    if (privacyNotice) content = /*#__PURE__*/ (0, $iKObn.jsx)((0, $d0520af42d86d748$export$c749023b2d124212), {
        title: format("legalContent.privacyNotice.title"),
        content: privacyNotice.content,
        headerLink: {
            label: format("legalContent.privacyNotice.switchLabel"),
            to: (0, $lDZlX.RoutesPath).TermsOfUse
        }
    });
    else if (isLoading) content = /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {});
    else content = isError ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
        onRefresh: operation
    }) : null;
    return /*#__PURE__*/ (0, $iKObn.jsx)($ea594a6041ee1c5f$var$Container, {
        children: content
    });
};
const $ea594a6041ee1c5f$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "stretch")};
	flex-grow: 1;
`;



var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $28f8Y = parcelRequire("28f8Y");

var $1IlhR = parcelRequire("1IlhR");

var $lDZlX = parcelRequire("lDZlX");


var $5WGN2 = parcelRequire("5WGN2");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
const $0a69857cc2652519$export$3b099986889b4c15 = ()=>{
    const { format: format, locale: locale } = (0, $1eHG3.useI18n)();
    const retrieveTermsOfUse = (0, $81g6h.useCallback)(()=>(0, $ghfIB.legalContentManager).retrieveTermsOfUse(locale), [
        locale
    ]);
    const [operation, isLoading, isError] = (0, $grmoS.useAsyncOperation)(retrieveTermsOfUse, {});
    const termsOfUse = (0, $1IWnK.useObservable)((0, $ghfIB.legalContentManager).termsOfUse);
    let fallbackContent = null;
    if (isLoading) fallbackContent = /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {});
    else if (isError) fallbackContent = /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
        onRefresh: operation
    });
    (0, $81g6h.useEffect)(()=>{
        operation();
    }, [
        operation
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($0a69857cc2652519$var$Container, {
        children: termsOfUse ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $d0520af42d86d748$export$c749023b2d124212), {
            title: format("legalContent.termsOfUse.title"),
            content: termsOfUse.content,
            headerLink: {
                label: format("legalContent.termsOfUse.switchLabel"),
                to: (0, $lDZlX.RoutesPath).PrivacyNotice
            }
        }) : fallbackContent
    });
};
const $0a69857cc2652519$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "stretch")};
	flex-grow: 1;
`;



var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $bXTqq = parcelRequire("bXTqq");

var $hE6rp = parcelRequire("hE6rp");
function $fec74558288ce465$export$1f9b870ad76091() {
    return (0, $hE6rp.useParams)();
}



var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $bhNoX = parcelRequire("bhNoX");

var $6nO8b = parcelRequire("6nO8b");

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $bXTqq = parcelRequire("bXTqq");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $12cV0 = parcelRequire("12cV0");

var $5UMQ1 = parcelRequire("5UMQ1");

var $GDBjl = parcelRequire("GDBjl");

var $dhb7H = parcelRequire("dhb7H");

var $9XVwj = parcelRequire("9XVwj");

var $lDZlX = parcelRequire("lDZlX");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $a6fIt = parcelRequire("a6fIt");

var $5UMQ1 = parcelRequire("5UMQ1");

var $8FlUV = parcelRequire("8FlUV");

var $hIci4 = parcelRequire("hIci4");

var $jjBFV = parcelRequire("jjBFV");

var $kI5xQ = parcelRequire("kI5xQ");
parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");

var $gVYTG = parcelRequire("gVYTG");

var $4Ms0E = parcelRequire("4Ms0E");
const $7d321a46827cf12b$export$fe750e20a65dd013 = ({ control: control, emailError: emailError, setEmailError: setEmailError, onEmailInputLeave: onEmailInputLeave, countryLocales: countryLocales = {
    locales: new Map()
}, isCountryLanguagesFieldVisible: isCountryLanguagesFieldVisible = false })=>{
    const { format: format, locale: locale } = (0, $1eHG3.useI18n)();
    const selectedLocale = (0, $eKUeg.useWatch)({
        control: control,
        name: "locale"
    }) ?? locale;
    return /*#__PURE__*/ (0, $iKObn.jsxs)($7d321a46827cf12b$var$FormContainer, {
        children: [
            isCountryLanguagesFieldVisible && /*#__PURE__*/ (0, $iKObn.jsx)((0, $4Ms0E.CountryLanguagesField), {
                name: "locale",
                control: control,
                locales: countryLocales.locales,
                labelStyle: {
                    marginTop: 16,
                    marginBottom: 8
                }
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                name: "email",
                control: control,
                rules: {
                    required: format("global.form.field.requiredError"),
                    pattern: {
                        value: (0, $kI5xQ.REGEX_EMAIL),
                        message: format("register.accountCreation.email.formatError")
                    },
                    onChange: ()=>setEmailError("")
                },
                render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($7d321a46827cf12b$var$EmailFieldLabel, {
                                className: "p-size-m",
                                children: format("register.accountCreation.email.label")
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                ...field,
                                "data-test": (0, $a6fIt.e2eTestId).registerPt.emailTextInput,
                                placeholder: format("register.accountCreation.email.placeholder"),
                                error: fieldState.invalid || !!emailError,
                                inputMode: "email",
                                autoCorrect: "off",
                                autoCapitalize: "none",
                                onBlur: (e)=>onEmailInputLeave?.(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($7d321a46827cf12b$var$StyledErrorMessage, {
                                children: fieldState.error?.message || emailError
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $jjBFV.PasswordField), {
                dataTest: (0, $a6fIt.e2eTestId).registerPt.passwordTextInput,
                control: control,
                error: false,
                name: "password",
                labelStyle: {
                    marginTop: 16
                },
                rulesStyle: {
                    fontSize: "0.75rem",
                    marginTop: 8
                }
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $gVYTG.ConsentContainer), {
                control: control,
                documentsLocale: selectedLocale
            })
        ]
    });
};
const $7d321a46827cf12b$var$FormContainer = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: column;
`;
const $7d321a46827cf12b$var$StyledErrorMessage = (0, $5UMQ1.default)((0, $8FlUV.ErrorMessage))`
	margin-top: 8px;
`;
const $7d321a46827cf12b$var$EmailFieldLabel = (0, $5UMQ1.default).label`
	margin-top: 16px;
	margin-bottom: 8px;
`;


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $buI4E = parcelRequire("buI4E");

var $dU78w = parcelRequire("dU78w");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
const $ddf922e49e1d02e0$export$eb41a5af6a1796c2 = ({ onSuccess: onSuccess, veevaUserRecordData: veevaUserRecordData, countryLocales: countryLocales })=>{
    const isCountryLanguagesFieldVisible = (0, $81g6h.useMemo)(()=>Array.from(countryLocales.locales.values()).flat().length > 1, [
        countryLocales
    ]);
    const [emailError, setEmailError] = (0, $81g6h.useState)("");
    const { format: format, locale: locale } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    const user = (0, $1IWnK.useObservable)((0, $ghfIB.userManager).user);
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const termsOfUse = (0, $1IWnK.useObservable)((0, $ghfIB.legalContentManager).termsOfUse);
    const privacyNotice = (0, $1IWnK.useObservable)((0, $ghfIB.legalContentManager).privacyNotice);
    const { control: control, handleSubmit: handleSubmit, reset: reset, watch: watch } = (0, $eKUeg.useForm)({
        defaultValues: {
            locale: countryLocales.defaultLocale && (0, $bXTqq.localeToIntlLocale)(countryLocales.defaultLocale),
            email: "",
            password: "",
            consent: false,
            agreeToPhysiomeEmails: false,
            agreeToBiogenEmails: false
        }
    });
    const newLocale = watch("locale");
    const handleLocaleChange = (0, $81g6h.useCallback)(async ()=>{
        if ((0, $lTdpc.isNotNil)(newLocale) && locale !== newLocale) {
            (0, $ghfIB.registerManager).changeLocale(newLocale);
            await (0, $ghfIB.legalContentManager).retrieveLegalDocuments(newLocale);
        }
    }, [
        locale,
        newLocale
    ]);
    (0, $81g6h.useEffect)(()=>{
        handleLocaleChange();
    }, [
        handleLocaleChange
    ]);
    const email = watch("email");
    const emailAlreadyExistsError = (0, $81g6h.useMemo)(()=>format("register.accountCreation.email.userExistsError", {
            link: {
                className: "p-size-s-bold underline",
                onClick: ()=>navigate((0, $lDZlX.RoutesPath).Login, {
                        state: {
                            email: email
                        }
                    })
            }
        }), [
        format,
        navigate,
        email
    ]);
    (0, $81g6h.useEffect)(()=>{
        reset({
            locale: countryLocales.defaultLocale && (0, $bXTqq.localeToIntlLocale)(countryLocales.defaultLocale),
            email: veevaUserRecordData?.email ?? "",
            password: "",
            consent: false,
            agreeToPhysiomeEmails: false,
            agreeToBiogenEmails: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        veevaUserRecordData
    ]);
    const onVipRegister = (0, $81g6h.useCallback)(async (data)=>{
        try {
            if ((0, $lTdpc.isNotNil)(privacyNotice) && (0, $lTdpc.isNotNil)(termsOfUse) && (0, $lTdpc.isNotNil)(veevaUserRecordData)) {
                const createVipPtInput = {
                    record: veevaUserRecordData,
                    ...data,
                    pnVersion: privacyNotice.version,
                    touVersion: termsOfUse.version
                };
                await (0, $ghfIB.vipRegisterManager).registerVipUser(createVipPtInput);
                (0, $ghfIB.analyticsService).trackEvent({
                    category: (0, $auPqo.AnalyticsCategory).PERMISSIONS,
                    action: data.agreeToBiogenEmails ? "acceptEmailConsent" : "refuseEmailConsent",
                    params: [
                        "biogen"
                    ]
                });
                (0, $ghfIB.analyticsService).trackEvent({
                    category: (0, $auPqo.AnalyticsCategory).PERMISSIONS,
                    action: data.agreeToPhysiomeEmails ? "acceptEmailConsent" : "refuseEmailConsent",
                    params: [
                        "physiome"
                    ]
                });
                (0, $ghfIB.analyticsService).trackEvent({
                    category: (0, $auPqo.AnalyticsCategory).REGISTRATION,
                    action: "accountCreation",
                    params: [
                        user?.country ?? "",
                        "VIP flow",
                        false
                    ]
                });
                onSuccess?.();
                await (0, $ghfIB.userManager).loginWithEmail(data.email, data.password);
                if (isCountryLanguagesFieldVisible && (0, $lTdpc.isNotNil)(data.locale)) {
                    const newUserLocale = (0, $bXTqq.intlLocaleToLocale)(data.locale);
                    await (0, $ghfIB.userManager).updateUser({
                        locale: newUserLocale
                    });
                }
            }
        } catch (e) {
            if (e instanceof (0, $12cV0.UsernameExistsCodeError)) {
                setEmailError(emailAlreadyExistsError);
                return;
            }
            showToast(format("global.toast.error.title"), format("global.toast.error.message"));
            throw e;
        }
    }, [
        privacyNotice,
        termsOfUse,
        veevaUserRecordData,
        user?.country,
        onSuccess,
        isCountryLanguagesFieldVisible,
        showToast,
        format,
        emailAlreadyExistsError
    ]);
    const [registerVip, loading] = (0, $grmoS.useAsyncOperation)(onVipRegister, {});
    return /*#__PURE__*/ (0, $iKObn.jsxs)($ddf922e49e1d02e0$var$MainContainer, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($ddf922e49e1d02e0$var$StyledSpace, {}),
            /*#__PURE__*/ (0, $iKObn.jsx)($ddf922e49e1d02e0$var$StyledAppLogo, {
                height: 54,
                width: 211
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($ddf922e49e1d02e0$var$Title, {
                className: "p-size-l-bold",
                children: format("login.vip.newTitle", {
                    name: (0, $buI4E.formatName)({
                        firstName: veevaUserRecordData?.firstName,
                        lastName: veevaUserRecordData?.lastName
                    })
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($ddf922e49e1d02e0$var$SubTitle, {
                className: "p-size-s",
                children: format("login.vip.newSubtitle")
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($ddf922e49e1d02e0$var$Form, {
                onSubmit: handleSubmit(registerVip),
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $7d321a46827cf12b$export$fe750e20a65dd013), {
                        control: control,
                        emailError: emailError,
                        setEmailError: (val)=>setEmailError(val),
                        countryLocales: countryLocales,
                        isCountryLanguagesFieldVisible: isCountryLanguagesFieldVisible
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($ddf922e49e1d02e0$var$StyledButton, {
                        type: "submit",
                        label: format("register.accountCreation.registerButton.pt"),
                        loading: loading
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($ddf922e49e1d02e0$var$Separator, {}),
                    /*#__PURE__*/ (0, $iKObn.jsx)($ddf922e49e1d02e0$var$LogInLabel, {
                        className: "p-size-s",
                        children: format("register.alreadyHaveAccount", {
                            link: {
                                className: "text-primary p-size-s-bold",
                                onClick: ()=>navigate((0, $lDZlX.RoutesPath).Login)
                            }
                        })
                    })
                ]
            })
        ]
    });
};
const $ddf922e49e1d02e0$var$MainContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "center")};
	width: 100%;
`;
const $ddf922e49e1d02e0$var$StyledAppLogo = (0, $5UMQ1.default)((0, $GDBjl.AppLogo))`
	margin-bottom: 24px;
	align-self: center;
`;
const $ddf922e49e1d02e0$var$StyledSpace = (0, $5UMQ1.default).div`
	flex: 1;
`;
const $ddf922e49e1d02e0$var$Title = (0, $5UMQ1.default).h3`
	align-self: start;
	padding-bottom: 28px;
	padding-top: 80px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding-top: 0px;
	}
`;
const $ddf922e49e1d02e0$var$SubTitle = (0, $5UMQ1.default).p`
	align-self: start;
`;
const $ddf922e49e1d02e0$var$Form = (0, $5UMQ1.default)((0, $dU78w.motion).form)`
	${(0, $5WGN2.stack)("L", "flexstart", "stretch")};
	width: 100%;
	margin-bottom: 16px;
`;
const $ddf922e49e1d02e0$var$StyledButton = (0, $5UMQ1.default)((0, $dhb7H.Button))`
	width: 100%;
`;
const $ddf922e49e1d02e0$var$Separator = (0, $5UMQ1.default).div`
	background-color: ${(0, $kKnoQ.colors).grey10};
	height: 1px;
`;
const $ddf922e49e1d02e0$var$LogInLabel = (0, $5UMQ1.default).div`
	text-align: center;
`;



var $grmoS = parcelRequire("grmoS");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $lDZlX = parcelRequire("lDZlX");

var $81g6h = parcelRequire("81g6h");
const $be983e0f784a712b$export$144b62ffea26a8db = (veevaId)=>{
    const navigate = (0, $htiSH.useNavigate)();
    const [veevaUserData, setVeevaUserData] = (0, $81g6h.useState)();
    const fetchVeevaUser = (0, $81g6h.useCallback)(async (userId)=>{
        try {
            const { record: record, emailAlreadyExists: emailAlreadyExists } = await (0, $ghfIB.vipRegisterManager).getVeevaUserData(userId);
            if (emailAlreadyExists) navigate((0, $lDZlX.RoutesPath).Login, {
                state: {
                    email: record.email
                }
            });
            setVeevaUserData(record);
        } catch (_) {
            navigate((0, $lDZlX.RoutesPath).Register);
            return;
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const [fetchVeevaUserData, loading] = (0, $grmoS.useAsyncOperation)(fetchVeevaUser, {});
    (0, $81g6h.useEffect)(()=>{
        veevaId && fetchVeevaUserData(veevaId);
    }, [
        fetchVeevaUserData,
        veevaId
    ]);
    return {
        loading: loading,
        veevaUserData: veevaUserData
    };
};



var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $1IlhR = parcelRequire("1IlhR");

var $81g6h = parcelRequire("81g6h");
var $16481cc1bc2caefe$export$dc8a48d838f0e600;
(function(LoadingSize) {
    LoadingSize["FullScreen"] = "FullScreen";
    LoadingSize["FullSpace"] = "FullSpace";
})($16481cc1bc2caefe$export$dc8a48d838f0e600 || ($16481cc1bc2caefe$export$dc8a48d838f0e600 = {}));
const $16481cc1bc2caefe$export$3dfcbcf80c1dbed5 = ({ size: size } = {
    size: "FullSpace"
})=>{
    const loaderStyle = (0, $81g6h.useMemo)(()=>{
        switch(size){
            case "FullSpace":
                return {
                    flex: 1
                };
            case "FullScreen":
            default:
                return {
                    height: "100vh",
                    width: "100vw"
                };
        }
    }, [
        size
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($16481cc1bc2caefe$var$Container, {
        style: loaderStyle,
        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {})
    });
};
const $16481cc1bc2caefe$var$Container = (0, $5UMQ1.default).div`
	display: flex;
	justify-content: center;
	align-items: center;
`;



var $81g6h = parcelRequire("81g6h");
function $025e7d5f4c580627$export$2e2bcd8739ae039() {
    const { veevaId: veevaId } = (0, $fec74558288ce465$export$1f9b870ad76091)();
    const { veevaUserData: veevaUserData, loading: loading } = (0, $be983e0f784a712b$export$144b62ffea26a8db)(veevaId);
    const { supportedLocales: supportedLocales } = (0, $bhNoX.useSupportedLocales)({
        localeManager: $ghfIB.localeManager
    });
    const countryLocales = (0, $81g6h.useMemo)(()=>(0, $bXTqq.getCountryLocalesFromLang)(veevaUserData?.locale, supportedLocales), [
        supportedLocales,
        veevaUserData?.locale
    ]);
    (0, $81g6h.useEffect)(()=>{
        (0, $ghfIB.analyticsService).trackEvent({
            category: (0, $auPqo.AnalyticsCategory).VIP,
            action: "reachStep"
        });
    }, []);
    const initVipFlow = (0, $81g6h.useCallback)(async ()=>{
        if (veevaUserData) {
            await (0, $ghfIB.registerManager).sendCountryCode(veevaUserData.countryCode);
            await (0, $ghfIB.legalContentManager).retrieveLegalDocuments(veevaUserData.locale);
        }
    }, [
        veevaUserData
    ]);
    const [retrieveLegalDocuments] = (0, $grmoS.useAsyncOperation)(initVipFlow, {});
    (0, $81g6h.useEffect)(()=>{
        retrieveLegalDocuments();
    }, [
        retrieveLegalDocuments,
        veevaUserData?.countryCode
    ]);
    return loading || !veevaUserData ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $16481cc1bc2caefe$export$3dfcbcf80c1dbed5), {}) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $6nO8b.LoginContainer), {
        form: /*#__PURE__*/ (0, $iKObn.jsx)((0, $ddf922e49e1d02e0$export$eb41a5af6a1796c2), {
            onSuccess: ()=>{
                (0, $ghfIB.analyticsService).trackEvent({
                    category: (0, $auPqo.AnalyticsCategory).VIP,
                    action: "validateStep"
                });
            },
            veevaUserRecordData: veevaUserData,
            countryLocales: {
                locales: countryLocales,
                defaultLocale: veevaUserData.locale
            }
        })
    });
}



var $iKObn = parcelRequire("iKObn");

var $htiSH = parcelRequire("htiSH");

var $lDZlX = parcelRequire("lDZlX");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");

var $hE6rp = parcelRequire("hE6rp");
function $c61001f0447fdbb9$export$2e2bcd8739ae039() {
    const location = (0, $hE6rp.useLocation)();
    const navigate = (0, $htiSH.useNavigate)();
    (0, $81g6h.useEffect)(()=>{
        const searchParams = new URLSearchParams(location.search);
        const { veevaid: veevaId, ...otherParams } = Object.fromEntries(searchParams.entries());
        if ((0, $lTdpc.isNotNil)(veevaId)) // We cast otherParams as undefined because we don't expect any query params for the VipLogin page.
        // Nonetheless, we want to pass any potential query params to the VipLogin.
        navigate((0, $lDZlX.RoutesPath).VipLogin, {
            route: {
                veevaId: veevaId
            },
            query: otherParams
        });
        else navigate((0, $lDZlX.RoutesPath).Register);
    }, [
        location.search,
        navigate
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {});
}



var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $kkH7g = parcelRequire("kkH7g");

var $5UMQ1 = parcelRequire("5UMQ1");

var $243Cr = parcelRequire("243Cr");

var $1IlhR = parcelRequire("1IlhR");

var $lKlJT = parcelRequire("lKlJT");

var $8CNE2 = parcelRequire("8CNE2");

var $5kXMA = parcelRequire("5kXMA");

var $lDZlX = parcelRequire("lDZlX");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5CjOe = parcelRequire("5CjOe");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
var $e60bcd234bf92f2b$var$EmptyMessageIcon = function EmptyMessageIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_222_14037",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "10",
                width: "58",
                height: "45",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M55.458 43.954H21.793L11.557 54.362c-.44.447-1.21.138-1.21-.495v-9.913h-2.58A4.765 4.765 0 0 1 3 39.187v-24.42A4.765 4.765 0 0 1 7.767 10h47.691a4.765 4.765 0 0 1 4.767 4.767v24.42a4.765 4.765 0 0 1-4.767 4.767Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_222_14037)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M30.055 61.227c19.493 0 35.295-15.802 35.295-35.295 0-19.494-15.802-35.296-35.295-35.296-19.494 0-35.296 15.802-35.296 35.296 0 19.493 15.802 35.295 35.296 35.295Z",
                        fill: "#4427FA"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M22.722 62.053c17.229 0 31.195-13.967 31.195-31.196 0-17.23-13.966-31.196-31.195-31.196-17.23 0-31.196 13.967-31.196 31.196S5.493 62.053 22.722 62.053Z",
                        fill: "#334EF5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M18.285 60.347c12.852 0 23.271-10.42 23.271-23.272 0-12.852-10.419-23.27-23.271-23.27-12.853 0-23.271 10.418-23.271 23.27 0 12.853 10.418 23.272 23.27 23.272Z",
                        fill: "#2275F0"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M11.406 58.008c9.76 0 17.672-7.912 17.672-17.672 0-9.76-7.912-17.672-17.672-17.672-9.76 0-17.672 7.912-17.672 17.672 0 9.76 7.912 17.672 17.672 17.672Z",
                        fill: "#119CEB"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M5.882 57.802c6.698 0 12.128-5.43 12.128-12.128S12.58 33.547 5.882 33.547s-12.127 5.43-12.127 12.127c0 6.698 5.43 12.128 12.127 12.128Z",
                        fill: "#00C3E6"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M20.569 33.492c0-1.706 1.17-2.938 2.84-2.938 1.672 0 2.814 1.204 2.814 2.938 0 1.733-1.135 2.91-2.84 2.91-1.707 0-2.814-1.232-2.814-2.91ZM28.782 33.492c0-1.706 1.17-2.938 2.841-2.938 1.672 0 2.814 1.204 2.814 2.938 0 1.733-1.135 2.91-2.841 2.91-1.706 0-2.814-1.232-2.814-2.91ZM36.995 33.492c0-1.706 1.17-2.938 2.842-2.938 1.671 0 2.813 1.204 2.813 2.938 0 1.733-1.135 2.91-2.841 2.91-1.706 0-2.813-1.232-2.813-2.91Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_222_14037)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M52 64c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z",
                        fill: "#FF0A4B"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M47.088 48.456c0-.65.209-1.31.626-1.977.417-.667 1.025-1.217 1.826-1.66.8-.441 1.735-.658 2.81-.658.993 0 1.868.184 2.635.55.76.367 1.351.868 1.76 1.493a3.67 3.67 0 0 1 .625 2.06c0 .584-.116 1.092-.358 1.534a4.723 4.723 0 0 1-.842 1.134c-.326.317-.91.86-1.752 1.61-.233.217-.417.4-.558.559a2.487 2.487 0 0 0-.317.442 1.998 1.998 0 0 0-.159.4c-.033.133-.091.367-.166.7-.134.71-.543 1.068-1.226 1.068-.359 0-.66-.117-.901-.35-.242-.234-.367-.576-.367-1.043 0-.575.092-1.076.267-1.493.175-.425.417-.792.709-1.109.292-.317.692-.7 1.192-1.134.442-.383.76-.675.95-.867.193-.192.36-.409.493-.65.133-.242.2-.5.2-.784 0-.55-.2-1.01-.609-1.385-.408-.375-.934-.567-1.576-.567-.75 0-1.309.192-1.668.567-.358.376-.658.943-.9 1.685-.234.775-.676 1.159-1.326 1.159-.384 0-.709-.134-.968-.409-.266-.267-.391-.567-.391-.875h-.009Zm5.02 11.266c-.416 0-.783-.134-1.092-.409-.309-.267-.467-.65-.467-1.134 0-.434.15-.792.45-1.092.3-.292.676-.442 1.11-.442.433 0 .792.15 1.092.442.292.292.442.658.442 1.092 0 .484-.15.859-.459 1.134a1.557 1.557 0 0 1-1.067.409h-.009Z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_222_14037",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(40 40)",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
};
$e60bcd234bf92f2b$var$EmptyMessageIcon.defaultProps = {
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $e60bcd234bf92f2b$export$c536f637504a7f68 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($e60bcd234bf92f2b$var$Line, {}),
            /*#__PURE__*/ (0, $iKObn.jsx)($e60bcd234bf92f2b$var$Container, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $5CjOe.MessageContainer), {
                    iconSvg: $e60bcd234bf92f2b$var$EmptyMessageIcon,
                    title: format("notificationCenter.emptyList.title"),
                    description: format("notificationCenter.emptyList.subtitle")
                })
            })
        ]
    });
};
const $e60bcd234bf92f2b$var$Container = (0, $5UMQ1.default).div`
	margin-top: 128px;
	margin-bottom: 128px;
	display: grid;
	place-content: center;
`;
const $e60bcd234bf92f2b$var$Line = (0, $5UMQ1.default).div`
	margin-top: 16px;
	height: 1px;
	background-color: ${(0, $kKnoQ.colors).grey10};
`;



var $70tpO = parcelRequire("70tpO");

var $7CwXm = parcelRequire("7CwXm");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $iV9Zw = parcelRequire("iV9Zw");

var $8zvzh = parcelRequire("8zvzh");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $5UMQ1 = parcelRequire("5UMQ1");

var $lKlJT = parcelRequire("lKlJT");

var $8CNE2 = parcelRequire("8CNE2");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $4UKJF = parcelRequire("4UKJF");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $c22GE = parcelRequire("c22GE");

var $243Cr = parcelRequire("243Cr");

var $28f8Y = parcelRequire("28f8Y");

var $5kXMA = parcelRequire("5kXMA");

var $lDZlX = parcelRequire("lDZlX");

var $8uAJp = parcelRequire("8uAJp");

var $kvJz4 = parcelRequire("kvJz4");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");

var $bhNoX = parcelRequire("bhNoX");

var $aZEA4 = parcelRequire("aZEA4");

var $9IUdZ = parcelRequire("9IUdZ");
const $ef2f10a749a73060$export$a957c933d9e7c63f = ()=>{
    const navigate = (0, $htiSH.useNavigate)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const { format: format } = (0, $1eHG3.useI18n)();
    const { formatMedicalProfession: formatMedicalProfession } = (0, $8uAJp.useMedicalProfession)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const user = (0, $4UKJF.useUser)();
    const { supportedLocales: supportedLocales } = (0, $bhNoX.useSupportedLocales)({
        localeManager: $ghfIB.localeManager
    });
    const GET_COUNTRY_NAME = (countryCode)=>(0, $aZEA4.countries)[countryCode.toUpperCase()].native;
    const countryLanguageTraduction = (0, $9IUdZ.useCountryLanguageOptions)(new Map(user?.country ? [
        [
            user.country,
            [
                user.locale
            ]
        ]
    ] : []), true, GET_COUNTRY_NAME);
    const userSupportedLocales = (0, $81g6h.useMemo)(()=>{
        if (user?.country) return supportedLocales.get(user.country) ?? [];
        return [];
    }, [
        supportedLocales,
        user?.country
    ]);
    const openEditPasswordDialog = (0, $81g6h.useCallback)(()=>{
        (0, $kvJz4.sendAnalyticsEventEditPassword)();
        dialogContext?.openModal((0, $243Cr.ModalId).EditPassword);
    }, [
        dialogContext
    ]);
    const openEditProfessionalInfoDialog = (0, $81g6h.useCallback)(()=>{
        (0, $kvJz4.sendAnalyticsEventEditProfile)();
        dialogContext?.openModal((0, $243Cr.ModalId).EditProfessionalInformation, {
            defaultValues: {
                firstName: user?.firstName,
                lastName: user?.lastName,
                postalCode: user?.postalCode,
                cityOfPractice: user?.cityOfPractice
            }
        });
    }, [
        dialogContext,
        user
    ]);
    const openEditUserLocaleDialog = (0, $81g6h.useCallback)(()=>{
        if (!user?.locale || !user.country) return;
        dialogContext?.openModal((0, $243Cr.ModalId).EditUserLocale, {
            currentLocale: user.locale,
            currentCountry: user.country,
            userSupportedLocales: userSupportedLocales
        });
    }, [
        dialogContext,
        user,
        userSupportedLocales
    ]);
    if (!user) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
        onRefresh: (0, $ghfIB.userManager).retrieveUser
    });
    return /*#__PURE__*/ (0, $iKObn.jsxs)($ef2f10a749a73060$var$Sections, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($ef2f10a749a73060$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$Title, {
                        children: format("settings.accountTab.professionalInformationSection.title")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($ef2f10a749a73060$var$SectionContent, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)($ef2f10a749a73060$var$TwoColumnLayout, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$InfoField, {
                                        label: format("settings.accountTab.professionalInformationSection.firstName"),
                                        value: user.firstName
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$InfoField, {
                                        label: format("settings.accountTab.professionalInformationSection.lastName"),
                                        value: user.lastName
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$InfoField, {
                                        label: format("settings.accountTab.professionalInformationSection.postalCode"),
                                        value: user.postalCode
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$InfoField, {
                                        label: format("settings.accountTab.professionalInformationSection.cityOfPractice"),
                                        value: user.cityOfPractice
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$InfoField, {
                                        label: format("settings.accountTab.professionalInformationSection.medicalProfession"),
                                        value: (0, $lTdpc.isNotNil)(user.medicalProfession) ? formatMedicalProfession(user.medicalProfession) : undefined
                                    }),
                                    isDesktop && /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$EmptyField, {}),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$InfoField, {
                                        label: format("settings.accountTab.professionalInformationSection.typeOfIdentification"),
                                        value: user.professionalId?.name
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$InfoField, {
                                        label: format("settings.accountTab.professionalInformationSection.professionalNumber"),
                                        value: user.professionalId?.value
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                                uiStyle: "secondary",
                                label: format("settings.accountTab.professionalInformationSection.editButton"),
                                onClick: openEditProfessionalInfoDialog
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($ef2f10a749a73060$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$Title, {
                        children: format("settings.accountTab.credentialsSection.title")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($ef2f10a749a73060$var$SectionContent, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)($ef2f10a749a73060$var$OneColumnLayout, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$InfoField, {
                                        label: format("settings.accountTab.credentialsSection.emailAddress"),
                                        value: user.email
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$InfoField, {
                                        label: format("settings.accountTab.credentialsSection.password"),
                                        value: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$EndAlignedButton, {
                                uiStyle: "secondary",
                                label: format("settings.accountTab.credentialsSection.editButton"),
                                onClick: openEditPasswordDialog
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($ef2f10a749a73060$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$Title, {
                        children: format("settings.accountTab.languageSection.title")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($ef2f10a749a73060$var$SectionContent, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$OneColumnLayout, {
                                children: /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$LanguageDescription, {
                                    className: "p-size-s-bold",
                                    children: countryLanguageTraduction.get(user.locale)
                                })
                            }),
                            userSupportedLocales.length > 1 && /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$EndAlignedButton, {
                                uiStyle: "secondary",
                                label: format("settings.accountTab.languageSection.editButton"),
                                onClick: openEditUserLocaleDialog
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($ef2f10a749a73060$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$Title, {
                        children: format("settings.accountTab.deleteSection.title")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($ef2f10a749a73060$var$Description, {
                        className: "p-size-s",
                        children: format("settings.accountTab.deleteSection.description")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $c22GE.TertiaryButton), {
                        label: format("settings.accountTab.deleteSection.cta"),
                        onClick: ()=>navigate((0, $lDZlX.RoutesPath).LeavingReasons),
                        uiStyle: "danger"
                    })
                ]
            })
        ]
    });
};
const $ef2f10a749a73060$var$Sections = (0, $5UMQ1.default).div`
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		margin: 32px 24px;
		${(0, $5WGN2.stack)(32, "flexstart", "stretch")}
	}
`;
const $ef2f10a749a73060$var$Section = (0, $5UMQ1.default).div``;
const $ef2f10a749a73060$var$Title = (0, $5UMQ1.default).h3`
	margin-top: 40px;
	margin-bottom: 16px;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		margin-top: 0;
	}
`;
const $ef2f10a749a73060$var$SectionContent = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("L", "spacebetween", "flexstart")};
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		${(0, $5WGN2.stack)("L", "flexstart", "stretch")}
	}
`;
const $ef2f10a749a73060$var$Description = (0, $5UMQ1.default).p`
	margin-bottom: 16px;
`;
const $ef2f10a749a73060$var$LanguageDescription = (0, $5UMQ1.default).p`
	margin-top: 15px;
`;
const $ef2f10a749a73060$var$OneColumnLayout = (0, $5UMQ1.default).div`
	display: grid;
	place-content: start;
	align-items: start;
	gap: 20px 32px;
`;
const $ef2f10a749a73060$var$TwoColumnLayout = (0, $5UMQ1.default)($ef2f10a749a73060$var$OneColumnLayout)`
	grid-template-columns: auto auto;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		grid-template-columns: 1fr;
		${(0, $5WGN2.stack)(undefined, "flexstart", "stretch")}
	}
`;
const $ef2f10a749a73060$var$EmptyField = (0, $5UMQ1.default).div``;
const $ef2f10a749a73060$var$EndAlignedButton = (0, $5UMQ1.default)((0, $dhb7H.Button))`
	align-self: end;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		align-self: stretch;
	}
`;
const $ef2f10a749a73060$var$InfoField = ({ label: label, value: value })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                className: "p-size-s-bold",
                children: label
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: (0, $lTdpc.isNotEmpty)(value) ? value : format("global.empty")
            })
        ]
    });
};



var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $02mFA = parcelRequire("02mFA");

var $5UMQ1 = parcelRequire("5UMQ1");

var $9XVwj = parcelRequire("9XVwj");

var $5kXMA = parcelRequire("5kXMA");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $02mFA = parcelRequire("02mFA");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5kXMA = parcelRequire("5kXMA");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $lTdpc = parcelRequire("lTdpc");

var $68IWj = parcelRequire("68IWj");

var $81g6h = parcelRequire("81g6h");
function $093df5bb12c35f74$var$booleanToPreferenceStatus(isChecked) {
    return isChecked ? (0, $02mFA.PtNotificationPreferencesStatus).ENABLED : (0, $02mFA.PtNotificationPreferencesStatus).DISABLED;
}
const $093df5bb12c35f74$export$1c600085c01829cd = ({ label: label, preference: preference, onChange: onChange })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const handlePreferenceChange = (0, $81g6h.useCallback)((e, key)=>{
        if (!preference) return;
        if (preference[key] !== (0, $02mFA.PtNotificationPreferencesStatus).NA && (0, $lTdpc.isNotNil)(e.checked)) onChange({
            ...preference,
            [key]: $093df5bb12c35f74$var$booleanToPreferenceStatus(e.checked)
        });
    }, [
        preference,
        onChange
    ]);
    const handleMailChange = (0, $81g6h.useCallback)((e)=>{
        handlePreferenceChange(e, "email");
    }, [
        handlePreferenceChange
    ]);
    const handleWebChange = (0, $81g6h.useCallback)((e)=>{
        handlePreferenceChange(e, "web");
    }, [
        handlePreferenceChange
    ]);
    return (0, $lTdpc.isNotNil)(preference) ? /*#__PURE__*/ (0, $iKObn.jsxs)($093df5bb12c35f74$var$Row, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: label
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($093df5bb12c35f74$var$Checkboxes, {
                children: [
                    preference.email !== (0, $02mFA.PtNotificationPreferencesStatus).NA ? /*#__PURE__*/ (0, $iKObn.jsxs)($093df5bb12c35f74$var$CheckboxContainer, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $68IWj.Checkbox), {
                                inputId: "mail",
                                checked: preference.email === (0, $02mFA.PtNotificationPreferencesStatus).ENABLED,
                                onChange: handleMailChange
                            }),
                            !isDesktop && /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                className: "p-size-s-bold",
                                children: format("settings.notificationPreferences.emailColumn")
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $iKObn.jsx)($093df5bb12c35f74$var$EmptyCheckbox, {}),
                    preference.web !== (0, $02mFA.PtNotificationPreferencesStatus).NA ? /*#__PURE__*/ (0, $iKObn.jsxs)($093df5bb12c35f74$var$CheckboxContainer, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $68IWj.Checkbox), {
                                inputId: "web",
                                checked: preference.web === (0, $02mFA.PtNotificationPreferencesStatus).ENABLED,
                                onChange: handleWebChange
                            }),
                            !isDesktop && /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                className: "p-size-s-bold",
                                children: format("settings.notificationPreferences.webColumn")
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $iKObn.jsx)($093df5bb12c35f74$var$EmptyCheckbox, {})
                ]
            })
        ]
    }) : null;
};
const $093df5bb12c35f74$var$Row = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")};
	margin-bottom: 8px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		${(0, $5WGN2.stack)(8, "center", "flexstart")};
		margin-bottom: 24px;
	}
`;
const $093df5bb12c35f74$var$Checkboxes = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacearound", "center")};
	width: 180px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		width: 300px;
	}
`;
const $093df5bb12c35f74$var$CheckboxContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "center", "center")};
	width: 90px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		justify-content: flex-start;
		gap: 8px;
	}
`;
const $093df5bb12c35f74$var$EmptyCheckbox = (0, $5UMQ1.default).div`
	width: 90px;
`;


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $9AWgp = parcelRequire("9AWgp");

var $81g6h = parcelRequire("81g6h");
var $4c8bc01083229142$var$BrowserIcon = function BrowserIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M3.333 2C2.597 2 2 2.597 2 3.333v9.334C2 13.395 2.605 14 3.333 14h9.334c.728 0 1.333-.605 1.333-1.333V3.333C14 2.597 13.403 2 12.667 2H3.333ZM4 3.333a.667.667 0 1 1 0 1.334.667.667 0 0 1 0-1.334Zm2 0a.667.667 0 1 1 0 1.334.667.667 0 0 1 0-1.334Zm2.667 0H12a.667.667 0 0 1 0 1.334H8.667a.667.667 0 0 1 0-1.334ZM3.333 6h9.334v6.667H3.333V6Z",
            fill: "currentColor"
        })
    });
};
$4c8bc01083229142$var$BrowserIcon.defaultProps = {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $4c8bc01083229142$var$MailIcon = function MailIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M20 21H4c-1.65 0-3-1.35-3-3V6c0-1.65 1.35-3 3-3h16c1.65 0 3 1.35 3 3v12c0 1.65-1.35 3-3 3ZM4 5c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H4Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.134 7.919a1 1 0 0 1 1.378-.315l4.956 3.113a1 1 0 0 0 1.064 0l4.956-3.113a1 1 0 1 1 1.063 1.694l-4.955 3.112a3 3 0 0 1-3.192 0L5.45 9.298a1 1 0 0 1-.315-1.38Z",
                fill: "currentColor"
            })
        ]
    });
};
$4c8bc01083229142$var$MailIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $4c8bc01083229142$export$6246e8e5e661699b = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const [notificationPreferences, setNotificationPreferences] = (0, $81g6h.useState)((0, $ghfIB.userManager).user.get()?.notificationPreferences ?? []);
    const savedNotificationPreferences = (0, $81g6h.useRef)((0, $ghfIB.userManager).user.get()?.notificationPreferences ?? []);
    const findPreferenceByType = (type)=>notificationPreferences.find((pref)=>pref.type === type);
    const changePreferenceType = (changedPref)=>{
        const updatedNotificationPreferences = notificationPreferences.map((pref)=>{
            if (pref.type === changedPref.type) return {
                ...pref,
                web: changedPref.web,
                email: changedPref.email
            };
            return pref;
        });
        setNotificationPreferences(updatedNotificationPreferences);
    };
    function sendAnalyticsOnDifferences(oldPrefs, newPrefs) {
        newPrefs.forEach((newPref)=>{
            const oldPref = oldPrefs.find((p)=>p.type === newPref.type);
            if (newPref.web !== oldPref?.web) (0, $ghfIB.analyticsService).trackEvent({
                category: (0, $auPqo.AnalyticsCategory).NOTIFICATIONS,
                action: "modifyNotificationPreferences",
                params: [
                    newPref.type,
                    "Web",
                    newPref.web
                ]
            });
            if (newPref.email !== oldPref?.email) (0, $ghfIB.analyticsService).trackEvent({
                category: (0, $auPqo.AnalyticsCategory).NOTIFICATIONS,
                action: "modifyNotificationPreferences",
                params: [
                    newPref.type,
                    "Email",
                    newPref.email
                ]
            });
        });
    }
    const [savePreferences, isLoading] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(async ()=>{
        try {
            await (0, $ghfIB.userManager).updateNotificationPreferences(notificationPreferences);
            showToast(format("settings.notificationPreferences.save.successToast.title"), format("settings.notificationPreferences.save.successToast.message"), "success");
            sendAnalyticsOnDifferences(savedNotificationPreferences.current, notificationPreferences);
            savedNotificationPreferences.current = [
                ...notificationPreferences
            ];
        } catch (e) {
            showToast(format("settings.notificationPreferences.save.errorToast.title"), format("settings.notificationPreferences.save.errorToast.message"), "error");
            (0, $ghfIB.networkActionsErrorsManager).reportError(e);
        }
    }, [
        format,
        notificationPreferences,
        showToast
    ]), {});
    const preferencesGroups = (0, $81g6h.useMemo)(()=>[
            {
                preferenceTypes: [
                    {
                        label: format("settings.notificationPreferences.checkboxes.physiomeEmails"),
                        type: (0, $02mFA.PtNotificationPreferencesType).PHYSIO_ME
                    },
                    {
                        label: format("settings.notificationPreferences.checkboxes.biogenEmails"),
                        type: (0, $02mFA.PtNotificationPreferencesType).BIOGEN
                    }
                ]
            },
            {
                title: format("settings.notificationPreferences.title.patientRelated"),
                preferenceTypes: [
                    {
                        label: format("settings.notificationPreferences.checkboxes.patientProgramStarted"),
                        type: (0, $02mFA.PtNotificationPreferencesType).PATIENT_PROGRAM_STARTED
                    },
                    {
                        label: format("settings.notificationPreferences.checkboxes.patientProgramEndingSoon"),
                        type: (0, $02mFA.PtNotificationPreferencesType).PATIENT_PROGRAM_ENDING_SOON
                    },
                    {
                        label: format("settings.notificationPreferences.checkboxes.patientProgramEnded"),
                        type: (0, $02mFA.PtNotificationPreferencesType).PATIENT_PROGRAM_ENDED
                    },
                    {
                        label: format("settings.notificationPreferences.checkboxes.patientRegistered"),
                        type: (0, $02mFA.PtNotificationPreferencesType).PATIENT_REGISTERED
                    },
                    {
                        label: format("settings.notificationPreferences.checkboxes.monthlyRecap"),
                        type: (0, $02mFA.PtNotificationPreferencesType).MONTHLY_RECAP
                    }
                ]
            },
            {
                title: format("settings.notificationPreferences.title.hctRelated"),
                preferenceTypes: [
                    {
                        label: format("settings.notificationPreferences.checkboxes.hctInvitationAccepted"),
                        type: (0, $02mFA.PtNotificationPreferencesType).HCT_INVITATION_ACCEPTED
                    }
                ]
            }
        ], [
        format
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($4c8bc01083229142$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($4c8bc01083229142$var$RowTitle, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("h3", {
                        children: format("settings.notificationPreferences.title.physiomeUpdates")
                    }),
                    isDesktop && /*#__PURE__*/ (0, $iKObn.jsxs)($4c8bc01083229142$var$ColumnTitleContainer, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)($4c8bc01083229142$var$ColumnTitle, {
                                className: "p-size-s-bold",
                                children: [
                                    format("settings.notificationPreferences.emailColumn"),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($4c8bc01083229142$var$MailIcon, {
                                        width: 16,
                                        height: 16
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)($4c8bc01083229142$var$ColumnTitle, {
                                className: "p-size-s-bold",
                                children: [
                                    format("settings.notificationPreferences.webColumn"),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($4c8bc01083229142$var$BrowserIcon, {
                                        width: 16,
                                        height: 16
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            preferencesGroups.map((group)=>/*#__PURE__*/ (0, $iKObn.jsxs)("div", {
                    children: [
                        group.title && /*#__PURE__*/ (0, $iKObn.jsx)($4c8bc01083229142$var$Title, {
                            children: group.title
                        }),
                        group.preferenceTypes.map((pref)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $093df5bb12c35f74$export$1c600085c01829cd), {
                                label: pref.label,
                                preference: findPreferenceByType(pref.type),
                                onChange: (p)=>changePreferenceType({
                                        ...p,
                                        type: p.type
                                    })
                            }, pref.type))
                    ]
                }, group.title ?? group.preferenceTypes.map(({ type: type })=>type).join("-"))),
            /*#__PURE__*/ (0, $iKObn.jsx)($4c8bc01083229142$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)($4c8bc01083229142$var$StyledButton, {
                    label: format("settings.notificationPreferences.saveButton"),
                    onClick: ()=>savePreferences(),
                    loading: isLoading
                })
            })
        ]
    });
};
const $4c8bc01083229142$var$Container = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: column;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		margin: 32px 24px;
	}
`;
const $4c8bc01083229142$var$RowTitle = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")};
	margin-top: 16px;
	margin-bottom: 24px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		${(0, $5WGN2.stack)(undefined, "center", "flexstart")};
		margin-top: 0;
	}
`;
const $4c8bc01083229142$var$Title = (0, $5UMQ1.default).h3`
	margin-top: 40px;
	margin-bottom: 24px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		margin-top: 8px;
		margin-bottom: 16px;
	}
`;
const $4c8bc01083229142$var$ColumnTitleContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacearound", "center")};
	width: 180px;
`;
const $4c8bc01083229142$var$ColumnTitle = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "center", "center")};
	gap: 8px;
	width: 90px;
`;
const $4c8bc01083229142$var$ButtonContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "flexend")}
	margin-top: 40px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		margin-top: 8px;
	}
`;
const $4c8bc01083229142$var$StyledButton = (0, $5UMQ1.default)((0, $9AWgp.Button))`
	min-width: 180px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		min-width: unset;
	}
`;


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $kKnoQ = parcelRequire("kKnoQ");

var $bY9wC = parcelRequire("bY9wC");

var $81g6h = parcelRequire("81g6h");

var $3ff0fa53a76fe5fa$export$c89b88baaf1b40a2;
(function(TabSettings) {
    TabSettings["Account"] = "account";
    TabSettings["NotificationPreferences"] = "notificationPreferences";
    TabSettings["Cookies"] = "cookies";
})($3ff0fa53a76fe5fa$export$c89b88baaf1b40a2 || ($3ff0fa53a76fe5fa$export$c89b88baaf1b40a2 = {}));
const $3ff0fa53a76fe5fa$var$tabIndices = [
    "account",
    "notificationPreferences",
    "cookies"
];
const $3ff0fa53a76fe5fa$export$8f6dcfe950367406 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { active: active } = (0, $8zvzh.useQueryParams)();
    const { updateHistory: updateHistory } = (0, $iV9Zw.useHistory)();
    const [activeTabIndex, setActiveTabIndex] = (0, $81g6h.useState)($3ff0fa53a76fe5fa$var$tabIndices.indexOf(active ?? "account"));
    const selectTab = (0, $81g6h.useCallback)((tabIndex)=>{
        setActiveTabIndex(tabIndex);
        updateHistory({
            active: $3ff0fa53a76fe5fa$var$tabIndices[tabIndex]
        });
    }, [
        updateHistory
    ]);
    const openCookieDialog = (0, $81g6h.useCallback)(()=>{
        (0, $ghfIB.cookiebotManager).openConsentDialog();
        (0, $ghfIB.analyticsService).trackEvent({
            category: (0, $auPqo.AnalyticsCategory).PERMISSIONS,
            action: "openCookieSettings"
        });
    }, []);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($3ff0fa53a76fe5fa$var$StyledPage, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $15ade5a6153d87cc$export$8534dc24c72e73ef), {
                hideForValidatedPt: true,
                showForPendingPt: true
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $8CNE2.PageHeader), {
                title: format("tabbar.settings"),
                tertiaryButton: {
                    label: format("settings.manageCookiesButton"),
                    onClick: openCookieDialog
                }
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($3ff0fa53a76fe5fa$var$Card, {
                className: "p-card",
                children: /*#__PURE__*/ (0, $iKObn.jsxs)($3ff0fa53a76fe5fa$var$StyledTabView, {
                    activeIndex: activeTabIndex,
                    onTabChange: (e)=>selectTab(e.index),
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $bY9wC.TabPanel), {
                            header: format("settings.accountTab.header"),
                            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $ef2f10a749a73060$export$a957c933d9e7c63f), {})
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $bY9wC.TabPanel), {
                            header: format("settings.notificationPreferences"),
                            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $4c8bc01083229142$export$6246e8e5e661699b), {})
                        })
                    ]
                })
            })
        ]
    });
};
const $3ff0fa53a76fe5fa$var$StyledPage = (0, $5UMQ1.default)((0, $lKlJT.Page))`
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding-left: 20px;
		padding-right: 20px;
		max-width: 100%;
	}
`;
const $3ff0fa53a76fe5fa$var$StyledTabView = (0, $5UMQ1.default)((0, $bY9wC.TabView))`
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		.p-tabview-nav {
			background-color: ${(0, $kKnoQ.colors).primaryBackground} !important;
		}

		.p-tabview-nav-link {
			background-color: ${(0, $kKnoQ.colors).primaryBackground} !important;
			justify-content: center !important;
		}

		.p-tabview-panels {
			padding: 0 !important;
		}
	}
`;
const $3ff0fa53a76fe5fa$var$Card = (0, $5UMQ1.default).div`
	padding: 24px 40px;
	width: 1200px;
	max-width: 100%;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 0;
		flex: 1;
		border-radius: 0;
	}
`;


parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $kXaMn = parcelRequire("kXaMn");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");

var $50fe7726fa894ed8$var$MailOpenedIcon = function MailOpenedIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M20 22.52H4c-1.65 0-3-1.35-3-3V9.5c0-1.06.57-2.05 1.48-2.59l7.51-4.38c1.19-.71 2.82-.71 4.03 0l7.49 4.37c.92.54 1.49 1.53 1.49 2.59v10.03c0 1.65-1.35 3-3 3ZM12 3.99c-.35 0-.71.09-1 .27L3.49 8.63c-.3.18-.49.51-.49.86v10.03c0 .54.46 1 1 1h16c.54 0 1-.46 1-1V9.5a1 1 0 0 0-.5-.86L13 4.27c-.3-.18-.65-.27-1.01-.27l.01-.01Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.134 9.919a1 1 0 0 1 1.378-.315l4.956 3.113a1 1 0 0 0 1.064 0l4.956-3.113a1 1 0 0 1 1.063 1.694l-4.955 3.112a3 3 0 0 1-3.192 0L5.45 11.298a1 1 0 0 1-.315-1.38Z",
                fill: "currentColor"
            })
        ]
    });
};
$50fe7726fa894ed8$var$MailOpenedIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $50fe7726fa894ed8$var$SettingsIcon = function SettingsIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M16.007 10.855a4.13 4.13 0 0 0-2.893-2.872C9.96 7.14 7.129 9.99 7.994 13.145a4.13 4.13 0 0 0 2.893 2.872c3.153.843 5.984-2.008 5.12-5.162ZM14.02 12.51a2.063 2.063 0 0 1-1.498 1.51c-1.562.374-2.904-.969-2.54-2.53a2.062 2.062 0 0 1 1.499-1.51c1.56-.374 2.903.969 2.54 2.53Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "m19.745 13.583-.37-.213a7.587 7.587 0 0 0 0-2.742l.37-.213a2.503 2.503 0 0 0-2.5-4.333l-.37.214A7.482 7.482 0 0 0 14.5 4.927V4.5a2.5 2.5 0 1 0-5 0v.428a7.48 7.48 0 0 0-2.373 1.371l-.373-.216a2.501 2.501 0 1 0-2.5 4.334l.37.213a7.584 7.584 0 0 0 0 2.742l-.37.213a2.501 2.501 0 1 0 2.5 4.333l.371-.214A7.48 7.48 0 0 0 9.5 19.073v.427a2.5 2.5 0 0 0 5 0v-.427a7.48 7.48 0 0 0 2.373-1.372l.373.215a2.501 2.501 0 1 0 2.5-4.334v.001Zm-2.123-3.146a5.873 5.873 0 0 1 0 3.125.834.834 0 0 0 .387.944l.903.521a.834.834 0 0 1-.834 1.445l-.904-.524a.833.833 0 0 0-1.013.138 5.82 5.82 0 0 1-2.703 1.562.834.834 0 0 0-.625.808V19.5a.833.833 0 0 1-1.667 0v-1.043a.833.833 0 0 0-.626-.808 5.82 5.82 0 0 1-2.702-1.566.834.834 0 0 0-1.012-.137l-.903.522a.833.833 0 1 1-.834-1.443l.904-.522a.833.833 0 0 0 .386-.944 5.873 5.873 0 0 1 0-3.125.833.833 0 0 0-.387-.94l-.904-.522a.834.834 0 0 1 .834-1.444l.905.523a.833.833 0 0 0 1.011-.134 5.82 5.82 0 0 1 2.703-1.563.833.833 0 0 0 .626-.81V4.5a.833.833 0 1 1 1.667 0v1.043a.833.833 0 0 0 .625.808 5.82 5.82 0 0 1 2.703 1.566.834.834 0 0 0 1.012.137l.904-.522a.833.833 0 1 1 .833 1.443l-.903.522a.833.833 0 0 0-.386.94Z",
                fill: "currentColor"
            })
        ]
    });
};
$50fe7726fa894ed8$var$SettingsIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $50fe7726fa894ed8$export$4731034551e6664c = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isDesktop: isDesktop, isMobile: isMobile } = (0, $5kXMA.useDimensions)();
    const notifications = (0, $1IWnK.useObservable)((0, $ghfIB.notificationManager).notifications);
    const unreadNotificationCount = (0, $1IWnK.useObservable)((0, $ghfIB.notificationManager).unreadCount);
    const [hasReachedEnd, setHasReachedEnd] = (0, $81g6h.useState)(false);
    const navigate = (0, $htiSH.useNavigate)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const disabled = (0, $81g6h.useMemo)(()=>unreadNotificationCount === 0, [
        unreadNotificationCount
    ]);
    const openMarkAllAsReadDialog = (0, $81g6h.useCallback)(()=>dialogContext?.openModal((0, $243Cr.ModalId).MarkAllNotificationsAsRead, {
            unreadNotificationCount: unreadNotificationCount
        }), [
        dialogContext,
        unreadNotificationCount
    ]);
    const [loadNotification, isLoading] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(async ()=>{
        const { reachedEnd: reachedEnd } = await (0, $ghfIB.notificationManager).loadNotifications();
        setHasReachedEnd(reachedEnd);
    }, []), {});
    const [loadMoreNotifications, isPageLoading] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(async ()=>{
        const { reachedEnd: reachedEnd } = await (0, $ghfIB.notificationManager).loadMoreNotifications();
        setHasReachedEnd(reachedEnd);
    }, []), {});
    (0, $81g6h.useEffect)(()=>{
        loadNotification();
    }, [
        loadNotification
    ]);
    const notificationGroups = (0, $81g6h.useMemo)(()=>{
        const groups = [
            {
                id: "today",
                notifications: [],
                title: format("notificationCenter.sections.today"),
                predicate: (date)=>(0, $kXaMn.datesAreOnSameDay)(date, (0, $kXaMn.now)())
            },
            {
                id: "last7days",
                notifications: [],
                title: format("notificationCenter.sections.last7days"),
                predicate: (date)=>(0, $kXaMn.now)().diff(date, "days", true) < (0, $kXaMn.WEEK_LENGTH)
            },
            {
                id: "last30days",
                notifications: [],
                title: format("notificationCenter.sections.last30days"),
                predicate: (date)=>(0, $kXaMn.now)().diff(date, "days", true) < 30
            },
            {
                id: "older",
                notifications: [],
                title: format("notificationCenter.sections.older"),
                predicate: ()=>true
            }
        ];
        notifications.forEach((notification)=>{
            for (const group of groups)if (group.predicate(notification.creationDate)) {
                group.notifications.push(notification);
                return;
            }
        });
        return groups.filter((group)=>group.notifications.length > 0);
    }, [
        notifications,
        format
    ]);
    (0, $81g6h.useEffect)(()=>{
        if (isLoading || isPageLoading || hasReachedEnd || (0, $lTdpc.isNil)(bottomListDivRef.current)) return;
        const intersectionObserver = new IntersectionObserver(async ([elem])=>{
            if (elem.isIntersecting) await loadMoreNotifications();
        });
        intersectionObserver.observe(bottomListDivRef.current);
        return ()=>intersectionObserver.disconnect();
    }, [
        isLoading,
        isPageLoading,
        hasReachedEnd,
        loadMoreNotifications
    ]);
    const bottomListDivRef = (0, $81g6h.useRef)(null);
    const navigateToSettings = (0, $81g6h.useCallback)(()=>navigate((0, $lDZlX.RoutesPath).Settings, {
            query: {
                active: (0, $3ff0fa53a76fe5fa$export$c89b88baaf1b40a2).NotificationPreferences
            }
        }), [
        navigate
    ]);
    const renderContent = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $iKObn.jsx)($50fe7726fa894ed8$var$StyledLoadingContainer, {});
        else if (notificationGroups.length === 0) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $e60bcd234bf92f2b$export$c536f637504a7f68), {});
        return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
            children: [
                notificationGroups.map((group)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $7CwXm.NotificationSection), {
                        title: group.title,
                        children: group.notifications.map((notification, index)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $70tpO.NotificationRow), {
                                notification: notification,
                                separator: index !== group.notifications.length - 1
                            }, notification.id))
                    }, group.id)),
                isPageLoading && /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {}),
                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                    ref: bottomListDivRef
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
        children: /*#__PURE__*/ (0, $iKObn.jsxs)((0, $lKlJT.Page), {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $15ade5a6153d87cc$export$8534dc24c72e73ef), {
                    showForPendingPt: false
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $8CNE2.PageHeader), {
                    title: format("notificationCenter.title"),
                    tertiaryButton: !isMobile ? {
                        label: format("settings.notificationPreferences"),
                        onClick: navigateToSettings,
                        icon: "pi pi-cog"
                    } : undefined,
                    menuItems: isMobile ? [
                        {
                            icon: /*#__PURE__*/ (0, $iKObn.jsx)($50fe7726fa894ed8$var$MailOpenedIcon, {
                                color: (0, $kKnoQ.colors).primary
                            }),
                            text: format("notificationCenter.markAllAsRead.button"),
                            disabled: disabled,
                            onClick: openMarkAllAsReadDialog,
                            itemClassName: "p-size-s-bold"
                        },
                        {
                            icon: /*#__PURE__*/ (0, $iKObn.jsx)($50fe7726fa894ed8$var$SettingsIcon, {
                                color: (0, $kKnoQ.colors).primary
                            }),
                            text: format("settings.notificationPreferences"),
                            onClick: navigateToSettings,
                            itemClassName: "p-size-s-bold"
                        }
                    ] : undefined
                }),
                /*#__PURE__*/ (0, $iKObn.jsxs)($50fe7726fa894ed8$var$Card, {
                    className: "p-card",
                    children: [
                        isDesktop && /*#__PURE__*/ (0, $iKObn.jsx)($50fe7726fa894ed8$var$ButtonContainer, {
                            children: /*#__PURE__*/ (0, $iKObn.jsxs)($50fe7726fa894ed8$var$Button, {
                                disabled: disabled,
                                className: "p-size-s-bold",
                                onClick: ()=>!disabled && openMarkAllAsReadDialog(),
                                children: [
                                    format("notificationCenter.markAllAsRead.button"),
                                    " ",
                                    /*#__PURE__*/ (0, $iKObn.jsx)($50fe7726fa894ed8$var$MailOpenedIcon, {
                                        width: 16,
                                        height: 16
                                    })
                                ]
                            })
                        }),
                        renderContent()
                    ]
                })
            ]
        })
    });
};
const $50fe7726fa894ed8$var$StyledLoadingContainer = (0, $5UMQ1.default)((0, $1IlhR.LoadingContainer))`
	margin-top: 128px;
	margin-bottom: 128px;
`;
const $50fe7726fa894ed8$var$Card = (0, $5UMQ1.default).div`
	padding: 32px;
	width: 1200px;
	max-width: 100%;
`;
const $50fe7726fa894ed8$var$ButtonContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween")}
`;
const $50fe7726fa894ed8$var$Button = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "center", "center")};
	gap: 8px;

	${({ disabled: disabled })=>disabled ? (0, $kkH7g.css)`
					color: ${(0, $kKnoQ.colors).grey50};
				` : (0, $kkH7g.css)`
					cursor: pointer;

					&:hover {
						color: ${(0, $kKnoQ.colors).primary};
					}

					&:active {
						color: ${(0, $kKnoQ.colors).primaryDark};
					}
				`}
`;



var $iKObn = parcelRequire("iKObn");

var $04Qjn = parcelRequire("04Qjn");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $8zvzh = parcelRequire("8zvzh");


var $aEP4N = parcelRequire("aEP4N");

var $6Yxa2 = parcelRequire("6Yxa2");

var $bC9c0 = parcelRequire("bC9c0");

var $a6fIt = parcelRequire("a6fIt");

var $5UMQ1 = parcelRequire("5UMQ1");

var $28f8Y = parcelRequire("28f8Y");

var $1IlhR = parcelRequire("1IlhR");

var $5kXMA = parcelRequire("5kXMA");

var $lDZlX = parcelRequire("lDZlX");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $Ukx0s = parcelRequire("Ukx0s");

var $4UKJF = parcelRequire("4UKJF");

var $5UMQ1 = parcelRequire("5UMQ1");

var $jrnUx = parcelRequire("jrnUx");

var $243Cr = parcelRequire("243Cr");

var $28f8Y = parcelRequire("28f8Y");

var $5kXMA = parcelRequire("5kXMA");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $2aAG8 = parcelRequire("2aAG8");

var $5UMQ1 = parcelRequire("5UMQ1");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $2aAG8 = parcelRequire("2aAG8");

var $Ukx0s = parcelRequire("Ukx0s");

var $5UMQ1 = parcelRequire("5UMQ1");

var $243Cr = parcelRequire("243Cr");

var $amllh = parcelRequire("amllh");

var $9XVwj = parcelRequire("9XVwj");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $buI4E = parcelRequire("buI4E");

var $81g6h = parcelRequire("81g6h");
var $af905401701cdca1$var$DeleteIcon = function DeleteIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M10.82 2c-.52 0-1.01.2-1.38.57L9.01 3h-5c-.13 0-.26.02-.39.07a1.004 1.004 0 0 0-.55.55c-.05.12-.07.25-.07.39s.02.26.07.39c.05.12.13.23.22.33.1.09.21.17.33.22.13.05.26.07.39.07h16c.13 0 .26-.02.39-.07a1.004 1.004 0 0 0 .55-.55c.05-.12.07-.25.07-.39s-.02-.26-.07-.39a1.19 1.19 0 0 0-.22-.33c-.1-.09-.21-.17-.33-.22-.13-.05-.26-.07-.39-.07h-5l-.43-.43A1.92 1.92 0 0 0 13.2 2h-2.38ZM16.13 22H7.88c-1.5 0-2.78-1.05-2.97-2.447L3.409 8.136a1 1 0 0 1 .991-1.13h15.22a1 1 0 0 1 .991 1.13L19.11 19.534C18.9 20.95 17.62 22 16.13 22ZM5.5 8.88l1.39 10.448c.06.44.5.797.99.797h8.25c.5 0 .93-.356 1-.825l1.39-10.42H5.5Z",
            fill: "currentColor"
        })
    });
};
$af905401701cdca1$var$DeleteIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $af905401701cdca1$var$LogoutIcon = function LogoutIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M5 5h6c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6c.55 0 1-.45 1-1s-.45-1-1-1H5V5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "m20.65 11.65-2.79-2.79a.501.501 0 0 0-.86.35V11h-7c-.55 0-1 .45-1 1s.45 1 1 1h7v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.19.2-.51.01-.7Z",
                fill: "currentColor"
            })
        ]
    });
};
$af905401701cdca1$var$LogoutIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $af905401701cdca1$var$ResendIcon = function ResendIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M11.842 2.002c-.537.008-1.084.058-1.637.154-4.029.707-7.285 3.925-8.03 7.947C1.004 16.448 5.866 22 12 22c5.135 0 9.378-3.89 9.938-8.879a1.009 1.009 0 0 0-1-1.121c-.5 0-.93.368-.985.865C19.52 16.87 16.118 20 12 20c-4.941 0-8.85-4.502-7.84-9.62.608-3.08 3.073-5.57 6.149-6.204a7.98 7.98 0 0 1 7.336 2.181l-1.43 1.43A.71.71 0 0 0 16.717 9H21a1 1 0 0 0 1-1V3.717a.71.71 0 0 0-1.213-.504l-1.73 1.73a9.942 9.942 0 0 0-7.215-2.941Z",
            fill: "currentColor"
        })
    });
};
$af905401701cdca1$var$ResendIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $af905401701cdca1$export$f0aeba7da0f4b8b1 = ({ user: user, patient: patient, healthcareTeamMember: healthcareTeamMember })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const reopenInviteUnregisteredPtDialog = (0, $81g6h.useCallback)(async (invitedPt)=>{
        dialogContext?.openModal((0, $243Cr.ModalId).HealthcareTeamUnregisteredInvite, {
            invitedPt: {
                email: invitedPt.email,
                invitationId: invitedPt.ptInvitationId
            },
            invitingPt: user,
            patient: patient
        });
        (0, $Ukx0s.sendAnalyticsEventResendInvitation)(patient, invitedPt);
    }, [
        dialogContext,
        patient,
        user
    ]);
    const deleteUnregisteredPt = (0, $81g6h.useCallback)(async (invitedPt)=>{
        await (0, $ghfIB.healthcareTeamManager).deleteMember(patient.id, invitedPt.id);
        showToast(format("patientDetails.healthcareTeam.actionButton.delete.toastSuccess.title"), format("patientDetails.healthcareTeam.actionButton.delete.toastSuccess.message", {
            invitedPtName: invitedPt.email,
            patientName: (0, $buI4E.formatName)(patient)
        }), "success");
        (0, $Ukx0s.sendAnalyticsEventDeleteColleague)(patient, invitedPt);
    }, [
        format,
        patient,
        showToast
    ]);
    const resendInvitation = (0, $81g6h.useCallback)(async (invitedPt)=>{
        try {
            await (0, $ghfIB.healthcareTeamManager).resendInvitation(patient.id, healthcareTeamMember.id);
            showToast(format("patientDetails.healthcareTeam.actionButton.resend.toastSuccess.title"), format("patientDetails.healthcareTeam.actionButton.resend.toastSuccess.message", {
                email: invitedPt.email
            }), "success");
            (0, $Ukx0s.sendAnalyticsEventResendInvitation)(patient, invitedPt);
        } catch (e) {
            console.error("Failed to resend invite", e);
        }
    }, [
        format,
        healthcareTeamMember.id,
        patient,
        showToast
    ]);
    const leaveHCT = (0, $81g6h.useCallback)(async ()=>{
        dialogContext?.openModal((0, $243Cr.ModalId).HealthcareTeamLeave, {
            patient: patient
        });
        (0, $Ukx0s.sendAnalyticsEventClickCtaLeaveHct)();
    }, [
        dialogContext,
        patient
    ]);
    const menuItems = (0, $81g6h.useMemo)(()=>{
        const items = [];
        if ((0, $2aAG8.isUnregisteredHealthcareTeamMember)(healthcareTeamMember)) {
            // Here the member can be either unregistered OR registered but unvalidated.
            // We only allow to resend the invitation if the member is unregistered
            if ((0, $lTdpc.isNil)(healthcareTeamMember.ptId)) items.push({
                text: format("patientDetails.healthcareTeam.actionButton.resend"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($af905401701cdca1$var$ResendIcon, {}),
                onClick: ()=>reopenInviteUnregisteredPtDialog(healthcareTeamMember)
            });
            items.push({
                text: format("patientDetails.healthcareTeam.actionButton.delete"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($af905401701cdca1$var$DeleteIcon, {}),
                destructive: true,
                onClick: ()=>deleteUnregisteredPt(healthcareTeamMember)
            });
        } else if (healthcareTeamMember.status !== (0, $2aAG8.HealthcareTeamMemberStatus).Confirmed) items.push({
            text: format("patientDetails.healthcareTeam.actionButton.resend"),
            icon: /*#__PURE__*/ (0, $iKObn.jsx)($af905401701cdca1$var$ResendIcon, {}),
            onClick: ()=>resendInvitation(healthcareTeamMember)
        });
        else if (user.id === healthcareTeamMember.ptId) items.push({
            text: format("patientDetails.healthcareTeam.actionButton.leave"),
            icon: /*#__PURE__*/ (0, $iKObn.jsx)($af905401701cdca1$var$LogoutIcon, {}),
            onClick: leaveHCT,
            destructive: true
        });
        return items;
    }, [
        deleteUnregisteredPt,
        format,
        healthcareTeamMember,
        leaveHCT,
        reopenInviteUnregisteredPtDialog,
        resendInvitation,
        user.id
    ]);
    if (menuItems.length === 0) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {});
    return /*#__PURE__*/ (0, $iKObn.jsx)($af905401701cdca1$var$ActionButton, {
        menuId: healthcareTeamMember.id,
        menuItems: menuItems
    });
};
const $af905401701cdca1$var$ActionButton = (0, $5UMQ1.default)((0, $amllh.MenuButton))`
	.menu-button {
		background-color: ${(0, $kKnoQ.colors).transparent};
		&.hover {
			background-color: ${(0, $kKnoQ.colors).grey10};
		}
	}
`;



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $02Kb9 = parcelRequire("02Kb9");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");
parcelRequire("81g6h");
const $d5343eea7162511b$var$statusWordings = {
    PENDING_PT_REGISTRATION: {
        tag: "patientDetails.healthcareTeam.listItem.status.unregistered",
        tooltip: "patientDetails.healthcareTeam.listItem.status.unregistered.tooltip"
    },
    PENDING_PATIENT_VALIDATION: {
        tag: "patientDetails.healthcareTeam.listItem.status.pendingPatientValidation",
        tooltip: "patientDetails.healthcareTeam.listItem.status.pendingPatientValidation.tooltip"
    },
    PENDING_PT_VALIDATION: {
        tag: "patientDetails.healthcareTeam.listItem.status.pendingPtValidation",
        tooltip: "patientDetails.healthcareTeam.listItem.status.pendingPtValidation.tooltip"
    },
    CONFIRMED: undefined
};
const $d5343eea7162511b$export$3ee4cf0da2caf032 = ({ member: member })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const wordings = $d5343eea7162511b$var$statusWordings[member.status];
    if ((0, $lTdpc.isNil)(wordings)) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {});
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $02Kb9.Tooltip), {
        content: format(wordings.tooltip),
        placement: "auto",
        children: /*#__PURE__*/ (0, $iKObn.jsx)($d5343eea7162511b$var$TagContainer, {
            children: format(wordings.tag)
        })
    });
};
const $d5343eea7162511b$var$TagContainer = (0, $5UMQ1.default).div`
	white-space: nowrap;
	padding: 4px 16px;
	border-radius: 3.25rem;
	border: 1px solid ${(0, $kKnoQ.colors).warnDark};
	color: ${(0, $kKnoQ.colors).warnDark};
	background-color: ${(0, $kKnoQ.colors).warn};
`;


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $buI4E = parcelRequire("buI4E");
parcelRequire("81g6h");
const $8ba75841e7d54b1b$export$3dcc731940fa5e44 = ({ member: member, user: user, patient: patient })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const name = (0, $buI4E.formatName)(member, member.email);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($8ba75841e7d54b1b$var$Row, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($8ba75841e7d54b1b$var$LeftContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($8ba75841e7d54b1b$var$FullNameContainer, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($8ba75841e7d54b1b$var$FullNameView, {
                                children: name
                            }),
                            (0, $2aAG8.isRegisteredHealthcareTeamMember)(member) && member.ptId === user.id && /*#__PURE__*/ (0, $iKObn.jsx)($8ba75841e7d54b1b$var$YouView, {
                                children: format("patientDetails.healthcareTeam.you")
                            })
                        ]
                    }),
                    name && /*#__PURE__*/ (0, $iKObn.jsx)($8ba75841e7d54b1b$var$EmailView, {
                        children: member.email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($8ba75841e7d54b1b$var$RightContainer, {
                hasSingleChild: user.id === member.ptId,
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $d5343eea7162511b$export$3ee4cf0da2caf032), {
                        member: member
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $af905401701cdca1$export$f0aeba7da0f4b8b1), {
                        user: user,
                        patient: patient,
                        healthcareTeamMember: member
                    })
                ]
            })
        ]
    }, member.id);
};
const $8ba75841e7d54b1b$var$Row = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")};
	padding: 24px;
	border-bottom: 1px solid ${(0, $kKnoQ.colors).grey25};

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		${(0, $5WGN2.stack)(8)};
	}
`;
const $8ba75841e7d54b1b$var$LeftContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "flexstart")};
`;
const $8ba75841e7d54b1b$var$RightContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(32, "flexend", "center")};
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		${(0, $5WGN2.row)(8, "spacebetween", "center")};
		width: 100%;
		justify-content: ${({ hasSingleChild: hasSingleChild })=>hasSingleChild ? "flex-end" : "flex-between"};
	}
`;
const $8ba75841e7d54b1b$var$FullNameContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(4, "flexstart", "center")};
	flex-wrap: wrap;
`;
const $8ba75841e7d54b1b$var$FullNameView = (0, $5UMQ1.default).span`
	color: ${(0, $kKnoQ.colors).black};
	font-size: 16px;
	font-weight: 700;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		max-width: 80vw;
	}
`;
const $8ba75841e7d54b1b$var$YouView = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).grey};
	font-size: 16px;
	font-weight: 100;
`;
const $8ba75841e7d54b1b$var$EmailView = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).grey};
	font-size: 12px;
	font-weight: 600;
`;



var $grmoS = parcelRequire("grmoS");

var $ghfIB = parcelRequire("ghfIB");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
function $0c95d95a6cd05f6c$export$6cb55b78c64c991a(patientId) {
    const healthcareTeam = (0, $1IWnK.useObservable)((0, $ghfIB.healthcareTeamManager).healthcareTeam);
    const fetchHealthcareTeam = (0, $81g6h.useCallback)(async ()=>await (0, $ghfIB.healthcareTeamManager).fetchHealthcareTeam(patientId), [
        patientId
    ]);
    const [fetchHealthcareTeamData, loading, error] = (0, $grmoS.useAsyncOperation)(fetchHealthcareTeam, {});
    (0, $81g6h.useEffect)(()=>{
        fetchHealthcareTeamData();
    }, [
        fetchHealthcareTeamData
    ]);
    return {
        loading: loading,
        error: error,
        healthcareTeam: healthcareTeam,
        refreshHealthcareTeam: fetchHealthcareTeamData
    };
}


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $lTdpc = parcelRequire("lTdpc");

var $9AWgp = parcelRequire("9AWgp");

var $81g6h = parcelRequire("81g6h");
const $362571945e6c2e3b$export$aa560270ebae7b35 = ({ patient: patient })=>{
    const { error: isHealthcareTeamError, healthcareTeam: healthcareTeam, refreshHealthcareTeam: refreshHealthcareTeam } = (0, $0c95d95a6cd05f6c$export$6cb55b78c64c991a)(patient.id);
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isMobile: isMobile } = (0, $5kXMA.useDimensions)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const user = (0, $4UKJF.useUser)();
    const openInviteDialog = (0, $81g6h.useCallback)((currentPatient, currentUser)=>{
        dialogContext?.openModal((0, $243Cr.ModalId).HealthcareTeamInvite, {
            patient: currentPatient,
            invitingPt: currentUser
        });
        (0, $Ukx0s.sendAnalyticsEventStartInvite)(currentPatient);
    }, [
        dialogContext
    ]);
    if (isHealthcareTeamError) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
        onRefresh: refreshHealthcareTeam
    });
    if ((0, $lTdpc.isNil)(user)) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.Error404), {});
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($362571945e6c2e3b$var$TabHeaderContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                        className: isMobile ? "p-size-l-bold" : "p-header-3",
                        children: format("patientDetails.tabs.healthcareTeam")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $9AWgp.Button), {
                        label: format("patientDetails.healthcareTeam.inviteColleagueButton"),
                        onClick: ()=>openInviteDialog(patient, user)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($362571945e6c2e3b$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($362571945e6c2e3b$var$TooltipContainer, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $jrnUx.ContentWithTooltip), {
                            tooltip: format("patientDetails.healthcareTeam.teamMemberTooltip"),
                            text: format("patientDetails.healthcareTeam.teamMembersTitle", {
                                count: healthcareTeam?.healthcareTeamMembers.length ?? "-"
                            })
                        })
                    }),
                    healthcareTeam?.healthcareTeamMembers.map((member)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $8ba75841e7d54b1b$export$3dcc731940fa5e44), {
                            member: member,
                            patient: patient,
                            user: user
                        }, member.id))
                ]
            })
        ]
    });
};
const $362571945e6c2e3b$var$TabHeaderContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")};
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		${(0, $5WGN2.stack)(24)};
		margin-top: 8px;
		padding-bottom: 24px;
	}
`;
const $362571945e6c2e3b$var$Container = (0, $5UMQ1.default).div`
	margin-top: 16px;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		margin-left: -32px;
		margin-right: -32px;
	}
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		margin-left: -16px;
		margin-right: -16px;
	}
`;
const $362571945e6c2e3b$var$TooltipContainer = (0, $5UMQ1.default).div`
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		margin-left: 24px;
		margin-bottom: 16px;
	}
`;



var $1CiDH = parcelRequire("1CiDH");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $bC9c0 = parcelRequire("bC9c0");

var $5SzTW = parcelRequire("5SzTW");

var $5UMQ1 = parcelRequire("5UMQ1");

var $imaOW = parcelRequire("imaOW");

var $9gtEr = parcelRequire("9gtEr");

var $28f8Y = parcelRequire("28f8Y");

var $i6nFl = parcelRequire("i6nFl");

var $fuvmS = parcelRequire("fuvmS");

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $cfkGk = parcelRequire("cfkGk");
"use client";
function $eced1bdb907c7bc2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $eced1bdb907c7bc2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $eced1bdb907c7bc2$var$_typeof(o);
}
function $eced1bdb907c7bc2$var$_toPrimitive(input, hint) {
    if ($eced1bdb907c7bc2$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($eced1bdb907c7bc2$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $eced1bdb907c7bc2$var$_toPropertyKey(arg) {
    var key = $eced1bdb907c7bc2$var$_toPrimitive(arg, "string");
    return $eced1bdb907c7bc2$var$_typeof(key) === "symbol" ? key : String(key);
}
function $eced1bdb907c7bc2$var$_defineProperty(obj, key, value) {
    key = $eced1bdb907c7bc2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $eced1bdb907c7bc2$var$classes = {
    root: function root(_ref) {
        var props = _ref.props;
        return (0, $cfkGk.classNames)("p-skeleton p-component", {
            "p-skeleton-circle": props.shape === "circle",
            "p-skeleton-none": props.animation === "none"
        });
    }
};
var $eced1bdb907c7bc2$var$styles = '\n@layer primereact {\n    .p-skeleton {\n        position: relative;\n        overflow: hidden;\n    }\n    \n    .p-skeleton::after {\n        content: "";\n        animation: p-skeleton-animation 1.2s infinite;\n        height: 100%;\n        left: 0;\n        position: absolute;\n        right: 0;\n        top: 0;\n        transform: translateX(-100%);\n        z-index: 1;\n    }\n    \n    .p-skeleton-circle {\n        border-radius: 50%;\n    }\n    \n    .p-skeleton-none::after {\n        animation: none;\n    }\n}\n\n@keyframes p-skeleton-animation {\n    from {\n        transform: translateX(-100%);\n    }\n    to {\n        transform: translateX(100%);\n    }\n}\n';
var $eced1bdb907c7bc2$var$inlineStyles = {
    root: {
        position: "relative"
    }
};
var $eced1bdb907c7bc2$var$SkeletonBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Skeleton",
        shape: "rectangle",
        size: null,
        width: "100%",
        height: "1rem",
        borderRadius: null,
        animation: "wave",
        style: null,
        className: null
    },
    css: {
        classes: $eced1bdb907c7bc2$var$classes,
        inlineStyles: $eced1bdb907c7bc2$var$inlineStyles,
        styles: $eced1bdb907c7bc2$var$styles
    }
});
function $eced1bdb907c7bc2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eced1bdb907c7bc2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eced1bdb907c7bc2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $eced1bdb907c7bc2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eced1bdb907c7bc2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $eced1bdb907c7bc2$export$8f31e4c4a37b8e9c = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $eced1bdb907c7bc2$var$SkeletonBase.getProps(inProps, context);
    var _SkeletonBase$setMeta = $eced1bdb907c7bc2$var$SkeletonBase.setMetaData({
        props: props
    }), ptm = _SkeletonBase$setMeta.ptm, cx = _SkeletonBase$setMeta.cx, sx = _SkeletonBase$setMeta.sx, isUnstyled = _SkeletonBase$setMeta.isUnstyled;
    (0, $4gQLd.useHandleStyle)($eced1bdb907c7bc2$var$SkeletonBase.css.styles, isUnstyled, {
        name: "skeleton"
    });
    var elementRef = $81g6h.useRef(null);
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var style = props.size ? {
        width: props.size,
        height: props.size,
        borderRadius: props.borderRadius
    } : {
        width: props.width,
        height: props.height,
        borderRadius: props.borderRadius
    };
    var rootProps = mergeProps({
        ref: elementRef,
        className: (0, $cfkGk.classNames)(props.className, cx("root")),
        style: $eced1bdb907c7bc2$var$_objectSpread($eced1bdb907c7bc2$var$_objectSpread({}, style), sx("root")),
        "aria-hidden": true
    }, $eced1bdb907c7bc2$var$SkeletonBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $81g6h.createElement("div", rootProps);
}));
$eced1bdb907c7bc2$export$8f31e4c4a37b8e9c.displayName = "Skeleton";



var $81g6h = parcelRequire("81g6h");
const $81ab56a969b1a9d8$export$aa6e150b47287d7c = ({ active: active, loading: loading = false, children: children })=>{
    const skeleton = (0, $81g6h.useMemo)(()=>active ? /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
            className: "p-panel p-component p-panel-toggleable",
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                    className: "p-panel-header",
                    style: {
                        paddingBottom: "18px"
                    },
                    children: /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between"
                        },
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                                style: {
                                    alignSelf: "flex-start"
                                },
                                children: /*#__PURE__*/ (0, $iKObn.jsx)($81ab56a969b1a9d8$var$CustomSkeleton, {
                                    height: "2rem",
                                    width: "300px",
                                    animation: loading ? "wave" : "none"
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                                style: {
                                    alignSelf: "flex-end"
                                },
                                children: /*#__PURE__*/ (0, $iKObn.jsx)($81ab56a969b1a9d8$var$CustomSkeleton, {
                                    height: "2rem",
                                    width: "100px",
                                    animation: loading ? "wave" : "none"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)($81ab56a969b1a9d8$var$ContentBox, {
                    children: /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
                        className: "p-panel-content",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                style: {
                                    paddingBottom: 20
                                },
                                children: /*#__PURE__*/ (0, $iKObn.jsx)($81ab56a969b1a9d8$var$CustomSkeleton, {
                                    height: "2rem",
                                    width: "300px",
                                    animation: loading ? "wave" : "none"
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
                                className: "css-0",
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                        style: {
                                            paddingBottom: 20
                                        },
                                        children: /*#__PURE__*/ (0, $iKObn.jsx)($81ab56a969b1a9d8$var$CustomSkeleton, {
                                            height: "2rem",
                                            width: "300px",
                                            animation: loading ? "wave" : "none"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $iKObn.jsx)($81ab56a969b1a9d8$var$CustomSkeleton, {
                                            height: "3rem",
                                            width: "300px",
                                            animation: loading ? "wave" : "none"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
            children: children
        }), [
        active,
        loading,
        children
    ]);
    return active ? skeleton : /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
        children: children
    });
};
const $81ab56a969b1a9d8$var$ContentBox = (0, $5UMQ1.default).div`
	height: 100%;
	padding: 40px;
	border-radius: 8px;
	border: 1px solid #d5d5db;
	display: grid;
	grid-template-columns: 1fr 1fr;
	place-items: flex-start;
	grid-gap: 40px;
`;
const $81ab56a969b1a9d8$var$CustomSkeleton = (0, $5UMQ1.default)((0, $eced1bdb907c7bc2$export$8f31e4c4a37b8e9c))`
	background: ${(0, $kKnoQ.colors).grey10};
`;



var $5kXMA = parcelRequire("5kXMA");


var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $eAmnG = parcelRequire("eAmnG");

var $bC9c0 = parcelRequire("bC9c0");

var $4UKJF = parcelRequire("4UKJF");

var $a6fIt = parcelRequire("a6fIt");

var $dhb7H = parcelRequire("dhb7H");

var $c22GE = parcelRequire("c22GE");

var $243Cr = parcelRequire("243Cr");

var $lDZlX = parcelRequire("lDZlX");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $9AWgp = parcelRequire("9AWgp");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $jhJol = parcelRequire("jhJol");

var $k7ffa = parcelRequire("k7ffa");

var $lbdsH = parcelRequire("lbdsH");

var $6b4aU = parcelRequire("6b4aU");

var $cfkGk = parcelRequire("cfkGk");

var $1gPAC = parcelRequire("1gPAC");

var $9rbaG = parcelRequire("9rbaG");

var $7hMfd = parcelRequire("7hMfd");
"use client";
function $cac12bb981be06b4$var$_extends() {
    $cac12bb981be06b4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cac12bb981be06b4$var$_extends.apply(this, arguments);
}
function $cac12bb981be06b4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cac12bb981be06b4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cac12bb981be06b4$var$_typeof(o);
}
function $cac12bb981be06b4$var$_toPrimitive(input, hint) {
    if ($cac12bb981be06b4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($cac12bb981be06b4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $cac12bb981be06b4$var$_toPropertyKey(arg) {
    var key = $cac12bb981be06b4$var$_toPrimitive(arg, "string");
    return $cac12bb981be06b4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $cac12bb981be06b4$var$_defineProperty(obj, key, value) {
    key = $cac12bb981be06b4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cac12bb981be06b4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $cac12bb981be06b4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $cac12bb981be06b4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cac12bb981be06b4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cac12bb981be06b4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cac12bb981be06b4$var$_arrayLikeToArray(o, minLen);
}
function $cac12bb981be06b4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cac12bb981be06b4$var$_slicedToArray(arr, i) {
    return $cac12bb981be06b4$var$_arrayWithHoles(arr) || $cac12bb981be06b4$var$_iterableToArrayLimit(arr, i) || $cac12bb981be06b4$var$_unsupportedIterableToArray(arr, i) || $cac12bb981be06b4$var$_nonIterableRest();
}
var $cac12bb981be06b4$var$classes$1 = {
    root: function root(_ref) {
        var props = _ref.props, context = _ref.context;
        return (0, $cfkGk.classNames)("p-tieredmenu p-component", {
            "p-tieredmenu-overlay": props.popup,
            "p-input-filled": context && context.inputStyle === "filled" || (0, $8Zwsm.default).inputStyle === "filled",
            "p-ripple-disabled": context && context.ripple === false || (0, $8Zwsm.default).ripple === false
        });
    },
    separator: "p-menuitem-separator",
    icon: function icon(_ref2) {
        var _icon = _ref2._icon;
        return (0, $cfkGk.classNames)("p-menuitem-icon", _icon);
    },
    content: "p-menuitem-content",
    label: "p-menuitem-text",
    submenuIcon: "p-submenu-icon",
    action: "p-menuitem-link",
    menuitem: function menuitem(_ref3) {
        var itemClassName = _ref3.itemClassName, active = _ref3.active, focused = _ref3.focused, disabled = _ref3.disabled;
        return (0, $cfkGk.classNames)("p-menuitem", {
            "p-menuitem-active p-highlight": active,
            "p-focus": focused,
            "p-disabled": disabled
        }, itemClassName);
    },
    menu: "p-tieredmenu-root-list",
    submenu: "p-submenu-list",
    transition: "p-connected-overlay"
};
var $cac12bb981be06b4$var$inlineStyles = {
    submenu: function submenu(_ref4) {
        var props = _ref4.subProps;
        return {
            display: !props.root && props.parentActive ? "block" : "none"
        };
    }
};
var $cac12bb981be06b4$var$styles$1 = "\n@layer primereact {\n    .p-tieredmenu-overlay {\n        position: absolute;\n    }\n\n    .p-tieredmenu ul {\n        margin: 0;\n        padding: 0;\n        list-style: none;\n    }\n\n    .p-tieredmenu .p-submenu-list {\n        position: absolute;\n        min-width: 100%;\n        z-index: 1;\n        display: none;\n    }\n\n    .p-tieredmenu .p-menuitem-link {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        text-decoration: none;\n        overflow: hidden;\n        position: relative;\n    }\n\n    .p-tieredmenu .p-menuitem-text {\n        line-height: 1;\n    }\n\n    .p-tieredmenu .p-menuitem {\n        position: relative;\n    }\n\n    .p-tieredmenu .p-menuitem-link .p-submenu-icon {\n        margin-left: auto;\n    }\n\n    .p-tieredmenu .p-menuitem-active > .p-submenu-list {\n        display: block;\n        left: 100%;\n        top: 0;\n    }\n\n    .p-tieredmenu .p-menuitem-active > .p-submenu-list-flipped {\n        left: -100%;\n    }\n}\n";
var $cac12bb981be06b4$var$TieredMenuBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "TieredMenu",
        id: null,
        model: null,
        popup: false,
        style: null,
        className: null,
        autoZIndex: true,
        baseZIndex: 0,
        breakpoint: undefined,
        scrollHeight: "400px",
        appendTo: null,
        transitionOptions: null,
        onShow: null,
        onFocus: null,
        onBlur: null,
        onHide: null,
        submenuIcon: null,
        children: undefined
    },
    css: {
        classes: $cac12bb981be06b4$var$classes$1,
        styles: $cac12bb981be06b4$var$styles$1,
        inlineStyles: $cac12bb981be06b4$var$inlineStyles
    }
});
function $cac12bb981be06b4$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cac12bb981be06b4$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cac12bb981be06b4$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $cac12bb981be06b4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cac12bb981be06b4$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cac12bb981be06b4$var$TieredMenuSub = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(props, ref) {
    var elementRef = $81g6h.useRef(null);
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var ptm = props.ptm, cx = props.cx, sx = props.sx;
    var getPTOptions = function getPTOptions(item, key) {
        return ptm(key, {
            hostName: props.hostName,
            context: {
                active: isItemActive(item)
            }
        });
    };
    var position = function position() {
        if (elementRef.current) {
            var parentItem = elementRef.current.parentElement;
            var containerOffset = (0, $cfkGk.DomHandler).getOffset(parentItem);
            var viewport = (0, $cfkGk.DomHandler).getViewport();
            var sublistWidth = elementRef.current.offsetParent ? elementRef.current.offsetWidth : (0, $cfkGk.DomHandler).getHiddenElementOuterWidth(elementRef.current);
            var itemOuterWidth = (0, $cfkGk.DomHandler).getOuterWidth(parentItem.children[0]);
            var top = parseInt(containerOffset.top, 10) + elementRef.current.offsetHeight - (0, $cfkGk.DomHandler).getWindowScrollTop();
            if (top > viewport.height) elementRef.current.style.top = viewport.height - top + "px";
            else elementRef.current.style.top = "0px";
            if (parseInt(containerOffset.left, 10) + itemOuterWidth + sublistWidth > viewport.width - (0, $cfkGk.DomHandler).calculateScrollbarWidth()) (0, $cfkGk.DomHandler).addClass(elementRef.current, "p-submenu-list-flipped");
        }
    };
    var onItemClick = function onItemClick(event1, processedItem) {
        var item = processedItem.item;
        if (isItemDisabled(processedItem)) {
            event1.preventDefault();
            return;
        }
        if (item.command) item.command({
            originalEvent: event1,
            item: item
        });
        props.onItemClick && props.onItemClick({
            originalEvent: event1,
            processedItem: processedItem
        });
        if (!item.url) {
            event1.preventDefault();
            event1.stopPropagation();
        }
    };
    var getItemId = function getItemId(processedItem) {
        return "".concat(props.menuId, "_").concat(processedItem.key);
    };
    var getItemProp = function getItemProp(processedItem, name, params) {
        return processedItem && processedItem.item ? (0, $cfkGk.ObjectUtils).getItemValue(processedItem.item[name], params) : undefined;
    };
    var isItemActive = function isItemActive(processedItem) {
        return props.activeItemPath.some(function(path) {
            return path.key === processedItem.key;
        });
    };
    var isItemVisible = function isItemVisible(processedItem) {
        return getItemProp(processedItem, "visible") !== false;
    };
    var isItemDisabled = function isItemDisabled(processedItem) {
        return getItemProp(processedItem, "disabled");
    };
    var isItemFocused = function isItemFocused(processedItem) {
        return props.focusedItemId === getItemId(processedItem);
    };
    var isItemGroup = function isItemGroup(processedItem) {
        return (0, $cfkGk.ObjectUtils).isNotEmpty(processedItem.items);
    };
    var onItemMouseEnter = function onItemMouseEnter(event1, processedItem) {
        props.onItemMouseEnter && props.onItemMouseEnter({
            originalEvent: event1,
            processedItem: processedItem
        });
    };
    var getAriaSetSize = function getAriaSetSize() {
        return props.model.filter(function(processedItem) {
            return isItemVisible(processedItem) && !getItemProp(processedItem, "separator");
        }).length;
    };
    var getAriaPosInset = function getAriaPosInset(index) {
        return index - props.model.slice(0, index).filter(function(processedItem) {
            return isItemVisible(processedItem) && getItemProp(processedItem, "separator");
        }).length + 1;
    };
    (0, $l2NC0.useUpdateEffect)(function() {
        if (!props.root && props.parentActive && !props.isMobileMode) position();
    }, [
        props.parentActive
    ]);
    $81g6h.useImperativeHandle(ref, function() {
        return {
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var createSeparator = function createSeparator(index) {
        var key = "separator_" + index;
        var separatorProps = mergeProps({
            key: key,
            className: cx("separator"),
            role: "separator"
        }, ptm("separator", {
            hostName: props.hostName
        }));
        return /*#__PURE__*/ $81g6h.createElement("li", separatorProps);
    };
    var createSubmenu = function createSubmenu(processedItem, index) {
        if (isItemGroup(processedItem)) return /*#__PURE__*/ $81g6h.createElement($cac12bb981be06b4$var$TieredMenuSub, {
            id: props.id + "_" + index,
            menuProps: props.menuProps,
            model: processedItem.items,
            menuId: props.menuId,
            ariaLabelledby: getItemId(processedItem),
            focusedItemId: props.focusedItemId,
            activeItemPath: props.activeItemPath,
            level: props.level + 1,
            onItemClick: props.onItemClick,
            popup: props.popup,
            onItemMouseEnter: props.onItemMouseEnter,
            parentActive: isItemActive(processedItem),
            isMobileMode: props.isMobileMode,
            submenuIcon: props.submenuIcon,
            ptm: props.ptm,
            cx: cx,
            sx: sx
        });
        return null;
    };
    var createMenuItem = function createMenuItem(processedItem, index) {
        if (isItemVisible(processedItem) === false) return null;
        var item = processedItem.item;
        var style = getItemProp(processedItem, "style");
        var itemClassName = getItemProp(processedItem, "className");
        var _icon = getItemProp(processedItem, "icon");
        var target = getItemProp(processedItem, "target");
        var url = getItemProp(processedItem, "url");
        var key = getItemId(processedItem);
        var focused = isItemFocused(processedItem);
        var active = isItemActive(processedItem);
        var disabled = isItemDisabled(processedItem);
        var grouped = isItemGroup(processedItem);
        var linkClassName = (0, $cfkGk.classNames)("p-menuitem-link");
        var iconClassName = (0, $cfkGk.classNames)("p-menuitem-icon", _icon);
        var iconProps = mergeProps({
            className: (0, $cfkGk.classNames)(item.icon, "p-menuitem-icon", "icon")
        }, getPTOptions(processedItem, "icon"));
        var icon = (0, $cfkGk.IconUtils).getJSXIcon(_icon, $cac12bb981be06b4$var$_objectSpread$2({}, iconProps), {
            props: props.menuProps
        });
        var labelProps = mergeProps({
            className: cx("label")
        }, getPTOptions(processedItem, "label"));
        var label = item.label && /*#__PURE__*/ $81g6h.createElement("span", labelProps, item.label);
        var submenuIconClassName = "p-submenu-icon";
        var submenuIconProps = mergeProps({
            className: cx("submenuIcon")
        }, getPTOptions(processedItem, "submenuIcon"));
        var submenuIcon = grouped && (0, $cfkGk.IconUtils).getJSXIcon(props.submenuIcon || /*#__PURE__*/ $81g6h.createElement((0, $1gPAC.AngleRightIcon), submenuIconProps), $cac12bb981be06b4$var$_objectSpread$2({}, submenuIconProps), {
            props: props.menuProps
        });
        var submenu = createSubmenu(processedItem, index);
        var actionProps = mergeProps({
            href: url || "#",
            "aria-hidden": true,
            tabIndex: "-1",
            onFocus: function onFocus(event1) {
                return event1.stopPropagation();
            },
            className: cx("action"),
            target: target
        }, getPTOptions(processedItem, "action"));
        var content = /*#__PURE__*/ $81g6h.createElement("a", actionProps, icon, label, submenuIcon, /*#__PURE__*/ $81g6h.createElement((0, $9rbaG.Ripple), null));
        if (item.template) {
            var defaultContentOptions = {
                className: linkClassName,
                labelClassName: "p-menuitem-text",
                iconClassName: iconClassName,
                submenuIconClassName: submenuIconClassName,
                element: content,
                props: props,
                active: active,
                disabled: disabled
            };
            content = (0, $cfkGk.ObjectUtils).getJSXElement(item.template, item, defaultContentOptions);
        }
        var contentProps = mergeProps({
            onClick: function onClick(event1) {
                return onItemClick(event1, processedItem);
            },
            onMouseEnter: function onMouseEnter(event1) {
                return onItemMouseEnter(event1, processedItem);
            },
            className: cx("content")
        }, getPTOptions(processedItem, "content"));
        var menuitemProps = mergeProps({
            key: key,
            id: key,
            "aria-label": item.label,
            "aria-disabled": disabled,
            "aria-expanded": grouped ? active : undefined,
            "aria-haspopup": grouped && !url ? "menu" : undefined,
            "aria-setsize": getAriaSetSize(),
            "aria-posinset": getAriaPosInset(index),
            "data-p-highlight": active,
            "data-p-disabled": disabled,
            "data-p-visited": focused,
            className: cx("menuitem", {
                itemClassName: itemClassName,
                active: active,
                focused: focused,
                disabled: disabled
            }),
            style: style,
            onMouseEnter: function onMouseEnter(event1) {
                return onItemMouseEnter(event1, item);
            },
            role: "menuitem"
        }, getPTOptions(processedItem, "menuitem"));
        return /*#__PURE__*/ $81g6h.createElement("li", menuitemProps, /*#__PURE__*/ $81g6h.createElement("div", contentProps, content), submenu);
    };
    var createItem = function createItem(processedItem, index) {
        return getItemProp(processedItem, "separator") ? createSeparator(index) : createMenuItem(processedItem, index);
    };
    var createMenu = function createMenu() {
        return props.model ? props.model.map(createItem) : null;
    };
    var submenu = createMenu();
    var ptKey = props.root ? "menu" : "submenu";
    var menuProps = mergeProps({
        ref: elementRef,
        id: props.id,
        tabIndex: props.tabIndex,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        onKeyDown: props.onKeyDown,
        className: cx(ptKey, {
            subProps: props
        }),
        style: sx(ptKey, {
            subProps: props
        }),
        role: props.root ? "menubar" : "menu",
        "aria-label": props.ariaLabel,
        "aria-labelledby": props.ariaLabelledby,
        "aria-orientation": props.ariaOrientation,
        "aria-activedescendant": props.focusedItemId
    }, ptm(ptKey, {
        hostName: props.hostName
    }));
    return /*#__PURE__*/ $81g6h.createElement("ul", menuProps, submenu);
}));
$cac12bb981be06b4$var$TieredMenuSub.displayName = "TieredMenuSub";
function $cac12bb981be06b4$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cac12bb981be06b4$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cac12bb981be06b4$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $cac12bb981be06b4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cac12bb981be06b4$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cac12bb981be06b4$var$TieredMenu = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $cac12bb981be06b4$var$TieredMenuBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState(props.id), _React$useState2 = $cac12bb981be06b4$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0], setIdState = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(!props.popup), _React$useState4 = $cac12bb981be06b4$var$_slicedToArray(_React$useState3, 2), visibleState = _React$useState4[0], setVisibleState = _React$useState4[1];
    var _React$useState5 = $81g6h.useState([]), _React$useState6 = $cac12bb981be06b4$var$_slicedToArray(_React$useState5, 2), activeItemPath = _React$useState6[0], setActiveItemPath = _React$useState6[1];
    var _React$useState7 = $81g6h.useState(false), _React$useState8 = $cac12bb981be06b4$var$_slicedToArray(_React$useState7, 2), focused = _React$useState8[0], setFocused = _React$useState8[1];
    var _React$useState9 = $81g6h.useState(null), _React$useState10 = $cac12bb981be06b4$var$_slicedToArray(_React$useState9, 2), focusedItemId = _React$useState10[0], setFocusedItemId = _React$useState10[1];
    var _React$useState11 = $81g6h.useState({
        index: -1,
        level: 0,
        parentKey: ""
    }), _React$useState12 = $cac12bb981be06b4$var$_slicedToArray(_React$useState11, 2), focusedItemInfo = _React$useState12[0], setFocusedItemInfo = _React$useState12[1];
    var _React$useState13 = $81g6h.useState(false), _React$useState14 = $cac12bb981be06b4$var$_slicedToArray(_React$useState13, 2), dirty = _React$useState14[0], setDirty = _React$useState14[1];
    var _React$useState15 = $81g6h.useState([]), _React$useState16 = $cac12bb981be06b4$var$_slicedToArray(_React$useState15, 2), processedItems = _React$useState16[0], setProcessedItems = _React$useState16[1];
    var _React$useState17 = $81g6h.useState([]), _React$useState18 = $cac12bb981be06b4$var$_slicedToArray(_React$useState17, 2), visibleItems = _React$useState18[0], setVisibleItems = _React$useState18[1];
    var _React$useState19 = $81g6h.useState(false), _React$useState20 = $cac12bb981be06b4$var$_slicedToArray(_React$useState19, 2), focusTrigger = _React$useState20[0], setFocusTrigger = _React$useState20[1];
    var _React$useState21 = $81g6h.useState(null), _React$useState22 = $cac12bb981be06b4$var$_slicedToArray(_React$useState21, 2), attributeSelectorState = _React$useState22[0], setAttributeSelectorState = _React$useState22[1];
    var _TieredMenuBase$setMe = $cac12bb981be06b4$var$TieredMenuBase.setMetaData({
        props: props,
        state: {
            id: idState,
            visible: visibleState,
            attributeSelector: attributeSelectorState
        }
    }), ptm = _TieredMenuBase$setMe.ptm, cx = _TieredMenuBase$setMe.cx, sx = _TieredMenuBase$setMe.sx, isUnstyled = _TieredMenuBase$setMe.isUnstyled;
    (0, $4gQLd.useHandleStyle)($cac12bb981be06b4$var$TieredMenuBase.css.styles, isUnstyled, {
        name: "tieredmenu"
    });
    var containerRef = $81g6h.useRef(null);
    var menuRef = $81g6h.useRef(null);
    var targetRef = $81g6h.useRef(null);
    var relatedTarget = $81g6h.useRef(null);
    var styleElementRef = $81g6h.useRef(null);
    var searchValue = $81g6h.useRef(null);
    var searchTimeout = $81g6h.useRef(null);
    var isMobileMode = (0, $l2NC0.useMatchMedia)("screen and (max-width: ".concat(props.breakpoint, ")"), !!props.breakpoint);
    var _useEventListener = (0, $l2NC0.useEventListener)({
        type: "click",
        listener: function listener(event1) {
            var isOutsideContainer = containerRef.current && !containerRef.current.contains(event1.target);
            var isOutsideTarget = props.popup ? !(targetRef.current && (targetRef.current === event1.target || targetRef.current.contains(event1.target))) : true;
            if (isOutsideContainer && isOutsideTarget) hide(event1, !props.popup);
        }
    }), _useEventListener2 = $cac12bb981be06b4$var$_slicedToArray(_useEventListener, 2), bindDocumentClickListener = _useEventListener2[0], unbindDocumentClickListener = _useEventListener2[1];
    var _useResizeListener = (0, $l2NC0.useResizeListener)({
        listener: function listener() {
            !isMobileMode && hide(event, true);
        }
    }), _useResizeListener2 = $cac12bb981be06b4$var$_slicedToArray(_useResizeListener, 2), bindDocumentResizeListener = _useResizeListener2[0], unbindDocumentResizeListener = _useResizeListener2[1];
    var onPanelClick = function onPanelClick(event1) {
        if (props.popup) (0, $k7ffa.OverlayService).emit("overlay-click", {
            originalEvent: event1,
            target: targetRef.current
        });
    };
    var toggle = function toggle(event1) {
        if (props.popup) visibleState ? hide(event1) : show(event1);
    };
    var show = function show(event1) {
        if (props.popup) {
            targetRef.current = event1.currentTarget;
            setVisibleState(true);
            props.onShow && props.onShow(event1);
            relatedTarget.current = event1.relatedTarget || null;
        }
        setFocusedItemInfo({
            index: findFirstFocusedItemIndex(),
            level: 0,
            parentKey: ""
        });
    };
    var hide = function hide(event1, isFocus) {
        if (props.popup) {
            setVisibleState(false);
            props.onHide && props.onHide(event1);
        }
        var menuElement = getMenuElement();
        setActiveItemPath([]);
        setFocusedItemInfo({
            index: -1,
            level: 0,
            parentKey: ""
        });
        isFocus && (0, $cfkGk.DomHandler).focus(relatedTarget.current || targetRef.current || menuElement);
        setDirty(false);
    };
    var onFocus = function onFocus(event1) {
        setFocused(true);
        setFocusedItemInfo(focusedItemInfo.index !== -1 ? focusedItemInfo : {
            index: findFirstFocusedItemIndex(),
            level: 0,
            parentKey: ""
        });
        props.onFocus && props.onFocus(event1);
    };
    var onBlur = function onBlur(event1) {
        setFocused(false);
        setFocusedItemInfo({
            index: -1,
            level: 0,
            parentKey: ""
        });
        searchValue.current = "";
        setDirty(false);
        props.onBlur && props.onBlur(event1);
    };
    var onKeyDown = function onKeyDown(event1) {
        var metaKey = event1.metaKey || event1.ctrlKey;
        switch(event1.code){
            case "ArrowDown":
                onArrowDownKey(event1);
                break;
            case "ArrowUp":
                onArrowUpKey(event1);
                break;
            case "ArrowLeft":
                onArrowLeftKey(event1);
                break;
            case "ArrowRight":
                onArrowRightKey(event1);
                break;
            case "Home":
                onHomeKey(event1);
                break;
            case "End":
                onEndKey(event1);
                break;
            case "Space":
                onSpaceKey(event1);
                break;
            case "Enter":
            case "NumpadEnter":
                onEnterKey(event1);
                break;
            case "Escape":
                props.popup && (0, $cfkGk.DomHandler).focus(targetRef.current);
                onEscapeKey(event1);
                break;
            case "Tab":
                onTabKey(event1);
                break;
            case "PageDown":
            case "PageUp":
            case "Backspace":
            case "ShiftLeft":
            case "ShiftRight":
                break;
            default:
                if (!metaKey && (0, $cfkGk.ObjectUtils).isPrintableCharacter(event1.key)) searchItems(event1.key);
                break;
        }
    };
    var onItemChange = function onItemChange(event1) {
        var processedItem = event1.processedItem, isFocus = event1.isFocus;
        if ((0, $cfkGk.ObjectUtils).isEmpty(processedItem)) return;
        var index = processedItem.index, key = processedItem.key, level = processedItem.level, parentKey = processedItem.parentKey, items = processedItem.items;
        var grouped = (0, $cfkGk.ObjectUtils).isNotEmpty(items);
        var _activeItemPath = activeItemPath.filter(function(p) {
            return p.parentKey !== parentKey && p.parentKey !== key;
        });
        if (grouped) _activeItemPath.push(processedItem);
        setFocusedItemInfo({
            index: index,
            level: level,
            parentKey: parentKey
        });
        setActiveItemPath(_activeItemPath);
        grouped && setDirty(true);
        isFocus && (0, $cfkGk.DomHandler).focus(getMenuElement());
    };
    var onItemClick = function onItemClick(event1) {
        var originalEvent = event1.originalEvent, processedItem = event1.processedItem;
        if (isItemDisabled(processedItem) || props.isMobileMode) return;
        var grouped = isProccessedItemGroup(processedItem);
        var root = (0, $cfkGk.ObjectUtils).isEmpty(processedItem.parent);
        var selected = isSelected(processedItem);
        var menuElement = getMenuElement();
        if (selected) {
            var index = processedItem.index, key = processedItem.key, level = processedItem.level, parentKey = processedItem.parentKey;
            setActiveItemPath(activeItemPath.filter(function(p) {
                return key !== p.key && key.startsWith(p.key);
            }));
            setFocusedItemInfo({
                index: index,
                level: level,
                parentKey: parentKey
            });
            if (!grouped) setDirty(!root);
            setTimeout(function() {
                (0, $cfkGk.DomHandler).focus(menuElement);
                if (grouped) setDirty(true);
            }, 0);
        } else if (grouped) {
            (0, $cfkGk.DomHandler).focus(menuElement);
            onItemChange(event1);
        } else {
            var rootProcessedItem = root ? processedItem : activeItemPath.find(function(p) {
                return p.parentKey === "";
            });
            var rootProcessedItemIndex = rootProcessedItem ? rootProcessedItem.index : -1;
            hide(originalEvent, true);
            setFocusedItemInfo({
                index: rootProcessedItemIndex,
                parentKey: rootProcessedItem ? rootProcessedItem.parentKey : ""
            });
        }
    };
    var onItemMouseEnter = function onItemMouseEnter(event1) {
        var originalEvent = event1.originalEvent, processedItem = event1.processedItem;
        if (isItemDisabled(processedItem) || props.isMobileMode) {
            originalEvent.preventDefault();
            return;
        }
        if (dirty && !props.popup) onItemChange(event1);
    };
    var onArrowDownKey = function onArrowDownKey(event1) {
        var itemIndex = focusedItemInfo.index !== -1 ? findNextItemIndex(focusedItemInfo.index) : findFirstFocusedItemIndex();
        changeFocusedItemIndex(itemIndex);
        event1.preventDefault();
    };
    var onArrowUpKey = function onArrowUpKey(event1) {
        if (event1.altKey) {
            if (props.popup) (0, $cfkGk.DomHandler).focus(targetRef.current);
            if (focusedItemInfo.index !== -1) {
                var processedItem = visibleItems[focusedItemInfo.index];
                var grouped = isProccessedItemGroup(processedItem);
                !grouped && onItemChange({
                    originalEvent: event1,
                    processedItem: processedItem
                });
            }
            props.popup && hide(event1, true);
            event1.preventDefault();
        } else {
            var itemIndex = focusedItemInfo.index !== -1 ? findPrevItemIndex(focusedItemInfo.index) : findLastFocusedItemIndex();
            changeFocusedItemIndex(itemIndex);
            event1.preventDefault();
        }
    };
    var onArrowLeftKey = function onArrowLeftKey(event1) {
        var processedItem = visibleItems[focusedItemInfo.index];
        var parentItem = activeItemPath.find(function(p) {
            return p.key === processedItem.parentKey;
        });
        var root = (0, $cfkGk.ObjectUtils).isEmpty(processedItem.parent);
        if (!root) {
            setFocusedItemInfo({
                index: -1,
                parentKey: parentItem ? parentItem.parentKey : ""
            });
            searchValue.current = "";
            setTimeout(function() {
                return setFocusTrigger(true);
            }, 0);
        }
        setActiveItemPath(activeItemPath.filter(function(p) {
            return p.parentKey !== focusedItemInfo.parentKey;
        }));
        event1.preventDefault();
    };
    var onArrowRightKey = function onArrowRightKey(event1) {
        var processedItem = visibleItems[focusedItemInfo.index];
        var grouped = isProccessedItemGroup(processedItem);
        if (grouped) {
            onItemChange({
                originalEvent: event1,
                processedItem: processedItem
            });
            setFocusedItemInfo({
                index: -1,
                parentKey: processedItem.key
            });
            searchValue.current = "";
            setTimeout(function() {
                return setFocusTrigger(true);
            }, 0);
        }
        event1.preventDefault();
    };
    var onHomeKey = function onHomeKey(event1) {
        changeFocusedItemIndex(findFirstItemIndex());
        event1.preventDefault();
    };
    var onEndKey = function onEndKey(event1) {
        changeFocusedItemIndex(findLastItemIndex());
        event1.preventDefault();
    };
    var onEnterKey = function onEnterKey(event1) {
        if (focusedItemInfo.index !== -1) {
            var _element = (0, $cfkGk.DomHandler).findSingle(getMenuElement(), 'li[id="'.concat("".concat(focusedItemId), '"]'));
            var anchorElement = _element && (0, $cfkGk.DomHandler).findSingle(_element, '[data-pc-section="action"]');
            props.popup && (0, $cfkGk.DomHandler).focus(targetRef.current);
            anchorElement ? anchorElement.click() : _element && _element.click();
        }
        event1.preventDefault();
    };
    var onSpaceKey = function onSpaceKey(event1) {
        onEnterKey(event1);
    };
    var onEscapeKey = function onEscapeKey(event1) {
        hide(event1, true);
        !props.popup && setFocusedItemInfo($cac12bb981be06b4$var$_objectSpread$1($cac12bb981be06b4$var$_objectSpread$1({}, focusedItemInfo), {}, {
            index: findFirstFocusedItemIndex()
        }));
        event1.preventDefault();
    };
    var onTabKey = function onTabKey(event1) {
        if (focusedItemInfo.index !== -1) {
            var processedItem = visibleItems[focusedItemInfo.index];
            var grouped = isProccessedItemGroup(processedItem);
            !grouped && onItemChange({
                originalEvent: event1,
                processedItem: processedItem
            });
        }
        hide(event1);
    };
    var getMenuElement = function getMenuElement() {
        return menuRef.current.getElement() || null;
    };
    var getItemProp = function getItemProp(item, name) {
        return item ? (0, $cfkGk.ObjectUtils).getItemValue(item[name]) : undefined;
    };
    var getItemLabel = function getItemLabel(item) {
        return getItemProp(item, "label");
    };
    var isItemDisabled = function isItemDisabled(item) {
        return getItemProp(item, "disabled");
    };
    var isItemSeparator = function isItemSeparator(item) {
        return getItemProp(item, "separator");
    };
    var getProccessedItemLabel = function getProccessedItemLabel(processedItem) {
        return processedItem ? getItemLabel(processedItem.item) : undefined;
    };
    var isProccessedItemGroup = function isProccessedItemGroup(processedItem) {
        return processedItem && (0, $cfkGk.ObjectUtils).isNotEmpty(processedItem.items);
    };
    var isItemMatched = function isItemMatched(processedItem) {
        return isValidItem(processedItem) && getProccessedItemLabel(processedItem).toLocaleLowerCase().startsWith(searchValue.current.toLocaleLowerCase());
    };
    var isValidItem = function isValidItem(processedItem) {
        return !!processedItem && !isItemDisabled(processedItem.item) && !isItemSeparator(processedItem.item);
    };
    var isValidSelectedItem = function isValidSelectedItem(processedItem) {
        return isValidItem(processedItem) && isSelected(processedItem);
    };
    var isSelected = function isSelected(processedItem) {
        return activeItemPath.some(function(p) {
            return p.key === processedItem.key;
        });
    };
    var findFirstItemIndex = function findFirstItemIndex() {
        return visibleItems.findIndex(function(processedItem) {
            return isValidItem(processedItem);
        });
    };
    var findLastItemIndex = function findLastItemIndex() {
        return (0, $cfkGk.ObjectUtils).findLastIndex(visibleItems, function(processedItem) {
            return isValidItem(processedItem);
        });
    };
    var findNextItemIndex = function findNextItemIndex(index) {
        var matchedItemIndex = index < visibleItems.length - 1 ? visibleItems.slice(index + 1).findIndex(function(processedItem) {
            return isValidItem(processedItem);
        }) : -1;
        return matchedItemIndex > -1 ? matchedItemIndex + index + 1 : index;
    };
    var findPrevItemIndex = function findPrevItemIndex(index) {
        var matchedItemIndex = index > 0 ? (0, $cfkGk.ObjectUtils).findLastIndex(visibleItems.slice(0, index), function(processedItem) {
            return isValidItem(processedItem);
        }) : -1;
        return matchedItemIndex > -1 ? matchedItemIndex : index;
    };
    var findSelectedItemIndex = function findSelectedItemIndex() {
        return visibleItems.findIndex(function(processedItem) {
            return isValidSelectedItem(processedItem);
        });
    };
    var findFirstFocusedItemIndex = function findFirstFocusedItemIndex() {
        var selectedIndex = findSelectedItemIndex();
        return selectedIndex < 0 ? findFirstItemIndex() : selectedIndex;
    };
    var findLastFocusedItemIndex = function findLastFocusedItemIndex() {
        var selectedIndex = findSelectedItemIndex();
        return selectedIndex < 0 ? findLastItemIndex() : selectedIndex;
    };
    var searchItems = function searchItems(_char) {
        searchValue.current = (searchValue.current || "") + _char;
        var itemIndex = -1;
        var matched = false;
        if (focusedItemInfo.index !== -1) {
            itemIndex = visibleItems.slice(focusedItemInfo.index).findIndex(function(processedItem) {
                return isItemMatched(processedItem);
            });
            itemIndex = itemIndex === -1 ? visibleItems.slice(0, focusedItemInfo.index).findIndex(function(processedItem) {
                return isItemMatched(processedItem);
            }) : itemIndex + focusedItemInfo.index;
        } else itemIndex = visibleItems.findIndex(function(processedItem) {
            return isItemMatched(processedItem);
        });
        if (itemIndex !== -1) matched = true;
        if (itemIndex === -1 && focusedItemInfo.index === -1) itemIndex = findFirstFocusedItemIndex();
        if (itemIndex !== -1) changeFocusedItemIndex(itemIndex);
        if (searchTimeout.current) clearTimeout(searchTimeout);
        searchTimeout.current = setTimeout(function() {
            searchValue.current = "";
            searchTimeout.current = null;
        }, 500);
        return matched;
    };
    var changeFocusedItemIndex = function changeFocusedItemIndex(index) {
        if (focusedItemInfo.index !== index) {
            setFocusedItemInfo($cac12bb981be06b4$var$_objectSpread$1($cac12bb981be06b4$var$_objectSpread$1({}, focusedItemInfo), {}, {
                index: index
            }));
            scrollInView();
        }
    };
    var scrollInView = function scrollInView() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
        var id = index !== -1 ? "".concat(idState, "_").concat(index) : focusedItemId;
        var element = (0, $cfkGk.DomHandler).findSingle(getMenuElement(), 'li[id="'.concat(id, '"]'));
        if (element) element.scrollIntoView && element.scrollIntoView({
            block: "nearest",
            inline: "start"
        });
    };
    var createProcessedItems = $81g6h.useCallback(function(items) {
        var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var parentKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
        var processedItems = [];
        items && items.forEach(function(item, index) {
            var key = (parentKey !== "" ? parentKey + "_" : "") + index;
            var newItem = {
                item: item,
                index: index,
                level: level,
                key: key,
                parent: parent,
                parentKey: parentKey
            };
            newItem.items = createProcessedItems(item.items, level + 1, newItem, key);
            processedItems.push(newItem);
        });
        return processedItems;
    }, []);
    var createStyle = function createStyle() {
        if (!styleElementRef.current) {
            styleElementRef.current = (0, $cfkGk.DomHandler).createInlineStyle(context && context.nonce || (0, $8Zwsm.default).nonce, context && context.styleContainer);
            var selector = "".concat(attributeSelectorState);
            var innerHTML = "\n@media screen and (max-width: ".concat(props.breakpoint, ") {\n    .p-tieredmenu[").concat(selector, "] > ul {\n        max-height: ").concat(props.scrollHeight, ";\n        overflow: ").concat(props.scrollHeight ? "auto" : "", ";\n    }\n\n    .p-tieredmenu[").concat(selector, "] .p-submenu-list {\n        position: relative;\n    }\n\n    .p-tieredmenu[").concat(selector, "] .p-menuitem-active > .p-submenu-list {\n        left: 0;\n        box-shadow: none;\n        border-radius: 0;\n        padding: 0 0 0 calc(var(--inline-spacing) * 2); /* @todo */\n    }\n\n    .p-tieredmenu[").concat(selector, "] .p-menuitem-active > .p-menuitem-link > .p-submenu-icon {\n        transform: rotate(-180deg);\n    }\n\n    .p-tieredmenu[").concat(selector, '] .p-submenu-icon:before {\n        content: "\\e930";\n    }\n\n    ').concat(!props.popup ? ".p-tieredmenu[".concat(selector, "] { width: 100%; }") : "", "\n}\n");
            styleElementRef.current.innerHTML = innerHTML;
        }
    };
    var destroyStyle = function destroyStyle() {
        styleElementRef.current = (0, $cfkGk.DomHandler).removeInlineStyle(styleElementRef.current);
    };
    var alignOverlay = function alignOverlay() {
        var calculateMinWidth = (0, $cfkGk.DomHandler).getOuterWidth(targetRef.current) > (0, $cfkGk.DomHandler).getOuterWidth(containerRef.current);
        (0, $cfkGk.DomHandler).alignOverlay(containerRef.current, targetRef.current, props.appendTo, calculateMinWidth);
    };
    var onEnter = function onEnter() {
        if (props.autoZIndex) (0, $cfkGk.ZIndexUtils).set("menu", containerRef.current, context && context.autoZIndex || (0, $8Zwsm.default).autoZIndex, props.baseZIndex || context && context.zIndex.menu || (0, $8Zwsm.default).zIndex.menu);
        (0, $cfkGk.DomHandler).addStyles(containerRef.current, {
            position: "absolute",
            top: "0",
            left: "0"
        });
        alignOverlay();
        (0, $cfkGk.DomHandler).focus(menuRef.current.getElement());
        scrollInView();
        if (attributeSelectorState && props.breakpoint) {
            containerRef.current.setAttribute(attributeSelectorState, "");
            createStyle();
        }
    };
    var onEntered = function onEntered() {
        bindDocumentClickListener();
        bindDocumentResizeListener();
    };
    var onExit = function onExit() {
        targetRef.current = null;
        unbindDocumentClickListener();
        unbindDocumentResizeListener();
    };
    var onExited = function onExited() {
        (0, $cfkGk.ZIndexUtils).clear(containerRef.current);
        destroyStyle();
    };
    (0, $l2NC0.useMountEffect)(function() {
        var uniqueId = (0, $cfkGk.UniqueComponentId)();
        !idState && setIdState(uniqueId);
        if (props.breakpoint) !attributeSelectorState && setAttributeSelectorState(uniqueId);
    });
    $81g6h.useEffect(function() {
        var itemsToProcess = props.model || [];
        var processed = createProcessedItems(itemsToProcess);
        setProcessedItems(processed);
    }, [
        props.model,
        createProcessedItems
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        var processedItem = activeItemPath.find(function(p) {
            return p.key === focusedItemInfo.parentKey;
        });
        var processed = processedItem ? processedItem.items : processedItems;
        setVisibleItems(processed);
    }, [
        activeItemPath,
        focusedItemInfo,
        processedItems
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        var focusedId = focusedItemInfo.index !== -1 ? "".concat(idState).concat((0, $cfkGk.ObjectUtils).isNotEmpty(focusedItemInfo.parentKey) ? "_" + focusedItemInfo.parentKey : "", "_").concat(focusedItemInfo.index) : null;
        setFocusedItemId(focusedId);
    }, [
        focusedItemInfo
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (!props.popup) {
            if ((0, $cfkGk.ObjectUtils).isNotEmpty(activeItemPath)) {
                bindDocumentClickListener();
                bindDocumentResizeListener();
            } else {
                unbindDocumentClickListener();
                unbindDocumentResizeListener();
            }
        }
    }, [
        activeItemPath
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (focusTrigger) {
            var itemIndex = focusedItemInfo.index !== -1 ? findNextItemIndex(focusedItemInfo.index) : findFirstFocusedItemIndex();
            changeFocusedItemIndex(itemIndex);
            setActiveItemPath(activeItemPath.filter(function(p) {
                return p.parentKey !== focusedItemInfo.parentKey;
            }));
            setFocusTrigger(false);
        }
    }, [
        focusTrigger
    ]);
    (0, $l2NC0.useUpdateEffect)(function() {
        if (attributeSelectorState && containerRef.current) {
            containerRef.current.setAttribute(attributeSelectorState, "");
            createStyle();
        }
        return function() {
            destroyStyle();
        };
    }, [
        attributeSelectorState,
        props.breakpoint
    ]);
    (0, $l2NC0.useUnmountEffect)(function() {
        (0, $cfkGk.ZIndexUtils).clear(containerRef.current);
    });
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            toggle: toggle,
            show: show,
            hide: hide,
            getElement: function getElement() {
                return containerRef.current;
            }
        };
    });
    var createElement = function createElement() {
        var rootProps = mergeProps({
            ref: containerRef,
            id: props.id,
            className: (0, $cfkGk.classNames)(props.className, cx("root")),
            style: props.style,
            onClick: onPanelClick
        }, $cac12bb981be06b4$var$TieredMenuBase.getOtherProps(props), ptm("root"));
        var transitionProps = mergeProps({
            classNames: cx("transition"),
            "in": visibleState,
            timeout: {
                enter: 120,
                exit: 100
            },
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: onEnter,
            onEntered: onEntered,
            onExit: onExit,
            onExited: onExited
        }, ptm("transition"));
        return /*#__PURE__*/ $81g6h.createElement((0, $lbdsH.CSSTransition), $cac12bb981be06b4$var$_extends({
            nodeRef: containerRef
        }, transitionProps), /*#__PURE__*/ $81g6h.createElement("div", rootProps, /*#__PURE__*/ $81g6h.createElement($cac12bb981be06b4$var$TieredMenuSub, {
            id: idState + "_list",
            ref: menuRef,
            hostName: "TieredMenu",
            menuProps: props,
            tabIndex: 0,
            model: processedItems,
            ariaLabel: props.ariaLabel,
            ariaLabelledBy: props.ariaLabelledBy,
            ariaOrientation: "vertical",
            ariaActiveDescendant: focused ? focusedItemId : undefined,
            menuId: idState,
            level: 0,
            focusedItemId: focusedItemId,
            activeItemPath: activeItemPath,
            onFocus: onFocus,
            onBlur: onBlur,
            onKeyDown: onKeyDown,
            onItemClick: onItemClick,
            onItemMouseEnter: onItemMouseEnter,
            root: true,
            popup: props.popup,
            onHide: hide,
            isMobileMode: isMobileMode,
            submenuIcon: props.submenuIcon,
            ptm: ptm,
            cx: cx,
            sx: sx
        })));
    };
    var element = createElement();
    return props.popup ? /*#__PURE__*/ $81g6h.createElement((0, $6b4aU.Portal), {
        element: element,
        appendTo: props.appendTo
    }) : element;
}));
$cac12bb981be06b4$var$TieredMenu.displayName = "TieredMenu";
var $cac12bb981be06b4$var$classes = {
    icon: "p-button-icon p-c",
    root: function root(_ref) {
        var props = _ref.props, size = _ref.size;
        return (0, $cfkGk.classNames)("p-splitbutton p-component", $cac12bb981be06b4$var$_defineProperty($cac12bb981be06b4$var$_defineProperty($cac12bb981be06b4$var$_defineProperty($cac12bb981be06b4$var$_defineProperty($cac12bb981be06b4$var$_defineProperty($cac12bb981be06b4$var$_defineProperty({
            "p-disabled": props.disabled,
            "p-button-loading-label-only": props.loading && !props.icon && props.label
        }, "p-button-".concat(props.severity), props.severity), "p-button-raised", props.raised), "p-button-rounded", props.rounded), "p-button-text", props.text), "p-button-outlined", props.outlined), "p-button-".concat(size), size));
    },
    button: "p-splitbutton-defaultbutton",
    menuButton: "p-splitbutton-menubutton",
    menu: function menu(_ref2) {
        var props = _ref2.subProps;
        return (0, $cfkGk.classNames)("p-menu p-menu-overlay p-component", props.menuClassName);
    },
    menuList: "p-menu-list p-reset",
    separator: "p-menu-separator",
    menuIcon: "p-menuitem-icon",
    menuLabel: "p-menuitem-text",
    anchor: function anchor(_ref3) {
        var _className = _ref3._className, disabled = _ref3.disabled;
        return (0, $cfkGk.classNames)("p-menuitem-link", _className, {
            "p-disabled": disabled
        });
    },
    menuItem: "p-menuitem",
    transition: "p-connected-overlay"
};
var $cac12bb981be06b4$var$styles = "\n@layer primereact {\n    .p-splitbutton {\n        display: inline-flex;\n        position: relative;\n    }\n\n    .p-splitbutton .p-splitbutton-defaultbutton,\n    .p-splitbutton.p-button-rounded > .p-splitbutton-defaultbutton.p-button,\n    .p-splitbutton.p-button-outlined > .p-splitbutton-defaultbutton.p-button,\n    .p-splitbutton.p-button-outlined > .p-splitbutton-defaultbutton.p-button-outlined.p-button:hover {\n        flex: 1 1 auto;\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n        border-right: 0 none;\n    }\n\n    .p-splitbutton-menubutton,\n    .p-splitbutton.p-button-rounded > .p-splitbutton-menubutton.p-button,\n    .p-splitbutton.p-button-outlined > .p-splitbutton-menubutton.p-button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .p-splitbutton .p-menu {\n        min-width: 100%;\n    }\n\n    .p-fluid .p-splitbutton  {\n        display: flex;\n    }\n}\n";
var $cac12bb981be06b4$var$SplitButtonBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "SplitButton",
        id: null,
        label: null,
        icon: null,
        autoZIndex: true,
        baseZIndex: 0,
        loading: false,
        loadingIcon: null,
        model: null,
        disabled: null,
        style: null,
        className: null,
        buttonClassName: null,
        menuStyle: null,
        menuClassName: null,
        menuButtonClassName: null,
        buttonProps: null,
        menuButtonProps: null,
        tabIndex: null,
        severity: null,
        rounded: false,
        raised: false,
        outlined: false,
        text: false,
        size: null,
        appendTo: null,
        tooltip: null,
        tooltipOptions: null,
        buttonTemplate: null,
        transitionOptions: null,
        dropdownIcon: null,
        onClick: null,
        onShow: null,
        onHide: null,
        children: undefined
    },
    css: {
        classes: $cac12bb981be06b4$var$classes,
        styles: $cac12bb981be06b4$var$styles
    }
});
function $cac12bb981be06b4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cac12bb981be06b4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cac12bb981be06b4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cac12bb981be06b4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cac12bb981be06b4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cac12bb981be06b4$export$651ad66661acd392 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $cac12bb981be06b4$var$SplitButtonBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState(props.id), _React$useState2 = $cac12bb981be06b4$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0], setIdState = _React$useState2[1];
    var _React$useState3 = $81g6h.useState(false), _React$useState4 = $cac12bb981be06b4$var$_slicedToArray(_React$useState3, 2), overlayVisibleState = _React$useState4[0], setOverlayVisibleState = _React$useState4[1];
    var elementRef = $81g6h.useRef(null);
    var menuRef = $81g6h.useRef(null);
    var defaultButtonRef = $81g6h.useRef(null);
    var overlayRef = $81g6h.useRef(null);
    var overlayDisplayOrder = (0, $l2NC0.useDisplayOrder)("split-button-tooltip", overlayVisibleState);
    var metaData = {
        props: props,
        state: {
            id: idState,
            overlayVisible: overlayVisibleState
        }
    };
    var _SplitButtonBase$setM = $cac12bb981be06b4$var$SplitButtonBase.setMetaData(metaData), ptm = _SplitButtonBase$setM.ptm, cx = _SplitButtonBase$setM.cx, isUnstyled = _SplitButtonBase$setM.isUnstyled;
    (0, $4gQLd.useHandleStyle)($cac12bb981be06b4$var$SplitButtonBase.css.styles, isUnstyled, {
        name: "splitbutton"
    });
    (0, $l2NC0.useGlobalOnEscapeKey)({
        callback: function callback() {
            hide();
        },
        when: overlayVisibleState && overlayDisplayOrder,
        priority: [
            (0, $l2NC0.ESC_KEY_HANDLING_PRIORITIES).SPLIT_BUTTON,
            overlayDisplayOrder
        ]
    });
    var onPanelClick = function onPanelClick(event1) {
        (0, $k7ffa.OverlayService).emit("overlay-click", {
            originalEvent: event1,
            target: elementRef.current
        });
    };
    var onMenuButtonKeyDown = function onMenuButtonKeyDown(event1) {
        if (event1.code === "ArrowDown" || event1.code === "ArrowUp") {
            onDropdownButtonClick(event1);
            event1.preventDefault();
        }
    };
    var onDropdownButtonClick = function onDropdownButtonClick(event1) {
        overlayVisibleState ? hide(event1) : show(event1);
    };
    var show = function show(event1) {
        setOverlayVisibleState(true);
        menuRef.current && menuRef.current.show(event1);
    };
    var hide = function hide(event1) {
        setOverlayVisibleState(false);
        menuRef.current && menuRef.current.hide(event1);
    };
    var onMenuShow = function onMenuShow() {
        props.onShow && props.onShow();
    };
    var onMenuHide = function onMenuHide() {
        setOverlayVisibleState(false);
        props.onHide && props.onHide();
    };
    var alignOverlay = function alignOverlay() {
        (0, $cfkGk.DomHandler).alignOverlay(overlayRef.current, defaultButtonRef.current.parentElement, props.appendTo || context && context.appendTo || (0, $8Zwsm.default).appendTo);
    };
    (0, $l2NC0.useMountEffect)(function() {
        if (!idState) setIdState((0, $cfkGk.UniqueComponentId)());
        alignOverlay();
    });
    (0, $l2NC0.useUnmountEffect)(function() {
        (0, $cfkGk.ZIndexUtils).clear(overlayRef.current);
    });
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            hide: hide,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    if (props.visible === false) return null;
    var hasTooltip = (0, $cfkGk.ObjectUtils).isNotEmpty(props.tooltip);
    var sizeMapping = {
        large: "lg",
        small: "sm"
    };
    var size = sizeMapping[props.size];
    var buttonContent = props.buttonTemplate ? (0, $cfkGk.ObjectUtils).getJSXElement(props.buttonTemplate, props) : null;
    var menuId = idState + "_overlay";
    var dropdownIcon = function dropdownIcon() {
        var iconProps = mergeProps({
            className: cx("icon")
        }, ptm("icon"));
        var icon = props.dropdownIcon || /*#__PURE__*/ $81g6h.createElement((0, $jhJol.ChevronDownIcon), iconProps);
        var dropdownIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $cac12bb981be06b4$var$_objectSpread({}, iconProps), {
            props: props
        });
        return dropdownIcon;
    };
    var rootProps = mergeProps({
        ref: elementRef,
        id: idState,
        className: (0, $cfkGk.classNames)(props.className, cx("root", {
            size: size
        })),
        style: props.style
    }, $cac12bb981be06b4$var$SplitButtonBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, null, /*#__PURE__*/ $81g6h.createElement("div", rootProps, /*#__PURE__*/ $81g6h.createElement((0, $9AWgp.Button), $cac12bb981be06b4$var$_extends({
        ref: defaultButtonRef,
        type: "button",
        className: (0, $cfkGk.classNames)(props.buttonClassName, cx("button")),
        icon: props.icon,
        loading: props.loading,
        loadingIcon: props.loadingIcon,
        severity: props.severity,
        label: props.label,
        "aria-label": props.label,
        raised: props.raised,
        onClick: props.onClick,
        disabled: props.disabled,
        tabIndex: props.tabIndex,
        size: props.size,
        outlined: props.outlined,
        text: props.text
    }, props.buttonProps, {
        pt: ptm("button"),
        __parentMetadata: {
            parent: metaData
        },
        unstyled: props.unstyled
    }), buttonContent), /*#__PURE__*/ $81g6h.createElement((0, $9AWgp.Button), $cac12bb981be06b4$var$_extends({
        type: "button",
        className: (0, $cfkGk.classNames)(props.menuButtonClassName, cx("menuButton")),
        icon: dropdownIcon,
        onClick: onDropdownButtonClick,
        disabled: props.disabled,
        "aria-expanded": overlayVisibleState,
        "aria-haspopup": "true",
        "aria-controls": menuId
    }, props.menuButtonProps, {
        size: props.size,
        severity: props.severity,
        outlined: props.outlined,
        text: props.text,
        raised: props.raised,
        pt: ptm("menuButton"),
        __parentMetadata: {
            parent: metaData
        },
        onKeyDown: onMenuButtonKeyDown,
        unstyled: props.unstyled
    })), /*#__PURE__*/ $81g6h.createElement($cac12bb981be06b4$var$TieredMenu, {
        ref: menuRef,
        popup: true,
        unstyled: props.unstyled,
        model: props.model,
        appendTo: props.appendTo,
        id: menuId,
        style: props.menuStyle,
        autoZIndex: props.autoZIndex,
        baseZIndex: props.baseZIndex,
        className: props.menuClassName,
        onClick: onPanelClick,
        onShow: onMenuShow,
        onHide: onMenuHide,
        pt: ptm("menu")
    })), hasTooltip && /*#__PURE__*/ $81g6h.createElement((0, $7hMfd.Tooltip), $cac12bb981be06b4$var$_extends({
        target: elementRef,
        content: props.tooltip,
        pt: ptm("tooltip")
    }, props.tooltipOptions)));
}));
$cac12bb981be06b4$export$651ad66661acd392.displayName = "SplitButton";



var $81g6h = parcelRequire("81g6h");
var $1e9366404357eeaf$export$62790fc80b39048d;
(function(CreateProgramButtonType) {
    CreateProgramButtonType["FromTemplate"] = "fromTemplate";
    CreateProgramButtonType["New"] = "new";
    CreateProgramButtonType["NewOrFromTemplate"] = "newOrFromTemplate";
})($1e9366404357eeaf$export$62790fc80b39048d || ($1e9366404357eeaf$export$62790fc80b39048d = {}));
const $1e9366404357eeaf$export$50f02f9fd2e16e8e = ({ patient: patient, buttonType: buttonType, onClick: onClick })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const user = (0, $4UKJF.useUser)();
    const navigate = (0, $htiSH.useNavigate)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const onButtonClick = (0, $81g6h.useCallback)(()=>{
        onClick?.(false);
        navigate((0, $lDZlX.RoutesPath).ProgramBuilder, {
            route: {
                patientId: patient.id
            }
        });
    }, [
        navigate,
        onClick,
        patient.id
    ]);
    const onTemplateButtonClicked = (0, $81g6h.useCallback)(()=>{
        onClick?.(true);
        (0, $lTdpc.isNotNil)(user) && dialogContext?.openModal((0, $243Cr.ModalId).TemplateListing, {
            editor: user,
            onTemplateClicked: async (template)=>{
                const detailedTemplate = await (0, $ghfIB.templateManager).fetchTemplate(template.id);
                const exerciseDetails = (0, $eAmnG.getProgramDetails)(detailedTemplate.days);
                (0, $bC9c0.sendAnalyticsEventUseTemplateForProgram)(patient.analyticsId, template, exerciseDetails, patient.status);
                navigate((0, $lDZlX.RoutesPath).ProgramBuilder, {
                    route: {
                        patientId: patient.id
                    },
                    query: {
                        templateId: template.id
                    }
                });
            }
        });
    }, [
        dialogContext,
        navigate,
        onClick,
        patient,
        user
    ]);
    switch(buttonType){
        case "newOrFromTemplate":
            return /*#__PURE__*/ (0, $iKObn.jsx)((0, $cac12bb981be06b4$export$651ad66661acd392), {
                id: (0, $a6fIt.e2eTestId).patientPage.createProgramButton,
                label: format("patientDetails.patientPrograms.createProgramButton"),
                onClick: onButtonClick,
                model: [
                    {
                        label: format("patientDetails.patientPrograms.createButtonStartFromTemplate"),
                        command: onTemplateButtonClicked
                    }
                ]
            });
        case "fromTemplate":
            return /*#__PURE__*/ (0, $iKObn.jsx)((0, $c22GE.TertiaryButton), {
                onClick: onTemplateButtonClicked,
                label: format("patientDetails.patientPrograms.createButtonStartFromTemplate")
            });
        case "new":
            return /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                id: (0, $a6fIt.e2eTestId).patientPage.createProgramButton,
                label: format("patientDetails.patientPrograms.createProgramButton"),
                onClick: onButtonClick,
                style: {
                    minHeight: "50px"
                }
            });
    }
};



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $bC9c0 = parcelRequire("bC9c0");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5CjOe = parcelRequire("5CjOe");

parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $81g6h = parcelRequire("81g6h");

var $1JaRC = parcelRequire("1JaRC");

var $kKnoQ = parcelRequire("kKnoQ");
var $67c50a2deb906efb$var$NoProgramsIcon = function NoProgramsIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_6561_182627)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask0_6561_182627",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "10",
                        y: "4",
                        width: "45",
                        height: "58",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M47.067 61.45H18.765a7.817 7.817 0 0 1-7.818-7.818v-41.05c0-4.319 3.5-7.818 7.818-7.818h25.191A4.1 4.1 0 0 1 46.87 5.98l6.841 6.924a4.107 4.107 0 0 1 1.183 2.871v37.857c0 4.319-3.5 7.818-7.818 7.818h-.008Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask0_6561_182627)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M34.484 71.436c27.707 0 50.167-22.461 50.167-50.168s-22.46-50.167-50.167-50.167-50.168 22.46-50.168 50.167S6.777 71.436 34.484 71.436Z",
                                fill: "#1B5EC0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M68.817 2.017C75.742 15.55 70.273 36.58 54.033 45.5c-16.24 8.918-37.104 2.358-44.029-11.177C3.08 20.788 8.549-.242 24.788-9.16c16.24-8.918 37.105-2.358 44.03 11.177Z",
                                fill: "#2275F0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M74.616-1.433c4.616 9.025.819 28.972-13.617 37.576-14.437 8.612-34.052 2.622-38.668-6.395-4.617-9.026-.82-28.973 13.617-37.576C50.384-16.441 70-10.451 74.616-1.433Z",
                                fill: "#119CEB"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M76.981-10.352c2.309 4.51.183 23.372-12.45 31.67-12.633 8.297-31 2.887-33.307-1.622-2.309-4.509-.182-23.371 12.45-31.67 12.633-8.297 31-2.886 33.307 1.622Z",
                                fill: "#00C3E5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M53.71 12.896 46.87 5.97a4.1 4.1 0 0 0-2.913-1.216v8.165a3.287 3.287 0 0 0 3.284 3.285h7.645v-.439c0-1.075-.422-2.11-1.183-2.87h.008Z",
                                fill: "#99E8F5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "m21.156 38.576 7.81-7.802 7.024 7.024L46.71 27.076",
                        stroke: "#fff",
                        strokeWidth: "5.394",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M52.947 64.54c6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12-6.627 0-12 5.372-12 12 0 6.627 5.373 12 12 12Z",
                        fill: "#20BB71"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M46.947 54.014h4.75v4.75c0 .346.12.648.361.889.24.24.543.36.89.36.346 0 .648-.12.889-.36.24-.24.36-.543.36-.89v-4.75h4.75c.347 0 .649-.12.89-.36.24-.24.36-.543.36-.89 0-.346-.12-.648-.36-.889-.241-.24-.543-.36-.89-.36h-4.75v-4.75c0-.347-.12-.649-.36-.89-.241-.24-.543-.36-.89-.36-.346 0-.648.12-.889.36-.24.241-.36.543-.36.89v4.75h-4.75c-.347 0-.65.12-.89.36-.24.241-.36.543-.36.89 0 .346.12.648.36.889.24.24.543.36.89.36Z",
                        fill: "#fff",
                        stroke: "#fff",
                        strokeWidth: ".5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_6561_182627",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(.947 .764)",
                        d: "M0 0h64v64H0z"
                    })
                })
            })
        ]
    });
};
$67c50a2deb906efb$var$NoProgramsIcon.defaultProps = {
    width: "65",
    height: "65",
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $67c50a2deb906efb$var$ProgramScheduledIcon = function ProgramScheduledIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M46.719 8.799H19.166a4.844 4.844 0 0 0-4.844 4.843v32.24a4.844 4.844 0 0 0 4.844 4.843h27.553a4.844 4.844 0 0 0 4.844-4.844V13.642A4.844 4.844 0 0 0 46.719 8.8Z",
                fill: "#33009A"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "m51.439 17.146-7.12 21.346a8.397 8.397 0 0 1-7.963 5.745H14.424l.304-12.493 35.663-20.76s1.205 1.656 1.048 6.173v-.011Z",
                fill: "#000"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_222_14191",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "5",
                y: "8",
                width: "46",
                height: "34",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M35.33 41.33H9.04c-2.76 0-4.698-2.703-3.83-5.316l7.355-21.955a7.683 7.683 0 0 1 7.3-5.25H47.09c2.196 0 3.74 2.152 3.041 4.236l-7.784 23.228a7.416 7.416 0 0 1-7.029 5.057h.011Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_222_14191)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M26.995 51.153c14.078 0 25.491-11.413 25.491-25.491C52.486 11.582 41.073.17 26.995.17 12.916.17 1.503 11.583 1.503 25.66c0 14.08 11.413 25.492 25.492 25.492Z",
                        fill: "#4427FA"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M31.613 43.797c12.443 0 22.53-10.086 22.53-22.529 0-12.442-10.087-22.529-22.53-22.529-12.442 0-22.529 10.087-22.529 22.53 0 12.442 10.087 22.528 22.53 22.528Z",
                        fill: "#334EF5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M34.013 33.107c9.282 0 16.806-7.524 16.806-16.806 0-9.283-7.524-16.807-16.806-16.807S17.206 7.018 17.206 16.3c0 9.283 7.524 16.807 16.807 16.807Z",
                        fill: "#2275F0"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M38.518 25.898c7.049 0 12.763-5.714 12.763-12.763 0-7.048-5.714-12.762-12.763-12.762-7.048 0-12.762 5.714-12.762 12.762 0 7.049 5.714 12.763 12.762 12.763Z",
                        fill: "#119CEB"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M41.796 17.427a8.764 8.764 0 1 0 0-17.528 8.764 8.764 0 0 0 0 17.528Z",
                        fill: "#00C3E6"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M19.605 28.343h-2.377a1.484 1.484 0 0 1-1.408-1.96l.62-1.836a1.695 1.695 0 0 1 1.61-1.16h2.378c1.013 0 1.734.99 1.408 1.96l-.62 1.835a1.695 1.695 0 0 1-1.61 1.16ZM27.265 28.343h-2.377a1.484 1.484 0 0 1-1.408-1.96l.62-1.836a1.695 1.695 0 0 1 1.61-1.16h2.377c1.014 0 1.735.99 1.409 1.96l-.62 1.835a1.695 1.695 0 0 1-1.61 1.16ZM34.936 28.343H32.56a1.484 1.484 0 0 1-1.408-1.96l.62-1.836a1.694 1.694 0 0 1 1.61-1.16h2.377c1.014 0 1.735.99 1.409 1.96l-.62 1.835a1.694 1.694 0 0 1-1.61 1.16ZM21.486 21.55H19.11a1.484 1.484 0 0 1-1.408-1.96l.62-1.836a1.695 1.695 0 0 1 1.61-1.16h2.377c1.014 0 1.735.991 1.408 1.96l-.62 1.836a1.694 1.694 0 0 1-1.61 1.16ZM29.157 21.55h-2.376a1.484 1.484 0 0 1-1.408-1.96l.62-1.836a1.694 1.694 0 0 1 1.61-1.16h2.377c1.014 0 1.735.991 1.408 1.96l-.62 1.836a1.694 1.694 0 0 1-1.61 1.16ZM36.817 21.55h-2.376a1.484 1.484 0 0 1-1.409-1.96l.62-1.836a1.694 1.694 0 0 1 1.61-1.16h2.378c1.014 0 1.734.991 1.408 1.96l-.62 1.836a1.694 1.694 0 0 1-1.61 1.16ZM17.465 35.304h-2.377a1.484 1.484 0 0 1-1.408-1.96l.62-1.836a1.694 1.694 0 0 1 1.61-1.16h2.377c1.014 0 1.735.99 1.408 1.96l-.62 1.836a1.694 1.694 0 0 1-1.61 1.16ZM25.136 35.304H22.76a1.484 1.484 0 0 1-1.408-1.96l.62-1.836a1.694 1.694 0 0 1 1.61-1.16h2.377c1.014 0 1.735.99 1.409 1.96l-.62 1.836a1.695 1.695 0 0 1-1.61 1.16ZM32.796 35.304h-2.377a1.484 1.484 0 0 1-1.408-1.96l.62-1.836a1.694 1.694 0 0 1 1.61-1.16h2.377c1.014 0 1.735.99 1.408 1.96l-.62 1.836a1.694 1.694 0 0 1-1.61 1.16Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M23.784 13.597a2.514 2.514 0 0 1-2.512-2.512v-4.01a2.514 2.514 0 0 1 2.512-2.512 2.514 2.514 0 0 1 2.512 2.512v4.01a2.514 2.514 0 0 1-2.512 2.512Z",
                fill: "#33009A"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M23.784 5.126c1.07 0 1.95.88 1.95 1.95v4.01c0 1.07-.88 1.948-1.95 1.948a1.957 1.957 0 0 1-1.948-1.949v-4.01c0-1.07.878-1.949 1.948-1.949Zm0-1.126a3.08 3.08 0 0 0-3.075 3.075v4.01a3.08 3.08 0 0 0 3.075 3.076 3.072 3.072 0 0 0 3.076-3.076v-4.01A3.08 3.08 0 0 0 23.784 4Z",
                fill: "#F2E9FF"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M40.737 13.597a2.514 2.514 0 0 1-2.512-2.512v-4.01a2.514 2.514 0 0 1 2.512-2.512 2.514 2.514 0 0 1 2.512 2.512v4.01a2.514 2.514 0 0 1-2.512 2.512Z",
                fill: "#33009A"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M40.737 5.126c1.07 0 1.95.88 1.95 1.95v4.01c0 1.07-.88 1.948-1.95 1.948a1.957 1.957 0 0 1-1.948-1.949v-4.01c0-1.07.878-1.949 1.948-1.949Zm0-1.126a3.08 3.08 0 0 0-3.075 3.075v4.01a3.08 3.08 0 0 0 3.075 3.076 3.072 3.072 0 0 0 3.076-3.076v-4.01A3.08 3.08 0 0 0 40.737 4Z",
                fill: "#F2E9FF"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M47 60c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z",
                fill: "#00C3E6"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M47 57.569c5.29 0 9.58-4.284 9.58-9.569 0-5.285-4.29-9.569-9.58-9.569s-9.58 4.284-9.58 9.57c0 5.284 4.29 9.568 9.58 9.568Z",
                fill: "#00C3E6"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M51.014 41.99 47 48l4.19 2.483",
                stroke: "#fff",
                strokeWidth: "2.062",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M47.215 40.653a.384.384 0 0 1-.387-.387v-1.618c0-.216.172-.387.387-.387.216 0 .387.171.387.387v1.618a.384.384 0 0 1-.387.387ZM47.215 56.752a.384.384 0 0 1-.387-.387v-1.618c0-.216.172-.387.387-.387.216 0 .387.171.387.387v1.618a.384.384 0 0 1-.387.386ZM56.077 47.89h-1.618a.384.384 0 0 1-.387-.387c0-.215.171-.387.387-.387h1.618c.215 0 .387.172.387.387a.385.385 0 0 1-.387.387ZM39.971 47.89h-1.617a.385.385 0 0 1-.387-.387c0-.215.171-.387.387-.387h1.617c.216 0 .387.172.387.387a.385.385 0 0 1-.387.387Z",
                fill: "#fff"
            })
        ]
    });
};
$67c50a2deb906efb$var$ProgramScheduledIcon.defaultProps = {
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $67c50a2deb906efb$export$3dcf988bf83aecff = ({ patient: patient, style: style, analyticsLocation: analyticsLocation, hasFutureProgram: hasFutureProgram })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const sendCreateProgramEvent = (0, $81g6h.useCallback)((fromTemplate)=>(0, $bC9c0.sendAnalyticsEventCreateProgram)(analyticsLocation, patient.analyticsId, fromTemplate), [
        analyticsLocation,
        patient.analyticsId
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($67c50a2deb906efb$var$EmptyContainer, {
        style: style,
        children: hasFutureProgram ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $5CjOe.MessageContainer), {
            iconSvg: $67c50a2deb906efb$var$ProgramScheduledIcon,
            title: format("patientDetails.progress.noOngoing.title"),
            description: format("patientDetails.progress.empty.description")
        }) : /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $5CjOe.MessageContainer), {
                    iconSvg: $67c50a2deb906efb$var$NoProgramsIcon,
                    title: format("patientDetails.progress.emptyProgram.title")
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $1e9366404357eeaf$export$50f02f9fd2e16e8e), {
                    patient: patient,
                    buttonType: (0, $1e9366404357eeaf$export$62790fc80b39048d).New,
                    onClick: sendCreateProgramEvent
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $1e9366404357eeaf$export$50f02f9fd2e16e8e), {
                    patient: patient,
                    buttonType: (0, $1e9366404357eeaf$export$62790fc80b39048d).FromTemplate,
                    onClick: sendCreateProgramEvent
                })
            ]
        })
    });
};
const $67c50a2deb906efb$var$EmptyContainer = (0, $5UMQ1.default).div`
	inset: 0;
	padding-top: 150px;
	${(0, $5WGN2.stack)(16, "flexstart", "center")};
	z-index: 50;
	margin-bottom: 0 !important;
	background-color: ${(0, $1JaRC.colorWithAlpha)((0, $kKnoQ.colors).white, 0.6)};

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding: 50px 0;
	}
`;



var $9L5pp = parcelRequire("9L5pp");

var $2hf1V = parcelRequire("2hf1V");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $buI4E = parcelRequire("buI4E");

var $81g6h = parcelRequire("81g6h");

var $lLAgw = parcelRequire("lLAgw");
const $9fc405adff9b5da8$export$8cb9e433fd52041e = ({ patient: patient })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { allPatientPrograms: allPatientPrograms, loading: loading, shouldDisplayProgramEndingSoonAlert: shouldDisplayProgramEndingSoonAlert, shouldDisplayProgramEndingNoOngoingAlert: shouldDisplayProgramEndingNoOngoingAlert, refreshAllPrograms: refreshAllPrograms } = (0, $9L5pp.useAllPatientPrograms)(patient);
    const { extendProgram: extendProgram } = (0, $2hf1V.useProgramActions)();
    const truncatedPatientName = (0, $buI4E.truncateString)(patient.firstName, 20);
    const { isMobile: isMobile } = (0, $5kXMA.useDimensions)();
    if (!allPatientPrograms) return loading ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $16481cc1bc2caefe$export$3dfcbcf80c1dbed5), {
        size: (0, $16481cc1bc2caefe$export$dc8a48d838f0e600).FullSpace
    }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
        style: {
            marginTop: 150
        },
        onRefresh: async ()=>{
            await refreshAllPrograms(patient.id);
        }
    });
    const hasNoPrograms = allPatientPrograms.ongoingProgram === undefined && allPatientPrograms.endedPrograms.length === 0 && allPatientPrograms.scheduledPrograms.length === 0 && allPatientPrograms.draftPrograms.length === 0;
    const skeletonProps = {
        active: hasNoPrograms,
        loading: loading
    };
    const shouldHideContent = isMobile && hasNoPrograms;
    let alertContent = null;
    if (shouldDisplayProgramEndingSoonAlert) alertContent = /*#__PURE__*/ (0, $iKObn.jsx)((0, $imaOW.AlertCard), {
        title: format("patientDetails.alert.programEndingSoon.title", {
            patientName: truncatedPatientName
        }),
        message: format("patientDetails.alert.programEndingSoon.message"),
        cardType: (0, $imaOW.CardType).Warn,
        secondaryButtons: [
            {
                title: format("patientDetails.alert.programEndingSoon.button"),
                onPressed: ()=>{
                    if ((0, $lTdpc.isNotNil)(allPatientPrograms.ongoingProgram)) extendProgram((0, $bC9c0.AnalyticsProgramLocation).PROGRAM_TAB, patient.id, patient.analyticsId, allPatientPrograms.ongoingProgram.id, (0, $5SzTW.GlobalProgramStatusType).EndingSoonProgramWithNoNext);
                }
            }
        ]
    });
    else if (shouldDisplayProgramEndingNoOngoingAlert) alertContent = /*#__PURE__*/ (0, $iKObn.jsx)((0, $imaOW.AlertCard), {
        title: format("patientDetails.alert.programEnded.title", {
            patientName: truncatedPatientName
        }),
        message: format("patientDetails.alert.programEnded.message"),
        cardType: (0, $imaOW.CardType).Warn
    });
    return /*#__PURE__*/ (0, $iKObn.jsxs)($9fc405adff9b5da8$var$Container, {
        children: [
            hasNoPrograms && /*#__PURE__*/ (0, $iKObn.jsx)((0, $67c50a2deb906efb$export$3dcf988bf83aecff), {
                patient: patient,
                analyticsLocation: (0, $bC9c0.AnalyticsProgramLocation).PROGRAM_TAB_BOTTOM,
                style: {
                    position: shouldHideContent ? "static" : "absolute"
                }
            }),
            !shouldHideContent && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($9fc405adff9b5da8$var$TabHeaderContainer, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $9gtEr.ConditionalSkeleton), {
                                ...skeletonProps,
                                skeletonStyle: {
                                    borderRadius: "0.5rem"
                                },
                                children: /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                                    className: isMobile ? "p-size-l-bold" : "p-header-3",
                                    children: format("patientDetails.tabs.programs")
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $9gtEr.ConditionalSkeleton), {
                                ...skeletonProps,
                                skeletonStyle: {
                                    borderRadius: "0.5rem"
                                },
                                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $1e9366404357eeaf$export$50f02f9fd2e16e8e), {
                                    patient: patient,
                                    buttonType: (0, $1e9366404357eeaf$export$62790fc80b39048d).NewOrFromTemplate,
                                    onClick: (fromTemplate)=>(0, $bC9c0.sendAnalyticsEventCreateProgram)((0, $bC9c0.AnalyticsProgramLocation).PROGRAM_TAB_TOP, patient.analyticsId, fromTemplate)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $9gtEr.ConditionalSkeleton), {
                        ...skeletonProps,
                        skeletonStyle: {
                            borderRadius: "0.5rem"
                        },
                        children: alertContent
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($9fc405adff9b5da8$var$AllPatientProgramsPanels, {
                        allPatientPrograms: allPatientPrograms,
                        patient: patient,
                        hasNoPrograms: hasNoPrograms,
                        loading: loading
                    })
                ]
            })
        ]
    });
};
const $9fc405adff9b5da8$var$AllPatientProgramsPanels = ({ allPatientPrograms: allPatientPrograms, patient: patient, hasNoPrograms: hasNoPrograms, loading: loading })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { lastProgramAdded: lastProgramAdded, navigateToProgram: navigateToProgram, getProgramCardActions: getProgramCardActions } = (0, $lLAgw.useProgramCard)();
    const { ongoingProgram: ongoingProgram, scheduledPrograms: scheduledPrograms, draftPrograms: draftPrograms, endedPrograms: endedPrograms } = allPatientPrograms;
    const displayProgramCardListing = (0, $81g6h.useCallback)((programs)=>programs.length > 0 && /*#__PURE__*/ (0, $iKObn.jsx)($9fc405adff9b5da8$var$CardsContainer, {
            children: programs.map((program)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $fuvmS.PatientProgramCard), {
                    program: program,
                    cardActions: getProgramCardActions(patient, program),
                    onClick: ()=>navigateToProgram(patient, program),
                    isNew: program.id === lastProgramAdded
                }, program.id))
        }), [
        getProgramCardActions,
        lastProgramAdded,
        navigateToProgram,
        patient
    ]);
    const skeletonProps = {
        active: hasNoPrograms,
        loading: loading
    };
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $81ab56a969b1a9d8$export$aa6e150b47287d7c), {
                ...skeletonProps,
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $i6nFl.Panel), {
                    id: "ongoing",
                    headerText: format("patientDetails.patientPrograms.ongoingPanel.title", {
                        count: ongoingProgram ? 1 : 0
                    }),
                    tooltip: /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                        children: format("patientDetails.patientPrograms.ongoingPanel.tooltip.v1_6")
                    }),
                    showToggleButton: false,
                    children: ongoingProgram && /*#__PURE__*/ (0, $iKObn.jsx)($9fc405adff9b5da8$var$OngoingLayout, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $fuvmS.PatientProgramCard), {
                            program: {
                                ...ongoingProgram,
                                status: (0, $5SzTW.ProgramStatus).Ongoing
                            },
                            cardActions: getProgramCardActions(patient, ongoingProgram),
                            onClick: ()=>navigateToProgram(patient, ongoingProgram),
                            isNew: ongoingProgram.id === lastProgramAdded
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $81ab56a969b1a9d8$export$aa6e150b47287d7c), {
                ...skeletonProps,
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $i6nFl.Panel), {
                    id: "future",
                    headerText: format("patientDetails.patientPrograms.scheduledPanel.title", {
                        count: scheduledPrograms.length
                    }),
                    tooltip: /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                        children: format("patientDetails.patientPrograms.futurePanel.tooltip.v1_6")
                    }),
                    showToggleButton: false,
                    children: displayProgramCardListing(scheduledPrograms)
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $81ab56a969b1a9d8$export$aa6e150b47287d7c), {
                ...skeletonProps,
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $i6nFl.Panel), {
                    id: "draft",
                    headerText: format("patientDetails.patientPrograms.draftPanel.title", {
                        count: draftPrograms.length
                    }),
                    tooltip: /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                        children: format("patientDetails.patientPrograms.draftPanel.tooltip.v1_6")
                    }),
                    showToggleButton: true,
                    children: displayProgramCardListing(draftPrograms)
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $81ab56a969b1a9d8$export$aa6e150b47287d7c), {
                ...skeletonProps,
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $i6nFl.Panel), {
                    id: "former",
                    headerText: format("patientDetails.patientPrograms.endedPanel.title", {
                        count: endedPrograms.length
                    }),
                    tooltip: /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                        children: format("patientDetails.patientPrograms.formerPanel.tooltip.v1_6")
                    }),
                    showToggleButton: true,
                    children: displayProgramCardListing(endedPrograms)
                })
            })
        ]
    });
};
const $9fc405adff9b5da8$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(40, "center", "stretch")};
	flex-grow: 1;
	position: relative;
`;
const $9fc405adff9b5da8$var$TabHeaderContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")};
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		${(0, $5WGN2.stack)(24)};
		margin-top: 8px;
	}
`;
const $9fc405adff9b5da8$var$CardsContainer = (0, $5UMQ1.default).div`
	padding-top: 16px;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
	grid-template-rows: min-content;
	grid-gap: 32px 16px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		grid-gap: 16px 24px;
	}
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		grid-template-columns: 1fr;
	}
`;
const $9fc405adff9b5da8$var$OngoingLayout = (0, $5UMQ1.default)($9fc405adff9b5da8$var$CardsContainer)`
	background-color: ${(0, $kKnoQ.colors).primaryBackground};
	border-radius: 0 0 8px 8px;
	padding: 16px;
`;



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $8zvzh = parcelRequire("8zvzh");

var $bC9c0 = parcelRequire("bC9c0");

var $5SzTW = parcelRequire("5SzTW");

var $5UMQ1 = parcelRequire("5UMQ1");

var $imaOW = parcelRequire("imaOW");

var $dhb7H = parcelRequire("dhb7H");

var $9gtEr = parcelRequire("9gtEr");

var $28f8Y = parcelRequire("28f8Y");

var $1IlhR = parcelRequire("1IlhR");

var $5kXMA = parcelRequire("5kXMA");

var $lDZlX = parcelRequire("lDZlX");


var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $eAmnG = parcelRequire("eAmnG");

var $kXaMn = parcelRequire("kXaMn");
function $e873ac3f9c980cfd$export$70df4193d87353f6(programProgressInPercent, programComplianceInPercent) {
    return {
        programProgressInPercent: programProgressInPercent ?? 0,
        programComplianceInPercent: programComplianceInPercent ?? 80,
        sessionsPerWeek: 4,
        exercisesPerWeek: 10,
        startDate: (0, $kXaMn.now)(),
        endDate: (0, $kXaMn.now)(),
        lastCompletedSession: (0, $kXaMn.now)(),
        completedSessionsCount: 16,
        pastSessionsCount: 20,
        totalSessions: 40
    };
}
function $e873ac3f9c980cfd$export$9aea4776f1775364() {
    const currentDate = (0, $kXaMn.now)();
    const compliancePercentages = [
        100,
        75,
        75,
        0,
        50,
        25,
        75,
        75
    ];
    return $e873ac3f9c980cfd$export$92c48343dae60d6f(currentDate, compliancePercentages);
}
function $e873ac3f9c980cfd$export$92c48343dae60d6f(date, compliancePercentages) {
    return compliancePercentages.map((percentage, i)=>({
            weekIndex: i,
            compliancePercentage: percentage,
            startDate: (0, $kXaMn.now)(),
            endDate: (0, $kXaMn.now)(),
            days: []
        }));
}
function $e873ac3f9c980cfd$export$73b6fb41dad2be6f() {
    const currentDate = (0, $kXaMn.now)();
    return {
        feedbacks: [
            {
                completionDate: (0, $kXaMn.addDaysToDate)(currentDate, -14),
                index: 1,
                exertion: 6,
                mood: 1
            },
            {
                completionDate: (0, $kXaMn.addDaysToDate)(currentDate, -13),
                index: 2,
                exertion: 2,
                mood: 6
            },
            {
                completionDate: (0, $kXaMn.addDaysToDate)(currentDate, -12),
                index: 3,
                exertion: 1,
                mood: 5
            },
            {
                completionDate: (0, $kXaMn.addDaysToDate)(currentDate, -11),
                index: 4,
                exertion: 2,
                mood: 2
            },
            {
                completionDate: (0, $kXaMn.addDaysToDate)(currentDate, -10),
                index: 5,
                exertion: 5,
                mood: 6
            },
            {
                completionDate: (0, $kXaMn.addDaysToDate)(currentDate, -9),
                index: 6,
                exertion: 4,
                mood: 5
            },
            {
                completionDate: (0, $kXaMn.addDaysToDate)(currentDate, -8),
                index: 7,
                exertion: 3,
                mood: 1
            },
            {
                completionDate: (0, $kXaMn.addDaysToDate)(currentDate, -7),
                index: 8,
                exertion: 5,
                mood: 2
            },
            {
                completionDate: (0, $kXaMn.addDaysToDate)(currentDate, -6),
                index: 9,
                exertion: 2,
                mood: 6
            },
            {
                completionDate: (0, $kXaMn.addDaysToDate)(currentDate, -5),
                index: 10,
                exertion: 4,
                mood: 3
            },
            {
                completionDate: (0, $kXaMn.addDaysToDate)(currentDate, -4),
                index: 11,
                exertion: 5,
                mood: 2
            },
            {
                completionDate: (0, $kXaMn.addDaysToDate)(currentDate, -3),
                index: 12,
                exertion: 5,
                mood: 1
            },
            {
                completionDate: (0, $kXaMn.addDaysToDate)(currentDate, -2),
                index: 13,
                exertion: 6,
                mood: 2
            },
            {
                completionDate: (0, $kXaMn.addDaysToDate)(currentDate, -1),
                index: 14,
                exertion: 3,
                mood: 6
            },
            {
                completionDate: currentDate,
                index: 15,
                exertion: 1,
                mood: 1
            }
        ]
    };
}



var $5UMQ1 = parcelRequire("5UMQ1");

var $9gtEr = parcelRequire("9gtEr");

var $jrnUx = parcelRequire("jrnUx");
/* eslint-disable sonarjs/cognitive-complexity */ 
var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $02Kb9 = parcelRequire("02Kb9");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $bl9tw = parcelRequire("bl9tw");

var $1JaRC = parcelRequire("1JaRC");
const $98ddf32ead2c8287$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


const $6b4ea032911028cd$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;



const $be31207e6004abef$export$7d15b64cf5a3a4c4 = (min, max)=>(v)=>Math.max(Math.min(v, max), min);
const $be31207e6004abef$export$83d2e9e3e4ee39ed = (v)=>v % 1 ? Number(v.toFixed(5)) : v;
const $be31207e6004abef$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $be31207e6004abef$export$740b69c5fad25dba = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $be31207e6004abef$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $be31207e6004abef$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $6ea4e82d2224cbda$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $6ea4e82d2224cbda$export$58f0f39f63f3cf42 = Object.assign(Object.assign({}, $6ea4e82d2224cbda$export$98e628dec113755e), {
    transform: (0, $be31207e6004abef$export$7d15b64cf5a3a4c4)(0, 1)
});
const $6ea4e82d2224cbda$export$dcdf75081b88279d = Object.assign(Object.assign({}, $6ea4e82d2224cbda$export$98e628dec113755e), {
    default: 1
});




const $e77d93d26ed382c0$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $be31207e6004abef$export$844ec244b1367d54)(v) && (0, $be31207e6004abef$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $e77d93d26ed382c0$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $be31207e6004abef$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $be31207e6004abef$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $5faaf1bfb8acc567$var$clampRgbUnit = (0, $be31207e6004abef$export$7d15b64cf5a3a4c4)(0, 255);
const $5faaf1bfb8acc567$export$7a99c86b5b1f4c9e = Object.assign(Object.assign({}, (0, $6ea4e82d2224cbda$export$98e628dec113755e)), {
    transform: (v)=>Math.round($5faaf1bfb8acc567$var$clampRgbUnit(v))
});
const $5faaf1bfb8acc567$export$4e46ac54fc82cf3b = {
    test: (0, $e77d93d26ed382c0$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $e77d93d26ed382c0$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $5faaf1bfb8acc567$export$7a99c86b5b1f4c9e.transform(red) + ", " + $5faaf1bfb8acc567$export$7a99c86b5b1f4c9e.transform(green) + ", " + $5faaf1bfb8acc567$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $be31207e6004abef$export$83d2e9e3e4ee39ed)((0, $6ea4e82d2224cbda$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $14b2589cabf9f699$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    } else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $14b2589cabf9f699$export$834dfc94dde4b3d8 = {
    test: (0, $e77d93d26ed382c0$export$2c8400d58aca05e)("#"),
    parse: $14b2589cabf9f699$var$parseHex,
    transform: (0, $5faaf1bfb8acc567$export$4e46ac54fc82cf3b).transform
};



const $b0e4f603587afddd$var$createUnitType = (unit)=>({
        test: (v)=>(0, $be31207e6004abef$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $b0e4f603587afddd$export$41fc368e1a942b97 = $b0e4f603587afddd$var$createUnitType("deg");
const $b0e4f603587afddd$export$626336c2cd4b14de = $b0e4f603587afddd$var$createUnitType("%");
const $b0e4f603587afddd$export$91c0eda1d06bf008 = $b0e4f603587afddd$var$createUnitType("px");
const $b0e4f603587afddd$export$f91e8c45a95a32f2 = $b0e4f603587afddd$var$createUnitType("vh");
const $b0e4f603587afddd$export$aed3d7b7d206c196 = $b0e4f603587afddd$var$createUnitType("vw");
const $b0e4f603587afddd$export$44e2e1705876d7ed = Object.assign(Object.assign({}, $b0e4f603587afddd$export$626336c2cd4b14de), {
    parse: (v)=>$b0e4f603587afddd$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$b0e4f603587afddd$export$626336c2cd4b14de.transform(v * 100)
});




const $0f1a1865893234db$export$810b04175080204c = {
    test: (0, $e77d93d26ed382c0$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $e77d93d26ed382c0$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $b0e4f603587afddd$export$626336c2cd4b14de).transform((0, $be31207e6004abef$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $b0e4f603587afddd$export$626336c2cd4b14de).transform((0, $be31207e6004abef$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $be31207e6004abef$export$83d2e9e3e4ee39ed)((0, $6ea4e82d2224cbda$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};


var $1f94da43c0b83123$export$491112666e282270 = function() {};
var $1f94da43c0b83123$export$f5708dca728d7177 = function() {};


function $29a8ce72ae11d7ec$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $29a8ce72ae11d7ec$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $29a8ce72ae11d7ec$var$hueToRgb(p, q, hue + 1 / 3);
        green = $29a8ce72ae11d7ec$var$hueToRgb(p, q, hue);
        blue = $29a8ce72ae11d7ec$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}


const $ba767867954f5434$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
const $ba767867954f5434$var$colorTypes = [
    (0, $14b2589cabf9f699$export$834dfc94dde4b3d8),
    (0, $5faaf1bfb8acc567$export$4e46ac54fc82cf3b),
    (0, $0f1a1865893234db$export$810b04175080204c)
];
const $ba767867954f5434$var$getColorType = (v)=>$ba767867954f5434$var$colorTypes.find((type)=>type.test(v));
const $ba767867954f5434$var$notAnimatable = (color)=>`'${color}' is not an animatable color. Use the equivalent color code instead.`;
const $ba767867954f5434$export$51e568cf5c039bac = (from, to)=>{
    let fromColorType = $ba767867954f5434$var$getColorType(from);
    let toColorType = $ba767867954f5434$var$getColorType(to);
    (0, $1f94da43c0b83123$export$f5708dca728d7177)(!!fromColorType, $ba767867954f5434$var$notAnimatable(from));
    (0, $1f94da43c0b83123$export$f5708dca728d7177)(!!toColorType, $ba767867954f5434$var$notAnimatable(to));
    let fromColor = fromColorType.parse(from);
    let toColor = toColorType.parse(to);
    if (fromColorType === (0, $0f1a1865893234db$export$810b04175080204c)) {
        fromColor = (0, $29a8ce72ae11d7ec$export$6ae64dbcd6bfc33e)(fromColor);
        fromColorType = (0, $5faaf1bfb8acc567$export$4e46ac54fc82cf3b);
    }
    if (toColorType === (0, $0f1a1865893234db$export$810b04175080204c)) {
        toColor = (0, $29a8ce72ae11d7ec$export$6ae64dbcd6bfc33e)(toColor);
        toColorType = (0, $5faaf1bfb8acc567$export$4e46ac54fc82cf3b);
    }
    const blended = Object.assign({}, fromColor);
    return (v)=>{
        for(const key in blended)if (key !== "alpha") blended[key] = $ba767867954f5434$export$d4ecea248cce73c(fromColor[key], toColor[key], v);
        blended.alpha = (0, $6b4ea032911028cd$export$2c9e8a9632a706b2)(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};






const $21dbdecb4f9c4e54$export$35e9368ef982300f = {
    test: (v)=>(0, $5faaf1bfb8acc567$export$4e46ac54fc82cf3b).test(v) || (0, $14b2589cabf9f699$export$834dfc94dde4b3d8).test(v) || (0, $0f1a1865893234db$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $5faaf1bfb8acc567$export$4e46ac54fc82cf3b).test(v)) return (0, $5faaf1bfb8acc567$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $0f1a1865893234db$export$810b04175080204c).test(v)) return (0, $0f1a1865893234db$export$810b04175080204c).parse(v);
        else return (0, $14b2589cabf9f699$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $be31207e6004abef$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $5faaf1bfb8acc567$export$4e46ac54fc82cf3b).transform(v) : (0, $0f1a1865893234db$export$810b04175080204c).transform(v);
    }
};




const $1274c0e1d343ae01$var$colorToken = "${c}";
const $1274c0e1d343ae01$var$numberToken = "${n}";
function $1274c0e1d343ae01$var$test(v) {
    var _a, _b, _c, _d;
    return isNaN(v) && (0, $be31207e6004abef$export$844ec244b1367d54)(v) && ((_b = (_a = v.match((0, $be31207e6004abef$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match((0, $be31207e6004abef$export$740b69c5fad25dba))) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
}
function $1274c0e1d343ae01$var$analyse(v) {
    if (typeof v === "number") v = `${v}`;
    const values = [];
    let numColors = 0;
    const colors = v.match((0, $be31207e6004abef$export$740b69c5fad25dba));
    if (colors) {
        numColors = colors.length;
        v = v.replace((0, $be31207e6004abef$export$740b69c5fad25dba), $1274c0e1d343ae01$var$colorToken);
        values.push(...colors.map((0, $21dbdecb4f9c4e54$export$35e9368ef982300f).parse));
    }
    const numbers = v.match((0, $be31207e6004abef$export$2444ca58c08448e4));
    if (numbers) {
        v = v.replace((0, $be31207e6004abef$export$2444ca58c08448e4), $1274c0e1d343ae01$var$numberToken);
        values.push(...numbers.map((0, $6ea4e82d2224cbda$export$98e628dec113755e).parse));
    }
    return {
        values: values,
        numColors: numColors,
        tokenised: v
    };
}
function $1274c0e1d343ae01$var$parse(v) {
    return $1274c0e1d343ae01$var$analyse(v).values;
}
function $1274c0e1d343ae01$var$createTransformer(v) {
    const { values: values, numColors: numColors, tokenised: tokenised } = $1274c0e1d343ae01$var$analyse(v);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++)output = output.replace(i < numColors ? $1274c0e1d343ae01$var$colorToken : $1274c0e1d343ae01$var$numberToken, i < numColors ? (0, $21dbdecb4f9c4e54$export$35e9368ef982300f).transform(v[i]) : (0, $be31207e6004abef$export$83d2e9e3e4ee39ed)(v[i]));
        return output;
    };
}
const $1274c0e1d343ae01$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $1274c0e1d343ae01$var$getAnimatableNone(v) {
    const parsed = $1274c0e1d343ae01$var$parse(v);
    const transformer = $1274c0e1d343ae01$var$createTransformer(v);
    return transformer(parsed.map($1274c0e1d343ae01$var$convertNumbersToZero));
}
const $1274c0e1d343ae01$export$83a0e34f1302825b = {
    test: $1274c0e1d343ae01$var$test,
    parse: $1274c0e1d343ae01$var$parse,
    createTransformer: $1274c0e1d343ae01$var$createTransformer,
    getAnimatableNone: $1274c0e1d343ae01$var$getAnimatableNone
};




const $5cb05c0bfc014c1c$export$c0c148ccc4f34a76 = {
    x: 0,
    y: 0,
    z: 0
};
const $5cb05c0bfc014c1c$export$4e960b977ccfec97 = (v)=>typeof v === "number";


const $044ec9ee455dd786$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $044ec9ee455dd786$export$a4627e546088548d = (...transformers)=>transformers.reduce($044ec9ee455dd786$var$combineFunctions);



function $4530adaf1271525e$var$getMixer(origin, target) {
    if ((0, $5cb05c0bfc014c1c$export$4e960b977ccfec97)(origin)) return (v)=>(0, $6b4ea032911028cd$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $21dbdecb4f9c4e54$export$35e9368ef982300f).test(origin)) return (0, $ba767867954f5434$export$51e568cf5c039bac)(origin, target);
    else return $4530adaf1271525e$export$65516310a87d8205(origin, target);
}
const $4530adaf1271525e$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$4530adaf1271525e$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $4530adaf1271525e$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = Object.assign(Object.assign({}, origin), target);
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $4530adaf1271525e$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
function $4530adaf1271525e$var$analyse(value) {
    const parsed = (0, $1274c0e1d343ae01$export$83a0e34f1302825b).parse(value);
    const numValues = parsed.length;
    let numNumbers = 0;
    let numRGB = 0;
    let numHSL = 0;
    for(let i = 0; i < numValues; i++){
        if (numNumbers || typeof parsed[i] === "number") numNumbers++;
        else if (parsed[i].hue !== undefined) numHSL++;
        else numRGB++;
    }
    return {
        parsed: parsed,
        numNumbers: numNumbers,
        numRGB: numRGB,
        numHSL: numHSL
    };
}
const $4530adaf1271525e$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $1274c0e1d343ae01$export$83a0e34f1302825b).createTransformer(target);
    const originStats = $4530adaf1271525e$var$analyse(origin);
    const targetStats = $4530adaf1271525e$var$analyse(target);
    const canInterpolate = originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $044ec9ee455dd786$export$a4627e546088548d)($4530adaf1271525e$export$3bbefa2f402845c4(originStats.parsed, targetStats.parsed), template);
    else {
        (0, $1f94da43c0b83123$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (p)=>`${p > 0 ? target : origin}`;
    }
};



const $7a6ab477628e602c$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);




const $795048fe965d5869$var$mixNumber = (from, to)=>(p)=>(0, $6b4ea032911028cd$export$2c9e8a9632a706b2)(from, to, p);
function $795048fe965d5869$var$detectMixerFactory(v) {
    if (typeof v === "number") return $795048fe965d5869$var$mixNumber;
    else if (typeof v === "string") {
        if ((0, $21dbdecb4f9c4e54$export$35e9368ef982300f).test(v)) return 0, $ba767867954f5434$export$51e568cf5c039bac;
        else return 0, $4530adaf1271525e$export$65516310a87d8205;
    } else if (Array.isArray(v)) return 0, $4530adaf1271525e$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $4530adaf1271525e$export$ebc23b6840c51ba1;
}
function $795048fe965d5869$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $795048fe965d5869$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = (0, $044ec9ee455dd786$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function $795048fe965d5869$var$fastInterpolate([from, to], [mixer]) {
    return (v)=>mixer((0, $98ddf32ead2c8287$export$504d7abb21fa8c9)(from, to, v));
}
function $795048fe965d5869$var$slowInterpolate(input, mixers) {
    const inputLength = input.length;
    const lastInputIndex = inputLength - 1;
    return (v)=>{
        let mixerIndex = 0;
        let foundMixerIndex = false;
        if (v <= input[0]) foundMixerIndex = true;
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            let i = 1;
            for(; i < inputLength; i++){
                if (input[i] > v || i === lastInputIndex) break;
            }
            mixerIndex = i - 1;
        }
        const progressInRange = (0, $98ddf32ead2c8287$export$504d7abb21fa8c9)(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function $795048fe965d5869$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $1f94da43c0b83123$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    (0, $1f94da43c0b83123$export$f5708dca728d7177)(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    const mixers = $795048fe965d5869$var$createMixers(output, ease, mixer);
    const interpolator = inputLength === 2 ? $795048fe965d5869$var$fastInterpolate(input, mixers) : $795048fe965d5869$var$slowInterpolate(input, mixers);
    return isClamp ? (v)=>interpolator((0, $7a6ab477628e602c$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}



var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $cfkGk = parcelRequire("cfkGk");
"use client";
var $18168ccb941e5878$var$ChartBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Chart",
        id: null,
        type: null,
        data: null,
        options: null,
        plugins: null,
        width: null,
        height: null,
        style: null,
        className: null,
        children: undefined
    },
    css: {
        classes: {
            root: "p-chart"
        },
        inlineStyles: {
            root: function root(_ref) {
                var props = _ref.props;
                return Object.assign({
                    width: props.width,
                    height: props.height
                }, props.style);
            }
        },
        styles: "\n        @layer primereact {\n            .p-chart {\n                position: relative\n            }\n        }\n        "
    }
});
// GitHub #3059 wrapper if loaded by script tag
var $18168ccb941e5878$var$ChartJS = function() {
    try {
        return Chart;
    } catch (_unused) {
        return null;
    }
}();

var $18168ccb941e5878$export$acaa6426d77a227e = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $18168ccb941e5878$var$ChartBase.getProps(inProps, context);
    var _ChartBase$setMetaDat = $18168ccb941e5878$var$ChartBase.setMetaData({
        props: props
    }), ptm = _ChartBase$setMetaDat.ptm, cx = _ChartBase$setMetaDat.cx, sx = _ChartBase$setMetaDat.sx, isUnstyled = _ChartBase$setMetaDat.isUnstyled;
    (0, $4gQLd.useHandleStyle)($18168ccb941e5878$var$ChartBase.css.styles, isUnstyled, {
        name: "chart"
    });
    var elementRef = $81g6h.useRef(null);
    var chartRef = $81g6h.useRef(null);
    var canvasRef = $81g6h.useRef(null);
    var initChart = function initChart() {
        destroyChart();
        var configuration = {
            type: props.type,
            data: props.data,
            options: props.options,
            plugins: props.plugins
        };
        if ($18168ccb941e5878$var$ChartJS) // GitHub #3059 loaded by script only
        chartRef.current = new $18168ccb941e5878$var$ChartJS(canvasRef.current, configuration);
        else (parcelRequire("9tyB9")).then(function(module) {
            destroyChart();
            // In case that the Chart component has been unmounted during asynchronous loading of ChartJS,
            // the canvasRef will not be available anymore, and no Chart should be created.
            if (!canvasRef.current) return;
            if (module) {
                if (module["default"]) // WebPack
                chartRef.current = new module["default"](canvasRef.current, configuration);
                else // ParcelJS
                chartRef.current = new module(canvasRef.current, configuration);
            }
        });
    };
    var destroyChart = function destroyChart() {
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            getCanvas: function getCanvas() {
                return canvasRef.current;
            },
            getChart: function getChart() {
                return chartRef.current;
            },
            getBase64Image: function getBase64Image() {
                return chartRef.current.toBase64Image();
            },
            getElement: function getElement() {
                return elementRef.current;
            },
            generateLegend: function generateLegend() {
                return chartRef.current && chartRef.current.generateLegend();
            },
            refresh: function refresh() {
                return chartRef.current && chartRef.current.update();
            }
        };
    });
    $81g6h.useEffect(function() {
        initChart();
    });
    (0, $l2NC0.useUnmountEffect)(function() {
        destroyChart();
    });
    var title = props.options && props.options.plugins && props.options.plugins.title && props.options.plugins.title.text;
    var ariaLabel = props.ariaLabel || title;
    var rootProps = mergeProps({
        id: props.id,
        ref: elementRef,
        style: sx("root"),
        className: (0, $cfkGk.classNames)(props.className, cx("root"))
    }, $18168ccb941e5878$var$ChartBase.getOtherProps(props), ptm("root"));
    var canvasProps = mergeProps({
        ref: canvasRef,
        width: props.width,
        height: props.height,
        role: "img",
        "aria-label": ariaLabel
    }, ptm("canvas"));
    return /*#__PURE__*/ $81g6h.createElement("div", rootProps, /*#__PURE__*/ $81g6h.createElement("canvas", canvasProps));
}), function(prevProps, nextProps) {
    return prevProps.data === nextProps.data && prevProps.options === nextProps.options && prevProps.type === nextProps.type;
});
$18168ccb941e5878$export$acaa6426d77a227e.displayName = "Chart";



var $81g6h = parcelRequire("81g6h");
const $7fd210307fec9699$export$614db49f3febe941 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ id: id, scale: scale, data: data, displayScales: displayScales = true, uiTheme: uiTheme = "cold", displayLineOnHover: displayLineOnHover, formatValue: formatValue, renderDotTooltipContent: renderDotTooltipContent, formatScaleYTooltip: formatScaleYTooltip, formatScaleY: formatScaleY, formatScaleX: formatScaleX, onDataHover: onDataHover, onDotTooltipHide: onDotTooltipHide }, ref)=>{
    const canvasContextRef = (0, $81g6h.useRef)(null);
    const [tooltip, setTooltip] = (0, $81g6h.useState)({
        position: {
            x: 0,
            y: 0
        },
        displayed: false,
        data: {
            dataIndex: 0,
            yValue: data[0] ?? scale.y.min
        }
    });
    const xTicks = scale.x.tick ?? scale.x.max - scale.x.min + 1;
    const yTicks = scale.y.tick ?? scale.y.max - scale.y.min + 1;
    const formatYValue = (0, $81g6h.useCallback)((v)=>formatValue?.(v) ?? v.toString(), [
        formatValue
    ]);
    const xAxisData = (0, $81g6h.useMemo)(()=>Array.from({
            length: xTicks
        }, (_, i)=>scale.x.min + i), [
        scale.x.min,
        xTicks
    ]);
    const graphData = (0, $81g6h.useMemo)(()=>$7fd210307fec9699$var$getGraphData(xAxisData, data, canvasContextRef, uiTheme, scale.y), [
        xAxisData,
        data,
        uiTheme,
        scale.y
    ]);
    const graphOptions = (0, $81g6h.useMemo)(()=>{
        const changeTooltip = (t)=>{
            if (displayScales) {
                setTooltip(t);
                if (t.displayed) onDataHover?.(t.data.dataIndex);
                else onDotTooltipHide?.(t.data.dataIndex);
            }
        };
        return $7fd210307fec9699$var$getGraphOptions(scale.y, displayScales, formatYValue, changeTooltip, formatScaleX);
    }, [
        displayScales,
        formatScaleX,
        formatYValue,
        onDataHover,
        onDotTooltipHide,
        scale.y
    ]);
    const plugins = (0, $81g6h.useMemo)(()=>displayLineOnHover ? $7fd210307fec9699$var$drawVerticalLinePlugin() : undefined, [
        displayLineOnHover
    ]);
    const renderTooltip = (0, $81g6h.useCallback)(()=>{
        if (!renderDotTooltipContent) return null;
        const ratio = tooltip.data.dataIndex / xTicks;
        const tooltipPosition = $7fd210307fec9699$var$getTooltipPosition(ratio);
        return /*#__PURE__*/ (0, $iKObn.jsx)($7fd210307fec9699$var$StyledTooltip, {
            visible: tooltip.displayed,
            content: renderDotTooltipContent(xAxisData[tooltip.data.dataIndex], data[tooltip.data.dataIndex]),
            placement: tooltipPosition,
            children: /*#__PURE__*/ (0, $iKObn.jsx)($7fd210307fec9699$var$StyledCircle, {
                data: tooltip
            })
        });
    }, [
        data,
        renderDotTooltipContent,
        tooltip,
        xAxisData,
        xTicks
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($7fd210307fec9699$var$GraphSectionContent, {
        className: `graph-${id}`,
        displayScales: displayScales,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($7fd210307fec9699$var$InternalGraph, {
                ref: ref,
                data: graphData,
                options: graphOptions,
                plugins: plugins,
                displayScales: displayScales
            }),
            displayScales && formatScaleYTooltip && /*#__PURE__*/ (0, $iKObn.jsx)($7fd210307fec9699$var$ScaleY, {
                children: Array.from({
                    length: yTicks
                }, (_, i)=>scale.y.min + i * (scale.y.max - scale.y.min) / (yTicks - 1)).reverse().map((value)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $81g6h.Fragment), {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $02Kb9.Tooltip), {
                            content: formatScaleYTooltip(value),
                            placement: "right",
                            allowHTML: true,
                            children: /*#__PURE__*/ (0, $iKObn.jsx)($7fd210307fec9699$var$ScaleYTick, {
                                visible: !!formatScaleY,
                                className: `p-size-xs scale-y-${id}-${value}`,
                                children: formatScaleY?.(value) ?? formatYValue(value)
                            }, value)
                        })
                    }, `${id}-${value}`))
            }),
            renderTooltip()
        ]
    });
});
$7fd210307fec9699$export$614db49f3febe941.displayName = "Graph";
const $7fd210307fec9699$var$InternalGraph = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $iKObn.jsx)($7fd210307fec9699$var$GraphContent, {
        ref: ref,
        id: "chart",
        type: "line",
        ...props
    })));
$7fd210307fec9699$var$InternalGraph.displayName = "InternalGraph";
const $7fd210307fec9699$var$GraphSectionContent = (0, $5UMQ1.default).div`
	position: relative;
	height: 244px;
	margin-top: ${({ displayScales: displayScales })=>displayScales ? 24 : 30}px;
	margin-left: ${({ displayScales: displayScales })=>displayScales ? 24 : 64}px;
	margin-right: 24px;
	margin-bottom: ${({ displayScales: displayScales })=>displayScales ? 16 : 46}px;
`;
const $7fd210307fec9699$var$GraphContent = (0, $5UMQ1.default)((0, $18168ccb941e5878$export$acaa6426d77a227e))`
	position: relative;
	height: 100%;
	width: 100%;

	canvas {
		position: relative;
		width: 100% !important;
		height: 100% !important;
	}
`;
const $7fd210307fec9699$var$ScaleY = (0, $5UMQ1.default).div`
	position: absolute;
	margin-left: -16px;
	width: 40px;
	top: 6px;
	left: 0;
	height: 207px;
	${(0, $5WGN2.stack)(undefined, "spacebetween", "center")};
`;
const $7fd210307fec9699$var$ScaleYTick = (0, $5UMQ1.default).div`
	opacity: ${({ visible: visible })=>visible ? 1 : 0};
	cursor: pointer;
	line-height: 1;
`;
const $7fd210307fec9699$var$getTooltipPosition = (ratio)=>{
    if (ratio < 0.33) return "right";
    if (ratio > 0.67) return "left";
    return "bottom";
};
const $7fd210307fec9699$var$StyledTooltip = (0, $5UMQ1.default)((0, $02Kb9.Tooltip))`
	white-space: pre-line;
`;
const $7fd210307fec9699$var$CIRCLE_RADIUS = 8;
const $7fd210307fec9699$var$StyledCircle = (0, $5UMQ1.default).div`
	left: ${({ data: data })=>data.position.x - $7fd210307fec9699$var$CIRCLE_RADIUS}px;
	top: ${({ data: data })=>data.position.y - $7fd210307fec9699$var$CIRCLE_RADIUS}px;
	position: absolute;
	width: ${$7fd210307fec9699$var$CIRCLE_RADIUS * 2}px;
	height: ${$7fd210307fec9699$var$CIRCLE_RADIUS * 2}px;
	pointer-events: none;
	touch-action: none;
	border-radius: ${$7fd210307fec9699$var$CIRCLE_RADIUS}px;
`;
function $7fd210307fec9699$var$getNewCanvasContext(ctx, chartArea, currentContext, uiTheme) {
    const chartWidth = chartArea.right - chartArea.left;
    const chartHeight = chartArea.bottom - chartArea.top;
    if (currentContext?.width !== chartWidth || currentContext.height !== chartHeight) {
        // Create the gradient because this is either the first render
        // or the size of the chart has changed
        const gradientColor = (0, $kKnoQ.colors).primary25;
        const firstColor = uiTheme === "hot" ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).rejection;
        const secondColor = uiTheme === "hot" ? (0, $kKnoQ.colors).rejection : (0, $kKnoQ.colors).primary;
        const backgroundGradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
        if (uiTheme === "cold") {
            backgroundGradient.addColorStop(0, (0, $1JaRC.colorWithAlpha)(gradientColor, 0));
            backgroundGradient.addColorStop(1, (0, $1JaRC.colorWithAlpha)(gradientColor, 0.4));
        } else {
            backgroundGradient.addColorStop(0, (0, $1JaRC.colorWithAlpha)(firstColor, 0));
            backgroundGradient.addColorStop(1, (0, $1JaRC.colorWithAlpha)(secondColor, 0.16));
        }
        const lineGradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
        lineGradient.addColorStop(0, (0, $1JaRC.colorWithAlpha)(firstColor, 0.6));
        lineGradient.addColorStop(1, (0, $1JaRC.colorWithAlpha)(secondColor, 0.6));
        return {
            backgroundGradient: backgroundGradient,
            lineGradient: lineGradient,
            width: chartWidth,
            height: chartHeight
        };
    }
    return currentContext;
}
function $7fd210307fec9699$var$getGraphData(xAxisLabels, data, canvasContextRef, uiTheme, yScale) {
    const getPointColor = (context)=>{
        const index = context.dataIndex;
        const value = context.dataset.data[index];
        const firstColor = uiTheme === "hot" ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).rejection;
        const secondColor = uiTheme === "hot" ? (0, $kKnoQ.colors).rejection : (0, $kKnoQ.colors).primary;
        return uiTheme === "cold" ? (0, $kKnoQ.colors).primary : (0, $795048fe965d5869$export$89e29e4ab65e70a9)([
            yScale.min,
            yScale.max
        ], [
            firstColor,
            secondColor
        ])(value);
    };
    const emptyDataSet = data.includes(null) ? data.map((v)=>v === null ? (yScale.max - yScale.min) / 2 + yScale.min : null) : null;
    return {
        labels: xAxisLabels,
        datasets: [
            {
                data: data,
                borderColor: uiTheme === "cold" ? (0, $kKnoQ.colors).primary25 : (context)=>{
                    const { ctx: ctx, chartArea: chartArea } = context.chart;
                    if (!chartArea) // This case happens on initial chart load
                    return;
                    const newContext = $7fd210307fec9699$var$getNewCanvasContext(ctx, chartArea, canvasContextRef.current, uiTheme);
                    canvasContextRef.current = newContext;
                    return newContext.lineGradient;
                },
                tension: 0.4,
                backgroundColor: (context)=>{
                    const { ctx: ctx, chartArea: chartArea } = context.chart;
                    if (!chartArea) // This case happens on initial chart load
                    return;
                    const newContext = $7fd210307fec9699$var$getNewCanvasContext(ctx, chartArea, canvasContextRef.current, uiTheme);
                    canvasContextRef.current = newContext;
                    return newContext.backgroundGradient;
                },
                fill: true,
                borderWidth: 4,
                pointStyle: "circle",
                pointRadius: 6,
                pointHoverRadius: 8,
                pointHitRadius: 12,
                pointBackgroundColor: getPointColor,
                pointHoverBackgroundColor: (0, $kKnoQ.colors).white,
                pointHoverBorderColor: getPointColor,
                pointBorderColor: (0, $kKnoQ.colors).white,
                pointBorderWidth: 1,
                pointHoverBorderWidth: 2
            },
            ...!emptyDataSet ? [] : [
                {
                    data: emptyDataSet,
                    borderWidth: 4,
                    pointStyle: "circle",
                    pointRadius: 6,
                    pointHoverRadius: 8,
                    pointHitRadius: 12,
                    pointBackgroundColor: (0, $kKnoQ.colors).grey50,
                    pointHoverBackgroundColor: (0, $kKnoQ.colors).grey50,
                    pointBorderWidth: 0,
                    showLine: false
                }
            ]
        ]
    };
}
function $7fd210307fec9699$var$getGraphOptions(scaleY, displayScales, formatValue, onTooltipChange, formatScaleX) {
    return {
        maintainAspectRatio: false,
        aspectRatio: 0.3,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: false,
                external: ({ tooltip: tooltip })=>{
                    onTooltipChange({
                        position: {
                            x: tooltip.caretX,
                            y: tooltip.caretY
                        },
                        displayed: tooltip.opacity !== 0,
                        data: {
                            dataIndex: tooltip.dataPoints[0].parsed.x,
                            yValue: tooltip.dataPoints[0].parsed.y
                        }
                    });
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    display: displayScales,
                    color: (0, $kKnoQ.colors).grey,
                    font: {
                        size: 12,
                        family: (0, $bl9tw.fonts).body,
                        weight: "600"
                    },
                    padding: 8,
                    callback: formatScaleX ? (index)=>formatScaleX(index) : undefined,
                    maxRotation: 0
                },
                grid: {
                    display: false
                },
                border: {
                    display: false
                }
            },
            y: {
                ticks: {
                    display: displayScales,
                    color: (0, $kKnoQ.colors).black,
                    padding: 8,
                    crossAlign: "far",
                    showLabelBackdrop: true,
                    count: scaleY.tick ?? scaleY.max - scaleY.min + 1,
                    font: {
                        size: 12,
                        family: (0, $bl9tw.fonts).body,
                        weight: "600"
                    },
                    callback: (value)=>formatValue(value)
                },
                grid: {
                    color: (0, $kKnoQ.colors).grey25,
                    lineWidth: 2,
                    drawTicks: false
                },
                border: {
                    dash: [
                        6,
                        16
                    ],
                    display: false
                },
                suggestedMin: scaleY.min,
                suggestedMax: scaleY.max
            }
        }
    };
}
function $7fd210307fec9699$var$drawVerticalLinePlugin() {
    const drawVerticalLine = (chart)=>{
        if (chart.tooltip._active.length) {
            const x = chart.tooltip._active[0].element.x;
            const yAxis = chart.scales.y;
            const ctx = chart.ctx;
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x, yAxis.top);
            ctx.lineTo(x, yAxis.bottom);
            ctx.lineWidth = 2;
            ctx.strokeStyle = (0, $kKnoQ.colors).grey25;
            ctx.stroke();
            ctx.restore();
        }
    };
    return [
        {
            beforeDraw: drawVerticalLine
        }
    ];
}



var $ghfIB = parcelRequire("ghfIB");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
function $5fc77be801ae305c$export$efdbec2abacbbb18(patientId, programId, withFetch = true) {
    const [loading, setLoading] = (0, $81g6h.useState)(withFetch && !!programId);
    const progressData = (0, $1IWnK.useComputedObservable)(()=>programId ? (0, $ghfIB.progressDataManager).progressDataByPatient.get().get(patientId)?.get(programId) : undefined, [
        patientId,
        programId
    ]);
    (0, $81g6h.useEffect)(()=>{
        const getProgressData = async (patientIdToFetch, programIdToFetch)=>{
            try {
                setLoading(true);
                await (0, $ghfIB.progressDataManager).fetchProgressData(patientIdToFetch, programIdToFetch);
            } catch (e) {
                console.error(e);
            } finally{
                setLoading(false);
            }
        };
        withFetch && programId && getProgressData(patientId, programId);
    }, [
        patientId,
        programId,
        withFetch
    ]);
    return {
        loading: loading,
        progressData: progressData
    };
}
function $5fc77be801ae305c$export$829710f02022784e(patientId, programId, withFetch = true) {
    const [loading, setLoading] = (0, $81g6h.useState)(withFetch && !!programId);
    const complianceGraphData = (0, $1IWnK.useComputedObservable)(()=>programId ? (0, $ghfIB.progressDataManager).complianceGraphDataByPatient.get().get(patientId)?.get(programId) : undefined, [
        patientId,
        programId
    ]);
    (0, $81g6h.useEffect)(()=>{
        const getComplianceGraphData = async (patientIdToFetch, programIdToFetch)=>{
            try {
                setLoading(true);
                await (0, $ghfIB.progressDataManager).fetchComplianceGraphData(patientIdToFetch, programIdToFetch);
            } catch (e) {
                console.error(e);
            } finally{
                setLoading(false);
            }
        };
        withFetch && programId && getComplianceGraphData(patientId, programId);
    }, [
        patientId,
        programId,
        withFetch
    ]);
    return {
        loading: loading,
        complianceGraphData: complianceGraphData
    };
}
function $5fc77be801ae305c$export$31429d028a2265b9(patientId, programId, withFetch = true) {
    const [loading, setLoading] = (0, $81g6h.useState)(withFetch && !!programId);
    const feedbackGraphData = (0, $1IWnK.useComputedObservable)(()=>programId ? (0, $ghfIB.progressDataManager).feedbackGraphDataByPatient.get().get(patientId)?.get(programId) : undefined, [
        patientId,
        programId
    ]);
    (0, $81g6h.useEffect)(()=>{
        const getFeedbackGraphData = async (patientIdToFetch, programIdToFetch)=>{
            try {
                setLoading(true);
                await (0, $ghfIB.progressDataManager).fetchFeedbackGraphData(patientIdToFetch, programIdToFetch);
            } catch (e) {
                console.error(e);
            } finally{
                setLoading(false);
            }
        };
        withFetch && programId && getFeedbackGraphData(patientId, programId);
    }, [
        patientId,
        programId,
        withFetch
    ]);
    return {
        loading: loading,
        feedbackGraphData: feedbackGraphData
    };
}


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");
var $fb772db1135f6866$var$CrossIcon = function CrossIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M6.14 5.302a.836.836 0 0 0-.583 1.435l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26a.834.834 0 0 0 1.377-.263.836.836 0 0 0-.195-.919L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 0 0-.6-.254Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.14 5.015a1.123 1.123 0 0 1 .803.338L12 10.41l5.057-5.057a1.123 1.123 0 1 1 1.588 1.589l-5.057 5.056 5.056 5.056c.107.103.192.226.251.363l-.263.114a.836.836 0 0 0-.189-.272L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 1 0-1.182 1.181l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26c.077.08.17.145.271.189l-.114.263a1.124 1.124 0 0 1-.362-.25L12 13.585l-5.056 5.056a1.123 1.123 0 1 1-1.588-1.588l5.056-5.056-5.057-5.056a1.123 1.123 0 0 1 .785-1.927ZM17.532 18.63a.834.834 0 0 0 1.168-.776.836.836 0 0 0-.068-.323l.263-.114a1.125 1.125 0 0 1-1.477 1.476l.114-.263Z",
                fill: "currentColor"
            })
        ]
    });
};
$fb772db1135f6866$var$CrossIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $fb772db1135f6866$var$NUMBER_OF_WEEKS_DISPLAYED = 8;
const $fb772db1135f6866$var$EMPTY_X_LABEL_VALUE = "";
const $fb772db1135f6866$var$SCALE = {
    x: {
        min: 0,
        max: $fb772db1135f6866$var$NUMBER_OF_WEEKS_DISPLAYED - 1
    },
    y: {
        min: 0,
        max: 100,
        tick: 5
    }
};
const $fb772db1135f6866$export$f6394e24454722bb = ({ patientId: patientId, programId: programId, isEmpty: isEmpty, isLoading: isLoading })=>{
    const { loading: loading, complianceGraphData: complianceGraphData } = (0, $5fc77be801ae305c$export$829710f02022784e)(patientId, programId);
    const definedComplianceGraphData = (0, $81g6h.useMemo)(()=>complianceGraphData ?? (0, $e873ac3f9c980cfd$export$9aea4776f1775364)(), [
        complianceGraphData
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($fb772db1135f6866$var$ComplianceGraphView, {
        isEmpty: isEmpty,
        isLoading: isLoading || complianceGraphData === undefined && loading || !!programId && complianceGraphData === undefined,
        complianceGraphData: definedComplianceGraphData
    });
};
const $fb772db1135f6866$var$ComplianceGraphView = ({ complianceGraphData: complianceGraphData, isEmpty: isEmpty, isLoading: isLoading = false })=>{
    const { format: format, formatPercent: formatPercent } = (0, $1eHG3.useI18n)();
    const skeletonProps = {
        active: isEmpty || isLoading,
        loading: isLoading
    };
    const displayScales = (0, $81g6h.useMemo)(()=>!isLoading && !isEmpty, [
        isEmpty,
        isLoading
    ]);
    const data = (0, $81g6h.useMemo)(()=>complianceGraphData.map((week)=>week.compliancePercentage), [
        complianceGraphData
    ]);
    const formatDotTooltip = (0, $81g6h.useCallback)((x)=>/*#__PURE__*/ (0, $iKObn.jsxs)($fb772db1135f6866$var$TooltipContent, {
            children: [
                format("patientDetails.progress.complianceGraphSection.tooltip.v1_6", {
                    x: complianceGraphData[x]?.weekIndex
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)($fb772db1135f6866$var$TooltipDays, {
                    children: complianceGraphData[x]?.days.map((day)=>/*#__PURE__*/ (0, $iKObn.jsx)($fb772db1135f6866$var$DayChecked, {
                            dayIndex: day.day,
                            checked: day.completed
                        }, day.day))
                })
            ]
        }), [
        complianceGraphData,
        format
    ]);
    const formatScaleX = (0, $81g6h.useCallback)((x)=>{
        const week = complianceGraphData[x];
        if ((0, $lTdpc.isNil)(week)) return $fb772db1135f6866$var$EMPTY_X_LABEL_VALUE;
        const { startDate: startDate, endDate: endDate } = week;
        return format("patientDetails.progress.complianceGraphSection.graphXAxisDate.oneMonth", {
            month: startDate.format("MMM"),
            day1: startDate.format("DD"),
            day2: endDate.format("DD")
        });
    }, [
        complianceGraphData,
        format
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($fb772db1135f6866$var$Section, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($fb772db1135f6866$var$HeaderContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $jrnUx.ContentWithTooltip), {
                        tooltip: format("patientDetails.progress.complianceSection.tooltip.v2_0"),
                        skeleton: skeletonProps.active ? skeletonProps : undefined,
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                            className: "p-size-m-bold",
                            children: format("patientDetails.progress.complianceGraphSection.title")
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $9gtEr.ConditionalSkeleton), {
                        ...skeletonProps,
                        skeletonStyle: {
                            borderRadius: 4
                        },
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($fb772db1135f6866$var$Cta, {
                            className: "p-size-xs-semi-bold",
                            children: format("patientDetails.progress.complianceGraphSection.scaleCta")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($fb772db1135f6866$var$GraphContainer, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $7fd210307fec9699$export$614db49f3febe941), {
                    id: "compliance",
                    displayScales: displayScales,
                    scale: $fb772db1135f6866$var$SCALE,
                    data: data,
                    renderDotTooltipContent: formatDotTooltip,
                    formatValue: formatPercent,
                    formatScaleX: formatScaleX
                })
            })
        ]
    });
};
const $fb772db1135f6866$var$Section = (0, $5UMQ1.default).section`
	${(0, $5WGN2.stack)(16, undefined, "stretch")}
`;
const $fb772db1135f6866$var$HeaderContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")};
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		flex-direction: column;
		align-items: flex-start;
		gap: 8px;
	}
`;
const $fb772db1135f6866$var$Cta = (0, $5UMQ1.default).div`
	padding: 4px 8px;
	border-radius: 4px;
	background-color: ${(0, $kKnoQ.colors).grey10};
	color: ${(0, $kKnoQ.colors).grey};
`;
const $fb772db1135f6866$var$TooltipContent = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)()};
`;
const $fb772db1135f6866$var$TooltipDays = (0, $5UMQ1.default).div`
	display: grid;
	grid-template-columns: auto 1fr;
`;
const $fb772db1135f6866$var$DayChecked = ({ dayIndex: dayIndex, checked: checked })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                className: "p-size-xs-semi-bold",
                children: (0, $eAmnG.formatDayColumn)(dayIndex, "short")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($fb772db1135f6866$var$DayContainer, {
                children: checked ? /*#__PURE__*/ (0, $iKObn.jsx)("i", {
                    className: "pi pi-check",
                    style: {
                        color: (0, $kKnoQ.colors).validation,
                        fontSize: "0.6rem"
                    }
                }) : /*#__PURE__*/ (0, $iKObn.jsx)($fb772db1135f6866$var$CrossIcon, {
                    width: 12,
                    height: 12,
                    color: (0, $kKnoQ.colors).rejection
                })
            })
        ]
    });
const $fb772db1135f6866$var$DayContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "flexstart", "center")};
	color: ${(0, $kKnoQ.colors).white};
	padding-left: 5px;
`;
const $fb772db1135f6866$var$GraphContainer = (0, $5UMQ1.default).div`
	border-radius: 8px;
	border: 1px solid ${(0, $kKnoQ.colors).grey25};
`;



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $bC9c0 = parcelRequire("bC9c0");

var $8jRcl = parcelRequire("8jRcl");


var $5UMQ1 = parcelRequire("5UMQ1");

var $9gtEr = parcelRequire("9gtEr");

var $jrnUx = parcelRequire("jrnUx");

var $243Cr = parcelRequire("243Cr");


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $bl9tw = parcelRequire("bl9tw");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");
const $c39a5888f571b152$var$NUMBER_OF_SESSIONS_DISPLAYED = 15;
const $c39a5888f571b152$var$EMPTY_X_LABEL_VALUE = "";
const $c39a5888f571b152$var$SCALE = {
    x: {
        min: 0,
        max: $c39a5888f571b152$var$NUMBER_OF_SESSIONS_DISPLAYED - 1
    },
    y: {
        min: 1,
        max: 6
    }
};
const $c39a5888f571b152$export$5fe67dc1547f29b8 = ({ patientId: patientId, programId: programId, isEmpty: isEmpty, isLoading: isLoading })=>{
    const { loading: loading, feedbackGraphData: feedbackGraphData } = (0, $5fc77be801ae305c$export$31429d028a2265b9)(patientId, programId);
    const definedFeedbackGraphData = (0, $81g6h.useMemo)(()=>feedbackGraphData ?? (0, $e873ac3f9c980cfd$export$73b6fb41dad2be6f)(), [
        feedbackGraphData
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($c39a5888f571b152$var$FeedbackGraphView, {
        isEmpty: isEmpty,
        isLoading: isLoading || feedbackGraphData === undefined && loading || !!programId && feedbackGraphData === undefined,
        feedbackGraphData: definedFeedbackGraphData
    });
};
const $c39a5888f571b152$var$FeedbackGraphView = ({ feedbackGraphData: feedbackGraphData, isEmpty: isEmpty, isLoading: isLoading = false })=>{
    const { format: format, formatDateShort: formatDateShort, formatDateMedWithoutYear: formatDateMedWithoutYear, formatDateFullWithoutYearWithWeekday: formatDateFullWithoutYearWithWeekday } = (0, $1eHG3.useI18n)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const { formatExertion: formatExertion, formatMood: formatMood } = (0, $8jRcl.useFormatFeedback)();
    const skeletonProps = {
        active: isEmpty || isLoading,
        loading: isLoading
    };
    const graphWithoutScales = isLoading || isEmpty;
    const exertionGraphRef = (0, $81g6h.useRef)(null);
    const moodGraphRef = (0, $81g6h.useRef)(null);
    const formatExertionScaleYTooltip = (0, $81g6h.useCallback)((v)=>{
        const exertionWording = formatExertion(v);
        return format("patientDetails.progress.exertionGraphSection.scaleYTooltip.v1_6", {
            title: exertionWording.title,
            description: exertionWording.description
        });
    }, [
        format,
        formatExertion
    ]);
    const formatExertionTooltip = (0, $81g6h.useCallback)((x)=>{
        const session = feedbackGraphData.feedbacks[x];
        if ((0, $lTdpc.isNotNil)(session)) return /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                    className: "p-size-s-bold",
                    children: formatDateFullWithoutYearWithWeekday(session.completionDate)
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                    className: "p-size-s",
                    children: (0, $lTdpc.isNotNil)(session.exertion) ? format("patientDetails.progress.exertionGraphSection.dots.tooltip.v2_4", {
                        exertion: formatExertion(session.exertion).value,
                        exertionText: formatExertion(session.exertion).title
                    }) : format("patientDetails.progress.exertionGraphSection.dots.tooltip.noData.v2_4")
                })
            ]
        });
        return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {});
    }, [
        feedbackGraphData.feedbacks,
        format,
        formatDateFullWithoutYearWithWeekday,
        formatExertion
    ]);
    const formatMoodScaleYTooltip = (0, $81g6h.useCallback)((v)=>{
        const moodWording = formatMood(v);
        return format("patientDetails.progress.moodGraphSection.scaleYTooltip.v1_6", {
            mood: moodWording.title
        });
    }, [
        format,
        formatMood
    ]);
    const formatMoodValue = (0, $81g6h.useCallback)((v)=>{
        const moodWording = formatMood(v);
        return moodWording.icon;
    }, [
        formatMood
    ]);
    const formatMoodTooltip = (0, $81g6h.useCallback)((x)=>{
        const session = feedbackGraphData.feedbacks[x];
        if ((0, $lTdpc.isNotNil)(session)) {
            if (session.mood) {
                const moodWording = formatMood(session.mood);
                return /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                            className: "p-size-s-bold",
                            children: formatDateFullWithoutYearWithWeekday(session.completionDate)
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsxs)($c39a5888f571b152$var$MoodContainer, {
                            children: [
                                moodWording.icon,
                                /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                                    className: "p-size-s",
                                    children: moodWording.title
                                })
                            ]
                        })
                    ]
                });
            }
            return format("patientDetails.progress.moodGraphSection.dots.tooltip.noData", {
                date: formatDateShort(session.completionDate)
            });
        }
        return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {});
    }, [
        feedbackGraphData.feedbacks,
        format,
        formatDateShort,
        formatMood,
        formatDateFullWithoutYearWithWeekday
    ]);
    const exertionData = (0, $81g6h.useMemo)(()=>feedbackGraphData.feedbacks.map((session)=>session.exertion), [
        feedbackGraphData.feedbacks
    ]);
    const moodData = (0, $81g6h.useMemo)(()=>feedbackGraphData.feedbacks.map((session)=>session.mood), [
        feedbackGraphData.feedbacks
    ]);
    const simulateHoverOnExertionDot = (0, $81g6h.useCallback)((dataIndex)=>$c39a5888f571b152$var$simulateHoverOnDot(dataIndex, exertionData[dataIndex] === null ? 1 : 0, exertionGraphRef.current?.getChart()), [
        exertionData
    ]);
    const removeHoverOnExertionDotSimulation = (0, $81g6h.useCallback)(()=>$c39a5888f571b152$var$removeHoverOnDotSimulation(exertionGraphRef.current?.getChart()), []);
    const simulateHoverOnMoodDot = (0, $81g6h.useCallback)((dataIndex)=>$c39a5888f571b152$var$simulateHoverOnDot(dataIndex, moodData[dataIndex] === null ? 1 : 0, moodGraphRef.current?.getChart()), [
        moodData
    ]);
    const formatScaleX = (0, $81g6h.useCallback)((xIndex)=>{
        const feedback = feedbackGraphData.feedbacks[xIndex];
        if ((0, $lTdpc.isNil)(feedback)) return $c39a5888f571b152$var$EMPTY_X_LABEL_VALUE;
        return formatDateMedWithoutYear(feedback.completionDate);
    }, [
        feedbackGraphData.feedbacks,
        formatDateMedWithoutYear
    ]);
    const removeHoverOnMoodDotSimulation = (0, $81g6h.useCallback)(()=>$c39a5888f571b152$var$removeHoverOnDotSimulation(moodGraphRef.current?.getChart()), []);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($c39a5888f571b152$var$Section, {
        className: $c39a5888f571b152$var$dotTooltipTarget,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($c39a5888f571b152$var$HeaderContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $jrnUx.ContentWithTooltip), {
                        tooltip: format("patientDetails.progress.trackersGraphSection.sectionTooltip"),
                        skeleton: skeletonProps.active ? skeletonProps : undefined,
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                            className: "p-size-m-bold",
                            children: format("patientDetails.progress.trackersGraphSection.title")
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $9gtEr.ConditionalSkeleton), {
                        ...skeletonProps,
                        skeletonStyle: {
                            borderRadius: 4
                        },
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($c39a5888f571b152$var$Cta, {
                            className: "p-size-xs-semi-bold",
                            children: format("patientDetails.progress.trackersGraphSection.scaleCta")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($c39a5888f571b152$var$GraphContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($c39a5888f571b152$var$SubtitleContainer, {
                        style: {
                            marginTop: 32
                        },
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $jrnUx.ContentWithTooltip), {
                            tooltip: format("patientDetails.progress.moodGraphSection.sectionTooltip", {
                                link: {
                                    className: "p-size-s-bold underline",
                                    onClick: ()=>{
                                        dialogContext?.openModal((0, $243Cr.ModalId).MoodDetails);
                                        (0, $bC9c0.sendAnalyticsEventOpenMoodTooltip)();
                                    }
                                }
                            }),
                            tooltipOptions: {
                                delay: [
                                    null,
                                    200
                                ],
                                interactive: true
                            },
                            skeleton: skeletonProps.active ? skeletonProps : undefined,
                            children: /*#__PURE__*/ (0, $iKObn.jsx)($c39a5888f571b152$var$StyledHeader, {
                                className: "p-size-l",
                                children: format("patientDetails.progress.moodGraphSection.title")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $7fd210307fec9699$export$614db49f3febe941), {
                        id: "mood",
                        ref: moodGraphRef,
                        uiTheme: "hot-reverse",
                        displayLineOnHover: true,
                        displayScales: !graphWithoutScales,
                        scale: $c39a5888f571b152$var$SCALE,
                        data: moodData,
                        renderDotTooltipContent: formatMoodTooltip,
                        formatScaleYTooltip: formatMoodScaleYTooltip,
                        formatScaleY: formatMoodValue,
                        onDataHover: simulateHoverOnExertionDot,
                        onDotTooltipHide: removeHoverOnExertionDotSimulation,
                        formatScaleX: formatScaleX
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($c39a5888f571b152$var$SubtitleContainer, {
                        style: {
                            marginTop: 12
                        },
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $jrnUx.ContentWithTooltip), {
                            tooltip: format("patientDetails.progress.exertionGraphSection.sectionTooltip", {
                                link: {
                                    className: "p-size-s-bold underline",
                                    onClick: ()=>{
                                        dialogContext?.openModal((0, $243Cr.ModalId).ExertionDetails);
                                        (0, $bC9c0.sendAnalyticsEventOpenExertionTooltip)();
                                    }
                                }
                            }),
                            tooltipOptions: {
                                delay: [
                                    null,
                                    200
                                ],
                                interactive: true
                            },
                            skeleton: skeletonProps.active ? skeletonProps : undefined,
                            children: /*#__PURE__*/ (0, $iKObn.jsx)($c39a5888f571b152$var$StyledHeader, {
                                className: "p-size-l",
                                children: format("patientDetails.progress.exertionGraphSection.title")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $7fd210307fec9699$export$614db49f3febe941), {
                        id: "exertion",
                        uiTheme: "hot",
                        ref: exertionGraphRef,
                        displayLineOnHover: true,
                        displayScales: !graphWithoutScales,
                        scale: $c39a5888f571b152$var$SCALE,
                        data: exertionData,
                        renderDotTooltipContent: formatExertionTooltip,
                        formatScaleYTooltip: formatExertionScaleYTooltip,
                        onDataHover: simulateHoverOnMoodDot,
                        onDotTooltipHide: removeHoverOnMoodDotSimulation,
                        formatScaleX: formatScaleX
                    })
                ]
            })
        ]
    });
};
function $c39a5888f571b152$var$simulateHoverOnDot(dataIndex, datasetIndex, chart) {
    if (chart) {
        const chartArea = chart.chartArea;
        chart.tooltip?.setActiveElements([
            {
                datasetIndex: datasetIndex,
                index: dataIndex
            }
        ], {
            x: (chartArea.left + chartArea.right) / 2,
            y: (chartArea.top + chartArea.bottom) / 2
        });
        chart.setActiveElements([
            {
                datasetIndex: datasetIndex,
                index: dataIndex
            }
        ]);
        chart.update();
    }
}
function $c39a5888f571b152$var$removeHoverOnDotSimulation(chart) {
    if (chart) {
        chart.setActiveElements([]);
        chart.tooltip?.setActiveElements([], {
            x: 0,
            y: 0
        });
        chart.update();
    }
}
const $c39a5888f571b152$var$Section = (0, $5UMQ1.default).section`
	${(0, $5WGN2.stack)(16, undefined, "stretch")}
`;
const $c39a5888f571b152$var$HeaderContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")};
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		flex-direction: column;
		align-items: flex-start;
		gap: 8px;
	}
`;
const $c39a5888f571b152$var$Cta = (0, $5UMQ1.default).div`
	padding: 4px 8px;
	border-radius: 4px;
	background-color: ${(0, $kKnoQ.colors).grey10};
	color: ${(0, $kKnoQ.colors).grey};
`;
const $c39a5888f571b152$var$StyledHeader = (0, $5UMQ1.default).h3`
	span {
		font-family: ${(0, $bl9tw.fonts).header};
	}
`;
const $c39a5888f571b152$var$GraphContainer = (0, $5UMQ1.default).div`
	border-radius: 8px;
	border: 1px solid ${(0, $kKnoQ.colors).grey25};
`;
const $c39a5888f571b152$var$SubtitleContainer = (0, $5UMQ1.default).div`
	margin-left: 46px;
	margin-bottom: -12px;
	position: relative;
	z-index: 10;
`;
const $c39a5888f571b152$var$MoodContainer = (0, $5UMQ1.default).span`
	${(0, $5WGN2.row)(8, undefined, "center")};
`;
const $c39a5888f571b152$var$dotTooltipTarget = "target-section";



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5SzTW = parcelRequire("5SzTW");


var $5UMQ1 = parcelRequire("5UMQ1");

var $9gtEr = parcelRequire("9gtEr");

var $jrnUx = parcelRequire("jrnUx");

var $eWFm9 = parcelRequire("eWFm9");

parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $kXaMn = parcelRequire("kXaMn");

var $buI4E = parcelRequire("buI4E");

var $81g6h = parcelRequire("81g6h");
var $14d59fa736c9c3bc$var$Arrow = function Arrow(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M10 5.342c-.256 0-.512.1-.707.295l-5.656 5.656a.999.999 0 0 0 0 1.414l5.656 5.656a.999.999 0 0 0 1.414 0l.086-.086a.999.999 0 0 0 0-1.414L6.93 13H20a1 1 0 0 0 0-2H6.93l3.863-3.863a.999.999 0 0 0 0-1.414l-.086-.086A.998.998 0 0 0 10 5.342Z",
            fill: "currentColor"
        })
    });
};
$14d59fa736c9c3bc$var$Arrow.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $14d59fa736c9c3bc$export$53f0639ab1a1e35a = ({ patientId: patientId, programId: programId, isLoading: isLoading, programStatus: programStatus, ...otherProps })=>{
    const { loading: loading, progressData: progressData } = (0, $5fc77be801ae305c$export$efdbec2abacbbb18)(patientId, programId);
    const dataAreLoading = isLoading || progressData === undefined && loading;
    return /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$ProgressDataContent, {
        patientId: patientId,
        programId: programId,
        programStatus: programStatus,
        isLoading: dataAreLoading,
        progressData: progressData ?? (dataAreLoading ? (0, $e873ac3f9c980cfd$export$70df4193d87353f6)(0, 0) : (0, $e873ac3f9c980cfd$export$70df4193d87353f6)()),
        ...otherProps
    });
};
const $14d59fa736c9c3bc$var$ProgressDataContent = ({ progressData: progressData, isEmpty: isEmpty, isLoading: isLoading, programStatus: programStatus })=>{
    const { format: format, formatPercent: formatPercent, formatDateRelative: formatDateRelative, formatProgramDuration: formatProgramDuration, formatDurationLeft: formatDurationLeft, formatDateMed: formatDateMed, formatDateMedWithoutYear: formatDateMedWithoutYear } = (0, $1eHG3.useI18n)();
    const skeletonProps = (0, $81g6h.useMemo)(()=>({
            active: isEmpty || isLoading,
            loading: isLoading
        }), [
        isEmpty,
        isLoading
    ]);
    const { progress: progress, durationLeft: durationLeft } = (0, $81g6h.useMemo)(()=>{
        const totalDuration = (0, $kXaMn.computeDiffInDays)(progressData.startDate, progressData.endDate);
        const completedDuration = (0, $kXaMn.computeDiffInDays)(progressData.startDate, (0, $kXaMn.nowAsStartOfDay)());
        const percentage = programStatus === (0, $5SzTW.ProgramStatus).Ended ? 100 : 100 * completedDuration / totalDuration;
        const leftDuration = Math.floor((0, $kXaMn.computeDiffInDays)((0, $kXaMn.nowAsStartOfDay)(), progressData.endDate));
        return {
            progress: percentage,
            durationLeft: leftDuration
        };
    }, [
        progressData.startDate,
        progressData.endDate,
        programStatus
    ]);
    const progressCircleStrokeColor = (0, $81g6h.useMemo)(()=>{
        if (durationLeft > (0, $kXaMn.TWO_MONTH_IN_DAYS)) return (0, $kKnoQ.colors).primary;
        if (durationLeft > (0, $kXaMn.TWO_WEEKS_IN_DAYS)) return (0, $kKnoQ.colors).yellow;
        return (0, $kKnoQ.colors).rejection;
    }, [
        durationLeft
    ]);
    const formatedRemainingTime = (0, $81g6h.useMemo)(()=>{
        const formattedDuration = formatDurationLeft(durationLeft, (0, $kXaMn.TWO_MONTH_IN_DAYS));
        return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
            children: formattedDuration.split(/(\d+)/).map((part, index)=>(0, $buI4E.isNumeric)(part) ? /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$CenteredText, {
                    className: "p-header-2-regular",
                    children: part
                }, `duration-part-${part}-${index}`) : part)
        });
    }, [
        durationLeft,
        formatDurationLeft
    ]);
    const formatLastCompletionDate = (0, $81g6h.useMemo)(()=>{
        if ((0, $lTdpc.isNil)(progressData.lastCompletedSession)) return format("patientDetails.progress.lastSessionCompleted.emptyValue");
        if ((0, $kXaMn.computeDiffInDays)(progressData.lastCompletedSession, (0, $kXaMn.now)()) < (0, $kXaMn.ONE_MONTH_IN_DAYS)) return formatDateRelative(progressData.lastCompletedSession);
        else return formatDateMed(progressData.lastCompletedSession);
    }, [
        format,
        formatDateMed,
        formatDateRelative,
        progressData.lastCompletedSession
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($14d59fa736c9c3bc$var$SectionsContainer, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($14d59fa736c9c3bc$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $jrnUx.ContentWithTooltip), {
                        tooltip: format("patientDetails.progress.programProgress.tooltip.v2_0"),
                        skeleton: skeletonProps.active ? skeletonProps : undefined,
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                            className: "p-size-m-bold",
                            children: format("patientDetails.progress.progressSection.title")
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($14d59fa736c9c3bc$var$ProgressSectionContent, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$StyledConditionalSkeleton, {
                                ...skeletonProps,
                                skeletonStyle: {
                                    width: 200,
                                    height: 200
                                },
                                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $eWFm9.ProgressCircle), {
                                    progress: progress,
                                    strokeProgressColor: progressCircleStrokeColor,
                                    size: 180,
                                    strokeWidth: 8,
                                    showRemaining: true,
                                    counterClockWise: true,
                                    children: durationLeft > 0 ? /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$CircleText, {
                                        className: "p-size-s-rubik-regular",
                                        children: formatedRemainingTime
                                    }) : /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$CircleText, {
                                        className: "p-size-s-rubik-regular",
                                        children: format("patientDetails.progress.progressCircle.ended", {
                                            element: /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$CenteredText, {
                                                        className: "p-header-2-regular",
                                                        children: formatDateMedWithoutYear(progressData.endDate)
                                                    }),
                                                    /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                                                        className: "p-size-s",
                                                        children: progressData.endDate.format("YYYY")
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)($14d59fa736c9c3bc$var$Content, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsxs)($14d59fa736c9c3bc$var$ColumnItemContainer, {
                                        children: [
                                            /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$ConditionalSkeletonItemTitle, {
                                                ...skeletonProps,
                                                children: format("patientDetails.progress.schedule.title")
                                            }),
                                            /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$StyledConditionalSkeleton, {
                                                ...skeletonProps,
                                                skeletonStyle: {
                                                    backgroundColor: "white"
                                                },
                                                children: /*#__PURE__*/ (0, $iKObn.jsxs)($14d59fa736c9c3bc$var$RowContainer, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$ConditionalSkeletonItemValue, {
                                                            ...skeletonProps,
                                                            children: formatDateMed(progressData.startDate)
                                                        }),
                                                        /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$StyledArrow, {
                                                            width: 24,
                                                            height: 24,
                                                            color: (0, $kKnoQ.colors).grey
                                                        }),
                                                        /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$ConditionalSkeletonItemValue, {
                                                            ...skeletonProps,
                                                            children: formatDateMed(progressData.endDate)
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$StyledConditionalSkeleton, {
                                                ...skeletonProps,
                                                children: /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                                    className: "p-size-s",
                                                    style: {
                                                        color: (0, $kKnoQ.colors).grey80
                                                    },
                                                    children: formatProgramDuration(progressData.startDate, progressData.endDate)
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsxs)($14d59fa736c9c3bc$var$ColumnItemContainer, {
                                        children: [
                                            /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$ConditionalSkeletonItemTitle, {
                                                ...skeletonProps,
                                                skeletonStyle: {
                                                    backgroundColor: "white"
                                                },
                                                children: format("patientDetails.progress.lastSessionCompleted.title")
                                            }),
                                            /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$ConditionalSkeletonItemValue, {
                                                ...skeletonProps,
                                                children: formatLastCompletionDate
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($14d59fa736c9c3bc$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $jrnUx.ContentWithTooltip), {
                        tooltip: format("patientDetails.progress.complianceSection.tooltip.v2_0"),
                        skeleton: skeletonProps.active ? skeletonProps : undefined,
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                            className: "p-size-m-bold",
                            children: format("patientDetails.progress.complianceSection.title")
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($14d59fa736c9c3bc$var$ComplianceSectionContent, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)($14d59fa736c9c3bc$var$ColumnItemContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$ConditionalSkeletonItemTitle, {
                                        ...skeletonProps,
                                        skeletonStyle: {
                                            backgroundColor: "white"
                                        },
                                        children: format("patientDetails.progress.compliance.title")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$ConditionalSkeletonItemBigValue, {
                                        ...skeletonProps,
                                        skeletonStyle: {
                                            borderRadius: "0.4rem"
                                        },
                                        children: progressData.pastSessionsCount ? formatPercent(progressData.programComplianceInPercent) : format("patientDetails.progress.programCompliance.emptyValue")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)($14d59fa736c9c3bc$var$RowItemContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$ConditionalSkeletonItemTitle, {
                                        ...skeletonProps,
                                        skeletonStyle: {
                                            borderRadius: "0.4rem",
                                            marginRight: 10
                                        },
                                        children: format("patientDetails.progress.sessionsCompleted.title")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$ConditionalSkeletonItemValue, {
                                        ...skeletonProps,
                                        skeletonStyle: {
                                            borderRadius: "0.4rem"
                                        },
                                        children: format("patientDetails.progress.sessionsCompleted.value", {
                                            count: progressData.completedSessionsCount,
                                            total: progressData.pastSessionsCount
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$Separator, {}),
                            /*#__PURE__*/ (0, $iKObn.jsxs)($14d59fa736c9c3bc$var$RowItemContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$ConditionalSkeletonItemTitle, {
                                        ...skeletonProps,
                                        skeletonStyle: {
                                            borderRadius: "0.4rem",
                                            marginRight: 10
                                        },
                                        children: format("patientDetails.progress.sessionsPerWeek.title")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$ConditionalSkeletonItemValue, {
                                        ...skeletonProps,
                                        skeletonStyle: {
                                            borderRadius: "0.4rem"
                                        },
                                        children: progressData.sessionsPerWeek
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$Separator, {}),
                            /*#__PURE__*/ (0, $iKObn.jsxs)($14d59fa736c9c3bc$var$RowItemContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$ConditionalSkeletonItemTitle, {
                                        ...skeletonProps,
                                        skeletonStyle: {
                                            borderRadius: "0.4rem",
                                            marginRight: 10
                                        },
                                        children: format("patientDetails.progress.exercisesPerWeek.title")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$ConditionalSkeletonItemValue, {
                                        ...skeletonProps,
                                        skeletonStyle: {
                                            borderRadius: "0.4rem"
                                        },
                                        children: progressData.exercisesPerWeek
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $14d59fa736c9c3bc$var$SectionsContainer = (0, $5UMQ1.default).section`
	display: grid;
	grid-template-columns: 2fr 1fr;
	grid-gap: 40px;

	@media ${(0, $eaiXJ.physioMeDesktopLargeBreakpoint)} {
		grid-gap: 30px;
	}

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		grid-template-columns: 1fr;
	}
`;
const $14d59fa736c9c3bc$var$Section = (0, $5UMQ1.default).section`
	${(0, $5WGN2.stack)(16, undefined, "stretch")}
`;
const $14d59fa736c9c3bc$var$ProgressSectionContent = (0, $5UMQ1.default).div`
	height: 100%;
	padding: 40px;
	border-radius: 8px;
	border: 1px solid ${(0, $kKnoQ.colors).grey25};
	display: grid;
	grid-template-columns: 1fr 1fr;
	place-items: center;
	grid-gap: 40px;

	@media ${(0, $eaiXJ.physioMeDesktopLargeBreakpoint)} {
		grid-gap: 10px;
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		grid-template-columns: 1fr;
		padding: 24px;
	}
`;
const $14d59fa736c9c3bc$var$ComplianceSectionContent = (0, $5UMQ1.default).div`
	height: 100%;
	padding: 24px;
	border-radius: 8px;
	border: 1px solid ${(0, $kKnoQ.colors).grey25};
	${(0, $5WGN2.stack)(12, "center")};
`;
const $14d59fa736c9c3bc$var$Separator = (0, $5UMQ1.default).div`
	height: 1px;
	width: 100%;
	background-color: ${(0, $kKnoQ.colors).grey25};
`;
const $14d59fa736c9c3bc$var$RowContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8, "spacebetween", "center")};
`;
const $14d59fa736c9c3bc$var$Content = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: column;
	gap: 32px;
`;
const $14d59fa736c9c3bc$var$CircleText = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: column;
	text-align: center;
	white-space: nowrap;
`;
const $14d59fa736c9c3bc$var$CenteredText = (0, $5UMQ1.default).p`
	text-align: center;
`;
const $14d59fa736c9c3bc$var$ColumnItemContainer = (0, $5UMQ1.default).div`
	width: 100%;
	${(0, $5WGN2.stack)(undefined, "flexstart", "stretch")}
`;
const $14d59fa736c9c3bc$var$StyledArrow = (0, $5UMQ1.default)($14d59fa736c9c3bc$var$Arrow)`
	transform: rotate(180deg);
`;
const $14d59fa736c9c3bc$var$RowItemContainer = (0, $5UMQ1.default).div`
	width: 100%;
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")}
`;
const $14d59fa736c9c3bc$var$StyledConditionalSkeleton = (0, $5UMQ1.default)((0, $9gtEr.ConditionalSkeleton))`
	align-self: flex-start;
	width: 100%;
`;
const $14d59fa736c9c3bc$var$ConditionalSkeletonItemTitle = ({ children: children, ...skeletonProps })=>/*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$StyledConditionalSkeleton, {
        ...skeletonProps,
        skeletonStyle: {
            minWidth: 50,
            minHeight: 20,
            ...skeletonProps.skeletonStyle
        },
        children: /*#__PURE__*/ (0, $iKObn.jsx)("div", {
            className: "p-size-s-rubik-regular",
            style: {
                color: (0, $kKnoQ.colors).grey
            },
            children: children
        })
    });
const $14d59fa736c9c3bc$var$ConditionalSkeletonItemValue = ({ children: children, ...skeletonProps })=>/*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$StyledConditionalSkeleton, {
        ...skeletonProps,
        skeletonStyle: {
            minWidth: 30,
            ...skeletonProps.skeletonStyle
        },
        children: /*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$CustomDiv, {
            className: "p-size-m-bold",
            children: children
        })
    });
const $14d59fa736c9c3bc$var$ConditionalSkeletonItemBigValue = ({ children: children, ...skeletonProps })=>/*#__PURE__*/ (0, $iKObn.jsx)($14d59fa736c9c3bc$var$StyledConditionalSkeleton, {
        ...skeletonProps,
        skeletonStyle: {
            minWidth: 30,
            ...skeletonProps.skeletonStyle
        },
        children: /*#__PURE__*/ (0, $iKObn.jsx)("div", {
            className: "p-header-2-regular",
            style: {
                display: "flex"
            },
            children: children
        })
    });
const $14d59fa736c9c3bc$var$CustomDiv = (0, $5UMQ1.default).div`
	display: flex;
	white-space: nowrap;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		white-space: normal;
	}
`;



var $9L5pp = parcelRequire("9L5pp");

var $2hf1V = parcelRequire("2hf1V");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $buI4E = parcelRequire("buI4E");

var $eT9rN = parcelRequire("eT9rN");

var $81g6h = parcelRequire("81g6h");
const $ad4ae06710f8510e$export$c761437371a0af4c = ({ patient: patient, ...otherProps })=>{
    const { allPatientPrograms: allPatientPrograms, loading: loading, error: error, refreshAllPrograms: refreshAllPrograms, shouldDisplayProgramEndingSoonAlert: shouldDisplayProgramEndingSoonAlert, shouldDisplayProgramEndingNoOngoingAlert: shouldDisplayProgramEndingNoOngoingAlert } = (0, $9L5pp.useAllPatientPrograms)(patient);
    const { isMobile: isMobile } = (0, $5kXMA.useDimensions)();
    if (!allPatientPrograms && error) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
        style: {
            marginTop: 150
        },
        onRefresh: async ()=>{
            await refreshAllPrograms(patient.id);
        }
    });
    return isMobile && loading ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {}) : /*#__PURE__*/ (0, $iKObn.jsx)($ad4ae06710f8510e$var$ProgressTabContent, {
        isLoading: allPatientPrograms === undefined && loading,
        patient: patient,
        allPatientPrograms: allPatientPrograms ?? {
            endedPrograms: [],
            scheduledPrograms: [],
            draftPrograms: []
        },
        shouldDisplayProgramEndingSoonAlert: shouldDisplayProgramEndingSoonAlert,
        shouldDisplayProgramEndingNoOngoingAlert: shouldDisplayProgramEndingNoOngoingAlert,
        ...otherProps
    });
};
const $ad4ae06710f8510e$var$getProgramStatusLabel = (program, format)=>{
    if (program?.status === (0, $5SzTW.ProgramStatus).Ongoing) return format("global.programStatus.ongoing");
    if (program?.status === (0, $5SzTW.ProgramStatus).Ended && program.stopped) return format("global.programStatus.stopped");
    return format("global.programStatus.completed");
};
const $ad4ae06710f8510e$var$ProgramValueTemplate = ({ program: program, isMobile: isMobile, format: format })=>{
    const programStatusLabel = $ad4ae06710f8510e$var$getProgramStatusLabel(program, format);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($ad4ae06710f8510e$var$OverflowValue, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($ad4ae06710f8510e$var$OverflowText, {
                className: isMobile ? "p-size-l-bold" : "p-header-3",
                children: program?.name ?? "Undefined"
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("span", {
                className: isMobile ? "p-size-l" : "p-header-3-regular",
                style: {
                    color: (0, $kKnoQ.colors).grey80
                },
                children: [
                    "\xa0",
                    `(${programStatusLabel})`
                ]
            })
        ]
    });
};
const $ad4ae06710f8510e$var$ProgressTabContent = ({ patient: patient, allPatientPrograms: allPatientPrograms, shouldDisplayProgramEndingSoonAlert: shouldDisplayProgramEndingSoonAlert, shouldDisplayProgramEndingNoOngoingAlert: shouldDisplayProgramEndingNoOngoingAlert, isLoading: isLoading = false })=>{
    const { ongoingProgram: ongoingProgram, endedPrograms: endedPrograms, scheduledPrograms: scheduledPrograms } = allPatientPrograms;
    const { programId: programId } = (0, $8zvzh.useQueryParams)();
    const navigate = (0, $htiSH.useNavigate)();
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isMobile: isMobile } = (0, $5kXMA.useDimensions)();
    const { duplicateAsDraftProgram: duplicateAsDraftProgram, loading: loading } = (0, $2hf1V.useProgramActions)();
    const groupedPatientPrograms = (0, $81g6h.useMemo)(()=>[
            ...ongoingProgram ? [
                {
                    label: format("patientDetails.progress.dropdown.ongoingSection", {
                        count: 1
                    }),
                    code: (0, $5SzTW.ProgramStatus).Ongoing,
                    items: [
                        ongoingProgram
                    ]
                }
            ] : [],
            ...endedPrograms.length > 0 ? [
                {
                    label: format("patientDetails.progress.dropdown.endedSection", {
                        count: endedPrograms.length
                    }),
                    code: (0, $5SzTW.ProgramStatus).Ended,
                    items: endedPrograms
                }
            ] : []
        ], [
        format,
        endedPrograms,
        ongoingProgram
    ]);
    const isEmpty = !isLoading && groupedPatientPrograms.length === 0;
    const hasFuturePrograms = scheduledPrograms.length > 0;
    const skeletonProps = (0, $81g6h.useMemo)(()=>({
            active: isEmpty || isLoading,
            loading: isLoading
        }), [
        isEmpty,
        isLoading
    ]);
    const selectedPatientProgram = (0, $81g6h.useMemo)(()=>groupedPatientPrograms.flatMap((programGroup)=>programGroup.items).find((program)=>program.id === programId) ?? groupedPatientPrograms[0]?.items[0], [
        groupedPatientPrograms,
        programId
    ]);
    const onPatientProgramsChange = (e)=>{
        if (e.value) navigate((0, $lDZlX.RoutesPath).PatientDetails, {
            route: {
                patientId: patient.id
            },
            query: {
                active: (0, $lDZlX.TabPatientDetails).PROGRESS_TAB,
                programId: e.value.id
            }
        });
    };
    // no dropdown methode to blur the dropdown so we focus another item to force the blur
    const hiddenInputRef = (0, $81g6h.useRef)(null);
    const blurDropdown = ()=>{
        hiddenInputRef.current?.focus();
        hiddenInputRef.current?.blur();
    };
    const extendProgram = (0, $81g6h.useCallback)(()=>{
        if (selectedPatientProgram?.status === (0, $5SzTW.ProgramStatus).Ongoing) {
            (0, $bC9c0.sendAnalyticsEventExtendProgram)((0, $bC9c0.AnalyticsProgramLocation).PROGRESS_TAB, patient.analyticsId, selectedPatientProgram.id);
            navigate((0, $lDZlX.RoutesPath).ProgramBuilder, {
                route: {
                    patientId: patient.id
                },
                query: {
                    programId: selectedPatientProgram.id,
                    openScheduleModal: "true"
                }
            });
        }
    }, [
        navigate,
        patient,
        selectedPatientProgram?.id,
        selectedPatientProgram?.status
    ]);
    const duplicateAsDraft = (0, $81g6h.useCallback)(()=>{
        if ((0, $lTdpc.isNotNil)(selectedPatientProgram)) {
            duplicateAsDraftProgram({
                patientId: patient.id,
                programName: selectedPatientProgram.name,
                programId: selectedPatientProgram.id
            });
            navigate((0, $lDZlX.RoutesPath).PatientDetails, {
                route: {
                    patientId: patient.id
                },
                query: {
                    active: (0, $lDZlX.TabPatientDetails).PROGRAMS_TAB
                }
            });
        }
    }, [
        duplicateAsDraftProgram,
        navigate,
        patient.id,
        selectedPatientProgram
    ]);
    const renderProgramValueTemplate = (0, $81g6h.useCallback)((e)=>/*#__PURE__*/ (0, $iKObn.jsx)($ad4ae06710f8510e$var$ProgramValueTemplate, {
            program: e,
            isMobile: isMobile,
            format: format
        }), [
        format,
        isMobile
    ]);
    const shouldHideContent = isMobile && isEmpty;
    const truncatedPatientName = (0, $buI4E.truncateString)(patient.firstName, 20);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($ad4ae06710f8510e$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($ad4ae06710f8510e$var$AbsoluteHiddenInput, {
                ref: hiddenInputRef
            }),
            isEmpty && /*#__PURE__*/ (0, $iKObn.jsx)((0, $67c50a2deb906efb$export$3dcf988bf83aecff), {
                patient: patient,
                hasFutureProgram: hasFuturePrograms,
                analyticsLocation: (0, $bC9c0.AnalyticsProgramLocation).PROGRESS_TAB,
                style: {
                    position: shouldHideContent ? "static" : "absolute"
                }
            }),
            !shouldHideContent && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($ad4ae06710f8510e$var$ButtonContainer, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $9gtEr.ConditionalSkeleton), {
                                ...skeletonProps,
                                skeletonStyle: {
                                    borderRadius: "0.5rem"
                                },
                                children: /*#__PURE__*/ (0, $iKObn.jsx)($ad4ae06710f8510e$var$StyledDropdown, {
                                    scrollHeight: "350px",
                                    value: selectedPatientProgram,
                                    style: skeletonProps.active ? {
                                        width: 350
                                    } : undefined,
                                    options: groupedPatientPrograms,
                                    onChange: onPatientProgramsChange,
                                    optionLabel: "name",
                                    onHide: blurDropdown,
                                    optionGroupLabel: "label",
                                    optionGroupChildren: "items",
                                    valueTemplate: renderProgramValueTemplate
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $9gtEr.ConditionalSkeleton), {
                                ...skeletonProps,
                                skeletonStyle: {
                                    borderRadius: "0.5rem"
                                },
                                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
                                    label: format("patientDetails.progress.openProgramButton"),
                                    onClick: ()=>{
                                        if (!selectedPatientProgram) return;
                                        navigate((0, $lDZlX.RoutesPath).ProgramBuilder, {
                                            route: {
                                                patientId: patient.id
                                            },
                                            query: {
                                                programId: selectedPatientProgram.id
                                            }
                                        });
                                        (0, $bC9c0.sendAnalyticsEventViewProgram)(patient.analyticsId, selectedPatientProgram, (0, $lDZlX.TabPatientDetails).PROGRESS_TAB);
                                    }
                                })
                            })
                        ]
                    }),
                    shouldDisplayProgramEndingSoonAlert && /*#__PURE__*/ (0, $iKObn.jsx)((0, $imaOW.AlertCard), {
                        title: format("patientDetails.alert.programEndingSoon.title", {
                            patientName: truncatedPatientName
                        }),
                        message: format("patientDetails.alert.programEndingSoon.message"),
                        cardType: (0, $imaOW.CardType).Warn,
                        secondaryButtons: [
                            {
                                title: format("patientDetails.alert.programEndingSoon.button"),
                                onPressed: extendProgram
                            }
                        ]
                    }),
                    shouldDisplayProgramEndingNoOngoingAlert && /*#__PURE__*/ (0, $iKObn.jsx)((0, $imaOW.AlertCard), {
                        title: format("patientDetails.alert.programEnded.title", {
                            patientName: truncatedPatientName
                        }),
                        message: format("patientDetails.alert.programEnded.message"),
                        cardType: (0, $imaOW.CardType).Warn,
                        secondaryButtons: [
                            {
                                title: format("patientDetails.alert.programEnded.button"),
                                onPressed: duplicateAsDraft,
                                loading: loading
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $14d59fa736c9c3bc$export$53f0639ab1a1e35a), {
                        isEmpty: isEmpty,
                        isLoading: isLoading,
                        patientId: patient.id,
                        programId: selectedPatientProgram?.id,
                        programStatus: selectedPatientProgram?.status
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $fb772db1135f6866$export$f6394e24454722bb), {
                        isEmpty: isEmpty,
                        isLoading: isLoading,
                        patientId: patient.id,
                        programId: selectedPatientProgram?.id
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $c39a5888f571b152$export$5fe67dc1547f29b8), {
                        isEmpty: isEmpty,
                        isLoading: isLoading,
                        patientId: patient.id,
                        programId: selectedPatientProgram?.id
                    })
                ]
            })
        ]
    });
};
const $ad4ae06710f8510e$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(40, "center", "stretch")};
	flex-grow: 1;
	position: relative;
`;
const $ad4ae06710f8510e$var$ButtonContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")};

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		${(0, $5WGN2.stack)(8, "spacebetween", "flexstart")};
	}
`;
const $ad4ae06710f8510e$var$StyledDropdown = (0, $5UMQ1.default)((0, $eT9rN.Dropdown))`
	max-width: calc(100% - 10rem);
	margin-left: -1rem;

	background-color: ${(0, $kKnoQ.colors).white};

	.p-dropdown-trigger-icon {
		font-size: 1.25rem;
	}

	.p-dropdown-label {
		padding: 1rem 0 1rem 1rem;
	}

	.p-dropdown-panel .p-dropdown-items {
		.p-dropdown-item-group {
			padding-left: 1rem;
		}

		.p-dropdown-item {
			padding-left: 2.5rem;

			&.p-highlight:before {
				left: 1rem;
			}
		}
	}

	:not(.p-disabled).p-focus {
		background-color: ${(0, $kKnoQ.colors).primaryBackground};
	}

	:hover:not(.p-focus) {
		background-color: ${(0, $kKnoQ.colors).primaryBackground};
		border-color: ${(0, $kKnoQ.colors).primaryBackground} !important;
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		max-width: 105%;
	}
`;
const $ad4ae06710f8510e$var$OverflowValue = (0, $5UMQ1.default).span`
	width: 100%;
	display: flex;
	flex-direction: row;
	overflow: hidden;
`;
const $ad4ae06710f8510e$var$OverflowText = (0, $5UMQ1.default).span`
	display: block;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;
const $ad4ae06710f8510e$var$AbsoluteHiddenInput = (0, $5UMQ1.default).input`
	position: absolute;
	opacity: 0;
	top: 0;
`;



var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
var $6a8a39b924ac5fbd$var$ArrowIcon = function ArrowIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M11.29 17.712a1.002 1.002 0 0 0 0-1.42L8 13.003h10a1 1 0 0 0 0-2H8l3.29-3.29a1.001 1.001 0 1 0-1.41-1.42l-4.29 4.3a2 2 0 0 0-.59 1.41 2 2 0 0 0 .59 1.4l4.29 4.3a1 1 0 0 0 1.41.01Z",
            fill: "currentColor"
        })
    });
};
$6a8a39b924ac5fbd$var$ArrowIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $6a8a39b924ac5fbd$export$e0d897ee21382f67 = ({ onClick: onClick })=>/*#__PURE__*/ (0, $iKObn.jsx)($6a8a39b924ac5fbd$var$Button, {
        onClick: onClick,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($6a8a39b924ac5fbd$var$ArrowIcon, {
            height: 24,
            width: 24,
            color: (0, $kKnoQ.colors).grey
        })
    });
const $6a8a39b924ac5fbd$var$Button = (0, $5UMQ1.default).button`
	cursor: pointer;
	border: 1px solid ${()=>(0, $kKnoQ.colors).primary25};
	border-radius: 8px;
	padding: 8px 16px;
	background-color: ${(0, $kKnoQ.colors).white};
	${(0, $5WGN2.row)(undefined, "center", "center")};

	:hover {
		border: 1px solid ${()=>(0, $kKnoQ.colors).primary};
	}
`;


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $kKnoQ = parcelRequire("kKnoQ");

var $5WGN2 = parcelRequire("5WGN2");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");

var $8Zwsm = parcelRequire("8Zwsm");

var $4gQLd = parcelRequire("4gQLd");

var $l2NC0 = parcelRequire("l2NC0");

var $gbrlA = parcelRequire("gbrlA");

var $cfkGk = parcelRequire("cfkGk");
"use client";
function $127c90090297db9c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $127c90090297db9c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $127c90090297db9c$var$_typeof(o);
}
function $127c90090297db9c$var$_toPrimitive(input, hint) {
    if ($127c90090297db9c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($127c90090297db9c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $127c90090297db9c$var$_toPropertyKey(arg) {
    var key = $127c90090297db9c$var$_toPrimitive(arg, "string");
    return $127c90090297db9c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $127c90090297db9c$var$_defineProperty(obj, key, value) {
    key = $127c90090297db9c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $127c90090297db9c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $127c90090297db9c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $127c90090297db9c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $127c90090297db9c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $127c90090297db9c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $127c90090297db9c$var$_arrayLikeToArray(o, minLen);
}
function $127c90090297db9c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $127c90090297db9c$var$_slicedToArray(arr, i) {
    return $127c90090297db9c$var$_arrayWithHoles(arr) || $127c90090297db9c$var$_iterableToArrayLimit(arr, i) || $127c90090297db9c$var$_unsupportedIterableToArray(arr, i) || $127c90090297db9c$var$_nonIterableRest();
}
var $127c90090297db9c$var$classes = {
    icon: "p-menuitem-icon",
    action: "p-menuitem-link",
    label: "p-menuitem-text",
    home: function home(_ref) {
        var _className = _ref._className, disabled = _ref.disabled;
        return (0, $cfkGk.classNames)("p-breadcrumb-home p-menuitem", {
            "p-disabled": disabled
        }, _className);
    },
    separatorIcon: "p-breadcrumb-chevron",
    separator: "p-menuitem-separator",
    menuitem: function menuitem(_ref2) {
        var item = _ref2.item;
        return (0, $cfkGk.classNames)("p-menuitem", item.className, {
            "p-disabled": item.disabled
        });
    },
    menu: "p-breadcrumb-list",
    root: "p-breadcrumb p-component"
};
var $127c90090297db9c$var$styles = "\n@layer primereact {\n    .p-breadcrumb {\n        overflow-x: auto;\n    }\n\n    .p-breadcrumb ol {\n        margin: 0;\n        padding: 0;\n        list-style-type: none;\n        display: flex;\n        align-items: center;\n        flex-wrap: nowrap;\n    }\n\n    .p-breadcrumb .p-menuitem-text {\n        line-height: 1;\n    }\n\n    .p-breadcrumb .p-menuitem-link {\n        text-decoration: none;\n        display: flex;\n        align-items: center;\n    }\n\n    .p-breadcrumb .p-menuitem-separator {\n        display: flex;\n        align-items: center;\n    }\n\n    .p-breadcrumb::-webkit-scrollbar {\n        display: none;\n    }\n}\n";
var $127c90090297db9c$var$BreadCrumbBase = (0, $4gQLd.ComponentBase).extend({
    defaultProps: {
        __TYPE: "BreadCrumb",
        id: null,
        model: null,
        home: null,
        separatorIcon: null,
        style: null,
        className: null,
        children: undefined
    },
    css: {
        classes: $127c90090297db9c$var$classes,
        styles: $127c90090297db9c$var$styles
    }
});
function $127c90090297db9c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $127c90090297db9c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $127c90090297db9c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $127c90090297db9c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $127c90090297db9c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $127c90090297db9c$export$717fd9b2f8e29b80 = /*#__PURE__*/ $81g6h.memo(/*#__PURE__*/ $81g6h.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $l2NC0.useMergeProps)();
    var context = $81g6h.useContext((0, $8Zwsm.PrimeReactContext));
    var props = $127c90090297db9c$var$BreadCrumbBase.getProps(inProps, context);
    var _React$useState = $81g6h.useState(props.id), _React$useState2 = $127c90090297db9c$var$_slicedToArray(_React$useState, 2), idState = _React$useState2[0], setIdState = _React$useState2[1];
    var elementRef = $81g6h.useRef(null);
    var _BreadCrumbBase$setMe = $127c90090297db9c$var$BreadCrumbBase.setMetaData({
        props: props,
        state: {
            id: idState
        }
    }), ptm = _BreadCrumbBase$setMe.ptm, cx = _BreadCrumbBase$setMe.cx, isUnstyled = _BreadCrumbBase$setMe.isUnstyled;
    (0, $4gQLd.useHandleStyle)($127c90090297db9c$var$BreadCrumbBase.css.styles, isUnstyled, {
        name: "breadcrumb"
    });
    var itemClick = function itemClick(event, item) {
        if (item.disabled) {
            event.preventDefault();
            return;
        }
        if (item.command) item.command({
            originalEvent: event,
            item: item
        });
        if (!item.url) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    var isCurrent = function isCurrent(url) {
        var lastPath = typeof window !== "undefined" ? window.location.pathname : "";
        return url === lastPath ? "page" : undefined;
    };
    var createHome = function createHome() {
        var home = props.home;
        if (home) {
            if (home.visible === false) return null;
            var _icon = home.icon, target = home.target, url = home.url, disabled = home.disabled, style = home.style, _className = home.className, template = home.template, _label = home.label;
            var iconProps = mergeProps({
                className: cx("icon")
            }, ptm("icon"));
            var icon = (0, $cfkGk.IconUtils).getJSXIcon(_icon, $127c90090297db9c$var$_objectSpread({}, iconProps), {
                props: props
            });
            var actionProps = mergeProps({
                href: url || "#",
                className: cx("action"),
                "aria-disabled": disabled,
                "aria-current": isCurrent(url),
                target: target,
                onClick: function onClick(event) {
                    return itemClick(event, home);
                }
            }, ptm("action"));
            var labelProps = mergeProps({
                className: cx("label")
            }, ptm("label"));
            var label = _label && /*#__PURE__*/ $81g6h.createElement("span", labelProps, _label);
            var content = /*#__PURE__*/ $81g6h.createElement("a", actionProps, icon, label);
            if (template) {
                var defaultContentOptions = {
                    onClick: function onClick(event) {
                        return itemClick(event, home);
                    },
                    className: "p-menuitem-link",
                    labelClassName: "p-menuitem-text",
                    element: content,
                    props: props
                };
                content = (0, $cfkGk.ObjectUtils).getJSXElement(template, home, defaultContentOptions);
            }
            var key = idState + "_home";
            var menuitemProps = mergeProps({
                id: key,
                key: key,
                className: cx("home", {
                    _className: _className,
                    disabled: disabled
                }),
                style: style
            }, ptm("home"));
            return /*#__PURE__*/ $81g6h.createElement("li", menuitemProps, content);
        }
        return null;
    };
    var createSeparator = function createSeparator(index) {
        var key = idState + "_sep_" + index;
        var separatorIconProps = mergeProps({
            className: cx("separatorIcon"),
            "aria-hidden": "true"
        }, ptm("separatorIcon"));
        var icon = props.separatorIcon || /*#__PURE__*/ $81g6h.createElement((0, $gbrlA.ChevronRightIcon), separatorIconProps);
        var separatorIcon = (0, $cfkGk.IconUtils).getJSXIcon(icon, $127c90090297db9c$var$_objectSpread({}, separatorIconProps), {
            props: props
        });
        var separatorProps = mergeProps({
            id: key,
            key: key,
            className: cx("separator"),
            role: "separator"
        }, ptm("separator"));
        return /*#__PURE__*/ $81g6h.createElement("li", separatorProps, separatorIcon);
    };
    var createMenuitem = function createMenuitem(item, index) {
        if (item.visible === false) return null;
        var labelProps = mergeProps({
            className: cx("label")
        }, ptm("label"));
        var label = item.label && /*#__PURE__*/ $81g6h.createElement("span", labelProps, item.label);
        var actionProps = mergeProps({
            href: item.url || "#",
            className: cx("action"),
            target: item.target,
            "aria-current": isCurrent(item.url),
            onClick: function onClick(event) {
                return itemClick(event, item);
            },
            "aria-disabled": item.disabled
        }, ptm("action"));
        var content = /*#__PURE__*/ $81g6h.createElement("a", actionProps, label);
        if (item.template) {
            var defaultContentOptions = {
                onClick: function onClick(event) {
                    return itemClick(event, item);
                },
                className: "p-menuitem-link",
                labelClassName: "p-menuitem-text",
                element: content,
                props: props
            };
            content = (0, $cfkGk.ObjectUtils).getJSXElement(item.template, item, defaultContentOptions);
        }
        var key = item.id || idState + "_" + index;
        var menuitemProps = mergeProps({
            id: key,
            key: key,
            className: cx("menuitem", {
                item: item
            }),
            style: item.style
        }, ptm("menuitem"));
        return /*#__PURE__*/ $81g6h.createElement("li", menuitemProps, content);
    };
    var createMenuitems = function createMenuitems() {
        if (props.model) {
            var _items = props.model.map(function(item, index) {
                if (item.visible === false) return null;
                var menuitem = createMenuitem(item, index);
                var separator = index === props.model.length - 1 ? null : createSeparator(index);
                var key = idState + "_" + index;
                return /*#__PURE__*/ $81g6h.createElement($81g6h.Fragment, {
                    key: key
                }, menuitem, separator);
            });
            return _items;
        }
        return null;
    };
    (0, $l2NC0.useMountEffect)(function() {
        if (!idState) setIdState((0, $cfkGk.UniqueComponentId)());
    });
    $81g6h.useImperativeHandle(ref, function() {
        return {
            props: props,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var home = createHome();
    var items = createMenuitems();
    var separator = createSeparator("home");
    var menuProps = mergeProps({
        className: cx("menu")
    }, ptm("menu"));
    var rootProps = mergeProps({
        id: props.id,
        ref: elementRef,
        className: (0, $cfkGk.classNames)(props.className, cx("root")),
        style: props.style
    }, $127c90090297db9c$var$BreadCrumbBase.getOtherProps(props), ptm("root"));
    return /*#__PURE__*/ $81g6h.createElement("nav", rootProps, /*#__PURE__*/ $81g6h.createElement("ol", menuProps, home, home && separator, items));
}));
$127c90090297db9c$export$717fd9b2f8e29b80.displayName = "BreadCrumb";



var $bY9wC = parcelRequire("bY9wC");
parcelRequire("81g6h");
const $d510a82b2e47296c$export$e8b137a2905aabca = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { formatPatientName: formatPatientName } = (0, $aEP4N.useFormatPatients)();
    const { patientId: patientId } = (0, $fec74558288ce465$export$1f9b870ad76091)();
    const { active: active, programId: programId } = (0, $8zvzh.useQueryParams)();
    const { loading: loading, patient: patient, error: error, refreshPatient: refreshPatient } = (0, $aEP4N.usePatient)(patientId);
    const navigate = (0, $htiSH.useNavigate)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    if (!patient) {
        if (loading) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {});
        return /*#__PURE__*/ (0, $iKObn.jsx)($d510a82b2e47296c$var$Container, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
                description: (0, $04Qjn.isApiError)(error) ? format("global.patientNotFound.description") : undefined,
                onRefresh: async ()=>{
                    patientId && await refreshPatient(patientId);
                }
            })
        });
    }
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($d510a82b2e47296c$var$Header, {
                children: [
                    !isDesktop && /*#__PURE__*/ (0, $iKObn.jsx)((0, $6a8a39b924ac5fbd$export$e0d897ee21382f67), {
                        onClick: ()=>navigate((0, $lDZlX.RoutesPath).Home)
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($d510a82b2e47296c$var$StyledBreadCrumb, {
                        model: [
                            {
                                label: format("patientDetails.breadCrumb.home"),
                                url: (0, $lDZlX.RoutesPath).Home,
                                command: (e)=>{
                                    e.originalEvent.preventDefault();
                                    navigate((0, $lDZlX.RoutesPath).Home);
                                }
                            },
                            {
                                label: formatPatientName(patient),
                                command: (e)=>{
                                    e.originalEvent.preventDefault();
                                }
                            }
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($d510a82b2e47296c$var$ContentContainer, {
                isDesktop: isDesktop,
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $1CiDH.PatientDetailsColumn), {
                        patient: patient
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($d510a82b2e47296c$var$ProgramsSection, {
                        children: (0, $6Yxa2.isPendingPatient)(patient) ? /*#__PURE__*/ (0, $iKObn.jsx)($d510a82b2e47296c$var$StyledTabView, {
                            activeIndex: (0, $lTdpc.isNotNil)(active) ? $d510a82b2e47296c$var$pendingPatientTabNames.indexOf(active) : 0,
                            onTabChange: ()=>navigate((0, $lDZlX.RoutesPath).PatientDetails, {
                                    route: {
                                        patientId: patient.id
                                    },
                                    query: {
                                        active: (0, $lDZlX.TabPatientDetails).PROGRAMS_TAB
                                    }
                                }),
                            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $bY9wC.TabPanel), {
                                header: format("patientDetails.tabs.programs"),
                                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $9fc405adff9b5da8$export$8cb9e433fd52041e), {
                                    patient: patient
                                })
                            })
                        }) : /*#__PURE__*/ (0, $iKObn.jsxs)($d510a82b2e47296c$var$StyledTabView, {
                            activeIndex: (0, $lTdpc.isNotNil)(active) ? $d510a82b2e47296c$var$patientTabNames.indexOf(active) : 0,
                            onTabChange: (e)=>{
                                navigate((0, $lDZlX.RoutesPath).PatientDetails, {
                                    route: {
                                        patientId: patient.id
                                    },
                                    query: {
                                        active: $d510a82b2e47296c$var$patientTabNames[e.index],
                                        programId: programId
                                    }
                                });
                                (0, $bC9c0.sendAnalyticsEventSwitchPatientDetail)(patient.analyticsId, $d510a82b2e47296c$var$patientTabNames[e.index]);
                            },
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)((0, $bY9wC.TabPanel), {
                                    className: (0, $a6fIt.e2eTestId).patientPage.progressTab,
                                    header: format("patientDetails.tabs.progress"),
                                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $ad4ae06710f8510e$export$c761437371a0af4c), {
                                        patient: patient
                                    })
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)((0, $bY9wC.TabPanel), {
                                    className: (0, $a6fIt.e2eTestId).patientPage.ProgramTab,
                                    header: format("patientDetails.tabs.programs"),
                                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $9fc405adff9b5da8$export$8cb9e433fd52041e), {
                                        patient: patient
                                    })
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)((0, $bY9wC.TabPanel), {
                                    className: (0, $a6fIt.e2eTestId).patientPage.healthcareTeamTab,
                                    header: format("patientDetails.tabs.healthcareTeam"),
                                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $362571945e6c2e3b$export$aa560270ebae7b35), {
                                        patient: patient
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $d510a82b2e47296c$var$patientTabNames = [
    (0, $lDZlX.TabPatientDetails).PROGRESS_TAB,
    (0, $lDZlX.TabPatientDetails).PROGRAMS_TAB,
    (0, $lDZlX.TabPatientDetails).HEALTHCARE_TAB
];
const $d510a82b2e47296c$var$pendingPatientTabNames = [
    (0, $lDZlX.TabPatientDetails).PROGRAMS_TAB
];
const $d510a82b2e47296c$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "stretch")};
	flex-grow: 1;
`;
const $d510a82b2e47296c$var$Header = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, undefined, "center")}
	margin: 16px 24px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		margin: 16px;
	}
`;
const $d510a82b2e47296c$var$ContentContainer = (0, $5UMQ1.default).div`
	${({ isDesktop: isDesktop })=>isDesktop && (0, $5WGN2.row)(24, "flexstart", "stretch")};
	flex-grow: 1;
	margin: 0 24px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		margin: 0;
		background-color: ${(0, $kKnoQ.colors).white};
	}
`;
const $d510a82b2e47296c$var$ProgramsSection = (0, $5UMQ1.default).section`
	flex: 1;
	background-color: ${(0, $kKnoQ.colors).white};
	border-radius: 16px 16px 0px 0px;
	padding: 24px 40px;
	min-width: 0;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		border-radius: 0;
		padding: 0;
		flex-grow: 1;
	}
`;
const $d510a82b2e47296c$var$StyledBreadCrumb = (0, $5UMQ1.default)((0, $127c90090297db9c$export$717fd9b2f8e29b80))`
	margin-left: 16px;

	.p-menuitem-text {
		font-size: 0.75rem;
		font-weight: 600;
		color: ${(0, $kKnoQ.colors).grey80};
	}

	li:last-child .p-menuitem-link {
		cursor: initial;
		color: ${(0, $kKnoQ.colors).grey};
	}
`;
const $d510a82b2e47296c$var$StyledTabView = (0, $5UMQ1.default)((0, $bY9wC.TabView))`
	.p-tabview-nav {
		@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
			background-color: ${(0, $kKnoQ.colors).primaryBackground} !important;
		}
	}

	.p-tabview-nav-link {
		@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
			background-color: ${(0, $kKnoQ.colors).primaryBackground} !important;
			justify-content: center !important;
		}
	}

	.p-tabview-panels {
		@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
			padding: 16px 32px !important;
		}
		@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
			padding: 16px !important;
		}
	}
`;



var $iKObn = parcelRequire("iKObn");

var $04Qjn = parcelRequire("04Qjn");

var $1eHG3 = parcelRequire("1eHG3");

var $8zvzh = parcelRequire("8zvzh");


var $aEP4N = parcelRequire("aEP4N");

var $eAmnG = parcelRequire("eAmnG");

var $5UMQ1 = parcelRequire("5UMQ1");

var $28f8Y = parcelRequire("28f8Y");


var $9L5pp = parcelRequire("9L5pp");

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $giAv5 = parcelRequire("giAv5");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $aEP4N = parcelRequire("aEP4N");

var $eAmnG = parcelRequire("eAmnG");

var $bC9c0 = parcelRequire("bC9c0");

var $daNIT = parcelRequire("daNIT");

var $ghfIB = parcelRequire("ghfIB");

var $isRr9 = parcelRequire("isRr9");

var $eAmnG = parcelRequire("eAmnG");

var $c9OC9 = parcelRequire("c9OC9");

var $cYBw6 = parcelRequire("cYBw6");

var $kLgU7 = parcelRequire("kLgU7");

var $lTdpc = parcelRequire("lTdpc");

var $jTpg0 = parcelRequire("jTpg0");

var $1IWnK = parcelRequire("1IWnK");

var $iglNQ = parcelRequire("iglNQ");

var $aAhWR = parcelRequire("aAhWR");
class $02b6689614593d0d$export$e4ac5f3bb70a008e {
    constructor(programContent, onboardingManager, dataIsLoading = false){
        this.onboardingManager = onboardingManager;
        this._alternativeError = (0, $1IWnK.observable)(null);
        this.alternativeError = this._alternativeError.readOnly();
        this._editedProgram = (0, $1IWnK.observable)(programContent);
        this.editedProgram = this._editedProgram.readOnly();
        this._dataIsLoading = (0, $1IWnK.observable)(dataIsLoading);
        this.dataIsLoading = this._dataIsLoading.readOnly();
        this.firstExerciseDraggableId = this._editedProgram.select((program)=>this.getFirstExerciseDraggableId(program.days));
        this.programMetadata = this._editedProgram.select((program)=>{
            let exerciseCount = 0;
            let alternativeExerciseCount = 0;
            program.days.forEach(([, session])=>{
                exerciseCount += session.exercises.length;
                session.exercises.forEach((exercise)=>{
                    alternativeExerciseCount += exercise.alternativeExercises.length;
                });
            });
            return {
                exerciseCount: exerciseCount,
                alternativeExerciseCount: alternativeExerciseCount
            };
        });
    }
    async reorderSessionExercises(sessionIndex, sourceExerciseIndex, destinationExerciseIndex) {
        const session = this._editedProgram.get().days.get(sessionIndex);
        const movedExercise = session.exercises[sourceExerciseIndex];
        const newSession = {
            exercises: (0, $kLgU7.reorder)(session.exercises, sourceExerciseIndex, destinationExerciseIndex)
        };
        this.hideComplementaryGuideIfNeeded(movedExercise.draggableId);
        this.editSession(sessionIndex, newSession);
    }
    async addExerciseToSession(exerciseToCopy, sessionIndex, exerciseIndex, skipOnboardings = false) {
        const session = this._editedProgram.get().days.get(sessionIndex);
        const newExercise = this.createMainExerciseFromBaseExercise(exerciseToCopy);
        const newSession = {
            exercises: (0, $kLgU7.immutableInsert)(newExercise, session.exercises, exerciseIndex)
        };
        await this.editSession(sessionIndex, newSession);
        (0, $ghfIB.libraryFilterManager).setLastAddedExerciseMetadata(newExercise.draggableId);
        if ((0, $ghfIB.libraryFilterManager).filteringState.get() === (0, $daNIT.LibraryFilteringState).COMPLEMENTARY && !skipOnboardings) await this.onboardingManager.passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).COMPLEMENTARY_EXERCISES_GUIDE_03);
    }
    duplicateExercise(sessionIndex, exerciseIndex) {
        const session = this._editedProgram.get().days.get(sessionIndex);
        const newSession = {
            exercises: (0, $kLgU7.immutableInsert)(session.exercises[exerciseIndex], session.exercises, exerciseIndex + 1, this.createExerciseCopy)
        };
        this.editSession(sessionIndex, newSession);
    }
    duplicateSession(sourceSessionIndex, destinationSessionIndex) {
        const sourceSession = this._editedProgram.get().days.get(sourceSessionIndex);
        const newSession = this.createSessionCopy(sourceSession);
        this.editSession(destinationSessionIndex, newSession);
    }
    clearSession(sessionIndex) {
        const emptySession = {
            exercises: []
        };
        this.editSession(sessionIndex, emptySession);
    }
    deleteExercise(sessionIndex, exerciseIndex) {
        const session = this._editedProgram.get().days.get(sessionIndex);
        const exercises = Array.from(session.exercises);
        exercises.splice(exerciseIndex, 1);
        const newSession = {
            exercises: exercises
        };
        this.editSession(sessionIndex, newSession);
    }
    moveExercise(sourceSessionIndex, sourceExerciseIndex, destinationSessionIndex, destinationExerciseIndex) {
        const editedProgram = this._editedProgram.get();
        const sourceSession = editedProgram.days.get(sourceSessionIndex);
        const movedExercise = sourceSession.exercises[sourceExerciseIndex];
        const destinationSession = editedProgram.days.get(destinationSessionIndex);
        const { newSource: newSource, newDestination: newDestination } = (0, $kLgU7.move)(sourceSession.exercises, destinationSession.exercises, sourceExerciseIndex, destinationExerciseIndex);
        const newProgram = {
            ...editedProgram,
            days: new (0, $c9OC9.ProgramDays)(editedProgram.days.map(([dayIndex, session])=>{
                if (dayIndex === sourceSessionIndex) return [
                    dayIndex,
                    {
                        exercises: newSource
                    }
                ];
                if (dayIndex === destinationSessionIndex) return [
                    dayIndex,
                    {
                        exercises: newDestination
                    }
                ];
                return [
                    dayIndex,
                    session
                ];
            }))
        };
        this.hideComplementaryGuideIfNeeded(movedExercise.draggableId);
        this.editProgram(newProgram);
    }
    async editProgram(newProgramContent) {
        this._editedProgram.set(newProgramContent);
    }
    renameProgram(newName) {
        this._editedProgram.set({
            ...this._editedProgram.get(),
            name: newName
        });
    }
    editProgramDates(startDate, endDate) {
        this._editedProgram.set({
            ...this._editedProgram.get(),
            startDate: startDate,
            endDate: endDate
        });
    }
    async editSession(sessionIndex, newSession) {
        const editedProgram = this._editedProgram.get();
        const newProgram = {
            ...editedProgram,
            days: new (0, $c9OC9.ProgramDays)(editedProgram.days.map(([dayIndex, session])=>[
                    dayIndex,
                    dayIndex === sessionIndex ? newSession : session
                ]))
        };
        await this.editProgram(newProgram);
    }
    editExercise(exerciseDraggableId, newExercise) {
        const editedProgram = this._editedProgram.get();
        this.editProgram((0, $eAmnG.updateExerciseFromProgram)(editedProgram, exerciseDraggableId, newExercise));
    }
    async addLibraryExerciseToAlternatives(exercise, alternativeExerciseIndex) {
        const editedExerciseWithAlternatives = (0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited.get();
        const newAlternative = this.createExerciseCopy(exercise);
        if ((0, $lTdpc.isNil)(editedExerciseWithAlternatives) || !this.isNewAlternativeValid(editedExerciseWithAlternatives, newAlternative)) return;
        (0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited.set({
            ...editedExerciseWithAlternatives,
            alternativeExercises: (0, $kLgU7.immutableInsert)(newAlternative, editedExerciseWithAlternatives.alternativeExercises, alternativeExerciseIndex)
        });
        (0, $ghfIB.libraryFilterManager).setLastAddedExerciseMetadata(newAlternative.draggableId, true);
    // Alternative onboarding steps removed: no onboarding step to pass here
    }
    reorderAlternativeExercises(sourceAlternativeExerciseIndex, destinationAlternativeExerciseIndex) {
        (0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited.update((exercise)=>(0, $lTdpc.isNotNil)(exercise) ? {
                ...exercise,
                alternativeExercises: (0, $kLgU7.reorder)(exercise.alternativeExercises, sourceAlternativeExerciseIndex, destinationAlternativeExerciseIndex)
            } : null);
    }
    updateAlternativeFromEditedExercise(exercise) {
        const editedExercise = (0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited.get();
        if ((0, $lTdpc.isNil)(editedExercise)) return;
        (0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited.set({
            ...editedExercise,
            alternativeExercises: editedExercise.alternativeExercises.map((alternative)=>alternative.draggableId === exercise.draggableId ? exercise : alternative)
        });
    }
    removeAlternativeFromExercise(alternative) {
        (0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited.update((exercise)=>(0, $lTdpc.isNotNil)(exercise) ? {
                ...exercise,
                alternativeExercises: exercise.alternativeExercises.filter((a)=>a.id !== alternative.id)
            } : null);
    }
    getExerciseIndex(exerciseDraggableId) {
        const editedProgram = this._editedProgram.get();
        for (const [dayIndex, session] of editedProgram.days.entries){
            const exerciseIndex = session.exercises.findIndex((ex)=>ex.draggableId === exerciseDraggableId);
            if (exerciseIndex > -1) return {
                sessionIndex: dayIndex,
                exerciseIndex: exerciseIndex
            };
        }
        return null;
    }
    getExerciseCount() {
        const editedProgram = this._editedProgram.get();
        let exerciseCount = 0;
        editedProgram.days.forEach(([, session])=>{
            exerciseCount += session.exercises.length;
        });
        return exerciseCount;
    }
    getExerciseCountInSession(sessionIndex) {
        const editedProgram = this._editedProgram.get();
        return editedProgram.days.get(sessionIndex).exercises.length;
    }
    getDaySessions(sessionIndex) {
        const editedProgram = this._editedProgram.get();
        return editedProgram.days.get(sessionIndex).exercises;
    }
    getAlternativeExerciseCount() {
        const editedProgram = this._editedProgram.get();
        let alternativeExerciseCount = 0;
        editedProgram.days.forEach(([, session])=>{
            session.exercises.forEach((exercise)=>{
                alternativeExerciseCount += exercise.alternativeExercises.length;
            });
        });
        return alternativeExerciseCount;
    }
    setDataIsLoading(isLoading) {
        this._dataIsLoading.set(isLoading);
    }
    setExerciseWithAlternativesEdited(exercise) {
        (0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited.set(exercise);
    }
    applyChangesAndResetEditedExercise() {
        const editedExercise = (0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited.get();
        if ((0, $lTdpc.isNil)(editedExercise)) return;
        this.editExercise(editedExercise.draggableId, editedExercise);
        (0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited.set(null);
        this.cleanAlternativeExerciseError();
    }
    cleanAlternativeExerciseError() {
        this._alternativeError.set(null);
    }
    createExerciseCopy(exercise) {
        return {
            ...exercise,
            draggableId: (0, $aAhWR.default)()
        };
    }
    createMainExerciseFromBaseExercise(baseExercise) {
        return {
            ...this.createExerciseCopy(baseExercise),
            alternativeExercises: []
        };
    }
    createSessionCopy(session) {
        return {
            exercises: session.exercises.map((exercise)=>this.createExerciseCopy(exercise))
        };
    }
    hideComplementaryGuideIfNeeded(movedExerciseDraggableId) {
        const lastAdded = (0, $ghfIB.libraryFilterManager).lastAddedExerciseMetadata.get();
        if ((0, $ghfIB.libraryFilterManager).filteringState.get() === (0, $daNIT.LibraryFilteringState).COMPLEMENTARY && (0, $iglNQ.complementaryGuide3ForceVisible).get() && lastAdded?.isComplementary && lastAdded.draggableId === movedExerciseDraggableId) (0, $iglNQ.hideComplementaryGuide3)();
    }
    isNewAlternativeValid(exercise, newAlternativeExercise) {
        if (exercise.alternativeExercises.length === (0, $cYBw6.MAX_ALTERNATIVE_EXERCISES)) {
            this._alternativeError.set((0, $cYBw6.AlternativeErrorType).MaxExercisesReached);
            return false;
        } else if ([
            exercise,
            ...exercise.alternativeExercises
        ].find((a)=>a.id === newAlternativeExercise.id)) {
            this._alternativeError.set((0, $cYBw6.AlternativeErrorType).ThisAlreadyExists);
            return false;
        }
        return true;
    }
    getFirstExerciseDraggableId(programDays) {
        let firstExerciseId;
        const reorderedDayIndexes = (0, $eAmnG.getDayColumnIndexes)();
        reorderedDayIndexes.some((dayIndex)=>{
            const session = programDays.get(dayIndex);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($jTpg0))).isEmpty(session.exercises)) {
                firstExerciseId = session.exercises[0].draggableId;
                return true;
            }
            return false;
        });
        return firstExerciseId;
    }
}



var $5SzTW = parcelRequire("5SzTW");

var $4UKJF = parcelRequire("4UKJF");

var $6Px22 = parcelRequire("6Px22");

var $243Cr = parcelRequire("243Cr");

var $9XVwj = parcelRequire("9XVwj");

var $lKGAO = parcelRequire("lKGAO");

var $lDZlX = parcelRequire("lDZlX");

var $2hf1V = parcelRequire("2hf1V");
/* eslint-disable sonarjs/no-duplicate-string */ 
var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $eAmnG = parcelRequire("eAmnG");

var $5SzTW = parcelRequire("5SzTW");

var $kkH7g = parcelRequire("kkH7g");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5kXMA = parcelRequire("5kXMA");

var $1eHG3 = parcelRequire("1eHG3");

var $eOSo1 = parcelRequire("eOSo1");

var $243Cr = parcelRequire("243Cr");

var $81g6h = parcelRequire("81g6h");

var $hE6rp = parcelRequire("hE6rp");

var $aanF2 = parcelRequire("aanF2");
var $hE6rp = parcelRequire("hE6rp");
function $ecae20262ad72252$export$111b8d00ddadaa34(pendingChanges) {
    const logger = (0, $eOSo1.getLogger)("\uD83E\uDDBA [useQuitBlocking]");
    const { format: format } = (0, $1eHG3.useI18n)();
    const message = format("global.nativeBlockModal");
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const navigate = (0, $hE6rp.useNavigate)();
    const [dialogOpen, setDialogOpen] = (0, $81g6h.useState)(false);
    const pendingNavigationRef = (0, $81g6h.useRef)(null);
    (0, $aanF2.useBeforeUnload)((event)=>{
        if (pendingChanges) {
            logger.debug("Navigation blocked, changes have been detected while reloading the page");
            event.preventDefault();
        }
    });
    (0, $hE6rp.useBlocker)(({ currentLocation: currentLocation, nextLocation: nextLocation })=>{
        if (dialogOpen || !pendingChanges) {
            logger.debug("Navigation unblocked: dialogOpen = ", dialogOpen, " pendingChanges", pendingChanges);
            return false;
        }
        logger.debug("Open dialog");
        pendingNavigationRef.current = nextLocation;
        setDialogOpen(true);
        dialogContext?.openModal((0, $243Cr.ModalId).SaveChanges, {
            onConfirm: ()=>{
                const target = pendingNavigationRef.current;
                pendingNavigationRef.current = null;
                logger.debug("Confirm pressed, navigating to next location : ", target, " from current location : ", currentLocation);
                if (target) navigate(target.pathname + target.search + target.hash);
            },
            onCancel: ()=>{
                pendingNavigationRef.current = null;
                setDialogOpen(false);
            },
            message: message
        });
        return pendingChanges;
    });
}



var $iKObn = parcelRequire("iKObn");

var $2jrEq = parcelRequire("2jrEq");

var $ghfIB = parcelRequire("ghfIB");

var $eAmnG = parcelRequire("eAmnG");

var $5UMQ1 = parcelRequire("5UMQ1");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $bFakw = parcelRequire("bFakw");

var $eAmnG = parcelRequire("eAmnG");

var $isRr9 = parcelRequire("isRr9");

var $c9OC9 = parcelRequire("c9OC9");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5kXMA = parcelRequire("5kXMA");

var $dVArM = parcelRequire("dVArM");

var $cYBw6 = parcelRequire("cYBw6");

var $5r5yY = parcelRequire("5r5yY");

var $3EwEG = parcelRequire("3EwEG");

var $41K57 = parcelRequire("41K57");

var $iKObn = parcelRequire("iKObn");

var $bFakw = parcelRequire("bFakw");

var $kkH7g = parcelRequire("kkH7g");

var $5UMQ1 = parcelRequire("5UMQ1");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $hLaGu = parcelRequire("hLaGu");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");

var $5WGN2 = parcelRequire("5WGN2");

var $cfkGk = parcelRequire("cfkGk");
parcelRequire("81g6h");
var $db32118662d8087f$var$BedIcon = function BedIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.874 4.288a8 8 0 1 0 9.838 9.838 7.363 7.363 0 0 1-9.838-9.838Zm-3.43-.603A10 10 0 0 1 12 2a1 1 0 0 1 .707 1.707 5.364 5.364 0 0 0 7.586 7.586A1 1 0 0 1 22 12 10 10 0 1 1 6.444 3.685Z",
            fill: "currentColor"
        })
    });
};
$db32118662d8087f$var$BedIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $db32118662d8087f$var$ClockIcon = function ClockIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.187 2.936a1 1 0 0 1 1-1h3.626a1 1 0 0 1 0 2h-3.626a1 1 0 0 1-1-1ZM12 7.56a6.251 6.251 0 1 0 0 12.503 6.251 6.251 0 0 0 0-12.503Zm-8.251 6.252a8.251 8.251 0 1 1 16.502 0 8.251 8.251 0 0 1-16.502 0Zm11.677-3.427a1 1 0 0 1 0 1.415l-2.719 2.719a1 1 0 0 1-1.414-1.414l2.72-2.72a1 1 0 0 1 1.413 0Z",
            fill: "currentColor"
        })
    });
};
$db32118662d8087f$var$ClockIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $db32118662d8087f$var$ListIcon = function ListIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M3 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM8 5a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2H8Zm-5 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm5 .5a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2H8Zm-5 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm5 .5a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2H8Z",
            fill: "currentColor"
        })
    });
};
$db32118662d8087f$var$ListIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $db32118662d8087f$export$5f587fb3fa527cfe = ({ session: session, className: className })=>{
    const { format: format, formatDuration: formatDuration } = (0, $1eHG3.useI18n)();
    const sessionTimeInSec = session.exercises.reduce((total, exercise)=>total + exercise.setCount * ((0, $hLaGu.isDurationExercise)(exercise) ? exercise.units : exercise.units * (0, $hLaGu.REPETITION_TIME_IN_SEC)), 0);
    return /*#__PURE__*/ (0, $iKObn.jsx)($db32118662d8087f$var$ColumnHeader, {
        className: (0, $cfkGk.classNames)("p-size-s-bold", className),
        children: session.exercises.length === 0 ? /*#__PURE__*/ (0, $iKObn.jsxs)($db32118662d8087f$var$ColumnHeaderDetails, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)($db32118662d8087f$var$BedIcon, {
                    width: "16",
                    height: "16"
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                    children: format("programBuilder.dayTable.emptyColumn")
                })
            ]
        }) : /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsxs)($db32118662d8087f$var$ColumnHeaderDetails, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)($db32118662d8087f$var$ListIcon, {
                            width: "16",
                            height: "16"
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                            children: session.exercises.length
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $iKObn.jsxs)($db32118662d8087f$var$ColumnHeaderDetails, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)($db32118662d8087f$var$ClockIcon, {
                            width: "16",
                            height: "16",
                            style: {
                                marginBottom: 2
                            }
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                            children: /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                                children: formatDuration(sessionTimeInSec)
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $db32118662d8087f$var$ColumnHeader = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(10, "center", "center")}
	border-radius: 8px;
	padding: 8px;
	line-height: 1.375rem;
	color: ${(0, $kKnoQ.colors).grey};
`;
const $db32118662d8087f$var$ColumnHeaderDetails = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(4, "center", "center")};
`;



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $amllh = parcelRequire("amllh");

var $02Kb9 = parcelRequire("02Kb9");

var $eGyIe = parcelRequire("eGyIe");

var $1IWnK = parcelRequire("1IWnK");
const $fb718c2fd2914ade$export$92102eab40aff691 = (0, $1IWnK.observable)(false);
const $fb718c2fd2914ade$export$39e11fc2bc349603 = ()=>{
    setTimeout(()=>{
        $fb718c2fd2914ade$export$92102eab40aff691.set(true);
    }, 0);
};
const $fb718c2fd2914ade$export$c64d9123fce3eb90 = ()=>{
    $fb718c2fd2914ade$export$92102eab40aff691.set(false);
};



var $ghfIB = parcelRequire("ghfIB");

var $eAmnG = parcelRequire("eAmnG");

var $isRr9 = parcelRequire("isRr9");

var $243Cr = parcelRequire("243Cr");

var $lKGAO = parcelRequire("lKGAO");

var $5e5pP = parcelRequire("5e5pP");

var $41NLE = parcelRequire("41NLE");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");
const $f7fcc588de372ceb$export$4da6e3f66c58b328 = (editedProgram)=>{
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const exerciseDragAndDropContext = (0, $81g6h.useContext)((0, $41NLE.ExerciseDragAndDropContext));
    const trackingContext = (0, $81g6h.useContext)((0, $lKGAO.TrackingContext));
    const openDuplicateColumnModal = (0, $81g6h.useCallback)((sourceDayIndex)=>dialogContext?.openModal((0, $243Cr.ModalId).DuplicateDayColumn, {
            initialDayColumns: new Map((0, $eAmnG.getDayColumnIndexes)().map((dayIndex)=>{
                let columnState = (0, $5e5pP.DayColumnState).AVAILABLE;
                if (sourceDayIndex === dayIndex) columnState = (0, $5e5pP.DayColumnState).SOURCE;
                else {
                    const session = editedProgram.days.get(dayIndex);
                    if ((0, $lTdpc.isNotNil)(session) && session.exercises.length > 0) columnState = (0, $5e5pP.DayColumnState).NOT_AVAILABLE;
                }
                return [
                    dayIndex,
                    columnState
                ];
            })),
            onConfirm: (sourceSessionIndex, destinationSessionIndexes)=>{
                destinationSessionIndexes.forEach((destinationSessionIndex)=>exerciseDragAndDropContext?.programEditor.duplicateSession(sourceSessionIndex, destinationSessionIndex));
                (0, $ghfIB.analyticsService).trackEvent({
                    category: trackingContext.category,
                    action: "duplicateSession",
                    params: [
                        destinationSessionIndexes.length
                    ]
                });
                if (destinationSessionIndexes.length > 0) (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).DUPLICATE_SESSION_GUIDE_02);
            }
        }), [
        dialogContext,
        editedProgram.days,
        exerciseDragAndDropContext?.programEditor,
        trackingContext.category
    ]);
    const onClearSession = (0, $81g6h.useCallback)((dayIndex)=>{
        exerciseDragAndDropContext?.programEditor.clearSession(dayIndex);
        (0, $ghfIB.analyticsService).trackEvent({
            category: trackingContext.category,
            action: "clearSession",
            params: []
        });
    }, [
        exerciseDragAndDropContext?.programEditor,
        trackingContext.category
    ]);
    return {
        openDuplicateColumnModal: openDuplicateColumnModal,
        onClearSession: onClearSession
    };
};


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");

var $isRr9 = parcelRequire("isRr9");

var $ghfIB = parcelRequire("ghfIB");
var $bbff0d9e591ef7dc$var$DeleteIcon = function DeleteIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M10.82 2c-.52 0-1.01.2-1.38.57L9.01 3h-5c-.13 0-.26.02-.39.07a1.004 1.004 0 0 0-.55.55c-.05.12-.07.25-.07.39s.02.26.07.39c.05.12.13.23.22.33.1.09.21.17.33.22.13.05.26.07.39.07h16c.13 0 .26-.02.39-.07a1.004 1.004 0 0 0 .55-.55c.05-.12.07-.25.07-.39s-.02-.26-.07-.39a1.19 1.19 0 0 0-.22-.33c-.1-.09-.21-.17-.33-.22-.13-.05-.26-.07-.39-.07h-5l-.43-.43A1.92 1.92 0 0 0 13.2 2h-2.38ZM16.13 22H7.88c-1.5 0-2.78-1.05-2.97-2.447L3.409 8.136a1 1 0 0 1 .991-1.13h15.22a1 1 0 0 1 .991 1.13L19.11 19.534C18.9 20.95 17.62 22 16.13 22ZM5.5 8.88l1.39 10.448c.06.44.5.797.99.797h8.25c.5 0 .93-.356 1-.825l1.39-10.42H5.5Z",
            fill: "currentColor"
        })
    });
};
$bbff0d9e591ef7dc$var$DeleteIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $bbff0d9e591ef7dc$var$DuplicateIcon = function DuplicateIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M4 2a2 2 0 0 0-2 2v13a1 1 0 0 0 2 0V4h13a1 1 0 0 0 0-2H4Zm4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H8Zm0 2h12v12H8V8Z",
            fill: "currentColor"
        })
    });
};
$bbff0d9e591ef7dc$var$DuplicateIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $bbff0d9e591ef7dc$export$4b7cb178afaad337 = ({ editedProgram: editedProgram, dayIndex: dayIndex, showQuickstartHalo: showQuickstartHalo = false })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { openDuplicateColumnModal: openDuplicateColumnModal, onClearSession: onClearSession } = (0, $f7fcc588de372ceb$export$4da6e3f66c58b328)(editedProgram);
    const [showDuplicateItemHalo, setShowDuplicateItemHalo] = (0, $81g6h.useState)(false);
    const duplicateGuide = format("programBuilder.quickstart.step.duplicateSession.guide02");
    return /*#__PURE__*/ (0, $iKObn.jsx)($bbff0d9e591ef7dc$var$MenuButtonContainer, {
        children: /*#__PURE__*/ (0, $iKObn.jsx)($bbff0d9e591ef7dc$var$StyledTooltip, {
            interactive: true,
            visible: showQuickstartHalo,
            appendTo: ()=>document.body,
            zIndex: 10000,
            popperOptions: {
                strategy: "fixed"
            },
            placement: "right",
            content: /*#__PURE__*/ (0, $iKObn.jsx)((0, $eGyIe.OnboardingPanel), {
                onClose: (e)=>{
                    (0, $fb718c2fd2914ade$export$c64d9123fce3eb90)();
                    e.stopPropagation();
                },
                text: duplicateGuide
            }),
            onClickOutside: ()=>(0, $fb718c2fd2914ade$export$c64d9123fce3eb90)(),
            onHidden: ()=>(0, $fb718c2fd2914ade$export$c64d9123fce3eb90)(),
            children: /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)($bbff0d9e591ef7dc$var$StyledMenuButton, {
                    shouldDisplayHalo: showQuickstartHalo,
                    onMenuClick: ()=>{
                        (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).DUPLICATE_SESSION_GUIDE_01);
                        if (showQuickstartHalo) {
                            setShowDuplicateItemHalo(true);
                            (0, $fb718c2fd2914ade$export$c64d9123fce3eb90)();
                        }
                    },
                    menuItems: [
                        {
                            icon: /*#__PURE__*/ (0, $iKObn.jsx)($bbff0d9e591ef7dc$var$DuplicateIcon, {}),
                            text: format("programBuilder.dayTable.columnMenu.duplicate"),
                            onClick: ()=>{
                                setShowDuplicateItemHalo(false);
                                openDuplicateColumnModal(dayIndex);
                            },
                            shouldDisplayHaloItem: showDuplicateItemHalo
                        },
                        {
                            icon: /*#__PURE__*/ (0, $iKObn.jsx)($bbff0d9e591ef7dc$var$DeleteIcon, {}),
                            text: format("programBuilder.dayTable.columnMenu.clear"),
                            onClick: ()=>{
                                setShowDuplicateItemHalo(false);
                                onClearSession(dayIndex);
                            },
                            destructive: true
                        }
                    ],
                    menuIconColor: (0, $kKnoQ.colors).black,
                    menuIconSize: 24
                })
            })
        })
    });
};
const $bbff0d9e591ef7dc$var$StyledMenuButton = (0, $5UMQ1.default)((0, $amllh.MenuButton))`
`;
const $bbff0d9e591ef7dc$var$MenuButtonContainer = (0, $5UMQ1.default).div`
	position: absolute;
	right: 0;
	top: 0;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		position: unset;
	}
`;
const $bbff0d9e591ef7dc$var$StyledTooltip = (0, $5UMQ1.default)((0, $02Kb9.Tooltip))`
	padding: 0;

	.tippy-arrow {
		color: ${(0, $kKnoQ.colors).onboardingPrimary};
	}

	.tippy-content {
		padding: 0;
	}
`;



var $lfEOz = parcelRequire("lfEOz");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
const $e5dd1d24cb192633$export$336e5598abe0aa93 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)($e5dd1d24cb192633$var$Placeholder, {
        onClick: ()=>(0, $ghfIB.libraryFilterManager).setSidebarVisible(true),
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($e5dd1d24cb192633$var$Text, {
            className: "p-size-xs-semi-bold",
            children: [
                format("programBuilder.dayTable.noExercisePlaceholder.title"),
                /*#__PURE__*/ (0, $iKObn.jsx)($e5dd1d24cb192633$var$LibraryContainer, {
                    children: format("programBuilder.dayTable.noExercisePlaceholder.libraryTitle")
                })
            ]
        })
    });
};
const $e5dd1d24cb192633$var$Text = (0, $5UMQ1.default).p`
	color: ${(0, $kKnoQ.colors).grey};
	max-width: 60%;
`;
const $e5dd1d24cb192633$var$LibraryContainer = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).primary};
	display: flex;
	place-items: center;
	place-content: center;
	gap: 4px;
`;
const $e5dd1d24cb192633$var$Placeholder = (0, $5UMQ1.default).div`
	display: grid;
	cursor: pointer;
	place-content: center;
	place-items: center;
	text-align: center;
	border-radius: 8px;
	background-color: ${(0, $kKnoQ.colors).primaryBackground};
	height: 124px;
	border: 1px solid ${(0, $kKnoQ.colors).transparent};
	:hover {
		border-color: ${(0, $kKnoQ.colors).primary};
	}
	:active {
		background-color: ${(0, $kKnoQ.colors).primary25};
	}
`;



var $2zGye = parcelRequire("2zGye");

var $kBALX = parcelRequire("kBALX");

var $h1dVk = parcelRequire("h1dVk");

var $ffhEE = parcelRequire("ffhEE");

var $kKnoQ = parcelRequire("kKnoQ");

var $5WGN2 = parcelRequire("5WGN2");

var $jKTFw = parcelRequire("jKTFw");

var $dDMmD = parcelRequire("dDMmD");

var $1IWnK = parcelRequire("1IWnK");


var $81g6h = parcelRequire("81g6h");

var $iZOKh = parcelRequire("iZOKh");
const $39cf9aa007c8193d$export$cd3675b00ed21432 = 300;
const $39cf9aa007c8193d$var$CARD_HEIGHT = 170;
const $39cf9aa007c8193d$export$1213300ca74857e3 = ({ title: title, session: session, index: index, isDropDisabled: isDropDisabled, updatedExerciseId: updatedExerciseId, programEditor: programEditor })=>{
    const editedProgram = (0, $1IWnK.useObservable)(programEditor.editedProgram);
    const { openExerciseDetailsModal: openExerciseDetailsModal } = (0, $kBALX.useEditorExerciseCardActions)();
    const { shouldAnimate: shouldAnimate } = (0, $h1dVk.useExerciseDragAndDrop)();
    const [isHovered, setIsHovered] = (0, $81g6h.useState)(false);
    const duplicateHalo = (0, $1IWnK.useObservable)((0, $fb718c2fd2914ade$export$92102eab40aff691));
    const firstNonEmptyDayIndex = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useMemo(()=>{
        const entries = editedProgram.days.entries;
        for(let i = 0; i < entries.length; i++){
            const [dayIdx, sess] = entries[i];
            if (sess.exercises.length > 0) return dayIdx;
        }
        return -1;
    }, [
        editedProgram
    ]);
    const componentRef = (0, $81g6h.useRef)(null);
    const [componentHeight, setComponentHeight] = (0, $81g6h.useState)(0);
    (0, $81g6h.useLayoutEffect)(()=>{
        if (componentRef.current) setComponentHeight(componentRef.current.clientHeight);
    }, [
        componentRef.current?.clientHeight
    ]);
    const allowDayColumnScroll = (0, $81g6h.useMemo)(()=>componentHeight < $39cf9aa007c8193d$var$CARD_HEIGHT * (session.exercises.length + 1), [
        componentHeight,
        session.exercises.length
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($39cf9aa007c8193d$var$DayColumnContent, {
        ref: componentRef,
        onMouseEnter: ()=>{
            setIsHovered(true);
        },
        onMouseOver: ()=>{
            setIsHovered(true);
        },
        onMouseLeave: ()=>{
            setIsHovered(false);
        },
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($39cf9aa007c8193d$var$ColumnTitle, {
                className: "p-size-l-bold",
                children: [
                    title,
                    session.exercises.length > 0 && /*#__PURE__*/ (0, $iKObn.jsx)((0, $bbff0d9e591ef7dc$export$4b7cb178afaad337), {
                        editedProgram: editedProgram,
                        dayIndex: index,
                        showQuickstartHalo: Boolean(duplicateHalo && index === firstNonEmptyDayIndex)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($39cf9aa007c8193d$var$ColumnContent, {
                isHovered: isHovered,
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($39cf9aa007c8193d$var$StyledDayColumnHeader, {
                        session: session
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $iZOKh.Droppable), {
                        droppableId: index.toString(),
                        isDropDisabled: isDropDisabled,
                        children: (provided, snapshot)=>/*#__PURE__*/ (0, $iKObn.jsxs)($39cf9aa007c8193d$var$List, {
                                id: "droppable_" + index,
                                ref: provided.innerRef,
                                isDraggingOver: snapshot.isDraggingOver,
                                allowScrolling: allowDayColumnScroll,
                                ...provided.droppableProps,
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsxs)($39cf9aa007c8193d$export$95d85c37ed8847e6, {
                                        active: shouldAnimate,
                                        children: [
                                            session.exercises.length === 0 && /*#__PURE__*/ (0, $iKObn.jsx)((0, $e5dd1d24cb192633$export$336e5598abe0aa93), {}),
                                            session.exercises.map((exercise, exerciseIndex)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $ffhEE.DraggableExerciseCard), {
                                                    className: "not-provided-placeholder",
                                                    exercise: exercise,
                                                    programEditor: programEditor,
                                                    index: exerciseIndex,
                                                    shouldAnimate: shouldAnimate,
                                                    onClick: ()=>openExerciseDetailsModal(exercise, session.exercises, (0, $bFakw.AnalyticsViewExerciseDetailOrigin).CANVAS),
                                                    onCommentIconClick: ()=>openExerciseDetailsModal(exercise, session.exercises, (0, $bFakw.AnalyticsViewExerciseDetailOrigin).CANVAS, (0, $2zGye.ExerciseDetailsDialogTabs).COMMENT),
                                                    updatedExerciseId: updatedExerciseId
                                                }, exercise.draggableId))
                                        ]
                                    }),
                                    provided.placeholder,
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $lfEOz.DayExercisePlaceholder), {
                                        className: "not-provided-placeholder",
                                        dayIndex: index,
                                        display: snapshot.isDraggingOver
                                    })
                                ]
                            })
                    })
                ]
            })
        ]
    });
};
const $39cf9aa007c8193d$export$95d85c37ed8847e6 = ({ active: active, children: children })=>active ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $dDMmD.AnimatePresence), {
        presenceAffectsLayout: true,
        children: children
    }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
        children: children
    });
const $39cf9aa007c8193d$var$spacedStack = ()=>(0, $5WGN2.stack)(0, "flexstart", "stretch");
const $39cf9aa007c8193d$var$DayColumnContent = (0, $5UMQ1.default).div`
	${$39cf9aa007c8193d$var$spacedStack()};
	flex: 1 !important;
	width: ${$39cf9aa007c8193d$export$cd3675b00ed21432}px;
	min-height: 0;
	background-color: ${(0, $kKnoQ.colors).white};
	border: 1px solid transparent;
`;
const $39cf9aa007c8193d$var$ColumnTitle = (0, $5UMQ1.default).div`
	text-align: center;
	display: grid;
	position: relative;
	place-items: center;
	height: 44px;
`;
const $39cf9aa007c8193d$var$ColumnContent = (0, $5UMQ1.default).div`
	border-radius: 16px;
	${$39cf9aa007c8193d$var$spacedStack()};
	background-color: ${(0, $kKnoQ.colors).primary10};
	flex: 1;
	min-height: 0;

	${({ isHovered: isHovered })=>isHovered && (0, $kkH7g.css)`
			outline: 1px solid ${(0, $kKnoQ.colors).primary25};
		`}
`;
const $39cf9aa007c8193d$var$StyledDayColumnHeader = (0, $5UMQ1.default)((0, $db32118662d8087f$export$5f587fb3fa527cfe))`
	margin: ${(0, $lfEOz.SESSION_DROPPABLE_HORIZONTAL_PADDING)}px;
`;
const $39cf9aa007c8193d$var$List = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "flexstart", "stretch")};
	padding: 0 ${(0, $lfEOz.SESSION_DROPPABLE_HORIZONTAL_PADDING)}px;
	flex: 1 1 auto;
	overflow-y: ${({ allowScrolling: allowScrolling })=>allowScrolling ? "auto" : "unset"};
	max-width: 100%;
	height: 150px;
	position: relative;

	> * {
		margin-bottom: ${(0, $lfEOz.ITEM_SPACING)}px;

		&:not(.not-provided-placeholder) {
			width: 100% !important;
		}
	}

	${(0, $jKTFw.getScrollbarStyle)(6)};
	// css for browser supporting -webkit-scrollbar which is not the case of Firefox
	@supports not (-moz-appearance: none) {
		padding-right: ${(0, $lfEOz.SESSION_DROPPABLE_HORIZONTAL_PADDING) - 2}px;
		margin-right: 2px;
	}
`;




var $2zGye = parcelRequire("2zGye");

var $41NLE = parcelRequire("41NLE");

var $kBALX = parcelRequire("kBALX");

var $h1dVk = parcelRequire("h1dVk");

var $ffhEE = parcelRequire("ffhEE");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $jKTFw = parcelRequire("jKTFw");

var $lTdpc = parcelRequire("lTdpc");

var $dU78w = parcelRequire("dU78w");

var $1IWnK = parcelRequire("1IWnK");

var $9d072 = parcelRequire("9d072");

var $81g6h = parcelRequire("81g6h");

var $iZOKh = parcelRequire("iZOKh");
const $3f06a0234463987f$var$PANEL_WIDTH = 308;
const $3f06a0234463987f$var$PANEL_MARGIN = 16;
const $3f06a0234463987f$var$ONBOARDING_PANEL_MARGIN = 8;
const $3f06a0234463987f$var$computeEmptyPanelHeight = ()=>{
    const separatorHeight = 26;
    const exerciseCardWithoutRepsHeight = 87.5;
    return (0, $3EwEG.AlternativeExerciseHeaderHeight) + exerciseCardWithoutRepsHeight + separatorHeight + (0, $41K57.NO_ALTERNATIVE_PLACEHOLDER_HEIGHT) + 12;
};
const $3f06a0234463987f$var$computePanelHeight = (alternativesLength, onboardingPanelHeight)=>{
    const exerciseCardHeight = 140;
    return $3f06a0234463987f$var$computeEmptyPanelHeight() + (8 + exerciseCardHeight) * alternativesLength + onboardingPanelHeight + $3f06a0234463987f$var$ONBOARDING_PANEL_MARGIN;
};
const $3f06a0234463987f$export$7d358f54fc1821df = ({ exercise: exercise, programEditor: programEditor, scrollContainerRef: scrollContainerRef })=>{
    (0, $1eHG3.useI18n)();
    const { shouldAnimate: shouldAnimate } = (0, $h1dVk.useExerciseDragAndDrop)();
    const error = (0, $1IWnK.useMemoizedObservable)(()=>programEditor.alternativeError, [
        programEditor
    ]);
    const editedExercise = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited);
    const mainAndAlternativeExercises = [
        exercise,
        ...exercise.alternativeExercises
    ];
    const topOnboardingPanelRef = (0, $81g6h.useRef)(null);
    const [topOnboardingPanelHeight, setTopOnboardingPanelHeight] = (0, $81g6h.useState)(0);
    const bottomOnboardingPanelRef = (0, $81g6h.useRef)(null);
    const [bottomOnboardingPanelHeight, setBottomOnboardingPanelHeight] = (0, $81g6h.useState)(0);
    (0, $81g6h.useLayoutEffect)(()=>{
        if ((0, $lTdpc.isNotNil)(topOnboardingPanelRef.current)) {
            const { height: height } = topOnboardingPanelRef.current.getBoundingClientRect();
            setTopOnboardingPanelHeight(height);
        }
        if ((0, $lTdpc.isNotNil)(bottomOnboardingPanelRef.current)) {
            const { height: height } = bottomOnboardingPanelRef.current.getBoundingClientRect();
            setBottomOnboardingPanelHeight(height);
        }
    }, []);
    const getAlternativePanelPosition = (0, $81g6h.useCallback)((i)=>{
        const columnIndex = (i ?? 0) % 7;
        return (columnIndex + 1) * (0, $eba2e8dd5c09cae0$export$67dd10eb4f98d630) + (columnIndex + 0.5) * (0, $39cf9aa007c8193d$export$cd3675b00ed21432) - $3f06a0234463987f$var$PANEL_WIDTH / 2 - (scrollContainerRef.current?.scrollLeft ?? 0);
    }, [
        scrollContainerRef
    ]);
    const panelPosition = (0, $81g6h.useMemo)(()=>{
        const cardElement = document.getElementById(editedExercise?.draggableId ?? "");
        if ((0, $lTdpc.isNotNil)(editedExercise) && (0, $lTdpc.isNotNil)(cardElement)) return {
            panelLeftPosition: getAlternativePanelPosition((0, $eAmnG.getLocaleDayColumnIndex)(programEditor.getExerciseIndex(editedExercise.draggableId)?.sessionIndex ?? (0, $c9OC9.DayIndex).SUNDAY)),
            cardTopPosition: document.getElementById(editedExercise.draggableId)?.getBoundingClientRect().top ?? 0
        };
        return null;
    }, [
        editedExercise,
        getAlternativePanelPosition,
        programEditor
    ]);
    const startPosition = (panelPosition?.cardTopPosition ?? 0) - (0, $3EwEG.AlternativeExerciseHeaderHeight) - (scrollContainerRef.current?.getBoundingClientRect().top ?? 0);
    const updateAlternativeFromEditedExercise = (0, $81g6h.useCallback)((updatedExercise)=>{
        programEditor.updateAlternativeFromEditedExercise(updatedExercise);
    }, [
        programEditor
    ]);
    const removeAlternative = (0, $81g6h.useCallback)((deletedAlternative)=>{
        (0, $bFakw.sendAnalyticsEventDeleteAlternativeExercises)(exercise, deletedAlternative);
        programEditor.removeAlternativeFromExercise(deletedAlternative);
    }, [
        programEditor,
        exercise
    ]);
    const { openExerciseDetailsModal: openExerciseDetailsModal } = (0, $kBALX.useEditorExerciseCardActions)();
    const shouldShowQuickstartTip = (0, $1IWnK.useObservable)((0, $9d072.alternativePanelQuickstartGuideRequested));
    const showGuide04 = (0, $1IWnK.useObservable)((0, $9d072.alternativeGuide3WasCompleted));
    (0, $81g6h.useEffect)(()=>{
        if (showGuide04 && shouldShowQuickstartTip) (0, $9d072.clearAlternativePanelQuickstartGuide)();
    }, [
        showGuide04,
        shouldShowQuickstartTip
    ]);
    // Auto-close the quickstart tip when an alternative is added
    const previousAlternativesCountRef = (0, $81g6h.useRef)(exercise.alternativeExercises.length);
    (0, $81g6h.useEffect)(()=>{
        const currentCount = exercise.alternativeExercises.length;
        const previousCount = previousAlternativesCountRef.current;
        if (shouldShowQuickstartTip && currentCount > previousCount) (async ()=>{
            await (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).ALTERNATIVE_EXERCISES_GUIDE_02);
            await (0, $ghfIB.onboardingManager).passStepOnboarding((0, $isRr9.OnboardingProgramQuickstartStep).ALTERNATIVE_EXERCISES_GUIDE_03);
            await (0, $ghfIB.onboardingManager).init();
            (0, $9d072.clearAlternativePanelQuickstartGuide)();
            (0, $9d072.hideAlternativeGuide3)();
            (0, $9d072.setAlternativeGuide3WasCompleted)();
        })();
        previousAlternativesCountRef.current = currentCount;
    }, [
        exercise.alternativeExercises.length,
        shouldShowQuickstartTip
    ]);
    const endPosition = (0, $81g6h.useMemo)(()=>{
        const columnHeight = (scrollContainerRef.current?.clientHeight ?? 0) + 22;
        const initCardHeight = $3f06a0234463987f$var$computeEmptyPanelHeight();
        const panelHeight = $3f06a0234463987f$var$computePanelHeight(exercise.alternativeExercises.length, topOnboardingPanelHeight + bottomOnboardingPanelHeight);
        const maxCardHeight = (columnHeight + initCardHeight) / 2 - $3f06a0234463987f$var$PANEL_MARGIN;
        if (panelHeight < maxCardHeight) return (columnHeight - initCardHeight) / 2;
        else return Math.max(columnHeight - panelHeight - 2 * $3f06a0234463987f$var$PANEL_MARGIN, $3f06a0234463987f$var$PANEL_MARGIN);
    }, [
        scrollContainerRef,
        exercise.alternativeExercises.length,
        topOnboardingPanelHeight,
        bottomOnboardingPanelHeight
    ]);
    const animatedStyle = {
        hidden: {
            top: startPosition,
            left: panelPosition?.panelLeftPosition,
            opacity: 0
        },
        visible: {
            opacity: 1,
            top: endPosition,
            left: panelPosition?.panelLeftPosition,
            transition: {
                type: "spring",
                stiffness: 150,
                damping: 15
            }
        },
        exit: {
            scale: 0.2,
            translateY: 158,
            left: panelPosition?.panelLeftPosition,
            opacity: 0,
            transition: {
                duration: 0.54,
                ease: "easeInOut"
            }
        }
    };
    return /*#__PURE__*/ (0, $iKObn.jsxs)($3f06a0234463987f$var$Container, {
        variants: animatedStyle,
        initial: "hidden",
        animate: "visible",
        exit: "exit",
        onClick: (e)=>e.stopPropagation(),
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $3EwEG.AlternativeExerciseHeader), {
                onCrossClicked: async ()=>{
                    programEditor.applyChangesAndResetEditedExercise();
                    await (0, $ghfIB.libraryFilterManager).clearLibraryFiltersAndSearch();
                    (0, $ghfIB.libraryFilterManager).clearActiveFilteringState();
                }
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $5r5yY.AlternativeError), {
                errorType: error,
                cleanError: ()=>programEditor.cleanAlternativeExerciseError()
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $ffhEE.ExerciseCard), {
                exercise: exercise,
                deviceType: (0, $5kXMA.ResponsiveDeviceType).Desktop,
                showAlternatives: false,
                onlyAllowPreview: true,
                hideContent: true,
                onClick: ()=>openExerciseDetailsModal(exercise, mainAndAlternativeExercises, (0, $bFakw.AnalyticsViewExerciseDetailOrigin).CANVAS),
                onCommentIconClick: ()=>openExerciseDetailsModal(exercise, mainAndAlternativeExercises, (0, $bFakw.AnalyticsViewExerciseDetailOrigin).CANVAS, (0, $2zGye.ExerciseDetailsDialogTabs).COMMENT)
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($3f06a0234463987f$var$Separator, {}),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $iZOKh.Droppable), {
                droppableId: (0, $41NLE.DROPPABLE_ID).Alternative,
                children: (provided, snapshot)=>/*#__PURE__*/ (0, $iKObn.jsxs)($3f06a0234463987f$var$AlternativeExercisesList, {
                        ref: provided.innerRef,
                        id: (0, $41NLE.DROPPABLE_ID).Alternative,
                        ...provided.droppableProps,
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $39cf9aa007c8193d$export$95d85c37ed8847e6), {
                                active: shouldAnimate,
                                children: exercise.alternativeExercises.map((ex, exerciseIndex, alternatives)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $dVArM.DraggableAlternativeExerciseCard), {
                                        className: "not-provided-placeholder",
                                        alternativeExercise: ex,
                                        relatedExercises: mainAndAlternativeExercises,
                                        index: exerciseIndex,
                                        shouldAnimate: shouldAnimate,
                                        alternatives: alternatives,
                                        alternativeExerciseIndex: exerciseIndex,
                                        updateExercise: updateAlternativeFromEditedExercise,
                                        onDelete: removeAlternative
                                    }, ex.draggableId))
                            }),
                            provided.placeholder,
                            exercise.alternativeExercises.length < (0, $cYBw6.MAX_ALTERNATIVE_EXERCISES) && /*#__PURE__*/ (0, $iKObn.jsx)((0, $41K57.NoAlternativeExercisePlaceholder), {
                                onClick: ()=>(0, $ghfIB.libraryFilterManager).setSidebarVisible(true),
                                display: !snapshot.isDraggingOver
                            })
                        ]
                    })
            })
        ]
    });
};
const $3f06a0234463987f$var$Container = (0, $5UMQ1.default)((0, $dU78w.motion).div)`
	position: absolute;
	width: ${$3f06a0234463987f$var$PANEL_WIDTH}px;
	padding: 0 12px 12px 12px;
	background-color: ${(0, $kKnoQ.colors).primary10};
	border-radius: 16px;
	max-height: calc(100% - 2 * 20px);
	z-index: 0;
	overflow-y: auto;
	${(0, $jKTFw.getScrollbarStyle)(6)};
`;
const $3f06a0234463987f$var$Separator = (0, $5UMQ1.default).div`
	margin: 12px 0;
	height: 2px;
	background-color: ${(0, $kKnoQ.colors).primary25};
`;
const $3f06a0234463987f$var$AlternativeExercisesList = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(8, "flexstart", "stretch")};
`;




var $kKnoQ = parcelRequire("kKnoQ");

var $5WGN2 = parcelRequire("5WGN2");

var $jKTFw = parcelRequire("jKTFw");

var $lTdpc = parcelRequire("lTdpc");

var $dDMmD = parcelRequire("dDMmD");
var $dU78w = parcelRequire("dU78w");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
const $eba2e8dd5c09cae0$export$67dd10eb4f98d630 = 12;
const $eba2e8dd5c09cae0$var$OVERLAY_STYLE = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            duration: 0.2
        }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 0.28
        }
    }
};
const $eba2e8dd5c09cae0$export$cd402b7558adf371 = ({ editedProgram: editedProgram, programEditor: programEditor, className: className })=>{
    const [dayIndexDisabled, setDayIndexDisabled] = (0, $81g6h.useState)(-1);
    const [updatedExerciseId, setUpdatedExerciseId] = (0, $81g6h.useState)();
    const scrollContainerRef = (0, $81g6h.useRef)(null);
    const mainContainerRef = (0, $81g6h.useRef)(null);
    const isSidebarVisible = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).sidebarVisible);
    const exerciseWithAlternativesEdited = (0, $1IWnK.useComputedObservable)(()=>(0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited.get(), [
        (0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited
    ]);
    // dayIndexDisabled is used to disable dropping dragged exercise on days that are not visible
    // (e.g: after scrolling to the right, the first day of the week could be under the exercise library)
    const updateDroppabledDays = ()=>{
        if (scrollContainerRef.current) {
            const daySize = scrollContainerRef.current.scrollWidth / 7;
            const daysDisabled = Math.round(scrollContainerRef.current.scrollLeft / daySize);
            setDayIndexDisabled(daysDisabled - 1);
        }
    };
    const onAlternativesPanelClose = (0, $81g6h.useCallback)(async ()=>{
        setUpdatedExerciseId(exerciseWithAlternativesEdited?.draggableId);
        programEditor.applyChangesAndResetEditedExercise();
        await (0, $ghfIB.libraryFilterManager).clearLibraryFiltersAndSearch();
        // Alternative onboarding step removed; no passStep here
        setTimeout(()=>setUpdatedExerciseId(undefined), 1000);
    }, [
        programEditor,
        exerciseWithAlternativesEdited?.draggableId
    ]);
    (0, $2jrEq.useKeyboardKeyPressed)({
        [(0, $2jrEq.KeyboardKeys).Escape]: ()=>{
            onAlternativesPanelClose();
        }
    });
    return /*#__PURE__*/ (0, $iKObn.jsxs)($eba2e8dd5c09cae0$var$MainContainer, {
        ref: mainContainerRef,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($eba2e8dd5c09cae0$var$OverflowBox, {
                ref: scrollContainerRef,
                onScroll: updateDroppabledDays,
                children: /*#__PURE__*/ (0, $iKObn.jsx)($eba2e8dd5c09cae0$var$DayTableContainer, {
                    className: className,
                    children: (0, $eAmnG.getDayColumnIndexes)().map((dayIndex, arrayIndex)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $39cf9aa007c8193d$export$1213300ca74857e3), {
                            title: (0, $eAmnG.formatDayColumn)(dayIndex, "long"),
                            session: editedProgram.days.get(dayIndex),
                            index: dayIndex,
                            isDropDisabled: arrayIndex <= dayIndexDisabled || (0, $lTdpc.isNotNil)(exerciseWithAlternativesEdited),
                            updatedExerciseId: updatedExerciseId,
                            programEditor: programEditor
                        }, dayIndex))
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $dDMmD.AnimatePresence), {
                initial: false,
                mode: "wait",
                children: (0, $lTdpc.isNotNil)(exerciseWithAlternativesEdited) && /*#__PURE__*/ (0, $iKObn.jsx)($eba2e8dd5c09cae0$var$Overlay, {
                    style: {
                        width: isSidebarVisible ? mainContainerRef.current?.clientWidth : "100%",
                        height: mainContainerRef.current?.clientHeight
                    },
                    onClick: onAlternativesPanelClose,
                    variants: $eba2e8dd5c09cae0$var$OVERLAY_STYLE,
                    initial: "hidden",
                    animate: "visible",
                    exit: "exit",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $3f06a0234463987f$export$7d358f54fc1821df), {
                        exercise: exerciseWithAlternativesEdited,
                        onClose: onAlternativesPanelClose,
                        programEditor: programEditor,
                        scrollContainerRef: scrollContainerRef
                    })
                })
            })
        ]
    });
};
const $eba2e8dd5c09cae0$var$MainContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "flexstart", "stretch")}
	width: 100%;
`;
const $eba2e8dd5c09cae0$var$DayTableContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)($eba2e8dd5c09cae0$export$67dd10eb4f98d630, "flexstart", "stretch")};
	background-color: ${(0, $kKnoQ.colors).white};
	flex-grow: 1;
	flex: none;

	padding: 20px 12px 16px 12px;

	> * {
		// css for browser supporting -webkit-scrollbar which is not the case of Firefox
		@supports not (-moz-appearance: none) {
			padding-bottom: 12px;
		}
	}
`;
const $eba2e8dd5c09cae0$var$OverflowBox = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, undefined, "stretch")};
	overflow-x: auto;
	flex: 1 0 auto;

	${(0, $jKTFw.getScrollbarStyle)(8)};
	// css for browser supporting -webkit-scrollbar which is not the case of Firefox
	@supports not (-moz-appearance: none) {
		margin-bottom: 4px;
	}
`;
const $eba2e8dd5c09cae0$var$Overlay = (0, $5UMQ1.default)((0, $dU78w.motion).div)`
	position: absolute;
	z-index: 11;
	background-color: rgba(0, 0, 0, 0.4);
	overflow-x: hidden;
`;



var $41NLE = parcelRequire("41NLE");

var $iKObn = parcelRequire("iKObn");

var $he9Ds = parcelRequire("he9Ds");

var $iV9Zw = parcelRequire("iV9Zw");

var $htiSH = parcelRequire("htiSH");

var $5SzTW = parcelRequire("5SzTW");

var $a6fIt = parcelRequire("a6fIt");

var $5UMQ1 = parcelRequire("5UMQ1");

var $a5hkt = parcelRequire("a5hkt");

var $243Cr = parcelRequire("243Cr");

var $amllh = parcelRequire("amllh");

var $5kXMA = parcelRequire("5kXMA");

var $lDZlX = parcelRequire("lDZlX");

var $iKObn = parcelRequire("iKObn");

var $a6fIt = parcelRequire("a6fIt");

var $jrnUx = parcelRequire("jrnUx");

var $5UMQ1 = parcelRequire("5UMQ1");

var $g8ETz = parcelRequire("g8ETz");

var $isRr9 = parcelRequire("isRr9");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
parcelRequire("81g6h");
const $06f7d348bd4277e0$export$6906986b9c4f9b75 = ({ primaryButton: primaryButton, secondaryButton: secondaryButton, primaryQuickstartTooltipVisible: primaryQuickstartTooltipVisible, onPrimaryQuickstartTooltipRequestClose: onPrimaryQuickstartTooltipRequestClose, primaryQuickstartTooltipStep: primaryQuickstartTooltipStep })=>/*#__PURE__*/ (0, $iKObn.jsxs)($06f7d348bd4277e0$var$ButtonContainer, {
        "data-test": (0, $a6fIt.e2eTestId).createTemplatePage.headerButtonContainer,
        children: [
            secondaryButton && /*#__PURE__*/ (0, $iKObn.jsx)((0, $jrnUx.TooltipButton), {
                id: "secondary-button-target",
                "data-test": (0, $a6fIt.e2eTestId).createTemplatePage.builderSecondaryButton,
                tooltipContent: secondaryButton.tooltip,
                className: "white-space-nowrap",
                disabled: secondaryButton.disabled,
                uiStyle: "secondary",
                onClick: secondaryButton.onClick,
                iconPos: "right",
                icon: secondaryButton.icon,
                loading: secondaryButton.loading,
                children: secondaryButton.label
            }),
            primaryButton && /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
                children: primaryQuickstartTooltipVisible ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $g8ETz.OnboardingTooltip), {
                    placement: "bottom",
                    visible: true,
                    onboardingStep: primaryQuickstartTooltipStep ?? (0, $isRr9.OnboardingProgramQuickstartStep).START_TEMPLATE_GUIDE_01,
                    onClose: (e)=>{
                        onPrimaryQuickstartTooltipRequestClose?.();
                        e.stopPropagation();
                    },
                    onClickOutside: onPrimaryQuickstartTooltipRequestClose,
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $jrnUx.TooltipButton), {
                            id: "primary-button-target",
                            "data-test": (0, $a6fIt.e2eTestId).createTemplatePage.builderPrimaryButton,
                            tooltipContent: primaryButton.tooltip,
                            className: "white-space-nowrap",
                            disabled: primaryButton.disabled,
                            onClick: primaryButton.onClick,
                            iconPos: "right",
                            icon: primaryButton.icon ?? "pi pi-calendar",
                            loading: primaryButton.loading,
                            children: primaryButton.label
                        })
                    })
                }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $jrnUx.TooltipButton), {
                    id: "primary-button-target",
                    "data-test": (0, $a6fIt.e2eTestId).createTemplatePage.builderPrimaryButton,
                    tooltipContent: primaryButton.tooltip,
                    className: "white-space-nowrap",
                    disabled: primaryButton.disabled,
                    onClick: primaryButton.onClick,
                    iconPos: "right",
                    icon: primaryButton.icon ?? "pi pi-calendar",
                    loading: primaryButton.loading,
                    children: primaryButton.label
                })
            })
        ]
    });
const $06f7d348bd4277e0$var$ButtonContainer = (0, $5UMQ1.default).div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 16px;
	margin-left: 16px;
	margin-right: 12px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		margin: unset;
		flex: 1;
		display: grid;
		grid-auto-flow: column;
		grid-auto-columns: minmax(0, 1fr);
		padding: 16px;
	}
`;



var $iKObn = parcelRequire("iKObn");

var $ccjD7 = parcelRequire("ccjD7");

var $lG6Cp = parcelRequire("lG6Cp");

var $aEP4N = parcelRequire("aEP4N");

var $6Yxa2 = parcelRequire("6Yxa2");

var $5UMQ1 = parcelRequire("5UMQ1");

var $2cfUo = parcelRequire("2cfUo");

var $1CiDH = parcelRequire("1CiDH");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");
const $b370b7d050060c5d$var$SEPARATOR = " - ";
const $b370b7d050060c5d$export$b3cce10d7b0b956a = (props)=>{
    const { patient: patient } = props;
    const { formatPatientName: formatPatientName } = (0, $aEP4N.useFormatPatients)();
    const { formatDisease: formatDisease } = (0, $lG6Cp.useFormatMedicalCondition)();
    const [textColor, setTextColor] = (0, $81g6h.useState)();
    return /*#__PURE__*/ (0, $iKObn.jsx)($b370b7d050060c5d$var$StyledTippy, {
        interactive: true,
        arrow: false,
        content: /*#__PURE__*/ (0, $iKObn.jsx)((0, $1CiDH.PatientDetailsContent), {
            patient: patient,
            isLightMode: true,
            isEditable: false
        }),
        onShow: ()=>setTextColor((0, $kKnoQ.colors).primary),
        onHide: ()=>setTextColor(undefined),
        placement: "bottom",
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($b370b7d050060c5d$var$MedicalCondition, {
            className: "p-size-xs-semi-bold",
            color: textColor,
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)($b370b7d050060c5d$var$PatientName, {
                    className: "p-size-xs-bold",
                    color: textColor,
                    children: formatPatientName(patient)
                }),
                !(0, $6Yxa2.isPendingPatient)(patient) && !(0, $ccjD7.isUnspecifiedDisease)(patient.disease) && $b370b7d050060c5d$var$SEPARATOR + formatDisease(patient.disease)
            ]
        })
    });
};
const $b370b7d050060c5d$var$MedicalCondition = (0, $5UMQ1.default).span`
	color: ${({ color: color = (0, $kKnoQ.colors).grey })=>color};

	&:hover,
	&:hover * {
		color: ${(0, $kKnoQ.colors).primary};
	}
`;
const $b370b7d050060c5d$var$PatientName = (0, $5UMQ1.default).span`
	color: ${({ color: color = (0, $kKnoQ.colors).black })=>color};
`;
const $b370b7d050060c5d$var$StyledTippy = (0, $5UMQ1.default)((0, $2cfUo.default))`
	background-color: ${(0, $kKnoQ.colors).white};
	border: 1px solid ${(0, $kKnoQ.colors).primary25};
	padding: 16px;
	border-radius: 16px;
	box-shadow: 0px 2px 8px 0px rgba(38, 38, 48, 0.16);
`;



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5SzTW = parcelRequire("5SzTW");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5kXMA = parcelRequire("5kXMA");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");
parcelRequire("81g6h");
var $dcc8df8d2b38b808$var$Arrow = function Arrow(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M10 5.342c-.256 0-.512.1-.707.295l-5.656 5.656a.999.999 0 0 0 0 1.414l5.656 5.656a.999.999 0 0 0 1.414 0l.086-.086a.999.999 0 0 0 0-1.414L6.93 13H20a1 1 0 0 0 0-2H6.93l3.863-3.863a.999.999 0 0 0 0-1.414l-.086-.086A.998.998 0 0 0 10 5.342Z",
            fill: "currentColor"
        })
    });
};
$dcc8df8d2b38b808$var$Arrow.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $dcc8df8d2b38b808$var$Calendar = function Calendar(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.677 5.773a.807.807 0 0 0-.807.807v12.647c0 .445.361.806.807.806h12.646a.807.807 0 0 0 .807-.806V6.58a.807.807 0 0 0-.807-.807H5.677ZM2.87 6.58a2.807 2.807 0 0 1 2.807-2.807h12.646A2.807 2.807 0 0 1 21.13 6.58v12.647a2.807 2.807 0 0 1-2.807 2.806H5.677a2.807 2.807 0 0 1-2.807-2.806V6.58Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.613 1.967a1 1 0 0 1 1 1V6.58a1 1 0 1 1-2 0V2.967a1 1 0 0 1 1-1ZM8.387 1.967a1 1 0 0 1 1 1V6.58a1 1 0 1 1-2 0V2.967a1 1 0 0 1 1-1ZM2.87 10.193a1 1 0 0 1 1-1h16.26a1 1 0 1 1 0 2H3.87a1 1 0 0 1-1-1Z",
                fill: "currentColor"
            })
        ]
    });
};
$dcc8df8d2b38b808$var$Calendar.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $dcc8df8d2b38b808$var$FinishFlag = function FinishFlag(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M5 2a1 1 0 0 0-1 1v18a1 1 0 1 0 2 0v-6h12c1.102 0 2-.898 2-2V4c0-1.102-.898-2-2-2H5Zm4 2h3v3h3V4h3v3h-3v3h3v3h-3v-3h-3v3H9v-3H6V7h3V4Zm0 3v3h3V7H9Z",
            fill: "currentColor"
        })
    });
};
$dcc8df8d2b38b808$var$FinishFlag.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $dcc8df8d2b38b808$var$SEPARATOR = "-";
const $dcc8df8d2b38b808$export$cd1d3fbb69b0d9ed = (props)=>{
    const { programStatus: programStatus, programContent: programContent, onClick: onClick } = props;
    const { formatDateMed: formatDateMed, formatDateShort: formatDateShort } = (0, $1eHG3.useI18n)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const isEnded = programStatus === (0, $5SzTW.ProgramStatus).Ended;
    const textColor = isEnded ? (0, $kKnoQ.colors).grey80 : (0, $kKnoQ.colors).grey;
    if ((0, $lTdpc.isNil)(programContent.startDate) || (0, $lTdpc.isNil)(programContent.endDate)) return null;
    return /*#__PURE__*/ (0, $iKObn.jsxs)($dcc8df8d2b38b808$var$DateContainer, {
        disabled: isEnded,
        onClick: !isEnded ? onClick : undefined,
        children: [
            isEnded ? /*#__PURE__*/ (0, $iKObn.jsx)($dcc8df8d2b38b808$var$StyledFinishFlag, {
                width: 24,
                height: 24,
                color: (0, $kKnoQ.colors).grey80
            }) : /*#__PURE__*/ (0, $iKObn.jsx)($dcc8df8d2b38b808$var$Calendar, {
                width: 24,
                height: 24,
                color: (0, $kKnoQ.colors).grey
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                className: "p-size-s-bold",
                style: {
                    color: textColor
                },
                children: isDesktop ? formatDateMed(programContent.startDate) : formatDateShort(programContent.startDate)
            }),
            !isDesktop ? /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                className: "p-size-s-bold",
                style: {
                    color: textColor
                },
                children: $dcc8df8d2b38b808$var$SEPARATOR
            }) : /*#__PURE__*/ (0, $iKObn.jsx)($dcc8df8d2b38b808$var$StyledArrow, {
                width: 24,
                height: 24,
                color: textColor
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                className: "p-size-s-bold",
                style: {
                    color: textColor
                },
                children: isDesktop ? formatDateMed(programContent.endDate) : formatDateShort(programContent.endDate)
            })
        ]
    });
};
const $dcc8df8d2b38b808$var$StyledFinishFlag = (0, $5UMQ1.default)($dcc8df8d2b38b808$var$FinishFlag)`
	transform: scaleX(-1);
`;
const $dcc8df8d2b38b808$var$StyledArrow = (0, $5UMQ1.default)($dcc8df8d2b38b808$var$Arrow)`
	transform: rotate(180deg);
`;
const $dcc8df8d2b38b808$var$DateContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(8, "center", "center")};
	max-width: max-content;
	padding: 16px 32px;
	border-radius: 32px;
	height: 56px;
	background-color: ${({ disabled: disabled })=>disabled ? (0, $kKnoQ.colors).grey10 : (0, $kKnoQ.colors).primary10};
	cursor: ${({ disabled: disabled })=>disabled ? "default" : "pointer"};
	border: 1px solid ${(0, $kKnoQ.colors).transparent};

	:hover {
		border: 1px solid ${({ disabled: disabled })=>disabled ? (0, $kKnoQ.colors).grey10 : (0, $kKnoQ.colors).primary25};
	}

	:focus {
		border: 1px solid ${({ disabled: disabled })=>disabled ? (0, $kKnoQ.colors).grey10 : (0, $kKnoQ.colors).primary};
	}

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 8px 24px;
		border-radius: 24px;
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding: 8px 16px;
	}
`;


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $cfkGk = parcelRequire("cfkGk");

var $81g6h = parcelRequire("81g6h");

var $hE6rp = parcelRequire("hE6rp");
var $f5a1a1c59d206855$var$ArrowLeft = function ArrowLeft(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M11.29 17.712a1.002 1.002 0 0 0 0-1.42L8 13.003h10a1 1 0 0 0 0-2H8l3.29-3.29a1.001 1.001 0 1 0-1.41-1.42l-4.29 4.3a2 2 0 0 0-.59 1.41 2 2 0 0 0 .59 1.4l4.29 4.3a1 1 0 0 0 1.41.01Z",
            fill: "currentColor"
        })
    });
};
$f5a1a1c59d206855$var$ArrowLeft.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $f5a1a1c59d206855$var$Arrow = function Arrow(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M10 5.342c-.256 0-.512.1-.707.295l-5.656 5.656a.999.999 0 0 0 0 1.414l5.656 5.656a.999.999 0 0 0 1.414 0l.086-.086a.999.999 0 0 0 0-1.414L6.93 13H20a1 1 0 0 0 0-2H6.93l3.863-3.863a.999.999 0 0 0 0-1.414l-.086-.086A.998.998 0 0 0 10 5.342Z",
            fill: "currentColor"
        })
    });
};
$f5a1a1c59d206855$var$Arrow.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $f5a1a1c59d206855$var$MenuIcon = function MenuIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M12 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 7a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 7a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z",
            fill: "currentColor"
        })
    });
};
$f5a1a1c59d206855$var$MenuIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $f5a1a1c59d206855$export$762dabf8c5869542 = (props)=>{
    const { patient: patient, programStatus: programStatus, programContent: programContent, statusMessage: statusMessage, primaryButton: primaryButton, secondaryButton: secondaryButton, programActions: programActions, onNameChanged: onNameChanged, onProgramSchedulerClick: onProgramSchedulerClick, editable: editable, primaryQuickstartTooltipVisible: primaryQuickstartTooltipVisible, onPrimaryQuickstartTooltipRequestClose: onPrimaryQuickstartTooltipRequestClose, primaryQuickstartTooltipStep: primaryQuickstartTooltipStep } = props;
    const [editing, setEditing] = (0, $81g6h.useState)(false);
    const [title, setTitle] = (0, $81g6h.useState)(programContent.name);
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const goBack = (0, $htiSH.useGoBack)();
    const navigate = (0, $htiSH.useNavigate)();
    const location = (0, $hE6rp.useLocation)();
    const { isInitialLocation: isInitialLocation } = (0, $iV9Zw.useHistory)();
    (0, $81g6h.useEffect)(()=>{
        setTitle(programContent.name);
    }, [
        programContent.name
    ]);
    const handleKeyDown = (event)=>{
        switch(event.key){
            case "Enter":
                onNameChanged(title);
                setEditing(false);
                break;
            case "Escape":
                setTitle(programContent.name);
                setEditing(false);
                break;
            default:
                break;
        }
    };
    const onGoBack = (0, $81g6h.useCallback)(()=>{
        if (isInitialLocation) navigate((0, $lDZlX.RoutesPath).Home);
        else location.pathname.startsWith((0, $lDZlX.RoutesPath).ProgramBuilder.split(":")[0]) ? navigate((0, $lDZlX.RoutesPath).ProgramList) : goBack();
    }, [
        goBack,
        isInitialLocation,
        navigate,
        location
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($f5a1a1c59d206855$var$Header, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($f5a1a1c59d206855$var$LeftContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $a5hkt.ButtonIcon), {
                        icon: isDesktop ? $f5a1a1c59d206855$var$ArrowLeft : $f5a1a1c59d206855$var$Arrow,
                        onClick: onGoBack,
                        size: "condensed",
                        testId: (0, $a6fIt.e2eTestId).createTemplatePage.headerBackButton
                    }),
                    isDesktop && /*#__PURE__*/ (0, $iKObn.jsxs)($f5a1a1c59d206855$var$Stack, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)($f5a1a1c59d206855$var$Top, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($f5a1a1c59d206855$var$TitleContainer, {
                                        editing: editing,
                                        onClick: ()=>editable && !editing && setEditing(true),
                                        children: editing ? /*#__PURE__*/ (0, $iKObn.jsx)($f5a1a1c59d206855$var$Input, {
                                            className: (0, $cfkGk.classNames)("p-size-l-bold flex-auto"),
                                            maxLength: (0, $he9Ds.APP_CONSTANTS).PROGRAM_OR_TEMPLATE_MAX_TITLE_LENGTH,
                                            type: "text",
                                            value: title,
                                            autoFocus: true,
                                            onBlur: ()=>{
                                                onNameChanged(title);
                                                setEditing(false);
                                            },
                                            onChange: (e)=>{
                                                setTitle(e.target.value);
                                            },
                                            onKeyDown: handleKeyDown
                                        }) : /*#__PURE__*/ (0, $iKObn.jsx)($f5a1a1c59d206855$var$TextOverflow, {
                                            "data-test": (0, $a6fIt.e2eTestId).patientPage.titreTextInput,
                                            className: "p-size-l-bold",
                                            children: programContent.name
                                        })
                                    }),
                                    programActions.length > 0 ? /*#__PURE__*/ (0, $iKObn.jsx)($f5a1a1c59d206855$var$StyledMenuButton, {
                                        menuItems: programActions
                                    }) : programStatus === (0, $5SzTW.ProgramStatus).Draft && /*#__PURE__*/ (0, $iKObn.jsx)($f5a1a1c59d206855$var$Separator, {}),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                                        className: "p-size-s",
                                        children: statusMessage
                                    })
                                ]
                            }),
                            (0, $lTdpc.isNotNil)(patient) && /*#__PURE__*/ (0, $iKObn.jsx)($f5a1a1c59d206855$var$Bottom, {
                                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $b370b7d050060c5d$export$b3cce10d7b0b956a), {
                                    patient: patient
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($f5a1a1c59d206855$var$MiddleContainer, {
                children: programStatus === (0, $5SzTW.ProgramStatus).Draft || programStatus === undefined ? !isDesktop && /*#__PURE__*/ (0, $iKObn.jsx)($f5a1a1c59d206855$var$TextOverflow, {
                    className: "p-size-s-bold",
                    children: programContent.name
                }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $dcc8df8d2b38b808$export$cd1d3fbb69b0d9ed), {
                    programContent: programContent,
                    programStatus: programStatus,
                    onClick: onProgramSchedulerClick
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($f5a1a1c59d206855$var$RightContainer, {
                children: isDesktop ? (secondaryButton || primaryButton) && /*#__PURE__*/ (0, $iKObn.jsx)((0, $06f7d348bd4277e0$export$6906986b9c4f9b75), {
                    secondaryButton: secondaryButton,
                    primaryButton: primaryButton,
                    primaryQuickstartTooltipVisible: primaryQuickstartTooltipVisible,
                    onPrimaryQuickstartTooltipRequestClose: onPrimaryQuickstartTooltipRequestClose,
                    primaryQuickstartTooltipStep: primaryQuickstartTooltipStep
                }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $a5hkt.ButtonIcon), {
                    icon: $f5a1a1c59d206855$var$MenuIcon,
                    onClick: ()=>{
                        dialogContext?.openModal((0, $243Cr.ModalId).ProgramBuilderActions, {
                            programName: programContent.name,
                            statusMessage: statusMessage,
                            onNameChanged: (newName)=>{
                                setTitle(newName);
                                onNameChanged(newName);
                                setEditing(false);
                            },
                            programActions: programActions,
                            patient: patient
                        });
                    },
                    size: "condensed"
                })
            })
        ]
    });
};
const $f5a1a1c59d206855$var$Header = (0, $5UMQ1.default).div`
	position: sticky;
	top: 0;
	z-index: 22;
	${(0, $5WGN2.row)(0, "spacebetween", "center")}
	padding: 14px 20px;
	background-color: ${(0, $kKnoQ.colors).white};
	border-bottom: 1px solid ${(0, $kKnoQ.colors).primary25};

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding: 16px 8px;
	}
`;
const $f5a1a1c59d206855$var$LeftContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(12, "flexstart", "center")};
	flex: 1 1 0;
`;
const $f5a1a1c59d206855$var$MiddleContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "center", "center")};
	flex: 1 1 0;
`;
const $f5a1a1c59d206855$var$RightContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "flexend", "center")};
	flex: 1 1 0;
`;
const $f5a1a1c59d206855$var$Stack = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "flexstart")}
`;
const $f5a1a1c59d206855$var$Top = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "flexstart", "center")}
	height: 40px;
`;
const $f5a1a1c59d206855$var$Bottom = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "flexstart", "center")}
`;
const $f5a1a1c59d206855$var$TitleContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "flexend", "center")};
	min-width: 0;
	overflow: hidden;
	max-width: 500px;
	cursor: ${(props)=>props.editing ? undefined : "text"};
`;
const $f5a1a1c59d206855$var$Separator = (0, $5UMQ1.default).div`
	width: 1px;
	height: 24px;
	margin-right: 8px;
	margin-left: 8px;
	background-color: ${(0, $kKnoQ.colors).primary25};
`;
const $f5a1a1c59d206855$var$TextOverflow = (0, $5UMQ1.default).span`
	max-width: 300px;
	line-height: 1.375rem;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		max-width: 250px;
	}
`;
const $f5a1a1c59d206855$var$Input = (0, $5UMQ1.default).input`
	max-width: 300px;
	height: 1.375rem;
	appearance: none;
	padding: 0;
	border: none;
	text-overflow: ellipsis;
	background-color: ${(0, $kKnoQ.colors).primaryBackground};
	color: ${(0, $kKnoQ.colors).black};

	&:focus {
		outline: 0;
	}
`;
const $f5a1a1c59d206855$var$StyledMenuButton = (0, $5UMQ1.default)((0, $amllh.MenuButton))`
	.menu-button {
		background-color: ${(0, $kKnoQ.colors).transparent};

		&.hover {
			background-color: ${(0, $kKnoQ.colors).grey10};
		}
	}
`;



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $kkH7g = parcelRequire("kkH7g");

var $5UMQ1 = parcelRequire("5UMQ1");

var $28f8Y = parcelRequire("28f8Y");

var $1IlhR = parcelRequire("1IlhR");

var $02Kb9 = parcelRequire("02Kb9");

var $41NLE = parcelRequire("41NLE");

var $2sRxO = parcelRequire("2sRxO");

var $di5pP = parcelRequire("di5pP");

var $daO8b = parcelRequire("daO8b");

var $ffhEE = parcelRequire("ffhEE");

var $kKnoQ = parcelRequire("kKnoQ");

var $5WGN2 = parcelRequire("5WGN2");

var $jKTFw = parcelRequire("jKTFw");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");

var $iZOKh = parcelRequire("iZOKh");

var $eGyIe = parcelRequire("eGyIe");

var $daNIT = parcelRequire("daNIT");

var $e0e2T = parcelRequire("e0e2T");
var $932f0b2abba92fe4$var$Info = function Info(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Zm0-20c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12.01 17.17c-.55 0-1-.45-1-1v-5.44c0-.55.45-1 1-1s1 .45 1 1v5.44c0 .55-.45 1-1 1ZM12 8.11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                fill: "currentColor"
            })
        ]
    });
};
$932f0b2abba92fe4$var$Info.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $932f0b2abba92fe4$export$b27635f35f9f6b40 = ({ areAlternativesEdited: areAlternativesEdited, showAddExerciseGuidance: showAddExerciseGuidance, onHideAddExerciseGuidance: onHideAddExerciseGuidance, showFilterLibraryGuidance: showFilterLibraryGuidance, onHideFilterLibraryGuidance: onHideFilterLibraryGuidance })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const alreadySelectedExercises = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEditedList);
    const { filteredSelectedExercises: filteredPreSelectedExercises, filteredExercises: filteredExercises, isAnyFilterActive: isAnyFilterActive, hasSelectedExercises: hasPreSelectedExercises, refreshLibraryExercises: refreshLibraryExercises, openExerciseDetailsModal: openExerciseDetailsModal, isError: isError, isLoading: isLoading } = (0, $2sRxO.useExerciseLibrary)();
    (0, $81g6h.useEffect)(()=>{
        // Keep complementary filtering state and filters when opening via Complementary flow
        if ((0, $ghfIB.libraryFilterManager).filteringState.get() !== (0, $daNIT.LibraryFilteringState).COMPLEMENTARY) (0, $ghfIB.libraryFilterManager).clearLibraryFiltersAndSearch();
        refreshLibraryExercises();
    }, [
        refreshLibraryExercises
    ]);
    const areFilteredExercisesNotPresent = (0, $81g6h.useMemo)(()=>isAnyFilterActive && filteredPreSelectedExercises.length === 0 && filteredExercises.length === 0 && alreadySelectedExercises.length === 0, [
        isAnyFilterActive,
        filteredPreSelectedExercises.length,
        filteredExercises.length,
        alreadySelectedExercises.length
    ]);
    const renderDraggableExerciseCard = (exercise, index)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $ffhEE.DraggableExerciseCard), {
            exercise: {
                ...exercise,
                alternativeExercises: []
            },
            index: index,
            uiStyle: "row",
            onClick: ()=>openExerciseDetailsModal(exercise),
            copy: true,
            showAlternatives: !areAlternativesEdited
        }, exercise.draggableId);
    let body;
    if (isLoading) body = /*#__PURE__*/ (0, $iKObn.jsx)($932f0b2abba92fe4$var$StyledLoadingContainer, {});
    else if (isError) body = /*#__PURE__*/ (0, $iKObn.jsx)($932f0b2abba92fe4$var$StyledNetworkError, {
        withoutIcon: true,
        description: format("exerciseLibrary.errorMessage"),
        onRefresh: refreshLibraryExercises
    });
    else body = /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $di5pP.ExerciseLibrarySearchFilter), {
                showFilterLibraryGuidance: showFilterLibraryGuidance,
                onHideFilterLibraryGuidance: onHideFilterLibraryGuidance
            }),
            areFilteredExercisesNotPresent ? /*#__PURE__*/ (0, $iKObn.jsx)($932f0b2abba92fe4$var$EmptySearchContainer, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $e0e2T.EmptySearch), {})
            }) : /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    !isAnyFilterActive && !hasPreSelectedExercises && /*#__PURE__*/ (0, $iKObn.jsx)((0, $daO8b.ExerciseLibraryCounts), {
                        mode: "LibraryAndAdded"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($932f0b2abba92fe4$var$ScrollContainer, {
                        children: [
                            filteredPreSelectedExercises.length > 0 && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($932f0b2abba92fe4$var$Section, {
                                        className: "p-size-m-bold",
                                        children: format("exerciseLibrary.selectedExercisesSection")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($932f0b2abba92fe4$var$StyledExerciseLibraryCount, {
                                        mode: "PreSelected"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $iZOKh.Droppable), {
                                        droppableId: (0, $41NLE.DROPPABLE_ID).PreSelectedExercise,
                                        isDropDisabled: true,
                                        children: (provided)=>/*#__PURE__*/ (0, $iKObn.jsxs)($932f0b2abba92fe4$var$List, {
                                                ref: provided.innerRef,
                                                children: [
                                                    filteredPreSelectedExercises.map((exercise, index)=>renderDraggableExerciseCard(exercise, index)),
                                                    provided.placeholder
                                                ]
                                            })
                                    })
                                ]
                            }),
                            filteredExercises.length > 0 && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                children: [
                                    hasPreSelectedExercises && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $iKObn.jsx)($932f0b2abba92fe4$var$Section, {
                                                className: "p-size-m-bold",
                                                children: format("exerciseLibrary.librarySection")
                                            }),
                                            /*#__PURE__*/ (0, $iKObn.jsx)($932f0b2abba92fe4$var$StyledExerciseLibraryCount, {
                                                mode: "Library"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $iZOKh.Droppable), {
                                        droppableId: (0, $41NLE.DROPPABLE_ID).Library,
                                        isDropDisabled: true,
                                        children: (provided)=>/*#__PURE__*/ (0, $iKObn.jsxs)($932f0b2abba92fe4$var$List, {
                                                ref: provided.innerRef,
                                                children: [
                                                    showAddExerciseGuidance && filteredExercises.length > 0 && /*#__PURE__*/ (0, $iKObn.jsx)($932f0b2abba92fe4$var$AddExerciseGuideTooltip, {
                                                        interactive: true,
                                                        visible: true,
                                                        placement: "right-start",
                                                        offset: [
                                                            12,
                                                            0
                                                        ],
                                                        arrow: true,
                                                        appendTo: (node)=>node.parentElement ?? document.body,
                                                        maxWidth: 360,
                                                        onClickOutside: onHideAddExerciseGuidance,
                                                        content: /*#__PURE__*/ (0, $iKObn.jsx)((0, $eGyIe.OnboardingPanel), {
                                                            text: format("programBuilder.quickstart.guide.addFirstExercise"),
                                                            onClose: ()=>onHideAddExerciseGuidance?.()
                                                        }),
                                                        children: /*#__PURE__*/ (0, $iKObn.jsx)($932f0b2abba92fe4$var$TooltipAnchor, {
                                                            "aria-hidden": true
                                                        })
                                                    }),
                                                    filteredExercises.map((exercise, index)=>renderDraggableExerciseCard(exercise, index)),
                                                    provided.placeholder
                                                ]
                                            })
                                    })
                                ]
                            }),
                            alreadySelectedExercises.length > 0 && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsxs)($932f0b2abba92fe4$var$AlreadySelectedHeader, {
                                        children: [
                                            /*#__PURE__*/ (0, $iKObn.jsxs)($932f0b2abba92fe4$var$Sort, {
                                                children: [
                                                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                                        className: "p-size-m-bold",
                                                        children: format("exerciseLibrary.alreadyAdded")
                                                    }),
                                                    /*#__PURE__*/ (0, $iKObn.jsx)($932f0b2abba92fe4$var$StyledTooltip, {
                                                        content: format("exerciseLibrary.alreadyInSelectionToolTipMessage", {
                                                            exerciseSelectedCount: alreadySelectedExercises.length
                                                        }),
                                                        children: /*#__PURE__*/ (0, $iKObn.jsx)($932f0b2abba92fe4$var$IconContainer, {
                                                            children: /*#__PURE__*/ (0, $iKObn.jsx)($932f0b2abba92fe4$var$Info, {
                                                                width: 22,
                                                                height: 22,
                                                                color: (0, $kKnoQ.colors).grey80
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            hasPreSelectedExercises && /*#__PURE__*/ (0, $iKObn.jsx)((0, $daO8b.ExerciseLibraryCounts), {
                                                mode: "Added"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($932f0b2abba92fe4$var$List, {
                                        children: alreadySelectedExercises.map((exercise)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $ffhEE.ExerciseCard), {
                                                exercise: exercise,
                                                draggable: false,
                                                uiStyle: "row",
                                                disabled: true
                                            }, exercise.id))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $iKObn.jsx)($932f0b2abba92fe4$var$Container, {
        children: body
    });
};
const $932f0b2abba92fe4$var$sharedPadding = (0, $kkH7g.css)`
	padding: 0 20px;
`;
const $932f0b2abba92fe4$var$StyledNetworkError = (0, $5UMQ1.default)((0, $28f8Y.NetworkError))`
	place-content: center;
	flex: 1;
	padding: 32px;
`;
const $932f0b2abba92fe4$var$StyledLoadingContainer = (0, $5UMQ1.default)((0, $1IlhR.LoadingContainer))`
	place-content: center;
	flex: 1;
`;
const $932f0b2abba92fe4$var$Container = (0, $5UMQ1.default).div`
	padding-top: 12px;
	${(0, $5WGN2.stack)(12, "flexstart", "stretch")};
	flex: 1;
	min-height: 0px;
`;
const $932f0b2abba92fe4$var$Section = (0, $5UMQ1.default).div`
	${$932f0b2abba92fe4$var$sharedPadding}
`;
const $932f0b2abba92fe4$var$StyledExerciseLibraryCount = (0, $5UMQ1.default)((0, $daO8b.ExerciseLibraryCounts))`
	margin-bottom: 12px;
`;
const $932f0b2abba92fe4$var$AlreadySelectedHeader = (0, $5UMQ1.default).div`
	margin-bottom: 12px;
`;
const $932f0b2abba92fe4$var$Sort = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(12, "flexstart", "center")}
	${$932f0b2abba92fe4$var$sharedPadding}
`;
const $932f0b2abba92fe4$var$EmptySearchContainer = (0, $5UMQ1.default).div`
	align-items: center;
	justify-content: center;
	display: flex;
	flex-grow: 1;
	padding: 72px;
`;
const $932f0b2abba92fe4$var$List = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "flexstart", "stretch")};
	padding: 0 20px 8px 20px;
	min-height: 0;
	@supports not (-moz-appearance: none) {
		padding-right: ${12}px;
		margin-right: 4px;
	}
	> * {
		margin-bottom: 8px;
	}
`;
const $932f0b2abba92fe4$var$TooltipAnchor = (0, $5UMQ1.default).div`
	height: 0;
	margin: 0;
	padding: 0;
`;
const $932f0b2abba92fe4$var$StyledTooltip = (0, $5UMQ1.default)((0, $02Kb9.Tooltip))`
	font-size: 16px;
`;
const $932f0b2abba92fe4$var$ScrollContainer = (0, $5UMQ1.default).div`
	${(0, $jKTFw.getScrollbarStyle)(8)};
	overflow-y: auto;
	flex: 1 1 auto;
`;
const $932f0b2abba92fe4$var$IconContainer = (0, $5UMQ1.default).div`
	display: flex;
`;
const $932f0b2abba92fe4$var$AddExerciseGuideTooltip = (0, $5UMQ1.default)((0, $02Kb9.Tooltip))`
	padding: 0;
	.tippy-arrow {
		color: ${(0, $kKnoQ.colors).onboardingPrimary};
	}
	&[data-placement^="right"] > .tippy-arrow {
		top: 50% !important;
		bottom: auto !important;
		transform: translateY(-50%) !important;
		margin-top: 0 !important;
		margin-bottom: 0 !important;
	}
	.tippy-content {
		padding: 0;
	}
`;



var $iKObn = parcelRequire("iKObn");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $02Kb9 = parcelRequire("02Kb9");

var $kKnoQ = parcelRequire("kKnoQ");

var $5WGN2 = parcelRequire("5WGN2");

var $jc7Ow = parcelRequire("jc7Ow");
function $4f1bf065721784dc$export$90ceba2564a894f8(elements, scope, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        let root = document;
        if (scope) {
            (0, $jc7Ow.invariant)(Boolean(scope.current), "Scope provided, but no element detected.");
            root = scope.current;
        }
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = root.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = root.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}



var $2tXqa = parcelRequire("2tXqa");

var $jc7Ow = parcelRequire("jc7Ow");

var $2WyfF = parcelRequire("2WyfF");
function $6ecc7f44e5e59ce8$export$d276bfce3b1077ca(keyframes) {
    return typeof keyframes === "object" && !Array.isArray(keyframes);
}



var $6VfLK = parcelRequire("6VfLK");

var $c3rG3 = parcelRequire("c3rG3");

var $jauEW = parcelRequire("jauEW");

var $4bs0h = parcelRequire("4bs0h");

var $2tXqa = parcelRequire("2tXqa");
function $2b872420e934d14e$export$f2911d8192f464a8(element) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {}
            },
            latestValues: {}
        }
    };
    const node = (0, $c3rG3.isSVGElement)(element) ? new (0, $jauEW.SVGVisualElement)(options) : new (0, $4bs0h.HTMLVisualElement)(options);
    node.mount(element);
    (0, $2tXqa.visualElementStore).set(element, node);
}



var $eRt7D = parcelRequire("eRt7D");

var $8Ybf5 = parcelRequire("8Ybf5");

var $4z4dP = parcelRequire("4z4dP");

var $lhAHd = parcelRequire("lhAHd");
/**
 * Create a progress => progress easing function from a generator.
 */ function $6b6bd1d40cc84482$export$7f1511d09ee75a99(options, scale = 100) {
    const generator = (0, $8Ybf5.spring)({
        keyframes: [
            0,
            scale
        ],
        ...options
    });
    const duration = Math.min((0, $4z4dP.calcGeneratorDuration)(generator), (0, $4z4dP.maxGeneratorDuration));
    return {
        type: "keyframes",
        ease: (progress)=>generator.next(duration * progress).value / scale,
        duration: (0, $lhAHd.millisecondsToSeconds)(duration)
    };
}




var $aEnkp = parcelRequire("aEnkp");

var $1vJ3I = parcelRequire("1vJ3I");

var $cw1Iu = parcelRequire("cw1Iu");

var $lhAHd = parcelRequire("lhAHd");

var $6ym6A = parcelRequire("6ym6A");
/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */ function $34a2e645bc7c4cf8$export$83ccd85155ba9791(current, next, prev, labels) {
    var _a;
    if (typeof next === "number") return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
}


const $188c8721f45b2260$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};



var $aHZLd = parcelRequire("aHZLd");
function $8bd4349541c789e6$export$41c5e731255a462(easing, i) {
    return (0, $aHZLd.isEasingArray)(easing) ? easing[(0, $188c8721f45b2260$export$4997ffc0176396a6)(0, easing.length, i)] : easing;
}



var $fXcrA = parcelRequire("fXcrA");

var $evA7j = parcelRequire("evA7j");
function $43ef0d4c6c5ac067$export$6f93cdbb78924b88(sequence, startTime, endTime) {
    for(let i = 0; i < sequence.length; i++){
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, $fXcrA.removeItem)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function $43ef0d4c6c5ac067$export$89dfa6760a9f76e7(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ $43ef0d4c6c5ac067$export$6f93cdbb78924b88(sequence, startTime, endTime);
    for(let i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, $evA7j.mixNumber)(startTime, endTime, offset[i]),
        easing: (0, $8bd4349541c789e6$export$41c5e731255a462)(easing, i)
    });
}


function $2c8634b7cb806f5c$export$66dd3fbf44e05bd9(a, b) {
    if (a.at === b.at) {
        if (a.value === null) return 1;
        if (b.value === null) return -1;
        return 0;
    } else return a.at - b.at;
}


const $8fdada8a255dc261$var$defaultSegmentEasing = "easeInOut";
function $8fdada8a255dc261$export$1f0f44b51a4b2f73(sequence, { defaultTransition: defaultTransition = {}, ...sequenceTransition } = {}, scope) {
    const defaultDuration = defaultTransition.duration || 0.3;
    const animationDefinitions = new Map();
    const sequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the sequence array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(let i = 0; i < sequence.length; i++){
        const segment = sequence[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if (typeof segment === "string") {
            timeLabels.set(segment, currentTime);
            continue;
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, $34a2e645bc7c4cf8$export$83ccd85155ba9791)(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        let [subject, keyframes, transition = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (transition.at !== undefined) currentTime = (0, $34a2e645bc7c4cf8$export$83ccd85155ba9791)(currentTime, transition.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ let maxDuration = 0;
        const resolveValueSequence = (valueKeyframes, valueTransition, valueSequence, elementIndex = 0, numElements = 0)=>{
            const valueKeyframesAsList = $8fdada8a255dc261$var$keyframesAsList(valueKeyframes);
            const { delay: delay = 0, times: times = (0, $aEnkp.defaultOffset)(valueKeyframesAsList), type: type = "keyframes", ...remainingTransition } = valueTransition;
            let { ease: ease = defaultTransition.ease || "easeOut", duration: duration } = valueTransition;
            /**
             * Resolve stagger() if defined.
             */ const calculatedDelay = typeof delay === "function" ? delay(elementIndex, numElements) : delay;
            /**
             * If this animation should and can use a spring, generate a spring easing function.
             */ const numKeyframes = valueKeyframesAsList.length;
            if (numKeyframes <= 2 && type === "spring") {
                /**
                 * As we're creating an easing function from a spring,
                 * ideally we want to generate it using the real distance
                 * between the two keyframes. However this isn't always
                 * possible - in these situations we use 0-100.
                 */ let absoluteDelta = 100;
                if (numKeyframes === 2 && $8fdada8a255dc261$var$isNumberKeyframesArray(valueKeyframesAsList)) {
                    const delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
                    absoluteDelta = Math.abs(delta);
                }
                const springTransition = {
                    ...remainingTransition
                };
                if (duration !== undefined) springTransition.duration = (0, $lhAHd.secondsToMilliseconds)(duration);
                const springEasing = (0, $6b6bd1d40cc84482$export$7f1511d09ee75a99)(springTransition, absoluteDelta);
                ease = springEasing.ease;
                duration = springEasing.duration;
            }
            duration !== null && duration !== void 0 ? duration : duration = defaultDuration;
            const startTime = currentTime + calculatedDelay;
            const targetTime = startTime + duration;
            /**
             * If there's only one time offset of 0, fill in a second with length 1
             */ if (times.length === 1 && times[0] === 0) times[1] = 1;
            /**
             * Fill out if offset if fewer offsets than keyframes
             */ const remainder = times.length - valueKeyframesAsList.length;
            remainder > 0 && (0, $1vJ3I.fillOffset)(times, remainder);
            /**
             * If only one value has been set, ie [1], push a null to the start of
             * the keyframe array. This will let us mark a keyframe at this point
             * that will later be hydrated with the previous value.
             */ valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
            /**
             * Add keyframes, mapping offsets to absolute time.
             */ (0, $43ef0d4c6c5ac067$export$89dfa6760a9f76e7)(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
            maxDuration = Math.max(calculatedDelay + duration, maxDuration);
            totalDuration = Math.max(targetTime, totalDuration);
        };
        if ((0, $6ym6A.isMotionValue)(subject)) {
            const subjectSequence = $8fdada8a255dc261$var$getSubjectSequence(subject, sequences);
            resolveValueSequence(keyframes, transition, $8fdada8a255dc261$var$getValueSequence("default", subjectSequence));
        } else {
            /**
             * Find all the elements specified in the definition and parse value
             * keyframes from their timeline definitions.
             */ const elements = (0, $4f1bf065721784dc$export$90ceba2564a894f8)(subject, scope, elementCache);
            const numElements = elements.length;
            /**
             * For every element in this segment, process the defined values.
             */ for(let elementIndex = 0; elementIndex < numElements; elementIndex++){
                /**
                 * Cast necessary, but we know these are of this type
                 */ keyframes;
                transition;
                const element = elements[elementIndex];
                const subjectSequence = $8fdada8a255dc261$var$getSubjectSequence(element, sequences);
                for(const key in keyframes)resolveValueSequence(keyframes[key], $8fdada8a255dc261$export$7c1391340308742e(transition, key), $8fdada8a255dc261$var$getValueSequence(key, subjectSequence), elementIndex, numElements);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    }
    /**
     * For every element and value combination create a new animation.
     */ sequences.forEach((valueSequences, element)=>{
        for(const key in valueSequences){
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, $2c8634b7cb806f5c$export$66dd3fbf44e05bd9));
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(let i = 0; i < valueSequence.length; i++){
                const { at: at, value: value, easing: easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0, $cw1Iu.progress)(0, totalDuration, at));
                valueEasing.push(easing || "easeOut");
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift($8fdada8a255dc261$var$defaultSegmentEasing);
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            if (!animationDefinitions.has(element)) animationDefinitions.set(element, {
                keyframes: {},
                transition: {}
            });
            const definition = animationDefinitions.get(element);
            definition.keyframes[key] = keyframes;
            definition.transition[key] = {
                ...defaultTransition,
                duration: totalDuration,
                ease: valueEasing,
                times: valueOffset,
                ...sequenceTransition
            };
        }
    });
    return animationDefinitions;
}
function $8fdada8a255dc261$var$getSubjectSequence(subject, sequences) {
    !sequences.has(subject) && sequences.set(subject, {});
    return sequences.get(subject);
}
function $8fdada8a255dc261$var$getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}
function $8fdada8a255dc261$var$keyframesAsList(keyframes) {
    return Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];
}
function $8fdada8a255dc261$export$7c1391340308742e(transition, key) {
    return transition[key] ? {
        ...transition,
        ...transition[key]
    } : {
        ...transition
    };
}
const $8fdada8a255dc261$var$isNumber = (keyframe)=>typeof keyframe === "number";
const $8fdada8a255dc261$var$isNumberKeyframesArray = (keyframes)=>keyframes.every($8fdada8a255dc261$var$isNumber);



var $6ym6A = parcelRequire("6ym6A");
function $dadc2b20153263db$var$animateElements(elementOrSelector, keyframes, options, scope) {
    const elements = (0, $4f1bf065721784dc$export$90ceba2564a894f8)(elementOrSelector, scope);
    const numElements = elements.length;
    (0, $jc7Ow.invariant)(Boolean(numElements), "No valid element provided.");
    const animations = [];
    for(let i = 0; i < numElements; i++){
        const element = elements[i];
        /**
         * Check each element for an associated VisualElement. If none exists,
         * we need to create one.
         */ if (!(0, $2tXqa.visualElementStore).has(element)) /**
             * TODO: We only need render-specific parts of the VisualElement.
             * With some additional work the size of the animate() function
             * could be reduced significantly.
             */ (0, $2b872420e934d14e$export$f2911d8192f464a8)(element);
        const visualElement = (0, $2tXqa.visualElementStore).get(element);
        const transition = {
            ...options
        };
        /**
         * Resolve stagger function if provided.
         */ if (typeof transition.delay === "function") transition.delay = transition.delay(i, numElements);
        animations.push(...(0, $6VfLK.animateTarget)(visualElement, {
            ...keyframes,
            transition: transition
        }, {}));
    }
    return new (0, $2WyfF.GroupPlaybackControls)(animations);
}
const $dadc2b20153263db$var$isSequence = (value)=>Array.isArray(value) && Array.isArray(value[0]);
function $dadc2b20153263db$var$animateSequence(sequence, options, scope) {
    const animations = [];
    const animationDefinitions = (0, $8fdada8a255dc261$export$1f0f44b51a4b2f73)(sequence, options, scope);
    animationDefinitions.forEach(({ keyframes: keyframes, transition: transition }, subject)=>{
        let animation;
        if ((0, $6ym6A.isMotionValue)(subject)) animation = (0, $eRt7D.animateSingleValue)(subject, keyframes.default, transition.default);
        else animation = $dadc2b20153263db$var$animateElements(subject, keyframes, transition);
        animations.push(animation);
    });
    return new (0, $2WyfF.GroupPlaybackControls)(animations);
}
const $dadc2b20153263db$export$c17e592002be9b90 = (scope)=>{
    /**
     * Implementation
     */ function scopedAnimate(valueOrElementOrSequence, keyframes, options) {
        let animation;
        if ($dadc2b20153263db$var$isSequence(valueOrElementOrSequence)) animation = $dadc2b20153263db$var$animateSequence(valueOrElementOrSequence, keyframes, scope);
        else if ((0, $6ecc7f44e5e59ce8$export$d276bfce3b1077ca)(keyframes)) animation = $dadc2b20153263db$var$animateElements(valueOrElementOrSequence, keyframes, options, scope);
        else animation = (0, $eRt7D.animateSingleValue)(valueOrElementOrSequence, keyframes, options);
        if (scope) scope.animations.push(animation);
        return animation;
    }
    return scopedAnimate;
};
const $dadc2b20153263db$export$e3607ec2d7a891c4 = $dadc2b20153263db$export$c17e592002be9b90();


var $dU78w = parcelRequire("dU78w");
var $81g6h = parcelRequire("81g6h");

var $dW73m = parcelRequire("dW73m");

var $3LSjD = parcelRequire("3LSjD");

var $eaulW = parcelRequire("eaulW");
/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */ function $191995ff4a40cfc7$export$15b697acf84c78b9(initial) {
    const value = (0, $eaulW.useConstant)(()=>(0, $dW73m.motionValue)(initial));
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */ const { isStatic: isStatic } = (0, $81g6h.useContext)((0, $3LSjD.MotionConfigContext));
    if (isStatic) {
        const [, setLatest] = (0, $81g6h.useState)(initial);
        (0, $81g6h.useEffect)(()=>value.on("change", setLatest), []);
    }
    return value;
}



var $1FCO4 = parcelRequire("1FCO4");

var $gjKjc = parcelRequire("gjKjc");
function $1271f68f3cd6795a$export$7dee4fa9fc2b33f3(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */ const value = (0, $191995ff4a40cfc7$export$15b697acf84c78b9)(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */ const updateValue = ()=>value.set(combineValues());
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */ updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */ (0, $1FCO4.useIsomorphicLayoutEffect)(()=>{
        const scheduleUpdate = ()=>(0, $gjKjc.frame).preRender(updateValue, false, true);
        const subscriptions = values.map((v)=>v.on("change", scheduleUpdate));
        return ()=>{
            subscriptions.forEach((unsubscribe)=>unsubscribe());
            (0, $gjKjc.cancelFrame)(updateValue);
        };
    });
    return value;
}



var $6ym6A = parcelRequire("6ym6A");
/**
 * Combine multiple motion values into a new one using a string template literal.
 *
 * ```jsx
 * import {
 *   motion,
 *   useSpring,
 *   useMotionValue,
 *   useMotionTemplate
 * } from "framer-motion"
 *
 * function Component() {
 *   const shadowX = useSpring(0)
 *   const shadowY = useMotionValue(0)
 *   const shadow = useMotionTemplate`drop-shadow(${shadowX}px ${shadowY}px 20px rgba(0,0,0,0.3))`
 *
 *   return <motion.div style={{ filter: shadow }} />
 * }
 * ```
 *
 * @public
 */ function $a65f623e1bab97c8$export$ba64c34ccdc6dde0(fragments, ...values) {
    /**
     * Create a function that will build a string from the latest motion values.
     */ const numFragments = fragments.length;
    function buildValue() {
        let output = ``;
        for(let i = 0; i < numFragments; i++){
            output += fragments[i];
            const value = values[i];
            if (value) output += (0, $6ym6A.isMotionValue)(value) ? value.get() : value;
        }
        return output;
    }
    return (0, $1271f68f3cd6795a$export$7dee4fa9fc2b33f3)(values.filter((0, $6ym6A.isMotionValue)), buildValue);
}


var $bVo2Y = parcelRequire("bVo2Y");
const $1bcd814890776179$var$isCustomValueType = (v)=>{
    return v && typeof v === "object" && v.mix;
};
const $1bcd814890776179$var$getMixer = (v)=>$1bcd814890776179$var$isCustomValueType(v) ? v.mix : undefined;
function $1bcd814890776179$export$51186ad6e864892a(...args) {
    const useImmediate = !Array.isArray(args[0]);
    const argOffset = useImmediate ? 0 : -1;
    const inputValue = args[0 + argOffset];
    const inputRange = args[1 + argOffset];
    const outputRange = args[2 + argOffset];
    const options = args[3 + argOffset];
    const interpolator = (0, $bVo2Y.interpolate)(inputRange, outputRange, {
        mixer: $1bcd814890776179$var$getMixer(outputRange[0]),
        ...options
    });
    return useImmediate ? interpolator(inputValue) : interpolator;
}




var $eaulW = parcelRequire("eaulW");

var $dW73m = parcelRequire("dW73m");

function $09ef13037d2dc7d8$export$e3d20747ab930783(compute) {
    /**
     * Open session of collectMotionValues. Any MotionValue that calls get()
     * will be saved into this array.
     */ (0, $dW73m.collectMotionValues).current = [];
    compute();
    const value = (0, $1271f68f3cd6795a$export$7dee4fa9fc2b33f3)((0, $dW73m.collectMotionValues).current, compute);
    /**
     * Synchronously close session of collectMotionValues.
     */ (0, $dW73m.collectMotionValues).current = undefined;
    return value;
}


function $b638f0a91873d359$export$a87ba948fb2b39ec(input, inputRangeOrTransformer, outputRange, options) {
    if (typeof input === "function") return (0, $09ef13037d2dc7d8$export$e3d20747ab930783)(input);
    const transformer = typeof inputRangeOrTransformer === "function" ? inputRangeOrTransformer : (0, $1bcd814890776179$export$51186ad6e864892a)(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input) ? $b638f0a91873d359$var$useListTransform(input, transformer) : $b638f0a91873d359$var$useListTransform([
        input
    ], ([latest])=>transformer(latest));
}
function $b638f0a91873d359$var$useListTransform(values, transformer) {
    const latest = (0, $eaulW.useConstant)(()=>[]);
    return (0, $1271f68f3cd6795a$export$7dee4fa9fc2b33f3)(values, ()=>{
        latest.length = 0;
        const numValues = values.length;
        for(let i = 0; i < numValues; i++)latest[i] = values[i].get();
        return transformer(latest);
    });
}



var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
var $909d9a8c8470e5ac$var$ChevronDoubleLeftIcon = function ChevronDoubleLeftIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "m7.195 12 3.982 4.071a1.149 1.149 0 0 1 0 1.598 1.089 1.089 0 0 1-1.564 0l-4.807-4.916a1.081 1.081 0 0 1 0-1.506L9.613 6.33a1.089 1.089 0 0 1 1.564 0 1.149 1.149 0 0 1 0 1.598L7.195 12ZM15.195 12l3.982 4.071a1.149 1.149 0 0 1 0 1.598 1.089 1.089 0 0 1-1.564 0l-4.807-4.916a1.081 1.081 0 0 1 0-1.506l4.807-4.916a1.089 1.089 0 0 1 1.564 0 1.149 1.149 0 0 1 0 1.598L15.195 12Z",
            fill: "currentColor"
        })
    });
};
$909d9a8c8470e5ac$var$ChevronDoubleLeftIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $909d9a8c8470e5ac$var$ChevronDoubleRightIcon = function ChevronDoubleRightIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "m8.805 12-3.981 4.071a1.149 1.149 0 0 0 0 1.598 1.088 1.088 0 0 0 1.563 0l4.807-4.916a1.081 1.081 0 0 0 0-1.506L6.387 6.33a1.089 1.089 0 0 0-1.563 0 1.149 1.149 0 0 0 0 1.598L8.805 12ZM16.805 12l-3.982 4.071a1.149 1.149 0 0 0 0 1.598 1.089 1.089 0 0 0 1.564 0l4.807-4.916a1.081 1.081 0 0 0 0-1.506L14.387 6.33a1.089 1.089 0 0 0-1.564 0 1.149 1.149 0 0 0 0 1.598L16.805 12Z",
            fill: "currentColor"
        })
    });
};
$909d9a8c8470e5ac$var$ChevronDoubleRightIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $909d9a8c8470e5ac$export$114b63cb8d731b7d = ({ children: children, pushedContent: pushedContent, title: title, disabled: disabled, disabledTooltip: disabledTooltip })=>{
    const sidebarVisible = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).sidebarVisible);
    const [sidebarTop, setSidebarTop] = (0, $81g6h.useState)(0);
    const sidebarId = "sidebar";
    const progressValue = (0, $191995ff4a40cfc7$export$15b697acf84c78b9)(disabled ? 0 : 1);
    const slideX = (0, $b638f0a91873d359$export$a87ba948fb2b39ec)(progressValue, [
        0,
        1
    ], [
        0,
        $909d9a8c8470e5ac$var$SIDEBAR_WIDTH
    ]);
    const width = (0, $a65f623e1bab97c8$export$ba64c34ccdc6dde0)`${slideX}px`;
    const x = (0, $b638f0a91873d359$export$a87ba948fb2b39ec)(progressValue, [
        0,
        1
    ], [
        $909d9a8c8470e5ac$var$OPENING_BUTTON_WIDTH,
        0
    ]);
    const pushedWidth = (0, $a65f623e1bab97c8$export$ba64c34ccdc6dde0)`calc(100% - ${slideX}px)`;
    (0, $81g6h.useEffect)(()=>{
        const controls = (0, $dadc2b20153263db$export$e3607ec2d7a891c4)(progressValue, sidebarVisible ? 1 : 0, {
            ease: "easeInOut"
        });
        return controls.stop;
    }, [
        progressValue,
        sidebarVisible
    ]);
    (0, $81g6h.useEffect)(()=>{
        const sidebarRect = document.getElementById(sidebarId)?.getBoundingClientRect();
        if (sidebarRect) setSidebarTop(sidebarRect.top + document.documentElement.scrollTop);
    }, []);
    (0, $81g6h.useEffect)(()=>{
        (0, $ghfIB.libraryFilterManager).setSidebarVisible(!disabled);
    }, [
        disabled
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($909d9a8c8470e5ac$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($909d9a8c8470e5ac$var$Sidebar, {
                id: sidebarId,
                style: {
                    width: width
                },
                children: /*#__PURE__*/ (0, $iKObn.jsxs)($909d9a8c8470e5ac$var$SidebarContainer, {
                    style: {
                        maxHeight: `calc(100vh - ${sidebarTop}px)`
                    },
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsxs)($909d9a8c8470e5ac$var$HeaderContainer, {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)("h3", {
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)($909d9a8c8470e5ac$var$ClosingButton, {
                                    onClick: ()=>(0, $ghfIB.libraryFilterManager).setSidebarVisible(false),
                                    children: /*#__PURE__*/ (0, $iKObn.jsx)($909d9a8c8470e5ac$var$ChevronDoubleLeftIcon, {
                                        width: 24,
                                        height: 24,
                                        color: (0, $kKnoQ.colors).grey,
                                        fill: (0, $kKnoQ.colors).white
                                    })
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)((0, $02Kb9.Tooltip), {
                                    content: disabledTooltip,
                                    disabled: !disabled,
                                    placement: "right",
                                    children: /*#__PURE__*/ (0, $iKObn.jsx)($909d9a8c8470e5ac$var$OpeningButtonWrapper, {
                                        style: {
                                            x: x
                                        },
                                        children: /*#__PURE__*/ (0, $iKObn.jsx)($909d9a8c8470e5ac$var$OpeningButton, {
                                            className: "p-button",
                                            disabled: disabled,
                                            onClick: ()=>!disabled && (0, $ghfIB.libraryFilterManager).setSidebarVisible(true),
                                            children: /*#__PURE__*/ (0, $iKObn.jsx)($909d9a8c8470e5ac$var$ChevronDoubleRightIcon, {
                                                width: 24,
                                                height: 24,
                                                color: disabled ? (0, $kKnoQ.colors).grey : (0, $kKnoQ.colors).white,
                                                fill: disabled ? (0, $kKnoQ.colors).grey25 : (0, $kKnoQ.colors).primary
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        children
                    ]
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($909d9a8c8470e5ac$var$PushedContainer, {
                style: {
                    width: pushedWidth
                },
                children: pushedContent
            })
        ]
    });
};
const $909d9a8c8470e5ac$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, undefined, "stretch")};
	flex: 1;
`;
const $909d9a8c8470e5ac$var$SIDEBAR_WIDTH = 450;
const $909d9a8c8470e5ac$var$Sidebar = (0, $5UMQ1.default)((0, $dU78w.motion).div)`
	background-color: ${(0, $kKnoQ.colors).white};
	z-index: 20;
	${(0, $5WGN2.stack)(undefined, "flexstart", "flexend")};
`;
const $909d9a8c8470e5ac$var$SidebarContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "flexstart", "stretch")};
	width: ${$909d9a8c8470e5ac$var$SIDEBAR_WIDTH}px;
	flex: 1;
	border-right: 1px solid var(--surface-border);
`;
const $909d9a8c8470e5ac$var$PushedContainer = (0, $5UMQ1.default)((0, $dU78w.motion).div)`
	${(0, $5WGN2.row)(undefined, undefined, "stretch")};
	flex: 1;
`;
const $909d9a8c8470e5ac$var$HeaderContainer = (0, $5UMQ1.default).div`
	position: relative;
	${(0, $5WGN2.row)(undefined, "spacebetween", "center")};
	background-color: ${(0, $kKnoQ.colors).white};

	h3 {
		padding: 20px 0px 6px 20px;
		font-size: 20px;
	}
`;
const $909d9a8c8470e5ac$var$OPENING_BUTTON_WIDTH = 76;
const $909d9a8c8470e5ac$var$OpeningButton = (0, $5UMQ1.default).button`
	border-radius: 0px 24px 24px 0px;
	padding: 0 12px 0 16px;
	height: 38px;

	${(0, $5WGN2.row)(5, "flexend", "center")};
`;
const $909d9a8c8470e5ac$var$OpeningButtonWrapper = (0, $5UMQ1.default)((0, $dU78w.motion).div)`
	position: absolute;
	right: 0;
	top: calc(50% - 16px);
	z-index: -1;
`;
const $909d9a8c8470e5ac$var$ClosingButton = (0, $5UMQ1.default).button`
	${(0, $5WGN2.row)(5, "flexend", "center")};
	color: ${(0, $kKnoQ.colors).grey};
	height: 38px;
	padding: 0 16px 0 12px;
	border: none;
	border-radius: 24px 0px 0px 24px;
	background: ${(0, $kKnoQ.colors).transparent};
	cursor: pointer;

	:hover {
		background: ${(0, $kKnoQ.colors).primary10};
	}
`;



var $iKObn = parcelRequire("iKObn");

var $eAmnG = parcelRequire("eAmnG");

var $5UMQ1 = parcelRequire("5UMQ1");

var $iKObn = parcelRequire("iKObn");

var $ghfIB = parcelRequire("ghfIB");

var $hLaGu = parcelRequire("hLaGu");

var $bFakw = parcelRequire("bFakw");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5kXMA = parcelRequire("5kXMA");



var $2zGye = parcelRequire("2zGye");

var $kBALX = parcelRequire("kBALX");

var $ffhEE = parcelRequire("ffhEE");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $243Cr = parcelRequire("243Cr");

var $2sRxO = parcelRequire("2sRxO");

var $jD5Wy = parcelRequire("jD5Wy");

var $kKnoQ = parcelRequire("kKnoQ");

var $81g6h = parcelRequire("81g6h");
var $f734114e65d4ad82$var$AddIcon = function AddIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M11 13H6a.967.967 0 0 1-.713-.287A.968.968 0 0 1 5 12c0-.283.096-.52.287-.713A.967.967 0 0 1 6 11h5V6c0-.283.096-.52.287-.713A.968.968 0 0 1 12 5c.283 0 .52.096.713.287.191.192.287.43.287.713v5h5c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 18 13h-5v5c0 .283-.096.52-.287.712A.968.968 0 0 1 12 19a.968.968 0 0 1-.713-.288A.968.968 0 0 1 11 18v-5Z",
            fill: "currentColor"
        })
    });
};
$f734114e65d4ad82$var$AddIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $f734114e65d4ad82$export$bc76f6e6ce79f979 = ({ onAdd: onAdd })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const { refreshLibraryExercises: refreshLibraryExercises } = (0, $2sRxO.useExerciseLibrary)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($f734114e65d4ad82$var$Container, {
        onClick: ()=>{
            refreshLibraryExercises();
            dialogContext?.openModal((0, $243Cr.ModalId).MobileExerciseLibrary, {
                exerciseLibraryAddingFlow: (0, $jD5Wy.ExerciseLibraryFlow).Default,
                onClose: (exercises)=>onAdd(exercises)
            });
        },
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($f734114e65d4ad82$var$IconContainer, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)($f734114e65d4ad82$var$AddIcon, {
                    width: 14,
                    height: 14,
                    color: (0, $kKnoQ.colors).black
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                className: "p-size-s-bold",
                children: format("programBuilder.dayTable.addExercisesButton")
            })
        ]
    });
};
const $f734114e65d4ad82$var$Container = (0, $5UMQ1.default).div`
	display: flex;
	gap: 10px;
	padding: 6px;
	margin-left: -6px;
	width: fit-content;
	cursor: pointer;
	place-items: center;
`;
const $f734114e65d4ad82$var$IconContainer = (0, $5UMQ1.default).div`
	width: 32px;
	height: 32px;
	display: grid;
	place-items: center;
	place-content: center;
	border-radius: 16px;
	background-color: ${(0, $kKnoQ.colors).primary25};
`;



var $kKnoQ = parcelRequire("kKnoQ");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
const $03f1fec0abba1d25$export$2fa2967919157591 = ({ title: title, session: session, dayIndex: dayIndex, className: className, programEditor: programEditor })=>{
    const [updatedExerciseId, setUpdatedUpdatedExerciseId] = (0, $81g6h.useState)();
    const editedProgram = (0, $1IWnK.useObservable)(programEditor.editedProgram);
    const { openExerciseDetailsModal: openExerciseDetailsModal } = (0, $kBALX.useEditorExerciseCardActions)();
    //todo Duplicate from day table
    const updateExercise = (0, $81g6h.useCallback)(async (updatedExercise)=>{
        (0, $hLaGu.isMainExercise)(updatedExercise) && programEditor.editExercise(updatedExercise.draggableId, updatedExercise);
        setUpdatedUpdatedExerciseId(updatedExercise.draggableId);
        await (0, $ghfIB.libraryFilterManager).clearLibraryFiltersAndSearch();
        setTimeout(()=>setUpdatedUpdatedExerciseId(undefined), 1000);
    }, [
        programEditor
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($03f1fec0abba1d25$var$Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($03f1fec0abba1d25$var$TitleContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($03f1fec0abba1d25$var$Title, {
                        className: "p-size-l",
                        children: title
                    }),
                    session.exercises.length > 0 && /*#__PURE__*/ (0, $iKObn.jsx)((0, $bbff0d9e591ef7dc$export$4b7cb178afaad337), {
                        editedProgram: editedProgram,
                        dayIndex: dayIndex
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($03f1fec0abba1d25$var$DaysContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $db32118662d8087f$export$5f587fb3fa527cfe), {
                        session: session
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $f734114e65d4ad82$export$bc76f6e6ce79f979), {
                        onAdd: (exercises)=>{
                            const reversedExercises = [
                                ...exercises
                            ].reverse();
                            reversedExercises.forEach((exercise)=>programEditor.addExerciseToSession(exercise, dayIndex, 0));
                        }
                    }),
                    session.exercises.map((exercise)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $ffhEE.ExerciseCard), {
                            exercise: exercise,
                            programEditor: programEditor,
                            deviceType: (0, $5kXMA.ResponsiveDeviceType).Mobile,
                            onClick: ()=>openExerciseDetailsModal(exercise, session.exercises, (0, $bFakw.AnalyticsViewExerciseDetailOrigin).CANVAS),
                            onCommentIconClick: ()=>openExerciseDetailsModal(exercise, session.exercises, (0, $bFakw.AnalyticsViewExerciseDetailOrigin).CANVAS, (0, $2zGye.ExerciseDetailsDialogTabs).COMMENT),
                            updatedExerciseId: updatedExerciseId,
                            updateExercise: updateExercise
                        }, exercise.draggableId)),
                    session.exercises.length > 0 && /*#__PURE__*/ (0, $iKObn.jsx)((0, $f734114e65d4ad82$export$bc76f6e6ce79f979), {
                        onAdd: (exercises)=>{
                            exercises.forEach((exercise)=>programEditor.addExerciseToSession(exercise, dayIndex, programEditor.getExerciseCountInSession(dayIndex)));
                        }
                    })
                ]
            })
        ]
    });
};
const $03f1fec0abba1d25$var$TitleContainer = (0, $5UMQ1.default).div`
	display: flex;
	place-items: center;
	padding-left: 13px;
`;
const $03f1fec0abba1d25$var$Title = (0, $5UMQ1.default).div`
	margin-top: 10px;
	margin-bottom: 10px;
`;
const $03f1fec0abba1d25$var$Container = (0, $5UMQ1.default).div`
	scroll-snap-align: center;
	display: flex;
	flex-direction: column;
	scroll-snap-align: start;
	flex: 1;
`;
const $03f1fec0abba1d25$var$DaysContainer = (0, $5UMQ1.default).div`
	background-color: ${(0, $kKnoQ.colors).primary10};
	display: flex;
	flex-direction: column;
	gap: 8px;
	border-radius: 16px;
	padding: 8px;
	flex: 1;
`;


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $kKnoQ = parcelRequire("kKnoQ");

var $1IWnK = parcelRequire("1IWnK");
parcelRequire("81g6h");
const $df3cc16c4f1a6eb9$export$a6fbf6bd6c5c81f = ({ programEditor: programEditor, className: className })=>{
    const editedProgram = (0, $1IWnK.useObservable)(programEditor.editedProgram);
    return /*#__PURE__*/ (0, $iKObn.jsx)($df3cc16c4f1a6eb9$var$DayTableContainer, {
        children: (0, $eAmnG.getDayColumnIndexes)().map((dayIndex)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $03f1fec0abba1d25$export$2fa2967919157591), {
                className: className,
                dayIndex: dayIndex,
                title: (0, $eAmnG.formatDayColumn)(dayIndex, "long"),
                session: editedProgram.days.get(dayIndex),
                programEditor: programEditor
            }, dayIndex))
    });
};
const $df3cc16c4f1a6eb9$var$DayTableContainer = (0, $5UMQ1.default).div`
	scroll-snap-type: x mandatory;
	scroll-padding: 32px;
	display: grid;
	grid-auto-flow: column;
	gap: 12px;
	overflow-x: auto;
	overflow-y: hidden;
	padding: 16px;
	padding-top: 8px;
	min-height: 100vh;
	background-color: ${(0, $kKnoQ.colors).white};

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		grid-auto-columns: 375px;
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		grid-auto-columns: 85vw;
	}
`;



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");
parcelRequire("81g6h");
const $0f653268f22f0a05$export$96f602c9e50477fa = ({ primaryButton: primaryButton, secondaryButton: secondaryButton })=>{
    (0, $1eHG3.useI18n)();
    if ((0, $lTdpc.isNil)(primaryButton) && (0, $lTdpc.isNil)(secondaryButton)) return null;
    return /*#__PURE__*/ (0, $iKObn.jsx)($0f653268f22f0a05$var$StickyBottom, {
        children: /*#__PURE__*/ (0, $iKObn.jsx)($0f653268f22f0a05$var$Footer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $06f7d348bd4277e0$export$6906986b9c4f9b75), {
                secondaryButton: secondaryButton,
                primaryButton: primaryButton
            })
        })
    });
};
const $0f653268f22f0a05$var$StickyBottom = (0, $5UMQ1.default).div`
	position: sticky;
	bottom: 0;
	width: 100%;
	z-index: 99;
`;
const $0f653268f22f0a05$var$Footer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "spacearound", "center")};
	background: ${(0, $kKnoQ.colors).white};
	border-top: 1px solid ${(0, $kKnoQ.colors).primary10};
`;


const $0d47cb3322d957ff$export$f9b75aee75f60728 = (_programStatus)=>{
    // Touch param to satisfy unused-var lint without any side effect
    _programStatus;
// Alternative exercise tooltip analytics removed
};



var $keCmP = parcelRequire("keCmP");

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dDMmD = parcelRequire("dDMmD");
var $dU78w = parcelRequire("dU78w");

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $1IWnK = parcelRequire("1IWnK");

var $isRr9 = parcelRequire("isRr9");
var $a6226d5c2cacd45a$var$LightSvg = function LightSvg(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1Zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7Zm2.85 11.1-.85.6V16h-4v-2.3l-.85-.6A4.997 4.997 0 0 1 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1Z",
            fill: "currentColor"
        })
    });
};
$a6226d5c2cacd45a$var$LightSvg.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $a6226d5c2cacd45a$export$988bb749955b53f2 = ({ onClick: onClick })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const stepsStatus = (0, $1IWnK.useObservable)((0, $ghfIB.onboardingManager).onboardingStepsStatus);
    const completedCount = (0, $81g6h.useMemo)(()=>{
        if (!stepsStatus) return 0;
        const isCompleted = (step)=>{
            const status = stepsStatus[step];
            return status === (0, $isRr9.OnboardingStepStatus).DISMISSED || status === (0, $isRr9.OnboardingStepStatus).DISMISSED_BUT_DISPLAYED;
        };
        // Map underlying guide steps to the 6 visible Quickstart items
        const addExercise = isCompleted((0, $isRr9.OnboardingProgramQuickstartStep).ADD_EXERCISE_GUIDE_01);
        const filterLibrary = isCompleted((0, $isRr9.OnboardingProgramQuickstartStep).FILTER_LIBRARY_GUIDE_01) && isCompleted((0, $isRr9.OnboardingProgramQuickstartStep).FILTER_LIBRARY_GUIDE_02);
        const complementary = isCompleted((0, $isRr9.OnboardingProgramQuickstartStep).COMPLEMENTARY_EXERCISES_GUIDE_01) && isCompleted((0, $isRr9.OnboardingProgramQuickstartStep).COMPLEMENTARY_EXERCISES_GUIDE_02) && isCompleted((0, $isRr9.OnboardingProgramQuickstartStep).COMPLEMENTARY_EXERCISES_GUIDE_03);
        const duplicateSession = isCompleted((0, $isRr9.OnboardingProgramQuickstartStep).DUPLICATE_SESSION_GUIDE_01) && isCompleted((0, $isRr9.OnboardingProgramQuickstartStep).DUPLICATE_SESSION_GUIDE_02);
        const startProgram = isCompleted((0, $isRr9.OnboardingProgramQuickstartStep).START_GUIDE_02);
        const alternatives = [
            (0, $isRr9.OnboardingProgramQuickstartStep).ALTERNATIVE_EXERCISES_GUIDE_01,
            (0, $isRr9.OnboardingProgramQuickstartStep).ALTERNATIVE_EXERCISES_GUIDE_02,
            (0, $isRr9.OnboardingProgramQuickstartStep).ALTERNATIVE_EXERCISES_GUIDE_03
        ].every(isCompleted);
        return [
            addExercise,
            filterLibrary,
            complementary,
            alternatives,
            duplicateSession,
            startProgram
        ].reduce((acc, done)=>acc + (done ? 1 : 0), 0);
    }, [
        stepsStatus
    ]);
    const iconOnly = completedCount === 6;
    return /*#__PURE__*/ (0, $iKObn.jsxs)($a6226d5c2cacd45a$var$Pill, {
        "data-testid": "quickstart-pill",
        onClick: onClick,
        "data-variant": iconOnly ? "icon-only" : "default",
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($a6226d5c2cacd45a$var$IconWrapper, {
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $iKObn.jsx)($a6226d5c2cacd45a$var$LightSvg, {})
            }),
            !iconOnly && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($a6226d5c2cacd45a$var$LabelText, {
                        children: format("programBuilder.quickstart.pill")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($a6226d5c2cacd45a$var$CountBadge, {
                        children: format("programBuilder.quickstart.pillCount", {
                            completedCount: completedCount,
                            totalCount: 6
                        })
                    })
                ]
            })
        ]
    });
};
const $a6226d5c2cacd45a$var$Pill = (0, $5UMQ1.default).button`
  position: relative;
  z-index: 0;
  border: none;
  background: var(--color-primary, #A055F0);
  color: #fff;
  min-width: 188px;
  min-height: 44px;
  line-height: 20px;
  padding: 2px 8px;
  border-radius: 999px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: background .2s ease;
  &:hover { background: var(--color-primary-hover, #8B4AD1); }

  &[data-variant="icon-only"] {
    min-width: 44px;
    width: 44px;
    min-height: 44px;
    padding: 10px;
    justify-content: center;
    gap: 0;
  }
`;
const $a6226d5c2cacd45a$var$IconWrapper = (0, $5UMQ1.default).span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  opacity: 0.9;
  line-height: 0;
  svg { width: 24px; height: 24px; display: block; }
`;
const $a6226d5c2cacd45a$var$CountBadge = (0, $5UMQ1.default).span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #603390;
  color: #ffffff;
  border-radius: 999px;
  line-height: 20px;
  padding: 2px 8px;
  min-height: 24px;
  min-width: 42px;
  font-weight: 600;
`;
const $a6226d5c2cacd45a$var$LabelText = (0, $5UMQ1.default).span`
  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  padding-right: 8px;
`;



var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");
var $be42e3bcdacc090d$var$CheckIcon = function CheckIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.064 5.318c.449.449.449 1.177 0 1.626L9.325 18.683a1.15 1.15 0 0 1-1.626 0L2.936 13.92a1.15 1.15 0 0 1 1.627-1.627l3.95 3.95L19.437 5.318a1.15 1.15 0 0 1 1.626 0Z",
            fill: "currentColor"
        })
    });
};
$be42e3bcdacc090d$var$CheckIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $be42e3bcdacc090d$var$ChevronRightIcon = function ChevronRightIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.97 5.355a1 1 0 0 0-.009 1.414L14.125 12 8.96 17.231a1 1 0 0 0 1.424 1.405l5.857-5.933a1 1 0 0 0 0-1.405l-5.857-5.934a1 1 0 0 0-1.414-.01Z",
            fill: "currentColor"
        })
    });
};
$be42e3bcdacc090d$var$ChevronRightIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $be42e3bcdacc090d$export$42a6c6f4f4c8bdbe = ({ step: step, state: state })=>{
    const clickable = state === "active" || state === "completed";
    return /*#__PURE__*/ (0, $iKObn.jsxs)($be42e3bcdacc090d$var$Row, {
        type: "button",
        "data-state": state,
        disabled: !clickable,
        onClick: clickable ? ()=>step.onClick?.() : undefined,
        "data-testid": `quickstart-step-${step.id}`,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($be42e3bcdacc090d$var$Bullet, {
                "aria-hidden": "true",
                children: state === "completed" || state === "completed-disabled" ? /*#__PURE__*/ (0, $iKObn.jsx)($be42e3bcdacc090d$var$CheckIcon, {}) : null
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($be42e3bcdacc090d$var$Texts, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)($be42e3bcdacc090d$var$Title, {
                    children: step.title
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($be42e3bcdacc090d$var$EndIcon, {
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $iKObn.jsx)($be42e3bcdacc090d$var$ChevronRightIcon, {})
            })
        ]
    });
};
const $be42e3bcdacc090d$var$Row = (0, $5UMQ1.default).button`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 5px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  opacity: 0.55;
  text-align: left;
  width: 100%;
  font: inherit;
  &[data-state="active"] { opacity: 1; }
  &[data-state="completed"] { opacity: 1; }
  &[data-state="completed-disabled"] { opacity: 0.75; }
  &:hover { background: rgba(0,0,0,0.05); }
  &:disabled { cursor: default; }
  &:disabled:hover { background: transparent; }
`;
const $be42e3bcdacc090d$var$Bullet = (0, $5UMQ1.default).span`
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border-radius: 50%;
  border: 2px solid ${(0, $kKnoQ.colors).grey50};
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  [data-state="completed"] & {
    background: #A055F0;
    border-radius: 50%;
  border: none;
    color: #ffffff; 
  }
  [data-state="completed-disabled"] & {
    background: #D5D5DB;
    border-radius: 50%;
    border: none;
    color: #ffffff;
  }
  svg { width: 16px; height: 16px; display: block; }
`;
const $be42e3bcdacc090d$var$Texts = (0, $5UMQ1.default).div`
  flex: 1;
  min-width: 0;
`;
const $be42e3bcdacc090d$var$Title = (0, $5UMQ1.default).div`
  font-size: 16px;
  line-height: 1.25;
  font-weight: 700;
  color: #14202c;
  [data-state="completed-disabled"] & {
    color: #74748B;
  }
`;
const $be42e3bcdacc090d$var$EndIcon = (0, $5UMQ1.default).span`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  color: ${(0, $kKnoQ.colors).grey50};
  svg { width: 20px; height: 20px; display: block; }
`;


const $0a51aca762607a39$var$STORAGE_KEY = "programBuilder.quickstart.visibility";
const $0a51aca762607a39$var$defaultState = {
    open: true,
    minimized: false
};
const $0a51aca762607a39$var$isQuickstartVisibilityState = (v)=>{
    if (typeof v !== "object" || v === null) return false;
    const obj = v;
    return typeof obj.open === "boolean" && typeof obj.minimized === "boolean";
};
function $0a51aca762607a39$export$55a70d78998303dd() {
    try {
        if (typeof window === "undefined") return $0a51aca762607a39$var$defaultState;
        const ls = window.localStorage;
        const raw = ls.getItem($0a51aca762607a39$var$STORAGE_KEY);
        if (!raw) return $0a51aca762607a39$var$defaultState;
        const parsed = JSON.parse(raw);
        if ($0a51aca762607a39$var$isQuickstartVisibilityState(parsed)) return parsed;
    } catch (/* istanbul ignore next */ e) {
        // eslint-disable-next-line no-console
        console.warn(e);
    }
    return $0a51aca762607a39$var$defaultState;
}
function $0a51aca762607a39$export$5334b8e7e307cdbb(state) {
    try {
        if (typeof window === "undefined") return;
        const ls = window.localStorage;
        ls.setItem($0a51aca762607a39$var$STORAGE_KEY, JSON.stringify(state));
    } catch (/* istanbul ignore next */ e) {
        // eslint-disable-next-line no-console
        console.warn(e);
    }
}



var $9d072 = parcelRequire("9d072");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");
const $625ec8a7e07fd975$export$ee2bfb8c57eedcd3 = (guide)=>{
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "startQuickstartGuide",
        params: [
            guide
        ]
    });
};
const $625ec8a7e07fd975$export$149f4b063c0e86a7 = (guide)=>{
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        action: "completeQuickstartGuide",
        params: [
            guide
        ]
    });
};
const $625ec8a7e07fd975$export$1cceac452ca5591a = (id)=>{
    switch(id){
        case "add-exercise":
            return "ADD_FIRST_EXERCISE";
        case "filter-library":
            return "FILTER_LIBRARY";
        case "add-complementary":
            return "ADD_COMPLEMENTARY_EXERCISES";
        case "add-alternatives":
            return "ADD_ALTERNATIVE_EXERCISES";
        case "duplicate-session":
            return "DUPLICATE_SESSION";
        case "start-program":
            return "START_SESSION";
        default:
            return null;
    }
};


const $6852a3b0052afe26$export$b31c0210621f08ce = ({ steps: steps, onClose: onClose })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const initial = (0, $0a51aca762607a39$export$55a70d78998303dd)();
    const [open, setOpen] = (0, $81g6h.useState)(initial.open);
    const [minimized, setMinimized] = (0, $81g6h.useState)(initial.minimized);
    const closeAndMinimize = (0, $81g6h.useCallback)(()=>{
        (0, $9d072.hideAlternativeHalo)();
        setOpen(false);
        setMinimized(true);
    }, []);
    const restore = (0, $81g6h.useCallback)(()=>{
        setOpen(true);
        setMinimized(false);
    }, []);
    const toggle = (0, $81g6h.useCallback)(()=>{
        (0, $9d072.hideAlternativeHalo)();
        if (open && !minimized) closeAndMinimize();
        else restore();
    }, [
        open,
        minimized,
        closeAndMinimize,
        restore
    ]);
    (0, $81g6h.useEffect)(()=>{
        (0, $0a51aca762607a39$export$5334b8e7e307cdbb)({
            open: open,
            minimized: minimized
        });
    }, [
        open,
        minimized
    ]);
    (0, $81g6h.useEffect)(()=>{
        if (open && !minimized) (0, $9d072.hideAlternativeHalo)();
    }, [
        open,
        minimized
    ]);
    const orderedSteps = (0, $81g6h.useMemo)(()=>steps, [
        steps
    ]);
    const resolveState = (s)=>{
        if (s.computeState) return s.computeState();
        return "active";
    };
    const allCompleted = (0, $81g6h.useMemo)(()=>orderedSteps.every((s)=>{
            const st = s.computeState ? s.computeState() : "active";
            return st === "completed" || st === "completed-disabled";
        }), [
        orderedSteps
    ]);
    const autoMinimizedRef = (0, $81g6h.useRef)(false);
    (0, $81g6h.useEffect)(()=>{
        if (allCompleted && !autoMinimizedRef.current) {
            setOpen(false);
            setMinimized(true);
            autoMinimizedRef.current = true;
        }
    }, [
        allCompleted
    ]);
    const content = /*#__PURE__*/ (0, $iKObn.jsxs)($6852a3b0052afe26$var$Container, {
        initial: {
            opacity: 0,
            y: 20
        },
        animate: {
            opacity: 1,
            y: 0
        },
        exit: {
            opacity: 0,
            y: 10
        },
        transition: {
            duration: 0.25,
            ease: "easeOut"
        },
        "data-testid": "quickstart-popover",
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($6852a3b0052afe26$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($6852a3b0052afe26$var$Title, {
                        children: format("programBuilder.quickstart.title")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($6852a3b0052afe26$var$CloseBtn, {
                        "aria-label": "close",
                        onClick: ()=>{
                            closeAndMinimize();
                            onClose?.();
                        },
                        children: "\xd7"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($6852a3b0052afe26$var$Intro, {
                children: format("programBuilder.quickstart.intro")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($6852a3b0052afe26$var$StepsList, {
                children: orderedSteps.map((s)=>{
                    const wrapped = {
                        ...s,
                        onClick: ()=>{
                            closeAndMinimize();
                            const guideName = (0, $625ec8a7e07fd975$export$1cceac452ca5591a)(s.id);
                            if (guideName) (0, $625ec8a7e07fd975$export$ee2bfb8c57eedcd3)(guideName);
                            s.onClick?.();
                        }
                    };
                    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $be42e3bcdacc090d$export$42a6c6f4f4c8bdbe), {
                        step: wrapped,
                        state: resolveState(s)
                    }, s.id);
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $iKObn.jsxs)($6852a3b0052afe26$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $dDMmD.AnimatePresence), {
                initial: false,
                children: open && !minimized && content
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $a6226d5c2cacd45a$export$988bb749955b53f2), {
                onClick: toggle
            })
        ]
    });
};
const $6852a3b0052afe26$var$Wrapper = (0, $5UMQ1.default).div`
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  pointer-events: none;
  > * { pointer-events: auto; }
`;
const $6852a3b0052afe26$var$Container = (0, $5UMQ1.default)((0, $dU78w.motion).div)`
  width: 340px;
  max-height: 395px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  padding: 12px 12px 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-family: inherit;
`;
const $6852a3b0052afe26$var$Header = (0, $5UMQ1.default).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const $6852a3b0052afe26$var$Title = (0, $5UMQ1.default).h4`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #14202c;
`;
const $6852a3b0052afe26$var$Intro = (0, $5UMQ1.default).p`
  color: #5a6472;
  font-size: 16px;
`;
const $6852a3b0052afe26$var$CloseBtn = (0, $5UMQ1.default).button`
  border: none;
  background: transparent;
  color: #5a6472;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  padding: 4px 8px;
  border-radius: 8px;
  &:hover { background: rgba(0,0,0,0.06); }
`;
const $6852a3b0052afe26$var$StepsList = (0, $5UMQ1.default).div`
  overflow-y: auto;
  padding: 4px 0 8px 0;
  display: flex;
  flex-direction: column;
`;



var $iglNQ = parcelRequire("iglNQ");

var $9d072 = parcelRequire("9d072");


var $2sUOK = parcelRequire("2sUOK");

var $lTdpc = parcelRequire("lTdpc");

var $isRr9 = parcelRequire("isRr9");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");


var $ghfIB = parcelRequire("ghfIB");
const $20b237f279bf9a8b$var$STORAGE_KEY = "programBuilder.quickstart.completedGuides";
const $20b237f279bf9a8b$var$GUIDE_KEYS = [
    "ADD_FIRST_EXERCISE",
    "FILTER_LIBRARY",
    "ADD_COMPLEMENTARY_EXERCISES",
    "ADD_ALTERNATIVE_EXERCISES",
    "DUPLICATE_SESSION",
    "START_SESSION"
];
function $20b237f279bf9a8b$var$currentUserKey() {
    const user = (0, $ghfIB.userManager).user.get();
    return user?.id ?? "__anonymous";
}
function $20b237f279bf9a8b$var$isLegacyCompletedGuides(obj) {
    if (!obj || typeof obj !== "object") return false;
    const keys = Object.keys(obj);
    return keys.some((k)=>$20b237f279bf9a8b$var$GUIDE_KEYS.includes(k));
}
function $20b237f279bf9a8b$var$readAll() {
    if (!("localStorage" in globalThis)) return {};
    try {
        const raw = globalThis.localStorage.getItem($20b237f279bf9a8b$var$STORAGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== "object") return {};
        if ($20b237f279bf9a8b$var$isLegacyCompletedGuides(parsed)) return {
            __legacy: parsed
        };
        return parsed;
    } catch (error_) {
        console.debug("[QuickstartCompletionStorage] readAll failed", error_);
        return {};
    }
}
function $20b237f279bf9a8b$var$readForCurrentUser() {
    const all = $20b237f279bf9a8b$var$readAll();
    const key = $20b237f279bf9a8b$var$currentUserKey();
    if (key === "__anonymous" && all.__legacy) return all.__legacy;
    return all[key] ?? {};
}
function $20b237f279bf9a8b$var$writeForCurrentUser(state) {
    if (!("localStorage" in globalThis)) return;
    try {
        const all = $20b237f279bf9a8b$var$readAll();
        const key = $20b237f279bf9a8b$var$currentUserKey();
        all[key] = state;
        globalThis.localStorage.setItem($20b237f279bf9a8b$var$STORAGE_KEY, JSON.stringify(all));
    } catch (error_) {
        console.debug("[QuickstartCompletionStorage] write failed", error_);
        return;
    }
}
function $20b237f279bf9a8b$export$25a53633ffc76bda(guide) {
    const state = $20b237f279bf9a8b$var$readForCurrentUser();
    return state[guide] === true;
}
function $20b237f279bf9a8b$export$b95ef3ba8aff4c7e(guide) {
    const state = $20b237f279bf9a8b$var$readForCurrentUser();
    if (state[guide]) return;
    state[guide] = true;
    $20b237f279bf9a8b$var$writeForCurrentUser(state);
}


const $665d077530360e17$export$73c8a2ff98437ce = ({ patient: patient, programContent: programContent, programEditor: programEditor, programStatus: programStatus, statusMessage: statusMessage, availableActions: availableActions, secondaryButton: secondaryButton, primaryButton: primaryButton, dataIsLoading: dataIsLoading, quitBlockingEnabled: quitBlockingEnabled = true, viewOnly: viewOnly = false, disabledLibraryTooltip: disabledLibraryTooltip, initialNotSavedProgramContent: initialNotSavedProgramContent, onProgramContentChanged: onProgramContentChanged, onProgramSchedulerClick: onProgramSchedulerClick })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const editedProgram = (0, $1IWnK.useObservable)(programEditor.editedProgram);
    const exerciseWithAlternativesEdited = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited);
    const onboardingStepsStatus = (0, $1IWnK.useObservable)((0, $ghfIB.onboardingManager).onboardingStepsStatus);
    const editedProgramWithUpdatedAlternativeExercises = (0, $eAmnG.updateExerciseFromProgram)(editedProgram, exerciseWithAlternativesEdited?.draggableId, exerciseWithAlternativesEdited);
    const hasPendingChanges = !(0, $eAmnG.programContentAreEquals)(editedProgramWithUpdatedAlternativeExercises, programContent);
    (0, $ecae20262ad72252$export$111b8d00ddadaa34)(quitBlockingEnabled && hasPendingChanges);
    (0, $81g6h.useEffect)(()=>{
        programEditor.setDataIsLoading(dataIsLoading);
    }, [
        dataIsLoading,
        programEditor
    ]);
    (0, $81g6h.useEffect)(()=>{
        if (initialNotSavedProgramContent) programEditor.editProgram((0, $eAmnG.programContentDeepCopy)(initialNotSavedProgramContent));
    }, [
        initialNotSavedProgramContent,
        programEditor
    ]);
    (0, $81g6h.useEffect)(()=>{
        onProgramContentChanged?.(editedProgramWithUpdatedAlternativeExercises);
    }, [
        editedProgram,
        onProgramContentChanged,
        editedProgramWithUpdatedAlternativeExercises
    ]);
    (0, $0d47cb3322d957ff$export$f9b75aee75f60728)(programStatus);
    const [showAddExerciseGuidance, setShowAddExerciseGuidance] = (0, $81g6h.useState)(false);
    const [showFilterLibraryGuidance, setShowFilterLibraryGuidance] = (0, $81g6h.useState)(false);
    const [primaryQuickstartTooltipVisible, setPrimaryQuickstartTooltipVisible] = (0, $81g6h.useState)(false);
    const firstExerciseDraggableId = (0, $1IWnK.useObservable)(programEditor.firstExerciseDraggableId);
    const hasAtLeastOneExercise = (0, $lTdpc.isNotNil)(firstExerciseDraggableId);
    const isQuickstartStepCompleted = (step)=>{
        if (!step) return false;
        const status = onboardingStepsStatus ? onboardingStepsStatus[step] : undefined;
        return status === (0, $isRr9.OnboardingStepStatus).DISMISSED || status === (0, $isRr9.OnboardingStepStatus).DISMISSED_BUT_DISPLAYED;
    };
    const addExerciseCompleted = isQuickstartStepCompleted((0, $isRr9.OnboardingProgramQuickstartStep).ADD_EXERCISE_GUIDE_01);
    const filterGuide01Completed = isQuickstartStepCompleted((0, $isRr9.OnboardingProgramQuickstartStep).FILTER_LIBRARY_GUIDE_01);
    const filterGuide02Completed = isQuickstartStepCompleted((0, $isRr9.OnboardingProgramQuickstartStep).FILTER_LIBRARY_GUIDE_02);
    const complementaryGuide01Completed = isQuickstartStepCompleted((0, $isRr9.OnboardingProgramQuickstartStep).COMPLEMENTARY_EXERCISES_GUIDE_01);
    const complementaryGuide02Completed = isQuickstartStepCompleted((0, $isRr9.OnboardingProgramQuickstartStep).COMPLEMENTARY_EXERCISES_GUIDE_02);
    const complementaryGuide03Completed = isQuickstartStepCompleted((0, $isRr9.OnboardingProgramQuickstartStep).COMPLEMENTARY_EXERCISES_GUIDE_03);
    const addComplementaryCompleted = complementaryGuide01Completed && complementaryGuide02Completed && complementaryGuide03Completed;
    const duplicateGuide01Completed = isQuickstartStepCompleted((0, $isRr9.OnboardingProgramQuickstartStep).DUPLICATE_SESSION_GUIDE_01);
    const duplicateGuide02Completed = isQuickstartStepCompleted((0, $isRr9.OnboardingProgramQuickstartStep).DUPLICATE_SESSION_GUIDE_02);
    const startGuide02Completed = isQuickstartStepCompleted((0, $isRr9.OnboardingProgramQuickstartStep).START_GUIDE_02);
    const startProgramCompleted = startGuide02Completed;
    const quickstartStates = {
        Locked: "locked",
        Active: "active",
        Completed: "completed",
        CompletedDisabled: "completed-disabled"
    };
    const computeAddComplementaryState = ()=>{
        if (addComplementaryCompleted) return quickstartStates.Completed;
        if (hasAtLeastOneExercise) return quickstartStates.Active;
        return quickstartStates.Locked;
    };
    const alternativeGuideStepsCompleted = [
        (0, $isRr9.OnboardingProgramQuickstartStep).ALTERNATIVE_EXERCISES_GUIDE_01,
        (0, $isRr9.OnboardingProgramQuickstartStep).ALTERNATIVE_EXERCISES_GUIDE_02,
        (0, $isRr9.OnboardingProgramQuickstartStep).ALTERNATIVE_EXERCISES_GUIDE_03
    ].every((step)=>isQuickstartStepCompleted(step));
    const computeDuplicateSessionState = ()=>{
        if (duplicateGuide01Completed && duplicateGuide02Completed) return quickstartStates.Completed;
        if (hasAtLeastOneExercise) return quickstartStates.Active;
        return quickstartStates.Locked;
    };
    (0, $81g6h.useEffect)(()=>{
        const trackOnce = (guide, completed)=>{
            if (!completed) return;
            if ((0, $20b237f279bf9a8b$export$25a53633ffc76bda)(guide)) return;
            (0, $625ec8a7e07fd975$export$149f4b063c0e86a7)(guide);
            (0, $20b237f279bf9a8b$export$b95ef3ba8aff4c7e)(guide);
        };
        trackOnce("ADD_FIRST_EXERCISE", addExerciseCompleted);
        trackOnce("FILTER_LIBRARY", filterGuide01Completed && filterGuide02Completed);
        trackOnce("ADD_COMPLEMENTARY_EXERCISES", addComplementaryCompleted);
        trackOnce("ADD_ALTERNATIVE_EXERCISES", alternativeGuideStepsCompleted);
        trackOnce("DUPLICATE_SESSION", duplicateGuide01Completed && duplicateGuide02Completed);
        trackOnce("START_SESSION", startProgramCompleted);
    }, [
        addExerciseCompleted,
        filterGuide01Completed,
        filterGuide02Completed,
        addComplementaryCompleted,
        alternativeGuideStepsCompleted,
        duplicateGuide01Completed,
        duplicateGuide02Completed,
        startProgramCompleted
    ]);
    const quickstartSteps = [
        {
            id: "add-exercise",
            title: format("programBuilder.quickstart.step.addFirstExercise"),
            computeState: ()=>addExerciseCompleted ? quickstartStates.Completed : quickstartStates.Active,
            onClick: ()=>setShowAddExerciseGuidance(true)
        },
        {
            id: "filter-library",
            title: format("programBuilder.quickstart.step.filterLibrary"),
            computeState: ()=>filterGuide01Completed && filterGuide02Completed ? quickstartStates.Completed : quickstartStates.Active,
            onClick: ()=>setShowFilterLibraryGuidance(true)
        },
        {
            id: "add-complementary",
            title: format("programBuilder.quickstart.step.addComplementaryExercises"),
            computeState: ()=>{
                if (!hasAtLeastOneExercise) return addComplementaryCompleted ? quickstartStates.CompletedDisabled : quickstartStates.Locked;
                return computeAddComplementaryState();
            },
            onClick: ()=>(0, $iglNQ.showComplementaryTooltip)()
        },
        {
            id: "add-alternatives",
            title: format("programBuilder.quickstart.step.addAlternativeExercises"),
            computeState: ()=>{
                if (!hasAtLeastOneExercise) return alternativeGuideStepsCompleted ? quickstartStates.CompletedDisabled : quickstartStates.Locked;
                return alternativeGuideStepsCompleted ? quickstartStates.Completed : quickstartStates.Active;
            },
            onClick: ()=>{
                (0, $9d072.resetAlternativeGuide3)();
                (0, $9d072.showAlternativeHalo)();
            }
        },
        {
            id: "duplicate-session",
            title: format("programBuilder.quickstart.step.duplicateSession"),
            computeState: ()=>{
                if (!hasAtLeastOneExercise) return duplicateGuide01Completed && duplicateGuide02Completed ? quickstartStates.CompletedDisabled : quickstartStates.Locked;
                return computeDuplicateSessionState();
            },
            onClick: ()=>(0, $fb718c2fd2914ade$export$39e11fc2bc349603)()
        },
        {
            id: "start-program",
            title: format("programBuilder.quickstart.step.startProgram"),
            computeState: ()=>{
                if (!hasAtLeastOneExercise) return startProgramCompleted ? quickstartStates.CompletedDisabled : quickstartStates.Locked;
                if (patient && programStatus && programStatus !== (0, $5SzTW.ProgramStatus).Draft) return startProgramCompleted ? quickstartStates.CompletedDisabled : quickstartStates.Locked;
                if (startProgramCompleted) return quickstartStates.Completed;
                return quickstartStates.Active;
            },
            onClick: ()=>{
                if (!patient || programStatus === (0, $5SzTW.ProgramStatus).Draft) {
                    setPrimaryQuickstartTooltipVisible(true);
                    (0, $2sUOK.requestStartGuide02)();
                }
            }
        }
    ];
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $keCmP.OnboardingContextProvider), {
        programEditor: programEditor,
        programStatus: programStatus,
        children: /*#__PURE__*/ (0, $iKObn.jsxs)((0, $41NLE.ProgramBuilderDragDropContextProvider), {
            programEditor: programEditor,
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)((0, $f5a1a1c59d206855$export$762dabf8c5869542), {
                    patient: patient,
                    programContent: editedProgram,
                    programStatus: programStatus,
                    statusMessage: statusMessage,
                    programActions: availableActions,
                    secondaryButton: $665d077530360e17$var$getButtonProps(secondaryButton, editedProgramWithUpdatedAlternativeExercises),
                    primaryButton: $665d077530360e17$var$getButtonProps(primaryButton && {
                        ...primaryButton,
                        onClick: async (pc)=>{
                            setPrimaryQuickstartTooltipVisible(false);
                            const startStep = patient ? (0, $isRr9.OnboardingProgramQuickstartStep).START_DRAFT_GUIDE_01 : (0, $isRr9.OnboardingProgramQuickstartStep).START_TEMPLATE_GUIDE_01;
                            await (0, $ghfIB.onboardingManager).passStepOnboarding(startStep);
                            primaryButton.onClick?.(pc);
                        }
                    }, editedProgramWithUpdatedAlternativeExercises),
                    primaryQuickstartTooltipStep: patient ? (0, $isRr9.OnboardingProgramQuickstartStep).START_DRAFT_GUIDE_01 : (0, $isRr9.OnboardingProgramQuickstartStep).START_TEMPLATE_GUIDE_01,
                    primaryQuickstartTooltipVisible: primaryQuickstartTooltipVisible,
                    onPrimaryQuickstartTooltipRequestClose: async ()=>{
                        setPrimaryQuickstartTooltipVisible(false);
                        const startStep = patient ? (0, $isRr9.OnboardingProgramQuickstartStep).START_DRAFT_GUIDE_01 : (0, $isRr9.OnboardingProgramQuickstartStep).START_TEMPLATE_GUIDE_01;
                        await (0, $ghfIB.onboardingManager).passStepOnboarding(startStep);
                    },
                    onNameChanged: (newName)=>programEditor.renameProgram(newName),
                    onProgramSchedulerClick: ()=>onProgramSchedulerClick?.(editedProgram),
                    editable: !viewOnly
                }),
                isDesktop ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $909d9a8c8470e5ac$export$114b63cb8d731b7d), {
                    disabled: viewOnly,
                    disabledTooltip: disabledLibraryTooltip,
                    pushedContent: /*#__PURE__*/ (0, $iKObn.jsx)($665d077530360e17$var$StyledDayTable, {
                        disabled: viewOnly,
                        editedProgram: editedProgram,
                        programEditor: programEditor
                    }),
                    title: format("exerciseLibrary.header"),
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $932f0b2abba92fe4$export$b27635f35f9f6b40), {
                        areAlternativesEdited: (0, $lTdpc.isNotNil)((0, $ghfIB.libraryFilterManager).exerciseWithAlternativesEdited.get()),
                        showAddExerciseGuidance: showAddExerciseGuidance,
                        onHideAddExerciseGuidance: ()=>setShowAddExerciseGuidance(false),
                        showFilterLibraryGuidance: showFilterLibraryGuidance,
                        onHideFilterLibraryGuidance: ()=>setShowFilterLibraryGuidance(false)
                    })
                }) : /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)($665d077530360e17$var$StyledMobileDayCarousel, {
                            disabled: viewOnly,
                            programEditor: programEditor
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $0f653268f22f0a05$export$96f602c9e50477fa), {
                            primaryButton: $665d077530360e17$var$getButtonProps(primaryButton, editedProgramWithUpdatedAlternativeExercises),
                            secondaryButton: $665d077530360e17$var$getButtonProps(secondaryButton, editedProgramWithUpdatedAlternativeExercises)
                        })
                    ]
                }),
                isDesktop && /*#__PURE__*/ (0, $iKObn.jsx)((0, $6852a3b0052afe26$export$b31c0210621f08ce), {
                    steps: quickstartSteps
                })
            ]
        })
    });
};
const $665d077530360e17$var$disableElementCSS = ({ disabled: disabled })=>disabled && (0, $kkH7g.css)`
		opacity: 0.5;
		touch-action: none;
		pointer-events: none;
		user-select: none;
	`;
const $665d077530360e17$var$StyledDayTable = (0, $5UMQ1.default)((0, $eba2e8dd5c09cae0$export$cd402b7558adf371))`
	${$665d077530360e17$var$disableElementCSS}
`;
const $665d077530360e17$var$StyledMobileDayCarousel = (0, $5UMQ1.default)((0, $df3cc16c4f1a6eb9$export$a6fbf6bd6c5c81f))`
	${$665d077530360e17$var$disableElementCSS}
`;
function $665d077530360e17$var$getButtonProps(buttonProps, editedProgram) {
    return buttonProps ? {
        ...buttonProps,
        tooltip: buttonProps.disabledTooltipMessage,
        onClick: ()=>buttonProps.onClick?.(editedProgram)
    } : undefined;
}



var $lTdpc = parcelRequire("lTdpc");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
var $386e72469e7ea4a8$var$DeleteIcon = function DeleteIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M10.82 2c-.52 0-1.01.2-1.38.57L9.01 3h-5c-.13 0-.26.02-.39.07a1.004 1.004 0 0 0-.55.55c-.05.12-.07.25-.07.39s.02.26.07.39c.05.12.13.23.22.33.1.09.21.17.33.22.13.05.26.07.39.07h16c.13 0 .26-.02.39-.07a1.004 1.004 0 0 0 .55-.55c.05-.12.07-.25.07-.39s-.02-.26-.07-.39a1.19 1.19 0 0 0-.22-.33c-.1-.09-.21-.17-.33-.22-.13-.05-.26-.07-.39-.07h-5l-.43-.43A1.92 1.92 0 0 0 13.2 2h-2.38ZM16.13 22H7.88c-1.5 0-2.78-1.05-2.97-2.447L3.409 8.136a1 1 0 0 1 .991-1.13h15.22a1 1 0 0 1 .991 1.13L19.11 19.534C18.9 20.95 17.62 22 16.13 22ZM5.5 8.88l1.39 10.448c.06.44.5.797.99.797h8.25c.5 0 .93-.356 1-.825l1.39-10.42H5.5Z",
            fill: "currentColor"
        })
    });
};
$386e72469e7ea4a8$var$DeleteIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $386e72469e7ea4a8$var$DuplicateIcon = function DuplicateIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M4 2a2 2 0 0 0-2 2v13a1 1 0 0 0 2 0V4h13a1 1 0 0 0 0-2H4Zm4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H8Zm0 2h12v12H8V8Z",
            fill: "currentColor"
        })
    });
};
$386e72469e7ea4a8$var$DuplicateIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $386e72469e7ea4a8$var$StopIcon = function StopIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M19.736 5.7a.885.885 0 0 0-.645-.264.885.885 0 0 0-.646.264.885.885 0 0 0-.263.645v12.01c0 .5-.182.927-.537 1.281a1.751 1.751 0 0 1-1.281.537h-6.319a.94.94 0 0 1-.436-.11.823.823 0 0 1-.318-.29l-3.573-5.21 1.864 1.31a.95.95 0 0 0 1.5-.782V4.727a.885.885 0 0 0-.264-.645.885.885 0 0 0-.645-.264.885.885 0 0 0-.646.264.885.885 0 0 0-.263.645v8.71L4.627 11.6a1.488 1.488 0 0 0-1.072-.273c-.391.046-.737.21-1.019.5a.883.883 0 0 0-.12 1.14l5.375 7.86c.254.382.582.673.982.873.39.21.818.31 1.272.31h6.319c1.109 0 2.045-.437 2.8-1.32A3.544 3.544 0 0 0 20 18.374V6.355a.885.885 0 0 0-.264-.646V5.7Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M8.83 13.172c.964-.345 3.615-.672 4.634-.69a9.166 9.166 0 0 1 3.309.545c.1.037 1.308.477 1.417.477a.907.907 0 0 0 .855-.6.907.907 0 0 0-.546-1.164c-.336-.118-1.79-.64-2.135-.73V3.817a.885.885 0 0 0-.264-.645.885.885 0 0 0-.646-.264.885.885 0 0 0-.645.264.885.885 0 0 0-.264.645v6.891a14.856 14.856 0 0 0-1.109-.045c-.236 0-.472.018-.709.045v-7.8a.885.885 0 0 0-.263-.645.885.885 0 0 0-.646-.264.885.885 0 0 0-.645.264.885.885 0 0 0-.264.645V11c-.354.09-2.342.336-2.688.454a.907.907 0 0 0-.545 1.163.907.907 0 0 0 1.164.546l-.01.01Z",
                fill: "currentColor"
            })
        ]
    });
};
$386e72469e7ea4a8$var$StopIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $386e72469e7ea4a8$var$InfoIcon = function InfoIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Zm0-20c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12.01 17.17c-.55 0-1-.45-1-1v-5.44c0-.55.45-1 1-1s1 .45 1 1v5.44c0 .55-.45 1-1 1ZM12 8.11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                fill: "currentColor"
            })
        ]
    });
};
$386e72469e7ea4a8$var$InfoIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $386e72469e7ea4a8$var$PlayIcon = function PlayIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 7c0-1.597 1.753-2.514 3.071-1.687l.006.003 8.135 5.174c1.222.788 1.242 2.587-.007 3.375L9.08 19.042h-.002C7.741 19.9 6 18.938 6 17.36V7Zm2 .003v10.355l.003-.001 8.132-5.182h-.002c0-.001 0-.002-.002-.002l-.002-.002-8.121-5.164a.055.055 0 0 0-.006-.004H8Z",
            fill: "currentColor"
        })
    });
};
$386e72469e7ea4a8$var$PlayIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $386e72469e7ea4a8$var$PrimaryButtonLabel = {
    [(0, $5SzTW.ProgramStatus).Ongoing]: "programBuilder.editOngoingProgramButton.v2_1",
    [(0, $5SzTW.ProgramStatus).Scheduled]: "programBuilder.editScheduleProgramButton.v2_1",
    [(0, $5SzTW.ProgramStatus).Draft]: "programBuilder.startButton",
    [(0, $5SzTW.ProgramStatus).Ended]: "programBuilder.editEndedProgramButton.v2_1"
};
const $386e72469e7ea4a8$export$f26d6fcaf3362a47 = ({ patient: patient, program: program, template: template, programIsLoading: programIsLoading, openScheduleModal: openScheduleModal })=>{
    const [isUpdating, setIsUpdating] = (0, $81g6h.useState)(false);
    const { format: format } = (0, $1eHG3.useI18n)();
    const user = (0, $4UKJF.useUser)();
    const { formatPatientName: formatPatientName } = (0, $aEP4N.useFormatPatients)();
    const defaultProgramContent = (0, $81g6h.useMemo)(()=>({
            name: program.name ?? format("programBuilder.defaultTitle.v2_1", {
                patientName: patient.firstName
            }),
            days: program.days,
            startDate: program.startDate,
            endDate: program.endDate
        }), [
        format,
        patient.firstName,
        program.days,
        program.endDate,
        program.name,
        program.startDate
    ]);
    const programContentFromTemplate = (0, $81g6h.useMemo)(()=>template ? {
            name: defaultProgramContent.name,
            days: template.days
        } : undefined, [
        defaultProgramContent.name,
        template
    ]);
    const isViewOnly = program.status === (0, $5SzTW.ProgramStatus).Ended;
    const { duplicateAsDraftProgram: duplicateAsDraftProgram, duplicateAsTemplateProgram: duplicateAsTemplateProgram, loading: loading } = (0, $2hf1V.useProgramActions)();
    // if viewOnly change it should not reset the content so there is a useEffect to change editable property if viewOnly change
    // same for dataIsLoading
    const programEditor = (0, $81g6h.useMemo)(()=>new (0, $02b6689614593d0d$export$e4ac5f3bb70a008e)((0, $eAmnG.programContentDeepCopy)(defaultProgramContent), (0, $ghfIB.onboardingManager), programIsLoading), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $81g6h.useEffect)(()=>{
        programEditor.editProgram((0, $eAmnG.programContentDeepCopy)(defaultProgramContent));
    }, [
        defaultProgramContent,
        programEditor
    ]);
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const patientId = patient.id;
    const navigate = (0, $htiSH.useNavigate)();
    const [isApplyingRemoteChanges, setIsApplyingRemoteChanges] = (0, $81g6h.useState)(false);
    const [hasPendingChanges, setHasPendingChanges] = (0, $81g6h.useState)(false);
    const [editedProgramIsEmpty, setEditedProgramIsEmpty] = (0, $81g6h.useState)(defaultProgramContent.days.isEmpty);
    const editedProgram = (0, $1IWnK.useObservable)(programEditor.editedProgram);
    const isProgramFromTemplate = (0, $1IWnK.useComputedObservable)(()=>(0, $ghfIB.templateOperationsManager).lastTemplateOperation.get()?.type === "assign", []);
    const navigateToNewProgram = (0, $81g6h.useCallback)((programId)=>navigate((0, $lDZlX.RoutesPath).ProgramBuilder, {
            route: {
                patientId: patientId
            },
            query: {
                programId: programId
            }
        }, {
            replace: true
        }), [
        navigate,
        patientId
    ]);
    const [saveProgram, loadingSave] = (0, $grmoS.useAsyncOperation)(async (editedContent)=>{
        try {
            setIsApplyingRemoteChanges(true);
            const editedContentWithDefaultName = {
                days: editedContent.days,
                name: editedContent.name
            };
            let metadata;
            if ((0, $eAmnG.isNewProgram)(program)) {
                metadata = await (0, $ghfIB.programManager).createDraftProgram(patientId, editedContentWithDefaultName, ()=>false);
                (0, $bC9c0.sendAnalyticsEventSaveProgram)(patient, metadata.id);
            } else {
                await (0, $ghfIB.programManager).saveProgram(patientId, program.id, editedContentWithDefaultName);
                if (program.status === (0, $5SzTW.ProgramStatus).Draft) (0, $bC9c0.sendAnalyticsEventSaveProgram)(patient, program.id);
                else (0, $bC9c0.sendAnalyticsEventEditProgram)();
            }
            showToast(format("programBuilder.saveButton.successToast.title"), format("programBuilder.saveButton.successToast.message"), "success");
            if ((0, $eAmnG.isNewProgram)(program) && metadata) navigateToNewProgram(metadata.id);
            if (!(0, $eAmnG.isNewProgram)(program) && template?.id) navigateToNewProgram(program.id);
            setIsApplyingRemoteChanges(false);
        } catch (error) {
            console.error("Failed to save program", error);
            showToast(format("programBuilder.saveButton.errorToast.title"), format("programBuilder.saveButton.errorToast.message"));
            setIsApplyingRemoteChanges(false);
        }
    }, {
        deps: [
            format,
            navigateToNewProgram,
            patient.analyticsId,
            patientId,
            program,
            showToast,
            template?.id
        ]
    });
    const getStatusWording = (0, $81g6h.useCallback)(()=>{
        switch(program.status){
            case (0, $5SzTW.ProgramStatus).Ongoing:
                return format("programBuilder.programStatus.ongoing.v2_1");
            case (0, $5SzTW.ProgramStatus).Scheduled:
                return format("programBuilder.programStatus.scheduled.v2_1");
            case (0, $5SzTW.ProgramStatus).Draft:
                return format("programBuilder.programStatus.draft");
            case (0, $5SzTW.ProgramStatus).Ended:
                return format("programBuilder.programStatus.ended.v2_1");
        }
    }, [
        format,
        program.status
    ]);
    const navigateBackToPatientPrograms = (0, $81g6h.useCallback)(()=>{
        setIsApplyingRemoteChanges(true);
        setTimeout(()=>{
            navigate((0, $lDZlX.RoutesPath).PatientDetails, {
                route: {
                    patientId: patient.id
                },
                query: {
                    active: (0, $lDZlX.TabPatientDetails).PROGRAMS_TAB
                }
            }, {
                replace: true
            });
            dialogContext?.closeAll();
            setIsApplyingRemoteChanges(false);
        }, 100);
    }, [
        dialogContext,
        navigate,
        patient.id
    ]);
    const confirmDuplication = (0, $81g6h.useCallback)((onConfirm)=>{
        dialogContext?.openModal((0, $243Cr.ModalId).ConfirmDuplication, {
            onConfirm: onConfirm
        });
    }, [
        dialogContext
    ]);
    const availableActions = (0, $81g6h.useMemo)(()=>{
        if ((0, $eAmnG.isNewProgram)(program)) return [];
        const runDuplicateAsDraft = async ()=>duplicateAsDraftProgram({
                patientId: patient.id,
                programName: program.name,
                programId: program.id
            });
        const handleDuplicateAsDraft = async ()=>{
            if (hasPendingChanges) {
                confirmDuplication(runDuplicateAsDraft);
                return;
            }
            await runDuplicateAsDraft();
        };
        const runDuplicateAsTemplate = async (templateName)=>duplicateAsTemplateProgram({
                patientId: patient.id,
                programId: program.id,
                templateName: templateName
            });
        const handleDuplicateAsTemplateSubmit = async (templateName)=>{
            if (hasPendingChanges) {
                confirmDuplication(()=>runDuplicateAsTemplate(templateName));
                return;
            }
            await runDuplicateAsTemplate(templateName);
            dialogContext?.closeAll();
        };
        const deleteAction = {
            text: format("programBuilder.popupMenu.deleteProgram"),
            icon: /*#__PURE__*/ (0, $iKObn.jsx)($386e72469e7ea4a8$var$DeleteIcon, {
                height: 24,
                width: 24
            }),
            destructive: true,
            onClick: ()=>{
                dialogContext?.openModal((0, $243Cr.ModalId).DeleteProgram, {
                    patient: patient,
                    program: program,
                    onSuccess: ()=>{
                        navigateBackToPatientPrograms();
                        (0, $bC9c0.sendAnalyticsEventDeleteProgram)(patient, program.id, (0, $bC9c0.AnalyticsProgramLocation).PROGRAM_BUILDER);
                    }
                });
            }
        };
        const duplicateAsDraftAction = {
            text: format("global.programOperation.duplicateAsDraft"),
            icon: /*#__PURE__*/ (0, $iKObn.jsx)($386e72469e7ea4a8$var$DuplicateIcon, {
                height: 24,
                width: 24
            }),
            onClick: handleDuplicateAsDraft
        };
        const duplicateAsTemplateAction = {
            text: format("global.programOperation.duplicateAsTemplate"),
            icon: /*#__PURE__*/ (0, $iKObn.jsx)($386e72469e7ea4a8$var$DuplicateIcon, {
                height: 24,
                width: 24
            }),
            onClick: ()=>{
                dialogContext?.openModal((0, $243Cr.ModalId).DuplicateAsTemplateProgram, {
                    programName: editedProgram.name,
                    onSubmit: handleDuplicateAsTemplateSubmit
                });
            }
        };
        const stopAction = {
            text: format("programBuilder.popupMenu.stopProgram"),
            icon: /*#__PURE__*/ (0, $iKObn.jsx)($386e72469e7ea4a8$var$StopIcon, {
                height: 24,
                width: 24
            }),
            destructive: true,
            onClick: ()=>{
                (0, $lTdpc.isNotNil)(user) && dialogContext?.openModal((0, $243Cr.ModalId).StopProgram, {
                    patient: patient,
                    program: program,
                    editor: user,
                    onSuccess: ()=>{
                        navigateBackToPatientPrograms();
                        (0, $bC9c0.sendAnalyticsEventStopProgram)(patient, program.id, (0, $bC9c0.AnalyticsProgramLocation).PROGRAM_BUILDER);
                    }
                });
            }
        };
        switch(program.status){
            case (0, $5SzTW.ProgramStatus).Scheduled:
            case (0, $5SzTW.ProgramStatus).Draft:
                return [
                    duplicateAsDraftAction,
                    duplicateAsTemplateAction,
                    deleteAction
                ];
            case (0, $5SzTW.ProgramStatus).Ongoing:
                return [
                    duplicateAsDraftAction,
                    duplicateAsTemplateAction,
                    stopAction
                ];
            case (0, $5SzTW.ProgramStatus).Ended:
                return [
                    duplicateAsTemplateAction,
                    deleteAction
                ];
        }
    }, [
        dialogContext,
        editedProgram.name,
        format,
        confirmDuplication,
        duplicateAsDraftProgram,
        duplicateAsTemplateProgram,
        navigateBackToPatientPrograms,
        hasPendingChanges,
        patient,
        program,
        user
    ]);
    (0, $81g6h.useEffect)(()=>()=>(0, $ghfIB.templateOperationsManager).removeLastTemplateOperation(), []);
    const secondaryButtonProps = (0, $81g6h.useMemo)(()=>{
        if (program.status === (0, $5SzTW.ProgramStatus).Draft) return {
            label: format("programBuilder.saveButton"),
            disabled: editedProgramIsEmpty || !hasPendingChanges,
            disabledTooltipMessage: editedProgramIsEmpty ? format("programBuilder.cantSaveProgramTooltipMessage") : format("programBuilder.cantSaveBecauseAlreadySavedTooltipMessage"),
            onClick: saveProgram,
            loading: loadingSave
        };
    }, [
        editedProgramIsEmpty,
        format,
        hasPendingChanges,
        loadingSave,
        program.status,
        saveProgram
    ]);
    const openStartProgramDialog = (0, $81g6h.useCallback)((editedContent)=>{
        if (user) dialogContext?.openModal((0, $243Cr.ModalId).StartProgram, {
            patient: patient,
            editor: user,
            program: program,
            editedProgram: editedContent,
            onSuccess: async ()=>{
                if (program.status === (0, $5SzTW.ProgramStatus).Draft) navigateBackToPatientPrograms();
            },
            skipDialogConfirmation: program.status === (0, $5SzTW.ProgramStatus).Ongoing || program.status === (0, $5SzTW.ProgramStatus).Scheduled,
            handleLoading: setIsUpdating
        });
    }, [
        dialogContext,
        navigateBackToPatientPrograms,
        patient,
        program,
        user
    ]);
    const primaryButtonProps = (0, $81g6h.useMemo)(()=>{
        let primaryButtonIcon;
        if (program.status === (0, $5SzTW.ProgramStatus).Ongoing) primaryButtonIcon = "pi pi-save";
        else if (program.status === (0, $5SzTW.ProgramStatus).Draft) primaryButtonIcon = /*#__PURE__*/ (0, $iKObn.jsx)($386e72469e7ea4a8$var$PlayIcon, {
            className: "p-button-icon-right",
            width: 16,
            height: 16
        });
        return {
            disabled: editedProgramIsEmpty,
            label: format($386e72469e7ea4a8$var$PrimaryButtonLabel[program.status]),
            icon: primaryButtonIcon,
            disabledTooltipMessage: format("programBuilder.cantStartProgramTooltipMessage"),
            onClick: async (editedContent)=>{
                if (program.status === (0, $5SzTW.ProgramStatus).Ended) {
                    await duplicateAsDraftProgram({
                        patientId: patient.id,
                        programName: program.name,
                        programId: program.id,
                        onSuccess: navigateBackToPatientPrograms
                    });
                    return;
                }
                if ((0, $lTdpc.isNotNil)(user)) openStartProgramDialog(editedContent);
            },
            loading: loading || isUpdating
        };
    }, [
        editedProgramIsEmpty,
        format,
        program,
        loading,
        isUpdating,
        user,
        openStartProgramDialog,
        duplicateAsDraftProgram,
        patient.id,
        navigateBackToPatientPrograms
    ]);
    const openDatesScheduler = (0, $81g6h.useCallback)((editedContent)=>{
        dialogContext?.openModal((0, $243Cr.ModalId).ScheduleProgram, {
            patient: patient,
            editedProgram: editedContent,
            program: program,
            onSave: (dates)=>programEditor.editProgramDates(dates.startDate, dates.endDate),
            secondaryButtonProps: program.status === (0, $5SzTW.ProgramStatus).Ongoing ? {
                label: format("programBuilder.scheduleDialog.updateProgramButton"),
                onClick: (dates)=>{
                    programEditor.editProgramDates(dates.startDate, dates.endDate);
                    openStartProgramDialog({
                        ...editedContent,
                        ...dates
                    });
                },
                loading: isUpdating
            } : undefined
        });
    }, [
        dialogContext,
        format,
        isUpdating,
        openStartProgramDialog,
        patient,
        program,
        programEditor
    ]);
    (0, $giAv5.useOnceEffect)(()=>openDatesScheduler(editedProgram), openScheduleModal, [
        openScheduleModal
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $lKGAO.TrackingContextProvider), {
        category: (0, $auPqo.AnalyticsCategory).PROGRAM,
        programId: (0, $eAmnG.isProgram)(program) ? program.id : "",
        children: [
            isProgramFromTemplate && /*#__PURE__*/ (0, $iKObn.jsx)((0, $6Px22.Banner), {
                uiStyle: "success",
                icon: $386e72469e7ea4a8$var$InfoIcon,
                text: format("programBuilder.assignTemplateBanner.v1_6", {
                    name: formatPatientName(patient)
                }),
                onDelete: ()=>(0, $ghfIB.templateOperationsManager).removeLastTemplateOperation()
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $665d077530360e17$export$73c8a2ff98437ce), {
                patient: patient,
                programContent: defaultProgramContent,
                programEditor: programEditor,
                programStatus: program.status,
                initialNotSavedProgramContent: programContentFromTemplate,
                statusMessage: getStatusWording(),
                availableActions: availableActions,
                onProgramContentChanged: (newProgramContent)=>{
                    setHasPendingChanges(!(0, $eAmnG.programContentAreEquals)(newProgramContent, defaultProgramContent));
                    setEditedProgramIsEmpty(newProgramContent.days.isEmpty);
                },
                secondaryButton: secondaryButtonProps,
                primaryButton: primaryButtonProps,
                dataIsLoading: programIsLoading,
                quitBlockingEnabled: !isApplyingRemoteChanges,
                viewOnly: isViewOnly,
                disabledLibraryTooltip: format("programBuilder.cantOpenFormerExerciseLibraryTooltipMessage"),
                onProgramSchedulerClick: openDatesScheduler
            })
        ]
    });
};



var $4x2M3 = parcelRequire("4x2M3");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $buI4E = parcelRequire("buI4E");

var $81g6h = parcelRequire("81g6h");
const $e76f15e066bf48ed$export$f79f473d8aee3ee6 = ()=>{
    const { patientId: patientId } = (0, $fec74558288ce465$export$1f9b870ad76091)();
    const { programId: programId, templateId: templateId, openScheduleModal: openScheduleModal } = (0, $8zvzh.useQueryParams)();
    const { format: format } = (0, $1eHG3.useI18n)();
    if (!patientId) return /*#__PURE__*/ (0, $iKObn.jsx)($e76f15e066bf48ed$var$Container, {
        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
            description: format("global.patientNotFound.description")
        })
    });
    return /*#__PURE__*/ (0, $iKObn.jsx)($e76f15e066bf48ed$var$ProgramBuilderContent, {
        patientId: patientId,
        programId: programId,
        templateId: templateId,
        openScheduleModal: (0, $buI4E.stringToBoolean)(openScheduleModal ?? "")
    });
};
const $e76f15e066bf48ed$var$ProgramBuilderContent = ({ patientId: patientId, programId: programId, templateId: templateId, openScheduleModal: openScheduleModal })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { loading: patientLoading, patient: patient, error: errorPatient, refreshPatient: refreshPatient } = (0, $aEP4N.usePatient)(patientId);
    const { loading: programLoading, program: program, error: errorProgram, refreshProgram: refreshProgram } = (0, $9L5pp.usePatientProgram)({
        programId: programId,
        patientId: patientId
    });
    const { template: template, loading: templateLoading, error: errorTemplate, refreshTemplate: refreshTemplate } = (0, $4x2M3.useTemplate)(templateId);
    const currentProgram = (0, $81g6h.useMemo)(()=>programId ? program : (0, $eAmnG.getEmptyNewProgram)(patientId), [
        patientId,
        program,
        programId
    ]);
    if (!currentProgram || !patient || templateId && !template) {
        if (patientLoading || programLoading || templateLoading) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $16481cc1bc2caefe$export$3dfcbcf80c1dbed5), {
            size: (0, $16481cc1bc2caefe$export$dc8a48d838f0e600).FullSpace
        });
        return /*#__PURE__*/ (0, $iKObn.jsx)($e76f15e066bf48ed$var$Container, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
                description: $e76f15e066bf48ed$var$getErrorWording(format, errorPatient, errorProgram, errorTemplate),
                onRefresh: async ()=>{
                    if (patientId && programId) {
                        await refreshPatient(patientId);
                        await refreshProgram(patientId, programId);
                        if (templateId) await refreshTemplate(templateId);
                    }
                }
            })
        });
    }
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $386e72469e7ea4a8$export$f26d6fcaf3362a47), {
        patient: patient,
        program: currentProgram,
        programIsLoading: programLoading || templateLoading,
        template: template,
        openScheduleModal: openScheduleModal
    });
};
function $e76f15e066bf48ed$var$getErrorWording(format, patientError, programError, templateError) {
    if ((0, $04Qjn.isApiError)(patientError)) return format("global.patientNotFound.description");
    if ((0, $04Qjn.isApiError)(programError)) return format("global.programNotFound.description");
    if ((0, $04Qjn.isApiError)(templateError)) return format("templateBuilder.templateNotFoundError");
    return undefined;
}
const $e76f15e066bf48ed$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "stretch")};
	flex-grow: 1;
`;



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $8zvzh = parcelRequire("8zvzh");

var $28f8Y = parcelRequire("28f8Y");

var $1IlhR = parcelRequire("1IlhR");

var $1acTy = parcelRequire("1acTy");

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $5O4Jv = parcelRequire("5O4Jv");

var $5UMQ1 = parcelRequire("5UMQ1");

var $hIci4 = parcelRequire("hIci4");

var $5RTr6 = parcelRequire("5RTr6");

var $jCNJs = parcelRequire("jCNJs");

var $2kge5 = parcelRequire("2kge5");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $68IWj = parcelRequire("68IWj");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
const $88480e12bca23281$export$c7384d2c2163ec5c = ({ config: config, onSuccess: onSuccess })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const [privacyNoticeUrl, setPrivacyNoticeUrl] = (0, $81g6h.useState)("");
    const { control: control, handleSubmit: handleSubmit, resetField: resetField, watch: watch, clearErrors: clearErrors } = (0, $eKUeg.useForm)({
        defaultValues: {
            firstName: "",
            lastName: "",
            countryCode: config.initialCountryCode,
            postalCode: "",
            phoneNumber: "",
            medicalProfession: undefined,
            shareDataConsent: false,
            patientFirstName: "",
            patientLastName: ""
        },
        shouldFocusError: false
    });
    const openPatientPrivacyNotice = (0, $81g6h.useCallback)(()=>{
        window.open(privacyNoticeUrl, "_blank");
    }, [
        privacyNoticeUrl
    ]);
    const selectedCountryCode = watch("countryCode");
    const [submitForm, isSubmitting] = (0, $grmoS.useAsyncOperation)(async (data)=>{
        try {
            await (0, $ghfIB.prospectRequestManager).sendInviteYourPTRequest(data);
            (0, $ghfIB.analyticsService).trackEvent({
                category: (0, $auPqo.AnalyticsCategory).PROSPECT,
                action: "successSubmit",
                params: [
                    (0, $5O4Jv.ProspectCampaigns).INVITE_YOUR_PT,
                    data.countryCode,
                    data.medicalProfession ?? "null"
                ]
            });
            onSuccess();
        } catch (e) {
            console.error("Failed to submit demo request", e);
            (0, $ghfIB.analyticsService).trackEvent({
                category: (0, $auPqo.AnalyticsCategory).PROSPECT,
                action: "failSubmit",
                params: [
                    (0, $5O4Jv.ProspectCampaigns).INVITE_YOUR_PT
                ]
            });
            (0, $ghfIB.networkActionsErrorsManager).reportError(e);
            throw e;
        }
    }, {});
    const onFormErrorSubmit = (fieldErrors)=>{
        const showAnalytics = Object.values(fieldErrors).every((field)=>field.type !== "required");
        if (showAnalytics) (0, $ghfIB.analyticsService).trackEvent({
            category: (0, $auPqo.AnalyticsCategory).PROSPECT,
            action: "failSubmit",
            params: [
                (0, $5O4Jv.ProspectCampaigns).INVITE_YOUR_PT
            ]
        });
    };
    return /*#__PURE__*/ (0, $iKObn.jsxs)($88480e12bca23281$var$FormContainer, {
        onSubmit: handleSubmit(submitForm, onFormErrorSubmit),
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                className: "p-size-s-bold",
                children: format("inviteYourPt.form.ptSection.title")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $2kge5.PtInfoControls), {
                initialCountryCode: selectedCountryCode,
                config: config,
                control: control,
                resetField: resetField,
                clearErrors: clearErrors,
                campaign: (0, $5O4Jv.ProspectCampaigns).INVITE_YOUR_PT,
                onPrivacyNoticeUrlChange: setPrivacyNoticeUrl
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($88480e12bca23281$var$Separator, {}),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                className: "p-size-s-bold",
                children: format("inviteYourPt.form.patientSection.title")
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($88480e12bca23281$var$TwoColumnLayout, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                        name: "patientFirstName",
                        control: control,
                        rules: {
                            required: format("global.form.field.requiredError")
                        },
                        render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $5RTr6.FormField), {
                                title: format("inviteYourPt.form.patientSection.firstName.title"),
                                errorMessage: fieldState.error?.message,
                                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                    ...field,
                                    placeholder: format("inviteYourPt.form.patientSection.firstName.placeholder"),
                                    error: fieldState.invalid,
                                    inputMode: "text",
                                    autoCorrect: "off",
                                    autoCapitalize: "none"
                                })
                            })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                        name: "patientLastName",
                        control: control,
                        rules: {
                            required: format("global.form.field.requiredError")
                        },
                        render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $5RTr6.FormField), {
                                title: format("inviteYourPt.form.patientSection.lastName.title"),
                                errorMessage: fieldState.error?.message,
                                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                    ...field,
                                    placeholder: format("inviteYourPt.form.patientSection.lastName.placeholder"),
                                    error: fieldState.invalid,
                                    inputMode: "text",
                                    autoCorrect: "off",
                                    autoCapitalize: "none"
                                })
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                name: "shareDataConsent",
                control: control,
                rules: {
                    required: format("inviteYourPt.form.patientSection.consentCheckbox.requiredError")
                },
                render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $5RTr6.FormField), {
                        errorMessage: fieldState.error?.message,
                        children: /*#__PURE__*/ (0, $iKObn.jsxs)($88480e12bca23281$var$CheckboxContainer, {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)($88480e12bca23281$var$StyledCheckbox, {
                                    inputId: "inviteYourPtShareDataConsent",
                                    ...field,
                                    checked: field.value
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)("label", {
                                    htmlFor: "inviteYourPtShareDataConsent",
                                    children: format("inviteYourPt.form.patientSection.consentCheckbox.label")
                                })
                            ]
                        })
                    })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                className: "p-size-xs-semi-bold",
                children: format("inviteYourPt.form.privacyFooter", {
                    link: {
                        onClick: openPatientPrivacyNotice,
                        className: "text-primary"
                    }
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($88480e12bca23281$var$StyledButton, {
                label: format("inviteYourPt.form.submitButton"),
                type: "submit",
                loading: isSubmitting
            })
        ]
    });
};
const $88480e12bca23281$var$FormContainer = (0, $5UMQ1.default).form`
	display: grid;
	gap: 16px;
`;
const $88480e12bca23281$var$StyledButton = (0, $5UMQ1.default)((0, $jCNJs.RoundedButton))`
	margin-top: 24px;
`;
const $88480e12bca23281$var$CheckboxContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(16, "flexstart", "flexstart")}
	margin-top: 24px;
`;
const $88480e12bca23281$var$StyledCheckbox = (0, $5UMQ1.default)((0, $68IWj.Checkbox))`
	margin-top: 0.125rem;
`;
const $88480e12bca23281$var$TwoColumnLayout = (0, $5UMQ1.default).div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 24px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		grid-template-columns: unset;
	}
`;
const $88480e12bca23281$var$Separator = (0, $5UMQ1.default).div`
	height: 2px;
	background-color: ${(0, $kKnoQ.colors).grey10};
	margin: 24px 0;
`;



var $6uwo0 = parcelRequire("6uwo0");

var $4Mcub = parcelRequire("4Mcub");

var $itAai = parcelRequire("itAai");

var $7a0sk = parcelRequire("7a0sk");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $81g6h = parcelRequire("81g6h");

var $ghfIB = parcelRequire("ghfIB");
const $c8a3bad677643819$export$2f747e1d422b5111 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { locale: queryLocale } = (0, $8zvzh.useQueryParams)();
    const locale = (0, $81g6h.useMemo)(()=>queryLocale ? (0, $ghfIB.localeManager).resolveLocale(queryLocale) : (0, $ghfIB.localeManager).resolveLocaleFromNavigator(), [
        queryLocale
    ]);
    const { config: config, configError: configError, configLoading: configLoading } = (0, $6uwo0.useProspectRequestLoading)(locale);
    const [isFormSent, setFormSent] = (0, $81g6h.useState)(false);
    const { countryConfig: countryConfig } = (0, $1acTy.useCountryConfig)();
    (0, $81g6h.useEffect)(()=>{
        (0, $ghfIB.localeManager).changeLocale(locale);
    }, [
        locale
    ]);
    const navigateToWebsite = (0, $81g6h.useCallback)(()=>{
        window.open(countryConfig?.landingPages.patient, "_self");
    }, [
        countryConfig?.landingPages.patient
    ]);
    let formContent;
    if (configLoading) formContent = /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {});
    else if (configError || (0, $lTdpc.isNil)(config)) /* TODO: MAR-1614 Change 404 to a more suitable error */ formContent = /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.Error404), {});
    else formContent = /*#__PURE__*/ (0, $iKObn.jsx)((0, $88480e12bca23281$export$c7384d2c2163ec5c), {
        config: config,
        onSuccess: ()=>setFormSent(true)
    });
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $itAai.ProspectPage), {
        backgroundColor: (0, $kKnoQ.colors).mobilePrimaryBlue,
        children: !isFormSent ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $4Mcub.ProspectFormContainer), {
            title: format("inviteYourPt.form.title", {
                color: (0, $kKnoQ.colors).mobilePrimaryBlue
            }),
            description: format("inviteYourPt.form.description"),
            children: /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                children: formContent
            })
        }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $7a0sk.ProspectSuccessMessage), {
            title: format("inviteYourPt.confirmMessage.title"),
            description: format("inviteYourPt.confirmMessage.description"),
            buttonLabel: format("inviteYourPt.confirmMessage.backButton"),
            onButtonClick: navigateToWebsite
        })
    });
};



var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $8zvzh = parcelRequire("8zvzh");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $28f8Y = parcelRequire("28f8Y");

var $1IlhR = parcelRequire("1IlhR");

var $lDZlX = parcelRequire("lDZlX");


var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5kXMA = parcelRequire("5kXMA");

var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $5UMQ1 = parcelRequire("5UMQ1");

var $GDBjl = parcelRequire("GDBjl");

var $lDZlX = parcelRequire("lDZlX");


var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
const $de15b70f06812adb$export$fb38c322ea1b96a = ({ addSeparator: addSeparator, active: active, label: label })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            addSeparator && /*#__PURE__*/ (0, $iKObn.jsx)($de15b70f06812adb$var$StepSeparator, {
                active: active
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($de15b70f06812adb$var$StepContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($de15b70f06812adb$var$Dot, {
                        active: active
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($de15b70f06812adb$var$Label, {
                        className: "p-size-xs-semi-bold",
                        active: active,
                        children: label
                    })
                ]
            })
        ]
    });
const $de15b70f06812adb$var$StepSeparator = (0, $5UMQ1.default).div`
	background-color: ${({ active: active })=>active ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).grey25};
	height: 2px;
	width: 100%;
	max-width: 320px;
`;
const $de15b70f06812adb$var$StepContainer = (0, $5UMQ1.default).div`
	position: relative;
`;
const $de15b70f06812adb$var$Label = (0, $5UMQ1.default).div`
	position: absolute;
	text-align: center;
	left: 50%;
	transform: translateX(-50%);
	white-space: nowrap;
	color: ${({ active: active })=>active ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).grey80};
`;
const $de15b70f06812adb$var$Dot = (0, $5UMQ1.default).div`
	height: 8px;
	width: 8px;
	border-radius: 100%;
	background-color: ${({ active: active })=>active ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).grey};
`;



var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");
parcelRequire("81g6h");

var $8miOT = parcelRequire("8miOT");
const $ce1c88dbec399c9b$export$93bd66f1c8889010 = ({ step: currentStep })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    const navigateToLogin = async ()=>{
        navigate((0, $lDZlX.RoutesPath).Login);
    };
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($ce1c88dbec399c9b$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($ce1c88dbec399c9b$var$StyledAppLogo, {
                        height: 32,
                        width: 125,
                        onClick: ()=>navigateToLogin()
                    }),
                    (0, $lTdpc.isNotNil)(currentStep) && /*#__PURE__*/ (0, $iKObn.jsx)($ce1c88dbec399c9b$var$StepsContainer, {
                        children: (0, $0fc3fe377bd96867$export$a422db565b6d727a).map((step, stepIndex)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $de15b70f06812adb$export$fb38c322ea1b96a), {
                                addSeparator: stepIndex > 0,
                                active: step.step <= currentStep,
                                label: format(step.label)
                            }, step.step))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($ce1c88dbec399c9b$var$SubnavigationContainer, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $8miOT.ContactSupport), {
                    uiStyle: "secondary"
                })
            })
        ]
    });
};
const $ce1c88dbec399c9b$var$SubnavigationContainer = (0, $5UMQ1.default).div`
	position: absolute;
	top: 0px;
	right: 0px;
	margin-top: 110px;
	margin-right: 65px;
`;
const $ce1c88dbec399c9b$var$StyledAppLogo = (0, $5UMQ1.default)((0, $GDBjl.AppLogo))`
	cursor: pointer;
`;
const $ce1c88dbec399c9b$var$StepsContainer = (0, $5UMQ1.default).div`
	display: flex;
	gap: 4px;
	place-items: center;
	place-content: center;
	width: 100%;
	padding-left: 5rem;
`;
const $ce1c88dbec399c9b$var$Container = (0, $5UMQ1.default).div`
	height: 80px;
	border-bottom: 1px solid ${(0, $kKnoQ.colors).primary25};
	background-color: ${(0, $kKnoQ.colors).white};
	display: grid;
	grid-template-columns: 128px 1fr 128px;
	place-items: center;
	padding-left: 40px;
	padding-right: 40px;
`;



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $5UMQ1 = parcelRequire("5UMQ1");

var $lDZlX = parcelRequire("lDZlX");


var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");
parcelRequire("81g6h");

var $GDBjl = parcelRequire("GDBjl");
const $d4d2491f4bab2e6b$export$f293b0322d19955f = ({ step: currentStep })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const currentStepLabel = (0, $0fc3fe377bd96867$export$a422db565b6d727a).find((step)=>step.step === currentStep)?.label;
    const navigate = (0, $htiSH.useNavigate)();
    const navigateToLogin = async ()=>{
        navigate((0, $lDZlX.RoutesPath).Login);
    };
    return /*#__PURE__*/ (0, $iKObn.jsxs)($d4d2491f4bab2e6b$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($d4d2491f4bab2e6b$var$StyledAppLogo, {
                height: 25,
                width: 96,
                onClick: ()=>navigateToLogin()
            }),
            (0, $lTdpc.isNotNil)(currentStep) && /*#__PURE__*/ (0, $iKObn.jsxs)($d4d2491f4bab2e6b$var$StepsContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($d4d2491f4bab2e6b$var$DotsContainer, {
                        children: (0, $0fc3fe377bd96867$export$a422db565b6d727a).map((step)=>/*#__PURE__*/ (0, $iKObn.jsx)($d4d2491f4bab2e6b$var$Dot, {
                                active: step.step <= currentStep
                            }, step.step))
                    }),
                    (0, $lTdpc.isNotNil)(currentStepLabel) && /*#__PURE__*/ (0, $iKObn.jsx)($d4d2491f4bab2e6b$var$Label, {
                        className: "p-size-xs-semi-bold",
                        children: format(currentStepLabel)
                    })
                ]
            })
        ]
    });
};
const $d4d2491f4bab2e6b$var$Container = (0, $5UMQ1.default).div`
	height: 80px;
	border-bottom: 1px solid ${(0, $kKnoQ.colors).primary25};
	display: flex;
	justify-content: center;
	align-items: center;
`;
const $d4d2491f4bab2e6b$var$StyledAppLogo = (0, $5UMQ1.default)((0, $GDBjl.AppLogo))`
	cursor: pointer;
	position: absolute;
	left: 10px;
	top: 20px;
`;
const $d4d2491f4bab2e6b$var$StepsContainer = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;
const $d4d2491f4bab2e6b$var$DotsContainer = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: row;
	gap: 8px;
`;
const $d4d2491f4bab2e6b$var$Dot = (0, $5UMQ1.default).div`
	height: 8px;
	width: 8px;
	border-radius: 100%;
	background-color: ${({ active: active })=>active ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).grey25};
`;
const $d4d2491f4bab2e6b$var$Label = (0, $5UMQ1.default).div`
	white-space: nowrap;
	margin-top: 8px;
	color: ${(0, $kKnoQ.colors).primary};
`;


parcelRequire("81g6h");
var $0fc3fe377bd96867$export$6328d0aeff8e1740;
(function(ProfessionalInformationValidationSteps) {
    ProfessionalInformationValidationSteps[ProfessionalInformationValidationSteps["INTRODUCTION"] = 0] = "INTRODUCTION";
    ProfessionalInformationValidationSteps[ProfessionalInformationValidationSteps["PROFESSIONAL_INFORMATION"] = 1] = "PROFESSIONAL_INFORMATION";
    ProfessionalInformationValidationSteps[ProfessionalInformationValidationSteps["IDENTITY_VERIFICATION"] = 2] = "IDENTITY_VERIFICATION";
    ProfessionalInformationValidationSteps[ProfessionalInformationValidationSteps["DONE"] = 3] = "DONE";
})($0fc3fe377bd96867$export$6328d0aeff8e1740 || ($0fc3fe377bd96867$export$6328d0aeff8e1740 = {}));
const $0fc3fe377bd96867$export$a422db565b6d727a = [
    {
        step: 0,
        label: "register.progressionBar.introduction"
    },
    {
        step: 1,
        label: "register.progressionBar.professionalInfo"
    },
    {
        step: 2,
        label: "register.progressionBar.identityVerification"
    },
    {
        step: 3,
        label: "register.progressionBar.done"
    }
];
const $0fc3fe377bd96867$export$a2948c2a1e8ac11d = ({ step: step })=>{
    const { responsiveDeviceType: responsiveDeviceType } = (0, $5kXMA.useDimensions)();
    return /*#__PURE__*/ (0, $iKObn.jsx)($0fc3fe377bd96867$var$Container, {
        children: responsiveDeviceType === (0, $5kXMA.ResponsiveDeviceType).Desktop ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $ce1c88dbec399c9b$export$93bd66f1c8889010), {
            step: step
        }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $d4d2491f4bab2e6b$export$f293b0322d19955f), {
            step: step
        })
    });
};
const $0fc3fe377bd96867$var$Container = (0, $5UMQ1.default).div`
	position: sticky;
	top: 0;
	left: 0;
	right: 0;
	z-index: 2;
	background-color: white;
`;



var $5WGN2 = parcelRequire("5WGN2");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
const $7acd07ced8efc546$export$d5c3019acf93eae0 = ()=>{
    const { format: format, locale: uiLocale } = (0, $1eHG3.useI18n)();
    const { locale: queryLocale } = (0, $8zvzh.useQueryParams)();
    const locale = queryLocale ?? uiLocale;
    const fetchPrivacyNotice = (0, $81g6h.useCallback)(()=>(0, $ghfIB.legalContentManager).retrievePrivacyNotice(locale), [
        locale
    ]);
    const [operation, isLoading, isError] = (0, $grmoS.useAsyncOperation)(fetchPrivacyNotice, {});
    const privacyNotice = (0, $1IWnK.useObservable)((0, $ghfIB.legalContentManager).privacyNotice);
    (0, $81g6h.useEffect)(()=>{
        operation();
    }, [
        operation
    ]);
    let content;
    if (privacyNotice) content = /*#__PURE__*/ (0, $iKObn.jsx)((0, $d0520af42d86d748$export$c749023b2d124212), {
        title: format("legalContent.privacyNotice.title"),
        content: privacyNotice.content,
        headerLink: {
            label: format("legalContent.privacyNotice.switchLabel"),
            to: `${(0, $lDZlX.RoutesPath).RegisterTermsOfUse}?locale=${encodeURIComponent(locale)}`
        }
    });
    else if (isLoading) content = /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {});
    else content = isError ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
        onRefresh: operation
    }) : null;
    return /*#__PURE__*/ (0, $iKObn.jsxs)($7acd07ced8efc546$var$Page, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $0fc3fe377bd96867$export$a2948c2a1e8ac11d), {}),
            /*#__PURE__*/ (0, $iKObn.jsx)($7acd07ced8efc546$var$Container, {
                children: content
            })
        ]
    });
};
const $7acd07ced8efc546$var$Page = (0, $5UMQ1.default).div`
	min-height: 100vh;
	${(0, $5WGN2.stack)(undefined, undefined, "stretch")};
`;
const $7acd07ced8efc546$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "stretch")};
	flex-grow: 1;
	height: 100%;
`;



var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $8zvzh = parcelRequire("8zvzh");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $28f8Y = parcelRequire("28f8Y");

var $1IlhR = parcelRequire("1IlhR");

var $lDZlX = parcelRequire("lDZlX");



var $5WGN2 = parcelRequire("5WGN2");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
const $380d700d6082ba30$export$dd4488968b03c830 = ()=>{
    const { format: format, locale: uiLocale } = (0, $1eHG3.useI18n)();
    const { locale: queryLocale } = (0, $8zvzh.useQueryParams)();
    const locale = queryLocale ?? uiLocale;
    const retrieveTermsOfUse = (0, $81g6h.useCallback)(()=>(0, $ghfIB.legalContentManager).retrieveTermsOfUse(locale), [
        locale
    ]);
    const [operation, isLoading, isError] = (0, $grmoS.useAsyncOperation)(retrieveTermsOfUse, {});
    const termsOfUse = (0, $1IWnK.useObservable)((0, $ghfIB.legalContentManager).termsOfUse);
    (0, $81g6h.useEffect)(()=>{
        operation();
    }, [
        operation
    ]);
    let content;
    if (termsOfUse) content = /*#__PURE__*/ (0, $iKObn.jsx)((0, $d0520af42d86d748$export$c749023b2d124212), {
        title: format("legalContent.termsOfUse.title"),
        content: termsOfUse.content,
        headerLink: {
            label: format("legalContent.termsOfUse.switchLabel"),
            to: `${(0, $lDZlX.RoutesPath).RegisterPrivacyNotice}?locale=${encodeURIComponent(locale)}`
        }
    });
    else if (isLoading) content = /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {});
    else content = isError ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
        onRefresh: operation
    }) : null;
    return /*#__PURE__*/ (0, $iKObn.jsxs)($380d700d6082ba30$var$Page, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $0fc3fe377bd96867$export$a2948c2a1e8ac11d), {}),
            /*#__PURE__*/ (0, $iKObn.jsx)($380d700d6082ba30$var$Container, {
                children: content
            })
        ]
    });
};
const $380d700d6082ba30$var$Page = (0, $5UMQ1.default).div`
	min-height: 100vh;
	${(0, $5WGN2.stack)(undefined, undefined, "stretch")};
`;
const $380d700d6082ba30$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "stretch")};
	flex-grow: 1;
	height: 100%;
`;



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $5UMQ1 = parcelRequire("5UMQ1");

var $GDBjl = parcelRequire("GDBjl");

var $dhb7H = parcelRequire("dhb7H");

var $6nO8b = parcelRequire("6nO8b");

var $1acTy = parcelRequire("1acTy");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");
parcelRequire("81g6h");
var $227b3242735de48c$var$RejectedSvg = function RejectedSvg(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M76.515 13.485 13.582 76.417c-7.447 7.447-7.447 19.522 0 26.969l62.933 62.933c7.447 7.447 19.521 7.447 26.969 0l62.932-62.933c7.447-7.447 7.448-19.522 0-26.969l-62.932-62.933c-7.447-7.447-19.522-7.447-26.97 0Z",
                fill: "#F2E9FF"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_4145_74695",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "7",
                width: "165",
                height: "165",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M76.515 13.485 13.582 76.417c-7.447 7.447-7.447 19.522 0 26.969l62.933 62.933c7.447 7.447 19.521 7.447 26.969 0l62.932-62.933c7.447-7.447 7.448-19.522 0-26.969l-62.932-62.933c-7.447-7.447-19.522-7.447-26.97 0Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_4145_74695)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "m23.719 156.117 30.84-38.93a28.205 28.205 0 0 1 24.61-14.44l43.99.62c9.05.13 16.66 6.82 17.94 15.77l9.68 67.43-47.99 9.36-79.07-39.82v.01Z",
                        fill: "#0BDEF3"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask1_4145_74695",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "81",
                        y: "52",
                        width: "47",
                        height: "69",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M81.688 102.817a6.536 6.536 0 0 0 6.45-6.54v-42.95l23.379-.54c8.31-.19 14.56 7.58 12.53 15.64-.04.16 1.901 3.02 3.521 5.37.96 1.39.06 3.29-1.62 3.44l-.701.06 2.04 11.11c.71 3.85-2.26 7.4-6.17 7.4h-4.019v17.82c0 5.47-6.14 8.69-10.64 5.57l-24.77-16.38Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask1_4145_74695)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M131.046 123.296c17.615-13.341 21.088-38.425 7.756-56.027-13.331-17.602-38.418-21.055-56.032-7.714-17.615 13.342-21.088 38.426-7.757 56.027 13.332 17.602 38.419 21.056 56.033 7.714Z",
                                fill: "#50F"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M85.687 112.747c14.21 12.24 35.61 11.63 48.91-1.63 6.07-6.06 9.33-13.82 9.76-21.74.5-9.03-2.9-18.13-9.65-25.16-2.68-2.79-5.67-5.14-8.88-6.93-12.86-7.14-29.48-5.62-40.87 4.91-4.5 4.19-8.21 9.41-9.81 15.12-1.61 5.76-.75 11.53.54 17.23.99 4.38 2.22 8.71 4.79 12.55 1.42 2.12 3.24 3.95 5.21 5.65Z",
                                fill: "#4427FA"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M85.86 112.117c16.33 12.33 39.58 11.51 54.66-2.41 6.66-6.15 10.44-14.12 11.28-22.43.96-9.48-2.5-19.12-9.13-26.93-2.87-3.38-6.06-6.4-9.56-8.79-13.98-9.47-33.33-9.44-47.34 1.54-5.51 4.32-11.03 10.14-13.07 16.84-2.13 7 .24 13.65 1.77 20.45 1.19 5.29 1.8 10.66 4.85 15.3 1.69 2.57 4.08 4.58 6.54 6.44v-.01Z",
                                fill: "#334EF5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M99.95 100.767c13.71 8.57 31.96 7.6 44.53-2.67 5.25-4.29 8.53-9.92 9.63-16.06 1.25-7-1.09-14.31-5.48-20.53-2.18-3.09-4.61-6.01-7.36-8.41-10.91-9.51-27.57-11.39-40.53-3.42-5.04 3.1-11.19 7.82-13.15 13.64-2.15 6.37 1.49 12.02 2.83 18.09 1.06 4.78.67 9.78 3.35 13.97 1.49 2.34 3.85 3.93 6.18 5.39Z",
                                fill: "#2275F0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M106.469 90.497c10.92 5.03 24.26 3.63 34.4-2.92 3.8-2.45 6.62-5.73 7.98-9.69 1.54-4.52.45-9.63-1.82-14.14-1.45-2.86-3.16-5.6-5.16-8.03-7.85-9.51-21.8-13.32-33.72-8.38-4.56 1.89-11.36 5.49-13.23 10.45-2.17 5.74 2.73 10.39 3.89 15.72.93 4.26-.46 8.89 1.85 12.64 1.3 2.11 3.6 3.32 5.81 4.34v.01Z",
                                fill: "#119CEB"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M113.917 72.837c.6 2.83-1.2 6.05.27 8.54.84 1.42 2.51 2.11 4.11 2.48 6.08 1.4 12.38-.51 18.33-2.4 1.73-.55 3.56-1.16 4.78-2.51 1.39-1.54 1.73-3.8 1.38-5.84-.35-2.04-1.3-3.92-2.23-5.77-3.64-7.17-12.1-11.48-20.32-10.07-3.08.53-8.72 2.39-10.05 5.48-1.66 3.85 3 6.62 3.74 10.08l-.01.01Z",
                                fill: "#00C3E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M122.88 54.767v-.22c-.19-5.54-5.29-9.58-10.72-8.48l-17.05 3.46c-10.65-.28-18.03 10.56-13.86 20.37l6.67 15.72.23.53v-15.41c0-2.18 1.71-3.97 3.89-4.07a4.07 4.07 0 0 1 4.24 3.83c.06 1.09.99 1.93 2.08 1.88l.73-.03c.94-.04 1.8-.56 2.27-1.38l2.5-4.4a6.991 6.991 0 0 0 .18-6.56c-1.01-2.02.46-4.4 2.72-4.4h6.67l4.93 2.22c2.18.98 4.62-.67 4.53-3.06h-.01Z",
                        fill: "#33009A"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "m127.49 190.047-115.72-10.52 13.64-47.8a18.603 18.603 0 0 1 13.86-13.31l4.04-.92c2.35-.54 4.54-1.51 6.51-2.91l3.38-2.28c.17-.12.45-.3.77-.5l.34-.23c.19-.13.38-.29.57-.49.07-.08.13-.17.19-.26l.02-1.82c.03-2.42-.46-4.77-1.45-6.98l-2.66-5.93c-.44-.97-.85-1.87-1.23-2.75-1.56-3.96-2.47-6.89-2.78-9.02-.06-.26-.11-.52-.16-.78-1.98.11-3.97-.18-5.83-.84-3.78-1.35-6.81-4.13-8.54-7.82-1.83-3.89-2.01-8.3-.51-12.42 3.01-8.28 11.97-12.69 19.96-9.83 3.03 1.08 5.58 3.09 7.36 5.74 5.06-2.07 11.5-2.87 19.2-2.38 1.69.11 3.35.43 4.96.95 7.79 1.12 14.06 7.02 15.62 14.75.92 4.53.09 9.27-2.26 13.24l2.31 3.18c.73 1.01.87 2.34.35 3.47-.52 1.13-1.6 1.9-2.84 2.01l-1.01.09-1.79 9.25a5.761 5.761 0 0 1-6.09 4.64l-5.24-.4-.37 6.76.9.64c.52.37 1.13.74 1.84 1.13 1.5.82 3.07 1.42 4.67 1.78l2.41.46c6.96 1.34 12.74 6.33 15.07 13.03l20.53 59.06-.02.01Zm-109.4-14.86 102.28 9.3-18.04-51.89a15.072 15.072 0 0 0-11.37-9.83l-2.49-.48c-2.11-.48-4.11-1.24-6-2.27-.88-.48-1.64-.95-2.33-1.44l-3.11-2.21.79-14.44 10.23.78c.45.04.83-.27.91-.69l2.49-12.87 2.17-.19-1-1.37c-.38-.52-.71-1.12-.99-1.83l-.5-1.25.78-1.09c2.25-3.15 3.07-6.97 2.31-10.74a13.752 13.752 0 0 0-11.7-10.9l-.47-.11c-1.27-.43-2.58-.69-3.92-.78-7.93-.5-14.25.45-18.77 2.83l-2.27 1.2-1.08-2.33c-1.17-2.53-3.23-4.42-5.78-5.34-5.46-1.95-11.62 1.13-13.71 6.89-1.05 2.89-.93 5.97.34 8.67 1.17 2.5 3.22 4.38 5.76 5.29 1.81.65 3.78.75 5.71.31l2.71-.63.28 2.76c.1 1.04.25 1.95.44 2.78l.04.21c.17 1.19.74 3.53 2.48 7.94.34.78.74 1.66 1.15 2.58l2.67 5.97c.83 1.85 1.39 3.84 1.67 5.85l.97-.27-.11 3.49c-.04 1.48-.52 2.96-1.4 4.26-.25.38-.5.73-.79 1.05-.45.48-.93.89-1.43 1.22l-.41.28c-.28.18-.48.31-.63.41l-3.38 2.28a22.892 22.892 0 0 1-8.21 3.66l-4.04.92a13.715 13.715 0 0 0-10.23 9.85l-12.03 42.16.01.01Z",
                        fill: "#F2E9FF"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M58.354 72.719c2.926-6.888-.042-14.74-6.63-17.54-6.587-2.798-14.3.516-17.226 7.404-2.926 6.887.041 14.74 6.63 17.539 6.587 2.799 14.3-.516 17.226-7.403ZM80.728 91.617c8.958 0 16.22-7.262 16.22-16.22 0-8.958-7.262-16.22-16.22-16.22-8.958 0-16.22 7.262-16.22 16.22 0 8.958 7.262 16.22 16.22 16.22Z",
                        fill: "#33009A"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "m123.93 187.267-19.29-55.48a17.488 17.488 0 0 0-13.22-11.43l-2.49-.48a20.73 20.73 0 0 1-7.38-3.3l-2.24-1.59c-1.41-1-3.11-1.54-4.84-1.54l-12.33-2.56c-1.73 0-6.17 2.44-7.58 3.45l-3.33 2.25c-2.22 1.58-4.73 2.7-7.38 3.3l-4.04.92a16.205 16.205 0 0 0-12.05 11.6l-12.83 44.96",
                        fill: "#0BDEF3"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M78.11 161.447c.53-.42 7.18 15.88 7.67 15.39l6.16-4.34-3.14-29.99-7.99-21.76-24.2-4.88 21.51 45.58h-.01Z",
                        fill: "#4427FA"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "m76.378 118.457-2.62-5.02h.71c1.73 0 3.43.54 4.84 1.54l2.24 1.59c.67.47 1.37.89 2.09 1.28l5.36 8.09c1.1 1.67.82 3.89-.66 5.23l-2.54 2.3 4.29 3.73a7.087 7.087 0 0 1 2.43 5.75l-.25 4.49.93 24.09-2.09 2-14.75-55.09.02.02Z",
                        fill: "#33009A"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask2_4145_74695",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "49",
                        y: "59",
                        width: "49",
                        height: "70",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M50.1 83.767v-.09c-.3-1.27-.51-2.59-.58-3.94-.81-14.69 9.69-21.81 28.83-20.56 7.56.49 14.54 7.21 15.32 14.74.27 2.63.22 5.19-.15 7.6-.25 1.63.13 3.29 1.1 4.62l2.48 3.41c.46.64.05 1.54-.73 1.61l-2.85.25-2.21 10.09a4.527 4.527 0 0 1-4.63 3.39l-6.54-.35-1.11 20.34c-.17 3.18-3.82 4.88-6.37 2.98l-18.11-13.53 1.11-.74a5.667 5.667 0 0 0 2.53-4.57l.12-4.38s-7.32-14.61-8.21-20.88v.01Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask2_4145_74695)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M98.968 132.649c19.38-14.678 23.2-42.278 8.532-61.645-14.669-19.367-42.27-23.168-61.651-8.49-19.38 14.68-23.2 42.279-8.532 61.646 14.669 19.367 42.27 23.168 61.651 8.489Z",
                                fill: "#50F"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M49.07 121.037c15.63 13.46 39.18 12.8 53.81-1.79 6.68-6.67 10.26-15.21 10.74-23.92.55-9.94-3.19-19.95-10.62-27.68-2.95-3.07-6.23-5.65-9.77-7.62-14.15-7.85-32.43-6.19-44.97 5.4-4.95 4.61-9.04 10.35-10.79 16.64-1.77 6.34-.83 12.69.59 18.95 1.09 4.82 2.44 9.59 5.27 13.81 1.56 2.33 3.57 4.35 5.74 6.22v-.01Z",
                                fill: "#4427FA"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M49.259 120.347c17.97 13.57 43.55 12.67 60.14-2.65 7.32-6.77 11.49-15.53 12.41-24.68 1.05-10.43-2.75-21.03-10.05-29.63-3.16-3.72-6.67-7.05-10.52-9.68-15.39-10.42-36.67-10.38-52.08 1.7-6.06 4.75-12.14 11.16-14.38 18.52-2.35 7.7.27 15.02 1.95 22.5 1.31 5.82 1.98 11.73 5.34 16.83 1.86 2.83 4.49 5.04 7.2 7.08l-.01.01Z",
                                fill: "#334EF5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M64.758 107.857c15.08 9.43 35.16 8.36 48.99-2.93 5.77-4.71 9.39-10.92 10.6-17.67 1.38-7.7-1.2-15.74-6.03-22.59-2.4-3.4-5.07-6.61-8.1-9.25-12-10.46-30.34-12.53-44.59-3.76-5.55 3.41-12.32 8.6-14.47 15.01-2.36 7.01 1.64 13.23 3.12 19.9 1.16 5.26.74 10.76 3.69 15.37 1.64 2.58 4.24 4.33 6.8 5.93l-.01-.01Z",
                                fill: "#2275F0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M71.991 96.387c12.01 5.53 26.69 3.99 37.85-3.21 4.18-2.7 7.29-6.3 8.78-10.66 1.7-4.97.5-10.59-2.01-15.55-1.59-3.15-3.48-6.17-5.68-8.83-8.64-10.46-23.99-14.66-37.1-9.22-5.02 2.08-12.5 6.04-14.56 11.5-2.38 6.32 3.01 11.43 4.28 17.3 1.02 4.69-.51 9.79 2.04 13.91 1.43 2.32 3.96 3.65 6.4 4.77v-.01Z",
                                fill: "#119CEB"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M80.14 77.127c.66 3.11-1.32 6.65.29 9.4.92 1.56 2.76 2.32 4.53 2.73 6.69 1.54 13.62-.56 20.161-2.64 1.91-.61 3.91-1.27 5.25-2.76 1.53-1.69 1.9-4.18 1.52-6.43-.38-2.25-1.43-4.32-2.46-6.35-4.01-7.89-13.31-12.63-22.35-11.08-3.39.58-9.59 2.63-11.06 6.03-1.83 4.24 3.3 7.28 4.11 11.09l.01.01Z",
                                fill: "#00C3E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M93.623 73.497c-.91-7.84-7.5-13.83-15.38-14.34-19.08-1.22-29.54 5.91-28.73 20.56.08 1.35.28 2.67.58 3.94v.09c.3 2.11 1.33 5.18 2.57 8.31 1.13 2.6 2.5 5.42 3.93 9.02 1 2.14 1.71 3.55 1.71 3.55l-.04 3.42 1.75-.48a13.73 13.73 0 0 0 9.49-10.27l.53-2.45c-.56-.23-1.04-.64-1.36-1.21l-3.29-5.94a3.296 3.296 0 0 1 1.51-4.59c.34-.16.76-.23 1.21-.26 2.55-.13 3.48-3.58 1.29-4.9-.02-.01-.04-.02-.06-.04-.99-.58-1.99-1.25-2.64-1.88 8.81 2.36 11.12-.49 16.18-2.71 4.07-1.79 7.96-.88 10.83 1.21-.03-.34-.06-.69-.1-1.03h.02Z",
                        fill: "#33009A"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M57.531 109.017c.03-2.76-.53-5.49-1.66-8.01-1.02-2.29-2.21-4.94-2.66-5.93-.43-.95-.83-1.84-1.21-2.72-1.47-3.72-2.35-6.57-2.62-8.5-.32-1.37-.52-2.75-.59-4.1-.35-6.33 1.33-11.38 5-15.03 4.95-4.91 13.2-7.03 24.5-6.31 8.36.53 15.11 6.83 16.06 14.98.04.35.08.71.11 1.06l.13 1.59-1.29-.94c-1.78-1.3-5.47-3.17-10.11-1.13-.96.42-1.82.87-2.65 1.3-2.94 1.52-5.55 2.87-10.54 2.18 1.13.83 1.6 2.16 1.26 3.52-.38 1.5-1.59 2.52-3.1 2.59-.4.02-.71.09-.95.19-.66.3-1.14.84-1.37 1.53-.23.69-.16 1.41.19 2.04l3.29 5.94.23.4c1.84 3.16 1.2 7.2-1.58 9.59-2.5 2.14-5.43 4.31-7.74 5l-2.71.74.01.02Zm16.73-49.25c-8.77 0-15.45 2.05-19.45 6.02-3.36 3.34-4.9 8.01-4.57 13.91.07 1.26.26 2.55.56 3.82l.02.18c.25 1.78 1.1 4.52 2.52 8.12.37.85.77 1.74 1.19 2.68.83 1.84 1.78 3.93 2.74 6.34.98 2.08 1.68 3.49 1.69 3.49l.08.16-.03 2.62.82-.22a12.96 12.96 0 0 0 8.96-9.72l.41-1.91c-.49-.31-.89-.73-1.17-1.24l-3.29-5.94c-.54-.98-.65-2.15-.3-3.21a4.017 4.017 0 0 1 2.15-2.4c.4-.18.9-.29 1.48-.32 1.04-.05 1.59-.84 1.76-1.49.17-.66.04-1.54-.81-2.06-1.28-.76-2.22-1.42-2.83-2.01l-2.05-1.97 2.75.74c6.84 1.83 9.54.43 12.97-1.34.85-.44 1.74-.9 2.73-1.34 3.4-1.5 7.05-1.32 10.23.44-1.07-7.21-7.15-12.73-14.63-13.2-1.35-.09-2.66-.13-3.93-.13v-.02ZM80.031 172.037c1.3-.58 2.14.92 3.29 0l-25.79-60.3h-.12c-.43.72-1.02 1.37-1.74 1.85l-.41.27c-.27.17-.51.33-.69.46l-1.85 1.25-.31 12.4a4.053 4.053 0 0 0 3.26 4.07l7.05 1.4-.61.68a7.105 7.105 0 0 0-.72 8.52l18.64 29.41v-.01Z",
                        fill: "#33009A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M148.72 109.278c7.944 0 14.384-6.44 14.384-14.384s-6.44-14.384-14.384-14.384-14.384 6.44-14.384 14.384 6.44 14.384 14.384 14.384Z",
                fill: "#FF0A4B"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M154.819 103.032a2.04 2.04 0 0 1-1.451-.603l-12.183-12.183a2.038 2.038 0 0 1 0-2.887c.799-.799 2.088-.799 2.887 0l12.182 12.183c.8.799.8 2.087 0 2.887a2.106 2.106 0 0 1-1.451.603h.016Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M142.621 103.032a2.037 2.037 0 0 1-1.451-.603 2.038 2.038 0 0 1 0-2.887l12.182-12.183c.799-.799 2.088-.799 2.887 0 .799.8.799 2.088 0 2.887l-12.183 12.183a2.106 2.106 0 0 1-1.451.603h.016Z",
                fill: "#fff"
            })
        ]
    });
};
$227b3242735de48c$var$RejectedSvg.defaultProps = {
    width: "180",
    height: "180",
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
function $227b3242735de48c$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $6nO8b.LoginContainer), {
        form: /*#__PURE__*/ (0, $iKObn.jsx)($227b3242735de48c$var$RejectedPtCard, {})
    });
}
const $227b3242735de48c$var$RejectedPtCard = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { countryConfig: countryConfig } = (0, $1acTy.useCountryConfig)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($227b3242735de48c$var$MainContainer, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($227b3242735de48c$var$StyledAppLogo, {
                height: 42,
                width: 211
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($227b3242735de48c$var$RejectedImg, {
                height: 180,
                width: 180
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($227b3242735de48c$var$Title, {
                children: format("register.rejected-pt.title")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($227b3242735de48c$var$Subtitle, {
                className: "p-size-m",
                children: format("register.rejected-pt.subtitle")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($227b3242735de48c$var$StrechButton, {
                onClick: ()=>{
                    (0, $ghfIB.analyticsService).trackEvent({
                        category: (0, $auPqo.AnalyticsCategory).COMMUNICATION,
                        action: "contactCustomerSupport"
                    });
                    window.open(`mailto:${countryConfig?.customerSupportEmail}`);
                },
                label: format("register.rejected-pt.contact-button")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($227b3242735de48c$var$Logout, {
                className: "p-size-s",
                onClick: ()=>(0, $ghfIB.userManager).logout(),
                children: format("register.rejected-pt.logout")
            })
        ]
    });
};
const $227b3242735de48c$var$MainContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "spacebetween", "center")}
`;
const $227b3242735de48c$var$Title = (0, $5UMQ1.default).h1`
	margin-bottom: 24px;
`;
const $227b3242735de48c$var$StyledAppLogo = (0, $5UMQ1.default)((0, $GDBjl.AppLogo))`
	justify-self: center;
`;
const $227b3242735de48c$var$RejectedImg = (0, $5UMQ1.default)($227b3242735de48c$var$RejectedSvg)`
	justify-self: center;
`;
const $227b3242735de48c$var$Subtitle = (0, $5UMQ1.default).div`
	margin-bottom: 24px;
`;
const $227b3242735de48c$var$StrechButton = (0, $5UMQ1.default)((0, $dhb7H.Button))`
	align-self: stretch;
`;
const $227b3242735de48c$var$Logout = (0, $5UMQ1.default).div`
	margin-top: 12px;
	cursor: pointer;
	text-align: center;
`;




var $iKObn = parcelRequire("iKObn");

var $04Qjn = parcelRequire("04Qjn");

var $1eHG3 = parcelRequire("1eHG3");

var $8zvzh = parcelRequire("8zvzh");

var $8fBuh = parcelRequire("8fBuh");

var $ghfIB = parcelRequire("ghfIB");

var $l2BWr = parcelRequire("l2BWr");

var $5UMQ1 = parcelRequire("5UMQ1");

var $28f8Y = parcelRequire("28f8Y");

var $1IlhR = parcelRequire("1IlhR");

var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $eAmnG = parcelRequire("eAmnG");


var $l2BWr = parcelRequire("l2BWr");

var $iBbjf = parcelRequire("iBbjf");

var $02mFA = parcelRequire("02mFA");

var $243Cr = parcelRequire("243Cr");

var $9XVwj = parcelRequire("9XVwj");

var $lKGAO = parcelRequire("lKGAO");

var $lDZlX = parcelRequire("lDZlX");


var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");

var $ghvAC = parcelRequire("ghvAC");
var $f0c8ad8c619f4665$var$AssignIcon = function AssignIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M10.81 11.54c-1.26 0-2.48-.51-3.37-1.4-.9-.9-1.39-2.1-1.39-3.37s.5-2.47 1.39-3.37C8.33 2.5 9.56 2 10.81 2s2.48.51 3.37 1.4c.89.89 1.39 2.1 1.39 3.37s-.5 2.47-1.39 3.37c-.89.89-2.12 1.4-3.37 1.4Zm0-7.53c-.73 0-1.44.3-1.96.81a2.779 2.779 0 0 0 0 3.92c1.03 1.03 2.88 1.03 3.91 0a2.779 2.779 0 0 0 0-3.92c-.52-.51-1.23-.81-1.96-.81h.01ZM16.94 17.828a.963.963 0 0 1-.668-.273l-2.482-2.482a.936.936 0 1 1 1.326-1.325l1.823 1.824 4.521-4.522a.936.936 0 1 1 1.326 1.325l-5.189 5.19a.923.923 0 0 1-.667.272l.01-.01Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.268 13.965a1 1 0 0 1-.933 1.063c-1.523.099-3.47.511-5.004 1.204-.767.346-1.377.738-1.782 1.149-.396.402-.549.771-.549 1.119V20h12.49a1 1 0 1 1 0 2H4c-1.102 0-2-.898-2-2v-1.5c0-1.017.476-1.863 1.124-2.522.64-.65 1.49-1.166 2.385-1.57 1.79-.807 3.979-1.265 5.696-1.376a1 1 0 0 1 1.063.933Z",
                fill: "currentColor"
            })
        ]
    });
};
$f0c8ad8c619f4665$var$AssignIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $f0c8ad8c619f4665$var$DeleteIcon = function DeleteIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M10.82 2c-.52 0-1.01.2-1.38.57L9.01 3h-5c-.13 0-.26.02-.39.07a1.004 1.004 0 0 0-.55.55c-.05.12-.07.25-.07.39s.02.26.07.39c.05.12.13.23.22.33.1.09.21.17.33.22.13.05.26.07.39.07h16c.13 0 .26-.02.39-.07a1.004 1.004 0 0 0 .55-.55c.05-.12.07-.25.07-.39s-.02-.26-.07-.39a1.19 1.19 0 0 0-.22-.33c-.1-.09-.21-.17-.33-.22-.13-.05-.26-.07-.39-.07h-5l-.43-.43A1.92 1.92 0 0 0 13.2 2h-2.38ZM16.13 22H7.88c-1.5 0-2.78-1.05-2.97-2.447L3.409 8.136a1 1 0 0 1 .991-1.13h15.22a1 1 0 0 1 .991 1.13L19.11 19.534C18.9 20.95 17.62 22 16.13 22ZM5.5 8.88l1.39 10.448c.06.44.5.797.99.797h8.25c.5 0 .93-.356 1-.825l1.39-10.42H5.5Z",
            fill: "currentColor"
        })
    });
};
$f0c8ad8c619f4665$var$DeleteIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $f0c8ad8c619f4665$export$3228eefb2260bf42 = ({ template: template, templateIsLoading: templateIsLoading })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const programContentWithEmptyName = (0, $81g6h.useMemo)(()=>({
            name: template.name ?? "",
            days: template.days
        }), [
        template.days,
        template.name
    ]);
    // if dataIsLoading change it should not reset the content so there is a useEffect to change editable property if viewOnly change
    const programEditor = (0, $81g6h.useMemo)(()=>new (0, $02b6689614593d0d$export$e4ac5f3bb70a008e)((0, $eAmnG.programContentDeepCopy)(programContentWithEmptyName), (0, $ghfIB.onboardingManager), templateIsLoading), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        programContentWithEmptyName
    ]);
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const navigate = (0, $htiSH.useNavigate)();
    const ptStatus = (0, $1IWnK.useObservable)((0, $ghfIB.userStatusManager).ptRegistrationStatus);
    const preSelectedExercises = (0, $1IWnK.useObservable)((0, $ghfIB.libraryFilterManager).selectedExercises);
    const [isQuitBlockingEnabled, setIsQuitBlockingEnabled] = (0, $81g6h.useState)(true);
    const [hasPendingChanges, setHasPendingChanges] = (0, $81g6h.useState)(false);
    const [editedTemplateIsEmpty, setEditedTemplateIsEmpty] = (0, $81g6h.useState)(template.days.isEmpty);
    const defaultName = (0, $81g6h.useMemo)(()=>format("templateBuilder.defaultTitle.v2_1"), [
        format
    ]);
    const navigateToNewTemplate = (0, $81g6h.useCallback)((templateId)=>navigate((0, $lDZlX.RoutesPath).TemplateBuilder, {
            query: {
                templateId: templateId
            },
            state: {
                preSelectedExercises: preSelectedExercises
            }
        }, {
            replace: true
        }), [
        navigate,
        preSelectedExercises
    ]);
    const isPendingUser = (0, $81g6h.useMemo)(()=>ptStatus === (0, $02mFA.RegistrationStatus).PENDING, [
        ptStatus
    ]);
    const [saveTemplate, saveLoading] = (0, $grmoS.useAsyncOperation)(async (editedContent)=>{
        try {
            setIsQuitBlockingEnabled(false);
            let metadata;
            if (!(0, $l2BWr.isTemplate)(template)) {
                metadata = await (0, $ghfIB.templateManager).createTemplate(editedContent);
                await (0, $ghfIB.getStartedManager).tryMarkProgramsStepAsCompleted();
                (0, $iBbjf.sendAnalyticsEventSaveTemplate)(metadata.id);
            } else {
                await (0, $ghfIB.templateManager).updateTemplate(template.id, editedContent);
                (0, $iBbjf.sendAnalyticsEventEditTemplate)(template.id);
            }
            showToast(format("templateBuilder.saveButton.successToast.title"), format("templateBuilder.saveButton.successToast.message.v2_6"), "success");
            if (!(0, $l2BWr.isTemplate)(template) && metadata) navigateToNewTemplate(metadata.id);
        } catch (error) {
            console.error("Failed to save template", error);
            showToast(format("templateBuilder.saveButton.errorToast.title"), format("templateBuilder.saveButton.errorToast.message"));
        } finally{
            setIsQuitBlockingEnabled(true);
        }
    }, {
        deps: [
            format,
            navigateToNewTemplate,
            showToast,
            template
        ]
    });
    const availableActions = (0, $81g6h.useMemo)(()=>{
        if (!(0, $l2BWr.isTemplate)(template)) return [];
        const deleteAction = {
            text: format("templateBuilder.popupMenu.deleteTemplate"),
            icon: /*#__PURE__*/ (0, $iKObn.jsx)($f0c8ad8c619f4665$var$DeleteIcon, {
                width: 24,
                height: 24
            }),
            destructive: true,
            onClick: ()=>{
                dialogContext?.openModal((0, $243Cr.ModalId).DeleteTemplate, {
                    templateId: template.id,
                    templateName: template.name,
                    onSuccess: ()=>{
                        navigate((0, $lDZlX.RoutesPath).ProgramList, {
                            query: {
                                active: (0, $ghvAC.ProgramListTabNames).Templates
                            }
                        });
                        dialogContext.closeAll();
                    }
                });
            }
        };
        return [
            deleteAction
        ];
    }, [
        format,
        template,
        dialogContext,
        navigate
    ]);
    const statusMessage = (0, $81g6h.useMemo)(()=>(0, $l2BWr.isTemplate)(template) ? format("templateBuilder.statusMessage") : format("templateBuilder.statusMessage.newProgram"), [
        format,
        template
    ]);
    const secondaryButtonLabel = (0, $81g6h.useMemo)(()=>(0, $l2BWr.isTemplate)(template) ? format("templateBuilder.saveButton") : format("templateBuilder.saveButton.asTemplate"), [
        format,
        template
    ]);
    const primaryButtonDisabledTooltipMessage = (0, $81g6h.useMemo)(()=>{
        if (isPendingUser) return format("templateBuilder.demoMode.cantAssignTemplate.tooltip");
        if (editedTemplateIsEmpty) return format("templateBuilder.cantAssignTemplateTooltipMessage");
        return format("templateBuilder.cantAssignNotSavedTemplateTooltipMessage");
    }, [
        editedTemplateIsEmpty,
        format,
        isPendingUser
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $lKGAO.TrackingContextProvider), {
        category: (0, $auPqo.AnalyticsCategory).TEMPLATE,
        programId: (0, $l2BWr.isTemplate)(template) ? template.id : "",
        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $665d077530360e17$export$73c8a2ff98437ce), {
            programContent: programContentWithEmptyName,
            programEditor: programEditor,
            statusMessage: statusMessage,
            availableActions: availableActions,
            dataIsLoading: templateIsLoading,
            onProgramContentChanged: (newProgramContent)=>{
                setHasPendingChanges(!(0, $eAmnG.programContentAreEquals)(newProgramContent, programContentWithEmptyName));
                setEditedTemplateIsEmpty(newProgramContent.days.isEmpty);
            },
            secondaryButton: {
                label: secondaryButtonLabel,
                disabled: editedTemplateIsEmpty || !hasPendingChanges,
                disabledTooltipMessage: editedTemplateIsEmpty ? format("templateBuilder.cantSaveEmptyTemplateTooltipMessage") : format("templateBuilder.cantSaveBecauseAlreadySavedTooltipMessage"),
                onClick: (programContent)=>{
                    const newTemplate = {
                        ...template,
                        ...programContent
                    };
                    if (!programContent.name) dialogContext?.openModal((0, $243Cr.ModalId).TemplateName, {
                        template: {
                            ...newTemplate,
                            name: newTemplate.name ?? defaultName
                        },
                        onSubmit: async (name)=>{
                            await saveTemplate({
                                ...programContent,
                                name: name
                            });
                        }
                    });
                    else saveTemplate(programContent);
                },
                loading: saveLoading
            },
            primaryButton: {
                label: format("templateBuilder.assignButton"),
                icon: /*#__PURE__*/ (0, $iKObn.jsx)($f0c8ad8c619f4665$var$AssignIcon, {
                    className: "p-button-icon-right",
                    width: 20,
                    height: 20
                }),
                disabled: editedTemplateIsEmpty,
                disabledTooltipMessage: primaryButtonDisabledTooltipMessage,
                onClick: (programContent)=>{
                    const newTemplate = {
                        ...template,
                        ...programContent
                    };
                    setIsQuitBlockingEnabled(false);
                    dialogContext?.openModal((0, $243Cr.ModalId).AssignTemplate, {
                        template: newTemplate,
                        onCancel: ()=>setIsQuitBlockingEnabled(true)
                    });
                }
            },
            quitBlockingEnabled: isQuitBlockingEnabled
        })
    });
};



var $4x2M3 = parcelRequire("4x2M3");

var $5WGN2 = parcelRequire("5WGN2");

var $81g6h = parcelRequire("81g6h");
const $91406f69ff667336$var$TemplateBuilder = ()=>{
    const { templateId: templateId } = (0, $8zvzh.useQueryParams)();
    const { format: format } = (0, $1eHG3.useI18n)();
    const stateParams = (0, $8fBuh.useStateParams)();
    const { loading: loading, template: template, error: error, refreshTemplate: refreshTemplate } = (0, $4x2M3.useTemplate)(templateId);
    const currentTemplate = (0, $81g6h.useMemo)(()=>templateId ? template : (0, $l2BWr.getEmptyNewTemplate)(), [
        template,
        templateId
    ]);
    (0, $81g6h.useEffect)(()=>{
        (0, $ghfIB.libraryFilterManager).clearAllSelectedExercises();
        (0, $ghfIB.libraryFilterManager).selectExercises(stateParams.preSelectedExercises ?? []);
        return ()=>{
            (0, $ghfIB.libraryFilterManager).clearAllSelectedExercises();
        };
    }, [
        stateParams.preSelectedExercises
    ]);
    if (!currentTemplate) {
        if (loading) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {});
        return /*#__PURE__*/ (0, $iKObn.jsx)($91406f69ff667336$var$Container, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
                description: (0, $04Qjn.isApiError)(error) ? format("templateBuilder.templateNotFoundError") : undefined,
                onRefresh: async ()=>{
                    if (templateId) await refreshTemplate(templateId);
                }
            })
        });
    }
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $f0c8ad8c619f4665$export$3228eefb2260bf42), {
        template: currentTemplate,
        templateIsLoading: loading
    });
};
var $91406f69ff667336$export$2e2bcd8739ae039 = $91406f69ff667336$var$TemplateBuilder;
const $91406f69ff667336$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "stretch")};
	flex-grow: 1;
`;



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $bC9c0 = parcelRequire("bC9c0");

var $5UMQ1 = parcelRequire("5UMQ1");

var $lKlJT = parcelRequire("lKlJT");

var $8CNE2 = parcelRequire("8CNE2");

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $a6fIt = parcelRequire("a6fIt");

var $dhb7H = parcelRequire("dhb7H");

var $lDZlX = parcelRequire("lDZlX");
const $edcceb766a915349$export$50f02f9fd2e16e8e = (props)=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
        ...props,
        "data-test": (0, $a6fIt.e2eTestId).homePage.createProgramButton,
        label: format("templateListing.createProgramButton"),
        onClick: (e)=>{
            props.onClick?.(e);
            navigate((0, $lDZlX.RoutesPath).TemplateBuilder);
        }
    });
};


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
parcelRequire("81g6h");


var $ghvAC = parcelRequire("ghvAC");
const $01719a909aa0348f$export$602f68ad7b8e36ce = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const sendAnalytics = ()=>(0, $bC9c0.sendAnalyticsEventCreateProgram)((0, $bC9c0.AnalyticsProgramLocation).PROGRAM_PAGE);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($01719a909aa0348f$var$StyledPage, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $15ade5a6153d87cc$export$8534dc24c72e73ef), {
                showForPendingPt: false
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $8CNE2.PageHeader), {
                title: format("tabbar.programs"),
                primaryButton: /*#__PURE__*/ (0, $iKObn.jsx)((0, $edcceb766a915349$export$50f02f9fd2e16e8e), {
                    onClick: sendAnalytics
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($01719a909aa0348f$var$Card, {
                className: "p-card",
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $ghvAC.Tabs), {})
            })
        ]
    });
};
const $01719a909aa0348f$var$StyledPage = (0, $5UMQ1.default)((0, $lKlJT.Page))`
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 0;
		max-width: 100%;
	}
`;
const $01719a909aa0348f$var$Card = (0, $5UMQ1.default).div`
	padding: 32px;
	width: 1280px;
	max-width: 100%;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 0;
		flex: 1;
	}
`;



var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $22plg = parcelRequire("22plg");

var $1eHG3 = parcelRequire("1eHG3");

var $giAv5 = parcelRequire("giAv5");

var $lTdpc = parcelRequire("lTdpc");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $jKTFw = parcelRequire("jKTFw");

var $5kXMA = parcelRequire("5kXMA");

var $28f8Y = parcelRequire("28f8Y");

var $8CNE2 = parcelRequire("8CNE2");

var $e0e2T = parcelRequire("e0e2T");

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $1IWnK = parcelRequire("1IWnK");

var $5UMQ1 = parcelRequire("5UMQ1");

var $9gtEr = parcelRequire("9gtEr");

var $3whlY = parcelRequire("3whlY");

var $ghfIB = parcelRequire("ghfIB");
const $f8a2432cef7287d4$var$DUMMY_EXERCISE_COUNT = 99;
const $f8a2432cef7287d4$export$bda05c300d1e8682 = ({ loading: loading })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { filteredExercises: filteredExercises, search: search } = (0, $3whlY.useExercisePage)();
    const exerciseTotalCount = (0, $1IWnK.useObservable)((0, $ghfIB.exerciseManager).exerciseTotalCount);
    const activeFilters = (0, $1IWnK.useObservable)((0, $ghfIB.exerciseFilterManager).activeFilters);
    const isAnyFilterActive = (0, $81g6h.useMemo)(()=>activeFilters.length > 0 || search, [
        activeFilters.length,
        search
    ]);
    const content = (0, $81g6h.useMemo)(()=>{
        if (loading) return format("exerciseListing.exerciseCount", {
            count: $f8a2432cef7287d4$var$DUMMY_EXERCISE_COUNT
        });
        return isAnyFilterActive ? format("exerciseListing.filteredExerciseCounts", {
            filteredCount: filteredExercises.length,
            totalCount: exerciseTotalCount
        }) : format("exerciseListing.exerciseCount", {
            count: exerciseTotalCount
        });
    }, [
        exerciseTotalCount,
        filteredExercises.length,
        format,
        isAnyFilterActive,
        loading
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $9gtEr.ConditionalSkeleton), {
        contentDriven: true,
        active: loading,
        loading: loading,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($f8a2432cef7287d4$var$Container, {
            children: content
        })
    });
};
const $f8a2432cef7287d4$var$Container = (0, $5UMQ1.default).div`
	white-space: nowrap;
`;



var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5WGN2 = parcelRequire("5WGN2");

var $5kXMA = parcelRequire("5kXMA");

var $hLaGu = parcelRequire("hLaGu");

var $68IWj = parcelRequire("68IWj");

var $9P6Oe = parcelRequire("9P6Oe");

var $kKnoQ = parcelRequire("kKnoQ");

var $kVPyX = parcelRequire("kVPyX");

var $9gtEr = parcelRequire("9gtEr");

var $lTdpc = parcelRequire("lTdpc");

var $3whlY = parcelRequire("3whlY");

var $lTdpc = parcelRequire("lTdpc");
const $f9b19c2d9e76ed1d$export$241a8e0b37091f42 = async (canvas, urls)=>{
    if ((0, $lTdpc.isNil)(canvas) || urls.length === 0) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const images = await Promise.all(urls.map((src)=>new Promise((resolve, reject)=>{
            const img = new Image();
            if (src.startsWith("http")) img.crossOrigin = "anonymous";
            img.src = src;
            img.onload = ()=>resolve(img);
            img.onerror = ()=>reject(new Error(`Failed to load image: ${src}`));
        })));
    canvas.width = images.length * images[0].width;
    canvas.height = images[0].height;
    images.forEach((img, index)=>{
        ctx.drawImage(img, index * img.width, 0);
    });
    return canvas.toDataURL();
};


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
const $d959b4937c9bb5fe$export$14c51e3613113aa7 = ({ loading: loading = false, exercise: exercise })=>{
    const { formatExerciseCategory: formatExerciseCategory } = (0, $kVPyX.useExerciseFormatter)();
    const { selectedExercises: selectedExercises, openFilteredExerciseDetailsModal: openFilteredExerciseDetailsModal } = (0, $3whlY.useExercisePage)();
    const { isMobile: isMobile } = (0, $5kXMA.useDimensions)();
    const canvasRef = (0, $81g6h.useRef)(null);
    const [sprite, setSprite] = (0, $81g6h.useState)(null);
    const exer = (0, $81g6h.useMemo)(()=>(0, $lTdpc.isNotNil)(exercise) ? exercise : $d959b4937c9bb5fe$var$DUMMY_EXERCISE, [
        exercise
    ]);
    const isAnimationAvailable = (0, $81g6h.useMemo)(()=>!isMobile && exer.keyframeUrls.length > 1, [
        isMobile,
        exer.keyframeUrls
    ]);
    const ids = (0, $81g6h.useMemo)(()=>({
            animationId: `exercise-card-anim-${exer.id}`,
            animationBackgroundId: `exercise-card-anim-bg-${exer.id}`
        }), [
        exer.id
    ]);
    const isChecked = (0, $81g6h.useMemo)(()=>(0, $lTdpc.isNotNil)(exercise) && selectedExercises.includes(exercise), [
        exercise,
        selectedExercises
    ]);
    (0, $81g6h.useEffect)(()=>{
        (async ()=>{
            if (isAnimationAvailable) {
                const builtSprite = await (0, $f9b19c2d9e76ed1d$export$241a8e0b37091f42)(canvasRef.current, exer.keyframeUrls);
                if ((0, $lTdpc.isNotNil)(builtSprite)) setSprite(builtSprite);
            }
        })();
    }, [
        isAnimationAvailable,
        exer.keyframeUrls
    ]);
    const handleCheckboxClick = (0, $81g6h.useCallback)((selected)=>{
        if ((0, $lTdpc.isNotNil)(exercise)) (0, $ghfIB.exerciseFilterManager).updateSelectedExercise(exercise, selected);
    }, [
        exercise
    ]);
    const handleExerciseClick = (0, $81g6h.useCallback)(async ()=>{
        if (loading) return;
        if ((0, $lTdpc.isNotNil)(exercise)) openFilteredExerciseDetailsModal(exercise);
        await (0, $ghfIB.getStartedManager).tryMarkExercisesStepAsCompleted();
    }, [
        exercise,
        loading,
        openFilteredExerciseDetailsModal
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($d959b4937c9bb5fe$var$ExerciseContainer, {
        loading: loading,
        onClick: async ()=>handleExerciseClick(),
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)((0, $9gtEr.ConditionalSkeleton), {
                active: loading,
                loading: loading,
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($d959b4937c9bb5fe$var$StyledCheckbox, {
                        checked: isChecked,
                        onClick: (event)=>{
                            event.stopPropagation();
                            handleCheckboxClick(!isChecked);
                        }
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($d959b4937c9bb5fe$var$ImgContainer, {
                        isAnimationEnabled: isAnimationAvailable,
                        animationId: ids.animationId,
                        animationBackgroundId: ids.animationBackgroundId,
                        stepCount: exer.keyframeUrls.length,
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($d959b4937c9bb5fe$var$Thumbnail, {
                                src: exer.thumbnails.mediumThumbnailUrl,
                                isLoading: (0, $lTdpc.isNil)(exercise)
                            }),
                            isAnimationAvailable && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($d959b4937c9bb5fe$var$StyledCanvas, {
                                        ref: canvasRef
                                    }),
                                    sprite && /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $iKObn.jsx)($d959b4937c9bb5fe$var$AnimationBackground, {
                                                className: ids.animationBackgroundId
                                            }),
                                            /*#__PURE__*/ (0, $iKObn.jsx)($d959b4937c9bb5fe$var$Animation, {
                                                className: ids.animationId,
                                                sprite: sprite
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($d959b4937c9bb5fe$var$Details, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($d959b4937c9bb5fe$var$Content, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $9gtEr.ConditionalSkeleton), {
                                contentDriven: true,
                                active: loading,
                                loading: loading,
                                children: /*#__PURE__*/ (0, $iKObn.jsx)($d959b4937c9bb5fe$var$Category, {
                                    className: "p-size-s-semi-bold",
                                    children: formatExerciseCategory(exer.category)
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $9gtEr.ConditionalSkeleton), {
                                contentDriven: true,
                                active: loading,
                                loading: loading,
                                children: /*#__PURE__*/ (0, $iKObn.jsx)($d959b4937c9bb5fe$var$Title, {
                                    className: "p-size-s-rubik-medium",
                                    children: exer.title
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($d959b4937c9bb5fe$var$BodyPartIconContainer, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $9gtEr.ConditionalSkeleton), {
                            contentDriven: true,
                            active: loading,
                            loading: loading,
                            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $9P6Oe.BodyPartIcon), {
                                bodyPart: exer.primaryBodyPart,
                                additionalBodyPartsCount: exer.secondaryBodyParts.length,
                                width: 24,
                                height: 24
                            })
                        })
                    })
                ]
            })
        ]
    });
};
const $d959b4937c9bb5fe$var$THUMBNAIL_IMAGE_HEIGHT = 160;
const $d959b4937c9bb5fe$var$ANIMATION_IMAGE_HEIGHT = $d959b4937c9bb5fe$var$THUMBNAIL_IMAGE_HEIGHT;
const $d959b4937c9bb5fe$var$ANIMATION_IMAGE_WIDTH = $d959b4937c9bb5fe$var$ANIMATION_IMAGE_HEIGHT;
const $d959b4937c9bb5fe$var$ANIMATION_DELAY_MS = 500;
const $d959b4937c9bb5fe$var$ANIMATION_FRAME_DURATION_MS = 650;
const $d959b4937c9bb5fe$var$DUMMY_EXERCISE = {
    id: "dummy",
    title: "Title dummy exercise",
    category: (0, $hLaGu.ExerciseCategory).WarmUp,
    primaryBodyPart: (0, $hLaGu.ExerciseBodyPart).UpperLimbs,
    secondaryBodyParts: [],
    thumbnails: {
        mediumThumbnailUrl: undefined
    },
    keyframeUrls: []
};
const $d959b4937c9bb5fe$var$ExerciseContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(4, "flexstart", "stretch")};
	cursor: ${({ loading: loading })=>loading ? "default" : "pointer"};
	position: relative;
	width: 286px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		width: 100%;
	}
`;
const $d959b4937c9bb5fe$var$StyledCheckbox = (0, $5UMQ1.default)((0, $68IWj.Checkbox))`
	position: absolute;
	top: 0;
	left: 0;
	padding: 12px 20px 20px 12px;
	z-index: 1;
`;
const $d959b4937c9bb5fe$var$ImgContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "center", "center")};

	${({ isAnimationEnabled: isAnimationEnabled, animationId: animationId, animationBackgroundId: animationBackgroundId, stepCount: stepCount })=>isAnimationEnabled && `
		&:hover .${animationId} {
			animation: anim-${animationId} ${stepCount * $d959b4937c9bb5fe$var$ANIMATION_FRAME_DURATION_MS}ms steps(${stepCount}) ${$d959b4937c9bb5fe$var$ANIMATION_DELAY_MS}ms infinite;

			@keyframes anim-${animationId} {
				0% {
					visibility: visible;
					background-position: 0 0;
				}
				100% {
					background-position: -${stepCount * $d959b4937c9bb5fe$var$ANIMATION_IMAGE_WIDTH}px 0;
				}
			}
    }
    
    &:hover .${animationBackgroundId} {
      animation: anim-${animationBackgroundId} 1ms ${$d959b4937c9bb5fe$var$ANIMATION_DELAY_MS}ms forwards;
    }

    @keyframes anim-${animationBackgroundId} {
      100% {
        visibility: visible;
      }
    }
	`}
`;
const $d959b4937c9bb5fe$var$StyledCanvas = (0, $5UMQ1.default).canvas`
	display: none;
`;
const $d959b4937c9bb5fe$var$Thumbnail = (0, $5UMQ1.default).img`
	width: 100%;
	height: ${$d959b4937c9bb5fe$var$THUMBNAIL_IMAGE_HEIGHT}px;
	object-fit: cover;
	border-radius: 8px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		${({ isLoading: isLoading })=>!isLoading && `
			height: ${$d959b4937c9bb5fe$var$THUMBNAIL_IMAGE_HEIGHT}px;
		`}
	}
`;
const $d959b4937c9bb5fe$var$Animation = (0, $5UMQ1.default).div`
	visibility: hidden;
	position: absolute;
	width: ${$d959b4937c9bb5fe$var$ANIMATION_IMAGE_WIDTH}px;
	height: ${$d959b4937c9bb5fe$var$ANIMATION_IMAGE_HEIGHT}px;
	background-image: url("${({ sprite: sprite })=>sprite}");
	background-size: auto 100%;
	background-repeat: no-repeat;
`;
const $d959b4937c9bb5fe$var$AnimationBackground = (0, $5UMQ1.default).div`
	visibility: hidden;
	position: absolute;
	width: 100%;
	height: ${$d959b4937c9bb5fe$var$ANIMATION_IMAGE_HEIGHT}px;
	background-color: ${(0, $kKnoQ.colors).primary10};
	border-radius: 8px;
	z-index: 0;
`;
const $d959b4937c9bb5fe$var$Details = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(4, "spacebetween", "stretch")};
`;
const $d959b4937c9bb5fe$var$Category = (0, $5UMQ1.default).p`
	color: ${(0, $kKnoQ.colors).grey80};
`;
const $d959b4937c9bb5fe$var$Title = (0, $5UMQ1.default).div`
	flex: 1;
`;
const $d959b4937c9bb5fe$var$Content = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(4, "flexstart", "stretch")};
`;
const $d959b4937c9bb5fe$var$BodyPartIconContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, "flexstart", "stretch")};
	padding: 7px 6px 0 0;
`;



var $3whlY = parcelRequire("3whlY");

var $3iKWb = parcelRequire("3iKWb");

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");

var $5WGN2 = parcelRequire("5WGN2");

var $5kXMA = parcelRequire("5kXMA");

var $243Cr = parcelRequire("243Cr");

var $hIci4 = parcelRequire("hIci4");

var $3whlY = parcelRequire("3whlY");

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $1IWnK = parcelRequire("1IWnK");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5WGN2 = parcelRequire("5WGN2");

var $ghfIB = parcelRequire("ghfIB");

var $kKnoQ = parcelRequire("kKnoQ");
var $7f49f51551dc262d$var$FilterIcon = function FilterIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.333 5.333a1 1 0 0 1-1 1H4.5a1 1 0 0 1 0-2h5.833a1 1 0 0 1 1 1ZM20.5 5.333a1 1 0 0 1-1 1h-5.833a1 1 0 1 1 0-2H19.5a1 1 0 0 1 1 1ZM13 12a1 1 0 0 1-1 1H4.5a1 1 0 1 1 0-2H12a1 1 0 0 1 1 1ZM20.5 12a1 1 0 0 1-1 1h-4.167a1 1 0 1 1 0-2H19.5a1 1 0 0 1 1 1ZM9.667 18.667a1 1 0 0 1-1 1H4.5a1 1 0 1 1 0-2h4.167a1 1 0 0 1 1 1ZM20.5 18.667a1 1 0 0 1-1 1H12a1 1 0 1 1 0-2h7.5a1 1 0 0 1 1 1Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.333 1.833a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1ZM15.333 8.5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1ZM8.667 15.167a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1Z",
                fill: "currentColor"
            })
        ]
    });
};
$7f49f51551dc262d$var$FilterIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $7f49f51551dc262d$export$fb46dd9777cc6db0 = ({ onClick: onClick, className: className })=>{
    const activeFilters = (0, $1IWnK.useObservable)((0, $ghfIB.exerciseFilterManager).activeFilters);
    return /*#__PURE__*/ (0, $iKObn.jsx)($7f49f51551dc262d$var$StyledButton, {
        selected: activeFilters.length > 0,
        onClick: onClick,
        className: className,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($7f49f51551dc262d$var$FilterIcon, {
            width: 24,
            height: 24
        })
    });
};
const $7f49f51551dc262d$var$StyledButton = (0, $5UMQ1.default).button`
	appearance: none;
	margin: 0;
	padding: 8px;
	border: none;
	position: relative;
	cursor: pointer;
	color: ${({ selected: selected })=>selected ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).grey};
	${(0, $5WGN2.stack)(undefined, "center", "center")};
	border-radius: 8px;
	background-color: ${({ selected: selected })=>selected ? (0, $kKnoQ.colors).primaryBackground : (0, $kKnoQ.colors).transparent};

	:hover {
		background-color: ${(0, $kKnoQ.colors).primaryBackground};
	}
`;


const $29e029b8a3e0445a$export$820e4d34d59f5d7f = ({ className: className })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const { search: search } = (0, $3whlY.useExercisePage)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    const hasMarkedOnboardingRef = (0, $81g6h.useRef)(false);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($29e029b8a3e0445a$var$Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($29e029b8a3e0445a$var$Row, {
                className: "p-input-icon-left p-input-icon-right",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("i", {
                        className: "pi pi-search"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($29e029b8a3e0445a$var$StyledTextInput, {
                        placeholder: format("searchFilter.searchInputPlaceholder"),
                        value: search,
                        onChange: (e)=>{
                            (0, $ghfIB.exerciseFilterManager).searchWord.set(e.target.value);
                            if (!hasMarkedOnboardingRef.current) {
                                hasMarkedOnboardingRef.current = true;
                                (0, $ghfIB.getStartedManager).tryMarkExercisesStepAsCompleted();
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($29e029b8a3e0445a$var$ClearFilterButton, {
                        className: "pi pi-times",
                        displayed: !!search,
                        onClick: ()=>(0, $ghfIB.exerciseFilterManager).searchWord.set("")
                    })
                ]
            }),
            !isDesktop && /*#__PURE__*/ (0, $iKObn.jsx)((0, $7f49f51551dc262d$export$fb46dd9777cc6db0), {
                onClick: ()=>dialogContext?.openModal((0, $243Cr.ModalId).ExerciseFilters)
            })
        ]
    });
};
const $29e029b8a3e0445a$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("XS", "flexstart", "center")}
`;
const $29e029b8a3e0445a$var$Row = (0, $5UMQ1.default).div`
	flex: 1;
`;
const $29e029b8a3e0445a$var$StyledTextInput = (0, $5UMQ1.default)((0, $hIci4.TextInput))`
	width: 100%;
`;
const $29e029b8a3e0445a$var$ClearFilterButton = (0, $5UMQ1.default).i`
	cursor: pointer;
	display: ${({ displayed: displayed })=>displayed ? undefined : "none"};

	:hover {
		color: ${(0, $kKnoQ.colors).primary} !important;
	}
`;



var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $3whlY = parcelRequire("3whlY");
const $c999f59109e5a421$export$549785741f6eedf8 = ({ className: className })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { selectedExercises: selectedExercises } = (0, $3whlY.useExercisePage)();
    return /*#__PURE__*/ (0, $iKObn.jsx)($c999f59109e5a421$var$Container, {
        className: className,
        children: format("exerciseListing.selectedExerciseCount", {
            selectedCount: selectedExercises.length
        })
    });
};
const $c999f59109e5a421$var$Container = (0, $5UMQ1.default).div`
	white-space: nowrap;
`;



var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $5WGN2 = parcelRequire("5WGN2");

var $3whlY = parcelRequire("3whlY");

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $5kXMA = parcelRequire("5kXMA");

var $ghfIB = parcelRequire("ghfIB");

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");
var $8401393172be2483$var$CrossIcon = function CrossIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M6.14 5.302a.836.836 0 0 0-.583 1.435l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26a.834.834 0 0 0 1.377-.263.836.836 0 0 0-.195-.919L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 0 0-.6-.254Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.14 5.015a1.123 1.123 0 0 1 .803.338L12 10.41l5.057-5.057a1.123 1.123 0 1 1 1.588 1.589l-5.057 5.056 5.056 5.056c.107.103.192.226.251.363l-.263.114a.836.836 0 0 0-.189-.272L13.183 12l5.26-5.262a.836.836 0 1 0-1.182-1.182L12 10.816l-5.261-5.26a.836.836 0 1 0-1.182 1.181l5.26 5.261-5.26 5.261a.836.836 0 1 0 1.182 1.182L12 13.181l5.261 5.26c.077.08.17.145.271.189l-.114.263a1.124 1.124 0 0 1-.362-.25L12 13.585l-5.056 5.056a1.123 1.123 0 1 1-1.588-1.588l5.056-5.056-5.057-5.056a1.123 1.123 0 0 1 .785-1.927ZM17.532 18.63a.834.834 0 0 0 1.168-.776.836.836 0 0 0-.068-.323l.263-.114a1.125 1.125 0 0 1-1.477 1.476l.114-.263Z",
                fill: "currentColor"
            })
        ]
    });
};
$8401393172be2483$var$CrossIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $8401393172be2483$export$eceda513ad14fae1 = ({ onClick: onClick, className: className })=>{
    const [isHovered, setIsHovered] = (0, $81g6h.useState)(false);
    return /*#__PURE__*/ (0, $iKObn.jsx)($8401393172be2483$var$Container, {
        className: className,
        onClick: onClick,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        children: /*#__PURE__*/ (0, $iKObn.jsx)($8401393172be2483$var$CrossIcon, {
            width: 16,
            height: 16,
            color: isHovered ? (0, $kKnoQ.colors).white : (0, $kKnoQ.colors).grey80
        })
    });
};
const $8401393172be2483$var$Container = (0, $5UMQ1.default).div`
	display: grid;
	place-items: center;
	cursor: pointer;
	width: 24px;
	height: 24px;
	background-color: var(--primary-10);
	border-top-right-radius: 8px;
	border-bottom-left-radius: 8px;

	&:hover {
		background-color: var(--rejection);
	}
`;



var $3whlY = parcelRequire("3whlY");
const $da14b428419be51e$export$8cb3b16264e6d8d6 = ({ exercise: exercise, className: className })=>{
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const { openSelectedExerciseDetailsModal: openSelectedExerciseDetailsModal } = (0, $3whlY.useExercisePage)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($da14b428419be51e$var$Container, {
        className: className,
        children: [
            isDesktop && /*#__PURE__*/ (0, $iKObn.jsx)($da14b428419be51e$var$StyledCrossButton, {
                onClick: ()=>(0, $ghfIB.exerciseFilterManager).updateSelectedExercise(exercise, false),
                className: "cross-button"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($da14b428419be51e$var$ThumbnailContainer, {
                onClick: ()=>openSelectedExerciseDetailsModal(exercise),
                src: exercise.thumbnails.mediumThumbnailUrl,
                className: "thumbnail"
            })
        ]
    });
};
const $da14b428419be51e$var$Container = (0, $5UMQ1.default).div`
	display: inline-block;
	position: relative;

	.cross-button:hover + .thumbnail {
		border-color: var(--rejection);
	}

	.cross-button:hover + .thumbnail::after {
		opacity: 0.3;
	}
`;
const $da14b428419be51e$var$ThumbnailContainer = (0, $5UMQ1.default).div`
	background-image: url("${({ src: src })=>src}");
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	border: 1px solid var(--primary-10);
	border-radius: 8px;
	height: 64px;
	width: 64px;
	position: relative;
	cursor: pointer;

	&::after {
		content: "";
		position: absolute;
		inset: 0;
		border-radius: 8px;
		background-color: var(--rejection);
		opacity: 0;
	}
`;
const $da14b428419be51e$var$StyledCrossButton = (0, $5UMQ1.default)((0, $8401393172be2483$export$eceda513ad14fae1))`
	position: absolute;
	top: 0;
	right: 0;
	z-index: 10;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		display: none;
	}
`;



var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $jKTFw = parcelRequire("jKTFw");
const $6acf630650be406b$export$5060e9cdfaa120ed = ({ blurWidth: blurWidth, side: side = "both", zIndex: zIndex = 100, className: className, children: children })=>{
    const [hasScrollbar, setHasScrollbar] = (0, $81g6h.useState)(false);
    const [leftBlurWidth, setLeftBlurWidth] = (0, $81g6h.useState)(0);
    const [rightBlurWidth, setRightBlurWidth] = (0, $81g6h.useState)(0);
    const [blurHeight, setBlurHeight] = (0, $81g6h.useState)(0);
    const containerRef = (0, $81g6h.useRef)(null);
    const updateBlurDimensions = (0, $81g6h.useCallback)(()=>{
        if (!containerRef.current) return;
        const { scrollWidth: scrollWidth, clientWidth: clientWidth, clientHeight: clientHeight, scrollLeft: scrollLeft } = containerRef.current;
        const hasScroll = scrollWidth > clientWidth;
        const scrollRemaining = scrollWidth - clientWidth - scrollLeft;
        setHasScrollbar(hasScroll);
        setLeftBlurWidth(Math.min(scrollLeft, blurWidth));
        setRightBlurWidth(Math.min(scrollRemaining, blurWidth));
        setBlurHeight(clientHeight);
    }, [
        blurWidth
    ]);
    (0, $81g6h.useEffect)(()=>{
        const el = containerRef.current;
        if (!el) return;
        updateBlurDimensions();
        el.addEventListener("scroll", updateBlurDimensions);
        const mutationObserver = new MutationObserver(()=>updateBlurDimensions());
        mutationObserver.observe(el, {
            childList: true,
            subtree: true
        });
        const resizeObserver = new ResizeObserver(()=>updateBlurDimensions());
        resizeObserver.observe(el);
        return ()=>{
            el.removeEventListener("scroll", updateBlurDimensions);
            mutationObserver.disconnect();
            resizeObserver.disconnect();
        };
    }, [
        updateBlurDimensions
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($6acf630650be406b$var$Container, {
        ref: containerRef,
        className: className,
        children: [
            hasScrollbar && /*#__PURE__*/ (0, $iKObn.jsxs)($6acf630650be406b$var$BlurContainer, {
                zIndex: zIndex,
                children: [
                    (side == "both" || side == "left") && /*#__PURE__*/ (0, $iKObn.jsx)($6acf630650be406b$var$Blur, {
                        side: "left",
                        blurWidth: leftBlurWidth,
                        blurHeight: blurHeight
                    }),
                    (side == "both" || side == "right") && /*#__PURE__*/ (0, $iKObn.jsx)($6acf630650be406b$var$Blur, {
                        side: "right",
                        blurWidth: rightBlurWidth,
                        blurHeight: blurHeight
                    })
                ]
            }),
            children
        ]
    });
};
const $6acf630650be406b$var$Container = (0, $5UMQ1.default).div`
	${(0, $jKTFw.getScrollbarStyle)(8)}
	position: relative;
	overflow-x: auto;
`;
const $6acf630650be406b$var$BlurContainer = (0, $5UMQ1.default).div`
	position: sticky;
	top: 0;
	left: 0;
	right: 0;
	z-index: ${({ zIndex: zIndex })=>zIndex};
`;
const $6acf630650be406b$var$Blur = (0, $5UMQ1.default).div`
	position: absolute;
	top: 0;
	width: ${({ blurWidth: blurWidth })=>blurWidth}px;
	height: ${({ blurHeight: blurHeight })=>blurHeight}px;
	pointer-events: none;

	${({ side: side })=>side === "left" ? `left: 0;
         background: linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0));` : `right: 0;
         background: linear-gradient(to left, rgba(255,255,255,1), rgba(255,255,255,0));`}
`;


const $950cd52e92c0dd10$export$d2ac8f94a2b72ccc = ({ className: className })=>{
    const { selectedExercises: selectedExercises } = (0, $3whlY.useExercisePage)();
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $6acf630650be406b$export$5060e9cdfaa120ed), {
        blurWidth: 50,
        className: className,
        children: /*#__PURE__*/ (0, $iKObn.jsx)($950cd52e92c0dd10$var$Row, {
            children: selectedExercises.map((exercise)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $da14b428419be51e$export$8cb3b16264e6d8d6), {
                    exercise: exercise
                }, exercise.id))
        })
    });
};
const $950cd52e92c0dd10$var$Row = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("SM")}
`;



var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $dhb7H = parcelRequire("dhb7H");

var $lDZlX = parcelRequire("lDZlX");

var $5kXMA = parcelRequire("5kXMA");

var $3whlY = parcelRequire("3whlY");
const $e9d0bdc14ab71414$export$50f02f9fd2e16e8e = ({ className: className })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const { selectedExercises: selectedExercises } = (0, $3whlY.useExercisePage)();
    const label = (0, $81g6h.useMemo)(()=>isDesktop ? format("exerciseListing.createProgramButton") : format("exerciseListing.createProgramButtonMobile", {
            count: selectedExercises.length
        }), [
        format,
        isDesktop,
        selectedExercises.length
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $dhb7H.Button), {
        className: className,
        label: label,
        onClick: ()=>navigate((0, $lDZlX.RoutesPath).TemplateBuilder, {
                state: {
                    preSelectedExercises: selectedExercises
                }
            })
    });
};



var $hFruA = parcelRequire("hFruA");
const $5eae589f6c43f5e6$export$8fb79a48688049ed = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isDesktop: isDesktop } = (0, $5kXMA.useDimensions)();
    const { filteredExercises: filteredExercises, selectedExercises: selectedExercises, refreshExercises: refreshExercises, isLoading: isLoading, isError: isError } = (0, $3whlY.useExercisePage)();
    const displayEmptySearch = (0, $81g6h.useMemo)(()=>!isLoading && filteredExercises.length === 0, [
        isLoading,
        filteredExercises.length
    ]);
    const { width: contentContainerWidth, ref: contentContainerRef } = (0, $22plg.useResizeDetector)();
    const { height: bottomContainerHeight, ref: bottomContainerRef } = (0, $22plg.useResizeDetector)();
    const isBottomVisible = (0, $81g6h.useMemo)(()=>selectedExercises.length > 0, [
        selectedExercises.length
    ]);
    (0, $giAv5.useOnceEffect)(()=>{
        refreshExercises();
    });
    const exerciseList = (0, $81g6h.useMemo)(()=>isLoading ? Array.from({
            length: 10
        }, (_, index)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $d959b4937c9bb5fe$export$14c51e3613113aa7), {
                loading: true
            }, index)) : filteredExercises.map((exercise)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $d959b4937c9bb5fe$export$14c51e3613113aa7), {
                exercise: exercise
            }, exercise.id)), [
        isLoading,
        filteredExercises
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)($5eae589f6c43f5e6$var$Container, {
        children: isError ? /*#__PURE__*/ (0, $iKObn.jsx)($5eae589f6c43f5e6$var$ErrorContainer, {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
                onRefresh: refreshExercises
            })
        }) : /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)($5eae589f6c43f5e6$var$StyledPageHeader, {
                    title: format("tabbar.exercises")
                }),
                /*#__PURE__*/ (0, $iKObn.jsxs)($5eae589f6c43f5e6$var$PageBody, {
                    className: "p-card",
                    children: [
                        isDesktop ? /*#__PURE__*/ (0, $iKObn.jsxs)($5eae589f6c43f5e6$var$StickyFilterContainer, {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)($5eae589f6c43f5e6$var$StyledSearchFilter, {}),
                                /*#__PURE__*/ (0, $iKObn.jsx)($5eae589f6c43f5e6$var$StyledFilterListingPanel, {})
                            ]
                        }) : /*#__PURE__*/ (0, $iKObn.jsxs)($5eae589f6c43f5e6$var$MobileFilterContainer, {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)($5eae589f6c43f5e6$var$MobileStyledSearchFilter, {}),
                                /*#__PURE__*/ (0, $iKObn.jsx)((0, $hFruA.ActiveFilterListing), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsxs)($5eae589f6c43f5e6$var$ContentContainer, {
                            ref: contentContainerRef,
                            showPadding: isBottomVisible,
                            paddingBottomHeight: bottomContainerHeight,
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)($5eae589f6c43f5e6$var$ExerciseListContainer, {
                                    children: displayEmptySearch ? /*#__PURE__*/ (0, $iKObn.jsx)($5eae589f6c43f5e6$var$EmptySearchSection, {
                                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $e0e2T.EmptySearch), {})
                                    }) : /*#__PURE__*/ (0, $iKObn.jsxs)($5eae589f6c43f5e6$var$ExerciseListSection, {
                                        children: [
                                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $f8a2432cef7287d4$export$bda05c300d1e8682), {
                                                loading: isLoading
                                            }),
                                            /*#__PURE__*/ (0, $iKObn.jsx)($5eae589f6c43f5e6$var$ExerciseList, {
                                                children: exerciseList
                                            })
                                        ]
                                    })
                                }),
                                (0, $lTdpc.isNotNil)(contentContainerWidth) && /*#__PURE__*/ (0, $iKObn.jsx)($5eae589f6c43f5e6$var$FixedBottomContainer, {
                                    isVisible: isBottomVisible,
                                    children: isBottomVisible && (isDesktop ? /*#__PURE__*/ (0, $iKObn.jsxs)($5eae589f6c43f5e6$var$BottomContainer, {
                                        ref: bottomContainerRef,
                                        width: contentContainerWidth,
                                        children: [
                                            /*#__PURE__*/ (0, $iKObn.jsx)($5eae589f6c43f5e6$var$StyledSelectedExerciseCount, {}),
                                            /*#__PURE__*/ (0, $iKObn.jsx)($5eae589f6c43f5e6$var$StyledSelectedExerciseListingPanel, {}),
                                            /*#__PURE__*/ (0, $iKObn.jsx)($5eae589f6c43f5e6$var$StyledCreateProgramButton, {})
                                        ]
                                    }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
                                        children: /*#__PURE__*/ (0, $iKObn.jsxs)($5eae589f6c43f5e6$var$MobileBottomContainer, {
                                            ref: bottomContainerRef,
                                            children: [
                                                /*#__PURE__*/ (0, $iKObn.jsx)($5eae589f6c43f5e6$var$StyledSelectedExerciseListingPanel, {}),
                                                /*#__PURE__*/ (0, $iKObn.jsx)($5eae589f6c43f5e6$var$StyledCreateProgramButton, {})
                                            ]
                                        })
                                    }))
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $5eae589f6c43f5e6$var$StyledCreateProgramButton = (0, $5UMQ1.default)((0, $e9d0bdc14ab71414$export$50f02f9fd2e16e8e))`
	margin-top: 7px;
`;
const $5eae589f6c43f5e6$var$StyledSelectedExerciseListingPanel = (0, $5UMQ1.default)((0, $950cd52e92c0dd10$export$d2ac8f94a2b72ccc))`
	flex: 1;
	padding-bottom: 4px;
`;
const $5eae589f6c43f5e6$var$StyledSelectedExerciseCount = (0, $5UMQ1.default)((0, $c999f59109e5a421$export$549785741f6eedf8))`
	margin-top: 22px;
`;
const $5eae589f6c43f5e6$var$FixedBottomContainer = (0, $5UMQ1.default).div`
	width: 100%;
	min-height: 80px;
	position: fixed;
	bottom: 0;
	z-index: 1;
	background-color: #ffffff;
	border-top: 1px solid var(--primary-25);
	box-shadow: 0px -4px 8px 0px ${(0, $kKnoQ.colors).black}14;
	transition:
		transform 300ms ease-in-out,
		opacity 300ms ease-in-out;
	transform: ${({ isVisible: isVisible })=>isVisible ? "translateY(0)" : "translateY(100%)"};
	opacity: ${({ isVisible: isVisible })=>isVisible ? 1 : 0};

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		bottom: 64px;
	}
`;
const $5eae589f6c43f5e6$var$BottomContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("SM")}
	margin-bottom: 4px;
	padding-left: 24px;
	padding-top: 8px;
	${({ width: width })=>`width: ${width}px;`};
`;
const $5eae589f6c43f5e6$var$MobileBottomContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "flexstart", "stretch")}
	padding: 8px 16px;
`;
const $5eae589f6c43f5e6$var$ContentContainer = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: column;
	flex: 1;
	width: 100%;
	padding-bottom: ${({ showPadding: showPadding, paddingBottomHeight: paddingBottomHeight })=>showPadding && paddingBottomHeight ? `${paddingBottomHeight + 13}px` : "0px"};
	transition: padding-bottom 400ms ease-out;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		align-items: center;
	}
`;
const $5eae589f6c43f5e6$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "flexstart", "stretch")}
	flex: 1;
	margin: 0 auto;
	max-width: calc(100vw - 120px);
	width: 100%;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		margin: 0;
		max-width: none;
	}
`;
const $5eae589f6c43f5e6$var$StyledPageHeader = (0, $5UMQ1.default)((0, $8CNE2.PageHeader))`
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 32px 24px;
	}
`;
const $5eae589f6c43f5e6$var$PageBody = (0, $5UMQ1.default).div`
	display: flex;
	flex-grow: 1;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		${(0, $5WGN2.stack)()}
		border-radius: 0;
	}
`;
const $5eae589f6c43f5e6$var$StickyFilterContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, undefined, "stretch")}
	border-right: 1px solid var(--surface-border);
	min-width: 390px;
	max-width: 390px;
	max-height: 100vh;
	position: sticky;
	top: 0;
`;
const $5eae589f6c43f5e6$var$MobileFilterContainer = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("S")}
	width: 100%;
	padding: 24px 5px 16px 16px;
`;
const $5eae589f6c43f5e6$var$StyledSearchFilter = (0, $5UMQ1.default)((0, $29e029b8a3e0445a$export$820e4d34d59f5d7f))`
	margin: 24px;
`;
const $5eae589f6c43f5e6$var$MobileStyledSearchFilter = (0, $5UMQ1.default)((0, $29e029b8a3e0445a$export$820e4d34d59f5d7f))`
	width: 100%;
`;
const $5eae589f6c43f5e6$var$StyledFilterListingPanel = (0, $5UMQ1.default)((0, $3iKWb.FilterListingPanel))`
	${(0, $jKTFw.getScrollbarStyle)(8)}
	overflow-y: auto;
	padding: 0 24px 24px 24px;
`;
const $5eae589f6c43f5e6$var$ExerciseListContainer = (0, $5UMQ1.default).div`
	display: flex;
	flex-grow: 1;
	padding: 24px;
	width: 100%;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 8px 16px 16px;
	}
`;
const $5eae589f6c43f5e6$var$EmptySearchSection = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, undefined, "center")}
	align-self: center;
	flex-grow: 1;
`;
const $5eae589f6c43f5e6$var$ExerciseListSection = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(24)}
	width: 100%;
`;
const $5eae589f6c43f5e6$var$ErrorContainer = (0, $5UMQ1.default).div`
	display: flex;
	flex: 1;
	align-items: center;
	justify-content: center;
`;
const $5eae589f6c43f5e6$var$ExerciseList = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(24)}
	flex-wrap: wrap;
	width: 100%;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		flex-direction: column;
	}
`;



var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $8CNE2 = parcelRequire("8CNE2");

var $1eHG3 = parcelRequire("1eHG3");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $ghfIB = parcelRequire("ghfIB");
parcelRequire("aanF2");
var $hE6rp = parcelRequire("hE6rp");

var $6cSBm = parcelRequire("6cSBm");

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $6cSBm = parcelRequire("6cSBm");

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");
const $c7e707e33ad6721d$export$e247a9a947d47fb6 = ({ url: url, alt: alt = "GIF animation", repeatDuration: repeatDuration = 2000, ...imgProps })=>{
    const [timestamp, setTimestamp] = (0, $81g6h.useState)(Date.now());
    const intervalRef = (0, $81g6h.useRef)(null);
    (0, $81g6h.useEffect)(()=>{
        intervalRef.current = setInterval(()=>{
            setTimestamp(Date.now());
        }, repeatDuration);
        return ()=>{
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const gifUrl = `${url}${url.includes("?") ? "&" : "?"}t=${timestamp}`;
    return /*#__PURE__*/ (0, $iKObn.jsx)($c7e707e33ad6721d$var$GifContainer, {
        children: /*#__PURE__*/ (0, $iKObn.jsx)($c7e707e33ad6721d$var$GifImage, {
            src: gifUrl,
            alt: alt,
            ...imgProps
        })
    });
};
const $c7e707e33ad6721d$var$GifContainer = (0, $5UMQ1.default).div`
	position: relative;
	width: 100%;
	height: 100%;
	display: inline-block;
`;
const $c7e707e33ad6721d$var$GifImage = (0, $5UMQ1.default).img`
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
	max-width: 100%;
`;



var $kKnoQ = parcelRequire("kKnoQ");

var $bl9tw = parcelRequire("bl9tw");

var $buI4E = parcelRequire("buI4E");

var $81g6h = parcelRequire("81g6h");

var $6cSBm = parcelRequire("6cSBm");

var $hEQyt = parcelRequire("hEQyt");

var $1eHG3 = parcelRequire("1eHG3");
const $0f68fe4b539aa457$var$loadVideoDuration = (video, apiDuration, setDuration)=>{
    const handleLoadedMetadata = ()=>{
        if (video.duration && Number.isFinite(video.duration) && video.duration > 0) {
            const videoDurationMinutes = (0, $hEQyt.calculateMediaDurationMinutes)(video.duration);
            const totalDuration = videoDurationMinutes + (apiDuration ?? 0);
            if (totalDuration > 0) setDuration(totalDuration);
        }
    };
    video.addEventListener("loadedmetadata", handleLoadedMetadata);
    return ()=>{
        video.removeEventListener("loadedmetadata", handleLoadedMetadata);
        video.src = "";
    };
};
const $0f68fe4b539aa457$export$ed879e2ca19c530 = (mediaType, mediaUrl, apiDuration)=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const [mediaDurationMinutes, setMediaDurationMinutes] = (0, $81g6h.useState)(null);
    (0, $81g6h.useEffect)(()=>{
        // For ARTICLE type, use duration from API
        if (mediaType === (0, $6cSBm.MediaType).ARTICLE && apiDuration) {
            setMediaDurationMinutes(apiDuration);
            return;
        }
        // For VIDEO type, calculate duration from video metadata and add apiDuration
        if (mediaType === (0, $6cSBm.MediaType).VIDEO && mediaUrl) {
            const video = document.createElement("video");
            video.preload = "metadata";
            video.src = mediaUrl;
            return $0f68fe4b539aa457$var$loadVideoDuration(video, apiDuration, setMediaDurationMinutes);
        }
    }, [
        mediaType,
        mediaUrl,
        apiDuration
    ]);
    const durationLabel = mediaDurationMinutes !== null && mediaDurationMinutes <= 1 ? format("global.time.minute") : format("global.time.minutes").replace("%d", (mediaDurationMinutes ?? 0).toString());
    return {
        durationLabel: durationLabel
    };
};



var $1eHG3 = parcelRequire("1eHG3");

var $cD3aa = parcelRequire("cD3aa");
var $83bcb0904afdd6f8$var$LuClock8 = function LuClock8(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M6.667 0a6.667 6.667 0 1 0 6.666 6.667A6.674 6.674 0 0 0 6.667 0Zm0 12.222a5.555 5.555 0 1 1 0-11.11 5.555 5.555 0 0 1 0 11.11Z",
                fill: "#565671"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M6.763 3.333a.569.569 0 0 0-.57.574v2.484L4.268 7.603a.575.575 0 0 0 .606.976l2.19-1.378a.573.573 0 0 0 .268-.492V3.907a.576.576 0 0 0-.57-.574Z",
                fill: "#565671"
            })
        ]
    });
};
$83bcb0904afdd6f8$var$LuClock8.defaultProps = {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $83bcb0904afdd6f8$var$MediaThumbnail = ({ item: item })=>{
    if (item.mediaType === (0, $6cSBm.MediaType).ARTICLE && item.mediaUrl) return /*#__PURE__*/ (0, $iKObn.jsx)("img", {
        src: item.mediaUrl,
        alt: `thumbnail-${item.title}`,
        loading: "lazy"
    });
    if (item.mediaType === (0, $6cSBm.MediaType).VIDEO && item.previewUrl) return /*#__PURE__*/ (0, $iKObn.jsx)((0, $c7e707e33ad6721d$export$e247a9a947d47fb6), {
        url: item.previewUrl,
        alt: `thumbnail-${item.title}`,
        repeatDuration: 1600
    });
    return /*#__PURE__*/ (0, $iKObn.jsx)($83bcb0904afdd6f8$var$Placeholder, {
        children: /*#__PURE__*/ (0, $iKObn.jsx)($83bcb0904afdd6f8$var$MediaLabel, {
            children: item.mediaType
        })
    });
};
const $83bcb0904afdd6f8$export$44e965a712d5fdba = ({ item: item, onNavigate: onNavigate })=>{
    const { formatDateFull: formatDateFull } = (0, $1eHG3.useI18n)();
    const handleClick = (0, $81g6h.useCallback)(()=>{
        onNavigate(item.documentId);
    }, [
        item.documentId,
        onNavigate
    ]);
    const handleKeyDown = (0, $81g6h.useCallback)((e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onNavigate(item.documentId);
        }
    }, [
        item.documentId,
        onNavigate
    ]);
    const { durationLabel: durationLabel } = (0, $0f68fe4b539aa457$export$ed879e2ca19c530)(item.mediaType, item.mediaUrl, item.duration);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($83bcb0904afdd6f8$var$ItemCard, {
        role: "button",
        tabIndex: 0,
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        "aria-label": `View ${item.title}`,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($83bcb0904afdd6f8$var$MediaBadge, {
                "aria-label": `Content type: ${item.mediaType}`,
                children: item.mediaType
            }),
            durationLabel && /*#__PURE__*/ (0, $iKObn.jsxs)($83bcb0904afdd6f8$var$DurationRow, {
                "aria-label": `Duration: ${durationLabel}`,
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($83bcb0904afdd6f8$var$LuClock8, {
                        width: 13.33,
                        height: 13.33,
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($83bcb0904afdd6f8$var$DurationText, {
                        children: durationLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($83bcb0904afdd6f8$var$ThumbWrapper, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)($83bcb0904afdd6f8$var$MediaThumbnail, {
                    item: item
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($83bcb0904afdd6f8$var$CardContent, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($83bcb0904afdd6f8$var$CardTitle, {
                        children: (0, $buI4E.formatTitle)(item.title)
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($83bcb0904afdd6f8$var$CardMeta, {
                        children: [
                            item.author && /*#__PURE__*/ (0, $iKObn.jsx)($83bcb0904afdd6f8$var$AuthorName, {
                                children: item.author
                            }),
                            item.publicationDate && /*#__PURE__*/ (0, $iKObn.jsxs)($83bcb0904afdd6f8$var$PublicationDate, {
                                children: [
                                    " ",
                                    formatDateFull((0, (/*@__PURE__*/$parcel$interopDefault($cD3aa)))(item.publicationDate))
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $83bcb0904afdd6f8$var$ItemCard = (0, $5UMQ1.default).article`
	width: 270px;
	height: 317px;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	border-radius: 8px;
	padding: 16px;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
	background: ${(0, $kKnoQ.colors).primary10};
	box-sizing: border-box;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
		transform: translateY(-2px);
	}

	&:focus {
		outline: 2px solid ${(0, $kKnoQ.colors).primary};
		outline-offset: 2px;
	}

	&:active {
		transform: translateY(0);
	}
`;
const $83bcb0904afdd6f8$var$ThumbWrapper = (0, $5UMQ1.default).div`
	width: 100%;
	height: 150px;
	flex-shrink: 0;
	overflow: hidden;
	border-radius: 6px;
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}
`;
const $83bcb0904afdd6f8$var$Placeholder = (0, $5UMQ1.default).div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${(0, $kKnoQ.colors).grey10};
`;
const $83bcb0904afdd6f8$var$MediaLabel = (0, $5UMQ1.default).span`
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 12px;
	color: ${(0, $kKnoQ.colors).grey50};
	font-weight: 700;
`;
const $83bcb0904afdd6f8$var$MediaBadge = (0, $5UMQ1.default).div`
	font-family: ${(0, $bl9tw.fonts).header};
	font-size: 16px;
	font-weight: 700;
	font-style: normal;
	color: ${(0, $kKnoQ.colors).primaryDark};
	border-radius: 16px;
	display: inline-block;
	align-self: flex-start;
`;
const $83bcb0904afdd6f8$var$DurationRow = (0, $5UMQ1.default).div`
	display: flex;
	align-items: center;
	gap: 3px;
	margin-bottom: 10px;
	color: ${(0, $kKnoQ.colors).grey};
	font-size: 13px;
	font-weight: 600;
	svg {
		fill: ${(0, $kKnoQ.colors).grey};
		color: ${(0, $kKnoQ.colors).grey};
	}
`;
const $83bcb0904afdd6f8$var$DurationText = (0, $5UMQ1.default).span`
	font-family: ${(0, $bl9tw.fonts).body};
	color: ${(0, $kKnoQ.colors).grey};
	font-size: 12px;
`;
const $83bcb0904afdd6f8$var$CardContent = (0, $5UMQ1.default).div`
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	text-align: left;
`;
const $83bcb0904afdd6f8$var$CardTitle = (0, $5UMQ1.default).h3`
	margin: 10px 0 6px 0;
	font-size: 18px;
	font-weight: 700;
	font-family: ${(0, $bl9tw.fonts).header};
	color: ${(0, $kKnoQ.colors).black};
	line-height: 1.2;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	&:hover,
	&:focus {
		text-decoration: underline;
		cursor: pointer;
	}
`;
const $83bcb0904afdd6f8$var$CardMeta = (0, $5UMQ1.default).div`
	font-size: 12px;
	color: ${(0, $kKnoQ.colors).grey50};
`;
const $83bcb0904afdd6f8$var$AuthorName = (0, $5UMQ1.default).span`
	font-family: ${(0, $bl9tw.fonts).body};
	font-weight: 700;
	color: ${(0, $kKnoQ.colors).grey};
	font-size: 12px;
`;
const $83bcb0904afdd6f8$var$PublicationDate = (0, $5UMQ1.default).span`
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 12px;
	font-weight: 600;
	color: ${(0, $kKnoQ.colors).grey};
	margin-left: 6px;
`;



var $kKnoQ = parcelRequire("kKnoQ");

var $bl9tw = parcelRequire("bl9tw");

var $kKnoQ = parcelRequire("kKnoQ");
const $49eb052a898fd102$export$e963f6cee9e742e7 = (active)=>{
    if (!active) return "transparent";
    return (0, $kKnoQ.colors).primary;
};
const $49eb052a898fd102$export$739ce4756621745d = (active, variant)=>{
    if (!active) return (0, $kKnoQ.colors).black;
    return variant === "all" ? (0, $kKnoQ.colors).white : (0, $kKnoQ.colors).black;
};


var $1f30f250cfe8e844$var$LearnHeroDesktop = function LearnHeroDesktop(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fill: "url(#pattern0_5105_5250)",
                d: "M0 0h1440v300H0z"
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("pattern", {
                        id: "pattern0_5105_5250",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("use", {
                            xlinkHref: "#image0_5105_5250",
                            transform: "matrix(.00049 0 0 .00234 0 -4.3)"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("image", {
                        id: "image0_5105_5250",
                        width: "2048",
                        height: "4096",
                        preserveAspectRatio: "none",
                        xlinkHref: "data:image/jpeg;base64,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"
                    })
                ]
            })
        ]
    });
};
$1f30f250cfe8e844$var$LearnHeroDesktop.defaultProps = {
    width: "1440",
    height: "300",
    viewBox: "0 0 1440 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var $1f30f250cfe8e844$var$LearnHeroTablet = function LearnHeroTablet(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fill: "url(#pattern0_5105_5266)",
                d: "M0 0h768v300H0z"
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("pattern", {
                        id: "pattern0_5105_5266",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("use", {
                            xlinkHref: "#image0_5105_5266",
                            transform: "matrix(.00049 0 0 .00125 0 -2.06)"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("image", {
                        id: "image0_5105_5266",
                        width: "2048",
                        height: "4096",
                        preserveAspectRatio: "none",
                        xlinkHref: "data:image/jpeg;base64,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"
                    })
                ]
            })
        ]
    });
};
$1f30f250cfe8e844$var$LearnHeroTablet.defaultProps = {
    width: "768",
    height: "300",
    viewBox: "0 0 768 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var $1f30f250cfe8e844$var$LearnHeroMobile = function LearnHeroMobile(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fill: "url(#pattern0_5105_5269)",
                d: "M0 0h375v365H0z"
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("pattern", {
                        id: "pattern0_5105_5269",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("use", {
                            xlinkHref: "#image0_5105_5269",
                            transform: "matrix(.00049 0 0 .0005 0 -.527)"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("image", {
                        id: "image0_5105_5269",
                        width: "2048",
                        height: "4096",
                        preserveAspectRatio: "none",
                        xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAARCBAACAADAREAAhEBAxEB/8QAHQABAAEFAQEBAAAAAAAAAAAAAAIBBAUGBwgDCv/EAFgQAQACAQIDAwgIBQEFBQQCEwABAgMEEQUhMQYSQRMzUWFxcrGyBxQiMlKBktIjQpGh8MEVJENi0VNjguHxc5OiwhYlNDVEVKOzVXSDlNM2RWRGhKS0w//EABwBAQACAwEBAQAAAAAAAAAAAAABAgMEBQYHCP/EAFYRAQACAQEEBgYJAgUBBQUAEwABAhEDBCExQQUSUWFxsSIycoGR0QYTUoKSobLB8EKiFCMzYuHxQ1Njk8IVJDRzg6PSVLMWRMPiRWR01CU1VYSUpMT/2gAMAwEAAhEDEQA/AP3n5M2WMl/4l9u/bl377RG88vvdP+jqUpTq19Gvqx/THZHcvuiMYiMRXExGZzMZ4TumOPhu3dkfLZfx3/Xk/ct1KfZr+GPkjMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/wBlfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/AK8n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv8AZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv+vJ+46lPs1/DHyMx2/2V+Z5bL+O/wCvJ+46lPs1/DHyMx2/2V+Z5bL+O/68n7jqU+zX8MfIzHb/AGV+Z5bL+O/68n7jqU+zX8MfIzHb/ZX5nlsv47/ryfuOpT7Nfwx8jMdv9lfmeWy/jv8AryfuOpT7Nfwx8jMdv9lfmrGbLvH8S/WP+Jk/cdSn2a/hj5JiYmYjtn7NY/OJ3IZPOZPft80lPUr7NfKETwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUm1a/etEe2Yj4piJnhEz4RkW+TXaLFM+V1elx7TPLJqMVPy5333/Nlrs+0X9TQ1rR210rzG/nmK8O9eaTMzitsRxjE5iffGfGN/isb8f4Pj5W12O0+jHXJk/vSloiPRPPx8GevR2224bPePamtP1Wif5jivGjbMZrOJjO/ERv78x/OK1t2o4RTply39VcGT/WKxH9Yj0s1eiNttxpSvP0tSn7TPw4pjRtM4mKxG/f1vnMx5ra/a/hkbxTDrMlo/wC7xUj2/az96I5xz7sz8GWvQm1TjramhWPavM/CNPH5r/4ecTOYnvzw7vHt7eS0v2zxc5x6C8xv1vqK029sRjv/AEmd/Tz5M1egrzuttFYnsrpzaPjN68u5H+HnGetP4Zx5vjbtlfpXQUiZ6d7PM7bezHXf+n9F46Drz2ifdpx+9iNCIzmczy3Yx7s7/i+U9sdV/Lo9NG+0favln+m003n0dGSOg9HfnX1Z57q04d/HHjvx2J+ornjPGP8Anv8Al3vlPbDiO893T6GOv3seonb+mprvt/03heOhNlxv1Nome62nH/5OZ/nct9Rp8vf6XziP3fG3azitp5RpKequG88o9/LbrvvM+HReOhtjjj9dbx1I/akcj6nT5zOezl4Ziefb+aE9qeLz0yYY5dYwU9fp3j/OnptHRGxRPq6k906lsflifzPqdOf6f7pjzl8rdp+MxzjU0jbr/u+Dp+ePl+UStHROw/8Ac2meX+bqR8fS4LfU6XPj2ZtP59bH5+KkdpuMzzjVxHLp9W0/X2zhT/7J2GOOjn/62rPlqK/Vaf2fzt81Y7S8Zid/rcT6p0+m2/thif7o/wDZWwf9zMf/AFdX97yfVaf2fzt81f8A6T8YjnOppPtwYIj+2OD/ANk7DPDRt7tTV/8AtpW+or9n+6f/ALZOvani3/a4be3Bj/8Al2/yVZ6H2LPqale76y3x35lX6nTj+n+6Z8pfSO1nFa7bxpL+/ivHyZK7/wBuntUnobY54TrR4Xj96SToUiM593W3+X7vtXthxHf7Wn0U+qKZ4/KZ+sW/pH/RWehNlxu1dePG2nP5fVxKI0adsx4zP7R5vpHbHVxt3tJpre7fJWZ9m9rfHl61P/Yejvxr6sdma0n44iOHdx7kfUVzxnjw7uzt97617Z5OW+gpMc+dc94+OKY29fq5eKs9BU3/APvNo7p06/8A28Tx5Y/5idCvKZj3d/y3PvXtninlfh+SvLrTPF95/wDFipXn7WOegrf07TWfa05ru917Z90H+Hnj1piO3qzjzXdO1/Dbcr4NZSfGe5itWPzjNEz+VeTBPQm1Rnq6mhMe1eJn3fVzH5o/w9sRw8Znq5+MTn3Lmnang9uuXNSN/wCfBeP6zXvRt6ZiZ9W7FPRG2xwpS3hqV/eYR9TaJ3xG7stunx3dnGYxw4ZXWPj/AAbLv3ddjrPhGSmXHtPo716VrMeG+/t28cNujttrnOz3nH2Zrb4RW0zPuVnStGcRPdw/+2z+S+x67Q5dvJavS5JnflTUYrdPVF5tv6p259GC2zbRT19DWrHbbTvEfGYwj6u8ROaYxGd+c9vLcuItW3OtotHpiYn4MUxMcYmPGMMeJ7FUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACu3+nPw5+kDaefq68p5e0TieyfgtM+u0WmmY1Gr02G0fy5MtK3/Kkz35/Kszzjluzaez6+rGdPR1bx21paa/ixj809S08ImfCJ+PDHy582My9pOEYon/eZy2jpXFiy3mfZaa1x/wBbx6t21Tovbbz/AKXUjtvesRHjETNvyXjR1J5RHjMftMz8IYzJ2y0keY0ee/ryXx49/bFLZfHlyn19eTcr0Hrf9pradJ7K1tfz6nL+c140Z4TaO7Fc/nMRPu/Zj83bHV2mYwaTT4o6R5W2TNaI5/hnDG+88t4mPTDap0JoR/qa2ref9sV047uP1kz374XjRrjEzM7+XLwiZnnns3ds5lj8nafjN99tRjx9eVMGLxnrvel539e/9WzTonYq8dO1/avbyi0ftE9kLfVU7Jx2daffMY3Rnw3Mfl4txPNv5TX6qYmNpiuW+Os+2uO1KzHojbl4eDYpseyU9XZ9HxmlbT8bRM8u1MUpEerGfZjz4rK2TJeZm+S95md97Wtad/TMzM7z62eK1rERWtaxHCIiIiPCIhfPZu8M/DigsgAAAAAAAAAAAAAAAAAAAAAABKuTJTaa3tWY8a3tEx7Jjb1ehWa1nOa1nPHMROfHMJz2xE+6Mfljf3r3FxXieHbyev1VYjpWc+S9Yj0RW9pr+e3P0MNtj2S+Zts2jMzxmNOtZme2ZiIn4Y5ImKzGJrE/CJnnOZxMyv8AH2l4xjnnqKZIjwyYcU7+qe7WkxEeG07+uGtforYbcNK1Z/23vGPCJtaPHcrNKYxETHhMx+eePuiP3yGLthra7Rm0umyxG3m5y4bT6d5m2au/omKxHq6Na/QmhP8Ap62rSf8AdFbxHwik/n71PqacYmc785xMeUT+fmyWLtjpp2jNo8+PfrOLJTL/AGt5Hp7efojx1b9B6sepr6dvbranhvjr+SI0pjMRbrZ7YmJmd0cpsyeLtLwfNFf95thnaN65sWSsx7Zit6Rv02i889/bOpfovbaTP+VF47aXrMT4RMxb41hTU0dSJ9XMY4xMd/eyeDX6LUzEafV6bNaf5KZqTf8ARv34357bxEz6GpqbPr6UZ1NHVpH2rUtFfxYx+bH1Lc4mPGOPhPD813t4+Hp/9P6MKIrMzjdns3/tGDb/AD/PZP8AQRMY5+f7xCggAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWOf9/HYTWMzETzz5LfPq9Hpt/rGpwYZiOmTLStt/dtMWn8onbrziJ2y00NbV/09LUv31paY+MRheaTmIrEz2zjPb7vJhdR2n4Th3imXLqLR1jBitMR6PtZPJxP/hm0eHWJb2l0TtmpvtSulHbqWjOPZr1p90xC0aGpMZx1Y5dbO/s4ROGG1HbLeJjS6OImfu3z5Jnw8cWOI6enyu0dJhvafQfPV154b66dMY+/aZ3eNIzw4zDJ9RXnbGOyInl25nn2V4Z3dmKy9qeMZd4rlxYKzExtjw0mdpmZ5TkjJMT47xMWjb2S3KdEbFTfNL6mPt3tEfCk1j47u5aNKkcpnxmcT7t2fCYx3MRm12tz+e1epyeq2fJNeu+3dm3diPVEelvU2fQ08dTR0q44TGnWJ8cxGc+/xXiIjhFY8Ij5bvctf858/jv/AHZU/n4/z+clJjf/AD/Tp/YM8v2jz4qgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAptG+/8ArPw6CZnPu5b/AN5lXb/r6Ofp/wA9XoDPdj4/PK5xa3WYPM6rUYtvCmbJWPT92Lbf2Yr6Ghqf6mjpX77UrM/GYyicTGJiJjviPky+HtPxfFERbNjzxEbbZsNJnb12xxjvM+u1pn0y0r9E7FfONO2nM86XtHwi02rHhERHcpOlS39ON2N3Hl257PdGdzLaftjaIiNVootMdb6fJt7dseSLb/nlj1ehpanQcb50teY7K6lIn42rMfoljts8ZnFpjumM/nu8mY0/ajhOedr5Mmnnw8tittP/AIsXlYjx+93enp5NHU6I2zT9WtNXt+rvGYjlOL9SZzy6ucqzoXjsnMTjFvCYzmN26eH54wzeDV6TU/8A2PqcGbx2x5a2tt4z3Y3tER4zMc+XJo6mhraX+ppalIicZtS0RnszMY/Nj+rtGcxPjjd+cx2/zD7sSs8Zx/PgCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFdv7df67f5sJxP8iezPZ2LfPqtNpom2o1GHDERv8AxMtKzt15Vm3emfRERMz4Qy6ejras409LU1PYpa0e+YiYiO+d0Jilp4VmfcwWo7V8Lw7xi8tqbRE+bxdyk22mOd800ttv41raPGKz49DT6H2u+OvGnpRz698zjwpFt/dMwzfU2tvvis8MZ5cd8cfzjxhgdR2w1l94wabBhif5r2vmvHrjljpM9OtNuXOJ3dHT6E0K/wCpq6mpMTE4rFaVnfvid9piJjstnsmOd40aRxzb34+ON/wmP3YPPxniup38rrc3dnrTHbyNduX8uKKV8PGJ3jrPWW/p7DsmljqaGnmOE2jr2+N5tPHv9zJFaRwrEY4ZjMfnmY3d87+xjZmZmZmd5md5md959szM7z623u5boSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAc4mJidpiYneOvL4e092fEzy7f2ZLBxjien2jFrc8RXbat7+VpER4dzLF67eG23To1dTYtk1c9fQ05meM1jqW8c06s538ZlE0pM5tGd+cxGLfHjnvzu72bwdr9dSKxn02nzxHW1ZvhvPtmPKU339GOseqHP1OhNntMzp6upp54RMRqViezfNbY8bTPfKn1VY4ZjtziYnj3R+89+NzO6ftZwzLFYzRm015j7UXx+UpG/LeLY5taYj0zjrz8PFz9Toba6Zmn1erHLq26tp914iInui08Y3sVtG/GJrPdnf8Zj4RNv2Z3BrNJqYidPqcGbfwx5aTb86b9+s+mLViYc7U0NfSnGrpalO+1LRE47LYxMd8TMMU1tE4mJjvnh8eGF1ty35f1jf+nViREZ7PjHlx3+CgmazHHtwCoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABO0RMzO0emeURtt1meW2wvFYmud+d//DE6rjnCtJvGXV0veJ2nHh/jW3jf7M+T71a25dLTWYnlMc943dHo/bNbHU0bRE8Lan+XGO308TMc8xEprpXtPDEcc/z+Ya5qu2Uc66PRzM8+7k1FvZznFjn1xPnvVvDp6XQc7p1tb2q6UflF7xHxmndhmjZ8RE2tx+zw3Tid+/y3sBqeP8W1Xei+ryY6zv8AYwbYYiJ8ItTbJMbcvtXmZiIiZl0tPo3Y9LGNGtpjnqZvPjid2fCIxyZIpWMYjOO3f55iPcw8zNpm1pm1pnebTMzNpmZmZmfGZmZmZnrPVvRERGIiIiIxERG6IjhEdmO7wWUiNv8AI/pyiAVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiZid4naY5xMcpifTyOPEZfTce4rpdoprMmStdtqZ9s1do3iIickWtWIieXdtXbrHPm0tXo7Y9XM20a1mc+lp/wCXOZ5+jiJnxic88qzSsznqxnt5z4tg0/bKdq11mj3nlFr6a+3TrNcWSZjxneIy9d9tonaObqdB5mfqdfHZGrX4RNqRHGcb+riOxW+jmIxO7fxmOPLfGY7e1sWl49wnV7Vx6umO89KZ/wCDbf8AD9vas2iZiJit7deW/jzNbo7bNHM20bWrH9Wn/mRjtxXNojG/M1jEb5YJ0rRwiZ8Pnz+EfLL8p5xMTG2+8TEx16xMdY/zwaMxMbpjE9kscxj+T+8R5AgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABXaev+fn6PzFurOM43YzxjgpPKJmZiIiN5mZ5RHXeZ6RHp36HHgjE8O3vjz4MLq+0PCtJFqzqK58kTt5PTxGW2/Wft8scbR1ickT1mInnDf0ejds1pj/KnTrO/r6uaR8MTefdWY7ZhljStOMxMcPWxiY7s9kbuE53bt7WtX2v1OTauj0+PDWN975v4uSef8tazTHTlvymMnOesRydbR6E0q79fVtqTyrp+hX3zPWtPu6vPjxZI0Y/qnM5zu+c5mc9kzxy1vVcS1+stvqNVmyRP8nfmuKI/5cVO7jrM8t5iu87b2mZ5upo7Ls+hGNLSpWftYzaZ772zaeeN+6eDLWtaxiIxG/x7eM5nj8lkzpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXel4hrtFbfS6rNijl9iLzbHO34sdu9SesxzrPpYdXZtn169XV0aX47+rEXjPZeMWj3SWils9aM5zyjnPK3Hv4fBsmk7YavHPd1mmx6is8u/imMOWOcbzaJi+O8TEb7VrTafHwnla3QmjbM6GpbSn7N4+spPdE5i1fGZt4MU6NeNd3dPpRHxmJzu/nBs2k7R8K1VYic8abJM7Tj1MeTmOUc4y88MxPP+fvRG82iObla3Rm2aMzjTnVrH9Wl6X9u6/Z/TjlEyxW0tTEYjrRHCa798zz3538fGccMM1ExaItWYtW0RNbRMTExPSYmOUxPhMcmhMTEzExMTE4mJ3TExxiY5TDFieyd2c7uGOPw5qoMTjPIEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEf5/p/UTHHf/AD+e/wAJ4MZrOMcO0MT5fU0nJG/8HF/FyzMeHcpv3Z9d5rXw3iYlt6Gw7TtH+npW6v27+hT3Wnj93K9dK1p3RiMROZ3RvjO7OM7+UZnulq+r7ZZJ3podNXHG/LLqJ71523mJ8lSYrWeW+1r3iY5zETvv19DoSkb9o1ZtP2NLERx53tEzMTHZWsx2tiNLFfSnljdw74zMZ/KOE79zV9VxHXa2Z+s6nLkiZ37k27uOJ9WOu2ONvVX/AFdfR2XZ9CI+q0qUmIx1sZt77Tm0++V4rWOERHnu753/AJrL8/hz/t8GdIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACkxE/D8vQfz+dk98b09ae3znz/fPxXul4hrdHMTptVmxRWd+5Ft8c+nvYrb45idomYmu0zDBrbNoa8T9bpUvmMZmMWiO60YtGOWJ3KzETExMROe7E/GMT+bZ9H2wy1nua7TVy1ieeXBPk8kcv+zt3qX335xFsfP08ojk6/QmnMTOz6k0nlTU9Ks93WjFq++LMNtGJx1ZmMcp3+PZj4No0XG+Ga7aMWorXJO0TizTGLJvPSKxfaL8vHHa8b+MTEw5GvsG1bP6+nM15Xp6dd3bjM1+9EMVtK9ZnNZ6ucZiM/LHvwy23Lff2ev1+yefPbwaaOp6Oc8s8P53fzhQUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABOJn+eXb7nyzajBpqTk1GXHhpETPeyXrSOUTPLvTznl92N5npEbr6enqatopp0te08IrWbT+RFZnhEz4RM7+zdE72r63tbpMUTTR4r6m+/nL/wsMR6Ymd8l/D7PcpHPeL9YdfQ6F1r4nXvXSr9mvp6k9270I8c28J5566M8b4jdO6MTv5bsdWPz7ccGqazjvE9ZNovqLYsVt48jp98VO7MTExMx/EvExymMl7RMTO8bbQ7Gh0dsmhETXSi943/Wanp2zHCYifQrPfWscMs0aenWN1czxzaImc/lG7liI745xh9o9DeWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAzPay2i45xPQzWMWotfFXl5DNvlxzX8Md6YvSOnm7U29PSY0tfo/ZNozNtKK3nM/WafoWzPOcRi053zNotlFqado3578RPHv3xE/D4y2vR9rtLk2prcNtNeZ85i3y4pjbnM187SN/CK5PXbpvx9foXVrOdnvGrX7N8UvHdE+rbxma+DBbQn+mc7+e7Ed2/f7/j27Tg1GDVUjJpsuPNSY372O9bbeq23Osx4xaKzHjDkamlqaVupq0tp2jlaJifGM8Y74zDDatonfGN/dv8I5x4Psxo6szy4Y/MCYmJxIIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAViI267Tv/wBOs+HX0eAvFMxnOPd/yxuu4tw/h/ejUainlIiZjBj+3mt6I8nWd6d7l3ZyTSs7797bm2tDYtp2nE6WnPVmcfWW9GkdvpTxxzisWnuTXTtbh8Z3R37+cbv6c9+Gna3tdqcsTTQ4o01N/O5YjJmnn1iu84qbxyneMvPfa23XubP0LpUmLbRedafsUzSme+fXt/bu4x2Zq6MRGLT1vDMR8eMx2cPBq2o1Go1V5yajPkzXmd+9lva8+PKN55VjflWNoj2cnX09LT0q9TSpXTrHKsREeM44z3zmWaMRGIiIjl3fDGd3b7sPkuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKTG+3q5/5z/wCoPrgzZtNkrl0+W+G9Zma2xWtS3PrvMTG8T4xttPKJ5QrfTpq1mmpSt6zGJi8RaOOd2Y3eMb878m7nvhtOi7W6vB3a6zHXVVjl5Sm2LPHt2/hX6fgrM8+9ad944+0dDaN/S0Lzo2+zbN6Tns42rjnObRjl20nTiZma5jniZzHuzv8APuhuGi4zw7iHdjBqK+VtEfwMn8PLG0Ryisztb20m9fRadpcTaNh2nZszqac9SJx9ZX0qe+Y9XwtES176dozaY3dsely48scOeJ7mUmP829c/9P8ANmoxzEcpz27uE9iggAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA6deXj+XpExE7sRx4fH+cWD1/aLhuh3pF/rWXp5LTzW/d9d8u/crMTG20d63j3NuvR2fozatoxbqfVUnf19XMZ9muOtPbwiO/gy10rTxjEZ3zPPjwjETy7Y4b+MNK1/aTiOt71KXjSYbT9zBvF5r6LZuV5n09zydZ8a7cp7uzdF7LoYtav12pEetqb6xPOa09WO7rdaY7ctiunSsxvz453fdx1cz4THmwEzNpmZnebc7TPOZn0zM85/N0uEREboiMRHKI7IjlCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB6/GOk+Meyesfkfn47498cxneH9ouI6KK0tk+tYYnecWeZtaI5RMUzTM5a8onuxabVrv9zrE8/aejNl2iZtFfqrzwtpxEZ44m1MdWZz607rTw63OK2pW2MxjHZz8Y4fk3XQdpOHazat7fVM0xH8PUTEVmfRTNH8OefKO/wByZ3jasxu4O0dF7VoZtFfrtOP6tPMzHtU9aPu9aI5zwYLaVqxMxid++cRPxrPCPDPPduZ6Oe23PfaY28YnpMenfw9Lm8OLDid/dxBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABPdis2mdojrM7RWPbaZiIiPGZ6JiJmcREzM8IjfM+5MRnxzEYxO/Phn4Y8Gt8R7T6HR97Hg31eeOURjnbDEzEfezc4t1jeMcX571tak7zHU2XonaNfFtT/I0535tGbzHbGnmJiO+2J5xEwzU0ZnfMxWO/HW4/Z3+/OJ3cMTv0rX8b4hxCZjJmnFhnePIYZmmOYnblfnNsn/jmY5ztEO9s3R+zbNia06+pG/6y/pWz/tj1a/diJ7ZlsRStd0Rmd0xPyjhGd093jMsRt/0/z+jd/n8+Kcz2gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKTHs/ON+n5wJzw3Ru7uPiyuh4zxDh20Yc82w13mcGXfJi29UTPep4c6WrvPOd+k6e0bBs205nUpEXn/tKejfPbM74n70THmpatbTmY38pjETH5YmfGPKG76DtTodX3Meq30eafs72+1gmY35+WnaKb/wDeRWI5x3p2iZ4O09EbRo5tpf52nG/dGNSI76c+6azMzx6sMF9G2+a+lHPh1pnPKOfu+HbslbVtEWratqzETW1ZiYtE9JiY6xPphypiYmYmJiYnExMYmJ7Jid8SwzExnPL+c9/u443qoQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABiewmYiJmZ2iOczPKIjrvMzyjkceCcT2T8Gt8Q7T6HSd7Hp/wDfM8TttjnbDWfHvZecW7vhGOL7zym1XV2bonaNbFtX/I093rxP1kx3U3Y8bTXwlnjRm2JtEUzPjwz/AE8uXbns4w0bX8Z1/EZtGfLNcEzExp8W9MPKY7vervM3mOsTe15jnMd3lD0GzbDs2yxE6dM6mJzq3xN+G+InhHW7KxHZvZ6UrWN0b985md8THZHfujt443MZs20gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG0f5/n9PR4Ccz/OPx4sjoOLa/h0x9WzW8l3otOnyb3w2nlvvTeJiZjrNLVvP4t9u7q7TsWz7VH+bSOtETEalfRvHHGJjjHOItExnkrNa29aM+G6d3DfieE78TEx3N54b2o0Wr2xauPqWadoib272C0zO28ZeUU6TvGSIrG8fbtPTz+09Ea+j6Wj/n07KxMakeNP6vGszMzn0Y3Z176Uxvr6XnG7s4T7o48IxDZomJiJiYmJjeJjnEx6YmOUx63KmJicTExMcYndMe5gEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACu35/8Apv8A+np57esmIzwx4c2A4j2j0PD98dLfW9REzHksN692k133jLl51rzjaa0794mPtUiPtR0tl6L2jacWtH1OlOJ694nMxPOlIxNt2/M9Ws8pmWamled/qxOJ37sx3RMb+6eHZne0PiPG+IcSmYzZe5h728afDvTH4bd7a3eyTtH88zG/OKxz39Ds2wbPsu+lOtqY36l8Wt39Xdimf9sRON0zO9nita8IzO7fM5893Hf553YxMRt/f/P/AD8W6vM5/n5eHZHLIIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUmN//AC/z2/15bH8/n8/IZXQcZ13DZjyObvYd472DLvfFMeqJmJxzM9bY5rMxyneIam07Ds+1+vTF8TjUpiL8+ePSiOy0W54xlE1raN8YnfvicT78RmeyImZ7sN74d2k0Gu2pmtGiz8o7ma2+O8z0nHmisV58o2vFLTPSLTvt53auitp2fNqR9fp4metpx6Ue1p5m3vr1ojjMxGM619K0b67459scc8Z4c89sy2LblvvHs5+r8vHn6OXpcximMdnun+eKggAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAj18xasb4zwn5f9GM4jxjQ8NrPlssXyz93T4tr5Z67TaN9qVnbnN7V/5YtyidzZth2jap/y69WnPUvmKR4TjNp7qxPfiN7L9VNuEYjtmccOMb+M9mM7+PGGgcS7Ra7XzOOszpdPO+2LFa3etExzjLl5TflymK9yk9O7Mxu9HsvRmz7Ni0xGtqRj07xGIntpSc9XxnNo7YyzV061zzndvxzjdmOz35nf3ywLorgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG3+f51/9fTIM5w3tBruHTXHNvrOmjbfDltbesR4Yskxa2Odp5fer/wB25+1dG7PtObRH1WrP9dIjEz23rui09/rd+5W9K33zHpfa+HGOeMTziZzxiW/cO41oOIxEYsnk83LfT5tqZN+v2J51yxymP4dptHKb1pvG/nNq2DaNl33r1tPlqUzNfC27NZ9qIieUzva1tOaxPo5jhExO/wCHH3fnPGMvPj6N/wDOnJpMcxMcf5hQQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAttVq9NosNs+qzUxY6/in7Vp8K0r969p8K0i07bzMRETMZdHR1de8aejS17TyiOEdszwiO+Zjfu4zC0UtaYiIznHDv7fg0XinarPnm+Hh8Tp8W8ROefP5I2n7sc4wxM77TEzk5RMWr3u69FsnQ+lpxF9pmNW/H6uP8ATrPfz1JjsmK1nfGJiMzs00qxvtmd3DlE+HOJnjHDsana1r2te9rXve02ta072ta07zMzPOZmeczO8zPWXYiIrEVrEViIxERGIiI4RERuiI4YjEM08t2MRj+Z4KJQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAb2i1bVmazXnExO0xMc6zE+ExMbxPWDdO6YiYnjE8Jjsnuk5YbXwztTqdN3cWuidVhidvK7/AO8Y69JnflGbbrtfa8z/AMTaIq4+19EaWrm+zzGjfE+hj/KtO+eHGkzwzGaxERinNjtpRMT1Z6tpzmOU/Gd35RXlGG96PW6bXYozaXNTLSeUxExF6T6MlJ2tSfR3oiJjnEzExLzuvs+ts95prUtS3LMejaO2to3WjwndwnE7mtNLVnE4j35+GM592e9dMKsxicfP98AgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmaxEzbaIjnNpnaIiI8ZnlHt/rsREzOIjMzuiI4zPYyVrExvjn39zUuJ9qdPg72Lh8V1ObaY8tPPT455x9nad80x1+zMU6fbtzh2tk6I1NTF9pzpafH6uP8AVtHfnMaceMTbl1Y3SyU0JnfbMRnhEb5jsmN2J7s5iM5iMND1Oqz63LbNqcts2Sdo3v0rEdK1ryilYjpWsRHPfbnMz6LS0NLQrFNKlaVjfu5z2zbfMzmOMzO+O5sRiu6sdWI3Y889vv8ADlD4MgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwfbT6nPo8tc2my5MOSOXfpPhvH2bRO8WrbpNZiYnrMct4x6ujp69LaerWL1nlMdm/MTxrMdsTE9kk4mJiYznt9/74n3N64X2qw5u7h4jFcGTaKxqKzthvbfb7ddpnFaduc/ax7zM/YiNnn9s6Hvp51NlmdSvGdKf9Sscc1nheOyN1uERFpmGC+hMb6xnnNd+Y3dv54nfwy2+LVtWLUmLVtETW0TExMTETExMTMTE77xPSY22nq4kxMTMTExMTiYmMTExumJid8TE8p4NeYx29k5xnPh2fzKqEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG0z0gTjhvjf47vHd/ObG8S4to+GUmdRki2WY3pp6Tvlvv0nbpSs/ivtHKYje32Z29l2LX2u2NOuKRPpalsxSvbv/qmI/prme3Eb16adrzu4c7cox2/ly554OdcT47reJzalrTg00TPd0+OZ7u3WPK2jacsxynadqRPOtYnnPptk6O0NkiLRH1mrMRnUtEZzz6kcKx8bY3TaW1SlaYmMTaM+lEY48N0xy+O/iwzfWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAU39U/5/wBP7+G4nHfE/H94j8jf/p6PjtuGJxnlHNb6jWaTSV7+q1On0tNt+9qM+LDXbxnfJesbR4z0ZdPQ1taero6OrrT2aWnfUn4VrM/kmKWnOImcdkTPPHZx7pxPcweftj2W0+/leP8AC+Ub/Y1eLLP5RiteZn1REy6Gn0H0vq+p0dtc5x62jekb+2bxWI98wvGhrTw07fDEfGdzDan6TexmniduK21Fo/k0+i1uSZ9l7YKYufh/Ejbxb2l9E+ndTGdjjTif6tTaNnrjxrGpa8Y9j3skbLrT/TEeNoj+e5gs30xdm6TMYtHxbPtvEW8jpsVbRv1iLaqbRHvVieXOHRp9B+lLRHX19i04nl9Zq3tHjMaERPbunDJXY9XnOn+c/tHDjjLHZPpp4fHmeB63JP8A3mqwYo5dJ+xjzT6eUzt4bzu2a/QPaZ9fpDQr7GjqW87U/nJaNitv/wAysZ5RXPu48mNzfTXntExp+z2HHPhObiV80T4c600eCY/K0/6trT+gWnH+r0le3bFNlrT3Ztr6n519y0bDGN+pOc53Vx4f1ftlisv0ydorT/C4fwbHXfeO9i1uW0eP3vrtK9f+T1N2n0G6Lj19p26888X0Kx7o+omY+M/K8bFpx/Vee3fEePCPPKyv9Lvay33a8Lx+7o8kzHPflN9Tadmav0K6Grxttlva16d/2dGvan/B6UTum+Ofpb/yj+e/db2+lftjbfbVaKvPl3dBh5er7Xe/v8OTLH0O6Djjpa9vHaNT/wBPVW/wmjPGJ/FO/wAe3+d+fjP0pds53mOI4K78uXD9DP8Aa2C0f5653vH0Q6C57LqT47TtH7akH+E0Psz+K3zfOfpO7bTyji9a9enDuGbz6Oc6Sen/AK9F/wD8E+gf/uKZ5b9p2vd4Y14wn/C6H2P7rfPd7seaM/SZ22npxrb2cP4V/roZWj6KdAR/+IRPjtO1/wD7wmNm0I4Uxy9a3/2xH0mdt/HjUTEeE8O4V19O8aGJ9Piifon0BP8A+IY8Nq2z/wDeME7LoTOZp/df/wC2Sj6Tu20b/wD1xWd/Tw7hkbezu6Ov5+nxR/8Agl0B/wDcUx//AHW1z568o/wmh9ifxWnznzfSv0o9s69eI4Lb9e9w/Q8/T93BG2/jt+Wyk/RHoKf/AMV1I5btp2j99SUf4TQ+zP4rfN9q/St2xr11Wjt72gwR8kV9vLbmpP0O6Dnho69fDaNSf1db80f4PR7Lfin+eC4p9Lnayv3o4Zk97SZI8d/5NRX+kMdvoX0NPCdrr7OvTsx/VpW/67+KP8FpZ42x2Z/fE+S8xfTJ2ipMeV4fwbJXnv3cWtx3n/xfXb15dfub778+csF/oN0XPqbTt1J776F4+H+HrP8Acidi0uVrxPLPVmO+cTG/du7uLKYPpq1Nf/sjs/gyTPWcHEcmnjf0xF9JqJ8ek2nn0mGnqfQPSn/S6S1Kf/M2aupz5zXW0/jEQrOwxPDUmPGkftMMnh+mnQT5/gWsx+rFrMOWP/jxYPy2iPXvPNq3+ge0xM/V9I6Nvb0NSk+/q31P5v7lJ2K/GNSOHZMb8b+fPnLJYfpi7N3mPK6Li+GZnrGLTZaxv1mdtVW20f8ALWZn1c2rqfQfpWsehr7DfHLr6tJnHZnQmN/faN/HtUnYtTlNO/Mz+Xo+/wD5ZzT/AEn9jM8R3uKX0152+xqNDrqTvPhNqYMuKNvHfJ+cxEzHP1fol07p5xsddWI/q0to2efhW2pW8+6kqTsmvH9MT4TH7zDNYO2XZXUTEYuP8LmZ5xF9XixT+cZZpMb+iY3aGp0H0xpev0btf3dG94900i0T7ssc6GrE4nTtu7s/nG5m9NrtHrI72k1em1Veve0+fFmrMT4xOO9o29fSfBoauz6+hPV1tHV0bc66unfTmPGL1j+cVJraOMTHjExjxzC538Np/t/1/Ln4yw+/z+WP524RMY5xPv78c8c/nwVEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE84mPSDLcM41reF2rXFfymn3jv6fLNprtEzvOO2++K07zzr9mZ2m9bxEQ0tq2DQ2uM3r1NTE41aREW4butGMXiJxunGIzFZrlW9K6nrRieUxEbuO7w398ui8N4xo+J12w28nmj72nyTEZY26zXblkr/zV6fzVrPJ5jath19kn0462nM+jq1zNJzwic762/2z92Zje1b6dq7/AFondExnlymOX5stt/n9f+njtLTY5jHFQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEb3pjra+S9MdKRNrXvaK1rEdZm07REJrW17RWsTa1pxFaxMzM9kRG+UxGZxETM8ojj5S0rivazaLYOF77c4tqr1597p/u+O0b9I3jJePZSY2u7+x9DzMxfa8RwmNKLeE/wCZaOHfWs5jnOd0bVNDGJv34iYjExv357OG7fvndnfDScmTJmvbJlvbJkvM2te9pta0z4zaZmd/z5eDv1rWlYrSIrWIxFaxEREdkRG6GaJxGI4Yxjs4cMeCERt/n5f5unOUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALPU8Q0OijfWazS6SIjeZ1GoxYY6b8pyXrv4dN+v5s+ls20bRONDQ1taeGNLTveffFIthaK2t6tZn8/2j4ZmWp6/6Rux+gm1L8Xx6nJEb9zQYs+sifZmw4500+yc8TPodnZ/ov03tMRauxX0qzOOttN9PQmOGM6epeNWOP8A3eI7cs1dm1bR6kx7UxX8p3/CMY79zVNZ9MvBcUTGh4ZxDWXjfby1sGkxT6PtxfU5I8N98PSeTsaH0F2+8/8AvG17No1/2Rqa94+7NdKsx/8AU8t+WNi1J42rXu9afDlHl72q6r6ZuNZJn6pwrh2mr4eWvqNVePbNb6as/ojnHr5djR+guwVx9ftm1a07s9SunoxPbiJjVmM+1OO9mjYtOPWva3hER85/nw1nWfSZ2y1cztxSukpP/D0el02KI69MlsWTPHX/ALb+/N1dD6KdB6O+dknWndv19bVv/ZF66e/n6Hdw3MsbLox/Rnx/4w1zUdpO0Gr3+s8b4plieU1trtR3Zj0TWMkRMT6NtvU6ml0V0bo4+q2DZKYxiY2fSmYmOE5mszndxzlljS068KUjnurHyYe9rXtN72te89bXmbWn22mZmfzlvREViIrEREboiIiIiOyIjdC6KQAAAAAAAAAAAAAAAAAAA/z/AD/PAMfz354cN3bxNv8AOX9enUFa2tWYtW01tE7xaszExPpiY2mJ9iJiJiYmImJ3TExmJjsmJ4jMaftFx/S7fVuNcUwxXpFNdqe7G3orOSax4+HjLS1ei+jdbP1uw7JeZ3TNtn0sz4zFcypOnpznNKzntrDYtH9JXbLSTWJ4t9bpXb+HrNNpc0Tt42yxipqJ8d/43Pf1RtzNb6K9B62Z/wAH9Taf6tDV1tPGeUV69tOI+53cJmJxzs2jMY6uI7pmP3/nNs2l+mXjmOa/W+GcN1Nf5vJTqNLafZM31FY/Ok9d/DZydb6C9H2z9Tte1aU8uvGlrRHjEV0pnG7+qPHmwzsOnPq3tHjiflz/AC3d7atF9M3CMsRGv4Vr9Jedt/q98Osxxzjf7Vp0uSfHpi8PW4+0fQXbqTP+G2zZtav/AItdTQvPdisa1d/bN4x3434p2K8eras+O747p+P5Q2rQ/ST2P11ox14tXS5LdK67Bn0tY9PezZKfVq+yc+/o36ORtH0V6b2eJtOxzrVjns+pp6szx4adZ+tn/wAv3wxW2XVrHqzbnMxjER8c5bdpeJcP10b6PXaTVRPT6vqMObl/+jvbr1j1exxNbZdp2fdr7PraM8/rdK+nv+9WP54ww2pavGsx4r1gUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAASpa+O9clL2pes71tW01tWeW01mNpiY25TE+MotEWrNbRFqzGJiYzExziY4TnvPh/PP3t04V2qmsVwcTibRyimrrE96I5RtmpEc4iP56xFt4+1W3O0cHbOh851NkxE75nRmd3/07Twnn1bTiM4i0YiGHU0c5mm7O+azwmd/Ds7Izu74bvTJjy0rkxXrkx2jel6Wi1bR4TFqzMT+UuBatqWmt6zW0bpraJiY8Yne1pjE437uOf5801UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG2/QGN4jxfScMx75775ZjfHgpMTlvPOYmY3+xXefOWiIiOUd6eTb2XY9ba7Y064pExFtS3qV7d/8AVaI39WN/DOM5ZaUtbMYxiYnrTwjfHx92fDg5vxPjOs4peYyT5LBFommmpafJ17vSbz1y3jedrWjlvbuRSJ2ep2TYdDZKx1Yi2pjFtW0ZvOeMRyrXhGIxmMTPWne2a0rWN2+08bT5RHKOE4YiN9ucbS3FlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/n8+Kk2iI3mdo233nlG3pn1R4+jrOxiZ4Rnl754QnE7u/hz/k93Fr/Eu1nZzhG8a/jGhxZIjecFM1c+p/PT4PKZoifTNIr63T2XobpTbcTs+w7Reszj6y2nOnpf8Am6nVp7otM9zJXR1b46tLYnnMYj4ziGicS+mDs/potXh2l13Esm+8TaldHp//AHmWb5onnM8tLtO3O28vQ7L9COktXE7TrbPstZ4xFra+rH3KRXT3xn/ts8MxubFNj1JjfatYmPGd/Ldjs7f3aRr/AKYuPZ4tTh+g4fw+LRMRkvXJq89Ou00m9sWDfx2vp8kb+G2+/f2b6D9Hacxbado2naZjjWJpo6c90xWLamMbvR1Kz4M9Ni06zm1rW37uUfvPZzaZrO2/azXRaufj3EIrbeLV02WNHWYnrWY0lcETWek1nltMxttyd3Q6A6G2fE6fR2zTMcJ1afXzExzidedTEx2xiefFnroaVeFInfnf6Xhxzwave18l7ZMlrXveZte97Ta1pnnM2tMzMzMzMzMzMzM85deIisRWsRWtYxERERERG6IiI3RERwjhHJliIjdEYjshFIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArW1qTFq2tW1Zi1bVmYtWYmNrRMTExMbRO8Tvy5ExExMTETExMTExmJiY3xMc4nhid3aY/6Nm0XbTtVoO7Gm47xCa1+7j1GedXjjbpEU1UZqxEeiI29XKNuTr9A9D7TMzq9HbNm3G2npxo2nv62jOnMz3zOeG/dDFOjpW46dfhjyw3Th/0w9oNPFaa/R8P4jWNotkimTSai/hM2titfTz4cq6anTnO08uDtP0I6N1Zm2za+07NM5xTrV1tOvZEReI1MeOrM97DOx0n1bWpzxutETv3xmM+XBu3Dvph4DqNq8R0Wu4feZje9K49bp43233vScWeOe8xEaa3LnNt42ngbT9B+kdLM7LtGzbTXfitptoanh1bRfTnxnVrv5c2vfY9WMzW0XjvnEz8d358vc3rhna7s1xXaui4zosmS222HLljTaiZnlMVwaiMWW209ZpW0RvHPbaZ8/tXQvSux79o2HaK0j/tKUnV04jtnU0pvSud84tMTx3Ne2jq09alvGIzHxjP8x2tkiYmItExNZjeJiYmJj0xMctnKmJjdMYnsliVEzExx3AgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABk+HcX1nDL74L9/DM97JpskzOK87bTNfHHeYiI79ducV33iJhqbVsWhtdcalYjUiMV1a7r18cetWPszE4zMxiVbUraN/xjOfyxmO7OJx24dI4ZxnScVpE4r9zPWu+TT5Jjyldt4maf8AaY4mOV6dImvfilp7ry217Dr7Jb069bTmcU1a76znfGedbY5TjniZiMta+nNePDdviMRM885nETGY7OM4zG+Mrtt1abEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAry23mdo2nn4R/kdfRHPfnEHHgyRWOrnM8Jnu/f5tN4t2px4e9g4ZNcuWN4tqp2tipO8xtiiY/iWjb78xOKOW3lOcR3Ni6ItfGrtUTSnGulwvbdExNp/ojf6vrdvV55a6E5mb8InfXO+eyc8on4xuaHky5M2S2XNe2TLeZte9pmbTaec7zPr6eERyjk9FWldOsUpWK1rGKxWMRER2R/JbExjdEYiOEcMRO/GOXf3oLIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJ5f5/m/sjmfz+f8mM/9YjzY/X8V4dwvF5fiOu0mixTv3banPjxd+Y8McXtWb2/5aVtPqhs7Pse1bXf6vZdn1tovuzGlp2v1e3rdWJisR9q0xC9dO9pxWtpnsiJ/Plj3uf8V+lnszoJmminVcWyxvz0uLyWnrMTttbPqZxTMT1i2HFmrtMc93pNj+hnS20R1tf6nYqZ3RrX6+rMdsael14jwvfTnu5tmmx6lt840/anrT8K7vjLnnFPph47qptXhmj0fDMUxtF797W6nf8AFF8kYsFYmJmO79XtaOsZHptk+hHR2lETtevr7XfPCsxoaWOzq162pMx2/WxE/ZbFNj06+tNrTz34iY7MY4fu5/xLtN2g4vM/7R4vrtRWZ38j5e2LTxPpjT4Zx4In1xj3nxmXpdl6J6N2LH+G2LZ9K0f9p9XFtX36t+tqT+LDYrpadIxWlY58Mz8ZzP5sE6DIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAbR/n+f5z9Ifn4+TNcN7R8e4RaJ4dxbXaWInfyVc974Jmd/vafLN8F+s7d/HO3hs0Nq6L6O22Jjatj2fVmYx150qxqRjs1axXUr7rRnnljtpad/WpWeWcb/AIxvdA4X9L/H9JMV4lpdFxPF/NaKzo9TPPrGTF38E8usTpd5mI+3Hj5vbPoT0brRnZdXX2S/KJmNfSx2TS/V1PfGtiMzPVnLXvsenaPRm1Z344TG/u3Tjuif+eh8K+lvs1rrRj19dVwnLMR9rPj8vpptP8sZtNOTJHp72XBipEdbcnmds+hfSuzxNtnnR2ykctO/1erEcczTV6tZ7MU1L2meEcmtfY9WsZjF+6OPwn5+GZ3Og8P4xwvi1Jy8N4ho9bjrMd6dPqMeW1N/+0pW3fxzzjaMlaztvy6PNbTsO2bHfqbXs2ts8z6v1unekWxx6szXq2iJ3ZrMxmY3te9LU9atonfnMbvdOI97JNVWcZ3Zx38QQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAljvfFeMuK98eSs70vS01tSd994mNp335/wBuiLRW8TW9YtW0YtWYiYmOGJiYmOCZ38YieWJ4YxjHhj397eeEdqa320/E5il9+7TVxHdpbfblnrH3bbzyy12pMbRatdpvbz+3dDzXOrskTasxmdHPWtG+fUndmIjjWZm0YnEznqxr30edd/8AtzEbu7Mb+yImc8MZ4N1iYtWtqzFq2iJrMTvExMRMTHpiazExMbxO8Tu4MxMTMTExMTiYndMTHGJjlMNeYxndO7jmMY8eP7CEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALbV6zTaHDfPqssY8dYnbeftXtHStK9bWnwiI9czFd5jLo6GrtF409Kk2tPHsrH2rTwiI5zPhGZ3L1pa3CMzunHdPPw555eXOeL9oNTxGbYcUW0+k328nEx38sdN81o23jxnHG1Of2u/aIl6nYujdLZYi98amv9uY9GnPGnE8J4enMdbs6sTMNqlIrv4zjGeyOyPDfvmM75a86S4AAAAAAAAAAAAAAAAAAAAAAAAAAAAACm/T1+qfb/kBjj3f9GJ4nx7g3BqTbifEtJo9q9+KZcseWtXeedMFO9myb7TERTHaZmNoiejd2To7btut1dk2XW19+JtSk9SJ/3ak4068YmZtaIiN87mSmlqX9Wk2jtjx37+Hvnd73MuKfTHwjTxfHwnQ6riOSszWubPP1LTTP44i1cmotWPvVrbFhm0cp7k7THq9j+g+3anVttu06OzVnEzTT/wA/VjhunE10qzMZjMal+rOJxaG1XYrzjrTFY5xHpW+MREf88c7nM+K/SZ2s4pW+Kutpw7BflOLh2KMF9v8A85vbLqq7ePk81Ined4nk9Zsf0T6G2Sa2toTtWpXfF9qt9ZXMb/8ASrFdGd/2tO2J4TENqmy6VJz1ZtPbaY7OURiPjGfOdFz6jUarJbLqc+XUZbdcmbJfLkn23vNrdd/GXodPT09KsU0qU06R/Tp0rSsT3VrERwiOXkzxERwiI54iMPiukAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB9MWbNp8lcunzZcGWv3cmHJbFkr6dr0mLR+UwrelNSs01KU1KTxresWrPjW0TE++JRMRPHfG/c3nhX0ldrOFVri+vxxDBXpi4jT6xaI9EaiJpqto5RFbZ5rWOVYh5/bPot0Ntkzf/DTs2pPG+y2nSifHS9LRzzmY04tM8Zlgtsujbf1erPbXMcuzMxx3/zLpnCfpk4XmrSnGOHarQ5eVbZtLaNZp/fmk+Tz467zzrWue0RHK1+UPJ7Z9Btr05tbYtq0topGZrp60To6vsxaOtp2nHCZtpxM8oy1b7FaPUtFuyJjE475iMTO7jP/AC6dwvtDwTjVYnhnE9Jq7Wr3vJY8sVz1r4zfT5O5npt4xfHWY3jfbeN/J7X0Zt+wTMbXsmtoRE469q505nOPR1a9bTtmeHVvMTyzhqX09SnrVmO/G74szvH+ePs9P5NFQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABneEcf1PDJrjv3s+jm328Np3tjjxnDM2+zPSe5O+O23Skz3o5229HaW1RN4/y9aI3XiN1p4xGpG7PZ1vWjtmIiFb6dbxPK04xPv57t8fDt5RDpGj12m1+GM+lyRenLvV6Xx2mN+5kpM71tH5xMfarNq7Wny2vs+rs1509Wk1nlPGto5TW0bpifjHCYiYmGrelqziYnxnn355xG7fOMRjMQu2FjAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAViJnlAtWsWz3f8ALCcW43puF17kTGbV2jfHgrO3d9F81o38nWY5xG02ty7sbd61ehsXR+rtdotv09GJ9LUmOPbGnE461uUzmK15znETeulNpnlWJ4zxmM8vnjH5ua63X6riGac2qyTed7dynTHirO32MdfCvKOc72ttE2taeb1Oz7Po7NSNPSrFY3da3G15iMda1uc/CIzMViI3NqIisYiP5/x3bu7is2dIAAAAAAAAAAAAAAAAAAAAAAAAAAAAC01mv0XD8U59fq9No8Mb75dVmx4Kco3mItktWJn1RMz4bbs2hs+0bTeNPZ9HV19Sf6NLTtqW+FYmYjvnctWtrzisTM9kRn+fyZ3OX8a+l7gOjpfHwnBqOLaiJ2raazo9HExO29suWs6i23K1YpppreI2nJSJiZ9bsP0K6R15rbbNTS2PSmMzWJjW1/CKUmNOOyZtq5rxituDbpsd5xNp6kT35tHw3b+2ZiOW/MS5Vxn6TO1PFpmuPV14Xp53/gcOrOK1vROTU3m+ptaI5fYyY6Tynye8bvY7D9FOiNiiLW0Z2zVj/tNqnrxHdXSiK6URnf6VbW4+ljc26bNo13zHXntvv+EcO/ON/FoWXLlz5L5c2TJmy5LTa+TLe2TJe09bXvaZtaZ8ZtMz6+j0VKU061pStaUrGK1pWK1rEcIrWIiIiOyIwzxERiI3RHKIiI/nhhBZIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACWO98V65MV748lLRamSlppetq7bWrau01tG3KYmJjwmOSLVres1tWLVtExatoi1bRPGJicxMTziYwiYid0745xMRMT457G98H+kjtTwi0VtrY4np45Tp+JVnUbf8ANXURampraPDfNanjNJee276LdD7bEzGzzsury1Nln6vt3TpTFtGYzxxpxblFoYNTZtK/9PVmZ413cp5b45dkftPVuDfS/wAE1da04xps/Cs8zETkpFtZpLRvt3u/jpGopO3OaTp7xWI28raXjtu+hO36MzbYtXT2zT3zFbTGhrxuzjq3n6q3Z1o1azP2Ial9jvHqTFo+E926d2/fwnwjt6fouJaDiWKM/D9bpdbhmInymmz48ta77bRfuWtNLc53raK2ieUxEvI7Rsu07LqTpbToauhqRnNdWlqTOOcdaIzGN8TGYmN8TiWpatqzi1ZrPZMY/n87F7E7/wCeqJ5/1YJ3fzj4KqgAAAAAAAAAAAAAAAAAAAAAAAAAAATzBdaPW6jQZoz6bJNLxt3o60yVifuZK77WpPo5TEz3qzW21ow6+hpbRpzp6tYtWeH2qz9qs8az3xx4TmNyJiLRi0Z7M53dkx2THJ0nhHHtNxOK4rzGDWRXe+G0/ZybTzthtP39+s0na9ecfarWbz5bbejtXZJm9c6mhM4i+N9c8tSI3RPLrR6M7s9WbRVq30prvjM17YxmJ5Zjzx47uDPTG35+Hoj1+vffl4OcxKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAr05z02neZ6RvvG8+jbqJjjHu5Z493Pjy3tN412mpii2m4bat8vOL6qNppjnxjFHOL3ieU3nekR0raZ3jubD0TOpFdXaomtONdLfFrRym/OsdlfWnniOOxTS4WtmN0ejG6Zx2793bw7uOWg3tbJa18kze9pm1rW52ta072tMz1mZ5zPjL0dYisRFYisVjERG6IiN0RGOEYZ/23R4d3cokAAAAAAAAAAAAAAAAAAAAAAAAAAAN4jfeYjbr6vaYnsMT2d3v7Gmcc7edmuAzlx6niFNVq8e/+46GaanUReu/2Mk0tGHDaZ2ia58uO0RMTMbTG/d6P+jvSvSPUvpbNOloXxjaNozpaUxP9Vc1m94xwnTpaJmJxPZn09DU1MTFcRPO26PCOeZ7Yxx3Y3Z4/wAb+l7jWsi2Hg+mw8KwzvEZr7avW2jedpi16+QxbxtvEYslonnXJG2z22wfQnYNDq327V1NsviM6df8nQiee6s/WXxymb1iedW7TY9OuJtM2nsziOP54+E83LtdxDXcTz21PENXqNbnv1y6nLfNfbntWs3me7Su+1aV2pWOVaxHJ67Z9m2fZNONLZtDS0NOvCmlStIzuzM4iOtacRm1s2njMzLarWtYxWsVjsiIjyWbOsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAbR6AXWj12t4fnrqdBqtRo9RSfs5tNmyYckemO9jtEzWelqzvW0crRMTLDr7PobTp20do0dPX0rcdPVpW9Z78WiYiY5TGJid8TEq2rW0YtWLR2WiJj84l0/gn0ucc0O2Li2HFxfBvzy/Z0usrHKPOY6+RyREb8rYYvvt/F2juz5PpD6F9H7Rm+xal9i1OVN+ts8/cvP1lZmePV1JrH2MzlrX2PTtvpM0mOG6JrM8eHHu7O52Hgf0gdmeOzixYtdGi1eTaI0fENtPlm8x9zHkm1tPmtM/drjzWtaNvsRaJrHiOkPo10t0f1r32f6/RrvnX2bOrSKx/VasRGrSIj1pvpxETnfMb50tTZ9WmfRzEc65mJ93d4cInLdYmJjeJiYnpPhPs9Mc+scnAmMcf549jXx/P55KgAAAAAAAAAAAAAAAAAAAAAAAAAAArWZratqzNbVtFq2iZi0WrMTExMbTExMRtO/KYhExFomtozWd0xO+JjsmOExvnd3z2ndO+N+7x8W9cF7URaKaXicxF94pj1c84t6K595iIt/LGSKxE8u/EbTkt5/buicdbW2WMxxto844ZnT7Y4zNZnP2ZnMVjFfSjfNIzHHERwzxmMzu7MduMdjdd4nnE7xPOJ9MeEuBw4tWY3z/wBP+nh27uIIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfPLlxYMd82bJTFixx3r3vPdrEbxEc/TMzERHWZmIjnMLUpfUtFNOs3vacRWsZmf5znhEb53JiJnERvmZxjn4+DnXGu0eTXd7TaObYtJzre/3cuo8d7TG00xTE/c3m1o+/O32K+o2Houuz41dfF9fjEcaaXdj+q8fa3RH9MTutO3TTisRa2JtuxjhGOOe2Z7eP5NYdZlnujEfzmCAAAAAAAAAAAAAAAAAAAAAAAAADoD4Z9Tg0uG+o1ObFp9PijfJmzZKYsWOvL7V8mSa1rHOOs8vTvyZNPS1Na9dPS076mpecU09Olr3tPZWtYmZnjwjlKYiZmIiJmZ4REZmfCIcv499LXAuHTbDwnHk4zqYiY8pjmcGhpeJmNrZ71nJm223mcGK+O0bRXNvMzX1vR30M6Q2rq6m2WrsOlO/qWj6zaLRu4adZ6tM8P8y8WiYnOnwztaex3vibz1K/G3w5cfNxjjnb3tLx6Jx6nXW02lmZ/wBz0He02GYnflktW0588bTt3c2bJTlvFYl7vo/6O9FdHTF9LZ41daP+32jGrqRPHNYmI09Oc89OlZ5Zlv6ez6WnviOtbGOtbfPu5R7oabt/nw/p4O4zYj+eXh3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKfD0f8AWd+f9AbdwPtx2k7Px5PRa++bTct9Hre9qtNG34IvaMuCJ3nvRp8uLvTO9t5iJji9IfR/orpKZtr7NWmrOf8AP2fGjq7+dprHU1Jjl9bS+OWGHU0NPU41xO/fG6d8Y97tHAfpc4LxCceDjGHJwjUzWInNvOfQWvtO/wDErEZsEWmImsZMdqV6XzcotbwvSP0L2/ZuvqbDeu26UTMxp/6e0RXlHVmfq9SYicTNb1tbjGnGcRo6ux6lczSevGeEbrRv3buE9+MeGHU9Nq9NrMGPU6TPi1Ony172PPhyUy4r15xvXJjm1Z2mJiee9ZiYnaY2nx+ro6uhqW0tbT1NLVpOLaepS1L1nsmtoiYzG+N2/djdOWrNZrOLRMW4YmMT8J3+/GOHuuGNUAAAAAAAAAAAAAAAAAAAAAAAAAABsfBu0Wfh8xg1Pez6KeW0T3suDnG045n71Nuc4pmIjl3Jrttfl7d0Zp7TnU0saevuzPCmpy9KI4Wx/XiZnHpbt8Y76cXzjdacYzO7dnjjG/sn3YdIwZ8OpxVzafJXLivzrek7xO3KYnxraJ5WrO1qzvExEw8tqad9K86epWaXrxraMT3T2TE8YmMxMb4mYalqzWZiYmJjjmMfzm+qiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFprtdp+H4LajU37tY5UrG05MtuUdzFWZib2589uVY3taa1iZjPs+z6u06kaelXM/1WnPVpH2rTjdG7dzmd0RMzELUrNpxEdvGMxG7n/Pjwcw4txjVcVy/bnyWnpMziwUn7Mc42tflEXyTH823drzrWI6z6zY9h0tkruiLasxEX1ZjfPbFYnPVr3cZxEy3KUikYjfPOe/EZx3Z4MTHSNm7PGcrAAAAAAAAAAAAAAAAAAAAAAAAAALLXcQ0XDcFtTr9Xg0mnpEzOXPlpirM7TPdr3pibWmImYrXe0zH2YmWfZ9m2jatSNHZtDU19SZxFNOlr24xG/ET1YjnacREZmZwvStrTEVr1pzvjE93HEbo8efLjnj3H/ph0uKLYOzuknV5ImYnW66l8WniI6Ti03erny79d8tsHd2iZpbeYr7fo36Ea15jU6T1o0azET/h9nmt9XM8r6uJ06RHZSNTOZiLVxEzuU2OZnOpOIxHoxiZ987sY5zxmNzi/GO0XGuPZZy8V1+fUx3u/TDN+5psU7bRGHTUiuHHFa8otFO/PObWm02mfd7D0ZsPR1IpsezaejuxbUiOtq35z19W2dS2ZjOJt1Y5RERERu00qafqViO/jM8eM8efOWFb7IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAy/CeO8X4Fm8vwrX59HbvRa9KW72DLt4ZtPeLYM0erJjt15bTzaW29HbD0jT6vbNm0teMTEWtGNSkT9jUrjUpO7+m0dk7lL6dNT16xPZPCY8JjfHx83Zuz/0w4snc0/aLR+QnaK/7Q0NbXxTPSbZtJMWyUiI597BfL3t9owxy38L0l9B71zqdGa/1kb5/w20TWt+6NPWiK0tMzuiupWkRG+dSWlqbHOc0tExHGLRv+Mcc9+/e7Jw7ieg4rp66nh2s0+twTFf4mDJW/dm0b93JWPt47dd6ZK0vExMTWJh4fatk2nY9WdHatDU0NSM+jqVmucTjNZ3xavDFq2tWYmJi0xLSvW1Zxas1nnExj957l+1lAAAAAAAAAAAAAAAAAAAAAAAAADaPR/n+TIMpwzi+p4Xl72KfKYbzHldPaZ7l+nOJ5+TvEdLxHqtFo+zOptexaW2UmLR1dSI9DVjHWr3Tn1qzzrntxid6tqVvGJ4xwndnn2xw7s/8dP4fxHS8SwRm0999uWTHO0ZMVvtfZyR4b7TtO8xbb7MzHTyW07Nq7LqTp6sezaMzW8dtZx8YnExzhqWpNJxOOEzE79/dntjsnymF611AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFYjedvb8BMREzvnDE8V4xpuFYd8k+Uz5InyOnrMd69to2taY3mlI353mOXOKxaZmrc2PYtXa74rHV04mOvqTG6sdkfatjOIz4zGYzl09ObcpiInfM7t2PVjtmeW7fv7MuYa7XaniGe2fU5JvaZmKVjlTHSZ3ilK84iscuf3rTHetMzMzPrdn2fS2bTjT0q4jjaZ32vbna085n4RG6IiIiGzWtaxisYj889szz9/Dks2dIAAAAAAAAAAAAAAAAAAAAAAACkzt/p4cxPb3R8Vlr+JaHhWmyaviOrwaPT44mbZM+StInb+WkT9rJkt0pjxxa97bVrEzMQ2Nm2XaNs1a6Oy6Opr6tpxFdOk2mO2ZmN1axG+1rTFaxmZmIjK1aWtMRWJtM8MR3c+GI8cbt/Y4t2i+mCkeU0vZrS977M1/wBpa2ndit55d/T6OJ3tMRtal9RMRNo+3p7Vja3vOjPoTM9XW6V1sb8zsuz23zHZq6+7Gd8WrpRM4ndqxPDd0tjmd+rPHE9WJ38cz1pmN2e7f3uL8T4vxPjOf6zxTW59bm2mtbZ796tKzO80xY4iMeKkzzmmOlK789nutk2LZNh0/qtj2fS2emczGnXE2mP6r233vbG7rXtacc29WlaRisRHhG+d2N88WObSwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC/wCHcU4hwnURq+G6zPotREd3ymDJNJtWZiZpkrzpkxzMRM48lbUmYjes7Nfatk2bbdKdHatDT19KZz1NSsWiJjdFqzxraImYi1Zi0ZnE71bUreOresWjsmPLsnvje7R2d+mDni03aXSxMd2KzxLRUiLTaNojJqdHG0c+c3vppiInaKabafs+D6U+hEenrdFau/Of8Jr23Y3z1dLXnfu4VrrcvW1s8dLV2PMZ0p+7M/vPdujPxxw7Tw7ivDuL6amr4brMGs094iYvhvFprM7fYyU85iyV3+3jy1pevLesPCbVse1bFq20dq0NTQ1K/wBN6zETH2qW9W9Z5WpM1nlLRvp2pMxaJiY7vz7Md+Z9zINZQAAAAAAAAAAAAAAAAAAAAAAAABdaPWajQZ66jS5Jx5K9Yj7uSu8TNMld4i1Lbc4nn0mJraImMWvoae0ac6erWLVnh21nfi1Z4xMZ5d8TmJmJTEWjFomY8d8dkx2THjjdwdP4RxnTcWx7VmMWppERlwWned9+d8UzP28e8zvO0TWdq2iJmJnyW27Dq7Hff6WlafQ1I7OUXj+m3dwnjG7hqalJrPbXO62/OJxiJ4zunxzvmGXnl/b+8btFjmMTj+fzzBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAca47h4XWcOLu5tbav2aRMTXFvG8XzeO+0xalI2m0RE71rMXnpbB0dqbXPXvFqaFZ32xvvid9aZ+E3n0az2zuZtPT607/AEa7ondO/fviM790xv47873M8+fNqct8+ovbJlyWm1r2neZnpyjpWsRyrWu0VrtERHR6vT06aVK6enWK0rGIrH8zMzO+ZnfM75bXDdHLhj+ZfJcAAAAAAAAAAAAAAAAAAAAAAAAxM8IyttXq9NocGTVazUYtLpsNe9lz571x46V6b2veYiN5mIrHWbTEREzMROXR0dXaNSmjoaV9bV1JxTT06ze9p7IrEZmYiJmeMRXMziImYtWs23VibWnhER/M+7/hxntL9Lunw+V0nZvBGqyx9n/aWqx2rp6Tvztp9PM1y5piN4rfN5KkW2t5PLTlb3PRX0K1dTqa3Smp9VTj/hdGYnVnsjV1d9KR21pF7Y3daluG7pbHM79SZrHDqxO+Y55nlnu5R3uI8U4zxTjepnVcU1ufWZp+75W8zjxVn+TDijbFipE7z3MdKVmZm0xNpmZ+gbHsOybBpfU7Hoaehp84pX0rz9q95ze9uXWvaZxuzjc3qUrSMVrER3c/FjG0uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAv+HcU4jwjU01fDdZn0eopMfbw3msXjr3MlOdMuOf5seWt8do5WrMNbatj2bbdK2htWhp6+lb+m9YnE/apb1qWjlak1tHKVbVraMWiJjvdu7NfS9TJOHS9pdPGG07UniekrM4p8K31OljvXpM/wA98E3rvO8YKVidvA9K/Qm1YvrdFak3iPSjZNa0RfvjS1pxW2Jx1a6kVnGc6kzho6ux8bac53+rO+cePPf2++Z5do0Wu0fEdNj1mg1WHWaXLE+Tz6fJXJjtMTtaN6zPdtS0TW9J2tS29b1i0bPCbRs+vsurbQ2nS1NHVpjraepWa2jO+JxPGJjfExmJjfEzDRtWazMWiYmOMTGMRPDt47t/CO/MLvePSwqgAAAAAAAAAAAAAAAAAAAAAAAPpizZdPlpmwXtiyUtE0vTlasx/buzG9bRMTFonaY2mVdSldWlqakReloxatt8TGc+e/O7E74nJumJiYiYnjE/D+d7pPBe0GLiNYwamaYtdERERyrTUbV3tfFvO/lOW98fPaJm1ZtEWinldv6Nvsszqaeb6EzO/EzbS37ov2134i+7M7pxOM62rpYmbV31xnO/dPZPwnEzvnnylsblsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABtv8AEIjO5q3He0NNDFtLo7Vvq+l8m0Wx6f0xPPu2y+ik7xSY3tE/dt2OjujJ2jGtrxNdHjWvC2r2Y5xTvjfb+nEelGfS0ptObbo5Rv8AS8N2cT+e+HOr3vkvbJktN73mbWvaZta1pnebWmZ5zM77zO8+vm9PWta1itYitaxERWIiIiI5RjhEdkNndEYiN3lx+PjO9FIAAAAAAAAAAAAAAAAAAAAAAAja1aVta9q1rWs2ta0xWtaxvM2tMzEREREzMztER49UxE2mK1ibWmcRWImZmZ4YiN85ndGExWZ4b/PnujtnuhyrtP8ASpwnhXldLwaKcW19Ymvla2tHD8GTfb7eWsxbUzXrNNPPk5n7M562i0R7Don6H7ZtnU1tum2xbNM56kxH+J1K43TWk5jSiZ3RbVjrRHpRp2iYmdvS2S9sWtMVr2YzMxzxmN3ON+9wLjnaPjHaLUeX4rrMmfaZnFp6z5PS6feJj+Bp6z5Ok7TtN5i2S/XJe0830fo/ovYejNP6vY9npp5iIvqT6Wtqf/M1Z9O2/f1YmK1/prWNzoU0qacYpWInGM8575nj+bBugyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMxwXtBxfs/qa6rhesyae+++TFE9/TZomIia59PfvYssTHKJtXv15TS1LRFo0dv6N2LpLSnS2zQpqxj0b+rq6c78Tp6lcXpMZ4RPVnfFomJmFL6dNSMXrE9k8474njE/lPN3vsv9K3DOJeS0nHK14XrbRFPrXetPD814jaJm1t76SbzvPdzTfFE9c+8xWPnPS30O2vZevrdHzO2bPEzb6rERtOnXsxG7WivbSK3nlp8Zc/W2S1Zm1PTiZ4f1fCMZ4TnHHi61TJTJSuTHat6XrW9L1mLVvS0Rat6WrMxatomJraJ2mOcPG2rNLTW0TW1ZmtqzExNbROJrMTETExMYmOUtOYmOPfHvjjE9nvTVQAAAAAAAAAAAAAAAAAAAAAAArEzS0Xraa2rMWi1Z7s1ms7xMWjaYmJ57xPLb2omItE1mImJiYmJjMTExiYmJ3TExxjG/O9OYxjG/nziY8J8f5l0LgXaKurimk11u5qfu4ssxtTPG0bVt4UzT64iuTw2t9mfNdIdGTo9bX2eM6XG+nGZtp8ZmY5zSOfGa78z1d7W1NLHpVzjnGc47Z7ZiffMd/LbfT6pmP6OK15/n88wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGncf7RRgjJotBeJzzvXPqKzFowxt9qmKd53yx0tbafJ9I3vO9O50b0Z9Z1dfaaz9XunT0p3Tqb8ZtzinOI3Tbjw3W2tLRicWvmI5VjfM+PtRmOyd/Lc0GZm0za0za1p3taZ3m0zMzMzM9ZmZmZnxmXpIiIiIiIiIjERG6IiOERHKIZ54zw905hQQAAAAAAAAAAAAAAAAAAAAAABHGGndpe3HA+zNJpqc/1nXzWZx8P0tqX1G8dJzzvNNLjtO0RbLEWtG846ZO7MR3Oivo/wBIdLWi2lp/VbNmOttWtE108c/q4461o+zTdE7r2pln09C+piYjFc+tPDHDdxnOe7HHfwh507Tdu+O9prWxZ831Ph/SOH6S1q4bRvExOpvP29TflG/fmuKsxvjw0tMzP07on6O9H9FRF6U+v2rjO1a0RN6z2aVd9dGu+fVzeYnFr2iIx0tLQ09KM8Z4za0RmJ7o/p8+9pbvM4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADcOzXbjjnZi9aaXP9Z0Ezvfh2qm99NtM9604dpi+myTO897FMVm3PJS/SeJ0r0B0f0tWba2n9VtGI6u1aMVrq7oxEamYmNWscOrfMxG6tq8WHV0NPVietGLfajdPv5T4T34xl6I7MdveCdpq1xYss6LiXdrOTh2qtWt5tP3vquXaK6qkTExHciM0V2vkwY4nl8x6W+jnSHRUze9Pr9l61ortWlEzWIicx9dTjo2mMR6UzTO6t7zE55urs99Oc4zXf6UcI44znh27/BvDgNcAAAAAAAAAAAAAAAAAAAAAABTpziZid+9vHXeOkx7NomNvQnjunE8t/j7vzG+8A7RRkiui4jf+JG1cGqvMR3/RTPa0xHf8K5OXf5Rbe3PJ53pHovq9bX2avo8dTRrGerw9LTiMzMcZtXjX+mMZiuDU0o9asc560Z3+MR2fHnung3RwGsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0rj/aOKRfQ8Pv8Ab50z6mltu5znvYsVt/vRtMXyV+79qtd7d6a9/o7ovPV2jaqzEbraelMetwmLXjsxOa0nGeNt2InZ09LGJvHbis9/OfGOW/Mc+GNE5+M7+ueu/reh/LybE4xzznPdEfzG8EAAAAAAAAAAAAAAAAAAAAAALDiPE9BwjS31vEtVi0mmx/ey5bbRMz0pSsb3yZLdK48dbXtPKtZbGy7JtO261dDZdG+vq24UpGcRHG1p3VrWOdrTFY5yvWlrTFaxMzPKOXjPCMzu48d04lwHtV9LGt105NH2crk4fpN5rbiGSKxr89YiYnyNd710uO0zvW0TOomO7PewT3sc/SOh/obs+z9XX6Umu063GNmrMzs+nOYmOvMxE61ojdMTEaUZmOrfdaOho7JFYi2p6Vsbq/0xM9u7OcREfHdwceve+S98mS9smTJab3ve1rXva0zNrXtaZm1rWmZtaZ3mZ3mZnm9vWtaVrSlYrWsRWtaxEVrEboisRERERERERG6OTdiIiMRuiEUgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtbWraLVtNbVmLVtWZi1bRO8WrMc4mJiJiYneJ5+CJiJiYmImJiYmJjMTE7piYndMTHGETGeO+OycYdc7K/SrxDhvc0fHvK8T0c2pWNbv3+IYK9JnJa87aysRtP8S1c/K0+VyTMVjxfTH0P2bautr9HdTZNfEzOhjGzak8cViImdCZ3+rFtPfEdSsRMtXV2Stt+nPUmJz1f6Z57ojGPd2vQPC+L8O41pKa3hmqxavT33jvY5+1jtHXHlx22yYslfGl61naYtEd2Ymfm217FtWw61tDa9G+jq1xuvG60TwtS0ejes78WrMxumM5iXNvS1JmtomJjt4d+J4TGc4x397JNVQAAAAAAAAAAAAAAAAAAAAAABu3AO0Pd7mh1+T7MbV0+pvb7vSIxZbTO0V8KZJ6cq35bWjgdI9GTPW2jZq5mc21NKI3zMzvtpxHPnNOe+Y37pw6mlnM18ZjG7HDOIid/d3zjfO/ev/Kf684eea0xicAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADxaL2h7Q79/Q8OyfZ501GprMbzMRMWxYZ9G+8XyRO8860nbe0+g6N6N9XaNprv46WlPLsvqR2/ZpOMTvtndDappRGLTHZMRyjO+JzO/hvx/wBI0iI9vWZ8fGZ8Pz/683oGZUAAAAAAAAAAAAAAAAAAAAAFJ33j+/8Am8fCRMRn9u2Z5cu1zXtZ9JfCuATl0eg7nFOK179LYsd/900mSvL/AHrPWd7WraZ30+GJvvS1cuTBM1m3q+hvortnSUV19o62x7HM1mLWr/na1J3zOjpzGIrMcNXUxXfE0rqRnG1o7NbU9K0TWnbOJmeHCPzzO7fG6cS858a4/wAV7QaqdXxTV5NRfefJ4t5rp9PWf5NPgifJ4q+nux3rz9q9rWmZn6fsHRux9G6MaOx6NdKv9VuOrqT9rU1J9K89mZxWN1YiIiI6VNOmnGKRER27sznv/kdjDN5cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABlOEcb4nwHV01nC9Xk0uaOV613thz15/w8+Gf4ebHO8z3bxM1ttas1tEWjT23o/ZOkdGdDbNGutTjWZzF9Oft6epExaluWYnfEzE5jdNb0reJi0RMT8fdPGOL0V2S+k7hnHIxaPis4uF8UmtKROS/d0OsyTtWZwZbT/Ava3ONPnn+etMWbNaJ2+Y9NfRPauj+ttGx9ba9kzaZitc7RoV4x9ZSP8AUrEbp1NPsm1qUiYczW2W9M2pHWr3Z60REfnHfx3ZxEOox489+f8Akev/AKvItWYxz8eP7qiAAAAAAAAAAAAAAAAAAAAAAG59n+0E4u5oddffFyrp9ReZmcXXbFltO8zj6Vx2nzfKsz5OInHwukujYv1to2euL8dTSrHr9tqRH9fO0f1b5j0vWw30on0qxv5xynv+cRx5YlvrzjVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABMRlo3aHtBP29BoL8t5pqdRSevpw4pjn138peOUbd2szHeeh6M6Nj0do2mmc79LTty7L3id2/Oa1xyzOPRbWnpxEZtxjHVjjHbFu7sxu7d7R4j/AF36/wCcunw2jk77KqAAAAAAAAAAAAAAAAAAAABvEf564j/WAY7inFeH8H0mTXcT1WPSaakTvfJP2rT3ZmKYsdYnJmyzEfZxYq3yWnpWeba2TYtp27Wrs+yaN9bVtwikbojOOte04pp0jjN9Sa1jnOdy9KWvMRWJmezu5zy3e+HnTtd9J3EeM+V0PB5y8N4ZO9bZYnu6/V133nv5aWn6vittG2LDbv2iNsuW1bTjj6d0L9E9l2CKbRt0U2va+MVmM7Poz2VpP+rePt3jqxO+tImItPS0dlrTFr4tfjuj0az3dvDjMduIzvcrewbYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD60w5snm8OW/j9jHe3L0/ZiVLaunT19SlMcetetfOYMTyiZ8Iz5PvXh2vv93R6ifDnitWP1Witf7sNtt2SnrbRo+EalbTxxwrMz/M8FopaeFbfCV1TgfE7f/c/dj03y4Y/t5SbR/Rgt0rsNc/52cfZ09Sfz6kV/NP1d/sz78R5y+9ezvEJ6+Qp7cm/5fZrPs5f+bFPTOxxw+ttx4Uj97Vn+b9y31N+74/m+sdmtZPXNp4/PJPwx+DHPTezRw0tafGKR/658k/UX7a/Gfk+sdmM3LvarFHp2x3t/Tea7/2Y56c0+Wz3nszeseUTj80xoTztGe6Jnd47vhj3vrHZef5tbEezTb/HPCk9O9my53c9bG/3aU7k/Uf7/wC3/wDOSjsxTx1tp9mCI/8A+1lf/bt8/wDw1cf/ADZmf/vcfH8ux9R/v/t//OSjsxi/++8n5Yqx/wDPKP8A25qf/c9O/wDzLf8A2p9R/v8A7f8A84/+jGL/AO+8n/uq/vP/AG5fns9P/MmP/TKfqI+1Pw/5RnsxTflrLRHrwRM/18rHwTHTt+ezV92rMf8AolH1H+/+3/8AORnsvPhrYn1Tptv7xnn4LR0727L8Nb9vqv3PqP8Af/b/APnPnPZjN4avHPtx2j4WsvHTmnz2e8eF6z+0I+ot9qPzfGezWsjpm08/nkj40hkjpvZuelrR7qT/AOtH1F+2vxn5Pnbs7xCOk4LezJMfGkf3/wCi/wD7Z2PnGtHfNIx+V5n8kfU3iJndu7/5HxmHwvwLidYmfq8WiPwZcMz+UTki0/lEs0dK7DP/AG01nstp6vnFJj80TpXj+n4TH8/m5a34br6fe0efw5xjm0c/XXeN/UzV23ZL+rtOjv7b1r+VpiVepeP6bfCVvbBmpv38WWm3XvY7V+MQz11dO/q6lLezes+UyjExxifhL5LoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAdO7I/SZxPgPktDxPynE+FV+zWL231ukp0j6vlvP8AFx05T5DNO0RPdxZMccnk+mvopsnSPX19k6uybZMZmYrjQ1pj/vKV9S0/95SMzO+1bzvautstdSetWepftjhPjEcN27Mfm9HcI4zw3jmjx63heqx6rBeIi3dnbLhvtvOPPittkxZK9JreImfvV71Zi0/Ltt2Dauj9e2z7Xo20tSM4zvpesf16d49G9Z7azOOE4nMOZqad9O01vGJ7d+J74nmykTv6Y9rU/n8/ngoAAAAAAAAAAAAAAAAAAAAAA3Ps92g8lFNBrr/wpmK6bUW/4fWK4ss7fcmZ7tLzP8PaItPk+ePh9J9G9frbRs9fTjfq6cf185vWPt85rHr8Yzb1sOrTrelWOGZmIzPLjHGeW+OE8Z4N9eba0xicAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABpPaHtB5OMmg0F9snOmo1FZ+5PLfFhtXf7e28ZLc+5G9Y2tMzTv9GdG9aa7TtNZ6vHS07RHpccXvFv6eE0jhPrTmIxOzpaW+LWjETjFZmJm2/nwxG7G+O/lGdE2idp6+P8Ano8P9es7+izjPDs7f55c44RjYnOZzx5qoQAAAAAAAAAAAAAAAAAAAAA5/wBr/pA4X2ZrfTYppxDi/djuaLFkjuYZmY2vrM1Yt5GIja0YY/jZNo+zjpaMr0nQn0b2vpaa6t4nZtizOdovX0tSOzZ6TMdff6M6k+hSczm1qxWdnS2a+pvnMU5zic57Ijfnlv4dmd7zTxztBxXtFq51fFNVfNaLXnDgj7Gm0tLzv5LT4Yma46xEVrNvtZbxWs5cmS0TafqvR/Rux9GaP1OyaNdOJisampO/V1Zr/VqXnfac5nG6lZmepWsbnT09OunWK1jG6MzzmY5zyz4buxhW+yfz+fEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABcYtHq88/wAHT5snrrjv3fztt3Y5+Mzsw6m07Ppf6mtp0xxi169bjyrnM8Y3RErRW08KzPulkcfAOJX2mcVMcT/2mWvL2xTvz/ZpX6X2Gn/aWv7FLb/faKx+eO9b6q/OIjxmPzZLF2YvMb5tXWJ9GLFNo/Xe1Of/AIGnfp2ucaWzzPfqakV3Z49WtbRMY37rd0skaE87R7o+a8x9m9FWYnJk1GXbwm1KVn2xWne/paGtfprarbqU0aR24ta0eGbdWe/NVo0K85mfy/n891/Tg/DcfTSY59+b5N/b372alukdttnO0XjP2YpT9NYXjTpG/qx78z+UzMLvHpdNh81p8OOfTTFSs/1iIn/y5Rya99faNTdqbRrXjsvqWtHwlMUrHCsR4R/P54y+/ht/n/RhmM/z+ZjunMdycfDs3YCIx8t2PLd7sQkOrG/dx3z3gn+f8fsAAAAAAAAAAAG/Lbw6oxH/ADnHDPZjtknxmPh+8SJMdu/xETGecx4Y+Q+GTTabNzy4MOSfTfFS8+3e1ZmJ9e+7LTW1tOIjT1tWkRj1NS9eHb1Zj39qJrWeNaz4xE+a1vwjhuTfvaTFG/4Jvjn/APB2r/nqbFekNtrjG06m77XVvnx69bKfVU37uP5eH8/JYZezehvMzjvnxeO0Xrevs2vWbT+vf8m3TpraqYi9NLU75rats981t1Y7PUlWdGvKbRw5xj3c/issvZi20zh1cTPhXLimsfnatrfJz9TZp07GYjV2aY7Z079bs/ptSsds778McVJ0J5Wj3xjw5yx+Ts/xLH0piy/+zy19f4+5Pg3adL7FacTe+n7enb/0df48FJ0tTlETx54jd4/l2sbl0erwb+W02bHEcu9bHbu/leIms/lMtzT2nZ9WInT19K2d+IvXre+uetHviFJraJxMTHunz4fyeyVszoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZbg/HOKcA1ddbwvV5NPljaMld+9h1GOLRacWoxT9jLjttzi0b1371LUtEWjS27o/ZOktCdDbNGurTfNZndfTtMY6+nePSpaO2JxPC0WrmJpeldSOraMxy5TE8MxPGJelOx/0icM7R1x6TVTTh3GJjadLe/8AA1Mx/Nost5jvTMfanTW/jV5xSctazd8s6a+jG19F9bW0c7VsMb/ra1/zNGJ5a9KxuiN0Rq1/y5zHW+rmeq5uts1tP0t9q9sRviM/1bsZ/wB3DtxxdGeXagAAAAAAAAAAAAAAAAAAAAAJicZ74w3bs9x/byfD9bflypptRaY5eFcOWZ25TtMY77zMTtSY2ms14HSfRuettOz13751dKsZz26lIjnvzeOE77Rvic4NXT609aI7c1r75zEdszPDnyb0881QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGodoePzpotoNFePLzyz5q7T5CJ3icdd/8Ai2jlNon+HExtHfnevb6M6O+tmNo16/5cTnTpMf6k/anP9EcomPT9mPS2dKkTi14nER6McN/2u/PGO2eO7e59z3mZnff/AKz/ANfbPi9K2JxOO3nHZjdH5cf2BAAAAAAAAAAAAAAAAAAAAD5Zs+HT4smfPlx4cOGlsmXLltGPHjx1iZte97zFa0rETNrTMViImZmIhemnfVtWmnS2pe9orSlKza1rTMRFa1rEzMzMxEREZmZxCYiZnERMzwxEb89mHBe2f0qXyzm4b2YvbHj3nHm4vETXJkjpauhrPPHXnt9ZvEZJ2mcNaRNck/RegvofWsU2rpesWtjraexZzWvOJ2iY3Wtx/wAqszSM+nMzmsdHQ2XEROrv7Kdnjxie3G+OGd+YcQte97Wve1r3vabWve02ve1p3ta1rTNrWmZmZmZmZnnM7y9/WtaxFaxFa1iIrWsREREboiIjdERG6IjdDdiMRiIxjw/bcilIAAAAAAAAAAAAAAAAAAAAAAAAAAAAABHPpz36beIMhh4XxDPETj0uXuz0teIxVmPTE5JrEx645NTU2/Y9LMX19PMcYrPXnPZikWxPjheKXnhWffGPPDLYezWottOfPix79a44tktHtmYpXf2TMetztTpzSjrRpaOpfHCb2rSJ+HXnHjESvGhbnMRHdv8Ad3fnx7mVw9nuH44/iRlz2/5792u/qrjis7eqbW9sufq9MbZf1J09KOylOtb8WpMxPurX3MkaNYnfviO2ePujGI8ZnPgymHRaPTx/B02Gk/iilZt+d5ibTHXlM8vCeu+jq7VtOtn6zX1LRP8ATNrRXvxWsxWOe+K9nYyRWscKxHujPx4rn+zCsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAt82j0uo89psOTeNt7Y6zbb1X278b+O1oZtPado0v8AT1tSndW8499ZzWffEqTSs8Yj4ePZMfljhzYvN2e4flie5GXBafGl+/X0c65ItvHqiazP4vGd3T6Y23Tn0ppq13evWIn8VJpMfC37KTo1nhmPCePxicfn8sVm7M5qxM4NTjybb7VyVtjmfzrOSN58N9oiesxE7ujp9OaU7tXQvThv07V1I+Fvq5iI97HOhblasx4TE8ue/dx5MTm4VxDDEzfS5JiOs44jLEeufJzbaPXLoafSGx6uOptGnmd0ReZ05meyOvFcz3RnPJSdO8caz7t/ln+eDHdOrc48FAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFYmYmLRMxMTvExO0xMc4mJ6xMTziYmOZMRMTExExO6YnfExO6YmOExPPKJ8M/t34/ku0djfpSzaScPDe0t8mo00zWmLiv39RgiNorXWViJtqMUeOeu+evO14zTPer4Ppz6IU1uvtXRVa6WriZvse6unqc5+ondGleY/onGnPCJpwnT19l60TbT3TPrVxGLcZzHOJ+OfHj6B0+p0+rwYtTpc2PUafPjrlw5sV63x5Md43rel6zNbRPqnrynm+b6mlqaOpfS1aW09XTtNL6d6zW9LV4xas4mJjvhzZiazMTExMbpid0w+0Tv0Y0AAAAAAAAAAAAAAAAAAAAAN97O8f8r3OHa28eUiIrps9rTPldtorhvM9MsRH2LzP243pMzeI73nelOjur1tp0K+jO/W04j1ZnOdSsfZnd1o5TOYjEzjX1dOIjrVz3xyjlmN/x3dnLhucxt1cFr/uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAe0P52NZ7QccjQUnS6Wd9Zkr9q28TGmpaPvTzj+LaJiccTG1Y+3aJjuxbr9G9HztFo1tWMaNZ9GJzE6tonhG71In1p5z6MZ342NPTz6U56sTwnhad+6fCN09+Y3c+azM2mbTMza0zNpmZmZmeczM7zvM+M85n0vUxERERERERuiIjERHCIjujlHJsAAAAAAAAAAAAAAAAAAAAAMLxzj3DOz+ivreKamuHHXeMeKv2s+py1jvRh0+LfvXvPKJnlSm/eyXx1ibRv9H9HbX0ltFdn2TSm9pxN7zu09Kk7pvq3xitcZmI9a3CkWnETl09O+pbFInO/P8Atjhmezw4zy7vMXa7t3xTtRlth3touE0vM4dBjyTM36bZNZkr3frGTl3q1mPJYt9qVm2+S31noX6PbJ0RSL4jaNstGNTab19X/bo1nP1dcbpmJ698elOMVjp6GhTSjMYtbnb5Ry5du/O/k0bb/N5/zx/zaHoGwAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+mLDlzW7mLHfJb0UrNpj1ztE7R655Kampp6UdbUvSle29orHuzO/3JiJmcREzPZDM6fs/rs0RbJ3NPWf8AtLd68x6e5Tvbey1qz6YhzNbpnZNKcUm2tbhHUjFc9k2tiezfWtoZK6Nrb5xXx4/Dw5Tj92awdnNHjiJz5Muot4xv5Kn5VpveP/eT7HM1emtpvONKunpRnEbvrL555m3o8OHoceMskaNYx1ptac8t0e+I3xHdmeW+WZw6TS6eIjBgxY9vGtK96fbeYm0z65mZc3V19bXmZ1dXUvnlNp6vhFImKxHdERHcyxSsRiIxw4cd3fxXH9P6QxY+fGf57uC38/mP3AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfDNpdNqImM2DFl3jbe9KzaOvS23erPOdpiYmN+Usunr62jj6rW1NPE5xS8xE787676zGeUxMe5Wa1mMTET475+PH353MPqOzmiyxPkLZNPed9oi05afnW896fRG2SPZPJ0NLpratOYjVrp69eE7vq7z3daPRicb89Sc8MRmJY7aNcbpmvjOY4xx/bfHHewmo7Pa7FvOLyeorHPalu5fbxnuX2ido8K2tPoiXV0umdk1JxqdfRnnNo61M793Wrns4zWI34nE7mKdG/LExyxPzxH5/8AOGy4M2C3dzYsmK3hGSlqzPrjeI3j1xu6Wnq6WrHW0tSmpXtpaLR78TOGOYmOMTHjGHyZEAAAAAAAAAAAAAAAAAAAAAAAAAAAAANz7J9tuKdlc9aYrW1fDMl4nU8Oy22pMRO85NNkmJnTZ+cz3qROPJM/xcd+7W1OF0z0BsfTGnNrxGjtda40tqpXNoxwpq1zEa2n3W9KsZ+rvXNotg1dCmrjO60cLREbp47+3M9v5TL0/wAA7R8L7SaOus4ZnreI2rn015iup0uSY38nmxb716T3bx3seSI3x2tETMfJekui9s6K150Nr05rx+r1a5nR1qxO62neYjO7jWcXrM+lEbs8rU0raU4tu44nlON+74488RMM85zGAAAAAAAAAAAAAAAAAAAAp05+jnE+PLn169YgxndjOd2OW/l2Do3Z3jsayldFq71jVY6RGLJadvrFaxyid53nNEdfHJH2vvRaHmOlOj/qLTtGhH+Tac2rxnTtMzv9iZ3RH9M7uExLX1dPf1qxuzviOWeyMcPjvltc8pmPQ4zXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIjcGD45xmnDME0xzW+szVnyNOUxjjfacuSOsVjnFImPt2iYiJrFpr0ej9httep1rRMaFJ9O2+OtPHqVntnd1pic1rOeMwzaen1+MbozmZnjMTwieeY3Tj/AJctvfJlvfLltN8l7Te97Tva1rTvaZ5R4+jbfrtD11a1pWK0rFa1iK1rEYiKxGIiIzOMR3trhjG6I4d2OER/IRSAAAAAAAAAAAAAAAAAAAAYz/1iPNovbDt1w3sth8lE11nFctJnT6DHaYikeGbV5K7xgxRO01rMeVzRvGOvdm2SnoehPo9tXTF+vMTobFW0RqbTaPWmONNGs/6l+MTMehTjec9WttjR0LavGJrSJ32x+Ubsz378Rxl5g41xziXH9bk1/E9RbNlvMxSm8xh0+OZ3jDp8czMY8deXKJm1pjvZLXvM2n61sHR+y9G7PXZtk0o06ViOtbjqatsb76t533vPbO6OFYrWIiOpTTrpxFaxERvzw3z37u+ee7gxDdZAAAAAAAAAAAAAAAAAAAAAAAAAAAM/z/jj7k6Y8mW3dx0vktP8tKzaf6REyra9KR1r2rSvba0Vj4zMQRmeETPulm9N2e1ubac0001J2378xfJtPjGOk7b/APLe9J9Ozl63TGy6eY0+tr2jdHVjq0mfbtHDvrW0dmWWNG88cV8d8/CM/mz2m7P6DDtbLF9Rb/vJ2pE+mMddo58+VrX6fnPJ1+l9r1YxTq6Mf+HvtPja+cY/2xE+PBlro1jjm3jOI/LjPbE7t7M48ePDXuYqUx03n7NKxSvt7tYiN53n0/8AXmWvfUt1tS1r2xjrWtNpxHLMzM45+eN0RliIiIiIxHu/bmmhIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACN8dMlZrkpTJWetb1i1Z9sTC1bXpPW07WpbfiazNZ+NZiePFExExiYiY44xH77mH1PANBn546201/Tin7Mz68du9WI93u+vfo6Oj0vtmliLTXXr/4nrRw3ReuLT42ie/MsU6NZ4eju5cOWN055d7Aans7rMXetgmmppG8xFZ8nk29dLz3d+vKt7TO3KN52dbR6Y2bUxGrFtG08cx16e61Yz8aREc5xvYp0bxnGLR3dnhOP34sJkxZMVu7lx3x2/DkrNLf0tETt6+jqU1KakdbTvW9e2lotHxiZYpiY3TGJ7JfNcAAAAAAAAAAAAAAAAAAAAAAAAAAAZPhPGOI8D1mPX8M1N9PqMcxv3Z3x5ab7ziz453plxW/mpeJ2+9Xa8VtGptuw7L0hoW2fa9Gurp2zjMYtS2MRfTvHpUvHK1ZieU5iZiaXpW8TW0RaJjhPLvieMT3w9O9je33D+1GOumzdzRcYpTfLpLWnyeo2mInLo72279Z3iZwWmc2P7UfxKVnLb5N079HNp6ItOrTrbRsVrYprRHpaed8U16xnqzumI1Ij6u271bT1I5ets1tL0o9KnbuzHdbl7+E7vCOgbx/nr6fB5v+fz4tYAAAAAAAAAAAAAAAAAAABWL3x2rfHM1vS1bVtE7TW1Z71Zj0TEx1jnHKeeyJiLRMWiJiYmJid8TExiYmPCee5PKfKY3Ty+O//nk6dwHjVeJ4pw5rVjW4qxOSvKIy13mIy0jlET0jLWN4rMxaNotEV8n0jsE7Lfr6cTOhefRnfP1dp/otO/dzrM8Y3TmYmZ1dXT6uZj1ZmIxu3Tv57sR39vHHPYXMYZiY4/z+ZBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABHP/PR1ExGZiGN4txPFwrTTlvtbLeJrhw7xHlLxtPOYneKV5WvbwjaI3m0RO3seyX2vVild1K4nU1Ps17I7bWxMVjt3zuiZjLXTzMxvxznsjMfnPDh38sTyfUajNq8+TUZ8lr5cs960z0j0ViI6VrG1a1jlEREc9oex0tKmjp10tOvVpSMRHb22meM2mczM85me7G1ERWOrEYj38vGf+eXDc+LIAAAAAAAAAAAAAAAAAAAKb8+nL0/57Ofo5T7CcbuO+eEcZ/47u1yHtx9JeHhXluFcBvj1PE472LUa2Jrl02gnbaa4piZrn1decWrO+LT3jbJ5S9bYo9t9H/opqbZ1Ns6RrfS2T0b6WhOa6u0xxib8LaejaMTExi+pWc06tZi87mhss2mL33VxExG+LTnfnujs7eLznqM+bV5s2p1OXJn1GfJbLmzZb2vkyZLzva972mbWtM895mZ6eh9P09PT0dOmlpUrp6WnWKU06VitKVrGIrWsYiIiOUOlWIrEViMRG6Ih8l0gAAAAAAAAAAAAAAAAAAAAAAAAAMjpeFa7VxFseGa45nbyuX+HTx5xvE2tHLrWtv6tLX6Q2TZ56t9WLX/7vTxe+7jExE4rPdaayvXTtacRGO+d0fzfHDPFsel7N6fHtbVZLZ7fgrvjx+2Zie/bb21j1TG8OLr9Na2pmuhSNGPtTi98cuMdSszHH1p7J5s1dGv9UzOJ4Rujw7Z5b4mGfw4MGnr3MGHHhrvvMUrERM+m3jafXaZmee8y5Opq6urab6upfUn/AHWmceGeEd0YjuZYrFfViI7YiI3+/j2c+T6qc+Xw38/n59qwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD55sOHUUnHnxUy0npW9YtEdecbxMxPPlMTEx13X09XV0rdfS1L6du2lpiZ8cbpjumJiecImInjifGIn/AJ/P9sYHVdnNNk3tpsl9Paf5J/iYt/ZM9+u/vTEdIrDq6PTetp4rr1rrR9qI6mpMdm6OpMxwjdEzznMsNtGJ9XNfHfE+G/Pjn3Nc1XCNdpIta+Kb469cuL7dNvTO0Reseu1au1s/SOy7RiK6nUvP9GpHUtnsiZ9G0+zacxvhhtS1czMbo5x+3Pl2MY3lAAAAAAAAAAAAAAAAAAAAAAAAAAH0w5cuny482DJfDmxXrkxZcVrY8mPJSYtW9L1mLVvWYiYtWYmJiJiVb0pqUtp6la3pes1vS8Ratq2jE1tWYmJiY3TExiYJiJiYmMxO6YnhMdkvQfYf6TMevnDwrtFlph1s9zFpuJW7uPBq5neIx6vlFMOon7Na5I2xZp+/5PJtOT5r9IPopfZ/rNt6Lpa+hvvq7LXNtTRiN820eM3043zNfX044dam6nN2jZcZvp744zXjMct3bEzy5co3Ydoid9/RvynwmPTHKOUvB/yWiqAAAAAAAAAAAAAAAAAAAD6YM2XTZ6ajBktjy47RalqzMTWY8OvOJiZi0TytWZrMbTMTXUpTV07aepWLUtExaJiJznfnhxicTWf6ZiJjendO6Y3Tunhv+OMfyZ3ur8I4ri4rpoyV7tNRjitc+GN57tpjlam++9L7TNec7TvWZmYeO27Y77Hq9Wc207ZnTvPOI41tjGLVziYxGd0xundp307RO+cxv6s9/ZPPPDfOY4RnkyrSYgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFtrNZh0GnyanUW7tKRO0R9695iZpjpHje8xtXpEc7TMREzGbQ0NTaNWulpxm1p3zyrXna3ZFY3zz5RmZiF6VmbVxz8o45/ng5NxDX5+JarJqM0zzma4qb71xYu9M1pX1xE73ttE2tMz02iPZbNs2nsulXS0/G9udr4iJtO7njdGZ6sYjO5uVrFYiI98zvmZ7c+UcI+KxbCQAAAAAAAAAAAAAAAAAAEMl6Y6XyZL1pjx1tfJe8xWlKUibWta1pita1rEzNrTERETM8lq1m9orWJta0xWsREzM2mYiIiIiZmZmcREb5mdyYiZnGJzw4Tx5RwnfPCI7Xnzt39Jl9X5bhHZzNbHpftYtXxPHM0yarl3bYtJP2bY8E/arfPG180eammLa+T6T9HvopGj9XtvSlItrbraOyXiLV0d8zF9eN8WvwtXT31pxtm/o16Oz7NEYvqVjP9NZxP4u2Y4xu3OK/wCvOfbPWfze9bwAAAAAAAAAAAAAAAAAAAAAAAACVa2vatKVte1p2rWsTNpn0REc5/JFrVrE2tMVrETMzMxEREcZmZ4RAzuk7PavPtbUTGlxz4W+1mmNt42pWYiu/T7d62if5dnJ2npjZ9GZrpRO0WxxrPV04nhjrzEzM8/RrNcf1ROcZa6Np3z6Md/H4cve2fScI0Ok2tTFGTJH/EzbZLxPprExFKT661iesb7TO/D2jpHa9omYtqdTTnPoaWaV989abWiecWmYzGYiNzPXTrXlEz2zGfhyhkunRpMgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYjsAGO1fCdDrN7ZMUUyTvHlMW2O/PxttHdvMctu/W3o5R13NDpDa9mxGnqTekT/AKep6dcRyrmYmsTO+eraOfNjtp1tnMY7JjdP7xPvjLWNX2d1WGJvp7RqaRv9mNqZYjwnuzPdvPOfuzvM7bU9Hc2bpnQ1cV14nQvO7M+lpzPP0ojNc4zHWjERu68zxwW0bV9X0o753x49s+EfDgwN6Xx2mmSlqXr96l4mtqzMb84nnHKYn2c+jrVtW9YtS0WraMxasxMTHbExulixiZicxPZP83IrHEAAAAAAAAAAAAAAAAAAAAAAAADEdnHj3uxdhvpLy8MnDwjj+S+fh0d3FpeIW72TNoY32imfn38+krG0VnacuniIiO/jiKY/EfSH6K02v6zbejaV09p321dmjFabRzm2nu6unrTjfwrqTvmIvNrW09fZuvm+nERbfmuI9KeU9kdvfu7seisWXFnxY82HJTLhzY65cWXHaLY8mO9YtTJS1ZmtqWrMWraJmJiYmJmJfML0tp3tp3ral6WtW9LxMWras4tW0TETE1ndMTEYlzJiYmYmMTG6e6ex9FUAAAAAAAAAAAAAAAAAAALvQ63Pw/U49Tp7bWpvFqzv3clJ5Wx3iJjeto9e8TEWrtaImMO0aGntOlbS1IzW2+JjjW0cLVnlMfnEzE7pxMTEWiazwn4x3x3+fCdzrWg12DiGlpqcE7xeIi9ZmO9iyVivfx2jaPtVmfCdrVmLxvExM+M2jZ9TZtW2lqRvjfWY4XrMz1bR3TjhxiYmJ3xLUtWa+jMb4zPWjnGfLHwnd3rtgYwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEMmTHhx3y5bxTHjrNr2npWtY3m0/35er1rVra9q0pE2taYrWscZmZxER70xE2nEd0fGf5PhEy5Xxri+TimqnuzNdJimY0+Od438LZbx0m9vDeJ7lZikTvFpn2GwbFXZNKM4trXxOpbjieVKz9mN/Z1pzOMYbtKTSkZiOt/VjlG6IiZ90bu2GGbywAAAAAAAAAAAAAAAAAAC31er02h0+bV6vNj02mwUnJlz5bRXHjrHjaZ9e0REc7WmK1ibTEMujo6u0atNHQ07aurqW6tNOkTa1rT2RHdmZnhERMziIytWtrWiKxNpzuiOM/LxeZO3P0hantFfJw7htsml4LS21o50zcQmk8smf7MXx4N+ePTTM7xtfNvfu0xfV/o/8ARnR6Liu1bVFdbb7RmOens0THq6e/FtT7Wrjd6uniM2v1NDZo0vStvv8AlXniJ5z2zz4cHMnrG0AAAAAAAAAAAAAAAAAAAAAAAAnjx5Mt4x4sd8l7dK0rNp5c5naPCPGekKX1KadZvqXrSscbWmKx8ZN87oiZnsji2PSdm8t9r6zJGGvXyWOYtln1Wt9yn/h8p+U844u09Nadc12av1k/95fNaRnhMV3Wtnlnq+9mpozO+26J5RMZ4e/HCN3k2jS6LS6Ond0+GtOW0352yW9drzMzPs+7HhDh6+06+0Wm2tq2twxXdFK4+zSIisd84zPGZzvbFaVrwiM9vP48f27l0wRGP5/1WAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP8gFtqdHpdXXu58NMnLaLTERkrz3+zkrtevPwi3qneOTNobRr7PbraWravbEerPb1qzms5743bsYxlW1K2jfHv5x72sazs3kpvfRZPKViPNZJit+XhW/Ktt/Dv9zb0235d3Zum6W3bVT6ud3+ZSJmk5n+qm+1Z7qzfPZG6GC2hMb6znunETHv4T3tby4suG8482O+O8fy3rNZ8ee0xG8eiY3iXa09TT1axfTvW9Z51mJj8uE9072Dhx3PmuAAAAAAAAAAAAAAAAAAAAAAAAOjdie3+s7M5KaLWeU1nBL3mbYImJzaO1vvZtJM7b1mftZNPa0Y7zvenk8trWv5jp/6N6HS1La+h1dDb6xu1MYprxWN2nrRHCcREU1YjrVjFbdamIrra+z11Y60ejeOE7sTv/q7d3CeMPT+h12k4lpcOt0GoxarS569/FmxW71bR4xPjW1Z3reltr0tE1vWLRMR8k2jZ9fZNa+htGlfR1tOcXpeMTE9scprPGtoma2jfEzE5cq1ZpM1tGLROJj+cfdGO/ku2FUAAAAAAAAAAAAAAAAAABluD8Vy8L1PlI3tp8m1dRi/FSJ+/XnERkpHOszyn7VZ5W5ae27HTbNLqzu1a5nSv2Wx6s7szW3CY8JjfG+t6xeOyYjdPuxMcI3T755xOcurYsuPPix5sN4yYstYvS8dLVnx2nnHomJiJieUxE8njr0tp3tp3ia3pM1tE8pj+cebTtWaziePZzjx8eW+X0UVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVjr4fnzE4ns7fy3y512l4z9ayW0OmttpsVts16zvGbLWfuxPSceOY5T0vf7Ucq1l6forYfqaxtGrXGrePQif+zpMce614nExO+I3bpmYbWlTq+laIzMboiMbp37+cZ927EYjlqezss2fPOOQIAAAAAAAAAAAAAAAAAAWHE+J6HhGjzcQ4jqKabS4Kza+S87zM/wAuPHSN7ZMt5+zTHSJvaeUR122Nl2TaNt19PZtm0rautqTita8o52tM4itKxvta0xWI4ytStr26tY60zu4Tu793DHOXlftn2313avVTjp39LwjBkn6roonacs1m0U1OqmPv55rM7UiZx4Inu070zbJf6/0F0Bs/Q+lF56uttupWI1teY3VzETOlo53104mN9sRbUnfbEdWtetoaEaUcc2njP7Rzxw7M888GjPQtgAAAAAAAAAAAAAAAAAAAAAABKmPJltFMdLZL2+7WkTaZn2REz/bl4q3vTTrN72rSscbWmIiPfO7+bjjOIzM5xiImZz7my6Ps5lt9vW38lG8fwsc1tfbxi9+dKz7sX8edZiN+JtPTVK5rstPrJ/728TFOe+td1rcM7+rvxGJzuzV0bTvtOI7Ofx3xH8y2nT6TTaSnc0+GmKOUTNYnvW26d60zNrbeE2mZ/s4OttGttFutraltSY4RbdWufs1iIrXMcYiO5sVrWvCMd+7Px/nxyuGJYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARiOyOzhy7B8c+m0+qp3NRiplrHOItHOJ6b1tExas+us7sulr62z3m+jedOcb5r/Vv4WjfFo54msxMq2rFoxMZ93D38mra3s3eu+TRXjJHen+BktEXiOsdy/3beMbWmvLb7Vpl3tl6arbFdqp1N0Y1aRM1meE9em+1eU5r1szO6sRDBfQxvrMzw3TO/lz3Z9+/jvnOGtZMWTDeceXHfHeOtb1ms/0mI5eiY5T1h26alNWsX071vSeFqzFon3xz7Y4xzYJiY3TGJ7JfNcAAAAAAAAAAAAAAAAAAAAAAAbn2P7acQ7Karak21HDM96zrNDad685rE59PM7Rj1Fa12id4rkiIpkjbuWpwum+gdm6Z0fSxpbXp1mNDaIjfzmNPV3TN9KbcsTamZtTfmLYNbQrrRv3WjhPxxE9296r4Rxfh/HNDh4jw3UV1GmzRvExyyYrx97FnxzPexZqTytS0RMcpjes1tPx/bdi2no/aL7NtWnOnq0nnvrevK+nbGL0tG+LRu5TiYmI5N6W07TW0YnlxxMdsTPGPz5TvyyTUUAAAAAAAAAAAAAAAAAAAbP2c419Ry/U9Tb/dM9omt53iNPlneIned9seSZiLxvtE7XiI+3NuT0psH19Pr9KP87TrvrGJ+spxx7Vd817s1nM9XGPV0+tXrRETaOzjMdk43+zz47+DpP8AnLm8q08T2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANT7S8Z+q4p4fprx9Yy1/j3jffDhvET3YmNu7kyR49a0tNoje1ZdrorYfrbRtGtWfq6TnTieF7xPGc8a1n3TbdM4iYnZ09OM9eY3ROIjO6Zj1u/HLfHHg529Mz8QAAAAAAAAAAAAAAAAAAGK4xxnQcC0GfiPEc0YdPhjaPHJmyTEzTDhpym+W+21Kxy62tNa1taNzYdh2jpDadPZdlpN9XUzPZWlInFtS9v6aV/qnwiIm0xE309O2paK14zzjl3y8pdre2HEO1es8pnmcGgwWtOi0Nbb48MWjacuSf+LqMlYjv3n7NYmaY4rXfvfYuhehNm6G0OppxGptGpEf4jaJjFrzG/qUjf1NKsz6NY3z61pmcY7Glo10q4iM2n1rTvmZ+W+Y5NRdplAAAAAAAAAAAAAAAAAAAAAAViJmYiImZmYiIiN5mZ6bRHOfyJmIiZmYiIjMzO6IiOMzPKIGwaHs9qM8Rk1Uzp8U7T3P+NaJ2mdqzExj5TG3eiZj8G0OPtXS+jpZroRGtffHW3/V1mO2Y335+rMRO7Ft7LXRtbj6MYif92/u5e/f3bm3aXR6bR07mnxVpvt3rT9q9uW32rzzn1R0jw2mZmfO7RtGvtNutq6k2xwrwrWP9tY3RPfzjdbLYrStfVjHjv8A+fhOO5csK4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiYzGJ5i31Ok02rpFNRipkiN+7aYiL13/AAXiItWZ8dp5+O7PobRrbNbraOpNJxiYjfW3Zms5icb8Z4Z3YVtWtuMZ848Jalruz2fDvk0lp1GPnPk52jNWPDaNork225zXu2neNqdXoNk6Y0tTFNpiNG+6OvGfqrT3530zPDM2r22hr30ZjfXfGeE7p448J/LujLXbRNbTW0TW0TMTW0TExMdYmJ5xPqnm7MTExExMTExmJicxMdsTG6YYfFRIAAAAAAAAAAAAAAAAAAAAAA2jst2s4l2V1v1jSW8rpc1qRrNDktaMOopXlvHd83npWbTizRv3bT3bxfHNqTyOmOhtl6Y2f6rWjqa1ItOhtFYidTStMcN8elp2mI69N2YjNZraItGLV0a6sb91oj0bRxj/AI7YesOBcd4f2i4fi4jw7LF8V4iuXFaYjNps3di19PqKRM9zLTvR0ma3rMXpa1LVtPxzpHo/aejNpvsu1U6t6763jM6erSZmK6mnaYjNbY5xExMTW0RaJiOPqadtK01tHhPKYzMZj4eLMNFQAAAAAAAAAAAAAAAAAAExOOWeE927t7ePbHvb/wBmeM+WrHDdVb+NSv8AuuS1vOY6xG+KZnl3sccqbz9qkbda/a830tsPUmdq0a+haf8AOrHCtp4XiI5W39bstv4WnGvq0jHWjfxzGN0d/HG/jw4x2y3Hw39v9tv+rhtae7eAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxPGOKY+F6W2T7NtRkiaabFP819ueS0R/w8W8WtzjeZrSJ3s3dh2S2160V3xpVmJ1bxHCu/FYnh1r4mK9m+2JiJhk06decco3zOeXKPfv4ePJyjLkvmyXzZb2vkyWte97TMza1p3mZ/PpEcojlG0PY0pWla0pWK1rEVrWN0REcIhuREREREYiOCCwAAAAAAAAAAAAAAAAAAw/HOOcP7P8OzcR4jm8lhx/Zx1rHey580xM49Php/NlybTtvtWlYtkvauOlrRu9H7BtPSW1aey7NTr3vvtMzimnpxMRbV1Lb+rSmYmd0zM4rWLWtWJyaenbUtFYjMzxzuiIjjMzy4Y798RveT+1XaviPavXzqdXPktLi71dFoaWmcWmxTafvTtWMue8beVz2rWbzG1a0xxTHX7J0P0Ns3Q+zxpaMdfWvETtG0WiIvrXiI4Rmeppx/RpxMxXfMza02tPX0dKulXEcZ9ae2e7ju7ImZ72ruuygAAAAAAAAAAAAAAAAAAAAAMpoeE6vXbWrXyWD/tskTFZ57fw6/eyTynnG1eW03jlvobX0js+y5rM/WavLSpOZif99t8UjhnObRnMVnE4vXTtbhGI7Zjdy+PHw7Zw3PQ8M0ugjfFTv5doic2SInJ6+5vvGOJ8Yptvy3mdoea2rbto2vde3V0+WlSZim/7XCbzHbbh/TEb2zXSrWO2ftTjPumIjHDkyLTZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFd5/zn06f5+RiPj+4x2t4Xo9fH8bHteOmXHtTJz8JnaYtHjEXrbaecbTO7c2bbtp2Sf8q8TSeOnfNqbt+axmJrOeM1mMxxzuUtp1vvmN/bHH39uO/95abruDavRb228vhjefLY6zyiP+0pvM05c5nnT/m8HpNl6S2fasVz9VqzOPq7zG+f9lt0WzyjdbtrznWvp2r3xxzG/dv49k9vLvYl0GMAAAAAAAAAAAAAAAAAAAAABsXZrtPxLsvr663QX72O/dpq9HkmfIavDFomaXj+TJG0zhz1jv4rTP3qWyY78zpXonZel9mnZ9ojq2jNtHXrEfWaGpiYi1ftUnPp6cz1bx2Witq49XSrq16to38p5xPbH57p3S9Zdn+0HDu0fDsXEeH5e9SdqZ8N9ozaXPERN8Genhau/wBm0b0yU2vjtasxL410l0btPRe1W2Xaa7436epXM01tOZxXU057J51n0qWzW0RMOPq6dtK01tHfExwmO7O/xid8c2cc9jAAAAAAAAAAAAAAAAAASpe2O9cmO01vSYtS1ZmLVtE7xMTHOJiYieSLRFqzW0RNbRMTWeExMYxPxTE8uXh47/zn+YdU4HxanFdLE22jVYYimekfzTHKuasfhybTvEfdtFo227sz4/pDY7bJrTERP1V5mdOZ5c5pPfXMceMYntxp6tOrOKxPVnMx3ZxmN3Zjd3YZpoMQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD46nUYtJgy6nPaKYsVJtMz4zttFKxO297T9msR1ttEbzMMmlpX1tSulpx1r3nER5zM8oiN8zyiJlatZtOIjMznd7t88Jjd28p38HI+J6/LxPVX1GTetZma4sXe3rixeFI5bTPja3KbWmZ3iOT2my7Np7LoxpUxMxvvfGJvfnaecRyiMziIiO9uxWKxju4xjfPuxGOW7OMLFsJAAAAAAAAAAAAAAAAAAYjjfG+H9n+H5uI8RzRiw442pSu05s+WfuYMGOZicmW89Ij7NaxbJkmuOtrRu9H9H7T0ltNNl2WnWvffa05imlSPW1NS39Na/G04rWJtMRN6adtS0VrGZnf3RHf/ADi8mdqO1Gv7U8Qtq9XPksGObU0ejpMzi0uKZ32ido8pmvtE5s0xFr2iIiK0rSlfs3RHRGzdEbNGhox19S2J19eYxfWvGd+Mz1aVzMU04nFYmZnNpta3Y0dGujXEb5n1rc5n5RyhrLqsoAAAAAAAAAAAAAAAAAAAAD76fTZ9VkjFp8dsl58I6RHptafs1iPTaYhi1tbS2ek6mteKUjnPGZ5RWONpnsjMpiJmcREzPc2/h/AMOn2yavu580TvFI8zTnvHLlOS3pm32OfKs8rPObZ0vq6uabNnS0+dp/1be+P9OJnszbl1uMNimjEYm2+fs8s+7j5S2KNojaI9ERtyiIjw229no2/s42/MzO/OZmZ4zM4+XHnuzv3zmxEcPhy+HaJSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAdep+Xhun48hgOIcAwanvZNLtp8085rtthvPrrHm5mInnSNt/wCWZ+062x9L62hNdPaP87S3xFs51axu4TOOvjOcWnPKJiIiGG+jEzM13T2cpn47s+GNzTdRpc+kyTiz47Y7R0351tH4q2jeLRPpifbzel0dfS2ikamleL1njjjWey1eNZ7piO2N2Ja01ms4mJjx598fzx3vgyoAAAAAAAAAAAAAAAAAAAAAbB2b7ScR7McRrr9BfetorTVaW9pjDrMMTM+Sy8p7s1mZtiy1ib4rzvETWb0vzelOi9l6W2adn2mu+M20dWsf5mjqYx16b4zE8L0mereN04mImMerpV1azW0eE84ntj+b3rTs/wAf4f2k4di4jw7JvSfsZsFpjy2lzViO9gzVjpaOU1t93JSa3pM1tEvjPSXRu09F7VfZdpr6UelTUjPU1tOeGpSZ4xPCYnfW0TW0RMOPqadtK81ty4TytHbHH+cd+5nHPYwAAAAAAAAAAAAAAAAAF5w/XZeG6rHqsPOacr4t9q5cczHfpbaJnaY5xO0920VtEd6IYNp2em1aVtLU57624zS2MVtGez3ZiZiZxKJr1qzWeE4jPZPKfPuxmObrml1WHW6fFqcFotjy1iY8LVtEbWpeOe1623raN+sTMcpiZ8XraN9DVvpakYtScd0xytHbFo3x+e/MNO9bVmc8c4njx9+OPHK4YlAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHNu0nF/r2edJgtvpNPad5jpnzRym/Wd6Y97UpG8xbe1+e9dvVdF7FGz6f12pX/O1I3RPHTpO+K45Wtum3ON1d2Jzu0p1Y608bduN0bue/f8ADETiN0tYdZcAAAAAAAAAAAAAAAAABi+McY0HAtBn4lxHN5HTYK89oi2TLknlTDgpMx5TNknlSm8b87WmtK2tG3sOxbR0htOnsuy06+rqTzzFaVj1r6loierSsb7Wx2RETMxE309O2pbq1jM+OMRzmd07v52RPkztZ2r1/aviE6nUTOHR4ZtXQ6GtpnFpsc7Ra0xvtfUZe7Fs+Xb7Vtq1iuOta1+zdDdDbP0Ps0aWli+veInaNomI6+raOEROMxpUzMadM7ozM5taZnsaWlXSriN8zjrW5zMcPdHKOTVnXZQAAAAAAAAAAAAAAAAAAACZ6eudv8/z1+AM9w/gWfVd3LqO9p9PPON4jyuSOf3KzH2azt9+0eia1tE7uVtvSuls/W09HGrrRu4/5dJ59a0cbR9mvPMTNZiYZKaVrTvzEduOPLdw/P3RLc9PpsGlx+T0+OuOnWdutp6d69p3ta3hvaZnblHLk8zra+rtF/rNa83tyzwrHZWvCsd0REZ3zv3tqtYrGKxj9/F9+rEsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGInjBMRPH+e7m+Go02DVY5xZ8dclJ57WjnWdpjvVtG1q2iJna1ZiY9LLo62rs9/rNG9qW5zXhaI5Wrvi0d0xMTiOyFbViYmJiMeHd3b/AIb+TTuI8BzabvZdL3s+CImZptvlxxHXlWsd+sRz3jnERO9do3ek2PpbT18aevEaOrOIieGnee6ZmepOd2JnE7sWmZa19Ka74nMceWY93d8u9r7rsQAAAAAAAAAAAAAAAAAAAADZOzHafiHZbiNNbo7TfDea01ujta0YNZhjvR3bxH3cuPvWvgyxE2xXmeVsdsmO/L6W6J2bpfZbbPrx1b1zbQ16xE6mhqTjfXPGlsRXUpO69ecWil64tXSrq0ms8f6bc6z3ePPtetOBcc0HaHh2HiXDsvlMWSNr47TWM2nyxETfBqMdbW8nlpM9N5i1Zrkpa1L1tPxnpDo/aejNq1Nl2mnVvSc1vGfq9Wk+rqadpiOtS3biJraJraItW0RyNXTtp3mto4cJ34mO2Jnj8I38mYaLGAAAAAAAAAAAAAAAAAA2Ls7xf/Z+p8hmt/ueotEW3+7hyTtFcs+is7d3JttHc2t1pETzOk9i/wATpfWUjOvpRMx23rvmacd88bVz/VmI9aZU1a9euY9aInfnfOZxid/huxndwmOPT+UxEx489+sTHhMTHKfbHL0PJb4zn/p4tS2IjGJiY4zyntx+U8FBUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA23ExGf5/Pyat2m4v9TwfUcFv951NZ8pMfewYJ5TO+8bXzc61jntSLWmImaTPY6K2P67U+v1In6vSmOpG7F9TjHHjWm609s9WN8daGfR082i08I4ROcTmN2+I4RPHfvmYjdvc4eobAAAAAAAAAAAAAAAAAACx4jxHR8K0Wo1+vz002k01O/ly3mIjbfaKUjfe2TJaYpjpWO9e9orWJmWxsuza+2a+ns2zadtXW1bdWlKxOczxtM8K1rGbWtM4rETNsRC9a2taK1jNp4Rx4xxnwjfveTe2Ha7W9q9f5W/fw8O09rxoNFMxMY6TO05csxEeU1GSIibWneMcfw8fLvTf7L0H0JodDbN1K41Np1Yidp18THXtHClImZ6ulTOIjjafTtvmIr19LSjSruxa+PSnhGeM47I59/Hm0922YAAAAAAAAAAAAAAAAAAAB9tPp8+qyRi0+O2W88+7WOkbxHetM7RWsTMRNrTEbzEb82PV1tLQpOprXrp0jnaeM4mcREZm04iZitYmZxOI3JiJtOIiZnu/m6O/g3Th3AsOk7uXURXPn5WiNpnFjn/lrble28zve0cpiO5EbbvMbZ0tq7TnT0Ito6O+LTmI1NSOcTaJ9GvLq1mYmOtm0xOI2aaMVjNsTb4xEznhExvx2zxnfiGfn/OW3+fnzcqO/jz/AOGZQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/n/AE94wnEuCYNZ3suHbBqOveiNseSf+8rHS1p23vXeeu8W6x1Ni6U1tmxTVzq6Mcpn06R/ttPGI4dS04xwmvBhvpRbfGItynl7438t2ePHg0nU6bPpMk4tRjnHeI3jfba1d5jvVtG8WrMxPOJmOUx1iXp9HX0topF9G8XrO7dxicZ6to41tv4TES1rRNZxMTE/l4xPOPDL4MqAAAAAAAAAAAAAAAAAAAAG1dk+1eu7K8QjVaebZdJmmtNdopttj1GKJ+9XfeKajHEzOHLtvG80tvjvaJ4/TPQ+z9MbNOlqRFNekTOz7RFYm2leeU87ad8RF6Z37rRi1YmMWrpV1a4ndMb625xPj2dvx4w9a8K4roeM6HT8Q4fmrn02op3qWjlNbRt38WSk7Wplx2ma3paImsxPhtM/Gds2PaNh2jU2batOdPW059KJ3xas+reto3WpaMTW2d8T44496W07TW0YmJx2Z7JjumP+WRaqgAAAAAAAAAAAAAAAAB7QdC7L8X+sYo4dqL/xsNf93taeeTDSOeOZ573w9InrOPaOfctM+a6X2L6u87Vp1xS8/wCbEcK3nhaI5Vv8It3WiIwa1ONoxETMTMZ5784jERic5nhzmc8tucRrTuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWPEdfi4bpMuqybW7sd3Hj3iJy5Z37mOu8T12mbTETMUra207TE7Gy7PfataujTdnfa2MxSketafDdERmM2mIzvX06za0RHdMz2RmMz7vznc5HqM+XVZ8moz2m2XLbvXnwid5mK1jwrXfu1rHKKxERye109Omjp10tOsVpSMRiMZ7ZntmZ3zM75mZmd8t2IisREcIjd4Y59/b35fFcAAAAAAAAAAAAAAAAAfDU6nBpMGbU6nLTBg0+O2XNmy2iuPHjpEza1p8IiI9s9I3nkyaWlqa2pp6WlS2pqal4pSlImbWtMxERHfOfdxnELVr1piIzMzOIiOPlPHl4S8p9uu2uo7U63yOCbYeD6TJb6ng+1S2otG1Z1mppNtpyWjfyNJiPIYrdzbv2yWt9h+j3QOl0PodfUit9u16xOvqbrRpRx+o0rYiepXd17R/qXjPq1pFetoaEaVczvvMb84nHdExGce/f2NCejbAAAAAAAAAAAAAAAAAAAADLcO4RqNfaLeZ0/LfNeNu9z5xjrO3et694rHPed9onn7b0jo7HHV/wBTWnhp1nhuzE3tGerE8o9ad2IxOYvTTteYxurnfP7R/wAcO5vOk0en0WOMeDHFY5d60873n03tPOfZyrG87RDy20bTrbVfr61pn7NY3UpHZWsTiOWZ39aYzO9t1rFYxHx5z4rlgiMfDHwWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAW+p0mDWY5xZ6RevOYnpek9e9S3Ws8vDlbba0THJl0NfW2W/X0LzWd3Wru6t4jlau6Jz38MzNcThW1K2jEx4TuzHg0fiXB8+hmclN82mmZ2yRH2qRy2jLEconntFo+zMxP3eUPU7D0lpbXEUtjT14iM0mfRvOMzOnM75jn1Z9KuceliZal9Oa5njXfvxjEd/Z47vnh3SUAAAAAAAAAAAAAAAAAAAAbt2K7Y6nspxDe0Wz8L1VqV12m52mIjlGp01ZvWtdRjjrvtXLj3x2mJ7l8fA6e6D0umdmxHV09r0Ymdn1pjdMzx0tSYiZnTv2xvpbFoid9bYNfRjVr2WjhPb3T8+T1hotbpuIaXBrdHlpn0upx1y4c1JiaZKW8Y8YmJia2rMRalotS0RasxHxvX0NXZtXU0NeltPW0rTXU07Ri1bRynxjExMZi1Zi0TMTEuRas1ma23TEzEx2LpiVAAAAAAAAAAAAAAAAATw5b6fLjz4bTTLjvF6WiZiYtE7/nv0mOlo3rPJXUpXVpbTvETW9ZrMTHGJjHd8eMTv4kb90xmJ3T27+zvdc4VxHFxPSY9RSYi+0Uz44nnjyx96Np592fvUmfvVmOk77eL2zZrbJrW07Zmvradp/qpMziezMcLRHCe7DS1KzW0xx7J3749/5/syLVUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJmKxNpmIrETMzPKIiN95mZ5REbTvM+iUxEzMRETMzOIiN8zM8IiOcyfz+eLlfHuK24nq9scz9V0/epgjbaLzM/azWjaPtX2iK784pEbxEzbf1/R2xxsujm0f52p6Wp/tj+mkTz6u/P+6ZxOMY3dOkUjlMzxn9vnyzw3YYN0FwAAAAAAAAAAAAAAAAEb2rSlr2tWlaRNrXtMRWta87WtM8oiIiZmZnbbryTETaYrWJtMzERWImZmZnERERvmZndERvnknE9nZ+fD4vMn0i9ubcf1FuE8MyzXg2lyTGXJWYiOI6ilomMszHO2lxXr3tPG8Rkt/HvEz5KMf1j6MfR6OjdKNs2usTt2tXNKzH/AMLp2rvpEf8Ae3if82076x/l1mI6/W6mz6HUiL3j05j8Md+efLnjdjDlj17bAAAAAAAAAAAAAAAAAAAViJmYiImZmYiIiN5mZ5RERHOZmekEzERMzOIjfMzwiO2T+eXnnc2nhnAJma59fXuxymmn8bRtvE5pjnWN5831/HtzrPA27pbHW0tkmJnfFtfjEf8Ay44W9ud2N9czi0Z9PSzi1uG/0e3vnw7Pi22ta0rWlKxWtYiK1rG1axEbRERHKI6bbbbc426PPTM2tNrWmbTnrTM5mZmc5mZ3zPHfO+WziOzhujujsVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmImJraImtomJiYiYmJjpMTymJ6T6pn2G+JiYmYxOYmJmJjHOJiM558d0xExI1TinAd+9qNDXaedr6bwn0zhmd9p6z5OeU77UmsRFZ7+w9LYxpbXbMcK6/OOyNXtjl9ZxjjaJ32a2ppY31jxrHvndw+DU5iazNbRNbRMxMTExMTHWJiecTHjEvQRMTETExMTETExOYmJ3xMTG6YmOEsCiQAAAAAAAAAAAAAAAAAAB0r6Pu3GTs3qo4fr72vwXV5I7/PvTw/Pbl9axRMbzitO0anHHWseWpE3pNMnlfpL9H69KaM7Ts1Yrt+jWeryjadOI/wBG/KLxx0r9voW9G0TTV2jQjVjrVj048d8dnj2d/dueo8eTHkx0yY70yY8la2x5MdovjvS0RNbUtWZratomJraszExMTE7Pkdq2pa1L1mlqzNbVtE1tW0Tia2icTFondMTGc7sZcqYmJmJjExnMdmM5j3Y5701UAAAAAAAAAAAAAAAAAMxwPiluGayLTP8Au2bbHqa9fs8u7krXn9rHMxPhM1m0fzRMaXSGxxtehMREfW0zbSnGN+/NJnsvjHPE4nlhW9YvWY58p3bt+ZjPOJ3dm/G+Ijf1esxetb1mLVtEWraJiYmsxvExt4THOJ6TDxsxMTMTExMTMTE8YmN0xPfEtKYmM55Tj3xx+CqEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANQ7U8W8hh/2bhvtl1FO9ntW21seGf+HO3S2Xbed5j+HExMTF427fQ+x/WXnatSvoaU/5cTG61+dt/GKZjG6Ym09tZbOhTPpTG7f1Ynhbj+UTmN3GZmOLnz0rOAAAAAAAAAAAAAAAAAf9P/Tx9v8A1g/n8/n/AAcB+k3t15W2bs3wfPvjrNsfFdXitExktE2rfh+O228VrMf71etvtWjyEfZrli30f6J/R7qRTpTbtP0p6t9j0bxMTWMRNdptGcZtE/5MTG6P8zjNer0dl0MY1Lxx9WJzunj1p5b4ndnlv54jhv8AnsfQW+AAAAAAAAAAAAAAAAAAA+uHDl1GSuLDSb5LztWsf3mfCIjrMzyiOcypq6uno0tqalopSsZm0/lEc5mZ3REb5ndCYibTiIzM8G8cM4Nh0URlzd3NqdonvTETTFvHOMcTH3t5mJvPPblEV5vK7d0lqbVM6enM6eh2Ruvqb903mN2N3qb4+1M7m1p6UV3zvt5eHz8WbcxlAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYieIw/E+EYdfE5abYtVERtk2nu5donaMsR18Ii8RNoiIjnEbOhsPSOpscxS0zqaHOkzGdPM8dPOMZnM9XMVmZnhM5jFqacW3x6M9vKZzGImO/tjhzzuaLqNPm0uW2HPjtS9Z5xPSY8LVnpas+FqzMT/AFes0tbT16RqaVovS3CY5TziYnfExziYiWraJrOJ3T/OD4siAAAAAAAAAAAAAAAAAAAHafoz7dfUb4ezvF8v+6ZbRThury3/APsXJaYiujyTMTtgy2mfI2taIw3nuTMYr1nF4T6WfR/6+l+k9ip/nUibbVo0iP8ANpEZtr1jdP1lIj/MiImdSsdaI69Z6+jtOhmJvTfMetHGZ5zbxxxieO7G/D0O+ZOdOOXx7fdyBAAAAAAAAAAAAAAAAADfOyvFoyUjhme218cWtpbWmdr44ibWw13iN5xxHeptv9iZiNq44ed6Y2Kaz/i9OPRtMV1oiPVtuiupu5X9W3+6M5mbTjDr13dfHHjv7Mxme6Zmfm3WfV/n+fl7HBas7v581AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWfENbj4dpMmqy7TFY2x13jfJkt9ylfXM85251rFrdIln2bZ77TrU0qf1b7TyrWONp8OHjMQvSk2nHb2T54zw792ccd0TyHPnyarNl1Ga3eyZb2vefXM9IielaxEVrHSKxERyh7bT066WnTTpGKUrFaxx3d/fPGe/LdiOrER2R48d74rgAAAAAAAAAAAAAAAADlH0k9t44Hpr8H4Zl/8ArbV4pjNlx32tw7TXjbvzt93U56WmMHOtsVf48zExi73sfot0BO36sbdtdP8A3LQvE6dLV3bTq1nON/HS07RH1m6YvOdPh18bmy6HXnr3j0ImMRP9UxOc9uI90Tw4RLzPMzMzMzMzMzMzM7zMzzmZmeczM9ZfV4iIjERiI3REcIjsdRQAAAAAAAAAAAAAAAAAAF5otDqNdl8ngryjzmS0T3MdfGbT6dt+7WN7TPOI2iZjW2natHZKdfVtvnPUpGOveY5Vju5zO6I90TatZvOIjxnlHj+zftBw7T6DFFcUROS0R5XLMfbyWj18+7Tf7tImYjx3neXktr2zW2zU62pMVpWfQ04z1aRvzv3Ta07utaY7ojG5t0pFI3b5njOMTOP27PivmquAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtNboNPr8UY81ecfcyV5ZMc7c5rbafszO29dpi0VjeN4Z9l2vX2S/X07Ri261JzNLRmMZ554xExi0ZxE4ndS9ItERjuiecRu4dvfv8ABoGu4fqOH5e5ljek7+TyxE9zJEeiduVo/mpPOPXExM+v2TbNHbKdfTnFo9fTmY61JnhnHGs8rRununMRqXpak4n3THCY+fbHLvjEzYtpUAAAAAAAAAAAAAAAAAA6dAekPoz7cRxTBj4DxXPvxLS4+7otRltPe1+mx1j+He0/e1WnrX7VrTNs+La875KZLX+W/Sv6PzsepbpLY6f+6atpnaNOsbtm1bz60RHDR1bTuiIiNO3o7q2pEczatDqz9ZSJ6s7pjd6M53YiOU7+6N0dzsDxLSAAAAAAAAAAAAAAAAATxZcmDLjzYrTTJivXJjtEbzFqzvE7eMb9Y6TG8TymYVvSupW2neItS8TW0Tzid07+Xjy4ni69wvX04no8WpxxEW27uakc/J5ax9us9eU/erO/Olq+yPFbXs1tl176VuETmluV6TPozGfwz/uiYaV6zW2O3fEzPKZnGZ884355b1+1lAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFY6x7fRv8A28fYJjfMeLmHaLiv+0NXOHFbfS6WZpTaeWTLH2cmX0TWJjuY55/ZiZjbv2h63ovY/wDDaEal4xra0Ra3Oa040r3TOetaO2Yic9WMbenTqxnGJnf34mN3xjfPLf2NddNknf8Al+UYAAAAAAAAAAAAAAAAAab207Wafsrwu2ffHl4jqYti4dpbWjvXyd37WoyV370afT7xbJO0d+80xRas5ImO50F0NqdMbXGn6VNm0sX2rWiN1a53aVJ4Tq6uMV3+jWLXxMVxOfQ0Z1bxG/qxvtMcI7s8M43/AJbpeSdXqtRrtTn1mrzXz6nU5L5c+XJMTbJe872meUREeEVjatY2rWIrERH2fR0dLZ9LT0NGldPS0qVpp0rGIrWsYiO/tmZzMzmZmZmZdetYrHVrGIjERGIjlHDH8zlbsqwAAAAAAAAAAAAAAAAADKcN4Xm4heZj+Hp6TEZMsx16b1xxPK1/TtvWvW09Kzo7bt2nsdMbr61onqaefha8xvrXPvtwrzmL005vPdznu7u/+T2N902mw6TFXDgpFaVjnP8ANeenfvbaJtafGZ/pDyOtr6m06k6urebWtv7KxH2axEzFaxyiPjOZzt1rFYiI3Y/Pvntny5cn3Y4jCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD46jBh1WK2HPSuSlo22mOdZ22i1bda2jwmJ5eDJo6upoXrqaVpres8Y5xnMxaIxE1nnExifFFqxaMTGY8p7Y72h8T4Vl4ffvV3yaa1tqZNudd9p7mSI6WjfaLcq323jaeUer2HpDT2yvVnFNeselSeFsZibUzxjdvjjXhvjfOpfTmnfHb8+yfynlziMS6LGAAAAAAAAAAAAAAAAAA+2n1GfS58Wp02W+DUYMlcuHLjtNL48lJ71LVtHOJiYieXsneN4mmpp6etp30tWldTT1K2pelozW1bRi1ZieMTEomItExPCf57/e9Y9hu1+HtTw2JyTTHxXSRWnENPE7d7feKavFExG+HPtM2rXecOSLY53r5O1/jf0h6Ev0RtU9SLW2PWzbZtWY4cOto3mJnF9PO604+sri0b+tWvI2jRnSvuzNJ9WZ34/wBue7yw3l55rgAAAAAAAAAAAAAAAExv6fynY/n8/wCBnez/ABT/AGbrIrkttpdT3ceaJ+7S2/2M0zyn7Ez9rn9ybTtMxDn9JbJG1aGaRH12lm1J52jHpaf3uMcfSiI3RMqXr1q7s9aMzExxndw+Gcd/OHU+UxExO8T4x/p6tvF4/hxatqYiZz/0/mOwFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAATETPD9mu9pOJxodH5DFbbU6utqV2naceLbbJk3id4tMT3KbbTFpm0TvjmHU6K2T/Ea/1l4/ytGYtMTGYvfjWm/dMRjrWjfuxEx6USzaWnmczG6vHx4xHw3zx5b98w5i9Y2QAAAAAAAAAAAAAAAAGM4xxbR8E4fqeJ6/J5LTabH3p2mJvlyTO2PBipa1Yvly2mK0rvG8zG8xETau3sWxa/SG06WybPXraurbEbp6tK49LUvaMzFKR6VpmJiMc5mIm+nSb26sRmZ+ERzmZ4xiOzyy8fdouP63tJxTPxLW2mO/M00+n73ex6XTxaZx6fF9msTWu8za3drOS9rXtG9uX23ozo3Z+itk09l2eI9H0tXUxi2tqzERbVvvnfbERFczFaxFY3Q7Onp10qxWvdmeczzme+fy5MG6DIAAAAAAAAAAAAAAAAAAzfCuEX11oy5u9j0tZ6xytmmJ50pvzivha+3jtWZtvNeX0h0jXZazp6eL7RMbo4104mN1r8Mz9muYzxtMRiLZNPTm85ndWOPbPh8+HGOMS3rHjx4aVxYqVx46RtWlY2isdeXWevOZmZmZmZmZmZl5W976lpvqWm17Tm1p3zMzx37vhERERERERERDbiIiIiI3RGI/nfz7ZTVSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAjelclLUyVi9LxNbVtG8TExttMT/keCa2tS1b0nq3pMWraJxMTHOJ5ImImMTGYnlLRuLcGtorWz6eLX0tp3mJ53wTM7RFp62pPKIvO8x0tziJt6no/pKNpiNLW6tNeOE8I1YiOMcovzmsbp3zXdujV1NOaZmN9cx4xnt5Y7++N2WCdZiAAAAAAAAAAAAAAAAAAZfgXG9b2e4np+KaG81y4LRGTH3pjHqcFpjyunzRH3seSsc+UzW0VyU2yUpMaXSGwbP0nsursm0ViaakejfEdbS1I9TVpM8LVnwiazatvRtMTTU066lZraMxMbp5xPKY7Jj/idz2DwLjei7QcN0/E9DfvYs9dr45mJyafNWI8rp8sREd2+O28bzG16zXJXet6zPxHpDYNfo3a9XZNori+nOYtjFdTTmZ6mpSedbx74mLVnfWXG1NOdO01njE+6YzOJjunh3cJ3xmcw0mOYxukAAAAAAAAAAAAAAAAB0jsxxP63pfqeWY8vpKVrTeeeTBH2aW5z1x7xjtMcojyczO9uXlultk+o1frqR/l60zndurqYzMZ/wB++8Z3zPX5Q19auJzE+jPuiJ/LGfnvxhtDkNcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABDLmx6fFkz5bRTHipa9726VrWN5n078o226zy57r6dLat66dI6172itYjnMziF6zMbojOcfLznm4/xHW34jrM2qvyi093HT8GKm9aV6+jabem82ttEztHtdl2euzaFNGu/qxm1vtXnfa3vnh2ViI5NyKxWIjGOc98zz4QsmwkAAAAAAAAAAAAAAABG1q0ra97RWlKza9rTEVrWsTNrWmZiIrERMzM8ojnPJMRNpitYmbTMREREzMzM4iIiN8zM7oiN8yYz48o7e6HlX6Qu2N+0vEZ0ukvaODaDJaumryiNVnjvUvrbbc5reN66etp+zinvTFb5L1j7B9Gug69FbL9drVidu2msTqzz0dOcWroRnhMTidWY9a8RG+KVmevs2j9VWZnHXtjrd0Rvx+e/t3dznb07ZAAAAAAAAAAAAAAAAAAZ/hHBp1c11Ooia6beJpWY2nPtv0nrGOOUTP82+1dt5s5HSPScbNnQ0cW15j0rcY0o/3Rwm843VnhO+0Tuhl09Ob753V5d8/KOc+6N/DeK1rSta0rFa1iK1rEREVrEbRERG0bREbdHl5mZmZtM2tMzMzOczMzmZnMzOZme1txERGI3RCqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmItWa2iJi0bTE84mJ3iYmPHeJ25+Eyb4mJicTE5jHHMTExMTxiYxmJjnieRiJ4xnl7p4w0rjHBvq3e1WliZwb75MfWcO+3Ou8zNse/tmnLf7POPTdG9Jxr42faJiNaN1L7ojVjsmI4XjwiLct/HV1NPq+lX1c8OyfPH5+5rjtMIAAAAAAAAAAAAAAAAADfOwXa/J2X4nFNRa9+E669MeuxRMzGG0z3aa3FTnEXw7z5StY3y4e9XebRSY879I+hK9L7J1tOK123Z4tbZ7zu68cbbPed3o6k+rM7qXxO6s3zr7Ro/W1zHr131zw74ndvie/OJ971hiy48+LHmw5KZcWalcuLJS1b0yY8lYtS9L1ma2pasxNbVmYmJiYmd93xu9bUtal62pelprelomtq2rMxatqziYtWYmJiYzExiXImJiZic5jdOe59FUAAAAAAAAAAAAAAAALrQazLw/V4dVitzxXiZrP89J2i+OZmecXrvHpiZiYneIYdo0KbTo30bxutG6Y41tG+to76zv7JjMTumUWjrRMTz4+PHl3uwafPi1WHHqMNu9iy1i9J9U9YnptNZ3raPCYmHidXTvo6l9K8YvS01mPDnHdMYmJ5xMS0r16tpiYxjl4bvzxnfvfZjVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaN2t4nEzThuG07csmqmsbTv1xYpnpG3nLRHLninfld6DobZeO13jtpoxMfjv8A+iPvdza0qxvtiOcRjs58eM8stIh6Bmn+Z7ef5gAAAAAAAAAAAAAAAKbxHWY/qGJ7OPDvcP8ApU7ZTgx37M8Oy7Zc1Ini2Wu2+PDeItTRRaJmYyZa7X1How2pj/4l4j3/AND+g41LV6W2qmaadp/wVJz6epXMW17RiImunOa6XbeJt/RWZ6GyaOf820c/R5b+3HZjh490OAPpLoAAAAAAAAAAAAAAAAAANi4PwadT3dTqqzXTxtOPHPKc3jFp8YxRPq3v0iYjeZ4vSXSX1PW0NnnOtwtfGY0+2N+6b9m/FeM74wzael1sTbMV8/3x4fGG6xERERERERERERG0REcoiIjlERHKIjo8zmZ32mZmd8zMzMzM8ZmZ3zMzznfPNtcOCoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG0TynnE8pjbfl48vH2HxzymN0x3xPKYGm8Z4L5LvavSVmcXO2bDG8zj5zM3pG+8453+1WI+x1j7HKnpOjek/rMbPtMxGp6ulqTw1IxERW08IvxxacdbdHrzE21dTS6vpVj0ecdnf4NZdxhAAAAAAAAAAAAAAAAAAd2+ivtn3e52X4llnuz3v9j5rzHKZmbX0FrTtM7zNsml3mZie9grMR5CkfPfph0FnrdLbJSImMf43TrE74iMRtMRw3REV1sY/p1JjP1lmhtehnOrWOGOtGOM9sbt+7ET3znPF3p85c4AAAAAAAAAAAAAAAABufZPic48k8NzW+xkmcmm3jfbJtvkxRM84rev2q1nlFqzEbWvG/C6Z2TrVjaqRvpiurjnTOKW3bvRmcTMZ3THKrFq060dbHDdM93j28I354t9ecasxPHE47f5j9sggAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABZ8Q1uPh+jzavJ/w6x3K+N8lp7uOkePO23emPu1i1pmIrMs+zaFtp1qaNf6p9Kfs0jfa0+EcO2cRxletetasRvzvnjujnn3fnucfy5smoy5M+a02yZrTkvado3vaZmZ2iI2jptG0REbRERts9vTTppUrp0jq0pEVrHZEd+Zz3zmczvzLd3REREYiIxH8n+Zz2vmsAAAAAAAAAAAAAAAANL7b9qsXZbhN9RWa34jqe9g4dgtG/eyzG99ReI5+R09Z71+nfyeTxbx5TeO70B0Nfpfba0mLV2XRxqbVqRuxTO7TrP8A3mrMdWOda9a+MVxOfQ0p1rTXhWMTaecRv3R7WZ7uLyRmzZdRmy6jPkvlz58l82bLeZtfJlyWm+S9rTzm1rTNpn0y+06dKaVKaenWtNPTpWlKVjFa0pEVrWIjhERERDsRERERHCIiIjwfJZIAAAAAAAAAAAAAAAADYuDcHnUzXVamsxpo546TMxOa0T1msx5qN+cxMTeY227sTLjdJdI/UROhoW/zp3XtEZjSrPKJz/qTHDd6MTnjiGXT0+tObR6Oe/fjt7uU79/Dtxu0RERtERERyiIiIiIjpEREREREcoiIiPRDzG/MzMzMzOZmec/ztzPe24jAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAATGf5/P5vjeNN41wfyM21elp/Bnec2KsTvjnePt0iP+HPObx0p1j7HKvpOi+kp1cbPtFv8AM9XSvb/tI3xFbTP9fKs8bRjMzffbV1dPqz1q+rOcxzjwjnHl3w1l3GEAAAAAAAAAAAAAAAABLHe+LJTLivbHlx3pkx5Kztal6Wi1b1mOcWrMRMWjnExEx0Ratb1tS8RatqzW1bRmJraJiYmOcTEzmOE53kxE7pjMdkvWfYPtbTtRwmJzWrHFtDFMXEMUbUnLMxtj1lKxH3M8VnvxG0Y80XrtFfJzb4z9IuhZ6I22epFv8HtHWvs1/W6v29G0zMelpzPozPrUms5mYtjkbRo/V6mN/UtOYtPLMzunfjd7px35b1E7/wBZj+k7PPNZUAAAAAAAAAAAAAAAEqXyYslMuK9seTHat6XrO01tWd62j1xO0/ki1a3ratoi1bRNbVnhaJjExPdMbpOUxynjHbx+bsHDNfTiOhw6mm0TMTXLT8Gam0ZKRznlvPerM85pNZnaZmseJ2vZrbLr30rZxE9bTtP9WnO+s+ON09lolq6kdTNO6Jic8a8Yme/lMdvCZhfNZhAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxM8Ic47U8S+s6qujxXmcGln+JETtW+pnlafX5Ku1I6R3py7bxs9T0Rsv1WjOveMamtHo54xpbpjw60+lPdFW3o06sTMxiZj8sbu6JzPwjtas67KAAAAAAAAAAAAAAAAtdbrNNw/SajXavLXDptLivnzZLTG1cdKzadt552npWsb2vbatYmZiGbQ0NXadbS2fRpOpq6166enWOM2tOIz2RG+bTuisRNpmIiVq1m1orEb7TiM5xmd2/8/DGZ3RLx72r7R6ntPxjPxHN36YN5xaHTWtvGl0lZnydNo+z5S8zOTNaPvZLTtM1iu327ofovS6J2LT2bT6ttTEX2jViJj63WmI61t+/qx6tInhSIzvy7OlpV0qRWMTPOe2c55zO73tbdRlAAAAAAAAAAAAAAAAAZ/g3CZ1lo1GorMaak/ZrO8eXtHLbwmccT96f5p+zHjMcnpPpD/DVnR0bf59o32jf9VWY3W3f1z/TGfR4zyicunp9ffPqxPxxy/wCfFvERFYisREVrERERyiIiNoiI8IiIiHld8zNpzNrTm0zMzMzOZmZmd8zmZ3y2oiI4Rju/nw3blRIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABPOJiecTExMTziYnrEx6J3nePHc5xPOJiYnnExwmJ5THLsO38/5zaTxrhH1abarTVn6vaf4lKx5i09Jjr/CtPq+xPLfaa7en6M6S+viNDXnGtER1LTu+tjHDfj068/tROcZiWrqafV9KsT1eM9374925rvtdlhAAAAAAAAAAAAAAAAAZ3s3x7V9m+Lafiek3tGOfJ6nB3prTVaS818rgvO0x9ru1tjtMW8nmpjybTNdp53SvRuh0rsWrsmtER1vT0tTETbR1q56mpXnumZi0RMdak2rmM5jHqacalJpPPhO/dMc/nvjPDO97F4bxDScV0Om4hostcul1eKubFesxMxFo+1jvETPdyYrb48tJ5471tS0RNZfENq2bW2PaNXZdopNNXRvNLVnPjFq540vExak8LVtExulxr0tS01mJiYxHDjw3+/dPv4yvmuoAAAAAAAAAAAAAAAA2TszxL6nrY0+W0xp9ZNcc8+VM/Pyd9v+bzc84371Zn7sOX0tsv1+z/W1j/M0Itbhvtp/113dmOtHHhMRjMyx6tOtTMb7Rw8OcdvfGN0+Lpk/5/nN5NqTGP37p5wCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAATEZmI7WL4zxCOG6DLmi22a8eT08bb75bb7TtMbTFIiclt52mKTWN7WiJ3Nh2adq2imnMehE9fUnOPQrxjPbacVjG/fnhEzGWunM2iM7uMzEb4iPfznEdu/sy5JNptM2tMza0zaZneZmZneZmZ57zPOd+e72kRERiIiIjdERwiI3REY3YjlhtcFAAAAAAAAAAAAAAAAA/N52+lbtd9c1H/0b0GWJ02kyVycTyU3mM2qrtNNL3ona1NNP2ssRvE5+7Ezvh5/Tfod0L9Rpf8AtXaKTGrr1muy1t/Ro2zFtbHGLa0bqTOJjTzMZjUh09l0erH1loxNs4jGMRPHMTHPHw4cZzxh7tugAAAAAAAAAAAAAAAAMzwjhdtdk8plia6XHP255xOW0f8ADpO3hym8x0jlExMxMc3pHb67JTqacxbaLx6MTiY04n+u8Zjv6sc53z6MSyadOvOf6Y4zGN/dH7+Pw36taUrWlKxSlKxWtY5RWsRtER6nkpm1pm1pm1rTNrWnfMzM5mZ98tuIxGP5u3KoSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAApMRaJraItWYmJiecTExttMT1j0wb4mJicTE5iY4xjfunlviN/77yYzu/53c498bmicY4TOhv5bDWZ0uSeW28+RtM+btP4Z5dy07/hme9t3vV9G9IRtVfqtWYjXpEd31tYj1oj7UcbxHKetG7MV09TTinDPVz8J4/Ds+HDGcG6rGAAAAAAAAAAAAAAAAA679Fna3/ZevjgOuyzGg4jl/wBzvafs6bX32itZmZ3ri1e0Y9o3iNROO21Yvlu8V9L+hf8AF7P/AO0dnpnadlr/AJ0V46uzRmZnHCb6OZtndM6fWr6U106xp7Xo9ev1lY9Osb8f1V/eYz74zEcoek9/77+E+G3/AFfLHMmMc8/v4eE7gQAAAAAAAAAAAAAAAc/DlPp9Hrj1x4A6xwLiH+0dBTJef4+HbDniZ3m161jbJy8MldrTPLa3erG+28+N6Q2X/C7RasR/l39PT7qzM5r41nd4Ynnhq6lMXjlFt8RyiOO7sxnh2dnBmGiwgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKx1j2+nb+/h7RaMxMTie73xOHL+0nEfr2vnFjtM6fSb48cRO8WyzO2a8bTO8TasUrM7x3ccTE83rei9l/w+zxe0Y1dbF7dsUx6Fe7dm099scm3pxMVzO6beXKP39/ujXnTXmc7wAAAAAAAAAAAAAAAGjdvu1UdmODWvgtE8T1/f03D68p8naKx5bVWid966etomI2mLZrYqzHdm0x6D6OdDz0tt0RqR/wC6bN1dXaZ3x1omZ6mjExwnVmJid8YpW8xviM7Oz6P1t4zEdWu+2c7+ExHv8OGeLyVe98l75MlrXyXta973tNr3vaZta1rTzm1rTMzMzMzPOZmZl9nrWta1rWIrWsRWtYiIitYjERERuiIiMREboh14iIjEbohFIAAAAAAAAAAAAAAAAyXDOHZOIZ4rG9cFJi2bJtO3d3jfHWenlLx930RvaYmI2nS27babHpTbEW1bRMaennfM49aefUrOM9vCN8rUpN5xE4xvmf29/LxzydCxYseDHXFipFMdI2rWvSI6+O8zMzzmZmZmZmZmZl47UvfVvbU1LTa95za08ZnwjEYjhERGIjERGIhuxEVjERiOx9FUgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIZMdMuO+LLWL48lZresxvFqz1ienxjntPWIWpe2neupS01vWYmtonhMc+z8t8bp3ImImJieExhz7inDb8Pzct7afJMzhv6PGcd5/HWPH+aPtRz70R6/YNtrtelvxXWpERqU7eUXr/ALbdm/qz6M8ptqalJpM/Zzunx5eMf8sW32MAAAAAAAAAAAAAAABWJmJiYmYmJiYmJ2mJjnExMc4mJ5xMdCYiYmJjMTumJ4THZI9WfR12rjtHwiuDU5InivDaUwauLX3vqMUfZwayInnPlKx3M9uf8es2mYjJSHx36T9DT0Xts6ujWY2Pa5tfRxGK6V+N9DdujqzM204xH+XMRvmky5O06X1ds1iepeZtXjiJ39aPDnHdnG7LobzLVAAAAAAAAAAAAAAAAZ3s9xGOH6+kZLTGn1P8HLz5VtadseWYmdtqXmItbrGO14jwief0nsv+J2a01iPrNH06TzmIj0qRP+6MzEc7REzjfMUvXNYxxicx298Z744RwzxdUnrP+nT8vU8e053TPioIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYjjvEJ4dw7JkpeK582+HTxH3ovaJi2SOXLydIteJn7M2itZne0RO90fs3+J2mlbRnTpMX1eUTWJ9X784r24mZjGGxpx192N0RHW8se/84nunHJee8zM7zPX28+fXx8Xst2MRGOPw3Yj3YbH8+SoAAAAAAAAAAAAAAALfVanBo9Pn1epyUw6fTYsmfNlyTtTHixVm97WnryrWZ5bzM7bRM7QyaOlqa+rp6OlSb6ureunp0rGbWtaerWsR3zMfOIytWs2mKxGbTMRHvz/x4PHna3tFn7T8a1HEskTTBERp9Fhn/g6PFNvJVmN52vkta+fLtO3lct4r9iKxH2/obozT6J2DS2WuLak/5m0am7/M17xHXn2axEadP9la53zLs6OlGlSKxx42mO2cZjPZux4Rya06rKAAAAAAAAAAAAAAAAutHpMutz0wYonnO977T3cdIna15nlHLwjeO9O0RPNg2naNPZdK2rqTujdWscb3nOKx44nM78REzO6E1rN56sce+eXbz8t8ujaXS4dFhrgwxEVrzm382S0xG97THW07fl0jaIiI8XtGvq7Vqzq6kzmZ9GvKlY4UiMboiJnxnfxmZbtaxWMR755yuGJYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8NTpsWrw3wZqxal4/Otonetqz4WrPOJ9W3SdpyaWtqbPqU1dKZi1Z78TGJzW0RE5rMbpjHZO6YiVbVi0Ynh5T2w51rtFl0Gotgyc452x5I27uSkztFo2nlMc4mOsTHjExM+z2TatPa9GurTdPC9M5mlo4xPDMTxrbhMTE9sRp2rNJmJ8YnlMT2eWOXhjNm2VQAAAAAAAAAAAAAAAGe7M8e1PZvi+l4npp70Y7eT1OKemfSZZiM+KYiYjvd2IvimeVc2PHeYmKzE83pbo7S6V2HW2TV3TaOvo356WtXM6d43TuzM1vHOlrV3TOYx6unGrSaz7p5xPKfCOcc3sfQa3TcR0em1+jy1zaXV4qZ8GWvLv47xEx3o2ia3r9y9LRFqXrNbRFomI+H7Roauy6+rs+vSdPV0b2070nf1bVnE4nnWfWrMZi1ZiYmYmJcW9Zraa2jExOJ5743Z9/GO2JiYXbCqAAAAAAAAAAAAAAApO/LafGP7f6+MeuIP58h1bs/xGeIcPp5S021Gm2w5953tbbeceSZnnbv15TbbeckZN/B5DpLZf8NtFprXGlq5vp44Rn1qd3VtwjlWatXVrFZ3RjPCffGY8f2njlm3OYQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFYj8/8AXry/PYXpETE58/5/Pe5b2j4j9e4hfHjtE6fSb4sfdnla+/8AGvvvO+947kTHKaY6zG/emXrui9m+o2atrRjU1sXtnjEb+pXtiOrMTicTEzMct21p16teybb8b+H9PH4+MzwYB0lwAAAAAAAAAAAAAAAP5/OLg/0t9qtu52Y0WbntTPxe1PRO19NpJnnPPlqMsV8Jw13ne9Y+ifQvoePS6W16c7aexxbjH9OrrY4c506T7c4j0Zno7JpRv1Jjurv7OMzHDPLPDnHHLg76I3wAAAAAAAAAAAAAAAE8WLJmyUxYqzfJktFa1jrMz8I8ZmeUREzMxEKampTSpbU1LRWlKza1p4REec8oiN8ziI3yRGZiI4zuiO10ThnD6cP08Uja2a+1s2SI2m1ucxWPHuY95iv52mIm0w8dtu2W2zW605jSpu0qTPqx9qccbXxEzPLEREzERMbmnSKxy608Z57p4eETu753si02QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAidugLHiGhx6/BOK8RF67zhybc8d/D/wANul6+Mc4jvRExs7HtV9j1o1KxNqTiupTO61N2d08LROZrOM5zEzi05pesXiY4TE7p7+z84+Mc3OcuLJgyXw5qzTJjt3bVnbrtvvG0zExMTExO/OJiXtNLUpradNXTtF6XjNbRmMxmY4TETExMTExyndO9pzExMxMYmOMPmugAAAAAAAAAAAAAAAB276Je1XkMt+zOty28lnm+fhVr25Y88RN8+kiZnetc1Ytmxx0jLXL/AD5Y38D9M+h41NOvSuhSIvpxXT2yIjfbT3V09accZ05xp2njNJpyo0ds0cx9bWN8Yi3fG/E+7hv5Y37sPQT5q5oAAAAAAAAAAAAAAADNcA4h9Q4jjm+Tu4NRtgzxM7VrF5juZLR/3d9p709KWvt1aHSWzf4nZrRWM6mnPX0+2ZiJzSPbjMRHO0V7FdSnWpjG/dNePLM289+Pdnfnq8/l6tv6+PPbny9LxzSmMY74z+c/soIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABMRmcMTxzXf7P4fmyVmIzZI8jg9PlMkTE2iJjf8Ah071/RvWN94nad3o/Z/8TtNKTEzSk/WanZ1azG6e604r24mZjgy005m8Z4cZxnGImJxOO3dHGN+/k5K9m254z4/ziCAAAAAAAAAAAAAAAGu9qOPYezfBtZxXLEXyY6xi0uGbbeW1eWJjBj59I7298kxEzXDS9oraY7s9Pojo7U6U27Q2Sm6tp6+rflp6NZidS/fOPRrG7rXmtcxxjLpac6t4rHDO+eyOf5cO/c8c6vVajXarUazVZbZtTqs2TPny3ne18mW03vPoiN5nasbRWNq1iKxER9w0dHT2fR09DRpFNLSpXT06RGIrWsRER8I3zxmczO+XarEViKxwiMRy3Qt2VIAAAAAAAAAAAAAAB6IiN9+QN54JwuNLjjU56/7zlr9mtoj+DjnaYiOu2S3W0+FZiu0T3t/K9KbdO0X+p0p/ydOd8xO7VvGd84j1a8K75iZzbfira0tPEdaeM8O73x28+7dPNn3JZgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGE4zwyNbinNijbU4az3Yjb+LSOc47TtEzaOc4532iZmu21t46fRm3Tst/q9W0zoak75n/s7/biIjdWcYtHhOfRxOLV0+tGY9aOHLMc4ntns4YaFttyneJjlMT1jb0789/a9bx4NQAAAAAAAAAAAAAAAB9cObLps2LUYMl8WfBkplw5aWmt8eXHaL0vWYmJi1LVi1ZiYmJjlKupSmrp30tSsX09StqXpaImLUtE1tWYmJ3TEzExwlExExMTwmJifCXsPsh2ixdpuCabiMRWuprEafX4o2/hazFWsZe7ETMxjyxaM+KJ5xjy1rO9os+IdN9GX6J2/V2aczpWmdTZ7zn09C9pmmZxETamJ074/rpM7omHH1tP6q81xOOMTMRvjMd3LGJ78TzltDkMAAAAAAAAAAAAAAABPLn6OfXbp6/89Yfz5Oqdn+ITxDh+OclonUafbDmjfe092P4eSecz/EpETNp5WvW8xz5R4/pLZv8ADbTbqxjS1c6mn2Rn16x7Np4cqzXty1NWvVtu4TEzmfLPPsiOUY7Wcc9iAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVj/AEn4f5/qJrnO7jv8pcx7T6/65xCcNJmcWi72KOfK2WZic1v1RXH1mZ8n12nux6zonZ50dm69o9PXmL99aRupHjMZtPtY4w3KVmKxM8bRE+7lw5cceLXHUXAAAAAAAAAAAAAAAAeWvpO7Tzxzjc8P019+HcHvk0+Oa371dRq99tTqO7H2Yito+r4+d/s4rZItHlppX699E+iY6P2CNp1azG1bdWmpaJjE6WjvnS08zvzMT9ZeMVxa8VmJ+ribdfZtL6ukTMelaImYnjHd7+M9890OaPVNkAAAAAAAAAAAAAAABs3AeGRmv9d1Ff4WOf4NLRyyXidpyc+tcc/d9N+e8dza3D6W2/6qv+F0rf5l4/zLRO+lZ4U3b4tfnnGKTG6evExm0adb0p4cu+e3vj9/BuTzbaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACYyNQ4/wzuTOuwV+zaf94pWI2raeUZYiPC08r8uVtrfzTt6Lonb+tjZNWfSrH+TaZ32iN86ffNY31ns9HjEROtq0xM2jhM793DPPPfPd48WrO8wAAAAAAAAAAAAAAAAOg/Rz2n/+j3HaYtReK8N4pOPS6ub27tMN+9MabVzMzFaxiyWmmW1vs1wZMtutavN/Sfon/wBp9H2vp1mdq2SLa2h1a9a2pXH+boxGJmZvWItSK751KUrG61onX2nSnUpu41zO7jMcZiPHG7vx3vV0TvG/LaekxzifX7PRPjHN8bnd4888pciYxPz/AJKogAAAAAAAAAAAAAABn+zevnRcRpjtMeS1k1wZO9MxtaZ3w2iY26X+zO/Lu3tPWN45vSmzf4jZrWrE9fQzqVxziIxeJ4zvrvjH9URHCcKaletXsmvpR7uW+JdR/wA/zd5FpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMdxXWxw/Q59TvteK+Twx13zZImuPl4xE72t/y1ltbHoTtO06el/TM9a89lK77fGI6sd8wvSk2mOzO/wjfPy8fe5DM2tM2tM2taZmZmd5mZmZm0z1mZmd59b20RERERERERiIiMYjHCI4REcm9ON2OHl3R4RERnn8FBAAAAAAAAAAAAAAAHFoP0idpv/o7wK9cF+7xHiflNJooi01vjrNY+saqu20x9Xx3iKTExtmyYt4mN4ej+jHRP/tTpGs6lc7LsnV1tfMZi85n6rRnO7/NtWetGN+nS/CcTGzs2lOpqRMx6NMWt/wCmPfP5RLya+yuuAAAAAAAAAAAAAAAAyPDOH24hqIx7TGGn2814/lrHSsT0715javo+1b+WWnt2112PRm+6dS3o6VZ52ndMz/trE5nt3V5r0rNrY5Rvnw/LfPCHRaUpipXHjrFKUrFaVjpFYjaIj2RHjz9vN4u1r3va97Ta15m1rTjMzMxO/G7OZnhu/JuRERGI4cI8I/nPtSEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE1res0vEWraJrato3iazG0xPpiYmYmPR7SJmtotWZrasxNbRMxMTG+JieUxO+JxMwTGYmJ4TulzvivD7aDUTWsTODLvbDaefLf7WOZ/FjmYjnMzNZraZ3mdvY9H7ZXa9HfMRraeK6tc88brxHZfEz3TmOERM6V6RS2Ij0eU+cd8xz+eWLb6gAAAAAAAAAAAAAAAD1P9Gfaf/bvBK6PVZItxHhMU02bvT9vNpdpjS6iY33n7NZw5LeOTH3rbTkiHyH6V9E/+z9vnX0q42XbZtq0xHo6ernOtpfGfrKxuiK2xG6k45O1aXUv1oj0bZnwxjPOe3+Q6S8q1QAAAAAAAAAAAAAACfVtv4biYnjGcRPHdnn+3H3OucF18cQ4fhzTMzlpE4c+8zvOXHERNp5f8Su2T1xO3WN58Xt+z/4bab0iMUt6enuxHUtM4iPZnNfutPUr1bTHHMdaJmeHGZiPduxxhlGmxAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOfdrdf5bU4tDjtHk9NWL5Yjbac+Su8RPpnHimNo8JyW3jfp6bobZuppW2i0YtqzNaTMf9nWd8xz9K0TnlMVht6MYrM4xNufdHb4z+UQ1B2mUAAAAAAAAAAAAAABS1q0ra9pita1m1rWmIrWtY3mbTPKIiI3mZ5RHNMRMzEREzMzERERmZmd0RERvmZndERxI49vdHGXj7tv2jt2l49qdXS0zodPP1Xh9d94+rYrT/F97UZO9mmdt4relJmZpEvtn0f6Ljoro7S0bRH+I1f87aZ5/W3j1PDSr1dPsma2tHrO1oaUaWnEY9Kd9vGflGIj39stRdtmAAAAAAAAAAAAAAATx4smbJTFirNsmS0UpWNo3m07RznlHp3nlHWZiN5VvemlS2pqW6tKVm1rYmcRHdGZnwiJmeUTO4iJmcRGZndiHSOH6Kmg01cNdptP28t+X28k7d6ekco2iKx1isc5md5nxW2bVfa9adW2a1jdp0+zSM4ic53znNp524YiIiN2lIpWI3Z4zPf/ADdHcvWsuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtdbo8ev098GTlMx3sd/GmSN5rb1+MTEzzidt45bZ9l2i+ya1dWmcRPp15XpOetWfjmu6cWxOOKlqRaJieO/E9k/wAxw/ec82zYcmny5MOWO7kx2mto/vEx6YmJiYnpMTEx1e209Smtp01dOc0vWLVnx4xPZMTmJjlMY5NOYmJmJ4w+S6AAAAAAAAAAAAAAAGz9kO0GXs1x3ScQrP8Au9rRp9djneYyaPLasZeUTE9/FtGbHMc/KY6xMWrNqzyemujadK9H62zTH+bETqbPbOJpr0iepv8As2zNLxO7q2md0xExi1tP6ylq88ZrPOLRn/j5w9i4cuPPixZsOSmXDlx0yYslLRauTHesXpetomYtW9Zi0TG8TE7xyl8PvS+ne1NSs0vS1q2paJi1bVmYtWYnfExMTExPCYcWYmJmJ3TE4mOyYfRVAAAAAAAAAAAAAAADaOymvjT66+kvbbFq67V3nlGopE+TiOsV78d6v/NbuRMxtWXI6Y2f63QjWiJm+hOZxz0retw4xWcW374jPJXVrmsTjHKcYzjtn3Yme6c85dJnlO3+v/lDyzUtWK4xnfnj7lBQAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8NVqaaPTZtVk50w47XmOk27scqRM8om8zFYnaZ3mOXPnk0dK2vq6ejXdbUtFYnszxnHPqxE2nuiVqxFpx2zu/Pn3cfdwnc41my31GfLnyzvfLe2S0+m17TM+PSN/s+iJmHuqUrp0pSm6tKxSsb/VrERGeU8OPHPi3o9GMRwxEcP+Pjh81gAAAAAAAAAAAAAAByz6VO0f8AsngscL02SI1vGe/hvtaYvh0FP/sjJERzjy8zGmrM8rUtm7v2qcvX/Q/ov/GbfO2atZnQ2Hq3ruzW+02/0qzP/hxnVmIzMWrpxbEW37myaUXvN5jNaRExOf6pjh7t8zzjd7/MUb+P9fT/AOf9vhH1l1AAAAAAAAAAAAAAAAG6cA4d5Gn13NWPK5YmMNZjnjxz1vHotkieXLeKdJiLzDzPTG2Tq3nZdO3+XpzE6sxPr6nGKTj+mm7Oc+lyzWJjZ0qYxeeM8O6McZ8f5xbI4sZ59/8Ax+TOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1/j3DvrOL63ijfPgr9uI65MMbzPLrN6da9d6zaOvdh2Oidt+p1P8AD6kxGlqzmtpn1NSd2M8q2iMT/uxO7ewa1cx1o4xEzPfEce/dnv3Z9+jvUNYAAAAAAAAAAAAAAAB6R+ibtJHEOGZOB6q9frfCoi2l3na+Xh97d2sbbz3p0uW3kpmIiK4suCu28TM/LPpn0V/htrr0ho0mNHbJxrYj0abTWOOeUa1I60RzvTUnsiOZtml1bRqVjEWzFuyLRmc92YjPfOebr7xTSx/MwAAAAAAAAAAAAAAAnjvbFemSk92+O1b0n0WrMWrPh0mIVtWt62paM1tE1tE84mMTHwOO7t5eLseh1Vdbo9Nqqxt5bFFrR12yRM1yV36z3b1tXefRvtzeH2jRnQ1tTRn+i0xEzxmvGszjtrMT72lqRNbTWd81mYzjGY3Y8/zXTCoAAAAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAAACaxmYj+cGmdr9d5PFh4fS/2stoz5or44ab+Srad9tr5Im8V/7utpmPs793oXZ5te+02rHVpE6enM8evOOvNe+KzFZnsvMRnfja0qYzO/ERu8d2c4jhEebQo6R4er0PRzxnn39rKAAAAAAAAAAAAAAA+eXLTDjyZst648WLHfLkvee7WmPHWbXta08q1rWJtaZnaIiZ9cWpS17VpSJte9q0rWIzNrWnERERvmZmYiIiN8ymImZiI4zMRiOOZ7I5vG3azj2TtHx3W8TtvXDe8YdHjnf+Fo8MzTBXnM7WvG+bJEcvK5ckxERMRH3Lobo6vRfR2z7JG+8V+s17fa19TFtSe+KzilM7+pSud7taOnGlSKx2Zn2p4/zjua46jKAAAAAAAAAAAAAAAy/B+HzrtTE3j/AHfDMXyzvt3p/lxxttMzafvbfdpEzvEzG/P6R2yNl0cVn/O1ImunHOsf1Xn2c7u20xyiV9Ok3tG7dG+3h2Z/k4icOgxEREREbRHKPZ4R+Tx/OZmZmZnM57Z4z4zz79/HLd4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH5RPt/wA/zx3Md8/yc57c+/w37zi0LjfD40eo8pjjbT6iZtTbfbHed5vi9UR96n/LPd3nuvW9F7Z/idHqXnOtoxEXmd03rPq38Zxi3+6JndnEaepTqW3erPDu7vd/ObCOmxgAAAAAAAAAAAAAAM72b43m7Pca0XFcP2owZIrqMe87ZtLk+xqMU7T1nHM2xzO/dyVpbae7tPP6V6P0+k9h19j1N31lc6dudNanpad47otERaOdZtG7LHqUjUpas78xOO6eXwl7M02ow6vT4dVp71y4NRix58OSsxNMmPLWMlL1mOUxNbRO8c/S+F6unfR1NTS1KzTU0r2070ndNb0nq2iYnfExMT+zi2ia2mJjExMxMdkxunnPOJ92/hMY+7GqAAAAAAAAAAAAAAA3jshro/3jh97Tv/8AZODfp3eVMtd+URO/cvFY675J25bz5/pvZ/8AT2msbv8AS1O3O+aWn+6szPD0YzviIw61Zti0cYzE9s55zy3Yxy5c28PPtad0zHZIIAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAJmIiZnpETMz6IjnM+raOe5EZnEcZ3QmOMcfdx9zj/FNZOv1+o1MzE1tkmuKI6Rix/Yx7euax3rf81rbbRtEe32PQjZ9m0tL+qK5v33t6VvhM4juiG9WJrEREzPbPDfPHhjhw78Qx7ZSAAAAAAAAAAAAAAB/Pg5N9LHaL/ZvB8fBtPaY1fGO9XNNZ2nFoMcx5beInvR9Zv3cMbx3bY4z1nntE+z+hvRn+K2623asZ0dixNMxmL7TaJ6mOU/VV62pmMzFvq5jjlu7Hp9a86k8Kbo77T8uPweaH1V0wAAAAAAAAAAAAAAE8eO+bJTFjrNr5LRWtY8Zmdoj1Rz3mekREzMxCt7106W1LzitKza0zyiIzP8AxHOdxjO6Oe74uk6DR00Omx4K7TaI72S8RtOTJaN7W9nStd+cUisc9nidr2m+169tacxWd1KzPq6cerG7O/fmcYibTblMN2lYrWI453zPf/xyyvGuuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtdZpaa3T5NPk2+3H2LTG80vH3Lxzj7s9ecb1mazymWfZ9ovs2tTWpmepPpVicdek7rVnxjhunE4mIzEK3rFqzE4iOXLE8vD+Q5tmw5NPlyYckTW+O01tE7+HSY361tG1qz41mJjlL22nqU1dOmpSc0vWLVndwnlOM4mJ3THKYmJ3w0pjE4njG7+ZfJdAAAAAAAAAAAAAAAD0Z9EXaGdZw7UcB1F99Rw2fL6SbT9q+gy3iL0iOsxps9tot0iufHTaO7vb5h9NejPqNq0+kdOuNLao+r18RujaKV9G09+rpxw4zOne2+Z3c3a9Lq2rfjFt0zO/FoiZjEcPSiMYmZzh2R4ZogAAAAAAAAAAAAAALzh+rtodbp9VX/AIeSO/H48Uztlp/4qTaI8Yna0c45YNp0K7Roamjb+us9Wey8b6W91oiZ7Y3E161bRu37t/fmYn3TEfvMRl2Otq3rF6TE0tEWrMdLVtETExzneJiYnlMvDzE1mazGJrMxMdkxOJj4tCYnv7N/dGfL/hVCAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAGC7R6z6nwzLFbxGXVb6fHtMd6IvWfKW584iMfejvREzW1q9J226PReh9ftdJmM00v8y09kx6kdkz18TjnETyiWbSpm0TPCMT+WYzzjl4/m5Y9e253/yP2iAQAAAAAAAAAAAAAAhkvTFjvkyWimPHW173tO1aVrHeta0zMbVrETM8+kStWtr2rSkTa9pitaxGZm07oiIjjMzuhMRmcYme6OLxt2t47btFx/X8Si15098nkdFW8zvj0eD7GCIrP3O/G+a9I5Rly5N95mZn7j0L0fHRnR2zbLiv1tadfXmuPS19T0tSc8bRWZ6lZnf1KVjdEREdrR0/qtOtd2celjG+efjHZM78dnBrbqsoAAAAAAAAAAAAAADbuzug2idflrO8xNNPEx0r0vljx+1Mdys8uUXnn3omPPdM7XmY2TTtujF9bHbxpSfCPTnjvmvZMTn0af1z93fG+J3Z/Kcd3jhtTz8RiMfz85lsiQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP58BrPaHh/lcf17FH28cd3PEbRM4uUVvG0c5pMzE9Z7vqry7fQ+2Rp3nZdSfRvPW0s5xF5zmsz2XiMxmfXjdvu19en9cR3W8o8OzhLTXpWuAAAAAAAAAAAAAAAzvZrjeXs9xvQcVx961NPmiupxVnnm0mX+HqMXo3tjtM070TWuStLTH2XP6V2CnSewbRsd8ROpSZ0rzGY09avpaV+3EWiItjEzWbRnex6un9ZS1O2N08cTyn498eL2bp8+PU4MOow2i+HPix5sV69L48tIyUvG/halq2jx2mN4h8K1NO2lqamleMX072071njW1LTW0T3xMTE98OJaJi1onjEzE+MS+yiAAAAAAAAAAAAAAFJiJ/z/N/z3gTE4/n8/mXT+y+sjVcNjDa2+XR28jMTMzPktonBbx5d3fHG8xzp0iNt/J9LaH1W1TeIjq68fWRjdEW4Xjxzi0+17mrrRMWmYzi0ZnhjdunfnjuzjG+O1sTlsAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAJxM8Imfc5v2r1v1jiFdNXbyejp3Z22mPLZNrZJid56VilfbWz1XQ+h9Vs06s+trznwpSZiu7vnNvCY921o1xXrc7b9/Hdu9+/M+G/tau6zKAAAAAAAAAAAAAAA5f8ASp2g/wBlcBnh2DLNNbxm1sFe7Mxeuix9ydZfeI+zGStqabaed65sndnak7et+h/Rv+M6R/xWpSLaGwxGpOYzE69sxoVxzmsxbV7ppXPGM7myacW1IvypGfvcI+Eb89uN3Z5ffW3UAAAAAAAAAAAAAAAXvD9HbXarHhjeKb97LaP5cUTHen2zv3a/80x4btXbNprsmhfVnHW9XTrP9WpPq15buc74xETK1azaYiPGe6Of/He6TSlcdKY6R3aY61pWsdIrWNojx6Ry/v13eKm1r2te8za17Ta0zxmZ3zM988/hvw3YiIjEcI3RH84+O/xSQkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABS1a3ral4i1bRMWraN4tFo2mJieUxMdfV16wRNqzFqziazExMTviY3xMcMTE4xOUTviYnnu+O5zjiWitodVfFz8nb7eG3XfHaZ2iZ/FWYms78+UT0mHtdh2qNq0K6m7r19DVjsvERmcdlomLRjdvmOUtPUr1bTHLjE90/Lgx7bUAAAAAAAAAAAAAAAelvom4/HEeC5OD6jLa+r4PeIwxkmZm3D80zOn7tpnnGnyeVwd3bbHijT1idpiK/Kvpn0b/AIXb67dpUiujt0TN+rGIjaaRjVzEbo+tp1dTPG9/rbTEzmZ5e16XVv14jFbxmccOtzz2TPHvnvl1p4xpgAAAAAAAAAAAAAANi7Ma2dNxOuGZ/h6ys4bbztEZIibYp8ImZt9iPT5SY5zG08zpbQ+t2SdSPX0Z+sjnM04XjnOMelPCI6sTM4lTWr1tPOfV3xHHtz8590unPJNPE9kggAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAB8dTnrpdNn1F/uYcV8k9efdjfb1zae7WI6zaa7Mmlp21dTT0q+tqXrWPfOM+ERvnuhlpwxEb5tiPGcbu39u9xjLkvny5M2S02yZcl8t7TtvNrzNrT09Mz8OnJ7qla6dK6dIxWla0rG/hWIiOfZEf8AVt7oxEboiIj4ILAAAAAAAAAAAAAACkzt1/r4fn6D+fz+fundzn+c+f8A1+LyH2949bj/AGk1memTv6PSWnQ6GImJp5HBaYvkrMRHejPnnLmi3XuXpXeYrWY+1/Rzo2Ojei9DTtXq6+vEbRtGYxaNTViJik54fVU6unjh1q2nEZl2Nn0409KsYxMx1rZjE5mI3fCIzv4tMd1nAAAAAAAAAAAAAAAb/wAD0MaTSxkyV2z6iIvbffelNpnHTw57T3rei1pid4rEvI9KbX/iNonTpOdLRmaxjneJxe+eHGOrHbWuY3zv29GvVrmYxNvLl8+Uz7mZc1lAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYnjOh+u6Se5WJz4N8mKfGenlKb/89Y5R0m1ab9N3Q6N2r/C7RHWnGlqzGnqdlczEUvPs2nfM8K2thi1adaszHGN/jjjHw4d8Q569g1AAAAAAAAAAAAAAAG1di+PW7O9odDrrX7mlvf6rr4mJ7s6PUTFclrRHP+BbuaiNufexRG0xM1nj9PdHR0n0ZtGzxXra1a/XbPymNfTzNIiZ3enHW05zuxeeE4mMWvp/Wadq4zOM17cx8PB7FraLRFomJraImtqzvFqzG8TExymJjaYmJmJjxfEJiYmYmJiYmYmJjExMbpiYnfExPGHFmMTjs93iqhAAAAAAAAAAAAAACtbWpat6TNbUmLVtEzExasxNZiY6TExvE7TO/T1xaItWa2iJraJiYnnExMTHhMTOTjx4c3ZtFqq63SafVVneMuKtp2/ltttentpfvVmPCYeG2jStoa2ro2jE6d5iO+ONZ8LVmLRPOJaV6zW01n+Ry92MfyFywqAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAANT7W6yMWix6OJnv6q8WtETt/BwzE8+n3svk+74T3beMO10LoTfXvrzHo6VJrHfe8Y3buEUi2ezMcpbGhXfNscN0ZjhMx39sZx/0c7embAAAAAAAAAAAAAAADR/pB47XgPZvW5aW21mtr/s/SbTETXJqK2jJk67x5LTxlyVmIn+JGOJ2id49B9Gujp6R6V0KWjOhs8/4rXzwmmnMdWvf9Zq9Ssx9nrTG+Gzs2l9ZqViY3VnrWzHGImMR+LdPjjnh5H/8AN9o/nwdcAAAAAAAAAAAAAABl+C6GNbq6zeInBg2y5YnnFuf2Kbc94tbnbeJjuxMT1iJ53Se1TsuzW6szGrq5pp441+3bjG+tc4xvi0wyadOvbujfP7R7/fuzudBeP3TiffHvbgkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaFx3Q/VNXOakRGHUzOSNo2iuTf+JX0RG/248Nrbcoq9Z0TtU7Rs/wBXef8AM0cVnM77aePQtOd+cZrPPNe+Gnq16tt3Cd8fv+fmwjqMYAAAAAAAAAAAAAAD1f8ARpx7/bfZrBTLbfV8LtHD9RvbvWvjxUidLmnx2vh2pzmd74snSOUfG/pV0dGwdK6tqRjR2yJ2nT3YiLWtMa1InhPV1Im0dlb0iczvcjatPqaszHq3zaOW+d8x8Zz73QXm2sAAAAAAAAAAAAAAA6B2Q1ff0+fQ2+9gv5bH6Zx5ZnvxER+DJG8z4+Uj0TLzfTej1dTT2iOGpX6u3danq/irOIj/AGtfXrwt7p/bf+W/s3NwcNrgAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAKx1/zl6/y6+rr4CY4xj+dn5uV9o9ZOr4rniu049LtpqeG/c55J/PLa/LxiK9HsOjND6nY9PPraudW3Z6W6mPCkV8JmYbtK9WsR24mfdmIz7vNgnQWAAAAAAAAAAAAAAUnpy6+Ht8P/Xw6kEfz+fzPJ5j+ljjv+0uP14ZhyxfScGx2xWisxNZ12fu31UzMfenHWuLBMTM+TvjyxHdm14n6z9Dej/8L0bO16lJrrbdaLxNvWjZ9PNdGMTwi0zfUjHrVvSZzEVx1dj0+rp9ac5vOd/2Y3R8ePwcsevbYAAAAAAAAAAAAAB1mIiJmZmIiIjeZmeUcoPy5793AdG4Voo0OkpjtEeVv/EzT49+3Ssz49yu1I8N4mYjeZmfF7ftM7XtF7xM/V1nqaUb4jqVnfbExum85tPdiOTc069WsRPGd8+PZ7ox78sk02QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABY8S0VddpMmGdovG18Vp/lyV328OlomaTtO+1pnadm1sW0zsm0U1cz1N9dSI50nj76zEWjO7NcZjMSpqV69cc85jxiJ/KeHv98c2mJrM1tE1mszWY9ExvEx+Uxt/o9rExMRMTmJiJie2J3xLS/k9yiQAAAAAAAAAAAAAB0f6L+OxwftJi0ubJNNJxen1LJFrbUjU797R5LbzEd7yu+CLT0jUW5xEzLy30u6Pnbeir62nSLa2xW+vrOPS+qxjXrExEzjqY1JjnOlHPDW2qnW0+tEZmnpe7nzjhy49z1TH/X+vj/d8gcmd0zz7+3v94IAAAAAAAAAAAAAAZngOsnR8U015mIx5rfV8u/TuZZiImZ6RFckY7zM+FZjxaPSOj9fsmrWIzakfW0x9qm+d3PNetWO+fcrevWpbtiMx45jPZxiZiccu3g6xP8An+bR/np6vGtKd0zH8/dQQAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAtddqY0mj1OpmYjyOG9679JvttSvr715rXbnvvt64zbPpTr6+lpb/TvWJxx6uc2n3VzPuWpHWtEb98xw8d/5ZlxqbWvNr2mZtaZtM26zM85mZ3neZmZmd+b3MRERiIxEboiOGI4Yxyjg35nOPDf+f7Y4KJQAAAAAAAAAAAAAAxPHuK4uCcH4hxXLEWrotNky1xzO3lcu3dwYd9p28rmtTHvtO3e32nZu9HbHfb9t2bY6TidfVrS1sZ6lOOpfHPqacWtjnjC+nTr3rT7UxE90c590PFWoz5dVnz6nPab5tRmyZ8t5/myZbze9tukb2tM7Q+8aenTS09PS046tNKldOkdlKVitY90REO5ERWIiOEREfB8l0gAAAAAAAAAAAAAM7wHRTqdX5e9d8Ol2vO/S2WZnyddvRWY78z6axE9efK6W2r6jZ/qqzjU181jHGKRjrz74nqx25mY9WWXSr1rZmMxEb/GeH7/zDe5nfq8nERHBtiQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJiJ4/zI0ftBovIamNTSNsWp52iNtozR9/ePCLxteJj71vKbxERG/qOh9q+t0J0L5+s0JxXPPSn1MTz6s+jMY3R1YzxautXFutyt584+TX3YYQAAAAAAAAAAAAAE8eS+LJjy47TTJivXJjvWdrUvS0Wpas+E1tETE+ExCtq1vW1LxFq3rNbVmMxatomJiY5xMTMTHYTGYxPCePh/wAvaHZrjEce4Hw3iu1Yvq9NW2opTfuY9VjmcOppTfeYrXPjyRStpm0U23nfr8J6V2GejukNq2OczXR1ZjTtbHWto2jr6VrYxmZ07VmZiIjOcOJq0+rvauOE7s5zjjE/DGc8844bs657EAAAAAAAAAAAAAApMzG20zE79Y9UTPr25+O0ymMb84mO/wD6xlMTjlns+MOx8M1X13QaXUzO9smKvlJ/7ym9Mm/r79bfF4ba9H6jaNbSxiK3nqx/sn0qf2zDR1K4vaMc87uGJ3/z37o4L5rqAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAANS7Yaqcek0+jraYtqMk5bxG3LHiiu0WjrtbJeJiNtpmk7bbbO10Jo9bW1NaY3aderWZ+1fPDvisTnHDrYnMS2NGsZtOJ3RERM98zPh6uPlvy549M2AAAAAAAAAAAAAAAHD/pk435PT8P4DhyzFtTb6/rKVtt/AxTbHpaZI8a5M8ZckRv97TUtMcqy9/9Btg62rtPSV6xNdKP8NoWmP8AtLxFta1eya6c0pM44atoieLf2PT9K2pO+Ijq1nvnfPHE5xiPfMdrz++kuiAAAAAAAAAAAAAArETMxERMzM7REeMzyiPbPgTMREzM4iN8zPCI7ZHR+GaONFpMeKYiMsx380xz3yW6xv4xSNqR4fZ3jq8Xt20ztW031ImZ049DSjspXPL/AHTm05zObY4REN3Tr1axHvnfPGeOY58o/wCm/INNcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABZcR0ka3SZsG0Te1e9jm3KK5a868+cxEzHdtMR9208vBs7Hrzs206ermerFsakRzpbdaMc8RMWiJnjWvipqUi9Zjnxjxjh8vBzW1Zra1bRMWraa2iesWiZiYn2TEx8OT20TExExMTExExMcJid8THdMNLhOFEgAAAAAAAAAAAAADuv0N8aiL8R7P5bzvfbiejrad671jHg1dKz1i01jBkrSOUxXNbaJi0z89+nOwZjZekqV3RnZdeY4xHpamhM8sdadStpnfGaRmcxjQ23Tz1dSOUdWZiOX9Od/bM7/AMne3zlzgAAAAAAAAAAAAAAG+9j9VFsOq0Vp+1ivGoxx1ma3iK5Ij0RW1aTPPb7e+2+7zvTejMX0deI3XidO09k1nNfjHW4/ZYdau6LRjhNZ7omd3hPH3ceWdzcFqgAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAOW9pdV9Z4tmis7001a6avLb7WP7WTp07uW+Svr7u71/RejOlsenM7ras21ZjHK26ue/qVrPv7m5pR1ad8zM57uEdvGIz5Y54F0WQAAAAAAAAAAAAABG0xXeZmIrETNpnlEREbzMz4bf02338ExGZxG+ZmIiOczKYjPjy788PDHP+S8a9r+Mzx7tFxLiNZmcN89sGliZ320um/g4J8dpvWnlLRvMRfJaN52h9z6F2GOjujNl2Wf9SunF9bHPW1fT1I5bq2maxPOKxudrRpFNOteeMzy3zjOI7IndHHdjfva26jKAAAAAAAAAAAAAAzfAdH9Z1sZb13w6XbJb0TknfyNd/D7UTfx37m3Lfdy+ltp+o2aaVnGpr5069sUx6dvhMV8bxjey6VetbPKu+f2j9/c32es/58OX9Hk44R/1bYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADRe0Gj8hq4z0rtj1Md6ZiJ2jNXaMkeiJtG1vXM2nbrEep6H2n63Z/qbTm+hisZnfOnO+k98V31zHCIrE72prV6tsxwtv98cfOJ9+7gwLrsQAAAAAAAAAAAAADOdm+L34Fx3hvFK86abU4/L18b6bJPk9TSJmdt5wWyd3r3bxW3PbZz+ldir0j0ftWyW46ulb6ufs6tPT0rduI1K1z2xmMxmVNSkalLUnnE47p5T8XtHHkrlpTJjtF8eSlb0tG0xat4i1bRMdYmJifz/p8JtW1LWpaJi1bTW1ZzExMTiYn3uHMTHHvj3xxhNVAAAAAAAAAAAAAADMcA1UaTiumtMz3M1p02SN+W2aO7SfHlXL5O07x92J6bzLR6S0frtj1YjHW04+truzPob5juzXrRE9+J3K6kZpOOMRM9nDfj3xE+OccXWHjWiAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAA+Op1FdLptRqbRvGDDky7dO93KzaK9Y52mIiP8Am2ZNLTnW1dPSjjqXrTw60xEzPdETme6GXTmJmteEzOM8t/b/ANHF73tkvfJed7ZLWvafTa1ptM+2ZmZl7utYrWtY4ViKx4RGI/KG38oj4RiPyRSAAAAAAAAAAAAAANK+kHjNuC9luI5sV4pqNXWOH6aZ6xk1cWpktT/nx6eM2Wk9ItSJno730b2GNv6X2XTtGdLRtO06sb8TTR9KsT3W1fq6T2xaY55jY2an1mpWOVfSnsxGJjPDdmIjtnPc8iPtTsAAAAAAAAAAAAAAAOicH0n1TRY4tERlzR5bJ6Ym8RNaz66U2jad4i3eeN6S1/8AE7XeYnOnpf5enHKerMxa3f1rZmO7Dc0q9Wsds7598Ru93myjRZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGO4rpI1miy44jfJSPK4tuvlKbztHv171OfLnv1iG5sG0Ts206d/6LT9Xqco6l5jM/dmIt7sbomZU1K9asxHGN8eMfOMw5w9o0gAAAAAAAAAAAAAD2A9Y/RrxieLdltHGTJF9Tw2bcNzbz9uK6eKzpptvMzO+mvirFp+9al+czFtvjf0q2H/AAXTGvNa9XS2qI2rT3YrnUmY1Yjlu1a3mYjhFq8phyNqp1NWZiMRf0o8Z9b89/vb+821gAAAAAAAAAAAAAFYmazFqztasxNZjrExO8T+U8yYiYmJ3xMYmO2JHZdDqY1mi02piIic2Kl5iJ3itpjbJXeOvdvExE7b8vDo8LtGlOhr6ujOf8u9qxnjMZ9GffXE+9p6kdW015RMx44md/bwxEbu2OS6YWMAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAABrXarVeQ4bGCJ+3rMsY/X5PHtlyf17taTvExNbz4xy63Q+j9ZtU6kxmNCk3+/b0K/DNrR2TWJZ9CubZ3+jG/HOJzG/P5d8OaPVNkAAAAAAAAAAAAABSZ29HWN9/QR8/ygedfpj4xGo4noODYsnepw/BOp1NYmdo1Wr28nS8dO9j01aZKztO1dTPPnaI+nfQfYZ0tk2nbr1xO1akaWjMxG/S0Mxe1Z44tq2tWe2dLhuh0tipitrzGetPVif8AbXOZ8JndjEcHGnum8AAAAAAAAAAAAAAyfCNHOs1uKkxE48cxly77bd2sxtWYnlPfvNa7THSZmd4iWj0jtEbNsupaJxe8Tp0xnPWtE74xvjq1i1s54xHPGb6detaI5Rvnwjj8eDos/wDn/Xm8ZWePHdON/HhG/hHHi3Y+HHz/AH4iQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABz3jWknS67JMRtjz/wAbHPvTPfr7a339P2Zrvzew6M2j6/ZaRMzN9L/Kvnn1YjqW99cZ74lp6tereeyd8e/j8J/LDEugxgAAAAAAAAAAAAAOtfRDximh47qeF5bTFOL6aIwxv9mdZoovmx1tv07+ntqYi3Oe/FKbT3t48Z9NdhttHR+ltlIibbFqT9Z2/U6/VpaY7erqRpTMfZm1uTT2ynWpW8RnqTv34nqzxx78efJ6WfKnLAAAAAAAAAAAAAAAdF7I6qcvD8mmtMzOlzT3d/8As8sd+sflk8rHo22iOjy/TWjFNopqxGI1qel33p6Mz+HqfCWtrxEW62d8/njn254Zz27m1uOwAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAOc9rtTOXX4tNE710uKN45T/Ezfbv6tpxxjj1TvL1PQul1NmvqzG/WvPHnSm6P7utPL389vRjFM/anPLfEbomJ8ZmMdsS1V12UAAAAAAAAAAAAAB88uSmLHky5LRTHjpbJe0ztFaUibWmdufKsTP5eK1K2vetKxm17VrWI4za0xER75mIWrvmIxnO74+6c4eKePcTtxnjPEuKWiaxrdXlzY6W2m1MM27uDHaY5TOPDXHSZjlM15cn3no7ZI2HYdl2SJiZ0NGlLTEYi14jOpaI37rXm1uM8eLt6dPq6Vp9mMe/nPxYlurgAAAAAAAAAAAAAN47PaTyOktqLVmMmptvG//Y05U5eETaLW38Ymsxy5z5XpnaPrdpro1nNNCMTEY36l4mbTM90dWvdMWjuja0a4r1udvKOH5592GwOSzAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMHx/SfWNF5WtZtk00+UiY6+StH8Wvs27t59zlymXT6I2n6na/q7WxTXjqTmN31kYnTnPbObUjl6cd0zh1q5rmOMTM57pnfH7x4Y4zv0N61qgAAAAAAAAAAAAAMhwriObhPEtBxPBEWy6HVYdTWkztGSMV4tbFaY593LWJx322nu2nad2ttmzU2zZNo2TUnFNo0dTSm0b5r16zEXiO2kzFo5ZiMq3rF62pPC0THxe2tNqMeq0+DVYbd7DqMOPPit+LHlpGSk8vTW0ezpvL4Jq6dtHV1NK8YvpXvp3jsvS01tHutEx+0OFMYmYnjEzHwnD7MaAAAAAAAAAAAAAAGzdlNVbBxPyO+1dXhvjmPDymOPK0tETM7TFa5Kxy/nn8+V0zpRqbJ9ZHraN627+pbNLRw7ZrMz3RHhTVjNN/9MxOO6ZxPfuz383Sp/r0+H+nR5Rpfz+fz4gAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAKxMRvM9IiZ8P689+nX+/SBMY357P578ZxndlxriOpnV67VamZ38rmvNfVjie7jj/w461j8nudm0o0dn0dKP6NOsT7Uxm0++0zLdrXq1ivDERnx5/nlZs6wAAAAAAAAAAAAADQvpH4vbhPZTXzjt3NRxDucNwzvETEaneNRMRvM7xpK54rMTvW81ty25+i+i2xRtvTGz9aJnT2bO1anHf8AVY+q3xjdOtOnmJ41iY35ls7NSL6teMxWOtPDlwjf22xv3YjdnO95MfZnX/kAAAAAAAAAAAAAAPvpcFtVqMOnp97LkrTfbfuxM/atMRzmK13tMRznbaObFr6tdDR1Na/q6dJtMc5xG6sd9pxEd8wmIm0xEcZ/n/V0/HSuPHTHSIiuOtaViI22rWIiI/pEPDXtN72vb1rWtafG05n829EYiI7N0eSSqQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFLVi1ZraN62rNbR6a2iYmJ69YmY9G3gVma2i0TMTExMT2TE9aJjsmJ4eEdiMcY45z+fJzHWaadJqs+nnf+HkmKzPjSdppP51mN/Xu9zs2tG0aGlrV/7SkTMdlo3Wj3WicdzStXq2mvZP5cvyWzOqAAAAAAAAAAAAAA9U/Rdxe3EuyumwZLd/NwvLk4faZne3kaTXJpd/RFMGWuKvLaa4eu8W2+P/S7Yo2TpjU1KV6untlK7TERGI69s01cbsZtqUm88835RMOTtdIpqzMRiLxFo7M8J5c5jPH8sOjvLtUAAAAAAAAAAAAABcaTPbS6rTamnXDmx5Num9a2jv138ItXes+qZjxY9bTjV0dXSnhfTvXhnEzWYicdsTiY74MdaJic4mJzjjvjH8y7PW0WrFoneLRFomOkxMbxP5xLwkxMTMTumJmJjsmN0tC3GfHf48/dngqhAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAADG8Y1P1ThuszRO1ow3pSfGMmWPJ0tHpms2723/K29h0vrtr0NOd8TeLWzwmtPTtE90xGPeyaURbUrE8M+Xb2eLkMf5/n+eyOj2rcAAAAAAAAAAAAAAAed/pk4rOXiPDOD0v/AAtJprazNWLbxbPqrTTF34588WHFM03neK57ctpiZ+m/QbZIpsu17bavp6+rGhSZjGNPRiLX6vde94i26MzpR2OnsVcVvfHG2I4cI48OG/j4bnF3u26AAAAAAAAAAAAAA2fs1pYvmzaq0bxir5PHvHLv352mJ2na1aRFfVGTn4OF05r9XS09CP8AtJ6+p7FeETx3TbfyzNIiJ4wz6Fd827N37/l+/c3F5xsgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANR7S6Xa2HWVr97+BkmNusb2xzPPf7vfjfnyrEdZjf0PQmvMxq7PM8P82keMxXUiN3DM1nxmZxxa2vXExaI47pnvjhn3eTVXfYAAAAAAAAAAAAAAHXfoe4rOm45rOF3v3cXE9J5THSf5tVou/krFfXOnyai08ucY95n7MPFfTfY/rej9Da61zfZNbq2t2aW0YrOe762ulEZ4Tbdxlp7bTOnW2PUnj2RbEb/ABmI9+HpN8scsAAAAAAAAAAAAABSf67/APSevo/uH88XWuA6idTwrR3tMTamPyNucTO+GfJxv02maRWZ3jfnMz4vGdI6UaW2a9YjFbW+sjw1I6043Rui0zEY3btzT1K4vOOEzGPf5b8/9MMu0mMAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAABqPbDUdzSabSxMxbUZpyz/AOzwRtMT718lJj3JdvoTS62tq607409OKR7WpPGPCKTE+02NGu+bZicRHxnt8MY789znr0rYkAAAAAAAAAAAAABSZ239X+vT2RuHnyeL+1PE54x2h4vxHv8Afpn1mSuG0dJ0+DbT6bu9J28hix+Eb9dond926I2SNh6M2LZer1baehSdSOf1up/maue/6y9su5pV6mnSvOKxnxnfP5ywDpMgAAAAAAAAAAAAB19YOk8K031TQ4Mcxte1fKZI5xPfybWtWfd5U3/5fREPFbfrf4jatXUifRi00pPGJpT0azHdbE2jh605jLd069WkRPHjPvlftRcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABZcQ031vR58EfftTfH/AO0pMWpEz4RNoiJnaeU9Gzset/h9p0dWfVrbF57KW9G+7nOJzEdscY3K3r1qzHPl4xvj5Oaf6TMT7Ynaf7vb8eDRjPPiAAAAAAAAAAAAAAy/AeIzwjjXDOJRa1Y0eswZck1528jF4rnrEePew2vWa/zRMxvG+7S6R2WNt2Ha9lmImdfQ1KVieHX6szpz3YvFZzymM8lNSvXpevbWY4c/5jHY9r1tW9a3rMWpesWraJiYmtoiazExymJid4mOW3tfBZiazNbRMWiZiYmMTExmJieyYndhw5jG6ePZ58/+sb0kIAAAAAAAAAAAAAAb72O1E2w6zST/AMPJTPTfrtkr5O/r23x0nn4zPON438705pxF9DWiN9q207Tjd6M9avdn0rRu5RDDrVjNbTwxMT+3Kc4z7s57m5uC1QAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAD+4Oa9q9TGbicYa9NLgpjt6PKZP41p/RfHH/AIZ9L1XQ+l1Nk+snjrXtaPZp6ER+Kt58JbmlGKZx60zOZ44jdEfDf72susyAAAAAAAAAAAAAANY7ZcSnhPZnjOtrfyeWujvhw3idpjPqpjS4ZrtO+9cmatuUTttvttEzHW6C2X/GdLbDoTXrUnXrqakYzH1ejH11+tu4TWk1488c9+bQr19Wle/M5iMYj0uyeOJjPhDxs+5O0AAAAAAAAAAAAAAyHC9N9a12nxT9yL+Uyct96Y/t2rPv7RTfwm2+09Gpt+v/AIfZdXU/qmvUp7V/Rifu5m2OeF6V61ojlnM+Eb/+PPc6R/kR6IeJiMfzj3y3RIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAI7P5v8AHlz8c4HOuMaWNLr81I+5efLU23jauSZmY9lb96sb+ERvzez6O1519k0rT61I+qt40xETPfNeracbszOGnqV6t57J3x7/AJTmGMbzGAAAAAAAAAAAAABxevuwPE68U7KcHzd/vZcGm+o6iJne1cuht9Xjveu+GuLLG+89zJTed3xP6R7JOydMbbp9XFNTV/xGnOJiJptEfWTjliupN6Tw9KtsZjhx9pr1dW8TznrRjhif3zx8MRiIbk4bXAAAAAAAAAAAAAAbF2X1E4OLY6TP2dTjvgmJ6bxtlpPoiZtjiu8+FnM6W0vrNjvbfnStTUjwzNLR8L5+6pqxE6fDOPS5c56s4z3dnPficbunPJNIAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAA9omN0x4w43xHUfWuIazURzrkz5Jxz6ccWmtP/AIK15R06c4iJn3Gy6c6Wz6OnMYmmlSLe1MZv/dM7+9vRHVrWO6OWOUZ/PMbuxZthIAAAAAAAAAAAAADi30z8R8lw3hPDK32tqtXm1eWsTznHpMcY6d+In7tsmp3r3o2m2OZjeaTt7v6C7N19r23a5ru0dGmjS0xu62tabWxOOMV0sTicxF+yW9sNfSvfsjq/GYnj7vH3ZeeH010gAAAAAAAAAAAAAG29mdPHd1GqtH2pmMFJ9ERtfL4+M+T25fyztPN57pzWnOjs8TGMTq3jnmc1p8I6+Y74Z9Cu+Z90fHM7+HOIjm2twGyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1ntLpothwaqtftYrzivMR/Jkjem8+it4mI3255JjrLudCa3V1NXQmd16xqUiftV3WiO+1ZzPdTua+vHC0ccxE+E8M/Ce6ObTXpGuAAAAAAAAAAAAAA779DHEqzh4xwm9tr0yYeI4ce/O1MkfV9TaI8fJzj00Tt+ONt9+Xzn6dbJPX2Hba19G1b7NqW7LVn63RiZx/VFtbGZx6PLDQ22kz1L8sTEzu3TG+scf6t/wdzjn/n/o+eucAAAAAAAAAAAAAAuNJnnS6vTaiI38hmxZJiPGK3ibR696xMbf+THraf12jq6W6PrNO9InsmazET7pmJjvhExmLR2xMZ7M8+92jlMRas7xMRMT6pjeP89npeDmMTMTxjdLRmMc+6e7h++Y9wIAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAWnEc0afh+rzxMROPT5piZ/H3JikR67WmtY38WfZdP63aNDTxnratImP9vWibTu5RWJme6GTTiJtET2x8M5nd3RG/fw7OLjMdZ5bR/158o228Z6f9Hup4Rv92I3cvHlHL925me3+fyZVQAAAAAAAAAAAAAKT8eXt6+jp7T+SPK/0qcQ+u9rdRhrbvU4dpdLoo2netb9ydTlj0d6Mmpml5jn3qbTH2eX2D6H7N9R0LpXmMW2rW1tecxiZr1o0aTPPE10otWOUW79/X2WvV0onGOtMz4xG6J9+MucPUNkAAAAAAAAAAAAAB0vhuD6vodNimNrRji1un38kze++3WYtaY3meURt4Q8TtuvGvteteJzE3mtfZpitcRnhMR1u/MzzbunHVpWMYnGZ48Z7eye5etVcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABa67B9a0eowdZyY5isdI79ftUnfw2vFebNsurGhtOlrTmIpeJtO/1ZjF8cc+jM58IjGcSpevWraO2Pz5THe5jz8eU+MeiXuuPBpAAAAAAAAAAAAAAN9+jTiNeH9r+HeUv3Meurm4de3LnbU03wV58vt6rHgpHrtHXpPnPpXss7V0JtXVr1r7POntVY5xGlbGpb7ujbVme6Jjnlr7VXraNufVxbhndE7/AIVmZ5eMPWUdI/z/AEjl6OT43PH+fOd/b3uRPGf5ju8Y596qEAAAAAAAAAAAAAAOv8IzxqeGaLNE774KUtM779/F/CyRz58r0tHx8Hidt0p0dr2ikxj/ADLWjs6t569cd3VtDU1Y6tpjvzjPDO/98x4zywyLVYgAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAGt9q83k+FTj3j+Pnw4p39FbTm2jn6ccf19jq9D06+2Rb/u9PUv8AGIp5Xn3M2jvt3REz8cR/PBzN6ttAAAAAAAAAAAAAAIZL1x0vkvaK0x0te9pmIiK0rNrTMzyiIiJmZnltErVrN7VrWOta1orWI4zMziI3b98zjcmOMY48vHl8ZeH+Jau2v4jr9deZm2s1uq1VpnnO+fPfL/8AN06R0jlD7/sujGzbNs+z1xEaGhpaMY4f5enWn7e/i7tK9Wta/ZrEfCMLJnWAAAAAAAAAAAAAX3DcE6nXabFtvE5Itf0dzH9u+/KeUxWY59ZmI8Wrt2t9RsmvqZxMacxWefWv6FceE2ifd2LUjrWrHLMZ8I8e3h7+10rf/P7/AOS8REYjH8lvCQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOI5xxbB9X4hqabfZtfytJ223rl+3y5z0mZrM+msvZ9Ha31+x6N8+lWsadu61PR38ONYrbws0rxi8x2748J3x393uY5uqAAAAAAAAAAAAALjSai+k1Wm1ePeMmm1GHUU2naYvhyVyV2nwnvVjn4Metp11tHV0berq6d9O3s6lZrP5Si0ZiYnhMTE57J4/k9w6XUY9XptPqsVovi1OHFqMVo6Wx5qVyUtHOeU1tEx/p0fn/AFdO+jq6mjqVmt9K99O9Z41vS01tE+ExMODaOrMxPGJxv7n3Y0AAAAAAAAAAAAAAOkdks/lOG5MMz9rBqrxt4xTJWt6z7JtN9vRO8R0l5fpqnV2qt8btTSrv5TakzWffFernxjfvauvHpRPbEflM/wDHFtDjsIAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAADQ+2OffLodNE7RWmXPaPTNprSm/simTbx5z0jr6LoPTjq7Rq85tTTjuiIm1vj1q8ezdzbOhG61pjdM4j4dv7d0tLd5nAAAAAAAAAAAAAAaf291/8As/slxvNW3dvl0k6OkxO0xbXWrpZmsxzi0UzWtWY2mJiJ6bu39Hdnjaumtg05jNa60a9oxmJjZ4nXiLRw6s204ic7pzjG9n2evW1qRMcJ634cW8o4PH8ev/P6vtrsgAAAAAAAAAAAAANo7M4JnLqNTMcqUrhrO3KbZJ71tp9Na1rv78S4PTurEaWjoRvm9p1LRnf1axNYzz9KbTjdOZrMc2fQjfa3ZGOc8fDu84bg862QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADoTwn+ee74jUu02n56bVR4xbBf1bfbxz+cTePVtHpeg6C1d2toTGMdXVr4epfPGIx6Ex29aexra8b627sTPxmPOWqPQMAAAAAAAAAAAAAAH8/n873rb6Odf9e7H8JtNu9fSUvoLxM7zT6rltjxxO3TbT+SmN5+7NenR8X+lGz/4fpvbYxiutam0V5Z+upFrz351evntnPi4+1V6utecetOY+EZnvzv9+exvTz7XAAAAAAAAAAAAAAbf2OzdzVavT78suGmSN/GcN5r49Z2zTM7bb7bzHLeOJ05p50tHVx6mpas47NSM+7fSIjO/4sOvHoRPZbzifl/0zv6C801QAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAFYjf8v8ArEf6iYjM4hy7tPn8rxfNWJ+zgx4cMeibd3yluvotkmvLxjbns9d0Tp9TYqTjfq2vqT2xi00j3TWkTv5Tnm3NKMUiOeZz2cd2GvukuAAAAAAAAAAAAAA4z9MuvnFwnhXDaztOr1t9Tk25TOPR4ZpWsx+G2TUVvt+LFWfB7r6C7NF9s2zapjP1GhXSr3W175mY7JiulNfC845t7YqxN727K4+M7+/hEd+ebzq+nOkAAAAAAAAAAAAAA6BwLBODh+K1q7Wz2tntHpi20U5+vHWsx6peP6W1Z1dsvWsxNdKK6WZ376xm2I7r2tGJ5w29GuKRPOZmf2j8o/NmHPZQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGL4zp/rHD88REd7FEZq7/93O9vzmneiPTO0N7o3WjR2zRmZxW8zpT/APU3R/d1ZnO6IiZY9WM0nuxMe7/jLnb2TTAAAAAAAAAAAAAAegPoX1020nGuGzbeMOo0+ux18Y+sY5wZpiOu0zpsG+3Tb0zG/wA3+nezxGtsG1RGJvpauz2nt+qtGpSJ/wDN1MePZE45+21jrUtMcYmsz4TmPfvn49zuD5+54AAAAAAAAAAAAADN9nc/kOL6WZnauWb4LevytLVpH/vfJz+XhPONDpPT+s2LWxxpFdSPuWibf29ZW/qzxmYjMY7uP5Z97q0/5/ns9nseOadt0+7E+6Zjn3Y/bcoKgAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAKx8Of9/bHjy/MTG6fjv7Pyny+HGONcQyxn1+syxMzF9TmtWd996+UmK7c5jbuxG3qe62an1ez6FMY6ulpxO7fnqxnv4zP8hvVjERHZER8I96zZkgAAAAAAAAAAAAAPM30v8AEPrPaTBoa2macN0GKlonlFdRqr3z5No/9h9Vido6xPsj6v8AQnZvqui9TaJiItte03tE9ulo1rp1j3aka0x2RPbl1djrMac2nja27wiIiP3coexbYAAAAAAAAAAAACVKWyXpjpzvktWlI9NrT3axz9MzCt7VpW17TitK2taeytYmZn3RBEZnEcZ3Q6njpGLHjx16Y6UpHKI5UrFY5R6Yjm8He86l76k5zqXtec9tpzPZ29kN+N0RHZEJqpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUtWL1vS0b1tW1bR/wAtomJ8J8JItNbUtG61bRas99fS/bCJjO7lzjtjHBy3NitgzZcNvvYsl8cz6Zpaa7x6p23h73S1I1dPT1a7o1KVvEc4i0ROJ74zie9ozGJmOyZj4S+S6AAAAAAAAAAAAAHTPon186TtXj08ztTiOi1Okn0Renc1eO234v8Ad7Y4nwjJb0y8p9Mtn+u6GtqR62y6+jreNbTbRtHh/mxaeO+seMa21U6+ln7Notw5cJjPLdOfdD1I+ROQAAAAAAAAAAAAAA++mzRg1OnzTO0Ys+LJPspetpj+kSx6tPrNLV0/t6d6/GswTEzExGMzExGe+P5+ztU8+fLn6Ofx58/W8G0JzOM9m74z++VBAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAD4arNOn0uqzx1w6fNkj1zSk2iPzmI/PlPLdl0afWa2lp8YvqUrPhNoifyytWIm1YnnaI90zvcWjfx6+P+fDx9PN7vw4N7wAAAAAAAAAAAAAAAeNu2etjiHanjuorMWpHEM+nxzE96Jx6SfqtLVmOtbVwxas+MWiX3LoHZ52bofo/SmMW/wANp6lonjFtaPrrRPfWb9WfB29GvV0qR/ticTyzmce7OPd3tYdZlAAAAAAAAAAAAAZXgmGc3EtPy+zitOa0zziIxxvWf1zSPzc/pTUjT2LW3xm8RpxEzjPXnFoz7HWnwhfSjOpWPGfhGY/N0N4/9v8Ar+7dAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaBx7DOLiOW221c9aZq/nHdt05b9+lpnp16c3ruitWNTY6Rz0rW0p909avu6tqx7mnrRi89+Jj37vPPuYZ0mMAAAAAAAAAAAABnezGvjhfaHg2vtPdx6fiOmtmmNt/IXyVxZ+vj5G99t/wCsOf0ts07X0Zt2zxGbauzasUjt1IpNtPhv/wBSteDHq162nqV+1Wfjjd5R8pe03wdwwAAAAAAAAAAAAAFJ8OW+0+n8j+fzGf58UxzzwiP+I/OYdm4fl8toNFlme9N9Lgm0+m3cjvb85/m3/wDV4baqfV7Tr04RXV1Ijw604x3Yxho6m69o7Jnh2cuO/gu2BQAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAABhu0GbyPB9bbeN7464oieW/lclKT/SszafVEt7o2nX23QjlW03nnjqVtaPziI8Zhk0ozeO7M/CHKHsm4AAAAAAAAAAAAAAtNdqY0mi1mqnppdLqNRafCIw4bZZmZ8IiKzPP0SzbPpTra+hoxvnW1tPSiI379S8UiPfnyWrGbRHbMR8ZiP3eHL3tkve9pmbXta9pmZmZtaZtMzM853mZ6v0DWIrEVjdFYiIiN0RERiMO7G6IjsiI7uHLuRSkAAAAAAAAAAAABtPZjFM31WeY+7SmKJ9603tEflSsz6N46uD07eOpoaWeNr3mO6tepGfHr2x3wz6Eb7W7sfHj5R8W3vOtkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABqnafDO2lzxE7RN8Np8OcRekT/TJMex3+g9SM7RpTO+epqVjujNLedPi1teN9bdmaz+Ux/x72pPQsAAAAAAAAAAAAACsTMTExymJiYn1x0OI9u8G1Ua3hPDNZE96NXw/R6mJ/8AbafHkmOc77xNuceE8vVHwHbtH/D7btehMYnR2nX0sexq2rE+ExG7HL4zw9SIre1YzutMTnx/LvjwZJqsYAAAAAAAAAAAABPs35x/6iYzy9/hG+fJ1HszmjLwfT133nBbLht/4ck3rH5Y8lIeQ6VpNNt1Z5akUvXwmsVn+6tmprxi+e2sTHwx798fLcz7nMIAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAADVO1+Sa8P0+OJ28rq67xvG81pjyTttHP701nfpG3Pk7PQlc7TqWxnq6Nojum1q4/KJZ9CPStOcYru8cx8ODnX+f5/n9Xp2yAAAAAAAAAAAAAA0v6QtdPD+yHGstd+/n00aGvPb7Ouy49Ll57dfI5ckxHjttG2+7u/RrZ42jpvYKz6unqztE7s4nZ6W1af/AGStWxs1c6tInhnrY7ermYz4TGfc8hvtbsAAAAAAAAAAAAAAN97P4ox8Opbbac2XLkmfGYiYxR/bHy9ryXS+p19ttX/u9OlMcuepM+/6zHu5xDb0fU98z+37M25jKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAw/HcXlOG5p6zitjyR13ja8VmeX/Le3sjeZdDorU6m3accIvF9PjGJzXrRHbnrVjDFrRE0ntjE/Ccfl1nP3sGoAAAAAAAAAAAAAA9Y/RlrLavsdwyL2719LbVaSZnrFcOpyTij/AMOHJjrHPfuxXk+N/SzRjR6c2vEYrqxo60eN9KsW+N63t4zPu5G1V6utbdunf75iJn8/zmZ5t/ebawAAAAAAAAAAAAADoPY/Jvo9Xi3+5qK32/8AaYojfbrznHtv6I6TMPNdOVxr6Nu3SmufZvM/l1/za+v/AE9/dPLhv987u5t7iNcAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAjrH+vT8xMcY8Y82j9s8sTbQYImZtFc+W8e2cdKb895neuSN+m0bPQ9B03bRqTHGdOkT4Ra1o/OrZ0c4tPLMY7d0c/dj82j/wCf1d9mAAAAAAAAAAAAAAcm+mHVxh7N6XSxO19ZxTDHd3+9h0+DPlvb2Vyzgjbfrbd7L6EaM6nSutrTX0dDY7+l2X1NTTpWPfT634ce3c2KJnUmeUVtnxzWI+MTPwnfyeaH1Z1AAAAAAAAAAAAAAHT9Hh+r6XT4doiaYccTt+KaxNp5fitMzPrl4XaNT67aNfV49bV1JieHo9bFY91YiPc3qRitY3erHjy/Lj+S5YVgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHyz44zYM+GY3jLiyU8f5qWjfbnzjf/J5r6V/q9bS1N+aalLRx3dWazO/hjd5xG/KLRmJjjmJhyyY2mYnrHKXvWgAAAAAAAAAAAAAA9F/QxroycH4rw6edtHxCmqjeZ5Y9dgrSsR4bRk0eW3tvPpfMPp1s8027Y9pj1dfZraU+3s+pNpn3116R7vFzdtri1L/AGq45Y9HM/nmPzdleGaIAAAAAAAAAAAAADcux2bu6nWaf/tcFM0c/wDsLzT+v8ff17OH05p50tDV+xqWpP8A9SvW/wDyf5sWtHo57JxPvifz5x4N+ebagAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAADm3ay/e4rWu+/k9Lhr6udsuT/wCfn4/2er6GrjY8/a1tSfhFK7/g3NL1O6bTjwjdHfjc1h1WQAAAAAAAAAAAAAB59+mrUTbW8C0u/LDptbnmu/LfUZdPjiZ9e2nmI/OPF9K+geljQ6R1sevq6GnE/wDy6alpj/7LHj7nR2GMV1LcZmaxy5RM/vv8O5xF75vgAAAAAAAAAAAAPvpcc5tTp8Uf8TNjp7IteImfyiZn8mLX1PqtDW1Psad7RnnMVmYj3ziPemsZmI7ZiPjPvdR2iOn+f5/m7wn7zM/Gc/m3wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHMtfi8hrdVh22imbJ3Y26UtabU9X3Jq9xsmp9bsuhqcZtpUzvifSiMW4f7olo2jFpjsmcceHLjvWjYVAAAAAAAAAAAAAdm+hjURTi/GNLvt5fh+LNt6Z02pikT69vrU/ql4X6daXW2LYtb/u9pvp/+bpTaf8A71n3NLbYzSk/7pj4x+Ubvjh6KfMXMAAAAAAAAAAAAAAbF2Wydzi+OP8AtMOenPbafsxk2nx/k5bePo5S5nS9c7Fefs6mnPxt1c/3Y97Hqx6E9sTHniMeE/Hl2unPJNMAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAByntFkjLxjWTE7xS2PFHq8nhx0tHLr9utufi9j0ZXqbDoRMRmYvacc+tqWmJ8erMN3T9Su7GYmYjumZwwrfXAAAAAAAAAAAAAJ/L852/0kHl36WtZGo7W3wRO/1Dh+j01o36XyRk1kztEztM01VOU89ojo+ufQzQ+q6FrqTG/adp19aJ/21muhHuzo2+Lq7HGNHP2rzPjjEft/MznmL1jbAAAAAAAAAAAAAZfgWPynE8HSYpGS/PfaO7jtEfn3pjaZ5b7bud0rfq7Dq/7ppTxzeJn8omfCJZNKPTjsjf8At8MzDoLyDcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaDx/H5PiWSdtoy48WSPX9nuTP8AWkvW9EX6+xUjOZpe9J7t/WiPhaGnqxi89+/9vOJ8ODCumxgAAAAAAAAAAAAOhfRfq50vbHQY95iutwazR3nw2tp76ikTHjE5dPjjbwmYnweZ+l2hGt0HtNuM6Gpoa9fGNWulbfyxTVtPfEY55a+1RnRtOIzWYtGfGI/fuy9Wxvz39Pq38Ou0Rz/zd8d7O6Pn8HInf/P5y3e5UQAAAAAAAAAAAAAyvA8vkeL6C2+3ezxi/LPE4Z/L+JH+Q0+kNP6zYtojs05v/wCX/mf+iUWjNZ8M/Df+zrbxbQAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAI6x/r0/MHGuIX8rxDXZPxazUz133ic1pr7dq92Il7rZqxTZ9Csf06OlHZvjTrns4znk6ERitYzwrWMcuH7eM5znK0ZgAAAAAAAAAAAABSek/wCc/Dp6xMc/D94ePO3Wo+tdruPZd99tffDHs02PHpoj8oxRH5Pt/wBHtL6roXo6nbs8anv1bW1Z4995dnZ4xo6ffGd3DfMz+/zam7LMAAAAAAAAAAAAA2Xszj31OoyzHm8MUj1TkvE8vyxzH5+txOnL40NHT+3qzbHbFKTExPvvE+5m0cZtM8IiI+M7vJubzTaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAah2nxxGXS5Y62pkxz7KWrav98luv8A1ei6CvM02nTnhF6XrHtVmtp/srHb7mtrRiazzmJid2OHzmZn+Q1Z3mAAAAAAAAAAAAABsnY/P9W7U8Ay77R/tTSY569M+WuGY5emMkx+focvpvT+t6I6Sp27HrWjx06TqRPumuWLXjOjqR/tl7Mj1ev/ADk+FuLPLtiN/jmQQAAAAAAAAAAAAA++kt5PVabJHKceowX/AEZa2j+kxvv4TzY9aIto61Z3xbS1KzHbFqWjHvzvJ4Tw575745927zdpeDc8AAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAmdomfRG5G+YjtHEclu/kyW696+S28Ry53mfX6fz5y9/SOrSsfZrWvwjHwjHk6ON2e+Y+GPmilAAAAAAAAAAAAAAJiYjOd+7hnGd8PEPGdTGs4vxTVxO8aniOtz1n01y6nJeu3q7to29T79sOl9RsWyaOMfVbNoacx2TTSrWfziXc046tKV7K1jdw4Ma2lwAAAAAAAAAAAAG49maTGDVZNuVs1KRPuU70//jI6/wCrzfTls6uhTPq6drfitjhyzFJjPybOhwtO7GYjv+XOMR492dncNnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAa52lx76TBk2501EV39EZMd5n8t6Vj27Oz0JbG06tN2LaPWjvmt6x+UWmff3Swa0ejHdafzzLSnp2sAAAAAAAAAAAAAuNJqLaTV6bVU372m1GHUV25T3sOSuSNp9O9Y2Y9bTjW0dXRnhq6eppznfGL1ms590omMxMdsTHxe5q2i9YvWd63iLRMeMTETE/nGz8+TE1mYndMTMTHfE4lwZiYmYntnzx5pIQAAAAAAAAAAAAArEzExMdYmJ/pO/+T4GInMTviYmD3Z/n83c3bMdovjpeJ3ralLRMdNrViY58vCfQ8DaOra1Z41tMT7pw0JjGYzvjdjGJ4z+0Z98QmqgAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAABb6zJ5LSarL/wBlp8+Tf3MV7eHsZdCn1mto0+3q6dPxXiP3WpGbV7OtWJ98uLvdt4AAAAAAAAAAAAABZ8Qz/VtBrdTPKMGk1Gbf0eSw3vvy5/y+Hw5s+zaf1u0aGl/3mtpaf49Stf3WrGbVjtmIz2ZmIzv3fF4bfoF3gAAAAAAAAAAAAAG/dn8fc4bjt/2uTLkn2xbycb/ljjb1THg8l0vfrbbeP+7pp0jf216/nfzbejHoZ7ZzjwnGfy/JmnMZQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGJ45Tv8M1HLeaeTvHq7uWm8/pm0fm3+i7dXbtDlFuvWY4Zzp2xHfviJx3dzHrRnTnumJ/OHPXsWnHCOYAAAAAAAAAAAAB6P8APCf6f5HiD23wLNOp4LwjUTO9s3DdDktPptbTYptP9d3wPpDT+q2/bdON0U2raKxE8orq3iPycLU3XvHZa0Rns60sq01AAAAAAAAAAAAAAHZOGXnJwzQW6zOk0/et4zaMNItv+e/Px39O7w+116u1bTGMRGvq4jum9pj8phpanr34cflw7/8AleNdQAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAABjeM27nCdfO+2+my18f547nPbp96f6842bewR1ts2aP/FrP4Z60+TJpx6VZ5Z8N+N3jvzHu5Zche1bgAAAAAAAAAAAAADX+1eXyHZnj2XfbucJ123hztp8lYjw5zMxEet0uh6fWdLdHUxnO27Nu8NWtvhGMz3MmjGdXTjtvXzif5/JeL33Z3AAAAAAAAAAAAAAHSOE17nDtJHpwxb9czf/AOZ4vpC3W23aJ/8AEmv4Yiv7N3S9Svh+8+TINNcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABY8Sp3+H6yvXbT5bfnSs3j+9eXrbWxW6u17NP8A42nX3WtFZ/KZypqepb2Z/n8+E8HNXtmkAAAAAAAAAAAAAA9jdiM/1jslwDJvvtw7Bimev2tPE6e3/wAWKZn17vh/T9Pq+mekq/8A61qX4Y/1Z+t/9fHnDi7RGNbUjst57/3+DanHYQAAAAAAAAAAAAAHWuA27/CNFO8z3cU1/TkvX+kRERv7HjOkYxtu0R/vifxUrb92pqxi9t+fS3bu6Jz+cbmWaTEAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAw3aGe7wbWT+KuOvs3z44mPz3/v1b/Rlett2h3Te3w07yyaXr1jlv8p/n5cHKHsW4AAAAAAAAAAAAAA0n6Rc/wBX7GccvvtN8OnwR6/rGt02CY/TkmZ9UTvy3h3voxp/WdO9H17NTV1P/K0NXU39m+sR4zEcWfZozr6fdMz8Imf5+e55F6vtTsgAAAAAAAAAAAAAfz4OoaTHOLS6bHMbTjwYqTE9d646xO/5w8Jr3+s19a8cL6upf8V5n929SMVrHZWI+EYn81wxLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAI3rGSl6TG8Xpan6omP8AX0T7E1tNLVvHGtq2jlwmJ/JE8Mdu74uVTG0zE+E7f0e/4tBQAAAAAAAAAAAAAHq/6Ls/lexfDKb7zgy6/DO87z/9n6jLG/qiMsRH/Ls+OfS7T6nTu125alNmvw3Z/wAPp0n4zSZ8Zlx9qiI1rTHC0Vn8ojn4OgvNNcAAAAAAAAAAAAAB1Ps1bvcG0sxP3bZ6zE9eWoyTHL1xMTt4RtLyHSsY27V7405j/wAuv75aurnr35RiuO/1fdynh2d0s65zCAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAwHae/d4Pnj8eTBSPyy1v6PGK28em7p9ERnbdOfs01J/smv/qZdKPTrPteX/Llz1rbAAAAAAAAAAAAAAc2+lfL5Psdqab7eX1ugxe3bN5fb188O/5PVfQ2nW6c0pxn6vZ9ov4Z0+pn+/8ANtbH/rR3Vt5PLD686wAAAAAAAAAAAACVK969Kx1tatf6zEf6q2nq1tPZWZ+EZI3zEdrqzwMcIz2OhEY+Mz8ZyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACJ5eO/4T++HLM1e7mzV/DlyV/peY/0e90p62np2+1Sk/GsS0ZjEzHZMw+S6AAAAAAAAAAAAAHpv6Ics37L5ce8/wuKaqu3WIi+HT3jlv+KbTvy5ztz33j5P9Nq9Xpek4/1Nj0ZzHHNb6tZzu7KxG/PJy9sr/m54ZrX375iZ927+Q6q8e0wAAAAAAAAAAAAAHS+yd+/wm0T1x6rNSPRtMY7/APz7/nt4bvK9M1xtkT9rRpb871/9LW1+Md8R+U2+bZXJYAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAGsdrbd3hVI/HrMNf/AMHnt/8ALDr9Cxna7f7dC8/36cfuz6MT1s8sTjxzWP54S5s9S2QAAAAAAAAAAAAAHJ/phv3ezOlp+Pi2n3/8On1U/wCvxey+hFc9K61vs7Fqf3aujH89zc2L/Vmf9s+cfJ5nfVnUAAAAAAAAAAAAAffSx3tVpq/iz4Y/rkrDFtE9XQ1rdmlqT8KWlNfWr4x5uovCROfjMfCcN8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARO+Mdu75/L3jmWvr3NbrK+jU545dPOW9c/F7nZJ62y7Nbt0NGf/sdWhaMWty9KfOVo2EAAAAAAAAAAAAAPR/0NXm3AeJU3+5xW3Lx2vpNPzjbn1iefLbn7Xy76c1x0jstsetsdYzjs1tbdM8909nv3OZtsf5te+kz8M9/d/wAOwvENIAAAAAAAAAAAAAB0TsfaJ4fqq+NdZa0T72HBHp9FZ6xHteY6bj/3nSnt0Ij4al5/dra/rRPd+8/zv9zbHGYAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAGp9sZ/3DS15c9XE/pxZv3fB2uhI/wDedWecaEx7pvTPk2dCc9burP52rP7OdvTM4AAAAAAAAAAAAADjv0z224Fwun4+K7/lXSZ/D/xQ9x9BYz0htluzY8fHW0/lLe2KMXvP+z96z+/m84vqDpAAAAAAAAAAAAAL3h1e9r9HHX/ecM/pyVt/o1tsnGybTP8A4GrHxpaP3Wp69fajzdLeIj+fP38W8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE7omew/dzji9e5xLVxP/a979da38PT3ns+jp62xbPPZp9X8Npr+zS1PXt4sc3VAAAAAAAAAAAAAHoP6FrzOg45j5bU1mkvtv/2mHJWZ9m2OJnxnaIfNfp5XG09H2+1oa9fw6lJ/9c+Ge9ztt9fT762iPGd37w7a8C0AAAAAAAAAAAAAAG/djZj6trq9Ns2KYiPHvUmPhXx26ct3nOnP9XQnt07/AJWif3a+v/THjn3cPOW5OE1wAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAGndsZ/3XRR//MZJ9u2OIn1x1jn05dOrudBx/m689mnWPjfOfyx72xs8b7z3RHnPnWPJoD0jYAAAAAAAAAAAAAJ5xMek4DiX00320HBKcvtazV29f2MGOv8ASJyTv659T3v0DjO09IW7NDRj8Wpef/TDobDxvO/hEd3L8+HwefH0t0AAAAAAAAAAAAAGS4PHe4lpI/7yZ/Tjvb/RpdJTjYdpmOM0iI8bWrWPNfT9euOOXRnjP58W6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH7Inl4x+c48pc+47G3FNT64wz4f9hjienrj+vN6/oqc7Bod31sf/ZdSfKWpq/6lvd+cQxDosYAAAAAAAAAAAADvH0KX5dpKeieEXjfbx/2lFp8Pwxv+U+HP539Pa7+i7d221n//AFZj45n+ZaG3Ru0/v+UY+Hw45d4fO3OAAAAAAAAAAAAAAb32M38nxCPRbTz/AFjNEbf6/k8705HpbPP+3Uj86/8ALX1/6fvft826uC1wAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAGl9sp2xaCPTk1E+vlXH/XrP9Hd6D/1Non/Zp+dvk2NDjbwj92hvRtgAAAAAAAAAAAAA9h4jhf012/g9nafiy8UtH/gpoK8/1zt6n0L6BR/mdKT2U2OPxTtE/s6Gw751Z9n85t8nA30Z0AAAAAAAAAAAAAGW4FG/FNN6vLT/AP4+X/1c7pX/AOA1++dL/wC/acz+USyaX+pX3/pl0J4+P3nj4z/I7m5G+IntEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQOPxtxPNymN6YZ5+P8Ksbx6uW35PW9Ef8AwOnHZfV/PUtb92prTm8+ER8GGdNiAAAAAAAAAAAAAdx+hS0/We0NNp2tg4bbw23rk1kRy67x35mPz6zs+f8A08j/ACejZ5xqbVHutTRz5Rlobdw0/G3lV3983c4AAAAAAAAAAAAABvHY2Y/+sK//AJvP982/x6PP9O8Nm/8Aq/8A5Ng14nFZ5Rn/ANLeHn2sAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAA0ntl9zh/XlfP7I3jF09vPd3+gvX2n2dP8AKbz/AM+5s6HC3fMfl/1aK9CzgAAAAAAAAAAAAAOD/TbP/wC7Mb//AJZ3jw//AIVEfnHOP6von0Cj/wDms/8A7D//ANk/J0dh/wC074p56kODvojfAAAAAAAAAAAAAZjgP/2z0/u5v/xORzulf/gdbx0v/vtGXR/1I7onyx+7oDyEbvz/ADnLbjdER2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG+3+fn/oiYz/x4TH7jQ+0P/wBsbevDi+Ex8Ies6GjGxVjs1NT9Wf3aerGLz34n4sG6rGAAAAAAAAAAAAA7X9C0/wD1hxyN/wD7j0ltvTtmzRv6OW/jMbb8+sPBfTzH+G6P/wDn62PwU/nwaO3erpz/ALrfnEfJ6FfNHNAAAAAAAAAAAAAAbt2N+9r45793T8/zy7/n08HA6d4bN46uf/seP3x72HW9Xu/5j5N6eeaoAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAADSe2X3NB72f4Ynf6C47V4aPnqtnQ4W8Y8mivQs4AAAAAAAAAAAAADgn02ec7N+5xb5uGvo30C9TpT2tj8tqdHYeGp418rOFPoTfAAAAAAAAAAAAAZngH/2zw+5m/wDxVnN6W/8AgdX2tP8A++VZdH148Jb+8jEYjHY2wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmYjj/Of7DQ+0MbcRn14cUz/APFHwiHq+h5zsVf/AJmpjv4S1Nb158IYN1WIAAAAAAAAAAAAB2n6Fv8A7acb/wDzDT//AOxLwn07/wDg9g//AGnU/wDvTS231aeN/wBEvQ75k5gAAAAAAAAAAAAADduxv39f7uD45Xn+nf8A8W/+r/6GHW9X+dsN6efaoAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAADSe2W/c0E/8+f4Yt/7S7/QXrbT2dXS+MfWY/5/Zs6HC3i0V6FnAAAAAAAAAAAAAAcF+myPtdmremOMR+meFz/839n0X6BTu6VjsnYp+MbXH7f9XR2Hhqfcn4zeP2cJfQ2+AAAAAAAAAAAAAzHAf/tng9dc3/4q8/6Od0t/8Dq906f/AN8pH7suj68eEugPIRGIx2NsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABofaH/7Y2/8AY4vhL1nQ8Y2Ksf8AiannENTW9efCGDdRiAAAAAAAAAAAAAdq+heJ/wBo8ctG28aHTViJ9M57zHy+rr1eD+nkz/hdgjlO0asz7tOsfv5NHbt1ae1b864ehnzNzQAAAAAAAAAAAAAG7djfv6/3cHxyOB07jGzTzzq+GI+r+bDrer3/APMf8N6eeaoAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAADSu2UfwuHz/z6iJ6/hxTv6I8I9e07u90FPp7THbXTn4TeP3nw+DY0J9aPCfPk0R6JsAAAAAAAAAAAAAE9J69PDr+XrP5/MjhP02RvXs3bblFuL138eccNnb2T3d49k7830P6BTPW6UjlNdinHhO1R+/l3OhsPHVjn6H5ddwV9FdAAAAAAAAAAAAABl+Bf/bTTeuM3/4jLLndK/8AwGt46X561I85ZNL/AFK+/wApdBePjv7Z85x+TbjhGeOIyJSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArH+f1gGg9oJ34lkjnyxYY5+P2Imfy57PWdDxjYacd99Tj3WmP2aernrzn3eHJhHUYwAAAAAAAAAAAAHbvoVr/vvHrbTvXTaCu8f8+XU7xP6Yn8ngfp5P8AkdHRu3620Tjwpp/P84aG3cNPxv8A+n+fyHoJ81c4AAAAAAAAAAAAABu/YyNp4hzn7unj/wCLJO//AJ9PCPQ4HTvDZv8A6v8A6Pl/OeHXmOrEc5z/AOlvLzzVAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAab2yj/AHfQ2/77NX85pSY5+vaeXqd3oP8A1dojn9XSfdFpz8MtjQic28I/efyiGgvRtgAAAAAAAAAAAAABxD6aq/7nwC8R93U6+u+34sWmnb8/J/ntD3/0DnGt0lXt0tmn4X1Y/wDV7nQ2HjqT29X9/m8/PpLoAAAAAAAAAAAAAMpwWe7xPSz/AM2SP1Yclf8AVodJx1th2iO6k/h1aW/ZfTnF6z4+U+Lojx38+LdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmcfGI+M4c/49O/FNR6q4Y/8AwNJ/1eu6JjGwaPfOrPx1b/vHc09b/Unux5RP7sO6TGAAAAAAAAAAAAA7r9ClY7/aTJO0d2vCaRM9drTxKbRH51rv69vRtPzz6e29HoqvbO22n7sbLEfqlo7dvjT+/PwiJd7fOnNAAAAAAAAAAAAAAbz2Mj7PEJ587aePzjy07T6uu3see6cnfs8d2rP50if2a+v/AE+/9m7uA1wAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAGo9sY/3PST6NTaOn4sV/H2V5e2Xb6E/19aP/AAfK9fm2NCJzaf8Abu/FEeW7wmXPXpWwAAAAAAAAAAAAATG8THpjZMTiYnsnI4x9M9N+EcHybbTXiWSm/v6W9v7zT0b8vB7n6CWn/G7dXPHZaWx7OrWP/U39imOveI+zE45f0xnxz+/bv87PpzogAAAAAAAAAAAAL/hdu7xDRz6c+Ov657v/AMzU26vW2PaY/wDBvO7j6MTb8sL6fr1z2ukvFN0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARP8jt3Tu/nYieXjv+E/vhzvjVu9xPVz12tjry/wCTDjr/AKPZ9GR1dh2eP9t5/FqXt+7T1PXt4sW3lAAAAAAAAAAAAAHfvoVptpu0GSP5s/D8fo+5j1duv/6SJ8do39T5v9Pbf5vRtN27T2q3f6VtGPh6P5Oft0+lp15REzOOOJmI/PhvdyfP3PAAAAAAAAAAAAAAb52Mr/B19o6TkwR7dq5J3j9XPfZ53p3/AFNnjspqfnasfs19fPo9m/8Ab/hujgtcAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAABq3a+u/DMNo/k1uLf2Th1O/+kOx0JONr1I7dnv8frNLHwbGhO+Y/wBsxx/3VnOPy+LnD1DYAAAAAAAAAAAAAAcj+mSm/Z3QX2+5xbHz9He02pj/AEj/ANN3tfoNbHSe01+1sdvy1tKW7sU/5l++nDt3x8PF5rfU3TAAAAAAAAAAAAAXOit3dZpLdNtTgnf2ZasG0xnZtojt0NWPjp2Wr61fajzdPeFjv7Z85x+TeEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiZxjvnH89+73jmnErd7X6yf/5jLH5VvNY+D2+xV6ux7LHH/I0pz32pFp/Of+rSvOb29qY+G5ZNpQAAAAAAAAAAAAB6L+him3BuL5fx8TpSfZj0uKY/OZyTG3w8fmP06tnbtip9nZLW/FrXj3YimZ93u5u3b70jsrPnPydleFaIAAAAAAAAAAAAADoPY+s/U9XbwnUxX9OKk8/1Q8103P8An6MdmjnHje3y/Jr7ROZr3R8o/b823uI1wAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAGu9qqd7hF5/BnwW29O9rU39e03dToecbbWPtaepH5Rb9mbR9aPveVXMXrG0AAAAAAAAAAAAAA5f9LmKcnZPvx/weJ6PJPu2rnxfNkr/q9d9C79Xpnq/wDebJr1jxidO/lWW3sc/wCdPsW8eXDteX31p1QAAAAAAAAAAAAH1w27ubFb8OXHb+l4n/RTVjraepHbS8fGswmOMeMebqbwMTmM8O5viQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/z/AD0InfEx27viOXaq3e1Oot+LPmt/XJaXvNCOroaMTumNLTiY7MUrDQt61sTn0p83wZUAAAAAAAAAAAAAPS30O4+72b1l/wAfFc3t+zp9NH9P/P1PlX04tnpXQrndXYtPdyzOrrT/ADLl7bP+bEdlPn/zu4TudaeMaYAAAAAAAAAAAAADpHZCsxwvNM7x3tZkmPRMRiwVj4T+cS8v03OdrpEctnpHv6+pM+fww1df1o8P3nk2hx2EAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAABhO0kd7gurj0eQn+moxzt09G8/nt4Oj0VONu0e+NSP/ALHdk0vXr979MuVPXtwAAAAAAAAAAAAABoP0nYfK9iuLzEb2xW0GWPV3eI6Wtp/Kl7S9H9E79Tp7YoziLxtFJ9+za01j32rWGxss416d/Wj+2Xk3+z7K7AAAAAAAAAAAAABvMbTHWJiTxHVcd4yY6Xjpelbx7LVif9Xgb16lrU+zaa/hmY/Zv14RPbv+O/8AdNVIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB05z0jnPsjnP8AYn/p48vz4H8/njG5ym1u9a1vxWm39Z3e/iOrERHCIiPhGHPRSAAAAAAAAAAAAAPU30UYYx9j9NfaP941uvy+HPbN9XmfXywRE78+Ux0fIfpjqTbpvVrn/T0Nmp/ZOpH/AN8y5O2TnWmOytY/LPb2T3eDpTyrVAAAAAAAAAAAAAAdQ7L07vB8NvHJlz2mPTtktTf/AODb+vN5Lpe2dtvH2aadY8JrFv8A1NTV33t3RH7fNsDmMQAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAADE8dp3uEa6NpnbD3uu3Ol6239e0R6m70dONt2ef8Afj8VbR+ecMuniLV4ZzPwmvzn4uSvZtsAAAAAAAAAAAAABq/bbD5fsnx/HznbhuoyxEeM4a+Wr/fHG+/SP6uv0Bf6vpno23/61p18I1J+rmfhaf8AnhOXQnGtpz/ujh37se/g8bvuLtgAAAAAAAAAAAAAT8P5vdL4bfv6DR2md5+r4qzPuUin/wArxG216m17TH/jalvxWm37t6m+lfZj8owvWssAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAttbknFo9VkjrTT5rR70UtNf/i2Z9mr19o0Kcra2nE+E3rn8sq2nFbTwnqzjxxMuYPctEAAAAAAAAAAAAAB68+jzB9X7GcCx/i0+bPPX/7p1eo1PjM9YyxPo26REcnxT6Tan1vTvSNuzV09P/ytDS0p/Ok+9xtpnOvqT34+ERH7e7g3RwmAAAAAAAAAAAAAAB1fs7Xu8G0nSN65LeG897Pkn/WZn8uTx3Sc527X7ppHw06R/wANTV3XtvieEce6J3d3/LMtBiAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAWXE6eU4dr6dZnR6nux/zeRtNf7xH9GxslurtWz2ndEa+lme7r1z+WV6TEWpjjmIns4/zu7nHHuG6AAAAAAAAAAAAAAxXHcP1jgvFsEdcvDddSOv3rabLFenrmP8ATm3Oj9T6rb9i1M4im1bPaZ7o1aTP5L6c4vWcZ9KvnH7PEj747oAAAAAAAAAAAAADofBL9/hmm5/d8pSfV3ct45/ltP5vH9KV6u3a/ZPUtHfnTpn88x7m5pTmle7d+c+bKueyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMbxi3c4bqp9OOK/rvWv8Aq3ejq9bbdnjj6c2n7tLW/LGVNXP1dsdkfCZjP5OcvZtIAAAAAAAAAAAAAB7T7L4ZwdnOB4ZjbucK0Ebc/HS4p8fbz25b+EdHwjpe/wBZ0p0hf7W2bTP/ANmvH7c/LDh6s9bV1Jzn07ec8O7s7mdc5jAAAAAAAAAAAAAAdf4NTucK0EbTG+lxX5/95Wt+n/j3/P0w8Vt09bbNpns1r17fVnq/s09X17b4nE8scvR4+6PNkWoxgAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAIZKxfHes84tS1Zj0xaJif7Sms9W1bRxrMTHunKY3TE8N8b+zf3uJTG0zE77xNon1TEzEx/XlHqj1PfxOYiY4TiY7d8fzPZl0JjHz92fDnAIAAAAAAAAAAAAAQyVi9LUtG9bxNbx13raJiY/OJ2/PdMTNZi1ZxMTExPOJicxMd/YmO3s3/nHzeGdTgtpdTqNNf7+nz5cF/D7WHJbHblz8az4v0HpakaulpatfV1dOmpHhesWj8pd6s9asWjhMRMcuMZfBkSAAAAAAAAAAAAA3fs1k72jzY5/wCHqJmPVW+Ok+r+aLT659G3Py/TdMbVp2jMRbRiJ8a2vv4Twjq/zc2dD1Z9r8t3j38o8ezYXHZwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGC7RZO5w+KR/xc+Ok+ysWyT+UWx1/rDq9DU622dbM/5ele3LjONOI4c4taePLsli1p9DHbaIj858on+b2iPVtTgAAAAAAAAAAAAArWs2tWtYmbWmK1iOszM7REeuZnZEzERMzOIiJmZnhERvmZ8Cf+fg90aXDGm02n08dMGDDhiPCIxY644iPV9nl/0fnzWv8AW62rqzx1NS+p+O02/dwbTm0z3zMeEzM/u+7GqAAAAAAAAAAAAAA7VpsfktNp8X/ZYMOL2eTx1p/aI2eD1rdfW1b8evqals+1aZ/dpWnMzMc5nPxnEd26I7M832Y1AAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAADr6wcW1VfJ6vU4+W1NRnpHXf7GW1Z339f5ve6M50dK3bpaczwj1qxMbo7vg6HKJjGJiJjhwmMx+X84PguAAAAAAAAAAAAAAmP57937vGPa7B9X7T8exbbbcV1t4jw2y575Y29UxeJj1bbPuvQup9b0T0deeM7HoRPjTTik/Ca4dvRnraWnPbWOPdu72uumyAAAAAAAAAAAAANr7MZI72rxeM1xZIj0xWb1t/TvV/q8/wBO03bNfHC2pSZ8YrNY+MTOeWGfRmfSiO6fz37/AA7m2vPtkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABqvae8xTSY9+U2y3mPditYmf1Tt7Z9Tu9BVib7TfHq106+E2m1pj+2M97X15nFY77ftj8pai9G1wAAAAAAAAAAAAGZ7O6f63x7gummJmM3FNDS0RG8zSdTj78R6+7E855R1nk0elNWdDo3b9aJiJ09j2i1ZnhFo0r9X+7CmrPV07zzilp/L+fKeD2tHj7Z/z/ADpHo6R8FcOY/Ph8Zj9lRAAAAAAAAAAAAAD6Yad/Nir17+THTbxne+3+qupPV072+zW07+G6ufnlMbotOcTEbvhMz+Ubsf8ALtkRtER6I2eBc4AAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAA6BHGM8ObkfG8XkeLa+np1Fsv/v4jNHz/wCTu9rsF/rNj2e3ZpxT36f+XPv9He3qTE1rMdkR2ZmN0zjlw/nBi22sAAAAAAAAAAAAApP+cpn4A8nfSdpLaXtlxO221NXTR6vFy61vpcOK8x4Tvnw5ufPf0xO8Psn0T1o1ugtkiPW0ba+jfumute9f/sd6e/LsbLbraNe2JtE8O3PLun4tBekbAAAAAAAAAAAAADOdnsnc4jWvhlw5Mc89undyR/fHtHrlyumKdbYptz09Slo9+aT2boi8zPgyaM4vEdsY93H9v5GW+PKNwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABo/aTJ3tdTHvyxYKRMei17WvM/nWaenlEPUdCUiuyWvjfqa1pzmZzWsVrHOf6utMeLU1rRNoxwiI+M7/LDX3YYgAAAAAAAAAAAAG6fR5p51PbLgdNt4x6jLqbeqNLpc+oif1Y6xH/ADTEdXC+k2p9V0H0hbO+2lTSjv8ArdbT05/K0zPZGZ5MG0zjQ1J7oj8UxH7vXj4o437bgAAAAAAAAAAAAAF9wzHObiWhxxttOqwTPPn3a5K2t/8ABW23plr7XaKbLtFpmYmNHUx4zS0R+cxgmZiLY7J5RPKf2y7E8O54AAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAJjjHjHm5j2px9zi+W207ZcOC8T6dqRj/rHk+fo8OT1vRFutsVI+xfUr8bdb/1NvSz1IieMTMT8e3xmfya66bIAAAAAAAAAAAAAA84/TNp4pxzhep28/wycUzt1nT6nLbbfbnMRqI68+fo2fUPoLq9bo/bNHP+ntcX8I1dKkeelLp7FOdO0fZvmPfHH8nHXuG6AAAAAAAAAAAAAvuGZfI6/S5PDy1K258orknycz16RFt/Ryam36f1mx7RTn9Va0Y45p6cY78wtScXrPfHwndPm6U8TmJnHPs/n84dreEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADnPF8sZeJau0dK5PJ/nirGO3/xVn2dHs+jqfV7Fs8TxtSNSeX+pM3j8rRx39rS1JzqW8fLd+zGt1QAAAAAAAAAAAAB1n6HdLGXtLq9Tau/1TheeaTtv3cmfPp8UTv4TOPysevvT7XjfpvrTTorR0on/AFts04tv4009PVvMY5+n1J9zU2y2NKMc7x+WZ84jhyzyelo9e3Wenr/z1vlLlTv/AC/KMKgAAAAAAAAAAAAAz3ZrH5TjGl5b9yua/wDTFesdfXaJ68p26ud0rbq7DqxztbTr/fWZ/KuPepqTilt+OH6onnns7HUnkGkAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAA592wxTXV6TPtyy6e2Lf0zhyTafziM1Y3nwiIh6XoS+dDW0+dNWL+7UrER+enLb0ZjFqxynnO/f+UcP5vag7bKAAAAAAAAAAAAAA4p9NGh8pw/g3EYif8AdtbqNHeY6bazBXNTvcvCdFMRO+0Tbbxe9+gm0dXadu2Sf+10NPXr/wDQ1J07RHLf/iInHGcZ5S3thti16/aiJz317/fPhu7Zeen0t0gAAAAAAAAAAAAFazNbRaOtZi0e2JiY+CJiJiYnhMTE+En8/mXVMd4yYseSOcZKUvE+mLVi2+3riYl4K9J073pMYml70mN26a2mJ8vyhvxOYid2+In+d2+E1UgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKWmK1teelYmZ57dImfX6ExE2tWsf1TERz3zMRjEb+ZO6JnscryXnJkyZJneb3teZ9M2tNpn+sve1rFK1rG6K1isR2RWIiPyhz53zM9qCwAAAAAAAAAAAAA7z9CujtFePa+1dqWtotHitt1tSM+fPG/qjJp5mNv5uc8o3+dfTzXjPR2zRPpRGvr3jutOnp6c++a6vwc/bpx9XTxtM8+URnx3/B3d88c8AAAAAAAAAAAAABtXZDHNuJZcu32cWkyc/RbJfHWv8A8MX/AKb+Dj9NXiNlpTnfWriO6tbzP5zX4sWtMdSc85jnjt7p8fc6M8u1AAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAD2hwad2yx97TaLLH8me9J2jp5SkWnn0iJnFEz6uUdHc6DtjW16cradbfgtiO/+v5tnQmZ60d0T8N0e/Hm0B6RnAAAAAAAAAAAAAAc6+lPTTqOx2uvETM6TU6HUxtHSPrFdPafXtXPaZ25xG87cnp/ohrRpdObPWZx9fpbRo+M/VW1Yic9+lHvw2tknq61f90THhx+XHl38/Kj7C6wAAAAAAAAAAAAADonBss5eG6aZ5zStsU+zHaa1/pSKw8b0lp/V7brxHC0xqR/9SItPxv1vz3tzSnNK++PhMxH5YZRosgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADH8WzeQ4dqrxMd62KcdfCd8s+S3jw3iL96PXHtbewaX1u26FeUXi89kxpf5kR4ejiccetx3bsepMxS27ljPjiP3n4d8ObvatMAAAAAAAAAAAAAB6j+iXTeQ7JY8n/AN+cQ1upn/wzi0kTv6P92/ttHSXyP6Z6v1nTVq/9xs2hpce3r62P/s2+O/vhydsnOt4Viv5zP7umvJtUAAAAAAAAAAAAABvnY3Htj1+baPtZNPji23OPJ1y2mPZPlImY8dnnenLels9M7orqWx7U0iJ/tlg1pn0Y3cLce/Ee7dz7p5ZzujgtYAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAABr3ajD5XhGa0RvbBkw5q+H88Yp6eiuW0z6o36w6XROp1NtpH/eUvT+3rxE+NqRHPezaExF9/OJj9/wBu3t8Y5g9c2gAAAAAAAAAAAAAGG7Q6OvEOBcZ0UxFp1PDdbjpE+GWdPecVukzE0yxS0evnt0b3RmvOzdI7DrxOPq9q0LzP+yNSsXjlutSbRPnDJpW6upW3Zav6oz+WXih96dwAAAAAAAAAAAAABuPZnN3sGo08zzx5K5a+7kr3ZiPZOOJn1238Xm+nNLGro60cL0nTnx07daJnxi8x93lz2dCd017N/wAWzuGzgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANc7SZu5pMWGOubN3p9zFWZnl71qT+Ts9CaXW2jU1d2NLTx3xbUnd/bW/Zxhg159GI7Zz8P+sNKenawAAAAAAAAAAAAAD2X2P0McN7McE0m21q8O0+XJHozaqs6rNHX/ALXPf1+M9do+GdN7R/iulukNblO1atKz26elb6nTn8FI7ezlmeLr2m2reeXWnHhGIj8oiOzc2VymEAAAAAAAAAAAAAB0rsninHwuckxG+fUZb1nb+WsVxePX7WO/piN/TG7yvTN+ttkVj/s9KlffM2vPOeVo7PDt1tefSiOUREz47+HumPHEeDZnJYAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAFhxTF5bhuvx7bzOlzTWNpn7VKzeu0R1nvVjb1+vZs7Hf6vatntM4iNWkTPda0Vn8pnK+n69Z/3R+c/LM+5x2Okf5/0e347+3ux+TenfM/sqIAAAAAAAAAAAAAUmItExMRMTExMT4xPKY9k+KYmYmJjdMTmJ7Jg4PEfGtDPDeMcU4fMTEaPX6vT136zjxZ71x2/8eOK2jx2nnETyffNg2iNq2LZNpjH+fs2jqzjla+nWbRz9W0zE753xxd6lutStuc1iZjsmY3/AJ5j3MY21gAAAAAAAAAAAAGe7PZ4xa/yc9NRivjjryvXbJWfR92t68/G0bdXJ6Z05vsc3iN+jqVt922aTHb61q8OzuZdGfTx2xMfDf28cROJ5N6eVj+fCG2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH7jSO0maL6zHhid4wYo70eEXyTNp9v2PJz+ez0/QunNNn1NSYx9bq5rOd81pEVie70utHuy1Nec3iPsxj475/LDXnZYgAAAAAAAAAAAAF1oNLfXa7R6LFG+TWavT6Wkbb/b1GWmKnKOc72tHLf082Hadauz7Pr695xXQ0dXVtOcejp0teZzy3R/wreYrW0zwiJmf5ue4sWOMdKY6xtTHSuOsdfs0iIjn6IjlEf2jo/P8Ae03ta077XtNpmO2ZmZjHjPHM+PFwpmZznfmc+fzfRVAAAAAAAAAAAAACk8ue2+39fy/zpuJjn4bvdMTz3cI5uvcFxRh4VoKR46emSeW3PLvlmfzm++/ju8Vt9+vtm0W/8Sa/gxT/ANLS1ZzqW7px7o3R5fLdhk2oxgAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAExExaLRExMTExMbxMTymJ9Uxv8ABMTMTExumJzE9kwmO3s/6c93GXFM+OcObNhmd5xZcmOZ9M0vNZnw9Hoe807/AFmnp35XpW/4qxP7t/Od+MZiN3ZufJcAAAAAAAAAAAAAAeUPpQ0U6PthrbzH2ddg0uuxztt3q3xRgyTt4fxtPkifTMb9d4j7H9EteNfoTZ659LZtTW2e8Z4TW86lY7/8vUp5Oxstuto17azNZnwnP7ufPStgAAAAAAAAAAAABcaTN9X1Wnzz0xZsd7ct96xaO9ER4zNd4hh2nS+u2fW0o46mnete60xPVn3WxPuWrPVtE9kx28OfDu/6TwdQ5T0nePCY8Y8J/N4WO/MZ5Ty7v5zb0d3Pf8QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAn4fmOZ8QzRqNbqssTvW2a8Vn00pPcpP51rEvb7FpTo7Loacxia6detHZa3pWj3WmYaN561rT3z8OEfks2yqAAAAAAAAAAAAA3f6OdHOt7YcJju96mlyZdbknnMVjTYb5Mdp26RGace2+32u7HSd3A+lGvGh0Jts5iJ1a00K986t61tEfc62c7sRLBtM40b98dWPGZj/ndzeuXxZxgAAAAAAAAAAAAAEqUnJemOsb2vatIj0zaYrH95RMxWJtPCsTM+ERk8XbMeOuLHjxU+5jx0x092lYpHs5V6eDwV7Te9rzxva1p8bTMz+ctG05nMxiZ3z7/APjCSqoAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAB/n+f5ImJ/nhE492cfCHJuPYfIcW1tfC2WMsevy1K5Z29UWvMe2PDo9n0df6zYtCc5mKzSfuWmsZ90RPvbmnvpWePGM4xwnHkxDdXAAAAAAAAAAAAAAcD+mjQzF+B8RivWmq0WS23jW1NRirM9P589qx67co25/RvoHtEzTb9lmeFtHXrEzGd8TpXnEd1dPM47HS2K0YvWOGYt4Z3Y90RGZ7efFwt9CbwAAAAAAAAAAAAADpXDM8ajQabJ4+SrS3v4v4dv6zWZj1TDxO26X1O1a9OEfWTavs3xauOXC0Ru5x2t3TnrUie7Hvjj+e+O7dhfNVcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABaa7PGn0epzb7TTFfuz/wA9o7mP0c5vasR62fZdL6/aNHSxmLaletH+2s9a/wDbWf8AhW89Wlp7I/PO783Mv89D3LRAAAAAAAAAAAAAAdq+hjQRk4hxjiNo56fSYdHjn0Tqsvlsm3r20lI5c+7a3OPHwX072ia7NsOyxw1dbU17cN/1NOpWO3/trTwxuho7bacUpHGbdb4bo/Off7noZ80c0AAAAAAAAAAAAABk+DYfL8U0OPbf/eKXmP8Alxb5bf0rSZam3X+r2PaLf+HNY8b4pH52jv7N6tpxWZxndMYjjv3fv73Xp6/039u3P+7xTSnjOeW74KCAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAHOu1+Kaa/T5o6ZtPtM+mcV5iY9u16/28Jh6foS+dm1aZ36erE47I1KxjwzNZ3c5y2tCc1mOyZ+Exn5+DVHZZgAAAAAAAAAAAAAHOfpT4fGt7I6vL3Ytk4fqNNrcfKeW1/q+XnG+0eR1GTfltyiZ6PT/RDaZ0OmtGmcV2nS1dnt35r9bSPHr6VW1slurrRH2omvv4x48ODyq+wusAAAAAAAAAAAAAA3Lszni2DUaed+9jyVyV5x9zJG1to235Wpznp9uPz8105pTXV0taMY1K/VzP+7TnrRntzW0xHOOrPu2NCeNeycx3xMYn4Tjf4Q2ZxGwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1ztLn7mlxYInnnyzaY9NMURO8+rv2pMR4zG/g7PQmlNtfU1sbtKnVif9+pMxiPCtbRPdMdrDrz6MRzmeHdGf8AhpT07VAAAAAAAAAAAAAAen/om4fGk7K/WpifKcS12o1Mztz8lh7ulx09cb4cmSvryzvy3fJfpntM6/TH1MTHV2XZ9LS7uvqZ1rz3TjUrWfY7cuVtd5nWxHCsRHlM/nEefN1F5FqAAAAAAAAAAAAAANo7JYu/xK+WYifIafJas7dJyTXHHPfrNbWidvCZ26buT0zqdXZK0if9TVpExnjFYtbPhmK+G5j1p6td32sdm6Mz+eOHJ0h5VpgAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAANS7YYIvodLn62w6i1J584pmrMzv7b46cuUend2uhNTq7Rq6fLU0ut97TtGPyvZn0JxMx2x5cY+FnPHpmyAAAAAAAAAAAAAAx/FtDTifDOIcOycqa3R6jTWn8PlsVqVvHKedLWi8dNprE7xs2dj2i2ybXs21V322fX09WI7epeLTXwtEdWe6efBalppeto41mJ+HLlx4cXiLJS2LJfFeNr472pePRalpraPymJh9+raL1res5rasWrPbFozE++Jd6JzETHOM/FBIAAAAAAAAAAAAAzHAtR5DiGOJnauetsMzvtzttNPbveta/+LdzeltGdXY7zX1tKY1Y8IzFvdFZmZ8GTSnF4793xdAeRbgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABHOYJ4T4DQ+0GeM3ELUiYmunx0x8ucd6d738dt4m3dt6JrtPR6zofSnT2OLzGJ1r2v39WPRrHLd6MzG7fE5amrbrX3coiPCeM579+J8GDdRiAAAAAAAAAAAAAViJtMViJmbTEREdZmeURHrmeX59SZiImZ3REZmeyIPF7X7PcO/2TwPhXDeXe0mg0+LLMdLZ4x1tntHqvmtkt+b4L0ntP+M6Q23auWttOremeWn15jTrz9XTitfc4Wrbr6l78rWmY8OTMNFQAAAAAAAAAAAAABvvY3T93T6zVTG3lctMNd999sNZtaYmYidrTlrvvP8ALHoec6d1M6uhpR/TS2pMxznUtERHHl1J4YjE7mvrzvrHdnv/AOjc3Ca4AAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAADFcd08ajhGtp1tTH5avLed8FoyzHo+1FZrE8p3t6G70fq/VbZoW5Wv9XPhqRNPym0T7mXS9avjjHDdMYzx5Tjl2Zns5H49Pz/p/1n+j2nLj7vj8o+LbVQAAAAAAAAAAAAAKT7N//SfHw9vITHhn+Z9zx9274ZHCe1fGNNWJjFl1M63DvG0eT11Y1U1rH4ceTLfFXryx85mX236O7X/jOhth1Zx16aX+HvjPrbPM6MTOed6Uree+zs7Pfr6VJnjjqz41zHlES1F22YAAAAAAAAAAAABKl7Y70yVna1LVvWfRNZiY/vCt6xetqW4XrNZ8LRMT+UnDfHJ1LDmrnw4s9Y2rlx0yRHo70Rbb8t9v9ZeE1dOdHVvpW9bTtak7uPVmYzG/dE8Y47p8W/WetET2xE48X0USAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhkyVw48mW87Vx0tktPqpE2nl4zO20R4ytSltS9dOsTNr2rSvLM2mIj853z8ETOImeyJn4OXZsk5suTLb72W98k+je077erbfl/6vd6dI09OmnHClK0jlmKxEZ9+GjMzMzM898vmugAAAAAAAAAAAABsnZDhk8X7S8G0MfcvrcWbNv0+r6XfVaiOk7TbDhvSu/LvWiHL6b2uNi6K27aJ412e+np78T9brR9Tpz7r3rae6JY9a3U07zzxMR4zuj83suOno9Xo9X5f+mz4X+biTmJxPL+R+SogAAAAAAAAAAAAAB1Xs7gnT8I0sWja2Xymot64zXm2OfzxdyZeP6U1I1Nt1sTmKdXTjxpWIvHuv1o9zV1pzad+d8R+U8e+Zz29ud7NuewgAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAI5Kxkx3xW+5kpalo5c63iYn+0zt6JWraa2raONbRaPGJzH5wmJmOEznu93yhxXNivgzZcGTzmHJfFfbp36WmttvDbvVnb0R02jZ7yl41KUvX1b0reN3GLRmPynfjxntdDMTETHCd8duOMfGJj3xPB81kAAAAAAAAAAAAAAPPf0z8LjHruE8YpE7arT5dBn5coyaW/lsFpnxtkx6jLWd5n7OCvTx+l/QXa+ts+2bDbGdHUrtGn2zXVjqakY7K206T46kulsV81tSeU9aN/LdE7uW+InhvmZmXE3vW8AAAAAAAAAAAAAA3ns7qfLaKcMzvbTX7sf+zyb3pMzv4T36xty7tYjw5+U6Y0Pq9qjViPR16daeUReuK2xjjmIpac85ls6Ns1xH9M7/AH57u3jv5M+5TOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwnH9T5DQWxxytqbxiifGKfeyf/DEV/wDHu6fROhGrtcXnHV0azqcONvVpHdibTb3MOvOK4+16Pfjjb3bojxnG7LQnrWqAAAAAAAAAAAAAA7F9DnDLZ+M8Q4raP4XD9HGnpvymdRrb7xas+MUw6fNW8RzjytN+U7T4f6cbXGnsOzbHGevtOv8AW27I0tnrvieybampSa+xbdzjS22+KVpztbO/HCvOc9szu/4l6Njp/bn6ny/+djmKgAAAAAAAAAAAAArWtr3rjpEze9orWI252tO1Y6T47R7ZjruiZisTa04iImZnsiN8z7oOWeUcZ5bt87+6N7teHFGHDiwxttix48ddum1KRX+20cvDm8HqWm973nje9rT42mZ/dpXnM5zG+Znd34nyxGO7tfRRQAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAACOMOV9otPOn4vquW1c00z0nbbvVyVjvT/AO9jJHtiXsOi9SNTYtLfv0+tp27prO6PwTWfe3qepXtxiY7MTw+Xdhg3QWAAAAAAAAAAAAAAc8+k/hUcS7JazJWJnNwzJh4hi26zXHbyWoiZ9H1bNlv67Ur0nnHpvoltk7L0zoVnH1e11vs188pvHX05jv8AraUry3WnjwnZ2W3U1azuxbNZzynjHhw8N+PDyk+xOuAAAAAAAAAAAAAAznZ/UeR18Y5ttTUUtjmJnaJvH28c+jvbxalfXeYjq5fS+j9Zsk3iubaNovGIzPVn0bx4YmLW4epEzuhl0ZxfHK2Y9/H+eLfHk22AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0ftFqJya2uCLRNNNSI2iYmPKZIi155ePd7kc99u7O0RMy9T0NoxTZp1pjFte2d8YnqUzWsfi68+/46utbNoiOERv8d/58OTX3XYQAAAAAAAAAAAAAHqT6KOFToOy2PVXiYy8V1ObWbTExMYababBHri1cNs1Z/Dmjbbnv8i+mO2RtPS9tGs5pselTQ7p1LZ1dSfdN4pPfSXK2y3W1ZiP6IiOPOczPh3+7MOmPKNQAAAAAAAAAAAAABl+A4Iz8X0VZjeKZfLW5dIwVnLE/qiI3nlvMR1nadPpHU+r2LXtnEzTqRPbOpMUx8Jn855K6k4pbwnv47p/Lnx59kusvFtEAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAADxaN2ywfb0OqiOU1y6e8+ETFoyY67+uLZZj2W9L0PQepu19KZ501Kx4xNbT+VM7uz37WjO61c84tjszGPHhjM+ctId9mAAAAAAAAAAAAAAWus0uLW6XVaPPXvYNXgy6bLWPHHmpbHfntynu2naefd2ifUy6GrfQ1tLX05xfR1KatJ7L6dovXxjMRu3Z4d6a2msxNZxMTExPfE5j83iPXaTJoNdq9Dm87o9Rm02TwibYclscz7Jmu8eqeb77s+tXadDR2inqa+lp6tY44rqVi0RPfETiXerPWiLRO6Yz28cTx7v3WrMkAAAAAAAAAAAABKl7Y70yVna1L1vWfRatotX+8Qi1YvW1LRmtq2raO2sxMT+WThieyYn4OoafNXUYMOen3cuOuSI8a96N5rPrrP2Z9cTDwmrpTo6uppWx1tO9qzjGJmJxmMcrRi0Z34mG/WYtEWjhO/+eE7n2Y0gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPnly1w4smW87Ux0te0+qsTadvXO20Rz3mdojdalJ1dTT06+te9aV7OtaYiMzyjf2xuznci2IjMxwzM90Rv9++IcvzZbZsuTLfnbJkveee/O1pn/X8uj3enp10tOmnX1dOlaRuxurERy8GhnOZ7Znz3vmuAAAAAAAAAAAAAPrp8GXVZ8Gmw172bUZceDFX8WTLeKUr+drRz22iN5lTV1KaOnqaupPVppUtqXnsrSs2tPuiJRMxETM7oiJmZ7o4vbnDNFj4bw/Q8Pxeb0Wlw6as+NvIY6Y+/MeE3ms2tHha0783wLa9otte07RtV/X2jX1NWd+er17Wt1c/7cxWO6rh3tNrTaeNpmZzyzwj4RxX7XUAAAAAAAAAAAAAAbl2N0/e1Or1MxG+PFTDW089py3787evbFEeqJmJ5Tu4fTmpjS0dKJ9a83mO3qV6sfrn8mLVndWsZzMznG/djEfnPd8t+ebagAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAADA9pcE5+EaiYje2Caaisbb+bttefVtjveZnwiJ8HR6K1fq9t04ziNSLaU9/WjNY+9etYjtmWXR/1IjtiY4444+O/l/0ctj19Xr25O+Z8QQAAAAAAAAAAAAAA8sfSpwqOH9qs2ppWK4eK6fFrYrEbVjNEfV8+0+M3vhjNbx7+a2+0bPr30P2ydp6IppWmZvserfQmZnfNJn63Tzv4VredOvdSHW2O/W0sc6TMe7jH8/kc2eqbQAAAAAAAAAAAAADdezeq8ppsmmt97BbvUnfn5PJO+0R1+zeLeG324jeOTy/Teh1NemvWIxrV6ts8PrKR1Yn71Jru7K2mMzMtnRtmJrPLhnsnl/McYxnfjY3HZwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGv8AaLU+R0cYImItqbRE+jyVJi1+fTnbuV9Ex3tvB1+htD6zaZ1ZiZro1zHt3zWuYnfur153cJxlh1rej1e2Y7OETmfzjH7tHepaoAAAAAAAAAAAAADf/oz4VHFO1mitkjvYOHVycRyxMb72wbU09fy1OTFeYnlNKWh5v6V7ZOydDbRFZxqbVNdlpPZGpmdWf/JrescJibRPJrbVfqaNscbzFY8J3z+UT4Zy9YvjbkAAAAAAAAAAAAAAKTO3+eqZ9fhB/P5vgdO7LaeMPCqZNvtanNkzTO2+9YmMVOvWNsc2iOn2uXKeXk+l9X6zbJry0aV047Mzm8/nbE+G/e1ta0dfHZERnxic9nbHw5NjctgAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAfPLjrmxZcVo3rlx3x2iek1vWazE/lMrUtNL0vG6aWraJ76zEx+cLVmYnMcvH9v+mXFsmO2LJkxXja+LJfHaPRalpraPbExO8eE8nvK2i9a3rOa2rFonti0RMT8Jb2c70FgAAAAAAAAAAAAAByH6X+F11XAdLxOlN8vC9VWt7xvMxptbNMN4tv4eXrppiJn7M2nb70zPtPoTtk6PSOtslrYptmhNq1ndE62hm0Yjl/lzq8PWxv3w3djv1bzE7ovE43YjNd/Lnjrco8Z3Q82vqjpgAAAAAAAAAAAAAMnwjVfVNdhva3dx3nyOWd9o7mTaIm3qreK3mfDutHpHQ/xGyalYjN6R9ZTdmetSJmYiO21etWO+V9O3VtEzw4T73RXjW6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA57xrVfWtfl7tonHgjyOPbb+WZ79omJmJ3vNtp8YiPRtHr+i9nnQ2TT60T19X/ADb5j7UR1a9uIpFd074mZ4TLT1bda89kbo35/nuYl0WMAAAAAAAAAAAAAB6J+hzhVcHC+IcXyRMZdfqa6XDMxMR9W0kTNppM7bxk1GW1b7bx3tPSN94mHzL6cbZOptezbFWc12fRnW1Ij/vdaYiOtGP6dOkTE5j/AFJ5cebtt82rT7MTM+M93hz8XZ3hGiAAAAAAAAAAAAAArWs3tSkdb2rWI9M2naI/OZj29PFEzFYmZ3RETM+ERMz4eP7pjHP+fPvxvdo02Cum02DT1+7hw48UdOfcpFZneOUzMxMzPjM7+LwmtqTq6upqTx1L2v8AitM48IziOyHPtvtae+fN92NAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAABHL/PT1D+fzz8XLO0mn+r8WzzETFdRFNRTlPOckbZJ39M5a5JmfTvPJ7DovV+t2LTzOZ05nSntjqz6P8AZNf+rd05iaVxyjE+Mf8AGP8AowToLgAAAAAAAAAAAAAMbxjh+Pi3CuIcNyxE11ukz6fnG8Vvkx2jHf1Tjyd3JWeUxasTE7trYtptse17NtVJmLbPraerunGa1vE2r3xauazHOJnkvS3UtW0bsTE/Cc8u3h/y8TZsOXT5sunz0tizYMuTDmx3ja2PLivNMlLR4Wpes1mPTEvvenqU1aU1dO0X09SldSlo4WpeItW0d01mJjul3ImJiJrMTExmJjhjlh8l0gAAAAAAAAAAAAAOj8K1X1zQ4clvOVjyWTx3yY4is2meX367X9U22iNnitv2eNm2rUpHq2n6ynL0L5nGI49Wc0zz6sTO+Ixu6dutSJ5xun3fPdPvZFqLgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALLiWqjSaPNm6Wis48cenLeJrT27TPft/wAsTHLk2Ni0P8TtVNLG6bda84/7Osda2Zjfm3qxndmY71b26tZnOJxOPHhH5zDmkzvMzPWecvcNEAAAAAAAAAAAAABKtbXtWlKze9rRWtaxNrWtadq1rWN5tMzyiIiZmZiI5zCJmIiZmYiIiZmZnEREb5mZndERG+ZngPanZ3hdOC8D4ZwylYrOl0mOmXb+bUWicmpvPKN5vqL5LzO3OZ9Gz4P0ptdtu6Q2varTNvrta9qTPLSj0dGvhXSrSsRyiO3Lhat5vqXtM5zM48I3Rw7ohmmgoAAAAAAAAAAAAAAzPZ/TRquLaSto3pivOovy5fwazeu/qnJFKzz577dZaPSWr9VsetMTib1+rr433Tjv6vWnd2e9W8zFLTGImY6u+ftbvyiZl1iZ3nf0/n/ns8OjxrSmMTMdiggAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAABpnbHTTbBo9XEebyXwXmInlGSvfpvO3SLY7RHPbe+3Wdp73Qeri+vozPrVrqVjvrPVt75i1e/dwnjGzs8x6VZ54mO7E4mffu3eEtCeiZwAAAAAAAAAAAAAFJ8PbHo/wBfR15cz+fv+xG78/zjDyn9J/B7cL7VarPWu2n4tWvEMUxXaPKX+xqqb9JtGopfLPL7uam/Od5+xfRLbY2vofR05n/N2OZ2a8Z39WvpaNsdn1Vq0jtmlsbnW2W/W0ojjNJ6s+HGOycY4Z57t7nj0zaAAAAAAAAAAAAAAbF2d1cYtTfTXnamorE05zt5WnOIjwjv0m0TPprWHG6Z2adTRpr1j0tC3pds6dt0989W2JiOUTaeU5zaNsW6s8J4eP8AzDdnl4nMdnH8pw2hIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA03tJq+/lxaSlt64o8pliJ5eUtH2In0zWk7+qMk+PT0nQuz9XT1NotGLak9TTnn9XWY60x2Ra8Ynj/pw1da2/q8o3zHfP8meXHnuay7jCAAAAAAAAAAAAAA3n6OuEX4v2r4fHci+Dh1p4nqZt92tdLNZwR02mb6u2nr3ZmPsza3SsvPfSjba7F0PtPpTGptVf8JpRHGba0TGpPHMRXRjUnPbFY5wwbTeKaNu23oR4znw5RPB63fGHGn4/wA3gAAAAAAAAAAAAAARxjm3jsbp4ius1k12n7OlpM78o2jJmiJ/9zO/s9MvP9Oasx9RoRO7E6to+NKfD0+Pjvywa88I3cZmY+MRjfw4/CO9vDz7WzM8ZyAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAxvGNNOr4ZrMFaza84ZvjrH3rZMUxkpFecT3ptWKx7fa2th1Y0dr0NSZxWLxW08orfNLTPdEWzPhmN7Jpzi9Zzjf8M8/+m/du34zyF7ZuAAAAAAAAAAAAAAAOTfS9weut4Bg4rSszn4RqIm0x0nR6uaYc0WiOvdzRpr1tPKseU8b7vZ/Qrbv8P0jqbJaY+r23SxWJ/wC+0etqUmOzOnOrE4xMz1eUNzYr9XUms4xeN3bmu/8AOJnxx3PND6q6gAAAAAAAAAAAAACePJfDkplpM1vjtW9ZjwtWd49vOOnj0VvSupS2neM1vWa2jti0Ynw3Tx5cUxOJiY5Tn4OnabUV1Wnw6im0Rlx1ttExPdtttaszHjW0TE7xE7xzeG1tK2hraujbjp3mOcZid9bYnlasxMY3Tnd2N2tutWLdsfnz/N92JYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8s+amnw5M2SdqYqWvPhvtHKI38bTtWPXML6WnbV1dPSp62paKxz488RvxEZtM8oiUTMViZnhEZcxzZr582TNkne+W9r29G9p32j1R0j1Q9zpaddLTppV9XTrWsds4jGZ754z3zLRmZtMzPGZz8eXN8mRAAAAAAAAAAAAAAD0b9DvBvq3CdbxrJ5ziWeNPgjafs6bRzaLW3nr5XUXyVmI3iIw1neZtMR8v8Apvt3122aGwV9XZNP6zUnPHV14iYjHLqadaznjM3tExuiZ5m23zeKcqxmfGd3DwiJid+Yn3OxvDtIAAAAAAAAAAAAAAD+fzi6zwHTRpeFaSnd7t8lPrGTf702zb3jvb84mKTSu089qxE9IeN6R1vrts1rZzFbfV1xwxT0d2N2Jtmfe1NaYm8xE5iJx765jPZv/Zl2ixAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAmLTETHdjw3/AM/6bnH+K6WdHxHV6fpWuWbY4jfbyWT+Jj67c4peInblExMbztvPt9j1o19m0dTnNIi3b16+jf8AurMx2xMS3qz1oie6IzHDMbvzxLHtlIAAAAAAAAAAAAACz4hosPEdDrNBnrFsOs02bTZYmN/sZsdsczG/S1e93qz1raImNp2ln2bXvsu0aG06czF9DVpq0xOPSpatsT3WxiY4TEzE5jMLVtNbVtH9MxP84ceEvEuv0efh2t1eg1FZrn0epz6bLExttfDktjmY35zFu7vWY5TExMTtMb/e9m19Padn0do05zp6+lp6tJjE+jqVi0RO/dMROJjlMYl3K261YtHC0Zjwn/jC1ZlgAAAAAAAAAAAAAG2dm9Z53RX6c82H2xERkrHWd5iItEdPvTy5PP8ATez+ptNe7S1Mcec0t51n7sb2xo340nxj94/ePf3RG2z1nw5vPthQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/n84DVu0mritMeirM968xlzbTtHciZjHWduvetE29Edys9ZrMd3oXZ5te+02iMUzp6fb15j07R2YpMVzHHrWjO7fr69uFffP7fzwah/d6NrgAAAAAAAAAAAAAPtptPl1eowaXBScmbU5sWDDSvO18ma9cdKxHpm1oiPix6urTR0tTW1Jiunpad9S9p4RSlZtafdETKJmIiZnhETM+Eb3tjg/DsPCOF6HhmCIjFotLhwRt1tetf4uW07RvbNk7+W8+N73n1Pgu27Vfbdr2ja9Sc32jWvqTHKsWn0KR3UrilY5VrDh3t17Tad82mZ92d3fujd4RDJNVQAAAAAAAAAAAAABd6DTW1mt02mrE2jLmpW+3WMcTFsk+yuOLWnnHKGDadWNDQ1tWZx1KWmM/amMUj32mIjvktPVrNscImd/CZjO7y9+XZekbREf8Ap4ex4ZoTMzGJ7c558MeQIAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAaF2w0nczabW1+7lpOnycul8czekz1+9S8x6K+TnfnMzPpOhNbraeroTxpaNSvs3jFojwtWJ7Zmzc0pmYmmczG/xzOMR24mPznvaY7jIAAAAAAAAAAAAAAA80fS5wX6jxzBxbFH8Di+CPKbRyjWaWtceTfaNu7kwTgvWd95tGTflEb/VfoXt8a/R+psV5/wAzYtSerE89DWm16++upGpWd26Jpzl1NjvFqTTOepO6cY9G2/8AKc+bkz2bcAAAAAAAAAAAAAAfbTZ76bPiz45mLY71ttvtvET9qs+q9Zmsx4xPgx62lXW0tTSv6t6zXhnE49GfGtsTE8piJTEzExMcYdOw5aZ8WPNjnemSlb135TtaInaY8JjpMc9pifQ8NqadtLUvpXjFqWmluOMxzicb4njE84mG9ExMRMb4mMvookAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABHJeuLHfLknu48dZve3Xu1rG8ztHOeXSOszyjnyWrS2paunSOta8xSsds23RHLt7Y3b8omYiJmeEOY6vU21epy6i+++S82rE/y0jlSse7SIr6eW89XuNn0K7PoaejXGKViJmP6rTvvafatMz78Rww0rWm0zM8/yjlHuW7MqAAAAAAAAAAAAAA6f9FHBJ4l2j/2hkpE6Xg+L6xNrRExbV5e9j0tIiYmO9TbJni38lsVdtrWrLyX0x2//C9F/wCGpaY1duv9ViN0xo06ttaZnstmmniN8xe3KJam16nU0+rHG+7j/T/V8cxG7jv5Q9QvkjlAAAAAAAAAAAAAAANu7IaScmsz6uY3rp8fk6zy5Zc0THLl4Y6338Yi8c+bi9N63V0dPRid+rbrTHbSnb42mMcvRnnDFrWxTH2u/lHL3TMTjhPHlu6E8y1AAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAGH7QaWNbwvU12+3hr9Zx+9hje0bRtytii9IifGYmd9m90brfUbZpWzit5+qt4XxEb+WLxWfcy6Vpi8b907p/b898++XJo8evXx/L+sb78/wCnJ7JuTx/4xw3fz5qiAAAAAAAAAAAAAAGjfSHwOvG+zGurWk31Wgr/ALQ0fd37/lNPW3lqREb96c2ntlpFIiN8k0t1rD0P0Z6QnYOltnmbRXR2mf8ADa2fV6upMdS0zMxjqakUt1pzivWjnLY2bU6mrEzwt6M9m/h4RG7d3fDyQ+zuwAAAAAAAAAAAAAAA2/s5re9S+iyWnem+TBEz/LM75Kx7tpm8R/zWmOUS8701suLU2qkRi2KauOPX/ovPjWJrM43YrHNsaN+NJ8Y/eP3+LaXBbAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADWe0et7mKmipba+bbJmiNt4xVn7FZ67d+8b8vCm08rc+10LsvX1LbVevo6czXS7J1JiYtbv6tJiN/Cb7t9Yxg1rYiKxM798+HDHxaa9M1gAAAAAAAAAAAAAAHqz6M+CRwjsxpc18e2p4tMcRzTaNpjHliI0lNp5xEaaK5Yjwvlv6dnx36WbfO29LatK2idLYv/AHWkR9uk51rbomJmdWbV48KVjHNydq1OvqzE5xSOrEbuPGd/Pfu8u/ojzLVAAAAAAAAAAAAAAP8AP8/zpzB1Ps5pfqvC8MzH29T3tTfw85G2P+mOKT7Zl5DpTW+u2u+PV0ojSr93M2n8c2jwiGDV9af9sTGO/E53+/GGdc5rAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAHKd4mItExMTE9J3jbnHjHqImYnMTiY3xMcYntTHGP24+7v7HHOJaX6jr9Vpf5cWa3k953mcVtr4533nfelqz+fSJ3h7nZdaNo2fR1ud6R1scIvGa3iMdlolvxbrxW2PWiOHOczE/nmPd71kzgAAAAAAAAAAAAAClucTHX0xtE7x4xtPKd4InG/8Anj7kxumP3eOu2nA57P8AaLiGhiNtNfJOr0c7bR9V1Mzkx0jn1wTN9PaeXetim0RFbQ+4dBdIR0l0Zs20TP8Am1r9Trxz+u0sVtaez6yOrqRHKLxGZw7WhqfWaVbZzOMW9qN0/Hj72quwygAAAAAAAAAAAAAPvps99NnxZ8c7Wx3i3qmIn7VZ9Vo3rPqn0sWtpU19LU0r+res1mecTPC0d9ZxMd8JiZrMTHGHTMGamow48+OYmmSsWjbw3jnE7comJ3iY8JiYeG1NO+jq6mleMWpaazGZnPV3ZjPGJ3TExxiYmeMN6s5iJid0x/OPw8X1VSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhly0w48mXJMVpjrN7TPhFYmfXP5R1naOuy1KW1L006RNrXtFaxHbM4jw8eEc0TMRvnhiZzy3fzc5nq9TfV6nLqL9clpmI8K0jlSse7WIjfaJmec85e42fQrs+jp6Nd8Urvn7VpnNre+0zPdGI5NG1uvM2nnPlw92I3dseK2ZkAAAAAAAAAAAAAANh7K8Fycf49w7hta97Hkz1y6qZmYrXSYJ8rqJmdp2m2Os4scTytlyY6TMd7dzOmNvr0b0dtW1TOL105poxxmdfUiaaURHOK2nr25xStp5MWteNPTtac5iJiMds7o88+6Xs2ta1rWtaxWtYiK1iNorWI2iKxyisRHKIiIiI5REQ+FzM2mZmZmZnMzO+ZmeMzPGZmd8zO+Z3y4s8Z357Z7Z5/9efFJCAAAAAAAAAAAAAAFzotNOr1em01d982alJmI3mtd972j3ccWtv0jbnyYtfVjR0dXVnhp0tbxnhWPfaYj3kziLW+zWZdmrWtK1pWIrWkRWtY5RWtY2isdOkRt+TwszNpm0zmbTMzPbMzmZ+LRmbZnMz3x48e7fx7OxVCoAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAJicND7YaOYy6bXVrHdvWdPlmIjles9/HM84me9WbxvO/3Ijp3Yn0fQmvE11dnmd9Z+tpHbW0dW8RuxiturPbm0zHbGzoWiYms8cxMcM4xifdE43e7O7dpbuswAAAAAAAAAAAAABPP/P8/wDMHHfpf4F9b4XpuOYcXez8MvGHU3rWZtbRai8RE32jnXBqJpNZ6UjNltP2d5r7f6FdI/UbZq7BqWxp7XXr6UTMREbRpRMzFczx1NLMT2zp0jOcRO9sepi80n+vMx7UcvfHxx3POL6i6QAAAAAAAAAAAAAADa+zmuiJvock/e3y4Jmek7TOTHEz4TH261jxi23hDz/TWy7q7XSOERTViIzu/ov7p9Cfu8omWfRvjNZ8Y/fu7J5c5ba8/wDz+cWyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1XtHru7Wmhx2je8Rkz7c5isTE0pvHTeft2jrt3Y5Rbn3ehdl60ztd6zHV9HRzwmZjF7R4Z6kcszbnEY19a/8AR75+O6P3n/hqL0bXAAAAAAAAAAAAAAAehPod4DXDotZ2gzUnyurvOi0U2iIiumw231GSk9Z8rniMUztG31eYiZ71tvmn046Qm+vodG6do6mhWNfXiJnM6upExpVtHD0NKevHHP1uZiMRnm7bqT1q6cf04tPjPD4Rv7N/c7Y8E0QAAAAAAAAAAAAAAG39kNL5TVZ9Zam9dPjjHS0+GXLP2u7P4q4otW3ojLHpcXpvW6ujp6MTv1bda0c+pThnum8xjtmk9jDrWxWIiZ9L3cPDvmOfKPB0Gef+f5+bzLWmcz2cPyjAIAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAYvjOj+vcN1OCN+/FPLYuW++TD9utY9E5IicW/hF5nwbmwa/wDh9q0rz6s26l/Zv6Mz93MWxz6uGTSmYtE78Zxbwnu7p3z+zkf/AKfn6HtG4AAAAAAAAAAAAAAAtNdo8HENJqdDqazfT6vBl0+esdZx5qWpbafTEWmY232mInaWbZ9fU2bX0to0p6upo6lNWk8cW07RavumYxPbGYndK1bTWYtE4mJid/D+cu3Ey8V8X4bm4PxPXcL1HPLotRkwWtETWLxWd8eSInnFcuOaZK9fs2jnPKZ+87FtWntuybPtel6mvp11IjOZrMx6VZmN2aWiaz3w7lLxesWjhMRPbjuzw3Mc2VgAAAAAAAAAAAAAH0xZb4clMuOe7fHaL1n0TWd439MT0mPGN4U1KV1aX07xmt6zW0d0xiff2T2mZjfHGN8ePL+Tu7XS9HqaazTYtRjmNr1jvRz+xkjlek7+NbRMR4TG1onad3iNp0L7Nr30b/029GftUnfW0Y3YmN853xOazGYy3qW61Ynt4+PP9/5K5YVgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHw1WoppcGXPknauOszt42t0rWPXa0xWPXLLoaNto1aaNPWvbGY39WP6rTHZWPSnu8VbWisTPZ+fd48nM8+bJqM2TPlne+W02t0iI36RG3hEbREbztEQ9vpaVNHTppacYpp1ite/HOe+Z3zwzM5aUzNpmZnMz/P54PkyIAAAAAAAAAAAAAAXnDtDn4nr9Jw/TR3tRrdRi0+KJ32i2S0V71tufdpG97zHStZnwYNp2jT2TZ9badacaWhp31bzzxSJnEZ42twrHOZiFbWilZtPCsTMvavC+H4eE8O0fDdP5nRafFp8czERN4x1iJyWisREXyW72S+3W1pneXwfbNp1Ns2rX2rV9faNW2raN8xXrTmKxnf1aRitc8ohxL3nUtNp5zM/FftZQAAAAAAAAAAAAAAnpOwOr8A0c6LhenpaIjJmj6zl23j7WWItWs7+NMfcpbf8AmrO07PG9I631+16tonNaT9VTvrSZiZ4zum3WmO6YaerbrXnHCN0e7j+efyZlosYAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAACsTMdI9O/PbflyjpPr/r6oF626sYxzmfycj43ovqPE9RirSaYr28th33iPJ5d7RFfxRS3fpvPP7Pjtu9psGv/iNk0rzPWvWPq7zxnrU3ZmeMTNYrb3zO6JblLdanPPDfxzXdv58O3O/nHBim4kAAAAAAAAAAAAAABwP6Yez/AHcmj7R6ete7eKcP18Vja3lIjJfSZ7bRtMTSuTBe1p70TTBXnExFfo30I6SzXX6L1JnNc7Ts+eHUnq11qRM8MTNdStY3T1tS3Kc9HY9TdOnbOY9Kud8YnjieXdHj3uFxz/v/AGnZ9Cb4AAAAAAAAAAAAAADYOAa+dPqPq2S38HUTEV36UzdKz6vKR9ievOKdNplx+l9kjV0f8RSInU0Y9KIjffTzmY7M0n0ozPDrY34ZdG/VtiZ9Ge3t5cPhv3Yj3t4eWic8p98ePy/OG2JAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/AD/z6Gf548vH5wNL7Q67yuaNHjtvjwTE5ZjpbNttt0jljidpj8UzE86vS9D7J9XpztN49PVjGnnGa6eeO7nfEb/sxXhmWrrWzbq8o8/5w8Z8I1t22EAAAAAAAAAAAAAAB2j6IOz/ANY12q7QanFvh0UTpNBa3S2sy1/3jJjiOczg09oxza32d9RMV3tS3d8H9NukvqtDR6M0r+nr41tpiOWhS2NKtp4f5mrE2xx/yoziLRnR23UxEaccZzNuMbuUd+ZxPu73oh8zc0AAAAAAAAAAAAAABkOE6SNdxDTae0b0tki2X14cf28kbxO8d6te7vy2m0dZ231dt1/8Ps2rqxPpRWa09u3o1nvxM5xHKJ4RvVtPVra0co3eM7o/N2DpG0RERG20RG0RERttHq22/pDxPHi0pnPPPiCAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAGo9r9F5TTYdbSsd7TW8llmOc+SyzvWZnfnFMm1Yj05JnlvLt9C6/V1dTQtO7Ujr0z9unGPvV3/AHfBs6No31jnvxyzGZ7OOM5n/bPi55HTn19T004zu4M6qAAAAAAAAAAAAAABieOcKwcb4TruF6isWpq8F8dZmN/JZtt8GevotgzRTLXw3ptO8TMNzo/bNTYNt2fa9K0xbQ1ItMR/XThqac92pSbUnutmN+GTTtNL1tHKfy5592e/smJxMeLtZpNRoNXqdFqsc4tTpM+TT5sdutMmK00vG8TMWjeJmtqzNbVmLVmYmJn7voa2ltGjpa+jaL6Wtp11NO8cLVvGYnunE4mJ3xOYnE7o7dbRaItHCYzHgtmVIAAAAAAAAAAAAABEzE7xO0xziY6xMdJ5bTykmImJiYzE7pieEx2SOh8I1/17SxN5/j4dseblEd6229ckbeF439lotHPZ47pDZP8AC7RMVj/K1M30sRwj+qn3Jnd/tms823pX61d/GuIn4bpjunzyyrQZQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGO4pro0Gkvkif4uTfHhr1+3Mb96YnltSN7TPPntEx9qG5sGyzte0VrP8Ap09PUmJx6MTia+NpxWIjfG+f6WPUv1K7vWnh/Ozt8XOZmbTNrTM2tMzMzO8zMzvMzPjMzzmXs4iIiIiIiIiIiI4REboiO6IafHfPNRIAAAAAAAAAAAAAA+uDDl1ObFp8GO2XPnyUw4cVI718mXJaKUpWI5za1piIj0ypqalNLTvq6lopp6dLXve26taUibWtM9kREzKLTiMzOIiJmfCIz/OHj2+zuznBcXZ/guh4Vhjf6viic95mLeV1OW05NTl35T9rLa8445xTHFKR92HwrpTb79JbftO2XzH1tsadeHU0qx1NKmM8YpERad3WtNrY3zDi6t51L2vM8Znqx2RHCOWMxz49vazrnsQAAAAAAAAAAAAAADfOyGimuPUa+1fOT9XwzMfyV2vltE79JvFY9fcn0PO9N6+baezVn1P8y/tTmtYnviOtPd1o55YNecYr75jh4d/fju+G6OC1gAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAHw1Wnx6vT5tNl+5mx3xzMREzWbRPdtG/LvUttavomIlk0dW2jq6erX1tO8WjvxO+J7pjMT3TK1ZmtotHGJz444xPdMbpcazYrYMuXDeNr4sl8d4mNtrUtNZ/vHL1ep7qlovSt6763rW0c91oiY/KW9nO/Oc78+O981gAAAAAAAAAAAAAAExOJz/N+552+l/s79W12m7QabHMYdf3dNrprH2a6zFWZw5Z26TqMFO5PKKzbBNpnvXnf6d9Cekvrdm1ejdW+dTZpnV2eJ4zoXmOvWO36vVnMc8akRHo1h0tj1OtWdOZ319KPZnEfCJ+GccIhxh7pugAAAAAAAAAAAAAAMhw3W20Gqpl5zjt9jNXeeeO3WYiOtqT9qvpmO70tLU27ZY2vQtp7o1I9LStMcLxG6J/229W3dOeMQvS/UtE8Y4THd8Y4cXR62rkrW9Ji1L1i1bVneLVmN4mJ8Yn09Hipi1bTS0TFqzNbRPGJjjE5xO6d2/fPHfG9uRMYjhGd8RHZx3e7iqJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUm1axNrTFa1iZm0zERERG8zMztER6Z8DEzMRETMzMRERxmZndERzmZ5c+CJ3R+/DEc539nFzviuvnX6q14mfI498eGszvHcjlN9to2nJtFpjnMR3azM7PZbBskbJoRWYj62/p6sxH9U8K55xSJmI5TPWtER1mnqWm1sxwicRns5/Hly/fGN5QAAAAAAAAAAAAAAB1z6Jez0cQ4tl43qK2nS8JmK6feJimTiGWs9yd55T9WxTOWYie9GTJp7fd5W8X9M+k/8NsdOj9K0fXbZ6Wr9quzUtGd0cPrbx1MzumldWOPDT2zUxSNOsx1rzvjn1Y39vOcRv/5elHytzJ4z4/ziCAAAAAAAAAAAAAAFa0tkvTFSO9fJetKxHWbWtFaxHjvMzHs6+iJi1opW17TitIm0z2RETMzM8IxETxn98TmIifd8Oed/h2uy6HS00WkwaWnTFjrWbeN78pvafR3r963Lpvt06eG2jWttGtqa1t03tMxH2a8K1+7WIj3ZaN7za1pnnu+E5jPfjd+a6YVAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAFY6+P5ddvH+wmOMb8d+MucdrNFODW01lY/h6qv8SdumbHXad+W326dy0c5m0xeekc/UdDbRGpoW0LT6ejOa556d5zGPZt1onlETXnMNvRnMdXj1cd2YnfHh2fvvaq7DIAAAAAAAAAAAAAAAwvaHg2Dj/B9dwrPO0arBaMV9t/JaikxfT5ojeN5xZq0tMbx3q96u8RMzG/0Zt2p0bt2z7Zp7/qdSOvXh19O2a6lOE461JtETicTieTJpX+rvW/ZPdz90/HG7v4T4w1WmzaPU6jR6ik48+lzZdPmxzymmXDktjvWY9VqzEel910dXT19LS19K0W09bTpq6do4WpesWrPviYduJi0RMb4mImJ7pjMPgyJAAAAAAAAAAAAAAAbd2d4jExOgzTvasWtp5mec123tj333nu87VifDvx4Q870zsWJjbNOuIma11sdud1+GN8ejaYxOerPO0s+jfGaz939/n4RPg2pwWyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1jtBxCKY/qOK0TfJETnmJ51xzzjH7cnW3PlSNpja8S7nQ+xze3+K1I9GkzGlE/1XjjfHZTfFePpYmJzVr6t8R1InM/1T5d2/j3Rhpz0jXAAAAAAAAAAAAAAAfTDhyajLi0+Gk5M2fJTDix1je18mW0UpSI8Zta0ViPGZVveulS+pe0Vpp1te9p3RWtIm1rTPKIiJmfAmYiJmeERmfCHsvsvwPH2e4HouFU7tr4sff1WSsRHltXm+3qMnLnNe/Pcxzae9GKlKz918L6X6Qv0nt+0bZbMVvfq6VJnP1ejT0dOu7dnHpWxum9rTHFxNXUnUva05iJxiOWIj0d/hOZiee/w2FzWIAAAAAAAAAAAAAABsvZXQ21PEfrNqx5HRV78zO0xGe9ZjFEbeMR5TJE9azSs8ptDldMbRGls31UTMX156u7MZ06zm857JxWmN2etO7dLHqWxXGcTbdnjiOc+HKc9rpbyjUnj28s+G6AQAAAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxHHND9f4bmxVrNsuLfPg26+UxxvNY9Pfp3qd302iee0N3o/aP8AD7Vp2mcUvP1epnh1bzG+e6toraZ7Ilm0bdW0comYiZ5788OUY4593PdyWJ39P+f359fY9pjw/n5fm2v52KoAAAAAAAAAAAAAAAHnj6X+zv1fW6btHpq/wtb3dJroiu8U1WKk+RzTMco+sYKeSnvdL6eOczk2j6b9CelPrdDV6M1Z9PZ862zzM77aN7enp4/8PUnrRv311OEdSZnpbHqTNZ054131ndvicbu/GYnuiYcW6/8An/nw5Pdt4AAAAAAAAAAAAAABKl74r0yY7TW9LReto5TFqzExMT6pjnHj0nl1ratb1tS9YtW0TW1ZjMTExiYn+ZjjG8/bf8HSOG62mv01ctdoyV+xmpvH2bxEbzEdYpbfvVmfCZjrWzxW27NbY9e2nMTNJ9LSvicWpMzO/wD3V31tiOMZ3RMY3NO8XjPOPW+HH3r5rMgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACz1+spodNfPbnb7mKn48lonuxM+ERtNrTzmKxaYjfaJ2Nl2a+169dKs4ic21LfYpEx1rY7ZzFY/3TEbszMU1LdSM4z3ZxMzyjzz3R8ebZcmTNkvly2m2TJa17Wnxm07zy6REdIiOVYiIrERyj2unp00qU06R1aUrFaxHKI85njMzvmZmZ372nMzM5nfMoLoAAAAAAAAAAAAAAAdf+iXs39f4pk49qa1nS8KtOPTVtXeMnEMlImLxvHd20uK/lPxRly4L12mky8V9M+lP8NsdOjtKZjV2yOtqzE46uzUtvjt/wA68dTsmlNSJ4xnT2zUitepEzE2445137vf29mc53PSP+f5/nwfLHMmc47v5/x7oBAAAAAAAAAAAAAABPSfZ6dv7+HtB1Ts9ofqXDcM2iYzamPrGXeNtpvEeTptPOO5j7u8Tz782naN4h4/pPaPr9rvic00v8qmN8TFZ9K27dPWtnfHKIjM4y1Na3WvjlX0eXv4TiWcc9iAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAABOeHdOfL5OUcf0P1HiWWtY2w5t9Ri2jaIrkme9TbbbamSL1jb+WK9N5h7Lo3aI2jZaTM5vp/wCVfM781iMW7+tXqznt60b8ZbmnaLUjnOIie7Hzj4flGGby4AAAAAAAAAAAAAADF8a4Vp+N8L1vCtVvGLWYLYpvERa2K+8XxZq1mYibYctaZKxvG8123iJbmwbbq9H7ZobZpb76GpF+rnqxeuJrfTmY3xF6Tas8eOZiV6XmlotHGJz/AMZ74/m6Hi/iGg1HC9dq+H6qvc1Gjz5MGWu0xHepbbvV3iszS8bXpaY+1W0W6S+67NtGltez6O06Nutpa+nXUpO7OLRnE4zi1ZzW0crRMcnbraL1i0cJiJj3rNnWAAAAAAAAAAAAAAAZHhevtoNTXJznDfamesRvvTf70RvH26T9qvp516Wlpbfslds0Jpw1KZtpWzjF8cJ/224T2brRvrC9LdS2eMcJjtj+drotL1yVrekxat4i1Zid4mJjeJj8njZrakzS0TW1ZmtomMTE1nExjlvhuxMTGY3xKSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABSZisTa0xFaxM2mZ2iIiN5mZnlERHOZnoYtMxFYzaZiKxETMzMziIiI3zM8scyZxvc84txCdfqJmvLBi71cFfTEzzyTvt9q+0b+iIrHhMz7Ho/ZI2TQxb/V1MW1Z74z1ax3ViZ7d82nOJjGnq368/7YzEfvO/t8sZhi2+xgAAAAAAAAAAAAAALnR6TUa/V6fRaXHOXUarNjwYaR1tky2ilY9Ubzva08qxEzPKJYtfW09n0dXX1rRTS0aW1NS08q0ibTPwjdHOdyLWisTad0RGZn/j4fF7M7O8Gwdn+EaLhODu2jTYo8tkisVnNqL/AG8+aY6z5TLa013mZrSKY95ikbfDOk9v1Oktt19s1Mx9beepSZz9XpVzXTp2R1aRETiMWt1rc9/E1b21L2tbdMzw44iN0Rnu7sRPHDNuexgAAAAAAAAAAAAAAMrwTQ24hxHDhmInFS3lc0z08ljmJmJ6x9uZrjjflvbeY23iNPb9ojZtm1LxOLzHU0/btuiY9mM2znljjxi8xWMxnlHvmP2nOe78+ueEez0/29Xs9f5R4tp3iIxjv/ZQUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAa32n0P1rh/l6V3zaOZy8o5zhttGavsrERlnptFJ6zOzq9EbR9TtH1dpxTXiK7+EXjM0+OZr4zGe7PpWxaKxwtHD/AHRnE98zvjd2x4OZ/wCj1bZAAAAAAAAAAAAAAAP7g4V9L3Znv1w9ptNT7VIx6PiVK1jnTea6TVWmImfsWmNPkmf5bYIju92X0L6FdK9W2p0TrW3W62tskzPC2OtraMRPbETq1iOcavHMY6Gx6vHTmZ7a54RxzX9497gn+f51fRnQAAAAAAAAAAAAAAAAbR2f4l3JjQZ7RFLTadPaZ6Xmd5xTHSK2me9SeX25mOto24PS+w9bO16Vc2iIjWrEb5rGIrqR2zTERbdmKxExOKzDNo3xPUmJxM7p7OeO2YnM47JzynduDzraAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD+fz4meXNqnaDiXXQYLTz56m0T4TtMYd955zynJz6bUmZ3tEd/ojYc42vVrwmfqa2iN88J1fhmKe+3KrW1rxmaxz9ac8o3TWI7M7578NSj/P85dHoWAAAAAAAAAAAAAAAAB3D6IuzM5M2btNqaR3MHf0nDItHOc1qzTVamN42iMeO3kMdomd7ZM0TEdyO98/+mvSvUpp9FaNp62p1dba8Tw04nOjpTid82tH1lomMRFdOd/W3aO2asREacTOZxNsdnKOPbvn3RE75x6AjpHsfN54zjhyc2eM4AAAAAAAAAAAAAAAN49IOj9lNB5DRX1d42yaud67xO8YMczFI28IvbvX3/mjuT0228v0xtH1mvGjWc00Y34/7y0RNszz6sYjunrR2tfWtmeryrGcxPGZjEZ8N2I5el4NpcdrgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKTWLVtW0Rat62ras84tW0TWYmPHeJmExM1mLROJiYmJjjExOYmPCUxMxOYnE7988t38x3uP8T0U8P12fTbWilbTbDa3W+G/PHbfaItO32bWiNu/W0dYmHttk2j/E7Pp6szE2tXF4jdi9d1ox/Tv3xH2ZiY3TDdrbrVif5nn/ADsxywsGysAAAAAAAAAAAAAAAtdbo8HENJqNFqqRk0+qw5MGbHPS+PLWa2jrHOI3ms+E7T4M2hr6uza2ltGjbqaujeupp2jjF6zms+HbHONy1bTWYtHGJiY92e7hv374/ePGnaLgep7O8Y1nCtRFp8hk3wZrV7sanS33nBqKxEzXa9eVu7a0VyVvjme9WYj7n0Z0hpdJ7Fo7ZpYj6yuNSkT1vqtWu7U05nETms74mYibVmtsYtDtad41KVtHON8dk5xPHh24nfMMI32QAAAAAAAAAAAAAABWJmJiY5TExMTHWJjnyn27T+UExExMTviYxMdsSN/4NxKNfg7mSYjVYYiLxy3y13iIy1iPTvEX2jaLbdO9EPIdJbFbZNWbUjOhqTM03TPUnjOnO/lvmnHNd2M1xO3pX60Yn1o/OO1mHOZQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGK4txKNBg2pMTqMsWjDXlPc5bTltE/y13jaNp71tomJiJ23+j9ina9b0o/yNPE6k74z2UrMf1W39ad2K8JzjOPUvFInGOtO6Mcff8AznHi57a1rWta0za1pm1rTMzMzPOZmZ8ZnnL2ERFYitYiIrERERwiIjERHdEbmn4zmZ3zn+Y+CiQAAAAAAAAAAAAAABleCcI1XHeK6PhWljbJq81aWyd2bVw4Y3tmz3rHOa4cVbXmN4720Vid5iJ0+kNt0ejtj19s1vU0KTaKxMROped1NKsz/VqWmKxunGczGIlTUvGnWbTwiOHOZ5RHjv4vZvDeH6bhWg0nDtJTyen0mGmHFWdt9qViJveaxWLZMlt8mS20d/Ja1p5y+FbVtOrtm0a2069utq62pbUvOZxm05iKxMzNaVjFaV3RWtYjG5xdS3XvNp4zvnPHPfw4cOzEe5fMCgAAAAAAAAAAAAAAC84fpLa/WafS13jyuSIvaI37mOu9sl/RHdpFpjeYjvbRvzYNp1o2fQ1Nad/UrmIzEZtMxFY39tpjt3ZnG5Fp6tZnsjLsWOlcWOmLHHdx461pSvorSsVrH5ViIeIta17Wvac2tM2tM85mczPxaM2mZme2cz3znOZSVQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArH+k/D/P8AUTXGYzw/4al2t4fGfTU12OPt6WYpk7sc7YMk8pmdomfJ36cuVb2mZ5RLs9DbT9XrW0LT6OtvrnlqVjh9+u7xrWObZ07xnqxwnM8Of/MZz3xHbDnb07MAAAAAAAAAAAAAAAA5Z9KXZeeM8J/2tpMVsnEOEUte1aRE2z6Dfv58fd23tbBO+oxxvvFYzVrW1sldvX/RHpb/AAO2/wCD1rxXZtttFYm3DT2ndXStnhEan+nbMcZpMzEVlt7JrRp36tsRW3Cd+627x44x443vMT6y6vEAAAAAAAAAAAAAAAB99LqcukzUz4Z7t6T0/ltX+alo8a2jlMfnG0xExi19Gm0aV9LUjNbxjPOs8rVnlaJ3xPu4TKazNZi0cY/mPCebpGj1eLW4KajFyi3K1JmO9jvH3qWjrvHp8YmJ8YeK2nQvsurbS1I31ndaM4vWZxW1e2J7s4nMcYbtbRaImPCY7J5x/wArlhWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAW+q1OLR4b5807VpHKI2mb2neK0rHSZtMbeiI+1PLmy6GjfadWmlpxm15jfOYitY3za0xGerEcd2+d3GVL2itetyjGY5+HjO7d2Zc41mqy63PfPlmO9adq1j7tKR92lfVEdfGbTMzvMzL2uz7Pp7NpV0tPhWMzM8bWn1rT3zPwjERiIiI07Wm05nj3RjwWzMgAAAAAAAAAAAAAAAB6T+ijsx/szht+OavHaut4rSKaemSNpw8OrMWpaK2jvd7V5KxlmZ5Ww0wTHW2/wAs+mPS3+L2qvR+jaJ0NjtM6tqzmNTapjFozG7GhW00jnF7akTwiI5m16vWt1KzExTM27ZtmI+Ebse/MuuvFNIAAAAAAAAAAAAAABSZ2iZ9EHvx3yN/7I6CMeLLxHJH282+HBE16Y6Wicl956xe9e7G0dMczvtZ5vpraOtemzV4aeL3ntvaPRr92szM9vWjsYda/wDTwxvnHOcTiIxGImN3xy3Jw2qAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAjfHXLjyYrx3seSlqXrPS1bVmtqz7azMezf2LVtalq3rOLUtFqzHGLVnMT7pjLJSP6uccO6e3+d7jvENHfQazPpL7zGK8xS8/wA+OeeO/j96kxM852tvETO272+za9do0NPWr/XWMxx6tozFqznfutG7tjE825E9aOtnjxjnnsn85hZs4AAAAAAAAAAAAAAApNYneJjeJiYmJ5xMTvymJ3iY5+j1dExMxMTHGJzHKc+Mb/z3ch5N+kLstbs3xq99Pi7vC+IzfU6Ga7zXDO8Tn0k786+QvePJxbeZwWx/ataL937L9Gul46U2CtdS+dr2WK6W0ROIm8YmNPW3bpjUrWetMcNSLRiImsz2Nn1frKYn167rR++eE5584nj2zoT0TYAAAAAAAAAAAAAAAAZLhfEb8P1EW3m2DJtXPjjnvXflkrH46c+7ziLRM1mee8aO37HXbNLq7o1aZnSvPKeM1n/bbERM7+rOLREzGJvS80nMcJ4x2x84dEpemWlcmO0XpesWraNpiazziYmJnw2/PePB4+1b0tal6zW9ZmtqzxiY4xO6G5E537sTwx2duf2wkqkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABS1q0ra97RSlaza1p5REViZmZ329CYi1rVrSJta0xEREZmZmcRGI35md3Ce9EzjMzuiN+e7n7/jy48HPeLcStxDP9ibV02OZjDSY7u/Od8lq8/tX6RH8tNojaZtM+v6O2GNj0Y60ROteInUtE5iOcUiY3YrxmedpmeGIjU1L9e3PEcI/fxn8u1inQYwAAAAAAAAAAAAAAAG6dhezF+03G8WHLS88O0fd1PEckconFW32NNFvx6m8eTiI+1GOMt427m8cL6Q9LV6J2C96Wj/ABWtE6Wy1nEz15j0tWYnEdXSietv3Tbq1niwbRq/VUmYmOtO6sePPHHEdz1zSlMda0pWK0pWtKViIitK1jataxHKIiu0REeERD4ra02mbWmZtaZta075mZnMzPfM5n3uPNpnOd+efvz+c/zfKaEAAAAAAAAAAAAAAALnR6XJrtTh0uL72a8U38K13+3efVSsWtbnvtG0c5hi19auz6WprX9WlZnHO08KxHfaZiI5b8zuTOIjM8sZieed8Yx2x24x29nY8ODHpsOLBirFceKlaUrH4axERO/jM85meszvMzMy8PqaltW99S85te02tPfM5+EcIjhEbo3NC0zO+eczM74nfzxjlwx+T6KKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAnMxwmYah2s4fOXBTiOON76fbHnnxnBa0923r8nktETyjauSZmdqxv2+htp6mpbZrT6Orm+nnlqRG+Pv1j41iI3y2NGZ3xbniYnjvnlPux/wBZc+elZwAAAAAAAAAAAAAAAGsdruzmDtPwXUcOvFK6mP4+hz2jlg1mOs+TtMxEzGO8TbFl23nyd52ibRV1uhelNTonbtPaa5tpT/l7Rpxx1NG0xNojO7rVmItTOI60RmYiZZtHVnSvFuW6Lc8x2d27OPDHc8eajT5tJqM+l1FLYs+ny5MGbHaNrUy4rzS9J9dbVmPyfb9LUpraenraVovp6tK6lLRwtS8Rasx4xMS7MTExExOYmIn3S+K6QAAAAAAAAAAAAAAAGwcE4r9VyfVdRb/dsk/YtM7eRyTPPeZ6Y7T96elZmLco7+/H6U2D6+v1+jH+dSPSrETM6tI5REcb1/p7Y9HfisMulqdWcWn0Z/KZ3Z8O2OEcW8ddpjxjfw229Xp9vjLy26M+M538J9/Dvjk2xIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArHr6eP9Y/p6N/WieXj24378eOeGBpXHOK+XtbR6e38Glv4t4nllvWfuxMTzx0nrv968b9K1mfTdFdH/VRG061f820f5dZjfSs/wBUxjdeYnEfZrM53zMRq6t8zNY4RMZntnHCO6M/HLW3bYQAAAAAAAAAAAAAAAH0xYsmfLiwYaWyZc2SmLFjrG9smTJaKUpWPG1rzFYjxmdlb3rp0vqXtFaUra97TwrWsTa1p7oiJme5EziJnsiZ7OD192K7M4+zHBMGktWk6/PFdRxLNTn5TU3rG+OLzG84tNX+DiiNqztbL3Ytlu+J9O9K36W2/U1s2/w+nM6ey0nd1NKJ9bETjr6s+neZ3760zMUq42vqzq3mcz1Y9GsZ5RP55458M8MtucVhAAAAAAAAAAAAAAABMRM5xy4/z3N87JcO7uPLxHJTa2TfDppmOlImJy3jfp37x3Inr9i/hZ53praetamzUtOKYvq+1MehWe3FZ62OG+N2Yhr61pxFYmd2Jt48K493Pd2eO6OC1gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFMmOmfHfBlpF8eWs471mN4tS1ZraJj0TE7+E9dpjdal7UtW9JmtqzFq2jjExOYn4skXxiMTGI4xO/xcd4jo76DWZ9LePN3mcdvx4rfax3/Osx3o5920TWZ3iXt9l167ToaerX+qvpR9m8brR7pzjtjE825ExasWjdnlnfExunMct+f23cbJnAAAAAAAAAAAAAAAFJjf/wBN/wDPz39h29/zif2HCfpa7KTbbtPocczNe5g4tjpWPuREV0+t2rET9neMGeZ732fI25RGSz6J9DOmMf8A8J2i26etqbFaZ5zMzq6G/tnOppx2/WRxmsOhsmrujStu50mc7+Oa9kY4xHbnnMODPojoAAAAAAAAAAAAAAAAANu4FxaJiuh1NtpiNtPltMRE9P4Npn+b8EzO8x9nnNYifO9K9H752rQrmM51qRGZjjP1te77cRG6fS3RNpjPpak56tpn/b8pxvnnj3dkNqcFsgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANY45xbycW0Wmv/ABJjbPlrMT5OvS2KsxO8ZJjlaf5I3jlbp3Oi+j/rJrtOvX0InOlS0evMcNSYn+iP6ftTv9XHW19XU/prO/haezujv7e78tOeka4AAAAAAAAAAAAAAAADt30Tdk41GWe02uxTOHBa+LhdMlImuXPXembWR3oneME97FhtXpn8pbeL4avA/TLpn6ukdE7Pf09SK32y1Z3105xNNCcTunU3X1Kzx0+rE5rqTDQ2vVmI+qieO+0RPCMRiPfO+d0Zjdw3vQT5q538+AAAAAAAAAAAAAAAAC50Wky67V4NLije+W8RM7cqVjeb5Leqld7bTPPu7V3ttDFtGtXZ9G+tfhSJmP8AdbdFax3zbEe/fuJtFYzMermfLGd2d37ux4MOPTYMWnw17uPDSuOvpmtYiI3nrMztvaZmZm3OZeH1NS2re+pec3vabWnvmc7o5RHCI4RGIjdDRtabTae3/j5Q+iioAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJrjMZxjvap2r4b9Y0tdbhrvm03LLMR9q2ntPo596cVvtdPs1veZmdoh2eh9q+q1Z2e9sU1d9M8I1Y8uvWMd9orHNtadoziJic7+McY/Lf+c4hzp6dlAAAAAAAAAAAAAAAAfHUafDqsGbTajFXNg1GK+HNivG9cmLJWa3pbpytWZjrExvvExPNfS1dTR1Ka2leaamlet9O9Zxat6zFq2jviYifNMTMTExxiYmPGJzH5vIHbHszn7LcZy6K0Wvo80TqOH555+V01rTEVtP/a4bb4ssbRMzWMm0VyUmftvQfS2n0vsNNojFdamNPadP7GrEb5iPsakenTjiJmsz1qy7Ojqxq0i2YzwtXdut54nGY9/ZiNUdhmAAAAAAAAAAAAAAAAImYmJidpiYmJjrExO8TE+ExPOJ8JJiJiYmMxO6YnhMdkjeOC8WjVUjTai3+80j7F7TzzVjrO8/8SP5o3+1H2tpmJ28t0l0fOz2nX0YmdC0z1qxH+laZjEexP8ATM8Jnq7o6udrS1InFbet2zPH/nHx48WwOQzAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMHxjisaKk4MMxOpyV6xMfwKz0vPKftzH3Kz4fanltFup0b0fO1X+t1YmNCkxu3x9bMZ9GOHoxPrzHdWJzma4dXU6uaxO+ezlG/M5jn2eUbs6JaZtabWmZtaZm1p5zMzO8zM+MzMzMzPWZmXq4iIiIiIiIiIiIjEREboiIjdERHCGqokAAAAAAAAAAAAAAAAbL2U7OajtPxjBw7DFq4K/x9dqI2j6vpKWrGS8TMTE5LzMYsNYi02yXrM18nW9q8rpjpTS6J2HU2q+Lak/5ez6c/9rrWiZrXdv6tYib3nditZiJ601icWtqxpUm08eFY7Z/nF7C0mk0+h02n0elxxh02mw0w4cVd5rTHjrFaxEzvMztHO1pm1p3tbe0zL4jr62rtOtqbRrXm+rq3tqalpxm17zNpnEY58IjdEYiIxEQ41pm02tOJmbTMznnPHdnhnhK5YlQAAAAAAAAAAAAAACf823/0B0Dsnw7yWK/Ectft598eCLdYwxMxkvHo8pesRWZjfu071d633nzfTO1de9dmpPo6c9bUxzvMbq+FYnM8szv31hh1bcKRMcrTnHHG7nxjM7p59We+NwnnMz6XDaoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAClq1vS+O9YtS9bUvW3OLVtE1mJjxiYmY5+EymJmsxaszE1mJiY4xMTmJjvid6YnHj2/n54n3d7kXFtBbh2uy6eYt5OZ8pgvMcr4bzPc5+M1nfHbl96lp6bTPtdi2mNq2emru62OrqRHK9fW8In1ojsmIb1LRasTnfjfGOE9nlPhOeO5jW0kAAAAAAAAAAAAAAABp/bTsth7U8HyaT7NNbpptqOHai0RvjzxXecNrcpjDqYrGPNz69zLO9sVYdvoHpe/RG211t9tn1cae06cTOLaeZxfEcb6UzN6Yjf6VOF5ln0NWdO8T/TO6YxndxziMZmN8x354ZmXkTPgzabPm02ox3w6jBkvizYslZrfHlx2mt6XiecWraJifXD7Vp6lNbTpq6V6309Slb6d6zmt6WiLVtE84mJiYdiJiYiYnMTGYnufJdIAAAAAAAAAAAAAAACVbWpat6WmtqzFq2rO01tE7xMTHOJiecSi1a3ratoi1bRNbVmMxMTGJiY5xMcRvnCeK112OMWWYrqsdftRyiMtYmIjJXnP2p/nry2md4+zMbeS6Q6Ptsl51KZtoXt6M8ZpM/wBFuG77M84jE+lx29PU68Yn1vPdx88s05vFlAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYji3FacPxd2n29TkifJ18KRzjyl4iekTtNa9bWjbpvLf2DYLbZfrXzTRpPpzumbTj1KTvjOONv6YnhOYicWpeKxjETblziO/5NBve+W9smS03ve02ta07za0zvMzP+ep6+lK0rWlKxWtYitaxuiIjhENT8/FBYAAAAAAAAAAAAAAAATx48mbJTFipfLlyXrjx48dZvfJe8xWtKUrE2ta1piK1iJmZmIiN0WtWlbXvataVibWtaYrWtYjM2tacRERG+ZmYiI3yTOImeGIzl637CdlMfZbg9ceWtLcT1vc1HEcsVjeMkVnyelraJt3selre1KzvEXyWy5IrXyndj4v8ASHpi3S+3WtSZjZNDraWy0zOJrmOtqzGIxbWmtbTGMxWKUmZ6uZ420a31t5mPVjdWN/vnGcZnd8Ibs4DAAAAAAAAAAAAAAAAAvuG6G/EdZi0tImK3nfLfltTFXnktvO8b7cq7xtN7VrPOdmvtW0V2XQvrWxmIxSs/1Xn1Y5bs75xOerEzyRaepWbT2cM75zjd788+WXX8eOmLHTFjrFMeOlaY6xvtWlY2rEb7ztERt1eJta17Wvac2tM2tM85mczPvnsaVpzPPOMzPfO/d2cf5zmqqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA13tLwz69ovLYq76jSROSvpvi+9lx+G/KIvWOverNa87zv1Oitq/w+v1LzjS1sVnsrfPoW7ozM1nlicz6rNpW6s4mYxbHPhPLn7vfHZOOYRO/+f57fZMPWS2lQAAAAAAAAAAAAAAAAcM+lbsf5Stu0/DsUd/HFa8WxY62mb44ju0120bxviiIx6idoicfcyTEdzJafoP0O6b6lo6J2q89W8zOxXtMYrad9tnzxxffbSic4t1qRPpUrHQ2TWn/AErTu/pnsmf6Z4cZzjOczLgT6O6AAAAAAAAAAAAAAAAACePJkw5KZcVppkpaLVtE7TWY8Y8J9ExMbTEzE7xyVvSmpS2nqVi1LxNbVnhMT/N0xvid8TEwmJmJzG6Yb9wrilOIY+5bamqpXfJSN9rxHLylPVM/erzmkztO8TEz5Db9hvsep1ozbZ7z6F5xms78ad4znrY4W4WjhETmI2tPU68Yn1o48OzjHb344T3cMu0GUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABi+KcTxcPxRHK2oyRPkse/tjv29FKzHPnvafsxtzmN7YNivtmpOZmujTHXvHHO/NK/wC6Yxx3VjfOZxE49S/UicYm08I/ee7jy7scXP8ALmyZ8t8uW03yXne1p8Z9XhERG0REbbRG0ctnr9PTppUrp6dYrSsYiI4Y85mZzMzMzMzOZ3tSZmZmZ3zPGf5+Ucnz/wA/qugAAAAAAAAAAAAAAAAB3L6KeyHlLx2o4ji3pjtanCMVt/tZK71y62a7bTWk97Fp97ecjJkmsd3Defn30x6b6sT0Tst/StETttoxurMRNNnzndNt19TER6PUr1sTerQ2vWjdpVnjMdaeXh8OMc4mOUy77H/X49fz6vnH8/ng58zmZniqIAAAAAAAAAAAAAAAN4jrOwOk9l+G/U9JOry0muo1kRasT96mCLb4/ZOTbyk+O046zETWdvLdLbV9drfU0tnT0d044W1f6p74p6sd8WmN0sGtPKOFZjluzvie3hwzO7s4tnchrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOWdoOGf7O11px1202p3y4O7E92s7x5TFziIjydp+zHP+HNN5mYnb1/Ru1f4nZ4i0zOrpYpfPOP6b8f6ozmcR6UW3YxM71LRasRmJtXdOOfZOeed/PlwjngnRWAAAAAAAAAAAAAAAAQyY6ZaXx5K1yY8lLY8mO8Ral8d4mt6XrMTFq2rMxMTG0xMxPKZWra1LVvW01tSYtW1ZmLVtWc1tExMTExMRMTE5id8JicYmMxMb4nsmM7/du/N5M7edkb9l+KTbT1tbhOum+XQZJ5ximJ3y6O89Yvg3jyc2+/hmk96165e79l+jvTVel9jiNSYjbNnitNorG7r8q69eXV1MelEbq3zGIrNc9fZ9aNWkZ9au60e7dO6MRE9nKdzRXoWwAAAAAAAAAAAAAAAAA+mLLkwZKZcNppkpO9bR1ifZ0mJ6TWeUxyneOSmpp01aW09SsWpaMTWYzE/LtiY3xPBMTMcG/8L4pj4hj7s7U1OOseUx9In03x785pPj1mkztMzymfI7fsN9jvmM20bz6F984nd6FuUW7OEWjMxwtEbenqRaIifW5x4c/f3cGVaDIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAxvEuJ4uHYpneL6i8TGHF157TtkvtO9aVnx62netZid5jd2LYdTbNTEZppU/1NTunHo05Tee/1YjrTHDOPUvFI5dblH7z3OfZ8+XU5b5s15vkvMzMz4c+URHSK1jlFY2iPDbo9fpaWnoaddLTrFaVjERH5zM8ZtM75md8y1JmZnMzMz3vkyIAAAAAAAAAAAAAAAAAbn2I7KZe1PFq4bxenDdJ3c3EM9d67Y99qabHfeIjNqZia16zSkXy/wAm08Lp/pmnQ+xzeJrbatbNNl0535tj0tW0cZ09KJibfatNaf1ZjBr6v1VMxMda04rE498+Ed/P3Q9cYMGLTYsWDBjriw4cdcWLFSIrTHjpWK0pSsbRWta1iIiI25e3f4vqal9W99TUta99S1r3vaZm1rWmZta0zvmZmZmZnM73HmZmZmeMzmec5njv4/J9VEAAAAAAAAAAAAAAAAMzwLhs8R11K3rvpsPdy6id9omsTO2PeI33yTEV2jn3e9Mbd3do9IbVGy7PaazjV1M00o5xON9+GPQicxndnETG/fFrRWszn0pzEZxjhxnPKN/Du4OrxtEREREbRERty2iOm0dIjbaIjntERs8bMzMzMzmZ3zM8ZntlpzeJjGN+748wUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYzjHDq8T0WXBMR5av8XT3mI+zlpEzEb9YrePsX2idqz3tp7sQ3Nh2qdk2iupv6k+hqxHOluM45zWYi0d8cmXSvNbd07p48/DMTO+eMeEw5HalsdrUvWa2pa1bVmNpraszFqzHhMTExMemOb2cWi0RaJzFoiYmJzExMZic98b23u5d38+SiQAAAAAAAAAAAAAAABhO0PAtF2i4XqOGa2u1csRbDmilb5dLqK7+S1GHvbbXpMzE8697HbJjtMUvZv9G9I6/Re16W16EzM0nF9PrTWutp2x19K+M+jbETE4nq2it4jNYZNLUtp2i0Tw4xnGeWP5E8I3PHvGOE6zgfEdTwzX45x6jTXmsztMUy0nnjz4pn72LLXa9LRM8p7s7Wi0R9u2HbdDpDZdLa9ntFtPVrE4/qpb+rTvHK9J3Wj3xmJiZ7Onet6xas5jHvjunjvjhPexjbXAAAAAAAAAAAAAAAAAfTFlyYMlcuK9qZKTvW1ZmJj/rExymJ5TEzE7xKmpp01aW09SsWpaMTWYzH/ExxiY3xOJiYmCJxMTHGN8T2N+4VxTHr8fcv3aamkR36Ryi//PjiZ3ms9bRzms7R0mJeS27YL7HfNc30LT6F+dZxHoXxiInOcTwtExjfFojb09Trbp9bdnhETu4xHHxjlnduZZz2UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABi+J8TxcPx7RtfUXj+Hi36eHfvtzrSOcx42mNo6TMb+w7Dfa75nNdGs+nfGJn/ZTdibds8KxiZzmInFqanUjHGZ4d385fm0DNmy6jLfNmvN73nnafbPKPRWP5YiIiI6PXaWlTRpXT06xSlYxFYjuiMz2zON8zvnm1ZmZmZmZmZnMzP83RHKIfJdAAAAAAAAAAAAAAAAAC+4Zw3WcX12m4docVs2q1WWMeOkRMxG/O2TJMRPcxYq75MuSfs0pW1rTERLX2vatDYtn1dq2i8aejo0m97TjM44VrEzHWvecVpWN9rTFY3yre9aVm1pxEfzHjPCO2dz2F2Z7O6PszwnBw3S7XvWPKavU9zuX1eqtERkz3rvbaOUUxU71vJ4q0pFp2m1viPSvSev0ttmptWtmsT6OjpdbrV0dGJnq6dZxGeM2vbEda82tiM4jjaurbVvN5zHKsZ4RHCPjvnvbA5rEAAAAAAAAAAAAAAAArFZtMVrEza0xERHOZmZiIiPXPT8yZiImZxEREzMzwiIjfPu4jrHBOG14ZoqUtEfWMu2XUW5TPlJjlj35/ZxR9mI6TPett9qZnxm37VO1bRa0TP1dPQ0onh1YnfbHbed85346sT6sRGpq361pxnqxuj5+/dP8A0hl2kxAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK/HltPoExOOUT4/zvc/7V8L8llrxLDX7Gaa01ERG0UyxvFcs7bxHlax3Z/54je0zeNvSdD7X16Tst59LTibaczMb6bs0jnM0nfEb/RmeEVbWjfrV6uczGZjtmu/jyzHLumPfpzuMoAAAAAAAAAAAAAAAADnf0g9jadpuHTqdJSteMaClraW8REW1WKO9bJo725RveZm+C1omKZfs71plyTHp/o307boraY0ta0zsO0WiNWuZxo3nEV16xOd1YiK3iJibU3+latInZ2bW+qtiZnqWn0u7stwzGJnfjjntjf5VvS+O9seSlqZKWml6XrNb0vWZi1bVtEWrasxMTWYiYmJiY3fYK2rasWrMWraItW1Zia2rMZiYmN0xMb4mN0xvh1omJxMb4n5Z/niilIAAAAAAAAAAAAAAAACVL3xXrkx3tS9Zi1bV5TEx6/RPo9sdJmFb1retqXrFqWiYmtozExPHd/Pjg4N74TxiuuiMGbamqrHqiuaIjnanPeL7Rvem20dazMbxXym39HW2SZ1dPN9ntMzmZmbaU59W/Lq78VvHHGLYnE22tLUi26fW7e3/AJ7scs55Rm3MZgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAnd/PmMNxTi+PQVnFj7uTVWr9mvWMUTv9vJtPq5Unnbl0jm6OwdHX2y0al802es+lbdFr4mM1pmM9mbR6vfaMRi1NSKxjjaeU8I75/ZoeXLkzZLZct5vkvO972neZ5bf22iIjpERtERERD1tKU06V09OsVpWMVrHCI/eZ4zM75nMzMzMy1ZmZnM75lBZAAAAAAAAAAAAAAAAACsRMzEREzMztERvvMzyiI257z4bcyZiImZnERvmZ4RHbI9Q/Rz2Mr2f0P+0dfjj/bGvxxN62jnodLaYvXTRv0y5Nq21ExHK0Ri3/hzNvkf0o6dnpPaJ2XZ7f8AuOzXmKzHDaNWIms63sViZjSjfmJ6+PTiK8vadb6ycRmNOJ3YxvtH9U4nlviN/Lfh06OnP/P8/r6Xk2mAAAAAAAAAAAAAAAAA2vsrwv6xqLa/NX+DpbR5KNp2vqNomJ58tsMbW369+2OY6S43S+1/VaUbPSZjU1ozeYx6OnmYmO308THZ1YtE8mPWt1a47d3hG/Mccxmcx+eHRXmGpM5+GPh/xiAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+Oo0+LVYMunzV72PNSaWjfadp6TE+Fqztas+ExEr6WpfR1KatJxekxas8eHKY5xMZiY5xMwtWZrMTHHMf9Pfwnxcg1+iy8P1eXS5vvY5nu222jJjn7mSvOeVo57daz9mdrVmHt9n16bTo01qcLRGY+zb+qs99ZzHfxjdLeiYtHWjhPLjjtjOI4fnEwtGYAAAAAAAAAAAAAAAANt+oOD/Sh2J38t2n4Vi5x9ri+mx1mZmIrG/EKVrMxEUrERqoiIjbbUW3/jXt9E+iPT+Op0Vtl93DYta9sRmZ3bNa1uOZz9Tv7dKMf5cR0Nl1+GleePqTntnfWd3jNfg4O+iOh/I7wAAAAAAAAAAAAAAAAAFa2tW0Wraa2rO8WrMxaJjpMTG0xMemETEWia2iJiYxMTETExPGJid0xPZI3ThPG66ju6bV2imf7uPLMxFc077RW3hXJ4ei8xyiLTtPmukOjJ0etrbPGdLjfTjfOlHOa85p+dOM5rEzGzp6sTitsRO6IntnOMeOd3f3c9jn+n+eP+Q4lZmeP7ePGJ38uUM4kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAa/wAV43TSxfT6WYyanba14mJpg35TE89rZOv2elZj7W8xNJ63R/Rltoxra8TXQ3TWvC2rvzu51puj0omJtmerjjGDU1cZrXjwz2Yznxny8cxGkWva9rXva1rWmZm15mbWmes2mZmZmfTPP0vU1rWsRWtYrWsYitYiIiI4RERiIiOyGt38+1RIAAAAAAAAAAAAAAAAAA7f9F3Yr6xfF2m4piicGK8zwnBk/wCLlpMR9evWeU48du9XTRPO2Wk5e7FaYrX8B9Lun/q636J2O/8AmWiI2zVrMehS0Z/w9bROYvaMTq7t1Jimc2vFdHa9bGdKu6cZvMdk4xHviYznljHLPoF82c0AAAAAAAAAAAAAAAABc6PS5dbqcWlwxvky2iPTFa9bZLf8tKxNpn0RtHOYYtfWps+lfWvOK0iZ7JtPKsZ5zOIiO8nFazaZiIjdvnGZ7I3T+e52DSaXFotNi02GNseKsVrM/etO8zbJado3ted7WmIiN7coiIiI8Trat9fVvq3n0rzmccI5REZzuiMRG/hDTvM29KZ474ieOJxG7u3bo5R3vuxMYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADW+0nCvr2m+s4a76rSxa3/Nlw9b09dq8705zz79Y53dXorbP8PrfVXn/K1piO6upwrbuid1be6Z9VsaWpi3VnGLds7ondEb5njHDPbMzwjM8yjp/n+fl4dN5er/ADbM/D+fz/hUQAAAAAAAAAAAAAAAAjetb1tS1a2peJretoia2rblatomJiYtWZiYmNpidpTWZrMWiZiYnMTWcTFo3xMTG+JicTmN8cjg8ufSJ2Kt2c1s8R0GO08G12WZpFYtaNBqLzMzpb22nbDbnOmtaYmaxOK32qd+/wBc+jHT0dKaH+G2m8Rt+hWOtMzETtOnEREatY3ZvHDVrEccXjdaYr1tm141Y6tt2pHH/dG6OtH5RMdvi5o9W2gAAAAAAAAAAAAAAAAAAG1cJ45Ne5ptbaZp93HnnrTltWuX016RF+sbRF943tXgdIdFdbra+yVjrb5voxiInjPW084iJ45pmInM9XE7pz6ericX38ons48e39t7bomJiJiYmJ5xMTvExPOJiekxMdJ3l53fEzExMWjMTExiYmJxMTw4eEfGJxsiQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA6RvPKPT4cuqM8t+d3CJnyz4Y57yZx/P5jxnc1Pi3HY+1ptDfrvXJqI9cbTXDPLn6ckej7G/3nf6O6Jx1dbaonlNNG2/O/MW1Int4/V/j5xOvqavGtJjfGJnf78fP4TwmNTmZmZmZ3meczPWZ9MvRcODXAAAAAAAAAAAAAAAAAAAdC7AdjL9p9f8AWNVS1eD6HLSdTee9X61lj7ddHitEc+9HdnUWraLYsVo2mL3rMea+knTteidm+q0Zi23bRS31UejP1NeE696zOd05jSiYmLXic5isxOttGtGlXET6do3R2d8/njlnjE4w9VYsdMWPHixUrjxYqVx48dK92mPHSIrSlaxERFaViK1iIiIiI5Pj17Wva172m172m1rWnM2taZm1pnnMzMzM8e3M73JmczM798538ZnnM988X0VQAAAAAAAAAAAAAAAAf5/6/wCf3DGXR+y3C50ennW567ajVV3xxPXHgnaa7Ry2nLyvb+aK92J2t3nl+lts+u1PqNO2dLSn0pjhfUxifGKb6x39aeGGvq3jPU5RM5mMccxHH/bicb+M9jaXHa4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACsf38OvXw6f26RuL0jM84x2dv8y5j2l4XOg1U58NNtLqZ71Nqz3MWWed8U92Noi0fbxxy3ibVrH2Jes6L2z/ABGj9Xe2dbSiInM770/pvGZzMx6t534nEzPpRDbpbrRMTnMY98cO3txE9nHsa46iwAAAAAAAAAAAAAAAACy4hoNJxPR6jQa7DXPpdTjnHlxX6TWecWieU1vSdr0vWYtW9a2rMTG7Psu062ya+ltOhedPV0rRal45THKY3xNbRmtomJiazMTErVvakxNZxMTmPH/pu/5eR+1/ZXVdleJ30uTv5tFmm2TQayaTFc+LfnjvMR3I1GHlXNjifGmSIimSj7R0J0xo9MbJGtXq02imK7ToRbM6d8etWJnrTpX40tPfWZm1Zl2dHVjVrE8Lf1Vzwn5Txj897VHZZQAAAAAAAAAAAAAAAAAAGb4XxnJopjDm3y6WZ22jnfFvMzM4/CY57zSZ2n+Waz15e3dGae1Z1dPGntHOeFNTEYiL4357LRG7nFt2MunqTTdOZrPxjwzP5fDDecObFqMdc2G9cmO8b1tWYn8p8YmOkxMRMTvExExMPLamnqaV7aepSaXrOJraJifHhiYnjExMxMb4nDaiYtETE5iX0USAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhky48NLZMt646UjebWmIj2bz4z4R1meUc5WpS+reunp1m9rTiIjjM/tjjMziIjfMxEImYjjOPFpHFeNZdZNsGntbFpedbTvtfPHSO941xzG/2N+cT9vn9mvqNg6Mps0V1dbq318RMc66Uzx6v2rdtsbp9X7U6l9SbT1YzFY8c28Z3Ry7+MxLAusxgAAAAAAAAAAAAAAAAAANl7K9mdb2p4pj0OmiceCndy67VzWZppdNFoi1t9prOa8b10+KdvKZOs1x1yXryumOldDojZL7Rq4tqTmmz6MTEW1dWYnqxjOYpXjqXjPVrwibTWs4tXVrpUm08eFY7Zxu93bPJ674XwvR8H0Om4doMUYdLpaRjpWNptaet8mS20TfLltM5Mt552vMzPV8V2va9fbto1dq2m/X1ta3WtOMRHKK1jlSkYrSOVYiHHva17da2+Z54x7vdw9zINZQAAAAAAAAAAAAAAAABnuz3C54lq+9lrH1XTTW+XfnGS2+9MPo+1tveN/uRPTvVmed0ntcbLodWk/52rE1picTSMelqdu7hXdxmJ5TCmpfqVzHrTuju78/9PzdS5RtEdIiNoiNoj1R6oeQ48WnPH+b878/zAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWut0eHX6XNpc0b1yVnu28ceSOdMlf+altp26TG9bfZmWbZ9e+zatNbT41nfHK1Z9as91o3dscY3xC1bTWYmJxj847Pf578845BqtLl0eozabNHdyYrTWYid4mOtb15R9m9drVnxiecRO722lrU19Omrpzmt6xMdsdtZ76zmJ8N27DeiYmMxwnh3TzjjPDhPPc+DIAAAAAAAAAAAAAAAAAMF2i4Bou0nDM3DddSO7eJvgz7ROXS6mItGLUYZnpas2mLV3iMmO1sduVuXQ6M6S2jovaqbVs874xXUpnFNbSmYm+leOy2ImLYma2iLRvhl09SdO0WjO7EYjdE1/qie3un3z2PInHuB67s9xLPw3X45rkx2mcWWInyWpwTa1ceowz/ADY8ndnlvvS0Wx32vS0R9q6O6Q2fpPZdPatmtE1vERekzHX0tTETbS1I5WrmO60TFq5raJnr6epXUrFqzx4xziecT4dvD4sO3mQAAAAAAAAAAAAAAAAAABfaHiGo0GTvYrd7HMx5TDaZ8neI9X8to8LxG8euN4nU2vY9Ha6dXUri8RPU1I9akzH517azunlicTFq2tWc198Tzjs7vGN8N90XENPr8ffxW2vER5TFaf4lPDnHjXeNotH2Z6cp3iPKbVsmtsdurqV9CZxTUrGaX8Psz21nExyzGJnbpeLxunfHGJ4x8/HnzxO5e7f5/n+f1amYn+fz+Z7JXEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZ/nz7OAs9brtPoMflM9ucxPk8cc75JiN9qx6OcRNp2rG8by2Nm2XV2u/U0o3RMde/wDTSJzGbT8cV3zMxujcpe9aRmePKI4z/O2d3a0PX8S1HEMneyWmuKsz5PDWZ7lY6bz+K+3W09OcVisTMT6zY9h0tjpisdbUmPT1bRHWtnfiPs15xWOPGZmd7VvebzmeHKOUfOe2fhhj24oAAAAAAAAAAAAAAAAAAAynBuD67jvENPw3h+KcufPaN7bT5PDiiYjJnzWiJimHHExN7T13itd72rWdTbtu2fo7ZtTatqvFNPTicRPral5ierp0jd1tS0xisd0zOKxMxS960rNrTwid3Oe6I7ZeuezHZvRdmOGYtBpK9+893JrNVt3cmr1Pd2tltzttTpGLFE7Y8cd3ebTabfFululNfpba77TrTNa766GlnNdHSic1pGIjNp3ze8xm1pmcRGIjj6urOraZmZiN/VrHCI5R3ds4zE7ucNjctiAAAAAAAAAAAAAAAAAfXBgy6nNjwYazfLltFaVjxmfGZnlERHO1p5ViJmZiIU1NSmlS2pqT1aUjNrTy+G+Zmd0RG+Z3QTujPKOf88Y+Lr3DtDi4dpMWlxc+79rJeeuTLaK9+/qiZj7Mfy1itd523eK2raL7VrX1rbutOK15VpHq190b5nnaZndlp6l+vOfh3R2fOcz3Y4L1rsYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJjjGe1rHaXhH1zTxq8FN9Tp6z3q1rvbNhiZmazttM3xzvavKZmverG8zER1+itt+o1PqdScaOrO6ZndTUnERPdW2Orbv6s8Ils6cxWcTnqzMe7H7YzHjMZni5tD1LMAAAAAAAAAAAAAAAAABwah2x7J6TtVw22DJFMOvwRN+H6zu72w5Z64skxHetps3KMuOJ3iYrkrHfpG/a6D6Z1+h9qjUrM32bUxXadDO69I/qrE7o1acaW576TPVtLPoas6VsxvicxavdEcfHPPlETndO7yVxDh+s4VrdRw/X4ZwarS5Jx5sVue1o2mLVvEzW+O9Zi+O9d63patqzMTD7Ps206G2aGltOz3jU0dasXpeMxmJ4xMTia2rOa2rMRNbRMTETDr1tF4i1ZzE8PlPf28MLNnWAAAAAAAAAAAAAAAAAAAfTFmy4MlcuG9seSs7xaszE+ydutZ6TWd4tHKYmFNTTpq0mmpSt6WjE1tGY8Y7JjlMYmJ3xMSmJmJiYmYmOxuvDOOYtV3cOpmuHU8oi3THmmZ2jaZ3il5/DaYrO32Z3+y8vt3RWps+dXQidXR3zaN06mnHHfEY69c7+tG+N/Wjd1p2KasW3WmInfvxmJ+GMTyxznv3M+5Ufz+fzPFnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYLifG8Oji+HBNc2p512648Vo69+0dbRtP2Kzyn70x0nqbF0XqbTMamr1tPQ484vqRux1eyuf6pjE59GJ3yw31YrmIxM7/CJicb9+/wAIw0nPny6nJbLmvbJkvO8zaenqrHStY6RWsRERyiIh6jS0tPRpXT0qxSlYxERHHvmeM2nnaczM75lrTM2nMzmf5/MPkyIAAAAAAAAAAAAAAAAAAAXOj0eq4hqsGi0eG+o1WpyVxYMNNu9kvbwjfaIiIibWtaYpWsTa1q1i0xi19fR2bR1No19Sulo6VZvqaluFaxz3ZmZmcRFYibWmYrWJmYhFrRWJtacRH8989kc3rHsT2P0vZXh8RPk8/FNTWttdq6xvziZmNNgmYma4MW+28TE5rxOW0V3pWnxvp/pvW6Y2nMdbT2TSmY2fRnsmMfW6mJxOrePdSuKRn0ptyNfWnVmOMViZ6sTGOzf7/Hdwbs4DXAAAAAAAAAAAAAAAAAJ38I3/AM/yD34HRey/Cfq2H6/np/H1FdsMWjecWC232u7P3b5eUxPKe5tETHevE+Y6W2z63U/w+nOdPTn05j+vUjOYzzrTOMc7ZnlEsGrff1IxMRE5njEzxjHDdEeP5NrcZrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK7+nn6P6+P8Af8xaJnOc7+2c/wDVzPtLwj6hqPrWmrH1TUW+7He2xZ7bzau08q0v96nhG1qRFYiN/V9F7b/iNP6nUnOtpRxmd+ppxui2edq8Lc53TvmZbeleLxETnrRvme2N2d3OY547czHZrTqrgAAAAAAAAAAAAAAAAANA7ddicHanR+XwdzDxnSY7fVM88q6ikTNvqeomOmO1pmcWTaZw5Jm33L5Kz6T6PdPanRGv9Xqda+w61o+v043zp24fX6UbvSiMdav/AGlYiu+1aTGzoa86U4/onjE78TjfMeOOHw7/ACpqNNn0efNpdViyYNRgyWx5cOStq5Md6TtatqzETEx1jrvvvG8bS+w6Wrp6+nTW0r11NPUrF6XpMTW1bRmJiYzGP5u4OtExMdaJzGM5jf5PiuniAAAAAAAAAAAAAAAAAAAbf9f8/qDYeG8dy6aa4dX3s2DpF9982KPDnP36x07s/ajwttHdnkbb0Tp60W1Nn6ulq4merjGnee+IiepaftRE13b65nLNTVmu62Zj848M8u7vzluWHNi1GOuXDeuTHaN4tWYn8pj+W0dLVnnWYmJ5w8xqaepo3nT1a2reu6YmJzu5xP8AVE4zW0brcYmYmGzFotGYnMT/AD+Q+qqQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAzjyHzzZceDHbLmvXHSkb2taYiPHlHjMztyiN5meUc5W06X1bRTTra95nEVrEzOe/sjvnERG/OETaIiZmcRHH5ePdxadxLj2TP3sOj72LD0nLvMZcnp2jaPJ1/ObztvM1iZq9JsXRNNLq6u041NWN8acb9OnZnPr2jviKxPCLes1r6szurujfGecx5xH5tc/9fz67/wBebtMIAAAAAAAAAAAAAAAAAAAD6YcOXUZceDBjvmzZr1x4sWOs3yZMl7RFa0rWJm1rTO0REeP5xW96adLampatKUrNr3tMVrWtYza1rTiIiIjMzO6IRMxETMziIjfPZD1J2A7D4+zOl+u62tMvGtXjiMt47tqaLFbe31bBbaJ70x3frGSJnv3rFK/w696/yH6SfSC3S2r9Rs82psGjaZpXfE6943fW6kdkb/q6T6sT1p9KcV5W0a/1szWuYpE7v907t8xy4Rjfyzjfu6Q8u1QAAAAAAAAAAAAAAAAAOLYezvCf9oany2aszo9PaLX7222XLG00wc+tZj7WXb+TaN98lZjmdJ7b/htLqUn/ADtWJiv+ym+LX7p5U/3Znf1ZiceredON2605x2xyme7sjv7cS6f7OUeiOjyTUmczkEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPhqtNi1mny6bNHex5a9223WOcTW1Z2na1bRFqztymIlk0dW+hqU1dOcXpOY7J5TE8MxaJmJ3xumcTE7163msxMRvjh4ZzjsxM8e7MeHI+I6HNw7V5dLljfuTvjydK5cczPcyV68piOfOe7aJrPOJe12baKbVo11aTG/daud9LRxrO6OHKecYmN0w3ImLREx4THZO7d47/hiYzErJnSAAAAAAAAAAAAAAAAACYnE5cx+kDsJj7RaeeI8OpXHxvT02jbaleIYqRywZbTMVrnrG3kM1p8PJX+zatsfrfo39IrdF6sbLtM2t0fqW55tOzXmczqUiImZ05n/AFKR29evpRMW2tn2idOeraP8ud/bNe/w8oeYcuLLgy5MGfHfFmw3vjy4r1mt8eSlpral6zETW1ZiYtExvExs+s0vTUpXU07VvS9YtS9Zia2raMxaJjdMTE5iXViYmImN8TGYntiXzWAAAAAAAAAAAAAAAAAAAAF3pNbqNFk7+C813279J548kR4Xr0nx2tG1o3naY3a+0bLo7VTq6tImYz1bxuvSZ51tx8YnNZxGYnELVtNZzHwnhPjG7Me9u+g4zptdtSZ8jqJ33xXmNr7dZx232ty25bRbrO07bz5fbOjtfZM3/wBXRj/tKxvrujdqVjPVmZziYzWd2/O6NqmrF93Ceyefh8uP7ZZz2QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABiuIcX02g3pM+W1HLbDSekzG8TktzikeO3O08vs7Tu3tj6O19sxaI+r0c79W3CY3xMUr/wBpPKeFY3+lmGO+rFOHpW7I/fs+TSdZr9Tr79/Pee7EzNMVZmMdPD7Nd53nbl3rTNpjrL1OzbJobJXq6VIi0x6epOJvee209ndGIjszvatrTac2nPlHhHx+KybKoAAAAAAAAAAAAAAAAAAACePHfLemPHS2TJktWmPHSs2ve9pitaUrWJm1rTMRWsRMzMxERui1q1ra1rRWtYm1rWmIrWsRmbWmcRERETMzM4iN8nDi9L/R52CrwHDXi3FcdL8Zz03xYrbXjhmG8TWaVmJms6rJXzuSN/JRM4cc7eUtf5R9JfpHPSN7bFsd5jYdO2L2jMf4q9ZiYtOYi0aVLRPUrOOtMRe0Z6sV5e07RN56lPUjj/u7O+I7pxPPsdWePaYAAAAAAAAAAAAAAAAAC60Wky6/VYtLhie/kttNtpmMdI27+S3h3aRO8zMxvO1Y5zDDtGvTZ9K+rqTurEzEc7W4VrHfad0fHhEyTMVibTOMY4cZ48Ph2S67o9Hi0OmxabDG1Mddu9yi17TO973263tM77z0jascoh4vX1r7Rq31dSc2tPDlWI4VjuiN3fxnfMtO8zbNp/qnMd0YnEYx2b/2hcsLGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwnHeE04npf4cRXV4ItfBaYj7UTtNsNp9GSIjaZmIreK22mO9v0Oj9snZNb0pn6nUmI1I7Oy8R21zvxvmuY44ZtPU6szn1cRnu74jvnlHOXK71tjtal4ml6Wmlq3ia2ras7WrMTtMTExMTE84mJiecPX1tFoi1Zi1ZiJi0b4mJxMTE8Jicxvjc25js7Mzwn37uEYwolAAAAAAAAAAAAAAAAAADlX0hdgq8fxZOLcKx1pxnBTfLjj7NeI4cdZ2x+ERq6xG2LLO0ZI2w3tMRS1PYfRr6R26NvXYtsvNtg1LYpafSnZb2mPSjnOjMzM3pGZpOb1jPWi23s+0TpzFLTmnLtrMzHvmOO6d0TvjsnzPkx5MOS+LNS+LLivbHlx5KzW+PJSZrel62iLVtW0TW1bRExMTExEvq1b01K1vp2rel6xal6zE1tW0ZrasxMxMTExMTEzExwl1YmJ3xOY7YQWAAAAAAAAAAAAAAAAAAAACJmJ3idpjnEx1ifSceI2Ph/H8uDbFrItnxcojLvvmxx6bbz/FiI9MxeI3ne07Q4u2dD6erM6mzTGlffM6fDStu3RWI/05zwxHV34xWN7NTVtGItOY7ecdvHOffvxwluGHPh1OOMuDJTLSeXerPSY8LRtE1t0mYtETzjeObzmppamhaaa1Lad43zFuyecTmYmvGImJxunDZraLRGJifD5Zl9VEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPnlz4tPjtlz5KY8detrzEc/RHKZm089qxEzO3KJnZfT09TWtFNKltS074rWMzMdvZEdszMRHOUTaI4zEfz4tQ4h2gyZe9i0UTix84nNaP4l45xvSP8Ahxtz3535xtNJiYei2PoemnP1m1TGrfMTXSjP1dOfpcPrJ4bsRWMTExaJy1r6szupMxHOec90dnu3zhrczMzMzMzMzMzMzMzMz1mZnnu7cRERERERERiIjdERHCIjlEMKgAAAAAAAAAAAAAAAAAAAAJVra9q0pW173tFaUrE2ta1p2rWtYiZta0zERERMzM7RG6JmKxNrTEViJmZmYiIiIzMzM7oiI3zM7ogekfo7+j+ODUx8b4zhieLZK97Saa/OOHY71mO9esxt9cvWZi07z5Cs9yu15vL5b9J/pJO3WtsGw3mNjrONbVrunarVnhE8fqKzETEbvrLR1p9GKw5m07R180pb0Y4zH9fDn9mPzxPLGeuvFNIAAAAAAAAAAAAAAAAAA2mZiKxMzPKK1je0zMxEbR1mfCI57zMcp6SzERMziIjfNpnEREZznu557j+ZnhHj/OUuo9n+ERw3TeUzRE6zPETlttzx061wxvG8TE7Tkmu0Wvy3mtay8j0lts7VqzWkzGhpzMUj7U8JvOO3+nnFZ5TMxGtq3626PVrnEc5nnM9/KM8Yid0TMM+5rDme2QQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAR/n+TuH8/nn4tJ7UcG70X4npq7TEf73jrvvMdIz1jnzrHLLt4RGSelpnv9E7bjGyatpxO7RtM8J35089+c07J9HnENrR1Jx1JxxzXumN8/Hl3zjduidFehZgAAAAAAAAAAAAAAAAAAHJ/pB+j7HxzHk4vwjFXFxjFWbZsNYrjpxHHSJtMW2rG2siIiuPJM7ZoiMWWd/J2r7L6NfSS3R9q7Ftt7X2G8407zm1tltbdGN+Z0M77Vj1J9KkTHWrO5s20fV+hefQ7eM1mf23cOPHETweaclL4smTFlpbHlxXtjyY71ml8d6zMWpeloi1bVmJi1ZiJiYmJjeJfVa2retb0tW9L1i1LVmLVtWd8WrMZiYmN8TG6Y3w6kTExmN8SikAAAAAAAAAAAAAAAAAAAAAXGm1Wo0mSMmnyWx2jbeI51tEeF6TvW0eqYnbw2nmw62hpbRTqa1IvXln1qz21tG+s98Tv4TmNyYtasxNZx29/wCfzbhw/j+n1G2LVbafNP8AN/wbzEb77/8AD69Lb1jpF5mYq85tfRGro9bU0M62nG+ax/q1jvrwvjM767+c1xGWxXVrOOtGLRz4R37+W7t3Z7OLYImJjeJ3iecTHSY9Lkc5jnEzExziY4xPZMc4ZwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD0z4RzndEzwxGc/zlEzn3ftkwOv49ptL3senmNRnidomJ/hUt6bWjfvzHjWm/jE2q6uydFa+0RF9aJ0NKeU/wCpaP8AbWcdWJ+1bumItDDfWiu6N88O6J85x3REY5w07VavUazJ5TUZJvP8tdoilPVWsco22j1z1mZnm9LobNobNSKaNIrHO3G1u+1p3z4Z6scKxEbmta1rTmZz+3h2QtmdAAAAAAAAAAAAAAAAAAAAACVa2vatKVte97RWlKxNrWtadq1rWImbWtMxERETMzO0RuiZisTa0xFYiZmZmIiIiMzMzO6IiN8zO6IJ3PR30e/R7XhNcXG+NYq24pesZNJpLxFq8PraItXJkjpOtmJ29Gnie7H8TvTX5f8ASX6TTtk32DYLzXZKzNdfWrM1ttMxOJpWeMaGe7/M4z6GInm7TtPXzp6cz1eFrfa7Yjnj4Z8HYHiGiAAAAAAAAAAAAAAAAAATyiZ9AN17McH7814nqafZrP8AulJ352jlOeY5RNazvGLffe0TfaO7SZ4HS23Yidl0p3z/AK1onhH/AHfv437sV35mGHV1Or6Mb8xvnMZju54mYxPvxv3w3t55qyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArXrHtj4ia8Y8Y80snnMnv2+aVaepX2a+UJnhP3P0ygsqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAApMRaJraImJiYmJ5xMTG0xMeMTHKUxMxMTEzExOYmN0xMcJieUwnMw5h2g4RbhuojLhrP1PUWmccxvthvO8zhn1R1xTMzM1iYneaTM+t6N26Nq0upeca+nERb/fG6IvHfP9XZPdaIbmnbr1jG+Y48538Jnvnnuje190lwAAAAAAAAAAAAAAAAAAHLe3/wBH+LtBjvxThdKYeN46fbpHdpj4jSsRtTLaYiK6mtY2xZrTEX5Yss93uXx+v+jn0lv0baux7Za19gvb0bb7W2W1p32rGd+jMznUpETMT6VIz1q329n2idOerec0nnM769++d8d0e55lzYcunzZMGfHkw58N7Y8uLLSaXx5KzNbUtW0RMWrMc4mN4n8n1el6alK6mnat6XrFqXpMWrasxmLVtGYmJjfExLqRMTETExMTwmOD5rJAAAAAAAAAAAAAAAAAAAAAAZTQ8X1ehmta28rhjl5HJNprETO89yY545336b13mZmszLR2ro7Z9qzaY+r1eP1tIiJnEY9OJ3X5cfSxERFoiF66lqbonMdk8PnHu4tx0XFtHrtq0v5LNNYmcOWdrbx17kztW8R/y/a252rDzW1dH7TsuZvEX08zjUpmYiOXWjjWeW+MTPC0437NNStsRnFuyfniIn+bmTaTIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAx2t4rpNDG2S/fy7TMYcf2rzPh39p2x1mfG207bzEW22bey7BtO1TmlZrp5jOpfdWOGeruzbEb8ViYmd0zXfM476tac8z2Rv+OM497TdfxjV63vU38lgnl5HHO0W/8AaXnneZ/Kn/LvvM+l2To3Z9lxbH1urG/628RmPYrG6njvt/uxiGvfUtfujsjs755+W7gxToMYAAAAAAAAAAAAAAAAAAAAACePHfLkpixUvky5L1pjx46ze972tFa1rWsTNrWmYiIiJmZnki1q0ra97RWtYm1rWmIrWtYzMzM4iIiIzMyTMRxnHi9J/R/9HmPglcPGOM44ycXtHe0+mtFb4+Gxbfad4m1b6uaz9q/TBvNMe9u9e3yv6SfSa23zfYdhtNNiierq6sZi+1THGN++uhE74rx1N1rYjFY5e07R1/RpM9XO+c4zMeHLxzE8u7rTxjTAAAAAAAAAAAAAAAAAAAZzgXCbcU1PevExo8E1nPeJ279pjeuGk7TvNutpj7tInnEzXfn9IbbGyaWK4nW1ImNOJ3xWIxm87+Wd0Txt2xE4re9aRHO0xujwzmZ7I4cd+d+6Il1SK1pWtaRFa0rWtaxG1a1rEVrWseERERG3Tly5PITM2mbWmZmZmZmd8zMzmZmeczO+WnaZnOZzvzxzx7O7+SIVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfDVabDrcF9Nnr3sWWNrRvtMc4mtqzt9m1ZiLRbrvG87smjq30NSurpz1b0nMTynlMTHOJjMTHZK0WmJzEznOd88YjlOY3/zc5JxHQZuG6q+nyxyje+LJH3cuKZnu3j0TO0xaP5bxaJ5REz7TZdpptelXVpumfRtTjNLxxrP5TE84mJ7m7W0WjMeExziecfzisWwkAAAAAAAAAAAAAAAAAAnnEx6Qc37ddgdP2mxW12hjFpuN4qfZyTHdxa6taz3cGpmOVbxyjDqJiZpERjvvjms4/U/R/6R6vRV42faOtq7Be2+uc32eZmM6mlGM2jnqae7retXFonrbez7ROnPVnM07OM1zMb43b/Ddx3b3l/V6TU6DU59HrMN9PqtPktizYclZrfHes9JifTG0xaN62rMWrM1mJn61oa2ltOlp6+heuppatYvp3rOa2rPOPKYnfExMTETEw6dbRaImJzExExO7fnw3eMf8LdlWAAAAAAAAAAAAAAAAAAAAAAI5Tv4+Ex15ev2gzui49qtN3aZ99ThjaNrTtlrEeMZJ525ctrxaem0xzieTtXRGz62b6ONDVnM5iJmluO6aZxXfOc16vhO7GSmrau6Z626PHd+cxvjdn37226PiOk1sR5HLHlNomcN9q5a+neu/PaeW9JtX1vPbRse0bLONXTnq8I1a+lp27PS4xM8Yi8RLZrqVtG6fdO6fhO9fNb+SvvzO7wntAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACZx2/z5Cz1ev0uijfUZIi20zGKv2sttvCKRzjfbaLW7td+sw2Nn2TaNqnGlp26uYidSfRpXfztMcYjfNYibYndEq2vWkb58I4zP87Z3NS1vaDU6iJpp4+q4533ms75rRP8Azx5uNvDHzif55jbb0Oy9D6Gji2tP194xiJjGlExifVnffExxtux/RDWvq2t6uax3TvnPbMfljfDAzMzMzMzMzzmZ5zM+MzM9XXiIiIiIxEboiOERyiI5YYlAAAAAAAAAAAAAAAAAAAAAAAfbT6fPq8+HS6bFfPqM+SmLDix1718mS8xWtK125zaZ28No5zMRvMU1dXT0dO+rq3rp6enWb3veYita1jMzMzwiIRMxETMziI3zMvTXYL6PsPZ3HTifE648/GslYmtY2tj4dW9NrYscxM1vqJi22XNG8R5vFM0718nyf6RfSXU6TtbZNkm2nsFbYtPC+1TWd17xiJrpxMZpp537rX34rXmbRtM6k9Wm6kcc8bePZHdE7+c8HUHkmmAAAAAAAAAAAAAAAAAAAvNBoM/EtTj02GJibT3r361xY4mO/ktziPsx0jnM2msVmZlg2naNPZdK2reeETFY4Te2JxWvteG6MzO6EWtFYzPujtnE/wA7MZzMOt6LSYNBpselwV2x446zt3r2nfvXvMREWtadpmdo5RFYiKxER4zX19TaNW+tqTm1p4b8VjlWuZmYrHKM9875lp2vNpmZ3TM7/DGMfPtneuWFQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/z+oMZxfhmLiultivMUz03tp8u0R3L8o2naJmaXjlePVEx9qsNvYtrvsmtF430tiupT7Vc8Y/3V3zWe3McJlkpe1ZzEx2TG7hGMY4YnfOJz2+/k2fDl02fJp81ZplxT3b0nb7Mx029MWiYtFucTWazE7TD2WnemrSupS0WpeM1mOf/MTumOMTExLdzFo60TmJ378Z37+Efzk+a6AAAAAAAAAAAAAAAAAADbf/ANZj4CczGe/i0btn2I0PavTRevc0nFsFZjS66KbxeOU+Q1cUjvZcM7bUtO99PaZtj3rbJjyeh6C6f2jofV6s9bW2K851dnm3qz/3mh1piKanbG6upEYtvitq59HXnS3cazPpV7J5THPx34nnHDPljinCtfwbW5tBxLT302pwztNbx9nJSZmK5cN4+zlw32nuZKTNbbTHWJiPr2ybZs23aFNp2XVrq6V44x61Z4zTUrO+l65jrUtETGY7YdWl66lYtWYmMb+2JxE4nsmOcY49jHtlcAAAAAAAAAAAAAAAAAAAAAABWtrUtFq2mtqzvFqzMWifTExtMT64RMRaJraImJjExMRMTE8YmJ3TE9kjYNH2h1ODu01MfWcccu9M93NEe90v/wCOO9Pjdydp6H0NXNtGZ0LzvxGbaUz2dXjT7k4j7Mstda1cRPpRujvjy/Pf48G06TiOk1sR5HLHfmN5xXmK5a7dY7k/e2/FSbV9fo4G0bFtOyzP1tJmnCNSu/TnsxOMxnfuvi2cbu3YpqVvw3T2TjK+aq4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACz1fENJo4mc+atbdYxV+3lnlvG1I6b+m3dr6ZiGxs+ybTtNo+q07TWd03t6OnE535v2xHGIzM8oUtetZnNvdxmPhHPvnzapre0Oozd6mlr9XxzEx3p2tmtHpifu49/Du72j8cdHf2bobR05i+vM614/piZjSjxrxv97ETwmrBfWtOYr6Mcp/qnjxnly4b+/t1+1rXmbWta1p5za0za0z6ZmZmZn1zLsREViK1iK1iMREREREdkRG6I8GH+cf5/wAqJAAAAAAAAAAAAAAAAAAAAAAAF7w/h2t4rq8Wh4fp76rVZ7d3Hixxz5c7XvaZimPHWOd8l5rSkRM2tEMG07Vs+x6N9o2nVpo6OnGbXvOI7oiIzNrT/TWsTa07oiVbWrSJtaYiIjM/zv5PUXYnsHouy2GNTn8nrOM5qbZtX3fsaesxE+Q0lbc6Vjea5M0xGXNMTv5PHMYo+R9P/SLX6XvOlpzbR2Cls6ehnFtWY3Rqa8xumd2a6eZrpxMb7WibOVr7RbVnEejSOEc577dvhwjv4ugvNNbiAAAAAAAAAAAAAAAAAAAnixXz5KYcVZvky2ilKV62meW0f6z4dZVveunW172itaRNrWnhER29vhz4REk7omZ3REZmeyP+eXa6twbhWPhWmivK2py7W1GTrE2iOVKbx5um8xWNudpteedto8dt22X2zV62+NKmY0qcMRnfa2+Ym9uc8oiKxuhqal+tO7hHD3xHH3xmY93Jl+rSYgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGudoODV4hh+saeNtZhpO0cojPjjnOOeU73jnOK3LnM0tymJr1ejdvnZr/Vak/5F7b53zOnad3Wjf6s7uvGM49KN8TFs2lqdXdad3LuxH79nbv7c8zmJrM1tExaJmJiYmJiYnaYmJ5xMTymJ5xL1cTExExMTExmJjfExPCYnnEtrv5T/wAfNQAAAAAAAAAAAAAAAAAAAP5/ODVu1HZPhnanR/V9Zj8nqccW+qa7FETn01p2nrO3lMN5j+Lhtbu36xMZO7evX6I6Z2vojX+t0LdfStMfXbPeZ+r1axGPu3ru6t6xmMYnNM1nNpa1tK2azmN+azO60cd/H0uWfB5W7Q9nOJ9mddbQ8Sw93fe2n1GPe2n1WLeYjJhvttvtt38dtsmKZiL1jeJn7B0Z0psnSuzxtGy3zjFdXStu1dG+MzTUr+m0ZreN9ZnExHW09WmpXNffGPVnO+J3Rz58ObAuiyAAAAAAAAAAAAAAAAAAAAAAAAKxMxMTEzExMTExymJjnExMc4mJ5x6CYiYmJiJiYmJid8TE7piYndMTG6e04b4mYnticT+TN6Pj2t021MsxqcUfy5J2yRH/AC5dpnfp9+L+iOTl7T0Ts2vM304+o1JjGaRHUnx090R9ya555ZK6t455jv48uE+7sls+k4zodXtWMkYckxH8PNtSZmZ22raZ7l536RE96Y593rtwdo6N2rZ980+spmfT0om0eNqxHWrE8czGI4ZZ66tbc8TnGJ3Z5xiZnE7vzZX+n5TE/D/JaOc/9JjzZQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGf52/zs4jGavi+h0fK+XymTaf4WGIvaNuX2p3ilefha0W67Q3dDo7atpxNNOdOmf8AU1J6lfdGJtaJieNazG/fOcwx21KVzE75xwjfn9o9+O7LV9Zx/WajeuHbS495+5PeyTG/jkmImOX4YjbpvMQ7+z9EbNozFtTO0X/3xEacTjE9Wm/PZ6U25ziJndgtrXnhisd3HPjPu/ksHa1rTNrTNrTO82tMzMzPWZmecz65dSIisRFYiIjdERERER2REboYt88ePxUSAAAAAAAAAAAAAAAAAAAAAAAAMzwLgPEu0WupoOGYJy5J2tly23rg02Lnvlz5YiYpXaJ7sc7ZLbUx1taYho9I9I7L0Xs9to2vUilYzFKRidXVv9jTpmJtbfGeEVj0rTWsTLHqatdOJtaZjHCOc9mOPH3Y545+qeyfZDhvZXR+T00Rn12au2s4hesRlzzynuUiPM6elojuYa28O/ktkyb2fH+mem9q6Y1utqz9Xs9Jn6nZqzM00+Mda07vrNSYn0tSY/21itdzla2vbVmeturE5rXOYjx38ccZjE57N7bnFYAAAAAAAAAAAAAAAAAAADxiIiZmekRzmZ3iIiI9cz/1Py8R0ns9wONDjjWaqn++ZaxNazET9Xx2rExWY6xmvE/xJ/lr9iNprbveW6T2/wDxFp0dKf8AJpPpTGf8y0Tx44mlZ9Xdvn0t/o41tXU63o1mJrEZnfG+czz7t2I7czwls7kMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABEb8vT/kf1/sLV9aPf5S0vtLwSckX4jpKfxKxNtXirHO8RPPPWNvv1iP4kR96u9+Votv3uiukOrNdl17ejvjRvP9M8tO07t07+rMzun0d8TERtad4iYrbMxviN/PjiZnfvnOO/3Q0N6JkAAAAAAAAAAAAAAAAAAAP9AYjjXBeHce0OXh/E9PXPgyfapO22XDmiLRXPgyRHexZqRaYraJ2ms2peLY7XpO5sO37V0dtFNp2XVnT1K7pjjS9MxM6epSd1qTjfE8JxMTFoiYvTUvpzE0tiYzHLhM5mJ7YmYji8t9r+xHEeymom199XwvLfu6XX0p3Y3mO9GHU0ibeRzRziszPczRWb49vtY6fXuhOn9l6Y0oiMaO2UrnW2aZzw3dfStMR9ZSeMxHpaeYi/GLW62jr11YxuraONc/CY7Y8paU7zOAAAAAAAAAAAAAAAAAAAAAAAAAAyOk4rrdH3a48s2xxyjDl+3j258oiZ71I8fsWr/o0to6P2XaczfTit53/WaeKXz2ziOraZ5zetvJeupeuIi27snfw5b98Rjsw2XS9o9LkiK6mltPflveN8mOfT0+1WPHaa297wcXX6F16ZnQvGtG/0ZxS/dumerbHdaszyr2Zo1qzutmJ7YiJjw4ftnvZ7FmxZqxfDkpkpaN4tS0Wjw5ct9pjfnE7TE8pjffbkX09XStNNWlqWjjFqzXj3TvnPGJjdMb+xmiYnhMT4T/1fRVIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACGTLjxUm+W9MdIjebZLRWI5x4zMR4+PsjnMLVpqalorp1te0ziK1rNpnj2RO74eKJmI3zujt/n7sDq+0WlwxMaeltTeP5vuYvymYm9p8NopEePe5bT1tn6G2jUxOtaNCvZuvqTw5RPVrHGJmbZjsYra9Yzjf3zuiOX/AD7+PZreq4vrtX3q3yzjxW/4WL7FdvRMxM2t6+9aYmd+W20R2tDo7ZNnxNdKL3jf9ZqRF7Z7YzHVrMcI6tYmI58ZnBa9rcZ3dkbu7lx3MY3lAAAAAAAAAAAAAAAAAAAAAAAAAAG39k+xvE+1eq7uCs6fh+G9Y1fEL0mceOJjfyeGszXy2omOmOs92kTFstqVtWZ4nTPTuydD6ObzGrtV6zOjs1ZiLWnh1tSd/wBXpxztMZtia0i0xOMOrrV0o45tO+K92OfDEd8/KHqbgPAOGdndDj0PDcHk8cbWy5bTFs+py93uzn1GSIjv5LR4REUxx9jHWtIiHyHpHpHauk9pttG1anWt6tNON2lo0zn6vSrmerWJ55m1uNpmZmXJ1NS2rPWtPPdHKI5RG7GIxv7Z3yzbQYwAAAAAAAAAAAAAAAAAACf8/wA/z8gbv2a4Jv3OJaynTu20mG0fnGotEx4TETh57TO2Tu7RSZ4HSvSG62y6Nt85jWvHZ/3cT3/1zHL0czmYjFq3xmsbsxEzMcondjfv353492cN63npvy/p/WI8f6vPNXhmN27McP58eKggAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWJ239cbez0/8AQTE8e/Gf5nj/AMuddo+BxpLW1+kpM6e897PjrEz9XtO/24jwxWmdtojbHadvuTG3pujOkI1ors+tbGrEYpeZ/wBSI5Tu9eI99o38c52tPUi0TW0743xPbnxnjwzx7s72p/5/n/n6Ha/n8/4ZQAAAAAAAAAAAAAAAAAAAHw1Wl0+t0+XS6vDj1Gmz0nHmw5aRfHkpPWLVneJ9MT1iYiYmJiJZNHW1dn1Ka2jqX0tXTtFqalLTW1bRziY/k8JWraazExMxMc4nEx/PN5w7bfRpqeDzm4nwSL6zhcd7Jm0sRN9Vw+laza956zqNLXa0+V87ir3Yy1vFbZp+o9AfSvS276vZNvmujtk4rTV3V0dptM4rHKNPWnMR1PVvPqTEzFHS0Nqi+K3xW26IndFZ4/CcRw58t7kv+f57Xs24AAAAAAAAAAAAAAAAAAAAAAAAAAA+mLNlwWi+HJfFeOlqWms+ydp5xPjE7xMcpiYU1NLT1azTVpXUrPGt6xaPz4T2TG+J3xvImYnMTMTw4/twZ7S9o9Vj2rqqV1FYjbvV2x5I/OI7lvZ3KzPXvOTr9C6F8zoXto25ROb0+Ez1q+PWtEfZllrrWic2iLdk8J8t3u7+ctg0/G+H6iI3y+QvMz9jPEU29ffjfHt6PtRPprHRx9bovbdGfUnWrEetpeln7m68TEYzPVmOOM8WautS3GerPZb5xmPzz3MtvExExMTExExMc4mJ5xt6d46bbxPg0JzGYmJiYnExOImJ5xMZ3THOJZM/zt8P5++AkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAnlvMzERHWd+UbeO/Tb1kb5xznlxnw3fzfHbBmO3v8Ad2sVqeNcP08T/GjNeP8Ah4PtzM9Odt4x12nrvaJ9ETPJv6PRu2a0xjSnTrP9er6ER92fTnPLFZjtmOLHbVpXnnuriffnOPdnPc1/U9o9Tk3rpsdMFfx22yZJ9m8RSvh/Lad/5nW2foTQ0/S1721rZziM0pjsmYnr28etHhuYba1pmerERHKZ3z8OEd/Hjjllgc2fNqLzfPlvltPje0229URPKseiKxER0iIdfS0dLRrFNLTpp1jlSsRnxxvme2ZzM85YpmZ3zMz4vkyIAAAAAAAAAAAAAAAAAAAAAAAAAAAdS7E/Rvq+PTi4lxauTRcH3rfHSYmmq4jSd5jyMTtOHTW2iZ1Fo3yUn+BFt5y4/I9P/SnR6O6+y7HNNo23fW9onraOzTGMxeeF9WMzH1UTikx/mTGIpbT2jaa6c9WnpXjj2Vnv38Y44378Z7J9J6PQ6Xh+mw6PQ4Mem0uClaYsOKvdrWtdvzm07b2vabXtabWtM2tMvlevtGttOrfX2jUtq62pabXveczM+URyisRFYiIiIxERHMtabTNrTMzM5mZ3rthQAAAAAAAAAAAAAAAAAAApv/6+B7/dv+WPzTETMTPZj8+xtPZ7gdtbkrrdVSY0eK2+OkxMRqb1mdtvCcVLV2vM/evHcrvEX25HSfSH1FZ0NG0TrWj0pjf9VWfLUtE5rHKJ60/0xOLU1Op6McZiYnhmsTundPPsx255TDpHKNoiIiI5RERERERG20bREbRtyjbk8tv5755z2y1JmJnMfz5+IIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUtWt6zS1a3reJratoia2i3KYmJ5TExymJ5bTKYmazFqzMTE5iYmYmJjhMTG+JjthMTieOMb+3fHD4cvk5jx7gl+G5J1GCJvostvszvMzp7zt/Cvvv9md58nfl3tu7b7Ud63rOjtvjaqfV6kxGvSOHD6yIj1q98Y9KOXGN0zjc07xeMb4tEcJ4TEc8zPxjfv4cd2vR0jwdNcAAAAAAAAAAAAAAAAAAABSYievP1T0/p0/z1HDgnM/z58XGu2v0YYuIzm4p2dx49Nrp72TPw/7OLTay3diZtp5ma002otMTM0mK4Mtrb2nFbvWt7noH6W6my/V7H0nNtXZ4iKae1TM21dCM4iurGOtq6cR/VGb0iIiOvGK13dDauriupPo53Tvma8cZx60d+Jnh2Q896jT6jSZ8um1WHJp9RhvNMuHLS2PJjtH8t6WiJidtpjltMTExvExM/TNPV09bTpq6N66mnesWpekxatonnExMxMcvdvxO50YmLRmJiYnhMdn/AFy+K6QAAAAAAAAAAAAAAAAAAAAAAAAAAAFzg1mq0sxODPkx7fyxaZpPOZ50nek85571ndh1dn0NeJjV0qXzzmsRbs3XjF47sWjHJMTNeEzHgzmn7S56TEanDTNXbabY58nkj17bWpb2RFOfSYcrW6E0rRnQ1Laduy/p1nuzutHjM28JZa61o3THW784nynP5eLOafjnD8+0TlnDeZ2iuas0j9cb4/VzvE7+HRytbovbdLfGnGrHbp2627vriL58KzEccs1dWk88bo4xj8/+nyytb0vWLUtW9J6WpaLVn2TG8cvGOsdJ2lz7VvSerasxaJjNbRNZiO+J3+XgyceCQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKWtWkTa9q1rHW1rRWI8Oc2mI6zBETaYitZvMzjq1jNpnHCIjfM90E7v5/Pexeo43w7T8vLeVt+HDHlPVO942x8vR3t/U39HozbdbE/VfV1nfnV9CYjs6u+0z92Ihjtq0rOM5nnEb/lHbz5MFqe0ua0zGlw1xV/Hl+3f2xWNqV9kzf2+Dq6PQmnXE6+rbUn7OnHUr4TM9a0+MdXw5sU68znFccY38fGMYx3MHqNbq9VMznz5MkT/LNu7SPZjrtSPyq6ujsuz7PGNLSpSftYzafG9s2n4sM2m3Gc88cs9uI3LVnQAAAAAAAAAAAAAAAAAAAAAAAAAAAA+mLDl1GXHhwYsmbNlvWmPFirN8mS9p2itKVibWtM9IiJmVb3pp0tqalq0pSJte95ita1jfM2tOIiI7ZRMxG+d0c5mYiI8cu/8AYn6L6aScPFe0mOmbUxNMmn4XO18OC3OYtrZ50z5YmY/gRE4aTX7Vstp7lPm/T30ttrRqbH0Ve1NKc01dsjNdTUjOJjQ4W06T/wB5/qW/pikelbn621daLV05msRE5tvzOeEVxjHj+WN7tkVrWIisRWIiKxEcoiI5RERHKIiOUREcngpmZzmczMzMzO+ZmeMzPHfzaGfmqgAAAAAAAAAAAAAAAAAAAJ5f2j+vIj+e7iM9wLgt+KZpvl3posMxOS/TyloneMNJ3id5/wCJaPN1mOlrV353SG3V2SnVpi2veJ6lfsR/3lo7Psx/VPdEqXv1KzMYzMYiJ7+f848O11ClKYqVxY61pjxxFaUpERStY5RFYjlEejZ5G1rXtNrTNrWnM2tMzMz2zM75ak2mZnM5zPGfPuzz7eaSFQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHzy4sWfHfDmpGTFkrNb0tzi1Z8J/0mOdZ2tHOFqXvp3relpres5raOMT/PdMbpTEzXfE4ndiY4+6eXf28OGXLONcHycKz/Z3yaTLMzgy7TMxttviybV2jJXrXblkrEWjae/WnsNh26m2U34rrVj/ADKduc+lTM5ms8876zOJzumd2luvHDExxjtiZxE8efL943zhm8vid09vD3AgAAAAAAAAAAAAAAAAAAAnpPs/zqEfzOf23tK7V9iOF9qsPezVjR8RpWI0/EcNKzlrWInu4tRSZiNRhjffu2tF6z5vJSO93u90N0/tnQ98UmdfZbWmdTZr2mKZmYzfStv+r1J5zFZrb+qs7pjPpa9tKcZi1M76zwnlmOOJ4T7sPMXaDs3xbs1q50nE9PNItvODU4+9fTamm+0Ww5e7ETMfz0tFcmPl36RExM/Wejeldi6V0Y1tk1YtMf6mlbFdbSns1KZmYjstEzS39Np3urp6tNWIms57Y5xPZMe7jwYF0WQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB9cWfNgt3sOXJitPWaXtXf1T3ZjeI8N9/wCrHqaWlqxjV06akRwi9YtjwzE49yYmY4TMT3TMeUxlmMHaDX4o7uSceor/AN5Xu2/VTu79etotPrc7V6G2PUnNIvoznPoTmufZvFseFZrG+cb5yyV1rxumImO/j+X77/Bl8HaXTX5ajDlw29OOYy09s/ctHPwilo9cObq9B69JmdHV09Ss43WidO3ZiN16zjlm1Y47mSNamIzGJjwxHbPbHbwZbBxLQaiP4eqxb/hvbyd/ypk7tp9sRMetoauxbXoz6ehqY+1WOvX8VOtEe+Ynu4skalLcLR4Tun8/23L2JiY3iYmPTE7w1c/zE/z+T2Svnl+0+fBUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGYj4Z90BPLrMREeO/L+qfDfPZG+fDEc+4WWfiOh00T5XU4omP5K28pk/Rj7146bbzERv4tnS2Patf/T0NSYmM9a0dSuPav1a+7Oe5SdSkcbR7t89nCM8/Kexic/aTS0iY0+LJmt4TbbHjnn133veeXh3IieXPnMxv6XQm0WmJ1r6WlXjPVzqX8MYrWOUZ687uNeTHOtEcImfyifjmdzEajtDr8vLF5PTx6cde9efD72TvRHtrWJ33nfpEdLR6G2TTnN+vrT2XtNa55zFadWZz2WtaOyGOda88JiI7omZ+MzP5RDD5tRnzz3s2bJlmN5jyl7W2367RMzEb+qIdLT0dLRjGlp00459SsVz4zEZn35Y5mZ4zM+MviyIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZrgfZ/ivaLWV0XC9NOW/XLmvvTTaen48+aYmtI8K1jvZLztXHS9piGh0h0lsfRehOvterFK8KUj0tXVtyrp0zm09s7q1jfa1Y3sepqU06za04xwjnM9kRzenOyPYPhfZbHXNEV1vFbU/i6/LSInHNq7XxaOkxPkMM9JtvbNkiZ79+7NcdPk/TX0i2vpe86eZ0Nji3obNSfWiJzW+vaP9S/du06Yjq1zm08zV2idWZ/prndWIju32nnnnjGOGJ4t6j/r8fy/z09XnmsAAAAAAAAAAAAAAAAAAAAAyvB+E5uK6ju/ax6fFMTnzbfdiecUxzMbWvfadoneKxE3tEx3azpbdttNj087rat8xp0mePD0rc4rHbGMz6MTnOK3vFIzOJnlGd878d/D/pl1fDgw6bFjwYKRTFirFaViOkRvM7z4zMzNrWnnMzMzvPN4/U1L6t7ampabXtOZmfKOyIjdERuiMRG5pWmbTMzxnj8o7sPoogAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8dTpsOswX02fHGTFkja1Z/tNZ/ltWftVtHOs84lk0tW+jqV1NO01vWcxMeUxO6YnhMTumF63tWYmJxMbsxnhu5eERwxlyni3CM3CdRNLTN9PebfV8220XrE7zW3P7OSkTtaNo3iItHKdo9hsW2023T60R1dWuI1NPOerPCJiMR6Np9XfOPVnfDcrqRqR1v6t2Y7PnmIjE7ufYxbcT/PiAAAAAAAAAAAAAAAAAAAAAx/EuFcP4xpMuh4lpcer02X72PJWN6zvvW+O8bXxZKTzrkpat6zvtPOYnZ2TbNp2HXptOy6ttHWpwtWd0xzres5relv6qWiaz2boXre1JiazMTEY3c47JjhMd2N/jveb+2P0acQ4D5TX8K8rxLhMd/Jfam+r0NInfbPjrzzYa1nf6xjrHdrW056Y4iL3+o9B/SvZukeps+2dXZdsnq1rmcaO0WndH1dp9S9rf9lad8zEUteZmK9PR2mt8Vtit+UcInsxnGJ7pxyxGN7l71zaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAffDqtTp53wZ8uL1UyWrWferE923/AIoli1dDQ1oxq6Wnqd96VtMeFpjMe6Y4R2Ji1q8JmPCWUxdoOI4+Vr480eMZccfHHOO2/P0zHqlo6nRGxX9Wl9Ke3TvPZjhfrxjuwyRrXjjMT4x+8Y/k+DJY+08cvLaSY5c5x5Innv4VtWOW3hNuvi0b9BzGfqtoieyNSmPjasz38K92IWjaOOa8OOJ/blz4z82Rxcf4bk272TJinxjLjnl08cc5K9d/Hw/JpX6J26kzjTpqRHOmpXyv1LZ93D4Mka1J5zHjHyz/ACWQxa7RZtox6rBa09KxlpFvV9iZi3X1cva09TZdq0szfZ9StYjOZpbH4orNfz968XrMxETE54b4+GOOfcuuXhMT7ObBnh4fDx7P52StE53/AC/bIkAAAAAAAAAAAAAAAAAAAAAP858if5/MTnwFtl1ujwbxm1OGkxPOs5Kzf9ET3uXjy/ozaezbTqxnT0NW0Twt1LdWez0sYjPfMT3KzesZzaN3fHlx/LwY7Lx/huOOWTJlmOW2PHbn64nJ5Ovq+9vu3NPonbb8aU04nne8bvGK9e3f6vdxUnWpEZzM90ROfl+bHZO09efkdLMx/LbJkiPzmtYt6uUXn2+Ld0+g7bvrdorHbFKTPPhFrTHLnNfcpOv9mu7v+UfNjc3aDiOX7lseCPRixxM/nbJOSd/ZtHqbun0PsVPWrfVn/wAS84+FIpHbxzO/jO5Sda88JiPCI/fLGZtXqtRP8bUZcnPeIte01ifVXfu1/KIb2ls+ho/6Wjp0nhmtKxafG2OtPvmWObWnjMz4yt9o9EMyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHSeyH0ccR7ReT1uv8rw7hE7Xrlmu2q1td5ia6THf7tJrEzGpyVtj+7OOmbn3fLdN/SjZejOvobP1Nq23ExNInOloTjdOtavG2Zj/KpMW4xe2numdbW2mmnuri98xGM7oz2z+3lvelOE8G4bwTSY9DwzS49Lp8fOa0j7eS8xEWy5sk/by5bRERa97TMxEVjasREfK9s27atv1rbRtetbW1Z3RNuFa78UpWPRpSMziKxG+Zmczvcu97ak5vbrTwieyOyI5R7s/mybUUAAAAAAAAAAAAAAAAAAAAAZPhfC9RxTURixxNMNNpz55rvXFWd+XWN722mKUjnM72natbTGptm16eyaU3tObzu09PO+09vdWP6p3Y4RmZ3VtaKxv48o3Zn8+HHM8I753Oq6TS4NFp6abT0imLHHKI62mdu9e0/zWtMbzM+PTaIiI8fra2pr6ltXVt1r24zyiI4REcIiI3RH75lp2vNs5xOce7HZ2f8AM9srhiVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAW+q0uDW4L6bUUi+LJHPwtWY51tS20zW1Z6THsneN4ZdHW1NDUrq6Vuras+6Y5xaOcTG6Y+GJxK9LzScxO+OEcu/uxnEzG7x7eU8V4VqOF6iceSJthvM2wZoj7OSm/T/lyVnbv19c2rMxMS9hse2ae16fWruvX/AFKTxpPKY376241numJxMb9ul4vEzHGOMb935Ru72N3/ANf7dW2sAAAAAAAAAAAAAAAAAAAAApMRPKekxtMeEx7On9YneOU8kxOJzz5fz5YmOMSOT9r/AKMNFxjyuv4L5HhvE7Wm+XDMTTQauduczSkT9VzWnaZy46zjvabTkxTe85XsehPpbtGw9TZtu6+1bJERWt437RoRnlNpiNXTrGcUtMWrXEVvisVbmjtVqYreOtWI4xmbRPHM54xEcY8ZjPB524jw3X8J1WTRcR0uXSarHtNsWWu0zWZnu3paN6ZMdtp7mTHa2O209207S+nbLtWzbbo12jZdamvo3zi9JzGY41tE4tS0ZjrUtEWjO+IdKtq3jrVt1onnHDw7u/nnisWwsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+lM2bH5vLkp6O5e1NtunSesemNmO2lpX9fTpf2qVt8cxOU5mOEz7px+8L7FxfiWKNq6vJaN9/4vdyz/AFy1vbb1RLW1Ojti1PW2ekf/AC5tp/lpzWPyWjUvH9U+/f55Xde0XEa9ZwX97FMb8tv5L0/t8OTWt0NsduH11PZ1I/8AVW3hvz8d6Y1b4mJxOZz6UZ926Y/4XmPtPkiNsukpafTjy2x/2tXJy38N9/W179BUmf8AL2m9Y7L6dL+G+Jp8ccoX+vnnXf2xPxxExK5r2mwT9/TZq+7elv6793/X2ME9B60err6dvai8cPDre/gtGvXnE/lPy/n53FO0egtytGoptz50rMb+ru3tO/XwYbdCbXXhbSv3RqXj4xetY/Nb66n+6PGPlMrmvG+F2/8Aunuz6LYs1f7+T7v92D/2Tt1Zn/ImYznNdTSx4Y+szMe7G/gn63T+1+U/J9Y4tw6emsw/nM1+MQrPR+2xx2fU90RPlMp+sp9qPi+kcR0M9NXp+f8A3tI+MqTsW1xx2bW/8u0+UJi9J/qr8YT+u6P/AO+9N/7/ABfuV/wu0/8A3Pr/APlan/2p16far+KPmnGp01umowT7MuOfhZWdHWjjo6seOneP2T1q/aj4wr5fB/22L/3lP+qPqtX/ALrU/wDLv8jMdsfGDy+D/tsX/vKf9T6nV/7rU/Bb5GY7Y+MKTqdPHXUYY9uXHHxsmNHWnho6s+Gnef2OtWONoj3wh9d0f/33pv8A3+L963+G2meGz68//S1P/tUden2q/ij5oTxHQx11en/LLSfhMrRsW1z/APi2v79O8ecQidSkf1V+Mfz+d0vnbi3Dq9dZh5ei02+WJ5evovHR+2zw2fU98RX9UwfWU+1H88ve+U8c4XXn9Zi3jEVxZrb/AJxj25+uYZI6L263/YTHfOppRj3TfP5InVpH9WfCJn/hbW7R8PrP2Y1F/XXHWI/+PJWfz28fUzV6F2y3G2jTxvMz/bS0eXirOtTlEz7sLe3afTxM9zTZ5nwmbUrv7dptMb/nPP8ANkjoLWmfS19OIzyi9seEejEePHv3q/XRv9GZz3zH55n8sdmFtk7T3mJjFo6Vn8WTNN4/TWmOfb9qerYr0FT+vabzG7dTTik9/pTa/wClE6/HFYjvmePZnER5rO3aLiFunkKe7imfnvdsV6G2OvH62/tXiM+PUrX48e9E6155V+E/vMrXJxjiWXlOryVj/u4pin+uOtbf3bNOjdi0+Gz0tw/1JtqcOeNS1oz7lJ1Lz/VPu3eSxvnz5JmcmbLeZ/HkvafXv3rTv4tmulpU9TT06ezStfKIVzaeMzM+/wDeZ7nyZEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALvQ8P1vE9Vi0eg02XV6nLO1MOKs2tO20zeZ6UpTre95rSkfataIhg2jadDZNG+vtOrTR0aRm2pecRGeERztaZ3VrWJtad0RMq2tWsTa04iOMzn+T7noTsh9Fml4ZOPiHaDyWv19Zx5MWjr9vQ6W0RMz5WLctXlraYne0RgpMcqZp7t4+a9N/S/W2uL7N0b19n2eYtW+vPo7RrRn+jH+hpzHZM6tomczp76zz9ba5tmunOK7/S3xNuzG6cRxicxv47uDsERtERERERERERG0REdIjbwiOkbR7I6R4mZmeMzOZmZzv3zxnxnm0p/P+fn38/HKqEAAAAAAAAAAAAAAAAAAAAAMhw3hufimojDh+zWsxbNmmJ7mGvP723W1tpilOtp8YrFrV1dr2vT2TTnUvvtOY09OJ9K9t3DsiuYm08IjtmYiYtaKRm3u7/Dj8d7q2j0en0GCmm01O7jp1mdpvktP3sl7REb2ty35bRERWsRWIiPH6+vqbRqW1dW3WtPLhWsRwrWOUR2c5zMzMzMzpWtNpzacz4Yx3Y4LphVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWus0eDX6e2m1FO9jtziY2i1L7cslLbcr18J5xMb1mJrMxObQ19TZ9SNXStMWjdMf02rzraOcTz90xviJWraazExxzv74zG78nKuKcLz8K1E4ssTbFebTgzRExTJj5zG/hXJEbd+kzM161+xMTPsNj2vT2vS69N1q4jU059ak+c1nO63CeE74mI3a2i0RMTv5xwxjdO6d+M8J/fMRjm0kAAAAAAAAAAAAAAAAAAAAABg+PdnuFdotHOj4npq5oiJ8hmrtTU6a893e+nzRWZx2nuxNq86ZKx3clLU3hv9HdJ7Z0Xrxr7JqzSZmPrNOczpatYz6Orp5iLxGZxO61ZnNbVneyU1b6cxNJx2xyt7UZ3/AMw839rfo64t2cnJqtNF+J8JiZmNVip/H01NonbWYK7zSsTM1+sY+9gnaJvOG16431Pob6T7F0pFdHVmNk2zGJ0b2/y9We3Q1JxFpndP1dsXjMxXrxWbOno7RXUiItMVvjhO6J5ZieHHlx7nO3pmyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf5+QN97KfR/xjtLbHqb0tw/hXerN9dnpMWzUmecaPDbu2zTt/xJ7uCszzvaY7k+d6Y+kuw9FRbTraNp2zE9XZ9O0YpMZx9fqRmNOM/wBG/Un7MROWvrbRTTjETFr8oiYxHHfMzu5d89z0l2f7M8I7N6WNPw3TRS9o2zarJtfV6md9982WYidon7uOkVxU/kpG8zPyzpPpbbeldX6zatWbVic6ejX0dHS3Y/y6Z+NrTN7f1WnlzdXVvqWzad3CIj1Y908d87pnj27mwuYwgAAAAAAAAAAAAAAAAAAAAAMhw3huo4nqK4cMbVjac2aY+xip42nnHetPOKUid7T6Kxa1dbatq09k051NSczOYpSJ9K9uyOOIjObWndEdszETFrRWMz7o/nLGf5x6podBp+Haeun01O7WOd7ztN8l9tpve20bzPSI5RWIitYisRDx+0bRqbTqTq6s5md0RHq1ryrWOUR8ZnfO9raszbfMzxxEcojsj9+2d853LxgYQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFrrNHp9fgvptTSL47c48LUvG/dvSec1vWZ5T65i29ZmJzaGvqbPqV1dK01tG7utWeNbRzrPOPfGJiJWraazmJnPj59sbo3c8Q5ZxXhOo4Vn8nkicmC8z5DUVrMVvG28xeN/s5K7/apvPpibRMS9fse2aW2afWr6OpX/U05nM1meE13b6zytu7JiJjDcpeLxmOPOOz8o3d8buPYxjbXmJj/rE+QIAAAAAAAAAAAAAAAAAAAAANo9Ef+vX+onM7t87uHdjhhybtZ9FvDeLRk1nBPJcK4h3bWnTxXucP1V9+9valImdLed+7N8NJx9Jthmd7T7Lob6X7VsfU0Nv6+2bNmIjVmc7TpV4brWn/ADqxx6upMX5ReIxDb0tqtTEXnr1374z1o/KM+ffG/PnvivB+JcE1VtFxTSZdLnrG9e/XemWm+3lMOWu+PLSZ5d6lpiJiaztaJiPpex7dsu36Ma+ya1NbTndPVn0qW511KTi1LR2WiMxMTGazEz0aalNSM0tExv8Ay45/ngxjbXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZDhnCuIcZ1dNFwzS5dXqLzypjrypXxvlyW2x4sceOTJatI6b78mtte2bNsOjbX2vWpo6Vf6rzvtPKtKxm17TyrSJtPYra9aRM2mIxGd84/5egOyn0U6Dh0Y9b2g8lxPW92LU0cbzw/TWnad7xMROsyVjeu2Sv1aN7fwskxjyR836Y+mO0bV1tDo3r7JoZxbX3RtOtXfnq4mY0KTx9C31s4r6dM2q52ttdrZjTzWMxv4Wn890Tnvnhw59frWtYitYiIrEREViIiIiNoiIjlERHKIjlEcoeJmZmZmZmZnfMzOZmZnMzM89+/xaeZnMzMzM8ZzO/x7VUIAAAAAAAAAAAAAAAAAAAAAAZLhnDNRxTPGLDHcx12nNntEzTFSfT0715/lpE72577Vi1q6u17XpbJpze++05jT04nE2n4Tisc5xu753TW94pGZxM7sRnjnw4c8/Di6nodDp+H6eun09e7WIib2n7+W8xHevknxtMxyjpWIitYrWIiPIbRtGrtOpOrq2zM7q1j1aVzurWOUR8ZnfMzMzLUte1pzme6Imd3dx7/fxXbArmZ4zM+8EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALfV6XBrcF9PqKd/HeNvRas85i1Lbb1vWedbR0n0xyZdHW1NDUrq6VuravwmJ41mOcTG6Y98YmImLVvNZiY3TGfzxmJ3TmN3Cfjwct4vwfPwnL9rfLp8k7YdREbRMc57mSOlclY+9HKtoibUnaJrX12xbdp7ZTd6GrWM305nOOXWrPOszjfxjMRbfvndpbr1zGInO+Mx4RjfwznGGJbq0xieOfjHmCAAAAAAAAAAAAAAAAAAAAAAGL4rwfhvGtJfR8T0uLV6e0b7Xrteloidr4ckTF8OSP5b47VmI3rv3bTDb2Pbtr2DWrr7Jr30dSJ3zWc1vHOupSYmupWedbRO/E8Yhk09S1JiaTNZzvnjnM9m+OG7hOfGIcC7U/RTxDh85NX2fnJxPRxM2nRWiJ4hhrtM/YisVrq6xMTH8OtM0b0iMWXe14+j9EfTHZtq6mh0lFNk1sREa8TjZtS0bvSzmdCZ3Tm020+Ob1xFXQ0tqrbEXxW3bndM8eG+Y+OI4buDkV6Xx2tTJW1L0tal6Xia2paszFq2raImtqzExasxExMTE84e1ratoi1Zi1bRE1tWYmJid8TExumJjfExultxOYz5TmPiilIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACsRNpitYmbTMREREzMzM7RERHOZmeURHOZJmIiZmYiIjMzO6IiOMzPKIHV+y/0V8U4pOPV8b8pwnQ7xaNPNP/rHUUjnMRjtHd0lZj7PfzxOWJ6YJjm8b0v9MNk2TraPR/U23aMTH1sW/wDdtK3CJm8b9aY4zGnMUxiJ1YmcRp6u10pM1p6U87RjEYz8e7lv3vQXCOB8L4FpY0fC9Ji0uGOd5rETlzWnrfPmtE5M1/CLZLW7sRFa7VrWsfNdt6Q2vpHWnX2zXvrXndEWnFKV+zp6cYpp15zFIjMzMzmZmZ599W97Ra05mOETwj3cPhjfvZZpsYAAAAAAAAAAAAAAAAAAAAAADKcJ4VqOK55pSJx4KWjy2omJmlImN4iOneyW2mK0jptMzMRG7T2zbdLY6Zt6WpaPQ0+E2ntmd+KRzt7oiZRa0VjM75nOI8O/hHbOfdmcxHUtHo8Gh09NNp6RTHXeZnl3r2n71722ibWttzmekbREREREeR19fU2jUtq6k5tPCOVY5VrHKI/PjOZmZaV7Tecz/I5R7l0wqgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPlnwYdVivg1FK5MWSNr1tvzjrvExtatonnW1Zi0TziY6r6epfRvXU07TW9ZzEx5THCYnhMTExMbpiYWraYnOZz28Z7Pf7925y/jXBM/C8k5Kb5NHkttjyzznHMzyx5YjnFojaK35Uyddq23q9bsG36e116s+jr1j09Pfi0RG+9J+zP8AVGc13cc5ncpqfWRwjO/PKJ5zMZmJ7+2OG+IYR0FgAAAAAAAAAAAAAAAAAAAAAAAGm9pew3Au01ZvqsE6XXRWa4+IaTbHn3mOXlqxHk9RWJ25ZqzkrEbY8uOJtv3OivpB0j0VPV0dSNbZ5mJts2tM208RnPUmcW0rTv8A9O3VmcTat5iIjY0te+lExE5id/VnGPdM7/8AnlLzz2l7Ace7NzbNkxfX+H1iZjX6Ot7UpWPHU4tpyaedom1rW72GOkZbTE7fTOivpJ0d0pilb/4baZxH+H17Vi1pn/ur7q6u/hEYv20h0dLaNPU3Z6tvszMb/DEzE/HLR3oGcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABuXZvsLx3tLauTT4PqmgmY73ENXW1MExvtP1eu3f1N42mdsceTiY2vkpMxvwulfpD0d0VE11dT67aY4bLozFtTPL6yc9XSj2p632a2YNXX09LjOZ+zHH39mN3Gd+d8c3ofsx2C4F2ZiubFinW8R7tYvr9XWtslbRvMzpsfPHpqzMzt5PfL3e7XJlvtD5n0t9IukOls0veNDZszjZtGZisxy+ttutrTEYj0sUzma0rMy5urtGpq7pnq13+jH7zxny7m7uAwAAAAAAAAAAAAAAAAAAAAAAAE9J/16fmDMcG4Nn4rl70zOHSUtHlc0xzmY2mceOJmd72j/AMNN4m3LaLaO3bdp7HTGYvr2j0NOJ3Ru3Wvu3RE++2MRzmK3vFIzMZndiOGfGeUd7qOl0uDR4aafT0jHipERERzm3pte0872mec2tMzM/k8jq6upr6ltTVtN72nfM8uyIiN1axyiIiI5NO0zM5mcz45xzxHdGeHB92NUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABDJjx5sd8WWlcmO8TW9LRvW1Z8JieUwtW1qWi9LTW1ZzFonExPctE4xMZie2JxPh4dvHLnHHez+Th1rajSVtl0czM2rzm+mmZ+7fbvTbF+HLvO07VyfamLW9R0f0lXaYjS1piuvymd1dXvjsv2158a5jMRs01IvOJxE93PdnsjGOcNZdZmnunP8AP5xx4AgAAAAAAAAAAAAAAAAAAAAAABS0RaJrMbxMTExMRMTExtMTE7xMT4xPKek7xvCYnExMcYnMcuHhv+CYnH8/nDi5h2m+i/gnGO/qeG93g2umLTPkKR9SzX2mYnNpomIxzNtom+m7m282tjy25PWdE/S7b9h6ultWdu2eJj/UtP8AiKV4T1NWc9eI4xXVi2ZjqxekTmNrS2q+niLenXvn0t3fx8M7++Y3OB8f7J8c7N5e5xLR2jDO049bp+9m0WTedoiueK1il9/+Hmrjy+Pc7s1mfo/RvTPR/StOtsmvWdSPX2fUxTaKc8zpzMzav++k2pM5jrZiYjo6erTVjNZ38JrO60T2Y+TW3UZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGwcC7L8b7R5fJ8L0V8uOvndVl/g6PDG+38TUX2pNv+6x9/NMRM1x2iLbc3pDpfYOi6Rba9etLW9TRp6evf2dKvpdX/fbq0icRNomYicWpraelGbzGeVY3zPPhG+M7vDPHm732a+ivg3CfJ6ni014xrorW3k8lJrw/BfeJt5PBO06iYn7Nb6neJja8afHbp846V+mG3bb1tLYonYdnzMdas52nUrOYjrakRjTzEZmul6UTunUtXjoau13vupHVr27ptw5zE7pnM7u7jO91OtK1rFaxFa1rWtaxERWK1jaIiIiIiIjltG0bco2eRmZmZmZmZmZmZmZmZmecznfOd+e3jlqZ3zPb2bvh2JIQAAAAAAAAAAAAAAAAAAAAAAAT/n+eP8AnsBsXBeAZeJWrnz97FoqzP2ttr55r1ri3mO7TbeLZdrRvvWkTbvTTmbf0jTZYnT08X15jdHGNOJz6V+UznhTOZ4ziMdal9TqRMRObY4cYrnnMZ47/dx8OlYsWLBiphw464sWOvdpSkbViN5mfzmZmZmeczMzO8zLyl731LTfUtN72nM2tOZn+co4RG6NzTmZmczOZnnL6KoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJiLxNbRE1mJrMWiJiazvvExPWJiZiYnfeOW3gmJmJiYmYmJzExumJjhMTymExvnfOM8+yeOeXh72g8c7NWwzfWcOrNsX3s2lrG84uUzN8PWb02iZtSN7Vnbub05V9H0f0rF+robVaItjFNaeFuyupyi3ZbdE7+tPW47VNXrTFbRHWxGJjhPdPZPZ8OxpruM2J7JBAAAAAAAAAAAAAAAAAAAAAAABt/nh/ToGePe+WXDiz4r4c2OmXFlramTFkpXJjyUvExal6Xia2pMTMWrMc4mYWpe1LVvS1qXpMWraszW1bRMTFqzGJi0YjE8efFaJxOczmI3TGc53YxPKe/8nJu0X0S8L4hN9TwPLHCdTMWn6taL5NBkv1juxvOXTbz9mZx9/HWNprgjb7XtOjPpntezRXS6Qp/jdKMR9bWYrtNY753U1cRvxbq3mc9bU5Rt6e12riLx1o5zwmM+Gc9+6N/Hi4Xxvsxxvs9l7nFNDkw47WmuPU0jyukzTG/m9RTenemOfk79zLFedqQ+g9H9LbB0nTrbHtFNS0RE30rehracTu9PTti0Rnd1ozSZ4Wlv01aanqzGedZ3WjMc4/nzwLosgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADM8G7PcY4/nnBwrQZtVNdvKZYr3NPhiek5tTk7uHHvtO1bXi9tp7tbbS0Nu6T2Ho2n1m2bRTRic9WkzNtW+OPU0qxN7YzGZiuIzGZjKl9WmnGb2iN0zEcZnHZEb/2d07N/RJw7ReT1PaDLHE9TtE/U8U3x6HFfrPfv9jNqtukd6MWOd572K28d3590p9NNq1+tpdG0/wAJpZmPr7xW20Xjh6NcW09LPGcde0f03rjfoam2WtmKR1Y+1n0vh8t/e65p9Ng0uHHp9NhxafBhrWmLDhpXHjx1r92tKUitKxEeFYiPa8XqaupraltXV1L6upeZtfU1LTa9rTxm1rTMzM9sy0pmZnNpmZnfmZzvnfP/AC+7GjP8/niAAAAAAAAAAAAAAAAAAAAAAAAbx6YE4nsn4Nu4H2ctqfJ6zX1mun3i+LT23i2eNt62vtMdzFvziJ55OUxMUmJni9IdJxpZ0dnmLau+L6kb4054TFeMWv3zurPKZ4YdTViua19bhM4ier3RE7pmY49numJ6DWK0rWlKxStaxWtaxEVisRtERERERERyiPCNo8HmpmZmZmZmZmZmZ4zM75me+ZatpzM/PPKFUIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAV/wA8P+k/5+YmJxE8e7ljv8f25tR452brqu/q+H1rTUzvfLgiIrjzdOdN9q48nWZ/kyTO89229r9ro/pSdLGjtMzbS3RTU4204jO63O1OERzrHDMbozaerMYrbfHKecePd5c88ufXpfHa1MlbUvS01tS0TFq2idpiYnnExPXfp4vS1tFoi1Zi1bRExMTmJid8TExumJhsopAAAAAAAAAAAAAAAAAAAAAAAAAHxz4MOox2w58OLPhyRNcmHNSuXFes7bxbHeLUtExvvFomJ5xMTvK+nqX0rRfTvfTvXfW+naaWrPbFq4tExyxMeO6FotMb43TynsjunjGN2N/KOzfyftF9EnCdfNs/A808J1NrWvbT5O/m0GTfee7Su85tLPenePJ2yYq03rTTxERt7Poz6abZs+NPpCkbbpRERGpXq6e01xztOOpqxiP6q1vM77ak537entlq/wCpHXjlMbrRMRETPZOfdPbO/fxDjvZPj3Z2944loclcFb9yuuwxObRZd52rNc9Y2pN/5ceaMWbwtjiYmHvuj+mejuk6x/hdorOpNetOhqf5evXEZnOnac26vO1JvTnFpiYlv6erTUj0bb8b6zutHjE7/fv8WuOoyfzAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADP8ABOzHHO0N4rwrh+bPj78UvqrbYtJineO939RkmuPekT3rY6TfLtt3cdpmsTzdv6X6P6MrnbNppp36s2rox6eteOXV0q5ti07otaK0znNoiJmMd9XT0/WtETyjnPhDt/Z76IuGaOK5+PZ54nqImto02CcmDQ0iNpmt5+zqNRMzHWbYKd3lbDbfd4DpL6a7XrzOn0dp/wCE0sTH1upFdTaLZ4TEelpaW7jERqWzvjUho6u2Wndpx1Yxx427u74Z5TE9vWtPpdNo8VNPpNPg0uDHHdph0+LHhxUrG20Vx461rWOURyjp+Ux4zV1tXXvbU1tS+tqW321NW9r3njxtaZmePOWlNptOZmZntmcz2Rv4zj+c1wxoAAAAAAAAAAAAAAAAAAAAAAAAAViLWtFa1ta1piK1rE2tMzMRERWOczO/KIiZnpHPZEzFYm0zEREZmZ3REc5meGIP558+EcOfzb9wTszGKKaziNIvl3rfDppjemKYmZi2aJia3yREfc3mlOtt7bxTzu39KzfraOyzMU31vq8LX5TFOGKzvibYzaOGI32w31sejWffG/Pd3RPDMcePKJncp9m3/Twj8vT4uF4tafh3KCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADfboDBcY4Fg4pS2Sndw6ysbUzbb1ybRG1M1Y52rERtW8R3qR0mYiKT0dh6Q1NktFbTa+hM76Z31zxmmc4768Lb+Ez1mbT1JrMRMZjfu3Rjw4eO+cT5801Wl1GizW0+px2x5KzP3o5WjwtS0R3bUnwtE7Ttt1329Xo62nr0jU0rRasxy4xPOJid8WjnE+TZiYtETExMT4/mt2RIAAAAAAAAAAAAAAAAAAAAAAAAACGTHjy474smOmXHkrNL48la3pkraNpretomtqzHKYtExMelatrUtW1LWpasxNbVmYtWYnMTFo3xMTvzG/O9OZzE5xMcMbsfDxcz4/wDRZ2f4tOTPoItwbV2rad9NWL6O+TlMTk0lrRWsTzifq2TBX+aa2tvNvV9HfTDpLY4rp7Tjb9GsxH+bM114rziutEZt2xOtXUnlmIxFdrT2vUpiLenWJ5zi2OyJ+cT+bivHvo+7S8B3y5dHOu0kTP8AvfD99RSIiN5nNiisZ8ERHObXxRj35VyWnk950d9JeiukcVpr/wCH1px/kbTjStMzuiKXmZ09Sc8q3m3OaxG9vae06V4j0urbdmLbp39/CfdPjENI9rvs4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADc+A9gu0nH5rfBoraTSW/8Au3XxbTYZjw8lW1ZzZ943+1hxXpG21r1mYieF0j9Iui+jc11deNbWj/sNnxq6kT/vmJimn4XtE9kTvYdTaNLT42zP2a759/Z7/c7VwD6KeBcLnHn4na3GdXSYttmp5LQ1vymNtLW1vLVjp/vGS9LTznFG8RHhOkvpj0jtcW09kiuw6Nt2aT19omvPOtMRFJn/AMOlbRwi88Z0dTa9S2ep/lx3TEzPL1uMfdjdu383T8WHFgx0w4cePFixxFceLHStMdKxzitKViK1iPCIiIh5G976lrX1L2ve05te9pta09trWmZme+ZmWpMzO+d/PhH59vvfRVAAAAAAAAAAAAAAAAAAAAAAAAAAD66fT59Xmpg02O2XLeYiK1jbaOk2tMx3a1r1m1prWI23npvj1dXT0aW1NW0UpWMzM8+UREcbTM8IiJmewmYjfOMd7pfBuAYeGxXPm7ubWzHPJ1rh361wxPjtMRbJMd6dpiO7EzWfK7d0jqbVM0pnT0I4V/qv33mO/hWN0c8zETGvOpFsxmIrwjfiZjfvnsiY5eOc7mw7/DZzWG05meHGcbo4fz5qCoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACx4hw3S8Swzh1FN7RExizRyyYbTtvak7TO0zEb0netoiO9WZiJjZ2batXZdTr6Vt0469Jz1Lx2Wjt7LRvjlO+YnJS81ndu7uU7ue/j2cYzycx4nwjVcLyTGWvlMF5nyWopH2L+ito/wCHkiNt62nnz7s2rHees2TbdLbKZpPVvWI6+nad9e+PtVmc4mPfFZnDareLxu49k5zHLG/lExLFttYAAAAAAAAAAAAAAAAAAAAAAAAAAAn/AD/OfUGncd7B9muPxlvqdBTTavLvaddoe7ptT3+Ud++1Zw55mI2t9YxZd46TFtrR3Oj/AKRdK9GzWNLaLaujXEf4faM6ul1Y4VrMzGppxHL6u9IzxiYzE56bRqafC0zETHo23xjEx49nDd3cnG+OfRFxrQ2tl4PnxcW03WMV5rpdbT1dy9pwZY6RFq5qWmd48jHKbe46P+muwa8RTb9O2xavDr162ts9uEetWI1KTM59GdO0Ru/zJzu3dPa6W9eJp2TG+uN++Z4xwnMcMdrl2r0Os4fmtp9dpdRo89ZmLYtThyYckbePdyVrMx6JjeJjaYmYmHr9HaNDaaRq7PraWvpzwvpXrqV3xnjWZiJ7p3xzht1tW0ZraLR3TE+S1ZU/z4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPvptLqdblpg0enz6rNkmIpi0+K+bJaZ6bUx1tad/VDHq62loUnU19XT0aVzNr6t66dYxxza8xEY8UTasRMzMREcZmYx4ePc6jwP6JOOa+1MvF8uLhGmmIt3J7up1tt9pisYcd4xYt4md5yZu/SeU4Z57eR6Q+mnR+zRamxUvturEzHW36OhHf17Vm98TjEV04raOGpDU1NspWPQjrz8K/HnjHLd3uxcC+j/ALNcBjFkxaGmt1mOYt9d18V1GaL9e9ipNYwYZrMb0nFireJ2mbzaN58P0h9JOlekZtXU2idDQtEx9Rs2dOkxPK9ot9ZeJicWi95rP2Yjc09TadTU4ziOda7ox8czn3eLdefLfr4/5/T0f6OD+UdjXVAAAAAAAAAAAAAAAAAAAAAAAAAAABkuGcK1XFcvk8Fe7jiY8pnvExjxxynr/Nfad644+1M9dq/ajV2rbNHZKdbUtm0xPU06+ved/wAK9tp3Rw32xExa0Vzmd/KIxMz+fDv4d8OmcN4VpOGYfJ4Kb5LRHlc94jymSY58/CtInlWlfsxHPab72nye1bXrbXeb6lsVzmmnEz1aR3ds9tp3zMzwjERqXvN53zPGd0cOPHPPOI4xx38NzJNVjAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAicb4QzYcWpxXwailcuLJExalo3id/7xMTziazExMRMbTtMXpe+net9O00vWcxas4mJ+XbE7pjdMTDLSZmZnM5iYmPHf+Xdw7nO+M9m82jm+o0XfzaWN7Xx8py4I6zy2icmLbeYtH26Vj7cTtOSfTbD0rTXxpa/V09bdEW4U1JndERyrad26d0z6sxnqs9b53WjE8M8p8N875jfjtzjsjVYnr/5b/29cS68/wAxn92RUAAAAAAAAAAAAAAAAAAAAAAAAAAADbcM481hxDhfDuK4LabiWi0+tw2/k1GKuTuzz2tjtMd7HeN52vjtW8bztaGzs22bVsepGrsuvq6GpH9Wlea54brRG69ZxGa3i1Z5wvW96TmlrV8J3e+OEx3Tucr439D/AAnVTOXgurzcMyz/APc+ffV6S0zv92bWrqMW/jM5c1doiKY48fX7B9N9s0cU2/Qptdf+808aOtHDfMRE6V8b90U055zaeDb09svGIvEW743T/wA58Ozjvcn4z9H3angs5LZeHX1umx72nV8O31WLuViZm96ViNRjrWImbzlw0rXxmYjvPZbD9JeiNu6tabTXQ1bYj6naf8m/WnhEWtP1V5nl1NS0znhnc26bRpX4WxOcYt6M57s7p+PDv3NKd5micxn+fz+SCQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD0esP5/P8AnDcODdg+1HHPJ303Dcmn02XnXWa7/ddPFOX2478Tny1nrE4MOXvRziJiJlxNv+kXRPR/Xrq7VXV1qZzobP8A52r1o/pnqz9XS3HMal6YxvxuzgvtGlSMzbM9lcTOezs9+ff29a4L9D3DNN3c3G9bm4jkiIn6tpd9NpYmdvv5N51GWInfbu208THO0THJ4zb/AKb7Vq5psGhTZa/97q41taY/21x9VSZ741Mcpji1L7Zef9OvVj7U75jfz5R4b+PHm6pw3hHDOEYY0/DNBptFir4YMVa2v/zZMm05Mt56TfLe95252l4/att2vbdSdXa9o1de889S9rRWOylc9Wlc7+rSK1iZnEQ1LXvac3tMzO/fw90cMeEYlktv83lqqAAAAAAAAAAAAAAAAAAAAAAAAAAAAANm4N2cz6+aajVd7Bo55xG0xl1EbbxGPeNqUmI85POYmO5W2/erydu6T09n62lo41NffE/Y054elP8AVaJ/pjsnrTHCaW1IpmI9K2O3ERn7Uz3Z4c8b4zDo2DT4dLipg0+OmLFSNq0rE7RG/WZtvM2t1m0z3rTznrvPmNTU1NW86mpab3txtPH5RHZERERyhqWtNpzO+ec/zhERuh9FFQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGqcZ7M4tZ39ToK0wanebZMO22LN4zNduWK++/OsRSZmN4i0zaezsPSttGPqto62ppboreN96eP2690+lEcM7ojY09aY3XmZicRzz8cTM8u/slz3Liy6e84c2O+LLSe7al6zW1ZmN43iZ6bc4mJmJjnEzD0tNSmrWNTTtF6WjMWicxPvjG/t55472zx3xvjtzns593BBZAAAAAAAAAAAAAAAAAAAAAAAAAAAAABO/hO35bg1zjHZLs9x2kxxHhmnyZZnf61irOn1cW9P1nBOPLaPHuZLXxzPO1JdTYumuk+j5/8Addr1aU4fU3n63Qx2RpanWpWeXWrFbRG6LQy01tTTmZre0R9njHwtnGO3Ey5bxj6GqWmcnAuKTjiY/wDsXiVe/G/OfsarBWLRXblFb6e8785ybco9dsX06tERXpDY+tOf9XZbRWcf7tLUnEzxmZrqVjlFW3Tbf+8r76+7lM/vyjnx5fxXsR2n4NOSdXwnUXw03n6zpK/W9PNK9bzfB37Y6xz38tTFaIjeaxHOfXbH0/0Tt0V+p2zSrecf5WvP1OrEzwr1dTqxad8R6FrxM7omZ3NquvpW4XiN+MWzWc9mJiPyzu3tU/tty58p/pPP2+ieU83YZgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMxmI7eHuAbRwrsZ2m4zNPqXCNV5K8RaNTqaxpNN3Jn78ZtROOL1iOcRijJa0fcraXJ2zp3orYYt/iNt0uvXMfVaU/XavWj+nqaXWms+31YjnMMV9bTpnrXjMco3z28I8Obp/B/oZnvVy8c4pWa7bzpeG0ne07Rt3tXqKxtEdJrXTTNo6ZKy8lt3053TTo/Y5znH1u1TGI7caOlbfPZM6uI51lq322N8Upv7bTEx8I88z4cnUuD9juznAo34fwzTxm256rUVnVaqbemM+eb2xxPLemGMdN437u7yG3dOdKdI5jadr1Zp/wBzpzGjo47J09OKxef91+tblnDUvr6up615x2R6MeE4xnjPHMtnjl/n+f229jksIAAAAAAAAAAAAAAAAAAAAAAAAAAAAACWPHfPemLFS2XJe0RSlIm1pnrERFd58N/R49Fb2rp1te9opWsTNptOIiI7f53cVo9HFpmIx2/Cd3x3cffMZ6Bwfszj0/c1PEIrlzxtbHp4mLYcUzG/8XeNsuSJnp9ysxM/bnbbzm3dLW1ItpbNmmnOYtqcL3jfHoc6VmN+d1pz/TjfrX1t+K7o7cb5jtjM7vGOPKY4tu6dHEa08Z/fj7wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGO4lwnScUxTXPXu5axMY89IjymP0REzP26bzzpb7MxvMbWiJjb2XbNbZL505zSZjr6dp9C3fz6tscLRv5TmNzPS9qx1onjE5jlOM8Y7uHzc04nwjV8KybZq9/DaZ8nqMfPHfrtFuczjvyjelvGfszaOb1Wybbo7ZWOpPV1Melp2n0q9s/7q/wC6OXGInMM9b1vwzns3Z/L38PjMb2Ljn/6bNteePP38e8EAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAmJxnv8Af/OCm3TnPKZn27+nYQ17inZPs5xnv24hwjR5cuTfvaimP6vqd5/m+sYJx5ptvt968xO0bxMcp6mx9M9KbD1Y2bbdelK4xpWt9bpYjl9VqdekRjsrGOWOLLXW1KcL2ju4xxzjE7sTz8nNeKfQzockXvwjiuo019pmmDXYq6nFM78q+Ww+Ry0rHTvTjzTEbcpneXqdk+nW0Vmtdt2PS1Y3RN9nvbSvEfa6mp9ZS093X04474jENqm22j16RMZ3zE9Wd0b8RPGe7OeU8nOOKfRr2t4XW2T/AGfHEMVd98nDcsam20eMaeYx6u0e5gttHO2z1OyfSroXa5in+JnZr24V2qv1MZ7J1c20Y9+pGeWd7ZrtWjecRbEz9qOr+e+PzaRn0+o02ScWpwZtPljrjz4smK8c9udcla2j18uTv6erp6tYvpamnq0nhbTvW9Z99ZmGeJiYzExMdsTmPjD4rpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfXDgz6i8YtPhy58k9MeHHfLefZSkWtP5QpfU09Ks31L006xxte1aVjxtaYiPiiZiN8zER2zMR5t14Z9G/a3idK5Y4d9Rw26ZOJZI0k8us/V5i+riIjnEzgiLRzrNtpcHa/pT0NslppO1f4jUj+nZK/Xx4fWxMaOeUxGpMxziGC+06VMxnrT/t3xns63q597o3C/oa0lK1vxji2bPflN8HD8dcGGP+WNRqK5cmSJ6xeMGGfDux1ny+2fTrWtNo2DY6adeFdTabTqXnvnS05rWnh9ZqRnnMZhrX220+pSIjl1t8z7o3Yz3+HCXS+F9juzXBoxzoOEaWmXHtNdTmpOq1XejnN4z6mcuStpnefsTWtd9qVrWIiPK7X050rt3WjaNt1rUtnOlS31Olj7M6elFKzHL0omZ5zM72rfW1b+te2OzOI37+EYjw3ZxOMzDZNv8AOXL1R4bcv8lyv5/z+7Hn+cc9+/KogAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABkeG8K1fE8s0wV7uOvnM94muKnTf7XOLW57xSu9tt5nasTZq7VtmhslOtqWzaY9HTrMTe3HG7diN2+07o75mIRa0VjMzjPCO3j3TiN3Gd37dL4ZwfScLx7Ya+UzzH8TUXrHlLxvzrXfeKU5RMUr1/nm0xu8rte3a2129Oerpx6ulWfRjvmeNrd8+6Ijc1b6k3zmJiOMRHCM7pme3PKfhhlP8AP8/82mxAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIZMWLNjviy0rkpevdtS8RatonrFon+seiY367LVtalovS01tWc1tWZiYntiYTEzExMTie1onF+y1sfe1PDYnJjjebaaZ3yUiJiZnFM7zkjx7k75InpNt429FsXTFbY09rxW3CNaN1bTjEdeI3Vn/AHR6PdHParrdbEXxE7/S3xE7+/8AbxnnjTZ+zM1tExaJmJiYmJiY6xMT0mPGJ2dyJiYiY3xMZiY3xMTw38N/Lt5M2JxnlPCSJ35iAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFnrdBoeI4pwa/R6XW4Z64tVgx56bzExvEZK2iLRymLRHejbes7xG2fQ2naNmv8AWbPr62hqR/Xo6l9O2M5xM0mJmOOYmcTnh22re1JzW0xPdMx5THw4b5aJxP6LeymvrM4dLn4Zlnn5XQai1a7/APNg1Hl8PdmesY8dLbTMRaNo39Dsv0u6Z2aY6+tp7XT7G06cTOO7U0vq9TPfa198ZmJ4Niu16tZ3zF4zzjlHZO7j3xnvaHxH6GNdSJvwri+m1MxM7YddhvprberNhnU1m3qnHjj02jo9Fsv070LTFds2LU0u3U2fUrqxn/5d40piO3F7T3S2K7dWZxekx3xOfy3THxn3tF1/0f8Aa7h0Wtl4NqM+Om++TQzTWxMRvzimntfNttG+8442jrtO8R6LZvpJ0LtWIpt2lp2n+naOts857OtqxWmfC055ZZ67To2/riOHrejx8fzahlw5sF5x58WXDes7Wplx3x2ifGJreImJjxiY3h2aalNSsW0701Kzvi1LRasxPCYmszDNExO+JiY7YnL5rpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfTHiy5rxjw48mW9p2imOlr2mZ6RFaxMzM+Ebbz4K2vSkTa9q0rEZm1rRWIiOMzMzEREEzEcZiPHc2zh/YLtbxKIvh4NqcOO0bxk1vc0MbT0t3dTbHkmvPfvVxzExziecb8bafpH0LsszF9v0b2jjXQztE5jjGdKL1iY4TE2ifhLBbadGvG8TP+3f5N64b9DHEcsRfivFtLpYnafI6PFk1V9p6xbJljTUpb0xWuWv/ADPPbV9OtmpmNj2PW1v9+veujX3Vp9baYz2zSe5r222kZ6unM984rvzun+rv4797feGfRV2U0FYnUYNRxTLvvN9dnt3I5xPdrg00afF3eUxtkjJbaZ3tO+0ed2v6YdMbTMxpamlslOHV0NOJtz3zqas6l88N9OpHdu34bbXq2ziYrHKKxy75nM58JiM+7O+aHhvD+GYpw8O0Ok0OLeJnHpdPiwVtMR960Y6V71ucxNrb2nnO/OXndo2radqtF9p2jW2i/wBrW1L6kxHZHXtOI3RujEfBr2tN8Ta1rT/umZmOHDMzu7OHfyXrXUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAViJmYiImZmdoiOczM9IiPGZJmI3zOI7ZP58OPwbdwnstkz93UcSi2HFvWa6aOWXLG2/8AEmY/g1mYiJrzyzETG2OYizi7b0vTTzp7LMal8TE6v9FM5jFPtzzzupH+7fEY9TWiPUnM53z/AExaMZmMbpnHu4+DfcWHFgx1w4MdMWKkbUpSNqxG8zyjlzmZ3mdt5nnPOZebve+pa172m97Tm1rTmZnx/KI4RG6NzUtPWnMzmZ3zPfz/AJ5cI+iqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFd/8A0/z1chOd0xiN/Gd+d3vx+TB8U4DpOKRbJtGDVbfZz467d6Y32jLSu0ZInfbvTteI+7eOk9DY+kdbZJiufrNHO/TtOcZxmaT/AEzujdvrO/Mb5lkpq2ru41+zHb3c+Hbns3cY5zr+F6zhuTyeox7Um0xjzViZxZY6xNL8tpmOc0tEXjfnG3OfT7NtejtVOtpW9LGbaczEXpvx6Vd+7smN08p5NutqXjNZ54xPH8uXu88LBsgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACm3rn/I2/8AP2iczjHLy/nwW2p0Wi1lJx6zSaXVY5jaaanT4s9JjptNctLVmNuW2zNpbRr6Futoa+to2icxbS1L6dontzS0TnvymLWrwmY8JmPLHb8+MtO130bdj9da154VGkvbrbQ5sumrHu4q2nBX08sUeveOTt7P9KunNniIjbJ1qxy2jT09WffeaxqT7757Gau1a1f6ut7UdafjO9p3EPoY4feZnhfGdXpus+T12DFq4mec7Vy4J0dq1j148tto2mZmd3c2b6d7TXdtew6OrjHp7Pe+jiO+up9fFpnutSM8sM8bZasR1qVnPOs9/HG+N/Lf72o676IO0unra+j1HDuIRG8RipmyafPadt9orqMdcEeie9qYiJ8dt5drZ/pt0VqTFdbT2rZp52tp11dOOHPSvbU353f5XDsmYhmrtmnbjFq9s460R4439/BqWp7EdrdJv5XgHELbdfIYo1cctt9p0ts2/Kd+W8cp58pdnS+kHQutjqdJbLGf+9v9R2x/28afOMeOO2GWNfRtw1K+/d5xHa1vPgz6bJOLU4cuny1+9jz474skc9udMkVtHOJjnEc4l1dPU09WsX0tSmpSeFtO9b1nwtWZifiyxMWjNZiY7p/nu7XyXSAAAAAAAAAAAAAAAAAAAAAAAAAAA+mHDm1GSMWDFlzZbfdx4cdsuS3LflSkWtPj4eCt7006zfUvXTpHG97RWseNrTER8UTMRGZmIjv5dvPDZdN2J7WavbyPAeI173SdRh+qR6t51dsER+cxu5Wr0/0No5i/SOyzMZzGnf66d3HdoxqSxTtGjHHUr7pzxjPLLa9D9EPabU1i+rzcO4dExEzjy576jPHpju6XHkwTMeP+8xz26xvMcfaPpr0TpTMaNNq2qeVqaddLTns3616akRPL/K4ccTunFbbNKs4iLW78YjxzO/Hu/fG3cP8AoY0NJi3E+NanURynyWh0+PS7Tt/Nlz21U2iZ25Rix2232nfnXi7T9O9eYmNk2DS0uOL7Rq31s8sxTTjRiJjf/wBpaPhicNtut/TSI75mZ7N+N3Hfuy3LQ/Rp2O0U1t/sv63eu21tdnzaiszHjbFNq4Lb+i2KYjwiHC2j6VdN7REx/i/qKznds+nTSmPC+LakY7YvE9sywW2rXtu62PZiI/ON/wCbcdNw/Q6KsU0Wj0ujpWNq00unw4KxHoiuKlYiPCdo5x18HD1dp2jXnOvr62taZz1tbUvqTnxva0/zcwze1pmZmZz2zM/DMz7uzwXe3t67/wCer2MKoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC80HD9XxHL5LTY+9MTHfyzvGHFEzMRbJbae70n7Mb3ttPdraYmI19o2rR2WnX1bxG6erWN97zHKtfyzOKxzmIJmtY35j85ndndHGd3fj4ujcK4BpeG7ZbxXUavbac1q/Zxz4+QpO/cnrHfne8xMxvWLTV5jbOktbas0jOlo53UrM5t/8yYx1s8erjqxiOMx1mpfVm26N1ezt8flw8We/z/PY5zHn5+M94IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQy4cOoxWw58dM2O8bWpkrFq+Mb7TE89p5TG0xzmJiYiV6al9K0X072pes5i1ZmJjny5dsTunmtFpiazExExnE848d3w48Wh8V7K5MXezcNm2bHEWtbTWn+LWN9/4V528pWI3+xaIyRER3ZyWnaPQ7J0xS+NPaoilt0RrVj0J3Y9OserM9sejnjFY3timtE7rxETGMWjMRMcN8cuW+ffjc061bUtNL1tS8TNbVtE96to6xO/OJj18/wDTuRMWiJrMTExumJjExymO3Mc44+M783H3gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAG0egAMz293u7AHyzafBqK9zUYMOen4M2OmWvo+7eto6cui9NXU0p62nqX07dtL2pO7hvrMSmJmOEzHhOGA1fY/sxrYmNRwHhlpn+bHpseDJ6OWXBGLJHLbaO9ERMcvS6Oj030voY+q6R2uMcr61tWv4NWb1/t8WWNfViYxqXxHbOfjxj8pazqfoo7IZ5nyWm1uj33n/AHfXZrxEzO+22q+szt6IiY2iNt3V0vpj03p46+roa/D/AFdn06zOP/k/VcecskbXrRxtW3jWPju6vH8t+5gtT9C/CrxP1PjGv08+H1jDp9XWPbFPqlp/O+/jvz2jpaX072yuPr9h2bVjn9XqamjPxt9dH9vdjdmckbdbnSs9sRMx8OP85Ne1H0L8Up/9i8Z0GeI/7fBqNLMx7KTqo39s7R6XS0vp3scx/nbBtOnP/h6mlqx8bfUzj3e5kjbaRxpb3TE/nPVn4sPn+iPtZiiZx/7N1O3SMWsmlp9W2fDirz9d9t/Hxb2n9NOhr7r/AOK0u++hFoj/AMu95/JeNs0p4zavjXPDwnOJ5R8exhdR9HPbPTbzfgebJHp0+o0Wp39lcGpyX/KaxPq2b2n9KOgtXdXpClZ/8TS2jS/PU0q1/NkjadCf+0iPGLR5ww+Xst2lw7+V4Dxau3Kf9w1Mx/WuOYn2xy/q3qdL9FXiJp0jsVs9m06X55tu8JXjW0p4alPxQsMvCuKYd/LcN1+Lbr5TR6inzY4bFNs2TU9Tatmv7GvpW8rT2StF6TwtX4x81lal6T3b1tS3otWaz/SYiWxFq2jNZiY7YmJj8k5jlOfDf5IpSAAAAAb9fUAAGf5w8wFa1tadq1m0+isTM/0jeUTMRGZmIjtmcR8ZF9j4VxPN5nh2vy79PJ6PUX3/AE45YL7ZslPX2rZ6Y49fX0q4+NoVm9I43rGP90fNf4+y3aTN5vgPFr+HLQanb+s44hrW6X6Lpnr9I7FXHHO06Wfh10Tq6ccb1j3x+fZ72XwfR32z1G3c4HnpE899Rn0mm2j0zGfUY7cvRFZt6mnqfSboLS9bpDStP/h6evq/npaV498zEd7HO06Ef9pE+EWnyjHxZnB9Ena3LzyV4dpvVl1nft/+Ax5q/wDxf1c/U+mnQ1PUnatXvpodWP8A7Jek/kxztmjHDrT93HmzOn+hfi1tp1XGNBhiZjeMOHPqbRy58rzpq8vR3uu/PZpav072Kufqdh2nUnl9ZfS0on31nWmI92e5SdupypafGYj5/wA/LP6b6F+GUiPrnGtfqJ57/V9Pp9JE+O22S+rtEc9uVonl125ubrfTva7Z+o2HZ9Ls+t1NTWnHd1I0YzHOZjf2Mc7bacYpWPfaefdNf382f030T9kMExObBrdZt1jPrctKz08NL9Xnw3+9PXlMRyc3V+mXTepnqamz6H/y9Ctp+OrOrH5KTterMbrRXwrmfzjDZNL2N7LaOIjT8B4bG3KLZdNTUZI9uXUzmyW5xG+99t+fjLlavTnS+vMzqdI7Xvj1a6s6dczx9DS6lI4zjFd0bolinW1JnfqXnv8AlG7HxbBg02DTVmmnwYcFOX2MOKmKvLpypERtHPltHj+fO1NXU1Z62pqampb7Wpe15+Nsz2c5+WKZmZzMzM9szmfi+7GgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWIm0xWsTNpmKxERMzMzO0RERG8zM8o26kzERMzMRERmZmYiIjjvmd0GP5+fk23hXZbNnmufiE2w4ZiLV08cs9v/aT/wAKJ67c8nPaYpLi7Z0vTTzp7NEal43TqTv06+zj155Z9XPO3BivrVjdWczwmeMR39/hHjnk33Bp8OlxVwafHTFirt3a0jaI5c5metrT/Na0za0xvMzPN53U1dTWvN9W9r2mczNp/KI4RHZERERwiGva3W3zOZzz4xEZ3Z7N/Dl38X1Y1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFYnb/OnsExOJ7ffhiOJcE0XE6zbJSMWoiNq6nFERl6fzxP2clYiOl+dY+7avVu7Jt+vskxFbdfS56V5nq+NZ40nfO+N2ZnMSzaVrVjdO7M7uU5x/JjhO7LnfE+C67hlpnJjnLp95imox1maTz2r5Tr5K0x1rflE7xW94iZen2Tb9n2usRW3U1d3W0rTHWjdv6ucdeI7a8vWis7mxW9b8M57JmOPOOycdscexiercSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABnHBTbfrz69f88PATmfjx7/H4m0fH89/CfV/0j0CPd5/NS9KZI7t61vX0WrFo/paJj+ya2tWc1maz2xMxPhmJiU5nlu8N2fHt/mGPycG4Rm89wvh2b/2ui02T58U/+fju2a7dttPU2vaqR2U19WsfCt4W+svHC9o8LTHlO/3+5Z27LdmrzvbgHBpn1cN0desbfy4Y/wDLr1Z46X6Vrw6S27t/+L1587z/AM8OCY1tWOGpf8U9ue3vfG3Y/stbr2f4V+Wiwx8KQvHTfS8cOkts9+vqT5zKfr9Xj9ZbMds583znsT2TnrwDhn/6tTl6f6+O68dP9Mx/+ktr58da0+c8s/zCY19aN/1lvfKE9h+yMzvPZ/h35YNo/pEwn/8ACDprh/7S2r/zM/nMZT/idb7c/GfmrHYfsjH/APT/AA388O/xtJ/7f6an/wDSW1f+ZMeUH+I1vt2+NvmlHYnsnWd47P8ADPz01J/tMeuf6+zaP/b/AEz/AP1La/8AzbH+I1vt2j3z++U47Hdlq9OAcK6789Hhtzjp96k9PR0584nkpPTfS88ekts92vqR8cWjj8VfrtX/ALy3x/Px7+L717Ldmqfd4Bwb8+G6O3P88MqT0v0rPHpLbv8A/K148ronW1Z46l/xT815j4NwjD5nhXDcP/stDpcfyYo2/LbpDBfbtt1P9TbNqv7e0atvO8o+svPG9p8bT8OOcfyF9TFjxx3cdKY68/s0rWtd56ztERG7Xta1pmbzN5njNpmZn3zOeavWmec+/f55/N9P828FTM7uG7fwx5YNv/Xlv8Nv7BM55R7sx+4IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJ9nP+35z4f0n8j+fzfAynDeD67ido8hj7uGLRFtRk3riiJnnETPO94jnNKRPOaxaa7xLU2rbdDZI9O2bzHo6VZzed0b5jhWsznE24xG7M7kXtWm6Z343Ru38e/hPbMxz3Z3OicM4HouGRF6V8vqY66nLEd+N4jzVYnbFHX7v29pmLXtG0R5na+kNfa5msz9XpT/2VZ9GcTmJtO6bTw47t0TFYlrX1LW4xNY5RymP93bPd8cyzMzvO7QYVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABOZjhMx71LVreJreItS0bWraImto6TExMTExty2mJ5eCYmYmJiZiYnMTE4mJ7YmN8SRMxMb8fHd37mpcU7K4M/ey8PtXTZZ3mcFt/IWn/lnabY5mfCInHvG0RSvXtbJ0xqaeKbTE6lN0fWR/qR7UcL+O63GZm07meuvviLZnlNpxn378bo58ebRNTpdTo8k4dVhvhyR4XjbeJmdrVtvNb1nltaszWfD0R6HR1tPXpF9K9dSs868pxmYmONZiN8xOJiGxExO+OGf5D4MgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+2n0+fV5a4dPivmyW32rSJnaI5TNp6VrHja0xEeMserq6ejSb6t60rHO04zPZEcZmeURmZRMxEZndHDM8M9jeOGdlMWPuZuI28tk2ifq1J2xVnrtkvH2skxPWtZrTrEzkiYmPP7X0xe+abL6FeE6to9K0dtYn1c8pnNueIncw3185im6JnGZ447s7sd87444iW41rWlYpStaUrERWlYitaxEbREVjaIiI5RERtEdHEmZtM2tMzMzmZmZmZmeMzM75me2WvMzM5zM88zxzu+XwwqhAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC31Wj02uxTh1WGmalvC0farPhalq7Xpb10mJnnznfZl0dfV2e/1mleaW7uEx2Wid1o47pjHv3r1tMWjqzNZ7c55e6MdzR+J9lM+Dv5eH2nPjj7U4L7RnrERG/dtO1cu20ztMUvttWK3tG8+g2XpjTvim0xGnbh9ZGfq5nlmN80me3fXO+ZrG6NmNSMxF5xM88bu7wj8sRPZhqN63x3tjyUtS9LTW1L1mtq2jbetq2iJi0eiY8HaiYtEWrMWraM1tExMTHbExumO+GSN8ZjfHbHBFIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArWtr2ilKza1pitYrHeta0ztFYrG8zMztERETvPLqTMViZtMREb5md0RGM5mZ3Y7c/wDRyz4+Hbx822cM7K6nUdzLr7TpcPWcNdp1F67RznlNcUTvvvaJvtEx3KzMS421dMaWnmmzxGtf7c5+qrP5Tf3TFeExad8MdtWI3VxaZjO6MxG7PHdPOOG6eGc7m9aTRaXQ4ow6XDXFWOsxG97+vJed73t6Jtado5RtDzutr6uveb6t7XtPbO6O6tY9Gsd0RHbxa1r2t60544nhiMYxHd29sLliUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAzM8Zyx/EOE6HiNNs+KPKbRtnx7Uz0mOUR3tvtRG8/ZvFqTE793eItG1s22a+y2zpX9Hnp2zOnb7uYxPfWYnvxuZaXms8YxMb4nM8uMd88+c747p0LiXZrXaLvZcH++aeOe+OtvLUrMb75MURadq9Jtjm0Rt3p7kfZj0Wy9K7Pr4pqf5OrPK0x9XPs33b544tEdkZxmdimpW/wDtnvmN89mcx2TjMRPjxjXJ5TtPKY5TE8p36Tyn18tnUjfGY3x2xw+K4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB+fqCIzubBw7s3r9d3cmX/dNNbn5TLX+JaPCceHetp3n+a/cpMc677bTzNq6U2fZ81pP12rH9NJ9GJ3brX313dlYtOd04Vtq0rERxt3ct+OMZifzndOOMY33h/B9Dw2sTgx97N/NqMn280777xFulI22ju0rWPTz3mfO7Ttu0bVM/WXxTO7SpmKRjhmM5tPfaZnsxG5r31JtmJndjhGIjOeUeHGfhjgybUYcz2gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKxO3T/I9ceImJiM5jPZ3MNxHgXD+JRa+TH5HUTMW+s4dq3taI2iclZia5OkRPejvbcq2rO0xvbN0htGy4itvrNON31WpvrGfsz61Jjl1ZxvnMTEzDLXWvHDGJ3TE7448e2MR84honEez2v4fNrxT6zpqzM+XwxNprXntOXH96nSd5jvUjl9raYei2XpPZtpxWZ+q1Z/ovMREz2UvM4t3RutPY2K6lbcN3djnMZxnh3ccx2MFz36cvTv/o6H8/n8/wCb4n4xmPd+/cCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFN/wC8TPo6bf8AUGc4f2f4hxDuXikafT2nnnzb13r6cdOV7+qdq0nef4kdWhtPSWzbN1q9b6zUiP8ATpv39lrb617+No3ZrvhS9603TmZ7McJnlMzujvzv7sYmd64dwDQcP7t+5Go1FZ73l80RaazG23kqfdxxG28TG99+c35Rt57auktp2nNZt9XpTu+rpuiY/wB9vWv2TnFeysMFta1sxjEYxunzmOP892bc9imc/DH8/wCNwIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJnfr49fX16/1E5nt93L4cPcwnEOz/D+Id680+rai0efwxEbzvytlx8qZOs7z9m8xy78cpjobN0ltOzYr1vrdKP8As7zM4jn1bb5r3cax9mWWmrasYmYmvfMZ3b8ZxMx5bo3TwnSOIdneI6LvXpT63giN/KYYnvVjx8pimZvExHOZrF6RH82/KO/s3Smy6+Im31OpO7qam6Jnl1b+rOZ3Rnq2mf6ebPXUrbnFfH5xnGeWcZ345MC6LJjx+Hdn+dwIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZzh/Z/iOvmtpx/VsEx3vLZ4mu8TzjyePlfJvHOsxEUn/ALTnG/P2npLZdnzXrfW6kTMTTTnOPat6tcTumMzaPs7pUtqUrumczv3Rv909nnv4N34f2e4fw+a5Jp9Z1FY89miLRFuW848c70p0+zP2rx+Oebz+09JbTtOa9b6rSmf9PTmYzHLr242/Ks/Za99S1sxExEd3Ht48fyjsZ7flEeEco5Ryc9jz/P5z7+KggAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWJ2n+39evjAnO6Y7cfkw/EOB8O4hvbJh8lm35Z8G2PJPrvyml59M3rafCJrEzvu7N0htOzYil+vT/ALvUzav3d8Wr92YjtiWSuraMb5mMYmJ4cd2+Zz7sxG5pWu7L8Q0nevp4+u4Y3nfFyzVjlzthm0zbr/w5vO+87RE8u/s/S+za0RXU/wAi/wDunNJ8L4jHGfW6vKN8s9dWk7s4nv4fHh8cNctFqWtS9bUvWdrVtE1tWfRMTtMT6tuXjtLqRMTEWiYmJ3xMTmJjtiY3Y7+fLmyRv4b/AAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArvaYisTNrTtFYje0zvttERvMzv4E7szM7o3zPCMYznfjkfz+fzwbFoOzPENZtbNEaLFP8+aJ8rMdZ7uHetvCNvKWxxbflMw5m0dLbNoZrSZ17xndpzHUieWdTfH4YvjmpOrSm/M2nsiImM985xjj3xPDhON10HAeHcPmL0xeWzRER5bUd3JaJjad6V2jHTa0bxate/tvE2mJmJ4O0dI7VtOazf6vTn/s9PNY+9OetbwmcdzXtq2tiOEc4rOM9m/fPu4Z5QzM/5/nj7eTQY5nM/wDX95kEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK7z6fX+fp9c+uROZxjO7sWGs4ZoNfE/WtPS95juxlr9jNX0bZK7TtXwrbenPnWYjaNnQ2vaNmn/K1LVj7E+lSc8fRnMb+cxie9mpaYjdM753xndM754cJnn/0abruyOox/b0GaNRTnvizd3FljnO0VvH8K/Lr3vJdOW/j3Nn6a0rbtppOnbd6dIm9J7ZmM9evPhF/cvGtWd0xjhvjfWIntjfMd/He1XNp8+mvOPUYcmHJG/wBnJWaz+W8RFo5xzrMx656uvp6unq1i+net6zzrMTHGd044T3TvjhLNExPCYnwnP7z/ADsfFkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH1w4M2ovGPBiyZskzERXHS1p58o32ie7HptO0R4zspqamnpVm2petKxHG0xEbuzM757ozM8ozhMYjOccOf/AFj+cm1aHslqcu1tfkrpqcp8ljmuXLbffeLW83SNtpiYnJvzjaI5zyNo6a0qbtmrOrb7domlI74j17b8/Y7czwYratY3VzM8N8TEZ+EzOeUYjxnG/cdFwrQ8PrE6bBWMkR3ZzXjv5rb77zOS3Ou+201pFK7bR3erh7Rtm0bTM/W6kzWZzGnX0dOOz0Y445TbrW72vfUtbd1sxxxGYiOO7HP3xvZBqqZn8sb4id3vBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD5ZsGDU45xajFjzY7TzpkrF49sRPS0da2rNbRPOJidpi+nqamlaL6d7UtH9VZmJ8Jxxjtid0801tNZzEzE904n+fl3NX1vZHSZpm+hy30153/h5I8rhmZnflO/lce/WftZIjwr6OvodNa1MRr0jVj7VcUvy4x6s4jhur3zLPXXmIxaM8d+cTH7TnnujshqOt4LxLQRa2bT2tir/xsP8AFx938VprHepHrvWnhHWdna0Nv2XaZiunqRF5/ov6FpnsjO6Z34xW1uEzwZq3rbhPunj29m/d2djFRMTvt4Tt+bcXxPw/nu9+AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAApvH+cuu/p29HgnHlnt8s9vu5piM84jxmGT0fBuI6/uzg02SMc7fxsn8LFtMbzMWtt34iOczji+09N55NPX27Zdn60amrXrR/RT0r5jliPVmc8LTXtlSbVrxmM8cc/54tu0PZHT4prfXZbai0bTOLHvTFE8pmJtP8AEvG/Tbye/LeNuTi7R01q3zXZ6RpRvxe+LX8Yj1az3T18cmG2vmMVjHfume7u8c57uOW1abT6fSUjHp8OPDjjf7OOkREzO28222m0zMR3ptMzO3OZcjU1dTWt19W9tS3DNpmZiOyOyO6MQx/WZnNpm09v7Yzj4Y8H2n/p8GNS05mZ/nAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE8+vP2+vr/UTnfnh3cv53cPcxGt4Hw3XTNsunimWeuXBtiyT67d2O7efXetpbuh0htWz7qas2r9jU9Ou7lGfSrHdW1V66t43daZjjid8e7PD3e6Gq6zsjqcfevos9NRWN5jFliMeXbflHe38ne0eMzOKs+iJ2iexodNaVsV2jTtpzuzek9emec9XHXrHh15jvZ41q7otExM98YjhxjjEe/PdDWNRpNVpLRXU4MmCZ3iPKUmK2mOsUt92223OazMbOvpa+jrRM6WpTUj/baJmParxjOeE4mGbNJzNZz2Y4fHj28uK3ZEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPvp9LqtXaaabBlz2rt3ox0tbu7+Nrcq1ifCbTEcp69GPV1tLQjraupSkTnHWtETPhHGfh8OJujfM4j993LjOJmM4jhnDZtJ2R1mWIvq81NLXrOOm2bLt023rPkq7+Exe+3jG/2Z5Ov01o0zGjS2tMcLWzSk/GOvMR4VzynmxW1qxmIrNrcuUR8d898Y4c+zbNFwHhuh+3j08ZMscpy6j+LePXWLR5PHO20d6lK2nfrttEcfX6R2vX3W1ZpTf6Gn6Eb+UzHpWjutaY3Zxnepa9rVznG6JiInGOe6ePHlnf4sv/AKcoiI2iI9ERHKGiwRMxnE8eIIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVr1j2x8RNeMeMeaWTzmT37fNKtPUr7NfKEzwn7n6ZQWVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUyUx5a9zJSmSsxG9b0ras7emsxMTty2mfR0TW1qzmtprMcJrMxMe+N7J146sRGc4x4cv+n7Nf1fZjhep71qVvpck7+YmPJzM9JnHbesRE/wAtO5G3L2dLR6W2vSjFrRrV3f6kZtH34xM57bdaexeNa0YiZ60cZzG+N26I3+7f3coavq+yXEMPevp749XSJ3iKzGLLt6Zpee7vtG21clpnpEb9evo9M7NqYjVi+jbhvjr0jj/VWM8Z4zWsRz3cMsatJ45r478+GN+/jG7u3y17Np9Rp7dzPgy4bb9MtLUmfXHeiN45+G7p6erp6sdbT1KXjtraLeWcMkTE8Jjxznyy+K4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACcT4+G/yfXFgzZ7RTBhy5rT/LipbJPPpvFYnaPWpfUppxnUvWkb997RWN3HfMxwROK75mIjtmYx2ceE+7P5S2HS9lOI5+7bPOPSUnaf4k+UyxExHOMeOdt9pnlfJSYmOcRyc3W6Y2XTzGn1te3+30KZ37pvaM4zEb61tHYpbWrWZnGZmOUbs9u/dy3+LZ9H2X4ZpprfNXJq71289O2KbeM+SptWY8dr9+J6TE7buRr9L7Vq5ik10Kzy049LHZ17Zn316s97BOtaZn+mOyIiZ+M+eM8mw0x4sVIx4sdMVI6Ux1rSsb+iKxEejrEzyc2973tNr2te08bWmbT8ZzLHa02mc598zO/tzM8UlVQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFd+noj/X2bSJicconxz80MuPHmpOPLix5cdvvY8lYvS3trbes/0Wre9Ji1LWpaOFq2msx4TExKYtMTms4nuzy8csBquy/C9TG+PHk0mTwtp7fYtPonHki9YjfnMY+5Mz4w6Oj0ttelutautXGMakelEd16zW2fa60dzPXUtiJnE7p3cO3n298z47muarsjrcf2tLlxamv4bT5HLv6Ii02xzHT7U5Kb/h5Opo9NaF8RrUvpW3ZmPTp45jFo8OrPitXWrPHMbszMb4jt7+3ljhva7qdDrdHbbU6XNij8dqT3J5RO9bxvS0del56dd5iHT0to0NaInS1qXzG+ItHWjxrOLR74hlia2x1ZieOd8d/fu8J92cwtWYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXWn0Ws1lorpdNmzc9pmtLdyN94jvZJiKUjfbna0Rt49GLU2jQ0Yzq6tKR2WtHWntxXPWtPdETJaa14z378cozOIiZmZ8OHY2HS9ktflmLarJi0tJjfaLRmy+v7NZjHER6Zyb79Ky5mt0zs9ImNGt9a2/EzH1dO6czm3uivvYra1I4ZtO7lER375nO7w3tj0vZbhemiLZK31d+XPPbbHWY5zFcWOKVmOn3/Ke1y9fpfa9XdWa6NecacZtPja3Wn8PVY7615nlHDdGfO2/wCDPYsOHBSMeHFjxUjpTHSKV9vdrERv69ufju51731LTfUva9p42tM2n4znd2Rwhh605zM5ntnfP554Prv/AJ/n9fgoZn+cfjxUEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKTEWjaYiYnrExEx/SSJmN8Tie2CPHHexmq4HwrV7zl0mKt53+3hicNpmd+c9yK1tad+c2iZ9O/OG7pdIbZo4imtaYjhW/px4R1szEd0TDNGtaN0ZmO+Yns7YnHDG7EY5Ne1PY7HMzOk1lqR1imop3+fo8pjisxH/wCjmdtt+e+3S0unLRiNbQie22naY3ezbO/7/wAOVo192+u/lid35sBqOzfFtNMx9X8vWN9rae0XiY68qW7mXf0ROP1Rv1no6fSux6sb9WdO0/06sTExyjNoiaf3eTN169uPa3eWY/Nh8uLLgvOPNjvhyR1plpbHePXNbRE7evZvUvTUr1tO1b1+1S0Wr8azMfmtyzy7eXxfLePT6/8AP+nVYV33/wA/MAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE8ePJlvGPFjvkvb7tMdLXtPhyrWJmfyhW1q0ibXtWtY42tMViPGZmIgndvndHby7OPDizGn7OcW1Fq/7tOCszzvqLeSiI6b2pvOWem3LHaY9DR1ek9i0on/ADfrJj+nSibzPhbdT43hSdSkZ9KJxyjfnw5b+W/E8eDPabsbSJidXrLWjbeaaekxz9EZMs2229MYt/GNujnavTlsTGhoxE8ItqWzu76Uxn8fdicKTrxyiJmftZ+M4358J9+OOw6XgPCdLtamlx3vH8+fvZpmfTteZpE8o2mtImN9o2hztXpHbNaJi2tatZ/p08acY7M1xaY7pme9jnVtM77TjsiMR7pzFv8AntZfasREViK+qsRER4dI5eEdIiPa0pmZ4zM+O9W9omN08+/vUQxgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK16x7Y+ImvGPGPNLJ5zJ79vmlWnqV9mvlCZ4T9z9MoLKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK7zy9XKP8AP9eotN5mMbt75ZMWLLHdy48eSv4clK3j+lomFq3vSc0tak9tbTWfjExJFprOYnHhMx+cTE59/dw3MRqOzvCdTM2nTRhtP82ntbFEdemOJ8lv/wCDeekzMN7S6U23SjEa03js1Yi87+20x157s23csMlNW8TEZznMb4iZ7effHNhtR2NpM76bW2pG3Kmoxd/eeu/lMfc2jpG3kreneW9p9OW4a2hWe22naa/2262fxwyfXYnExx5x8p88sLqOy/FsO80x4tTEb88GWu87f8uXyUzPqr3p9Df0ul9j1N1r20Z4f5lJmPjSLxHjOIXjV0p3ZtE9/b2RiLRjPPPNh82h1um3nPpdRhrHW2TDkrXfeY+9NYr4enn8d3T2jQ1d2nrad57K3rM/DOe3kvGJndNeP2oz8+HctN538I/1/v6PDrHWeXXNu/ny/fPuFQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXGLR6zURE6fS58289aYr2rynn9qK93+s/1Yr6+hpf6utp6ftXrE8M8M59xMxX1piO3MxnHhnv/AJiWZ0/Zji2fab4semrMb758ld/XHcxeUvEx6LVryaWr0tsennq3tqznGKUn9VurXHszZS2pSN8TNo7ondwnfnEc+3lLM6fsdWNravWTaPGmnpFf/wALkm3smJwxty589mhq9OTjGjoRE/a1bZ/srjf9/d2SpOtGJ6tc8MTPb2Y3T44n4Y35rT9nOE6eYt9X8vaJ5TqL2y1/93vGK0e9S3taGr0pturGPrfq47NKsUn8W+8e60d7HOtqcJxEccRmOMduc/nuZjHhxYa93Dix4q/hx0rSP6ViIaNr3vOb3tee21ptPxmZY5vad+eznPLtzM5976f5/myqJnPnn+bvyBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABvPpEzMzxmZ8QQCcz2zu4dyxzcM4dqJmcuj017W63nDSLb+nvVjvTt4Tvu2KbXtOniKa+rWI4V69pr+GZmv5LRe0f1W+M/Ke5i8/ZbhOXnjrm08+jFltau+3WYzRl5b+FbViPCPCNzT6Y2ynrTp6sf76RE+ETpzT84lk+vtu3R74/+1iPKWJzdjY2mdPr7b+FM+HePHrel948Pu4/hs3KdOzujV2eMfa074n8M1xP4o/PdaNeOcb8/wBOeHv+fYxmTspxWkz3I0+aPDuZu7vzn/tq4/V1naPZG7br0xsdsZnVp29bTzjv9C1vLPcvGrSc4z8O/wDksZm4PxTTztl0Oo5dbY8flq/nfD36f3bdNu2PVjNdo0ozytb6u34dTq2/Lfxjcv1qzu60c+eOG/nieCwvjyY52yY70n/npavTw+1Ec/U2K3pb1b1t7NonymUxv4YmI4zmMfFDf47LJxvxu+MY+PADG7P8+HE3/wCvpEAAAAAAAAAAAAAAAAAAAAAAAAKbx/nT+vQTiYjMxjkqGJjj/wA/DiCMTHGMJUpfJPdpS959FaWt8IlFrVrGbWrWM49K0R5zH83E7ozOMeMMhh4PxTPMeT0Gp2mdotfHOGn683k6cvH7XJram27Jp+vtGlGOVbde34ada35Im1YnHWjPdOfLLJY+yvFrzHfrp8MT/wBpmi23t8jGX+3t35w1b9MbHXPVnU1PZpMZ/HNfzVtq0jEYnMRy5/HHeymDsbyidTruf81MGHlHsyZL89/XjjZp6nTm+Y0tn3cp1L7/AH1rH/qUnXrmcVnHf/O3w3cZZTD2U4VinfJGfUz02y5ZrT2xGGMVt/T3pnfb0bw1NTpjbL7qzp6XsUiZ+N5v5K/XzMb8VxPKMzMd8zn3+G6IZbDwzhuDacWh09bRt3beSra0bTvv3rxa0z05zMzy6tO+2bVqZi+0asxPGOvNaz92uIx3Ywx21LTn0p4zzmJx7sRiezG5fdOjWYwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFa9Y9sfETXjHjHmlk85k9+3zSrT1K+zXyhM8J+5+mUFlQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFYnYWrbq/z+b1e9/p4z4f+fo28fVsRM5mZ7UbRFo2tETG20xMbxMc+UxO+/X2epMTMTmJmJ7YnEpm08Ph/OGe+IiVhl4VwzNvOTQaWZmYmbVw0pefbakRaZ9czMx7NojYptm16fqbRrREboib2tER2RFpmI+CfrLxwmfGZmZ/OcfkscnZvg+Tf/dZxzPjjzZo239ETea7ejess9OlNup/23W9qlJ/PqxP5p+t1O3Puj9ohj8nY/QW3nFqdVjmYnlacOSvP1eSpbb0xNp32jm2a9N7RHr6WjbvrF6z+drR+XuXjaLROZrWcdmY/eVpfsbP8mv5f8+n/p0y+hnr079rZvw6v7TT91o1451/OP8AhZ5OyGvjzeo0l49FrZccz6ojyV4/raI9cdWevTezT62nr18IpaPj16z+S8atcZ39nDn/ADmtL9l+MV6YcV/T3NRij+15pb+0f15Tnr0vsM8dS9ezradvz6vWiD62k8/jEra3AOMUiZnQ5JiPw2xXn9NbzM/lE8tmSvSWxW4bRWPai9fzmsRHv8l+tX7X5ePLjy3ZiPctr8K4njje3D9bt/y6bLaP61rMf3Zq7XsluG06EeOrSvfzmJR1qfarPhaPmt76bU4/v6fPSI337+LJXbb21j899tmWurpW9XV07ezes+UpiYnhMTjjic4fGa3jrS0Rv12n/py58ue0etbrV7Y+MfPzwtjhv4+Py592VOk7T/n+bwn9uP7fz5pxjjP5T++Pyz5Kb+nl7dhG7fvnu3cfz3K+P+f5/f8AIQpv6p67f+nTl6Z29m4KgAAb7/lyE4meETPuP8/z/UJx2z8I+ckbz4T/AJ7P85k4jjMG7nM/DP7wr3b8tqWnn+Gf+nP/AD0SjNd+bRHvj95j+eKH1rptRf7mnz335x3cWS0T+cVmFZ1dKsZtqadfG9Y85/MmYjjMR4rmvCuJ3+7w/WzHpnTZoj1c5pEf3Yp2vZa8dp0O+PraTPwi0yr16fbr+KPmua8A4vbbbQ5IifG1sddvbFrxMf0YbdJbFXjtFZ9mLW8qzBF6b/SzjsjPyXNOy/GLzG+DHTffnfPi25e7a07evbb+ksdultijhqWt7Onb94iPz/NWdWkZ35xnlOfDfz/LtldY+yHEbbeUz6THv4RfNe0e2IwxX+lp68t2G3TezR6unrWnvrSsfGbzP9qPra4zie7hv3ePu8V7XsbMT/E18f8AgwT/APNl/wBInfrEbNe3Tv2dm/Fq/KiProxmKTPPfOI3ct0T+3Nd4+x+hiYnJqdVeY69zyWOJ/rjvO3q3/Nht05tM7qaWjWP93Xt7916xn3K/wCItviKxET8fjun453bu9f4+zXB6RETpZyT42yZs0zPtrF609XKsTtHt31rdK7dacxqxXh6tKRjHZmsz+asa945+GIiMe/GZ+K+x8J4ZhmJx6DSxaJiYtbDTJaNt9trXraYnnznfeWvfbdrv620a2J4xF7VifGKzEfkrOrqT/VOOyJmI/KY/nFf1itdorWIiOURG0RHqjaI2jfm15mZnMzMz2zOZUmczn5/vlLfp6onxnx/P/PFC0WxwiPDM/8ATOOeO8md9vVGwraetOeCggAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABWvWPbHxE14x4x5pZPOZPft80q09Svs18oTPCfufplBZUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE5ntn4ggABSa1nrET7YhOZjhMwIThxT1xY59tKz8YT17xwtb8U/NOZ7Z+MoTpdLad7abTzPpnDjmf71WjW1o4aupHhqWj9zrW+1Pxl850Ght97RaSfbpsM/Gi0bTtEcNfWjw1b/wD2yevf7dvxT80Z4bw6eug0U7dN9Lgnb/8ABrf4vao4bTtEf/W1P/tjr3+1b8U/NT/ZnDf/AMn6H/8AVNP/APsz/F7X/wDdO0f+dqf/AGx17/at+Kfmf7M4bHTh+hj/APtNP/8Asz/F7X/907R/52p/9sde/wBq34p+av8As3h3/wB4aL/9Vwf/ALM/xe1Tx2naJ/8Aran/ANsde/27fin5pRoNDX7ui0kezTYY+FFZ2naJ46+tPjq3n/1HXv8Abt+KfmnGk0tfu6bT19mHHHwqj67Wnjras/8A1L/NHWt2z8ZfSMOGOmLHHspWP9FOveeN7T96fmZntn4ynFax0rEeyIhGZnjMz70KoAATmcYzOOzkbz6RAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSyecye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJrxjxjzSy+cye/b5pVp6lfZr5QmeE/c/TKCyoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACtese2PiJjjHjHm//2Q=="
                    })
                ]
            })
        ]
    });
};
$1f30f250cfe8e844$var$LearnHeroMobile.defaultProps = {
    width: "375",
    height: "365",
    viewBox: "0 0 375 365",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var $1f30f250cfe8e844$var$EmptyLearn = function EmptyLearn(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M258.046 28.402c-.488-3.461-3.449-6.139-7.035-6.139h-.057c-3.029 0-5.877-1.498-7.523-4.028-2.11-3.234-5.764-5.379-9.906-5.379h-.136C231.256 5.436 224.425 0 216.312 0c-8.114 0-14.513 5.106-16.873 12.175-8.182.273-11.597 5.073-11.597 11.348 0 1.747.408 3.404 1.112 4.879h69.104-.012Z",
                fill: "#ECEDFC"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M.008 124.073c.326-2.316 2.308-4.108 4.708-4.108h.038c2.028 0 3.934-1.002 5.035-2.695a7.912 7.912 0 0 1 6.629-3.6h.091c1.428-4.966 6-8.604 11.429-8.604 5.43 0 9.712 3.418 11.292 8.148 5.475.183 7.76 3.395 7.76 7.594 0 1.17-.273 2.278-.744 3.265H0h.008Z",
                fill: "#E5E6FB"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_5221_7036",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "89",
                y: "0",
                width: "132",
                height: "135",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M191.463 99.929c-35.339 0-63.983-28.644-63.983-63.984 0-12.987 3.904-25.064 10.559-35.158-28.219 8.395-48.792 34.51-48.792 65.44 0 37.727 30.586 68.313 68.313 68.313 28.259 0 52.494-17.154 62.891-41.61-8.718 4.45-18.55 6.999-28.988 6.999Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_5221_7036)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M151.45 160.332c41.974 0 76-34.026 76-76s-34.026-76-76-76c-41.973 0-76 34.026-76 76s34.027 76 76 76Z",
                        fill: "#4427FA"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M141.699 114.088c32.299 0 58.482-26.183 58.482-58.481 0-32.299-26.183-58.482-58.482-58.482-32.298 0-58.481 26.183-58.481 58.481 0 32.299 26.183 58.482 58.481 58.482Z",
                        fill: "#334EF5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M133.527 87.487c24.098 0 43.634-19.535 43.634-43.633 0-24.099-19.536-43.634-43.634-43.634S89.894 19.755 89.894 43.853c0 24.099 19.535 43.634 43.633 43.634Z",
                        fill: "#2275F0"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M132.11 62.768c18.3 0 33.135-14.835 33.135-33.135 0-18.3-14.835-33.135-33.135-33.135-18.299 0-33.134 14.835-33.134 33.135 0 18.3 14.835 33.135 33.134 33.135Z",
                        fill: "#119CEB"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M126.203 39.261c12.557 0 22.737-10.18 22.737-22.737 0-12.557-10.18-22.737-22.737-22.737-12.557 0-22.737 10.18-22.737 22.737 0 12.558 10.18 22.737 22.737 22.737Z",
                        fill: "#00C3E6"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M215.353 57.932c-8.415 2.953-10.802 5.34-13.756 13.756-2.953-8.416-5.34-10.803-13.755-13.756 8.415-2.953 10.802-5.34 13.755-13.756 2.954 8.416 5.341 10.803 13.756 13.756ZM160.21 30.703c-5.159 1.821-6.635 3.278-8.436 8.436-1.82-5.158-3.277-6.635-8.435-8.436 5.158-1.82 6.635-3.277 8.435-8.435 1.821 5.158 3.277 6.635 8.436 8.435ZM72.354 96.631c-5.158 1.82-6.635 3.277-8.435 8.436-1.82-5.159-3.277-6.635-8.436-8.436 5.159-1.82 6.636-3.277 8.436-8.435 1.82 5.158 3.277 6.635 8.435 8.435Z",
                fill: "#FFAF00"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M185.435 153.17c-.87-6.17-6.15-10.944-12.542-10.944h-.101c-5.401 0-10.479-2.67-13.412-7.181-3.762-5.765-10.276-9.589-17.659-9.589h-.243c-3.803-13.229-15.981-22.919-30.445-22.919-14.463 0-25.872 9.103-30.08 21.706-14.585.485-20.674 9.042-20.674 20.228 0 3.116.728 6.069 1.983 8.699h123.193-.02Z",
                fill: "#D0D2F8"
            })
        ]
    });
};
$1f30f250cfe8e844$var$EmptyLearn.defaultProps = {
    width: "259",
    height: "154",
    viewBox: "0 0 259 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $1f30f250cfe8e844$var$ArticlesIcon = function ArticlesIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M14 17H9m8-4H9m-6 8h16a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2m5-3h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z",
            stroke: "#434CE5",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
$1f30f250cfe8e844$var$ArticlesIcon.defaultProps = {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $1f30f250cfe8e844$var$VideosIcon = function VideosIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M11 15v4m-4 0h8M9 5.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25A.751.751 0 0 1 9 10.249V5.75ZM3 1h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2Z",
            stroke: "#434CE5",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
$1f30f250cfe8e844$var$VideosIcon.defaultProps = {
    width: "22",
    height: "20",
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $1f30f250cfe8e844$export$8f9baa9a7ed3b961 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $hE6rp.useNavigate)();
    const [items, setItems] = (0, $81g6h.useState)([]);
    const [loading, setLoading] = (0, $81g6h.useState)(false);
    const [error, setError] = (0, $81g6h.useState)(null);
    const [selectedTabs, setSelectedTabs] = (0, $81g6h.useState)([
        "ALL"
    ]);
    const handleNavigate = (0, $81g6h.useCallback)((documentId)=>{
        navigate(`/learn/${documentId}`);
    }, [
        navigate
    ]);
    const handleTabClick = (0, $81g6h.useCallback)((tabKey)=>{
        setSelectedTabs((prev)=>{
            if (tabKey === "ALL") return [
                "ALL"
            ];
            const isAlreadySelected = prev.includes(tabKey);
            if (isAlreadySelected) {
                const newTabs = prev.filter((t)=>t !== tabKey);
                return newTabs.length === 0 ? [
                    "ALL"
                ] : newTabs;
            }
            const newTabs = prev.filter((t)=>t !== "ALL");
            return [
                ...newTabs,
                tabKey
            ];
        });
    }, []);
    const fetchItems = (0, $81g6h.useCallback)(()=>{
        let mounted = true;
        setLoading(true);
        setError(null);
        let mediaTypeFilter;
        if (!selectedTabs.includes("ALL") && selectedTabs.length === 1) mediaTypeFilter = selectedTabs[0];
        (0, $ghfIB.learnManager).getItems(0, 20, mediaTypeFilter).then((resp)=>{
            if (!mounted) return;
            setItems(resp.items);
        }).catch((e)=>{
            console.warn("[LearnPage] failed to load items", e);
            if (mounted) setError("Failed to load content. Please try again.");
        }).finally(()=>{
            if (mounted) setLoading(false);
        });
        return ()=>{
            mounted = false;
        };
    }, [
        selectedTabs
    ]);
    (0, $81g6h.useEffect)(()=>fetchItems(), [
        fetchItems
    ]);
    const renderContent = ()=>{
        if (loading) return /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$LoadingContainer, {
            role: "status",
            "aria-live": "polite",
            children: /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$LoadingText, {
                children: "Loading content..."
            })
        });
        if (error) return /*#__PURE__*/ (0, $iKObn.jsxs)($1f30f250cfe8e844$var$ErrorContainer, {
            role: "alert",
            "aria-live": "assertive",
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$ErrorTitle, {
                    children: "Unable to Load Content"
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$ErrorText, {
                    children: error
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$RetryButton, {
                    onClick: fetchItems,
                    children: "Try Again"
                })
            ]
        });
        if (items.length === 0) return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$EmptyGraphicWrapper, {
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$EmptyLearn, {})
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$EmptyTitle, {
                    children: format("learn.empty.title")
                }),
                /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$EmptySubtitle, {
                    children: format("learn.empty.subtitle")
                })
            ]
        });
        return /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$ItemsGrid, {
            role: "list",
            "aria-label": "Learning content items",
            children: items.map((item)=>/*#__PURE__*/ (0, $iKObn.jsx)((0, $83bcb0904afdd6f8$export$44e965a712d5fdba), {
                    item: item,
                    onNavigate: handleNavigate
                }, item.documentId))
        });
    };
    return /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($1f30f250cfe8e844$var$HeroSection, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($1f30f250cfe8e844$var$HeroSvgWrapper, {
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$HeroSvgDesktop, {
                                "aria-hidden": true,
                                children: /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$LearnHeroDesktop, {
                                    preserveAspectRatio: "xMidYMid slice",
                                    focusable: false
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$HeroSvgTablet, {
                                "aria-hidden": true,
                                children: /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$LearnHeroTablet, {
                                    preserveAspectRatio: "xMidYMid slice",
                                    focusable: false
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$HeroSvgMobile, {
                                "aria-hidden": true,
                                children: /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$LearnHeroMobile, {
                                    preserveAspectRatio: "xMidYMid slice",
                                    focusable: false
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$HeaderContainer, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $8CNE2.PageHeader), {
                            title: format("tabbar.learn")
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($1f30f250cfe8e844$var$HeroContent, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$HeroTitle, {
                                children: format("learn.hero.title")
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$HeroSubtitle, {
                                children: format("learn.hero.subtitle")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$EmptySection, {
                as: "div",
                children: /*#__PURE__*/ (0, $iKObn.jsxs)($1f30f250cfe8e844$var$EmptyContent, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$TabsRow, {
                            children: [
                                {
                                    key: "ALL",
                                    label: format("learn.tab.all"),
                                    Icon: undefined,
                                    variant: "all"
                                },
                                {
                                    key: (0, $6cSBm.MediaType).ARTICLE,
                                    label: format("learn.tab.articles"),
                                    Icon: $1f30f250cfe8e844$var$ArticlesIcon,
                                    variant: "default"
                                },
                                {
                                    key: (0, $6cSBm.MediaType).VIDEO,
                                    label: format("learn.tab.videos"),
                                    Icon: $1f30f250cfe8e844$var$VideosIcon,
                                    variant: "default"
                                }
                            ].map((tab)=>/*#__PURE__*/ (0, $iKObn.jsxs)($1f30f250cfe8e844$var$TabButton, {
                                    variant: tab.variant,
                                    active: selectedTabs.includes(tab.key),
                                    onClick: ()=>handleTabClick(tab.key),
                                    children: [
                                        tab.Icon ? /*#__PURE__*/ (0, $iKObn.jsx)($1f30f250cfe8e844$var$TabIcon, {
                                            "aria-hidden": true,
                                            active: selectedTabs.includes(tab.key),
                                            children: /*#__PURE__*/ (0, $iKObn.jsx)(tab.Icon, {})
                                        }) : null,
                                        tab.label
                                    ]
                                }, tab.key))
                        }),
                        renderContent()
                    ]
                })
            })
        ]
    });
};
const $1f30f250cfe8e844$var$HeroSection = (0, $5UMQ1.default).div`
	width: 100%;
	position: relative;
	overflow: hidden;
	display: block;
	padding: 0;

	/* Mobile: smaller height */
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		min-height: var(--learn-hero-height, 250px);
	}

	/* Tablet: medium height */
	@media (min-width: 501px) and (max-width: 1199px) {
		min-height: var(--learn-hero-height, 380px);
	}

	/* Desktop: default height */
	@media (min-width: 1200px) {
		min-height: var(--learn-hero-height, 300px);
	}
`;
const $1f30f250cfe8e844$var$HeroContent = (0, $5UMQ1.default).div`
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	z-index: 2;
	padding: 0 16px;
	width: 100%;
	max-width: 100%;
	box-sizing: border-box;

	/* Mobile: responsive padding and max-width */
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding: 0 20px;
		max-width: 100%;
	}

	/* Tablet: max-width for better readability */
	@media (min-width: 501px) and (max-width: 1199px) {
		max-width: 720px;
		padding: 0 24px;
	}

	/* Desktop: larger max-width */
	@media (min-width: 1200px) {
		max-width: 1392px;
		padding: 0 24px;
	}
`;
const $1f30f250cfe8e844$var$HeroSvgWrapper = (0, $5UMQ1.default).div`
	position: absolute;
	inset: 0;
	z-index: 0;
	pointer-events: none;
	display: block;
	svg {
		width: 100%;
		height: 100%;
		display: block;
		transform-origin: center;
		transform: translateY(0%);
	}

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		svg {
			/* shift the SVG upward on tablet to mimic background-position: center top */
			transform: translateY(-12%);
		}
	}
`;
const $1f30f250cfe8e844$var$HeroSvgDesktop = (0, $5UMQ1.default).div`
	display: none;
	width: 100%;
	height: 100%;
	@media (min-width: 1025px) {
		display: block;
	}
`;
const $1f30f250cfe8e844$var$HeroSvgTablet = (0, $5UMQ1.default).div`
	display: none;
	width: 100%;
	height: 100%;
	@media (min-width: 521px) and (max-width: 1024px) {
		display: block;
	}
`;
const $1f30f250cfe8e844$var$HeroSvgMobile = (0, $5UMQ1.default).div`
	display: none;
	width: 100%;
	height: 100%;
	@media (max-width: 520px) {
		display: block;
	}
`;
const $1f30f250cfe8e844$var$HeroTitle = (0, $5UMQ1.default).h1`
	margin: 0;
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 24px;
	line-height: 1.2;
	color: ${(0, $kKnoQ.colors).black};
	font-weight: 300;
	letter-spacing: 0.2px;
	max-width: 100%;
	word-break: break-word;
	width: 100%;

	/* Mobile: smaller font size */
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		font-size: 20px;
		line-height: 1.3;
	}

	/* Tablet: medium font size */
	@media (min-width: 501px) and (max-width: 1199px) {
		font-size: 28px;
		max-width: 720px;
	}

	/* Desktop: larger font size */
	@media (min-width: 1200px) {
		font-size: 30px;
		max-width: 900px;
	}
`;
const $1f30f250cfe8e844$var$HeroSubtitle = (0, $5UMQ1.default).p`
	margin: 12px 0 0 0;
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 24px;
	line-height: 1.4;
	color: ${(0, $kKnoQ.colors).black};
	font-weight: 300;
	max-width: 100%;
	letter-spacing: 0.2px;
	width: 100%;
	word-break: break-word;

	/* Mobile: smaller font size and adjusted spacing */
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		font-size: 18px;
		line-height: 1.5;
		margin-top: 8px;
	}

	/* Tablet: medium font size */
	@media (min-width: 501px) and (max-width: 1199px) {
		font-size: 26px;
		max-width: 720px;
	}

	/* Desktop: larger font size */
	@media (min-width: 1200px) {
		font-size: 30px;
		max-width: 1100px;
	}
`;
const $1f30f250cfe8e844$var$HeaderContainer = (0, $5UMQ1.default).div`
	position: absolute;
	top: 24px;
	left: 24px;
	z-index: 3;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		top: 12px;
		left: 12px;
	}
`;
const $1f30f250cfe8e844$var$EmptySection = (0, $5UMQ1.default).section`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0px 88px 88px 88px;
	box-sizing: border-box;
	background: transparent;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 32px 12px;
	}
`;
const $1f30f250cfe8e844$var$EmptyContent = (0, $5UMQ1.default).div`
	max-width: 960px;
	text-align: center;
`;
const $1f30f250cfe8e844$var$EmptyGraphicWrapper = (0, $5UMQ1.default).div`
	display: block;
	margin: 0 auto 20px auto;
	width: 220px;
	max-width: 60%;
	svg {
		width: 100%;
		height: auto;
		display: block;
	}
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		width: 160px;
		margin-bottom: 16px;
	}
`;
const $1f30f250cfe8e844$var$EmptyTitle = (0, $5UMQ1.default).h2`
	margin: 0 0 8px 0;
	font-family: ${(0, $bl9tw.fonts).header};
	font-size: 24px;
	line-height: 1;
	font-weight: 700;
	color: ${(0, $kKnoQ.colors).black};
`;
const $1f30f250cfe8e844$var$EmptySubtitle = (0, $5UMQ1.default).p`
	margin: 0;
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 16px;
	line-height: 1.5;
	color: ${(0, $kKnoQ.colors).black};
	font-weight: 400;
	font-style: normal;
`;
const $1f30f250cfe8e844$var$LoadingContainer = (0, $5UMQ1.default).div`
	width: 100%;
	text-align: center;
	padding: 80px 20px;
`;
const $1f30f250cfe8e844$var$LoadingText = (0, $5UMQ1.default).p`
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 16px;
	color: ${(0, $kKnoQ.colors).grey50};
	margin: 0;
`;
const $1f30f250cfe8e844$var$ErrorContainer = (0, $5UMQ1.default).div`
	width: 100%;
	max-width: 500px;
	margin: 40px auto;
	padding: 24px;
	background: ${(0, $kKnoQ.colors).rejection10};
	border: 1px solid ${(0, $kKnoQ.colors).rejection25};
	border-radius: 12px;
	text-align: center;
`;
const $1f30f250cfe8e844$var$ErrorTitle = (0, $5UMQ1.default).h2`
	font-family: ${(0, $bl9tw.fonts).header};
	font-size: 20px;
	font-weight: 700;
	color: ${(0, $kKnoQ.colors).rejectionDark};
	margin: 0 0 8px 0;
`;
const $1f30f250cfe8e844$var$ErrorText = (0, $5UMQ1.default).p`
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 14px;
	color: ${(0, $kKnoQ.colors).rejectionDark};
	margin: 0 0 16px 0;
	line-height: 1.5;
`;
const $1f30f250cfe8e844$var$RetryButton = (0, $5UMQ1.default).button`
	padding: 10px 24px;
	background: ${(0, $kKnoQ.colors).primary};
	color: ${(0, $kKnoQ.colors).white};
	border: none;
	border-radius: 8px;
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: background 0.2s ease;

	&:hover {
		background: ${(0, $kKnoQ.colors).primaryDark};
	}

	&:focus {
		outline: 2px solid ${(0, $kKnoQ.colors).primary};
		outline-offset: 2px;
	}
`;
const $1f30f250cfe8e844$var$TabsRow = (0, $5UMQ1.default).div`
	display: flex;
	gap: 30px;
	margin: 40px 0 40px 0;
	flex-wrap: wrap;
	justify-content: center;
`;
const $1f30f250cfe8e844$var$TabIcon = (0, $5UMQ1.default).span`
	display: inline-flex;
	width: 16px;
	height: 16px;
	margin-right: 8px;
	align-items: center;
	justify-content: center;
	color: ${(props)=>props.active ? (0, $kKnoQ.colors).white : (0, $kKnoQ.colors).black};
	transition: all 0.2s ease;
	svg {
		width: 100%;
		height: 100%;
		display: block;
		${(props)=>props.active ? "filter: brightness(0) invert(1);" : "filter: brightness(1) invert(0);"}
	}
`;
const $1f30f250cfe8e844$var$TabButton = (0, $5UMQ1.default).button`
	border: 1px solid ${(props)=>props.active ? (0, $kKnoQ.colors).primary75 : (0, $kKnoQ.colors).primary25};
	background: ${(props)=>(0, $49eb052a898fd102$export$e963f6cee9e742e7)(props.active)};
	color: ${(props)=>props.active ? (0, $kKnoQ.colors).white : (0, $49eb052a898fd102$export$739ce4756621745d)(props.active, props.variant)};
	padding: 8px 14px;
	border-radius: 20px;
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		border-color: ${(0, $kKnoQ.colors).primary};
	}

	&:focus {
		outline: 2px solid ${(0, $kKnoQ.colors).primary};
		outline-offset: 2px;
	}
`;
const $1f30f250cfe8e844$var$ItemsGrid = (0, $5UMQ1.default).div`
	display: grid;
	/* Desktop: 4 fixed-width cards (270px) centered */
	grid-template-columns: repeat(4, 270px);
	gap: 48px 40px;
	margin-top: 8px;
	justify-content: center;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		/* Tablet: 2 columns */
		grid-template-columns: repeat(2, 270px);
	}
	@media (max-width: 520px) {
		grid-template-columns: 1fr;
		justify-content: stretch;
	}
`;



var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $hE6rp = parcelRequire("hE6rp");

var $ghfIB = parcelRequire("ghfIB");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");
const $4130d988bf8cb7b5$export$b872f0fcdfaf46f6 = (contentType, contentId, percentValue = 0)=>{
    (0, $ghfIB.analyticsService).trackEvent({
        category: (0, $auPqo.AnalyticsCategory).CONTENT,
        action: "contentViewed",
        params: [
            contentType,
            contentId,
            percentValue
        ]
    });
};


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");
var $ffbb4190df1d0c54$exports = {};
$ffbb4190df1d0c54$exports = JSON.parse('{"v":"5.6.5","fr":30,"ip":0,"op":22,"w":32,"h":32,"nm":"thumbs-up","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"thumbs-up","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[16,16,0],"ix":2},"a":{"a":0,"k":[12,12,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":0,"s":[{"i":[[0,0],[0,0],[0,1.104],[0,0],[-1.104,0],[0,0]],"o":[[0,0],[-1.104,0],[0,0],[0,-1.104],[0,0],[0,0]],"v":[[-4.913,9.994],[-7.913,9.994],[-9.913,7.994],[-9.913,0.994],[-7.913,-1.006],[-4.913,-1.006]],"c":false}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":6,"s":[{"i":[[0,0],[0,0],[0,1.104],[0,0],[-1.104,0],[0,0]],"o":[[0,0],[-1.104,0],[0,0],[0,-1.104],[0,0],[0,0]],"v":[[-4.913,9.994],[-7.779,10.576],[-9.779,8.576],[-10.947,1.35],[-8.947,-0.65],[-4.913,-1.006]],"c":false}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":12,"s":[{"i":[[0,0],[0,0],[0,1.104],[0,0],[-1.104,0],[0,0]],"o":[[0,0],[-1.104,0],[0,0],[0,-1.104],[0,0],[0,0]],"v":[[-4.913,9.994],[-7.808,10.083],[-9.808,8.083],[-9.618,1.221],[-7.618,-0.779],[-4.913,-1.006]],"c":false}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":16,"s":[{"i":[[0,0],[0,0],[0,1.104],[0,0],[-1.104,0],[0,0]],"o":[[0,0],[-1.104,0],[0,0],[0,-1.104],[0,0],[0,0]],"v":[[-4.913,9.994],[-7.779,10.576],[-9.779,8.576],[-10.947,1.35],[-8.947,-0.65],[-5.863,-1.014]],"c":false}]},{"t":22,"s":[{"i":[[0,0],[0,0],[0,1.104],[0,0],[-1.104,0],[0,0]],"o":[[0,0],[-1.104,0],[0,0],[0,-1.104],[0,0],[0,0]],"v":[[-4.913,9.994],[-7.913,9.994],[-9.913,7.994],[-9.913,0.994],[-7.913,-1.006],[-4.913,-1.006]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":0,"s":[{"i":[[0,0],[0,0],[1.657,0],[0,0],[0,0],[0,0],[-0.149,0.986],[0,0],[1.093,0.166],[0.108,-0.001]],"o":[[0,0],[0,-1.657],[0,0],[0,0],[0,0],[0.997,0.012],[0,0],[0.166,-1.092],[-0.106,-0.016],[0,0]],"v":[[2.087,-3.006],[2.087,-7.006],[-0.913,-10.006],[-4.913,-1.006],[-4.913,9.994],[6.367,9.994],[8.367,8.294],[9.747,-0.706],[8.069,-2.984],[7.747,-3.006]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":6,"s":[{"i":[[0,0],[0,0],[1.657,0],[0,0],[0,0],[0,0],[-0.149,0.986],[0,0],[1.093,0.166],[0.108,-0.001]],"o":[[0,0],[0.913,-1.235],[0,0],[0,0],[0,0],[0.997,0.012],[0,0],[0.166,-1.092],[-0.106,-0.016],[0,0]],"v":[[2.647,-1.381],[5.483,-3.383],[4.556,-6.601],[-4.913,-1.006],[-4.913,9.994],[6.367,9.994],[8.367,8.294],[9.609,0.333],[7.931,-1.945],[7.609,-1.967]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":12,"s":[{"i":[[0,0],[0,0],[1.657,0],[0,0],[0,0],[0,0],[-0.149,0.986],[0,0],[1.093,0.166],[0.108,-0.001]],"o":[[0,0],[-0.055,-2.114],[0,0],[0,0],[0,0],[0.997,0.012],[0,0],[0.166,-1.092],[-0.106,-0.016],[0,0]],"v":[[1.903,-2.227],[2.183,-7.849],[-1.445,-11.464],[-4.913,-1.006],[-4.913,9.994],[6.68,9.431],[8.68,7.731],[10.466,-0.465],[8.788,-2.743],[8.466,-2.765]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":16,"s":[{"i":[[0,0],[0,0],[1.657,0],[0,0],[0,0],[0,0],[-0.149,0.986],[0,0],[1.093,0.166],[0.108,-0.001]],"o":[[0,0],[0.913,-1.235],[0,0],[0,0],[0,0],[0.997,0.012],[0,0],[0.166,-1.092],[-0.106,-0.016],[0,0]],"v":[[2.74,-1.718],[4.922,-3.927],[3.995,-7.145],[-5.863,-1.014],[-4.913,9.994],[6.367,9.994],[8.367,8.294],[9.737,0.335],[8.059,-1.943],[7.737,-1.965]],"c":true}]},{"t":22,"s":[{"i":[[0,0],[0,0],[1.657,0],[0,0],[0,0],[0,0],[-0.149,0.986],[0,0],[1.093,0.166],[0.108,-0.001]],"o":[[0,0],[0,-1.657],[0,0],[0,0],[0,0],[0.997,0.012],[0,0],[0.166,-1.092],[-0.106,-0.016],[0,0]],"v":[[2.087,-3.006],[2.087,-7.006],[-0.913,-10.006],[-4.913,-1.006],[-4.913,9.994],[6.367,9.994],[8.367,8.294],[9.747,-0.706],[8.069,-2.984],[7.747,-3.006]],"c":true}]}],"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":6,"s":[5.017,20.604],"to":[-0.083,-0.333],"ti":[0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":12,"s":[4.517,18.604],"to":[0,0],"ti":[-0.083,-0.333]},{"t":16,"s":[5.017,20.604]}],"ix":2},"a":{"a":0,"k":[-6.895,8.562],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":1,"k":[{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.3],"y":[0]},"t":0,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.3],"y":[0]},"t":6,"s":[19]},{"i":{"x":[0.177],"y":[1]},"o":{"x":[0.641],"y":[0]},"t":12,"s":[-17.275]},{"i":{"x":[0.442],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":16,"s":[11.047]},{"t":22,"s":[0]}],"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"hand","np":4,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":0,"s":[{"i":[[0,0],[0,0],[0,1.104],[0,0],[-1.104,0],[0,0]],"o":[[0,0],[-1.104,0],[0,0],[0,-1.104],[0,0],[0,0]],"v":[[-4.913,9.994],[-7.913,9.994],[-9.913,7.994],[-9.913,0.994],[-7.913,-1.006],[-4.913,-1.006]],"c":false}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":6,"s":[{"i":[[0,0],[0,0],[0,1.104],[0,0],[-1.104,0],[0,0]],"o":[[0,0],[-1.104,0],[0,0],[0,-1.104],[0,0],[0,0]],"v":[[-4.913,9.994],[-7.779,10.576],[-9.779,8.576],[-10.947,1.35],[-8.947,-0.65],[-4.913,-1.006]],"c":false}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":12,"s":[{"i":[[0,0],[0,0],[0,1.104],[0,0],[-1.104,0],[0,0]],"o":[[0,0],[-1.104,0],[0,0],[0,-1.104],[0,0],[0,0]],"v":[[-4.913,9.994],[-7.808,10.083],[-9.808,8.083],[-9.618,1.221],[-7.618,-0.779],[-4.913,-1.006]],"c":false}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":16,"s":[{"i":[[0,0],[0,0],[0,1.104],[0,0],[-1.104,0],[0,0]],"o":[[0,0],[-1.104,0],[0,0],[0,-1.104],[0,0],[0,0]],"v":[[-4.913,9.994],[-7.779,10.576],[-9.779,8.576],[-10.947,1.35],[-8.947,-0.65],[-5.863,-1.014]],"c":false}]},{"t":22,"s":[{"i":[[0,0],[0,0],[0,1.104],[0,0],[-1.104,0],[0,0]],"o":[[0,0],[-1.104,0],[0,0],[0,-1.104],[0,0],[0,0]],"v":[[-4.913,9.994],[-7.913,9.994],[-9.913,7.994],[-9.913,0.994],[-7.913,-1.006],[-4.913,-1.006]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":16,"s":[0]},{"t":22,"s":[100]}],"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":6,"s":[5.017,20.604],"to":[-0.083,-0.333],"ti":[0,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":12,"s":[4.517,18.604],"to":[0,0],"ti":[-0.083,-0.333]},{"t":16,"s":[5.017,20.604]}],"ix":2},"a":{"a":0,"k":[-6.895,8.562],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":1,"k":[{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.3],"y":[0]},"t":0,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.3],"y":[0]},"t":6,"s":[19]},{"i":{"x":[0.177],"y":[1]},"o":{"x":[0.641],"y":[0]},"t":12,"s":[-17.275]},{"i":{"x":[0.442],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":16,"s":[11.047]},{"t":22,"s":[0]}],"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"fill","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":22,"st":0,"bm":0}],"markers":[]}');



var $ikMhW = parcelRequire("ikMhW");

var $6cSBm = parcelRequire("6cSBm");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $3hnF2 = parcelRequire("3hnF2");
const $d63e9c725d26088e$var$ContentWrapper = (0, $5UMQ1.default).div`
	flex-direction: column;
	gap: 24px;
`;
const $d63e9c725d26088e$export$1772c30d01dec64a = /*#__PURE__*/ (0, $81g6h.memo)(({ content: content, className: className })=>/*#__PURE__*/ (0, $iKObn.jsx)($d63e9c725d26088e$var$ContentWrapper, {
        className: className,
        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $3hnF2.BaseBlocksRenderer), {
            content: content
        })
    }));
$d63e9c725d26088e$export$1772c30d01dec64a.displayName = "ArticleRenderer";



var $5lYAo = parcelRequire("5lYAo");

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $kKnoQ = parcelRequire("kKnoQ");

var $bl9tw = parcelRequire("bl9tw");
const $e7c9a12a8cf17c6a$export$bf4193ede2b26fcd = ({ tipsModule: tipsModule })=>/*#__PURE__*/ (0, $iKObn.jsxs)($e7c9a12a8cf17c6a$var$TipsModuleContainer, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($e7c9a12a8cf17c6a$var$TipsIconWrapper, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)($e7c9a12a8cf17c6a$var$TipsIcon, {
                    src: tipsModule.image.url,
                    alt: tipsModule.title || "Tips"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($e7c9a12a8cf17c6a$var$TipsModuleBox, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($e7c9a12a8cf17c6a$var$TipsModuleTitle, {
                        children: tipsModule.title
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($e7c9a12a8cf17c6a$var$TipsModuleContent, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $d63e9c725d26088e$export$1772c30d01dec64a), {
                            content: tipsModule.content
                        })
                    })
                ]
            })
        ]
    });
// Tips Module Styles
const $e7c9a12a8cf17c6a$var$TipsModuleContainer = (0, $5UMQ1.default).div`
	position: relative;
	width: 100%;
	margin-top: 100px;
	margin-bottom: 32px;

	@media (max-width: 520px) {
		margin-top: 70px;
	}
`;
const $e7c9a12a8cf17c6a$var$TipsIconWrapper = (0, $5UMQ1.default).div`
	position: absolute;
	top: -60px;
	left: 50%;
	transform: translateX(-50%) rotate(45deg);
	width: 120px;
	height: 120px;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${(0, $kKnoQ.colors).white};
	border-radius: 16px;
	box-shadow: -4.927px 0px 9.854px 0px rgba(38, 38, 48, 0.08);

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		width: 120px;
		height: 120px;
		top: -60px;
	}

	@media (max-width: 520px) {
		width: 100px;
		height: 100px;
		top: -50px;
	}
`;
const $e7c9a12a8cf17c6a$var$TipsIcon = (0, $5UMQ1.default).img`
	width: 100%;
	height: 100%;
	object-fit: contain;
	transform: rotate(-45deg) scale(1.2);
`;
const $e7c9a12a8cf17c6a$var$TipsModuleBox = (0, $5UMQ1.default).div`
	background: #ecedfc;
	border-radius: 16px;
	padding: 80px 32px 40px 32px;
	position: relative;
	z-index: 1;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 80px 24px 32px 24px;
	}

	@media (max-width: 520px) {
		padding: 70px 20px 24px 20px;
	}
`;
const $e7c9a12a8cf17c6a$var$TipsModuleTitle = (0, $5UMQ1.default).h2`
	font-family: ${(0, $bl9tw.fonts).header};
	font-size: 24px;
	font-weight: 700;
	color: #212bc2;
	margin: 0 0 24px 0;
	line-height: 1;
	margin-top: 32px;
	@media (max-width: 520px) {
		font-size: 20px;
	}
`;
const $e7c9a12a8cf17c6a$var$TipsModuleContent = (0, $5UMQ1.default).div`
	font-family: ${(0, $bl9tw.fonts).body};
	color: ${(0, $kKnoQ.colors).black};

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		margin-top: 18px;
		margin-bottom: 10px;
		font-family: ${(0, $bl9tw.fonts).header};
		font-size: 18px;
		font-weight: 700;
		color: ${(0, $kKnoQ.colors).primaryDark50};
	}

	p {
		margin-top: 16px;
		margin-bottom: 16px;
		color: ${(0, $kKnoQ.colors).black};
		font-size: 18px;
		line-height: 1.5;
		&:last-child {
			margin-bottom: 0;
		}
	}
	ul,
	ol {
		margin-top: 16px;
		margin-bottom: 16px;
		padding-left: 24px;
		font-size: 18px;
		color: ${(0, $kKnoQ.colors).black};
		line-height: 1.5;
	}

	li {
		margin-bottom: 8px;
		font-family: ${(0, $bl9tw.fonts).body};
		font-size: 18px;
		font-weight: 400;
		color: ${(0, $kKnoQ.colors).black};

		&:last-child {
			margin-bottom: 0;
		}
	}

	ul li {
		list-style-type: none;
		position: relative;
		padding-left: 4px;

		&::before {
			content: "";
			position: absolute;
			left: -24px;
			top: 10px;
			width: 6px;
			height: 6px;
			background-color: ${(0, $kKnoQ.colors).primary};
			border-radius: 50%;
		}
	}

	strong {
		font-family: ${(0, $bl9tw.fonts).header};
		font-weight: 700;
		color: ${(0, $kKnoQ.colors).black};
	}
`;



var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");
var $fb995e0f55f55d3f$export$2deb71ebd3734d23;
(function(AnimationType) {
    AnimationType["None"] = "none";
    AnimationType["Opacity"] = "opacity";
    AnimationType["Scale"] = "scale";
})($fb995e0f55f55d3f$export$2deb71ebd3734d23 || ($fb995e0f55f55d3f$export$2deb71ebd3734d23 = {}));
const $fb995e0f55f55d3f$export$70657092e12a5d01 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).forwardRef(({ type: type = "opacity", children: children, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onTouchStart: onTouchStart, onTouchEnd: onTouchEnd, style: style, ...props }, ref)=>{
    const [isPressed, setIsPressed] = (0, $81g6h.useState)(false);
    const handleMouseDown = (e)=>{
        setIsPressed(true);
        onMouseDown?.(e);
    };
    const handleMouseUp = (e)=>{
        setIsPressed(false);
        onMouseUp?.(e);
    };
    const handleTouchStart = (e)=>{
        setIsPressed(true);
        onTouchStart?.(e);
    };
    const handleTouchEnd = (e)=>{
        setIsPressed(false);
        onTouchEnd?.(e);
    };
    return /*#__PURE__*/ (0, $iKObn.jsx)($fb995e0f55f55d3f$var$StyledAnimatedButton, {
        ref: ref,
        animationType: type,
        isPressed: isPressed,
        onMouseDown: handleMouseDown,
        onMouseUp: handleMouseUp,
        onMouseLeave: ()=>setIsPressed(false),
        onTouchStart: handleTouchStart,
        onTouchEnd: handleTouchEnd,
        style: style,
        ...props,
        children: children
    });
});
$fb995e0f55f55d3f$export$70657092e12a5d01.displayName = "AnimatedButton";
const $fb995e0f55f55d3f$var$StyledAnimatedButton = (0, $5UMQ1.default).button`
	transition: all 0.15s ease-out;

	${({ animationType: animationType, isPressed: isPressed })=>{
    switch(animationType){
        case "opacity":
            return `
					opacity: ${isPressed ? 0.8 : 1};
				`;
        case "scale":
            return `
					transform: scale(${isPressed ? 0.95 : 1});
				`;
        case "none":
        default:
            return "";
    }
}}
`;



var $kKnoQ = parcelRequire("kKnoQ");

var $bl9tw = parcelRequire("bl9tw");

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $kKnoQ = parcelRequire("kKnoQ");

var $bl9tw = parcelRequire("bl9tw");

var $buI4E = parcelRequire("buI4E");
const $14bfc7aa0f664a03$export$c99330bafc28ff57 = ({ quoteModule: quoteModule })=>{
    const author = quoteModule.author;
    console.log("author image:", author?.image);
    console.log("author image url:", author?.image?.url);
    return /*#__PURE__*/ (0, $iKObn.jsx)($14bfc7aa0f664a03$var$QuoteModuleContainer, {
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($14bfc7aa0f664a03$var$QuoteContent, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsx)($14bfc7aa0f664a03$var$QuoteDivider, {}),
                /*#__PURE__*/ (0, $iKObn.jsx)($14bfc7aa0f664a03$var$QuoteText, {
                    children: quoteModule.quote
                }),
                author && /*#__PURE__*/ (0, $iKObn.jsxs)($14bfc7aa0f664a03$var$QuoteAuthorSection, {
                    children: [
                        author.image?.url ? /*#__PURE__*/ (0, $iKObn.jsx)($14bfc7aa0f664a03$var$AuthorImage, {
                            src: author.image.url,
                            alt: author.name,
                            loading: "lazy"
                        }) : /*#__PURE__*/ (0, $iKObn.jsx)($14bfc7aa0f664a03$var$AuthorInitials, {
                            children: (0, $buI4E.getInitials)(author.name)
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsxs)($14bfc7aa0f664a03$var$AuthorInfo, {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)($14bfc7aa0f664a03$var$AuthorName, {
                                    children: author.name
                                }),
                                author.title && /*#__PURE__*/ (0, $iKObn.jsx)($14bfc7aa0f664a03$var$AuthorTitle, {
                                    children: author.title
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
// Quote Module Styles
const $14bfc7aa0f664a03$var$QuoteModuleContainer = (0, $5UMQ1.default).div`
	position: relative;
	width: 100%;
	margin-top: 16px;
	margin-bottom: 16px;
	background: #ecedfc;
	border-radius: 16px;
	padding: 32px 40px;
	display: flex;
	flex-direction: column;
	gap: 16px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 24px 32px;
	}

	@media (max-width: 520px) {
		padding: 20px 24px;
	}
`;
const $14bfc7aa0f664a03$var$QuoteContent = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: row;
	align-items: stretch;
	gap: 16px;
	width: 100%;
`;
const $14bfc7aa0f664a03$var$QuoteDivider = (0, $5UMQ1.default).div`
	width: 4px;
	background: ${(0, $kKnoQ.colors).primary};
	border-radius: 16px;
	flex-shrink: 0;
`;
const $14bfc7aa0f664a03$var$QuoteText = (0, $5UMQ1.default).div`
	flex: 1;
	font-family: ${(0, $bl9tw.fonts).header};
	font-size: 18px;
	font-weight: 500;
	font-style: italic;
	color: #212bc2;
	line-height: 1;
	display: flex;
	flex-direction: column;

	p {
		font-family: ${(0, $bl9tw.fonts).header};
		font-size: 18px;
		font-weight: 500;
		font-style: italic;
		color: #212bc2;
		line-height: normal;
		margin: 0;

		&:not(:last-child) {
			margin-bottom: 16px;
		}
	}

	strong {
		font-weight: 700;
	}

	em {
		font-style: italic;
	}
`;
const $14bfc7aa0f664a03$var$QuoteAuthorSection = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 16px;
`;
const $14bfc7aa0f664a03$var$AuthorImage = (0, $5UMQ1.default).img`
	width: 55px;
	height: 55px;
	border-radius: 50%;
	object-fit: cover;
	flex-shrink: 0;
`;
const $14bfc7aa0f664a03$var$AuthorInitials = (0, $5UMQ1.default).div`
	width: 55px;
	height: 55px;
	border-radius: 50%;
	background: ${(0, $kKnoQ.colors).grey80};
	color: ${(0, $kKnoQ.colors).white};
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: ${(0, $bl9tw.fonts).header};
	font-size: 18px;
	font-weight: 700;
	flex-shrink: 0;
`;
const $14bfc7aa0f664a03$var$AuthorInfo = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;
const $14bfc7aa0f664a03$var$AuthorName = (0, $5UMQ1.default).div`
	font-family: ${(0, $bl9tw.fonts).header};
	font-size: 18px;
	font-weight: 700;
	color: #212bc2;
	line-height: 1;
`;
const $14bfc7aa0f664a03$var$AuthorTitle = (0, $5UMQ1.default).div`
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 18px;
	font-weight: 400;
	color: #212bc2;
	line-height: 1;
`;




var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $cD3aa = parcelRequire("cD3aa");
var $90cc3bc45cc54aca$var$LuClock8 = function LuClock8(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M6.667 0a6.667 6.667 0 1 0 6.666 6.667A6.674 6.674 0 0 0 6.667 0Zm0 12.222a5.555 5.555 0 1 1 0-11.11 5.555 5.555 0 0 1 0 11.11Z",
                fill: "#565671"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M6.763 3.333a.569.569 0 0 0-.57.574v2.484L4.268 7.603a.575.575 0 0 0 .606.976l2.19-1.378a.573.573 0 0 0 .268-.492V3.907a.576.576 0 0 0-.57-.574Z",
                fill: "#565671"
            })
        ]
    });
};
$90cc3bc45cc54aca$var$LuClock8.defaultProps = {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $90cc3bc45cc54aca$var$MegaphoneIcon = function MegaphoneIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M39.518 3.223 3.223 39.518c-4.297 4.298-4.297 11.266 0 15.564l36.295 36.294c4.298 4.298 11.266 4.298 15.564 0l36.294-36.294c4.298-4.298 4.298-11.266 0-15.564L55.082 3.223c-4.298-4.297-11.266-4.297-15.564 0Z",
                fill: "#F5EEFD"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                width: "7.978",
                height: "16.386",
                rx: "3.989",
                transform: "matrix(.90884 -.41659 .4197 .90793 25.75 57.41)",
                fill: "#119CEB"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_7002_4209",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "27",
                y: "55",
                width: "12",
                height: "16",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("rect", {
                    width: "7.978",
                    height: "16.386",
                    rx: "3.989",
                    transform: "matrix(.90884 -.41659 .4197 .90793 25.75 57.41)",
                    fill: "#119CEB"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("g", {
                mask: "url(#mask0_7002_4209)",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M36.106 63.81c2.653.866 5.304 2.703 6.299 3.514 1.58-3.982 4.71-12 4.586-12.223-.155-.278-6.878-13.318-7.541-13.534-.664-.217-17.421 3.797-17.836 4.026-.332.183.787 12.775 1.387 19.047 3.263-.637 10.452-1.695 13.105-.83Z",
                    fill: "#2275F0"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M28.29 43.672c-.905.432-2.031.843-3.217 1.22-3.665 1.17-6.683 4.259-5.947 8.035a18.507 18.507 0 0 0 1.588 4.701c1.592 3.208 5.54 4.027 8.936 2.898l2.982-.992c2.479-.824 5.201-1.01 8.21-.643 7.869.962 15.491-4.941 12.782-12.392a311.572 311.572 0 0 0-1.177-3.185c-2.776-7.383-12.914-7.465-19.15-2.641-2.05 1.587-3.768 2.407-5.007 2.999Z",
                fill: "#334EF5"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask1_7002_4209",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "19",
                y: "25",
                width: "40",
                height: "41",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M28.291 43.673c-.85.406-1.896.793-3.002 1.152-3.789 1.228-6.926 4.424-6.118 8.325.11.526.24 1.045.393 1.558 1.573 5.275 7.848 6.564 13.069 4.828 6.826-2.27 14.595.065 25.976 5.725-3.837-16.463-13.804-40.112-13.804-40.112-7.123 13.96-13.304 16.99-16.514 18.524Z",
                    fill: "#334EF5"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask1_7002_4209)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M29.86 38.705c5.443-4.647-6.674-9.75-8.575-11.856L14.13 12.155 44.796-1.457c5.478 19.785 16.068 67 15.472 67.103-.746.129 6.39 10.277 3.769 8.452-6.988-4.865-6.882-2.402-15.253-10.821-9.427-9.48-17.276-1.614-22.772-6.736-6.125-5.708-2.532-12.39 3.848-17.836Z",
                        fill: "#2275F0"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M33.992 33.133c1.977-4.95-3.798-8.51-5.518-10.765l-5.917-15.23L54.245-3.916c3.824 20.167 10.475 68.091 9.872 68.144-.754.067 5.518 10.765 3.058 8.732-6.562-5.421-7.28-.554-14.928-9.63-10.292-12.216-16-4.89-21.054-10.446-4.792-5.267-.307-11.975 2.799-19.752Z",
                        fill: "#119CEB"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M38.557 37.838c1.177-2.755-2.208-4.717-3.212-5.964l-3.434-8.445 18.658-6.231c2.189 11.193 5.96 37.798 5.605 37.83-.443.039 3.213 5.964 1.772 4.842-3.841-2.993-3.657-.927-8.126-5.947-5.032-5.654-10.01-2.032-12.965-5.103-2.802-2.913-.146-6.653 1.702-10.982Z",
                        fill: "#00C3E6"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                cx: "7.082",
                cy: "21.92",
                rx: "7.082",
                ry: "21.92",
                transform: "matrix(.94612 -.32329 .32585 .9456 39.584 26.18)",
                fill: "#33009A"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask2_7002_4209",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "43",
                y: "23",
                width: "21",
                height: "43",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                    cx: "7.082",
                    cy: "21.92",
                    rx: "7.082",
                    ry: "21.92",
                    transform: "matrix(.94612 -.32329 .32585 .9456 39.584 26.18)",
                    fill: "#33009A"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask3_7002_4209",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "50",
                y: "35",
                width: "12",
                height: "18",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                    cx: "4.955",
                    cy: "8.774",
                    rx: "4.955",
                    ry: "8.774",
                    transform: "matrix(.9194 -.39282 .3956 .91864 47.99 38.06)",
                    fill: "#33009A"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask3_7002_4209)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                        cx: "5.332",
                        cy: "6.314",
                        rx: "5.332",
                        ry: "6.314",
                        transform: "matrix(.91947 -.39284 .39453 .91902 44.442 42.25)",
                        fill: "#FFAF00"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask4_7002_4209",
                        style: {
                            maskType: "alpha"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "46",
                        y: "39",
                        width: "12",
                        height: "14",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                            cx: "5.332",
                            cy: "6.314",
                            rx: "5.332",
                            ry: "6.314",
                            transform: "matrix(.91947 -.39284 .39453 .91902 44.442 42.25)",
                            fill: "#119CEB"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("g", {
                        mask: "url(#mask4_7002_4209)",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M53.74 38.162c.657-.281 1.606-.27 2.747.39 1.142.662 2.296 1.898 3.039 3.622.742 1.725.846 3.41.54 4.69-.306 1.279-.952 1.97-1.609 2.251-.657.281-1.607.27-2.748-.39-1.141-.661-2.295-1.898-3.037-3.622-.743-1.725-.848-3.41-.542-4.689.306-1.28.953-1.972 1.61-2.252Z",
                            stroke: "#FF8214",
                            strokeWidth: "5.625"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M35.458 58.666a.83.83 0 0 1-.515 1.056l-6.493 2.24a.83.83 0 1 1-.546-1.568l6.494-2.24c.435-.15.91.079 1.06.512Z",
                fill: "#33009A"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "m73.386 40.283-9.6 1.938c-.884.177-1.309-1.053-.51-1.46l8.728-4.418c2.906-1.279 4.463 3.142 1.383 3.935l-.001.005ZM69.77 50.516l-5.492-3.474c-.77-.49-.197-1.676.665-1.396l6.18 2.03c2.205.852.714 3.996-1.352 2.835l-.001.005ZM65.803 32.014l-3.624 5.36c-.522.758-1.712.13-1.375-.72l2.39-6.005c.886-1.962 3.727-.48 2.604 1.364l.005.002Z",
                fill: "#00C3E6"
            })
        ]
    });
};
$90cc3bc45cc54aca$var$MegaphoneIcon.defaultProps = {
    width: "95",
    height: "95",
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $90cc3bc45cc54aca$var$InfoSvg = function InfoSvg(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Zm0-20c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12.01 17.17c-.55 0-1-.45-1-1v-5.44c0-.55.45-1 1-1s1 .45 1 1v5.44c0 .55-.45 1-1 1ZM12 8.11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                fill: "currentColor"
            })
        ]
    });
};
$90cc3bc45cc54aca$var$InfoSvg.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $90cc3bc45cc54aca$var$IMAGE_EXTENSION_REGEX = /\.(png|jpe?g|webp|svg)$/i;
const $90cc3bc45cc54aca$var$QUOTE_MODULE_COMPONENT = "embed.quote-module";
const $90cc3bc45cc54aca$var$TIPS_MODULE_COMPONENT = "embed.educational-article-tips-module";
const $90cc3bc45cc54aca$var$MediaSection = ({ item: item })=>{
    const hasMedia = !!item.mediaUrl;
    const isVideo = hasMedia && item.mediaType === (0, $6cSBm.MediaType).VIDEO;
    const isImage = hasMedia && item.mediaUrl && $90cc3bc45cc54aca$var$IMAGE_EXTENSION_REGEX.test(item.mediaUrl);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($90cc3bc45cc54aca$var$MediaContainer, {
        isVisible: hasMedia,
        children: [
            isVideo && item.mediaUrl && /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$VideoWrapper, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $5lYAo.VideoPlayer), {
                    url: item.mediaUrl,
                    displayVideoGradient: false,
                    autoPlay: true,
                    controls: true
                })
            }),
            isImage && item.mediaUrl && /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$ArticleImage, {
                src: item.mediaUrl,
                alt: item.title
            })
        ]
    });
};
const $90cc3bc45cc54aca$var$ArticleModuleSection = ({ module: module })=>{
    switch(module.__component){
        case $90cc3bc45cc54aca$var$QUOTE_MODULE_COMPONENT:
            return /*#__PURE__*/ (0, $iKObn.jsx)((0, $14bfc7aa0f664a03$export$c99330bafc28ff57), {
                quoteModule: module
            });
        case $90cc3bc45cc54aca$var$TIPS_MODULE_COMPONENT:
            return /*#__PURE__*/ (0, $iKObn.jsx)((0, $e7c9a12a8cf17c6a$export$bf4193ede2b26fcd), {
                tipsModule: module
            });
        default:
            return null;
    }
};
const $90cc3bc45cc54aca$export$508bbe50647e594 = ({ item: item })=>{
    const [showReferences, setShowReferences] = (0, $81g6h.useState)(true);
    const [feedback, setFeedback] = (0, $81g6h.useState)(null);
    const [isFeedbackSubmitted, setIsFeedbackSubmitted] = (0, $81g6h.useState)(false);
    const [hideFeedbackButtons, setHideFeedbackButtons] = (0, $81g6h.useState)(false);
    const [showThankYouMessage, setShowThankYouMessage] = (0, $81g6h.useState)(false);
    const playerRefUp = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(null);
    const playerRefDown = (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).useRef(null);
    const { durationLabel: durationLabel } = (0, $0f68fe4b539aa457$export$ed879e2ca19c530)(item.mediaType, item.mediaUrl, item.duration);
    const hasContent = !!(item.content && Array.isArray(item.content) && item.content.length > 0);
    const hasCallout = !!(item.callout && Array.isArray(item.callout) && item.callout.length > 0);
    const articleModules = (item.articleModules ?? []).sort((a, b)=>{
        if (a.__component === $90cc3bc45cc54aca$var$QUOTE_MODULE_COMPONENT && b.__component !== $90cc3bc45cc54aca$var$QUOTE_MODULE_COMPONENT) return -1;
        if (a.__component !== $90cc3bc45cc54aca$var$QUOTE_MODULE_COMPONENT && b.__component === $90cc3bc45cc54aca$var$QUOTE_MODULE_COMPONENT) return 1;
        return 0;
    });
    const toggleReferences = ()=>setShowReferences((prev)=>!prev);
    const handleFeedback = (type)=>{
        if (isFeedbackSubmitted) return;
        setFeedback(type);
        setIsFeedbackSubmitted(true);
        (0, $ghfIB.analyticsService).trackEvent({
            category: (0, $auPqo.AnalyticsCategory).LEARN,
            action: "contentFeedback",
            params: [
                item.documentId,
                type
            ]
        });
        if (type === "liked") playerRefUp.current?.play();
        else playerRefDown.current?.play();
        setTimeout(()=>{
            setHideFeedbackButtons(true);
            setShowThankYouMessage(true);
        }, 1000);
    };
    const { format: format, formatDateFull: formatDateFull } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($90cc3bc45cc54aca$var$DocumentContainer, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($90cc3bc45cc54aca$var$DocumentHeader, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$DocumentTitle, {
                        as: "h1",
                        children: item.title
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($90cc3bc45cc54aca$var$MetadataRow, {
                        role: "contentinfo",
                        "aria-label": "Article metadata",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$AuthorText, {
                                isVisible: !!item.author,
                                "aria-label": `Author: ${item.author}`,
                                children: item.author
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$PublicationDateText, {
                                isVisible: !!item.publicationDate,
                                "aria-label": `Published: ${formatDateFull((0, (/*@__PURE__*/$parcel$interopDefault($cD3aa)))(item.publicationDate))}`,
                                children: formatDateFull((0, (/*@__PURE__*/$parcel$interopDefault($cD3aa)))(item.publicationDate))
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)($90cc3bc45cc54aca$var$DurationRow, {
                                isVisible: !!durationLabel,
                                "aria-label": `Duration: ${durationLabel}`,
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$LuClock8, {
                                        width: 16,
                                        height: 16,
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$DurationText, {
                                        children: durationLabel
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$MediaSection, {
                item: item
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$DocumentContent, {
                isVisible: hasContent,
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $d63e9c725d26088e$export$1772c30d01dec64a), {
                    content: item.content ?? []
                })
            }),
            articleModules.map((module)=>/*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$ArticleModuleSection, {
                    module: module
                }, module.id)),
            /*#__PURE__*/ (0, $iKObn.jsxs)($90cc3bc45cc54aca$var$CalloutBox, {
                isVisible: hasCallout,
                role: "note",
                "aria-label": "Important information",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$MegaphoneIconWrapper, {
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$MegaphoneIcon, {})
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$CalloutContent, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $d63e9c725d26088e$export$1772c30d01dec64a), {
                            content: item.callout ?? []
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($90cc3bc45cc54aca$var$ReferenceSection, {
                isVisible: !!item.reference,
                role: "complementary",
                "aria-labelledby": "references-title",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($90cc3bc45cc54aca$var$ReferenceHeader, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsxs)($90cc3bc45cc54aca$var$ReferenceHeaderLeft, {
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$ReferenceTitle, {
                                        id: "references-title",
                                        children: format("learn.References.title")
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$InfoIcon, {
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$InfoSvg, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$ToggleButton, {
                                onClick: toggleReferences,
                                "aria-expanded": showReferences,
                                "aria-label": `${showReferences ? "Hide" : "Show"} references`,
                                type: "button",
                                children: showReferences ? "Hide" : "Show"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$ReferenceDivider, {}),
                    /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$ReferenceText, {
                        isVisible: showReferences,
                        "aria-live": "polite",
                        children: item.reference
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($90cc3bc45cc54aca$var$FeedbackSection, {
                role: "group",
                "aria-labelledby": "feedback-title",
                isVisible: !hideFeedbackButtons,
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$FeedbackTitle, {
                        id: "feedback-title",
                        children: format("learn.Feedback.title")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($90cc3bc45cc54aca$var$FeedbackButtons, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $fb995e0f55f55d3f$export$70657092e12a5d01), {
                                type: (0, $fb995e0f55f55d3f$export$2deb71ebd3734d23).Scale,
                                onClick: ()=>handleFeedback("liked"),
                                isActive: feedback === "liked",
                                "aria-label": "Like this content",
                                "aria-pressed": feedback === "liked",
                                className: "feedback-button",
                                style: {
                                    width: "56px",
                                    height: "56px",
                                    borderRadius: "50%",
                                    background: feedback === "liked" ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).primary10,
                                    border: "none",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer"
                                },
                                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $ikMhW.Player), {
                                    ref: playerRefUp,
                                    loop: false,
                                    controls: false,
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ffbb4190df1d0c54$exports))),
                                    style: {
                                        height: "24px",
                                        width: "24px",
                                        filter: feedback === "liked" ? "brightness(0) invert(1)" : "brightness(0) saturate(100%) invert(33%) sepia(89%) saturate(1749%) hue-rotate(201deg) brightness(95%) contrast(95%)"
                                    },
                                    "aria-hidden": "true"
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $fb995e0f55f55d3f$export$70657092e12a5d01), {
                                type: (0, $fb995e0f55f55d3f$export$2deb71ebd3734d23).Scale,
                                onClick: ()=>handleFeedback("disliked"),
                                isActive: feedback === "disliked",
                                "aria-label": "Dislike this content",
                                "aria-pressed": feedback === "disliked",
                                className: "feedback-button",
                                style: {
                                    width: "56px",
                                    height: "56px",
                                    borderRadius: "50%",
                                    background: feedback === "disliked" ? (0, $kKnoQ.colors).primary : (0, $kKnoQ.colors).primary10,
                                    border: "none",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer"
                                },
                                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $ikMhW.Player), {
                                    ref: playerRefDown,
                                    loop: false,
                                    controls: false,
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ffbb4190df1d0c54$exports))),
                                    style: {
                                        height: "24px",
                                        width: "24px",
                                        transform: "rotate(180deg)",
                                        filter: feedback === "disliked" ? "brightness(0) invert(1)" : "brightness(0) saturate(100%) invert(33%) sepia(89%) saturate(1749%) hue-rotate(201deg) brightness(95%) contrast(95%)"
                                    },
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$ThankYouMessage, {
                isVisible: showThankYouMessage,
                role: "status",
                "aria-live": "polite",
                children: format("mediaContent.feedback.thanks")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$FooterSection, {
                isVisible: !!item.footer,
                role: "contentinfo",
                children: /*#__PURE__*/ (0, $iKObn.jsx)($90cc3bc45cc54aca$var$FooterText, {
                    children: item.footer
                })
            })
        ]
    });
};
const $90cc3bc45cc54aca$var$DocumentContainer = (0, $5UMQ1.default).div`
	width: 100%;
`;
const $90cc3bc45cc54aca$var$DocumentHeader = (0, $5UMQ1.default).header`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-bottom: 24px;
`;
const $90cc3bc45cc54aca$var$DocumentTitle = (0, $5UMQ1.default).h1`
	font-family: ${(0, $bl9tw.fonts).header};
	color: ${(0, $kKnoQ.colors).black};
	margin: 0;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		font-size: 28px;
	}

	@media (max-width: 520px) {
		font-size: 24px;
	}
`;
const $90cc3bc45cc54aca$var$MetadataRow = (0, $5UMQ1.default).div`
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
	font-size: 13px;
`;
const $90cc3bc45cc54aca$var$AuthorText = (0, $5UMQ1.default).span`
	font-family: ${(0, $bl9tw.fonts).body};
	color: ${(0, $kKnoQ.colors).grey50};
	display: ${({ isVisible: isVisible })=>isVisible ? "inline" : "none"};
`;
const $90cc3bc45cc54aca$var$PublicationDateText = (0, $5UMQ1.default).span`
	font-family: ${(0, $bl9tw.fonts).body};
	color: ${(0, $kKnoQ.colors).grey50};
	display: ${({ isVisible: isVisible })=>isVisible ? "inline" : "none"};

	&::before {
		content: "|";
		margin: 0 8px;
		color: ${(0, $kKnoQ.colors).grey25};
	}
`;
const $90cc3bc45cc54aca$var$DurationRow = (0, $5UMQ1.default).div`
	display: ${({ isVisible: isVisible })=>isVisible ? "flex" : "none"};
	align-items: center;
	gap: 4px;
	color: ${(0, $kKnoQ.colors).grey50};

	&::before {
		content: "|";
		margin: 0 8px;
		color: ${(0, $kKnoQ.colors).grey25};
	}

	svg {
		fill: ${(0, $kKnoQ.colors).grey50};
		color: ${(0, $kKnoQ.colors).grey50};
		width: 14px;
		height: 14px;
	}
`;
const $90cc3bc45cc54aca$var$DurationText = (0, $5UMQ1.default).span`
	font-family: ${(0, $bl9tw.fonts).body};
`;
// Media Styles
const $90cc3bc45cc54aca$var$MediaContainer = (0, $5UMQ1.default).div`
	width: 100%;
	margin-bottom: ${({ isVisible: isVisible })=>isVisible ? "40px" : "0"};
	max-height: ${({ isVisible: isVisible })=>isVisible ? "2000px" : "0"};
	opacity: ${({ isVisible: isVisible })=>isVisible ? "1" : "0"};
	overflow: hidden;
	transition:
		max-height 0.3s ease-in-out,
		opacity 0.3s ease-in-out,
		margin-bottom 0.3s ease-in-out;
`;
const $90cc3bc45cc54aca$var$ArticleImage = (0, $5UMQ1.default).img`
	width: 100%;
	height: auto;
	max-height: 490px;
	object-fit: cover;
	border-radius: 16px;
	display: block;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		height: 373px;
		max-height: 373px;
	}

	@media (max-width: 520px) {
		height: 192px;
		max-height: 192px;
		border-radius: 12px;
	}
`;
const $90cc3bc45cc54aca$var$VideoWrapper = (0, $5UMQ1.default).div`
	width: 100%;
	border-radius: 16px;
	overflow: hidden;
	display: block;

	@media (max-width: 520px) {
		border-radius: 12px;
	}
`;
// Content Styles
const $90cc3bc45cc54aca$var$DocumentContent = (0, $5UMQ1.default).article`
	width: 100%;
	font-family: ${(0, $bl9tw.fonts).body};

	color: ${(0, $kKnoQ.colors).black};
	margin-bottom: ${({ isVisible: isVisible })=>isVisible ? "32px" : "0"};
	max-height: ${({ isVisible: isVisible })=>isVisible ? "none" : "0"};
	opacity: ${({ isVisible: isVisible })=>isVisible ? "1" : "0"};
	overflow: ${({ isVisible: isVisible })=>isVisible ? "visible" : "hidden"};
	transition:
		max-height 0.3s ease-in-out,
		opacity 0.3s ease-in-out,
		margin-bottom 0.3s ease-in-out;

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-family: ${(0, $bl9tw.fonts).header};
		font-size: 24px;
		font-weight: 700;
		color: ${(0, $kKnoQ.colors).black};
		margin: 32px 0 16px 0;

		&:first-child {
			margin-top: 0;
		}
	}

	p {
		margin: 0 0 16px 0;
		color: ${(0, $kKnoQ.colors).black};
		font-size: 18px;
		line-height: 1.7;

		&:last-child {
			margin-bottom: 0;
		}
	}

	ul,
	ol {
		margin: 0 0 24px 0;
		padding-left: 28px;
		font-size: 18px;
		color: ${(0, $kKnoQ.colors).black};
		line-height: 1.7;
	}

	li {
		margin-bottom: 8px;
		font-family: ${(0, $bl9tw.fonts).body};
		font-size: 18px;
		font-weight: 400;
		color: ${(0, $kKnoQ.colors).black};
		&:last-child {
			margin-bottom: 0;
		}
	}

	ul li {
		list-style-type: none;
		position: relative;
		padding-left: 4px;

		&::before {
			content: "";
			position: absolute;
			left: -24px;
			top: 10px;
			width: 6px;
			height: 6px;
			background-color: ${(0, $kKnoQ.colors).primary};
			border-radius: 50%;
		}
	}

	strong {
		font-family: ${(0, $bl9tw.fonts).header};
		font-weight: 700;
		color: ${(0, $kKnoQ.colors).black};
	}
`;
// Callout Styles
const $90cc3bc45cc54aca$var$CalloutBox = (0, $5UMQ1.default).div`
	position: relative;
	background: ${(0, $kKnoQ.colors).white};
	border-radius: 16px;
	padding: 72px 32px 32px 32px;
	margin-bottom: 32px;
	margin-top: 120px;
	display: ${(props)=>props.isVisible ? "block" : "none"};
	box-shadow:
		0px 44.344px 12.81px 0px rgba(162, 156, 201, 0),
		0px 28.577px 10.84px 0px rgba(162, 156, 201, 0.03),
		0px 15.767px 9.854px 0px rgba(162, 156, 201, 0.1),
		0px 6.898px 6.898px 0px rgba(162, 156, 201, 0.17),
		0px 1.971px 3.942px 0px rgba(162, 156, 201, 0.2);

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 64px 24px 24px 24px;
	}

	@media (max-width: 520px) {
		padding: 56px 20px 20px 20px;
	}
`;
const $90cc3bc45cc54aca$var$MegaphoneIconWrapper = (0, $5UMQ1.default).div`
	position: absolute;
	top: -45px;
	left: 32px;
	width: 70px;
	height: 70px;
	align-items: center;
	justify-content: center;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		width: 60px;
		height: 60px;
		top: -40px;
		left: 24px;
	}

	@media (max-width: 520px) {
		width: 50px;
		height: 50px;
		top: -40px;
		left: 20px;
	}
`;
const $90cc3bc45cc54aca$var$CalloutContent = (0, $5UMQ1.default).div`
	display: flex;
	flex-direction: column;
	gap: 24px;

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-family: ${(0, $bl9tw.fonts).header};
		font-size: 24px;
		font-weight: 700;
		line-height: 1;
		color: ${(0, $kKnoQ.colors).black};
		margin: 0;
	}

	p {
		font-family: ${(0, $bl9tw.fonts).body};
		font-size: 18px;
		font-weight: 400;
		line-height: 1.7;
		color: ${(0, $kKnoQ.colors).black};
		margin: 0;

		&:not(:last-child) {
			margin-bottom: 16px;
		}
	}

	strong {
		font-family: ${(0, $bl9tw.fonts).header};
		font-weight: 700;
	}

	ul,
	ol {
		margin: 0;
		padding-left: 28px;
		font-family: ${(0, $bl9tw.fonts).body};
		font-size: 18px;
		font-weight: 400;
		line-height: 1.7;
		color: ${(0, $kKnoQ.colors).black};
	}

	li {
		margin-bottom: 8px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	ul li {
		list-style-type: none;
		position: relative;
		padding-left: 4px;

		&::before {
			content: "";
			position: absolute;
			left: -24px;
			top: 10px;
			width: 6px;
			height: 6px;
			background-color: ${(0, $kKnoQ.colors).primary};
			border-radius: 50%;
		}
	}
`;
// Reference Styles
const $90cc3bc45cc54aca$var$ReferenceSection = (0, $5UMQ1.default).section`
	margin-top: ${({ isVisible: isVisible })=>isVisible ? "40px" : "0"};
	background: rgba(86, 86, 113, 0.05);
	border-radius: 8px;
	padding: ${({ isVisible: isVisible })=>isVisible ? "16px" : "0"};
	display: ${({ isVisible: isVisible })=>isVisible ? "flex" : "none"};
	flex-direction: column;
	gap: 8px;
	max-height: ${({ isVisible: isVisible })=>isVisible ? "2000px" : "0"};
	opacity: ${({ isVisible: isVisible })=>isVisible ? "1" : "0"};
	overflow: hidden;
	transition:
		max-height 0.3s ease-in-out,
		opacity 0.3s ease-in-out,
		margin-top 0.3s ease-in-out,
		padding 0.3s ease-in-out;
`;
const $90cc3bc45cc54aca$var$ReferenceHeader = (0, $5UMQ1.default).div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`;
const $90cc3bc45cc54aca$var$ReferenceHeaderLeft = (0, $5UMQ1.default).div`
	display: flex;
	align-items: center;
	gap: 8px;
`;
const $90cc3bc45cc54aca$var$ReferenceTitle = (0, $5UMQ1.default).h2`
	font-family:
		"Rubik",
		system-ui,
		-apple-system,
		"Segoe UI",
		Roboto,
		"Helvetica Neue",
		Arial;
	font-size: 20px;
	font-weight: 500;
	color: ${(0, $kKnoQ.colors).black};
	margin: 0;
`;
const $90cc3bc45cc54aca$var$InfoIcon = (0, $5UMQ1.default).div`
	width: 16px;
	height: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	color: ${(0, $kKnoQ.colors).grey};

	svg {
		width: 16px;
		height: 16px;
	}
`;
const $90cc3bc45cc54aca$var$ToggleButton = (0, $5UMQ1.default).button`
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 16px;
	font-weight: 700;
	color: ${(0, $kKnoQ.colors).grey};
	background: none;
	border: none;
	cursor: pointer;
	padding: 0;
	margin: 0;
	transition: opacity 0.2s ease;

	&:hover {
		opacity: 0.7;
	}
`;
const $90cc3bc45cc54aca$var$ReferenceDivider = (0, $5UMQ1.default).div`
	width: 100%;
	height: 1px;
	background: ${(0, $kKnoQ.colors).grey25};
	flex-shrink: 0;
`;
const $90cc3bc45cc54aca$var$ReferenceText = (0, $5UMQ1.default).div`
	font-family:
		"Nunito",
		system-ui,
		-apple-system,
		"Segoe UI",
		Roboto,
		"Helvetica Neue",
		Arial;
	font-size: 14px;
	line-height: 1.6;
	color: ${(0, $kKnoQ.colors).black};
	white-space: pre-wrap;
	padding-left: 16px;
	max-height: ${({ isVisible: isVisible })=>isVisible ? "2000px" : "0"};
	opacity: ${({ isVisible: isVisible })=>isVisible ? "1" : "0"};
	overflow: hidden;
	transition:
		max-height 0.3s ease-in-out,
		opacity 0.3s ease-in-out;

	ul {
		margin: 0;
		padding: 0;
		list-style: none;
	}

	li {
		margin-left: 21px;
		position: relative;

		&::before {
			content: "•";
			position: absolute;
			left: -21px;
		}
	}

	p {
		margin: 4px 0;

		&:first-child {
			margin-top: 0;
		}

		&:last-child {
			margin-bottom: 0;
		}
	}
`;
// Feedback Styles
const $90cc3bc45cc54aca$var$FeedbackSection = (0, $5UMQ1.default).section`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
	margin-top: ${({ isVisible: isVisible })=>isVisible ? "40px" : "0"};
	width: 100%;
	max-height: ${({ isVisible: isVisible })=>isVisible ? "2000px" : "0"};
	opacity: ${({ isVisible: isVisible })=>isVisible ? "1" : "0"};
	overflow: hidden;
	transition:
		max-height 0.3s ease-in-out,
		opacity 0.3s ease-in-out,
		margin-top 0.3s ease-in-out;
`;
const $90cc3bc45cc54aca$var$ThankYouMessage = (0, $5UMQ1.default).div`
    width: 100%;
    text-align: center;
    font-family:
        "Rubik",
        system-ui,
        -apple-system,
        "Segoe UI",
        Roboto,
        "Helvetica Neue",
        Arial;
    font-size: 16px;
    font-weight: 500;
    color: ${(0, $kKnoQ.colors).black};
    margin-top: 40px;
    max-height: ${({ isVisible: isVisible })=>isVisible ? "200px" : "0"};
    opacity: ${({ isVisible: isVisible })=>isVisible ? "1" : "0"};
    overflow: hidden;
    transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out, margin-top 0.3s ease-in-out;
`;
const $90cc3bc45cc54aca$var$FeedbackTitle = (0, $5UMQ1.default).p`
	font-family:
		"Rubik",
		system-ui,
		-apple-system,
		"Segoe UI",
		Roboto,
		"Helvetica Neue",
		Arial;
	font-size: 16px;
	font-weight: 500;
	color: ${(0, $kKnoQ.colors).black};
	margin: 0;
	text-align: center;
`;
const $90cc3bc45cc54aca$var$FeedbackButtons = (0, $5UMQ1.default).div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;
`;
// Footer Styles
const $90cc3bc45cc54aca$var$FooterSection = (0, $5UMQ1.default).footer`
	width: 100%;
	max-width: 400px;
	margin: ${({ isVisible: isVisible })=>isVisible ? "32px auto 0" : "0 auto"};
	padding-top: ${({ isVisible: isVisible })=>isVisible ? "24px" : "0"};
	max-height: ${({ isVisible: isVisible })=>isVisible ? "500px" : "0"};
	opacity: ${({ isVisible: isVisible })=>isVisible ? "1" : "0"};
	overflow: hidden;
	transition:
		max-height 0.3s ease-in-out,
		opacity 0.3s ease-in-out,
		margin-top 0.3s ease-in-out,
		padding-top 0.3s ease-in-out;
`;
const $90cc3bc45cc54aca$var$FooterText = (0, $5UMQ1.default).div`
	font-family:
		"Nunito",
		system-ui,
		-apple-system,
		"Segoe UI",
		Roboto,
		"Helvetica Neue",
		Arial;
	font-size: 13px;
	line-height: 1.6;
	color: ${(0, $kKnoQ.colors).black};
	text-align: center;
`;



var $kKnoQ = parcelRequire("kKnoQ");

var $bl9tw = parcelRequire("bl9tw");

var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");


var $1eHG3 = parcelRequire("1eHG3");
var $f7a95d68391463e9$var$ArrowUp = function ArrowUp(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "m35.422 18.753-8.6-8.581a4 4 0 0 0-5.64 0l-8.601 8.58a2 2 0 1 0 2.84 2.82l6.58-6.58v22.001a2 2 0 1 0 4 0v-22l6.58 6.58a2.001 2.001 0 1 0 2.841-2.82Z",
            fill: "#fff"
        })
    });
};
$f7a95d68391463e9$var$ArrowUp.defaultProps = {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $f7a95d68391463e9$var$THRESHOLD_PX = 600;
const $f7a95d68391463e9$export$e0a2fa2ca78dc95 = ({ inline: inline = false })=>{
    const [visible, setVisible] = (0, $81g6h.useState)(false);
    const { format: format } = (0, $1eHG3.useI18n)();
    const onScroll = (0, $81g6h.useCallback)(()=>{
        const y = window.scrollY || window.pageYOffset;
        setVisible(y > $f7a95d68391463e9$var$THRESHOLD_PX);
    }, []);
    (0, $81g6h.useEffect)(()=>{
        onScroll();
        window.addEventListener("scroll", onScroll, {
            passive: true
        });
        return ()=>window.removeEventListener("scroll", onScroll);
    }, [
        onScroll
    ]);
    const handleClick = ()=>{
        if (typeof window !== "undefined") {
            const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
            window.scrollTo({
                top: 0,
                behavior: prefersReduced ? "auto" : "smooth"
            });
        }
    };
    const isVisible = visible;
    const classNames = [
        "scroll-to-top",
        isVisible ? "visible" : "",
        inline ? "vertical" : ""
    ].join(" ").trim();
    return /*#__PURE__*/ (0, $iKObn.jsxs)("button", {
        className: classNames,
        onClick: handleClick,
        "aria-label": format("global.scrollToTop"),
        "aria-hidden": !isVisible,
        type: "button",
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                className: "arrow-wrap",
                children: /*#__PURE__*/ (0, $iKObn.jsx)($f7a95d68391463e9$var$ArrowUp, {
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                className: "label-wrap",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("span", {
                    className: "scroll-label",
                    children: format("global.scrollToTop")
                })
            })
        ]
    });
};
var $f7a95d68391463e9$export$2e2bcd8739ae039 = $f7a95d68391463e9$export$e0a2fa2ca78dc95;


var $d6963d219c9955c1$var$BackIcon = function BackIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M10 5.342c-.256 0-.512.1-.707.295l-5.656 5.656a.999.999 0 0 0 0 1.414l5.656 5.656a.999.999 0 0 0 1.414 0l.086-.086a.999.999 0 0 0 0-1.414L6.93 13H20a1 1 0 0 0 0-2H6.93l3.863-3.863a.999.999 0 0 0 0-1.414l-.086-.086A.998.998 0 0 0 10 5.342Z",
            fill: "currentColor"
        })
    });
};
$d6963d219c9955c1$var$BackIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $d6963d219c9955c1$export$a89930b0684a2a79 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const goBack = (0, $htiSH.useGoBack)();
    const { documentId: documentId } = (0, $hE6rp.useParams)();
    const [item, setItem] = (0, $81g6h.useState)(null);
    const [loading, setLoading] = (0, $81g6h.useState)(true);
    const [error, setError] = (0, $81g6h.useState)(null);
    const maxScrollPercentageRef = (0, $81g6h.useRef)(0);
    const calculateScrollPercentage = (0, $81g6h.useCallback)(()=>{
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        return docHeight > 0 ? Math.round(scrollTop / docHeight * 100) : 0;
    }, []);
    const handleRetry = (0, $81g6h.useCallback)(()=>{
        if (!documentId) return;
        setLoading(true);
        setError(null);
        (0, $ghfIB.learnManager).getItem(documentId).then((document1)=>{
            setItem(document1);
        }).catch((e)=>{
            console.error("[LearnDocumentPage] Failed to load document", e);
            setError("Failed to load document. Please try again.");
        }).finally(()=>{
            setLoading(false);
        });
    }, [
        documentId
    ]);
    (0, $81g6h.useEffect)(()=>{
        let mounted = true;
        if (!documentId) {
            setError("No document ID provided");
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        (0, $ghfIB.learnManager).getItem(documentId).then((document1)=>{
            if (!mounted) return;
            setItem(document1);
        }).catch((e)=>{
            console.error("[LearnDocumentPage] Failed to load document", e);
            if (mounted) setError("Failed to load document. Please try again.");
        }).finally(()=>{
            if (mounted) setLoading(false);
        });
        return ()=>{
            mounted = false;
        };
    }, [
        documentId
    ]);
    (0, $81g6h.useEffect)(()=>{
        const handleScroll = ()=>{
            const currentPercent = calculateScrollPercentage();
            if (currentPercent > maxScrollPercentageRef.current) maxScrollPercentageRef.current = currentPercent;
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        calculateScrollPercentage
    ]);
    (0, $81g6h.useEffect)(()=>()=>{
            if (item && documentId) {
                const percentValue = maxScrollPercentageRef.current;
                (0, $4130d988bf8cb7b5$export$b872f0fcdfaf46f6)(item.mediaType, documentId, percentValue);
            }
        }, [
        item,
        documentId
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($d6963d219c9955c1$var$PageWrapper, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($d6963d219c9955c1$var$HeaderSection, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($d6963d219c9955c1$var$BackButton, {
                        as: "button",
                        onClick: goBack,
                        "aria-label": format("global.dialog.back"),
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)($d6963d219c9955c1$var$BackIcon, {
                                width: 20,
                                height: 20,
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($d6963d219c9955c1$var$BackLabel, {
                                children: format("global.dialog.back")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($d6963d219c9955c1$var$PageTitle, {
                        children: format("tabbar.learn")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($d6963d219c9955c1$var$ContentContainer, {
                children: /*#__PURE__*/ (0, $iKObn.jsxs)($d6963d219c9955c1$var$ContentCard, {
                    children: [
                        loading && /*#__PURE__*/ (0, $iKObn.jsxs)($d6963d219c9955c1$var$LoadingMessage, {
                            role: "status",
                            "aria-live": "polite",
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)($d6963d219c9955c1$var$LoadingSpinner, {}),
                                /*#__PURE__*/ (0, $iKObn.jsx)($d6963d219c9955c1$var$LoadingText, {
                                    children: "Loading content..."
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0, $iKObn.jsxs)($d6963d219c9955c1$var$ErrorMessage, {
                            role: "alert",
                            "aria-live": "assertive",
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)($d6963d219c9955c1$var$ErrorTitle, {
                                    children: "Unable to Load Content"
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)($d6963d219c9955c1$var$ErrorText, {
                                    children: error
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)($d6963d219c9955c1$var$RetryButton, {
                                    onClick: handleRetry,
                                    children: "Try Again"
                                })
                            ]
                        }),
                        !loading && !error && item && /*#__PURE__*/ (0, $iKObn.jsx)("article", {
                            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $90cc3bc45cc54aca$export$508bbe50647e594), {
                                item: item
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $f7a95d68391463e9$export$2e2bcd8739ae039), {
                inline: true
            })
        ]
    });
};
const $d6963d219c9955c1$var$PageWrapper = (0, $5UMQ1.default).div`
	width: 100%;
	min-height: 100vh;
	background: ${(0, $kKnoQ.colors).grey5};
`;
const $d6963d219c9955c1$var$HeaderSection = (0, $5UMQ1.default).div`
	max-width: 1200px;
	margin: 0 auto;
	padding: 32px 24px 24px 24px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 24px 20px 20px 20px;
	}

	@media (max-width: 520px) {
		padding: 20px 16px 16px 16px;
	}
`;
const $d6963d219c9955c1$var$BackButton = (0, $5UMQ1.default).button`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
	color: ${(0, $kKnoQ.colors).primary};
	background: transparent;
	border: none;
	padding: 8px 0;
	font-family: ${(0, $bl9tw.fonts).body};
	transition: color 0.2s ease;
	margin-bottom: 16px;

	&:hover {
		color: ${(0, $kKnoQ.colors).primaryDark};
	}

	&:focus {
		outline: 2px solid ${(0, $kKnoQ.colors).primary};
		outline-offset: 2px;
		border-radius: 4px;
	}

	&:active {
		transform: scale(0.98);
	}

	svg {
		flex-shrink: 0;
		path {
			fill: currentColor;
		}
	}
`;
const $d6963d219c9955c1$var$BackLabel = (0, $5UMQ1.default).span`
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 16px;
	font-weight: 600;
	line-height: 1.5;
	color: ${(0, $kKnoQ.colors).primary};
`;
const $d6963d219c9955c1$var$PageTitle = (0, $5UMQ1.default).h1`
	font-family: ${(0, $bl9tw.fonts).header};
	font-size: 32px;
	font-weight: 700;
	color: ${(0, $kKnoQ.colors).black};
	margin: 0;

	@media (max-width: 520px) {
		font-size: 28px;
	}
`;
const $d6963d219c9955c1$var$ContentContainer = (0, $5UMQ1.default).div`
	max-width: 1200px;
	margin: 0 auto;
	padding: 0 24px 48px 24px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 0 20px 40px 20px;
	}

	@media (max-width: 520px) {
		padding: 0 16px 32px 16px;
	}
`;
const $d6963d219c9955c1$var$ContentCard = (0, $5UMQ1.default).div`
	background: ${(0, $kKnoQ.colors).white};
	border-radius: 16px;
	padding: 64px 120px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 48px;
		border-radius: 12px;
	}

	@media (max-width: 520px) {
		padding: 24px;
		border-radius: 12px;
	}
`;
const $d6963d219c9955c1$var$LoadingMessage = (0, $5UMQ1.default).div`
	width: 100%;
	text-align: center;
	padding: 80px 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
`;
const $d6963d219c9955c1$var$LoadingSpinner = (0, $5UMQ1.default).div`
	width: 40px;
	height: 40px;
	border: 4px solid ${(0, $kKnoQ.colors).primary25};
	border-top-color: ${(0, $kKnoQ.colors).primary};
	border-radius: 50%;
	animation: spin 0.8s linear infinite;

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}
`;
const $d6963d219c9955c1$var$LoadingText = (0, $5UMQ1.default).p`
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 16px;
	color: ${(0, $kKnoQ.colors).grey50};
	margin: 0;
`;
const $d6963d219c9955c1$var$ErrorMessage = (0, $5UMQ1.default).div`
	width: 100%;
	max-width: 500px;
	margin: 40px auto;
	padding: 32px;
	background: ${(0, $kKnoQ.colors).rejection10};
	border: 1px solid ${(0, $kKnoQ.colors).rejection25};
	border-radius: 12px;
	text-align: center;
`;
const $d6963d219c9955c1$var$ErrorTitle = (0, $5UMQ1.default).h2`
	font-family: ${(0, $bl9tw.fonts).header};
	font-size: 20px;
	font-weight: 700;
	color: ${(0, $kKnoQ.colors).rejectionDark};
	margin: 0 0 12px 0;
`;
const $d6963d219c9955c1$var$ErrorText = (0, $5UMQ1.default).p`
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 14px;
	color: ${(0, $kKnoQ.colors).rejectionDark};
	margin: 0 0 20px 0;
	line-height: 1.5;
`;
const $d6963d219c9955c1$var$RetryButton = (0, $5UMQ1.default).button`
	padding: 10px 24px;
	background: ${(0, $kKnoQ.colors).primary};
	color: ${(0, $kKnoQ.colors).white};
	border: none;
	border-radius: 8px;
	font-family: ${(0, $bl9tw.fonts).body};
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		background: ${(0, $kKnoQ.colors).primaryDark};
		transform: translateY(-1px);
	}

	&:focus {
		outline: 2px solid ${(0, $kKnoQ.colors).primary};
		outline-offset: 2px;
	}

	&:active {
		transform: translateY(0);
	}
`;
var $d6963d219c9955c1$export$2e2bcd8739ae039 = $d6963d219c9955c1$export$a89930b0684a2a79;



var $iKObn = parcelRequire("iKObn");

var $giAv5 = parcelRequire("giAv5");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $4UKJF = parcelRequire("4UKJF");

var $02mFA = parcelRequire("02mFA");

var $5UMQ1 = parcelRequire("5UMQ1");

var $lDZlX = parcelRequire("lDZlX");

var $iKObn = parcelRequire("iKObn");

var $5UMQ1 = parcelRequire("5UMQ1");

var $8miOT = parcelRequire("8miOT");

var $5kXMA = parcelRequire("5kXMA");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $hAuJ9 = parcelRequire("hAuJ9");

var $81g6h = parcelRequire("81g6h");

var $22plg = parcelRequire("22plg");
var $fb0ab2b1dee10f6f$var$CircleBg = function CircleBg(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                opacity: ".2",
                cx: "679.388",
                cy: "678.678",
                rx: "679.388",
                ry: "678.678",
                transform: "matrix(-.99702 -.07711 -.07728 .99701 1460.25 105.701)",
                fill: "#D0D2F8"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                opacity: ".15",
                cx: "499.497",
                cy: "498.975",
                rx: "499.497",
                ry: "498.975",
                transform: "matrix(-.99702 -.07711 -.07728 .99701 1266.61 271.32)",
                fill: "#D0D2F8"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("ellipse", {
                opacity: ".12",
                cx: "296.835",
                cy: "296.524",
                rx: "296.835",
                ry: "296.524",
                transform: "matrix(-.99702 -.07711 -.07728 .99701 1049.17 457.883)",
                fill: "#D0D2F8"
            })
        ]
    });
};
$fb0ab2b1dee10f6f$var$CircleBg.defaultProps = {
    width: "1461",
    height: "1459",
    viewBox: "0 0 1461 1459",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $fb0ab2b1dee10f6f$var$RESPONSIVE_PADDING = {
    [(0, $5kXMA.ResponsiveDeviceType).Desktop]: 24,
    [(0, $5kXMA.ResponsiveDeviceType).Tablet]: 32,
    [(0, $5kXMA.ResponsiveDeviceType).Mobile]: 16
};
const $fb0ab2b1dee10f6f$export$650a10f2d998a0d8 = ({ form: form, children: children })=>{
    const { height: height, ref: ref } = (0, $22plg.useResizeDetector)();
    const { responsiveDeviceType: responsiveDeviceType, isMobile: isMobile } = (0, $5kXMA.useDimensions)();
    const backgroundOffset = (0, $81g6h.useMemo)(()=>{
        if ((0, $lTdpc.isNil)(height)) return 0;
        return height + $fb0ab2b1dee10f6f$var$RESPONSIVE_PADDING[responsiveDeviceType] * 2;
    }, [
        height,
        responsiveDeviceType
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($fb0ab2b1dee10f6f$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)($fb0ab2b1dee10f6f$var$FormContainer, {
                ref: ref,
                children: [
                    isMobile && /*#__PURE__*/ (0, $iKObn.jsx)($fb0ab2b1dee10f6f$var$RowContactSupport, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($fb0ab2b1dee10f6f$var$SubnavigationContainer, {
                            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $8miOT.ContactSupport), {
                                uiStyle: "secondary"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($fb0ab2b1dee10f6f$var$FormCard, {
                        children: form
                    })
                ]
            }),
            children,
            /*#__PURE__*/ (0, $iKObn.jsx)($fb0ab2b1dee10f6f$var$BackgroundCircles, {
                insetTop: backgroundOffset
            })
        ]
    });
};
const $fb0ab2b1dee10f6f$var$Container = (0, $5UMQ1.default).div`
	background-color: ${(0, $kKnoQ.colors).primary10};
	min-height: 100vh;
	width: 100%;
	max-width: 100vw;
	flex: 1;
	display: flex;
	flex-direction: row;
	padding: ${$fb0ab2b1dee10f6f$var$RESPONSIVE_PADDING[(0, $5kXMA.ResponsiveDeviceType).Desktop]}px;
	gap: 56px;
	position: relative;
	z-index: 1;
	align-items: flex-start;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		flex-direction: column;
		padding: 0 0 100px 0;
		gap: 0;
		overflow: hidden;
		align-items: initial;
	}
`;
const $fb0ab2b1dee10f6f$var$RowContactSupport = (0, $5UMQ1.default).span`
	${(0, $5WGN2.stack)(8, undefined, "stretch")}
	margin-bottom: 50px;
`;
const $fb0ab2b1dee10f6f$var$SubnavigationContainer = (0, $5UMQ1.default).span`
	align-self: start;
	position: absolute;
	top: 0px;
	right: 0px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		margin-top: 24px;
		margin-right: 16px;
	}
`;
const $fb0ab2b1dee10f6f$var$FormContainer = (0, $5UMQ1.default).div`
	width: 50%;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: ${$fb0ab2b1dee10f6f$var$RESPONSIVE_PADDING[(0, $5kXMA.ResponsiveDeviceType).Tablet]}px 16px;
		background-color: ${(0, $kKnoQ.colors).white};
		width: 100%;
	}
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding: ${$fb0ab2b1dee10f6f$var$RESPONSIVE_PADDING[(0, $5kXMA.ResponsiveDeviceType).Mobile]}px;
	}
`;
const $fb0ab2b1dee10f6f$var$FormCard = (0, $5UMQ1.default).div`
	flex: 1;
	display: flex;
	border-radius: 40px;
	background-color: ${(0, $kKnoQ.colors).white};
	padding: 80px 40px;
	justify-content: center;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 0 0;
		min-width: 500px;
	}
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding: 0 16px;
		min-width: unset;
	}
`;
const $fb0ab2b1dee10f6f$var$BackgroundCircles = (0, $5UMQ1.default).div`
	background-image: ${(0, $hAuJ9.svgComponentToCSS)(/*#__PURE__*/ (0, $iKObn.jsx)($fb0ab2b1dee10f6f$var$CircleBg, {
    width: 1459,
    height: "100%"
}))};
	height: 100%;
	width: 50%;
	position: fixed;
	background-repeat: no-repeat;
	right: 0px;
	bottom: 0px;
	-webkit-background-position: right bottom;
	background-position: initial;
	z-index: -2;
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		top: ${({ insetTop: insetTop })=>insetTop}px;
		background-position-x: 50%;
		width: 100%;
		position: absolute;
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		background-image: ${(0, $hAuJ9.svgComponentToCSS)(/*#__PURE__*/ (0, $iKObn.jsx)($fb0ab2b1dee10f6f$var$CircleBg, {
    width: 1459,
    height: "100%"
}))};
		left: 0px;
		top: 890px;
	}
`;



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
var $b729670b658a16e1$var$IdentityIcon = function IdentityIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M12 3c-4.959 0-9 4.041-9 9 0 4.067 1.782 7.97 2.662 9.65.255.486.859.637 1.329.356l.018-.011c.47-.282.63-.89.384-1.38C6.583 19.007 5 15.425 5 12c0-3.877 3.123-7 7-7s7 3.123 7 7c0 .565-.435 1-1 1s-1-.435-1-1c0-2.75-2.25-5-5-5s-5 2.25-5 5c0 5.157 3.92 8.256 5.697 9.395.462.297 1.057.096 1.303-.395.246-.492.055-1.103-.401-1.41C12.068 18.563 9 16.003 9 12c0-1.668 1.332-3 3-3s3 1.332 3 3c0 1.645 1.355 3 3 3s3-1.355 3-3c0-4.959-4.041-9-9-9Zm0 8c-.552 0-1.005.45-.94.998.178 1.526.78 3.27 2.051 4.774 1.416 1.673 3.684 2.97 6.89 3.194.55.038.999-.414.999-.966s-.45-.995-1-1.037c-2.662-.204-4.298-1.228-5.361-2.485-.906-1.07-1.382-2.362-1.558-3.482C12.996 11.45 12.552 11 12 11Z",
            fill: "currentColor"
        })
    });
};
$b729670b658a16e1$var$IdentityIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $b729670b658a16e1$var$LockIcon = function LockIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M12 1C8.676 1 6 3.676 6 7v1c-1.093 0-2 .907-2 2v10c0 1.093.907 2 2 2h12c1.093 0 2-.907 2-2V10c0-1.093-.907-2-2-2V7c0-3.324-2.676-6-6-6Zm0 2c2.276 0 4 1.724 4 4v1H8V7c0-2.276 1.724-4 4-4Zm-6 7h12v10H6V10Zm6 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z",
            fill: "currentColor"
        })
    });
};
$b729670b658a16e1$var$LockIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $b729670b658a16e1$var$ShieldIcon = function ShieldIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.892 3.038C10.042 4.652 7.322 6 5 6v7c0 2.236.77 3.861 1.987 5.106 1.243 1.274 2.997 2.194 5.01 2.889l.022.008c2.005-.7 3.754-1.622 4.995-2.895C18.229 16.861 19 15.236 19 13V6c-2.32 0-5.032-1.338-6.892-2.962a.17.17 0 0 0-.216 0ZM10.59 1.52a2.17 2.17 0 0 1 2.82 0l.008.007C15.058 2.961 17.323 4 19 4a2 2 0 0 1 2 2v7c0 2.764-.98 4.889-2.554 6.504-1.547 1.588-3.625 2.64-5.777 3.39l-.008.003a2 2 0 0 1-1.327-.015c-2.154-.745-4.231-1.794-5.778-3.378C3.979 17.889 3 15.764 3 13V6a2 2 0 0 1 2-2c1.676 0 3.952-1.049 5.582-2.473l.008-.007Z",
            fill: "currentColor"
        })
    });
};
$b729670b658a16e1$var$ShieldIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $b729670b658a16e1$var$stepDataDescription = {
    [(0, $0fc3fe377bd96867$export$6328d0aeff8e1740).PROFESSIONAL_INFORMATION]: {
        title: "register.description.professionalinformation.title",
        note1: "register.description.professionalinformation.note1",
        note2: "register.description.professionalinformation.note2",
        icon: $b729670b658a16e1$var$ShieldIcon
    },
    [(0, $0fc3fe377bd96867$export$6328d0aeff8e1740).IDENTITY_VERIFICATION]: {
        title: "register.description.checkidentity.title",
        note1: "register.description.checkidentity.note1",
        note2: "register.description.checkidentity.note2",
        icon: $b729670b658a16e1$var$IdentityIcon
    }
};
function $b729670b658a16e1$export$2e2bcd8739ae039({ step: step }) {
    const { format: format } = (0, $1eHG3.useI18n)();
    const { icon: Icon, title: title, note1: note1, note2: note2 } = $b729670b658a16e1$var$stepDataDescription[step];
    return /*#__PURE__*/ (0, $iKObn.jsxs)($b729670b658a16e1$var$ContentRight, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($b729670b658a16e1$var$StyledSubTitle, {
                children: format(title)
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($b729670b658a16e1$var$NotesContainer, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($b729670b658a16e1$var$StyledIcon, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)(Icon, {
                            width: 16,
                            color: (0, $kKnoQ.colors).white
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        className: "p-size-m",
                        children: format(note1)
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($b729670b658a16e1$var$StyledIcon, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($b729670b658a16e1$var$LockIcon, {
                            width: 16,
                            color: (0, $kKnoQ.colors).white
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        className: "p-size-m",
                        children: format(note2)
                    })
                ]
            })
        ]
    });
}
const $b729670b658a16e1$var$ContentRight = (0, $5UMQ1.default).div`
	position: sticky;
	width: 50%;
	top: 100px;
	z-index: 2;
	color: ${(0, $kKnoQ.colors).grey};
	padding-top: 140px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding: 48px 32px;
		width: 100%;
	}
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding: 48px 16px;
	}
`;
const $b729670b658a16e1$var$StyledSubTitle = (0, $5UMQ1.default).h2`
	font-size: 24px;
	margin-bottom: 32px;
`;
const $b729670b658a16e1$var$NotesContainer = (0, $5UMQ1.default).div`
	display: grid;
	grid-template-columns: auto 1fr;
	gap: 16px;
	line-height: 32px;
`;
const $b729670b658a16e1$var$StyledIcon = (0, $5UMQ1.default).div`
	background-color: ${(0, $kKnoQ.colors).primary};
	border-radius: 16px;
	padding: 8px;
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
`;




var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $8miOT = parcelRequire("8miOT");

var $c22GE = parcelRequire("c22GE");

var $5kXMA = parcelRequire("5kXMA");

var $lDZlX = parcelRequire("lDZlX");

var $8MrZI = parcelRequire("8MrZI");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("81g6h");
var $5135f0a1c7d195bf$var$CheckIcon = function CheckIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.064 5.318c.449.449.449 1.177 0 1.626L9.325 18.683a1.15 1.15 0 0 1-1.626 0L2.936 13.92a1.15 1.15 0 0 1 1.627-1.627l3.95 3.95L19.437 5.318a1.15 1.15 0 0 1 1.626 0Z",
            fill: "currentColor"
        })
    });
};
$5135f0a1c7d195bf$var$CheckIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $5135f0a1c7d195bf$var$VerifyAccountIcon = function VerifyAccountIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                clipPath: "url(#clip0_352_116075)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M53.737 4.34 4.844 53.231c-5.786 5.785-5.786 15.166 0 20.952l48.893 48.892c5.785 5.786 15.166 5.786 20.952 0l48.892-48.892c5.786-5.786 5.786-15.166 0-20.952L74.689 4.339c-5.786-5.785-15.167-5.785-20.952 0Z",
                        fill: "#F5EEFD"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask0_352_116075",
                        style: {
                            maskType: "alpha"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0",
                        width: "128",
                        height: "128",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M53.737 4.34 4.844 53.231c-5.786 5.785-5.786 15.166 0 20.952l48.893 48.892c5.785 5.786 15.166 5.786 20.952 0l48.892-48.892c5.786-5.786 5.786-15.166 0-20.952L74.689 4.339c-5.786-5.785-15.167-5.785-20.952 0Z",
                            fill: "#F5EEFD"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask0_352_116075)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "m22.357 130.847 9.712-34.309c2.9-10.251 11.8-17.79 22.281-18.27.38-.017.752-.026 1.133-.026l39.211.558c8.064.112 14.852 6.173 15.993 14.278l8.224 38.164-24.217 22.59-72.345-22.993.008.008Z",
                                fill: "#309"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M93.434 130.682 89.191 87.41l-12.518 1.657 13.752 41.272",
                                fill: "#1C0060"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                                id: "mask1_352_116075",
                                style: {
                                    maskType: "luminance"
                                },
                                maskUnits: "userSpaceOnUse",
                                x: "57",
                                y: "33",
                                width: "42",
                                height: "62",
                                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                    d: "M57.731 78.302c3.187-.043 5.748-2.68 5.748-5.916V33.493l20.836-.49c7.404-.172 12.983 6.86 11.174 14.158-.034.146 1.69 2.73 3.136 4.86.854 1.253.05 2.979-1.445 3.116l-.626.06 1.817 10.063c.626 3.486-2.011 6.697-5.502 6.697h-3.584v16.132c0 4.954-5.477 7.865-9.484 5.049L57.714 78.31l.017-.008Z",
                                    fill: "#fff"
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                                mask: "url(#mask1_352_116075)",
                                children: [
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M101.738 96.883c15.701-12.078 18.796-34.789 6.913-50.725-11.883-15.937-34.244-19.064-49.944-6.985-15.7 12.078-18.795 34.789-6.912 50.725 11.883 15.937 34.243 19.064 49.943 6.985Z",
                                        fill: "#50F"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M61.298 87.282c12.662 11.076 31.74 10.535 43.598-1.476 5.419-5.487 8.318-12.518 8.707-19.687.448-8.174-2.587-16.416-8.605-22.778-2.392-2.525-5.055-4.654-7.912-6.277-11.462-6.465-26.279-5.091-36.43 4.448-4.015 3.795-7.32 8.517-8.74 13.685-1.437 5.212-.677 10.44.481 15.6.888 3.967 1.978 7.891 4.269 11.368 1.268 1.915 2.89 3.58 4.649 5.117h-.017Z",
                                        fill: "#4427F9"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M61.45 86.716c14.556 11.162 35.282 10.423 48.721-2.18 5.934-5.573 9.307-12.785 10.059-20.314.854-8.586-2.223-17.31-8.14-24.384-2.553-3.056-5.401-5.795-8.52-7.959-12.468-8.569-29.711-8.543-42.196 1.4-4.91 3.915-9.83 9.178-11.656 15.24-1.902 6.336.22 12.354 1.581 18.519 1.056 4.79 1.606 9.65 4.32 13.849 1.504 2.326 3.642 4.147 5.831 5.83Z",
                                        fill: "#334EF4"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M74.001 76.448c12.215 7.761 28.486 6.886 39.694-2.413 4.674-3.88 7.607-8.98 8.588-14.544 1.115-6.336-.972-12.956-4.886-18.588-1.944-2.8-4.108-5.444-6.559-7.616-9.721-8.611-24.58-10.311-36.126-3.1-4.497 2.808-9.975 7.084-11.724 12.356-1.91 5.77 1.327 10.886 2.527 16.373.938 4.327.6 8.852 2.984 12.646 1.335 2.121 3.432 3.564 5.502 4.877v.009Z",
                                        fill: "#2275EF"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M80.299 63.207c9.728 4.55 21.621 3.288 30.666-2.645 3.389-2.223 5.9-5.186 7.108-8.774 1.378-4.096.406-8.715-1.623-12.802-1.284-2.593-2.814-5.074-4.598-7.263-6.999-8.612-19.432-12.063-30.057-7.59-4.066 1.717-10.127 4.971-11.8 9.461-1.927 5.203 2.434 9.41 3.465 14.236.829 3.863-.414 8.053 1.649 11.444 1.158 1.915 3.212 3.005 5.181 3.924l.009.009Z",
                                        fill: "#119BEA"
                                    }),
                                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                        d: "M84.653 45.246c.533 2.559-1.073 5.478.237 7.736.744 1.288 2.232 1.915 3.669 2.25 5.418 1.27 11.03-.464 16.338-2.173 1.547-.498 3.17-1.047 4.261-2.266 1.234-1.391 1.538-3.443 1.234-5.29-.313-1.845-1.158-3.554-1.995-5.22-3.246-6.49-10.786-10.397-18.106-9.117-2.747.48-7.768 2.163-8.96 4.962-1.479 3.486 2.68 5.993 3.33 9.127l-.008-.009Z",
                                        fill: "#00C2E5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M94.448 34.797V34.6c-.169-5.014-4.716-8.68-9.56-7.676l-15.197 3.134c-9.501-.249-16.069 9.556-12.358 18.442l5.95 14.235.203.481v-13.96c0-1.975 1.53-3.598 3.466-3.684 1.978-.085 3.669 1.451 3.787 3.47.059.986.879 1.742 1.85 1.7l.652-.027a2.419 2.419 0 0 0 2.02-1.253l2.231-3.984a6.394 6.394 0 0 0 .153-5.941c-.905-1.83.405-3.984 2.425-3.984h5.943l4.395 2.009c1.944.884 4.116-.61 4.04-2.765Z",
                                fill: "#309"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "m56.37 78.293-.896 8.56c-.465 4.439 2.156 8.612 6.306 10.063l13.144 4.584-3.204 9.565c-1.107 3.314-.034 6.98 2.68 9.135l14.2 11.273M90.679 78.996l7.16 7.195a5.462 5.462 0 0 1 .963 5.563l-3.272 8.432 4.683 4.387a7.583 7.583 0 0 1 2.232 7.04l-3.914 19.318",
                                stroke: "#334EF4",
                                strokeMiterlimit: "10"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "m44.925 130.28 2.908-9.229",
                                stroke: "#1C0060",
                                strokeWidth: "3",
                                strokeMiterlimit: "10",
                                strokeLinecap: "round"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M20.502 49.724c.032-1.1.958-1.93 2.057-1.948 2.12-.036 5.417-.219 7.052-.963 1.617-.736 3.805-2.084 5.169-2.957a2.23 2.23 0 0 1 2.488.073c1.557 1.106 4.314 2.897 6.505 3.42 1.816.432 4.019.513 5.607.5 1.163-.009 2.164.877 2.168 2.04.014 3.91-.336 12.352-3.337 17.697-4.01 7.141-10.672 9.64-12.161 9.64-1.49 0-7.77-2.432-12.161-9.64-3.331-5.468-3.5-14.041-3.387-17.862Z",
                                fill: "#FFAF00"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M33.266 66.152c-.377 0-.766-.15-1.055-.44l-3.453-3.453a1.516 1.516 0 0 1 0-2.123 1.516 1.516 0 0 1 2.122 0l2.399 2.4 7.975-7.976a1.516 1.516 0 0 1 2.123 0c.577.59.577 1.532 0 2.123l-9.043 9.042c-.289.29-.678.44-1.055.44l-.013-.013Z",
                                fill: "#fff"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("defs", {
                children: /*#__PURE__*/ (0, $iKObn.jsx)("clipPath", {
                    id: "clip0_352_116075",
                    children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(.505)",
                        d: "M0 0h128v128H0z"
                    })
                })
            })
        ]
    });
};
$5135f0a1c7d195bf$var$VerifyAccountIcon.defaultProps = {
    width: "129",
    height: "128",
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $5135f0a1c7d195bf$export$3fc08bfee2beedb0 = ({ onNext: onNext })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    const { idTypeOptions: idTypeOptions } = (0, $8MrZI.useRegistrationCountryUserConfig)();
    const { isMobile: isMobile } = (0, $5kXMA.useDimensions)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($5135f0a1c7d195bf$var$Container, {
        children: [
            isMobile && /*#__PURE__*/ (0, $iKObn.jsx)($5135f0a1c7d195bf$var$RowContactSupport, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)($5135f0a1c7d195bf$var$SubnavigationContainer, {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $8miOT.ContactSupport), {
                        uiStyle: "secondary"
                    })
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($5135f0a1c7d195bf$var$VerifyAccountIcon, {}),
            /*#__PURE__*/ (0, $iKObn.jsx)("h3", {
                children: format("register.introduction.title")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                className: "p-size-m",
                children: format("register.introduction.description")
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($5135f0a1c7d195bf$var$Requirements, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                        className: "p-size-m",
                        children: format("register.introduction.requirements.title")
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($5135f0a1c7d195bf$var$Row, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                children: /*#__PURE__*/ (0, $iKObn.jsx)($5135f0a1c7d195bf$var$IconContainer, {
                                    children: /*#__PURE__*/ (0, $iKObn.jsx)($5135f0a1c7d195bf$var$CheckIcon, {
                                        width: 12,
                                        height: 12,
                                        color: (0, $kKnoQ.colors).primary
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                                className: "p-size-m",
                                children: format("register.introduction.requirements.license", {
                                    licenses: idTypeOptions.map((m)=>m.label).join(", ")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)($5135f0a1c7d195bf$var$Row, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                children: /*#__PURE__*/ (0, $iKObn.jsx)($5135f0a1c7d195bf$var$IconContainer, {
                                    children: /*#__PURE__*/ (0, $iKObn.jsx)($5135f0a1c7d195bf$var$CheckIcon, {
                                        width: 12,
                                        height: 12,
                                        color: (0, $kKnoQ.colors).primary
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("p", {
                                className: "p-size-m",
                                children: format("register.introduction.requirements.id")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($5135f0a1c7d195bf$var$NextButton, {
                label: format("global.dialog.continue"),
                onClick: onNext
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $c22GE.TertiaryButton), {
                label: format("register.introduction.cta.back"),
                onClick: ()=>{
                    (0, $ghfIB.analyticsService).trackEvent({
                        category: (0, $auPqo.AnalyticsCategory).REGISTRATION,
                        action: "doItLaterCta"
                    });
                    navigate((0, $lDZlX.RoutesPath).Home);
                }
            })
        ]
    });
};
const $5135f0a1c7d195bf$var$RowContactSupport = (0, $5UMQ1.default).span`
	${(0, $5WGN2.stack)(8, undefined, "stretch")}
	margin-bottom: 50px;
`;
const $5135f0a1c7d195bf$var$SubnavigationContainer = (0, $5UMQ1.default).span`
	align-self: start;
	position: absolute;
	top: 0px;
	right: 0px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		margin-top: 100px;
		margin-right: 16px;
	}
`;
const $5135f0a1c7d195bf$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(24, "center", "center")};
	max-width: 450px;
	margin: 0 12px;
`;
const $5135f0a1c7d195bf$var$Requirements = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(12, undefined, "flexstart")}
`;
const $5135f0a1c7d195bf$var$IconContainer = (0, $5UMQ1.default).div`
	width: 20px;
	height: 20px;
	border-radius: 10px;
	background-color: ${(0, $kKnoQ.colors).primary10};
	justify-content: center;
	align-items: center;
	display: flex;
	margin-top: 2px;
`;
const $5135f0a1c7d195bf$var$Row = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(12, undefined, "flexstart")}
`;
const $5135f0a1c7d195bf$var$NextButton = (0, $5UMQ1.default)((0, $dhb7H.Button))`
	align-self: stretch;
	margin-top: 16px;
`;



var $iKObn = parcelRequire("iKObn");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $5UMQ1 = parcelRequire("5UMQ1");

var $dhb7H = parcelRequire("dhb7H");

var $28f8Y = parcelRequire("28f8Y");

var $8FlUV = parcelRequire("8FlUV");

var $hIci4 = parcelRequire("hIci4");

var $1IlhR = parcelRequire("1IlhR");

var $02Kb9 = parcelRequire("02Kb9");

var $5kXMA = parcelRequire("5kXMA");

var $1acTy = parcelRequire("1acTy");

var $8MrZI = parcelRequire("8MrZI");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");

var $kKnoQ = parcelRequire("kKnoQ");

var $lTdpc = parcelRequire("lTdpc");

var $1IWnK = parcelRequire("1IWnK");

var $eT9rN = parcelRequire("eT9rN");

var $81g6h = parcelRequire("81g6h");

var $eKUeg = parcelRequire("eKUeg");
var $21b8e529c2343545$var$InfoIcon = function InfoIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12 23C5.93 23 1 18.07 1 12S5.93 1 12 1s11 4.93 11 11-4.93 11-11 11Zm0-20c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M12.01 17.17c-.55 0-1-.45-1-1v-5.44c0-.55.45-1 1-1s1 .45 1 1v5.44c0 .55-.45 1-1 1ZM12 8.11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
                fill: "currentColor"
            })
        ]
    });
};
$21b8e529c2343545$var$InfoIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $21b8e529c2343545$var$DEFAULT_REQUIRED_WORDING = "global.form.field.requiredError";
const $21b8e529c2343545$export$22a2716399e46fc9 = ({ onSuccess: onSuccess })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isMobile: isMobile } = (0, $5kXMA.useDimensions)();
    const { countryConfig: countryConfig } = (0, $1acTy.useCountryConfig)();
    const countryCode = (0, $1IWnK.useObservable)((0, $ghfIB.localeManager).countryCode);
    const user = (0, $1IWnK.useObservable)((0, $ghfIB.userManager).user);
    const { control: control, handleSubmit: handleSubmit, watch: watch, setValue: setValue, clearErrors: clearErrors } = (0, $eKUeg.useForm)({
        defaultValues: {
            cityOfPractice: "",
            postalCode: "",
            idType: undefined,
            idValue: undefined,
            medicalProfession: undefined
        }
    });
    const selectedIdName = watch("idType");
    const { idTypeOptions: idTypeOptions, medicalProfessionOptions: medicalProfessionOptions, isError: isError, isLoading: isLoading, isEmpty: isEmpty, selectedIdProps: selectedIdProps, selectedPostalCodeTemplate: selectedPostalCodeTemplate, refresh: refresh } = (0, $8MrZI.useRegistrationCountryUserConfig)(selectedIdName, (value)=>setValue("idType", value));
    const [sendRegistrationData, isSubmitLoading] = (0, $grmoS.useAsyncOperation)((0, $81g6h.useCallback)(async (data)=>{
        if (!(0, $lTdpc.isNotNil)(user)) throw new Error("User is not loaded");
        try {
            await (0, $ghfIB.registerManager).validateProfessionalInformation({
                ...data,
                firstName: user.firstName,
                lastName: user.lastName,
                professionalId: {
                    value: data.idValue,
                    countryCode: countryCode,
                    name: data.idType
                }
            });
            onSuccess();
        } catch (e) {
            console.error("Failed to send registration data", e);
            throw e;
        }
    }, [
        countryCode,
        onSuccess,
        user
    ]), {});
    let content;
    if (isLoading) content = /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {});
    else if (isError) content = /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
        onRefresh: refresh
    });
    else content = /*#__PURE__*/ (0, $iKObn.jsxs)($21b8e529c2343545$var$Form, {
        onSubmit: handleSubmit(sendRegistrationData),
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$Header, {
                className: "p-size-l-bold",
                children: format("register.professionalInfo.header")
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($21b8e529c2343545$var$TwoColumnLayout, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$Column, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                            name: "postalCode",
                            control: control,
                            rules: {
                                required: format($21b8e529c2343545$var$DEFAULT_REQUIRED_WORDING),
                                pattern: new RegExp(selectedPostalCodeTemplate?.validationRegex ?? "")
                            },
                            render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$Label, {
                                            className: "p-size-m",
                                            children: format("register.professionalInfo.postalCode.label")
                                        }),
                                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                            ...field,
                                            error: !!fieldState.error,
                                            placeholder: selectedPostalCodeTemplate?.placeholder ?? format("register.professionalInfo.postalCode.placeholder")
                                        }),
                                        /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$StyledErrorMessage, {
                                            children: fieldState.error?.message
                                        }),
                                        /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$StyledErrorMessage, {
                                            color: (0, $kKnoQ.colors).rejection,
                                            hidden: !(fieldState.error && (0, $lTdpc.isNotEmpty)(field.value)),
                                            children: format("register.professionalInfo.postalCode.errorText")
                                        })
                                    ]
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$Column, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                            name: "cityOfPractice",
                            control: control,
                            rules: {
                                required: format($21b8e529c2343545$var$DEFAULT_REQUIRED_WORDING)
                            },
                            render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$Label, {
                                            className: "p-size-m",
                                            children: format("register.professionalInfo.city.label")
                                        }),
                                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                            ...field,
                                            error: !!fieldState.error,
                                            placeholder: format("register.professionalInfo.city.placeholder")
                                        }),
                                        /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$StyledErrorMessage, {
                                            children: fieldState.error?.message
                                        })
                                    ]
                                })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$FormField, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                    name: "medicalProfession",
                    control: control,
                    rules: {
                        required: format("global.form.dropdown.requiredError")
                    },
                    render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$Label, {
                                    className: "p-size-m",
                                    children: format("register.professionalInfo.medicalExpertise.label")
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)((0, $eT9rN.Dropdown), {
                                    options: medicalProfessionOptions,
                                    optionLabel: "label",
                                    optionValue: "value",
                                    placeholder: format("global.form.dropdown.placeholder"),
                                    className: fieldState.error ? "p-invalid" : undefined,
                                    ...field
                                }),
                                /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$StyledErrorMessage, {
                                    children: fieldState.error?.message
                                })
                            ]
                        })
                })
            }),
            !isEmpty && /*#__PURE__*/ (0, $iKObn.jsxs)($21b8e529c2343545$var$TwoColumnLayout, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$Column, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                            name: "idType",
                            control: control,
                            rules: {
                                required: format("global.form.dropdown.requiredError"),
                                onChange: ()=>{
                                    clearErrors("idValue");
                                    setValue("idValue", "");
                                }
                            },
                            render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$Label, {
                                            className: "p-size-m",
                                            children: format("register.professionalInfo.idType.label")
                                        }),
                                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $eT9rN.Dropdown), {
                                            options: idTypeOptions,
                                            optionLabel: "label",
                                            optionValue: "value",
                                            placeholder: format("global.form.dropdown.placeholder"),
                                            className: fieldState.error ? "p-invalid" : undefined,
                                            ...field
                                        }),
                                        /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$StyledErrorMessage, {
                                            children: fieldState.error?.message
                                        })
                                    ]
                                })
                        })
                    }),
                    (0, $lTdpc.isNotNil)(selectedIdProps) && /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$Column, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $eKUeg.Controller), {
                            name: "idValue",
                            control: control,
                            rules: {
                                required: true,
                                pattern: new RegExp(selectedIdProps.regex)
                            },
                            render: ({ field: field, fieldState: fieldState })=>/*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $iKObn.jsxs)($21b8e529c2343545$var$LabelWithTooltip, {
                                            className: "p-size-m",
                                            children: [
                                                selectedIdProps.label,
                                                /*#__PURE__*/ (0, $iKObn.jsx)((0, $02Kb9.Tooltip), {
                                                    placement: "auto",
                                                    interactive: true,
                                                    content: /*#__PURE__*/ (0, $iKObn.jsxs)("div", {
                                                        children: [
                                                            selectedIdProps.description,
                                                            /*#__PURE__*/ (0, $iKObn.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $iKObn.jsx)("br", {}),
                                                            format("register.professionalInfo.idValue.tooltip.contactSupport", {
                                                                link: {
                                                                    onClick: ()=>window.open(`mailto:${countryConfig?.customerSupportEmail}`),
                                                                    className: "underline"
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    maxWidth: isMobile ? 250 : 400,
                                                    children: /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$InfoIcon, {
                                                            style: {
                                                                cursor: "help"
                                                            },
                                                            className: "info-icon-id-value",
                                                            width: 16,
                                                            height: 16,
                                                            color: (0, $kKnoQ.colors).grey
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $iKObn.jsx)((0, $hIci4.TextInput), {
                                            ...field,
                                            error: !!fieldState.error,
                                            placeholder: selectedIdProps.placeholder,
                                            maxLength: selectedIdProps.maxLength
                                        }),
                                        /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$HelpText, {
                                            color: fieldState.error ? (0, $kKnoQ.colors).rejection : (0, $kKnoQ.colors).grey,
                                            children: selectedIdProps.helpText
                                        })
                                    ]
                                })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($21b8e529c2343545$var$StyledButton, {
                label: format("register.professionalInfo.submitButton"),
                type: "submit",
                loading: isSubmitLoading
            })
        ]
    });
    return content;
};
const $21b8e529c2343545$var$HelpText = (0, $5UMQ1.default).div`
	margin-top: 8px;
	color: ${({ color: color })=>color};
`;
const $21b8e529c2343545$var$Label = (0, $5UMQ1.default).label`
	margin-bottom: 8px;
`;
const $21b8e529c2343545$var$LabelWithTooltip = (0, $5UMQ1.default).div`
	display: flex;
	place-items: center;
	gap: 8px;
	margin-bottom: 8px;
`;
const $21b8e529c2343545$var$Form = (0, $5UMQ1.default).form`
	max-width: 100%;
	display: flex;
	flex-direction: column;
	width: 684px;
`;
const $21b8e529c2343545$var$Header = (0, $5UMQ1.default).div`
	margin-bottom: 24px;
`;
const $21b8e529c2343545$var$StyledErrorMessage = (0, $5UMQ1.default)((0, $8FlUV.ErrorMessage))`
	margin-top: 8px;
`;
const $21b8e529c2343545$var$FormField = (0, $5UMQ1.default).div`
	display: grid;
	margin-bottom: 16px;
`;
const $21b8e529c2343545$var$TwoColumnLayout = (0, $5UMQ1.default)($21b8e529c2343545$var$FormField)`
	grid-template-columns: 1fr 1fr;
	gap: 16px;
	align-items: start;
	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		grid-template-columns: 1fr;
	}
`;
const $21b8e529c2343545$var$Column = (0, $5UMQ1.default).div`
	display: grid;
`;
const $21b8e529c2343545$var$StyledButton = (0, $5UMQ1.default)((0, $dhb7H.Button))`
	margin-top: 24px;
`;



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $9Q47x = parcelRequire("9Q47x");

var $dhb7H = parcelRequire("dhb7H");
parcelRequire("81g6h");

var $kKnoQ = parcelRequire("kKnoQ");

var $8miOT = parcelRequire("8miOT");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $5kXMA = parcelRequire("5kXMA");
var $c123d742886ed9f3$var$CheckMarkIcon = function CheckMarkIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M51.18 9.6H12.82c-3.546 0-6.42 2.996-6.42 6.69v31.42c0 3.695 2.874 6.69 6.42 6.69h38.36c3.545 0 6.42-2.995 6.42-6.69V16.29c0-3.694-2.875-6.69-6.42-6.69Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_124_11989",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "10",
                y: "0",
                width: "54",
                height: "43",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M27.428 42.164a5.151 5.151 0 0 1-3.64-1.507L11.904 28.773a5.157 5.157 0 0 1 0-7.28 5.157 5.157 0 0 1 7.28 0l8.244 8.25 27.44-27.44a5.157 5.157 0 0 1 7.28 0 5.157 5.157 0 0 1 0 7.28L31.073 40.658a5.151 5.151 0 0 1-3.64 1.507h-.006Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_124_11989)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M29.937 45.926c13.836 0 25.052-11.216 25.052-25.052S43.773-4.178 29.937-4.178c-13.835 0-25.052 11.216-25.052 25.052s11.217 25.052 25.052 25.052Z",
                        fill: "#29D37A"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M59.05 14.794c1.207 10.307-7.3 22.46-19.816 24.299-12.516 1.839-24.298-7.325-25.505-17.632-1.207-10.306 7.3-22.459 19.816-24.298C46.06-4.676 57.843 4.488 59.05 14.794Z",
                        fill: "#3ADE88"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M63.284 11.627c.804 6.871-6.373 18.73-17.657 20.799-11.29 2.069-22.408-6.43-23.213-13.302-.804-6.87 6.373-18.73 17.657-20.798 11.284-2.07 22.408 6.43 23.213 13.301Z",
                        fill: "#4CE997"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M67.524 8.46c.402 3.435-5.447 15-15.505 17.3-10.058 2.298-20.524-5.531-20.926-8.967-.403-3.435 5.447-15 15.504-17.299 10.058-2.299 20.525 5.53 20.927 8.966Z",
                        fill: "#5DF4A5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M71.758 5.293s-4.521 11.264-13.353 13.8c-8.832 2.528-18.634-4.637-18.634-4.637S44.292 3.192 53.124.656c8.831-2.535 18.634 4.637 18.634 4.637Z",
                        fill: "#6EFFB3"
                    })
                ]
            })
        ]
    });
};
$c123d742886ed9f3$var$CheckMarkIcon.defaultProps = {
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var $c123d742886ed9f3$var$CheckIcon = function CheckIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.064 5.318c.449.449.449 1.177 0 1.626L9.325 18.683a1.15 1.15 0 0 1-1.626 0L2.936 13.92a1.15 1.15 0 0 1 1.627-1.627l3.95 3.95L19.437 5.318a1.15 1.15 0 0 1 1.626 0Z",
            fill: "currentColor"
        })
    });
};
$c123d742886ed9f3$var$CheckIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $c123d742886ed9f3$export$539b3a5e932906dc = ({ onFinish: onFinish })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { isMobile: isMobile } = (0, $5kXMA.useDimensions)();
    return /*#__PURE__*/ (0, $iKObn.jsxs)($c123d742886ed9f3$var$Container, {
        children: [
            isMobile && /*#__PURE__*/ (0, $iKObn.jsx)($c123d742886ed9f3$var$RowContactSupport, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)($c123d742886ed9f3$var$SubnavigationContainer, {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $8miOT.ContactSupport), {
                        uiStyle: "secondary"
                    })
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($c123d742886ed9f3$var$IconCompleted, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $9Q47x.BackgroundIcon), {
                    iconSvg: $c123d742886ed9f3$var$CheckMarkIcon
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($c123d742886ed9f3$var$Header, {
                className: "p-size-l-bold",
                children: format("register.completed.pending.approval.header")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($c123d742886ed9f3$var$Description, {
                children: format("register.completed.pending.approval.note1")
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($c123d742886ed9f3$var$Description, {
                children: format("register.completed.pending.approval.note2")
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($c123d742886ed9f3$var$Description, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($c123d742886ed9f3$var$IconContainer, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($c123d742886ed9f3$var$CheckIcon, {
                            width: 12,
                            height: 12,
                            color: (0, $kKnoQ.colors).primary
                        })
                    }),
                    format("register.completed.pending.approval.bullet1")
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($c123d742886ed9f3$var$Description, {
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)($c123d742886ed9f3$var$IconContainer, {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)($c123d742886ed9f3$var$CheckIcon, {
                            width: 12,
                            height: 12,
                            color: (0, $kKnoQ.colors).primary
                        })
                    }),
                    format("register.completed.pending.approval.bullet2")
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($c123d742886ed9f3$var$StyledButton, {
                onClick: onFinish,
                label: format("global.close")
            })
        ]
    });
};
const $c123d742886ed9f3$var$IconContainer = (0, $5UMQ1.default).div`
	width: 20px;
	height: 20px;
	border-radius: 10px;
	background-color: ${(0, $kKnoQ.colors).primary10};
	display: inline-block;
	margin-right: 10px;
	padding-left: 4px;
`;
const $c123d742886ed9f3$var$IconCompleted = (0, $5UMQ1.default).div`
	place-items: center;
	display: grid;
`;
const $c123d742886ed9f3$var$Container = (0, $5UMQ1.default).div`
	display: grid;
	max-width: 448px;
	padding-left: 24px;
	padding-right: 24px;
`;
const $c123d742886ed9f3$var$RowContactSupport = (0, $5UMQ1.default).span`
	${(0, $5WGN2.stack)(8, undefined, "stretch")}
	margin-bottom: 80px;
`;
const $c123d742886ed9f3$var$SubnavigationContainer = (0, $5UMQ1.default).span`
	align-self: start;
	position: absolute;
	top: 0px;
	right: 0px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		margin-top: 100px;
		margin-right: 16px;
	}
`;
const $c123d742886ed9f3$var$Header = (0, $5UMQ1.default).div`
	margin: 24px 0 16px;
`;
const $c123d742886ed9f3$var$Description = (0, $5UMQ1.default).div`
	margin-bottom: 16px;
	text-align: left;
`;
const $c123d742886ed9f3$var$StyledButton = (0, $5UMQ1.default)((0, $dhb7H.Button))`
	width: 100%;
	margin-top: 40px;
`;



var $iKObn = parcelRequire("iKObn");

var $giAv5 = parcelRequire("giAv5");

var $5UMQ1 = parcelRequire("5UMQ1");

var $1IlhR = parcelRequire("1IlhR");

var $grmoS = parcelRequire("grmoS");

var $1eHG3 = parcelRequire("1eHG3");

var $bXTqq = parcelRequire("bXTqq");

var $ghfIB = parcelRequire("ghfIB");
const $d74ac32dda794729$export$12654723e7ea97c1 = "onfido-mount";
const $d74ac32dda794729$var$languageRestriction = (language)=>{
    const spanishCountries = [
        "es_CL",
        "es_UY",
        "es_AR"
    ];
    const englishCountries = [
        "en_CA"
    ];
    const swissCountries = [
        "fr_CH",
        "de_CH",
        "it_CH"
    ];
    if (spanishCountries.includes(language)) return "es_419";
    else if (englishCountries.includes(language)) return "en_US";
    else if (swissCountries.includes(language)) {
        const mapping = {
            "fr_CH": "fr",
            "de_CH": "de",
            "it_CH": "it"
        };
        return mapping[language] || language;
    } else return language;
};
function $d74ac32dda794729$var$loadOnfidoScript() {
    return new Promise((resolve, reject)=>{
        const script = document.createElement("script");
        script.src = "https://sdk.onfido.com/v14";
        script.async = true;
        script.onload = ()=>resolve(window.Onfido);
        script.onerror = ()=>reject(new Error("[Onfido] Failed to load SDK"));
        document.head.appendChild(script);
    });
}
const $d74ac32dda794729$export$b2a2eb49e4f111a8 = ()=>{
    const { locale: locale } = (0, $1eHG3.useI18n)();
    const [initOnfido, loading, error] = (0, $grmoS.useAsyncOperation)(async (onComplete)=>{
        const onfidoUserConfig = await (0, $ghfIB.onfidoService).getOnfidoInitConfig();
        const onfido = await $d74ac32dda794729$var$loadOnfidoScript();
        const onfidoOut = onfido.init({
            token: onfidoUserConfig.token,
            workflowRunId: onfidoUserConfig.workflowRunId,
            containerId: $d74ac32dda794729$export$12654723e7ea97c1,
            onComplete: async ()=>{
                await (0, $ghfIB.userService).completeIdentityVerification();
                onComplete();
                await onfidoOut.tearDown();
            },
            onError: ()=>{
                onfidoOut.tearDown().finally(()=>{
                    throw error;
                });
            },
            language: {
                locale: $d74ac32dda794729$var$languageRestriction((0, $bXTqq.intlLocaleToLocale)(locale)),
                phrases: {}
            }
        });
        return onfidoOut;
    }, {
        deps: [
            locale
        ]
    });
    return {
        initOnfido: initOnfido,
        loading: loading,
        error: error
    };
};


parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
parcelRequire("81g6h");
const $37a13aaf062a3efa$export$d4dc75417ec3d774 = ({ onComplete: onComplete })=>{
    const { initOnfido: initOnfido, loading: loading } = (0, $d74ac32dda794729$export$b2a2eb49e4f111a8)();
    (0, $giAv5.useOnceEffect)(()=>initOnfido(onComplete));
    return /*#__PURE__*/ (0, $iKObn.jsxs)($37a13aaf062a3efa$var$Container, {
        children: [
            loading && /*#__PURE__*/ (0, $iKObn.jsx)((0, $1IlhR.LoadingContainer), {}),
            /*#__PURE__*/ (0, $iKObn.jsx)($37a13aaf062a3efa$var$OnfidoComponent, {
                id: (0, $d74ac32dda794729$export$12654723e7ea97c1),
                loading: loading
            })
        ]
    });
};
const $37a13aaf062a3efa$var$Container = (0, $5UMQ1.default).div`
	width: 100%;
	min-width: 50%;
`;
const $37a13aaf062a3efa$var$OnfidoComponent = (0, $5UMQ1.default).div`
	#onfido-sdk {
		max-width: none;
		max-height: none;

		@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
			min-height: 600px;
			height: auto;
		}
	}
`;


parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
const $107ea047730c026e$export$8f29b94bdaa5fcbc = ()=>{
    const navigate = (0, $htiSH.useNavigate)();
    const [currentStep, setCurrentStep] = (0, $81g6h.useState)();
    const hcpUserStatus = (0, $1IWnK.useObservable)((0, $ghfIB.userStatusManager).hcpStatus);
    const ptRegistrationStatus = (0, $1IWnK.useObservable)((0, $ghfIB.userStatusManager).ptRegistrationStatus);
    const identityStatus = (0, $1IWnK.useObservable)((0, $ghfIB.userStatusManager).identityStatus);
    const user = (0, $4UKJF.useUser)();
    const currentPtId = user?.id ? user.id : "";
    const isScenario2 = hcpUserStatus === (0, $02mFA.RegistrationStatus).INCOMPLETE && identityStatus === (0, $02mFA.IdentityStatus).NOT_NEEDED;
    const isScenario3 = hcpUserStatus === (0, $02mFA.RegistrationStatus).NOT_NEEDED && identityStatus === (0, $02mFA.IdentityStatus).INCOMPLETE;
    const statusesLoaded = ptRegistrationStatus !== null && hcpUserStatus !== null && identityStatus !== null;
    (0, $giAv5.useOnceEffect)(()=>{
        if (!(0, $ghfIB.userStatusManager).hasPtViewedIntroduction(currentPtId) && !isScenario2 && !isScenario3) setCurrentStep((0, $0fc3fe377bd96867$export$6328d0aeff8e1740).INTRODUCTION);
        else if (ptRegistrationStatus === (0, $02mFA.RegistrationStatus).INCOMPLETE && hcpUserStatus === (0, $02mFA.RegistrationStatus).INCOMPLETE) setCurrentStep((0, $0fc3fe377bd96867$export$6328d0aeff8e1740).PROFESSIONAL_INFORMATION);
        else if (hcpUserStatus === (0, $02mFA.RegistrationStatus).PENDING) setCurrentStep((0, $0fc3fe377bd96867$export$6328d0aeff8e1740).IDENTITY_VERIFICATION);
    }, statusesLoaded);
    (0, $81g6h.useEffect)(()=>{
        if (hcpUserStatus === (0, $02mFA.RegistrationStatus).NOT_NEEDED && identityStatus === (0, $02mFA.IdentityStatus).INCOMPLETE) setCurrentStep((0, $0fc3fe377bd96867$export$6328d0aeff8e1740).IDENTITY_VERIFICATION);
    }, [
        hcpUserStatus,
        identityStatus
    ]);
    const renderStep = (0, $81g6h.useCallback)((step)=>{
        switch(step){
            case (0, $0fc3fe377bd96867$export$6328d0aeff8e1740).INTRODUCTION:
                (0, $ghfIB.analyticsService).trackEvent({
                    category: (0, $auPqo.AnalyticsCategory).REGISTRATION,
                    action: "reachStep",
                    params: [
                        "INTRODUCTION"
                    ]
                });
                return /*#__PURE__*/ (0, $iKObn.jsx)((0, $5135f0a1c7d195bf$export$3fc08bfee2beedb0), {
                    onNext: ()=>{
                        (0, $ghfIB.userStatusManager).updatePtViewedIntroduction(currentPtId);
                        setCurrentStep((0, $ghfIB.userStatusManager).hcpStatus.get() === (0, $02mFA.RegistrationStatus).PENDING ? (0, $0fc3fe377bd96867$export$6328d0aeff8e1740).IDENTITY_VERIFICATION : (0, $0fc3fe377bd96867$export$6328d0aeff8e1740).PROFESSIONAL_INFORMATION);
                    }
                });
            case (0, $0fc3fe377bd96867$export$6328d0aeff8e1740).PROFESSIONAL_INFORMATION:
                (0, $ghfIB.analyticsService).trackEvent({
                    category: (0, $auPqo.AnalyticsCategory).REGISTRATION,
                    action: "reachStep",
                    params: [
                        "PROFESSIONAL_INFORMATION"
                    ]
                });
                return /*#__PURE__*/ (0, $iKObn.jsx)((0, $fb0ab2b1dee10f6f$export$650a10f2d998a0d8), {
                    form: /*#__PURE__*/ (0, $iKObn.jsx)((0, $21b8e529c2343545$export$22a2716399e46fc9), {
                        onSuccess: ()=>setCurrentStep((0, $ghfIB.userStatusManager).identityStatus.get() === (0, $02mFA.IdentityStatus).NOT_NEEDED ? (0, $0fc3fe377bd96867$export$6328d0aeff8e1740).DONE : (0, $0fc3fe377bd96867$export$6328d0aeff8e1740).IDENTITY_VERIFICATION)
                    }),
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $b729670b658a16e1$export$2e2bcd8739ae039), {
                        step: (0, $0fc3fe377bd96867$export$6328d0aeff8e1740).PROFESSIONAL_INFORMATION
                    })
                });
            case (0, $0fc3fe377bd96867$export$6328d0aeff8e1740).IDENTITY_VERIFICATION:
                (0, $ghfIB.analyticsService).trackEvent({
                    category: (0, $auPqo.AnalyticsCategory).REGISTRATION,
                    action: "reachStep",
                    params: [
                        "IDENTITY_VERIFICATION"
                    ]
                });
                return /*#__PURE__*/ (0, $iKObn.jsx)((0, $fb0ab2b1dee10f6f$export$650a10f2d998a0d8), {
                    form: /*#__PURE__*/ (0, $iKObn.jsx)((0, $37a13aaf062a3efa$export$d4dc75417ec3d774), {
                        onComplete: ()=>setCurrentStep((0, $0fc3fe377bd96867$export$6328d0aeff8e1740).DONE)
                    }),
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $b729670b658a16e1$export$2e2bcd8739ae039), {
                        step: (0, $0fc3fe377bd96867$export$6328d0aeff8e1740).IDENTITY_VERIFICATION
                    })
                });
            case (0, $0fc3fe377bd96867$export$6328d0aeff8e1740).DONE:
                (0, $ghfIB.analyticsService).trackEvent({
                    category: (0, $auPqo.AnalyticsCategory).REGISTRATION,
                    action: "reachStep",
                    params: [
                        "DONE"
                    ]
                });
                return /*#__PURE__*/ (0, $iKObn.jsx)((0, $c123d742886ed9f3$export$539b3a5e932906dc), {
                    onFinish: ()=>navigate((0, $lDZlX.RoutesPath).Home)
                });
        }
    }, [
        currentPtId,
        navigate
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $0fc3fe377bd96867$export$a2948c2a1e8ac11d), {
                step: isScenario2 || isScenario3 ? undefined : currentStep
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($107ea047730c026e$var$Container, {
                children: renderStep(currentStep)
            })
        ]
    });
};
const $107ea047730c026e$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "center", "center")};
	flex-grow: 1;
	background-color: ${(0, $kKnoQ.colors).white};
`;



var $28f8Y = parcelRequire("28f8Y");

var $81g6h = parcelRequire("81g6h");

var $aanF2 = parcelRequire("aanF2");
var $hE6rp = parcelRequire("hE6rp");

var $iKObn = parcelRequire("iKObn");

var $ghfIB = parcelRequire("ghfIB");

var $81g6h = parcelRequire("81g6h");

var $hE6rp = parcelRequire("hE6rp");

var $243Cr = parcelRequire("243Cr");
const $de09878819c9fb97$export$a97487fc898631bc = ({ children: children })=>{
    const location = (0, $hE6rp.useLocation)();
    const dialogContext = (0, $81g6h.useContext)((0, $243Cr.DialogContext));
    (0, $81g6h.useEffect)(()=>{
        const manageSurveyDialog = async ()=>{
            await (0, $ghfIB.userSurveyManager).processPage(location.pathname, async (survey)=>{
                dialogContext?.openModal((0, $243Cr.ModalId).AddSurvey, {
                    survey: survey
                });
            });
        };
        manageSurveyDialog();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location.pathname
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {
        children: children
    });
};



var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $eaiXJ = parcelRequire("eaiXJ");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $lKlJT = parcelRequire("lKlJT");

var $8CNE2 = parcelRequire("8CNE2");

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $1IWnK = parcelRequire("1IWnK");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $lDZlX = parcelRequire("lDZlX");

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $kKnoQ = parcelRequire("kKnoQ");

var $4nRkH = parcelRequire("4nRkH");

var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");
var $e0dd8e3e1aeb285d$var$BlankEffectIcon = function BlankEffectIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M55.813 6.705 6.706 55.813c-8.94 8.94-8.94 23.434 0 32.373l49.108 49.109c8.94 8.94 23.434 8.94 32.373 0l49.109-49.108c8.94-8.94 8.94-23.434 0-32.373L88.187 6.703c-8.94-8.939-23.434-8.939-32.373 0Z",
            fill: "#F6F6FE"
        })
    });
};
$e0dd8e3e1aeb285d$var$BlankEffectIcon.defaultProps = {
    width: "144",
    height: "144",
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $e0dd8e3e1aeb285d$export$a5d9c38757eb2874 = ({ icon: Icon })=>/*#__PURE__*/ (0, $iKObn.jsxs)($e0dd8e3e1aeb285d$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($e0dd8e3e1aeb285d$var$BlankEffectIcon, {
                width: 144,
                height: 144
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)($e0dd8e3e1aeb285d$var$StyledIcon, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)(Icon, {
                    width: 128,
                    height: 128
                })
            })
        ]
    });
const $e0dd8e3e1aeb285d$var$Container = (0, $5UMQ1.default).div`
	position: relative;
`;
const $e0dd8e3e1aeb285d$var$StyledIcon = (0, $5UMQ1.default).div`
	position: absolute;
	top: 8px;
	left: 8px;
`;



var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $1eHG3 = parcelRequire("1eHG3");

var $5UMQ1 = parcelRequire("5UMQ1");

var $kKnoQ = parcelRequire("kKnoQ");
parcelRequire("42FK8");
var $5WGN2 = parcelRequire("5WGN2");

var $gOhJS = parcelRequire("gOhJS");

var $4nRkH = parcelRequire("4nRkH");
const $b13d3af731dfe001$export$ae755fb12761fec1 = ({ status: status })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const { color: color, backgroundColor: backgroundColor, border: border } = (0, $81g6h.useMemo)(()=>{
        switch(status){
            case (0, $4nRkH.GetStartedStepStatus).Default:
                return {
                    color: (0, $kKnoQ.colors).grey25,
                    backgroundColor: undefined,
                    border: true
                };
            case (0, $4nRkH.GetStartedStepStatus).Completed:
                return {
                    color: (0, $kKnoQ.colors).white,
                    backgroundColor: (0, $kKnoQ.colors).validation,
                    border: false
                };
            case (0, $4nRkH.GetStartedStepStatus).Disabled:
                return {
                    color: `${(0, $kKnoQ.colors).grey50}33`,
                    backgroundColor: undefined,
                    border: true
                };
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)($b13d3af731dfe001$var$Container, {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($b13d3af731dfe001$var$StyledCheckmarkIcon, {
                size: "M",
                colors: {
                    circle: backgroundColor,
                    check: color
                },
                border: border ? `2px dashed ${color};` : undefined
            }),
            status === (0, $4nRkH.GetStartedStepStatus).Completed && /*#__PURE__*/ (0, $iKObn.jsx)($b13d3af731dfe001$var$CompletedStatus, {
                className: "p-size-s",
                children: format("getStarted.checkIcon.completed")
            })
        ]
    });
};
const $b13d3af731dfe001$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)("XS", "flexstart", "center")};
`;
const $b13d3af731dfe001$var$StyledCheckmarkIcon = (0, $5UMQ1.default)((0, $gOhJS.CheckmarkIcon))`
	${({ border: border })=>border && `border: ${border};`}
`;
const $b13d3af731dfe001$var$CompletedStatus = (0, $5UMQ1.default).div`
	color: ${(0, $kKnoQ.colors).grey};
`;


const $e6fdf75fad137c98$export$30fb424233fb8973 = ({ status: status, icon: icon, mainHeadline: mainHeadline, secondaryHeadline: secondaryHeadline, description: description, bottom: bottom, className: className })=>/*#__PURE__*/ (0, $iKObn.jsxs)($e6fdf75fad137c98$var$Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)($e6fdf75fad137c98$var$CardIllustrationContainer, {
                children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $e0dd8e3e1aeb285d$export$a5d9c38757eb2874), {
                    icon: icon
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)($e6fdf75fad137c98$var$Card, {
                className: "p-card",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsxs)($e6fdf75fad137c98$var$Top, {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $b13d3af731dfe001$export$ae755fb12761fec1), {
                                status: status
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($e6fdf75fad137c98$var$MainHeadline, {
                                status: status,
                                children: mainHeadline
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($e6fdf75fad137c98$var$SecondaryHeadline, {
                                status: status,
                                className: "p-size-l-bold",
                                children: secondaryHeadline
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)($e6fdf75fad137c98$var$Description, {
                                status: status,
                                className: "p-size-s",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                        children: bottom
                    })
                ]
            })
        ]
    });
const $e6fdf75fad137c98$var$Container = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)()};
	min-width: 300px;
	width: 320px;
`;
const $e6fdf75fad137c98$var$CardIllustrationContainer = (0, $5UMQ1.default).div`
	align-self: center;
	height: 96px;
	overflow: visible;
`;
const $e6fdf75fad137c98$var$Card = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(undefined, "spacebetween")};
	flex: 1;
	align-self: stretch;
	padding: 56px 24px 24px 24px;
`;
const $e6fdf75fad137c98$var$Top = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)(16)};
`;
const $e6fdf75fad137c98$var$MainHeadline = (0, $5UMQ1.default).h3`
	color: ${({ status: status })=>status === (0, $4nRkH.GetStartedStepStatus).Disabled ? (0, $kKnoQ.colors).grey50 : (0, $kKnoQ.colors).onboardingPrimary};
`;
const $e6fdf75fad137c98$var$SecondaryHeadline = (0, $5UMQ1.default).div`
	${({ status: status })=>status === (0, $4nRkH.GetStartedStepStatus).Disabled && `color: ${(0, $kKnoQ.colors).grey50};`}
`;
const $e6fdf75fad137c98$var$Description = (0, $5UMQ1.default).div`
	${({ status: status })=>status === (0, $4nRkH.GetStartedStepStatus).Disabled && `color: ${(0, $kKnoQ.colors).grey50};`}
`;



var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $5UMQ1 = parcelRequire("5UMQ1");

var $c22GE = parcelRequire("c22GE");
var $9c6c0ec64f1c6c91$var$ArrowRightIcon = function ArrowRightIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsx)("svg", {
        ...props,
        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
            d: "M12.71 17.712a1.002 1.002 0 0 1 0-1.42l3.29-3.29H6a1 1 0 0 1 0-2h10l-3.29-3.29a1.001 1.001 0 1 1 1.41-1.42l4.29 4.3a2 2 0 0 1 .59 1.41 2 2 0 0 1-.59 1.4l-4.29 4.3a1 1 0 0 1-1.41.01Z",
            fill: "currentColor"
        })
    });
};
$9c6c0ec64f1c6c91$var$ArrowRightIcon.defaultProps = {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $9c6c0ec64f1c6c91$export$15d663f77d176497 = ({ label: label, onClick: onClick })=>/*#__PURE__*/ (0, $iKObn.jsx)($9c6c0ec64f1c6c91$var$Container, {
        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $c22GE.TertiaryButton), {
            onClick: onClick,
            label: label,
            icon: /*#__PURE__*/ (0, $iKObn.jsx)($9c6c0ec64f1c6c91$var$ArrowRightIcon, {
                width: 24,
                height: 24
            })
        })
    });
const $9c6c0ec64f1c6c91$var$Container = (0, $5UMQ1.default).div`
	margin-top: 24px;
`;


var $81dcf50acdf179fd$var$WeightIcon = function WeightIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M53.47 4.362 4.362 53.47c-5.816 5.816-5.816 15.244 0 21.06l49.108 49.108c5.816 5.816 15.244 5.816 21.06 0l49.108-49.108c5.816-5.816 5.816-15.244 0-21.06L74.53 4.362c-5.816-5.816-15.244-5.816-21.06 0Z",
                fill: "#F5EEFD"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_1681_284",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "76",
                y: "42",
                width: "34",
                height: "34",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "m96.211 42.841-11.49 1.82c-1.767.28-3.247 1.517-3.885 3.241L76.72 59.106a5.345 5.345 0 0 0 .812 5.123l7.375 9.385c1.135 1.442 2.924 2.162 4.697 1.881l11.49-1.82c1.768-.28 3.247-1.517 3.885-3.24l4.115-11.205a5.347 5.347 0 0 0-.811-5.123l-7.376-9.384c-1.135-1.443-2.924-2.162-4.697-1.882Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_1681_284)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M119.192 44.426c.201-21.066-16.186-38.49-36.602-38.92-20.415-.429-37.128 16.3-37.329 37.367-.2 21.065 16.186 38.49 36.602 38.92 20.415.429 37.128-16.3 37.329-37.367Z",
                        fill: "#50F"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M101.039 57.394c-21.016 2.55-39.49-7.796-43.125-24.69-1.605-7.465.264-15.11 4.754-21.785C67.792 3.308 76.607-2.576 86.891-5.746c4.443-1.37 8.934-2.34 13.279-2.693 17.314-1.354 33.089 6.76 37.685 20.97 1.81 5.588 2.693 12.33.194 18.277-2.613 6.22-8.697 10.28-14.181 14.82-4.264 3.532-8.107 7.353-13.486 9.614-2.98 1.25-6.186 1.776-9.351 2.161l.008-.009Z",
                        fill: "#334EF3"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M97.33 44.568c-5.45 14.304-19.526 23.785-34.51 22.898-6.25-.371-11.79-2.88-15.986-7.008-4.778-4.706-7.069-11.66-7.235-18.926-.085-3.61.108-7.22.831-10.62C43.288 17.459 54.623 6.663 68.618 5.56c5.446-.43 12.609-.234 17.273 3.165 5.1 3.723 5.514 10.118 7.855 15.552 1.848 4.284 4.884 7.925 5.207 12.666.18 2.648-.697 5.2-1.618 7.624l-.005.001Z",
                        fill: "#2275EE"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask1_1681_284",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "67",
                y: "44",
                width: "34",
                height: "33",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "m87.705 44.188-11.49 1.82c-1.768.28-3.247 1.517-3.885 3.241l-4.115 11.205a5.345 5.345 0 0 0 .811 5.122l7.376 9.385c1.135 1.443 2.924 2.162 4.697 1.881l11.49-1.82c1.768-.28 3.247-1.517 3.885-3.24l4.115-11.205a5.346 5.346 0 0 0-.811-5.122l-7.376-9.385c-1.135-1.443-2.924-2.162-4.697-1.882Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask1_1681_284)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M134.579 57.275c.201-21.066-16.186-38.49-36.601-38.92-20.416-.429-37.129 16.3-37.33 37.366-.2 21.066 16.187 38.491 36.602 38.92 20.415.43 37.128-16.3 37.329-37.366Z",
                        fill: "#50F"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M125.063 61.014c-3.808 17.415-20.015 28.942-37.184 26.154-7.844-1.273-14.532-5.45-19.217-11.32-5.342-6.697-7.833-15.626-6.686-24.838.454-3.655 1.377-7.143 2.773-10.327 5.613-12.722 18.776-20.864 33.028-19.115 5.647.713 11.275 2.664 15.602 6.177 4.366 3.547 6.911 8.485 9.081 13.604 1.677 3.943 3.153 7.972 3.354 12.38.113 2.432-.231 4.875-.755 7.286h.004Z",
                        fill: "#4427F8"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M124.598 60.63c-5.332 18.679-23.033 31.078-41.88 28.771-8.325-1.02-15.52-5.05-20.72-11-5.926-6.787-8.667-16.16-8.045-25.913.268-4.216.968-8.343 2.25-12.15 5.166-15.15 19.537-25.968 35.97-25.335 6.464.246 13.769 1.65 18.971 5.673 5.44 4.208 7.331 10.677 9.946 16.789 2.034 4.752 4.528 9.24 4.825 14.535.163 2.933-.509 5.826-1.31 8.639l-.007-.01Z",
                        fill: "#334EF3"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M112.717 57.422c-5.451 14.303-19.527 23.785-34.51 22.897-6.25-.37-11.79-2.88-15.986-7.008-4.779-4.706-7.069-11.66-7.235-18.926-.085-3.61.108-7.219.831-10.619 2.857-13.454 14.192-24.25 28.188-25.353 5.446-.43 12.608-.233 17.272 3.166 5.101 3.722 5.514 10.117 7.856 15.552 1.847 4.283 4.884 7.925 5.206 12.666.181 2.647-.696 5.2-1.617 7.624h-.005Z",
                        fill: "#2275EE"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M99.866 55.042c-5.333 10.001-16.001 16.397-27.134 17.027-4.167.236-8.063-.714-11.252-3.01-3.636-2.625-5.638-7.18-6.426-11.94-.503-3.019-.742-6.096-.592-9.087.595-11.746 8.847-22.507 20.406-25.37 4.43-1.095 11.456-2.128 15.574.652 4.767 3.221 3.691 9.56 5.766 14.321 1.66 3.814 5.236 6.609 5.583 10.802.198 2.358-.843 4.579-1.924 6.61l-.001-.005Z",
                        fill: "#119AE9"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M85.408 41.644c1.11 2.52 4.223 3.998 4.503 6.745.16 1.567-.698 3.039-1.684 4.223-3.742 4.488-9.466 6.544-14.917 8.42-1.589.549-3.275 1.098-4.924.74-1.877-.409-3.376-1.965-4.24-3.738-.866-1.773-1.2-3.756-1.518-5.707-1.245-7.578 2.656-15.645 9.527-19.162 2.577-1.32 7.78-3.041 10.475-1.402 3.354 2.044 1.417 6.79 2.778 9.88Z",
                        fill: "#00C1E4"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask2_1681_284",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "38",
                y: "56",
                width: "49",
                height: "16",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "m82.01 56.974-40.629 6.434c-2.175.345-3.65 2.45-3.294 4.7l.001.005c.357 2.25 2.41 3.796 4.585 3.451l40.629-6.435c2.176-.344 3.65-2.448 3.294-4.699v-.005c-.357-2.25-2.41-3.796-4.586-3.451Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask2_1681_284)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M86.68 66.67c1.473-21.06-13.809-39.304-34.132-40.746-20.324-1.443-37.992 14.46-39.464 35.522-1.473 21.061 13.81 39.304 34.133 40.747C67.54 103.635 85.209 87.731 86.68 66.67Z",
                        fill: "#50F"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M73.686 68.69c-5.333 18.68-23.034 31.079-41.88 28.772-8.326-1.02-15.52-5.05-20.72-11-5.927-6.787-8.668-16.16-8.045-25.914.267-4.215.968-8.342 2.25-12.148 5.165-15.15 19.537-25.969 35.97-25.336 6.464.246 13.768 1.65 18.97 5.673 5.44 4.208 7.332 10.677 9.946 16.789 2.034 4.752 4.528 9.24 4.826 14.535.162 2.933-.51 5.826-1.311 8.639l-.006-.01Z",
                        fill: "#334EF3"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M64.586 65.043c-5.45 14.303-19.527 23.784-34.51 22.897-6.25-.37-11.79-2.88-15.986-7.008-4.779-4.706-7.069-11.66-7.235-18.926-.085-3.61.108-7.219.831-10.619 2.857-13.454 14.192-24.25 28.188-25.353 5.446-.43 12.608-.233 17.273 3.165 5.1 3.723 5.514 10.118 7.855 15.553 1.848 4.283 4.884 7.924 5.206 12.666.181 2.647-.696 5.2-1.617 7.624h-.005Z",
                        fill: "#119AE9"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M51.281 62.366c-5.332 10.001-16 16.398-27.133 17.027-4.167.237-8.063-.713-11.252-3.01-3.636-2.625-5.638-7.18-6.426-11.939-.503-3.02-.742-6.096-.592-9.088.595-11.746 8.847-22.507 20.405-25.37 4.43-1.095 11.457-2.128 15.575.652 4.767 3.221 3.691 9.56 5.765 14.321 1.662 3.814 5.236 6.61 5.584 10.802.198 2.358-.844 4.579-1.925 6.61v-.005Z",
                        fill: "#119AE9"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M37.568 48.482c1.11 2.52 4.223 3.998 4.502 6.746.16 1.567-.697 3.038-1.684 4.222-3.741 4.488-9.465 6.544-14.916 8.42-1.589.55-3.275 1.099-4.925.74-1.876-.408-3.375-1.965-4.24-3.738-.865-1.773-1.2-3.756-1.518-5.706-1.244-7.579 2.656-15.645 9.528-19.162 2.577-1.32 7.78-3.042 10.475-1.402 3.354 2.044 1.416 6.79 2.778 9.88Z",
                        fill: "#00C1E4"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask3_1681_284",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "27",
                y: "50",
                width: "34",
                height: "34",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "m46.889 50.653-11.49 1.82c-1.768.28-3.248 1.517-3.886 3.241l-4.115 11.204a5.346 5.346 0 0 0 .812 5.123l7.375 9.385c1.135 1.442 2.925 2.162 4.697 1.881l11.49-1.82c1.768-.28 3.248-1.517 3.886-3.24l4.114-11.205a5.346 5.346 0 0 0-.811-5.123l-7.376-9.384c-1.134-1.443-2.924-2.162-4.696-1.882Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask3_1681_284)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M64.113 72.603c13.591-17.476 11.629-40.609-4.384-51.669-16.012-11.06-40.011-5.86-53.603 11.616C-7.465 50.026-5.503 73.16 10.51 84.22c16.012 11.06 40.011 5.86 53.603-11.616Z",
                        fill: "#50F"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M13.103 52.028C-.231 37.564-.344 17.601 13.335 5.116c6.043-5.515 14.07-8.5 22.572-8.94 9.695-.499 19.727 2.796 28.024 8.767 3.585 2.58 6.826 5.426 9.423 8.517 10.296 12.347 11.057 28.98.356 40.646-4.207 4.59-9.962 9.141-16.752 10.672-7.1 1.6-14.024-.673-21.076-2.217-5.484-1.2-11.017-1.913-15.912-4.689-2.71-1.54-4.87-3.667-6.88-5.844h.013Z",
                        fill: "#334EF3"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M48.402 47.172c-5.45 14.303-19.526 23.785-34.51 22.897-6.25-.37-11.79-2.88-15.986-7.008-4.778-4.705-7.068-11.66-7.235-18.926-.085-3.61.108-7.218.831-10.619C-5.64 20.062 5.695 9.266 19.69 8.163c5.446-.429 12.608-.233 17.273 3.166 5.1 3.723 5.514 10.118 7.855 15.552 1.848 4.283 4.884 7.925 5.207 12.666.18 2.648-.697 5.2-1.618 7.624h-.005Z",
                        fill: "#2275EE"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M34.298 49.767C28.965 59.768 18.297 66.165 7.164 66.794c-4.167.237-8.063-.714-11.252-3.01-3.636-2.625-5.638-7.18-6.426-11.94-.503-3.019-.742-6.095-.592-9.087.595-11.746 8.847-22.507 20.406-25.37 4.43-1.095 11.456-2.128 15.574.652 4.767 3.221 3.691 9.56 5.766 14.321 1.66 3.814 5.235 6.61 5.583 10.802.198 2.358-.843 4.579-1.925 6.61v-.005Z",
                        fill: "#119AE9"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask4_1681_284",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "18",
                y: "52",
                width: "34",
                height: "33",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "m37.983 52.064-11.49 1.82c-1.768.28-3.247 1.517-3.885 3.24L18.493 68.33a5.345 5.345 0 0 0 .811 5.123l7.376 9.384c1.134 1.443 2.924 2.162 4.697 1.882l11.49-1.82c1.767-.28 3.247-1.517 3.885-3.241l4.115-11.204a5.345 5.345 0 0 0-.812-5.123l-7.375-9.385c-1.135-1.443-2.924-2.162-4.697-1.881Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask4_1681_284)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M84.856 65.15c.2-21.066-16.187-38.49-36.602-38.92-20.415-.429-37.128 16.3-37.33 37.366-.2 21.066 16.187 38.491 36.602 38.92 20.416.429 37.128-16.3 37.33-37.366Z",
                        fill: "#50F"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M75.339 68.886C71.53 86.3 55.323 97.828 38.154 95.039c-7.844-1.272-14.531-5.45-19.217-11.319-5.342-6.698-7.833-15.626-6.686-24.839.454-3.655 1.377-7.142 2.773-10.326C20.637 35.833 33.8 27.69 48.053 29.44c5.646.713 11.274 2.664 15.6 6.177 4.367 3.546 6.913 8.485 9.082 13.604 1.677 3.942 3.153 7.972 3.354 12.38.113 2.431-.231 4.874-.755 7.286l.005-.001Z",
                        fill: "#4427F8"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M74.874 68.502c-5.332 18.68-23.033 31.078-41.88 28.772-8.325-1.02-15.52-5.051-20.72-11-5.926-6.787-8.668-16.16-8.045-25.914.268-4.215.968-8.343 2.25-12.149 5.166-15.15 19.537-25.968 35.97-25.336 6.464.246 13.769 1.65 18.97 5.674 5.44 4.208 7.332 10.676 9.947 16.788 2.034 4.753 4.527 9.24 4.825 14.535.163 2.933-.51 5.826-1.31 8.64l-.007-.01Z",
                        fill: "#2275EE"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M49.29 62.681C43.957 72.683 33.289 79.08 22.156 79.71c-4.167.236-8.063-.714-11.252-3.01-3.635-2.625-5.638-7.18-6.426-11.94-.503-3.019-.741-6.096-.592-9.087.595-11.746 8.847-22.507 20.406-25.37 4.43-1.096 11.456-2.128 15.574.652 4.767 3.22 3.691 9.56 5.766 14.321 1.66 3.814 5.236 6.609 5.583 10.802.198 2.358-.843 4.579-1.925 6.61v-.005Z",
                        fill: "#119AE9"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M35.575 48.798c1.11 2.52 4.224 3.998 4.503 6.745.16 1.567-.698 3.039-1.684 4.223-3.741 4.488-9.466 6.544-14.917 8.42-1.588.549-3.274 1.098-4.924.74-1.877-.409-3.375-1.965-4.24-3.738-.866-1.773-1.2-3.756-1.518-5.707-1.244-7.578 2.656-15.645 9.528-19.162 2.577-1.32 7.78-3.041 10.474-1.402 3.354 2.044 1.417 6.79 2.778 9.881Z",
                        fill: "#00C1E4"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M40.459 52.529a5.113 5.113 0 0 1 1.851 1.475l7.376 9.384a5.346 5.346 0 0 1 .811 5.123l-4.115 11.204a5.144 5.144 0 0 1-1.287 1.956M90.062 44.672a5.115 5.115 0 0 1 1.852 1.476l7.375 9.384a5.343 5.343 0 0 1 .811 5.123l-4.114 11.204a5.146 5.146 0 0 1-1.287 1.956",
                stroke: "#1D0255",
                strokeWidth: "1.693",
                strokeLinecap: "round"
            })
        ]
    });
};
$81dcf50acdf179fd$var$WeightIcon.defaultProps = {
    width: "128",
    height: "128",
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $81dcf50acdf179fd$export$e396ce63e1f2ee5e = ({ className: className })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    const exercisesStepStatus = (0, $1IWnK.useObservable)((0, $ghfIB.getStartedManager).exercisesStepStatus);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $e6fdf75fad137c98$export$30fb424233fb8973), {
        className: className,
        status: exercisesStepStatus,
        icon: $81dcf50acdf179fd$var$WeightIcon,
        mainHeadline: format("getStarted.exercisesCard.mainHeadline"),
        secondaryHeadline: format("getStarted.exercisesCard.secondaryHeadline"),
        description: format("getStarted.exercisesCard.description"),
        bottom: /*#__PURE__*/ (0, $iKObn.jsx)((0, $9c6c0ec64f1c6c91$export$15d663f77d176497), {
            label: format("getStarted.exercisesCard.ctaButton"),
            onClick: ()=>{
                (0, $ghfIB.analyticsService).trackEvent({
                    category: (0, $auPqo.AnalyticsCategory).GETSTARTED,
                    action: "cardCTA",
                    params: [
                        "exercises"
                    ]
                });
                navigate((0, $lDZlX.RoutesPath).ExerciseList);
            }
        })
    });
};



var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $1IWnK = parcelRequire("1IWnK");

var $1eHG3 = parcelRequire("1eHG3");

var $htiSH = parcelRequire("htiSH");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $lDZlX = parcelRequire("lDZlX");


var $2ffa503f93ab6dcc$var$ScheduleIcon = function ScheduleIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M53.47 4.362 4.362 53.47c-5.816 5.816-5.816 15.244 0 21.06l49.108 49.108c5.816 5.816 15.244 5.816 21.06 0l49.108-49.108c5.816-5.816 5.816-15.244 0-21.06L74.53 4.362c-5.816-5.816-15.244-5.816-21.06 0Z",
                fill: "#F5EEFD"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M85.229 32.7H46.482a6.811 6.811 0 0 0-6.811 6.812v45.336a6.811 6.811 0 0 0 6.811 6.812H85.23a6.812 6.812 0 0 0 6.811-6.812V39.512a6.812 6.812 0 0 0-6.811-6.811Z",
                fill: "#33009A"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M91.866 44.439 81.855 74.457a11.808 11.808 0 0 1-11.2 8.079H39.813l.428-17.568 50.152-29.194s1.695 2.328 1.473 8.68v-.015Z",
                fill: "#000"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_1681_390",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "26",
                y: "32",
                width: "65",
                height: "47",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M69.213 78.449H32.241c-3.88 0-6.605-3.802-5.386-7.477L37.2 40.098a10.804 10.804 0 0 1 10.265-7.381h38.287c3.09 0 5.26 3.025 4.277 5.956L79.082 71.336a10.43 10.43 0 0 1-9.884 7.113h.016Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_1681_390)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M57.492 92.262c19.798 0 35.847-16.05 35.847-35.848S77.29 20.567 57.492 20.567c-19.798 0-35.848 16.05-35.848 35.847 0 19.798 16.05 35.848 35.848 35.848Z",
                        fill: "#4427FA"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M63.986 81.918c17.497 0 31.681-14.185 31.681-31.682S81.483 18.555 63.986 18.555 32.304 32.739 32.304 50.236 46.49 81.918 63.986 81.918Z",
                        fill: "#334EF5"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M67.36 66.885c13.053 0 23.635-10.581 23.635-23.634S80.412 19.617 67.36 19.617 43.726 30.197 43.726 43.25c0 13.053 10.581 23.634 23.634 23.634Z",
                        fill: "#2275F0"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M73.697 56.747c9.912 0 17.947-8.036 17.947-17.948S83.61 20.852 73.696 20.852c-9.912 0-17.947 8.035-17.947 17.947 0 9.912 8.035 17.948 17.947 17.948Z",
                        fill: "#119CEB"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M78.306 44.834c6.806 0 12.324-5.517 12.324-12.324 0-6.806-5.518-12.324-12.324-12.324S65.982 25.704 65.982 32.51c0 6.807 5.518 12.324 12.324 12.324Z",
                        fill: "#00C3E6"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M47.1 60.184h-3.343a2.087 2.087 0 0 1-1.98-2.756l.872-2.582a2.383 2.383 0 0 1 2.265-1.631h3.342a2.087 2.087 0 0 1 1.98 2.756l-.87 2.582a2.383 2.383 0 0 1-2.266 1.632ZM57.872 60.184h-3.343a2.087 2.087 0 0 1-1.98-2.756l.871-2.582a2.383 2.383 0 0 1 2.266-1.631h3.342a2.087 2.087 0 0 1 1.98 2.756l-.871 2.582a2.383 2.383 0 0 1-2.265 1.632ZM68.66 60.184h-3.343a2.087 2.087 0 0 1-1.98-2.756l.87-2.582a2.383 2.383 0 0 1 2.266-1.631h3.343a2.087 2.087 0 0 1 1.98 2.756l-.872 2.582a2.383 2.383 0 0 1-2.265 1.632ZM49.745 50.633h-3.342a2.087 2.087 0 0 1-1.98-2.757l.871-2.582a2.383 2.383 0 0 1 2.265-1.631h3.343a2.087 2.087 0 0 1 1.98 2.756L52.01 49a2.383 2.383 0 0 1-2.266 1.632ZM60.533 50.633H57.19a2.087 2.087 0 0 1-1.98-2.757l.87-2.582a2.383 2.383 0 0 1 2.266-1.631h3.342a2.087 2.087 0 0 1 1.98 2.756L62.8 49a2.383 2.383 0 0 1-2.266 1.632ZM71.304 50.633h-3.342a2.087 2.087 0 0 1-1.98-2.757l.871-2.582a2.383 2.383 0 0 1 2.265-1.631h3.343a2.087 2.087 0 0 1 1.98 2.756L73.57 49a2.383 2.383 0 0 1-2.266 1.632ZM44.09 69.974h-3.342a2.087 2.087 0 0 1-1.98-2.756l.871-2.582a2.383 2.383 0 0 1 2.265-1.632h3.343a2.087 2.087 0 0 1 1.98 2.756l-.871 2.582a2.383 2.383 0 0 1-2.266 1.632ZM54.878 69.974h-3.343a2.087 2.087 0 0 1-1.98-2.756l.872-2.582a2.383 2.383 0 0 1 2.265-1.632h3.342a2.087 2.087 0 0 1 1.98 2.756l-.87 2.582a2.383 2.383 0 0 1-2.266 1.632ZM65.65 69.974h-3.343a2.087 2.087 0 0 1-1.98-2.756l.871-2.582a2.383 2.383 0 0 1 2.266-1.632h3.342a2.087 2.087 0 0 1 1.98 2.756l-.871 2.582a2.383 2.383 0 0 1-2.265 1.632Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M52.977 39.45a3.536 3.536 0 0 1-3.532-3.533v-5.64a3.536 3.536 0 0 1 3.532-3.532 3.536 3.536 0 0 1 3.533 3.532v5.64a3.536 3.536 0 0 1-3.533 3.532Z",
                fill: "#33009A"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M52.977 27.537a2.752 2.752 0 0 1 2.74 2.74v5.64a2.752 2.752 0 0 1-2.74 2.74 2.752 2.752 0 0 1-2.74-2.74v-5.64a2.752 2.752 0 0 1 2.74-2.74Zm0-1.584a4.33 4.33 0 0 0-4.324 4.324v5.64a4.33 4.33 0 0 0 4.324 4.324 4.32 4.32 0 0 0 4.325-4.325v-5.639a4.33 4.33 0 0 0-4.325-4.324Z",
                fill: "#F2E9FF"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M76.817 39.45a3.536 3.536 0 0 1-3.532-3.533v-5.64a3.536 3.536 0 0 1 3.532-3.532 3.536 3.536 0 0 1 3.533 3.532v5.64a3.536 3.536 0 0 1-3.533 3.532Z",
                fill: "#33009A"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M76.817 27.537a2.752 2.752 0 0 1 2.74 2.74v5.64a2.752 2.752 0 0 1-2.74 2.74 2.752 2.752 0 0 1-2.74-2.74v-5.64a2.752 2.752 0 0 1 2.74-2.74Zm0-1.584a4.33 4.33 0 0 0-4.324 4.324v5.64a4.33 4.33 0 0 0 4.324 4.324 4.32 4.32 0 0 0 4.325-4.325v-5.639a4.33 4.33 0 0 0-4.325-4.324Z",
                fill: "#F2E9FF"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M82.108 97.671c7.378 0 13.36-5.98 13.36-13.359 0-7.378-5.982-13.36-13.36-13.36-7.378 0-13.36 5.982-13.36 13.36 0 7.378 5.982 13.36 13.36 13.36Z",
                fill: "#20BB71"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M79.601 89.37c-.32 0-.652-.127-.898-.37l-2.942-2.893a1.256 1.256 0 0 1 0-1.778 1.307 1.307 0 0 1 1.808 0l2.043 2.01 6.793-6.683a1.307 1.307 0 0 1 1.808 0 1.256 1.256 0 0 1 0 1.779L80.51 89.01a1.293 1.293 0 0 1-.899.369l-.01-.01Z",
                fill: "#fff"
            })
        ]
    });
};
$2ffa503f93ab6dcc$var$ScheduleIcon.defaultProps = {
    width: "128",
    height: "128",
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $2ffa503f93ab6dcc$export$2642d82beaef8744 = ({ className: className })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    const programsStepStatus = (0, $1IWnK.useObservable)((0, $ghfIB.getStartedManager).programsStepStatus);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $e6fdf75fad137c98$export$30fb424233fb8973), {
        className: className,
        status: programsStepStatus,
        icon: $2ffa503f93ab6dcc$var$ScheduleIcon,
        mainHeadline: format("getStarted.programsCard.mainHeadline"),
        secondaryHeadline: format("getStarted.programsCard.secondaryHeadline"),
        description: format("getStarted.programsCard.description"),
        bottom: /*#__PURE__*/ (0, $iKObn.jsx)((0, $9c6c0ec64f1c6c91$export$15d663f77d176497), {
            label: format("getStarted.programsCard.ctaButton"),
            onClick: ()=>{
                (0, $ghfIB.analyticsService).trackEvent({
                    category: (0, $auPqo.AnalyticsCategory).GETSTARTED,
                    action: "cardCTA",
                    params: [
                        "programs"
                    ]
                });
                navigate((0, $lDZlX.RoutesPath).TemplateBuilder);
            }
        })
    });
};



var $iKObn = parcelRequire("iKObn");

var $81g6h = parcelRequire("81g6h");

var $1IWnK = parcelRequire("1IWnK");

var $htiSH = parcelRequire("htiSH");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $auPqo = parcelRequire("auPqo");

var $5UMQ1 = parcelRequire("5UMQ1");

var $02mFA = parcelRequire("02mFA");

var $4nRkH = parcelRequire("4nRkH");

var $lDZlX = parcelRequire("lDZlX");



var $66d405ac014829e4$var$PatientAddIcon = function PatientAddIcon(props) {
    return /*#__PURE__*/ (0, $iKObn.jsxs)("svg", {
        ...props,
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M53.47 4.362 4.362 53.47c-5.816 5.816-5.816 15.244 0 21.06l49.108 49.108c5.816 5.816 15.244 5.816 21.06 0l49.108-49.108c5.816-5.816 5.816-15.244 0-21.06L74.53 4.362c-5.816-5.816-15.244-5.816-21.06 0Z",
                fill: "#F5EEFD"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                id: "mask0_301_16603",
                style: {
                    maskType: "luminance"
                },
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "128",
                height: "129",
                children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                    d: "M53.476 4.36 4.359 53.475c-5.812 5.812-5.812 15.236 0 21.048l49.117 49.117c5.812 5.812 15.236 5.812 21.048 0l49.117-49.117c5.812-5.812 5.812-15.236 0-21.048L74.524 4.359c-5.812-5.812-15.236-5.812-21.048 0Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                mask: "url(#mask0_301_16603)",
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M36.402 85.25a21.961 21.961 0 0 1 19.162-11.244l34.252.483c7.046.1 12.972 5.31 13.968 12.279l.716 6.732L75 123 36.402 85.25Z",
                        fill: "#33009A"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask1_301_16603",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "57",
                        y: "35",
                        width: "37",
                        height: "53",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M57.526 74.06a5.09 5.09 0 0 0 5.022-5.092V35.525l18.205-.42c6.47-.148 11.337 5.902 9.756 12.178-.031.124 1.48 2.351 2.74 4.181.748 1.082.047 2.562-1.26 2.679l-.546.046 1.589 8.65c.552 2.999-1.76 5.763-4.804 5.763h-3.13v13.875c0 4.259-4.781 6.766-8.285 4.337L57.526 74.06Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask1_301_16603)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M95.973 90.033c13.716-10.388 16.42-29.92 6.039-43.624-10.38-13.706-29.913-16.395-43.629-6.007-13.715 10.388-16.419 29.92-6.039 43.625 10.38 13.705 29.914 16.394 43.63 6.006Z",
                                fill: "#50F"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M60.64 81.792c11.065 9.53 27.728 9.055 38.084-1.27 4.726-4.718 7.264-10.76 7.599-16.927.389-7.03-2.258-14.116-7.514-19.59-2.086-2.172-4.415-4.002-6.914-5.396-10.013-5.56-22.954-4.376-31.822 3.823-3.504 3.262-6.393 7.327-7.639 11.773-1.253 4.485-.584 8.977.42 13.416.771 3.41 1.73 6.782 3.73 9.772 1.106 1.65 2.523 3.075 4.057 4.399Z",
                                fill: "#4427FA"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M60.773 81.301c12.715 9.6 30.818 8.962 42.56-1.876 5.186-4.789 8.129-10.995 8.783-17.465.747-7.381-1.947-14.887-7.109-20.968-2.235-2.632-4.718-4.984-7.444-6.845-10.885-7.373-25.951-7.35-36.86 1.2-4.29 3.363-8.588 7.895-10.177 13.112-1.658 5.45.187 10.628 1.379 15.922.926 4.12 1.401 8.3 3.776 11.914 1.316 2 3.177 3.566 5.092 5.014v-.008Z",
                                fill: "#334EF5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M71.744 72.464c10.675 6.673 24.885 5.918 34.672-2.079 4.088-3.34 6.642-7.724 7.499-12.505.973-5.45-.849-11.142-4.267-15.985-1.698-2.406-3.59-4.68-5.731-6.548-8.495-7.405-21.467-8.869-31.558-2.663-3.924 2.413-8.713 6.089-10.239 10.62-1.674 4.96 1.16 9.36 2.204 14.086.825 3.721.521 7.615 2.608 10.877 1.16 1.822 2.998 3.06 4.812 4.197Z",
                                fill: "#2275F0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M76.82 64.468c8.503 3.916 18.89 2.826 26.786-2.274 2.958-1.908 5.154-4.462 6.213-7.545 1.199-3.52.35-7.498-1.417-11.01-1.129-2.227-2.46-4.36-4.018-6.252-6.112-7.405-16.974-10.371-26.255-6.525-3.55 1.472-8.845 4.275-10.301 8.137-1.69 4.469 2.125 8.09 3.028 12.24.725 3.317-.358 6.922 1.441 9.842 1.012 1.642 2.803 2.585 4.524 3.379v.008Z",
                                fill: "#119CEB"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M82.63 50.717c.467 2.204-.935 4.71.21 6.65.654 1.105 1.954 1.642 3.2 1.93 4.734 1.09 9.64-.397 14.272-1.868 1.347-.428 2.772-.903 3.722-1.955 1.082-1.199 1.347-2.958 1.074-4.547-.272-1.588-1.012-3.052-1.736-4.492-2.834-5.583-9.421-8.94-15.822-7.841-2.398.412-6.79 1.86-7.825 4.267-1.292 2.997 2.336 5.154 2.912 7.848l-.008.008Z",
                                fill: "#00C3E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M89.598 36.647v-.171c-.148-4.314-4.119-7.46-8.347-6.603l-13.276 2.694c-8.292-.218-14.038 8.222-10.791 15.86l5.193 12.24.18.414v-12a3.17 3.17 0 0 1 3.028-3.168 3.17 3.17 0 0 1 3.301 2.982c.047.849.771 1.503 1.62 1.464l.568-.023a2.144 2.144 0 0 0 1.768-1.075l1.946-3.426a5.444 5.444 0 0 0 .14-5.108c-.786-1.573.359-3.426 2.118-3.426h5.194l3.839 1.729c1.697.763 3.597-.522 3.527-2.383h-.008Z",
                        fill: "#33009A"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M80.044 120.829c-7.417-.712-60.679-33.734-60.679-33.734l3.146-.716a14.172 14.172 0 0 0 5.069-2.266l2.632-1.775c.132-.094.35-.234.6-.39l.264-.179c.148-.101.296-.226.444-.381.054-.063.1-.133.148-.203l.015-1.417a12.82 12.82 0 0 0-1.129-5.435l-2.071-4.617a168.66 168.66 0 0 1-.958-2.141c-1.214-3.084-1.915-5.357-2.164-7.024a22.368 22.368 0 0 1-.296-1.62c-1.472-1.626-1.145-5.979-.086-9.25 1.518-4.687 4.524-7.762 8.495-8.68 4.127-2.095 9.64-2.936 16.398-2.508 1.316.085 2.608.335 3.854.74 6.066.88 10.948 5.466 12.17 11.484.716 3.528.07 7.218-1.76 10.31l1.799 2.475c.568.78.677 1.815.273 2.702a2.707 2.707 0 0 1-2.212 1.573l-.786.07-1.394 7.203a4.48 4.48 0 0 1-4.742 3.612l-4.087-.311-.289 5.264.701.498c.405.288.88.576 1.433.88a13.997 13.997 0 0 0 3.636 1.386l1.876.358a15.577 15.577 0 0 1 11.734 10.145l7.973 23.947h-.007ZM74.5 116.5l-6.034-18.364a11.735 11.735 0 0 0-8.853-7.654l-1.94-.374a18.126 18.126 0 0 1-4.671-1.767 17.967 17.967 0 0 1-1.814-1.121l-2.414-1.721.615-11.244 7.966.608a.676.676 0 0 0 .708-.545l1.939-10.021 1.69-.148-.78-1.067a6.489 6.489 0 0 1-.77-1.425l-.39-.973.608-.849c1.752-2.453 2.39-5.427 1.799-8.362a10.708 10.708 0 0 0-9.118-8.487l-.366-.086a12.064 12.064 0 0 0-3.052-.607c-6.175-.398-11.096.35-14.615 2.203l-.241.125-.265.054c-2.141.436-3.839 1.83-5.046 4.127-1.308 2.484-1.62 5.279-1.565 6.79l.639-.148.218 2.149c.078.81.194 1.518.342 2.164l.032.164c.132.926.576 2.756 1.93 6.182.265.607.577 1.293.896 2.009l2.079 4.648a16.856 16.856 0 0 1 1.3 4.555l.755-.21-.085 2.718a6.232 6.232 0 0 1-1.09 3.317c-.195.295-.39.568-.615.817-.35.374-.724.693-1.114.95l-.32.21c-.225.14-.373.242-.49.327l-2.631 1.776C18.474 95.218 62.76 110.435 74.5 116.5Z",
                        fill: "#F5EEFD"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M41.223 81.625c2.472-5.819-.038-12.454-5.607-14.82-5.569-2.366-12.087.433-14.56 6.252-2.472 5.819.038 12.454 5.607 14.82 5.569 2.366 12.088-.433 14.56-6.252ZM51.655 66.236c6.975 0 12.63-5.655 12.63-12.63 0-6.975-5.655-12.63-12.63-12.63-6.975 0-12.63 5.655-12.63 12.63 0 6.975 5.655 12.63 12.63 12.63Z",
                        fill: "#33009A"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "m78.5 120.5-8.236-22.995a13.616 13.616 0 0 0-10.293-8.9l-1.939-.373a16.142 16.142 0 0 1-5.746-2.57l-1.744-1.238a6.53 6.53 0 0 0-3.769-1.199l-9.6-1.993c-1.347 0-4.805 1.9-5.902 2.686l-2.593 1.752a16.004 16.004 0 0 1-5.747 2.57L18.5 89c1.715 1.715 27.631 27.712 39.5 39h11.5",
                        fill: "#00C3E6"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("mask", {
                        id: "mask2_301_16603",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: "27",
                        y: "40",
                        width: "38",
                        height: "56",
                        children: /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                            d: "M27.798 60.116v-.07a17.252 17.252 0 0 1-.452-3.068c-.63-11.438 7.545-16.982 22.448-16.009 5.887.382 11.321 5.614 11.929 11.477.21 2.048.171 4.041-.117 5.918a4.844 4.844 0 0 0 .856 3.597l1.931 2.655a.794.794 0 0 1-.568 1.254l-2.22.194-1.72 7.857a3.525 3.525 0 0 1-3.605 2.64l-5.092-.273-.864 15.837c-.133 2.476-2.975 3.8-4.96 2.32L31.263 83.911l.864-.577a4.413 4.413 0 0 0 1.97-3.558l.093-3.41s-5.7-11.376-6.392-16.258v.008Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsxs)("g", {
                        mask: "url(#mask2_301_16603)",
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M65.872 98.208C80.962 86.78 83.936 65.29 72.515 50.21 61.094 35.13 39.602 32.17 24.512 43.6 9.422 55.029 6.448 76.518 17.87 91.598c11.422 15.08 32.913 18.039 48.003 6.61Z",
                                fill: "#50F"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M26.996 89.135c12.17 10.48 30.507 9.966 41.898-1.394 5.201-5.194 7.989-11.843 8.363-18.625.428-7.74-2.484-15.534-8.27-21.552-2.296-2.39-4.85-4.4-7.607-5.934-11.017-6.112-25.25-4.82-35.014 4.205-3.855 3.59-7.04 8.059-8.402 12.956-1.378 4.937-.646 9.881.46 14.755.848 3.753 1.9 7.468 4.103 10.753 1.214 1.815 2.78 3.387 4.47 4.843v-.007Z",
                                fill: "#4427FA"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M27.144 88.605c13.992 10.566 33.91 9.866 46.827-2.063 5.7-5.271 8.946-12.092 9.662-19.216.818-8.122-2.14-16.375-7.825-23.071-2.46-2.897-5.193-5.49-8.19-7.538-11.984-8.113-28.553-8.082-40.552 1.324-4.718 3.699-9.453 8.69-11.197 14.42-1.83 5.996.21 11.695 1.519 17.52 1.02 4.531 1.541 9.133 4.158 13.104 1.448 2.203 3.496 3.924 5.606 5.513l-.008.007Z",
                                fill: "#334EF5"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M39.213 78.88c11.742 7.343 27.377 6.51 38.145-2.281 4.493-3.667 7.311-8.503 8.253-13.759 1.075-5.995-.934-12.255-4.695-17.589-1.868-2.647-3.947-5.146-6.307-7.202-9.343-8.145-23.623-9.756-34.719-2.928-4.321 2.655-9.592 6.697-11.267 11.688-1.837 5.458 1.277 10.3 2.43 15.494.903 4.096.576 8.378 2.873 11.968 1.277 2.009 3.301 3.371 5.295 4.617l-.008-.008Z",
                                fill: "#2275F0"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M44.842 69.95c9.352 4.305 20.782 3.106 29.472-2.5 3.254-2.103 5.676-4.906 6.836-8.3 1.323-3.87.39-8.246-1.565-12.108-1.238-2.453-2.71-4.804-4.423-6.875-6.727-8.145-18.68-11.415-28.887-7.18-3.909 1.62-9.733 4.704-11.337 8.955-1.853 4.92 2.344 8.9 3.333 13.47.794 3.652-.397 7.623 1.588 10.831 1.114 1.806 3.084 2.842 4.983 3.714v-.008Z",
                                fill: "#119CEB"
                            }),
                            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                                d: "M51.188 54.945c.514 2.422-1.028 5.178.226 7.32.716 1.214 2.149 1.806 3.527 2.125 5.21 1.2 10.605-.436 15.697-2.056 1.487-.475 3.045-.988 4.088-2.149 1.191-1.315 1.48-3.254 1.183-5.006-.295-1.752-1.113-3.364-1.915-4.944-3.122-6.144-10.364-9.834-17.402-8.628-2.64.452-7.467 2.048-8.612 4.696-1.425 3.3 2.57 5.668 3.2 8.635l.008.007Z",
                                fill: "#00C3E6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M61.684 52.127c-.709-6.105-5.84-10.769-11.975-11.166-14.857-.95-23.001 4.602-22.37 16.008.062 1.052.218 2.08.451 3.068v.07c.234 1.643 1.036 4.034 2.001 6.47.88 2.025 1.947 4.221 3.06 7.024.779 1.666 1.332 2.764 1.332 2.764l-.032 2.663 1.363-.374a10.691 10.691 0 0 0 7.39-7.996l.412-1.908a2.14 2.14 0 0 1-1.059-.942l-2.562-4.625a2.566 2.566 0 0 1 1.176-3.574c.265-.125.592-.179.942-.202 1.986-.102 2.71-2.788 1.005-3.816a.163.163 0 0 1-.047-.03c-.77-.452-1.55-.974-2.056-1.465 6.86 1.838 8.659-.381 12.599-2.11 3.169-1.393 6.197-.685 8.432.943-.023-.265-.047-.538-.078-.803h.016Z",
                        fill: "#33009A"
                    }),
                    /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                        d: "M33.583 79.784a14.833 14.833 0 0 0-1.292-6.237 903.28 903.28 0 0 0-2.071-4.617c-.335-.74-.647-1.433-.943-2.118-1.144-2.897-1.83-5.116-2.04-6.619a18.245 18.245 0 0 1-.46-3.192c-.272-4.929 1.037-8.86 3.894-11.703 3.854-3.823 10.278-5.474 19.077-4.913 6.509.413 11.765 5.318 12.504 11.664.031.272.063.553.086.825l.101 1.238-1.004-.732c-1.386-1.012-4.26-2.468-7.872-.88-.748.328-1.417.678-2.064 1.013-2.289 1.183-4.321 2.234-8.206 1.697.88.646 1.245 1.682.98 2.74-.295 1.169-1.237 1.963-2.413 2.017a2.21 2.21 0 0 0-.74.148 1.97 1.97 0 0 0-1.066 1.192 1.954 1.954 0 0 0 .148 1.588l2.561 4.625.18.312c1.432 2.46.934 5.606-1.231 7.467-1.947 1.666-4.228 3.356-6.027 3.893l-2.11.576.008.016ZM46.61 41.436c-6.829 0-12.03 1.596-15.145 4.688-2.616 2.6-3.815 6.236-3.558 10.83.054.981.202 1.986.436 2.975l.016.14c.194 1.386.856 3.52 1.962 6.322.288.662.6 1.355.926 2.087.646 1.433 1.386 3.06 2.134 4.937.763 1.619 1.308 2.717 1.316 2.717l.062.124-.023 2.04.638-.17a10.091 10.091 0 0 0 6.976-7.57l.32-1.486a2.644 2.644 0 0 1-.911-.966l-2.562-4.625a3.15 3.15 0 0 1-.233-2.5c.272-.825.88-1.51 1.674-1.868.311-.14.7-.226 1.152-.25.81-.038 1.238-.653 1.37-1.16.133-.513.031-1.198-.63-1.603-.997-.592-1.729-1.106-2.204-1.565l-1.596-1.534 2.141.576C46.197 55 48.3 53.91 50.97 52.532c.662-.343 1.355-.701 2.126-1.044 2.647-1.168 5.489-1.028 7.965.343-.833-5.614-5.567-9.912-11.391-10.278a45.948 45.948 0 0 0-3.06-.101v-.016Z",
                        fill: "#33009A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M110 76c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z",
                fill: "#20BB71"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M111.202 72.385c.312-.311.495-.733.495-1.201V56.808c0-.945-.761-1.707-1.706-1.707s-1.707.762-1.707 1.707v14.376a1.707 1.707 0 0 0 2.909 1.211l.009-.01Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $iKObn.jsx)("path", {
                d: "M118.385 65.201c.312-.311.496-.734.496-1.201 0-.945-.762-1.707-1.707-1.707h-14.376c-.945 0-1.706.762-1.706 1.707 0 .945.761 1.706 1.706 1.706h14.376c.468 0 .899-.193 1.202-.496l.009-.009Z",
                fill: "#fff"
            })
        ]
    });
};
$66d405ac014829e4$var$PatientAddIcon.defaultProps = {
    width: "128",
    height: "128",
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const $66d405ac014829e4$export$bea3f131f38ad33c = ({ className: className })=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const navigate = (0, $htiSH.useNavigate)();
    const ptRegistrationStatus = (0, $1IWnK.useObservable)((0, $ghfIB.userStatusManager).ptRegistrationStatus);
    const patientsStepStatus = (0, $1IWnK.useObservable)((0, $ghfIB.getStartedManager).patientsStepStatus);
    const { status: status, bottom: bottom } = (0, $81g6h.useMemo)(()=>{
        switch(ptRegistrationStatus){
            case (0, $02mFA.RegistrationStatus).INCOMPLETE:
            case (0, $02mFA.RegistrationStatus).PENDING:
                return {
                    status: (0, $4nRkH.GetStartedStepStatus).Disabled,
                    bottom: /*#__PURE__*/ (0, $iKObn.jsx)($66d405ac014829e4$var$StyledValidateAccountCard, {
                        showForPendingPt: true
                    })
                };
            default:
                return {
                    status: patientsStepStatus,
                    bottom: /*#__PURE__*/ (0, $iKObn.jsx)((0, $9c6c0ec64f1c6c91$export$15d663f77d176497), {
                        label: format("getStarted.patientsCard.ctaButton"),
                        onClick: ()=>{
                            (0, $ghfIB.analyticsService).trackEvent({
                                category: (0, $auPqo.AnalyticsCategory).GETSTARTED,
                                action: "cardCTA",
                                params: [
                                    "patients"
                                ]
                            });
                            navigate((0, $lDZlX.RoutesPath).Home, {
                                state: {
                                    openAddPatientModal: true
                                }
                            });
                        }
                    })
                };
        }
    }, [
        format,
        navigate,
        patientsStepStatus,
        ptRegistrationStatus
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $e6fdf75fad137c98$export$30fb424233fb8973), {
        className: className,
        status: status,
        icon: $66d405ac014829e4$var$PatientAddIcon,
        mainHeadline: format("getStarted.patientsCard.mainHeadline"),
        secondaryHeadline: format("getStarted.patientsCard.secondaryHeadline"),
        description: format("getStarted.patientsCard.description"),
        bottom: bottom
    });
};
const $66d405ac014829e4$var$StyledValidateAccountCard = (0, $5UMQ1.default)((0, $15ade5a6153d87cc$export$8534dc24c72e73ef))`
	.alertContainer {
		flex-direction: column;
	}
`;



var $kkH7g = parcelRequire("kkH7g");
const $a440cdf17e13c483$export$703047282e947ca0 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $lKlJT.Page), {
        children: /*#__PURE__*/ (0, $iKObn.jsxs)($a440cdf17e13c483$var$Container, {
            children: [
                /*#__PURE__*/ (0, $iKObn.jsxs)($a440cdf17e13c483$var$Header, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)($a440cdf17e13c483$var$StyledPageHeader, {
                            title: format("getStarted.title")
                        }),
                        /*#__PURE__*/ (0, $iKObn.jsx)("div", {
                            className: "p-size-m",
                            children: format("getStarted.description")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $iKObn.jsxs)($a440cdf17e13c483$var$Body, {
                    children: [
                        /*#__PURE__*/ (0, $iKObn.jsx)($a440cdf17e13c483$var$StyledExercisesCard, {}),
                        /*#__PURE__*/ (0, $iKObn.jsx)($a440cdf17e13c483$var$DashedDivider, {}),
                        /*#__PURE__*/ (0, $iKObn.jsx)($a440cdf17e13c483$var$StyledProgramsCard, {}),
                        /*#__PURE__*/ (0, $iKObn.jsx)($a440cdf17e13c483$var$DashedDivider, {}),
                        /*#__PURE__*/ (0, $iKObn.jsx)($a440cdf17e13c483$var$StyledPatientsCard, {})
                    ]
                })
            ]
        })
    });
};
const $a440cdf17e13c483$var$Container = (0, $5UMQ1.default).div`
	padding-inline: 40px;

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		padding-inline: 5%;
	}

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding-inline: 20px;
	}
`;
const $a440cdf17e13c483$var$Header = (0, $5UMQ1.default).div`
	${(0, $5WGN2.stack)("XS")};
	padding-block: 40px;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding-block: 24px 16px;
	}
`;
const $a440cdf17e13c483$var$StyledPageHeader = (0, $5UMQ1.default)((0, $8CNE2.PageHeader))`
	padding: 0;

	@media ${(0, $eaiXJ.physioMeMobileBreakpoint)} {
		padding: 0;
	}
`;
const $a440cdf17e13c483$var$Body = (0, $5UMQ1.default).div`
	${(0, $5WGN2.row)(undefined, undefined, "stretch")};

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		${(0, $5WGN2.stack)(16, undefined, "center")};
	}
`;
const $a440cdf17e13c483$var$sharedCardStyles = (0, $kkH7g.css)`
	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		width: 100%;
	}
`;
const $a440cdf17e13c483$var$StyledExercisesCard = (0, $5UMQ1.default)((0, $81dcf50acdf179fd$export$e396ce63e1f2ee5e))`
	${$a440cdf17e13c483$var$sharedCardStyles}
`;
const $a440cdf17e13c483$var$StyledProgramsCard = (0, $5UMQ1.default)((0, $2ffa503f93ab6dcc$export$2642d82beaef8744))`
	${$a440cdf17e13c483$var$sharedCardStyles}
`;
const $a440cdf17e13c483$var$StyledPatientsCard = (0, $5UMQ1.default)((0, $66d405ac014829e4$export$bea3f131f38ad33c))`
	${$a440cdf17e13c483$var$sharedCardStyles}
`;
const $a440cdf17e13c483$var$DashedDivider = (0, $5UMQ1.default).div`
	align-self: center;
	margin: 96px 5px 0 5px;
	width: 30px;
	height: ${({ height: height = 3 })=>height}px;
	background-image: ${({ color: color = (0, $kKnoQ.colors).onboardingPrimary, dash: dash = 7, gap: gap = 5 })=>`repeating-linear-gradient(to right, ${color} 0, ${color} ${dash}px, transparent ${dash}px, transparent ${dash + gap}px)`};

	@media ${(0, $eaiXJ.physioMeTabletBreakpoint)} {
		display: none;
	}
`;


const $282cb96344d69475$var$CHUNK_RELOAD_SESSION_KEY = "chunk-reload-at";
const $282cb96344d69475$var$CHUNK_RELOAD_GUARD_MS = 10000;
const $282cb96344d69475$var$fullScreenCenterStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh"
};
const $282cb96344d69475$var$isChunkLoadError = (error)=>error instanceof Error && (error.message.includes("Failed to fetch dynamically imported module") || error.name === "ChunkLoadError");
const $282cb96344d69475$var$reloadOnChunkError = ()=>{
    try {
        const lastReload = sessionStorage.getItem($282cb96344d69475$var$CHUNK_RELOAD_SESSION_KEY);
        const now = Date.now();
        if (!lastReload || now - parseInt(lastReload, 10) > $282cb96344d69475$var$CHUNK_RELOAD_GUARD_MS) {
            sessionStorage.setItem($282cb96344d69475$var$CHUNK_RELOAD_SESSION_KEY, String(now));
            window.location.reload();
        }
    } catch  {
        window.location.reload();
    }
};
const $282cb96344d69475$var$hasAlreadyReloaded = ()=>{
    try {
        const lastReload = sessionStorage.getItem($282cb96344d69475$var$CHUNK_RELOAD_SESSION_KEY);
        return !!lastReload && Date.now() - parseInt(lastReload, 10) <= $282cb96344d69475$var$CHUNK_RELOAD_GUARD_MS;
    } catch  {
        return false;
    }
};
const $282cb96344d69475$var$RouteChunkErrorHandler = ()=>{
    const error = (0, $hE6rp.useRouteError)();
    const alreadyReloaded = $282cb96344d69475$var$hasAlreadyReloaded();
    $81g6h.useEffect(()=>{
        if ($282cb96344d69475$var$isChunkLoadError(error) && !alreadyReloaded) $282cb96344d69475$var$reloadOnChunkError();
    }, [
        error,
        alreadyReloaded
    ]);
    if ($282cb96344d69475$var$isChunkLoadError(error) && alreadyReloaded) return /*#__PURE__*/ (0, $iKObn.jsx)("div", {
        style: $282cb96344d69475$var$fullScreenCenterStyle,
        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {
            onRefresh: ()=>window.location.reload()
        })
    });
    if (!$282cb96344d69475$var$isChunkLoadError(error)) return /*#__PURE__*/ (0, $iKObn.jsx)("div", {
        style: $282cb96344d69475$var$fullScreenCenterStyle,
        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $28f8Y.NetworkError), {})
    });
    return null;
};
class $282cb96344d69475$var$ChunkLoadErrorBoundary extends $81g6h.Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            isChunkError: false
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            isChunkError: $282cb96344d69475$var$isChunkLoadError(error)
        };
    }
    componentDidCatch(error) {
        if (!$282cb96344d69475$var$isChunkLoadError(error)) return;
        $282cb96344d69475$var$reloadOnChunkError();
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
}

const $282cb96344d69475$var$RegisterPage = /*#__PURE__*/ $81g6h.lazy(()=>(parcelRequire("gYCcI")));

const $282cb96344d69475$var$LoginPage = /*#__PURE__*/ $81g6h.lazy(()=>(parcelRequire("915oF")));

const $282cb96344d69475$var$ForgotPasswordPage = /*#__PURE__*/ $81g6h.lazy(()=>(parcelRequire("eRh25")));

const $282cb96344d69475$var$DebugPage = /*#__PURE__*/ $81g6h.lazy(()=>(parcelRequire("ioeVs")));

const $282cb96344d69475$var$ErrorPage = /*#__PURE__*/ $81g6h.lazy(()=>(parcelRequire("bzn3S")));

const $282cb96344d69475$var$DemoRequestPage = /*#__PURE__*/ $81g6h.lazy(()=>(parcelRequire("bLBWM")));
const $282cb96344d69475$var$router = (0, $aanF2.createBrowserRouter)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $e7772db0426f0484$export$86b66307423b6077), {}),
        errorElement: /*#__PURE__*/ (0, $iKObn.jsx)($282cb96344d69475$var$RouteChunkErrorHandler, {}),
        children: [
            {
                path: (0, $lDZlX.RoutesPath).Home,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $de09878819c9fb97$export$a97487fc898631bc), {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $95cdcb34c06a4072$export$36d69433c4f81145), {})
                    })
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).Rejected,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $227b3242735de48c$export$2e2bcd8739ae039), {})
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).PatientDetails,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $de09878819c9fb97$export$a97487fc898631bc), {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $d510a82b2e47296c$export$e8b137a2905aabca), {})
                    })
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).ProgramBuilder,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $de09878819c9fb97$export$a97487fc898631bc), {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $e76f15e066bf48ed$export$f79f473d8aee3ee6), {})
                    })
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).ProgramList,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $de09878819c9fb97$export$a97487fc898631bc), {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $01719a909aa0348f$export$602f68ad7b8e36ce), {})
                    })
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).TemplateBuilder,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $de09878819c9fb97$export$a97487fc898631bc), {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $91406f69ff667336$export$2e2bcd8739ae039), {})
                    })
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).ExerciseList,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $de09878819c9fb97$export$a97487fc898631bc), {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $5eae589f6c43f5e6$export$8fb79a48688049ed), {})
                    })
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).Learn,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $de09878819c9fb97$export$a97487fc898631bc), {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $1f30f250cfe8e844$export$8f9baa9a7ed3b961), {})
                    })
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).LearnDocument,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $de09878819c9fb97$export$a97487fc898631bc), {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $d6963d219c9955c1$export$2e2bcd8739ae039), {})
                    })
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).GetStarted,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $de09878819c9fb97$export$a97487fc898631bc), {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $a440cdf17e13c483$export$703047282e947ca0), {})
                    })
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).PrivacyNotice,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $ea594a6041ee1c5f$export$652846203595a37c), {})
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).Settings,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $3ff0fa53a76fe5fa$export$8f6dcfe950367406), {})
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).LeavingReasons,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $394c3fa8ef25a3bf$export$6831430b1ff54dd2), {})
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).TermsOfUse,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $0a69857cc2652519$export$3b099986889b4c15), {})
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).NotificationCenter,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $de09878819c9fb97$export$a97487fc898631bc), {
                        children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $50fe7726fa894ed8$export$4731034551e6664c), {})
                    })
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).ProfessionalInformation,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $107ea047730c026e$export$8f29b94bdaa5fcbc), {})
                })
            },
            {
                path: "/",
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $e7772db0426f0484$export$8786dd0748f1ae31), {}),
                children: [
                    {
                        path: (0, $lDZlX.RoutesPath).Debug,
                        index: true,
                        element: /*#__PURE__*/ (0, $iKObn.jsx)($282cb96344d69475$var$DebugPage, {})
                    }
                ]
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $iKObn.jsx)($282cb96344d69475$var$ErrorPage, {})
            }
        ]
    },
    {
        path: "/",
        element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $e7772db0426f0484$export$c12aa631bb452f60), {}),
        errorElement: /*#__PURE__*/ (0, $iKObn.jsx)($282cb96344d69475$var$RouteChunkErrorHandler, {}),
        children: [
            {
                path: (0, $lDZlX.RoutesPath).Register,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($282cb96344d69475$var$RegisterPage, {})
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).Login,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($282cb96344d69475$var$LoginPage, {})
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).VipLogin,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $025e7d5f4c580627$export$2e2bcd8739ae039), {})
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).VipLoginRedirection,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $c61001f0447fdbb9$export$2e2bcd8739ae039), {})
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).DemoRequest,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($282cb96344d69475$var$DemoRequestPage, {})
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).InviteYourPt,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $c8a3bad677643819$export$2f747e1d422b5111), {})
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).ForgotPassword,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)($282cb96344d69475$var$ForgotPasswordPage, {})
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).AccountDeleted,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $a91cd70ef7aee32a$export$5f403e64283a9db4), {})
                })
            }
        ]
    },
    {
        path: (0, $lDZlX.RoutesPath).ThankYouSurvey,
        element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $3f058afc10146c2e$export$87d14518ad540bf9), {})
        }),
        errorElement: /*#__PURE__*/ (0, $iKObn.jsx)($282cb96344d69475$var$RouteChunkErrorHandler, {})
    },
    {
        path: "/",
        errorElement: /*#__PURE__*/ (0, $iKObn.jsx)($282cb96344d69475$var$RouteChunkErrorHandler, {}),
        children: [
            {
                path: (0, $lDZlX.RoutesPath).RegisterPrivacyNotice,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $7acd07ced8efc546$export$d5c3019acf93eae0), {})
                })
            },
            {
                path: (0, $lDZlX.RoutesPath).RegisterTermsOfUse,
                element: /*#__PURE__*/ (0, $iKObn.jsx)((0, $23b723217c7bc267$export$cd680e3bc94f76c3), {
                    children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $380d700d6082ba30$export$dd4488968b03c830), {})
                })
            }
        ]
    }
]);
const $282cb96344d69475$export$8707b35fd1c03f46 = ()=>/*#__PURE__*/ (0, $iKObn.jsx)($282cb96344d69475$var$ChunkLoadErrorBoundary, {
        children: /*#__PURE__*/ (0, $iKObn.jsx)($81g6h.Suspense, {
            fallback: null,
            children: /*#__PURE__*/ (0, $iKObn.jsx)((0, $aanF2.RouterProvider), {
                router: $282cb96344d69475$var$router
            })
        })
    });



var $iKObn = parcelRequire("iKObn");
parcelRequire("81g6h");

var $gc7GP = parcelRequire("gc7GP");
var $816a5fd428e7fdcb$exports = {};
"use strict";
function $816a5fd428e7fdcb$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $81g6h = parcelRequire("81g6h");
var $816a5fd428e7fdcb$var$React__default = $816a5fd428e7fdcb$var$_interopDefault($81g6h);
function $816a5fd428e7fdcb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $816a5fd428e7fdcb$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $816a5fd428e7fdcb$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $816a5fd428e7fdcb$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $816a5fd428e7fdcb$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $816a5fd428e7fdcb$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($81g6h.PureComponent);
        $816a5fd428e7fdcb$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $816a5fd428e7fdcb$var$_defineProperty(SideEffect, "canUseDOM", $816a5fd428e7fdcb$var$canUseDOM);
        return SideEffect;
    };
}
$816a5fd428e7fdcb$exports = $816a5fd428e7fdcb$var$withSideEffect;


var $37790c2f8c69d4cd$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $37790c2f8c69d4cd$var$hasElementType = typeof Element !== "undefined";
var $37790c2f8c69d4cd$var$hasMap = typeof Map === "function";
var $37790c2f8c69d4cd$var$hasSet = typeof Set === "function";
var $37790c2f8c69d4cd$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $37790c2f8c69d4cd$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$37790c2f8c69d4cd$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($37790c2f8c69d4cd$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$37790c2f8c69d4cd$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($37790c2f8c69d4cd$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($37790c2f8c69d4cd$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($37790c2f8c69d4cd$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$37790c2f8c69d4cd$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$37790c2f8c69d4cd$exports = function isEqual(a, b) {
    try {
        return $37790c2f8c69d4cd$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $81g6h = parcelRequire("81g6h");
var $ad4b78ed25b1e663$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $ad4b78ed25b1e663$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $ad4b78ed25b1e663$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $ad4b78ed25b1e663$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $ad4b78ed25b1e663$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $ad4b78ed25b1e663$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$ad4b78ed25b1e663$exports = $ad4b78ed25b1e663$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $ad4b78ed25b1e663$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($ad4b78ed25b1e663$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($ad4b78ed25b1e663$var$getOwnPropertySymbols) {
            symbols = $ad4b78ed25b1e663$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($ad4b78ed25b1e663$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $9f5636d98d694ae7$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $9f5636d98d694ae7$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $9f5636d98d694ae7$var$VALID_TAG_NAMES = Object.keys($9f5636d98d694ae7$var$TAG_NAMES).map(function(name) {
    return $9f5636d98d694ae7$var$TAG_NAMES[name];
});
var $9f5636d98d694ae7$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $9f5636d98d694ae7$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $9f5636d98d694ae7$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $9f5636d98d694ae7$var$HTML_TAG_MAP = Object.keys($9f5636d98d694ae7$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$9f5636d98d694ae7$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $9f5636d98d694ae7$var$SELF_CLOSING_TAGS = [
    $9f5636d98d694ae7$var$TAG_NAMES.NOSCRIPT,
    $9f5636d98d694ae7$var$TAG_NAMES.SCRIPT,
    $9f5636d98d694ae7$var$TAG_NAMES.STYLE
];
var $9f5636d98d694ae7$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $9f5636d98d694ae7$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $9f5636d98d694ae7$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $9f5636d98d694ae7$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $9f5636d98d694ae7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $9f5636d98d694ae7$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $9f5636d98d694ae7$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $9f5636d98d694ae7$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $9f5636d98d694ae7$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $9f5636d98d694ae7$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $9f5636d98d694ae7$var$getInnermostProperty(propsList, $9f5636d98d694ae7$var$TAG_NAMES.TITLE);
    var innermostTemplate = $9f5636d98d694ae7$var$getInnermostProperty(propsList, $9f5636d98d694ae7$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $9f5636d98d694ae7$var$getInnermostProperty(propsList, $9f5636d98d694ae7$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $9f5636d98d694ae7$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $9f5636d98d694ae7$var$getInnermostProperty(propsList, $9f5636d98d694ae7$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $9f5636d98d694ae7$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $9f5636d98d694ae7$var$_extends({}, tagAttrs, current);
    }, {});
};
var $9f5636d98d694ae7$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$9f5636d98d694ae7$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$9f5636d98d694ae7$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $9f5636d98d694ae7$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $9f5636d98d694ae7$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $9f5636d98d694ae7$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $9f5636d98d694ae7$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $9f5636d98d694ae7$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $9f5636d98d694ae7$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $9f5636d98d694ae7$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $9f5636d98d694ae7$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($ad4b78ed25b1e663$exports)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $9f5636d98d694ae7$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $9f5636d98d694ae7$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $9f5636d98d694ae7$var$getBaseTagFromPropsList([
            $9f5636d98d694ae7$var$TAG_PROPERTIES.HREF,
            $9f5636d98d694ae7$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $9f5636d98d694ae7$var$getAttributesFromPropsList($9f5636d98d694ae7$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $9f5636d98d694ae7$var$getInnermostProperty(propsList, $9f5636d98d694ae7$var$HELMET_PROPS.DEFER),
        encode: $9f5636d98d694ae7$var$getInnermostProperty(propsList, $9f5636d98d694ae7$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $9f5636d98d694ae7$var$getAttributesFromPropsList($9f5636d98d694ae7$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $9f5636d98d694ae7$var$getTagsFromPropsList($9f5636d98d694ae7$var$TAG_NAMES.LINK, [
            $9f5636d98d694ae7$var$TAG_PROPERTIES.REL,
            $9f5636d98d694ae7$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $9f5636d98d694ae7$var$getTagsFromPropsList($9f5636d98d694ae7$var$TAG_NAMES.META, [
            $9f5636d98d694ae7$var$TAG_PROPERTIES.NAME,
            $9f5636d98d694ae7$var$TAG_PROPERTIES.CHARSET,
            $9f5636d98d694ae7$var$TAG_PROPERTIES.HTTPEQUIV,
            $9f5636d98d694ae7$var$TAG_PROPERTIES.PROPERTY,
            $9f5636d98d694ae7$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $9f5636d98d694ae7$var$getTagsFromPropsList($9f5636d98d694ae7$var$TAG_NAMES.NOSCRIPT, [
            $9f5636d98d694ae7$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $9f5636d98d694ae7$var$getOnChangeClientState(propsList),
        scriptTags: $9f5636d98d694ae7$var$getTagsFromPropsList($9f5636d98d694ae7$var$TAG_NAMES.SCRIPT, [
            $9f5636d98d694ae7$var$TAG_PROPERTIES.SRC,
            $9f5636d98d694ae7$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $9f5636d98d694ae7$var$getTagsFromPropsList($9f5636d98d694ae7$var$TAG_NAMES.STYLE, [
            $9f5636d98d694ae7$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $9f5636d98d694ae7$var$getTitleFromPropsList(propsList),
        titleAttributes: $9f5636d98d694ae7$var$getAttributesFromPropsList($9f5636d98d694ae7$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $9f5636d98d694ae7$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $9f5636d98d694ae7$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $9f5636d98d694ae7$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $9f5636d98d694ae7$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $9f5636d98d694ae7$var$rafPolyfill : $parcel$global.requestAnimationFrame || $9f5636d98d694ae7$var$rafPolyfill;
var $9f5636d98d694ae7$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $9f5636d98d694ae7$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $9f5636d98d694ae7$var$cafPolyfill;
var $9f5636d98d694ae7$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $9f5636d98d694ae7$var$_helmetCallback = null;
var $9f5636d98d694ae7$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($9f5636d98d694ae7$var$_helmetCallback) $9f5636d98d694ae7$var$cancelAnimationFrame($9f5636d98d694ae7$var$_helmetCallback);
    if (newState.defer) $9f5636d98d694ae7$var$_helmetCallback = $9f5636d98d694ae7$var$requestAnimationFrame(function() {
        $9f5636d98d694ae7$var$commitTagChanges(newState, function() {
            $9f5636d98d694ae7$var$_helmetCallback = null;
        });
    });
    else {
        $9f5636d98d694ae7$var$commitTagChanges(newState);
        $9f5636d98d694ae7$var$_helmetCallback = null;
    }
};
var $9f5636d98d694ae7$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $9f5636d98d694ae7$var$updateAttributes($9f5636d98d694ae7$var$TAG_NAMES.BODY, bodyAttributes);
    $9f5636d98d694ae7$var$updateAttributes($9f5636d98d694ae7$var$TAG_NAMES.HTML, htmlAttributes);
    $9f5636d98d694ae7$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $9f5636d98d694ae7$var$updateTags($9f5636d98d694ae7$var$TAG_NAMES.BASE, baseTag),
        linkTags: $9f5636d98d694ae7$var$updateTags($9f5636d98d694ae7$var$TAG_NAMES.LINK, linkTags),
        metaTags: $9f5636d98d694ae7$var$updateTags($9f5636d98d694ae7$var$TAG_NAMES.META, metaTags),
        noscriptTags: $9f5636d98d694ae7$var$updateTags($9f5636d98d694ae7$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $9f5636d98d694ae7$var$updateTags($9f5636d98d694ae7$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $9f5636d98d694ae7$var$updateTags($9f5636d98d694ae7$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $9f5636d98d694ae7$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $9f5636d98d694ae7$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $9f5636d98d694ae7$var$flattenArray(title);
    $9f5636d98d694ae7$var$updateAttributes($9f5636d98d694ae7$var$TAG_NAMES.TITLE, attributes);
};
var $9f5636d98d694ae7$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($9f5636d98d694ae7$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($9f5636d98d694ae7$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($9f5636d98d694ae7$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($9f5636d98d694ae7$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $9f5636d98d694ae7$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($9f5636d98d694ae7$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $9f5636d98d694ae7$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $9f5636d98d694ae7$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $9f5636d98d694ae7$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($9f5636d98d694ae7$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $9f5636d98d694ae7$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $9f5636d98d694ae7$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $9f5636d98d694ae7$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $9f5636d98d694ae7$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $9f5636d98d694ae7$var$HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + $9f5636d98d694ae7$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $9f5636d98d694ae7$var$HELMET_ATTRIBUTE + '="true">' + $9f5636d98d694ae7$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $9f5636d98d694ae7$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $9f5636d98d694ae7$var$TAG_PROPERTIES.INNER_HTML || attribute === $9f5636d98d694ae7$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $9f5636d98d694ae7$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $9f5636d98d694ae7$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $9f5636d98d694ae7$var$HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $9f5636d98d694ae7$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$9f5636d98d694ae7$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $9f5636d98d694ae7$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$9f5636d98d694ae7$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $9f5636d98d694ae7$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$9f5636d98d694ae7$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $9f5636d98d694ae7$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement($9f5636d98d694ae7$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $9f5636d98d694ae7$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$9f5636d98d694ae7$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $9f5636d98d694ae7$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $9f5636d98d694ae7$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $9f5636d98d694ae7$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement(type, mappedTag);
    });
};
var $9f5636d98d694ae7$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $9f5636d98d694ae7$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $9f5636d98d694ae7$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $9f5636d98d694ae7$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $9f5636d98d694ae7$var$ATTRIBUTE_NAMES.BODY:
        case $9f5636d98d694ae7$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $9f5636d98d694ae7$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $9f5636d98d694ae7$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $9f5636d98d694ae7$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $9f5636d98d694ae7$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $9f5636d98d694ae7$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $9f5636d98d694ae7$var$getMethodsForTag($9f5636d98d694ae7$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $9f5636d98d694ae7$var$getMethodsForTag($9f5636d98d694ae7$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $9f5636d98d694ae7$var$getMethodsForTag($9f5636d98d694ae7$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $9f5636d98d694ae7$var$getMethodsForTag($9f5636d98d694ae7$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $9f5636d98d694ae7$var$getMethodsForTag($9f5636d98d694ae7$var$TAG_NAMES.META, metaTags, encode),
        noscript: $9f5636d98d694ae7$var$getMethodsForTag($9f5636d98d694ae7$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $9f5636d98d694ae7$var$getMethodsForTag($9f5636d98d694ae7$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $9f5636d98d694ae7$var$getMethodsForTag($9f5636d98d694ae7$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $9f5636d98d694ae7$var$getMethodsForTag($9f5636d98d694ae7$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $9f5636d98d694ae7$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $9f5636d98d694ae7$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $9f5636d98d694ae7$var$classCallCheck(this, HelmetWrapper);
            return $9f5636d98d694ae7$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($37790c2f8c69d4cd$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $9f5636d98d694ae7$var$TAG_NAMES.SCRIPT:
                case $9f5636d98d694ae7$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $9f5636d98d694ae7$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $9f5636d98d694ae7$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $9f5636d98d694ae7$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $9f5636d98d694ae7$var$TAG_NAMES.TITLE:
                    return $9f5636d98d694ae7$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $9f5636d98d694ae7$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $9f5636d98d694ae7$var$TAG_NAMES.BODY:
                    return $9f5636d98d694ae7$var$_extends({}, newProps, {
                        bodyAttributes: $9f5636d98d694ae7$var$_extends({}, newChildProps)
                    });
                case $9f5636d98d694ae7$var$TAG_NAMES.HTML:
                    return $9f5636d98d694ae7$var$_extends({}, newProps, {
                        htmlAttributes: $9f5636d98d694ae7$var$_extends({}, newChildProps)
                    });
            }
            return $9f5636d98d694ae7$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $9f5636d98d694ae7$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $9f5636d98d694ae7$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $9f5636d98d694ae7$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $9f5636d98d694ae7$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $9f5636d98d694ae7$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $9f5636d98d694ae7$var$TAG_NAMES.LINK:
                    case $9f5636d98d694ae7$var$TAG_NAMES.META:
                    case $9f5636d98d694ae7$var$TAG_NAMES.NOSCRIPT:
                    case $9f5636d98d694ae7$var$TAG_NAMES.SCRIPT:
                    case $9f5636d98d694ae7$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $9f5636d98d694ae7$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $9f5636d98d694ae7$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).createElement(Component, newProps);
        };
        $9f5636d98d694ae7$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($81g6h))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($gc7GP))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $9f5636d98d694ae7$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $9f5636d98d694ae7$var$NullComponent = function NullComponent() {
    return null;
};
var $9f5636d98d694ae7$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($816a5fd428e7fdcb$exports)))($9f5636d98d694ae7$var$reducePropsToState, $9f5636d98d694ae7$var$handleClientStateChange, $9f5636d98d694ae7$var$mapStateOnServer)($9f5636d98d694ae7$var$NullComponent);
var $9f5636d98d694ae7$export$dcef8f9bb9a41431 = $9f5636d98d694ae7$var$Helmet($9f5636d98d694ae7$var$HelmetSideEffects);
$9f5636d98d694ae7$export$dcef8f9bb9a41431.renderStatic = $9f5636d98d694ae7$export$dcef8f9bb9a41431.rewind;
var $9f5636d98d694ae7$export$2e2bcd8739ae039 = $9f5636d98d694ae7$export$dcef8f9bb9a41431;



var $1eHG3 = parcelRequire("1eHG3");
const $6918d6b3fa79b100$export$e7adebdc1ebd2fed = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $9f5636d98d694ae7$export$dcef8f9bb9a41431), {
        children: /*#__PURE__*/ (0, $iKObn.jsx)("title", {
            children: format("metadata.title")
        })
    });
};



var $iKObn = parcelRequire("iKObn");

var $1eHG3 = parcelRequire("1eHG3");

var $ghfIB = parcelRequire("ghfIB");

var $9XVwj = parcelRequire("9XVwj");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
const $4385a2b6fbca20a6$export$b8e387019d2227d4 = ()=>{
    const { format: format } = (0, $1eHG3.useI18n)();
    const actionError = (0, $1IWnK.useObservable)((0, $ghfIB.networkActionsErrorsManager).actionErrors);
    const debugSettings = (0, $1IWnK.useObservable)((0, $ghfIB.networkDebugManager).debugSettings);
    const { showToast: showToast } = (0, $81g6h.useContext)((0, $9XVwj.ToastContext));
    (0, $81g6h.useEffect)(()=>{
        if (actionError) {
            showToast(actionError.title ?? format("global.toast.error.title"), actionError.message ?? format("global.toast.error.message"));
            (0, $ghfIB.networkActionsErrorsManager).clearError();
        }
    }, [
        actionError,
        format,
        showToast
    ]);
    (0, $81g6h.useEffect)(()=>{
        if (debugSettings.enableRandomNetworkErrors) showToast("DEBUG", "Random network errors are active", "warn");
    }, [
        debugSettings,
        format,
        showToast
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsx)((0, $iKObn.Fragment), {});
};



var $kKnoQ = parcelRequire("kKnoQ");

var $bl9tw = parcelRequire("bl9tw");



var $lTdpc = parcelRequire("lTdpc");

var $1IWnK = parcelRequire("1IWnK");

var $81g6h = parcelRequire("81g6h");
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $6NkbF = parcelRequire("6NkbF");

var $iWpxp = parcelRequire("iWpxp");

var $81g6h = parcelRequire("81g6h");

var $yGWuH = parcelRequire("yGWuH");

var $hkEGL = parcelRequire("hkEGL");
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $6NkbF = parcelRequire("6NkbF");

var $6NkbF = parcelRequire("6NkbF");

var $iWpxp = parcelRequire("iWpxp");

var $ktjzr = parcelRequire("ktjzr");

var $ktjzr = parcelRequire("ktjzr");

var $iWpxp = parcelRequire("iWpxp");
var $045124ab5d10d2f7$var$NUMBER_FORMAT_OPTIONS = [
    "style",
    "currency",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem",
    // ES2023 NumberFormat
    "trailingZeroDisplay",
    "roundingPriority",
    "roundingIncrement",
    "roundingMode"
];
function $045124ab5d10d2f7$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $iWpxp.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $iWpxp.filterProps)(options, $045124ab5d10d2f7$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $045124ab5d10d2f7$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $045124ab5d10d2f7$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $ktjzr.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return String(value);
}
function $045124ab5d10d2f7$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $045124ab5d10d2f7$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $ktjzr.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return [];
}



var $iWpxp = parcelRequire("iWpxp");

var $fHOge = parcelRequire("fHOge");

var $ktjzr = parcelRequire("ktjzr");
var $786a845425b3516a$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $786a845425b3516a$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $iWpxp.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $iWpxp.filterProps)(options, $786a845425b3516a$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $786a845425b3516a$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $fHOge.FormatError)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, $fHOge.ErrorCode).MISSING_INTL_API));
    try {
        return $786a845425b3516a$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $ktjzr.IntlFormatError)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}



var $6NkbF = parcelRequire("6NkbF");

var $iWpxp = parcelRequire("iWpxp");

var $ktjzr = parcelRequire("ktjzr");
var $a5d6f8978de15c23$var$DATE_TIME_FORMAT_OPTIONS = [
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem",
    "fractionalSecondDigits"
];
function $a5d6f8978de15c23$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $iWpxp.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $iWpxp.filterProps)(options, $a5d6f8978de15c23$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $a5d6f8978de15c23$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $a5d6f8978de15c23$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $ktjzr.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return String(date);
}
function $a5d6f8978de15c23$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $a5d6f8978de15c23$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $ktjzr.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return String(date);
}
function $a5d6f8978de15c23$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $iWpxp.filterProps)(options, $a5d6f8978de15c23$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $ktjzr.IntlFormatError)("Error formatting date time range.", config.locale, e));
    }
    return String(from);
}
function $a5d6f8978de15c23$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $a5d6f8978de15c23$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $ktjzr.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return [];
}
function $a5d6f8978de15c23$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $a5d6f8978de15c23$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $ktjzr.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return [];
}



var $iWpxp = parcelRequire("iWpxp");

var $ktjzr = parcelRequire("ktjzr");

var $fHOge = parcelRequire("fHOge");
var $34227e0c71d3d3fc$var$PLURAL_FORMAT_OPTIONS = [
    "type"
];
function $34227e0c71d3d3fc$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $fHOge.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $fHOge.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $iWpxp.filterProps)(options, $34227e0c71d3d3fc$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $ktjzr.IntlFormatError)("Error formatting plural.", locale, e));
    }
    return "other";
}



var $6NkbF = parcelRequire("6NkbF");

var $5JgwF = parcelRequire("5JgwF");
parcelRequire("q7Vsy");
var $4hlvu = parcelRequire("4hlvu");

var $ktjzr = parcelRequire("ktjzr");
parcelRequire("23pH2");
var $au5gb = parcelRequire("au5gb");
function $097865d1e8ccce56$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $6NkbF.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $097865d1e8ccce56$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $097865d1e8ccce56$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $4hlvu.IntlMessageFormat).formats;
    return (0, $6NkbF.__assign)((0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, mfFormats), f1), {
        date: $097865d1e8ccce56$var$deepMergeOptions($097865d1e8ccce56$var$setTimeZoneInOptions(mfFormats.date, timeZone), $097865d1e8ccce56$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $097865d1e8ccce56$var$deepMergeOptions($097865d1e8ccce56$var$setTimeZoneInOptions(mfFormats.time, timeZone), $097865d1e8ccce56$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $097865d1e8ccce56$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $5JgwF.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $au5gb.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, defaultRichTextElements), values || {});
    formats = $097865d1e8ccce56$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $097865d1e8ccce56$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $ktjzr.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $ktjzr.MessageFormatError)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $6NkbF.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $ktjzr.MessageFormatError)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $ktjzr.MessageFormatError)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
};



var $6NkbF = parcelRequire("6NkbF");

var $iWpxp = parcelRequire("iWpxp");

var $fHOge = parcelRequire("fHOge");

var $ktjzr = parcelRequire("ktjzr");
var $f4eef32a30c36290$var$LIST_FORMAT_OPTIONS = [
    "type",
    "style"
];
var $f4eef32a30c36290$var$now = Date.now();
function $f4eef32a30c36290$var$generateToken(i) {
    return "".concat($f4eef32a30c36290$var$now, "_").concat(i, "_").concat($f4eef32a30c36290$var$now);
}
function $f4eef32a30c36290$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $f4eef32a30c36290$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
function $f4eef32a30c36290$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $fHOge.FormatError)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, $fHOge.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $iWpxp.filterProps)(options, $f4eef32a30c36290$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $f4eef32a30c36290$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $ktjzr.IntlFormatError)("Error formatting list.", locale, e));
    }
    // @ts-ignore
    return values;
}



var $iWpxp = parcelRequire("iWpxp");

var $fHOge = parcelRequire("fHOge");

var $ktjzr = parcelRequire("ktjzr");
var $717a543162b88354$var$DISPLAY_NAMES_OPTONS = [
    "style",
    "type",
    "fallback",
    "languageDisplay"
];
function $717a543162b88354$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $fHOge.FormatError)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, $fHOge.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $iWpxp.filterProps)(options, $717a543162b88354$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $ktjzr.IntlFormatError)("Error formatting display name.", locale, e));
    }
}


function $a02db3a676f98677$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $a02db3a676f98677$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $a02db3a676f98677$var$messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
function $a02db3a676f98677$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $iWpxp.createFormatters)(cache);
    var resolvedConfig = (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, (0, $iWpxp.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $ktjzr.InvalidConfigError)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $ktjzr.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $ktjzr.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    $a02db3a676f98677$var$verifyConfigMessages(resolvedConfig);
    return (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $045124ab5d10d2f7$export$f5dd818bff069720).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $045124ab5d10d2f7$export$6871080848f10b2f).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $786a845425b3516a$export$b4ea3b48dcf921f6).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $a5d6f8978de15c23$export$3ae94a2503e890a1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $a5d6f8978de15c23$export$dc1f059bce486b1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $a5d6f8978de15c23$export$3203edd9e5edd663).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $a5d6f8978de15c23$export$a7fc3a91cb2ec376).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $a5d6f8978de15c23$export$af6e5d7a5c73edeb).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $34227e0c71d3d3fc$export$bbbd05c900f3568d).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $097865d1e8ccce56$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $097865d1e8ccce56$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        formatList: (0, $f4eef32a30c36290$export$e8b8be48b45905bb).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $f4eef32a30c36290$export$6f284aad1934db69).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $717a543162b88354$export$62fe1a4d9e891fa2).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}



var $81g6h = parcelRequire("81g6h");

var $yGWuH = parcelRequire("yGWuH");

var $eSQuK = parcelRequire("eSQuK");
function $130328c9f9172c55$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $eSQuK.isFormatXMLElementFn)(v) ? (0, $yGWuH.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $130328c9f9172c55$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $130328c9f9172c55$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $097865d1e8ccce56$export$25868d1e8e76735f).apply(void 0, (0, $6NkbF.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $81g6h.Children.toArray(chunks);
    return chunks;
};
var $130328c9f9172c55$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $6NkbF.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $130328c9f9172c55$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $a02db3a676f98677$export$7e4cbedfdd7b4c0d)((0, $6NkbF.__assign)((0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, (0, $yGWuH.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $6NkbF.__assign)((0, $6NkbF.__assign)({}, coreIntl), {
        formatMessage: $130328c9f9172c55$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $130328c9f9172c55$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};


function $d00edca6d866149b$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $d00edca6d866149b$var$IntlProvider = /** @class */ function(_super) {
    (0, $6NkbF.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $iWpxp.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $130328c9f9172c55$export$7e4cbedfdd7b4c0d)($d00edca6d866149b$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $d00edca6d866149b$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $d00edca6d866149b$var$processIntlConfig(props);
        if (!(0, $yGWuH.shallowEqual)(prevConfig, config)) return {
            intl: (0, $130328c9f9172c55$export$7e4cbedfdd7b4c0d)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $yGWuH.invariantIntlContext)(this.state.intl);
        return $81g6h.createElement((0, $hkEGL.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, $yGWuH.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($81g6h.PureComponent);
var $d00edca6d866149b$export$2e2bcd8739ae039 = $d00edca6d866149b$var$IntlProvider;



var $bXTqq = parcelRequire("bXTqq");

var $buI4E = parcelRequire("buI4E");
const $5fb5522a4142e427$var$DEFAULT_ACTIVITY_EVENTS = [
    "mousemove",
    "mousedown",
    "keydown",
    "scroll",
    "touchstart",
    "click"
];
const $5fb5522a4142e427$export$4177e09970510241 = ()=>{
    const raw = "86400000";
    if (raw) {
        const parsed = Number.parseInt(raw, 10);
        if (!Number.isNaN(parsed) && parsed > 0) return parsed;
    }
    const rawEnv = "production";
    const env = String(rawEnv).toLowerCase();
    if (env === "dev" || env === "development") return 600000;
    return 86400000;
};
const $5fb5522a4142e427$export$de1f5cd1b155caa0 = ()=>{
    const flag = "true";
    if (!flag) return false;
    return (0, $buI4E.stringToBoolean)(flag.trim());
};
const $5fb5522a4142e427$var$handleExpiry = async (state)=>{
    if (!state.userGet()) return;
    state.onExpire?.();
    try {
        await state.logout();
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("[Inactivity] logout failed", e);
    }
};
const $5fb5522a4142e427$var$schedule = (state)=>{
    if (!state.enabled || !state.userGet()) return;
    if (state.timer) globalThis.clearTimeout(state.timer);
    state.timer = globalThis.setTimeout(()=>$5fb5522a4142e427$var$handleExpiry(state), state.timeoutMs);
};
const $5fb5522a4142e427$var$registerActivityListeners = (state, handler)=>{
    if (!state.enabled || typeof globalThis.addEventListener !== "function") return;
    for (const ev of $5fb5522a4142e427$var$DEFAULT_ACTIVITY_EVENTS)globalThis.addEventListener(ev, handler, true);
};
const $5fb5522a4142e427$var$unregisterActivityListeners = (state, handler)=>{
    if (typeof globalThis.removeEventListener !== "function") return;
    for (const ev of $5fb5522a4142e427$var$DEFAULT_ACTIVITY_EVENTS)globalThis.removeEventListener(ev, handler, true);
};
const $5fb5522a4142e427$export$8daed8c24d70aea4 = (um, opts)=>{
    const resolvedOpts = {
        timeoutMs: $5fb5522a4142e427$export$4177e09970510241(),
        enabled: $5fb5522a4142e427$export$de1f5cd1b155caa0()
    };
    if (opts) Object.assign(resolvedOpts, opts);
    const state = {
        timer: null,
        timeoutMs: resolvedOpts.timeoutMs,
        enabled: resolvedOpts.enabled,
        onExpire: resolvedOpts.onExpire,
        userGet: ()=>um.user.get(),
        logout: ()=>um.logout()
    };
    const activityHandler = ()=>$5fb5522a4142e427$var$schedule(state);
    const start = ()=>{
        $5fb5522a4142e427$var$registerActivityListeners(state, activityHandler);
        $5fb5522a4142e427$var$schedule(state);
    };
    const stop = ()=>{
        $5fb5522a4142e427$var$unregisterActivityListeners(state, activityHandler);
        if (state.timer) globalThis.clearTimeout(state.timer);
        state.timer = null;
    };
    const reset = ()=>$5fb5522a4142e427$var$schedule(state);
    return {
        start: start,
        stop: stop,
        reset: reset
    };
};


const $6ea305a5f6844166$export$86fbec116b87613f = ()=>{
    const [servicesInitialized, setServicesInitialized] = (0, $81g6h.useState)(false);
    const locale = (0, $1IWnK.useObservable)((0, $ghfIB.localeManager).locale);
    const translationsStatus = (0, $1IWnK.useObservable)((0, $ghfIB.translationsManager).translationsStatus);
    const localeWordings = (0, $81g6h.useMemo)(()=>(0, $ghfIB.translationsManager).getLocaleWordings(locale), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        locale,
        servicesInitialized
    ]);
    const scriptRef = (0, $81g6h.useRef)(null);
    (0, $81g6h.useEffect)(()=>{
        const init = async ()=>{
            try {
                await (0, $ghfIB.initializeServicesAndManagers)();
            } catch (e) {
                console.error("failed to init services", e);
            } finally{
                setServicesInitialized(true);
            }
        };
        init();
    }, []);
    (0, $81g6h.useEffect)(()=>{
        if (!servicesInitialized || !translationsStatus.available) return;
        const baseScriptURL = "https://consent.cookiebot.com/uc.js?cbid=815f9805-5c74-41e3-b174-a7e216b7b409&blockingmode=auto";
        let cultureValue;
        // Special case for Brazilian Portuguese because it's the only one full locale in Cookiebot
        if (locale.toLowerCase() === "pt-br") cultureValue = "pt-BR";
        else cultureValue = (0, $bXTqq.getLowercaseCountryCodeFromIntlLocale)(locale).toUpperCase();
        const fullScriptURL = `${baseScriptURL}&culture=${cultureValue}`;
        const newScript = document.createElement("script");
        scriptRef.current = newScript;
        newScript.id = "Cookiebot";
        newScript.src = fullScriptURL;
        newScript.dataset.culture = cultureValue;
        newScript.async = true;
        document.head.appendChild(newScript);
        return ()=>{
            const currentScript = scriptRef.current;
            if (currentScript && document.head.contains(currentScript)) currentScript.remove();
        };
    }, [
        servicesInitialized,
        translationsStatus.available,
        locale
    ]);
    return /*#__PURE__*/ (0, $iKObn.jsxs)((0, $iKObn.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iKObn.jsx)((0, $kkH7g.Global), {
                styles: $6ea305a5f6844166$var$globalStyles
            }),
            /*#__PURE__*/ (0, $iKObn.jsxs)((0, $d00edca6d866149b$export$2e2bcd8739ae039), {
                locale: locale,
                messages: localeWordings,
                children: [
                    /*#__PURE__*/ (0, $iKObn.jsx)((0, $6918d6b3fa79b100$export$e7adebdc1ebd2fed), {}),
                    /*#__PURE__*/ (0, $iKObn.jsxs)((0, $9XVwj.ToastProvider), {
                        children: [
                            /*#__PURE__*/ (0, $iKObn.jsx)((0, $4385a2b6fbca20a6$export$b8e387019d2227d4), {}),
                            servicesInitialized ? /*#__PURE__*/ (0, $iKObn.jsx)($6ea305a5f6844166$var$AppContainer, {}) : null
                        ]
                    })
                ]
            })
        ]
    });
};
// eslint-disable-next-line sonarjs/cognitive-complexity
const $6ea305a5f6844166$var$AppContainer = ()=>{
    const consentStatistics = (0, $1IWnK.useObservable)((0, $ghfIB.cookiebotManager).consentStatistics);
    const serverConfigStatus = (0, $1IWnK.useObservable)((0, $ghfIB.serverConfigManager).serverConfigStatus);
    const translationsStatus = (0, $1IWnK.useObservable)((0, $ghfIB.translationsManager).translationsStatus);
    const currentUser = (0, $1IWnK.useObservable)((0, $ghfIB.userManager).user);
    const errorObject = (0, $81g6h.useMemo)(()=>typeof translationsStatus.error === "object" && (0, $lTdpc.isNotNil)(translationsStatus.error) ? translationsStatus.error : {}, [
        translationsStatus.error
    ]);
    (0, $81g6h.useEffect)(()=>{
        if (consentStatistics) $8b28b65f4c22988d$export$2cd8252107eb640b({
            dsn: "https://ce54c161cbbd4c36b891bbbc33201dde@o1137486.ingest.sentry.io/6260380",
            environment: "prod",
            integrations: [
                $25167119000bf015$export$b4109253475213e9(),
                $24ab5428e3ae71ca$export$6e0872131894301d(),
                $2c6845a34a9d5bee$export$2832a2ae028f5e28()
            ],
            tracesSampleRate: 1,
            ignoreErrors: [
                /Network Error/i,
                /Fetch Error/i
            ]
        });
        else $15458dde2c60d92b$export$8360e631d277ea4d(0);
    }, [
        consentStatistics
    ]);
    (0, $81g6h.useEffect)(()=>{
        (0, $ghfIB.userManager).onUserLogout.add((0, $ghfIB.resetServicesAndManagers));
        return ()=>(0, $ghfIB.userManager).onUserLogout.remove((0, $ghfIB.resetServicesAndManagers));
    }, []);
    (0, $81g6h.useEffect)(()=>{
        if (!(0, $5fb5522a4142e427$export$de1f5cd1b155caa0)()) return; // feature gate
        const controller = (0, $5fb5522a4142e427$export$8daed8c24d70aea4)((0, $ghfIB.userManager), {
            enabled: (0, $5fb5522a4142e427$export$de1f5cd1b155caa0)(),
            timeoutMs: (0, $5fb5522a4142e427$export$4177e09970510241)()
        });
        if (currentUser) controller.start();
        else controller.stop();
        return ()=>controller.stop();
    }, [
        currentUser
    ]);
    const [showErrorScreen, errorType] = (0, $81g6h.useMemo)(()=>{
        if (!translationsStatus.available) return [
            true,
            (0, $gMt2l.hasOwnProperty)(errorObject, "status") ? (0, $27ea4d9f023c86f3$export$dba1278861bf0dc1).SERVER : (0, $27ea4d9f023c86f3$export$dba1278861bf0dc1).NETWORK
        ];
        if (!serverConfigStatus.available) return [
            true,
            (0, $04Qjn.isApiError)(serverConfigStatus.error) ? (0, $27ea4d9f023c86f3$export$dba1278861bf0dc1).SERVER : (0, $27ea4d9f023c86f3$export$dba1278861bf0dc1).NETWORK
        ];
        return [
            false,
            (0, $27ea4d9f023c86f3$export$dba1278861bf0dc1).SERVER
        ];
    }, [
        errorObject,
        serverConfigStatus.available,
        serverConfigStatus.error,
        translationsStatus.available
    ]);
    return showErrorScreen ? /*#__PURE__*/ (0, $iKObn.jsx)((0, $27ea4d9f023c86f3$export$c83f1bc4d3f4576d), {
        refresh: (0, $ghfIB.initializeServicesAndManagers),
        errorType: errorType
    }) : /*#__PURE__*/ (0, $iKObn.jsx)((0, $282cb96344d69475$export$8707b35fd1c03f46), {});
};
const $6ea305a5f6844166$var$globalStyles = (0, $kkH7g.css)`
	html,
	body {
		padding: 0;
		margin: 0;
		min-height: 100vh;
		display: flex;
		flex-direction: column;
		background-color: ${(0, $kKnoQ.colors).primaryBackground};
		font-family: ${(0, $bl9tw.fonts).body};
		color: ${(0, $kKnoQ.colors).black};
		font-weight: 400;
		font-size: 1rem;
	}

	a {
		text-decoration: none;
	}

	* {
		font-family: ${(0, $bl9tw.fonts).body};
		text-edge: cap alphabetic;
		leading-trim: both;
	}
`;




var $hQaMG = parcelRequire("hQaMG");
// Fire-and-forget; ensures the script is requested immediately
(0, $hQaMG.branchManager).init(undefined);
// Guard against external DOM mutations (e.g., browser auto-translation) causing NotFoundError on removeChild
const $04cbf1b6649a8ab6$var$originalRemoveChild = Node.prototype.removeChild;
Node.prototype.removeChild = function(child) {
    try {
        return $04cbf1b6649a8ab6$var$originalRemoveChild.call(this, child);
    } catch (error) {
        if (error instanceof DOMException && error.name === "NotFoundError") {
            if (child.parentNode && child.parentNode !== this) return child;
            if (!child.parentNode) return child;
        }
        throw error;
    }
};
const $04cbf1b6649a8ab6$var$root = (0, $caa473416a32e491$export$882461b6382ed46c)(document.getElementById("react-root"));
$04cbf1b6649a8ab6$var$root.render(/*#__PURE__*/ (0, $iKObn.jsx)((0, $6ea305a5f6844166$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.e8e4d161.js.map
